var _s={};(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.Hl.re === region.E9.re)
	{
		return 'on line ' + region.Hl.re;
	}
	return 'on lines ' + region.Hl.re + ' through ' + region.E9.re;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ad0,
		impl.aaq,
		impl.ahd,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		aeD: func(record.aeD),
		Cs: record.Cs,
		A9: record.A9
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.aeD;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.Cs;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.A9) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ad0,
		impl.aaq,
		impl.ahd,
		function(sendToApp, initialModel) {
			var view = impl.ahP;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ad0,
		impl.aaq,
		impl.ahd,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.ZF && impl.ZF(sendToApp)
			var view = impl.ahP;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.e5);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.$G) && (_VirtualDom_doc.title = title = doc.$G);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.afn;
	var onUrlRequest = impl.afo;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		ZF: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.Xj === next.Xj
							&& curr.adO === next.adO
							&& curr.Wx.a === next.Wx.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		ad0: function(flags)
		{
			return A3(impl.ad0, flags, _Browser_getUrl(), key);
		},
		ahP: impl.ahP,
		aaq: impl.aaq,
		ahd: impl.ahd
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { adI: 'hidden', abT: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { adI: 'mozHidden', abT: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { adI: 'msHidden', abT: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { adI: 'webkitHidden', abT: 'webkitvisibilitychange' }
		: { adI: 'hidden', abT: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		Y4: _Browser_getScene(),
		ahQ: {
			HS: _Browser_window.pageXOffset,
			aa5: _Browser_window.pageYOffset,
			ahT: _Browser_doc.documentElement.clientWidth,
			Ql: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		ahT: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		Ql: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			Y4: {
				ahT: node.scrollWidth,
				Ql: node.scrollHeight
			},
			ahQ: {
				HS: node.scrollLeft,
				aa5: node.scrollTop,
				ahT: node.clientWidth,
				Ql: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			Y4: _Browser_getScene(),
			ahQ: {
				HS: x,
				aa5: y,
				ahT: _Browser_doc.documentElement.clientWidth,
				Ql: _Browser_doc.documentElement.clientHeight
			},
			acU: {
				HS: x + rect.left,
				aa5: y + rect.top,
				ahT: rect.width,
				Ql: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.OT.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.OT.b, xhr)); });
		$elm$core$Maybe$isJust(request.tn) && _Http_track(router, xhr, request.tn.a);

		try {
			xhr.open(request.F6, request.aav, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.aav));
		}

		_Http_configureRequest(xhr, request);

		request.e5.a && xhr.setRequestHeader('Content-Type', request.e5.a);
		xhr.send(request.e5.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.iJ; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.HA.a || 0;
	xhr.responseType = request.OT.d;
	xhr.withCredentials = request.abf;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		aav: xhr.responseURL,
		_L: xhr.status,
		ag8: xhr.statusText,
		iJ: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			agQ: event.loaded,
			ag_: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			af5: event.loaded,
			ag_: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.aeK) { flags += 'm'; }
	if (options.abS) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;


// BYTES

function _Bytes_width(bytes)
{
	return bytes.byteLength;
}

var _Bytes_getHostEndianness = F2(function(le, be)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([1]))[0] === 1 ? le : be));
	});
});


// ENCODERS

function _Bytes_encode(encoder)
{
	var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
	$elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
	return mutableBytes;
}


// SIGNED INTEGERS

var _Bytes_write_i8  = F3(function(mb, i, n) { mb.setInt8(i, n); return i + 1; });
var _Bytes_write_i16 = F4(function(mb, i, n, isLE) { mb.setInt16(i, n, isLE); return i + 2; });
var _Bytes_write_i32 = F4(function(mb, i, n, isLE) { mb.setInt32(i, n, isLE); return i + 4; });


// UNSIGNED INTEGERS

var _Bytes_write_u8  = F3(function(mb, i, n) { mb.setUint8(i, n); return i + 1 ;});
var _Bytes_write_u16 = F4(function(mb, i, n, isLE) { mb.setUint16(i, n, isLE); return i + 2; });
var _Bytes_write_u32 = F4(function(mb, i, n, isLE) { mb.setUint32(i, n, isLE); return i + 4; });


// FLOATS

var _Bytes_write_f32 = F4(function(mb, i, n, isLE) { mb.setFloat32(i, n, isLE); return i + 4; });
var _Bytes_write_f64 = F4(function(mb, i, n, isLE) { mb.setFloat64(i, n, isLE); return i + 8; });


// BYTES

var _Bytes_write_bytes = F3(function(mb, offset, bytes)
{
	for (var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)
	{
		mb.setUint32(offset + i, bytes.getUint32(i));
	}
	for (; i < len; i++)
	{
		mb.setUint8(offset + i, bytes.getUint8(i));
	}
	return offset + len;
});


// STRINGS

function _Bytes_getStringWidth(string)
{
	for (var width = 0, i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		width +=
			(code < 0x80) ? 1 :
			(code < 0x800) ? 2 :
			(code < 0xD800 || 0xDBFF < code) ? 3 : (i++, 4);
	}
	return width;
}

var _Bytes_write_string = F3(function(mb, offset, string)
{
	for (var i = 0; i < string.length; i++)
	{
		var code = string.charCodeAt(i);
		offset +=
			(code < 0x80)
				? (mb.setUint8(offset, code)
				, 1
				)
				:
			(code < 0x800)
				? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */
					| (code >>> 6 & 0x1F /* 0b00011111 */) << 8
					| code & 0x3F /* 0b00111111 */)
				, 2
				)
				:
			(code < 0xD800 || 0xDBFF < code)
				? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */
					| (code >>> 12 & 0xF /* 0b00001111 */) << 8
					| code >>> 6 & 0x3F /* 0b00111111 */)
				, mb.setUint8(offset + 2, 0x80 /* 0b10000000 */
					| code & 0x3F /* 0b00111111 */)
				, 3
				)
				:
			(code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000
			, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */
				| (code >>> 18 & 0x7 /* 0b00000111 */) << 24
				| (code >>> 12 & 0x3F /* 0b00111111 */) << 16
				| (code >>> 6 & 0x3F /* 0b00111111 */) << 8
				| code & 0x3F /* 0b00111111 */)
			, 4
			);
	}
	return offset;
});


// DECODER

var _Bytes_decode = F2(function(decoder, bytes)
{
	try {
		return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
	} catch(e) {
		return $elm$core$Maybe$Nothing;
	}
});

var _Bytes_read_i8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getInt8(offset)); });
var _Bytes_read_i16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE)); });
var _Bytes_read_i32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE)); });
var _Bytes_read_u8  = F2(function(      bytes, offset) { return _Utils_Tuple2(offset + 1, bytes.getUint8(offset)); });
var _Bytes_read_u16 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE)); });
var _Bytes_read_u32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE)); });
var _Bytes_read_f32 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE)); });
var _Bytes_read_f64 = F3(function(isLE, bytes, offset) { return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE)); });

var _Bytes_read_bytes = F3(function(len, bytes, offset)
{
	return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
});

var _Bytes_read_string = F3(function(len, bytes, offset)
{
	var string = '';
	var end = offset + len;
	for (; offset < end;)
	{
		var byte = bytes.getUint8(offset++);
		string +=
			(byte < 128)
				? String.fromCharCode(byte)
				:
			((byte & 0xE0 /* 0b11100000 */) === 0xC0 /* 0b11000000 */)
				? String.fromCharCode((byte & 0x1F /* 0b00011111 */) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */)
				:
			((byte & 0xF0 /* 0b11110000 */) === 0xE0 /* 0b11100000 */)
				? String.fromCharCode(
					(byte & 0xF /* 0b00001111 */) << 12
					| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
					| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
				)
				:
				(byte =
					((byte & 0x7 /* 0b00000111 */) << 18
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 12
						| (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */) << 6
						| bytes.getUint8(offset++) & 0x3F /* 0b00111111 */
					) - 0x10000
				, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00)
				);
	}
	return _Utils_Tuple2(offset, string);
});

var _Bytes_decodeFailure = F2(function() { throw 0; });




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.y) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.J);
		} else {
			var treeLen = builder.y * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.R) : builder.R;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.y);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.J);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{R: nodeList, y: (len / $elm$core$Array$branchFactor) | 0, J: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {adz: fragment, adO: host, VL: path, Wx: port_, Xj: protocol, Bi: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Main$Layout = function (a) {
	return {$: 4, a: a};
};
var $author$project$Main$Model = F5(
	function (shared, route, page, layout, loadClinicalDebouncer) {
		return {a6: layout, ri: loadClinicalDebouncer, Gy: page, d: route, Cd: shared};
	});
var $author$project$Main$Pages = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$Shared = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Spa$Generated$Route$NotFound = {$: 8};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {iI: frag, Vx: params, g7: unvisited, aaN: value, kK: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.g7;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.aaN);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.aaN);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.VL),
					$elm$url$Url$Parser$prepareQuery(url.Bi),
					url.adz,
					$elm$core$Basics$identity)));
	});
var $author$project$Spa$Generated$Route$Accounting = {$: 1};
var $author$project$Spa$Generated$Route$Admin__AdvanceBilling = {$: 19};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields = {$: 196};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Link = {$: 197};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations = {$: 198};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview = {$: 199};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers = {$: 200};
var $author$project$Spa$Generated$Route$Admin__Athenahealth__Top = {$: 165};
var $author$project$Spa$Generated$Route$Admin__Billing = {$: 20};
var $author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String = function (a) {
	return {$: 307, a: a};
};
var $author$project$Spa$Generated$Route$Admin__CancellationReasons = {$: 21};
var $author$project$Spa$Generated$Route$Admin__CardReaders = {$: 22};
var $author$project$Spa$Generated$Route$Admin__Categories = {$: 23};
var $author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String = function (a) {
	return {$: 267, a: a};
};
var $author$project$Spa$Generated$Route$Admin__ChargeItems__New = {$: 201};
var $author$project$Spa$Generated$Route$Admin__ChargeItems__Top = {$: 166};
var $author$project$Spa$Generated$Route$Admin__ChargeItems__Upload = {$: 202};
var $author$project$Spa$Generated$Route$Admin__Commissions = {$: 24};
var $author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String = function (a) {
	return {$: 268, a: a};
};
var $author$project$Spa$Generated$Route$Admin__CompanyPlans__New = {$: 203};
var $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top = {$: 167};
var $author$project$Spa$Generated$Route$Admin__Coupons = {$: 25};
var $author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String = function (a) {
	return {$: 269, a: a};
};
var $author$project$Spa$Generated$Route$Admin__CoveragePlans__New = {$: 204};
var $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top = {$: 168};
var $author$project$Spa$Generated$Route$Admin__CreditCategories = {$: 26};
var $author$project$Spa$Generated$Route$Admin__Credits__Upload = {$: 205};
var $author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String = function (a) {
	return {$: 271, a: a};
};
var $author$project$Spa$Generated$Route$Admin__DataExportSettings__New = {$: 206};
var $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top = {$: 170};
var $author$project$Spa$Generated$Route$Admin__DataExport__Id_String = function (a) {
	return {$: 270, a: a};
};
var $author$project$Spa$Generated$Route$Admin__DataExport__Top = {$: 169};
var $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys = {$: 207};
var $author$project$Spa$Generated$Route$Admin__Developers__GetStarted = {$: 208};
var $author$project$Spa$Generated$Route$Admin__Developers__Sandboxes = {$: 209};
var $author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints = {$: 210};
var $author$project$Spa$Generated$Route$Admin__Documents__Id_String = function (a) {
	return {$: 272, a: a};
};
var $author$project$Spa$Generated$Route$Admin__Documents__New = {$: 211};
var $author$project$Spa$Generated$Route$Admin__Documents__Top = {$: 171};
var $author$project$Spa$Generated$Route$Admin__ElationLegacy = {$: 27};
var $author$project$Spa$Generated$Route$Admin__Elation__Link = {$: 212};
var $author$project$Spa$Generated$Route$Admin__Elation__Overview = {$: 213};
var $author$project$Spa$Generated$Route$Admin__Elation__Providers = {$: 214};
var $author$project$Spa$Generated$Route$Admin__Elation__Top = {$: 172};
var $author$project$Spa$Generated$Route$Admin__Features = {$: 28};
var $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations = {$: 29};
var $author$project$Spa$Generated$Route$Admin__Integrations__Slug_String = function (a) {
	return {$: 273, a: a};
};
var $author$project$Spa$Generated$Route$Admin__InternalSettings = {$: 30};
var $author$project$Spa$Generated$Route$Admin__InvoiceSettings = {$: 31};
var $author$project$Spa$Generated$Route$Admin__LeadSources = {$: 32};
var $author$project$Spa$Generated$Route$Admin__Locations = {$: 33};
var $author$project$Spa$Generated$Route$Admin__Mailgun = {$: 34};
var $author$project$Spa$Generated$Route$Admin__Notes = {$: 35};
var $author$project$Spa$Generated$Route$Admin__Notifications__Company = {$: 215};
var $author$project$Spa$Generated$Route$Admin__Notifications__Employee = {$: 216};
var $author$project$Spa$Generated$Route$Admin__Notifications__Membership = {$: 217};
var $author$project$Spa$Generated$Route$Admin__Notifications__Patient = {$: 218};
var $author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule = {$: 295};
var $author$project$Spa$Generated$Route$Admin__Notifications__Practice = {$: 219};
var $author$project$Spa$Generated$Route$Admin__Notifications__Settings = {$: 220};
var $author$project$Spa$Generated$Route$Admin__Patients = {$: 36};
var $author$project$Spa$Generated$Route$Admin__PaymentMethodImport = {$: 37};
var $author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload = {$: 221};
var $author$project$Spa$Generated$Route$Admin__PaymentProcessing = {$: 38};
var $author$project$Spa$Generated$Route$Admin__PaymentSources = {$: 39};
var $author$project$Spa$Generated$Route$Admin__Plans__Id_String = function (a) {
	return {$: 274, a: a};
};
var $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New = function (a) {
	return {$: 317, a: a};
};
var $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String = function (a) {
	return {$: 321, a: a};
};
var $author$project$Spa$Generated$Route$Admin__Plans__New = {$: 222};
var $author$project$Spa$Generated$Route$Admin__Plans__Top = {$: 173};
var $author$project$Spa$Generated$Route$Admin__Practice = {$: 40};
var $author$project$Spa$Generated$Route$Admin__ProviderGroups = {$: 41};
var $author$project$Spa$Generated$Route$Admin__Providers__Top = {$: 174};
var $author$project$Spa$Generated$Route$Admin__Providers__Upload = {$: 223};
var $author$project$Spa$Generated$Route$Admin__Quickbooks__Top = {$: 175};
var $author$project$Spa$Generated$Route$Admin__ScheduledJobs = {$: 42};
var $author$project$Spa$Generated$Route$Admin__SelfService = {$: 43};
var $author$project$Spa$Generated$Route$Admin__Signup = {$: 44};
var $author$project$Spa$Generated$Route$Admin__SignupPages__Id_String = function (a) {
	return {$: 275, a: a};
};
var $author$project$Spa$Generated$Route$Admin__SignupPages__New = {$: 224};
var $author$project$Spa$Generated$Route$Admin__SignupPages__Top = {$: 176};
var $author$project$Spa$Generated$Route$Admin__Stripe = {$: 45};
var $author$project$Spa$Generated$Route$Admin__Taxes = {$: 46};
var $author$project$Spa$Generated$Route$Admin__Team = {$: 47};
var $author$project$Spa$Generated$Route$Admin__Team__New = {$: 225};
var $author$project$Spa$Generated$Route$AffiliateBills__Top = {$: 10};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions = function (a) {
	return {$: 226, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String = function (a) {
	return {$: 308, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top = function (a) {
	return {$: 283, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders = function (a) {
	return {$: 227, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders = function (a) {
	return {$: 228, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients = function (a) {
	return {$: 229, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings = function (a) {
	return {$: 230, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users = function (a) {
	return {$: 231, a: a};
};
var $author$project$Spa$Generated$Route$Affiliates__Create = {$: 48};
var $author$project$Spa$Generated$Route$Affiliates__New = {$: 49};
var $author$project$Spa$Generated$Route$Affiliates__Top = {$: 11};
var $author$project$Spa$Generated$Route$Apps__Slug_String = function (a) {
	return {$: 161, a: a};
};
var $author$project$Spa$Generated$Route$Blank = {$: 2};
var $author$project$Spa$Generated$Route$Calendar = {$: 3};
var $author$project$Spa$Generated$Route$Charges__New = {$: 50};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top = function (a) {
	return {$: 323, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended = function (a) {
	return {$: 318, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New = function (a) {
	return {$: 319, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top = function (a) {
	return {$: 311, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals = function (a) {
	return {$: 296, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals = function (a) {
	return {$: 297, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String = function (a) {
	return {$: 322, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top = function (a) {
	return {$: 312, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top = function (a) {
	return {$: 284, a: a};
};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New = {$: 232};
var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top = {$: 177};
var $author$project$Spa$Generated$Route$Commissions__StatementLines__Summary = {$: 233};
var $author$project$Spa$Generated$Route$Commissions__StatementLines__Top = {$: 178};
var $author$project$Spa$Generated$Route$Commissions__Statements = {$: 51};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing = function (a) {
	return {$: 234, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas = function (a) {
	return {$: 235, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create = function (a) {
	return {$: 298, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top = function (a) {
	return {$: 324, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top = function (a) {
	return {$: 285, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions = function (a) {
	return {$: 236, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings = function (a) {
	return {$: 237, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String = function (a) {
	return {$: 309, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top = function (a) {
	return {$: 286, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes = function (a) {
	return {$: 238, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications = function (a) {
	return {$: 239, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources = function (a) {
	return {$: 240, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup = function (a) {
	return {$: 241, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String = function (a) {
	return {$: 310, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New = function (a) {
	return {$: 299, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top = function (a) {
	return {$: 179, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top = function (a) {
	return {$: 287, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top = function (a) {
	return {$: 313, a: a};
};
var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults = function (a) {
	return {$: 320, a: a};
};
var $author$project$Spa$Generated$Route$Companies__New = {$: 52};
var $author$project$Spa$Generated$Route$Companies__Top = {$: 12};
var $author$project$Spa$Generated$Route$Contacts__ContactId_String__Top = function (a) {
	return {$: 180, a: a};
};
var $author$project$Spa$Generated$Route$Contacts__List = {$: 53};
var $author$project$Spa$Generated$Route$Contacts__New = {$: 54};
var $author$project$Spa$Generated$Route$Error__Status_String = function (a) {
	return {$: 162, a: a};
};
var $author$project$Spa$Generated$Route$Files__Public = {$: 55};
var $author$project$Spa$Generated$Route$Files__Top = {$: 13};
var $author$project$Spa$Generated$Route$Forms = {$: 4};
var $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String = function (a) {
	return {$: 276, a: a};
};
var $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top = {$: 181};
var $author$project$Spa$Generated$Route$Hinter__ClonePractice = {$: 56};
var $author$project$Spa$Generated$Route$Hinter__Disputes = {$: 57};
var $author$project$Spa$Generated$Route$Hinter__FeatureFlags = {$: 58};
var $author$project$Spa$Generated$Route$Hinter__NewGroup = {$: 59};
var $author$project$Spa$Generated$Route$Hinter__NewPartner = {$: 60};
var $author$project$Spa$Generated$Route$Hinter__NewPractice = {$: 61};
var $author$project$Spa$Generated$Route$Home = {$: 5};
var $author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top = function (a) {
	return {$: 182, a: a};
};
var $author$project$Spa$Generated$Route$Inventory__List = {$: 62};
var $author$project$Spa$Generated$Route$Inventory__New = {$: 63};
var $author$project$Spa$Generated$Route$Inventory__Settings = {$: 64};
var $author$project$Spa$Generated$Route$Join__Token_String = function (a) {
	return {$: 163, a: a};
};
var $author$project$Spa$Generated$Route$Login = {$: 6};
var $author$project$Spa$Generated$Route$Logout = {$: 7};
var $author$project$Spa$Generated$Route$Marketplace__Layer__Manage__Settings = {$: 300};
var $author$project$Spa$Generated$Route$Marketplace__Manage = {$: 65};
var $author$project$Spa$Generated$Route$Marketplace__Slug_String = function (a) {
	return {$: 164, a: a};
};
var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding = function (a) {
	return {$: 301, a: a};
};
var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings = function (a) {
	return {$: 302, a: a};
};
var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users = function (a) {
	return {$: 303, a: a};
};
var $author$project$Spa$Generated$Route$Marketplace__Top = {$: 14};
var $author$project$Spa$Generated$Route$Messages__Calls = {$: 66};
var $author$project$Spa$Generated$Route$Messages__Drafts = {$: 67};
var $author$project$Spa$Generated$Route$Messages__Faxes__New = {$: 242};
var $author$project$Spa$Generated$Route$Messages__Faxes__Top = {$: 183};
var $author$project$Spa$Generated$Route$Messages__Forms = {$: 68};
var $author$project$Spa$Generated$Route$Messages__Labs = {$: 69};
var $author$project$Spa$Generated$Route$Messages__Messages = {$: 70};
var $author$project$Spa$Generated$Route$Messages__Scheduled__New = {$: 243};
var $author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top = function (a) {
	return {$: 288, a: a};
};
var $author$project$Spa$Generated$Route$Messages__Scheduled__Top = {$: 184};
var $author$project$Spa$Generated$Route$Messages__Sms = {$: 71};
var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String = function (a) {
	return {$: 277, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New = {$: 244};
var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top = {$: 185};
var $author$project$Spa$Generated$Route$NewSettings__Erx = {$: 72};
var $author$project$Spa$Generated$Route$NewSettings__HinterSettings = {$: 73};
var $author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String = function (a) {
	return {$: 278, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Locations__Top = {$: 186};
var $author$project$Spa$Generated$Route$NewSettings__PracticeInfo = {$: 74};
var $author$project$Spa$Generated$Route$NewSettings__Team = {$: 75};
var $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String = function (a) {
	return {$: 279, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo = function (a) {
	return {$: 304, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Templates__New = {$: 245};
var $author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String = function (a) {
	return {$: 280, a: a};
};
var $author$project$Spa$Generated$Route$NewSettings__Templates__Top = {$: 187};
var $author$project$Spa$Generated$Route$Oauth__Callback = {$: 76};
var $author$project$Spa$Generated$Route$Onboard__DealId_String__Top = function (a) {
	return {$: 188, a: a};
};
var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed = function (a) {
	return {$: 246, a: a};
};
var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing = function (a) {
	return {$: 247, a: a};
};
var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment = function (a) {
	return {$: 248, a: a};
};
var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__User = function (a) {
	return {$: 249, a: a};
};
var $author$project$Spa$Generated$Route$Onboarding = {$: 9};
var $author$project$Spa$Generated$Route$Partner__ApiKeys = {$: 77};
var $author$project$Spa$Generated$Route$Partner__Billing = {$: 78};
var $author$project$Spa$Generated$Route$Partner__Billing__Hinter = {$: 250};
var $author$project$Spa$Generated$Route$Partner__Dashboard__Top = {$: 189};
var $author$project$Spa$Generated$Route$Partner__Engagements = {$: 79};
var $author$project$Spa$Generated$Route$Partner__Hinter = {$: 80};
var $author$project$Spa$Generated$Route$Partner__Practices__Top = {$: 190};
var $author$project$Spa$Generated$Route$Partner__Product = {$: 81};
var $author$project$Spa$Generated$Route$Partner__Product__ActivationSettings = {$: 251};
var $author$project$Spa$Generated$Route$Partner__Product__AppSettings = {$: 252};
var $author$project$Spa$Generated$Route$Partner__Product__Hinter = {$: 253};
var $author$project$Spa$Generated$Route$Partner__Product__New = {$: 254};
var $author$project$Spa$Generated$Route$Partner__Sandboxes__Top = {$: 191};
var $author$project$Spa$Generated$Route$Partner__Team = {$: 82};
var $author$project$Spa$Generated$Route$Partner__WebhookEndpoints = {$: 83};
var $author$project$Spa$Generated$Route$Patients__Create = {$: 84};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top = function (a) {
	return {$: 289, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top = function (a) {
	return {$: 290, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top = function (a) {
	return {$: 314, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top = function (a) {
	return {$: 315, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top = function (a) {
	return {$: 291, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Chart = function (a) {
	return {$: 255, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Edit = function (a) {
	return {$: 256, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits = function (a) {
	return {$: 257, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top = function (a) {
	return {$: 316, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New = function (a) {
	return {$: 305, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top = function (a) {
	return {$: 292, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Merge = function (a) {
	return {$: 258, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top = function (a) {
	return {$: 293, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top = function (a) {
	return {$: 294, a: a};
};
var $author$project$Spa$Generated$Route$Patients__PatientId_String__Top = function (a) {
	return {$: 192, a: a};
};
var $author$project$Spa$Generated$Route$Patients__Top = {$: 15};
var $author$project$Spa$Generated$Route$Patients__Upload = {$: 85};
var $author$project$Spa$Generated$Route$PracticeSetup__Account = {$: 86};
var $author$project$Spa$Generated$Route$PracticeSetup__Communications = {$: 87};
var $author$project$Spa$Generated$Route$PracticeSetup__Complete = {$: 88};
var $author$project$Spa$Generated$Route$PracticeSetup__Documents = {$: 89};
var $author$project$Spa$Generated$Route$PracticeSetup__Legal = {$: 90};
var $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing = {$: 91};
var $author$project$Spa$Generated$Route$PracticeSetup__Plans = {$: 92};
var $author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit = function (a) {
	return {$: 306, a: a};
};
var $author$project$Spa$Generated$Route$PracticeSetup__Plans__New = {$: 259};
var $author$project$Spa$Generated$Route$PracticeSetup__Team = {$: 93};
var $author$project$Spa$Generated$Route$PracticeSetup__Top = {$: 16};
var $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String = function (a) {
	return {$: 281, a: a};
};
var $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top = {$: 193};
var $author$project$Spa$Generated$Route$Reports__CompanyInvoices = {$: 94};
var $author$project$Spa$Generated$Route$Reports__CreditOutstanding = {$: 95};
var $author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary = {$: 260};
var $author$project$Spa$Generated$Route$Reports__CreditTransactions = {$: 96};
var $author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary = {$: 261};
var $author$project$Spa$Generated$Route$Reports__Custom__Id_String = function (a) {
	return {$: 282, a: a};
};
var $author$project$Spa$Generated$Route$Reports__Custom__New = {$: 262};
var $author$project$Spa$Generated$Route$Reports__Dashboard = {$: 97};
var $author$project$Spa$Generated$Route$Reports__DeferredRevenue = {$: 98};
var $author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary = {$: 263};
var $author$project$Spa$Generated$Route$Reports__Deposits = {$: 99};
var $author$project$Spa$Generated$Route$Reports__Disputes = {$: 100};
var $author$project$Spa$Generated$Route$Reports__Invoices = {$: 101};
var $author$project$Spa$Generated$Route$Reports__Memberships = {$: 102};
var $author$project$Spa$Generated$Route$Reports__Months = {$: 103};
var $author$project$Spa$Generated$Route$Reports__PaymentApplications = {$: 104};
var $author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary = {$: 264};
var $author$project$Spa$Generated$Route$Reports__Revenue = {$: 105};
var $author$project$Spa$Generated$Route$Reports__Revenue__Summary = {$: 265};
var $author$project$Spa$Generated$Route$Reports__SalesTax = {$: 106};
var $author$project$Spa$Generated$Route$Reports__SalesTax__Summary = {$: 266};
var $author$project$Spa$Generated$Route$Reports__SignupAttempts = {$: 107};
var $author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators = {$: 108};
var $author$project$Spa$Generated$Route$StyleGuide__AddressInput = {$: 109};
var $author$project$Spa$Generated$Route$StyleGuide__Alert = {$: 110};
var $author$project$Spa$Generated$Route$StyleGuide__Badge = {$: 111};
var $author$project$Spa$Generated$Route$StyleGuide__Button = {$: 112};
var $author$project$Spa$Generated$Route$StyleGuide__Carousel = {$: 113};
var $author$project$Spa$Generated$Route$StyleGuide__Checkbox = {$: 114};
var $author$project$Spa$Generated$Route$StyleGuide__CurrencyInput = {$: 115};
var $author$project$Spa$Generated$Route$StyleGuide__DateInput = {$: 116};
var $author$project$Spa$Generated$Route$StyleGuide__DateRangeInput = {$: 117};
var $author$project$Spa$Generated$Route$StyleGuide__Dropdown = {$: 118};
var $author$project$Spa$Generated$Route$StyleGuide__ExportCsv = {$: 119};
var $author$project$Spa$Generated$Route$StyleGuide__FileInput = {$: 120};
var $author$project$Spa$Generated$Route$StyleGuide__FlexGrid = {$: 121};
var $author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu = {$: 122};
var $author$project$Spa$Generated$Route$StyleGuide__FormExample = {$: 123};
var $author$project$Spa$Generated$Route$StyleGuide__FormGroup = {$: 124};
var $author$project$Spa$Generated$Route$StyleGuide__FormStatic = {$: 125};
var $author$project$Spa$Generated$Route$StyleGuide__HiConfirm = {$: 126};
var $author$project$Spa$Generated$Route$StyleGuide__HorizontalRule = {$: 127};
var $author$project$Spa$Generated$Route$StyleGuide__Icon = {$: 128};
var $author$project$Spa$Generated$Route$StyleGuide__Input = {$: 129};
var $author$project$Spa$Generated$Route$StyleGuide__Link = {$: 130};
var $author$project$Spa$Generated$Route$StyleGuide__ListGroup = {$: 131};
var $author$project$Spa$Generated$Route$StyleGuide__Modal = {$: 132};
var $author$project$Spa$Generated$Route$StyleGuide__Pagination = {$: 133};
var $author$project$Spa$Generated$Route$StyleGuide__Panel = {$: 134};
var $author$project$Spa$Generated$Route$StyleGuide__PasswordInput = {$: 135};
var $author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer = {$: 136};
var $author$project$Spa$Generated$Route$StyleGuide__PhoneInput = {$: 137};
var $author$project$Spa$Generated$Route$StyleGuide__Popover = {$: 138};
var $author$project$Spa$Generated$Route$StyleGuide__ProgressBar = {$: 139};
var $author$project$Spa$Generated$Route$StyleGuide__ResourceFilter = {$: 140};
var $author$project$Spa$Generated$Route$StyleGuide__SearchInput = {$: 141};
var $author$project$Spa$Generated$Route$StyleGuide__SearchableSelect = {$: 142};
var $author$project$Spa$Generated$Route$StyleGuide__Select = {$: 143};
var $author$project$Spa$Generated$Route$StyleGuide__Skeleton = {$: 144};
var $author$project$Spa$Generated$Route$StyleGuide__SvgIcon = {$: 145};
var $author$project$Spa$Generated$Route$StyleGuide__Table = {$: 146};
var $author$project$Spa$Generated$Route$StyleGuide__Tabs = {$: 147};
var $author$project$Spa$Generated$Route$StyleGuide__Toast = {$: 148};
var $author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch = {$: 149};
var $author$project$Spa$Generated$Route$StyleGuide__Tooltip = {$: 150};
var $author$project$Spa$Generated$Route$StyleGuide__Top = {$: 17};
var $author$project$Spa$Generated$Route$StyleGuide__Typography = {$: 151};
var $author$project$Spa$Generated$Route$StyleGuide__UploadForm = {$: 152};
var $author$project$Spa$Generated$Route$StyleGuide__UploadResult = {$: 153};
var $author$project$Spa$Generated$Route$StyleGuide__Well = {$: 154};
var $author$project$Spa$Generated$Route$Support__CannySso = {$: 155};
var $author$project$Spa$Generated$Route$Tasks__New = {$: 156};
var $author$project$Spa$Generated$Route$Tasks__TasksId_String__Top = function (a) {
	return {$: 194, a: a};
};
var $author$project$Spa$Generated$Route$Tasks__Top = {$: 18};
var $author$project$Spa$Generated$Route$Top = {$: 0};
var $author$project$Spa$Generated$Route$User__AcceptTerms = {$: 157};
var $author$project$Spa$Generated$Route$User__Mfa = {$: 158};
var $author$project$Spa$Generated$Route$User__Organizations__Top = {$: 195};
var $author$project$Spa$Generated$Route$User__Profile = {$: 159};
var $author$project$Spa$Generated$Route$User__Security = {$: 160};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.kK;
		var unvisited = _v0.g7;
		var params = _v0.Vx;
		var frag = _v0.iI;
		var value = _v0.aaN;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.kK;
			var unvisited = _v1.g7;
			var params = _v1.Vx;
			var frag = _v1.iI;
			var value = _v1.aaN;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.kK;
		var unvisited = _v0.g7;
		var params = _v0.Vx;
		var frag = _v0.iI;
		var value = _v0.aaN;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.kK;
			var unvisited = _v0.g7;
			var params = _v0.Vx;
			var frag = _v0.iI;
			var value = _v0.aaN;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Spa$Generated$Route$routes = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Top, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Accounting,
			$elm$url$Url$Parser$s('accounting')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Blank,
			$elm$url$Url$Parser$s('blank')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Calendar,
			$elm$url$Url$Parser$s('calendar')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Forms,
			$elm$url$Url$Parser$s('forms')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Home,
			$elm$url$Url$Parser$s('home')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Login,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Logout,
			$elm$url$Url$Parser$s('logout')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NotFound,
			$elm$url$Url$Parser$s('not_found')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboarding,
			$elm$url$Url$Parser$s('onboarding')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$AffiliateBills__Top,
			$elm$url$Url$Parser$s('affiliate_bills')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__Top,
			$elm$url$Url$Parser$s('affiliates')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__Top,
			$elm$url$Url$Parser$s('companies')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Files__Top,
			$elm$url$Url$Parser$s('files')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Top,
			$elm$url$Url$Parser$s('marketplace')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__Top,
			$elm$url$Url$Parser$s('patients')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Top,
			$elm$url$Url$Parser$s('practice_setup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Top,
			$elm$url$Url$Parser$s('style_guide')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Tasks__Top,
			$elm$url$Url$Parser$s('tasks')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__AdvanceBilling,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('advance_billing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Billing,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('billing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CancellationReasons,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('cancellation_reasons'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CardReaders,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('card_readers'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Categories,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('categories'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Commissions,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('commissions'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Coupons,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('coupons'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CreditCategories,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('credit_categories'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ElationLegacy,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('elation_legacy'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Features,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('features'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('hipaa_authorizations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__InternalSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('internal_settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__InvoiceSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('invoice_settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__LeadSources,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('lead_sources'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Locations,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('locations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Mailgun,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('mailgun'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('notes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Patients,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('patients'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('payment_method_import'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__PaymentProcessing,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('payment_processing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__PaymentSources,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('payment_sources'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Practice,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('practice'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ProviderGroups,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('provider_groups'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ScheduledJobs,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('scheduled_jobs'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__SelfService,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('self_service'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Signup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('signup'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Stripe,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('stripe'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Taxes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('taxes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Team,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('team'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__Create,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('affiliates'),
				$elm$url$Url$Parser$s('create'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('affiliates'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Charges__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('charges'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__Statements,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				$elm$url$Url$Parser$s('statements'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('companies'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Contacts__List,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('contacts'),
				$elm$url$Url$Parser$s('list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Contacts__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('contacts'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Files__Public,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('files'),
				$elm$url$Url$Parser$s('public'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__ClonePractice,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('clone_practice'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__Disputes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('disputes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__FeatureFlags,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('feature_flags'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__NewGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('new_group'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__NewPartner,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('new_partner'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__NewPractice,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('new_practice'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Inventory__List,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('inventory'),
				$elm$url$Url$Parser$s('list'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Inventory__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('inventory'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Inventory__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('inventory'),
				$elm$url$Url$Parser$s('settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Manage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('marketplace'),
				$elm$url$Url$Parser$s('manage'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Calls,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('calls'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Drafts,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('drafts'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Forms,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('forms'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Labs,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('labs'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Messages,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('messages'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Sms,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('sms'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Erx,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('erx'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__HinterSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('hinter_settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__PracticeInfo,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('practice_info'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Team,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('team'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Oauth__Callback,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('oauth'),
				$elm$url$Url$Parser$s('callback'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__ApiKeys,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('api_keys'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Billing,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('billing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Engagements,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('engagements'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Hinter,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('hinter'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Product,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('product'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Team,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('team'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__WebhookEndpoints,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('webhook_endpoints'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__Create,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('patients'),
				$elm$url$Url$Parser$s('create'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('patients'),
				$elm$url$Url$Parser$s('upload'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Account,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('account'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Communications,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('communications'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Complete,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('complete'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Documents,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('documents'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Legal,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('legal'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('payment_processing'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Plans,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('plans'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Team,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				$elm$url$Url$Parser$s('team'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CompanyInvoices,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('company_invoices'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('credit_outstanding'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CreditTransactions,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('credit_transactions'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Dashboard,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('dashboard'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('deferred_revenue'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Deposits,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('deposits'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Disputes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('disputes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Invoices,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('invoices'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Memberships,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('memberships'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Months,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('months'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__PaymentApplications,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('payment_applications'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Revenue,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('revenue'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__SalesTax,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('sales_tax'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__SignupAttempts,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('signup_attempts'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('activity_indicators'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__AddressInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('address_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Alert,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('alert'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Badge,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('badge'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Button,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('button'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Carousel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('carousel'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Checkbox,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('checkbox'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__CurrencyInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('currency_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__DateInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('date_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__DateRangeInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('date_range_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Dropdown,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('dropdown'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ExportCsv,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('export_csv'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FileInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('file_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FlexGrid,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('flex_grid'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('flyout_menu'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FormExample,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('form_example'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FormGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('form_group'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__FormStatic,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('form_static'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__HiConfirm,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('hi_confirm'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__HorizontalRule,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('horizontal_rule'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Icon,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('icon'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Input,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Link,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('link'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ListGroup,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('list_group'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Modal,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('modal'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Pagination,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('pagination'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Panel,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('panel'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__PasswordInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('password_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('payment_source_displayer'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__PhoneInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('phone_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Popover,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('popover'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ProgressBar,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('progress_bar'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ResourceFilter,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('resource_filter'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__SearchInput,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('search_input'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__SearchableSelect,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('searchable_select'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Select,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('select'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Skeleton,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('skeleton'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__SvgIcon,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('svg_icon'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Table,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('table'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Tabs,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('tabs'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Toast,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('toast'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('toggle_switch'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Tooltip,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('tooltip'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Typography,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('typography'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__UploadForm,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('upload_form'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__UploadResult,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('upload_result'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$StyleGuide__Well,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('style_guide'),
				$elm$url$Url$Parser$s('well'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Support__CannySso,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('support'),
				$elm$url$Url$Parser$s('canny_sso'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Tasks__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('tasks'),
				$elm$url$Url$Parser$s('new'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__AcceptTerms,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('accept_terms'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__Mfa,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('mfa'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__Profile,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('profile'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__Security,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('security'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Apps__Slug_String,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {_c: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('apps'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Error__Status_String,
			A2(
				$elm$url$Url$Parser$map,
				function (status) {
					return {ag7: status};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('error'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Join__Token_String,
			A2(
				$elm$url$Url$Parser$map,
				function (token) {
					return {$Q: token};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('join'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Slug_String,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {_c: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('marketplace'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('athenahealth'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('charge_items'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CompanyPlans__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('company_plans'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('coverage_plans'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExport__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('data_export'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExportSettings__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('data_export_settings'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Documents__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('documents'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Elation__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('elation'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('plans'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Providers__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('providers'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Quickbooks__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('quickbooks'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__SignupPages__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				$elm$url$Url$Parser$s('signup_pages'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				$elm$url$Url$Parser$s('broker_accounts'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				$elm$url$Url$Parser$s('statement_lines'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Contacts__ContactId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (contactId) {
					return {acb: contactId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('contacts'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('hinter'),
				$elm$url$Url$Parser$s('admin_users_groups'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (inventoryId) {
					return {ad5: inventoryId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('inventory'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Faxes__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('faxes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Scheduled__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				$elm$url$Url$Parser$s('scheduled'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('appointment_types'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Locations__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('locations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Templates__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				$elm$url$Url$Parser$s('templates'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__DealId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (dealId) {
					return {act: dealId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Dashboard__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('dashboard'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Practices__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('practices'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Sandboxes__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				$elm$url$Url$Parser$s('sandboxes'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				$elm$url$Url$Parser$s('ancillary_charges'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Tasks__TasksId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (tasksId) {
					return {ahi: tasksId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('tasks'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$User__Organizations__Top,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('user'),
				$elm$url$Url$Parser$s('organizations'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Fields,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('fields')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Link,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('link')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Locations,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('locations')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Overview,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('overview')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Athenahealth__Providers,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('athenahealth'),
					$elm$url$Url$Parser$s('providers')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ChargeItems__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('charge_items'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ChargeItems__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('charge_items'),
					$elm$url$Url$Parser$s('upload')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CompanyPlans__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('company_plans'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CoveragePlans__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('coverage_plans'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Credits__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('credits'),
					$elm$url$Url$Parser$s('upload')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExportSettings__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('data_export_settings'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__ApiKeys,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('api_keys')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__GetStarted,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('get_started')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__Sandboxes,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('sandboxes')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('developers'),
					$elm$url$Url$Parser$s('webhook_endpoints')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Documents__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('documents'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Elation__Link,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elation'),
					$elm$url$Url$Parser$s('link')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Elation__Overview,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elation'),
					$elm$url$Url$Parser$s('overview')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Elation__Providers,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('elation'),
					$elm$url$Url$Parser$s('providers')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Company,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('company')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Employee,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('employee')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Membership,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('membership')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Patient,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('patient')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Practice,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('practice')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					$elm$url$Url$Parser$s('settings')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('payment_method_import'),
					$elm$url$Url$Parser$s('upload')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('plans'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Providers__Upload,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('providers'),
					$elm$url$Url$Parser$s('upload')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__SignupPages__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('signup_pages'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Team__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('team'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {pp: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('affiliate_actions'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {pp: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('link_providers'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {pp: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('linked_providers'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {pp: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('patients'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {pp: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {pp: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('users'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('broker_accounts'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__StatementLines__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('commissions'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('statement_lines'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('affiliates_pricing'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('eas'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('ended_commissions'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('invoice_settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('notes'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('notifications'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('payment_sources'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('signup'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Faxes__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('faxes'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Scheduled__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('messages'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('scheduled'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('appointment_types'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Templates__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('new_settings'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('templates'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed,
			A2(
				$elm$url$Url$Parser$map,
				function (onboardId) {
					return {afq: onboardId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('completed'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing,
			A2(
				$elm$url$Url$Parser$map,
				function (onboardId) {
					return {afq: onboardId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('completing'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment,
			A2(
				$elm$url$Url$Parser$map,
				function (onboardId) {
					return {afq: onboardId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('payment'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Onboard__OnboardId_String__User,
			A2(
				$elm$url$Url$Parser$map,
				function (onboardId) {
					return {afq: onboardId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('onboard'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('user'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Billing__Hinter,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('billing'),
					$elm$url$Url$Parser$s('hinter')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Product__ActivationSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('product'),
					$elm$url$Url$Parser$s('activation_settings')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Product__AppSettings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('product'),
					$elm$url$Url$Parser$s('app_settings')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Product__Hinter,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('product'),
					$elm$url$Url$Parser$s('hinter')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Partner__Product__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('partner'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('product'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Chart,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('chart'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('edit'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('manage_credits'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Merge,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('merge'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Plans__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('practice_setup'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('plans'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('credit_outstanding'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('credit_transactions'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Custom__New,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('custom'),
					$elm$url$Url$Parser$s('new')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('deferred_revenue'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('payment_applications'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Revenue__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('revenue'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__SalesTax__Summary,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('reports'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('sales_tax'),
					$elm$url$Url$Parser$s('summary')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('charge_items'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('company_plans'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('coverage_plans'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExport__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('data_export'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('data_export_settings'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Documents__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('documents'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Integrations__Slug_String,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {_c: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('integrations'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('plans'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__SignupPages__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('signup_pages'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('hinter'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('admin_users_groups'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String,
			A2(
				$elm$url$Url$Parser$map,
				function (ident) {
					return {adS: ident};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('appointment_types'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (bookingLocationId) {
					return {abH: bookingLocationId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('locations'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (teamId) {
					return {ahk: teamId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('team'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String,
			A2(
				$elm$url$Url$Parser$map,
				function (templateId) {
					return {ahl: templateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('templates'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('reports'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('ancillary_charges'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Reports__Custom__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('reports'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('custom'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (affiliateId) {
					return {pp: affiliateId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('bills'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {bP: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('employees'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('invoices'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('uploads'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (scheduledId) {
					return {agG: scheduledId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('messages'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('scheduled'),
						$elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('accounts'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('affiliation'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('charges'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('memberships'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('notes'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						$elm$url$Url$Parser$s('notifications'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('admin'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('notifications'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('patient'),
						$elm$url$Url$Parser$s('dunning_schedule'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {bP: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('deals')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {bP: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('ended_deals')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('employees'),
							$elm$url$Url$Parser$s('create')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New,
			A2(
				$elm$url$Url$Parser$map,
				function (companyId) {
					return {ff: companyId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('signup_pages'),
							$elm$url$Url$Parser$s('new')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Layer__Manage__Settings,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('marketplace'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('layer'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('manage'),
						$elm$url$Url$Parser$s('settings'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {_c: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('marketplace'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('manage'),
							$elm$url$Url$Parser$s('onboarding')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {_c: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('marketplace'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('manage'),
							$elm$url$Url$Parser$s('settings')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users,
			A2(
				$elm$url$Url$Parser$map,
				function (slug) {
					return {_c: slug};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('marketplace'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('manage'),
							$elm$url$Url$Parser$s('users')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo,
			A2(
				$elm$url$Url$Parser$map,
				function (teamId) {
					return {ahk: teamId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('new_settings'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('team'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('basic_info')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New,
			A2(
				$elm$url$Url$Parser$map,
				function (patientId) {
					return {VN: patientId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('memberships'),
							$elm$url$Url$Parser$s('new')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('practice_setup'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('plans'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('edit')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('billing'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('practice_invoices'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (affiliateId, id) {
						return {pp: affiliateId, adR: id};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('affiliates'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('bills'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (companyId, id) {
						return {ff: companyId, adR: id};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('invoices'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (companyId, id) {
						return {ff: companyId, adR: id};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('signup_pages'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {bP: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('brokers')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {bP: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							$elm$url$Url$Parser$s('statements')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (companyId, uploadId) {
						return {ff: companyId, HK: uploadId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('uploads'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (patientId, agreementId) {
						return {IM: agreementId, VN: patientId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('agreements'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (patientId, invoiceId) {
						return {aea: invoiceId, VN: patientId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('charges'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (patientId, membershipId) {
						return {yS: membershipId, VN: patientId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('patients'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('memberships'),
							$elm$url$Url$Parser$string))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New,
			A2(
				$elm$url$Url$Parser$map,
				function (id) {
					return {adR: id};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('plans'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('pricing_versions'),
								$elm$url$Url$Parser$s('new'))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {bP: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('brokers'),
								$elm$url$Url$Parser$s('ended'))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New,
			A2(
				$elm$url$Url$Parser$map,
				function (brokerAccountId) {
					return {bP: brokerAccountId};
				},
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('brokers'),
								$elm$url$Url$Parser$s('new'))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (companyId, uploadId) {
						return {ff: companyId, HK: uploadId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('uploads'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$string,
								$elm$url$Url$Parser$s('upload_results'))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (id, pricingVersionId) {
						return {adR: id, afY: pricingVersionId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('admin'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('plans'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('pricing_versions'),
								$elm$url$Url$Parser$string)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (brokerAccountId, statementId) {
						return {bP: brokerAccountId, ag6: statementId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('statements'),
								$elm$url$Url$Parser$string)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F2(
					function (brokerAccountId, brokerId) {
						return {bP: brokerAccountId, Eo: brokerId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('commissions'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('broker_accounts'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('brokers'),
								$elm$url$Url$Parser$string)))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top,
			A2(
				$elm$url$Url$Parser$map,
				F3(
					function (companyId, employeeId, dependentId) {
						return {ff: companyId, acF: dependentId, acX: employeeId};
					}),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('companies'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$string,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('employees'),
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$string,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('dependent'),
									$elm$url$Url$Parser$string)))))))
		]));
var $author$project$Spa$Generated$Route$fromUrl = $elm$url$Url$Parser$parse($author$project$Spa$Generated$Route$routes);
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Utils$Route$fromUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Spa$Generated$Route$fromUrl,
	$elm$core$Maybe$withDefault($author$project$Spa$Generated$Route$NotFound));
var $jinjor$elm_debounce$Debounce$Debounce = $elm$core$Basics$identity;
var $jinjor$elm_debounce$Debounce$init = {d5: _List_Nil, S6: false};
var $author$project$Shared$GlobalSearchMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Shared$GotTimeZone = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Data$Loading = {$: 1};
var $author$project$OutMsg$NoAction = {$: 0};
var $author$project$Api$Data$NotAsked = {$: 0};
var $author$project$Shared$ReleaseMsg = function (a) {
	return {$: 14, a: a};
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Api$Data$Client = $elm$core$Basics$identity;
var $author$project$Api$Data$clientInit = F4(
	function (prePath, providerAuthUrl, apiVersion, authToken) {
		return {D6: apiVersion, e2: authToken, A6: prePath, GU: providerAuthUrl, B9: true};
	});
var $author$project$Utils$Environment$Development = 2;
var $author$project$Utils$Environment$Feature = 3;
var $author$project$Utils$Environment$Production = 0;
var $author$project$Utils$Environment$Staging = 1;
var $author$project$Utils$Environment$decode = function (envName) {
	return A2(
		$elm$core$Maybe$andThen,
		function (env) {
			switch (env) {
				case 'production':
					return $elm$core$Maybe$Just(0);
				case 'staging':
					return $elm$core$Maybe$Just(1);
				case 'development':
					return $elm$core$Maybe$Just(2);
				case 'feature':
					return $elm$core$Maybe$Just(3);
				default:
					return $elm$core$Maybe$Nothing;
			}
		},
		envName);
};
var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(
	function (history, current) {
		return {Mr: current, b9: history};
	});
var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(
	function (standardOffset, zoneRules) {
		return {Hk: standardOffset, HT: zoneRules};
	});
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(
	function (year, month, day, time, clock) {
		return {fe: clock, acq: day, aeI: month, ahs: time, ahX: year};
	});
var $elm$time$Time$Jan = 0;
var $justinmimbs$timezone_data$TimeZone$Specification$Universal = 0;
var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function (_v0) {
	dropChangesBeforeEpoch:
	while (true) {
		var initial = _v0.a;
		var changes = _v0.b;
		if (changes.b) {
			var change = changes.a;
			var rest = changes.b;
			if (change.Hl <= 0) {
				var $temp$_v0 = _Utils_Tuple2(change.f, rest);
				_v0 = $temp$_v0;
				continue dropChangesBeforeEpoch;
			} else {
				return _Utils_Tuple2(initial, changes);
			}
		} else {
			return _Utils_Tuple2(initial, _List_Nil);
		}
	}
};
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $justinmimbs$timezone_data$RataDie$weekdayNumber = function (rd) {
	var _v0 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v0) {
		return 7;
	} else {
		var n = _v0;
		return n;
	}
};
var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(
	function (weekday, rd) {
		var daysSincePreviousWeekday = A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7) - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
		return rd - daysSincePreviousWeekday;
	});
var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(
	function (weekday, rd) {
		var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
		return _Utils_eq(rd, floored) ? rd : (floored + 7);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$timezone_data$RataDie$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
	return (365 * y) + leapYears;
};
var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(
	function (y, m, d) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + d;
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m)) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function (rd) {
	return (rd - 719163) * 1440;
};
var $elm$core$List$sortBy = _List_sortBy;
var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(
	function (clock, _v0) {
		var standard = _v0.gS;
		var save = _v0.agD;
		switch (clock) {
			case 0:
				return 0;
			case 1:
				return 0 - standard;
			default:
				return 0 - (standard + save);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function (_v0) {
	var year = _v0.ahX;
	var month = _v0.aeI;
	var day = _v0.acq;
	var time = _v0.ahs;
	return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
		A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
};
var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(
	function (offset, datetime) {
		return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.fe, offset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(
	function (previousOffset, start, until, standardOffset, rules) {
		var transitions = A2(
			$elm$core$List$concatMap,
			function (year) {
				return A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.Hl;
					},
					A2(
						$elm$core$List$map,
						function (rule) {
							return {
								fe: rule.fe,
								agD: rule.agD,
								Hl: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(
									function () {
										var _v2 = rule.acq;
										switch (_v2.$) {
											case 0:
												var day = _v2.a;
												return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.aeI, day);
											case 1:
												var weekday = _v2.a;
												var after = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$ceilingWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.aeI, after));
											case 2:
												var weekday = _v2.a;
												var before = _v2.b;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.aeI, before));
											default:
												var weekday = _v2.a;
												return A2(
													$justinmimbs$timezone_data$RataDie$floorWeekday,
													weekday,
													A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.aeI));
										}
									}()) + rule.ahs
							};
						},
						A2(
							$elm$core$List$filter,
							function (rule) {
								return (_Utils_cmp(rule.PG, year) < 1) && (_Utils_cmp(year, rule.$H) < 1);
							},
							rules)));
			},
			A2($elm$core$List$range, start.ahX - 1, until.ahX));
		var initialOffset = {agD: 0, gS: standardOffset};
		var initialChange = {
			f: standardOffset,
			Hl: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
		};
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (transition, _v1) {
					var currentOffset = _v1.a;
					var changes = _v1.b;
					var newOffset = {agD: transition.agD, gS: standardOffset};
					if (_Utils_cmp(
						transition.Hl + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fe, previousOffset),
						initialChange.Hl) < 1) {
						var updatedInitialChange = {f: standardOffset + transition.agD, Hl: initialChange.Hl};
						return _Utils_Tuple2(
							newOffset,
							_List_fromArray(
								[updatedInitialChange]));
					} else {
						if (_Utils_cmp(
							transition.Hl + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fe, currentOffset),
							A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
							var change = {
								f: standardOffset + transition.agD,
								Hl: transition.Hl + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fe, currentOffset)
							};
							return _Utils_Tuple2(
								newOffset,
								A2($elm$core$List$cons, change, changes));
						} else {
							return _Utils_Tuple2(currentOffset, changes);
						}
					}
				}),
			_Utils_Tuple2(
				initialOffset,
				_List_fromArray(
					[initialChange])),
			transitions);
		var nextOffset = _v0.a;
		var descendingChanges = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(descendingChanges),
			nextOffset);
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(
	function (previousOffset, start, until, _v0) {
		var standardOffset = _v0.Hk;
		var zoneRules = _v0.HT;
		if (!zoneRules.$) {
			var save = zoneRules.a;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						f: standardOffset + save,
						Hl: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
					}
					]),
				{agD: save, gS: standardOffset});
		} else {
			var rules = zoneRules.a;
			return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(
	function (f, a, rev, list) {
		stripDuplicatesByHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(rev);
			} else {
				var x = list.a;
				var xs = list.b;
				var b = f(x);
				var rev_ = (!_Utils_eq(a, b)) ? A2($elm$core$List$cons, x, rev) : rev;
				var $temp$f = f,
					$temp$a = b,
					$temp$rev = rev_,
					$temp$list = xs;
				f = $temp$f;
				a = $temp$a;
				rev = $temp$rev;
				list = $temp$list;
				continue stripDuplicatesByHelp;
			}
		}
	});
var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(
	function (zoneStart, zoneUntil, zone) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, _v2) {
					var state = _v1.a;
					var nextStart = _v1.b;
					var start = _v2.a;
					var ranges = _v2.b;
					return _Utils_Tuple2(
						nextStart,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple3(start, state, nextStart),
							ranges));
				}),
			_Utils_Tuple2(zoneStart, _List_Nil),
			zone.b9);
		var currentStart = _v0.a;
		var historyRanges = _v0.b;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple3(currentStart, zone.Mr, zoneUntil),
				historyRanges));
	});
var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(
	function (minYear, maxYear, zone) {
		var initialState = function () {
			var _v5 = zone.b9;
			if (_v5.b) {
				var _v6 = _v5.a;
				var earliest = _v6.a;
				return earliest;
			} else {
				return zone.Mr;
			}
		}();
		var initialOffset = {
			agD: function () {
				var _v4 = initialState.HT;
				if (!_v4.$) {
					var save = _v4.a;
					return save;
				} else {
					return 0;
				}
			}(),
			gS: initialState.Hk
		};
		var ascendingChanges = A4(
			$justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp,
			function ($) {
				return $.f;
			},
			initialOffset.gS + initialOffset.agD,
			_List_Nil,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v1, _v2) {
						var start = _v1.a;
						var state = _v1.b;
						var until = _v1.c;
						var prevOffset = _v2.a;
						var prevChanges = _v2.b;
						var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
						var nextChanges = _v3.a;
						var nextOffset = _v3.b;
						return _Utils_Tuple2(
							nextOffset,
							_Utils_ap(prevChanges, nextChanges));
					}),
				_Utils_Tuple2(initialOffset, _List_Nil),
				A3(
					$justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges,
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, 0, 1, 0, 0),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, 0, 1, 0, 0),
					zone)).b);
		var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(
			_Utils_Tuple2(initialOffset.gS + initialOffset.agD, ascendingChanges));
		var initial = _v0.a;
		var ascending = _v0.b;
		return _Utils_Tuple2(
			$elm$core$List$reverse(ascending),
			initial);
	});
var $justinmimbs$timezone_data$TimeZone$fromSpecification = function (zone) {
	var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
	var descending = _v0.a;
	var bottom = _v0.b;
	return A2($elm$time$Time$customZone, bottom, descending);
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$Apr = 3;
var $justinmimbs$timezone_data$TimeZone$Specification$Day = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Feb = 1;
var $justinmimbs$timezone_data$TimeZone$Specification$Last = function (a) {
	return {$: 3, a: a};
};
var $elm$time$Time$Mar = 2;
var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(
	function (from, to, month, day, time, clock, save) {
		return {fe: clock, acq: day, PG: from, aeI: month, agD: save, ahs: time, $H: to};
	});
var $elm$time$Time$Sun = 6;
var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = 2;
var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $author$project$Shared$defaultTimeZone = $justinmimbs$timezone_data$TimeZone$america__los_angeles(0);
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$fromRataDie = function (rd) {
	return rd;
};
var $author$project$Api$AuthToken$Valid = $elm$core$Basics$identity;
var $author$project$Api$AuthToken$fromString = function (authToken) {
	return authToken;
};
var $justinmimbs$timezone_data$TimeZone$NoDataForZoneName = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$timezone_data$TimeZone$NoZoneName = {$: 0};
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$getZoneName = _Time_getZoneName(0);
var $justinmimbs$timezone_data$TimeZone$Specification$Save = function (a) {
	return {$: 0, a: a};
};
var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__accra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__addis_ababa = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $elm$time$Time$May = 4;
var $elm$time$Time$Sep = 8;
var $justinmimbs$timezone_data$TimeZone$Specification$Standard = 1;
var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1380,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1380,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__algiers = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 26, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 4, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__asmara = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__bamako = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__lagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__bangui = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__banjul = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__bissau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__maputo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__blantyre = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__brazzaville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__bujumbura = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Thu = 3;
var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1959,
		1981,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1994,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1988,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1994,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2010,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 3, 1),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__cairo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
};
var $elm$time$Time$Dec = 11;
var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2018,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2021,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2022,
		2022,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2023,
		2023,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2025,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2026,
		2026,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2027,
		2027,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2028,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2029,
		2029,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2030,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2031,
		2031,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2032,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2033,
		2033,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2034,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2035,
		2035,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2036,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2037,
		2037,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$africa__conakry = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__dakar = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__djibouti = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__douala = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 3, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
};
var $justinmimbs$timezone_data$TimeZone$africa__freetown = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__gaborone = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__harare = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__juba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 1, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__kampala = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__kigali = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__kinshasa = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__libreville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__lome = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__luanda = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__lubumbashi = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__lusaka = $justinmimbs$timezone_data$TimeZone$africa__maputo;
var $justinmimbs$timezone_data$TimeZone$africa__malabo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__maseru = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
var $justinmimbs$timezone_data$TimeZone$africa__mbabane = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
var $justinmimbs$timezone_data$TimeZone$africa__mogadishu = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-45,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 7, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 2, 8, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$africa__niamey = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__nouakchott = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__ouagadougou = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$africa__porto_novo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 0, 1, 60, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 1, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 9, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 10, 10, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 9, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__tunis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2017,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2017,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
};
var $justinmimbs$timezone_data$TimeZone$america__adak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__anchorage = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__port_of_spain = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__anguilla = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__antigua = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2017,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2011,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2014,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2019,
		1,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2018,
		2018,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__araguaina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 8, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1969,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1993,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1992,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 6, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 18, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 8, 26, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 14, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 0, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 11, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
};
var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__curacao = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__aruba = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1995,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1995,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2001,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2001,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2004,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2003,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2009,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2012,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__asuncion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para))));
};
var $justinmimbs$timezone_data$TimeZone$america__atikokan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__bahia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2000,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 3, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__barbados = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
};
var $justinmimbs$timezone_data$TimeZone$america__belem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__belize = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__blanc_sablon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__bogota = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
};
var $justinmimbs$timezone_data$TimeZone$america__boise = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 1, 3, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 10, 5, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__cancun = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 7, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 1, 1, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__caracas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 11, 9, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-270,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 1, 150, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayenne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__panama = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cayman = $justinmimbs$timezone_data$TimeZone$america__panama;
var $justinmimbs$timezone_data$TimeZone$america__chicago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $elm$time$Time$Sat = 5;
var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		5,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
};
var $justinmimbs$timezone_data$TimeZone$america__creston = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__dawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 9, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 7, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__denver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__detroit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 3, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__dominica = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__edmonton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
};
var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1962,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1951,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1960,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		1,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2010,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__grenada = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__guadeloupe = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guatemala = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$america__guyana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-225,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 6, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__halifax = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1990,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1985,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 14),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1997,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2003,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2010,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		0,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__havana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
};
var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__inuvik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 3, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__jamaica = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__juneau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 27, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 9, 26, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__kralendijk = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$america__la_paz = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__lima = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
};
var $justinmimbs$timezone_data$TimeZone$america__lower_princes = $justinmimbs$timezone_data$TimeZone$america__curacao;
var $justinmimbs$timezone_data$TimeZone$america__maceio = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 9, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 4, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $elm$time$Time$Mon = 0;
var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1980,
		5,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 23),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__managua = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 1, 16, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
};
var $justinmimbs$timezone_data$TimeZone$america__manaus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__marigot = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__martinique = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__matamoros = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__menominee = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 3, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__merida = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 11, 2, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 10, 4, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 20, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$america__miquelon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1946,
		1972,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1972,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		1,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__moncton = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__monterrey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		2,
		90),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1991,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2015,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2014,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__montevideo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 2, 10, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 11, 22, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
};
var $justinmimbs$timezone_data$TimeZone$america__montserrat = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$rules_Bahamas = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1964,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1964,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__nassau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bahamas)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__new_york = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nipigon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__nome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__noronha = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 10, 7, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 9, 26, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__nuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__pangnirtung = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 3, 2, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__phoenix = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1987,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1997,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2015,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
};
var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1972,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1986,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1996,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1997,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2010,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		240,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		180,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		240,
		0,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__rainy_river = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__recife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__regina = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__resolute = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 180, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santarem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__santiago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1974,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 3, 60, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
};
var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$america__sitka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_barthelemy = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_johns = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-210,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__st_kitts = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_lucia = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_thomas = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__st_vincent = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__swift_current = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 3, 30, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		7,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thule = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1950,
		1973,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1957,
		1973,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$america__thunder_bay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__tijuana = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__toronto = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__tortola = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
var $justinmimbs$timezone_data$TimeZone$america__vancouver = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1986,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2005,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$america__yakutat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$america__yellowknife = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 5, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1020, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 9, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 7, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 2, 17, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 9, 4, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 2, 8, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 9, 4, 1, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 10, 1200, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1200, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1968,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1971,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1986,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1999,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo = $justinmimbs$timezone_data$TimeZone$pacific__auckland;
var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 11, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__syowa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		120),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 1, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
};
var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__oslo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen = $justinmimbs$timezone_data$TimeZone$europe__oslo;
var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aden = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__almaty = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1988,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1998,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2002,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2012,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__amman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2010,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		180,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 5, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bahrain = $justinmimbs$timezone_data$TimeZone$asia__qatar;
var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		240,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2015,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		300,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__baku = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
};
var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 4, 28, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1987,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__beirut = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 7),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		150,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		150,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 7, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 7, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__brunei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__chita = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2006,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2016,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__choibalsan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 2, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__colombo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 4, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						390,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 26, 30, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 15, 30, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1966,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1992,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1996,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(0),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2011,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__damascus = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dili = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 4, 3, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 8, 17, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dubai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 9, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1997,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 8, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 9, 29, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2005,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2003,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2007,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		1,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2014,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(3),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2013,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		2015,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2018,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1987,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1988,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1990,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1998,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(14),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2001,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2003,
		2003,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2012,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 4, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(9),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(23),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 23),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__gaza = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 7, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 8, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 27, 1, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 7, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hebron = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 5, 13, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		210,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
};
var $justinmimbs$timezone_data$TimeZone$asia__hovd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2006,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2006,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 5, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 10, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 28, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 31, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 25, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 8, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 7, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__istanbul = $justinmimbs$timezone_data$TimeZone$europe__istanbul;
var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kabul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				270,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2002,
		2002,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2009,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(15),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__karachi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 2, 26, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				345,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				330,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuching = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__kuwait = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1965,
		1973,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1976,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1976,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(13),
		210,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		210,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__macau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
};
var $justinmimbs$timezone_data$TimeZone$asia__magadan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 3, 24, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__makassar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__manila = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
};
var $justinmimbs$timezone_data$TimeZone$asia__muscat = $justinmimbs$timezone_data$TimeZone$asia__dubai;
var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 4, 23, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 6, 24, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__omsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__oral = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__phnom_penh = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 7, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 4, 4, 1410, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 11, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1988,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__seoul = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
};
var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1991,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1991,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
};
var $justinmimbs$timezone_data$TimeZone$asia__singapore = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						450,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		6,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__taipei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 27, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 2, 27, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1999,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2003,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2004,
		2004,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2005,
		2005,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2012,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2013,
		2015,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2019,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2023,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		2023,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2024,
		2024,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2027,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2025,
		2027,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2029,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2028,
		2029,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2031,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2030,
		2031,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2033,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2032,
		2033,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2035,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2034,
		2035,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2037,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2036,
		2037,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		1440,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__tehran = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						210,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 10, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				210,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
};
var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						330,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 4, 1, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 29, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						420,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
};
var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__vientiane = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						480,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						540,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yangon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						360,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(25),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1982,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 2, 28, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 28, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 10, 25, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-60,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$atlantic__st_helena = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1985,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		2000,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		2000,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2010,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 8, 15, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 8, 5, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1994,
		1994,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1991,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1981,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						570,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
};
var $justinmimbs$timezone_data$TimeZone$australia__darwin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1991,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(17),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__eucla = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				525,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__hobart = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1993,
		1994,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
};
var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1984,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1985,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1986,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1987,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						630,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				630,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
};
var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1985,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1985,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1990,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1986,
		1987,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1988,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1994,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1995,
		2005,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2007,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2006,
		2006,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		2007,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
};
var $justinmimbs$timezone_data$TimeZone$australia__perth = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				480,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
};
var $justinmimbs$timezone_data$TimeZone$australia__sydney = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$europe__amsterdam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__andorra = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 2, 31, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(11),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		540,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__athens = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 10, 27, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__berlin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__prague = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__bratislava = $justinmimbs$timezone_data$TimeZone$europe__prague;
var $justinmimbs$timezone_data$TimeZone$europe__brussels = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1980,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1995,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1991,
		1993,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1983,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__budapest = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zurich = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__busingen = $justinmimbs$timezone_data$TimeZone$europe__zurich;
var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 6, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
};
var $justinmimbs$timezone_data$TimeZone$europe__copenhagen = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		120,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		120,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		60,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		60,
		0,
		-60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		-60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__dublin = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
};
var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1980,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1995,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23),
		60,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		1995,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		60,
		0,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__london = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 9, 31, 120, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__guernsey = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1982,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__isle_of_man = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$europe__jersey = $justinmimbs$timezone_data$TimeZone$europe__london;
var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kiev = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__kirov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 8, 26, 60, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						0,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 60, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 60, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				0,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ljubljana = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__luxembourg = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 12),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1975,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__madrid = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1967,
		1969,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1970,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1972,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1971,
		1971,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1972,
		1972,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1977,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1979,
		4,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		0,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1979,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1980,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__malta = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 2, 31, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__mariehamn = $justinmimbs$timezone_data$TimeZone$europe__helsinki;
var $justinmimbs$timezone_data$TimeZone$europe__minsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		60,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		60,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__monaco = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__moscow = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__nicosia = $justinmimbs$timezone_data$TimeZone$asia__nicosia;
var $justinmimbs$timezone_data$TimeZone$europe__paris = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__podgorica = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1996,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__riga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 21, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 1, 29, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 2, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__rome = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__samara = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__san_marino = $justinmimbs$timezone_data$TimeZone$europe__rome;
var $justinmimbs$timezone_data$TimeZone$europe__sarajevo = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__saratov = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 4, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 0, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 180, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__skopje = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1982,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1),
		1380,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		60,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__sofia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 2, 31, 1380, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 8, 26, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__stockholm = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 22, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 240, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 21, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(8),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(5),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1979,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(4),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1981,
		1981,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(3),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(18),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1984,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		0,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__tirane = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__uzhgorod = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 180, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vaduz = $justinmimbs$timezone_data$TimeZone$europe__zurich;
var $justinmimbs$timezone_data$TimeZone$europe__vatican = $justinmimbs$timezone_data$TimeZone$europe__rome;
var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1980,
		1980,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		0,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$europe__vienna = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 2, 29, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 60, 0)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						240,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 11, 27, 120, 1))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				180,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						60,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				60,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $justinmimbs$timezone_data$TimeZone$europe__zagreb = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
var $justinmimbs$timezone_data$TimeZone$europe__zaporozhye = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						180,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						120,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				120,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
};
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $justinmimbs$timezone_data$TimeZone$indian__antananarivo = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__chagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				360,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__christmas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				420,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__cocos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				390,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__comoro = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__kerguelen = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__mahe = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$indian__maldives = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				300,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1982,
		1982,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(10),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1983,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(21),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		2008,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
};
var $justinmimbs$timezone_data$TimeZone$indian__mayotte = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
var $justinmimbs$timezone_data$TimeZone$indian__reunion = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				240,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(5),
		180,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		240,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__apia = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 29, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 11, 28, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1975,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1975,
		1988,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1989,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1989,
		1989,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2006,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1990,
		2007,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		165,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2007,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		8,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		165,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2008,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		3,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		165,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				765,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__chuuk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__easter = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-420,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 2, 14, 180, 0))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		720,
		0,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(30),
		720,
		0,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1983,
		1991,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1984,
		1991,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1993,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1992,
		1992,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22),
		1440,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__efate = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__enderbury = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 30, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1998,
		1999,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		2000,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2009,
		2009,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(29),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2010,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2010,
		2013,
		9,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2011,
		2011,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2012,
		2013,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2014,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2014,
		2018,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2015,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 12),
		180,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2019,
		2019,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2020,
		2020,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(20),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2021,
		$justinmimbs$timezone_data$TimeZone$maxYear,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8),
		120,
		2,
		60)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__funafuti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-300,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-360,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		1,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		5,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1969,
		1969,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(31),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1970,
		1971,
		8,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1973,
		1973,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(16),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1974,
		1974,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		4,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(26),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1976,
		1976,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(22),
		121,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		3,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(24),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1977,
		7,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(28),
		120,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__guam = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						600,
						$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 23, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-640,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-600,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				840,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-720,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 7, 20, 1440, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__majuro = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-570,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__midway = $justinmimbs$timezone_data$TimeZone$pacific__pago_pago;
var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 1, 10, 120, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__niue = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 9, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(60)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 2, 2, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						690,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 4, 120, 1)),
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						660,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 6, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
};
var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1977,
		1978,
		11,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1979,
		1,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(27),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1996,
		1996,
		11,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(1),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1997,
		1997,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(2),
		120,
		1,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__palau = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				540,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-510,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 27, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-480,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__pohnpei = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				660,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1978,
		1978,
		10,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(12),
		0,
		2,
		30),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1991,
		2,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		0,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1979,
		1990,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		0,
		2,
		30)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						-630,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 10, 12, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__saipan = $justinmimbs$timezone_data$TimeZone$pacific__guam;
var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				-600,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray(
	[
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		1999,
		1999,
		9,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(7),
		120,
		1,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2000,
		2,
		$justinmimbs$timezone_data$TimeZone$Specification$Day(19),
		120,
		1,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2000,
		2001,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2001,
		2002,
		0,
		$justinmimbs$timezone_data$TimeZone$Specification$Last(6),
		120,
		2,
		0),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2016,
		2016,
		10,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1),
		120,
		2,
		60),
		A7(
		$justinmimbs$timezone_data$TimeZone$Specification$Rule,
		2017,
		2017,
		0,
		A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15),
		180,
		2,
		0)
	]);
var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_fromArray(
				[
					_Utils_Tuple2(
					A2(
						$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
						780,
						$justinmimbs$timezone_data$TimeZone$Specification$Save(0)),
					A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
				]),
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				780,
				$justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__wake = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$pacific__wallis = function (_v0) {
	return $justinmimbs$timezone_data$TimeZone$fromSpecification(
		A2(
			$justinmimbs$timezone_data$TimeZone$Specification$Zone,
			_List_Nil,
			A2(
				$justinmimbs$timezone_data$TimeZone$Specification$ZoneState,
				720,
				$justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
};
var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Africa/Abidjan', $justinmimbs$timezone_data$TimeZone$africa__abidjan),
			_Utils_Tuple2('Africa/Accra', $justinmimbs$timezone_data$TimeZone$africa__accra),
			_Utils_Tuple2('Africa/Addis_Ababa', $justinmimbs$timezone_data$TimeZone$africa__addis_ababa),
			_Utils_Tuple2('Africa/Algiers', $justinmimbs$timezone_data$TimeZone$africa__algiers),
			_Utils_Tuple2('Africa/Asmara', $justinmimbs$timezone_data$TimeZone$africa__asmara),
			_Utils_Tuple2('Africa/Bamako', $justinmimbs$timezone_data$TimeZone$africa__bamako),
			_Utils_Tuple2('Africa/Bangui', $justinmimbs$timezone_data$TimeZone$africa__bangui),
			_Utils_Tuple2('Africa/Banjul', $justinmimbs$timezone_data$TimeZone$africa__banjul),
			_Utils_Tuple2('Africa/Bissau', $justinmimbs$timezone_data$TimeZone$africa__bissau),
			_Utils_Tuple2('Africa/Blantyre', $justinmimbs$timezone_data$TimeZone$africa__blantyre),
			_Utils_Tuple2('Africa/Brazzaville', $justinmimbs$timezone_data$TimeZone$africa__brazzaville),
			_Utils_Tuple2('Africa/Bujumbura', $justinmimbs$timezone_data$TimeZone$africa__bujumbura),
			_Utils_Tuple2('Africa/Cairo', $justinmimbs$timezone_data$TimeZone$africa__cairo),
			_Utils_Tuple2('Africa/Casablanca', $justinmimbs$timezone_data$TimeZone$africa__casablanca),
			_Utils_Tuple2('Africa/Ceuta', $justinmimbs$timezone_data$TimeZone$africa__ceuta),
			_Utils_Tuple2('Africa/Conakry', $justinmimbs$timezone_data$TimeZone$africa__conakry),
			_Utils_Tuple2('Africa/Dakar', $justinmimbs$timezone_data$TimeZone$africa__dakar),
			_Utils_Tuple2('Africa/Dar_es_Salaam', $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam),
			_Utils_Tuple2('Africa/Djibouti', $justinmimbs$timezone_data$TimeZone$africa__djibouti),
			_Utils_Tuple2('Africa/Douala', $justinmimbs$timezone_data$TimeZone$africa__douala),
			_Utils_Tuple2('Africa/El_Aaiun', $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
			_Utils_Tuple2('Africa/Freetown', $justinmimbs$timezone_data$TimeZone$africa__freetown),
			_Utils_Tuple2('Africa/Gaborone', $justinmimbs$timezone_data$TimeZone$africa__gaborone),
			_Utils_Tuple2('Africa/Harare', $justinmimbs$timezone_data$TimeZone$africa__harare),
			_Utils_Tuple2('Africa/Johannesburg', $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
			_Utils_Tuple2('Africa/Juba', $justinmimbs$timezone_data$TimeZone$africa__juba),
			_Utils_Tuple2('Africa/Kampala', $justinmimbs$timezone_data$TimeZone$africa__kampala),
			_Utils_Tuple2('Africa/Khartoum', $justinmimbs$timezone_data$TimeZone$africa__khartoum),
			_Utils_Tuple2('Africa/Kigali', $justinmimbs$timezone_data$TimeZone$africa__kigali),
			_Utils_Tuple2('Africa/Kinshasa', $justinmimbs$timezone_data$TimeZone$africa__kinshasa),
			_Utils_Tuple2('Africa/Lagos', $justinmimbs$timezone_data$TimeZone$africa__lagos),
			_Utils_Tuple2('Africa/Libreville', $justinmimbs$timezone_data$TimeZone$africa__libreville),
			_Utils_Tuple2('Africa/Lome', $justinmimbs$timezone_data$TimeZone$africa__lome),
			_Utils_Tuple2('Africa/Luanda', $justinmimbs$timezone_data$TimeZone$africa__luanda),
			_Utils_Tuple2('Africa/Lubumbashi', $justinmimbs$timezone_data$TimeZone$africa__lubumbashi),
			_Utils_Tuple2('Africa/Lusaka', $justinmimbs$timezone_data$TimeZone$africa__lusaka),
			_Utils_Tuple2('Africa/Malabo', $justinmimbs$timezone_data$TimeZone$africa__malabo),
			_Utils_Tuple2('Africa/Maputo', $justinmimbs$timezone_data$TimeZone$africa__maputo),
			_Utils_Tuple2('Africa/Maseru', $justinmimbs$timezone_data$TimeZone$africa__maseru),
			_Utils_Tuple2('Africa/Mbabane', $justinmimbs$timezone_data$TimeZone$africa__mbabane),
			_Utils_Tuple2('Africa/Mogadishu', $justinmimbs$timezone_data$TimeZone$africa__mogadishu),
			_Utils_Tuple2('Africa/Monrovia', $justinmimbs$timezone_data$TimeZone$africa__monrovia),
			_Utils_Tuple2('Africa/Nairobi', $justinmimbs$timezone_data$TimeZone$africa__nairobi),
			_Utils_Tuple2('Africa/Ndjamena', $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
			_Utils_Tuple2('Africa/Niamey', $justinmimbs$timezone_data$TimeZone$africa__niamey),
			_Utils_Tuple2('Africa/Nouakchott', $justinmimbs$timezone_data$TimeZone$africa__nouakchott),
			_Utils_Tuple2('Africa/Ouagadougou', $justinmimbs$timezone_data$TimeZone$africa__ouagadougou),
			_Utils_Tuple2('Africa/Porto-Novo', $justinmimbs$timezone_data$TimeZone$africa__porto_novo),
			_Utils_Tuple2('Africa/Sao_Tome', $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
			_Utils_Tuple2('Africa/Tripoli', $justinmimbs$timezone_data$TimeZone$africa__tripoli),
			_Utils_Tuple2('Africa/Tunis', $justinmimbs$timezone_data$TimeZone$africa__tunis),
			_Utils_Tuple2('Africa/Windhoek', $justinmimbs$timezone_data$TimeZone$africa__windhoek),
			_Utils_Tuple2('America/Adak', $justinmimbs$timezone_data$TimeZone$america__adak),
			_Utils_Tuple2('America/Anchorage', $justinmimbs$timezone_data$TimeZone$america__anchorage),
			_Utils_Tuple2('America/Anguilla', $justinmimbs$timezone_data$TimeZone$america__anguilla),
			_Utils_Tuple2('America/Antigua', $justinmimbs$timezone_data$TimeZone$america__antigua),
			_Utils_Tuple2('America/Araguaina', $justinmimbs$timezone_data$TimeZone$america__araguaina),
			_Utils_Tuple2('America/Argentina/Buenos_Aires', $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
			_Utils_Tuple2('America/Argentina/Catamarca', $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
			_Utils_Tuple2('America/Argentina/Cordoba', $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
			_Utils_Tuple2('America/Argentina/Jujuy', $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
			_Utils_Tuple2('America/Argentina/La_Rioja', $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
			_Utils_Tuple2('America/Argentina/Mendoza', $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
			_Utils_Tuple2('America/Argentina/Rio_Gallegos', $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
			_Utils_Tuple2('America/Argentina/Salta', $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
			_Utils_Tuple2('America/Argentina/San_Juan', $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
			_Utils_Tuple2('America/Argentina/San_Luis', $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
			_Utils_Tuple2('America/Argentina/Tucuman', $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
			_Utils_Tuple2('America/Argentina/Ushuaia', $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
			_Utils_Tuple2('America/Aruba', $justinmimbs$timezone_data$TimeZone$america__aruba),
			_Utils_Tuple2('America/Asuncion', $justinmimbs$timezone_data$TimeZone$america__asuncion),
			_Utils_Tuple2('America/Atikokan', $justinmimbs$timezone_data$TimeZone$america__atikokan),
			_Utils_Tuple2('America/Bahia', $justinmimbs$timezone_data$TimeZone$america__bahia),
			_Utils_Tuple2('America/Bahia_Banderas', $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
			_Utils_Tuple2('America/Barbados', $justinmimbs$timezone_data$TimeZone$america__barbados),
			_Utils_Tuple2('America/Belem', $justinmimbs$timezone_data$TimeZone$america__belem),
			_Utils_Tuple2('America/Belize', $justinmimbs$timezone_data$TimeZone$america__belize),
			_Utils_Tuple2('America/Blanc-Sablon', $justinmimbs$timezone_data$TimeZone$america__blanc_sablon),
			_Utils_Tuple2('America/Boa_Vista', $justinmimbs$timezone_data$TimeZone$america__boa_vista),
			_Utils_Tuple2('America/Bogota', $justinmimbs$timezone_data$TimeZone$america__bogota),
			_Utils_Tuple2('America/Boise', $justinmimbs$timezone_data$TimeZone$america__boise),
			_Utils_Tuple2('America/Cambridge_Bay', $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
			_Utils_Tuple2('America/Campo_Grande', $justinmimbs$timezone_data$TimeZone$america__campo_grande),
			_Utils_Tuple2('America/Cancun', $justinmimbs$timezone_data$TimeZone$america__cancun),
			_Utils_Tuple2('America/Caracas', $justinmimbs$timezone_data$TimeZone$america__caracas),
			_Utils_Tuple2('America/Cayenne', $justinmimbs$timezone_data$TimeZone$america__cayenne),
			_Utils_Tuple2('America/Cayman', $justinmimbs$timezone_data$TimeZone$america__cayman),
			_Utils_Tuple2('America/Chicago', $justinmimbs$timezone_data$TimeZone$america__chicago),
			_Utils_Tuple2('America/Chihuahua', $justinmimbs$timezone_data$TimeZone$america__chihuahua),
			_Utils_Tuple2('America/Costa_Rica', $justinmimbs$timezone_data$TimeZone$america__costa_rica),
			_Utils_Tuple2('America/Creston', $justinmimbs$timezone_data$TimeZone$america__creston),
			_Utils_Tuple2('America/Cuiaba', $justinmimbs$timezone_data$TimeZone$america__cuiaba),
			_Utils_Tuple2('America/Curacao', $justinmimbs$timezone_data$TimeZone$america__curacao),
			_Utils_Tuple2('America/Danmarkshavn', $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
			_Utils_Tuple2('America/Dawson', $justinmimbs$timezone_data$TimeZone$america__dawson),
			_Utils_Tuple2('America/Dawson_Creek', $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
			_Utils_Tuple2('America/Denver', $justinmimbs$timezone_data$TimeZone$america__denver),
			_Utils_Tuple2('America/Detroit', $justinmimbs$timezone_data$TimeZone$america__detroit),
			_Utils_Tuple2('America/Dominica', $justinmimbs$timezone_data$TimeZone$america__dominica),
			_Utils_Tuple2('America/Edmonton', $justinmimbs$timezone_data$TimeZone$america__edmonton),
			_Utils_Tuple2('America/Eirunepe', $justinmimbs$timezone_data$TimeZone$america__eirunepe),
			_Utils_Tuple2('America/El_Salvador', $justinmimbs$timezone_data$TimeZone$america__el_salvador),
			_Utils_Tuple2('America/Fort_Nelson', $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
			_Utils_Tuple2('America/Fortaleza', $justinmimbs$timezone_data$TimeZone$america__fortaleza),
			_Utils_Tuple2('America/Glace_Bay', $justinmimbs$timezone_data$TimeZone$america__glace_bay),
			_Utils_Tuple2('America/Goose_Bay', $justinmimbs$timezone_data$TimeZone$america__goose_bay),
			_Utils_Tuple2('America/Grand_Turk', $justinmimbs$timezone_data$TimeZone$america__grand_turk),
			_Utils_Tuple2('America/Grenada', $justinmimbs$timezone_data$TimeZone$america__grenada),
			_Utils_Tuple2('America/Guadeloupe', $justinmimbs$timezone_data$TimeZone$america__guadeloupe),
			_Utils_Tuple2('America/Guatemala', $justinmimbs$timezone_data$TimeZone$america__guatemala),
			_Utils_Tuple2('America/Guayaquil', $justinmimbs$timezone_data$TimeZone$america__guayaquil),
			_Utils_Tuple2('America/Guyana', $justinmimbs$timezone_data$TimeZone$america__guyana),
			_Utils_Tuple2('America/Halifax', $justinmimbs$timezone_data$TimeZone$america__halifax),
			_Utils_Tuple2('America/Havana', $justinmimbs$timezone_data$TimeZone$america__havana),
			_Utils_Tuple2('America/Hermosillo', $justinmimbs$timezone_data$TimeZone$america__hermosillo),
			_Utils_Tuple2('America/Indiana/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
			_Utils_Tuple2('America/Indiana/Knox', $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
			_Utils_Tuple2('America/Indiana/Marengo', $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
			_Utils_Tuple2('America/Indiana/Petersburg', $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
			_Utils_Tuple2('America/Indiana/Tell_City', $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
			_Utils_Tuple2('America/Indiana/Vevay', $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
			_Utils_Tuple2('America/Indiana/Vincennes', $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
			_Utils_Tuple2('America/Indiana/Winamac', $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
			_Utils_Tuple2('America/Inuvik', $justinmimbs$timezone_data$TimeZone$america__inuvik),
			_Utils_Tuple2('America/Iqaluit', $justinmimbs$timezone_data$TimeZone$america__iqaluit),
			_Utils_Tuple2('America/Jamaica', $justinmimbs$timezone_data$TimeZone$america__jamaica),
			_Utils_Tuple2('America/Juneau', $justinmimbs$timezone_data$TimeZone$america__juneau),
			_Utils_Tuple2('America/Kentucky/Louisville', $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
			_Utils_Tuple2('America/Kentucky/Monticello', $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
			_Utils_Tuple2('America/Kralendijk', $justinmimbs$timezone_data$TimeZone$america__kralendijk),
			_Utils_Tuple2('America/La_Paz', $justinmimbs$timezone_data$TimeZone$america__la_paz),
			_Utils_Tuple2('America/Lima', $justinmimbs$timezone_data$TimeZone$america__lima),
			_Utils_Tuple2('America/Los_Angeles', $justinmimbs$timezone_data$TimeZone$america__los_angeles),
			_Utils_Tuple2('America/Lower_Princes', $justinmimbs$timezone_data$TimeZone$america__lower_princes),
			_Utils_Tuple2('America/Maceio', $justinmimbs$timezone_data$TimeZone$america__maceio),
			_Utils_Tuple2('America/Managua', $justinmimbs$timezone_data$TimeZone$america__managua),
			_Utils_Tuple2('America/Manaus', $justinmimbs$timezone_data$TimeZone$america__manaus),
			_Utils_Tuple2('America/Marigot', $justinmimbs$timezone_data$TimeZone$america__marigot),
			_Utils_Tuple2('America/Martinique', $justinmimbs$timezone_data$TimeZone$america__martinique),
			_Utils_Tuple2('America/Matamoros', $justinmimbs$timezone_data$TimeZone$america__matamoros),
			_Utils_Tuple2('America/Mazatlan', $justinmimbs$timezone_data$TimeZone$america__mazatlan),
			_Utils_Tuple2('America/Menominee', $justinmimbs$timezone_data$TimeZone$america__menominee),
			_Utils_Tuple2('America/Merida', $justinmimbs$timezone_data$TimeZone$america__merida),
			_Utils_Tuple2('America/Metlakatla', $justinmimbs$timezone_data$TimeZone$america__metlakatla),
			_Utils_Tuple2('America/Mexico_City', $justinmimbs$timezone_data$TimeZone$america__mexico_city),
			_Utils_Tuple2('America/Miquelon', $justinmimbs$timezone_data$TimeZone$america__miquelon),
			_Utils_Tuple2('America/Moncton', $justinmimbs$timezone_data$TimeZone$america__moncton),
			_Utils_Tuple2('America/Monterrey', $justinmimbs$timezone_data$TimeZone$america__monterrey),
			_Utils_Tuple2('America/Montevideo', $justinmimbs$timezone_data$TimeZone$america__montevideo),
			_Utils_Tuple2('America/Montserrat', $justinmimbs$timezone_data$TimeZone$america__montserrat),
			_Utils_Tuple2('America/Nassau', $justinmimbs$timezone_data$TimeZone$america__nassau),
			_Utils_Tuple2('America/New_York', $justinmimbs$timezone_data$TimeZone$america__new_york),
			_Utils_Tuple2('America/Nipigon', $justinmimbs$timezone_data$TimeZone$america__nipigon),
			_Utils_Tuple2('America/Nome', $justinmimbs$timezone_data$TimeZone$america__nome),
			_Utils_Tuple2('America/Noronha', $justinmimbs$timezone_data$TimeZone$america__noronha),
			_Utils_Tuple2('America/North_Dakota/Beulah', $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
			_Utils_Tuple2('America/North_Dakota/Center', $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
			_Utils_Tuple2('America/North_Dakota/New_Salem', $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
			_Utils_Tuple2('America/Nuuk', $justinmimbs$timezone_data$TimeZone$america__nuuk),
			_Utils_Tuple2('America/Ojinaga', $justinmimbs$timezone_data$TimeZone$america__ojinaga),
			_Utils_Tuple2('America/Panama', $justinmimbs$timezone_data$TimeZone$america__panama),
			_Utils_Tuple2('America/Pangnirtung', $justinmimbs$timezone_data$TimeZone$america__pangnirtung),
			_Utils_Tuple2('America/Paramaribo', $justinmimbs$timezone_data$TimeZone$america__paramaribo),
			_Utils_Tuple2('America/Phoenix', $justinmimbs$timezone_data$TimeZone$america__phoenix),
			_Utils_Tuple2('America/Port-au-Prince', $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
			_Utils_Tuple2('America/Port_of_Spain', $justinmimbs$timezone_data$TimeZone$america__port_of_spain),
			_Utils_Tuple2('America/Porto_Velho', $justinmimbs$timezone_data$TimeZone$america__porto_velho),
			_Utils_Tuple2('America/Puerto_Rico', $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
			_Utils_Tuple2('America/Punta_Arenas', $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
			_Utils_Tuple2('America/Rainy_River', $justinmimbs$timezone_data$TimeZone$america__rainy_river),
			_Utils_Tuple2('America/Rankin_Inlet', $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
			_Utils_Tuple2('America/Recife', $justinmimbs$timezone_data$TimeZone$america__recife),
			_Utils_Tuple2('America/Regina', $justinmimbs$timezone_data$TimeZone$america__regina),
			_Utils_Tuple2('America/Resolute', $justinmimbs$timezone_data$TimeZone$america__resolute),
			_Utils_Tuple2('America/Rio_Branco', $justinmimbs$timezone_data$TimeZone$america__rio_branco),
			_Utils_Tuple2('America/Santarem', $justinmimbs$timezone_data$TimeZone$america__santarem),
			_Utils_Tuple2('America/Santiago', $justinmimbs$timezone_data$TimeZone$america__santiago),
			_Utils_Tuple2('America/Santo_Domingo', $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
			_Utils_Tuple2('America/Sao_Paulo', $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
			_Utils_Tuple2('America/Scoresbysund', $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
			_Utils_Tuple2('America/Sitka', $justinmimbs$timezone_data$TimeZone$america__sitka),
			_Utils_Tuple2('America/St_Barthelemy', $justinmimbs$timezone_data$TimeZone$america__st_barthelemy),
			_Utils_Tuple2('America/St_Johns', $justinmimbs$timezone_data$TimeZone$america__st_johns),
			_Utils_Tuple2('America/St_Kitts', $justinmimbs$timezone_data$TimeZone$america__st_kitts),
			_Utils_Tuple2('America/St_Lucia', $justinmimbs$timezone_data$TimeZone$america__st_lucia),
			_Utils_Tuple2('America/St_Thomas', $justinmimbs$timezone_data$TimeZone$america__st_thomas),
			_Utils_Tuple2('America/St_Vincent', $justinmimbs$timezone_data$TimeZone$america__st_vincent),
			_Utils_Tuple2('America/Swift_Current', $justinmimbs$timezone_data$TimeZone$america__swift_current),
			_Utils_Tuple2('America/Tegucigalpa', $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
			_Utils_Tuple2('America/Thule', $justinmimbs$timezone_data$TimeZone$america__thule),
			_Utils_Tuple2('America/Thunder_Bay', $justinmimbs$timezone_data$TimeZone$america__thunder_bay),
			_Utils_Tuple2('America/Tijuana', $justinmimbs$timezone_data$TimeZone$america__tijuana),
			_Utils_Tuple2('America/Toronto', $justinmimbs$timezone_data$TimeZone$america__toronto),
			_Utils_Tuple2('America/Tortola', $justinmimbs$timezone_data$TimeZone$america__tortola),
			_Utils_Tuple2('America/Vancouver', $justinmimbs$timezone_data$TimeZone$america__vancouver),
			_Utils_Tuple2('America/Whitehorse', $justinmimbs$timezone_data$TimeZone$america__whitehorse),
			_Utils_Tuple2('America/Winnipeg', $justinmimbs$timezone_data$TimeZone$america__winnipeg),
			_Utils_Tuple2('America/Yakutat', $justinmimbs$timezone_data$TimeZone$america__yakutat),
			_Utils_Tuple2('America/Yellowknife', $justinmimbs$timezone_data$TimeZone$america__yellowknife),
			_Utils_Tuple2('Antarctica/Casey', $justinmimbs$timezone_data$TimeZone$antarctica__casey),
			_Utils_Tuple2('Antarctica/Davis', $justinmimbs$timezone_data$TimeZone$antarctica__davis),
			_Utils_Tuple2('Antarctica/DumontDUrville', $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville),
			_Utils_Tuple2('Antarctica/Macquarie', $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
			_Utils_Tuple2('Antarctica/Mawson', $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
			_Utils_Tuple2('Antarctica/McMurdo', $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo),
			_Utils_Tuple2('Antarctica/Palmer', $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
			_Utils_Tuple2('Antarctica/Rothera', $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
			_Utils_Tuple2('Antarctica/Syowa', $justinmimbs$timezone_data$TimeZone$antarctica__syowa),
			_Utils_Tuple2('Antarctica/Troll', $justinmimbs$timezone_data$TimeZone$antarctica__troll),
			_Utils_Tuple2('Antarctica/Vostok', $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
			_Utils_Tuple2('Arctic/Longyearbyen', $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen),
			_Utils_Tuple2('Asia/Aden', $justinmimbs$timezone_data$TimeZone$asia__aden),
			_Utils_Tuple2('Asia/Almaty', $justinmimbs$timezone_data$TimeZone$asia__almaty),
			_Utils_Tuple2('Asia/Amman', $justinmimbs$timezone_data$TimeZone$asia__amman),
			_Utils_Tuple2('Asia/Anadyr', $justinmimbs$timezone_data$TimeZone$asia__anadyr),
			_Utils_Tuple2('Asia/Aqtau', $justinmimbs$timezone_data$TimeZone$asia__aqtau),
			_Utils_Tuple2('Asia/Aqtobe', $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
			_Utils_Tuple2('Asia/Ashgabat', $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
			_Utils_Tuple2('Asia/Atyrau', $justinmimbs$timezone_data$TimeZone$asia__atyrau),
			_Utils_Tuple2('Asia/Baghdad', $justinmimbs$timezone_data$TimeZone$asia__baghdad),
			_Utils_Tuple2('Asia/Bahrain', $justinmimbs$timezone_data$TimeZone$asia__bahrain),
			_Utils_Tuple2('Asia/Baku', $justinmimbs$timezone_data$TimeZone$asia__baku),
			_Utils_Tuple2('Asia/Bangkok', $justinmimbs$timezone_data$TimeZone$asia__bangkok),
			_Utils_Tuple2('Asia/Barnaul', $justinmimbs$timezone_data$TimeZone$asia__barnaul),
			_Utils_Tuple2('Asia/Beirut', $justinmimbs$timezone_data$TimeZone$asia__beirut),
			_Utils_Tuple2('Asia/Bishkek', $justinmimbs$timezone_data$TimeZone$asia__bishkek),
			_Utils_Tuple2('Asia/Brunei', $justinmimbs$timezone_data$TimeZone$asia__brunei),
			_Utils_Tuple2('Asia/Chita', $justinmimbs$timezone_data$TimeZone$asia__chita),
			_Utils_Tuple2('Asia/Choibalsan', $justinmimbs$timezone_data$TimeZone$asia__choibalsan),
			_Utils_Tuple2('Asia/Colombo', $justinmimbs$timezone_data$TimeZone$asia__colombo),
			_Utils_Tuple2('Asia/Damascus', $justinmimbs$timezone_data$TimeZone$asia__damascus),
			_Utils_Tuple2('Asia/Dhaka', $justinmimbs$timezone_data$TimeZone$asia__dhaka),
			_Utils_Tuple2('Asia/Dili', $justinmimbs$timezone_data$TimeZone$asia__dili),
			_Utils_Tuple2('Asia/Dubai', $justinmimbs$timezone_data$TimeZone$asia__dubai),
			_Utils_Tuple2('Asia/Dushanbe', $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
			_Utils_Tuple2('Asia/Famagusta', $justinmimbs$timezone_data$TimeZone$asia__famagusta),
			_Utils_Tuple2('Asia/Gaza', $justinmimbs$timezone_data$TimeZone$asia__gaza),
			_Utils_Tuple2('Asia/Hebron', $justinmimbs$timezone_data$TimeZone$asia__hebron),
			_Utils_Tuple2('Asia/Ho_Chi_Minh', $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
			_Utils_Tuple2('Asia/Hong_Kong', $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
			_Utils_Tuple2('Asia/Hovd', $justinmimbs$timezone_data$TimeZone$asia__hovd),
			_Utils_Tuple2('Asia/Irkutsk', $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
			_Utils_Tuple2('Asia/Istanbul', $justinmimbs$timezone_data$TimeZone$asia__istanbul),
			_Utils_Tuple2('Asia/Jakarta', $justinmimbs$timezone_data$TimeZone$asia__jakarta),
			_Utils_Tuple2('Asia/Jayapura', $justinmimbs$timezone_data$TimeZone$asia__jayapura),
			_Utils_Tuple2('Asia/Jerusalem', $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
			_Utils_Tuple2('Asia/Kabul', $justinmimbs$timezone_data$TimeZone$asia__kabul),
			_Utils_Tuple2('Asia/Kamchatka', $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
			_Utils_Tuple2('Asia/Karachi', $justinmimbs$timezone_data$TimeZone$asia__karachi),
			_Utils_Tuple2('Asia/Kathmandu', $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
			_Utils_Tuple2('Asia/Khandyga', $justinmimbs$timezone_data$TimeZone$asia__khandyga),
			_Utils_Tuple2('Asia/Kolkata', $justinmimbs$timezone_data$TimeZone$asia__kolkata),
			_Utils_Tuple2('Asia/Krasnoyarsk', $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
			_Utils_Tuple2('Asia/Kuala_Lumpur', $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur),
			_Utils_Tuple2('Asia/Kuching', $justinmimbs$timezone_data$TimeZone$asia__kuching),
			_Utils_Tuple2('Asia/Kuwait', $justinmimbs$timezone_data$TimeZone$asia__kuwait),
			_Utils_Tuple2('Asia/Macau', $justinmimbs$timezone_data$TimeZone$asia__macau),
			_Utils_Tuple2('Asia/Magadan', $justinmimbs$timezone_data$TimeZone$asia__magadan),
			_Utils_Tuple2('Asia/Makassar', $justinmimbs$timezone_data$TimeZone$asia__makassar),
			_Utils_Tuple2('Asia/Manila', $justinmimbs$timezone_data$TimeZone$asia__manila),
			_Utils_Tuple2('Asia/Muscat', $justinmimbs$timezone_data$TimeZone$asia__muscat),
			_Utils_Tuple2('Asia/Nicosia', $justinmimbs$timezone_data$TimeZone$asia__nicosia),
			_Utils_Tuple2('Asia/Novokuznetsk', $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
			_Utils_Tuple2('Asia/Novosibirsk', $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
			_Utils_Tuple2('Asia/Omsk', $justinmimbs$timezone_data$TimeZone$asia__omsk),
			_Utils_Tuple2('Asia/Oral', $justinmimbs$timezone_data$TimeZone$asia__oral),
			_Utils_Tuple2('Asia/Phnom_Penh', $justinmimbs$timezone_data$TimeZone$asia__phnom_penh),
			_Utils_Tuple2('Asia/Pontianak', $justinmimbs$timezone_data$TimeZone$asia__pontianak),
			_Utils_Tuple2('Asia/Pyongyang', $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
			_Utils_Tuple2('Asia/Qatar', $justinmimbs$timezone_data$TimeZone$asia__qatar),
			_Utils_Tuple2('Asia/Qostanay', $justinmimbs$timezone_data$TimeZone$asia__qostanay),
			_Utils_Tuple2('Asia/Qyzylorda', $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
			_Utils_Tuple2('Asia/Riyadh', $justinmimbs$timezone_data$TimeZone$asia__riyadh),
			_Utils_Tuple2('Asia/Sakhalin', $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
			_Utils_Tuple2('Asia/Samarkand', $justinmimbs$timezone_data$TimeZone$asia__samarkand),
			_Utils_Tuple2('Asia/Seoul', $justinmimbs$timezone_data$TimeZone$asia__seoul),
			_Utils_Tuple2('Asia/Shanghai', $justinmimbs$timezone_data$TimeZone$asia__shanghai),
			_Utils_Tuple2('Asia/Singapore', $justinmimbs$timezone_data$TimeZone$asia__singapore),
			_Utils_Tuple2('Asia/Srednekolymsk', $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
			_Utils_Tuple2('Asia/Taipei', $justinmimbs$timezone_data$TimeZone$asia__taipei),
			_Utils_Tuple2('Asia/Tashkent', $justinmimbs$timezone_data$TimeZone$asia__tashkent),
			_Utils_Tuple2('Asia/Tbilisi', $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
			_Utils_Tuple2('Asia/Tehran', $justinmimbs$timezone_data$TimeZone$asia__tehran),
			_Utils_Tuple2('Asia/Thimphu', $justinmimbs$timezone_data$TimeZone$asia__thimphu),
			_Utils_Tuple2('Asia/Tokyo', $justinmimbs$timezone_data$TimeZone$asia__tokyo),
			_Utils_Tuple2('Asia/Tomsk', $justinmimbs$timezone_data$TimeZone$asia__tomsk),
			_Utils_Tuple2('Asia/Ulaanbaatar', $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
			_Utils_Tuple2('Asia/Urumqi', $justinmimbs$timezone_data$TimeZone$asia__urumqi),
			_Utils_Tuple2('Asia/Ust-Nera', $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
			_Utils_Tuple2('Asia/Vientiane', $justinmimbs$timezone_data$TimeZone$asia__vientiane),
			_Utils_Tuple2('Asia/Vladivostok', $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
			_Utils_Tuple2('Asia/Yakutsk', $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
			_Utils_Tuple2('Asia/Yangon', $justinmimbs$timezone_data$TimeZone$asia__yangon),
			_Utils_Tuple2('Asia/Yekaterinburg', $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
			_Utils_Tuple2('Asia/Yerevan', $justinmimbs$timezone_data$TimeZone$asia__yerevan),
			_Utils_Tuple2('Atlantic/Azores', $justinmimbs$timezone_data$TimeZone$atlantic__azores),
			_Utils_Tuple2('Atlantic/Bermuda', $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
			_Utils_Tuple2('Atlantic/Canary', $justinmimbs$timezone_data$TimeZone$atlantic__canary),
			_Utils_Tuple2('Atlantic/Cape_Verde', $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
			_Utils_Tuple2('Atlantic/Faroe', $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
			_Utils_Tuple2('Atlantic/Madeira', $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
			_Utils_Tuple2('Atlantic/Reykjavik', $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik),
			_Utils_Tuple2('Atlantic/South_Georgia', $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
			_Utils_Tuple2('Atlantic/St_Helena', $justinmimbs$timezone_data$TimeZone$atlantic__st_helena),
			_Utils_Tuple2('Atlantic/Stanley', $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
			_Utils_Tuple2('Australia/Adelaide', $justinmimbs$timezone_data$TimeZone$australia__adelaide),
			_Utils_Tuple2('Australia/Brisbane', $justinmimbs$timezone_data$TimeZone$australia__brisbane),
			_Utils_Tuple2('Australia/Broken_Hill', $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
			_Utils_Tuple2('Australia/Darwin', $justinmimbs$timezone_data$TimeZone$australia__darwin),
			_Utils_Tuple2('Australia/Eucla', $justinmimbs$timezone_data$TimeZone$australia__eucla),
			_Utils_Tuple2('Australia/Hobart', $justinmimbs$timezone_data$TimeZone$australia__hobart),
			_Utils_Tuple2('Australia/Lindeman', $justinmimbs$timezone_data$TimeZone$australia__lindeman),
			_Utils_Tuple2('Australia/Lord_Howe', $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
			_Utils_Tuple2('Australia/Melbourne', $justinmimbs$timezone_data$TimeZone$australia__melbourne),
			_Utils_Tuple2('Australia/Perth', $justinmimbs$timezone_data$TimeZone$australia__perth),
			_Utils_Tuple2('Australia/Sydney', $justinmimbs$timezone_data$TimeZone$australia__sydney),
			_Utils_Tuple2('Europe/Amsterdam', $justinmimbs$timezone_data$TimeZone$europe__amsterdam),
			_Utils_Tuple2('Europe/Andorra', $justinmimbs$timezone_data$TimeZone$europe__andorra),
			_Utils_Tuple2('Europe/Astrakhan', $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
			_Utils_Tuple2('Europe/Athens', $justinmimbs$timezone_data$TimeZone$europe__athens),
			_Utils_Tuple2('Europe/Belgrade', $justinmimbs$timezone_data$TimeZone$europe__belgrade),
			_Utils_Tuple2('Europe/Berlin', $justinmimbs$timezone_data$TimeZone$europe__berlin),
			_Utils_Tuple2('Europe/Bratislava', $justinmimbs$timezone_data$TimeZone$europe__bratislava),
			_Utils_Tuple2('Europe/Brussels', $justinmimbs$timezone_data$TimeZone$europe__brussels),
			_Utils_Tuple2('Europe/Bucharest', $justinmimbs$timezone_data$TimeZone$europe__bucharest),
			_Utils_Tuple2('Europe/Budapest', $justinmimbs$timezone_data$TimeZone$europe__budapest),
			_Utils_Tuple2('Europe/Busingen', $justinmimbs$timezone_data$TimeZone$europe__busingen),
			_Utils_Tuple2('Europe/Chisinau', $justinmimbs$timezone_data$TimeZone$europe__chisinau),
			_Utils_Tuple2('Europe/Copenhagen', $justinmimbs$timezone_data$TimeZone$europe__copenhagen),
			_Utils_Tuple2('Europe/Dublin', $justinmimbs$timezone_data$TimeZone$europe__dublin),
			_Utils_Tuple2('Europe/Gibraltar', $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
			_Utils_Tuple2('Europe/Guernsey', $justinmimbs$timezone_data$TimeZone$europe__guernsey),
			_Utils_Tuple2('Europe/Helsinki', $justinmimbs$timezone_data$TimeZone$europe__helsinki),
			_Utils_Tuple2('Europe/Isle_of_Man', $justinmimbs$timezone_data$TimeZone$europe__isle_of_man),
			_Utils_Tuple2('Europe/Istanbul', $justinmimbs$timezone_data$TimeZone$europe__istanbul),
			_Utils_Tuple2('Europe/Jersey', $justinmimbs$timezone_data$TimeZone$europe__jersey),
			_Utils_Tuple2('Europe/Kaliningrad', $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
			_Utils_Tuple2('Europe/Kiev', $justinmimbs$timezone_data$TimeZone$europe__kiev),
			_Utils_Tuple2('Europe/Kirov', $justinmimbs$timezone_data$TimeZone$europe__kirov),
			_Utils_Tuple2('Europe/Lisbon', $justinmimbs$timezone_data$TimeZone$europe__lisbon),
			_Utils_Tuple2('Europe/Ljubljana', $justinmimbs$timezone_data$TimeZone$europe__ljubljana),
			_Utils_Tuple2('Europe/London', $justinmimbs$timezone_data$TimeZone$europe__london),
			_Utils_Tuple2('Europe/Luxembourg', $justinmimbs$timezone_data$TimeZone$europe__luxembourg),
			_Utils_Tuple2('Europe/Madrid', $justinmimbs$timezone_data$TimeZone$europe__madrid),
			_Utils_Tuple2('Europe/Malta', $justinmimbs$timezone_data$TimeZone$europe__malta),
			_Utils_Tuple2('Europe/Mariehamn', $justinmimbs$timezone_data$TimeZone$europe__mariehamn),
			_Utils_Tuple2('Europe/Minsk', $justinmimbs$timezone_data$TimeZone$europe__minsk),
			_Utils_Tuple2('Europe/Monaco', $justinmimbs$timezone_data$TimeZone$europe__monaco),
			_Utils_Tuple2('Europe/Moscow', $justinmimbs$timezone_data$TimeZone$europe__moscow),
			_Utils_Tuple2('Europe/Nicosia', $justinmimbs$timezone_data$TimeZone$europe__nicosia),
			_Utils_Tuple2('Europe/Oslo', $justinmimbs$timezone_data$TimeZone$europe__oslo),
			_Utils_Tuple2('Europe/Paris', $justinmimbs$timezone_data$TimeZone$europe__paris),
			_Utils_Tuple2('Europe/Podgorica', $justinmimbs$timezone_data$TimeZone$europe__podgorica),
			_Utils_Tuple2('Europe/Prague', $justinmimbs$timezone_data$TimeZone$europe__prague),
			_Utils_Tuple2('Europe/Riga', $justinmimbs$timezone_data$TimeZone$europe__riga),
			_Utils_Tuple2('Europe/Rome', $justinmimbs$timezone_data$TimeZone$europe__rome),
			_Utils_Tuple2('Europe/Samara', $justinmimbs$timezone_data$TimeZone$europe__samara),
			_Utils_Tuple2('Europe/San_Marino', $justinmimbs$timezone_data$TimeZone$europe__san_marino),
			_Utils_Tuple2('Europe/Sarajevo', $justinmimbs$timezone_data$TimeZone$europe__sarajevo),
			_Utils_Tuple2('Europe/Saratov', $justinmimbs$timezone_data$TimeZone$europe__saratov),
			_Utils_Tuple2('Europe/Simferopol', $justinmimbs$timezone_data$TimeZone$europe__simferopol),
			_Utils_Tuple2('Europe/Skopje', $justinmimbs$timezone_data$TimeZone$europe__skopje),
			_Utils_Tuple2('Europe/Sofia', $justinmimbs$timezone_data$TimeZone$europe__sofia),
			_Utils_Tuple2('Europe/Stockholm', $justinmimbs$timezone_data$TimeZone$europe__stockholm),
			_Utils_Tuple2('Europe/Tallinn', $justinmimbs$timezone_data$TimeZone$europe__tallinn),
			_Utils_Tuple2('Europe/Tirane', $justinmimbs$timezone_data$TimeZone$europe__tirane),
			_Utils_Tuple2('Europe/Ulyanovsk', $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
			_Utils_Tuple2('Europe/Uzhgorod', $justinmimbs$timezone_data$TimeZone$europe__uzhgorod),
			_Utils_Tuple2('Europe/Vaduz', $justinmimbs$timezone_data$TimeZone$europe__vaduz),
			_Utils_Tuple2('Europe/Vatican', $justinmimbs$timezone_data$TimeZone$europe__vatican),
			_Utils_Tuple2('Europe/Vienna', $justinmimbs$timezone_data$TimeZone$europe__vienna),
			_Utils_Tuple2('Europe/Vilnius', $justinmimbs$timezone_data$TimeZone$europe__vilnius),
			_Utils_Tuple2('Europe/Volgograd', $justinmimbs$timezone_data$TimeZone$europe__volgograd),
			_Utils_Tuple2('Europe/Warsaw', $justinmimbs$timezone_data$TimeZone$europe__warsaw),
			_Utils_Tuple2('Europe/Zagreb', $justinmimbs$timezone_data$TimeZone$europe__zagreb),
			_Utils_Tuple2('Europe/Zaporozhye', $justinmimbs$timezone_data$TimeZone$europe__zaporozhye),
			_Utils_Tuple2('Europe/Zurich', $justinmimbs$timezone_data$TimeZone$europe__zurich),
			_Utils_Tuple2('Indian/Antananarivo', $justinmimbs$timezone_data$TimeZone$indian__antananarivo),
			_Utils_Tuple2('Indian/Chagos', $justinmimbs$timezone_data$TimeZone$indian__chagos),
			_Utils_Tuple2('Indian/Christmas', $justinmimbs$timezone_data$TimeZone$indian__christmas),
			_Utils_Tuple2('Indian/Cocos', $justinmimbs$timezone_data$TimeZone$indian__cocos),
			_Utils_Tuple2('Indian/Comoro', $justinmimbs$timezone_data$TimeZone$indian__comoro),
			_Utils_Tuple2('Indian/Kerguelen', $justinmimbs$timezone_data$TimeZone$indian__kerguelen),
			_Utils_Tuple2('Indian/Mahe', $justinmimbs$timezone_data$TimeZone$indian__mahe),
			_Utils_Tuple2('Indian/Maldives', $justinmimbs$timezone_data$TimeZone$indian__maldives),
			_Utils_Tuple2('Indian/Mauritius', $justinmimbs$timezone_data$TimeZone$indian__mauritius),
			_Utils_Tuple2('Indian/Mayotte', $justinmimbs$timezone_data$TimeZone$indian__mayotte),
			_Utils_Tuple2('Indian/Reunion', $justinmimbs$timezone_data$TimeZone$indian__reunion),
			_Utils_Tuple2('Pacific/Apia', $justinmimbs$timezone_data$TimeZone$pacific__apia),
			_Utils_Tuple2('Pacific/Auckland', $justinmimbs$timezone_data$TimeZone$pacific__auckland),
			_Utils_Tuple2('Pacific/Bougainville', $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
			_Utils_Tuple2('Pacific/Chatham', $justinmimbs$timezone_data$TimeZone$pacific__chatham),
			_Utils_Tuple2('Pacific/Chuuk', $justinmimbs$timezone_data$TimeZone$pacific__chuuk),
			_Utils_Tuple2('Pacific/Easter', $justinmimbs$timezone_data$TimeZone$pacific__easter),
			_Utils_Tuple2('Pacific/Efate', $justinmimbs$timezone_data$TimeZone$pacific__efate),
			_Utils_Tuple2('Pacific/Enderbury', $justinmimbs$timezone_data$TimeZone$pacific__enderbury),
			_Utils_Tuple2('Pacific/Fakaofo', $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
			_Utils_Tuple2('Pacific/Fiji', $justinmimbs$timezone_data$TimeZone$pacific__fiji),
			_Utils_Tuple2('Pacific/Funafuti', $justinmimbs$timezone_data$TimeZone$pacific__funafuti),
			_Utils_Tuple2('Pacific/Galapagos', $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
			_Utils_Tuple2('Pacific/Gambier', $justinmimbs$timezone_data$TimeZone$pacific__gambier),
			_Utils_Tuple2('Pacific/Guadalcanal', $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
			_Utils_Tuple2('Pacific/Guam', $justinmimbs$timezone_data$TimeZone$pacific__guam),
			_Utils_Tuple2('Pacific/Honolulu', $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
			_Utils_Tuple2('Pacific/Kiritimati', $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
			_Utils_Tuple2('Pacific/Kosrae', $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
			_Utils_Tuple2('Pacific/Kwajalein', $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
			_Utils_Tuple2('Pacific/Majuro', $justinmimbs$timezone_data$TimeZone$pacific__majuro),
			_Utils_Tuple2('Pacific/Marquesas', $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
			_Utils_Tuple2('Pacific/Midway', $justinmimbs$timezone_data$TimeZone$pacific__midway),
			_Utils_Tuple2('Pacific/Nauru', $justinmimbs$timezone_data$TimeZone$pacific__nauru),
			_Utils_Tuple2('Pacific/Niue', $justinmimbs$timezone_data$TimeZone$pacific__niue),
			_Utils_Tuple2('Pacific/Norfolk', $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
			_Utils_Tuple2('Pacific/Noumea', $justinmimbs$timezone_data$TimeZone$pacific__noumea),
			_Utils_Tuple2('Pacific/Pago_Pago', $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
			_Utils_Tuple2('Pacific/Palau', $justinmimbs$timezone_data$TimeZone$pacific__palau),
			_Utils_Tuple2('Pacific/Pitcairn', $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
			_Utils_Tuple2('Pacific/Pohnpei', $justinmimbs$timezone_data$TimeZone$pacific__pohnpei),
			_Utils_Tuple2('Pacific/Port_Moresby', $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
			_Utils_Tuple2('Pacific/Rarotonga', $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
			_Utils_Tuple2('Pacific/Saipan', $justinmimbs$timezone_data$TimeZone$pacific__saipan),
			_Utils_Tuple2('Pacific/Tahiti', $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
			_Utils_Tuple2('Pacific/Tarawa', $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
			_Utils_Tuple2('Pacific/Tongatapu', $justinmimbs$timezone_data$TimeZone$pacific__tongatapu),
			_Utils_Tuple2('Pacific/Wake', $justinmimbs$timezone_data$TimeZone$pacific__wake),
			_Utils_Tuple2('Pacific/Wallis', $justinmimbs$timezone_data$TimeZone$pacific__wallis)
		]));
var $justinmimbs$timezone_data$TimeZone$getZone = A2(
	$elm$core$Task$andThen,
	function (nameOrOffset) {
		if (!nameOrOffset.$) {
			var zoneName = nameOrOffset.a;
			var _v1 = A2($elm$core$Dict$get, zoneName, $justinmimbs$timezone_data$TimeZone$zones);
			if (!_v1.$) {
				var zone = _v1.a;
				return $elm$core$Task$succeed(
					_Utils_Tuple2(
						zoneName,
						zone(0)));
			} else {
				return $elm$core$Task$fail(
					$justinmimbs$timezone_data$TimeZone$NoDataForZoneName(zoneName));
			}
		} else {
			return $elm$core$Task$fail($justinmimbs$timezone_data$TimeZone$NoZoneName);
		}
	},
	$elm$time$Time$getZoneName);
var $author$project$Components$GlobalSearch$Closed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$GlobalSearch$GotSearchPermissions = function (a) {
	return {$: 13, a: a};
};
var $author$project$Utils$Maybe$toBool = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Data$clientHasAuthToken = function (_v0) {
	var client = _v0;
	return $author$project$Utils$Maybe$toBool(client.e2);
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Api$Provider$SearchPermissions$All$SearchPermissions = $elm$core$Basics$identity;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$Api$Provider$SearchPermissions$Shared$SearchPermissions = $elm$core$Basics$identity;
var $author$project$Api$Provider$SearchPermissions$Shared$Record = F4(
	function (id, attributes, searchable, name) {
		return {vw: attributes, adR: id, zh: name, Zc: searchable};
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Api$Provider$SearchPermissions$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'searchable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'attributes',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$SearchPermissions$Shared$Record)))));
var $author$project$Api$Provider$SearchPermissions$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SearchPermissions$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SearchPermissions$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SearchPermissions$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Api$Data$Failure = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Data$Success = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Data$fromResult = function (result) {
	if (!result.$) {
		var _v1 = result.a;
		var value = _v1.a;
		var headers = _v1.b;
		return A2($author$project$Api$Data$Success, value, headers);
	} else {
		var reasons = result.a;
		return $author$project$Api$Data$Failure(reasons);
	}
};
var $author$project$Api$Data$BadStatus = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Data$BadUrl = {$: 1};
var $author$project$Api$Data$Conflict = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Data$Decoder = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Data$Forbidden = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Data$GatewayError = {$: 4};
var $author$project$Api$Data$Network = {$: 3};
var $author$project$Api$Data$NotFound = {$: 5};
var $author$project$Api$Data$Timeout = {$: 2};
var $author$project$Api$Data$Unauthorized = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Api$Data$decodeErrorToString = function (decodeError) {
	switch (decodeError.$) {
		case 0:
			return $elm$json$Json$Decode$errorToString(decodeError);
		case 1:
			var index = decodeError.a;
			var error = decodeError.b;
			return $elm$core$String$fromInt(index) + (' -> ' + $author$project$Api$Data$decodeErrorToString(error));
		case 2:
			var errors = decodeError.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $author$project$Api$Data$decodeErrorToString, errors));
		default:
			var message = decodeError.a;
			return message + ('\n' + A3(
				$elm$core$String$replace,
				message,
				'',
				A3(
					$elm$core$String$replace,
					'  ',
					'',
					A3(
						$elm$core$String$replace,
						'\n',
						'',
						A3(
							$elm$core$String$replace,
							'Problem with the given value:',
							'',
							$elm$json$Json$Decode$errorToString(decodeError))))));
	}
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Api$Data$InternalServerError = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Data$handleServerError = function (body) {
	var decodedMessage = A2(
		$elm$json$Json$Decode$decodeString,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['message']),
			$elm$json$Json$Decode$string),
		body);
	return $elm$core$Result$Err(
		$author$project$Api$Data$InternalServerError(
			$elm$core$Result$toMaybe(decodedMessage)));
};
var $author$project$Api$Data$handleJsonResponse = F2(
	function (decoder, response) {
		switch (response.$) {
			case 0:
				return $elm$core$Result$Err($author$project$Api$Data$BadUrl);
			case 1:
				return $elm$core$Result$Err($author$project$Api$Data$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Api$Data$Network);
			case 3:
				var metadata = response.a;
				var body = response.b;
				var _v1 = metadata._L;
				switch (_v1) {
					case 404:
						return $elm$core$Result$Err($author$project$Api$Data$NotFound);
					case 401:
						var decodedMessage = A2(
							$elm$json$Json$Decode$decodeString,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['message']),
								$elm$json$Json$Decode$string),
							body);
						return $elm$core$Result$Err(
							$author$project$Api$Data$Unauthorized(
								$elm$core$Result$toMaybe(decodedMessage)));
					case 403:
						var decodedMessage = A2(
							$elm$json$Json$Decode$decodeString,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['message']),
								$elm$json$Json$Decode$string),
							body);
						return $elm$core$Result$Err(
							$author$project$Api$Data$Forbidden(
								$elm$core$Result$toMaybe(decodedMessage)));
					case 409:
						var decodedMessage = A2(
							$elm$json$Json$Decode$decodeString,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['message']),
								$elm$json$Json$Decode$string),
							body);
						return $elm$core$Result$Err(
							$author$project$Api$Data$Conflict(
								$elm$core$Result$toMaybe(decodedMessage)));
					case 500:
						return $author$project$Api$Data$handleServerError(body);
					case 504:
						return $author$project$Api$Data$handleServerError(body);
					case 502:
						return $elm$core$Result$Err($author$project$Api$Data$GatewayError);
					default:
						var decodedError = A2(
							$elm$json$Json$Decode$decodeString,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['message']),
								$elm$json$Json$Decode$string),
							body);
						if (!decodedError.$) {
							var error = decodedError.a;
							return $elm$core$Result$Err(
								A2($author$project$Api$Data$BadStatus, metadata._L, error));
						} else {
							var decoderError = decodedError.a;
							return $elm$core$Result$Err(
								$author$project$Api$Data$Decoder(
									'[' + (metadata.aav + ('] ' + $author$project$Api$Data$decodeErrorToString(decoderError)))));
						}
				}
			default:
				var metadata = response.a;
				var body = response.b;
				var jsonBody = $elm$core$String$isEmpty(body) ? '{}' : body;
				var _v3 = A2($elm$json$Json$Decode$decodeString, decoder, jsonBody);
				if (!_v3.$) {
					var decoded = _v3.a;
					return $elm$core$Result$Ok(
						_Utils_Tuple2(decoded, metadata.iJ));
				} else {
					var error = _v3.a;
					return $elm$core$Result$Err(
						$author$project$Api$Data$Decoder(
							'[' + (metadata.aav + ('] ' + $author$project$Api$Data$decodeErrorToString(error)))));
				}
		}
	});
var $author$project$Api$Data$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			A2($elm$core$Basics$composeR, $author$project$Api$Data$fromResult, toMsg),
			$author$project$Api$Data$handleJsonResponse(decoder));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {Yf: reqs, _2: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.tn;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.Yf));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state._2)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					abf: r.abf,
					e5: r.e5,
					OT: A2(_Http_mapExpect, func, r.OT),
					iJ: r.iJ,
					F6: r.F6,
					HA: r.HA,
					tn: r.tn,
					aav: r.aav
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{abf: false, e5: r.e5, OT: r.OT, iJ: r.iJ, F6: r.F6, HA: r.HA, tn: r.tn, aav: r.aav}));
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Api$Data$requestBody = function (_v0) {
	var request = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$http$Http$emptyBody,
		A2(
			$elm$core$Maybe$map,
			function (body) {
				switch (body.$) {
					case 0:
						var value = body.a;
						return $elm$http$Http$jsonBody(value);
					case 1:
						var name = body.a;
						var files = body.b;
						return $elm$http$Http$multipartBody(
							A2(
								$elm$core$List$map,
								$elm$http$Http$filePart(name),
								files));
					default:
						var parts = body.a;
						return $elm$http$Http$multipartBody(parts);
				}
			},
			request.e5));
};
var $author$project$Api$AuthToken$toString = function (authToken) {
	var token = authToken;
	return $elm$core$Maybe$Just(token);
};
var $author$project$Api$AuthToken$asHeader = function (authToken) {
	return A2(
		$elm$core$Maybe$map,
		function (token) {
			return 'Bearer ' + token;
		},
		$author$project$Api$AuthToken$toString(authToken));
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Api$Data$authHeader = function (authToken) {
	return A2(
		$elm$core$Maybe$map,
		function (tokenHeader) {
			return A2($elm$http$Http$header, 'Authorization', tokenHeader);
		},
		$author$project$Api$AuthToken$asHeader(authToken));
};
var $author$project$Api$Data$clientApiVersionHeader = $elm$core$Maybe$map(
	$elm$http$Http$header('Hint-Version'));
var $author$project$Api$Data$clientHeaders = function (_v0) {
	var sendAuth = _v0.B9;
	var authToken = _v0.e2;
	var apiVersion = _v0.D6;
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				sendAuth ? A2($elm$core$Maybe$andThen, $author$project$Api$Data$authHeader, authToken) : $elm$core$Maybe$Nothing,
				$author$project$Api$Data$clientApiVersionHeader(apiVersion)
			]));
};
var $author$project$Api$Data$requestHeaders = F2(
	function (client, _v0) {
		var request = _v0;
		return _Utils_ap(
			request.iJ,
			$author$project$Api$Data$clientHeaders(client));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Api$Data$formatToString = function (format) {
	return '.csv';
};
var $author$project$Api$Data$pathToPieces = F2(
	function (maybeFormat, _v0) {
		var pieces = _v0;
		if (!maybeFormat.$) {
			var format = maybeFormat.a;
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, piece) {
						return _Utils_eq(
							index,
							$elm$core$List$length(pieces) - 1) ? _Utils_ap(
							piece,
							$author$project$Api$Data$formatToString(format)) : piece;
					}),
				pieces);
		} else {
			return pieces;
		}
	});
var $author$project$Api$Data$requestToUrl = F2(
	function (_v0, _v1) {
		var client = _v0;
		var request = _v1;
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			client.A6,
			A2(
				$elm$core$List$cons,
				'api',
				A2($author$project$Api$Data$pathToPieces, $elm$core$Maybe$Nothing, request.$H)),
			request.Bi);
	});
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Api$Data$makeRequest = F5(
	function (method, client, decoder, toMsg, request) {
		var tracker = request.tn;
		return $elm$http$Http$request(
			{
				e5: $author$project$Api$Data$requestBody(request),
				OT: A2($author$project$Api$Data$expectJson, toMsg, decoder),
				iJ: A2($author$project$Api$Data$requestHeaders, client, request),
				F6: $elm$core$String$toUpper(method),
				HA: $elm$core$Maybe$Just(61 * 1000),
				tn: tracker,
				aav: A2($author$project$Api$Data$requestToUrl, client, request)
			});
	});
var $author$project$Api$Data$get = $author$project$Api$Data$makeRequest('get');
var $author$project$Api$Data$Path = $elm$core$Basics$identity;
var $author$project$Api$Data$pathAppend = F2(
	function (pieces, _v0) {
		var path = _v0;
		return _Utils_ap(path, pieces);
	});
var $author$project$Api$Data$newPath = $elm$core$Basics$identity;
var $author$project$Api$Data$providerPath = $author$project$Api$Data$newPath(
	_List_fromArray(
		['provider']));
var $author$project$Api$Provider$Search$path = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['search']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Data$Request = $elm$core$Basics$identity;
var $author$project$Api$Data$requestTo = function (path) {
	return {
		e5: $elm$core$Maybe$Nothing,
		iJ: _List_fromArray(
			[
				A2($elm$http$Http$header, 'Accept', 'application/json, text/plain, */*')
			]),
		Bi: _List_Nil,
		$H: path,
		tn: $elm$core$Maybe$Nothing
	};
};
var $author$project$Api$Provider$Search$permissions = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$SearchPermissions$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['permissions']),
					$author$project$Api$Provider$Search$path)));
	});
var $author$project$Components$GlobalSearch$init = F2(
	function (apiClient, url) {
		var searchPermissionsCmd = $author$project$Api$Data$clientHasAuthToken(apiClient) ? A2($author$project$Api$Provider$Search$permissions, apiClient, $author$project$Components$GlobalSearch$GotSearchPermissions) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			$author$project$Components$GlobalSearch$Closed(
				{aav: url}),
			searchPermissionsCmd);
	});
var $gingko$time_distance$Time$Distance$I18n$en = F3(
	function (_v0, tense, distanceId) {
		var withAffix = _v0.ahV;
		var toStr = $elm$core$String$fromInt;
		var maybeAffix = function (str) {
			var _v2 = _Utils_Tuple2(withAffix, tense);
			if (_v2.a) {
				if (!_v2.b) {
					var _v3 = _v2.b;
					return str + ' ago';
				} else {
					var _v4 = _v2.b;
					return 'in ' + str;
				}
			} else {
				return str;
			}
		};
		return maybeAffix(
			function () {
				switch (distanceId.$) {
					case 0:
						var i = distanceId.a;
						return (i === 1) ? 'less than 1 second' : ('less than ' + (toStr(i) + ' seconds'));
					case 1:
						return 'half a minute';
					case 2:
						var i = distanceId.a;
						return (i === 1) ? 'less than a minute' : ('less than ' + (toStr(i) + ' minutes'));
					case 3:
						var i = distanceId.a;
						return (i === 1) ? '1 minute' : (toStr(i) + ' minutes');
					case 4:
						var i = distanceId.a;
						return (i === 1) ? 'about 1 hour' : ('about ' + (toStr(i) + ' hours'));
					case 5:
						var i = distanceId.a;
						return (i === 1) ? '1 day' : (toStr(i) + ' days');
					case 6:
						var i = distanceId.a;
						return (i === 1) ? 'about 1 month' : ('about ' + (toStr(i) + ' months'));
					case 7:
						var i = distanceId.a;
						return (i === 1) ? '1 month' : (toStr(i) + ' months');
					case 8:
						var i = distanceId.a;
						return (i === 1) ? 'about 1 year' : ('about ' + (toStr(i) + ' years'));
					case 9:
						var i = distanceId.a;
						return (i === 1) ? 'over 1 year' : ('over ' + (toStr(i) + ' years'));
					default:
						var i = distanceId.a;
						return (i === 1) ? 'almost 1 year' : ('almost ' + (toStr(i) + ' years'));
				}
			}());
	});
var $gingko$time_distance$Time$Distance$Types$Future = 1;
var $gingko$time_distance$Time$Distance$Types$Past = 0;
var $gingko$time_distance$Time$Distance$Types$AboutXHours = function (a) {
	return {$: 4, a: a};
};
var $gingko$time_distance$Time$Distance$Types$LessThanXMinutes = function (a) {
	return {$: 2, a: a};
};
var $gingko$time_distance$Time$Distance$Types$XDays = function (a) {
	return {$: 5, a: a};
};
var $gingko$time_distance$Time$Distance$Types$XMinutes = function (a) {
	return {$: 3, a: a};
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $gingko$time_distance$Time$Distance$minutes_in_almost_two_days = 2520;
var $gingko$time_distance$Time$Distance$minutes_in_day = 1440;
var $gingko$time_distance$Time$Distance$minutes_in_month = 43200;
var $gingko$time_distance$Time$Distance$minutes_in_two_months = 86400;
var $gingko$time_distance$Time$Distance$Types$AboutXYears = function (a) {
	return {$: 8, a: a};
};
var $gingko$time_distance$Time$Distance$Types$AlmostXYears = function (a) {
	return {$: 10, a: a};
};
var $gingko$time_distance$Time$Distance$Types$OverXYears = function (a) {
	return {$: 9, a: a};
};
var $gingko$time_distance$Time$Distance$Types$XMonths = function (a) {
	return {$: 7, a: a};
};
var $elm$core$Basics$round = _Basics_round;
var $gingko$time_distance$Time$Distance$upToOneYear = function (minutes) {
	var nearestMonth = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_month);
	return $gingko$time_distance$Time$Distance$Types$XMonths(nearestMonth);
};
var $gingko$time_distance$Time$Distance$moreThanTwoMonths = function (minutes) {
	var months = (minutes / $gingko$time_distance$Time$Distance$minutes_in_month) | 0;
	if (months < 12) {
		return $gingko$time_distance$Time$Distance$upToOneYear(minutes);
	} else {
		var years = $elm$core$Basics$floor(months / 12);
		var monthsSinceStartOfYear = A2($elm$core$Basics$modBy, 12, months);
		return (monthsSinceStartOfYear < 3) ? $gingko$time_distance$Time$Distance$Types$AboutXYears(years) : ((monthsSinceStartOfYear < 9) ? $gingko$time_distance$Time$Distance$Types$OverXYears(years) : $gingko$time_distance$Time$Distance$Types$AlmostXYears(years + 1));
	}
};
var $gingko$time_distance$Time$Distance$upToOneDay = function (minutes) {
	var hours = $elm$core$Basics$round(minutes / 60);
	return $gingko$time_distance$Time$Distance$Types$AboutXHours(hours);
};
var $gingko$time_distance$Time$Distance$Types$HalfAMinute = {$: 1};
var $gingko$time_distance$Time$Distance$Types$LessThanXSeconds = function (a) {
	return {$: 0, a: a};
};
var $gingko$time_distance$Time$Distance$upToOneMinute = function (seconds) {
	return (seconds < 5) ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(5) : ((seconds < 10) ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(10) : ((seconds < 20) ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(20) : ((seconds < 40) ? $gingko$time_distance$Time$Distance$Types$HalfAMinute : ((seconds < 60) ? $gingko$time_distance$Time$Distance$Types$LessThanXMinutes(1) : $gingko$time_distance$Time$Distance$Types$XMinutes(1)))));
};
var $gingko$time_distance$Time$Distance$upToOneMonth = function (minutes) {
	var days = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_day);
	return $gingko$time_distance$Time$Distance$Types$XDays(days);
};
var $gingko$time_distance$Time$Distance$Types$AboutXMonths = function (a) {
	return {$: 6, a: a};
};
var $gingko$time_distance$Time$Distance$upToTwoMonths = function (minutes) {
	var months = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_month);
	return $gingko$time_distance$Time$Distance$Types$AboutXMonths(months);
};
var $gingko$time_distance$Time$Distance$calculateDistance = F3(
	function (includeSeconds, s1, s2) {
		var seconds = ($elm$core$Basics$abs(s2 - s1) / 1000) | 0;
		var minutes = $elm$core$Basics$round(seconds / 60);
		return (includeSeconds && (minutes < 2)) ? $gingko$time_distance$Time$Distance$upToOneMinute(seconds) : ((!minutes) ? $gingko$time_distance$Time$Distance$Types$LessThanXMinutes(1) : ((minutes < 2) ? $gingko$time_distance$Time$Distance$Types$XMinutes(minutes) : ((minutes < 45) ? $gingko$time_distance$Time$Distance$Types$XMinutes(minutes) : ((minutes < 90) ? $gingko$time_distance$Time$Distance$Types$AboutXHours(1) : ((_Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_day) < 0) ? $gingko$time_distance$Time$Distance$upToOneDay(minutes) : ((_Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_almost_two_days) < 0) ? $gingko$time_distance$Time$Distance$Types$XDays(1) : ((_Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_month) < 0) ? $gingko$time_distance$Time$Distance$upToOneMonth(minutes) : ((_Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_two_months) < 0) ? $gingko$time_distance$Time$Distance$upToTwoMonths(minutes) : $gingko$time_distance$Time$Distance$moreThanTwoMonths(minutes)))))))));
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $gingko$time_distance$Time$Distance$inWordsWithConfig = F4(
	function (config, locale, otherTime, currentTime) {
		var otherSeconds = $elm$time$Time$posixToMillis(otherTime);
		var currentSeconds = $elm$time$Time$posixToMillis(currentTime);
		var distance = A3($gingko$time_distance$Time$Distance$calculateDistance, true, otherSeconds, currentSeconds);
		var tense = function () {
			var _v0 = A2($elm$core$Basics$compare, currentSeconds, otherSeconds);
			if (_v0 === 2) {
				return 0;
			} else {
				return 1;
			}
		}();
		return A3(locale, config, tense, distance);
	});
var $gingko$time_distance$Time$Distance$inWords = F2(
	function (otherTime, currentTime) {
		return A4(
			$gingko$time_distance$Time$Distance$inWordsWithConfig,
			{ahV: true},
			$gingko$time_distance$Time$Distance$I18n$en,
			otherTime,
			currentTime);
	});
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayName = function (day) {
	switch (day) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayOfMonthWithSuffix = F2(
	function (pad, day) {
		var value = function () {
			switch (day) {
				case 1:
					return '1st';
				case 21:
					return '21st';
				case 2:
					return '2nd';
				case 22:
					return '22nd';
				case 3:
					return '3rd';
				case 23:
					return '23rd';
				case 31:
					return '31st';
				default:
					return $elm$core$String$fromInt(day) + 'th';
			}
		}();
		return pad ? A3($elm$core$String$padLeft, 4, ' ', value) : value;
	});
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayShort = function (day) {
	switch (day) {
		case 0:
			return 'Mon';
		case 1:
			return 'Tue';
		case 2:
			return 'Wed';
		case 3:
			return 'Thu';
		case 4:
			return 'Fri';
		case 5:
			return 'Sat';
		default:
			return 'Sun';
	}
};
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthShort = function (month) {
	switch (month) {
		case 0:
			return 'Jan';
		case 1:
			return 'Feb';
		case 2:
			return 'Mar';
		case 3:
			return 'Apr';
		case 4:
			return 'May';
		case 5:
			return 'Jun';
		case 6:
			return 'Jul';
		case 7:
			return 'Aug';
		case 8:
			return 'Sep';
		case 9:
			return 'Oct';
		case 10:
			return 'Nov';
		default:
			return 'Dec';
	}
};
var $CoderDennis$elm_time_format$Time$Format$I18n$I_default$twelveHourPeriod = function (period) {
	if (!period) {
		return 'AM';
	} else {
		return 'PM';
	}
};
var $CoderDennis$elm_time_format$Time$Format$Config$Config_en_us$config = {
	PE: {MO: '%-m/%-d/%Y', acp: '%-m/%-d/%Y %-I:%M %p', adq: 6, aeu: '%A, %B %d, %Y', aev: '%-I:%M:%S %p', ahs: '%-I:%M %p'},
	bt: {MS: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayName, MT: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayOfMonthWithSuffix, MU: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayShort, Ud: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthName, Ui: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthShort, aae: $CoderDennis$elm_time_format$Time$Format$I18n$I_default$twelveHourPeriod}
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {x4: index, aex: match, Gj: number, ahc: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{abS: false, aeK: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $CoderDennis$elm_time_format$Time$Format$formatRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(y|Y|m|_m|-m|B|^B|b|^b|d|-d|-@d|e|@e|A|^A|a|^a|H|-H|k|I|-I|l|p|P|M|S|%|L)'));
var $CoderDennis$elm_time_format$Time$Format$collapse = function (m) {
	return A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, m);
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $CoderDennis$elm_time_format$Time$Format$hourMod12 = function (h) {
	return (!A2($elm$core$Basics$modBy, 12, h)) ? 12 : A2($elm$core$Basics$modBy, 12, h);
};
var $CoderDennis$elm_time_format$Time$Format$Core$monthToInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $CoderDennis$elm_time_format$Time$Format$padWith = function (c) {
	return A2(
		$elm$core$Basics$composeL,
		A2($elm$core$String$padLeft, 2, c),
		$elm$core$String$fromInt);
};
var $CoderDennis$elm_time_format$Time$Format$padWithN = F2(
	function (n, c) {
		return A2(
			$elm$core$Basics$composeL,
			A2($elm$core$String$padLeft, n, c),
			$elm$core$String$fromInt);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.Hl, posixMinutes) < 0) {
					return posixMinutes + era.f;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		acq: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		aeI: month,
		ahX: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).acq;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).aeI;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).ahX;
	});
var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$AM = 0;
var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$PM = 1;
var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod = F2(
	function (z, d) {
		return (A2($elm$time$Time$toHour, z, d) < 12) ? 0 : 1;
	});
var $CoderDennis$elm_time_format$Time$Format$formatToken = F4(
	function (config, zone, d, m) {
		var symbol = A2(
			$elm$core$Maybe$withDefault,
			' ',
			$CoderDennis$elm_time_format$Time$Format$collapse(
				$elm$core$List$head(m.ahc)));
		switch (symbol) {
			case 'Y':
				return A3(
					$CoderDennis$elm_time_format$Time$Format$padWithN,
					4,
					'0',
					A2($elm$time$Time$toYear, zone, d));
			case 'y':
				return A2(
					$elm$core$String$right,
					2,
					A3(
						$CoderDennis$elm_time_format$Time$Format$padWithN,
						2,
						'0',
						A2($elm$time$Time$toYear, zone, d)));
			case 'm':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					$CoderDennis$elm_time_format$Time$Format$Core$monthToInt(
						A2($elm$time$Time$toMonth, zone, d)));
			case '_m':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					' ',
					$CoderDennis$elm_time_format$Time$Format$Core$monthToInt(
						A2($elm$time$Time$toMonth, zone, d)));
			case '-m':
				return $elm$core$String$fromInt(
					$CoderDennis$elm_time_format$Time$Format$Core$monthToInt(
						A2($elm$time$Time$toMonth, zone, d)));
			case 'B':
				return config.bt.Ud(
					A2($elm$time$Time$toMonth, zone, d));
			case '^B':
				return $elm$core$String$toUpper(
					config.bt.Ud(
						A2($elm$time$Time$toMonth, zone, d)));
			case 'b':
				return config.bt.Ui(
					A2($elm$time$Time$toMonth, zone, d));
			case '^b':
				return $elm$core$String$toUpper(
					config.bt.Ui(
						A2($elm$time$Time$toMonth, zone, d)));
			case 'd':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					A2($elm$time$Time$toDay, zone, d));
			case '-d':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toDay, zone, d));
			case '-@d':
				return A2(
					config.bt.MT,
					false,
					A2($elm$time$Time$toDay, zone, d));
			case 'e':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					' ',
					A2($elm$time$Time$toDay, zone, d));
			case '@e':
				return A2(
					config.bt.MT,
					true,
					A2($elm$time$Time$toDay, zone, d));
			case 'A':
				return config.bt.MS(
					A2($elm$time$Time$toWeekday, zone, d));
			case '^A':
				return $elm$core$String$toUpper(
					config.bt.MS(
						A2($elm$time$Time$toWeekday, zone, d)));
			case 'a':
				return config.bt.MU(
					A2($elm$time$Time$toWeekday, zone, d));
			case '^a':
				return $elm$core$String$toUpper(
					config.bt.MU(
						A2($elm$time$Time$toWeekday, zone, d)));
			case 'H':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					A2($elm$time$Time$toHour, zone, d));
			case '-H':
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, d));
			case 'k':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					' ',
					A2($elm$time$Time$toHour, zone, d));
			case 'I':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					$CoderDennis$elm_time_format$Time$Format$hourMod12(
						A2($elm$time$Time$toHour, zone, d)));
			case '-I':
				return $elm$core$String$fromInt(
					$CoderDennis$elm_time_format$Time$Format$hourMod12(
						A2($elm$time$Time$toHour, zone, d)));
			case 'l':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					' ',
					$CoderDennis$elm_time_format$Time$Format$hourMod12(
						A2($elm$time$Time$toHour, zone, d)));
			case 'p':
				return $elm$core$String$toUpper(
					config.bt.aae(
						A2($CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod, zone, d)));
			case 'P':
				return config.bt.aae(
					A2($CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod, zone, d));
			case 'M':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					A2($elm$time$Time$toMinute, zone, d));
			case 'S':
				return A2(
					$CoderDennis$elm_time_format$Time$Format$padWith,
					'0',
					A2($elm$time$Time$toSecond, zone, d));
			case 'L':
				return A3(
					$CoderDennis$elm_time_format$Time$Format$padWithN,
					3,
					'0',
					A2($elm$time$Time$toMillis, zone, d));
			case '%':
				return symbol;
			default:
				return '';
		}
	});
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $CoderDennis$elm_time_format$Time$Format$format = F4(
	function (config, formatStr, zone, time) {
		return A3(
			$elm$regex$Regex$replace,
			$CoderDennis$elm_time_format$Time$Format$formatRegex,
			A3($CoderDennis$elm_time_format$Time$Format$formatToken, config, zone, time),
			formatStr);
	});
var $author$project$Formatters$Time$toTimeStamp = F3(
	function (zone, expression, time) {
		return A4($CoderDennis$elm_time_format$Time$Format$format, $CoderDennis$elm_time_format$Time$Format$Config$Config_en_us$config, expression, zone, time);
	});
var $author$project$Formatters$Time$toString = F4(
	function (zone, now, format, time) {
		switch (format) {
			case 0:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y at %l:%M %p', time);
			case 1:
				return A2($gingko$time_distance$Time$Distance$inWords, time, now);
			case 2:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%B %d, %Y at %l:%M %p', time);
			case 3:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%l:%M %p', time);
			case 4:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y %l:%M %p', time);
			case 5:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y', time);
			default:
				return A3($author$project$Formatters$Time$toTimeStamp, zone, '%B %d, %Y', time);
		}
	});
var $author$project$Formatters$Time$init = F2(
	function (zone, now) {
		return A2($author$project$Formatters$Time$toString, zone, now);
	});
var $author$project$Ui$Toast$Toastr = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Toast$init = A2($author$project$Ui$Toast$Toastr, 1, _List_Nil);
var $author$project$Utils$Release$Model = $elm$core$Basics$identity;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Utils$Release$FetchLiveRelease = {$: 1};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Utils$Release$scheduleNextReleaseCheck = A2(
	$elm$core$Task$attempt,
	function (_v0) {
		return $author$project$Utils$Release$FetchLiveRelease;
	},
	$elm$core$Process$sleep(10 * 1000));
var $author$project$Utils$Release$init = function (release) {
	return _Utils_Tuple2(
		{
			EO: A2($elm$core$Maybe$withDefault, '', release),
			zj: false
		},
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always($author$project$Utils$Release$scheduleNextReleaseCheck),
				release)));
};
var $author$project$Shared$GotSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shared$GotUser = function (a) {
	return {$: 4, a: a};
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Ports$Session$sessionAuthorizePort = _Platform_outgoingPort(
	'sessionAuthorizePort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'redirect',
					$elm$json$Json$Encode$bool($.af6))
				]));
	});
var $author$project$Ports$Session$authorize = function (options) {
	return $author$project$Ports$Session$sessionAuthorizePort(options);
};
var $author$project$Shared$BackupJwtRefreshWindowFinished = {$: 27};
var $author$project$Api$Data$clientAuthToken = function (_v0) {
	var client = _v0;
	return client.e2;
};
var $simonh1000$elm_jwt$Jwt$TokenDecodeError = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $simonh1000$elm_jwt$Jwt$TokenHeaderError = {$: 2};
var $simonh1000$elm_jwt$Jwt$TokenProcessingError = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $simonh1000$elm_jwt$Jwt$fixlength = function (s) {
	var _v0 = A2(
		$elm$core$Basics$modBy,
		4,
		$elm$core$String$length(s));
	switch (_v0) {
		case 0:
			return $elm$core$Result$Ok(s);
		case 2:
			return $elm$core$Result$Ok(
				$elm$core$String$concat(
					_List_fromArray(
						[s, '=='])));
		case 3:
			return $elm$core$Result$Ok(
				$elm$core$String$concat(
					_List_fromArray(
						[s, '='])));
		default:
			return $elm$core$Result$Err(
				$simonh1000$elm_jwt$Jwt$TokenProcessingError('Wrong length'));
	}
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$bytes$Bytes$Encode$getWidth = function (builder) {
	switch (builder.$) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		case 3:
			return 1;
		case 4:
			return 2;
		case 5:
			return 4;
		case 6:
			return 4;
		case 7:
			return 8;
		case 8:
			var w = builder.a;
			return w;
		case 9:
			var w = builder.a;
			return w;
		default:
			var bs = builder.a;
			return _Bytes_width(bs);
	}
};
var $elm$bytes$Bytes$LE = 0;
var $elm$bytes$Bytes$Encode$write = F3(
	function (builder, mb, offset) {
		switch (builder.$) {
			case 0:
				var n = builder.a;
				return A3(_Bytes_write_i8, mb, offset, n);
			case 1:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i16, mb, offset, n, !e);
			case 2:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_i32, mb, offset, n, !e);
			case 3:
				var n = builder.a;
				return A3(_Bytes_write_u8, mb, offset, n);
			case 4:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u16, mb, offset, n, !e);
			case 5:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_u32, mb, offset, n, !e);
			case 6:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f32, mb, offset, n, !e);
			case 7:
				var e = builder.a;
				var n = builder.b;
				return A4(_Bytes_write_f64, mb, offset, n, !e);
			case 8:
				var bs = builder.b;
				return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
			case 9:
				var s = builder.b;
				return A3(_Bytes_write_string, mb, offset, s);
			default:
				var bs = builder.a;
				return A3(_Bytes_write_bytes, mb, offset, bs);
		}
	});
var $elm$bytes$Bytes$Encode$writeSequence = F3(
	function (builders, mb, offset) {
		writeSequence:
		while (true) {
			if (!builders.b) {
				return offset;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$builders = bs,
					$temp$mb = mb,
					$temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
				builders = $temp$builders;
				mb = $temp$mb;
				offset = $temp$offset;
				continue writeSequence;
			}
		}
	});
var $elm$bytes$Bytes$Decode$decode = F2(
	function (_v0, bs) {
		var decoder = _v0;
		return A2(_Bytes_decode, decoder, bs);
	});
var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
var $elm$bytes$Bytes$Decode$string = function (n) {
	return _Bytes_read_string(n);
};
var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
var $elm$bytes$Bytes$BE = 1;
var $danfishgold$base64_bytes$Encode$isValidChar = function (c) {
	if ($elm$core$Char$isAlphaNum(c)) {
		return true;
	} else {
		switch (c) {
			case '+':
				return true;
			case '/':
				return true;
			default:
				return false;
		}
	}
};
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$bytes$Bytes$Encode$Seq = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$getWidths = F2(
	function (width, builders) {
		getWidths:
		while (true) {
			if (!builders.b) {
				return width;
			} else {
				var b = builders.a;
				var bs = builders.b;
				var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b),
					$temp$builders = bs;
				width = $temp$width;
				builders = $temp$builders;
				continue getWidths;
			}
		}
	});
var $elm$bytes$Bytes$Encode$sequence = function (builders) {
	return A2(
		$elm$bytes$Bytes$Encode$Seq,
		A2($elm$bytes$Bytes$Encode$getWidths, 0, builders),
		builders);
};
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $danfishgold$base64_bytes$Encode$unsafeConvertChar = function (_char) {
	var key = $elm$core$Char$toCode(_char);
	if ((key >= 65) && (key <= 90)) {
		return key - 65;
	} else {
		if ((key >= 97) && (key <= 122)) {
			return (key - 97) + 26;
		} else {
			if ((key >= 48) && (key <= 57)) {
				return ((key - 48) + 26) + 26;
			} else {
				switch (_char) {
					case '+':
						return 62;
					case '/':
						return 63;
					default:
						return -1;
				}
			}
		}
	}
};
var $elm$bytes$Bytes$Encode$U16 = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
var $elm$bytes$Bytes$Encode$U8 = function (a) {
	return {$: 3, a: a};
};
var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
var $danfishgold$base64_bytes$Encode$encodeCharacters = F4(
	function (a, b, c, d) {
		if ($danfishgold$base64_bytes$Encode$isValidChar(a) && $danfishgold$base64_bytes$Encode$isValidChar(b)) {
			var n2 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(b);
			var n1 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(a);
			if ('=' === d) {
				if ('=' === c) {
					var n = (n1 << 18) | (n2 << 12);
					var b1 = n >> 16;
					return $elm$core$Maybe$Just(
						$elm$bytes$Bytes$Encode$unsignedInt8(b1));
				} else {
					if ($danfishgold$base64_bytes$Encode$isValidChar(c)) {
						var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
						var n = ((n1 << 18) | (n2 << 12)) | (n3 << 6);
						var combined = n >> 8;
						return $elm$core$Maybe$Just(
							A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}
			} else {
				if ($danfishgold$base64_bytes$Encode$isValidChar(c) && $danfishgold$base64_bytes$Encode$isValidChar(d)) {
					var n4 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(d);
					var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
					var n = ((n1 << 18) | (n2 << 12)) | ((n3 << 6) | n4);
					var combined = n >> 8;
					var b3 = n;
					return $elm$core$Maybe$Just(
						$elm$bytes$Bytes$Encode$sequence(
							_List_fromArray(
								[
									A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined),
									$elm$bytes$Bytes$Encode$unsignedInt8(b3)
								])));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $danfishgold$base64_bytes$Encode$encodeChunks = F2(
	function (input, accum) {
		encodeChunks:
		while (true) {
			var _v0 = $elm$core$String$toList(
				A2($elm$core$String$left, 4, input));
			_v0$4:
			while (true) {
				if (!_v0.b) {
					return $elm$core$Maybe$Just(accum);
				} else {
					if (_v0.b.b) {
						if (_v0.b.b.b) {
							if (_v0.b.b.b.b) {
								if (!_v0.b.b.b.b.b) {
									var a = _v0.a;
									var _v1 = _v0.b;
									var b = _v1.a;
									var _v2 = _v1.b;
									var c = _v2.a;
									var _v3 = _v2.b;
									var d = _v3.a;
									var _v4 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, d);
									if (!_v4.$) {
										var enc = _v4.a;
										var $temp$input = A2($elm$core$String$dropLeft, 4, input),
											$temp$accum = A2($elm$core$List$cons, enc, accum);
										input = $temp$input;
										accum = $temp$accum;
										continue encodeChunks;
									} else {
										return $elm$core$Maybe$Nothing;
									}
								} else {
									break _v0$4;
								}
							} else {
								var a = _v0.a;
								var _v5 = _v0.b;
								var b = _v5.a;
								var _v6 = _v5.b;
								var c = _v6.a;
								var _v7 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, '=');
								if (_v7.$ === 1) {
									return $elm$core$Maybe$Nothing;
								} else {
									var enc = _v7.a;
									return $elm$core$Maybe$Just(
										A2($elm$core$List$cons, enc, accum));
								}
							}
						} else {
							var a = _v0.a;
							var _v8 = _v0.b;
							var b = _v8.a;
							var _v9 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, '=', '=');
							if (_v9.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var enc = _v9.a;
								return $elm$core$Maybe$Just(
									A2($elm$core$List$cons, enc, accum));
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
			return $elm$core$Maybe$Nothing;
		}
	});
var $danfishgold$base64_bytes$Encode$encoder = function (string) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$bytes$Bytes$Encode$sequence),
		A2($danfishgold$base64_bytes$Encode$encodeChunks, string, _List_Nil));
};
var $danfishgold$base64_bytes$Encode$toBytes = function (string) {
	return A2(
		$elm$core$Maybe$map,
		$elm$bytes$Bytes$Encode$encode,
		$danfishgold$base64_bytes$Encode$encoder(string));
};
var $danfishgold$base64_bytes$Base64$toBytes = $danfishgold$base64_bytes$Encode$toBytes;
var $elm$bytes$Bytes$width = _Bytes_width;
var $danfishgold$base64_bytes$Base64$toString = function (b64String) {
	var _v0 = $danfishgold$base64_bytes$Base64$toBytes(b64String);
	if (_v0.$ === 1) {
		return $elm$core$Maybe$Nothing;
	} else {
		var b64Bytes = _v0.a;
		return A2(
			$elm$bytes$Bytes$Decode$decode,
			$elm$bytes$Bytes$Decode$string(
				$elm$bytes$Bytes$width(b64Bytes)),
			b64Bytes);
	}
};
var $elm$core$String$map = _String_map;
var $simonh1000$elm_jwt$Jwt$unurl = function () {
	var fix = function (c) {
		switch (c) {
			case '-':
				return '+';
			case '_':
				return '/';
			default:
				return c;
		}
	};
	return $elm$core$String$map(fix);
}();
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $simonh1000$elm_jwt$Jwt$getTokenParts = function (token) {
	var verifyJson = F2(
		function (errorHandler, str) {
			return A2(
				$elm$core$Result$mapError,
				errorHandler,
				A2(
					$elm$core$Result$map,
					function (_v8) {
						return str;
					},
					A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, str)));
		});
	var processor = A2(
		$elm$core$Basics$composeR,
		$simonh1000$elm_jwt$Jwt$unurl,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$split('.'),
			$elm$core$List$map($simonh1000$elm_jwt$Jwt$fixlength)));
	var _v0 = processor(token);
	_v0$1:
	while (true) {
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			if (!_v0.a.$) {
				if (!_v0.b.a.$) {
					var header = _v0.a.a;
					var _v1 = _v0.b;
					var body = _v1.a.a;
					var _v2 = _v1.b;
					var header_ = A2(
						$elm$core$Result$andThen,
						verifyJson(
							function (_v3) {
								return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
							}),
						A2(
							$elm$core$Result$fromMaybe,
							$simonh1000$elm_jwt$Jwt$TokenHeaderError,
							$danfishgold$base64_bytes$Base64$toString(header)));
					var body_ = A2(
						$elm$core$Result$andThen,
						verifyJson($simonh1000$elm_jwt$Jwt$TokenDecodeError),
						A2(
							$elm$core$Result$fromMaybe,
							$simonh1000$elm_jwt$Jwt$TokenProcessingError('Invalid UTF-16'),
							$danfishgold$base64_bytes$Base64$toString(body)));
					return A3(
						$elm$core$Result$map2,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						header_,
						body_);
				} else {
					break _v0$1;
				}
			} else {
				if (_v0.b.a.$ === 1) {
					break _v0$1;
				} else {
					var err = _v0.a.a;
					var _v6 = _v0.b;
					var _v7 = _v6.b;
					return $elm$core$Result$Err(err);
				}
			}
		} else {
			return $elm$core$Result$Err(
				$simonh1000$elm_jwt$Jwt$TokenProcessingError('Token has invalid shape'));
		}
	}
	var _v4 = _v0.b;
	var err = _v4.a.a;
	var _v5 = _v4.b;
	return $elm$core$Result$Err(err);
};
var $simonh1000$elm_jwt$Jwt$decodeToken = F2(
	function (dec, token) {
		return A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$json$Json$Decode$decodeString(dec),
				$elm$core$Result$mapError($simonh1000$elm_jwt$Jwt$TokenDecodeError)),
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$second,
				$simonh1000$elm_jwt$Jwt$getTokenParts(token)));
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $simonh1000$elm_jwt$Jwt$getTokenExpirationMillis = function (token) {
	var decodeExp = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$int,
				A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)
			]));
	return A2(
		$elm$core$Result$map,
		function (exp) {
			return 1000 * exp;
		},
		A2(
			$simonh1000$elm_jwt$Jwt$decodeToken,
			A2($elm$json$Json$Decode$field, 'exp', decodeExp),
			token));
};
var $author$project$Api$AuthToken$expiresAt = function (authToken) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Result$toMaybe,
		A2(
			$elm$core$Maybe$map,
			$simonh1000$elm_jwt$Jwt$getTokenExpirationMillis,
			A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
};
var $author$project$Api$AuthToken$issuedAt = function (authToken) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Result$toMaybe,
		A2(
			$elm$core$Maybe$map,
			function (token) {
				var decodeExp = $elm$json$Json$Decode$oneOf(
					_List_fromArray(
						[
							$elm$json$Json$Decode$int,
							A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)
						]));
				return A2(
					$elm$core$Result$map,
					function (iat) {
						return 1000 * iat;
					},
					A2(
						$simonh1000$elm_jwt$Jwt$decodeToken,
						A2($elm$json$Json$Decode$field, 'iat', decodeExp),
						token));
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
};
var $author$project$Shared$GotNewBackupJwt = function (a) {
	return {$: 26, a: a};
};
var $author$project$Api$Data$platformPath = $author$project$Api$Data$newPath(_List_Nil);
var $author$project$Api$Auth$authPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['auth']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$AuthToken$decode = function (authToken) {
	return $elm$json$Json$Decode$succeed(authToken);
};
var $author$project$Api$Auth$authTokenDecoder = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Api$AuthToken$decode,
	A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string));
var $author$project$Api$Data$post = $author$project$Api$Data$makeRequest('post');
var $author$project$Api$Auth$refreshToken = F2(
	function (client, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			client,
			$author$project$Api$Auth$authTokenDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['refresh']),
					$author$project$Api$Auth$authPath)));
	});
var $author$project$Shared$refreshToken = function (apiClient) {
	return A2($author$project$Api$Auth$refreshToken, apiClient, $author$project$Shared$GotNewBackupJwt);
};
var $author$project$Shared$backupJwtRefreshTimeout = function (apiClient) {
	var refreshWindowStart = $author$project$Api$AuthToken$issuedAt(
		$author$project$Api$Data$clientAuthToken(apiClient));
	var expiresAt = $author$project$Api$AuthToken$expiresAt(
		$author$project$Api$Data$clientAuthToken(apiClient));
	var _v0 = _Utils_Tuple2(refreshWindowStart, expiresAt);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var refreshStart = _v0.a.a;
		var expiresAt_ = _v0.b.a;
		var fiveMinMs = (5 * 60) * 1000;
		return (_Utils_cmp(expiresAt_ - refreshStart, fiveMinMs) > 0) ? A2(
			$elm$core$Task$perform,
			function (_v1) {
				return $author$project$Shared$BackupJwtRefreshWindowFinished;
			},
			$elm$core$Process$sleep((expiresAt_ - refreshStart) - fiveMinMs)) : $author$project$Shared$refreshToken(apiClient);
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $simonh1000$elm_jwt$Jwt$isExpired = F2(
	function (now, token) {
		return A2(
			$elm$core$Result$map,
			function (millis) {
				return _Utils_cmp(
					$elm$time$Time$posixToMillis(now),
					millis) > 0;
			},
			$simonh1000$elm_jwt$Jwt$getTokenExpirationMillis(token));
	});
var $author$project$Api$AuthToken$isExpired = F2(
	function (authToken, now) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Result$toMaybe,
				A2(
					$elm$core$Maybe$map,
					$simonh1000$elm_jwt$Jwt$isExpired(now),
					A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken))));
	});
var $author$project$Api$Data$clientHasTokenExpired = F2(
	function (_v0, now) {
		var client = _v0;
		return A2($author$project$Api$AuthToken$isExpired, client.e2, now);
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$Navigation$pushUrl = _Platform_outgoingPort('pushUrl', $elm$json$Json$Encode$string);
var $elm$core$String$append = _String_append;
var $author$project$Spa$Generated$Route$toString = function (route) {
	var segments = function () {
		switch (route.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					['accounting']);
			case 2:
				return _List_fromArray(
					['blank']);
			case 3:
				return _List_fromArray(
					['calendar']);
			case 4:
				return _List_fromArray(
					['forms']);
			case 5:
				return _List_fromArray(
					['home']);
			case 6:
				return _List_fromArray(
					['login']);
			case 7:
				return _List_fromArray(
					['logout']);
			case 8:
				return _List_fromArray(
					['not_found']);
			case 9:
				return _List_fromArray(
					['onboarding']);
			case 10:
				return _List_fromArray(
					['affiliate_bills']);
			case 11:
				return _List_fromArray(
					['affiliates']);
			case 12:
				return _List_fromArray(
					['companies']);
			case 13:
				return _List_fromArray(
					['files']);
			case 14:
				return _List_fromArray(
					['marketplace']);
			case 15:
				return _List_fromArray(
					['patients']);
			case 16:
				return _List_fromArray(
					['practice_setup']);
			case 17:
				return _List_fromArray(
					['style_guide']);
			case 18:
				return _List_fromArray(
					['tasks']);
			case 19:
				return _List_fromArray(
					['admin', 'advance_billing']);
			case 20:
				return _List_fromArray(
					['admin', 'billing']);
			case 21:
				return _List_fromArray(
					['admin', 'cancellation_reasons']);
			case 22:
				return _List_fromArray(
					['admin', 'card_readers']);
			case 23:
				return _List_fromArray(
					['admin', 'categories']);
			case 24:
				return _List_fromArray(
					['admin', 'commissions']);
			case 25:
				return _List_fromArray(
					['admin', 'coupons']);
			case 26:
				return _List_fromArray(
					['admin', 'credit_categories']);
			case 27:
				return _List_fromArray(
					['admin', 'elation_legacy']);
			case 28:
				return _List_fromArray(
					['admin', 'features']);
			case 29:
				return _List_fromArray(
					['admin', 'hipaa_authorizations']);
			case 30:
				return _List_fromArray(
					['admin', 'internal_settings']);
			case 31:
				return _List_fromArray(
					['admin', 'invoice_settings']);
			case 32:
				return _List_fromArray(
					['admin', 'lead_sources']);
			case 33:
				return _List_fromArray(
					['admin', 'locations']);
			case 34:
				return _List_fromArray(
					['admin', 'mailgun']);
			case 35:
				return _List_fromArray(
					['admin', 'notes']);
			case 36:
				return _List_fromArray(
					['admin', 'patients']);
			case 37:
				return _List_fromArray(
					['admin', 'payment_method_import']);
			case 38:
				return _List_fromArray(
					['admin', 'payment_processing']);
			case 39:
				return _List_fromArray(
					['admin', 'payment_sources']);
			case 40:
				return _List_fromArray(
					['admin', 'practice']);
			case 41:
				return _List_fromArray(
					['admin', 'provider_groups']);
			case 42:
				return _List_fromArray(
					['admin', 'scheduled_jobs']);
			case 43:
				return _List_fromArray(
					['admin', 'self_service']);
			case 44:
				return _List_fromArray(
					['admin', 'signup']);
			case 45:
				return _List_fromArray(
					['admin', 'stripe']);
			case 46:
				return _List_fromArray(
					['admin', 'taxes']);
			case 47:
				return _List_fromArray(
					['admin', 'team']);
			case 48:
				return _List_fromArray(
					['affiliates', 'create']);
			case 49:
				return _List_fromArray(
					['affiliates', 'new']);
			case 50:
				return _List_fromArray(
					['charges', 'new']);
			case 51:
				return _List_fromArray(
					['commissions', 'statements']);
			case 52:
				return _List_fromArray(
					['companies', 'new']);
			case 53:
				return _List_fromArray(
					['contacts', 'list']);
			case 54:
				return _List_fromArray(
					['contacts', 'new']);
			case 55:
				return _List_fromArray(
					['files', 'public']);
			case 56:
				return _List_fromArray(
					['hinter', 'clone_practice']);
			case 57:
				return _List_fromArray(
					['hinter', 'disputes']);
			case 58:
				return _List_fromArray(
					['hinter', 'feature_flags']);
			case 59:
				return _List_fromArray(
					['hinter', 'new_group']);
			case 60:
				return _List_fromArray(
					['hinter', 'new_partner']);
			case 61:
				return _List_fromArray(
					['hinter', 'new_practice']);
			case 62:
				return _List_fromArray(
					['inventory', 'list']);
			case 63:
				return _List_fromArray(
					['inventory', 'new']);
			case 64:
				return _List_fromArray(
					['inventory', 'settings']);
			case 65:
				return _List_fromArray(
					['marketplace', 'manage']);
			case 66:
				return _List_fromArray(
					['messages', 'calls']);
			case 67:
				return _List_fromArray(
					['messages', 'drafts']);
			case 68:
				return _List_fromArray(
					['messages', 'forms']);
			case 69:
				return _List_fromArray(
					['messages', 'labs']);
			case 70:
				return _List_fromArray(
					['messages', 'messages']);
			case 71:
				return _List_fromArray(
					['messages', 'sms']);
			case 72:
				return _List_fromArray(
					['new_settings', 'erx']);
			case 73:
				return _List_fromArray(
					['new_settings', 'hinter_settings']);
			case 74:
				return _List_fromArray(
					['new_settings', 'practice_info']);
			case 75:
				return _List_fromArray(
					['new_settings', 'team']);
			case 76:
				return _List_fromArray(
					['oauth', 'callback']);
			case 77:
				return _List_fromArray(
					['partner', 'api_keys']);
			case 78:
				return _List_fromArray(
					['partner', 'billing']);
			case 79:
				return _List_fromArray(
					['partner', 'engagements']);
			case 80:
				return _List_fromArray(
					['partner', 'hinter']);
			case 81:
				return _List_fromArray(
					['partner', 'product']);
			case 82:
				return _List_fromArray(
					['partner', 'team']);
			case 83:
				return _List_fromArray(
					['partner', 'webhook_endpoints']);
			case 84:
				return _List_fromArray(
					['patients', 'create']);
			case 85:
				return _List_fromArray(
					['patients', 'upload']);
			case 86:
				return _List_fromArray(
					['practice_setup', 'account']);
			case 87:
				return _List_fromArray(
					['practice_setup', 'communications']);
			case 88:
				return _List_fromArray(
					['practice_setup', 'complete']);
			case 89:
				return _List_fromArray(
					['practice_setup', 'documents']);
			case 90:
				return _List_fromArray(
					['practice_setup', 'legal']);
			case 91:
				return _List_fromArray(
					['practice_setup', 'payment_processing']);
			case 92:
				return _List_fromArray(
					['practice_setup', 'plans']);
			case 93:
				return _List_fromArray(
					['practice_setup', 'team']);
			case 94:
				return _List_fromArray(
					['reports', 'company_invoices']);
			case 95:
				return _List_fromArray(
					['reports', 'credit_outstanding']);
			case 96:
				return _List_fromArray(
					['reports', 'credit_transactions']);
			case 97:
				return _List_fromArray(
					['reports', 'dashboard']);
			case 98:
				return _List_fromArray(
					['reports', 'deferred_revenue']);
			case 99:
				return _List_fromArray(
					['reports', 'deposits']);
			case 100:
				return _List_fromArray(
					['reports', 'disputes']);
			case 101:
				return _List_fromArray(
					['reports', 'invoices']);
			case 102:
				return _List_fromArray(
					['reports', 'memberships']);
			case 103:
				return _List_fromArray(
					['reports', 'months']);
			case 104:
				return _List_fromArray(
					['reports', 'payment_applications']);
			case 105:
				return _List_fromArray(
					['reports', 'revenue']);
			case 106:
				return _List_fromArray(
					['reports', 'sales_tax']);
			case 107:
				return _List_fromArray(
					['reports', 'signup_attempts']);
			case 108:
				return _List_fromArray(
					['style_guide', 'activity_indicators']);
			case 109:
				return _List_fromArray(
					['style_guide', 'address_input']);
			case 110:
				return _List_fromArray(
					['style_guide', 'alert']);
			case 111:
				return _List_fromArray(
					['style_guide', 'badge']);
			case 112:
				return _List_fromArray(
					['style_guide', 'button']);
			case 113:
				return _List_fromArray(
					['style_guide', 'carousel']);
			case 114:
				return _List_fromArray(
					['style_guide', 'checkbox']);
			case 115:
				return _List_fromArray(
					['style_guide', 'currency_input']);
			case 116:
				return _List_fromArray(
					['style_guide', 'date_input']);
			case 117:
				return _List_fromArray(
					['style_guide', 'date_range_input']);
			case 118:
				return _List_fromArray(
					['style_guide', 'dropdown']);
			case 119:
				return _List_fromArray(
					['style_guide', 'export_csv']);
			case 120:
				return _List_fromArray(
					['style_guide', 'file_input']);
			case 121:
				return _List_fromArray(
					['style_guide', 'flex_grid']);
			case 122:
				return _List_fromArray(
					['style_guide', 'flyout_menu']);
			case 123:
				return _List_fromArray(
					['style_guide', 'form_example']);
			case 124:
				return _List_fromArray(
					['style_guide', 'form_group']);
			case 125:
				return _List_fromArray(
					['style_guide', 'form_static']);
			case 126:
				return _List_fromArray(
					['style_guide', 'hi_confirm']);
			case 127:
				return _List_fromArray(
					['style_guide', 'horizontal_rule']);
			case 128:
				return _List_fromArray(
					['style_guide', 'icon']);
			case 129:
				return _List_fromArray(
					['style_guide', 'input']);
			case 130:
				return _List_fromArray(
					['style_guide', 'link']);
			case 131:
				return _List_fromArray(
					['style_guide', 'list_group']);
			case 132:
				return _List_fromArray(
					['style_guide', 'modal']);
			case 133:
				return _List_fromArray(
					['style_guide', 'pagination']);
			case 134:
				return _List_fromArray(
					['style_guide', 'panel']);
			case 135:
				return _List_fromArray(
					['style_guide', 'password_input']);
			case 136:
				return _List_fromArray(
					['style_guide', 'payment_source_displayer']);
			case 137:
				return _List_fromArray(
					['style_guide', 'phone_input']);
			case 138:
				return _List_fromArray(
					['style_guide', 'popover']);
			case 139:
				return _List_fromArray(
					['style_guide', 'progress_bar']);
			case 140:
				return _List_fromArray(
					['style_guide', 'resource_filter']);
			case 141:
				return _List_fromArray(
					['style_guide', 'search_input']);
			case 142:
				return _List_fromArray(
					['style_guide', 'searchable_select']);
			case 143:
				return _List_fromArray(
					['style_guide', 'select']);
			case 144:
				return _List_fromArray(
					['style_guide', 'skeleton']);
			case 145:
				return _List_fromArray(
					['style_guide', 'svg_icon']);
			case 146:
				return _List_fromArray(
					['style_guide', 'table']);
			case 147:
				return _List_fromArray(
					['style_guide', 'tabs']);
			case 148:
				return _List_fromArray(
					['style_guide', 'toast']);
			case 149:
				return _List_fromArray(
					['style_guide', 'toggle_switch']);
			case 150:
				return _List_fromArray(
					['style_guide', 'tooltip']);
			case 151:
				return _List_fromArray(
					['style_guide', 'typography']);
			case 152:
				return _List_fromArray(
					['style_guide', 'upload_form']);
			case 153:
				return _List_fromArray(
					['style_guide', 'upload_result']);
			case 154:
				return _List_fromArray(
					['style_guide', 'well']);
			case 155:
				return _List_fromArray(
					['support', 'canny_sso']);
			case 156:
				return _List_fromArray(
					['tasks', 'new']);
			case 157:
				return _List_fromArray(
					['user', 'accept_terms']);
			case 158:
				return _List_fromArray(
					['user', 'mfa']);
			case 159:
				return _List_fromArray(
					['user', 'profile']);
			case 160:
				return _List_fromArray(
					['user', 'security']);
			case 161:
				var slug = route.a._c;
				return _List_fromArray(
					['apps', slug]);
			case 162:
				var status = route.a.ag7;
				return _List_fromArray(
					['error', status]);
			case 163:
				var token = route.a.$Q;
				return _List_fromArray(
					['join', token]);
			case 164:
				var slug = route.a._c;
				return _List_fromArray(
					['marketplace', slug]);
			case 165:
				return _List_fromArray(
					['admin', 'athenahealth']);
			case 166:
				return _List_fromArray(
					['admin', 'charge_items']);
			case 167:
				return _List_fromArray(
					['admin', 'company_plans']);
			case 168:
				return _List_fromArray(
					['admin', 'coverage_plans']);
			case 169:
				return _List_fromArray(
					['admin', 'data_export']);
			case 170:
				return _List_fromArray(
					['admin', 'data_export_settings']);
			case 171:
				return _List_fromArray(
					['admin', 'documents']);
			case 172:
				return _List_fromArray(
					['admin', 'elation']);
			case 173:
				return _List_fromArray(
					['admin', 'plans']);
			case 174:
				return _List_fromArray(
					['admin', 'providers']);
			case 175:
				return _List_fromArray(
					['admin', 'quickbooks']);
			case 176:
				return _List_fromArray(
					['admin', 'signup_pages']);
			case 177:
				return _List_fromArray(
					['commissions', 'broker_accounts']);
			case 178:
				return _List_fromArray(
					['commissions', 'statement_lines']);
			case 179:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId]);
			case 180:
				var contactId = route.a.acb;
				return _List_fromArray(
					['contacts', contactId]);
			case 181:
				return _List_fromArray(
					['hinter', 'admin_users_groups']);
			case 182:
				var inventoryId = route.a.ad5;
				return _List_fromArray(
					['inventory', inventoryId]);
			case 183:
				return _List_fromArray(
					['messages', 'faxes']);
			case 184:
				return _List_fromArray(
					['messages', 'scheduled']);
			case 185:
				return _List_fromArray(
					['new_settings', 'appointment_types']);
			case 186:
				return _List_fromArray(
					['new_settings', 'locations']);
			case 187:
				return _List_fromArray(
					['new_settings', 'templates']);
			case 188:
				var dealId = route.a.act;
				return _List_fromArray(
					['onboard', dealId]);
			case 189:
				return _List_fromArray(
					['partner', 'dashboard']);
			case 190:
				return _List_fromArray(
					['partner', 'practices']);
			case 191:
				return _List_fromArray(
					['partner', 'sandboxes']);
			case 192:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId]);
			case 193:
				return _List_fromArray(
					['reports', 'ancillary_charges']);
			case 194:
				var tasksId = route.a.ahi;
				return _List_fromArray(
					['tasks', tasksId]);
			case 195:
				return _List_fromArray(
					['user', 'organizations']);
			case 196:
				return _List_fromArray(
					['admin', 'athenahealth', 'fields']);
			case 197:
				return _List_fromArray(
					['admin', 'athenahealth', 'link']);
			case 198:
				return _List_fromArray(
					['admin', 'athenahealth', 'locations']);
			case 199:
				return _List_fromArray(
					['admin', 'athenahealth', 'overview']);
			case 200:
				return _List_fromArray(
					['admin', 'athenahealth', 'providers']);
			case 201:
				return _List_fromArray(
					['admin', 'charge_items', 'new']);
			case 202:
				return _List_fromArray(
					['admin', 'charge_items', 'upload']);
			case 203:
				return _List_fromArray(
					['admin', 'company_plans', 'new']);
			case 204:
				return _List_fromArray(
					['admin', 'coverage_plans', 'new']);
			case 205:
				return _List_fromArray(
					['admin', 'credits', 'upload']);
			case 206:
				return _List_fromArray(
					['admin', 'data_export_settings', 'new']);
			case 207:
				return _List_fromArray(
					['admin', 'developers', 'api_keys']);
			case 208:
				return _List_fromArray(
					['admin', 'developers', 'get_started']);
			case 209:
				return _List_fromArray(
					['admin', 'developers', 'sandboxes']);
			case 210:
				return _List_fromArray(
					['admin', 'developers', 'webhook_endpoints']);
			case 211:
				return _List_fromArray(
					['admin', 'documents', 'new']);
			case 212:
				return _List_fromArray(
					['admin', 'elation', 'link']);
			case 213:
				return _List_fromArray(
					['admin', 'elation', 'overview']);
			case 214:
				return _List_fromArray(
					['admin', 'elation', 'providers']);
			case 215:
				return _List_fromArray(
					['admin', 'notifications', 'company']);
			case 216:
				return _List_fromArray(
					['admin', 'notifications', 'employee']);
			case 217:
				return _List_fromArray(
					['admin', 'notifications', 'membership']);
			case 218:
				return _List_fromArray(
					['admin', 'notifications', 'patient']);
			case 219:
				return _List_fromArray(
					['admin', 'notifications', 'practice']);
			case 220:
				return _List_fromArray(
					['admin', 'notifications', 'settings']);
			case 221:
				return _List_fromArray(
					['admin', 'payment_method_import', 'upload']);
			case 222:
				return _List_fromArray(
					['admin', 'plans', 'new']);
			case 223:
				return _List_fromArray(
					['admin', 'providers', 'upload']);
			case 224:
				return _List_fromArray(
					['admin', 'signup_pages', 'new']);
			case 225:
				return _List_fromArray(
					['admin', 'team', 'new']);
			case 226:
				var affiliateId = route.a.pp;
				return _List_fromArray(
					['affiliates', affiliateId, 'affiliate_actions']);
			case 227:
				var affiliateId = route.a.pp;
				return _List_fromArray(
					['affiliates', affiliateId, 'link_providers']);
			case 228:
				var affiliateId = route.a.pp;
				return _List_fromArray(
					['affiliates', affiliateId, 'linked_providers']);
			case 229:
				var affiliateId = route.a.pp;
				return _List_fromArray(
					['affiliates', affiliateId, 'patients']);
			case 230:
				var affiliateId = route.a.pp;
				return _List_fromArray(
					['affiliates', affiliateId, 'settings']);
			case 231:
				var affiliateId = route.a.pp;
				return _List_fromArray(
					['affiliates', affiliateId, 'users']);
			case 232:
				return _List_fromArray(
					['commissions', 'broker_accounts', 'new']);
			case 233:
				return _List_fromArray(
					['commissions', 'statement_lines', 'summary']);
			case 234:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'affiliates_pricing']);
			case 235:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'eas']);
			case 236:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'ended_commissions']);
			case 237:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'invoice_settings']);
			case 238:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'notes']);
			case 239:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'notifications']);
			case 240:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'payment_sources']);
			case 241:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'signup']);
			case 242:
				return _List_fromArray(
					['messages', 'faxes', 'new']);
			case 243:
				return _List_fromArray(
					['messages', 'scheduled', 'new']);
			case 244:
				return _List_fromArray(
					['new_settings', 'appointment_types', 'new']);
			case 245:
				return _List_fromArray(
					['new_settings', 'templates', 'new']);
			case 246:
				var onboardId = route.a.afq;
				return _List_fromArray(
					['onboard', onboardId, 'completed']);
			case 247:
				var onboardId = route.a.afq;
				return _List_fromArray(
					['onboard', onboardId, 'completing']);
			case 248:
				var onboardId = route.a.afq;
				return _List_fromArray(
					['onboard', onboardId, 'payment']);
			case 249:
				var onboardId = route.a.afq;
				return _List_fromArray(
					['onboard', onboardId, 'user']);
			case 250:
				return _List_fromArray(
					['partner', 'billing', 'hinter']);
			case 251:
				return _List_fromArray(
					['partner', 'product', 'activation_settings']);
			case 252:
				return _List_fromArray(
					['partner', 'product', 'app_settings']);
			case 253:
				return _List_fromArray(
					['partner', 'product', 'hinter']);
			case 254:
				return _List_fromArray(
					['partner', 'product', 'new']);
			case 255:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'chart']);
			case 256:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'edit']);
			case 257:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'manage_credits']);
			case 258:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'merge']);
			case 259:
				return _List_fromArray(
					['practice_setup', 'plans', 'new']);
			case 260:
				return _List_fromArray(
					['reports', 'credit_outstanding', 'summary']);
			case 261:
				return _List_fromArray(
					['reports', 'credit_transactions', 'summary']);
			case 262:
				return _List_fromArray(
					['reports', 'custom', 'new']);
			case 263:
				return _List_fromArray(
					['reports', 'deferred_revenue', 'summary']);
			case 264:
				return _List_fromArray(
					['reports', 'payment_applications', 'summary']);
			case 265:
				return _List_fromArray(
					['reports', 'revenue', 'summary']);
			case 266:
				return _List_fromArray(
					['reports', 'sales_tax', 'summary']);
			case 267:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'charge_items', id]);
			case 268:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'company_plans', id]);
			case 269:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'coverage_plans', id]);
			case 270:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'data_export', id]);
			case 271:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'data_export_settings', id]);
			case 272:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'documents', id]);
			case 273:
				var slug = route.a._c;
				return _List_fromArray(
					['admin', 'integrations', slug]);
			case 274:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'plans', id]);
			case 275:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'signup_pages', id]);
			case 276:
				var id = route.a.adR;
				return _List_fromArray(
					['hinter', 'admin_users_groups', id]);
			case 277:
				var ident = route.a.adS;
				return _List_fromArray(
					['new_settings', 'appointment_types', ident]);
			case 278:
				var bookingLocationId = route.a.abH;
				return _List_fromArray(
					['new_settings', 'locations', bookingLocationId]);
			case 279:
				var teamId = route.a.ahk;
				return _List_fromArray(
					['new_settings', 'team', teamId]);
			case 280:
				var templateId = route.a.ahl;
				return _List_fromArray(
					['new_settings', 'templates', templateId]);
			case 281:
				var id = route.a.adR;
				return _List_fromArray(
					['reports', 'ancillary_charges', id]);
			case 282:
				var id = route.a.adR;
				return _List_fromArray(
					['reports', 'custom', id]);
			case 283:
				var affiliateId = route.a.pp;
				return _List_fromArray(
					['affiliates', affiliateId, 'bills']);
			case 284:
				var brokerAccountId = route.a.bP;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId]);
			case 285:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'employees']);
			case 286:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'invoices']);
			case 287:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'uploads']);
			case 288:
				var scheduledId = route.a.agG;
				return _List_fromArray(
					['messages', 'scheduled', scheduledId]);
			case 289:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'accounts']);
			case 290:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'affiliation']);
			case 291:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'charges']);
			case 292:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'memberships']);
			case 293:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'notes']);
			case 294:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'notifications']);
			case 295:
				return _List_fromArray(
					['admin', 'notifications', 'patient', 'dunning_schedule']);
			case 296:
				var brokerAccountId = route.a.bP;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'deals']);
			case 297:
				var brokerAccountId = route.a.bP;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'ended_deals']);
			case 298:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'employees', 'create']);
			case 299:
				var companyId = route.a.ff;
				return _List_fromArray(
					['companies', companyId, 'signup_pages', 'new']);
			case 300:
				return _List_fromArray(
					['marketplace', 'layer', 'manage', 'settings']);
			case 301:
				var slug = route.a._c;
				return _List_fromArray(
					['marketplace', slug, 'manage', 'onboarding']);
			case 302:
				var slug = route.a._c;
				return _List_fromArray(
					['marketplace', slug, 'manage', 'settings']);
			case 303:
				var slug = route.a._c;
				return _List_fromArray(
					['marketplace', slug, 'manage', 'users']);
			case 304:
				var teamId = route.a.ahk;
				return _List_fromArray(
					['new_settings', 'team', teamId, 'basic_info']);
			case 305:
				var patientId = route.a.VN;
				return _List_fromArray(
					['patients', patientId, 'memberships', 'new']);
			case 306:
				var id = route.a.adR;
				return _List_fromArray(
					['practice_setup', 'plans', id, 'edit']);
			case 307:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'billing', 'practice_invoices', id]);
			case 308:
				var affiliateId = route.a.pp;
				var id = route.a.adR;
				return _List_fromArray(
					['affiliates', affiliateId, 'bills', id]);
			case 309:
				var companyId = route.a.ff;
				var id = route.a.adR;
				return _List_fromArray(
					['companies', companyId, 'invoices', id]);
			case 310:
				var companyId = route.a.ff;
				var id = route.a.adR;
				return _List_fromArray(
					['companies', companyId, 'signup_pages', id]);
			case 311:
				var brokerAccountId = route.a.bP;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'brokers']);
			case 312:
				var brokerAccountId = route.a.bP;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'statements']);
			case 313:
				var companyId = route.a.ff;
				var uploadId = route.a.HK;
				return _List_fromArray(
					['companies', companyId, 'uploads', uploadId]);
			case 314:
				var patientId = route.a.VN;
				var agreementId = route.a.IM;
				return _List_fromArray(
					['patients', patientId, 'agreements', agreementId]);
			case 315:
				var patientId = route.a.VN;
				var invoiceId = route.a.aea;
				return _List_fromArray(
					['patients', patientId, 'charges', invoiceId]);
			case 316:
				var patientId = route.a.VN;
				var membershipId = route.a.yS;
				return _List_fromArray(
					['patients', patientId, 'memberships', membershipId]);
			case 317:
				var id = route.a.adR;
				return _List_fromArray(
					['admin', 'plans', id, 'pricing_versions', 'new']);
			case 318:
				var brokerAccountId = route.a.bP;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'brokers', 'ended']);
			case 319:
				var brokerAccountId = route.a.bP;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'brokers', 'new']);
			case 320:
				var companyId = route.a.ff;
				var uploadId = route.a.HK;
				return _List_fromArray(
					['companies', companyId, 'uploads', uploadId, 'upload_results']);
			case 321:
				var id = route.a.adR;
				var pricingVersionId = route.a.afY;
				return _List_fromArray(
					['admin', 'plans', id, 'pricing_versions', pricingVersionId]);
			case 322:
				var brokerAccountId = route.a.bP;
				var statementId = route.a.ag6;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'statements', statementId]);
			case 323:
				var brokerAccountId = route.a.bP;
				var brokerId = route.a.Eo;
				return _List_fromArray(
					['commissions', 'broker_accounts', brokerAccountId, 'brokers', brokerId]);
			default:
				var companyId = route.a.ff;
				var employeeId = route.a.acX;
				var dependentId = route.a.acF;
				return _List_fromArray(
					['companies', companyId, 'employees', employeeId, 'dependent', dependentId]);
		}
	}();
	return A2(
		$elm$core$String$append,
		'/',
		A2($elm$core$String$join, '/', segments));
};
var $author$project$Ports$Navigation$pushRoute = F2(
	function (queryParams, route) {
		return $author$project$Ports$Navigation$pushUrl(
			_Utils_ap(
				$author$project$Spa$Generated$Route$toString(route),
				$elm$url$Url$Builder$toQuery(queryParams)));
	});
var $author$project$Api$Platform$Session$One$Session = $elm$core$Basics$identity;
var $author$project$Api$Platform$Session$One$Record = function (id) {
	return function (createdAt) {
		return function (role) {
			return function (restrictedByGroups) {
				return function (user) {
					return function (showCollectionWarning) {
						return function (requestDetail) {
							return function (organization) {
								return function (permissionSets) {
									return function (locationGroups) {
										return function (sandbox) {
											return {Mf: createdAt, adR: id, S$: locationGroups, Vd: organization, Wf: permissionSets, Yg: requestDetail, Yy: restrictedByGroups, agy: role, Y$: sandbox, ZT: showCollectionWarning, aaz: user};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {K6: col, acc: contextStack, nI: problem, n3: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.n3, s.K6, x, s.aB));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.sX),
			s.f) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.sX);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.f, offset) < 0,
					0,
					{K6: col, aB: s0.aB, ad_: s0.ad_, f: offset, n3: row, sX: s0.sX});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.f, s.n3, s.K6, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.f, s1.f, s0.sX),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.f, s.sX);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{K6: 1, aB: s.aB, ad_: s.ad_, f: s.f + 1, n3: s.n3 + 1, sX: s.sX}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{K6: s.K6 + 1, aB: s.aB, ad_: s.ad_, f: newOffset, n3: s.n3, sX: s.sX}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.f, s.n3, s.K6, s.sX);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{K6: newCol, aB: s.aB, ad_: s.ad_, f: newOffset, n3: newRow, sX: s.sX});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {K6: col, nI: problem, n3: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.n3, p.K6, p.nI);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{K6: 1, aB: _List_Nil, ad_: 1, f: 0, n3: 1, sX: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $elm_community$json_extra$Json$Decode$Extra$datetime = A2(
	$elm$json$Json$Decode$andThen,
	function (dateString) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
		if (!_v0.$) {
			var v = _v0.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$LocationGroup$Shared$LocationGroup = $elm$core$Basics$identity;
var $author$project$Api$Common$LocationGroup$Min$LocationGroup = $elm$core$Basics$identity;
var $author$project$Api$Common$LocationGroup$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Common$LocationGroup$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$LocationGroup$Min$Record)));
var $author$project$Api$Common$LocationGroup$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$LocationGroup$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$LocationGroup$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$LocationGroup$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$PermissionSet$Shared$PermissionSet = $elm$core$Basics$identity;
var $author$project$Api$Common$PermissionSet$Shared$Record = F2(
	function (name, enabled) {
		return {Ot: enabled, zh: name};
	});
var $author$project$Api$Common$PermissionSet$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$PermissionSet$Shared$Record)));
var $author$project$Api$Common$PermissionSet$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$PermissionSet$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$RequestDetail$Shared$RequestDetail = $elm$core$Basics$identity;
var $author$project$Api$Common$RequestDetail$Shared$Record = F9(
	function (ip, clientName, deviceType, osName, state, country, countryCode, deviceBrand, deviceName) {
		return {K2: clientName, pZ: country, LZ: countryCode, ND: deviceBrand, NE: deviceName, NF: deviceType, Rt: ip, Vj: osName, sZ: state};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Api$Common$RequestDetail$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'device_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'device_brand',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'country_code',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'country',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'os_name',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'device_type',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'client_name',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'ip',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Api$Common$RequestDetail$Shared$Record))))))))));
var $author$project$Api$Common$RequestDetail$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$RequestDetail$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Organization$Shared$Organization = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Organization$Min$Organization = $elm$core$Basics$identity;
var $author$project$Api$Platform$Organization$Min$Record = F3(
	function (type_, id, name) {
		return {adR: id, zh: name, ahI: type_};
	});
var $author$project$Api$OrganizationType$Company = 1;
var $author$project$Api$OrganizationType$Partner = 2;
var $author$project$Api$OrganizationType$Practice = 0;
var $author$project$Api$OrganizationType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'company':
				return $elm$json$Json$Decode$succeed(1);
			case 'practice':
				return $elm$json$Json$Decode$succeed(0);
			case 'partner':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported organization type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Platform$Organization$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Api$OrganizationType$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Min$Record))));
var $author$project$Api$Platform$Organization$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Organization$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Organization$Shared$Record = F7(
	function (accountType, isNetwork, requiresMfa, onboarded, practiceIsOnboarding, onboardingClinical, sandboxOf) {
		return {H7: accountType, RV: isNetwork, U5: onboarded, U6: onboardingClinical, WI: practiceIsOnboarding, Yn: requiresMfa, Y1: sandboxOf};
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Api$Platform$Organization$Shared$SandboxOfPartner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Platform$Organization$Shared$SandboxOfPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Organization$SandboxOf$Organization = $elm$core$Basics$identity;
var $author$project$Api$Platform$Organization$SandboxOf$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Organization$Shared$sandboxOfDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (sandboxOfType) {
		if (sandboxOfType.$ === 1) {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (sandboxOfType.a) {
				case 'Practice':
					return A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sandbox_of',
							$author$project$Api$Platform$Organization$SandboxOf$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$SandboxOfPractice)));
				case 'Partner':
					return A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'sandbox_of',
							$author$project$Api$Platform$Organization$SandboxOf$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$SandboxOfPartner)));
				default:
					var somethingElse = sandboxOfType.a;
					return $elm$json$Json$Decode$fail('Unsupported sandbox of type ' + somethingElse);
			}
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['sandbox_of_type']),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Platform$Organization$Shared$recordDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Organization$Shared$sandboxOfDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'onboarding_clinical',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'practice_is_onboarding',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'onboarded',
				$elm$json$Json$Decode$bool,
				true,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'requires_mfa',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'is_network',
						$elm$json$Json$Decode$bool,
						false,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'account_type',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$Record))))))));
var $author$project$Api$Platform$Organization$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Organization$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$Organization$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$Organization)));
var $author$project$Api$Platform$User$Shared$User = $elm$core$Basics$identity;
var $author$project$Api$Platform$User$Shared$Record = function (id) {
	return function (name) {
		return function (firstName) {
			return function (lastName) {
				return function (email) {
					return function (canSwitchOrganizations) {
						return function (isAdmin) {
							return function (termsAccepted) {
								return function (mfaStatus) {
									return function (requiresMfa) {
										return function (isMfaActive) {
											return function (phones) {
												return function (identityProviderId) {
													return function (intercomUserHash) {
														return {KE: canSwitchOrganizations, Oo: email, Pu: firstName, adR: id, QK: identityProviderId, Re: intercomUserHash, Ru: isAdmin, RT: isMfaActive, SA: lastName, TW: mfaStatus, zh: name, Wi: phones, Yn: requiresMfa, Hw: termsAccepted};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Platform$Mfa$Status$Active = 0;
var $author$project$Api$Platform$Mfa$Status$Inactive = 1;
var $author$project$Api$Platform$Mfa$Status$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'active':
				return $elm$json$Json$Decode$succeed(0);
			case 'inactive':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported mfa status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Phone$Shared$Phone = $elm$core$Basics$identity;
var $author$project$Api$Common$Phone$Shared$Record = F3(
	function (number, type_, usFormattable) {
		return {Gj: number, ahI: type_, HM: usFormattable};
	});
var $author$project$Api$Common$Phone$Shared$Home = {$: 1};
var $author$project$Api$Common$Phone$Shared$Mobile = {$: 0};
var $author$project$Api$Common$Phone$Shared$Office = {$: 2};
var $author$project$Api$Common$Phone$Shared$Other = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Common$Phone$Shared$typeDecoder = A2(
	$elm$json$Json$Decode$map,
	function (str) {
		switch (str) {
			case 'mobile':
				return $author$project$Api$Common$Phone$Shared$Mobile;
			case 'home':
				return $author$project$Api$Common$Phone$Shared$Home;
			case 'office':
				return $author$project$Api$Common$Phone$Shared$Office;
			default:
				var somethingElse = str;
				return $author$project$Api$Common$Phone$Shared$Other(somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Phone$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'us_formattable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$author$project$Api$Common$Phone$Shared$typeDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'number',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Phone$Shared$Record))));
var $author$project$Api$Common$Phone$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Phone$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$User$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'intercom_user_hash',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'identity_provider_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phones',
			$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_mfa_active',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'requires_mfa',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'mfa_status',
						$author$project$Api$Platform$Mfa$Status$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'terms_accepted',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_admin',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'can_switch_organizations',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'email',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'first_name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$Shared$Record)))))))))))))));
var $author$project$Api$Platform$User$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$User$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Session$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sandbox',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'location_groups',
		$elm$json$Json$Decode$list($author$project$Api$Common$LocationGroup$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'permission_sets',
			$elm$json$Json$Decode$list($author$project$Api$Common$PermissionSet$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'organization',
				$elm$json$Json$Decode$nullable($author$project$Api$Platform$Organization$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'request_detail',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'show_collection_warning',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'user',
							$author$project$Api$Platform$User$Shared$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'restricted_by_groups',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'role',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'created_at',
										$elm_community$json_extra$Json$Decode$Extra$datetime,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Platform$Session$One$Record))))))))))));
var $author$project$Api$Platform$Session$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Session$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Session$sessionPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['session']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Session$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$Session$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Session$sessionPath));
	});
var $author$project$Api$Platform$User$One$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$User$One$Record = F4(
	function (practicesCount, companiesCount, partnersCount, defaultOrganization) {
		return {Lq: companiesCount, Nd: defaultOrganization, VH: partnersCount, WM: practicesCount};
	});
var $author$project$Api$Platform$User$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'default_organization',
	$elm$json$Json$Decode$nullable($author$project$Api$Platform$Organization$Shared$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'partners_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'companies_count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practices_count',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$One$Record)))));
var $author$project$Api$Platform$User$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$User$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$User$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$One$User)));
var $author$project$Api$Platform$User$userPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['user']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$User$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$User$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath));
	});
var $author$project$Api$AuthToken$jwtIssuer = function (authToken) {
	return A2(
		$elm$core$Maybe$andThen,
		$elm$core$Result$toMaybe,
		A2(
			$elm$core$Maybe$map,
			function (token) {
				return A2(
					$simonh1000$elm_jwt$Jwt$decodeToken,
					A2($elm$json$Json$Decode$field, 'iss', $elm$json$Json$Decode$string),
					token);
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
};
var $author$project$Api$AuthToken$isDefaultAuthJwt = F2(
	function (authToken, providerAuthUrl) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (issuer) {
					return _Utils_eq(issuer, providerAuthUrl);
				},
				$author$project$Api$AuthToken$jwtIssuer(authToken)));
	});
var $author$project$Api$Data$usingDefaultAuth = F2(
	function (_v0, backupAuthEnabled) {
		var client = _v0;
		var isDefaultAuthJwt = A2($author$project$Api$AuthToken$isDefaultAuthJwt, client.e2, client.GU);
		return (!backupAuthEnabled) && isDefaultAuthJwt;
	});
var $author$project$Shared$initSession = F3(
	function (apiClient, currentTime, backupAuthEnabled) {
		var refreshTimeoutCmd = (!A2($author$project$Api$Data$usingDefaultAuth, apiClient, backupAuthEnabled)) ? $author$project$Shared$backupJwtRefreshTimeout(apiClient) : $elm$core$Platform$Cmd$none;
		var notExpired = !A2($author$project$Api$Data$clientHasTokenExpired, apiClient, currentTime);
		var canRetrieveSession = $author$project$Api$Data$clientHasAuthToken(apiClient) && notExpired;
		var retrieveApiSession = canRetrieveSession ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Platform$Session$retrieve, apiClient, $author$project$Shared$GotSession),
					A2($author$project$Api$Platform$User$retrieve, apiClient, $author$project$Shared$GotUser)
				])) : $elm$core$Platform$Cmd$none;
		var session = canRetrieveSession ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked;
		var authenticate = function () {
			var _v0 = _Utils_Tuple2(
				$author$project$Api$Data$clientHasAuthToken(apiClient),
				backupAuthEnabled);
			if (_v0.a) {
				return $author$project$Ports$Session$authorize(
					{af6: true});
			} else {
				if (_v0.b) {
					return A2($author$project$Ports$Navigation$pushRoute, _List_Nil, $author$project$Spa$Generated$Route$Login);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}
		}();
		return _Utils_Tuple2(
			session,
			_List_fromArray(
				[authenticate, retrieveApiSession, refreshTimeoutCmd]));
	});
var $author$project$Ui$Image$Store = $elm$core$Basics$identity;
var $author$project$Ui$Image$initStore = $elm$core$Basics$identity;
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Shared$init = F2(
	function (flags, url) {
		var providerAuthUrl = flags.GU;
		var defaultTheme = 'v2';
		var currentTime = $elm$time$Time$millisToPosix(flags.ack);
		var maybeAuthToken = A2(
			$elm$core$Maybe$andThen,
			function (token) {
				return A2(
					$author$project$Api$AuthToken$isExpired,
					$elm$core$Maybe$Just(token),
					currentTime) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(token);
			},
			A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, flags.agU));
		var backupAuthEnabled = flags.abt;
		var apiClient = A4($author$project$Api$Data$clientInit, flags.abm, providerAuthUrl, flags.D6, maybeAuthToken);
		var _v0 = A3($author$project$Shared$initSession, apiClient, currentTime, backupAuthEnabled);
		var session = _v0.a;
		var sessionCmds = _v0.b;
		var _v1 = $author$project$Utils$Release$init(flags.agf);
		var release = _v1.a;
		var releaseCmd = _v1.b;
		var _v2 = A2($author$project$Components$GlobalSearch$init, apiClient, url);
		var globalSearch = _v2.a;
		var globalSearchCmd = _v2.b;
		var cmds = _Utils_ap(
			sessionCmds,
			_List_fromArray(
				[
					A2($elm$core$Task$attempt, $author$project$Shared$GotTimeZone, $justinmimbs$timezone_data$TimeZone$getZone),
					A2($elm$core$Platform$Cmd$map, $author$project$Shared$GlobalSearchMsg, globalSearchCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Shared$ReleaseMsg, releaseCmd)
				]));
		return _Utils_Tuple2(
			{
				pi: maybeAuthToken,
				D5: apiClient,
				ab9: $author$project$Api$Data$NotAsked,
				LE: '',
				cO: $justinmimbs$date$Date$fromRataDie(flags.acj),
				Mw: $author$project$Api$Data$NotAsked,
				lG: $elm$core$Maybe$Nothing,
				ack: currentTime,
				adu: flags,
				fJ: globalSearch,
				mq: false,
				adM: $author$project$Utils$Environment$decode(flags.adM),
				adN: flags.adN,
				qT: $author$project$Ui$Image$initStore(flags.QO),
				qV: $elm$core$Maybe$Nothing,
				ad: $elm$core$Maybe$Nothing,
				aeR: $author$project$Utils$Environment$decode(flags.aeR),
				afu: false,
				ga: $elm$core$Maybe$Nothing,
				Vz: $author$project$Api$Data$NotAsked,
				afE: $elm$core$Maybe$Nothing,
				afI: $elm$core$Maybe$Nothing,
				V9: $elm$core$Maybe$Nothing,
				Wa: false,
				ej: $author$project$OutMsg$NoAction,
				WF: $author$project$Api$Data$Loading,
				sj: $elm$core$Maybe$Nothing,
				agf: release,
				n0: $elm$core$Maybe$Nothing,
				ZD: session,
				sK: false,
				sP: false,
				gU: false,
				$B: defaultTheme,
				Hy: A2($author$project$Formatters$Time$init, $author$project$Shared$defaultTimeZone, currentTime),
				Hz: $author$project$Shared$defaultTimeZone,
				kv: $author$project$Ui$Toast$init,
				aav: url,
				aaz: $author$project$Api$Data$Loading,
				aa1: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(cmds));
	});
var $author$project$Spa$Generated$Pages$Accounting__Model = function (a) {
	return {$: 1, a: a};
};
var $author$project$Spa$Generated$Pages$Accounting__Msg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Model = function (a) {
	return {$: 19, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Msg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Model = function (a) {
	return {$: 196, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Msg = function (a) {
	return {$: 196, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Model = function (a) {
	return {$: 197, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Msg = function (a) {
	return {$: 197, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Model = function (a) {
	return {$: 198, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Msg = function (a) {
	return {$: 198, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Model = function (a) {
	return {$: 199, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Msg = function (a) {
	return {$: 199, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Model = function (a) {
	return {$: 200, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Msg = function (a) {
	return {$: 200, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Model = function (a) {
	return {$: 165, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Msg = function (a) {
	return {$: 165, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Billing__Model = function (a) {
	return {$: 20, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Billing__Msg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Model = function (a) {
	return {$: 307, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Msg = function (a) {
	return {$: 307, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Model = function (a) {
	return {$: 21, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Msg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CardReaders__Model = function (a) {
	return {$: 22, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CardReaders__Msg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Categories__Model = function (a) {
	return {$: 23, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Categories__Msg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Model = function (a) {
	return {$: 267, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Msg = function (a) {
	return {$: 267, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Model = function (a) {
	return {$: 201, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Msg = function (a) {
	return {$: 201, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Model = function (a) {
	return {$: 166, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Msg = function (a) {
	return {$: 166, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Model = function (a) {
	return {$: 202, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Msg = function (a) {
	return {$: 202, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Commissions__Model = function (a) {
	return {$: 24, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Commissions__Msg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Model = function (a) {
	return {$: 268, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Msg = function (a) {
	return {$: 268, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Model = function (a) {
	return {$: 203, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Msg = function (a) {
	return {$: 203, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Model = function (a) {
	return {$: 167, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Msg = function (a) {
	return {$: 167, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Coupons__Model = function (a) {
	return {$: 25, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Coupons__Msg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Model = function (a) {
	return {$: 269, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Msg = function (a) {
	return {$: 269, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Model = function (a) {
	return {$: 204, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Msg = function (a) {
	return {$: 204, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Model = function (a) {
	return {$: 168, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Msg = function (a) {
	return {$: 168, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CreditCategories__Model = function (a) {
	return {$: 26, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__CreditCategories__Msg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Model = function (a) {
	return {$: 205, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Msg = function (a) {
	return {$: 205, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Model = function (a) {
	return {$: 271, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Msg = function (a) {
	return {$: 271, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Model = function (a) {
	return {$: 206, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Msg = function (a) {
	return {$: 206, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Model = function (a) {
	return {$: 170, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Msg = function (a) {
	return {$: 170, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Model = function (a) {
	return {$: 270, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Msg = function (a) {
	return {$: 270, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Model = function (a) {
	return {$: 169, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Msg = function (a) {
	return {$: 169, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Model = function (a) {
	return {$: 207, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Msg = function (a) {
	return {$: 207, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Model = function (a) {
	return {$: 208, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Msg = function (a) {
	return {$: 208, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Model = function (a) {
	return {$: 209, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Msg = function (a) {
	return {$: 209, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Model = function (a) {
	return {$: 210, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Msg = function (a) {
	return {$: 210, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Model = function (a) {
	return {$: 272, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Msg = function (a) {
	return {$: 272, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__New__Model = function (a) {
	return {$: 211, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__New__Msg = function (a) {
	return {$: 211, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__Top__Model = function (a) {
	return {$: 171, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Documents__Top__Msg = function (a) {
	return {$: 171, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Model = function (a) {
	return {$: 27, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Msg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Link__Model = function (a) {
	return {$: 212, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Link__Msg = function (a) {
	return {$: 212, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Model = function (a) {
	return {$: 213, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Msg = function (a) {
	return {$: 213, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Model = function (a) {
	return {$: 214, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Msg = function (a) {
	return {$: 214, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Top__Model = function (a) {
	return {$: 172, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Elation__Top__Msg = function (a) {
	return {$: 172, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Features__Model = function (a) {
	return {$: 28, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Features__Msg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Model = function (a) {
	return {$: 29, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Msg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Model = function (a) {
	return {$: 273, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Msg = function (a) {
	return {$: 273, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__InternalSettings__Model = function (a) {
	return {$: 30, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__InternalSettings__Msg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Model = function (a) {
	return {$: 31, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Msg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__LeadSources__Model = function (a) {
	return {$: 32, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__LeadSources__Msg = function (a) {
	return {$: 32, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Locations__Model = function (a) {
	return {$: 33, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Locations__Msg = function (a) {
	return {$: 33, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Mailgun__Model = function (a) {
	return {$: 34, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Mailgun__Msg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notes__Model = function (a) {
	return {$: 35, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notes__Msg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Model = function (a) {
	return {$: 215, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Msg = function (a) {
	return {$: 215, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Model = function (a) {
	return {$: 216, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Msg = function (a) {
	return {$: 216, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Model = function (a) {
	return {$: 217, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Msg = function (a) {
	return {$: 217, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Model = function (a) {
	return {$: 295, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Msg = function (a) {
	return {$: 295, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Model = function (a) {
	return {$: 218, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Msg = function (a) {
	return {$: 218, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Model = function (a) {
	return {$: 219, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Msg = function (a) {
	return {$: 219, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Model = function (a) {
	return {$: 220, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Msg = function (a) {
	return {$: 220, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Patients__Model = function (a) {
	return {$: 36, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Patients__Msg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Model = function (a) {
	return {$: 37, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Msg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Model = function (a) {
	return {$: 221, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Msg = function (a) {
	return {$: 221, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Model = function (a) {
	return {$: 38, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Msg = function (a) {
	return {$: 38, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentSources__Model = function (a) {
	return {$: 39, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__PaymentSources__Msg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Model = function (a) {
	return {$: 274, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Msg = function (a) {
	return {$: 274, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Model = function (a) {
	return {$: 317, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Msg = function (a) {
	return {$: 317, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Model = function (a) {
	return {$: 321, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Msg = function (a) {
	return {$: 321, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__New__Model = function (a) {
	return {$: 222, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__New__Msg = function (a) {
	return {$: 222, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Top__Model = function (a) {
	return {$: 173, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Plans__Top__Msg = function (a) {
	return {$: 173, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Practice__Model = function (a) {
	return {$: 40, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Practice__Msg = function (a) {
	return {$: 40, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Model = function (a) {
	return {$: 41, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Msg = function (a) {
	return {$: 41, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Providers__Top__Model = function (a) {
	return {$: 174, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Providers__Top__Msg = function (a) {
	return {$: 174, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Model = function (a) {
	return {$: 223, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Msg = function (a) {
	return {$: 223, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Model = function (a) {
	return {$: 175, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Msg = function (a) {
	return {$: 175, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Model = function (a) {
	return {$: 42, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Msg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SelfService__Model = function (a) {
	return {$: 43, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SelfService__Msg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Model = function (a) {
	return {$: 275, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Msg = function (a) {
	return {$: 275, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Model = function (a) {
	return {$: 224, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Msg = function (a) {
	return {$: 224, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Model = function (a) {
	return {$: 176, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Msg = function (a) {
	return {$: 176, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Signup__Model = function (a) {
	return {$: 44, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Signup__Msg = function (a) {
	return {$: 44, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Stripe__Model = function (a) {
	return {$: 45, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Stripe__Msg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Taxes__Model = function (a) {
	return {$: 46, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Taxes__Msg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Team__Model = function (a) {
	return {$: 47, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Team__Msg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Team__New__Model = function (a) {
	return {$: 225, a: a};
};
var $author$project$Spa$Generated$Pages$Admin__Team__New__Msg = function (a) {
	return {$: 225, a: a};
};
var $author$project$Spa$Generated$Pages$AffiliateBills__Top__Model = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Generated$Pages$AffiliateBills__Top__Msg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Model = function (a) {
	return {$: 226, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Msg = function (a) {
	return {$: 226, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Model = function (a) {
	return {$: 308, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Msg = function (a) {
	return {$: 308, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Model = function (a) {
	return {$: 283, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Msg = function (a) {
	return {$: 283, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Model = function (a) {
	return {$: 227, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Msg = function (a) {
	return {$: 227, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Model = function (a) {
	return {$: 228, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Msg = function (a) {
	return {$: 228, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Model = function (a) {
	return {$: 229, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Msg = function (a) {
	return {$: 229, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Model = function (a) {
	return {$: 230, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Msg = function (a) {
	return {$: 230, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Model = function (a) {
	return {$: 231, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Msg = function (a) {
	return {$: 231, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__Create__Model = function (a) {
	return {$: 48, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__Create__Msg = function (a) {
	return {$: 48, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__New__Model = function (a) {
	return {$: 49, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__New__Msg = function (a) {
	return {$: 49, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__Top__Model = function (a) {
	return {$: 11, a: a};
};
var $author$project$Spa$Generated$Pages$Affiliates__Top__Msg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Spa$Generated$Pages$Apps__Slug_String__Model = function (a) {
	return {$: 161, a: a};
};
var $author$project$Spa$Generated$Pages$Apps__Slug_String__Msg = function (a) {
	return {$: 161, a: a};
};
var $author$project$Spa$Generated$Pages$Blank__Model = function (a) {
	return {$: 2, a: a};
};
var $author$project$Spa$Generated$Pages$Blank__Msg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Spa$Generated$Pages$Calendar__Model = function (a) {
	return {$: 3, a: a};
};
var $author$project$Spa$Generated$Pages$Calendar__Msg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Spa$Generated$Pages$Charges__New__Model = function (a) {
	return {$: 50, a: a};
};
var $author$project$Spa$Generated$Pages$Charges__New__Msg = function (a) {
	return {$: 50, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Model = function (a) {
	return {$: 323, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Msg = function (a) {
	return {$: 323, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Model = function (a) {
	return {$: 318, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Msg = function (a) {
	return {$: 318, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Model = function (a) {
	return {$: 319, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Msg = function (a) {
	return {$: 319, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Model = function (a) {
	return {$: 311, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Msg = function (a) {
	return {$: 311, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Model = function (a) {
	return {$: 296, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Msg = function (a) {
	return {$: 296, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Model = function (a) {
	return {$: 297, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Msg = function (a) {
	return {$: 297, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Model = function (a) {
	return {$: 322, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Msg = function (a) {
	return {$: 322, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Model = function (a) {
	return {$: 312, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Msg = function (a) {
	return {$: 312, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Model = function (a) {
	return {$: 284, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Msg = function (a) {
	return {$: 284, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Model = function (a) {
	return {$: 232, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Msg = function (a) {
	return {$: 232, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Model = function (a) {
	return {$: 177, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Msg = function (a) {
	return {$: 177, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Model = function (a) {
	return {$: 233, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Msg = function (a) {
	return {$: 233, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Model = function (a) {
	return {$: 178, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Msg = function (a) {
	return {$: 178, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__Statements__Model = function (a) {
	return {$: 51, a: a};
};
var $author$project$Spa$Generated$Pages$Commissions__Statements__Msg = function (a) {
	return {$: 51, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Model = function (a) {
	return {$: 234, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Msg = function (a) {
	return {$: 234, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Model = function (a) {
	return {$: 235, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Msg = function (a) {
	return {$: 235, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Model = function (a) {
	return {$: 298, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Msg = function (a) {
	return {$: 298, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Model = function (a) {
	return {$: 324, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Msg = function (a) {
	return {$: 324, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Model = function (a) {
	return {$: 285, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Msg = function (a) {
	return {$: 285, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Model = function (a) {
	return {$: 236, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Msg = function (a) {
	return {$: 236, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Model = function (a) {
	return {$: 237, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Msg = function (a) {
	return {$: 237, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Model = function (a) {
	return {$: 309, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Msg = function (a) {
	return {$: 309, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Model = function (a) {
	return {$: 286, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Msg = function (a) {
	return {$: 286, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Model = function (a) {
	return {$: 238, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Msg = function (a) {
	return {$: 238, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Model = function (a) {
	return {$: 239, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Msg = function (a) {
	return {$: 239, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Model = function (a) {
	return {$: 240, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Msg = function (a) {
	return {$: 240, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Model = function (a) {
	return {$: 310, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Msg = function (a) {
	return {$: 310, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Model = function (a) {
	return {$: 299, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Msg = function (a) {
	return {$: 299, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Model = function (a) {
	return {$: 241, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Msg = function (a) {
	return {$: 241, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Model = function (a) {
	return {$: 179, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Msg = function (a) {
	return {$: 179, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Model = function (a) {
	return {$: 287, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Msg = function (a) {
	return {$: 287, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Model = function (a) {
	return {$: 313, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Msg = function (a) {
	return {$: 313, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Model = function (a) {
	return {$: 320, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Msg = function (a) {
	return {$: 320, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__New__Model = function (a) {
	return {$: 52, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__New__Msg = function (a) {
	return {$: 52, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__Top__Model = function (a) {
	return {$: 12, a: a};
};
var $author$project$Spa$Generated$Pages$Companies__Top__Msg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Model = function (a) {
	return {$: 180, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Msg = function (a) {
	return {$: 180, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__List__Model = function (a) {
	return {$: 53, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__List__Msg = function (a) {
	return {$: 53, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__New__Model = function (a) {
	return {$: 54, a: a};
};
var $author$project$Spa$Generated$Pages$Contacts__New__Msg = function (a) {
	return {$: 54, a: a};
};
var $author$project$Spa$Generated$Pages$Error__Status_String__Model = function (a) {
	return {$: 162, a: a};
};
var $author$project$Spa$Generated$Pages$Error__Status_String__Msg = function (a) {
	return {$: 162, a: a};
};
var $author$project$Spa$Generated$Pages$Files__Public__Model = function (a) {
	return {$: 55, a: a};
};
var $author$project$Spa$Generated$Pages$Files__Public__Msg = function (a) {
	return {$: 55, a: a};
};
var $author$project$Spa$Generated$Pages$Files__Top__Model = function (a) {
	return {$: 13, a: a};
};
var $author$project$Spa$Generated$Pages$Files__Top__Msg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Spa$Generated$Pages$Forms__Model = function (a) {
	return {$: 4, a: a};
};
var $author$project$Spa$Generated$Pages$Forms__Msg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Model = function (a) {
	return {$: 276, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Msg = function (a) {
	return {$: 276, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Model = function (a) {
	return {$: 181, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Msg = function (a) {
	return {$: 181, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Model = function (a) {
	return {$: 56, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Msg = function (a) {
	return {$: 56, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__Disputes__Model = function (a) {
	return {$: 57, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__Disputes__Msg = function (a) {
	return {$: 57, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Model = function (a) {
	return {$: 58, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Msg = function (a) {
	return {$: 58, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewGroup__Model = function (a) {
	return {$: 59, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewGroup__Msg = function (a) {
	return {$: 59, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewPartner__Model = function (a) {
	return {$: 60, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewPartner__Msg = function (a) {
	return {$: 60, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewPractice__Model = function (a) {
	return {$: 61, a: a};
};
var $author$project$Spa$Generated$Pages$Hinter__NewPractice__Msg = function (a) {
	return {$: 61, a: a};
};
var $author$project$Spa$Generated$Pages$Home__Model = function (a) {
	return {$: 5, a: a};
};
var $author$project$Spa$Generated$Pages$Home__Msg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Model = function (a) {
	return {$: 182, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Msg = function (a) {
	return {$: 182, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__List__Model = function (a) {
	return {$: 62, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__List__Msg = function (a) {
	return {$: 62, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__New__Model = function (a) {
	return {$: 63, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__New__Msg = function (a) {
	return {$: 63, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__Settings__Model = function (a) {
	return {$: 64, a: a};
};
var $author$project$Spa$Generated$Pages$Inventory__Settings__Msg = function (a) {
	return {$: 64, a: a};
};
var $author$project$Spa$Generated$Pages$Join__Token_String__Model = function (a) {
	return {$: 163, a: a};
};
var $author$project$Spa$Generated$Pages$Join__Token_String__Msg = function (a) {
	return {$: 163, a: a};
};
var $author$project$Spa$Generated$Pages$Login__Model = function (a) {
	return {$: 6, a: a};
};
var $author$project$Spa$Generated$Pages$Login__Msg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Spa$Generated$Pages$Logout__Model = function (a) {
	return {$: 7, a: a};
};
var $author$project$Spa$Generated$Pages$Logout__Msg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Layer__Manage__Settings__Model = function (a) {
	return {$: 300, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Layer__Manage__Settings__Msg = function (a) {
	return {$: 300, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Manage__Model = function (a) {
	return {$: 65, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Manage__Msg = function (a) {
	return {$: 65, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Model = function (a) {
	return {$: 301, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Msg = function (a) {
	return {$: 301, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Model = function (a) {
	return {$: 302, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Msg = function (a) {
	return {$: 302, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Model = function (a) {
	return {$: 303, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Msg = function (a) {
	return {$: 303, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Model = function (a) {
	return {$: 164, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Msg = function (a) {
	return {$: 164, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Top__Model = function (a) {
	return {$: 14, a: a};
};
var $author$project$Spa$Generated$Pages$Marketplace__Top__Msg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Calls__Model = function (a) {
	return {$: 66, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Calls__Msg = function (a) {
	return {$: 66, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Drafts__Model = function (a) {
	return {$: 67, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Drafts__Msg = function (a) {
	return {$: 67, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__New__Model = function (a) {
	return {$: 242, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__New__Msg = function (a) {
	return {$: 242, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Model = function (a) {
	return {$: 183, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Msg = function (a) {
	return {$: 183, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Forms__Model = function (a) {
	return {$: 68, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Forms__Msg = function (a) {
	return {$: 68, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Labs__Model = function (a) {
	return {$: 69, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Labs__Msg = function (a) {
	return {$: 69, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Messages__Model = function (a) {
	return {$: 70, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Messages__Msg = function (a) {
	return {$: 70, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Model = function (a) {
	return {$: 243, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Msg = function (a) {
	return {$: 243, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Model = function (a) {
	return {$: 288, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Msg = function (a) {
	return {$: 288, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Model = function (a) {
	return {$: 184, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Msg = function (a) {
	return {$: 184, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Sms__Model = function (a) {
	return {$: 71, a: a};
};
var $author$project$Spa$Generated$Pages$Messages__Sms__Msg = function (a) {
	return {$: 71, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Model = function (a) {
	return {$: 277, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Msg = function (a) {
	return {$: 277, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Model = function (a) {
	return {$: 244, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Msg = function (a) {
	return {$: 244, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Model = function (a) {
	return {$: 185, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Msg = function (a) {
	return {$: 185, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Erx__Model = function (a) {
	return {$: 72, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Erx__Msg = function (a) {
	return {$: 72, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Model = function (a) {
	return {$: 73, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Msg = function (a) {
	return {$: 73, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Model = function (a) {
	return {$: 278, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Msg = function (a) {
	return {$: 278, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Model = function (a) {
	return {$: 186, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Msg = function (a) {
	return {$: 186, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Model = function (a) {
	return {$: 74, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Msg = function (a) {
	return {$: 74, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__Model = function (a) {
	return {$: 75, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__Msg = function (a) {
	return {$: 75, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Model = function (a) {
	return {$: 304, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Msg = function (a) {
	return {$: 304, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Model = function (a) {
	return {$: 279, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Msg = function (a) {
	return {$: 279, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Model = function (a) {
	return {$: 245, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Msg = function (a) {
	return {$: 245, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Model = function (a) {
	return {$: 280, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Msg = function (a) {
	return {$: 280, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Model = function (a) {
	return {$: 187, a: a};
};
var $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Msg = function (a) {
	return {$: 187, a: a};
};
var $author$project$Spa$Generated$Pages$NotFound__Model = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Generated$Pages$NotFound__Msg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Generated$Pages$Oauth__Callback__Model = function (a) {
	return {$: 76, a: a};
};
var $author$project$Spa$Generated$Pages$Oauth__Callback__Msg = function (a) {
	return {$: 76, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Model = function (a) {
	return {$: 188, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Msg = function (a) {
	return {$: 188, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Model = function (a) {
	return {$: 246, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Msg = function (a) {
	return {$: 246, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Model = function (a) {
	return {$: 247, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Msg = function (a) {
	return {$: 247, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Model = function (a) {
	return {$: 248, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Msg = function (a) {
	return {$: 248, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Model = function (a) {
	return {$: 249, a: a};
};
var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Msg = function (a) {
	return {$: 249, a: a};
};
var $author$project$Spa$Generated$Pages$Onboarding__Model = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Generated$Pages$Onboarding__Msg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__ApiKeys__Model = function (a) {
	return {$: 77, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__ApiKeys__Msg = function (a) {
	return {$: 77, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Model = function (a) {
	return {$: 250, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Msg = function (a) {
	return {$: 250, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Model = function (a) {
	return {$: 78, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Billing__Msg = function (a) {
	return {$: 78, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Model = function (a) {
	return {$: 189, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Msg = function (a) {
	return {$: 189, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Engagements__Model = function (a) {
	return {$: 79, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Engagements__Msg = function (a) {
	return {$: 79, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Hinter__Model = function (a) {
	return {$: 80, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Hinter__Msg = function (a) {
	return {$: 80, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Practices__Top__Model = function (a) {
	return {$: 190, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Practices__Top__Msg = function (a) {
	return {$: 190, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__ActivationSettings__Model = function (a) {
	return {$: 251, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__ActivationSettings__Msg = function (a) {
	return {$: 251, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__AppSettings__Model = function (a) {
	return {$: 252, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__AppSettings__Msg = function (a) {
	return {$: 252, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__Hinter__Model = function (a) {
	return {$: 253, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__Hinter__Msg = function (a) {
	return {$: 253, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__Model = function (a) {
	return {$: 81, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__Msg = function (a) {
	return {$: 81, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__New__Model = function (a) {
	return {$: 254, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Product__New__Msg = function (a) {
	return {$: 254, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Model = function (a) {
	return {$: 191, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Msg = function (a) {
	return {$: 191, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Team__Model = function (a) {
	return {$: 82, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__Team__Msg = function (a) {
	return {$: 82, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__WebhookEndpoints__Model = function (a) {
	return {$: 83, a: a};
};
var $author$project$Spa$Generated$Pages$Partner__WebhookEndpoints__Msg = function (a) {
	return {$: 83, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Create__Model = function (a) {
	return {$: 84, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Create__Msg = function (a) {
	return {$: 84, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Model = function (a) {
	return {$: 289, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Msg = function (a) {
	return {$: 289, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Model = function (a) {
	return {$: 290, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Msg = function (a) {
	return {$: 290, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Model = function (a) {
	return {$: 314, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Msg = function (a) {
	return {$: 314, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Model = function (a) {
	return {$: 315, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Msg = function (a) {
	return {$: 315, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Model = function (a) {
	return {$: 291, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Msg = function (a) {
	return {$: 291, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Model = function (a) {
	return {$: 255, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Msg = function (a) {
	return {$: 255, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Model = function (a) {
	return {$: 256, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Msg = function (a) {
	return {$: 256, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Model = function (a) {
	return {$: 257, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Msg = function (a) {
	return {$: 257, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Model = function (a) {
	return {$: 316, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Msg = function (a) {
	return {$: 316, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Model = function (a) {
	return {$: 305, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Msg = function (a) {
	return {$: 305, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Model = function (a) {
	return {$: 292, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Msg = function (a) {
	return {$: 292, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Model = function (a) {
	return {$: 258, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Msg = function (a) {
	return {$: 258, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Model = function (a) {
	return {$: 293, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Msg = function (a) {
	return {$: 293, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Model = function (a) {
	return {$: 294, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Msg = function (a) {
	return {$: 294, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Model = function (a) {
	return {$: 192, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Msg = function (a) {
	return {$: 192, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Top__Model = function (a) {
	return {$: 15, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Top__Msg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Upload__Model = function (a) {
	return {$: 85, a: a};
};
var $author$project$Spa$Generated$Pages$Patients__Upload__Msg = function (a) {
	return {$: 85, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Account__Model = function (a) {
	return {$: 86, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Account__Msg = function (a) {
	return {$: 86, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Model = function (a) {
	return {$: 87, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Msg = function (a) {
	return {$: 87, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Model = function (a) {
	return {$: 88, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Msg = function (a) {
	return {$: 88, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Model = function (a) {
	return {$: 89, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Msg = function (a) {
	return {$: 89, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Model = function (a) {
	return {$: 90, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Msg = function (a) {
	return {$: 90, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Model = function (a) {
	return {$: 91, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Msg = function (a) {
	return {$: 91, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Model = function (a) {
	return {$: 306, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Msg = function (a) {
	return {$: 306, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Model = function (a) {
	return {$: 92, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Msg = function (a) {
	return {$: 92, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Model = function (a) {
	return {$: 259, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Msg = function (a) {
	return {$: 259, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Team__Model = function (a) {
	return {$: 93, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Team__Msg = function (a) {
	return {$: 93, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Top__Model = function (a) {
	return {$: 16, a: a};
};
var $author$project$Spa$Generated$Pages$PracticeSetup__Top__Msg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Model = function (a) {
	return {$: 281, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Msg = function (a) {
	return {$: 281, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Model = function (a) {
	return {$: 193, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Msg = function (a) {
	return {$: 193, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Model = function (a) {
	return {$: 94, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Msg = function (a) {
	return {$: 94, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Model = function (a) {
	return {$: 95, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Msg = function (a) {
	return {$: 95, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Model = function (a) {
	return {$: 260, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Msg = function (a) {
	return {$: 260, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Model = function (a) {
	return {$: 96, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Msg = function (a) {
	return {$: 96, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Model = function (a) {
	return {$: 261, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Msg = function (a) {
	return {$: 261, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Model = function (a) {
	return {$: 282, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Msg = function (a) {
	return {$: 282, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Custom__New__Model = function (a) {
	return {$: 262, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Custom__New__Msg = function (a) {
	return {$: 262, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Dashboard__Model = function (a) {
	return {$: 97, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Dashboard__Msg = function (a) {
	return {$: 97, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Model = function (a) {
	return {$: 98, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Msg = function (a) {
	return {$: 98, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Model = function (a) {
	return {$: 263, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Msg = function (a) {
	return {$: 263, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Deposits__Model = function (a) {
	return {$: 99, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Deposits__Msg = function (a) {
	return {$: 99, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Disputes__Model = function (a) {
	return {$: 100, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Disputes__Msg = function (a) {
	return {$: 100, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Invoices__Model = function (a) {
	return {$: 101, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Invoices__Msg = function (a) {
	return {$: 101, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Memberships__Model = function (a) {
	return {$: 102, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Memberships__Msg = function (a) {
	return {$: 102, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Months__Model = function (a) {
	return {$: 103, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Months__Msg = function (a) {
	return {$: 103, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Model = function (a) {
	return {$: 104, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Msg = function (a) {
	return {$: 104, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Model = function (a) {
	return {$: 264, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Msg = function (a) {
	return {$: 264, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Revenue__Model = function (a) {
	return {$: 105, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Revenue__Msg = function (a) {
	return {$: 105, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Model = function (a) {
	return {$: 265, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Msg = function (a) {
	return {$: 265, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SalesTax__Model = function (a) {
	return {$: 106, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SalesTax__Msg = function (a) {
	return {$: 106, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Model = function (a) {
	return {$: 266, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Msg = function (a) {
	return {$: 266, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Model = function (a) {
	return {$: 107, a: a};
};
var $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Msg = function (a) {
	return {$: 107, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Model = function (a) {
	return {$: 108, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Msg = function (a) {
	return {$: 108, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Model = function (a) {
	return {$: 109, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Msg = function (a) {
	return {$: 109, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Alert__Model = function (a) {
	return {$: 110, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Alert__Msg = function (a) {
	return {$: 110, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Badge__Model = function (a) {
	return {$: 111, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Badge__Msg = function (a) {
	return {$: 111, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Button__Model = function (a) {
	return {$: 112, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Button__Msg = function (a) {
	return {$: 112, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Model = function (a) {
	return {$: 113, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Msg = function (a) {
	return {$: 113, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Model = function (a) {
	return {$: 114, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Msg = function (a) {
	return {$: 114, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Model = function (a) {
	return {$: 115, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Msg = function (a) {
	return {$: 115, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Model = function (a) {
	return {$: 116, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Msg = function (a) {
	return {$: 116, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Model = function (a) {
	return {$: 117, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Msg = function (a) {
	return {$: 117, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Model = function (a) {
	return {$: 118, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Msg = function (a) {
	return {$: 118, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Model = function (a) {
	return {$: 119, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Msg = function (a) {
	return {$: 119, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Model = function (a) {
	return {$: 120, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Msg = function (a) {
	return {$: 120, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FlexGrid__Model = function (a) {
	return {$: 121, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FlexGrid__Msg = function (a) {
	return {$: 121, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Model = function (a) {
	return {$: 122, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Msg = function (a) {
	return {$: 122, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Model = function (a) {
	return {$: 123, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Msg = function (a) {
	return {$: 123, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Model = function (a) {
	return {$: 124, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Msg = function (a) {
	return {$: 124, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Model = function (a) {
	return {$: 125, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Msg = function (a) {
	return {$: 125, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Model = function (a) {
	return {$: 126, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Msg = function (a) {
	return {$: 126, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Model = function (a) {
	return {$: 127, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Msg = function (a) {
	return {$: 127, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Icon__Model = function (a) {
	return {$: 128, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Icon__Msg = function (a) {
	return {$: 128, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Input__Model = function (a) {
	return {$: 129, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Input__Msg = function (a) {
	return {$: 129, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Link__Model = function (a) {
	return {$: 130, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Link__Msg = function (a) {
	return {$: 130, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Model = function (a) {
	return {$: 131, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Msg = function (a) {
	return {$: 131, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Modal__Model = function (a) {
	return {$: 132, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Modal__Msg = function (a) {
	return {$: 132, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Model = function (a) {
	return {$: 133, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Msg = function (a) {
	return {$: 133, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Panel__Model = function (a) {
	return {$: 134, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Panel__Msg = function (a) {
	return {$: 134, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Model = function (a) {
	return {$: 135, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Msg = function (a) {
	return {$: 135, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Model = function (a) {
	return {$: 136, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Msg = function (a) {
	return {$: 136, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Model = function (a) {
	return {$: 137, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Msg = function (a) {
	return {$: 137, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Popover__Model = function (a) {
	return {$: 138, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Popover__Msg = function (a) {
	return {$: 138, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Model = function (a) {
	return {$: 139, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Msg = function (a) {
	return {$: 139, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Model = function (a) {
	return {$: 140, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Msg = function (a) {
	return {$: 140, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Model = function (a) {
	return {$: 141, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Msg = function (a) {
	return {$: 141, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__SearchableSelect__Model = function (a) {
	return {$: 142, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__SearchableSelect__Msg = function (a) {
	return {$: 142, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Select__Model = function (a) {
	return {$: 143, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Select__Msg = function (a) {
	return {$: 143, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Model = function (a) {
	return {$: 144, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Msg = function (a) {
	return {$: 144, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__SvgIcon__Model = function (a) {
	return {$: 145, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__SvgIcon__Msg = function (a) {
	return {$: 145, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Table__Model = function (a) {
	return {$: 146, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Table__Msg = function (a) {
	return {$: 146, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Tabs__Model = function (a) {
	return {$: 147, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Tabs__Msg = function (a) {
	return {$: 147, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Toast__Model = function (a) {
	return {$: 148, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Toast__Msg = function (a) {
	return {$: 148, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Model = function (a) {
	return {$: 149, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Msg = function (a) {
	return {$: 149, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Model = function (a) {
	return {$: 150, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Msg = function (a) {
	return {$: 150, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Top__Model = function (a) {
	return {$: 17, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Top__Msg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Typography__Model = function (a) {
	return {$: 151, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Typography__Msg = function (a) {
	return {$: 151, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Model = function (a) {
	return {$: 152, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Msg = function (a) {
	return {$: 152, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Model = function (a) {
	return {$: 153, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Msg = function (a) {
	return {$: 153, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Well__Model = function (a) {
	return {$: 154, a: a};
};
var $author$project$Spa$Generated$Pages$StyleGuide__Well__Msg = function (a) {
	return {$: 154, a: a};
};
var $author$project$Spa$Generated$Pages$Support__CannySso__Model = function (a) {
	return {$: 155, a: a};
};
var $author$project$Spa$Generated$Pages$Support__CannySso__Msg = function (a) {
	return {$: 155, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__New__Model = function (a) {
	return {$: 156, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__New__Msg = function (a) {
	return {$: 156, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Model = function (a) {
	return {$: 194, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Msg = function (a) {
	return {$: 194, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__Top__Model = function (a) {
	return {$: 18, a: a};
};
var $author$project$Spa$Generated$Pages$Tasks__Top__Msg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Spa$Generated$Pages$Top__Model = function (a) {
	return {$: 0, a: a};
};
var $author$project$Spa$Generated$Pages$Top__Msg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Spa$Generated$Pages$User__AcceptTerms__Model = function (a) {
	return {$: 157, a: a};
};
var $author$project$Spa$Generated$Pages$User__AcceptTerms__Msg = function (a) {
	return {$: 157, a: a};
};
var $author$project$Spa$Generated$Pages$User__Mfa__Model = function (a) {
	return {$: 158, a: a};
};
var $author$project$Spa$Generated$Pages$User__Mfa__Msg = function (a) {
	return {$: 158, a: a};
};
var $author$project$Spa$Generated$Pages$User__Organizations__Top__Model = function (a) {
	return {$: 195, a: a};
};
var $author$project$Spa$Generated$Pages$User__Organizations__Top__Msg = function (a) {
	return {$: 195, a: a};
};
var $author$project$Spa$Generated$Pages$User__Profile__Model = function (a) {
	return {$: 159, a: a};
};
var $author$project$Spa$Generated$Pages$User__Profile__Msg = function (a) {
	return {$: 159, a: a};
};
var $author$project$Spa$Generated$Pages$User__Security__Model = function (a) {
	return {$: 160, a: a};
};
var $author$project$Spa$Generated$Pages$User__Security__Msg = function (a) {
	return {$: 160, a: a};
};
var $author$project$Spa$Page$SessionFailed = {$: 2};
var $author$project$Spa$Page$SessionLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Spa$Page$SessionLoading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Permission$User = 7;
var $author$project$Permission$Company__Account = 18;
var $author$project$Permission$Company__AffiliatesPricing = 23;
var $author$project$Permission$Company__Employees = 19;
var $author$project$Permission$Company__Invoice = 20;
var $author$project$Permission$Company__Invoices = 21;
var $author$project$Permission$Company__One = 22;
var $author$project$Permission$Company__PaymentSources = 24;
var $author$project$Permission$Company__Signup = 26;
var $author$project$Permission$Company__Uploads = 25;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Permission$companySessionCanGoTo = function (state) {
	var allowedStates = _List_fromArray(
		[18, 19, 20, 21, 22, 23, 24, 25, 26]);
	return A2($elm$core$List$member, state, allowedStates);
};
var $author$project$Api$Platform$User$Shared$isAdmin = function (_v0) {
	var record = _v0;
	return record.Ru;
};
var $author$project$Permission$Hinter__AdminAdminUsersGroup = 14;
var $author$project$Permission$Hinter__AdminAdminUsersGroups = 13;
var $author$project$Permission$Hinter__AdminClonePractice = 9;
var $author$project$Permission$Hinter__AdminDisputes = 12;
var $author$project$Permission$Hinter__AdminFeatureFlags = 15;
var $author$project$Permission$Hinter__AdminNewGroup = 11;
var $author$project$Permission$Hinter__AdminNewPartner = 10;
var $author$project$Permission$Hinter__AdminNewPractice = 8;
var $author$project$Permission$Marketplace__List = 56;
var $author$project$Permission$Marketplace__Slug_String = 57;
var $author$project$Permission$Partner__Billing__Hinter = 33;
var $author$project$Permission$Partner__Hinter = 32;
var $author$project$Permission$Partner__Product__Hinter = 36;
var $author$project$Permission$onlyHintersStates = _List_fromArray(
	[8, 9, 12, 13, 14, 15, 10, 11, 36, 33, 32, 56, 57]);
var $author$project$Api$Platform$Session$One$organization = function (_v0) {
	var record = _v0;
	return record.Vd;
};
var $author$project$Permission$Partner__ApiKeys = 39;
var $author$project$Permission$Partner__Billing = 34;
var $author$project$Permission$Partner__Practices = 41;
var $author$project$Permission$Partner__Product = 31;
var $author$project$Permission$Partner__Product_AppSettings = 42;
var $author$project$Permission$Partner__Product__ActivationSettings = 35;
var $author$project$Permission$Partner__Product__New = 38;
var $author$project$Permission$Partner__Products = 37;
var $author$project$Permission$Partner__Sandboxes = 43;
var $author$project$Permission$Partner__Team = 30;
var $author$project$Permission$Partner__WebhookEndpoints = 40;
var $author$project$Permission$partnerSessionCanGoTo = function (state) {
	var allowedStates = _List_fromArray(
		[30, 31, 32, 35, 36, 37, 38, 39, 40, 41, 42, 43, 33, 34, 57]);
	return A2($elm$core$List$member, state, allowedStates);
};
var $author$project$Permission$Admin__PaymentProcessing = 3;
var $author$project$Permission$Admin__Stripe = 6;
var $author$project$Permission$Onboarding = 51;
var $author$project$Permission$PracticeIsOnboarding = 52;
var $author$project$Api$Common$PermissionSet$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ot;
};
var $author$project$Api$Platform$Session$One$permissionSets = function (_v0) {
	var record = _v0;
	return record.Wf;
};
var $author$project$Permission$enabledPermissionSetsFor = function (session) {
	return A2(
		$elm$core$List$filter,
		$author$project$Api$Common$PermissionSet$Shared$enabled,
		$author$project$Api$Platform$Session$One$permissionSets(session));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Common$PermissionSet$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Platform$Organization$Shared$onboarded = function (_v0) {
	var record = _v0.b;
	return record.U5;
};
var $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding = function (_v0) {
	var record = _v0.b;
	return record.WI;
};
var $author$project$Permission$patientsPermission = {zh: 'view_patients'};
var $author$project$Permission$requiredPermissionSetFor = function (state) {
	switch (state) {
		case 44:
			return $elm$core$Maybe$Just($author$project$Permission$patientsPermission);
		case 45:
			return $elm$core$Maybe$Just(
				{zh: 'view_reports'});
		case 16:
			return $elm$core$Maybe$Just(
				{zh: 'manage_employers'});
		case 0:
			return $elm$core$Maybe$Just(
				{zh: 'change_admin_settings'});
		case 46:
			return $elm$core$Maybe$Just(
				{zh: 'manage_commissions'});
		case 1:
			return $elm$core$Maybe$Just(
				{zh: 'practice_billing_only'});
		case 2:
			return $elm$core$Maybe$Just(
				{zh: 'practice_billing_only'});
		case 3:
			return $elm$core$Maybe$Just(
				{zh: 'practice_billing_only'});
		case 4:
			return $elm$core$Maybe$Just(
				{zh: 'practice_billing_only'});
		case 5:
			return $elm$core$Maybe$Just(
				{zh: 'practice_billing_only'});
		case 6:
			return $elm$core$Maybe$Just(
				{zh: 'change_admin_settings'});
		case 48:
			return $elm$core$Maybe$Just(
				{zh: 'revise_invoices'});
		case 50:
			return $elm$core$Maybe$Just(
				{zh: 'manage_networks'});
		case 49:
			return $elm$core$Maybe$Just(
				{zh: 'issue_refunds'});
		case 7:
			return $elm$core$Maybe$Nothing;
		case 8:
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Nothing;
		case 14:
			return $elm$core$Maybe$Nothing;
		case 15:
			return $elm$core$Maybe$Nothing;
		case 17:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Nothing;
		case 19:
			return $elm$core$Maybe$Nothing;
		case 20:
			return $elm$core$Maybe$Nothing;
		case 21:
			return $elm$core$Maybe$Nothing;
		case 22:
			return $elm$core$Maybe$Nothing;
		case 23:
			return $elm$core$Maybe$Nothing;
		case 24:
			return $elm$core$Maybe$Nothing;
		case 25:
			return $elm$core$Maybe$Nothing;
		case 26:
			return $elm$core$Maybe$Nothing;
		case 27:
			return $elm$core$Maybe$Nothing;
		case 28:
			return $elm$core$Maybe$Nothing;
		case 29:
			return $elm$core$Maybe$Nothing;
		case 47:
			return $elm$core$Maybe$Nothing;
		case 51:
			return $elm$core$Maybe$Nothing;
		case 52:
			return $elm$core$Maybe$Nothing;
		case 53:
			return $elm$core$Maybe$Nothing;
		case 54:
			return $elm$core$Maybe$Nothing;
		case 30:
			return $elm$core$Maybe$Nothing;
		case 31:
			return $elm$core$Maybe$Nothing;
		case 32:
			return $elm$core$Maybe$Nothing;
		case 35:
			return $elm$core$Maybe$Nothing;
		case 36:
			return $elm$core$Maybe$Nothing;
		case 37:
			return $elm$core$Maybe$Nothing;
		case 38:
			return $elm$core$Maybe$Nothing;
		case 39:
			return $elm$core$Maybe$Nothing;
		case 40:
			return $elm$core$Maybe$Nothing;
		case 41:
			return $elm$core$Maybe$Nothing;
		case 42:
			return $elm$core$Maybe$Nothing;
		case 43:
			return $elm$core$Maybe$Nothing;
		case 33:
			return $elm$core$Maybe$Nothing;
		case 34:
			return $elm$core$Maybe$Nothing;
		case 55:
			return $elm$core$Maybe$Nothing;
		case 56:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Permission$Accounting = 53;
var $author$project$Permission$Admin = 0;
var $author$project$Permission$BrokerAccounts = 47;
var $author$project$Permission$ClinicalApp = 55;
var $author$project$Permission$Commissions = 46;
var $author$project$Permission$Companies = 16;
var $author$project$Permission$Company = 17;
var $author$project$Permission$IssueRefunds = 49;
var $author$project$Permission$Network = 50;
var $author$project$Permission$PartnerApp = 54;
var $author$project$Permission$Patients = 44;
var $author$project$Permission$Reports = 45;
var $author$project$Permission$ReviseInvoices = 48;
var $author$project$Permission$topLevelStateFor = function (state) {
	switch (state) {
		case 44:
			return 44;
		case 45:
			return 45;
		case 0:
			return 0;
		case 46:
			return 46;
		case 47:
			return 47;
		case 1:
			return 0;
		case 2:
			return 0;
		case 3:
			return 0;
		case 4:
			return 0;
		case 5:
			return 0;
		case 6:
			return 0;
		case 48:
			return 48;
		case 50:
			return 50;
		case 49:
			return 49;
		case 7:
			return 7;
		case 8:
			return 7;
		case 9:
			return 7;
		case 10:
			return 7;
		case 11:
			return 7;
		case 12:
			return 7;
		case 13:
			return 7;
		case 14:
			return 7;
		case 15:
			return 7;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 17;
		case 19:
			return 17;
		case 20:
			return 17;
		case 21:
			return 17;
		case 22:
			return 17;
		case 23:
			return 17;
		case 24:
			return 17;
		case 25:
			return 17;
		case 26:
			return 17;
		case 27:
			return 17;
		case 28:
			return 17;
		case 29:
			return 17;
		case 51:
			return 51;
		case 52:
			return 52;
		case 53:
			return 53;
		case 54:
			return 54;
		case 30:
			return 41;
		case 31:
			return 41;
		case 32:
			return 32;
		case 35:
			return 31;
		case 36:
			return 31;
		case 37:
			return 41;
		case 38:
			return 31;
		case 39:
			return 41;
		case 40:
			return 41;
		case 41:
			return 41;
		case 42:
			return 42;
		case 43:
			return 43;
		case 33:
			return 34;
		case 34:
			return 34;
		case 55:
			return 55;
		case 56:
			return 56;
		default:
			return 56;
	}
};
var $author$project$Api$Platform$Session$One$user = function (_v0) {
	var record = _v0;
	return record.aaz;
};
var $author$project$Utils$User$viewingAsNonHinter = F2(
	function (session, hinterViewOff) {
		return (!A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session)) || hinterViewOff;
	});
var $author$project$Permission$practiceSessionCanGoTo = F3(
	function (session, hinterViewOff, state) {
		if ((!A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Platform$Organization$Shared$onboarded,
				$author$project$Api$Platform$Session$One$organization(session)))) && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff)) {
			return state === 51;
		} else {
			if (function () {
				var practiceIsOnboarding = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Platform$Organization$Shared$practiceIsOnboarding,
						$author$project$Api$Platform$Session$One$organization(session)));
				return practiceIsOnboarding && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff);
			}()) {
				return (state === 52) || ((state === 6) || (state === 3));
			} else {
				var topLevelState = $author$project$Permission$topLevelStateFor(state);
				var enabledPermissionSets = $author$project$Permission$enabledPermissionSetsFor(session);
				var currentPermissionSet = function () {
					var _v1 = _Utils_Tuple2(
						$author$project$Permission$requiredPermissionSetFor(state),
						$author$project$Permission$requiredPermissionSetFor(topLevelState));
					if (!_v1.a.$) {
						var permissionSet = _v1.a.a;
						return $elm$core$Maybe$Just(permissionSet);
					} else {
						if (!_v1.b.$) {
							var _v2 = _v1.a;
							var permissionSet = _v1.b.a;
							return $elm$core$Maybe$Just(permissionSet);
						} else {
							var _v3 = _v1.a;
							var _v4 = _v1.b;
							return $elm$core$Maybe$Nothing;
						}
					}
				}();
				if (currentPermissionSet.$ === 1) {
					return !$elm$core$List$isEmpty(enabledPermissionSets);
				} else {
					var currentPermissionSet_ = currentPermissionSet.a;
					return A2(
						$elm$core$List$any,
						function (permissionSet) {
							return _Utils_eq(
								$author$project$Api$Common$PermissionSet$Shared$name(permissionSet),
								currentPermissionSet_.zh);
						},
						enabledPermissionSets);
				}
			}
		}
	});
var $author$project$Api$Platform$Organization$Min$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Platform$Organization$Shared$type_ = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Organization$Min$type_(min);
};
var $author$project$Permission$canGoTo = F3(
	function (session, hinterViewOff, state) {
		if (A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session) && A2($elm$core$List$member, state, $author$project$Permission$onlyHintersStates)) {
			return true;
		} else {
			if (state === 7) {
				return true;
			} else {
				var _v0 = $author$project$Api$Platform$Session$One$organization(session);
				if (_v0.$ === 1) {
					return false;
				} else {
					var organization = _v0.a;
					var _v1 = $author$project$Api$Platform$Organization$Shared$type_(organization);
					switch (_v1) {
						case 1:
							return $author$project$Permission$companySessionCanGoTo(state);
						case 0:
							return A3($author$project$Permission$practiceSessionCanGoTo, session, hinterViewOff, state);
						default:
							return $author$project$Permission$partnerSessionCanGoTo(state);
					}
				}
			}
		}
	});
var $author$project$Permission$Admin__Billing = 1;
var $author$project$Permission$Admin__PaymentMethodImport = 4;
var $author$project$Permission$Admin__PaymentMethodImport__Upload = 5;
var $author$project$Permission$Admin__PaymentSources = 2;
var $author$project$Permission$Company__EndedCommissions = 29;
var $author$project$Permission$Company__Notes = 27;
var $author$project$Permission$Company__Notifications = 28;
var $author$project$Permission$forRoute = function (route) {
	switch (route.$) {
		case 196:
			return $elm$core$Maybe$Just(0);
		case 197:
			return $elm$core$Maybe$Just(0);
		case 198:
			return $elm$core$Maybe$Just(0);
		case 199:
			return $elm$core$Maybe$Just(0);
		case 200:
			return $elm$core$Maybe$Just(0);
		case 165:
			return $elm$core$Maybe$Just(0);
		case 307:
			return $elm$core$Maybe$Just(1);
		case 267:
			return $elm$core$Maybe$Just(0);
		case 201:
			return $elm$core$Maybe$Just(0);
		case 166:
			return $elm$core$Maybe$Just(0);
		case 202:
			return $elm$core$Maybe$Just(0);
		case 268:
			return $elm$core$Maybe$Just(0);
		case 203:
			return $elm$core$Maybe$Just(0);
		case 167:
			return $elm$core$Maybe$Just(0);
		case 269:
			return $elm$core$Maybe$Just(0);
		case 204:
			return $elm$core$Maybe$Just(0);
		case 168:
			return $elm$core$Maybe$Just(0);
		case 205:
			return $elm$core$Maybe$Just(0);
		case 272:
			return $elm$core$Maybe$Just(0);
		case 211:
			return $elm$core$Maybe$Just(0);
		case 171:
			return $elm$core$Maybe$Just(0);
		case 212:
			return $elm$core$Maybe$Just(0);
		case 213:
			return $elm$core$Maybe$Just(0);
		case 214:
			return $elm$core$Maybe$Just(0);
		case 172:
			return $elm$core$Maybe$Just(0);
		case 273:
			return $elm$core$Maybe$Just(0);
		case 215:
			return $elm$core$Maybe$Just(0);
		case 216:
			return $elm$core$Maybe$Just(0);
		case 217:
			return $elm$core$Maybe$Just(0);
		case 218:
			return $elm$core$Maybe$Just(0);
		case 219:
			return $elm$core$Maybe$Just(0);
		case 220:
			return $elm$core$Maybe$Just(0);
		case 295:
			return $elm$core$Maybe$Just(0);
		case 274:
			return $elm$core$Maybe$Just(0);
		case 222:
			return $elm$core$Maybe$Just(0);
		case 173:
			return $elm$core$Maybe$Just(0);
		case 174:
			return $elm$core$Maybe$Just(0);
		case 223:
			return $elm$core$Maybe$Just(0);
		case 175:
			return $elm$core$Maybe$Just(0);
		case 275:
			return $elm$core$Maybe$Just(0);
		case 224:
			return $elm$core$Maybe$Just(0);
		case 176:
			return $elm$core$Maybe$Just(0);
		case 19:
			return $elm$core$Maybe$Just(0);
		case 20:
			return $elm$core$Maybe$Just(1);
		case 21:
			return $elm$core$Maybe$Just(0);
		case 22:
			return $elm$core$Maybe$Just(0);
		case 23:
			return $elm$core$Maybe$Just(0);
		case 24:
			return $elm$core$Maybe$Just(0);
		case 25:
			return $elm$core$Maybe$Just(0);
		case 26:
			return $elm$core$Maybe$Just(0);
		case 27:
			return $elm$core$Maybe$Just(0);
		case 28:
			return $elm$core$Maybe$Just(0);
		case 30:
			return $elm$core$Maybe$Just(0);
		case 29:
			return $elm$core$Maybe$Just(0);
		case 31:
			return $elm$core$Maybe$Just(0);
		case 32:
			return $elm$core$Maybe$Just(0);
		case 33:
			return $elm$core$Maybe$Just(0);
		case 34:
			return $elm$core$Maybe$Just(0);
		case 35:
			return $elm$core$Maybe$Just(0);
		case 36:
			return $elm$core$Maybe$Just(0);
		case 39:
			return $elm$core$Maybe$Just(2);
		case 38:
			return $elm$core$Maybe$Just(3);
		case 37:
			return $elm$core$Maybe$Just(4);
		case 221:
			return $elm$core$Maybe$Just(5);
		case 40:
			return $elm$core$Maybe$Just(0);
		case 41:
			return $elm$core$Maybe$Just(0);
		case 42:
			return $elm$core$Maybe$Just(0);
		case 43:
			return $elm$core$Maybe$Just(0);
		case 170:
			return $elm$core$Maybe$Just(0);
		case 206:
			return $elm$core$Maybe$Just(0);
		case 271:
			return $elm$core$Maybe$Just(0);
		case 169:
			return $elm$core$Maybe$Just(0);
		case 270:
			return $elm$core$Maybe$Just(0);
		case 207:
			return $elm$core$Maybe$Just(0);
		case 208:
			return $elm$core$Maybe$Just(0);
		case 210:
			return $elm$core$Maybe$Just(0);
		case 209:
			return $elm$core$Maybe$Just(0);
		case 44:
			return $elm$core$Maybe$Just(0);
		case 45:
			return $elm$core$Maybe$Just(6);
		case 46:
			return $elm$core$Maybe$Just(0);
		case 47:
			return $elm$core$Maybe$Just(0);
		case 225:
			return $elm$core$Maybe$Just(0);
		case 74:
			return $elm$core$Maybe$Just(55);
		case 75:
			return $elm$core$Maybe$Just(55);
		case 279:
			return $elm$core$Maybe$Just(55);
		case 304:
			return $elm$core$Maybe$Just(55);
		case 72:
			return $elm$core$Maybe$Just(55);
		case 1:
			return $elm$core$Maybe$Just(0);
		case 61:
			return $elm$core$Maybe$Just(8);
		case 56:
			return $elm$core$Maybe$Just(9);
		case 60:
			return $elm$core$Maybe$Just(10);
		case 59:
			return $elm$core$Maybe$Just(11);
		case 57:
			return $elm$core$Maybe$Just(12);
		case 58:
			return $elm$core$Maybe$Just(15);
		case 181:
			return $elm$core$Maybe$Just(13);
		case 276:
			return $elm$core$Maybe$Just(14);
		case 159:
			return $elm$core$Maybe$Just(7);
		case 158:
			return $elm$core$Maybe$Just(7);
		case 160:
			return $elm$core$Maybe$Just(7);
		case 195:
			return $elm$core$Maybe$Just(7);
		case 157:
			return $elm$core$Maybe$Just(7);
		case 102:
			return $elm$core$Maybe$Just(45);
		case 107:
			return $elm$core$Maybe$Just(45);
		case 97:
			return $elm$core$Maybe$Just(45);
		case 103:
			return $elm$core$Maybe$Just(45);
		case 106:
			return $elm$core$Maybe$Just(45);
		case 266:
			return $elm$core$Maybe$Just(45);
		case 193:
			return $elm$core$Maybe$Just(45);
		case 281:
			return $elm$core$Maybe$Just(45);
		case 99:
			return $elm$core$Maybe$Just(45);
		case 94:
			return $elm$core$Maybe$Just(45);
		case 101:
			return $elm$core$Maybe$Just(45);
		case 95:
			return $elm$core$Maybe$Just(45);
		case 260:
			return $elm$core$Maybe$Just(45);
		case 96:
			return $elm$core$Maybe$Just(45);
		case 261:
			return $elm$core$Maybe$Just(45);
		case 104:
			return $elm$core$Maybe$Just(45);
		case 264:
			return $elm$core$Maybe$Just(45);
		case 105:
			return $elm$core$Maybe$Just(45);
		case 265:
			return $elm$core$Maybe$Just(45);
		case 98:
			return $elm$core$Maybe$Just(45);
		case 263:
			return $elm$core$Maybe$Just(45);
		case 282:
			return $elm$core$Maybe$Just(45);
		case 100:
			return $elm$core$Maybe$Just(45);
		case 52:
			return $elm$core$Maybe$Just(16);
		case 12:
			return $elm$core$Maybe$Just(16);
		case 179:
			return $elm$core$Maybe$Just(22);
		case 236:
			return $elm$core$Maybe$Just(29);
		case 234:
			return $elm$core$Maybe$Just(23);
		case 286:
			return $elm$core$Maybe$Just(21);
		case 309:
			return $elm$core$Maybe$Just(21);
		case 238:
			return $elm$core$Maybe$Just(27);
		case 239:
			return $elm$core$Maybe$Just(28);
		case 237:
			return $elm$core$Maybe$Just(0);
		case 285:
			return $elm$core$Maybe$Just(19);
		case 298:
			return $elm$core$Maybe$Just(19);
		case 324:
			return $elm$core$Maybe$Just(19);
		case 240:
			return $elm$core$Maybe$Just(24);
		case 287:
			return $elm$core$Maybe$Just(25);
		case 313:
			return $elm$core$Maybe$Just(25);
		case 235:
			return $elm$core$Maybe$Just(25);
		case 320:
			return $elm$core$Maybe$Just(25);
		case 241:
			return $elm$core$Maybe$Just(26);
		case 299:
			return $elm$core$Maybe$Just(26);
		case 310:
			return $elm$core$Maybe$Just(26);
		case 51:
			return $elm$core$Maybe$Just(46);
		case 178:
			return $elm$core$Maybe$Just(46);
		case 233:
			return $elm$core$Maybe$Just(46);
		case 177:
			return $elm$core$Maybe$Just(46);
		case 232:
			return $elm$core$Maybe$Just(46);
		case 284:
			return $elm$core$Maybe$Just(47);
		case 296:
			return $elm$core$Maybe$Just(47);
		case 297:
			return $elm$core$Maybe$Just(47);
		case 311:
			return $elm$core$Maybe$Just(47);
		case 319:
			return $elm$core$Maybe$Just(47);
		case 323:
			return $elm$core$Maybe$Just(47);
		case 318:
			return $elm$core$Maybe$Just(47);
		case 312:
			return $elm$core$Maybe$Just(47);
		case 322:
			return $elm$core$Maybe$Just(47);
		case 11:
			return $elm$core$Maybe$Just(50);
		case 49:
			return $elm$core$Maybe$Just(50);
		case 48:
			return $elm$core$Maybe$Just(50);
		case 226:
			return $elm$core$Maybe$Just(0);
		case 227:
			return $elm$core$Maybe$Just(50);
		case 283:
			return $elm$core$Maybe$Just(50);
		case 308:
			return $elm$core$Maybe$Just(50);
		case 228:
			return $elm$core$Maybe$Just(50);
		case 230:
			return $elm$core$Maybe$Just(50);
		case 229:
			return $elm$core$Maybe$Just(50);
		case 231:
			return $elm$core$Maybe$Just(50);
		case 10:
			return $elm$core$Maybe$Just(50);
		case 163:
			return $elm$core$Maybe$Nothing;
		case 7:
			return $elm$core$Maybe$Nothing;
		case 76:
			return $elm$core$Maybe$Nothing;
		case 155:
			return $elm$core$Maybe$Nothing;
		case 162:
			return $elm$core$Maybe$Nothing;
		case 6:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 8:
			return $elm$core$Maybe$Nothing;
		case 15:
			return $elm$core$Maybe$Just(44);
		case 84:
			return $elm$core$Maybe$Just(44);
		case 85:
			return $elm$core$Maybe$Just(44);
		case 192:
			return $elm$core$Maybe$Just(44);
		case 256:
			return $elm$core$Maybe$Just(44);
		case 258:
			return $elm$core$Maybe$Just(44);
		case 289:
			return $elm$core$Maybe$Just(44);
		case 257:
			return $elm$core$Maybe$Just(44);
		case 314:
			return $elm$core$Maybe$Just(44);
		case 255:
			return $elm$core$Maybe$Just(55);
		case 291:
			return $elm$core$Maybe$Just(44);
		case 315:
			return $elm$core$Maybe$Just(44);
		case 292:
			return $elm$core$Maybe$Just(44);
		case 305:
			return $elm$core$Maybe$Just(44);
		case 316:
			return $elm$core$Maybe$Just(44);
		case 293:
			return $elm$core$Maybe$Just(44);
		case 290:
			return $elm$core$Maybe$Just(44);
		case 294:
			return $elm$core$Maybe$Just(44);
		case 50:
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Just(51);
		case 82:
			return $elm$core$Maybe$Just(30);
		case 81:
			return $elm$core$Maybe$Just(31);
		case 77:
			return $elm$core$Maybe$Just(39);
		case 83:
			return $elm$core$Maybe$Just(40);
		case 190:
			return $elm$core$Maybe$Just(41);
		case 80:
			return $elm$core$Maybe$Just(32);
		case 250:
			return $elm$core$Maybe$Just(33);
		case 78:
			return $elm$core$Maybe$Just(34);
		case 251:
			return $elm$core$Maybe$Just(35);
		case 253:
			return $elm$core$Maybe$Just(36);
		case 189:
			return $elm$core$Maybe$Just(37);
		case 254:
			return $elm$core$Maybe$Just(38);
		case 252:
			return $elm$core$Maybe$Just(42);
		case 191:
			return $elm$core$Maybe$Just(43);
		case 79:
			return $elm$core$Maybe$Just(41);
		case 17:
			return $elm$core$Maybe$Nothing;
		case 108:
			return $elm$core$Maybe$Nothing;
		case 112:
			return $elm$core$Maybe$Nothing;
		case 154:
			return $elm$core$Maybe$Nothing;
		case 127:
			return $elm$core$Maybe$Nothing;
		case 128:
			return $elm$core$Maybe$Nothing;
		case 145:
			return $elm$core$Maybe$Nothing;
		case 130:
			return $elm$core$Maybe$Nothing;
		case 146:
			return $elm$core$Maybe$Nothing;
		case 134:
			return $elm$core$Maybe$Nothing;
		case 149:
			return $elm$core$Maybe$Nothing;
		case 151:
			return $elm$core$Maybe$Nothing;
		case 148:
			return $elm$core$Maybe$Nothing;
		case 147:
			return $elm$core$Maybe$Nothing;
		case 110:
			return $elm$core$Maybe$Nothing;
		case 139:
			return $elm$core$Maybe$Nothing;
		case 114:
			return $elm$core$Maybe$Nothing;
		case 129:
			return $elm$core$Maybe$Nothing;
		case 133:
			return $elm$core$Maybe$Nothing;
		case 124:
			return $elm$core$Maybe$Nothing;
		case 123:
			return $elm$core$Maybe$Nothing;
		case 137:
			return $elm$core$Maybe$Nothing;
		case 132:
			return $elm$core$Maybe$Nothing;
		case 126:
			return $elm$core$Maybe$Nothing;
		case 111:
			return $elm$core$Maybe$Nothing;
		case 150:
			return $elm$core$Maybe$Nothing;
		case 122:
			return $elm$core$Maybe$Nothing;
		case 138:
			return $elm$core$Maybe$Nothing;
		case 119:
			return $elm$core$Maybe$Nothing;
		case 131:
			return $elm$core$Maybe$Nothing;
		case 135:
			return $elm$core$Maybe$Nothing;
		case 125:
			return $elm$core$Maybe$Nothing;
		case 117:
			return $elm$core$Maybe$Nothing;
		case 136:
			return $elm$core$Maybe$Nothing;
		case 153:
			return $elm$core$Maybe$Nothing;
		case 120:
			return $elm$core$Maybe$Nothing;
		case 152:
			return $elm$core$Maybe$Nothing;
		case 142:
			return $elm$core$Maybe$Nothing;
		case 140:
			return $elm$core$Maybe$Nothing;
		case 115:
			return $elm$core$Maybe$Nothing;
		case 143:
			return $elm$core$Maybe$Nothing;
		case 116:
			return $elm$core$Maybe$Nothing;
		case 141:
			return $elm$core$Maybe$Nothing;
		case 109:
			return $elm$core$Maybe$Nothing;
		case 121:
			return $elm$core$Maybe$Nothing;
		case 144:
			return $elm$core$Maybe$Nothing;
		case 188:
			return $elm$core$Maybe$Nothing;
		case 248:
			return $elm$core$Maybe$Nothing;
		case 249:
			return $elm$core$Maybe$Nothing;
		case 247:
			return $elm$core$Maybe$Nothing;
		case 246:
			return $elm$core$Maybe$Nothing;
		case 16:
			return $elm$core$Maybe$Just(52);
		case 86:
			return $elm$core$Maybe$Just(52);
		case 92:
			return $elm$core$Maybe$Just(52);
		case 259:
			return $elm$core$Maybe$Just(52);
		case 306:
			return $elm$core$Maybe$Just(52);
		case 89:
			return $elm$core$Maybe$Just(52);
		case 91:
			return $elm$core$Maybe$Just(52);
		case 88:
			return $elm$core$Maybe$Just(52);
		case 93:
			return $elm$core$Maybe$Just(52);
		case 87:
			return $elm$core$Maybe$Just(52);
		case 90:
			return $elm$core$Maybe$Just(52);
		case 262:
			return $elm$core$Maybe$Just(0);
		case 118:
			return $elm$core$Maybe$Nothing;
		case 113:
			return $elm$core$Maybe$Nothing;
		case 317:
			return $elm$core$Maybe$Just(0);
		case 321:
			return $elm$core$Maybe$Just(0);
		case 161:
			return $elm$core$Maybe$Just(54);
		case 14:
			return $elm$core$Maybe$Just(56);
		case 164:
			return $elm$core$Maybe$Just(57);
		case 301:
			return $elm$core$Maybe$Just(0);
		case 303:
			return $elm$core$Maybe$Just(0);
		case 302:
			return $elm$core$Maybe$Just(0);
		case 300:
			return $elm$core$Maybe$Just(0);
		case 65:
			return $elm$core$Maybe$Just(0);
		case 3:
			return $elm$core$Maybe$Just(55);
		case 5:
			return $elm$core$Maybe$Just(55);
		case 53:
			return $elm$core$Maybe$Just(55);
		case 54:
			return $elm$core$Maybe$Just(55);
		case 180:
			return $elm$core$Maybe$Just(55);
		case 13:
			return $elm$core$Maybe$Just(55);
		case 55:
			return $elm$core$Maybe$Just(55);
		case 4:
			return $elm$core$Maybe$Just(55);
		case 62:
			return $elm$core$Maybe$Just(55);
		case 63:
			return $elm$core$Maybe$Just(55);
		case 182:
			return $elm$core$Maybe$Just(55);
		case 64:
			return $elm$core$Maybe$Just(55);
		case 71:
			return $elm$core$Maybe$Just(55);
		case 70:
			return $elm$core$Maybe$Just(55);
		case 66:
			return $elm$core$Maybe$Just(55);
		case 69:
			return $elm$core$Maybe$Just(55);
		case 183:
			return $elm$core$Maybe$Just(55);
		case 242:
			return $elm$core$Maybe$Just(55);
		case 68:
			return $elm$core$Maybe$Just(55);
		case 67:
			return $elm$core$Maybe$Just(55);
		case 184:
			return $elm$core$Maybe$Just(55);
		case 243:
			return $elm$core$Maybe$Just(55);
		case 288:
			return $elm$core$Maybe$Just(55);
		case 18:
			return $elm$core$Maybe$Just(55);
		case 156:
			return $elm$core$Maybe$Just(55);
		case 194:
			return $elm$core$Maybe$Just(55);
		case 186:
			return $elm$core$Maybe$Just(55);
		case 278:
			return $elm$core$Maybe$Just(55);
		case 185:
			return $elm$core$Maybe$Just(55);
		case 244:
			return $elm$core$Maybe$Just(55);
		case 277:
			return $elm$core$Maybe$Just(55);
		case 187:
			return $elm$core$Maybe$Just(55);
		case 245:
			return $elm$core$Maybe$Just(55);
		case 280:
			return $elm$core$Maybe$Just(55);
		default:
			return $elm$core$Maybe$Just(55);
	}
};
var $author$project$Permission$homeStateMappingFor = function (role) {
	switch (role) {
		case 'practice_admin':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_manager':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_staff':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_staff_limited':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_reports_only':
			return $author$project$Spa$Generated$Route$Reports__Dashboard;
		case 'practice_read_only':
			return $author$project$Spa$Generated$Route$Patients__Top;
		case 'practice_practice_billing_only':
			return $author$project$Spa$Generated$Route$Admin__Billing;
		default:
			return $author$project$Spa$Generated$Route$Patients__Top;
	}
};
var $author$project$Api$Platform$Organization$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Platform$Organization$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Organization$Min$id(min);
};
var $author$project$Api$Platform$User$Shared$requiresMfa = function (_v0) {
	var record = _v0;
	return record.Yn;
};
var $author$project$Api$Platform$Session$One$role = function (_v0) {
	var record = _v0;
	return record.agy;
};
var $author$project$Permission$homeStateFor = F2(
	function (session, hinterViewOff) {
		var _v0 = $author$project$Api$Platform$Session$One$organization(session);
		if (_v0.$ === 1) {
			var requiresMfa = $author$project$Api$Platform$User$Shared$requiresMfa(
				$author$project$Api$Platform$Session$One$user(session));
			return requiresMfa ? $author$project$Spa$Generated$Route$User__Mfa : $author$project$Spa$Generated$Route$User__Profile;
		} else {
			var organization = _v0.a;
			var _v1 = $author$project$Api$Platform$Organization$Shared$type_(organization);
			switch (_v1) {
				case 0:
					return ((!$author$project$Api$Platform$Organization$Shared$type_(organization)) && ((!$author$project$Api$Platform$Organization$Shared$onboarded(organization)) && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff))) ? $author$project$Spa$Generated$Route$Onboarding : (((!$author$project$Api$Platform$Organization$Shared$type_(organization)) && $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding(organization)) ? $author$project$Spa$Generated$Route$Patients__Top : ((!$author$project$Api$Platform$Organization$Shared$type_(organization)) ? $author$project$Permission$homeStateMappingFor(
						$author$project$Api$Platform$Session$One$role(session)) : $author$project$Spa$Generated$Route$NotFound));
				case 1:
					return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
						{
							ff: $author$project$Api$Platform$Organization$Shared$id(organization)
						});
				default:
					return $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
			}
		}
	});
var $author$project$Permission$authorizeRoute = F3(
	function (session, hinterViewOff, route) {
		var code = $author$project$Permission$forRoute(route);
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Permission$canGoTo, session, hinterViewOff),
				code)) || _Utils_eq(
			A2($author$project$Permission$homeStateFor, session, hinterViewOff),
			route);
	});
var $author$project$Spa$Page$authorizeUrl = F3(
	function (session, hinterViewOff, url) {
		return A3(
			$author$project$Permission$authorizeRoute,
			session,
			hinterViewOff,
			$author$project$Utils$Route$fromUrl(url));
	});
var $author$project$Utils$Tuple3$fromTuple2 = F2(
	function (third_, _v0) {
		var first_ = _v0.a;
		var second_ = _v0.b;
		return _Utils_Tuple3(first_, second_, third_);
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Utils$Tuple3$mapFirst = F2(
	function (mapFunc, _v0) {
		var first_ = _v0.a;
		var second_ = _v0.b;
		var third_ = _v0.c;
		return _Utils_Tuple3(
			mapFunc(first_),
			second_,
			third_);
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Utils$Route$toString = F2(
	function (params, route) {
		var queryString = $elm$url$Url$Builder$toQuery(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var k = _v0.a;
					var v = _v0.b;
					return A2($elm$url$Url$Builder$string, k, v);
				},
				$elm$core$Dict$toList(params)));
		return _Utils_ap(
			$author$project$Spa$Generated$Route$toString(route),
			queryString);
	});
var $author$project$Utils$Route$navigate = F2(
	function (params, route) {
		return $author$project$Ports$Navigation$pushUrl(
			A2($author$project$Utils$Route$toString, params, route));
	});
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Components$BlankPage$view = _List_Nil;
var $author$project$Spa$Page$applicationPractice = function (page) {
	return {
		ad0: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple2(shared.ZD, shared.WF);
				_v0$3:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										if (!_v0.b.a.$) {
											var _v1 = _v0.a;
											var session = _v1.a;
											var _v2 = _v0.b;
											var practice = _v2.a.a;
											return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) ? _Utils_Tuple3(
												$author$project$Spa$Page$SessionLoading(url),
												A2(
													$author$project$Utils$Route$navigate,
													$elm$core$Dict$empty,
													A2($author$project$Permission$homeStateFor, session, shared.adN)),
												_List_Nil) : A2(
												$author$project$Utils$Tuple3$mapFirst,
												$author$project$Spa$Page$SessionLoaded,
												A2(
													$author$project$Utils$Tuple3$fromTuple2,
													_List_Nil,
													A4(page.ad0, session, practice, shared, url)));
										} else {
											var _v3 = _v0.a;
											var session = _v3.a;
											var _v4 = _v0.b;
											return _Utils_Tuple3(
												$author$project$Spa$Page$SessionLoading(url),
												A2(
													$author$project$Utils$Route$navigate,
													$elm$core$Dict$empty,
													A2($author$project$Permission$homeStateFor, session, shared.adN)),
												_List_Nil);
										}
									case 2:
										break _v0$3;
									default:
										break _v0$5;
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							case 0:
								if (_v0.b.$ === 2) {
									break _v0$3;
								} else {
									var _v5 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{af6: true}),
										_List_Nil);
								}
							default:
								if (_v0.b.$ === 2) {
									break _v0$3;
								} else {
									break _v0$5;
								}
						}
					}
					return _Utils_Tuple3(
						$author$project$Spa$Page$SessionLoading(url),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aer: F2(
			function (shared, model) {
				var _v6 = _Utils_Tuple3(shared.ZD, shared.WF, model);
				_v6$1:
				while (true) {
					_v6$3:
					while (true) {
						_v6$4:
						while (true) {
							if (!_v6.c.$) {
								switch (_v6.a.$) {
									case 3:
										switch (_v6.b.$) {
											case 3:
												if (!_v6.b.a.$) {
													var _v7 = _v6.a;
													var session = _v7.a;
													var _v8 = _v6.b;
													var practice = _v8.a.a;
													var url = _v6.c.a;
													if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) {
														return _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoading(url),
															A2(
																$author$project$Utils$Route$navigate,
																$elm$core$Dict$empty,
																A2($author$project$Permission$homeStateFor, session, shared.adN)),
															_List_Nil);
													} else {
														var _v9 = A4(page.ad0, session, practice, shared, url);
														var pageModel = _v9.a;
														var cmd = _v9.b;
														return _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoaded(pageModel),
															cmd,
															_List_Nil);
													}
												} else {
													break _v6$1;
												}
											case 2:
												break _v6$3;
											default:
												break _v6$4;
										}
									case 2:
										return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
									default:
										if (_v6.b.$ === 2) {
											break _v6$3;
										} else {
											break _v6$4;
										}
								}
							} else {
								if (((_v6.a.$ === 3) && (_v6.b.$ === 3)) && (_v6.b.a.$ === 1)) {
									break _v6$1;
								} else {
									break _v6$4;
								}
							}
						}
						if (model.$ === 1) {
							var modelWithSession = model.a;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Page$SessionLoaded,
									A2(
										page.aer,
										shared,
										_Utils_update(
											modelWithSession,
											{D5: shared.D5}))));
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						}
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				var _v10 = _v6.a;
				var session = _v10.a;
				var _v11 = _v6.b;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						A2($author$project$Permission$homeStateFor, session, shared.adN)),
					_List_Nil);
			}),
		agD: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.agD, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		ahd: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahd(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		aaq: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.aaq, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		ahP: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahP(modelWithSession);
			} else {
				return {e5: $author$project$Components$BlankPage$view, $G: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Accounting$GotLayerAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Accounting$Loading = {$: 0};
var $author$project$Pages$Accounting$NavMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Accounting$Overview = 0;
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Api$Feature$Accounting = 15;
var $author$project$Components$Layer$CreateForm$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$one = function (_v0) {
	var record = _v0.b;
	return record;
};
var $author$project$Api$Feature$toString = function (feature) {
	switch (feature) {
		case 0:
			return 'commissions_tracking';
		case 6:
			return 'joint_product';
		case 3:
			return 'manually_disable_elation_sync';
		case 5:
			return 'membership_auto_renew_editable';
		case 1:
			return 'nonmonthly_sponsor_billing';
		case 4:
			return 'quickbooks_bypass_pmpm_check';
		case 7:
			return 'disable_sponsor_billing';
		case 2:
			return 'tobacco_surcharge';
		case 8:
			return 'custom_js_on_signup_pages';
		case 9:
			return 'report_access';
		case 10:
			return 'multi_language';
		case 11:
			return 'virtual_bank_account';
		case 12:
			return 'customizable_notifications_by_employer';
		case 13:
			return 'passthrough_credit_card_fees';
		case 14:
			return 'allow_stripe_card_readers';
		case 15:
			return 'accounting';
		case 16:
			return 'accounting_without_bookkeeping';
		case 17:
			return 'multiple_retail_memberships';
		case 18:
			return 'manage_data_exports';
		case 19:
			return 'unified_experience';
		case 20:
			return 'age_tiered_couple_rates';
		case 21:
			return 'pricing_versions';
		case 22:
			return 'packages';
		case 23:
			return 'self_buy';
		case 24:
			return 'stripe_capital';
		case 25:
			return 'marketplace_view_tiles';
		case 26:
			return 'nav_reorganization';
		case 27:
			return 'new_messaging_endpoint';
		default:
			return 'stripe_embedded_onboarding';
	}
};
var $author$project$Api$Provider$Practice$One$featureEnabled = function (feature) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Provider$Practice$One$one,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.Pd;
			},
			$elm$core$List$member(
				$author$project$Api$Feature$toString(feature))));
};
var $author$project$Api$Provider$Practice$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Practice$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$name(shared);
};
var $author$project$Components$Layer$CreateForm$formFieldsInit = function (practice) {
	return {
		abI: false,
		SK: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practice$One$name(practice)),
		ag0: false
	};
};
var $author$project$Utils$Form$Form = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Utils$Form$init = function (fields_) {
	return A4($author$project$Utils$Form$Form, fields_, false, fields_, _List_Nil);
};
var $author$project$Components$Layer$CreateForm$init = function (practice) {
	var model = {
		vI: A2($author$project$Api$Provider$Practice$One$featureEnabled, 15, practice),
		PB: $author$project$Utils$Form$init(
			$author$project$Components$Layer$CreateForm$formFieldsInit(practice)),
		jY: $author$project$Api$Data$NotAsked
	};
	return model;
};
var $author$project$Ui$Nav$Model = $elm$core$Basics$identity;
var $author$project$Ports$NavTabs$navTabActiveChanged = _Platform_outgoingPort('navTabActiveChanged', $elm$json$Json$Encode$string);
var $author$project$Ui$Nav$init = F2(
	function (navId, toMsg) {
		return _Utils_Tuple2(
			{adR: navId, ahx: toMsg, HE: 0, HF: 0},
			$author$project$Ports$NavTabs$navTabActiveChanged(navId));
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$Layer$layerPortLoad = _Platform_outgoingPort(
	'layerPortLoad',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Layer$load = $author$project$Ports$Layer$layerPortLoad(0);
var $author$project$Api$Provider$LayerAccount$One$LayerAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$LayerAccount$Shared$LayerAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$LayerAccount$Shared$Record = function (status) {
	return {ag7: status};
};
var $author$project$Api$Provider$LayerAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$Shared$Record));
var $author$project$Api$Provider$LayerAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LayerAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LayerAccount$One$Record = F7(
	function (legalName, tin, state, entityType, phone, smsEnabled, bookkeepingEnabled) {
		return {J5: bookkeepingEnabled, OK: entityType, SK: legalName, Wg: phone, _e: smsEnabled, sZ: state, $F: tin};
	});
var $author$project$Api$Provider$LayerAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bookkeeping_enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sms_enabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'phone',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'entity_type',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tin',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'legal_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$One$Record))))))));
var $author$project$Api$Provider$LayerAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LayerAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$LayerAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$One$LayerAccount)));
var $author$project$Api$Provider$Practice$practicePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Practice$LayerAccount$layerAccountPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['layer_account']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$LayerAccount$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$LayerAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$layerAccountPath));
	});
var $author$project$Pages$Accounting$sectionId = function (section) {
	switch (section) {
		case 0:
			return 'overview';
		case 1:
			return 'bank-transactions-and-accounts';
		case 2:
			return 'reports';
		case 3:
			return 'general-ledger';
		default:
			return 'settings';
	}
};
var $author$project$Pages$Accounting$BankTransactionsAndAccounts = 1;
var $author$project$Pages$Accounting$GeneralLedger = 3;
var $author$project$Pages$Accounting$Reports = 2;
var $author$project$Pages$Accounting$Settings = 4;
var $author$project$Pages$Accounting$sections = function (bookkeepingEnabled) {
	return A2(
		$elm$core$List$cons,
		0,
		A2(
			$elm$core$List$cons,
			1,
			A2(
				$elm$core$List$cons,
				2,
				_Utils_ap(
					bookkeepingEnabled ? _List_Nil : _List_fromArray(
						[3]),
					_List_fromArray(
						[4])))));
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Ports$Navigation$replaceUrl = _Platform_outgoingPort('replaceUrl', $elm$json$Json$Encode$string);
var $author$project$Pages$Accounting$updateUrl = function (section) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$core$String$append,
			A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[
						$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Accounting)
					]),
				_List_Nil),
			'#' + $author$project$Pages$Accounting$sectionId(section)));
};
var $author$project$Pages$Accounting$init = F4(
	function (_v0, practice, shared, _v1) {
		var rawUrl = _v1.af3;
		var section = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				function (fragment) {
					return A2(
						$elm_community$list_extra$List$Extra$find,
						function (section_) {
							return _Utils_eq(
								$author$project$Pages$Accounting$sectionId(section_),
								fragment);
						},
						$author$project$Pages$Accounting$sections(false));
				},
				rawUrl.adz));
		var _v2 = A2($author$project$Ui$Nav$init, 'accounting-nav', $author$project$Pages$Accounting$NavMsg);
		var nav = _v2.a;
		var navCmd = _v2.b;
		var model = {
			pi: $author$project$Api$Data$Loading,
			D5: shared.D5,
			lA: $author$project$Components$Layer$CreateForm$init(practice),
			lW: $elm$core$Maybe$Nothing,
			yw: $author$project$Api$Data$Loading,
			m8: nav,
			WF: practice,
			cn: section,
			ag7: $author$project$Pages$Accounting$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						navCmd,
						$author$project$Pages$Accounting$updateUrl(section),
						A2($author$project$Api$Provider$Practice$LayerAccount$retrieve, shared.D5, $author$project$Pages$Accounting$GotLayerAccount),
						$author$project$Ports$Layer$load
					])));
	});
var $author$project$Pages$Accounting$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Accounting$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Ui$Nav$GotUnderlinePosition = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Ports$NavTabs$onNavTabActivePositionChange = _Platform_incomingPort(
	'onNavTabActivePositionChange',
	A2(
		$elm$json$Json$Decode$andThen,
		function (width) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (navId) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (left) {
							return $elm$json$Json$Decode$succeed(
								{ael: left, aeN: navId, ahT: width});
						},
						A2($elm$json$Json$Decode$field, 'left', $elm$json$Json$Decode$float));
				},
				A2($elm$json$Json$Decode$field, 'navId', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float)));
var $author$project$Ui$Nav$subscriptions = function (_v0) {
	var toMsg = _v0.ahx;
	return A2(
		$elm$core$Platform$Sub$map,
		toMsg,
		$author$project$Ports$NavTabs$onNavTabActivePositionChange($author$project$Ui$Nav$GotUnderlinePosition));
};
var $author$project$Pages$Accounting$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Pages$Accounting$CreateAccount = {$: 2};
var $author$project$Pages$Accounting$CreateFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Accounting$EditFormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Accounting$GotAccessToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Accounting$HasLayerAccountAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$OutMsg$RefreshPractice = {$: 2};
var $author$project$Api$Provider$Practice$LayerAccount$activate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$LayerAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$Practice$LayerAccount$layerAccountPath)));
	});
var $author$project$Ui$Toast$Error = 1;
var $author$project$OutMsg$GatewayError = {$: 19};
var $author$project$OutMsg$SessionExpired = function (a) {
	return {$: 14, a: a};
};
var $author$project$OutMsg$ShowToast = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$OutMsg$DecodeFailed = function (a) {
	return {$: 0, a: a};
};
var $author$project$OutMsg$reportDecodeError = function (response) {
	if ((response.$ === 2) && (response.a.$ === 7)) {
		var error = response.a.a;
		return _List_fromArray(
			[
				$author$project$OutMsg$DecodeFailed(error)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Toast$defaultError = 'An error occurred, please try again.';
var $author$project$Ui$Toast$serverError = function (errorResponse) {
	switch (errorResponse.$) {
		case 8:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, errorMessage);
		case 6:
			var code = errorResponse.a;
			var errorMessage = errorResponse.b;
			return (code >= 500) ? $author$project$Ui$Toast$defaultError : errorMessage;
		case 0:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, errorMessage);
		default:
			return $author$project$Ui$Toast$defaultError;
	}
};
var $author$project$OutMsg$handleErrorResponse = function (response) {
	return _Utils_ap(
		$author$project$OutMsg$reportDecodeError(response),
		function () {
			if (response.$ === 2) {
				var error = response.a;
				switch (error.$) {
					case 0:
						return _List_fromArray(
							[
								$author$project$OutMsg$SessionExpired(error)
							]);
					case 4:
						return _List_fromArray(
							[
								$author$project$OutMsg$GatewayError,
								A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error))
							]);
					default:
						return _List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error))
							]);
				}
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Components$Layer$EditForm$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled = function (_v0) {
	var record = _v0.b;
	return record.J5;
};
var $author$project$Api$Provider$LayerAccount$One$entityType = function (_v0) {
	var record = _v0.b;
	return record.OK;
};
var $author$project$Components$PhoneInput$US = 0;
var $author$project$Components$PhoneInput$International = 1;
var $author$project$Api$Common$Phone$Shared$number = function (_v0) {
	var record = _v0;
	return record.Gj;
};
var $author$project$Api$Common$Phone$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Common$Phone$Shared$usFormattable = function (_v0) {
	var record = _v0;
	return record.HM;
};
var $author$project$Utils$Phone$fromApi = function (phone) {
	var region = $author$project$Api$Common$Phone$Shared$usFormattable(phone) ? 0 : 1;
	return {
		Gj: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Common$Phone$Shared$number(phone)),
		agc: region,
		ahI: $author$project$Api$Common$Phone$Shared$type_(phone)
	};
};
var $author$project$Components$PhoneInput$Model = $elm$core$Basics$identity;
var $author$project$Components$PhoneInput$PhoneRegionDropdownMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$PhoneInput$PhoneTypeDropdownMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$DownRight = 0;
var $author$project$Ui$NewDropdown$defaultConfig = function (_v0) {
	var id = _v0.adR;
	var toMsg = _v0.ahx;
	return {xb: 0, adR: id, ahx: toMsg};
};
var $author$project$Components$PhoneInput$defaults = {
	Ik: false,
	abk: true,
	acB: $author$project$Api$Common$Phone$Shared$Mobile,
	acN: false,
	mo: false,
	yQ: 5,
	nT: _List_fromArray(
		[0, 1]),
	agk: false,
	ahJ: _List_fromArray(
		[$author$project$Api$Common$Phone$Shared$Mobile, $author$project$Api$Common$Phone$Shared$Home, $author$project$Api$Common$Phone$Shared$Office])
};
var $author$project$Components$PhoneInput$initPhone = F3(
	function (type_, region, number) {
		return {Gj: number, agc: region, ahI: type_};
	});
var $author$project$Components$PhoneInput$emptyPhone = function (type_) {
	return A3($author$project$Components$PhoneInput$initPhone, type_, 0, '');
};
var $author$project$Ui$NewDropdown$init = function (_v0) {
	var id = _v0.adR;
	var direction = _v0.xb;
	var toMsg = _v0.ahx;
	return {xb: direction, adR: id, U9: false, ahx: toMsg};
};
var $author$project$Components$PhoneInput$phoneRegionDropdownId = F2(
	function (id, index) {
		return id + ('phone-input-phone-region' + $elm$core$String$fromInt(index));
	});
var $author$project$Components$PhoneInput$phoneTypeDropdownId = F2(
	function (id, index) {
		return id + ('phone-input-phone-type' + $elm$core$String$fromInt(index));
	});
var $author$project$Components$PhoneInput$init = F3(
	function (id, phones, optionals) {
		var options = optionals($author$project$Components$PhoneInput$defaults);
		var phones_ = ($elm$core$List$isEmpty(phones) && options.Ik) ? _List_fromArray(
			[
				$author$project$Components$PhoneInput$emptyPhone(options.acB)
			]) : phones;
		return {
			abk: options.abk,
			acB: options.acB,
			acN: options.acN,
			PB: $author$project$Utils$Form$init(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, phone) {
							return _Utils_Tuple3(
								phone,
								$author$project$Ui$NewDropdown$init(
									$author$project$Ui$NewDropdown$defaultConfig(
										{
											adR: A2($author$project$Components$PhoneInput$phoneTypeDropdownId, id, index),
											ahx: $author$project$Components$PhoneInput$PhoneTypeDropdownMsg(index)
										})),
								$author$project$Ui$NewDropdown$init(
									$author$project$Ui$NewDropdown$defaultConfig(
										{
											adR: A2($author$project$Components$PhoneInput$phoneRegionDropdownId, id, index),
											ahx: $author$project$Components$PhoneInput$PhoneRegionDropdownMsg(index)
										})));
						}),
					phones_)),
			mo: options.mo,
			adR: id,
			yQ: options.yQ,
			nT: options.nT,
			agk: options.agk,
			ahJ: options.ahJ
		};
	});
var $author$project$Components$Layer$EditForm$initPhone = function (maybePhone) {
	var phoneToUse = A2(
		$elm$core$Maybe$withDefault,
		{Gj: '', agc: 0, ahI: $author$project$Api$Common$Phone$Shared$Mobile},
		A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone));
	return A3(
		$author$project$Components$PhoneInput$init,
		'layer-account-phone',
		_List_fromArray(
			[phoneToUse]),
		function (opts) {
			return _Utils_update(
				opts,
				{abk: false, acN: true, yQ: 1});
		});
};
var $author$project$Api$Provider$LayerAccount$One$legalName = function (_v0) {
	var record = _v0.b;
	return record.SK;
};
var $author$project$Api$Provider$LayerAccount$One$phone = function (_v0) {
	var record = _v0.b;
	return record.Wg;
};
var $author$project$Api$Provider$LayerAccount$One$smsEnabled = function (_v0) {
	var record = _v0.b;
	return record._e;
};
var $author$project$Api$Provider$LayerAccount$One$state = function (_v0) {
	var record = _v0.b;
	return record.sZ;
};
var $author$project$Api$Provider$LayerAccount$One$tin = function (_v0) {
	var record = _v0.b;
	return record.$F;
};
var $author$project$Components$Layer$EditForm$formFieldsInit = function (layerAccount) {
	return {
		OK: $author$project$Api$Provider$LayerAccount$One$entityType(layerAccount),
		SK: $author$project$Api$Provider$LayerAccount$One$legalName(layerAccount),
		Wg: $author$project$Components$Layer$EditForm$initPhone(
			$author$project$Api$Provider$LayerAccount$One$phone(layerAccount)),
		_e: $author$project$Api$Provider$LayerAccount$One$smsEnabled(layerAccount),
		sZ: $author$project$Api$Provider$LayerAccount$One$state(layerAccount),
		$F: $author$project$Api$Provider$LayerAccount$One$tin(layerAccount)
	};
};
var $author$project$Components$Layer$EditForm$init = function (layerAccount) {
	var model = {
		J5: $author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount),
		PB: $author$project$Utils$Form$init(
			$author$project$Components$Layer$EditForm$formFieldsInit(layerAccount)),
		jY: $author$project$Api$Data$NotAsked
	};
	return model;
};
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$accessTokenPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['access_token']),
	$author$project$Api$Provider$Practice$LayerAccount$layerAccountPath);
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$AccessToken = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$Record = F3(
	function (token, businessId, env) {
		return {Kf: businessId, OL: env, $Q: token};
	});
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'env',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'business_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'token',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$LayerAccount$AccessToken$Record))));
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$LayerAccount$AccessToken$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Practice$LayerAccount$AccessToken$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$AccessToken$accessTokenPath));
	});
var $author$project$Api$Provider$LayerAccount$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$LayerAccount$Shared$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$LayerAccount$Shared$record,
	function ($) {
		return $.ag7;
	});
var $author$project$Api$Provider$LayerAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$LayerAccount$Shared$status(shared);
};
var $author$project$Components$Layer$CreateForm$GotLayerAccountCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Layer$CreateForm$LayerAccountCreated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Layer$CreateForm$None = {$: 0};
var $author$project$Ui$Toast$Success = 3;
var $author$project$Utils$Encode$nullable = F2(
	function (encoder, value) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, encoder, value));
	});
var $author$project$Api$Data$Json = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Data$requestWithJson = F2(
	function (json, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				e5: $elm$core$Maybe$Just(
					$author$project$Api$Data$Json(json))
			});
	});
var $author$project$Api$Provider$Practice$LayerAccount$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'layer_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'legal_name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.SK)),
								_Utils_Tuple2(
								'software_terms_accepted',
								$elm$json$Json$Encode$bool(fields.ag0)),
								_Utils_Tuple2(
								'bookkeeping_terms_accepted',
								$elm$json$Json$Encode$bool(fields.abI))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$LayerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$layerAccountPath)));
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Utils$String$isBlank = function (string) {
	return $elm$core$String$isEmpty(
		$elm$core$String$trim(string));
};
var $author$project$Utils$String$toMaybe = function (string) {
	return $author$project$Utils$String$isBlank(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Components$Layer$CreateForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						SK: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ag0: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{abI: bool});
		}
	});
var $rtfeldman$elm_validate$Validate$fromValid = function (_v0) {
	var subject = _v0;
	return subject;
};
var $author$project$Utils$Form$update = F3(
	function (updater, field_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		return A4(
			$author$project$Utils$Form$Form,
			originalFields,
			validated_,
			A2(updater, field_, fields_),
			errors_);
	});
var $author$project$Components$Layer$CreateForm$BookkeepingTermsAcceptedValidation = 2;
var $author$project$Components$Layer$CreateForm$LegalNameValidation = 0;
var $author$project$Components$Layer$CreateForm$SoftwareTermsAcceptedValidation = 1;
var $rtfeldman$elm_validate$Validate$Validator = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$all = function (validators) {
	var newGetErrors = function (subject) {
		var accumulateErrors = F2(
			function (_v0, totalErrors) {
				var getErrors = _v0;
				return _Utils_ap(
					totalErrors,
					getErrors(subject));
			});
		return A3($elm$core$List$foldl, accumulateErrors, _List_Nil, validators);
	};
	return newGetErrors;
};
var $rtfeldman$elm_validate$Validate$ifFalse = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_Nil : _List_fromArray(
				[error]);
		};
		return getErrors;
	});
var $rtfeldman$elm_validate$Validate$ifTrue = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_fromArray(
				[error]) : _List_Nil;
		};
		return getErrors;
	});
var $rtfeldman$elm_validate$Validate$ifNothing = F2(
	function (subjectToMaybe, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _Utils_eq(
					subjectToMaybe(subject),
					$elm$core$Maybe$Nothing);
			},
			error);
	});
var $author$project$Components$Layer$CreateForm$formFieldsValidator = function (bookkeepingActive) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.SK;
				},
				_Utils_Tuple2(0, 'Please enter a legal name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function ($) {
					return $.ag0;
				},
				_Utils_Tuple2(1, 'Please accept the software terms.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function (fields) {
					return (!bookkeepingActive) || fields.abI;
				},
				_Utils_Tuple2(2, 'Please accept the bookkeeping terms.'))
			]));
};
var $rtfeldman$elm_validate$Validate$Valid = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$validate = F2(
	function (_v0, subject) {
		var getErrors = _v0;
		var _v1 = getErrors(subject);
		if (!_v1.b) {
			return $elm$core$Result$Ok(subject);
		} else {
			var errors = _v1;
			return $elm$core$Result$Err(errors);
		}
	});
var $author$project$Utils$Form$validate = F2(
	function (formFieldsValidator, _v0) {
		var originalFields = _v0.a;
		var fields_ = _v0.c;
		var _v1 = A2($rtfeldman$elm_validate$Validate$validate, formFieldsValidator, fields_);
		if (!_v1.$) {
			var validForm = _v1.a;
			return $elm$core$Result$Ok(
				_Utils_Tuple2(
					A4($author$project$Utils$Form$Form, originalFields, true, fields_, _List_Nil),
					validForm));
		} else {
			var errors_ = _v1.a;
			return $elm$core$Result$Err(
				A4($author$project$Utils$Form$Form, originalFields, true, fields_, errors_));
		}
	});
var $author$project$Components$Layer$CreateForm$validate = function (model) {
	return A2(
		$elm$core$Result$mapError,
		function (validatedForm) {
			return _Utils_update(
				model,
				{PB: validatedForm});
		},
		A2(
			$elm$core$Result$map,
			function (_v0) {
				var validatedForm = _v0.a;
				var validFormFields = _v0.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{PB: validatedForm}),
					validFormFields);
			},
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$Layer$CreateForm$formFieldsValidator(model.vI),
				model.PB)));
};
var $author$project$Components$Layer$CreateForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Layer$CreateForm$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					l6: $author$project$Components$Layer$CreateForm$None,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 1:
				var _v2 = $author$project$Components$Layer$CreateForm$validate(model);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newModel = _v3.a;
					var validFormFields = _v3.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var apiFields = {abI: fields.abI, SK: fields.SK, ag0: fields.ag0};
					return {
						EC: A3($author$project$Api$Provider$Practice$LayerAccount$create, apiClient, apiFields, $author$project$Components$Layer$CreateForm$GotLayerAccountCreated),
						l6: $author$project$Components$Layer$CreateForm$None,
						y8: _Utils_update(
							newModel,
							{jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newModel = _v2.a;
					return {EC: $elm$core$Platform$Cmd$none, l6: $author$project$Components$Layer$CreateForm$None, y8: newModel, as: _List_Nil};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var layerAccount = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						l6: $author$project$Components$Layer$CreateForm$LayerAccountCreated(layerAccount),
						y8: _Utils_update(
							model,
							{jY: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Account created successfully')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						l6: $author$project$Components$Layer$CreateForm$None,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Layer$EditForm$GotLayerAccountUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Layer$EditForm$Phone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Layer$EditForm$PhoneInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$Form$fields = function (_v0) {
	var fields_ = _v0.c;
	return fields_;
};
var $author$project$Components$Layer$EditForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						SK: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						$F: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						sZ: $author$project$Utils$String$toMaybe(string)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						OK: $author$project$Utils$String$toMaybe(string)
					});
			case 4:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Wg: phone});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{_e: bool});
		}
	});
var $rtfeldman$elm_validate$Validate$fromErrors = function (toErrors) {
	return toErrors;
};
var $author$project$Components$PhoneInput$PhoneValidation = $elm$core$Basics$identity;
var $agustinrhcp$elm_mask$Mask$maskRec = F2(
	function (input, pattern) {
		var _v0 = _Utils_Tuple2(input, pattern);
		if (!_v0.b.b) {
			return '';
		} else {
			if (_v0.a.b) {
				var _v1 = _v0.a;
				var _char = _v1.a;
				var remainingChar = _v1.b;
				var _v2 = _v0.b;
				var token = _v2.a;
				var remainingTokens = _v2.b;
				switch (token.$) {
					case 2:
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								function (_int) {
									return _Utils_ap(
										$elm$core$String$fromInt(_int),
										A2($agustinrhcp$elm_mask$Mask$maskRec, remainingChar, remainingTokens));
								},
								$elm$core$String$toInt(
									$elm$core$String$fromChar(_char))));
					case 1:
						return _Utils_ap(
							$elm$core$String$fromChar(_char),
							A2($agustinrhcp$elm_mask$Mask$maskRec, remainingChar, remainingTokens));
					default:
						var a = token.a;
						return _Utils_ap(
							$elm$core$String$fromChar(a),
							A2($agustinrhcp$elm_mask$Mask$maskRec, input, remainingTokens));
				}
			} else {
				var _v4 = _v0.b;
				var token = _v4.a;
				var remainingTokens = _v4.b;
				if (!token.$) {
					var symbol = token.a;
					return _Utils_ap(
						$elm$core$String$fromChar(symbol),
						A2($agustinrhcp$elm_mask$Mask$maskRec, input, remainingTokens));
				} else {
					return '';
				}
			}
		}
	});
var $agustinrhcp$elm_mask$Mask$mask = F2(
	function (_v0, stringInput) {
		var pattern = _v0;
		return $elm$core$String$isEmpty(stringInput) ? '' : A2(
			$agustinrhcp$elm_mask$Mask$maskRec,
			$elm$core$String$toList(stringInput),
			pattern);
	});
var $author$project$Components$PhoneInput$phoneMask = '(###) ###-####';
var $agustinrhcp$elm_mask$Mask$defaultConfig = {D4: '*', E2: '#'};
var $agustinrhcp$elm_mask$Mask$Pattern = $elm$core$Basics$identity;
var $agustinrhcp$elm_mask$Mask$Any = {$: 1};
var $agustinrhcp$elm_mask$Mask$Digit = {$: 2};
var $agustinrhcp$elm_mask$Mask$Symbol = function (a) {
	return {$: 0, a: a};
};
var $agustinrhcp$elm_mask$Mask$charToToken = F2(
	function (_v0, _char) {
		var digitChar = _v0.E2;
		var anyChar = _v0.D4;
		return _Utils_eq(_char, digitChar) ? $agustinrhcp$elm_mask$Mask$Digit : (_Utils_eq(_char, anyChar) ? $agustinrhcp$elm_mask$Mask$Any : $agustinrhcp$elm_mask$Mask$Symbol(_char));
	});
var $agustinrhcp$elm_mask$Mask$tokens = F2(
	function (conf, string) {
		return A2(
			$elm$core$List$map,
			$agustinrhcp$elm_mask$Mask$charToToken(conf),
			$elm$core$String$toList(string));
	});
var $agustinrhcp$elm_mask$Mask$fromStringWithConf = F2(
	function (conf, string) {
		return A2($agustinrhcp$elm_mask$Mask$tokens, conf, string);
	});
var $agustinrhcp$elm_mask$Mask$fromString = $agustinrhcp$elm_mask$Mask$fromStringWithConf($agustinrhcp$elm_mask$Mask$defaultConfig);
var $author$project$Components$PhoneInput$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Components$PhoneInput$phoneMask);
var $author$project$Components$PhoneInput$phoneIncomplete = F2(
	function (phoneNumber, phoneRegion) {
		if (!phoneRegion) {
			var maskedPhone = A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$PhoneInput$phonePattern, phoneNumber);
			return ($elm$core$String$length(maskedPhone) > 0) && (!_Utils_eq(
				$elm$core$String$length($author$project$Components$PhoneInput$phoneMask),
				$elm$core$String$length(maskedPhone)));
		} else {
			return false;
		}
	});
var $author$project$Components$PhoneInput$validatePhone = F3(
	function (isRequired, index, _v0) {
		var phone = _v0.a;
		return A2($author$project$Components$PhoneInput$phoneIncomplete, phone.Gj, phone.agc) ? _List_fromArray(
			[
				_Utils_Tuple2(index, 'Please enter a valid phone number.')
			]) : (((!index) && (isRequired && $elm$core$String$isEmpty(phone.Gj))) ? _List_fromArray(
			[
				_Utils_Tuple2(index, 'Please enter a phone number.')
			]) : _List_Nil);
	});
var $author$project$Components$PhoneInput$validatePhones = F2(
	function (isRequired, phones) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$PhoneInput$validatePhone(isRequired),
				phones));
	});
var $author$project$Components$PhoneInput$formFieldsValidator = function (isRequired) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$PhoneInput$validatePhones(isRequired))
			]));
};
var $author$project$Components$PhoneInput$getPhones = function (_v0) {
	var model = _v0;
	var _v1 = A2(
		$author$project$Utils$Form$validate,
		$author$project$Components$PhoneInput$formFieldsValidator(model.agk),
		model.PB);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var formFields = _v2.b;
		return $elm$core$Maybe$Just(
			A2(
				$elm$core$List$map,
				function (_v3) {
					var phone = _v3.a;
					return phone;
				},
				$rtfeldman$elm_validate$Validate$fromValid(formFields)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$Phone$toRecord = function (phone) {
	var usFormattable = function () {
		var _v0 = phone.agc;
		if (!_v0) {
			return true;
		} else {
			return false;
		}
	}();
	return {Gj: phone.Gj, ahI: phone.ahI, HM: usFormattable};
};
var $author$project$Api$Data$patch = $author$project$Api$Data$makeRequest('patch');
var $author$project$Api$Provider$Practice$LayerAccount$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'layer_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'legal_name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.SK)),
								_Utils_Tuple2(
								'tin',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.$F)),
								_Utils_Tuple2(
								'state',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.sZ)),
								_Utils_Tuple2(
								'entity_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OK)),
								_Utils_Tuple2(
								'phone_number',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Wh)),
								_Utils_Tuple2(
								'sms_enabled',
								$elm$json$Json$Encode$bool(fields._e))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$LayerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$layerAccountPath)));
	});
var $author$project$Components$PhoneInput$Phones = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$filter = _String_filter;
var $author$project$Components$PhoneInput$numPhoneMaskDigits = $elm$core$String$length(
	A2(
		$elm$core$String$filter,
		function (c) {
			return c === '#';
		},
		$author$project$Components$PhoneInput$phoneMask));
var $author$project$Components$PhoneInput$clipPhoneNumberToMask = F2(
	function (phoneNumber, phoneRegion) {
		return ((!phoneRegion) && (_Utils_cmp(
			$elm$core$String$length(phoneNumber),
			$author$project$Components$PhoneInput$numPhoneMaskDigits) > 0)) ? A2($elm$core$String$left, $author$project$Components$PhoneInput$numPhoneMaskDigits, phoneNumber) : phoneNumber;
	});
var $author$project$Formatters$PhoneType$fromString = function (string) {
	switch (string) {
		case 'Mobile':
			return $author$project$Api$Common$Phone$Shared$Mobile;
		case 'Home':
			return $author$project$Api$Common$Phone$Shared$Home;
		case 'Office':
			return $author$project$Api$Common$Phone$Shared$Office;
		default:
			var otherDescription = string;
			return $author$project$Api$Common$Phone$Shared$Other(otherDescription);
	}
};
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Components$PhoneInput$formFieldsUpdate = F2(
	function (field, phones) {
		switch (field.$) {
			case 0:
				var phones_ = field.a;
				return phones_;
			case 1:
				var index = field.a;
				var type_ = field.b;
				return A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (_v1) {
						var phone = _v1.a;
						var typeDropdown = _v1.b;
						var regionDropdown = _v1.c;
						return _Utils_Tuple3(
							_Utils_update(
								phone,
								{
									ahI: $author$project$Formatters$PhoneType$fromString(type_)
								}),
							typeDropdown,
							regionDropdown);
					},
					phones);
			case 2:
				var index = field.a;
				var region = field.b;
				return A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (_v2) {
						var phone = _v2.a;
						var typeDropdown = _v2.b;
						var regionDropdown = _v2.c;
						return _Utils_Tuple3(
							_Utils_update(
								phone,
								{
									Gj: A2($author$project$Components$PhoneInput$clipPhoneNumberToMask, phone.Gj, region),
									agc: region
								}),
							typeDropdown,
							regionDropdown);
					},
					phones);
			default:
				var index = field.a;
				var number = field.b;
				return A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (_v3) {
						var phone = _v3.a;
						var typeDropdown = _v3.b;
						var regionDropdown = _v3.c;
						return _Utils_Tuple3(
							_Utils_update(
								phone,
								{Gj: number}),
							typeDropdown,
							regionDropdown);
					},
					phones);
		}
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Ui$NewDropdown$MenuClosedAfterFocus = {$: 9};
var $author$project$Ui$NewDropdown$NoOp = {$: 6};
var $author$project$Ui$NewDropdown$RightDown = 1;
var $author$project$Ports$Dropdown$focusFirstDropdownOptionPort = _Platform_outgoingPort('focusFirstDropdownOptionPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Dropdown$focusFirstItem = $author$project$Ports$Dropdown$focusFirstDropdownOptionPort;
var $author$project$Ports$Dropdown$focusInnerDropdownOptionInputPort = _Platform_outgoingPort(
	'focusInnerDropdownOptionInputPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$focusInnerInput = $author$project$Ports$Dropdown$focusInnerDropdownOptionInputPort(0);
var $author$project$Ports$Dropdown$focusInnerDropdownOptionLinkPort = _Platform_outgoingPort(
	'focusInnerDropdownOptionLinkPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$focusInnerLink = $author$project$Ports$Dropdown$focusInnerDropdownOptionLinkPort(0);
var $author$project$Ports$Dropdown$focusNextDropdownOptionPort = _Platform_outgoingPort(
	'focusNextDropdownOptionPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$focusNextItem = $author$project$Ports$Dropdown$focusNextDropdownOptionPort(0);
var $author$project$Ports$Dropdown$focusPrevDropdownOptionPort = _Platform_outgoingPort(
	'focusPrevDropdownOptionPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$focusPrevItem = $author$project$Ports$Dropdown$focusPrevDropdownOptionPort(0);
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Ui$NewDropdown$focusTrigger = F2(
	function (msg, id) {
		return A2(
			$elm$core$Task$attempt,
			$elm$core$Basics$always(msg),
			$elm$browser$Browser$Dom$focus(id + '-trigger'));
	});
var $author$project$Ports$Dropdown$dropdownSimulateClick = _Platform_outgoingPort(
	'dropdownSimulateClick',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$simulateClick = $author$project$Ports$Dropdown$dropdownSimulateClick(0);
var $author$project$Ports$Dropdown$submitFormDropdownPort = _Platform_outgoingPort(
	'submitFormDropdownPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Dropdown$submitForm = $author$project$Ports$Dropdown$submitFormDropdownPort(0);
var $author$project$Ui$NewDropdown$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: !model.U9}),
					(!model.U9) ? A2(
						$elm$core$Platform$Cmd$map,
						model.ahx,
						$author$project$Ports$Dropdown$focusFirstItem(model.adR)) : $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: true}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: true}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: !model.U9}),
					(!model.U9) ? A2(
						$elm$core$Platform$Cmd$map,
						model.ahx,
						$author$project$Ports$Dropdown$focusFirstItem(model.adR)) : $elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						model.ahx,
						A2($author$project$Ui$NewDropdown$focusTrigger, $author$project$Ui$NewDropdown$MenuClosedAfterFocus, model.adR)));
			case 5:
				var arrowDirection = msg.a;
				var openAndFocusFirst = _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: true}),
					$author$project$Ports$Dropdown$focusFirstItem(model.adR));
				var _v1 = model.xb;
				switch (_v1) {
					case 0:
						if (arrowDirection === 1) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 1:
						if (arrowDirection === 2) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 4:
						if (arrowDirection === 1) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					case 2:
						if (arrowDirection === 1) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					default:
						if (arrowDirection === 1) {
							return openAndFocusFirst;
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
				}
			case 7:
				var direction = msg.a;
				switch (direction) {
					case 0:
						return _Utils_Tuple2(model, $author$project$Ports$Dropdown$focusPrevItem);
					case 1:
						return _Utils_Tuple2(model, $author$project$Ports$Dropdown$focusNextItem);
					case 2:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return (model.xb === 1) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{U9: false}),
							A2(
								$elm$core$Platform$Cmd$map,
								model.ahx,
								A2($author$project$Ui$NewDropdown$focusTrigger, $author$project$Ui$NewDropdown$NoOp, model.adR))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 6:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Platform$Cmd$map,
						model.ahx,
						A2($author$project$Ui$NewDropdown$focusTrigger, $author$project$Ui$NewDropdown$MenuClosedAfterFocus, model.adR)));
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: false}),
					$elm$core$Platform$Cmd$none);
			case 10:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Platform$Cmd$map, model.ahx, $author$project$Ports$Dropdown$focusInnerInput));
			case 11:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Platform$Cmd$map, model.ahx, $author$project$Ports$Dropdown$focusInnerLink));
			case 12:
				var id = msg.a;
				return _Utils_eq(model.adR, id) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: false}),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 13:
				return _Utils_Tuple2(model, $author$project$Ports$Dropdown$submitForm);
			default:
				return _Utils_Tuple2(
					model,
					A2($elm$core$Platform$Cmd$map, model.ahx, $author$project$Ports$Dropdown$simulateClick));
		}
	});
var $author$project$Components$PhoneInput$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var phones = $author$project$Utils$Form$fields(model.PB);
				var lastIndex = $elm$core$List$length(phones);
				var newPhones = _Utils_ap(
					phones,
					_List_fromArray(
						[
							_Utils_Tuple3(
							$author$project$Components$PhoneInput$emptyPhone(model.acB),
							$author$project$Ui$NewDropdown$init(
								$author$project$Ui$NewDropdown$defaultConfig(
									{
										adR: A2($author$project$Components$PhoneInput$phoneTypeDropdownId, model.adR, lastIndex),
										ahx: $author$project$Components$PhoneInput$PhoneTypeDropdownMsg(lastIndex)
									})),
							$author$project$Ui$NewDropdown$init(
								$author$project$Ui$NewDropdown$defaultConfig(
									{
										adR: A2($author$project$Components$PhoneInput$phoneRegionDropdownId, model.adR, lastIndex),
										ahx: $author$project$Components$PhoneInput$PhoneRegionDropdownMsg(lastIndex)
									})))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$PhoneInput$formFieldsUpdate,
								$author$project$Components$PhoneInput$Phones(newPhones),
								model.PB)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var index = msg.a;
				var phones = $author$project$Utils$Form$fields(model.PB);
				var newPhones = A2($elm_community$list_extra$List$Extra$removeAt, index, phones);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$PhoneInput$formFieldsUpdate,
								$author$project$Components$PhoneInput$Phones(newPhones),
								model.PB)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$PhoneInput$formFieldsUpdate, field, model.PB);
				var validatedForm = function () {
					var _v2 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$PhoneInput$formFieldsValidator(model.agk),
						newForm);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var form = _v3.a;
						return form;
					} else {
						var form = _v2.a;
						return form;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{PB: validatedForm}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var index = msg.a;
				var dropdownMsg = msg.b;
				var phones = $author$project$Utils$Form$fields(model.PB);
				var maybePhone = A2($elm_community$list_extra$List$Extra$getAt, index, phones);
				var _v4 = function () {
					if (!maybePhone.$) {
						var _v6 = maybePhone.a;
						var phone = _v6.a;
						var typeDropdown = _v6.b;
						var regionDropdown = _v6.c;
						var _v7 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, typeDropdown);
						var updatedTypeDropdown = _v7.a;
						var dropdownCmd = _v7.b;
						var updatedPhonesList = A3(
							$elm_community$list_extra$List$Extra$setAt,
							index,
							_Utils_Tuple3(phone, updatedTypeDropdown, regionDropdown),
							phones);
						return _Utils_Tuple2(updatedPhonesList, dropdownCmd);
					} else {
						return _Utils_Tuple2(phones, $elm$core$Platform$Cmd$none);
					}
				}();
				var updatedPhones = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$PhoneInput$formFieldsUpdate,
								$author$project$Components$PhoneInput$Phones(updatedPhones),
								model.PB)
						}),
					cmd);
			default:
				var index = msg.a;
				var dropdownMsg = msg.b;
				var phones = $author$project$Utils$Form$fields(model.PB);
				var maybePhone = A2($elm_community$list_extra$List$Extra$getAt, index, phones);
				var _v8 = function () {
					if (!maybePhone.$) {
						var _v10 = maybePhone.a;
						var phone = _v10.a;
						var typeDropdown = _v10.b;
						var regionDropdown = _v10.c;
						var _v11 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, regionDropdown);
						var updatedRegionDropdown = _v11.a;
						var dropdownCmd = _v11.b;
						var updatedPhonesList = A3(
							$elm_community$list_extra$List$Extra$setAt,
							index,
							_Utils_Tuple3(phone, typeDropdown, updatedRegionDropdown),
							phones);
						return _Utils_Tuple2(updatedPhonesList, dropdownCmd);
					} else {
						return _Utils_Tuple2(phones, $elm$core$Platform$Cmd$none);
					}
				}();
				var updatedPhones = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$PhoneInput$formFieldsUpdate,
								$author$project$Components$PhoneInput$Phones(updatedPhones),
								model.PB)
						}),
					cmd);
		}
	});
var $author$project$Components$Layer$EditForm$EntityTypeValidation = 3;
var $author$project$Components$Layer$EditForm$LegalNameValidation = 0;
var $author$project$Components$Layer$EditForm$PhoneValidation = 4;
var $author$project$Components$Layer$EditForm$StateValidation = 2;
var $author$project$Utils$Form$hasAnyValidationError = function (_v0) {
	var errors_ = _v0.d;
	return !$elm$core$List$isEmpty(errors_);
};
var $author$project$Components$PhoneInput$hasErrors = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(model.PB);
};
var $author$project$Components$Layer$EditForm$formFieldsValidator = function () {
	var validatePhone = function (_v0) {
		var phone = _v0.Wg;
		return $author$project$Components$PhoneInput$hasErrors(phone) ? _List_fromArray(
			[
				_Utils_Tuple2(4, '')
			]) : _List_Nil;
	};
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.SK;
				},
				_Utils_Tuple2(0, 'Please enter a legal name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.sZ;
				},
				_Utils_Tuple2(2, 'Please select a state.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.OK;
				},
				_Utils_Tuple2(3, 'Please enter an entity type.')),
				$rtfeldman$elm_validate$Validate$fromErrors(validatePhone)
			]));
}();
var $author$project$Utils$Form$set = F2(
	function (fields_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var errors_ = _v0.d;
		return A4($author$project$Utils$Form$Form, originalFields, validated_, fields_, errors_);
	});
var $author$project$Utils$Result$merge = function (result) {
	if (!result.$) {
		var ok = result.a;
		return ok;
	} else {
		var err = result.a;
		return err;
	}
};
var $author$project$Components$PhoneInput$validate = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$map,
			function (_v1) {
				var form = _v1.a;
				return _Utils_update(
					model,
					{PB: form});
			},
			A2(
				$elm$core$Result$mapError,
				function (form) {
					return _Utils_update(
						model,
						{PB: form});
				},
				A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$PhoneInput$formFieldsValidator(model.agk),
					model.PB))));
};
var $author$project$Components$Layer$EditForm$validate = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var form_ = A2(
		$author$project$Utils$Form$set,
		_Utils_update(
			fields,
			{
				Wg: $author$project$Components$PhoneInput$validate(fields.Wg)
			}),
		model.PB);
	return A2(
		$elm$core$Result$mapError,
		function (validatedForm) {
			return _Utils_update(
				model,
				{PB: validatedForm});
		},
		A2(
			$elm$core$Result$map,
			function (_v0) {
				var validatedForm = _v0.a;
				var validFormFields = _v0.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{PB: validatedForm}),
					validFormFields);
			},
			A2($author$project$Utils$Form$validate, $author$project$Components$Layer$EditForm$formFieldsValidator, form_)));
};
var $author$project$Components$Layer$EditForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Layer$EditForm$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v2 = $author$project$Utils$Form$fields(model.PB);
				var phone = _v2.Wg;
				var _v3 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v3.a;
				var phoneCmd = _v3.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Layer$EditForm$formFieldsUpdate,
					$author$project$Components$Layer$EditForm$Phone(phoneInput),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Layer$EditForm$PhoneInputMsg, phoneCmd),
					_List_Nil);
			case 2:
				var _v4 = $author$project$Components$Layer$EditForm$validate(model);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newModel = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var phoneNumber = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Gj;
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$Utils$Phone$toRecord,
							$elm$core$List$head(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									$author$project$Components$PhoneInput$getPhones(fields.Wg)))));
					var apiFields = {OK: fields.OK, SK: fields.SK, Wh: phoneNumber, _e: fields._e, sZ: fields.sZ, $F: fields.$F};
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{jY: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Provider$Practice$LayerAccount$update, apiClient, apiFields, $author$project$Components$Layer$EditForm$GotLayerAccountUpdated),
						_List_Nil);
				} else {
					var newModel = _v4.a;
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Account updated successfully')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Ui$Nav$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (msg.$ === 1) {
			var navId = msg.a.aeN;
			var width = msg.a.ahT;
			var left = msg.a.ael;
			return _Utils_eq(navId, model.adR) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{HE: left, HF: width}),
				$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Ports$NavTabs$navTabActiveChanged(model.adR));
		}
	});
var $author$project$Pages$Accounting$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var navMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$Accounting$NavMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newNav) {
								return _Utils_update(
									model,
									{m8: newNav});
							},
							A2($author$project$Ui$Nav$update, navMsg, model.m8))));
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var layerAccount = response.a;
							var editForm = $author$project$Components$Layer$EditForm$init(layerAccount);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										lW: $elm$core$Maybe$Just(editForm),
										yw: response,
										ag7: $author$project$Pages$Accounting$HasLayerAccountAccount(layerAccount)
									}),
								($author$project$Api$Provider$LayerAccount$One$status(layerAccount) === 'active') ? A2($author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve, model.D5, $author$project$Pages$Accounting$GotAccessToken) : $elm$core$Platform$Cmd$none,
								_List_fromArray(
									[$author$project$OutMsg$RefreshPractice]));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{ag7: $author$project$Pages$Accounting$CreateAccount}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pi: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 6:
				var section = msg.a;
				var _v3 = _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve, model.D5, $author$project$Pages$Accounting$GotAccessToken),
								$author$project$Pages$Accounting$updateUrl(section)
							])));
				var accessToken = _v3.a;
				var sectionCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pi: accessToken, cn: section}),
					sectionCmd,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v4 = model.lW;
				if (!_v4.$) {
					var editForm = _v4.a;
					var _v5 = A3($author$project$Components$Layer$EditForm$update, model.D5, subMsg, editForm);
					var editForm_ = _v5.a;
					var editFormCmd = _v5.b;
					var editFormOutMsg = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lW: $elm$core$Maybe$Just(editForm_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Accounting$EditFormMsg, editFormCmd),
						editFormOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var subMsg = msg.a;
				var createFormResult = A3($author$project$Components$Layer$CreateForm$update, model.D5, subMsg, model.lA);
				var status = function () {
					var _v6 = createFormResult.l6;
					if (!_v6.$) {
						return model.ag7;
					} else {
						var layerAccount = _v6.a;
						return $author$project$Pages$Accounting$HasLayerAccountAccount(layerAccount);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lA: createFormResult.y8, ag7: status}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Accounting$CreateFormMsg, createFormResult.EC),
					createFormResult.as);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ag7: $author$project$Pages$Accounting$Loading}),
					A2($author$project$Api$Provider$Practice$LayerAccount$activate, model.D5, $author$project$Pages$Accounting$GotLayerAccount),
					_List_Nil);
		}
	});
var $author$project$Api$Feature$AccountingWithoutBookkeeping = 16;
var $author$project$Ui$Panel$Body = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Panel$body = $author$project$Ui$Panel$Body;
var $author$project$Ui$Panel$Footer = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Panel$footer = $author$project$Ui$Panel$Footer;
var $author$project$Ui$Panel$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Panel$heading = $author$project$Ui$Panel$Heading;
var $author$project$Ui$Element$Alignment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Alignment$Content = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Alignment$FlexCenter = 1;
var $author$project$Ui$Alignment$justifyCenter = $author$project$Ui$Alignment$Content(1);
var $author$project$Ui$Element$justifyCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$justifyCenter);
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Ui$Typography$Color = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Typography$Muted = 0;
var $author$project$Ui$Typography$muted = $author$project$Ui$Typography$Color(0);
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Api$Phi$maskElement = $elm$html$Html$Attributes$class('fs-mask');
var $author$project$Api$Phi$displayAttr = _List_fromArray(
	[
		$author$project$Api$Phi$maskElement,
		A2($elm$html$Html$Attributes$attribute, 'data-recording-sensitive', '')
	]);
var $author$project$Ui$Alignment$toClassName = function (alignment) {
	switch (alignment.$) {
		case 0:
			switch (alignment.a) {
				case 0:
					var _v1 = alignment.a;
					return 'text-left';
				case 1:
					var _v2 = alignment.a;
					return 'text-center';
				default:
					var _v3 = alignment.a;
					return 'text-right';
			}
		case 1:
			switch (alignment.a) {
				case 0:
					var _v4 = alignment.a;
					return 'flex items-start';
				case 1:
					var _v5 = alignment.a;
					return 'flex items-center';
				default:
					var _v6 = alignment.a;
					return 'flex items-end';
			}
		case 2:
			switch (alignment.a) {
				case 0:
					var _v7 = alignment.a;
					return 'flex justify-start';
				case 1:
					var _v8 = alignment.a;
					return 'flex justify-center';
				default:
					var _v9 = alignment.a;
					return 'flex justify-end';
			}
		case 3:
			switch (alignment.a) {
				case 1:
					var _v10 = alignment.a;
					return 'flex justify-around';
				case 0:
					var _v11 = alignment.a;
					return 'flex justify-between';
				default:
					var _v12 = alignment.a;
					return 'flex justify-evenly';
			}
		default:
			switch (alignment.a) {
				case 0:
					var _v13 = alignment.a;
					return 'flex self-start';
				case 1:
					var _v14 = alignment.a;
					return 'flex self-center';
				default:
					var _v15 = alignment.a;
					return 'flex self-end';
			}
	}
};
var $author$project$Ui$Alignment$toAttrs = function (alignment) {
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$class(
			$author$project$Ui$Alignment$toClassName(alignment))
		]);
};
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Ui$OverflowWrap$toAttrs = function (overflowWrap) {
	var value = function () {
		switch (overflowWrap) {
			case 3:
				return 'wrap-word';
			case 0:
				return 'break-word';
			case 2:
				return 'anywhere';
			case 1:
				return 'normal';
			default:
				return 'break-all';
		}
	}();
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'overflow-wrap', value)
		]);
};
var $author$project$Ui$FontWeight$toClass = function (direction) {
	if (!direction) {
		return $elm$html$Html$Attributes$class('font-weight-medium');
	} else {
		return $elm$html$Html$Attributes$class('font-weight-normal');
	}
};
var $author$project$Ui$Margin$toClass = function (margin) {
	switch (margin) {
		case 0:
			return $elm$html$Html$Attributes$class('mb-0');
		case 5:
			return $elm$html$Html$Attributes$class('mb-2');
		case 1:
			return $elm$html$Html$Attributes$class('mb-025');
		case 2:
			return $elm$html$Html$Attributes$class('mb-075');
		case 3:
			return $elm$html$Html$Attributes$class('mb-2em');
		case 4:
			return $elm$html$Html$Attributes$class('mb-10');
		case 19:
			return $elm$html$Html$Attributes$class('mt-0');
		case 6:
			return $elm$html$Html$Attributes$class('mt-05');
		case 7:
			return $elm$html$Html$Attributes$class('mt-075');
		case 8:
			return $elm$html$Html$Attributes$class('mt-2');
		case 9:
			return $elm$html$Html$Attributes$class('mt-4');
		case 20:
			return $elm$html$Html$Attributes$class('mt-05');
		case 10:
			return $elm$html$Html$Attributes$class('ml-05');
		case 11:
			return $elm$html$Html$Attributes$class('ml-1');
		case 12:
			return $elm$html$Html$Attributes$class('ml-2');
		case 13:
			return $elm$html$Html$Attributes$class('ml-30');
		case 21:
			return $elm$html$Html$Attributes$class('mt-1');
		case 18:
			return $elm$html$Html$Attributes$class('mt-3');
		case 22:
			return $elm$html$Html$Attributes$class('mt-8');
		case 14:
			return $elm$html$Html$Attributes$class('mr-05');
		case 15:
			return $elm$html$Html$Attributes$class('mr-1');
		case 16:
			return $elm$html$Html$Attributes$class('mr-2');
		case 17:
			return $elm$html$Html$Attributes$class('mr-4');
		case 23:
			return $elm$html$Html$Attributes$class('nmx-1');
		case 24:
			return $elm$html$Html$Attributes$class('mx-05');
		default:
			return $elm$html$Html$Attributes$class('m-0');
	}
};
var $author$project$Ui$Padding$toClass = function (margin) {
	switch (margin) {
		case 0:
			return $elm$html$Html$Attributes$class('p-0');
		case 1:
			return $elm$html$Html$Attributes$class('pl-0');
		case 2:
			return $elm$html$Html$Attributes$class('pl-05');
		case 3:
			return $elm$html$Html$Attributes$class('pl-2');
		case 4:
			return $elm$html$Html$Attributes$class('pr-2');
		case 5:
			return $elm$html$Html$Attributes$class('pt-0');
		case 7:
			return $elm$html$Html$Attributes$class('pt-05');
		case 6:
			return $elm$html$Html$Attributes$class('pt-1');
		case 8:
			return $elm$html$Html$Attributes$class('pb-1');
		case 9:
			return $elm$html$Html$Attributes$class('pb-3');
		case 10:
			return $elm$html$Html$Attributes$class('px-1');
		default:
			return $elm$html$Html$Attributes$class('px-2');
	}
};
var $author$project$Ui$Pull$toClass = function (direction) {
	if (!direction) {
		return $elm$html$Html$Attributes$class('pull-left');
	} else {
		return $elm$html$Html$Attributes$class('pull-right');
	}
};
var $author$project$Ui$Typography$optionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			var list = option.a;
			return list;
		case 2:
			var alignment = option.a;
			return $author$project$Ui$Alignment$toAttrs(alignment);
		case 3:
			var overflowWrap_ = option.a;
			return $author$project$Ui$OverflowWrap$toAttrs(overflowWrap_);
		case 4:
			var decoration = option.a;
			switch (decoration) {
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('italic')
						]);
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('underline')
						]);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-strike')
						]);
				case 3:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('font-bold')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-capitalized')
						]);
			}
		case 1:
			var color = option.a;
			switch (color) {
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-muted')
						]);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-primary')
						]);
				case 5:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-danger')
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-success')
						]);
				case 4:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-warning')
						]);
				case 3:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-info')
						]);
				case 6:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-dark-gray')
						]);
				case 7:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-gray')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-main')
						]);
			}
		case 5:
			var direction = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$Pull$toClass(direction)
				]);
		case 6:
			var bool = option.a;
			return bool ? $author$project$Api$Phi$displayAttr : _List_Nil;
		case 7:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-xs')
				]);
		case 8:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-body-sm text-muted')
				]);
		case 9:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('help-text')
				]);
		case 10:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('amount')
				]);
		case 11:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('badge')
				]);
		case 12:
			var margin_ = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$Margin$toClass(margin_)
				]);
		case 13:
			var padding_ = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$Padding$toClass(padding_)
				]);
		case 14:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('control-label')
				]);
		case 15:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('pre-wrap')
				]);
		case 16:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('ellipsis')
				]);
		case 17:
			var fontWeight_ = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$FontWeight$toClass(fontWeight_)
				]);
		case 18:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-label-md text-muted')
				]);
		case 19:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('numeric')
				]);
		case 20:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('created-by')
				]);
		case 21:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('authorization_code')
				]);
		case 22:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('long-text')
				]);
		case 23:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('subtotal')
				]);
		case 24:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('membership-savings')
				]);
		case 25:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-3')
				]);
		case 26:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-4')
				]);
		case 27:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('display-5')
				]);
		case 28:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('age')
				]);
		case 29:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('xs:hidden')
				]);
		case 30:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('sm:hidden')
				]);
		case 31:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('md:hidden')
				]);
		case 32:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('title-separator')
				]);
		case 33:
			var bool = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('content-disabled', bool)
						]))
				]);
		case 34:
			var bool = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inactive', bool)
						]))
				]);
		case 35:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]);
		case 36:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('highlighted')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full')
				]);
	}
};
var $author$project$Ui$Typography$optionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$Typography$optionToAttributes, options));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Ui$Typography$p = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$p,
			$author$project$Ui$Typography$optionsToAttributes(options),
			content);
	});
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Ui$Typography$headingSm = function (content) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$elm$html$Html$h4,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-heading-sm text-main')
				]),
			content));
};
var $author$project$Ui$Panel$title = function (contents) {
	return $author$project$Ui$Typography$headingSm(contents);
};
var $author$project$Components$Layer$CreateForm$CreateLayerAccount = {$: 1};
var $author$project$Ui$Form$Horizontal = {$: 0};
var $author$project$Ui$Form$horizontal = $author$project$Ui$Form$Horizontal;
var $author$project$Ui$Form$OnSubmit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$onSubmit = $author$project$Ui$Form$OnSubmit;
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Ui$Form$defaultOptions = {vz: true, x0: false, x7: false, zA: false, zR: $elm$core$Maybe$Nothing, Cm: false};
var $author$project$Ui$Form$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						return _Utils_update(
							record,
							{x0: true});
					case 4:
						return _Utils_update(
							record,
							{x7: true});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{zA: bool});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{vz: bool});
					case 3:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								zR: $elm$core$Maybe$Just(msg)
							});
					default:
						return _Utils_update(
							record,
							{Cm: true});
				}
			}),
		$author$project$Ui$Form$defaultOptions,
		options);
};
var $author$project$Ui$Form$view = F2(
	function (options, contents) {
		var optionsRecord = $author$project$Ui$Form$optionsToRecord(options);
		return A2(
			$elm$html$Html$form,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('form-horizontal', optionsRecord.x0),
							_Utils_Tuple2('form-inline', optionsRecord.x7),
							_Utils_Tuple2('form-signup', optionsRecord.Cm)
						])),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$novalidate(optionsRecord.zA),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$autocomplete(optionsRecord.vz),
						function () {
							var _v0 = optionsRecord.zR;
							if (!_v0.$) {
								var onSubmit_ = _v0.a;
								return _List_fromArray(
									[
										$elm$html$Html$Events$onSubmit(onSubmit_)
									]);
							} else {
								return _List_Nil;
							}
						}()))),
			contents);
	});
var $author$project$Components$Layer$CreateForm$BookkeepingTermsAccepted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Layer$CreateForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$HintUrls$accountingBookkeepingTermsUrl = 'https://www.hint.com/layer-terms-annex-c';
var $author$project$Ui$Link$ExternalHref = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Ui$Link$defaultOptions = {vw: _List_Nil, du: false, mr: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, qP: _List_Nil, x2: $elm$core$Maybe$Nothing, qQ: _List_Nil, d: $elm$core$Maybe$Nothing, su: _List_Nil, tb: 0};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$SvgIcon$Md = 2;
var $author$project$Ui$SvgIcon$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$SvgIcon$base = $author$project$Ui$SvgIcon$Size(2);
var $author$project$Ui$SvgIcon$Lg = 3;
var $author$project$Ui$SvgIcon$lg = $author$project$Ui$SvgIcon$Size(3);
var $author$project$Ui$SvgIcon$Sm = 1;
var $author$project$Ui$SvgIcon$sm = $author$project$Ui$SvgIcon$Size(1);
var $author$project$Ui$SvgIcon$Xs = 0;
var $author$project$Ui$SvgIcon$xs = $author$project$Ui$SvgIcon$Size(0);
var $author$project$Ui$Link$sizeToIconSize = function (size_) {
	switch (size_) {
		case 1:
			return _List_fromArray(
				[$author$project$Ui$SvgIcon$xs]);
		case 0:
			return _List_fromArray(
				[$author$project$Ui$SvgIcon$sm]);
		case 2:
			return _List_fromArray(
				[$author$project$Ui$SvgIcon$base]);
		default:
			return _List_fromArray(
				[$author$project$Ui$SvgIcon$lg]);
	}
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Utils$Html$Attributes$test = $elm$html$Html$Attributes$attribute('data-test');
var $author$project$Ui$Link$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var route_ = option.a;
						return _Utils_update(
							record,
							{
								d: $elm$core$Maybe$Just(route_)
							});
					case 1:
						var list = option.a;
						return _Utils_update(
							record,
							{
								su: _Utils_ap(list, record.su)
							});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{
								mr: $elm$core$Maybe$Just(string)
							});
					case 3:
						var string = option.a;
						return _Utils_update(
							record,
							{
								mr: $elm$core$Maybe$Just('mailto:' + string)
							});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								mr: $elm$core$Maybe$Just('tel:' + string)
							});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.vw)
							});
					case 8:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onClick(msg),
									record.vw)
							});
					case 6:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$target('_blank'),
									record.vw)
							});
					case 7:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('w-full block'),
									record.vw)
							});
					case 9:
						var side = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Pull$toClass(side),
									record.vw)
							});
					case 10:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('disabled', bool)
												])),
										record.vw))
							});
					case 11:
						var margin_ = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Margin$toClass(margin_),
									record.vw)
							});
					case 12:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('text-muted pointer'),
									record.vw)
							});
					case 14:
						var size = option.a;
						var modifier = function () {
							switch (size) {
								case 1:
									return '--xs';
								case 0:
									return '--sm';
								case 2:
									return '--md';
								default:
									return '--lg';
							}
						}();
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('link' + modifier),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('button' + modifier, record.du)
												])),
										record.vw)),
								qP: _Utils_ap(
									$author$project$Ui$Link$sizeToIconSize(size),
									record.qP),
								qQ: _Utils_ap(
									$author$project$Ui$Link$sizeToIconSize(size),
									record.qQ)
							});
					case 13:
						var style_ = option.a;
						switch (style_) {
							case 0:
								return _Utils_update(
									record,
									{
										vw: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--primary'),
											record.vw),
										du: true
									});
							case 1:
								return _Utils_update(
									record,
									{
										vw: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--success'),
											record.vw),
										du: true
									});
							case 2:
								return _Utils_update(
									record,
									{
										vw: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--default'),
											record.vw),
										du: true
									});
							case 3:
								return _Utils_update(
									record,
									{
										vw: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--secondary'),
											record.vw),
										du: true
									});
							case 4:
								return _Utils_update(
									record,
									{
										vw: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('button button--warning'),
											record.vw),
										du: true
									});
							default:
								return _Utils_update(
									record,
									{
										vw: A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$class('underline'),
											record.vw)
									});
						}
					case 15:
						var icon_ = option.a;
						return _Utils_update(
							record,
							{
								QG: $elm$core$Maybe$Just(icon_)
							});
					case 16:
						var iconRight_ = option.a;
						return _Utils_update(
							record,
							{
								x2: $elm$core$Maybe$Just(iconRight_)
							});
					case 17:
						var label = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-label', label),
									record.vw)
							});
					case 18:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('text-current'),
									record.vw)
							});
					default:
						var _int = option.a;
						return _Utils_update(
							record,
							{tb: _int});
				}
			}),
		$author$project$Ui$Link$defaultOptions,
		options);
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Link$view = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Link$optionsToRecord(options);
		return A2(
			$elm$html$Html$a,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('link', !optionsRecord.du)
								]))
						]),
						function () {
						var _v0 = _Utils_Tuple2(optionsRecord.d, optionsRecord.mr);
						if (!_v0.a.$) {
							var route_ = _v0.a.a;
							return _List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									_Utils_ap(
										$author$project$Spa$Generated$Route$toString(route_),
										$elm$url$Url$Builder$toQuery(optionsRecord.su)))
								]);
						} else {
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var string = _v0.b.a;
								return _List_fromArray(
									[
										$elm$html$Html$Attributes$href(string)
									]);
							} else {
								var _v2 = _v0.a;
								var _v3 = _v0.b;
								return _List_Nil;
							}
						}
					}(),
						_List_fromArray(
						[
							$elm$html$Html$Attributes$tabindex(optionsRecord.tb)
						]),
						optionsRecord.vw
					])),
			_List_fromArray(
				[
					function () {
					var _v4 = optionsRecord.QG;
					if (!_v4.$) {
						var icon_ = _v4.a;
						return icon_(optionsRecord.qP);
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('link__content')
						]),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						content)),
					function () {
					var _v5 = optionsRecord.x2;
					if (!_v5.$) {
						var iconRight_ = _v5.a;
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ml-2')
								]),
							_List_fromArray(
								[
									iconRight_(optionsRecord.qQ)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Ui$Link$externalHref = F3(
	function (externalHref_, options, content) {
		return A2(
			$author$project$Ui$Link$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$ExternalHref(externalHref_),
				options),
			content);
	});
var $author$project$Ui$Form$Group$InputGrid = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Group$spanToWidthClass = function (span) {
	return (span === 12) ? 'w-full' : ('w-' + ($elm$core$String$fromInt(span) + '/12'));
};
var $author$project$Ui$Form$Group$inputSpan = function (span) {
	return $author$project$Ui$Form$Group$InputGrid(
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Form$Group$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Group$Plain = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Group$label = A2($elm$core$Basics$composeR, $author$project$Ui$Form$Group$Plain, $author$project$Ui$Form$Group$Label);
var $author$project$Ui$Form$Group$LabelGrid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Group$labelSpan = function (span) {
	return $author$project$Ui$Form$Group$LabelGrid(
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Form$Checkbox$OnCheck = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Checkbox$onCheck = $author$project$Ui$Form$Checkbox$OnCheck;
var $author$project$Ui$Form$Checkbox$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Checkbox$required = $author$project$Ui$Form$Checkbox$Required;
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Ui$Typography$strong = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$strong,
			$author$project$Ui$Typography$optionsToAttributes(options),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($elm$core$Basics$never),
				content));
	});
var $author$project$Ui$Link$TargetBlank = {$: 6};
var $author$project$Ui$Link$targetBlank = $author$project$Ui$Link$TargetBlank;
var $author$project$Utils$Form$errorBelongsToGroup = F2(
	function (currentValidationGroup, _v0) {
		var validationGroup = _v0.a;
		var error = _v0.b;
		return _Utils_eq(currentValidationGroup, validationGroup) ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
	});
var $author$project$Utils$Form$validationErrors = F2(
	function (validationGroup, _v0) {
		var errors_ = _v0.d;
		return A2(
			$elm$core$List$filterMap,
			$author$project$Utils$Form$errorBelongsToGroup(validationGroup),
			errors_);
	});
var $author$project$Ui$Form$Checkbox$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Checkbox$value = $author$project$Ui$Form$Checkbox$Value;
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$Ui$Alignment$toClass = function (alignment) {
	return $elm$html$Html$Attributes$class(
		$author$project$Ui$Alignment$toClassName(alignment));
};
var $author$project$Ui$ScreenSize$toClassPrefix = function (screenSize) {
	switch (screenSize) {
		case 0:
			return '';
		case 1:
			return 'sm:';
		case 2:
			return 'md:';
		case 3:
			return 'lg:';
		default:
			return 'xl:';
	}
};
var $author$project$Ui$Element$optionToAttribute = function (option) {
	switch (option.$) {
		case 1:
			var alignment = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$Alignment$toClass(alignment)
				]);
		case 0:
			var screenSize = option.a;
			var display = option.b;
			return $elm$core$List$singleton(
				function () {
					switch (display) {
						case 0:
							return $elm$html$Html$Attributes$class(
								$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'block');
						case 1:
							return $elm$html$Html$Attributes$class(
								$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'inline-block');
						default:
							return $elm$html$Html$Attributes$class(
								$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex');
					}
				}());
		case 2:
			var paddingClass = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(paddingClass)
				]);
		case 3:
			var marginClass = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(marginClass)
				]);
		case 5:
			var style = option.a;
			return $elm$core$List$singleton(
				function () {
					switch (style) {
						case 0:
							return $elm$html$Html$Attributes$class('text-muted');
						case 1:
							return $elm$html$Html$Attributes$class('text-body-sm');
						case 2:
							return $elm$html$Html$Attributes$class('text-body-md');
						case 3:
							return $elm$html$Html$Attributes$class('font-bold');
						default:
							return $elm$html$Html$Attributes$class('text-danger');
					}
				}());
		case 6:
			var testString = option.a;
			return _List_fromArray(
				[
					$author$project$Utils$Html$Attributes$test(testString)
				]);
		case 4:
			var _v3 = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('bg-primary-50')
				]);
		case 7:
			var screenSize = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden')
				]);
		case 8:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex flex-wrap')
				]);
		case 9:
			var val = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'flex gap-' + $elm$core$String$fromInt(val))
				]);
		case 10:
			var val = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'space-x-' + $elm$core$String$fromInt(val))
				]);
		case 11:
			var val = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					'space-y-' + $elm$core$String$fromInt(val))
				]);
		case 12:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('flex-auto')
				]);
		case 13:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('items-stretch')
				]);
		case 14:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('h-full')
				]);
		case 15:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full')
				]);
		case 16:
			return $author$project$Api$Phi$displayAttr;
		default:
			var screenSize = option.a;
			var dir = option.b;
			return $elm$core$List$singleton(
				function () {
					if (!dir) {
						return $elm$html$Html$Attributes$class(
							$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex-row');
					} else {
						return $elm$html$Html$Attributes$class(
							$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex-col');
					}
				}());
	}
};
var $author$project$Ui$Element$optionsToAttributes = $elm$core$List$concatMap(
	A2(
		$elm$core$Basics$composeR,
		$author$project$Ui$Element$optionToAttribute,
		$elm$core$List$map(
			$elm$html$Html$Attributes$map($elm$core$Basics$never))));
var $author$project$Ui$Element$customNode = F3(
	function (node, classes, options) {
		return A2(
			$elm$html$Html$node,
			node,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class(classes),
				$author$project$Ui$Element$optionsToAttributes(options)));
	});
var $author$project$Ui$Element$custom = F2(
	function (classes, options) {
		return A3($author$project$Ui$Element$customNode, 'div', classes, options);
	});
var $author$project$Ui$Element$view = $author$project$Ui$Element$custom('');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $author$project$Ui$Form$Checkbox$defaultOptions = {hK: _List_Nil, pY: _List_Nil, fE: _List_Nil, Q0: _List_Nil, d8: _List_Nil};
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $author$project$Ui$Form$Checkbox$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var val = option.a;
						return _Utils_update(
							record,
							{
								Q0: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$checked(val),
									record.Q0)
							});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								Q0: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$required(bool),
									record.Q0),
								d8: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('label-required', bool)
											])),
									record.d8)
							});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								Q0: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									record.Q0),
								d8: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('text-muted', bool)
											])),
									record.d8)
							});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								Q0: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									record.Q0),
								d8: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('text-muted', bool)
											])),
									record.d8)
							});
					case 2:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								Q0: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onCheck(toMsg),
									record.Q0)
							});
					case 5:
						var attributes = option.a;
						return _Utils_update(
							record,
							{
								hK: _Utils_ap(
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										attributes),
									record.hK)
							});
					case 6:
						var attributes = option.a;
						return _Utils_update(
							record,
							{
								pY: _Utils_ap(
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										attributes),
									record.pY)
							});
					case 7:
						return _Utils_update(
							record,
							{
								hK: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('inline-block'),
									record.hK)
							});
					default:
						var errors_ = option.a;
						return _Utils_update(
							record,
							{fE: errors_});
				}
			}),
		$author$project$Ui$Form$Checkbox$defaultOptions,
		options);
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Utils$Html$empty = $elm$html$Html$text('');
var $author$project$Utils$FormErrors$viewError = function (error) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-danger')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Utils$FormErrors$view = function (errorList) {
	return $elm$core$List$isEmpty(errorList) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, $author$project$Utils$FormErrors$viewError, errorList));
};
var $author$project$Ui$Form$Checkbox$view = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Form$Checkbox$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('checkbox'),
				optionsRecord.hK),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					optionsRecord.d8,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('checkbox'),
								optionsRecord.Q0),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							optionsRecord.pY,
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$never),
								content)),
							$author$project$Utils$FormErrors$view(optionsRecord.fE)
						]))
				]));
	});
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $author$project$Ui$Form$Group$defaultOptions = {vw: _List_Nil, QG: $elm$core$Maybe$Nothing, mv: _List_Nil, aej: $elm$core$Maybe$Nothing, yr: 'control-label', mN: _List_Nil, ys: $elm$core$Maybe$Nothing, mO: false, agk: false};
var $author$project$Ui$Clearfix$toClass = $elm$html$Html$Attributes$class('clearfix');
var $author$project$Ui$Form$Group$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var lab = option.a;
						return _Utils_update(
							record,
							{
								aej: $elm$core$Maybe$Just(lab)
							});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{agk: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{
								mN: _Utils_ap(record.mN, list)
							});
					case 4:
						var list = option.a;
						return _Utils_update(
							record,
							{
								mv: _Utils_ap(record.mv, list)
							});
					case 2:
						var side = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Pull$toClass(side),
									record.vw)
							});
					case 5:
						var list = option.a;
						return _Utils_update(
							record,
							{
								ys: $elm$core$Maybe$Just(list)
							});
					case 6:
						var list = option.a;
						return _Utils_update(
							record,
							{yr: list});
					case 7:
						return _Utils_update(
							record,
							{
								vw: A2($elm$core$List$cons, $author$project$Ui$Clearfix$toClass, record.vw)
							});
					case 8:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('form-inline'),
									record.vw)
							});
					case 9:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('has-error', bool)
											])),
									record.vw)
							});
					case 10:
						var margin_ = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Margin$toClass(margin_),
									record.vw)
							});
					case 11:
						return _Utils_update(
							record,
							{mO: true});
					case 12:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.vw)
							});
					case 13:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('form-group--label-above'),
									record.vw)
							});
					default:
						var icon_ = option.a;
						return _Utils_update(
							record,
							{
								QG: $elm$core$Maybe$Just(icon_)
							});
				}
			}),
		$author$project$Ui$Form$Group$defaultOptions,
		options);
};
var $author$project$Ui$Typography$Attr = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Typography$attrs = function (attributes) {
	return $author$project$Ui$Typography$Attr(attributes);
};
var $author$project$Ui$Typography$label = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				$elm$html$Html$label,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('text-label-md'),
					$author$project$Ui$Typography$optionsToAttributes(options)),
				content));
	});
var $author$project$Utils$String$noBreakSpace = $elm$core$String$fromChar('\u00A0');
var $author$project$Utils$Html$noBreakSpace = $elm$html$Html$text($author$project$Utils$String$noBreakSpace);
var $author$project$Api$Phi$phiSafe = function (content) {
	return A2($elm$html$Html$span, $author$project$Api$Phi$displayAttr, content);
};
var $author$project$Api$Phi$text = function (_v0) {
	var string = _v0;
	return $author$project$Api$Phi$phiSafe(
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Ui$Form$Group$viewLabel = function (options) {
	var _v0 = options.aej;
	if (!_v0.$) {
		var label_ = _v0.a;
		var labelHtml_ = function () {
			switch (label_.$) {
				case 0:
					var html = label_.a;
					return A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						html);
				case 1:
					var lab = label_.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(lab)
						]);
				default:
					var lab = label_.a;
					return _List_fromArray(
						[
							$author$project$Api$Phi$text(lab)
						]);
			}
		}();
		var iconHtml = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (icon_) {
					return _List_fromArray(
						[icon_]);
				},
				options.QG));
		return A2(
			$author$project$Ui$Typography$label,
			_List_fromArray(
				[
					$author$project$Ui$Typography$attrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(options.yr),
							$elm$html$Html$Attributes$class(
							A2($elm$core$String$join, ' ', options.mN)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('label-required', options.agk)
								]))
						]))
				]),
			_Utils_ap(
				iconHtml,
				_Utils_ap(
					labelHtml_,
					_List_fromArray(
						[
							options.agk ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-group__required')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('*')
								])) : $elm$html$Html$text(''),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$elm$html$Html$div(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form-group__help')
											]))),
								options.ys)),
							options.mO ? $author$project$Utils$Html$noBreakSpace : $author$project$Utils$Html$empty
						]))));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Ui$Form$Group$viewLegend = function (options) {
	var _v0 = options.aej;
	if ((!_v0.$) && (_v0.a.$ === 1)) {
		var label_ = _v0.a.a;
		return A2(
			$elm$html$Html$legend,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label_)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Ui$Form$Group$view = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Form$Group$optionsToRecord(options);
		return A2(
			$elm$html$Html$fieldset,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('form-group'),
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.vw)),
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$viewLegend(optionsRecord),
					(!optionsRecord.mO) ? $author$project$Ui$Form$Group$viewLabel(optionsRecord) : $author$project$Utils$Html$empty,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-group__content'),
							$elm$html$Html$Attributes$class(
							A2($elm$core$String$join, ' ', optionsRecord.mv))
						]),
					A2(
						$elm$core$List$cons,
						optionsRecord.mO ? $author$project$Ui$Form$Group$viewLabel(optionsRecord) : $author$project$Utils$Html$empty,
						content))
				]));
	});
var $author$project$Components$Layer$CreateForm$viewBookkeepingTermsAcceptedCheckbox = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var bookkeepingTermsAccepted = _v0.abI;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(bookkeepingTermsAccepted),
								$author$project$Ui$Form$Checkbox$required(true),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Components$Layer$CreateForm$FormUpdated, $author$project$Components$Layer$CreateForm$BookkeepingTermsAccepted))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('I agree to this platform\'s '),
										A3(
										$author$project$Ui$Link$externalHref,
										$author$project$Utils$HintUrls$accountingBookkeepingTermsUrl,
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('Bookkeeping Service Addendum.')
											]))
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 2, form))
					]))
			]));
};
var $author$project$Components$Layer$CreateForm$LegalName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Input$Autofocus = function (a) {
	return {$: 20, a: a};
};
var $author$project$Ui$Form$Input$autofocus = $author$project$Ui$Form$Input$Autofocus;
var $author$project$Ui$Form$Input$Errors = function (a) {
	return {$: 19, a: a};
};
var $author$project$Ui$Form$Input$errors = $author$project$Ui$Form$Input$Errors;
var $author$project$Utils$Form$hasValidationErrors = F2(
	function (validationGroup, form) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Utils$Form$validationErrors, validationGroup, form));
	});
var $author$project$Ui$Form$Input$Invalid = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Input$invalid = $author$project$Ui$Form$Input$Invalid;
var $author$project$Ui$Form$Input$OnInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Input$onInput = $author$project$Ui$Form$Input$OnInput;
var $author$project$Ui$Form$Input$Placeholder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Input$placeholder = $author$project$Ui$Form$Input$Placeholder;
var $author$project$Ui$Form$Group$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Group$required = $author$project$Ui$Form$Group$Required;
var $author$project$Ui$Form$Input$Value = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Input$value = $author$project$Ui$Form$Input$Value;
var $author$project$Ui$Form$Input$inputTypeToAttributes = function (type_) {
	switch (type_.$) {
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('tel')
				]);
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('text'),
					A2($elm$html$Html$Attributes$attribute, 'inputmode', 'decimal')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('url')
				]);
		case 4:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('email')
				]);
		case 5:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_('password')
				]);
		default:
			var otherType = type_.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$type_(otherType)
				]);
	}
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $author$project$Ui$Form$Input$onNumberInput = F2(
	function (prevValue, tagger) {
		return A2(
			$elm$html$Html$Events$on,
			'input',
			A2(
				$elm$json$Json$Decode$map,
				function (val) {
					var _v0 = _Utils_Tuple2(
						val,
						$elm$core$String$toFloat(val));
					switch (_v0.a) {
						case '':
							return tagger(val);
						case '-':
							return tagger(val);
						default:
							if (!_v0.b.$) {
								return tagger(val);
							} else {
								return tagger(prevValue);
							}
					}
				},
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['target', 'value']),
					$elm$json$Json$Decode$string)));
	});
var $author$project$Ui$Form$Input$optionsToInputHandler = function (optionsRecord) {
	var _v0 = _Utils_Tuple2(optionsRecord.afc, optionsRecord.ahI);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		return _List_Nil;
	} else {
		if (_v0.b.$ === 2) {
			var handler = _v0.a.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					A2($author$project$Ui$Form$Input$onNumberInput, optionsRecord.aaN, handler)
				]);
		} else {
			var handler = _v0.a.a;
			return _List_fromArray(
				[
					$elm$html$Html$Events$onInput(handler)
				]);
		}
	}
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $author$project$Ui$Form$Input$Text = {$: 1};
var $author$project$Ui$Form$Input$defaultOptions = {vw: _List_Nil, fE: _List_Nil, xM: false, xO: false, q$: false, afc: $elm$core$Maybe$Nothing, ahI: $author$project$Ui$Form$Input$Text, aaN: '', DR: _List_Nil, tA: _List_Nil};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Api$Phi$inputAttr = _List_fromArray(
	[
		$author$project$Api$Phi$maskElement,
		A2($elm$html$Html$Attributes$attribute, 'data-recording-ignore', 'mask')
	]);
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $agustinrhcp$elm_mask$Mask$maskedValue = F2(
	function (pattern, val) {
		return $elm$core$String$isEmpty(val) ? $elm$html$Html$Attributes$value('') : $elm$html$Html$Attributes$value(
			A2($agustinrhcp$elm_mask$Mask$mask, pattern, val));
	});
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Utils$Dom$onKeyDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$map, msg, $elm$html$Html$Events$keyCode));
};
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $agustinrhcp$elm_mask$Mask$unMaskRec = F2(
	function (input, pattern) {
		unMaskRec:
		while (true) {
			var _v0 = _Utils_Tuple2(input, pattern);
			_v0$1:
			while (true) {
				if (_v0.a.b) {
					if (_v0.b.b) {
						var _v1 = _v0.a;
						var _char = _v1.a;
						var remainingChar = _v1.b;
						var _v2 = _v0.b;
						var token = _v2.a;
						var remainingTokens = _v2.b;
						switch (token.$) {
							case 2:
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function (_int) {
											return _Utils_ap(
												$elm$core$String$fromInt(_int),
												A2($agustinrhcp$elm_mask$Mask$unMaskRec, remainingChar, remainingTokens));
										},
										$elm$core$String$toInt(
											$elm$core$String$fromChar(_char))));
							case 1:
								return _Utils_ap(
									$elm$core$String$fromChar(_char),
									A2($agustinrhcp$elm_mask$Mask$unMaskRec, remainingChar, remainingTokens));
							default:
								var symbol = token.a;
								if (_Utils_eq(symbol, _char)) {
									var $temp$input = remainingChar,
										$temp$pattern = remainingTokens;
									input = $temp$input;
									pattern = $temp$pattern;
									continue unMaskRec;
								} else {
									return '';
								}
						}
					} else {
						break _v0$1;
					}
				} else {
					if (!_v0.b.b) {
						break _v0$1;
					} else {
						return '';
					}
				}
			}
			return '';
		}
	});
var $agustinrhcp$elm_mask$Mask$unMask = F2(
	function (_v0, string) {
		var pattern = _v0;
		return $elm$core$String$isEmpty(string) ? '' : A2(
			$agustinrhcp$elm_mask$Mask$unMaskRec,
			$elm$core$String$toList(string),
			pattern);
	});
var $agustinrhcp$elm_mask$Mask$isMasked = F2(
	function (pattern, text) {
		return _Utils_eq(
			text,
			A2(
				$agustinrhcp$elm_mask$Mask$mask,
				pattern,
				A2($agustinrhcp$elm_mask$Mask$unMask, pattern, text)));
	});
var $agustinrhcp$elm_mask$Mask$unMaskValue = F3(
	function (pattern, currentValue, maskedNewValue) {
		if ($elm$core$String$isEmpty(maskedNewValue)) {
			return '';
		} else {
			if ($elm$core$String$isEmpty(currentValue)) {
				return A2($agustinrhcp$elm_mask$Mask$isMasked, pattern, maskedNewValue) ? A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue) : A2(
					$agustinrhcp$elm_mask$Mask$unMask,
					pattern,
					A2($agustinrhcp$elm_mask$Mask$mask, pattern, maskedNewValue));
			} else {
				if (_Utils_cmp(
					A2($agustinrhcp$elm_mask$Mask$mask, pattern, currentValue),
					maskedNewValue) > 0) {
					var unmaskedNewValue = A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue);
					return (_Utils_cmp(currentValue, unmaskedNewValue) > 0) ? unmaskedNewValue : A2($elm$core$String$dropRight, 1, currentValue);
				} else {
					return A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue);
				}
			}
		}
	});
var $agustinrhcp$elm_mask$Mask$onMaskedInput = F3(
	function (pattern, currentValue, msg) {
		return $elm$html$Html$Events$onInput(
			A2(
				$elm$core$Basics$composeR,
				A2($agustinrhcp$elm_mask$Mask$unMaskValue, pattern, currentValue),
				msg));
	});
var $author$project$Ui$Form$Input$onOff = function (bool) {
	return bool ? 'on' : 'off';
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Ui$Form$Input$trueFalse = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Ui$Form$Input$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$id(string),
									record.vw)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$placeholder(string),
									record.vw)
							});
					case 2:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								afc: $elm$core$Maybe$Just(handler)
							});
					case 3:
						var string = option.a;
						return _Utils_update(
							record,
							{aaN: string});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									record.vw)
							});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{ahI: string});
					case 7:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('feedback-errored', bool)
											])),
									record.vw),
								q$: bool
							});
					case 8:
						var bool = option.a;
						var phiAttrs = bool ? $author$project$Api$Phi$inputAttr : _List_Nil;
						return _Utils_update(
							record,
							{
								vw: _Utils_ap(phiAttrs, record.vw)
							});
					case 9:
						var pattern = option.a;
						var string = option.b;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($agustinrhcp$elm_mask$Mask$maskedValue, pattern, string),
									record.vw)
							});
					case 10:
						var pattern = option.a;
						var lastValue = option.b;
						var handler = option.c;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A3($agustinrhcp$elm_mask$Mask$onMaskedInput, pattern, lastValue, handler),
									record.vw)
							});
					case 11:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onBlur(handler),
									record.vw)
							});
					case 12:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onClick(handler),
									record.vw)
							});
					case 13:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Utils$Dom$onKeyDown(handler),
									record.vw)
							});
					case 14:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$autocomplete(bool),
									record.vw)
							});
					case 15:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$Attributes$attribute,
										'autocorrect',
										$author$project$Ui$Form$Input$onOff(bool)),
									record.vw)
							});
					case 16:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$Attributes$attribute,
										'autocapitalize',
										$author$project$Ui$Form$Input$onOff(bool)),
									record.vw)
							});
					case 17:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$Attributes$attribute,
										'spellcheck',
										$author$project$Ui$Form$Input$trueFalse(bool)),
									record.vw)
							});
					case 20:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$autofocus(bool),
									record.vw)
							});
					case 18:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								xM: bool,
								tA: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('has-feedback', bool)
											])),
									record.tA)
							});
					case 19:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
					case 21:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$maxlength(_int),
									record.vw)
							});
					case 6:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.vw)
							});
					case 22:
						var html = option.a;
						return _Utils_update(
							record,
							{DR: html});
					case 23:
						var attributes = option.a;
						return _Utils_update(
							record,
							{
								vw: A2($elm$core$List$append, record.vw, attributes)
							});
					case 24:
						var labelled = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-label', labelled),
									record.vw)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{xO: bool});
				}
			}),
		$author$project$Ui$Form$Input$defaultOptions,
		options);
};
var $author$project$Ui$Form$Input$viewErrors = function (option) {
	if (option.$ === 19) {
		var errors_ = option.a;
		return $author$project$Utils$FormErrors$view(errors_);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Form$Input$viewFeedback = function (options) {
	var _v0 = _Utils_Tuple2(options.xM, options.q$);
	if (_v0.a) {
		if (_v0.b) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('has-error form-control__feedback')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('glyphicon form-control-feedback glyphicon-remove')
							]),
						_List_Nil)
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-muted form-control__feedback')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('glyphicon form-control-feedback glyphicon-ok')
							]),
						_List_Nil)
					]));
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Form$Input$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
	var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
	var errorDescription = $elm$core$List$isEmpty(optionsRecord.fE) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$attribute,
			'aria-describedby',
			A2($elm$core$String$join, '. ', optionsRecord.fE))
		]);
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('input-wrapper'),
			optionsRecord.tA),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$Input$viewFeedback(optionsRecord),
						A2(
						$elm$html$Html$input,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('form-control'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(optionsRecord.aaN),
								_Utils_ap(
									$author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.ahI),
									_Utils_ap(
										errorDescription,
										_Utils_ap(optionsRecord.vw, onInputHandler))))),
						_List_Nil)
					]),
					optionsRecord.DR,
					optionsRecord.xO ? _List_Nil : A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
				])));
};
var $author$project$Components$Layer$CreateForm$viewLegalNameInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var legalName = _v0.SK;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Legal Name')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', legalName)),
						$author$project$Ui$Form$Input$placeholder('Legal Name'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$CreateForm$FormUpdated, $author$project$Components$Layer$CreateForm$LegalName)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]));
};
var $author$project$Components$Layer$CreateForm$SoftwareTermsAccepted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$HintUrls$accountingSoftwareTermsUrl = 'https://www.hint.com/layer-terms-annex-b';
var $author$project$Components$Layer$CreateForm$viewSoftwareTermsAcceptedCheckbox = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var softwareTermsAccepted = _v0.ag0;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(softwareTermsAccepted),
								$author$project$Ui$Form$Checkbox$required(true),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Components$Layer$CreateForm$FormUpdated, $author$project$Components$Layer$CreateForm$SoftwareTermsAccepted))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('I agree to this platform\'s '),
										A3(
										$author$project$Ui$Link$externalHref,
										$author$project$Utils$HintUrls$accountingSoftwareTermsUrl,
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accounting Software Terms of Service.')
											]))
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]))
			]));
};
var $author$project$Components$Layer$CreateForm$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$Layer$CreateForm$CreateLayerAccount),
				$author$project$Ui$Form$horizontal
			]),
		_List_fromArray(
			[
				$author$project$Components$Layer$CreateForm$viewLegalNameInput(model.PB),
				$author$project$Components$Layer$CreateForm$viewSoftwareTermsAcceptedCheckbox(model.PB),
				model.vI ? $author$project$Components$Layer$CreateForm$viewBookkeepingTermsAcceptedCheckbox(model.PB) : $elm$html$Html$text('')
			]));
};
var $author$project$Ui$Panel$defaultOptions = {vx: _List_Nil, lu: $elm$core$Maybe$Nothing, s_: 'panel-default', Dh: false};
var $author$project$Ui$Panel$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 4:
						return _Utils_update(
							record,
							{Dh: true});
					case 0:
						var style = option.a;
						switch (style) {
							case 0:
								return _Utils_update(
									record,
									{s_: 'panel--primary'});
							case 1:
								return _Utils_update(
									record,
									{s_: 'panel--success'});
							case 2:
								return _Utils_update(
									record,
									{s_: 'panel--info'});
							case 3:
								return _Utils_update(
									record,
									{s_: 'panel--warning'});
							case 4:
								return _Utils_update(
									record,
									{s_: 'panel--danger'});
							default:
								return _Utils_update(
									record,
									{s_: 'light-grey-panel'});
						}
					case 1:
						return _Utils_update(
							record,
							{
								vx: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('h-full'),
									record.vx)
							});
					case 2:
						return _Utils_update(
							record,
							{
								vx: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('p-6'),
									record.vx)
							});
					case 3:
						return _Utils_update(
							record,
							{
								vx: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('border-left-panel'),
									record.vx)
							});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vx: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('panel--active', bool)
											])),
									record.vx)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								lu: $elm$core$Maybe$Just(bool)
							});
				}
			}),
		$author$project$Ui$Panel$defaultOptions,
		options);
};
var $author$project$Ui$SvgIcon$ChevronDown = 13;
var $author$project$Ui$SvgIcon$Class = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SvgIcon$iconOptionToSvgOption = function (iconOption) {
	return $author$project$Ui$SvgIcon$Class(
		function () {
			switch (iconOption.$) {
				case 0:
					switch (iconOption.a) {
						case 0:
							var _v1 = iconOption.a;
							return 'icon--xs';
						case 1:
							var _v2 = iconOption.a;
							return 'icon--sm';
						case 2:
							var _v3 = iconOption.a;
							return '';
						case 3:
							var _v4 = iconOption.a;
							return 'icon--lg';
						default:
							var _v5 = iconOption.a;
							return 'icon--xl';
					}
				case 1:
					switch (iconOption.a) {
						case 0:
							var _v6 = iconOption.a;
							return 'icon--danger';
						case 1:
							var _v7 = iconOption.a;
							return 'icon--primary';
						case 2:
							var _v8 = iconOption.a;
							return 'icon--info';
						case 3:
							var _v9 = iconOption.a;
							return 'icon--success';
						default:
							var _v10 = iconOption.a;
							return '';
					}
				case 7:
					return 'icon--circled';
				case 2:
					var deg = iconOption.a;
					return 'rotate-' + $elm$core$String$fromInt(deg);
				case 3:
					return 'ml-1';
				case 4:
					return 'mr-1';
				case 5:
					var _int = iconOption.a;
					return 'mb-' + $elm$core$String$fromInt(_int);
				default:
					var deg = iconOption.a;
					return 'rotate-' + $elm$core$String$fromInt(deg);
			}
		}());
};
var $author$project$Ui$SvgIcon$iconOptionsToSvgOptions = function (iconOptions) {
	return A2(
		$elm$core$List$cons,
		$author$project$Ui$SvgIcon$Class('icon'),
		A2($elm$core$List$map, $author$project$Ui$SvgIcon$iconOptionToSvgOption, iconOptions));
};
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
var $author$project$Generated$Icons$account = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1.5 -1.5 19 19'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '0.6'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-linejoin', 'round'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.93596 12.3744C3.76355 11.8095 4.58128 11.3727 5.38916 11.064C6.19704 10.7553 7.06732 10.601 8 10.601C8.93268 10.601 9.80952 10.7553 10.6305 11.064C11.4516 11.3727 12.2693 11.8095 13.0837 12.3744C13.6617 11.665 14.069 10.9557 14.3054 10.2463C14.5419 9.53695 14.6601 8.78818 14.6601 8C14.6601 6.10837 14.023 4.52545 12.7488 3.25123C11.4745 1.97701 9.89163 1.3399 8 1.3399C6.10837 1.3399 4.52545 1.97701 3.25123 3.25123C1.97701 4.52545 1.3399 6.10837 1.3399 8C1.3399 8.78818 1.46141 9.53695 1.70443 10.2463C1.94745 10.9557 2.35796 11.665 2.93596 12.3744ZM8 8.63054C7.22496 8.63054 6.578 8.36782 6.05911 7.84236C5.54023 7.31691 5.28079 6.66667 5.28079 5.89163C5.28079 5.12972 5.54351 4.48604 6.06897 3.96059C6.59442 3.43514 7.2381 3.17241 8 3.17241C8.77504 3.17241 9.422 3.43514 9.94089 3.96059C10.4598 4.48604 10.7192 5.13629 10.7192 5.91133C10.7192 6.67324 10.4565 7.31691 9.93103 7.84236C9.40558 8.36782 8.7619 8.63054 8 8.63054ZM8 16C6.90969 16 5.87849 15.7898 4.9064 15.3695C3.93432 14.9491 3.08374 14.3744 2.35468 13.6453C1.62562 12.9163 1.0509 12.069 0.630542 11.1034C0.210181 10.1379 0 9.10345 0 8C0 6.89655 0.210181 5.86207 0.630542 4.89655C1.0509 3.93103 1.62562 3.08374 2.35468 2.35468C3.08374 1.62562 3.93103 1.0509 4.89655 0.630542C5.86207 0.210181 6.89655 0 8 0C9.10345 0 10.1379 0.210181 11.1034 0.630542C12.069 1.0509 12.9163 1.62562 13.6453 2.35468C14.3744 3.08374 14.9491 3.93103 15.3695 4.89655C15.7898 5.86207 16 6.89655 16 8C16 9.09031 15.7898 10.1215 15.3695 11.0936C14.9491 12.0657 14.3744 12.9163 13.6453 13.6453C12.9163 14.3744 12.069 14.9491 11.1034 15.3695C10.1379 15.7898 9.10345 16 8 16ZM8 14.6601C8.70936 14.6601 9.4023 14.5583 10.0788 14.3547C10.7553 14.1511 11.4286 13.7931 12.0985 13.2808C11.4286 12.8079 10.7553 12.4499 10.0788 12.2069C9.4023 11.9639 8.70936 11.8424 8 11.8424C7.29064 11.8424 6.60099 11.9639 5.93103 12.2069C5.26108 12.4499 4.58457 12.8079 3.90148 13.2808C4.57143 13.7931 5.24466 14.1511 5.92118 14.3547C6.5977 14.5583 7.29064 14.6601 8 14.6601ZM8 7.38916C8.4335 7.38916 8.79146 7.25123 9.07389 6.97537C9.35632 6.69951 9.49754 6.33826 9.49754 5.89163C9.49754 5.45813 9.35632 5.10345 9.07389 4.82759C8.79146 4.55172 8.4335 4.41379 8 4.41379C7.5665 4.41379 7.20854 4.55172 6.92611 4.82759C6.64368 5.10345 6.50246 5.45813 6.50246 5.89163C6.50246 6.33826 6.64368 6.69951 6.92611 6.97537C7.20854 7.25123 7.5665 7.38916 8 7.38916Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$accountPricing = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.1471 27L11.5294 23.2167C11.1961 23.0985 10.8333 22.9261 10.4412 22.6995C10.049 22.4729 9.70588 22.2414 9.41176 22.0049L5.91176 23.6305L3 18.4877L6.23529 16.1232C6.19608 15.9655 6.17157 15.7783 6.16176 15.5616C6.15196 15.3448 6.14706 15.1576 6.14706 15C6.14706 14.8424 6.15196 14.6552 6.16176 14.4384C6.17157 14.2217 6.19608 14.0345 6.23529 13.8768L3 11.5123L5.91176 6.36946L9.44118 7.99507C9.71569 7.75862 10.049 7.53202 10.4412 7.31527C10.8333 7.09852 11.1961 6.93103 11.5294 6.81281L12.1471 3H17.8529L18.4706 6.78325C18.8039 6.92118 19.1716 7.0936 19.5735 7.30049C19.9755 7.50739 20.3137 7.73892 20.5882 7.99507L24.1176 6.36946L27 11.5123L23.7647 13.8177C23.8039 13.9951 23.8284 14.1921 23.8382 14.4089C23.848 14.6256 23.8529 14.8227 23.8529 15C23.8529 15.1773 23.848 15.3695 23.8382 15.5764C23.8284 15.7833 23.8039 15.9754 23.7647 16.1527L27 18.4877L24.0882 23.6305L20.5588 22.0049C20.2843 22.2414 19.9559 22.4778 19.5735 22.7143C19.1912 22.9507 18.8235 23.1182 18.4706 23.2167L17.8529 27H12.1471ZM15 18.8424C16.0588 18.8424 16.9608 18.468 17.7059 17.7192C18.451 16.9704 18.8235 16.064 18.8235 15C18.8235 13.936 18.451 13.0296 17.7059 12.2808C16.9608 11.532 16.0588 11.1576 15 11.1576C13.9412 11.1576 13.0392 11.532 12.2941 12.2808C11.549 13.0296 11.1765 13.936 11.1765 15C11.1765 16.064 11.549 16.9704 12.2941 17.7192C13.0392 18.468 13.9412 18.8424 15 18.8424ZM15 17.069C14.4118 17.069 13.9216 16.867 13.5294 16.4631C13.1373 16.0591 12.9412 15.5714 12.9412 15C12.9412 14.4286 13.1373 13.9409 13.5294 13.5369C13.9216 13.133 14.4118 12.931 15 12.931C15.5686 12.931 16.0539 13.133 16.4559 13.5369C16.8578 13.9409 17.0588 14.4286 17.0588 15C17.0588 15.5714 16.8578 16.0591 16.4559 16.4631C16.0539 16.867 15.5686 17.069 15 17.069ZM13.7647 24.9901H16.2353L16.6471 21.6798C17.2941 21.5222 17.9118 21.2759 18.5 20.9409C19.0882 20.6059 19.6176 20.1921 20.0882 19.6995L23.2059 21.0591L24.3235 19.0197L21.5588 17.0099C21.6373 16.6749 21.7059 16.3399 21.7647 16.0049C21.8235 15.67 21.8529 15.335 21.8529 15C21.8529 14.665 21.8284 14.33 21.7794 13.9951C21.7304 13.6601 21.6569 13.3251 21.5588 12.9901L24.3235 10.9803L23.2059 8.94089L20.0882 10.3005C19.6373 9.76847 19.1225 9.32512 18.5441 8.97044C17.9657 8.61576 17.3333 8.39901 16.6471 8.3202L16.2353 5.00985H13.7647L13.3529 8.3202C12.6863 8.43842 12.0588 8.66995 11.4706 9.01478C10.8824 9.35961 10.3529 9.78818 9.88235 10.3005L6.79412 8.94089L5.67647 10.9803L8.41176 12.9901C8.33333 13.3251 8.26961 13.6601 8.22059 13.9951C8.17157 14.33 8.14706 14.665 8.14706 15C8.14706 15.335 8.17157 15.67 8.22059 16.0049C8.26961 16.3399 8.33333 16.6749 8.41176 17.0099L5.67647 19.0197L6.79412 21.0591L9.88235 19.6995C10.3725 20.1921 10.9118 20.6059 11.5 20.9409C12.0882 21.2759 12.7059 21.5222 13.3529 21.6798L13.7647 24.9901Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$add = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 13 13'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.72183 13V7.27817H0V5.72183H5.72183V0H7.27817V5.72183H13V7.27817H7.27817V13H5.72183Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$admin = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -0.5 21 21'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375V9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625V10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM9.05 18H11.025L11.375 15.35C11.8917 15.2167 12.3708 15.0208 12.8125 14.7625C13.2542 14.5042 13.6583 14.1917 14.025 13.825L16.5 14.85L17.475 13.15L15.325 11.525C15.4083 11.2917 15.4667 11.0458 15.5 10.7875C15.5333 10.5292 15.55 10.2667 15.55 10C15.55 9.73333 15.5333 9.47083 15.5 9.2125C15.4667 8.95417 15.4083 8.70833 15.325 8.475L17.475 6.85L16.5 5.15L14.025 6.2C13.6583 5.81667 13.2542 5.49583 12.8125 5.2375C12.3708 4.97917 11.8917 4.78333 11.375 4.65L11.05 2H9.075L8.725 4.65C8.20833 4.78333 7.72917 4.97917 7.2875 5.2375C6.84583 5.49583 6.44167 5.80833 6.075 6.175L3.6 5.15L2.625 6.85L4.775 8.45C4.69167 8.7 4.63333 8.95 4.6 9.2C4.56667 9.45 4.55 9.71667 4.55 10C4.55 10.2667 4.56667 10.525 4.6 10.775C4.63333 11.025 4.69167 11.275 4.775 11.525L2.625 13.15L3.6 14.85L6.075 13.8C6.44167 14.1833 6.84583 14.5042 7.2875 14.7625C7.72917 15.0208 8.20833 15.2167 8.725 15.35L9.05 18ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$alert = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12 0C5.37187 0 0 5.37188 0 12C0 18.6281 5.37187 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM19.2914 19.2914C18.3445 20.2383 17.2406 20.9836 16.0125 21.5016C14.7422 22.0406 13.3922 22.3125 12 22.3125C10.6078 22.3125 9.25781 22.0406 7.9875 21.5039C6.75938 20.9836 5.65781 20.2406 4.70859 19.2937C3.76172 18.3469 3.01641 17.243 2.49844 16.0148C1.95938 14.7422 1.6875 13.3922 1.6875 12C1.6875 10.6078 1.95938 9.25781 2.49609 7.9875C3.01641 6.75937 3.75938 5.65781 4.70625 4.70859C5.65312 3.76172 6.75703 3.01641 7.98516 2.49844C9.25781 1.95938 10.6078 1.6875 12 1.6875C13.3922 1.6875 14.7422 1.95938 16.0125 2.49609C17.2406 3.01641 18.3422 3.75937 19.2914 4.70625C20.2383 5.65312 20.9836 6.75703 21.5016 7.98516C22.0406 9.25781 22.3125 10.6078 22.3125 12C22.3125 13.3922 22.0406 14.7422 21.5039 16.0125C20.9836 17.2406 20.2406 18.3445 19.2914 19.2914ZM14.7703 16.5375H12.7734V8.33203C12.7734 7.86563 12.3961 7.48828 11.9297 7.48828H11.0859H9.67969C9.21328 7.48828 8.83594 7.86563 8.83594 8.33203C8.83594 8.79844 9.21328 9.17578 9.67969 9.17578H11.0859V16.5375H9.08906C8.62266 16.5375 8.24531 16.9148 8.24531 17.3812C8.24531 17.8477 8.62266 18.225 9.08906 18.225H11.0859H12.7734H14.7703C15.2367 18.225 15.6141 17.8477 15.6141 17.3812C15.6141 16.9148 15.2367 16.5375 14.7703 16.5375ZM11.0859 5.16797C11.0859 4.70198 11.4637 4.32422 11.9297 4.32422C12.3957 4.32422 12.7734 4.70198 12.7734 5.16797C12.7734 5.63396 12.3957 6.01172 11.9297 6.01172C11.4637 6.01172 11.0859 5.63396 11.0859 5.16797Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$apiKey = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M280-400q-33 0-56.5-23.5T200-480q0-33 23.5-56.5T280-560q33 0 56.5 23.5T360-480q0 33-23.5 56.5T280-400Zm0 160q-100 0-170-70T40-480q0-100 70-170t170-70q67 0 121.5 33t86.5 87h352l120 120-180 180-80-60-80 60-85-60h-47q-32 54-86.5 87T280-240Zm0-80q56 0 98.5-34t56.5-86h125l58 41 82-61 71 55 75-75-40-40H435q-14-52-56.5-86T280-640q-66 0-113 47t-47 113q0 66 47 113t113 47Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$app = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M200-120q-33 0-56.5-23.5T120-200v-500q0-14 4.5-26.5T138-750l56-68q9-11 20.5-16.5T240-840h480q14 0 25.5 5.5T766-818l56 68q9 11 13.5 23.5T840-700v500q0 33-23.5 56.5T760-120H200Zm16-600h528l-34-40H250l-34 40Zm-16 520h560v-440H200v440Zm382-78 142-142-142-142-58 58 84 84-84 84 58 58Zm-202 0 58-58-84-84 84-84-58-58-142 142 142 142Zm-180 78v-440 440Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$arrowLeft = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 26'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.7065 25.5066L0 12.8283L12.7565 0.0999985L15.5848 2.8218L7.58705 10.8478H33.237V14.8087H7.58705L15.5348 22.7565L12.7065 25.5066Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$arrowRight = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 35 26'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M21.6215 25.4066L18.7932 22.6565L26.741 14.7087H0.886719V10.7478H26.741L18.7432 2.7218L21.5715 0L34.3281 12.7283L21.6215 25.4066Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$arrowRightBottom = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 8 8'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4.75184 8L3.81094 7.16387L5.45953 5.70371H0V0H1.32826V4.52335H5.45953L3.81094 3.05834L4.74639 2.22222L8 5.11353L4.75184 8Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$book = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 19 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4.5 11C5.15764 11 5.79771 11.0833 6.42021 11.25C7.04285 11.4167 7.65278 11.625 8.25 11.875V2.41667C7.66667 2.11111 7.0625 1.88194 6.4375 1.72917C5.8125 1.57639 5.16514 1.5 4.49542 1.5C3.98236 1.5 3.47292 1.54514 2.96708 1.63542C2.46125 1.72569 1.97222 1.875 1.5 2.08333V11.5C1.98611 11.3194 2.47785 11.191 2.97521 11.1146C3.47271 11.0382 3.98097 11 4.5 11ZM9.75 11.875C10.3472 11.5972 10.9572 11.3819 11.5798 11.2292C12.2023 11.0764 12.8424 11 13.5 11C14.0139 11 14.5243 11.0312 15.0312 11.0938C15.5382 11.1562 16.0278 11.2917 16.5 11.5V2.08333C16.0139 1.90278 15.5195 1.76042 15.0169 1.65625C14.5142 1.55208 14.0081 1.5 13.4983 1.5C12.8328 1.5 12.1875 1.57639 11.5625 1.72917C10.9375 1.88194 10.3333 2.11111 9.75 2.41667V11.875ZM9 14C8.31944 13.5556 7.60417 13.1944 6.85417 12.9167C6.10417 12.6389 5.31944 12.5 4.5 12.5C3.97222 12.5 3.44444 12.5521 2.91667 12.6562C2.38889 12.7604 1.88194 12.9167 1.39583 13.125C1.0625 13.2639 0.746528 13.2394 0.447917 13.0515C0.149306 12.8635 0 12.5894 0 12.2292V1.75C0 1.55556 0.0520833 1.375 0.15625 1.20833C0.260417 1.04167 0.402778 0.916667 0.583333 0.833333C1.20833 0.555556 1.8475 0.347222 2.50083 0.208333C3.15417 0.0694444 3.82056 0 4.5 0C5.29097 0 6.06486 0.09375 6.82167 0.28125C7.57847 0.46875 8.30458 0.75 9 1.125C9.70833 0.763889 10.4388 0.486111 11.1915 0.291667C11.944 0.0972222 12.7135 0 13.5 0C14.1794 0 14.8458 0.0694444 15.4992 0.208333C16.1525 0.347222 16.7917 0.555556 17.4167 0.833333C17.5972 0.916667 17.7431 1.04167 17.8542 1.20833C17.9653 1.375 18.0208 1.55556 18.0208 1.75V12.2292C18.0208 12.5764 17.9132 12.8542 17.6979 13.0625C17.4826 13.2708 17.2569 13.3194 17.0208 13.2083C16.4653 12.9583 15.8925 12.7778 15.3025 12.6667C14.7126 12.5556 14.1118 12.5 13.5 12.5C12.6806 12.5 11.8958 12.6389 11.1458 12.9167C10.3958 13.1944 9.68056 13.5556 9 14Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$burgerMenu = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 2V0H16V2H0ZM0 7H16V5H0V7ZM0 12H16V10H0V12Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$burgerMenuClose = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '8 8 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.92918 9.3427L20.6571 22.0706L22.0713 20.6564L9.34339 7.92849L7.92918 9.3427Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M20.6571 7.92893L7.92913 20.6569L9.34334 22.0711L22.0713 9.34315L20.6571 7.92893Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$businessCenter = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M146.67-120q-27 0-46.84-19.83Q80-159.67 80-186.67v-466.66q0-27 19.83-46.84Q119.67-720 146.67-720H320v-93.33q0-27 19.83-46.84Q359.67-880 386.67-880h186.66q27 0 46.84 19.83Q640-840.33 640-813.33V-720h173.33q27 0 46.84 19.83Q880-680.33 880-653.33v466.66q0 27-19.83 46.84Q840.33-120 813.33-120H146.67Zm240-600h186.66v-93.33H386.67V-720Zm426.66 352.67H580.67v66.66h-200v-66.66h-234v180.66h666.66v-180.66Zm-366 0H514V-434h-66.67v66.67ZM146.67-434h234v-66.67h200V-434h232.66v-219.33H146.67V-434ZM480-400.67Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$calendar = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 20 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$call = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M795-120q-116 0-236.5-56T335-335Q232-438 176-558.5T120-795q0-19.29 12.86-32.14Q145.71-840 165-840h140q14 0 24 10t14 25l26.93 125.64Q372-665 369.5-653.5t-10.73 19.73L259-533q26 44 55 82t64 72q37 38 78 69.5t86 55.5l95-98q10-11 23.15-15 13.15-4 25.85-2l119 26q15 4 25 16.04 10 12.05 10 26.96v135q0 19.29-12.86 32.14Q814.29-120 795-120ZM229-588l81-82-23-110H180q2 42 13.5 88.5T229-588Zm369 363q41 19 89 31t93 14v-107l-103-21-79 83ZM229-588Zm369 363Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$check = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 10 8'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M9.22494 0.671064C9.03255 0.497837 8.73617 0.51337 8.56294 0.705758L3.31035 6.53935L1.44406 4.46663C1.27083 4.27424 0.97444 4.25871 0.782052 4.43193C0.589664 4.60516 0.574131 4.90155 0.747358 5.09394L2.95557 7.54641C3.08001 7.68461 3.268 7.73155 3.43534 7.68281C3.52259 7.66093 3.6045 7.61374 3.66921 7.54186L9.25964 1.33307C9.43286 1.14068 9.41733 0.844291 9.22494 0.671064Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$chevron = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-2 0 13 13'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 2L7 6.5L2 11'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.5'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-linecap', 'square')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$chevronDown = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 8'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M11.9741 0.991346L6.07575 7.84129L0.177371 0.991345L1.06142 0.230102L6.07575 6.05338L11.0901 0.230103L11.9741 0.991346Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$circle = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'circle',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'cx', '12'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'cy', '12'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'r', '10')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$commissions = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-8 -8 64 64'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.5 21C7.6 21 5.125 19.975 3.075 17.925C1.025 15.875 0 13.4 0 10.5C0 7.6 1.025 5.125 3.075 3.075C5.125 1.025 7.6 0 10.5 0C13.4 0 15.875 1.025 17.925 3.075C19.975 5.125 21 7.6 21 10.5C21 13.4 19.975 15.875 17.925 17.925C15.875 19.975 13.4 21 10.5 21ZM10.5 15C11.75 15 12.8125 14.5625 13.6875 13.6875C14.5625 12.8125 15 11.75 15 10.5C15 9.25 14.5625 8.1875 13.6875 7.3125C12.8125 6.4375 11.75 6 10.5 6C9.25 6 8.1875 6.4375 7.3125 7.3125C6.4375 8.1875 6 9.25 6 10.5C6 11.75 6.4375 12.8125 7.3125 13.6875C8.1875 14.5625 9.25 15 10.5 15ZM37.5 48C34.6 48 32.125 46.975 30.075 44.925C28.025 42.875 27 40.4 27 37.5C27 34.6 28.025 32.125 30.075 30.075C32.125 28.025 34.6 27 37.5 27C40.4 27 42.875 28.025 44.925 30.075C46.975 32.125 48 34.6 48 37.5C48 40.4 46.975 42.875 44.925 44.925C42.875 46.975 40.4 48 37.5 48ZM37.5 42C38.75 42 39.8125 41.5625 40.6875 40.6875C41.5625 39.8125 42 38.75 42 37.5C42 36.25 41.5625 35.1875 40.6875 34.3125C39.8125 33.4375 38.75 33 37.5 33C36.25 33 35.1875 33.4375 34.3125 34.3125C33.4375 35.1875 33 36.25 33 37.5C33 38.75 33.4375 39.8125 34.3125 40.6875C35.1875 41.5625 36.25 42 37.5 42ZM4.2 48L0 43.8L43.8 0L48 4.2L4.2 48Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$contact = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 22 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 14.85C2.9 13.9667 3.94583 13.2708 5.1375 12.7625C6.32917 12.2542 7.61667 12 9 12C10.3833 12 11.6708 12.2542 12.8625 12.7625C14.0542 13.2708 15.1 13.9667 16 14.85V2H2V14.85ZM9 10C9.96667 10 10.7917 9.65833 11.475 8.975C12.1583 8.29167 12.5 7.46667 12.5 6.5C12.5 5.53333 12.1583 4.70833 11.475 4.025C10.7917 3.34167 9.96667 3 9 3C8.03333 3 7.20833 3.34167 6.525 4.025C5.84167 4.70833 5.5 5.53333 5.5 6.5C5.5 7.46667 5.84167 8.29167 6.525 8.975C7.20833 9.65833 8.03333 10 9 10ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM3.725 16H14.275C13.5417 15.35 12.7125 14.8542 11.7875 14.5125C10.8625 14.1708 9.93333 14 9 14C8.06667 14 7.12917 14.1708 6.1875 14.5125C5.24583 14.8542 4.425 15.35 3.725 16ZM9 8C8.58333 8 8.22917 7.85417 7.9375 7.5625C7.64583 7.27083 7.5 6.91667 7.5 6.5C7.5 6.08333 7.64583 5.72917 7.9375 5.4375C8.22917 5.14583 8.58333 5 9 5C9.41667 5 9.77083 5.14583 10.0625 5.4375C10.3542 5.72917 10.5 6.08333 10.5 6.5C10.5 6.91667 10.3542 7.27083 10.0625 7.5625C9.77083 7.85417 9.41667 8 9 8Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$copy = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.24141 9.90068V0H11.0769V9.90068H2.24141ZM3.60072 8.62754H9.70315V1.28668H3.60072V8.62754ZM0 12V2.66817H1.37377V10.7133H8.09801V12H0ZM3.60072 8.62754V1.28668V8.62754Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$cross = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 10 9'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.72526 4.20443L9.04297 0.889323C9.24349 0.688802 9.24349 0.364583 9.04297 0.165365C8.84245 -0.0351562 8.51823 -0.0351562 8.31901 0.165365L5 3.47917L1.68099 0.164062C1.48047 -0.0364583 1.15625 -0.0364583 0.957031 0.164062C0.75651 0.364583 0.75651 0.688802 0.957031 0.888021L4.27474 4.20312L0.957031 7.51953C0.75651 7.72005 0.75651 8.04427 0.957031 8.24349C1.05729 8.34375 1.1888 8.39323 1.31901 8.39323C1.45052 8.39323 1.58073 8.34375 1.68099 8.24349L5 4.92839L8.31901 8.24479C8.41927 8.34505 8.54948 8.39453 8.68099 8.39453C8.8125 8.39453 8.94271 8.34505 9.04297 8.24479C9.24349 8.04427 9.24349 7.72005 9.04297 7.52083L5.72526 4.20443Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$crossCircle = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M9.80534 4.18684C9.61257 3.99543 9.30085 3.99543 9.10944 4.18821L6.99987 6.30325L4.8903 4.18821C4.6989 3.99543 4.38718 3.99543 4.1944 4.18684C4.00163 4.37825 4.00163 4.68997 4.19304 4.88274L6.30534 7.00051L4.19304 9.11829C4.00163 9.31106 4.00163 9.62278 4.1944 9.81418C4.29011 9.90989 4.41589 9.95774 4.54167 9.95774C4.66745 9.95774 4.7946 9.90989 4.8903 9.81282L6.99987 7.69778L9.10944 9.81418C9.20515 9.91125 9.33229 9.95911 9.45808 9.95911C9.58386 9.95911 9.70964 9.91125 9.80534 9.81555C9.99811 9.62415 9.99811 9.31243 9.80671 9.11965L7.6944 7.00051L9.80534 4.88274C9.99811 4.68997 9.99811 4.37825 9.80534 4.18684ZM7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM11.2533 11.2533C10.701 11.8057 10.057 12.2404 9.34062 12.5426C8.59961 12.857 7.81211 13.0156 7 13.0156C6.18789 13.0156 5.40039 12.857 4.65938 12.5439C3.94297 12.2404 3.30039 11.807 2.74668 11.2547C2.19434 10.7023 1.75957 10.0584 1.45742 9.34199C1.14297 8.59961 0.984375 7.81211 0.984375 7C0.984375 6.18789 1.14297 5.40039 1.45605 4.65938C1.75957 3.94297 2.19297 3.30039 2.74531 2.74668C3.29766 2.19434 3.9416 1.75957 4.65801 1.45742C5.40039 1.14297 6.18789 0.984375 7 0.984375C7.81211 0.984375 8.59961 1.14297 9.34062 1.45605C10.057 1.75957 10.6996 2.19297 11.2533 2.74531C11.8057 3.29766 12.2404 3.9416 12.5426 4.65801C12.857 5.40039 13.0156 6.18789 13.0156 7C13.0156 7.81211 12.857 8.59961 12.5439 9.34062C12.2404 10.057 11.807 10.701 11.2533 11.2533Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dashboard = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 20 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 16H5V10H11V16H14V7L8 2.5L2 7V16ZM0 18V6L8 0L16 6V18H9V12H7V18H0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$delete = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 38'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.67175 37.6098C4.72348 37.6098 3.91667 37.2783 3.2513 36.6153C2.58593 35.9523 2.25325 35.1483 2.25325 34.2033V5.90655H0V2.5H9.91415V0.784798H23.5087V2.5H33.4348V5.90655H31.1816V34.2033C31.1816 35.1233 30.8426 35.921 30.1648 36.5965C29.4869 37.272 28.6863 37.6098 27.7631 37.6098H5.67175ZM27.7631 5.90655H5.67175V34.2033H27.7631V5.90655ZM10.912 29.9989H14.1152V10.0489H10.912V29.9989ZM19.3196 29.9989H22.5348V10.0489H19.3196V29.9989Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$demography = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M762.5-257.5Q780-275 780-300t-17.5-42.5Q745-360 720-360t-42.5 17.5Q660-325 660-300t17.5 42.5Q695-240 720-240t42.5-17.5ZM779-136q27-16 43-42-23-12-48.5-19t-53.5-7q-28 0-53.5 7T618-178q16 26 43 42t59 16q32 0 59-16Zm-563-8q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v258q-17.1-5.76-35.1-9.92T744-502v-242H216v528h241q1.88 19.52 5.94 37.26Q467-161 473-144H216Zm0-96v24-528 242-2 264Zm72-48h172q4-19 10.19-36.97Q476.38-342.93 484-360H288v72Zm0-156h264q26-20 56-34.5t64-20.5v-17H288v72Zm0-156h384v-72H288v72ZM719.77-48Q640-48 584-104.23q-56-56.22-56-136Q528-320 584.23-376q56.22-56 136-56Q800-432 856-375.77q56 56.22 56 136Q912-160 855.77-104q-56.22 56-136 56Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dev = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M224-358h98.67q20.1 0 34.38-14.28 14.28-14.29 14.28-34.39v-146.66q0-20.1-14.28-34.39Q342.77-602 322.67-602H224v244Zm48.67-48.67v-146.66h50v146.66h-50ZM433-358h100.67v-48.67h-82v-52h52v-44h-52v-50.66h82V-602H433.31q-13.31 0-21.81 8.5Q403-585 403-572v183.73q0 13.27 8.5 21.77T433-358Zm246.57-9.5q10.1-8.5 13.76-21.5L756-602h-50.67l-49.66 168L606-602h-50.67L618-389q3.67 13 13.76 21.5t23.91 8.5q13.81 0 23.9-8.5ZM186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h586.66q27 0 46.84 19.83Q840-800.33 840-773.33v586.66q0 27-19.83 46.84Q800.33-120 773.33-120H186.67Zm0-66.67h586.66v-586.66H186.67v586.66Zm0-586.66v586.66-586.66Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dollar = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.89385 14V12.3609C2.1378 12.2323 1.51862 11.9463 1.03631 11.5028C0.554004 11.0592 0.208566 10.4968 0 9.81543L1.19274 9.35262C1.41434 9.98255 1.73371 10.4454 2.15084 10.741C2.56797 11.0367 3.0568 11.1846 3.61732 11.1846C4.24302 11.1846 4.7514 11.0335 5.14246 10.7314C5.53352 10.4293 5.72905 10.0211 5.72905 9.50689C5.72905 8.95409 5.54656 8.52341 5.18156 8.21488C4.81657 7.90633 4.14525 7.5978 3.1676 7.28926C2.22905 6.99357 1.5284 6.59825 1.06564 6.1033C0.602887 5.60836 0.371508 4.98806 0.371508 4.24242C0.371508 3.54821 0.596368 2.95684 1.04609 2.46832C1.49581 1.9798 2.11173 1.69697 2.89385 1.61983V0H4.1257V1.61983C4.71229 1.69697 5.22393 1.89624 5.66061 2.21763C6.0973 2.53903 6.42644 2.95041 6.64804 3.45179L5.45531 3.95317C5.27281 3.55464 5.0284 3.25895 4.72207 3.06612C4.41574 2.87328 4.02142 2.77686 3.53911 2.77686C2.95251 2.77686 2.48976 2.90542 2.15084 3.16253C1.81192 3.41965 1.64246 3.77319 1.64246 4.22314C1.64246 4.68595 1.82821 5.0652 2.19972 5.36088C2.57123 5.65657 3.29143 5.9651 4.36033 6.2865C5.25978 6.56933 5.92458 6.96786 6.35475 7.48209C6.78492 7.99633 7 8.64555 7 9.42975C7 10.2525 6.75559 10.9146 6.26676 11.416C5.77793 11.9174 5.06425 12.2388 4.1257 12.3802V14H2.89385Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$dots = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 3'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.7622 2.02143C1.55894 2.02143 1.3811 1.94521 1.22866 1.79277C1.07622 1.64033 1 1.45741 1 1.24399C1 1.03058 1.07622 0.84765 1.22866 0.695211C1.3811 0.542772 1.56402 0.466553 1.77744 0.466553C1.98069 0.466553 2.15854 0.542772 2.31098 0.695211C2.46341 0.84765 2.53963 1.03058 2.53963 1.24399C2.53963 1.45741 2.46341 1.64033 2.31098 1.79277C2.15854 1.94521 1.97561 2.02143 1.7622 2.02143ZM6 2.02143C5.78658 2.02143 5.60366 1.94521 5.45122 1.79277C5.29878 1.64033 5.22256 1.45741 5.22256 1.24399C5.22256 1.03058 5.29878 0.84765 5.45122 0.695211C5.60366 0.542772 5.78658 0.466553 6 0.466553C6.21341 0.466553 6.39634 0.542772 6.54878 0.695211C6.70122 0.84765 6.77744 1.03058 6.77744 1.24399C6.77744 1.45741 6.70122 1.64033 6.54878 1.79277C6.39634 1.94521 6.21341 2.02143 6 2.02143ZM10.2226 2.02143C10.0091 2.02143 9.82876 1.94521 9.6814 1.79277C9.53404 1.64033 9.46036 1.45741 9.46036 1.24399C9.46036 1.03058 9.53658 0.84765 9.68902 0.695211C9.84146 0.542772 10.0244 0.466553 10.2378 0.466553C10.4512 0.466553 10.6316 0.542772 10.779 0.695211C10.9263 0.84765 11 1.03058 11 1.24399C11 1.45741 10.9238 1.64033 10.7713 1.79277C10.6189 1.94521 10.436 2.02143 10.2226 2.02143Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '0.5')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$edit = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 9 9'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.99474 2.53088L6.46912 1.00526L7.46255 0L9 1.52562L7.99474 2.53088ZM0 9V7.47438L5.9724 1.50197L7.49803 3.02759L1.52562 9H0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$employeeUploads = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M13.8079 23.1872H15.5813V17.2167L18.0049 19.6404L19.2463 18.399L14.6355 13.9064L10.0837 18.4581L11.3251 19.6995L13.8079 17.2167V23.1872ZM5 27V3H17.7094L24.2709 9.56158V27H5ZM16.6749 10.5074V5.00985H7.00985V24.9901H22.2611V10.5074H16.6749Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$employees = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 25.8526V22.5893C0 21.7844 0.206677 21.0555 0.620031 20.4029C1.03339 19.7502 1.60991 19.2607 2.34959 18.9344C3.93774 18.2382 5.37904 17.7378 6.67349 17.4333C7.96795 17.1287 9.28959 16.9764 10.6384 16.9764C12.0308 16.9764 13.3633 17.1287 14.636 17.4333C15.9087 17.7378 17.3391 18.2382 18.9273 18.9344C19.667 19.2607 20.2489 19.7502 20.6731 20.4029C21.0974 21.0555 21.3095 21.7844 21.3095 22.5893V25.8526H0ZM19.5473 16.9111C21.0049 17.0852 22.381 17.3408 23.6754 17.678C24.9699 18.0152 26.0304 18.3905 26.8571 18.8039C27.5751 19.2172 28.1516 19.7502 28.5867 20.4029C29.0218 21.0555 29.2394 21.7952 29.2394 22.6219V25.8526H23.3328V22.5893C23.3328 21.2187 22.9901 20.082 22.3048 19.1791C21.6195 18.2763 20.7003 17.5203 19.5473 16.9111ZM10.6711 14.9858C9.19169 14.9858 7.9897 14.518 7.06509 13.5825C6.14048 12.6471 5.67818 11.4505 5.67818 9.99288C5.67818 8.51351 6.14048 7.31152 7.06509 6.38691C7.9897 5.4623 9.18081 5 10.6384 5C12.1178 5 13.3252 5.4623 14.2607 6.38691C15.1962 7.31152 15.6639 8.51351 15.6639 9.99288C15.6639 11.4505 15.1962 12.6471 14.2607 13.5825C13.3252 14.518 12.1287 14.9858 10.6711 14.9858ZM22.6801 9.99288C22.6801 11.4505 22.2178 12.6471 21.2932 13.5825C20.3686 14.518 19.1666 14.9858 17.6872 14.9858C17.4479 14.9858 17.1814 14.9695 16.8877 14.9368C16.594 14.9042 16.3275 14.8335 16.0882 14.7247C16.6103 14.1808 17.0073 13.5064 17.2793 12.7014C17.5512 11.8965 17.6872 10.9936 17.6872 9.99288C17.6872 8.99213 17.5512 8.11103 17.2793 7.34959C17.0073 6.58815 16.6103 5.8811 16.0882 5.22843C16.3275 5.16317 16.594 5.10878 16.8877 5.06527C17.1814 5.02176 17.4479 5 17.6872 5C19.1666 5 20.3686 5.46774 21.2932 6.40323C22.2178 7.33871 22.6801 8.53527 22.6801 9.99288ZM2.25169 23.6336H19.0578V22.6219C19.0578 22.2739 18.9545 21.9366 18.7478 21.6103C18.5411 21.284 18.2855 21.0555 17.9809 20.925C16.4363 20.2506 15.1418 19.7937 14.0976 19.5544C13.0533 19.3151 11.9002 19.1955 10.6384 19.1955C9.42012 19.1955 8.27252 19.3151 7.19563 19.5544C6.11873 19.7937 4.81884 20.2506 3.29596 20.925C2.99138 21.0555 2.74119 21.284 2.54539 21.6103C2.34959 21.9366 2.25169 22.2739 2.25169 22.6219V23.6336ZM10.6384 12.832C11.4651 12.832 12.1504 12.5655 12.6943 12.0325C13.2382 11.4995 13.5102 10.8196 13.5102 9.99288C13.5102 9.16617 13.2437 8.48088 12.7106 7.93699C12.1776 7.3931 11.4978 7.12116 10.6711 7.12116C9.84436 7.12116 9.15906 7.3931 8.61517 7.93699C8.07128 8.48088 7.79934 9.16617 7.79934 9.99288C7.79934 10.8196 8.07128 11.4995 8.61517 12.0325C9.15906 12.5655 9.83348 12.832 10.6384 12.832Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$enter = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 13 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.92857 1H11.5V7.86957H1.5M1.5 7.86957L4.5 4.73913M1.5 7.86957L4.5 11'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$exit = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.5285 10.5191L9.59892 9.58197L11.5149 7.65027H4.95122V6.34973H11.477L9.56098 4.41803L10.4905 3.48087L14 7.01913L10.5285 10.5191ZM0 14V0H6.84824V1.30055H1.30894V12.6995H6.84824V14H0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$export = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 15'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.51131 11.2051L2.94118 6.69162L4.04977 5.59132L6.74208 8.26347V0H8.28054V8.26347L10.9729 5.59132L12.0814 6.69162L7.51131 11.2051ZM1.53846 15C1.13122 15 0.773002 14.8503 0.463801 14.5509C0.1546 14.2515 0 13.8922 0 13.4731V10.015H1.53846V13.4731H13.4615V10.015H15V13.4731C15 13.8922 14.8492 14.2515 14.5475 14.5509C14.2459 14.8503 13.8839 15 13.4615 15H1.53846Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$favicon = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '800'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 1000'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'defs',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'linearGradient',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient1'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '681.6406'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1557.7874'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '681.6406'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '557.7873'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#00BFFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'linearGradient',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient2'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '0'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1239.5522'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '1000'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '1239.5522'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1D63F2')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
									]),
								_List_Nil)
							]))
					])),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M363.3 363.9C363.3 363.9 363.3 321.3 363.3 318.2C363.3 142.5 505.9 0 681.6 0C857.3 0 1000 142.5 1000 318.2V1000L590.6 727.5L363.3 363.9Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient1)')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M364.1 363.5C364.1 363.5 321.5 363.5 318.4 363.5C142.6 363.5 0 506.1 0 681.8C0 857.5 142.6 1000 318.4 1000H1000L364.1 363.5Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient2)')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$file = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '39'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 52 52'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 0H20.2759L24 3.75114H48V39H0V0ZM4.0197 4.1084V34.9511H43.9803V7.8H22.3448L18.6207 4.1084H4.0197ZM4.0197 34.9511V4.1084V34.9511Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$filter = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.18883 12V8.16667H6.3V9.53333H12V10.6445H6.3V12H5.18883ZM0 10.6445V9.53333H4.07783V10.6445H0ZM2.96667 7.91117V6.5555H0V5.4445H2.96667V4.06667H4.07783V7.91117H2.96667ZM5.18883 6.5555V5.4445H12V6.5555H5.18883ZM7.92217 3.83333V0H9.03333V1.3555H12V2.46667H9.03333V3.83333H7.92217ZM0 2.46667V1.3555H6.81117V2.46667H0Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$flag = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 18'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 18V0H9.2549L9.75164 2.23699H16V12.1734H9.01961L8.52288 9.96243H1.77778V18H0ZM10.5359 10.4046H14.2222V4.00578H8.2353L7.73856 1.76879H1.77778V8.19364H10.0392L10.5359 10.4046Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$form = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 18 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4 16H12V14H4V16ZM4 12H12V10H4V12ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$groups = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$help = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.48634 16C1.0929 16 0.746812 15.8506 0.448088 15.5519C0.149363 15.2532 0 14.9071 0 14.5137V1.48634C0 1.07832 0.149363 0.728598 0.448088 0.437158C0.746812 0.145719 1.0929 0 1.48634 0H14.5137C14.9217 0 15.2714 0.145719 15.5628 0.437158C15.8543 0.728598 16 1.07832 16 1.48634V14.5137C16 14.9071 15.8543 15.2532 15.5628 15.5519C15.2714 15.8506 14.9217 16 14.5137 16H1.48634ZM1.48634 14.5137H14.5137V1.48634H1.48634V14.5137ZM7.91257 13.1148C8.16029 13.1148 8.36794 13.031 8.53552 12.8634C8.7031 12.6958 8.78689 12.4882 8.78689 12.2404C8.78689 11.9927 8.7031 11.7851 8.53552 11.6175C8.36794 11.4499 8.16029 11.3661 7.91257 11.3661C7.66484 11.3661 7.45719 11.4499 7.28962 11.6175C7.12204 11.7851 7.03825 11.9927 7.03825 12.2404C7.03825 12.4882 7.12568 12.6958 7.30055 12.8634C7.47541 13.031 7.67942 13.1148 7.91257 13.1148ZM7.14754 9.87978H8.48088C8.48088 9.44262 8.55009 9.07832 8.68853 8.78689C8.82696 8.49545 9.08561 8.16758 9.46448 7.80328C9.91621 7.35155 10.2404 6.93989 10.4372 6.56831C10.6339 6.19672 10.7322 5.79964 10.7322 5.37705C10.7322 4.59016 10.4809 3.97086 9.97814 3.51913C9.47541 3.0674 8.80874 2.84153 7.97814 2.84153C7.20583 2.84153 6.55373 3.02732 6.02186 3.39891C5.48998 3.77049 5.0929 4.26958 4.8306 4.89617L6.0765 5.42077C6.28051 5.02732 6.53916 4.72131 6.85246 4.50273C7.16576 4.28415 7.5337 4.17486 7.95628 4.17486C8.40802 4.17486 8.75774 4.2878 9.00546 4.51366C9.25319 4.73953 9.37705 5.04189 9.37705 5.42077C9.37705 5.7122 9.2969 5.98907 9.13661 6.25137C8.97632 6.51366 8.7286 6.81239 8.39344 7.14754C7.83971 7.67213 7.49363 8.11293 7.35519 8.46995C7.21676 8.82696 7.14754 9.2969 7.14754 9.87978ZM1.48634 14.5137V1.48634V14.5137Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$hint404 = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '190'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '69'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 190 69'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M81.9569 68.9947H129.013L129.021 69V68.9947H129.026L129.021 68.9895V21.9569C129.021 9.83247 119.188 0 107.064 0C98.5922 0 91.2394 4.80054 87.5781 11.8292L91.5 24.5L96 18L101.5 39L105 33.5L122.5 64.5L106 47.5L100.5 54.5L92.5 36.5L88 44L78.1371 25.4122C67.8329 27.2205 60 36.2162 60 47.0378C60 59.1623 69.8325 68.9947 81.9569 68.9947Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#paint0_linear_24_321)')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M30.19 55.2733H0.320007V43.0933L28.2567 0.559998H44.11V43.0933H52.9067V55.2733H44.11V69H30.19V55.2733ZM30.19 19.5067H29.9967L14.82 43.0933H30.19V19.5067Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#1D66F3')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M167.19 55.2733H137.32V43.0933L165.257 0.559998H181.11V43.0933H189.907V55.2733H181.11V69H167.19V55.2733ZM167.19 19.5067H166.997L151.82 43.0933H167.19V19.5067Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#06B0FE')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'defs',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'linearGradient',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'paint0_linear_24_321'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '73'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '63'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '116.5'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '27'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1D66F3')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0.371318'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1483F7')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0.655803'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#06ACFC')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#00BFFF')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Generated$Icons$hintHeart = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1000 1000'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'defs',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'linearGradient',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient1'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '681.6406'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1557.7874'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '681.6406'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '557.7873'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#00BFFF')
									]),
								_List_Nil)
							])),
						A3(
						$elm$svg$Svg$node,
						'linearGradient',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient2'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '0'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1239.5522'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '1000'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '1239.5522'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
							]),
						_List_fromArray(
							[
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1D63F2')
									]),
								_List_Nil),
								A3(
								$elm$svg$Svg$node,
								'stop',
								_List_fromArray(
									[
										A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
										A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
									]),
								_List_Nil)
							]))
					])),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M363.3 363.9C363.3 363.9 363.3 321.3 363.3 318.2C363.3 142.5 505.9 0 681.6 0C857.3 0 1000 142.5 1000 318.2V1000L590.6 727.5L363.3 363.9Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient1)')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M364.1 363.5C364.1 363.5 321.5 363.5 318.4 363.5C142.6 363.5 0 506.1 0 681.8C0 857.5 142.6 1000 318.4 1000H1000L364.1 363.5Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient2)')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$hintHeartFlat = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1000 1000'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M363.3 363.9C363.3 363.9 363.3 321.3 363.3 318.2C363.3 142.5 505.9 0 681.6 0C857.3 0 1000 142.5 1000 318.2V1000L590.6 727.5L363.3 363.9Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0F91F9')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M364.1 363.5C364.1 363.5 321.5 363.5 318.4 363.5C142.6 363.5 0 506.1 0 681.8C0 857.5 142.6 1000 318.4 1000H1000L364.1 363.5Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#1D63F2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$history = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 0h24v24H0V0z')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$inbox = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 22 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V13H13C12.5 13.6333 11.9042 14.125 11.2125 14.475C10.5208 14.825 9.78333 15 9 15C8.21667 15 7.47917 14.825 6.7875 14.475C6.09583 14.125 5.5 13.6333 5 13H2V16ZM9 13C9.63333 13 10.2083 12.8167 10.725 12.45C11.2417 12.0833 11.6 11.6 11.8 11H16V2H2V11H6.2C6.4 11.6 6.75833 12.0833 7.275 12.45C7.79167 12.8167 8.36667 13 9 13Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$inventory = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M21.2208 41.103L29.4267 32.8971L15.1029 18.5733L6.89699 26.7792C2.94159 30.7346 2.94159 37.1476 6.89699 41.103C10.8524 45.0584 17.2654 45.0584 21.2208 41.103ZM17.8821 15.7941L32.2059 30.1179L41.103 21.2208C45.0584 17.2654 45.0584 10.8524 41.103 6.89699C37.1476 2.94159 30.7346 2.94159 26.7792 6.89699L17.8821 15.7941ZM43.8823 4.11775C38.3919 -1.37259 29.4903 -1.37258 24 4.11775L4.11775 24C-1.37258 29.4903 -1.37258 38.3919 4.11775 43.8823C9.60808 49.3726 18.5097 49.3726 24 43.8822L43.8823 24C49.3726 18.5097 49.3726 9.60808 43.8823 4.11775ZM25.6991 18.364L31.7459 12.3171L28.9667 9.53789L22.9198 15.5847L25.6991 18.364Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$invoices = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.46624 28C6.5051 28 5.68711 27.6626 5.01227 26.9877C4.33742 26.3129 4 25.4949 4 24.5338V20.5154H7.95704V3.00012L9.85887 4.87128L11.73 3.00012L13.5705 4.87128L15.4723 3.00012L17.3128 4.87128L19.2147 3.00012L21.0858 4.87128L22.957 3.00012L24.8281 4.87128L26.6993 3.00012V24.5338C26.6993 25.4949 26.3619 26.3129 25.687 26.9877C25.0122 27.6626 24.1942 28 23.233 28H7.46624ZM23.233 25.9141C23.642 25.9141 23.9743 25.7863 24.23 25.5307C24.4856 25.2751 24.6134 24.9428 24.6134 24.5338V6.34366H10.0736V20.5154H21.8527V24.5338C21.8527 24.9428 21.9805 25.2751 22.2361 25.5307C22.4917 25.7863 22.824 25.9141 23.233 25.9141ZM11.6993 11.2209V9.38046H18.9079V11.2209H11.6993ZM11.6993 15.3314V13.4909H18.9079V15.3314H11.6993ZM21.7607 11.2209C21.5153 11.2209 21.3005 11.1289 21.1165 10.9449C20.9324 10.7608 20.8404 10.5461 20.8404 10.3007C20.8404 10.0553 20.9324 9.84058 21.1165 9.65653C21.3005 9.47248 21.5153 9.38046 21.7607 9.38046C22.0061 9.38046 22.2208 9.47248 22.4048 9.65653C22.5889 9.84058 22.6809 10.0553 22.6809 10.3007C22.6809 10.5461 22.5889 10.7608 22.4048 10.9449C22.2208 11.1289 22.0061 11.2209 21.7607 11.2209ZM21.7607 15.178C21.5153 15.178 21.3005 15.086 21.1165 14.9019C20.9324 14.7179 20.8404 14.5031 20.8404 14.2577C20.8404 14.0123 20.9324 13.7976 21.1165 13.6136C21.3005 13.4295 21.5153 13.3375 21.7607 13.3375C22.0061 13.3375 22.2208 13.4295 22.4048 13.6136C22.5889 13.7976 22.6809 14.0123 22.6809 14.2577C22.6809 14.5031 22.5889 14.7179 22.4048 14.9019C22.2208 15.086 22.0061 15.178 21.7607 15.178ZM7.43557 25.9141H19.7668V22.6013H6.08588V24.5338C6.08588 24.9428 6.21369 25.2751 6.46931 25.5307C6.72494 25.7863 7.04702 25.9141 7.43557 25.9141Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$kebabMenu = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 3 17'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.2439 16.9373C0.902439 16.9373 0.609756 16.8153 0.365854 16.5714C0.121951 16.3275 0 16.0348 0 15.6934C0 15.3681 0.121951 15.0836 0.365854 14.8397C0.609756 14.5958 0.902439 14.4738 1.2439 14.4738C1.58537 14.4738 1.87805 14.5958 2.12195 14.8397C2.36585 15.0836 2.4878 15.3763 2.4878 15.7177C2.4878 16.0429 2.36585 16.3275 2.12195 16.5714C1.87805 16.8153 1.58537 16.9373 1.2439 16.9373ZM1.2439 10.1812C0.902439 10.1812 0.609756 10.0592 0.365854 9.8153C0.121951 9.5714 0 9.27872 0 8.93725C0 8.59579 0.121951 8.30311 0.365854 8.05921C0.609756 7.8153 0.902439 7.69335 1.2439 7.69335C1.58537 7.69335 1.87805 7.8153 2.12195 8.05921C2.36585 8.30311 2.4878 8.59579 2.4878 8.93725C2.4878 9.27872 2.36585 9.5714 2.12195 9.8153C1.87805 10.0592 1.58537 10.1812 1.2439 10.1812ZM1.2439 3.40067C0.902439 3.40067 0.609756 3.27872 0.365854 3.03482C0.121951 2.79091 0 2.49823 0 2.15677C0 1.8153 0.121951 1.52669 0.365854 1.29091C0.609756 1.05514 0.902439 0.937256 1.2439 0.937256C1.58537 0.937256 1.87805 1.05921 2.12195 1.30311C2.36585 1.54701 2.4878 1.83969 2.4878 2.18116C2.4878 2.52262 2.36585 2.81124 2.12195 3.04701C1.87805 3.28278 1.58537 3.40067 1.2439 3.40067Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$launch = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 12V0H4.7986V1.11475H1.11475V10.8852H10.8852V7.20141H12V12H0ZM4.4918 8.31148L3.70492 7.5082L10.0984 1.11475H6.63934V0H12V5.36066H10.8852V1.91803L4.4918 8.31148Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$location = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 15'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6 13.2675C7.54074 11.9909 8.7037 10.7637 9.48889 9.58587C10.2741 8.40805 10.6667 7.31003 10.6667 6.29179C10.6667 5.39514 10.5074 4.63526 10.1889 4.01216C9.87037 3.38906 9.47778 2.87994 9.01111 2.4848C8.54444 2.08967 8.03704 1.80471 7.48889 1.62994C6.94074 1.45517 6.44444 1.36778 6 1.36778C5.55556 1.36778 5.05926 1.45517 4.51111 1.62994C3.96296 1.80471 3.45556 2.08967 2.98889 2.4848C2.52222 2.87994 2.12963 3.38906 1.81111 4.01216C1.49259 4.63526 1.33333 5.39514 1.33333 6.29179C1.33333 7.31003 1.72593 8.40805 2.51111 9.58587C3.2963 10.7637 4.45926 11.9909 6 13.2675ZM6 15C3.97037 13.4347 2.46296 11.9377 1.47778 10.5091C0.492592 9.08055 0 7.67477 0 6.29179C0 5.25836 0.181482 4.3503 0.544445 3.56763C0.907408 2.78495 1.37778 2.12766 1.95556 1.59574C2.53333 1.06383 3.17778 0.664894 3.88889 0.398936C4.6 0.132979 5.3037 0 6 0C6.6963 0 7.4 0.132979 8.11111 0.398936C8.82222 0.664894 9.46667 1.06383 10.0444 1.59574C10.6222 2.12766 11.0926 2.78495 11.4556 3.56763C11.8185 4.3503 12 5.25836 12 6.29179C12 7.67477 11.5074 9.08055 10.5222 10.5091C9.53704 11.9377 8.02963 13.4347 6 15ZM6 7.75076C6.42963 7.75076 6.7963 7.59498 7.1 7.28343C7.4037 6.97188 7.55556 6.59574 7.55556 6.15502C7.55556 5.71429 7.4037 5.33815 7.1 5.0266C6.7963 4.71505 6.42963 4.55927 6 4.55927C5.57037 4.55927 5.2037 4.71505 4.9 5.0266C4.5963 5.33815 4.44444 5.71429 4.44444 6.15502C4.44444 6.59574 4.5963 6.97188 4.9 7.28343C5.2037 7.59498 5.57037 7.75076 6 7.75076Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$mail = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm340-302L140-685v465h680v-465L480-462Zm0-60 336-218H145l335 218ZM140-685v-55 520-465Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$marketplace = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '80 -920 840 840')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M841-518v318q0 33-23.5 56.5T761-120H201q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518Zm-272-42q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$minus = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 10.56h24v2.88H0z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$onlineSignup = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M3 3V24.9376H11.7568L13.7667 22.9278H5.00986L5.00986 5.00986H22.52V14.1744L24.5334 12.1611V3H3Z')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M25.6432 19.0929L23.672 17.1461L25.0288 15.8061L27 17.7529L25.6432 19.0929ZM15.6827 27V25.0532L22.5712 18.2333L24.5424 20.1801L17.6539 27H15.6827ZM7.79999 19.233V17.4884H15.7616V19.233H7.79999ZM7.79999 14.9095V13.1902H20.0368V14.9095H7.79999ZM7.79999 10.586V8.86667H20.0368V10.586H7.79999Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$open = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.42857 1H11V7.86957H1M1 7.86957L4 4.73913M1 7.86957L4 11'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$package = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M440-183v-274L200-596v274l240 139Zm80 0 240-139v-274L520-457v274Zm-80 92L160-252q-19-11-29.5-29T120-321v-318q0-22 10.5-40t29.5-29l280-161q19-11 40-11t40 11l280 161q19 11 29.5 29t10.5 40v318q0 22-10.5 40T800-252L520-91q-19 11-40 11t-40-11Zm200-528 77-44-237-137-78 45 238 136Zm-160 93 78-45-237-137-78 45 237 137Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$patients = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-2 -4 28 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0ZM18 16V13C18 12.2667 17.7958 11.5625 17.3875 10.8875C16.9792 10.2125 16.4 9.63333 15.65 9.15C16.5 9.25 17.3 9.42083 18.05 9.6625C18.8 9.90417 19.5 10.2 20.15 10.55C20.75 10.8833 21.2083 11.2542 21.525 11.6625C21.8417 12.0708 22 12.5167 22 13V16H18ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM18 4C18 5.1 17.6083 6.04167 16.825 6.825C16.0417 7.60833 15.1 8 14 8C13.8167 8 13.5833 7.97917 13.3 7.9375C13.0167 7.89583 12.7833 7.85 12.6 7.8C13.05 7.26667 13.3958 6.675 13.6375 6.025C13.8792 5.375 14 4.7 14 4C14 3.3 13.8792 2.625 13.6375 1.975C13.3958 1.325 13.05 0.733333 12.6 0.2C12.8333 0.116667 13.0667 0.0625 13.3 0.0375C13.5333 0.0125 13.7667 0 14 0C15.1 0 16.0417 0.391667 16.825 1.175C17.6083 1.95833 18 2.9 18 4ZM2 14H14V13.2C14 13.0167 13.9542 12.85 13.8625 12.7C13.7708 12.55 13.65 12.4333 13.5 12.35C12.6 11.9 11.6917 11.5625 10.775 11.3375C9.85833 11.1125 8.93333 11 8 11C7.06667 11 6.14167 11.1125 5.225 11.3375C4.30833 11.5625 3.4 11.9 2.5 12.35C2.35 12.4333 2.22917 12.55 2.1375 12.7C2.04583 12.85 2 13.0167 2 13.2V14ZM8 6C8.55 6 9.02083 5.80417 9.4125 5.4125C9.80417 5.02083 10 4.55 10 4C10 3.45 9.80417 2.97917 9.4125 2.5875C9.02083 2.19583 8.55 2 8 2C7.45 2 6.97917 2.19583 6.5875 2.5875C6.19583 2.97917 6 3.45 6 4C6 4.55 6.19583 5.02083 6.5875 5.4125C6.97917 5.80417 7.45 6 8 6Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$paymentMethods = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 25.8768V5H28V25.8768H2ZM4.17734 10.6034H25.8226V7.17734H4.17734V10.6034ZM4.17734 14.734V23.6995H25.8226V14.734H4.17734Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$practices = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M420-280h120v-100h100v-120H540v-100H420v100H320v120h100v100ZM160-120v-480l320-240 320 240v480H160Zm80-80h480v-360L480-740 240-560v360Zm240-270Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$progressActivity = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '20px'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '20px'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$quote = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm228-240 92-160q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 23-5.5 42.5T458-480L320-240h-92Zm360 0 92-160q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 23-5.5 42.5T818-480L680-240h-92ZM362.5-517.5Q380-535 380-560t-17.5-42.5Q345-620 320-620t-42.5 17.5Q260-585 260-560t17.5 42.5Q295-500 320-500t42.5-17.5Zm360 0Q740-535 740-560t-17.5-42.5Q705-620 680-620t-42.5 17.5Q620-585 620-560t17.5 42.5Q655-500 680-500t42.5-17.5ZM680-560Zm-360 0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$repeat = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 33'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M16.6813 32.6098C12.1682 32.6098 8.32346 31.0216 5.14702 27.8451C1.97056 24.6687 0.382324 20.8249 0.382324 16.3138C0.382324 11.8028 1.97056 7.95605 5.14702 4.77365C8.32346 1.59121 12.1682 -3.8147e-06 16.6813 -3.8147e-06C19.5624 -3.8147e-06 22.0911 0.583865 24.2675 1.7516C26.4438 2.91933 28.3281 4.52533 29.9204 6.5696V-3.8147e-06H33.0639V13.1424H19.9095V10.0109H28.2617C26.987 8.0428 25.3823 6.45203 23.4476 5.2386C21.5128 4.0252 19.2573 3.4185 16.6813 3.4185C13.0778 3.4185 10.0282 4.66617 7.53247 7.1615C5.03674 9.65683 3.78887 12.7059 3.78887 16.3088C3.78887 19.9116 5.03677 22.9614 7.53257 25.4582C10.0284 27.9549 13.078 29.2033 16.6816 29.2033C19.4082 29.2033 21.9115 28.4216 24.1916 26.8582C26.4716 25.2948 28.0657 23.229 28.9736 20.6609H32.4921C31.5175 24.2406 29.5679 27.127 26.6434 29.3201C23.7189 31.5132 20.3982 32.6098 16.6813 32.6098Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$report = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-8 -8 64 64'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M36 48V27H48V48H36ZM18 48V0H30V48H18ZM0 48V15H12V48H0Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sandbox = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M40-120v-80h42l35-525q2-32 25-53.5t55-21.5h245q32 0 55 21.5t25 53.5l36 525h162v-246q-52-14-86-56t-34-98q0-34 13-63.5t36-51.5q-5-11-7-22t-2-23q0-50 35-85t85-35q50 0 85 35t35 85q0 12-2 23t-7 22q23 22 36 51.5t13 63.5q0 56-34 98t-86 56v246h120v80H40Zm123-80h314l-35-520h-32v360h30v80H200v-80h30v-360h-32l-35 520Zm127-160h60v-360h-60v360Zm470-160q33 0 56.5-23.5T840-600q0-28-13-43t-27-29v-88q0-17-11.5-28.5T760-800q-17 0-28.5 11.5T720-760v88q-14 14-27 29t-13 43q0 33 23.5 56.5T760-520Zm0-80Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$scissors = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M39.5833 43.7501L25 29.1667L20.1042 34.0626C20.382 34.5834 20.5729 35.139 20.6771 35.7293C20.7813 36.3195 20.8333 36.9098 20.8333 37.5001C20.8333 39.7918 20.0174 41.7536 18.3854 43.3855C16.7535 45.0174 14.7917 45.8334 12.5 45.8334C10.2083 45.8334 8.24653 45.0174 6.61459 43.3855C4.98264 41.7536 4.16667 39.7918 4.16667 37.5001C4.16667 35.2084 4.98264 33.2466 6.61459 31.6147C8.24653 29.9827 10.2083 29.1667 12.5 29.1667C13.0903 29.1667 13.6806 29.2188 14.2708 29.323C14.8611 29.4272 15.4167 29.6181 15.9375 29.8959L20.8333 25.0001L15.9375 20.1042C15.4167 20.382 14.8611 20.573 14.2708 20.6772C13.6806 20.7813 13.0903 20.8334 12.5 20.8334C10.2083 20.8334 8.24653 20.0174 6.61459 18.3855C4.98264 16.7536 4.16667 14.7917 4.16667 12.5001C4.16667 10.2084 4.98264 8.24661 6.61459 6.61467C8.24653 4.98272 10.2083 4.16675 12.5 4.16675C14.7917 4.16675 16.7535 4.98272 18.3854 6.61467C20.0174 8.24661 20.8333 10.2084 20.8333 12.5001C20.8333 13.0904 20.7813 13.6806 20.6771 14.2709C20.5729 14.8612 20.382 15.4167 20.1042 15.9376L45.8333 41.6668V43.7501H39.5833ZM31.25 22.9167L27.0833 18.7501L39.5833 6.25008H45.8333V8.33342L31.25 22.9167ZM12.5 16.6667C13.6458 16.6667 14.6267 16.2588 15.4427 15.4428C16.2587 14.6268 16.6667 13.6459 16.6667 12.5001C16.6667 11.3542 16.2587 10.3733 15.4427 9.55737C14.6267 8.7414 13.6458 8.33342 12.5 8.33342C11.3542 8.33342 10.3733 8.7414 9.5573 9.55737C8.74133 10.3733 8.33334 11.3542 8.33334 12.5001C8.33334 13.6459 8.74133 14.6268 9.5573 15.4428C10.3733 16.2588 11.3542 16.6667 12.5 16.6667ZM25 26.0417C25.2778 26.0417 25.5208 25.9376 25.7292 25.7293C25.9375 25.5209 26.0417 25.2779 26.0417 25.0001C26.0417 24.7223 25.9375 24.4793 25.7292 24.2709C25.5208 24.0626 25.2778 23.9584 25 23.9584C24.7222 23.9584 24.4792 24.0626 24.2708 24.2709C24.0625 24.4793 23.9583 24.7223 23.9583 25.0001C23.9583 25.2779 24.0625 25.5209 24.2708 25.7293C24.4792 25.9376 24.7222 26.0417 25 26.0417ZM12.5 41.6668C13.6458 41.6668 14.6267 41.2588 15.4427 40.4428C16.2587 39.6268 16.6667 38.6459 16.6667 37.5001C16.6667 36.3543 16.2587 35.3733 15.4427 34.5574C14.6267 33.7414 13.6458 33.3334 12.5 33.3334C11.3542 33.3334 10.3733 33.7414 9.5573 34.5574C8.74133 35.3733 8.33334 36.3543 8.33334 37.5001C8.33334 38.6459 8.74133 39.6268 9.5573 40.4428C10.3733 41.2588 11.3542 41.6668 12.5 41.6668Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$search = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M14.9071 16L9.11475 10.2216C8.69217 10.5864 8.18944 10.871 7.60656 11.0752C7.02368 11.2795 6.40437 11.3817 5.74863 11.3817C4.14572 11.3817 2.78689 10.8272 1.67213 9.71819C0.557377 8.60921 0 7.26676 0 5.69083C0 4.11491 0.557377 2.77246 1.67213 1.66347C2.78689 0.554492 4.13115 0 5.70492 0C7.27869 0 8.61931 0.554492 9.72678 1.66347C10.8342 2.77246 11.388 4.11491 11.388 5.69083C11.388 6.31829 11.286 6.92385 11.082 7.50752C10.878 8.0912 10.5792 8.6384 10.1858 9.14911L16 14.9056L14.9071 16ZM5.72678 9.8933C6.87796 9.8933 7.85792 9.48108 8.66667 8.65663C9.47541 7.83219 9.87978 6.84359 9.87978 5.69083C9.87978 4.53808 9.47541 3.54948 8.66667 2.72503C7.85792 1.90059 6.87796 1.48837 5.72678 1.48837C4.54645 1.48837 3.54827 1.90059 2.73224 2.72503C1.91621 3.54948 1.5082 4.53808 1.5082 5.69083C1.5082 6.84359 1.91621 7.83219 2.73224 8.65663C3.54827 9.48108 4.54645 9.8933 5.72678 9.8933Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$selectArrows = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4.13031 13L4.13031 1M4.13031 1L7.26074 4M4.13031 1L0.999873 4'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.1304 1V13M10.1304 13L7 10M10.1304 13L13.2609 10'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$send = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 39 33'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0185714 33L39 16.5L0.0185714 0L0 12.8333L27.8571 16.5L0 20.1667L0.0185714 33Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$share = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '3 0 48 48'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M36.35 44.3Q33.85 44.3 32.1 42.525Q30.35 40.75 30.35 38.3Q30.35 37.95 30.425 37.45Q30.5 36.95 30.65 36.55L15.95 28Q15.2 28.9 14.05 29.45Q12.9 30 11.7 30Q9.2 30 7.45 28.25Q5.7 26.5 5.7 24Q5.7 21.5 7.45 19.75Q9.2 18 11.7 18Q12.9 18 14 18.475Q15.1 18.95 15.95 19.85L30.65 11.4Q30.5 11.05 30.425 10.575Q30.35 10.1 30.35 9.7Q30.35 7.2 32.1 5.45Q33.85 3.7 36.35 3.7Q38.85 3.7 40.6 5.45Q42.35 7.2 42.35 9.7Q42.35 12.2 40.6 13.95Q38.85 15.7 36.35 15.7Q35.15 15.7 34.025 15.3Q32.9 14.9 32.15 14.05L17.45 22.15Q17.55 22.55 17.625 23.1Q17.7 23.65 17.7 24Q17.7 24.35 17.625 24.75Q17.55 25.15 17.45 25.6L32.15 33.9Q32.9 33.2 33.95 32.75Q35 32.3 36.35 32.3Q38.85 32.3 40.6 34.05Q42.35 35.8 42.35 38.3Q42.35 40.8 40.6 42.55Q38.85 44.3 36.35 44.3ZM36.35 12.4Q37.5 12.4 38.275 11.625Q39.05 10.85 39.05 9.7Q39.05 8.55 38.275 7.775Q37.5 7 36.35 7Q35.2 7 34.425 7.775Q33.65 8.55 33.65 9.7Q33.65 10.85 34.425 11.625Q35.2 12.4 36.35 12.4ZM11.7 26.7Q12.85 26.7 13.625 25.925Q14.4 25.15 14.4 24Q14.4 22.85 13.625 22.075Q12.85 21.3 11.7 21.3Q10.55 21.3 9.775 22.075Q9 22.85 9 24Q9 25.15 9.775 25.925Q10.55 26.7 11.7 26.7ZM36.35 41Q37.5 41 38.275 40.225Q39.05 39.45 39.05 38.3Q39.05 37.15 38.275 36.375Q37.5 35.6 36.35 35.6Q35.2 35.6 34.425 36.375Q33.65 37.15 33.65 38.3Q33.65 39.45 34.425 40.225Q35.2 41 36.35 41Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sort = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sortDown = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sortUp = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil),
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$sponsors = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '2 -2 48 48'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4 42V9.5L14 2L24 9.5V14H44V42H4ZM8 38H12V34H8V38ZM8 30H12V26H8V30ZM8 22H12V18H8V22ZM8 14H12V10H8V14ZM16 14H20V10H16V14ZM16 38H40V18H16V38ZM28 26V22H36V26H28ZM28 34V30H36V34H28ZM20 26V22H24V26H20ZM20 34V30H24V34H20Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$star = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M44.375 38.9584L38.125 32.7084L41.0417 29.7917L47.2917 36.0417L44.375 38.9584ZM36.875 13.9584L33.9583 11.0417L40.2083 4.79175L43.125 7.70841L36.875 13.9584ZM13.125 13.9584L6.87501 7.70841L9.79168 4.79175L16.0417 11.0417L13.125 13.9584ZM5.62501 38.9584L2.70834 36.0417L8.95834 29.7917L11.875 32.7084L5.62501 38.9584ZM18.4375 35.0522L25 31.0938L31.5625 35.1042L29.8438 27.6042L35.625 22.6042L28.0208 21.9272L25 14.8438L21.9792 21.8751L14.375 22.5522L20.1563 27.6042L18.4375 35.0522ZM12.1354 43.7501L15.5208 29.1147L4.16668 19.2709L19.1667 17.9688L25 4.16675L30.8333 17.9688L45.8333 19.2709L34.4792 29.1147L37.8646 43.7501L25 35.9897L12.1354 43.7501Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$starNote = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M26.2353 34.6797H16.3529V31.3984H26.2353V34.6797ZM32.978 25.3281H16.3529V22.0469H32.978V25.3281ZM32.978 15.9766H16.3529V12.6953H32.978V15.9766ZM4.92647 42.3906C5.54412 43.0469 6.26472 43.375 7.08824 43.375H28.7059V40.0938H7.08824V7.28125H37.9706V25H41.0588V7.28125C41.0588 6.4063 40.75 5.64062 40.1324 4.98438C39.5147 4.32812 38.794 4 37.9706 4H7.08824C6.26472 4 5.54412 4.32812 4.92647 4.98438C4.30882 5.64062 4 6.4063 4 7.28125V40.0938C4 40.9687 4.30882 41.7344 4.92647 42.3906ZM34.5592 39.7809L37.3529 46L40.1467 39.7809L46 36.8125L40.1467 33.8441L37.3529 27.625L34.5592 33.8441L28.7059 36.8125L34.5592 39.7809ZM12.0294 16.3375C13.0528 16.3375 13.8824 15.456 13.8824 14.3688C13.8824 13.2816 13.0528 12.4 12.0294 12.4C11.006 12.4 10.1765 13.2816 10.1765 14.3688C10.1765 15.456 11.006 16.3375 12.0294 16.3375ZM13.8824 23.6875C13.8824 24.7747 13.0528 25.6562 12.0294 25.6562C11.006 25.6562 10.1765 24.7747 10.1765 23.6875C10.1765 22.6003 11.006 21.7188 12.0294 21.7188C13.0528 21.7188 13.8824 22.6003 13.8824 23.6875ZM12.0294 34.975C13.0528 34.975 13.8824 34.0935 13.8824 33.0063C13.8824 31.919 13.0528 31.0375 12.0294 31.0375C11.006 31.0375 10.1765 31.919 10.1765 33.0063C10.1765 34.0935 11.006 34.975 12.0294 34.975Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#00BFFF')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$stop = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7 14C6.03448 14 5.12644 13.8161 4.27586 13.4483C3.42529 13.0805 2.68391 12.5805 2.05172 11.9483C1.41954 11.3161 0.91954 10.5747 0.551724 9.72414C0.183908 8.87356 0 7.96552 0 7C0 6.03448 0.183908 5.12356 0.551724 4.26724C0.91954 3.41092 1.41954 2.66954 2.05172 2.0431C2.68391 1.41667 3.42529 0.91954 4.27586 0.551724C5.12644 0.183908 6.03448 0 7 0C7.96552 0 8.87356 0.183908 9.72414 0.551724C10.5747 0.91954 11.3161 1.41667 11.9483 2.0431C12.5805 2.66954 13.0805 3.41092 13.4483 4.26724C13.8161 5.12356 14 6.03448 14 7C14 7.96552 13.8161 8.87356 13.4483 9.72414C13.0805 10.5747 12.5805 11.3161 11.9483 11.9483C11.3161 12.5805 10.5747 13.0805 9.72414 13.4483C8.87356 13.8161 7.96552 14 7 14ZM7 12.8276C8.62069 12.8276 9.99713 12.2615 11.1293 11.1293C12.2615 9.99713 12.8276 8.62069 12.8276 7C12.8276 6.32184 12.7126 5.66667 12.4828 5.03448C12.2529 4.4023 11.9253 3.82759 11.5 3.31034L3.31034 11.4828C3.81609 11.931 4.38793 12.2672 5.02586 12.4914C5.66379 12.7155 6.32184 12.8276 7 12.8276ZM2.51724 10.6897L10.6897 2.51724C10.1724 2.08046 9.5977 1.74713 8.96552 1.51724C8.33333 1.28736 7.67816 1.17241 7 1.17241C5.37931 1.17241 4.00287 1.73563 2.87069 2.86207C1.73851 3.98851 1.17241 5.36782 1.17241 7C1.17241 7.67816 1.2931 8.33333 1.53448 8.96552C1.77586 9.5977 2.10345 10.1724 2.51724 10.6897Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$syncedFrom = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 17'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'transform', 'rotate(180, 7.5, 8.5)'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.5 12.0161C11.8667 12.0161 11.3 12.2721 10.8667 12.6732L4.925 9.13153C4.96667 8.93524 5 8.73896 5 8.53414C5 8.32932 4.96667 8.13303 4.925 7.93675L10.8 4.42922C11.25 4.85592 11.8417 5.12048 12.5 5.12048C13.8833 5.12048 15 3.97691 15 2.56024C15 1.14357 13.8833 0 12.5 0C11.1167 0 10 1.14357 10 2.56024C10 2.76506 10.0333 2.96135 10.075 3.15763L4.2 6.66516C3.75 6.23845 3.15833 5.9739 2.5 5.9739C1.11667 5.9739 0 7.11747 0 8.53414C0 9.9508 1.11667 11.0944 2.5 11.0944C3.15833 11.0944 3.75 10.8298 4.2 10.4031L10.1333 13.9533C10.0917 14.1325 10.0667 14.3203 10.0667 14.508C10.0667 15.882 11.1583 17 12.5 17C13.8417 17 14.9333 15.882 14.9333 14.508C14.9333 13.134 13.8417 12.0161 12.5 12.0161ZM12.5 1.70683C12.9583 1.70683 13.3333 2.09086 13.3333 2.56024C13.3333 3.02962 12.9583 3.41365 12.5 3.41365C12.0417 3.41365 11.6667 3.02962 11.6667 2.56024C11.6667 2.09086 12.0417 1.70683 12.5 1.70683ZM2.5 9.38755C2.04167 9.38755 1.66667 9.00351 1.66667 8.53414C1.66667 8.06476 2.04167 7.68072 2.5 7.68072C2.95833 7.68072 3.33333 8.06476 3.33333 8.53414C3.33333 9.00351 2.95833 9.38755 2.5 9.38755ZM12.5 15.3785C12.0417 15.3785 11.6667 14.9945 11.6667 14.5251C11.6667 14.0557 12.0417 13.6717 12.5 13.6717C12.9583 13.6717 13.3333 14.0557 13.3333 14.5251C13.3333 14.9945 12.9583 15.3785 12.5 15.3785Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$syncedTo = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 17'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.5 12.0161C11.8667 12.0161 11.3 12.2721 10.8667 12.6732L4.925 9.13153C4.96667 8.93524 5 8.73896 5 8.53414C5 8.32932 4.96667 8.13303 4.925 7.93675L10.8 4.42922C11.25 4.85592 11.8417 5.12048 12.5 5.12048C13.8833 5.12048 15 3.97691 15 2.56024C15 1.14357 13.8833 0 12.5 0C11.1167 0 10 1.14357 10 2.56024C10 2.76506 10.0333 2.96135 10.075 3.15763L4.2 6.66516C3.75 6.23845 3.15833 5.9739 2.5 5.9739C1.11667 5.9739 0 7.11747 0 8.53414C0 9.9508 1.11667 11.0944 2.5 11.0944C3.15833 11.0944 3.75 10.8298 4.2 10.4031L10.1333 13.9533C10.0917 14.1325 10.0667 14.3203 10.0667 14.508C10.0667 15.882 11.1583 17 12.5 17C13.8417 17 14.9333 15.882 14.9333 14.508C14.9333 13.134 13.8417 12.0161 12.5 12.0161ZM12.5 1.70683C12.9583 1.70683 13.3333 2.09086 13.3333 2.56024C13.3333 3.02962 12.9583 3.41365 12.5 3.41365C12.0417 3.41365 11.6667 3.02962 11.6667 2.56024C11.6667 2.09086 12.0417 1.70683 12.5 1.70683ZM2.5 9.38755C2.04167 9.38755 1.66667 9.00351 1.66667 8.53414C1.66667 8.06476 2.04167 7.68072 2.5 7.68072C2.95833 7.68072 3.33333 8.06476 3.33333 8.53414C3.33333 9.00351 2.95833 9.38755 2.5 9.38755ZM12.5 15.3785C12.0417 15.3785 11.6667 14.9945 11.6667 14.5251C11.6667 14.0557 12.0417 13.6717 12.5 13.6717C12.9583 13.6717 13.3333 14.0557 13.3333 14.5251C13.3333 14.9945 12.9583 15.3785 12.5 15.3785Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$task = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 20 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.6 15.05L14.65 8L13.25 6.6L7.6 12.25L4.75 9.4L3.35 10.8L7.6 15.05ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H6.2C6.41667 1.4 6.77917 0.916667 7.2875 0.55C7.79583 0.183333 8.36667 0 9 0C9.63333 0 10.2042 0.183333 10.7125 0.55C11.2208 0.916667 11.5833 1.4 11.8 2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V4H2V18ZM9 3.25C9.21667 3.25 9.39583 3.17917 9.5375 3.0375C9.67917 2.89583 9.75 2.71667 9.75 2.5C9.75 2.28333 9.67917 2.10417 9.5375 1.9625C9.39583 1.82083 9.21667 1.75 9 1.75C8.78333 1.75 8.60417 1.82083 8.4625 1.9625C8.32083 2.10417 8.25 2.28333 8.25 2.5C8.25 2.71667 8.32083 2.89583 8.4625 3.0375C8.60417 3.17917 8.78333 3.25 9 3.25Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$testConnection = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'svg-icon'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'width: 1.80078125em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1844 1024'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'version', '1.1'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M650.541129 1022.638311 108.423481 1022.638311C52.314305 1022.638311 6.776422 976.885119 6.776422 920.510651L6.776422 103.489375C6.776422 47.114907 52.314305 1.361715 108.423481 1.361715L650.541129 1.361715C706.650305 1.361715 752.188187 47.114907 752.188187 103.489375 752.188187 159.863843 706.650305 205.617034 650.541129 205.617034L210.07054 205.617034 210.07054 818.382991 650.541129 818.382991C706.650305 818.382991 752.188187 864.136183 752.188187 920.510651 752.188187 976.885119 706.650305 1022.638311 650.541129 1022.638311L650.541129 1022.638311ZM1734.776422 1022.638311 1192.65878 1022.638311C1136.549601 1022.638311 1091.011717 976.885119 1091.011717 920.510651 1091.011717 864.136183 1136.549601 818.382991 1192.65878 818.382991L1633.129359 818.382991 1633.129359 205.617034 1192.65878 205.617034C1136.549601 205.617034 1091.011717 159.863843 1091.011717 103.489375 1091.011717 47.114907 1136.549601 1.361715 1192.65878 1.361715L1734.776422 1.361715C1790.885601 1.361715 1836.423485 47.114907 1836.423485 103.489375L1836.423485 920.510651C1836.423485 976.885119 1790.885601 1022.638311 1734.776422 1022.638311L1734.776422 1022.638311ZM1328.188191 614.127672 515.011716 614.127672C458.90254 614.127672 413.364658 568.374481 413.364658 512.000013 413.364658 455.625545 458.90254 409.872353 515.011716 409.872353L1328.188191 409.872353C1384.297359 409.872353 1429.835244 455.625545 1429.835244 512.000013 1429.835244 568.374481 1384.297359 614.127672 1328.188191 614.127672L1328.188191 614.127672Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$transfer = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 42 33'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.3555 32.6098L0.418457 22.6728L10.3555 12.7359L12.7425 15.1228L6.90771 20.9696H22.2414V24.3881H6.90766L12.7424 30.2228L10.3555 32.6098ZM31.0794 19.8739L28.6924 17.487L34.5392 11.6522H19.2055V8.2337H34.5392L28.6924 2.387L31.0794 -3.8147e-06L41.0283 9.937L31.0794 19.8739Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$translate = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.99882 12C5.16604 12 4.38488 11.8428 3.65534 11.5283C2.92571 11.2138 2.29008 10.7854 1.74846 10.243C1.20675 9.70048 0.77993 9.06279 0.468017 8.32991C0.156006 7.59713 0 6.81435 0 5.98156C0 5.14622 0.156006 4.36565 0.468017 3.63985C0.77993 2.91396 1.20675 2.28059 1.74846 1.73976C2.29008 1.19893 2.92571 0.773784 3.65534 0.464329C4.38488 0.154776 5.16604 0 5.99882 0C6.83406 0 7.61586 0.154776 8.34422 0.464329C9.07257 0.773784 9.70756 1.19893 10.2492 1.73976C10.7909 2.28059 11.2181 2.91396 11.5308 3.63985C11.8436 4.36565 12 5.14622 12 5.98156C12 6.81435 11.8436 7.59713 11.5308 8.32991C11.2181 9.06279 10.7909 9.70048 10.2492 10.243C9.70756 10.7854 9.07257 11.2138 8.34422 11.5283C7.61586 11.8428 6.83406 12 5.99882 12ZM5.9941 10.896C6.3009 10.5451 6.56207 10.1543 6.77762 9.72363C6.99317 9.29293 7.17056 8.79645 7.3098 8.23418H4.6964C4.826 8.7702 4.99798 9.25847 5.21235 9.699C5.42672 10.1395 5.6873 10.5385 5.9941 10.896ZM4.65996 10.6993C4.4339 10.3467 4.2417 9.96799 4.08339 9.56315C3.92507 9.15841 3.79183 8.71542 3.68366 8.23418H1.64492C1.98358 8.86037 2.3867 9.3657 2.85427 9.75018C3.32194 10.1346 3.92384 10.451 4.65996 10.6993ZM7.3393 10.6895C7.99017 10.482 8.57441 10.1676 9.09204 9.74635C9.60957 9.32509 10.0286 8.82103 10.3492 8.23418H8.32268C8.20793 8.70884 8.07188 9.14858 7.91455 9.55342C7.75712 9.95816 7.56537 10.3368 7.3393 10.6895ZM1.28458 7.26142H3.49678C3.46728 7.01893 3.44845 6.79601 3.44029 6.59265C3.43203 6.3894 3.4279 6.1857 3.4279 5.98156C3.4279 5.74881 3.43365 5.53793 3.44515 5.34894C3.45666 5.15994 3.47716 4.95398 3.50666 4.73106H1.28458C1.22233 4.95319 1.17892 5.15733 1.15433 5.34348C1.12975 5.52952 1.11746 5.74222 1.11746 5.98156C1.11746 6.21845 1.12975 6.43547 1.15433 6.63263C1.17892 6.82979 1.22233 7.03938 1.28458 7.26142ZM4.49978 7.26142H7.50656C7.54098 6.99267 7.56315 6.76321 7.57309 6.57304C7.58302 6.38286 7.58798 6.1857 7.58798 5.98156C7.58798 5.78155 7.58302 5.59034 7.57309 5.40794C7.56315 5.22543 7.54098 4.9998 7.50656 4.73106H4.49978C4.46369 4.9998 4.43994 5.22543 4.42854 5.40794C4.41703 5.59034 4.41128 5.78155 4.41128 5.98156C4.41128 6.1857 4.41703 6.38286 4.42854 6.57304C4.43994 6.76321 4.46369 6.99267 4.49978 7.26142ZM8.4898 7.26142H10.7083C10.769 7.03938 10.812 6.82979 10.8374 6.63263C10.8628 6.43547 10.8755 6.21845 10.8755 5.98156C10.8755 5.74222 10.8628 5.52952 10.8374 5.34348C10.812 5.15733 10.769 4.95319 10.7083 4.73106H8.49968C8.52525 5.02763 8.54359 5.26678 8.5547 5.4485C8.56581 5.63012 8.57137 5.80781 8.57137 5.98156C8.57137 6.19219 8.56419 6.3926 8.54983 6.58277C8.53547 6.77305 8.51546 6.99926 8.4898 7.26142ZM8.3128 3.75476H10.3492C10.0417 3.14322 9.62919 2.62702 9.11166 2.20616C8.59413 1.78529 8.0001 1.48424 7.32956 1.30301C7.55553 1.65062 7.74724 2.02296 7.90467 2.42003C8.0621 2.8171 8.19814 3.26201 8.3128 3.75476ZM4.6964 3.75476H7.31968C7.21063 3.26781 7.03973 2.79856 6.80697 2.34702C6.57422 1.89547 6.30326 1.48852 5.9941 1.12616C5.70697 1.41801 5.46113 1.77088 5.2566 2.18477C5.05207 2.59865 4.86533 3.12198 4.6964 3.75476ZM1.64492 3.75476H3.6934C3.79507 3.28168 3.92178 2.84827 4.0735 2.45455C4.22533 2.06072 4.41752 1.68017 4.65008 1.3129C3.97797 1.49412 3.38886 1.79148 2.88274 2.20498C2.37652 2.61857 1.96391 3.13516 1.64492 3.75476Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$trendingDown = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '25'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '25'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 25 25'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'mask',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'mask0_107_13'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'mask-type:alpha'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'maskUnits', 'userSpaceOnUse'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'x', '0'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'y', '0'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'width', '25'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'height', '25')
					]),
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'rect',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'x', '0.90918'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'y', '0.0909119'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'width', '24'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'height', '24'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#E1000C')
							]),
						_List_Nil)
					])),
				A3(
				$elm$svg$Svg$node,
				'g',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'mask', 'url(#mask0_107_13)')
					]),
				_List_fromArray(
					[
						A3(
						$elm$svg$Svg$node,
						'path',
						_List_fromArray(
							[
								A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M16.9092 18.0909V16.0909H19.5092L14.3092 10.9409L10.3092 14.9409L2.90918 7.49091L4.30918 6.09091L10.3092 12.0909L14.3092 8.09091L20.9092 14.6909V12.0909H22.9092V18.0909H16.9092Z'),
								A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Generated$Icons$trendingUp = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '1 -4 20 20'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.4 12L0 10.6L7.4 3.15L11.4 7.15L16.6 2H14V0H20V6H18V3.4L11.4 10L7.4 6L1.4 12Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$unpublishedRuleArrow = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'width', '21'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'height', '22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 21 22'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1 19H0.5V19.5H1V19ZM20.5 19L15.5 16.1132V21.8868L20.5 19ZM0.5 0.5V19H1.5V0.5H0.5ZM1 19.5H16V18.5H1V19.5Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$upload = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 16'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.54097 15.119C1.12482 15.119 0.763951 14.9656 0.458371 14.6587C0.15279 14.3519 0 13.9895 0 13.5715V10.0949H1.54097V13.5726H13.459V10.0949H15V13.5701C15 13.9877 14.8463 14.3503 14.5388 14.6578C14.2313 14.9653 13.8714 15.119 13.459 15.119H1.54097ZM6.73223 11.2853V2.97522L4.05056 5.66232L2.94277 4.55994L7.5027 0L12.0626 4.55994L10.9548 5.66232L8.27318 2.97522V11.2853H6.73223Z'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$void = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 11'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.40872 8.5L8.52589 6.36538L10.6621 8.5L11.5395 7.63461L9.3842 5.5L11.5014 3.36539L10.624 2.48077L8.52589 4.63462L6.40872 2.48077L5.53134 3.36539L7.66758 5.5L5.53134 7.63461L6.40872 8.5ZM3.87193 11L0 5.5L3.87193 0H14V11H3.87193ZM4.53951 9.69231H12.703V1.30769H4.53951L1.62125 5.5L4.53951 9.69231Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$warning = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12 1.6875C13.3922 1.6875 14.7422 1.95938 16.0125 2.49609C17.2406 3.01641 18.3422 3.75937 19.2914 4.70625C20.2383 5.65312 20.9836 6.75703 21.5016 7.98516C22.0406 9.25781 22.3125 10.6078 22.3125 12C22.3125 13.3922 22.0406 14.7422 21.5039 16.0125C20.9836 17.2406 20.2406 18.3422 19.2938 19.2914C18.3469 20.2383 17.243 20.9836 16.0148 21.5016C14.7422 22.0406 13.3922 22.3125 12 22.3125C10.6078 22.3125 9.25781 22.0406 7.9875 21.5039C6.75938 20.9836 5.65781 20.2406 4.70859 19.2937C3.76172 18.3469 3.01641 17.243 2.49844 16.0148C1.95938 14.7422 1.6875 13.3922 1.6875 12C1.6875 10.6078 1.95938 9.25781 2.49609 7.9875C3.01641 6.75937 3.75938 5.65781 4.70625 4.70859C5.65312 3.76172 6.75703 3.01641 7.98516 2.49844C9.25781 1.95938 10.6078 1.6875 12 1.6875ZM12 0C5.37187 0 0 5.37188 0 12C0 18.6281 5.37187 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM12 15C11.482 15 11.0625 14.5805 11.0625 14.0625V5.41406C11.0625 4.89609 11.482 4.47656 12 4.47656C12.518 4.47656 12.9375 4.89609 12.9375 5.41406V14.0625C12.9375 14.5805 12.518 15 12 15ZM10.9453 17.5547C10.9453 16.9722 11.4175 16.5 12 16.5C12.5825 16.5 13.0547 16.9722 13.0547 17.5547C13.0547 18.1372 12.5825 18.6094 12 18.6094C11.4175 18.6094 10.9453 18.1372 10.9453 17.5547Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Generated$Icons$webhook = function (attrs) {
	return A3(
		$elm$svg$Svg$node,
		'svg',
		_Utils_ap(
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
				]),
			attrs),
		_List_fromArray(
			[
				A3(
				$elm$svg$Svg$node,
				'path',
				_List_fromArray(
					[
						A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M280-120q-83 0-141.5-58.5T80-320q0-73 45.5-127.5T240-516v83q-35 12-57.5 43T160-320q0 50 35 85t85 35q50 0 85-35t35-85v-40h235q8-9 19.5-14.5T680-380q25 0 42.5 17.5T740-320q0 25-17.5 42.5T680-260q-14 0-25.5-5.5T635-280H476q-14 69-68.5 114.5T280-120Zm400 0q-56 0-101.5-27.5T507-220h107q14 10 31 15t35 5q50 0 85-35t35-85q0-50-35-85t-85-35q-20 0-37 5.5T611-418L489-621q-21-4-35-20t-14-39q0-25 17.5-42.5T500-740q25 0 42.5 17.5T560-680v8.5q0 3.5-2 8.5l87 146q8-2 17-2.5t18-.5q83 0 141.5 58.5T880-320q0 83-58.5 141.5T680-120ZM280-260q-25 0-42.5-17.5T220-320q0-22 14-38t34-21l94-156q-29-27-45.5-64.5T300-680q0-83 58.5-141.5T500-880q83 0 141.5 58.5T700-680h-80q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 43 26 75.5t66 41.5L337-338q2 5 2.5 9t.5 9q0 25-17.5 42.5T280-260Z')
					]),
				_List_Nil)
			]));
};
var $author$project$Ui$SvgIcon$generatedFun = function (name) {
	switch (name) {
		case 0:
			return $author$project$Generated$Icons$syncedTo;
		case 1:
			return $author$project$Generated$Icons$syncedFrom;
		case 2:
			return $author$project$Generated$Icons$unpublishedRuleArrow;
		case 3:
			return $author$project$Generated$Icons$account;
		case 4:
			return $author$project$Generated$Icons$admin;
		case 6:
			return $author$project$Generated$Icons$commissions;
		case 7:
			return $author$project$Generated$Icons$help;
		case 8:
			return $author$project$Generated$Icons$patients;
		case 9:
			return $author$project$Generated$Icons$report;
		case 10:
			return $author$project$Generated$Icons$share;
		case 11:
			return $author$project$Generated$Icons$sponsors;
		case 12:
			return $author$project$Generated$Icons$chevron;
		case 13:
			return $author$project$Generated$Icons$chevronDown;
		case 14:
			return $author$project$Generated$Icons$location;
		case 15:
			return $author$project$Generated$Icons$copy;
		case 16:
			return $author$project$Generated$Icons$enter;
		case 17:
			return $author$project$Generated$Icons$selectArrows;
		case 18:
			return $author$project$Generated$Icons$open;
		case 19:
			return $author$project$Generated$Icons$kebabMenu;
		case 20:
			return $author$project$Generated$Icons$launch;
		case 21:
			return $author$project$Generated$Icons$exit;
		case 22:
			return $author$project$Generated$Icons$paymentMethods;
		case 23:
			return $author$project$Generated$Icons$employees;
		case 24:
			return $author$project$Generated$Icons$employeeUploads;
		case 25:
			return $author$project$Generated$Icons$invoices;
		case 26:
			return $author$project$Generated$Icons$onlineSignup;
		case 27:
			return $author$project$Generated$Icons$accountPricing;
		case 28:
			return $author$project$Generated$Icons$burgerMenu;
		case 29:
			return $author$project$Generated$Icons$burgerMenuClose;
		case 30:
			return $author$project$Generated$Icons$hint404;
		case 31:
			return $author$project$Generated$Icons$favicon;
		case 32:
			return $author$project$Generated$Icons$hintHeart;
		case 33:
			return $author$project$Generated$Icons$hintHeartFlat;
		case 34:
			return $author$project$Generated$Icons$sort;
		case 35:
			return $author$project$Generated$Icons$sortDown;
		case 36:
			return $author$project$Generated$Icons$sortUp;
		case 37:
			return $author$project$Generated$Icons$send;
		case 38:
			return $author$project$Generated$Icons$add;
		case 39:
			return $author$project$Generated$Icons$edit;
		case 40:
			return $author$project$Generated$Icons$search;
		case 41:
			return $author$project$Generated$Icons$delete;
		case 42:
			return $author$project$Generated$Icons$flag;
		case 43:
			return $author$project$Generated$Icons$repeat;
		case 44:
			return $author$project$Generated$Icons$check;
		case 45:
			return $author$project$Generated$Icons$circle;
		case 46:
			return $author$project$Generated$Icons$cross;
		case 47:
			return $author$project$Generated$Icons$transfer;
		case 51:
			return $author$project$Generated$Icons$history;
		case 48:
			return $author$project$Generated$Icons$upload;
		case 49:
			return $author$project$Generated$Icons$export;
		case 50:
			return $author$project$Generated$Icons$dollar;
		case 52:
			return $author$project$Generated$Icons$void;
		case 53:
			return $author$project$Generated$Icons$calendar;
		case 54:
			return $author$project$Generated$Icons$stop;
		case 55:
			return $author$project$Generated$Icons$dots;
		case 56:
			return $author$project$Generated$Icons$arrowRight;
		case 58:
			return $author$project$Generated$Icons$arrowRightBottom;
		case 57:
			return $author$project$Generated$Icons$arrowLeft;
		case 59:
			return $author$project$Generated$Icons$warning;
		case 5:
			return $author$project$Generated$Icons$alert;
		case 60:
			return $author$project$Generated$Icons$crossCircle;
		case 61:
			return $author$project$Generated$Icons$translate;
		case 62:
			return $author$project$Generated$Icons$filter;
		case 64:
			return $author$project$Generated$Icons$trendingDown;
		case 63:
			return $author$project$Generated$Icons$trendingUp;
		case 65:
			return $author$project$Generated$Icons$scissors;
		case 66:
			return $author$project$Generated$Icons$star;
		case 67:
			return $author$project$Generated$Icons$starNote;
		case 68:
			return $author$project$Generated$Icons$minus;
		case 69:
			return $author$project$Generated$Icons$testConnection;
		case 70:
			return $author$project$Generated$Icons$dashboard;
		case 71:
			return $author$project$Generated$Icons$inbox;
		case 72:
			return $author$project$Generated$Icons$contact;
		case 73:
			return $author$project$Generated$Icons$form;
		case 74:
			return $author$project$Generated$Icons$file;
		case 75:
			return $author$project$Generated$Icons$inventory;
		case 76:
			return $author$project$Generated$Icons$task;
		case 77:
			return $author$project$Generated$Icons$apiKey;
		case 78:
			return $author$project$Generated$Icons$webhook;
		case 79:
			return $author$project$Generated$Icons$practices;
		case 81:
			return $author$project$Generated$Icons$app;
		case 82:
			return $author$project$Generated$Icons$groups;
		case 83:
			return $author$project$Generated$Icons$sandbox;
		case 84:
			return $author$project$Generated$Icons$package;
		case 85:
			return $author$project$Generated$Icons$call;
		case 86:
			return $author$project$Generated$Icons$mail;
		case 80:
			return $author$project$Generated$Icons$progressActivity;
		case 87:
			return $author$project$Generated$Icons$marketplace;
		case 88:
			return $author$project$Generated$Icons$book;
		case 89:
			return $author$project$Generated$Icons$demography;
		case 90:
			return $author$project$Generated$Icons$businessCenter;
		case 91:
			return $author$project$Generated$Icons$dev;
		default:
			return $author$project$Generated$Icons$quote;
	}
};
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$color = _VirtualDom_attribute('color');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Ui$SvgIcon$optionToAttr = function (option) {
	switch (option.$) {
		case 0:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$color(string)
				]);
		case 1:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(string)
				]);
		case 2:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill(string)
				]);
		case 3:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$width(string)
				]);
		case 4:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$height(string)
				]);
		case 5:
			var degrees = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$transform(
					'rotate(' + ($elm$core$String$fromFloat(degrees) + ')'))
				]);
		default:
			var string = option.a;
			return _List_fromArray(
				[
					$elm$svg$Svg$Attributes$class(string)
				]);
	}
};
var $author$project$Ui$SvgIcon$view = F2(
	function (options, name) {
		var optionAttrs = A2($elm$core$List$concatMap, $author$project$Ui$SvgIcon$optionToAttr, options);
		return A2($author$project$Ui$SvgIcon$generatedFun, name, optionAttrs);
	});
var $author$project$Ui$SvgIcon$viewIcon = F2(
	function (name, iconOptions) {
		return A2(
			$author$project$Ui$SvgIcon$view,
			$author$project$Ui$SvgIcon$iconOptionsToSvgOptions(iconOptions),
			name);
	});
var $author$project$Ui$SvgIcon$chevronDown = $author$project$Ui$SvgIcon$viewIcon(13);
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Ui$HorizontalRule$optionToAttributes = function (option) {
	if (!option.$) {
		var style = option.a;
		switch (style) {
			case 0:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('double')
					]);
			case 1:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('thin')
					]);
			case 2:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('minimal')
					]);
			default:
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('separator')
					]);
		}
	} else {
		var margin_ = option.a;
		return _List_fromArray(
			[
				$author$project$Ui$Margin$toClass(margin_)
			]);
	}
};
var $author$project$Ui$HorizontalRule$optionsToAttributes = function (options) {
	return A2($elm$core$List$concatMap, $author$project$Ui$HorizontalRule$optionToAttributes, options);
};
var $author$project$Ui$HorizontalRule$view = function (options) {
	return A2(
		$elm$html$Html$hr,
		$author$project$Ui$HorizontalRule$optionsToAttributes(options),
		_List_Nil);
};
var $author$project$Ui$Table$defaultOptions = {
	vw: _List_Nil,
	EB: _List_Nil,
	wL: _List_fromArray(
		['table-wrapper']),
	S_: false,
	DS: $elm$core$Maybe$Nothing
};
var $author$project$Ui$Table$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'table-striped', record.EB)
							});
					case 1:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'table-bordered', record.EB)
							});
					case 2:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'vertical-centered', record.EB)
							});
					case 3:
						var contents = option.a;
						return _Utils_update(
							record,
							{
								DS: $elm$core$Maybe$Just(contents)
							});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{S_: bool});
					case 6:
						var classes = option.a;
						return _Utils_update(
							record,
							{wL: classes});
					default:
						var testString = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(testString),
									record.vw)
							});
				}
			}),
		$author$project$Ui$Table$defaultOptions,
		options);
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Ui$SvgIcon$Sort = 34;
var $author$project$Ui$SvgIcon$SortDown = 35;
var $author$project$Ui$SvgIcon$SortUp = 36;
var $author$project$Ui$SvgIcon$class = $author$project$Ui$SvgIcon$Class;
var $author$project$Ui$SvgIcon$Height = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$SvgIcon$height = $author$project$Ui$SvgIcon$Height;
var $author$project$Ui$Table$defaultCellOptions = {vw: _List_Nil, EB: _List_Nil, pU: 1, zI: $elm$core$Maybe$Nothing, sv: 1, ke: $elm$core$Maybe$Nothing, Hf: false};
var $author$project$Ui$Table$sizeToScreenPrefix = function (screenSize) {
	switch (screenSize) {
		case 0:
			return '';
		case 1:
			return 'sm:';
		case 2:
			return 'md:';
		case 3:
			return 'lg:';
		default:
			return 'xl:';
	}
};
var $author$project$Ui$Table$optionsToCellRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 3:
						var _int = option.a;
						return _Utils_update(
							record,
							{pU: _int});
					case 11:
						var _int = option.a;
						return _Utils_update(
							record,
							{sv: _int});
					case 9:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'nowrap', 'nowrap'),
									record.vw)
							});
					case 8:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'style', 'padding-left: 20px !important'),
									record.vw)
							});
					case 10:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								zI: $elm$core$Maybe$Just(msg)
							});
					case 12:
						var bool = option.a;
						return _Utils_update(
							record,
							{Hf: bool});
					case 13:
						var direction = option.a;
						return _Utils_update(
							record,
							{
								ke: $elm$core$Maybe$Just(direction)
							});
					case 7:
						var width = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'min-width', width),
									record.vw)
							});
					case 0:
						var attr_ = option.a;
						return _Utils_update(
							record,
							{
								vw: A2($elm$core$List$cons, attr_, record.vw)
							});
					case 15:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle'),
									record.vw)
							});
					case 14:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'vertical-align', 'bottom'),
									record.vw)
							});
					case 2:
						var alignment = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Alignment$toClass(alignment),
									record.vw)
							});
					case 5:
						var screen = option.a;
						var span = option.b;
						var widthClass = 'w-' + ((span === 12) ? 'full' : ($elm$core$String$fromInt(span) + '/12'));
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(
										_Utils_ap(
											$author$project$Ui$Table$sizeToScreenPrefix(screen),
											widthClass)),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class(
											$author$project$Ui$Table$sizeToScreenPrefix(screen) + 'table-cell'),
										record.vw))
							});
					case 6:
						var screenSize = option.a;
						if (!screenSize) {
							return _Utils_update(
								record,
								{
									vw: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('flex-grid-hidden'),
										record.vw)
								});
						} else {
							return _Utils_update(
								record,
								{
									vw: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class(
											$author$project$Ui$Table$sizeToScreenPrefix(screenSize) + 'hidden'),
										record.vw)
								});
						}
					case 4:
						var screenSize = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(
										$author$project$Ui$Table$sizeToScreenPrefix(screenSize) + 'table-cell'),
									record.vw)
							});
					default:
						var value = option.a;
						return value ? _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'table-cell--active', record.EB)
							}) : record;
				}
			}),
		$author$project$Ui$Table$defaultCellOptions,
		options);
};
var $author$project$Ui$Skeleton$Span = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$ScreenSize$Xs = 0;
var $author$project$Ui$Skeleton$span = $author$project$Ui$Skeleton$Span(0);
var $author$project$Ui$Skeleton$innerText = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				function (option) {
					if (option.$ === 2) {
						var someText = option.a;
						return $elm$core$Maybe$Just(someText);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				options)));
};
var $author$project$Ui$Skeleton$optionToAttrs = function (option) {
	switch (option.$) {
		case 0:
			var screenSize = option.a;
			var _int = option.b;
			var width = 'w-' + ((_int === 12) ? 'full' : ($elm$core$String$fromInt(_int) + '/12'));
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					_Utils_ap(
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize),
						width))
				]);
		case 1:
			var _v1 = option.a;
			return $elm$core$List$singleton(
				$elm$html$Html$Attributes$class('skeleton--block'));
		default:
			return $elm$core$List$singleton(
				$elm$html$Html$Attributes$class('w-auto'));
	}
};
var $author$project$Ui$Skeleton$view = F2(
	function (modifier, options) {
		var attrs = A3(
			$elm$core$List$foldl,
			F2(
				function (option, acc) {
					return _Utils_ap(
						acc,
						$author$project$Ui$Skeleton$optionToAttrs(option));
				}),
			_List_Nil,
			options);
		return A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('skeleton--' + modifier),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('skeleton'),
					attrs)),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Ui$Skeleton$innerText(options))
				]));
	});
var $author$project$Ui$Skeleton$text = $author$project$Ui$Skeleton$view('text');
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$Ui$Table$viewHeader = F2(
	function (loading_, _v0) {
		var _v1 = _v0;
		var options = _v1.a;
		var contents = _v1.b;
		var optionsRecord = $author$project$Ui$Table$optionsToCellRecord(options);
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($elm$core$String$join, ' ', optionsRecord.EB)),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('clickable', optionsRecord.Hf)
							])),
						$elm$html$Html$Attributes$class('table_cell table__cell--header')
					]),
					A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.vw),
					function () {
					var _v4 = optionsRecord.zI;
					if (!_v4.$) {
						var toMsg = _v4.a;
						return _List_fromArray(
							[
								$elm$html$Html$Events$onClick(toMsg),
								$elm$html$Html$Attributes$class('clickable')
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
		return A2(
			$elm$html$Html$th,
			attributes,
			_Utils_ap(
				loading_ ? _List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(10)
							]))
					]) : contents,
				function () {
					var _v2 = optionsRecord.ke;
					if (!_v2.$) {
						var direction = _v2.a;
						return $elm$core$List$singleton(
							A2(
								$author$project$Ui$SvgIcon$view,
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$height('12px'),
										$author$project$Ui$SvgIcon$class('ml-2 -mb-0.5')
									]),
								function () {
									if (!direction) {
										return 36;
									} else {
										return 35;
									}
								}()));
					} else {
						return optionsRecord.Hf ? _List_fromArray(
							[
								A2(
								$author$project$Ui$SvgIcon$view,
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$height('12px'),
										$author$project$Ui$SvgIcon$class('ml-2 -mb-0.5')
									]),
								34)
							]) : _List_Nil;
					}
				}()));
	});
var $author$project$Ui$Table$Cell = $elm$core$Basics$identity;
var $author$project$Ui$Table$cell = F2(
	function (options, content) {
		return _Utils_Tuple2(options, content);
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$rowspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rowspan',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Ui$Table$viewCell = function (_v0) {
	var _v1 = _v0;
	var options = _v1.a;
	var content = _v1.b;
	var optionsRecord = $author$project$Ui$Table$optionsToCellRecord(options);
	var attributes = $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table__cell')
				]),
				A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map($elm$core$Basics$never),
				optionsRecord.vw),
				_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($elm$core$String$join, ' ', optionsRecord.EB))
				]),
				(optionsRecord.pU !== 1) ? _List_fromArray(
				[
					$elm$html$Html$Attributes$colspan(optionsRecord.pU)
				]) : _List_Nil,
				(optionsRecord.sv !== 1) ? _List_fromArray(
				[
					$elm$html$Html$Attributes$rowspan(optionsRecord.sv)
				]) : _List_Nil
			]));
	return A2($elm$html$Html$td, attributes, content);
};
var $author$project$Ui$Table$viewLoading = function (colspan_) {
	return A2(
		$elm$core$List$repeat,
		10,
		A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Ui$Table$viewCell,
				A2(
					$elm$core$List$repeat,
					colspan_,
					A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(10)
									]))
							]))))));
};
var $author$project$Ui$Table$defaultRowOptions = {vw: _List_Nil, EB: _List_Nil};
var $author$project$Ui$Table$optionsToRowRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var color_ = option.a;
					switch (color_) {
						case 2:
							return _Utils_update(
								record,
								{
									EB: A2($elm$core$List$cons, 'table__row--info', record.EB)
								});
						case 1:
							return _Utils_update(
								record,
								{
									EB: A2($elm$core$List$cons, 'table__row--success', record.EB)
								});
						case 3:
							return _Utils_update(
								record,
								{
									EB: A2($elm$core$List$cons, 'table__row--warning', record.EB)
								});
						case 4:
							return _Utils_update(
								record,
								{
									EB: A2($elm$core$List$cons, 'table__row--danger', record.EB)
								});
						default:
							return _Utils_update(
								record,
								{
									EB: A2($elm$core$List$cons, 'active', record.EB)
								});
					}
				} else {
					return _Utils_update(
						record,
						{
							EB: A2($elm$core$List$cons, 'table__row--indented', record.EB)
						});
				}
			}),
		$author$project$Ui$Table$defaultRowOptions,
		options);
};
var $author$project$Ui$Table$viewRow = function (row_) {
	if (row_.$ === 1) {
		var _v1 = row_.a;
		var options = _v1.a;
		var cells = _v1.b;
		var optionsRecord = $author$project$Ui$Table$optionsToRowRecord(options);
		var attributes = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('table__row'),
				$elm$html$Html$Attributes$class(
				A2($elm$core$String$join, ' ', optionsRecord.EB))
			]);
		return A2(
			$elm$html$Html$tr,
			attributes,
			A2($elm$core$List$map, $author$project$Ui$Table$viewCell, cells));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Table$viewZeroState = F2(
	function (contents, colspan_) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table__row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table__cell'),
							$elm$html$Html$Attributes$colspan(colspan_),
							$elm$html$Html$Attributes$class('text-center')
						]),
					contents)
				]));
	});
var $author$project$Ui$Table$view = F4(
	function (options, headers, rows, footers) {
		var optionsRecord = $author$project$Ui$Table$optionsToRecord(options);
		var mainContainerClasses = A2($elm$core$String$join, ' ', optionsRecord.wL);
		var classes = A2($elm$core$List$cons, 'table', optionsRecord.EB);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(mainContainerClasses)
				]),
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$table,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class(
							A2($elm$core$String$join, ' ', classes)),
						A2(
							$elm$core$List$map,
							$elm$html$Html$Attributes$map($elm$core$Basics$never),
							optionsRecord.vw)),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Ui$Table$viewHeader(optionsRecord.S_),
										headers))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							function () {
								var _v0 = _Utils_Tuple3(
									optionsRecord.S_,
									optionsRecord.DS,
									$elm$core$List$isEmpty(rows));
								if (_v0.a) {
									return $author$project$Ui$Table$viewLoading(
										$elm$core$List$length(headers));
								} else {
									if ((!_v0.b.$) && _v0.c) {
										var contents = _v0.b.a;
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Table$viewZeroState,
												contents,
												$elm$core$List$length(headers))
											]);
									} else {
										return A2($elm$core$List$map, $author$project$Ui$Table$viewRow, rows);
									}
								}
							}()),
							$elm$core$List$isEmpty(footers) ? $author$project$Utils$Html$empty : A2(
							$elm$html$Html$tfoot,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Ui$Table$viewRow, footers))
						]))));
	});
var $author$project$Ui$Panel$sectionToContents = F2(
	function (optionsRecord, section) {
		switch (section.$) {
			case 0:
				var attributes = section.a;
				var contents = section.b;
				var _v1 = optionsRecord.lu;
				if (!_v1.$) {
					var isCollapsed = _v1.a;
					var chevron = A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-heading__chevron')
							]),
						_List_fromArray(
							[
								$author$project$Ui$SvgIcon$chevronDown(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$xs]))
							]));
					var checkbox = A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$class('panel__checkbox'),
								A2(
								$elm$html$Html$Attributes$property,
								'defaultChecked',
								$elm$json$Json$Encode$bool(isCollapsed))
							]),
						_List_Nil);
					return $elm$core$Maybe$Just(
						A4(
							$author$project$Ui$Element$customNode,
							'label',
							'panel-heading',
							attributes,
							A2(
								$elm$core$List$cons,
								checkbox,
								_Utils_ap(
									contents,
									_List_fromArray(
										[chevron])))));
				} else {
					return $elm$core$Maybe$Just(
						A3($author$project$Ui$Element$custom, 'panel-heading', attributes, contents));
				}
			case 1:
				var attributes = section.a;
				var contents = section.b;
				return $elm$core$Maybe$Just(
					A3($author$project$Ui$Element$custom, 'panel-body', attributes, contents));
			case 2:
				var attributes = section.a;
				var contents = section.b;
				return $elm$core$Maybe$Just(
					A3($author$project$Ui$Element$custom, 'panel-footer', attributes, contents));
			case 3:
				var options = section.a;
				var headers = section.b;
				var rows = section.c;
				var footers = section.d;
				return $elm$core$Maybe$Just(
					A4($author$project$Ui$Table$view, options, headers, rows, footers));
			case 4:
				return $elm$core$Maybe$Just(
					$author$project$Ui$HorizontalRule$view(_List_Nil));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Ui$Panel$sectionsToContents = F2(
	function (optionsRecord, sections) {
		return A2(
			$elm$core$List$filterMap,
			$author$project$Ui$Panel$sectionToContents(optionsRecord),
			sections);
	});
var $author$project$Ui$Panel$view = F2(
	function (options, sections) {
		var optionsRecord = $author$project$Ui$Panel$optionsToRecord(options);
		var isCollapsible = !_Utils_eq(optionsRecord.lu, $elm$core$Maybe$Nothing);
		var isCollapsed = A2($elm$core$Maybe$withDefault, false, optionsRecord.lu);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panel'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(optionsRecord.s_),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('panel--subtle', optionsRecord.Dh),
									_Utils_Tuple2('panel--collapsible', isCollapsible),
									_Utils_Tuple2('panel--collapsed', isCollapsed)
								])),
						optionsRecord.vx))),
			A2($author$project$Ui$Panel$sectionsToContents, optionsRecord, sections));
	});
var $author$project$Ui$Button$Loading = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Button$loading = $author$project$Ui$Button$Loading;
var $author$project$Ui$Button$OnClick = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Button$onClick = function (msg) {
	return $author$project$Ui$Button$OnClick(msg);
};
var $author$project$Ui$Button$Primary = 1;
var $author$project$Ui$Button$Styled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Button$primary = $author$project$Ui$Button$Styled(1);
var $author$project$Ui$Button$AriaLabel = function (a) {
	return {$: 18, a: a};
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $author$project$Utils$Dom$isOutsideTarget = function (id) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (elementId) {
					return _Utils_eq(id, elementId) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Utils$Dom$isOutsideTarget(id));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $author$project$Utils$Dom$blurOutside = F2(
	function (msg, id) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('blurred inside');
			},
			A2(
				$elm$json$Json$Decode$field,
				'relatedTarget',
				$author$project$Utils$Dom$isOutsideTarget(id)));
	});
var $author$project$Utils$Dom$onOutsideBlur = F2(
	function (msg, id) {
		return A2(
			$elm$html$Html$Events$on,
			'blur',
			A2($author$project$Utils$Dom$blurOutside, msg, id));
	});
var $author$project$Ui$Button$Secondary = 2;
var $author$project$Ui$Button$Default = 0;
var $author$project$Ui$Button$Md = 1;
var $author$project$Ui$Button$defaultOptions = {vw: _List_Nil, dW: false, N0: false, Fp: false, QG: $elm$core$Maybe$Nothing, qP: _List_Nil, S_: false, zI: $elm$core$Maybe$Nothing, zN: $elm$core$Maybe$Nothing, ag_: 1, s_: 0, tb: 0, ahI: 'button'};
var $author$project$Ui$Button$sizeToIconSize = function (size_) {
	switch (size_) {
		case 0:
			return _List_fromArray(
				[$author$project$Ui$SvgIcon$sm]);
		case 1:
			return _List_Nil;
		default:
			return _List_fromArray(
				[$author$project$Ui$SvgIcon$lg]);
	}
};
var $author$project$Ui$Button$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var stylingType = option.a;
						return _Utils_update(
							record,
							{s_: stylingType});
					case 8:
						var size_ = option.a;
						return _Utils_update(
							record,
							{
								qP: _Utils_ap(
									$author$project$Ui$Button$sizeToIconSize(size_),
									record.qP),
								ag_: size_
							});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{dW: bool});
					case 3:
						return _Utils_update(
							record,
							{ahI: 'submit'});
					case 12:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('close'),
									A2(
										$elm$core$List$cons,
										A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
										record.vw)),
								s_: 2
							});
					case 6:
						var bool = option.a;
						return _Utils_update(
							record,
							{S_: bool});
					case 4:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								zI: $elm$core$Maybe$Just(msg)
							});
					case 5:
						var ids = option.a;
						var msg = option.b;
						return _Utils_update(
							record,
							{
								zN: $elm$core$Maybe$Just(
									_Utils_Tuple2(ids, msg))
							});
					case 7:
						var bool = option.a;
						return _Utils_update(
							record,
							{Fp: bool});
					case 2:
						var list = option.a;
						return _Utils_update(
							record,
							{
								vw: _Utils_ap(record.vw, list)
							});
					case 9:
						var side = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Pull$toClass(side),
									record.vw)
							});
					case 11:
						var margin_ = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Margin$toClass(margin_),
									record.vw)
							});
					case 10:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('button--primary', bool)
											])),
									record.vw)
							});
					case 13:
						var alignment = option.a;
						return _Utils_update(
							record,
							{
								vw: _Utils_ap(
									$author$project$Ui$Alignment$toAttrs(alignment),
									record.vw)
							});
					case 14:
						var padding_ = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Padding$toClass(padding_),
									record.vw)
							});
					case 15:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('dropdown-toggle'),
									record.vw)
							});
					case 16:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.vw)
							});
					case 17:
						var iconFunc = option.a;
						return _Utils_update(
							record,
							{
								QG: $elm$core$Maybe$Just(iconFunc)
							});
					case 18:
						var label = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$attribute, 'aria-label', label),
									record.vw)
							});
					case 20:
						var index = option.a;
						return _Utils_update(
							record,
							{tb: index});
					default:
						var display_ = option.a;
						var screenSize = option.b;
						return display_ ? _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(
										$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'inline-flex'),
									record.vw)
							}) : _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(
										$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden'),
									record.vw)
							});
				}
			}),
		$author$project$Ui$Button$defaultOptions,
		options);
};
var $author$project$Ui$SvgIcon$ProgressActivity = 80;
var $author$project$Ui$SvgIcon$progressActivity = $author$project$Ui$SvgIcon$viewIcon(80);
var $author$project$Ui$Button$sizeClass = function (size_) {
	return $elm$html$Html$Attributes$class(
		function () {
			switch (size_) {
				case 0:
					return 'button--sm';
				case 1:
					return '';
				default:
					return 'button--lg';
			}
		}());
};
var $author$project$Ui$Button$styleClass = function (style) {
	return $elm$html$Html$Attributes$class(
		function () {
			switch (style) {
				case 0:
					return 'button--default';
				case 1:
					return 'button--primary';
				case 2:
					return 'button--secondary';
				case 3:
					return 'button--success';
				case 4:
					return 'button--warning';
				case 5:
					return 'button--danger';
				case 7:
					return 'button--link';
				case 6:
					return 'button--outline';
				case 8:
					return 'button--link button--link-gray';
				case 9:
					return 'button--with-bg-image';
				default:
					return 'button--badge';
			}
		}());
};
var $author$project$Ui$Button$view = F3(
	function (_v0, options, content) {
		var ariaLabel = _v0.abp;
		var optionsRecord = $author$project$Ui$Button$optionsToRecord(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Button$AriaLabel(ariaLabel),
				options));
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('button--loading', optionsRecord.S_),
								_Utils_Tuple2('w-full justify-center', optionsRecord.Fp)
							])),
						$author$project$Ui$Button$styleClass(optionsRecord.s_),
						$author$project$Ui$Button$sizeClass(optionsRecord.ag_),
						$elm$html$Html$Attributes$disabled(optionsRecord.dW || optionsRecord.S_),
						(!(!optionsRecord.tb)) ? $elm$html$Html$Attributes$tabindex(optionsRecord.tb) : $elm$html$Html$Attributes$class('')
					]),
					A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.vw),
					function () {
					var _v1 = _Utils_Tuple2(optionsRecord.dW, optionsRecord.zI);
					if ((!_v1.a) && (!_v1.b.$)) {
						var msg = _v1.b.a;
						return _List_fromArray(
							[
								$elm$html$Html$Events$onClick(msg)
							]);
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						$elm$html$Html$Attributes$type_(optionsRecord.ahI)
					]),
					function () {
					var _v2 = optionsRecord.zN;
					if (_v2.$ === 1) {
						return _List_Nil;
					} else {
						var _v3 = _v2.a;
						var id = _v3.a;
						var msg = _v3.b;
						return _List_fromArray(
							[
								A2($author$project$Utils$Dom$onOutsideBlur, msg, id)
							]);
					}
				}()
				]));
		return A2(
			$elm$html$Html$button,
			attributes,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (icon_) {
							return icon_(optionsRecord.qP);
						},
						optionsRecord.QG)),
				_Utils_ap(
					$elm$core$List$isEmpty(content) ? _List_Nil : _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button__content')
								]),
							content)
						]),
					optionsRecord.S_ ? _List_fromArray(
						[
							$author$project$Ui$SvgIcon$progressActivity(_List_Nil)
						]) : _List_Nil)));
	});
var $author$project$Components$Layer$CreateForm$viewSubmitButton = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Save account'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$Layer$CreateForm$CreateLayerAccount),
				$author$project$Ui$Button$loading(
				_Utils_eq(model.jY, $author$project$Api$Data$Loading))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Save')
			]));
};
var $author$project$Pages$Accounting$viewCreateAccountBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Accounting')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text('Set up your accounting to get financial insights and reports.')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Accounting$CreateFormMsg,
							$author$project$Components$Layer$CreateForm$view(model.lA))
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Accounting$CreateFormMsg,
							$author$project$Components$Layer$CreateForm$viewSubmitButton(model.lA))
						]))
				]))
		]);
};
var $author$project$Ui$Icon$Loading = 8;
var $author$project$Ui$Typography$Aligned = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Typography$aligned = $author$project$Ui$Typography$Aligned;
var $author$project$Ui$Typography$HelpBlock = {$: 8};
var $author$project$Ui$Typography$helpBlock = $author$project$Ui$Typography$HelpBlock;
var $author$project$Ui$Alignment$Center = 1;
var $author$project$Ui$Alignment$Text = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Alignment$textCenter = $author$project$Ui$Alignment$Text(1);
var $author$project$Ui$Icon$nameClass = function (type_) {
	switch (type_) {
		case 7:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-plus')
				]);
		case 9:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-alert')
				]);
		case 17:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-arrow-right')
				]);
		case 13:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-arrow-left')
				]);
		case 33:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-ok text-success')
				]);
		case 11:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-envelope')
				]);
		case 4:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-pencil')
				]);
		case 10:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-erase')
				]);
		case 19:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-remove text-danger')
				]);
		case 15:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-flag')
				]);
		case 26:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-remove text-danger')
				]);
		case 25:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-link')
				]);
		case 8:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-refresh spin')
				]);
		case 20:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-remove text-danger')
				]);
		case 31:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-new-window')
				]);
		case 23:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-ok')
				]);
		case 24:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-ok-circle text-success')
				]);
		case 60:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon glyphicon-ok text-primary-300')
				]);
		case 32:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-list-alt')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-plus')
				]);
		case 14:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-plus-sign')
				]);
		case 29:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-print')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-remove')
				]);
		case 16:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-floppy-disk')
				]);
		case 27:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-chevron-down')
				]);
		case 28:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-chevron-up')
				]);
		case 30:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-search')
				]);
		case 12:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-ban-circle')
				]);
		case 18:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-ok text-success')
				]);
		case 35:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-warning-sign text-danger')
				]);
		case 36:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-ban-circle text-warning')
				]);
		case 34:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-wrench')
				]);
		case 22:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-shopping-cart')
				]);
		case 21:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-duplicate')
				]);
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-earphone')
				]);
		case 5:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-question-sign text-info')
				]);
		case 6:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-question-sign')
				]);
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-user')
				]);
		case 37:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-cloud-download')
				]);
		case 38:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-lock')
				]);
		case 39:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-file')
				]);
		case 41:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-arrow-up text-danger')
				]);
		case 40:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-arrow-down text-success')
				]);
		case 42:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-cloud-upload')
				]);
		case 43:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-chevron-left')
				]);
		case 44:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-chevron-right')
				]);
		case 45:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-calendar')
				]);
		case 46:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-flash')
				]);
		case 47:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-export')
				]);
		case 48:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-menu-down')
				]);
		case 49:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-menu-up')
				]);
		case 50:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-triangle-top')
				]);
		case 51:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-triangle-bottom')
				]);
		case 52:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-tasks')
				]);
		case 53:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-gift')
				]);
		case 54:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-send')
				]);
		case 55:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-eye-close')
				]);
		case 56:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-eye-open')
				]);
		case 57:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-copy')
				]);
		case 58:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-retweet')
				]);
		case 59:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-random')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('glyphicon-info-sign text-warning')
				]);
	}
};
var $author$project$Utils$Html$Attributes$none = $elm$html$Html$Attributes$class('');
var $author$project$Ui$Icon$optionToAttr = function (option) {
	switch (option.$) {
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-friendly')
				]);
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-muted')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('clickable')
				]);
		case 3:
			var direction = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$Pull$toClass(direction)
				]);
		default:
			var size = option.a;
			switch (size) {
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-xs')
						]);
				case 1:
					return _List_fromArray(
						[$author$project$Utils$Html$Attributes$none]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-md')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('icon-lg')
						]);
			}
	}
};
var $author$project$Ui$Icon$view = F2(
	function (options, name) {
		var optionAttrs = A2($elm$core$List$concatMap, $author$project$Ui$Icon$optionToAttr, options);
		return A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('glyphicon'),
				_Utils_ap(
					$author$project$Ui$Icon$nameClass(name),
					optionAttrs)),
			_List_Nil);
	});
var $author$project$Pages$Accounting$viewLoadingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[
				$author$project$Ui$Typography$helpBlock,
				$author$project$Ui$Typography$muted,
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$Icon$view, _List_Nil, 8)
			]))
	]);
var $author$project$Pages$Accounting$ActivateLayerAccount = {$: 5};
var $author$project$Ui$Form$Group$inputSpanSm = function (span) {
	return $author$project$Ui$Form$Group$InputGrid(
		_List_fromArray(
			[
				'sm:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$OrderedList$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$OrderedList$item = $author$project$Ui$OrderedList$Item;
var $author$project$Ui$Form$Group$labelSpanSm = function (span) {
	return $author$project$Ui$Form$Group$LabelGrid(
		_List_fromArray(
			[
				'sm:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Link$Lg = 3;
var $author$project$Ui$Link$Size = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Link$lg = $author$project$Ui$Link$Size(3);
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Ui$OrderedList$defaultOptions = {vw: _List_Nil};
var $author$project$Ui$OrderedList$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var padding_ = option.a;
					return _Utils_update(
						record,
						{
							vw: A2(
								$elm$core$List$cons,
								$author$project$Ui$Padding$toClass(padding_),
								record.vw)
						});
				} else {
					return _Utils_update(
						record,
						{
							vw: A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('i'),
								record.vw)
						});
				}
			}),
		$author$project$Ui$OrderedList$defaultOptions,
		options);
};
var $author$project$Ui$OrderedList$itemOptionToAttributes = function (option) {
	var margin_ = option;
	return _List_fromArray(
		[
			$author$project$Ui$Margin$toClass(margin_)
		]);
};
var $author$project$Ui$OrderedList$itemOptionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$OrderedList$itemOptionToAttributes, options));
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Ui$OrderedList$viewItem = function (item_) {
	var options = item_.a;
	var contents = item_.b;
	return A2(
		$elm$html$Html$li,
		$author$project$Ui$OrderedList$itemOptionsToAttributes(options),
		contents);
};
var $author$project$Ui$OrderedList$view = F2(
	function (options, items) {
		var optionsRecord = $author$project$Ui$OrderedList$optionsToRecord(options);
		return A2(
			$elm$html$Html$ol,
			optionsRecord.vw,
			A2($elm$core$List$map, $author$project$Ui$OrderedList$viewItem, items));
	});
var $author$project$Components$Layer$OnboardingForm$view = function (onSubmit) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('You\'re almost there!')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label(''),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										A2(
										$author$project$Ui$OrderedList$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$OrderedList$item,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Schedule your onboarding call '),
														A3(
														$author$project$Ui$Link$externalHref,
														'https://calendly.com/hint-bookkeeping/onboarding-call',
														_List_fromArray(
															[$author$project$Ui$Link$targetBlank, $author$project$Ui$Link$lg]),
														_List_fromArray(
															[
																$elm$html$Html$text('here')
															])),
														$elm$html$Html$text('.')
													])),
												A2(
												$author$project$Ui$OrderedList$item,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Come back here to finish setup once you\'re on the call.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Finish setup'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(onSubmit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Finish Setup')
							]))
					]))
			]));
};
var $author$project$Pages$Accounting$viewOnboardingAccountBody = _List_fromArray(
	[
		$author$project$Components$Layer$OnboardingForm$view($author$project$Pages$Accounting$ActivateLayerAccount)
	]);
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Ui$Typography$heading = function (content) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$elm$html$Html$h3,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-heading-md text-main')
				]),
			content));
};
var $author$project$Ui$Element$Margin = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Element$mb2 = $author$project$Ui$Element$Margin('mb-2');
var $author$project$Pages$Accounting$SectionChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Nav$Active = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Nav$activeItem = $author$project$Ui$Nav$Active;
var $author$project$Ui$Nav$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Nav$item = $author$project$Ui$Nav$Item;
var $author$project$Ui$Nav$OnClick = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Nav$onItemClick = $author$project$Ui$Nav$OnClick;
var $author$project$Pages$Accounting$sectionName = function (section) {
	switch (section) {
		case 0:
			return 'Overview';
		case 1:
			return 'Bank Transactions and Accounts';
		case 2:
			return 'Reports';
		case 3:
			return 'General Ledger';
		default:
			return 'Settings';
	}
};
var $author$project$Pages$Accounting$sectionToNavItem = F2(
	function (currentSection, section) {
		return A2(
			$author$project$Ui$Nav$item,
			_List_fromArray(
				[
					$author$project$Ui$Nav$activeItem(
					_Utils_eq(section, currentSection)),
					$author$project$Ui$Nav$onItemClick(
					$author$project$Pages$Accounting$SectionChanged(section))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Pages$Accounting$sectionName(section))
				]));
	});
var $author$project$Ui$Typography$div = F2(
	function (options, contents) {
		return A2(
			$elm$html$Html$div,
			$author$project$Ui$Typography$optionsToAttributes(options),
			contents);
	});
var $author$project$WebComponents$Layer$view = F4(
	function (component, environment, businessId, accessToken) {
		return A3(
			$elm$html$Html$node,
			'layer-' + component,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'business-id', businessId),
					A2($elm$html$Html$Attributes$attribute, 'environment', environment),
					A2($elm$html$Html$Attributes$attribute, 'business-access-token', accessToken)
				]),
			_List_Nil);
	});
var $author$project$WebComponents$Layer$accountingOverview = $author$project$WebComponents$Layer$view('accounting-overview');
var $author$project$WebComponents$Layer$bankTransactionsWithLinkedAccounts = $author$project$WebComponents$Layer$view('bank-transactions-with-linked-accounts');
var $author$project$WebComponents$Layer$bookkeepingOverview = $author$project$WebComponents$Layer$view('bookkeeping-overview');
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$businessId = function (_v0) {
	var record = _v0;
	return record.Kf;
};
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$env = function (_v0) {
	var record = _v0;
	return record.OL;
};
var $author$project$WebComponents$Layer$generalLedger = $author$project$WebComponents$Layer$view('general-ledger');
var $author$project$WebComponents$Layer$reports = $author$project$WebComponents$Layer$view('reports');
var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$token = function (_v0) {
	var record = _v0;
	return record.$Q;
};
var $author$project$Pages$Accounting$sectionToComponent = F3(
	function (layerAccount, accessToken, section) {
		return A2(
			$elm$core$Maybe$map,
			function (component) {
				return A3(
					component,
					$author$project$Api$Provider$Practice$LayerAccount$AccessToken$env(accessToken),
					$author$project$Api$Provider$Practice$LayerAccount$AccessToken$businessId(accessToken),
					$author$project$Api$Provider$Practice$LayerAccount$AccessToken$token(accessToken));
			},
			function () {
				switch (section) {
					case 0:
						return $elm$core$Maybe$Just(
							$author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount) ? $author$project$WebComponents$Layer$bookkeepingOverview : $author$project$WebComponents$Layer$accountingOverview);
					case 1:
						return $elm$core$Maybe$Just($author$project$WebComponents$Layer$bankTransactionsWithLinkedAccounts);
					case 2:
						return $elm$core$Maybe$Just($author$project$WebComponents$Layer$reports);
					case 3:
						return $elm$core$Maybe$Just($author$project$WebComponents$Layer$generalLedger);
					default:
						return $elm$core$Maybe$Nothing;
				}
			}());
	});
var $author$project$Api$Data$toMaybe = function (data) {
	if (data.$ === 3) {
		var value = data.a;
		return $elm$core$Maybe$Just(value);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Layer$EditForm$UpdateLayerAccount = {$: 2};
var $author$project$Ui$Element$mt4 = $author$project$Ui$Element$Margin('mt-4');
var $author$project$Ui$Button$Submit = {$: 3};
var $author$project$Ui$Button$submit = $author$project$Ui$Button$Submit;
var $author$project$Ui$Form$Input$Disabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Input$disabled = $author$project$Ui$Form$Input$Disabled;
var $author$project$Components$Layer$EditForm$viewCountryInput = A2(
	$author$project$Ui$Form$Group$view,
	_List_fromArray(
		[
			$author$project$Ui$Form$Group$labelSpan(4),
			$author$project$Ui$Form$Group$inputSpan(8),
			$author$project$Ui$Form$Group$label('Country')
		]),
	_List_fromArray(
		[
			$author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$value('United States'),
					$author$project$Ui$Form$Input$disabled(true)
				]))
		]));
var $author$project$Components$Layer$EditForm$EntityType = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Layer$EditForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Select$Item = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Select$option = $author$project$Ui$Form$Select$Item;
var $author$project$Components$Layer$EditForm$entityTypeOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var type_ = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(type_),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2('', 'Select an entity type'),
			_Utils_Tuple2('SOLE_PROP', 'Sole Proprietor'),
			_Utils_Tuple2('C_CORP', 'C Corp'),
			_Utils_Tuple2('LLC', 'LLC'),
			_Utils_Tuple2('S_CORP', 'S Corp'),
			_Utils_Tuple2('PARTNERSHIP', 'Partnership')
		]));
var $author$project$Ui$Form$Select$Errors = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Select$errors = $author$project$Ui$Form$Select$Errors;
var $author$project$Ui$Form$Select$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Select$invalid = $author$project$Ui$Form$Select$Invalid;
var $author$project$Ui$Form$Select$OnChange = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Select$onChange = $author$project$Ui$Form$Select$OnChange;
var $author$project$Ui$Form$Select$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Select$value = $author$project$Ui$Form$Select$Value;
var $author$project$Ui$Spinner$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Types$Xs = 0;
var $author$project$Ui$Spinner$extraSmall = $author$project$Ui$Spinner$Size(0);
var $author$project$Ui$SvgIcon$IconColor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SvgIcon$Info = 2;
var $author$project$Ui$SvgIcon$info = $author$project$Ui$SvgIcon$IconColor(2);
var $author$project$Ui$Form$Select$defaultOptions = {EB: _List_Nil, dW: false, fE: _List_Nil, xO: false, x7: false, q$: false, S_: false, ae4: $elm$core$Maybe$Nothing, aaN: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$Select$updateOptionsRecord = F2(
	function (option_, options) {
		switch (option_.$) {
			case 1:
				var bool = option_.a;
				return _Utils_update(
					options,
					{dW: bool});
			case 0:
				var maybeSelected = option_.a;
				return _Utils_update(
					options,
					{aaN: maybeSelected});
			case 2:
				var bool = option_.a;
				return _Utils_update(
					options,
					{q$: bool});
			case 3:
				var bool = option_.a;
				return _Utils_update(
					options,
					{S_: bool});
			case 4:
				var list = option_.a;
				return _Utils_update(
					options,
					{fE: list});
			case 5:
				var string = option_.a;
				return _Utils_update(
					options,
					{
						EB: A2($elm$core$List$cons, string, options.EB)
					});
			case 6:
				var toMsg = option_.a;
				return _Utils_update(
					options,
					{
						ae4: $elm$core$Maybe$Just(toMsg)
					});
			case 7:
				var size_ = option_.a;
				switch (size_) {
					case 0:
						return _Utils_update(
							options,
							{
								EB: A2($elm$core$List$cons, 'input-xs', options.EB)
							});
					case 1:
						return _Utils_update(
							options,
							{
								EB: A2($elm$core$List$cons, 'input-sm', options.EB)
							});
					case 2:
						return _Utils_update(
							options,
							{
								EB: A2($elm$core$List$cons, 'input-md', options.EB)
							});
					default:
						return _Utils_update(
							options,
							{
								EB: A2($elm$core$List$cons, 'input-lg', options.EB)
							});
				}
			case 8:
				return _Utils_update(
					options,
					{x7: true});
			default:
				var bool = option_.a;
				return _Utils_update(
					options,
					{xO: bool});
		}
	});
var $author$project$Ui$Form$Select$optionsListToRecord = function (optionsList) {
	return A3($elm$core$List$foldl, $author$project$Ui$Form$Select$updateOptionsRecord, $author$project$Ui$Form$Select$defaultOptions, optionsList);
};
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$Ui$Spinner$optionToAttrs = function (option) {
	switch (option.$) {
		case 1:
			var attributes = option.a;
			return A2(
				$elm$core$List$map,
				$elm$html$Html$Attributes$map($elm$core$Basics$never),
				attributes);
		case 0:
			var size = option.a;
			switch (size) {
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('spinner-xs')
						]);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('spinner-sm')
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('spinner')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('spinner-lg')
						]);
			}
		default:
			var side = option.a;
			return _List_fromArray(
				[
					$author$project$Ui$Pull$toClass(side)
				]);
	}
};
var $author$project$Ui$Spinner$view = function (options) {
	return A2(
		$elm$html$Html$span,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('spinner'),
			A2($elm$core$List$concatMap, $author$project$Ui$Spinner$optionToAttrs, options)),
		_List_Nil);
};
var $author$project$Ui$Form$Select$itemAttributes = function (options) {
	var disabledAttr = options.dW ? _List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'disabled', 'disabled')
		]) : _List_Nil;
	return A2(
		$elm$core$List$cons,
		$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('disabled', options.dW)
				])),
		disabledAttr);
};
var $author$project$Ui$Form$Select$defaultItemOptions = {dW: false};
var $author$project$Ui$Form$Select$itemOptionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option_, record) {
				var bool = option_;
				return _Utils_update(
					record,
					{dW: bool});
			}),
		$author$project$Ui$Form$Select$defaultItemOptions,
		options);
};
var $elm$html$Html$optgroup = _VirtualDom_node('optgroup');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $author$project$Ui$Form$Select$viewItem = F2(
	function (currentValue, item_) {
		if (!item_.$) {
			var label_ = item_.a;
			var items = item_.b;
			return A2(
				$elm$html$Html$optgroup,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'label', label_)
					]),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Form$Select$viewItem(currentValue),
					items));
		} else {
			var options = item_.a;
			var value_ = item_.b;
			var label_ = item_.c;
			var optionsRecord = $author$project$Ui$Form$Select$itemOptionsToRecord(options);
			return A2(
				$elm$html$Html$option,
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'label', label_),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$selected(
							_Utils_eq(currentValue, value_)),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$value(
								A2($elm$core$Maybe$withDefault, '', value_)),
							$author$project$Ui$Form$Select$itemAttributes(optionsRecord)))),
				_List_fromArray(
					[
						$elm$html$Html$text(label_)
					]));
		}
	});
var $author$project$Ui$Form$Select$view = F2(
	function (options, items) {
		var optionsRecord = $author$project$Ui$Form$Select$optionsListToRecord(options);
		var errorDescription = $elm$core$List$isEmpty(optionsRecord.fE) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-describedby',
				A2($elm$core$String$join, '. ', optionsRecord.fE))
			]);
		var ariaInvalid = optionsRecord.q$ ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('input-wrapper'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inline-block', optionsRecord.x7)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$select,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('form-control'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class(
								A2($elm$core$String$join, ' ', optionsRecord.EB)),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$disabled(optionsRecord.S_ || optionsRecord.dW),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('disabled', optionsRecord.S_ || optionsRecord.dW),
												_Utils_Tuple2('feedback-errored', optionsRecord.q$)
											])),
									_Utils_ap(
										function () {
											var _v0 = optionsRecord.ae4;
											if (!_v0.$) {
												var toMsg = _v0.a;
												return _List_fromArray(
													[
														$elm$html$Html$Events$onInput(toMsg)
													]);
											} else {
												return _List_Nil;
											}
										}(),
										_Utils_ap(errorDescription, ariaInvalid)))))),
					A2(
						$elm$core$List$map,
						$author$project$Ui$Form$Select$viewItem(optionsRecord.aaN),
						items)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('new-dropdown__trigger__chevron')
						]),
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$chevronDown(
							_List_fromArray(
								[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$info]))
						])),
					optionsRecord.S_ ? $author$project$Ui$Spinner$view(
					_List_fromArray(
						[$author$project$Ui$Spinner$extraSmall])) : $author$project$Utils$Html$empty,
					optionsRecord.xO ? $author$project$Utils$Html$empty : $author$project$Utils$FormErrors$view(optionsRecord.fE)
				]));
	});
var $author$project$Components$Layer$EditForm$viewEntityTypeInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var entityType = _v0.OK;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Entity Type'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(entityType),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$EntityType)),
						$author$project$Ui$Form$Select$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
						$author$project$Ui$Form$Select$errors(
						A2($author$project$Utils$Form$validationErrors, 3, form))
					]),
				$author$project$Components$Layer$EditForm$entityTypeOptions)
			]));
};
var $author$project$Components$Layer$EditForm$LegalName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Layer$EditForm$viewLegalNameInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var legalName = _v0.SK;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Legal Name')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', legalName)),
						$author$project$Ui$Form$Input$placeholder('Legal Name'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$LegalName)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]));
};
var $author$project$Components$PhoneInput$PhoneAdded = {$: 0};
var $author$project$Ui$Button$Link = 7;
var $author$project$Ui$Button$styled = $author$project$Ui$Button$Styled;
var $author$project$Ui$Button$link = $author$project$Ui$Button$styled(7);
var $author$project$Ui$Padding$None = 0;
var $author$project$Ui$Padding$none = 0;
var $author$project$Ui$Button$Padding = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Button$padding = $author$project$Ui$Button$Padding;
var $author$project$Formatters$PhoneType$toString = function (type_) {
	switch (type_.$) {
		case 0:
			return 'Mobile';
		case 1:
			return 'Home';
		case 2:
			return 'Office';
		default:
			var otherDescription = type_.a;
			return otherDescription;
	}
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
	});
var $author$project$Ui$Form$Static$optionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			var bool = option.a;
			return bool ? $author$project$Api$Phi$displayAttr : _List_Nil;
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('numeric')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-muted')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('no-value')
				]);
	}
};
var $author$project$Ui$Form$Static$optionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$Form$Static$optionToAttributes, options));
};
var $author$project$Ui$Form$Static$view = F2(
	function (options, contents) {
		return A2(
			$elm$html$Html$p,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('form-control-static'),
				$author$project$Ui$Form$Static$optionsToAttributes(options)),
			contents);
	});
var $author$project$Components$PhoneInput$viewAddMore = F2(
	function (phones, max) {
		return _Utils_cmp(
			$elm$core$List$length(phones),
			max) < 0;
	});
var $author$project$Components$PhoneInput$FormFieldUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PhoneInput$PhoneRemoved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PhoneInput$PhoneType = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$AriaLabel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$NewDropdown$ariaLabel = $author$project$Ui$NewDropdown$AriaLabel;
var $author$project$Ui$FlexGrid$Col = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$FlexGrid$column = $author$project$Ui$FlexGrid$Col;
var $author$project$Ui$SvgIcon$Delete = 41;
var $author$project$Ui$SvgIcon$delete = $author$project$Ui$SvgIcon$viewIcon(41);
var $author$project$Ui$NewDropdown$Disabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$NewDropdown$disabled = $author$project$Ui$NewDropdown$Disabled;
var $author$project$Ui$Button$Icon = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ui$Button$icon = $author$project$Ui$Button$Icon;
var $author$project$Ui$NewDropdown$Item = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$item = $author$project$Ui$NewDropdown$Item;
var $author$project$Ui$FlexGrid$Element = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$FlexGrid$justifyCenter = $author$project$Ui$FlexGrid$Element($author$project$Ui$Element$justifyCenter);
var $author$project$Ui$NewDropdown$Item$OnSelect = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$NewDropdown$onSelect = $author$project$Ui$NewDropdown$Item$OnSelect;
var $author$project$Ui$FlexGrid$optionsToClasses = F2(
	function (toAttributesFunc, options) {
		return A2($elm$core$List$concatMap, toAttributesFunc, options);
	});
var $author$project$Ui$FlexGrid$rowElementOptions = function (options) {
	return A2(
		$elm$core$List$filterMap,
		function (option) {
			if (!option.$) {
				var elemOption = option.a;
				return $elm$core$Maybe$Just(elemOption);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		options);
};
var $author$project$Ui$FlexGrid$rowOptionToClass = function (option) {
	if (option.$ === 1) {
		switch (option.a) {
			case 0:
				var _v1 = option.a;
				return _List_fromArray(
					['gap-0']);
			case 1:
				var _v2 = option.a;
				return _List_fromArray(
					['gap-2']);
			case 2:
				var _v3 = option.a;
				return _List_fromArray(
					['gap-4']);
			default:
				var _v4 = option.a;
				return _List_fromArray(
					['gap-6']);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$FlexGrid$elementOptions = function (options) {
	return A2(
		$elm$core$List$concatMap,
		function (option) {
			if (option.$ === 5) {
				var elemOption = option.a;
				return _List_fromArray(
					[elemOption]);
			} else {
				return _List_Nil;
			}
		},
		options);
};
var $author$project$Ui$FlexGrid$optionToClass = function (option) {
	optionToClass:
	while (true) {
		switch (option.$) {
			case 1:
				var screenSize = option.a;
				return _List_fromArray(
					[
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden'
					]);
			case 3:
				var screenSize = option.a;
				return _List_fromArray(
					[
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'grid'
					]);
			case 0:
				var screenSize = option.a;
				var _int = option.b;
				return _List_fromArray(
					[
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + ('col-span-' + $elm$core$String$fromInt(_int))
					]);
			case 4:
				var screenSize = option.a;
				var _int = option.b;
				return _List_fromArray(
					[
						$author$project$Ui$ScreenSize$toClassPrefix(screenSize) + ('col-start-' + $elm$core$String$fromInt(_int + 1))
					]);
			case 2:
				var _v1 = option.a;
				var bool = _v1.a;
				var opt = _v1.b;
				if (bool) {
					var $temp$option = opt;
					option = $temp$option;
					continue optionToClass;
				} else {
					return _List_Nil;
				}
			case 5:
				return _List_Nil;
			case 6:
				var _int = option.a;
				return _List_fromArray(
					[
						'gap-' + $elm$core$String$fromInt(_int)
					]);
			default:
				return _List_fromArray(
					['h-full']);
		}
	}
};
var $author$project$Ui$FlexGrid$viewCol = function (col) {
	if (col.$ === 1) {
		var options = col.a;
		var content = col.b;
		return A3(
			$author$project$Ui$Element$custom,
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$cons,
					'grid-col',
					A2($author$project$Ui$FlexGrid$optionsToClasses, $author$project$Ui$FlexGrid$optionToClass, options))),
			$author$project$Ui$FlexGrid$elementOptions(options),
			content);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Ui$FlexGrid$row = F2(
	function (options, columns) {
		return A3(
			$author$project$Ui$Element$custom,
			A2(
				$elm$core$String$join,
				' ',
				A2(
					$elm$core$List$cons,
					'grid-row',
					A2($author$project$Ui$FlexGrid$optionsToClasses, $author$project$Ui$FlexGrid$rowOptionToClass, options))),
			$author$project$Ui$FlexGrid$rowElementOptions(options),
			A2($elm$core$List$map, $author$project$Ui$FlexGrid$viewCol, columns));
	});
var $author$project$Ui$FlexGrid$RowElement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Alignment$Items = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Alignment$itemsCenter = $author$project$Ui$Alignment$Items(1);
var $author$project$Ui$Element$itemsCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsCenter);
var $author$project$Ui$FlexGrid$rowItemsCenter = $author$project$Ui$FlexGrid$RowElement($author$project$Ui$Element$itemsCenter);
var $author$project$Ui$NewDropdown$Item$Selected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$NewDropdown$selected = $author$project$Ui$NewDropdown$Item$Selected;
var $author$project$Ui$FlexGrid$Span = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$FlexGrid$span = $author$project$Ui$FlexGrid$Span(0);
var $author$project$Ui$ScreenSize$Sm = 1;
var $author$project$Ui$FlexGrid$spanSm = $author$project$Ui$FlexGrid$Span(1);
var $author$project$Components$PhoneInput$PhoneNumber = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$PhoneInput$PhoneRegion = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Form$Input$AutoCapitalize = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ui$Form$Input$autoCapitalize = $author$project$Ui$Form$Input$AutoCapitalize;
var $author$project$Ui$Form$Input$AutoComplete = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Form$Input$autoComplete = $author$project$Ui$Form$Input$AutoComplete;
var $author$project$Ui$Form$Input$AutoCorrect = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ui$Form$Input$autoCorrect = $author$project$Ui$Form$Input$AutoCorrect;
var $author$project$Ui$Form$Input$group = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('input-group')
			]),
		content);
};
var $author$project$Ui$Form$Input$MaskedValue = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Ui$Form$Input$maskedValue = $author$project$Ui$Form$Input$MaskedValue;
var $author$project$Ui$Form$Input$Phi = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Input$phi = $author$project$Ui$Form$Input$Phi;
var $author$project$Components$PhoneInput$phonePlaceholder = A3($elm$core$String$replace, '#', '5', $author$project$Components$PhoneInput$phoneMask);
var $author$project$Components$PhoneInput$regionToString = function (region) {
	if (!region) {
		return 'US';
	} else {
		return 'Int\'l';
	}
};
var $author$project$Ui$Form$Input$SpellCheck = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ui$Form$Input$spellCheck = $author$project$Ui$Form$Input$SpellCheck;
var $author$project$Ui$Form$Input$Tel = {$: 0};
var $author$project$Ui$Form$Input$Type = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Input$tel = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Tel);
var $author$project$Utils$Form$validated = function (_v0) {
	var validated_ = _v0.b;
	return validated_;
};
var $author$project$Ui$NewDropdown$DropdownButtonClicked = {$: 0};
var $author$project$Ui$NewDropdown$optionsToRecord = A2(
	$elm$core$List$foldl,
	F2(
		function (option, record) {
			switch (option.$) {
				case 0:
					switch (option.a) {
						case 0:
							var _v1 = option.a;
							return _Utils_update(
								record,
								{
									lg: _List_fromArray(
										['button button--secondary'])
								});
						case 2:
							var _v2 = option.a;
							return _Utils_update(
								record,
								{
									lg: _List_fromArray(
										['button button--warning'])
								});
						default:
							var _v3 = option.a;
							return _Utils_update(
								record,
								{
									lg: _List_fromArray(
										['button button--link'])
								});
					}
				case 1:
					var _v4 = option.a;
					return _Utils_update(
						record,
						{
							vL: _List_fromArray(
								['button--sm'])
						});
				case 2:
					var isInvalid = option.a;
					return _Utils_update(
						record,
						{q$: isInvalid});
				case 3:
					var isDisabled = option.a;
					return _Utils_update(
						record,
						{dW: isDisabled});
				case 4:
					var isReadonly = option.a;
					return _Utils_update(
						record,
						{sk: isReadonly});
				case 5:
					var errorList = option.a;
					return _Utils_update(
						record,
						{fE: errorList});
				case 6:
					var label = option.a;
					return _Utils_update(
						record,
						{abp: label});
				case 7:
					var placeholder_ = option.a;
					return _Utils_update(
						record,
						{v7: placeholder_});
				default:
					var isLoading = option.a;
					return _Utils_update(
						record,
						{S_: isLoading});
			}
		}),
	{
		abp: '',
		lg: _List_fromArray(
			['button button--default']),
		vL: _List_Nil,
		v7: '',
		dW: false,
		fE: _List_Nil,
		q$: false,
		S_: false,
		sk: false
	});
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $author$project$Ui$NewDropdown$ArrowPressed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$NewDropdown$Down = 1;
var $author$project$Ui$NewDropdown$EnterPressed = {$: 13};
var $author$project$Ui$NewDropdown$Right = 2;
var $author$project$Ui$NewDropdown$Up = 0;
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Ui$NewDropdown$triggerKeyHandlers = function (toMsg) {
	return A2(
		$elm$html$Html$Events$custom,
		'keydown',
		A2(
			$elm$json$Json$Decode$map,
			function (msg_) {
				return {aeD: msg_, A9: true, Cs: true};
			},
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					switch (key) {
						case ' ':
							return $elm$json$Json$Decode$succeed(
								toMsg($author$project$Ui$NewDropdown$DropdownButtonClicked));
						case 'Enter':
							return $elm$json$Json$Decode$succeed(
								toMsg($author$project$Ui$NewDropdown$EnterPressed));
						case 'ArrowDown':
							return $elm$json$Json$Decode$succeed(
								toMsg(
									$author$project$Ui$NewDropdown$ArrowPressed(1)));
						case 'ArrowUp':
							return $elm$json$Json$Decode$succeed(
								toMsg(
									$author$project$Ui$NewDropdown$ArrowPressed(0)));
						case 'ArrowRight':
							return $elm$json$Json$Decode$succeed(
								toMsg(
									$author$project$Ui$NewDropdown$ArrowPressed(2)));
						default:
							return $elm$json$Json$Decode$fail('ignore');
					}
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$Ui$NewDropdown$ArrowNavigation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$NewDropdown$Item$Checkbox = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$FocusInput = {$: 10};
var $author$project$Ui$NewDropdown$FocusLink = {$: 11};
var $author$project$Ui$NewDropdown$Item$InnerDropdown = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$NewDropdown$InnerDropdownButtonClicked = {$: 3};
var $author$project$Ui$NewDropdown$Item$Input = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$NewDropdown$Item$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$Item$Link = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Ui$NewDropdown$Item$OnArrowRight = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$NewDropdown$Item$Radio = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$Item$Separator = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$NewDropdown$ItemEnterPressed = {$: 14};
var $author$project$Ui$NewDropdown$ItemSelected = {$: 8};
var $author$project$Ui$NewDropdown$Left = 3;
var $author$project$Ui$NewDropdown$defaultItemOptions = function (toMsg) {
	return {
		vw: _List_Nil,
		hL: false,
		QG: $elm$core$Maybe$Nothing,
		ad1: $elm$core$Maybe$Nothing,
		UZ: _List_fromArray(
			[
				_Utils_Tuple2(
				'ArrowDown',
				toMsg(
					$author$project$Ui$NewDropdown$ArrowNavigation(1))),
				_Utils_Tuple2(
				'ArrowUp',
				toMsg(
					$author$project$Ui$NewDropdown$ArrowNavigation(0))),
				_Utils_Tuple2(
				'ArrowLeft',
				toMsg(
					$author$project$Ui$NewDropdown$ArrowNavigation(3))),
				_Utils_Tuple2(
				'ArrowRight',
				toMsg(
					$author$project$Ui$NewDropdown$ArrowNavigation(2)))
			]),
		zH: $elm$core$Basics$always(
			toMsg($author$project$Ui$NewDropdown$NoOp)),
		zI: toMsg($author$project$Ui$NewDropdown$NoOp),
		ae9: toMsg($author$project$Ui$NewDropdown$NoOp),
		afa: toMsg($author$project$Ui$NewDropdown$ItemEnterPressed),
		afb: toMsg($author$project$Ui$NewDropdown$NoOp),
		afc: $elm$core$Basics$always(
			toMsg($author$project$Ui$NewDropdown$NoOp)),
		afh: toMsg($author$project$Ui$NewDropdown$ItemSelected),
		afl: false,
		ag: false,
		aaN: $elm$core$Maybe$Nothing
	};
};
var $author$project$Ui$NewDropdown$Item$OnEnter = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$NewDropdown$onEnter = $author$project$Ui$NewDropdown$Item$OnEnter;
var $author$project$Ui$NewDropdown$Item$OnFocus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$NewDropdown$onFocus = $author$project$Ui$NewDropdown$Item$OnFocus;
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Ui$Margin$Left_2 = 12;
var $author$project$Ui$NewDropdown$Item$optionsToRecord = F2(
	function (defaultOptions, options) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (option_, record) {
					switch (option_.$) {
						case 0:
							var msg = option_.a;
							return _Utils_update(
								record,
								{zI: msg});
						case 1:
							var msg = option_.a;
							return _Utils_update(
								record,
								{afb: msg});
						case 2:
							var bool = option_.a;
							return _Utils_update(
								record,
								{ag: bool});
						case 3:
							var msg = option_.a;
							return _Utils_update(
								record,
								{afc: msg});
						case 4:
							var string = option_.a;
							return _Utils_update(
								record,
								{
									aaN: $elm$core$Maybe$Just(string)
								});
						case 5:
							var checked = option_.a;
							return _Utils_update(
								record,
								{hL: checked});
						case 6:
							var msg = option_.a;
							return _Utils_update(
								record,
								{zH: msg});
						case 7:
							var msg = option_.a;
							return _Utils_update(
								record,
								{ae9: msg});
						case 8:
							var placeholder = option_.a;
							return _Utils_update(
								record,
								{
									ad1: $elm$core$Maybe$Just(placeholder)
								});
						case 9:
							var msg = option_.a;
							return _Utils_update(
								record,
								{
									UZ: A2(
										$elm$core$List$map,
										function (_v1) {
											var key = _v1.a;
											var handler = _v1.b;
											if (key === 'ArrowRight') {
												return _Utils_Tuple2('ArrowRight', msg);
											} else {
												return _Utils_Tuple2(key, handler);
											}
										},
										record.UZ)
								});
						case 10:
							return _Utils_update(
								record,
								{afl: true});
						case 11:
							return _Utils_update(
								record,
								{
									vw: _Utils_ap(
										record.vw,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('lg:hidden')
											]))
								});
						case 12:
							var iconFunc = option_.a;
							return _Utils_update(
								record,
								{
									QG: $elm$core$Maybe$Just(iconFunc)
								});
						default:
							return _Utils_update(
								record,
								{
									vw: A2(
										$elm$core$List$cons,
										$author$project$Ui$Margin$toClass(12),
										record.vw)
								});
					}
				}),
			defaultOptions,
			options);
	});
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$NewDropdown$Item$onKeyDown = function (handlers) {
	return A2(
		$elm$html$Html$Events$custom,
		'keydown',
		A2(
			$elm$json$Json$Decode$map,
			function (msg) {
				return {aeD: msg, A9: true, Cs: true};
			},
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					var _v0 = A2(
						$elm$core$List$filter,
						function (_v1) {
							var k = _v1.a;
							return _Utils_eq(k, key);
						},
						handlers);
					if (_v0.b && (!_v0.b.b)) {
						var _v2 = _v0.a;
						var msg = _v2.b;
						return $elm$json$Json$Decode$succeed(msg);
					} else {
						return $elm$json$Json$Decode$fail('ignore');
					}
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
};
var $author$project$Ui$NewDropdown$Item$onMouse = F2(
	function (event, msg) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			$elm$json$Json$Decode$succeed(
				{aeD: msg, A9: true, Cs: true}));
	});
var $author$project$Ui$NewDropdown$Item$viewCheckbox = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('new-dropdown-menu__item'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onFocus(options.afb),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('new-dropdown-menu__item--focusable'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('new-dropdown-menu__item--checkbox'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$tabindex(-1),
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										options.vw))))))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2($author$project$Ui$NewDropdown$Item$onMouse, 'mousedown', options.afb)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$author$project$Ui$NewDropdown$Item$onKeyDown(
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'Enter',
											options.zH(!options.hL)),
										options.UZ)),
									$elm$html$Html$Attributes$tabindex(-1),
									$elm$html$Html$Events$onCheck(options.zH),
									$elm$html$Html$Attributes$checked(options.hL)
								]),
							_List_Nil),
							content
						]))
				]));
	});
var $author$project$Ui$NewDropdown$Item$viewInnerDropdown = F4(
	function (dropdownId, open, options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('new-dropdown-menu__item'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('new-dropdown-menu__item--focusable'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('new-dropdown-menu__item--inner'),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$tabindex(-1),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('new-dropdown'),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('new-dropdown--open', open)
												])),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$id(dropdownId),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$NewDropdown$Item$onKeyDown(
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2('Enter', options.ae9),
														options.UZ)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$Attributes$map($elm$core$Basics$never),
													options.vw)))))))))),
			content);
	});
var $author$project$Ui$NewDropdown$Item$decodePressedKey = F2(
	function (expectedKey, toMsg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (key) {
				return _Utils_eq(key, expectedKey) ? $elm$json$Json$Decode$succeed(toMsg) : $elm$json$Json$Decode$fail('ignore');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	});
var $author$project$Ui$NewDropdown$Item$onEnter = F2(
	function (event, msg) {
		return A2(
			$elm$html$Html$Events$custom,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (msg_) {
					return {aeD: msg_, A9: true, Cs: true};
				},
				A2($author$project$Ui$NewDropdown$Item$decodePressedKey, 'Enter', msg)));
	});
var $author$project$Ui$NewDropdown$Item$viewInput = function (options) {
	return A2(
		$elm$html$Html$li,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('new-dropdown-menu__item new-dropdown-menu__item--focusable'),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('new-dropdown-menu__item--input'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onFocus(options.afb),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$tabindex(-1),
							A2(
								$elm$core$List$map,
								$elm$html$Html$Attributes$map($elm$core$Basics$never),
								options.vw)))))),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (icon_) {
						return icon_(
							_List_fromArray(
								[$author$project$Ui$SvgIcon$info]));
					},
					options.QG)),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$author$project$Ui$NewDropdown$Item$onKeyDown(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2('Enter', options.ae9),
							options.UZ)),
						$elm$html$Html$Events$onInput(options.afc),
						function () {
						var _v0 = options.ad1;
						if (!_v0.$) {
							var placeholder = _v0.a;
							return $elm$html$Html$Attributes$placeholder(placeholder);
						} else {
							return $elm$html$Html$Attributes$class('');
						}
					}(),
						$elm$html$Html$Attributes$autocomplete(false),
						$elm$html$Html$Attributes$tabindex(-1),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$Attributes$class(''),
						A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, options.aaN)),
						$elm$html$Html$Attributes$class('form-control'),
						options.afl ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$NewDropdown$Item$onEnter, 'keyup', options.afa)
					]),
				_List_Nil)
			]));
};
var $author$project$Ui$NewDropdown$Item$viewItem = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('new-dropdown-menu__item', true),
							_Utils_Tuple2('new-dropdown-menu__item--active', options.ag),
							_Utils_Tuple2('new-dropdown-menu__item--focusable', true)
						])),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Events$onClick(options.zI),
					A2(
						$elm$core$List$cons,
						options.afl ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$NewDropdown$Item$onMouse, 'mouseup', options.afh),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
							A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$attribute, 'designMode', 'true'),
								A2(
									$elm$core$List$cons,
									options.afl ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$NewDropdown$Item$onEnter, 'keyup', options.afa),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$NewDropdown$Item$onKeyDown(options.UZ),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Attributes$tabindex(-1),
											A2(
												$elm$core$List$map,
												$elm$html$Html$Attributes$map($elm$core$Basics$never),
												options.vw))))))))),
			_List_fromArray(
				[content]));
	});
var $author$project$Ui$NewDropdown$Item$viewLink = F3(
	function (href, options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('new-dropdown-menu__item', true),
							_Utils_Tuple2('new-dropdown-menu__item--active', options.ag),
							_Utils_Tuple2('new-dropdown-menu__item--focusable', true),
							_Utils_Tuple2('new-dropdown-menu__item--link', true)
						])),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onFocus(options.afb),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$tabindex(-1),
							A2(
								$elm$core$List$map,
								$elm$html$Html$Attributes$map($elm$core$Basics$never),
								options.vw))))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$href(href),
							$author$project$Ui$NewDropdown$Item$onKeyDown(options.UZ)
						]),
					_List_fromArray(
						[
							A2($elm$html$Html$map, $elm$core$Basics$never, content)
						]))
				]));
	});
var $author$project$Ui$NewDropdown$Item$viewRadio = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$li,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('new-dropdown-menu__item'),
				A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Events$onFocus(options.afb),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('new-dropdown-menu__item--focusable'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('new-dropdown-menu__item--radio'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$tabindex(-1),
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										options.vw))))))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2($author$project$Ui$NewDropdown$Item$onMouse, 'mousedown', options.afb)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('radio'),
									$author$project$Ui$NewDropdown$Item$onKeyDown(
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'Enter',
											options.zH(!options.hL)),
										options.UZ)),
									$elm$html$Html$Attributes$tabindex(-1),
									$elm$html$Html$Events$onCheck(options.zH),
									$elm$html$Html$Attributes$checked(options.hL)
								]),
							_List_Nil),
							content
						]))
				]));
	});
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$NewDropdown$Item$viewSeparator = function (options) {
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('new-dropdown-menu__item new-dropdown-menu__item--separator'),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Events$onMouseDown(options.zI),
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					options.vw))),
		_List_Nil);
};
var $author$project$Ui$NewDropdown$Item$view = F2(
	function (defaultOptions, item) {
		switch (item.$) {
			case 0:
				var options = item.a;
				var content = item.b;
				return A2(
					$author$project$Ui$NewDropdown$Item$viewItem,
					A2($author$project$Ui$NewDropdown$Item$optionsToRecord, defaultOptions, options),
					content);
			case 1:
				var options = item.a;
				return $author$project$Ui$NewDropdown$Item$viewInput(
					A2($author$project$Ui$NewDropdown$Item$optionsToRecord, defaultOptions, options));
			case 2:
				var options = item.a;
				return $author$project$Ui$NewDropdown$Item$viewSeparator(
					A2($author$project$Ui$NewDropdown$Item$optionsToRecord, defaultOptions, options));
			case 3:
				var options = item.a;
				var content = item.b;
				return A2(
					$author$project$Ui$NewDropdown$Item$viewCheckbox,
					A2($author$project$Ui$NewDropdown$Item$optionsToRecord, defaultOptions, options),
					content);
			case 4:
				var options = item.a;
				var content = item.b;
				return A2(
					$author$project$Ui$NewDropdown$Item$viewRadio,
					A2($author$project$Ui$NewDropdown$Item$optionsToRecord, defaultOptions, options),
					content);
			case 5:
				var id = item.a;
				var isOpen = item.b;
				var options = item.c;
				var content = item.d;
				return A4(
					$author$project$Ui$NewDropdown$Item$viewInnerDropdown,
					id,
					isOpen,
					A2($author$project$Ui$NewDropdown$Item$optionsToRecord, defaultOptions, options),
					content);
			default:
				var href = item.a;
				var options = item.b;
				var content = item.c;
				return A3(
					$author$project$Ui$NewDropdown$Item$viewLink,
					href,
					A2($author$project$Ui$NewDropdown$Item$optionsToRecord, defaultOptions, options),
					content);
		}
	});
var $author$project$Ui$NewDropdown$innerDropdownContent = F3(
	function (trigger, items, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('new-dropdown__trigger'),
						$elm$html$Html$Attributes$tabindex(0),
						$elm$html$Html$Attributes$id(model.adR + '-trigger'),
						$elm$html$Html$Events$onClick(
						model.ahx($author$project$Ui$NewDropdown$InnerDropdownButtonClicked))
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($elm$core$Basics$never),
					trigger)),
				A3($author$project$Ui$NewDropdown$viewMenu, model.ahx, model, items)
			]);
	});
var $author$project$Ui$NewDropdown$viewMenu = F3(
	function (toMsg, _v0, items) {
		var direction = _v0.xb;
		var hasNestedDropdowns = A2(
			$elm$core$List$any,
			function (item_) {
				if (item_.$ === 5) {
					return true;
				} else {
					return false;
				}
			},
			items);
		var directionClass = function () {
			switch (direction) {
				case 0:
					return '';
				case 1:
					return 'new-dropdown-menu--dir-rd';
				case 2:
					return 'new-dropdown-menu--dir-dl';
				case 3:
					return 'new-dropdown-menu--dir-tl';
				default:
					return 'new-dropdown-menu--dir-tr';
			}
		}();
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-dropdown-menu'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'listbox'),
					$elm$html$Html$Attributes$class(directionClass),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('new-dropdown-menu--overflow-scroll', !hasNestedDropdowns)
						]))
				]),
			A2(
				$elm$core$List$map,
				function (item_) {
					switch (item_.$) {
						case 0:
							var options = item_.a;
							return A2(
								$author$project$Ui$NewDropdown$Item$view,
								function (defaults) {
									return _Utils_update(
										defaults,
										{
											UZ: _List_fromArray(
												[
													_Utils_Tuple2(
													'ArrowDown',
													toMsg(
														$author$project$Ui$NewDropdown$ArrowNavigation(1))),
													_Utils_Tuple2(
													'ArrowUp',
													toMsg(
														$author$project$Ui$NewDropdown$ArrowNavigation(0)))
												])
										});
								}(
									$author$project$Ui$NewDropdown$defaultItemOptions(toMsg)),
								$author$project$Ui$NewDropdown$Item$Input(
									_Utils_ap(
										options,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$onFocus(
												toMsg($author$project$Ui$NewDropdown$FocusInput))
											]))));
						case 1:
							return A2(
								$author$project$Ui$NewDropdown$Item$view,
								$author$project$Ui$NewDropdown$defaultItemOptions(toMsg),
								$author$project$Ui$NewDropdown$Item$Separator(_List_Nil));
						case 2:
							var options = item_.a;
							var content = item_.b;
							return A2(
								$author$project$Ui$NewDropdown$Item$view,
								$author$project$Ui$NewDropdown$defaultItemOptions(toMsg),
								A2(
									$author$project$Ui$NewDropdown$Item$Checkbox,
									_Utils_ap(
										options,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$onFocus(
												toMsg($author$project$Ui$NewDropdown$FocusInput))
											])),
									content));
						case 3:
							var options = item_.a;
							var content = item_.b;
							return A2(
								$author$project$Ui$NewDropdown$Item$view,
								$author$project$Ui$NewDropdown$defaultItemOptions(toMsg),
								A2(
									$author$project$Ui$NewDropdown$Item$Radio,
									_Utils_ap(
										options,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$onFocus(
												toMsg($author$project$Ui$NewDropdown$FocusInput))
											])),
									content));
						case 4:
							var options = item_.a;
							var content = item_.b;
							return A2(
								$author$project$Ui$NewDropdown$Item$view,
								$author$project$Ui$NewDropdown$defaultItemOptions(toMsg),
								A2($author$project$Ui$NewDropdown$Item$Item, options, content));
						case 6:
							var href = item_.a;
							var options = item_.b;
							var content = item_.c;
							return A2(
								$author$project$Ui$NewDropdown$Item$view,
								$author$project$Ui$NewDropdown$defaultItemOptions(toMsg),
								A3(
									$author$project$Ui$NewDropdown$Item$Link,
									href,
									_Utils_ap(
										options,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$onFocus(
												toMsg($author$project$Ui$NewDropdown$FocusLink))
											])),
									content));
						default:
							var content = item_.a;
							var items_ = item_.b;
							var innerModel = item_.c;
							return A2(
								$author$project$Ui$NewDropdown$Item$view,
								$author$project$Ui$NewDropdown$defaultItemOptions(toMsg),
								A4(
									$author$project$Ui$NewDropdown$Item$InnerDropdown,
									innerModel.adR,
									innerModel.U9,
									A2(
										$elm$core$List$cons,
										$author$project$Ui$NewDropdown$onEnter(
											innerModel.ahx($author$project$Ui$NewDropdown$DropdownButtonClicked)),
										function () {
											var _v2 = innerModel.xb;
											if (_v2 === 1) {
												return _List_fromArray(
													[
														$author$project$Ui$NewDropdown$Item$OnArrowRight(
														innerModel.ahx($author$project$Ui$NewDropdown$InnerDropdownButtonClicked))
													]);
											} else {
												return _List_Nil;
											}
										}()),
									A3($author$project$Ui$NewDropdown$innerDropdownContent, content, items_, innerModel)));
					}
				},
				items));
	});
var $author$project$Ui$NewDropdown$viewSelect = F4(
	function (options, content, items, model) {
		var toMsg = model.ahx;
		var optionsRecord = $author$project$Ui$NewDropdown$optionsToRecord(options);
		var errorDescription = $elm$core$List$isEmpty(optionsRecord.fE) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-describedby',
				A2($elm$core$String$join, '. ', optionsRecord.fE))
			]);
		var ariaInvalid = (optionsRecord.q$ || (!$elm$core$List$isEmpty(optionsRecord.fE))) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-dropdown'),
					$elm$html$Html$Attributes$id(model.adR),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('new-dropdown--open', model.U9 && ((!optionsRecord.dW) && (!optionsRecord.sk))),
							_Utils_Tuple2(
							'new-dropdown--invalid',
							optionsRecord.q$ || (!$elm$core$List$isEmpty(optionsRecord.fE))),
							_Utils_Tuple2('new-dropdown--disabled', optionsRecord.dW),
							_Utils_Tuple2('new-dropdown--readonly', optionsRecord.sk)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('new-dropdown__trigger new-dropdown__trigger--select'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$id(model.adR + '-trigger'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('combobox'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$tabindex(0),
									A2(
										$elm$core$List$cons,
										A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
										A2(
											$elm$core$List$cons,
											A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox'),
											A2(
												$elm$core$List$cons,
												A2(
													$elm$html$Html$Attributes$attribute,
													'aria-expanded',
													model.U9 ? 'true' : 'false'),
												A2(
													$elm$core$List$cons,
													$elm$core$String$isEmpty(optionsRecord.abp) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.abp),
													A2(
														$elm$core$List$cons,
														A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'options-list'),
														_Utils_ap(
															optionsRecord.dW ? _List_fromArray(
																[
																	A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')
																]) : (optionsRecord.sk ? _List_fromArray(
																[
																	$elm$html$Html$Attributes$readonly(true)
																]) : _List_fromArray(
																[
																	$author$project$Ui$NewDropdown$triggerKeyHandlers(toMsg),
																	$elm$html$Html$Events$onClick(
																	toMsg($author$project$Ui$NewDropdown$DropdownButtonClicked))
																])),
															_Utils_ap(errorDescription, ariaInvalid))))))))))),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('flex justify-between items-center')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('truncate')
										]),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($elm$core$Basics$never),
										content)),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-dropdown__trigger__chevron')
										]),
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$chevronDown(
											_List_fromArray(
												[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$info]))
										]))
								]))
						])),
					(optionsRecord.dW || optionsRecord.sk) ? $elm$html$Html$text('') : A3($author$project$Ui$NewDropdown$viewMenu, toMsg, model, items),
					$author$project$Utils$FormErrors$view(optionsRecord.fE)
				]));
	});
var $author$project$Ui$Form$Input$WithFeedback = function (a) {
	return {$: 18, a: a};
};
var $author$project$Ui$Form$Input$withFeedback = $author$project$Ui$Form$Input$WithFeedback;
var $author$project$Components$PhoneInput$viewNumberInput = F5(
	function (regions, form, regionDropdown, index, phone) {
		var phoneNumber = phone.Gj;
		return $author$project$Ui$Form$Input$group(
			_List_fromArray(
				[
					A4(
					$author$project$Ui$NewDropdown$viewSelect,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$ariaLabel('Phone region')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$PhoneInput$regionToString(phone.agc))
						]),
					A2(
						$elm$core$List$map,
						function (region) {
							return A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$PhoneInput$FormFieldUpdated(
											A2($author$project$Components$PhoneInput$PhoneRegion, index, region))),
										$author$project$Ui$NewDropdown$selected(
										_Utils_eq(region, phone.agc))
									]),
								$elm$html$Html$text(
									$author$project$Components$PhoneInput$regionToString(region)));
						},
						regions),
					regionDropdown),
					function () {
					var _v0 = phone.agc;
					if (!_v0) {
						return $author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$PhoneInput$phonePattern, phoneNumber),
									$author$project$Ui$Form$Input$placeholder($author$project$Components$PhoneInput$phonePlaceholder),
									$author$project$Ui$Form$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$PhoneInput$FormFieldUpdated,
												$author$project$Components$PhoneInput$PhoneNumber(index)),
											$elm$core$String$filter($elm$core$Char$isDigit)),
										$elm$core$String$left(14))),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, index, form)),
									$author$project$Ui$Form$Input$autoComplete(false),
									$author$project$Ui$Form$Input$autoCorrect(false),
									$author$project$Ui$Form$Input$autoCapitalize(false),
									$author$project$Ui$Form$Input$spellCheck(false),
									$author$project$Ui$Form$Input$tel,
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$withFeedback(
									$author$project$Utils$Form$validated(form))
								]));
					} else {
						return $author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(phoneNumber),
									$author$project$Ui$Form$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PhoneInput$FormFieldUpdated,
										$author$project$Components$PhoneInput$PhoneNumber(index))),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, index, form)),
									$author$project$Ui$Form$Input$autoComplete(false),
									$author$project$Ui$Form$Input$autoCorrect(false),
									$author$project$Ui$Form$Input$autoCapitalize(false),
									$author$project$Ui$Form$Input$spellCheck(false),
									$author$project$Ui$Form$Input$tel,
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$withFeedback(
									$author$project$Utils$Form$validated(form))
								]));
					}
				}()
				]));
	});
var $author$project$Components$PhoneInput$viewPhone = function (max) {
	return function (isRequired) {
		return function (allowRemove) {
			return function (phoneTypes) {
				return function (regions) {
					return function (disablePhoneType) {
						return function (hidePhoneType) {
							return function (form) {
								return function (index) {
									return function (_v0) {
										var phone = _v0.a;
										var typeDropdown = _v0.b;
										var regionDropdown = _v0.c;
										var phoneInputGridAttrs = hidePhoneType ? ((((max > 1) || (!isRequired)) && allowRemove) ? _List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(11),
												$author$project$Ui$FlexGrid$span(10)
											]) : _List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(11),
												$author$project$Ui$FlexGrid$span(12)
											])) : ((((max === 1) && isRequired) || (!allowRemove)) ? _List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(8),
												$author$project$Ui$FlexGrid$span(12)
											]) : _List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(7),
												$author$project$Ui$FlexGrid$span(10)
											]));
										return A2(
											$author$project$Ui$FlexGrid$row,
											_List_fromArray(
												[$author$project$Ui$FlexGrid$rowItemsCenter]),
											$elm$core$List$concat(
												_List_fromArray(
													[
														(!hidePhoneType) ? _List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanSm(4),
																	$author$project$Ui$FlexGrid$span(12)
																]),
															_List_fromArray(
																[
																	A4(
																	$author$project$Ui$NewDropdown$viewSelect,
																	_List_fromArray(
																		[
																			$author$project$Ui$NewDropdown$disabled(disablePhoneType),
																			$author$project$Ui$NewDropdown$ariaLabel('Phone type')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Formatters$PhoneType$toString(phone.ahI))
																		]),
																	A2(
																		$elm$core$List$map,
																		function (phoneType) {
																			return A2(
																				$author$project$Ui$NewDropdown$item,
																				_List_fromArray(
																					[
																						$author$project$Ui$NewDropdown$onSelect(
																						$author$project$Components$PhoneInput$FormFieldUpdated(
																							A2(
																								$author$project$Components$PhoneInput$PhoneType,
																								index,
																								$author$project$Formatters$PhoneType$toString(phoneType)))),
																						$author$project$Ui$NewDropdown$selected(
																						_Utils_eq(phoneType, phone.ahI))
																					]),
																				$elm$html$Html$text(
																					$author$project$Formatters$PhoneType$toString(phoneType)));
																		},
																		phoneTypes),
																	typeDropdown)
																])),
															A2(
															$author$project$Ui$FlexGrid$column,
															phoneInputGridAttrs,
															_List_fromArray(
																[
																	A5($author$project$Components$PhoneInput$viewNumberInput, regions, form, regionDropdown, index, phone)
																]))
														]) : _List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															phoneInputGridAttrs,
															_List_fromArray(
																[
																	A5($author$project$Components$PhoneInput$viewNumberInput, regions, form, regionDropdown, index, phone)
																]))
														]),
														(((max > 1) || (!isRequired)) && allowRemove) ? _List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanSm(1),
																	$author$project$Ui$FlexGrid$span(2),
																	$author$project$Ui$FlexGrid$justifyCenter
																]),
															((!index) && isRequired) ? _List_Nil : _List_fromArray(
																[
																	A3(
																	$author$project$Ui$Button$view,
																	{abp: 'Remove phone'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$link,
																			$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
																			$author$project$Ui$Button$onClick(
																			$author$project$Components$PhoneInput$PhoneRemoved(index))
																		]),
																	_List_Nil)
																]))
														]) : _List_Nil
													])));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$PhoneInput$view = function (_v0) {
	var model = _v0;
	var phones = $author$project$Utils$Form$fields(model.PB);
	var phoneTypes = A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		$author$project$Formatters$PhoneType$toString,
		$elm$core$List$concat(
			_List_fromArray(
				[
					model.ahJ,
					A2(
					$elm$core$List$map,
					function (_v1) {
						var phone = _v1.a;
						return phone.ahI;
					},
					phones)
				])));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$indexedMap,
					A8($author$project$Components$PhoneInput$viewPhone, model.yQ, model.agk, model.abk, phoneTypes, model.nT, model.acN, model.mo, model.PB),
					phones),
					A2($author$project$Components$PhoneInput$viewAddMore, phones, model.yQ) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var label = A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[
											'Add',
											(!$elm$core$List$isEmpty(phones)) ? 'Another' : '',
											' Phone'
										]));
								return A3(
									$author$project$Ui$Button$view,
									{abp: label},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick($author$project$Components$PhoneInput$PhoneAdded)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							}()
							]))
					]) : _List_Nil
				])));
};
var $author$project$Components$Layer$EditForm$viewPhoneNumberInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var phone = _v0.Wg;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Phone Number')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Layer$EditForm$PhoneInputMsg,
				$author$project$Components$PhoneInput$view(phone))
			]));
};
var $author$project$Components$Layer$EditForm$SmsEnabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Layer$EditForm$viewSmsEnabledInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var smsEnabled = _v0._e;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(smsEnabled),
						$author$project$Ui$Form$Checkbox$onCheck(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$SmsEnabled))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('I agree to receive SMS messages at the phone number provided above')
					]))
			]));
};
var $author$project$Components$Layer$EditForm$State = function (a) {
	return {$: 2, a: a};
};
var $author$project$Utils$State$list = _List_fromArray(
	[
		_Utils_Tuple2('AL', 'Alabama'),
		_Utils_Tuple2('AK', 'Alaska'),
		_Utils_Tuple2('AZ', 'Arizona'),
		_Utils_Tuple2('AR', 'Arkansas'),
		_Utils_Tuple2('CA', 'California'),
		_Utils_Tuple2('CO', 'Colorado'),
		_Utils_Tuple2('CT', 'Connecticut'),
		_Utils_Tuple2('DE', 'Delaware'),
		_Utils_Tuple2('DC', 'District of Columbia'),
		_Utils_Tuple2('FL', 'Florida'),
		_Utils_Tuple2('GA', 'Georgia'),
		_Utils_Tuple2('HI', 'Hawaii'),
		_Utils_Tuple2('ID', 'Idaho'),
		_Utils_Tuple2('IL', 'Illinois'),
		_Utils_Tuple2('IN', 'Indiana'),
		_Utils_Tuple2('IA', 'Iowa'),
		_Utils_Tuple2('KS', 'Kansas'),
		_Utils_Tuple2('KY', 'Kentucky'),
		_Utils_Tuple2('LA', 'Louisiana'),
		_Utils_Tuple2('ME', 'Maine'),
		_Utils_Tuple2('MD', 'Maryland'),
		_Utils_Tuple2('MA', 'Massachusetts'),
		_Utils_Tuple2('MI', 'Michigan'),
		_Utils_Tuple2('MN', 'Minnesota'),
		_Utils_Tuple2('MS', 'Mississippi'),
		_Utils_Tuple2('MO', 'Missouri'),
		_Utils_Tuple2('MT', 'Montana'),
		_Utils_Tuple2('NE', 'Nebraska'),
		_Utils_Tuple2('NV', 'Nevada'),
		_Utils_Tuple2('NH', 'New Hampshire'),
		_Utils_Tuple2('NJ', 'New Jersey'),
		_Utils_Tuple2('NM', 'New Mexico'),
		_Utils_Tuple2('NY', 'New York'),
		_Utils_Tuple2('NC', 'North Carolina'),
		_Utils_Tuple2('ND', 'North Dakota'),
		_Utils_Tuple2('OH', 'Ohio'),
		_Utils_Tuple2('OK', 'Oklahoma'),
		_Utils_Tuple2('OR', 'Oregon'),
		_Utils_Tuple2('PA', 'Pennsylvania'),
		_Utils_Tuple2('PR', 'Puerto Rico'),
		_Utils_Tuple2('RI', 'Rhode Island'),
		_Utils_Tuple2('SC', 'South Carolina'),
		_Utils_Tuple2('SD', 'South Dakota'),
		_Utils_Tuple2('TN', 'Tennessee'),
		_Utils_Tuple2('TX', 'Texas'),
		_Utils_Tuple2('UT', 'Utah'),
		_Utils_Tuple2('VT', 'Vermont'),
		_Utils_Tuple2('VI', 'Virgin Islands'),
		_Utils_Tuple2('VA', 'Virginia'),
		_Utils_Tuple2('WA', 'Washington'),
		_Utils_Tuple2('WV', 'West Virginia'),
		_Utils_Tuple2('WI', 'Wisconsin'),
		_Utils_Tuple2('WY', 'Wyoming')
	]);
var $author$project$Components$Layer$EditForm$stateOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var code = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(code),
			label);
	},
	A2(
		$elm$core$List$cons,
		_Utils_Tuple2('', 'Select a state'),
		$author$project$Utils$State$list));
var $author$project$Components$Layer$EditForm$viewStateInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var state = _v0.sZ;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('State'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(state),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$State)),
						$author$project$Ui$Form$Select$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
						$author$project$Ui$Form$Select$errors(
						A2($author$project$Utils$Form$validationErrors, 2, form))
					]),
				$author$project$Components$Layer$EditForm$stateOptions)
			]));
};
var $author$project$Components$Layer$EditForm$Tin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Layer$EditForm$TinValidation = 1;
var $author$project$Components$Layer$EditForm$viewTinInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var tin = _v0.$F;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('TIN')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', tin)),
						$author$project$Ui$Form$Input$placeholder('123456789'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$Tin)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]))
			]));
};
var $author$project$Components$Layer$EditForm$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$Layer$EditForm$UpdateLayerAccount),
				$author$project$Ui$Form$horizontal
			]),
		_List_fromArray(
			[
				$author$project$Components$Layer$EditForm$viewLegalNameInput(model.PB),
				$author$project$Components$Layer$EditForm$viewTinInput(model.PB),
				$author$project$Components$Layer$EditForm$viewStateInput(model.PB),
				$author$project$Components$Layer$EditForm$viewCountryInput,
				$author$project$Components$Layer$EditForm$viewEntityTypeInput(model.PB),
				model.J5 ? $author$project$Components$Layer$EditForm$viewPhoneNumberInput(model.PB) : $elm$html$Html$text(''),
				model.J5 ? $author$project$Components$Layer$EditForm$viewSmsEnabledInput(model.PB) : $elm$html$Html$text(''),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Save account'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Pages$Accounting$toPane = F4(
	function (layerAccount, accessToken, editForm, section) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (section === 4) {
								return A2(
									$elm$core$Maybe$withDefault,
									A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											])),
									A2(
										$elm$core$Maybe$map,
										$elm$html$Html$map($author$project$Pages$Accounting$EditFormMsg),
										A2($elm$core$Maybe$map, $author$project$Components$Layer$EditForm$view, editForm)));
							} else {
								var loadingHtml = A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]));
								var _v1 = _Utils_Tuple2(
									$author$project$Api$Data$toMaybe(layerAccount),
									$author$project$Api$Data$toMaybe(accessToken));
								if ((!_v1.a.$) && (!_v1.b.$)) {
									var layerAccount_ = _v1.a.a;
									var accessToken_ = _v1.b.a;
									return A2(
										$elm$core$Maybe$withDefault,
										loadingHtml,
										A3($author$project$Pages$Accounting$sectionToComponent, layerAccount_, accessToken_, section));
								} else {
									return loadingHtml;
								}
							}
						}()
						]))
				]));
	});
var $author$project$Ui$Nav$navOptionsToOptionsRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				return _Utils_update(
					record,
					{Co: true});
			}),
		{Co: false},
		options);
};
var $author$project$Ui$Nav$defaultOptions = {Ic: false, adR: $elm$core$Maybe$Nothing, rg: _List_Nil, zI: $elm$core$Maybe$Nothing, d: $elm$core$Maybe$Nothing};
var $author$project$Ui$Nav$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 1:
						var linkOptions_ = option.a;
						return _Utils_update(
							record,
							{
								rg: _Utils_ap(record.rg, linkOptions_)
							});
					case 0:
						var bool = option.a;
						return _Utils_update(
							record,
							{Ic: bool});
					case 2:
						var route_ = option.a;
						return _Utils_update(
							record,
							{
								d: $elm$core$Maybe$Just(route_)
							});
					case 3:
						var string = option.a;
						return _Utils_update(
							record,
							{
								adR: $elm$core$Maybe$Just(string)
							});
					default:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								zI: $elm$core$Maybe$Just(handler)
							});
				}
			}),
		$author$project$Ui$Nav$defaultOptions,
		options);
};
var $author$project$Ui$Link$Route = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Link$route = F3(
	function (route_, options, content) {
		return A2(
			$author$project$Ui$Link$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$Route(route_),
				options),
			content);
	});
var $author$project$Ui$Nav$ItemClicked = {$: 0};
var $elm$html$Html$Events$onMouseUp = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseup',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Nav$viewNonEmptyItem = F3(
	function (toMsg, options, contents) {
		var optionsRecord = $author$project$Ui$Nav$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-tabs__item'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'presentation'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('nav-tabs__item--active', optionsRecord.Ic)
						])),
					function () {
					var _v0 = _Utils_Tuple2(optionsRecord.zI, optionsRecord.Ic);
					if ((!_v0.a.$) && (!_v0.b)) {
						var handler = _v0.a.a;
						return $elm$html$Html$Events$onClick(handler);
					} else {
						return $author$project$Utils$Html$Attributes$none;
					}
				}(),
					optionsRecord.Ic ? $author$project$Utils$Html$Attributes$none : A2(
					$elm$html$Html$Attributes$map,
					toMsg,
					$elm$html$Html$Events$onMouseUp($author$project$Ui$Nav$ItemClicked)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$Attributes$class(''),
					A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, optionsRecord.adR))
				]),
			_List_fromArray(
				[contents]));
	});
var $author$project$Ui$Nav$viewItem = F2(
	function (toMsg, item_) {
		switch (item_.$) {
			case 0:
				var options = item_.a;
				var html = item_.b;
				var optionsRecord = $author$project$Ui$Nav$optionsToRecord(options);
				return A3(
					$author$project$Ui$Nav$viewNonEmptyItem,
					toMsg,
					options,
					function () {
						var _v1 = optionsRecord.d;
						if (!_v1.$) {
							var route_ = _v1.a;
							return A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A3($author$project$Ui$Link$route, route_, optionsRecord.rg, html));
						} else {
							return A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A3(
									$author$project$Ui$Button$view,
									{abp: 'Nav Item'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									html));
						}
					}());
			case 1:
				var options = item_.a;
				var html = item_.b;
				return A3($author$project$Ui$Nav$viewNonEmptyItem, toMsg, options, html);
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Ui$Nav$view = F3(
	function (options, items, _v0) {
		var underlineWidth = _v0.HF;
		var underlineLeft = _v0.HE;
		var id = _v0.adR;
		var toMsg = _v0.ahx;
		var transform = 'translateX(' + ($elm$core$String$fromFloat(underlineLeft) + ('px) ' + ('scaleX(' + ($elm$core$String$fromFloat(underlineWidth) + ')'))));
		var optionsRecord = $author$project$Ui$Nav$navOptionsToOptionsRecord(options);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('nav-tabs'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('nav-tabs--slim', optionsRecord.Co)
						])),
					$elm$html$Html$Attributes$id(id)
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'transform', transform),
							$elm$html$Html$Attributes$class('nav-tabs__underline')
						]),
					_List_Nil),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Nav$viewItem(toMsg),
					items)));
	});
var $author$project$Pages$Accounting$viewSections = F2(
	function (layerAccount, model) {
		var sectionNavItems = A2(
			$elm$core$List$map,
			$author$project$Pages$Accounting$sectionToNavItem(model.cn),
			$author$project$Pages$Accounting$sections(
				$author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Accounting')
									]))
							])),
						A3($author$project$Ui$Nav$view, _List_Nil, sectionNavItems, model.m8)
					])),
				A4($author$project$Pages$Accounting$toPane, model.yw, model.pi, model.lW, model.cn)
			]);
	});
var $author$project$Pages$Accounting$view = function (model) {
	var accountingEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 15, model.WF) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 16, model.WF);
	return {
		e5: function () {
			var _v0 = _Utils_Tuple2(accountingEnabled, model.ag7);
			if (_v0.a) {
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.b;
						return $author$project$Pages$Accounting$viewLoadingBody;
					case 1:
						var layerAccount = _v0.b.a;
						return ($author$project$Api$Provider$LayerAccount$One$status(layerAccount) === 'onboarding') ? $author$project$Pages$Accounting$viewOnboardingAccountBody : A2($author$project$Pages$Accounting$viewSections, layerAccount, model);
					default:
						var _v2 = _v0.b;
						return $author$project$Pages$Accounting$viewCreateAccountBody(model);
				}
			} else {
				return _List_Nil;
			}
		}(),
		$G: 'Accounting'
	};
};
var $author$project$Pages$Accounting$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Accounting$init, aer: $author$project$Pages$Accounting$load, agD: $author$project$Pages$Accounting$save, ahd: $author$project$Pages$Accounting$subscriptions, aaq: $author$project$Pages$Accounting$update, ahP: $author$project$Pages$Accounting$view});
var $author$project$Pages$Admin$AdvanceBilling$GotNotificationSetting = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Utils$User$isViewingAsHinter = F2(
	function (session, hinterViewOff) {
		return A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session) && (!hinterViewOff);
	});
var $author$project$Shared$isHintAdmin = function (model) {
	var _v0 = model.ZD;
	if (_v0.$ === 3) {
		var session = _v0.a;
		return A2($author$project$Utils$User$isViewingAsHinter, session, model.adN);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$NotificationSetting$One$NotificationSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Shared$NotificationSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Shared$Record = function (id) {
	return function (shortDescriptionHtml) {
		return function (description) {
			return function (disableable) {
				return function (enabled) {
					return function (customEnabled) {
						return function (subject) {
							return function (body) {
								return function (subjectExample) {
									return function (bodyExample) {
										return function (availableLiquidVariables) {
											return function (meta) {
												return function (isTranslatable) {
													return {JK: availableLiquidVariables, e5: body, J3: bodyExample, MB: customEnabled, Nx: description, NH: disableable, Ot: enabled, adR: id, Sc: isTranslatable, TU: meta, ZM: shortDescriptionHtml, Hp: subject, _0: subjectExample};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$HtmlTemplate$HtmlTemplate = $elm$core$Basics$identity;
var $author$project$Api$HtmlTemplate$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Api$Provider$NotificationSetting$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Meta$MetaRecord = function (body) {
	return {e5: body};
};
var $author$project$Api$Provider$NotificationSetting$Meta$EditableRecord = function (editable) {
	return {Oa: editable};
};
var $author$project$Api$Provider$NotificationSetting$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Meta$EditableRecord));
var $author$project$Api$Provider$NotificationSetting$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'body',
	$author$project$Api$Provider$NotificationSetting$Meta$editableRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Meta$MetaRecord));
var $author$project$Api$Provider$NotificationSetting$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSetting$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$NotificationSetting$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_translatable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'meta',
		$author$project$Api$Provider$NotificationSetting$Meta$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'available_liquid_variables',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'body_example',
				$author$project$Api$HtmlTemplate$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subject_example',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'body',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'subject',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'custom_enabled',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'enabled',
									$elm$json$Json$Decode$bool,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'disableable',
										$elm$json$Json$Decode$bool,
										false,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'description',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'short_description_html',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Shared$Record))))))))))))));
var $author$project$Api$Provider$NotificationSetting$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSetting$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$NotificationSetting$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSetting$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$NotificationSetting$notificationSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['notification_settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$NotificationSetting$notificationSettingPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$NotificationSetting$notificationSettingsPath);
};
var $author$project$Api$Param$boolToString = function (bool_) {
	return A2(
		$elm$json$Json$Encode$encode,
		0,
		$elm$json$Json$Encode$bool(bool_));
};
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {acq: d, aeI: m, ahX: y};
			}
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		Gt: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		ahX: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.ahX, 0, date.Gt);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.acq;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.aeI;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.Gt;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		aa$: 1 + (((rd - week1Day1) / 7) | 0),
		aa0: wy,
		ahS: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.aa$;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.aa0;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.zd(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.Ud(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.zd(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.EX(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.kL(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.kL(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.kL(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.HR(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.kL(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.kL(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.f, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	EX: $justinmimbs$date$Date$withOrdinalSuffix,
	Ud: $justinmimbs$date$Date$monthToName,
	zd: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	HR: $justinmimbs$date$Date$weekdayToName,
	kL: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $author$project$Utils$Date$toQuery = function (date) {
	return A2($justinmimbs$date$Date$format, 'yyyy-MM-dd', date);
};
var $author$project$Api$Param$toQuery = function (param) {
	switch (param.$) {
		case 0:
			var key = param.a;
			var string_ = param.b;
			return _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, key, string_)
				]);
		case 1:
			var key = param.a;
			var bool_ = param.b;
			return _List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					key,
					$author$project$Api$Param$boolToString(bool_))
				]);
		case 2:
			var key = param.a;
			var date_ = param.b;
			return _List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					key,
					$author$project$Utils$Date$toQuery(date_))
				]);
		default:
			var key = param.a;
			var list_ = param.b;
			return ($elm$core$List$length(list_) > 1) ? A2(
				$elm$core$List$map,
				function (string_) {
					return A2($elm$url$Url$Builder$string, key + '[]', string_);
				},
				list_) : A2(
				$elm$core$List$map,
				function (string_) {
					return A2($elm$url$Url$Builder$string, key, string_);
				},
				list_);
	}
};
var $author$project$Api$Data$requestWithQuery = F2(
	function (params, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				Bi: _Utils_ap(
					request.Bi,
					A2($elm$core$List$concatMap, $author$project$Api$Param$toQuery, params))
			});
	});
var $author$project$Api$Param$String = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Param$string = $author$project$Api$Param$String;
var $author$project$Language$toValue = function (lang) {
	if (!lang) {
		return 'en';
	} else {
		return 'es';
	}
};
var $author$project$Api$Provider$NotificationSetting$retrieve = F4(
	function (apiClient, id_, maybeLanguage, toMsg) {
		var query = function () {
			if (!maybeLanguage.$) {
				var language = maybeLanguage.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Api$Param$string,
						'language',
						$author$project$Language$toValue(language))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				query,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
	});
var $author$project$Pages$Admin$AdvanceBilling$init = F4(
	function (_v0, practice, shared, _v1) {
		var notificationSettingIds = _List_fromArray(
			['patient_upcoming_monthly_autopay_invoice_generated', 'patient_upcoming_non_monthly_autopay_invoice_generated', 'patient_upcoming_monthly_non_autopay_invoice_generated', 'patient_upcoming_non_monthly_non_autopay_invoice_generated']);
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				w: $elm$core$Maybe$Nothing,
				FR: $author$project$Shared$isHintAdmin(shared),
				a9: $elm$core$Dict$empty,
				WF: practice
			},
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					function (id) {
						return A4(
							$author$project$Api$Provider$NotificationSetting$retrieve,
							shared.D5,
							id,
							$elm$core$Maybe$Nothing,
							$author$project$Pages$Admin$AdvanceBilling$GotNotificationSetting(id));
					},
					notificationSettingIds)));
	});
var $author$project$Pages$Admin$AdvanceBilling$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$AdvanceBilling$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$AdvanceBilling$CancelEdit = {$: 1};
var $author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Ui$Modal$decodePressedKey = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return (key === 'Escape') ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {Wl: pids, _2: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {ac5: event, yq: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.Wl,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.yq;
		var event = _v0.ac5;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state._2);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Ui$Modal$subscribeToEscapeKeyPress = function (closeMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		$author$project$Ui$Modal$decodePressedKey(closeMsg));
};
var $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
var $author$project$Components$Admin$NotificationSetting$Customize$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$NotificationSetting$Customize$Close = {$: 1};
var $author$project$Components$Admin$NotificationSetting$Customize$Ignore = {$: 14};
var $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$NotificationSetting$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId = function (notificationSetting) {
	return 'notification-editor' + $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting);
};
var $author$project$Ports$CKEditor$ckEditorOnChangePort = _Platform_incomingPort(
	'ckEditorOnChangePort',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$CKEditor$onChange = function (toMsg) {
	return $author$project$Ports$CKEditor$ckEditorOnChangePort(
		function (_v0) {
			var elementId = _v0.a;
			var value = _v0.b;
			return A2(toMsg, elementId, value);
		});
};
var $author$project$Ui$NewDropdown$BlurredOut = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$NewDropdown$EscapeKeyPressed = {$: 4};
var $author$project$Ports$Dropdown$onDropdownBlur = _Platform_incomingPort('onDropdownBlur', $elm$json$Json$Decode$string);
var $author$project$Ports$Dropdown$onBlur = $author$project$Ports$Dropdown$onDropdownBlur;
var $author$project$Ports$Dropdown$onDropdownEscapeKeyPressed = _Platform_incomingPort('onDropdownEscapeKeyPressed', $elm$json$Json$Decode$string);
var $author$project$Ports$Dropdown$onEscapeKeyPressed = function (msg) {
	return $author$project$Ports$Dropdown$onDropdownEscapeKeyPressed(
		$elm$core$Basics$always(msg));
};
var $author$project$Ui$NewDropdown$subscriptions = function (model) {
	return model.U9 ? $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				model.ahx,
				$author$project$Ports$Dropdown$onEscapeKeyPressed($author$project$Ui$NewDropdown$EscapeKeyPressed)),
				A2(
				$elm$core$Platform$Sub$map,
				model.ahx,
				$author$project$Ports$Dropdown$onBlur($author$project$Ui$NewDropdown$BlurredOut))
			])) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$NotificationSetting$Customize$subscriptions = function (model) {
	if (model.U9) {
		var notificationBodyEditorId_ = $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.UN);
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ports$CKEditor$onChange(
					F2(
						function (elementId, value) {
							return _Utils_eq(elementId, notificationBodyEditorId_) ? A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$Customize$Body)(value) : $author$project$Components$Admin$NotificationSetting$Customize$Ignore;
						})),
					function () {
					var _v0 = A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.U9;
						},
						model.fy);
					if ((!_v0.$) && _v0.a) {
						return $elm$core$Platform$Sub$none;
					} else {
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$Customize$Close);
					}
				}(),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Ui$NewDropdown$subscriptions, model.fy))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Pages$Admin$AdvanceBilling$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var setting = _v0.a;
						var customize = _v0.b;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(setting),
							$author$project$Components$Admin$NotificationSetting$Customize$subscriptions(customize));
					},
					$elm$core$Dict$values(model.a9))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$AdvanceBilling$CancelEdit)),
					model.w))
			]));
};
var $author$project$Api$Provider$Notification$PracticeContext = {$: 0};
var $author$project$OutMsg$PracticeUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.abz;
	});
var $author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.abA;
	});
var $author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.abB;
	});
var $author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.abC;
	});
var $author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agE;
	});
var $author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agF;
	});
var $author$project$Pages$Admin$AdvanceBilling$formFieldsInit = F3(
	function (type_, frequency, practice) {
		return {
			abz: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays(practice)),
			abA: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays(practice)),
			abB: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays(practice)),
			abC: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays(practice)),
			qH: frequency,
			agE: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays(practice)),
			agF: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays(practice)),
			ahI: type_
		};
	});
var $author$project$Pages$Admin$AdvanceBilling$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						abz: $elm$core$String$toInt(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						abB: $elm$core$String$toInt(string)
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						abA: $elm$core$String$toInt(string)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						abC: $elm$core$String$toInt(string)
					});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						agE: $elm$core$String$toInt(string)
					});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						agF: $elm$core$String$toInt(string)
					});
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDaysValidation = 0;
var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDaysValidation = 1;
var $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDaysValidation = 2;
var $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDaysValidation = 3;
var $author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays = F2(
	function (days, vaildationGroup) {
		if (!days.$) {
			var _int = days.a;
			return (_int < 0) ? _List_fromArray(
				[
					_Utils_Tuple2(vaildationGroup, 'Please enter a number greater or equal to 0')
				]) : ((_int > 90) ? _List_fromArray(
				[
					_Utils_Tuple2(vaildationGroup, 'Please enter a number lower or equal to 90')
				]) : _List_Nil);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(vaildationGroup, 'Please enter a number')
				]);
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance = F3(
	function (createDays, scheduleDays, validationGroup) {
		var _v0 = _Utils_Tuple2(createDays, scheduleDays);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var createDays_ = _v0.a.a;
			var scheduleDays_ = _v0.b.a;
			return (_Utils_cmp(createDays_, scheduleDays_) < 1) ? _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'The number of days in create & notify needs to be greater than schedule payment in advance.')
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$validateAutopay = function (fields) {
	var _v0 = fields.qH;
	if (!_v0) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.abz, 0),
					A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.agE, 2),
					A3($author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance, fields.abz, fields.agE, 2)
				]));
	} else {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.abB, 1),
					A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.agF, 3),
					A3($author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance, fields.abB, fields.agF, 3)
				]));
	}
};
var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDaysValidation = 4;
var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDaysValidation = 5;
var $author$project$Pages$Admin$AdvanceBilling$validateNonAutopay = function (fields) {
	var _v0 = fields.qH;
	if (!_v0) {
		return A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.abA, 4);
	} else {
		return A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.abC, 5);
	}
};
var $author$project$Pages$Admin$AdvanceBilling$validateAdvanceBilling = function (fields) {
	var _v0 = fields.ahI;
	if (!_v0) {
		return $author$project$Pages$Admin$AdvanceBilling$validateAutopay(fields);
	} else {
		return $author$project$Pages$Admin$AdvanceBilling$validateNonAutopay(fields);
	}
};
var $author$project$Pages$Admin$AdvanceBilling$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$AdvanceBilling$validateAdvanceBilling)
		]));
var $author$project$Api$Provider$NotificationSetting$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$id(shared);
};
var $author$project$Components$Admin$NotificationSetting$Toggle$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$NotificationSetting$Toggle$init = F2(
	function (getters, notificationSetting) {
		return {
			Ot: getters.Ot(notificationSetting),
			xK: getters,
			UN: notificationSetting,
			so: $author$project$Api$Data$NotAsked
		};
	});
var $author$project$Language$EN = 0;
var $author$project$Language$english = 0;
var $author$project$Api$Provider$NotificationSetting$Shared$body = function (_v0) {
	var record = _v0;
	return record.e5;
};
var $author$project$Api$Provider$NotificationSetting$Shared$subject = function (_v0) {
	var record = _v0;
	return record.Hp;
};
var $author$project$Components$Admin$NotificationSetting$Customize$initFormFields = function (notificationSetting) {
	return {
		e5: $author$project$Api$Provider$NotificationSetting$Shared$body(notificationSetting),
		Hp: $author$project$Api$Provider$NotificationSetting$Shared$subject(notificationSetting)
	};
};
var $author$project$Components$Admin$NotificationSetting$Customize$init = F2(
	function (notificationSetting, context) {
		return {
			aB: context,
			fy: $elm$core$Maybe$Nothing,
			PB: $author$project$Utils$Form$init(
				$author$project$Components$Admin$NotificationSetting$Customize$initFormFields(notificationSetting)),
			yu: $author$project$Language$english,
			rr: false,
			UN: notificationSetting,
			U9: false,
			afU: $author$project$Api$Data$NotAsked,
			n7: false,
			op: false,
			ks: $author$project$Api$Data$NotAsked,
			aaa: $elm$core$Dict$empty,
			DF: false
		};
	});
var $author$project$Api$Provider$NotificationSetting$One$toShared = function (_v0) {
	var shared = _v0;
	return shared;
};
var $author$project$Components$Admin$NotificationSetting$Customize$initFromOne = function (notificationSettingOne) {
	return A2(
		$author$project$Components$Admin$NotificationSetting$Customize$init,
		$author$project$Api$Provider$NotificationSetting$One$toShared(notificationSettingOne),
		$author$project$Api$Provider$Notification$PracticeContext);
};
var $author$project$Api$Provider$NotificationSetting$Shared$disableable = function (_v0) {
	var record = _v0;
	return record.NH;
};
var $author$project$Api$Provider$NotificationSetting$One$disableable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$disableable(shared);
};
var $author$project$Api$Provider$NotificationSetting$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ot;
};
var $author$project$Api$Provider$NotificationSetting$One$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$enabled(shared);
};
var $author$project$Components$Admin$NotificationSetting$Toggle$oneGetters = {NH: $author$project$Api$Provider$NotificationSetting$One$disableable, Ot: $author$project$Api$Provider$NotificationSetting$One$enabled, adR: $author$project$Api$Provider$NotificationSetting$One$id};
var $author$project$Components$Admin$NotificationSetting$Customize$GotNotificationSetting = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$Customize$LanguageDropdownMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$NotificationSetting$Customize$None = 0;
var $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingUpdated = 1;
var $author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables = function (_v0) {
	var record = _v0;
	return record.JK;
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Ports$CKEditor$ckEditorSetDataPort = _Platform_outgoingPort(
	'ckEditorSetDataPort',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Ports$CKEditor$setData = F2(
	function (elementId, value) {
		return $author$project$Ports$CKEditor$ckEditorSetDataPort(
			_Utils_Tuple2(elementId, value));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$initForm = function (setting) {
	var body = $author$project$Api$Provider$NotificationSetting$Shared$body(setting);
	return _Utils_Tuple2(
		$author$project$Utils$Form$init(
			{
				e5: body,
				Hp: $author$project$Api$Provider$NotificationSetting$Shared$subject(setting)
			}),
		A2(
			$author$project$Ports$CKEditor$setData,
			$author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(setting),
			body));
};
var $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable = function (_v0) {
	var record = _v0;
	return record.Sc;
};
var $author$project$Api$Data$map = F2(
	function (func, dataList) {
		switch (dataList.$) {
			case 3:
				var value = dataList.a;
				var headers = dataList.b;
				return A2(
					$author$project$Api$Data$Success,
					func(value),
					headers);
			case 0:
				return $author$project$Api$Data$NotAsked;
			case 1:
				return $author$project$Api$Data$Loading;
			default:
				var error = dataList.a;
				return $author$project$Api$Data$Failure(error);
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{Hp: string});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{e5: string});
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$Admin$NotificationSetting$Customize$GotPreview = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$NotificationSettingPreview$NotificationSettingPreview = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSettingPreview$Record = F2(
	function (subject, body) {
		return {e5: body, Hp: subject};
	});
var $author$project$Api$Provider$NotificationSettingPreview$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'body',
	$author$project$Api$HtmlTemplate$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'subject',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSettingPreview$Record)));
var $author$project$Api$Provider$NotificationSettingPreview$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSettingPreview$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$companiesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['companies']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Company$companyPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[companyId]),
		$author$project$Api$Provider$Company$companiesPath);
};
var $author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['notification_settings']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath = F2(
	function (companyId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath(companyId));
	});
var $author$project$Api$Provider$Company$NotificationSetting$preview = F5(
	function (apiClient, companyId, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									function (subject) {
										return _Utils_Tuple2(
											'subject',
											$elm$json$Json$Encode$string(subject));
									},
									fields.Hp),
									A2(
									$elm$core$Maybe$map,
									function (body) {
										return _Utils_Tuple2(
											'body',
											$elm$json$Json$Encode$string(body));
									},
									fields.e5)
								])))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.yu)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$NotificationSettingPreview$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['preview']),
						A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
	});
var $author$project$Api$Provider$NotificationSetting$preview = F4(
	function (apiClient, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$map,
									function (subject) {
										return _Utils_Tuple2(
											'subject',
											$elm$json$Json$Encode$string(subject));
									},
									fields.Hp),
									A2(
									$elm$core$Maybe$map,
									function (body) {
										return _Utils_Tuple2(
											'body',
											$elm$json$Json$Encode$string(body));
									},
									fields.e5)
								])))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.yu)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$NotificationSettingPreview$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['preview']),
						$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$previewNotificationSetting = F3(
	function (apiClient, formFields, _v0) {
		var context = _v0.aB;
		var language = _v0.yu;
		var notificationSetting = _v0.UN;
		var _v1 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var subject = _v1.Hp;
		var body = _v1.e5;
		if (context.$ === 1) {
			var id = context.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$preview,
				apiClient,
				id,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{
					e5: $elm$core$Maybe$Just(body),
					yu: language,
					Hp: $elm$core$Maybe$Just(subject)
				},
				$author$project$Components$Admin$NotificationSetting$Customize$GotPreview);
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$preview,
				apiClient,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{
					e5: $elm$core$Maybe$Just(body),
					yu: language,
					Hp: $elm$core$Maybe$Just(subject)
				},
				$author$project$Components$Admin$NotificationSetting$Customize$GotPreview);
		}
	});
var $author$project$Ports$CKEditor$ckEditorReplacePort = _Platform_outgoingPort(
	'ckEditorReplacePort',
	function ($) {
		var a = $.a;
		var b = $.b;
		var c = $.c;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b),
					$elm$json$Json$Encode$list($elm$json$Json$Encode$string)(c)
				]));
	});
var $author$project$Ports$CKEditor$replace = F3(
	function (elementId, value, autocompleteOptions) {
		return $author$project$Ports$CKEditor$ckEditorReplacePort(
			_Utils_Tuple3(elementId, value, autocompleteOptions));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$GotReset = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Company$NotificationSetting$reset = F5(
	function (apiClient, companyId, id_, _v0, toMsg) {
		var language = _v0.yu;
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(language)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reset']),
						A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
	});
var $author$project$Api$Provider$NotificationSetting$reset = F4(
	function (apiClient, id_, _v0, toMsg) {
		var language = _v0.yu;
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(language)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reset']),
						$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$resetNotificationSetting = F2(
	function (apiClient, _v0) {
		var context = _v0.aB;
		var language = _v0.yu;
		var notificationSetting = _v0.UN;
		if (context.$ === 1) {
			var id = context.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$reset,
				apiClient,
				id,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{yu: language},
				$author$project$Components$Admin$NotificationSetting$Customize$GotReset);
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$reset,
				apiClient,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{yu: language},
				$author$project$Components$Admin$NotificationSetting$Customize$GotReset);
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$GotTest = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Data$EmptyBody = 0;
var $author$project$Api$Data$emptyBodyDecoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Company$NotificationSetting$test = F5(
	function (apiClient, companyId, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(fields.Hp)),
								_Utils_Tuple2(
								'body',
								$elm$json$Json$Encode$string(fields.e5))
							]))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.yu)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['test']),
						A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
	});
var $author$project$Api$Provider$NotificationSetting$test = F4(
	function (apiClient, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(fields.Hp)),
								_Utils_Tuple2(
								'body',
								$elm$json$Json$Encode$string(fields.e5))
							]))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.yu)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['test']),
						$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$testNotificationSetting = F3(
	function (apiClient, formFields, _v0) {
		var context = _v0.aB;
		var notificationSetting = _v0.UN;
		var language = _v0.yu;
		var _v1 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var subject = _v1.Hp;
		var body = _v1.e5;
		if (context.$ === 1) {
			var id = context.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$test,
				apiClient,
				id,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{e5: body, yu: language, Hp: subject},
				$author$project$Components$Admin$NotificationSetting$Customize$GotTest);
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$test,
				apiClient,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{e5: body, yu: language, Hp: subject},
				$author$project$Components$Admin$NotificationSetting$Customize$GotTest);
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$Company$NotificationSetting$update = F5(
	function (apiClient, companyId, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(fields.Hp)),
								_Utils_Tuple2(
								'body',
								$elm$json$Json$Encode$string(fields.e5))
							]))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.yu)))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_))));
	});
var $author$project$Api$Provider$NotificationSetting$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'subject',
								$elm$json$Json$Encode$string(fields.Hp)),
								_Utils_Tuple2(
								'body',
								$elm$json$Json$Encode$string(fields.e5))
							]))),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(fields.yu)))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$updateNotificationSetting = F2(
	function (apiClient, _v0) {
		var context = _v0.aB;
		var language = _v0.yu;
		var notificationSetting = _v0.UN;
		var form = _v0.PB;
		var _v1 = $author$project$Utils$Form$fields(form);
		var subject = _v1.Hp;
		var body = _v1.e5;
		if (context.$ === 1) {
			var id = context.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$update,
				apiClient,
				id,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{e5: body, yu: language, Hp: subject},
				$author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting);
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$update,
				apiClient,
				$author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting),
				{e5: body, yu: language, Hp: subject},
				$author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting);
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 14:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 15:
				var dropdownMsg = msg.a;
				var _v1 = model.fy;
				if (!_v1.$) {
					var dropdown = _v1.a;
					var _v2 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, dropdown);
					var newDropdown = _v2.a;
					var dropdownCmd = _v2.b;
					var newModel = _Utils_update(
						model,
						{
							fy: $elm$core$Maybe$Just(newDropdown)
						});
					return {EC: dropdownCmd, ac5: 0, y8: newModel, as: _List_Nil};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 0:
				var dropdown = (model.rr && $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable(model.UN)) ? $elm$core$Maybe$Just(
					$author$project$Ui$NewDropdown$init(
						$author$project$Ui$NewDropdown$defaultConfig(
							{adR: 'customize-language-dropdown', ahx: $author$project$Components$Admin$NotificationSetting$Customize$LanguageDropdownMsg}))) : $elm$core$Maybe$Nothing;
				var _v3 = $author$project$Components$Admin$NotificationSetting$Customize$initForm(model.UN);
				var form = _v3.a;
				return {
					EC: A3(
						$author$project$Ports$CKEditor$replace,
						$author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.UN),
						$author$project$Api$Provider$NotificationSetting$Shared$body(model.UN),
						$author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.UN)),
					ac5: 0,
					y8: _Utils_update(
						model,
						{fy: dropdown, PB: form, yu: $author$project$Language$english, U9: true}),
					as: _List_Nil
				};
			case 1:
				return function (closedModel) {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: closedModel, as: _List_Nil};
				}(
					_Utils_update(
						model,
						{U9: false, afU: $author$project$Api$Data$NotAsked}));
			case 2:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, model.PB);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return function (okFormModel) {
						return {
							EC: A3($author$project$Components$Admin$NotificationSetting$Customize$previewNotificationSetting, apiClient, validFormFields, okFormModel),
							ac5: 0,
							y8: okFormModel,
							as: _List_Nil
						};
					}(
						_Utils_update(
							model,
							{PB: newForm, afU: $author$project$Api$Data$Loading}));
				} else {
					var newForm = _v4.a;
					return function (failedFormModel) {
						return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: failedFormModel, as: _List_Nil};
					}(
						_Utils_update(
							model,
							{PB: newForm, afU: $author$project$Api$Data$NotAsked}));
				}
			case 3:
				var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, model.PB);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var newForm = _v7.a;
					var validFormFields = _v7.b;
					return function (okModel) {
						return {
							EC: A3($author$project$Components$Admin$NotificationSetting$Customize$testNotificationSetting, apiClient, validFormFields, okModel),
							ac5: 0,
							y8: okModel,
							as: _List_Nil
						};
					}(
						_Utils_update(
							model,
							{PB: newForm, ks: $author$project$Api$Data$Loading}));
				} else {
					var newForm = _v6.a;
					return function (errModel) {
						return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: errModel, as: _List_Nil};
					}(
						_Utils_update(
							model,
							{PB: newForm, ks: $author$project$Api$Data$NotAsked}));
				}
			case 4:
				return function (resettingModel) {
					return {
						EC: A2($author$project$Components$Admin$NotificationSetting$Customize$resetNotificationSetting, apiClient, resettingModel),
						ac5: 0,
						y8: resettingModel,
						as: _List_Nil
					};
				}(
					_Utils_update(
						model,
						{afU: $author$project$Api$Data$Loading}));
			case 5:
				return function (editingModel) {
					var _v8 = $author$project$Utils$Form$fields(model.PB);
					var body = _v8.e5;
					return {
						EC: A3(
							$author$project$Ports$CKEditor$replace,
							$author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.UN),
							body,
							$author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.UN)),
						ac5: 0,
						y8: editingModel,
						as: _List_Nil
					};
				}(
					_Utils_update(
						model,
						{afU: $author$project$Api$Data$NotAsked}));
			case 6:
				return {
					EC: A2($author$project$Components$Admin$NotificationSetting$Customize$updateNotificationSetting, apiClient, model),
					ac5: 0,
					y8: _Utils_update(
						model,
						{n7: true}),
					as: _List_Nil
				};
			case 7:
				var response = msg.a;
				return function (modelWPreview) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: modelWPreview,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}(
					_Utils_update(
						model,
						{afU: response}));
			case 10:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsUpdate, field, model.PB);
				var validatedForm = function () {
					var _v9 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, newForm);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var form = _v10.a;
						return form;
					} else {
						var form = _v9.a;
						return form;
					}
				}();
				var newModel = _Utils_update(
					model,
					{PB: validatedForm, n7: false});
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: newModel, as: _List_Nil};
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return function (okModel) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: okModel,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Notification successfully updated.')
								])
						};
					}(
						_Utils_update(
							model,
							{U9: false}));
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 12:
				var language = msg.a;
				var response = msg.b;
				var _v12 = function () {
					if (_Utils_eq(language, model.yu)) {
						if (response.$ === 3) {
							var setting = response.a;
							return $author$project$Components$Admin$NotificationSetting$Customize$initForm(
								$author$project$Api$Provider$NotificationSetting$One$toShared(setting));
						} else {
							return _Utils_Tuple2(model.PB, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model.PB, $elm$core$Platform$Cmd$none);
					}
				}();
				var form = _v12.a;
				var formCmd = _v12.b;
				return function (translations) {
					return {
						EC: formCmd,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: form, aaa: translations}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}(
					A3(
						$elm$core$Dict$insert,
						$author$project$Language$toValue(language),
						A2($author$project$Api$Data$map, $author$project$Api$Provider$NotificationSetting$One$toShared, response),
						model.aaa));
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var notificationSettingOne = response.a;
					var notificationSetting = $author$project$Api$Provider$NotificationSetting$One$toShared(notificationSettingOne);
					var _v15 = $author$project$Components$Admin$NotificationSetting$Customize$initForm(notificationSetting);
					var form = _v15.a;
					var formCmd = _v15.b;
					var newModel = _Utils_update(
						model,
						{PB: form, UN: notificationSetting});
					return {
						EC: formCmd,
						ac5: 1,
						y8: newModel,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Notification successfully reset.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var response = msg.a;
				return function (newModel) {
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: newModel,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'A sample of this email has been sent to you.')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: newModel,
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				}(
					_Utils_update(
						model,
						{ks: response}));
			case 13:
				return function (newModel) {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: newModel, as: _List_Nil};
				}(
					_Utils_update(
						model,
						{op: !model.op}));
			default:
				var language = msg.a;
				var _v17 = _Utils_eq(language, $author$project$Language$english) ? $author$project$Components$Admin$NotificationSetting$Customize$initForm(model.UN) : A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(
						model.PB,
						A4(
							$author$project$Api$Provider$NotificationSetting$retrieve,
							apiClient,
							$author$project$Api$Provider$NotificationSetting$Shared$id(model.UN),
							$elm$core$Maybe$Just(language),
							$author$project$Components$Admin$NotificationSetting$Customize$GotNotificationSetting(language))),
					A2(
						$elm$core$Maybe$map,
						function (translatedSetting) {
							return $author$project$Components$Admin$NotificationSetting$Customize$initForm(translatedSetting);
						},
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Data$toMaybe,
							A2(
								$elm$core$Dict$get,
								$author$project$Language$toValue(language),
								model.aaa))));
				var form = _v17.a;
				var formCmd = _v17.b;
				return {
					EC: formCmd,
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: form, yu: language}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Company$NotificationSetting$toggle = F5(
	function (apiClient, companyId, id_, enabled_, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(enabled_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_))));
	});
var $author$project$Api$Provider$NotificationSetting$toggle = F4(
	function (apiClient, id_, enabled_, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(enabled_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$NotificationSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
	});
var $author$project$Components$Admin$NotificationSetting$Toggle$update = F4(
	function (apiClient, context, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var bool = msg.a;
			var toggleCmd = function () {
				if (context.$ === 1) {
					var companyId = context.a;
					return A5(
						$author$project$Api$Provider$Company$NotificationSetting$toggle,
						apiClient,
						companyId,
						model.xK.adR(model.UN),
						bool,
						$author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled);
				} else {
					return A4(
						$author$project$Api$Provider$NotificationSetting$toggle,
						apiClient,
						model.xK.adR(model.UN),
						bool,
						$author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled);
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{so: $author$project$Api$Data$Loading}),
				toggleCmd,
				_List_Nil);
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var notificationSetting = response.a;
				var status = $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting) ? 'enabled' : 'disabled';
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Ot: $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting),
							so: $author$project$Api$Data$NotAsked
						}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'This notification has been ' + status)
						]));
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{so: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Practice$One$Practice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practice$Shared$Practice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$Shared$Record = function (id) {
	return function (name) {
		return function (email) {
			return function (usesSponsors) {
				return function (cancellationReasonOther) {
					return function (deactivated) {
						return function (deactivateOn) {
							return function (subdomain) {
								return function (hasClinicalAccount) {
									return function (hasStripeAccount) {
										return function (hasPaymentProcessorAccount) {
											return function (url) {
												return function (stripeClientId) {
													return function (stripePublishableKey) {
														return function (logoUrl) {
															return function (usesCardReaders) {
																return function (isNetwork) {
																	return function (isAffiliate) {
																		return function (elationEnabled) {
																			return function (acceptsCards) {
																				return function (acceptsAmex) {
																					return function (stripeLink) {
																						return function (encourageAch) {
																							return function (createdAt) {
																								return function (paymentProcessor) {
																									return function (hasBankTransfersCapability) {
																										return {H$: acceptsAmex, H0: acceptsCards, abN: cancellationReasonOther, Mf: createdAt, M_: deactivateOn, M$: deactivated, Og: elationEnabled, Oo: email, Ou: encourageAch, P1: hasBankTransfersCapability, P2: hasClinicalAccount, Qd: hasPaymentProcessorAccount, Qi: hasStripeAccount, adR: id, Rv: isAffiliate, RV: isNetwork, S8: logoUrl, zh: name, V0: paymentProcessor, _R: stripeClientId, _X: stripeLink, _Z: stripePublishableKey, _$: subdomain, aav: url, aaD: usesCardReaders, aaH: usesSponsors};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.nI;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$head,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString),
				$elm$core$Maybe$withDefault('')))));
var $elm_community$json_extra$Json$Decode$Extra$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$Utils$Date$decode = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Api$Provider$Practice$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'has_bank_transfers_capability',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'encourage_ach',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'stripe_account_link',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'accepts_amex',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'accepts_cards',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'elation_enabled',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_affiliate',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'is_network',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'uses_card_readers',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'logo_url',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'stripe_publishable_key',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'stripe_client_id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'url',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'has_payment_processor_account',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'has_stripe_account',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'has_clinical_account',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'subdomain',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'deactivate_on',
																				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'deactivated',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'cancellation_reason_other',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'uses_sponsors',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'email',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'name',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'id',
																										$elm$json$Json$Decode$string,
																										$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$Shared$Record)))))))))))))))))))))))))));
var $author$project$Api$Provider$Practice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$One$Record = function (requireGroupForLocations) {
	return function (requiresMfa) {
		return function (trackPatientsByLocation) {
			return function (chargePatientsCreditCardFees) {
				return function (passthroughFeesCutoffEnabled) {
					return function (passthroughFeesCutoffDate) {
						return function (ssnEnabled) {
							return function (requiresSSN) {
								return function (requiresPatientEmail) {
									return function (requiresPatientMobile) {
										return function (requiresPractitioner) {
											return function (requiresLocation) {
												return function (requiresDefaultLocationForCompanies) {
													return function (hasCompaniesWithoutDefaultLocation) {
														return function (hasLocationsWithoutGroup) {
															return function (onboarded) {
																return function (organizationId) {
																	return function (canDeleteAllPatients) {
																		return function (collectSSNOnSignup) {
																			return function (collectPractitionerOnSignup) {
																				return function (collectLocationOnSignup) {
																					return function (selfServiceRequestAccessUrl) {
																						return function (notRetailPlansCount) {
																							return function (locationGroupsCount) {
																								return function (feePlanType) {
																									return function (sendZeroRevenueMembershipNotification) {
																										return function (emailReplyAddress) {
																											return function (salutation) {
																												return function (greetsFormally) {
																													return function (footer) {
																														return function (memberPortalSignupUrl) {
																															return function (meta) {
																																return function (practiceOnboarding) {
																																	return function (features) {
																																		return function (daysWithOutstandingBalance) {
																																			return function (collectionWarningStatus) {
																																				return function (accessRestricted) {
																																					return function (daysUntilAccessRestricted) {
																																						return function (billMonthlyAutopayInAdvanceInDays) {
																																							return function (billNonMonthlyAutopayInAdvanceInDays) {
																																								return function (billMonthlyNonAutopayInAdvanceInDays) {
																																									return function (billNonMonthlyNonAutopayInAdvanceInDays) {
																																										return function (scheduleMonthlyPaymentInAdvanceInDays) {
																																											return function (scheduleNonMonthlyPaymentInAdvanceInDays) {
																																												return function (commissionsEnabled) {
																																													return function (commissionsTrackingFrom) {
																																														return function (sessionTimeoutInMinutes) {
																																															return function (ein) {
																																																return function (practicePulse) {
																																																	return function (engagementThreshold) {
																																																		return function (defaultToActivePatientsFilter) {
																																																			return function (plansCount) {
																																																				return function (companiesCount) {
																																																					return function (owner) {
																																																						return function (businessLocation) {
																																																							return function (companyInvoiceSetting) {
																																																								return function (paymentSourceSetting) {
																																																									return function (address) {
																																																										return function (phones) {
																																																											return function (network) {
																																																												return function (featureGates) {
																																																													return function (labelBillingAsShipping) {
																																																														return function (accountType) {
																																																															return function (transInclusivity) {
																																																																return function (hasActiveCompanies) {
																																																																	return function (customForms) {
																																																																		return function (acceptsAch) {
																																																																			return function (postSignupButtonLabel) {
																																																																				return function (postSignupRedirectUrl) {
																																																																					return function (showPostSignupFooterButton) {
																																																																						return function (redirectsPostSignup) {
																																																																							return function (postSignupMessage) {
																																																																								return function (collectPaymentSourceOnSignup) {
																																																																									return function (autoConfirmSignup) {
																																																																										return function (prepayFirstPaymentOnSignup) {
																																																																											return function (mergeDuplicatePatientsOnSignup) {
																																																																												return function (collectAddressOnSignup) {
																																																																													return function (collectBillingAddressOnSignup) {
																																																																														return function (collectLeadSourceOnSignup) {
																																																																															return function (collectBrokerOnSignup) {
																																																																																return function (startDateSelectableOnSignup) {
																																																																																	return function (allowPayerOnBehalfOnSignup) {
																																																																																		return function (collectInsuranceOnSignup) {
																																																																																			return function (signupPageNotFoundRedirectUrl) {
																																																																																				return function (signupSettings) {
																																																																																					return function (defaultPlanId) {
																																																																																						return function (minEnrollAge) {
																																																																																							return function (restrictZipCodesOnSignup) {
																																																																																								return function (allowedZipCodesOnSignup) {
																																																																																									return function (defaultMembershipStartDate) {
																																																																																										return function (anyRetailBrokers) {
																																																																																											return function (mailgunStatus) {
																																																																																												return function (addons) {
																																																																																													return function (customLogoUrl) {
																																																																																														return function (emr) {
																																																																																															return function (emrOther) {
																																																																																																return function (defaultPatientsPreferredLanguage) {
																																																																																																	return function (stripeCustomerLink) {
																																																																																																		return function (membershipCancellationEnabled) {
																																																																																																			return function (allowMultipleRetailMemberships) {
																																																																																																				return function (hasManagedPartner) {
																																																																																																					return {H_: acceptsAch, H2: accessRestricted, H7: accountType, Is: addons, It: address, IW: allowMultipleRetailMemberships, IY: allowPayerOnBehalfOnSignup, I0: allowedZipCodesOnSignup, Jg: anyRetailBrokers, JD: autoConfirmSignup, abz: billMonthlyAutopayInAdvanceInDays, abA: billMonthlyNonAutopayInAdvanceInDays, abB: billNonMonthlyAutopayInAdvanceInDays, abC: billNonMonthlyNonAutopayInAdvanceInDays, Kg: businessLocation, Kq: canDeleteAllPatients, ab$: chargePatientsCreditCardFees, K7: collectAddressOnSignup, K8: collectBillingAddressOnSignup, K9: collectBrokerOnSignup, Lc: collectInsuranceOnSignup, Ld: collectLeadSourceOnSignup, ab7: collectLocationOnSignup, Lf: collectPaymentSourceOnSignup, Lg: collectPractitionerOnSignup, Lh: collectSSNOnSignup, Lj: collectionWarningStatus, Lo: commissionsEnabled, Lp: commissionsTrackingFrom, Lq: companiesCount, Lu: companyInvoiceSetting, MC: customForms, MF: customLogoUrl, MX: daysUntilAccessRestricted, MY: daysWithOutstandingBalance, Nc: defaultMembershipStartDate, Ne: defaultPatientsPreferredLanguage, Ni: defaultPlanId, acD: defaultToActivePatientsFilter, Of: ein, acV: emailReplyAddress, acY: emr, ac_: emrOther, ac3: engagementThreshold, Pb: featureGates, Pd: features, Pg: feePlanType, adv: footer, adE: greetsFormally, P0: hasActiveCompanies, P3: hasCompaniesWithoutDefaultLocation, P9: hasLocationsWithoutGroup, Qa: hasManagedPartner, St: labelBillingAsShipping, S0: locationGroupsCount, Tc: mailgunStatus, TA: memberPortalSignupUrl, aeB: membershipCancellationEnabled, TS: mergeDuplicatePatientsOnSignup, TU: meta, T_: minEnrollAge, Uo: network, UM: notRetailPlansCount, U5: onboarded, aft: organizationId, Vp: owner, afA: passthroughFeesCutoffDate, afB: passthroughFeesCutoffEnabled, V4: paymentSourceSetting, Wi: phones, Wr: plansCount, WB: postSignupButtonLabel, WC: postSignupMessage, WD: postSignupRedirectUrl, WJ: practiceOnboarding, WK: practicePulse, WX: prepayFirstPaymentOnSignup, X1: redirectsPostSignup, agj: requireGroupForLocations, agn: requiresDefaultLocationForCompanies, Ym: requiresLocation, Yn: requiresMfa, Yo: requiresPatientEmail, Yp: requiresPatientMobile, Yr: requiresPractitioner, Ys: requiresSSN, Yx: restrictZipCodesOnSignup, agC: salutation, agE: scheduleMonthlyPaymentInAdvanceInDays, agF: scheduleNonMonthlyPaymentInAdvanceInDays, Zi: selfServiceRequestAccessUrl, Zu: sendZeroRevenueMembershipNotification, agT: sessionTimeoutInMinutes, ZX: showPostSignupFooterButton, Z3: signupPageNotFoundRedirectUrl, Z5: signupSettings, _D: ssnEnabled, _F: startDateSelectableOnSignup, _U: stripeCustomerLink, $$: trackPatientsByLocation, $1: transInclusivity};
																																																																																																				};
																																																																																																			};
																																																																																																		};
																																																																																																	};
																																																																																																};
																																																																																															};
																																																																																														};
																																																																																													};
																																																																																												};
																																																																																											};
																																																																																										};
																																																																																									};
																																																																																								};
																																																																																							};
																																																																																						};
																																																																																					};
																																																																																				};
																																																																																			};
																																																																																		};
																																																																																	};
																																																																																};
																																																																															};
																																																																														};
																																																																													};
																																																																												};
																																																																											};
																																																																										};
																																																																									};
																																																																								};
																																																																							};
																																																																						};
																																																																					};
																																																																				};
																																																																			};
																																																																		};
																																																																	};
																																																																};
																																																															};
																																																														};
																																																													};
																																																												};
																																																											};
																																																										};
																																																									};
																																																								};
																																																							};
																																																						};
																																																					};
																																																				};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$AccountType$Affiliate = 1;
var $author$project$Api$AccountType$Mce = 2;
var $author$project$Api$AccountType$Standard = 0;
var $author$project$Api$AccountType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'standard':
				return $elm$json$Json$Decode$succeed(0);
			case 'affiliate':
				return $elm$json$Json$Decode$succeed(1);
			case 'mce':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported practice account_type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$FeePlanType$Pmpm = 1;
var $author$project$Api$FeePlanType$Transaction = 0;
var $author$project$Api$FeePlanType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'transaction':
				return $elm$json$Json$Decode$succeed(0);
			case 'pmpm':
				return $elm$json$Json$Decode$succeed(1);
			case 'pmpm_tiered':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported practice fee_plan_type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Language$ES = 1;
var $author$project$Language$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'en':
				return $elm$json$Json$Decode$succeed(0);
			case 'es':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Invalid language');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$CollectOnSignup$Default = 3;
var $author$project$Api$CollectOnSignup$No = 0;
var $author$project$Api$CollectOnSignup$Optional = 1;
var $author$project$Api$CollectOnSignup$Require = 2;
var $author$project$Api$CollectOnSignup$Yes = 4;
var $author$project$Api$CollectOnSignup$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'no':
				return $elm$json$Json$Decode$succeed(0);
			case 'optional':
				return $elm$json$Json$Decode$succeed(1);
			case 'require':
				return $elm$json$Json$Decode$succeed(2);
			case 'default':
				return $elm$json$Json$Decode$succeed(3);
			case 'yes':
				return $elm$json$Json$Decode$succeed(4);
			default:
				var somethingElse = str;
				return $elm$json$Json$Decode$fail('Unknown collect on signup value: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Address$Shared$Address = $elm$core$Basics$identity;
var $author$project$Api$Common$Address$Shared$Record = F7(
	function (line1, line2, city, state, zip, country, stripeCountryCode) {
		return {pT: city, pZ: country, rf: line1, yy: line2, sZ: state, _T: stripeCountryCode, tC: zip};
	});
var $author$project$Api$Common$Address$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stripe_country_code',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'country',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'zip',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'state',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'city',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'line2',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'line1',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Api$Common$Address$Shared$Record))))))));
var $author$project$Api$Common$Address$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Address$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$FeatureGate$Shared$FeatureGate = $elm$core$Basics$identity;
var $author$project$Api$Common$FeatureGate$Shared$Record = F2(
	function (code, startingTier) {
		return {K3: code, ag5: startingTier};
	});
var $author$project$Api$FeatureGate$CallUs = 3;
var $author$project$Api$FeatureGate$Enterprise = 2;
var $author$project$Api$FeatureGate$Growth = 1;
var $author$project$Api$FeatureGate$OtherStartingTier = 4;
var $author$project$Api$FeatureGate$Startup = 0;
var $author$project$Api$FeatureGate$decodeStartingTier = function (startingTierStr) {
	switch (startingTierStr) {
		case 'startup':
			return $elm$json$Json$Decode$succeed(0);
		case 'growth':
			return $elm$json$Json$Decode$succeed(1);
		case 'enterprise':
			return $elm$json$Json$Decode$succeed(2);
		case 'call_us':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$succeed(4);
	}
};
var $author$project$Api$Common$FeatureGate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'starting_tier',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$FeatureGate$decodeStartingTier, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'code',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$FeatureGate$Shared$Record)));
var $author$project$Api$Common$FeatureGate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$FeatureGate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Addon$Min$Addon = $elm$core$Basics$identity;
var $author$project$Api$Provider$Addon$Min$Record = F4(
	function (id, name, url, sendsExternalEmail) {
		return {adR: id, zh: name, Zw: sendsExternalEmail, aav: url};
	});
var $author$project$Api$Provider$Addon$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sends_external_email',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Addon$Min$Record)))));
var $author$project$Api$Provider$Addon$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Addon$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Form$Shared$Form = $elm$core$Basics$identity;
var $author$project$Api$Provider$Form$Shared$Record = F3(
	function (id, name, formItems) {
		return {PC: formItems, adR: id, zh: name};
	});
var $author$project$Api$Provider$FormItem$Shared$FormItem = $elm$core$Basics$identity;
var $author$project$Api$Provider$FormItem$Shared$Record = F3(
	function (id, title, itemType) {
		return {adR: id, q9: itemType, $G: title};
	});
var $author$project$Api$Provider$FormItem$Shared$Boolean = 0;
var $author$project$Api$Provider$FormItem$Shared$MultipleStrings = 1;
var $author$project$Api$Provider$FormItem$Shared$String = 2;
var $author$project$Api$Provider$FormItem$Shared$itemTypeDecoder = function (itemTypeString) {
	switch (itemTypeString) {
		case 'string':
			return $elm$json$Json$Decode$succeed(2);
		case 'multiple_strings':
			return $elm$json$Json$Decode$succeed(1);
		case 'boolean':
			return $elm$json$Json$Decode$succeed(0);
		default:
			return $elm$json$Json$Decode$fail('Unsupported item type: ' + itemTypeString);
	}
};
var $author$project$Api$Provider$FormItem$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'item_type',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$FormItem$Shared$itemTypeDecoder, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormItem$Shared$Record))));
var $author$project$Api$Provider$FormItem$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FormItem$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Form$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'form_items',
	$elm$json$Json$Decode$list($author$project$Api$Provider$FormItem$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Form$Shared$Record))));
var $author$project$Api$Provider$Form$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Form$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Location$Min$Location = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Location$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Min$Record)));
var $author$project$Api$Provider$Location$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Network$Shared$Network = $elm$core$Basics$identity;
var $author$project$Api$Provider$Network$Shared$Record = F2(
	function (syncByAffiliation, ratesFromAffiliate) {
		return {XN: ratesFromAffiliate, $f: syncByAffiliation};
	});
var $author$project$Api$Provider$Network$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rates_from_affiliate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sync_by_affiliation',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Network$Shared$Record)));
var $author$project$Api$Provider$Network$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Network$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$Emr$AkuteHealth = 3;
var $author$project$Api$Provider$Practice$Emr$AthenaHealth = 4;
var $author$project$Api$Provider$Practice$Emr$Canvas = 9;
var $author$project$Api$Provider$Practice$Emr$Cerbo = 2;
var $author$project$Api$Provider$Practice$Emr$CharmEMR = 6;
var $author$project$Api$Provider$Practice$Emr$DrChrono = 8;
var $author$project$Api$Provider$Practice$Emr$EClinicalWorks = 5;
var $author$project$Api$Provider$Practice$Emr$ElationHealth = 1;
var $author$project$Api$Provider$Practice$Emr$Emr = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$Emr$Healthie = 11;
var $author$project$Api$Provider$Practice$Emr$HintClinical = 0;
var $author$project$Api$Provider$Practice$Emr$Jane = 10;
var $author$project$Api$Provider$Practice$Emr$Other = 13;
var $author$project$Api$Provider$Practice$Emr$PracticeFusion = 7;
var $author$project$Api$Provider$Practice$Emr$VibrantPractice = 12;
var $author$project$Api$Provider$Practice$Emr$options = _List_fromArray(
	[
		{adR: 'hint_clinical', zh: 'Hint Clinical', ae: 0},
		{adR: 'akute_health', zh: 'Akute Health', ae: 3},
		{adR: 'athena_health', zh: 'AthenaHealth', ae: 4},
		{adR: 'canvas', zh: 'Canvas', ae: 9},
		{adR: 'cerbo', zh: 'Cerbo', ae: 2},
		{adR: 'charm_emr', zh: 'CharmEMR', ae: 6},
		{adR: 'dr_chrono', zh: 'DrChrono', ae: 8},
		{adR: 'e_clinical_works', zh: 'eClinicalWorks', ae: 5},
		{adR: 'elation_health', zh: 'Elation Health', ae: 1},
		{adR: 'healthie', zh: 'Healthie', ae: 11},
		{adR: 'jane', zh: 'Jane', ae: 10},
		{adR: 'practice_fusion', zh: 'PracticeFusion', ae: 7},
		{adR: 'vibrant_practice', zh: 'Vibrant Practice', ae: 12},
		{adR: 'other', zh: 'Other', ae: 13}
	]);
var $author$project$Api$Provider$Practice$Emr$fromValue = function (string) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (_v0) {
			var id = _v0.adR;
			return _Utils_eq(id, string);
		},
		$author$project$Api$Provider$Practice$Emr$options);
};
var $author$project$Api$Provider$Practice$Emr$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Api$Provider$Practice$Emr$fromValue(string);
		if (!_v0.$) {
			var emr = _v0.a;
			return $elm$json$Json$Decode$succeed(emr);
		} else {
			return $elm$json$Json$Decode$fail('Unsupported emr option: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$PracticeOnboarding$Shared$PracticeOnboarding = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$Shared$Record = F2(
	function (id, accountStep) {
		return {H6: accountStep, adR: id};
	});
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Communications = 5;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$ContactInfo = 1;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Legal = 6;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$MembershipPricing = 2;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$NotOnboarding = 8;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$NotStarted = 0;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$PatientAgreements = 3;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Profile = 4;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$SetupCompleted = 7;
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$decode = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		switch (string) {
			case 'not_started':
				return 0;
			case 'contact_info':
				return 1;
			case 'membership_pricing':
				return 2;
			case 'patient_agreements':
				return 3;
			case 'users_setup':
				return 4;
			case 'communications_setup':
				return 5;
			case 'legal_setup':
				return 6;
			case 'setup_completed':
				return 7;
			default:
				return 8;
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$PracticeOnboarding$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account_step',
	$author$project$Api$Provider$PracticeOnboarding$AccountStep$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeOnboarding$Shared$Record)));
var $author$project$Api$Provider$PracticeOnboarding$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeOnboarding$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupSettings$Min$SignupSettings = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupSettings$Min$Record = function (customJavascriptText) {
	return {MD: customJavascriptText};
};
var $author$project$Api$Provider$SignupSettings$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'custom_javascript_text',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupSettings$Min$Record));
var $author$project$Api$Provider$SignupSettings$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupSettings$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$User$Min$User = $elm$core$Basics$identity;
var $author$project$Api$Provider$User$Min$Record = function (name) {
	return {zh: name};
};
var $author$project$Api$Provider$User$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$User$Min$Record));
var $author$project$Api$Provider$User$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$User$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Expandable$Expanded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Expandable$NotExpanded = {$: 1};
var $author$project$Api$Expandable$expandable = F2(
	function (key, decoder) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			key,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						$elm$json$Json$Decode$null($author$project$Api$Expandable$NotExpanded),
						A2($elm$json$Json$Decode$map, $author$project$Api$Expandable$Expanded, decoder)
					])),
			$author$project$Api$Expandable$NotExpanded);
	});
var $author$project$Api$Provider$CustomForm$CustomForm = $elm$core$Basics$identity;
var $author$project$Api$Provider$CustomForm$FormQuestion = $elm$core$Basics$identity;
var $author$project$Api$Provider$Form$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$FormItem$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CustomForm$Boolean = 0;
var $author$project$Api$Provider$CustomForm$MultipleStrings = 1;
var $author$project$Api$Provider$CustomForm$String = 2;
var $author$project$Api$Provider$CustomForm$itemTypeToQuestionType = function (type_) {
	switch (type_) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Api$Provider$Form$Shared$items = function (_v0) {
	var record = _v0;
	return record.PC;
};
var $author$project$Api$Provider$Form$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$FormItem$Shared$title = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Api$Provider$FormItem$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.q9;
};
var $author$project$Api$Provider$CustomForm$initFromForm = function (form) {
	var formItems = $author$project$Api$Provider$Form$Shared$items(form);
	var emptyFormQuestion = function (item) {
		return {
			px: _List_Nil,
			adR: $author$project$Api$Provider$FormItem$Shared$id(item),
			$G: $author$project$Api$Provider$FormItem$Shared$title(item),
			ahI: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType(
				$author$project$Api$Provider$FormItem$Shared$type_(item))
		};
	};
	var questions_ = A2(
		$elm$core$List$map,
		function (formItem) {
			return emptyFormQuestion(formItem);
		},
		formItems);
	return {
		xI: '',
		adR: $author$project$Api$Provider$Form$Shared$id(form),
		zh: $author$project$Api$Provider$Form$Shared$name(form),
		Bj: questions_
	};
};
var $author$project$Api$Provider$Practice$One$OneMeta = F4(
	function (hasPractitioners, hasLocations, collectLocationOnSignup, collectPractitionerOnSignup) {
		return {ab7: collectLocationOnSignup, Lg: collectPractitionerOnSignup, P8: hasLocations, Qe: hasPractitioners};
	});
var $author$project$Api$Provider$Practice$One$OneMetaEditable = function (editable) {
	return {Oa: editable};
};
var $author$project$Api$Provider$Practice$One$metaEditableDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$OneMetaEditable));
var $author$project$Api$Provider$Practice$One$metaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_practitioner_on_signup',
	$author$project$Api$Provider$Practice$One$metaEditableDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'collect_location_on_signup',
		$author$project$Api$Provider$Practice$One$metaEditableDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'has_locations',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'has_practitioners',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$OneMeta)))));
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$Shared = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$Shared$Record));
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$sharedDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyInvoiceSetting$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentSourceSetting$Shared$Shared = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentSourceSetting$Shared$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$PaymentSourceSetting$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$Shared$Record));
var $author$project$Api$Provider$PaymentSourceSetting$Shared$sharedDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentSourceSetting$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'has_managed_partner',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'allow_multiple_retail_memberships',
		$elm$json$Json$Decode$bool,
		false,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'membership_cancellation_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'stripe_customer_link',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'default_patients_preferred_language',
					$author$project$Language$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'emr_other',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'emr',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practice$Emr$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'custom_logo_url',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'addons',
									$elm$json$Json$Decode$list($author$project$Api$Provider$Addon$Min$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'mailgun_status',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'any_retail_brokers',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'default_membership_start_date',
												$author$project$Utils$Date$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'allowed_zip_codes_on_signup',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'restrict_zip_codes_on_signup',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'min_enroll_age',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
															A3(
																$author$project$Api$Expandable$expandable,
																'default_plan_id',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$author$project$Api$Expandable$expandable,
																	'signup_settings',
																	$author$project$Api$Provider$SignupSettings$Min$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'signup_page_not_found_redirect_url',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'collect_insurance_on_signup',
																			$author$project$Api$CollectOnSignup$decoder,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'allows_payer_on_behalf_on_signup',
																				$author$project$Api$CollectOnSignup$decoder,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'start_date_selectable_on_signup',
																					$elm$json$Json$Decode$bool,
																					false,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'collect_broker_on_signup',
																						$author$project$Api$CollectOnSignup$decoder,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'collect_lead_source_on_signup',
																							$author$project$Api$CollectOnSignup$decoder,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'collect_billing_address_on_signup',
																								$author$project$Api$CollectOnSignup$decoder,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'collect_address_on_signup',
																									$author$project$Api$CollectOnSignup$decoder,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'merge_duplicate_patients_on_online_signup',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'prepay_first_payment_on_signup',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'auto_confirm_signups',
																												$elm$json$Json$Decode$bool,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'collect_payment_source_on_signup',
																													$author$project$Api$CollectOnSignup$decoder,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'post_signup_message',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'redirects_post_signup',
																															$elm$json$Json$Decode$bool,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'show_post_signup_footer_button',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'post_signup_redirect_url',
																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'post_signup_button_label',
																																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'accepts_ach',
																																			$elm$json$Json$Decode$bool,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'forms',
																																				A2(
																																					$elm$json$Json$Decode$map,
																																					$elm$core$List$map($author$project$Api$Provider$CustomForm$initFromForm),
																																					$elm$json$Json$Decode$list($author$project$Api$Provider$Form$Shared$decoder)),
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'has_active_companies',
																																					$elm$json$Json$Decode$bool,
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'trans_inclusivity',
																																						$elm$json$Json$Decode$bool,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'account_type',
																																							$author$project$Api$AccountType$decode,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'label_billing_as_shipping',
																																								$elm$json$Json$Decode$bool,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'feature_gates',
																																									$elm$json$Json$Decode$list($author$project$Api$Common$FeatureGate$Shared$decoder),
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'network',
																																										$elm$json$Json$Decode$nullable($author$project$Api$Provider$Network$Shared$decoder),
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'phones',
																																											$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'address',
																																												$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'payment_source_setting',
																																													$author$project$Api$Provider$PaymentSourceSetting$Shared$sharedDecoder,
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'company_invoice_setting',
																																														$author$project$Api$Provider$CompanyInvoiceSetting$Shared$sharedDecoder,
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'business_location',
																																															$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
																																															A3(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																'owner',
																																																$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder),
																																																A3(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																	'companies_count',
																																																	$elm$json$Json$Decode$int,
																																																	A3(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																		'plans_count',
																																																		$elm$json$Json$Decode$int,
																																																		A3(
																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																			'default_to_active_patients_filter',
																																																			$elm$json$Json$Decode$bool,
																																																			A3(
																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																				'engagement_threshold',
																																																				$elm$json$Json$Decode$int,
																																																				A3(
																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																					'practice_pulse',
																																																					$elm$json$Json$Decode$bool,
																																																					A3(
																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																						'ein',
																																																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																						A3(
																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																							'session_timeout_in_minutes',
																																																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																																							A3(
																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																								'commissions_tracking_from',
																																																								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																																																								A3(
																																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																									'commissions_enabled',
																																																									$elm$json$Json$Decode$bool,
																																																									A3(
																																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																										'schedule_non_monthly_payment_in_advance_in_days',
																																																										$elm$json$Json$Decode$int,
																																																										A3(
																																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																											'schedule_monthly_payment_in_advance_in_days',
																																																											$elm$json$Json$Decode$int,
																																																											A3(
																																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																												'bill_non_monthly_non_autopay_in_advance_in_days',
																																																												$elm$json$Json$Decode$int,
																																																												A3(
																																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																													'bill_monthly_non_autopay_in_advance_in_days',
																																																													$elm$json$Json$Decode$int,
																																																													A3(
																																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																														'bill_non_monthly_autopay_in_advance_in_days',
																																																														$elm$json$Json$Decode$int,
																																																														A3(
																																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																															'bill_monthly_autopay_in_advance_in_days',
																																																															$elm$json$Json$Decode$int,
																																																															A3(
																																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																'days_until_access_restricted',
																																																																$elm$json$Json$Decode$int,
																																																																A3(
																																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																	'access_restricted',
																																																																	$elm$json$Json$Decode$bool,
																																																																	A3(
																																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																		'collection_warning_status',
																																																																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																																		A3(
																																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																			'days_with_outstanding_balance',
																																																																			$elm$json$Json$Decode$int,
																																																																			A3(
																																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																				'features',
																																																																				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																																																																				A3(
																																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																					'practice_onboarding',
																																																																					$elm$json$Json$Decode$nullable($author$project$Api$Provider$PracticeOnboarding$Shared$decoder),
																																																																					A3(
																																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																						'meta',
																																																																						$author$project$Api$Provider$Practice$One$metaDecoder,
																																																																						A3(
																																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																							'member_portal_signup_url',
																																																																							$elm$json$Json$Decode$string,
																																																																							A3(
																																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																								'footer',
																																																																								$elm$json$Json$Decode$string,
																																																																								A3(
																																																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																									'greets_formally',
																																																																									$elm$json$Json$Decode$bool,
																																																																									A3(
																																																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																										'salutation',
																																																																										$elm$json$Json$Decode$string,
																																																																										A3(
																																																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																											'email_reply_address',
																																																																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																																																											A3(
																																																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																												'send_zero_revenue_membership_notification',
																																																																												$elm$json$Json$Decode$bool,
																																																																												A3(
																																																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																													'fee_plan_type',
																																																																													$author$project$Api$FeePlanType$decode,
																																																																													A3(
																																																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																														'location_groups_count',
																																																																														$elm$json$Json$Decode$int,
																																																																														A3(
																																																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																															'not_retail_plans_count',
																																																																															$elm$json$Json$Decode$int,
																																																																															A3(
																																																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																'self_service_request_access_url',
																																																																																$elm$json$Json$Decode$string,
																																																																																A3(
																																																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																	'collect_location_on_signup',
																																																																																	$author$project$Api$CollectOnSignup$decoder,
																																																																																	A3(
																																																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																		'collect_practitioner_on_signup',
																																																																																		$author$project$Api$CollectOnSignup$decoder,
																																																																																		A3(
																																																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																			'collect_ssn_on_signup',
																																																																																			$author$project$Api$CollectOnSignup$decoder,
																																																																																			A3(
																																																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																				'can_delete_all_patients',
																																																																																				$elm$json$Json$Decode$bool,
																																																																																				A3(
																																																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																					'organization_id',
																																																																																					$elm$json$Json$Decode$string,
																																																																																					A3(
																																																																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																						'onboarded',
																																																																																						$elm$json$Json$Decode$bool,
																																																																																						A3(
																																																																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																							'has_locations_without_group',
																																																																																							$elm$json$Json$Decode$bool,
																																																																																							A3(
																																																																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																								'has_companies_without_default_location',
																																																																																								$elm$json$Json$Decode$bool,
																																																																																								A3(
																																																																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																									'require_default_location_for_companies',
																																																																																									$elm$json$Json$Decode$bool,
																																																																																									A4(
																																																																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																																																										'requires_location',
																																																																																										$elm$json$Json$Decode$bool,
																																																																																										false,
																																																																																										A4(
																																																																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																																																											'requires_practitioner',
																																																																																											$elm$json$Json$Decode$bool,
																																																																																											false,
																																																																																											A3(
																																																																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																												'requires_patient_mobile',
																																																																																												$elm$json$Json$Decode$bool,
																																																																																												A3(
																																																																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																													'requires_patient_email',
																																																																																													$elm$json$Json$Decode$bool,
																																																																																													A3(
																																																																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																														'requires_ssn',
																																																																																														$elm$json$Json$Decode$bool,
																																																																																														A4(
																																																																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																																																															'ssn_enabled',
																																																																																															$elm$json$Json$Decode$bool,
																																																																																															false,
																																																																																															A3(
																																																																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																'passthrough_fees_cutoff_date',
																																																																																																$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																																																																																																A3(
																																																																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																	'passthrough_fees_cutoff_enabled',
																																																																																																	$elm$json$Json$Decode$bool,
																																																																																																	A3(
																																																																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																		'charge_patients_credit_card_fees',
																																																																																																		$elm$json$Json$Decode$bool,
																																																																																																		A4(
																																																																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																																																																																			'track_patients_by_location',
																																																																																																			$elm$json$Json$Decode$bool,
																																																																																																			false,
																																																																																																			A3(
																																																																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																				'requires_mfa',
																																																																																																				$elm$json$Json$Decode$bool,
																																																																																																				A3(
																																																																																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																																																																					'require_group_for_locations',
																																																																																																					$elm$json$Json$Decode$bool,
																																																																																																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$Record))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Practice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Practice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$Practice)));
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Api$Provider$Practice$updateAdvanceBilling = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bill_monthly_autopay_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.abz)),
								_Utils_Tuple2(
								'bill_monthly_non_autopay_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.abA)),
								_Utils_Tuple2(
								'bill_non_monthly_autopay_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.abB)),
								_Utils_Tuple2(
								'bill_non_monthly_non_autopay_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.abC)),
								_Utils_Tuple2(
								'schedule_monthly_payment_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.agE)),
								_Utils_Tuple2(
								'schedule_non_monthly_payment_in_advance_in_days',
								$elm$json$Json$Encode$int(fields.agF))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$AdvanceBilling$updateAdvanceBilling = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$updateAdvanceBilling,
			apiClient,
			{
				abz: A2($elm$core$Maybe$withDefault, 0, fields.abz),
				abA: A2($elm$core$Maybe$withDefault, 0, fields.abA),
				abB: A2($elm$core$Maybe$withDefault, 0, fields.abB),
				abC: A2($elm$core$Maybe$withDefault, 0, fields.abC),
				agE: A2($elm$core$Maybe$withDefault, 0, fields.agE),
				agF: A2($elm$core$Maybe$withDefault, 0, fields.agF)
			},
			$author$project$Pages$Admin$AdvanceBilling$Updated);
	});
var $author$project$Pages$Admin$AdvanceBilling$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var type_ = msg.a;
				var frequency = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							w: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Utils$Form$init(
										A3($author$project$Pages$Admin$AdvanceBilling$formFieldsInit, type_, frequency, model.WF)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{w: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var field = msg.a;
				var _v1 = model.w;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var form = _v2.a;
					var updateRequest = _v2.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$AdvanceBilling$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								w: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, updateRequest))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v3 = model.w;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var form = _v4.a;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$AdvanceBilling$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									w: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
								}),
							A2($author$project$Pages$Admin$AdvanceBilling$updateAdvanceBilling, model.D5, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									w: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				var _v7 = model.w;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var form = _v8.a;
					if (response.$ === 3) {
						var practice = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{w: $elm$core$Maybe$Nothing, WF: practice}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Settings successfully updated.'),
									$author$project$OutMsg$PracticeUpdated(response)
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									w: $elm$core$Maybe$Just(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var notificationSetting = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a9: A3(
									$elm$core$Dict$insert,
									id,
									_Utils_Tuple3(
										notificationSetting,
										$author$project$Components$Admin$NotificationSetting$Customize$initFromOne(notificationSetting),
										A2($author$project$Components$Admin$NotificationSetting$Toggle$init, $author$project$Components$Admin$NotificationSetting$Toggle$oneGetters, notificationSetting)),
									model.a9)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var setting = msg.a;
				var subMsg = msg.b;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (_v11) {
							var customize = _v11.b;
							var result = A3($author$project$Components$Admin$NotificationSetting$Customize$update, model.D5, subMsg, customize);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										a9: A3(
											$elm$core$Dict$update,
											$author$project$Api$Provider$NotificationSetting$One$id(setting),
											function (tuple) {
												if (!tuple.$) {
													var _v13 = tuple.a;
													var s = _v13.a;
													var t = _v13.c;
													return $elm$core$Maybe$Just(
														_Utils_Tuple3(s, result.y8, t));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											},
											model.a9)
									}),
								A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(setting),
									result.EC),
								result.as);
						},
						A2(
							$elm$core$Dict$get,
							$author$project$Api$Provider$NotificationSetting$One$id(setting),
							model.a9)));
			default:
				var id = msg.a;
				var toggleNotification = msg.b;
				var subMsg = msg.c;
				var _v14 = A4($author$project$Components$Admin$NotificationSetting$Toggle$update, model.D5, $author$project$Api$Provider$Notification$PracticeContext, subMsg, toggleNotification);
				var toggleNotification_ = _v14.a;
				var subCmd = _v14.b;
				var subOutMsg = _v14.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a9: A3(
								$elm$core$Dict$update,
								id,
								$elm$core$Maybe$map(
									function (_v15) {
										var notificationSetting_ = _v15.a;
										var customize = _v15.b;
										return _Utils_Tuple3(notificationSetting_, customize, toggleNotification_);
									}),
								model.a9)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg, id, toggleNotification_),
						subCmd),
					subOutMsg);
		}
	});
var $author$project$Ui$Element$Muted = 0;
var $author$project$Ui$Element$Text = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Element$textMuted = $author$project$Ui$Element$Text(0);
var $author$project$Pages$Admin$AdvanceBilling$Autopay = 0;
var $author$project$Pages$Admin$AdvanceBilling$Edit = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Admin$AdvanceBilling$Monthly = 0;
var $author$project$Pages$Admin$AdvanceBilling$NonMonthly = 1;
var $author$project$Ui$Pull$Right = 1;
var $author$project$Ui$Table$Grid = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Ui$Table$Xs = 0;
var $author$project$Ui$Table$cellSpan = $author$project$Ui$Table$Grid(0);
var $author$project$Ui$SvgIcon$Edit = 39;
var $author$project$Ui$SvgIcon$edit = $author$project$Ui$SvgIcon$viewIcon(39);
var $author$project$Ui$Table$Header = $elm$core$Basics$identity;
var $author$project$Ui$Table$header = F2(
	function (options, contents) {
		return _Utils_Tuple2(options, contents);
	});
var $author$project$Ui$Button$Pull = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Button$pull = $author$project$Ui$Button$Pull;
var $author$project$Ui$Table$Row = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Table$row = F2(
	function (options, cells) {
		return $author$project$Ui$Table$Row(
			_Utils_Tuple2(options, cells));
	});
var $author$project$Ui$Button$Size = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Button$Sm = 0;
var $author$project$Ui$Button$sm = $author$project$Ui$Button$Size(0);
var $author$project$Formatters$String$vowels = _List_fromArray(
	['a', 'e', 'i', 'o', 'u']);
var $author$project$Formatters$String$endsWithConsonantAndY = function (word) {
	var lastTwoChars = $elm$core$String$toList(
		A2($elm$core$String$right, 2, word));
	if (((lastTwoChars.b && lastTwoChars.b.b) && ('y' === lastTwoChars.b.a)) && (!lastTwoChars.b.b.b)) {
		var _char = lastTwoChars.a;
		var _v1 = lastTwoChars.b;
		return !A2($elm$core$List$member, _char, $author$project$Formatters$String$vowels);
	} else {
		return false;
	}
};
var $author$project$Formatters$String$endsWithS = function (word) {
	var lastChar = A2($elm$core$String$right, 1, word);
	return lastChar === 's';
};
var $author$project$Formatters$String$pluralOf = function (singular) {
	if (singular === 'child') {
		return 'children';
	} else {
		return $author$project$Formatters$String$endsWithConsonantAndY(singular) ? (A2($elm$core$String$dropRight, 1, singular) + 'ies') : ($author$project$Formatters$String$endsWithS(singular) ? singular : (singular + 's'));
	}
};
var $elm_community$string_extra$String$Extra$pluralize = F3(
	function (singular, plural, count) {
		return (count === 1) ? ('1 ' + singular) : ($elm$core$String$fromInt(count) + (' ' + plural));
	});
var $author$project$Formatters$String$pluralize = F2(
	function (singular, count) {
		var plural = $author$project$Formatters$String$pluralOf(singular);
		return A3($elm_community$string_extra$String$Extra$pluralize, singular, plural, count);
	});
var $author$project$Formatters$Int$toDays = $author$project$Formatters$String$pluralize('day');
var $author$project$Components$Admin$NotificationSetting$Customize$OpenModal = {$: 0};
var $author$project$Api$Provider$NotificationSetting$Meta$bodyEditable = function (_v0) {
	var meta = _v0;
	return meta.e5.Oa;
};
var $author$project$Api$Provider$NotificationSetting$Shared$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Components$Admin$NotificationSetting$Customize$button = function (model) {
	return $author$project$Api$Provider$NotificationSetting$Meta$bodyEditable(
		$author$project$Api$Provider$NotificationSetting$Shared$meta(model.UN)) ? A3(
		$author$project$Ui$Button$view,
		{abp: 'Customize notification'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
				$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$OpenModal)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Customize')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Ui$Modal$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Modal$body = function (contents) {
	return $author$project$Ui$Modal$Body(contents);
};
var $author$project$Ui$Modal$Footer = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Modal$footer = function (contents) {
	return $author$project$Ui$Modal$Footer(contents);
};
var $author$project$Ui$Modal$Header = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Modal$header = function (contents) {
	return $author$project$Ui$Modal$Header(contents);
};
var $author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml = function (_v0) {
	var record = _v0;
	return record.ZM;
};
var $author$project$Ui$Modal$title = function (string) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Ui$Modal$Md = 1;
var $author$project$Ui$Modal$defaultOptions = {qj: true, zR: $elm$core$Maybe$Nothing, ag_: 1};
var $author$project$Ui$Modal$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var size_ = option.a;
						return _Utils_update(
							record,
							{ag_: size_});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{qj: bool});
					default:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								zR: $elm$core$Maybe$Just(msg)
							});
				}
			}),
		$author$project$Ui$Modal$defaultOptions,
		options);
};
var $author$project$Ui$Modal$sizeClass = function (size_) {
	switch (size_) {
		case 0:
			return 'modal-sm';
		case 1:
			return '';
		case 2:
			return 'modal-lg';
		default:
			return 'x-large';
	}
};
var $author$project$Ui$Modal$viewBackdrop = function (onClose) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal__backdrop'),
				A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
				A2($elm$html$Html$Attributes$style, 'inset', '0px'),
				A2($elm$html$Html$Attributes$style, 'z-index', '1040'),
				$elm$html$Html$Events$onClick(onClose)
			]),
		_List_Nil);
};
var $author$project$Utils$Html$multiplication = $elm$html$Html$text(
	$elm$core$String$fromChar('×'));
var $author$project$Ui$Modal$closeButton = function (onClose) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('button'),
				$elm$html$Html$Attributes$class('button close'),
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
				$elm$html$Html$Events$onClick(onClose)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
					]),
				_List_fromArray(
					[$author$project$Utils$Html$multiplication]))
			]));
};
var $author$project$Ui$Modal$viewSection = F3(
	function (dismisiable_, onCloseMsg, section) {
		switch (section.$) {
			case 0:
				var contents = section.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-header')
						]),
					dismisiable_ ? A2(
						$elm$core$List$cons,
						$author$project$Ui$Modal$closeButton(onCloseMsg),
						contents) : contents);
			case 1:
				var contents = section.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-body')
						]),
					contents);
			case 2:
				var contents = section.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-faq')
						]),
					contents);
			default:
				var contents = section.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-footer')
						]),
					contents);
		}
	});
var $author$project$Ui$Modal$view = F3(
	function (onClose, options, sections) {
		var optionsRecord = $author$project$Ui$Modal$optionsToRecord(options);
		var wrapInsideForm = function (htmlSections) {
			var _v0 = optionsRecord.zR;
			if (!_v0.$) {
				var msg = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$form,
						_List_fromArray(
							[
								$elm$html$Html$Events$onSubmit(msg)
							]),
						htmlSections)
					]);
			} else {
				return htmlSections;
			}
		};
		return function (content) {
			return A3(
				$elm$html$Html$node,
				'elm-modal',
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elm-modal show'),
						$elm$html$Html$Attributes$tabindex(-1),
						A2($elm$html$Html$Attributes$attribute, 'role', 'dialog')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$viewBackdrop(onClose),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('modal-dialog'),
								$elm$html$Html$Attributes$class(
								$author$project$Ui$Modal$sizeClass(optionsRecord.ag_)),
								A2($elm$html$Html$Attributes$attribute, 'role', 'document')
							]),
						_List_fromArray(
							[content]))
					]));
		}(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-content')
					]),
				wrapInsideForm(
					A2(
						$elm$core$List$map,
						A2($author$project$Ui$Modal$viewSection, optionsRecord.qj, onClose),
						sections))));
	});
var $author$project$Components$Admin$NotificationSetting$Customize$Subject = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$NotificationSettingPreview$body = function (_v0) {
	var record = _v0;
	return record.e5;
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Ui$Alert$Danger = 3;
var $author$project$Ui$SvgIcon$Cross = 46;
var $author$project$Ui$SvgIcon$cross = $author$project$Ui$SvgIcon$viewIcon(46);
var $author$project$Ui$Alert$dismissButton = function (msg) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Dismiss alert'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(msg)
			]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$cross(_List_Nil)
			]));
};
var $author$project$Ui$Alert$defaultOptions = {vw: _List_Nil, qj: $elm$core$Maybe$Nothing, s9: $elm$core$Maybe$Nothing};
var $author$project$Ui$Alert$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								qj: $elm$core$Maybe$Just(msg)
							});
					case 1:
						var margin_ = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Ui$Margin$toClass(margin_),
									record.vw)
							});
					case 2:
						var alignment_ = option.a;
						return _Utils_update(
							record,
							{
								vw: _Utils_ap(
									$author$project$Ui$Alignment$toAttrs(alignment_),
									record.vw)
							});
					case 3:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('hard-notification'),
									record.vw)
							});
					case 4:
						var svgIcon = option.a;
						return _Utils_update(
							record,
							{
								s9: $elm$core$Maybe$Just(svgIcon)
							});
					default:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('h-full'),
									record.vw)
							});
				}
			}),
		$author$project$Ui$Alert$defaultOptions,
		options);
};
var $author$project$Ui$Alert$styleClass = function (style) {
	switch (style) {
		case 0:
			return 'alert--success';
		case 1:
			return 'alert--info';
		case 2:
			return 'alert--warning';
		case 3:
			return 'alert--danger';
		default:
			return 'alert--primary';
	}
};
var $author$project$Ui$SvgIcon$Width = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$SvgIcon$width = $author$project$Ui$SvgIcon$Width;
var $author$project$Ui$Alert$view = F3(
	function (style, options, contents) {
		var optionsRecord = $author$project$Ui$Alert$optionsToRecord(options);
		var hasFullHeight = A2(
			$elm$core$List$any,
			function (opt) {
				if (opt.$ === 5) {
					return true;
				} else {
					return false;
				}
			},
			options);
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$html$Html$Attributes$class('alert'),
						$elm$html$Html$Attributes$class(
						$author$project$Ui$Alert$styleClass(style)),
						A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
					]),
					A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					optionsRecord.vw),
					function () {
					var _v2 = optionsRecord.qj;
					if (!_v2.$) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert--dismissible')
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v3 = optionsRecord.s9;
					if (!_v3.$) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert--icon')
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
		return A2(
			$elm$html$Html$div,
			attributes,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = optionsRecord.s9;
						if (!_v0.$) {
							var msg = _v0.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$width('24px'),
											$author$project$Ui$SvgIcon$height('24px')
										]),
									msg)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('alert--contents'),
								hasFullHeight ? _List_fromArray(
									[
										$elm$html$Html$Attributes$class('h-full')
									]) : _List_Nil),
							contents)
						]),
						function () {
						var _v1 = optionsRecord.qj;
						if (!_v1.$) {
							var msg = _v1.a;
							return _List_fromArray(
								[
									$author$project$Ui$Alert$dismissButton(msg)
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
	});
var $author$project$Ui$Alert$danger = $author$project$Ui$Alert$view(3);
var $author$project$Api$Data$errorToString = function (errorResponse) {
	switch (errorResponse.$) {
		case 0:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, 'Unauthorized', errorMessage);
		case 1:
			return 'BadUrl';
		case 2:
			return 'Timeout';
		case 3:
			return 'Network';
		case 4:
			return 'Server Error';
		case 5:
			return 'Not Found';
		case 8:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, 'Internal Server Error', errorMessage);
		case 6:
			var errorMessage = errorResponse.b;
			return errorMessage;
		case 7:
			var string = errorResponse.a;
			return 'Decoder error! ' + string;
		case 9:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, 'Forbidden', errorMessage);
		default:
			var errorMessage = errorResponse.a;
			return A2($elm$core$Maybe$withDefault, 'Conflict', errorMessage);
	}
};
var $author$project$Ui$Form$Textarea$Id = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Textarea$id = $author$project$Ui$Form$Textarea$Id;
var $author$project$Ui$Form$Textarea$Phi = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Textarea$phi = $author$project$Ui$Form$Textarea$Phi;
var $author$project$Ui$Typography$Phi = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Typography$phi = $author$project$Ui$Typography$Phi;
var $author$project$Ui$Form$Textarea$Rows = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Textarea$rows = $author$project$Ui$Form$Textarea$Rows;
var $author$project$Ui$Typography$Small = {$: 7};
var $author$project$Ui$Typography$small = $author$project$Ui$Typography$Small;
var $author$project$Api$Provider$NotificationSettingPreview$subject = function (_v0) {
	var record = _v0;
	return record.Hp;
};
var $author$project$Api$HtmlTemplate$view = F2(
	function (attributes, _v0) {
		var html = _v0;
		return A3(
			$elm$html$Html$node,
			'html-template',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'contents', html),
				attributes),
			_List_Nil);
	});
var $author$project$Ui$Form$Textarea$disableGrammarly = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$attribute, 'data-gramm_editor', 'false'),
		A2($elm$html$Html$Attributes$attribute, 'data-gramm', 'false'),
		A2($elm$html$Html$Attributes$attribute, 'data-enable-grammarly', 'false')
	]);
var $author$project$Ui$Form$Textarea$defaultOptions = {vw: $author$project$Ui$Form$Textarea$disableGrammarly, fE: _List_Nil, xO: false, q$: false, tA: _List_Nil};
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Form$Textarea$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$id(string),
									record.vw)
							});
					case 1:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$rows(_int),
									record.vw)
							});
					case 2:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onInput(handler),
									record.vw)
							});
					case 3:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Events$onBlur(handler),
									record.vw)
							});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$value(string),
									record.vw)
							});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('feedback-errored', bool)
											])),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$Attributes$attribute,
											'aria-invalid',
											bool ? 'true' : 'false'),
										record.vw)),
								q$: bool
							});
					case 6:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
					case 7:
						var bool = option.a;
						var phiAttrs = bool ? $author$project$Api$Phi$inputAttr : _List_Nil;
						return _Utils_update(
							record,
							{
								vw: _Utils_ap(phiAttrs, record.vw)
							});
					case 8:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$placeholder(string),
									record.vw)
							});
					case 9:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$disabled(bool),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('disabled', bool)
												])),
										record.vw))
							});
					case 10:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$author$project$Utils$Html$Attributes$test(string),
									record.vw)
							});
					case 11:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'min-height', string),
									record.vw)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{xO: bool});
				}
			}),
		$author$project$Ui$Form$Textarea$defaultOptions,
		options);
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Ui$Form$Textarea$viewErrors = function (option) {
	if (option.$ === 6) {
		var errors_ = option.a;
		return $author$project$Utils$FormErrors$view(errors_);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Form$Textarea$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$Textarea$optionsToRecord(options);
	var errorDescription = $elm$core$List$isEmpty(optionsRecord.fE) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$attribute,
			'aria-describedby',
			A2($elm$core$String$join, '. ', optionsRecord.fE))
		]);
	return A2(
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('input-wrapper'),
			optionsRecord.tA),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$elm$html$Html$textarea,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('form-control'),
							_Utils_ap(errorDescription, optionsRecord.vw)),
						_List_Nil)
					]),
					optionsRecord.xO ? _List_Nil : A2($elm$core$List$map, $author$project$Ui$Form$Textarea$viewErrors, options)
				])));
};
var $author$project$Ui$Well$optionToAttrs = function (option) {
	switch (option.$) {
		case 0:
			var size = option.a;
			switch (size) {
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('well-xs')
						]);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('well-sm'),
							$elm$html$Html$Attributes$class('max-w-sm')
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('well')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('well-lg')
						]);
			}
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('signin')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('clearfix')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('border-0')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('w-full')
				]);
	}
};
var $author$project$Ui$Well$view = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('well'),
				A2($elm$core$List$concatMap, $author$project$Ui$Well$optionToAttrs, options)),
			content);
	});
var $author$project$Components$Admin$NotificationSetting$Customize$LanguageSelected = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$NotificationSetting$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Ui$Alert$Info = 1;
var $author$project$Ui$Alert$info = $author$project$Ui$Alert$view(1);
var $author$project$Ui$Element$mt2 = $author$project$Ui$Element$Margin('mt-2');
var $author$project$Language$spanish = 1;
var $author$project$Language$toLabel = function (lang) {
	if (!lang) {
		return 'English';
	} else {
		return 'Spanish';
	}
};
var $author$project$Components$Admin$NotificationSetting$Customize$viewPreview = F4(
	function (notificationSetting, subject, body, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$info,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Liquid syntax is used to build this email. '),
						A3(
						$author$project$Ui$Link$externalHref,
						'http://shopify.github.io/liquid/basics/introduction/',
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('Click here')
							])),
						$elm$html$Html$text(' to learn more.')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$NotificationSetting$Shared$description(notificationSetting))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.afU, model.fy);
				if (_v0.a.$ === 3) {
					var _v1 = _v0.a;
					return $elm$html$Html$text('');
				} else {
					if (!_v0.b.$) {
						var dropdown = _v0.b.a;
						var languageToItem = function (lang) {
							return A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$selected(
										_Utils_eq(lang, model.yu)),
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$Admin$NotificationSetting$Customize$LanguageSelected(lang))
									]),
								$elm$html$Html$text(
									$author$project$Language$toLabel(lang)));
						};
						var items = A2(
							$elm$core$List$map,
							languageToItem,
							_List_fromArray(
								[$author$project$Language$english, $author$project$Language$spanish]));
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Now editing'),
									$author$project$Ui$Form$Group$labelSpan(2),
									$author$project$Ui$Form$Group$inputSpan(4)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$NewDropdown$viewSelect,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Language$toLabel(model.yu))
										]),
									items,
									dropdown)
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}
			}(),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$label('Subject')
					]),
				_List_fromArray(
					[subject])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$label('Body')
					]),
				_List_fromArray(
					[body]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$Customize$ToogleVariables = {$: 13};
var $author$project$Components$Admin$NotificationSetting$Customize$viewToogleVariables = function (showVariables) {
	var action = showVariables ? 'hide' : 'show';
	return _List_fromArray(
		[
			$elm$html$Html$text('Click '),
			A3(
			$author$project$Ui$Button$view,
			{abp: action + 'variables'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$ToogleVariables)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('here')
				])),
			$elm$html$Html$text(' to ' + (action + ' variables'))
		]);
};
var $author$project$Components$Admin$NotificationSetting$Customize$viewModalBody = function (model) {
	var _v0 = model.afU;
	if (_v0.$ === 3) {
		var preview = _v0.a;
		return _Utils_ap(
			A4(
				$author$project$Components$Admin$NotificationSetting$Customize$viewPreview,
				model.UN,
				A2(
					$author$project$Ui$Well$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$NotificationSettingPreview$subject(preview))
								]))
						])),
				A2(
					$author$project$Ui$Well$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('notification-email-layout')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Api$HtmlTemplate$view,
									$author$project$Api$Phi$displayAttr,
									$author$project$Api$Provider$NotificationSettingPreview$body(preview))
								]))
						])),
				model),
			_List_fromArray(
				[
					function () {
					var _v1 = model.ks;
					if (_v1.$ === 2) {
						var error = _v1.a;
						return A2(
							$author$project$Ui$Alert$danger,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Error sending email')
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text(
									$author$project$Api$Data$errorToString(error))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	} else {
		var _v2 = $author$project$Utils$Form$fields(model.PB);
		var subject = _v2.Hp;
		return A4(
			$author$project$Components$Admin$NotificationSetting$Customize$viewPreview,
			model.UN,
			A2(
				$author$project$Ui$Form$Group$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(subject),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$Customize$Subject)),
								$author$project$Ui$Form$Input$phi(true)
							]))
					])),
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Textarea$rows(15),
										$author$project$Ui$Form$Textarea$id(
										$author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.UN)),
										$author$project$Ui$Form$Textarea$phi(true)
									]))
							])),
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text('You can edit your footer '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Notifications__Settings,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here.')
									]))
							])),
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						model.DF ? $author$project$Components$Admin$NotificationSetting$Customize$viewToogleVariables(model.op) : _List_fromArray(
							[$author$project$Utils$Html$empty])),
						model.op ? A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (liquidVariable) {
										return A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(liquidVariable)
												]));
									},
									$author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.UN)))
							])) : $author$project$Utils$Html$empty
					])),
			model);
	}
};
var $author$project$Ui$Icon$Back = 43;
var $author$project$Components$Admin$NotificationSetting$Customize$Edit = {$: 5};
var $author$project$Ui$Icon$Email = 11;
var $author$project$Ui$Icon$Forward = 44;
var $author$project$Components$Admin$NotificationSetting$Customize$Preview = {$: 2};
var $author$project$Components$Admin$NotificationSetting$Customize$Reset = {$: 4};
var $author$project$Components$Admin$NotificationSetting$Customize$Save = {$: 6};
var $author$project$Components$Admin$NotificationSetting$Customize$Test = {$: 3};
var $author$project$Ui$Button$Danger = 5;
var $author$project$Ui$Button$danger = $author$project$Ui$Button$Styled(5);
var $author$project$Components$Admin$NotificationSetting$Customize$viewModalFooter = function (model) {
	var _v0 = model.afU;
	if (_v0.$ === 3) {
		var loading = model.n7;
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Close the modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Edit)
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 43),
						$elm$html$Html$text('Back')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Save email'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$submit,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Save),
						$author$project$Ui$Button$loading(loading)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Save Email')
					]))
			]);
	} else {
		var testLoading = function () {
			var _v1 = model.ks;
			if (_v1.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var loading = model.n7;
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Reset to default version'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Reset),
						$author$project$Ui$Button$loading(loading),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
						$author$project$Ui$Button$sm
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Reset to Default Version')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Send Me a Test Copy'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Test),
						$author$project$Ui$Button$loading(testLoading),
						$author$project$Ui$Button$sm
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 11),
						$elm$html$Html$text(' Send Me a Test Copy')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Preview and save'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Preview),
						$author$project$Ui$Button$loading(loading),
						$author$project$Ui$Button$sm
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 44),
						$elm$html$Html$text(' Preview & Save')
					]))
			]);
	}
};
var $author$project$Components$Admin$NotificationSetting$Customize$viewModal = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$NotificationSetting$Customize$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						$author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml(model.UN))
					])),
				$author$project$Ui$Modal$body(
				$author$project$Components$Admin$NotificationSetting$Customize$viewModalBody(model)),
				$author$project$Ui$Modal$footer(
				$author$project$Components$Admin$NotificationSetting$Customize$viewModalFooter(model))
			]));
};
var $author$project$Components$Admin$NotificationSetting$Customize$modal = function (model) {
	return model.U9 ? $author$project$Components$Admin$NotificationSetting$Customize$viewModal(model) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$NotificationSetting$Toggle$ToggleNotificationSetting = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ToggleSwitch$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$ToggleSwitch$disabled = $author$project$Ui$ToggleSwitch$Disabled;
var $author$project$Ui$ToggleSwitch$On = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ToggleSwitch$on = $author$project$Ui$ToggleSwitch$On;
var $author$project$Ui$ToggleSwitch$OnChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$ToggleSwitch$onChange = $author$project$Ui$ToggleSwitch$OnChange;
var $author$project$Ui$SvgIcon$Check = 44;
var $author$project$Ui$ToggleSwitch$defaultOptions = {EB: _List_Nil, dW: false, rD: false, ahx: $elm$core$Maybe$Nothing};
var $author$project$Ui$ToggleSwitch$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var bool = option.a;
						return _Utils_update(
							record,
							{rD: bool});
					case 1:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								ahx: $elm$core$Maybe$Just(toMsg)
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{dW: bool});
					default:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'toggle--sm', record.EB)
							});
				}
			}),
		$author$project$Ui$ToggleSwitch$defaultOptions,
		options);
};
var $author$project$Utils$Bool$toString = function (bool) {
	return bool ? 'true' : 'false';
};
var $author$project$Ui$ToggleSwitch$view = function (options) {
	var optionsRecord = $author$project$Ui$ToggleSwitch$optionsToRecord(options);
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'role', 'switch'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-checked',
				$author$project$Utils$Bool$toString(optionsRecord.rD)),
				$elm$html$Html$Attributes$class('toggle'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('toggle--disabled', optionsRecord.dW)
					])),
				$elm$html$Html$Attributes$class(
				A2($elm$core$String$join, ' ', optionsRecord.EB))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('checkbox'),
						$elm$html$Html$Attributes$checked(optionsRecord.rD),
						$elm$html$Html$Attributes$disabled(optionsRecord.dW),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$Attributes$class(''),
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onCheck, optionsRecord.ahx))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggle__background')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$SvgIcon$view,
						_List_fromArray(
							[
								$author$project$Ui$SvgIcon$class('toggle__icon')
							]),
						44),
						A2(
						$author$project$Ui$SvgIcon$view,
						_List_fromArray(
							[
								$author$project$Ui$SvgIcon$class('toggle__icon')
							]),
						46)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggle__knob')
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$NotificationSetting$Toggle$view = function (_v0) {
	var model = _v0;
	return model.xK.NH(model.UN) ? $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(model.Ot),
				$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$NotificationSetting$Toggle$ToggleNotificationSetting),
				$author$project$Ui$ToggleSwitch$disabled(
				_Utils_eq(model.so, $author$project$Api$Data$Loading))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting = F2(
	function (model, id) {
		var _v0 = A2($elm$core$Dict$get, id, model.a9);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var notificationSetting = _v1.a;
			var customizeNotification = _v1.b;
			var toggleNotification = _v1.c;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg, id, toggleNotification),
					$author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification)),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(notificationSetting),
					$author$project$Components$Admin$NotificationSetting$Customize$button(customizeNotification)),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(notificationSetting),
					$author$project$Components$Admin$NotificationSetting$Customize$modal(customizeNotification))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Spinner$view(_List_Nil)
						]))
				]);
		}
	});
var $author$project$Pages$Admin$AdvanceBilling$viewAutopayTable = function (model) {
	return A4(
		$author$project$Ui$Table$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Billing Period')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create & Notify')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Schedule Payment In Advance')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Email Notifications')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Monthly')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays(model.WF)))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays(model.WF)))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_monthly_autopay_invoice_generated')),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Edit'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										A2($author$project$Pages$Admin$AdvanceBilling$Edit, 0, 0)),
										$author$project$Ui$Button$pull(1),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Quarterly, Semi-Annual, Annual')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays(model.WF)))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays(model.WF)))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_non_monthly_autopay_invoice_generated')),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Edit'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										A2($author$project$Pages$Admin$AdvanceBilling$Edit, 0, 1)),
										$author$project$Ui$Button$pull(1),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							]))
					]))
			]),
		_List_Nil);
};
var $author$project$Pages$Admin$AdvanceBilling$Save = {$: 3};
var $author$project$Ui$Margin$Bottom_2 = 5;
var $author$project$Ui$Alert$Margin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Alert$mb2 = $author$project$Ui$Alert$Margin(5);
var $author$project$Ui$Modal$OnSubmit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Modal$onSubmit = $author$project$Ui$Modal$OnSubmit;
var $author$project$Ui$Clearfix$view = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[$author$project$Ui$Clearfix$toClass]),
	_List_Nil);
var $author$project$Ui$Alert$Warning = 2;
var $author$project$Ui$Alert$warning = $author$project$Ui$Alert$view(2);
var $author$project$Components$Admin$CreateEditModal$modal = F2(
	function (_v0, formGroups) {
		var label = _v0.aej;
		var maybeId = _v0.Tv;
		var onClose = _v0.U_;
		var onSave = _v0.U0;
		var loading = _v0.S_;
		var maybeUpdateWarning = _v0.Tw;
		var helpText = _v0.Qn;
		var updating = function () {
			if (maybeId.$ === 1) {
				return false;
			} else {
				return true;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit(
					onSave(maybeId))
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(
							updating ? ('Edit ' + label) : ('New ' + label)),
							function () {
							if (!helpText.$) {
								var helpText_ = helpText.a;
								return A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(helpText_)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							var _v2 = _Utils_Tuple2(maybeUpdateWarning, updating);
							if ((!_v2.a.$) && _v2.b) {
								var updateWarning = _v2.a.a;
								return A2(
									$author$project$Ui$Alert$warning,
									_List_fromArray(
										[$author$project$Ui$Alert$mb2]),
									_List_fromArray(
										[
											$elm$html$Html$text(updateWarning)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-horizontal')
								]),
							formGroups),
							$author$project$Ui$Clearfix$view
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(onClose)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Save ' + label},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$submit
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDays = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDays = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDays = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDays = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Input$addon = $elm$html$Html$span(
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('input-group__addon')
		]));
var $author$project$Ui$Form$Input$Number = {$: 2};
var $author$project$Ui$Form$Input$number = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Number);
var $author$project$Ui$Typography$Bold = 3;
var $author$project$Ui$Typography$Decoration = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Typography$bold = $author$project$Ui$Typography$Decoration(3);
var $author$project$Ui$Typography$Italic = 2;
var $author$project$Ui$Typography$italic = $author$project$Ui$Typography$Decoration(2);
var $author$project$Ui$Typography$span = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$span,
			$author$project$Ui$Typography$optionsToAttributes(options),
			content);
	});
var $author$project$Pages$Admin$AdvanceBilling$viewPendingMessage = F2(
	function (frequency, days) {
		var label = function () {
			if (!frequency) {
				return 'Monthly';
			} else {
				return 'Quarterly, Semi-Annual, Annual';
			}
		}();
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$small]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_fromArray(
						[$author$project$Ui$Typography$italic]),
					_List_fromArray(
						[
							$elm$html$Html$text('Pending: ')
						])),
					$elm$html$Html$text('Starting tonight, your '),
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$bold]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
					$elm$html$Html$text(' patients will have invoices generated '),
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$bold]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2($elm$core$Maybe$map, $author$project$Formatters$Int$toDays, days)))
						])),
					$elm$html$Html$text(' in advance')
				]));
	});
var $author$project$Pages$Admin$AdvanceBilling$viewAutopayFields = F2(
	function (frequency, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			if (!frequency) {
				return _Utils_Tuple3(fields.agE, $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDays, 2);
			} else {
				return _Utils_Tuple3(fields.agF, $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDays, 3);
			}
		}();
		var scheduleValue = _v0.a;
		var scheduleField = _v0.b;
		var scheduleValidationGroup = _v0.c;
		var _v2 = function () {
			if (!frequency) {
				return _Utils_Tuple3(fields.abz, $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDays, 0);
			} else {
				return _Utils_Tuple3(fields.abB, $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDays, 1);
			}
		}();
		var createValue = _v2.a;
		var createField = _v2.b;
		var createValidationGroup = _v2.c;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(5),
						$author$project$Ui$Form$Group$inputSpan(7),
						$author$project$Ui$Form$Group$label('Create & Notify')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, createValue))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, createField))
									])),
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('days')
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, createValidationGroup, form)),
						A2($author$project$Pages$Admin$AdvanceBilling$viewPendingMessage, frequency, createValue)
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(5),
						$author$project$Ui$Form$Group$inputSpan(7),
						$author$project$Ui$Form$Group$label('Schedule Payment In Advance')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, scheduleValue))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, scheduleField))
									])),
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('days')
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, scheduleValidationGroup, form))
					]))
			]);
	});
var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDays = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDays = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$AdvanceBilling$viewNonAutopayFields = F2(
	function (frequency, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			if (!frequency) {
				return _Utils_Tuple3(fields.abA, $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDays, 4);
			} else {
				return _Utils_Tuple3(fields.abC, $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDays, 5);
			}
		}();
		var value = _v0.a;
		var field = _v0.b;
		var validationGroup = _v0.c;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(5),
						$author$project$Ui$Form$Group$inputSpan(7),
						$author$project$Ui$Form$Group$label('Invoice & Notification Lead Time')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, field))
									])),
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('days')
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
						A2($author$project$Pages$Admin$AdvanceBilling$viewPendingMessage, frequency, value)
					]))
			]);
	});
var $author$project$Pages$Admin$AdvanceBilling$viewEditModal = F2(
	function (form, saveRequest) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Invoicing Ahead of Time',
			S_: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(''),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$AdvanceBilling$CancelEdit,
			U0: $elm$core$Basics$always($author$project$Pages$Admin$AdvanceBilling$Save)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var type_ = _v0.ahI;
		var frequency = _v0.qH;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			function () {
				if (!type_) {
					return A2($author$project$Pages$Admin$AdvanceBilling$viewAutopayFields, frequency, form);
				} else {
					return A2($author$project$Pages$Admin$AdvanceBilling$viewNonAutopayFields, frequency, form);
				}
			}());
	});
var $author$project$Pages$Admin$AdvanceBilling$NonAutopay = 1;
var $author$project$Pages$Admin$AdvanceBilling$viewNonAutopayTable = function (model) {
	return A4(
		$author$project$Ui$Table$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Billing Period')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create & Notify')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_Nil),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Email Notifications')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Monthly')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays(model.WF)))
							])),
						A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_monthly_non_autopay_invoice_generated')),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Edit'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										A2($author$project$Pages$Admin$AdvanceBilling$Edit, 1, 0)),
										$author$project$Ui$Button$pull(1),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Quarterly, Semi-Annual, Annual')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Int$toDays(
									$author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays(model.WF)))
							])),
						A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_non_monthly_non_autopay_invoice_generated')),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Edit'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										A2($author$project$Pages$Admin$AdvanceBilling$Edit, 1, 1)),
										$author$project$Ui$Button$pull(1),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							]))
					]))
			]),
		_List_Nil);
};
var $author$project$Pages$Admin$AdvanceBilling$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.w;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var form = _v1.a;
					var updateRequest = _v1.b;
					return A2($author$project$Pages$Admin$AdvanceBilling$viewEditModal, form, updateRequest);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Invoicing Ahead of Time')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text('We will create invoices and notify your members before their bill date, unless they have already been billed. You can specify the lead time (in days) before invoicing below. Any changes you make will take effect tonight during our nightly billing run.')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('For Autopay Members')
											]))
									])),
								$author$project$Pages$Admin$AdvanceBilling$viewAutopayTable(model)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('For Autopay Disabled Members')
											]))
									])),
								$author$project$Pages$Admin$AdvanceBilling$viewNonAutopayTable(model)
							]))
					]))
			]),
		$G: 'Admin | Advance Billing'
	};
};
var $author$project$Pages$Admin$AdvanceBilling$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$AdvanceBilling$init, aer: $author$project$Pages$Admin$AdvanceBilling$load, agD: $author$project$Pages$Admin$AdvanceBilling$save, ahd: $author$project$Pages$Admin$AdvanceBilling$subscriptions, aaq: $author$project$Pages$Admin$AdvanceBilling$update, ahP: $author$project$Pages$Admin$AdvanceBilling$view});
var $author$project$Components$Admin$Athena$StepHeader$Fields = 3;
var $author$project$Pages$Admin$Athenahealth$Fields$GotAthena = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Admin$Athena$StepHeader$init = function (currentStep) {
	return {EP: currentStep, dX: $elm$core$Maybe$Nothing};
};
var $author$project$Api$Provider$Integration$Athena$athenaPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['athena_configuration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$AthenaConfiguration$One$AthenaConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$AthenaConfiguration$Shared$AthenaConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$AthenaConfiguration$Shared$Record = F8(
	function (status, allowNewPatientCreation, athenaPracticeName, athenaPracticeId, athenaProviderGroupId, scopedByProviderGroup, setupSubstate, ignoredFields) {
		return {IX: allowNewPatientCreation, Js: athenaPracticeId, Jt: athenaPracticeName, Ju: athenaProviderGroupId, QM: ignoredFields, Zb: scopedByProviderGroup, ZG: setupSubstate, ag7: status};
	});
var $author$project$Api$Provider$AthenaConfiguration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ignored_fields',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'setup_substate',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'scoped_by_provider_group',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'athena_provider_group_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'athena_practice_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'athena_practice_name',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'allow_new_patient_creation',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$AthenaConfiguration$Shared$Record)))))))));
var $author$project$Api$Provider$AthenaConfiguration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AthenaConfiguration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AthenaConfiguration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AthenaConfiguration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
	});
var $author$project$Pages$Admin$Athenahealth$Fields$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				k1: $author$project$Api$Data$Loading,
				k2: $author$project$Api$Data$NotAsked,
				cA: _List_Nil,
				jY: $author$project$Api$Data$NotAsked,
				ki: $author$project$Components$Admin$Athena$StepHeader$init(3)
			},
			A2(
				$author$project$Api$Provider$Integration$Athena$retrieve,
				shared.D5,
				$author$project$Pages$Admin$Athenahealth$Fields$GotAthena(true)));
	});
var $author$project$Pages$Admin$Athenahealth$Fields$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Fields$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$Athena$StepHeader$HiConfirmClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HiConfirm$subscribeToEscapeKeyPress = function (onClose) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(
		onClose(false));
};
var $author$project$Components$Admin$Athena$StepHeader$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Admin$Athena$StepHeader$HiConfirmClosed)),
			model.dX));
};
var $author$project$Pages$Admin$Athenahealth$Fields$subscriptions = function (_v0) {
	var stepHeader = _v0.ki;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg,
		$author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
};
var $author$project$Pages$Admin$Athenahealth$Fields$FieldMappingsUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaCustomFields = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ade;
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$externalId(shared);
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$humanName = function (_v0) {
	var record = _v0;
	return record.QD;
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$humanName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$humanName(shared);
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$CustomField$customFieldsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['custom_fields']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$CustomField$All$CustomField = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$CustomField = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$Record = F2(
	function (externalId, name) {
		return {ade: externalId, zh: name};
	});
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'external_id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$CustomField$Shared$Record)));
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$CustomField$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$CustomField$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$CustomField$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$CustomField$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$CustomField$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$CustomField$customFieldsPath));
	});
var $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaFieldMappings = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$FieldMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$FieldMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$Record = F3(
	function (id, humanName, externalId) {
		return {ade: externalId, QD: humanName, adR: id};
	});
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'human_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['field_mappings']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$FieldMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath));
	});
var $author$project$Pages$Admin$Athenahealth$Fields$fetchCustomFieldsData = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{k2: $author$project$Api$Data$Loading, cA: _List_Nil}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$Integration$Athena$CustomField$list, model.D5, $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaCustomFields),
					A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, model.D5, $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaFieldMappings)
				])));
};
var $author$project$Components$Admin$Athena$StepHeader$Initial = 0;
var $author$project$Components$Admin$Athena$StepHeader$Link = 1;
var $author$project$Components$Admin$Athena$StepHeader$Locations = 2;
var $author$project$Components$Admin$Athena$StepHeader$Overview = 5;
var $author$project$Components$Admin$Athena$StepHeader$Providers = 4;
var $author$project$Components$Admin$Athena$StepHeader$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5]);
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $author$project$Components$Admin$Athena$StepHeader$stepIndex = function (step_) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (currentStep_) {
				return _Utils_eq(step_, currentStep_);
			},
			$author$project$Components$Admin$Athena$StepHeader$all));
};
var $author$project$Components$Admin$Athena$StepHeader$canGoToStep = F2(
	function (step, setupSubstateStep) {
		return _Utils_cmp(
			$author$project$Components$Admin$Athena$StepHeader$stepIndex(step),
			$author$project$Components$Admin$Athena$StepHeader$stepIndex(setupSubstateStep)) < 0;
	});
var $author$project$Api$Provider$AthenaConfiguration$Shared$setupSubstate = function (_v0) {
	var record = _v0;
	return record.ZG;
};
var $author$project$Api$Provider$AthenaConfiguration$One$setupSubstate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$setupSubstate(shared);
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$AthenaConfiguration$One$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$status(shared);
};
var $author$project$Components$Admin$Athena$StepHeader$stepRoute = function (step) {
	switch (step) {
		case 0:
			return $author$project$Spa$Generated$Route$Admin__Athenahealth__Top;
		case 1:
			return $author$project$Spa$Generated$Route$Admin__Athenahealth__Link;
		case 2:
			return $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations;
		case 3:
			return $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields;
		case 4:
			return $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers;
		default:
			return $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview;
	}
};
var $author$project$Components$Admin$Athena$StepHeader$goToStep = F2(
	function (athenaConfiguration, step) {
		_v0$2:
		while (true) {
			switch (athenaConfiguration.$) {
				case 3:
					var athenaConfiguration_ = athenaConfiguration.a;
					if (($author$project$Api$Provider$AthenaConfiguration$One$status(athenaConfiguration_) === 'inactive') && (!(!step))) {
						return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Top);
					} else {
						var setupSubstateStep = function () {
							var _v1 = $author$project$Api$Provider$AthenaConfiguration$One$setupSubstate(athenaConfiguration_);
							switch (_v1) {
								case 'link_practice':
									return 1;
								case 'locations_mapping':
									return 2;
								case 'fields_mapping':
									return 3;
								case 'providers_mapping':
									return 4;
								case 'completed':
									return 5;
								default:
									return 5;
							}
						}();
						return (($author$project$Api$Provider$AthenaConfiguration$One$status(athenaConfiguration_) !== 'inactive') && ((!step) && (!_Utils_eq(step, setupSubstateStep)))) ? A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Components$Admin$Athena$StepHeader$stepRoute(setupSubstateStep)) : (((step === 1) && (!_Utils_eq(step, setupSubstateStep))) ? A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Components$Admin$Athena$StepHeader$stepRoute(setupSubstateStep)) : ((A2($author$project$Components$Admin$Athena$StepHeader$canGoToStep, step, setupSubstateStep) && (!_Utils_eq(step, setupSubstateStep))) ? $elm$core$Platform$Cmd$none : A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Components$Admin$Athena$StepHeader$stepRoute(setupSubstateStep))));
					}
				case 2:
					if (athenaConfiguration.a.$ === 5) {
						var _v2 = athenaConfiguration.a;
						return (!(!step)) ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Top) : $elm$core$Platform$Cmd$none;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Pages$Admin$Athenahealth$Fields$setIntegration = F3(
	function (athenaConfiguration, fetchCustomFields, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (cmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 3)
						]));
			},
			(fetchCustomFields ? $author$project$Pages$Admin$Athenahealth$Fields$fetchCustomFieldsData : function (model_) {
				return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
			})(
				_Utils_update(
					model,
					{k1: athenaConfiguration})));
	});
var $author$project$Api$Data$put = $author$project$Api$Data$makeRequest('put');
var $author$project$Api$Provider$Integration$Athena$FieldMapping$update = F3(
	function (apiClient, fieldMappings, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'field_mappings',
					A2(
						$elm$json$Json$Encode$list,
						function (fieldMapping) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(fieldMapping.adR)),
										_Utils_Tuple2(
										'external_id',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMapping.ade))
									]));
						},
						fieldMappings))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath)));
	});
var $author$project$Components$Admin$Athena$StepHeader$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Data$delete = $author$project$Api$Data$makeRequest('delete');
var $author$project$Api$Provider$Integration$Athena$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
	});
var $author$project$Components$Admin$Athena$StepHeader$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dX: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dX: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
						}),
					A2($author$project$Api$Provider$Integration$Athena$delete, apiClient, $author$project$Components$Admin$Athena$StepHeader$Disabled),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{dX: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dX: $elm$core$Maybe$Nothing}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration has been disabled.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dX: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $elm_community$list_extra$List$Extra$updateIf = F3(
	function (predicate, update, list) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return predicate(item) ? update(item) : item;
			},
			list);
	});
var $author$project$Pages$Admin$Athenahealth$Fields$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var fetchCustomFields = msg.a;
				var response = msg.b;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A3($author$project$Pages$Admin$Athenahealth$Fields$setIntegration, response, fetchCustomFields, model));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A3($author$project$Pages$Admin$Athenahealth$Fields$setIntegration, response, fetchCustomFields, model));
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k2: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var athenaFieldMappings = response.a;
					var fieldMappings = A2(
						$elm$core$List$map,
						function (athenaFieldMapping) {
							return {
								ade: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId(athenaFieldMapping),
								adR: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$id(athenaFieldMapping),
								zh: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$humanName(athenaFieldMapping)
							};
						},
						athenaFieldMappings);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cA: fieldMappings}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cA: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Integration$Athena$FieldMapping$update,
						model.D5,
						A2(
							$elm$core$List$map,
							function (athenaFieldMapping) {
								return {ade: athenaFieldMapping.ade, adR: athenaFieldMapping.adR};
							},
							model.cA),
						$author$project$Pages$Admin$Athenahealth$Fields$FieldMappingsUpdated),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k2: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$CustomField$list, model.D5, $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaCustomFields),
					_List_Nil);
			case 6:
				var athenaFieldMapping = msg.a;
				var athenaFieldId = msg.b;
				var athenaFieldMappings = A3(
					$elm_community$list_extra$List$Extra$updateIf,
					function (fieldMapping) {
						return _Utils_eq(fieldMapping.adR, athenaFieldMapping.adR);
					},
					function (fieldMapping) {
						return _Utils_update(
							fieldMapping,
							{
								ade: $author$project$Utils$String$toMaybe(athenaFieldId)
							});
					},
					model.cA);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cA: athenaFieldMappings}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v5 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.D5, subMsg, model.ki);
				var stepHeader = _v5.a;
				var subCmd = _v5.b;
				var subOutMsg = _v5.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ki: stepHeader}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Athenahealth$Fields$CompleteFields = {$: 3};
var $author$project$Ui$Form$Autocomplete = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$autocomplete = $author$project$Ui$Form$Autocomplete;
var $author$project$Components$HiConfirm$CustomMessage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HiConfirm$customMessage = $author$project$Components$HiConfirm$CustomMessage;
var $author$project$Components$HiConfirm$Loading = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$HiConfirm$loading = $author$project$Components$HiConfirm$Loading;
var $author$project$Components$HiConfirm$defaultOptions = {vM: $elm$core$Maybe$Nothing, vY: true, w_: $elm$core$Maybe$Nothing, w$: $elm$core$Maybe$Nothing, xa: $elm$core$Maybe$Nothing, S_: false, zB: $elm$core$Maybe$Nothing, Ca: $elm$core$Maybe$Nothing, Cf: true, Dt: true, aaO: $elm$core$Maybe$Nothing};
var $author$project$Components$HiConfirm$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{
								aaO: $elm$core$Maybe$Just(string)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								zB: $elm$core$Maybe$Just(string)
							});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{
								w_: $elm$core$Maybe$Just(string)
							});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{Dt: bool});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{vY: bool});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{
								xa: $elm$core$Maybe$Just(string)
							});
					case 6:
						var string = option.a;
						return _Utils_update(
							record,
							{
								Ca: $elm$core$Maybe$Just(string)
							});
					case 7:
						var bool = option.a;
						return _Utils_update(
							record,
							{S_: bool});
					case 8:
						var string = option.a;
						return _Utils_update(
							record,
							{
								w$: $elm$core$Maybe$Just(string)
							});
					case 9:
						var bool = option.a;
						return _Utils_update(
							record,
							{Cf: bool});
					default:
						var buttonStyle_ = option.a;
						return _Utils_update(
							record,
							{
								vM: $elm$core$Maybe$Just(buttonStyle_)
							});
				}
			}),
		$author$project$Components$HiConfirm$defaultOptions,
		options);
};
var $elm_community$string_extra$String$Extra$regexFromString = A2(
	$elm$core$Basics$composeR,
	$elm$regex$Regex$fromString,
	$elm$core$Maybe$withDefault($elm$regex$Regex$never));
var $elm$core$String$toLower = _String_toLower;
var $elm_community$string_extra$String$Extra$changeCase = F2(
	function (mutator, word) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var head = _v0.a;
					var tail = _v0.b;
					return A2(
						$elm$core$String$cons,
						mutator(head),
						tail);
				},
				$elm$core$String$uncons(word)));
	});
var $elm$core$Char$toUpper = _Char_toUpper;
var $elm_community$string_extra$String$Extra$toSentenceCase = function (word) {
	return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
};
var $elm_community$string_extra$String$Extra$humanize = function (string) {
	return $elm_community$string_extra$String$Extra$toSentenceCase(
		$elm$core$String$toLower(
			$elm$core$String$trim(
				A3(
					$elm$regex$Regex$replace,
					$elm_community$string_extra$String$Extra$regexFromString('_id$|[-_\\s]+'),
					$elm$core$Basics$always(' '),
					A3(
						$elm$regex$Regex$replace,
						$elm_community$string_extra$String$Extra$regexFromString('[A-Z]+'),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.aex;
							},
							$elm$core$String$append('-')),
						string)))));
};
var $elm_community$string_extra$String$Extra$toTitleCase = function (ws) {
	var uppercaseMatch = A2(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('\\w+'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aex;
			},
			$elm_community$string_extra$String$Extra$toSentenceCase));
	return A3(
		$elm$regex$Regex$replace,
		$elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'),
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.aex;
			},
			uppercaseMatch),
		ws);
};
var $author$project$Formatters$String$titleize = A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$humanize, $elm_community$string_extra$String$Extra$toTitleCase);
var $author$project$Components$HiConfirm$viewMessage = F4(
	function (maybeVerb, maybeProcessedNoun, maybeDetail, maybeSentence) {
		var _v0 = _Utils_Tuple2(maybeVerb, maybeProcessedNoun);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var verb_ = _v0.a.a;
			var processedNoun = _v0.b.a;
			var _v1 = _Utils_Tuple2(maybeDetail, maybeSentence);
			if (!_v1.a.$) {
				if (_v1.b.$ === 1) {
					var detail_ = _v1.a.a;
					var _v4 = _v1.b;
					return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' ' + (processedNoun + ('  ' + (detail_ + '.'))))));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				if (_v1.b.$ === 1) {
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' this ' + (processedNoun + '.'))));
				} else {
					var _v5 = _v1.a;
					var sentence_ = _v1.b.a;
					return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' ' + (processedNoun + ('. ' + sentence_)))));
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$HiConfirm$viewBody = F2(
	function (processedNoun, options) {
		var alignment = options.vY ? _List_fromArray(
			[
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			$author$project$Api$Phi$displayAttr,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					alignment,
					function () {
						var _v0 = options.w_;
						if (!_v0.$) {
							var customMessage_ = _v0.a;
							return A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$never),
								customMessage_);
						} else {
							return $elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v1 = A4($author$project$Components$HiConfirm$viewMessage, options.aaO, processedNoun, options.xa, options.Ca);
										if (!_v1.$) {
											var message = _v1.a;
											return _List_fromArray(
												[
													$elm$html$Html$text(message),
													$author$project$Utils$Html$noBreakSpace
												]);
										} else {
											return _List_Nil;
										}
									}(),
										_List_fromArray(
										[
											$elm$html$Html$text('This action cannot be undone.')
										])
									]));
						}
					}())
				]));
	});
var $author$project$Ui$Button$Success = 3;
var $author$project$Ui$Button$Warning = 4;
var $author$project$Components$HiConfirm$calculatebuttonStyle = function (maybeVerb) {
	if (maybeVerb.$ === 1) {
		return 1;
	} else {
		var verb_ = maybeVerb.a;
		switch (verb_) {
			case 'remove':
				return 5;
			case 'deactivate':
				return 5;
			case 'delete':
				return 5;
			case 'disable':
				return 5;
			case 'destroy':
				return 5;
			case 'void':
				return 5;
			case 'mark':
				return 5;
			case 'unlock':
				return 4;
			case 'unenroll':
				return 5;
			case 'approve':
				return 3;
			case 'merge':
				return 5;
			case 'enroll':
				return 4;
			case 'end':
				return 5;
			case 'clear':
				return 5;
			case 'archive':
				return 5;
			case 'cancel':
				return 5;
			default:
				return 1;
		}
	}
};
var $author$project$Ui$Button$FullWidth = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Button$fullWidth = $author$project$Ui$Button$FullWidth;
var $author$project$Ui$FlexGrid$Empty = {$: 0};
var $author$project$Ui$FlexGrid$none = $author$project$Ui$FlexGrid$Empty;
var $author$project$Ui$FlexGrid$Offset = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$FlexGrid$offset = $author$project$Ui$FlexGrid$Offset(0);
var $author$project$Components$HiConfirm$viewFooter = F6(
	function (maybeVerb, processedNoun, loading_, showCancelButton, buttonStyle_, onClose) {
		var verb_ = A2($elm$core$Maybe$withDefault, 'confirm', maybeVerb);
		var confirmButtonColOptions = showCancelButton ? _List_fromArray(
			[
				$author$project$Ui$FlexGrid$span(6)
			]) : _List_fromArray(
			[
				$author$project$Ui$FlexGrid$span(6),
				$author$project$Ui$FlexGrid$offset(3)
			]);
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					showCancelButton ? A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel action'},
							_List_fromArray(
								[
									$author$project$Ui$Button$fullWidth(true),
									$author$project$Ui$Button$onClick(
									onClose(false))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						])) : $author$project$Ui$FlexGrid$none,
					A2(
					$author$project$Ui$FlexGrid$column,
					confirmButtonColOptions,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{
								abp: $author$project$Formatters$String$titleize(verb_) + (' ' + A2($elm$core$Maybe$withDefault, '', processedNoun))
							},
							_List_fromArray(
								[
									$author$project$Ui$Button$fullWidth(true),
									$author$project$Ui$Button$styled(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Components$HiConfirm$calculatebuttonStyle(maybeVerb),
										buttonStyle_)),
									$author$project$Ui$Button$loading(loading_),
									$author$project$Ui$Button$onClick(
									onClose(true))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$titleize(verb_) + (' ' + A2($elm$core$Maybe$withDefault, '', processedNoun)))
								]))
						]))
				]));
	});
var $author$project$Components$HiConfirm$viewHeader = F3(
	function (maybeCustomTitle, mayberVerb, maybeProcessedNoun) {
		var header = function () {
			if (!maybeCustomTitle.$) {
				var title = maybeCustomTitle.a;
				return title;
			} else {
				var _v1 = _Utils_Tuple2(mayberVerb, maybeProcessedNoun);
				if (!_v1.a.$) {
					if (_v1.b.$ === 1) {
						var verb_ = _v1.a.a;
						var _v2 = _v1.b;
						return $author$project$Formatters$String$titleize(verb_);
					} else {
						var verb_ = _v1.a.a;
						var processedNoun = _v1.b.a;
						return $author$project$Formatters$String$titleize(verb_) + (' ' + processedNoun);
					}
				} else {
					return 'Please Confirm';
				}
			}
		}();
		return $author$project$Ui$Typography$headingSm(
			_List_fromArray(
				[
					$elm$html$Html$text(header)
				]));
	});
var $author$project$Components$HiConfirm$modal = F2(
	function (onClose, options) {
		var optionsRecord = $author$project$Components$HiConfirm$optionsToRecord(options);
		var processedNoun = function () {
			var _v0 = _Utils_Tuple2(optionsRecord.Dt, optionsRecord.zB);
			_v0$2:
			while (true) {
				if (_v0.a) {
					if (!_v0.b.$) {
						var noun_ = _v0.b.a;
						return $elm$core$Maybe$Just(
							$author$project$Formatters$String$titleize(noun_));
					} else {
						break _v0$2;
					}
				} else {
					if (!_v0.b.$) {
						var noun_ = _v0.b.a;
						return $elm$core$Maybe$Just(noun_);
					} else {
						break _v0$2;
					}
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		return A3(
			$author$project$Ui$Modal$view,
			onClose(false),
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							A3($author$project$Components$HiConfirm$viewHeader, optionsRecord.w$, optionsRecord.aaO, processedNoun)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2($author$project$Components$HiConfirm$viewBody, processedNoun, optionsRecord)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A6($author$project$Components$HiConfirm$viewFooter, optionsRecord.aaO, processedNoun, optionsRecord.S_, optionsRecord.Cf, optionsRecord.vM, onClose)
						]))
				]));
	});
var $author$project$Components$Admin$Athena$StepHeader$modal = function (model) {
	var _v0 = model.dX;
	if (!_v0.$) {
		var disablingRequest = _v0.a;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Admin$Athena$StepHeader$HiConfirmClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text('Please confirm you would like to deactivate the athenahealth integration.')
						])),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(disablingRequest, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Form$NoValidate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$noValidate = $author$project$Ui$Form$NoValidate;
var $author$project$Ui$Padding$Left_0 = 1;
var $author$project$Ui$Margin$Top_1 = 21;
var $author$project$Components$Admin$Athena$StepHeader$inBreadcrumbsAs = function (step) {
	switch (step) {
		case 0:
			return '';
		case 1:
			return 'Connect Account';
		case 2:
			return 'Match Locations to Departments';
		case 3:
			return 'Match Custom Fields';
		case 4:
			return 'Match Providers';
		default:
			return 'Overview';
	}
};
var $author$project$Ui$HorizontalBreadcrumb$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$HorizontalBreadcrumb$item = $author$project$Ui$HorizontalBreadcrumb$Item;
var $author$project$Ui$Form$Group$LabelClass = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Group$labelClass = $author$project$Ui$Form$Group$LabelClass;
var $author$project$Ui$Form$Group$Html = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Skeleton$TextSpan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Skeleton$spanFromText = $author$project$Ui$Skeleton$TextSpan;
var $author$project$Ui$Form$Group$labelSkeleton = function (text) {
	return $author$project$Ui$Form$Group$Label(
		$author$project$Ui$Form$Group$Html(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText(text)
						]))
				])));
};
var $author$project$Ui$HorizontalBreadcrumb$Margin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$HorizontalBreadcrumb$margin = $author$project$Ui$HorizontalBreadcrumb$Margin;
var $author$project$Ui$HorizontalBreadcrumb$Padding = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$HorizontalBreadcrumb$padding = $author$project$Ui$HorizontalBreadcrumb$Padding;
var $author$project$Components$Admin$Athena$StepHeader$showOnBreadcrumbs = function (step_) {
	switch (step_) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		default:
			return true;
	}
};
var $author$project$Ui$HorizontalBreadcrumb$optionToAttributes = function (option) {
	if (!option.$) {
		var margin_ = option.a;
		return _List_fromArray(
			[
				$author$project$Ui$Margin$toClass(margin_)
			]);
	} else {
		var padding_ = option.a;
		return _List_fromArray(
			[
				$author$project$Ui$Padding$toClass(padding_)
			]);
	}
};
var $author$project$Ui$HorizontalBreadcrumb$optionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$HorizontalBreadcrumb$optionToAttributes, options));
};
var $author$project$Ui$HorizontalBreadcrumb$itemOptionToAttributes = function (option) {
	if (!option.$) {
		var bool = option.a;
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('current', bool)
					]))
			]);
	} else {
		var bool = option.a;
		return _List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('disabled', bool)
					]))
			]);
	}
};
var $author$project$Ui$HorizontalBreadcrumb$itemOptionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$HorizontalBreadcrumb$itemOptionToAttributes, options));
};
var $author$project$Ui$HorizontalBreadcrumb$viewItem = function (_v0) {
	var options = _v0.a;
	var contents = _v0.b;
	return A2(
		$elm$html$Html$li,
		$author$project$Ui$HorizontalBreadcrumb$itemOptionsToAttributes(options),
		contents);
};
var $author$project$Ui$HorizontalBreadcrumb$view = F2(
	function (options, items) {
		return A2(
			$elm$html$Html$ul,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('horizontal-breadcrumb'),
				$author$project$Ui$HorizontalBreadcrumb$optionsToAttributes(options)),
			A2($elm$core$List$map, $author$project$Ui$HorizontalBreadcrumb$viewItem, items));
	});
var $author$project$Components$Admin$Athena$StepHeader$skeleton = function () {
	var stepToBreadcrumbSkeleton = A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Admin$Athena$StepHeader$inBreadcrumbsAs,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Ui$Skeleton$spanFromText,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Ui$Skeleton$text,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						$author$project$Ui$HorizontalBreadcrumb$item(_List_Nil))))));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton('Status'),
						$author$project$Ui$Form$Group$labelClass('text-left'),
						$author$project$Ui$Form$Group$labelSpanSm(1),
						$author$project$Ui$Form$Group$inputSpanSm(11)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('Inactive')
									]))
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$HorizontalBreadcrumb$view,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalBreadcrumb$margin(21),
						$author$project$Ui$HorizontalBreadcrumb$padding(1)
					]),
				A2(
					$elm$core$List$map,
					stepToBreadcrumbSkeleton,
					A2($elm$core$List$filter, $author$project$Components$Admin$Athena$StepHeader$showOnBreadcrumbs, $author$project$Components$Admin$Athena$StepHeader$all)))
			]));
}();
var $author$project$Components$Admin$Athena$StepHeader$Disable = {$: 0};
var $author$project$Components$Admin$Athena$StepHeader$stringToStep = function (string) {
	switch (string) {
		case 'link_practice':
			return $elm$core$Maybe$Just(1);
		case 'locations_mapping':
			return $elm$core$Maybe$Just(2);
		case 'fields_mapping':
			return $elm$core$Maybe$Just(3);
		case 'providers_mapping':
			return $elm$core$Maybe$Just(4);
		case 'completed':
			return $elm$core$Maybe$Just(5);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$Margin$Left_0_5 = 10;
var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeId = function (_v0) {
	var record = _v0;
	return record.Js;
};
var $author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeId(shared);
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeName = function (_v0) {
	var record = _v0;
	return record.Jt;
};
var $author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeName(shared);
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaProviderGroupId = function (_v0) {
	var record = _v0;
	return record.Ju;
};
var $author$project$Api$Provider$AthenaConfiguration$One$athenaProviderGroupId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaProviderGroupId(shared);
};
var $author$project$Ui$Typography$Margin = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Typography$margin = $author$project$Ui$Typography$Margin;
var $author$project$Components$Admin$Athena$StepHeader$viewName = function (maybeConfig) {
	if (!maybeConfig.$) {
		var config = maybeConfig.a;
		var _v1 = _Utils_Tuple2(
			$author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeName(config),
			$author$project$Api$Provider$AthenaConfiguration$One$athenaProviderGroupId(config));
		if (!_v1.a.$) {
			var name = _v1.a.a;
			var maybeProviderGroupId = _v1.b;
			var practiceId = 'Practice ID: ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeId(config));
			var groupId = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (providerGroupId) {
						return ', Provider Group ID: ' + providerGroupId;
					},
					maybeProviderGroupId));
			return A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$margin(10)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('at ' + (name + (' (' + (practiceId + (groupId + ')')))))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Badge$formatLabel = function (label) {
	switch (label) {
		case 'needs_payment_info':
			return 'no payment info';
		case 'bank_not_verified':
			return 'bank not verified';
		case 'saving':
			return 'saving...';
		case 'refund_pending':
			return 'refund processing';
		case 'refund_cancelled':
			return 'refund cancelled';
		case 'refund_actually_pending':
			return 'refund pending';
		case 'refund_successful':
			return 'refunded';
		case 'refund_failed':
			return 'refund failed';
		case 'refund_unattempted':
			return 'refund unattempted';
		case 'new_payment_source':
			return 'new';
		case 'needs_trial_deposits':
			return 'unverified';
		case 'not_redeemable':
			return 'not redeemable';
		case 'bad_debt':
			return 'bad debt';
		case 'no_payment':
			return 'no payment';
		case 'accepted_and_outdated':
			return 'out of date';
		case 'not_accepted':
			return 'not accepted';
		case 'scheduled_without_source':
			return 'scheduled';
		case 'review_data_matches':
			return 'review data matches';
		case 'review_file_size':
			return 'review file size';
		case 'enqueued_for_preprocessing':
			return 'enqueued';
		case 'enqueued_for_processing':
			return 'enqueued';
		case 'preprocessing':
			return 'processing';
		case 'postprocessing':
			return 'processing';
		case 'ready_to_preprocess':
			return 'enqueued';
		case 'ready_to_process':
			return 'ready to process';
		case 'deal_ending':
			return 'ending';
		case 'unpublished_change':
			return 'unpublished change';
		case 'failed_payment':
			return 'failed payment';
		case 'in_development':
			return 'in development';
		default:
			return label;
	}
};
var $author$project$Ui$Badge$Color = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Badge$Danger = 3;
var $author$project$Ui$Badge$danger = $author$project$Ui$Badge$Color(3);
var $author$project$Ui$Badge$Info = 1;
var $author$project$Ui$Badge$info = $author$project$Ui$Badge$Color(1);
var $author$project$Ui$Badge$Primary = 4;
var $author$project$Ui$Badge$primary = $author$project$Ui$Badge$Color(4);
var $author$project$Ui$Badge$Success = 2;
var $author$project$Ui$Badge$success = $author$project$Ui$Badge$Color(2);
var $author$project$Ui$Badge$Warning = 0;
var $author$project$Ui$Badge$warning = $author$project$Ui$Badge$Color(0);
var $author$project$Ui$Badge$mapColor = function (status) {
	switch (status) {
		case 'needs_payment_info':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'pending':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'downloading':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'bank_not_verified':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'successful':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'live':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'failed':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'refunded':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'retrying':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'cancelled':
			return _List_Nil;
		case 'default':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'saving':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'refund_pending':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'refund_actually_pending':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'refund_successful':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'refund_failed':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'active':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'unconfirmed':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'confirmed':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'warning':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'new_payment_source':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'needs_trial_deposits':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'invalid':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'inactive':
			return _List_Nil;
		case 'expiring':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'connected':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'requested':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'unpaid':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'paid':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'clearing':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'processing':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'redeemable':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'not_redeemable':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'viewed':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'bad_debt':
			return _List_Nil;
		case 'disputed':
			return _List_Nil;
		case 'overdue':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'sent':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'issued':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'no_payment':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'missing':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'accepted':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'accepted_and_outdated':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'not_accepted':
			return _List_Nil;
		case 'none':
			return _List_Nil;
		case 'scheduled':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'scheduled_without_source':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'in transit':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'completed':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'enabled':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'synced':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'unsynced':
			return _List_Nil;
		case 'errored':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'opened':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'error':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'processed':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'review_data_matches':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'review_file_size':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'enqueued_for_preprocessing':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'enqueued_for_processing':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'preprocessing':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'postprocessing':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'ready_to_preprocess':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'ready_to_process':
			return _List_fromArray(
				[$author$project$Ui$Badge$primary]);
		case 'payable':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'deal_ending':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'published':
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 'unpublished':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'unpublished_change':
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 'upcoming':
			return _List_fromArray(
				[$author$project$Ui$Badge$info]);
		case 'failed_payment':
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		case 'in_development':
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Ui$Badge$optionToAttr = function (option) {
	switch (option.$) {
		case 0:
			return $elm$html$Html$Attributes$class('badge--inline');
		case 1:
			return $elm$html$Html$Attributes$class('badge--lg');
		case 2:
			return $elm$html$Html$Attributes$class('badge--sm');
		case 5:
			return $elm$html$Html$Attributes$class('mr-2');
		case 3:
			var testString = option.a;
			return $author$project$Utils$Html$Attributes$test(testString);
		default:
			var color = option.a;
			switch (color) {
				case 0:
					return $elm$html$Html$Attributes$class('badge--warning');
				case 1:
					return $elm$html$Html$Attributes$class('badge--info');
				case 2:
					return $elm$html$Html$Attributes$class('badge--success');
				case 3:
					return $elm$html$Html$Attributes$class('badge--danger');
				case 4:
					return $elm$html$Html$Attributes$class('badge--primary');
				case 5:
					return $elm$html$Html$Attributes$class('badge--neutral');
				case 6:
					return $elm$html$Html$Attributes$class('badge--accent-primary');
				default:
					return $elm$html$Html$Attributes$class('badge--accent-secondary');
			}
	}
};
var $author$project$Ui$Badge$view = F2(
	function (options, content) {
		return function (attrs) {
			return A2($elm$html$Html$span, attrs, content);
		}(
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('badge'),
				A2($elm$core$List$map, $author$project$Ui$Badge$optionToAttr, options)));
	});
var $author$project$Ui$Badge$fromString = F2(
	function (options, label) {
		return function (options_) {
			return A2(
				$author$project$Ui$Badge$view,
				options_,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Ui$Badge$formatLabel(label))
					]));
		}(
			_Utils_ap(
				options,
				$author$project$Ui$Badge$mapColor(label)));
	});
var $author$project$Components$Admin$Athena$StepHeader$viewStatus = F2(
	function (status, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelClass('text-label-md text-muted'),
					$author$project$Ui$Form$Group$labelSpanSm(1),
					$author$project$Ui$Form$Group$inputSpanSm(11)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($author$project$Ui$Badge$fromString, _List_Nil, status),
						content))
				]));
	});
var $author$project$Components$Admin$Athena$StepHeader$breadcrumbsDisabled = function (step) {
	switch (step) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		case 3:
			return false;
		case 4:
			return false;
		default:
			return false;
	}
};
var $author$project$Ui$HorizontalBreadcrumb$Current = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$HorizontalBreadcrumb$current = $author$project$Ui$HorizontalBreadcrumb$Current;
var $author$project$Ui$HorizontalBreadcrumb$Disabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$HorizontalBreadcrumb$disabled = $author$project$Ui$HorizontalBreadcrumb$Disabled;
var $author$project$Components$Admin$Athena$StepHeader$stepIsDisabled = F3(
	function (setupSubstateStep, currentStep, step) {
		var minStepIndex = (_Utils_cmp(
			$author$project$Components$Admin$Athena$StepHeader$stepIndex(currentStep),
			$author$project$Components$Admin$Athena$StepHeader$stepIndex(setupSubstateStep)) > 0) ? $author$project$Components$Admin$Athena$StepHeader$stepIndex(currentStep) : $author$project$Components$Admin$Athena$StepHeader$stepIndex(setupSubstateStep);
		return $author$project$Components$Admin$Athena$StepHeader$breadcrumbsDisabled(step) || (_Utils_cmp(
			minStepIndex,
			$author$project$Components$Admin$Athena$StepHeader$stepIndex(step)) < 0);
	});
var $author$project$Components$Admin$Athena$StepHeader$viewStepBreadcrumb = F3(
	function (setupSubstateStep, currentStep, step) {
		var isCurrent = _Utils_eq(step, currentStep);
		return A2(
			$author$project$Ui$HorizontalBreadcrumb$item,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalBreadcrumb$current(isCurrent),
					$author$project$Ui$HorizontalBreadcrumb$disabled(
					$author$project$Components$Admin$Athena$StepHeader$breadcrumbsDisabled(step))
				]),
			_List_fromArray(
				[
					(isCurrent || A3($author$project$Components$Admin$Athena$StepHeader$stepIsDisabled, setupSubstateStep, currentStep, step)) ? A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Admin$Athena$StepHeader$inBreadcrumbsAs(step))
						])) : A3(
					$author$project$Ui$Link$route,
					$author$project$Components$Admin$Athena$StepHeader$stepRoute(step),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Admin$Athena$StepHeader$inBreadcrumbsAs(step))
						]))
				]));
	});
var $author$project$Components$Admin$Athena$StepHeader$view = F2(
	function (athenahealthConfiguration, model) {
		var athenahealthConfiguration_ = $author$project$Api$Data$toMaybe(athenahealthConfiguration);
		var practiceNameAndIds = $author$project$Components$Admin$Athena$StepHeader$viewName(athenahealthConfiguration_);
		var setupSubstateStep = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Admin$Athena$StepHeader$stringToStep,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$AthenaConfiguration$One$setupSubstate, athenahealthConfiguration_)));
		var status = A2(
			$elm$core$Maybe$withDefault,
			'pending',
			A2($elm$core$Maybe$map, $author$project$Api$Provider$AthenaConfiguration$One$status, athenahealthConfiguration_));
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Components$Admin$Athena$StepHeader$viewStatus,
					status,
					_List_fromArray(
						[
							practiceNameAndIds,
							$author$project$Utils$Maybe$toBool(athenahealthConfiguration_) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Deativate integration'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Athena$StepHeader$Disable),
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$pull(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Deactivate the integration')
								])) : $author$project$Utils$Html$empty
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$HorizontalBreadcrumb$view,
					_List_fromArray(
						[
							$author$project$Ui$HorizontalBreadcrumb$margin(21),
							$author$project$Ui$HorizontalBreadcrumb$padding(1)
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Admin$Athena$StepHeader$viewStepBreadcrumb, setupSubstateStep, model.EP),
						A2($elm$core$List$filter, $author$project$Components$Admin$Athena$StepHeader$showOnBreadcrumbs, $author$project$Components$Admin$Athena$StepHeader$all))),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Pages$Admin$Athenahealth$Fields$RefreshAthenaCustomFields = {$: 5};
var $author$project$Ui$Alignment$End = 2;
var $author$project$Ui$Alignment$itemsEnd = $author$project$Ui$Alignment$Items(2);
var $author$project$Ui$Element$itemsEnd = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsEnd);
var $author$project$Ui$FlexGrid$justifyRight = $author$project$Ui$FlexGrid$Element($author$project$Ui$Element$itemsEnd);
var $author$project$Ui$SvgIcon$Repeat = 43;
var $author$project$Ui$SvgIcon$repeat = $author$project$Ui$SvgIcon$viewIcon(43);
var $author$project$Ui$ScreenSize$Lg = 3;
var $author$project$Ui$FlexGrid$spanLg = $author$project$Ui$FlexGrid$Span(3);
var $author$project$Ui$ScreenSize$Md = 2;
var $author$project$Ui$FlexGrid$spanMd = $author$project$Ui$FlexGrid$Span(2);
var $author$project$Ui$Icon$ArrowRight = 17;
var $author$project$Pages$Admin$Athenahealth$Fields$UpdateFieldMapping = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ade;
};
var $author$project$Api$Provider$Integration$Athena$CustomField$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$CustomField$Shared$externalId(shared);
};
var $author$project$Ui$Form$Select$ItemDisabled = $elm$core$Basics$identity;
var $author$project$Ui$Form$Select$itemDisabled = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Integration$Athena$CustomField$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$CustomField$Shared$name(shared);
};
var $author$project$Pages$Admin$Athenahealth$Fields$athenaCustomFieldsOptions = function (athenaCustomFields) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(true)
				]),
			$elm$core$Maybe$Nothing,
			'Choose athenahealth Custom Field'),
		A2(
			$elm$core$List$map,
			function (athenaCustomField) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Integration$Athena$CustomField$All$externalId(athenaCustomField)),
					$author$project$Api$Provider$Integration$Athena$CustomField$All$name(athenaCustomField) + (' (' + ($author$project$Api$Provider$Integration$Athena$CustomField$All$externalId(athenaCustomField) + ')')));
			},
			athenaCustomFields));
};
var $author$project$Ui$Icon$TextMuted = {$: 1};
var $author$project$Ui$Icon$textMuted = $author$project$Ui$Icon$TextMuted;
var $author$project$Pages$Admin$Athenahealth$Fields$viewAthenaFieldMapping = F2(
	function (athenaCustomFields, athenaFieldMapping) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint data point: '),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(athenaFieldMapping.zh)
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[$author$project$Ui$Icon$textMuted]),
									17)
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('athenahealth custom field: ')
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(athenaFieldMapping.ade),
											$author$project$Ui$Form$Select$onChange(
											$author$project$Pages$Admin$Athenahealth$Fields$UpdateFieldMapping(athenaFieldMapping))
										]),
									$author$project$Pages$Admin$Athenahealth$Fields$athenaCustomFieldsOptions(athenaCustomFields))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Ui$Skeleton$input = $author$project$Ui$Skeleton$view('input');
var $author$project$Ui$Skeleton$spanMd = $author$project$Ui$Skeleton$Span(2);
var $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsListSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	A2(
		$elm$core$List$repeat,
		10,
		A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Hint data point: ')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8),
											$author$project$Ui$Skeleton$spanMd(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('athenahealth custom field: ')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))));
var $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStep = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanLg(9),
								$author$project$Ui$FlexGrid$spanMd(8),
								$author$project$Ui$FlexGrid$spanSm(7)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Match Custom Fields')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We will sync information about each patient’s membership to athenahealth in custom fields.  You will need to configure these custom fields in athenahealth first, and then return to this page once complete.')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanLg(3),
								$author$project$Ui$FlexGrid$spanMd(4),
								$author$project$Ui$FlexGrid$spanSm(5),
								$author$project$Ui$FlexGrid$justifyRight
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Refresh athenahealth Custom Fields'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Fields$RefreshAthenaCustomFields),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Refresh athenahealth Custom Fields')
									]))
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				function () {
				var _v0 = model.k2;
				if (_v0.$ === 3) {
					var athenaCustomFields = _v0.a;
					return A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Admin$Athenahealth$Fields$viewAthenaFieldMapping(athenaCustomFields),
							model.cA));
				} else {
					return $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsListSkeleton;
				}
			}()
			]));
};
var $author$project$Ui$Button$Disabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Button$disabled = $author$project$Ui$Button$Disabled;
var $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStepFooter = function (model) {
	var canContinue = !A2(
		$elm$core$List$any,
		function (athenaFieldMapping) {
			return _Utils_eq(athenaFieldMapping.ade, $elm$core$Maybe$Nothing);
		},
		model.cA);
	return A2(
		$author$project$Ui$Panel$footer,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Go to next step'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Fields$CompleteFields),
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$disabled(!canContinue)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Next Step')
					]))
			]));
};
var $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStepSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(9),
							$author$project$Ui$FlexGrid$spanMd(8),
							$author$project$Ui$FlexGrid$spanSm(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Match Custom Fields')
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(11)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(3),
							$author$project$Ui$FlexGrid$spanMd(4),
							$author$project$Ui$FlexGrid$spanSm(5),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Refresh athenahealth Custom Fields')
								]))
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			$author$project$Pages$Admin$Athenahealth$Fields$viewFieldsListSkeleton
		]));
var $author$project$Pages$Admin$Athenahealth$Fields$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg,
				$author$project$Components$Admin$Athena$StepHeader$modal(model.ki)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Fields$CompleteFields)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('athenahealth')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v0 = model.k1;
									if (_v0.$ === 3) {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg,
												A2($author$project$Components$Admin$Athena$StepHeader$view, model.k1, model.ki)),
												$author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStep(model)
											]);
									} else {
										return _List_fromArray(
											[$author$project$Components$Admin$Athena$StepHeader$skeleton, $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStepSkeleton]);
									}
								}()),
								$author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStepFooter(model)
							]))
					]))
			]),
		$G: 'Integrations | Athenahealth'
	};
};
var $author$project$Pages$Admin$Athenahealth$Fields$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Athenahealth$Fields$init, aer: $author$project$Pages$Admin$Athenahealth$Fields$load, agD: $author$project$Pages$Admin$Athenahealth$Fields$save, ahd: $author$project$Pages$Admin$Athenahealth$Fields$subscriptions, aaq: $author$project$Pages$Admin$Athenahealth$Fields$update, ahP: $author$project$Pages$Admin$Athenahealth$Fields$view});
var $author$project$Pages$Admin$Athenahealth$Link$GotAthena = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Link$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				k1: $author$project$Api$Data$Loading,
				PB: $elm$core$Maybe$Nothing,
				jY: $author$project$Api$Data$NotAsked,
				ki: $author$project$Components$Admin$Athena$StepHeader$init(1)
			},
			A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.D5, $author$project$Pages$Admin$Athenahealth$Link$GotAthena));
	});
var $author$project$Pages$Admin$Athenahealth$Link$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Link$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Link$subscriptions = function (_v0) {
	var stepHeader = _v0.ki;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg,
		$author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
};
var $author$project$Pages$Admin$Athenahealth$Link$Linked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Integration$Athena$link = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'athena_integration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'athena_practice_id',
								$elm$json$Json$Encode$int(fields.Js)),
								_Utils_Tuple2(
								'athena_provider_group_id',
								$elm$json$Json$Encode$int(fields.Ju))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['link']),
						$author$project$Api$Provider$Integration$Athena$athenaPath))));
	});
var $author$project$Pages$Admin$Athenahealth$Link$createAthena = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Integration$Athena$link,
			apiClient,
			{
				Js: A2($elm$core$Maybe$withDefault, 0, fields.Js),
				Ju: A2($elm$core$Maybe$withDefault, 0, fields.Ju)
			},
			$author$project$Pages$Admin$Athenahealth$Link$Linked);
	});
var $author$project$Pages$Admin$Athenahealth$Link$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					Js: $elm$core$String$toInt(string)
				});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					Ju: $elm$core$String$toInt(string)
				});
		}
	});
var $author$project$Pages$Admin$Athenahealth$Link$AthenaPracticeIdValidation = 0;
var $author$project$Api$Provider$AthenaConfiguration$Shared$scopedByProviderGroup = function (_v0) {
	var record = _v0;
	return record.Zb;
};
var $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$scopedByProviderGroup(shared);
};
var $author$project$Pages$Admin$Athenahealth$Link$AthenaProviderGroupIdValidation = 1;
var $author$project$Pages$Admin$Athenahealth$Link$validateProviderGroupId = F2(
	function (isRequired, _v0) {
		var athenaProviderGroupId = _v0.Ju;
		return (isRequired && (!$author$project$Utils$Maybe$toBool(athenaProviderGroupId))) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a provider group id')
			]) : _List_Nil;
	});
var $author$project$Pages$Admin$Athenahealth$Link$formFieldsValidator = function (model) {
	var providerGroupRequired = function () {
		var _v0 = model.k1;
		if (_v0.$ === 3) {
			var config = _v0.a;
			return $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup(config);
		} else {
			return false;
		}
	}();
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.Js;
				},
				_Utils_Tuple2(0, 'Please enter a practice id')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Admin$Athenahealth$Link$validateProviderGroupId(providerGroupRequired))
			]));
};
var $author$project$Pages$Admin$Athenahealth$Link$formFieldsInit = {Js: $elm$core$Maybe$Nothing, Ju: $elm$core$Maybe$Nothing};
var $author$project$Pages$Admin$Athenahealth$Link$setIntegration = F2(
	function (athenaConfiguration, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					k1: athenaConfiguration,
					PB: $elm$core$Maybe$Just(
						$author$project$Utils$Form$init($author$project$Pages$Admin$Athenahealth$Link$formFieldsInit))
				}),
			A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 1));
	});
var $author$project$Pages$Admin$Athenahealth$Link$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A2($author$project$Pages$Admin$Athenahealth$Link$setIntegration, response, model));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A2($author$project$Pages$Admin$Athenahealth$Link$setIntegration, response, model));
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var field = msg.a;
				var _v3 = model.PB;
				if (!_v3.$) {
					var form = _v3.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Athenahealth$Link$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v4 = model.PB;
				if (!_v4.$) {
					var form = _v4.a;
					var _v5 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Pages$Admin$Athenahealth$Link$formFieldsValidator(model),
						form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							A2($author$project$Pages$Admin$Athenahealth$Link$createAthena, model.D5, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations),
						_List_Nil);
				} else {
					var _v8 = model.PB;
					if (!_v8.$) {
						var form = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(form),
									jY: response
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			default:
				var subMsg = msg.a;
				var _v9 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.D5, subMsg, model.ki);
				var stepHeader = _v9.a;
				var subCmd = _v9.b;
				var subOutMsg = _v9.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ki: stepHeader}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Athenahealth$Link$Save = {$: 2};
var $author$project$Pages$Admin$Athenahealth$Link$AthenaPracticeId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Link$AthenaProviderGroupId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Link$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Input$CustomAttributes = function (a) {
	return {$: 23, a: a};
};
var $author$project$Ui$Form$Input$customAttributes = $author$project$Ui$Form$Input$CustomAttributes;
var $author$project$Pages$Admin$Athenahealth$Link$viewConfigureInfo = A2(
	$author$project$Ui$Typography$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Please enter your athenahealth practice ID. This ID can be found by logging into athenahealth, and clicking on your username in the top right. '),
			$elm$html$Html$text('A dropdown will appear with a “PRACTICE” section. Your ID is next to your Practice name in parenthesis.')
		]));
var $author$project$Pages$Admin$Athenahealth$Link$viewLinkStep = F3(
	function (saveRequest, athenaConfig, form) {
		var scopedByProviderGroup = function () {
			if (athenaConfig.$ === 3) {
				var config = athenaConfig.a;
				return $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup(config);
			} else {
				return false;
			}
		}();
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Connect athenahealth Account')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label(''),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Pages$Admin$Athenahealth$Link$viewConfigureInfo,
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Js))),
									$author$project$Ui$Form$Input$autoComplete(false),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$placeholder('Enter athenahealth Practice ID'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Athenahealth$Link$FormUpdated, $author$project$Pages$Admin$Athenahealth$Link$AthenaPracticeId)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								])),
							scopedByProviderGroup ? $author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Ju))),
									$author$project$Ui$Form$Input$autoComplete(false),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$customAttributes(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mt-2')
										])),
									$author$project$Ui$Form$Input$placeholder('Enter athenahealth Provider Group ID'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Athenahealth$Link$FormUpdated, $author$project$Pages$Admin$Athenahealth$Link$AthenaProviderGroupId)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								])) : $author$project$Utils$Html$empty,
							function () {
							if (saveRequest.$ === 2) {
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Alert$danger,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('We do not have access yet to your Athena practice. Please make sure you have sign the Authorization & Consent form on the Athena side. If you see this message for more than a few days, please contact us.')
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Admin$Athenahealth$Link$viewLinkStepFooter = function (saveRequest) {
	return A2(
		$author$project$Ui$Panel$footer,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Got to next step'},
				_List_fromArray(
					[
						$author$project$Ui$Button$submit,
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Next Step')
					]))
			]));
};
var $author$project$Pages$Admin$Athenahealth$Link$viewLinkStepSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Typography$headingSm(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Connect athenahealth Account')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(_List_Nil)
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(_List_Nil)
						])),
					$author$project$Ui$Skeleton$input(_List_Nil)
				]))
		]));
var $author$project$Pages$Admin$Athenahealth$Link$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg,
				$author$project$Components$Admin$Athena$StepHeader$modal(model.ki)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Link$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('athenahealth')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v0 = model.k1;
									if (_v0.$ === 1) {
										return _List_fromArray(
											[$author$project$Components$Admin$Athena$StepHeader$skeleton, $author$project$Pages$Admin$Athenahealth$Link$viewLinkStepSkeleton]);
									} else {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg,
												A2($author$project$Components$Admin$Athena$StepHeader$view, model.k1, model.ki)),
												function () {
												var _v1 = model.PB;
												if (!_v1.$) {
													var form = _v1.a;
													return A3($author$project$Pages$Admin$Athenahealth$Link$viewLinkStep, model.jY, model.k1, form);
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									}
								}()),
								$author$project$Pages$Admin$Athenahealth$Link$viewLinkStepFooter(model.jY)
							]))
					]))
			]),
		$G: 'Integrations | Athenahealth'
	};
};
var $author$project$Pages$Admin$Athenahealth$Link$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Athenahealth$Link$init, aer: $author$project$Pages$Admin$Athenahealth$Link$load, agD: $author$project$Pages$Admin$Athenahealth$Link$save, ahd: $author$project$Pages$Admin$Athenahealth$Link$subscriptions, aaq: $author$project$Pages$Admin$Athenahealth$Link$update, ahP: $author$project$Pages$Admin$Athenahealth$Link$view});
var $author$project$Pages$Admin$Athenahealth$Locations$GotAthena = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Admin$Athenahealth$Locations$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				k1: $author$project$Api$Data$Loading,
				k3: $author$project$Api$Data$NotAsked,
				hx: $author$project$Api$Data$NotAsked,
				iw: $elm$core$Set$empty,
				jY: $author$project$Api$Data$NotAsked,
				ki: $author$project$Components$Admin$Athena$StepHeader$init(2)
			},
			A2(
				$author$project$Api$Provider$Integration$Athena$retrieve,
				shared.D5,
				$author$project$Pages$Admin$Athenahealth$Locations$GotAthena(true)));
	});
var $author$project$Pages$Admin$Athenahealth$Locations$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Locations$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Locations$subscriptions = function (_v0) {
	var stepHeader = _v0.ki;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg,
		$author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
};
var $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaConfigured = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaDepartments = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaLocationMappings = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Locations$GotLocationMapping = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Integration$Athena$configure = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['configure']),
					$author$project$Api$Provider$Integration$Athena$athenaPath)));
	});
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$Department$All$Department = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$Department$Shared$Department = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$Department$Shared$Record = F3(
	function (id, name, providerGroup) {
		return {adR: id, zh: name, Xk: providerGroup};
	});
var $author$project$Api$Provider$Integration$Athena$Department$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'provider_group',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$Department$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$Department$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$Department$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$Department$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$Department$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$Department$departmentsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['departments']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$Department$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$Department$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$Department$departmentsPath));
	});
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$LocationMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$LocationMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$Record = F3(
	function (id, name, externalId) {
		return {ade: externalId, adR: id, zh: name};
	});
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['location_mappings']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$LocationMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$LocationMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath));
	});
var $author$project$Pages$Admin$Athenahealth$Locations$resetHintLocations = function (model) {
	return _Utils_update(
		model,
		{iw: $elm$core$Set$empty});
};
var $author$project$Pages$Admin$Athenahealth$Locations$fetchDepartmentsData = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{k3: $author$project$Api$Data$Loading, hx: $author$project$Api$Data$Loading}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$Integration$Athena$Department$list, model.D5, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaDepartments),
					A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.D5, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaLocationMappings)
				])));
};
var $author$project$Pages$Admin$Athenahealth$Locations$setIntegration = F3(
	function (athenaConfiguration, fetchDepartments, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (cmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 2)
						]));
			},
			(fetchDepartments ? $author$project$Pages$Admin$Athenahealth$Locations$fetchDepartmentsData : function (model_) {
				return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
			})(
				_Utils_update(
					model,
					{k1: athenaConfiguration})));
	});
var $author$project$Api$Provider$Integration$Athena$LocationMapping$One$LocationMapping = 0;
var $author$project$Api$Provider$Integration$Athena$LocationMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath);
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location_mapping',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'external_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ade))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Integration$Athena$LocationMapping$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingPath(id))));
	});
var $author$project$Pages$Admin$Athenahealth$Locations$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var fetchDepartments = msg.a;
				var response = msg.b;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A3($author$project$Pages$Admin$Athenahealth$Locations$setIntegration, response, fetchDepartments, model));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A3($author$project$Pages$Admin$Athenahealth$Locations$setIntegration, response, fetchDepartments, model));
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k3: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						$author$project$Pages$Admin$Athenahealth$Locations$resetHintLocations(
							_Utils_update(
								model,
								{hx: response})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hx: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$configure, model.D5, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaConfigured),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k3: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$Department$list, model.D5, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaDepartments),
					_List_Nil);
			case 6:
				var athenaLocationMapping = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iw: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping),
								model.iw)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var athenaLocationMapping = msg.a;
				var athenaLocationId = msg.b;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Integration$Athena$LocationMapping$update,
						model.D5,
						$author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping),
						{
							ade: $author$project$Utils$String$toMaybe(athenaLocationId)
						},
						$author$project$Pages$Admin$Athenahealth$Locations$GotLocationMapping),
					_List_Nil);
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.D5, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaLocationMappings),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth department have been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.D5, subMsg, model.ki);
				var stepHeader = _v6.a;
				var subCmd = _v6.b;
				var subOutMsg = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ki: stepHeader}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Athenahealth$Locations$CompleteLocations = {$: 3};
var $author$project$Pages$Admin$Athenahealth$Locations$RefreshAthenaDepartments = {$: 5};
var $author$project$Pages$Admin$Athenahealth$Locations$EditAthenaLocationMapping = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Locations$UpdateLocationMapping = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Admin$Athenahealth$Locations$displayName = F2(
	function (name, providerGroup) {
		if (!providerGroup.$) {
			var providerGroupId = providerGroup.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[name, ' (Provider Group: #', providerGroupId, ')']));
		} else {
			return name;
		}
	});
var $author$project$Api$Provider$Integration$Athena$Department$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Integration$Athena$Department$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Department$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$Department$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Integration$Athena$Department$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Department$Shared$name(shared);
};
var $author$project$Api$Provider$Integration$Athena$Department$Shared$providerGroup = function (_v0) {
	var record = _v0;
	return record.Xk;
};
var $author$project$Api$Provider$Integration$Athena$Department$All$providerGroup = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Department$Shared$providerGroup(shared);
};
var $author$project$Pages$Admin$Athenahealth$Locations$athenaDepartmentsOptions = function (athenaDepartments) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(true)
				]),
			$elm$core$Maybe$Nothing,
			'Choose athenahealth Department'),
		A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Unlink this Department'),
			A2(
				$elm$core$List$map,
				function (athenaDepartment) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Integration$Athena$Department$All$id(athenaDepartment)),
						A2(
							$author$project$Pages$Admin$Athenahealth$Locations$displayName,
							$author$project$Api$Provider$Integration$Athena$Department$All$name(athenaDepartment),
							$author$project$Api$Provider$Integration$Athena$Department$All$providerGroup(athenaDepartment)));
				},
				athenaDepartments)));
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ade;
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$externalId(shared);
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$name(shared);
};
var $author$project$Ui$Alignment$Between = 0;
var $author$project$Ui$Alignment$ContentSpacing = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Alignment$spaceBetween = $author$project$Ui$Alignment$ContentSpacing(0);
var $author$project$Ui$Element$spaceBetween = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$spaceBetween);
var $author$project$Pages$Admin$Athenahealth$Locations$viewAthenaLocationMapping = F3(
	function (editingLocationMappings, athenaDepartments, athenaLocationMapping) {
		var isEditingAthenaLocationMapping = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping),
			editingLocationMappings);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint Location: '),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Integration$Athena$LocationMapping$All$name(athenaLocationMapping))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[$author$project$Ui$Icon$textMuted]),
									17)
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('athenahealth department: ')
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(3)
								]),
							_List_fromArray(
								[
									function () {
									if (isEditingAthenaLocationMapping) {
										return A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping)),
													$author$project$Ui$Form$Select$onChange(
													$author$project$Pages$Admin$Athenahealth$Locations$UpdateLocationMapping(athenaLocationMapping))
												]),
											$author$project$Pages$Admin$Athenahealth$Locations$athenaDepartmentsOptions(athenaDepartments));
									} else {
										var athenaDepartment = A2(
											$elm_community$list_extra$List$Extra$find,
											function (athenaDepartment_) {
												return _Utils_eq(
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$Integration$Athena$Department$All$id(athenaDepartment_)),
													$author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping));
											},
											athenaDepartments);
										var chosenDepartment = function () {
											if (!athenaDepartment.$) {
												var department_ = athenaDepartment.a;
												return A2(
													$author$project$Pages$Admin$Athenahealth$Locations$displayName,
													$author$project$Api$Provider$Integration$Athena$Department$All$name(department_),
													$author$project$Api$Provider$Integration$Athena$Department$All$providerGroup(department_));
											} else {
												return 'Not linked';
											}
										}();
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													_List_fromArray(
														[
															$elm$html$Html$text(chosenDepartment)
														])),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Edit location mapping'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$Athenahealth$Locations$EditAthenaLocationMapping(athenaLocationMapping)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]));
									}
								}()
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsListSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	A2(
		$elm$core$List$repeat,
		10,
		A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Platform Location: ')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8),
											$author$project$Ui$Skeleton$spanMd(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('athenahealth department: ')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))));
var $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStepSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(9),
							$author$project$Ui$FlexGrid$spanMd(8),
							$author$project$Ui$FlexGrid$spanSm(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(5)
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(11)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(3),
							$author$project$Ui$FlexGrid$spanMd(4),
							$author$project$Ui$FlexGrid$spanSm(5),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Refresh athenahealth Departments')
								]))
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			$author$project$Pages$Admin$Athenahealth$Locations$viewLocationsListSkeleton
		]));
var $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStep = function (model) {
	var _v0 = model.hx;
	if (_v0.$ === 3) {
		var athenaLocationMappings = _v0.a;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(9),
									$author$project$Ui$FlexGrid$spanMd(8),
									$author$project$Ui$FlexGrid$spanSm(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Match Hint Locations to athenahealth Departments')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Keep your patients organized by matching your Hint Locations to athenahealth Departments. If a patient is not at a location that is linked to a department, they will not be synced to Athena.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(3),
									$author$project$Ui$FlexGrid$spanMd(4),
									$author$project$Ui$FlexGrid$spanSm(5),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Refresh athenahealth Departments'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Locations$RefreshAthenaDepartments),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Refresh athenahealth Departments')
										]))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					function () {
					var _v1 = model.k3;
					if (_v1.$ === 3) {
						var athenaDepartments = _v1.a;
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Admin$Athenahealth$Locations$viewAthenaLocationMapping, model.iw, athenaDepartments),
								athenaLocationMappings));
					} else {
						return $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsListSkeleton;
					}
				}()
				]));
	} else {
		return $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStepSkeleton;
	}
};
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Set$isEmpty = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$isEmpty(dict);
};
var $author$project$Ui$Panel$None = {$: 5};
var $author$project$Ui$Panel$none = $author$project$Ui$Panel$None;
var $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStepFooter = function (model) {
	var _v0 = model.hx;
	if (_v0.$ === 3) {
		var athenaLocationMappings = _v0.a;
		var canContinue = A2(
			$elm$core$List$any,
			function (athenaLocationMapping) {
				return !_Utils_eq(
					$author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping),
					$elm$core$Maybe$Nothing);
			},
			athenaLocationMappings) && $elm$core$Set$isEmpty(model.iw);
		return A2(
			$author$project$Ui$Panel$footer,
			_List_fromArray(
				[$author$project$Ui$Element$justifyCenter]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Go to next step'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Locations$CompleteLocations),
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$loading(
							_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
							$author$project$Ui$Button$disabled(!canContinue)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Next Step')
						]))
				]));
	} else {
		return $author$project$Ui$Panel$none;
	}
};
var $author$project$Pages$Admin$Athenahealth$Locations$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg,
				$author$project$Components$Admin$Athena$StepHeader$modal(model.ki)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Locations$CompleteLocations)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('athenahealth')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										var _v0 = model.k1;
										if (_v0.$ === 3) {
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg,
												A2($author$project$Components$Admin$Athena$StepHeader$view, model.k1, model.ki));
										} else {
											return $author$project$Components$Admin$Athena$StepHeader$skeleton;
										}
									}(),
										$author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStep(model)
									])),
								$author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStepFooter(model)
							]))
					]))
			]),
		$G: 'Integrations | Athenahealth'
	};
};
var $author$project$Pages$Admin$Athenahealth$Locations$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Athenahealth$Locations$init, aer: $author$project$Pages$Admin$Athenahealth$Locations$load, agD: $author$project$Pages$Admin$Athenahealth$Locations$save, ahd: $author$project$Pages$Admin$Athenahealth$Locations$subscriptions, aaq: $author$project$Pages$Admin$Athenahealth$Locations$update, ahP: $author$project$Pages$Admin$Athenahealth$Locations$view});
var $author$project$Pages$Admin$Athenahealth$Overview$GotAthena = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaFieldMappings = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaLocationMappings = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaProviderMappings = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$ProviderMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$ProviderMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$Record = F3(
	function (id, name, externalId) {
		return {ade: externalId, adR: id, zh: name};
	});
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['provider_mappings']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$ProviderMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath));
	});
var $author$project$Pages$Admin$Athenahealth$Overview$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				k1: $author$project$Api$Data$Loading,
				yz: $elm$core$Maybe$Nothing,
				yA: $elm$core$Maybe$Nothing,
				yB: $elm$core$Maybe$Nothing,
				jY: $author$project$Api$Data$NotAsked,
				ki: $author$project$Components$Admin$Athena$StepHeader$init(5)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.D5, $author$project$Pages$Admin$Athenahealth$Overview$GotAthena),
						A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, shared.D5, $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaLocationMappings),
						A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, shared.D5, $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaFieldMappings),
						A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, shared.D5, $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaProviderMappings)
					])));
	});
var $author$project$Pages$Admin$Athenahealth$Overview$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Overview$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Overview$subscriptions = function (_v0) {
	var stepHeader = _v0.ki;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg,
		$author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
};
var $author$project$Pages$Admin$Athenahealth$Overview$Activated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Overview$Updated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Integration$Athena$activate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$Integration$Athena$athenaPath)));
	});
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ade;
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$externalId(shared);
};
var $author$project$Pages$Admin$Athenahealth$Overview$setIntegration = F2(
	function (athenaConfiguration, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{k1: athenaConfiguration}),
			A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 5));
	});
var $author$project$Api$Provider$Integration$Athena$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'athena_integration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'allow_new_patient_creation',
								$elm$json$Json$Encode$bool(fields.IX))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath)));
	});
var $author$project$Pages$Admin$Athenahealth$Overview$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A2($author$project$Pages$Admin$Athenahealth$Overview$setIntegration, response, model));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A2($author$project$Pages$Admin$Athenahealth$Overview$setIntegration, response, model));
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var locationMappings = response.a;
					var linkedLocations = A2(
						$elm$core$List$filter,
						function (locationMapping) {
							return !_Utils_eq(
								$author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(locationMapping),
								$elm$core$Maybe$Nothing);
						},
						locationMappings);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								yA: $elm$core$Maybe$Just(
									$elm$core$List$length(linkedLocations))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var fieldMappings = response.a;
					var linkedFields = A2(
						$elm$core$List$filter,
						function (fieldMapping) {
							return !_Utils_eq(
								$author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId(fieldMapping),
								$elm$core$Maybe$Nothing);
						},
						fieldMappings);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								yz: $elm$core$Maybe$Just(
									$elm$core$List$length(linkedFields))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var providerMappings = response.a;
					var linkedProviders = A2(
						$elm$core$List$filter,
						function (providerMapping) {
							return !_Utils_eq(
								$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(providerMapping),
								$elm$core$Maybe$Nothing);
						},
						providerMappings);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								yB: $elm$core$Maybe$Just(
									$elm$core$List$length(linkedProviders))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$activate, model.D5, $author$project$Pages$Admin$Athenahealth$Overview$Activated),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k1: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration has been activated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var allowNewPatientCreation = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Integration$Athena$update,
						model.D5,
						{IX: allowNewPatientCreation},
						$author$project$Pages$Admin$Athenahealth$Overview$Updated),
					_List_Nil);
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k1: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration have been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v8 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.D5, subMsg, model.ki);
				var stepHeader = _v8.a;
				var subCmd = _v8.b;
				var subOutMsg = _v8.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ki: stepHeader}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Athenahealth$Overview$Activate = {$: 4};
var $author$project$Pages$Admin$Athenahealth$Overview$ToggleNewPatientCreation = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$allowNewPatientCreation = function (_v0) {
	var record = _v0;
	return record.IX;
};
var $author$project$Api$Provider$AthenaConfiguration$One$allowNewPatientCreation = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$allowNewPatientCreation(shared);
};
var $author$project$Api$Provider$AthenaConfiguration$Shared$ignoredFields = function (_v0) {
	var record = _v0;
	return record.QM;
};
var $author$project$Api$Provider$AthenaConfiguration$One$ignoredFields = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$AthenaConfiguration$Shared$ignoredFields(shared);
};
var $author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStep = F2(
	function (athenaConfiguration, model) {
		var allowNewPatientCreation = $author$project$Api$Provider$AthenaConfiguration$One$allowNewPatientCreation(athenaConfiguration);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Number of Locations Linked to Departments'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = model.yA;
									if (!_v0.$) {
										var linkedLocationsCount = _v0.a;
										return $elm$html$Html$text(
											$elm$core$String$fromInt(linkedLocationsCount));
									} else {
										return $author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanFromText('100')
												]));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Number of Custom Fields Linked'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v1 = model.yz;
									if (!_v1.$) {
										var linkedFieldsCount = _v1.a;
										return $elm$html$Html$text(
											$elm$core$String$fromInt(linkedFieldsCount));
									} else {
										return $author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanFromText('100')
												]));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Number of Providers Linked'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v2 = model.yB;
									if (!_v2.$) {
										var linkedProvidersCount = _v2.a;
										return $elm$html$Html$text(
											$elm$core$String$fromInt(linkedProvidersCount));
									} else {
										return $author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanFromText('100')
												]));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Create patients from athenahealth'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(allowNewPatientCreation),
									$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$Athenahealth$Overview$ToggleNewPatientCreation),
									$author$project$Ui$ToggleSwitch$disabled(
									_Utils_eq(model.jY, $author$project$Api$Data$Loading))
								])),
							allowNewPatientCreation ? A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Update linked patients with changes from athenahealth. If a patient is '),
											$elm$html$Html$text('not found, create a new record in Hint. This is suggested for direct '),
											$elm$html$Html$text('care practices.')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Note: Only patients in athenahealth departments linked to Hint will be '),
											$elm$html$Html$text('created in Hint.')
										]))
								])) : A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update linked patients with changes from athenahealth. If a patient is not found, '),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text('do not create')
										])),
									$elm$html$Html$text(' a record in Hint. This is suggested for hybrid practices '),
									$elm$html$Html$text('that have both fee-for-service as well as direct care patients.')
								]))
						])),
					$elm$core$List$isEmpty(
					$author$project$Api$Provider$AthenaConfiguration$One$ignoredFields(athenaConfiguration)) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Fields excluded from the sync'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$String$join,
										', ',
										$author$project$Api$Provider$AthenaConfiguration$One$ignoredFields(athenaConfiguration)))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStepFooter = F2(
	function (athenaConfiguration, model) {
		var status = $author$project$Api$Provider$AthenaConfiguration$One$status(athenaConfiguration);
		return (status === 'pending') ? A2(
			$author$project$Ui$Panel$footer,
			_List_fromArray(
				[$author$project$Ui$Element$justifyCenter]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Activate integration'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Overview$Activate),
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$loading(
							_Utils_eq(model.jY, $author$project$Api$Data$Loading))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Activate')
						]))
				])) : $author$project$Ui$Panel$none;
	});
var $author$project$Ui$Skeleton$Block = 0;
var $author$project$Ui$Skeleton$Display = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Skeleton$block = $author$project$Ui$Skeleton$Display(0);
var $author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStepSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Number of Locations Linked to Departments'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('100')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Number of Custom Fields Linked'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('100')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Number of Providers Linked'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('100')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Create patients from athenahealth'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanMd(2),
							$author$project$Ui$Skeleton$span(3)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(6)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(7)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(5)
								]))
						]))
				]))
		]));
var $author$project$Pages$Admin$Athenahealth$Overview$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg,
				$author$project$Components$Admin$Athena$StepHeader$modal(model.ki)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Overview$Activate)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('athenahealth')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v0 = model.k1;
									if (_v0.$ === 3) {
										var athenaConfiguration = _v0.a;
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg,
												A2($author$project$Components$Admin$Athena$StepHeader$view, model.k1, model.ki)),
												A2($author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStep, athenaConfiguration, model)
											]);
									} else {
										return _List_fromArray(
											[$author$project$Components$Admin$Athena$StepHeader$skeleton, $author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStepSkeleton]);
									}
								}()),
								function () {
								var _v1 = model.k1;
								if (_v1.$ === 3) {
									var athenaConfiguration = _v1.a;
									return A2($author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStepFooter, athenaConfiguration, model);
								} else {
									return $author$project$Ui$Panel$none;
								}
							}()
							]))
					]))
			]),
		$G: 'Integrations | Athenahealth'
	};
};
var $author$project$Pages$Admin$Athenahealth$Overview$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Athenahealth$Overview$init, aer: $author$project$Pages$Admin$Athenahealth$Overview$load, agD: $author$project$Pages$Admin$Athenahealth$Overview$save, ahd: $author$project$Pages$Admin$Athenahealth$Overview$subscriptions, aaq: $author$project$Pages$Admin$Athenahealth$Overview$update, ahP: $author$project$Pages$Admin$Athenahealth$Overview$view});
var $author$project$Pages$Admin$Athenahealth$Providers$GotAthena = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Admin$Athenahealth$Providers$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				k1: $author$project$Api$Data$Loading,
				k4: $author$project$Api$Data$NotAsked,
				k5: $author$project$Api$Data$NotAsked,
				ix: $elm$core$Set$empty,
				jY: $author$project$Api$Data$NotAsked,
				ki: $author$project$Components$Admin$Athena$StepHeader$init(4)
			},
			A2(
				$author$project$Api$Provider$Integration$Athena$retrieve,
				shared.D5,
				$author$project$Pages$Admin$Athenahealth$Providers$GotAthena(true)));
	});
var $author$project$Pages$Admin$Athenahealth$Providers$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Providers$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Providers$subscriptions = function (_v0) {
	var stepHeader = _v0.ki;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg,
		$author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
};
var $author$project$Pages$Admin$Athenahealth$Providers$Completed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviderMappings = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviders = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Providers$GotProviderMapping = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Integration$Athena$complete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['complete']),
					$author$project$Api$Provider$Integration$Athena$athenaPath)));
	});
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$Provider$All$Provider = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$Provider = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$Record = F3(
	function (id, name, providerGroups) {
		return {adR: id, zh: name, Xl: providerGroups};
	});
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'provider_groups',
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$Provider$Shared$Record))));
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$Provider$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$Provider$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Athena$Provider$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Athena$Provider$providersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['providers']),
	$author$project$Api$Provider$Integration$Athena$athenaPath);
var $author$project$Api$Provider$Integration$Athena$Provider$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$Provider$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$Provider$providersPath));
	});
var $author$project$Pages$Admin$Athenahealth$Providers$resetHintProviders = function (model) {
	return _Utils_update(
		model,
		{ix: $elm$core$Set$empty});
};
var $author$project$Pages$Admin$Athenahealth$Providers$fetchProvidersData = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{k4: $author$project$Api$Data$Loading, k5: $author$project$Api$Data$Loading}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$Integration$Athena$Provider$list, model.D5, $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviders),
					A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.D5, $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviderMappings)
				])));
};
var $author$project$Pages$Admin$Athenahealth$Providers$setIntegration = F3(
	function (athenaConfiguration, fetchProviders, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			function (cmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 4)
						]));
			},
			(fetchProviders ? $author$project$Pages$Admin$Athenahealth$Providers$fetchProvidersData : function (model_) {
				return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
			})(
				_Utils_update(
					model,
					{k1: athenaConfiguration})));
	});
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$One$ProviderMapping = 0;
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath);
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'provider_mapping',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'external_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ade))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Integration$Athena$ProviderMapping$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingPath(id))));
	});
var $author$project$Pages$Admin$Athenahealth$Providers$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var fetchProviders = msg.a;
				var response = msg.b;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A3($author$project$Pages$Admin$Athenahealth$Providers$setIntegration, response, fetchProviders, model));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A3($author$project$Pages$Admin$Athenahealth$Providers$setIntegration, response, fetchProviders, model));
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k5: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						$author$project$Pages$Admin$Athenahealth$Providers$resetHintProviders(
							_Utils_update(
								model,
								{k4: response})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{k4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$complete, model.D5, $author$project$Pages$Admin$Athenahealth$Providers$Completed),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k5: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$Provider$list, model.D5, $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviders),
					_List_Nil);
			case 6:
				var athenaProviderMapping = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ix: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping),
								model.ix)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var athenaProviderMapping = msg.a;
				var athenaProviderId = msg.b;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Integration$Athena$ProviderMapping$update,
						model.D5,
						$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping),
						{
							ade: $author$project$Utils$String$toMaybe(athenaProviderId)
						},
						$author$project$Pages$Admin$Athenahealth$Providers$GotProviderMapping),
					_List_Nil);
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.D5, $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviderMappings),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth provider have been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.D5, subMsg, model.ki);
				var stepHeader = _v6.a;
				var subCmd = _v6.b;
				var subOutMsg = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ki: stepHeader}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Athenahealth$Providers$CompleteProviders = {$: 3};
var $author$project$Pages$Admin$Athenahealth$Providers$RefreshAthenaProviders = {$: 5};
var $author$project$Pages$Admin$Athenahealth$Providers$EditAthenaProviderMapping = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Providers$UpdateProviderMapping = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Admin$Athenahealth$Providers$displayName = F2(
	function (name, providerGroups) {
		if (!providerGroups.$) {
			var providerGroupIds = providerGroups.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						' (Provider Group: ',
						A2(
						$elm$core$String$join,
						', ',
						A2(
							$elm$core$List$map,
							function (id) {
								return '#' + id;
							},
							providerGroupIds)),
						')'
					]));
		} else {
			return name;
		}
	});
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Integration$Athena$Provider$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Provider$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Integration$Athena$Provider$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Provider$Shared$name(shared);
};
var $author$project$Api$Provider$Integration$Athena$Provider$Shared$providerGroups = function (_v0) {
	var record = _v0;
	return record.Xl;
};
var $author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$Provider$Shared$providerGroups(shared);
};
var $author$project$Pages$Admin$Athenahealth$Providers$athenaProvidersOptions = function (athenaProviders) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(true)
				]),
			$elm$core$Maybe$Nothing,
			'Choose athenahealth Provider'),
		A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Unlink this Provider'),
			A2(
				$elm$core$List$map,
				function (athenaProvider) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$Integration$Athena$Provider$All$id(athenaProvider))),
						A2(
							$author$project$Pages$Admin$Athenahealth$Providers$displayName,
							$author$project$Api$Provider$Integration$Athena$Provider$All$name(athenaProvider),
							$author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups(athenaProvider)));
				},
				athenaProviders)));
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$name(shared);
};
var $author$project$Ui$Button$size = $author$project$Ui$Button$Size;
var $author$project$Pages$Admin$Athenahealth$Providers$viewAthenaProviderMapping = F3(
	function (editingProviderMappings, athenaProviders, athenaProviderMapping) {
		var isEditingAthenaProviderMapping = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping),
			editingProviderMappings);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint provider: '),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$name(athenaProviderMapping))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[$author$project$Ui$Icon$textMuted]),
									17)
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('athenahealth provider: ')
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(3)
								]),
							_List_fromArray(
								[
									function () {
									if (isEditingAthenaProviderMapping) {
										return A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(athenaProviderMapping)),
													$author$project$Ui$Form$Select$onChange(
													$author$project$Pages$Admin$Athenahealth$Providers$UpdateProviderMapping(athenaProviderMapping))
												]),
											$author$project$Pages$Admin$Athenahealth$Providers$athenaProvidersOptions(athenaProviders));
									} else {
										var athenaProvider = A2(
											$elm_community$list_extra$List$Extra$find,
											function (athenaProvider_) {
												return _Utils_eq(
													$elm$core$Maybe$Just(
														$elm$core$String$fromInt(
															$author$project$Api$Provider$Integration$Athena$Provider$All$id(athenaProvider_))),
													$author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(athenaProviderMapping));
											},
											athenaProviders);
										var chosenProvider = function () {
											if (!athenaProvider.$) {
												var provider_ = athenaProvider.a;
												return A2(
													$author$project$Pages$Admin$Athenahealth$Providers$displayName,
													$author$project$Api$Provider$Integration$Athena$Provider$All$name(provider_),
													$author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups(provider_));
											} else {
												return 'Not linked';
											}
										}();
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													_List_fromArray(
														[
															$elm$html$Html$text(chosenProvider)
														])),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Edit provider mapping'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$size(0),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$Athenahealth$Providers$EditAthenaProviderMapping(athenaProviderMapping)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]));
									}
								}()
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersListSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	A2(
		$elm$core$List$repeat,
		10,
		A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Platform Provider: ')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8),
											$author$project$Ui$Skeleton$spanMd(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('athenahealth provider: ')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))));
var $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStepSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(9),
							$author$project$Ui$FlexGrid$spanMd(8),
							$author$project$Ui$FlexGrid$spanSm(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Link Providers')
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Keep the primary provider in athenahealth in sync with the the assigned provider in HintOS.')
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(3),
							$author$project$Ui$FlexGrid$spanMd(4),
							$author$project$Ui$FlexGrid$spanSm(5),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Refresh athenahealth Providers')
								]))
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			$author$project$Pages$Admin$Athenahealth$Providers$viewProvidersListSkeleton
		]));
var $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStep = function (model) {
	var _v0 = model.k4;
	if (_v0.$ === 3) {
		var athenaProviderMappings = _v0.a;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(9),
									$author$project$Ui$FlexGrid$spanMd(8),
									$author$project$Ui$FlexGrid$spanSm(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Link Providers')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Keep the primary provider in athenahealth in sync with the the assigned provider in HintOS.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(3),
									$author$project$Ui$FlexGrid$spanMd(4),
									$author$project$Ui$FlexGrid$spanSm(5),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Refresh athenahealth Providers'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Providers$RefreshAthenaProviders),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Refresh athenahealth Providers')
										]))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					function () {
					var _v1 = model.k5;
					if (_v1.$ === 3) {
						var athenaProviders = _v1.a;
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Admin$Athenahealth$Providers$viewAthenaProviderMapping, model.ix, athenaProviders),
								athenaProviderMappings));
					} else {
						return $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersListSkeleton;
					}
				}()
				]));
	} else {
		return $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStepSkeleton;
	}
};
var $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStepFooter = function (model) {
	var canContinue = $elm$core$Set$isEmpty(model.ix);
	return A2(
		$author$project$Ui$Panel$footer,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Go to next step'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Providers$CompleteProviders),
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$disabled(!canContinue)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Next Step')
					]))
			]));
};
var $author$project$Pages$Admin$Athenahealth$Providers$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg,
				$author$project$Components$Admin$Athena$StepHeader$modal(model.ki)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Providers$CompleteProviders)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('athenahealth')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										var _v0 = model.k1;
										if (_v0.$ === 3) {
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg,
												A2($author$project$Components$Admin$Athena$StepHeader$view, model.k1, model.ki));
										} else {
											return $author$project$Components$Admin$Athena$StepHeader$skeleton;
										}
									}(),
										$author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStep(model)
									])),
								$author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStepFooter(model)
							]))
					]))
			]),
		$G: 'Integrations | Athenahealth'
	};
};
var $author$project$Pages$Admin$Athenahealth$Providers$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Athenahealth$Providers$init, aer: $author$project$Pages$Admin$Athenahealth$Providers$load, agD: $author$project$Pages$Admin$Athenahealth$Providers$save, ahd: $author$project$Pages$Admin$Athenahealth$Providers$subscriptions, aaq: $author$project$Pages$Admin$Athenahealth$Providers$update, ahP: $author$project$Pages$Admin$Athenahealth$Providers$view});
var $author$project$Pages$Admin$Athenahealth$Top$GotAthena = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Athenahealth$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{D5: shared.D5, k1: $author$project$Api$Data$Loading, jY: $author$project$Api$Data$NotAsked},
			A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.D5, $author$project$Pages$Admin$Athenahealth$Top$GotAthena));
	});
var $author$project$Pages$Admin$Athenahealth$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Athenahealth$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Athenahealth$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Athenahealth$Top$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Integration$Athena$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$AthenaConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
	});
var $author$project$Pages$Admin$Athenahealth$Top$setIntegration = F2(
	function (athenaConfiguration, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{k1: athenaConfiguration}),
			A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 0));
	});
var $author$project$Pages$Admin$Athenahealth$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A2($author$project$Pages$Admin$Athenahealth$Top$setIntegration, response, model));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A2($author$project$Pages$Admin$Athenahealth$Top$setIntegration, response, model));
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k1: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Athena$create, model.D5, $author$project$Pages$Admin$Athenahealth$Top$Created),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Link),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Athenahealth$Top$Create = {$: 1};
var $author$project$Pages$Admin$Athenahealth$Top$viewStatus = F2(
	function (status, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($author$project$Ui$Badge$fromString, _List_Nil, status),
						content))
				]));
	});
var $author$project$Pages$Admin$Athenahealth$Top$viewInitialStep = function (_v0) {
	var saveRequest = _v0.jY;
	var athenaConfiguration = _v0.k1;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				if (athenaConfiguration.$ === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSkeleton('Status'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$text(
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$spanFromText('inactive')
											]))
									]))
							]));
				} else {
					return A2($author$project$Pages$Admin$Athenahealth$Top$viewStatus, 'inactive', _List_Nil);
				}
			}(),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Enable athenahealth Integration'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Top$Create),
								$author$project$Ui$Button$loading(
								_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Enable athenahealth Integration')
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('About'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
								A3(
								$author$project$Ui$Link$externalHref,
								'https://www.athenahealth.com/',
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text('athenahealth')
									])),
								$elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, '),
								$elm$html$Html$text('and act upon relevant clinical information to care for your patients.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Our integration will automatically create and synchronize patient demographic, '),
								$elm$html$Html$text('contact, and membership information with athenahealth.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To configure this integration, you need to provide your existing athenahealth practice ID. '),
								$elm$html$Html$text('Please contact us if you need help identifying this information')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Athenahealth$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('athenahealth')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$Admin$Athenahealth$Top$viewInitialStep(model)
									]))
							]))
					]))
			]),
		$G: 'Integrations | Athenahealth'
	};
};
var $author$project$Pages$Admin$Athenahealth$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Athenahealth$Top$init, aer: $author$project$Pages$Admin$Athenahealth$Top$load, agD: $author$project$Pages$Admin$Athenahealth$Top$save, ahd: $author$project$Pages$Admin$Athenahealth$Top$subscriptions, aaq: $author$project$Pages$Admin$Athenahealth$Top$update, ahP: $author$project$Pages$Admin$Athenahealth$Top$view});
var $author$project$Pages$Admin$Billing$GotManagementGroup = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$Billing$NotInitialized = {$: 0};
var $author$project$Pages$Admin$Billing$GotBankAccounts = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$BankAccount$bankAccountsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['bank_accounts']),
		basePath);
};
var $author$project$Api$Provider$BankAccount$All$BankAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$BankAccount$One$BankAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BankAccount$Shared$BankAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$BankAccount$Shared$Record = function (id) {
	return function (name) {
		return function (type_) {
			return function (lastFour) {
				return function (status) {
					return function (label) {
						return function (errorMessage) {
							return function (lastPaymentErrorMessage) {
								return function (createdVia) {
									return function (createdByName) {
										return function (createdAt) {
											return function (bankName) {
												return function (paymentProcessor) {
													return function (assignedMemberships) {
														return {Jq: assignedMemberships, JR: bankName, Mf: createdAt, Mh: createdByName, Mi: createdVia, ON: errorMessage, adR: id, aej: label, Sz: lastFour, SB: lastPaymentErrorMessage, zh: name, V0: paymentProcessor, ag7: status, ahI: type_};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$BankAccount$Shared$AssignedMembership = F2(
	function (id, planName) {
		return {adR: id, Wo: planName};
	});
var $author$project$Api$Provider$BankAccount$Shared$assignedMembershipDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan_name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$Shared$AssignedMembership)));
var $author$project$Api$Provider$BankAccount$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'assigned_memberships',
	$elm$json$Json$Decode$list($author$project$Api$Provider$BankAccount$Shared$assignedMembershipDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bank_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_by_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_via',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'last_payment_error_message',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'error_message',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'label',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'status',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_four',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'type',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$Shared$Record)))))))))))))));
var $author$project$Api$Provider$BankAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BankAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BankAccount$One$Record = F2(
	function (_default, defaults) {
		return {M5: _default, Nn: defaults};
	});
var $author$project$Api$Provider$Source$Defaults$Defaults = $elm$core$Basics$identity;
var $author$project$Api$Provider$Source$Defaults$Record = F2(
	function (hintCustomer, network) {
		return {Qu: hintCustomer, Uo: network};
	});
var $author$project$Api$Provider$Source$Defaults$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'network',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hint_customer',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Source$Defaults$Record)));
var $author$project$Api$Provider$Source$Defaults$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Source$Defaults$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BankAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'defaults',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Source$Defaults$decoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'default',
		$elm$json$Json$Decode$bool,
		false,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$One$Record)));
var $author$project$Api$Provider$BankAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BankAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BankAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$One$BankAccount)));
var $author$project$Api$Provider$BankAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BankAccount$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Param$List = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Param$list = $author$project$Api$Param$List;
var $author$project$Api$Provider$BankAccount$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$BankAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						_List_fromArray(
							['assigned_memberships']))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$BankAccount$bankAccountsPath(basePath))));
	});
var $author$project$Pages$Admin$Billing$fetchBankAccounts = function (apiClient) {
	return A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$Billing$GotBankAccounts);
};
var $author$project$Pages$Admin$Billing$GotCards = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Card$cardsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['cards']),
		basePath);
};
var $author$project$Api$Provider$Card$All$Card = $elm$core$Basics$identity;
var $author$project$Api$Provider$Card$One$Card = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Card$Shared$Card = $elm$core$Basics$identity;
var $author$project$Api$Provider$Card$Shared$Record = function (id) {
	return function (name) {
		return function (type_) {
			return function (lastFour) {
				return function (status) {
					return function (label) {
						return function (errorMessage) {
							return function (lastPaymentErrorMessage) {
								return function (expMonth) {
									return function (expYear) {
										return function (createdVia) {
											return function (createdByName) {
												return function (createdAt) {
													return function (cardType) {
														return function (zip) {
															return function (paymentProcessor) {
																return function (funding) {
																	return function (assignedMemberships) {
																		return {Jq: assignedMemberships, KI: cardType, Mf: createdAt, Mh: createdByName, Mi: createdVia, ON: errorMessage, ac9: expMonth, ada: expYear, PK: funding, adR: id, aej: label, Sz: lastFour, SB: lastPaymentErrorMessage, zh: name, V0: paymentProcessor, ag7: status, ahI: type_, tC: zip};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Card$Shared$AssignedMembership = F2(
	function (id, planName) {
		return {adR: id, Wo: planName};
	});
var $author$project$Api$Provider$Card$Shared$assignedMembershipDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan_name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$Shared$AssignedMembership)));
var $author$project$Api$Provider$Card$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'assigned_memberships',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Card$Shared$assignedMembershipDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'funding',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payment_processor',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'zip',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'card_type',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_at',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'created_by_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'created_via',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'exp_year',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'exp_month',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_payment_error_message',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'error_message',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'label',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'status',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'last_four',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'type',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'name',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'id',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$Shared$Record)))))))))))))))))));
var $author$project$Api$Provider$Card$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Card$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Card$One$Record = F2(
	function (_default, defaults) {
		return {M5: _default, Nn: defaults};
	});
var $author$project$Api$Provider$Card$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'defaults',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Source$Defaults$decoder),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'default',
		$elm$json$Json$Decode$bool,
		false,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$One$Record)));
var $author$project$Api$Provider$Card$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Card$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Card$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$One$Card)));
var $author$project$Api$Provider$Card$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Card$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Card$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Card$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						_List_fromArray(
							['assigned_memberships']))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Card$cardsPath(basePath))));
	});
var $author$project$Pages$Admin$Billing$fetchCards = function (apiClient) {
	return A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$Billing$GotCards);
};
var $author$project$Pages$Admin$Billing$GotPracticeInvoices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PracticeInvoice$All$PracticeInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeInvoice$Shared$PracticeInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeInvoice$Shared$Record = function (humanStatus) {
	return function (id) {
		return function (invoiceDate) {
			return function (dueDate) {
				return function (invoiceNumber) {
					return function (paidAt) {
						return function (totalInCents) {
							return function (paidInCents) {
								return function (dueInCents) {
									return function (meta) {
										return {N1: dueDate, N2: dueInCents, QE: humanStatus, adR: id, Rn: invoiceDate, Rq: invoiceNumber, TU: meta, Vt: paidAt, Vu: paidInCents, $X: totalInCents};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$PracticeInvoice$Status$Cancelled = 4;
var $author$project$Api$Provider$PracticeInvoice$Status$Disputed = 6;
var $author$project$Api$Provider$PracticeInvoice$Status$Draft = 2;
var $author$project$Api$Provider$PracticeInvoice$Status$Issued = 3;
var $author$project$Api$Provider$PracticeInvoice$Status$Overdue = 5;
var $author$project$Api$Provider$PracticeInvoice$Status$Paid = 0;
var $author$project$Api$Provider$PracticeInvoice$Status$Processing = 1;
var $author$project$Api$Provider$PracticeInvoice$Status$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'paid':
				return $elm$json$Json$Decode$succeed(0);
			case 'processing':
				return $elm$json$Json$Decode$succeed(1);
			case 'draft':
				return $elm$json$Json$Decode$succeed(2);
			case 'overdue':
				return $elm$json$Json$Decode$succeed(5);
			case 'cancelled':
				return $elm$json$Json$Decode$succeed(4);
			case 'disputed':
				return $elm$json$Json$Decode$succeed(6);
			case 'issued':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unsupported Practice Invoice status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$PracticeInvoice$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeInvoice$Meta$MetaRecord = function (actions) {
	return {tF: actions};
};
var $author$project$Api$Provider$PracticeInvoice$Meta$ActionsRecord = F6(
	function (cancel, issue, destroy, paymentsProcess, adjust, refund) {
		return {IB: adjust, KF: cancel, NA: destroy, Sh: issue, V6: paymentsProcess, X2: refund};
	});
var $author$project$Api$Provider$PracticeInvoice$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'refund',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'adjust',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payments_process',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'destroy',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'issue',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'cancel',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Meta$ActionsRecord)))))));
var $author$project$Api$Provider$PracticeInvoice$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$PracticeInvoice$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Meta$MetaRecord));
var $author$project$Api$Provider$PracticeInvoice$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeInvoice$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeInvoice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$PracticeInvoice$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'paid_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'paid_at',
					$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'invoice_number',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'due_date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_date',
								$author$project$Utils$Date$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'human_status',
										$author$project$Api$Provider$PracticeInvoice$Status$decode,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Shared$Record)))))))))));
var $author$project$Api$Provider$PracticeInvoice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeInvoice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeInvoice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeInvoice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Pagination$Model = $elm$core$Basics$identity;
var $author$project$Api$Pagination$init = {bV: 1, mM: 10, A7: '', oN: 0};
var $author$project$Api$Provider$PracticeInvoice$listDefaults = {Fi: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init};
var $author$project$Api$Pagination$limit = function (_v0) {
	var model = _v0;
	return model.mM;
};
var $author$project$Api$Pagination$offset = function (_v0) {
	var model = _v0;
	return (model.bV - 1) * model.mM;
};
var $author$project$Api$Pagination$toApiParams = function (model) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var key = _v0.a;
			var value = _v0.b;
			return A2($author$project$Api$Param$string, key, value);
		},
		_List_fromArray(
			[
				_Utils_Tuple2(
				'offset',
				$elm$core$String$fromInt(
					$author$project$Api$Pagination$offset(model))),
				_Utils_Tuple2(
				'limit',
				$elm$core$String$fromInt(
					$author$project$Api$Pagination$limit(model)))
			]));
};
var $author$project$Api$Provider$PracticeInvoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$PracticeInvoice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Fi;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', filter)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice', 'invoices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticeInvoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeInvoice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$PracticeInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath)));
	});
var $author$project$Pages$Admin$Billing$fetchPracticeInvoices = F2(
	function (apiClient, pagination) {
		return A3(
			$author$project$Api$Provider$PracticeInvoice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination});
			},
			$author$project$Pages$Admin$Billing$GotPracticeInvoices);
	});
var $author$project$Pages$Admin$Billing$GotApplicationFeePlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$ApplicationFeePlan$applicationFeePlanPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['fee_plan']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$ApplicationFeePlan$One$ApplicationFeePlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$ApplicationFeePlan$One$Record = function (id) {
	return function (name) {
		return function (pricedBy) {
			return function (collectionFeePercentage) {
				return function (minimumPerMonthInCents) {
					return function (totalAchFeeInCents) {
						return function (totalAchFeePercentage) {
							return function (totalAmexFeePercentage) {
								return function (totalCardFeeInCents) {
									return function (totalCardFeePercentage) {
										return function (achTransactionFeeCapInCents) {
											return function (trancheSize) {
												return {H9: achTransactionFeeCapInCents, Li: collectionFeePercentage, adR: id, T5: minimumPerMonthInCents, zh: name, Bb: pricedBy, $R: totalAchFeeInCents, $S: totalAchFeePercentage, $T: totalAmexFeePercentage, $U: totalCardFeeInCents, HB: totalCardFeePercentage, ahF: trancheSize};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$ApplicationFeePlan$One$RecordIntermediate = F2(
	function (pricedBy, pricingStructure) {
		return {Bb: pricedBy, W2: pricingStructure};
	});
var $author$project$Api$Provider$PricingStructure$Shared$PricingStructure = $elm$core$Basics$identity;
var $author$project$Api$Provider$PricingStructure$Shared$IntermediateRecord = F7(
	function (id, description, fixedAmountInCents, percentage, splitType, pricingType, tiers) {
		return {Nx: description, adr: fixedAmountInCents, adR: id, afJ: percentage, afX: pricingType, ag3: splitType, $D: tiers};
	});
var $author$project$Api$Provider$PricingStructure$Shared$Record = F6(
	function (id, description, fixedAmountInCents, percentage, splitType, pricingType) {
		return {Nx: description, adr: fixedAmountInCents, adR: id, afJ: percentage, afX: pricingType, ag3: splitType};
	});
var $author$project$Api$PricingType$FixedAmountInCents = {$: 1};
var $author$project$Api$PricingType$Percentage = {$: 0};
var $author$project$Api$PricingType$PercentageAndFixedAmount = {$: 2};
var $author$project$Api$PricingType$Tiered = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$PricingType$decoder = F2(
	function (pricingTypeStr, tiers) {
		switch (pricingTypeStr) {
			case 'percentage':
				return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$Percentage);
			case 'fixed_amount_in_cents':
				return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$FixedAmountInCents);
			case 'percentage_and_fixed_amount':
				return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$PercentageAndFixedAmount);
			case 'tiered':
				return $elm$core$List$isEmpty(tiers) ? $elm$json$Json$Decode$fail('Must have tiers if tiered') : $elm$json$Json$Decode$succeed(
					$author$project$Api$PricingType$Tiered(tiers));
			default:
				var somethingElse = pricingTypeStr;
				return $elm$json$Json$Decode$fail('Unknown PricingType value: ' + somethingElse);
		}
	});
var $author$project$Api$Provider$PricingTier$Shared$PricingTier = $elm$core$Basics$identity;
var $author$project$Api$Provider$PricingTier$Shared$Record = F3(
	function (fixedAmountInCents, lowerBound, upperBound) {
		return {adr: fixedAmountInCents, Tb: lowerBound, aau: upperBound};
	});
var $author$project$Api$Provider$PricingTier$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'upper_bound',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lower_bound',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fixed_amount_in_cents',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingTier$Shared$Record))));
var $author$project$Api$Provider$PricingTier$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingTier$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$SplitType$AllMembers = 0;
var $author$project$Api$SplitType$Flat = 2;
var $author$project$Api$SplitType$PrimaryOnly = 1;
var $author$project$Api$SplitType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'all_members':
				return $elm$json$Json$Decode$succeed(0);
			case 'primary_only':
				return $elm$json$Json$Decode$succeed(1);
			case 'flat':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported Pricing Structure -> split_type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $author$project$Api$Provider$PricingStructure$Shared$recordDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (intermediate) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tiers',
			A2($author$project$Api$PricingType$decoder, intermediate.afX, intermediate.$D),
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				intermediate.ag3,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					intermediate.afJ,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						intermediate.adr,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							intermediate.Nx,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								intermediate.adR,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingStructure$Shared$Record)))))));
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tiers',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PricingTier$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'pricing_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'split_type',
				$author$project$Api$SplitType$decoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'percentage',
					$elm$json$Json$Decode$float,
					0.0,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'fixed_amount_in_cents',
						$elm$json$Json$Decode$int,
						0,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'description',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingStructure$Shared$IntermediateRecord)))))))));
var $author$project$Api$Provider$PricingStructure$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingStructure$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ApplicationFeePlan$One$Pmpm = {$: 1};
var $author$project$Api$Provider$ApplicationFeePlan$One$PmpmTiered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$ApplicationFeePlan$One$Transaction = {$: 0};
var $author$project$Api$Provider$PricingStructure$Shared$pricingType = function (_v0) {
	var record = _v0;
	return record.afX;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$pricedByDecoder = F2(
	function (pricedByStr, pricingStructure) {
		switch (pricedByStr) {
			case 'transaction':
				return $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Transaction);
			case 'pmpm':
				return $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Pmpm);
			case 'pmpm_tiered':
				if (pricingStructure.$ === 1) {
					return $elm$json$Json$Decode$fail('PMPM ApplicationFeePlans must have pricingStructure');
				} else {
					var structure = pricingStructure.a;
					var _v2 = $author$project$Api$Provider$PricingStructure$Shared$pricingType(structure);
					if (_v2.$ === 3) {
						var tiers = _v2.a;
						return $elm$json$Json$Decode$succeed(
							$author$project$Api$Provider$ApplicationFeePlan$One$PmpmTiered(tiers));
					} else {
						return $elm$json$Json$Decode$fail('PMPM Tiered ApplicationFeePlans must have tiers');
					}
				}
			default:
				var somethingElse = pricedByStr;
				return $elm$json$Json$Decode$fail('Unknown PricedBy value: ' + somethingElse);
		}
	});
var $author$project$Api$Provider$ApplicationFeePlan$One$recordDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (intermediate) {
		return A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tranche_size',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'ach_transaction_fee_cap_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total_card_fee_percentage',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'total_card_fee_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total_amex_fee_percentage',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'total_ach_fee_percentage',
								$elm$json$Json$Decode$float,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'total_ach_fee_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'minimum_per_month_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'collection_fee_percentage',
											$elm$json$Json$Decode$float,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'priced_by',
												A2($author$project$Api$Provider$ApplicationFeePlan$One$pricedByDecoder, intermediate.Bb, intermediate.W2),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Record)))))))))))));
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pricing_structure',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingStructure$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'priced_by',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$RecordIntermediate))));
var $author$project$Api$Provider$ApplicationFeePlan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ApplicationFeePlan$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ApplicationFeePlan$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$ApplicationFeePlan$applicationFeePlanPath));
	});
var $author$project$Pages$Admin$Billing$fetchApplicationFeePlan = function (apiClient) {
	return A2($author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotApplicationFeePlan);
};
var $author$project$Pages$Admin$Billing$GotPracticePricing = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticePricing$One$PracticePricing = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticePricing$One$Record = function (nextBillDate) {
	return function (products) {
		return function (includedMembers) {
			return function (includedRevenue) {
				return function (livesOveragePriceInCents) {
					return function (revenueOveragePriceInCents) {
						return function (txnFees) {
							return function (trancheBased) {
								return function (pmpmFeeInCents) {
									return function (trancheMembersCount) {
										return function (infoMessageTitle) {
											return function (infoMessageBody) {
												return function (manualBilling) {
													return function (hubspotDealUrl) {
														return function (currentMembers) {
															return {Mv: currentMembers, QB: hubspotDealUrl, adX: includedMembers, adY: includedRevenue, QX: infoMessageBody, QY: infoMessageTitle, aeq: livesOveragePriceInCents, Te: manualBilling, UC: nextBillDate, Wt: pmpmFeeInCents, Bc: products, YG: revenueOveragePriceInCents, ahD: trancheBased, ahE: trancheMembersCount, aaf: txnFees};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$HintBillingComponent$Shared$HintBillingComponent = $elm$core$Basics$identity;
var $author$project$Api$Provider$HintBillingComponent$Shared$Record = function (id) {
	return function (quantity) {
		return function (name) {
			return function (description) {
				return function (componentType) {
					return function (unitName) {
						return function (productType) {
							return function (addonType) {
								return function (priceInCents) {
									return function (startDate) {
										return function (endDate) {
											return function (isBillable) {
												return function (hintBillingProduct) {
													return {Ir: addonType, LC: componentType, Nx: description, qs: endDate, Qs: hintBillingProduct, adR: id, Ry: isBillable, zh: name, Ba: priceInCents, GT: productType, Bd: quantity, _E: startDate, aaj: unitName};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$HintBillingComponent$AddonType$Free = 3;
var $author$project$Api$Provider$HintBillingComponent$AddonType$OneTime = 2;
var $author$project$Api$Provider$HintBillingComponent$AddonType$Recurring = 0;
var $author$project$Api$Provider$HintBillingComponent$AddonType$RecurringQuantified = 1;
var $author$project$Api$Provider$HintBillingComponent$AddonType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'recurring':
				return $elm$json$Json$Decode$succeed(0);
			case 'recurring_quantified':
				return $elm$json$Json$Decode$succeed(1);
			case 'one_time':
				return $elm$json$Json$Decode$succeed(2);
			case 'free':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unsupported addon type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$HintBillingComponent$ComponentType$Addon = 1;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$BaseFee = 0;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$CliniciansPackage = 4;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$Discount = 5;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$LivesPackage = 2;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$RevenuePackage = 3;
var $author$project$Api$Provider$HintBillingComponent$ComponentType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'base_fee':
				return $elm$json$Json$Decode$succeed(0);
			case 'addon':
				return $elm$json$Json$Decode$succeed(1);
			case 'lives_package':
				return $elm$json$Json$Decode$succeed(2);
			case 'revenue_package':
				return $elm$json$Json$Decode$succeed(3);
			case 'discount':
				return $elm$json$Json$Decode$succeed(5);
			case 'clinicians_package':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Unsupported component type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$HintBillingComponent$ProductType$Clinical = 1;
var $author$project$Api$Provider$HintBillingComponent$ProductType$Core = 0;
var $author$project$Api$Provider$HintBillingComponent$ProductType$Thea = 2;
var $author$project$Api$Provider$HintBillingComponent$ProductType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'core':
				return $elm$json$Json$Decode$succeed(0);
			case 'clinical':
				return $elm$json$Json$Decode$succeed(1);
			case 'thea':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported component type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$HintBillingComponent$UnitName$Clinician = 4;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Copilot = 5;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Dollar = 1;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Feed = 3;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Integration = 2;
var $author$project$Api$Provider$HintBillingComponent$UnitName$Member = 0;
var $author$project$Api$Provider$HintBillingComponent$UnitName$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'member':
				return $elm$json$Json$Decode$succeed(0);
			case 'dollar':
				return $elm$json$Json$Decode$succeed(1);
			case 'integration':
				return $elm$json$Json$Decode$succeed(2);
			case 'feed':
				return $elm$json$Json$Decode$succeed(3);
			case 'clinician':
				return $elm$json$Json$Decode$succeed(4);
			case 'copilot':
				return $elm$json$Json$Decode$succeed(5);
			default:
				return $elm$json$Json$Decode$fail('Unsupported unit name: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$HintBillingProduct$Shared$HintBillingProduct = $elm$core$Basics$identity;
var $author$project$Api$Provider$HintBillingProduct$Shared$Record = F7(
	function (id, name, componentType, unitName, productType, addonType, archived) {
		return {Ir: addonType, Jn: archived, LC: componentType, adR: id, zh: name, GT: productType, aaj: unitName};
	});
var $author$project$Api$Provider$HintBillingProduct$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'archived',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'addon_type',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$AddonType$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'product',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$ProductType$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'unit_name',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$UnitName$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'component_type',
					$author$project$Api$Provider$HintBillingComponent$ComponentType$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$HintBillingProduct$Shared$Record))))))));
var $author$project$Api$Provider$HintBillingProduct$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$HintBillingProduct$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$HintBillingComponent$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hint_billing_product',
	$author$project$Api$Provider$HintBillingProduct$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_billable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'price_in_cents',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'addon_type',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$AddonType$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'product',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$ProductType$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'unit_name',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$UnitName$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'component_type',
									$author$project$Api$Provider$HintBillingComponent$ComponentType$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'description',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'quantity',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$HintBillingComponent$Shared$Record))))))))))))));
var $author$project$Api$Provider$HintBillingComponent$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$HintBillingComponent$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TxnFees$TxnFees = $elm$core$Basics$identity;
var $author$project$Api$Provider$TxnFees$TxnFeesRecord = F6(
	function (totalAchFeeInCents, totalAchFeePercentage, totalAmexFeePercentage, totalCardFeeInCents, totalCardFeePercentage, achTransactionFeeCapInCents) {
		return {H9: achTransactionFeeCapInCents, $R: totalAchFeeInCents, $S: totalAchFeePercentage, $T: totalAmexFeePercentage, $U: totalCardFeeInCents, HB: totalCardFeePercentage};
	});
var $author$project$Api$Provider$TxnFees$txnFeesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ach_transaction_fee_cap_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total_card_fee_percentage',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'total_card_fee_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total_amex_fee_percentage',
				$elm$json$Json$Decode$float,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'total_ach_fee_percentage',
					$elm$json$Json$Decode$float,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'total_ach_fee_in_cents',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$TxnFees$TxnFeesRecord)))))));
var $author$project$Api$Provider$TxnFees$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TxnFees$txnFeesRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticePricing$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'current_members',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hubspot_deal_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'manual_billing',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'info_message_body',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'info_message_title',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tranche_members_count',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'pmpm_fee_in_cents',
							$elm$json$Json$Decode$float,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'tranche_based',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'txn_fees',
									$author$project$Api$Provider$TxnFees$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'revenue_overage_price_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'lives_overage_price_in_cents',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'included_revenue',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'included_members',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'products',
														$elm$json$Json$Decode$list($author$project$Api$Provider$HintBillingComponent$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'next_bill_date',
															$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
															$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$One$Record))))))))))))))));
var $author$project$Api$Provider$PracticePricing$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticePricing$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticePricing$practiceSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice/pricing']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticePricing$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticePricing$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$practiceSettingsPath));
	});
var $author$project$Pages$Admin$Billing$fetchPracticePricing = function (apiClient) {
	return A2($author$project$Api$Provider$PracticePricing$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotPracticePricing);
};
var $author$project$Pages$Admin$Billing$GotUpgradePricing = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$PracticePricing$Upgrade$UpgradePricing = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticePricing$Upgrade$Record = F6(
	function (tierName, currentTierName, totalInCents, nextBillDate, components, txnFees) {
		return {LD: components, My: currentTierName, UC: nextBillDate, $C: tierName, $X: totalInCents, aaf: txnFees};
	});
var $author$project$Api$Provider$PracticePricing$Upgrade$componentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'component_type',
	$author$project$Api$Provider$HintBillingComponent$ComponentType$decode,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'old_price_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'quantity',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'price_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed(
						F5(
							function (name, priceInCents, quantity, oldPriceInCents, componentType) {
								return {LC: componentType, zh: name, UY: oldPriceInCents, Ba: priceInCents, Bd: quantity};
							})))))));
var $author$project$Api$Provider$PracticePricing$Upgrade$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'txn_fees',
	$author$project$Api$Provider$TxnFees$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'components',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PracticePricing$Upgrade$componentDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'next_bill_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'current_tier_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'tier_name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$Upgrade$Record)))))));
var $author$project$Api$Provider$PracticePricing$Upgrade$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PracticePricing$Upgrade$recordDecoder);
var $author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice', 'pricing', 'upgrade']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticePricing$Upgrade$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticePricing$Upgrade$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath));
	});
var $author$project$Pages$Admin$Billing$fetchUpgradePricing = function (apiClient) {
	return A2($author$project$Api$Provider$PracticePricing$Upgrade$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotUpgradePricing);
};
var $author$project$Pages$Admin$Billing$fetchPricingData = function (apiClient) {
	return _List_fromArray(
		[
			$author$project$Pages$Admin$Billing$fetchApplicationFeePlan(apiClient),
			$author$project$Pages$Admin$Billing$fetchPracticePricing(apiClient),
			$author$project$Pages$Admin$Billing$fetchUpgradePricing(apiClient)
		]);
};
var $author$project$Pages$Admin$Billing$GotUninvoicedCharges = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$PracticeCharge$All$PracticeCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeCharge$Shared$PracticeCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeCharge$Shared$Record = F7(
	function (id, description, serviceDescription, quantity, priceInCents, subtotalInCents, fromRecurringCharge) {
		return {Nx: description, PI: fromRecurringCharge, adR: id, Ba: priceInCents, Bd: quantity, ZC: serviceDescription, _7: subtotalInCents};
	});
var $author$project$Api$Provider$PracticeCharge$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'from_recurring_charge',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'subtotal_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'price_in_cents',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'quantity',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'service_description',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeCharge$Shared$Record))))))));
var $author$project$Api$Provider$PracticeCharge$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeCharge$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeCharge$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeCharge$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeCharge$listDefaults = {Rh: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$PracticeCharge$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$PracticeCharge$listDefaults);
	var _v0 = options.Rh;
	if (!_v0.$) {
		var invoice = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'invoice', invoice)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$PracticeCharge$practiceChargesPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practice/charges']),
		basePath);
};
var $author$project$Api$Provider$PracticeCharge$list = F4(
	function (basePath, apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeCharge$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$PracticeCharge$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeCharge$practiceChargesPath(basePath))));
	});
var $author$project$Pages$Admin$Billing$fetchUninvoicedCharges = function (apiClient) {
	return A4(
		$author$project$Api$Provider$PracticeCharge$list,
		$author$project$Api$Data$providerPath,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					Rh: $elm$core$Maybe$Just('')
				});
		},
		$author$project$Pages$Admin$Billing$GotUninvoicedCharges);
};
var $author$project$Api$Provider$ManagementGroup$Shared$ManagementGroup = $elm$core$Basics$identity;
var $author$project$Api$Provider$ManagementGroup$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$ManagementGroup$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagementGroup$Shared$Record)));
var $author$project$Api$Provider$ManagementGroup$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ManagementGroup$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagementGroup$resourcePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['management_group']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagementGroup$getCurrent = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ManagementGroup$Shared$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath));
	});
var $author$project$Api$Provider$Practice$Shared$hasClinicalAccount = function (_v0) {
	var record = _v0;
	return record.P2;
};
var $author$project$Api$Provider$Practice$One$hasClinicalAccount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$hasClinicalAccount(shared);
};
var $author$project$Components$HintBilling$InvoicesTable$Model = $elm$core$Basics$identity;
var $author$project$Components$HintBilling$InvoicesTable$init = function (currentDate) {
	return {cO: currentDate, q2: _List_Nil, S_: false};
};
var $author$project$Api$Feature$StripeCapital = 24;
var $author$project$Api$Provider$Practice$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$Practice$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$paymentProcessor(shared);
};
var $author$project$Pages$Admin$Billing$shouldShowCapitalTile = function (practice) {
	return ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') && A2($author$project$Api$Provider$Practice$One$featureEnabled, 24, practice);
};
var $author$project$Components$HintBilling$InvoicesTable$withLoadingStatus = F2(
	function (loadingStatus, _v0) {
		var record = _v0;
		return _Utils_update(
			record,
			{S_: loadingStatus});
	});
var $author$project$Pages$Admin$Billing$init = F4(
	function (session, practice, shared, _v0) {
		var model = {
			D5: shared.D5,
			pD: $author$project$Api$Data$Loading,
			vW: $elm$core$Maybe$Nothing,
			pL: $author$project$Api$Data$NotAsked,
			pN: $author$project$Api$Data$Loading,
			hW: $elm$core$Maybe$Nothing,
			cO: shared.cO,
			me: $author$project$Api$Data$Loading,
			P2: $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice),
			FR: $author$project$Shared$isHintAdmin(shared),
			WF: practice,
			ek: $author$project$Api$Pagination$init,
			AV: $author$project$Api$Data$Loading,
			jz: A2(
				$author$project$Components$HintBilling$InvoicesTable$withLoadingStatus,
				true,
				$author$project$Components$HintBilling$InvoicesTable$init(shared.cO)),
			ck: $author$project$Api$Data$Loading,
			ZD: session,
			Hy: shared.Hy,
			oW: _List_Nil,
			ct: $author$project$Pages$Admin$Billing$NotInitialized,
			o2: $elm$core$Maybe$Nothing,
			kC: $elm$core$Maybe$Nothing
		};
		var managementGroupCmd = $author$project$Pages$Admin$Billing$shouldShowCapitalTile(practice) ? A2($author$project$Api$Provider$ManagementGroup$getCurrent, shared.D5, $author$project$Pages$Admin$Billing$GotManagementGroup) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					managementGroupCmd,
					A2(
						$elm$core$List$cons,
						A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, shared.D5, model.ek),
						A2(
							$elm$core$List$cons,
							$author$project$Pages$Admin$Billing$fetchCards(shared.D5),
							A2(
								$elm$core$List$cons,
								$author$project$Pages$Admin$Billing$fetchBankAccounts(shared.D5),
								A2(
									$elm$core$List$cons,
									$author$project$Pages$Admin$Billing$fetchUninvoicedCharges(shared.D5),
									$author$project$Pages$Admin$Billing$fetchPricingData(shared.D5))))))));
	});
var $author$project$Pages$Admin$Billing$load = F2(
	function (shared, model) {
		var _v0 = _Utils_Tuple2(shared.WF, shared.ZD);
		if (((_v0.a.$ === 3) && (!_v0.a.a.$)) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var practice = _v1.a.a;
			var _v2 = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{D5: shared.D5, WF: practice}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Admin$Billing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Billing$CapitalOfferLoaded = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$Billing$CreateChargeModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Billing$UpdateModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ports$Stripe$stripePortOnCapitalOfferLoaded = _Platform_incomingPort('stripePortOnCapitalOfferLoaded', $elm$json$Json$Decode$string);
var $author$project$Ports$Stripe$onCapitalOfferLoaded = $author$project$Ports$Stripe$stripePortOnCapitalOfferLoaded;
var $author$project$Components$ApplicationFeePlan$UpdateModal$Close = {$: 0};
var $author$project$Components$ApplicationFeePlan$UpdateModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$ApplicationFeePlan$UpdateModal$Close);
};
var $author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked = {$: 0};
var $author$project$Components$HintBilling$CreateChargeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked);
};
var $author$project$Components$UpgradePracticeModal$Close = {$: 0};
var $author$project$Components$UpgradePracticeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$UpgradePracticeModal$Close);
};
var $author$project$Pages$Admin$Billing$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.ct;
				if (!_v0.$) {
					return $elm$core$Platform$Sub$none;
				} else {
					var updateModal = _v0.b;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Admin$Billing$UpdateModalMsg,
						$author$project$Components$ApplicationFeePlan$UpdateModal$subscriptions(updateModal));
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$CreateChargeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$HintBilling$CreateChargeModal$subscriptions, model.hW))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$UpgradePracticeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$UpgradePracticeModal$subscriptions, model.kC))),
				$author$project$Ports$Stripe$onCapitalOfferLoaded($author$project$Pages$Admin$Billing$CapitalOfferLoaded)
			]));
};
var $author$project$Pages$Admin$Billing$GotCapitalSession = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$Billing$Initialized = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Billing$InvoiceCreated = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeChargeDeleted = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeInvoice$One$PracticeInvoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeInvoice$One$Record = F9(
	function (autoPayEnabled, autoPayDate, invoiceType, securePdfInlineToken, securePdfPrintableToken, source, payments, charges, purchaseOrderNumber) {
		return {JF: autoPayDate, JG: autoPayEnabled, KU: charges, Rr: invoiceType, V5: payments, Xq: purchaseOrderNumber, Ze: securePdfInlineToken, agK: securePdfPrintableToken, Hg: source};
	});
var $author$project$Api$Common$Source$Shared$Source = $elm$core$Basics$identity;
var $author$project$Api$Common$Source$Shared$Record = function (type_) {
	return function (id) {
		return function (name) {
			return function (label) {
				return function (status) {
					return function (lastFour) {
						return function (createdAt) {
							return function (external) {
								return function (oneTimeUse) {
									return function (paymentProcessor) {
										return function (funding) {
											return {Mf: createdAt, O4: external, PK: funding, adR: id, aej: label, Sz: lastFour, zh: name, U7: oneTimeUse, V0: paymentProcessor, ag7: status, ahI: type_};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Source$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'funding',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'payment_processor',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'one_time_use',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'external',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'created_at',
					$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'last_four',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'status',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'label',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'id',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'type',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$core$Maybe$Nothing,
											$elm$json$Json$Decode$succeed($author$project$Api$Common$Source$Shared$Record))))))))))));
var $author$project$Api$Common$Source$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Source$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$File$Token$Token = $elm$core$Basics$identity;
var $author$project$Api$File$Token$decoder = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		return string;
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Payment$One$Payment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Payment$Shared$Payment = $elm$core$Basics$identity;
var $author$project$Api$Provider$Payment$Shared$Record = function (id) {
	return function (status) {
		return function (amountInCents) {
			return function (attemptedInCents) {
				return function (paidAt) {
					return function (createdAt) {
						return function (errorMessage) {
							return function (external) {
								return function (memo) {
									return function (isRefundable) {
										return function (isRefundableOnPaymentProcessor) {
											return function (source) {
												return function (passthroughFees) {
													return function (paymentProcessor) {
														return function (cardReader) {
															return function (isCancelable) {
																return function (errorCode) {
																	return {I2: amountInCents, Jw: attemptedInCents, abR: cardReader, Mf: createdAt, OM: errorCode, ON: errorMessage, O4: external, adR: id, RA: isCancelable, R3: isRefundable, R4: isRefundableOnPaymentProcessor, aeC: memo, Vt: paidAt, VJ: passthroughFees, V0: paymentProcessor, Hg: source, ag7: status};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CardReader$Shared$CardReader = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReader$Shared$Record = F4(
	function (id, label, serialNumber, paymentProcessor) {
		return {adR: id, aej: label, V0: paymentProcessor, Zy: serialNumber};
	});
var $author$project$Api$Provider$CardReader$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'serial_number',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'label',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$Shared$Record)))));
var $author$project$Api$Provider$CardReader$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReader$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Payment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error_code',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_cancelable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'card_reader',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$CardReader$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'payment_processor',
				$elm$json$Json$Decode$string,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'passthrough_fees',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'source',
						$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_refundable_on_payment_processor',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_refundable',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'memo',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'external',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'error_message',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'created_at',
												$elm_community$json_extra$Json$Decode$Extra$datetime,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'paid_at',
													$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'attempted_in_cents',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'amount_in_cents',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'status',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$Shared$Record))))))))))))))))));
var $author$project$Api$Provider$Payment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Payment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Payment$One$Record = F3(
	function (createdBy, refunds, dispute) {
		return {Mg: createdBy, NQ: dispute, X3: refunds};
	});
var $author$project$Api$Provider$Dispute$Shared$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Provider$Dispute$Shared$Record = F2(
	function (id, status) {
		return {adR: id, ag7: status};
	});
var $author$project$Api$Provider$Dispute$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Dispute$Shared$Record)));
var $author$project$Api$Provider$Dispute$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Dispute$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Payment$Creator$Creator = $elm$core$Basics$identity;
var $author$project$Api$Provider$Payment$Creator$Record = function (name) {
	return {zh: name};
};
var $author$project$Api$Provider$Payment$Creator$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$Creator$Record));
var $author$project$Api$Provider$Payment$Creator$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Payment$Creator$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Refund$One$Refund = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Refund$Shared$Refund = $elm$core$Basics$identity;
var $author$project$Api$Provider$Refund$Shared$Record = F8(
	function (id, status, createdAt, external, memo, amountInCents, paymentProcessor, errorMessage) {
		return {I2: amountInCents, Mf: createdAt, ON: errorMessage, O4: external, adR: id, aeC: memo, V0: paymentProcessor, ag7: status};
	});
var $author$project$Api$Provider$Refund$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error_message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'amount_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'memo',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'external',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_at',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$Shared$Record)))))))));
var $author$project$Api$Provider$Refund$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Refund$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Refund$One$Record = function (createdBy) {
	return {Mg: createdBy};
};
var $author$project$Api$Provider$User$Shared$User = $elm$core$Basics$identity;
var $author$project$Api$Provider$User$Shared$Record = F3(
	function (name, displayName, isAdmin) {
		return {NP: displayName, Ru: isAdmin, zh: name};
	});
var $author$project$Api$Provider$User$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_admin',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'display_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$User$Shared$Record))));
var $author$project$Api$Provider$User$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$User$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Refund$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_by',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$One$Record));
var $author$project$Api$Provider$Refund$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Refund$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Refund$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$One$Refund)));
var $author$project$Api$Provider$Payment$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dispute',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Dispute$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'refunds',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Refund$One$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_by',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Payment$Creator$decoder),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$One$Record))));
var $author$project$Api$Provider$Payment$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Payment$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Payment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$One$Payment)));
var $author$project$Api$Provider$PracticeInvoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'purchase_order_number',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeCharge$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payments',
			$elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'source',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'secure_pdf_printable_token',
					$author$project$Api$File$Token$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'secure_pdf_inline_token',
						$author$project$Api$File$Token$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'invoice_type',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auto_pay_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auto_pay_enabled',
									$elm$json$Json$Decode$bool,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$One$Record))))))))));
var $author$project$Api$Provider$PracticeInvoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeInvoice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PracticeInvoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$One$PracticeInvoice)));
var $author$project$Api$Provider$PracticeInvoice$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath));
	});
var $author$project$Api$Provider$PracticeCharge$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id_]),
					$author$project$Api$Provider$PracticeCharge$practiceChargesPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Api$Provider$PracticeCharge$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$PracticeCharge$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$description(shared);
};
var $author$project$Api$Provider$PracticePricing$One$hubspotDealUrl = function (_v0) {
	var record = _v0;
	return record.QB;
};
var $author$project$Api$Provider$PracticeCharge$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PracticeCharge$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$id(shared);
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$GotCategories = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$HintBillingComponent$Shared$isBillable = function (_v0) {
	var record = _v0;
	return record.Ry;
};
var $author$project$Api$Provider$PracticePricing$One$billableProducts = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$List$filter,
		function (product) {
			return $author$project$Api$Provider$HintBillingComponent$Shared$isBillable(product);
		},
		record.Bc);
};
var $author$project$Formatters$Date$Full = {$: 0};
var $author$project$Api$Provider$HintBillingComponent$Shared$componentType = function (_v0) {
	var record = _v0;
	return record.LC;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Currency$Currency = $elm$core$Basics$identity;
var $myrho$elm_round$Round$funNum = F3(
	function (fun, s, fl) {
		return A2(
			$elm$core$Maybe$withDefault,
			0 / 0,
			$elm$core$String$toFloat(
				A2(fun, s, fl)));
	});
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $elm$core$Char$fromCode = _Char_fromCode;
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $myrho$elm_round$Round$roundNum = $myrho$elm_round$Round$funNum($myrho$elm_round$Round$round);
var $author$project$Utils$Round$float = function (value) {
	return A2($myrho$elm_round$Round$roundNum, 5, value);
};
var $author$project$Currency$fromFloat = function (_float) {
	return $elm$core$String$fromFloat(
		$author$project$Utils$Round$float(_float / 100));
};
var $author$project$Api$Provider$HintBillingComponent$Shared$hintBillingProduct = function (_v0) {
	var record = _v0;
	return record.Qs;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$HintBillingProduct$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents = function (_v0) {
	var record = _v0;
	return record.Ba;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Bd;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$toMonths = function (rd) {
	var date = $justinmimbs$date$Date$toCalendarDate(rd);
	var wholeMonths = (12 * (date.ahX - 1)) + ($justinmimbs$date$Date$monthToNumber(date.aeI) - 1);
	return wholeMonths + (date.acq / 100);
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $justinmimbs$date$Date$diff = F3(
	function (unit, _v0, _v1) {
		var rd1 = _v0;
		var rd2 = _v1;
		switch (unit) {
			case 0:
				return ((($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0) / 12) | 0;
			case 1:
				return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1)) | 0;
			case 2:
				return ((rd2 - rd1) / 7) | 0;
			default:
				return rd2 - rd1;
		}
	});
var $author$project$Formatters$Date$relative = F3(
	function (currentDate, option, date) {
		var diff = A3($justinmimbs$date$Date$diff, 3, currentDate, date);
		return ((!_Utils_eq(
			option,
			$elm$core$Maybe$Just('bill'))) && (_Utils_cmp(diff, -1) < 1)) ? ((_Utils_cmp(diff, -7) < 1) ? A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date) : ((_Utils_cmp(diff, -2) < 1) ? ($elm$core$String$fromInt((-1) * diff) + ' days ago') : 'Yesterday')) : ((diff <= 0) ? 'Today' : ((diff === 1) ? 'Tomorrow' : ((diff < 7) ? ('in ' + ($elm$core$String$fromInt(diff) + ' days')) : A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date))));
	});
var $author$project$Formatters$Date$timeago = F3(
	function (currentDate, type_, date) {
		var diff = A3($justinmimbs$date$Date$diff, 3, date, currentDate);
		return (_Utils_eq(
			type_,
			$elm$core$Maybe$Just('days')) && (!diff)) ? 'today' : ((_Utils_eq(
			type_,
			$elm$core$Maybe$Just('days')) && (diff === 1)) ? 'tomorrow' : A3($author$project$Formatters$Date$relative, currentDate, $elm$core$Maybe$Nothing, date));
	});
var $author$project$Formatters$Date$toString = F2(
	function (format, date) {
		switch (format.$) {
			case 0:
				return A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
			case 1:
				return A2($justinmimbs$date$Date$format, 'MMMM ddd', date);
			case 2:
				return A2($justinmimbs$date$Date$format, 'MMMM yyyy', date);
			case 3:
				return A2($justinmimbs$date$Date$format, 'MMMM ddd, yyyy', date);
			case 4:
				var currentDate = format.a;
				var option = format.b;
				return A3($author$project$Formatters$Date$relative, currentDate, option, date);
			default:
				var currentDate = format.a;
				var type_ = format.b;
				return A3($author$project$Formatters$Date$timeago, currentDate, type_, date);
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initHintCustomerProduct = function (charge) {
	var priceInCents = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(charge);
	return {
		Nx: $author$project$Api$Provider$HintBillingComponent$Shared$description(charge),
		qs: $author$project$Api$Provider$HintBillingComponent$Shared$endDate(charge),
		xr: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
				$author$project$Api$Provider$HintBillingComponent$Shared$endDate(charge))),
		iN: $author$project$Api$Provider$HintBillingComponent$Shared$componentType(charge),
		Qt: $author$project$Api$Provider$HintBillingProduct$Shared$id(
			$author$project$Api$Provider$HintBillingComponent$Shared$hintBillingProduct(charge)),
		adR: $elm$core$Maybe$Just(
			$author$project$Api$Provider$HintBillingComponent$Shared$id(charge)),
		Ba: $elm$core$Maybe$Just(
			$author$project$Currency$fromFloat(priceInCents)),
		Bd: A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Api$Provider$HintBillingComponent$Shared$quantity(charge)),
		_E: $author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge),
		_G: A2(
			$author$project$Formatters$Date$toString,
			$author$project$Formatters$Date$Full,
			$author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge))
	};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initFormFieldsFromPracticePlan = function (charges) {
	var recurringCharges = A2($elm$core$List$map, $author$project$Components$ApplicationFeePlan$UpdateModalForm$initHintCustomerProduct, charges);
	return {JT: $elm$core$Maybe$Nothing, KU: recurringCharges, QA: $elm$core$Maybe$Nothing};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$init = function (charges) {
	return $author$project$Utils$Form$init(
		$author$project$Components$ApplicationFeePlan$UpdateModalForm$initFormFieldsFromPracticePlan(charges));
};
var $author$project$Api$Provider$PracticePricing$One$isLegacyPricing = function (practicePricing) {
	return $elm$core$List$isEmpty(
		A2(
			$elm$core$List$filter,
			function (billingComponent) {
				return !$author$project$Api$Provider$HintBillingComponent$Shared$componentType(billingComponent);
			},
			$author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing)));
};
var $author$project$Api$Provider$HintBillingProduct$billingComponentsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['billing_components']),
	A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['pricing']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['practice']),
			$author$project$Api$Data$providerPath)));
var $author$project$Api$Provider$HintBillingProduct$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$HintBillingProduct$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$HintBillingProduct$billingComponentsPath));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$init = F4(
	function (apiClient, currentDate, practicePricing, hubspotDealUrl) {
		var charges = $author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing);
		return _Utils_Tuple2(
			{
				KL: _List_Nil,
				KU: charges,
				cO: currentDate,
				PB: $author$project$Components$ApplicationFeePlan$UpdateModalForm$init(charges),
				QB: hubspotDealUrl,
				aee: !$author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing),
				ci: $elm$core$Dict$empty,
				jF: $jinjor$elm_debounce$Debounce$init
			},
			A2($author$project$Api$Provider$HintBillingProduct$list, apiClient, $author$project$Components$ApplicationFeePlan$UpdateModal$GotCategories));
	});
var $author$project$Components$HintBilling$CreateChargeModal$GotCategories = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$HintBilling$CreateChargeModal$formFieldInit = function (practiceInvoice) {
	return {
		iN: $elm$core$Maybe$Nothing,
		Qs: $elm$core$Maybe$Nothing,
		zh: '',
		WH: practiceInvoice,
		Ba: $elm$core$Maybe$Nothing,
		Bd: $elm$core$Maybe$Just(1)
	};
};
var $author$project$Components$HintBilling$CreateChargeModal$init = F2(
	function (apiClient, practiceInvoice) {
		return _Utils_Tuple2(
			{
				KL: _List_Nil,
				PB: $author$project$Utils$Form$init(
					$author$project$Components$HintBilling$CreateChargeModal$formFieldInit(practiceInvoice)),
				ns: $elm$core$Maybe$Nothing,
				jF: $jinjor$elm_debounce$Debounce$init
			},
			A2($author$project$Api$Provider$HintBillingProduct$list, apiClient, $author$project$Components$HintBilling$CreateChargeModal$GotCategories));
	});
var $author$project$Api$Provider$PracticePricing$Upgrade$currentTierName = function (_v0) {
	var record = _v0;
	return record.My;
};
var $author$project$Api$Platform$Session$One$organizationIsCompany = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq(1),
			A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.Vd)));
};
var $author$project$Utils$Analytics$Shared$AnalyticsProperty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Utils$Analytics$Shared$property = F2(
	function (key, value) {
		return A2($author$project$Utils$Analytics$Shared$AnalyticsProperty, key, value);
	});
var $author$project$Utils$Analytics$Shared$appProperty = function (session) {
	var organizationIsCompany = $author$project$Api$Platform$Session$One$organizationIsCompany(session);
	var appName = organizationIsCompany ? 'employer' : 'core';
	return A2($author$project$Utils$Analytics$Shared$property, 'app', appName);
};
var $author$project$Utils$Analytics$HintBilling$currentTierProperty = function (value) {
	return A2($author$project$Utils$Analytics$Shared$property, 'current_tier', value);
};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Ports$FullStory$encodeEvent = F2(
	function (type_, payload) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(type_)),
					_Utils_Tuple2('payload', payload)
				]));
	});
var $author$project$Ports$FullStory$encodeSimpleEvent = F2(
	function (type_, payload) {
		return A2(
			$author$project$Ports$FullStory$encodeEvent,
			type_,
			A3(
				$elm$json$Json$Encode$dict,
				$elm$core$Basics$identity,
				$elm$json$Json$Encode$string,
				$elm$core$Dict$fromList(payload)));
	});
var $author$project$Ports$FullStory$fullStoryPortLogEvent = _Platform_outgoingPort('fullStoryPortLogEvent', $elm$core$Basics$identity);
var $author$project$Ports$FullStory$logEvent = F2(
	function (type_, payload) {
		return $author$project$Ports$FullStory$fullStoryPortLogEvent(
			A2($author$project$Ports$FullStory$encodeSimpleEvent, type_, payload));
	});
var $author$project$Ports$Intercom$encodeEvent = F2(
	function (type_, payload) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(type_)),
					_Utils_Tuple2('payload', payload)
				]));
	});
var $author$project$Ports$Intercom$encodeSimpleEvent = F2(
	function (type_, payload) {
		return A2(
			$author$project$Ports$Intercom$encodeEvent,
			type_,
			A3(
				$elm$json$Json$Encode$dict,
				$elm$core$Basics$identity,
				$elm$json$Json$Encode$string,
				$elm$core$Dict$fromList(payload)));
	});
var $author$project$Ports$Intercom$intercomPortLogEvent = _Platform_outgoingPort('intercomPortLogEvent', $elm$core$Basics$identity);
var $author$project$Ports$Intercom$logEvent = F2(
	function (type_, payload) {
		return $author$project$Ports$Intercom$intercomPortLogEvent(
			A2($author$project$Ports$Intercom$encodeSimpleEvent, type_, payload));
	});
var $author$project$Utils$Analytics$Shared$propertyToTuple = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return _Utils_Tuple2(key, value);
};
var $author$project$Utils$Analytics$Shared$logSimpleEvent = F2(
	function (eventName, properties) {
		var propertyTuples = A2($elm$core$List$map, $author$project$Utils$Analytics$Shared$propertyToTuple, properties);
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Ports$FullStory$logEvent, eventName, propertyTuples),
					A2($author$project$Ports$Intercom$logEvent, eventName, propertyTuples)
				]));
	});
var $author$project$Utils$Analytics$HintBilling$newTierProperty = function (value) {
	return A2($author$project$Utils$Analytics$Shared$property, 'new_tier', value);
};
var $author$project$Utils$Analytics$HintBilling$logEventWithTiers = F4(
	function (session, currentTier, newTier, eventName) {
		return A2(
			$author$project$Utils$Analytics$Shared$logSimpleEvent,
			eventName,
			_List_fromArray(
				[
					$author$project$Utils$Analytics$Shared$appProperty(session),
					$author$project$Utils$Analytics$HintBilling$currentTierProperty(currentTier),
					$author$project$Utils$Analytics$HintBilling$newTierProperty(newTier)
				]));
	});
var $author$project$Api$Provider$PracticePricing$Upgrade$tierName = function (_v0) {
	var record = _v0;
	return record.$C;
};
var $author$project$Components$UpgradePracticeModal$logActionPerformedEvent = F3(
	function (session, pricing, eventName) {
		if (!pricing.$) {
			var pricing_ = pricing.a;
			return A4(
				$author$project$Utils$Analytics$HintBilling$logEventWithTiers,
				session,
				$author$project$Api$Provider$PracticePricing$Upgrade$currentTierName(pricing_),
				$author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing_),
				eventName);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$UpgradePracticeModal$init = F3(
	function (upgradePricing, session, hasClinicalAccount) {
		return _Utils_Tuple2(
			{abc: false, P2: hasClinicalAccount, iY: false, ZD: session, g8: upgradePricing},
			A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, session, upgradePricing, 'Self Buy Upgrade Modal Opened'));
	});
var $author$project$Utils$Analytics$HintBilling$linkTextProperty = function (value) {
	return A2($author$project$Utils$Analytics$Shared$property, 'link_text', value);
};
var $author$project$Utils$Analytics$HintBilling$targetUrlProperty = function (value) {
	return A2($author$project$Utils$Analytics$Shared$property, 'target_url', value);
};
var $author$project$Utils$Analytics$HintBilling$logLinkClickedEvent = F3(
	function (session, linkText, targetUrl) {
		return A2(
			$author$project$Utils$Analytics$Shared$logSimpleEvent,
			'Self Buy Upgrade Link Clicked',
			_List_fromArray(
				[
					$author$project$Utils$Analytics$Shared$appProperty(session),
					$author$project$Utils$Analytics$HintBilling$linkTextProperty(linkText),
					$author$project$Utils$Analytics$HintBilling$targetUrlProperty(targetUrl)
				]));
	});
var $author$project$Ports$Stripe$stripePortMountCapitalPromoTile = _Platform_outgoingPort(
	'stripePortMountCapitalPromoTile',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.be)),
					_Utils_Tuple2(
					'stripeClientSecret',
					$elm$json$Json$Encode$string($.oC))
				]));
	});
var $author$project$Ports$Stripe$mountCapitalPromoTile = F2(
	function (selector, stripeClientSecret) {
		return $author$project$Ports$Stripe$stripePortMountCapitalPromoTile(
			{be: selector, oC: stripeClientSecret});
	});
var $author$project$Ports$Navigation$navigationLoad = _Platform_outgoingPort('navigationLoad', $elm$json$Json$Encode$string);
var $author$project$Ports$Navigation$load = $author$project$Ports$Navigation$navigationLoad;
var $author$project$Utils$Route$navigateAndReload = F2(
	function (params, route) {
		return $author$project$Ports$Navigation$load(
			A2($author$project$Utils$Route$toString, params, route));
	});
var $author$project$Pages$Admin$Billing$GotChargeCreated = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Provider$PracticeCharge$One$PracticeCharge = 0;
var $author$project$Api$Provider$PracticeCharge$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Utils$Encode$association = function (id) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(id))
			]));
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Api$Provider$PracticeCharge$encodeChargeParams = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(fields.Nx)),
				_Utils_Tuple2(
				'quantity',
				$elm$json$Json$Encode$int(fields.Bd)),
				_Utils_Tuple2(
				'price_in_cents',
				$elm$json$Json$Encode$float(fields.Ba)),
				_Utils_Tuple2(
				'hint_billing_product',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Qt))
			]));
};
var $author$project$Api$Provider$PracticeCharge$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$author$project$Api$Provider$PracticeCharge$encodeChargeParams(fields))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeCharge$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeCharge$practiceChargesPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$Admin$Billing$saveCharge = F2(
	function (apiClient, chargeParams) {
		return A3($author$project$Api$Provider$PracticeCharge$create, apiClient, chargeParams, $author$project$Pages$Admin$Billing$GotChargeCreated);
	});
var $author$project$Api$Provider$Practice$StripeAccount$sessionDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['session_key']),
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['stripe_account']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$StripeAccount$session = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$StripeAccount$sessionDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['session']),
					$author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
	});
var $author$project$Api$Pagination$totalCountFromHeaders = F2(
	function (headers, _v0) {
		var model = _v0;
		var totalCount = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, 'x-total-count', headers)));
		return _Utils_update(
			model,
			{oN: totalCount});
	});
var $author$project$Api$Pagination$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var _int = msg;
		return _Utils_update(
			model,
			{bV: _int});
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$ApplicationFeePlanUpdated = 2;
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$Closed = 1;
var $author$project$Components$ApplicationFeePlan$UpdateModal$HubspotDealUpdated = 3;
var $author$project$Components$ApplicationFeePlan$UpdateModal$None = 0;
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Ui$Toast$Warning = 2;
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeComponentTypeChanged = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Currency$toString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Currency$toFloat = A2(
	$elm$core$Basics$composeR,
	$author$project$Currency$toString,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$toFloat,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				$elm$core$Basics$mul(100)),
			$elm$core$Maybe$map($author$project$Utils$Round$float))));
var $author$project$Utils$Billing$ProductPrice$convertPriceInCents = F2(
	function (currencyPrice, componentType) {
		return A2(
			$elm$core$Maybe$andThen,
			function (priceInCents) {
				if (!priceInCents) {
					return currencyPrice;
				} else {
					var absPrice = $elm$core$Basics$abs(priceInCents);
					var normalizedPrice = function () {
						if ((!componentType.$) && (componentType.a === 5)) {
							var _v1 = componentType.a;
							return -absPrice;
						} else {
							return absPrice;
						}
					}();
					return $elm$core$Maybe$Just(
						$author$project$Currency$fromFloat(normalizedPrice));
				}
			},
			A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, currencyPrice));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField = F2(
	function (formField, form) {
		switch (formField.$) {
			case 0:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{Nx: string});
					},
					form.KU);
				return _Utils_update(
					form,
					{KU: newRecurringCharges});
			case 1:
				var list = formField.a;
				return _Utils_update(
					form,
					{KU: list});
			case 2:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{_G: string});
					},
					form.KU);
				return _Utils_update(
					form,
					{KU: newRecurringCharges});
			case 3:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{xr: string});
					},
					form.KU);
				return _Utils_update(
					form,
					{KU: newRecurringCharges});
			case 4:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{Qt: string});
					},
					form.KU);
				return _Utils_update(
					form,
					{KU: newRecurringCharges});
			case 5:
				var index = formField.a;
				var string = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{
								Bd: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(string))
							});
					},
					form.KU);
				return _Utils_update(
					form,
					{KU: newRecurringCharges});
			case 6:
				var index = formField.a;
				var value = formField.b;
				var convertedValue = A2(
					$elm$core$Maybe$andThen,
					function (charge) {
						return A2(
							$author$project$Utils$Billing$ProductPrice$convertPriceInCents,
							value,
							$elm$core$Maybe$Just(charge.iN));
					},
					A2($elm_community$list_extra$List$Extra$getAt, index, form.KU));
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{Ba: convertedValue});
					},
					form.KU);
				return _Utils_update(
					form,
					{KU: newRecurringCharges});
			case 7:
				var value = formField.a;
				return _Utils_update(
					form,
					{
						QA: $author$project$Utils$String$toMaybe(value)
					});
			default:
				var index = formField.a;
				var value = formField.b;
				var newRecurringCharges = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (charge) {
						return _Utils_update(
							charge,
							{iN: value});
					},
					form.KU);
				return _Utils_update(
					form,
					{KU: newRecurringCharges});
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$convertPriceForCharge = F4(
	function (form, index, componentType, formWithComponentType) {
		var formFields = $author$project$Utils$Form$fields(form);
		var currentCharge = A2($elm_community$list_extra$List$Extra$getAt, index, formFields.KU);
		var currentPrice = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Ba;
				},
				currentCharge));
		var convertedPrice = A2(
			$author$project$Utils$Billing$ProductPrice$convertPriceInCents,
			currentPrice,
			$elm$core$Maybe$Just(componentType));
		return A3(
			$author$project$Utils$Form$update,
			$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
			A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged, index, convertedPrice),
			formWithComponentType);
	});
var $author$project$Api$Provider$HintBillingProduct$Shared$componentType = function (_v0) {
	var record = _v0;
	return record.LC;
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryComponentTypeById = F2(
	function (categories, categoryId) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$HintBillingProduct$Shared$componentType,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (category) {
						return _Utils_eq(
							$author$project$Api$Provider$HintBillingProduct$Shared$id(category),
							categoryId);
					},
					categories)));
	});
var $author$project$Api$Provider$HintBillingProduct$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById = F2(
	function (categories, categoryId) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$HintBillingProduct$Shared$name,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (category) {
							return _Utils_eq(
								$author$project$Api$Provider$HintBillingProduct$Shared$id(category),
								categoryId);
						},
						categories))));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryFieldChanged = F4(
	function (model, index, categoryId, categoryField) {
		var newDescription = A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById, model.KL, categoryId);
		var formWithCategory = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, categoryField, model.PB);
		var descriptionField = A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged, index, newDescription);
		var formWithDescription = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, descriptionField, formWithCategory);
		var categoryComponentType = A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryComponentTypeById, model.KL, categoryId);
		return function (form) {
			if (!categoryComponentType.$) {
				var componentType = categoryComponentType.a;
				var formWithComponentType = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
					A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeComponentTypeChanged, index, componentType),
					form);
				return A4($author$project$Components$ApplicationFeePlan$UpdateModal$convertPriceForCharge, form, index, componentType, formWithComponentType);
			} else {
				return form;
			}
		}(formWithDescription);
	});
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounced = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$debouncePrice = function (_v0) {
	var index = _v0.a;
	var price = _v0.b;
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounced,
		$elm$core$Task$succeed(
			_Utils_Tuple2(index, price)));
};
var $author$project$Utils$Form$fromValidateResult = function (result) {
	if (!result.$) {
		var _v1 = result.a;
		var newForm = _v1.a;
		return newForm;
	} else {
		var newForm = result.a;
		return newForm;
	}
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdValidation = {$: 3};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdIsNumber = function (form) {
	var _v0 = form.QA;
	if (!_v0.$) {
		var id = _v0.a;
		var _v1 = $elm$core$String$toInt(id);
		if (!_v1.$) {
			return true;
		} else {
			return false;
		}
	} else {
		return true;
	}
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdIsNumber,
	_Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdValidation, 'Must be a number'));
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescription = F2(
	function (index, charge) {
		return $elm$core$String$isEmpty(charge.Nx) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index),
				'Description can\'t be blank')
			]) : _List_Nil;
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescriptions = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescription, form.KU));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeDescriptionValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescriptions);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{R: nodeList, y: nodeListSize, J: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Utils$Date$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $author$project$Utils$Date$monthFromInt = function (intMonth) {
	return A2(
		$elm$core$Array$get,
		intMonth - 1,
		$elm$core$Array$fromList($author$project$Utils$Date$months));
};
var $author$project$Utils$Date$dateFromCalendar = function (_v0) {
	var yearString = _v0.aa6;
	var monthString = _v0.Uj;
	var dayString = _v0.MV;
	var maybeYear = $elm$core$String$toInt(yearString);
	var maybeMonth = A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$Date$monthFromInt,
		$elm$core$String$toInt(monthString));
	var maybeDay = $elm$core$String$toInt(dayString);
	var _v1 = _Utils_Tuple3(maybeDay, maybeMonth, maybeYear);
	if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
		var day = _v1.a.a;
		var month = _v1.b.a;
		var year = _v1.c.a;
		return $elm$core$Result$Ok(
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day));
	} else {
		return $elm$core$Result$Err('Invalid Date');
	}
};
var $author$project$Utils$Date$DateParts = F3(
	function (monthString, dayString, yearString) {
		return {MV: dayString, Uj: monthString, aa6: yearString};
	});
var $author$project$Utils$Date$validateDatePart = F2(
	function (length, datePart) {
		return _Utils_eq(
			$elm$core$String$length(datePart),
			length) ? $elm$parser$Parser$succeed(datePart) : $elm$parser$Parser$problem('Date part is invalid.');
	});
var $author$project$Utils$Date$chompDatePart = function (length) {
	return A2(
		$elm$parser$Parser$andThen,
		$author$project$Utils$Date$validateDatePart(length),
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
};
var $author$project$Utils$Date$dateSeparator = '/';
var $author$project$Utils$Date$dateParser = function () {
	var stringSeparator = $elm$core$String$fromChar($author$project$Utils$Date$dateSeparator);
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed($author$project$Utils$Date$DateParts),
				A2(
					$elm$parser$Parser$ignorer,
					$author$project$Utils$Date$chompDatePart(2),
					$elm$parser$Parser$symbol(stringSeparator))),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$Utils$Date$chompDatePart(2),
				$elm$parser$Parser$symbol(stringSeparator))),
		A2(
			$elm$parser$Parser$ignorer,
			$author$project$Utils$Date$chompDatePart(4),
			$elm$parser$Parser$end));
}();
var $author$project$Utils$Date$fromUsString = function (dateString) {
	var _v0 = A2($elm$parser$Parser$run, $author$project$Utils$Date$dateParser, dateString);
	if (!_v0.$) {
		var dateParts = _v0.a;
		return $author$project$Utils$Date$dateFromCalendar(dateParts);
	} else {
		return $elm$core$Result$Err('Invalid Date');
	}
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDate = F2(
	function (index, charge) {
		if (charge.xr === '') {
			return _List_Nil;
		} else {
			var _v0 = $author$project$Utils$Date$fromUsString(charge.xr);
			if (!_v0.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation(index),
						'Date is invalid')
					]);
			}
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDates = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDate, form.KU));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeEndDateValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDates);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCentsPositive = F2(
	function (index, charge) {
		var _v0 = A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, charge.Ba);
		if (!_v0.$) {
			var priceInCents = _v0.a;
			var _v1 = _Utils_Tuple2(!priceInCents, charge.iN === 5);
			if (_v1.a && _v1.b) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
						'Credit amount cannot be $0')
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCentsPositive = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCentsPositive, form.KU));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsPositiveValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCentsPositive);
var $author$project$Currency$isValidFloat = function (_v0) {
	var string = _v0;
	var _v1 = $elm$core$String$toFloat(string);
	if (!_v1.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCents = F2(
	function (index, charge) {
		var noValueErrorMessage = (charge.iN === 5) ? 'Must be a negative number' : 'Must be a positive number';
		var _v0 = charge.Ba;
		if (!_v0.$) {
			var priceInCents = _v0.a;
			return $author$project$Currency$isValidFloat(priceInCents) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
					noValueErrorMessage)
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
					noValueErrorMessage)
				]);
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCents = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCents, form.KU));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCents);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantity = F2(
	function (index, charge) {
		return (charge.Bd > 0) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index),
				'Quantity must be greater than 0.')
			]);
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantities = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantity, form.KU));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeQuantityValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantities);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDate = F2(
	function (index, charge) {
		var _v0 = $author$project$Utils$Date$fromUsString(charge._G);
		if (!_v0.$) {
			return _List_Nil;
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation(index),
					'Date is invalid')
				]);
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDates = function (form) {
	return $elm$core$List$concat(
		A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDate, form.KU));
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeStartDateValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDates);
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeStartDateValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeEndDateValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeDescriptionValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsPositiveValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeQuantityValidator, $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator]));
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotOnlyValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator]));
var $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator = function (model) {
	return model.aee ? $author$project$Components$ApplicationFeePlan$UpdateModalForm$formFieldsValidator : $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotOnlyValidator;
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form).QA;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initEmptyCustomerProduct = F2(
	function (category, currentDate) {
		return {
			Nx: $author$project$Api$Provider$HintBillingProduct$Shared$name(category),
			qs: $elm$core$Maybe$Nothing,
			xr: '',
			iN: $author$project$Api$Provider$HintBillingProduct$Shared$componentType(category),
			Qt: $author$project$Api$Provider$HintBillingProduct$Shared$id(category),
			adR: $elm$core$Maybe$Nothing,
			Ba: $elm$core$Maybe$Nothing,
			Bd: 1,
			_E: currentDate,
			_G: A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, currentDate)
		};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounceMsg = function (a) {
	return {$: 9, a: a};
};
var $jinjor$elm_debounce$Debounce$Later = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$later = $jinjor$elm_debounce$Debounce$Later;
var $author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(500),
	ahG: $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounceMsg
};
var $jinjor$elm_debounce$Debounce$Flush = function (a) {
	return {$: 1, a: a};
};
var $jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$delayCmd = F2(
	function (delay, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(delay));
	});
var $jinjor$elm_debounce$Debounce$length = function (_v0) {
	var input = _v0.d5;
	return $elm$core$List$length(input);
};
var $jinjor$elm_debounce$Debounce$push = F3(
	function (config, a, _v0) {
		var d = _v0;
		var newDebounce = _Utils_update(
			d,
			{
				d5: A2($elm$core$List$cons, a, d.d5)
			});
		var selfCmd = function () {
			var _v1 = config.ag9;
			switch (_v1.$) {
				case 0:
					var offset = _v1.a;
					return d.S6 ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Nothing));
				case 1:
					var offset = _v1.a;
					var delay = _v1.b;
					return d.S6 ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush(
							$elm$core$Maybe$Just(delay)));
				default:
					var delay = _v1.a;
					return A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						delay,
						$jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom(
							$jinjor$elm_debounce$Debounce$length(newDebounce)));
			}
		}();
		return _Utils_Tuple2(
			newDebounce,
			A2($elm$core$Platform$Cmd$map, config.ahG, selfCmd));
	});
var $jinjor$elm_debounce$Debounce$takeLast = F3(
	function (send, head, tail) {
		return _Utils_Tuple2(
			_List_Nil,
			send(head));
	});
var $jinjor$elm_debounce$Debounce$update = F4(
	function (config, send, msg, _v0) {
		var d = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
			case 1:
				var tryAgainAfter = msg.a;
				var _v2 = d.d5;
				if (_v2.b) {
					var head = _v2.a;
					var tail = _v2.b;
					var selfCmd = function () {
						if (!tryAgainAfter.$) {
							var delay = tryAgainAfter.a;
							return A2(
								$jinjor$elm_debounce$Debounce$delayCmd,
								delay,
								$jinjor$elm_debounce$Debounce$Flush(
									$elm$core$Maybe$Just(delay)));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v3 = A2(send, head, tail);
					var input = _v3.a;
					var sendCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{d5: input, S6: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									sendCmd,
									A2($elm$core$Platform$Cmd$map, config.ahG, selfCmd)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{S6: false}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var lastInputLength = msg.a;
				var _v5 = _Utils_Tuple2(
					_Utils_cmp(
						$elm$core$List$length(d.d5),
						lastInputLength) < 1,
					d.d5);
				if (_v5.a && _v5.b.b) {
					var _v6 = _v5.b;
					var head = _v6.a;
					var tail = _v6.b;
					var _v7 = A2(send, head, tail);
					var input = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{d5: input}),
						cmd);
				} else {
					return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm = F2(
	function (model, newForm) {
		return {
			EC: $elm$core$Platform$Cmd$none,
			ac5: 0,
			y8: _Utils_update(
				model,
				{PB: newForm}),
			as: _List_Nil
		};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$PlanUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$backfillDate = F2(
	function (currentDate, charge) {
		var startDate = function () {
			var _v1 = $author$project$Utils$Date$fromUsString(charge._G);
			if (!_v1.$) {
				var val = _v1.a;
				return val;
			} else {
				return currentDate;
			}
		}();
		var endDate = function () {
			if (charge.xr === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v0 = $author$project$Utils$Date$fromUsString(charge.xr);
				if (!_v0.$) {
					var val = _v0.a;
					return $elm$core$Maybe$Just(val);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}();
		return _Utils_update(
			charge,
			{qs: endDate, _E: startDate});
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$convertToPricingCharge = function (charge) {
	var _v0 = charge.Ba;
	if (!_v0.$) {
		var priceInCents = _v0.a;
		return $elm$core$Maybe$Just(
			{Nx: charge.Nx, qs: charge.qs, Qt: charge.Qt, adR: charge.adR, Ba: priceInCents, Bd: charge.Bd, _E: charge._E});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Currency$encodeFloat = A2(
	$elm$core$Basics$composeR,
	$author$project$Currency$toFloat,
	$author$project$Utils$Encode$nullable($elm$json$Json$Encode$float));
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Api$Provider$Practice$Pricing$encodeChargeParams = function (charge) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, charge.adR)),
				_Utils_Tuple2(
				'hint_billing_product',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'id',
							$elm$json$Json$Encode$string(charge.Qt))
						]))),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(charge.Nx)),
				_Utils_Tuple2(
				'quantity',
				$elm$json$Json$Encode$int(charge.Bd)),
				_Utils_Tuple2(
				'price_in_cents',
				$author$project$Currency$encodeFloat(charge.Ba)),
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$string(
					$justinmimbs$date$Date$toIsoString(charge._E))),
				_Utils_Tuple2(
				'end_date',
				A2(
					$author$project$Utils$Encode$nullable,
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $justinmimbs$date$Date$toIsoString),
					charge.qs))
			]));
};
var $author$project$Api$Provider$Practice$Pricing$pricingPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['pricing']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$Pricing$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_pricing',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'charges',
								A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Practice$Pricing$encodeChargeParams, fields.KU)),
								_Utils_Tuple2(
								'hubspot_deal_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.QA))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$ApplicationFeePlan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$Pricing$pricingPath)));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$updatePlan = F3(
	function (apiClient, model, validFields) {
		var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		var allCharges = formFields.KU;
		var pricingCharges = A2(
			$elm$core$List$filterMap,
			$author$project$Components$ApplicationFeePlan$UpdateModal$convertToPricingCharge,
			A2(
				$elm$core$List$map,
				$author$project$Components$ApplicationFeePlan$UpdateModal$backfillDate(model.cO),
				allCharges));
		return A3(
			$author$project$Api$Provider$Practice$Pricing$update,
			apiClient,
			{KU: pricingCharges, QA: formFields.QA},
			$author$project$Components$ApplicationFeePlan$UpdateModal$PlanUpdated);
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{
							PB: $author$project$Components$ApplicationFeePlan$UpdateModalForm$init(model.KU),
							ci: $elm$core$Dict$empty,
							jF: $jinjor$elm_debounce$Debounce$init
						}),
					as: _List_Nil
				};
			case 1:
				var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
				var _v1 = A2($author$project$Utils$Form$validate, validator, model.PB);
				if (_v1.$ === 1) {
					var newForm = _v1.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					return {
						EC: A3($author$project$Components$ApplicationFeePlan$UpdateModal$updatePlan, apiClient, model, validFormFields),
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_fromArray(
							[$author$project$OutMsg$RefreshPractice])
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var updateEvent = $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified(model.PB) ? 3 : 2;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: updateEvent,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Plan updated')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var field = msg.a;
				var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
				var updatedForm = function () {
					if (field.$ === 4) {
						var index = field.a;
						var categoryId = field.b;
						return A4($author$project$Components$ApplicationFeePlan$UpdateModal$categoryFieldChanged, model, index, categoryId, field);
					} else {
						return A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, field, model.PB);
					}
				}();
				return A2(
					$author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm,
					model,
					$author$project$Utils$Form$fromValidateResult(
						A2($author$project$Utils$Form$validate, validator, updatedForm)));
			case 8:
				var index = msg.a;
				var price = msg.b;
				var newPendingPrices = A3($elm$core$Dict$insert, index, price, model.ci);
				var _v5 = A3(
					$jinjor$elm_debounce$Debounce$push,
					$author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig,
					_Utils_Tuple2(index, price),
					model.jF);
				var newDebouncer = _v5.a;
				var debounceCmd = _v5.b;
				return {
					EC: debounceCmd,
					ac5: 0,
					y8: _Utils_update(
						model,
						{ci: newPendingPrices, jF: newDebouncer}),
					as: _List_Nil
				};
			case 9:
				var debounceMsg = msg.a;
				var _v6 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$ApplicationFeePlan$UpdateModal$debouncePrice),
					debounceMsg,
					model.jF);
				var newDebouncer = _v6.a;
				var cmd = _v6.b;
				return {
					EC: cmd,
					ac5: 0,
					y8: _Utils_update(
						model,
						{jF: newDebouncer}),
					as: _List_Nil
				};
			case 10:
				var _v7 = msg.a;
				var index = _v7.a;
				var price = _v7.b;
				var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
				var updatedForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
					A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged, index, price),
					model.PB);
				var newPendingPrices = A2($elm$core$Dict$remove, index, model.ci);
				return function (newForm) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm, ci: newPendingPrices}),
						as: _List_Nil
					};
				}(
					$author$project$Utils$Form$fromValidateResult(
						A2($author$project$Utils$Form$validate, validator, updatedForm)));
			case 4:
				var dataCategories = msg.a;
				if (dataCategories.$ === 3) {
					var categories_ = dataCategories.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{KL: categories_}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(dataCategories)
					};
				}
			case 5:
				var fields = $author$project$Utils$Form$fields(model.PB);
				var emptyCharge = function () {
					var _v9 = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (category) {
								return $author$project$Api$Provider$HintBillingProduct$Shared$name(category) === 'Service Credit';
							},
							model.KL));
					if (!_v9.$) {
						var category = _v9.a;
						return _List_fromArray(
							[
								A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$initEmptyCustomerProduct, category, model.cO)
							]);
					} else {
						return _List_Nil;
					}
				}();
				var newComponents = _Utils_ap(fields.KU, emptyCharge);
				return A2(
					$author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm,
					_Utils_update(
						model,
						{ci: $elm$core$Dict$empty}),
					A3(
						$author$project$Utils$Form$update,
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(newComponents),
						model.PB));
			case 6:
				var index = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var maybeCharge = A2($elm_community$list_extra$List$Extra$getAt, index, fields.KU);
				var _v10 = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.adR;
					},
					maybeCharge);
				if (_v10.$ === 1) {
					if (!maybeCharge.$) {
						var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
						var updatedCharges = A2($elm_community$list_extra$List$Extra$removeAt, index, fields.KU);
						var updatedForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
							$author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(updatedCharges),
							model.PB);
						var newPendingPrices = A2($elm$core$Dict$remove, index, model.ci);
						return A2(
							$author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm,
							_Utils_update(
								model,
								{ci: newPendingPrices}),
							$author$project$Utils$Form$fromValidateResult(
								A2($author$project$Utils$Form$validate, validator, updatedForm)));
					} else {
						return A2($author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm, model, model.PB);
					}
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 2, 'Existing charges cannot be deleted')
							])
					};
				}
			default:
				var index = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var updatedCharges = A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, charge) {
							if (_Utils_eq(i, index)) {
								var possibleEndDate = (A2($justinmimbs$date$Date$compare, charge._E, model.cO) === 2) ? charge._E : model.cO;
								return _Utils_update(
									charge,
									{
										xr: A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, possibleEndDate)
									});
							} else {
								return charge;
							}
						}),
					fields.KU);
				return A2(
					$author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm,
					model,
					A3(
						$author$project$Utils$Form$update,
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField,
						$author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(updatedCharges),
						model.PB));
		}
	});
var $author$project$Components$HintBilling$CreateChargeModal$Closed = {$: 1};
var $author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$None = {$: 0};
var $author$project$Components$HintBilling$CreateChargeModal$PriceInCents = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$SaveCharge = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$PriceDebounced = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$debouncePrice = function (price) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$HintBilling$CreateChargeModal$PriceDebounced,
		$elm$core$Task$succeed(price));
};
var $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Bd: $elm$core$String$toInt(string)
					});
			case 2:
				var price = field.a;
				var convertedPrice = A2($author$project$Utils$Billing$ProductPrice$convertPriceInCents, price, fields.iN);
				return _Utils_update(
					fields,
					{Ba: convertedPrice});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Qs: $elm$core$Maybe$Just(string)
					});
			default:
				var componentType = field.a;
				return _Utils_update(
					fields,
					{iN: componentType});
		}
	});
var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProductValidation = 3;
var $author$project$Components$HintBilling$CreateChargeModal$NameValidation = 0;
var $author$project$Components$HintBilling$CreateChargeModal$validateName = function (fields) {
	return (fields.zh === '') ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter a name.')
		]) : _List_Nil;
};
var $author$project$Components$HintBilling$CreateChargeModal$PriceValidation = 2;
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents = function (_v0) {
	var record = _v0;
	return record.N2;
};
var $author$project$Api$Provider$PracticeInvoice$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$paidInCents = function (_v0) {
	var record = _v0;
	return record.Vu;
};
var $author$project$Api$Provider$PracticeInvoice$One$paidInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$paidInCents(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus = function (_v0) {
	var record = _v0;
	return record.QE;
};
var $author$project$Api$Provider$PracticeInvoice$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus(shared);
};
var $author$project$Components$HintBilling$CreateChargeModal$maxCreditAmount = function (practiceInvoice) {
	return ($author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice) === 3) ? $author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice) : $author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice);
};
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {M4: decimals, Q3: integers, Vg: original, A7: prefix, _8: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.Q3,
				$elm$core$List$singleton(formatted.M4))));
	return onlyZeros ? 1 : ((formatted.Vg < 0) ? 2 : 0);
};
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.M4;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.M4;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = $cuducos$elm_format_number$FormatNumber$Parser$splitThousands(
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{A7: locale.aeO, _8: locale.aeP});
			case 0:
				return _Utils_update(
					partial,
					{A7: locale.afO, _8: locale.afP});
			default:
				return _Utils_update(
					partial,
					{A7: locale.ahZ, _8: locale.ah_});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.acw, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.ahr, formatted.Q3);
		var decimals = stringfyDecimals(formatted.M4);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.A7, integers, decimals, formatted._8]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $author$project$Currency$toInt = function (_v0) {
	var string = _v0;
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Basics$round,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$mul(100),
			$elm$core$String$toFloat(string)));
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	acw: '.',
	M4: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	aeO: '−',
	aeP: '',
	afO: '',
	afP: '',
	ahr: '',
	ahZ: '',
	ah_: ''
};
var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$base,
	{
		M4: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
		ahr: ','
	});
var $author$project$Currency$format = function (currency) {
	var _v0 = $author$project$Currency$toInt(currency);
	if (!_v0.$) {
		var cents = _v0.a;
		return '$' + A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, cents / 100);
	} else {
		return 'N/A';
	}
};
var $author$project$Currency$fromInt = function (_int) {
	return $elm$core$String$fromFloat(_int / 100);
};
var $author$project$Components$HintBilling$CreateChargeModal$priceErrorForInvoice = function (practiceInvoice) {
	if ($author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice) === 3) {
		var dueText = $author$project$Currency$format(
			$author$project$Currency$fromInt(
				$author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)));
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Credit cannot excceed the Total Due of ' + (dueText + '.'))
			]);
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Credit cannot excceed amount paid.')
			]);
	}
};
var $author$project$Components$HintBilling$CreateChargeModal$validatePrice = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Ba, fields.iN);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			var priceInCents = _v0.a.a;
			var componentType = _v0.b.a;
			var _v1 = $author$project$Currency$toFloat(priceInCents);
			if (!_v1.$) {
				var price = _v1.a;
				var _v2 = _Utils_Tuple2(!price, componentType === 5);
				_v2$2:
				while (true) {
					if (_v2.a) {
						if (_v2.b) {
							return _List_fromArray(
								[
									_Utils_Tuple2(2, 'Credit amount cannot be $0')
								]);
						} else {
							break _v2$2;
						}
					} else {
						if (_v2.b) {
							return A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A3(
									$elm$core$Maybe$map2,
									F2(
										function (practiceInvoice_, quantity_) {
											return (_Utils_cmp(
												$elm$core$Basics$abs(price * quantity_),
												$author$project$Components$HintBilling$CreateChargeModal$maxCreditAmount(practiceInvoice_)) > 0) ? $author$project$Components$HintBilling$CreateChargeModal$priceErrorForInvoice(practiceInvoice_) : _List_Nil;
										}),
									fields.WH,
									fields.Bd));
						} else {
							break _v2$2;
						}
					}
				}
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(2, 'Must be a valid number')
					]);
			}
		} else {
			return _List_Nil;
		}
	} else {
		var _v3 = _v0.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Must be a number')
			]);
	}
};
var $author$project$Components$HintBilling$CreateChargeModal$QuantityValidation = 1;
var $author$project$Components$HintBilling$CreateChargeModal$validateQuantity = function (fields) {
	var _v0 = fields.Bd;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a quantity.')
			]);
	} else {
		var qty = _v0.a;
		return (qty > 0) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(1, 'Quantity must be greater than 0.')
			]);
	}
};
var $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validatePrice),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validateName),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validateQuantity),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Qs;
			},
			_Utils_Tuple2(3, 'Please select a category.'))
		]));
var $author$project$Components$HintBilling$CreateChargeModal$params = function (fields) {
	return {
		Nx: fields.zh,
		Qt: fields.Qs,
		Ba: A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Ba)),
		Bd: A2($elm$core$Maybe$withDefault, 1, fields.Bd)
	};
};
var $author$project$Components$HintBilling$CreateChargeModal$PriceDebounceMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(500),
	ahG: $author$project$Components$HintBilling$CreateChargeModal$PriceDebounceMsg
};
var $author$project$Components$HintBilling$CreateChargeModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$HintBilling$CreateChargeModal$Closed,
					y8: _Utils_update(
						model,
						{ns: $elm$core$Maybe$Nothing, jF: $jinjor$elm_debounce$Debounce$init}),
					as: _List_Nil
				};
			case 1:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$HintBilling$CreateChargeModal$SaveCharge(
							$author$project$Components$HintBilling$CreateChargeModal$params(fields)),
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$HintBilling$CreateChargeModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var field = msg.a;
				if (field.$ === 2) {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$HintBilling$CreateChargeModal$None, y8: model, as: _List_Nil};
				} else {
					return function (updatedForm) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$HintBilling$CreateChargeModal$None,
							y8: _Utils_update(
								model,
								{PB: updatedForm}),
							as: _List_Nil
						};
					}(
						$author$project$Utils$Form$fromValidateResult(
							A2(
								$author$project$Utils$Form$validate,
								$author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator,
								A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, field, model.PB))));
				}
			case 5:
				var price = msg.a;
				var _v5 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig, price, model.jF);
				var newDebouncer = _v5.a;
				var debounceCmd = _v5.b;
				return {
					EC: debounceCmd,
					ac5: $author$project$Components$HintBilling$CreateChargeModal$None,
					y8: _Utils_update(
						model,
						{
							ns: $elm$core$Maybe$Just(price),
							jF: newDebouncer
						}),
					as: _List_Nil
				};
			case 6:
				var debounceMsg = msg.a;
				var _v6 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$HintBilling$CreateChargeModal$debouncePrice),
					debounceMsg,
					model.jF);
				var newDebouncer = _v6.a;
				var cmd = _v6.b;
				return {
					EC: cmd,
					ac5: $author$project$Components$HintBilling$CreateChargeModal$None,
					y8: _Utils_update(
						model,
						{jF: newDebouncer}),
					as: _List_Nil
				};
			case 7:
				var price = msg.a;
				var updatedForm = $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator,
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
							$author$project$Components$HintBilling$CreateChargeModal$PriceInCents(price),
							model.PB)));
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$HintBilling$CreateChargeModal$None,
					y8: _Utils_update(
						model,
						{PB: updatedForm, ns: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var list = response.a;
					var serviceCreditCategory = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (product) {
								return $author$project$Api$Provider$HintBillingProduct$Shared$name(product) === 'Service Credit';
							},
							list));
					var updatedForm = function () {
						if (!serviceCreditCategory.$) {
							var category = serviceCreditCategory.a;
							var formWithCategory = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
								$author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct(
									$author$project$Api$Provider$HintBillingProduct$Shared$id(category)),
								model.PB);
							var formWithComponentType = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
								$author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$HintBillingProduct$Shared$componentType(category))),
								formWithCategory);
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
								$author$project$Components$HintBilling$CreateChargeModal$Name(
									$author$project$Api$Provider$HintBillingProduct$Shared$name(category)),
								formWithComponentType);
						} else {
							return model.PB;
						}
					}();
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$HintBilling$CreateChargeModal$None,
						y8: _Utils_update(
							model,
							{KL: list, PB: updatedForm}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$HintBilling$CreateChargeModal$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var hintBillingProductId = msg.a;
				var hintBillingProduct = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (product) {
							return _Utils_eq(
								$author$project$Api$Provider$HintBillingProduct$Shared$id(product),
								hintBillingProductId);
						},
						model.KL));
				var formWithCategory = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
					$author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct(hintBillingProductId),
					model.PB);
				var currentPrice = $author$project$Utils$Form$fields(model.PB).Ba;
				var componentType = A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingProduct$Shared$componentType, hintBillingProduct);
				var convertedPrice = A2($author$project$Utils$Billing$ProductPrice$convertPriceInCents, currentPrice, componentType);
				var formWithComponentType = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
					$author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType(componentType),
					formWithCategory);
				var formWithPrice = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
					$author$project$Components$HintBilling$CreateChargeModal$PriceInCents(convertedPrice),
					formWithComponentType);
				var categoryName = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingProduct$Shared$name, hintBillingProduct));
				var updatedForm = $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator,
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate,
							$author$project$Components$HintBilling$CreateChargeModal$Name(categoryName),
							formWithPrice)));
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$HintBilling$CreateChargeModal$None,
					y8: _Utils_update(
						model,
						{PB: updatedForm}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$UpgradePracticeModal$Closed = {$: 1};
var $author$project$Components$UpgradePracticeModal$CreatedUpgrade = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$UpgradePracticeModal$None = {$: 0};
var $author$project$Components$UpgradePracticeModal$UpgradedSuccess = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticePricing$Upgrade$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'upgrade',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'agreed_to_terms',
								$elm$json$Json$Encode$bool(fields.abc))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath)));
	});
var $author$project$Components$UpgradePracticeModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {
					EC: A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, model.ZD, model.g8, 'Self Buy Upgrade Modal Closed'),
					ac5: $author$project$Components$UpgradePracticeModal$Closed,
					y8: model
				};
			case 1:
				var value = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$UpgradePracticeModal$None,
					y8: _Utils_update(
						model,
						{abc: value})
				};
			case 2:
				return model.iY ? {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$UpgradePracticeModal$None, y8: model} : {
					EC: A3(
						$author$project$Api$Provider$PracticePricing$Upgrade$create,
						apiClient,
						{abc: model.abc},
						$author$project$Components$UpgradePracticeModal$CreatedUpgrade),
					ac5: $author$project$Components$UpgradePracticeModal$None,
					y8: _Utils_update(
						model,
						{iY: true})
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var tier = function () {
						var _v2 = model.g8;
						if (!_v2.$) {
							var pricing = _v2.a;
							return $author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing);
						} else {
							return 'plan';
						}
					}();
					return {
						EC: A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, model.ZD, model.g8, 'Self Buy Upgrade Completed'),
						ac5: $author$project$Components$UpgradePracticeModal$UpgradedSuccess('Your upgrade to ' + (tier + ' was successful')),
						y8: _Utils_update(
							model,
							{iY: false})
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$UpgradePracticeModal$None,
						y8: _Utils_update(
							model,
							{iY: false})
					};
				}
			default:
				var text = msg.a;
				var href = msg.b;
				return {
					EC: A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.ZD, text, href),
					ac5: $author$project$Components$UpgradePracticeModal$None,
					y8: model
				};
		}
	});
var $elm$url$Url$Builder$Relative = {$: 1};
var $elm$url$Url$Builder$rootToPrePath = function (root) {
	switch (root.$) {
		case 0:
			return '/';
		case 1:
			return '';
		default:
			var prePath = root.a;
			return prePath + '/';
	}
};
var $elm$url$Url$Builder$custom = F4(
	function (root, pathSegments, parameters, maybeFragment) {
		var fragmentless = _Utils_ap(
			$elm$url$Url$Builder$rootToPrePath(root),
			_Utils_ap(
				A2($elm$core$String$join, '/', pathSegments),
				$elm$url$Url$Builder$toQuery(parameters)));
		if (maybeFragment.$ === 1) {
			return fragmentless;
		} else {
			var fragment = maybeFragment.a;
			return fragmentless + ('#' + fragment);
		}
	});
var $author$project$Pages$Admin$Billing$updateUrl = function (maybeCustomPath) {
	var url = $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Billing);
	if (!maybeCustomPath.$) {
		var customPath = maybeCustomPath.a;
		return $author$project$Ports$Navigation$pushUrl(
			A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Relative,
				_List_fromArray(
					[url]),
				_List_Nil,
				$elm$core$Maybe$Just(customPath)));
	} else {
		return $author$project$Ports$Navigation$pushUrl(url);
	}
};
var $author$project$Components$UpgradePracticeModal$urlParam = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (tierName) {
			return 'self-upgrade-' + tierName;
		},
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$toLower,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticePricing$Upgrade$tierName, model.g8)));
};
var $author$project$Components$HintBilling$InvoicesTable$NotPaid = {$: 1};
var $author$project$Components$HintBilling$InvoicesTable$PaidTime = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate = function (_v0) {
	var record = _v0;
	return record.Rn;
};
var $author$project$Api$Provider$PracticeInvoice$All$date = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$dueDate = function (_v0) {
	var record = _v0;
	return record.N1;
};
var $author$project$Api$Provider$PracticeInvoice$All$dueDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$dueDate(shared);
};
var $author$project$Api$Provider$PracticeInvoice$All$dueInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PracticeInvoice$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$id(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Api$Provider$PracticeInvoice$All$number = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$paidAt = function (_v0) {
	var record = _v0;
	return record.Vt;
};
var $author$project$Api$Provider$PracticeInvoice$All$paidAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$paidAt(shared);
};
var $author$project$Api$Provider$PracticeInvoice$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus(shared);
};
var $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents = function (_v0) {
	var record = _v0;
	return record.$X;
};
var $author$project$Api$Provider$PracticeInvoice$All$totalInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents(shared);
};
var $author$project$Components$HintBilling$InvoicesTable$withPracticeInvoices = F3(
	function (practiceInvoices, timeFormatter, _v0) {
		var record = _v0;
		return _Utils_update(
			record,
			{
				q2: A2(
					$elm$core$List$map,
					function (practiceInvoice) {
						return {
							MO: $author$project$Api$Provider$PracticeInvoice$All$date(practiceInvoice),
							N1: $author$project$Api$Provider$PracticeInvoice$All$dueDate(practiceInvoice),
							N2: $author$project$Api$Provider$PracticeInvoice$All$dueInCents(practiceInvoice),
							adR: $author$project$Api$Provider$PracticeInvoice$All$id(practiceInvoice),
							Gj: $author$project$Api$Provider$PracticeInvoice$All$number(practiceInvoice),
							GA: function () {
								var _v1 = $author$project$Api$Provider$PracticeInvoice$All$paidAt(practiceInvoice);
								if (!_v1.$) {
									var time = _v1.a;
									return A2($author$project$Components$HintBilling$InvoicesTable$PaidTime, time, timeFormatter);
								} else {
									return $author$project$Components$HintBilling$InvoicesTable$NotPaid;
								}
							}(),
							ag7: $author$project$Api$Provider$PracticeInvoice$All$status(practiceInvoice),
							$X: $author$project$Api$Provider$PracticeInvoice$All$totalInCents(practiceInvoice)
						};
					},
					practiceInvoices)
			});
	});
var $author$project$Pages$Admin$Billing$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{me: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pD: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pN: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var invoices = response.a;
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ek: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ek),
								AV: response,
								jz: A2(
									$author$project$Components$HintBilling$InvoicesTable$withLoadingStatus,
									false,
									A3($author$project$Components$HintBilling$InvoicesTable$withPracticeInvoices, invoices, model.Hy, model.jz))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{AV: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var uninvoicedCharges_ = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oW: uninvoicedCharges_}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.ek);
				var newModel = _Utils_update(
					model,
					{
						ek: pagination,
						jz: A2($author$project$Components$HintBilling$InvoicesTable$withLoadingStatus, true, model.jz)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, model.D5, pagination),
					_List_Nil);
			case 6:
				var practicePricing = msg.a;
				var _v3 = model.ct;
				if (!_v3.$) {
					var hubspotDealUrl = A2(
						$elm$core$Maybe$andThen,
						$author$project$Api$Provider$PracticePricing$One$hubspotDealUrl,
						$author$project$Api$Data$toMaybe(model.ck));
					var _v4 = A4($author$project$Components$ApplicationFeePlan$UpdateModal$init, model.D5, model.cO, practicePricing, hubspotDealUrl);
					var newModel = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ct: A2($author$project$Pages$Admin$Billing$Initialized, true, newModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, cmd),
						_List_Nil);
				} else {
					var modal = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ct: A2($author$project$Pages$Admin$Billing$Initialized, true, modal)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var subMsg = msg.a;
				var _v5 = model.ct;
				if (!_v5.$) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var open = _v5.a;
					var updateModal = _v5.b;
					var result = A3($author$project$Components$ApplicationFeePlan$UpdateModal$update, model.D5, subMsg, updateModal);
					var loadingModel = _Utils_update(
						model,
						{me: $author$project$Api$Data$Loading, ck: $author$project$Api$Data$Loading, ct: $author$project$Pages$Admin$Billing$NotInitialized, o2: $elm$core$Maybe$Nothing});
					var fetchDataCmd = $elm$core$Platform$Cmd$batch(
						$author$project$Pages$Admin$Billing$fetchPricingData(model.D5));
					var _v6 = result.ac5;
					switch (_v6) {
						case 1:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										ct: A2($author$project$Pages$Admin$Billing$Initialized, false, result.y8)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.EC),
								result.as);
						case 2:
							return _Utils_Tuple3(
								loadingModel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											fetchDataCmd,
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.EC)
										])),
								result.as);
						case 3:
							return _Utils_Tuple3(
								loadingModel,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											fetchDataCmd,
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.EC)
										])),
								result.as);
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										ct: A2($author$project$Pages$Admin$Billing$Initialized, open, result.y8)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.EC),
								result.as);
					}
				}
			case 10:
				var _v7 = A2($author$project$Components$HintBilling$CreateChargeModal$init, model.D5, $elm$core$Maybe$Nothing);
				var createChargeModal = _v7.a;
				var createChargeModalCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hW: $elm$core$Maybe$Just(createChargeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$CreateChargeModalMsg, createChargeModalCmd),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v8 = model.hW;
				if (!_v8.$) {
					var createChargeModal = _v8.a;
					var result = A2($author$project$Components$HintBilling$CreateChargeModal$update, subMsg, createChargeModal);
					var _v9 = function () {
						var _v10 = result.ac5;
						switch (_v10.$) {
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							case 2:
								var chargeParams = _v10.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Admin$Billing$saveCharge, model.D5, chargeParams));
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(result.y8),
									$elm$core$Platform$Cmd$none);
						}
					}();
					var createChargeModal_ = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hW: createChargeModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$CreateChargeModalMsg, result.EC),
									cmd
								])),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var practiceCharge = msg.a;
				var id = $author$project$Api$Provider$PracticeCharge$All$id(practiceCharge);
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$PracticeCharge$delete,
						model.D5,
						id,
						$author$project$Pages$Admin$Billing$PracticeChargeDeleted(practiceCharge)),
					_List_Nil);
			case 12:
				var practiceCharge = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var uninvoicedCharges_ = A2(
						$elm$core$List$filter,
						function (charge) {
							return !_Utils_eq(
								$author$project$Api$Provider$PracticeCharge$All$id(charge),
								$author$project$Api$Provider$PracticeCharge$All$id(practiceCharge));
						},
						model.oW);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oW: uninvoicedCharges_}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$PracticeCharge$All$description(practiceCharge) + ' was successfully deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var response = msg.a;
				_v12$2:
				while (true) {
					switch (response.$) {
						case 3:
							var upgrade = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										o2: $elm$core$Maybe$Just(upgrade)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v13 = response.a;
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							} else {
								break _v12$2;
							}
						default:
							break _v12$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 14:
				var _v14 = A3($author$project$Components$UpgradePracticeModal$init, model.o2, model.ZD, model.P2);
				var upgradePracticeModal = _v14.a;
				var upgradePracticeModalCmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kC: $elm$core$Maybe$Just(upgradePracticeModal)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg, upgradePracticeModalCmd),
								$author$project$Pages$Admin$Billing$updateUrl(
								$author$project$Components$UpgradePracticeModal$urlParam(upgradePracticeModal))
							])),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var _v15 = model.kC;
				if (!_v15.$) {
					var upgradePracticeModal = _v15.a;
					var result = A3($author$project$Components$UpgradePracticeModal$update, model.D5, subMsg, upgradePracticeModal);
					var _v16 = function () {
						var _v17 = result.ac5;
						switch (_v17.$) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Pages$Admin$Billing$updateUrl($elm$core$Maybe$Nothing),
									_List_Nil);
							case 2:
								var successMsg = _v17.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, successMsg)
										]));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(result.y8),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
						}
					}();
					var modal_ = _v16.a;
					var cmd_ = _v16.b;
					var outMsgs_ = _v16.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kC: modal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg, result.EC),
									cmd_
								])),
						outMsgs_);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$PracticeInvoice$create, model.D5, $author$project$Pages$Admin$Billing$InvoiceCreated),
					_List_Nil);
			case 17:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, model.D5, model.ek),
									$author$project$Pages$Admin$Billing$fetchUninvoicedCharges(model.D5)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice created successfully.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 18:
				var label = msg.a;
				var url = msg.b;
				return _Utils_Tuple3(
					model,
					A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.ZD, label, url),
					_List_Nil);
			case 19:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$author$project$Pages$Admin$Billing$fetchUninvoicedCharges(model.D5),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Charge created successfully.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 20:
				var response = msg.a;
				if (response.$ === 3) {
					var secret = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pL: response}),
						A2($author$project$Ports$Stripe$mountCapitalPromoTile, '#stripe-capital-promo-tile', secret),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pL: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 21:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Provider$Practice$StripeAccount$session, model.D5, $author$project$Pages$Admin$Billing$GotCapitalSession),
						_List_Nil);
				}
			default:
				var productType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							vW: $elm$core$Maybe$Just(productType)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Billing$PracticeInvoicePaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Alignment$justifyEnd = $author$project$Ui$Alignment$Content(2);
var $author$project$Ui$Element$justifyRight = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$justifyEnd);
var $author$project$Ui$Modal$Lg = 2;
var $author$project$Ui$Modal$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Modal$size = $author$project$Ui$Modal$Size;
var $author$project$Components$ApplicationFeePlan$UpdateModal$Save = {$: 1};
var $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Group$inputSpanMd = function (span) {
	return $author$project$Ui$Form$Group$InputGrid(
		_List_fromArray(
			[
				'md:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Ui$Form$Group$labelSpanMd = function (span) {
	return $author$project$Ui$Form$Group$LabelGrid(
		_List_fromArray(
			[
				'md:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
			]));
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewHubspotDealId = F2(
	function (form, hubspotDealUrl) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Import from Hubspot Deal'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(4)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Utils$Form$fields(form).QA)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged, $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdChanged)),
							$author$project$Ui$Form$Input$number,
							$author$project$Ui$Form$Input$placeholder('')
						])),
					function () {
					if (!hubspotDealUrl.$) {
						var url = hubspotDealUrl.a;
						return A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$margin(21)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									url,
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('View in HubSpot')
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$AddRecurringChargeButtonClicked = {$: 5};
var $author$project$Ui$Margin$Top_3 = 18;
var $author$project$Ui$SvgIcon$Add = 38;
var $author$project$Ui$SvgIcon$add = $author$project$Ui$SvgIcon$viewIcon(38);
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$chargesTotalInCents = function (charges) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$filterMap,
			function (c) {
				return A2(
					$elm$core$Maybe$map,
					function (cents) {
						return cents * c.Bd;
					},
					A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, c.Ba));
			},
			charges));
};
var $author$project$Ui$Alignment$Start = 0;
var $author$project$Ui$Alignment$itemsStart = $author$project$Ui$Alignment$Items(0);
var $author$project$Ui$Element$itemsStart = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsStart);
var $author$project$Ui$FlexGrid$justifyLeft = $author$project$Ui$FlexGrid$Element($author$project$Ui$Element$itemsStart);
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewChargesTotal = function (charges) {
	var totalInCents = $author$project$Components$ApplicationFeePlan$UpdateModal$chargesTotalInCents(charges);
	return (totalInCents > 0) ? A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(6),
						$author$project$Ui$FlexGrid$justifyLeft
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Total')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(6),
						$author$project$Ui$FlexGrid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Currency$format(
									$author$project$Currency$fromInt(totalInCents)))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$DeleteRecurringCharge = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$EndRecurringCharge = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$Lives = 0;
var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceInputChanged = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeCategoryChanged = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeEndDateChanged = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeQuantityChanged = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeStartDateChanged = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForExistingCharges = function (categories) {
	return A2(
		$elm$core$List$map,
		function (category) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$author$project$Api$Provider$HintBillingProduct$Shared$id(category)),
				$author$project$Api$Provider$HintBillingProduct$Shared$name(category));
		},
		categories);
};
var $author$project$Components$HintBilling$HintBillingProductOptions$UpdatePricing = 0;
var $author$project$Api$Provider$HintBillingProduct$Shared$addonType = function (_v0) {
	var record = _v0;
	return record.Ir;
};
var $author$project$Api$Provider$HintBillingProduct$Shared$archived = function (_v0) {
	var record = _v0;
	return record.Jn;
};
var $author$project$Api$Provider$HintBillingComponent$AddonType$isFree = function (addonType) {
	if (addonType === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$HintBilling$HintBillingProductOptions$isFreeProduct = function (hintBillingProduct) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$HintBillingComponent$AddonType$isFree,
			$author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct)));
};
var $author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime = function (addonType) {
	if (addonType === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$HintBilling$HintBillingProductOptions$isSelectable = F2(
	function (action, hintBillingProduct) {
		if ($author$project$Api$Provider$HintBillingProduct$Shared$archived(hintBillingProduct) || $author$project$Components$HintBilling$HintBillingProductOptions$isFreeProduct(hintBillingProduct)) {
			return false;
		} else {
			switch (action) {
				case 0:
					var _v1 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
					switch (_v1) {
						case 0:
							return false;
						case 2:
							return false;
						case 4:
							return true;
						case 3:
							return false;
						case 1:
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$not,
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime,
										$author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct))));
						default:
							return true;
					}
				case 1:
					var _v2 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
					switch (_v2) {
						case 1:
							return A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime,
									$author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct)));
						case 5:
							return true;
						default:
							return false;
					}
				default:
					var _v3 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
					if (_v3 === 5) {
						return true;
					} else {
						return false;
					}
			}
		}
	});
var $author$project$Components$HintBilling$HintBillingProductOptions$toSelectOption = function (hintBillingProduct) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Api$Provider$HintBillingProduct$Shared$id(hintBillingProduct)),
		$author$project$Api$Provider$HintBillingProduct$Shared$name(hintBillingProduct));
};
var $author$project$Components$HintBilling$HintBillingProductOptions$selectOptions = F2(
	function (action, hintBillingProducts) {
		return A2(
			$elm$core$List$map,
			$author$project$Components$HintBilling$HintBillingProductOptions$toSelectOption,
			A2(
				$elm$core$List$filter,
				$author$project$Components$HintBilling$HintBillingProductOptions$isSelectable(action),
				hintBillingProducts));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForNewCharges = function (categories) {
	return A2($author$project$Components$HintBilling$HintBillingProductOptions$selectOptions, 0, categories);
};
var $author$project$Ui$Form$CurrencyInput$Disabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$CurrencyInput$disabled = $author$project$Ui$Form$CurrencyInput$Disabled;
var $author$project$Ui$Form$Select$Disabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Select$disabled = $author$project$Ui$Form$Select$Disabled;
var $author$project$Components$ApplicationFeePlan$UpdateModal$getDefaultDescription = F2(
	function (categories, charge) {
		return $elm$core$String$isEmpty(charge.Nx) ? A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById, categories, charge.Qt) : charge.Nx;
	});
var $author$project$Ui$Form$CurrencyInput$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$CurrencyInput$invalid = function (bool) {
	return $author$project$Ui$Form$CurrencyInput$Invalid(bool);
};
var $author$project$Ui$FlexGrid$mb2 = $author$project$Ui$FlexGrid$RowElement($author$project$Ui$Element$mb2);
var $author$project$Ui$Form$CurrencyInput$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$CurrencyInput$onInput = function (handler) {
	return $author$project$Ui$Form$CurrencyInput$OnInput(handler);
};
var $author$project$Ui$Form$CurrencyInput$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$CurrencyInput$value = function (_int) {
	return $author$project$Ui$Form$CurrencyInput$Value(_int);
};
var $author$project$Ui$Form$Input$HideErrors = function (a) {
	return {$: 25, a: a};
};
var $author$project$Ui$Form$Input$hideErrors = $author$project$Ui$Form$Input$HideErrors;
var $author$project$Ui$Form$CurrencyInput$defaultOptions = {fE: _List_Nil, xO: false, ap: _List_Nil, q$: false, AT: $elm$core$Maybe$Nothing, A7: true, aaN: $elm$core$Maybe$Nothing};
var $author$project$Currency$fromString = $elm$core$Basics$identity;
var $author$project$Ui$Form$CurrencyInput$inputHandler = function (handler) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$String$toMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Currency$fromString),
			handler));
};
var $author$project$Ui$Form$CurrencyInput$inputValue = function (currency) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Currency$toString, currency));
};
var $author$project$Ui$Form$Input$OnBlur = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Form$Input$onBlur = $author$project$Ui$Form$Input$OnBlur;
var $author$project$Ui$Form$Input$Test = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Input$test = function (dataTest) {
	return $author$project$Ui$Form$Input$Test(dataTest);
};
var $author$project$Ui$Form$CurrencyInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$onInput(
										$author$project$Ui$Form$CurrencyInput$inputHandler(handler)),
									record.ap)
							});
					case 9:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$onBlur(handler),
									record.ap)
							});
					case 1:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$value(
										$author$project$Ui$Form$CurrencyInput$inputValue(_int)),
									record.ap),
								aaN: _int
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{q$: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$placeholder(string),
									record.ap)
							});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$disabled(bool),
									record.ap)
							});
					case 6:
						var string = option.a;
						return _Utils_update(
							record,
							{
								AT: $elm$core$Maybe$Just(string)
							});
					case 7:
						return _Utils_update(
							record,
							{A7: false});
					case 8:
						var string = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$test(string),
									record.ap)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{xO: bool});
				}
			}),
		$author$project$Ui$Form$CurrencyInput$defaultOptions,
		options);
};
var $author$project$Ui$Form$CurrencyInput$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$CurrencyInput$optionsToRecord(options);
	var prefix = optionsRecord.A7 ? $author$project$Ui$Form$Input$addon(
		_List_fromArray(
			[
				$elm$html$Html$text('$')
			])) : $author$project$Utils$Html$empty;
	return $author$project$Ui$Form$Input$group(
		A2(
			$elm$core$List$cons,
			prefix,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Input$view(
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$invalid(optionsRecord.q$),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$errors(optionsRecord.fE),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Form$Input$number,
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$hideErrors(optionsRecord.xO),
									optionsRecord.ap))))),
				function () {
					var _v0 = optionsRecord.AT;
					if (!_v0.$) {
						var postfix_ = _v0.a;
						return _List_fromArray(
							[
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text(postfix_)
									]))
							]);
					} else {
						return _List_Nil;
					}
				}())));
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewPackageTotal = F2(
	function (params, packageType) {
		var totalFloat = A2(
			$elm$core$Maybe$andThen,
			function (priceInCents) {
				var quantityFloat = params.Bd;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromFloat,
					A2(
						$elm$core$Maybe$map,
						$author$project$Utils$Round$float,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$mul(quantityFloat),
							$author$project$Currency$toFloat(priceInCents))));
			},
			params.Ba);
		if (!totalFloat.$) {
			var value = totalFloat.a;
			return A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Currency$format(value))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Ui$Form$Input$withPreAddon = F2(
	function (addonText, options) {
		var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
		var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$Input$addon(
						_List_fromArray(
							[
								$elm$html$Html$text(addonText)
							])),
						$author$project$Ui$Form$Input$viewFeedback(optionsRecord),
						A2(
						$elm$html$Html$input,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('form-control'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(optionsRecord.aaN),
								_Utils_ap(
									$author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.ahI),
									_Utils_ap(optionsRecord.vw, onInputHandler)))),
						_List_Nil)
					]),
					A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
				]));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringCharge = F4(
	function (model, fieldsDisabled, index, charge) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(charge.Qt)),
													$author$project$Ui$Form$Select$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
														$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeCategoryChanged(index))),
													$author$project$Ui$Form$Select$disabled(
													fieldsDisabled || (!_Utils_eq(charge.adR, $elm$core$Maybe$Nothing)))
												]),
											_Utils_eq(charge.adR, $elm$core$Maybe$Nothing) ? $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForNewCharges(model.KL) : $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForExistingCharges(model.KL))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(3)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$value(charge._G),
															$author$project$Ui$Form$Input$onInput(
															A2(
																$elm$core$Basics$composeL,
																$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeStartDateChanged(index))),
															$author$project$Ui$Form$Input$invalid(
															A2(
																$author$project$Utils$Form$hasValidationErrors,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation(index),
																model.PB)),
															$author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
															$author$project$Ui$Form$Input$disabled(fieldsDisabled)
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(3)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$value(charge.xr),
															$author$project$Ui$Form$Input$onInput(
															A2(
																$elm$core$Basics$composeL,
																$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeEndDateChanged(index))),
															$author$project$Ui$Form$Input$invalid(
															A2(
																$author$project$Utils$Form$hasValidationErrors,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation(index),
																model.PB)),
															$author$project$Ui$Form$Input$placeholder('end date'),
															$author$project$Ui$Form$Input$disabled(fieldsDisabled)
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($author$project$Components$ApplicationFeePlan$UpdateModal$getDefaultDescription, model.KL, charge)),
													$author$project$Ui$Form$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
														$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged(index))),
													$author$project$Ui$Form$Input$invalid(
													A2(
														$author$project$Utils$Form$hasValidationErrors,
														$author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index),
														model.PB)),
													$author$project$Ui$Form$Input$placeholder('charge name'),
													$author$project$Ui$Form$Input$disabled(fieldsDisabled)
												])),
											$author$project$Utils$FormErrors$view(
											A2(
												$author$project$Utils$Form$validationErrors,
												$author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index),
												model.PB))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(3)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											A2(
												$author$project$Ui$Form$Input$withPreAddon,
												'Qty',
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														$elm$core$String$fromInt(charge.Bd)),
														$author$project$Ui$Form$Input$onInput(
														A2(
															$elm$core$Basics$composeL,
															$author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged,
															$author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeQuantityChanged(index))),
														$author$project$Ui$Form$Input$number,
														$author$project$Ui$Form$Input$disabled(fieldsDisabled),
														$author$project$Ui$Form$Input$invalid(
														A2(
															$author$project$Utils$Form$hasValidationErrors,
															$author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index),
															model.PB))
													]))),
											$author$project$Utils$FormErrors$view(
											A2(
												$author$project$Utils$Form$validationErrors,
												$author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index),
												model.PB))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(3)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$CurrencyInput$value(
															A2(
																$elm$core$Maybe$withDefault,
																charge.Ba,
																A2($elm$core$Dict$get, index, model.ci))),
															$author$project$Ui$Form$CurrencyInput$onInput(
															$author$project$Components$ApplicationFeePlan$UpdateModal$PriceInputChanged(index)),
															$author$project$Ui$Form$CurrencyInput$invalid(
															A2(
																$author$project$Utils$Form$hasValidationErrors,
																$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
																model.PB)),
															$author$project$Ui$Form$CurrencyInput$disabled(fieldsDisabled)
														]))
												])),
											$author$project$Utils$FormErrors$view(
											A2(
												$author$project$Utils$Form$validationErrors,
												$author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index),
												model.PB))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_fromArray(
										[
											_Utils_eq(charge.adR, $elm$core$Maybe$Nothing) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Delete recurring charge'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Components$ApplicationFeePlan$UpdateModal$DeleteRecurringCharge(index)),
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
													$author$project$Ui$Button$disabled(fieldsDisabled)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												])) : A3(
											$author$project$Ui$Button$view,
											{abp: 'End recurring charge'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Components$ApplicationFeePlan$UpdateModal$EndRecurringCharge(index)),
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
													$author$project$Ui$Button$disabled(fieldsDisabled)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('End')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6),
											$author$project$Ui$FlexGrid$justifyRight
										]),
									_List_fromArray(
										[
											A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewPackageTotal, charge, 0)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringChargesSection = F3(
	function (model, formFields, fieldsDisabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Charges'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$indexedMap,
					A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringCharge, model, fieldsDisabled),
					$author$project$Utils$Form$fields(formFields).KU),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$margin(18)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Add new recurring charge'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$AddRecurringChargeButtonClicked),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
										$author$project$Ui$Button$disabled(fieldsDisabled)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add New')
									]))
							])),
						$author$project$Components$ApplicationFeePlan$UpdateModal$viewChargesTotal(
						$author$project$Utils$Form$fields(formFields).KU)
					])));
	});
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewBody = function (model) {
	var showIfEditable = function (section) {
		return model.aee ? section : $author$project$Utils$Html$empty;
	};
	var fieldsDisabled = $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified(model.PB);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$ApplicationFeePlan$UpdateModal$Save),
				$author$project$Ui$Form$horizontal
			]),
		_List_fromArray(
			[
				A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewHubspotDealId, model.PB, model.QB),
				showIfEditable(
				$author$project$Ui$HorizontalRule$view(_List_Nil)),
				showIfEditable(
				A3($author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringChargesSection, model, model.PB, fieldsDisabled))
			]));
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$viewFooter = function (model) {
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Cancel and close modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$Close)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Cancel')
				])),
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Save plan'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$disabled(
					$author$project$Utils$Form$hasAnyValidationError(model.PB)),
					$author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$Save)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Save')
				]))
		]);
};
var $author$project$Components$ApplicationFeePlan$UpdateModal$view = function (model) {
	var modalTitle = model.aee ? 'Edit Subscription' : 'Reset Pricing with a HubSpot Deal';
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$ApplicationFeePlan$UpdateModal$Close,
		_List_fromArray(
			[
				$author$project$Ui$Modal$size(2)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(modalTitle)
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$ApplicationFeePlan$UpdateModal$viewBody(model)
					])),
				$author$project$Ui$Modal$footer(
				$author$project$Components$ApplicationFeePlan$UpdateModal$viewFooter(model))
			]));
};
var $author$project$Components$HintBilling$CreateChargeModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProductSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$PriceInputChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$HintBilling$CreateChargeModal$Quantity = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$CurrencyInput$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$CurrencyInput$errors = $author$project$Ui$Form$CurrencyInput$Errors;
var $author$project$Components$HintBilling$HintBillingProductOptions$AddCharge = 1;
var $author$project$Components$HintBilling$HintBillingProductOptions$AddCredit = 2;
var $author$project$Components$HintBilling$CreateChargeModal$hintBillingProductOptions = F2(
	function (hintBillingProducts, practiceInvoice) {
		var action = function () {
			var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeInvoice$One$status, practiceInvoice);
			if ((!_v0.$) && (!_v0.a)) {
				var _v1 = _v0.a;
				return 2;
			} else {
				return 1;
			}
		}();
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a category'),
			A2($author$project$Components$HintBilling$HintBillingProductOptions$selectOptions, action, hintBillingProducts));
	});
var $author$project$Components$HintBilling$CreateChargeModal$viewBody = F3(
	function (hintBillingProducts, form, pendingPrice) {
		var fields = $author$project$Utils$Form$fields(form);
		var hintBillingProductId = fields.Qs;
		var hintBillingProduct = A2(
			$elm$core$Maybe$andThen,
			function (hintBillingProductId_) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (hintBillingProduct_) {
							return _Utils_eq(
								$author$project$Api$Provider$HintBillingProduct$Shared$id(hintBillingProduct_),
								hintBillingProductId_);
						},
						hintBillingProducts));
			},
			hintBillingProductId);
		var _v0 = fields;
		var name = _v0.zh;
		var quantity = _v0.Bd;
		var priceInCents = _v0.Ba;
		var practiceInvoice = _v0.WH;
		var displayPrice = A2($elm$core$Maybe$withDefault, priceInCents, pendingPrice);
		var priceFloat = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, displayPrice));
		var floorTotalInCents = $elm$core$Basics$round(
			priceFloat * A2($elm$core$Maybe$withDefault, 0, quantity));
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[$author$project$Ui$Form$horizontal]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Category'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2(
										$elm$core$Maybe$map,
										function (hbp) {
											return $author$project$Api$Provider$HintBillingProduct$Shared$id(hbp);
										},
										hintBillingProduct)),
									$author$project$Ui$Form$Select$onChange($author$project$Components$HintBilling$CreateChargeModal$HintBillingProductSelected),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 3, form))
								]),
							A2($author$project$Components$HintBilling$CreateChargeModal$hintBillingProductOptions, hintBillingProducts, practiceInvoice))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Charge Name'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(9)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$HintBilling$CreateChargeModal$FormUpdated, $author$project$Components$HintBilling$CreateChargeModal$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('QTY'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$number,
									$author$project$Ui$Form$Input$value(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, quantity))),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$HintBilling$CreateChargeModal$FormUpdated, $author$project$Components$HintBilling$CreateChargeModal$Quantity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Price'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(9)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(displayPrice),
											$author$project$Ui$Form$CurrencyInput$onInput($author$project$Components$HintBilling$CreateChargeModal$PriceInputChanged),
											$author$project$Ui$Form$CurrencyInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
											$author$project$Ui$Form$CurrencyInput$errors(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Total'),
							$author$project$Ui$Form$Group$labelSpan(3),
							$author$project$Ui$Form$Group$inputSpan(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Currency$format(
												$author$project$Currency$fromInt(floorTotalInCents)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$HintBilling$CreateChargeModal$FormSubmitted = {$: 1};
var $author$project$Components$HintBilling$CreateChargeModal$saveButtonLabel = F2(
	function (hintBillingComponentType, practiceInvoice) {
		var _v0 = _Utils_Tuple2(
			hintBillingComponentType,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeInvoice$One$status, practiceInvoice));
		if ((!_v0.a.$) && (_v0.a.a === 5)) {
			if ((!_v0.b.$) && (!_v0.b.a)) {
				var _v1 = _v0.a.a;
				var _v2 = _v0.b.a;
				return 'Add Credit & Refund';
			} else {
				var _v3 = _v0.a.a;
				return 'Add Credit';
			}
		} else {
			return 'Add Charge';
		}
	});
var $author$project$Components$HintBilling$CreateChargeModal$viewFooter = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var hintBillingComponentType = _v0.iN;
	var practiceInvoice = _v0.WH;
	var buttonLabel = A2($author$project$Components$HintBilling$CreateChargeModal$saveButtonLabel, hintBillingComponentType, practiceInvoice);
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Cancel and close modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick($author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Cancel')
				])),
			A3(
			$author$project$Ui$Button$view,
			{abp: buttonLabel},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick($author$project$Components$HintBilling$CreateChargeModal$FormSubmitted)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonLabel)
				]))
		]);
};
var $author$project$Components$HintBilling$CreateChargeModal$view = F2(
	function (_v0, modalTitle) {
		var model = _v0;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(modalTitle)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A3($author$project$Components$HintBilling$CreateChargeModal$viewBody, model.KL, model.PB, model.ns)
						])),
					$author$project$Ui$Modal$footer(
					$author$project$Components$HintBilling$CreateChargeModal$viewFooter(model.PB))
				]));
	});
var $author$project$Components$UpgradePracticeModal$ConfirmUpgrade = {$: 2};
var $author$project$Ui$FlexGrid$Gutter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$FlexGrid$Md = 2;
var $author$project$Ui$FlexGrid$gutterMd = $author$project$Ui$FlexGrid$Gutter(2);
var $author$project$Ui$Element$mt8 = $author$project$Ui$Element$Margin('mt-8');
var $author$project$Ui$Element$Stretch = {$: 13};
var $author$project$Ui$Element$stretch = $author$project$Ui$Element$Stretch;
var $author$project$Ui$FlexGrid$rowItemsStretch = $author$project$Ui$FlexGrid$RowElement($author$project$Ui$Element$stretch);
var $author$project$Ui$Button$secondary = $author$project$Ui$Button$Styled(2);
var $author$project$Ui$Element$SpaceX = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Element$spaceX4 = $author$project$Ui$Element$SpaceX(4);
var $author$project$Components$UpgradePracticeModal$AgreedToTerms = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Typography$Danger = 5;
var $author$project$Ui$Typography$danger = $author$project$Ui$Typography$Color(5);
var $author$project$Ui$Element$Display = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Element$Flex = 2;
var $author$project$Ui$Element$flexMd = A2($author$project$Ui$Element$Display, 2, 2);
var $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$Margin$Left_1 = 11;
var $author$project$Components$HintBilling$FeatureListLink$link = function (hasClinicalAccount) {
	return hasClinicalAccount ? 'https://www.hint.com/clinical/pricing' : 'https://www.hint.com/pricing';
};
var $author$project$Ui$Link$Margin = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Link$margin = $author$project$Ui$Link$Margin;
var $author$project$Ui$Link$OnClick = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Link$onClick = $author$project$Ui$Link$OnClick;
var $author$project$Components$UpgradePracticeModal$viewAdditionalInfoFooter = function (hasClinicalAccount) {
	var pricingInfoText = 'view our pricing information';
	var contactSalesText = 'Contact our sales team';
	var contactSalesLinkHref = 'mailto:sales@hint.com';
	return A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[$author$project$Ui$Typography$muted]),
		_List_fromArray(
			[
				$elm$html$Html$text('Have any questions? '),
				A3(
				$author$project$Ui$Link$externalHref,
				contactSalesLinkHref,
				_List_fromArray(
					[
						$author$project$Ui$Link$targetBlank,
						$author$project$Ui$Link$onClick(
						A2($author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked, contactSalesText, contactSalesLinkHref))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(contactSalesText)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' or')
					])),
				A3(
				$author$project$Ui$Link$externalHref,
				$author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount),
				_List_fromArray(
					[
						$author$project$Ui$Link$margin(11),
						$author$project$Ui$Link$targetBlank,
						$author$project$Ui$Link$onClick(
						A2(
							$author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked,
							pricingInfoText,
							$author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(pricingInfoText)
					])),
				$elm$html$Html$text(' on our website.')
			]));
};
var $author$project$Components$UpgradePracticeModal$viewConfirmationCheckbox = F2(
	function (agreedToTerms, hasClinicalAccount) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(agreedToTerms),
							$author$project$Ui$Form$Checkbox$required(true),
							$author$project$Ui$Form$Checkbox$onCheck(
							function (value) {
								return $author$project$Components$UpgradePracticeModal$AgreedToTerms(value);
							})
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexMd]),
							_List_fromArray(
								[
									$elm$html$Html$text('I agree to these changes, subject to the previously agreed upon terms of service.'),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$danger]),
									_List_fromArray(
										[
											$elm$html$Html$text(' *')
										]))
								]))
						])),
					$author$project$Components$UpgradePracticeModal$viewAdditionalInfoFooter(hasClinicalAccount)
				]));
	});
var $author$project$Ui$SvgIcon$Star = 66;
var $author$project$Ui$Alert$Success = 0;
var $author$project$Ui$Margin$Top_4 = 9;
var $author$project$Ui$Alert$Alignment = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Alert$alignment = $author$project$Ui$Alert$Alignment;
var $author$project$Ui$Typography$Black = 8;
var $author$project$Ui$Typography$black = $author$project$Ui$Typography$Color(8);
var $author$project$Ui$SvgIcon$Color = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$SvgIcon$color = $author$project$Ui$SvgIcon$Color;
var $author$project$Ui$Alert$margin = $author$project$Ui$Alert$Margin;
var $author$project$Ui$Alignment$Left = 0;
var $author$project$Ui$Alignment$textLeft = $author$project$Ui$Alignment$Text(0);
var $author$project$Components$UpgradePracticeModal$viewClinicalDiscountBanner = function (hasClinicalAccount) {
	return hasClinicalAccount ? A3(
		$author$project$Ui$Alert$view,
		0,
		_List_fromArray(
			[
				$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
				$author$project$Ui$Alert$margin(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flexMd]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$SvgIcon$view,
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$height('1.8rem'),
										$author$project$Ui$SvgIcon$color('#2A8000')
									]),
								66)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$bold,
										$author$project$Ui$Typography$margin(5),
										$author$project$Ui$Typography$black
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Thanks for being a Clinical customer!')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$black]),
								_List_fromArray(
									[
										$elm$html$Html$text('You get a '),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$bold]),
										_List_fromArray(
											[
												$elm$html$Html$text('20% discount')
											])),
										$elm$html$Html$text(' on clinicians and members.')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Ui$SvgIcon$Calendar = 53;
var $author$project$Ui$SvgIcon$Scissors = 65;
var $author$project$Ui$SvgIcon$Sponsors = 11;
var $author$project$Ui$SvgIcon$StarNote = 67;
var $author$project$Ui$Element$SpaceY = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Element$spaceY4 = $author$project$Ui$Element$SpaceY(4);
var $author$project$Ui$Link$IconRight = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ui$Link$iconRight = $author$project$Ui$Link$IconRight;
var $author$project$Ui$SvgIcon$Launch = 20;
var $author$project$Ui$SvgIcon$launch = $author$project$Ui$SvgIcon$viewIcon(20);
var $author$project$Ui$Link$Md = 2;
var $author$project$Ui$Link$md = $author$project$Ui$Link$Size(2);
var $author$project$Ui$Link$Sm = 0;
var $author$project$Ui$Link$sm = $author$project$Ui$Link$Size(0);
var $author$project$Ui$Link$Style = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Link$Underline = 5;
var $author$project$Ui$Link$underline = $author$project$Ui$Link$Style(5);
var $author$project$Components$HintBilling$FeatureListLink$view = F3(
	function (hasClinicalAccount, onAnalyticsClick, smallSize) {
		return A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount),
			_List_fromArray(
				[
					$author$project$Ui$Link$targetBlank,
					$author$project$Ui$Link$underline,
					$author$project$Ui$Link$iconRight($author$project$Ui$SvgIcon$launch),
					$author$project$Ui$Link$onClick(
					A2(
						onAnalyticsClick,
						'See All Features',
						$author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount))),
					smallSize ? $author$project$Ui$Link$sm : $author$project$Ui$Link$md
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('See All Features')
				]));
	});
var $author$project$Ui$Element$mr2 = $author$project$Ui$Element$Margin('mr-2');
var $author$project$Components$UpgradePracticeModal$viewFeatureItem = F3(
	function (title, description, svgIcon) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexMd, $author$project$Ui$Element$itemsStart]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mr2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$height('1.8rem'),
									$author$project$Ui$SvgIcon$color('#00BFFF')
								]),
							svgIcon)
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $author$project$Components$UpgradePracticeModal$viewFeaturesList = function (hasClinicalAccount) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4, $author$project$Ui$Element$spaceY4]),
		_List_fromArray(
			[
				A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Lower Fees on Every Transaction', 'Grow your practice and keep more of what you earn. Lower transaction fees apply to every payment, starting with your next one.', 65),
				A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Employer Management & Billing', 'Streamline eligibility tracking, boost enrollments, and simplify billing for sponsoring employers with intuitive, built-in tools.', 11),
				hasClinicalAccount ? A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Hint Copilot', 'Simplify charting and streamline comminication with accurate, AI-generated SOAP notes and patient summaries.', 67) : A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Scheduled Plan Changes', 'Automate annual price increase, plan updates, and special offers so changes go live exactly when you want them.', 53),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A3($author$project$Components$HintBilling$FeatureListLink$view, hasClinicalAccount, $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked, true)
					]))
			]));
};
var $author$project$Components$UpgradePracticeModal$viewMarketingContent = F2(
	function (upgradePricing, hasClinicalAccount) {
		var tierName = function () {
			if (!upgradePricing.$) {
				var pricing = upgradePricing.a;
				return $author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing);
			} else {
				return 'Growth';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('px-4 py-2')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$heading(
					_List_fromArray(
						[
							$elm$html$Html$text('Upgrade to ' + tierName)
						])),
					$author$project$Components$UpgradePracticeModal$viewClinicalDiscountBanner(hasClinicalAccount),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Unlock All Benefits Now, Pay Nothing Today')
										]))
								])),
							$author$project$Components$UpgradePracticeModal$viewFeaturesList(hasClinicalAccount)
						]))
				]));
	});
var $author$project$Ui$Alert$FullHeight = {$: 5};
var $author$project$Ui$Alert$fullHeight = $author$project$Ui$Alert$FullHeight;
var $author$project$Api$Provider$PracticePricing$Upgrade$components = function (_v0) {
	var record = _v0;
	return record.LD;
};
var $author$project$Ui$Element$Direction = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Ui$Element$DirectionColumn = 1;
var $author$project$Ui$Element$flexCol = A2($author$project$Ui$Element$Direction, 0, 1);
var $author$project$Utils$Currency$fromInt = function (cents) {
	return (cents >= 0) ? ('$' + A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, cents / 100)) : ('-$' + A2(
		$cuducos$elm_format_number$FormatNumber$format,
		$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
		$elm$core$Basics$abs(cents) / 100));
};
var $author$project$Ui$Element$FullHeight = {$: 14};
var $author$project$Ui$Element$fullHeight = $author$project$Ui$Element$FullHeight;
var $author$project$Ui$HorizontalRule$Margin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$HorizontalRule$margin = $author$project$Ui$HorizontalRule$Margin;
var $author$project$Ui$Element$mb4 = $author$project$Ui$Element$Margin('mb-4');
var $author$project$Api$Provider$PracticePricing$Upgrade$nextBillDate = function (_v0) {
	var record = _v0;
	return record.UC;
};
var $author$project$Api$Provider$PracticePricing$Upgrade$totalInCents = function (_v0) {
	var record = _v0;
	return record.$X;
};
var $author$project$Api$Provider$PracticePricing$Upgrade$txnFees = function (_v0) {
	var record = _v0;
	return record.aaf;
};
var $author$project$Components$UpgradePracticeModal$viewDiscountInfo = A2(
	$author$project$Ui$Typography$p,
	_List_fromArray(
		[
			$author$project$Ui$Typography$muted,
			$author$project$Ui$Typography$small,
			$author$project$Ui$Typography$margin(9)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Any existing credits or discounts will continue to apply until they expire.')
		]));
var $author$project$Ui$Margin$Right_2 = 16;
var $author$project$Ui$Typography$Strike = 1;
var $author$project$Ui$Typography$strike = $author$project$Ui$Typography$Decoration(1);
var $author$project$Ui$Alignment$Right = 2;
var $author$project$Ui$Alignment$textRight = $author$project$Ui$Alignment$Text(2);
var $author$project$Ui$Icon$Question = 5;
var $author$project$Ui$Popover$Body = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Popover$body = $author$project$Ui$Popover$Body;
var $author$project$Ui$Icon$Clickable = {$: 2};
var $author$project$Ui$Icon$clickable = $author$project$Ui$Icon$Clickable;
var $author$project$Ui$Popover$Dark = 0;
var $author$project$Ui$Popover$Styling = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Popover$dark = $author$project$Ui$Popover$Styling(0);
var $author$project$Formatters$Locales$noDecimalLocale = {
	acw: '.',
	M4: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	aeO: '−',
	aeP: '',
	afO: '',
	afP: '',
	ahr: ',',
	ahZ: '',
	ah_: ''
};
var $author$project$Utils$Currency$fromIntNoDecimals = function (cents) {
	return '$' + A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, cents / 100);
};
var $author$project$Ui$Typography$HelpText = {$: 9};
var $author$project$Ui$Typography$helpText = $author$project$Ui$Typography$HelpText;
var $author$project$Ui$Popover$OnHover = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Popover$onHover = $author$project$Ui$Popover$OnHover;
var $author$project$Ui$Popover$Size = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Popover$Small = 3;
var $author$project$Ui$Popover$sm = $author$project$Ui$Popover$Size(3);
var $author$project$Api$Provider$PracticePricing$TrancheSizes$trancheSize = function (tierName) {
	switch (tierName) {
		case 'Growth':
			return $elm$core$Maybe$Just(50);
		case 'Scale':
			return $elm$core$Maybe$Just(250);
		case 'Enterprise':
			return $elm$core$Maybe$Just(500);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Popover$Default = 0;
var $author$project$Ui$Popover$defaultOptions = {x1: true, yH: _List_Nil, zL: $elm$core$Maybe$Nothing, ag_: 0, s_: 'popover__elm', hd: false};
var $author$project$Ui$Popover$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, optionsRecord) {
				switch (option.$) {
					case 0:
						var style = option.a;
						return _Utils_update(
							optionsRecord,
							{s_: 'popover--dark'});
					case 1:
						var bool = option.a;
						return _Utils_update(
							optionsRecord,
							{hd: bool});
					case 2:
						var bool = option.a;
						return _Utils_update(
							optionsRecord,
							{x1: bool});
					case 3:
						var size_ = option.a;
						return _Utils_update(
							optionsRecord,
							{ag_: size_});
					case 4:
						var msg = option.a;
						return _Utils_update(
							optionsRecord,
							{
								zL: $elm$core$Maybe$Just(msg)
							});
					default:
						var margin_ = option.a;
						return _Utils_update(
							optionsRecord,
							{
								yH: A2(
									$elm$core$List$cons,
									$author$project$Ui$Margin$toClass(margin_),
									optionsRecord.yH)
							});
				}
			}),
		$author$project$Ui$Popover$defaultOptions,
		options);
};
var $author$project$Ui$Popover$sectionToContents = function (section) {
	switch (section.$) {
		case 0:
			var attributes = section.a;
			var contents = section.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('popover__heading'),
						attributes),
					contents)
				]);
		case 1:
			var attributes = section.a;
			var contents = section.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('popover__body'),
						attributes),
					contents)
				]);
		default:
			var attributes = section.a;
			var contents = section.b;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('popover__footer'),
						attributes),
					contents)
				]);
	}
};
var $author$project$Ui$Popover$sectionsToContents = function (sections) {
	return A2($elm$core$List$concatMap, $author$project$Ui$Popover$sectionToContents, sections);
};
var $author$project$Ui$Popover$sizeToClass = function (size_) {
	switch (size_) {
		case 0:
			return '';
		case 3:
			return 'popover--sm';
		case 2:
			return 'popover--md';
		default:
			return 'popover--lg';
	}
};
var $author$project$Ui$Popover$popoverContent = F2(
	function (sections, optionsRecord) {
		return A2(
			$elm$html$Html$div,
			_Utils_ap(
				optionsRecord.yH,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('popover__content'),
						$elm$html$Html$Attributes$class(
						$author$project$Ui$Popover$sizeToClass(optionsRecord.ag_)),
						$elm$html$Html$Attributes$class(optionsRecord.s_)
					])),
			$author$project$Ui$Popover$sectionsToContents(sections));
	});
var $author$project$Ui$Popover$popoverDisplayedContent = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('popover__content--displayed')
			]),
		content);
};
var $author$project$Ui$Popover$popoverView = F4(
	function (options, displayedContent, sections, maybeModel) {
		var optionsRecord = $author$project$Ui$Popover$optionsToRecord(options);
		if (!maybeModel.$) {
			var model = maybeModel.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('popover__wrapper'),
						$elm$html$Html$Attributes$id(model.adR),
						model.U9 ? $elm$html$Html$Attributes$class('visible') : $elm$html$Html$Attributes$class('')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Popover$popoverDisplayedContent(displayedContent),
						A2($author$project$Ui$Popover$popoverContent, sections, optionsRecord)
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('popover__wrapper'),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$Attributes$class(''),
						A2($elm$core$Maybe$map, $elm$html$Html$Events$onMouseOver, optionsRecord.zL)),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('visible', optionsRecord.hd),
								_Utils_Tuple2('hoverable', optionsRecord.x1)
							]))
					]),
				_List_fromArray(
					[
						$author$project$Ui$Popover$popoverDisplayedContent(displayedContent),
						A2($author$project$Ui$Popover$popoverContent, sections, optionsRecord)
					]));
		}
	});
var $author$project$Ui$Popover$view = F3(
	function (options, displayedContent, sections) {
		return A4($author$project$Ui$Popover$popoverView, options, displayedContent, sections, $elm$core$Maybe$Nothing);
	});
var $author$project$Components$HintBilling$MemberTranches$view = F4(
	function (tierName, quantity, itemPriceInCents, onAnalyticsClick) {
		var _v0 = $author$project$Api$Provider$PracticePricing$TrancheSizes$trancheSize(tierName);
		if (!_v0.$) {
			var trancheSize = _v0.a;
			var numberOfTranches = (quantity / trancheSize) | 0;
			var pricePerTranche = (itemPriceInCents / numberOfTranches) | 0;
			var perMembersPriceText = $author$project$Utils$Currency$fromIntNoDecimals(pricePerTranche) + ('/mo per ' + ($elm$core$String$fromInt(trancheSize) + ' members '));
			return A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text(perMembersPriceText),
						A3(
						$author$project$Ui$Popover$view,
						_List_fromArray(
							[
								$author$project$Ui$Popover$dark,
								$author$project$Ui$Popover$sm,
								$author$project$Ui$Popover$onHover(
								A2(onAnalyticsClick, perMembersPriceText, 'tooltip'))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Icon$view,
								_List_fromArray(
									[$author$project$Ui$Icon$clickable]),
								5)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Popover$body,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Additional members are automatically added in tranches of ' + ($elm$core$String$fromInt(trancheSize) + ' members. If your member count goes below this tranche, you can downgrade at any time.'))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$UpgradePracticeModal$viewLineItem = F2(
	function (tierName, component) {
		var quantity = A2($elm$core$Maybe$withDefault, 1, component.Bd);
		var oldPriceInCents = A2(
			$elm$core$Maybe$map,
			function (price) {
				return quantity * price;
			},
			component.UY);
		var itemPriceInCents = quantity * component.Ba;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$black]),
							_List_fromArray(
								[
									function () {
									var _v0 = component.Bd;
									if (!_v0.$) {
										var qty = _v0.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(qty))
														])),
													$elm$html$Html$text(' ' + component.zh)
												]));
									} else {
										return $elm$html$Html$text(component.zh);
									}
								}()
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if (!oldPriceInCents.$) {
										var price = oldPriceInCents.a;
										return A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$muted,
													$author$project$Ui$Typography$strike,
													$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight),
													$author$project$Ui$Typography$margin(16)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(price))
												]));
									} else {
										return $author$project$Utils$Html$noBreakSpace;
									}
								}(),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$black]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(itemPriceInCents))
										]))
								]))
						])),
					(component.LC === 2) ? A4($author$project$Components$HintBilling$MemberTranches$view, tierName, quantity, itemPriceInCents, $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$UpgradePracticeModal$viewLineItems = F2(
	function (tierName, components) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceY4]),
			A2(
				$elm$core$List$map,
				$author$project$Components$UpgradePracticeModal$viewLineItem(tierName),
				A2(
					$elm$core$List$filter,
					function (component) {
						return !(!component.Ba);
					},
					components)));
	});
var $author$project$Ui$Margin$Top_2 = 8;
var $author$project$Api$Provider$TxnFees$achTransactionFeeCapInCents = function (_v0) {
	var record = _v0;
	return record.H9;
};
var $author$project$Api$Provider$TxnFees$amexSurcharge = function (_v0) {
	var record = _v0;
	return record.$T - record.HB;
};
var $author$project$Api$Provider$TxnFees$totalAchFeeInCents = function (_v0) {
	var record = _v0;
	return record.$R;
};
var $author$project$Api$Provider$TxnFees$totalAchFeePercentage = function (_v0) {
	var record = _v0;
	return record.$S;
};
var $author$project$Api$Provider$TxnFees$totalCardFeeInCents = function (_v0) {
	var record = _v0;
	return record.$U;
};
var $author$project$Api$Provider$TxnFees$totalCardFeePercentage = function (_v0) {
	var record = _v0;
	return record.HB;
};
var $author$project$Utils$Billing$TxnFees$viewFees = F2(
	function (txnFees, inline) {
		var totalCardFeePercentage = $elm$core$String$fromFloat(
			$author$project$Api$Provider$TxnFees$totalCardFeePercentage(txnFees)) + '%';
		var totalCardFeeInCents = $elm$core$String$fromInt(
			$author$project$Api$Provider$TxnFees$totalCardFeeInCents(txnFees)) + 'c';
		var totalAchFeePercentage = $elm$core$String$fromFloat(
			$author$project$Api$Provider$TxnFees$totalAchFeePercentage(txnFees)) + '%';
		var totalAchFeeInCents = $elm$core$String$fromInt(
			$author$project$Api$Provider$TxnFees$totalAchFeeInCents(txnFees)) + 'c';
		var amexSurchargeDisplay = ' + ' + ($elm$core$String$fromFloat(
			$author$project$Api$Provider$TxnFees$amexSurcharge(txnFees)) + '% Amex surcharge');
		var achCapDisplay = function () {
			var _v0 = $author$project$Api$Provider$TxnFees$achTransactionFeeCapInCents(txnFees);
			if (!_v0.$) {
				var cap = _v0.a;
				return ' ($' + ($elm$core$String$fromFloat(cap / 100) + ' cap per txn)');
			} else {
				return '';
			}
		}();
		return inline ? A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$black, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text('Credit cards: ' + (totalCardFeePercentage + (' + ' + totalCardFeeInCents))),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(amexSurchargeDisplay)
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$black, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text('ACH: ' + (totalAchFeePercentage + (' + ' + (totalAchFeeInCents + achCapDisplay))))
						]))
				])) : A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Credit Card:')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[
									$elm$html$Html$text(totalCardFeePercentage)
								])),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text(' + ' + totalCardFeeInCents)
								])),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text(amexSurchargeDisplay)
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('ACH:')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[
									$elm$html$Html$text(totalAchFeePercentage)
								])),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text(' + ' + totalAchFeeInCents)
								])),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text(achCapDisplay)
								]))
						]))
				]));
	});
var $author$project$Components$UpgradePracticeModal$viewTransactionFees = function (txnFees) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[
						$author$project$Ui$Typography$black,
						$author$project$Ui$Typography$margin(5),
						$author$project$Ui$Typography$small
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Updated Transaction Fees')
					])),
				$author$project$Ui$HorizontalRule$view(
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$margin(8)
					])),
				A2($author$project$Utils$Billing$TxnFees$viewFees, txnFees, true)
			]));
};
var $author$project$Components$UpgradePracticeModal$viewPricingContent = function (pricing) {
	var nextBillDate = function () {
		var _v0 = $author$project$Api$Provider$PracticePricing$Upgrade$nextBillDate(pricing);
		if (!_v0.$) {
			var date = _v0.a;
			return A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date);
		} else {
			return '';
		}
	}();
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$fullHeight]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Your new recurring total')
									])),
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromInt(
											$author$project$Api$Provider$PracticePricing$Upgrade$totalInCents(pricing)))
									]))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Due on ' + nextBillDate)
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$margin(9)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$UpgradePracticeModal$viewLineItems,
								$author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing),
								$author$project$Api$Provider$PracticePricing$Upgrade$components(pricing))
							])),
						$author$project$Components$UpgradePracticeModal$viewDiscountInfo
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$UpgradePracticeModal$viewTransactionFees(
						$author$project$Api$Provider$PracticePricing$Upgrade$txnFees(pricing))
					]))
			]));
};
var $author$project$Components$UpgradePracticeModal$viewPricingSidebar = function (upgradePricing) {
	return A3(
		$author$project$Ui$Alert$view,
		1,
		_List_fromArray(
			[
				$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
				$author$project$Ui$Alert$fullHeight
			]),
		_List_fromArray(
			[
				function () {
				if (!upgradePricing.$) {
					var pricing = upgradePricing.a;
					return $author$project$Components$UpgradePracticeModal$viewPricingContent(pricing);
				} else {
					return A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$margin(9)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Loading pricing information...')
									]))
							]));
				}
			}()
			]));
};
var $author$project$Components$UpgradePracticeModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$UpgradePracticeModal$Close,
		_List_fromArray(
			[
				$author$project$Ui$Modal$size(2)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_fromArray(
							[$author$project$Ui$FlexGrid$gutterMd, $author$project$Ui$FlexGrid$rowItemsStretch]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(7)
									]),
								_List_fromArray(
									[
										A2($author$project$Components$UpgradePracticeModal$viewMarketingContent, model.g8, model.P2)
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(5)
									]),
								_List_fromArray(
									[
										$author$project$Components$UpgradePracticeModal$viewPricingSidebar(model.g8)
									]))
							])),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt8]),
						_List_fromArray(
							[
								A2($author$project$Components$UpgradePracticeModal$viewConfirmationCheckbox, model.abc, model.P2)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt4, $author$project$Ui$Element$spaceX4]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Cancel and lose modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$secondary,
										$author$project$Ui$Button$onClick($author$project$Components$UpgradePracticeModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Upgrade'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Components$UpgradePracticeModal$ConfirmUpgrade),
										$author$project$Ui$Button$disabled((!model.abc) || model.iY)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Upgrade')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Billing$modals = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.ct;
				if ((_v0.$ === 1) && _v0.a) {
					var modal = _v0.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Billing$UpdateModalMsg,
						$author$project$Components$ApplicationFeePlan$UpdateModal$view(modal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.hW;
				if (!_v1.$) {
					var modal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Billing$CreateChargeModalMsg,
						A2($author$project$Components$HintBilling$CreateChargeModal$view, modal, 'Add Charge or Credit'));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.kC;
				if (!_v2.$) {
					var modal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Billing$UpgradePracticeModalMsg,
						$author$project$Components$UpgradePracticeModal$view(modal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Api$Provider$PracticePricing$One$manualBilling = function (_v0) {
	var record = _v0;
	return record.Te;
};
var $author$project$Pages$Admin$Billing$shouldShowBillingSections = function (practicePricingData) {
	if (practicePricingData.$ === 3) {
		var practicePricing = practicePricingData.a;
		return !$author$project$Api$Provider$PracticePricing$One$manualBilling(practicePricing);
	} else {
		return true;
	}
};
var $author$project$Ui$Table$Loading = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Table$loading = $author$project$Ui$Table$Loading;
var $author$project$Api$Pagination$CurrentPageChanged = $elm$core$Basics$identity;
var $author$project$Ui$Pagination$List$CurrentPage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Pagination$List$currentPage = $author$project$Ui$Pagination$List$CurrentPage;
var $author$project$Ui$Pagination$List$ItemsPerPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Pagination$List$itemsPerPage = $author$project$Ui$Pagination$List$ItemsPerPage;
var $author$project$Ui$Pagination$List$OnClick = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Pagination$List$onClick = $author$project$Ui$Pagination$List$OnClick;
var $author$project$Ui$Pagination$List$TotalCount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Pagination$List$totalCount = $author$project$Ui$Pagination$List$TotalCount;
var $author$project$Ui$Skeleton$inputSm = $author$project$Ui$Skeleton$view('input-sm');
var $author$project$Ui$Skeleton$inputXs = $author$project$Ui$Skeleton$view('input-xs');
var $author$project$Ui$Pagination$List$offsetSize = 2;
var $author$project$Ui$Pagination$List$onClick_ = F2(
	function (maybeMsg, pageNumber) {
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return $elm$html$Html$Events$onClick(
				msg(pageNumber));
		} else {
			return $author$project$Utils$Html$Attributes$none;
		}
	});
var $author$project$Ui$Pagination$List$Md = 1;
var $author$project$Ui$Pagination$List$defaultOptions = {bV: 0, xQ: false, xR: false, mM: 0, S_: false, zI: $elm$core$Maybe$Nothing, ag_: 1, oN: 0};
var $author$project$Ui$Pagination$List$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var _int = option.a;
						return _Utils_update(
							record,
							{oN: _int});
					case 1:
						var _int = option.a;
						return _Utils_update(
							record,
							{mM: _int});
					case 2:
						return _Utils_update(
							record,
							{xR: true});
					case 3:
						return _Utils_update(
							record,
							{xQ: true});
					case 4:
						var _int = option.a;
						return _Utils_update(
							record,
							{bV: _int});
					case 5:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								zI: $elm$core$Maybe$Just(toMsg)
							});
					case 6:
						var size_ = option.a;
						return _Utils_update(
							record,
							{ag_: size_});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{S_: bool});
				}
			}),
		$author$project$Ui$Pagination$List$defaultOptions,
		options);
};
var $author$project$Ui$Pagination$List$sizeClass = function (size_) {
	switch (size_) {
		case 0:
			return 'pagination--sm';
		case 1:
			return '';
		default:
			return 'pagination--lg';
	}
};
var $author$project$Ui$Element$spaceX2 = $author$project$Ui$Element$SpaceX(2);
var $author$project$Ui$Pagination$List$viewPage = F3(
	function (currentPage_, maybeMsg, pageNumber) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pagination__item'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							_Utils_eq(currentPage_, pageNumber))
						])),
					A2($author$project$Ui$Pagination$List$onClick_, maybeMsg, pageNumber)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(pageNumber))
				]));
	});
var $author$project$Ui$Pagination$List$view = function (options) {
	var optionsRecord = $author$project$Ui$Pagination$List$optionsToRecord(options);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter]),
		function () {
			if (optionsRecord.S_) {
				var skeleton = function (text) {
					return function () {
						var _v0 = optionsRecord.ag_;
						if (!_v0) {
							return $author$project$Ui$Skeleton$inputXs;
						} else {
							return $author$project$Ui$Skeleton$inputSm;
						}
					}()(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText(text + '0')
							]));
				};
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceX2, $author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								skeleton('First'),
								skeleton('1'),
								skeleton('2'),
								skeleton('3'),
								skeleton('...'),
								skeleton('Last')
							]))
					]);
			} else {
				var showTotalItems = (!optionsRecord.xQ) && (!((_Utils_cmp(optionsRecord.oN, optionsRecord.mM) < 1) && optionsRecord.xR));
				return $elm$core$List$concat(
					_List_fromArray(
						[
							function () {
							if (!optionsRecord.oN) {
								return _List_Nil;
							} else {
								if (_Utils_cmp(optionsRecord.oN, optionsRecord.mM) > 0) {
									var totalPages = $elm$core$Basics$ceiling(optionsRecord.oN / optionsRecord.mM);
									var lastVisible = A2($elm$core$Basics$min, optionsRecord.bV + $author$project$Ui$Pagination$List$offsetSize, totalPages);
									var firstVisible = A2($elm$core$Basics$max, optionsRecord.bV - $author$project$Ui$Pagination$List$offsetSize, 1);
									var pages = A2($elm$core$List$range, firstVisible, lastVisible);
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pagination'),
													$elm$html$Html$Attributes$class(
													$author$project$Ui$Pagination$List$sizeClass(optionsRecord.ag_))
												]),
											$elm$core$List$concat(
												_List_fromArray(
													[
														_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination__item'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('disabled', optionsRecord.bV === 1)
																		])),
																	A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.zI, 1)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('First')
																]))
														]),
														(firstVisible > 1) ? _List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination__item'),
																	A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.zI, firstVisible - 1)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('...')
																]))
														]) : _List_Nil,
														A2(
														$elm$core$List$map,
														A2($author$project$Ui$Pagination$List$viewPage, optionsRecord.bV, optionsRecord.zI),
														pages),
														(_Utils_cmp(lastVisible, totalPages) < 0) ? _List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination__item'),
																	A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.zI, lastVisible + 1)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('...')
																]))
														]) : _List_Nil,
														_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pagination__item'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2(
																			'disabled',
																			_Utils_eq(optionsRecord.bV, totalPages))
																		])),
																	A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.zI, totalPages)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Last')
																]))
														])
													])))
										]);
								} else {
									return _List_Nil;
								}
							}
						}(),
							function () {
							if (showTotalItems) {
								var offsetCount = (optionsRecord.bV - 1) * optionsRecord.mM;
								var fromItems = offsetCount + 1;
								var fromItems_ = (!optionsRecord.oN) ? 0 : fromItems;
								var currentPageItemsCount = (_Utils_cmp(optionsRecord.mM * optionsRecord.bV, optionsRecord.oN) > 0) ? (optionsRecord.oN - (optionsRecord.mM * (optionsRecord.bV - 1))) : optionsRecord.mM;
								var toItems = (fromItems - 1) + currentPageItemsCount;
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pagination__total ml-auto')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(fromItems_) + (' — ' + ($elm$core$String$fromInt(toItems) + (' of ' + $elm$core$String$fromInt(optionsRecord.oN)))))
											]))
									]);
							} else {
								return _List_Nil;
							}
						}()
						]));
			}
		}());
};
var $author$project$Api$Pagination$view = F2(
	function (options, _v0) {
		var model = _v0;
		return $author$project$Ui$Pagination$List$view(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Pagination$List$totalCount(model.oN),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Pagination$List$itemsPerPage(model.mM),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Pagination$List$currentPage(model.bV),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Pagination$List$onClick($elm$core$Basics$identity),
							options)))));
	});
var $author$project$Api$Provider$PracticeInvoice$Status$toString = function (status_) {
	switch (status_) {
		case 0:
			return 'paid';
		case 1:
			return 'processing';
		case 2:
			return 'draft';
		case 5:
			return 'overdue';
		case 4:
			return 'cancelled';
		case 6:
			return 'disputed';
		default:
			return 'issued';
	}
};
var $author$project$Api$Provider$PracticeInvoice$Status$toBadge = function (status_) {
	var badgeOption = function () {
		switch (status_) {
			case 0:
				return _List_fromArray(
					[$author$project$Ui$Badge$success]);
			case 1:
				return _List_fromArray(
					[$author$project$Ui$Badge$primary]);
			case 3:
				return _List_fromArray(
					[$author$project$Ui$Badge$warning]);
			case 5:
				return _List_fromArray(
					[$author$project$Ui$Badge$danger]);
			default:
				return _List_Nil;
		}
	}();
	return A2(
		$author$project$Ui$Badge$view,
		badgeOption,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$PracticeInvoice$Status$toString(status_))
			]));
};
var $author$project$Components$HintBilling$InvoicesTable$viewInvoiceUrl = F2(
	function (id, linkContent) {
		return A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String(
				{adR: id}),
			_List_Nil,
			_List_fromArray(
				[linkContent]));
	});
var $author$project$Formatters$Time$Date__Full = 5;
var $author$project$Components$HintBilling$InvoicesTable$isInvoicePaid = function (invoice) {
	return !invoice.ag7;
};
var $author$project$Components$HintBilling$InvoicesTable$viewPaidInfo = function (invoice) {
	if ($author$project$Components$HintBilling$InvoicesTable$isInvoicePaid(invoice)) {
		var _v0 = invoice.GA;
		if (!_v0.$) {
			var time = _v0.a;
			var timeFormatter = _v0.b;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						' on ' + A2(timeFormatter, 5, time))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$HintBilling$InvoicesTable$viewInvoice = function (invoice) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Components$HintBilling$InvoicesTable$viewInvoiceUrl,
						invoice.adR,
						$elm$html$Html$text(
							A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, invoice.MO)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(invoice.Gj))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Api$Provider$PracticeInvoice$Status$toBadge(invoice.ag7),
						$author$project$Components$HintBilling$InvoicesTable$viewPaidInfo(invoice)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(invoice.$X))
					]))
			]));
};
var $author$project$Components$HintBilling$InvoicesTable$viewInvoicesTableHeaders = _List_fromArray(
	[
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(3)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Date')
			])),
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(2)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Invoice Number')
			])),
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(4)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Invoice Status')
			])),
		A2(
		$author$project$Ui$Table$header,
		_List_fromArray(
			[
				$author$project$Ui$Table$cellSpan(3)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Invoice Total')
			]))
	]);
var $author$project$Components$HintBilling$InvoicesTable$view = F2(
	function (_v0, pagination) {
		var record = _v0;
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A4(
					$author$project$Ui$Table$view,
					_List_fromArray(
						[
							$author$project$Ui$Table$loading(record.S_)
						]),
					$author$project$Components$HintBilling$InvoicesTable$viewInvoicesTableHeaders,
					$elm$core$List$isEmpty(record.q2) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have no invoices yet!')
										]))
								]))
						]) : A2($elm$core$List$map, $author$project$Components$HintBilling$InvoicesTable$viewInvoice, record.q2),
					_List_Nil),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A2($author$project$Api$Pagination$view, _List_Nil, pagination)
						]))
				]));
	});
var $author$project$Ui$Element$Gap = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Element$gap2 = $author$project$Ui$Element$Gap(2);
var $author$project$Ui$Tooltip$Bottom = 1;
var $author$project$Pages$Admin$Billing$CreateInvoiceClicked = {$: 16};
var $author$project$Ui$SvgIcon$HintHeart = 32;
var $author$project$Ui$SvgIcon$hintHeart = $author$project$Ui$SvgIcon$viewIcon(32);
var $author$project$Ui$HinterOnly$icon = $author$project$Ui$SvgIcon$hintHeart;
var $author$project$Ui$HinterOnly$button = F3(
	function (accessibility, options, content) {
		return A3(
			$author$project$Ui$Button$view,
			accessibility,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Button$icon($author$project$Ui$HinterOnly$icon),
				options),
			content);
	});
var $author$project$Ui$Tooltip$Placement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Tooltip$placement = $author$project$Ui$Tooltip$Placement;
var $author$project$Ui$Tooltip$placementToAttribute = function (plmnt) {
	switch (plmnt) {
		case 0:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip--top')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip--right')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip--left')
				]);
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('tooltip--bottom')
				]);
	}
};
var $author$project$Ui$Tooltip$optionsToAttributes = function (options) {
	return _Utils_ap(
		$author$project$Ui$Tooltip$placementToAttribute(options.AQ),
		_Utils_ap(
			function () {
				var _v0 = options.sh;
				if (!_v0.$) {
					var direction = _v0.a;
					return _List_fromArray(
						[
							$author$project$Ui$Pull$toClass(direction)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			function () {
				var _v1 = options.nf;
				if (!_v1.$) {
					var padding_ = _v1.a;
					return _List_fromArray(
						[
							$author$project$Ui$Padding$toClass(padding_)
						]);
				} else {
					return _List_Nil;
				}
			}()));
};
var $author$project$Ui$Tooltip$Top = 0;
var $author$project$Ui$StackingOrder$StackingOrder = $elm$core$Basics$identity;
var $author$project$Ui$StackingOrder$z100 = 100;
var $author$project$Ui$Tooltip$defaultOptions = {Ic: true, nf: $elm$core$Maybe$Nothing, AQ: 0, sh: $elm$core$Maybe$Nothing, Cq: $author$project$Ui$StackingOrder$z100, DP: false};
var $author$project$Ui$Tooltip$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				switch (option.$) {
					case 0:
						var place = option.a;
						return _Utils_update(
							acc,
							{AQ: place});
					case 1:
						var bool = option.a;
						return _Utils_update(
							acc,
							{Ic: bool});
					case 2:
						var direction = option.a;
						return _Utils_update(
							acc,
							{
								sh: $elm$core$Maybe$Just(direction)
							});
					case 3:
						var order = option.a;
						return _Utils_update(
							acc,
							{Cq: order});
					case 4:
						return _Utils_update(
							acc,
							{DP: true});
					default:
						var padding_ = option.a;
						return _Utils_update(
							acc,
							{
								nf: $elm$core$Maybe$Just(padding_)
							});
				}
			}),
		$author$project$Ui$Tooltip$defaultOptions,
		options);
};
var $author$project$Ui$StackingOrder$toClass = function (_v0) {
	var _int = _v0;
	return $elm$html$Html$Attributes$class(
		'z-' + $elm$core$String$fromInt(_int));
};
var $author$project$Ui$Tooltip$view = F3(
	function (options, tooltip, contents) {
		var optionsRecord = $author$project$Ui$Tooltip$optionsToRecord(options);
		return optionsRecord.Ic ? A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('tooltip-wrapper'),
				function () {
					var _v0 = optionsRecord.nf;
					if (!_v0.$) {
						var padding_ = _v0.a;
						return _List_fromArray(
							[
								$author$project$Ui$Padding$toClass(padding_)
							]);
					} else {
						return _List_Nil;
					}
				}()),
			_Utils_ap(
				contents,
				_List_fromArray(
					[
						function (attrs) {
						return A2($elm$html$Html$span, attrs, _List_Nil);
					}(
						function (attrs) {
							return _Utils_ap(
								attrs,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'data-text', tooltip),
										$elm$html$Html$Attributes$class('tooltip'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('tooltip--wide', optionsRecord.DP)
											])),
										$author$project$Ui$StackingOrder$toClass(optionsRecord.Cq)
									]));
						}(
							$author$project$Ui$Tooltip$optionsToAttributes(optionsRecord)))
					]))) : A2(
			$elm$html$Html$span,
			function () {
				var _v1 = optionsRecord.nf;
				if (!_v1.$) {
					var padding_ = _v1.a;
					return _List_fromArray(
						[
							$author$project$Ui$Padding$toClass(padding_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			contents);
	});
var $author$project$Ui$Tooltip$Wide = {$: 4};
var $author$project$Ui$Tooltip$wide = $author$project$Ui$Tooltip$Wide;
var $author$project$Pages$Admin$Billing$viewCreateInvoiceButton = A3(
	$author$project$Ui$Tooltip$view,
	_List_fromArray(
		[
			$author$project$Ui$Tooltip$placement(1),
			$author$project$Ui$Tooltip$wide
		]),
	'Create the invoice now based on current active counts. The next tranche check will be on the following invoice',
	_List_fromArray(
		[
			A3(
			$author$project$Ui$HinterOnly$button,
			{abp: 'Bill next month'},
			_List_fromArray(
				[
					$author$project$Ui$Button$styled(0),
					$author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$CreateInvoiceClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Bill next month')
				]))
		]));
var $author$project$Pages$Admin$Billing$OpenUpdateModal = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Billing$viewUpdatePricingButton = function (practicePricing) {
	var label = $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? 'Reset Pricing with a HubSpot Deal' : 'Edit Subscription';
	return A3(
		$author$project$Ui$HinterOnly$button,
		{abp: label},
		_List_fromArray(
			[
				$author$project$Ui$Button$styled(0),
				$author$project$Ui$Button$onClick(
				$author$project$Pages$Admin$Billing$OpenUpdateModal(practicePricing))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pages$Admin$Billing$UpgradePracticeClicked = {$: 14};
var $author$project$Pages$Admin$Billing$viewUpgradeButton = function (upgradeAvailable) {
	if (!upgradeAvailable.$) {
		var upgrade = upgradeAvailable.a;
		var label = 'Upgrade to ' + $author$project$Api$Provider$PracticePricing$Upgrade$tierName(upgrade);
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$UpgradePracticeClicked)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Billing$viewActionButtons = F3(
	function (dataPracticePricing, isHintAdmin, upgradeAvailable) {
		if (dataPracticePricing.$ === 3) {
			var practicePricing = dataPracticePricing.a;
			return isHintAdmin ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						$author$project$Pages$Admin$Billing$viewUpdatePricingButton(practicePricing),
						$author$project$Pages$Admin$Billing$viewCreateInvoiceButton,
						$author$project$Pages$Admin$Billing$viewUpgradeButton(upgradeAvailable)
					])) : A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						$author$project$Pages$Admin$Billing$viewUpgradeButton(upgradeAvailable)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$PracticePricing$One$products = function (_v0) {
	var record = _v0;
	return record.Bc;
};
var $author$project$Pages$Admin$Billing$extractCreditsFromPracticePricing = function (practicePricing) {
	return A2(
		$elm$core$List$filter,
		function (product) {
			return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) === 5;
		},
		$author$project$Api$Provider$PracticePricing$One$products(practicePricing));
};
var $author$project$Pages$Admin$Billing$filterCreditsBeforeNextBillDate = F2(
	function (credits, maybeNextBillDate) {
		if (!maybeNextBillDate.$) {
			var nextBillDate = maybeNextBillDate.a;
			return A2(
				$elm$core$List$filter,
				function (credit) {
					var _v1 = $author$project$Api$Provider$HintBillingComponent$Shared$endDate(credit);
					if (!_v1.$) {
						var endDate = _v1.a;
						return !(!A2($justinmimbs$date$Date$compare, endDate, nextBillDate));
					} else {
						return true;
					}
				},
				credits);
		} else {
			return credits;
		}
	});
var $author$project$Api$Provider$PracticePricing$One$nextBillDate = function (_v0) {
	var record = _v0;
	return record.UC;
};
var $author$project$Pages$Admin$Billing$AddOneTimeChargeButtonClicked = {$: 10};
var $author$project$Pages$Admin$Billing$viewAdditionalChargesHeader = function (isHintAdmin) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Additional Charges & Credits')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('These will be added to the next invoice when it is created.')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(4)
						]),
					_List_fromArray(
						[
							isHintAdmin ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{abp: 'Add Charge or Credit'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$AddOneTimeChargeButtonClicked)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Charge or Credit')
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]))
		]);
};
var $author$project$Formatters$Date$MonthAndDayAndYear = {$: 3};
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.ahX - 1)) + ($justinmimbs$date$Date$monthToNumber(date.aeI) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.acq,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $author$project$Utils$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $author$project$Utils$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $author$project$Utils$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $author$project$Utils$Uom$dateDiff = F2(
	function (m1, m2) {
		var yDiff = $justinmimbs$date$Date$year(m2) - $justinmimbs$date$Date$year(m1);
		var mDiff = $justinmimbs$date$Date$monthNumber(m2) - $justinmimbs$date$Date$monthNumber(m1);
		var dDiff = $justinmimbs$date$Date$day(m2) - $justinmimbs$date$Date$day(m1);
		var _v0 = function () {
			if (dDiff < 0) {
				var daysInLastFullMonth = function (lastFullMonth) {
					return A2(
						$author$project$Utils$Date$daysInMonth,
						$justinmimbs$date$Date$year(lastFullMonth),
						$justinmimbs$date$Date$month(lastFullMonth));
				}(
					A3(
						$justinmimbs$date$Date$add,
						1,
						-1,
						A3(
							$justinmimbs$date$Date$fromCalendarDate,
							$justinmimbs$date$Date$year(m2),
							$justinmimbs$date$Date$month(
								A3($justinmimbs$date$Date$add, 1, 1, m2)),
							1)));
				return _Utils_Tuple2(
					(_Utils_cmp(
						daysInLastFullMonth,
						$justinmimbs$date$Date$day(m1)) < 0) ? ((daysInLastFullMonth + dDiff) + ($justinmimbs$date$Date$day(m1) - daysInLastFullMonth)) : (daysInLastFullMonth + dDiff),
					mDiff - 1);
			} else {
				return _Utils_Tuple2(dDiff, mDiff);
			}
		}();
		var dDiff_ = _v0.a;
		var mDiff_ = _v0.b;
		var _v1 = (mDiff_ < 0) ? _Utils_Tuple2(12 + mDiff_, yDiff - 1) : _Utils_Tuple2(mDiff_, yDiff);
		var mDiff__ = _v1.a;
		var yDiff_ = _v1.b;
		return {acs: dDiff_, aeJ: mDiff__, ahY: yDiff_};
	});
var $author$project$Pages$Admin$Billing$calculateMonthsRemaining = F2(
	function (currentDate, maybeEndDate) {
		if (!maybeEndDate.$) {
			var endDate = maybeEndDate.a;
			if (A2($justinmimbs$date$Date$compare, currentDate, endDate) === 2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var billingStartDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
				var diff = A2($author$project$Utils$Uom$dateDiff, billingStartDate, endDate);
				var totalMonths = (diff.ahY * 12) + diff.aeJ;
				return (totalMonths > 0) ? $elm$core$Maybe$Just(
					$elm$core$String$fromInt(totalMonths) + ' months left') : (((!totalMonths) && (diff.acs >= 0)) ? $elm$core$Maybe$Just('This month') : $elm$core$Maybe$Nothing);
			}
		} else {
			return $elm$core$Maybe$Just('forever');
		}
	});
var $cuducos$elm_format_number$FormatNumber$Locales$Max = function (a) {
	return {$: 1, a: a};
};
var $author$project$Formatters$Locales$partialPenniesLocale = _Utils_update(
	$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
	{
		M4: $cuducos$elm_format_number$FormatNumber$Locales$Max(10)
	});
var $author$project$Utils$Currency$formatFromFloat = function (cents) {
	var formattedWithTwoDecimals = A2(
		$cuducos$elm_format_number$FormatNumber$format,
		$cuducos$elm_format_number$FormatNumber$Locales$usLocale,
		$elm$core$Basics$abs(cents) / 100);
	var formattedWithMaxDecimals = A2(
		$cuducos$elm_format_number$FormatNumber$format,
		$author$project$Formatters$Locales$partialPenniesLocale,
		$elm$core$Basics$abs(cents) / 100);
	return (_Utils_cmp(
		$elm$core$String$length(formattedWithMaxDecimals),
		$elm$core$String$length(formattedWithTwoDecimals)) > -1) ? formattedWithMaxDecimals : formattedWithTwoDecimals;
};
var $author$project$Utils$Currency$fromFloat = function (cents) {
	var formatted = $author$project$Utils$Currency$formatFromFloat(cents);
	return (cents >= 0) ? ('$' + formatted) : ('-$' + formatted);
};
var $author$project$Pages$Admin$Billing$viewCreditTableRow = F4(
	function (currentDate, maybeNextBillDate, _v0, credit) {
		var creditType = function () {
			var startDateToUse = (A2(
				$justinmimbs$date$Date$compare,
				$author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit),
				currentDate) === 2) ? $author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit) : currentDate;
			var startDate = $author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit);
			var shouldShowStartsOn = function () {
				if (!maybeNextBillDate.$) {
					var nextBillDate = maybeNextBillDate.a;
					return A2($justinmimbs$date$Date$compare, startDate, nextBillDate) === 2;
				} else {
					return false;
				}
			}();
			var baseCreditType = function () {
				var _v2 = A2(
					$author$project$Pages$Admin$Billing$calculateMonthsRemaining,
					startDateToUse,
					$author$project$Api$Provider$HintBillingComponent$Shared$endDate(credit));
				if (!_v2.$) {
					var monthsText = _v2.a;
					return 'Recurring (' + (monthsText + ')');
				} else {
					return 'One-Time';
				}
			}();
			return shouldShowStartsOn ? (baseCreditType + (' - starts on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDayAndYear, startDate))) : baseCreditType;
		}();
		var creditQuantity = function () {
			var _v1 = $author$project$Api$Provider$HintBillingComponent$Shared$quantity(credit);
			if (!_v1.$) {
				var qty = _v1.a;
				return $elm$core$String$fromInt(qty);
			} else {
				return '1';
			}
		}();
		var creditPrice = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(credit);
		var creditName = $author$project$Api$Provider$HintBillingComponent$Shared$description(credit);
		var creditAmount = creditPrice * A2(
			$elm$core$Maybe$withDefault,
			1,
			$author$project$Api$Provider$HintBillingComponent$Shared$quantity(credit));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[
									$elm$html$Html$text(creditName)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(creditType)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(creditQuantity)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromFloat(creditPrice))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromFloat(creditAmount))
						])),
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Pages$Admin$Billing$DeleteOneTimeChargeClicked = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$PracticeCharge$Shared$priceInCents = function (_v0) {
	var record = _v0;
	return record.Ba;
};
var $author$project$Api$Provider$PracticeCharge$All$priceInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$PracticeCharge$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Bd;
};
var $author$project$Api$Provider$PracticeCharge$All$quantity = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$quantity(shared);
};
var $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents = function (_v0) {
	var record = _v0;
	return record._7;
};
var $author$project$Api$Provider$PracticeCharge$All$subtotalInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(shared);
};
var $author$project$Pages$Admin$Billing$viewTableRow = F2(
	function (isHintAdmin, practiceCharge) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$PracticeCharge$All$description(practiceCharge))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('One-Time')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$PracticeCharge$All$quantity(practiceCharge)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromFloat(
								$author$project$Api$Provider$PracticeCharge$All$priceInCents(practiceCharge)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$PracticeCharge$All$subtotalInCents(practiceCharge)))
						])),
					isHintAdmin ? A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$HinterOnly$button,
							{abp: 'Delete one time charge'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$size(0),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Admin$Billing$DeleteOneTimeChargeClicked(practiceCharge)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						])) : A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Ui$Table$ZeroState = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Table$zeroState = $author$project$Ui$Table$ZeroState;
var $author$project$Pages$Admin$Billing$viewAdditionalChargesTable = F5(
	function (uninvoicedCharges, credits, isHintAdmin, currentDate, maybeNextBillDate) {
		var creditRows = A2(
			$elm$core$List$map,
			A3($author$project$Pages$Admin$Billing$viewCreditTableRow, currentDate, maybeNextBillDate, isHintAdmin),
			credits);
		var chargeRows = A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Billing$viewTableRow(isHintAdmin),
			uninvoicedCharges);
		var allRows = _Utils_ap(chargeRows, creditRows);
		return _List_fromArray(
			[
				A4(
				$author$project$Ui$Table$view,
				_List_fromArray(
					[
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('You have no additional charges yet!')
									]))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Charge Name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Type')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Qty')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Price')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Amount')
							])),
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					]),
				allRows,
				_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt8]),
				_List_Nil)
			]);
	});
var $author$project$Pages$Admin$Billing$viewAdditionalChargesSection = F4(
	function (uninvoicedCharges, isHintAdmin, practicePricingData, currentDate) {
		var headerView = $author$project$Pages$Admin$Billing$viewAdditionalChargesHeader(isHintAdmin);
		var _v0 = function () {
			if (practicePricingData.$ === 3) {
				var practicePricing = practicePricingData.a;
				return _Utils_Tuple2(
					$author$project$Pages$Admin$Billing$extractCreditsFromPracticePricing(practicePricing),
					$author$project$Api$Provider$PracticePricing$One$nextBillDate(practicePricing));
			} else {
				return _Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing);
			}
		}();
		var credits = _v0.a;
		var nextBillDate = _v0.b;
		var filteredCredits = A2($author$project$Pages$Admin$Billing$filterCreditsBeforeNextBillDate, credits, nextBillDate);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				_Utils_ap(
					headerView,
					A5($author$project$Pages$Admin$Billing$viewAdditionalChargesTable, uninvoicedCharges, filteredCredits, isHintAdmin, currentDate, nextBillDate))));
	});
var $author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents = function (_v0) {
	var record = _v0;
	return record.Wt;
};
var $author$project$Ui$Typography$Display3 = {$: 25};
var $author$project$Ui$Typography$display3 = $author$project$Ui$Typography$Display3;
var $author$project$Ui$Typography$Info = 3;
var $author$project$Ui$Typography$info = $author$project$Ui$Typography$Color(3);
var $author$project$Components$HintBilling$NextBill$skeleton = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceY4, $author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$block,
							$author$project$Ui$Skeleton$span(2)
						])),
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$block,
							$author$project$Ui$Skeleton$span(3)
						]))
				])),
			A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[$author$project$Ui$Typography$info]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$display3]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('$1000')
								]))
						]))
				])),
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanMd(2),
					$author$project$Ui$Skeleton$block
				])),
			$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanMd(2),
					$author$project$Ui$Skeleton$block
				]))
		]));
var $author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents = function (_v0) {
	var record = _v0;
	return record.T5;
};
var $author$project$Components$HintBilling$LegacyPricing$startedAddOns = F2(
	function (currentDate, charges) {
		return A2(
			$elm$core$List$filter,
			function (charge) {
				return !(!A2(
					$justinmimbs$date$Date$compare,
					currentDate,
					$author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge)));
			},
			A2(
				$elm$core$List$filter,
				function (addon) {
					return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(addon) === 1;
				},
				charges));
	});
var $author$project$Ui$Icon$Ok = 23;
var $author$project$Api$Provider$HintBillingComponent$Shared$totalAmountInCents = function (_v0) {
	var record = _v0;
	return record.Ba * A2($elm$core$Maybe$withDefault, 0, record.Bd);
};
var $author$project$Components$HintBilling$LegacyPricing$viewAddOn = function (product) {
	var amount = $author$project$Utils$Currency$fromFloat(
		$author$project$Api$Provider$HintBillingComponent$Shared$totalAmountInCents(product));
	var description = amount + (' for ' + $author$project$Api$Provider$HintBillingComponent$Shared$description(product));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-gray')
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$Icon$view, _List_Nil, 23),
				$elm$html$Html$text(' ' + description)
			]));
};
var $author$project$Api$Provider$ApplicationFeePlan$One$collectionFeePercentage = function (_v0) {
	var record = _v0;
	return record.Li;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$pricedBy = function (_v0) {
	var record = _v0;
	return record.Bb;
};
var $author$project$Api$Provider$PricingTier$Shared$fixedAmountInCents = function (_v0) {
	var record = _v0;
	return record.adr;
};
var $author$project$Api$Provider$PricingTier$Shared$lowerBound = function (_v0) {
	var record = _v0;
	return record.Tb;
};
var $author$project$Api$Provider$PricingTier$Shared$upperBound = function (_v0) {
	var record = _v0;
	return record.aau;
};
var $author$project$Api$Provider$PricingTier$Shared$rangeDescription = function (tier) {
	var range = function () {
		var _v1 = $author$project$Api$Provider$PricingTier$Shared$upperBound(tier);
		if (_v1.$ === 1) {
			return $author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) - 1;
		} else {
			var actualUpperbound = _v1.a;
			return actualUpperbound - ($author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) - 1);
		}
	}();
	var prettyfiedRange = ((range < 1000) || (!(!A2($elm$core$Basics$modBy, 100, range)))) ? A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, range) : $elm$core$String$concat(
		_List_fromArray(
			[
				$elm$core$String$fromFloat(range / 1000.0),
				'k'
			]));
	var prefix = function () {
		if ($author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) === 1) {
			return 'First ';
		} else {
			var _v0 = $author$project$Api$Provider$PricingTier$Shared$upperBound(tier);
			if (!_v0.$) {
				return 'Next ';
			} else {
				return 'After ';
			}
		}
	}();
	return $elm$core$String$concat(
		_List_fromArray(
			[prefix, prettyfiedRange, ' members']));
};
var $author$project$Components$HintBilling$LegacyPricing$viewPricingTierInformation = function (pricingTier) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('cascading-pricing-tier')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$PricingTier$Shared$rangeDescription(pricingTier))
							])),
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile-item-big-number')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(
									$author$project$Api$Provider$PricingTier$Shared$fixedAmountInCents(pricingTier)))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' pmpm')
							]))
					]))
			]));
};
var $author$project$Components$HintBilling$LegacyPricing$viewPricingTiersInformation = function (tiers) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex')
					]),
				A2($elm$core$List$map, $author$project$Components$HintBilling$LegacyPricing$viewPricingTierInformation, tiers)),
				$author$project$Ui$HorizontalRule$view(_List_Nil)
			]));
};
var $author$project$Components$HintBilling$LegacyPricing$viewPricingInformation = F2(
	function (feePlan, pmpmFee) {
		var _v0 = $author$project$Api$Provider$ApplicationFeePlan$One$pricedBy(feePlan);
		switch (_v0.$) {
			case 0:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile-item-big-number')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromFloat(
									$author$project$Api$Provider$ApplicationFeePlan$One$collectionFeePercentage(feePlan)))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('% of collections')
							]))
					]);
			case 1:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile-item-big-number')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromFloat(pmpmFee))
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' pmpm')
							]))
					]);
			default:
				var tiers = _v0.a;
				return _List_fromArray(
					[
						$author$project$Components$HintBilling$LegacyPricing$viewPricingTiersInformation(tiers)
					]);
		}
	});
var $author$project$Components$HintBilling$LegacyPricing$viewLegacyPricingInformation = F4(
	function (feePlan, pmpmFee, currentDate, charges) {
		var addOns = A2($author$project$Components$HintBilling$LegacyPricing$startedAddOns, currentDate, charges);
		var hasAddons = !$elm$core$List$isEmpty(addOns);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						A2($author$project$Components$HintBilling$LegacyPricing$viewPricingInformation, feePlan, pmpmFee))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									($author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents(feePlan) > 0) ? _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Plan Minimum: ')
											])),
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents(feePlan)))
											]))
									]) : _List_Nil,
									hasAddons ? _List_fromArray(
									[
										$author$project$Utils$Html$noBreakSpace,
										A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Add-Ons: ')
											]))
									]) : _List_Nil,
									A2(
									$elm$core$List$map,
									$author$project$Components$HintBilling$LegacyPricing$viewAddOn,
									A2($author$project$Components$HintBilling$LegacyPricing$startedAddOns, currentDate, addOns))
								])))
					]))
			]);
	});
var $author$project$Ui$Popover$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Popover$heading = $author$project$Ui$Popover$Heading;
var $author$project$Api$Provider$ApplicationFeePlan$One$achTransactionFeeCapInCents = function (_v0) {
	var record = _v0;
	return record.H9;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$amexSurcharge = function (_v0) {
	var record = _v0;
	return record.$T - record.HB;
};
var $author$project$Ui$HorizontalRule$Style = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$HorizontalRule$Thin = 1;
var $author$project$Ui$HorizontalRule$thin = $author$project$Ui$HorizontalRule$Style(1);
var $author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeeInCents = function (_v0) {
	var record = _v0;
	return record.$R;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeePercentage = function (_v0) {
	var record = _v0;
	return record.$S;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeeInCents = function (_v0) {
	var record = _v0;
	return record.$U;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeePercentage = function (_v0) {
	var record = _v0;
	return record.HB;
};
var $author$project$Components$HintBilling$LegacyPricing$viewFeeBreakdown = function (feePlan) {
	var totalCardFeePercentage = $elm$core$String$fromFloat(
		$author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeePercentage(feePlan)) + '%';
	var totalCardFeeInCents = $elm$core$String$fromInt(
		$author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeeInCents(feePlan)) + 'c';
	var totalAchFeePercentage = $elm$core$String$fromFloat(
		$author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeePercentage(feePlan)) + '%';
	var totalAchFeeInCents = $elm$core$String$fromInt(
		$author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeeInCents(feePlan)) + 'c';
	var creditCardTransactionDisplay = 'Credit Card: ' + (totalCardFeePercentage + (' + ' + totalCardFeeInCents));
	var amexSurchargeDisplay = '+ ' + ($elm$core$String$fromFloat(
		$author$project$Api$Provider$ApplicationFeePlan$One$amexSurcharge(feePlan)) + '% surcharge for Amex');
	var achCapDisplay = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (achCap) {
				return ' (' + ($author$project$Utils$Currency$fromInt(achCap) + ' Cap)');
			},
			$author$project$Api$Provider$ApplicationFeePlan$One$achTransactionFeeCapInCents(feePlan)));
	var achTransactionDisplay = 'ACH: ' + (totalAchFeePercentage + (' + ' + (totalAchFeeInCents + achCapDisplay)));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hint pricing does not include processing fees for accepting card or ACH payments.')
						])),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(creditCardTransactionDisplay)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$italic]),
							_List_fromArray(
								[
									$elm$html$Html$text(amexSurchargeDisplay)
								]))
						])),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(achTransactionDisplay)
								]))
						]))
				]))
		]);
};
var $author$project$Components$HintBilling$LegacyPricing$viewPopover = function (feePlan) {
	return A3(
		$author$project$Ui$Popover$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Utils$Html$noBreakSpace,
				A2($author$project$Ui$Icon$view, _List_Nil, 5)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Popover$heading,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Transaction Fees')
					])),
				A2(
				$author$project$Ui$Popover$body,
				_List_Nil,
				$author$project$Components$HintBilling$LegacyPricing$viewFeeBreakdown(feePlan))
			]));
};
var $author$project$Components$HintBilling$LegacyPricing$view = F4(
	function (currentDate, feePlan, pmpmFee, charges) {
		var popoverView = $author$project$Components$HintBilling$LegacyPricing$viewPopover(feePlan);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Hint Pricing'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('small')
												]),
											_List_fromArray(
												[popoverView]))
										]))
								]))
						])),
				A4($author$project$Components$HintBilling$LegacyPricing$viewLegacyPricingInformation, feePlan, pmpmFee, currentDate, charges)));
	});
var $author$project$Pages$Admin$Billing$viewBillingSection = F3(
	function (applicationFeePlan, practicePricingData, currentDate) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			function () {
				var _v0 = _Utils_Tuple2(applicationFeePlan, practicePricingData);
				if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
					var _v1 = _v0.a;
					var feePlan = _v1.a;
					var _v2 = _v0.b;
					var practicePricing = _v2.a;
					return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(10)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Components$HintBilling$LegacyPricing$view,
									currentDate,
									feePlan,
									$author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(practicePricing),
									$author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing))
								]))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$empty]))
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[$author$project$Components$HintBilling$NextBill$skeleton]))
						]);
				}
			}());
	});
var $author$project$Pages$Admin$Billing$viewCapitalPromoTile = F3(
	function (practice, capitalSession, capitalProductType) {
		if (capitalSession.$ === 3) {
			return ($author$project$Pages$Admin$Billing$shouldShowCapitalTile(practice) && (!_Utils_eq(
				capitalProductType,
				$elm$core$Maybe$Just('none')))) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('stripe-capital-promo-tile'),
						$elm$html$Html$Attributes$class('mb-4 rounded-lg shadow-card surface-base border-l-4 border-primary p-4')
					]),
				_List_Nil) : $elm$html$Html$text('');
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Ui$SvgIcon$Alert = 5;
var $author$project$Ui$Margin$NoMargin = 25;
var $author$project$Ui$Alert$Icon = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Alert$icon = $author$project$Ui$Alert$Icon;
var $author$project$Api$Provider$PracticePricing$One$infoMessageBody = function (_v0) {
	var record = _v0;
	return record.QX;
};
var $author$project$Api$Provider$PracticePricing$One$infoMessageTitle = function (_v0) {
	var record = _v0;
	return record.QY;
};
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Ui$Typography$title = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				$elm$html$Html$h5,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('text-title-md text-main'),
					$author$project$Ui$Typography$optionsToAttributes(options)),
				content));
	});
var $author$project$Pages$Admin$Billing$viewInfoMessage = function (practicePricingData) {
	if (practicePricingData.$ === 3) {
		var practicePricing = practicePricingData.a;
		var maybeTitle = $author$project$Api$Provider$PracticePricing$One$infoMessageTitle(practicePricing);
		if (!maybeTitle.$) {
			var infoMessageTitle = maybeTitle.a;
			var infoMessageBody = A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$PracticePricing$One$infoMessageBody(practicePricing));
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$info,
						_List_fromArray(
							[
								$author$project$Ui$Alert$margin(25),
								$author$project$Ui$Alert$icon(5),
								$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(infoMessageTitle)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(infoMessageBody)
									]))
							])),
						A2($elm$html$Html$br, _List_Nil, _List_Nil)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Source$BankAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$BankAccount$ProviderAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$BankAccount$One$defaults = function (_v0) {
	var record = _v0.b;
	return record.Nn;
};
var $author$project$Api$Provider$BankAccount$All$defaults = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$defaults(one);
};
var $author$project$Api$Provider$Source$Defaults$hintCustomer = function (_v0) {
	var record = _v0;
	return record.Qu;
};
var $author$project$Api$Source$defaultPracticeBankAccount = function (bankAccounts) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Source$BankAccount,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$BankAccount$ProviderAll,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (bankAccount) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Source$Defaults$hintCustomer,
							$author$project$Api$Provider$BankAccount$All$defaults(bankAccount)));
				},
				bankAccounts)));
};
var $author$project$Api$Source$Card = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Card$ProviderAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Card$One$defaults = function (_v0) {
	var record = _v0.b;
	return record.Nn;
};
var $author$project$Api$Provider$Card$All$defaults = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$defaults(one);
};
var $author$project$Api$Source$defaultPracticeCard = function (cards) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Source$Card,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Card$ProviderAll,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (card) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Source$Defaults$hintCustomer,
							$author$project$Api$Provider$Card$All$defaults(card)));
				},
				cards)));
};
var $author$project$Api$Source$defaultPracticeSource = F2(
	function (cards, bankAccounts) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Api$Source$defaultPracticeCard(cards),
						$author$project$Api$Source$defaultPracticeBankAccount(bankAccounts)
					])));
	});
var $author$project$Components$PaymentSourceDisplayer$LimitedView = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$limitedView = $author$project$Components$PaymentSourceDisplayer$LimitedView;
var $author$project$Components$PaymentSourceDisplayer$NoPaymentMethodStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus = $author$project$Components$PaymentSourceDisplayer$NoPaymentMethodStatus;
var $author$project$Components$PaymentSourceDisplayer$Source = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$source = $author$project$Components$PaymentSourceDisplayer$Source;
var $author$project$Api$Provider$BankAccount$Shared$assignedMemberships = function (_v0) {
	var record = _v0;
	return record.Jq;
};
var $author$project$Api$Provider$BankAccount$One$assignedMemberships = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$assignedMemberships(shared);
};
var $author$project$Api$Provider$BankAccount$All$assignedMemberships = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$assignedMemberships(one);
};
var $author$project$Api$BankAccount$assignedMemberships = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$assignedMemberships(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$assignedMemberships(bankAccount_);
		case 2:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Api$Provider$Card$Shared$assignedMemberships = function (_v0) {
	var record = _v0;
	return record.Jq;
};
var $author$project$Api$Provider$Card$One$assignedMemberships = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$assignedMemberships(shared);
};
var $author$project$Api$Provider$Card$All$assignedMemberships = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$assignedMemberships(one);
};
var $author$project$Api$Card$assignedMemberships = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$assignedMemberships(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$assignedMemberships(card_);
		case 2:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Api$Source$assignedMemberships = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$assignedMemberships(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$assignedMemberships(bankAccount);
		default:
			return _List_Nil;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Employer$BankAccount$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Employer$BankAccount$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$createdAt(shared);
};
var $author$project$Api$Employer$BankAccount$All$createdAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$createdAt(one);
};
var $author$project$Api$Provider$BankAccount$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$BankAccount$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$createdAt(shared);
};
var $author$project$Api$Provider$BankAccount$All$createdAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$createdAt(one);
};
var $author$project$Api$BankAccount$createdAt = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$createdAt(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$createdAt(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$createdAt(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$createdAt(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Employer$Card$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$createdAt(shared);
};
var $author$project$Api$Employer$Card$All$createdAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$createdAt(one);
};
var $author$project$Api$Provider$Card$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Card$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Card$All$createdAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$createdAt(one);
};
var $author$project$Api$Card$createdAt = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$createdAt(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$createdAt(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$createdAt(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$createdAt(card_);
	}
};
var $author$project$Api$Common$Source$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Source$createdAt = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$Card$createdAt(card));
		case 1:
			var bankAccount = source.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$BankAccount$createdAt(bankAccount));
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$createdAt(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdByName = function (_v0) {
	var record = _v0;
	return record.Mh;
};
var $author$project$Api$Provider$BankAccount$Shared$createdByName = function (_v0) {
	var record = _v0;
	return record.Mh;
};
var $author$project$Api$Provider$BankAccount$One$createdByName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$createdByName(shared);
};
var $author$project$Api$Provider$BankAccount$All$createdByName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$createdByName(one);
};
var $author$project$Api$BankAccount$createdByName = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$createdByName(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$createdByName(bankAccount_);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Card$Shared$createdByName = function (_v0) {
	var record = _v0;
	return record.Mh;
};
var $author$project$Api$Provider$Card$One$createdByName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$createdByName(shared);
};
var $author$project$Api$Provider$Card$All$createdByName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$createdByName(one);
};
var $author$project$Api$Card$createdByName = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$createdByName(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$createdByName(card_);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Source$createdByName = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$createdByName(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$createdByName(bankAccount);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdVia = function (_v0) {
	var record = _v0;
	return record.Mi;
};
var $author$project$Api$Provider$BankAccount$Shared$createdVia = function (_v0) {
	var record = _v0;
	return record.Mi;
};
var $author$project$Api$Provider$BankAccount$One$createdVia = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$createdVia(shared);
};
var $author$project$Api$Provider$BankAccount$All$createdVia = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$createdVia(one);
};
var $author$project$Api$BankAccount$createdVia = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$createdVia(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$createdVia(bankAccount_);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Card$Shared$createdVia = function (_v0) {
	var record = _v0;
	return record.Mi;
};
var $author$project$Api$Provider$Card$One$createdVia = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$createdVia(shared);
};
var $author$project$Api$Provider$Card$All$createdVia = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$createdVia(one);
};
var $author$project$Api$Card$createdVia = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$createdVia(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$createdVia(card_);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Source$createdVia = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$createdVia(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$createdVia(bankAccount);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Employer$BankAccount$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Employer$BankAccount$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$errorMessage(shared);
};
var $author$project$Api$Employer$BankAccount$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$errorMessage(one);
};
var $author$project$Api$Provider$BankAccount$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$BankAccount$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$BankAccount$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$errorMessage(one);
};
var $author$project$Api$BankAccount$errorMessage = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$errorMessage(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$errorMessage(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$errorMessage(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$errorMessage(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Employer$Card$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$errorMessage(shared);
};
var $author$project$Api$Employer$Card$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$errorMessage(one);
};
var $author$project$Api$Provider$Card$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$Card$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$Card$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$errorMessage(one);
};
var $author$project$Api$Card$errorMessage = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$errorMessage(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$errorMessage(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$errorMessage(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$errorMessage(card_);
	}
};
var $author$project$Api$Source$errorMessage = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$errorMessage(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$errorMessage(bankAccount);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$expMonth = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Employer$Card$Shared$expMonth = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Employer$Card$One$expMonth = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$expMonth(shared);
};
var $author$project$Api$Employer$Card$All$expMonth = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$expMonth(one);
};
var $author$project$Api$Provider$Card$Shared$expMonth = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Provider$Card$One$expMonth = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$expMonth(shared);
};
var $author$project$Api$Provider$Card$All$expMonth = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$expMonth(one);
};
var $author$project$Api$Card$expMonth = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$expMonth(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$expMonth(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$expMonth(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$expMonth(card_);
	}
};
var $author$project$Api$Source$expMonth = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$expMonth(card);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$expYear = function (_v0) {
	var record = _v0;
	return record.ada;
};
var $author$project$Api$Employer$Card$Shared$expYear = function (_v0) {
	var record = _v0;
	return record.ada;
};
var $author$project$Api$Employer$Card$One$expYear = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$expYear(shared);
};
var $author$project$Api$Employer$Card$All$expYear = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$expYear(one);
};
var $author$project$Api$Provider$Card$Shared$expYear = function (_v0) {
	var record = _v0;
	return record.ada;
};
var $author$project$Api$Provider$Card$One$expYear = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$expYear(shared);
};
var $author$project$Api$Provider$Card$All$expYear = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$expYear(one);
};
var $author$project$Api$Card$expYear = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$expYear(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$expYear(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$expYear(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$expYear(card_);
	}
};
var $author$project$Api$Source$expYear = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$expYear(card);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$funding = function (_v0) {
	var record = _v0;
	return record.PK;
};
var $author$project$Api$Provider$Card$Shared$funding = function (_v0) {
	var record = _v0;
	return record.PK;
};
var $author$project$Api$Provider$Card$One$funding = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$funding(shared);
};
var $author$project$Api$Provider$Card$All$funding = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$funding(one);
};
var $author$project$Api$Card$funding = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$funding(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$funding(card_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Source$Shared$funding = function (_v0) {
	var record = _v0;
	return record.PK;
};
var $author$project$Api$Source$funding = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$funding(card);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$funding(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Employer$BankAccount$Shared$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Employer$BankAccount$One$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$label(shared);
};
var $author$project$Api$Employer$BankAccount$All$label = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$label(one);
};
var $author$project$Api$Provider$BankAccount$Shared$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Provider$BankAccount$One$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$label(shared);
};
var $author$project$Api$Provider$BankAccount$All$label = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$label(one);
};
var $author$project$Api$BankAccount$label = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$label(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$label(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$label(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$label(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Employer$Card$One$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$label(shared);
};
var $author$project$Api$Employer$Card$All$label = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$label(one);
};
var $author$project$Api$Provider$Card$Shared$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Provider$Card$One$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$label(shared);
};
var $author$project$Api$Provider$Card$All$label = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$label(one);
};
var $author$project$Api$Card$label = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$label(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$label(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$label(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$label(card_);
	}
};
var $author$project$Api$Common$Source$Shared$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Source$label = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$label(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$label(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$label(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Employer$BankAccount$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Employer$BankAccount$One$lastFour = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$lastFour(shared);
};
var $author$project$Api$Employer$BankAccount$All$lastFour = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$lastFour(one);
};
var $author$project$Api$Provider$BankAccount$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Provider$BankAccount$One$lastFour = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$lastFour(shared);
};
var $author$project$Api$Provider$BankAccount$All$lastFour = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$lastFour(one);
};
var $author$project$Api$BankAccount$lastFour = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$lastFour(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$lastFour(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$lastFour(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$lastFour(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Employer$Card$One$lastFour = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$lastFour(shared);
};
var $author$project$Api$Employer$Card$All$lastFour = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$lastFour(one);
};
var $author$project$Api$Provider$Card$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Provider$Card$One$lastFour = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$lastFour(shared);
};
var $author$project$Api$Provider$Card$All$lastFour = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$lastFour(one);
};
var $author$project$Api$Card$lastFour = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$lastFour(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$lastFour(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$lastFour(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$lastFour(card_);
	}
};
var $author$project$Api$Common$Source$Shared$lastFour = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Source$lastFour = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$lastFour(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$lastFour(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$lastFour(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.SB;
};
var $author$project$Api$Employer$BankAccount$Shared$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.SB;
};
var $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$lastPaymentErrorMessage(shared);
};
var $author$project$Api$Employer$BankAccount$All$lastPaymentErrorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage(one);
};
var $author$project$Api$Provider$BankAccount$Shared$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.SB;
};
var $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$lastPaymentErrorMessage(shared);
};
var $author$project$Api$Provider$BankAccount$All$lastPaymentErrorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage(one);
};
var $author$project$Api$BankAccount$lastPaymentErrorMessage = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$lastPaymentErrorMessage(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$lastPaymentErrorMessage(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.SB;
};
var $author$project$Api$Employer$Card$One$lastPaymentErrorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$lastPaymentErrorMessage(shared);
};
var $author$project$Api$Employer$Card$All$lastPaymentErrorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$lastPaymentErrorMessage(one);
};
var $author$project$Api$Provider$Card$Shared$lastPaymentErrorMessage = function (_v0) {
	var record = _v0;
	return record.SB;
};
var $author$project$Api$Provider$Card$One$lastPaymentErrorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$lastPaymentErrorMessage(shared);
};
var $author$project$Api$Provider$Card$All$lastPaymentErrorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$lastPaymentErrorMessage(one);
};
var $author$project$Api$Card$lastPaymentErrorMessage = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$lastPaymentErrorMessage(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$lastPaymentErrorMessage(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$lastPaymentErrorMessage(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$lastPaymentErrorMessage(card_);
	}
};
var $author$project$Api$Source$lastPaymentErrorMessage = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$lastPaymentErrorMessage(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$lastPaymentErrorMessage(bankAccount);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$BankAccount$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$BankAccount$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$name(shared);
};
var $author$project$Api$Employer$BankAccount$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$name(one);
};
var $author$project$Api$Provider$BankAccount$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$BankAccount$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$name(shared);
};
var $author$project$Api$Provider$BankAccount$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$name(one);
};
var $author$project$Api$BankAccount$name = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$name(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$name(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$name(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$name(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$Card$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$name(shared);
};
var $author$project$Api$Employer$Card$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$name(one);
};
var $author$project$Api$Provider$Card$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Card$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$name(shared);
};
var $author$project$Api$Provider$Card$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$name(one);
};
var $author$project$Api$Card$name = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$name(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$name(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$name(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$name(card_);
	}
};
var $author$project$Api$Common$Source$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Source$name = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$name(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$name(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$name(source_);
	}
};
var $author$project$Components$PaymentSourceDisplayer$defaultOptions = {abR: $elm$core$Maybe$Nothing, yx: false, zz: false, VN: $elm$core$Maybe$Nothing, V0: $elm$core$Maybe$Nothing, Ce: false, oo: false, Hg: $elm$core$Maybe$Nothing, Cw: $elm$core$Maybe$Nothing};
var $author$project$Components$PaymentSourceDisplayer$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var source_ = option.a;
						return _Utils_update(
							record,
							{Hg: source_});
					case 1:
						var cardReader_ = option.a;
						return _Utils_update(
							record,
							{abR: cardReader_});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{yx: bool});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{zz: bool});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{oo: bool});
					case 5:
						var processor = option.a;
						return _Utils_update(
							record,
							{
								V0: $elm$core$Maybe$Just(processor)
							});
					case 6:
						var stripePaymentMethodMigration_ = option.a;
						return _Utils_update(
							record,
							{
								Cw: $elm$core$Maybe$Just(stripePaymentMethodMigration_)
							});
					case 7:
						var bool = option.a;
						return _Utils_update(
							record,
							{Ce: bool});
					default:
						var patientId_ = option.a;
						return _Utils_update(
							record,
							{VN: patientId_});
				}
			}),
		$author$project$Components$PaymentSourceDisplayer$defaultOptions,
		options);
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Employer$BankAccount$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Employer$BankAccount$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$paymentProcessor(shared);
};
var $author$project$Api$Employer$BankAccount$All$paymentProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$paymentProcessor(one);
};
var $author$project$Api$Provider$BankAccount$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$BankAccount$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$BankAccount$All$paymentProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$paymentProcessor(one);
};
var $author$project$Api$BankAccount$paymentProcessor = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$paymentProcessor(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$paymentProcessor(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$paymentProcessor(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$paymentProcessor(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Employer$Card$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$paymentProcessor(shared);
};
var $author$project$Api$Employer$Card$All$paymentProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$paymentProcessor(one);
};
var $author$project$Api$Provider$Card$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$Card$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$Card$All$paymentProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$paymentProcessor(one);
};
var $author$project$Api$Card$paymentProcessor = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$paymentProcessor(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$paymentProcessor(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$paymentProcessor(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$paymentProcessor(card_);
	}
};
var $author$project$Api$Common$Source$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Source$paymentProcessor = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$paymentProcessor(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$paymentProcessor(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$paymentProcessor(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Employer$BankAccount$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Employer$BankAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$status(shared);
};
var $author$project$Api$Employer$BankAccount$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$status(one);
};
var $author$project$Api$Provider$BankAccount$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$BankAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$status(shared);
};
var $author$project$Api$Provider$BankAccount$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$status(one);
};
var $author$project$Api$BankAccount$status = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$status(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$status(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$status(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$status(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Employer$Card$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$status(shared);
};
var $author$project$Api$Employer$Card$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$status(one);
};
var $author$project$Api$Provider$Card$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Card$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$status(shared);
};
var $author$project$Api$Provider$Card$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$status(one);
};
var $author$project$Api$Card$status = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$status(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$status(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$status(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$status(card_);
	}
};
var $author$project$Api$Common$Source$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Source$status = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$Card$status(card));
		case 1:
			var bankAccount = source.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$BankAccount$status(bankAccount));
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$status(source_);
	}
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Employer$BankAccount$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Employer$BankAccount$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$type_(shared);
};
var $author$project$Api$Employer$BankAccount$All$type_ = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$type_(one);
};
var $author$project$Api$Provider$BankAccount$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$BankAccount$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$type_(shared);
};
var $author$project$Api$Provider$BankAccount$All$type_ = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$type_(one);
};
var $author$project$Api$BankAccount$type_ = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$type_(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$type_(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$type_(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$type_(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Employer$Card$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$type_(shared);
};
var $author$project$Api$Employer$Card$All$type_ = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$type_(one);
};
var $author$project$Api$Provider$Card$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$Card$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$type_(shared);
};
var $author$project$Api$Provider$Card$All$type_ = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$type_(one);
};
var $author$project$Api$Card$type_ = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$type_(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$type_(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$type_(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$type_(card_);
	}
};
var $author$project$Api$Common$Source$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Source$type_ = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$type_(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$type_(bankAccount);
		default:
			var source_ = source.a;
			return $author$project$Api$Common$Source$Shared$type_(source_);
	}
};
var $author$project$Api$Provider$CardReader$Shared$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$CardReader$Shared$label = function (cardReader) {
	var providerShared = cardReader;
	return $author$project$Api$Provider$CardReader$Shared$label(providerShared);
};
var $author$project$Api$Provider$CardReader$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$CardReader$Shared$paymentProcessor = function (cardReader) {
	var providerShared = cardReader;
	return $author$project$Api$Provider$CardReader$Shared$paymentProcessor(providerShared);
};
var $author$project$Ui$Badge$Spaced = {$: 5};
var $author$project$Ui$Badge$spacedRight = $author$project$Ui$Badge$Spaced;
var $author$project$Utils$PaymentProcessor$toLabelText = F2(
	function (isHintAdmin, processor) {
		var _v0 = _Utils_Tuple2(isHintAdmin, processor);
		switch (_v0.b) {
			case 'stripe':
				return 'Stripe';
			case 'rainforest':
				if (_v0.a) {
					return 'rainforest';
				} else {
					return 'Built-in Processor';
				}
			default:
				return processor;
		}
	});
var $author$project$Utils$PaymentProcessor$toBadge = F4(
	function (showProcessor, isHintAdmin, element, getPaymentProcessor) {
		var badge = F2(
			function (style, label) {
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Badge$fromString,
						_List_fromArray(
							[$author$project$Ui$Badge$spacedRight, style]),
						label));
			});
		var _v0 = _Utils_Tuple2(
			showProcessor,
			getPaymentProcessor(element));
		_v0$2:
		while (true) {
			if (_v0.a && (!_v0.b.$)) {
				switch (_v0.b.a) {
					case 'stripe':
						return A2(
							badge,
							$author$project$Ui$Badge$primary,
							A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'stripe'));
					case 'rainforest':
						return A2(
							badge,
							$author$project$Ui$Badge$success,
							A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'rainforest'));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$PaymentSourceDisplayer$viewCardReader = F2(
	function (optionsRecord, cardReader_) {
		var label = $author$project$Api$CardReader$Shared$label(cardReader_);
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Html$empty,
					A4(
						$author$project$Utils$PaymentProcessor$toBadge,
						optionsRecord.oo,
						optionsRecord.oo,
						cardReader_,
						A2($elm$core$Basics$composeR, $author$project$Api$CardReader$Shared$paymentProcessor, $elm$core$Maybe$Just))),
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Card Reader: '),
									$elm$html$Html$text(
									$author$project$Formatters$String$titleize(label))
								]))
						]))
				]));
	});
var $author$project$Ui$OverflowWrap$BreakWord = 0;
var $author$project$Ui$OverflowWrap$breakWord = 0;
var $elm$html$Html$em = _VirtualDom_node('em');
var $author$project$Ui$Typography$OverflowWrap = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Typography$overflowWrap = $author$project$Ui$Typography$OverflowWrap;
var $author$project$Components$PaymentSourceDisplayer$actualPaymentProcessor = F2(
	function (givenPaymentProcessor_, source_) {
		var _v0 = _Utils_Tuple2(givenPaymentProcessor_, source_.V0);
		if (!_v0.a.$) {
			var processor = _v0.a.a;
			return $elm$core$Maybe$Just(processor);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var processor = _v0.b.a;
				return $elm$core$Maybe$Just(processor);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$PaymentSourceDisplayer$paymentProcessorLabel = F3(
	function (showProcessor_, givenPaymentProcessor_, source_) {
		return A4(
			$author$project$Utils$PaymentProcessor$toBadge,
			showProcessor_,
			showProcessor_,
			source_,
			$author$project$Components$PaymentSourceDisplayer$actualPaymentProcessor(givenPaymentProcessor_));
	});
var $author$project$Components$PaymentSourceDisplayer$sourceName = function (source_) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, source_.zh);
	if (!_v0.$) {
		var label = _v0.a;
		return $elm$core$Maybe$Just(label);
	} else {
		return source_.ahI;
	}
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Ui$Typography$Primary = 1;
var $author$project$Ui$Typography$primary = $author$project$Ui$Typography$Color(1);
var $author$project$Components$PaymentSourceDisplayer$viewMembershipLink = F2(
	function (patientId_, membership) {
		if (!patientId_.$) {
			var pid = patientId_.a;
			return _List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
						{yS: membership.adR, VN: pid}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(membership.Wo)
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$primary]),
					_List_fromArray(
						[
							$elm$html$Html$text(membership.Wo)
						]))
				]);
		}
	});
var $author$project$Components$PaymentSourceDisplayer$viewAssignedMemberships = F3(
	function (showAssignedMemberships_, patientId_, memberships) {
		if (!showAssignedMemberships_) {
			return $author$project$Utils$Html$empty;
		} else {
			if (!memberships.b) {
				return $author$project$Utils$Html$empty;
			} else {
				var membershipLinks = $elm$core$List$concat(
					A2(
						$elm$core$List$intersperse,
						_List_fromArray(
							[
								$elm$html$Html$text(', ')
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$PaymentSourceDisplayer$viewMembershipLink(patientId_),
							memberships)));
				return A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$text('Assigned to: '),
						membershipLinks));
			}
		}
	});
var $author$project$Ui$Typography$Warning = 4;
var $author$project$Ui$Typography$warning = $author$project$Ui$Typography$Color(4);
var $author$project$Components$PaymentSourceDisplayer$viewAdditionalInfo = F4(
	function (timeFormatter, showAssignedMemberships_, patientId_, source_) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = _Utils_Tuple2(source_.ON, source_.SB);
					if (!_v0.a.$) {
						var errorMessage = _v0.a.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$danger]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invalid: ' + errorMessage)
								]));
					} else {
						if (!_v0.b.$) {
							var _v1 = _v0.a;
							var lastPaymentErrorMessage = _v0.b.a;
							return A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$warning]),
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Failed: ' + lastPaymentErrorMessage)
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}
				}(),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Added ' + A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(5),
											source_.Mf)))
								])),
							function () {
							var _v2 = _Utils_Tuple2(source_.ac9, source_.ada);
							if ((!_v2.a.$) && (!_v2.b.$)) {
								var expMonth = _v2.a.a;
								var expYear = _v2.b.a;
								var textColor = function () {
									var _v3 = source_.ag7;
									if ((!_v3.$) && (_v3.a === 'expiring')) {
										return $author$project$Ui$Typography$danger;
									} else {
										return $author$project$Ui$Typography$muted;
									}
								}();
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small, textColor]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											', expires ' + ($elm$core$String$fromInt(expMonth) + ('/' + $elm$core$String$fromInt(expYear))))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							function () {
							var _v4 = source_.tC;
							if (!_v4.$) {
								var zip = _v4.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											$elm$html$Html$text(', ZIP code ' + zip)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					function () {
					var _v5 = source_.Mi;
					if (!_v5.$) {
						var createdVia = _v5.a;
						return A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(createdVia)
										])),
									function () {
									var _v6 = source_.Mh;
									if (!_v6.$) {
										var createdByName = _v6.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' by ' + createdByName)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A3($author$project$Components$PaymentSourceDisplayer$viewAssignedMemberships, showAssignedMemberships_, patientId_, source_.Jq)
				]));
	});
var $author$project$Components$PaymentSourceDisplayer$viewSource = F3(
	function (timeFormatter, optionsRecord, source_) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$Html$empty,
					A3($author$project$Components$PaymentSourceDisplayer$paymentProcessorLabel, optionsRecord.oo, optionsRecord.V0, source_)),
					function () {
					var _v0 = $author$project$Components$PaymentSourceDisplayer$sourceName(source_);
					if (!_v0.$) {
						var name = _v0.a;
						return A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Formatters$String$titleize(name))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v1 = source_.Sz;
					if (!_v1.$) {
						var lastFour = _v1.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('*' + lastFour)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v2 = source_.PK;
					if (!_v2.$) {
						var funding = _v2.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('(' + (funding + ')'))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					optionsRecord.zz ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Badge$fromString,
					_List_Nil,
					A2($elm$core$Maybe$withDefault, 'N/A', source_.ag7)),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v3 = source_.aej;
					if (!_v3.$) {
						var label = _v3.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$em,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted mr-2')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true),
													$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(label)
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					optionsRecord.yx ? $author$project$Utils$Html$empty : A4($author$project$Components$PaymentSourceDisplayer$viewAdditionalInfo, timeFormatter, optionsRecord.Ce, optionsRecord.VN, source_)
				]));
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$All$zip = function (_v0) {
	var record = _v0;
	return record.tC;
};
var $author$project$Api$Employer$Card$Shared$zip = function (_v0) {
	var record = _v0;
	return record.tC;
};
var $author$project$Api$Employer$Card$One$zip = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$zip(shared);
};
var $author$project$Api$Employer$Card$All$zip = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$zip(one);
};
var $author$project$Api$Provider$Card$Shared$zip = function (_v0) {
	var record = _v0;
	return record.tC;
};
var $author$project$Api$Provider$Card$One$zip = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$zip(shared);
};
var $author$project$Api$Provider$Card$All$zip = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$zip(one);
};
var $author$project$Api$Card$zip = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$zip(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$zip(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$zip(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$zip(card_);
	}
};
var $author$project$Api$Source$zip = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$zip(card);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$PaymentSourceDisplayer$view = F2(
	function (timeFormatter, options) {
		var optionsRecord = $author$project$Components$PaymentSourceDisplayer$optionsToRecord(options);
		var _v0 = _Utils_Tuple3(optionsRecord.Hg, optionsRecord.abR, optionsRecord.Cw);
		if (!_v0.a.$) {
			var source_ = _v0.a.a;
			return A3(
				$author$project$Components$PaymentSourceDisplayer$viewSource,
				timeFormatter,
				optionsRecord,
				{
					Jq: $author$project$Api$Source$assignedMemberships(source_),
					Mf: $author$project$Api$Source$createdAt(source_),
					Mh: $author$project$Api$Source$createdByName(source_),
					Mi: $author$project$Api$Source$createdVia(source_),
					ON: $author$project$Api$Source$errorMessage(source_),
					ac9: $author$project$Api$Source$expMonth(source_),
					ada: $author$project$Api$Source$expYear(source_),
					PK: $author$project$Api$Source$funding(source_),
					aej: $author$project$Api$Source$label(source_),
					Sz: $author$project$Api$Source$lastFour(source_),
					SB: $author$project$Api$Source$lastPaymentErrorMessage(source_),
					zh: $author$project$Api$Source$name(source_),
					V0: $author$project$Api$Source$paymentProcessor(source_),
					ag7: $author$project$Api$Source$status(source_),
					ahI: $author$project$Api$Source$type_(source_),
					tC: $author$project$Api$Source$zip(source_)
				});
		} else {
			if (!_v0.b.$) {
				var cardReader_ = _v0.b.a;
				return A2($author$project$Components$PaymentSourceDisplayer$viewCardReader, optionsRecord, cardReader_);
			} else {
				if (!_v0.c.$) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					var stripePaymentMethodMigration_ = _v0.c.a;
					return A3(
						$author$project$Components$PaymentSourceDisplayer$viewSource,
						timeFormatter,
						optionsRecord,
						{
							Jq: _List_Nil,
							Mf: $elm$core$Maybe$Just(
								$author$project$Api$Provider$StripePaymentMethodMigration$All$createdAt(stripePaymentMethodMigration_)),
							Mh: $author$project$Api$Provider$StripePaymentMethodMigration$All$createdByName(stripePaymentMethodMigration_),
							Mi: $author$project$Api$Provider$StripePaymentMethodMigration$All$createdVia(stripePaymentMethodMigration_),
							ON: $author$project$Api$Provider$StripePaymentMethodMigration$All$errorMessage(stripePaymentMethodMigration_),
							ac9: $author$project$Api$Provider$StripePaymentMethodMigration$All$expMonth(stripePaymentMethodMigration_),
							ada: $author$project$Api$Provider$StripePaymentMethodMigration$All$expYear(stripePaymentMethodMigration_),
							PK: $author$project$Api$Provider$StripePaymentMethodMigration$All$funding(stripePaymentMethodMigration_),
							aej: $author$project$Api$Provider$StripePaymentMethodMigration$All$label(stripePaymentMethodMigration_),
							Sz: $author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour(stripePaymentMethodMigration_),
							SB: $author$project$Api$Provider$StripePaymentMethodMigration$All$lastPaymentErrorMessage(stripePaymentMethodMigration_),
							zh: $author$project$Api$Provider$StripePaymentMethodMigration$All$name(stripePaymentMethodMigration_),
							V0: $elm$core$Maybe$Just(
								$author$project$Api$Provider$StripePaymentMethodMigration$All$paymentProcessor(stripePaymentMethodMigration_)),
							ag7: $author$project$Api$Provider$StripePaymentMethodMigration$All$status(stripePaymentMethodMigration_),
							ahI: $elm$core$Maybe$Just(
								$author$project$Api$Provider$StripePaymentMethodMigration$All$type_(stripePaymentMethodMigration_)),
							tC: $author$project$Api$Provider$StripePaymentMethodMigration$All$zip(stripePaymentMethodMigration_)
						});
				} else {
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					var _v5 = _v0.c;
					return $author$project$Utils$Html$empty;
				}
			}
		}
	});
var $author$project$Components$PracticeSourceDisplayer$view = F2(
	function (timeFormatter, source) {
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$helpBlock]),
			_List_fromArray(
				[
					$elm$html$Html$text('Payment source: '),
					A2(
					$author$project$Components$PaymentSourceDisplayer$view,
					timeFormatter,
					_List_fromArray(
						[
							$author$project$Components$PaymentSourceDisplayer$source(source),
							$author$project$Components$PaymentSourceDisplayer$limitedView(true),
							$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true)
						])),
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Admin__PaymentSources,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Edit')
						]))
				]));
	});
var $author$project$Pages$Admin$Billing$viewPracticePaymentSource = F3(
	function (timeFormatter, cards, bankAccounts) {
		return A2(
			$author$project$Components$PracticeSourceDisplayer$view,
			timeFormatter,
			A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts));
	});
var $author$project$Pages$Admin$Billing$viewInvoicesHeader = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Invoices')
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								function () {
								var _v0 = _Utils_Tuple2(model.pN, model.pD);
								if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
									var _v1 = _v0.a;
									var cards = _v1.a;
									var _v2 = _v0.b;
									var bankAccounts = _v2.a;
									return A3($author$project$Pages$Admin$Billing$viewPracticePaymentSource, model.Hy, cards, bankAccounts);
								} else {
									return $author$project$Ui$Skeleton$text(
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$spanFromText('Payment source: *Visa 4242')
											]));
								}
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Billing$AnalyticsLinkClicked = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Ui$Margin$Top_8 = 22;
var $author$project$Api$Provider$PracticePricing$One$addOns = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$List$filter,
		function (product) {
			return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) === 1;
		},
		record.Bc);
};
var $author$project$Api$Provider$PracticePricing$One$txnFees = function (_v0) {
	var record = _v0;
	return record.aaf;
};
var $author$project$Api$Provider$HintBillingComponent$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Ui$Element$spaceY2 = $author$project$Ui$Element$SpaceY(2);
var $author$project$Api$Provider$HintBillingComponent$Shared$addonType = function (_v0) {
	var record = _v0;
	return record.Ir;
};
var $author$project$Ui$SvgIcon$check = $author$project$Ui$SvgIcon$viewIcon(44);
var $author$project$Components$HintBilling$Pricing$trimSubString = F2(
	function (name, substringToReplace) {
		return A3($elm$core$String$replace, substringToReplace, '', name);
	});
var $author$project$Components$HintBilling$Pricing$viewProduct = F3(
	function (content, maybeQuantity, maybePrice) {
		var totalPrice = function () {
			var _v2 = _Utils_Tuple2(maybeQuantity, maybePrice);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var quantity = _v2.a.a;
				var price = _v2.b.a;
				var total = quantity * price;
				var formattedTotal = $author$project$Utils$Currency$fromIntNoDecimals(
					$elm$core$Basics$round(total));
				return $elm$core$Maybe$Just(formattedTotal);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(
							A2(
								$elm$core$Maybe$withDefault,
								12,
								A2(
									$elm$core$Maybe$map,
									function (_v0) {
										return 9;
									},
									totalPrice)))
						]),
					_List_fromArray(
						[content])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(3)
						]),
					_List_fromArray(
						[
							function () {
							if (!totalPrice.$) {
								var price = totalPrice.a;
								return A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(price)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$HintBilling$Pricing$viewAddon = function (addOn) {
	var _v0 = _Utils_Tuple2(
		$author$project$Api$Provider$HintBillingComponent$Shared$componentType(addOn),
		$author$project$Api$Provider$HintBillingComponent$Shared$addonType(addOn));
	if ((_v0.a === 1) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var addonType = _v0.b.a;
		var shouldShowAddon = (addonType === 1) ? A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (qty) {
					return qty > 0;
				},
				$author$project$Api$Provider$HintBillingComponent$Shared$quantity(addOn))) : true;
		if (shouldShowAddon) {
			var displayName = A2(
				$author$project$Components$HintBilling$Pricing$trimSubString,
				$author$project$Api$Provider$HintBillingComponent$Shared$name(addOn),
				'Add-on: ');
			return A3(
				$author$project$Components$HintBilling$Pricing$viewProduct,
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$check(_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(displayName)
								]))
						])),
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing);
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$HintBilling$Pricing$viewAddons = function (addOns) {
	var sortedAddOns = A2($elm$core$List$sortBy, $author$project$Api$Provider$HintBillingComponent$Shared$name, addOns);
	return A2(
		$author$project$Ui$FlexGrid$column,
		_List_fromArray(
			[
				$author$project$Ui$FlexGrid$spanMd(3)
			]),
		$elm$core$List$isEmpty(sortedAddOns) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Add-Ons')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$spaceY2]),
												A2($elm$core$List$map, $author$project$Components$HintBilling$Pricing$viewAddon, sortedAddOns))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$HintBilling$Pricing$viewFeesBreakdown = function (txnFees) {
	return A2(
		$author$project$Ui$FlexGrid$column,
		_List_fromArray(
			[
				$author$project$Ui$FlexGrid$spanMd(4)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Transaction Fees *')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$spaceY2]),
												_List_fromArray(
													[
														A2($author$project$Utils$Billing$TxnFees$viewFees, txnFees, false)
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
								_List_fromArray(
									[
										$elm$html$Html$text('* Transaction fees are taken at the time of the transaction')
									]))
							]))
					]))
			]));
};
var $author$project$Api$Provider$PracticePricing$One$revenueOveragePriceInCents = function (_v0) {
	var record = _v0;
	return record.YG;
};
var $author$project$Components$HintBilling$NextBill$viewNextBillDate = function (maybeNextBillDate) {
	var billDateText = function () {
		if (!maybeNextBillDate.$) {
			var nextBillDAte = maybeNextBillDate.a;
			return ' Next Bill: ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDAte);
		} else {
			return '';
		}
	}();
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(billDateText)
			]));
};
var $author$project$Ui$Element$flex = A2($author$project$Ui$Element$Display, 0, 2);
var $author$project$Components$HintBilling$NextBill$viewPrice = function (billableProducts) {
	var totalAmountInCents = $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (product) {
				return $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product) * A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Api$Provider$HintBillingComponent$Shared$quantity(product));
			},
			A2(
				$elm$core$List$filter,
				function (product) {
					return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) !== 5;
				},
				billableProducts)));
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromIntNoDecimals(
							$elm$core$Basics$round(totalAmountInCents)))
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text('/ mo')
					]))
			]));
};
var $author$project$Components$HintBilling$NextBill$view = F2(
	function (pricing, viewCustomContent) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Monthly Subscription')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									$author$project$Components$HintBilling$NextBill$viewPrice(
									$author$project$Api$Provider$PracticePricing$One$billableProducts(pricing))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(12)
								]),
							_List_fromArray(
								[
									$author$project$Components$HintBilling$NextBill$viewNextBillDate(
									$author$project$Api$Provider$PracticePricing$One$nextBillDate(pricing))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$margin(12)
								]),
							_List_fromArray(
								[viewCustomContent]))
						]))
				]));
	});
var $author$project$Components$HintBilling$Pricing$viewBillingSection = F3(
	function (applicationFeePlan, pricing, currentDate) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			function () {
				if (applicationFeePlan.$ === 3) {
					var feePlan = applicationFeePlan.a;
					return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(pricing) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(10)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Components$HintBilling$LegacyPricing$view,
									currentDate,
									feePlan,
									$author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(pricing),
									$author$project$Api$Provider$PracticePricing$One$billableProducts(pricing))
								]))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$HintBilling$NextBill$view, pricing, $author$project$Utils$Html$empty)
								]))
						]);
				} else {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[$author$project$Components$HintBilling$NextBill$skeleton]))
						]);
				}
			}());
	});
var $author$project$Components$HintBilling$Pricing$createNewGroup = function (addonData) {
	return {
		iS: (!addonData.Ba) ? addonData.Bd : 0,
		zh: addonData.zh,
		eo: (addonData.Ba > 0) ? addonData.Ba : 0,
		Bd: addonData.Bd,
		aaj: addonData.aaj
	};
};
var $author$project$Api$Provider$HintBillingComponent$UnitName$toString = function (unitName_) {
	switch (unitName_) {
		case 0:
			return 'member';
		case 1:
			return 'dollar';
		case 2:
			return 'integration';
		case 3:
			return 'feed';
		case 4:
			return 'clinician';
		default:
			return 'copilot';
	}
};
var $author$project$Api$Provider$HintBillingComponent$Shared$unitName = function (_v0) {
	var record = _v0;
	return record.aaj;
};
var $author$project$Components$HintBilling$Pricing$extractAddonData = function (addon) {
	var unitName = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$HintBillingComponent$UnitName$toString,
		$author$project$Api$Provider$HintBillingComponent$Shared$unitName(addon));
	var quantity = A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Api$Provider$HintBillingComponent$Shared$quantity(addon));
	var priceInCents = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(addon);
	var addonName = A2(
		$author$project$Components$HintBilling$Pricing$trimSubString,
		$author$project$Api$Provider$HintBillingComponent$Shared$name(addon),
		'Add-on:');
	return {zh: addonName, Ba: priceInCents, Bd: quantity, aaj: unitName};
};
var $author$project$Components$HintBilling$Pricing$updateExistingGroup = F2(
	function (group, addonData) {
		return _Utils_update(
			group,
			{
				iS: group.iS + ((!addonData.Ba) ? addonData.Bd : 0),
				zh: (addonData.Ba > 0) ? addonData.zh : group.zh,
				eo: ((addonData.Ba > 0) && (!group.eo)) ? addonData.Ba : group.eo,
				Bd: group.Bd + addonData.Bd
			});
	});
var $author$project$Components$HintBilling$Pricing$groupByUnitName = F2(
	function (addon, groups) {
		var addonData = $author$project$Components$HintBilling$Pricing$extractAddonData(addon);
		var _v0 = addonData.aaj;
		if (_v0.$ === 1) {
			return A2(
				$elm$core$List$cons,
				$author$project$Components$HintBilling$Pricing$createNewGroup(addonData),
				groups);
		} else {
			var _v1 = A2(
				$elm$core$List$filter,
				function (group) {
					return _Utils_eq(group.aaj, addonData.aaj);
				},
				groups);
			if (_v1.b) {
				return A2(
					$elm$core$List$map,
					function (group) {
						return _Utils_eq(group.aaj, addonData.aaj) ? A2($author$project$Components$HintBilling$Pricing$updateExistingGroup, group, addonData) : group;
					},
					groups);
			} else {
				return A2(
					$elm$core$List$cons,
					$author$project$Components$HintBilling$Pricing$createNewGroup(addonData),
					groups);
			}
		}
	});
var $author$project$Components$HintBilling$Pricing$formatPluralName = F2(
	function (name, quantity) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$bold]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(quantity))
					])),
				$elm$html$Html$text(
				A3(
					$elm$core$String$replace,
					$elm$core$String$fromInt(quantity),
					'',
					A2($author$project$Formatters$String$pluralize, name, quantity)))
			]);
	});
var $author$project$Components$HintBilling$Pricing$renderAddonGroup = function (group) {
	var pricingDetails = ((group.iS > 0) && (group.eo > 0)) ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(group.iS) + (' included in your plan, ' + ($author$project$Utils$Currency$fromIntNoDecimals(
						$elm$core$Basics$round(group.eo)) + ' each')))
				]))
		]) : _List_Nil;
	var paidQuantity = A2($elm$core$Basics$max, 0, group.Bd - group.iS);
	var content = A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_Utils_ap(
			A2($author$project$Components$HintBilling$Pricing$formatPluralName, group.zh, group.Bd),
			pricingDetails));
	return A3(
		$author$project$Components$HintBilling$Pricing$viewProduct,
		content,
		$elm$core$Maybe$Just(paidQuantity),
		$elm$core$Maybe$Just(group.eo));
};
var $author$project$Components$HintBilling$Pricing$viewPricedAddons = function (addons) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$HintBilling$Pricing$renderAddonGroup,
		A2(
			$elm$core$List$filter,
			function (group) {
				return group.eo > 0;
			},
			A3(
				$elm$core$List$foldl,
				$author$project$Components$HintBilling$Pricing$groupByUnitName,
				_List_Nil,
				A2(
					$elm$core$List$filter,
					function (addon) {
						return !_Utils_eq(
							$author$project$Api$Provider$HintBillingComponent$Shared$quantity(addon),
							$elm$core$Maybe$Nothing);
					},
					addons))));
};
var $author$project$Api$Provider$PracticePricing$One$currentMembers = function (_v0) {
	var record = _v0;
	return record.Mv;
};
var $author$project$Api$Provider$ApplicationFeePlan$One$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$HintBilling$Pricing$productTypePrefix = F2(
	function (hasClinicalAccount, baseFeeName) {
		return hasClinicalAccount ? ('Clinical ' + baseFeeName) : ('Core ' + baseFeeName);
	});
var $author$project$Formatters$Float$toPercentage = function (_float) {
	return $elm$core$String$fromFloat(_float) + '%';
};
var $author$project$Components$HintBilling$Pricing$viewProductByType = F6(
	function (pricing, applicationFeePlan, product, hasClinicalAccount, onAnalyticsClick, maybeRevenueOveragePriceInCents) {
		var quantity = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Api$Provider$HintBillingComponent$Shared$quantity(product));
		var _v0 = $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product);
		switch (_v0) {
			case 0:
				return A3(
					$author$project$Components$HintBilling$Pricing$viewProduct,
					A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Components$HintBilling$Pricing$productTypePrefix,
											hasClinicalAccount,
											$author$project$Api$Provider$HintBillingComponent$Shared$name(product)))
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
								_List_fromArray(
									[
										$elm$html$Html$text('Base Subscription Tier. '),
										A3($author$project$Components$HintBilling$FeatureListLink$view, hasClinicalAccount, onAnalyticsClick, true)
									]))
							])),
					$elm$core$Maybe$Just(quantity),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
			case 4:
				var name = $author$project$Api$Provider$HintBillingComponent$Shared$name(product);
				var formattedPriceInCents = $author$project$Utils$Currency$fromIntNoDecimals(
					$elm$core$Basics$round(
						$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
				return A3(
					$author$project$Components$HintBilling$Pricing$viewProduct,
					A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_Utils_ap(
							A2($author$project$Components$HintBilling$Pricing$formatPluralName, name, quantity),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											$elm$html$Html$text(formattedPriceInCents + '/mo per Clinician')
										]))
								]))),
					$elm$core$Maybe$Just(quantity),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
			case 2:
				var membersPriceInCents = quantity * $elm$core$Basics$round(
					$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product));
				var feePlanName = function () {
					if (applicationFeePlan.$ === 3) {
						var feePlan = applicationFeePlan.a;
						return $author$project$Api$Provider$ApplicationFeePlan$One$name(feePlan);
					} else {
						return '';
					}
				}();
				var currentUsageText = ' Current Usage ' + ($elm$core$String$fromInt(
					$author$project$Api$Provider$PracticePricing$One$currentMembers(pricing)) + ' Members');
				return A3(
					$author$project$Components$HintBilling$Pricing$viewProduct,
					A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Up to ' + ($elm$core$String$fromInt(quantity) + ' Members'))
									])),
								A4($author$project$Components$HintBilling$MemberTranches$view, feePlanName, quantity, membersPriceInCents, onAnalyticsClick),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(currentUsageText)
									]))
							])),
					$elm$core$Maybe$Just(quantity),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
			case 3:
				if ($author$project$Api$Provider$HintBillingComponent$Shared$name(product) !== 'Additional Billed Revenue') {
					var overageRevenueExplaination = function () {
						if (!maybeRevenueOveragePriceInCents.$) {
							var revenueOveragePriceInCents = maybeRevenueOveragePriceInCents.a;
							return ' (' + ($author$project$Formatters$Float$toPercentage(revenueOveragePriceInCents) + ' on additional revenue)');
						} else {
							return '';
						}
					}();
					var revenueExplainationText = '$' + ($elm$core$String$fromFloat(quantity / 1000) + ('k' + overageRevenueExplaination));
					return A3(
						$author$project$Components$HintBilling$Pricing$viewProduct,
						A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Billed Revenue')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(revenueExplainationText)
										]))
								])),
						$elm$core$Maybe$Just(quantity),
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
				} else {
					return $author$project$Utils$Html$empty;
				}
			case 1:
				return $author$project$Utils$Html$empty;
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$HintBilling$Pricing$viewProductsBreakDown = F5(
	function (pricing, applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick) {
		var revenueOveragePriceInCents = $author$project$Api$Provider$PracticePricing$One$revenueOveragePriceInCents(pricing);
		var products = A2(
			$elm$core$List$filter,
			function (product) {
				return !_Utils_eq(
					$author$project$Api$Provider$HintBillingComponent$Shared$quantity(product),
					$elm$core$Maybe$Nothing);
			},
			$author$project$Api$Provider$PracticePricing$One$billableProducts(pricing));
		var baseFeeHasCost = A2(
			$elm$core$List$any,
			function (product) {
				return (!$author$project$Api$Provider$HintBillingComponent$Shared$componentType(product)) && ($author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product) > 0);
			},
			products);
		var addOns = $author$project$Api$Provider$PracticePricing$One$addOns(pricing);
		return A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(5)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$Components$HintBilling$Pricing$viewBillingSection, applicationFeePlan, pricing, currentDate)
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Panel$body,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$spaceY2]),
													_Utils_ap(
														A2(
															$elm$core$List$map,
															function (product) {
																return A6($author$project$Components$HintBilling$Pricing$viewProductByType, pricing, applicationFeePlan, product, hasClinicalAccount, onAnalyticsClick, revenueOveragePriceInCents);
															},
															products),
														$author$project$Components$HintBilling$Pricing$viewPricedAddons(addOns)))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											(hasClinicalAccount && baseFeeHasCost) ? $elm$html$Html$text('* Because you are a Clinical customer, you get a 20% discount on clinicians and members.') : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Components$HintBilling$Pricing$view = F5(
	function (applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick, pricing) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A5($author$project$Components$HintBilling$Pricing$viewProductsBreakDown, pricing, applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick),
					$author$project$Components$HintBilling$Pricing$viewAddons(
					$author$project$Api$Provider$PracticePricing$One$addOns(pricing)),
					$author$project$Components$HintBilling$Pricing$viewFeesBreakdown(
					$author$project$Api$Provider$PracticePricing$One$txnFees(pricing))
				]));
	});
var $author$project$Pages$Admin$Billing$viewProductsSection = F4(
	function (practicePricingData, applicationFeePlanData, currentDate, hasClinicalAccount) {
		if (practicePricingData.$ === 3) {
			var practicePricing = practicePricingData.a;
			return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[
						$author$project$Ui$Typography$margin(22)
					]),
				_List_fromArray(
					[
						A5($author$project$Components$HintBilling$Pricing$view, applicationFeePlanData, currentDate, hasClinicalAccount, $author$project$Pages$Admin$Billing$AnalyticsLinkClicked, practicePricing)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Admin$Billing$viewBody = function (model) {
	var showBillingSections = $author$project$Pages$Admin$Billing$shouldShowBillingSections(model.ck);
	var billingSections = showBillingSections ? _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Billing')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3($author$project$Pages$Admin$Billing$viewActionButtons, model.ck, model.FR, model.o2)
								]))
						]))
				])),
			A3($author$project$Pages$Admin$Billing$viewBillingSection, model.me, model.ck, model.cO),
			A4($author$project$Pages$Admin$Billing$viewProductsSection, model.ck, model.me, model.cO, model.P2),
			A4($author$project$Pages$Admin$Billing$viewAdditionalChargesSection, model.oW, model.FR, model.ck, model.cO)
		]) : _List_Nil;
	return _List_fromArray(
		[
			$author$project$Pages$Admin$Billing$modals(model),
			A3($author$project$Pages$Admin$Billing$viewCapitalPromoTile, model.WF, model.pL, model.vW),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						$author$project$Pages$Admin$Billing$viewInfoMessage(model.ck),
						_Utils_ap(
							billingSections,
							_List_fromArray(
								[
									$author$project$Pages$Admin$Billing$viewInvoicesHeader(model),
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Billing$PracticeInvoicePaginationMsg,
									A2($author$project$Components$HintBilling$InvoicesTable$view, model.jz, model.ek))
								]))))
				]))
		]);
};
var $author$project$Pages$Admin$Billing$view = function (model) {
	return {
		e5: $author$project$Pages$Admin$Billing$viewBody(model),
		$G: 'Admin | Billing'
	};
};
var $author$project$Pages$Admin$Billing$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Billing$init, aer: $author$project$Pages$Admin$Billing$load, agD: $author$project$Pages$Admin$Billing$save, ahd: $author$project$Pages$Admin$Billing$subscriptions, aaq: $author$project$Pages$Admin$Billing$update, ahP: $author$project$Pages$Admin$Billing$view});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DropdownMenuMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$DownloadFile$DropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$DownloadFile$init = function (currentUrl) {
	return {
		fy: $author$project$Ui$NewDropdown$init(
			$author$project$Ui$NewDropdown$defaultConfig(
				{adR: 'download-files-dropdown', ahx: $author$project$Components$Invoice$DownloadFile$DropdownMsg})),
		R0: false,
		aav: currentUrl
	};
};
var $author$project$Components$Invoice$PaymentsHistory$PopoverMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentsList$init = F4(
	function (timeFormatter, basePath, session, allowPartialRefunds) {
		return {vl: allowPartialRefunds, vD: basePath, cF: $elm$core$Maybe$Nothing, hE: $elm$core$Maybe$Nothing, gh: $elm$core$Maybe$Nothing, eq: $elm$core$Maybe$Nothing, jK: $elm$core$Maybe$Nothing, ZD: session, kb: $elm$core$Maybe$Nothing, kc: $elm$core$Maybe$Nothing, Hy: timeFormatter};
	});
var $author$project$Ui$Popover$Model = $elm$core$Basics$identity;
var $author$project$Ui$Popover$init = F3(
	function (id, open, toMsg) {
		return {adR: id, U9: open, ahx: toMsg};
	});
var $author$project$Components$Invoice$PaymentsHistory$init = F4(
	function (timeFormatter, basePath, session, allowPartialRefunds) {
		return {
			jr: A4($author$project$Components$PaymentsList$init, timeFormatter, basePath, session, allowPartialRefunds),
			aM: A3($author$project$Ui$Popover$init, 'payment-history', false, $author$project$Components$Invoice$PaymentsHistory$PopoverMsg),
			Hy: timeFormatter
		};
	});
var $author$project$Api$Provider$PracticeInvoice$paymentsBasePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practice_invoices', id_]),
		$author$project$Api$Data$providerPath);
};
var $author$project$Api$Provider$PracticeInvoice$practiceInvoicePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath);
};
var $author$project$Api$Provider$PracticeInvoice$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				hW: $elm$core$Maybe$Nothing,
				lC: $elm$core$Maybe$Nothing,
				cO: shared.cO,
				h8: $elm$core$Maybe$Nothing,
				iq: $author$project$Components$Invoice$DownloadFile$init(shared.aav),
				lV: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'invoice-actions-dropdown-menu', ahx: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DropdownMenuMsg})),
				adR: params.adR,
				FR: $author$project$Shared$isHintAdmin(shared),
				jq: A4(
					$author$project$Components$Invoice$PaymentsHistory$init,
					shared.Hy,
					$author$project$Api$Provider$PracticeInvoice$paymentsBasePath(params.adR),
					session,
					$author$project$Shared$isHintAdmin(shared)),
				WF: practice,
				WH: $author$project$Api$Data$Loading,
				sj: shared.sj,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				Hy: shared.Hy,
				ty: $elm$core$Maybe$Nothing
			},
			A3($author$project$Api$Provider$PracticeInvoice$retrieve, shared.D5, params.adR, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$Close = {$: 0};
var $author$project$Components$Invoice$CreatePaymentModal$GotLocalStorageItem = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ports$LocalStorage$localStorageGotItemPort = _Platform_incomingPort(
	'localStorageGotItemPort',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$LocalStorage$gotItem = function (toMsg) {
	return $author$project$Ports$LocalStorage$localStorageGotItemPort(toMsg);
};
var $author$project$Components$CardReader$ConnectingModal$Cancel = {$: 0};
var $author$project$Components$CardReader$ConnectingModal$StripeReadReusableCardCancelled = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$StripeReaderConnected = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$StripeReaderDisconnected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$StripeReusableCardRead = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$StripeTerminalCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnCreated = _Platform_incomingPort('stripeTerminalPortOnCreated', $elm$json$Json$Decode$string);
var $author$project$Ports$StripeTerminal$onCreated = $author$project$Ports$StripeTerminal$stripeTerminalPortOnCreated;
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReadReusableCardCancelled = _Platform_incomingPort(
	'stripeTerminalPortOnReadReusableCardCancelled',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$StripeTerminal$onReadReusableCardCancelled = function (toMsg) {
	return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReadReusableCardCancelled(
		function (_v0) {
			var token = _v0.a;
			var error = _v0.b;
			var result = function () {
				if (!error.$) {
					var string = error.a;
					return $elm$core$Result$Err(string);
				} else {
					return $elm$core$Result$Ok(0);
				}
			}();
			return A2(toMsg, token, result);
		});
};
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReaderConnected = _Platform_incomingPort(
	'stripeTerminalPortOnReaderConnected',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(_v0, _v1));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$StripeTerminal$onReaderConnected = function (toMsg) {
	return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReaderConnected(
		function (_v0) {
			var token = _v0.a;
			var error = _v0.b;
			var result = function () {
				if (!error.$) {
					var string = error.a;
					return $elm$core$Result$Err(string);
				} else {
					return $elm$core$Result$Ok(0);
				}
			}();
			return A2(toMsg, token, result);
		});
};
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReusableCardRead = _Platform_incomingPort(
	'stripeTerminalPortOnReusableCardRead',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2(
							$elm$json$Json$Decode$index,
							2,
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
									]))));
				},
				A2(
					$elm$json$Json$Decode$index,
					1,
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$StripeTerminal$onReusableCardRead = function (toMsg) {
	return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReusableCardRead(
		function (_v0) {
			var token = _v0.a;
			var paymentMethodId = _v0.b;
			var error = _v0.c;
			var result = function () {
				if (!paymentMethodId.$) {
					var string = paymentMethodId.a;
					return $elm$core$Result$Ok(string);
				} else {
					return $elm$core$Result$Err(
						A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, error));
				}
			}();
			return A2(toMsg, token, result);
		});
};
var $author$project$Ports$StripeTerminal$stripeTerminalPortOnUnexpectedReaderDisconnect = _Platform_incomingPort('stripeTerminalPortOnUnexpectedReaderDisconnect', $elm$json$Json$Decode$string);
var $author$project$Ports$StripeTerminal$onUnexpectedReaderDisconnect = $author$project$Ports$StripeTerminal$stripeTerminalPortOnUnexpectedReaderDisconnect;
var $author$project$Components$CardReader$ConnectingModal$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$StripeTerminal$onCreated($author$project$Components$CardReader$ConnectingModal$StripeTerminalCreated),
				$author$project$Ports$StripeTerminal$onReaderConnected($author$project$Components$CardReader$ConnectingModal$StripeReaderConnected),
				$author$project$Ports$StripeTerminal$onReusableCardRead($author$project$Components$CardReader$ConnectingModal$StripeReusableCardRead),
				$author$project$Ports$StripeTerminal$onReadReusableCardCancelled($author$project$Components$CardReader$ConnectingModal$StripeReadReusableCardCancelled),
				$author$project$Ports$StripeTerminal$onUnexpectedReaderDisconnect($author$project$Components$CardReader$ConnectingModal$StripeReaderDisconnected),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CardReader$ConnectingModal$Cancel)
			]));
};
var $author$project$Components$CardReader$PaymentModal$Cancel = {$: 0};
var $author$project$Components$CardReader$PaymentModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CardReader$PaymentModal$Cancel);
};
var $author$project$Components$Invoice$CreatePaymentModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = _Utils_Tuple2(model.hF, model.bS);
				if (!_v1.a.$) {
					var _v2 = _v1.a.a;
					var cardReaderConnectingModal = _v2.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg,
						$author$project$Components$CardReader$ConnectingModal$subscriptions(cardReaderConnectingModal));
				} else {
					if (!_v1.b.$) {
						var _v3 = _v1.b.a;
						var cardReaderPaymentModal = _v3.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg,
							$author$project$Components$CardReader$PaymentModal$subscriptions(cardReaderPaymentModal));
					} else {
						var _v4 = _v1.a;
						var _v5 = _v1.b;
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$CreatePaymentModal$Close);
					}
				}
			}(),
				$author$project$Ports$LocalStorage$gotItem($author$project$Components$Invoice$CreatePaymentModal$GotLocalStorageItem)
			]));
};
var $author$project$Components$Invoice$DownloadFile$CloseModal = {$: 3};
var $author$project$Components$Invoice$DownloadFile$subscriptions = function (model) {
	return model.R0 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$DownloadFile$CloseModal) : $author$project$Ui$NewDropdown$subscriptions(model.fy);
};
var $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Popover$isOpen = function (msg) {
	var model = msg;
	return model.U9;
};
var $author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$PaymentsList$CancelRefundConfirmed = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$PaymentsList$ClosePaymentDisputeModal = {$: 3};
var $author$project$Components$PaymentsList$CloseRainforestPaymentModal = {$: 6};
var $author$project$Components$PaymentsList$RefundModalMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$PaymentsList$SimulateDisputeModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Invoice$RefundModal$Close = {$: 0};
var $author$project$Components$Invoice$RefundModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$RefundModal$Close);
};
var $author$project$Components$DisputeModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
var $author$project$Components$PaymentDisputeModal$subscriptions = F2(
	function (model, toMsg) {
		var _v0 = model.NQ;
		if (!_v0.$) {
			return $author$project$Components$DisputeModal$subscriptions(toMsg);
		} else {
			return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$Components$Rainforest$SessionModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
var $author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal = {$: 0};
var $author$project$Components$Rainforest$SimulateDisputeEventModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal);
};
var $author$project$Components$Rainforest$SimulateDisputeModal$CloseModal = {$: 0};
var $author$project$Components$Rainforest$SimulateDisputeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateDisputeModal$CloseModal);
};
var $author$project$Components$PaymentsList$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentsList$RefundModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$RefundModal$subscriptions, model.jK))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (paymentDisputeModal) {
						return A2($author$project$Components$PaymentDisputeModal$subscriptions, paymentDisputeModal, $author$project$Components$PaymentsList$ClosePaymentDisputeModal);
					},
					model.gh)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Rainforest$SessionModal$subscriptions($author$project$Components$PaymentsList$CloseRainforestPaymentModal)),
					model.eq)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentsList$SimulateDisputeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Rainforest$SimulateDisputeModal$subscriptions, model.kc))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentsList$SimulateDisputeEventModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Rainforest$SimulateDisputeEventModal$subscriptions, model.kb))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed),
						$elm$core$Tuple$first),
					model.cF)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$PaymentsList$CancelRefundConfirmed)),
					model.hE))
			]));
};
var $author$project$Ui$Popover$Close = 0;
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $author$project$Utils$Dom$outsideTarget = F2(
	function (msg, id) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('inside target');
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				$author$project$Utils$Dom$isOutsideTarget(id)));
	});
var $author$project$Utils$Dom$onOutsideMouseDown = F2(
	function (msg, id) {
		return $elm$browser$Browser$Events$onMouseDown(
			A2($author$project$Utils$Dom$outsideTarget, msg, id));
	});
var $author$project$Ui$Popover$decodePressedKey = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return (key === 'Escape') ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
};
var $author$project$Ui$Popover$subscribeToEscapeKeyPress = function (closeMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		$author$project$Ui$Popover$decodePressedKey(closeMsg));
};
var $author$project$Ui$Popover$subscriptions = function (_v0) {
	var id = _v0.adR;
	var toMsg = _v0.ahx;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$author$project$Utils$Dom$onOutsideMouseDown,
				toMsg(0),
				id),
				$author$project$Ui$Popover$subscribeToEscapeKeyPress(
				toMsg(0))
			]));
};
var $author$project$Components$Invoice$PaymentsHistory$subscriptions = function (_v0) {
	var paymentsList = _v0.jr;
	var popover = _v0.aM;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg,
				$author$project$Components$PaymentsList$subscriptions(paymentsList)),
				$author$project$Ui$Popover$isOpen(popover) ? $author$project$Ui$Popover$subscriptions(popover) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(model.lV),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.lC))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.iq)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg,
				$author$project$Components$Invoice$PaymentsHistory$subscriptions(model.jq)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.h8))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.ty)))
			]));
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Deleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issued = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Paid = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$PracticeInvoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Practice$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Voided = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Adjusted = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Refunded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$PracticeInvoice$adjust = F4(
	function (apiClient, id_, chargeParams, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_invoice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'charge',
								$author$project$Api$Provider$PracticeCharge$encodeChargeParams(chargeParams))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['adjust']),
						$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)))));
	});
var $author$project$Api$Provider$PracticeInvoice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$id(shared);
};
var $author$project$Api$Provider$PracticeInvoice$refund = F4(
	function (apiClient, id_, chargeParams, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_invoice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'charge',
								$author$project$Api$Provider$PracticeCharge$encodeChargeParams(chargeParams))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['credit_and_refund']),
						$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)))));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$adjustInvoiceAction = F3(
	function (apiClient, practiceInvoice, chargeParams) {
		if (practiceInvoice.$ === 3) {
			var practiceInvoice_ = practiceInvoice.a;
			return (!$author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice_)) ? A4(
				$author$project$Api$Provider$PracticeInvoice$refund,
				apiClient,
				$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice_),
				chargeParams,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Refunded) : A4(
				$author$project$Api$Provider$PracticeInvoice$adjust,
				apiClient,
				$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice_),
				chargeParams,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Adjusted);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Provider$PracticeInvoice$cancel = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_))));
	});
var $author$project$Api$Payment$Employer_One = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Payment$Provider_One = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Payment$One$Payment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Payment$Shared$Payment = $elm$core$Basics$identity;
var $author$project$Api$Employer$Payment$Shared$Record = F9(
	function (id, status, amountInCents, attemptedInCents, createdAt, external, errorMessage, source, paymentProcessor) {
		return {I2: amountInCents, Jw: attemptedInCents, Mf: createdAt, ON: errorMessage, O4: external, adR: id, V0: paymentProcessor, Hg: source, ag7: status};
	});
var $author$project$Api$Employer$Payment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'external',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'attempted_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$Shared$Record))))))))));
var $author$project$Api$Employer$Payment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Payment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Payment$One$Record = function (refunds) {
	return {X3: refunds};
};
var $author$project$Api$Employer$Refund$Shared$Refund = $elm$core$Basics$identity;
var $author$project$Api$Employer$Refund$Shared$Record = F5(
	function (id, createdAt, status, amountInCents, paymentProcessor) {
		return {I2: amountInCents, Mf: createdAt, adR: id, V0: paymentProcessor, ag7: status};
	});
var $author$project$Api$Employer$Refund$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$Refund$Shared$Record))))));
var $author$project$Api$Employer$Refund$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Refund$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Payment$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'refunds',
	$elm$json$Json$Decode$list($author$project$Api$Employer$Refund$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$One$Record));
var $author$project$Api$Employer$Payment$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Payment$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Payment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$One$Payment)));
var $author$project$Currency$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Currency$toInt,
	$author$project$Utils$Encode$nullable($elm$json$Json$Encode$int));
var $author$project$Utils$Date$toIsoString = function (date) {
	return $justinmimbs$date$Date$toIsoString(date);
};
var $author$project$Utils$Date$encode = function (date) {
	return $elm$json$Json$Encode$string(
		$author$project$Utils$Date$toIsoString(date));
};
var $author$project$Api$Payment$paymentsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['payments']),
		basePath);
};
var $author$project$Utils$Encode$typedAssociation = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adR)),
				_Utils_Tuple2(
				'type',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahI))
			]));
};
var $author$project$Api$Payment$create = F7(
	function (basePath, apiClient, session, payableKey, payableId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								payableKey,
								$elm$json$Json$Encode$string(payableId)),
								_Utils_Tuple2(
								'source',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, fields.Hg)),
								_Utils_Tuple2(
								'amount_in_cents',
								$author$project$Currency$encode(fields.I2)),
								_Utils_Tuple2(
								'external',
								$elm$json$Json$Encode$bool(fields.O4)),
								_Utils_Tuple2(
								'memo',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aeC)),
								_Utils_Tuple2(
								'paid_at',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Vt)),
								_Utils_Tuple2(
								'card_reader',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.abR)),
								_Utils_Tuple2(
								'source_one_time_use',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.ag2)),
								_Utils_Tuple2(
								'selected_card_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agO)),
								_Utils_Tuple2(
								'selected_card_funding',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agN))
							])))
				]));
		return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Payment$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Employer_One))) : A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Payment$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Provider_One))))(
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Payment$paymentsPath(basePath))));
	});
var $author$project$Api$Provider$PracticeInvoice$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)));
	});
var $author$project$Api$Common$Source$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Practice$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Practice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$id(shared);
};
var $author$project$Components$Invoice$CreatePaymentModal$External = 1;
var $author$project$Components$Invoice$CreatePaymentModal$GotBankAccounts = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$GotCards = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Invoice$CreatePaymentModal$PayNow = 0;
var $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.IW;
	});
var $author$project$Api$Practice$allowMultipleRetailMemberships = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$CardReader$All$label = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReader$Shared$label(shared);
};
var $author$project$Api$Provider$CardReader$All$paymentProcessor = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReader$Shared$paymentProcessor(shared);
};
var $author$project$Utils$PaymentProcessor$toLabel = F3(
	function (showProcessor, element, getPaymentProcessor) {
		var _v0 = _Utils_Tuple2(
			showProcessor,
			getPaymentProcessor(element));
		if (_v0.a && (!_v0.b.$)) {
			var paymentProcessor_ = _v0.b.a;
			return $elm$core$Maybe$Just('[' + (paymentProcessor_ + ']'));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel = F2(
	function (showProcessor, cardReader) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3(
						$author$project$Utils$PaymentProcessor$toLabel,
						showProcessor,
						cardReader,
						A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just)),
						$elm$core$Maybe$Just(
						$author$project$Api$Provider$CardReader$All$label(cardReader))
					])));
	});
var $author$project$Api$Provider$CardReader$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CardReader$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReader$Shared$id(shared);
};
var $author$project$Components$Invoice$CreatePaymentModal$cardReaderToValue = function (cardReader) {
	return $elm$core$Maybe$Just(
		$author$project$Api$Provider$CardReader$All$id(cardReader));
};
var $author$project$Components$Invoice$CreatePaymentModal$Card = 2;
var $author$project$Components$Invoice$CreatePaymentModal$Cash = 1;
var $author$project$Components$Invoice$CreatePaymentModal$Check = 0;
var $author$project$Components$Invoice$CreatePaymentModal$Other = 4;
var $author$project$Components$Invoice$CreatePaymentModal$defaultOptions = {
	E_: 0,
	qk: 0,
	O4: false,
	Fe: _List_fromArray(
		[0, 1, 2, 4]),
	oo: false
};
var $author$project$Components$Invoice$CreatePaymentModal$Manual = 0;
var $author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Source$Source = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$Invoice$Shared$dueInCents = function (_v0) {
	var record = _v0;
	return record.N2;
};
var $author$project$Api$Employer$Invoice$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$Invoice$Shared$dueInCents = function (_v0) {
	var record = _v0.b;
	return record.N2;
};
var $author$project$Api$Provider$Invoice$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$dueInCents(shared);
};
var $author$project$Api$Invoice$One$dueInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$dueInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$dueInCents(invoice_);
	}
};
var $author$project$Api$Provider$CustomerInvoice$Shared$dueInCents = function (_v0) {
	var record = _v0;
	return record.N2;
};
var $author$project$Api$Provider$CustomerInvoice$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$Statement$Shared$dueInCents = function (_v0) {
	var record = _v0;
	return record.N2;
};
var $author$project$Api$Provider$Statement$One$dueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$dueInCents(shared);
};
var $author$project$Components$DateInput$DatePickerMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $agustinrhcp$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $agustinrhcp$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $agustinrhcp$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $agustinrhcp$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $agustinrhcp$elm_datepicker$DatePicker$off = $agustinrhcp$elm_datepicker$DatePicker$Date$Off;
var $agustinrhcp$elm_datepicker$DatePicker$defaultSettings = {
	pP: $agustinrhcp$elm_datepicker$DatePicker$formatCell,
	hI: $agustinrhcp$elm_datepicker$DatePicker$off,
	lr: 'elm-datepicker--',
	EF: _List_Nil,
	aco: $justinmimbs$date$Date$format('yyyy-MM-dd'),
	acr: $agustinrhcp$elm_datepicker$DatePicker$Date$formatDay,
	adq: 6,
	Q0: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	FA: _List_Nil,
	FB: $elm$core$Maybe$Nothing,
	FC: $elm$core$Maybe$Nothing,
	aed: $elm$core$Basics$always(false),
	zb: $agustinrhcp$elm_datepicker$DatePicker$Date$formatMonth,
	afz: $justinmimbs$date$Date$fromIsoString,
	r4: 'Please pick a date...',
	pf: $elm$core$String$fromInt
};
var $author$project$Components$DateInput$formatWeekday = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Mon';
		case 1:
			return 'Tue';
		case 2:
			return 'Wed';
		case 3:
			return 'Thu';
		case 4:
			return 'Fri';
		case 5:
			return 'Sat';
		default:
			return 'Sun';
	}
};
var $author$project$Components$DateInput$baseDatePickerSettings = function () {
	var defaultSettings_ = $agustinrhcp$elm_datepicker$DatePicker$defaultSettings;
	return _Utils_update(
		defaultSettings_,
		{
			aco: $justinmimbs$date$Date$format('MM/dd/yyyy'),
			acr: $author$project$Components$DateInput$formatWeekday,
			FA: _List_fromArray(
				[
					_Utils_Tuple2('form-control', true)
				]),
			afz: $author$project$Utils$Date$fromUsString
		});
}();
var $agustinrhcp$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $agustinrhcp$elm_datepicker$DatePicker$Day = 0;
var $agustinrhcp$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $agustinrhcp$elm_datepicker$DatePicker$init = _Utils_Tuple2(
	{
		a4: $elm$core$Maybe$Just($agustinrhcp$elm_datepicker$DatePicker$Date$initDate),
		fG: false,
		ca: $elm$core$Maybe$Nothing,
		U9: false,
		jt: 0,
		$P: $agustinrhcp$elm_datepicker$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $agustinrhcp$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $author$project$Components$DateInput$init = function () {
	var _v0 = $agustinrhcp$elm_datepicker$DatePicker$init;
	var datePicker = _v0.a;
	var datePickerCmd = _v0.b;
	return _Utils_Tuple2(
		{lM: datePicker},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$DateInput$DatePickerMsg($author$project$Components$DateInput$baseDatePickerSettings),
			datePickerCmd));
}();
var $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource = function (_v0) {
	var record = _v0.b;
	return record.TH;
};
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Api$Employer$Invoice$One$source = function (_v0) {
	var record = _v0.b;
	return record.Hg;
};
var $author$project$Api$Provider$Invoice$One$source = function (_v0) {
	var record = _v0.b;
	return record.Hg;
};
var $author$project$Api$Invoice$One$source = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$source(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$source(invoice_);
	}
};
var $author$project$Api$Provider$CustomerInvoice$One$source = function (_v0) {
	var record = _v0.b;
	return record.Hg;
};
var $author$project$Api$Provider$PracticeInvoice$One$source = function (_v0) {
	var record = _v0.b;
	return record.Hg;
};
var $author$project$Components$Invoice$CreatePaymentModal$formFieldsFromPayable = F5(
	function (today, external, defaultExternalSource, allowMultipleMemberships, payable) {
		var _v0 = function () {
			switch (payable.$) {
				case 0:
					var practiceInvoice = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice),
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Source$Source,
							$author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)));
				case 1:
					var invoice = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Invoice$One$dueInCents(invoice),
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Source$Source,
							$author$project$Api$Invoice$One$source(invoice)));
				case 2:
					var invoice = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Invoice$One$dueInCents(invoice),
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Source$Source,
							$author$project$Api$Invoice$One$source(invoice)));
				case 3:
					var invoice = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice),
						allowMultipleMemberships ? A2(
							$elm_community$maybe_extra$Maybe$Extra$orElse,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Source$Source,
								$author$project$Api$Provider$CustomerInvoice$One$source(invoice)),
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Source$Source,
								$author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice))) : A2(
							$elm$core$Maybe$map,
							$author$project$Api$Source$Source,
							$author$project$Api$Provider$CustomerInvoice$One$source(invoice)));
				default:
					var statement = payable.b;
					return _Utils_Tuple2(
						$author$project$Api$Provider$Statement$One$dueInCents(statement),
						$elm$core$Maybe$Nothing);
			}
		}();
		var dueInCents = _v0.a;
		var defaultSource = _v0.b;
		var _v2 = $author$project$Components$DateInput$init;
		var dateInput = _v2.a;
		var dateInputCmd = _v2.b;
		return _Utils_Tuple2(
			{
				I2: $elm$core$Maybe$Just(
					$author$project$Currency$fromInt(dueInCents)),
				cH: 0,
				abR: $elm$core$Maybe$Nothing,
				O4: external,
				mb: defaultExternalSource,
				mB: dueInCents,
				aeC: $elm$core$Maybe$Nothing,
				Vt: $elm$core$Maybe$Just(today),
				Gz: dateInput,
				Hg: defaultSource,
				Ct: false
			},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg(dateInput),
				dateInputCmd));
	});
var $author$project$Ui$Form$SearchableSelect$init = function (_v0) {
	var id = _v0.adR;
	var toLabel = _v0.ahw;
	var toValue = _v0.g0;
	var toTitle = _v0.ahA;
	return {dE: $jinjor$elm_debounce$Debounce$init, adR: id, FV: toLabel, yo: toTitle, FW: toValue, yF: false, U9: false, $A: ''};
};
var $author$project$Api$BankAccount$EmployerAll = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Employer$BankAccount$bankAccountsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['bank_accounts']),
		basePath);
};
var $author$project$Api$Employer$BankAccount$All$BankAccount = $elm$core$Basics$identity;
var $author$project$Api$Employer$BankAccount$One$BankAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$BankAccount$Shared$BankAccount = $elm$core$Basics$identity;
var $author$project$Api$Employer$BankAccount$Shared$Record = function (id) {
	return function (name) {
		return function (type_) {
			return function (lastFour) {
				return function (status) {
					return function (label) {
						return function (errorMessage) {
							return function (lastPaymentErrorMessage) {
								return function (createdAt) {
									return function (bankName) {
										return function (paymentProcessor) {
											return {JR: bankName, Mf: createdAt, ON: errorMessage, adR: id, aej: label, Sz: lastFour, SB: lastPaymentErrorMessage, zh: name, V0: paymentProcessor, ag7: status, ahI: type_};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$BankAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'bank_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'last_payment_error_message',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'error_message',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'label',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'last_four',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'type',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$Shared$Record))))))))))));
var $author$project$Api$Employer$BankAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$BankAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$BankAccount$One$Record = function (_default) {
	return {M5: _default};
};
var $author$project$Api$Employer$BankAccount$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'default',
	$elm$json$Json$Decode$bool,
	false,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$One$Record));
var $author$project$Api$Employer$BankAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$BankAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$BankAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$One$BankAccount)));
var $author$project$Api$Employer$BankAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$BankAccount$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$BankAccount$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$BankAccount$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$BankAccount$bankAccountsPath(basePath)));
	});
var $author$project$Api$BankAccount$list = F4(
	function (basePath, apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$BankAccount$list,
			basePath,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$BankAccount$EmployerAll)))) : A3(
			$author$project$Api$Provider$BankAccount$list,
			basePath,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$BankAccount$ProviderAll))));
	});
var $author$project$Api$Card$EmployerAll = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Employer$Card$cardsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['cards']),
		basePath);
};
var $author$project$Api$Employer$Card$All$Card = $elm$core$Basics$identity;
var $author$project$Api$Employer$Card$One$Card = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Card$Shared$Card = $elm$core$Basics$identity;
var $author$project$Api$Employer$Card$Shared$Record = function (id) {
	return function (name) {
		return function (type_) {
			return function (lastFour) {
				return function (status) {
					return function (label) {
						return function (errorMessage) {
							return function (lastPaymentErrorMessage) {
								return function (expMonth) {
									return function (expYear) {
										return function (createdAt) {
											return function (cardType) {
												return function (zip) {
													return function (paymentProcessor) {
														return {KI: cardType, Mf: createdAt, ON: errorMessage, ac9: expMonth, ada: expYear, adR: id, aej: label, Sz: lastFour, SB: lastPaymentErrorMessage, zh: name, V0: paymentProcessor, ag7: status, ahI: type_, tC: zip};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Card$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'zip',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'card_type',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'exp_year',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'exp_month',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'last_payment_error_message',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'error_message',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'label',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'status',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_four',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'type',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'name',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$elm$json$Json$Decode$string,
														$elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$Shared$Record)))))))))))))));
var $author$project$Api$Employer$Card$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Card$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Card$One$Record = function (_default) {
	return {M5: _default};
};
var $author$project$Api$Employer$Card$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'default',
	$elm$json$Json$Decode$bool,
	false,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$One$Record));
var $author$project$Api$Employer$Card$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Card$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Card$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$One$Card)));
var $author$project$Api$Employer$Card$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Card$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Card$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Card$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Card$cardsPath(basePath)));
	});
var $author$project$Api$Card$list = F4(
	function (basePath, apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Card$list,
			basePath,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Card$EmployerAll)))) : A3(
			$author$project$Api$Provider$Card$list,
			basePath,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Card$ProviderAll))));
	});
var $author$project$Api$Employer$BankAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$BankAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$id(shared);
};
var $author$project$Api$Employer$BankAccount$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$id(one);
};
var $author$project$Api$Provider$BankAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$BankAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$id(shared);
};
var $author$project$Api$Provider$BankAccount$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$id(one);
};
var $author$project$Api$BankAccount$id = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$id(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$id(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$id(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$id(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$Card$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$id(shared);
};
var $author$project$Api$Employer$Card$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$id(one);
};
var $author$project$Api$Provider$Card$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Card$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$id(shared);
};
var $author$project$Api$Provider$Card$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$id(one);
};
var $author$project$Api$Card$id = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$id(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$id(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$id(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$id(card_);
	}
};
var $author$project$Api$Source$id = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$id(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$id(bankAccount);
		default:
			var source_ = source.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'external',
				$author$project$Api$Common$Source$Shared$id(source_));
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$paymentSourceToValue = function (source) {
	return $elm$core$Maybe$Just(
		$author$project$Api$Source$id(source));
};
var $author$project$Components$Invoice$CreatePaymentModal$sourceName = function (source_) {
	var _v0 = $author$project$Api$Source$name(source_);
	if (!_v0.$) {
		var name = _v0.a;
		return $elm$core$Maybe$Just(name);
	} else {
		return $author$project$Api$Source$type_(source_);
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$sourceLabel = F2(
	function (showProcessor, source) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, source, $author$project$Api$Source$paymentProcessor),
						A2(
						$elm$core$Maybe$map,
						$author$project$Formatters$String$titleize,
						$author$project$Components$Invoice$CreatePaymentModal$sourceName(source)),
						A2(
						$elm$core$Maybe$map,
						function (lastFour) {
							return ' * ' + lastFour;
						},
						$author$project$Api$Source$lastFour(source)),
						A2(
						$elm$core$Maybe$map,
						function (funding) {
							return ' (' + (funding + ')');
						},
						$author$project$Api$Source$funding(source))
					])));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewCardReader = F2(
	function (showProcessor, cardReader) {
		return _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A4(
					$author$project$Utils$PaymentProcessor$toBadge,
					showProcessor,
					showProcessor,
					cardReader,
					A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just))),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel, showProcessor, cardReader))
					]))
			]);
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewPaymentSource = F2(
	function (showProcessor, source) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A4($author$project$Utils$PaymentProcessor$toBadge, showProcessor, showProcessor, source, $author$project$Api$Source$paymentProcessor)),
						function () {
						var _v0 = $author$project$Components$Invoice$CreatePaymentModal$sourceName(source);
						if (!_v0.$) {
							var name = _v0.a;
							return A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Formatters$String$titleize(name))
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						$author$project$Utils$Html$noBreakSpace,
						function () {
						var _v1 = $author$project$Api$Source$lastFour(source);
						if (!_v1.$) {
							var lastFour = _v1.a;
							return A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*' + lastFour)
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						$author$project$Utils$Html$noBreakSpace,
						function () {
						var _v2 = $author$project$Api$Source$funding(source);
						if (!_v2.$) {
							var funding = _v2.a;
							return A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('(' + (funding + ')'))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						A2(
							$elm$core$Maybe$withDefault,
							'N/A',
							$author$project$Api$Source$status(source))),
						$author$project$Utils$Html$noBreakSpace,
						function () {
						var _v3 = $author$project$Api$Source$label(source);
						if (!_v3.$) {
							var label = _v3.a;
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-muted')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true),
														$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label)
													]))
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]);
	});
var $author$project$Components$Invoice$CreatePaymentModal$init = function (today) {
	return function (timeFormatter) {
		return function (paymentPath) {
			return function (sourcePath) {
				return function (apiClient) {
					return function (session) {
						return function (practice) {
							return function (isHintAdmin) {
								return function (rainforestEnv) {
									return function (optionsBuilder) {
										return function (payable) {
											var options = optionsBuilder($author$project$Components$Invoice$CreatePaymentModal$defaultOptions);
											var displayModal = options.O4 ? 1 : 0;
											var _v0 = function () {
												var _v1 = _Utils_Tuple2(options.O4, sourcePath);
												if ((!_v1.a) && (!_v1.b.$)) {
													var sourcePath_ = _v1.b.a;
													return _Utils_Tuple2(
														$elm$core$Platform$Cmd$batch(
															_List_fromArray(
																[
																	A4($author$project$Api$Card$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreatePaymentModal$GotCards),
																	A4($author$project$Api$BankAccount$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreatePaymentModal$GotBankAccounts)
																])),
														$author$project$Api$Data$Loading);
												} else {
													return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
												}
											}();
											var sourceCmd = _v0.a;
											var sourceStatus = _v0.b;
											var _v2 = A5(
												$author$project$Components$Invoice$CreatePaymentModal$formFieldsFromPayable,
												today,
												options.O4,
												options.E_,
												$author$project$Api$Practice$allowMultipleRetailMemberships(practice),
												payable);
											var fields = _v2.a;
											var fieldsCmd = _v2.b;
											return _Utils_Tuple2(
												{
													pD: sourceStatus,
													hF: $elm$core$Maybe$Nothing,
													bS: $elm$core$Maybe$Nothing,
													pM: $author$project$Ui$Form$SearchableSelect$init(
														{
															adR: 'card-reader-select',
															ahw: $author$project$Components$Invoice$CreatePaymentModal$viewCardReader(options.oo),
															ahA: $author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel(options.oo),
															g0: $author$project$Components$Invoice$CreatePaymentModal$cardReaderToValue
														}),
													hG: $author$project$Api$Data$NotAsked,
													pN: sourceStatus,
													qk: displayModal,
													PB: $author$project$Utils$Form$init(fields),
													FR: isHintAdmin,
													zY: options,
													afF: payable,
													af: $author$project$Api$Data$NotAsked,
													rX: paymentPath,
													r_: $author$project$Ui$Form$SearchableSelect$init(
														{
															adR: 'source-select',
															ahw: $author$project$Components$Invoice$CreatePaymentModal$viewPaymentSource(options.oo),
															ahA: $author$project$Components$Invoice$CreatePaymentModal$sourceLabel(options.oo),
															g0: $author$project$Components$Invoice$CreatePaymentModal$paymentSourceToValue
														}),
													WF: practice,
													sj: rainforestEnv,
													ZD: session,
													Hh: sourcePath,
													Hy: timeFormatter,
													$P: today,
													V: true
												},
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[fieldsCmd, sourceCmd])));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$PracticeInvoice$issue = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeInvoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['issue']),
					$author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_))));
	});
var $author$project$Components$CardReader$ConnectingModal$Affiliate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$BrokerAccount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReader = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderSelectMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$Closed = 0;
var $author$project$Components$CardReader$ConnectingModal$Company = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$None = 1;
var $author$project$Components$Invoice$CreatePaymentModal$PaidAt = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$Patient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$PaymentCreated = 2;
var $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSelectMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$Practice = function (a) {
	return {$: 2, a: a};
};
var $author$project$OutMsg$RefreshPatientsList = {$: 11};
var $author$project$Components$Invoice$CreatePaymentModal$Source = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Payment$Shared$cardReader = function (_v0) {
	var record = _v0;
	return record.abR;
};
var $author$project$Api$Provider$Payment$One$cardReader = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$cardReader(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$cardReader = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$cardReader(shared);
};
var $author$project$Api$Payment$cardReader = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$cardReader(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$cardReader(payment_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$CardCreated = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Api$Card$EmployerOne = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Card$ProviderOne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$PaymentProcessorParams$encode = function (param) {
	if (!param.$) {
		var stripeId = param.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'payment_processor',
				$elm$json$Json$Encode$string('stripe')),
				_Utils_Tuple2(
				'stripe_id',
				$elm$json$Json$Encode$string(stripeId))
			]);
	} else {
		var rainforestId = param.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'payment_processor',
				$elm$json$Json$Encode$string('rainforest')),
				_Utils_Tuple2(
				'rainforest_id',
				$elm$json$Json$Encode$string(rainforestId))
			]);
	}
};
var $author$project$Api$Employer$Card$create = F4(
	function (basePath, apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'card',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'card_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.KI)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'last_four',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Sz)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'created_via',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Mi)),
									$author$project$Api$PaymentProcessorParams$encode(fields.V1))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$Card$cardsPath(basePath))));
	});
var $author$project$Api$Provider$Card$create = F4(
	function (basePath, apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'card',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										_Utils_Tuple2(
										'card_type',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.KI)),
										_Utils_Tuple2(
										'last_four',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Sz)),
										_Utils_Tuple2(
										'created_via',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Mi))
									]),
									$author$project$Api$PaymentProcessorParams$encode(fields.V1),
									function () {
									var _v0 = fields.U7;
									if (!_v0.$) {
										var oneTimeUse = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'one_time_use',
												$elm$json$Json$Encode$bool(oneTimeUse))
											]);
									} else {
										return _List_Nil;
									}
								}()
								]))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Card$cardsPath(basePath))));
	});
var $author$project$Api$Card$create = F5(
	function (basePath, apiClient, session, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$Card$create,
			basePath,
			apiClient,
			{KI: fields.KI, Mi: fields.Mi, Sz: fields.Sz, V1: fields.V1},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A4(
			$author$project$Api$Provider$Card$create,
			basePath,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
	});
var $author$project$Components$Invoice$CreatePaymentModal$createCard = F5(
	function (basePath, apiClient, session, formFields, readCard) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (basePath_) {
					return A5(
						$author$project$Api$Card$create,
						basePath_,
						apiClient,
						session,
						{
							KI: $elm$core$Maybe$Nothing,
							Mi: $elm$core$Maybe$Just(readCard.Mi),
							Sz: $elm$core$Maybe$Nothing,
							U7: $elm$core$Maybe$Just(readCard.U7),
							V1: readCard.V1
						},
						$author$project$Components$Invoice$CreatePaymentModal$CardCreated(formFields));
				},
				basePath));
	});
var $author$project$Components$Invoice$CreatePaymentModal$Created = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Invoice$CreatePaymentModal$externalSourceCode = function (externalSource) {
	switch (externalSource) {
		case 0:
			return 'check';
		case 1:
			return 'cash';
		case 2:
			return 'card';
		case 3:
			return 'eft';
		default:
			return 'other';
	}
};
var $author$project$Api$Employer$Invoice$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$Invoice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$id(shared);
};
var $author$project$Api$Provider$Invoice$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Invoice$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$id(min);
};
var $author$project$Api$Provider$Invoice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$id(shared);
};
var $author$project$Api$Invoice$One$id = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$id(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$id(invoice_);
	}
};
var $author$project$Api$Provider$CustomerInvoice$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CustomerInvoice$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$id(shared);
};
var $author$project$Api$Provider$Statement$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Statement$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$id(shared);
};
var $author$project$Components$Invoice$CreatePaymentModal$payableIdAndKey = function (payable) {
	var payableKey = function () {
		switch (payable.$) {
			case 0:
				return 'practice_invoice_id';
			case 1:
				return 'invoice_id';
			case 2:
				return 'affiliate_bill_id';
			case 3:
				return 'customer_invoice_id';
			default:
				return 'statement_id';
		}
	}();
	var payableId = function () {
		switch (payable.$) {
			case 0:
				var practiceInvoice = payable.b;
				return $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice);
			case 1:
				var invoice = payable.b;
				return $author$project$Api$Invoice$One$id(invoice);
			case 2:
				var invoice = payable.b;
				return $author$project$Api$Invoice$One$id(invoice);
			case 3:
				var invoice = payable.b;
				return $author$project$Api$Provider$CustomerInvoice$One$id(invoice);
			default:
				var statement = payable.b;
				return $author$project$Api$Provider$Statement$One$id(statement);
		}
	}();
	return _Utils_Tuple2(payableKey, payableId);
};
var $author$project$Components$Invoice$CreatePaymentModal$createPayment = F8(
	function (externalSource, basePath, apiClient, session, payable, formFields, cardReaderCard, cardReader) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var selectedSource = function () {
			if (externalSource) {
				return $elm$core$Maybe$Just(
					{
						adR: $elm$core$Maybe$Nothing,
						ahI: $elm$core$Maybe$Just(
							$author$project$Components$Invoice$CreatePaymentModal$externalSourceCode(fields.mb))
					});
			} else {
				var _v1 = _Utils_Tuple2(cardReaderCard, cardReader);
				if (_v1.a.$ === 1) {
					if (_v1.b.$ === 1) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						return A2(
							$elm$core$Maybe$map,
							function (source) {
								return {
									adR: $elm$core$Maybe$Just(
										$author$project$Api$Source$id(source)),
									ahI: $author$project$Api$Source$type_(source)
								};
							},
							fields.Hg);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					var cardReaderCard_ = _v1.a.a;
					return $elm$core$Maybe$Just(
						{
							adR: $elm$core$Maybe$Just(
								$author$project$Api$Card$id(cardReaderCard_)),
							ahI: $author$project$Api$Card$type_(cardReaderCard_)
						});
				}
			}
		}();
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$payableIdAndKey(payable);
		var payableKey = _v0.a;
		var payableId = _v0.b;
		return A7(
			$author$project$Api$Payment$create,
			basePath,
			apiClient,
			session,
			payableKey,
			payableId,
			{
				I2: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Currency$fromInt(fields.mB),
					fields.I2),
				abR: A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, cardReader),
				O4: fields.O4,
				aeC: fields.aeC,
				Vt: fields.Vt,
				agN: $elm$core$Maybe$Nothing,
				agO: $elm$core$Maybe$Nothing,
				Hg: selectedSource,
				ag2: $elm$core$Maybe$Just(!fields.Ct)
			},
			$author$project$Components$Invoice$CreatePaymentModal$Created(formFields));
	});
var $author$project$Api$Employer$Payment$Shared$external = function (_v0) {
	var record = _v0;
	return record.O4;
};
var $author$project$Api$Employer$Payment$One$external = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$external(shared);
};
var $author$project$Api$Provider$Payment$Shared$external = function (_v0) {
	var record = _v0;
	return record.O4;
};
var $author$project$Api$Provider$Payment$One$external = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$external(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$external = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$external(shared);
};
var $author$project$Api$Payment$external = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$external(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$external(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$external(payment_);
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$GotCardReaders = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$CardReader$cardReadersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['card_readers']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CardReader$All$CardReader = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReader$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReader$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CardReader$listDefaults = {afy: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$CardReader$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CardReader$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.afy);
};
var $author$project$Api$Provider$CardReader$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CardReader$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CardReader$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReadersPath)));
	});
var $author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders = function (apiClient) {
	return A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Invoice$CreatePaymentModal$GotCardReaders);
};
var $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var _int = field.a;
				return _Utils_update(
					fields,
					{I2: _int});
			case 1:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{Vt: date, Gz: dateInput});
			case 2:
				var externalSource = field.a;
				return _Utils_update(
					fields,
					{mb: externalSource});
			case 4:
				var source = field.a;
				return _Utils_update(
					fields,
					{Hg: source});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aeC: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var cardReader = field.a;
				return _Utils_update(
					fields,
					{abR: cardReader});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ct: bool});
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$CardReaderValidation = 1;
var $author$project$Components$Invoice$CreatePaymentModal$AmountInCentsValidation = 0;
var $author$project$Currency$isValid = F2(
	function (options, currency) {
		var _v0 = $author$project$Currency$toInt(currency);
		if (!_v0.$) {
			var _int = _v0.a;
			var _v1 = _Utils_Tuple2(options.TZ, options.yQ);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var min = _v1.a.a;
					var max = _v1.b.a;
					return !((_Utils_cmp(_int, min) < 0) || (_Utils_cmp(_int, max) > 0));
				} else {
					var min = _v1.a.a;
					var _v2 = _v1.b;
					return _Utils_cmp(_int, min) > -1;
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var max = _v1.b.a;
					return _Utils_cmp(_int, max) < 1;
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return true;
				}
			}
		} else {
			return false;
		}
	});
var $author$project$Utils$Validate$isInvalidCurrency = F2(
	function (options, currency) {
		if (!currency.$) {
			var currency_ = currency.a;
			return !A2(
				$author$project$Currency$isValid,
				{yQ: options.yQ, TZ: options.TZ},
				currency_);
		} else {
			return !options.abi;
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$validateAmountInCents = function (fields) {
	var min = fields.O4 ? 0 : 50;
	var max = fields.mB;
	return A2(
		$author$project$Utils$Validate$isInvalidCurrency,
		{
			abi: false,
			yQ: $elm$core$Maybe$Just(max),
			TZ: $elm$core$Maybe$Just(min)
		},
		fields.I2) ? _List_fromArray(
		[
			_Utils_Tuple2(
			0,
			'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
		]) : _List_Nil;
};
var $author$project$Components$Invoice$CreatePaymentModal$SourceValidation = 2;
var $author$project$Components$Invoice$CreatePaymentModal$validateSource = function (fields) {
	return ((!fields.O4) && _Utils_eq(fields.Hg, $elm$core$Maybe$Nothing)) ? _List_fromArray(
		[
			_Utils_Tuple2(2, 'Please pick a source.')
		]) : _List_Nil;
};
var $author$project$Components$Invoice$CreatePaymentModal$formFieldsValidator = function (useExistingSources) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreatePaymentModal$validateAmountInCents),
				useExistingSources ? $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreatePaymentModal$validateSource) : A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.abR;
				},
				_Utils_Tuple2(1, 'Please pick a card reader.'))
			]));
};
var $author$project$Ports$LocalStorage$localStorageGetItemPort = _Platform_outgoingPort('localStorageGetItemPort', $elm$json$Json$Encode$string);
var $author$project$Ports$LocalStorage$getItem = function (key) {
	return $author$project$Ports$LocalStorage$localStorageGetItemPort(key);
};
var $author$project$Components$CardReader$ConnectingModal$Connecting = 0;
var $author$project$Components$CardReader$ConnectingModal$GotConnectionToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$GotReadCardResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$Model = $elm$core$Basics$identity;
var $author$project$Components$CardReader$ConnectingModal$Rainforest = 1;
var $author$project$Components$CardReader$ConnectingModal$Stripe = 0;
var $author$project$Api$Provider$CardReader$getConnectionToken = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['token']),
				$elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['connection_token']),
					$author$project$Api$Provider$CardReader$cardReadersPath)));
	});
var $author$project$Components$CardReader$SimulateForm$Model = $elm$core$Basics$identity;
var $author$project$Components$CardReader$SimulateForm$initFormFields = {
	abQ: $elm$core$Maybe$Just('VISA_SUCCESS'),
	ac5: $elm$core$Maybe$Just('PRESENTED')
};
var $author$project$Components$CardReader$SimulateForm$init = F2(
	function (session, cardReaderId) {
		return {
			e8: cardReaderId,
			PB: $author$project$Utils$Form$init($author$project$Components$CardReader$SimulateForm$initFormFields),
			ZD: session,
			ov: $author$project$Api$Data$NotAsked
		};
	});
var $author$project$Rainforest$isSandbox = function (env) {
	if (!env.$) {
		if (env.a === 1) {
			var _v1 = env.a;
			return true;
		} else {
			var _v2 = env.a;
			return false;
		}
	} else {
		return false;
	}
};
var $author$project$Api$Provider$CardReader$cardReaderPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$CardReader$cardReadersPath);
};
var $author$project$Api$Provider$CardReader$readCard = F5(
	function (apiClient, id, ownerType, ownerId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'owner',
					$author$project$Utils$Encode$typedAssociation(
						{
							adR: $elm$core$Maybe$Just(ownerId),
							ahI: $elm$core$Maybe$Just(ownerType)
						}))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['payment_method_id']),
				$elm$json$Json$Decode$string),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['read_card']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Components$CardReader$ConnectingModal$init = F7(
	function (apiClient, session, isHintAdmin, rainforestEnv, cardReader, owner, storeCard) {
		var _v0 = function () {
			if ($author$project$Api$Provider$CardReader$All$paymentProcessor(cardReader) === 'rainforest') {
				var _v1 = function () {
					switch (owner.$) {
						case 0:
							var companyId = owner.a;
							return _Utils_Tuple2('company', companyId);
						case 1:
							var patientId = owner.a;
							return _Utils_Tuple2('patient', patientId);
						case 2:
							var practiceId = owner.a;
							return _Utils_Tuple2('practice', practiceId);
						case 3:
							var brokerAccountId = owner.a;
							return _Utils_Tuple2('broker_account', brokerAccountId);
						default:
							var affiliateId = owner.a;
							return _Utils_Tuple2('affiliate', affiliateId);
					}
				}();
				var ownerType = _v1.a;
				var ownerId = _v1.b;
				return _Utils_Tuple3(
					1,
					0,
					A5(
						$author$project$Api$Provider$CardReader$readCard,
						apiClient,
						$author$project$Api$Provider$CardReader$All$id(cardReader),
						ownerType,
						ownerId,
						$author$project$Components$CardReader$ConnectingModal$GotReadCardResponse));
			} else {
				return _Utils_Tuple3(
					0,
					0,
					A2($author$project$Api$Provider$CardReader$getConnectionToken, apiClient, $author$project$Components$CardReader$ConnectingModal$GotConnectionToken));
			}
		}();
		var paymentProcessor = _v0.a;
		var connectionStatus = _v0.b;
		var connectionCmd = _v0.c;
		var simulateForm = ((paymentProcessor === 1) && (isHintAdmin && $author$project$Rainforest$isSandbox(rainforestEnv))) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Components$CardReader$SimulateForm$init,
				session,
				$author$project$Api$Provider$CardReader$All$id(cardReader))) : $elm$core$Maybe$Nothing;
		return _Utils_Tuple2(
			{cE: false, abR: cardReader, dx: connectionStatus, pX: $author$project$Api$Data$Loading, V0: paymentProcessor, sU: simulateForm, Ct: storeCard},
			connectionCmd);
	});
var $author$project$Components$CardReader$PaymentModal$Connecting = 0;
var $author$project$Components$CardReader$PaymentModal$GotReadPaymentResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CardReader$PaymentModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Employer$Payment$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$Payment$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$id(shared);
};
var $author$project$Api$Provider$Payment$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Payment$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$id(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$id(shared);
};
var $author$project$Api$Payment$id = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$id(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$id(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$id(payment_);
	}
};
var $author$project$Api$Provider$CardReader$readPayment = F4(
	function (apiClient, id, paymentId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_id',
					$elm$json$Json$Encode$string(paymentId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Payment$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['read_payment']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Api$CardReader$readPayment = F5(
	function (apiClient, session, id, paymentId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$CardReader$readPayment,
			apiClient,
			id,
			paymentId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Provider_One)));
	});
var $author$project$Components$CardReader$PaymentModal$init = F6(
	function (apiClient, session, isHintAdmin, rainforestEnv, cardReaderId, payment) {
		var simulateForm = (isHintAdmin && $author$project$Rainforest$isSandbox(rainforestEnv)) ? $elm$core$Maybe$Just(
			A2($author$project$Components$CardReader$SimulateForm$init, session, cardReaderId)) : $elm$core$Maybe$Nothing;
		var _v0 = _Utils_Tuple2(
			0,
			A5(
				$author$project$Api$CardReader$readPayment,
				apiClient,
				session,
				cardReaderId,
				$author$project$Api$Payment$id(payment),
				$author$project$Components$CardReader$PaymentModal$GotReadPaymentResponse));
		var connectionStatus = _v0.a;
		var connectionCmd = _v0.b;
		return _Utils_Tuple2(
			{cE: false, e8: cardReaderId, dx: connectionStatus, pX: $author$project$Api$Data$Loading, VY: payment, ZD: session, sU: simulateForm},
			connectionCmd);
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $author$project$Api$Employer$Practice$One$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Practice$paymentProcessor = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$paymentProcessor(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$paymentProcessor(practice_);
	}
};
var $author$project$Api$Provider$Practice$Shared$usesCardReaders = function (_v0) {
	var record = _v0;
	return record.aaD;
};
var $author$project$Api$Provider$Practice$One$usesCardReaders = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$usesCardReaders(shared);
};
var $author$project$Api$Practice$usesCardReaders = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$usesCardReaders(practice_);
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch = F3(
	function (apiClient, response, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.pN, model.pD);
			if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
				var _v2 = _v1.a;
				var cards = _v2.a;
				var _v3 = _v1.b;
				var bankAccounts = _v3.a;
				var useCardReader = $elm$core$List$isEmpty(cards) && ($elm$core$List$isEmpty(bankAccounts) && ($author$project$Api$Practice$usesCardReaders(model.WF) && (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD))));
				return _Utils_Tuple3(
					!useCardReader,
					useCardReader ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
					useCardReader ? $author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders(apiClient) : $elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple3(model.V, model.hG, $elm$core$Platform$Cmd$none);
			}
		}();
		var useExistingSources = _v0.a;
		var cardReaders = _v0.b;
		var cmd = _v0.c;
		return {
			EC: cmd,
			ac5: 1,
			y8: _Utils_update(
				model,
				{hG: cardReaders, V: useExistingSources}),
			as: $author$project$OutMsg$handleErrorResponse(response)
		};
	});
var $author$project$Api$Employer$Payment$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Employer$Payment$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$status(shared);
};
var $author$project$Api$Provider$Payment$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Payment$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$status(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$status(shared);
};
var $author$project$Api$Payment$status = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$status(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$status(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$status(payment_);
	}
};
var $author$project$Components$CardReader$ConnectingModal$CardRead = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$Closed = {$: 0};
var $author$project$Components$CardReader$ConnectingModal$Connected = 1;
var $author$project$Components$CardReader$ConnectingModal$GotCardReader = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$GotReportCardReadStatus = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$None = {$: 2};
var $author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CardReader$ConnectingModal$SimulateFormMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$CardReader$cancelReadCard = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel_read_card']),
					$author$project$Api$Provider$CardReader$cardReaderPath(id))));
	});
var $author$project$Ports$StripeTerminal$stripeTerminalPortCancelReadReusableCard = _Platform_outgoingPort('stripeTerminalPortCancelReadReusableCard', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$cancelReadReusableCard = $author$project$Ports$StripeTerminal$stripeTerminalPortCancelReadReusableCard;
var $author$project$Ports$StripeTerminal$stripeTerminalPortConnectReader = _Platform_outgoingPort(
	'stripeTerminalPortConnectReader',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					function ($) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'device_sw_version',
								$elm$json$Json$Encode$string($.acK)),
								_Utils_Tuple2(
								'device_type',
								$elm$json$Json$Encode$string($.acL)),
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string($.adR)),
								_Utils_Tuple2(
								'ip_address',
								$elm$json$Json$Encode$string($.aeb)),
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string($.aej)),
								_Utils_Tuple2(
								'livemode',
								$elm$json$Json$Encode$bool($.aep)),
								_Utils_Tuple2(
								'location',
								$elm$json$Json$Encode$string($.aet)),
								_Utils_Tuple2(
								'object',
								$elm$json$Json$Encode$string($.ae$)),
								_Utils_Tuple2(
								'serial_number',
								$elm$json$Json$Encode$string($.agR)),
								_Utils_Tuple2(
								'status',
								$elm$json$Json$Encode$string($.ag7))
							]));
				}(b)
				]));
	});
var $author$project$Ports$StripeTerminal$connectReader = F2(
	function (token, stripeObject) {
		return $author$project$Ports$StripeTerminal$stripeTerminalPortConnectReader(
			_Utils_Tuple2(token, stripeObject));
	});
var $author$project$Ports$StripeTerminal$stripeTerminalPortCreate = _Platform_outgoingPort('stripeTerminalPortCreate', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$create = $author$project$Ports$StripeTerminal$stripeTerminalPortCreate;
var $author$project$Ports$StripeTerminal$stripeTerminalPortClearCachedCredentials = _Platform_outgoingPort('stripeTerminalPortClearCachedCredentials', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$clearCachedCredentials = $author$project$Ports$StripeTerminal$stripeTerminalPortClearCachedCredentials;
var $author$project$Ports$StripeTerminal$stripeTerminalPortDisconnectReader = _Platform_outgoingPort('stripeTerminalPortDisconnectReader', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$disconnectReader = $author$project$Ports$StripeTerminal$stripeTerminalPortDisconnectReader;
var $author$project$Components$CardReader$ConnectingModal$disconnectReader = F4(
	function (apiClient, model, cmd, event) {
		return {
			EC: function () {
				var _v0 = _Utils_Tuple2(model.V0, model.pX);
				if (!_v0.a) {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var token = _v2.a;
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$StripeTerminal$disconnectReader(token),
									$author$project$Ports$StripeTerminal$clearCachedCredentials(token),
									cmd
								]));
					} else {
						return cmd;
					}
				} else {
					var _v3 = _v0.a;
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Api$Provider$CardReader$cancelReadCard,
								apiClient,
								$author$project$Api$Provider$CardReader$All$id(model.abR),
								$author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
								cmd
							]));
				}
			}(),
			ac5: A2($elm$core$Maybe$withDefault, $author$project$Components$CardReader$ConnectingModal$Closed, event),
			y8: _Utils_update(
				model,
				{cE: false, dx: 0}),
			as: _List_Nil
		};
	});
var $author$project$Components$CardReader$ConnectingModal$handleStripeFailure = F3(
	function (apiClient, model, error) {
		var result = A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
		var messge = A2($elm$core$String$contains, 'Action canceled.', error) ? $elm$core$Maybe$Nothing : (A2($elm$core$String$contains, 'Invalid object shape', error) ? $elm$core$Maybe$Just('We are having trouble talking to the reader, please reach out for help.') : $elm$core$Maybe$Just(error));
		var outMsgs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$OutMsg$ShowToast(1),
					$elm$core$List$singleton),
				messge));
		return _Utils_update(
			result,
			{as: outMsgs});
	});
var $author$project$Components$CardReader$ConnectingModal$PollCardReadStatus = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$CardReader$ConnectingModal$pollReadCardStatus = F2(
	function (cardReader, paymentMethodId) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return A2($author$project$Components$CardReader$ConnectingModal$PollCardReadStatus, cardReader, paymentMethodId);
			},
			$elm$core$Process$sleep(2000));
	});
var $author$project$Api$PaymentProcessorParams$RainforestParams = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$PaymentProcessorParams$rainforestParams = $author$project$Api$PaymentProcessorParams$RainforestParams;
var $author$project$Api$Provider$CardReader$ReadStatus = function (status) {
	return {ag7: status};
};
var $author$project$Api$Provider$CardReader$readCardStatusDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$ReadStatus));
var $author$project$Api$Provider$CardReader$readCardStatus = F4(
	function (apiClient, id, paymentMethodId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CardReader$readCardStatusDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'payment_method_id', paymentMethodId)
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['read_card_status']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Ports$StripeTerminal$stripeTerminalPortReadReusableCard = _Platform_outgoingPort('stripeTerminalPortReadReusableCard', $elm$json$Json$Encode$string);
var $author$project$Ports$StripeTerminal$readReusableCard = $author$project$Ports$StripeTerminal$stripeTerminalPortReadReusableCard;
var $author$project$Api$Provider$CardReader$One$CardReader = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReader$One$Record = function (stripeObject) {
	return {_Y: stripeObject};
};
var $author$project$Api$Provider$CardReader$One$StripeObject = function (device_sw_version) {
	return function (device_type) {
		return function (id) {
			return function (ip_address) {
				return function (label) {
					return function (livemode) {
						return function (location) {
							return function (object) {
								return function (serial_number) {
									return function (status) {
										return {acK: device_sw_version, acL: device_type, adR: id, aeb: ip_address, aej: label, aep: livemode, aet: location, ae$: object, agR: serial_number, ag7: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CardReader$One$stripeObjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'serial_number',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'object',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'livemode',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'label',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ip_address',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'device_type',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'device_sw_version',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$One$StripeObject)))))))))));
var $author$project$Api$Provider$CardReader$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stripe_object',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CardReader$One$stripeObjectDecoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$One$Record));
var $author$project$Api$Provider$CardReader$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReader$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CardReader$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CardReader$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CardReader$cardReaderPath(id)));
	});
var $author$project$Ports$LocalStorage$localStorageSetItemPort = _Platform_outgoingPort(
	'localStorageSetItemPort',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Ports$LocalStorage$setItem = F2(
	function (key, value) {
		return $author$project$Ports$LocalStorage$localStorageSetItemPort(
			_Utils_Tuple2(key, value));
	});
var $author$project$Api$Provider$CardReader$One$stripeObject = function (_v0) {
	var record = _v0;
	return record._Y;
};
var $author$project$Api$PaymentProcessorParams$StripeParams = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$PaymentProcessorParams$stripeParams = $author$project$Api$PaymentProcessorParams$StripeParams;
var $author$project$Components$CardReader$SimulateForm$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var event = field.a;
			return _Utils_update(
				fields,
				{
					ac5: $author$project$Utils$String$toMaybe(event)
				});
		} else {
			var card = field.a;
			return _Utils_update(
				fields,
				{
					abQ: $author$project$Utils$String$toMaybe(card)
				});
		}
	});
var $author$project$Components$CardReader$SimulateForm$CardValidation = 1;
var $author$project$Components$CardReader$SimulateForm$EventValidation = 0;
var $author$project$Components$CardReader$SimulateForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.ac5;
			},
			_Utils_Tuple2(0, 'Please pick an event.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.abQ;
			},
			_Utils_Tuple2(1, 'Please pick a card.'))
		]));
var $author$project$Components$CardReader$SimulateForm$GotSimulateResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CardReader$simulateDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['success']),
	$elm$json$Json$Decode$bool);
var $author$project$Api$Provider$CardReader$simulate = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'event',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.ac5)),
					_Utils_Tuple2(
					'card',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.abQ))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CardReader$simulateDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Api$CardReader$simulate = F5(
	function (apiClient, session, id, params, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$CardReader$simulate, apiClient, id, params, toMsg);
	});
var $author$project$Components$CardReader$SimulateForm$simulate = F4(
	function (apiClient, session, cardReaderId, validSimulateFormFields) {
		return A5(
			$author$project$Api$CardReader$simulate,
			apiClient,
			session,
			cardReaderId,
			$rtfeldman$elm_validate$Validate$fromValid(validSimulateFormFields),
			$author$project$Components$CardReader$SimulateForm$GotSimulateResponse);
	});
var $author$project$Components$CardReader$SimulateForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CardReader$SimulateForm$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CardReader$SimulateForm$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm, ov: $author$project$Api$Data$Loading}),
						A4($author$project$Components$CardReader$SimulateForm$simulate, apiClient, model.ZD, model.e8, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var success = response.a;
					var _v5 = success ? _Utils_Tuple2(3, 'Simulation success') : _Utils_Tuple2(1, 'Simulation failed');
					var toastLevel = _v5.a;
					var toastMessage = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ov: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, toastLevel, toastMessage)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ov: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
		}
	});
var $author$project$Components$CardReader$ConnectingModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var _v2 = _Utils_Tuple3(model.V0, model.dx, model.pX);
				if (!_v2.a) {
					if (!_v2.b) {
						var _v3 = _v2.a;
						var _v4 = _v2.b;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$CardReader$ConnectingModal$None,
							y8: _Utils_update(
								model,
								{cE: true}),
							as: _List_Nil
						};
					} else {
						if (_v2.c.$ === 3) {
							var _v7 = _v2.a;
							var _v8 = _v2.c;
							var token = _v8.a;
							return {
								EC: $author$project$Ports$StripeTerminal$cancelReadReusableCard(token),
								ac5: $author$project$Components$CardReader$ConnectingModal$None,
								y8: model,
								as: _List_Nil
							};
						} else {
							return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$CardReader$ConnectingModal$Closed, y8: model, as: _List_Nil};
						}
					}
				} else {
					if (!_v2.b) {
						var _v5 = _v2.a;
						var _v6 = _v2.b;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$CardReader$ConnectingModal$None,
							y8: _Utils_update(
								model,
								{cE: true}),
							as: _List_Nil
						};
					} else {
						var _v9 = _v2.a;
						var _v10 = _v2.b;
						return {
							EC: A3(
								$author$project$Api$Provider$CardReader$cancelReadCard,
								apiClient,
								$author$project$Api$Provider$CardReader$All$id(model.abR),
								$author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
							ac5: $author$project$Components$CardReader$ConnectingModal$None,
							y8: _Utils_update(
								model,
								{cE: true}),
							as: _List_Nil
						};
					}
				}
			case 1:
				var response = msg.a;
				var _v11 = _Utils_Tuple2(model.V0, response);
				if ((!_v11.a) && (_v11.b.$ === 3)) {
					var _v12 = _v11.a;
					var _v13 = _v11.b;
					var token = _v13.a;
					return {
						EC: $author$project$Ports$StripeTerminal$create(token),
						ac5: $author$project$Components$CardReader$ConnectingModal$None,
						y8: _Utils_update(
							model,
							{pX: response}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$CardReader$ConnectingModal$Closed,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var paymentMethodId = response.a;
					return model.cE ? A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
						EC: A2($author$project$Components$CardReader$ConnectingModal$pollReadCardStatus, model.abR, paymentMethodId),
						ac5: $author$project$Components$CardReader$ConnectingModal$None,
						y8: _Utils_update(
							model,
							{dx: 1}),
						as: _List_Nil
					};
				} else {
					return {
						EC: A3(
							$author$project$Api$Provider$CardReader$cancelReadCard,
							apiClient,
							$author$project$Api$Provider$CardReader$All$id(model.abR),
							$author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
						ac5: $author$project$Components$CardReader$ConnectingModal$Closed,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 2:
				var token = msg.a;
				return {
					EC: A3(
						$author$project$Api$Provider$CardReader$retrieve,
						apiClient,
						$author$project$Api$Provider$CardReader$All$id(model.abR),
						$author$project$Components$CardReader$ConnectingModal$GotCardReader(token)),
					ac5: $author$project$Components$CardReader$ConnectingModal$None,
					y8: model,
					as: _List_Nil
				};
			case 3:
				var token = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var cardReader = response.a;
					var _v16 = function () {
						var _v17 = _Utils_Tuple2(
							model.V0,
							$author$project$Api$Provider$CardReader$One$stripeObject(cardReader));
						if (!_v17.a) {
							if (!_v17.b.$) {
								var _v18 = _v17.a;
								var stripeObject = _v17.b.a;
								return _Utils_Tuple2(
									0,
									A2($author$project$Ports$StripeTerminal$connectReader, token, stripeObject));
							} else {
								var _v19 = _v17.a;
								var _v20 = _v17.b;
								return _Utils_Tuple2(0, $elm$core$Platform$Cmd$none);
							}
						} else {
							var _v21 = _v17.a;
							return _Utils_Tuple2(1, $elm$core$Platform$Cmd$none);
						}
					}();
					var connectionStatus = _v16.a;
					var cmd = _v16.b;
					return {
						EC: cmd,
						ac5: $author$project$Components$CardReader$ConnectingModal$None,
						y8: _Utils_update(
							model,
							{dx: connectionStatus}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$CardReader$ConnectingModal$Closed,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var token = msg.a;
				var result = msg.b;
				if (!result.$) {
					return model.cE ? A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
						EC: $author$project$Ports$StripeTerminal$readReusableCard(token),
						ac5: $author$project$Components$CardReader$ConnectingModal$None,
						y8: _Utils_update(
							model,
							{dx: 1}),
						as: _List_Nil
					};
				} else {
					var error = result.a;
					return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
				}
			case 5:
				var cardReadResult = msg.b;
				if (!cardReadResult.$) {
					var paymentMethodId = cardReadResult.a;
					var readCard = {
						Mi: 'via_card_reader',
						U7: !model.Ct,
						V1: $author$project$Api$PaymentProcessorParams$stripeParams(paymentMethodId)
					};
					return A4(
						$author$project$Components$CardReader$ConnectingModal$disconnectReader,
						apiClient,
						model,
						A2(
							$author$project$Ports$LocalStorage$setItem,
							'last-used-card-reader',
							$author$project$Api$Provider$CardReader$All$id(model.abR)),
						$elm$core$Maybe$Just(
							$author$project$Components$CardReader$ConnectingModal$CardRead(readCard)));
				} else {
					var error = cardReadResult.a;
					return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
				}
			case 6:
				var result = msg.b;
				if (!result.$) {
					return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					var error = result.a;
					return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$CardReader$ConnectingModal$Closed,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 8:
				var error = msg.a;
				return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
			case 10:
				var cardReader = msg.a;
				var paymentMethodId = msg.b;
				return {
					EC: A4(
						$author$project$Api$Provider$CardReader$readCardStatus,
						apiClient,
						$author$project$Api$Provider$CardReader$All$id(cardReader),
						paymentMethodId,
						$author$project$Components$CardReader$ConnectingModal$GotReportCardReadStatus(paymentMethodId)),
					ac5: $author$project$Components$CardReader$ConnectingModal$None,
					y8: model,
					as: _List_Nil
				};
			case 11:
				var paymentMethodId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var cardReadStatus = response.a;
					var _v27 = cardReadStatus.ag7;
					switch (_v27) {
						case 'active':
							var readCard = {
								Mi: 'via_card_reader',
								U7: !model.Ct,
								V1: $author$project$Api$PaymentProcessorParams$rainforestParams(paymentMethodId)
							};
							return A4(
								$author$project$Components$CardReader$ConnectingModal$disconnectReader,
								apiClient,
								model,
								A2(
									$author$project$Ports$LocalStorage$setItem,
									'last-used-card-reader',
									$author$project$Api$Provider$CardReader$All$id(model.abR)),
								$elm$core$Maybe$Just(
									$author$project$Components$CardReader$ConnectingModal$CardRead(readCard)));
						case 'canceled':
							return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						case 'failed':
							return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						default:
							return {
								EC: A2($author$project$Components$CardReader$ConnectingModal$pollReadCardStatus, model.abR, paymentMethodId),
								ac5: $author$project$Components$CardReader$ConnectingModal$None,
								y8: model,
								as: _List_Nil
							};
					}
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$CardReader$ConnectingModal$None,
						y8: model,
						as: $author$project$OutMsg$reportDecodeError(response)
					};
				}
			default:
				var subMsg = msg.a;
				var _v28 = model.sU;
				if (!_v28.$) {
					var simulateForm = _v28.a;
					var _v29 = A3($author$project$Components$CardReader$SimulateForm$update, apiClient, subMsg, simulateForm);
					var simulateForm_ = _v29.a;
					var simulateFormCmd = _v29.b;
					var simulateFormOutMsgs = _v29.c;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CardReader$ConnectingModal$SimulateFormMsg, simulateFormCmd),
						ac5: $author$project$Components$CardReader$ConnectingModal$None,
						y8: _Utils_update(
							model,
							{
								sU: $elm$core$Maybe$Just(simulateForm_)
							}),
						as: simulateFormOutMsgs
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$CardReader$ConnectingModal$None, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$CardReader$PaymentModal$Closed = 0;
var $author$project$Components$CardReader$PaymentModal$Connected = 1;
var $author$project$Components$CardReader$PaymentModal$GotReportPaymentReadStatus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CardReader$PaymentModal$None = 4;
var $author$project$Components$CardReader$PaymentModal$PaymentRead = 1;
var $author$project$Components$CardReader$PaymentModal$PaymentReadCancelled = 3;
var $author$project$Components$CardReader$PaymentModal$PaymentReadFailed = 2;
var $author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CardReader$PaymentModal$SimulateFormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CardReader$cancelReadPayment = F4(
	function (apiClient, id, paymentId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_id',
					$elm$json$Json$Encode$string(paymentId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['cancel_read_payment']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Api$CardReader$cancelReadPayment = F5(
	function (apiClient, session, id, paymentId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$CardReader$cancelReadPayment, apiClient, id, paymentId, toMsg);
	});
var $author$project$Components$CardReader$PaymentModal$disconnectReader = F4(
	function (apiClient, model, cmd, event) {
		return {
			EC: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Api$CardReader$cancelReadPayment,
						apiClient,
						model.ZD,
						model.e8,
						$author$project$Api$Payment$id(model.VY),
						$author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
						cmd
					])),
			ac5: A2($elm$core$Maybe$withDefault, 0, event),
			y8: _Utils_update(
				model,
				{cE: false, dx: 0}),
			as: _List_Nil
		};
	});
var $author$project$Components$CardReader$PaymentModal$PollPaymentReadStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus = function (cardReaderId) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$CardReader$PaymentModal$PollPaymentReadStatus(cardReaderId);
		},
		$elm$core$Process$sleep(2000));
};
var $author$project$Api$Provider$CardReader$readPaymentStatus = F4(
	function (apiClient, id, paymentId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Payment$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'payment_id', paymentId)
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['read_payment_status']),
						$author$project$Api$Provider$CardReader$cardReaderPath(id)))));
	});
var $author$project$Api$CardReader$readPaymentStatus = F5(
	function (apiClient, session, id, paymentId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$CardReader$readPaymentStatus,
			apiClient,
			id,
			paymentId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Provider_One)));
	});
var $author$project$Components$CardReader$PaymentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var _v2 = _Utils_Tuple2(model.dx, model.pX);
				if (!_v2.a) {
					var _v3 = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 4,
						y8: _Utils_update(
							model,
							{cE: true}),
						as: _List_Nil
					};
				} else {
					var _v4 = _v2.a;
					return {
						EC: A5(
							$author$project$Api$CardReader$cancelReadPayment,
							apiClient,
							model.ZD,
							model.e8,
							$author$project$Api$Payment$id(model.VY),
							$author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
						ac5: 4,
						y8: _Utils_update(
							model,
							{cE: true}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return model.cE ? A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
						EC: $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus(model.e8),
						ac5: 4,
						y8: _Utils_update(
							model,
							{dx: 1}),
						as: _List_Nil
					};
				} else {
					return {
						EC: A5(
							$author$project$Api$CardReader$cancelReadPayment,
							apiClient,
							model.ZD,
							model.e8,
							$author$project$Api$Payment$id(model.VY),
							$author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					return A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var cardReaderId = msg.a;
				return {
					EC: A5(
						$author$project$Api$CardReader$readPaymentStatus,
						apiClient,
						model.ZD,
						cardReaderId,
						$author$project$Api$Payment$id(model.VY),
						$author$project$Components$CardReader$PaymentModal$GotReportPaymentReadStatus),
					ac5: 4,
					y8: model,
					as: _List_Nil
				};
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var payment = response.a;
					var _v8 = $author$project$Api$Payment$status(payment);
					switch (_v8) {
						case 'paid':
							return A4(
								$author$project$Components$CardReader$PaymentModal$disconnectReader,
								apiClient,
								model,
								A2($author$project$Ports$LocalStorage$setItem, 'last-used-card-reader', model.e8),
								$elm$core$Maybe$Just(1));
						case 'cancelled':
							return A4(
								$author$project$Components$CardReader$PaymentModal$disconnectReader,
								apiClient,
								model,
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(3));
						case 'failed':
							return A4(
								$author$project$Components$CardReader$PaymentModal$disconnectReader,
								apiClient,
								model,
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(2));
						default:
							return {
								EC: $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus(model.e8),
								ac5: 4,
								y8: model,
								as: _List_Nil
							};
					}
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 4,
						y8: model,
						as: $author$project$OutMsg$reportDecodeError(response)
					};
				}
			default:
				var subMsg = msg.a;
				var _v9 = model.sU;
				if (!_v9.$) {
					var simulateForm = _v9.a;
					var _v10 = A3($author$project$Components$CardReader$SimulateForm$update, apiClient, subMsg, simulateForm);
					var simulateForm_ = _v10.a;
					var simulateFormCmd = _v10.b;
					var simulateFormOutMsgs = _v10.c;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CardReader$PaymentModal$SimulateFormMsg, simulateFormCmd),
						ac5: 4,
						y8: _Utils_update(
							model,
							{
								sU: $elm$core$Maybe$Just(simulateForm_)
							}),
						as: simulateFormOutMsgs
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 4, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Ui$Form$SearchableSelect$CustomTrigger = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$SearchableSelect$TypedDebounced = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$SearchableSelect$Closed = {$: 2};
var $author$project$Ui$Form$SearchableSelect$clearText = function (model) {
	return model.yF ? model : _Utils_update(
		model,
		{$A: ''});
};
var $author$project$Ui$Form$SearchableSelect$close = function (model) {
	return _Utils_Tuple3(
		$author$project$Ui$Form$SearchableSelect$clearText(
			_Utils_update(
				model,
				{U9: false})),
		$elm$core$Platform$Cmd$none,
		$elm$core$Maybe$Just($author$project$Ui$Form$SearchableSelect$Closed));
};
var $author$project$Ui$Form$SearchableSelect$DebouncedMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$SearchableSelect$debounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(300),
	ahG: $author$project$Ui$Form$SearchableSelect$DebouncedMsg
};
var $author$project$Ui$Form$SearchableSelect$TextDebounced = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$SearchableSelect$debounceText = function (text) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Ui$Form$SearchableSelect$TextDebounced,
		$elm$core$Task$succeed(text));
};
var $author$project$Ui$Form$SearchableSelect$ElementFocused = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$Form$SearchableSelect$focus = function (elementId) {
	return A2(
		$elm$core$Task$attempt,
		$author$project$Ui$Form$SearchableSelect$ElementFocused(elementId),
		$elm$browser$Browser$Dom$focus(elementId));
};
var $author$project$Ui$Form$SearchableSelect$Selected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$SearchableSelect$selectItem = F2(
	function (maybeItem, model) {
		var _v0 = $author$project$Ui$Form$SearchableSelect$close(model);
		var newModel = _v0.a;
		var newCmd = _v0.b;
		return _Utils_Tuple3(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						newCmd,
						$author$project$Ui$Form$SearchableSelect$focus(model.adR + '-input')
					])),
			$elm$core$Maybe$Just(
				$author$project$Ui$Form$SearchableSelect$Selected(maybeItem)));
	});
var $elm$core$Char$toLower = _Char_toLower;
var $author$project$Ui$Form$SearchableSelect$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var elementId = msg.a;
				var result = msg.b;
				return _Utils_Tuple3(
					model,
					function () {
						var _v1 = _Utils_Tuple2(
							result,
							_Utils_eq(elementId, model.adR + '-item-active'));
						if ((_v1.a.$ === 1) && _v1.b) {
							return $author$project$Ui$Form$SearchableSelect$focus(model.adR + '-item');
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					$elm$core$Maybe$Nothing);
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{U9: !model.U9}),
					$author$project$Ui$Form$SearchableSelect$focus(model.adR + '-input'),
					$elm$core$Maybe$Nothing);
			case 1:
				return $author$project$Ui$Form$SearchableSelect$close(model);
			case 5:
				return $author$project$Ui$Form$SearchableSelect$close(model);
			case 2:
				var keyCode = msg.a;
				if (keyCode === 27) {
					return $author$project$Ui$Form$SearchableSelect$close(model);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 6:
				var maybeItem = msg.a;
				var keyCode = msg.b;
				switch (keyCode) {
					case 27:
						var _v4 = $author$project$Ui$Form$SearchableSelect$close(model);
						var newModel = _v4.a;
						var newCmd = _v4.b;
						var event = _v4.c;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										newCmd,
										$author$project$Ui$Form$SearchableSelect$focus(model.adR + '-input')
									])),
							event);
					case 13:
						return A2($author$project$Ui$Form$SearchableSelect$selectItem, maybeItem, model);
					default:
						var _char = $elm$core$Char$fromCode(keyCode);
						return $elm$core$Char$isAlphaNum(_char) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									$A: $elm$core$String$fromChar(
										$elm$core$Char$toLower(_char))
								}),
							$author$project$Ui$Form$SearchableSelect$focus(model.adR + '-input'),
							$elm$core$Maybe$Nothing) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 4:
				var maybeItem = msg.a;
				return A2($author$project$Ui$Form$SearchableSelect$selectItem, maybeItem, model);
			case 10:
				var id = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ui$Form$SearchableSelect$focus(model.adR + '-input'),
					$elm$core$Maybe$Just(
						$author$project$Ui$Form$SearchableSelect$CustomTrigger(id)));
			case 7:
				var maybeSelected = msg.a;
				var text = msg.b;
				var newText = function () {
					var _v6 = _Utils_Tuple2(maybeSelected, model.U9);
					if ((!_v6.a.$) && (!_v6.b)) {
						var selected = _v6.a.a;
						return (_Utils_cmp(
							$elm$core$String$length(selected),
							$elm$core$String$length(text)) > 0) ? '' : A2($elm$core$String$right, 1, text);
					} else {
						return text;
					}
				}();
				var _v5 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Ui$Form$SearchableSelect$debounceConfig, newText, model.dE);
				var newDebouncer = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dE: newDebouncer, U9: true, $A: newText}),
					cmd,
					$elm$core$Maybe$Nothing);
			case 8:
				var debounceMsg = msg.a;
				var _v7 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Ui$Form$SearchableSelect$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Ui$Form$SearchableSelect$debounceText),
					debounceMsg,
					model.dE);
				var newDebouncer = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dE: newDebouncer}),
					cmd,
					$elm$core$Maybe$Nothing);
			default:
				var text = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(
						$author$project$Ui$Form$SearchableSelect$TypedDebounced(text)));
		}
	});
var $author$project$Components$DateInput$None = {$: 0};
var $author$project$Components$DateInput$Picked = function (a) {
	return {$: 1, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 2, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$EmptyString = {$: 1};
var $agustinrhcp$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$None = {$: 0};
var $agustinrhcp$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.fG;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a4: $elm$core$Maybe$Just(date),
							$P: date
						}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a4: $elm$core$Maybe$Just(date)
						}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 10:
				var date = msg.a;
				var pickable = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a4: $elm$core$Maybe$Just(date),
							jt: pickable
						}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 9:
				var pickable = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jt: pickable}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a4: $elm$core$Maybe$Nothing, ca: $elm$core$Maybe$Nothing, U9: false}),
					$agustinrhcp$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				var _v2 = settings.afz(text);
				if (!_v2.$) {
					var date = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a4: $elm$core$Maybe$Just(date),
								ca: $elm$core$Maybe$Just(text),
								U9: true
							}),
						$agustinrhcp$elm_datepicker$DatePicker$Picked(date));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ca: $elm$core$Maybe$Just(text),
								U9: true
							}),
						$agustinrhcp$elm_datepicker$DatePicker$None);
				}
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $agustinrhcp$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = model.ca;
						if (_v5.$ === 1) {
							return $agustinrhcp$elm_datepicker$DatePicker$FailedInput($agustinrhcp$elm_datepicker$DatePicker$EmptyString);
						} else {
							if (_v5.a === '') {
								return $agustinrhcp$elm_datepicker$DatePicker$FailedInput($agustinrhcp$elm_datepicker$DatePicker$EmptyString);
							} else {
								var rawInput = _v5.a;
								var _v6 = settings.afz(rawInput);
								if (!_v6.$) {
									var date = _v6.a;
									return settings.aed(date) ? $agustinrhcp$elm_datepicker$DatePicker$FailedInput(
										$agustinrhcp$elm_datepicker$DatePicker$Disabled(date)) : $agustinrhcp$elm_datepicker$DatePicker$Picked(date);
								} else {
									var e = _v6.a;
									return $agustinrhcp$elm_datepicker$DatePicker$FailedInput(
										$agustinrhcp$elm_datepicker$DatePicker$Invalid(e));
								}
							}
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a4: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.a4;
									}
								}(),
								ca: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.ca;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fG: false, U9: true}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: forceOpen}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fG: true}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fG: false}),
					$agustinrhcp$elm_datepicker$DatePicker$None);
			default:
				var keyCode = msg.a;
				if (keyCode === 27) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{U9: false}),
						$agustinrhcp$elm_datepicker$DatePicker$None);
				} else {
					return _Utils_Tuple2(model, $agustinrhcp$elm_datepicker$DatePicker$None);
				}
		}
	});
var $author$project$Components$DateInput$update = F2(
	function (msg, model) {
		var datePickerSettings_ = msg.a;
		var subMsg = msg.b;
		var _v1 = A3($agustinrhcp$elm_datepicker$DatePicker$update, datePickerSettings_, subMsg, model.lM);
		var datePicker = _v1.a;
		var datePickerEvent = _v1.b;
		var event = function () {
			_v2$2:
			while (true) {
				switch (datePickerEvent.$) {
					case 2:
						var date_ = datePickerEvent.a;
						return $author$project$Components$DateInput$Picked(
							$elm$core$Maybe$Just(date_));
					case 1:
						if (datePickerEvent.a.$ === 1) {
							var _v3 = datePickerEvent.a;
							return $author$project$Components$DateInput$Picked($elm$core$Maybe$Nothing);
						} else {
							break _v2$2;
						}
					default:
						break _v2$2;
				}
			}
			return $author$project$Components$DateInput$None;
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{lM: datePicker}),
			$elm$core$Platform$Cmd$none,
			event);
	});
var $author$project$Components$Invoice$CreatePaymentModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return {
			EC: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			ac5: 1,
			y8: _Utils_update(
				model,
				{PB: newForm}),
			as: _List_Nil
		};
	});
var $author$project$Components$Invoice$CreatePaymentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 7:
				var response = msg.a;
				return A3(
					$author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch,
					apiClient,
					response,
					_Utils_update(
						model,
						{pN: response}));
			case 8:
				var response = msg.a;
				return A3(
					$author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch,
					apiClient,
					response,
					_Utils_update(
						model,
						{pD: response}));
			case 9:
				var response = msg.a;
				return {
					EC: $author$project$Ports$LocalStorage$getItem('last-used-card-reader'),
					ac5: 1,
					y8: _Utils_update(
						model,
						{hG: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 10:
				var _v2 = msg.a;
				var key = _v2.a;
				var value = _v2.b;
				var _v3 = _Utils_Tuple2(key, value);
				if ((_v3.a === 'last-used-card-reader') && (!_v3.b.$)) {
					var lastUsedCardReaderId = _v3.b.a;
					var cardReader = A2(
						$elm_community$list_extra$List$Extra$find,
						function (cardReader_) {
							return _Utils_eq(
								$author$project$Api$Provider$CardReader$All$id(cardReader_),
								lastUsedCardReaderId);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							$author$project$Api$Data$toMaybe(model.hG)));
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
						$author$project$Components$Invoice$CreatePaymentModal$CardReader(cardReader),
						model.PB);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 11:
				var useExistingSources = msg.a;
				var _v4 = ((!useExistingSources) && _Utils_eq(model.hG, $author$project$Api$Data$NotAsked)) ? _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders(apiClient)) : _Utils_Tuple2(model.hG, $elm$core$Platform$Cmd$none);
				var cardReaders = _v4.a;
				var fetchCardReadersCmd = _v4.b;
				return {
					EC: fetchCardReadersCmd,
					ac5: 1,
					y8: _Utils_update(
						model,
						{hG: cardReaders, V: useExistingSources}),
					as: _List_Nil
				};
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 2:
				var paymentSourceSelectMsg = msg.a;
				var _v5 = A2($author$project$Ui$Form$SearchableSelect$update, paymentSourceSelectMsg, model.r_);
				var selectModel = _v5.a;
				var selectCmd = _v5.b;
				var event = _v5.c;
				var newForm = function () {
					if ((!event.$) && (!event.a.$)) {
						var maybeSource = event.a.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
							$author$project$Components$Invoice$CreatePaymentModal$Source(maybeSource),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSelectMsg, selectCmd),
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm, r_: selectModel}),
					as: _List_Nil
				};
			case 3:
				var cardReaderSelectMsg = msg.a;
				var _v7 = A2($author$project$Ui$Form$SearchableSelect$update, cardReaderSelectMsg, model.pM);
				var selectModel = _v7.a;
				var selectCmd = _v7.b;
				var event = _v7.c;
				var newForm = function () {
					if ((!event.$) && (!event.a.$)) {
						var maybeCardReader = event.a.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate,
							$author$project$Components$Invoice$CreatePaymentModal$CardReader(maybeCardReader),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderSelectMsg, selectCmd),
					ac5: 1,
					y8: _Utils_update(
						model,
						{pM: selectModel, PB: newForm}),
					as: _List_Nil
				};
			case 4:
				var _v9 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Invoice$CreatePaymentModal$formFieldsValidator(model.V),
					model.PB);
				if (!_v9.$) {
					var _v10 = _v9.a;
					var newForm = _v10.a;
					var validFormFields = _v10.b;
					var _v11 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var cardReader = _v11.abR;
					var storeCard = _v11.Ct;
					var _v12 = function () {
						var _v13 = _Utils_Tuple3(
							model.V,
							cardReader,
							$author$project$Api$Practice$paymentProcessor(model.WF));
						if (_v13.a) {
							return _Utils_Tuple3(
								$elm$core$Maybe$Nothing,
								A8($author$project$Components$Invoice$CreatePaymentModal$createPayment, model.zY.O4, model.rX, apiClient, model.ZD, model.afF, validFormFields, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
								$author$project$Api$Data$Loading);
						} else {
							if (!_v13.b.$) {
								if (_v13.c === 'rainforest') {
									var cardReader_ = _v13.b.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										A8(
											$author$project$Components$Invoice$CreatePaymentModal$createPayment,
											model.zY.O4,
											model.rX,
											apiClient,
											model.ZD,
											model.afF,
											validFormFields,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Just(cardReader_)),
										$author$project$Api$Data$Loading);
								} else {
									var cardReader_ = _v13.b.a;
									var owner = function () {
										var _v14 = model.afF;
										switch (_v14.$) {
											case 0:
												var practiceId = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Practice(practiceId);
											case 1:
												var companyId = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Company(companyId);
											case 2:
												var affiliateId = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Affiliate(affiliateId);
											case 3:
												var patientId = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Patient(patientId);
											default:
												var brokerAccountId = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$BrokerAccount(brokerAccountId);
										}
									}();
									return A2(
										$author$project$Utils$Tuple3$fromTuple2,
										model.af,
										A3(
											$elm$core$Tuple$mapBoth,
											function (m) {
												return $elm$core$Maybe$Just(
													_Utils_Tuple2(m, validFormFields));
											},
											$elm$core$Platform$Cmd$map($author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg),
											A7($author$project$Components$CardReader$ConnectingModal$init, apiClient, model.ZD, model.FR, model.sj, cardReader_, owner, storeCard)));
								}
							} else {
								var _v15 = _v13.b;
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, model.af);
							}
						}
					}();
					var cardReaderConnectingModal = _v12.a;
					var cmd = _v12.b;
					var paymentCreatedSaveRequest = _v12.c;
					return {
						EC: cmd,
						ac5: 1,
						y8: _Utils_update(
							model,
							{hF: cardReaderConnectingModal, PB: newForm, af: paymentCreatedSaveRequest}),
						as: _List_Nil
					};
				} else {
					var newForm = _v9.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 5:
				var validFormFields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var payment = response.a;
					var _v17 = function () {
						var _v18 = _Utils_Tuple3(
							$author$project$Api$Payment$cardReader(payment),
							$author$project$Api$Payment$external(payment),
							$author$project$Api$Payment$status(payment));
						if (!_v18.a.$) {
							var cardReader = _v18.a.a;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								$elm$core$Maybe$Nothing,
								A3(
									$elm$core$Tuple$mapBoth,
									function (m) {
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(m, validFormFields));
									},
									$elm$core$Platform$Cmd$map($author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg),
									A6(
										$author$project$Components$CardReader$PaymentModal$init,
										apiClient,
										model.ZD,
										model.FR,
										model.sj,
										$author$project$Api$Provider$CardReader$Shared$id(cardReader),
										payment)));
						} else {
							if (_v18.b) {
								var _v19 = _v18.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Platform$Cmd$none,
									$elm$core$Maybe$Just(
										_Utils_Tuple2('Payment added', 3)));
							} else {
								if (_v18.c === 'failed') {
									var _v20 = _v18.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										$elm$core$Platform$Cmd$none,
										$elm$core$Maybe$Just(
											_Utils_Tuple2('Payment failed', 1)));
								} else {
									var _v21 = _v18.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										$elm$core$Platform$Cmd$none,
										$elm$core$Maybe$Just(
											_Utils_Tuple2('Payment processed successfully', 3)));
								}
							}
						}
					}();
					var cardReaderPaymentModal = _v17.a;
					var cardReaderPaymentModalCmd = _v17.b;
					var message = _v17.c;
					return {
						EC: cardReaderPaymentModalCmd,
						ac5: _Utils_eq(cardReaderPaymentModal, $elm$core$Maybe$Nothing) ? 2 : 1,
						y8: _Utils_update(
							model,
							{bS: cardReaderPaymentModal, af: $author$project$Api$Data$NotAsked}),
						as: A2(
							$elm$core$List$append,
							_List_fromArray(
								[$author$project$OutMsg$RefreshPatientsList]),
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (_v22) {
										var toastMessage_ = _v22.a;
										var toastLevel_ = _v22.b;
										return _List_fromArray(
											[
												A2($author$project$OutMsg$ShowToast, toastLevel_, toastMessage_)
											]);
									},
									message)))
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{af: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 6:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$Invoice$CreatePaymentModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg,
					$author$project$Components$Invoice$CreatePaymentModal$PaidAt,
					function ($) {
						return $.Vt;
					});
			case 12:
				var subMsg = msg.a;
				var _v23 = model.hF;
				if (!_v23.$) {
					var _v24 = _v23.a;
					var cardReaderConnectingModal = _v24.a;
					var validFormFields = _v24.b;
					var cardReaderConnectingModalResult = A3($author$project$Components$CardReader$ConnectingModal$update, apiClient, subMsg, cardReaderConnectingModal);
					var _v25 = function () {
						var _v26 = cardReaderConnectingModalResult.ac5;
						switch (_v26.$) {
							case 1:
								var card = _v26.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A5($author$project$Components$Invoice$CreatePaymentModal$createCard, model.Hh, apiClient, model.ZD, validFormFields, card));
							case 0:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.af, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(cardReaderConnectingModalResult.y8, validFormFields)),
									model.af,
									$elm$core$Platform$Cmd$none);
						}
					}();
					var cardReaderConnectingModal_ = _v25.a;
					var paymentCreatedSaveRequest = _v25.b;
					var cmd = _v25.c;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg, cardReaderConnectingModalResult.EC),
									cmd
								])),
						ac5: 1,
						y8: _Utils_update(
							model,
							{hF: cardReaderConnectingModal_, af: paymentCreatedSaveRequest}),
						as: cardReaderConnectingModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 13:
				var subMsg = msg.a;
				var _v27 = model.bS;
				if (!_v27.$) {
					var _v28 = _v27.a;
					var cardReaderPaymentModal = _v28.a;
					var validFormFields = _v28.b;
					var cardReaderPaymentModalResult = A3($author$project$Components$CardReader$PaymentModal$update, apiClient, subMsg, cardReaderPaymentModal);
					var _v29 = cardReaderPaymentModalResult.ac5;
					switch (_v29) {
						case 1:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 2,
								y8: _Utils_update(
									model,
									{bS: $elm$core$Maybe$Nothing, af: $author$project$Api$Data$NotAsked}),
								as: _Utils_ap(
									cardReaderPaymentModalResult.as,
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, 'Payment processed successfully'),
											$author$project$OutMsg$RefreshPatientsList
										]))
							};
						case 3:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 2,
								y8: _Utils_update(
									model,
									{bS: $elm$core$Maybe$Nothing, af: $author$project$Api$Data$NotAsked}),
								as: _Utils_ap(
									cardReaderPaymentModalResult.as,
									_List_fromArray(
										[$author$project$OutMsg$RefreshPatientsList]))
							};
						case 2:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 2,
								y8: _Utils_update(
									model,
									{bS: $elm$core$Maybe$Nothing, af: $author$project$Api$Data$NotAsked}),
								as: _Utils_ap(
									cardReaderPaymentModalResult.as,
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 1, 'Payment failed'),
											$author$project$OutMsg$RefreshPatientsList
										]))
							};
						case 0:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 1,
								y8: _Utils_update(
									model,
									{bS: $elm$core$Maybe$Nothing, af: $author$project$Api$Data$NotAsked}),
								as: cardReaderPaymentModalResult.as
							};
						default:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 1,
								y8: _Utils_update(
									model,
									{
										bS: $elm$core$Maybe$Just(
											_Utils_Tuple2(cardReaderPaymentModalResult.y8, validFormFields))
									}),
								as: cardReaderPaymentModalResult.as
							};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			default:
				var validFormFields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var card = response.a;
					return {
						EC: A8(
							$author$project$Components$Invoice$CreatePaymentModal$createPayment,
							model.zY.O4,
							model.rX,
							apiClient,
							model.ZD,
							model.afF,
							validFormFields,
							$elm$core$Maybe$Just(card),
							$elm$core$Maybe$Nothing),
						ac5: 1,
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{af: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Invoice$DownloadFile$AvailableOptionSelected = 1;
var $author$project$Components$Invoice$DownloadFile$DownloadFileClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$DownloadFile$GotFile = 3;
var $author$project$Components$Invoice$DownloadFile$GotToken = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$DownloadFile$None = 0;
var $author$project$Components$Invoice$DownloadFile$PollFile = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$DownloadFile$UnavailableOptionSelected = 2;
var $author$project$Components$Invoice$DownloadFile$GotFileStatus = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$File$File = $elm$core$Basics$identity;
var $author$project$Api$File$Record = F2(
	function (processing, url) {
		return {W7: processing, aav: url};
	});
var $author$project$Api$File$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'processing',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$File$Record)));
var $author$project$Api$File$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$File$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$File$Token$toString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Api$File$retrievePath = function (token) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[
				'files',
				$author$project$Api$File$Token$toString(token)
			]),
		$author$project$Api$Data$providerPath);
};
var $author$project$Api$File$generate = F3(
	function (apiClient, token, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$File$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['generate']),
					$author$project$Api$File$retrievePath(token))));
	});
var $author$project$Components$Invoice$DownloadFile$generateFile = F3(
	function (model, apiClient, token) {
		return model.R0 ? A3(
			$author$project$Api$File$generate,
			apiClient,
			token,
			$author$project$Components$Invoice$DownloadFile$GotFileStatus(token)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Api$File$isProcessing = function (_v0) {
	var record = _v0;
	return record.W7;
};
var $author$project$Ports$Navigation$navigationPortOpenInNewWindow = _Platform_outgoingPort('navigationPortOpenInNewWindow', $elm$json$Json$Encode$string);
var $author$project$Ports$Navigation$openInNewWindow = $author$project$Ports$Navigation$navigationPortOpenInNewWindow;
var $author$project$Api$Provider$File$One$File = $elm$core$Basics$identity;
var $author$project$Api$Provider$File$One$Record = function (token) {
	return {$Q: token};
};
var $author$project$Api$Provider$File$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'token',
	$author$project$Api$File$Token$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$File$One$Record));
var $author$project$Api$Provider$File$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$File$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$File$retrieveToken = F4(
	function (apiClient, path, options, toMsg) {
		var lte = (options.F2 === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(options.F2);
		var gte = (options.Fu === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(options.Fu);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('account_statement')),
					_Utils_Tuple2(
					'options',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'date',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'gte',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, gte)),
											_Utils_Tuple2(
											'lte',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, lte))
										])))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$File$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['files']),
						path))));
	});
var $author$project$Api$Provider$File$One$token = function (_v0) {
	var record = _v0;
	return record.$Q;
};
var $author$project$Api$File$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Components$Invoice$DownloadFile$update = F3(
	function (apiClient, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 6:
					var path = msg.a;
					var options = msg.b;
					return {
						EC: A4($author$project$Api$File$retrieveToken, apiClient, path, options, $author$project$Components$Invoice$DownloadFile$GotToken),
						ac5: 0,
						y8: model,
						as: _List_Nil
					};
				case 7:
					var response = msg.a;
					switch (response.$) {
						case 3:
							var file = response.a;
							var $temp$apiClient = apiClient,
								$temp$msg = $author$project$Components$Invoice$DownloadFile$DownloadFileClicked(
								$author$project$Api$Provider$File$One$token(file)),
								$temp$model = model;
							apiClient = $temp$apiClient;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: model,
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
					}
				case 0:
					var token = msg.a;
					var newModel = _Utils_update(
						model,
						{R0: true});
					return {
						EC: A3($author$project$Components$Invoice$DownloadFile$generateFile, newModel, apiClient, token),
						ac5: 1,
						y8: newModel,
						as: _List_Nil
					};
				case 1:
					var token = msg.a;
					var response = msg.b;
					if (response.$ === 3) {
						var fileStatus = response.a;
						return $author$project$Api$File$isProcessing(fileStatus) ? {
							EC: A2(
								$elm$core$Task$perform,
								function (_v3) {
									return $author$project$Components$Invoice$DownloadFile$PollFile(token);
								},
								$elm$core$Process$sleep(2000)),
							ac5: 0,
							y8: _Utils_update(
								model,
								{R0: true}),
							as: _List_Nil
						} : {
							EC: A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									$author$project$Ports$Navigation$openInNewWindow,
									$author$project$Api$File$url(fileStatus))),
							ac5: 3,
							y8: _Utils_update(
								model,
								{R0: false}),
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: model,
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				case 2:
					var token = msg.a;
					return {
						EC: A3($author$project$Components$Invoice$DownloadFile$generateFile, model, apiClient, token),
						ac5: 0,
						y8: model,
						as: _List_Nil
					};
				case 3:
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{R0: false}),
						as: _List_Nil
					};
				case 4:
					var subMsg = msg.a;
					var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, model.fy);
					var newDropdown = _v4.a;
					var dropdownCmd = _v4.b;
					return {
						EC: dropdownCmd,
						ac5: 0,
						y8: _Utils_update(
							model,
							{fy: newDropdown}),
						as: _List_Nil
					};
				default:
					return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
			}
		}
	});
var $author$project$Components$Invoice$PaymentsHistory$DisputeSimulated = 4;
var $author$project$Components$Invoice$PaymentsHistory$None = 0;
var $author$project$Components$Invoice$PaymentsHistory$PaymentCancelled = 2;
var $author$project$Components$Invoice$PaymentsHistory$RefundCancelled = 3;
var $author$project$Components$Invoice$PaymentsHistory$RefundCreated = 1;
var $author$project$Components$PaymentsList$DisputeSimulated = 4;
var $author$project$Components$PaymentsList$GotCancelPayment = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$PaymentsList$GotRefundCancelled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$PaymentsList$None = 0;
var $author$project$Api$Platform$RainforestSession$Payment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentsList$PaymentCancelled = 2;
var $author$project$Components$PaymentsList$PaymentDisputeModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PaymentsList$RainforestPaymentModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Platform$RainforestSession$Refund = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentsList$RefundCancelled = 3;
var $author$project$Components$PaymentsList$RefundCreated = 1;
var $author$project$Api$Payment$paymentPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Payment$paymentsPath(basePath));
	});
var $author$project$Api$Payment$cancel = F5(
	function (basePath, apiClient, session, id_, toMsg) {
		return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Payment$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Employer_One))) : A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Payment$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Payment$Provider_One))))(
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					A2($author$project$Api$Payment$paymentPath, basePath, id_))));
	});
var $author$project$Api$Provider$Refund$refundsPath = function (paymentPath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['refunds']),
		paymentPath);
};
var $author$project$Api$Provider$Refund$refundPath = F2(
	function (paymentsPath, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Refund$refundsPath(paymentsPath));
	});
var $author$project$Api$Provider$Refund$cancel = F4(
	function (paymentPath, apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Refund$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					A2($author$project$Api$Provider$Refund$refundPath, paymentPath, id))));
	});
var $author$project$Api$Employer$Refund$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Refund$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Refund$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$id(shared);
};
var $author$project$Api$Refund$id = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$id(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$id(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$id(refund_);
	}
};
var $author$project$Components$Invoice$RefundModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Employer$Payment$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Employer$Payment$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Payment$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Payment$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$amountInCents(shared);
};
var $author$project$Api$Payment$amountInCents = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$amountInCents(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$amountInCents(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$amountInCents(payment_);
	}
};
var $author$project$Components$Invoice$RefundModal$formFieldsFromPayment = function (payment) {
	return {
		I2: $elm$core$Maybe$Just(
			$author$project$Currency$fromInt(
				$author$project$Api$Payment$amountInCents(payment))),
		aeC: $elm$core$Maybe$Nothing,
		no: $author$project$Api$Payment$amountInCents(payment)
	};
};
var $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor = function (_v0) {
	var record = _v0;
	return record.R4;
};
var $author$project$Api$Provider$Payment$One$isRefundableOnPaymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundableOnPaymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor(shared);
};
var $author$project$Api$Payment$isRefundableOnPaymentProcessor = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$isRefundableOnPaymentProcessor(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundableOnPaymentProcessor(payment_);
		default:
			return false;
	}
};
var $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment = function (payment) {
	return (!$author$project$Api$Payment$isRefundableOnPaymentProcessor(payment)) && (!$author$project$Api$Payment$external(payment));
};
var $author$project$Components$Invoice$RefundModal$isExternalRefund = function (payment) {
	var oldPaymentProcessorPayment = $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment(payment);
	var externalPayment = $author$project$Api$Payment$external(payment);
	return externalPayment || oldPaymentProcessorPayment;
};
var $author$project$Components$Invoice$RefundModal$init = F4(
	function (timeFormatter, paymentPath, allowPartialRefunds, payment) {
		return {
			vl: allowPartialRefunds,
			qC: $author$project$Components$Invoice$RefundModal$isExternalRefund(payment),
			PB: $author$project$Utils$Form$init(
				$author$project$Components$Invoice$RefundModal$formFieldsFromPayment(payment)),
			Gl: $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment(payment),
			VY: payment,
			rX: paymentPath,
			jY: $author$project$Api$Data$NotAsked,
			Hy: timeFormatter
		};
	});
var $author$project$Components$PaymentDisputeModal$Loading = {$: 2};
var $author$project$Components$PaymentDisputeModal$GotDisputes = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Dispute$All$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Provider$Dispute$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Dispute$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Dispute$disputesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['disputes']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Sort$Model = $elm$core$Basics$identity;
var $author$project$Api$Sort$init = {M5: $elm$core$Maybe$Nothing, A7: '', aaN: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Dispute$listDefaults = {afy: $author$project$Api$Pagination$init, GE: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Sort$pageParamName = function (prefix) {
	return prefix + 'sort';
};
var $author$project$Api$Sort$valueOrDefault = function (_v0) {
	var model = _v0;
	var _v1 = _Utils_Tuple2(model.aaN, model.M5);
	if (!_v1.a.$) {
		var value = _v1.a.a;
		return $elm$core$Maybe$Just(value);
	} else {
		var _v2 = _v1.a;
		var _default = _v1.b;
		return _default;
	}
};
var $author$project$Api$Sort$toPrefixeddParams = F2(
	function (prefix, _v0) {
		var model = _v0;
		var _v1 = $author$project$Api$Sort$valueOrDefault(model);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var column = _v2.a;
			var direction = _v2.b;
			var sortParam = function () {
				if (!direction) {
					return column;
				} else {
					return '-' + column;
				}
			}();
			return _List_fromArray(
				[
					A2(
					$author$project$Api$Param$string,
					$author$project$Api$Sort$pageParamName(prefix),
					sortParam)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Api$Sort$toParams = $author$project$Api$Sort$toPrefixeddParams('');
var $author$project$Api$Provider$Dispute$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Dispute$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Param$string('payment'),
						$elm$core$List$singleton),
					options.GE)),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Param$string('status'),
						$elm$core$List$singleton),
					options.ag7))
			]));
};
var $author$project$Api$Provider$Dispute$list = F3(
	function (apiClient, query, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Dispute$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Dispute$listOptionsToParams(query),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Dispute$disputesPath)));
	});
var $author$project$Components$PaymentDisputeModal$fetchDisputes = F2(
	function (client, paymentId) {
		return A3(
			$author$project$Api$Provider$Dispute$list,
			client,
			function (q) {
				return _Utils_update(
					q,
					{
						GE: $elm$core$Maybe$Just(paymentId)
					});
			},
			$author$project$Components$PaymentDisputeModal$GotDisputes);
	});
var $author$project$Components$PaymentDisputeModal$init = F2(
	function (client, paymentId) {
		return _Utils_Tuple2(
			{NQ: $author$project$Components$PaymentDisputeModal$Loading},
			A2($author$project$Components$PaymentDisputeModal$fetchDisputes, client, paymentId));
	});
var $author$project$Components$Rainforest$SessionModal$GotSession = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$SessionModal$Loading = {$: 0};
var $author$project$Api$Platform$RainforestSession$RainforestSession = F4(
	function (rainforestResourceId, rainforestSessionKey, rainforestResourceType, rainforestParentResourceId) {
		return {af$: rainforestParentResourceId, af0: rainforestResourceId, af1: rainforestResourceType, af2: rainforestSessionKey};
	});
var $author$project$Api$Platform$RainforestSession$decodeSession = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rainforest_parent_resource_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rainforest_resource_type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rainforest_session_key',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rainforest_resource_id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Platform$RainforestSession$RainforestSession)))));
var $author$project$Api$Platform$RainforestSession$rainforestSessionsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['rainforest_sessions']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$RainforestSession$create = F3(
	function (apiClient, resource, toMsg) {
		var _v0 = function () {
			switch (resource.$) {
				case 0:
					var depositId = resource.a;
					return _Utils_Tuple2('deposit', depositId);
				case 1:
					var paymentId = resource.a;
					return _Utils_Tuple2('payment', paymentId);
				default:
					var refundId = resource.a;
					return _Utils_Tuple2('refund', refundId);
			}
		}();
		var resoourceType = _v0.a;
		var resoourceId = _v0.b;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'resource_type',
					$elm$json$Json$Encode$string(resoourceType)),
					_Utils_Tuple2(
					'resource_id',
					$elm$json$Json$Encode$string(resoourceId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$RainforestSession$decodeSession,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$RainforestSession$rainforestSessionsPath)));
	});
var $author$project$Components$Rainforest$SessionModal$init = F2(
	function (client, resource) {
		return _Utils_Tuple2(
			{G0: resource, ZD: $author$project$Components$Rainforest$SessionModal$Loading},
			A3($author$project$Api$Platform$RainforestSession$create, client, resource, $elm$core$Basics$identity));
	});
var $author$project$Components$Rainforest$SimulateDisputeEventModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus = 'WON';
var $author$project$Components$Rainforest$SimulateDisputeEventModal$init = F4(
	function (basePath, session, payment, dispute) {
		return _Utils_Tuple2(
			{vD: basePath, NQ: dispute, VY: payment, ZD: session, ou: $author$project$Api$Data$NotAsked, ag7: $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Rainforest$SimulateDisputeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus = 'DISPUTE_ACTION_REQUIRED';
var $author$project$Components$Rainforest$SimulateDisputeModal$init = F3(
	function (basePath, session, payment) {
		return _Utils_Tuple2(
			{vD: basePath, VY: payment, ZD: session, ov: $author$project$Api$Data$NotAsked, ag7: $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Invoice$RefundModal$Closed = 0;
var $author$project$Components$Invoice$RefundModal$None = 1;
var $author$project$Components$Invoice$RefundModal$RefundCreated = 2;
var $author$project$Components$Invoice$RefundModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Refund$create = F4(
	function (paymentPath, apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'refund',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'amount_in_cents',
								$author$project$Currency$encode(fields.I2)),
								_Utils_Tuple2(
								'memo',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aeC)),
								_Utils_Tuple2(
								'external',
								$elm$json$Json$Encode$bool(fields.O4))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Refund$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Refund$refundsPath(paymentPath))));
	});
var $author$project$Components$Invoice$RefundModal$createRefund = F4(
	function (paymentPath, apiClient, formFields, externalRefund) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Refund$create,
			paymentPath,
			apiClient,
			{
				I2: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Currency$fromInt(fields.no),
					fields.I2),
				O4: externalRefund,
				aeC: fields.aeC
			},
			$author$project$Components$Invoice$RefundModal$Created);
	});
var $author$project$Components$Invoice$RefundModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var _int = field.a;
			return _Utils_update(
				fields,
				{I2: _int});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					aeC: $author$project$Utils$String$toMaybe(string)
				});
		}
	});
var $author$project$Components$Invoice$RefundModal$AmountInCentsValidation = 0;
var $author$project$Components$Invoice$RefundModal$validateAmountInCents = function (fields) {
	return A2(
		$author$project$Utils$Validate$isInvalidCurrency,
		{
			abi: false,
			yQ: $elm$core$Maybe$Just(fields.no),
			TZ: $elm$core$Maybe$Just(100)
		},
		fields.I2) ? _List_fromArray(
		[
			_Utils_Tuple2(
			0,
			'Please enter an amount between $1.00 and ' + ($author$project$Utils$Currency$fromInt(fields.no) + '.'))
		]) : _List_Nil;
};
var $author$project$Components$Invoice$RefundModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$RefundModal$validateAmountInCents)
		]));
var $author$project$Components$Invoice$RefundModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$RefundModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 2:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$RefundModal$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					return {
						EC: A4($author$project$Components$Invoice$RefundModal$createRefund, model.rX, apiClient, validFormFields, model.qC),
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm, jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Refund successfully created')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$PaymentDisputeModal$DisputeModalMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentDisputeModal$Failed = {$: 3};
var $author$project$Components$PaymentDisputeModal$First = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentDisputeModal$NoDisputes = {$: 1};
var $author$project$Api$Provider$Dispute$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Dispute$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Dispute$Shared$id(shared);
};
var $author$project$Components$DisputeModal$GotSession = $elm$core$Basics$identity;
var $author$project$Components$DisputeModal$Loading = {$: 0};
var $author$project$Api$Platform$Dispute$Session$Rainforest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Dispute$Session$RainforestSession = F2(
	function (chargebackId, sessionKey) {
		return {ab0: chargebackId, agS: sessionKey};
	});
var $author$project$Api$Platform$Dispute$Session$Stripe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Platform$Dispute$Session$StripeSession = F2(
	function (chargeId, sessionKey) {
		return {abW: chargeId, agS: sessionKey};
	});
var $author$project$Api$Platform$Dispute$Session$decodeSession = A2(
	$elm$json$Json$Decode$andThen,
	function (processor) {
		switch (processor) {
			case 'rainforest':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Platform$Dispute$Session$Rainforest,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'session_key',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'chargeback_id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$Session$RainforestSession))));
			case 'stripe':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Platform$Dispute$Session$Stripe,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'session_key',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'charge_id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$Session$StripeSession))));
			default:
				return $elm$json$Json$Decode$fail('Unsupported processor ' + processor);
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['payment_processor']),
		$elm$json$Json$Decode$string));
var $author$project$Api$Platform$Dispute$Session$disputesPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['disputes']),
		basePath);
};
var $author$project$Api$Platform$Dispute$Session$retrieve = F4(
	function (basePath, apiClient, disputeId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Dispute$Session$decodeSession,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[disputeId, 'session']),
					$author$project$Api$Platform$Dispute$Session$disputesPath(basePath))));
	});
var $author$project$Components$DisputeModal$init = F3(
	function (basePath, client, disputeId) {
		return _Utils_Tuple2(
			{NQ: $author$project$Components$DisputeModal$Loading},
			A4($author$project$Api$Platform$Dispute$Session$retrieve, basePath, client, disputeId, $elm$core$Basics$identity));
	});
var $author$project$Components$DisputeModal$Failed = {$: 1};
var $author$project$Components$DisputeModal$Session = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$Stripe$stripePortMountPaymentDisputesComponent = _Platform_outgoingPort(
	'stripePortMountPaymentDisputesComponent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'chargeId',
					$elm$json$Json$Encode$string($.abW)),
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.be)),
					_Utils_Tuple2(
					'stripeClientSecret',
					$elm$json$Json$Encode$string($.oC))
				]));
	});
var $author$project$Ports$Stripe$mountPaymentDisputesComponent = F3(
	function (selector, stripeClientSecret, chargeId) {
		return $author$project$Ports$Stripe$stripePortMountPaymentDisputesComponent(
			{abW: chargeId, be: selector, oC: stripeClientSecret});
	});
var $author$project$Components$DisputeModal$update = F2(
	function (msg, model) {
		var response = msg;
		switch (response.$) {
			case 3:
				var session = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							NQ: $author$project$Components$DisputeModal$Session(session)
						}),
					function () {
						if (!session.$) {
							return $elm$core$Platform$Cmd$none;
						} else {
							var stripeSession = session.a;
							return A3($author$project$Ports$Stripe$mountPaymentDisputesComponent, '#stripe-payment-disputes-' + stripeSession.abW, stripeSession.agS, stripeSession.abW);
						}
					}(),
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{NQ: $author$project$Components$DisputeModal$Failed}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$PaymentDisputeModal$update = F3(
	function (client, msg, model) {
		if (!msg.$) {
			var response = msg.a;
			switch (response.$) {
				case 3:
					var disputes = response.a;
					var _v2 = $elm$core$List$head(disputes);
					if (!_v2.$) {
						var dispute = _v2.a;
						var _v3 = A3(
							$author$project$Components$DisputeModal$init,
							$author$project$Api$Data$providerPath,
							client,
							$author$project$Api$Provider$Dispute$All$id(dispute));
						var disputeModal = _v3.a;
						var disputeCmd = _v3.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									NQ: $author$project$Components$PaymentDisputeModal$First(disputeModal)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentDisputeModal$DisputeModalMsg, disputeCmd),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{NQ: $author$project$Components$PaymentDisputeModal$NoDisputes}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				case 2:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{NQ: $author$project$Components$PaymentDisputeModal$Failed}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				default:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var subMsg = msg.a;
			var _v4 = model.NQ;
			if (!_v4.$) {
				var disputeModal = _v4.a;
				var _v5 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
				var newDisputeModal = _v5.a;
				var disputeModalCmd = _v5.b;
				var disputeModalOutMsgs = _v5.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							NQ: $author$project$Components$PaymentDisputeModal$First(newDisputeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentDisputeModal$DisputeModalMsg, disputeModalCmd),
					disputeModalOutMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Rainforest$SessionModal$Failed = {$: 1};
var $author$project$Components$Rainforest$SessionModal$Loaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Rainforest$SessionModal$update = F2(
	function (msg, model) {
		var response = msg;
		switch (response.$) {
			case 3:
				var session = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ZD: $author$project$Components$Rainforest$SessionModal$Loaded(session)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ZD: $author$project$Components$Rainforest$SessionModal$Failed}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Rainforest$SimulateDisputeEventModal$Closed = 2;
var $author$project$Components$Rainforest$SimulateDisputeEventModal$DisputeSimulated = 1;
var $author$project$Components$Rainforest$SimulateDisputeEventModal$GotSimulateDisputeEventResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Rainforest$SimulateDisputeEventModal$None = 0;
var $author$project$Api$Provider$Dispute$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Dispute$Shared$id(shared);
};
var $author$project$Api$Dispute$id = function (dispute) {
	if (!dispute.$) {
		var dispute_ = dispute.a;
		return $author$project$Api$Provider$Dispute$One$id(dispute_);
	} else {
		var dispute_ = dispute.a;
		return $author$project$Api$Provider$Dispute$Shared$id(dispute_);
	}
};
var $author$project$Api$Dispute$Provider_One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Dispute$One$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Provider$Dispute$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Dispute$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Payment$Dispute$paymentsDisputesPath = F2(
	function (basePath, paymentId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['disputes']),
			A2($author$project$Api$Payment$paymentPath, basePath, paymentId));
	});
var $author$project$Api$Payment$Dispute$paymentsDisputePath = F3(
	function (basePath, paymentId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			A2($author$project$Api$Payment$Dispute$paymentsDisputesPath, basePath, paymentId));
	});
var $author$project$Api$Payment$Dispute$simulateEvent = F7(
	function (basePath, apiClient, session, paymentId, disputeId, status, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(status))
				]));
		return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Basics$always($elm$core$Platform$Cmd$none) : A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Dispute$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Dispute$Provider_One))))(
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate_event']),
						A3($author$project$Api$Payment$Dispute$paymentsDisputePath, basePath, paymentId, disputeId)))));
	});
var $author$project$Components$Rainforest$SimulateDisputeEventModal$statuses = _List_fromArray(
	['DISPUTE_ACTION_REQUIRED', 'PROVISIONAL_WIN', 'WON', 'LOST']);
var $author$project$Components$Rainforest$SimulateDisputeEventModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
			case 1:
				var inputStatus = msg.a;
				var selectedStatus = A2(
					$elm_community$list_extra$List$Extra$find,
					function (status_) {
						return _Utils_eq(status_, inputStatus);
					},
					$author$project$Components$Rainforest$SimulateDisputeEventModal$statuses);
				var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus, selectedStatus);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{ag7: status}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: A7(
						$author$project$Api$Payment$Dispute$simulateEvent,
						model.vD,
						apiClient,
						model.ZD,
						$author$project$Api$Payment$id(model.VY),
						$author$project$Api$Dispute$id(model.NQ),
						model.ag7,
						$author$project$Components$Rainforest$SimulateDisputeEventModal$GotSimulateDisputeEventResponse),
					ac5: 0,
					y8: _Utils_update(
						model,
						{ou: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{ou: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Dispute event simulated successfully')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{ou: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Rainforest$SimulateDisputeModal$Closed = 2;
var $author$project$Components$Rainforest$SimulateDisputeModal$DisputeSimulated = 1;
var $author$project$Components$Rainforest$SimulateDisputeModal$GotSimulateDisputeResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Rainforest$SimulateDisputeModal$None = 0;
var $author$project$Api$Payment$Dispute$simulate = F6(
	function (basePath, apiClient, session, paymentId, status, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(status))
				]));
		return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Basics$always($elm$core$Platform$Cmd$none) : A3(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Dispute$One$decoder,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Dispute$Provider_One))))(
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate']),
						A2($author$project$Api$Payment$Dispute$paymentsDisputesPath, basePath, paymentId)))));
	});
var $author$project$Components$Rainforest$SimulateDisputeModal$statuses = _List_fromArray(
	['DISPUTE_ACTION_REQUIRED', 'INQUIRY_ACTION_REQUIRED']);
var $author$project$Components$Rainforest$SimulateDisputeModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
			case 1:
				var inputStatus = msg.a;
				var selectedStatus = A2(
					$elm_community$list_extra$List$Extra$find,
					function (status_) {
						return _Utils_eq(status_, inputStatus);
					},
					$author$project$Components$Rainforest$SimulateDisputeModal$statuses);
				var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus, selectedStatus);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{ag7: status}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: A6(
						$author$project$Api$Payment$Dispute$simulate,
						model.vD,
						apiClient,
						model.ZD,
						$author$project$Api$Payment$id(model.VY),
						model.ag7,
						$author$project$Components$Rainforest$SimulateDisputeModal$GotSimulateDisputeResponse),
					ac5: 0,
					y8: _Utils_update(
						model,
						{ov: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{ov: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Dispute simulated successfully')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{ov: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$PaymentsList$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var payment = msg.a;
				var paymentPath = A2(
					$author$project$Api$Payment$paymentPath,
					model.vD,
					$author$project$Api$Payment$id(payment));
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							jK: $elm$core$Maybe$Just(
								A4($author$project$Components$Invoice$RefundModal$init, model.Hy, paymentPath, model.vl, payment))
						}),
					as: _List_Nil
				};
			case 4:
				var subMsg = msg.a;
				var _v1 = model.gh;
				if (!_v1.$) {
					var paymentDisputeModal = _v1.a;
					var _v2 = A3($author$project$Components$PaymentDisputeModal$update, apiClient, subMsg, paymentDisputeModal);
					var newPaymentDisputeModal = _v2.a;
					var paymentDisputeModalCmd = _v2.b;
					var paymentDisputeModalOutMsgs = _v2.c;
					return function (m) {
						return {
							EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$PaymentDisputeModalMsg, paymentDisputeModalCmd),
							ac5: 0,
							y8: m,
							as: paymentDisputeModalOutMsgs
						};
					}(
						_Utils_update(
							model,
							{
								gh: $elm$core$Maybe$Just(newPaymentDisputeModal)
							}));
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 1:
				var subMsg = msg.a;
				var _v3 = model.jK;
				if (!_v3.$) {
					var refundModal = _v3.a;
					var refundModalResult = A3($author$project$Components$Invoice$RefundModal$update, apiClient, subMsg, refundModal);
					var _v4 = function () {
						var _v5 = refundModalResult.ac5;
						switch (_v5) {
							case 0:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 1:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(refundModalResult.y8),
									0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
						}
					}();
					var refundModal_ = _v4.a;
					var event = _v4.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RefundModalMsg, refundModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{jK: refundModal_}),
						as: refundModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 2:
				var payment = msg.a;
				var _v6 = A2(
					$author$project$Components$PaymentDisputeModal$init,
					apiClient,
					$author$project$Api$Payment$id(payment));
				var paymentDisputeModal = _v6.a;
				var paymentDisputeModalCmd = _v6.b;
				return function (m) {
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$PaymentDisputeModalMsg, paymentDisputeModalCmd),
						ac5: 0,
						y8: m,
						as: _List_Nil
					};
				}(
					_Utils_update(
						model,
						{
							gh: $elm$core$Maybe$Just(paymentDisputeModal)
						}));
			case 3:
				return function (m) {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: m, as: _List_Nil};
				}(
					_Utils_update(
						model,
						{gh: $elm$core$Maybe$Nothing}));
			case 5:
				var payment = msg.a;
				var _v7 = A2(
					$author$project$Components$Rainforest$SessionModal$init,
					apiClient,
					$author$project$Api$Platform$RainforestSession$Payment(
						$author$project$Api$Payment$id(payment)));
				var rainforestPaymentModal = _v7.a;
				var rainforestPaymentModalCmd = _v7.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							eq: $elm$core$Maybe$Just(rainforestPaymentModal)
						}),
					as: _List_Nil
				};
			case 8:
				var refund = msg.a;
				var _v8 = A2(
					$author$project$Components$Rainforest$SessionModal$init,
					apiClient,
					$author$project$Api$Platform$RainforestSession$Refund(
						$author$project$Api$Refund$id(refund)));
				var rainforestPaymentModal = _v8.a;
				var rainforestPaymentModalCmd = _v8.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							eq: $elm$core$Maybe$Just(rainforestPaymentModal)
						}),
					as: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var _v9 = model.eq;
				if (!_v9.$) {
					var rainforestPaymentModal = _v9.a;
					var _v10 = A2($author$project$Components$Rainforest$SessionModal$update, subMsg, rainforestPaymentModal);
					var newRainforestPaymentModal = _v10.a;
					var rainforestPaymentModalCmd = _v10.b;
					var rainforestPaymentModalOutMsg = _v10.c;
					return function (m) {
						return {
							EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
							ac5: 0,
							y8: m,
							as: rainforestPaymentModalOutMsg
						};
					}(
						_Utils_update(
							model,
							{
								eq: $elm$core$Maybe$Just(newRainforestPaymentModal)
							}));
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				return function (m) {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: m, as: _List_Nil};
				}(
					_Utils_update(
						model,
						{eq: $elm$core$Maybe$Nothing}));
			case 9:
				var payment = msg.a;
				var _v11 = A3($author$project$Components$Rainforest$SimulateDisputeModal$init, model.vD, model.ZD, payment);
				var simulateDisputeModal = _v11.a;
				var simulateDisputeModalCmd = _v11.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeModalMsg, simulateDisputeModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							kc: $elm$core$Maybe$Just(simulateDisputeModal)
						}),
					as: _List_Nil
				};
			case 10:
				var subMsg = msg.a;
				var _v12 = model.kc;
				if (!_v12.$) {
					var simulateDisputeModal = _v12.a;
					var simulateDisputeModalResult = A3($author$project$Components$Rainforest$SimulateDisputeModal$update, apiClient, subMsg, simulateDisputeModal);
					var _v13 = function () {
						var _v14 = simulateDisputeModalResult.ac5;
						switch (_v14) {
							case 2:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(simulateDisputeModalResult.y8),
									0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 4);
						}
					}();
					var simulateDisputeModal_ = _v13.a;
					var event = _v13.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeModalMsg, simulateDisputeModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{kc: simulateDisputeModal_}),
						as: simulateDisputeModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 11:
				var payment = msg.a;
				var dispute = msg.b;
				var _v15 = A4($author$project$Components$Rainforest$SimulateDisputeEventModal$init, model.vD, model.ZD, payment, dispute);
				var simulateDisputeEventModal = _v15.a;
				var simulateDisputeEventModalCmd = _v15.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg, simulateDisputeEventModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							kb: $elm$core$Maybe$Just(simulateDisputeEventModal)
						}),
					as: _List_Nil
				};
			case 12:
				var subMsg = msg.a;
				var _v16 = model.kb;
				if (!_v16.$) {
					var simulateDisputeEventModal = _v16.a;
					var simulateDisputeEventModalResult = A3($author$project$Components$Rainforest$SimulateDisputeEventModal$update, apiClient, subMsg, simulateDisputeEventModal);
					var _v17 = function () {
						var _v18 = simulateDisputeEventModalResult.ac5;
						switch (_v18) {
							case 2:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(simulateDisputeEventModalResult.y8),
									0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 4);
						}
					}();
					var simulateDisputeEventModal_ = _v17.a;
					var event = _v17.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg, simulateDisputeEventModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{kb: simulateDisputeEventModal_}),
						as: simulateDisputeEventModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 13:
				var payment = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							cF: $elm$core$Maybe$Just(
								_Utils_Tuple2(payment, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 16:
				var paymentAndRefund = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							hE: $elm$core$Maybe$Just(paymentAndRefund)
						}),
					as: _List_Nil
				};
			case 14:
				var payment = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					EC: A5(
						$author$project$Api$Payment$cancel,
						model.vD,
						apiClient,
						model.ZD,
						$author$project$Api$Payment$id(payment),
						$author$project$Components$PaymentsList$GotCancelPayment),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							cF: $elm$core$Maybe$Just(
								_Utils_Tuple2(payment, $author$project$Api$Data$Loading))
						}),
					as: _List_Nil
				} : {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{cF: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 15:
				var response = msg.a;
				var _v19 = model.cF;
				if (!_v19.$) {
					var _v20 = _v19.a;
					var payment = _v20.a;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: _Utils_update(
								model,
								{cF: $elm$core$Maybe$Nothing}),
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									cF: $elm$core$Maybe$Just(
										_Utils_Tuple2(payment, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 17:
				var confirmed = msg.a;
				return {
					EC: function () {
						var _v22 = _Utils_Tuple2(confirmed, model.hE);
						if (_v22.a && (!_v22.b.$)) {
							var _v23 = _v22.b.a;
							var payment = _v23.a;
							var refund = _v23.b;
							var paymentPath = A2(
								$author$project$Api$Payment$paymentPath,
								model.vD,
								$author$project$Api$Payment$id(payment));
							return A4(
								$author$project$Api$Provider$Refund$cancel,
								paymentPath,
								apiClient,
								$author$project$Api$Refund$id(refund),
								$author$project$Components$PaymentsList$GotRefundCancelled);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					ac5: 0,
					y8: _Utils_update(
						model,
						{hE: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: function () {
						if (response.$ === 3) {
							return 3;
						} else {
							return 0;
						}
					}(),
					y8: model,
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
		}
	});
var $author$project$Ui$Popover$update = F2(
	function (msg, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{U9: false});
	});
var $author$project$Components$Invoice$PaymentsHistory$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var popover = A3(
					$author$project$Ui$Popover$init,
					'payment-history',
					!$author$project$Ui$Popover$isOpen(model.aM),
					$author$project$Components$Invoice$PaymentsHistory$PopoverMsg);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{aM: popover}),
					as: _List_Nil
				};
			case 1:
				var subMsg = msg.a;
				var paymentsListResult = A3($author$project$Components$PaymentsList$update, apiClient, subMsg, model.jr);
				var event = function () {
					var _v1 = paymentsListResult.ac5;
					switch (_v1) {
						case 0:
							return 0;
						case 1:
							return 1;
						case 2:
							return 2;
						case 3:
							return 3;
						default:
							return 4;
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg, paymentsListResult.EC),
					ac5: event,
					y8: _Utils_update(
						model,
						{jr: paymentsListResult.y8}),
					as: paymentsListResult.as
				};
			default:
				var subMsg = msg.a;
				var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aM);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{aM: popoverModel}),
					as: _List_Nil
				};
		}
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WH: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lV);
				var dropdownMenu = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lV: dropdownMenu}),
					cmd,
					_List_Nil);
			case 2:
				var practiceInvoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ty: $elm$core$Maybe$Just(
								_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var practiceInvoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ty: $elm$core$Maybe$Just(
								_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$PracticeInvoice$cancel,
						model.D5,
						$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice),
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Voided),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ty: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WH: response, ty: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var practiceInvoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$PracticeInvoice$issue,
						model.D5,
						$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice),
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issued),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WH: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice issued')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var practiceInvoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							h8: $elm$core$Maybe$Just(
								_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var practiceInvoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							h8: $elm$core$Maybe$Just(
								_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$PracticeInvoice$delete,
						model.D5,
						$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice),
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Deleted),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{h8: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h8: $elm$core$Maybe$Nothing}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice removed')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				var practiceInvoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A7(
						$author$project$Api$Payment$create,
						$author$project$Api$Data$providerPath,
						model.D5,
						model.ZD,
						'practice_invoice_id',
						$author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice),
						{
							I2: $author$project$Currency$fromInt(
								$author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)),
							abR: $elm$core$Maybe$Nothing,
							O4: false,
							aeC: $elm$core$Maybe$Nothing,
							Vt: $elm$core$Maybe$Nothing,
							agN: $elm$core$Maybe$Nothing,
							agO: $elm$core$Maybe$Nothing,
							Hg: A2(
								$elm$core$Maybe$map,
								function (source) {
									return {
										adR: $author$project$Api$Common$Source$Shared$id(source),
										ahI: $author$project$Api$Common$Source$Shared$type_(source)
									};
								},
								$author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)),
							ag2: $elm$core$Maybe$Nothing
						},
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Paid),
					_List_Nil);
			case 13:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice paid successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var practiceInvoice = msg.a;
				var _v6 = $author$project$Components$Invoice$CreatePaymentModal$init(model.cO)(model.Hy)($author$project$Api$Data$providerPath)(
					$elm$core$Maybe$Just($author$project$Api$Data$providerPath))(model.D5)(model.ZD)(
					$author$project$Api$Practice$Provider(model.WF))(model.FR)(model.sj)(
					function (d) {
						return _Utils_update(
							d,
							{O4: true, oo: model.FR});
					})(
					A2(
						$author$project$Components$Invoice$CreatePaymentModal$PracticeInvoice,
						$author$project$Api$Provider$Practice$One$id(model.WF),
						practiceInvoice));
				var createPaymentModal = _v6.a;
				var createPaymentModalCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lC: $elm$core$Maybe$Just(createPaymentModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg, createPaymentModalCmd),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var paymentsHistoryResult = A3($author$project$Components$Invoice$PaymentsHistory$update, model.D5, subMsg, model.jq);
				var _v7 = function () {
					var _v8 = paymentsHistoryResult.ac5;
					switch (_v8) {
						case 0:
							return _Utils_Tuple2(model.WH, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.D5, model.adR, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.D5, model.adR, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.D5, model.adR, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.D5, model.adR, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
					}
				}();
				var practiceInvoice = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jq: paymentsHistoryResult.y8, WH: practiceInvoice}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg, paymentsHistoryResult.EC),
								cmd
							])),
					paymentsHistoryResult.as);
			case 16:
				var subMsg = msg.a;
				var _v9 = model.lC;
				if (!_v9.$) {
					var createPaymentModal = _v9.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.D5, subMsg, createPaymentModal);
					var _v10 = function () {
						var _v11 = createPaymentModalResult.ac5;
						switch (_v11) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.y8),
									model.WH,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.D5, model.adR, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.WH, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v10.a;
					var practiceInvoice = _v10.b;
					var cmd = _v10.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lC: createPaymentModal_, WH: practiceInvoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg, createPaymentModalResult.EC),
									cmd
								])),
						createPaymentModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 17:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.D5, subMsg, model.iq);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iq: downloadInvoiceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg, downloadInvoiceResult.EC),
					downloadInvoiceResult.as);
			case 18:
				var practiceInvoice = msg.a;
				var _v12 = A2(
					$author$project$Components$HintBilling$CreateChargeModal$init,
					model.D5,
					$elm$core$Maybe$Just(practiceInvoice));
				var createChargeModal = _v12.a;
				var createChargeModalCmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hW: $elm$core$Maybe$Just(createChargeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg, createChargeModalCmd),
					_List_Nil);
			case 19:
				var subMsg = msg.a;
				var _v13 = model.hW;
				if (!_v13.$) {
					var createChargeModal = _v13.a;
					var result = A2($author$project$Components$HintBilling$CreateChargeModal$update, subMsg, createChargeModal);
					var _v14 = function () {
						var _v15 = result.ac5;
						switch (_v15.$) {
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
							case 2:
								var chargeParams = _v15.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A3($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$adjustInvoiceAction, model.D5, model.WH, chargeParams),
									$author$project$Api$Data$Loading);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(result.y8),
									$elm$core$Platform$Cmd$none,
									$author$project$Api$Data$NotAsked);
						}
					}();
					var createChargeModal_ = _v14.a;
					var cmd = _v14.b;
					var saveRequest_ = _v14.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hW: createChargeModal_, jY: saveRequest_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg, result.EC),
									cmd
								])),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WH: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice adjusted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WH: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice refunded')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Formatters$Time$Date__Friendly = 6;
var $author$project$Ui$Pull$Left = 0;
var $author$project$Formatters$Time$Time__Friendly = 2;
var $author$project$Ui$Margin$Top_0 = 19;
var $author$project$Ui$Breadcrumb$Active = $elm$core$Basics$identity;
var $author$project$Ui$Breadcrumb$active = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$address = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.It;
	});
var $author$project$Api$Provider$PracticeInvoice$One$autoPayDate = function (_v0) {
	var record = _v0.b;
	return record.JF;
};
var $author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled = function (_v0) {
	var record = _v0.b;
	return record.JG;
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$chargeModalTitle = function (practiceInvoiceData) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (status) {
				return (!status) ? 'Add Credit & Refund' : 'Add Charge or Credit';
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeInvoice$One$status,
				$author$project$Api$Data$toMaybe(practiceInvoiceData))));
};
var $author$project$Api$Provider$PracticeInvoice$One$charges = function (_v0) {
	var record = _v0.b;
	return record.KU;
};
var $author$project$Ui$Form$Group$Clearfix = {$: 7};
var $author$project$Ui$Form$Group$clearfix = $author$project$Ui$Form$Group$Clearfix;
var $author$project$Api$Provider$PracticeInvoice$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate(shared);
};
var $author$project$Components$HiConfirm$Detail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$HiConfirm$detail = $author$project$Components$HiConfirm$Detail;
var $author$project$Formatters$Phone$phoneMask = '(###) ###-####';
var $author$project$Formatters$Phone$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Formatters$Phone$phoneMask);
var $author$project$Formatters$Phone$format = function (phoneNumber) {
	return A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Formatters$Phone$phonePattern, phoneNumber);
};
var $author$project$Api$Provider$PracticeCharge$Shared$fromRecurringCharge = function (_v0) {
	var record = _v0;
	return record.PI;
};
var $author$project$Ui$Typography$HintLabel = {$: 18};
var $author$project$Ui$Typography$hintLabel = $author$project$Ui$Typography$HintLabel;
var $author$project$Ui$Breadcrumb$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Breadcrumb$item = $author$project$Ui$Breadcrumb$Item;
var $author$project$Ui$Form$Group$Margin = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$Group$margin = $author$project$Ui$Form$Group$Margin;
var $author$project$Components$HiConfirm$Noun = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HiConfirm$noun = $author$project$Components$HiConfirm$Noun;
var $author$project$Components$HiConfirm$Verb = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$HiConfirm$verb = $author$project$Components$HiConfirm$Verb;
var $author$project$Components$Invoice$RefundModal$AmountInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$RefundModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$RefundModal$Memo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$RefundModal$Save = {$: 2};
var $author$project$Ui$Typography$Numeric = {$: 19};
var $author$project$Ui$Typography$numeric = $author$project$Ui$Typography$Numeric;
var $author$project$Api$Provider$Payment$Shared$paidAt = function (_v0) {
	var record = _v0;
	return record.Vt;
};
var $author$project$Api$Provider$Payment$One$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$paidAt(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$paidAt(shared);
};
var $author$project$Api$Payment$paidAt = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$paidAt(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$paidAt(payment_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Payment$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Employer$Payment$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$Payment$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$Payment$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$paymentProcessor(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$paymentProcessor(shared);
};
var $author$project$Api$Payment$paymentProcessor = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$paymentProcessor(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$paymentProcessor(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$paymentProcessor(payment_);
	}
};
var $author$project$Components$PaymentSourceDisplayer$PaymentProcessor = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$paymentProcessor = $author$project$Components$PaymentSourceDisplayer$PaymentProcessor;
var $author$project$Api$Employer$Payment$Shared$source = function (_v0) {
	var record = _v0;
	return record.Hg;
};
var $author$project$Api$Employer$Payment$One$source = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$source(shared);
};
var $author$project$Api$Provider$Payment$Shared$source = function (_v0) {
	var record = _v0;
	return record.Hg;
};
var $author$project$Api$Provider$Payment$One$source = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$source(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$source = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$source(shared);
};
var $author$project$Api$Payment$source = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$source(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$source(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$source(payment_);
	}
};
var $author$project$Components$Invoice$RefundModal$viewExternalRefundAlert = function (oldPaymentProcessorPayment) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_Nil,
		_List_fromArray(
			[
				oldPaymentProcessorPayment ? A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Alert$warning,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('This refund can no longer be processed in this platform and must be processed externally. By continuing, you acknowledge that you are responsible for refunding the sponsor outside of this platform.')
													]))
											]))
									]))
							]))
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Currency$zero = '0';
var $author$project$Components$Invoice$RefundModal$view = function (_v0) {
	var model = _v0;
	var source_ = $author$project$Api$Payment$source(model.VY);
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Invoice$RefundModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						model.qC ? 'Record Refund' : 'Process Refund')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$RefundModal$Save),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								$author$project$Components$Invoice$RefundModal$viewExternalRefundAlert(model.Gl),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Payment'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														model.Hy(5),
														$author$project$Api$Payment$paidAt(model.VY)))),
												$author$project$Api$Payment$external(model.VY) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
												A2(
												$author$project$Components$PaymentSourceDisplayer$view,
												model.Hy,
												_List_fromArray(
													[
														$author$project$Components$PaymentSourceDisplayer$source(
														A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source_)),
														$author$project$Components$PaymentSourceDisplayer$limitedView(true),
														$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
														$author$project$Components$PaymentSourceDisplayer$paymentProcessor(
														$author$project$Api$Payment$paymentProcessor(model.VY))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label(
										model.vl ? 'Available' : 'Refund'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$numeric]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(fields.no))
													]))
											]))
									])),
								model.vl ? A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Refund'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$CurrencyInput$value(fields.I2),
												$author$project$Ui$Form$CurrencyInput$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Invoice$RefundModal$FormUpdated, $author$project$Components$Invoice$RefundModal$AmountInCents)),
												$author$project$Ui$Form$CurrencyInput$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
												$author$project$Ui$Form$CurrencyInput$errors(
												A2($author$project$Utils$Form$validationErrors, 0, model.PB))
											]))
									])) : $author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Memo'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2($elm$core$Maybe$withDefault, '', fields.aeC)),
												$author$project$Ui$Form$Input$placeholder('Additional notes about this refund'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Invoice$RefundModal$FormUpdated, $author$project$Components$Invoice$RefundModal$Memo))
											]))
									]))
							])),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$RefundModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						function () {
						var label = A2(
							$elm$core$String$join,
							' ',
							_List_fromArray(
								[
									model.qC ? 'Record' : 'Process',
									$author$project$Currency$format(
									A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.I2)),
									'Refund'
								]));
						return A3(
							$author$project$Ui$Button$view,
							{abp: label},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Invoice$RefundModal$Save)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					}()
					]))
			]));
};
var $author$project$WebComponents$Rainforest$ChargebackRespond$view = F2(
	function (onClose, data) {
		return A3(
			$elm$html$Html$node,
			'rainforest-chargeback-respond',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'session-key', data.agS),
					A2($elm$html$Html$Attributes$attribute, 'chargeback-id', data.ab0),
					A2($elm$html$Html$Attributes$attribute, 'show-respond-button', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'hide-metadata', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'hide-related-info', 'true'),
					A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
					A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
					A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
					A2(
					$elm$html$Html$Events$on,
					'close-button-clicked',
					$elm$json$Json$Decode$succeed(onClose))
				]),
			_List_Nil);
	});
var $author$project$Components$DisputeModal$view = F2(
	function (onClose, model) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_Nil,
			_Utils_ap(
				function () {
					var _v0 = model.NQ;
					if (_v0.$ === 2) {
						return _List_Nil;
					} else {
						return _List_fromArray(
							[
								$author$project$Ui$Modal$header(_List_Nil)
							]);
					}
				}(),
				_List_fromArray(
					[
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								function () {
								var _v1 = model.NQ;
								switch (_v1.$) {
									case 0:
										return $elm$html$Html$text('Loading...');
									case 1:
										return $elm$html$Html$text('There was an error loading the dispute');
									default:
										if (!_v1.a.$) {
											var session = _v1.a.a;
											return A2($author$project$WebComponents$Rainforest$ChargebackRespond$view, onClose, session);
										} else {
											var session = _v1.a.a;
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id('stripe-payment-disputes-' + session.abW)
													]),
												_List_Nil);
										}
								}
							}()
							]))
					])));
	});
var $author$project$Components$PaymentDisputeModal$viewModal = F2(
	function (onClose, text) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(_List_Nil),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						]))
				]));
	});
var $author$project$Components$PaymentDisputeModal$view = F2(
	function (onClose, model) {
		var _v0 = model.NQ;
		switch (_v0.$) {
			case 2:
				return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'Loading...');
			case 0:
				var disputeModal = _v0.a;
				return A2($author$project$Components$DisputeModal$view, onClose, disputeModal);
			case 3:
				return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'There was an error loading the dispute');
			default:
				return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'There was an error loading the dispute');
		}
	});
var $author$project$Ui$Modal$Xl = 3;
var $author$project$Components$Rainforest$SessionModal$resourceDescription = function (resource) {
	switch (resource.$) {
		case 0:
			return 'deposit';
		case 1:
			return 'payment';
		default:
			return 'refund';
	}
};
var $author$project$WebComponents$Rainforest$DepositDetails$view = function (data) {
	return A3(
		$elm$html$Html$node,
		'rainforest-deposit-details',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'session-key', data.agS),
				A2($elm$html$Html$Attributes$attribute, 'deposit-id', data.acI),
				A2($elm$html$Html$Attributes$attribute, 'show-payin-signature', ''),
				A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
				A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
				A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
				A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
			]),
		_List_Nil);
};
var $author$project$WebComponents$Rainforest$PayinDetails$view = function (data) {
	return A3(
		$elm$html$Html$node,
		'rainforest-payin-details',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'session-key', data.agS),
				A2($elm$html$Html$Attributes$attribute, 'payin-id', data.VX),
				A2($elm$html$Html$Attributes$attribute, 'show-signature', ''),
				A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
				A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
				A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
				A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
			]),
		_List_Nil);
};
var $author$project$WebComponents$Rainforest$RefundDetails$view = function (data) {
	return A3(
		$elm$html$Html$node,
		'rainforest-refund-details',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'session-key', data.agS),
				A2($elm$html$Html$Attributes$attribute, 'refund-id', data.af9),
				A2($elm$html$Html$Attributes$attribute, 'parent-payin-id', data.VX),
				A2($elm$html$Html$Attributes$attribute, 'show-signature', ''),
				A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
				A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
				A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
				A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
			]),
		_List_Nil);
};
var $author$project$Components$Rainforest$SessionModal$view = F2(
	function (onClose, model) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(3)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(_List_Nil),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							var _v0 = model.ZD;
							switch (_v0.$) {
								case 0:
									return $elm$html$Html$text('Loading...');
								case 1:
									return $elm$html$Html$text(
										'There was an error loading the ' + $author$project$Components$Rainforest$SessionModal$resourceDescription(model.G0));
								default:
									var session = _v0.a;
									var _v1 = model.G0;
									switch (_v1.$) {
										case 0:
											return $author$project$WebComponents$Rainforest$DepositDetails$view(
												{acI: session.af0, agS: session.af2});
										case 1:
											return $author$project$WebComponents$Rainforest$PayinDetails$view(
												{VX: session.af0, agS: session.af2});
										default:
											return $author$project$WebComponents$Rainforest$RefundDetails$view(
												{
													VX: A2($elm$core$Maybe$withDefault, '', session.af$),
													af9: session.af0,
													agS: session.af2
												});
									}
							}
						}()
						]))
				]));
	});
var $author$project$Components$Rainforest$SimulateDisputeEventModal$SimulateDisputeEvent = {$: 2};
var $author$project$Components$Rainforest$SimulateDisputeEventModal$StatusSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$SimulateDisputeEventModal$statusOptions = A2(
	$elm$core$List$map,
	function (status) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(status),
			status);
	},
	$author$project$Components$Rainforest$SimulateDisputeEventModal$statuses);
var $author$project$Components$Rainforest$SimulateDisputeEventModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Simulate Dispute Event')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate a dispute event for testing purposes.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Status'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(model.ag7)),
										$author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateDisputeEventModal$StatusSelected)
									]),
								$author$project$Components$Rainforest$SimulateDisputeEventModal$statusOptions)
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Simulate Dispute Event'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeEventModal$SimulateDisputeEvent),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.ou, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate Dispute Event')
							]))
					]))
			]));
};
var $author$project$Components$Rainforest$SimulateDisputeModal$SimulateDispute = {$: 2};
var $author$project$Components$Rainforest$SimulateDisputeModal$StatusSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$SimulateDisputeModal$statusOptions = A2(
	$elm$core$List$map,
	function (status) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(status),
			status);
	},
	$author$project$Components$Rainforest$SimulateDisputeModal$statuses);
var $author$project$Components$Rainforest$SimulateDisputeModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$SimulateDisputeModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Simulate Dispute')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate a dispute for testing purposes. This will mark the payment as disputed.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Status'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(model.ag7)),
										$author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateDisputeModal$StatusSelected)
									]),
								$author$project$Components$Rainforest$SimulateDisputeModal$statusOptions)
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Simulate Dispute'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeModal$SimulateDispute),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.ov, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate Dispute')
							]))
					]))
			]));
};
var $author$project$Components$PaymentsList$modal = function (_v0) {
	var refundModal = _v0.jK;
	var paymentDisputeModal = _v0.gh;
	var rainforestPaymentModal = _v0.eq;
	var simulateDisputeModal = _v0.kc;
	var simulateDisputeEventModal = _v0.kb;
	var cancelingPayment = _v0.cF;
	var cancellingRefund = _v0.hE;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Invoice$RefundModal$view,
						$elm$html$Html$map($author$project$Components$PaymentsList$RefundModalMsg)),
					refundModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$PaymentDisputeModal$view($author$project$Components$PaymentsList$ClosePaymentDisputeModal),
					paymentDisputeModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Rainforest$SessionModal$view($author$project$Components$PaymentsList$CloseRainforestPaymentModal),
					rainforestPaymentModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateDisputeModal$view,
						$elm$html$Html$map($author$project$Components$PaymentsList$SimulateDisputeModalMsg)),
					simulateDisputeModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateDisputeEventModal$view,
						$elm$html$Html$map($author$project$Components$PaymentsList$SimulateDisputeEventModalMsg)),
					simulateDisputeEventModal)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var payment = _v1.a;
						var cancelRequest = _v1.b;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed(payment),
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('cancel'),
									$author$project$Components$HiConfirm$noun('payment'),
									$author$project$Components$HiConfirm$loading(
									_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
								]));
					},
					cancelingPayment)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Components$PaymentsList$CancelRefundConfirmed,
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('cancel'),
									$author$project$Components$HiConfirm$noun('refund')
								]));
					},
					cancellingRefund))
			]));
};
var $author$project$Components$Invoice$PaymentsHistory$modal = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg,
		$author$project$Components$PaymentsList$modal(model.jr));
};
var $author$project$Api$Provider$PracticeInvoice$One$number = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$PracticeInvoice$One$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$paidAt(shared);
};
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $author$project$Api$Provider$PracticeInvoice$One$payments = function (_v0) {
	var record = _v0.b;
	return record.V5;
};
var $author$project$Api$Provider$Practice$One$phones = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Wi;
	});
var $author$project$Ui$Typography$Pull = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Typography$pull = $author$project$Ui$Typography$Pull;
var $author$project$Api$Provider$PracticeInvoice$One$purchaseOrderNumber = function (_v0) {
	var record = _v0.b;
	return record.Xq;
};
var $author$project$Formatters$Bool$toString = function (bool) {
	return bool ? 'Yes' : 'No';
};
var $author$project$Api$Provider$PracticeInvoice$One$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents(shared);
};
var $author$project$Api$Common$Address$Shared$city = function (_v0) {
	var record = _v0;
	return record.pT;
};
var $author$project$Api$Common$Address$Shared$line1 = function (_v0) {
	var record = _v0;
	return record.rf;
};
var $author$project$Api$Common$Address$Shared$line2 = function (_v0) {
	var record = _v0;
	return record.yy;
};
var $author$project$Api$Common$Address$Shared$state = function (_v0) {
	var record = _v0;
	return record.sZ;
};
var $author$project$Components$AddressDisplay$viewField = F3(
	function (breakLike, getter, address) {
		var _v0 = getter(address);
		if (!_v0.$) {
			if (_v0.a === '') {
				return $author$project$Utils$Html$empty;
			} else {
				var string = _v0.a;
				return A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(string),
							breakLike ? A2($elm$html$Html$br, _List_Nil, _List_Nil) : $author$project$Utils$Html$empty
						]));
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Common$Address$Shared$zip = function (_v0) {
	var record = _v0;
	return record.tC;
};
var $author$project$Components$AddressDisplay$view = function (address) {
	return A2(
		$author$project$Ui$Typography$span,
		_List_fromArray(
			[
				$author$project$Ui$Typography$phi(true)
			]),
		_List_fromArray(
			[
				A3($author$project$Components$AddressDisplay$viewField, true, $author$project$Api$Common$Address$Shared$line1, address),
				A3($author$project$Components$AddressDisplay$viewField, true, $author$project$Api$Common$Address$Shared$line2, address),
				function () {
				var _v0 = A2(
					$elm$core$Maybe$map,
					$elm$core$String$trim,
					$author$project$Api$Common$Address$Shared$city(address));
				if (!_v0.$) {
					if (_v0.a === '') {
						return $author$project$Utils$Html$empty;
					} else {
						var city = _v0.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(city),
									$elm$html$Html$text(', '),
									A3($author$project$Components$AddressDisplay$viewField, false, $author$project$Api$Common$Address$Shared$state, address),
									$author$project$Utils$Html$noBreakSpace,
									A3($author$project$Components$AddressDisplay$viewField, false, $author$project$Api$Common$Address$Shared$zip, address)
								]));
					}
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$CardReader$SimulateForm$Card = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CardReader$SimulateForm$Event = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CardReader$SimulateForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CardReader$SimulateForm$Simulate = {$: 1};
var $author$project$Components$CardReader$SimulateForm$cards = _List_fromArray(
	['VISA_SUCCESS', 'VISA_42_SUCCESS', 'VISA_DEBIT_SUCCESS', 'MC_SUCCESS', 'MC_2_SUCCESS', 'MC_DEBIT_SUCCESS', 'MC_PREPAID_SUCCESS', 'AMEX_SUCCESS', 'AMEX_2_SUCCESS', 'DISCOVER_SUCCESS', 'DISCOVER_2_SUCCESS', 'DISCOVER_DEBIT_SUCCESS', 'DINERS_SUCCESS', 'DINERS_14_SUCCESS']);
var $author$project$Components$CardReader$SimulateForm$cardOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Choose a card...'),
	A2(
		$elm$core$List$map,
		function (card) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(card),
				card);
		},
		$author$project$Components$CardReader$SimulateForm$cards));
var $author$project$Components$CardReader$SimulateForm$events = _List_fromArray(
	['PRESENTED', 'CANCEL']);
var $author$project$Components$CardReader$SimulateForm$eventOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Choose an event...'),
	A2(
		$elm$core$List$map,
		function (event) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(event),
				event);
		},
		$author$project$Components$CardReader$SimulateForm$events));
var $author$project$Ui$Form$Group$Icon = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Form$Group$icon = $author$project$Ui$Form$Group$Icon;
var $author$project$Ui$SvgIcon$SpacedRight = {$: 4};
var $author$project$Ui$SvgIcon$spacedRight = $author$project$Ui$SvgIcon$SpacedRight;
var $author$project$Ui$HinterOnly$formGroup = F2(
	function (options, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Group$icon(
					$author$project$Ui$HinterOnly$icon(
						_List_fromArray(
							[$author$project$Ui$SvgIcon$spacedRight]))),
				options),
			content);
	});
var $author$project$Components$CardReader$SimulateForm$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$HinterOnly$formGroup,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Event')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(fields.ac5),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$CardReader$SimulateForm$FormUpdated, $author$project$Components$CardReader$SimulateForm$Event)),
								$author$project$Ui$Form$Select$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
								$author$project$Ui$Form$Select$errors(
								A2($author$project$Utils$Form$validationErrors, 0, model.PB))
							]),
						$author$project$Components$CardReader$SimulateForm$eventOptions)
					])),
				A2(
				$author$project$Ui$HinterOnly$formGroup,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Card')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(fields.abQ),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$CardReader$SimulateForm$FormUpdated, $author$project$Components$CardReader$SimulateForm$Card)),
								$author$project$Ui$Form$Select$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
								$author$project$Ui$Form$Select$errors(
								A2($author$project$Utils$Form$validationErrors, 1, model.PB))
							]),
						$author$project$Components$CardReader$SimulateForm$cardOptions)
					])),
				A3(
				$author$project$Ui$HinterOnly$button,
				{abp: 'Simulate'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick($author$project$Components$CardReader$SimulateForm$Simulate),
						$author$project$Ui$Button$loading(
						_Utils_eq(model.ov, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Simulate')
					]))
			]));
};
var $author$project$Components$CardReader$ConnectingModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CardReader$ConnectingModal$Cancel,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Processing Card')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								(!model.dx) ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								function () {
									var _v1 = model.dx;
									if (!_v1) {
										return _List_fromArray(
											[
												$elm$html$Html$text('Connecting to your card reader...')
											]);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text('Please insert or swipe your credit card into the card reader now.'),
												function () {
												var _v2 = model.sU;
												if (!_v2.$) {
													var simulateForm = _v2.a;
													return A2(
														$elm$html$Html$map,
														$author$project$Components$CardReader$ConnectingModal$SimulateFormMsg,
														$author$project$Components$CardReader$SimulateForm$view(simulateForm));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									}
								}())
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel card reader connection'},
						_List_fromArray(
							[
								$author$project$Ui$Button$fullWidth(true),
								$author$project$Ui$Button$onClick($author$project$Components$CardReader$ConnectingModal$Cancel),
								$author$project$Ui$Button$disabled(model.cE)
							]),
						_List_fromArray(
							[
								model.cE ? $elm$html$Html$text('Cancelling') : $elm$html$Html$text('Cancel')
							]))
					]))
			]));
};
var $author$project$Components$CardReader$PaymentModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CardReader$PaymentModal$Cancel,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Processing Card')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								(!model.dx) ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								function () {
									var _v1 = model.dx;
									if (!_v1) {
										return _List_fromArray(
											[
												$elm$html$Html$text('Connecting to your card reader...')
											]);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text('Please insert or swipe your credit card into the card reader now.'),
												function () {
												var _v2 = model.sU;
												if (!_v2.$) {
													var simulateForm = _v2.a;
													return A2(
														$elm$html$Html$map,
														$author$project$Components$CardReader$PaymentModal$SimulateFormMsg,
														$author$project$Components$CardReader$SimulateForm$view(simulateForm));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									}
								}())
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(3),
										$author$project$Ui$FlexGrid$offset(9)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel card reader connection'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$CardReader$PaymentModal$Cancel),
												$author$project$Ui$Button$disabled(model.cE)
											]),
										_List_fromArray(
											[
												model.cE ? $elm$html$Html$text('Cancelling') : $elm$html$Html$text('Cancel')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Invoice$CreatePaymentModal$CreatePayment = {$: 4};
var $author$project$Components$DateInput$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$DateInput$value = $author$project$Components$DateInput$Value;
var $author$project$Ui$Icon$Calendar = 45;
var $author$project$Components$DateInput$Above = 1;
var $author$project$Components$DateInput$datePickerSettings = function (optionsRecord) {
	var dataAttributes = function () {
		var _v0 = optionsRecord.w2;
		if (!_v0.$) {
			var dataTest = _v0.a;
			return _List_fromArray(
				[
					$author$project$Utils$Html$Attributes$test(dataTest)
				]);
		} else {
			return _List_Nil;
		}
	}();
	var baseSettings_ = $author$project$Components$DateInput$baseDatePickerSettings;
	var ariaAttributes = A2(
		$elm$core$List$cons,
		optionsRecord.q$ ? A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true') : A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'false'),
		$elm$core$List$isEmpty(optionsRecord.fE) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-describedby',
				A2($elm$core$String$join, '. ', optionsRecord.fE))
			]));
	return _Utils_update(
		baseSettings_,
		{
			Q0: A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$disabled(optionsRecord.dW),
				_Utils_ap(
					baseSettings_.Q0,
					_Utils_ap(dataAttributes, ariaAttributes))),
			FA: A2(
				$elm$core$List$cons,
				_Utils_Tuple2('disabled', optionsRecord.dW),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2('feedback-errored', optionsRecord.q$),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2('elm-datepicker--above', optionsRecord.Wz === 1),
						baseSettings_.FA))),
			aed: optionsRecord.xe,
			r4: optionsRecord.r4
		});
};
var $author$project$Components$DateInput$Below = 0;
var $author$project$Components$DateInput$defaultOptions = {
	vw: _List_Nil,
	w2: $elm$core$Maybe$Nothing,
	dW: false,
	xe: $elm$core$Basics$always(false),
	fE: _List_Nil,
	xO: false,
	q$: false,
	r4: 'Select a Date',
	Wz: 0,
	aaN: $elm$core$Maybe$Nothing
};
var $author$project$Components$DateInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{r4: string});
					case 0:
						var date = option.a;
						return _Utils_update(
							record,
							{aaN: date});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{dW: bool});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{q$: bool});
					case 4:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{
								w2: $elm$core$Maybe$Just(string)
							});
					case 6:
						var isDisabled = option.a;
						return _Utils_update(
							record,
							{xe: isDisabled});
					case 7:
						var attributes = option.a;
						return _Utils_update(
							record,
							{
								vw: _Utils_ap(
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map($elm$core$Basics$never),
										attributes),
									record.vw)
							});
					case 8:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
									record.vw)
							});
					case 9:
						var position = option.a;
						return _Utils_update(
							record,
							{Wz: position});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{xO: bool});
				}
			}),
		$author$project$Components$DateInput$defaultOptions,
		options);
};
var $agustinrhcp$elm_datepicker$DatePicker$Blur = {$: 6};
var $agustinrhcp$elm_datepicker$DatePicker$Focus = {$: 5};
var $agustinrhcp$elm_datepicker$DatePicker$KeyDown = function (a) {
	return {$: 11, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $agustinrhcp$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$ChangePicking = function (a) {
	return {$: 9, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$Month = 1;
var $agustinrhcp$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $agustinrhcp$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $agustinrhcp$elm_datepicker$DatePicker$Year = 2;
var $justinmimbs$date$Date$Years = 0;
var $agustinrhcp$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $agustinrhcp$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $agustinrhcp$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $agustinrhcp$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.lr;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $agustinrhcp$elm_datepicker$DatePicker$split = F2(
	function (into, list) {
		var _v0 = A2($elm$core$List$take, into, list);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var head = _v0;
			return A2(
				$elm$core$List$cons,
				head,
				A2(
					$agustinrhcp$elm_datepicker$DatePicker$split,
					into,
					A2($elm$core$List$drop, into, list)));
		}
	});
var $agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $agustinrhcp$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.lr;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $agustinrhcp$elm_datepicker$DatePicker$viewMonth = F3(
	function (focused, settings, month) {
		var year = $justinmimbs$date$Date$year(focused);
		var day = $justinmimbs$date$Date$day(focused);
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2(
					$agustinrhcp$elm_datepicker$DatePicker$mkClassList,
					settings,
					_List_fromArray(
						[
							_Utils_Tuple2('day', true)
						])),
					$elm$html$Html$Events$onClick(
					A2(
						$agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking,
						A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
						0))
				]),
			_List_fromArray(
				[
					settings.pP(
					settings.zb(month))
				]));
	});
var $agustinrhcp$elm_datepicker$DatePicker$monthList = F2(
	function (focused, settings) {
		var months = _List_fromArray(
			[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
		var splitMonths = A2($agustinrhcp$elm_datepicker$DatePicker$split, 3, months);
		return A2(
			$elm$core$List$map,
			function (monthsRow) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($agustinrhcp$elm_datepicker$DatePicker$viewMonth, focused, settings),
						monthsRow));
			},
			splitMonths);
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $agustinrhcp$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $agustinrhcp$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $agustinrhcp$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			Ms: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			EN: date
		};
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $agustinrhcp$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $agustinrhcp$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.aed(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$agustinrhcp$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $agustinrhcp$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			A2(
				$elm$core$List$cons,
				classList(
					_List_fromArray(
						[
							_Utils_Tuple2('day', true),
							_Utils_Tuple2('disabled', disabled),
							_Utils_Tuple2(
							'picked',
							picked(d)),
							_Utils_Tuple2(
							'today',
							isToday(d)),
							_Utils_Tuple2(
							'other-month',
							isOtherMonth(d))
						])),
				props),
			_List_fromArray(
				[
					settings.pP(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $agustinrhcp$elm_datepicker$DatePicker$viewYear = F3(
	function (focused, settings, year) {
		var month = $justinmimbs$date$Date$month(focused);
		var day = $justinmimbs$date$Date$day(focused);
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2(
					$agustinrhcp$elm_datepicker$DatePicker$mkClassList,
					settings,
					_List_fromArray(
						[
							_Utils_Tuple2('day', true)
						])),
					$elm$html$Html$Events$onClick(
					A2(
						$agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking,
						A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
						1))
				]),
			_List_fromArray(
				[
					settings.pP(
					settings.pf(year))
				]));
	});
var $agustinrhcp$elm_datepicker$DatePicker$yearList = F2(
	function (focused, settings) {
		var focusedYear = $justinmimbs$date$Date$year(focused);
		var years = A2($elm$core$List$range, focusedYear - 1, focusedYear + 10);
		var splitYears = A2($agustinrhcp$elm_datepicker$DatePicker$split, 3, years);
		return A2(
			$elm$core$List$map,
			function (yearsRow) {
				return A2(
					$elm$html$Html$tr,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($agustinrhcp$elm_datepicker$DatePicker$viewYear, focused, settings),
						yearsRow));
			},
			splitYears);
	});
var $agustinrhcp$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.EN;
		var today = _v0.$P;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $agustinrhcp$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $agustinrhcp$elm_datepicker$DatePicker$Date$Off);
};
var $agustinrhcp$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, _v0) {
		var focused = _v0.a4;
		var today = _v0.$P;
		var picking = _v0.jt;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.adq) - 1;
		var dpClass = $agustinrhcp$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($agustinrhcp$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v1 = A2($agustinrhcp$elm_datepicker$DatePicker$prepareDates, currentDate, settings.adq);
		var currentMonth = _v1.EN;
		var currentDates = _v1.Ms;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($agustinrhcp$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$agustinrhcp$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var _v2 = function () {
			var front = function (to_) {
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth),
					to_);
			};
			var back = function (from_) {
				return A2(
					$elm$core$List$range,
					from_,
					$justinmimbs$date$Date$year(currentMonth));
			};
			var _v3 = settings.hI;
			switch (_v3.$) {
				case 3:
					var from_ = _v3.a;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(
							$justinmimbs$date$Date$year(today) + 1));
				case 4:
					var to_ = _v3.a;
					return _Utils_Tuple2(
						front(
							$justinmimbs$date$Date$year(today) - 1),
						back(to_ + 1));
				case 2:
					var from_ = _v3.a;
					var to_ = _v3.b;
					return _Utils_Tuple2(
						front(from_ - 1),
						back(to_ + 1));
				case 1:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
				default:
					return _Utils_Tuple2(_List_Nil, _List_Nil);
			}
		}();
		var addedYearsFront = _v2.a;
		var addedYearsBack = _v2.b;
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$agustinrhcp$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				$elm$core$List$concat(
					_List_fromArray(
						[
							addedYearsFront,
							A2(
							$agustinrhcp$elm_datepicker$DatePicker$Date$yearRange,
							{EN: currentMonth, $P: today},
							settings.hI),
							addedYearsBack
						]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($agustinrhcp$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($agustinrhcp$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			function () {
				switch (picking) {
					case 0:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('picker-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('prev-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'prev',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('month-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$tabindex(-1),
														dpClass('month'),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Events$onClick(
														$agustinrhcp$elm_datepicker$DatePicker$ChangePicking(1))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.zb(
															$justinmimbs$date$Date$month(currentMonth)))
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$tabindex(-1),
														dpClass('year'),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Events$onClick(
														$agustinrhcp$elm_datepicker$DatePicker$ChangePicking(2))
													]),
												_List_fromArray(
													[
														(!$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.hI)) ? $elm$html$Html$text(
														settings.pf(
															$justinmimbs$date$Date$year(currentMonth))) : A3(
														$elm$html$Html$Keyed$node,
														'span',
														_List_Nil,
														_List_fromArray(
															[
																_Utils_Tuple2(
																$elm$core$String$fromInt(
																	$justinmimbs$date$Date$year(currentMonth)),
																dropdownYear)
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('next-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'next',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
											]))
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										dpClass('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_fromArray(
											[
												dpClass('weekdays')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												A2(
													$elm$core$List$map,
													function (d) {
														return A2(
															$elm$html$Html$td,
															_List_fromArray(
																[
																	dpClass('dow')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	settings.acr(d))
																]));
													},
													A2(
														$elm$core$List$take,
														7,
														A2(
															$elm$core$List$drop,
															firstDayOffset,
															$elm$core$List$concat(
																A2(
																	$elm$core$List$repeat,
																	2,
																	_List_fromArray(
																		[0, 1, 2, 3, 4, 5, 6])))))))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_fromArray(
											[
												dpClass('days')
											]),
										dayList)
									]))
							]);
					case 1:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('picker-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('prev-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'prev',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 0, -1, currentDate)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('month-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														dpClass('year'),
														$elm$html$Html$Attributes$type_('button'),
														$elm$html$Html$Events$onClick(
														$agustinrhcp$elm_datepicker$DatePicker$ChangePicking(2))
													]),
												_List_fromArray(
													[
														(!$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.hI)) ? $elm$html$Html$text(
														settings.pf(
															$justinmimbs$date$Date$year(currentMonth))) : A3(
														$elm$html$Html$Keyed$node,
														'span',
														_List_Nil,
														_List_fromArray(
															[
																_Utils_Tuple2(
																$elm$core$String$fromInt(
																	$justinmimbs$date$Date$year(currentMonth)),
																dropdownYear)
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('next-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'next',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 0, 1, currentDate)))
											]))
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										dpClass('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tbody,
										_List_fromArray(
											[
												dpClass('months')
											]),
										A2($agustinrhcp$elm_datepicker$DatePicker$monthList, currentDate, settings))
									]))
							]);
					default:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										dpClass('picker-header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('prev-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'prev',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 0, -12, currentDate)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('month-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														dpClass('year')
													]),
												_List_fromArray(
													[
														(!$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.hI)) ? $elm$html$Html$text(
														settings.pf(
															$justinmimbs$date$Date$year(currentMonth))) : A3(
														$elm$html$Html$Keyed$node,
														'span',
														_List_Nil,
														_List_fromArray(
															[
																_Utils_Tuple2(
																$elm$core$String$fromInt(
																	$justinmimbs$date$Date$year(currentMonth)),
																dropdownYear)
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												dpClass('next-container')
											]),
										_List_fromArray(
											[
												A2(
												arrow,
												'next',
												$agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(
													A3($justinmimbs$date$Date$add, 0, 12, currentDate)))
											]))
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										dpClass('table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tbody,
										_List_fromArray(
											[
												dpClass('years')
											]),
										A2($agustinrhcp$elm_datepicker$DatePicker$yearList, currentDate, settings))
									]))
							]);
				}
			}());
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $agustinrhcp$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var model = _v0;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.FB));
		var inputClasses = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.lr + 'input', true),
			settings.FA);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.FC)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($agustinrhcp$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($agustinrhcp$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($agustinrhcp$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($agustinrhcp$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($agustinrhcp$elm_datepicker$DatePicker$Focus),
							A2(
							$elm$html$Html$Events$on,
							'keydown',
							A2($elm$json$Json$Decode$map, $agustinrhcp$elm_datepicker$DatePicker$KeyDown, $elm$html$Html$Events$keyCode))
						]),
					_Utils_ap(
						settings.Q0,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.r4),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.aco, pickedDate)),
						model.ca))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.lr + 'container', true),
			settings.EF);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.U9 ? A3($agustinrhcp$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Components$DateInput$view = F2(
	function (options, model) {
		var optionsRecord = $author$project$Components$DateInput$optionsToRecord(options);
		var datePickerSettings_ = $author$project$Components$DateInput$datePickerSettings(optionsRecord);
		return A2(
			$elm$html$Html$div,
			optionsRecord.vw,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$DateInput$DatePickerMsg(datePickerSettings_),
							A3($agustinrhcp$elm_datepicker$DatePicker$view, optionsRecord.aaN, datePickerSettings_, model.lM)),
							$author$project$Ui$Form$Input$addon(
							_List_fromArray(
								[
									A2($author$project$Ui$Icon$view, _List_Nil, 45)
								]))
						])),
					optionsRecord.xO ? $elm$html$Html$text('') : $author$project$Utils$FormErrors$view(optionsRecord.fE)
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewCardPaymentWarningModal = function (fields) {
	return (fields.mb === 2) ? A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[$author$project$Ui$Typography$warning]),
				_List_fromArray(
					[
						$elm$html$Html$text('We will not collect this payment.'),
						$elm$html$Html$text(' This form is used to record a payment made in person, by mail, or using a different payment processor.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Invoice$CreatePaymentModal$ExternalSource = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Radio$OnCheck = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Radio$onCheck = $author$project$Ui$Form$Radio$OnCheck;
var $author$project$Ui$Form$Radio$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Radio$value = $author$project$Ui$Form$Radio$Value;
var $author$project$Ui$Form$Radio$inputOptionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			var val = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$checked(val)
				]);
		case 1:
			var toMsg = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Events$onCheck(toMsg)
				]);
		case 2:
			return _List_Nil;
		case 3:
			var disabled_ = option.a;
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$disabled(disabled_)
				]);
		case 4:
			return _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, '-webkit-appearance', 'none'),
					A2($elm$html$Html$Attributes$style, 'appearance', 'none'),
					A2($elm$html$Html$Attributes$style, 'background-color', '#fff'),
					A2($elm$html$Html$Attributes$style, 'margin', '0')
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$Ui$Form$Radio$labelOptionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_Nil;
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio-inline')
				]);
		case 3:
			return _List_Nil;
		case 4:
			return _List_Nil;
		default:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('pl-0')
				]);
	}
};
var $author$project$Ui$Form$Radio$view = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$label,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('radio-inline'),
				A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$labelOptionToAttributes, options)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('radio'),
						A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$inputOptionToAttributes, options)),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						content))
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceLabel = function (externalSource) {
	switch (externalSource) {
		case 0:
			return 'Check';
		case 1:
			return 'Cash';
		case 2:
			return 'External Card';
		case 3:
			return 'Electronic Funds Transfer';
		default:
			return 'Other';
	}
};
var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSource = F2(
	function (currentExternalSource, externalSource) {
		return A2(
			$author$project$Ui$Form$Radio$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Radio$value(
					_Utils_eq(currentExternalSource, externalSource)),
					$author$project$Ui$Form$Radio$onCheck(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Components$Invoice$CreatePaymentModal$FormUpdated,
						$elm$core$Basics$always(
							$author$project$Components$Invoice$CreatePaymentModal$ExternalSource(externalSource))))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceLabel(externalSource))
						]))
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$Memo = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$viewMemoModal = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Memo'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', fields.aeC)),
						$author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$Memo))
					]))
			]));
};
var $author$project$Components$Invoice$CreatePaymentModal$AmountInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Group$Inline = {$: 8};
var $author$project$Ui$Form$Group$inline = $author$project$Ui$Form$Group$Inline;
var $author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel = F2(
	function (fields, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Payment'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$inline
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(fields.I2),
											$author$project$Ui$Form$CurrencyInput$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$AmountInCents)),
											$author$project$Ui$Form$CurrencyInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(' of '),
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(fields.mB)),
											$elm$html$Html$text(' due')
										]))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 0, model.PB))
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceModal = F3(
	function (model, fields, amountInCentsString) {
		return _List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Record External Payment')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel, fields, model),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('On date'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg(fields.Gz),
										A2(
											$author$project$Components$DateInput$view,
											_List_fromArray(
												[
													$author$project$Components$DateInput$value(fields.Vt)
												]),
											fields.Gz))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Paid By'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								A2(
									$elm$core$List$map,
									$author$project$Components$Invoice$CreatePaymentModal$viewExternalSource(fields.mb),
									model.zY.Fe)),
								$author$project$Utils$Html$empty,
								$author$project$Utils$Html$empty,
								$author$project$Components$Invoice$CreatePaymentModal$viewMemoModal(fields)
							])),
						$author$project$Components$Invoice$CreatePaymentModal$viewCardPaymentWarningModal(fields),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Record payment'},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(1),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.af, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Record '),
								$elm$html$Html$text(amountInCentsString),
								$elm$html$Html$text(' Payment')
							]))
					]))
			]);
	});
var $author$project$Ui$Margin$Bottom_0_75 = 2;
var $author$project$Ui$Icon$Flash = 46;
var $author$project$Components$Invoice$CreatePaymentModal$StoreCard = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModal$UpdateUseExistingSources = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Typography$Gray = 7;
var $author$project$Ui$Typography$gray = $author$project$Ui$Typography$Color(7);
var $author$project$Ui$Form$ButtonSelect$Option = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Form$ButtonSelect$option = F2(
	function (value, label) {
		return A2($author$project$Ui$Form$ButtonSelect$Option, value, label);
	});
var $author$project$Ui$Button$group = function (contents) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('button-group')
			]),
		contents);
};
var $author$project$Ui$Button$Active = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Button$active = $author$project$Ui$Button$Active;
var $author$project$Ui$Form$ButtonSelect$viewOptionButton = F3(
	function (currentCardInput, onChange, _v0) {
		var value = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCardInput, value)),
					$author$project$Ui$Button$onClick(
					onChange(value))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Ui$Form$ButtonSelect$view = function (_v0) {
	var value = _v0.aaN;
	var options = _v0.zY;
	var onChange = _v0.ae4;
	return $author$project$Ui$Button$group(
		A2(
			$elm$core$List$map,
			A2($author$project$Ui$Form$ButtonSelect$viewOptionButton, value, onChange),
			options));
};
var $author$project$Ui$Margin$Top_0_5 = 20;
var $author$project$Ui$Form$SearchableSelect$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$SearchableSelect$disabled = $author$project$Ui$Form$SearchableSelect$Disabled;
var $author$project$Ui$Form$SearchableSelect$Errors = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$SearchableSelect$errors = $author$project$Ui$Form$SearchableSelect$Errors;
var $author$project$Ui$Form$SearchableSelect$Invalid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$SearchableSelect$invalid = $author$project$Ui$Form$SearchableSelect$Invalid;
var $author$project$Ui$Form$SearchableSelect$Loading = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$SearchableSelect$loading = $author$project$Ui$Form$SearchableSelect$Loading;
var $author$project$Ui$Form$SearchableSelect$Item$ActualItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Form$SearchableSelect$Item$new = F2(
	function (options, item) {
		return A2($author$project$Ui$Form$SearchableSelect$Item$ActualItem, options, item);
	});
var $author$project$Ui$Form$SearchableSelect$Placeholder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$SearchableSelect$placeholder = $author$project$Ui$Form$SearchableSelect$Placeholder;
var $author$project$Ui$Form$SearchableSelect$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$SearchableSelect$value = $author$project$Ui$Form$SearchableSelect$Value;
var $author$project$Ui$Form$SearchableSelect$ContainerBlurred = {$: 1};
var $author$project$Ui$Form$SearchableSelect$CustomTriggered = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$SearchableSelect$InputChanged = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Ui$Form$SearchableSelect$InputKeyDown = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$SearchableSelect$ItemBlurred = {$: 5};
var $author$project$Ui$Form$SearchableSelect$ItemClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$SearchableSelect$ItemKeyDown = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Ui$Form$SearchableSelect$Open = {$: 0};
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$Ui$Form$SearchableSelect$arrowIcon = A2(
	$elm$html$Html$i,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('caret pull-right')
		]),
	_List_Nil);
var $author$project$Ui$Form$SearchableSelect$Item$addValue = F2(
	function (maybeValue, attrs) {
		if (!maybeValue.$) {
			var val = maybeValue.a;
			return A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$value(val),
				attrs);
		} else {
			return attrs;
		}
	});
var $author$project$Ui$Form$SearchableSelect$Item$defaultOptions = {dW: false, yq: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$SearchableSelect$Item$updateOptionsRecord = F2(
	function (option, options) {
		var bool = option;
		return _Utils_update(
			options,
			{dW: bool});
	});
var $author$project$Ui$Form$SearchableSelect$Item$optionsListToRecord = function (optionsList) {
	return A3($elm$core$List$foldl, $author$project$Ui$Form$SearchableSelect$Item$updateOptionsRecord, $author$project$Ui$Form$SearchableSelect$Item$defaultOptions, optionsList);
};
var $author$project$Ui$Form$SearchableSelect$Item$viewKeyedItem = F2(
	function (_v0, _v1) {
		var toValue = _v0.g0;
		var toLabel = _v0.ahw;
		var selected = _v0.ag;
		var selectId = _v0.agM;
		var onBlurred = _v0.ae2;
		var onPicked = _v0.afi;
		var onKeyDown = _v0.afe;
		var options = _v1.a;
		var item = _v1.b;
		var value = toValue(item);
		var optionsRecord = $author$project$Ui$Form$SearchableSelect$Item$optionsListToRecord(options);
		var onClickHandler = optionsRecord.dW ? _List_Nil : _List_fromArray(
			[
				$elm$html$Html$Events$onMouseDown(
				onPicked(
					$elm$core$Maybe$Just(item)))
			]);
		var key = A2(
			$elm$core$Maybe$withDefault,
			A2($elm$core$Maybe$withDefault, '', value),
			optionsRecord.yq);
		var isSelected = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(item),
				selected));
		var itemId = _Utils_ap(
			selectId,
			isSelected ? '-item-active' : ('-item-' + key));
		var attrsFromSelect = A2(
			$author$project$Ui$Form$SearchableSelect$Item$addValue,
			value,
			_List_fromArray(
				[
					$author$project$Utils$Dom$onKeyDown(
					onKeyDown(
						$elm$core$Maybe$Just(item))),
					A2($author$project$Utils$Dom$onOutsideBlur, onBlurred, selectId),
					$elm$html$Html$Attributes$id(itemId),
					$elm$html$Html$Attributes$name(selectId)
				]));
		return _Utils_Tuple2(
			key,
			A2(
				$elm$html$Html$div,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('ui-select-choices-row'),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'role', 'option'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('active', isSelected),
										_Utils_Tuple2('disabled', optionsRecord.dW)
									])),
							_Utils_ap(attrsFromSelect, onClickHandler)))),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ui-select-choices-row-inner')
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($elm$core$Basics$never),
							toLabel(item)))
					])));
	});
var $author$project$Ui$Form$SearchableSelect$Item$keyedView = F2(
	function (optionsFromSelect, item) {
		var triggerToMsg = optionsFromSelect.ahH;
		switch (item.$) {
			case 1:
				var nonSelectableItem = item.a;
				if (!nonSelectableItem.$) {
					return _Utils_Tuple2(
						'0',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('divider')
								]),
							_List_Nil));
				} else {
					var content = nonSelectableItem.a;
					return _Utils_Tuple2(
						'0',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-select-choices-row disabled')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-select-choices-row-inner')
										]),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($elm$core$Basics$never),
										content))
								])));
				}
			case 2:
				var triggerId = item.a;
				var triggerContent = item.b;
				return _Utils_Tuple2(
					'0',
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ui-select-choices-row'),
								$elm$html$Html$Events$onMouseDown(
								triggerToMsg(triggerId))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('ui-select-choices-row-inner')
									]),
								A2(
									$elm$core$List$map,
									$elm$html$Html$map($elm$core$Basics$never),
									triggerContent))
							])));
			default:
				var options = item.a;
				var actualItem = item.b;
				return A2(
					$author$project$Ui$Form$SearchableSelect$Item$viewKeyedItem,
					optionsFromSelect,
					_Utils_Tuple2(options, actualItem));
		}
	});
var $author$project$Ui$Form$SearchableSelect$defaultOptions = {EB: _List_Nil, dW: false, fE: _List_Nil, q$: false, S_: false, r4: 'Pick an item', aaN: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$SearchableSelect$updateOptionsRecord = F2(
	function (option, options) {
		switch (option.$) {
			case 2:
				var bool = option.a;
				return _Utils_update(
					options,
					{dW: bool});
			case 0:
				var maybeSelected = option.a;
				return _Utils_update(
					options,
					{aaN: maybeSelected});
			case 1:
				var string = option.a;
				return _Utils_update(
					options,
					{r4: string});
			case 3:
				var bool = option.a;
				return _Utils_update(
					options,
					{q$: bool});
			case 4:
				var bool = option.a;
				return _Utils_update(
					options,
					{dW: bool, S_: bool});
			case 5:
				var list = option.a;
				return _Utils_update(
					options,
					{fE: list});
			default:
				var string = option.a;
				return _Utils_update(
					options,
					{
						EB: A2($elm$core$List$cons, string, options.EB)
					});
		}
	});
var $author$project$Ui$Form$SearchableSelect$optionsListToRecord = function (optionsList) {
	return A3($elm$core$List$foldl, $author$project$Ui$Form$SearchableSelect$updateOptionsRecord, $author$project$Ui$Form$SearchableSelect$defaultOptions, optionsList);
};
var $author$project$Ui$Form$SearchableSelect$view = F3(
	function (options, items, model) {
		var optionsRecord = $author$project$Ui$Form$SearchableSelect$optionsListToRecord(options);
		var selectedOptionTitle = A2($elm$core$Maybe$map, model.yo, optionsRecord.aaN);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('ui-select-container ui-select-bootstrap dropdown'),
					$elm$html$Html$Attributes$class(
					A2($elm$core$String$join, ' ', optionsRecord.EB)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('open', model.U9),
							_Utils_Tuple2('disabled', optionsRecord.S_)
						])),
					$elm$html$Html$Attributes$id(model.adR)
				]),
			_List_fromArray(
				[
					model.U9 ? A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-control ui-select-search'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('feedback-errored', optionsRecord.q$)
								])),
							A2($author$project$Utils$Dom$onOutsideBlur, $author$project$Ui$Form$SearchableSelect$ContainerBlurred, model.adR),
							$author$project$Utils$Dom$onKeyDown($author$project$Ui$Form$SearchableSelect$InputKeyDown),
							$elm$html$Html$Attributes$id(model.adR + '-input'),
							$elm$html$Html$Attributes$placeholder('Search...'),
							$elm$html$Html$Attributes$value(
							function () {
								var _v0 = _Utils_Tuple2(optionsRecord.aaN, model.U9);
								if ((!_v0.a.$) && (!_v0.b)) {
									var item = _v0.a.a;
									return model.yo(item);
								} else {
									return model.$A;
								}
							}()),
							$elm$html$Html$Events$onInput(
							$author$project$Ui$Form$SearchableSelect$InputChanged(selectedOptionTitle))
						]),
					_List_Nil) : A2(
					$elm$html$Html$span,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn btn-default form-control ui-select-toggle'),
									$elm$html$Html$Attributes$disabled(optionsRecord.S_ || optionsRecord.dW),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('btn-disabled', optionsRecord.S_ || optionsRecord.dW),
											_Utils_Tuple2('feedback-errored', optionsRecord.q$)
										]))
								]),
								optionsRecord.dW ? _List_Nil : _List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Ui$Form$SearchableSelect$Open)
								])
							])),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-select-match-text pull-left'),
									A2($elm$html$Html$Attributes$attribute, 'data-recording-sensitive', '')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, optionsRecord.r4, selectedOptionTitle))
								])),
							optionsRecord.S_ ? $author$project$Ui$Spinner$view(
							_List_fromArray(
								[$author$project$Ui$Spinner$extraSmall])) : $author$project$Ui$Form$SearchableSelect$arrowIcon
						])),
					function () {
					if ((!optionsRecord.dW) && (model.U9 && (!$elm$core$List$isEmpty(items)))) {
						var itemOptions = {ae2: $author$project$Ui$Form$SearchableSelect$ItemBlurred, afe: $author$project$Ui$Form$SearchableSelect$ItemKeyDown, afi: $author$project$Ui$Form$SearchableSelect$ItemClicked, agM: model.adR, ag: optionsRecord.aaN, ahw: model.FV, g0: model.FW, ahH: $author$project$Ui$Form$SearchableSelect$CustomTriggered};
						return A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu')
								]),
							_List_fromArray(
								[
									A3(
									$elm$html$Html$Keyed$node,
									'li',
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('ui-select-choices')
										]),
									A2(
										$elm$core$List$map,
										$author$project$Ui$Form$SearchableSelect$Item$keyedView(itemOptions),
										items))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					$author$project$Utils$FormErrors$view(optionsRecord.fE)
				]));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewCardReaders = function (model) {
	var _v0 = function () {
		var _v1 = model.hG;
		if (_v1.$ === 3) {
			var cardReaders_ = _v1.a;
			return _Utils_Tuple2(cardReaders_, false);
		} else {
			return _Utils_Tuple2(_List_Nil, true);
		}
	}();
	var cardReaders = _v0.a;
	var cardReadersLoading = _v0.b;
	var _v2 = $author$project$Utils$Form$fields(model.PB);
	var cardReader = _v2.abR;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				((!cardReadersLoading) && $elm$core$List$isEmpty(cardReaders)) ? A2(
				$author$project$Ui$Alert$danger,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('There are no card readers available. Please '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__CardReaders,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('add a card reader')
							])),
						$elm$html$Html$text(' now.')
					])) : $author$project$Utils$Html$empty,
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$CreatePaymentModal$CardReaderSelectMsg,
				A3(
					$author$project$Ui$Form$SearchableSelect$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$SearchableSelect$value(cardReader),
							$author$project$Ui$Form$SearchableSelect$placeholder('Choose Card Reader'),
							$author$project$Ui$Form$SearchableSelect$loading(cardReadersLoading),
							$author$project$Ui$Form$SearchableSelect$disabled(
							$elm$core$List$isEmpty(cardReaders)),
							$author$project$Ui$Form$SearchableSelect$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
							$author$project$Ui$Form$SearchableSelect$errors(
							A2($author$project$Utils$Form$validationErrors, 1, model.PB))
						]),
					A2(
						$elm$core$List$map,
						$author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil),
						cardReaders),
					model.pM)),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[
						$author$project$Ui$Typography$margin(20),
						$author$project$Ui$Typography$muted
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Defaulted to the last reader used on this computer. '),
						$elm$html$Html$text('Tap payments such as Apple Pay & Google Pay are not supported at this time.')
					]))
			]));
};
var $author$project$Components$Invoice$CreatePaymentModal$viewPaymentSources = F2(
	function (model, selected) {
		var selectedSourceId = A2($elm$core$Maybe$map, $author$project$Api$Source$id, selected);
		var patientSources = function () {
			var _v1 = _Utils_Tuple2(model.pN, model.pD);
			if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
				var _v2 = _v1.a;
				var cards = _v2.a;
				var _v3 = _v1.b;
				var bankAccounts = _v3.a;
				return $elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$Source$createdAt,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($elm$time$Time$posixToMillis),
								$elm$core$Maybe$withDefault(0))),
						_Utils_ap(
							A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
							A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
			} else {
				return _List_Nil;
			}
		}();
		var isSelectedInList = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (id) {
					return A2(
						$elm$core$List$any,
						function (s) {
							return _Utils_eq(
								$author$project$Api$Source$id(s),
								id);
						},
						patientSources);
				},
				selectedSourceId));
		var sources = function () {
			var _v0 = _Utils_Tuple2(selected, isSelectedInList);
			if ((!_v0.a.$) && (!_v0.b)) {
				var selectedSource = _v0.a.a;
				return A2($elm$core$List$cons, selectedSource, patientSources);
			} else {
				return patientSources;
			}
		}();
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSelectMsg,
			A3(
				$author$project$Ui$Form$SearchableSelect$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$SearchableSelect$value(selected),
						$author$project$Ui$Form$SearchableSelect$placeholder('Select a Source'),
						$author$project$Ui$Form$SearchableSelect$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB)),
						$author$project$Ui$Form$SearchableSelect$errors(
						A2($author$project$Utils$Form$validationErrors, 2, model.PB))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil),
					sources),
				model.r_));
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewPayNowModal = F3(
	function (model, fields, amountInCentsString) {
		return _List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Process Payment')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel, fields, model),
								$author$project$Utils$Html$empty,
								$author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Source'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										($author$project$Api$Practice$usesCardReaders(model.WF) && (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD))) ? $author$project$Ui$Form$ButtonSelect$view(
										{
											ae4: $author$project$Components$Invoice$CreatePaymentModal$UpdateUseExistingSources,
											zY: _List_fromArray(
												[
													A2($author$project$Ui$Form$ButtonSelect$option, true, 'Existing payment source'),
													A2($author$project$Ui$Form$ButtonSelect$option, false, 'Card Reader')
												]),
											aaN: model.V
										}) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$margin(2)
											]),
										_List_Nil),
										model.V ? A2($author$project$Components$Invoice$CreatePaymentModal$viewPaymentSources, model, fields.Hg) : $author$project$Components$Invoice$CreatePaymentModal$viewCardReaders(model)
									])),
								function () {
								if (!model.V) {
									var _v0 = function () {
										var _v1 = model.hG;
										if (_v1.$ === 3) {
											var cardReaders_ = _v1.a;
											return _Utils_Tuple2(cardReaders_, false);
										} else {
											return _Utils_Tuple2(_List_Nil, true);
										}
									}();
									var cardReaders = _v0.a;
									var cardReadersLoading = _v0.b;
									return A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Remember this card'),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Store card for future use')
													])),
												((!cardReadersLoading) && (!$elm$core$List$isEmpty(cardReaders))) ? A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('Save and set this card as the default payment method for future invoices.')
													])) : $author$project$Utils$Html$empty,
												$author$project$Ui$ToggleSwitch$view(
												_List_fromArray(
													[
														$author$project$Ui$ToggleSwitch$on(fields.Ct),
														$author$project$Ui$ToggleSwitch$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$StoreCard))
													]))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}(),
								$author$project$Components$Invoice$CreatePaymentModal$viewMemoModal(fields)
							])),
						$author$project$Utils$Html$empty,
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Process payment now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(3),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.af, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$CreatePayment)
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 46),
								$elm$html$Html$text(' Process '),
								$elm$html$Html$text(amountInCentsString),
								$elm$html$Html$text(' Now')
							]))
					]))
			]);
	});
var $author$project$Components$Invoice$CreatePaymentModal$viewCreatePaymentModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var amountInCentsString = $author$project$Currency$format(
		A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.I2));
	var modalToDisplay = function () {
		var _v0 = model.qk;
		if (!_v0) {
			return A3($author$project$Components$Invoice$CreatePaymentModal$viewPayNowModal, model, fields, amountInCentsString);
		} else {
			return A3($author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceModal, model, fields, amountInCentsString);
		}
	}();
	return A3($author$project$Ui$Modal$view, $author$project$Components$Invoice$CreatePaymentModal$Close, _List_Nil, modalToDisplay);
};
var $author$project$Components$Invoice$CreatePaymentModal$view = function (_v0) {
	var model = _v0;
	var _v1 = _Utils_Tuple2(model.hF, model.bS);
	if (!_v1.a.$) {
		var _v2 = _v1.a.a;
		var cardReaderConnectingModal = _v2.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg,
			$author$project$Components$CardReader$ConnectingModal$view(cardReaderConnectingModal));
	} else {
		if (!_v1.b.$) {
			var _v3 = _v1.b.a;
			var cardReaderPaymentModal = _v3.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg,
				$author$project$Components$CardReader$PaymentModal$view(cardReaderPaymentModal));
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return $author$project$Components$Invoice$CreatePaymentModal$viewCreatePaymentModal(model);
		}
	}
};
var $author$project$Components$Invoice$PaymentsHistory$Toggle = {$: 0};
var $author$project$Components$PaymentsList$AllowDisputes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentsList$allowDisputes = $author$project$Components$PaymentsList$AllowDisputes;
var $author$project$Components$PaymentsList$AllowRefunds = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentsList$allowRefunds = $author$project$Components$PaymentsList$AllowRefunds;
var $author$project$Components$PaymentsList$IsHintAdmin = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PaymentsList$isHintAdmin = $author$project$Components$PaymentsList$IsHintAdmin;
var $author$project$Ui$Popover$Large = 1;
var $author$project$Ui$Popover$lg = $author$project$Ui$Popover$Size(1);
var $author$project$Components$PaymentsList$ShowRefundMemo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentsList$showRefundMemo = $author$project$Components$PaymentsList$ShowRefundMemo;
var $author$project$Components$PaymentsList$defaultOptions = {abg: false, abj: false, FR: false, sM: false, agZ: false};
var $author$project$Components$PaymentsList$optionsToRecord = A2(
	$elm$core$List$foldl,
	F2(
		function (option, acc) {
			switch (option.$) {
				case 0:
					var bool = option.a;
					return _Utils_update(
						acc,
						{sM: bool});
				case 1:
					var bool = option.a;
					return _Utils_update(
						acc,
						{abj: bool});
				case 2:
					var bool = option.a;
					return _Utils_update(
						acc,
						{agZ: bool});
				case 3:
					var bool = option.a;
					return _Utils_update(
						acc,
						{abg: bool});
				default:
					var bool = option.a;
					return _Utils_update(
						acc,
						{FR: bool});
			}
		}),
	$author$project$Components$PaymentsList$defaultOptions);
var $author$project$Components$PaymentsList$CancelPayment = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$PaymentsList$OpenPaymentDisputeModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentsList$OpenRainforestPaymentModal = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PaymentsList$OpenSimulateDisputeEventModal = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$PaymentsList$OpenSimulateDisputeModal = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$CardReader$Shared$Provider = $elm$core$Basics$identity;
var $author$project$Components$PaymentsList$Refund = function (a) {
	return {$: 0, a: a};
};
var $author$project$Formatters$Time$Time__Full = 0;
var $author$project$Api$Employer$Payment$Shared$attemptedInCents = function (_v0) {
	var record = _v0;
	return record.Jw;
};
var $author$project$Api$Employer$Payment$One$attemptedInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$attemptedInCents(shared);
};
var $author$project$Api$Provider$Payment$Shared$attemptedInCents = function (_v0) {
	var record = _v0;
	return record.Jw;
};
var $author$project$Api$Provider$Payment$One$attemptedInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$attemptedInCents(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$attemptedInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$attemptedInCents(shared);
};
var $author$project$Api$Payment$attemptedInCents = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$attemptedInCents(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$attemptedInCents(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$attemptedInCents(payment_);
	}
};
var $author$project$Components$PaymentSourceDisplayer$CardReader = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$cardReader = $author$project$Components$PaymentSourceDisplayer$CardReader;
var $author$project$Api$Employer$Payment$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Employer$Payment$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Payment$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Payment$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$createdAt(shared);
};
var $author$project$Api$Payment$createdAt = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$createdAt(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$createdAt(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$createdAt(payment_);
	}
};
var $author$project$Api$Provider$Payment$One$createdBy = function (_v0) {
	var record = _v0.b;
	return record.Mg;
};
var $author$project$Api$Payment$createdBy = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$createdBy(payment_);
		case 0:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$Typography$CreatedBy = {$: 20};
var $author$project$Ui$Typography$createdBy = $author$project$Ui$Typography$CreatedBy;
var $author$project$Ui$SvgIcon$CrossCircle = 60;
var $author$project$Ui$SvgIcon$crossCircle = $author$project$Ui$SvgIcon$viewIcon(60);
var $author$project$Api$Provider$Payment$Creator$displayName = function (_v0) {
	var creator = _v0;
	return creator.zh;
};
var $author$project$Api$Dispute$Provider_Shared = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Payment$One$dispute = function (_v0) {
	var record = _v0.b;
	return record.NQ;
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$dispute = function (_v0) {
	var record = _v0.b;
	return record.NQ;
};
var $author$project$Api$Payment$dispute = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$Dispute$Provider_Shared,
				$author$project$Api$Provider$Payment$One$dispute(payment_));
		case 0:
			var payment_ = payment.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$Dispute$Provider_Shared,
				$author$project$Api$Provider$Payment$SharedWithRefunds$dispute(payment_));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Payment$Shared$errorCode = function (_v0) {
	var record = _v0;
	return record.OM;
};
var $author$project$Api$Provider$Payment$One$errorCode = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$errorCode(shared);
};
var $author$project$Api$Payment$errorCode = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$errorCode(payment_);
		case 0:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Payment$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Employer$Payment$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Payment$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$Payment$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$Payment$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$errorMessage(shared);
};
var $author$project$Api$Payment$errorMessage = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$errorMessage(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$errorMessage(payment_);
		default:
			var payment_ = payment.a;
			return $author$project$Api$Employer$Payment$One$errorMessage(payment_);
	}
};
var $author$project$Formatters$String$humanize = $elm_community$string_extra$String$Extra$humanize;
var $author$project$Api$Provider$Payment$Shared$isCancelable = function (_v0) {
	var record = _v0;
	return record.RA;
};
var $author$project$Api$Provider$Payment$One$isCancelable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isCancelable(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$isCancelable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isCancelable(shared);
};
var $author$project$Api$Payment$isCancelable = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$isCancelable(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$isCancelable(payment_);
		default:
			return false;
	}
};
var $author$project$Api$Provider$Payment$Shared$isRefundable = function (_v0) {
	var record = _v0;
	return record.R3;
};
var $author$project$Api$Provider$Payment$One$isRefundable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isRefundable(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$isRefundable(shared);
};
var $author$project$Api$Payment$isRefundable = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$isRefundable(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundable(payment_);
		default:
			return false;
	}
};
var $author$project$Api$Provider$Payment$Shared$memo = function (_v0) {
	var record = _v0;
	return record.aeC;
};
var $author$project$Api$Provider$Payment$One$memo = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$memo(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$memo = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$memo(shared);
};
var $author$project$Api$Payment$memo = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$memo(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$memo(payment_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Source$Shared$oneTimeUse = function (_v0) {
	var record = _v0;
	return record.U7;
};
var $author$project$Api$Refund$Employer_Shared = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Refund$Provider_One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Refund$Provider_Shared = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Payment$One$refunds = function (_v0) {
	var record = _v0.b;
	return record.X3;
};
var $author$project$Api$Provider$Payment$One$refunds = function (_v0) {
	var record = _v0.b;
	return record.X3;
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$refunds = function (_v0) {
	var record = _v0.b;
	return record.X3;
};
var $author$project$Api$Payment$refunds = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$Refund$Provider_One,
				$author$project$Api$Provider$Payment$One$refunds(payment_));
		case 0:
			var payment_ = payment.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$Refund$Provider_Shared,
				$author$project$Api$Provider$Payment$SharedWithRefunds$refunds(payment_));
		default:
			var payment_ = payment.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$Refund$Employer_Shared,
				$author$project$Api$Employer$Payment$One$refunds(payment_));
	}
};
var $author$project$Components$PaymentSourceDisplayer$ShowProcessor = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$showProcessor = $author$project$Components$PaymentSourceDisplayer$ShowProcessor;
var $author$project$Api$Provider$Dispute$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Dispute$One$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Dispute$Shared$status(shared);
};
var $author$project$Api$Dispute$status = function (dispute) {
	if (!dispute.$) {
		var dispute_ = dispute.a;
		return $author$project$Api$Provider$Dispute$One$status(dispute_);
	} else {
		var dispute_ = dispute.a;
		return $author$project$Api$Provider$Dispute$Shared$status(dispute_);
	}
};
var $author$project$Ui$Element$textRight = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textRight);
var $author$project$Api$Platform$Session$One$userIsPracticeAdmin = function (_v0) {
	var record = _v0;
	return record.agy === 'practice_admin';
};
var $author$project$Ui$SvgIcon$Danger = 0;
var $author$project$Ui$SvgIcon$danger = $author$project$Ui$SvgIcon$IconColor(0);
var $author$project$Ui$Badge$fromStringWithIcon = F3(
	function (options, label, icon) {
		var content = _List_fromArray(
			[
				icon,
				$elm$html$Html$text(
				$author$project$Ui$Badge$formatLabel(label))
			]);
		return function (attrs) {
			return A2($elm$html$Html$span, attrs, content);
		}(
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('badge badge--icon'),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Badge$optionToAttr,
					_Utils_ap(
						options,
						$author$project$Ui$Badge$mapColor(label)))));
	});
var $author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping = {EY: 'Cardholder should contact their bank to find out why the payment was declined or try a different payment method.', E3: 'The bank didn\'t approve this payment — often this happens when the purchase is unusual for the cardholder\'s account, like a new merchant or a different amount than normal. Cardholder should contact the bank to approve the payment, or try another payment method.', Fd: 'Ask the cardholder to update their payment method with a valid, unexpired card.', Fn: 'Use a different payment method or contact the associated bank if this may be an error.', Fz: 'Double-check the card details and try again.', FE: 'Use a different payment method or add funds to the respective account before retrying.', FF: 'Some card details weren\'t recognized. Please double-check the card information and try again.', FG: 'Some card details weren\'t recognized. Please double-check the card information and try again.', FH: 'Some card details weren\'t recognized. Please double-check the card information and try again.', F1: 'This card has been reported lost, so the bank won\'t approve the payment. Try a different payment method or contact the bank if this may be a mistake.', Gf: 'This card number isn\'t recognized by the bank — it may have been entered incorrectly or the card may have been replaced. Please double-check the number or use a different payment method.', Gi: 'The card number entered doesn\'t match any known bank. Please double-check the number and try again.', Gx: 'Cardholder should contact their bank to increase their card limit or use another payment method.', GR: 'There was a problem processing the payment. Please try again or use a different payment method.', G3: 'There was a problem processing the payment. Please try again or use a different payment method.', G4: 'Cardholder should contact their bank to find out why the payment was declined or try a different payment method.', G5: 'Bank payment failed — account owner should check the account details and balance or try another method.', G6: 'Contact the bank to find out why the payment was declined or try another payment method.', Ho: 'Cardholder should contact their bank for more information or try a different payment method', Hx: 'Cardholder should contact their bank for more information or try a different payment method', HG: 'Looks like we couldn\'t use the saved card on file. Please re-enter your card details and try again', HJ: 'This card type isn\'t supported. Please try a Visa, Mastercard, or another accepted payment method.'};
var $author$project$Components$PaymentFailedRecommendation$getRecommendationForErrorCode = function (errorCode) {
	var normalizedErrorCode = $elm$core$String$toLower(errorCode);
	switch (normalizedErrorCode) {
		case 'declined':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.EY);
		case 'do_not_honor':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.E3);
		case 'expired_card':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Fd);
		case 'fraudulent_card':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Fn);
		case 'incorrect_payment_information':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Fz);
		case 'insufficient_funds':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FE);
		case 'invalid_card_security_code':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FF);
		case 'invalid_expiration_date':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FG);
		case 'invalid_pin':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FH);
		case 'lost_card':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.F1);
		case 'no_card_number_on_file_with_issuer':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Gf);
		case 'no_such_card_issuer':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Gi);
		case 'over_limit':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Gx);
		case 'processing_error':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.GR);
		case 'retry':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.G3);
		case 'retry_with_threeds':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.G4);
		case 'risk_decline':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.G6);
		case 'stolen_card':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Ho);
		case 'threeds_challenge_failed':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Hx);
		case 'unexpected_payin_token':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.HG);
		case 'unsupported_card_type':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.HJ);
		case 'return_code':
			return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.G5);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$SvgIcon$Warning = 59;
var $author$project$Ui$SvgIcon$warning = $author$project$Ui$SvgIcon$viewIcon(59);
var $author$project$Components$PaymentFailedRecommendation$view = F2(
	function (maybeErrorCode, maybePaymentProcessor) {
		var _v0 = _Utils_Tuple2(
			A2($elm$core$Maybe$andThen, $author$project$Components$PaymentFailedRecommendation$getRecommendationForErrorCode, maybeErrorCode),
			maybePaymentProcessor);
		if (((!_v0.a.$) && (!_v0.b.$)) && (_v0.b.a === 'rainforest')) {
			var recommendation = _v0.a.a;
			return A3(
				$author$project$Ui$Popover$view,
				_List_fromArray(
					[$author$project$Ui$Popover$dark]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Badge$fromStringWithIcon,
						_List_fromArray(
							[$author$project$Ui$Badge$danger]),
						'recommendation',
						$author$project$Ui$SvgIcon$warning(
							_List_fromArray(
								[$author$project$Ui$SvgIcon$danger])))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Popover$body,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(recommendation)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$PaymentsList$CancelRefundClicked = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$PaymentsList$OpenRainforestRefundModal = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Employer$Refund$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Refund$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Refund$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$amountInCents(shared);
};
var $author$project$Api$Refund$amountInCents = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$amountInCents(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$amountInCents(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$amountInCents(refund_);
	}
};
var $author$project$Api$Employer$Refund$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Refund$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Refund$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$createdAt(shared);
};
var $author$project$Api$Refund$createdAt = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$createdAt(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$createdAt(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$createdAt(refund_);
	}
};
var $author$project$Api$Provider$Refund$One$createdBy = function (_v0) {
	var record = _v0.b;
	return record.Mg;
};
var $author$project$Api$Refund$createdBy = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$createdBy(refund_);
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$User$Shared$displayName = function (_v0) {
	var record = _v0;
	return record.NP;
};
var $author$project$Api$Provider$Refund$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$Refund$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$errorMessage(shared);
};
var $author$project$Api$Refund$errorMessage = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$errorMessage(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$errorMessage(refund_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Refund$Shared$external = function (_v0) {
	var record = _v0;
	return record.O4;
};
var $author$project$Api$Provider$Refund$One$external = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$external(shared);
};
var $author$project$Api$Refund$external = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$external(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$external(refund_);
		default:
			return false;
	}
};
var $author$project$Api$Provider$Refund$Shared$memo = function (_v0) {
	var record = _v0;
	return record.aeC;
};
var $author$project$Api$Provider$Refund$One$memo = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$memo(shared);
};
var $author$project$Api$Refund$memo = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$memo(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$memo(refund_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Refund$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$Refund$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$Refund$One$paymentProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$paymentProcessor(shared);
};
var $author$project$Api$Refund$paymentProcessor = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$paymentProcessor(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$paymentProcessor(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$paymentProcessor(refund_);
	}
};
var $author$project$Api$Employer$Refund$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Refund$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Refund$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Refund$Shared$status(shared);
};
var $author$project$Api$Refund$status = function (refund) {
	switch (refund.$) {
		case 0:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$One$status(refund_);
		case 1:
			var refund_ = refund.a;
			return $author$project$Api$Provider$Refund$Shared$status(refund_);
		default:
			var refund_ = refund.a;
			return $author$project$Api$Employer$Refund$Shared$status(refund_);
	}
};
var $author$project$Components$PaymentsList$viewRefund = F5(
	function (timeFormatter, source, optionsRecord, payment, refund) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__refund')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												timeFormatter,
												5,
												$author$project$Api$Refund$createdAt(refund)))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(7)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											function () {
												var _v0 = _Utils_Tuple2(
													$author$project$Api$Refund$paymentProcessor(refund),
													$author$project$Api$Refund$status(refund));
												if ((_v0.a === 'rainforest') && (_v0.b === 'pending')) {
													return 'refund_actually_pending';
												} else {
													var status = _v0.b;
													return 'refund_' + status;
												}
											}()),
											function () {
											if ($author$project$Api$Refund$external(refund)) {
												return $elm$html$Html$text(' Refunded as an external refund');
											} else {
												var _v1 = $author$project$Api$Refund$status(refund);
												if (_v1 === 'cancelled') {
													return $elm$html$Html$text('');
												} else {
													return A2(
														$author$project$Ui$Typography$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(' Processed automatically to '),
																A2(
																$elm$core$Maybe$withDefault,
																$author$project$Utils$Html$empty,
																A4(
																	$author$project$Utils$PaymentProcessor$toBadge,
																	optionsRecord.FR,
																	optionsRecord.FR,
																	refund,
																	A2($elm$core$Basics$composeR, $author$project$Api$Refund$paymentProcessor, $elm$core$Maybe$Just))),
																A2(
																$author$project$Ui$Typography$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$name, source)))
																	])),
																$elm$html$Html$text(' *'),
																$elm$html$Html$text(
																A2(
																	$elm$core$Maybe$withDefault,
																	'',
																	A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$lastFour, source)))
															]));
												}
											}
										}(),
											$author$project$Utils$Html$noBreakSpace,
											$author$project$Utils$Html$noBreakSpace,
											function () {
											var _v2 = _Utils_Tuple3(
												optionsRecord.FR,
												$author$project$Api$Refund$paymentProcessor(refund),
												$author$project$Api$Refund$status(refund));
											_v2$2:
											while (true) {
												_v2$3:
												while (true) {
													_v2$4:
													while (true) {
														if (_v2.b === 'rainforest') {
															switch (_v2.c) {
																case 'pending':
																	return A3(
																		$author$project$Ui$Button$view,
																		{abp: 'Cancel refund'},
																		_List_fromArray(
																			[
																				$author$project$Ui$Button$link,
																				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$crossCircle),
																				$author$project$Ui$Button$onClick(
																				$author$project$Components$PaymentsList$CancelRefundClicked(
																					_Utils_Tuple2(payment, refund)))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Cancel')
																			]));
																case 'canelled':
																	if (_v2.a) {
																		return $author$project$Utils$Html$empty;
																	} else {
																		break _v2$4;
																	}
																case 'failed':
																	if (_v2.a) {
																		break _v2$2;
																	} else {
																		break _v2$3;
																	}
																default:
																	if (_v2.a) {
																		break _v2$2;
																	} else {
																		break _v2$4;
																	}
															}
														} else {
															if (_v2.c === 'failed') {
																break _v2$3;
															} else {
																break _v2$4;
															}
														}
													}
													return $author$project$Utils$Html$empty;
												}
												return A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$danger]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'',
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Formatters$String$humanize,
																	$author$project$Api$Refund$errorMessage(refund))))
														]));
											}
											return A3(
												$author$project$Ui$HinterOnly$button,
												{abp: 'View on rainforest'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick(
														$author$project$Components$PaymentsList$OpenRainforestRefundModal(refund))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View on Rainforest')
													]));
										}(),
											function () {
											var _v3 = _Utils_Tuple2(
												optionsRecord.agZ,
												$author$project$Api$Refund$memo(refund));
											if (_v3.a && (!_v3.b.$)) {
												var memo = _v3.b.a;
												return $elm$html$Html$text(' - ' + memo);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										])),
									optionsRecord.sM ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$createdBy]),
									_List_fromArray(
										[
											$elm$html$Html$text('Created by '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'this platform',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$User$Shared$displayName,
													$author$project$Api$Refund$createdBy(refund)))),
											$elm$html$Html$text(' on '),
											$elm$html$Html$text(
											A2(
												timeFormatter,
												0,
												$author$project$Api$Refund$createdAt(refund)))
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight),
											$author$project$Ui$Typography$danger
										]),
									_List_fromArray(
										[
											($author$project$Api$Refund$status(refund) === 'failed') ? A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'-' + $author$project$Utils$Currency$fromInt(
														$author$project$Api$Refund$amountInCents(refund)))
												])) : A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													'-' + $author$project$Utils$Currency$fromInt(
														$author$project$Api$Refund$amountInCents(refund)))
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Components$PaymentsList$viewPayment = F4(
	function (timeFormatter, optionsRecord, session, payment) {
		var source = $author$project$Api$Payment$source(payment);
		var refunds_ = $author$project$Api$Payment$refunds(payment);
		var cardReader = $author$project$Api$Payment$cardReader(payment);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v0 = $author$project$Api$Payment$paidAt(payment);
											if (!_v0.$) {
												var paidAt_ = _v0.a;
												return $elm$html$Html$text(
													A2(timeFormatter, 5, paidAt_));
											} else {
												return $elm$html$Html$text(
													A2(
														timeFormatter,
														5,
														$author$project$Api$Payment$createdAt(payment)));
											}
										}()
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Payment$status(payment)),
											$author$project$Api$Payment$external(payment) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
											A2(
											$author$project$Components$PaymentSourceDisplayer$view,
											timeFormatter,
											_List_fromArray(
												[
													$author$project$Components$PaymentSourceDisplayer$source(
													A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source)),
													$author$project$Components$PaymentSourceDisplayer$cardReader(
													A2($elm$core$Maybe$map, $elm$core$Basics$identity, cardReader)),
													$author$project$Components$PaymentSourceDisplayer$limitedView(true),
													$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
													$author$project$Components$PaymentSourceDisplayer$showProcessor(optionsRecord.FR),
													$author$project$Components$PaymentSourceDisplayer$paymentProcessor(
													$author$project$Api$Payment$paymentProcessor(payment))
												])),
											function () {
											var _v1 = _Utils_Tuple2(
												$author$project$Api$Payment$status(payment),
												$author$project$Api$Payment$errorMessage(payment));
											if ((_v1.a === 'failed') && (!_v1.b.$)) {
												return A2($elm$html$Html$br, _List_Nil, _List_Nil);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v2 = $author$project$Api$Payment$status(payment);
											switch (_v2) {
												case 'failed':
													return A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$danger]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2(
																	$elm$core$Maybe$withDefault,
																	'',
																	A2(
																		$elm$core$Maybe$map,
																		$author$project$Formatters$String$humanize,
																		$author$project$Api$Payment$errorMessage(payment)))),
																$author$project$Utils$Html$noBreakSpace,
																A2(
																$author$project$Components$PaymentFailedRecommendation$view,
																$author$project$Api$Payment$errorCode(payment),
																$elm$core$Maybe$Just(
																	$author$project$Api$Payment$paymentProcessor(payment)))
															]));
												case 'disputed':
													var _v3 = _Utils_Tuple2(
														optionsRecord.abg,
														$author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
													if (_v3.a && _v3.b) {
														return A3(
															$author$project$Ui$Button$view,
															{abp: 'View dispute'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$PaymentsList$OpenPaymentDisputeModal(payment))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('View Dispute')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												default:
													return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v4 = _Utils_Tuple2(
												optionsRecord.FR,
												$author$project$Api$Payment$paymentProcessor(payment));
											if (_v4.a && (_v4.b === 'rainforest')) {
												return A3(
													$author$project$Ui$HinterOnly$button,
													{abp: 'View on rainforet '},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick(
															$author$project$Components$PaymentsList$OpenRainforestPaymentModal(payment))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('View on Rainforest')
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v5 = _Utils_Tuple3(
												optionsRecord.FR,
												$author$project$Api$Payment$paymentProcessor(payment),
												$author$project$Api$Payment$status(payment));
											if ((_v5.a && (_v5.b === 'rainforest')) && (_v5.c === 'paid')) {
												return A3(
													$author$project$Ui$HinterOnly$button,
													{abp: 'Simulate dispute'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick(
															$author$project$Components$PaymentsList$OpenSimulateDisputeModal(payment))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Simulate Dispute')
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v6 = _Utils_Tuple3(
												optionsRecord.FR,
												$author$project$Api$Payment$paymentProcessor(payment),
												$author$project$Api$Payment$dispute(payment));
											if ((_v6.a && (_v6.b === 'rainforest')) && (!_v6.c.$)) {
												var dispute = _v6.c.a;
												return (($author$project$Api$Dispute$status(dispute) !== 'won') && ($author$project$Api$Dispute$status(dispute) !== 'lost')) ? A3(
													$author$project$Ui$HinterOnly$button,
													{abp: 'Simulate dispute'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick(
															A2($author$project$Components$PaymentsList$OpenSimulateDisputeEventModal, payment, dispute))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Simulate Dispute Event')
														])) : $author$project$Utils$Html$empty;
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v7 = _Utils_Tuple3(
												$author$project$Api$Payment$paymentProcessor(payment),
												$author$project$Api$Payment$status(payment),
												$author$project$Api$Payment$isCancelable(payment));
											if (((_v7.a === 'rainforest') && (_v7.b === 'paid')) && _v7.c) {
												return A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$margin(10)
														]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Cancel payment'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$PaymentsList$CancelPayment(payment)),
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$crossCircle)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Cancel')
																])),
															$author$project$Utils$Html$noBreakSpace,
															A3(
															$author$project$Ui$Tooltip$view,
															_List_Nil,
															'Payment can be cancelled until 10PM EST',
															_List_fromArray(
																[
																	A2($author$project$Ui$Icon$view, _List_Nil, 5)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v8 = $author$project$Api$Payment$memo(payment);
											if (!_v8.$) {
												var memo = _v8.a;
												return A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(' - ' + memo)
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											optionsRecord.sM ? A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$createdBy]),
											_List_fromArray(
												[
													$elm$html$Html$text('Created by '),
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'this platform',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Provider$Payment$Creator$displayName,
															$author$project$Api$Payment$createdBy(payment)))),
													$elm$html$Html$text(' on '),
													$elm$html$Html$text(
													A2(
														timeFormatter,
														0,
														$author$project$Api$Payment$createdAt(payment)))
												])) : $author$project$Utils$Html$empty
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									function () {
									var isNotBankTransfers = !_Utils_eq(
										A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$type_, source),
										$elm$core$Maybe$Just('BankTransfer'));
									return ($author$project$Api$Payment$isRefundable(payment) && (optionsRecord.abj && isNotBankTransfers)) ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textRight]),
										_List_fromArray(
											[
												function () {
												var verb = $author$project$Api$Payment$external(payment) ? 'Record Refund' : 'Process Refund';
												return A3(
													$author$project$Ui$Button$view,
													{abp: verb},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$size(0),
															$author$project$Ui$Button$onClick(
															$author$project$Components$PaymentsList$Refund(payment))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(verb)
														]));
											}()
											])) : $author$project$Utils$Html$empty;
								}()
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											_Utils_eq(
											$author$project$Api$Payment$attemptedInCents(payment),
											$author$project$Api$Payment$amountInCents(payment)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$strike]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Payment$attemptedInCents(payment)))
												])),
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Payment$amountInCents(payment)))
												]))
										])),
									A2(
									$elm$core$Maybe$withDefault,
									false,
									A2($elm$core$Maybe$map, $author$project$Api$Common$Source$Shared$oneTimeUse, source)) ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$createdBy,
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('One time use')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					$elm$core$List$isEmpty(refunds_) ? $author$project$Utils$Html$empty : A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A4($author$project$Components$PaymentsList$viewRefund, timeFormatter, source, optionsRecord, payment),
						refunds_))
				]));
	});
var $author$project$Components$PaymentsList$view = F3(
	function (options, payments, _v0) {
		var timeFormatter = _v0.Hy;
		var session = _v0.ZD;
		var optionsRecord = $author$project$Components$PaymentsList$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('payments-list')
						]),
					A2(
						$elm$core$List$map,
						A3($author$project$Components$PaymentsList$viewPayment, timeFormatter, optionsRecord, session),
						payments))
				]));
	});
var $author$project$Ui$Popover$viewAsClickable = F4(
	function (options, displayedContent, sections, _v0) {
		var model = _v0;
		return A4(
			$author$project$Ui$Popover$popoverView,
			options,
			displayedContent,
			sections,
			$elm$core$Maybe$Just(model));
	});
var $author$project$Ui$Popover$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Popover$visible = $author$project$Ui$Popover$Visible;
var $author$project$Components$Invoice$PaymentsHistory$view = F2(
	function (_v0, model) {
		var allowRefunds = _v0.abj;
		var showRefundMemo = _v0.agZ;
		var isHintAdmin = _v0.FR;
		var allowDisputes = _v0.abg;
		var payments = _v0.V5;
		return $elm$core$List$isEmpty(payments) ? $author$project$Utils$Html$empty : A4(
			$author$project$Ui$Popover$viewAsClickable,
			_List_fromArray(
				[
					$author$project$Ui$Popover$lg,
					$author$project$Ui$Popover$visible(
					$author$project$Ui$Popover$isOpen(model.aM))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'View payment\'s history'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$onClick($author$project$Components$Invoice$PaymentsHistory$Toggle)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment History')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Popover$heading,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Payment History')
						])),
					A2(
					$author$project$Ui$Popover$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg,
							A3(
								$author$project$Components$PaymentsList$view,
								_List_fromArray(
									[
										$author$project$Components$PaymentsList$allowRefunds(allowRefunds),
										$author$project$Components$PaymentsList$showRefundMemo(showRefundMemo),
										$author$project$Components$PaymentsList$isHintAdmin(isHintAdmin),
										$author$project$Components$PaymentsList$allowDisputes(allowDisputes)
									]),
								payments,
								model.jr))
						]))
				]),
			model.aM);
	});
var $author$project$Ui$Breadcrumb$itemOptionToAttributes = function (option) {
	var bool = option;
	return _List_fromArray(
		[
			$elm$html$Html$Attributes$classList(
			_List_fromArray(
				[
					_Utils_Tuple2('active', bool)
				]))
		]);
};
var $author$project$Ui$Breadcrumb$itemOptionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$Breadcrumb$itemOptionToAttributes, options));
};
var $author$project$Ui$Breadcrumb$viewItem = function (_v0) {
	var options = _v0.a;
	var contents = _v0.b;
	return A2(
		$elm$html$Html$li,
		$author$project$Ui$Breadcrumb$itemOptionsToAttributes(options),
		contents);
};
var $author$project$Ui$Breadcrumb$view = F2(
	function (_v0, items) {
		return A2(
			$elm$html$Html$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('breadcrumb')
				]),
			A2($elm$core$List$map, $author$project$Ui$Breadcrumb$viewItem, items));
	});
var $author$project$Ui$Icon$ArrowLeft = 13;
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Delete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Icon$Erase = 10;
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issue = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Pay = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$RecordPayment = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Margin$Right_4 = 17;
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Void = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeInvoice$Meta$adjustAction = function (_v0) {
	var meta = _v0;
	return meta.tF.IB;
};
var $author$project$Ui$Link$ButtonSuccess = 1;
var $author$project$Ui$Link$buttonSuccess = $author$project$Ui$Link$Style(1);
var $author$project$Ui$NewDropdown$Button = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$NewDropdown$Warning = 2;
var $author$project$Ui$NewDropdown$buttonWarning = $author$project$Ui$NewDropdown$Button(2);
var $author$project$Api$Provider$PracticeInvoice$Meta$cancelAction = function (_v0) {
	var meta = _v0;
	return meta.tF.KF;
};
var $author$project$Api$Provider$PracticeInvoice$Meta$destroyAction = function (_v0) {
	var meta = _v0;
	return meta.tF.NA;
};
var $author$project$Ui$SvgIcon$Dollar = 50;
var $author$project$Ui$SvgIcon$dollarSign = $author$project$Ui$SvgIcon$viewIcon(50);
var $author$project$Ui$NewDropdown$view = F4(
	function (options, content, items, model) {
		var toMsg = model.ahx;
		var optionsRecord = $author$project$Ui$NewDropdown$optionsToRecord(options);
		if (optionsRecord.S_) {
			return $author$project$Ui$Skeleton$input(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(2)
					]));
		} else {
			var errorDescription = $elm$core$List$isEmpty(optionsRecord.fE) ? _List_Nil : _List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$attribute,
					'aria-describedby',
					A2($elm$core$String$join, '. ', optionsRecord.fE))
				]);
			var ariaInvalid = (optionsRecord.q$ || (!$elm$core$List$isEmpty(optionsRecord.fE))) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
				]) : _List_Nil;
			var buttonAttributes = A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('new-dropdown__trigger'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$tabindex(0),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$id(model.adR + '-trigger'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$type_('button'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class(
									A2(
										$elm$core$String$join,
										' ',
										_Utils_ap(optionsRecord.lg, optionsRecord.vL))),
								A2(
									$elm$core$List$cons,
									$elm$core$String$isEmpty(optionsRecord.abp) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.abp),
									_Utils_ap(
										optionsRecord.dW ? _List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')
											]) : (optionsRecord.sk ? _List_fromArray(
											[
												$elm$html$Html$Attributes$readonly(true)
											]) : _List_fromArray(
											[
												$author$project$Ui$NewDropdown$triggerKeyHandlers(toMsg),
												$elm$html$Html$Events$onClick(
												toMsg($author$project$Ui$NewDropdown$DropdownButtonClicked))
											])),
										_Utils_ap(errorDescription, ariaInvalid))))))));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('new-dropdown'),
						$elm$html$Html$Attributes$id(model.adR),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('new-dropdown--open', model.U9 && (!optionsRecord.dW)),
								_Utils_Tuple2('new-dropdown--invalid', optionsRecord.q$),
								_Utils_Tuple2('new-dropdown--disabled', optionsRecord.dW)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						buttonAttributes,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline-flex gap-1 items-center')
									]),
								A2(
									$elm$core$List$map,
									$elm$html$Html$map($elm$core$Basics$never),
									content)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('new-dropdown__trigger__chevron'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'ml-1 ',
												!$elm$core$List$isEmpty(content))
											]))
									]),
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$chevronDown(
										_List_fromArray(
											[$author$project$Ui$SvgIcon$xs]))
									]))
							])),
						optionsRecord.dW ? $elm$html$Html$text('') : A3($author$project$Ui$NewDropdown$viewMenu, toMsg, model, items)
					]));
		}
	});
var $author$project$Ui$HinterOnly$dropdown = F4(
	function (options, content, items, dropdownModel) {
		return A4(
			$author$project$Ui$NewDropdown$view,
			options,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$HinterOnly$icon(
					_List_fromArray(
						[$author$project$Ui$SvgIcon$spacedRight])),
				content),
			items,
			dropdownModel);
	});
var $author$project$Api$Common$Source$Shared$external = function (_v0) {
	var record = _v0;
	return record.O4;
};
var $author$project$Ui$Element$InlineBlock = 1;
var $author$project$Ui$Element$inlineBlock = A2($author$project$Ui$Element$Display, 0, 1);
var $author$project$Api$Provider$PracticeInvoice$Meta$issueAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Sh;
};
var $author$project$Ui$Button$Margin = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Button$margin = $author$project$Ui$Button$Margin;
var $author$project$Api$Provider$PracticeInvoice$Shared$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Api$Provider$PracticeInvoice$One$meta = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeInvoice$Shared$meta(shared);
};
var $author$project$Ui$Element$ml1 = $author$project$Ui$Element$Margin('ml-1');
var $author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction = function (_v0) {
	var meta = _v0;
	return meta.tF.V6;
};
var $author$project$Api$Provider$PracticeInvoice$Meta$refundAction = function (_v0) {
	var meta = _v0;
	return meta.tF.X2;
};
var $author$project$Api$Provider$PracticeInvoice$One$securePdfInlineToken = function (_v0) {
	var record = _v0.b;
	return record.Ze;
};
var $author$project$Ui$Button$success = $author$project$Ui$Button$Styled(3);
var $author$project$Ui$SvgIcon$Export = 49;
var $author$project$Ui$SvgIcon$export = $author$project$Ui$SvgIcon$viewIcon(49);
var $author$project$Components$Invoice$DownloadFile$defaultOptions = {QG: true, aej: $elm$core$Maybe$Nothing, Du: true};
var $author$project$Components$Invoice$DownloadFile$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var string = option.a;
					return _Utils_update(
						record,
						{
							aej: $elm$core$Maybe$Just(string)
						});
				} else {
					var bool = option.a;
					return _Utils_update(
						record,
						{Du: bool});
				}
			}),
		$author$project$Components$Invoice$DownloadFile$defaultOptions,
		options);
};
var $author$project$Components$Invoice$DownloadFile$viewModal = A3(
	$author$project$Ui$Modal$view,
	$author$project$Components$Invoice$DownloadFile$CloseModal,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Modal$header(
			_List_fromArray(
				[
					$author$project$Ui$Modal$title('In Progress')
				])),
			$author$project$Ui$Modal$body(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Your file is being processed and may take a few seconds.')
						])),
					$author$project$Ui$Spinner$view(_List_Nil)
				]))
		]));
var $author$project$Components$Invoice$DownloadFile$view = F4(
	function (model, token, options, buttonOptions) {
		var optionsRecord = $author$project$Components$Invoice$DownloadFile$optionsToRecord(options);
		var _v0 = _Utils_Tuple2('Download', $author$project$Ui$SvgIcon$export);
		var verb = _v0.a;
		var icon_ = _v0.b;
		var buttonLabel = function () {
			var _v1 = optionsRecord.aej;
			if (!_v1.$) {
				var label_ = _v1.a;
				return label_;
			} else {
				return verb;
			}
		}();
		var link = A3(
			$author$project$Ui$Button$view,
			{abp: buttonLabel},
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Button$onClick(
					$author$project$Components$Invoice$DownloadFile$DownloadFileClicked(token)),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Button$icon(icon_),
					buttonOptions)),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonLabel)
				]));
		var button = optionsRecord.Du ? A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			verb + ' PDF',
			_List_fromArray(
				[link])) : link;
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline text-left')
				]),
			_List_fromArray(
				[
					button,
					model.R0 ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewActions = F5(
	function (practiceInvoice, isHintAdmin, saveRequest, dropdownMenu, downloadInvoice) {
		var meta = $author$project$Api$Provider$PracticeInvoice$One$meta(practiceInvoice);
		var actions = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					function () {
					if ($author$project$Api$Provider$PracticeInvoice$Meta$cancelAction(meta)) {
						var voidText = function () {
							var _v1 = $author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice);
							if (!_v1) {
								return 'Void & Refund';
							} else {
								return 'Void';
							}
						}();
						return $elm$core$Maybe$Just(
							A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Void(practiceInvoice))
									]),
								A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A2($author$project$Ui$Icon$view, _List_Nil, 10),
											$elm$html$Html$text(voidText)
										]))));
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}(),
					$author$project$Api$Provider$PracticeInvoice$Meta$issueAction(meta) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issue(practiceInvoice))
							]),
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2($author$project$Ui$Icon$view, _List_Nil, 13),
									$elm$html$Html$text('Return To Issued')
								])))) : $elm$core$Maybe$Nothing,
					$author$project$Api$Provider$PracticeInvoice$Meta$adjustAction(meta) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal(practiceInvoice))
							]),
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$dollarSign(_List_Nil),
									$elm$html$Html$text('Add Charge or Credit')
								])))) : $elm$core$Maybe$Nothing,
					$author$project$Api$Provider$PracticeInvoice$Meta$refundAction(meta) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal(practiceInvoice))
							]),
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$dollarSign(_List_Nil),
									$elm$html$Html$text('Add Credit & Refund')
								])))) : $elm$core$Maybe$Nothing
				]));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg,
				A4(
					$author$project$Components$Invoice$DownloadFile$view,
					downloadInvoice,
					$author$project$Api$Provider$PracticeInvoice$One$securePdfInlineToken(practiceInvoice),
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$margin(17)
						]))),
				((!$elm$core$List$isEmpty(actions)) && isHintAdmin) ? A4(
				$author$project$Ui$HinterOnly$dropdown,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$disabled(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
						$author$project$Ui$NewDropdown$buttonWarning
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$ml1]),
						_List_fromArray(
							[
								$elm$html$Html$text('Revise Invoice')
							]))
					]),
				actions,
				dropdownMenu) : $author$project$Utils$Html$empty,
				($author$project$Api$Provider$PracticeInvoice$Meta$destroyAction(meta) && isHintAdmin) ? A3(
				$author$project$Ui$HinterOnly$button,
				{abp: 'Delete practice invoice'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Delete(practiceInvoice)),
						$author$project$Ui$Button$loading(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Delete')
					])) : $author$project$Utils$Html$empty,
				($author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta) && (!$author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)))) ? A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__PaymentSources,
				_List_fromArray(
					[$author$project$Ui$Link$buttonSuccess]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Payment Source')
					])) : $author$project$Utils$Html$empty,
				($author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta) && isHintAdmin) ? A3(
				$author$project$Ui$HinterOnly$button,
				{abp: 'Record payment'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$loading(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$RecordPayment(practiceInvoice))
					]),
				_List_fromArray(
					[
						$author$project$Utils$Html$noBreakSpace,
						$elm$html$Html$text('Record Payment')
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta),
					$author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice));
				if (_v0.a && (!_v0.b.$)) {
					var source = _v0.b.a;
					return (!$author$project$Api$Common$Source$Shared$external(source)) ? A3(
						$author$project$Ui$Button$view,
						{abp: 'Pay now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$success,
								$author$project$Ui$Button$loading(
								_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Pay(practiceInvoice))
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 46),
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('Pay now')
							])) : $author$project$Utils$Html$empty;
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
	});
var $author$project$Api$Provider$PracticeInvoice$One$invoiceType = function (_v0) {
	var record = _v0.b;
	return record.Rr;
};
var $author$project$Ui$Form$Static$Phi = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Static$phi = $author$project$Ui$Form$Static$Phi;
var $author$project$Api$Provider$PracticeCharge$Shared$serviceDescription = function (_v0) {
	var record = _v0;
	return record.ZC;
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewCharge = F2(
	function (practiceInvoice, practiceCharge) {
		var showUsageInfo = ($author$project$Api$Provider$PracticeInvoice$One$invoiceType(practiceInvoice) === 'pmpm') && ($author$project$Api$Provider$PracticeCharge$Shared$quantity(practiceCharge) > 1);
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$PracticeCharge$Shared$description(practiceCharge))
										])),
									$author$project$Utils$Html$noBreakSpace,
									showUsageInfo ? A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									'Usage charges are based on the preceding billing period',
									_List_fromArray(
										[
											A2($author$project$Ui$Icon$view, _List_Nil, 5)
										])) : $author$project$Utils$Html$empty,
									function () {
									var _v0 = $author$project$Api$Provider$PracticeCharge$Shared$serviceDescription(practiceCharge);
									if (!_v0.$) {
										var serviceDescription = _v0.a;
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Static$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(serviceDescription)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$PracticeCharge$Shared$quantity(practiceCharge)))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromFloat(
										$author$project$Api$Provider$PracticeCharge$Shared$priceInCents(practiceCharge)))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(practiceCharge)))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeeItem = function (practiceCharge) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-left', '2em')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(
					$author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(practiceCharge)) + (' for ' + $author$project$Api$Provider$PracticeCharge$Shared$description(practiceCharge)))
			]));
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeesCharges = function (practiceCharges) {
	if ($elm$core$List$length(practiceCharges) > 0) {
		var itemsDescriptions = A2($elm$core$List$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeeItem, practiceCharges);
		var fixedFeeSubtotalInCents = $elm$core$List$sum(
			A2($elm$core$List$map, $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents, practiceCharges));
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(6)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Fixed Fees')
								])),
						itemsDescriptions)),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('1')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(fixedFeeSubtotalInCents))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(fixedFeeSubtotalInCents))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$HiConfirm$CustomTitle = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$HiConfirm$customTitle = $author$project$Components$HiConfirm$CustomTitle;
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$voidInvoiceConfirm = F2(
	function (practiceInvoice, voidRequest) {
		var _v0 = $author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice);
		if (!_v0) {
			var paidInCents = $author$project$Utils$Currency$fromInt(
				$author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice));
			var customMessage = $elm$html$Html$text(
				'You are about to void and refund Invoice #' + ($elm$core$String$fromInt(
					$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)) + (' and refund ' + (paidInCents + ' to the practice.'))));
			return A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed(practiceInvoice),
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('void'),
						$author$project$Components$HiConfirm$customTitle('Void & Refund'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								customMessage,
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('This action cannot be undone.')
							])),
						$author$project$Components$HiConfirm$noun('& Refund ' + paidInCents),
						$author$project$Components$HiConfirm$loading(
						_Utils_eq(voidRequest, $author$project$Api$Data$Loading))
					]));
		} else {
			var customMessage = $elm$html$Html$text(
				'You are about to void Invoice #' + ($elm$core$String$fromInt(
					$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)) + '.'));
			return A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed(practiceInvoice),
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('void'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								customMessage,
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('This action cannot be undone.')
							])),
						$author$project$Components$HiConfirm$noun('Invoice'),
						$author$project$Components$HiConfirm$loading(
						_Utils_eq(voidRequest, $author$project$Api$Data$Loading))
					]));
		}
	});
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.h8;
			if (!_v0.$) {
				var _v1 = _v0.a;
				var practiceInvoice = _v1.a;
				var deleteRequest = _v1.b;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed(practiceInvoice),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun(
							'Invoice #' + $elm$core$String$fromInt(
								$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice))),
							$author$project$Components$HiConfirm$detail(
							'for ' + $author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice))),
							$author$project$Components$HiConfirm$loading(
							_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v2 = model.ty;
			if (!_v2.$) {
				var _v3 = _v2.a;
				var practiceInvoice = _v3.a;
				var voidRequest = _v3.b;
				return A2($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$voidInvoiceConfirm, practiceInvoice, voidRequest);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v4 = model.lC;
			if (!_v4.$) {
				var createPaymentModal = _v4.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg,
					$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v5 = model.hW;
			if (!_v5.$) {
				var modal = _v5.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg,
					A2(
						$author$project$Components$HintBilling$CreateChargeModal$view,
						modal,
						$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$chargeModalTitle(model.WH)));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg,
			$author$project$Components$Invoice$PaymentsHistory$modal(model.jq)),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					function () {
						var _v6 = model.WH;
						if (_v6.$ === 3) {
							var practiceInvoice = _v6.a;
							var _v7 = A2(
								$elm$core$List$partition,
								function (item) {
									return $author$project$Api$Provider$PracticeCharge$Shared$fromRecurringCharge(item);
								},
								$author$project$Api$Provider$PracticeInvoice$One$charges(practiceInvoice));
							var fixedFeeCharges = _v7.a;
							var nonFixedFeeCharges = _v7.b;
							return $elm$core$List$concat(
								_List_fromArray(
									[
										_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$elm$core$Basics$never,
											A2(
												$author$project$Ui$Breadcrumb$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Breadcrumb$item,
														_List_Nil,
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Admin__Billing,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Billing')
																	]))
															])),
														A2(
														$author$project$Ui$Breadcrumb$item,
														_List_fromArray(
															[
																$author$project$Ui$Breadcrumb$active(true)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																'#' + $elm$core$String$fromInt(
																	$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)))
															]))
													]))),
											$author$project$Ui$HorizontalRule$view(_List_Nil),
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$mb2]),
															_List_fromArray(
																[
																	$author$project$Ui$Typography$heading(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Invoice '),
																			$elm$html$Html$text(
																			'#' + $elm$core$String$fromInt(
																				$author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)))
																		]))
																])),
															$author$project$Ui$Typography$headingSm(
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(
																		$author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice))),
																	$author$project$Utils$Html$noBreakSpace,
																	$author$project$Api$Provider$PracticeInvoice$Status$toBadge(
																	$author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice))
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
															A5($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewActions, practiceInvoice, model.FR, model.jY, model.lV, model.iq))
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Payer'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Api$Provider$Practice$One$name(model.WF)),
																			function () {
																			var _v8 = A2(
																				$elm$core$Maybe$andThen,
																				$author$project$Api$Common$Phone$Shared$number,
																				$elm$core$List$head(
																					$author$project$Api$Provider$Practice$One$phones(model.WF)));
																			if (!_v8.$) {
																				var phoneNumber = _v8.a;
																				return A2(
																					$author$project$Ui$Typography$div,
																					_List_fromArray(
																						[
																							$author$project$Ui$Typography$phi(true)
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(
																							$author$project$Formatters$Phone$format(phoneNumber))
																						]));
																			} else {
																				return $author$project$Utils$Html$empty;
																			}
																		}(),
																			function () {
																			var _v9 = $author$project$Api$Provider$Practice$One$address(model.WF);
																			if (!_v9.$) {
																				var address = _v9.a;
																				return $author$project$Components$AddressDisplay$view(address);
																			} else {
																				return $author$project$Utils$Html$empty;
																			}
																		}()
																		]))
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Invoice Date'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8),
																	$author$project$Ui$Form$Group$clearfix
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2(
																				$author$project$Formatters$Date$toString,
																				$author$project$Formatters$Date$Full,
																				$author$project$Api$Provider$PracticeInvoice$One$date(practiceInvoice)))
																		]))
																])),
															function () {
															var _v10 = $author$project$Api$Provider$PracticeInvoice$One$purchaseOrderNumber(practiceInvoice);
															if (!_v10.$) {
																var purchaseOrderNumber = _v10.a;
																return A2(
																	$author$project$Ui$Form$Group$view,
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Group$label('PO #'),
																			$author$project$Ui$Form$Group$labelSpan(4),
																			$author$project$Ui$Form$Group$inputSpan(8),
																			$author$project$Ui$Form$Group$clearfix,
																			$author$project$Ui$Form$Group$margin(19)
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Form$Static$view,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(purchaseOrderNumber)
																				]))
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}(),
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Autopay'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8),
																	$author$project$Ui$Form$Group$clearfix
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Formatters$Bool$toString(
																				$author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled(practiceInvoice)))
																		]))
																])),
															$author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled(practiceInvoice) ? A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Autopay On'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8),
																	$author$project$Ui$Form$Group$clearfix
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2(
																					$elm$core$Maybe$map,
																					$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																					$author$project$Api$Provider$PracticeInvoice$One$autoPayDate(practiceInvoice))))
																		]))
																])) : $author$project$Utils$Html$empty,
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Payment Source'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8),
																	$author$project$Ui$Form$Group$clearfix
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			function () {
																			var _v11 = $author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice);
																			if (!_v11.$) {
																				var source = _v11.a;
																				return A2(
																					$author$project$Components$PaymentSourceDisplayer$view,
																					model.Hy,
																					_List_fromArray(
																						[
																							$author$project$Components$PaymentSourceDisplayer$source(
																							$elm$core$Maybe$Just(
																								$author$project$Api$Source$Source(source))),
																							$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
																							$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																						]));
																			} else {
																				return A2($author$project$Ui$Badge$fromString, _List_Nil, 'none');
																			}
																		}()
																		]))
																])),
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Total Paid'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8),
																	$author$project$Ui$Form$Group$clearfix
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$strong,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Utils$Currency$fromInt(
																						$author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice))),
																					function () {
																					if (!$author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice)) {
																						var showPaymentTime = true;
																						var format = showPaymentTime ? 2 : 6;
																						return $elm$html$Html$text(
																							' on ' + A2(
																								$elm$core$Maybe$withDefault,
																								'N/A',
																								A2(
																									$elm$core$Maybe$map,
																									model.Hy(format),
																									$author$project$Api$Provider$PracticeInvoice$One$paidAt(practiceInvoice))));
																					} else {
																						return $author$project$Utils$Html$empty;
																					}
																				}()
																				]))
																		])),
																	A2(
																	$elm$html$Html$map,
																	$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg,
																	A2(
																		$author$project$Components$Invoice$PaymentsHistory$view,
																		{
																			abg: model.FR,
																			abj: model.FR,
																			FR: model.FR,
																			V5: A2(
																				$elm$core$List$map,
																				$author$project$Api$Payment$Provider_One,
																				$author$project$Api$Provider$PracticeInvoice$One$payments(practiceInvoice)),
																			agZ: false
																		},
																		model.jq))
																])),
															A2(
															$author$project$Ui$Form$Group$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Group$label('Total Due'),
																	$author$project$Ui$Form$Group$labelSpan(4),
																	$author$project$Ui$Form$Group$inputSpan(8),
																	$author$project$Ui$Form$Group$clearfix
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Typography$strong,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Utils$Currency$fromInt(
																						$author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)))
																				]))
																		]))
																]))
														]))
												])),
											$author$project$Ui$HorizontalRule$view(_List_Nil),
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[
																	$author$project$Ui$Typography$hintLabel,
																	$author$project$Ui$Typography$muted,
																	$author$project$Ui$Typography$pull(0)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Charges')
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(2)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$numeric]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Qty')
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(2)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$numeric]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Price')
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(2)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$numeric]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Amount')
																]))
														]))
												]))
										]),
										A2(
										$elm$core$List$cons,
										$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeesCharges(fixedFeeCharges),
										A2(
											$elm$core$List$map,
											$author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewCharge(practiceInvoice),
											nonFixedFeeCharges)),
										_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(3),
															$author$project$Ui$FlexGrid$offset(7)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Total')
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(2)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Static$view,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$div,
																	_List_fromArray(
																		[$author$project$Ui$Typography$numeric, $author$project$Ui$Typography$bold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Utils$Currency$fromInt(
																				$author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice)))
																		]))
																]))
														]))
												]))
										])
									]));
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]))
								]);
						}
					}())
				]))
		]);
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$view = function (model) {
	return {
		e5: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewBody(model),
		$G: 'Admin | Billing'
	};
};
var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$init, aer: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$load, agD: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$save, ahd: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$subscriptions, aaq: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$update, ahP: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$view});
var $author$project$Pages$Admin$CancellationReasons$GotItems = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$CancellationReason$cancellationReasonsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['cancellation_reasons']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CancellationReason$All$CancellationReason = $elm$core$Basics$identity;
var $author$project$Api$Provider$CancellationReason$Shared$CancellationReason = $elm$core$Basics$identity;
var $author$project$Api$Provider$CancellationReason$Shared$Record = F3(
	function (id, description, meta) {
		return {Nx: description, adR: id, TU: meta};
	});
var $author$project$Api$Provider$CancellationReason$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$CancellationReason$Meta$MetaRecord = function (editable) {
	return {Oa: editable};
};
var $author$project$Api$Provider$CancellationReason$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CancellationReason$Meta$MetaRecord));
var $author$project$Api$Provider$CancellationReason$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CancellationReason$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CancellationReason$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$CancellationReason$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CancellationReason$Shared$Record))));
var $author$project$Api$Provider$CancellationReason$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CancellationReason$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CancellationReason$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CancellationReason$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CancellationReason$listDefaults = {afy: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$CancellationReason$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CancellationReason$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.afy);
};
var $author$project$Api$Provider$CancellationReason$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CancellationReason$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CancellationReason$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CancellationReason$cancellationReasonsPath)));
	});
var $author$project$Pages$Admin$CancellationReasons$fetchItems = function (model) {
	return A3(
		$author$project$Api$Provider$CancellationReason$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy});
		},
		$author$project$Pages$Admin$CancellationReasons$GotItems);
};
var $author$project$Pages$Admin$CancellationReasons$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var model = {D5: apiClient, ic: $elm$core$Maybe$Nothing, dN: $elm$core$Set$empty, FU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading, afy: $author$project$Api$Pagination$init};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$CancellationReasons$fetchItems(model));
	});
var $author$project$Pages$Admin$CancellationReasons$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CancellationReasons$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CancellationReasons$CancelEdit = {$: 2};
var $author$project$Pages$Admin$CancellationReasons$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$CancellationReasons$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CancellationReasons$CancelEdit)),
					model.FU)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CancellationReasons$HiConfirmClosed),
					model.ic))
			]));
};
var $author$project$Pages$Admin$CancellationReasons$Deleted = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$CancellationReason$cancellationReasonPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$CancellationReason$cancellationReasonsPath);
};
var $author$project$Api$Provider$CancellationReason$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CancellationReason$cancellationReasonPath(id_)));
	});
var $author$project$Api$Provider$CancellationReason$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$CancellationReason$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CancellationReason$Shared$description(shared);
};
var $author$project$Pages$Admin$CancellationReasons$formFieldsFromItem = function (item) {
	return $author$project$Api$Provider$CancellationReason$All$description(item);
};
var $author$project$Pages$Admin$CancellationReasons$formFieldsInit = '';
var $author$project$Pages$Admin$CancellationReasons$formFieldsUpdate = F2(
	function (field, _v0) {
		var description = field;
		return description;
	});
var $author$project$Pages$Admin$CancellationReasons$DescriptionValidation = 0;
var $rtfeldman$elm_validate$Validate$isWhitespaceChar = function (_char) {
	return (_char === ' ') || ((_char === '\n') || ((_char === '\t') || (_char === '\u000D')));
};
var $rtfeldman$elm_validate$Validate$isBlank = function (str) {
	isBlank:
	while (true) {
		var _v0 = $elm$core$String$uncons(str);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var rest = _v1.b;
			if ($rtfeldman$elm_validate$Validate$isWhitespaceChar(_char)) {
				var $temp$str = rest;
				str = $temp$str;
				continue isBlank;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var $rtfeldman$elm_validate$Validate$ifBlank = F2(
	function (subjectToString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $rtfeldman$elm_validate$Validate$isBlank(
					subjectToString(subject));
			},
			error);
	});
var $author$project$Pages$Admin$CancellationReasons$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a description.'))
		]));
var $author$project$Api$Provider$CancellationReason$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CancellationReason$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CancellationReason$Shared$id(shared);
};
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Pages$Admin$CancellationReasons$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$CancellationReason$One$CancellationReason = 0;
var $author$project$Api$Provider$CancellationReason$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$CancellationReason$create = F3(
	function (apiClient, description_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cancellation_reason',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(description_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CancellationReason$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CancellationReason$cancellationReasonsPath)));
	});
var $author$project$Pages$Admin$CancellationReasons$createItem = F2(
	function (apiClient, formFields) {
		var description = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$CancellationReason$create, apiClient, description, $author$project$Pages$Admin$CancellationReasons$Created);
	});
var $author$project$Pages$Admin$CancellationReasons$Updated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CancellationReason$update = F4(
	function (apiClient, id_, description_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cancellation_reason',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(description_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CancellationReason$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CancellationReason$cancellationReasonPath(id_))));
	});
var $author$project$Pages$Admin$CancellationReasons$updateItem = F3(
	function (apiClient, id, formFields) {
		var description = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$CancellationReason$update, apiClient, id, description, $author$project$Pages$Admin$CancellationReasons$Updated);
	});
var $author$project$Pages$Admin$CancellationReasons$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A3($author$project$Pages$Admin$CancellationReasons$updateItem, apiClient, id, formFields);
		} else {
			return A2($author$project$Pages$Admin$CancellationReasons$createItem, apiClient, formFields);
		}
	});
var $author$project$Pages$Admin$CancellationReasons$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$CancellationReasons$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v1 = model.FU;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var id = _v2.a;
					var form = _v2.b;
					var item = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CancellationReasons$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var form = msg.a;
				var id = msg.b;
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CancellationReasons$formFieldsValidator, form);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$CancellationReasons$saveItem, model.D5, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$CancellationReason$All$id(item)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$CancellationReasons$formFieldsFromItem(item)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iZ: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				var _v6 = model.FU;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$CancellationReasons$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v9 = model.FU;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$CancellationReasons$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2($elm$core$Set$remove, id, model.dN),
									iZ: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$CancellationReasons$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2($elm$core$Set$remove, id, model.dN)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$CancellationReasons$fetchItems(newModel),
					_List_Nil);
			case 10:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Nothing,
							dN: A2($elm$core$Set$insert, id, model.dN)
						}),
					A3(
						$author$project$Api$Provider$CancellationReason$delete,
						model.D5,
						id,
						$author$project$Pages$Admin$CancellationReasons$Deleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ic: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$CancellationReasons$New = {$: 0};
var $author$project$Pages$Admin$CancellationReasons$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Button$default = $author$project$Ui$Button$Styled(0);
var $author$project$Api$Data$isSuccess = function (data) {
	if (data.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Ui$Pagination$List$Loading = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Pagination$List$loading = $author$project$Ui$Pagination$List$Loading;
var $author$project$Components$HiConfirm$Sentence = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$HiConfirm$sentence = $author$project$Components$HiConfirm$Sentence;
var $author$project$Pages$Admin$CancellationReasons$Description = $elm$core$Basics$identity;
var $author$project$Pages$Admin$CancellationReasons$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$CancellationReasons$Save = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Admin$CancellationReasons$viewItemModal = F3(
	function (maybeId, item, form) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Cancellation Reason',
			S_: _Utils_eq(item, $author$project$Api$Data$Loading),
			Tv: maybeId,
			Tw: $elm$core$Maybe$Just('This update will be effective for future and historical terminations.'),
			U_: $author$project$Pages$Admin$CancellationReasons$CancelEdit,
			U0: $author$project$Pages$Admin$CancellationReasons$Save(form)
		};
		var description = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(description),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$placeholder('Add a reason'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CancellationReasons$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Ui$Table$VerticalCentered = {$: 2};
var $author$project$Ui$Table$verticalCentered = $author$project$Ui$Table$VerticalCentered;
var $author$project$Pages$Admin$CancellationReasons$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CancellationReasons$OpenHiConfirm = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$CancellationReason$Meta$editable = function (_v0) {
	var meta = _v0;
	return meta.Oa;
};
var $author$project$Api$Provider$CancellationReason$Shared$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Api$Provider$CancellationReason$All$meta = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CancellationReason$Shared$meta(shared);
};
var $author$project$Pages$Admin$CancellationReasons$viewItem = F2(
	function (deletingItems, item) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$CancellationReason$All$description(item))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if ($author$project$Api$Provider$CancellationReason$Meta$editable(
							$author$project$Api$Provider$CancellationReason$All$meta(item))) {
							var id = $author$project$Api$Provider$CancellationReason$All$id(item);
							var loading = A2($elm$core$Set$member, id, deletingItems);
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Edit cancellation reason'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$disabled(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$CancellationReasons$Edit(item)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Delete cancellation reason'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$size(0),
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$CancellationReasons$OpenHiConfirm(id)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Pages$Admin$CancellationReasons$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.iZ;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('Add a reason to start tracking why patients end their memberships.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Description')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$CancellationReasons$viewItem(model.dN),
			items),
		_List_Nil);
};
var $author$project$Pages$Admin$CancellationReasons$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.FU;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var item = _v1.c;
					return A3($author$project$Pages$Admin$CancellationReasons$viewItemModal, id, item, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ic;
				if (!_v2.$) {
					var id = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$CancellationReasons$HiConfirmClosed(id),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('cancellation reason'),
								$author$project$Components$HiConfirm$sentence('If a membership currently has this cancellation reason, it will not have it afterwards.')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Reasons for Membership Cancellation')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'New cancellation reason'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$pull(1),
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$CancellationReasons$New),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Cancellation Reason')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$CancellationReasons$viewPanelBody(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$CancellationReasons$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.iZ))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Cancellation Reasons'
	};
};
var $author$project$Pages$Admin$CancellationReasons$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CancellationReasons$init, aer: $author$project$Pages$Admin$CancellationReasons$load, agD: $author$project$Pages$Admin$CancellationReasons$save, ahd: $author$project$Pages$Admin$CancellationReasons$subscriptions, aaq: $author$project$Pages$Admin$CancellationReasons$update, ahP: $author$project$Pages$Admin$CancellationReasons$view});
var $author$project$Pages$Admin$CardReaders$GotCardReaderConfiguration = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$CardReaders$None = {$: 2};
var $author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['card_reader_configuration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CardReaderConfiguration$One$CardReaderConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReaderConfiguration$Shared$CardReaderConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CardReaderConfiguration$Shared$Record = function (status) {
	return {ag7: status};
};
var $author$project$Api$Provider$CardReaderConfiguration$Shared$Active = 0;
var $author$project$Api$Provider$CardReaderConfiguration$Shared$Inactive = 1;
var $author$project$Api$Provider$CardReaderConfiguration$Shared$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'active':
				return $elm$json$Json$Decode$succeed(0);
			case 'inactive':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported Card Reader Configuration status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$CardReaderConfiguration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$author$project$Api$Provider$CardReaderConfiguration$Shared$statusDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReaderConfiguration$Shared$Record));
var $author$project$Api$Provider$CardReaderConfiguration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReaderConfiguration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CardReaderConfiguration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CardReaderConfiguration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CardReaderConfiguration$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CardReaderConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath));
	});
var $author$project$Pages$Admin$CardReaders$init = F4(
	function (session, practice, shared, _v0) {
		var model = {
			D5: shared.D5,
			abR: $author$project$Pages$Admin$CardReaders$None,
			lk: $author$project$Api$Data$Loading,
			hG: $author$project$Api$Data$Loading,
			h9: $elm$core$Maybe$Nothing,
			fn: $elm$core$Set$empty,
			ik: false,
			qT: shared.qT,
			FR: $author$project$Shared$isHintAdmin(shared),
			WF: practice,
			ZD: session
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Api$Provider$CardReaderConfiguration$retrieve, shared.D5, $author$project$Pages$Admin$CardReaders$GotCardReaderConfiguration));
	});
var $author$project$Pages$Admin$CardReaders$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CardReaders$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CardReaders$Cancel = {$: 6};
var $author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$CardReaders$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.abR;
				if (_v0.$ === 2) {
					return $elm$core$Platform$Sub$none;
				} else {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CardReaders$Cancel);
				}
			}(),
				model.ik ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed),
					model.h9))
			]));
};
var $author$project$Pages$Admin$CardReaders$Adding = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CardReaders$CardReadersActivated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$CardReaders$DeletedCardReader = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$CardReaders$Editing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CardReaderConfiguration$activate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CardReaderConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath)));
	});
var $author$project$Pages$Admin$CardReaders$CreatedCardReader = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CardReader$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'card_reader',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(fields.aej)),
								_Utils_Tuple2(
								'registration_code',
								$elm$json$Json$Encode$string(fields.K3))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CardReader$Shared$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReadersPath)));
	});
var $author$project$Pages$Admin$CardReaders$create = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {K3: fields.K3, aej: fields.aej};
		return A3($author$project$Api$Provider$CardReader$create, apiClient, apiFields, $author$project$Pages$Admin$CardReaders$CreatedCardReader);
	});
var $author$project$Pages$Admin$CardReaders$CardReadersDeactivated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$CardReaderConfiguration$deactivate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CardReaderConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deactivate']),
					$author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath)));
	});
var $author$project$Pages$Admin$CardReaders$deactivateIntegration = function (model) {
	return _Utils_Tuple3(
		model,
		function (fn) {
			return fn($author$project$Pages$Admin$CardReaders$CardReadersDeactivated);
		}(
			$author$project$Api$Provider$CardReaderConfiguration$deactivate(model.D5)),
		_List_Nil);
};
var $author$project$Api$Provider$CardReader$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CardReader$cardReaderPath(id)));
	});
var $author$project$Pages$Admin$CardReaders$editFormFieldsUpdate = F2(
	function (field, _v0) {
		if (field.$ === 1) {
			var string = field.a;
			return string;
		} else {
			return '';
		}
	});
var $author$project$Pages$Admin$CardReaders$EditLabelValidation = 0;
var $author$project$Pages$Admin$CardReaders$editFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a label.'))
		]));
var $author$project$Pages$Admin$CardReaders$GotCardReaders = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CardReaders$fetchCardReaders = function (apiClient) {
	return A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Pages$Admin$CardReaders$GotCardReaders);
};
var $author$project$Pages$Admin$CardReaders$formFieldsFromCardReader = function (cardReader) {
	return $author$project$Api$Provider$CardReader$All$label(cardReader);
};
var $author$project$Pages$Admin$CardReaders$formFieldsInit = {K3: '', aej: ''};
var $author$project$Pages$Admin$CardReaders$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{K3: string});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{aej: string});
		}
	});
var $author$project$Pages$Admin$CardReaders$CodeValidation = 0;
var $author$project$Pages$Admin$CardReaders$LabelValidation = 1;
var $author$project$Pages$Admin$CardReaders$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.aej;
			},
			_Utils_Tuple2(1, 'Please enter a label.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.K3;
			},
			_Utils_Tuple2(0, 'Please enter a code.'))
		]));
var $author$project$Ports$Intercom$intercomPortOpen = _Platform_outgoingPort(
	'intercomPortOpen',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Intercom$open = function (session) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortOpen(0);
};
var $author$project$Api$Provider$CardReaderConfiguration$Shared$status = function (_v0) {
	var shared = _v0;
	return shared.ag7;
};
var $author$project$Api$Provider$CardReaderConfiguration$One$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReaderConfiguration$Shared$status(shared);
};
var $author$project$Pages$Admin$CardReaders$UpdatedCardReader = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$CardReader$update = F4(
	function (apiClient, id, label_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'card_reader',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(label_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CardReader$Shared$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CardReader$cardReaderPath(id))));
	});
var $author$project$Pages$Admin$CardReaders$updateCardReader = F3(
	function (apiClient, id, validForm) {
		var validLabel = $rtfeldman$elm_validate$Validate$fromValid(validForm);
		return A4($author$project$Api$Provider$CardReader$update, apiClient, id, validLabel, $author$project$Pages$Admin$CardReaders$UpdatedCardReader);
	});
var $author$project$Pages$Admin$CardReaders$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					function (fn) {
						return fn($author$project$Pages$Admin$CardReaders$CardReadersActivated);
					}(
						$author$project$Api$Provider$CardReaderConfiguration$activate(model.D5)),
					_List_Nil);
			case 13:
				var cardReaderConfiguration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lk: cardReaderConfiguration}),
					function () {
						if (cardReaderConfiguration.$ === 3) {
							var conf = cardReaderConfiguration.a;
							var _v2 = $author$project$Api$Provider$CardReaderConfiguration$One$status(conf);
							if (!_v2) {
								return $author$project$Pages$Admin$CardReaders$fetchCardReaders(model.D5);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					$author$project$OutMsg$reportDecodeError(cardReaderConfiguration));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hG: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							abR: $author$project$Pages$Admin$CardReaders$Adding(
								_Utils_Tuple2(
									$author$project$Utils$Form$init($author$project$Pages$Admin$CardReaders$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var cardReader = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							abR: $author$project$Pages$Admin$CardReaders$Editing(
								_Utils_Tuple3(
									$author$project$Api$Provider$CardReader$All$id(cardReader),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$CardReaders$formFieldsFromCardReader(cardReader)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				var _v3 = model.abR;
				switch (_v3.$) {
					case 0:
						var _v4 = _v3.a;
						var form = _v4.a;
						var cardReader = _v4.b;
						var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CardReaders$formFieldsUpdate, field, form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									abR: $author$project$Pages$Admin$CardReaders$Adding(
										_Utils_Tuple2(newForm, cardReader))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 1:
						var _v5 = _v3.a;
						var id = _v5.a;
						var form = _v5.b;
						var editingCardReader = _v5.c;
						var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CardReaders$editFormFieldsUpdate, field, form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									abR: $author$project$Pages$Admin$CardReaders$Editing(
										_Utils_Tuple3(id, newForm, editingCardReader))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var saveCardReader = msg.a;
				if (!saveCardReader.$) {
					var form = saveCardReader.a;
					var _v7 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CardReaders$formFieldsValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var newForm = _v8.a;
						var validFormFields = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									abR: $author$project$Pages$Admin$CardReaders$Adding(
										_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
								}),
							A2($author$project$Pages$Admin$CardReaders$create, model.D5, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									abR: $author$project$Pages$Admin$CardReaders$Adding(
										_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					var form = saveCardReader.a;
					var id = saveCardReader.b;
					var _v9 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CardReaders$editFormFieldsValidator, form);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var newForm = _v10.a;
						var validFormFields = _v10.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									abR: $author$project$Pages$Admin$CardReaders$Editing(
										_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Pages$Admin$CardReaders$updateCardReader, model.D5, id, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v9.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									abR: $author$project$Pages$Admin$CardReaders$Editing(
										_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{abR: $author$project$Pages$Admin$CardReaders$None}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var response = msg.a;
				var _v11 = model.abR;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var form = _v12.a;
					if (response.$ === 3) {
						var cardReader = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{abR: $author$project$Pages$Admin$CardReaders$None, hG: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$CardReaders$fetchCardReaders(model.D5),
										A2(
										$author$project$Ports$LocalStorage$setItem,
										'last-used-card-reader',
										$author$project$Api$Provider$CardReader$Shared$id(cardReader))
									])),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$CardReader$Shared$label(cardReader))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									abR: $author$project$Pages$Admin$CardReaders$Adding(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{abR: $author$project$Pages$Admin$CardReaders$None, hG: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$CardReaders$fetchCardReaders(model.D5),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Card reader updated')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{abR: $author$project$Pages$Admin$CardReaders$None}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var cardReader = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							h9: $elm$core$Maybe$Just(cardReader)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var cardReader = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									hG: $author$project$Api$Data$Loading,
									fn: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$CardReader$All$id(cardReader),
										model.fn)
								}),
							$author$project$Pages$Admin$CardReaders$fetchCardReaders(model.D5),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$CardReader$All$label(cardReader) + ' was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									fn: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$CardReader$All$id(cardReader),
										model.fn)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var configurationData = msg.a;
				switch (configurationData.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lk: configurationData}),
							$author$project$Pages$Admin$CardReaders$fetchCardReaders(model.D5),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Card reader integration activated. Please add your card reader now.')
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(configurationData));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var configurationData = msg.a;
				switch (configurationData.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lk: configurationData}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Card reader integration deactivated.')
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(configurationData));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ik: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				var confirmed = msg.a;
				return confirmed ? $author$project$Pages$Admin$CardReaders$deactivateIntegration(
					_Utils_update(
						model,
						{ik: false})) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ik: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var cardReader = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$CardReader$All$id(cardReader);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								h9: $elm$core$Maybe$Nothing,
								fn: A2($elm$core$Set$insert, id, model.fn)
							}),
						A3(
							$author$project$Api$Provider$CardReader$delete,
							model.D5,
							id,
							$author$project$Pages$Admin$CardReaders$DeletedCardReader(cardReader)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h9: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$open(model.ZD),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$CardReaders$AddCardReaderButtonClicked = {$: 2};
var $author$project$Api$Feature$AllowStripeCardReaders = 14;
var $author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmOpened = {$: 14};
var $author$project$Pages$Admin$CardReaders$ShowSupportChat = {$: 17};
var $author$project$Pages$Admin$CardReaders$rainforestSetupStepTwo = _List_fromArray(
	[
		$elm$html$Html$text('Set up your new card readers once they arrive by clicking \'Add Card Reader\' above. If you need assistance, please '),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Contact support'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
				$author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$ShowSupportChat)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('contact Support')
			]))
	]);
var $author$project$Pages$Admin$CardReaders$stripeSetupStepTwo = _List_fromArray(
	[
		$elm$html$Html$text('Please click on \"Add Card Reader\" above to initiate the process. If you need more assistance such as setting up Wi-Fi, please refer to these'),
		A3(
		$author$project$Ui$Link$externalHref,
		'https://docs.stripe.com/terminal/payments/setup-reader',
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				$elm$html$Html$text(' guides.')
			]))
	]);
var $author$project$Pages$Admin$CardReaders$setupStepTwo = function (practice) {
	return ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') ? $author$project$Pages$Admin$CardReaders$stripeSetupStepTwo : $author$project$Pages$Admin$CardReaders$rainforestSetupStepTwo;
};
var $author$project$Ui$ListGroup$defaultOptions = {vw: _List_Nil, DS: $elm$core$Maybe$Nothing};
var $author$project$Ui$ListGroup$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var contents = option.a;
					return _Utils_update(
						record,
						{
							DS: $elm$core$Maybe$Just(contents)
						});
				} else {
					var style_ = option.a;
					switch (style_) {
						case 0:
							return _Utils_update(
								record,
								{
									vw: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('background-success'),
										record.vw)
								});
						case 1:
							return _Utils_update(
								record,
								{
									vw: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('background-info'),
										record.vw)
								});
						case 2:
							return _Utils_update(
								record,
								{
									vw: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('background-warning'),
										record.vw)
								});
						case 3:
							return _Utils_update(
								record,
								{
									vw: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('background-error'),
										record.vw)
								});
						default:
							return _Utils_update(
								record,
								{
									vw: A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$class('background-header'),
										record.vw)
								});
					}
				}
			}),
		$author$project$Ui$ListGroup$defaultOptions,
		options);
};
var $author$project$Ui$ListGroup$itemOptionToAttributes = function (option) {
	switch (option.$) {
		case 0:
			var style_ = option.a;
			switch (style_) {
				case 0:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item-success')
						]);
				case 1:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item-info')
						]);
				case 2:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item-warning')
						]);
				case 3:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item-danger')
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-group-item__header')
						]);
			}
		case 1:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('clearfix')
				]);
		case 2:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('note')
				]);
		case 3:
			return _List_fromArray(
				[
					$elm$html$Html$Attributes$class('active')
				]);
		default:
			return _List_fromArray(
				[$author$project$Utils$Html$Attributes$none]);
	}
};
var $author$project$Ui$ListGroup$itemOptionsToAttributes = function (options) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$Attributes$map($elm$core$Basics$never),
		A2($elm$core$List$concatMap, $author$project$Ui$ListGroup$itemOptionToAttributes, options));
};
var $author$project$Ui$ListGroup$viewItem = function (_v0) {
	var options = _v0.a;
	var contents = _v0.b;
	return A2(
		$elm$html$Html$li,
		A2(
			$elm$core$List$cons,
			$elm$html$Html$Attributes$class('list-group-item'),
			$author$project$Ui$ListGroup$itemOptionsToAttributes(options)),
		contents);
};
var $author$project$Ui$ListGroup$viewZeroState = function (zeroState_) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-center list-group-item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(zeroState_)
			]));
};
var $author$project$Ui$ListGroup$view = F2(
	function (options, items) {
		var optionsRecord = $author$project$Ui$ListGroup$optionsToRecord(options);
		return A2(
			$elm$html$Html$ul,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('list-group'),
				optionsRecord.vw),
			_Utils_ap(
				function () {
					var _v0 = _Utils_Tuple2(
						optionsRecord.DS,
						$elm$core$List$isEmpty(items));
					if ((!_v0.a.$) && _v0.b) {
						var zeroState_ = _v0.a.a;
						return _List_fromArray(
							[
								$author$project$Ui$ListGroup$viewZeroState(zeroState_)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2($elm$core$List$map, $author$project$Ui$ListGroup$viewItem, items)));
	});
var $author$project$Pages$Admin$CardReaders$DeleteCardReaderButtonClicked = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$CardReaders$EditCardReaderButtonClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$ListGroup$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$ListGroup$item = $author$project$Ui$ListGroup$Item;
var $author$project$Api$Provider$CardReader$Shared$serialNumber = function (_v0) {
	var record = _v0;
	return record.Zy;
};
var $author$project$Api$Provider$CardReader$All$serialNumber = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CardReader$Shared$serialNumber(shared);
};
var $author$project$Pages$Admin$CardReaders$viewCardReader = F2(
	function (showProcessor, cardReader) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(9)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											$author$project$Utils$Html$empty,
											A4(
												$author$project$Utils$PaymentProcessor$toBadge,
												showProcessor,
												showProcessor,
												cardReader,
												A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just))),
											$elm$html$Html$text(
											$author$project$Api$Provider$CardReader$All$label(cardReader))
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											' - SN: ' + $author$project$Api$Provider$CardReader$All$serialNumber(cardReader))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'edit card reader'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$CardReaders$EditCardReaderButtonClicked(cardReader)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete card reader'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$CardReaders$DeleteCardReaderButtonClicked(cardReader)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CardReaders$viewMigrationAlert = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('m-0'),
			A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Alert$warning,
			_List_fromArray(
				[
					$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Card readers purchased from Stripe are not compatible with Hint Payments. Please order a new reader as part of Hint Payments setup.'),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('list-align-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint will cover the cost if you want to replace your card reader.')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Please complete this '),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://hinthealth.typeform.com/to/xgWqDFVc',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('form')
										])),
									$elm$html$Html$text(' to place an order and we\'ll take care of the rest.')
								]))
						]))
				]))
		]));
var $author$project$Ui$Tooltip$Active = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Tooltip$active = $author$project$Ui$Tooltip$Active;
var $author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip = F2(
	function (usingStripe, contents) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$active(usingStripe),
					$author$project$Ui$Tooltip$wide
				]),
			'Card readers are only supported on Hint Payments',
			contents);
	});
var $author$project$Pages$Admin$CardReaders$viewActiveAccount = function (model) {
	var usingStripe = $author$project$Api$Provider$Practice$One$paymentProcessor(model.WF) === 'stripe';
	var allowAddingReader = (!usingStripe) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 14, model.WF);
	return _List_fromArray(
		[
			usingStripe ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[$author$project$Pages$Admin$CardReaders$viewMigrationAlert])) : $author$project$Utils$Html$empty,
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'active'),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Deactivate the integration'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$pull(1),
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmOpened)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Deactivate the integration')
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('You can now allow patients to pay in-person with credit or '),
							$elm$html$Html$text('debit cards directly using your connected card readers.')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Card Readers'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip,
					!allowAddingReader,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add card reader'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$AddCardReaderButtonClicked),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
									$author$project$Ui$Button$disabled(!allowAddingReader)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Card Reader')
								]))
						])),
					function () {
					var _v0 = model.hG;
					if (_v0.$ === 3) {
						var cardReaders = _v0.a;
						return $elm$core$List$isEmpty(cardReaders) ? $author$project$Utils$Html$empty : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$ListGroup$view,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Pages$Admin$CardReaders$viewCardReader(model.FR),
										cardReaders))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				])),
			usingStripe ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Setup Information'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ol,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text('Order your reader')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Select and order reader(s) through Hint Support ('),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://support.hint.com/en/articles/10967048-ordering-a-card-reader',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('Instructions here')
										])),
									$elm$html$Html$text(').')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text('Set up your new card reader')
										]))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							$author$project$Pages$Admin$CardReaders$setupStepTwo(model.WF))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$CardReaders$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CardReaders$Label = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CardReaders$Save = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$CardReaders$Updating = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$CardReaders$viewEditModal = F3(
	function (id, form, cardReader) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Card Reader',
			S_: _Utils_eq(cardReader, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(id),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$CardReaders$Cancel,
			U0: function (_v0) {
				return $author$project$Pages$Admin$CardReaders$Save(
					A2($author$project$Pages$Admin$CardReaders$Updating, form, id));
			}
		};
		var label = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Reader Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(label),
									$author$project$Ui$Form$Input$placeholder('e.g. Lobby Computer'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Label)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CardReaders$ActivateIntegrationClicked = {$: 0};
var $author$project$Api$Provider$Practice$Shared$hasPaymentProcessorAccount = function (_v0) {
	var record = _v0;
	return record.Qd;
};
var $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$hasPaymentProcessorAccount(shared);
};
var $author$project$Api$Common$Address$Shared$isAddressIncomplete = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$List$any,
		$elm$core$Basics$identity,
		A2(
			$elm$core$List$map,
			$elm$core$String$isEmpty,
			A2(
				$elm$core$List$map,
				$elm$core$Maybe$withDefault(''),
				_List_fromArray(
					[record.rf, record.pT, record.sZ, record.tC, record.pZ]))));
};
var $author$project$Api$Provider$Practice$One$hasValidAddress = function (_v0) {
	var record = _v0.b;
	var _v1 = record.It;
	if (!_v1.$) {
		var address_ = _v1.a;
		return !$author$project$Api$Common$Address$Shared$isAddressIncomplete(address_);
	} else {
		return false;
	}
};
var $author$project$Pages$Admin$CardReaders$renderHtmlIf = F2(
	function (condition, element) {
		return condition ? element : $elm$html$Html$text('');
	});
var $author$project$Pages$Admin$CardReaders$viewRequirementsAlert = function (practice) {
	var hasValidAddress = $author$project$Api$Provider$Practice$One$hasValidAddress(practice);
	var hasPaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice);
	return (hasPaymentProcessorAccount && hasValidAddress) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('m-0'),
				A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$warning,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The card reader integration requires ')
							])),
						A2(
						$author$project$Pages$Admin$CardReaders$renderHtmlIf,
						!hasValidAddress,
						A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Practice,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('an up-to-date address')
								]))),
						A2(
						$author$project$Pages$Admin$CardReaders$renderHtmlIf,
						(!hasPaymentProcessorAccount) && (!hasValidAddress),
						A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' and ')
								]))),
						A2(
						$author$project$Pages$Admin$CardReaders$renderHtmlIf,
						!hasPaymentProcessorAccount,
						function () {
							var _v0 = $author$project$Api$Provider$Practice$One$paymentProcessor(practice);
							if (_v0 === 'stripe') {
								return A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Stripe,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('an active Stripe account')
										]));
							} else {
								return A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__PaymentProcessing,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('an active Payment Processing account')
										]));
							}
						}()),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('.')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$CardReaders$viewInactiveAccount = function (practice) {
	var usingStripe = $author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe';
	var hasValidAddress = $author$project$Api$Provider$Practice$One$hasValidAddress(practice);
	var hasPaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice);
	return _List_fromArray(
		[
			usingStripe ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					$author$project$Pages$Admin$CardReaders$viewRequirementsAlert(practice)
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
						])),
					A2(
					$author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip,
					usingStripe,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Enable Card Readers Integration'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$disabled((!hasPaymentProcessorAccount) || ((!hasValidAddress) || usingStripe)),
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$ActivateIntegrationClicked)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Enable Card Readers Integration')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('About'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Customers can swipe or insert their cards into our reader for storing and processing payments.')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('How it works'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ol,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Enable the card reader integration.')
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Order your card reader(s) through Hint Support ('),
											A3(
											$author$project$Ui$Link$externalHref,
											'https://support.hint.com/en/articles/10967048-ordering-a-card-reader',
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('Instructions here')
												])),
											$elm$html$Html$text(').')
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Connect your card reader(s) in Hint once they arrive.')
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Start accepting payments using your card reader(s).')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$CardReaders$Code = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CardReaders$Creating = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Image$RainforestCardReaderSplash = 6;
var $author$project$Ui$Popover$Footer = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Popover$footer = $author$project$Ui$Popover$Footer;
var $author$project$Ui$Image$Height = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Image$height = $author$project$Ui$Image$Height;
var $author$project$Ui$Image$Cdn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Image$Local = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Image$imageToSource = function (image) {
	switch (image) {
		case 0:
			return $author$project$Ui$Image$Local('find-ga-code');
		case 1:
			return $author$project$Ui$Image$Local('elationemr-logo');
		case 2:
			return $author$project$Ui$Image$Local('stripe-logo');
		case 3:
			return $author$project$Ui$Image$Local('mailgun-logo');
		case 4:
			return $author$project$Ui$Image$Local('sample-check');
		case 5:
			return $author$project$Ui$Image$Local('stripe-terminal-verifone-default-splash');
		case 6:
			return $author$project$Ui$Image$Local('rainforest-terminal-splash');
		case 13:
			return $author$project$Ui$Image$Local('help-circle');
		case 7:
			return $author$project$Ui$Image$Local('elationemr-blue-logo');
		case 8:
			return $author$project$Ui$Image$Cdn('partners/quickbooks/QuickBooks%20Logo_Horz.png');
		case 9:
			return $author$project$Ui$Image$Cdn('partners/quickbooks/C2QB_green_btn_lg_default.png');
		case 10:
			return $author$project$Ui$Image$Cdn('marketing-whitelabel-attribution.svg');
		case 11:
			return $author$project$Ui$Image$Cdn('logo-mark.svg');
		case 12:
			return $author$project$Ui$Image$Cdn('full-logo.svg');
		case 14:
			return $author$project$Ui$Image$Cdn('onboarding-complete.png');
		case 15:
			return $author$project$Ui$Image$Local('product-highlight-image-placeholder');
		default:
			return $author$project$Ui$Image$Local('marketplace-icon-placeholder');
	}
};
var $author$project$Ui$Image$nameToCdnSrc = function (imagePath) {
	return 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/' + imagePath;
};
var $author$project$Ui$Image$nameToLocalSrc = F2(
	function (_v0, image) {
		var store = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (_v1) {
						var imagePath = _v1.a;
						return _Utils_eq(imagePath, image);
					},
					store)));
	});
var $author$project$Ui$Image$imageToSrc = F2(
	function (store, image) {
		var _v0 = $author$project$Ui$Image$imageToSource(image);
		if (!_v0.$) {
			var nameString = _v0.a;
			return A2($author$project$Ui$Image$nameToLocalSrc, store, nameString);
		} else {
			var nameString = _v0.a;
			return $author$project$Ui$Image$nameToCdnSrc(nameString);
		}
	});
var $author$project$Ui$Image$Alt = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $author$project$Ui$Image$defaultOptions = {vw: _List_Nil};
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Image$screenSizeToHeightAutoClass = function (screenSize) {
	return $author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'h-auto';
};
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Ui$Image$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$width(_int),
									record.vw)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$alt(string),
									record.vw)
							});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(string),
									record.vw)
							});
					case 3:
						var _int = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$height(_int),
									record.vw)
							});
					case 4:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('w-full block'),
									record.vw)
							});
					case 5:
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class('rounded-lg'),
									record.vw)
							});
					default:
						var screenSize = option.a;
						var sizeClass = $author$project$Ui$Image$screenSizeToHeightAutoClass(screenSize);
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(sizeClass),
									record.vw)
							});
				}
			}),
		$author$project$Ui$Image$defaultOptions,
		options);
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Ui$Image$viewImg = F3(
	function (_v0, stringSrc, optionsMinusAlt) {
		var alt = _v0.I1;
		var options = A2(
			$elm$core$List$cons,
			$author$project$Ui$Image$Alt(alt),
			optionsMinusAlt);
		var optionsRecord = $author$project$Ui$Image$optionsToRecord(options);
		return A2(
			$elm$html$Html$img,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$src(stringSrc),
				optionsRecord.vw),
			_List_Nil);
	});
var $author$project$Ui$Image$view = F4(
	function (store, accessibilityOptions, options, source) {
		return A3(
			$author$project$Ui$Image$viewImg,
			accessibilityOptions,
			A2($author$project$Ui$Image$imageToSrc, store, source),
			options);
	});
var $author$project$Ui$Image$Width = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Image$width = $author$project$Ui$Image$Width;
var $author$project$Pages$Admin$CardReaders$viewRainforestConnectInstructions = function (imageStore) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Popover$view,
					_List_fromArray(
						[$author$project$Ui$Popover$dark]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Make sure the reader is on standby mode ')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Ui$Icon$view, _List_Nil, 5)
										]))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Popover$body,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The standby reader screen should look like this:')
								])),
							A2(
							$author$project$Ui$Popover$footer,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Image$view,
									imageStore,
									{I1: 'Rainforest card reader standby screen displaying 6-digit registration code'},
									_List_fromArray(
										[
											$author$project$Ui$Image$width(320),
											$author$project$Ui$Image$height(320)
										]),
									6)
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Identify the reader\'s registration code.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Registration codes are the 6 digits displayed on the reader screen.')
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Fill in the registration code below')
				]))
		]);
};
var $author$project$Ui$Image$StripeCardReaderSplash = 5;
var $author$project$Pages$Admin$CardReaders$viewStripeConnectInstructions = function (imageStore) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Popover$view,
					_List_fromArray(
						[$author$project$Ui$Popover$dark]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Make sure the reader is on standby mode ')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Ui$Icon$view, _List_Nil, 5)
										]))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Popover$body,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The standby reader screen should look like this:')
								])),
							A2(
							$author$project$Ui$Popover$footer,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Image$view,
									imageStore,
									{I1: 'Stripe card reader standby screen showing welcome message'},
									_List_Nil,
									5)
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Generate a pairing code.')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Keypad: ')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Enter the key sequence 0-7-1-3-9.')
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Touchscreen: ')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Swipe right from the left edge of the reader screen to reveal a settings button. '),
									$elm$html$Html$text('Tap the settings button and enter the admin PIN 0-7-1-3-9. Tap the generate pairing code button.')
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Fill in the pairing code below')
				]))
		]);
};
var $author$project$Pages$Admin$CardReaders$viewConnectInstructions = F2(
	function (imageStore, practice) {
		var _v0 = $author$project$Api$Provider$Practice$One$paymentProcessor(practice);
		if (_v0 === 'stripe') {
			return $author$project$Pages$Admin$CardReaders$viewStripeConnectInstructions(imageStore);
		} else {
			return $author$project$Pages$Admin$CardReaders$viewRainforestConnectInstructions(imageStore);
		}
	});
var $author$project$Pages$Admin$CardReaders$viewModal = F4(
	function (imageStore, practice, form, cardReader) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Card Reader',
			S_: _Utils_eq(cardReader, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Nothing,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$CardReaders$Cancel,
			U0: function (_v1) {
				return $author$project$Pages$Admin$CardReaders$Save(
					$author$project$Pages$Admin$CardReaders$Creating(form));
			}
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var label = _v0.aej;
		var code = _v0.K3;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('How it works'),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ol,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
										]),
									A2($author$project$Pages$Admin$CardReaders$viewConnectInstructions, imageStore, practice))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Code'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(code),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Code)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Reader Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(label),
									$author$project$Ui$Form$Input$placeholder('e.g. Lobby Computer'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Label)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CardReaders$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.abR;
				switch (_v0.$) {
					case 0:
						var _v1 = _v0.a;
						var form = _v1.a;
						var cardReader = _v1.b;
						return A4($author$project$Pages$Admin$CardReaders$viewModal, model.qT, model.WF, form, cardReader);
					case 1:
						var _v2 = _v0.a;
						var id = _v2.a;
						var form = _v2.b;
						var cardReader = _v2.c;
						return A3($author$project$Pages$Admin$CardReaders$viewEditModal, id, form, cardReader);
					default:
						return $author$project$Utils$Html$empty;
				}
			}(),
				model.ik ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								$elm$html$Html$text('Please confirm you would like to deactivate this card reader integration. '),
								$elm$html$Html$text('Your card readers may need to be synced again manually in the future.')
							]))
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v3 = model.h9;
				if (!_v3.$) {
					var cardReader = _v3.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed(cardReader),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('card reader')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[$author$project$Ui$Form$horizontal]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Card Readers')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v4 = model.lk;
									switch (_v4.$) {
										case 3:
											var conf = _v4.a;
											var _v5 = $author$project$Api$Provider$CardReaderConfiguration$One$status(conf);
											if (!_v5) {
												return $author$project$Pages$Admin$CardReaders$viewActiveAccount(model);
											} else {
												return $author$project$Pages$Admin$CardReaders$viewInactiveAccount(model.WF);
											}
										case 1:
											return _List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]);
										default:
											return _List_Nil;
									}
								}())
							]))
					]))
			]),
		$G: 'Integrations | Card Readers'
	};
};
var $author$project$Pages$Admin$CardReaders$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CardReaders$init, aer: $author$project$Pages$Admin$CardReaders$load, agD: $author$project$Pages$Admin$CardReaders$save, ahd: $author$project$Pages$Admin$CardReaders$subscriptions, aaq: $author$project$Pages$Admin$CardReaders$update, ahP: $author$project$Pages$Admin$CardReaders$view});
var $author$project$Pages$Admin$Categories$GotCategories = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Common$Category$ListOptionals$ThisMonthChargesAggregates = 0;
var $author$project$Api$Provider$Category$categoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['categories']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Category$All$Category = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Category$Shared$Category = $elm$core$Basics$identity;
var $author$project$Api$Provider$Category$Shared$Record = F3(
	function (id, name, defaultForMemberships) {
		return {E$: defaultForMemberships, adR: id, zh: name};
	});
var $author$project$Api$Provider$Category$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'default_for_memberships',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$Shared$Record))));
var $author$project$Api$Provider$Category$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Category$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Category$All$Record = F3(
	function (lastUsedAt, chargesThisMonthCount, chargesThisMonthAmountInCents) {
		return {KV: chargesThisMonthAmountInCents, KW: chargesThisMonthCount, SF: lastUsedAt};
	});
var $author$project$Api$Provider$Category$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'charges_this_month_amount_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$author$project$Api$Expandable$expandable,
		'charges_this_month_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_used_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$All$Record))));
var $author$project$Api$Provider$Category$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Category$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Category$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$All$Category)));
var $author$project$Api$Param$Bool = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Param$bool = $author$project$Api$Param$Bool;
var $author$project$Api$Common$Category$ListOptionals$defaults = {E$: $elm$core$Maybe$Nothing, Fc: _List_Nil, adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Common$Category$ListOptionals$expandToString = function (expand) {
	return 'this_month_charges_aggregates';
};
var $author$project$Api$Expandable$toParam = F2(
	function (toString, expand) {
		return _List_fromArray(
			[
				A2(
				$author$project$Api$Param$list,
				'expand',
				A2($elm$core$List$map, toString, expand))
			]);
	});
var $author$project$Api$Common$Category$ListOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$Category$ListOptionals$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.E$;
				if (!_v2.$) {
					var bool = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'default_for_memberships', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$elm$core$List$isEmpty(options.Fc) ? _List_Nil : A2($author$project$Api$Expandable$toParam, $author$project$Api$Common$Category$ListOptionals$expandToString, options.Fc),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Category$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Category$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Category$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Category$categoriesPath)));
	});
var $author$project$Pages$Admin$Categories$fetchCategories = function (model) {
	return A3(
		$author$project$Api$Provider$Category$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					Fc: _List_fromArray(
						[0]),
					afy: model.afy
				});
		},
		$author$project$Pages$Admin$Categories$GotCategories);
};
var $author$project$Pages$Admin$Categories$init = F4(
	function (_v0, practice, shared, _v1) {
		var model = {D5: shared.D5, KL: $author$project$Api$Data$Loading, Ex: $elm$core$Maybe$Nothing, dI: $elm$core$Set$empty, bW: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, WF: practice, Hy: shared.Hy};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$Categories$fetchCategories(model));
	});
var $author$project$Pages$Admin$Categories$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Categories$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Categories$CancelCategoryEdit = {$: 2};
var $author$project$Pages$Admin$Categories$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Api$Provider$Category$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Category$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Category$Shared$id(shared);
};
var $author$project$Pages$Admin$Categories$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Categories$CancelCategoryEdit)),
					model.Ex)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Categories$HiConfirmClosed),
						$author$project$Api$Provider$Category$All$id),
					model.bW))
			]));
};
var $author$project$Pages$Admin$Categories$CategoryDeleted = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$Category$categoryPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Category$categoriesPath);
};
var $author$project$Api$Provider$Category$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Category$categoryPath(id_)));
	});
var $author$project$Api$Provider$Category$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Category$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Category$Shared$name(shared);
};
var $author$project$Pages$Admin$Categories$formFieldsFromCategory = function (category) {
	return $author$project$Api$Provider$Category$All$name(category);
};
var $author$project$Pages$Admin$Categories$formFieldsInit = '';
var $author$project$Pages$Admin$Categories$formFieldsUpdate = F2(
	function (field, _v0) {
		var string = field;
		return string;
	});
var $author$project$Pages$Admin$Categories$NameValidation = 0;
var $author$project$Pages$Admin$Categories$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Pages$Admin$Categories$CategoryCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Category$One$Category = 0;
var $author$project$Api$Provider$Category$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Category$create = F3(
	function (apiClient, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Category$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Category$categoriesPath)));
	});
var $author$project$Pages$Admin$Categories$createCategory = F2(
	function (apiClient, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$Category$create, apiClient, name, $author$project$Pages$Admin$Categories$CategoryCreated);
	});
var $author$project$Pages$Admin$Categories$CategoryUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Category$update = F4(
	function (apiClient, id_, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Category$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Category$categoryPath(id_))));
	});
var $author$project$Pages$Admin$Categories$updateCategory = F3(
	function (apiClient, id, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Category$update, apiClient, id, name, $author$project$Pages$Admin$Categories$CategoryUpdated);
	});
var $author$project$Pages$Admin$Categories$saveCategory = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A3($author$project$Pages$Admin$Categories$updateCategory, apiClient, id, formFields);
		} else {
			return A2($author$project$Pages$Admin$Categories$createCategory, apiClient, formFields);
		}
	});
var $author$project$Pages$Admin$Categories$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Ex: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$Categories$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v1 = model.Ex;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var id = _v2.a;
					var form = _v2.b;
					var category = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Categories$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ex: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, category))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var form = msg.a;
				var id = msg.b;
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Categories$formFieldsValidator, form);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ex: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$Categories$saveCategory, model.D5, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ex: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var category = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Ex: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Category$All$id(category)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$Categories$formFieldsFromCategory(category)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Ex: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								KL: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{KL: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				var _v6 = model.Ex;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Ex: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Categories$fetchCategories(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Ex: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v9 = model.Ex;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Ex: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Categories$fetchCategories(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Ex: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var id = msg.a;
				var dataCategory = msg.b;
				switch (dataCategory.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									KL: $author$project$Api$Data$Loading,
									dI: A2($elm$core$Set$remove, id, model.dI)
								}),
							$author$project$Pages$Admin$Categories$fetchCategories(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dI: A2($elm$core$Set$remove, id, model.dI)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataCategory));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$Categories$fetchCategories(newModel),
					_List_Nil);
			case 10:
				var category = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bW: $elm$core$Maybe$Just(category)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dI: A2($elm$core$Set$insert, id, model.dI),
							bW: $elm$core$Maybe$Nothing
						}),
					A3(
						$author$project$Api$Provider$Category$delete,
						model.D5,
						id,
						$author$project$Pages$Admin$Categories$CategoryDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{bW: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Categories$NewCategory = {$: 0};
var $author$project$Pages$Admin$Categories$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Categories$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Categories$Name = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Categories$SaveCategory = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Admin$Categories$viewCategoryModal = F3(
	function (maybeId, category, form) {
		var name = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Charge Category',
			S_: _Utils_eq(category, $author$project$Api$Data$Loading),
			Tv: maybeId,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$Categories$CancelCategoryEdit,
			U0: $author$project$Pages$Admin$Categories$SaveCategory(form)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Name')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Diagnostics'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Categories$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Admin$Categories$EditCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Feature$JointProduct = 6;
var $author$project$Pages$Admin$Categories$OpenHiConfirm = function (a) {
	return {$: 10, a: a};
};
var $author$project$Formatters$Time$Time__AgoInWords = 1;
var $author$project$Api$Provider$Category$All$chargesThisMonthAmountInCents = function (_v0) {
	var record = _v0.b;
	return record.KV;
};
var $author$project$Api$Provider$Category$All$chargesThisMonthCount = function (_v0) {
	var record = _v0.b;
	return record.KW;
};
var $author$project$Api$Provider$Category$Shared$defaultForMemberships = function (_v0) {
	var record = _v0;
	return record.E$;
};
var $author$project$Api$Provider$Category$All$defaultForMemberships = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Category$Shared$defaultForMemberships(shared);
};
var $author$project$Api$Provider$Category$All$lastUsedAt = function (_v0) {
	var record = _v0.b;
	return record.SF;
};
var $author$project$Ui$Link$RouteParams = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Link$routeParams = $author$project$Ui$Link$RouteParams;
var $author$project$Api$Expandable$withDefault = F2(
	function (_default, expandable_) {
		if (!expandable_.$) {
			var a = expandable_.a;
			return a;
		} else {
			return _default;
		}
	});
var $author$project$Pages$Admin$Categories$viewCategory = F4(
	function (practice, timeFormatter, deletingCategories, category) {
		var id = $author$project$Api$Provider$Category$All$id(category);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Category$All$name(category))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							(A2(
							$author$project$Api$Expandable$withDefault,
							0,
							$author$project$Api$Provider$Category$All$chargesThisMonthCount(category)) > 0) ? A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__Revenue,
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'category', id)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Category$All$chargesThisMonthAmountInCents(category))) + ' this month')
								])) : $elm$html$Html$text('0')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Never',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(1),
											$author$project$Api$Provider$Category$All$lastUsedAt(category))))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if ($author$project$Api$Provider$Category$All$defaultForMemberships(category)) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Default for memberships')
										]))
								]);
						} else {
							if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && ($author$project$Api$Provider$Category$All$name(category) === 'Medications')) {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('Default for medications')
											]))
									]);
							} else {
								if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && ($author$project$Api$Provider$Category$All$name(category) === 'Labs')) {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Default for labs')
												]))
										]);
								} else {
									var loading = A2($elm$core$Set$member, id, deletingCategories);
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Edit charge category '},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$disabled(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$Categories$EditCategory(category)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														])),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Delete charge category '},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$size(0),
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$Categories$OpenHiConfirm(category)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]))
												]))
										]);
								}
							}
						}
					}())
				]));
	});
var $author$project$Pages$Admin$Categories$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.KL;
		if (_v1.$ === 3) {
			var categories_ = _v1.a;
			return _Utils_Tuple2(false, categories_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var categories = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('None')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Charges this month')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Last used')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			A3($author$project$Pages$Admin$Categories$viewCategory, model.WF, model.Hy, model.dI),
			categories),
		_List_Nil);
};
var $author$project$Pages$Admin$Categories$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.Ex;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var category = _v1.c;
					return A3($author$project$Pages$Admin$Categories$viewCategoryModal, id, category, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.bW;
				if (!_v2.$) {
					var category = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Categories$HiConfirmClosed(
							$author$project$Api$Provider$Category$All$id(category)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('charge category'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$Category$All$name(category) + ' and remove it from all historical charges')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Charge Categories')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'New charge category'},
								_List_fromArray(
									[
										$author$project$Ui$Button$default,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Categories$NewCategory),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Charge Category')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$Categories$viewPanelBody(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Categories$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.KL))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Charge Categories'
	};
};
var $author$project$Pages$Admin$Categories$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Categories$init, aer: $author$project$Pages$Admin$Categories$load, agD: $author$project$Pages$Admin$Categories$save, ahd: $author$project$Pages$Admin$Categories$subscriptions, aaq: $author$project$Pages$Admin$Categories$update, ahP: $author$project$Pages$Admin$Categories$view});
var $author$project$Pages$Admin$ChargeItems$Id_String$ChargeItemFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$CodeTypeDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeItem$Shared$Item = 0;
var $author$project$Components$TranslatedRichText$DropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$TranslatedRichText$init = F2(
	function (initialTranslations, dropdownId) {
		return {
			h1: $author$project$Language$english,
			fy: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: dropdownId, ahx: $author$project$Components$TranslatedRichText$DropdownMsg})),
			mE: false,
			aaa: initialTranslations
		};
	});
var $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption = 'deferred';
var $author$project$Components$Admin$ChargeItems$Form$formFieldsInit = {
	IN: $elm$core$Maybe$Nothing,
	Kh: false,
	Ex: $elm$core$Maybe$Nothing,
	K3: '',
	K5: $elm$core$Maybe$Nothing,
	p4: $elm$core$Maybe$Nothing,
	MW: $elm$core$Maybe$Nothing,
	Nx: $elm$core$Maybe$Nothing,
	iv: false,
	OW: '1',
	OX: 'months',
	b8: false,
	ms: 0,
	QN: $elm$core$Maybe$Nothing,
	q9: 0,
	SE: $elm$core$Maybe$Nothing,
	Tg: '',
	TU: $elm$core$Maybe$Nothing,
	zh: '',
	Vr: _List_Nil,
	Ba: $elm$core$Maybe$Nothing,
	Xv: $elm$core$Maybe$Nothing,
	YH: $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption,
	ez: A2($author$project$Components$TranslatedRichText$init, $elm$core$Dict$empty, 'rich-description-language'),
	$u: false,
	$_: false,
	aam: 'each'
};
var $author$project$Components$ResourceFilter$All = {$: 2};
var $author$project$Components$ResourceFilter$Category$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Category$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Category$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Data$employerPath = $author$project$Api$Data$newPath(
	_List_fromArray(
		['employer']));
var $author$project$Api$Employer$Category$categoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['categories']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Category$All$Category = $elm$core$Basics$identity;
var $author$project$Api$Employer$Category$Shared$Category = $elm$core$Basics$identity;
var $author$project$Api$Employer$Category$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Employer$Category$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Category$Shared$Record)));
var $author$project$Api$Employer$Category$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Category$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Category$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Category$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Category$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Category$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Category$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Category$categoriesPath)));
	});
var $author$project$Api$Category$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Category$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Category$All$Employer)))) : A3(
			$author$project$Api$Provider$Category$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Category$All$Provider))));
	});
var $author$project$Components$ResourceFilter$Category$list = $author$project$Api$Category$list;
var $author$project$Api$Employer$Category$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$Category$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Category$Shared$id(shared);
};
var $author$project$Api$Category$All$id = function (category) {
	if (!category.$) {
		var category_ = category.a;
		return $author$project$Api$Provider$Category$All$id(category_);
	} else {
		var category_ = category.a;
		return $author$project$Api$Employer$Category$All$id(category_);
	}
};
var $author$project$Api$Employer$Category$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$Category$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Category$Shared$name(shared);
};
var $author$project$Api$Category$All$name = function (category) {
	if (!category.$) {
		var category_ = category.a;
		return $author$project$Api$Provider$Category$All$name(category_);
	} else {
		var category_ = category.a;
		return $author$project$Api$Employer$Category$All$name(category_);
	}
};
var $author$project$Components$ResourceFilter$Category$resourceFromAll = function (category) {
	return {
		adR: $author$project$Api$Category$All$id(category),
		zh: $author$project$Api$Category$All$name(category)
	};
};
var $author$project$Components$ResourceFilter$Category$fetchResources = F5(
	function (session, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$Category$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Category$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$DropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ResourceFilter$GotItems = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Form$SearchableSelect$andMantainTextOnClose = function (model) {
	return _Utils_update(
		model,
		{yF: true});
};
var $author$project$Components$ResourceFilter$buildChoiceToValue = F4(
	function (allValue, noneValue, toValue, choice) {
		switch (choice.$) {
			case 2:
				return allValue;
			case 3:
				return noneValue;
			case 0:
				var item = choice.a;
				return $elm$core$Maybe$Just(
					toValue(item));
			case 1:
				var items = choice.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						',',
						A2($elm$core$List$map, toValue, items)));
			case 4:
				var extraItem = choice.a;
				return $elm$core$Maybe$Just(extraItem.aaN);
			default:
				var string = choice.a;
				return $elm$core$Maybe$Just(string);
		}
	});
var $author$project$Components$ResourceFilter$choiceToLabel = F6(
	function (allLabel, noneLabel, freeTextPrefix, resourceName, toLabel, choice) {
		switch (choice.$) {
			case 2:
				return _List_fromArray(
					[
						$elm$html$Html$text(allLabel)
					]);
			case 3:
				return _List_fromArray(
					[
						$elm$html$Html$text(noneLabel)
					]);
			case 0:
				var item = choice.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($elm$core$Basics$never),
							toLabel(item)))
					]);
			case 1:
				var items = choice.a;
				var count = $elm$core$List$length(items);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Formatters$String$pluralize, resourceName, count) + ' Selected')
							]))
					]);
			case 4:
				var extraItem = choice.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(extraItem.aej)
							]))
					]);
			default:
				var string = choice.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(freeTextPrefix),
								$elm$html$Html$text(string)
							]))
					]);
		}
	});
var $author$project$Components$ResourceFilter$choiceToTitle = F6(
	function (allLabel, noneLabel, freeTextPrefix, resourceName, toTitle, choice) {
		switch (choice.$) {
			case 2:
				return allLabel;
			case 3:
				return noneLabel;
			case 0:
				var item = choice.a;
				return toTitle(item);
			case 1:
				var items = choice.a;
				var count = $elm$core$List$length(items);
				return A2($author$project$Formatters$String$pluralize, resourceName, count) + ' Selected';
			case 4:
				var extraItem = choice.a;
				return extraItem.aej;
			default:
				var string = choice.a;
				return _Utils_ap(freeTextPrefix, string);
		}
	});
var $author$project$Components$ResourceFilter$defaults = {
	D0: 'All',
	IS: true,
	abe: $elm$core$Maybe$Nothing,
	ac6: $elm$core$Maybe$Nothing,
	ac7: $elm$core$Maybe$Nothing,
	d$: _List_Nil,
	adB: false,
	adC: 'Custom: ',
	adJ: false,
	adK: false,
	rc: 10,
	UL: 'None',
	aeZ: false,
	ae_: $elm$core$Maybe$Just(''),
	afT: $elm$core$Maybe$Nothing,
	af_: $elm$core$Maybe$Nothing,
	Ch: true
};
var $author$project$Components$ResourceFilter$SetPreSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ResourceFilter$setPreSelected = function (attempts) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$ResourceFilter$SetPreSelected(attempts + 1);
		},
		$elm$core$Process$sleep(10));
};
var $author$project$Api$Pagination$withItemsPerPage = F2(
	function (itemsPerPage, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{mM: itemsPerPage});
	});
var $author$project$Components$ResourceFilter$init = F3(
	function (apiClient, required, optionals) {
		var search = required.Pi;
		var options = optionals($author$project$Components$ResourceFilter$defaults);
		var pagination = A2($author$project$Api$Pagination$withItemsPerPage, options.rc, $author$project$Api$Pagination$init);
		var choiceToLabelFunc = A5($author$project$Components$ResourceFilter$choiceToLabel, options.D0, options.UL, options.adC, required.gx, required.ahw);
		return _Utils_Tuple2(
			{
				EA: choiceToLabelFunc,
				aZ: $elm$core$Maybe$Nothing,
				dE: $jinjor$elm_debounce$Debounce$init,
				fy: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'resource-filter-dropdown-' + required.adR, ahx: $author$project$Components$ResourceFilter$DropdownMsg})),
				ac6: options.ac6,
				ac7: options.ac7,
				d$: options.d$,
				xJ: $elm$core$Maybe$Nothing,
				i1: false,
				zY: options,
				afy: pagination,
				afT: options.afT,
				af_: options.af_,
				gx: required.gx,
				st: required.st,
				gB: search,
				n9: false,
				sC: function (select_) {
					return options.adB ? $author$project$Ui$Form$SearchableSelect$andMantainTextOnClose(select_) : select_;
				}(
					$author$project$Ui$Form$SearchableSelect$init(
						{
							adR: required.adR,
							ahw: choiceToLabelFunc,
							ahA: A5($author$project$Components$ResourceFilter$choiceToTitle, options.D0, options.UL, options.adC, required.gx, required.ahA),
							g0: A3($author$project$Components$ResourceFilter$buildChoiceToValue, options.abe, options.ae_, required.g0)
						})),
				ahw: required.ahw,
				ahA: required.ahA,
				g0: required.g0,
				oO: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4(
						search,
						$author$project$Components$ResourceFilter$GotItems(false),
						apiClient,
						pagination,
						options.af_),
						function () {
						var _v0 = options.afT;
						if (!_v0.$) {
							return $author$project$Components$ResourceFilter$setPreSelected(0);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}()
					])));
	});
var $author$project$Components$ResourceFilter$Category$retrieveResource = F4(
	function (session, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$Category$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Category$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Category$selectId = 'category';
var $author$project$Components$ResourceFilter$Category$toTitle = function ($) {
	return $.zh;
};
var $author$project$Components$ResourceFilter$Category$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Category$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Category$toValue = function ($) {
	return $.adR;
};
var $author$project$Components$ResourceFilter$Category$init = F3(
	function (apiClient, session, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$Category$fetchResources(session),
				adR: $author$project$Components$ResourceFilter$Category$selectId,
				gx: 'Category',
				st: $author$project$Components$ResourceFilter$Category$retrieveResource(session),
				ahw: $author$project$Components$ResourceFilter$Category$toLabel,
				ahA: $author$project$Components$ResourceFilter$Category$toTitle,
				g0: $author$project$Components$ResourceFilter$Category$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Provider$ChargeItem$chargeItemsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['charge_items']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ChargeItem$chargeItemPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ChargeItem$chargeItemsPath);
};
var $author$project$Api$Provider$ChargeItem$One$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$Shared$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$Min$ChargeItem = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeItem$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$ChargeItem$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Min$Record)));
var $author$project$Api$Provider$ChargeItem$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ChargeItem$Shared$Record = function (description) {
	return function (lastUsedAt) {
		return function (quantityInStock) {
			return function (priceInCents) {
				return function (lastSetQuantity) {
					return function (lowInventory) {
						return function (outOfStock) {
							return function (taxable) {
								return function (buyable) {
									return function (trackInventory) {
										return function (alertQuantity) {
											return function (daysSupply) {
												return function (code) {
													return function (codeType) {
														return function (manufacturer) {
															return function (itemType) {
																return function (templatePackage) {
																	return function (richDescriptions) {
																		return function (imageUrl) {
																			return {IN: alertQuantity, Kh: buyable, K3: code, K5: codeType, MW: daysSupply, Nx: description, QN: imageUrl, q9: itemType, SE: lastSetQuantity, SF: lastUsedAt, Ta: lowInventory, Tg: manufacturer, Vl: outOfStock, Ba: priceInCents, Xv: quantityInStock, BW: richDescriptions, $u: taxable, tf: templatePackage, $_: trackInventory};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Components$TranslatedRichText$decoder = function (fieldName) {
	var filterNulls = function (dict) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var key = _v0.a;
					var maybeValue = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (value) {
							return _Utils_Tuple2(key, value);
						},
						maybeValue);
				},
				$elm$core$Dict$toList(dict)));
	};
	return A2(
		$elm$json$Json$Decode$map,
		filterNulls,
		A2(
			$elm$json$Json$Decode$field,
			fieldName,
			$elm$json$Json$Decode$dict(
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))));
};
var $author$project$Api$Provider$ChargeItem$Shared$decodeRichDescriptions = $author$project$Components$TranslatedRichText$decoder('rich_description');
var $author$project$Api$Provider$ChargeItem$Shared$Package = 1;
var $author$project$Api$Provider$ChargeItem$Shared$stringToItemType = function (str) {
	switch (str) {
		case 'item':
			return 0;
		case 'package':
			return 1;
		default:
			return 0;
	}
};
var $author$project$Api$Provider$ChargeItem$Shared$TemplatePackage = F4(
	function (packageItems, expirationNumber, expirationUnit, revenueRecognition) {
		return {OW: expirationNumber, OX: expirationUnit, Vr: packageItems, YH: revenueRecognition};
	});
var $author$project$Api$Provider$PackageItem$Shared$PackageItem = F7(
	function (id, chargeItemId, chargeItemName, chargeItemTaxable, chargeItemPriceInCents, quantity, priceInCents) {
		return {abX: chargeItemId, abY: chargeItemName, abZ: chargeItemPriceInCents, ab_: chargeItemTaxable, adR: id, Ba: priceInCents, Bd: quantity};
	});
var $author$project$Currency$decode = A2($elm$json$Json$Decode$map, $author$project$Currency$fromInt, $elm$json$Json$Decode$int);
var $author$project$Api$Provider$PackageItem$Shared$decoder = function () {
	var extractChargeItemTaxable = A2(
		$elm$json$Json$Decode$field,
		'charge_item',
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'taxable', $elm$json$Json$Decode$bool)));
	var extractChargeItemPriceInCents = A2(
		$elm$json$Json$Decode$field,
		'charge_item',
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'price_in_cents', $elm$json$Json$Decode$float)));
	var extractChargeItemName = A2(
		$elm$json$Json$Decode$field,
		'charge_item',
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)));
	var extractChargeItemId = A2(
		$elm$json$Json$Decode$field,
		'charge_item',
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
	return A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'price_in_cents',
		$author$project$Currency$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'quantity',
			$elm$json$Json$Decode$int,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				extractChargeItemPriceInCents,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					extractChargeItemTaxable,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						extractChargeItemName,
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
							extractChargeItemId,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'id',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PackageItem$Shared$PackageItem))))))));
}();
var $author$project$Api$Provider$ChargeItem$Shared$templatePackageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revenue_recognition',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'expiration_unit',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'expiration_number',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'package_items',
				$elm$json$Json$Decode$list($author$project$Api$Provider$PackageItem$Shared$decoder),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$TemplatePackage)))));
var $author$project$Api$Provider$ChargeItem$Shared$recordDecoder = function () {
	var decodeTemplatePackage = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'package',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Api$Provider$ChargeItem$Shared$templatePackageDecoder)),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
	return A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'image_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Api$Provider$ChargeItem$Shared$decodeRichDescriptions,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				decodeTemplatePackage,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'item_type',
					A2($elm$json$Json$Decode$map, $author$project$Api$Provider$ChargeItem$Shared$stringToItemType, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'manufacturer',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code_type',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'code',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'days_supply',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'alert_quantity',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'track_inventory',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'buyable',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'taxable',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'out_of_stock',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'low_inventory',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'last_set_quantity',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'price_in_cents',
																	$elm$json$Json$Decode$float,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'quantity_in_stock',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'last_used_at',
																			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'description',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$Record))))))))))))))))))));
}();
var $author$project$Api$Provider$ChargeItem$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$ChargeItem)));
var $author$project$Api$Provider$ChargeItem$One$Record = F3(
	function (category, uom, meta) {
		return {Ex: category, TU: meta, aam: uom};
	});
var $author$project$Api$Provider$ChargeItem$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeItem$Meta$MetaRecord = F2(
	function (uom, buyable) {
		return {Kh: buyable, aam: uom};
	});
var $author$project$Api$Provider$ChargeItem$Meta$EditableRecord = function (editable) {
	return {Oa: editable};
};
var $author$project$Api$Provider$ChargeItem$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Meta$EditableRecord));
var $author$project$Api$Provider$ChargeItem$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'buyable',
	$author$project$Api$Provider$ChargeItem$Meta$editableRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uom',
		$author$project$Api$Provider$ChargeItem$Meta$editableRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Meta$MetaRecord)));
var $author$project$Api$Provider$ChargeItem$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Uom$Shared$Uom = $elm$core$Basics$identity;
var $author$project$Api$Provider$Uom$Shared$Record = F7(
	function (code, name, unitClass, periodUnit, periodQuantity, type_, periodInMonths) {
		return {K3: code, zh: name, Wc: periodInMonths, gk: periodQuantity, gl: periodUnit, ahI: type_, HH: unitClass};
	});
var $author$project$Api$Provider$Uom$PeriodUnit$Days = 0;
var $author$project$Api$Provider$Uom$PeriodUnit$HalfYears = 3;
var $author$project$Api$Provider$Uom$PeriodUnit$Months = 1;
var $author$project$Api$Provider$Uom$PeriodUnit$Quarters = 2;
var $author$project$Api$Provider$Uom$PeriodUnit$Years = 4;
var $author$project$Api$Provider$Uom$PeriodUnit$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'days':
				return $elm$json$Json$Decode$succeed(0);
			case 'months':
				return $elm$json$Json$Decode$succeed(1);
			case 'quarters':
				return $elm$json$Json$Decode$succeed(2);
			case 'half_years':
				return $elm$json$Json$Decode$succeed(3);
			case 'years':
				return $elm$json$Json$Decode$succeed(4);
			default:
				var somethingElse = string;
				return $elm$json$Json$Decode$fail('Unsupported Uom -> period_unit: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Uom$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'period_in_months',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'period_quantity',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'period_unit',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Uom$PeriodUnit$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unit_class',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'code',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Uom$Shared$Record))))))));
var $author$project$Api$Provider$Uom$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Uom$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ChargeItem$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$ChargeItem$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uom',
		$author$project$Api$Provider$Uom$Shared$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'category',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$One$Record))));
var $author$project$Api$Provider$ChargeItem$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$One$ChargeItem)));
var $author$project$Api$Provider$ChargeItem$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ChargeItem$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ChargeItem$chargeItemPath(id_)));
	});
var $author$project$Components$Admin$ChargeItems$Form$init = F4(
	function (apiClient, session, id, practice) {
		var excludedCategoryTitles = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) ? $elm$core$Maybe$Just(
			_List_fromArray(
				['Labs'])) : $elm$core$Maybe$Nothing;
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$ChargeItem$retrieve, apiClient, id_, $author$project$Components$Admin$ChargeItems$Form$GotItem));
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just($author$project$Components$Admin$ChargeItems$Form$formFieldsInit),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var formFields = _v0.a;
		var cmd = _v0.b;
		var _v2 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Uncategorized', ac7: excludedCategoryTitles, aeZ: false});
			});
		var categoryResourceFilter = _v2.a;
		var categoryResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			{
				cJ: categoryResourceFilter,
				fc: $elm$core$Dict$empty,
				lt: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'code-type', ahx: $author$project$Components$Admin$ChargeItems$Form$CodeTypeDropdownMsg})),
				PB: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
				adR: id,
				yi: false,
				bv: $elm$core$Dict$empty,
				cf: $elm$core$Dict$empty,
				WF: practice,
				jY: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd)
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var params = _v1.Vx;
		var _v2 = A4(
			$author$project$Components$Admin$ChargeItems$Form$init,
			apiClient,
			session,
			$elm$core$Maybe$Just(params.adR),
			practice);
		var model = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: model},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$ChargeItems$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ChargeItems$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$ResourceFilter$subscriptions = function (model) {
	return $author$project$Ui$NewDropdown$subscriptions(model.fy);
};
var $author$project$Components$ResourceFilter$Category$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$TranslatedRichText$ContentChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TranslatedRichText$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.mE ? $author$project$Ports$CKEditor$onChange(
				F2(
					function (_v0, value) {
						return $author$project$Components$TranslatedRichText$ContentChanged(value);
					})) : $elm$core$Platform$Sub$none,
				$author$project$Ui$NewDropdown$subscriptions(model.fy)
			]));
};
var $author$project$Components$Admin$ChargeItems$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.cJ)),
				$author$project$Ui$NewDropdown$subscriptions(model.lt),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (form) {
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg,
							$author$project$Components$TranslatedRichText$subscriptions(
								$author$project$Utils$Form$fields(form).ez));
					},
					model.PB))
			]));
};
var $author$project$Pages$Admin$ChargeItems$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$ChargeItems$Form$subscriptions(model.PB));
};
var $author$project$Components$Admin$ChargeItems$Form$Category = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$CodeType = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$ResourceFilter$Extra = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$Image = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Components$Admin$ChargeItems$Form$PackageItemSelected = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Admin$ChargeItems$Form$PackageItemsValidation = 5;
var $author$project$Components$Admin$ChargeItems$Form$SelectPackageItem = F5(
	function (a, b, c, d, e) {
		return {$: 19, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Ports$Navigation$backPort = _Platform_outgoingPort(
	'backPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Navigation$back = $author$project$Ports$Navigation$backPort(0);
var $author$project$Api$Provider$ChargeItem$One$category = function (_v0) {
	var record = _v0.b;
	return record.Ex;
};
var $author$project$Components$Admin$ChargeItems$Form$CodeTypeValidation = 4;
var $author$project$Components$Admin$ChargeItems$Form$ExpirationValidation = 6;
var $author$project$Components$Admin$ChargeItems$Form$ImageValidation = 7;
var $author$project$Components$Admin$ChargeItems$Form$LastSetQuantityValidation = 3;
var $author$project$Components$Admin$ChargeItems$Form$NameValidation = 0;
var $author$project$Components$Admin$ChargeItems$Form$PriceInCentsValidation = 2;
var $author$project$Components$Admin$ChargeItems$Form$UomValidation = 1;
var $author$project$Utils$Form$clearGroupErrors = F2(
	function (group, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		return A4(
			$author$project$Utils$Form$Form,
			originalFields,
			validated_,
			fields_,
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var validationGroup = _v1.a;
					return !_Utils_eq(validationGroup, group);
				},
				errors_));
	});
var $author$project$Utils$FileSize$fiveMegabytes = (5 * 1024) * 1024;
var $author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Admin$ChargeItems$Form$validateCodeType = function (fields) {
	return ((fields.K3 !== '') && _Utils_eq(fields.K5, $elm$core$Maybe$Nothing)) ? _List_fromArray(
		[
			_Utils_Tuple2(4, 'Please pick a code type.')
		]) : _List_Nil;
};
var $author$project$Components$Admin$ChargeItems$Form$validateExpiration = function (fields) {
	if (fields.b8) {
		var _v0 = $elm$core$String$toInt(fields.OW);
		if (!_v0.$) {
			var n = _v0.a;
			return (n > 0) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(6, 'Please enter a positive number for expiration.')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(6, 'Please enter a valid positive number for expiration.')
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity = function (fields) {
	var invalid = _Utils_Tuple2(3, 'Please enter a quantity of 0 or more to track inventory for this item');
	var _v0 = _Utils_Tuple2(fields.$_, fields.SE);
	if (_v0.a) {
		if (!_v0.b.$) {
			var lastSetQuantity = _v0.b.a;
			return (lastSetQuantity < 0) ? _List_fromArray(
				[invalid]) : _List_Nil;
		} else {
			var _v1 = _v0.b;
			return _List_fromArray(
				[invalid]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$ChargeItems$Form$validatePackageItems = function (fields) {
	if (fields.q9 === 1) {
		if ($elm$core$List$isEmpty(fields.Vr)) {
			return _List_fromArray(
				[
					_Utils_Tuple2(5, 'Please add at least one item to the package.')
				]);
		} else {
			var missingChargeItem = A2(
				$elm$core$List$any,
				function (item) {
					return _Utils_eq(item.abX, $elm$core$Maybe$Nothing);
				},
				fields.Vr);
			return A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						missingChargeItem ? $elm$core$Maybe$Just(
						_Utils_Tuple2(5, 'Please select a charge item for each row.')) : $elm$core$Maybe$Nothing
					]));
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$ChargeItems$Form$validatePriceInCents = function (fields) {
	var _v0 = fields.q9;
	if (_v0 === 1) {
		var _v1 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Ba);
		if (!_v1.$) {
			var cents = _v1.a;
			return (cents > 0) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please enter a price greater than $0.')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please enter a price.')
				]);
		}
	} else {
		return _Utils_eq(fields.Ba, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter a price.')
			]) : _List_Nil;
	}
};
var $author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid = function (form) {
	if ($author$project$Utils$Form$validated(form)) {
		var fields = $author$project$Utils$Form$fields(form);
		var isCodeTypeValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validateCodeType(fields));
		var isExpirationValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validateExpiration(fields));
		var isImageValid = _Utils_cmp(fields.ms, $author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize) < 1;
		var isLastSetQuantityValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity(fields));
		var isNameValid = !$elm$core$String$isEmpty(fields.zh);
		var isPackageItemsValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validatePackageItems(fields));
		var isPriceValid = $elm$core$List$isEmpty(
			$author$project$Components$Admin$ChargeItems$Form$validatePriceInCents(fields));
		var isUomValid = !$elm$core$String$isEmpty(fields.aam);
		return (isImageValid ? $author$project$Utils$Form$clearGroupErrors(7) : $elm$core$Basics$identity)(
			(isExpirationValid ? $author$project$Utils$Form$clearGroupErrors(6) : $elm$core$Basics$identity)(
				(isPackageItemsValid ? $author$project$Utils$Form$clearGroupErrors(5) : $elm$core$Basics$identity)(
					(isCodeTypeValid ? $author$project$Utils$Form$clearGroupErrors(4) : $elm$core$Basics$identity)(
						(isLastSetQuantityValid ? $author$project$Utils$Form$clearGroupErrors(3) : $elm$core$Basics$identity)(
							(isPriceValid ? $author$project$Utils$Form$clearGroupErrors(2) : $elm$core$Basics$identity)(
								(isUomValid ? $author$project$Utils$Form$clearGroupErrors(1) : $elm$core$Basics$identity)(
									(isNameValid ? $author$project$Utils$Form$clearGroupErrors(0) : $elm$core$Basics$identity)(form))))))));
	} else {
		return form;
	}
};
var $author$project$Components$ResourceFilter$extraItems = F2(
	function (list, model) {
		return _Utils_update(
			model,
			{d$: list});
	});
var $author$project$Components$ResourceFilter$Category$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aej: item.zh, aaN: item.adR};
			},
			list_);
		return _Utils_update(
			model,
			{
				bb: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bb)
			});
	});
var $author$project$Components$ResourceFilter$ChargeItem$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (chargeItem) {
				return {aej: chargeItem.zh, aaN: chargeItem.adR};
			},
			list_);
		return _Utils_update(
			model,
			{
				bb: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bb)
			});
	});
var $author$project$Api$Provider$ChargeItem$Shared$alertQuantity = function (_v0) {
	var record = _v0.b;
	return record.IN;
};
var $author$project$Api$Provider$ChargeItem$One$alertQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$buyable = function (_v0) {
	var record = _v0.b;
	return record.Kh;
};
var $author$project$Api$Provider$ChargeItem$One$buyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$buyable(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$code = function (_v0) {
	var record = _v0.b;
	return record.K3;
};
var $author$project$Api$Provider$ChargeItem$One$code = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
};
var $author$project$Api$Provider$Uom$Shared$code = function (_v0) {
	var record = _v0;
	return record.K3;
};
var $author$project$Api$Provider$ChargeItem$Shared$codeType = function (_v0) {
	var record = _v0.b;
	return record.K5;
};
var $author$project$Api$Provider$ChargeItem$One$codeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$daysSupply = function (_v0) {
	var record = _v0.b;
	return record.MW;
};
var $author$project$Api$Provider$ChargeItem$One$daysSupply = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$daysSupply(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$description = function (_v0) {
	var record = _v0.b;
	return record.Nx;
};
var $author$project$Api$Provider$ChargeItem$One$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$expirationNumber = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.OW;
		},
		record.tf);
};
var $author$project$Api$Provider$ChargeItem$One$expirationNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$expirationNumber(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$expirationUnit = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.OX;
		},
		record.tf);
};
var $author$project$Api$Provider$ChargeItem$One$expirationUnit = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$expirationUnit(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$imageUrl = function (_v0) {
	var record = _v0.b;
	return record.QN;
};
var $author$project$Api$Provider$ChargeItem$One$imageUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$imageUrl(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$itemType = function (_v0) {
	var record = _v0.b;
	return record.q9;
};
var $author$project$Api$Provider$ChargeItem$One$itemType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity = function (_v0) {
	var record = _v0.b;
	return record.SE;
};
var $author$project$Api$Provider$ChargeItem$One$lastSetQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$manufacturer = function (_v0) {
	var record = _v0.b;
	return record.Tg;
};
var $author$project$Api$Provider$ChargeItem$One$manufacturer = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
};
var $author$project$Api$Provider$ChargeItem$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Provider$ChargeItem$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$ChargeItem$Shared$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Min$name(min);
};
var $author$project$Api$Provider$ChargeItem$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$packageItems = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Vr;
			},
			record.tf));
};
var $author$project$Api$Provider$ChargeItem$One$packageItems = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$packageItems(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$priceInCents = function (_v0) {
	var record = _v0.b;
	return record.Ba;
};
var $author$project$Api$Provider$ChargeItem$One$priceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$quantityInStock = function (_v0) {
	var record = _v0.b;
	return record.Xv;
};
var $author$project$Api$Provider$ChargeItem$One$quantityInStock = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$revenueRecognition = function (_v0) {
	var record = _v0.b;
	return A2(
		$elm$core$Maybe$andThen,
		function ($) {
			return $.YH;
		},
		record.tf);
};
var $author$project$Api$Provider$ChargeItem$One$revenueRecognition = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$revenueRecognition(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$richDescriptions = function (_v0) {
	var record = _v0.b;
	return record.BW;
};
var $author$project$Api$Provider$ChargeItem$One$richDescriptions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$richDescriptions(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$taxable = function (_v0) {
	var record = _v0.b;
	return record.$u;
};
var $author$project$Api$Provider$ChargeItem$One$taxable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$trackInventory = function (_v0) {
	var record = _v0.b;
	return record.$_;
};
var $author$project$Api$Provider$ChargeItem$One$trackInventory = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
};
var $author$project$Api$Provider$ChargeItem$One$uom = function (_v0) {
	var record = _v0.b;
	return record.aam;
};
var $author$project$Components$Admin$ChargeItems$Form$formFieldsFromItem = function (chargeItem) {
	var packageItems = ($author$project$Api$Provider$ChargeItem$One$itemType(chargeItem) === 1) ? A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, packageItem) {
				return {
					abX: $elm$core$Maybe$Just(packageItem.abX),
					abY: packageItem.abY,
					ab_: packageItem.ab_,
					adR: packageItem.adR,
					Ba: packageItem.Ba,
					Bd: packageItem.Bd,
					K: $elm$core$String$fromInt(index)
				};
			}),
		$author$project$Api$Provider$ChargeItem$One$packageItems(chargeItem)) : _List_Nil;
	return {
		IN: $author$project$Api$Provider$ChargeItem$One$alertQuantity(chargeItem),
		Kh: $author$project$Api$Provider$ChargeItem$One$buyable(chargeItem),
		Ex: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Category$Shared$id,
			$author$project$Api$Provider$ChargeItem$One$category(chargeItem)),
		K3: $author$project$Api$Provider$ChargeItem$One$code(chargeItem),
		K5: $author$project$Api$Provider$ChargeItem$One$codeType(chargeItem),
		p4: $author$project$Api$Provider$ChargeItem$One$imageUrl(chargeItem),
		MW: $author$project$Api$Provider$ChargeItem$One$daysSupply(chargeItem),
		Nx: $author$project$Api$Provider$ChargeItem$One$description(chargeItem),
		iv: false,
		OW: A2(
			$elm$core$Maybe$withDefault,
			'1',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				$author$project$Api$Provider$ChargeItem$One$expirationNumber(chargeItem))),
		OX: A2(
			$elm$core$Maybe$withDefault,
			'months',
			$author$project$Api$Provider$ChargeItem$One$expirationUnit(chargeItem)),
		b8: (!_Utils_eq(
			$author$project$Api$Provider$ChargeItem$One$expirationNumber(chargeItem),
			$elm$core$Maybe$Nothing)) || (!_Utils_eq(
			$author$project$Api$Provider$ChargeItem$One$expirationUnit(chargeItem),
			$elm$core$Maybe$Nothing)),
		ms: 0,
		QN: $elm$core$Maybe$Nothing,
		q9: $author$project$Api$Provider$ChargeItem$One$itemType(chargeItem),
		SE: $author$project$Api$Provider$ChargeItem$One$lastSetQuantity(chargeItem),
		Tg: $author$project$Api$Provider$ChargeItem$One$manufacturer(chargeItem),
		TU: $elm$core$Maybe$Just(
			$author$project$Api$Provider$ChargeItem$One$meta(chargeItem)),
		zh: $author$project$Api$Provider$ChargeItem$One$name(chargeItem),
		Vr: packageItems,
		Ba: $elm$core$Maybe$Just(
			$author$project$Currency$fromFloat(
				$author$project$Api$Provider$ChargeItem$One$priceInCents(chargeItem))),
		Xv: $author$project$Api$Provider$ChargeItem$One$quantityInStock(chargeItem),
		YH: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption,
			$author$project$Api$Provider$ChargeItem$One$revenueRecognition(chargeItem)),
		ez: A2(
			$author$project$Components$TranslatedRichText$init,
			$author$project$Api$Provider$ChargeItem$One$richDescriptions(chargeItem),
			'rich-description-language'),
		$u: $author$project$Api$Provider$ChargeItem$One$taxable(chargeItem),
		$_: $author$project$Api$Provider$ChargeItem$One$trackInventory(chargeItem),
		aam: $author$project$Api$Provider$Uom$Shared$code(
			$author$project$Api$Provider$ChargeItem$One$uom(chargeItem))
	};
};
var $author$project$Components$Admin$ChargeItems$Form$adjustPackageItemsPrices = F2(
	function (newPackagePrice, fields) {
		if (newPackagePrice.$ === 1) {
			return fields;
		} else {
			var newPrice = newPackagePrice.a;
			var newTotalCents = A2(
				$elm$core$Maybe$withDefault,
				0,
				$author$project$Currency$toInt(newPrice));
			var currentTotal = $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function (item) {
						var qty = (item.Bd <= 0) ? 1 : item.Bd;
						var price = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Currency$toInt(item.Ba));
						return price * qty;
					},
					fields.Vr));
			var adjustedRules = function () {
				if (!currentTotal) {
					var itemCount = A2(
						$elm$core$Basics$max,
						1,
						$elm$core$List$length(fields.Vr));
					var pricePerItem = (newTotalCents / itemCount) | 0;
					return A2(
						$elm$core$List$map,
						function (item) {
							return _Utils_update(
								item,
								{
									Ba: $author$project$Currency$fromInt(
										(pricePerItem / ((item.Bd <= 0) ? 1 : item.Bd)) | 0)
								});
						},
						fields.Vr);
				} else {
					var ratio = newTotalCents / currentTotal;
					return A2(
						$elm$core$List$map,
						function (item) {
							var currentPrice = A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Currency$toInt(item.Ba));
							var newItemPrice = $elm$core$Basics$round(currentPrice * ratio);
							return _Utils_update(
								item,
								{
									Ba: $author$project$Currency$fromInt(newItemPrice)
								});
						},
						fields.Vr);
				}
			}();
			return _Utils_update(
				fields,
				{Vr: adjustedRules, Ba: newPackagePrice});
		}
	});
var $author$project$Api$Provider$Uom$Shared$day = {
	K3: 'day',
	zh: 'Day',
	Wc: $elm$core$Maybe$Nothing,
	gk: $elm$core$Maybe$Just(1),
	gl: $elm$core$Maybe$Just(0),
	ahI: 'Time',
	HH: 'time'
};
var $author$project$Api$Provider$Uom$Shared$each = {K3: 'each', zh: 'Each', Wc: $elm$core$Maybe$Nothing, gk: $elm$core$Maybe$Nothing, gl: $elm$core$Maybe$Nothing, ahI: 'Quantity', HH: 'quantity'};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Api$Provider$Uom$Shared$unitClass = function (_v0) {
	var record = _v0;
	return record.HH;
};
var $author$project$Api$Provider$Uom$filterBylistOptionals = F2(
	function (options, uom) {
		return A2(
			$elm$core$List$all,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					function () {
					var _v0 = options.HH;
					if (!_v0.$) {
						var unitClass_ = _v0.a;
						return _Utils_eq(
							$author$project$Api$Provider$Uom$Shared$unitClass(uom),
							unitClass_);
					} else {
						return true;
					}
				}()
				]));
	});
var $author$project$Api$Provider$Uom$Shared$halfYear = {
	K3: 'half_year',
	zh: 'Half Year',
	Wc: $elm$core$Maybe$Just(6),
	gk: $elm$core$Maybe$Just(6),
	gl: $elm$core$Maybe$Just(1),
	ahI: 'Time',
	HH: 'time'
};
var $author$project$Api$Provider$Uom$listOptionalsDefaults = {HH: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Uom$Shared$month = {
	K3: 'month',
	zh: 'Month',
	Wc: $elm$core$Maybe$Just(1),
	gk: $elm$core$Maybe$Just(1),
	gl: $elm$core$Maybe$Just(1),
	ahI: 'Time',
	HH: 'time'
};
var $author$project$Api$Provider$Uom$Shared$quarter = {
	K3: 'quarter',
	zh: 'Quarter',
	Wc: $elm$core$Maybe$Just(3),
	gk: $elm$core$Maybe$Just(3),
	gl: $elm$core$Maybe$Just(1),
	ahI: 'Time',
	HH: 'time'
};
var $author$project$Api$Provider$Uom$Shared$year = {
	K3: 'year',
	zh: 'Year',
	Wc: $elm$core$Maybe$Just(12),
	gk: $elm$core$Maybe$Just(1),
	gl: $elm$core$Maybe$Just(4),
	ahI: 'Time',
	HH: 'time'
};
var $author$project$Api$Provider$Uom$list = function (optionals) {
	var options = optionals($author$project$Api$Provider$Uom$listOptionalsDefaults);
	return A2(
		$elm$core$List$filter,
		$author$project$Api$Provider$Uom$filterBylistOptionals(options),
		_List_fromArray(
			[$author$project$Api$Provider$Uom$Shared$each, $author$project$Api$Provider$Uom$Shared$day, $author$project$Api$Provider$Uom$Shared$month, $author$project$Api$Provider$Uom$Shared$quarter, $author$project$Api$Provider$Uom$Shared$halfYear, $author$project$Api$Provider$Uom$Shared$year]));
};
var $author$project$Utils$Uom$fromCode = function (code) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (uom_) {
			return _Utils_eq(
				$author$project$Api$Provider$Uom$Shared$code(uom_),
				code);
		},
		$author$project$Api$Provider$Uom$list($elm$core$Basics$identity));
};
var $author$project$Api$Provider$Uom$Shared$isTimeBased = function (_v0) {
	var record = _v0;
	return record.HH === 'time';
};
var $author$project$Utils$Uom$isTimeBased = function (code) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Uom$Shared$isTimeBased,
			$author$project$Utils$Uom$fromCode(code)));
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice = function (fields) {
	var totalPrice = $author$project$Currency$fromInt(
		$elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function (item) {
					var qty = (item.Bd <= 0) ? 1 : item.Bd;
					var price = A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Currency$toInt(item.Ba));
					return price * qty;
				},
				fields.Vr)));
	return _Utils_update(
		fields,
		{
			Ba: $elm$core$Maybe$Just(totalPrice)
		});
};
var $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						$_: fields.$_ && $author$project$Utils$Uom$isTimeBased(fields.aam),
						aam: string
					});
			case 2:
				var maybeCurrency = field.a;
				return _Utils_update(
					fields,
					{Ba: maybeCurrency});
			case 3:
				if (fields.q9 === 1) {
					var priceToUse = function () {
						var _v1 = fields.Ba;
						if (_v1.$ === 1) {
							return $elm$core$Maybe$Just($author$project$Currency$zero);
						} else {
							return fields.Ba;
						}
					}();
					return A2($author$project$Components$Admin$ChargeItems$Form$adjustPackageItemsPrices, priceToUse, fields);
				} else {
					return fields;
				}
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{$u: bool});
			case 5:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Kh: bool});
			case 6:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{Ex: maybeString});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						iv: bool && (!$author$project$Utils$Maybe$toBool(fields.Xv)),
						$_: bool
					});
			case 8:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						SE: $elm$core$String$toInt(string)
					});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						IN: $elm$core$String$toInt(string)
					});
			case 10:
				var string = field.a;
				var description = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
				return _Utils_update(
					fields,
					{Nx: description});
			case 11:
				return _Utils_update(
					fields,
					{iv: true});
			case 12:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						MW: $elm$core$String$toInt(string)
					});
			case 13:
				var string = field.a;
				return _Utils_update(
					fields,
					{K3: string});
			case 14:
				var string = field.a;
				return _Utils_update(
					fields,
					{K5: string});
			case 15:
				var string = field.a;
				return _Utils_update(
					fields,
					{Tg: string});
			case 16:
				var itemType = field.a;
				var updatedFields = _Utils_update(
					fields,
					{q9: itemType});
				return (itemType === 1) ? $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(updatedFields) : updatedFields;
			case 17:
				var nextTempId = $elm$core$String$fromInt(
					1 + A2(
						$elm$core$Maybe$withDefault,
						-1,
						$elm$core$List$maximum(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(item.K));
								},
								fields.Vr))));
				var newItem = {abX: $elm$core$Maybe$Nothing, abY: $elm$core$Maybe$Nothing, ab_: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, Ba: $author$project$Currency$zero, Bd: 1, K: nextTempId};
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							Vr: _Utils_ap(
								fields.Vr,
								_List_fromArray(
									[newItem]))
						}));
			case 18:
				var tempId = field.a;
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							Vr: A2(
								$elm$core$List$filter,
								function (item) {
									return !_Utils_eq(item.K, tempId);
								},
								fields.Vr)
						}));
			case 19:
				var tempId = field.a;
				var itemId = field.b;
				var itemName = field.c;
				var defaultPrice = field.d;
				var defaultTaxable = field.e;
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							Vr: A2(
								$elm$core$List$map,
								function (item) {
									return _Utils_eq(item.K, tempId) ? _Utils_update(
										item,
										{
											abX: $elm$core$Maybe$Just(itemId),
											abY: $elm$core$Maybe$Just(itemName),
											ab_: $elm$core$Maybe$Just(defaultTaxable),
											Ba: defaultPrice,
											Bd: 1
										}) : item;
								},
								fields.Vr)
						}));
			case 20:
				var tempId = field.a;
				var quantity = field.b;
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							Vr: A2(
								$elm$core$List$map,
								function (item) {
									return _Utils_eq(item.K, tempId) ? _Utils_update(
										item,
										{Bd: quantity}) : item;
								},
								fields.Vr)
						}));
			case 21:
				var tempId = field.a;
				var maybePrice = field.b;
				return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(
					_Utils_update(
						fields,
						{
							Vr: A2(
								$elm$core$List$map,
								function (item) {
									return _Utils_eq(item.K, tempId) ? _Utils_update(
										item,
										{
											Ba: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, maybePrice)
										}) : item;
								},
								fields.Vr)
						}));
			case 22:
				var bool = field.a;
				return _Utils_update(
					fields,
					{b8: bool});
			case 23:
				var str = field.a;
				return _Utils_update(
					fields,
					{OW: str});
			case 24:
				var maybeUnit = field.a;
				if (!maybeUnit.$) {
					var unit = maybeUnit.a;
					return _Utils_update(
						fields,
						{OX: unit});
				} else {
					return fields;
				}
			case 25:
				var value = field.a;
				return _Utils_update(
					fields,
					{YH: value});
			default:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						p4: $elm$core$Maybe$Just(string),
						ms: _int,
						QN: $elm$core$Maybe$Just(string)
					});
		}
	});
var $author$project$Utils$Validate$ifIntGreaterThan = F3(
	function (subjectToInt, max, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _Utils_cmp(
					subjectToInt(subject),
					max) > 0;
			},
			error);
	});
var $author$project$Components$Admin$ChargeItems$Form$imageValidator = A3(
	$author$project$Utils$Validate$ifIntGreaterThan,
	function ($) {
		return $.ms;
	},
	$author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize,
	_Utils_Tuple2(7, 'That image is too large! Our maximum image size is 5 MB.'));
var $author$project$Components$Admin$ChargeItems$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.aam;
			},
			_Utils_Tuple2(1, 'Please pick a uom.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validatePriceInCents),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateCodeType),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validatePackageItems),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateExpiration),
			$author$project$Components$Admin$ChargeItems$Form$imageValidator
		]));
var $author$project$Components$ResourceFilter$ChargeItem$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeItem$All$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$All$Record = F2(
	function (category, uom) {
		return {Ex: category, aam: uom};
	});
var $author$project$Api$Provider$ChargeItem$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uom',
	$author$project$Api$Provider$Uom$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'category',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$All$Record)));
var $author$project$Api$Provider$ChargeItem$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$All$ChargeItem)));
var $author$project$Api$Provider$ChargeItem$listDefaults = {Ex: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, FI: $elm$core$Maybe$Nothing, q9: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, $u: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$ChargeItem$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$ChargeItem$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.af_;
						if (!_v0.$) {
							var string = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'q', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.adR;
						if (!_v1.$) {
							var string = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'id', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.Ex;
						if (!_v2.$) {
							var string = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'category', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.FI;
						if (!_v3.$) {
							var string = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'inventory', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.$u;
						if (!_v4.$) {
							var bool = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$bool, 'taxable', bool)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.q9;
						if (!_v5.$) {
							var itemType = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'item_type', itemType)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$ChargeItem$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ChargeItem$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$ChargeItem$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath)));
	});
var $author$project$Components$ResourceFilter$ChargeItem$list = $author$project$Api$Provider$ChargeItem$list;
var $author$project$Api$Provider$ChargeItem$All$alertQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
};
var $author$project$Api$Provider$ChargeItem$All$category = function (_v0) {
	var record = _v0.b;
	return record.Ex;
};
var $author$project$Api$Provider$ChargeItem$All$code = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
};
var $author$project$Api$Provider$ChargeItem$All$codeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
};
var $author$project$Api$Provider$ChargeItem$All$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
};
var $author$project$Api$Provider$ChargeItem$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$ChargeItem$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Min$id(min);
};
var $author$project$Api$Provider$ChargeItem$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$id(shared);
};
var $author$project$Api$Provider$ChargeItem$All$itemType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared);
};
var $author$project$Api$Provider$ChargeItem$All$manufacturer = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
};
var $author$project$Api$Provider$ChargeItem$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
};
var $author$project$Api$Provider$ChargeItem$All$priceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$ChargeItem$All$quantityInStock = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
};
var $author$project$Api$Provider$ChargeItem$All$taxable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
};
var $author$project$Api$Provider$ChargeItem$All$trackInventory = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
};
var $author$project$Api$Provider$ChargeItem$All$uom = function (_v0) {
	var record = _v0.b;
	return record.aam;
};
var $author$project$Components$ResourceFilter$ChargeItem$resourceFromAll = function (chargeItem) {
	return {
		IN: $author$project$Api$Provider$ChargeItem$All$alertQuantity(chargeItem),
		Ex: $author$project$Api$Provider$ChargeItem$All$category(chargeItem),
		K3: $author$project$Api$Provider$ChargeItem$All$code(chargeItem),
		K5: $author$project$Api$Provider$ChargeItem$All$codeType(chargeItem),
		Nx: $author$project$Api$Provider$ChargeItem$All$description(chargeItem),
		adR: $author$project$Api$Provider$ChargeItem$All$id(chargeItem),
		aef: $author$project$Api$Provider$ChargeItem$All$itemType(chargeItem) === 1,
		q9: $author$project$Api$Provider$ChargeItem$All$itemType(chargeItem),
		Tg: $author$project$Api$Provider$ChargeItem$All$manufacturer(chargeItem),
		zh: $author$project$Api$Provider$ChargeItem$All$name(chargeItem),
		Ba: $author$project$Api$Provider$ChargeItem$All$priceInCents(chargeItem),
		Xv: $author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem),
		$u: $author$project$Api$Provider$ChargeItem$All$taxable(chargeItem),
		$_: $author$project$Api$Provider$ChargeItem$All$trackInventory(chargeItem),
		aam: $author$project$Api$Provider$ChargeItem$All$uom(chargeItem)
	};
};
var $author$project$Components$ResourceFilter$ChargeItem$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$ChargeItem$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$ChargeItem$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$ChargeItem$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$ChargeItem$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$ChargeItem$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$ChargeItem$selectId = 'charge_items';
var $author$project$Components$ResourceFilter$ChargeItem$itemTypeLabel = function (itemType_) {
	if (!itemType_) {
		return 'item';
	} else {
		return 'package';
	}
};
var $author$project$Api$Provider$Uom$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Formatters$ChargeItemCode$CodeTypeAndCode = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$ChargeItem$ForCharge$code = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
};
var $author$project$Formatters$ChargeItemCode$code = function (chargeItem) {
	if (!chargeItem.$) {
		var _v1 = chargeItem.a;
		var code_ = _v1.b;
		return code_;
	} else {
		var chargeItemForCharge = chargeItem.a;
		return $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItemForCharge);
	}
};
var $author$project$Api$Provider$ChargeItem$ForCharge$codeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
};
var $author$project$Formatters$ChargeItemCode$codeTypes = _List_fromArray(
	[
		_Utils_Tuple2('cpt', 'CPT'),
		_Utils_Tuple2('loinc', 'LOINC'),
		_Utils_Tuple2('ndc', 'NDC'),
		_Utils_Tuple2('snowmed', 'Snowmed'),
		_Utils_Tuple2('other', 'Other')
	]);
var $author$project$Formatters$ChargeItemCode$formatCodeType = function (codeType_) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Dict$get,
			codeType_,
			$elm$core$Dict$fromList($author$project$Formatters$ChargeItemCode$codeTypes)));
};
var $author$project$Formatters$ChargeItemCode$codeType = function (chargeItem) {
	if (!chargeItem.$) {
		var _v1 = chargeItem.a;
		var codeType_ = _v1.a;
		return $author$project$Formatters$ChargeItemCode$formatCodeType(
			A2($elm$core$Maybe$withDefault, '', codeType_));
	} else {
		var chargeItemForCharge = chargeItem.a;
		return $author$project$Formatters$ChargeItemCode$formatCodeType(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItemForCharge)));
	}
};
var $author$project$Formatters$ChargeItemCode$toString = function (chargeItem) {
	var codeTypeName = $author$project$Formatters$ChargeItemCode$codeType(chargeItem);
	return (codeTypeName === '') ? '' : (codeTypeName + (' ' + $author$project$Formatters$ChargeItemCode$code(chargeItem)));
};
var $author$project$Components$ResourceFilter$ChargeItem$titleBase = function (resource) {
	var formattedCode = $author$project$Formatters$ChargeItemCode$toString(
		$author$project$Formatters$ChargeItemCode$CodeTypeAndCode(
			_Utils_Tuple2(resource.K5, resource.K3)));
	return _Utils_ap(
		resource.zh,
		_Utils_ap(
			(formattedCode !== '') ? (' - ' + formattedCode) : '',
			(resource.Tg !== '') ? (' - ' + resource.Tg) : ''));
};
var $author$project$Components$ResourceFilter$ChargeItem$toLabel = F2(
	function (showItemType, resource) {
		var titleWithItemType = showItemType ? _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$ResourceFilter$ChargeItem$titleBase(resource)),
				$elm$html$Html$text(' '),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$attrs(
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-muted')
							]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$ResourceFilter$ChargeItem$itemTypeLabel(resource.q9))
					]))
			]) : _List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$ResourceFilter$ChargeItem$titleBase(resource))
			]);
		var timeBasedUom = $author$project$Api$Provider$Uom$Shared$unitClass(resource.aam) === 'time';
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						A2($author$project$Ui$Typography$span, _List_Nil, titleWithItemType),
						A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromFloat(resource.Ba)),
								timeBasedUom ? A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										' per ' + $author$project$Api$Provider$Uom$Shared$name(resource.aam))
									])) : $author$project$Utils$Html$empty
							]))
					])),
				function () {
				var _v0 = resource.Nx;
				if (!_v0.$) {
					var description = _v0.a;
					return A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text(description)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
	});
var $author$project$Components$ResourceFilter$ChargeItem$toTitle = function (resource) {
	return $author$project$Components$ResourceFilter$ChargeItem$titleBase(resource);
};
var $author$project$Components$ResourceFilter$ChargeItem$toValue = function ($) {
	return $.adR;
};
var $author$project$Components$ResourceFilter$ChargeItem$initWithItemType = F4(
	function (showItemTypeInTitle, apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$ChargeItem$fetchResources(listOptionals),
				adR: $author$project$Components$ResourceFilter$ChargeItem$selectId,
				gx: 'Item',
				st: $author$project$Components$ResourceFilter$ChargeItem$retrieveResource(listOptionals),
				ahw: $author$project$Components$ResourceFilter$ChargeItem$toLabel(showItemTypeInTitle),
				ahA: $author$project$Components$ResourceFilter$ChargeItem$toTitle,
				g0: $author$project$Components$ResourceFilter$ChargeItem$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$ChargeItem$init = $author$project$Components$ResourceFilter$ChargeItem$initWithItemType(false);
var $author$project$Api$Provider$ChargeItem$One$isLab = function (chargeItem) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Category$Shared$name,
		$author$project$Api$Provider$ChargeItem$One$category(chargeItem));
	if (!_v0.$) {
		var categoryName_ = _v0.a;
		return categoryName_ === 'Labs';
	} else {
		return false;
	}
};
var $author$project$Components$ResourceFilter$preSelectedId = F2(
	function (id, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{afT: id}),
			$author$project$Components$ResourceFilter$setPreSelected(0));
	});
var $author$project$Components$ResourceFilter$Category$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bb);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bb: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$ChargeItems$Form$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString = function (itemType_) {
	if (!itemType_) {
		return 'item';
	} else {
		return 'package';
	}
};
var $author$project$Api$Provider$ChargeItem$create = F3(
	function (apiClient, fields, toMsg) {
		var uom = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(fields.aam))
				]));
		var encodePackageItem = function (item) {
			return $elm$json$Json$Encode$object(
				$elm$core$List$concat(
					_List_fromArray(
						[
							function () {
							var _v3 = item.adR;
							if (!_v3.$) {
								var packageItemId = _v3.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(packageItemId))
									]);
							} else {
								return _List_Nil;
							}
						}(),
							_List_fromArray(
							[
								_Utils_Tuple2(
								'charge_item',
								$author$project$Utils$Encode$typedAssociation(item.lp)),
								_Utils_Tuple2(
								'quantity',
								$elm$json$Json$Encode$int(item.Bd)),
								_Utils_Tuple2(
								'price_in_cents',
								$author$project$Currency$encodeFloat(item.Ba))
							])
						])));
		};
		var encodePackage = function (pkg) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'package_items',
						A2($elm$json$Json$Encode$list, encodePackageItem, pkg.Vr)),
						_Utils_Tuple2(
						'expiration_number',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, pkg.OW)),
						_Utils_Tuple2(
						'expiration_unit',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, pkg.OX)),
						_Utils_Tuple2(
						'revenue_recognition',
						$elm$json$Json$Encode$string(pkg.YH))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge_item',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'price_in_cents',
									$author$project$Currency$encodeFloat(fields.Ba)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'description',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Nx)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'rich_description',
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'en',
														A2(
															$author$project$Utils$Encode$nullable,
															$elm$json$Json$Encode$string,
															A2($elm$core$Dict$get, 'en', fields.BW))),
														_Utils_Tuple2(
														'es',
														A2(
															$author$project$Utils$Encode$nullable,
															$elm$json$Json$Encode$string,
															A2($elm$core$Dict$get, 'es', fields.BW)))
													]))),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'track_inventory',
												$elm$json$Json$Encode$bool(fields.$_)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'alert_quantity',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.IN)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'taxable',
														$elm$json$Json$Encode$bool(fields.$u)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'buyable',
															$elm$json$Json$Encode$bool(fields.Kh)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'category',
																A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Ex)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2('uom', uom),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'days_supply',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.MW)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'code',
																			$elm$json$Json$Encode$string(fields.K3)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'code_type',
																				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.K5)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'manufacturer',
																					$elm$json$Json$Encode$string(fields.Tg)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'item_type',
																						$elm$json$Json$Encode$string(
																							$author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(fields.q9))),
																					_Utils_ap(
																						function () {
																							var _v0 = fields.SE;
																							if (!_v0.$) {
																								var lastSetQuantity_ = _v0.a;
																								return _List_fromArray(
																									[
																										_Utils_Tuple2(
																										'last_set_quantity',
																										$elm$json$Json$Encode$int(lastSetQuantity_))
																									]);
																							} else {
																								return _List_Nil;
																							}
																						}(),
																						_Utils_ap(
																							function () {
																								var _v1 = fields.Vq;
																								if (!_v1.$) {
																									var pkg = _v1.a;
																									return _List_fromArray(
																										[
																											_Utils_Tuple2(
																											'package',
																											encodePackage(pkg))
																										]);
																								} else {
																									return _List_Nil;
																								}
																							}(),
																							function () {
																								var _v2 = fields.QN;
																								if (!_v2.$) {
																									var url = _v2.a;
																									return _List_fromArray(
																										[
																											_Utils_Tuple2(
																											'image',
																											$elm$json$Json$Encode$string(url))
																										]);
																								} else {
																									return _List_Nil;
																								}
																							}())))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ChargeItem$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath)));
	});
var $author$project$Components$TranslatedRichText$translations = function (model) {
	return model.aaa;
};
var $author$project$Components$Admin$ChargeItems$Form$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var _package = function () {
			if (fields.q9 === 1) {
				var packageItems = A2(
					$elm$core$List$filterMap,
					function (item) {
						return A2(
							$elm$core$Maybe$map,
							function (chargeItemId) {
								return {
									lp: {
										adR: $elm$core$Maybe$Just(chargeItemId),
										ahI: $elm$core$Maybe$Just('charge_item')
									},
									adR: item.adR,
									Ba: item.Ba,
									Bd: item.Bd
								};
							},
							item.abX);
					},
					fields.Vr);
				return $elm$core$Maybe$Just(
					{
						OW: fields.b8 ? A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$max(1),
							$elm$core$String$toInt(fields.OW)) : $elm$core$Maybe$Nothing,
						OX: fields.b8 ? $elm$core$Maybe$Just(fields.OX) : $elm$core$Maybe$Nothing,
						Vr: packageItems,
						YH: fields.YH
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var apiFields = {
			IN: fields.IN,
			Kh: fields.Kh,
			Ex: fields.Ex,
			K3: fields.K3,
			K5: fields.K5,
			MW: fields.MW,
			Nx: fields.Nx,
			QN: fields.QN,
			q9: fields.q9,
			SE: fields.SE,
			Tg: fields.Tg,
			zh: fields.zh,
			Vq: _package,
			Ba: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Ba),
			BW: $author$project$Components$TranslatedRichText$translations(fields.ez),
			$u: fields.$u,
			$_: fields.$_,
			aam: fields.aam
		};
		return A3($author$project$Api$Provider$ChargeItem$create, apiClient, apiFields, $author$project$Components$Admin$ChargeItems$Form$Created);
	});
var $author$project$Components$Admin$ChargeItems$Form$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Encode$optional = F3(
	function (fieldName, encoder, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					fieldName,
					encoder(value))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Api$Provider$ChargeItem$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var uom = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(fields.aam))
				]));
		var encodePackageItem = function (item) {
			return $elm$json$Json$Encode$object(
				$elm$core$List$concat(
					_List_fromArray(
						[
							function () {
							var _v2 = item.adR;
							if (!_v2.$) {
								var packageItemId = _v2.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(packageItemId))
									]);
							} else {
								return _List_Nil;
							}
						}(),
							_List_fromArray(
							[
								_Utils_Tuple2(
								'charge_item',
								$author$project$Utils$Encode$typedAssociation(item.lp)),
								_Utils_Tuple2(
								'quantity',
								$elm$json$Json$Encode$int(item.Bd)),
								_Utils_Tuple2(
								'price_in_cents',
								$author$project$Currency$encodeFloat(item.Ba))
							])
						])));
		};
		var encodePackage = function (pkg) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'package_items',
						A2($elm$json$Json$Encode$list, encodePackageItem, pkg.Vr)),
						_Utils_Tuple2(
						'expiration_number',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, pkg.OW)),
						_Utils_Tuple2(
						'expiration_unit',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, pkg.OX)),
						_Utils_Tuple2(
						'revenue_recognition',
						$elm$json$Json$Encode$string(pkg.YH))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge_item',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'price_in_cents',
									$author$project$Currency$encodeFloat(fields.Ba)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'description',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Nx)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'rich_description',
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'en',
														A2(
															$author$project$Utils$Encode$nullable,
															$elm$json$Json$Encode$string,
															A2($elm$core$Dict$get, 'en', fields.BW))),
														_Utils_Tuple2(
														'es',
														A2(
															$author$project$Utils$Encode$nullable,
															$elm$json$Json$Encode$string,
															A2($elm$core$Dict$get, 'es', fields.BW)))
													]))),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'track_inventory',
												$elm$json$Json$Encode$bool(fields.$_)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'alert_quantity',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.IN)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'taxable',
														$elm$json$Json$Encode$bool(fields.$u)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'buyable',
															$elm$json$Json$Encode$bool(fields.Kh)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'category',
																A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Ex)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2('uom', uom),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'days_supply',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.MW)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'code',
																			$elm$json$Json$Encode$string(fields.K3)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'code_type',
																				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.K5)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'manufacturer',
																					$elm$json$Json$Encode$string(fields.Tg)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'item_type',
																						$elm$json$Json$Encode$string(
																							$author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(fields.q9))),
																					_Utils_ap(
																						A3($author$project$Utils$Encode$optional, 'last_set_quantity', $elm$json$Json$Encode$int, fields.SE),
																						_Utils_ap(
																							function () {
																								var _v0 = fields.Vq;
																								if (!_v0.$) {
																									var pkg = _v0.a;
																									return _List_fromArray(
																										[
																											_Utils_Tuple2(
																											'package',
																											encodePackage(pkg))
																										]);
																								} else {
																									return _List_Nil;
																								}
																							}(),
																							function () {
																								var _v1 = fields.QN;
																								if (!_v1.$) {
																									var url = _v1.a;
																									return _List_fromArray(
																										[
																											_Utils_Tuple2(
																											'image',
																											$elm$json$Json$Encode$string(url))
																										]);
																								} else {
																									return _List_Nil;
																								}
																							}())))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ChargeItem$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ChargeItem$chargeItemPath(id_))));
	});
var $author$project$Components$Admin$ChargeItems$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var _package = function () {
			if (fields.q9 === 1) {
				var packageItems = A2(
					$elm$core$List$filterMap,
					function (item) {
						return A2(
							$elm$core$Maybe$map,
							function (chargeItemId) {
								return {
									lp: {
										adR: $elm$core$Maybe$Just(chargeItemId),
										ahI: $elm$core$Maybe$Just('charge_item')
									},
									adR: item.adR,
									Ba: item.Ba,
									Bd: item.Bd
								};
							},
							item.abX);
					},
					fields.Vr);
				return $elm$core$Maybe$Just(
					{
						OW: fields.b8 ? A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$max(1),
							$elm$core$String$toInt(fields.OW)) : $elm$core$Maybe$Nothing,
						OX: fields.b8 ? $elm$core$Maybe$Just(fields.OX) : $elm$core$Maybe$Nothing,
						Vr: packageItems,
						YH: fields.YH
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var apiFields = {
			IN: fields.IN,
			Kh: fields.Kh,
			Ex: fields.Ex,
			K3: fields.K3,
			K5: fields.K5,
			MW: fields.MW,
			Nx: fields.Nx,
			QN: fields.QN,
			q9: fields.q9,
			SE: fields.iv ? fields.SE : $elm$core$Maybe$Nothing,
			Tg: fields.Tg,
			zh: fields.zh,
			Vq: _package,
			Ba: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Ba),
			BW: $author$project$Components$TranslatedRichText$translations(fields.ez),
			$u: fields.$u,
			$_: fields.$_,
			aam: fields.aam
		};
		return A4($author$project$Api$Provider$ChargeItem$update, apiClient, id, apiFields, $author$project$Components$Admin$ChargeItems$Form$Updated);
	});
var $author$project$Components$Admin$ChargeItems$Form$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Admin$ChargeItems$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Admin$ChargeItems$Form$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$ResourceFilter$ChargeItem$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{G0: resource});
	});
var $elm$file$File$size = _File_size;
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$Components$ResourceFilter$Closed = {$: 1};
var $author$project$Components$ResourceFilter$FreeText = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$GotPreselectedItem = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$ResourceFilter$ItemSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$Many = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$None = {$: 3};
var $author$project$Components$ResourceFilter$One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$SelectMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$DebouncedMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$ResourceFilter$debounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(300),
	ahG: $author$project$Components$ResourceFilter$DebouncedMsg
};
var $author$project$Components$ResourceFilter$DropdownSearchDebounced = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$ResourceFilter$debounceText = function (text) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$ResourceFilter$DropdownSearchDebounced,
		$elm$core$Task$succeed(text));
};
var $author$project$Components$ResourceFilter$itemChecked = F2(
	function (model, many) {
		return {
			EC: $elm$core$Platform$Cmd$none,
			ac5: $elm$core$Maybe$Just(
				$author$project$Components$ResourceFilter$ItemSelected(many)),
			y8: model,
			as: _List_Nil
		};
	});
var $author$project$Components$ResourceFilter$itemSelected = F3(
	function (apiClient, model, selected) {
		return {
			EC: A4(
				model.gB,
				$author$project$Components$ResourceFilter$GotItems(false),
				apiClient,
				model.afy,
				$elm$core$Maybe$Nothing),
			ac5: $elm$core$Maybe$Just(
				$author$project$Components$ResourceFilter$ItemSelected(
					A2($elm$core$Maybe$withDefault, $author$project$Components$ResourceFilter$None, selected))),
			y8: _Utils_update(
				model,
				{af_: $elm$core$Maybe$Nothing}),
			as: _List_Nil
		};
	});
var $author$project$Components$ResourceFilter$loadMoreTriggerId = 'load-more';
var $author$project$Api$Pagination$nextPage = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{bV: model.bV + 1});
};
var $author$project$Api$Pagination$reset = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{bV: 1});
};
var $author$project$Components$ResourceFilter$setPreselectedLimit = 20;
var $author$project$Components$ResourceFilter$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 9:
				var pagination = $author$project$Api$Pagination$nextPage(model.afy);
				return {
					EC: A4(
						model.gB,
						$author$project$Components$ResourceFilter$GotItems(true),
						apiClient,
						pagination,
						model.af_),
					ac5: $elm$core$Maybe$Nothing,
					y8: _Utils_update(
						model,
						{i1: true, afy: pagination}),
					as: _List_Nil
				};
			case 5:
				var a = msg.a;
				return function (newModel) {
					return A3($author$project$Components$ResourceFilter$itemSelected, apiClient, newModel, a);
				}(
					_Utils_update(
						model,
						{
							afy: $author$project$Api$Pagination$reset(model.afy)
						}));
			case 6:
				var a = msg.a;
				return A2($author$project$Components$ResourceFilter$itemChecked, model, a);
			case 4:
				var dropdownMsg = msg.a;
				var _v1 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.fy);
				var dropdown = _v1.a;
				var dropdownCmd = _v1.b;
				return {
					EC: dropdownCmd,
					ac5: $elm$core$Maybe$Nothing,
					y8: _Utils_update(
						model,
						{fy: dropdown}),
					as: _List_Nil
				};
			case 0:
				var selectMsg = msg.a;
				var _v2 = A2($author$project$Ui$Form$SearchableSelect$update, selectMsg, model.sC);
				var selectModel = _v2.a;
				var selectCmd = _v2.b;
				var selectEvent = _v2.c;
				var _v3 = function () {
					if (!selectEvent.$) {
						switch (selectEvent.a.$) {
							case 3:
								var id = selectEvent.a.a;
								if (_Utils_eq(id, $author$project$Components$ResourceFilter$loadMoreTriggerId)) {
									var pagination = $author$project$Api$Pagination$nextPage(model.afy);
									return _Utils_Tuple3(
										_Utils_update(
											model,
											{i1: true, afy: pagination}),
										A4(
											model.gB,
											$author$project$Components$ResourceFilter$GotItems(true),
											apiClient,
											pagination,
											model.af_),
										$elm$core$Maybe$Nothing);
								} else {
									return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
								}
							case 0:
								var selected = selectEvent.a.a;
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$elm$core$Maybe$Just(
										$author$project$Components$ResourceFilter$ItemSelected(
											A2($elm$core$Maybe$withDefault, $author$project$Components$ResourceFilter$None, selected))));
							case 1:
								var string = selectEvent.a.a;
								var pagination = $author$project$Api$Pagination$reset(model.afy);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											xJ: $author$project$Utils$String$toMaybe(string),
											afy: pagination,
											af_: $elm$core$Maybe$Just(string),
											n9: true
										}),
									A4(
										model.gB,
										$author$project$Components$ResourceFilter$GotItems(false),
										apiClient,
										pagination,
										$elm$core$Maybe$Just(string)),
									model.zY.adB ? $elm$core$Maybe$Just(
										$author$project$Components$ResourceFilter$ItemSelected(
											$author$project$Components$ResourceFilter$FreeText(string))) : $elm$core$Maybe$Nothing);
							default:
								var _v5 = selectEvent.a;
								var pagination = model.zY.adB ? model.afy : $author$project$Api$Pagination$reset(model.afy);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{afy: pagination, af_: $elm$core$Maybe$Nothing}),
									model.zY.adB ? $elm$core$Platform$Cmd$none : A4(
										model.gB,
										$author$project$Components$ResourceFilter$GotItems(false),
										apiClient,
										pagination,
										$elm$core$Maybe$Nothing),
									$elm$core$Maybe$Just($author$project$Components$ResourceFilter$Closed));
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					}
				}();
				var modelAfterEvent = _v3.a;
				var cmdAfterEvent = _v3.b;
				var eventAfterEvent = _v3.c;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$SelectMsg, selectCmd),
								cmdAfterEvent
							])),
					ac5: eventAfterEvent,
					y8: _Utils_update(
						modelAfterEvent,
						{sC: selectModel}),
					as: _List_Nil
				};
			case 3:
				var attempts = msg.a;
				var _v6 = model.aZ;
				if (!_v6.$) {
					var items = _v6.a;
					var _v7 = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none),
						A2(
							$elm$core$Maybe$map,
							function (preSelectedId_) {
								var selected = A2(
									$elm$core$Maybe$map,
									$author$project$Components$ResourceFilter$One,
									A2(
										$elm_community$list_extra$List$Extra$find,
										function (item) {
											return _Utils_eq(
												model.g0(item),
												preSelectedId_);
										},
										items));
								var extraSelected = A2(
									$elm$core$Maybe$map,
									$author$project$Components$ResourceFilter$Extra,
									A2(
										$elm_community$list_extra$List$Extra$find,
										function (extraItem) {
											return _Utils_eq(extraItem.aaN, preSelectedId_);
										},
										model.d$));
								var _v8 = _Utils_Tuple3(selected, extraSelected, preSelectedId_);
								if (!_v8.a.$) {
									var selected_ = _v8.a.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(
											$author$project$Components$ResourceFilter$ItemSelected(selected_)),
										$elm$core$Platform$Cmd$none);
								} else {
									if (!_v8.b.$) {
										var extraSelected_ = _v8.b.a;
										return _Utils_Tuple2(
											$elm$core$Maybe$Just(
												$author$project$Components$ResourceFilter$ItemSelected(extraSelected_)),
											$elm$core$Platform$Cmd$none);
									} else {
										var anyString = _v8.c;
										return ($elm$core$String$isEmpty(anyString) && model.zY.aeZ) ? _Utils_Tuple2(
											$elm$core$Maybe$Just(
												$author$project$Components$ResourceFilter$ItemSelected($author$project$Components$ResourceFilter$None)),
											$elm$core$Platform$Cmd$none) : ((!$elm$core$String$isEmpty(anyString)) ? _Utils_Tuple2(
											$elm$core$Maybe$Nothing,
											A3(
												model.st,
												$author$project$Components$ResourceFilter$GotPreselectedItem(anyString),
												apiClient,
												anyString)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none));
									}
								}
							},
							model.afT));
					var event = _v7.a;
					var cmd = _v7.b;
					return {
						EC: cmd,
						ac5: event,
						y8: _Utils_update(
							model,
							{afT: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return {
						EC: (_Utils_cmp(attempts, $author$project$Components$ResourceFilter$setPreselectedLimit) > 0) ? $elm$core$Platform$Cmd$none : $author$project$Components$ResourceFilter$setPreSelected(attempts),
						ac5: $elm$core$Maybe$Nothing,
						y8: model,
						as: _List_Nil
					};
				}
			case 1:
				var append = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var items = response.a;
					var headers = response.b;
					var dataItems = function () {
						var _v10 = _Utils_Tuple2(model.ac6, model.ac7);
						_v10$2:
						while (true) {
							if (!_v10.a.$) {
								if (_v10.b.$ === 1) {
									var excludedId_ = _v10.a.a;
									var _v11 = _v10.b;
									return A2(
										$elm$core$List$filter,
										function (item) {
											return !_Utils_eq(
												model.g0(item),
												excludedId_);
										},
										items);
								} else {
									break _v10$2;
								}
							} else {
								if (!_v10.b.$) {
									var _v12 = _v10.a;
									var excludedTitles_ = _v10.b.a;
									return A2(
										$elm$core$List$filter,
										function (item) {
											return !A2(
												$elm$core$List$member,
												model.ahA(item),
												excludedTitles_);
										},
										items);
								} else {
									break _v10$2;
								}
							}
						}
						return items;
					}();
					return {
						EC: $author$project$Components$ResourceFilter$setPreSelected(0),
						ac5: $elm$core$Maybe$Nothing,
						y8: _Utils_update(
							model,
							{
								aZ: $elm$core$Maybe$Just(
									append ? _Utils_ap(
										A2($elm$core$Maybe$withDefault, _List_Nil, model.aZ),
										dataItems) : dataItems),
								i1: false,
								n9: false,
								oO: A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$toInt,
										A2($elm$core$Dict$get, 'x-total-count', headers)))
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $elm$core$Maybe$Nothing,
						y8: _Utils_update(
							model,
							{aZ: $elm$core$Maybe$Nothing, i1: false, n9: false, oO: $elm$core$Maybe$Nothing}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 2:
				var preSelectedId_ = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var items = response.a;
					var preSelectedItem = A2(
						$elm$core$List$filter,
						function (item) {
							return A2(
								$elm$core$List$member,
								model.g0(item),
								A2($elm$core$String$split, ',', preSelectedId_));
						},
						items);
					if (preSelectedItem.b) {
						if (!preSelectedItem.b.b) {
							var preSelectedItem_ = preSelectedItem.a;
							return {
								EC: $author$project$Components$ResourceFilter$setPreSelected(0),
								ac5: $elm$core$Maybe$Just(
									$author$project$Components$ResourceFilter$ItemSelected(
										$author$project$Components$ResourceFilter$One(preSelectedItem_))),
								y8: _Utils_update(
									model,
									{
										aZ: $elm$core$Maybe$Just(
											_Utils_ap(
												A2($elm$core$Maybe$withDefault, _List_Nil, model.aZ),
												_List_fromArray(
													[preSelectedItem_])))
									}),
								as: _List_Nil
							};
						} else {
							var preselectedItems = preSelectedItem;
							return {
								EC: $author$project$Components$ResourceFilter$setPreSelected(0),
								ac5: $elm$core$Maybe$Just(
									$author$project$Components$ResourceFilter$ItemSelected(
										$author$project$Components$ResourceFilter$Many(preselectedItems))),
								y8: _Utils_update(
									model,
									{
										aZ: $elm$core$Maybe$Just(
											A2($elm$core$Maybe$withDefault, _List_Nil, model.aZ))
									}),
								as: _List_Nil
							};
						}
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $elm$core$Maybe$Nothing,
							y8: model,
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $elm$core$Maybe$Nothing,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 8:
				var text = msg.a;
				var _v15 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$ResourceFilter$debounceConfig, text, model.dE);
				var newDebouncer = _v15.a;
				var cmd = _v15.b;
				return {
					EC: cmd,
					ac5: $elm$core$Maybe$Nothing,
					y8: _Utils_update(
						model,
						{
							dE: newDebouncer,
							af_: $elm$core$Maybe$Just(text)
						}),
					as: _List_Nil
				};
			case 10:
				var debounceMsg = msg.a;
				var _v16 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$ResourceFilter$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$ResourceFilter$debounceText),
					debounceMsg,
					model.dE);
				var newDebouncer = _v16.a;
				var cmd = _v16.b;
				return {
					EC: cmd,
					ac5: $elm$core$Maybe$Nothing,
					y8: _Utils_update(
						model,
						{dE: newDebouncer}),
					as: _List_Nil
				};
			default:
				var text = msg.a;
				var pagination = $author$project$Api$Pagination$reset(model.afy);
				return {
					EC: A4(
						model.gB,
						$author$project$Components$ResourceFilter$GotItems(false),
						apiClient,
						pagination,
						$elm$core$Maybe$Just(text)),
					ac5: $elm$core$Maybe$Nothing,
					y8: _Utils_update(
						model,
						{
							afy: pagination,
							af_: $elm$core$Maybe$Just(text)
						}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$ResourceFilter$Category$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$ChargeItem$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$TranslatedRichText$update = F3(
	function (editorId, msg, model) {
		switch (msg.$) {
			case 0:
				var content = msg.a;
				var langKey = $author$project$Language$toValue(model.h1);
				var newTranslations = $elm$core$String$isEmpty(content) ? A2($elm$core$Dict$remove, langKey, model.aaa) : A3($elm$core$Dict$insert, langKey, content, model.aaa);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aaa: newTranslations}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var content = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Dict$get,
						$author$project$Language$toValue(model.h1),
						model.aaa));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mE: true}),
					A3($author$project$Ports$CKEditor$replace, editorId, content, _List_Nil));
			case 2:
				var language = msg.a;
				var content = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Dict$get,
						$author$project$Language$toValue(language),
						model.aaa));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{h1: language}),
					A2($author$project$Ports$CKEditor$setData, editorId, content));
			default:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$NewDropdown$update, subMsg, model.fy);
				var newDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fy: newDropdown}),
					cmd);
		}
	});
var $author$project$Components$ResourceFilter$choiceToValue = F2(
	function (model, choice) {
		switch (choice.$) {
			case 2:
				return model.zY.abe;
			case 3:
				return model.zY.ae_;
			case 0:
				var item = choice.a;
				return $elm$core$Maybe$Just(
					model.g0(item));
			case 1:
				var items = choice.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						',',
						A2($elm$core$List$map, model.g0, items)));
			case 4:
				var extraItem = choice.a;
				return $elm$core$Maybe$Just(extraItem.aaN);
			default:
				var string = choice.a;
				return $elm$core$Maybe$Just(string);
		}
	});
var $author$project$Components$ResourceFilter$Category$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Admin$ChargeItems$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var chargeItem = response.a;
					var formFields = $author$project$Components$Admin$ChargeItems$Form$formFieldsFromItem(chargeItem);
					var category = $author$project$Api$Provider$ChargeItem$One$category(chargeItem);
					var _v3 = function () {
						if ($author$project$Api$Provider$ChargeItem$One$itemType(chargeItem) === 1) {
							var packageItems = $author$project$Api$Provider$ChargeItem$One$packageItems(chargeItem);
							var originalPrices = $elm$core$Dict$fromList(
								A2(
									$elm$core$List$filterMap,
									$elm$core$Basics$identity,
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, item) {
												return A2(
													$elm$core$Maybe$andThen,
													function (price) {
														return (price > 0) ? $elm$core$Maybe$Just(
															_Utils_Tuple2(
																$elm$core$String$fromInt(index),
																$author$project$Currency$fromFloat(price))) : $elm$core$Maybe$Nothing;
													},
													item.abZ);
											}),
										packageItems)));
							return A3(
								$elm$core$List$foldl,
								F2(
									function (rule, _v6) {
										var _v7 = _v6.a;
										var filters = _v7.a;
										var cmds = _v7.b;
										var _v8 = _v6.b;
										var tMap = _v8.a;
										var _v9 = A3(
											$author$project$Components$ResourceFilter$ChargeItem$init,
											apiClient,
											function (opts) {
												return _Utils_update(
													opts,
													{
														q9: $elm$core$Maybe$Just('item')
													});
											},
											function (d) {
												return _Utils_update(
													d,
													{D0: 'Select a Charge Item'});
											});
										var resourceFilter = _v9.a;
										var cmd = _v9.b;
										var finalResourceFilter = function () {
											var _v10 = _Utils_Tuple2(rule.abX, rule.abY);
											if (!_v10.a.$) {
												var id = _v10.a.a;
												var maybeName = _v10.b;
												var name = A2($elm$core$Maybe$withDefault, id, maybeName);
												return A2(
													$author$project$Components$ResourceFilter$ChargeItem$setValue,
													$author$project$Components$ResourceFilter$Extra(
														{aej: name, aaN: id}),
													A2(
														$author$project$Components$ResourceFilter$ChargeItem$extraItems,
														_List_fromArray(
															[
																{adR: id, zh: name}
															]),
														resourceFilter));
											} else {
												return resourceFilter;
											}
										}();
										return _Utils_Tuple2(
											_Utils_Tuple2(
												A3($elm$core$Dict$insert, rule.K, finalResourceFilter, filters),
												A2(
													$elm$core$List$cons,
													A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(rule.K),
														cmd),
													cmds)),
											_Utils_Tuple2(tMap, originalPrices));
									}),
								_Utils_Tuple2(
									_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
									_Utils_Tuple2($elm$core$Dict$empty, originalPrices)),
								formFields.Vr);
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
								_Utils_Tuple2($elm$core$Dict$empty, $elm$core$Dict$empty));
						}
					}();
					var _v4 = _v3.a;
					var packageItemFilters = _v4.a;
					var filterCmds = _v4.b;
					var _v5 = _v3.b;
					var taxableMap = _v5.a;
					var originalPricesMap = _v5.b;
					var _v11 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$Category$extraItems(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return _List_fromArray(
											[
												{
												adR: $author$project$Api$Provider$Category$Shared$id(category_),
												zh: $author$project$Api$Provider$Category$Shared$name(category_)
											}
											]);
									},
									category))),
						A2(
							$author$project$Components$ResourceFilter$Category$preSelectedId,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
							model.cJ));
					var categoryResourceFilter = _v11.a;
					var categoryResourceFilterCmd = _v11.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cJ: categoryResourceFilter,
								fc: taxableMap,
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(formFields)),
								yi: $author$project$Api$Provider$ChargeItem$One$isLab(chargeItem),
								bv: originalPricesMap,
								cf: packageItemFilters
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
									$elm$core$Platform$Cmd$batch(filterCmds)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 10:
				var subMsg = msg.a;
				var _v12 = model.PB;
				if (!_v12.$) {
					var form = _v12.a;
					var fields = $author$project$Utils$Form$fields(form);
					var _v13 = A3($author$project$Components$TranslatedRichText$update, 'charge-item-rich-description-editor', subMsg, fields.ez);
					var newRichDescription = _v13.a;
					var richDescCmd = _v13.b;
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{ez: newRichDescription}),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg, richDescCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var field = msg.a;
				var _v14 = model.PB;
				if (!_v14.$) {
					var form = _v14.a;
					var updatedOriginalPrices = function () {
						if (field.$ === 18) {
							var tempId = field.a;
							return A2($elm$core$Dict$remove, tempId, model.bv);
						} else {
							return model.bv;
						}
					}();
					var newForm = function () {
						if (field.$ === 17) {
							return $author$project$Utils$Form$clearGroupErrors(5);
						} else {
							return $elm$core$Basics$identity;
						}
					}()(
						$author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(
							A3($author$project$Utils$Form$update, $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate, field, form)));
					var _v15 = function () {
						switch (field.$) {
							case 17:
								var formFields = $author$project$Utils$Form$fields(newForm);
								var tempId = A2(
									$elm$core$Maybe$withDefault,
									'0',
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.K;
										},
										$elm$core$List$head(
											$elm$core$List$reverse(formFields.Vr))));
								var _v17 = A3(
									$author$project$Components$ResourceFilter$ChargeItem$init,
									apiClient,
									function (opts) {
										return _Utils_update(
											opts,
											{
												q9: $elm$core$Maybe$Just('item')
											});
									},
									function (d) {
										return _Utils_update(
											d,
											{D0: 'Select a Charge Item'});
									});
								var resourceFilter = _v17.a;
								var cmd = _v17.b;
								return _Utils_Tuple2(
									A3($elm$core$Dict$insert, tempId, resourceFilter, model.cf),
									A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(tempId),
										cmd));
							case 18:
								var tempId = field.a;
								return _Utils_Tuple2(
									A2($elm$core$Dict$remove, tempId, model.cf),
									$elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(model.cf, $elm$core$Platform$Cmd$none);
						}
					}();
					var updatedFilters = _v15.a;
					var filterCmd = _v15.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								bv: updatedOriginalPrices,
								cf: updatedFilters
							}),
						filterCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v20 = model.PB;
				if (!_v20.$) {
					var form = _v20.a;
					var _v21 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$ChargeItems$Form$formFieldsValidator, form);
					if (!_v21.$) {
						var _v22 = _v21.a;
						var newForm = _v22.a;
						var validFormFields = _v22.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							A3($author$project$Components$Admin$ChargeItems$Form$saveItem, apiClient, model.adR, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v21.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				var _v23 = model.PB;
				if (!_v23.$) {
					if (response.$ === 3) {
						var chargeItem = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$ChargeItem$One$name(chargeItem))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				var _v25 = model.PB;
				if (!_v25.$) {
					if (response.$ === 3) {
						var chargeItem = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$ChargeItem$One$name(chargeItem) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cJ);
				var _v27 = model.PB;
				if (!_v27.$) {
					var form = _v27.a;
					var newForm = function () {
						var _v28 = categoryResourceResult.ac5;
						if (!_v28.$) {
							if (!_v28.a.$) {
								return A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate,
									$author$project$Components$Admin$ChargeItems$Form$Category(
										$author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8)),
									form);
							} else {
								var _v29 = _v28.a;
								return form;
							}
						} else {
							return form;
						}
					}();
					var newModel = _Utils_update(
						model,
						{
							cJ: categoryResourceResult.y8,
							PB: $elm$core$Maybe$Just(newForm)
						});
					return _Utils_Tuple3(
						newModel,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceResult.EC),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cJ: categoryResourceResult.y8}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceResult.EC),
						_List_Nil);
				}
			case 6:
				var tempId = msg.a;
				var subMsg = msg.b;
				var maybeFilter = A2($elm$core$Dict$get, tempId, model.cf);
				var _v30 = function () {
					if (!maybeFilter.$) {
						var resourceFilter = maybeFilter.a;
						var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, resourceFilter);
						var updatedFilters = A3($elm$core$Dict$insert, tempId, chargeItemResourceResult.y8, model.cf);
						var _v32 = function () {
							var _v33 = chargeItemResourceResult.ac5;
							_v33$2:
							while (true) {
								if ((!_v33.$) && (!_v33.a.$)) {
									switch (_v33.a.a.$) {
										case 0:
											var chargeItem = _v33.a.a.a;
											var _v34 = model.PB;
											if (!_v34.$) {
												var form = _v34.a;
												var originalPrice = $author$project$Currency$fromFloat(chargeItem.Ba);
												var selectedItem = A5($author$project$Components$Admin$ChargeItems$Form$SelectPackageItem, tempId, chargeItem.adR, chargeItem.zh, originalPrice, chargeItem.$u);
												var selectedForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate, selectedItem, form);
												var newTaxableMap = A3($elm$core$Dict$insert, chargeItem.adR, chargeItem.$u, model.fc);
												var newOriginalPrices = A3($elm$core$Dict$insert, tempId, originalPrice, model.bv);
												return _Utils_Tuple3(
													$elm$core$Maybe$Just(
														$author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(selectedForm)),
													newTaxableMap,
													newOriginalPrices);
											} else {
												return _Utils_Tuple3($elm$core$Maybe$Nothing, model.fc, model.bv);
											}
										case 4:
											return _Utils_Tuple3(model.PB, model.fc, model.bv);
										default:
											break _v33$2;
									}
								} else {
									break _v33$2;
								}
							}
							return _Utils_Tuple3(model.PB, model.fc, model.bv);
						}();
						var updatedForm = _v32.a;
						var updatedTaxableMap = _v32.b;
						var updatedOriginalPrices = _v32.c;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{fc: updatedTaxableMap, PB: updatedForm, bv: updatedOriginalPrices, cf: updatedFilters}),
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(tempId),
								chargeItemResourceResult.EC));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var updatedModel = _v30.a;
				var cmd = _v30.b;
				return _Utils_Tuple3(updatedModel, cmd, _List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v35 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lt);
				var newDropdown = _v35.a;
				var cmd = _v35.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lt: newDropdown}),
					cmd,
					_List_Nil);
			case 8:
				var selectedCodeType = msg.a;
				var newForm = A2(
					$elm$core$Maybe$map,
					function (form) {
						return $author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(
							A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate,
								$author$project$Components$Admin$ChargeItems$Form$CodeType(selectedCodeType),
								form));
					},
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var pictures = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v36) {
							var task = _v36.a;
							var size = _v36.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Admin$ChargeItems$Form$FormUpdated,
									$author$project$Components$Admin$ChargeItems$Form$Image(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (picture) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(picture),
									$elm$file$File$size(picture));
							},
							$elm$core$List$head(pictures))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			default:
				return _Utils_Tuple3(model, $author$project$Ports$Navigation$back, _List_Nil);
		}
	});
var $author$project$Pages$Admin$ChargeItems$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$ChargeItems$Form$update, model.D5, subMsg, model.PB);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Admin$ChargeItems$Form$BackButtonClicked = {$: 9};
var $author$project$Components$Admin$ChargeItems$Form$Save = {$: 2};
var $author$project$Ui$Panel$titleWithButton = F2(
	function (contents, buttons) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(contents),
					A2($author$project$Ui$Element$view, _List_Nil, buttons)
				]));
	});
var $author$project$Api$Feature$Packages = 22;
var $author$project$Api$Feature$SelfBuy = 23;
var $author$project$Api$Provider$ChargeItem$Meta$buyableEditable = function (_v0) {
	var meta = _v0;
	return meta.Kh.Oa;
};
var $author$project$Components$TranslatedRichText$EditToggled = {$: 1};
var $author$project$Ui$Form$Group$offsetLabel = $author$project$Ui$Form$Group$LabelGrid(
	_List_fromArray(
		['ml-1/12']));
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.f, s.n3, s.K6, s.sX);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.aB)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.f, newOffset) < 0,
			0,
			{K6: newCol, aB: s.aB, ad_: s.ad_, f: newOffset, n3: newRow, sX: s.sX});
	};
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {K6: s.K6 + (newOffset - s.f), aB: s.aB, ad_: s.ad_, f: newOffset, n3: s.n3, sX: s.sX};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.f, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.sX);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.n3, s.K6 - (floatOffset + s.f), invalid, s.aB));
		} else {
			if (_Utils_eq(s.f, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.f, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.f, floatOffset, s.sX));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.f, s.sX)) {
			var zeroOffset = s.f + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.sX) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.q$,
				c.adH,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.sX),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.sX) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.q$,
				c.UX,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.sX),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.sX) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.q$,
				c.J1,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.sX),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.q$,
				c.OV,
				c.Q2,
				c.Pz,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.q$,
				c.OV,
				c.Q2,
				c.Pz,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.f, s.sX),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				J1: $elm$core$Result$Err(invalid),
				OV: expecting,
				Pz: $elm$core$Result$Err(invalid),
				adH: $elm$core$Result$Err(invalid),
				Q2: $elm$core$Result$Ok($elm$core$Basics$identity),
				q$: invalid,
				UX: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Utils$Dom$textToHtml = function (htmlString) {
	var _v0 = $hecrj$html_parser$Html$Parser$run(htmlString);
	if (!_v0.$) {
		var nodes = _v0.a;
		return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(nodes);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Form$Textarea$Value = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Textarea$value = $author$project$Ui$Form$Textarea$Value;
var $author$project$Components$TranslatedRichText$LanguageSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$SvgIcon$Translate = 61;
var $author$project$Ui$SvgIcon$translate = $author$project$Ui$SvgIcon$viewIcon(61);
var $author$project$Components$TranslatedRichText$viewLanguageDropdown = F2(
	function (currentLanguage, dropdown) {
		var languageToItem = function (lang) {
			return A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(lang, currentLanguage)),
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$TranslatedRichText$LanguageSelected(lang))
					]),
				$elm$html$Html$text(
					$author$project$Language$toLabel(lang)));
		};
		var items = A2(
			$elm$core$List$map,
			languageToItem,
			_List_fromArray(
				[$author$project$Language$english, $author$project$Language$spanish]));
		return A3(
			$author$project$Ui$Element$custom,
			'absolute top-2 right-2 z-50 flex items-center',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mr2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_fromArray(
								[$author$project$Ui$Typography$hintLabel]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$translate(_List_Nil),
									$elm$html$Html$text('\u00A0'),
									$elm$html$Html$text('Now editing')
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Ui$NewDropdown$viewSelect,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pr-2')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Language$toLabel(currentLanguage))
										]))
								]),
							items,
							dropdown)
						]))
				]));
	});
var $author$project$Components$TranslatedRichText$view = F2(
	function (config, model) {
		var groupArgs = config.ae0 ? _List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(5),
				$author$project$Ui$Form$Group$inputSpanSm(6),
				$author$project$Ui$Form$Group$label('Plan Description'),
				$author$project$Ui$Form$Group$labelClass('')
			]) : _List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8),
				$author$project$Ui$Form$Group$label(config.aej)
			]);
		return A2(
			$author$project$Ui$Form$Group$view,
			groupArgs,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Element$custom,
					'relative',
					_List_Nil,
					function () {
						var currentDescription = A2(
							$elm$core$Dict$get,
							$author$project$Language$toValue(model.h1),
							model.aaa);
						return _List_fromArray(
							[
								function () {
								if (model.mE) {
									return $author$project$Ui$Form$Textarea$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Textarea$rows(10),
												$author$project$Ui$Form$Textarea$id(config.acT),
												$author$project$Ui$Form$Textarea$value(
												A2($elm$core$Maybe$withDefault, '', currentDescription))
											]));
								} else {
									var fallbackDescription = function () {
										var _v1 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, currentDescription);
										if (_v1.$ === 1) {
											return A2($elm$core$Dict$get, 'es', model.aaa);
										} else {
											return currentDescription;
										}
									}();
									return A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										_List_fromArray(
											[
												function () {
												if (!fallbackDescription.$) {
													var desc = fallbackDescription.a;
													return A2(
														$author$project$Ui$Typography$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('text-right')
																	]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Ui$Button$view,
																		{abp: 'Edit ' + config.aej},
																		_List_fromArray(
																			[
																				$author$project$Ui$Button$link,
																				$author$project$Ui$Button$onClick($author$project$Components$TranslatedRichText$EditToggled)
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Edit')
																			]))
																	])),
																A2(
																$author$project$Ui$Typography$div,
																_List_Nil,
																A2(
																	$elm$core$List$map,
																	$elm$html$Html$map($elm$core$Basics$never),
																	$author$project$Utils$Dom$textToHtml(desc)))
															]));
												} else {
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('flex justify-between items-center')
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$span,
																_List_fromArray(
																	[$author$project$Ui$Typography$muted]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('No description')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Edit ' + config.aej},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$onClick($author$project$Components$TranslatedRichText$EditToggled)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Edit')
																	]))
															]));
												}
											}()
											]));
								}
							}(),
								model.mE ? A2($author$project$Components$TranslatedRichText$viewLanguageDropdown, model.h1, model.fy) : $elm$html$Html$text('')
							]);
					}())
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionInitialPurchase = 'immediate';
var $author$project$Components$Admin$ChargeItems$Form$RevenueRecognition = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption = F3(
	function (selectedValue, optionValue, labelText) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio-inline')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('radio'),
							$elm$html$Html$Attributes$name('revenue-recognition'),
							$elm$html$Html$Attributes$value(optionValue),
							$elm$html$Html$Attributes$checked(
							_Utils_eq(selectedValue, optionValue)),
							$elm$html$Html$Events$onClick(
							$author$project$Components$Admin$ChargeItems$Form$FormUpdated(
								$author$project$Components$Admin$ChargeItems$Form$RevenueRecognition(optionValue)))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognition = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Revenue Recognition')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex flex-wrap gap-4 items-center')
					]),
				_List_fromArray(
					[
						A3($author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption, fields.YH, $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption, 'Upon item consumption (default)'),
						A3($author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption, fields.YH, $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionInitialPurchase, 'Upon initial purchase')
					]))
			]));
};
var $author$project$Components$Admin$ChargeItems$Form$viewAdvancedSettings = function (fields) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$margin(22)
			]),
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Advanced Settings')
							]))
					])),
				$author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognition(fields)
			]));
};
var $author$project$Components$Admin$ChargeItems$Form$Buyable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewBuyableCheckbox = F2(
	function (fields, disable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Can be purchased on patient portal')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.Kh),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Buyable)),
							$author$project$Ui$ToggleSwitch$disabled(disable)
						]))
				]));
	});
var $author$project$Components$ResourceFilter$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$disabled = $author$project$Components$ResourceFilter$Disabled;
var $author$project$Components$ResourceFilter$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$value = $author$project$Components$ResourceFilter$Value;
var $author$project$Components$ResourceFilter$DropdownItemChecked = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$ResourceFilter$DropdownItemSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$DropdownSearched = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$NewDropdown$Checkbox = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$checkbox = $author$project$Ui$NewDropdown$Checkbox;
var $author$project$Ui$NewDropdown$Item$Checked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$NewDropdown$checked = $author$project$Ui$NewDropdown$Item$Checked;
var $author$project$Ui$NewDropdown$Errors = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$NewDropdown$errors = $author$project$Ui$NewDropdown$Errors;
var $elm_community$list_extra$List$Extra$filterNot = F2(
	function (pred, list) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred),
			list);
	});
var $author$project$Components$ResourceFilter$DropdownLoadedMore = {$: 9};
var $author$project$Ui$NewDropdown$Item$OnSelectKeepOpen = {$: 10};
var $author$project$Ui$NewDropdown$onSelectKeepOpen = $author$project$Ui$NewDropdown$Item$OnSelectKeepOpen;
var $author$project$Ui$Button$Tabindex = function (a) {
	return {$: 20, a: a};
};
var $author$project$Ui$Button$preventFocus = $author$project$Ui$Button$Tabindex(-1);
var $author$project$Components$ResourceFilter$infoItem2 = F3(
	function (items, totalItemsCount, options) {
		if ($elm$core$List$isEmpty(items)) {
			return options.adJ ? _List_Nil : _List_fromArray(
				[
					A2(
					$author$project$Ui$NewDropdown$item,
					_List_Nil,
					$elm$html$Html$text('No results found'))
				]);
		} else {
			var _v0 = _Utils_Tuple2(options.Ch, totalItemsCount);
			if (_v0.a && (!_v0.b.$)) {
				var totalCount = _v0.b.a;
				var currentCount = $elm$core$List$length(items);
				return (_Utils_cmp(totalCount, currentCount) > 0) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect($author$project$Components$ResourceFilter$DropdownLoadedMore),
								$author$project$Ui$NewDropdown$onSelectKeepOpen
							]),
						A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'See more'},
									_List_fromArray(
										[$author$project$Ui$Button$link, $author$project$Ui$Button$preventFocus]),
									_List_fromArray(
										[
											$elm$html$Html$text('See '),
											$elm$html$Html$text(
											$elm$core$String$fromInt(options.rc)),
											$elm$html$Html$text(' more')
										])),
									$elm$html$Html$text(' or type to search')
								])))
					]) : _List_Nil;
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Ui$NewDropdown$Input = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$NewDropdown$input = $author$project$Ui$NewDropdown$Input;
var $author$project$Ui$NewDropdown$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$NewDropdown$invalid = $author$project$Ui$NewDropdown$Invalid;
var $author$project$Components$ResourceFilter$isChecked = F2(
	function (choice, item) {
		switch (choice.$) {
			case 0:
				var other = choice.a;
				return _Utils_eq(item, other);
			case 1:
				var items = choice.a;
				return A2($elm$core$List$member, item, items);
			default:
				return false;
		}
	});
var $author$project$Ui$NewDropdown$Item$OnCheck = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$NewDropdown$onCheck = $author$project$Ui$NewDropdown$Item$OnCheck;
var $author$project$Ui$NewDropdown$Item$OnInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$NewDropdown$onInput = $author$project$Ui$NewDropdown$Item$OnInput;
var $author$project$Components$ResourceFilter$Input = 0;
var $author$project$Components$ResourceFilter$defaultOptions = {
	abp: '',
	EB: _List_fromArray(
		['resource-filter']),
	dW: false,
	fE: _List_Nil,
	q$: false,
	S_: false,
	ze: false,
	s_: 0,
	aaN: $author$project$Components$ResourceFilter$All
};
var $author$project$Components$ResourceFilter$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var value_ = option.a;
						return _Utils_update(
							record,
							{aaN: value_});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{q$: bool});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{dW: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
					case 4:
						var style_ = option.a;
						return _Utils_update(
							record,
							{s_: style_});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{S_: bool});
					case 6:
						return _Utils_update(
							record,
							{ze: true});
					default:
						var label = option.a;
						return _Utils_update(
							record,
							{abp: label});
				}
			}),
		$author$project$Components$ResourceFilter$defaultOptions,
		options);
};
var $author$project$Ui$NewDropdown$Item$Placeholder = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$NewDropdown$placeholder = $author$project$Ui$NewDropdown$Item$Placeholder;
var $author$project$Ui$NewDropdown$Separator = {$: 1};
var $author$project$Ui$NewDropdown$separator = $author$project$Ui$NewDropdown$Separator;
var $author$project$Components$ResourceFilter$toggleItemSelection = F2(
	function (currentChoice, item) {
		switch (currentChoice.$) {
			case 0:
				var other = currentChoice.a;
				return _Utils_eq(other, item) ? $author$project$Components$ResourceFilter$All : $author$project$Components$ResourceFilter$Many(
					_List_fromArray(
						[other, item]));
			case 1:
				var items = currentChoice.a;
				if (A2($elm$core$List$member, item, items)) {
					var remainingItems = A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(item),
						items);
					if (!remainingItems.b) {
						return $author$project$Components$ResourceFilter$All;
					} else {
						if (!remainingItems.b.b) {
							var singleItem = remainingItems.a;
							return $author$project$Components$ResourceFilter$One(singleItem);
						} else {
							return $author$project$Components$ResourceFilter$Many(remainingItems);
						}
					}
				} else {
					return $author$project$Components$ResourceFilter$Many(
						A2($elm$core$List$cons, item, items));
				}
			case 3:
				return $author$project$Components$ResourceFilter$One(item);
			case 2:
				return $author$project$Components$ResourceFilter$One(item);
			case 4:
				return $author$project$Components$ResourceFilter$One(item);
			default:
				return $author$project$Components$ResourceFilter$One(item);
		}
	});
var $author$project$Ui$NewDropdown$Item$Value = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$NewDropdown$value = $author$project$Ui$NewDropdown$Item$Value;
var $author$project$Components$ResourceFilter$viewNew = F2(
	function (options, model) {
		var toLabel_ = function (choice) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('w-full')
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($elm$core$Basics$never),
					model.EA(choice)));
		};
		var optionsRecord = $author$project$Components$ResourceFilter$optionsToRecord(options);
		var items = function () {
			var _v0 = model.aZ;
			if (!_v0.$) {
				var list = _v0.a;
				var apiItemsValues = A2($elm$core$List$map, model.g0, list);
				return A2(
					$elm$core$List$cons,
					$author$project$Ui$NewDropdown$input(
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onInput($author$project$Components$ResourceFilter$DropdownSearched),
								$author$project$Ui$NewDropdown$value(
								A2($elm$core$Maybe$withDefault, '', model.af_)),
								model.zY.adB ? $author$project$Ui$NewDropdown$placeholder('Search or type your own...') : $author$project$Ui$NewDropdown$placeholder('Search...'),
								function () {
								if (model.zY.adB) {
									return $author$project$Ui$NewDropdown$onEnter(
										$author$project$Components$ResourceFilter$DropdownItemSelected(
											$elm$core$Maybe$Just(
												$author$project$Components$ResourceFilter$FreeText(
													A2($elm$core$Maybe$withDefault, '', model.af_)))));
								} else {
									if (list.b) {
										var x = list.a;
										return $author$project$Ui$NewDropdown$onEnter(
											$author$project$Components$ResourceFilter$DropdownItemSelected(
												$elm$core$Maybe$Just(
													$author$project$Components$ResourceFilter$One(x))));
									} else {
										return $author$project$Ui$NewDropdown$placeholder('Search...');
									}
								}
							}()
							])),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$NewDropdown$separator,
						_Utils_ap(
							function (allAndNone) {
								if (!allAndNone.b) {
									return _List_Nil;
								} else {
									return _Utils_ap(
										allAndNone,
										_List_fromArray(
											[$author$project$Ui$NewDropdown$separator]));
								}
							}(
								A2(
									$elm$core$List$map,
									function (_v2) {
										var label = _v2.a;
										var choice = _v2.b;
										return A2(
											$author$project$Ui$NewDropdown$item,
											_List_fromArray(
												[
													$author$project$Ui$NewDropdown$selected(
													_Utils_eq(optionsRecord.aaN, choice)),
													$author$project$Ui$NewDropdown$onSelect(
													$author$project$Components$ResourceFilter$DropdownItemSelected(
														$elm$core$Maybe$Just(choice)))
												]),
											$elm$html$Html$text(label));
									},
									A2(
										$elm$core$List$map,
										$elm$core$Tuple$second,
										A2(
											$elm$core$List$filter,
											$elm$core$Tuple$first,
											_List_fromArray(
												[
													_Utils_Tuple2(
													model.zY.IS,
													_Utils_Tuple2(model.zY.D0, $author$project$Components$ResourceFilter$All)),
													_Utils_Tuple2(
													model.zY.aeZ,
													_Utils_Tuple2(model.zY.UL, $author$project$Components$ResourceFilter$None))
												]))))),
							_Utils_ap(
								function () {
									var _v4 = optionsRecord.aaN;
									if (_v4.$ === 5) {
										var string = _v4.a;
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$NewDropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$NewDropdown$selected(
														_Utils_eq(
															optionsRecord.aaN,
															$author$project$Components$ResourceFilter$FreeText(string))),
														$author$project$Ui$NewDropdown$onSelect(
														$author$project$Components$ResourceFilter$DropdownItemSelected(
															$elm$core$Maybe$Just(
																$author$project$Components$ResourceFilter$FreeText(string))))
													]),
												$elm$html$Html$text(string))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								_Utils_ap(
									function () {
										var _v5 = _Utils_Tuple2(model.zY.adB, model.af_);
										_v5$2:
										while (true) {
											if (!_v5.b.$) {
												if (_v5.b.a === '') {
													return _List_Nil;
												} else {
													if (_v5.a) {
														var string = _v5.b.a;
														return _Utils_eq(
															optionsRecord.aaN,
															$author$project$Components$ResourceFilter$FreeText(string)) ? _List_Nil : _List_fromArray(
															[
																A2(
																$author$project$Ui$NewDropdown$item,
																_List_fromArray(
																	[
																		$author$project$Ui$NewDropdown$onSelect(
																		$author$project$Components$ResourceFilter$DropdownItemSelected(
																			$elm$core$Maybe$Just(
																				$author$project$Components$ResourceFilter$FreeText(string))))
																	]),
																$elm$html$Html$text('Select \"' + (string + '\"')))
															]);
													} else {
														break _v5$2;
													}
												}
											} else {
												break _v5$2;
											}
										}
										return _List_Nil;
									}(),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											function (item) {
												return optionsRecord.ze ? A2(
													$author$project$Ui$NewDropdown$checkbox,
													_List_fromArray(
														[
															$author$project$Ui$NewDropdown$checked(
															A2($author$project$Components$ResourceFilter$isChecked, optionsRecord.aaN, item)),
															$author$project$Ui$NewDropdown$onCheck(
															$elm$core$Basics$always(
																$author$project$Components$ResourceFilter$DropdownItemChecked(
																	A2($author$project$Components$ResourceFilter$toggleItemSelection, optionsRecord.aaN, item))))
														]),
													toLabel_(
														$author$project$Components$ResourceFilter$One(item))) : A2(
													$author$project$Ui$NewDropdown$item,
													_List_fromArray(
														[
															$author$project$Ui$NewDropdown$selected(
															_Utils_eq(
																optionsRecord.aaN,
																$author$project$Components$ResourceFilter$One(item))),
															$author$project$Ui$NewDropdown$onSelect(
															$author$project$Components$ResourceFilter$DropdownItemSelected(
																$elm$core$Maybe$Just(
																	$author$project$Components$ResourceFilter$One(item))))
														]),
													toLabel_(
														$author$project$Components$ResourceFilter$One(item)));
											},
											list),
										_Utils_ap(
											A2(
												$elm$core$List$map,
												function (item) {
													return A2(
														$author$project$Ui$NewDropdown$item,
														_List_fromArray(
															[
																$author$project$Ui$NewDropdown$selected(
																_Utils_eq(
																	optionsRecord.aaN,
																	$author$project$Components$ResourceFilter$Extra(item))),
																$author$project$Ui$NewDropdown$onSelect(
																$author$project$Components$ResourceFilter$DropdownItemSelected(
																	$elm$core$Maybe$Just(
																		$author$project$Components$ResourceFilter$Extra(item))))
															]),
														toLabel_(
															$author$project$Components$ResourceFilter$Extra(item)));
												},
												A2(
													$elm_community$list_extra$List$Extra$filterNot,
													function (extraItem) {
														return A2($elm$core$List$member, extraItem.aaN, apiItemsValues);
													},
													model.d$)),
											A3($author$project$Components$ResourceFilter$infoItem2, list, model.oO, model.zY))))))));
			} else {
				return _List_Nil;
			}
		}();
		var choiceToTitle_ = A5($author$project$Components$ResourceFilter$choiceToTitle, model.zY.D0, model.zY.UL, model.zY.adC, model.gx, model.ahA);
		return A4(
			$author$project$Ui$NewDropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$disabled(optionsRecord.dW),
					$author$project$Ui$NewDropdown$errors(optionsRecord.fE),
					$author$project$Ui$NewDropdown$invalid(optionsRecord.q$),
					$author$project$Ui$NewDropdown$ariaLabel(optionsRecord.abp)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					choiceToTitle_(optionsRecord.aaN))
				]),
			items,
			model.fy);
	});
var $author$project$Components$ResourceFilter$Category$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewCategoryInput = F2(
	function (categoryResourceFilter, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Category')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Category$viewNew,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(disabled)
							]),
						categoryResourceFilter))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$Code = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$CodeTypeSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewCodeInput = F4(
	function (fields, form, codeTypeDropdown, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Code')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.K3),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Code)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, 4, form)),
											$author$project$Ui$Form$Input$disabled(disabled)
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4)
								]),
							_List_fromArray(
								[
									function () {
									var items = A2(
										$elm$core$List$map,
										function (_v2) {
											var codeTypeId = _v2.a;
											var label = _v2.b;
											return A2(
												$author$project$Ui$NewDropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$NewDropdown$onSelect(
														$author$project$Components$Admin$ChargeItems$Form$CodeTypeSelected(
															$elm$core$Maybe$Just(codeTypeId))),
														$author$project$Ui$NewDropdown$selected(
														_Utils_eq(
															fields.K5,
															$elm$core$Maybe$Just(codeTypeId)))
													]),
												$elm$html$Html$text(label));
										},
										$author$project$Formatters$ChargeItemCode$codeTypes);
									var currentLabel = function () {
										var _v0 = fields.K5;
										if (!_v0.$) {
											var codeType = _v0.a;
											return A2(
												$elm$core$Maybe$withDefault,
												'Code Type',
												A2(
													$elm$core$Maybe$map,
													$elm$core$Tuple$second,
													$elm$core$List$head(
														A2(
															$elm$core$List$filter,
															function (_v1) {
																var id = _v1.a;
																return _Utils_eq(id, codeType);
															},
															$author$project$Formatters$ChargeItemCode$codeTypes))));
										} else {
											return 'Code Type';
										}
									}();
									return A4(
										$author$project$Ui$NewDropdown$viewSelect,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(currentLabel)
											]),
										items,
										codeTypeDropdown);
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$DaysSupply = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewDaysSupplyInput = F2(
	function (fields, disabled) {
		return $author$project$Utils$Uom$isTimeBased(fields.aam) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Days Supply')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$number,
											$author$project$Ui$Form$Input$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.MW))),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$DaysSupply)),
											$author$project$Ui$Form$Input$disabled(disabled)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$Description = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$Textarea$Disabled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$Textarea$disabled = $author$project$Ui$Form$Textarea$Disabled;
var $author$project$Ui$Form$Textarea$OnInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Textarea$onInput = $author$project$Ui$Form$Textarea$OnInput;
var $author$project$Ui$Form$Textarea$Placeholder = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Textarea$placeholder = $author$project$Ui$Form$Textarea$Placeholder;
var $author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput = F2(
	function (fields, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Description')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Textarea$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$value(
							A2($elm$core$Maybe$withDefault, '', fields.Nx)),
							$author$project$Ui$Form$Textarea$phi(true),
							$author$project$Ui$Form$Textarea$placeholder('Additional details for receipt'),
							$author$project$Ui$Form$Textarea$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Description)),
							$author$project$Ui$Form$Textarea$disabled(disabled)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Additional detail that will appear on both printed and emailed receipts (e.g. ICD-10 Codes)')
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$ExpirationNumber = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$ExpirationUnit = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$HasExpiration = function (a) {
	return {$: 22, a: a};
};
var $author$project$Ui$Form$Checkbox$Disabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Checkbox$disabled = $author$project$Ui$Form$Checkbox$Disabled;
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $author$project$Components$Admin$ChargeItems$Form$viewExpirationCheckbox = F3(
	function (fields, form, disable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Expiration')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(fields.b8),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$HasExpiration)),
							$author$project$Ui$Form$Checkbox$disabled(disable)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Set expiration date for this package')
						])),
					fields.b8 ? A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$margin(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Expires after '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
											A2($elm$html$Html$Attributes$style, 'width', '50px')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(fields.OW),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$ExpirationNumber)),
													$author$project$Ui$Form$Input$onBlur(
													$author$project$Components$Admin$ChargeItems$Form$FormUpdated(
														$author$project$Components$Admin$ChargeItems$Form$ExpirationNumber(
															((fields.OW === '') || (fields.OW === '0')) ? '1' : fields.OW))),
													$author$project$Ui$Form$Input$disabled(disable),
													$author$project$Ui$Form$Input$number,
													$author$project$Ui$Form$Input$customAttributes(
													_List_fromArray(
														[
															$elm$html$Html$Attributes$min('1')
														]))
												]))
										])),
									$elm$html$Html$text(' '),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
											A2($elm$html$Html$Attributes$style, 'width', '120px')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(fields.OX)),
													$author$project$Ui$Form$Select$onChange(
													function (unit) {
														return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
															$author$project$Components$Admin$ChargeItems$Form$ExpirationUnit(
																$elm$core$Maybe$Just(unit)));
													}),
													$author$project$Ui$Form$Select$disabled(disable)
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just('days'),
													'Days'),
													A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just('weeks'),
													'Weeks'),
													A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just('months'),
													'Months'),
													A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just('years'),
													'Years')
												]))
										])),
									$elm$html$Html$text(' from purchase date')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$helpBlock,
									$author$project$Ui$Typography$margin(21)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Package will expire for patients ' + (fields.OW + (' ' + (((fields.OW === '1') ? A2($elm$core$String$dropRight, 1, fields.OX) : fields.OX) + ' after the date of purchase.'))))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 6, form))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Ui$Form$File$Image = 0;
var $author$project$Components$Admin$ChargeItems$Form$ImageUploaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Form$File$Accept = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$File$accept = $author$project$Ui$Form$File$Accept;
var $author$project$Ui$Image$fromSrc = $author$project$Ui$Image$viewImg;
var $author$project$Ui$Form$File$OnInput = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$File$onInput = $author$project$Ui$Form$File$OnInput;
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $author$project$Ui$Form$File$acceptedToString = function (accepted) {
	switch (accepted) {
		case 1:
			return '.csv';
		case 0:
			return 'image/*';
		case 2:
			return 'application/pdf';
		case 3:
			return '.txt';
		case 4:
			return '.zip';
		default:
			return 'application/xml';
	}
};
var $elm$file$File$decoder = _File_decoder;
var $author$project$Ui$Form$File$filesDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'files']),
	$elm$json$Json$Decode$list($elm$file$File$decoder));
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $author$project$Ui$Form$File$defaultOptions = {
	HZ: _List_Nil,
	vx: _List_fromArray(
		[
			$elm$html$Html$Attributes$class('btn')
		]),
	xc: false,
	dW: false,
	xq: false,
	qW: false,
	yq: $elm$core$Maybe$Nothing,
	zf: false,
	afc: $elm$core$Maybe$Nothing
};
var $author$project$Ui$Form$File$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var bool = option.a;
						return _Utils_update(
							record,
							{dW: bool});
					case 1:
						var accepted = option.a;
						return _Utils_update(
							record,
							{
								HZ: A2($elm$core$List$cons, accepted, record.HZ)
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{zf: bool});
					case 3:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								afc: $elm$core$Maybe$Just(toMsg)
							});
					case 4:
						var bool = option.a;
						return _Utils_update(
							record,
							{xq: bool});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{xc: bool});
					case 6:
						return _Utils_update(
							record,
							{
								vx: _List_fromArray(
									[
										$elm$html$Html$Attributes$class('sr-only'),
										$elm$html$Html$Attributes$tabindex(-1)
									])
							});
					case 7:
						return _Utils_update(
							record,
							{qW: true});
					default:
						var k = option.a;
						return _Utils_update(
							record,
							{
								yq: $elm$core$Maybe$Just(k)
							});
				}
			}),
		$author$project$Ui$Form$File$defaultOptions,
		options);
};
var $author$project$Ui$Form$File$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$File$optionsToRecord(options);
	return function (input) {
		var _v1 = optionsRecord.yq;
		if (!_v1.$) {
			var k = _v1.a;
			return A3(
				$elm$html$Html$Keyed$node,
				'span',
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(k, input)
					]));
		} else {
			return input;
		}
	}(
		A2(
			$elm$html$Html$input,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$type_('file'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$disabled(optionsRecord.dW),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$multiple(optionsRecord.zf),
						_Utils_ap(
							optionsRecord.xc ? _List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$property,
									'webkitdirectory',
									$elm$json$Json$Encode$bool(true)),
									A2(
									$elm$html$Html$Attributes$property,
									'directory',
									$elm$json$Json$Encode$bool(true)),
									A2(
									$elm$html$Html$Attributes$property,
									'mozdirectory',
									$elm$json$Json$Encode$bool(true))
								]) : _List_Nil,
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$elm$html$Html$Attributes$map($elm$core$Basics$never),
									optionsRecord.vx),
								_Utils_ap(
									$elm$core$List$isEmpty(optionsRecord.HZ) ? _List_Nil : _List_fromArray(
										[
											$elm$html$Html$Attributes$accept(
											A2(
												$elm$core$String$join,
												',',
												A2($elm$core$List$map, $author$project$Ui$Form$File$acceptedToString, optionsRecord.HZ)))
										]),
									_Utils_ap(
										function () {
											var _v0 = optionsRecord.afc;
											if (!_v0.$) {
												var onInput_ = _v0.a;
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$Events$on,
														'change',
														A2($elm$json$Json$Decode$map, onInput_, $author$project$Ui$Form$File$filesDecoder))
													]);
											} else {
												return _List_Nil;
											}
										}(),
										optionsRecord.xq ? _List_fromArray(
											[
												$elm$html$Html$Attributes$value('')
											]) : _List_Nil))))))),
			_List_Nil));
};
var $author$project$Components$Admin$ChargeItems$Form$viewImageField = F2(
	function (errors, currentImageUrl) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Image')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Components$Admin$ChargeItems$Form$ImageUploaded)
						])),
					function () {
					if (!currentImageUrl.$) {
						if (currentImageUrl.a === '') {
							return $author$project$Utils$Html$empty;
						} else {
							var url = currentImageUrl.a;
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Image$fromSrc,
										{I1: 'Charge item image'},
										url,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(100)
											]))
									]));
						}
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$FormErrors$view(errors)
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$AddPackageItem = {$: 17};
var $author$project$Ui$Table$Colspan = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Table$colspan = $author$project$Ui$Table$Colspan;
var $author$project$Ui$Table$ContainerClasses = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Table$containerClasses = $author$project$Ui$Table$ContainerClasses;
var $author$project$Ui$Table$CellAlignment = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Table$textCenter = $author$project$Ui$Table$CellAlignment($author$project$Ui$Alignment$textCenter);
var $author$project$Ui$Table$textRight = $author$project$Ui$Table$CellAlignment($author$project$Ui$Alignment$textRight);
var $author$project$Ui$Icon$Failed = 19;
var $author$project$Components$Admin$ChargeItems$Form$RemovePackageItem = function (a) {
	return {$: 18, a: a};
};
var $author$project$Ui$Icon$Successful = 18;
var $author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemPrice = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Ui$Table$MinWidth = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Table$minWidth = $author$project$Ui$Table$MinWidth;
var $author$project$Ui$Form$CurrencyInput$Placeholder = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$CurrencyInput$placeholder = $author$project$Ui$Form$CurrencyInput$Placeholder;
var $author$project$Ui$Typography$Success = 2;
var $author$project$Ui$Typography$success = $author$project$Ui$Typography$Color(2);
var $author$project$Ui$Form$Input$text = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Text);
var $author$project$Components$ResourceFilter$activeStyleToClass = F2(
	function (style_, choice) {
		var _v0 = _Utils_Tuple2(style_, choice);
		if (!_v0.a) {
			var _v1 = _v0.a;
			return '';
		} else {
			if (_v0.b.$ === 2) {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return '';
			} else {
				var _v4 = _v0.a;
				return 'picker--active';
			}
		}
	});
var $author$project$Ui$Form$SearchableSelect$Class = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$SearchableSelect$class = $author$project$Ui$Form$SearchableSelect$Class;
var $author$project$Ui$Form$SearchableSelect$Item$Divider = {$: 0};
var $author$project$Ui$Form$SearchableSelect$Item$NonSelectable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$SearchableSelect$Item$divider = $author$project$Ui$Form$SearchableSelect$Item$NonSelectable($author$project$Ui$Form$SearchableSelect$Item$Divider);
var $author$project$Components$ResourceFilter$ifNothing = F3(
	function (maybeSth, skeleton, content) {
		return A2(
			$elm$core$Maybe$withDefault,
			skeleton,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(content),
				maybeSth));
	});
var $author$project$Ui$Form$SearchableSelect$Item$ReadOnly = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$SearchableSelect$Item$readOnly = A2($elm$core$Basics$composeL, $author$project$Ui$Form$SearchableSelect$Item$NonSelectable, $author$project$Ui$Form$SearchableSelect$Item$ReadOnly);
var $author$project$Ui$Form$SearchableSelect$Item$WithTrigger = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$Form$SearchableSelect$Item$withTrigger = $author$project$Ui$Form$SearchableSelect$Item$WithTrigger;
var $author$project$Components$ResourceFilter$infoItem = F4(
	function (loadingMore, items, totalItemsCount, options) {
		if ($elm$core$List$isEmpty(items)) {
			return options.adJ ? _List_Nil : _List_fromArray(
				[
					$author$project$Ui$Form$SearchableSelect$Item$readOnly(
					_List_fromArray(
						[
							$elm$html$Html$text('No results found')
						]))
				]);
		} else {
			var _v0 = _Utils_Tuple2(options.Ch, totalItemsCount);
			if (_v0.a && (!_v0.b.$)) {
				var totalCount = _v0.b.a;
				var currentCount = $elm$core$List$length(items);
				return (_Utils_cmp(totalCount, currentCount) > 0) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Form$SearchableSelect$Item$withTrigger,
						$author$project$Components$ResourceFilter$loadMoreTriggerId,
						_List_fromArray(
							[
								function () {
								var label = A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[
											'See',
											$elm$core$String$fromInt(options.rc),
											'more'
										]));
								return A3(
									$author$project$Ui$Button$view,
									{abp: label + ' or type to search'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$loading(loadingMore)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							}(),
								$elm$html$Html$text(' or type to search')
							]))
					]) : _List_Nil;
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$ResourceFilter$styleToClass = function (style_) {
	if (!style_) {
		return '';
	} else {
		return 'picker';
	}
};
var $author$project$Components$ResourceFilter$view = F2(
	function (options, model) {
		var placeholder = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						$elm$core$Tuple$first,
						_List_fromArray(
							[
								_Utils_Tuple2(model.zY.IS, model.zY.D0),
								_Utils_Tuple2(model.zY.aeZ, model.zY.UL)
							])))));
		var optionsRecord = $author$project$Components$ResourceFilter$optionsToRecord(options);
		var _v0 = function () {
			var _v1 = model.aZ;
			if (!_v1.$) {
				var list = _v1.a;
				var options_ = A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$SearchableSelect$value(
						$elm$core$Maybe$Just(optionsRecord.aaN)),
					(model.n9 || optionsRecord.S_) ? _List_fromArray(
						[
							$author$project$Ui$Form$SearchableSelect$loading(true)
						]) : _List_Nil);
				var formItems = A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$author$project$Ui$Form$SearchableSelect$Item$new,
							_List_Nil,
							$author$project$Components$ResourceFilter$One(item));
					},
					list);
				var apiItemsValues = A2($elm$core$List$map, model.g0, list);
				var extraItems_ = A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$author$project$Ui$Form$SearchableSelect$Item$new,
							_List_Nil,
							$author$project$Components$ResourceFilter$Extra(item));
					},
					A2(
						$elm_community$list_extra$List$Extra$filterNot,
						function (extraItem) {
							return A2($elm$core$List$member, extraItem.aaN, apiItemsValues);
						},
						model.d$));
				var freeTextItem = function () {
					var _v2 = _Utils_Tuple3(model.zY.adB, model.xJ, model.zY.adK);
					if ((_v2.a && (!_v2.b.$)) && (!_v2.c)) {
						var string = _v2.b.a;
						return _Utils_ap(
							$elm$core$List$isEmpty(
								_Utils_ap(formItems, extraItems_)) ? _List_Nil : _List_fromArray(
								[$author$project$Ui$Form$SearchableSelect$Item$divider]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$SearchableSelect$Item$new,
									_List_Nil,
									$author$project$Components$ResourceFilter$FreeText(string))
								]));
					} else {
						return _List_Nil;
					}
				}();
				var allAndNOneOptions = A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$filter,
						$elm$core$Tuple$first,
						_List_fromArray(
							[
								_Utils_Tuple2(model.zY.IS, $author$project$Components$ResourceFilter$All),
								_Utils_Tuple2(model.zY.aeZ, $author$project$Components$ResourceFilter$None)
							])));
				var allAndNOneItems = $elm$core$List$isEmpty(allAndNOneOptions) ? _List_Nil : _Utils_ap(
					A2(
						$elm$core$List$map,
						function (allOrNone) {
							return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, allOrNone);
						},
						allAndNOneOptions),
					_List_fromArray(
						[$author$project$Ui$Form$SearchableSelect$Item$divider]));
				return _Utils_Tuple2(
					options_,
					_Utils_ap(
						allAndNOneItems,
						_Utils_ap(
							formItems,
							_Utils_ap(
								extraItems_,
								_Utils_ap(
									freeTextItem,
									A4($author$project$Components$ResourceFilter$infoItem, model.i1, list, model.oO, model.zY))))));
			} else {
				return _Utils_Tuple2(
					_List_fromArray(
						[
							$author$project$Ui$Form$SearchableSelect$loading(true)
						]),
					_List_Nil);
			}
		}();
		var selectOptions = _v0.a;
		var items = _v0.b;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$ResourceFilter$SelectMsg,
			A3(
				$author$project$Components$ResourceFilter$ifNothing,
				model.aZ,
				$author$project$Ui$Skeleton$input(_List_Nil),
				A3(
					$author$project$Ui$Form$SearchableSelect$view,
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$SearchableSelect$placeholder(placeholder),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$SearchableSelect$invalid(optionsRecord.q$),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Form$SearchableSelect$disabled(optionsRecord.dW),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$SearchableSelect$errors(optionsRecord.fE),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$SearchableSelect$class(
											A2($elm$core$String$join, ' ', optionsRecord.EB)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$SearchableSelect$class(
												$author$project$Components$ResourceFilter$styleToClass(optionsRecord.s_)),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$SearchableSelect$class(
													A2($author$project$Components$ResourceFilter$activeStyleToClass, optionsRecord.s_, optionsRecord.aaN)),
												selectOptions))))))),
					items,
					model.sC)));
	});
var $author$project$Components$ResourceFilter$ChargeItem$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewPackageItemRow = F2(
	function (model, item) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = A2($elm$core$Dict$get, item.K, model.cf);
							if (!_v0.$) {
								var resourceFilter = _v0.a;
								var updatedResourceFilter = function () {
									var _v2 = _Utils_Tuple2(item.abX, item.abY);
									if ((!_v2.a.$) && (!_v2.b.$)) {
										var id = _v2.a.a;
										var name = _v2.b.a;
										return A2(
											$author$project$Components$ResourceFilter$ChargeItem$extraItems,
											_List_fromArray(
												[
													{adR: id, zh: name}
												]),
											resourceFilter);
									} else {
										return resourceFilter;
									}
								}();
								return A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(item.K),
									A2(
										$author$project$Components$ResourceFilter$ChargeItem$view,
										_List_fromArray(
											[
												$author$project$Components$ResourceFilter$value(
												function () {
													var _v1 = item.abX;
													if (!_v1.$) {
														var id = _v1.a;
														return $author$project$Components$ResourceFilter$Extra(
															{
																aej: A2($elm$core$Maybe$withDefault, '', item.abY),
																aaN: id
															});
													} else {
														return $author$project$Components$ResourceFilter$All;
													}
												}())
											]),
										updatedResourceFilter));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('6em')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$text,
									$author$project$Ui$Form$Input$value(
									(!item.Bd) ? '' : $elm$core$String$fromInt(item.Bd)),
									$author$project$Ui$Form$Input$onInput(
									function (val) {
										var qty = function () {
											if ($elm$core$String$isEmpty(val)) {
												return 0;
											} else {
												var _v3 = $elm$core$String$toInt(val);
												if (!_v3.$) {
													var n = _v3.a;
													return (n >= 0) ? n : item.Bd;
												} else {
													return item.Bd;
												}
											}
										}();
										return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
											A2($author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity, item.K, qty));
									}),
									$author$project$Ui$Form$Input$onBlur(
									$author$project$Components$Admin$ChargeItems$Form$FormUpdated(
										A2(
											$author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity,
											item.K,
											(!item.Bd) ? 1 : item.Bd))),
									$author$project$Ui$Form$Input$customAttributes(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$type_('number'),
											$elm$html$Html$Attributes$min('1')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$value(
													($author$project$Currency$toString(item.Ba) === '0') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(item.Ba)),
													$author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
													$author$project$Ui$Form$CurrencyInput$onInput(
													function (val) {
														return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(
															A2($author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemPrice, item.K, val));
													})
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											function () {
											var _v4 = _Utils_Tuple2(
												item.abX,
												A2($elm$core$Dict$get, item.K, model.bv));
											if ((!_v4.a.$) && (!_v4.b.$)) {
												var originalPrice = _v4.b.a;
												return (!_Utils_eq(originalPrice, item.Ba)) ? A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[
															$author$project$Ui$Typography$strike,
															$author$project$Ui$Typography$muted,
															$author$project$Ui$Typography$margin(20)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Currency$format(originalPrice))
														])) : $elm$html$Html$text('');
											} else {
												return $elm$html$Html$text('');
											}
										}()
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textCenter]),
					_List_fromArray(
						[
							function () {
							var _v5 = item.ab_;
							if (!_v5.$) {
								if (_v5.a) {
									return A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$success]),
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 18)
											]));
								} else {
									return A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$danger]),
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 19)
											]));
								}
							} else {
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$danger]),
									_List_fromArray(
										[
											A2($author$project$Ui$Icon$view, _List_Nil, 19)
										]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Remove item from package'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Admin$ChargeItems$Form$FormUpdated(
										$author$project$Components$Admin$ChargeItems$Form$RemovePackageItem(item.K))),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewIncludesTable = F3(
	function (model, fields, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Includes')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Table$view,
							_List_fromArray(
								[
									$author$project$Ui$Table$containerClasses(
									_List_fromArray(
										['table-wrapper', 'bg-white']))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Charge Item')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Quantity')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Price per Item')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_fromArray(
										[$author$project$Ui$Table$textCenter]),
									_List_fromArray(
										[
											$elm$html$Html$text('Taxable')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_fromArray(
										[$author$project$Ui$Table$textRight]),
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								]),
							$elm$core$List$isEmpty(fields.Vr) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$cell,
											_List_fromArray(
												[
													$author$project$Ui$Table$colspan(5),
													$author$project$Ui$Table$textCenter
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$p,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text('No items added to this package yet.')
														]))
												]))
										]))
								]) : A2(
								$elm$core$List$map,
								$author$project$Components$Admin$ChargeItems$Form$viewPackageItemRow(model),
								fields.Vr),
							_List_Nil),
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$margin(18)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add item to package'},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$AddPackageItem)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add to Package')
										]))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 5, form))
				]));
	});
var $author$project$Api$FeatureGate$InventoryAndSalesTax = 2;
var $author$project$Components$Admin$ChargeItems$Form$TrackInventory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Employer$Practice$One$featureGates = function (_v0) {
	var record = _v0;
	return record.Pb;
};
var $author$project$Api$Provider$Practice$One$featureGates = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Pb;
	});
var $author$project$Api$Practice$featureGates = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$featureGates(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$featureGates(practice_);
	}
};
var $author$project$Api$FeatureGate$codeToString = function (code_) {
	switch (code_) {
		case 0:
			return 'multiple_signup_pages';
		case 1:
			return 'charge_uploader';
		case 2:
			return 'inventory_and_sales_tax';
		case 3:
			return 'sponsor_adhoc_invoices';
		case 4:
			return 'patient_credits';
		case 5:
			return 'patient_portal';
		case 6:
			return 'membership_pricing_schedule_plan_changes';
		case 7:
			return 'membership_pricing_advance_pricing_rules';
		case 8:
			return 'employee_uploads';
		case 9:
			return 'manage_employers';
		case 10:
			return 'customize_dunning_schedule';
		case 11:
			return 'engagement_tracking';
		case 12:
			return 'scheduled_partial_payments';
		default:
			return 'multiple_retail_memberships';
	}
};
var $author$project$Api$Common$FeatureGate$Shared$hasCode = F2(
	function (one, _v0) {
		var code = _v0.K3;
		return _Utils_eq(
			$author$project$Api$FeatureGate$codeToString(one),
			code);
	});
var $author$project$Utils$FeatureGate$findByCode = F2(
	function (code_, list) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (featureGate) {
				return A2($author$project$Api$Common$FeatureGate$Shared$hasCode, code_, featureGate);
			},
			list);
	});
var $author$project$Utils$FeatureGate$customGate = F3(
	function (code, practice, gated) {
		var _v0 = A2(
			$author$project$Utils$FeatureGate$findByCode,
			code,
			$author$project$Api$Practice$featureGates(practice));
		if (!_v0.$) {
			return $elm$core$Maybe$Just(gated);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Utils$FeatureGate$gate = F3(
	function (code, practice, htmlMsg) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A3($author$project$Utils$FeatureGate$customGate, code, practice, htmlMsg));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewInventoryCheckbox = F3(
	function (fields, practice, disabled) {
		return A3(
			$author$project$Utils$FeatureGate$gate,
			2,
			$author$project$Api$Practice$Provider(practice),
			A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Inventory')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(fields.$_),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$TrackInventory)),
								$author$project$Ui$Form$Checkbox$disabled(
								$author$project$Utils$Uom$isTimeBased(fields.aam) || disabled)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Track inventory for this item')
							])),
						$author$project$Utils$Uom$isTimeBased(fields.aam) ? A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$info]),
						_List_fromArray(
							[
								$elm$html$Html$text('Inventory tracking is not available for time based charge items.')
							])) : $author$project$Utils$Html$empty
					])));
	});
var $author$project$Components$Admin$ChargeItems$Form$EditQuantity = {$: 11};
var $author$project$Components$Admin$ChargeItems$Form$LastSetQuantity = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewInventoryInput = F3(
	function (fields, form, disabled) {
		return fields.$_ ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Current inventory')
				]),
			_List_fromArray(
				[
					fields.iv ? $author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$number,
							$author$project$Ui$Form$Input$value(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.SE))),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$LastSetQuantity)),
							$author$project$Ui$Form$Input$placeholder('37'),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 3, form)),
							$author$project$Ui$Form$Input$disabled(disabled)
						])) : A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_Utils_ap(
						function () {
							var _v0 = _Utils_Tuple2(fields.Xv, fields.SE);
							if ((!_v0.a.$) && (!_v0.b.$)) {
								var quantityInStock = _v0.a.a;
								var lastSetQuantity = _v0.b.a;
								return _List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(quantityInStock)),
										$elm$html$Html$text('/'),
										$elm$html$Html$text(
										$elm$core$String$fromInt(lastSetQuantity))
									]);
							} else {
								return _List_fromArray(
									[
										$elm$html$Html$text('N/A')
									]);
							}
						}(),
						_List_fromArray(
							[
								$author$project$Utils$Html$noBreakSpace,
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Edit charge item'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$EditQuantity))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							])))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$ChargeItems$Form$AlertQuantity = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewInventoryShowWarningInput = F2(
	function (fields, disabled) {
		return fields.$_ ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Show a warning if the quantity in inventory is below')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$number,
							$author$project$Ui$Form$Input$value(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.IN))),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$AlertQuantity)),
							$author$project$Ui$Form$Input$placeholder('10'),
							$author$project$Ui$Form$Input$disabled(disabled)
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$ChargeItems$Form$Manufacturer = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewManufacturerInput = F2(
	function (fields, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Facility / Manufacturer')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.Tg),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Manufacturer)),
							$author$project$Ui$Form$Input$disabled(disabled)
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewNameInput = F3(
	function (fields, form, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Name')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.zh),
							$author$project$Ui$Form$Input$placeholder(
							(fields.q9 === 1) ? 'Package Name' : '800mg Ibuprofen'),
							$author$project$Ui$Form$Input$autofocus(true),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Name)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form)),
							$author$project$Ui$Form$Input$disabled(disabled)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('What is being charged for on the invoice or receipt.')
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$ApplyPackagePriceAdjustment = {$: 3};
var $author$project$Components$Admin$ChargeItems$Form$PriceInCents = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Padding$Top_1 = 6;
var $author$project$Ui$Form$CurrencyInput$OnBlur = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$CurrencyInput$onBlur = $author$project$Ui$Form$CurrencyInput$OnBlur;
var $author$project$Ui$Typography$Padding = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Typography$padding = $author$project$Ui$Typography$Padding;
var $author$project$Ui$Form$CurrencyInput$Postfix = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$CurrencyInput$postfix = $author$project$Ui$Form$CurrencyInput$Postfix;
var $author$project$Api$Provider$Uom$Shared$periodQuantity = function (_v0) {
	var record = _v0;
	return record.gk;
};
var $author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity = function (code) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$Uom$Shared$periodQuantity,
		$author$project$Utils$Uom$fromCode(code));
};
var $author$project$Api$Provider$Uom$Shared$periodUnit = function (_v0) {
	var record = _v0;
	return record.gl;
};
var $author$project$Api$Provider$Uom$PeriodUnit$toString = function (periodUnit_) {
	switch (periodUnit_) {
		case 0:
			return 'days';
		case 1:
			return 'months';
		case 2:
			return 'quarters';
		case 3:
			return 'half_years';
		default:
			return 'years';
	}
};
var $author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit = function (code) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Uom$PeriodUnit$toString,
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Provider$Uom$Shared$periodUnit,
			$author$project$Utils$Uom$fromCode(code)));
};
var $author$project$Components$Admin$ChargeItems$Form$viewPackagePriceInput = F2(
	function (fields, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Package Price')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$CurrencyInput$value(fields.Ba),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$CurrencyInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$PriceInCents)),
												A2(
													$elm$core$List$cons,
													$author$project$Ui$Form$CurrencyInput$onBlur(
														$author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$ApplyPackagePriceAdjustment)),
													A2(
														$elm$core$List$cons,
														$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
														function () {
															var _v0 = _Utils_Tuple3(
																$author$project$Utils$Uom$isTimeBased(fields.aam),
																$author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit(fields.aam),
																$author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity(fields.aam));
															if ((_v0.a && (!_v0.b.$)) && (!_v0.c.$)) {
																var periodUnit = _v0.b.a;
																var periodQuantity = _v0.c.a;
																return _List_fromArray(
																	[
																		$author$project$Ui$Form$CurrencyInput$postfix(
																		'per ' + A2($author$project$Formatters$String$pluralize, periodUnit, periodQuantity))
																	]);
															} else {
																return _List_Nil;
															}
														}()))))))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(6)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('+ tax')
										]))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 2, form))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$Taxable = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewPriceInput = F4(
	function (fields, form, practice, disabled) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Price')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(9)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$CurrencyInput$value(
											A2(
												$elm$core$Maybe$andThen,
												function (price) {
													return ($author$project$Currency$toString(price) === '0') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(price);
												},
												fields.Ba)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$CurrencyInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$PriceInCents)),
												A2(
													$elm$core$List$cons,
													$author$project$Ui$Form$CurrencyInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
													function () {
														var _v0 = _Utils_Tuple3(
															$author$project$Utils$Uom$isTimeBased(fields.aam),
															$author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit(fields.aam),
															$author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity(fields.aam));
														if ((_v0.a && (!_v0.b.$)) && (!_v0.c.$)) {
															var periodUnit = _v0.b.a;
															var periodQuantity = _v0.c.a;
															return _List_fromArray(
																[
																	$author$project$Ui$Form$CurrencyInput$postfix(
																	'per ' + A2($author$project$Formatters$String$pluralize, periodUnit, periodQuantity))
																]);
														} else {
															return _List_Nil;
														}
													}()))))),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 2, form)),
									fields.$u ? A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Taxes will be added '),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$italic]),
											_List_fromArray(
												[
													$elm$html$Html$text('on top of ')
												])),
											$elm$html$Html$text('this price, at invoice-time.')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Utils$FeatureGate$gate,
									2,
									$author$project$Api$Practice$Provider(practice),
									A2(
										$author$project$Ui$Form$Checkbox$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Checkbox$value(fields.$u),
												$author$project$Ui$Form$Checkbox$onCheck(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Taxable)),
												$author$project$Ui$Form$Checkbox$disabled(disabled)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Taxable')
											])))
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Do your members receive a discount for this product or service? '),
							A3(
							$author$project$Ui$Link$externalHref,
							'https://support.hint.com/en/articles/5921503-configuring-coverage-plans',
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('Configure a coverage rule')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$ItemType = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Admin$ChargeItems$Form$viewTypeToggle = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Type')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$ButtonSelect$view(
				{
					ae4: A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$ItemType),
					zY: _List_fromArray(
						[
							A2($author$project$Ui$Form$ButtonSelect$option, 0, 'Item'),
							A2($author$project$Ui$Form$ButtonSelect$option, 1, 'Package')
						]),
					aaN: fields.q9
				})
			]));
};
var $author$project$Components$Admin$ChargeItems$Form$Uom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$ChargeItem$Meta$uomEditable = function (_v0) {
	var meta = _v0;
	return meta.aam.Oa;
};
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				if (!scattered.b) {
					return $elm$core$List$reverse(gathered);
				} else {
					var toGather = scattered.a;
					var population = scattered.b;
					var _v1 = A2(
						$elm$core$List$partition,
						testFn(toGather),
						population);
					var gathering = _v1.a;
					var remaining = _v1.b;
					return A2(
						helper,
						remaining,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered));
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $author$project$Ui$Form$Select$Group = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Form$Select$group = $author$project$Ui$Form$Select$Group;
var $author$project$Api$Provider$Uom$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Components$Admin$ChargeItems$Form$uomGroupOptions = function (uoms) {
	return A2(
		$elm$core$List$map,
		function (uom_) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$author$project$Api$Provider$Uom$Shared$code(uom_)),
				$author$project$Api$Provider$Uom$Shared$name(uom_));
		},
		uoms);
};
var $author$project$Components$Admin$ChargeItems$Form$uomOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var uom = _v0.a;
		var uoms = _v0.b;
		return A2(
			$author$project$Ui$Form$Select$group,
			$author$project$Api$Provider$Uom$Shared$type_(uom),
			$author$project$Components$Admin$ChargeItems$Form$uomGroupOptions(
				A2($elm$core$List$cons, uom, uoms)));
	},
	A2(
		$elm_community$list_extra$List$Extra$gatherEqualsBy,
		$author$project$Api$Provider$Uom$Shared$type_,
		$author$project$Api$Provider$Uom$list($elm$core$Basics$identity)));
var $author$project$Components$Admin$ChargeItems$Form$viewUnitOfMeasureSelect = F3(
	function (fields, form, disabled) {
		var uomEditable = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Meta$uomEditable, fields.TU));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Unit of Measure')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(
							$elm$core$Maybe$Just(fields.aam)),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Uom)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form)),
							$author$project$Ui$Form$Select$disabled((!uomEditable) || disabled)
						]),
					$author$project$Components$Admin$ChargeItems$Form$uomOptions),
					uomEditable ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$info]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cannot be edited while this charge is recurring on memberships.')
						]))
				]));
	});
var $author$project$Components$Admin$ChargeItems$Form$viewForm = F2(
	function (model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var typeToggle = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.WF) ? _List_fromArray(
			[
				$author$project$Components$Admin$ChargeItems$Form$viewTypeToggle(fields)
			]) : _List_Nil;
		var disable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.WF) && model.yi;
		if (fields.q9 === 1) {
			var buyableEditable = function () {
				var _v0 = fields.TU;
				if (!_v0.$) {
					var meta = _v0.a;
					return $author$project$Api$Provider$ChargeItem$Meta$buyableEditable(meta);
				} else {
					return A2($author$project$Api$Provider$Practice$One$featureEnabled, 23, model.WF);
				}
			}();
			return $elm$core$List$concat(
				_List_fromArray(
					[
						typeToggle,
						A2(
						$elm$core$List$cons,
						A3($author$project$Components$Admin$ChargeItems$Form$viewNameInput, fields, form, disable),
						_Utils_ap(
							buyableEditable ? _List_fromArray(
								[
									A2(
									$author$project$Components$Admin$ChargeItems$Form$viewImageField,
									A2($author$project$Utils$Form$validationErrors, 7, form),
									fields.p4),
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg,
									A2(
										$author$project$Components$TranslatedRichText$view,
										{acT: 'charge-item-rich-description-editor', aej: 'Rich Description', ae0: false},
										fields.ez))
								]) : _List_Nil,
							_List_fromArray(
								[
									A3($author$project$Components$Admin$ChargeItems$Form$viewIncludesTable, model, fields, form),
									A2($author$project$Components$Admin$ChargeItems$Form$viewPackagePriceInput, fields, form),
									A3($author$project$Components$Admin$ChargeItems$Form$viewExpirationCheckbox, fields, form, disable),
									A2($author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput, fields, disable),
									A2($author$project$Components$Admin$ChargeItems$Form$viewCategoryInput, model.cJ, disable),
									buyableEditable ? A2($author$project$Components$Admin$ChargeItems$Form$viewBuyableCheckbox, fields, disable) : $author$project$Utils$Html$empty,
									$author$project$Components$Admin$ChargeItems$Form$viewAdvancedSettings(fields)
								])))
					]));
		} else {
			return $elm$core$List$concat(
				_List_fromArray(
					[
						typeToggle,
						_List_fromArray(
						[
							A3($author$project$Components$Admin$ChargeItems$Form$viewNameInput, fields, form, disable),
							A3($author$project$Components$Admin$ChargeItems$Form$viewUnitOfMeasureSelect, fields, form, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewDaysSupplyInput, fields, disable),
							A4($author$project$Components$Admin$ChargeItems$Form$viewPriceInput, fields, form, model.WF, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewCategoryInput, model.cJ, disable),
							A3($author$project$Components$Admin$ChargeItems$Form$viewInventoryCheckbox, fields, model.WF, disable),
							A3($author$project$Components$Admin$ChargeItems$Form$viewInventoryInput, fields, form, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewInventoryShowWarningInput, fields, disable),
							A4($author$project$Components$Admin$ChargeItems$Form$viewCodeInput, fields, form, model.lt, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewManufacturerInput, fields, disable),
							A2($author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput, fields, disable)
						])
					]));
		}
	});
var $author$project$Components$Admin$ChargeItems$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										function () {
										var _v1 = model.adR;
										if (!_v1.$) {
											return $elm$html$Html$text('Edit');
										} else {
											return $elm$html$Html$text('New Item');
										}
									}()
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$pull(1)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Delete charge item'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$BackButtonClicked),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$cross)
													]),
												_List_Nil)
											]))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										function () {
										var _v2 = model.adR;
										if (!_v2.$) {
											return $elm$html$Html$text('Any changes will affect current recurring charges and future created charges.');
										} else {
											return $elm$html$Html$text('Create a new charge item that can be selected from a saved menu.');
										}
									}()
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v3 = model.PB;
							if (!_v3.$) {
								var form = _v3.a;
								return A2($author$project$Components$Admin$ChargeItems$Form$viewForm, model, form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Go back'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$BackButtonClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									])),
								function () {
								var verb = function () {
									var _v4 = model.adR;
									if (!_v4.$) {
										return 'Update';
									} else {
										return 'Create';
									}
								}();
								return A3(
									$author$project$Ui$Button$view,
									{abp: verb + ' Charge'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$loading(
											_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
											$author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$Save)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(verb)
										]));
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$ChargeItems$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$ChargeItems$Form$view(model.PB))
			]),
		$G: 'Admin | Charge Items'
	};
};
var $author$project$Pages$Admin$ChargeItems$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$ChargeItems$Id_String$init, aer: $author$project$Pages$Admin$ChargeItems$Id_String$load, agD: $author$project$Pages$Admin$ChargeItems$Id_String$save, ahd: $author$project$Pages$Admin$ChargeItems$Id_String$subscriptions, aaq: $author$project$Pages$Admin$ChargeItems$Id_String$update, ahP: $author$project$Pages$Admin$ChargeItems$Id_String$view});
var $author$project$Pages$Admin$ChargeItems$New$ChargeItemFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$ChargeItems$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var _v2 = A4($author$project$Components$Admin$ChargeItems$Form$init, apiClient, session, $elm$core$Maybe$Nothing, practice);
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$ChargeItems$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ChargeItems$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ChargeItems$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$ChargeItems$Form$subscriptions(model.PB));
};
var $author$project$Pages$Admin$ChargeItems$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$ChargeItems$Form$update, model.D5, subMsg, model.PB);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$ChargeItems$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$ChargeItems$Form$view(model.PB))
			]),
		$G: 'Admin | Charge Items'
	};
};
var $author$project$Pages$Admin$ChargeItems$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$ChargeItems$New$init, aer: $author$project$Pages$Admin$ChargeItems$New$load, agD: $author$project$Pages$Admin$ChargeItems$New$save, ahd: $author$project$Pages$Admin$ChargeItems$New$subscriptions, aaq: $author$project$Pages$Admin$ChargeItems$New$update, ahP: $author$project$Pages$Admin$ChargeItems$New$view});
var $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$InventoryDropdownMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$ItemTypeDropdownMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$GotChargeItems = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString = function (status) {
	switch (status) {
		case 0:
			return 'in_stock';
		case 1:
			return 'low_inventory';
		default:
			return 'out_of_stock';
	}
};
var $author$project$Pages$Admin$ChargeItems$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Ex: model.fa,
				FI: A2($elm$core$Maybe$map, $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString, model.FI),
				q9: A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString, model.q9),
				afy: model.afy,
				af_: model.af_,
				ag1: model.ag1
			});
	};
};
var $author$project$Pages$Admin$ChargeItems$Top$fetchItems = function (model) {
	return A3(
		$author$project$Api$Provider$ChargeItem$list,
		model.D5,
		$author$project$Pages$Admin$ChargeItems$Top$fetchParams(model),
		$author$project$Pages$Admin$ChargeItems$Top$GotChargeItems);
};
var $author$project$Ui$SearchInput$Model = $elm$core$Basics$identity;
var $author$project$Ui$SearchInput$init = function (text) {
	return {dE: $jinjor$elm_debounce$Debounce$init, $A: text};
};
var $author$project$Utils$Report$CategoryResourceFilter$init = F3(
	function (apiClient, session, categoryId) {
		return A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Categories', UL: 'Unassigned', aeZ: true, afT: categoryId});
			});
	});
var $author$project$Api$Column$Column = $elm$core$Basics$identity;
var $author$project$Api$Column$init = F3(
	function (id, sortable, name) {
		return {adR: id, zh: name, zY: _List_Nil, Hf: sortable};
	});
var $author$project$Pages$Admin$ChargeItems$Top$initColumns = function (practice) {
	var taxableColumn = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A3(
			$author$project$Utils$FeatureGate$customGate,
			2,
			$author$project$Api$Practice$Provider(practice),
			_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'taxable', false, 'Taxable')
				])));
	var itemTypeColumn = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? _List_fromArray(
		[
			A3($author$project$Api$Column$init, 'item_type', true, 'Item Type')
		]) : _List_Nil;
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'name', true, 'Name'),
					A3($author$project$Api$Column$init, 'price_in_cents', true, 'Price'),
					A3($author$project$Api$Column$init, 'category', true, 'Category')
				]),
				itemTypeColumn,
				taxableColumn
			]));
};
var $author$project$Api$Pagination$pageParamName = function (prefix) {
	return prefix + 'page';
};
var $author$project$Api$Pagination$fromQuery = F2(
	function (query, _v0) {
		var model = _v0;
		var currentPage = A2(
			$elm$core$Maybe$withDefault,
			1,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2(
					$elm$core$Dict$get,
					$author$project$Api$Pagination$pageParamName(model.A7),
					query)));
		return _Utils_update(
			model,
			{bV: currentPage});
	});
var $author$project$Api$Pagination$initFromQuery = function (query) {
	return A2($author$project$Api$Pagination$fromQuery, query, $author$project$Api$Pagination$init);
};
var $author$project$Api$Sort$Asc = 0;
var $author$project$Api$Sort$Desc = 1;
var $author$project$Api$Sort$fromQuery = F2(
	function (query, _v0) {
		var model = _v0;
		var _v1 = A2(
			$elm$core$Dict$get,
			$author$project$Api$Sort$pageParamName(model.A7),
			query);
		if (!_v1.$) {
			var sort = _v1.a;
			var direction = A2($elm$core$String$startsWith, '-', sort) ? 1 : 0;
			return _Utils_update(
				model,
				{
					M5: $elm$core$Maybe$Nothing,
					aaN: $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A3($elm$core$String$replace, '-', '', sort),
							direction))
				});
		} else {
			return model;
		}
	});
var $author$project$Api$Sort$initFromQuery = function (query) {
	return A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init);
};
var $author$project$Pages$Admin$ChargeItems$Top$stringToItemType = function (str) {
	switch (str) {
		case 'item':
			return $elm$core$Maybe$Just(0);
		case 'package':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$ChargeItems$Top$InStock = 0;
var $author$project$Pages$Admin$ChargeItems$Top$LowInventory = 1;
var $author$project$Pages$Admin$ChargeItems$Top$OutOfStock = 2;
var $author$project$Pages$Admin$ChargeItems$Top$stringToStockStatus = function (str) {
	switch (str) {
		case 'in_stock':
			return $elm$core$Maybe$Just(0);
		case 'low_inventory':
			return $elm$core$Maybe$Just(1);
		case 'out_of_stock':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Api$Pagination$toPageQuery = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			A2(
			$elm$url$Url$Builder$int,
			$author$project$Api$Pagination$pageParamName(model.A7),
			model.bV)
		]);
};
var $author$project$Api$Sort$toQuery = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$List$concatMap,
		$author$project$Api$Param$toQuery,
		A2($author$project$Api$Sort$toPrefixeddParams, model.A7, model));
};
var $author$project$Pages$Admin$ChargeItems$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('category'),
			model.fa),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('inventory'),
			A2($elm$core$Maybe$map, $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString, model.FI)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('item_type'),
			A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString, model.q9))
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__ChargeItems__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$ChargeItems$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var categoryId = A2($elm$core$Dict$get, 'category', query);
		var apiClient = shared.D5;
		var _v1 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
		var categoryResourceFilter = _v1.a;
		var categoryResourceFilterCmd = _v1.b;
		var model = {
			D5: apiClient,
			fa: categoryId,
			cJ: categoryResourceFilter,
			bm: $author$project$Api$Data$Loading,
			Ll: $author$project$Pages$Admin$ChargeItems$Top$initColumns(practice),
			ia: $elm$core$Maybe$Nothing,
			dJ: $elm$core$Set$empty,
			acZ: shared.adu.acZ,
			FI: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Admin$ChargeItems$Top$stringToStockStatus,
				A2($elm$core$Dict$get, 'inventory', query)),
			mx: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'inventory-dropdown-filter', ahx: $author$project$Pages$Admin$ChargeItems$Top$InventoryDropdownMsg})),
			FR: $author$project$Shared$isHintAdmin(shared),
			q9: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Admin$ChargeItems$Top$stringToItemType,
				A2($elm$core$Dict$get, 'item_type', query)),
			mL: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'item-type-dropdown-filter', ahx: $author$project$Pages$Admin$ChargeItems$Top$ItemTypeDropdownMsg})),
			afw: shared.adu.afw,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: $author$project$Api$Sort$initFromQuery(query),
			Hy: shared.Hy
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						$author$project$Pages$Admin$ChargeItems$Top$fetchItems(model),
						$author$project$Pages$Admin$ChargeItems$Top$updateUrl(model)
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ChargeItems$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$ChargeItems$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed),
						$author$project$Api$Provider$ChargeItem$All$id),
					model.ia)),
				$author$project$Ui$NewDropdown$subscriptions(model.mx),
				$author$project$Ui$NewDropdown$subscriptions(model.mL),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.cJ))
			]));
};
var $author$project$Pages$Admin$ChargeItems$Top$Deleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$ChargeItem$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ChargeItem$chargeItemPath(id_)));
	});
var $author$project$Api$Sort$update = F2(
	function (column, _v0) {
		var model = _v0;
		var _v1 = function () {
			var _v2 = $author$project$Api$Sort$valueOrDefault(model);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var currentColumn = _v3.a;
				var currentDirection = _v3.b;
				return _Utils_eq(currentColumn, column) ? ((currentDirection === 1) ? _Utils_Tuple2(column, 0) : _Utils_Tuple2(column, 1)) : _Utils_Tuple2(column, 0);
			} else {
				return _Utils_Tuple2(column, 0);
			}
		}();
		var newColumn = _v1.a;
		var newDirection = _v1.b;
		return _Utils_update(
			model,
			{
				aaN: $elm$core$Maybe$Just(
					_Utils_Tuple2(newColumn, newDirection))
			});
	});
var $author$project$Components$FileLink$GotFile = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$file$File$Download$bytes = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(
				_File_download,
				name,
				mime,
				_File_makeBytesSafeForInternetExplorer(content)));
	});
var $author$project$Api$Data$formatToMimeType = function (format) {
	return 'text/csv';
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Api$Data$handleBytesResponse = function (response) {
	if (response.$ === 4) {
		var metadata = response.a;
		var body = response.b;
		return $elm$core$Result$Ok(
			_Utils_Tuple2(body, metadata.iJ));
	} else {
		return $elm$core$Result$Err($author$project$Api$Data$BadUrl);
	}
};
var $author$project$Api$Data$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		A2($elm$core$Basics$composeR, $author$project$Api$Data$fromResult, toMsg),
		$author$project$Api$Data$handleBytesResponse);
};
var $author$project$Api$Data$getFile = F3(
	function (client, url, toMsg) {
		return $elm$http$Http$request(
			{
				e5: $elm$http$Http$emptyBody,
				OT: $author$project$Api$Data$expectString(toMsg),
				iJ: $author$project$Api$Data$clientHeaders(client),
				F6: $elm$core$String$toUpper('get'),
				HA: $elm$core$Maybe$Just(61 * 1000),
				tn: $elm$core$Maybe$Nothing,
				aav: url
			});
	});
var $author$project$Api$Data$getFileNameFromHeaders = function (headers) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$String$replace, '\"', ''),
		A2(
			$elm$core$Maybe$andThen,
			$elm$core$List$head,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$tail,
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$split(' filename='),
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$List$head,
						A2(
							$elm$core$Maybe$map,
							$elm$core$String$split('; filename*'),
							A2($elm$core$Dict$get, 'content-disposition', headers)))))));
};
var $author$project$Components$FileLink$update = function (msg) {
	if (!msg.$) {
		var client = msg.a;
		var url = msg.b;
		var format = msg.c;
		var fetchFile = A3(
			$author$project$Api$Data$getFile,
			client,
			url,
			$author$project$Components$FileLink$GotFile(format));
		return _Utils_Tuple2(fetchFile, _List_Nil);
	} else {
		var format = msg.a;
		var response = msg.b;
		if (response.$ === 3) {
			var file = response.a;
			var headers = response.b;
			var fileName = A2(
				$elm$core$Maybe$withDefault,
				'export.' + $author$project$Api$Data$formatToString(format),
				$author$project$Api$Data$getFileNameFromHeaders(headers));
			return _Utils_Tuple2(
				A3(
					$elm$file$File$Download$bytes,
					fileName,
					$author$project$Api$Data$formatToMimeType(format),
					file),
				_List_Nil);
		} else {
			return _Utils_Tuple2(
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	}
};
var $author$project$Ui$SearchInput$None = {$: 0};
var $author$project$Ui$SearchInput$SearchChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SearchInput$DebouncedMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SearchInput$debounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(300),
	ahG: $author$project$Ui$SearchInput$DebouncedMsg
};
var $author$project$Ui$SearchInput$TextDebounced = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$SearchInput$debounceText = function (text) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Ui$SearchInput$TextDebounced,
		$elm$core$Task$succeed(text));
};
var $author$project$Ui$SearchInput$emitSearchChanged = function (text) {
	return $author$project$Ui$SearchInput$SearchChanged(
		$author$project$Utils$String$toMaybe(text));
};
var $author$project$Ui$SearchInput$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var isImmediate = msg.a;
				var text = msg.b;
				if (isImmediate) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$A: $author$project$Utils$String$toMaybe(text)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$Ui$SearchInput$emitSearchChanged(text));
				} else {
					var _v2 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Ui$SearchInput$debounceConfig, text, model.dE);
					var newDebouncer = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dE: newDebouncer,
								$A: $author$project$Utils$String$toMaybe(text)
							}),
						cmd,
						$author$project$Ui$SearchInput$None);
				}
			case 1:
				var debounceMsg = msg.a;
				var _v3 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Ui$SearchInput$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Ui$SearchInput$debounceText),
					debounceMsg,
					model.dE);
				var newDebouncer = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dE: newDebouncer}),
					cmd,
					$author$project$Ui$SearchInput$None);
			case 2:
				var text = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$Ui$SearchInput$emitSearchChanged(text));
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{$A: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$Ui$SearchInput$SearchChanged($elm$core$Maybe$Nothing));
		}
	});
var $author$project$Pages$Admin$ChargeItems$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bm: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bm: $author$project$Api$Data$Loading,
									dJ: A2($elm$core$Set$remove, id, model.dJ)
								}),
							$author$project$Pages$Admin$ChargeItems$Top$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Charge item successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dJ: A2($elm$core$Set$remove, id, model.dJ)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var chargeItem = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ia: $elm$core$Maybe$Just(chargeItem)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ia: $elm$core$Maybe$Nothing,
							dJ: A2($elm$core$Set$insert, id, model.dJ)
						}),
					A3(
						$author$project$Api$Provider$ChargeItem$delete,
						model.D5,
						id,
						$author$project$Pages$Admin$ChargeItems$Top$Deleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ia: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 0:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								bm: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$ChargeItems$Top$fetchItems(qModel),
										$author$project$Pages$Admin$ChargeItems$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, model.D5, subMsg, model.cJ);
				var categoryId = function () {
					var _v7 = categoryResourceResult.ac5;
					if (!_v7.$) {
						if (!_v7.a.$) {
							return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8);
						} else {
							var _v8 = _v7.a;
							return model.fa;
						}
					} else {
						return model.fa;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fa: categoryId, cJ: categoryResourceResult.y8});
				var _v6 = _Utils_eq(model.fa, newModel.fa) ? _Utils_Tuple2(model.bm, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])));
				var chargeItems = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{bm: chargeItems}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg, categoryResourceResult.EC),
								cmd
							])),
					categoryResourceResult.as);
			case 8:
				var subMsg = msg.a;
				var _v9 = A2($author$project$Ui$NewDropdown$update, subMsg, model.mx);
				var inventoryDropdown = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mx: inventoryDropdown}),
					cmd,
					_List_Nil);
			case 9:
				var selectedStatus = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bm: $author$project$Api$Data$Loading,
						FI: selectedStatus,
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 10:
				var subMsg = msg.a;
				var _v10 = A2($author$project$Ui$NewDropdown$update, subMsg, model.mL);
				var itemTypeDropdown = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mL: itemTypeDropdown}),
					cmd,
					_List_Nil);
			case 11:
				var selectedType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bm: $author$project$Api$Data$Loading,
						q9: selectedType,
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
								$author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v11 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v11.a;
				var outMsgs = _v11.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg, getFileCmdMsg),
					outMsgs);
		}
	});
var $author$project$Pages$Admin$ChargeItems$Top$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Link$ButtonDefault = 2;
var $author$project$Ui$Link$buttonDefault = $author$project$Ui$Link$Style(2);
var $author$project$Ui$Link$Icon = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ui$Link$icon = $author$project$Ui$Link$Icon;
var $author$project$Ui$Link$Pull = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Link$pull = $author$project$Ui$Link$Pull;
var $author$project$Ui$SearchInput$Clear = {$: 3};
var $author$project$Ui$SearchInput$InputChanged = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Form$Input$Id = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Input$id = $author$project$Ui$Form$Input$Id;
var $author$project$Ui$SearchInput$defaultOptions = {vA: false, adR: $elm$core$Maybe$Nothing, x3: false, S_: false, AN: false, r4: 'Search'};
var $author$project$Ui$SearchInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{r4: string});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{AN: bool});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{S_: bool});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{vA: bool});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								adR: $elm$core$Maybe$Just(string)
							});
					default:
						return _Utils_update(
							record,
							{x3: true});
				}
			}),
		$author$project$Ui$SearchInput$defaultOptions,
		options);
};
var $author$project$Ui$Form$Input$Wrapped = function (a) {
	return {$: 22, a: a};
};
var $author$project$Ui$Form$Input$wrapped = $author$project$Ui$Form$Input$Wrapped;
var $author$project$Ui$SearchInput$view = F2(
	function (options, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Ui$SearchInput$optionsToRecord(options);
		return $author$project$Ui$Form$Input$view(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', model.$A)),
							$author$project$Ui$Form$Input$placeholder(optionsRecord.r4),
							$author$project$Ui$Form$Input$phi(optionsRecord.AN),
							$author$project$Ui$Form$Input$onInput(
							$author$project$Ui$SearchInput$InputChanged(optionsRecord.x3)),
							$author$project$Ui$Form$Input$autofocus(optionsRecord.vA),
							$author$project$Ui$Form$Input$autoComplete(false),
							$author$project$Ui$Form$Input$autoCapitalize(false),
							$author$project$Ui$Form$Input$test('search-input'),
							$author$project$Ui$Form$Input$wrapped(
							_List_fromArray(
								[
									function () {
									var _v1 = model.$A;
									if (!_v1.$) {
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('input-wrapper__icon cursor-pointer'),
													$elm$html$Html$Events$onClick($author$project$Ui$SearchInput$Clear)
												]),
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$cross(_List_Nil)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]),
						function () {
						var _v2 = optionsRecord.adR;
						if (!_v2.$) {
							var idValue = _v2.a;
							return _List_fromArray(
								[
									$author$project$Ui$Form$Input$id(idValue)
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Top$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Category$viewNew, _List_Nil, categoryResourceFilter));
};
var $author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel = function (status) {
	switch (status) {
		case 0:
			return 'In Stock';
		case 1:
			return 'Low Inventory';
		default:
			return 'Out of Stock';
	}
};
var $author$project$Pages$Admin$ChargeItems$Top$viewInventoryDropdown = function (model) {
	var currentLabel = function () {
		var _v0 = model.FI;
		if (!_v0.$) {
			var status = _v0.a;
			return $author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel(status);
		} else {
			return 'All Inventory';
		}
	}();
	var allStatuses = _List_fromArray(
		[0, 1, 2]);
	var items = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected($elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Inventory')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				function (status) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected(
									$elm$core$Maybe$Just(status)))
							]),
						$elm$html$Html$text(
							$author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel(status)));
				},
				allStatuses)));
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.mx);
};
var $author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel = function (itemType) {
	if (!itemType) {
		return 'Items';
	} else {
		return 'Packages';
	}
};
var $author$project$Pages$Admin$ChargeItems$Top$viewItemTypeDropdown = function (model) {
	var itemTypes = _List_fromArray(
		[1, 0]);
	var items = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected($elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Item Types')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				function (itemType) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected(
									$elm$core$Maybe$Just(itemType)))
							]),
						$elm$html$Html$text(
							$author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel(itemType)));
				},
				itemTypes)));
	var currentLabel = function () {
		var _v0 = model.q9;
		if (!_v0.$) {
			var itemType = _v0.a;
			return $author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel(itemType);
		} else {
			return 'All Item Types';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.mL);
};
var $author$project$Api$Data$CSV = 0;
var $author$project$Ui$Tooltip$Left = 2;
var $author$project$Pages$Admin$ChargeItems$Top$SortTable = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Column$Sortable = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Link$AriaLabel = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ui$Link$ariaLabel = $author$project$Ui$Link$AriaLabel;
var $author$project$Api$Data$downloadUrl = F4(
	function (_v0, path, format, queryParams) {
		var client = _v0;
		var absolutePath = A2(
			$elm$url$Url$Builder$crossOrigin,
			client.A6,
			A2(
				$elm$core$List$cons,
				'api',
				A2(
					$author$project$Api$Data$pathToPieces,
					$elm$core$Maybe$Just(format),
					path)));
		return absolutePath(queryParams);
	});
var $author$project$Pages$Admin$ChargeItems$Top$exportCsvPath = function (model) {
	var csvParams = A2(
		$elm$core$List$concatMap,
		$author$project$Api$Param$toQuery,
		$author$project$Api$Provider$ChargeItem$listOptionsToParams(
			$author$project$Pages$Admin$ChargeItems$Top$fetchParams(model)));
	return A4($author$project$Api$Data$downloadUrl, model.D5, $author$project$Api$Provider$ChargeItem$chargeItemsPath, 0, csvParams);
};
var $author$project$Ui$Panel$Table = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$Panel$table = $author$project$Ui$Panel$Table;
var $author$project$Ui$SvgIcon$Upload = 48;
var $author$project$Ui$SvgIcon$upload = $author$project$Ui$SvgIcon$viewIcon(48);
var $author$project$Ui$Table$OnClick = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Table$onClick = $author$project$Ui$Table$OnClick;
var $author$project$Ui$Table$Sortable = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Table$sortable = $author$project$Ui$Table$Sortable;
var $author$project$Ui$Table$Asc = 0;
var $author$project$Ui$Table$Desc = 1;
var $author$project$Api$Sort$directionToTable = function (direction) {
	if (!direction) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Ui$Table$SortDirection = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Table$sortDirection = $author$project$Ui$Table$SortDirection;
var $author$project$Api$Sort$toTable = F2(
	function (column, _v0) {
		var model = _v0;
		var _v1 = $author$project$Api$Sort$valueOrDefault(model);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var currentColumn = _v2.a;
			var currentDirection = _v2.b;
			return _Utils_eq(currentColumn, column) ? _List_fromArray(
				[
					$author$project$Ui$Table$sortDirection(
					$author$project$Api$Sort$directionToTable(currentDirection))
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Api$Column$view = F2(
	function (type_, _v0) {
		var column = _v0;
		var atributtesFromType = function () {
			if (!type_.$) {
				var sort = type_.a;
				var toMsg = type_.b;
				return $elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$Ui$Table$sortable(column.Hf)
							]),
							column.Hf ? _List_fromArray(
							[
								$author$project$Ui$Table$onClick(
								toMsg(column.adR))
							]) : _List_Nil,
							A2($author$project$Api$Sort$toTable, column.adR, sort)
						]));
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Ui$Table$header,
			_Utils_ap(atributtesFromType, column.zY),
			_List_fromArray(
				[
					$elm$html$Html$text(column.zh)
				]));
	});
var $author$project$Components$FileLink$ExportClicked = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$FileLink$view = F3(
	function (_v0, linkOptions, linkContent) {
		var client = _v0.K1;
		var url = _v0.aav;
		var format = _v0.PE;
		return A3(
			$author$project$Ui$Link$externalHref,
			'#',
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$onClick(
					A3($author$project$Components$FileLink$ExportClicked, client, url, format)),
				linkOptions),
			linkContent);
	});
var $author$project$Pages$Admin$ChargeItems$Top$OpenHiConfirm = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Feature$UnifiedExperience = 19;
var $author$project$Utils$Clinical$getHost = F3(
	function (isUnifiedExperience, origin, emrHost) {
		return isUnifiedExperience ? origin : emrHost;
	});
var $author$project$Utils$Clinical$getInventoryUrl = F4(
	function (isUnifiedExperience, origin, emrHost, searchTerm) {
		return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + ('/inventory/list?search=' + searchTerm);
	});
var $author$project$Api$Provider$ChargeItem$All$isMedication = function (chargeItem) {
	var _v0 = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Category$Shared$name,
		$author$project$Api$Provider$ChargeItem$All$category(chargeItem));
	if (!_v0.$) {
		var categoryName_ = _v0.a;
		return categoryName_ === 'Medications';
	} else {
		return false;
	}
};
var $author$project$Api$Provider$ChargeItem$All$lastSetQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$lastUsedAt = function (_v0) {
	var record = _v0.b;
	return record.SF;
};
var $author$project$Api$Provider$ChargeItem$All$lastUsedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$lastUsedAt(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$lowInventory = function (_v0) {
	var record = _v0.b;
	return record.Ta;
};
var $author$project$Api$Provider$ChargeItem$All$lowInventory = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$lowInventory(shared);
};
var $author$project$Api$Provider$ChargeItem$Shared$outOfStock = function (_v0) {
	var record = _v0.b;
	return record.Vl;
};
var $author$project$Api$Provider$ChargeItem$All$outOfStock = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$outOfStock(shared);
};
var $author$project$Pages$Admin$ChargeItems$Top$viewItem = F6(
	function (practice, origin, emrHost, timeFormatter, deletingChargeItems, chargeItem) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$ChargeItem$All$name(chargeItem)),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									function () {
									var _v0 = $author$project$Api$Provider$ChargeItem$All$lastUsedAt(chargeItem);
									if (!_v0.$) {
										var lastUsedAt = _v0.a;
										return A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Last charged ' + A2(timeFormatter, 1, lastUsedAt))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$formatFromFloat(
										$author$project$Api$Provider$ChargeItem$All$priceInCents(chargeItem))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											$elm$html$Html$text('per '),
											$elm$html$Html$text(
											$author$project$Api$Provider$Uom$Shared$name(
												$author$project$Api$Provider$ChargeItem$All$uom(chargeItem)))
										])),
									function () {
									var _v1 = _Utils_Tuple2(
										$author$project$Api$Provider$ChargeItem$All$lastSetQuantity(chargeItem),
										$author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem));
									if ((!_v1.a.$) && (!_v1.b.$)) {
										var lastSetQuantity = _v1.a.a;
										var quantityInStock = _v1.b.a;
										return A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(quantityInStock)),
													$elm$html$Html$text('/'),
													$elm$html$Html$text(
													$elm$core$String$fromInt(lastSetQuantity))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									function () {
									var _v2 = _Utils_Tuple2(
										$author$project$Api$Provider$ChargeItem$All$lowInventory(chargeItem),
										$author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem));
									if (_v2.a) {
										if (_v2.b.$ === 1) {
											var _v3 = _v2.b;
											return $author$project$Utils$Html$empty;
										} else {
											if (!_v2.b.a) {
												return $author$project$Utils$Html$empty;
											} else {
												return A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$warning]),
													_List_fromArray(
														[
															$elm$html$Html$text('Low Inventory')
														]));
											}
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									$author$project$Api$Provider$ChargeItem$All$outOfStock(chargeItem) ? A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$danger]),
									_List_fromArray(
										[
											$elm$html$Html$text('Out of Stock')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Category$Shared$name,
											$author$project$Api$Provider$ChargeItem$All$category(chargeItem))))
								]))
						]),
						A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm_community$string_extra$String$Extra$toTitleCase(
										$author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(
											$author$project$Api$Provider$ChargeItem$All$itemType(chargeItem))))
								]))
						]) : _List_Nil,
						A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A3(
							$author$project$Utils$FeatureGate$customGate,
							2,
							$author$project$Api$Practice$Provider(practice),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$italic]),
											_List_fromArray(
												[
													$author$project$Api$Provider$ChargeItem$All$taxable(chargeItem) ? A2($author$project$Ui$Icon$view, _List_Nil, 18) : A2($author$project$Ui$Icon$view, _List_Nil, 19)
												]))
										]))
								]))),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									function () {
										if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && $author$project$Api$Provider$ChargeItem$All$isMedication(chargeItem)) {
											var isUnifiedExperience = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice);
											var chargeItemName = $author$project$Api$Provider$ChargeItem$All$name(chargeItem);
											var emrInventoryUrl = A4($author$project$Utils$Clinical$getInventoryUrl, isUnifiedExperience, origin, emrHost, chargeItemName);
											return _List_fromArray(
												[
													A3(
													$author$project$Ui$Link$externalHref,
													emrInventoryUrl,
													_List_fromArray(
														[
															$author$project$Ui$Link$sm,
															$author$project$Ui$Link$targetBlank,
															$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$launch)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit in Clinical')
														]))
												]);
										} else {
											var id = $author$project$Api$Provider$ChargeItem$All$id(chargeItem);
											var loading = A2($elm$core$Set$member, id, deletingChargeItems);
											return _List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String(
														{adR: id}),
													_List_fromArray(
														[
															$author$project$Ui$Link$sm,
															$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														])),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Delete charge item'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$size(0),
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$ChargeItems$Top$OpenHiConfirm(chargeItem)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]))
												]);
										}
									}())
								]))
						])
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Top$viewPanelTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bm;
		if (_v1.$ === 3) {
			var chargeItems_ = _v1.a;
			return _Utils_Tuple2(false, chargeItems_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var chargeItems = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No charge items found.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$ChargeItems$Top$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								((!A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.WF)) || model.FR) ? A3(
								$author$project$Ui$Tooltip$view,
								_List_fromArray(
									[
										$author$project$Ui$Tooltip$placement(2)
									]),
								'Upload from CSV',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__ChargeItems__Upload,
										_List_fromArray(
											[
												$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$upload),
												$author$project$Ui$Link$ariaLabel('Upload')
											]),
										_List_Nil)
									])) : $elm$html$Html$text(''),
								A3(
								$author$project$Ui$Tooltip$view,
								_List_fromArray(
									[
										$author$project$Ui$Tooltip$placement(2)
									]),
								'Export to CSV',
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg,
										A3(
											$author$project$Components$FileLink$view,
											{
												K1: model.D5,
												PE: 0,
												aav: $author$project$Pages$Admin$ChargeItems$Top$exportCsvPath(model)
											},
											_List_fromArray(
												[
													$author$project$Ui$Link$ariaLabel('Export CSV'),
													$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$export)
												]),
											_List_Nil))
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A5($author$project$Pages$Admin$ChargeItems$Top$viewItem, model.WF, model.afw, model.acZ, model.Hy, model.dJ),
			chargeItems),
		_List_Nil);
};
var $author$project$Pages$Admin$ChargeItems$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.ia;
				if (!_v0.$) {
					var chargeItem = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed(
							$author$project$Api$Provider$ChargeItem$All$id(chargeItem)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('charge item'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$ChargeItem$All$name(chargeItem) + ' and remove it from all existing charges')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Charge Items')
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__ChargeItems__New,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$pull(1),
										$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Item')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								$elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(4)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(3)
													]),
												_List_fromArray(
													[
														$author$project$Pages$Admin$ChargeItems$Top$viewCategoryResourceFilter(model.cJ)
													]))
											]),
											A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.WF) ? _List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(2)
													]),
												_List_fromArray(
													[
														$author$project$Pages$Admin$ChargeItems$Top$viewItemTypeDropdown(model)
													]))
											]) : _List_Nil,
											_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(3)
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Utils$FeatureGate$gate,
														2,
														$author$project$Api$Practice$Provider(model.WF),
														$author$project$Pages$Admin$ChargeItems$Top$viewInventoryDropdown(model))
													]))
											])
										])))
							])),
						$author$project$Pages$Admin$ChargeItems$Top$viewPanelTable(model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$ChargeItems$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.bm))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Charge Items'
	};
};
var $author$project$Pages$Admin$ChargeItems$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$ChargeItems$Top$init, aer: $author$project$Pages$Admin$ChargeItems$Top$load, agD: $author$project$Pages$Admin$ChargeItems$Top$save, ahd: $author$project$Pages$Admin$ChargeItems$Top$subscriptions, aaq: $author$project$Pages$Admin$ChargeItems$Top$update, ahP: $author$project$Pages$Admin$ChargeItems$Top$view});
var $author$project$Api$Upload$Resource$ChargeItem = 1;
var $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Upload$Form$GotPendingUploads = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Upload$Form$GotUploadColumns = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Upload$ListOptionals$Pending = 0;
var $author$project$Api$Provider$Upload$All$Upload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Common$Upload$Shared$Upload = $elm$core$Basics$identity;
var $author$project$Api$Common$Upload$Shared$Record = function (id) {
	return function (name) {
		return function (createdAt) {
			return function (status) {
				return function (rowsTotal) {
					return function (rowsProcessedOrIgnored) {
						return function (rowsFailed) {
							return function (rowsSupressed) {
								return function (errorMessage) {
									return function (startedAt) {
										return function (finishedAt) {
											return function (uploaderType) {
												return {Mf: createdAt, ON: errorMessage, Pr: finishedAt, adR: id, zh: name, YR: rowsFailed, YT: rowsProcessedOrIgnored, YU: rowsSupressed, YV: rowsTotal, _H: startedAt, ag7: status, aat: uploaderType};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Upload$Status$Cancelled = 13;
var $author$project$Api$Upload$Status$Downloading = 1;
var $author$project$Api$Upload$Status$EnqueuedForPreprocessing = 2;
var $author$project$Api$Upload$Status$EnqueuedForProcessing = 7;
var $author$project$Api$Upload$Status$Failed = 12;
var $author$project$Api$Upload$Status$Postprocessing = 10;
var $author$project$Api$Upload$Status$Preprocessing = 4;
var $author$project$Api$Upload$Status$Processed = 11;
var $author$project$Api$Upload$Status$Processing = 9;
var $author$project$Api$Upload$Status$ReadyToPreprocess = 3;
var $author$project$Api$Upload$Status$ReadyToProcess = 8;
var $author$project$Api$Upload$Status$ReviewDataMatches = 5;
var $author$project$Api$Upload$Status$ReviewFileSize = 6;
var $author$project$Api$Upload$Status$Unattempted = 0;
var $author$project$Api$Upload$Status$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'unattempted':
				return $elm$json$Json$Decode$succeed(0);
			case 'downloading':
				return $elm$json$Json$Decode$succeed(1);
			case 'enqueued_for_preprocessing':
				return $elm$json$Json$Decode$succeed(2);
			case 'ready_to_preprocess':
				return $elm$json$Json$Decode$succeed(3);
			case 'preprocessing':
				return $elm$json$Json$Decode$succeed(4);
			case 'review_data_matches':
				return $elm$json$Json$Decode$succeed(5);
			case 'review_file_size':
				return $elm$json$Json$Decode$succeed(6);
			case 'enqueued_for_processing':
				return $elm$json$Json$Decode$succeed(7);
			case 'ready_to_process':
				return $elm$json$Json$Decode$succeed(8);
			case 'processing':
				return $elm$json$Json$Decode$succeed(9);
			case 'postprocessing':
				return $elm$json$Json$Decode$succeed(10);
			case 'processed':
				return $elm$json$Json$Decode$succeed(11);
			case 'failed':
				return $elm$json$Json$Decode$succeed(12);
			case 'cancelled':
				return $elm$json$Json$Decode$succeed(13);
			default:
				return $elm$json$Json$Decode$fail('Unsupported upload status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Upload$UploaderType$Other = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Upload$UploaderType$SponsorAutosync = {$: 0};
var $author$project$Api$Upload$UploaderType$SponsorManual = {$: 1};
var $author$project$Api$Upload$UploaderType$SponsorManualV2 = {$: 2};
var $author$project$Api$Upload$UploaderType$decoder = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		switch (string) {
			case 'sponsor_autosync':
				return $author$project$Api$Upload$UploaderType$SponsorAutosync;
			case 'sponsor_manual':
				return $author$project$Api$Upload$UploaderType$SponsorManual;
			case 'sponsor_manual_v2':
				return $author$project$Api$Upload$UploaderType$SponsorManualV2;
			default:
				var somethingElse = string;
				return $author$project$Api$Upload$UploaderType$Other(somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Upload$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uploader_type',
	$author$project$Api$Upload$UploaderType$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'finished_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'started_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'error_message',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rows_supressed',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rows_failed',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'rows_processed_or_ignored',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'rows_total',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'status',
									$author$project$Api$Upload$Status$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'created_at',
										$elm_community$json_extra$Json$Decode$Extra$datetime,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Shared$Record)))))))))))));
var $author$project$Api$Common$Upload$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Upload$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Upload$All$Record = function (meta) {
	return {TU: meta};
};
var $author$project$Api$Provider$Upload$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Upload$Meta$Record = function (actions) {
	return {tF: actions};
};
var $author$project$Api$Provider$Upload$Meta$ActionsRecord = F4(
	function (preprocess, process, duplicate, cancel) {
		return {KF: cancel, N3: duplicate, WZ: preprocess, W5: process};
	});
var $author$project$Api$Provider$Upload$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cancel',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'duplicate',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'process',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'preprocess',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Meta$ActionsRecord)))));
var $author$project$Api$Provider$Upload$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Upload$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Meta$Record));
var $author$project$Api$Provider$Upload$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Upload$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Upload$Meta$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$All$Record));
var $author$project$Api$Provider$Upload$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Upload$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$All$Upload)));
var $author$project$Api$Common$Upload$ListOptionals$defaults = {Fi: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, G0: $elm$core$Maybe$Nothing};
var $author$project$Api$Common$Upload$ListOptionals$filterToString = function (filter) {
	return 'pending';
};
var $author$project$Api$Upload$Resource$toString = function (resource) {
	switch (resource) {
		case 0:
			return 'credit';
		case 1:
			return 'chargeitem';
		case 2:
			return 'practitioner';
		case 3:
			return 'patient';
		case 5:
			return 'membership';
		case 4:
			return 'charge';
		case 6:
			return 'payment_method_import';
		default:
			return 'patient_note';
	}
};
var $author$project$Api$Common$Upload$ListOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$Upload$ListOptionals$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Fi;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							$author$project$Api$Common$Upload$ListOptionals$filterToString(filter))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.G0;
				if (!_v1.$) {
					var resource = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'type',
							$author$project$Api$Upload$Resource$toString(resource))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.af_;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Upload$uploadsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['uploads']),
		basePath);
};
var $author$project$Api$Provider$Upload$list = F4(
	function (basePath, apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Upload$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Upload$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Upload$uploadsPath(basePath))));
	});
var $author$project$Api$Provider$Upload$Column$UploadColumns = $elm$core$Basics$identity;
var $author$project$Api$Provider$Upload$Column$UploadColumnsRecord = F2(
	function (columns, ignoredColumns) {
		return {Ll: columns, QL: ignoredColumns};
	});
var $author$project$Api$Provider$Upload$Column$Column = $elm$core$Basics$identity;
var $author$project$Api$Provider$Upload$Column$ColumnRecord = F6(
	function (name, aliases, help, required, allowedValues, _default) {
		return {IO: aliases, I$: allowedValues, M5: _default, Qm: help, zh: name, agk: required};
	});
var $author$project$Api$Provider$Upload$Column$columnRecordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'default',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'allowed_values',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'required',
			$elm$json$Json$Decode$bool,
			false,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'help',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'aliases',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Column$ColumnRecord)))))));
var $author$project$Api$Provider$Upload$Column$columnDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$Column$columnRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Upload$Column$uploadColumnsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ignored_columns',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'columns',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Upload$Column$columnDecoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Column$UploadColumnsRecord)));
var $author$project$Api$Provider$Upload$Column$uploadColumnsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$Column$uploadColumnsRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Upload$Column$uploadColumnsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['uploads', 'columns']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Upload$Column$retrieve = F3(
	function (apiClient, resource, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Upload$Column$uploadColumnsDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$string,
						'type',
						$author$project$Api$Upload$Resource$toString(resource))
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Upload$Column$uploadColumnsPath)));
	});
var $author$project$Components$Upload$Form$init = F4(
	function (timeFormatter, apiClient, resource, companyId) {
		return _Utils_Tuple2(
			{vU: true, ff: companyId, R0: $author$project$Api$Data$NotAsked, AM: $author$project$Api$Data$Loading, G0: resource, oh: false, sO: false, Hy: timeFormatter, DB: $author$project$Api$Data$NotAsked, DC: $author$project$Api$Data$Loading, ha: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$Upload$Column$retrieve, apiClient, resource, $author$project$Components$Upload$Form$GotUploadColumns),
						A4(
						$author$project$Api$Provider$Upload$list,
						$author$project$Api$Data$providerPath,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									Fi: $elm$core$Maybe$Just(0),
									G0: $elm$core$Maybe$Just(resource)
								});
						},
						$author$project$Components$Upload$Form$GotPendingUploads)
					])));
	});
var $author$project$Pages$Admin$ChargeItems$Upload$init = F4(
	function (_v0, practice, shared, _v1) {
		var _v2 = A4($author$project$Components$Upload$Form$init, shared.Hy, shared.D5, 1, $elm$core$Maybe$Nothing);
		var uploadForm = _v2.a;
		var uploadFormCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, lP: false, PB: uploadForm, WF: practice},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, uploadFormCmd));
	});
var $author$project$Pages$Admin$ChargeItems$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ChargeItems$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Upload$Form$CloseCannotUploadModal = {$: 8};
var $author$project$Components$Upload$Form$UploadResultMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress = function (onClose) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
};
var $author$project$Components$Upload$Result$ExportCsvMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Upload$Result$ModalClosed = {$: 4};
var $author$project$Components$ExportCsv$CloseModal = {$: 1};
var $author$project$Components$ExportCsv$subscriptions = function (model) {
	return model.yk ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$ExportCsv$CloseModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Upload$Result$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Upload$Result$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$Result$ModalClosed)
			]));
};
var $author$project$Components$Upload$Form$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Upload$Form$UploadResultMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Upload$Result$subscriptions, model.ha))),
				model.oh ? $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress($author$project$Components$Upload$Form$CloseCannotUploadModal) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$ChargeItems$Upload$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg,
		$author$project$Components$Upload$Form$subscriptions(model.PB));
};
var $author$project$Pages$Admin$ChargeItems$Upload$GotChargeDestroyAll = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ChargeItem$destroyAll = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath));
	});
var $author$project$Components$Upload$Form$ExportFileMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Upload$Form$GotIsProcessing = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Upload$Form$GotUpload = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Upload$One$Upload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Upload$One$Record = function (results) {
	return {YC: results};
};
var $author$project$Api$Common$Upload$Results$Invalid = {$: 2};
var $author$project$Api$Common$Upload$Results$Other = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Common$Upload$Results$TooManyUnenrollments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Upload$Results$TooManyUnenrollmentsRecord = F2(
	function (message, registrations) {
		return {aeD: message, age: registrations};
	});
var $author$project$Api$Common$Upload$Results$RegistrationRecord = F3(
	function (company, count, idents) {
		return {ab9: company, LY: count, adT: idents};
	});
var $author$project$Api$Common$Upload$Results$UploadWarningsRow = F6(
	function (ident, firstName, lastName, companyName, dob, externalId) {
		return {Lw: companyName, acQ: dob, ade: externalId, Pu: firstName, adS: ident, SA: lastName};
	});
var $author$project$Api$Common$Upload$Results$oldUploadWarningDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	'',
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		'',
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			'',
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				'',
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					'',
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$UploadWarningsRow)))))));
var $author$project$Api$Common$Upload$Results$uploadWarningDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'external_id',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'dob',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'company_name',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'last_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'first_name',
					$elm$json$Json$Decode$string,
					'',
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'ident',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$UploadWarningsRow)))))));
var $author$project$Api$Common$Upload$Results$uploadWarningsDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Api$Common$Upload$Results$uploadWarningDecoder, $author$project$Api$Common$Upload$Results$oldUploadWarningDecoder]));
var $author$project$Api$Common$Upload$Results$registrationRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'idents',
	$elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$uploadWarningsDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'company',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$RegistrationRecord))));
var $author$project$Api$Common$Upload$Results$tooManyUnenrollmentsRecordDeocder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'registrations',
	$elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$registrationRecordDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$TooManyUnenrollmentsRecord)));
var $author$project$Api$Common$Upload$Results$decoder = A2(
	$elm$json$Json$Decode$map,
	function (list) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var key = _v0.a;
				var value = _v0.b;
				if (key === 'too_many_unenrollments') {
					var _v2 = A2($elm$json$Json$Decode$decodeValue, $author$project$Api$Common$Upload$Results$tooManyUnenrollmentsRecordDeocder, value);
					if (!_v2.$) {
						var record = _v2.a;
						return $author$project$Api$Common$Upload$Results$TooManyUnenrollments(record);
					} else {
						return $author$project$Api$Common$Upload$Results$Invalid;
					}
				} else {
					var _v3 = A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$uploadWarningsDecoder),
						value);
					if (!_v3.$) {
						var list_ = _v3.a;
						return A2($author$project$Api$Common$Upload$Results$Other, key, list_);
					} else {
						return $author$project$Api$Common$Upload$Results$Invalid;
					}
				}
			},
			list);
	},
	$elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
var $author$project$Api$Provider$Upload$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'results',
	$author$project$Api$Common$Upload$Results$decoder,
	_List_Nil,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$One$Record));
var $author$project$Api$Provider$Upload$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Upload$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Upload$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$One$Upload)));
var $author$project$Api$Data$Files = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Data$requestWithFile = F3(
	function (name, file, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				e5: $elm$core$Maybe$Just(
					A2(
						$author$project$Api$Data$Files,
						name,
						_List_fromArray(
							[file])))
			});
	});
var $author$project$Api$Provider$Upload$create = F4(
	function (apiClient, resource, file, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Upload$One$decoder,
			toMsg,
			A3(
				$author$project$Api$Data$requestWithFile,
				'file',
				file,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'type',
							$author$project$Api$Upload$Resource$toString(resource))
						]),
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$Upload$uploadsPath($author$project$Api$Data$providerPath)))));
	});
var $author$project$Api$Common$Upload$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Upload$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$id(shared);
};
var $author$project$Api$Provider$Upload$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$id(shared);
};
var $author$project$Components$Upload$Result$GotUpload = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$UploadRowManual = 16;
var $author$project$Components$ExportCsv$init = function (_v0) {
	var resource = _v0.G0;
	var forCompany = _v0.adw;
	return {p0: $author$project$Api$Data$NotAsked, qB: false, adw: forCompany, yk: false, db: $author$project$Api$Data$NotAsked, G0: resource, bd: $elm$core$Set$empty};
};
var $author$project$Api$Provider$Upload$uploadPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Upload$uploadsPath(basePath));
	});
var $author$project$Api$Provider$Upload$retrieve = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Upload$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Upload$uploadPath, basePath, id_)));
	});
var $author$project$Components$Upload$Result$init = F2(
	function (apiClient, id) {
		return _Utils_Tuple2(
			{
				l9: $author$project$Components$ExportCsv$init(
					{adw: false, G0: 16}),
				adR: id,
				afy: $author$project$Api$Pagination$init,
				DB: $author$project$Api$Data$Loading,
				tu: $author$project$Api$Data$NotAsked
			},
			A4($author$project$Api$Provider$Upload$retrieve, $author$project$Api$Data$providerPath, apiClient, id, $author$project$Components$Upload$Result$GotUpload));
	});
var $author$project$Api$Provider$Company$Upload$companyUploadsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['uploads']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$Upload$companyUploadsIsProcessingPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['is_processing']),
		$author$project$Api$Provider$Company$Upload$companyUploadsPath(companyId));
};
var $author$project$Api$Provider$Company$Upload$isProcessingDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['is_processing']),
	$elm$json$Json$Decode$bool);
var $author$project$Api$Provider$Company$Upload$isProcessing = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Company$Upload$isProcessingDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$Upload$companyUploadsIsProcessingPath(companyId)));
	});
var $author$project$Components$Upload$Result$Closed = 1;
var $author$project$Components$Upload$Result$None = 0;
var $author$project$Components$Upload$Result$Result = F4(
	function (model, cmd, outMsgs, event) {
		return {EC: cmd, ac5: event, y8: model, as: outMsgs};
	});
var $author$project$Api$Provider$Report$UploadRowCharge = 17;
var $author$project$Api$Provider$Report$UploadRowMembership = 19;
var $author$project$Api$Common$UploadRow$ListOptionals$Failed = 0;
var $author$project$Components$Upload$Result$GotUploadRows = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$UploadRow$All$UploadRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$UploadRow$Shared$UploadRow = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadRow$Shared$Record = F6(
	function (id, rowNumber, status, reviewed, isSupressed, csvRow) {
		return {Mp: csvRow, adR: id, R9: isSupressed, YK: reviewed, YP: rowNumber, ag7: status};
	});
var $author$project$Api$Provider$UploadRow$Status$Created = 0;
var $author$project$Api$Provider$UploadRow$Status$Enqueued = 2;
var $author$project$Api$Provider$UploadRow$Status$Failed = 5;
var $author$project$Api$Provider$UploadRow$Status$Ignored = 6;
var $author$project$Api$Provider$UploadRow$Status$MappingRequired = 7;
var $author$project$Api$Provider$UploadRow$Status$Processed = 4;
var $author$project$Api$Provider$UploadRow$Status$Processing = 3;
var $author$project$Api$Provider$UploadRow$Status$RequiredFieldMappingRequired = 8;
var $author$project$Api$Provider$UploadRow$Status$Validated = 1;
var $author$project$Api$Provider$UploadRow$Status$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'created':
				return $elm$json$Json$Decode$succeed(0);
			case 'validated':
				return $elm$json$Json$Decode$succeed(1);
			case 'enqueued':
				return $elm$json$Json$Decode$succeed(2);
			case 'processing':
				return $elm$json$Json$Decode$succeed(3);
			case 'processed':
				return $elm$json$Json$Decode$succeed(4);
			case 'failed':
				return $elm$json$Json$Decode$succeed(5);
			case 'ignored':
				return $elm$json$Json$Decode$succeed(6);
			case 'mapping_required':
				return $elm$json$Json$Decode$succeed(7);
			case 'required_field_mapping_required':
				return $elm$json$Json$Decode$succeed(8);
			default:
				return $elm$json$Json$Decode$fail('Unsupported upload status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$UploadRow$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'csv_row',
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_supressed',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reviewed',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$author$project$Api$Provider$UploadRow$Status$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'row_number',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$Shared$Record)))))));
var $author$project$Api$Provider$UploadRow$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadRow$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$UploadRow$All$Record = F2(
	function (resultData, uploadRowResults) {
		return {YA: resultData, aar: uploadRowResults};
	});
var $author$project$Api$Common$UploadRowResult$Data$Data = $elm$core$Basics$identity;
var $author$project$Api$Common$UploadRowResult$Data$Record = F7(
	function (value, field, patientIdent, externalId, firstName, lastName, currentDob) {
		return {Mt: currentDob, ade: externalId, Pk: field, Pu: firstName, SA: lastName, VO: patientIdent, aaN: value};
	});
var $author$project$Api$Common$UploadRowResult$Data$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'current_dob',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'last_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'first_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'external_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'patient_ident',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'field',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'value',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							$elm$json$Json$Decode$succeed($author$project$Api$Common$UploadRowResult$Data$Record))))))));
var $author$project$Api$Common$UploadRowResult$Data$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$UploadRowResult$Data$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$UploadRowResult$Shared$UploadRowResult = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadRowResult$Shared$Record = F4(
	function (rowNumber, message, resultType, data) {
		return {MJ: data, aeD: message, YB: resultType, YP: rowNumber};
	});
var $author$project$Api$Provider$UploadRowResult$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'result_type',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'row_number',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRowResult$Shared$Record)))));
var $author$project$Api$Provider$UploadRowResult$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadRowResult$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$UploadRow$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'upload_row_results',
	$elm$json$Json$Decode$list($author$project$Api$Provider$UploadRowResult$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'result_data',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$All$Record)));
var $author$project$Api$Provider$UploadRow$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadRow$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$UploadRow$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$All$UploadRow)));
var $author$project$Api$Sort$withDefault = F3(
	function (column, direction, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				M5: $elm$core$Maybe$Just(
					_Utils_Tuple2(column, direction))
			});
	});
var $author$project$Api$Common$UploadRow$ListOptionals$defaults = {
	Fi: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	G0: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'row_number', 0, $author$project$Api$Sort$init),
	Hs: $elm$core$Maybe$Nothing,
	HL: $elm$core$Maybe$Nothing
};
var $author$project$Api$Common$UploadRow$ListOptionals$filterToString = function (filter) {
	switch (filter) {
		case 0:
			return 'failed';
		case 1:
			return 'warning';
		default:
			return 'processed';
	}
};
var $author$project$Api$Common$UploadRow$ListOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$UploadRow$ListOptionals$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Fi;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							$author$project$Api$Common$UploadRow$ListOptionals$filterToString(filter))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.G0;
				if (!_v1.$) {
					var resource = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'type',
							$author$project$Api$Upload$Resource$toString(resource))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.HL;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'upload_row_results_result_type', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.Hs;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'supress_filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.af_;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$UploadRow$uploadRowsPath = function (uploadId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['upload_rows']),
		A2($author$project$Api$Provider$Upload$uploadPath, $author$project$Api$Data$providerPath, uploadId));
};
var $author$project$Api$Provider$UploadRow$list = F4(
	function (apiClient, uploadId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$UploadRow$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$UploadRow$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$UploadRow$uploadRowsPath(uploadId))));
	});
var $author$project$Components$Upload$Result$fetchUploadRows = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$UploadRow$list,
			apiClient,
			model.adR,
			function (d) {
				return _Utils_update(
					d,
					{
						Fi: $elm$core$Maybe$Just(0),
						afy: model.afy
					});
			},
			$author$project$Components$Upload$Result$GotUploadRows);
	});
var $author$project$Api$Common$Upload$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Upload$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$status(shared);
};
var $author$project$Components$Upload$Result$finishProcessing = function (upload) {
	var _v0 = $author$project$Api$Provider$Upload$One$status(upload);
	switch (_v0) {
		case 11:
			return true;
		case 12:
			return true;
		default:
			return false;
	}
};
var $author$project$Components$Upload$Result$PollUpload = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Upload$Result$pollUpload = function (upload) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$Upload$Result$PollUpload(upload);
		},
		$elm$core$Process$sleep(2000));
};
var $author$project$Components$ExportCsv$DefaultColumnsSaved = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$ExportCsv$ExportFileMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$ReportExport$Shared$Generated = 3;
var $author$project$Components$ExportCsv$GotCsvReport = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ExportCsv$GotReportExport = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Common$CsvReport$Shared$columns = function (_v0) {
	var record = _v0;
	return record.Ll;
};
var $author$project$Api$Common$CsvReport$One$columns = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$CsvReport$Shared$columns(shared);
};
var $author$project$Api$Provider$ReportExport$All$ReportExport = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportExport$Shared$ReportExport = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportExport$Shared$Record = F4(
	function (id, status, totalCount, generatedCount) {
		return {PR: generatedCount, adR: id, ag7: status, oN: totalCount};
	});
var $author$project$Api$Provider$ReportExport$Shared$Enqueued = 1;
var $author$project$Api$Provider$ReportExport$Shared$Generating = 2;
var $author$project$Api$Provider$ReportExport$Shared$Pending = 0;
var $author$project$Api$Provider$ReportExport$Shared$decodeStatus = function (string) {
	switch (string) {
		case 'pending':
			return $elm$json$Json$Decode$succeed(0);
		case 'enqueued':
			return $elm$json$Json$Decode$succeed(1);
		case 'generating':
			return $elm$json$Json$Decode$succeed(2);
		case 'generated':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail('Unsupported report export status: ' + string);
	}
};
var $author$project$Api$Provider$ReportExport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'generated_count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total_count',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$ReportExport$Shared$decodeStatus, $elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$ReportExport$Shared$Record)))));
var $author$project$Api$Provider$ReportExport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportExport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportExport$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportExport$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportExport$reportExportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'exports']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Report$resourceToString = function (resource) {
	switch (resource) {
		case 0:
			return 'Patient';
		case 1:
			return 'SignupAttempt';
		case 2:
			return 'StatementLine';
		case 3:
			return 'Invoice';
		case 6:
			return 'RevenueLine';
		case 7:
			return 'DeferredRevenueLine';
		case 8:
			return 'TaxLine';
		case 9:
			return 'PaymentApplicationLine';
		case 10:
			return 'MembershipPatient';
		case 11:
			return 'Membership';
		case 12:
			return 'CustomerInvoice';
		case 13:
			return 'Deposit';
		case 14:
			return 'CreditLine';
		case 15:
			return 'Credit';
		case 16:
			return 'UploadRowManual';
		case 17:
			return 'UploadRowCharge';
		case 18:
			return 'UploadRowSponsor';
		case 19:
			return 'UploadRowMembership';
		case 20:
			return 'Location';
		case 4:
			return 'InvoiceLine';
		case 5:
			return 'AffiliateBillLine';
		case 21:
			return 'Dispute';
		case 22:
			return 'AffiliateAncillaryCharge';
		case 23:
			return 'CompanyRegistration';
		default:
			return 'PaymentMethodImport';
	}
};
var $author$project$Api$Param$toValue = function (params) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (param) {
				switch (param.$) {
					case 0:
						var key = param.a;
						var string_ = param.b;
						return _Utils_Tuple2(
							key,
							$elm$json$Json$Encode$string(string_));
					case 1:
						var key = param.a;
						var bool_ = param.b;
						return _Utils_Tuple2(
							key,
							$elm$json$Json$Encode$bool(bool_));
					case 2:
						var key = param.a;
						var date_ = param.b;
						return _Utils_Tuple2(
							key,
							$elm$json$Json$Encode$string(
								$author$project$Utils$Date$toQuery(date_)));
					default:
						var key = param.a;
						var list_ = param.b;
						var _v1 = _Utils_Tuple2(
							$elm$core$List$length(list_) > 1,
							$elm$core$List$head(list_));
						if ((!_v1.a) && (!_v1.b.$)) {
							var string_ = _v1.b.a;
							return _Utils_Tuple2(
								key,
								$elm$json$Json$Encode$string(string_));
						} else {
							return _Utils_Tuple2(
								key,
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, list_));
						}
				}
			},
			params));
};
var $author$project$Api$Provider$ReportExport$create = F5(
	function (apiClient, resource, params, columns, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'export',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'resource',
								$elm$json$Json$Encode$string(
									$author$project$Api$Provider$Report$resourceToString(resource))),
								_Utils_Tuple2(
								'columns',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, columns)),
								_Utils_Tuple2(
								'report_params',
								$author$project$Api$Param$toValue(params))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ReportExport$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ReportExport$reportExportsPath)));
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Api$Provider$ReportExport$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$ReportExport$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportExport$Shared$id(shared);
};
var $author$project$Api$Common$CsvReport$CsvReportColumn$name = function (_v0) {
	var record = _v0;
	return record.v6.zh;
};
var $author$project$Components$ExportCsv$PollReportExport = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$ExportCsv$pollReportExport = function (reportExport) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$ExportCsv$PollReportExport(reportExport);
		},
		$elm$core$Process$sleep(2000));
};
var $author$project$Api$Common$CsvReport$CsvReport$csvReportPath = F2(
	function (forCompany, resource) {
		var path = forCompany ? $author$project$Api$Data$employerPath : $author$project$Api$Data$providerPath;
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[
					'csv_reports',
					$author$project$Api$Provider$Report$resourceToString(resource)
				]),
			path);
	});
var $author$project$Api$Common$CsvReport$One$CsvReport = $elm$core$Basics$identity;
var $author$project$Api$Common$CsvReport$Shared$CsvReport = $elm$core$Basics$identity;
var $author$project$Api$Common$CsvReport$Shared$Record = function (columns) {
	return {Ll: columns};
};
var $author$project$Api$Common$CsvReport$CsvReportColumn$CsvReportColumn = $elm$core$Basics$identity;
var $author$project$Api$Common$CsvReport$CsvReportColumn$WrapperRecord = function (column) {
	return {v6: column};
};
var $author$project$Api$Common$CsvReport$CsvReportColumn$Record = F3(
	function (name, title, includeByDefault) {
		return {QS: includeByDefault, zh: name, $G: title};
	});
var $author$project$Api$Common$CsvReport$CsvReportColumn$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'include_by_default',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$CsvReportColumn$Record))));
var $author$project$Api$Common$CsvReport$CsvReportColumn$wrapperRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'column',
	$author$project$Api$Common$CsvReport$CsvReportColumn$recordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$CsvReportColumn$WrapperRecord));
var $author$project$Api$Common$CsvReport$CsvReportColumn$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$CsvReport$CsvReportColumn$wrapperRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$CsvReport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'columns',
	$elm$json$Json$Decode$list($author$project$Api$Common$CsvReport$CsvReportColumn$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$Shared$Record));
var $author$project$Api$Common$CsvReport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$CsvReport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$CsvReport$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$CsvReport$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$CsvReport$CsvReport$retrieve = F4(
	function (apiClient, forCompany, resource, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$CsvReport$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Common$CsvReport$CsvReport$csvReportPath, forCompany, resource)));
	});
var $author$project$Api$Provider$ReportExport$reportExportPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ReportExport$reportExportsPath);
};
var $author$project$Api$Provider$ReportExport$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ReportExport$All$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ReportExport$reportExportPath(id_)));
	});
var $author$project$Api$Common$CsvReport$CsvReport$saveColumns = F4(
	function (apiClient, resource, defaultColumns, toMsg) {
		var forCompany = false;
		var defaultColumnsString = A2(
			$elm$core$String$join,
			',',
			$elm$core$Set$toList(defaultColumns));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'default_columns',
					$elm$json$Json$Encode$string(defaultColumnsString))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['update_default_columns']),
						A2($author$project$Api$Common$CsvReport$CsvReport$csvReportPath, forCompany, resource)))));
	});
var $author$project$Api$Common$CsvReport$CsvReportColumn$includeByDefault = function (_v0) {
	var record = _v0;
	return record.v6.QS;
};
var $author$project$Components$ExportCsv$selectDefaultColumns = function (csvReport) {
	return $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			$author$project$Api$Common$CsvReport$CsvReportColumn$name,
			A2(
				$elm$core$List$filter,
				$author$project$Api$Common$CsvReport$CsvReportColumn$includeByDefault,
				$author$project$Api$Common$CsvReport$One$columns(csvReport))));
};
var $author$project$Api$Provider$ReportExport$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$ReportExport$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportExport$Shared$status(shared);
};
var $author$project$Components$ExportCsv$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{yk: true}),
					A4($author$project$Api$Common$CsvReport$CsvReport$retrieve, apiClient, model.adw, model.G0, $author$project$Components$ExportCsv$GotCsvReport),
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					$author$project$Components$ExportCsv$init(
						{adw: model.adw, G0: model.G0}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var dataCsvReport = msg.a;
				if (dataCsvReport.$ === 3) {
					var csvReport = dataCsvReport.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								p0: dataCsvReport,
								bd: $author$project$Components$ExportCsv$selectDefaultColumns(csvReport)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{p0: dataCsvReport}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(dataCsvReport));
				}
			case 3:
				var csvReport = msg.a;
				var selectedColumns = $elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						$author$project$Api$Common$CsvReport$CsvReportColumn$name,
						$author$project$Api$Common$CsvReport$One$columns(csvReport)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bd: selectedColumns}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bd: $elm$core$Set$empty}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Common$CsvReport$CsvReport$saveColumns, apiClient, model.G0, model.bd, $author$project$Components$ExportCsv$DefaultColumnsSaved),
					_List_Nil);
			case 5:
				var columnName = msg.a;
				var selected = msg.b;
				var selectedColumns = (!selected) ? A2($elm$core$Set$remove, columnName, model.bd) : A2($elm$core$Set$insert, columnName, model.bd);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bd: selectedColumns}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var reportParams_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qB: true, db: $author$project$Api$Data$Loading}),
					A5(
						$author$project$Api$Provider$ReportExport$create,
						apiClient,
						model.G0,
						reportParams_,
						$elm$core$Set$toList(model.bd),
						$author$project$Components$ExportCsv$GotReportExport),
					_List_Nil);
			case 7:
				var dataReportExport = msg.a;
				var cmd = function () {
					if (dataReportExport.$ === 3) {
						var reportExport = dataReportExport.a;
						return ($author$project$Api$Provider$ReportExport$All$status(reportExport) !== 3) ? $author$project$Components$ExportCsv$pollReportExport(reportExport) : $elm$core$Platform$Cmd$none;
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{db: dataReportExport}),
					cmd,
					$author$project$OutMsg$reportDecodeError(dataReportExport));
			case 8:
				var reportExport = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$ReportExport$retrieve,
						apiClient,
						$author$project$Api$Provider$ReportExport$All$id(reportExport),
						$author$project$Components$ExportCsv$GotReportExport),
					_List_Nil);
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v4 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v4.a;
				var outMsgs = _v4.b;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$ExportCsv$ExportFileMsg, getFileCmdMsg),
								A2(
								$elm$core$Task$perform,
								function (_v5) {
									return $author$project$Components$ExportCsv$CloseModal;
								},
								$elm$core$Task$succeed(0))
							])),
					outMsgs);
		}
	});
var $author$project$Api$Common$Upload$Shared$uploaderType = function (_v0) {
	var record = _v0;
	return record.aat;
};
var $author$project$Api$Provider$Upload$One$uploaderType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
};
var $author$project$Components$Upload$Result$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var upload = response.a;
					var resource = function () {
						var _v2 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
						_v2$2:
						while (true) {
							if (_v2.$ === 3) {
								switch (_v2.a) {
									case 'charge':
										return 17;
									case 'membership':
										return 19;
									default:
										break _v2$2;
								}
							} else {
								break _v2$2;
							}
						}
						return 16;
					}();
					var exportCsv = $author$project$Components$ExportCsv$init(
						{adw: false, G0: resource});
					var cmd = $author$project$Components$Upload$Result$finishProcessing(upload) ? A2($author$project$Components$Upload$Result$fetchUploadRows, apiClient, model) : $author$project$Components$Upload$Result$pollUpload(upload);
					return A4(
						$author$project$Components$Upload$Result$Result,
						_Utils_update(
							model,
							{l9: exportCsv, DB: response}),
						cmd,
						_List_Nil,
						0);
				} else {
					return A4(
						$author$project$Components$Upload$Result$Result,
						_Utils_update(
							model,
							{DB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response),
						0);
				}
			case 1:
				var upload = msg.a;
				return A4(
					$author$project$Components$Upload$Result$Result,
					model,
					A4(
						$author$project$Api$Provider$Upload$retrieve,
						$author$project$Api$Data$providerPath,
						apiClient,
						$author$project$Api$Provider$Upload$One$id(upload),
						$author$project$Components$Upload$Result$GotUpload),
					_List_Nil,
					0);
			case 2:
				var response = msg.a;
				var pagination = function () {
					if (response.$ === 3) {
						var headers = response.b;
						return A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy);
					} else {
						return model.afy;
					}
				}();
				return A4(
					$author$project$Components$Upload$Result$Result,
					_Utils_update(
						model,
						{afy: pagination, tu: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response),
					0);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return A4(
					$author$project$Components$Upload$Result$Result,
					newModel,
					A2($author$project$Components$Upload$Result$fetchUploadRows, apiClient, newModel),
					_List_Nil,
					0);
			case 4:
				return A4($author$project$Components$Upload$Result$Result, model, $elm$core$Platform$Cmd$none, _List_Nil, 1);
			default:
				var subMsg = msg.a;
				var _v4 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v4.a;
				var subCmd = _v4.b;
				var subOutMsg = _v4.c;
				var newModel = _Utils_update(
					model,
					{l9: exportCsv});
				return A4(
					$author$project$Components$Upload$Result$Result,
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Result$ExportCsvMsg, subCmd),
					subOutMsg,
					0);
		}
	});
var $author$project$Components$Upload$Form$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{DC: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sO: !model.sO}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var files = msg.a;
				var _v1 = $elm$core$List$head(files);
				if (!_v1.$) {
					var file = _v1.a;
					var _v2 = model.ff;
					if (!_v2.$) {
						var companyId = _v2.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{R0: $author$project$Api$Data$Loading}),
							A3(
								$author$project$Api$Provider$Company$Upload$isProcessing,
								apiClient,
								companyId,
								$author$project$Components$Upload$Form$GotIsProcessing(file)),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							model,
							A4($author$project$Api$Provider$Upload$create, apiClient, model.G0, file, $author$project$Components$Upload$Form$GotUpload),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var file = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var isProcessing = response.a;
					var cmd = isProcessing ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Upload$create, apiClient, model.G0, file, $author$project$Components$Upload$Form$GotUpload);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{R0: response, oh: isProcessing}),
						cmd,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{R0: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var upload = response.a;
					var _v5 = A2(
						$author$project$Components$Upload$Result$init,
						apiClient,
						$author$project$Api$Provider$Upload$One$id(upload));
					var uploadResult = _v5.a;
					var uploadResultCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								DB: response,
								ha: $elm$core$Maybe$Just(uploadResult)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, uploadResultCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{DB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{AM: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 6:
				var subMsg = msg.a;
				var _v6 = model.ha;
				if (!_v6.$) {
					var uploadResult = _v6.a;
					var result = A3($author$project$Components$Upload$Result$update, apiClient, subMsg, uploadResult);
					var uploadResult_ = function () {
						var _v7 = result.ac5;
						if (!_v7) {
							return $elm$core$Maybe$Just(result.y8);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ha: uploadResult_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, result.EC),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var upload = msg.a;
				var _v8 = A2(
					$author$project$Components$Upload$Result$init,
					apiClient,
					$author$project$Api$Provider$Upload$All$id(upload));
				var uploadResult = _v8.a;
				var uploadResultCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ha: $elm$core$Maybe$Just(uploadResult)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, uploadResultCmd),
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oh: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v9 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v9.a;
				var outMsgs = _v9.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$ExportFileMsg, getFileCmdMsg),
					outMsgs);
		}
	});
var $author$project$Pages$Admin$ChargeItems$Upload$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Upload$Form$update, model.D5, subMsg, model.PB);
				var uploadForm = _v1.a;
				var subCmd = _v1.b;
				var subOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: uploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, subCmd),
					subOutMsgs);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lP: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{lP: false}),
					A2($author$project$Api$Provider$ChargeItem$destroyAll, model.D5, $author$project$Pages$Admin$ChargeItems$Upload$GotChargeDestroyAll),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{lP: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Charges were successfully removed.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$ChargeItems$Upload$HiConfirmChargesClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Common$Upload$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Upload$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$name(shared);
};
var $author$project$Components$ExportCsv$OpenModal = {$: 0};
var $author$project$Components$ExportCsv$customButton = F2(
	function (options, children) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Export to csv'},
			_Utils_ap(
				options,
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$OpenModal),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$export)
					])),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Tooltip$view,
					_List_fromArray(
						[
							$author$project$Ui$Tooltip$placement(2)
						]),
					'Export to CSV',
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						children))
				]));
	});
var $author$project$Components$ExportCsv$button = A2(
	$author$project$Components$ExportCsv$customButton,
	_List_fromArray(
		[
			$author$project$Ui$Button$link,
			$author$project$Ui$Button$padding($author$project$Ui$Padding$none)
		]),
	_List_Nil);
var $author$project$Components$Upload$Result$failed = F2(
	function (upload, uploadRows) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Provider$Upload$One$status(upload),
			$elm$core$List$isEmpty(uploadRows));
		if (_v0.a === 12) {
			var _v1 = _v0.a;
			return true;
		} else {
			if (!_v0.b) {
				return true;
			} else {
				return false;
			}
		}
	});
var $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored = function (_v0) {
	var record = _v0;
	return record.YT;
};
var $author$project$Api$Provider$Upload$One$rowsProcessedOrIgnored = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
};
var $author$project$Api$Common$Upload$Shared$rowsTotal = function (_v0) {
	var record = _v0;
	return record.YV;
};
var $author$project$Api$Provider$Upload$One$rowsTotal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
};
var $author$project$Ui$Alert$success = $author$project$Ui$Alert$view(0);
var $author$project$Components$Upload$Result$exportParams = function (upload) {
	var _v0 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
	if (_v0.$ === 3) {
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'filter', '')
			]);
	} else {
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'filter', 'failed')
			]);
	}
};
var $author$project$Components$ExportCsv$Filter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ExportCsv$filter = $author$project$Components$ExportCsv$Filter;
var $author$project$Components$ExportCsv$DeselectAllColumns = {$: 4};
var $author$project$Components$ExportCsv$SaveDefaultColumns = {$: 10};
var $author$project$Components$ExportCsv$SelectAllColumns = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ExportCsv$StartExport = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Link$ButtonPrimary = 0;
var $author$project$Ui$Link$buttonPrimary = $author$project$Ui$Link$Style(0);
var $author$project$Components$ExportCsv$paramsForCsv = F2(
	function (optionsRecord, selectedColumns) {
		return A2(
			$elm$core$List$concatMap,
			$author$project$Api$Param$toQuery,
			A2(
				$elm$core$List$append,
				function () {
					var _v0 = optionsRecord.Fi;
					if (!_v0.$) {
						var filter_ = _v0.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'filter', filter_)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$append,
					_List_fromArray(
						[
							A2($author$project$Api$Param$list, 'columns', selectedColumns)
						]),
					optionsRecord.Vx)));
	});
var $author$project$Components$ExportCsv$downloadCsvHref = F3(
	function (apiClient, optionsRecord, selectedColumns) {
		return A2(
			$elm$core$Maybe$map,
			function (path_) {
				return A4(
					$author$project$Api$Data$downloadUrl,
					apiClient,
					path_,
					0,
					A2($author$project$Components$ExportCsv$paramsForCsv, optionsRecord, selectedColumns));
			},
			optionsRecord.VL);
	});
var $author$project$Formatters$Int$formatNumber = function (number) {
	return A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, number);
};
var $author$project$Ui$Link$FullWidth = {$: 7};
var $author$project$Ui$Link$fullWidth = $author$project$Ui$Link$FullWidth;
var $author$project$Api$Provider$ReportExport$Shared$generatedCount = function (_v0) {
	var record = _v0;
	return record.PR;
};
var $author$project$Api$Provider$ReportExport$All$generatedCount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportExport$Shared$generatedCount(shared);
};
var $author$project$Components$ExportCsv$totalCountLimit = 200 * 1000;
var $author$project$Components$ExportCsv$isInvalid = function (totalCount) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (count) {
				return _Utils_cmp(count, $author$project$Components$ExportCsv$totalCountLimit) > 0;
			},
			totalCount));
};
var $author$project$Components$ExportCsv$defaultOptions = {Fi: $elm$core$Maybe$Nothing, Vx: _List_Nil, VL: $elm$core$Maybe$Nothing, jO: false, Bs: _List_Nil, oN: $elm$core$Maybe$Nothing};
var $author$project$Components$ExportCsv$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var totalCount = option.a;
						return _Utils_update(
							record,
							{jO: true, oN: totalCount});
					case 1:
						var dict = option.a;
						return _Utils_update(
							record,
							{Vx: dict});
					case 2:
						var dict = option.a;
						return _Utils_update(
							record,
							{Bs: dict});
					case 3:
						var string = option.a;
						return _Utils_update(
							record,
							{
								Fi: $elm$core$Maybe$Just(string)
							});
					default:
						var path_ = option.a;
						return _Utils_update(
							record,
							{
								VL: $elm$core$Maybe$Just(path_)
							});
				}
			}),
		$author$project$Components$ExportCsv$defaultOptions,
		options);
};
var $author$project$Components$ExportCsv$reportExportGenerated = function (dataReportExport) {
	if (dataReportExport.$ === 3) {
		var reportExport = dataReportExport.a;
		return $author$project$Api$Provider$ReportExport$All$status(reportExport) === 3;
	} else {
		return false;
	}
};
var $author$project$Components$ExportCsv$reportExportHref = F2(
	function (apiClient, dataReportExport) {
		return A2(
			$elm$core$Maybe$map,
			function (reportExport) {
				var reportExportPath = $author$project$Api$Provider$ReportExport$reportExportPath(
					$author$project$Api$Provider$ReportExport$All$id(reportExport));
				return A4($author$project$Api$Data$downloadUrl, apiClient, reportExportPath, 0, _List_Nil);
			},
			$author$project$Api$Data$toMaybe(dataReportExport));
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $elm$core$Set$size = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$size(dict);
};
var $author$project$Api$Provider$ReportExport$Shared$totalCount = function (_v0) {
	var record = _v0;
	return record.oN;
};
var $author$project$Api$Provider$ReportExport$All$totalCount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportExport$Shared$totalCount(shared);
};
var $author$project$Components$ExportCsv$ToggleColumn = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Ui$Form$Checkbox$Attr = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Checkbox$attr = function (attributes) {
	return $author$project$Ui$Form$Checkbox$Attr(attributes);
};
var $author$project$Api$Common$CsvReport$CsvReportColumn$title = function (_v0) {
	var record = _v0;
	return record.v6.$G;
};
var $author$project$Components$ExportCsv$viewColumn = F2(
	function (selectedColumns, column) {
		var columnName = $author$project$Api$Common$CsvReport$CsvReportColumn$name(column);
		return A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(
					A2($elm$core$Set$member, columnName, selectedColumns)),
					$author$project$Ui$Form$Checkbox$attr(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-left')
						])),
					$author$project$Ui$Form$Checkbox$onCheck(
					$author$project$Components$ExportCsv$ToggleColumn(columnName))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Common$CsvReport$CsvReportColumn$title(column))
				]));
	});
var $author$project$Components$ExportCsv$viewModal = F3(
	function (apiClient, options, model) {
		var optionsRecord = $author$project$Components$ExportCsv$optionsToRecord(options);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$ExportCsv$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Export to CSV')
								]))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							if (model.qB) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-center')
										]),
									$elm$core$List$concat(
										_List_fromArray(
											[
												((!$author$project$Components$ExportCsv$reportExportGenerated(model.db)) || (!optionsRecord.jO)) ? _List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil),
													A2($elm$html$Html$br, _List_Nil, _List_Nil)
												]) : _List_Nil,
												optionsRecord.jO ? ($author$project$Components$ExportCsv$reportExportGenerated(model.db) ? _List_fromArray(
												[
													A2(
													$author$project$Ui$Alert$success,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Your export was generated successfully.')
														]))
												]) : _List_fromArray(
												[
													$elm$html$Html$text('Your export may take a few minutes to generate.'),
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													function () {
													var _v0 = A2(
														$elm$core$Maybe$andThen,
														$author$project$Api$Provider$ReportExport$All$totalCount,
														$author$project$Api$Data$toMaybe(model.db));
													if (!_v0.$) {
														var totalCount = _v0.a;
														return A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	'Generated ' + ($elm$core$String$fromInt(
																		A2(
																			$elm$core$Maybe$withDefault,
																			0,
																			A2(
																				$elm$core$Maybe$andThen,
																				$author$project$Api$Provider$ReportExport$All$generatedCount,
																				$author$project$Api$Data$toMaybe(model.db)))) + (' out of ' + $elm$core$String$fromInt(totalCount))))
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												])) : _List_Nil
											])));
							} else {
								var _v1 = model.p0;
								if (_v1.$ === 3) {
									var csvReport = _v1.a;
									var flexItemClass = 'relative after:absolute after:content-[\'|\'] after:-right-2 after:translate-x-1/2';
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('You\'re about to export and download the report. Please select the columns below:'),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('well well-sm'),
																A2($elm$html$Html$Attributes$style, 'overflow-y', 'scroll'),
																A2($elm$html$Html$Attributes$style, 'max-height', '212px')
															]),
														A2(
															$elm$core$List$map,
															$author$project$Components$ExportCsv$viewColumn(model.bd),
															$author$project$Api$Common$CsvReport$One$columns(csvReport)))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('flex justify-end gap-4')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(flexItemClass)
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Select all'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																		$author$project$Ui$Button$onClick(
																		$author$project$Components$ExportCsv$SelectAllColumns(csvReport))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Select All')
																	]))
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(flexItemClass)
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Select all'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																		$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$DeselectAllColumns)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Unselect All')
																	]))
															])),
														(!model.adw) ? A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class(flexItemClass)
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Save selection'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																		$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$SaveDefaultColumns)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Save Selection')
																	]))
															])) : $author$project$Utils$Html$empty,
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('text-muted pull-right')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$elm$core$String$fromInt(
																	$elm$core$Set$size(model.bd)) + (' of ' + ($elm$core$String$fromInt(
																	$elm$core$List$length(
																		$author$project$Api$Common$CsvReport$One$columns(csvReport))) + ' columns to be exported')))
															]))
													])),
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Components$ExportCsv$isInvalid(optionsRecord.oN) ? $author$project$Utils$FormErrors$view(
														_List_fromArray(
															[
																'Your report exceeds the  ' + ($author$project$Formatters$Int$formatNumber($author$project$Components$ExportCsv$totalCountLimit) + ' items limit and cannot be exported. Please refine your search criteria (e.g., adjust date ranges or filters) to reduce the number of records, then try again.')
															])) : $author$project$Utils$Html$empty
													]))
											]));
								} else {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-center')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]));
								}
							}
						}()
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							(optionsRecord.jO && $author$project$Components$ExportCsv$reportExportGenerated(model.db)) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							_List_fromArray(
								[
									function () {
									var _v2 = A2($author$project$Components$ExportCsv$reportExportHref, apiClient, model.db);
									if (!_v2.$) {
										var reportExportHref_ = _v2.a;
										return A2(
											$elm$html$Html$map,
											$author$project$Components$ExportCsv$ExportFileMsg,
											A3(
												$author$project$Components$FileLink$view,
												{K1: apiClient, PE: 0, aav: reportExportHref_},
												_List_fromArray(
													[$author$project$Ui$Link$buttonPrimary]),
												_List_fromArray(
													[
														$elm$html$Html$text('Download')
													])));
									} else {
										return A3(
											$author$project$Ui$Button$view,
											{abp: 'Download'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$disabled(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Download')
												]));
									}
								}()
								])) : A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Cancel'},
											_List_fromArray(
												[
													$author$project$Ui$Button$fullWidth(true),
													$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$CloseModal)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									function () {
										if (optionsRecord.jO) {
											return _List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Export'},
													_List_fromArray(
														[
															$author$project$Ui$Button$fullWidth(true),
															$author$project$Ui$Button$primary,
															$author$project$Ui$Button$disabled(
															model.qB || $author$project$Components$ExportCsv$isInvalid(optionsRecord.oN)),
															$author$project$Ui$Button$onClick(
															$author$project$Components$ExportCsv$StartExport(optionsRecord.Bs)),
															$author$project$Ui$Button$loading(
															_Utils_eq(optionsRecord.oN, $elm$core$Maybe$Nothing))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Export')
														]))
												]);
										} else {
											var _v3 = A3(
												$author$project$Components$ExportCsv$downloadCsvHref,
												apiClient,
												optionsRecord,
												$elm$core$Set$toList(model.bd));
											if (!_v3.$) {
												var downloadCsvHref_ = _v3.a;
												return _List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Components$ExportCsv$ExportFileMsg,
														A3(
															$author$project$Components$FileLink$view,
															{K1: apiClient, PE: 0, aav: downloadCsvHref_},
															_List_fromArray(
																[$author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$fullWidth]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Export')
																])))
													]);
											} else {
												return _List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{abp: 'Export'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$disabled(true)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Export')
															]))
													]);
											}
										}
									}())
								]))
						]))
				]));
	});
var $author$project$Components$ExportCsv$modal = F3(
	function (apiClient, options, model) {
		return model.yk ? A3($author$project$Components$ExportCsv$viewModal, apiClient, options, model) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$ExportCsv$Params = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ExportCsv$params = $author$project$Components$ExportCsv$Params;
var $author$project$Components$ExportCsv$Path = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ExportCsv$path = $author$project$Components$ExportCsv$Path;
var $author$project$Components$Upload$Result$viewExportToCsvModal = F3(
	function (apiClient, upload, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Upload$Result$ExportCsvMsg,
			A3(
				$author$project$Components$ExportCsv$modal,
				apiClient,
				_List_fromArray(
					[
						$author$project$Components$ExportCsv$params(
						$author$project$Components$Upload$Result$exportParams(upload)),
						$author$project$Components$ExportCsv$path(
						$author$project$Api$Provider$UploadRow$uploadRowsPath(
							$author$project$Api$Provider$Upload$One$id(upload))),
						$author$project$Components$ExportCsv$filter('upload')
					]),
				model.l9));
	});
var $author$project$Components$Upload$Result$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Panel$Danger = 4;
var $author$project$Ui$Panel$Styling = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Panel$danger = $author$project$Ui$Panel$Styling(4);
var $author$project$Api$Common$Upload$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$Upload$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$errorMessage(shared);
};
var $author$project$Components$Upload$Result$errorMessages = function (upload) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$split('\n'),
			$author$project$Api$Provider$Upload$One$errorMessage(upload)));
};
var $author$project$Api$Provider$UploadRow$All$uploadRowResults = function (_v0) {
	var record = _v0.b;
	return record.aar;
};
var $author$project$Api$Provider$UploadRowResult$Shared$data = function (_v0) {
	var record = _v0;
	return record.MJ;
};
var $author$project$Api$Common$UploadRowResult$Data$field = function (_v0) {
	var record = _v0;
	return record.Pk;
};
var $author$project$Components$Upload$Result$errorField = function (uploadRowResult) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Common$UploadRowResult$Data$field,
			$author$project$Api$Provider$UploadRowResult$Shared$data(uploadRowResult)));
};
var $author$project$Api$Common$UploadRowResult$Data$value = function (_v0) {
	var record = _v0;
	return record.aaN;
};
var $author$project$Components$Upload$Result$errorFieldValue = function (uploadRowResult) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Common$UploadRowResult$Data$value,
		$author$project$Api$Provider$UploadRowResult$Shared$data(uploadRowResult));
};
var $author$project$Api$Provider$UploadRowResult$Shared$message = function (_v0) {
	var record = _v0;
	return record.aeD;
};
var $author$project$Api$Provider$UploadRowResult$Shared$rowNumber = function (_v0) {
	var record = _v0;
	return record.YP;
};
var $author$project$Components$Upload$Result$viewUploadRowResult = function (uploadRowResult) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Provider$UploadRowResult$Shared$rowNumber(uploadRowResult)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Upload$Result$errorField(uploadRowResult))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = $author$project$Components$Upload$Result$errorFieldValue(uploadRowResult);
								if (!_v0.$) {
									var value = _v0.a;
									return $elm$html$Html$text(value);
								} else {
									return $elm$html$Html$text('Blank');
								}
							}()
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$UploadRowResult$Shared$message(uploadRowResult)))
							]))
					])),
				A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
			]));
};
var $author$project$Components$Upload$Result$viewUploadRow = function (uploadRow) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Upload$Result$viewUploadRowResult,
		$author$project$Api$Provider$UploadRow$All$uploadRowResults(uploadRow));
};
var $author$project$Components$Upload$Result$viewUploadErrors = F2(
	function (model, upload) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$danger]),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (message) {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]));
							},
							$author$project$Components$Upload$Result$errorMessages(upload))),
					function () {
						var _v0 = model.tu;
						if (_v0.$ === 3) {
							var list = _v0.a;
							return $elm$core$List$isEmpty(list) ? _List_Nil : _List_fromArray(
								[
									A4(
									$author$project$Ui$Panel$table,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Row #')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Field')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Value')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Error')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('pull-right')
														]),
													_List_fromArray(
														[
															A2($elm$html$Html$map, $author$project$Components$Upload$Result$ExportCsvMsg, $author$project$Components$ExportCsv$button)
														]))
												]))
										]),
									A2($elm$core$List$concatMap, $author$project$Components$Upload$Result$viewUploadRow, list),
									_List_Nil),
									A2(
									$author$project$Ui$Panel$footer,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Upload$Result$PaginationMsg,
											A2($author$project$Api$Pagination$view, _List_Nil, model.afy))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()))
			]);
	});
var $author$project$Components$Upload$Result$viewModalBody = F3(
	function (apiClient, model, upload) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Upload$Result$finishProcessing(upload),
			model.tu);
		if (_v0.a && (_v0.b.$ === 3)) {
			var _v1 = _v0.b;
			var uploadRows = _v1.a;
			return A2(
				$elm$core$List$cons,
				A3($author$project$Components$Upload$Result$viewExportToCsvModal, apiClient, upload, model),
				A2($author$project$Components$Upload$Result$failed, upload, uploadRows) ? A2($author$project$Components$Upload$Result$viewUploadErrors, model, upload) : _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$success,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Your file was uploaded successfully.'),
								function () {
								var _v2 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
								if (_v2.$ === 3) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Export results: '),
												A2($elm$html$Html$map, $author$project$Components$Upload$Result$ExportCsvMsg, $author$project$Components$ExportCsv$button)
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]));
		} else {
			return _List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					$elm$html$Html$text('Your upload is processing and may take a few minutes.'),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					($author$project$Api$Provider$Upload$One$rowsTotal(upload) > 0) ? $elm$html$Html$text(
					'Processed ' + (A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Api$Provider$Upload$One$rowsProcessedOrIgnored)(upload) + (' out of ' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Api$Provider$Upload$One$rowsTotal)(upload)))) : $author$project$Utils$Html$empty
				]);
		}
	});
var $author$project$Components$Upload$Result$modal = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Upload$Result$ModalClosed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							function () {
							var _v0 = model.DB;
							if (_v0.$ === 3) {
								var upload = _v0.a;
								return $author$project$Ui$Modal$title(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Upload$One$name(upload)));
							} else {
								return $author$project$Ui$Spinner$view(_List_Nil);
							}
						}()
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							function () {
								var _v1 = model.DB;
								if (_v1.$ === 3) {
									var upload = _v1.a;
									return A3($author$project$Components$Upload$Result$viewModalBody, apiClient, model, upload);
								} else {
									return _List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]);
								}
							}())
						]))
				]));
	});
var $author$project$Components$Upload$CannotUploadModal$view = function (onClose) {
	return A3(
		$author$project$Ui$Modal$view,
		onClose,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('There is an upload currently in process. Please wait for it to be done before starting another.')
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Understood'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(onClose)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('OK')
							]))
					]))
			]));
};
var $author$project$Components$Upload$Form$modal = F2(
	function (apiClient, model) {
		var _v0 = _Utils_Tuple2(model.oh, model.ha);
		if (!_v0.b.$) {
			var uploadResult = _v0.b.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$Upload$Form$UploadResultMsg,
				A2($author$project$Components$Upload$Result$modal, apiClient, uploadResult));
		} else {
			if (_v0.a) {
				return $author$project$Components$Upload$CannotUploadModal$view($author$project$Components$Upload$Form$CloseCannotUploadModal);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Pages$Admin$ChargeItems$Upload$DeleteAllCharges = {$: 1};
var $author$project$Ui$Icon$Remove = 2;
var $author$project$Ui$Form$File$Csv = 1;
var $author$project$Components$Upload$Form$FileUploaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Upload$Resource$Membership = 5;
var $author$project$Api$Provider$Upload$Column$columns = function (_v0) {
	var uploadColumns = _v0;
	return uploadColumns.Ll;
};
var $author$project$Ui$Form$File$Disabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$File$disabled = $author$project$Ui$Form$File$Disabled;
var $author$project$Ui$Form$File$Empty = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$File$empty = $author$project$Ui$Form$File$Empty;
var $author$project$Api$Provider$Upload$templatePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['template']),
	$author$project$Api$Provider$Upload$uploadsPath($author$project$Api$Data$providerPath));
var $author$project$Components$Upload$Form$exportCsvPath = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Data$downloadUrl,
			apiClient,
			$author$project$Api$Provider$Upload$templatePath,
			0,
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'type',
					$author$project$Api$Upload$Resource$toString(model.G0))
				]));
	});
var $author$project$Api$Provider$Upload$Column$ignoredColumns = function (_v0) {
	var uploadColumns = _v0;
	return uploadColumns.QL;
};
var $author$project$Api$Provider$Upload$Column$columnAliases = function (_v0) {
	var column = _v0;
	return column.IO;
};
var $author$project$Api$Provider$Upload$Column$columnAllowedValues = function (_v0) {
	var column = _v0;
	return column.I$;
};
var $author$project$Api$Provider$Upload$Column$columnDefault = function (_v0) {
	var column = _v0;
	return column.M5;
};
var $author$project$Api$Provider$Upload$Column$columnHelp = function (_v0) {
	var column = _v0;
	return column.Qm;
};
var $author$project$Api$Provider$Upload$Column$columnName = function (_v0) {
	var column = _v0;
	return column.zh;
};
var $author$project$Api$Provider$Upload$Column$columnRequired = function (_v0) {
	var column = _v0;
	return column.agk;
};
var $author$project$Ui$Typography$em = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$em,
			$author$project$Ui$Typography$optionsToAttributes(options),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($elm$core$Basics$never),
				content));
	});
var $author$project$Components$Upload$Form$formatAliases = function (column) {
	return A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			function (columnAlias) {
				return '\"' + (columnAlias + '\"');
			},
			$author$project$Api$Provider$Upload$Column$columnAliases(column)));
};
var $author$project$Components$Upload$Form$viewColumn = function (column) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Upload$Column$columnName(column)),
				$author$project$Api$Provider$Upload$Column$columnRequired(column) ? A2(
				$author$project$Ui$Typography$em,
				_List_fromArray(
					[$author$project$Ui$Typography$danger, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text(' * required')
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v0 = $author$project$Api$Provider$Upload$Column$columnAllowedValues(column);
				if (!_v0.$) {
					var allowedValues = _v0.a;
					return A2(
						$author$project$Ui$Typography$em,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text(allowedValues)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = $author$project$Api$Provider$Upload$Column$columnDefault(column);
				if (!_v1.$) {
					var _default = _v1.a;
					return A2(
						$author$project$Ui$Typography$em,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text(' Default: ' + _default)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$elm$core$List$isEmpty(
				$author$project$Api$Provider$Upload$Column$columnAliases(column)) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Typography$em,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						' Aliases: ' + $author$project$Components$Upload$Form$formatAliases(column))
					])),
				function () {
				var _v2 = $author$project$Api$Provider$Upload$Column$columnHelp(column);
				if (!_v2.$) {
					var help = _v2.a;
					return A3(
						$author$project$Ui$Tooltip$view,
						_List_Nil,
						help,
						_List_fromArray(
							[
								$author$project$Utils$Html$noBreakSpace,
								A2($author$project$Ui$Icon$view, _List_Nil, 5)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Upload$Form$ToggleIgnored = {$: 1};
var $author$project$Components$Upload$Form$viewIgnoredColumns = F2(
	function (showIgnored, ignoredColumns) {
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Click'),
					$author$project$Utils$Html$noBreakSpace,
					A3(
					$author$project$Ui$Button$view,
					{abp: 'see list of extra columns accepted'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$onClick($author$project$Components$Upload$Form$ToggleIgnored)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text('to see the list of extra columns that are accepted but its value will be ignored.'),
					showIgnored ? A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (ignoredColumn) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(ignoredColumn)
									]));
						},
						ignoredColumns)) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Upload$Form$ViewUploadResult = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Common$Upload$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Upload$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Upload$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$name(shared);
};
var $author$project$Components$Upload$Form$viewPendingUpload = F2(
	function (timeFormatter, pendingUpload) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$Upload$All$name(pendingUpload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								timeFormatter,
								0,
								$author$project$Api$Provider$Upload$All$createdAt(pendingUpload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'View progress'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$onClick(
									$author$project$Components$Upload$Form$ViewUploadResult(pendingUpload))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Progress')
								]))
						]))
				]));
	});
var $author$project$Components$Upload$Form$viewPendingUploads = F2(
	function (timeFormatter, pendingUploads) {
		if (pendingUploads.$ === 3) {
			var pendingUploads_ = pendingUploads.a;
			return $elm$core$List$isEmpty(pendingUploads_) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pending uploads')
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('File Name')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Uploaded at')
									])),
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Upload$Form$viewPendingUpload(timeFormatter),
							pendingUploads_),
						_List_Nil)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Upload$Form$view = F2(
	function (apiClient, model) {
		var _v0 = model.DC;
		if (_v0.$ === 3) {
			var uploadColumns = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Step 2. Create a CSV file.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('It should include these exact headers:')
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Components$Upload$Form$viewColumn,
							$author$project$Api$Provider$Upload$Column$columns(uploadColumns))),
						$elm$core$List$isEmpty(
						$author$project$Api$Provider$Upload$Column$ignoredColumns(uploadColumns)) ? $author$project$Utils$Html$empty : A2(
						$author$project$Components$Upload$Form$viewIgnoredColumns,
						model.sO,
						$author$project$Api$Provider$Upload$Column$ignoredColumns(uploadColumns)),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Get started with our ready-to-go template'),
								$author$project$Utils$Html$noBreakSpace,
								(model.G0 === 5) ? A3(
								$author$project$Ui$Link$externalHref,
								'https://docs.google.com/spreadsheets/d/1gOlyMYkKwCRuI682gvS2Z8VJq9LdChM_px-4g28MXZs/edit?gid=2103379914',
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text('here.')
									])) : A2(
								$elm$html$Html$map,
								$author$project$Components$Upload$Form$ExportFileMsg,
								A3(
									$author$project$Components$FileLink$view,
									{
										K1: apiClient,
										PE: 0,
										aav: A2($author$project$Components$Upload$Form$exportCsvPath, apiClient, model)
									},
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('here.')
										])))
							])),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Step 3. Upload the file.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								model.vU ? $elm$html$Html$text('Don\'t worry, once it\'s uploaded you\'ll be able to fix any errors.') : $elm$html$Html$text('There is an upload in process. Uploading will be available when it is complete.')
							])),
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(false)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Form$File$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$File$disabled(!model.vU),
												$author$project$Ui$Form$File$accept(1),
												$author$project$Ui$Form$File$onInput($author$project$Components$Upload$Form$FileUploaded),
												$author$project$Ui$Form$File$empty(true)
											]))
									]))
							])),
						A2($author$project$Components$Upload$Form$viewPendingUploads, model.Hy, model.AM)
					]));
		} else {
			return $author$project$Ui$Spinner$view(_List_Nil);
		}
	});
var $author$project$Pages$Admin$ChargeItems$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$titleWithButton,
						_List_fromArray(
							[
								$elm$html$Html$text('Upload Charge Items')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$pull(1)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 2)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						(!A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.WF)) ? A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Want to Start Over?')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Click the button below to remove existing charge items.')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Delete all charge items'},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$ChargeItems$Upload$DeleteAllCharges)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete All Charge Items')
									]))
							])) : $author$project$Utils$Html$empty,
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg,
						A2($author$project$Components$Upload$Form$view, model.D5, model.PB))
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
						_List_fromArray(
							[$author$project$Ui$Link$buttonDefault]),
						_List_fromArray(
							[
								$elm$html$Html$text('Back')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$ChargeItems$Upload$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				model.lP ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$ChargeItems$Upload$HiConfirmChargesClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('Delete All Charges'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Warning: ')
									])),
								$elm$html$Html$text('this will delete all the charges from the practice.')
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg,
				A2($author$project$Components$Upload$Form$modal, model.D5, model.PB)),
				$author$project$Pages$Admin$ChargeItems$Upload$viewBody(model)
			]),
		$G: 'Admin | Charge Items'
	};
};
var $author$project$Pages$Admin$ChargeItems$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$ChargeItems$Upload$init, aer: $author$project$Pages$Admin$ChargeItems$Upload$load, agD: $author$project$Pages$Admin$ChargeItems$Upload$save, ahd: $author$project$Pages$Admin$ChargeItems$Upload$subscriptions, aaq: $author$project$Pages$Admin$ChargeItems$Upload$update, ahP: $author$project$Pages$Admin$ChargeItems$Upload$view});
var $author$project$Pages$Admin$Commissions$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{D5: shared.D5, WF: practice, ZD: session},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Commissions$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Commissions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Commissions$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Commissions$GotPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Practice$enableCommissions = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['enable_commissions']),
					$author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Commissions$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$enableCommissions, model.D5, $author$project$Pages$Admin$Commissions$GotPractice),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WF: practice}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Commissions successfully enabled'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$open(model.ZD),
					_List_Nil);
		}
	});
var $author$project$Formatters$Date$MonthAndYear = {$: 2};
var $author$project$Api$Provider$Practice$One$commissionsEnabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lo;
	});
var $author$project$Api$Provider$Practice$One$commissionsTrackingFrom = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lp;
	});
var $author$project$Api$Feature$CommissionsTracking = 0;
var $author$project$Pages$Admin$Commissions$Enable = {$: 0};
var $author$project$Pages$Admin$Commissions$ShowSupportChat = {$: 2};
var $author$project$Pages$Admin$Commissions$viewEnableForm = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$horizontal,
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Commissions$Enable)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Once enabled, We will allow a broker to be associated with a retail membership and/or employers. '),
									$elm$html$Html$text('Commissions will be automatically calculated for these relationships.')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Enable commissions'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$disabled(
									!A2($author$project$Api$Provider$Practice$One$featureEnabled, 0, model.WF))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Enable commissions')
								])),
							A2($author$project$Api$Provider$Practice$One$featureEnabled, 0, model.WF) ? $author$project$Utils$Html$empty : A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Commissions is not yet available for your account, please '),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'contact us'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick($author$project$Pages$Admin$Commissions$ShowSupportChat)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('contact us')
												])),
											$elm$html$Html$text(' to learn more.')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Commissions$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$author$project$Api$Provider$Practice$One$commissionsEnabled(model.WF) ? $elm$html$Html$text('Commissions set-up') : $elm$html$Html$text('Enable commissions for this practice')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Api$Provider$Practice$One$commissionsEnabled(model.WF) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8),
										$author$project$Ui$Form$Group$label('Commission Status')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Tracking started in '),
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2(
														$elm$core$Maybe$map,
														$author$project$Formatters$Date$toString($author$project$Formatters$Date$MonthAndYear),
														$author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.WF))))
											]))
									]))
							]) : $author$project$Pages$Admin$Commissions$viewEnableForm(model))
					]))
			]),
		$G: 'Admin | Commissions'
	};
};
var $author$project$Pages$Admin$Commissions$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Commissions$init, aer: $author$project$Pages$Admin$Commissions$load, agD: $author$project$Pages$Admin$Commissions$save, ahd: $author$project$Pages$Admin$Commissions$subscriptions, aaq: $author$project$Pages$Admin$Commissions$update, ahP: $author$project$Pages$Admin$Commissions$view});
var $author$project$Components$Plan$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Feature$TobaccoSurcharge = 2;
var $author$project$Api$Provider$Plan$CoveragePlan = 1;
var $author$project$Components$Plan$Form$GotItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$McePricing = 2;
var $author$project$Api$Provider$Plan$One$Plan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$Shared$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Plan$Shared$Record = function (id) {
	return function (name) {
		return function (_default) {
			return function (buyable) {
				return function (addon) {
					return function (activeMembershipPatientsCount) {
						return function (activeCompaniesCount) {
							return function (planType) {
								return function (allowedBillingPeriodCodes) {
									return function (defaultPeriodInMonths) {
										return function (groupPricingType) {
											return function (groupDiscountRules) {
												return function (tobaccoSurchargeType) {
													return function (tobaccoSurchargeInCents) {
														return function (tobaccoSurchargePercentage) {
															return function (billsAtEndOfPeriod) {
																return function (maximumAge) {
																	return function (minimumAge) {
																		return function (isMcePlan) {
																			return function (minimumEnrollmentPeriodInMonths) {
																				return function (isDestroyable) {
																					return function (ageRateRules) {
																						return function (individualRateRule) {
																							return function (coupleRateRule) {
																								return function (singleParentWithSingleChildRateRuleEnabled) {
																									return function (singleParentWithSingleChildRateRule) {
																										return function (singleParentRateRule) {
																											return function (familyWithSingleChildRateRuleEnabled) {
																												return function (familyWithSingleChildRateRule) {
																													return function (additionalAdultRateRule) {
																														return function (additionalChildRateRule) {
																															return function (familyRateRule) {
																																return function (discountRules) {
																																	return function (coupleDiscountRule) {
																																		return function (singleParentDiscountRule) {
																																			return function (familyDiscountRule) {
																																				return function (additionalAdultDiscountRule) {
																																					return function (additionalChildDiscountRule) {
																																						return function (childrenOnlyDiscountRule) {
																																							return function (specialRates) {
																																								return function (pricingFrom) {
																																									return function (sponsorFeeDeal) {
																																										return function (coveragePlan) {
																																											return function (imageUrl) {
																																												return {Id: activeCompaniesCount, Ig: activeMembershipPatientsCount, tJ: additionalAdultDiscountRule, Io: additionalAdultRateRule, tK: additionalChildDiscountRule, Ip: additionalChildRateRule, Iq: addon, IL: ageRateRules, D1: allowedBillingPeriodCodes, J0: billsAtEndOfPeriod, Kh: buyable, v4: childrenOnlyDiscountRule, wQ: coupleDiscountRule, L$: coupleRateRule, L5: coveragePlan, M5: _default, Ng: defaultPeriodInMonths, NL: discountRules, xA: familyDiscountRule, O7: familyRateRule, O9: familyWithSingleChildRateRule, Pa: familyWithSingleChildRateRuleEnabled, PW: groupDiscountRules, P_: groupPricingType, adR: id, QN: imageUrl, QU: individualRateRule, RJ: isDestroyable, RR: isMcePlan, Tu: maximumAge, T1: minimumAge, T3: minimumEnrollmentPeriodInMonths, zh: name, Wp: planType, W1: pricingFrom, Cn: singleParentDiscountRule, Z8: singleParentRateRule, _a: singleParentWithSingleChildRateRule, _b: singleParentWithSingleChildRateRuleEnabled, _o: specialRates, _u: sponsorFeeDeal, $M: tobaccoSurchargeInCents, $N: tobaccoSurchargePercentage, $O: tobaccoSurchargeType};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$PlanType$AffiliateDependable = 4;
var $author$project$Api$PlanType$Company = 0;
var $author$project$Api$PlanType$Mce = 3;
var $author$project$Api$PlanType$Retail = 2;
var $author$project$Api$PlanType$SponsorFixedFee = 1;
var $author$project$Api$PlanType$decodePlanType = function (string) {
	switch (string) {
		case 'company':
			return $elm$json$Json$Decode$succeed(0);
		case 'sponsor_fixed_fee':
			return $elm$json$Json$Decode$succeed(1);
		case 'retail':
			return $elm$json$Json$Decode$succeed(2);
		case 'mce':
			return $elm$json$Json$Decode$succeed(3);
		case 'affiliate_dependable':
			return $elm$json$Json$Decode$succeed(4);
		default:
			return $elm$json$Json$Decode$fail('Unsupported plan type: ' + string);
	}
};
var $author$project$Api$PlanType$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$PlanType$decodePlanType, $elm$json$Json$Decode$string);
var $author$project$Api$Provider$CoveragePlan$One$CoveragePlan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CoveragePlan$Shared$CoveragePlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveragePlan$Shared$Record = F3(
	function (id, name, coverageRules) {
		return {acd: coverageRules, adR: id, zh: name};
	});
var $author$project$Api$Provider$CoverageRule$One$CoverageRule = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CoverageRule$Shared$CoverageRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageRule$Shared$Record = function (id) {
	return function (ruleType) {
		return function (amountInCents) {
			return function (timePeriod) {
				return function (quantity) {
					return function (percentage) {
						return function (patientContributionPercentage) {
							return function (sponsorContributionPercentage) {
								return function (item) {
									return function (published) {
										return function (category) {
											return {I2: amountInCents, Ex: category, adR: id, FU: item, afD: patientContributionPercentage, afJ: percentage, Xo: published, Bd: quantity, agA: ruleType, ag4: sponsorContributionPercentage, aht: timePeriod};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CoverageRule$Shared$Category = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CoverageRule$Shared$categoryDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Category$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$Category));
var $author$project$Api$Provider$CoverageRule$Shared$ChargeItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CoverageRule$Shared$chargeItemDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$ChargeItem));
var $author$project$Api$Provider$Category$Min$Category = $elm$core$Basics$identity;
var $author$project$Api$Provider$Category$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Category$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$Min$Record)));
var $author$project$Api$Provider$Category$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Category$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'category',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'published',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'item',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[$author$project$Api$Provider$CoverageRule$Shared$chargeItemDecoder, $author$project$Api$Provider$CoverageRule$Shared$categoryDecoder])),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsor_contribution_percentage',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patient_contribution_percentage',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'percentage',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'quantity',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'time_period',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'amount_in_cents',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'rule_type',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$Record))))))))))));
var $author$project$Api$Provider$CoverageRule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageRule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRule$One$Record = function (unpublishedRule) {
	return {HI: unpublishedRule};
};
var $author$project$Api$Provider$CoverageRule$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'unpublished_rule',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CoverageRule$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$One$Record));
var $author$project$Api$Provider$CoverageRule$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageRule$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CoverageRule$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$One$CoverageRule)));
var $author$project$Api$Provider$CoveragePlan$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coverage_rules',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CoverageRule$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$Shared$Record))));
var $author$project$Api$Provider$CoveragePlan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveragePlan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoveragePlan$One$Record = F2(
	function (plans, coverageDocuments) {
		return {L4: coverageDocuments, Wq: plans};
	});
var $author$project$Api$Provider$CoverageDocument$Shared$CoverageDocument = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageDocument$Shared$Record = F3(
	function (id, fileName, url) {
		return {Pm: fileName, adR: id, aav: url};
	});
var $author$project$Api$Provider$CoverageDocument$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'file_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageDocument$Shared$Record))));
var $author$project$Api$Provider$CoverageDocument$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageDocument$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$Min$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Plan$Min$Record = F5(
	function (id, maximumAge, minimumAge, name, tobaccoSurchargeType) {
		return {adR: id, Tu: maximumAge, T1: minimumAge, zh: name, $O: tobaccoSurchargeType};
	});
var $author$project$Api$Provider$Plan$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tobacco_surcharge_type',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'minimum_age',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'maximum_age',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Min$Record))))));
var $author$project$Api$Provider$Plan$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Plan$Min$recordDecoder);
var $author$project$Api$Provider$CoveragePlan$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'coverage_documents',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CoverageDocument$Shared$decoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plans',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Plan$Min$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$One$Record)));
var $author$project$Api$Provider$CoveragePlan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveragePlan$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CoveragePlan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$One$CoveragePlan)));
var $author$project$Api$Provider$DiscountRule$Shared$DiscountRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$DiscountRule$Shared$Record = function (fromSize) {
	return function (toSize) {
		return function (calculatedBy) {
			return function (monthMaximumInCents) {
				return function (monthMaximumInCentsEdited) {
					return function (quarterMaximumInCents) {
						return function (quarterMaximumInCentsEdited) {
							return function (semiAnnualMaximumInCents) {
								return function (semiAnnualMaximumInCentsEdited) {
									return function (annualMaximumInCents) {
										return function (annualMaximumInCentsEdited) {
											return function (monthAmountOffInCents) {
												return function (monthAmountOffInCentsEdited) {
													return function (quarterAmountOffInCents) {
														return function (quarterAmountOffInCentsEdited) {
															return function (semiAnnualAmountOffInCents) {
																return function (semiAnnualAmountOffInCentsEdited) {
																	return function (annualAmountOffInCents) {
																		return function (annualAmountOffInCentsEdited) {
																			return function (monthPercentOff) {
																				return function (monthPercentOffEdited) {
																					return function (quarterPercentOff) {
																						return function (quarterPercentOffEdited) {
																							return function (semiAnnualPercentOff) {
																								return function (semiAnnualPercentOffEdited) {
																									return function (annualPercentOff) {
																										return function (annualPercentOffEdited) {
																											return {I7: annualAmountOffInCents, I8: annualAmountOffInCentsEdited, I9: annualMaximumInCents, Ja: annualMaximumInCentsEdited, Jd: annualPercentOff, Je: annualPercentOffEdited, Km: calculatedBy, PJ: fromSize, T9: monthAmountOffInCents, Ua: monthAmountOffInCentsEdited, Ub: monthMaximumInCents, Uc: monthMaximumInCentsEdited, Ug: monthPercentOff, Uh: monthPercentOffEdited, Xy: quarterAmountOffInCents, Xz: quarterAmountOffInCentsEdited, XA: quarterMaximumInCents, XB: quarterMaximumInCentsEdited, XE: quarterPercentOff, XF: quarterPercentOffEdited, Zl: semiAnnualAmountOffInCents, Zm: semiAnnualAmountOffInCentsEdited, Zn: semiAnnualMaximumInCents, Zo: semiAnnualMaximumInCentsEdited, Zr: semiAnnualPercentOff, Zs: semiAnnualPercentOffEdited, $K: toSize};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$DiscountRule$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'annual_percent_off_edited',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'annual_percent_off',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'semi_annual_percent_off_edited',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'semi_annual_percent_off',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'quarter_percent_off_edited',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'quarter_percent_off',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'month_percent_off_edited',
							$elm$json$Json$Decode$bool,
							false,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'month_percent_off',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'annual_amount_off_in_cents_edited',
									$elm$json$Json$Decode$bool,
									false,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'annual_amount_off_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'semi_annual_amount_off_in_cents_edited',
											$elm$json$Json$Decode$bool,
											false,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'semi_annual_amount_off_in_cents',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'quarter_amount_off_in_cents_edited',
													$elm$json$Json$Decode$bool,
													false,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'quarter_amount_off_in_cents',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'month_amount_off_in_cents_edited',
															$elm$json$Json$Decode$bool,
															false,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'month_amount_off_in_cents',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'annual_maximum_in_cents_edited',
																	$elm$json$Json$Decode$bool,
																	false,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'annual_maximum_in_cents',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'semi_annual_maximum_in_cents_edited',
																			$elm$json$Json$Decode$bool,
																			false,
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'semi_annual_maximum_in_cents',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																				$elm$core$Maybe$Nothing,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'quarter_maximum_in_cents_edited',
																					$elm$json$Json$Decode$bool,
																					false,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'quarter_maximum_in_cents',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																						$elm$core$Maybe$Nothing,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'month_maximum_in_cents_edited',
																							$elm$json$Json$Decode$bool,
																							false,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'month_maximum_in_cents',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																								$elm$core$Maybe$Nothing,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'calculated_by',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'to_size',
																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'from_size',
																											$elm$json$Json$Decode$int,
																											$elm$json$Json$Decode$succeed($author$project$Api$Provider$DiscountRule$Shared$Record))))))))))))))))))))))))))));
var $author$project$Api$Provider$DiscountRule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DiscountRule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$RateRule$Shared$RateRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$RateRule$Shared$Record = F6(
	function (type_, fromAge, toAge, unit, periodRates, coupleAgeRateRule) {
		return {L_: coupleAgeRateRule, PH: fromAge, c7: periodRates, $I: toAge, ahI: type_, aai: unit};
	});
var $author$project$Api$Provider$RateRule$Shared$CoupleAgeRateRule = function (periodRates) {
	return {c7: periodRates};
};
var $author$project$Api$Provider$RateRule$Shared$PeriodRates = F8(
	function (monthAmountInCents, monthAmountInCentsEdited, quarterAmountInCents, quarterAmountInCentsEdited, semiAnnualAmountInCents, semiAnnualAmountInCentsEdited, annualAmountInCents, annualAmountInCentsEdited) {
		return {I5: annualAmountInCents, e_: annualAmountInCentsEdited, T8: monthAmountInCents, f5: monthAmountInCentsEdited, Xw: quarterAmountInCents, gr: quarterAmountInCentsEdited, Zj: semiAnnualAmountInCents, gG: semiAnnualAmountInCentsEdited};
	});
var $author$project$Api$Provider$RateRule$Shared$periodRatesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'annual_amount_in_cents_edited',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'annual_amount_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'semi_annual_amount_in_cents_edited',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'semi_annual_amount_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quarter_amount_in_cents_edited',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'quarter_amount_in_cents',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'month_amount_in_cents_edited',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'month_amount_in_cents',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$PeriodRates)))))))));
var $author$project$Api$Provider$RateRule$Shared$coupleAgeRateRuleDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RateRule$Shared$periodRatesDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$CoupleAgeRateRule));
var $author$project$Api$RateRuleType$AdditionalAdult = {$: 6};
var $author$project$Api$RateRuleType$AdditionalChild = {$: 7};
var $author$project$Api$RateRuleType$AgeBased = {$: 8};
var $author$project$Api$RateRuleType$AgeBasedCouple = {$: 9};
var $author$project$Api$RateRuleType$Couple = {$: 1};
var $author$project$Api$RateRuleType$Family = {$: 3};
var $author$project$Api$RateRuleType$FamilyWithSingleChild = {$: 5};
var $author$project$Api$RateRuleType$Individual = {$: 0};
var $author$project$Api$RateRuleType$SingleParent = {$: 2};
var $author$project$Api$RateRuleType$SingleParentWithSingleChild = {$: 4};
var $author$project$Api$RateRuleType$Unknown = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$RateRuleType$decode = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		switch (string) {
			case 'individual':
				return $author$project$Api$RateRuleType$Individual;
			case 'couple':
				return $author$project$Api$RateRuleType$Couple;
			case 'single_parent':
				return $author$project$Api$RateRuleType$SingleParent;
			case 'family':
				return $author$project$Api$RateRuleType$Family;
			case 'single_parent_with_single_child':
				return $author$project$Api$RateRuleType$SingleParentWithSingleChild;
			case 'family_with_single_child':
				return $author$project$Api$RateRuleType$FamilyWithSingleChild;
			case 'additional_adult':
				return $author$project$Api$RateRuleType$AdditionalAdult;
			case 'additional_child':
				return $author$project$Api$RateRuleType$AdditionalChild;
			case 'age_based':
				return $author$project$Api$RateRuleType$AgeBased;
			case 'age_based_couple':
				return $author$project$Api$RateRuleType$AgeBasedCouple;
			default:
				var somethingElse = string;
				return $author$project$Api$RateRuleType$Unknown(somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$RateRule$Shared$Months = 1;
var $author$project$Api$Provider$RateRule$Shared$Years = 0;
var $author$project$Api$Provider$RateRule$Shared$stringToUnit = function (str) {
	switch (str) {
		case 'years':
			return 0;
		case 'months':
			return 1;
		default:
			return 0;
	}
};
var $author$project$Api$Provider$RateRule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'couple_age_rate',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$coupleAgeRateRuleDecoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$RateRule$Shared$periodRatesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'unit',
			A2($elm$json$Json$Decode$map, $author$project$Api$Provider$RateRule$Shared$stringToUnit, $elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'to_age',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'from_age',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$author$project$Api$RateRuleType$decode,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$Record)))))));
var $author$project$Api$Provider$RateRule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RateRule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SpecialRate$Shared$SpecialRate = $elm$core$Basics$identity;
var $author$project$Api$Provider$SpecialRate$Shared$Record = function (id) {
	return function (name) {
		return function (monthAmountInCents) {
			return function (monthAmountInCentsEdited) {
				return function (quarterAmountInCents) {
					return function (quarterAmountInCentsEdited) {
						return function (semiAnnualAmountInCents) {
							return function (semiAnnualAmountInCentsEdited) {
								return function (annualAmountInCents) {
									return function (annualAmountInCentsEdited) {
										return function (isDestroyable) {
											return {I5: annualAmountInCents, e_: annualAmountInCentsEdited, adR: id, RJ: isDestroyable, T8: monthAmountInCents, f5: monthAmountInCentsEdited, zh: name, Xw: quarterAmountInCents, gr: quarterAmountInCentsEdited, Zj: semiAnnualAmountInCents, gG: semiAnnualAmountInCentsEdited};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$SpecialRate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_destroyable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'annual_amount_in_cents_edited',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'annual_amount_in_cents',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'semi_annual_amount_in_cents',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'quarter_amount_in_cents_edited',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'quarter_amount_in_cents',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'month_amount_in_cents_edited',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'month_amount_in_cents',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$SpecialRate$Shared$Record))))))))))));
var $author$project$Api$Provider$SpecialRate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SpecialRate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SponsorFeeDeal$Shared$SponsorFeeDeal = $elm$core$Basics$identity;
var $author$project$Api$Provider$SponsorFeeDeal$Shared$Record = function (amountInCents) {
	return {I2: amountInCents};
};
var $author$project$Api$Provider$SponsorFeeDeal$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$SponsorFeeDeal$Shared$Record));
var $author$project$Api$Provider$SponsorFeeDeal$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SponsorFeeDeal$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$author$project$Api$Expandable$expandable,
		'coverage_plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'sponsor_fee_deal',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$SponsorFeeDeal$Shared$decoder),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'pricing_from',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingStructure$Shared$decoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'special_rates',
					$elm$json$Json$Decode$list($author$project$Api$Provider$SpecialRate$Shared$decoder),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'children_only_discount_rule',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'additional_child_discount_rule',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'additional_adult_discount_rule',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'family_discount_rule',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'single_parent_discount_rule',
										$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'couple_discount_rule',
											$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'discount_rules',
												$elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder),
												_List_Nil,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'family_rate_rule',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'additional_child_rate_rule',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'additional_adult_rate_rule',
															$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'family_with_single_child_rate_rule',
																$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																$elm$core$Maybe$Nothing,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'family_with_single_child_rate_rule_enabled',
																	$elm$json$Json$Decode$bool,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'single_parent_rate_rule',
																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'single_parent_with_single_child_rate_rule',
																			$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'single_parent_with_single_child_rate_rule_enabled',
																				$elm$json$Json$Decode$bool,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'couple_rate_rule',
																					$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																					$elm$core$Maybe$Nothing,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'individual_rate_rule',
																						$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																						$elm$core$Maybe$Nothing,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'age_rate_rules',
																							$elm$json$Json$Decode$list($author$project$Api$Provider$RateRule$Shared$decoder),
																							_List_Nil,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'is_destroyable',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'minimum_enrollment_period_in_months',
																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'is_mce_plan',
																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'minimum_age',
																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'maximum_age',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'bills_at_end_of_period',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'tobacco_surcharge_percentage',
																														$elm$json$Json$Decode$float,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'tobacco_surcharge_in_cents',
																															$elm$json$Json$Decode$int,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'tobacco_surcharge_type',
																																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																	'group_discount_rules',
																																	$elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder),
																																	_List_Nil,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'group_pricing_type',
																																		$elm$json$Json$Decode$string,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'default_period_in_months',
																																			$elm$json$Json$Decode$int,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'allowed_billing_period_codes',
																																				$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'plan_type',
																																					$author$project$Api$PlanType$decoder,
																																					A3(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																						'active_companies_count',
																																						$elm$json$Json$Decode$int,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'active_membership_patients_count',
																																							$elm$json$Json$Decode$int,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'addon',
																																								$elm$json$Json$Decode$bool,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'buyable',
																																									$elm$json$Json$Decode$bool,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'default',
																																										$elm$json$Json$Decode$bool,
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'name',
																																											$elm$json$Json$Decode$string,
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'id',
																																												$elm$json$Json$Decode$string,
																																												$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Shared$Record)))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Plan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$One$Record = function (defaultPeriod) {
	return function (maxRegistrationFeeInCents) {
		return function (individualRegistrationFeeInCents) {
			return function (defaultChargeName) {
				return function (defaultChargeDescription) {
					return function (contractExpires) {
						return function (contractPeriodInMonths) {
							return function (contractType) {
								return function (contractEmailsEnabled) {
									return function (contractRenewalEmailLeadTime) {
										return function (iua) {
											return function (monthAdjustmentPercent) {
												return function (monthAllowed) {
													return function (quarterAdjustmentPercent) {
														return function (quarterAllowed) {
															return function (semiAnnualAdjustmentPercent) {
																return function (semiAnnualAllowed) {
																	return function (annualAdjustmentPercent) {
																		return function (annualAllowed) {
																			return function (familyNumAdultsIncluded) {
																				return function (familyNumChildrenIncluded) {
																					return function (groupPricingFamilyNumChildrenIncluded) {
																						return function (numberAdditionalChildrenAllowed) {
																							return function (childrenAgeLimit) {
																								return function (splitRevenueType) {
																									return function (fixedChildrenAgeLimit) {
																										return function (appliesGroupDiscountInTiers) {
																											return function (discountsEnabled) {
																												return function (registrationFeeName) {
																													return function (registrationFeeDescription) {
																														return function (registrationFeeCategory) {
																															return function (descriptions) {
																																return function (meta) {
																																	return function (mcePricing) {
																																		return function (upcomingPricingVersion) {
																																			return function (pricingEffectivenessType) {
																																				return function (usedInScheduledPlanChanges) {
																																					return {vn: annualAdjustmentPercent, vo: annualAllowed, Jj: appliesGroupDiscountInTiers, v3: childrenAgeLimit, LO: contractEmailsEnabled, LP: contractExpires, LQ: contractPeriodInMonths, LR: contractRenewalEmailLeadTime, EI: contractType, w4: defaultChargeDescription, w5: defaultChargeName, Nf: defaultPeriod, E1: descriptions, xg: discountsEnabled, O6: familyNumAdultsIncluded, xB: familyNumChildrenIncluded, Pv: fixedChildrenAgeLimit, PZ: groupPricingFamilyNumChildrenIncluded, QW: individualRegistrationFeeInCents, So: iua, Tr: maxRegistrationFeeInCents, Ty: mcePricing, TU: meta, y9: monthAdjustmentPercent, za: monthAllowed, zC: numberAdditionalChildrenAllowed, W0: pricingEffectivenessType, Bf: quarterAdjustmentPercent, Bg: quarterAllowed, X4: registrationFeeCategory, Bp: registrationFeeDescription, Bq: registrationFeeName, B6: semiAnnualAdjustmentPercent, B7: semiAnnualAllowed, _r: splitRevenueType, aap: upcomingPricingVersion, aay: usedInScheduledPlanChanges};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$ContractType$AutoRenew = 1;
var $author$project$Api$ContractType$Terminate = 0;
var $author$project$Api$ContractType$fromString = function (string) {
	switch (string) {
		case 'terminate':
			return $elm$core$Maybe$Just(0);
		case 'auto-renew':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$ContractType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unsupported contract type: ' + string),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Api$ContractType$fromString(string)));
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$PricingEffectivenessType$Anniversary = 2;
var $author$project$Api$PricingEffectivenessType$ContractRenewal = 1;
var $author$project$Api$PricingEffectivenessType$FirstBillAfter = 0;
var $author$project$Api$PricingEffectivenessType$fromString = function (string) {
	switch (string) {
		case 'first_bill_after':
			return $elm$core$Maybe$Just(0);
		case 'contract_renewal':
			return $elm$core$Maybe$Just(1);
		case 'anniversary':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$PricingEffectivenessType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unsupported pricing effectiveness type: ' + string),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Api$PricingEffectivenessType$fromString(string)));
	},
	$elm$json$Json$Decode$string);
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $author$project$Components$TranslatedRichText$decoderWithFallback = function (fieldName) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$author$project$Components$TranslatedRichText$decoder(fieldName),
				A2(
				$elm$json$Json$Decode$map,
				function (s) {
					return A2($elm$core$Dict$singleton, 'en', s);
				},
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed($elm$core$Dict$empty)
			]));
};
var $author$project$Api$Provider$Plan$One$decodeDescriptions = $author$project$Components$TranslatedRichText$decoderWithFallback('description');
var $author$project$Api$Provider$McePricing$One$McePricing = $elm$core$Basics$identity;
var $author$project$Api$Provider$McePricing$One$Record = F4(
	function (coupleRates, familyRates, individualRates, singleParentWithChildrenRates) {
		return {L0: coupleRates, O8: familyRates, QV: individualRates, Z9: singleParentWithChildrenRates};
	});
var $author$project$Api$Provider$McePricing$One$AgeBand = F3(
	function (fromAge, toAge, priceInCents) {
		return {PH: fromAge, Ba: priceInCents, $I: toAge};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Api$Provider$McePricing$One$ageBandDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Api$Provider$McePricing$One$AgeBand,
	A2($elm$json$Json$Decode$field, 'from_age', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'to_age', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'price_in_cents', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Api$Provider$McePricing$One$recordDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Api$Provider$McePricing$One$Record,
	A2(
		$elm$json$Json$Decode$field,
		'single_parent_with_children_rates',
		$elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'family_rates',
		$elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'individual_rates',
		$elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'couple_rates',
		$elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)));
var $author$project$Api$Provider$McePricing$One$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$McePricing$One$recordDecoder);
var $author$project$Api$Provider$Plan$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Plan$Meta$MetaRecord = F6(
	function (allPeriodCodes, allowedPeriodCodes, rules, iuaOptions, allowedPeriodsInMonths, contractTypes) {
		return {IT: allPeriodCodes, IZ: allowedPeriodCodes, I_: allowedPeriodsInMonths, LS: contractTypes, Sp: iuaOptions, YY: rules};
	});
var $author$project$Api$Provider$Plan$Meta$RulesRecord = function (individualRegistrationFeeInCents) {
	return function (minimumEnrollmentPeriodInMonths) {
		return function (maxRegistrationFeeInCents) {
			return function (fixedChildrenAgeLimit) {
				return function (familyNumAdultsIncluded) {
					return function (familyNumChildrenIncluded) {
						return function (groupPricingFamilyNumChildrenIncluded) {
							return function (coupleDiscountRule) {
								return function (familyDiscountRule) {
									return function (singleParentDiscountRule) {
										return function (additionalChildDiscountRule) {
											return function (additionalAdultDiscountRule) {
												return function (childrenOnlyDiscountRule) {
													return function (numberAdditionalChildrenAllowed) {
														return function (childrenAgeLimit) {
															return {tJ: additionalAdultDiscountRule, tK: additionalChildDiscountRule, v3: childrenAgeLimit, v4: childrenOnlyDiscountRule, wQ: coupleDiscountRule, xA: familyDiscountRule, O6: familyNumAdultsIncluded, xB: familyNumChildrenIncluded, Pv: fixedChildrenAgeLimit, PZ: groupPricingFamilyNumChildrenIncluded, QW: individualRegistrationFeeInCents, Tr: maxRegistrationFeeInCents, T3: minimumEnrollmentPeriodInMonths, zC: numberAdditionalChildrenAllowed, Cn: singleParentDiscountRule};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Plan$Meta$RuleRecord = function (enabled) {
	return {Ot: enabled};
};
var $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$RuleRecord));
var $author$project$Api$Provider$Plan$Meta$rulesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'children_age_limit',
	$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number_additional_children_allowed',
		$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'children_only_discount_rule',
			$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'additional_adult_discount_rule',
				$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'additional_child_discount_rule',
					$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'single_parent_discount_rule',
						$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'family_discount_rule',
							$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'couple_discount_rule',
								$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'group_pricing_family_num_children_included',
									$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'family_num_children_included',
										$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'family_num_adults_included',
											$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'fixed_children_age_limit',
												$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'max_registration_fee_in_cents',
													$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'minimum_enrollment_period_in_months',
														$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'individual_registration_fee_in_cents',
															$author$project$Api$Provider$Plan$Meta$ruleRecordDecoder,
															$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$RulesRecord))))))))))))))));
var $author$project$Api$Provider$Plan$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contract_types',
	$elm$json$Json$Decode$list($author$project$Api$ContractType$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'allowed_periods_in_months',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'iua_options',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rules',
				$author$project$Api$Provider$Plan$Meta$rulesRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'allowed_period_codes',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'all_period_codes',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$MetaRecord)))))));
var $author$project$Api$Provider$Plan$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PricingVersion$Shared$PricingVersion = $elm$core$Basics$identity;
var $author$project$Api$Provider$PricingVersion$Shared$Record = function (id) {
	return function (appliesGroupDiscountInTiers) {
		return function (childrenAgeLimit) {
			return function (discountsEnabled) {
				return function (effectiveDate) {
					return function (familyNumAdultsIncluded) {
						return function (familyNumChildrenIncluded) {
							return function (familyWithSingleChildRateRuleEnabled) {
								return function (fixedChildrenAgeLimit) {
									return function (groupPricingFamilyNumChildrenIncluded) {
										return function (groupPricingType) {
											return function (individualRegistrationFeeInCents) {
												return function (maxRegistrationFeeInCents) {
													return function (name) {
														return function (numberAdditionalChildrenAllowed) {
															return function (registrationFeeName) {
																return function (singleParentWithSingleChildRateRuleEnabled) {
																	return function (splitRevenueType) {
																		return function (additionalAdultDiscountRule) {
																			return function (additionalChildDiscountRule) {
																				return function (ageRateRules) {
																					return function (individualRateRule) {
																						return function (coupleRateRule) {
																							return function (singleParentRateRule) {
																								return function (familyWithSingleChildRateRule) {
																									return function (additionalAdultRateRule) {
																										return function (additionalChildRateRule) {
																											return function (familyRateRule) {
																												return function (childrenOnlyDiscountRule) {
																													return function (coupleDiscountRule) {
																														return function (familyDiscountRule) {
																															return function (groupDiscountRules) {
																																return function (singleParentWithSingleChildRateRule) {
																																	return function (singleParentDiscountRule) {
																																		return function (specialRates) {
																																			return function (registrationFeeDescription) {
																																				return function (registrationFeeCategoryId) {
																																					return {tJ: additionalAdultDiscountRule, Io: additionalAdultRateRule, tK: additionalChildDiscountRule, Ip: additionalChildRateRule, IL: ageRateRules, Jj: appliesGroupDiscountInTiers, v3: childrenAgeLimit, v4: childrenOnlyDiscountRule, wQ: coupleDiscountRule, L$: coupleRateRule, xg: discountsEnabled, Od: effectiveDate, xA: familyDiscountRule, O6: familyNumAdultsIncluded, xB: familyNumChildrenIncluded, O7: familyRateRule, O9: familyWithSingleChildRateRule, Pa: familyWithSingleChildRateRuleEnabled, Pv: fixedChildrenAgeLimit, PW: groupDiscountRules, PZ: groupPricingFamilyNumChildrenIncluded, P_: groupPricingType, adR: id, QU: individualRateRule, QW: individualRegistrationFeeInCents, Tr: maxRegistrationFeeInCents, zh: name, zC: numberAdditionalChildrenAllowed, Bo: registrationFeeCategoryId, Bp: registrationFeeDescription, Bq: registrationFeeName, Cn: singleParentDiscountRule, Z8: singleParentRateRule, _a: singleParentWithSingleChildRateRule, _b: singleParentWithSingleChildRateRuleEnabled, _o: specialRates, _r: splitRevenueType};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$PricingVersion$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'registration_fee_category',
	$elm$json$Json$Decode$nullable(
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'registration_fee_description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'special_rates',
			$elm$json$Json$Decode$list($author$project$Api$Provider$SpecialRate$Shared$decoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'single_parent_discount_rule',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'single_parent_with_single_child_rate_rule',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'group_discount_rules',
						$elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'family_discount_rule',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'couple_discount_rule',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'children_only_discount_rule',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'family_rate_rule',
										$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'additional_child_rate_rule',
											$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'additional_adult_rate_rule',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'family_with_single_child_rate_rule',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
													$elm$core$Maybe$Nothing,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'single_parent_rate_rule',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
														$elm$core$Maybe$Nothing,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'couple_rate_rule',
															$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
															$elm$core$Maybe$Nothing,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'individual_rate_rule',
																$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder),
																$elm$core$Maybe$Nothing,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'age_rate_rules',
																	$elm$json$Json$Decode$list($author$project$Api$Provider$RateRule$Shared$decoder),
																	_List_Nil,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'additional_child_discount_rule',
																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
																		$elm$core$Maybe$Nothing,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'additional_adult_discount_rule',
																			$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder),
																			$elm$core$Maybe$Nothing,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'split_revenue_type',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'single_parent_with_single_child_rate_rule_enabled',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'registration_fee_name',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'number_additional_children_allowed',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'name',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'max_registration_fee_in_cents',
																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'individual_registration_fee_in_cents',
																										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'group_pricing_type',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'group_pricing_family_num_children_included',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'fixed_children_age_limit',
																													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'family_with_single_child_rate_rule_enabled',
																														$elm$json$Json$Decode$bool,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'family_num_children_included',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'family_num_adults_included',
																																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'effective_date',
																																	$author$project$Utils$Date$decode,
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'discounts_enabled',
																																		$elm$json$Json$Decode$bool,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'children_age_limit',
																																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'applies_group_discount_in_tiers',
																																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'id',
																																					$elm$json$Json$Decode$string,
																																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$Shared$Record))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$PricingVersion$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingVersion$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'used_in_scheduled_plan_changes',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'pricing_effectiveness_type',
		$author$project$Api$PricingEffectivenessType$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'upcoming_pricing_version',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingVersion$Shared$decoder),
			A3(
				$author$project$Api$Expandable$expandable,
				'mce_pricing',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$McePricing$One$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'meta',
					$author$project$Api$Provider$Plan$Meta$decoder,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
						$author$project$Api$Provider$Plan$One$decodeDescriptions,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'registration_fee_category',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'registration_fee_description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'registration_fee_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'discounts_enabled',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'applies_group_discount_in_tiers',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'fixed_children_age_limit',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'split_revenue_type',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'children_age_limit',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'number_additional_children_allowed',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'group_pricing_family_num_children_included',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'family_num_children_included',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'family_num_adults_included',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'annual_allowed',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'annual_adjustment_percent',
																				$elm$json$Json$Decode$float,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'semi_annual_allowed',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'semi_annual_adjustment_percent',
																						$elm$json$Json$Decode$float,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'quarter_allowed',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'quarter_adjustment_percent',
																								$elm$json$Json$Decode$float,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'month_allowed',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'month_adjustment_percent',
																										$elm$json$Json$Decode$float,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'iua',
																											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'contract_renewal_email_lead_time',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'contract_emails_enabled',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'contract_type',
																														$elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'contract_period_in_months',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'contract_expires',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'default_charge_description',
																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'default_charge_name',
																																		$elm$json$Json$Decode$string,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																			'individual_registration_fee_in_cents',
																																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																				'max_registration_fee_in_cents',
																																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																				A3(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																					'default_period',
																																					$elm$json$Json$Decode$string,
																																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$One$Record))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Plan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Plan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$One$Plan)));
var $author$project$Api$Provider$Plan$expandToString = function (expand) {
	switch (expand) {
		case 0:
			return 'pricing';
		case 1:
			return 'coverage_plan';
		default:
			return 'mce_pricing';
	}
};
var $author$project$Api$Provider$Plan$plansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['plans']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Plan$planPath = function (planId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[planId]),
		$author$project$Api$Provider$Plan$plansPath);
};
var $author$project$Api$Provider$Plan$retrieve = F4(
	function (apiClient, planId, expand, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Plan$planPath(planId))));
	});
var $author$project$Components$Plan$Form$fetchPlan = F3(
	function (apiClient, id, loadSubsequentPlan) {
		return A4(
			$author$project$Api$Provider$Plan$retrieve,
			apiClient,
			id,
			_List_fromArray(
				[1, 2]),
			$author$project$Components$Plan$Form$GotItem(loadSubsequentPlan));
	});
var $author$project$Components$Plan$Form$init = F9(
	function (apiClient, _v0, currentDate, session, practice, _v1, listRoute, id, settings) {
		var _v2 = $author$project$Components$DateInput$init;
		var planChangeChangeOnDateInput = _v2.a;
		var planChangeChangeOnDateInputCmd = _v2.b;
		return _Utils_Tuple2(
			{
				hj: $elm$core$Maybe$Nothing,
				hQ: $elm$core$Maybe$Nothing,
				cO: currentDate,
				fm: $elm$core$Maybe$Nothing,
				PB: $elm$core$Maybe$Nothing,
				adN: settings.adN,
				adR: id,
				FU: $author$project$Api$Data$Loading,
				F_: listRoute,
				r5: planChangeChangeOnDateInput,
				jv: false,
				gn: $elm$core$Maybe$Nothing,
				WF: practice,
				WI: settings.WI,
				afU: _Utils_Tuple2(0, $author$project$Api$Data$NotAsked),
				em: $jinjor$elm_debounce$Debounce$init,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				oq: false,
				oK: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Components$Plan$Form$fetchPlan, apiClient, id, true),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg, planChangeChangeOnDateInputCmd)
					])));
	});
var $author$project$Pages$Admin$CompanyPlans$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var timeZone = _v0.Hz;
		var currentDate = _v0.cO;
		var hinterViewOff = _v0.adN;
		var query = _v1.Bi;
		var params = _v1.Vx;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (planForm) {
				return {D5: apiClient, ny: planForm};
			},
			A9(
				$author$project$Components$Plan$Form$init,
				apiClient,
				timeZone,
				currentDate,
				session,
				practice,
				query,
				$author$project$Spa$Generated$Route$Admin__CompanyPlans__Top,
				params.adR,
				{adN: hinterViewOff, WI: false}));
	});
var $author$project$Pages$Admin$CompanyPlans$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CompanyPlans$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModalMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Plan$Form$BasicPlanFormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$Form$ConfirmUpdateModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Plan$Form$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Plan$BasicForm$DescriptionMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$subscriptions = function (_v0) {
	var form = _v0;
	var fields = $author$project$Utils$Form$fields(form);
	var _v1 = fields.cJ;
	if (!_v1.$) {
		var categoryResourceFilter = _v1.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg,
			$author$project$Components$ResourceFilter$Category$subscriptions(categoryResourceFilter));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Plan$BasicForm$subscriptions = function (_v0) {
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg,
				$author$project$Components$Plan$Form$RegistrationFeePricingFields$subscriptions(fields.c9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$BasicForm$DescriptionMsg,
				$author$project$Components$TranslatedRichText$subscriptions(fields.Nx))
			]));
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Close = {$: 1};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Plan$Form$AddCoveragePlanModal$Close);
};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$Close = {$: 2};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Plan$Form$ConfirmUpdateModal$Close);
};
var $author$project$Components$Plan$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var form = _v1.b;
						var fields = $author$project$Utils$Form$fields(form);
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Plan$Form$BasicPlanFormUpdated,
							$author$project$Components$Plan$BasicForm$subscriptions(fields.aA));
					},
					model.PB)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$Form$ConfirmUpdateModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var confirmUpdateModal = _v2.b;
							return $author$project$Components$Plan$Form$ConfirmUpdateModal$subscriptions(confirmUpdateModal);
						},
						model.hQ))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Plan$Form$AddCoveragePlanModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$subscriptions, model.hj))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Plan$Form$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fm)))
			]));
};
var $author$project$Pages$Admin$CompanyPlans$Id_String$subscriptions = function (model) {
	return $author$project$Components$Plan$Form$subscriptions(model.ny);
};
var $author$project$Components$Plan$Form$BasicPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$MembershipScheduledChange$Type$Contract = 2;
var $author$project$Components$Plan$Form$CoveragePlan = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Plan$Form$CoveragePlanAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$MembershipScheduledChange$Type$Duration = 1;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Plan$Form$GotPreview = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupPricingType = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$Form$MembershipPricingFields = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$PlanChange = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeChangeOnDate = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeToPlan = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Plan$Form$PlanDeleted = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFieldsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Plan$Form$SubsequentPlanUpdated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Plan$Form$ToggleFixedMembershipPricing = {$: 27};
var $author$project$Api$ContractType$toString = function (contractType) {
	if (!contractType) {
		return 'terminate';
	} else {
		return 'auto-renew';
	}
};
var $author$project$Api$ContractType$encode = A2($elm$core$Basics$composeR, $author$project$Api$ContractType$toString, $elm$json$Json$Encode$string);
var $author$project$Api$PricingEffectivenessType$toString = function (pricingEffectivenessType) {
	switch (pricingEffectivenessType) {
		case 0:
			return 'first_bill_after';
		case 1:
			return 'contract_renewal';
		default:
			return 'anniversary';
	}
};
var $author$project$Api$PricingEffectivenessType$encode = A2($elm$core$Basics$composeR, $author$project$Api$PricingEffectivenessType$toString, $elm$json$Json$Encode$string);
var $author$project$Percentage$toFloat = function (_v0) {
	var string = _v0;
	return $elm$core$String$toFloat(string);
};
var $author$project$Percentage$encode = A2(
	$elm$core$Basics$composeR,
	$author$project$Percentage$toFloat,
	$author$project$Utils$Encode$nullable($elm$json$Json$Encode$float));
var $author$project$Api$Provider$Plan$encodeCoupleAgeRateRuleFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'month_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.T8)),
				_Utils_Tuple2(
				'month_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.f5)),
				_Utils_Tuple2(
				'quarter_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xw)),
				_Utils_Tuple2(
				'quarter_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gr)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Zj)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gG)),
				_Utils_Tuple2(
				'annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I5)),
				_Utils_Tuple2(
				'annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.e_))
			]));
};
var $author$project$Api$Provider$RateRule$Shared$unitToString = function (unit_) {
	if (!unit_) {
		return 'years';
	} else {
		return 'months';
	}
};
var $author$project$Api$Provider$Plan$encodeAgeRateRuleFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from_age',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.PH)),
				_Utils_Tuple2(
				'to_age',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.$I)),
				_Utils_Tuple2(
				'unit',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$RateRule$Shared$unitToString(fields.aai))),
				_Utils_Tuple2(
				'month_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.T8)),
				_Utils_Tuple2(
				'month_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.f5)),
				_Utils_Tuple2(
				'quarter_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xw)),
				_Utils_Tuple2(
				'quarter_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gr)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Zj)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gG)),
				_Utils_Tuple2(
				'annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I5)),
				_Utils_Tuple2(
				'annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.e_)),
				_Utils_Tuple2(
				'couple_age_rate_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeCoupleAgeRateRuleFields, fields.L_))
			]));
};
var $author$project$Api$Provider$Plan$encodeFamilyDiscountRule = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'month_maximum_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Ub)),
				_Utils_Tuple2(
				'month_maximum_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.Uc)),
				_Utils_Tuple2(
				'quarter_maximum_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.XA)),
				_Utils_Tuple2(
				'quarter_maximum_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.XB)),
				_Utils_Tuple2(
				'semi_annual_maximum_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Zn)),
				_Utils_Tuple2(
				'semi_annual_maximum_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.Zo)),
				_Utils_Tuple2(
				'annual_maximum_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I9)),
				_Utils_Tuple2(
				'annual_maximum_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.Ja))
			]));
};
var $author$project$Api$Provider$Plan$encodeFixedRateRule = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'month_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.T8)),
				_Utils_Tuple2(
				'month_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.f5)),
				_Utils_Tuple2(
				'quarter_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xw)),
				_Utils_Tuple2(
				'quarter_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gr)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Zj)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gG)),
				_Utils_Tuple2(
				'annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I5)),
				_Utils_Tuple2(
				'annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.e_))
			]));
};
var $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'from_size',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.PJ)),
				_Utils_Tuple2(
				'to_size',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.$K)),
				_Utils_Tuple2(
				'calculated_by',
				$elm$json$Json$Encode$string(fields.Km)),
				_Utils_Tuple2(
				'month_amount_off_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.T9)),
				_Utils_Tuple2(
				'month_amount_off_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.Ua)),
				_Utils_Tuple2(
				'quarter_amount_off_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xy)),
				_Utils_Tuple2(
				'quarter_amount_off_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.Xz)),
				_Utils_Tuple2(
				'semi_annual_amount_off_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Zl)),
				_Utils_Tuple2(
				'semi_annual_amount_off_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.Zm)),
				_Utils_Tuple2(
				'annual_amount_off_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I7)),
				_Utils_Tuple2(
				'annual_amount_off_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.I8)),
				_Utils_Tuple2(
				'month_percent_off',
				A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.Ug)),
				_Utils_Tuple2(
				'month_percent_off_edited',
				$elm$json$Json$Encode$bool(fields.Uh)),
				_Utils_Tuple2(
				'quarter_percent_off',
				A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.XE)),
				_Utils_Tuple2(
				'quarter_percent_off_edited',
				$elm$json$Json$Encode$bool(fields.XF)),
				_Utils_Tuple2(
				'semi_annual_percent_off',
				A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.Zr)),
				_Utils_Tuple2(
				'semi_annual_percent_off_edited',
				$elm$json$Json$Encode$bool(fields.Zs)),
				_Utils_Tuple2(
				'annual_percent_off',
				A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.Jd)),
				_Utils_Tuple2(
				'annual_percent_off_edited',
				$elm$json$Json$Encode$bool(fields.Je))
			]));
};
var $author$project$Api$Provider$Plan$encodeSpecialRateFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adR)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(fields.zh)),
				_Utils_Tuple2(
				'month_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.T8)),
				_Utils_Tuple2(
				'month_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.f5)),
				_Utils_Tuple2(
				'quarter_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Xw)),
				_Utils_Tuple2(
				'quarter_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gr)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Zj)),
				_Utils_Tuple2(
				'semi_annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.gG)),
				_Utils_Tuple2(
				'annual_amount_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I5)),
				_Utils_Tuple2(
				'annual_amount_in_cents_edited',
				$elm$json$Json$Encode$bool(fields.e_)),
				_Utils_Tuple2(
				'_create',
				$elm$json$Json$Encode$bool(fields.Me)),
				_Utils_Tuple2(
				'_destroy',
				$elm$json$Json$Encode$bool(fields.NB))
			]));
};
var $author$project$Api$Provider$Plan$encodeUpdateFields = function (fields) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(fields.zh)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'addon',
					$elm$json$Json$Encode$bool(fields.Iq)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'buyable',
						$elm$json$Json$Encode$bool(fields.Kh)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'default_period',
							$elm$json$Json$Encode$string(fields.Nf)),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'bills_at_end_of_period',
								$elm$json$Json$Encode$bool(fields.J0)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'discounts_enabled',
									$elm$json$Json$Encode$bool(fields.xg)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'registration_fee_name',
										$elm$json$Json$Encode$string(fields.Bq)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'registration_fee_description',
											$elm$json$Json$Encode$string(fields.Bp)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'individual_registration_fee_in_cents',
												A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.QW)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'minimum_enrollment_period_in_months',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.T3)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'default_charge_name',
														$elm$json$Json$Encode$string(fields.w5)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'default_charge_description',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.w4)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'registration_fee_category',
																A2(
																	$author$project$Utils$Encode$nullable,
																	function (id) {
																		return $elm$json$Json$Encode$object(
																			_List_fromArray(
																				[
																					_Utils_Tuple2(
																					'id',
																					$elm$json$Json$Encode$string(id))
																				]));
																	},
																	fields.Bo)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'max_registration_fee_in_cents',
																	A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Tr)),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'iua',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.So)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'month_adjustment_percent',
																			$author$project$Percentage$encode(fields.y9)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'month_allowed',
																				$elm$json$Json$Encode$bool(fields.za)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'quarter_adjustment_percent',
																					$author$project$Percentage$encode(fields.Bf)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'quarter_allowed',
																						$elm$json$Json$Encode$bool(fields.Bg)),
																					A2(
																						$elm$core$List$cons,
																						_Utils_Tuple2(
																							'semi_annual_adjustment_percent',
																							$author$project$Percentage$encode(fields.B6)),
																						A2(
																							$elm$core$List$cons,
																							_Utils_Tuple2(
																								'semi_annual_allowed',
																								$elm$json$Json$Encode$bool(fields.B7)),
																							A2(
																								$elm$core$List$cons,
																								_Utils_Tuple2(
																									'annual_adjustment_percent',
																									$author$project$Percentage$encode(fields.vn)),
																								A2(
																									$elm$core$List$cons,
																									_Utils_Tuple2(
																										'annual_allowed',
																										$elm$json$Json$Encode$bool(fields.vo)),
																									A2(
																										$elm$core$List$cons,
																										_Utils_Tuple2(
																											'tobacco_surcharge_type',
																											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.$O)),
																										A2(
																											$elm$core$List$cons,
																											_Utils_Tuple2(
																												'tobacco_surcharge_percentage',
																												$author$project$Percentage$encode(fields.$N)),
																											A2(
																												$elm$core$List$cons,
																												_Utils_Tuple2(
																													'tobacco_surcharge_in_cents',
																													$author$project$Currency$encode(fields.$M)),
																												A2(
																													$elm$core$List$cons,
																													_Utils_Tuple2(
																														'contract_expires',
																														$elm$json$Json$Encode$bool(fields.LP)),
																													A2(
																														$elm$core$List$cons,
																														_Utils_Tuple2(
																															'contract_period_in_months',
																															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.LQ)),
																														A2(
																															$elm$core$List$cons,
																															_Utils_Tuple2(
																																'contract_type',
																																A2($author$project$Utils$Encode$nullable, $author$project$Api$ContractType$encode, fields.EI)),
																															A2(
																																$elm$core$List$cons,
																																_Utils_Tuple2(
																																	'contract_emails_enabled',
																																	$elm$json$Json$Encode$bool(fields.LO)),
																																A2(
																																	$elm$core$List$cons,
																																	_Utils_Tuple2(
																																		'contract_renewal_email_lead_time',
																																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.LR)),
																																	A2(
																																		$elm$core$List$cons,
																																		_Utils_Tuple2(
																																			'minimum_age',
																																			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.T1)),
																																		A2(
																																			$elm$core$List$cons,
																																			_Utils_Tuple2(
																																				'maximum_age',
																																				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Tu)),
																																			A2(
																																				$elm$core$List$cons,
																																				_Utils_Tuple2(
																																					'coverage_plan',
																																					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.L5)),
																																				A2(
																																					$elm$core$List$cons,
																																					_Utils_Tuple2(
																																						'sponsor_fee_deal',
																																						$elm$json$Json$Encode$object(
																																							_List_fromArray(
																																								[
																																									_Utils_Tuple2(
																																									'amount_in_cents',
																																									A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Hi))
																																								]))),
																																					A2(
																																						$elm$core$List$cons,
																																						_Utils_Tuple2(
																																							'age_rate_rules',
																																							A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, fields.IL)),
																																						A2(
																																							$elm$core$List$cons,
																																							_Utils_Tuple2(
																																								'group_pricing_type',
																																								$elm$json$Json$Encode$string(fields.P_)),
																																							A2(
																																								$elm$core$List$cons,
																																								_Utils_Tuple2(
																																									'fixed_children_age_limit',
																																									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Pv)),
																																								A2(
																																									$elm$core$List$cons,
																																									_Utils_Tuple2(
																																										'family_num_adults_included',
																																										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.O6)),
																																									A2(
																																										$elm$core$List$cons,
																																										_Utils_Tuple2(
																																											'family_num_children_included',
																																											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.xB)),
																																										A2(
																																											$elm$core$List$cons,
																																											_Utils_Tuple2(
																																												'group_pricing_family_num_children_included',
																																												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.PZ)),
																																											A2(
																																												$elm$core$List$cons,
																																												_Utils_Tuple2(
																																													'number_additional_children_allowed',
																																													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.zC)),
																																												A2(
																																													$elm$core$List$cons,
																																													_Utils_Tuple2(
																																														'children_age_limit',
																																														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.v3)),
																																													A2(
																																														$elm$core$List$cons,
																																														_Utils_Tuple2(
																																															'split_revenue_type',
																																															$elm$json$Json$Encode$string(fields._r)),
																																														A2(
																																															$elm$core$List$cons,
																																															_Utils_Tuple2(
																																																'applies_group_discount_in_tiers',
																																																$elm$json$Json$Encode$bool(fields.Jj)),
																																															A2(
																																																$elm$core$List$cons,
																																																_Utils_Tuple2(
																																																	'single_parent_with_single_child_rate_rule_enabled',
																																																	$elm$json$Json$Encode$bool(fields._b)),
																																																A2(
																																																	$elm$core$List$cons,
																																																	_Utils_Tuple2(
																																																		'family_with_single_child_rate_rule_enabled',
																																																		$elm$json$Json$Encode$bool(fields.Pa)),
																																																	A2(
																																																		$elm$core$List$cons,
																																																		_Utils_Tuple2(
																																																			'couple_rate_rule',
																																																			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.L$)),
																																																		A2(
																																																			$elm$core$List$cons,
																																																			_Utils_Tuple2(
																																																				'family_rate_rule',
																																																				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.O7)),
																																																			A2(
																																																				$elm$core$List$cons,
																																																				_Utils_Tuple2(
																																																					'individual_rate_rule',
																																																					A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.QU)),
																																																				A2(
																																																					$elm$core$List$cons,
																																																					_Utils_Tuple2(
																																																						'single_parent_rate_rule',
																																																						A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.Z8)),
																																																					A2(
																																																						$elm$core$List$cons,
																																																						_Utils_Tuple2(
																																																							'single_parent_with_single_child_rate_rule',
																																																							A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields._a)),
																																																						A2(
																																																							$elm$core$List$cons,
																																																							_Utils_Tuple2(
																																																								'family_with_single_child_rate_rule',
																																																								A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.O9)),
																																																							A2(
																																																								$elm$core$List$cons,
																																																								_Utils_Tuple2(
																																																									'additional_adult_rate_rule',
																																																									A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.Io)),
																																																								A2(
																																																									$elm$core$List$cons,
																																																									_Utils_Tuple2(
																																																										'additional_child_rate_rule',
																																																										A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.Ip)),
																																																									A2(
																																																										$elm$core$List$cons,
																																																										_Utils_Tuple2(
																																																											'couple_discount_rule',
																																																											A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.wQ)),
																																																										A2(
																																																											$elm$core$List$cons,
																																																											_Utils_Tuple2(
																																																												'family_discount_rule',
																																																												A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.xA)),
																																																											A2(
																																																												$elm$core$List$cons,
																																																												_Utils_Tuple2(
																																																													'single_parent_discount_rule',
																																																													A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.Cn)),
																																																												A2(
																																																													$elm$core$List$cons,
																																																													_Utils_Tuple2(
																																																														'additional_adult_discount_rule',
																																																														A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.tJ)),
																																																													A2(
																																																														$elm$core$List$cons,
																																																														_Utils_Tuple2(
																																																															'additional_child_discount_rule',
																																																															A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.tK)),
																																																														A2(
																																																															$elm$core$List$cons,
																																																															_Utils_Tuple2(
																																																																'children_only_discount_rule',
																																																																A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.v4)),
																																																															A2(
																																																																$elm$core$List$cons,
																																																																_Utils_Tuple2(
																																																																	'group_discount_rules',
																																																																	A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields, fields.PW)),
																																																																A2(
																																																																	$elm$core$List$cons,
																																																																	_Utils_Tuple2(
																																																																		'special_rates',
																																																																		A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeSpecialRateFields, fields._o)),
																																																																	A2(
																																																																		$elm$core$List$cons,
																																																																		_Utils_Tuple2(
																																																																			'description',
																																																																			$elm$json$Json$Encode$object(
																																																																				_List_fromArray(
																																																																					[
																																																																						_Utils_Tuple2(
																																																																						'en',
																																																																						A2(
																																																																							$author$project$Utils$Encode$nullable,
																																																																							$elm$json$Json$Encode$string,
																																																																							A2($elm$core$Dict$get, 'en', fields.E1))),
																																																																						_Utils_Tuple2(
																																																																						'es',
																																																																						A2(
																																																																							$author$project$Utils$Encode$nullable,
																																																																							$elm$json$Json$Encode$string,
																																																																							A2($elm$core$Dict$get, 'es', fields.E1)))
																																																																					]))),
																																																																		A2(
																																																																			$elm$core$List$cons,
																																																																			_Utils_Tuple2(
																																																																				'pricing_effectiveness_type',
																																																																				$author$project$Api$PricingEffectivenessType$encode(fields.W0)),
																																																																			function () {
																																																																				var _v0 = fields.QN;
																																																																				if (!_v0.$) {
																																																																					var url = _v0.a;
																																																																					return _List_fromArray(
																																																																						[
																																																																							_Utils_Tuple2(
																																																																							'image',
																																																																							$elm$json$Json$Encode$string(url))
																																																																						]);
																																																																				} else {
																																																																					return _List_Nil;
																																																																				}
																																																																			}()))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
};
var $author$project$Api$Data$requestWithTracker = F2(
	function (tracker, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				tn: $elm$core$Maybe$Just(tracker)
			});
	});
var $author$project$Api$Provider$Plan$calculate = F6(
	function (apiClient, expand, tracker, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'plan',
					$author$project$Api$Provider$Plan$encodeUpdateFields(fields))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithTracker,
					tracker,
					A2(
						$author$project$Api$Data$requestWithQuery,
						_List_fromArray(
							[
								A2(
								$author$project$Api$Param$list,
								'expand',
								A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
							]),
						$author$project$Api$Data$requestTo(
							A2(
								$author$project$Api$Data$pathAppend,
								_List_fromArray(
									['calculate']),
								$author$project$Api$Provider$Plan$planPath(id)))))));
	});
var $author$project$Components$Plan$Form$BasicPlanFieldValidation = {$: 10};
var $author$project$Components$Plan$BasicForm$hasErrors = function (_v0) {
	var form = _v0.b;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateBasicPlanFormFields = function (_v0) {
	var basicPlan = _v0.aA;
	return $author$project$Components$Plan$BasicForm$hasErrors(basicPlan) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$BasicPlanFieldValidation, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation = {$: 2};
var $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation = {$: 4};
var $author$project$Components$Plan$Form$ContractTypeValidation = {$: 3};
var $author$project$Api$Provider$Plan$Meta$allowedPeriodsInMonths = function (_v0) {
	var meta = _v0;
	return meta.I_;
};
var $author$project$Api$Provider$Plan$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid = F2(
	function (plan, contractPeriodInMonths) {
		var maxPeriod = $elm$core$List$maximum(
			$author$project$Api$Provider$Plan$Meta$allowedPeriodsInMonths(
				$author$project$Api$Provider$Plan$One$meta(plan)));
		var _v0 = _Utils_Tuple2(contractPeriodInMonths, maxPeriod);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var contractPeriodInMonths_ = _v0.a.a;
			var maxPeriod_ = _v0.b.a;
			return !(!(contractPeriodInMonths_ % maxPeriod_));
		} else {
			return false;
		}
	});
var $author$project$Api$Provider$Plan$Shared$isMcePlan = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.RR);
};
var $author$project$Api$Provider$Plan$One$isMcePlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$isMcePlan(shared);
};
var $author$project$Utils$Validate$isOutsideIntRange = F2(
	function (options, _int) {
		var _v0 = _Utils_Tuple3(_int, options.TZ, options.yQ);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var int_ = _v0.a.a;
					var min = _v0.b.a;
					var max = _v0.c.a;
					return (_Utils_cmp(int_, min) < 0) || (_Utils_cmp(int_, max) > 0);
				} else {
					var int_ = _v0.a.a;
					var min = _v0.b.a;
					var _v1 = _v0.c;
					return _Utils_cmp(int_, min) < 0;
				}
			} else {
				if (!_v0.c.$) {
					var int_ = _v0.a.a;
					var _v2 = _v0.b;
					var max = _v0.c.a;
					return _Utils_cmp(int_, max) > 0;
				} else {
					var _v3 = _v0.b;
					var _v4 = _v0.c;
					return false;
				}
			}
		} else {
			var _v5 = _v0.a;
			return !options.abi;
		}
	});
var $author$project$Api$Provider$Plan$Shared$planType = function (_v0) {
	var record = _v0;
	return record.Wp;
};
var $author$project$Api$Provider$Plan$One$planType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$planType(shared);
};
var $author$project$Components$Plan$Form$validateContract = F2(
	function (plan, fields) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var isMcePlan = $author$project$Api$Provider$Plan$One$isMcePlan(plan);
		var forCompany = !$author$project$Api$Provider$Plan$One$planType(plan);
		return ((planType !== 1) && ((!isMcePlan) && (!forCompany))) ? $elm$core$List$concat(
			_List_fromArray(
				[
					(fields.LP && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(48),
						TZ: $elm$core$Maybe$Just(1)
					},
					fields.LQ)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, 'Please enter a number between 1 and 48.')
					]) : ((fields.LP && A2($author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid, plan, fields.LQ)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, '')
					]) : _List_Nil),
					(fields.LP && _Utils_eq(fields.EI, $elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$ContractTypeValidation, 'Please pick an action.')
					]) : _List_Nil,
					(fields.LP && (fields.LO && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(365),
						TZ: $elm$core$Maybe$Just(1)
					},
					fields.LR))) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, 'Please enter a number between 1 and 365.')
					]) : _List_Nil
				])) : _List_Nil;
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsValidation = {$: 11};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateFamilyMembershipPricingFields = function (_v0) {
	var familyMembershipPricingForm = _v0.cU;
	return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(familyMembershipPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFieldsValidation, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Plan$Form$validatePricingRuleAmountInCents = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 999999999;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.f5) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.T8)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.gr) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xw)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.gG) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Zj)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.e_) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.I5)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil
				]));
	});
var $author$project$Percentage$isValid = F2(
	function (options, percentage) {
		var _v0 = $author$project$Percentage$toFloat(percentage);
		if (!_v0.$) {
			var _float = _v0.a;
			var _v1 = _Utils_Tuple2(options.TZ, options.yQ);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var min = _v1.a.a;
					var max = _v1.b.a;
					return !((_Utils_cmp(_float, min) < 0) || (_Utils_cmp(_float, max) > 0));
				} else {
					var min = _v1.a.a;
					var _v2 = _v1.b;
					return _Utils_cmp(_float, min) > -1;
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var max = _v1.b.a;
					return _Utils_cmp(_float, max) < 1;
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return true;
				}
			}
		} else {
			return false;
		}
	});
var $author$project$Utils$Validate$isInvalidPercentage = F2(
	function (options, percentage) {
		if (!percentage.$) {
			var percentage_ = percentage.a;
			return !A2(
				$author$project$Percentage$isValid,
				{yQ: options.yQ, TZ: options.TZ},
				percentage_);
		} else {
			return !options.abi;
		}
	});
var $author$project$Components$Plan$Form$validatePricingRulePercentage = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 100;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.Uf) && A2(
					$author$project$Utils$Validate$isInvalidPercentage,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Ue)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.XD) && A2(
					$author$project$Utils$Validate$isInvalidPercentage,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.XC)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.Zq) && A2(
					$author$project$Utils$Validate$isInvalidPercentage,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Zp)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.Jc) && A2(
					$author$project$Utils$Validate$isInvalidPercentage,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Jb)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
					]) : _List_Nil
				]));
	});
var $author$project$Components$Plan$Form$validateGroupDiscountRule = F3(
	function (defaultPeriod, index, fields) {
		var _v0 = fields.Km;
		switch (_v0) {
			case 'amount_off_in_cents':
				return A3(
					$author$project$Components$Plan$Form$validatePricingRuleAmountInCents,
					defaultPeriod,
					{I5: fields.I7, e_: fields.I8, T8: fields.T9, f5: fields.Ua, Xw: fields.Xy, gr: fields.Xz, Zj: fields.Zl, gG: fields.Zm},
					$author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation(index));
			case 'percent_off':
				return A3(
					$author$project$Components$Plan$Form$validatePricingRulePercentage,
					defaultPeriod,
					{Jb: fields.Jd, Jc: fields.Je, Ue: fields.Ug, Uf: fields.Uh, XC: fields.XE, XD: fields.XF, Zp: fields.Zr, Zq: fields.Zs},
					$author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation(index));
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$Plan$Form$validateGroupMembershipPricingFields = F3(
	function (sharedFields, plan, fields) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var isMcePlan = $author$project$Api$Provider$Plan$One$isMcePlan(plan);
		return ((planType !== 1) && ((!isMcePlan) && (fields.P_ === 'group'))) ? $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$Plan$Form$validateGroupDiscountRule(sharedFields.Nf),
				fields.PW)) : _List_Nil;
	});
var $author$project$Components$Plan$Form$GroupTierPricingFieldsValidation = {$: 13};
var $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateGroupTierPricingFields = function (_v0) {
	var groupTierPricingForm = _v0.i;
	return $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(groupTierPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFieldsValidation, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsValidation = {$: 12};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateIndividualMembershipPricingFields = function (_v0) {
	var membershipPricingForm = _v0.cX;
	return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(membershipPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$IndividualMembershipPricingFieldsValidation, '')
		]) : _List_Nil;
};
var $author$project$Api$Provider$MembershipScheduledChange$Type$Date = 0;
var $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation = {$: 5};
var $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation = {$: 6};
var $author$project$Components$Plan$Form$PlanChangeToPlanValidation = {$: 7};
var $author$project$Utils$Date$isAfter = F2(
	function (date, otherDate) {
		return A2($justinmimbs$date$Date$compare, date, otherDate) === 2;
	});
var $author$project$Utils$Date$isBefore = F2(
	function (date, otherDate) {
		return !A2($justinmimbs$date$Date$compare, date, otherDate);
	});
var $author$project$Utils$Validate$isOutsideDateRange = F2(
	function (options, date) {
		var _v0 = _Utils_Tuple3(date, options.TZ, options.yQ);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				if (!_v0.c.$) {
					var date_ = _v0.a.a;
					var min = _v0.b.a;
					var max = _v0.c.a;
					return A2($author$project$Utils$Date$isBefore, date_, min) || A2($author$project$Utils$Date$isAfter, date_, max);
				} else {
					var date_ = _v0.a.a;
					var min = _v0.b.a;
					var _v1 = _v0.c;
					return A2($author$project$Utils$Date$isBefore, date_, min);
				}
			} else {
				if (!_v0.c.$) {
					var date_ = _v0.a.a;
					var _v2 = _v0.b;
					var max = _v0.c.a;
					return A2($author$project$Utils$Date$isAfter, date_, max);
				} else {
					var _v3 = _v0.b;
					var _v4 = _v0.c;
					return false;
				}
			}
		} else {
			var _v5 = _v0.a;
			return !options.abi;
		}
	});
var $author$project$Components$Plan$Form$validatePlanChange = F3(
	function (currentDate, planChangeEnabled, _v0) {
		var planChange = _v0.ju;
		if (planChangeEnabled) {
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
			var params = planChange.Vx;
			return $elm$core$List$concat(
				_List_fromArray(
					[
						(planChange.bU && _Utils_eq(params.$J, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							_Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeToPlanValidation, 'Please pick a plan.')
						]) : _List_Nil,
						(planChange.bU && ((!params.ahI) && A2(
						$author$project$Utils$Validate$isOutsideDateRange,
						{
							abi: false,
							yQ: $elm$core$Maybe$Nothing,
							TZ: $elm$core$Maybe$Just(yesterdayDate)
						},
						params.KO))) ? _List_fromArray(
						[
							_Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, 'Please enter a date greater or equal than yesterday')
						]) : _List_Nil,
						(planChange.bU && ((params.ahI === 1) && A2(
						$author$project$Utils$Validate$isOutsideIntRange,
						{
							abi: false,
							yQ: $elm$core$Maybe$Just(48),
							TZ: $elm$core$Maybe$Just(1)
						},
						params.KN))) ? _List_fromArray(
						[
							_Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, 'Please enter a number between 1 and 48.')
						]) : _List_Nil
					]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFieldsValidation = {$: 14};
var $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$Form$validateSpecialRatesFields = function (_v0) {
	var specialRatesForm = _v0.de;
	return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Plan$Form$SpecialRatesFieldsValidation, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation = {$: 0};
var $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation = {$: 1};
var $author$project$Components$Plan$Form$validateTobaccoSurcharge = F3(
	function (tobaccoSurchargeEnabled, plan, fields) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		if ((planType !== 1) && (tobaccoSurchargeEnabled && (!_Utils_eq(fields.$O, $elm$core$Maybe$Nothing)))) {
			var percentageTobaccoSurchargeType = _Utils_eq(
				fields.$O,
				$elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(
				fields.$O,
				$elm$core$Maybe$Just('percentage_per_membership'));
			if (percentageTobaccoSurchargeType && A2(
				$author$project$Utils$Validate$isInvalidPercentage,
				{
					abi: false,
					yQ: $elm$core$Maybe$Nothing,
					TZ: $elm$core$Maybe$Just(0)
				},
				fields.$N)) {
				return _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, 'Please enter a number between 0 and 100.')
					]);
			} else {
				var minAmountInCents = 0;
				var maxAmountInCents = 999999999;
				return ((!percentageTobaccoSurchargeType) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(maxAmountInCents),
						TZ: $elm$core$Maybe$Just(minAmountInCents)
					},
					fields.$M)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation,
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(minAmountInCents) + (' and ' + ($author$project$Utils$Currency$fromInt(maxAmountInCents) + '.'))))
					]) : _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Plan$Form$formFieldsValidator = F5(
	function (sharedField, currentDate, tobaccoSurchargeEnabled, planChangeEnabled, plan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$Plan$Form$validateContract(plan)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$validatePlanChange, currentDate, planChangeEnabled)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$validateTobaccoSurcharge, tobaccoSurchargeEnabled, plan)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateIndividualMembershipPricingFields),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateGroupTierPricingFields),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateSpecialRatesFields),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$validateGroupMembershipPricingFields, sharedField, plan)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateBasicPlanFormFields),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateFamilyMembershipPricingFields)
				]));
	});
var $author$project$Components$Plan$BasicForm$formFields = function (_v0) {
	var form = _v0.b;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$initSharedFields = F2(
	function (plan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var groupPricingType = _v0.P_;
		var basicPlan = _v0.aA;
		var _v1 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		var defaultPeriod = _v1.Nf;
		return {
			Nf: defaultPeriod,
			P_: groupPricingType,
			GH: $elm$core$Maybe$Just(plan)
		};
	});
var $author$project$Components$Plan$Form$PreviewDebouncedMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Plan$Form$previewDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Plan$Form$PreviewDebouncedMsg
};
var $author$project$Components$Plan$BasicForm$BasicPlanForm = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$RegistrationFeePricingForm = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCentsValidation = 0;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCentsValidation = 1;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validateRegistrationFeePricing = function (fields) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				(fields.YY.QW.Ot && A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					abi: false,
					yQ: $elm$core$Maybe$Nothing,
					TZ: $elm$core$Maybe$Just(1)
				},
				fields.QW)) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a number greater than 0.')
				]) : _List_Nil,
				(fields.YY.Tr.Ot && A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					abi: false,
					yQ: $elm$core$Maybe$Nothing,
					TZ: $elm$core$Maybe$Just(1)
				},
				fields.Tr)) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a number greater than 0.')
				]) : _List_Nil
			]));
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$RegistrationFeePricingFields$validateRegistrationFeePricing)
		]));
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validate = function (_v0) {
	var form = _v0;
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$elm$core$Result$mapError,
		$elm$core$Basics$identity,
		A2(
			$elm$core$Result$map,
			$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$Plan$Form$RegistrationFeePricingFields$validator,
				A2($author$project$Utils$Form$set, fields, form))));
};
var $author$project$Components$Plan$BasicForm$NameValidation = 0;
var $author$project$Components$Plan$BasicForm$RegistrationFeeNameValidation = 8;
var $author$project$Components$Plan$BasicForm$ImageValidation = 10;
var $author$project$Components$Plan$BasicForm$maxImageBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Plan$BasicForm$imageValidator = A3(
	$author$project$Utils$Validate$ifIntGreaterThan,
	function ($) {
		return $.ms;
	},
	$author$project$Components$Plan$BasicForm$maxImageBytesSize,
	_Utils_Tuple2(10, 'That image is too large! Our maximum image size is 5 MB.'));
var $author$project$Components$Plan$BasicForm$DefaultChargeNameValidation = 6;
var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonthsValidation = 5;
var $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercentValidation = 4;
var $author$project$Components$Plan$BasicForm$MonthAdjustmentPercentValidation = 1;
var $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercentValidation = 2;
var $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercentValidation = 3;
var $author$project$Components$Plan$BasicForm$validateBillingPeriod = F3(
	function (periodAllowed, adjustmentPercent, validationGroup) {
		return (periodAllowed && A2(
			$author$project$Utils$Validate$isInvalidPercentage,
			{
				abi: false,
				yQ: $elm$core$Maybe$Nothing,
				TZ: $elm$core$Maybe$Just(0)
			},
			adjustmentPercent)) ? _List_fromArray(
			[
				_Utils_Tuple2(validationGroup, 'Please enter a number between 0 and 100.')
			]) : _List_Nil;
	});
var $author$project$Components$Plan$BasicForm$validateBillingPeriods = function (fields) {
	return fields.J0 ? _List_Nil : $elm$core$List$concat(
		_List_fromArray(
			[
				A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.za, fields.y9, 1),
				A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.Bg, fields.Bf, 2),
				A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.B7, fields.B6, 3),
				A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.vo, fields.vn, 4)
			]));
};
var $author$project$Components$Plan$BasicForm$validateBillingOptions = F2(
	function (maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		if ((planType !== 1) && (!isMcePlan)) {
			var forCompany = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (plan) {
						return !$author$project$Api$Provider$Plan$One$planType(plan);
					},
					maybePlan));
			return $elm$core$List$concat(
				_List_fromArray(
					[
						(fields.YY.T3.Ot && ((!forCompany) && A2(
						$author$project$Utils$Validate$isOutsideIntRange,
						{
							abi: false,
							yQ: $elm$core$Maybe$Just(12),
							TZ: $elm$core$Maybe$Just(1)
						},
						fields.T3))) ? _List_fromArray(
						[
							_Utils_Tuple2(5, 'Please enter a number between 1 and 12.')
						]) : _List_Nil,
						$rtfeldman$elm_validate$Validate$isBlank(fields.w5) ? _List_fromArray(
						[
							_Utils_Tuple2(6, 'Please enter a name.')
						]) : _List_Nil,
						$author$project$Components$Plan$BasicForm$validateBillingPeriods(fields)
					]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Plan$BasicForm$RegistrationFeePricingValidation = 9;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$hasErrors = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Plan$BasicForm$validateRegistrationFeePricing = function (fields) {
	return $author$project$Components$Plan$Form$RegistrationFeePricingFields$hasErrors(fields.c9) ? _List_fromArray(
		[
			_Utils_Tuple2(9, 'Please fix the registration fee validation errors.')
		]) : _List_Nil;
};
var $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCentsValidation = 7;
var $author$project$Components$Plan$BasicForm$validateSponsorFeeDeal = F2(
	function (maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		return ((planType === 1) && A2(
			$author$project$Utils$Validate$isInvalidCurrency,
			{
				abi: false,
				yQ: $elm$core$Maybe$Nothing,
				TZ: $elm$core$Maybe$Just(1)
			},
			fields.Hi)) ? _List_fromArray(
			[
				_Utils_Tuple2(7, 'Please enter a number greater than 0.')
			]) : _List_Nil;
	});
var $author$project$Components$Plan$BasicForm$validator = F2(
	function (_v0, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.zh;
					},
					_Utils_Tuple2(0, 'Please enter a name.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.Bq;
					},
					_Utils_Tuple2(8, 'Please enter a registration fee name.')),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$BasicForm$validateRegistrationFeePricing),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$Plan$BasicForm$validateBillingOptions(maybePlan)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$Plan$BasicForm$validateSponsorFeeDeal(maybePlan)),
					$author$project$Components$Plan$BasicForm$imageValidator
				]));
	});
var $author$project$Components$Plan$BasicForm$validate = F2(
	function (_v0, maybePlan) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var validatedRegistrationFeeForm = function () {
			var _v1 = $author$project$Components$Plan$Form$RegistrationFeePricingFields$validate(fields.c9);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var newForm_ = _v2.a;
				return newForm_;
			} else {
				var newForm_ = _v1.a;
				return newForm_;
			}
		}();
		var updatedFields = _Utils_update(
			fields,
			{c9: validatedRegistrationFeeForm});
		return A2(
			$elm$core$Result$mapError,
			function (f) {
				return A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, f);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst(
					function (f) {
						return A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, f);
					}),
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Plan$BasicForm$validator, settings, maybePlan),
					A2($author$project$Utils$Form$set, updatedFields, form))));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyMembershipPricingForm = $elm$core$Basics$identity;
var $author$project$Api$DiscountRuleType$AdditionalAdult = 3;
var $author$project$Api$DiscountRuleType$AdditionalChild = 4;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation = {$: 1};
var $author$project$Api$DiscountRuleType$ChildrenOnly = 5;
var $author$project$Api$DiscountRuleType$Couple = 0;
var $author$project$Api$DiscountRuleType$Family = 2;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation = {$: 0};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation = {$: 2};
var $author$project$Api$DiscountRuleType$SingleParent = 1;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents = F3(
	function (defaultPeriod, discountRule, validationGroup) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (discountRule_) {
					var min = 0;
					var max = 9999900;
					return $elm$core$List$concat(
						_List_fromArray(
							[
								(((defaultPeriod === 'month') || discountRule_.Uc) && A2(
								$author$project$Utils$Validate$isInvalidCurrency,
								{
									abi: false,
									yQ: $elm$core$Maybe$Just(max),
									TZ: $elm$core$Maybe$Just(min)
								},
								discountRule_.Ub)) ? _List_fromArray(
								[
									_Utils_Tuple2(
									validationGroup('month'),
									'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
								]) : _List_Nil,
								(((defaultPeriod === 'quarter') || discountRule_.XB) && A2(
								$author$project$Utils$Validate$isInvalidCurrency,
								{
									abi: false,
									yQ: $elm$core$Maybe$Just(max),
									TZ: $elm$core$Maybe$Just(min)
								},
								discountRule_.XA)) ? _List_fromArray(
								[
									_Utils_Tuple2(
									validationGroup('quarter'),
									'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
								]) : _List_Nil,
								(((defaultPeriod === 'semi_annual') || discountRule_.Zo) && A2(
								$author$project$Utils$Validate$isInvalidCurrency,
								{
									abi: false,
									yQ: $elm$core$Maybe$Just(max),
									TZ: $elm$core$Maybe$Just(min)
								},
								discountRule_.Zn)) ? _List_fromArray(
								[
									_Utils_Tuple2(
									validationGroup('semi_annual'),
									'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
								]) : _List_Nil,
								(((defaultPeriod === 'annual') || discountRule_.Ja) && A2(
								$author$project$Utils$Validate$isInvalidCurrency,
								{
									abi: false,
									yQ: $elm$core$Maybe$Just(max),
									TZ: $elm$core$Maybe$Just(min)
								},
								discountRule_.I9)) ? _List_fromArray(
								[
									_Utils_Tuple2(
									validationGroup('annual'),
									'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
								]) : _List_Nil
							]));
				},
				discountRule));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule = F3(
	function (defaultPeriod, type_, fields) {
		switch (type_) {
			case 0:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.wQ,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			case 1:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.Cn,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			case 2:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.xA,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			case 3:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.tJ,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			case 4:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.tK,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
			default:
				return A3(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents,
					defaultPeriod,
					fields.v4,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyMembershipPricingFields = F3(
	function (sharedFields, maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		if ((planType !== 1) && ((!isMcePlan) && (sharedFields.P_ === 'family'))) {
			var _v0 = fields;
			var rules = _v0.YY;
			return $elm$core$List$concat(
				_List_fromArray(
					[
						rules.wQ.Ot ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nf, 0, fields) : _List_Nil,
						rules.xA.Ot ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nf, 2, fields) : _List_Nil,
						rules.Cn.Ot ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nf, 1, fields) : _List_Nil,
						(rules.xA.Ot || rules.Cn.Ot) ? $elm$core$List$concat(
						_List_fromArray(
							[
								(rules.xB.Ot && A2(
								$author$project$Utils$Validate$isOutsideIntRange,
								{
									abi: false,
									yQ: $elm$core$Maybe$Nothing,
									TZ: $elm$core$Maybe$Just(0)
								},
								fields.xB)) ? _List_fromArray(
								[
									_Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, 'Please enter a number greater than or equal to 0.')
								]) : _List_Nil,
								(rules.xB.Ot && rules.tK.Ot) ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nf, 4, fields) : _List_Nil,
								(rules.xB.Ot && (rules.zC.Ot && A2(
								$author$project$Utils$Validate$isOutsideIntRange,
								{
									abi: false,
									yQ: $elm$core$Maybe$Nothing,
									TZ: $elm$core$Maybe$Just(0)
								},
								fields.zC))) ? _List_fromArray(
								[
									_Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, 'Please enter a number greater than or equal to 0.')
								]) : _List_Nil,
								rules.tJ.Ot ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nf, 3, fields) : _List_Nil,
								rules.v4.Ot ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nf, 5, fields) : _List_Nil,
								(rules.v3.Ot && A2(
								$author$project$Utils$Validate$isOutsideIntRange,
								{
									abi: false,
									yQ: $elm$core$Maybe$Nothing,
									TZ: $elm$core$Maybe$Just(1)
								},
								fields.v3)) ? _List_fromArray(
								[
									_Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, 'Please enter a number greater than or equal to 1.')
								]) : _List_Nil
							])) : _List_Nil
					]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validator = F2(
	function (sharedFields, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyMembershipPricingFields, sharedFields, maybePlan))
				]));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate = F3(
	function (_v0, sharedFields, maybePlan) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validator, sharedFields, maybePlan),
					A2($author$project$Utils$Form$set, fields, form))));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupTierPricingForm = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation = {$: 2};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation = {$: 1};
var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation = {$: 3};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validatePricingRuleAmountInCents = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 999999999;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.f5) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.T8)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.gr) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xw)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.gG) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Zj)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.e_) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.I5)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule = F3(
	function (defaultPeriod, rateRuleType, rateRule) {
		var createValidationGroup = function (period) {
			return A2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation, rateRuleType, period);
		};
		return A3($author$project$Components$Plan$Form$GroupTierPricingFields$validatePricingRuleAmountInCents, defaultPeriod, rateRule, createValidationGroup);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validateGroupTierPricing = F3(
	function (sharedFields, maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		return ((planType !== 1) && ((!isMcePlan) && (sharedFields.P_ === 'fixed_pricing'))) ? $elm$core$List$concat(
			_List_fromArray(
				[
					A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nf, $author$project$Api$RateRuleType$Individual, fields.QU),
					A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nf, $author$project$Api$RateRuleType$Couple, fields.L$),
					A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nf, $author$project$Api$RateRuleType$SingleParent, fields.Z8),
					A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nf, $author$project$Api$RateRuleType$Family, fields.O7),
					fields._b ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nf, $author$project$Api$RateRuleType$SingleParentWithSingleChild, fields._a) : _List_Nil,
					fields.Pa ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nf, $author$project$Api$RateRuleType$FamilyWithSingleChild, fields.O9) : _List_Nil,
					fields.YY.O6.Ot ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nf, $author$project$Api$RateRuleType$AdditionalAdult, fields.Io) : _List_Nil,
					fields.YY.PZ.Ot ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nf, $author$project$Api$RateRuleType$AdditionalChild, fields.Ip) : _List_Nil,
					(fields.YY.Pv.Ot && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						abi: false,
						yQ: $elm$core$Maybe$Nothing,
						TZ: $elm$core$Maybe$Just(1)
					},
					fields.Pv)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, 'Please enter a number greater or equal than 1.')
					]) : _List_Nil,
					(fields.YY.O6.Ot && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						abi: false,
						yQ: $elm$core$Maybe$Nothing,
						TZ: $elm$core$Maybe$Just(2)
					},
					fields.O6)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, 'Please enter a number greater or equal than 2.')
					]) : _List_Nil,
					(fields.YY.PZ.Ot && A2(
					$author$project$Utils$Validate$isOutsideIntRange,
					{
						abi: false,
						yQ: $elm$core$Maybe$Nothing,
						TZ: $elm$core$Maybe$Just(0)
					},
					fields.PZ)) ? _List_fromArray(
					[
						_Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, 'Please enter a number greater than 0.')
					]) : _List_Nil
				])) : _List_Nil;
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validator = F2(
	function (sharedFields, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$GroupTierPricingFields$validateGroupTierPricing, sharedFields, maybePlan))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$validate = F3(
	function (sharedFields, _v0, maybePlan) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Plan$Form$GroupTierPricingFields$validator, sharedFields, maybePlan),
					A2($author$project$Utils$Form$set, fields, form))));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$IndividualMembershipPricingForm = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 999999999;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.f5) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.T8)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.gr) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xw)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.gG) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Zj)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.e_) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.I5)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
					]) : _List_Nil
				]));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validateIndividualMembershipPricing = F3(
	function (sharedFields, maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		return ((planType !== 1) && ((!isMcePlan) && (sharedFields.P_ !== 'fixed_pricing'))) ? $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, ageRateRule) {
						var flatAgeRateRule = {I5: ageRateRule.c7.I5, e_: ageRateRule.c7.e_, T8: ageRateRule.c7.T8, f5: ageRateRule.c7.f5, Xw: ageRateRule.c7.Xw, gr: ageRateRule.c7.gr, Zj: ageRateRule.c7.Zj, gG: ageRateRule.c7.gG};
						var individualValidation = A3(
							$author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents,
							sharedFields.Nf,
							flatAgeRateRule,
							$author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation(index));
						var coupleValidation = function () {
							var _v0 = ageRateRule.L_;
							if (!_v0.$) {
								var coupleRule = _v0.a;
								var flatCoupleRule = {I5: coupleRule.c7.I5, e_: coupleRule.c7.e_, T8: coupleRule.c7.T8, f5: coupleRule.c7.f5, Xw: coupleRule.c7.Xw, gr: coupleRule.c7.gr, Zj: coupleRule.c7.Zj, gG: coupleRule.c7.gG};
								return A3(
									$author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents,
									sharedFields.Nf,
									flatCoupleRule,
									$author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation(index));
							} else {
								return _List_Nil;
							}
						}();
						return _Utils_ap(individualValidation, coupleValidation);
					}),
				fields.IL)) : _List_Nil;
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validator = F2(
	function (sharedFields, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validateIndividualMembershipPricing, sharedFields, maybePlan))
				]));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate = F3(
	function (sharedFields, _v0, maybePlan) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validator, sharedFields, maybePlan),
					A2($author$project$Utils$Form$set, fields, form))));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRatesForm = $elm$core$Basics$identity;
var $author$project$Api$FeatureGate$MembershipPricingAdvancePricingRules = 7;
var $author$project$Utils$FeatureGate$gateAvailable = F2(
	function (code, practice) {
		var _v0 = A2(
			$author$project$Utils$FeatureGate$findByCode,
			code,
			$author$project$Api$Practice$featureGates(practice));
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$SpecialRatesFields$validatePricingRuleAmountInCents = F3(
	function (defaultPeriod, pricingRule, validationGroup) {
		var min = 0;
		var max = 999999999;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					(((defaultPeriod === 'month') || pricingRule.f5) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.T8)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('month'),
						'Please enter an amount between $0.00 and $9,999,999.99.')
					]) : _List_Nil,
					(((defaultPeriod === 'quarter') || pricingRule.gr) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Xw)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('quarter'),
						'Please enter an amount between $0.00 and $9,999,999.99.')
					]) : _List_Nil,
					(((defaultPeriod === 'semi_annual') || pricingRule.gG) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.Zj)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('semi_annual'),
						'Please enter an amount between $0.00 and $9,999,999.99.')
					]) : _List_Nil,
					(((defaultPeriod === 'annual') || pricingRule.e_) && A2(
					$author$project$Utils$Validate$isInvalidCurrency,
					{
						abi: false,
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					pricingRule.I5)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup('annual'),
						'Please enter an amount between $0.00 and $9,999,999.99.')
					]) : _List_Nil
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRate = F3(
	function (defaultPeriod, index, fields) {
		return fields.NB ? _List_Nil : $elm$core$List$concat(
			_List_fromArray(
				[
					$elm$core$String$isEmpty(fields.zh) ? _List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index),
						'Please enter a name.')
					]) : _List_Nil,
					A3(
					$author$project$Components$Plan$Form$SpecialRatesFields$validatePricingRuleAmountInCents,
					defaultPeriod,
					fields,
					$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation(index))
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRates = F4(
	function (sharedFields, practice, maybePlan, fields) {
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		return ((planType !== 1) && ((!isMcePlan) && A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			7,
			$author$project$Api$Practice$Provider(practice)))) ? $elm$core$List$concat(
			A2(
				$elm$core$List$indexedMap,
				$author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRate(sharedFields.Nf),
				fields._o)) : _List_Nil;
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$validator = F3(
	function (sharedFields, practice, maybePlan) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A3($author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRates, sharedFields, practice, maybePlan))
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$validate = F4(
	function (sharedFields, practice, _v0, maybePlan) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$Result$mapError,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Result$map,
				$elm$core$Tuple$mapFirst($elm$core$Basics$identity),
				A2(
					$author$project$Utils$Form$validate,
					A3($author$project$Components$Plan$Form$SpecialRatesFields$validator, sharedFields, practice, maybePlan),
					A2($author$project$Utils$Form$set, fields, form))));
	});
var $author$project$Components$Plan$Form$validateFormFields = F3(
	function (plan, practice, form) {
		var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
		var fields = $author$project$Utils$Form$fields(form);
		var validatedFamilyMembershipPricingForm = function () {
			var _v8 = A3(
				$author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate,
				fields.cU,
				sharedFields,
				$elm$core$Maybe$Just(plan));
			if (!_v8.$) {
				var _v9 = _v8.a;
				var newForm_ = _v9.a;
				return newForm_;
			} else {
				var newForm_ = _v8.a;
				return newForm_;
			}
		}();
		var validatedGroupTierPricingForm = function () {
			var _v6 = A3(
				$author$project$Components$Plan$Form$GroupTierPricingFields$validate,
				sharedFields,
				fields.i,
				$elm$core$Maybe$Just(plan));
			if (!_v6.$) {
				var _v7 = _v6.a;
				var newForm_ = _v7.a;
				return newForm_;
			} else {
				var newForm_ = _v6.a;
				return newForm_;
			}
		}();
		var validatedMembershipPricingForm = function () {
			var _v4 = A3(
				$author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate,
				sharedFields,
				fields.cX,
				$elm$core$Maybe$Just(plan));
			if (!_v4.$) {
				var _v5 = _v4.a;
				var newForm_ = _v5.a;
				return newForm_;
			} else {
				var newForm_ = _v4.a;
				return newForm_;
			}
		}();
		var validatedSpecialRatesForm = function () {
			var _v2 = A4(
				$author$project$Components$Plan$Form$SpecialRatesFields$validate,
				sharedFields,
				practice,
				fields.de,
				$elm$core$Maybe$Just(plan));
			if (!_v2.$) {
				var _v3 = _v2.a;
				var newForm_ = _v3.a;
				return newForm_;
			} else {
				var newForm_ = _v2.a;
				return newForm_;
			}
		}();
		var basicPlanForm = function () {
			var _v0 = A2(
				$author$project$Components$Plan$BasicForm$validate,
				fields.aA,
				$elm$core$Maybe$Just(plan));
			if (!_v0.$) {
				var _v1 = _v0.a;
				var newForm_ = _v1.a;
				return newForm_;
			} else {
				var newForm_ = _v0.a;
				return newForm_;
			}
		}();
		return A2(
			$author$project$Utils$Form$set,
			_Utils_update(
				fields,
				{aA: basicPlanForm, cU: validatedFamilyMembershipPricingForm, i: validatedGroupTierPricingForm, cX: validatedMembershipPricingForm, de: validatedSpecialRatesForm}),
			form);
	});
var $author$project$Components$Plan$Form$calculate = F4(
	function (plan, form, opts, model) {
		var newValidForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.WF, form);
		var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, newValidForm);
		var isValid = (!opts.aaM) || $author$project$Utils$Maybe$toBool(
			$elm$core$Result$toMaybe(
				A2(
					$author$project$Utils$Form$validate,
					A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.cO, model.oK, model.jv, plan),
					newValidForm)));
		var _v0 = (opts.ZP && isValid) ? A3(
			$jinjor$elm_debounce$Debounce$push,
			$author$project$Components$Plan$Form$previewDebounceConfig,
			$author$project$Utils$Form$fields(form),
			model.em) : _Utils_Tuple2(model.em, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			function () {
				if (opts.ZP && isValid) {
					return _Utils_update(
						model,
						{em: newDebouncer});
				} else {
					if (!isValid) {
						var previewId = model.afU.a + 1;
						return _Utils_update(
							model,
							{
								afU: _Utils_Tuple2(previewId, $author$project$Api$Data$NotAsked),
								em: newDebouncer
							});
					} else {
						return _Utils_update(
							model,
							{em: newDebouncer});
					}
				}
			}(),
			cmd);
	});
var $author$project$Components$Plan$Form$calculateAfterValidation = F5(
	function (model, plan, form, opts, showWarningModal) {
		var validatedForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.WF, form);
		var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, validatedForm);
		var _v0 = A2(
			$author$project$Utils$Form$validate,
			A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.cO, model.oK, model.jv, plan),
			validatedForm);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newForm_ = _v1.a;
			return A4(
				$author$project$Components$Plan$Form$calculate,
				plan,
				newForm_,
				opts,
				_Utils_update(
					model,
					{
						PB: $elm$core$Maybe$Just(
							_Utils_Tuple2(plan, newForm_)),
						oq: showWarningModal
					}));
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						PB: $elm$core$Maybe$Just(
							_Utils_Tuple2(plan, form)),
						oq: showWarningModal
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(false, false);
			case 1:
				return _Utils_Tuple2(false, false);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {ZP: shouldCalculate_, aaM: validateCalculateFields};
};
var $author$project$Components$Plan$BasicForm$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(false, false);
			case 20:
				return _Utils_Tuple2(false, false);
			case 21:
				return _Utils_Tuple2(false, false);
			case 1:
				return _Utils_Tuple2(false, false);
			case 2:
				return _Utils_Tuple2(false, false);
			case 17:
				return _Utils_Tuple2(false, false);
			case 5:
				return _Utils_Tuple2(false, false);
			case 6:
				return _Utils_Tuple2(false, false);
			case 19:
				return _Utils_Tuple2(false, false);
			case 3:
				return _Utils_Tuple2(true, false);
			case 4:
				return _Utils_Tuple2(true, false);
			case 9:
				return _Utils_Tuple2(true, true);
			case 10:
				return _Utils_Tuple2(true, true);
			case 11:
				return _Utils_Tuple2(true, true);
			case 12:
				return _Utils_Tuple2(true, true);
			case 13:
				return _Utils_Tuple2(true, true);
			case 14:
				return _Utils_Tuple2(true, true);
			case 15:
				return _Utils_Tuple2(true, false);
			case 16:
				return _Utils_Tuple2(true, true);
			case 7:
				return _Utils_Tuple2(false, false);
			case 22:
				return _Utils_Tuple2(false, false);
			case 8:
				return _Utils_Tuple2(false, false);
			case 18:
				return _Utils_Tuple2(false, false);
			case 23:
				var registrationField = field.a;
				var opts = $author$project$Components$Plan$Form$RegistrationFeePricingFields$calculateOpts(registrationField);
				return _Utils_Tuple2(opts.ZP, opts.aaM);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {ZP: shouldCalculate_, aaM: validateCalculateFields};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 2:
				return _Utils_Tuple2(false, true);
			case 3:
				return _Utils_Tuple2(false, true);
			case 4:
				return _Utils_Tuple2(false, true);
			case 5:
				return _Utils_Tuple2(true, true);
			case 6:
				return _Utils_Tuple2(false, true);
			case 7:
				return _Utils_Tuple2(true, true);
			case 0:
				return _Utils_Tuple2(false, true);
			case 1:
				return _Utils_Tuple2(false, false);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {ZP: shouldCalculate_, aaM: validateCalculateFields};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(true, false);
			case 1:
				return _Utils_Tuple2(true, false);
			case 2:
				return _Utils_Tuple2(true, false);
			case 3:
				return _Utils_Tuple2(true, false);
			case 4:
				return _Utils_Tuple2(true, false);
			case 5:
				return _Utils_Tuple2(true, false);
			case 6:
				return _Utils_Tuple2(true, false);
			case 7:
				return _Utils_Tuple2(true, false);
			case 8:
				return _Utils_Tuple2(false, true);
			case 9:
				return _Utils_Tuple2(false, true);
			case 10:
				return _Utils_Tuple2(false, true);
			case 11:
				return _Utils_Tuple2(false, true);
			case 12:
				return _Utils_Tuple2(false, false);
			case 13:
				return _Utils_Tuple2(true, false);
			case 14:
				return _Utils_Tuple2(false, false);
			case 15:
				return _Utils_Tuple2(false, false);
			case 16:
				return _Utils_Tuple2(true, false);
			case 17:
				return _Utils_Tuple2(false, false);
			case 18:
				return _Utils_Tuple2(true, false);
			default:
				return _Utils_Tuple2(true, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {ZP: shouldCalculate_, aaM: validateCalculateFields};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(true, true);
			case 1:
				return _Utils_Tuple2(true, true);
			case 2:
				return _Utils_Tuple2(false, true);
			case 3:
				return _Utils_Tuple2(true, true);
			case 4:
				return _Utils_Tuple2(true, true);
			case 5:
				return _Utils_Tuple2(false, true);
			case 6:
				return _Utils_Tuple2(true, true);
			case 7:
				return _Utils_Tuple2(true, true);
			case 8:
				return _Utils_Tuple2(false, true);
			case 9:
				return _Utils_Tuple2(true, true);
			case 10:
				return _Utils_Tuple2(true, false);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {ZP: shouldCalculate_, aaM: validateCalculateFields};
};
var $author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(true, true);
			case 1:
				return _Utils_Tuple2(true, true);
			case 2:
				return _Utils_Tuple2(false, true);
			case 3:
				return _Utils_Tuple2(true, true);
			case 4:
				return _Utils_Tuple2(false, true);
			default:
				return _Utils_Tuple2(true, true);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {ZP: shouldCalculate_, aaM: validateCalculateFields};
};
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $author$project$Api$Provider$CoveragePlan$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CoveragePlan$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoveragePlan$Shared$id(shared);
};
var $author$project$Api$Provider$CoveragePlan$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoveragePlan$Shared$id(shared);
};
var $author$project$Components$Plan$Form$coveragePlanId = function (coveragePlan) {
	if (!coveragePlan.$) {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_);
	} else {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$All$id(coveragePlan_);
	}
};
var $author$project$Components$Plan$Form$PreviewDebounced = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Plan$Form$debounceCalculate = function (formFields) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Plan$Form$PreviewDebounced,
		$elm$core$Task$succeed(formFields));
};
var $author$project$Api$Provider$Plan$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Plan$planPath(id)));
	});
var $author$project$Components$Plan$Form$GotSubsequentPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$SubsequentPlan$One$SubsequentPlan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$SubsequentPlan$Min$SubsequentPlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$SubsequentPlan$Min$Record = F2(
	function (id, type_) {
		return {adR: id, ahI: type_};
	});
var $author$project$Api$Provider$MembershipScheduledChange$Type$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'date':
				return $elm$json$Json$Decode$succeed(0);
			case 'duration':
				return $elm$json$Json$Decode$succeed(1);
			case 'contract':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported membership scheduled change type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$SubsequentPlan$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$author$project$Api$Provider$MembershipScheduledChange$Type$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$Min$Record)));
var $author$project$Api$Provider$SubsequentPlan$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SubsequentPlan$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SubsequentPlan$One$Record = F3(
	function (changeAfterMonths, changeOnDate, toPlan) {
		return {KN: changeAfterMonths, KO: changeOnDate, $J: toPlan};
	});
var $author$project$Api$Provider$SubsequentPlan$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'change_on_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'change_after_months',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$One$Record))));
var $author$project$Api$Provider$SubsequentPlan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SubsequentPlan$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$SubsequentPlan$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$One$SubsequentPlan)));
var $author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath = function (planId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['subsequent_plan']),
		$author$project$Api$Provider$Plan$planPath(planId));
};
var $author$project$Api$Provider$Plan$SubsequentPlan$retrieve = F3(
	function (apiClient, planId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$SubsequentPlan$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)));
	});
var $author$project$Components$Plan$Form$fetchSubsequentPlan = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Plan$SubsequentPlan$retrieve, apiClient, id, $author$project$Components$Plan$Form$GotSubsequentPlan);
	});
var $author$project$Api$Provider$Plan$Shared$ageRateRules = function (_v0) {
	var record = _v0;
	return record.IL;
};
var $author$project$Api$Provider$Plan$One$ageRateRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
};
var $author$project$Components$Plan$Form$PlanChange$clean = function (planChange) {
	var params = planChange.Vx;
	return (planChange.Vx.ahI === 2) ? _Utils_update(
		planChange,
		{
			Vx: _Utils_update(
				params,
				{KN: $elm$core$Maybe$Nothing, KO: $elm$core$Maybe$Nothing})
		}) : ((!planChange.Vx.ahI) ? _Utils_update(
		planChange,
		{
			Vx: _Utils_update(
				params,
				{KN: $elm$core$Maybe$Nothing})
		}) : _Utils_update(
		planChange,
		{
			Vx: _Utils_update(
				params,
				{KO: $elm$core$Maybe$Nothing})
		}));
};
var $author$project$Components$Plan$Form$exclusiveRanges = F5(
	function (fromGetter, fromSetter, toGetter, toSetter, range) {
		if ($elm$core$List$isEmpty(range)) {
			return range;
		} else {
			var minimum = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					fromGetter,
					$elm$core$List$head(range)));
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, current) {
						var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
						var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
						var newTo = function () {
							var _v1 = _Utils_Tuple2(
								next,
								toGetter(current));
							if (_v1.a.$ === 1) {
								var _v2 = _v1.a;
								return $elm$core$Maybe$Nothing;
							} else {
								if (_v1.b.$ === 1) {
									var _v3 = _v1.b;
									return toGetter(current);
								} else {
									var currentTo = _v1.b.a;
									var currentFrom = fromGetter(current);
									return (_Utils_cmp(currentTo, currentFrom) < 1) ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
								}
							}
						}();
						var newFrom = function () {
							var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
							if (!_v0.$) {
								var _int = _v0.a;
								return _int + 1;
							} else {
								return minimum;
							}
						}();
						return A2(
							toSetter,
							newTo,
							A2(fromSetter, newFrom, current));
					}),
				range);
		}
	});
var $author$project$Components$Plan$Form$exclusiveSizeRanges = A4(
	$author$project$Components$Plan$Form$exclusiveRanges,
	function ($) {
		return $.PJ;
	},
	F2(
		function (from, item) {
			return _Utils_update(
				item,
				{PJ: from});
		}),
	function ($) {
		return $.$K;
	},
	F2(
		function (to, item) {
			return _Utils_update(
				item,
				{$K: to});
		}));
var $author$project$Api$Provider$RateRule$Shared$fromAge = function (_v0) {
	var record = _v0;
	return record.PH;
};
var $author$project$Api$Employer$Plan$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$Plan$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$id(shared);
};
var $author$project$Api$Employer$Plan$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$id(shared);
};
var $author$project$Api$Provider$Plan$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Plan$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$id(shared);
};
var $author$project$Api$Provider$Plan$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$id(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$id(shared);
};
var $author$project$Api$Plan$id = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$id(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$id(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$id(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$id(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$id(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$id(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$id(plan_);
	}
};
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Components$Plan$Form$maxGroupFromSize = 10;
var $author$project$Api$Employer$Plan$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$Plan$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$name(shared);
};
var $author$project$Api$Employer$Plan$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$name(shared);
};
var $author$project$Api$Provider$Plan$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Plan$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$name(shared);
};
var $author$project$Api$Provider$Plan$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$name(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$name(shared);
};
var $author$project$Api$Plan$name = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$name(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$name(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$name(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$name(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$name(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$name(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$name(plan_);
	}
};
var $author$project$Utils$List$prepend = F2(
	function (xs, ys) {
		return _Utils_ap(ys, xs);
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleField$default = function (defaultPeriod) {
	return function (groupDiscountRule) {
		switch (defaultPeriod) {
			case 'month':
				return _Utils_update(
					groupDiscountRule,
					{
						T9: $elm$core$Maybe$Just($author$project$Currency$zero)
					});
			case 'quarter':
				return _Utils_update(
					groupDiscountRule,
					{
						Xy: $elm$core$Maybe$Just($author$project$Currency$zero)
					});
			case 'semi_annual':
				return _Utils_update(
					groupDiscountRule,
					{
						Zl: $elm$core$Maybe$Just($author$project$Currency$zero)
					});
			case 'annual':
				return _Utils_update(
					groupDiscountRule,
					{
						I7: $elm$core$Maybe$Just($author$project$Currency$zero)
					});
			default:
				return groupDiscountRule;
		}
	}(
		{I7: $elm$core$Maybe$Nothing, I8: false, D3: false, Jd: $elm$core$Maybe$Nothing, Je: false, pw: false, Km: 'amount_off_in_cents', PJ: 2, T9: $elm$core$Maybe$Nothing, Ua: false, F8: false, Ug: $elm$core$Maybe$Nothing, Uh: false, m6: false, Xy: $elm$core$Maybe$Nothing, Xz: false, GV: false, XE: $elm$core$Maybe$Nothing, XF: false, si: false, Zl: $elm$core$Maybe$Nothing, Zm: false, G8: false, Zr: $elm$core$Maybe$Nothing, Zs: false, sG: false, $K: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom = F2(
	function (defaultPeriod, base) {
		return function (groupDiscountRule) {
			var _v0 = _Utils_Tuple2(base.Km, defaultPeriod);
			_v0$8:
			while (true) {
				switch (_v0.a) {
					case 'amount_off_in_cents':
						switch (_v0.b) {
							case 'month':
								return _Utils_update(
									groupDiscountRule,
									{T9: base.T9, Ua: true});
							case 'quarter':
								return _Utils_update(
									groupDiscountRule,
									{Xy: base.Xy, Xz: true});
							case 'semi_annual':
								return _Utils_update(
									groupDiscountRule,
									{Zl: base.Zl, Zm: true});
							case 'annual':
								return _Utils_update(
									groupDiscountRule,
									{I7: base.I7, I8: true});
							default:
								break _v0$8;
						}
					case 'percent_off':
						switch (_v0.b) {
							case 'month':
								return _Utils_update(
									groupDiscountRule,
									{Ug: base.Ug, Uh: true});
							case 'quarter':
								return _Utils_update(
									groupDiscountRule,
									{XE: base.XE, XF: true});
							case 'semi_annual':
								return _Utils_update(
									groupDiscountRule,
									{Zr: base.Zr, Zs: true});
							case 'annual':
								return _Utils_update(
									groupDiscountRule,
									{Jd: base.Jd, Je: true});
							default:
								break _v0$8;
						}
					default:
						break _v0$8;
				}
			}
			return groupDiscountRule;
		}(
			function (groupDiscountRule) {
				return _Utils_update(
					groupDiscountRule,
					{
						Km: base.Km,
						PJ: A2($elm$core$Maybe$withDefault, 0, base.$K) + 1
					});
			}(
				$author$project$Components$Plan$Form$GroupDiscountRuleField$default(defaultPeriod)));
	});
var $author$project$Api$Provider$RateRule$Shared$toAge = function (_v0) {
	var record = _v0;
	return record.$I;
};
var $author$project$Utils$List$updateLast = F2(
	function (f, xs) {
		if (!xs.b) {
			return xs;
		} else {
			return A3(
				$elm_community$list_extra$List$Extra$updateAt,
				$elm$core$List$length(xs) - 1,
				f,
				xs);
		}
	});
var $author$project$Components$Plan$Form$formFieldsUpdate = F3(
	function (plan, field, fields) {
		switch (field.$) {
			case 0:
				var basicPlanForm = field.a;
				return _Utils_update(
					fields,
					{aA: basicPlanForm});
			case 1:
				var membershipPricingForm = field.a;
				return _Utils_update(
					fields,
					{cX: membershipPricingForm});
			case 2:
				var familyMembershipPricingForm = field.a;
				return _Utils_update(
					fields,
					{cU: familyMembershipPricingForm});
			case 3:
				var groupTierPricingForm = field.a;
				return _Utils_update(
					fields,
					{i: groupTierPricingForm});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						So: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{$O: string});
			case 6:
				var currency = field.a;
				return _Utils_update(
					fields,
					{$M: currency});
			case 7:
				var percentage = field.a;
				return _Utils_update(
					fields,
					{$N: percentage});
			case 8:
				var bool = field.a;
				var planChange = function () {
					if (_Utils_eq(fields.ju.Vx.adR, $elm$core$Maybe$Nothing)) {
						var planChangeType = bool ? 2 : 1;
						return $author$project$Components$Plan$Form$PlanChange$clean(
							function (planChange_) {
								var params = fields.ju.Vx;
								return _Utils_update(
									planChange_,
									{
										Vx: _Utils_update(
											params,
											{ahI: planChangeType})
									});
							}(fields.ju));
					} else {
						return fields.ju;
					}
				}();
				return _Utils_update(
					fields,
					{LP: bool, ju: planChange, W0: 0});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						LQ: $elm$core$String$toInt(string)
					});
			case 10:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						EI: $author$project$Api$ContractType$fromString(string)
					});
			case 11:
				var bool = field.a;
				return _Utils_update(
					fields,
					{LO: bool});
			case 12:
				var bool = field.a;
				return _Utils_update(
					fields,
					{xg: bool});
			case 13:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						LR: $elm$core$String$toInt(string)
					});
			case 14:
				var bool = field.a;
				var ageRateRules = $author$project$Api$Provider$Plan$One$ageRateRules(plan);
				var minimumAge = (bool && ($elm$core$List$length(ageRateRules) > 1)) ? A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Provider$RateRule$Shared$toAge,
					$elm$core$List$head(ageRateRules)) : $elm$core$Maybe$Just(0);
				return _Utils_update(
					fields,
					{xj: bool, T1: minimumAge});
			case 15:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						T1: $elm$core$String$toInt(string)
					});
			case 16:
				var bool = field.a;
				var ageRateRules = $author$project$Api$Provider$Plan$One$ageRateRules(plan);
				var maximumAge = (bool && ($elm$core$List$length(ageRateRules) > 1)) ? A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$RateRule$Shared$fromAge,
					$elm_community$list_extra$List$Extra$last(ageRateRules)) : $elm$core$Maybe$Nothing;
				return _Utils_update(
					fields,
					{xi: bool, Tu: maximumAge});
			case 17:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Tu: $elm$core$String$toInt(string)
					});
			case 18:
				var coveragePlan = field.a;
				return _Utils_update(
					fields,
					{L5: coveragePlan});
			case 19:
				var planChange = field.a;
				return _Utils_update(
					fields,
					{ju: planChange});
			case 20:
				var type_ = field.a;
				var planChange = fields.ju;
				var params = planChange.Vx;
				return _Utils_update(
					fields,
					{
						ju: $author$project$Components$Plan$Form$PlanChange$clean(
							_Utils_update(
								planChange,
								{
									Vx: _Utils_update(
										params,
										{ahI: type_})
								}))
					});
			case 21:
				var string = field.a;
				var planChange = fields.ju;
				var params = planChange.Vx;
				return _Utils_update(
					fields,
					{
						ju: _Utils_update(
							planChange,
							{
								Vx: _Utils_update(
									params,
									{
										KN: $elm$core$String$toInt(string)
									})
							})
					});
			case 22:
				var date = field.a;
				var planChange = fields.ju;
				var params = planChange.Vx;
				return _Utils_update(
					fields,
					{
						ju: _Utils_update(
							planChange,
							{
								Vx: _Utils_update(
									params,
									{KO: date})
							})
					});
			case 23:
				var newPlan = field.a;
				var toPlan = A2(
					$elm$core$Maybe$map,
					function (newPlan_) {
						return {
							adR: $author$project$Api$Plan$id(newPlan_),
							zh: $author$project$Api$Plan$name(newPlan_)
						};
					},
					newPlan);
				var planChange = fields.ju;
				var params = planChange.Vx;
				return _Utils_update(
					fields,
					{
						ju: _Utils_update(
							planChange,
							{
								Vx: _Utils_update(
									params,
									{$J: toPlan})
							})
					});
			case 24:
				var planChange = fields.ju;
				return _Utils_update(
					fields,
					{
						ju: _Utils_update(
							planChange,
							{bU: true})
					});
			case 25:
				var planChange = fields.ju;
				var newPlanChange = _Utils_eq(planChange.Vx.adR, $elm$core$Maybe$Nothing) ? _Utils_update(
					planChange,
					{bU: false}) : _Utils_update(
					planChange,
					{jL: true});
				return _Utils_update(
					fields,
					{ju: newPlanChange});
			case 26:
				var planChange = fields.ju;
				return _Utils_update(
					fields,
					{
						ju: _Utils_update(
							planChange,
							{jL: false})
					});
			case 27:
				var groupPricingType = (fields.P_ === 'fixed_pricing') ? 'family' : 'fixed_pricing';
				return _Utils_update(
					fields,
					{P_: groupPricingType});
			case 29:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Jj: bool});
			case 30:
				var bool = field.a;
				var groupDiscountRulesCalculatedBy = bool ? 'percent_off' : 'amount_off_in_cents';
				return _Utils_update(
					fields,
					{
						PW: A2(
							$elm$core$List$map,
							function (groupDiscountRule) {
								return _Utils_update(
									groupDiscountRule,
									{Km: groupDiscountRulesCalculatedBy});
							},
							fields.PW)
					});
			case 28:
				var string = field.a;
				return _Utils_update(
					fields,
					{P_: string});
			case 31:
				return A2(
					$elm$core$Maybe$withDefault,
					fields,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var newGroupDiscountRule = _v2.a;
							var newLastGroupDiscountRule = _v2.b;
							return _Utils_update(
								fields,
								{
									PW: A2(
										$author$project$Utils$List$prepend,
										_List_fromArray(
											[newGroupDiscountRule]),
										A2(
											$author$project$Utils$List$updateLast,
											function (last) {
												return A2($elm$core$Maybe$withDefault, last, newLastGroupDiscountRule);
											},
											fields.PW))
								});
						},
						A2(
							$elm$core$Maybe$map,
							function (lastGroupDiscountRule) {
								var lastToSize = (_Utils_cmp(lastGroupDiscountRule.PJ + 1, $author$project$Components$Plan$Form$maxGroupFromSize - 1) > 0) ? ($author$project$Components$Plan$Form$maxGroupFromSize - 1) : (lastGroupDiscountRule.PJ + 1);
								var newLastGroupDiscountRule_ = _Utils_update(
									lastGroupDiscountRule,
									{
										$K: $elm$core$Maybe$Just(lastToSize)
									});
								var _v1 = $author$project$Components$Plan$BasicForm$formFields(fields.aA);
								var defaultPeriod = _v1.Nf;
								return _Utils_Tuple2(
									A2($author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom, defaultPeriod, newLastGroupDiscountRule_),
									$elm$core$Maybe$Just(newLastGroupDiscountRule_));
							},
							$elm_community$list_extra$List$Extra$last(fields.PW))));
			case 32:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						PW: $author$project$Components$Plan$Form$exclusiveSizeRanges(
							A2($elm_community$list_extra$List$Extra$removeAt, index, fields.PW))
					});
			case 33:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						PW: $author$project$Components$Plan$Form$exclusiveSizeRanges(
							A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (groupDiscountRule) {
									return _Utils_update(
										groupDiscountRule,
										{
											PJ: A2(
												$elm$core$Maybe$withDefault,
												0,
												$elm$core$String$toInt(string))
										});
								},
								fields.PW))
					});
			case 34:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						PW: $author$project$Components$Plan$Form$exclusiveSizeRanges(
							A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (groupDiscountRule) {
									return _Utils_update(
										groupDiscountRule,
										{
											$K: $elm$core$String$toInt(string)
										});
								},
								fields.PW))
					});
			case 35:
				var index = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_update(
					fields,
					{
						PW: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{T9: currency, Ua: true});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{Xy: currency, Xz: true});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{Zl: currency, Zm: true});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{I7: currency, I8: true});
									default:
										return groupDiscountRule;
								}
							},
							fields.PW)
					});
			case 36:
				var index = field.a;
				var period = field.b;
				return _Utils_update(
					fields,
					{
						PW: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{F8: true});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{GV: true});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{G8: true});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{D3: true});
									default:
										return groupDiscountRule;
								}
							},
							fields.PW)
					});
			case 37:
				var index = field.a;
				var period = field.b;
				return _Utils_update(
					fields,
					{
						PW: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{Ua: false, F8: false});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{Xz: false, GV: false});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{Zm: false, G8: false});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{I8: false, D3: false});
									default:
										return groupDiscountRule;
								}
							},
							fields.PW)
					});
			case 38:
				var index = field.a;
				var period = field.b;
				var percent = field.c;
				return _Utils_update(
					fields,
					{
						PW: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{Ug: percent, Uh: true});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{XE: percent, XF: true});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{Zr: percent, Zs: true});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{Jd: percent, Je: true});
									default:
										return groupDiscountRule;
								}
							},
							fields.PW)
					});
			case 39:
				var index = field.a;
				var period = field.b;
				return _Utils_update(
					fields,
					{
						PW: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{m6: true});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{si: true});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{sG: true});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{pw: true});
									default:
										return groupDiscountRule;
								}
							},
							fields.PW)
					});
			case 40:
				var index = field.a;
				var period = field.b;
				return _Utils_update(
					fields,
					{
						PW: A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (groupDiscountRule) {
								switch (period) {
									case 'month':
										return _Utils_update(
											groupDiscountRule,
											{Uh: false, m6: false});
									case 'quarter':
										return _Utils_update(
											groupDiscountRule,
											{XF: false, si: false});
									case 'semi_annual':
										return _Utils_update(
											groupDiscountRule,
											{Zs: false, sG: false});
									case 'annual':
										return _Utils_update(
											groupDiscountRule,
											{Je: false, pw: false});
									default:
										return groupDiscountRule;
								}
							},
							fields.PW)
					});
			default:
				var pricingEffectivenessType = field.a;
				return _Utils_update(
					fields,
					{W0: pricingEffectivenessType});
		}
	});
var $author$project$Api$Provider$PricingVersion$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsInit = {L5: $elm$core$Maybe$Nothing};
var $author$project$Components$ResourceFilter$CoveragePlan$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveragePlan$coveragePlansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['coverage_plans']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CoveragePlan$All$CoveragePlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveragePlan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveragePlan$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoveragePlan$listDefaults = {adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$CoveragePlan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CoveragePlan$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$CoveragePlan$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CoveragePlan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CoveragePlan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlansPath)));
	});
var $author$project$Components$ResourceFilter$CoveragePlan$list = $author$project$Api$Provider$CoveragePlan$list;
var $author$project$Components$ResourceFilter$CoveragePlan$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$CoveragePlan$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$CoveragePlan$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$CoveragePlan$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$CoveragePlan$selectId = 'coverage-plans';
var $author$project$Api$Provider$CoveragePlan$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$CoveragePlan$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoveragePlan$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$CoveragePlan$toTitle = $author$project$Api$Provider$CoveragePlan$All$name;
var $author$project$Components$ResourceFilter$CoveragePlan$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CoveragePlan$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$CoveragePlan$toValue = $author$project$Api$Provider$CoveragePlan$All$id;
var $author$project$Components$ResourceFilter$CoveragePlan$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$CoveragePlan$fetchResources, adR: $author$project$Components$ResourceFilter$CoveragePlan$selectId, gx: 'Coverage Plan', st: $author$project$Components$ResourceFilter$CoveragePlan$retrieveResource, ahw: $author$project$Components$ResourceFilter$CoveragePlan$toLabel, ahA: $author$project$Components$ResourceFilter$CoveragePlan$toTitle, g0: $author$project$Components$ResourceFilter$CoveragePlan$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$init = F2(
	function (apiClient, id) {
		var _v0 = A2(
			$author$project$Components$ResourceFilter$CoveragePlan$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Coverage Plan', ac6: id});
			});
		var coveragePlanResourceFilter = _v0.a;
		var coveragePlanResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				wU: coveragePlanResourceFilter,
				PB: $author$project$Utils$Form$init($author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsInit),
				adR: id
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg, coveragePlanResourceFilterCmd));
	});
var $author$project$Components$Plan$Form$ConfirmUpdateModal$GotPatientsCount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subsequent_plan',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'change_after_months',
							A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.KN)),
							_Utils_Tuple2(
							'change_on_date',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.KO)),
							_Utils_Tuple2(
							'to_plan',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.$J))
						])))
			]));
};
var $author$project$Api$Provider$Plan$SubsequentPlan$patientsCountDecoder = A2(
	$elm$json$Json$Decode$field,
	'patients_count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
var $author$project$Api$Provider$Plan$SubsequentPlan$patientsCount = F4(
	function (apiClient, planId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$SubsequentPlan$patientsCountDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields(fields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['patients_count']),
						$author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)))));
	});
var $author$project$Components$Plan$Form$ConfirmUpdateModal$init = F5(
	function (apiClient, practice, plan, params, planChange) {
		var _v0 = function () {
			if (planChange.bU) {
				var apiFields = {
					KN: planChange.Vx.KN,
					KO: planChange.Vx.KO,
					$J: A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.adR;
						},
						planChange.Vx.$J)
				};
				return _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A4(
						$author$project$Api$Provider$Plan$SubsequentPlan$patientsCount,
						apiClient,
						$author$project$Api$Provider$Plan$One$id(plan),
						apiFields,
						$author$project$Components$Plan$Form$ConfirmUpdateModal$GotPatientsCount));
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
			}
		}();
		var patientsCount = _v0.a;
		var patientsCountCmd = _v0.b;
		return _Utils_Tuple2(
			{Vx: params, VS: patientsCount, GH: plan, ju: planChange, WF: practice},
			patientsCountCmd);
	});
var $author$project$Utils$Tuple3$mapSecond = F2(
	function (mapFunc, _v0) {
		var first_ = _v0.a;
		var second_ = _v0.b;
		var third_ = _v0.c;
		return _Utils_Tuple3(
			first_,
			mapFunc(second_),
			third_);
	});
var $author$project$Api$FeatureGate$MembershipPricingSchedulePlanChanges = 6;
var $author$project$Components$Plan$Form$CoveragePlanOne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers = function (_v0) {
	var record = _v0.b;
	return record.Jj;
};
var $author$project$Api$Provider$Plan$One$contractEmailsEnabled = function (_v0) {
	var record = _v0.b;
	return record.LO;
};
var $author$project$Api$Provider$Plan$One$contractExpires = function (_v0) {
	var record = _v0.b;
	return record.LP;
};
var $author$project$Api$Provider$Plan$One$contractPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.LQ;
};
var $author$project$Api$Provider$Plan$One$contractRenewalEmailLeadTime = function (_v0) {
	var record = _v0.b;
	return record.LR;
};
var $author$project$Api$Provider$Plan$One$contractType = function (_v0) {
	var record = _v0.b;
	return record.EI;
};
var $author$project$Api$Provider$Plan$Shared$coveragePlan = function (_v0) {
	var record = _v0;
	return record.L5;
};
var $author$project$Api$Provider$Plan$One$coveragePlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coveragePlan(shared);
};
var $author$project$Components$Plan$Form$defaultGroupRules = function (defaultPeriod) {
	return _List_fromArray(
		[
			$author$project$Components$Plan$Form$GroupDiscountRuleField$default(defaultPeriod)
		]);
};
var $author$project$Api$Provider$Plan$One$defaultPeriod = function (_v0) {
	var record = _v0.b;
	return record.Nf;
};
var $author$project$Api$Provider$Plan$One$discountsEnabled = function (_v0) {
	var record = _v0.b;
	return record.xg;
};
var $author$project$Api$Provider$Plan$Shared$addon = function (_v0) {
	var record = _v0;
	return record.Iq;
};
var $author$project$Api$Provider$Plan$One$addon = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$addon(shared);
};
var $author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Plan$One$annualAdjustmentPercent = function (_v0) {
	var record = _v0.b;
	return record.vn;
};
var $author$project$Api$Provider$Plan$One$annualAllowed = function (_v0) {
	var record = _v0.b;
	return record.vo;
};
var $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod = function (_v0) {
	var record = _v0;
	return record.J0;
};
var $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Provider$Plan$Shared$buyable = function (_v0) {
	var record = _v0;
	return record.Kh;
};
var $author$project$Api$Provider$Plan$One$buyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$buyable(shared);
};
var $author$project$Api$Provider$Plan$One$defaultChargeDescription = function (_v0) {
	var record = _v0.b;
	return record.w4;
};
var $author$project$Api$Provider$Plan$One$defaultChargeName = function (_v0) {
	var record = _v0.b;
	return record.w5;
};
var $author$project$Api$Provider$Plan$One$descriptions = function (_v0) {
	var record = _v0.b;
	return record.E1;
};
var $author$project$Api$Provider$PricingVersion$Shared$individualRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.QW;
};
var $author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$individualRegistrationFeeInCents(shared);
};
var $author$project$Api$Provider$Plan$Meta$individualRegistrationFeeInCentsRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.QW.Ot;
};
var $author$project$Api$Provider$PricingVersion$Shared$maxRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.Tr;
};
var $author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$maxRegistrationFeeInCents(shared);
};
var $author$project$Api$Provider$Plan$Meta$maxRegistrationFeeInCentsRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.Tr.Ot;
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules = F2(
	function (meta, maybePricingVersion) {
		if (!maybePricingVersion.$) {
			var pv = maybePricingVersion.a;
			return {
				QW: {
					Ot: !_Utils_eq(
						$author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents(pv),
						$elm$core$Maybe$Nothing)
				},
				Tr: {
					Ot: !_Utils_eq(
						$author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents(pv),
						$elm$core$Maybe$Nothing)
				}
			};
		} else {
			return {
				QW: {
					Ot: $author$project$Api$Provider$Plan$Meta$individualRegistrationFeeInCentsRuleEnabled(meta)
				},
				Tr: {
					Ot: $author$project$Api$Provider$Plan$Meta$maxRegistrationFeeInCentsRuleEnabled(meta)
				}
			};
		}
	});
var $author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents = function (_v0) {
	var record = _v0.b;
	return record.QW;
};
var $author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents = function (_v0) {
	var record = _v0.b;
	return record.Tr;
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees = F2(
	function (plan, maybePricingVersion) {
		if (!maybePricingVersion.$) {
			var pv = maybePricingVersion.a;
			return {
				x5: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					$author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents(pv)),
				yQ: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					$author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents(pv))
			};
		} else {
			return {
				x5: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					$author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents(plan)),
				yQ: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					$author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents(plan))
			};
		}
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$fill = F2(
	function (plan, maybePricingVersion) {
		var fees = A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees, plan, maybePricingVersion);
		return $author$project$Utils$Form$init(
			{
				cJ: $elm$core$Maybe$Nothing,
				QW: fees.x5,
				Tr: fees.yQ,
				YY: A2(
					$author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules,
					$author$project$Api$Provider$Plan$One$meta(plan),
					maybePricingVersion)
			});
	});
var $author$project$Api$Provider$Category$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Plan$One$registrationFeeCategory = function (_v0) {
	var record = _v0.b;
	return record.X4;
};
var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeCategoryId = function (_v0) {
	var record = _v0;
	return record.Bo;
};
var $author$project$Api$Provider$PricingVersion$One$registrationFeeCategoryId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeCategoryId(shared);
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$fillAsync = F4(
	function (plan, maybePricingVersion, apiClient, session) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		var fees = A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees, plan, maybePricingVersion);
		var categoryId = function () {
			if (!maybePricingVersion.$) {
				var pv = maybePricingVersion.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Provider$PricingVersion$One$registrationFeeCategoryId(pv)));
			} else {
				return A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Category$Min$id,
					$author$project$Api$Provider$Plan$One$registrationFeeCategory(plan));
			}
		}();
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						IS: false,
						UL: 'Unassigned',
						aeZ: true,
						ae_: $elm$core$Maybe$Just('')
					});
			});
		var categoryResourceFilter = _v0.a;
		var categoryResourceFilterInitCmd = _v0.b;
		var _v1 = A2($author$project$Components$ResourceFilter$Category$preSelectedId, categoryId, categoryResourceFilter);
		var categoryResourceFilterWithPreselected = _v1.a;
		var categoryResourceFilterCmd = _v1.b;
		return _Utils_Tuple2(
			$author$project$Utils$Form$init(
				{
					cJ: $elm$core$Maybe$Just(categoryResourceFilterWithPreselected),
					QW: fees.x5,
					Tr: fees.yQ,
					YY: A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules, meta, maybePricingVersion)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, categoryResourceFilterInitCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, categoryResourceFilterCmd)
					])));
	});
var $author$project$Percentage$Percentage = $elm$core$Basics$identity;
var $author$project$Percentage$fromFloat = function (_float) {
	return $elm$core$String$fromFloat(_float);
};
var $author$project$Api$Provider$Plan$Shared$imageUrl = function (_v0) {
	var record = _v0;
	return record.QN;
};
var $author$project$Api$Provider$Plan$One$imageUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$imageUrl(shared);
};
var $author$project$Api$Provider$Plan$Meta$minimumEnrollmentPeriodInMonthsRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.T3.Ot;
};
var $author$project$Components$Plan$BasicForm$initRules = function (meta) {
	return {
		T3: {
			Ot: $author$project$Api$Provider$Plan$Meta$minimumEnrollmentPeriodInMonthsRuleEnabled(meta)
		}
	};
};
var $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.T3;
};
var $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$One$monthAdjustmentPercent = function (_v0) {
	var record = _v0.b;
	return record.y9;
};
var $author$project$Api$Provider$Plan$One$monthAllowed = function (_v0) {
	var record = _v0.b;
	return record.za;
};
var $author$project$Api$Provider$Category$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Plan$One$quarterAdjustmentPercent = function (_v0) {
	var record = _v0.b;
	return record.Bf;
};
var $author$project$Api$Provider$Plan$One$quarterAllowed = function (_v0) {
	var record = _v0.b;
	return record.Bg;
};
var $author$project$Api$Provider$Plan$One$registrationFeeDescription = function (_v0) {
	var record = _v0.b;
	return record.Bp;
};
var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeDescription = function (_v0) {
	var record = _v0;
	return record.Bp;
};
var $author$project$Api$Provider$PricingVersion$One$registrationFeeDescription = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeDescription(shared);
};
var $author$project$Api$Provider$Plan$One$registrationFeeName = function (_v0) {
	var record = _v0.b;
	return record.Bq;
};
var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeName = function (_v0) {
	var record = _v0;
	return record.Bq;
};
var $author$project$Api$Provider$PricingVersion$One$registrationFeeName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeName(shared);
};
var $author$project$Api$Provider$Plan$One$semiAnnualAdjustmentPercent = function (_v0) {
	var record = _v0.b;
	return record.B6;
};
var $author$project$Api$Provider$Plan$One$semiAnnualAllowed = function (_v0) {
	var record = _v0.b;
	return record.B7;
};
var $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal = function (_v0) {
	var record = _v0;
	return record._u;
};
var $author$project$Api$Provider$Plan$One$sponsorFeeDeal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Components$Plan$BasicForm$fill = F6(
	function (practice, plan, practiceIsOnboarding, isViewingAsHinter, maybeApiContext, maybePricingVersion) {
		var settings = {ym: isViewingAsHinter, WF: practice, WI: practiceIsOnboarding};
		var _v0 = function () {
			if (!maybeApiContext.$) {
				var _v2 = maybeApiContext.a;
				var apiClient = _v2.a;
				var session = _v2.b;
				return A4($author$project$Components$Plan$Form$RegistrationFeePricingFields$fillAsync, plan, maybePricingVersion, apiClient, session);
			} else {
				return _Utils_Tuple2(
					A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$fill, plan, maybePricingVersion),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var registrationFeePricingForm = _v0.a;
		var regCmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Plan$BasicForm$BasicPlanForm,
				settings,
				$author$project$Utils$Form$init(
					{
						Iq: $author$project$Api$Provider$Plan$One$addon(plan),
						vn: $elm$core$Maybe$Just(
							$author$project$Percentage$fromFloat(
								$author$project$Api$Provider$Plan$One$annualAdjustmentPercent(plan))),
						vo: $author$project$Api$Provider$Plan$One$annualAllowed(plan),
						J0: $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod(plan),
						Kh: $author$project$Api$Provider$Plan$One$buyable(plan),
						p4: $author$project$Api$Provider$Plan$One$imageUrl(plan),
						w4: A2(
							$elm$core$Maybe$andThen,
							$author$project$Utils$String$toMaybe,
							$author$project$Api$Provider$Plan$One$defaultChargeDescription(plan)),
						w5: $author$project$Api$Provider$Plan$One$defaultChargeName(plan),
						Nf: $author$project$Api$Provider$Plan$One$defaultPeriod(plan),
						Nx: A2(
							$author$project$Components$TranslatedRichText$init,
							$author$project$Api$Provider$Plan$One$descriptions(plan),
							'plan-description-language-dropdown'),
						qo: false,
						iy: false,
						lY: false,
						ms: 0,
						QN: $elm$core$Maybe$Nothing,
						T3: $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths(plan),
						y9: $elm$core$Maybe$Just(
							$author$project$Percentage$fromFloat(
								$author$project$Api$Provider$Plan$One$monthAdjustmentPercent(plan))),
						za: $author$project$Api$Provider$Plan$One$monthAllowed(plan),
						zh: $author$project$Api$Provider$Plan$One$name(plan),
						Bf: $elm$core$Maybe$Just(
							$author$project$Percentage$fromFloat(
								$author$project$Api$Provider$Plan$One$quarterAdjustmentPercent(plan))),
						Bg: $author$project$Api$Provider$Plan$One$quarterAllowed(plan),
						Bo: A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Category$Min$id,
							$author$project$Api$Provider$Plan$One$registrationFeeCategory(plan)),
						sl: A2(
							$elm$core$Maybe$withDefault,
							'Unassigned',
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Category$Min$name,
								$author$project$Api$Provider$Plan$One$registrationFeeCategory(plan))),
						Bp: function () {
							if (!maybePricingVersion.$) {
								var pv = maybePricingVersion.a;
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$PricingVersion$One$registrationFeeDescription(pv));
							} else {
								return $author$project$Api$Provider$Plan$One$registrationFeeDescription(plan);
							}
						}(),
						Bq: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Provider$Plan$One$registrationFeeName(plan),
							A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$registrationFeeName, maybePricingVersion)),
						c9: registrationFeePricingForm,
						YY: $author$project$Components$Plan$BasicForm$initRules(
							$author$project$Api$Provider$Plan$One$meta(plan)),
						B6: $elm$core$Maybe$Just(
							$author$project$Percentage$fromFloat(
								$author$project$Api$Provider$Plan$One$semiAnnualAdjustmentPercent(plan))),
						B7: $author$project$Api$Provider$Plan$One$semiAnnualAllowed(plan),
						Hi: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents,
								$author$project$Api$Provider$Plan$One$sponsorFeeDeal(plan)))
					})),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, regCmd));
	});
var $author$project$Api$Provider$Plan$One$childrenAgeLimit = function (_v0) {
	var record = _v0.b;
	return record.v3;
};
var $author$project$Api$Provider$PricingVersion$Shared$childrenAgeLimit = function (_v0) {
	var record = _v0;
	return record.v3;
};
var $author$project$Api$Provider$PricingVersion$One$childrenAgeLimit = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$childrenAgeLimit(shared);
};
var $author$project$Api$Provider$Plan$One$familyNumChildrenIncluded = function (_v0) {
	var record = _v0.b;
	return record.xB;
};
var $author$project$Api$Provider$PricingVersion$Shared$familyNumChildrenIncluded = function (_v0) {
	var record = _v0;
	return record.xB;
};
var $author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyNumChildrenIncluded(shared);
};
var $author$project$Api$Provider$Plan$Shared$additionalAdultDiscountRule = function (_v0) {
	var record = _v0;
	return record.tJ;
};
var $author$project$Api$Provider$Plan$One$additionalAdultDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$additionalAdultDiscountRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$additionalChildDiscountRule = function (_v0) {
	var record = _v0;
	return record.tK;
};
var $author$project$Api$Provider$Plan$One$additionalChildDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$additionalChildDiscountRule(shared);
};
var $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents = function (_v0) {
	var record = _v0;
	return record.I9;
};
var $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited = function (_v0) {
	var record = _v0;
	return record.Ja;
};
var $author$project$Api$Provider$Plan$Shared$childrenOnlyDiscountRule = function (_v0) {
	var record = _v0;
	return record.v4;
};
var $author$project$Api$Provider$Plan$One$childrenOnlyDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$childrenOnlyDiscountRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$coupleDiscountRule = function (_v0) {
	var record = _v0;
	return record.wQ;
};
var $author$project$Api$Provider$Plan$One$coupleDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coupleDiscountRule(shared);
};
var $author$project$Components$Plan$Form$FamilyDiscountRuleField$empty = function (type_) {
	return {I9: $elm$core$Maybe$Nothing, Ja: false, vp: false, Ub: $elm$core$Maybe$Nothing, Uc: false, zc: false, XA: $elm$core$Maybe$Nothing, XB: false, Bh: false, Zn: $elm$core$Maybe$Nothing, Zo: false, B8: false, ahI: type_};
};
var $author$project$Api$Provider$Plan$Shared$familyDiscountRule = function (_v0) {
	var record = _v0;
	return record.xA;
};
var $author$project$Api$Provider$Plan$One$familyDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyDiscountRule(shared);
};
var $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents = function (_v0) {
	var record = _v0;
	return record.Ub;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited = function (_v0) {
	var record = _v0;
	return record.Uc;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents = function (_v0) {
	var record = _v0;
	return record.XA;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited = function (_v0) {
	var record = _v0;
	return record.XB;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents = function (_v0) {
	var record = _v0;
	return record.Zn;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited = function (_v0) {
	var record = _v0;
	return record.Zo;
};
var $author$project$Api$Provider$Plan$Shared$singleParentDiscountRule = function (_v0) {
	var record = _v0;
	return record.Cn;
};
var $author$project$Api$Provider$Plan$One$singleParentDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentDiscountRule(shared);
};
var $author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer = F3(
	function (type_, defaultIfMissing, maybePlan) {
		return function (_v1) {
			var discountRule = _v1.a;
			var defaultIfMissing_ = _v1.b;
			var _v2 = _Utils_Tuple2(discountRule, defaultIfMissing_);
			if (!_v2.a.$) {
				var discountRule_ = _v2.a.a;
				return $elm$core$Maybe$Just(
					{
						I9: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents(discountRule_)),
						Ja: $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited(discountRule_),
						vp: false,
						Ub: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents(discountRule_)),
						Uc: $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited(discountRule_),
						zc: false,
						XA: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents(discountRule_)),
						XB: $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited(discountRule_),
						Bh: false,
						Zn: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents(discountRule_)),
						Zo: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited(discountRule_),
						B8: false,
						ahI: type_
					});
			} else {
				if (_v2.b) {
					var _v3 = _v2.a;
					return $elm$core$Maybe$Just(
						$author$project$Components$Plan$Form$FamilyDiscountRuleField$empty(type_));
				} else {
					var _v4 = _v2.a;
					return $elm$core$Maybe$Nothing;
				}
			}
		}(
			function () {
				switch (type_) {
					case 0:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$coupleDiscountRule, maybePlan),
							defaultIfMissing);
					case 1:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$singleParentDiscountRule, maybePlan),
							defaultIfMissing);
					case 2:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$familyDiscountRule, maybePlan),
							defaultIfMissing);
					case 3:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$additionalAdultDiscountRule, maybePlan),
							defaultIfMissing);
					case 4:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$additionalChildDiscountRule, maybePlan),
							defaultIfMissing);
					default:
						return _Utils_Tuple2(
							A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$childrenOnlyDiscountRule, maybePlan),
							defaultIfMissing);
				}
			}());
	});
var $author$project$Api$Provider$PricingVersion$Shared$additionalAdultDiscountRule = function (_v0) {
	var record = _v0;
	return record.tJ;
};
var $author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$additionalAdultDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$additionalChildDiscountRule = function (_v0) {
	var record = _v0;
	return record.tK;
};
var $author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$additionalChildDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$childrenOnlyDiscountRule = function (_v0) {
	var record = _v0;
	return record.v4;
};
var $author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$childrenOnlyDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$coupleDiscountRule = function (_v0) {
	var record = _v0;
	return record.wQ;
};
var $author$project$Api$Provider$PricingVersion$One$coupleDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$coupleDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$familyDiscountRule = function (_v0) {
	var record = _v0;
	return record.xA;
};
var $author$project$Api$Provider$PricingVersion$One$familyDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyDiscountRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$singleParentDiscountRule = function (_v0) {
	var record = _v0;
	return record.Cn;
};
var $author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$singleParentDiscountRule(shared);
};
var $author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServerAndPricingVersion = F3(
	function (type_, defaultIfMissing, pricingVersion) {
		return function (_v1) {
			var discountRule = _v1.a;
			var defaultIfMissing_ = _v1.b;
			var _v2 = _Utils_Tuple2(discountRule, defaultIfMissing_);
			if (!_v2.a.$) {
				var discountRule_ = _v2.a.a;
				return $elm$core$Maybe$Just(
					{
						I9: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents(discountRule_)),
						Ja: $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited(discountRule_),
						vp: false,
						Ub: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents(discountRule_)),
						Uc: $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited(discountRule_),
						zc: false,
						XA: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents(discountRule_)),
						XB: $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited(discountRule_),
						Bh: false,
						Zn: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents(discountRule_)),
						Zo: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited(discountRule_),
						B8: false,
						ahI: type_
					});
			} else {
				if (_v2.b) {
					var _v3 = _v2.a;
					return $elm$core$Maybe$Just(
						$author$project$Components$Plan$Form$FamilyDiscountRuleField$empty(type_));
				} else {
					var _v4 = _v2.a;
					return $elm$core$Maybe$Nothing;
				}
			}
		}(
			function () {
				switch (type_) {
					case 0:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$coupleDiscountRule(pricingVersion),
							defaultIfMissing);
					case 1:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule(pricingVersion),
							defaultIfMissing);
					case 2:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$familyDiscountRule(pricingVersion),
							defaultIfMissing);
					case 3:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule(pricingVersion),
							defaultIfMissing);
					case 4:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule(pricingVersion),
							defaultIfMissing);
					default:
						return _Utils_Tuple2(
							$author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule(pricingVersion),
							defaultIfMissing);
				}
			}());
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule = F3(
	function (maybePricingVersion, discountRuleType, plan) {
		if (!maybePricingVersion.$) {
			var pricingVersion = maybePricingVersion.a;
			return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServerAndPricingVersion, discountRuleType, false, pricingVersion);
		} else {
			return A3(
				$author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer,
				discountRuleType,
				false,
				$elm$core$Maybe$Just(plan));
		}
	});
var $author$project$Api$Provider$Plan$Meta$additionalAdultDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.tJ.Ot;
};
var $author$project$Api$Provider$Plan$Meta$additionalChildDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.tK.Ot;
};
var $author$project$Api$Provider$Plan$Meta$childrenAgeLimitRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.v3.Ot;
};
var $author$project$Api$Provider$Plan$Meta$childrenOnlyDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.v4.Ot;
};
var $author$project$Api$Provider$Plan$Meta$coupleDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.wQ.Ot;
};
var $author$project$Api$Provider$Plan$Meta$familyDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.xA.Ot;
};
var $author$project$Api$Provider$Plan$Meta$familyNumChildrenIncludedRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.xB.Ot;
};
var $author$project$Api$Provider$PricingVersion$Shared$numberAdditionalChildrenAllowed = function (_v0) {
	var record = _v0;
	return record.zC;
};
var $author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$numberAdditionalChildrenAllowed(shared);
};
var $author$project$Api$Provider$Plan$Meta$numberAdditionalChildrenAllowedRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.zC.Ot;
};
var $author$project$Api$Provider$Plan$Meta$singleParentDiscountRuleRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.Cn.Ot;
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initRules = F2(
	function (meta, maybePricingVersion) {
		var pricingVersionHas = function (accessor) {
			if (!maybePricingVersion.$) {
				var pv = maybePricingVersion.a;
				var _v2 = accessor(pv);
				if (!_v2.$) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		};
		if (!maybePricingVersion.$) {
			return {
				tJ: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule)
				},
				tK: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule)
				},
				v3: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$childrenAgeLimit)
				},
				v4: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule)
				},
				wQ: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$coupleDiscountRule)
				},
				xA: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$familyDiscountRule)
				},
				xB: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded)
				},
				zC: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed)
				},
				Cn: {
					Ot: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule)
				}
			};
		} else {
			return {
				tJ: {
					Ot: $author$project$Api$Provider$Plan$Meta$additionalAdultDiscountRuleRuleEnabled(meta)
				},
				tK: {
					Ot: $author$project$Api$Provider$Plan$Meta$additionalChildDiscountRuleRuleEnabled(meta)
				},
				v3: {
					Ot: $author$project$Api$Provider$Plan$Meta$childrenAgeLimitRuleEnabled(meta)
				},
				v4: {
					Ot: $author$project$Api$Provider$Plan$Meta$childrenOnlyDiscountRuleRuleEnabled(meta)
				},
				wQ: {
					Ot: $author$project$Api$Provider$Plan$Meta$coupleDiscountRuleRuleEnabled(meta)
				},
				xA: {
					Ot: $author$project$Api$Provider$Plan$Meta$familyDiscountRuleRuleEnabled(meta)
				},
				xB: {
					Ot: $author$project$Api$Provider$Plan$Meta$familyNumChildrenIncludedRuleEnabled(meta)
				},
				zC: {
					Ot: $author$project$Api$Provider$Plan$Meta$numberAdditionalChildrenAllowedRuleEnabled(meta)
				},
				Cn: {
					Ot: $author$project$Api$Provider$Plan$Meta$singleParentDiscountRuleRuleEnabled(meta)
				}
			};
		}
	});
var $author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed = function (_v0) {
	var record = _v0.b;
	return record.zC;
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField = F3(
	function (maybePricingVersion, pricingVersionGetter, planValue) {
		if (!maybePricingVersion.$) {
			var pricingVersion = maybePricingVersion.a;
			return pricingVersionGetter(pricingVersion);
		} else {
			return planValue;
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill = F2(
	function (plan, maybePricingVersion) {
		var singleParentDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 1, plan);
		var numberAdditionalChildrenAllowed = A3(
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField,
			maybePricingVersion,
			$author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed,
			$author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed(plan));
		var familyNumChildrenIncluded = A3(
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField,
			maybePricingVersion,
			$author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded,
			$author$project$Api$Provider$Plan$One$familyNumChildrenIncluded(plan));
		var familyDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 2, plan);
		var coupleDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 0, plan);
		var childrenOnlyDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 5, plan);
		var childrenAgeLimit = A3(
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField,
			maybePricingVersion,
			$author$project$Api$Provider$PricingVersion$One$childrenAgeLimit,
			$author$project$Api$Provider$Plan$One$childrenAgeLimit(plan));
		var additionalChildDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 4, plan);
		var additionalAdultDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 3, plan);
		return $author$project$Utils$Form$init(
			{
				tJ: additionalAdultDiscountRule,
				tK: additionalChildDiscountRule,
				v3: childrenAgeLimit,
				v4: childrenOnlyDiscountRule,
				wQ: coupleDiscountRule,
				xA: familyDiscountRule,
				xB: familyNumChildrenIncluded,
				zC: numberAdditionalChildrenAllowed,
				YY: A2(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$initRules,
					$author$project$Api$Provider$Plan$One$meta(plan),
					maybePricingVersion),
				Cn: singleParentDiscountRule
			});
	});
var $author$project$Api$Provider$PricingVersion$Shared$appliesGroupDiscountInTiers = function (_v0) {
	var record = _v0;
	return record.Jj;
};
var $author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$appliesGroupDiscountInTiers(shared);
};
var $author$project$Api$Provider$Plan$One$familyNumAdultsIncluded = function (_v0) {
	var record = _v0.b;
	return record.O6;
};
var $author$project$Api$Provider$PricingVersion$Shared$familyNumAdultsIncluded = function (_v0) {
	var record = _v0;
	return record.O6;
};
var $author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyNumAdultsIncluded(shared);
};
var $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.Pa;
};
var $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.Pa;
};
var $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$One$fixedChildrenAgeLimit = function (_v0) {
	var record = _v0.b;
	return record.Pv;
};
var $author$project$Api$Provider$PricingVersion$Shared$fixedChildrenAgeLimit = function (_v0) {
	var record = _v0;
	return record.Pv;
};
var $author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$fixedChildrenAgeLimit(shared);
};
var $author$project$Api$Provider$Plan$One$groupPricingFamilyNumChildrenIncluded = function (_v0) {
	var record = _v0.b;
	return record.PZ;
};
var $author$project$Api$Provider$PricingVersion$Shared$groupPricingFamilyNumChildrenIncluded = function (_v0) {
	var record = _v0;
	return record.PZ;
};
var $author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$groupPricingFamilyNumChildrenIncluded(shared);
};
var $author$project$Api$Provider$Plan$Shared$additionalAdultRateRule = function (_v0) {
	var record = _v0;
	return record.Io;
};
var $author$project$Api$Provider$Plan$One$additionalAdultRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$additionalAdultRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$additionalAdultRateRule = function (_v0) {
	var record = _v0;
	return record.Io;
};
var $author$project$Api$Provider$PricingVersion$One$additionalAdultRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$additionalAdultRateRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$additionalChildRateRule = function (_v0) {
	var record = _v0;
	return record.Ip;
};
var $author$project$Api$Provider$Plan$One$additionalChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$additionalChildRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$additionalChildRateRule = function (_v0) {
	var record = _v0;
	return record.Ip;
};
var $author$project$Api$Provider$PricingVersion$One$additionalChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$additionalChildRateRule(shared);
};
var $author$project$Api$Provider$RateRule$Shared$annualAmountInCents = function (_v0) {
	var record = _v0;
	return record.c7.I5;
};
var $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.c7.e_;
};
var $author$project$Api$Provider$Plan$Shared$coupleRateRule = function (_v0) {
	var record = _v0;
	return record.L$;
};
var $author$project$Api$Provider$Plan$One$coupleRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$coupleRateRule = function (_v0) {
	var record = _v0;
	return record.L$;
};
var $author$project$Api$Provider$PricingVersion$One$coupleRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$coupleRateRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$familyRateRule = function (_v0) {
	var record = _v0;
	return record.O7;
};
var $author$project$Api$Provider$Plan$One$familyRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$familyRateRule = function (_v0) {
	var record = _v0;
	return record.O7;
};
var $author$project$Api$Provider$PricingVersion$One$familyRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyRateRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.O9;
};
var $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.O9;
};
var $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Components$Plan$Form$FixedRateRuleField$getRateRule = F4(
	function (planGetter, pricingVersionGetter, plan, maybePricingVersion) {
		if (!maybePricingVersion.$) {
			var pricingVersion = maybePricingVersion.a;
			return pricingVersionGetter(pricingVersion);
		} else {
			return planGetter(plan);
		}
	});
var $author$project$Api$Provider$Plan$Shared$individualRateRule = function (_v0) {
	var record = _v0;
	return record.QU;
};
var $author$project$Api$Provider$Plan$One$individualRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$individualRateRule = function (_v0) {
	var record = _v0;
	return record.QU;
};
var $author$project$Api$Provider$PricingVersion$One$individualRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$individualRateRule(shared);
};
var $author$project$Api$Provider$RateRule$Shared$monthAmountInCents = function (_v0) {
	var record = _v0;
	return record.c7.T8;
};
var $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.c7.f5;
};
var $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents = function (_v0) {
	var record = _v0;
	return record.c7.Xw;
};
var $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.c7.gr;
};
var $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents = function (_v0) {
	var record = _v0;
	return record.c7.Zj;
};
var $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.c7.gG;
};
var $author$project$Api$Provider$Plan$Shared$singleParentRateRule = function (_v0) {
	var record = _v0;
	return record.Z8;
};
var $author$project$Api$Provider$Plan$One$singleParentRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$singleParentRateRule = function (_v0) {
	var record = _v0;
	return record.Z8;
};
var $author$project$Api$Provider$PricingVersion$One$singleParentRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record._a;
};
var $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record._a;
};
var $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Components$Plan$Form$FixedRateRuleField$initFromServer = F4(
	function (defaultPeriod, type_, plan, maybePricingVersion) {
		var rateRule = function () {
			switch (type_.$) {
				case 0:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$individualRateRule, $author$project$Api$Provider$PricingVersion$One$individualRateRule, plan, maybePricingVersion);
				case 1:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$coupleRateRule, $author$project$Api$Provider$PricingVersion$One$coupleRateRule, plan, maybePricingVersion);
				case 2:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$singleParentRateRule, $author$project$Api$Provider$PricingVersion$One$singleParentRateRule, plan, maybePricingVersion);
				case 3:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$familyRateRule, $author$project$Api$Provider$PricingVersion$One$familyRateRule, plan, maybePricingVersion);
				case 4:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule, $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRule, plan, maybePricingVersion);
				case 5:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule, $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRule, plan, maybePricingVersion);
				case 6:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$additionalAdultRateRule, $author$project$Api$Provider$PricingVersion$One$additionalAdultRateRule, plan, maybePricingVersion);
				case 7:
					return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$additionalChildRateRule, $author$project$Api$Provider$PricingVersion$One$additionalChildRateRule, plan, maybePricingVersion);
				case 8:
					return $elm$core$Maybe$Nothing;
				case 9:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return function (fixedRateRule) {
			var baseAmountInCents = function () {
				switch (type_.$) {
					case 0:
						return 8000;
					case 1:
						return 10000;
					case 2:
						return 13000;
					case 3:
						return 20000;
					case 4:
						return 11000;
					case 5:
						return 16000;
					case 6:
						return 10000;
					case 7:
						return 10000;
					case 8:
						return 0;
					case 9:
						return 0;
					default:
						return 0;
				}
			}();
			switch (defaultPeriod) {
				case 'month':
					return _Utils_update(
						fixedRateRule,
						{
							T8: $elm$core$Maybe$Just(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Currency$fromInt(baseAmountInCents),
									fixedRateRule.T8))
						});
				case 'annual':
					return _Utils_update(
						fixedRateRule,
						{
							I5: $elm$core$Maybe$Just(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Currency$fromInt(baseAmountInCents * 12),
									fixedRateRule.I5))
						});
				default:
					return fixedRateRule;
			}
		}(
			{
				I5: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$annualAmountInCents, rateRule)),
				e_: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited, rateRule)),
				I6: false,
				T8: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$monthAmountInCents, rateRule)),
				f5: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited, rateRule)),
				F7: false,
				Xw: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents, rateRule)),
				gr: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited, rateRule)),
				Xx: false,
				Zj: A2(
					$elm$core$Maybe$map,
					$author$project$Currency$fromInt,
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents, rateRule)),
				gG: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited, rateRule)),
				Zk: false,
				ahI: type_
			});
	});
var $author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.O6.Ot;
};
var $author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.Pv.Ot;
};
var $author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled = function (_v0) {
	var meta = _v0;
	return meta.YY.PZ.Ot;
};
var $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record._b;
};
var $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record._b;
};
var $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$initRules = F2(
	function (plan, maybePricingVersion) {
		var ruleEnabled = F2(
			function (pvAccessor, planDefault) {
				if (!maybePricingVersion.$) {
					var pv = maybePricingVersion.a;
					return pvAccessor(pv);
				} else {
					return planDefault;
				}
			});
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		return {
			O6: {
				Ot: A2(
					ruleEnabled,
					function (pv) {
						return !_Utils_eq(
							$author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded(pv),
							$elm$core$Maybe$Nothing);
					},
					$author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled(meta))
			},
			O9: {
				Ot: A2(
					ruleEnabled,
					$author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled,
					$author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan))
			},
			Pv: {
				Ot: A2(
					ruleEnabled,
					function (pv) {
						return !_Utils_eq(
							$author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit(pv),
							$elm$core$Maybe$Nothing);
					},
					$author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled(meta))
			},
			PZ: {
				Ot: A2(
					ruleEnabled,
					function (pv) {
						return !_Utils_eq(
							$author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded(pv),
							$elm$core$Maybe$Nothing);
					},
					$author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled(meta))
			},
			_a: {
				Ot: A2(
					ruleEnabled,
					$author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled,
					$author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan))
			}
		};
	});
var $author$project$Api$Provider$Plan$One$splitRevenueType = function (_v0) {
	var record = _v0.b;
	return record._r;
};
var $author$project$Api$Provider$PricingVersion$Shared$splitRevenueType = function (_v0) {
	var record = _v0;
	return record._r;
};
var $author$project$Api$Provider$PricingVersion$One$splitRevenueType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$splitRevenueType(shared);
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$initFromServer = F2(
	function (plan, maybePricingVersion) {
		var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
		var familyRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Family, plan, maybePricingVersion);
		var familyWithSingleChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$FamilyWithSingleChild, plan, maybePricingVersion);
		var individualRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Individual, plan, maybePricingVersion);
		var singleParentRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$SingleParent, plan, maybePricingVersion);
		var singleParentWithSingleChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$SingleParentWithSingleChild, plan, maybePricingVersion);
		var coupleRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Couple, plan, maybePricingVersion);
		var additionalChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$AdditionalChild, plan, maybePricingVersion);
		var additionalAdultRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$AdditionalAdult, plan, maybePricingVersion);
		return $author$project$Utils$Form$init(
			{
				Io: additionalAdultRateRule,
				Ip: additionalChildRateRule,
				Jj: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							$author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers(pv));
					} else {
						return A2(
							$elm$core$Maybe$withDefault,
							false,
							$author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan));
					}
				}(),
				L$: coupleRateRule,
				O6: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return $author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded(pv);
					} else {
						return $author$project$Api$Provider$Plan$One$familyNumAdultsIncluded(plan);
					}
				}(),
				O7: familyRateRule,
				O9: familyWithSingleChildRateRule,
				Pa: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan),
					A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled, maybePricingVersion)),
				Pv: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return $author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit(pv);
					} else {
						return $author$project$Api$Provider$Plan$One$fixedChildrenAgeLimit(plan);
					}
				}(),
				PZ: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return $author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded(pv);
					} else {
						return $author$project$Api$Provider$Plan$One$groupPricingFamilyNumChildrenIncluded(plan);
					}
				}(),
				QU: individualRateRule,
				YY: A2($author$project$Components$Plan$Form$GroupTierPricingFields$initRules, plan, maybePricingVersion),
				Z8: singleParentRateRule,
				_a: singleParentWithSingleChildRateRule,
				_b: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan),
					A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled, maybePricingVersion)),
				_r: function () {
					if (!maybePricingVersion.$) {
						var pv = maybePricingVersion.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'even_children',
							$author$project$Api$Provider$PricingVersion$One$splitRevenueType(pv));
					} else {
						return A2(
							$elm$core$Maybe$withDefault,
							'even_children',
							$author$project$Api$Provider$Plan$One$splitRevenueType(plan));
					}
				}()
			});
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$fill = F2(
	function (plan, maybePricingVersion) {
		return A2($author$project$Components$Plan$Form$GroupTierPricingFields$initFromServer, plan, maybePricingVersion);
	});
var $author$project$Api$Provider$PricingVersion$Shared$ageRateRules = function (_v0) {
	var record = _v0;
	return record.IL;
};
var $author$project$Api$Provider$PricingVersion$One$ageRateRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$ageRateRules(shared);
};
var $author$project$Components$Plan$Form$AgeRateRuleField$empty = {
	L_: $elm$core$Maybe$Nothing,
	PH: 0,
	c7: {
		I5: $elm$core$Maybe$Nothing,
		e_: false,
		I6: false,
		T8: $elm$core$Maybe$Just($author$project$Currency$zero),
		f5: false,
		F7: false,
		Xw: $elm$core$Maybe$Nothing,
		gr: false,
		Xx: false,
		Zj: $elm$core$Maybe$Nothing,
		gG: false,
		Zk: false
	},
	$I: $elm$core$Maybe$Nothing,
	aai: 0
};
var $author$project$Currency$multiply = F2(
	function (_int, currency) {
		return A2(
			$elm$core$Maybe$withDefault,
			currency,
			A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$mul(_int),
					$author$project$Currency$toInt(currency))));
	});
var $author$project$Components$Plan$Form$AgeRateRuleField$default = function (defaultPeriod) {
	var defaultAmount = $author$project$Currency$fromInt(5000);
	if (defaultPeriod === 'month') {
		var updatedPeriodRates = $author$project$Components$Plan$Form$AgeRateRuleField$empty.c7;
		return _Utils_update(
			$author$project$Components$Plan$Form$AgeRateRuleField$empty,
			{
				c7: _Utils_update(
					updatedPeriodRates,
					{
						T8: $elm$core$Maybe$Just(defaultAmount)
					})
			});
	} else {
		var updatedPeriodRates = $author$project$Components$Plan$Form$AgeRateRuleField$empty.c7;
		return _Utils_update(
			$author$project$Components$Plan$Form$AgeRateRuleField$empty,
			{
				c7: _Utils_update(
					updatedPeriodRates,
					{
						I5: $elm$core$Maybe$Just(
							A2($author$project$Currency$multiply, 12, defaultAmount))
					})
			});
	}
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules = function (defaultPeriod) {
	return _List_fromArray(
		[
			$author$project$Components$Plan$Form$AgeRateRuleField$default(defaultPeriod)
		]);
};
var $author$project$Components$Plan$Form$AgeRateRuleField$convertCoupleAgeRateRule = function (serverCoupleRule) {
	return {
		c7: {
			I5: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.c7.I5),
			e_: serverCoupleRule.c7.e_,
			I6: false,
			T8: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.c7.T8),
			f5: serverCoupleRule.c7.f5,
			F7: false,
			Xw: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.c7.Xw),
			gr: serverCoupleRule.c7.gr,
			Xx: false,
			Zj: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.c7.Zj),
			gG: serverCoupleRule.c7.gG,
			Zk: false
		}
	};
};
var $author$project$Api$Provider$RateRule$Shared$coupleAgeRateRule = function (_v0) {
	var record = _v0;
	return record.L_;
};
var $author$project$Api$Provider$RateRule$Shared$unit = function (_v0) {
	var record = _v0;
	return record.aai;
};
var $author$project$Components$Plan$Form$AgeRateRuleField$initFromServer = function (ageRateRule) {
	return {
		L_: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Plan$Form$AgeRateRuleField$convertCoupleAgeRateRule,
			$author$project$Api$Provider$RateRule$Shared$coupleAgeRateRule(ageRateRule)),
		PH: $author$project$Api$Provider$RateRule$Shared$fromAge(ageRateRule),
		c7: {
			I5: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$RateRule$Shared$annualAmountInCents(ageRateRule)),
			e_: $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited(ageRateRule),
			I6: false,
			T8: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$RateRule$Shared$monthAmountInCents(ageRateRule)),
			f5: $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited(ageRateRule),
			F7: false,
			Xw: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$RateRule$Shared$quarterAmountInCents(ageRateRule)),
			gr: $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited(ageRateRule),
			Xx: false,
			Zj: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents(ageRateRule)),
			gG: $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited(ageRateRule),
			Zk: false
		},
		$I: $author$project$Api$Provider$RateRule$Shared$toAge(ageRateRule),
		aai: $author$project$Api$Provider$RateRule$Shared$unit(ageRateRule)
	};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill = F2(
	function (plan, maybePricingVersion) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var ageRateRules = function () {
			if (!maybePricingVersion.$) {
				var pricingVersion = maybePricingVersion.a;
				return A2(
					$elm$core$List$map,
					$author$project$Components$Plan$Form$AgeRateRuleField$initFromServer,
					$author$project$Api$Provider$PricingVersion$One$ageRateRules(pricingVersion));
			} else {
				return A2(
					$elm$core$List$map,
					$author$project$Components$Plan$Form$AgeRateRuleField$initFromServer,
					$author$project$Api$Provider$Plan$One$ageRateRules(plan));
			}
		}();
		return $author$project$Utils$Form$init(
			{
				IL: function () {
					if ((planType !== 1) && $elm$core$List$isEmpty(ageRateRules)) {
						var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
						return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules(defaultPeriod);
					} else {
						return ageRateRules;
					}
				}()
			});
	});
var $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents = function (_v0) {
	var record = _v0;
	return record.I5;
};
var $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.e_;
};
var $author$project$Api$Provider$SpecialRate$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$SpecialRate$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.RJ;
};
var $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents = function (_v0) {
	var record = _v0;
	return record.T8;
};
var $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.f5;
};
var $author$project$Api$Provider$SpecialRate$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents = function (_v0) {
	var record = _v0;
	return record.Xw;
};
var $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.gr;
};
var $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents = function (_v0) {
	var record = _v0;
	return record.Zj;
};
var $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited = function (_v0) {
	var record = _v0;
	return record.gG;
};
var $author$project$Components$Plan$Form$SpecialRateField$initFromServer = function (specialRate) {
	return {
		I5: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(specialRate)),
		e_: $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited(specialRate),
		I6: false,
		Me: false,
		NB: false,
		adR: $elm$core$Maybe$Just(
			$author$project$Api$Provider$SpecialRate$Shared$id(specialRate)),
		RJ: $author$project$Api$Provider$SpecialRate$Shared$isDestroyable(specialRate),
		T8: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(specialRate)),
		f5: $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited(specialRate),
		F7: false,
		zh: $author$project$Api$Provider$SpecialRate$Shared$name(specialRate),
		Xw: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(specialRate)),
		gr: $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited(specialRate),
		Xx: false,
		Zj: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(specialRate)),
		gG: $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited(specialRate),
		Zk: false
	};
};
var $author$project$Api$Provider$Plan$Shared$specialRates = function (_v0) {
	var record = _v0;
	return record._o;
};
var $author$project$Api$Provider$Plan$One$specialRates = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$specialRates = function (_v0) {
	var record = _v0;
	return record._o;
};
var $author$project$Api$Provider$PricingVersion$One$specialRates = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$specialRates(shared);
};
var $author$project$Components$Plan$Form$SpecialRateField$updateFromServer = F2(
	function (serverSpecialRates, specialRate) {
		var matchingServerSpecialRate = A2(
			$elm_community$list_extra$List$Extra$find,
			function (serverSpecialRate) {
				return _Utils_eq(
					specialRate.zh,
					$author$project$Api$Provider$SpecialRate$Shared$name(serverSpecialRate));
			},
			serverSpecialRates);
		if (!matchingServerSpecialRate.$) {
			var matchingServerSpecialRate_ = matchingServerSpecialRate.a;
			return _Utils_update(
				specialRate,
				{
					I5: A2(
						$elm$core$Maybe$map,
						$author$project$Currency$fromInt,
						$author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(matchingServerSpecialRate_)),
					e_: $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited(matchingServerSpecialRate_),
					I6: false,
					adR: $elm$core$Maybe$Just(
						$author$project$Api$Provider$SpecialRate$Shared$id(matchingServerSpecialRate_)),
					RJ: $author$project$Api$Provider$SpecialRate$Shared$isDestroyable(matchingServerSpecialRate_),
					T8: A2(
						$elm$core$Maybe$map,
						$author$project$Currency$fromInt,
						$author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(matchingServerSpecialRate_)),
					f5: $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited(matchingServerSpecialRate_),
					F7: false,
					Xw: A2(
						$elm$core$Maybe$map,
						$author$project$Currency$fromInt,
						$author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(matchingServerSpecialRate_)),
					gr: $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited(matchingServerSpecialRate_),
					Xx: false,
					Zj: A2(
						$elm$core$Maybe$map,
						$author$project$Currency$fromInt,
						$author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(matchingServerSpecialRate_)),
					gG: $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited(matchingServerSpecialRate_),
					Zk: false
				});
		} else {
			return specialRate;
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$initFromServer = F3(
	function (currentSpecialRates, plan, maybePricingVersion) {
		var serverSpecialRates = function () {
			if (!maybePricingVersion.$) {
				var pricingVersion = maybePricingVersion.a;
				return $author$project$Api$Provider$PricingVersion$One$specialRates(pricingVersion);
			} else {
				return $author$project$Api$Provider$Plan$One$specialRates(plan);
			}
		}();
		var specialRates = function () {
			if (!currentSpecialRates.$) {
				var currentSpecialRates_ = currentSpecialRates.a;
				return A2(
					$elm$core$List$map,
					$author$project$Components$Plan$Form$SpecialRateField$updateFromServer(serverSpecialRates),
					currentSpecialRates_);
			} else {
				return A2($elm$core$List$map, $author$project$Components$Plan$Form$SpecialRateField$initFromServer, serverSpecialRates);
			}
		}();
		return $author$project$Utils$Form$init(
			{_o: specialRates});
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$fill = F2(
	function (plan, maybePricingVersion) {
		return A3($author$project$Components$Plan$Form$SpecialRatesFields$initFromServer, $elm$core$Maybe$Nothing, plan, maybePricingVersion);
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$fillWithCurrent = F3(
	function (currentSpecialRates, plan, maybePricingVersion) {
		return A3(
			$author$project$Components$Plan$Form$SpecialRatesFields$initFromServer,
			$elm$core$Maybe$Just(currentSpecialRates),
			plan,
			maybePricingVersion);
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm = F3(
	function (maybeCurrentForm, plan, maybePricingVersion) {
		if (!maybeCurrentForm.$) {
			var currentForm = maybeCurrentForm.a;
			var currentSpecialRates = $author$project$Components$Plan$Form$SpecialRatesFields$formFields(currentForm)._o;
			return A3($author$project$Components$Plan$Form$SpecialRatesFields$fillWithCurrent, currentSpecialRates, plan, maybePricingVersion);
		} else {
			return A2($author$project$Components$Plan$Form$SpecialRatesFields$fill, plan, maybePricingVersion);
		}
	});
var $author$project$Api$Provider$Plan$Shared$groupDiscountRules = function (_v0) {
	var record = _v0;
	return record.PW;
};
var $author$project$Api$Provider$Plan$One$groupDiscountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$groupDiscountRules(shared);
};
var $author$project$Api$Provider$Plan$Shared$groupPricingType = function (_v0) {
	var record = _v0;
	return record.P_;
};
var $author$project$Api$Provider$Plan$One$groupPricingType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
};
var $author$project$Components$Plan$Form$PlanChange$init = {
	bU: false,
	Vx: {KN: $elm$core$Maybe$Nothing, KO: $elm$core$Maybe$Nothing, LQ: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, $J: $elm$core$Maybe$Nothing, ahI: 1},
	jL: false
};
var $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCents = function (_v0) {
	var record = _v0;
	return record.I7;
};
var $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCentsEdited = function (_v0) {
	var record = _v0;
	return record.I8;
};
var $author$project$Api$Provider$DiscountRule$Shared$annualPercentOff = function (_v0) {
	var record = _v0;
	return record.Jd;
};
var $author$project$Api$Provider$DiscountRule$Shared$annualPercentOffEdited = function (_v0) {
	var record = _v0;
	return record.Je;
};
var $author$project$Api$Provider$DiscountRule$Shared$calculatedBy = function (_v0) {
	var record = _v0;
	return record.Km;
};
var $author$project$Api$Provider$DiscountRule$Shared$fromSize = function (_v0) {
	var record = _v0;
	return record.PJ;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCents = function (_v0) {
	var record = _v0;
	return record.T9;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCentsEdited = function (_v0) {
	var record = _v0;
	return record.Ua;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthPercentOff = function (_v0) {
	var record = _v0;
	return record.Ug;
};
var $author$project$Api$Provider$DiscountRule$Shared$monthPercentOffEdited = function (_v0) {
	var record = _v0;
	return record.Uh;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCents = function (_v0) {
	var record = _v0;
	return record.Xy;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCentsEdited = function (_v0) {
	var record = _v0;
	return record.Xz;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOff = function (_v0) {
	var record = _v0;
	return record.XE;
};
var $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOffEdited = function (_v0) {
	var record = _v0;
	return record.XF;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCents = function (_v0) {
	var record = _v0;
	return record.Zl;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCentsEdited = function (_v0) {
	var record = _v0;
	return record.Zm;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOff = function (_v0) {
	var record = _v0;
	return record.Zr;
};
var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOffEdited = function (_v0) {
	var record = _v0;
	return record.Zs;
};
var $author$project$Api$Provider$DiscountRule$Shared$toSize = function (_v0) {
	var record = _v0;
	return record.$K;
};
var $author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer = function (groupDiscountRule) {
	return {
		I7: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCents(groupDiscountRule)),
		I8: $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCentsEdited(groupDiscountRule),
		D3: false,
		Jd: A2(
			$elm$core$Maybe$map,
			$author$project$Percentage$fromFloat,
			$author$project$Api$Provider$DiscountRule$Shared$annualPercentOff(groupDiscountRule)),
		Je: $author$project$Api$Provider$DiscountRule$Shared$annualPercentOffEdited(groupDiscountRule),
		pw: false,
		Km: $author$project$Api$Provider$DiscountRule$Shared$calculatedBy(groupDiscountRule),
		PJ: $author$project$Api$Provider$DiscountRule$Shared$fromSize(groupDiscountRule),
		T9: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCents(groupDiscountRule)),
		Ua: $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCentsEdited(groupDiscountRule),
		F8: false,
		Ug: A2(
			$elm$core$Maybe$map,
			$author$project$Percentage$fromFloat,
			$author$project$Api$Provider$DiscountRule$Shared$monthPercentOff(groupDiscountRule)),
		Uh: $author$project$Api$Provider$DiscountRule$Shared$monthPercentOffEdited(groupDiscountRule),
		m6: false,
		Xy: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCents(groupDiscountRule)),
		Xz: $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCentsEdited(groupDiscountRule),
		GV: false,
		XE: A2(
			$elm$core$Maybe$map,
			$author$project$Percentage$fromFloat,
			$author$project$Api$Provider$DiscountRule$Shared$quarterPercentOff(groupDiscountRule)),
		XF: $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOffEdited(groupDiscountRule),
		si: false,
		Zl: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCents(groupDiscountRule)),
		Zm: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCentsEdited(groupDiscountRule),
		G8: false,
		Zr: A2(
			$elm$core$Maybe$map,
			$author$project$Percentage$fromFloat,
			$author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOff(groupDiscountRule)),
		Zs: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOffEdited(groupDiscountRule),
		sG: false,
		$K: $author$project$Api$Provider$DiscountRule$Shared$toSize(groupDiscountRule)
	};
};
var $author$project$Components$Plan$Form$initRules = function (meta) {
	return {
		O6: {
			Ot: $author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled(meta)
		},
		Pv: {
			Ot: $author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled(meta)
		},
		PZ: {
			Ot: $author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled(meta)
		}
	};
};
var $author$project$Api$Provider$Plan$One$iua = function (_v0) {
	var record = _v0.b;
	return record.So;
};
var $author$project$Api$Provider$Plan$Shared$maximumAge = function (_v0) {
	var record = _v0;
	return record.Tu;
};
var $author$project$Api$Provider$Plan$One$maximumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Provider$Plan$Shared$minimumAge = function (_v0) {
	var record = _v0;
	return record.T1;
};
var $author$project$Api$Provider$Plan$One$minimumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Provider$Plan$One$pricingEffectivenessType = function (_v0) {
	var record = _v0.b;
	return record.W0;
};
var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeInCents = function (_v0) {
	var record = _v0;
	return record.$M;
};
var $author$project$Api$Provider$Plan$One$tobaccoSurchargeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeInCents(shared);
};
var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargePercentage = function (_v0) {
	var record = _v0;
	return record.$N;
};
var $author$project$Api$Provider$Plan$One$tobaccoSurchargePercentage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargePercentage(shared);
};
var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType = function (_v0) {
	var record = _v0;
	return record.$O;
};
var $author$project$Api$Provider$Plan$One$tobaccoSurchargeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Components$Plan$Form$initFormFields = F4(
	function (apiClient, model, currentPlanChange, plan) {
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var minimumAge = $author$project$Api$Provider$Plan$One$minimumAge(plan);
		var membershipPricingForm = A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var maximumAge = $author$project$Api$Provider$Plan$One$maximumAge(plan);
		var groupTierPricingForm = A2($author$project$Components$Plan$Form$GroupTierPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var groupDiscountRules = A2(
			$elm$core$List$map,
			$author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer,
			$author$project$Api$Provider$Plan$One$groupDiscountRules(plan));
		var familyPricingForm = A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var currentSpecialRatesForm = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.de;
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Form$fields,
				A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.PB)));
		var specialRatesForm = A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, currentSpecialRatesForm, plan, $elm$core$Maybe$Nothing);
		var coveragePlan = function () {
			var _v2 = $author$project$Api$Provider$Plan$One$coveragePlan(plan);
			if ((!_v2.$) && (!_v2.a.$)) {
				var coveragePlan_ = _v2.a.a;
				return $elm$core$Maybe$Just(
					$author$project$Components$Plan$Form$CoveragePlanOne(coveragePlan_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = model;
		var practice = _v0.WF;
		var _v1 = A6(
			$author$project$Components$Plan$BasicForm$fill,
			practice,
			plan,
			model.WI,
			A2($author$project$Utils$User$isViewingAsHinter, model.ZD, model.adN),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(apiClient, model.ZD)),
			$elm$core$Maybe$Nothing);
		var basicPlanForm = _v1.a;
		var basicPlanFormCmd = _v1.b;
		return _Utils_Tuple2(
			{
				Jj: A2(
					$elm$core$Maybe$withDefault,
					false,
					$author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan)),
				aA: basicPlanForm,
				LO: $author$project$Api$Provider$Plan$One$contractEmailsEnabled(plan),
				LP: $author$project$Api$Provider$Plan$One$contractExpires(plan),
				LQ: $author$project$Api$Provider$Plan$One$contractPeriodInMonths(plan),
				LR: $author$project$Api$Provider$Plan$One$contractRenewalEmailLeadTime(plan),
				EI: $author$project$Api$Provider$Plan$One$contractType(plan),
				L5: coveragePlan,
				xg: $author$project$Api$Provider$Plan$One$discountsEnabled(plan),
				xi: (!_Utils_eq(maximumAge, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
					maximumAge,
					$elm$core$Maybe$Just(0))),
				xj: (!_Utils_eq(minimumAge, $elm$core$Maybe$Nothing)) && (!_Utils_eq(
					minimumAge,
					$elm$core$Maybe$Just(0))),
				cU: familyPricingForm,
				PW: function () {
					if ((planType !== 1) && $elm$core$List$isEmpty(groupDiscountRules)) {
						var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
						return $author$project$Components$Plan$Form$defaultGroupRules(defaultPeriod);
					} else {
						return groupDiscountRules;
					}
				}(),
				P_: $author$project$Api$Provider$Plan$One$groupPricingType(plan),
				i: groupTierPricingForm,
				So: $author$project$Api$Provider$Plan$One$iua(plan),
				Tu: maximumAge,
				cX: membershipPricingForm,
				T1: minimumAge,
				ju: A2($elm$core$Maybe$withDefault, $author$project$Components$Plan$Form$PlanChange$init, currentPlanChange),
				W0: $author$project$Api$Provider$Plan$One$pricingEffectivenessType(plan),
				YY: $author$project$Components$Plan$Form$initRules(
					$author$project$Api$Provider$Plan$One$meta(plan)),
				de: specialRatesForm,
				$M: $elm$core$Maybe$Just(
					$author$project$Currency$fromInt(
						$author$project$Api$Provider$Plan$One$tobaccoSurchargeInCents(plan))),
				$N: $elm$core$Maybe$Just(
					$author$project$Percentage$fromFloat(
						$author$project$Api$Provider$Plan$One$tobaccoSurchargePercentage(plan))),
				$O: $author$project$Api$Provider$Plan$One$tobaccoSurchargeType(plan)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$BasicPlanFormUpdated, basicPlanFormCmd));
	});
var $author$project$Components$ResourceFilter$Plan$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Plan$EmployerAll = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Plan$ProviderAll = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$Plan$All$Plan = $elm$core$Basics$identity;
var $author$project$Api$Employer$Plan$Shared$Plan = $elm$core$Basics$identity;
var $author$project$Api$Employer$Plan$Shared$Record = function (id) {
	return function (name) {
		return function (planType) {
			return function (allowedBillingPeriodCodes) {
				return function (defaultPeriodInMonths) {
					return function (defaultPeriod) {
						return function (maximumAge) {
							return function (minimumAge) {
								return function (tobaccoSurchargeType) {
									return function (groupPricingType) {
										return function (maxRegistrationFeeInCents) {
											return function (individualRegistrationFeeInCents) {
												return function (billsAtEndOfPeriod) {
													return function (minimumEnrollmentPeriodInMonths) {
														return function (ageRateRules) {
															return function (individualRateRule) {
																return function (coupleRateRule) {
																	return function (singleParentWithSingleChildRateRuleEnabled) {
																		return function (singleParentWithSingleChildRateRule) {
																			return function (singleParentRateRule) {
																				return function (familyWithSingleChildRateRuleEnabled) {
																					return function (familyWithSingleChildRateRule) {
																						return function (familyRateRule) {
																							return function (sponsorFeeDeal) {
																								return {IL: ageRateRules, D1: allowedBillingPeriodCodes, J0: billsAtEndOfPeriod, L$: coupleRateRule, Nf: defaultPeriod, Ng: defaultPeriodInMonths, O7: familyRateRule, O9: familyWithSingleChildRateRule, Pa: familyWithSingleChildRateRuleEnabled, P_: groupPricingType, adR: id, QU: individualRateRule, QW: individualRegistrationFeeInCents, Tr: maxRegistrationFeeInCents, Tu: maximumAge, T1: minimumAge, T3: minimumEnrollmentPeriodInMonths, zh: name, Wp: planType, Z8: singleParentRateRule, _a: singleParentWithSingleChildRateRule, _b: singleParentWithSingleChildRateRuleEnabled, _u: sponsorFeeDeal, $O: tobaccoSurchargeType};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$RateRule$Shared$RateRule = $elm$core$Basics$identity;
var $author$project$Api$Employer$RateRule$Shared$Record = F8(
	function (type_, fromAge, toAge, unit, monthAmountInCents, quarterAmountInCents, semiAnnualAmountInCents, annualAmountInCents) {
		return {I5: annualAmountInCents, PH: fromAge, T8: monthAmountInCents, Xw: quarterAmountInCents, Zj: semiAnnualAmountInCents, $I: toAge, ahI: type_, aai: unit};
	});
var $author$project$Api$Employer$RateRule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'annual_amount_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'semi_annual_amount_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'quarter_amount_in_cents',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'month_amount_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unit',
					A2($elm$json$Json$Decode$map, $author$project$Api$Provider$RateRule$Shared$stringToUnit, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'to_age',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'from_age',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'type',
								$author$project$Api$RateRuleType$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Employer$RateRule$Shared$Record)))))))));
var $author$project$Api$Employer$RateRule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$RateRule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$SponsorFeeDeal$Shared$SponsorFeeDeal = $elm$core$Basics$identity;
var $author$project$Api$Employer$SponsorFeeDeal$Shared$Record = function (amountInCents) {
	return {I2: amountInCents};
};
var $author$project$Api$Employer$SponsorFeeDeal$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$SponsorFeeDeal$Shared$Record));
var $author$project$Api$Employer$SponsorFeeDeal$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$SponsorFeeDeal$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sponsor_fee_deal',
	$elm$json$Json$Decode$nullable($author$project$Api$Employer$SponsorFeeDeal$Shared$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'family_rate_rule',
		$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'family_with_single_child_rate_rule',
			$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'family_with_single_child_rate_rule_enabled',
				$elm$json$Json$Decode$bool,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'single_parent_rate_rule',
					$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'single_parent_with_single_child_rate_rule',
						$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'single_parent_with_single_child_rate_rule_enabled',
							$elm$json$Json$Decode$bool,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'couple_rate_rule',
								$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
								$elm$core$Maybe$Nothing,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'individual_rate_rule',
									$elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder),
									$elm$core$Maybe$Nothing,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'age_rate_rules',
										$elm$json$Json$Decode$list($author$project$Api$Employer$RateRule$Shared$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'minimum_enrollment_period_in_months',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'bills_at_end_of_period',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'individual_registration_fee_in_cents',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'max_registration_fee_in_cents',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'group_pricing_type',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'tobacco_surcharge_type',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'minimum_age',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'maximum_age',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'default_period',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'default_period_in_months',
																				$elm$json$Json$Decode$int,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'allowed_billing_period_codes',
																					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'plan_type',
																						$author$project$Api$PlanType$decoder,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'name',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'id',
																								$elm$json$Json$Decode$string,
																								$elm$json$Json$Decode$succeed($author$project$Api$Employer$Plan$Shared$Record)))))))))))))))))))))))));
var $author$project$Api$Employer$Plan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Plan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Plan$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$listDefaults = {af_: $elm$core$Maybe$Nothing};
var $author$project$Api$Employer$Plan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$Plan$listDefaults);
	var _v0 = options.af_;
	if (!_v0.$) {
		var string = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'q', string)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Employer$Plan$plansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['plans']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Plan$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Plan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$Plan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Plan$plansPath)));
	});
var $author$project$Api$Provider$Plan$All$Plan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$All$Record = F6(
	function (defaultPeriod, maxRegistrationFeeInCents, individualRegistrationFeeInCents, contractExpires, contractPeriodInMonths, contractType) {
		return {LP: contractExpires, LQ: contractPeriodInMonths, EI: contractType, Nf: defaultPeriod, QW: individualRegistrationFeeInCents, Tr: maxRegistrationFeeInCents};
	});
var $author$project$Api$Provider$Plan$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contract_type',
	$elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contract_period_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'contract_expires',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'individual_registration_fee_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'max_registration_fee_in_cents',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_period',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$All$Record)))))));
var $author$project$Api$Provider$Plan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Plan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$All$Plan)));
var $author$project$Api$Provider$Plan$listDefaults = {
	D8: $elm$core$Maybe$Nothing,
	D9: $elm$core$Maybe$Nothing,
	Ea: $elm$core$Maybe$Nothing,
	J0: $elm$core$Maybe$Nothing,
	Fc: _List_Nil,
	adR: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	AS: _List_Nil,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$PlanType$toString = function (planType) {
	switch (planType) {
		case 0:
			return 'company';
		case 1:
			return 'sponsor_fixed_fee';
		case 2:
			return 'retail';
		case 3:
			return 'mce';
		default:
			return 'affiliate_dependable';
	}
};
var $author$project$Api$Provider$Plan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Plan$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$elm$core$List$isEmpty(options.AS) ? _List_Nil : _List_fromArray(
				[
					A2(
					$author$project$Api$Param$string,
					'plan_type',
					A2(
						$elm$core$String$join,
						',',
						A2($elm$core$List$map, $author$project$Api$PlanType$toString, options.AS)))
				]),
				_List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, options.Fc))
				]),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				function () {
				var _v2 = options.Ea;
				if (!_v2.$) {
					var coveragePlanId = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'available_for_coverage_plan', coveragePlanId)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.D9;
				if (!_v3.$) {
					var companyId = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'available_for_company', companyId)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.D8;
				if (!_v4.$) {
					var affiliateId = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'available_for_affiliation', affiliateId)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.J0;
				if (!_v5.$) {
					var bool = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'bills_at_end_of_period', bool)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Plan$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Plan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Plan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
	});
var $author$project$Api$Plan$list = F4(
	function (apiClient, session, optionals, toMsg) {
		if ($author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			var options = optionals($author$project$Api$Provider$Plan$listDefaults);
			return A3(
				$author$project$Api$Employer$Plan$list,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{af_: options.af_});
				},
				A2(
					$elm$core$Basics$composeL,
					toMsg,
					$author$project$Api$Data$map(
						$elm$core$List$map($author$project$Api$Plan$EmployerAll))));
		} else {
			return A3(
				$author$project$Api$Provider$Plan$list,
				apiClient,
				optionals,
				A2(
					$elm$core$Basics$composeL,
					toMsg,
					$author$project$Api$Data$map(
						$elm$core$List$map($author$project$Api$Plan$ProviderAll))));
		}
	});
var $author$project$Components$ResourceFilter$Plan$list = $author$project$Api$Plan$list;
var $author$project$Components$ResourceFilter$Plan$fetchResources = F6(
	function (session, listOptionals, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$list,
			apiClient,
			session,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Plan$retrieveResource = F5(
	function (session, listOptionals, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$list,
			apiClient,
			session,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Plan$selectId = 'plans';
var $author$project$Components$ResourceFilter$Plan$toTitle = $author$project$Api$Plan$name;
var $author$project$Components$ResourceFilter$Plan$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Plan$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Plan$toValue = $author$project$Api$Plan$id;
var $author$project$Components$ResourceFilter$Plan$init = F4(
	function (apiClient, session, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: A2($author$project$Components$ResourceFilter$Plan$fetchResources, session, listOptionals),
				adR: $author$project$Components$ResourceFilter$Plan$selectId,
				gx: 'Plan',
				st: A2($author$project$Components$ResourceFilter$Plan$retrieveResource, session, listOptionals),
				ahw: $author$project$Components$ResourceFilter$Plan$toLabel,
				ahA: $author$project$Components$ResourceFilter$Plan$toTitle,
				g0: $author$project$Components$ResourceFilter$Plan$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Plan$Form$initPlanChangeToPlanResourceFilter = F3(
	function (apiClient, session, planType) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						AS: _List_fromArray(
							[planType])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Plan'});
			});
	});
var $author$project$Components$Plan$Form$resetParamsOnScope = F3(
	function (apiClient, response, model) {
		if (response.$ === 3) {
			var plan = response.a;
			var planType = $author$project$Api$Provider$Plan$One$planType(plan);
			var planChangeEnabled = (A2(
				$author$project$Utils$FeatureGate$gateAvailable,
				6,
				$author$project$Api$Practice$Provider(model.WF)) && (!planType)) || ((planType === 2) || (planType === 3));
			var currentPlanChange = A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ju;
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Utils$Form$fields,
					A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.PB)));
			var _v1 = (planChangeEnabled && _Utils_eq(model.gn, $elm$core$Maybe$Nothing)) ? A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A3($author$project$Components$Plan$Form$initPlanChangeToPlanResourceFilter, apiClient, model.ZD, planType)) : _Utils_Tuple2(model.gn, $elm$core$Platform$Cmd$none);
			var planChangeToPlanResourceFilter = _v1.a;
			var planChangeToPlanResourceFilterCmd = _v1.b;
			var _v2 = A4($author$project$Components$Plan$Form$initFormFields, apiClient, model, currentPlanChange, plan);
			var formFields = _v2.a;
			var formFieldsCmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						PB: $elm$core$Maybe$Just(
							_Utils_Tuple2(
								plan,
								$author$project$Utils$Form$init(formFields))),
						FU: response,
						jv: planChangeEnabled,
						gn: planChangeToPlanResourceFilter
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg, planChangeToPlanResourceFilterCmd),
							formFieldsCmd
						])),
				_List_Nil);
		} else {
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Plan$Form$SubsequentPlanDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$SubsequentPlan$delete = F3(
	function (apiClient, planId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)));
	});
var $author$project$Components$Plan$Form$PlanUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$Plan$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'plan',
					$author$project$Api$Provider$Plan$encodeUpdateFields(fields))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Plan$planPath(id))));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields = function (_v0) {
	var form = _v0;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Percentage$zero = '0';
var $author$project$Components$Plan$Form$updatePlanFields = function (formFields) {
	var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(formFields.cX);
	var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(formFields.cU);
	var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(formFields.aA);
	var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.c9);
	return {
		tJ: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
			},
			familyMembershipPricingFormFields.YY.tJ.Ot ? familyMembershipPricingFormFields.tJ : $elm$core$Maybe$Nothing),
		Io: function () {
			if ($author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).YY.O6.Ot) {
				var additionalAdultRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Io;
				return $elm$core$Maybe$Just(
					{I5: additionalAdultRateRule.I5, e_: additionalAdultRateRule.e_, T8: additionalAdultRateRule.T8, f5: additionalAdultRateRule.f5, Xw: additionalAdultRateRule.Xw, gr: additionalAdultRateRule.gr, Zj: additionalAdultRateRule.Zj, gG: additionalAdultRateRule.gG});
			} else {
				if ((formFields.P_ === 'family') && (!_Utils_eq(familyMembershipPricingFormFields.tJ, $elm$core$Maybe$Nothing))) {
					return A2(
						$elm$core$Maybe$map,
						function (familyDiscountRule) {
							return {I5: familyDiscountRule.I9, e_: familyDiscountRule.Ja, T8: familyDiscountRule.Ub, f5: familyDiscountRule.Uc, Xw: familyDiscountRule.XA, gr: familyDiscountRule.XB, Zj: familyDiscountRule.Zn, gG: familyDiscountRule.Zo};
						},
						familyMembershipPricingFormFields.tJ);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}(),
		tK: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
			},
			familyMembershipPricingFormFields.YY.tK.Ot ? familyMembershipPricingFormFields.tK : $elm$core$Maybe$Nothing),
		Ip: function () {
			if ($author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).YY.PZ.Ot) {
				var additionalChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Ip;
				return $elm$core$Maybe$Just(
					{I5: additionalChildRateRule.I5, e_: additionalChildRateRule.e_, T8: additionalChildRateRule.T8, f5: additionalChildRateRule.f5, Xw: additionalChildRateRule.Xw, gr: additionalChildRateRule.gr, Zj: additionalChildRateRule.Zj, gG: additionalChildRateRule.gG});
			} else {
				if ((formFields.P_ === 'family') && (!_Utils_eq(familyMembershipPricingFormFields.tK, $elm$core$Maybe$Nothing))) {
					return A2(
						$elm$core$Maybe$map,
						function (familyDiscountRule) {
							return {I5: familyDiscountRule.I9, e_: familyDiscountRule.Ja, T8: familyDiscountRule.Ub, f5: familyDiscountRule.Uc, Xw: familyDiscountRule.XA, gr: familyDiscountRule.XB, Zj: familyDiscountRule.Zn, gG: familyDiscountRule.Zo};
						},
						familyMembershipPricingFormFields.tK);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}(),
		Iq: basicPlanFormFields.Iq,
		IL: A2(
			$elm$core$List$map,
			function (ageRateRule) {
				return {
					I5: ageRateRule.c7.I5,
					e_: ageRateRule.c7.e_,
					L_: A2(
						$elm$core$Maybe$map,
						function (coupleRule) {
							return {I5: coupleRule.c7.I5, e_: coupleRule.c7.e_, T8: coupleRule.c7.T8, f5: coupleRule.c7.f5, Xw: coupleRule.c7.Xw, gr: coupleRule.c7.gr, Zj: coupleRule.c7.Zj, gG: coupleRule.c7.gG};
						},
						ageRateRule.L_),
					PH: $elm$core$Maybe$Just(ageRateRule.PH),
					T8: ageRateRule.c7.T8,
					f5: ageRateRule.c7.f5,
					Xw: ageRateRule.c7.Xw,
					gr: ageRateRule.c7.gr,
					Zj: ageRateRule.c7.Zj,
					gG: ageRateRule.c7.gG,
					$I: ageRateRule.$I,
					aai: ageRateRule.aai
				};
			},
			membershipPricingFormFields.IL),
		vn: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.vn),
		vo: basicPlanFormFields.vo,
		Jj: formFields.Jj,
		J0: basicPlanFormFields.J0,
		Kh: basicPlanFormFields.Kh,
		v3: familyMembershipPricingFormFields.v3,
		v4: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
			},
			familyMembershipPricingFormFields.YY.v4.Ot ? familyMembershipPricingFormFields.v4 : $elm$core$Maybe$Nothing),
		LO: formFields.LO,
		LP: formFields.LP,
		LQ: formFields.LQ,
		LR: formFields.LR,
		EI: formFields.EI,
		wQ: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
			},
			familyMembershipPricingFormFields.YY.wQ.Ot ? familyMembershipPricingFormFields.wQ : $elm$core$Maybe$Nothing),
		L$: function () {
			if (formFields.P_ === 'fixed_pricing') {
				var coupleRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).L$;
				return $elm$core$Maybe$Just(
					{I5: coupleRateRule.I5, e_: coupleRateRule.e_, T8: coupleRateRule.T8, f5: coupleRateRule.f5, Xw: coupleRateRule.Xw, gr: coupleRateRule.gr, Zj: coupleRateRule.Zj, gG: coupleRateRule.gG});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		L5: A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$coveragePlanId, formFields.L5),
		w4: basicPlanFormFields.w4,
		w5: basicPlanFormFields.w5,
		Nf: basicPlanFormFields.Nf,
		E1: $author$project$Components$TranslatedRichText$translations(basicPlanFormFields.Nx),
		xg: formFields.xg,
		xA: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
			},
			familyMembershipPricingFormFields.YY.xA.Ot ? familyMembershipPricingFormFields.xA : $elm$core$Maybe$Nothing),
		O6: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).YY.O6.Ot ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).O6 : $elm$core$Maybe$Nothing,
		xB: familyMembershipPricingFormFields.xB,
		O7: function () {
			if (formFields.P_ === 'fixed_pricing') {
				var familyRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).O7;
				return $elm$core$Maybe$Just(
					{I5: familyRateRule.I5, e_: familyRateRule.e_, T8: familyRateRule.T8, f5: familyRateRule.f5, Xw: familyRateRule.Xw, gr: familyRateRule.gr, Zj: familyRateRule.Zj, gG: familyRateRule.gG});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		O9: function () {
			if ((formFields.P_ === 'fixed_pricing') && $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Pa) {
				var familyWithSingleChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).O9;
				return $elm$core$Maybe$Just(
					{I5: familyWithSingleChildRateRule.I5, e_: familyWithSingleChildRateRule.e_, T8: familyWithSingleChildRateRule.T8, f5: familyWithSingleChildRateRule.f5, Xw: familyWithSingleChildRateRule.Xw, gr: familyWithSingleChildRateRule.gr, Zj: familyWithSingleChildRateRule.Zj, gG: familyWithSingleChildRateRule.gG});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		Pa: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Pa,
		Pv: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).YY.Pv.Ot ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Pv : $elm$core$Maybe$Nothing,
		PW: A2(
			$elm$core$List$map,
			function (groupDiscountRule) {
				return {
					I7: groupDiscountRule.I7,
					I8: groupDiscountRule.I8,
					Jd: groupDiscountRule.Jd,
					Je: groupDiscountRule.Je,
					Km: groupDiscountRule.Km,
					PJ: $elm$core$Maybe$Just(groupDiscountRule.PJ),
					T9: groupDiscountRule.T9,
					Ua: groupDiscountRule.Ua,
					Ug: groupDiscountRule.Ug,
					Uh: groupDiscountRule.Uh,
					Xy: groupDiscountRule.Xy,
					Xz: groupDiscountRule.Xz,
					XE: groupDiscountRule.XE,
					XF: groupDiscountRule.XF,
					Zl: groupDiscountRule.Zl,
					Zm: groupDiscountRule.Zm,
					Zr: groupDiscountRule.Zr,
					Zs: groupDiscountRule.Zs,
					$K: groupDiscountRule.$K
				};
			},
			formFields.PW),
		PZ: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).YY.PZ.Ot ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).PZ : $elm$core$Maybe$Nothing,
		P_: formFields.P_,
		QN: basicPlanFormFields.QN,
		QU: function () {
			if (formFields.P_ === 'fixed_pricing') {
				var individualRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).QU;
				return $elm$core$Maybe$Just(
					{I5: individualRateRule.I5, e_: individualRateRule.e_, T8: individualRateRule.T8, f5: individualRateRule.f5, Xw: individualRateRule.Xw, gr: individualRateRule.gr, Zj: individualRateRule.Zj, gG: individualRateRule.gG});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		QW: registrationFeeFields.YY.QW.Ot ? registrationFeeFields.QW : $elm$core$Maybe$Nothing,
		So: formFields.So,
		Tr: registrationFeeFields.YY.Tr.Ot ? registrationFeeFields.Tr : $elm$core$Maybe$Nothing,
		Tu: formFields.Tu,
		T1: formFields.T1,
		T3: basicPlanFormFields.T3,
		y9: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.y9),
		za: basicPlanFormFields.za,
		zh: basicPlanFormFields.zh,
		zC: familyMembershipPricingFormFields.zC,
		W0: formFields.W0,
		Bf: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bf),
		Bg: basicPlanFormFields.Bg,
		Bo: A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
			},
			basicPlanFormFields.Bo),
		Bp: basicPlanFormFields.Bp,
		Bq: basicPlanFormFields.Bq,
		B6: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.B6),
		B7: basicPlanFormFields.B7,
		Cn: A2(
			$elm$core$Maybe$map,
			function (familyDiscountRule) {
				return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
			},
			familyMembershipPricingFormFields.YY.Cn.Ot ? familyMembershipPricingFormFields.Cn : $elm$core$Maybe$Nothing),
		Z8: function () {
			if (formFields.P_ === 'fixed_pricing') {
				var singleParentRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Z8;
				return $elm$core$Maybe$Just(
					{I5: singleParentRateRule.I5, e_: singleParentRateRule.e_, T8: singleParentRateRule.T8, f5: singleParentRateRule.f5, Xw: singleParentRateRule.Xw, gr: singleParentRateRule.gr, Zj: singleParentRateRule.Zj, gG: singleParentRateRule.gG});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		_a: function () {
			if ((formFields.P_ === 'fixed_pricing') && $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._b) {
				var singleParentWithSingleChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._a;
				return $elm$core$Maybe$Just(
					{I5: singleParentWithSingleChildRateRule.I5, e_: singleParentWithSingleChildRateRule.e_, T8: singleParentWithSingleChildRateRule.T8, f5: singleParentWithSingleChildRateRule.f5, Xw: singleParentWithSingleChildRateRule.Xw, gr: singleParentWithSingleChildRateRule.gr, Zj: singleParentWithSingleChildRateRule.Zj, gG: singleParentWithSingleChildRateRule.gG});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		_b: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._b,
		_o: A2(
			$elm$core$List$map,
			function (specialRate) {
				return {I5: specialRate.I5, e_: specialRate.e_, Me: specialRate.Me, NB: specialRate.NB, adR: specialRate.adR, T8: specialRate.T8, f5: specialRate.f5, zh: specialRate.zh, Xw: specialRate.Xw, gr: specialRate.gr, Zj: specialRate.Zj, gG: specialRate.gG};
			},
			$author$project$Components$Plan$Form$SpecialRatesFields$formFields(formFields.de)._o),
		_r: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._r,
		Hi: basicPlanFormFields.Hi,
		$M: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, formFields.$M),
		$N: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, formFields.$N),
		$O: formFields.$O
	};
};
var $author$project$Components$Plan$Form$updatePlanRequest = F3(
	function (apiClient, id, validFields) {
		return A4(
			$author$project$Api$Provider$Plan$update,
			apiClient,
			id,
			$author$project$Components$Plan$Form$updatePlanFields(
				$rtfeldman$elm_validate$Validate$fromValid(validFields)),
			$author$project$Components$Plan$Form$PlanUpdated);
	});
var $author$project$Components$Plan$Form$saveItem = F3(
	function (apiClient, id, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var planChange = _v0.ju;
		return planChange.jL ? A3(
			$author$project$Api$Provider$Plan$SubsequentPlan$delete,
			apiClient,
			id,
			$author$project$Components$Plan$Form$SubsequentPlanDeleted(validFormFields)) : A3($author$project$Components$Plan$Form$updatePlanRequest, apiClient, id, validFormFields);
	});
var $author$project$Components$Plan$BasicForm$showWarningModal = function (field) {
	switch (field.$) {
		case 0:
			return false;
		case 20:
			return false;
		case 21:
			return false;
		case 1:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return false;
		case 22:
			return false;
		case 8:
			return false;
		case 18:
			var rule = field.a;
			return false;
		case 17:
			return false;
		case 23:
			return false;
		case 24:
			return false;
		default:
			return true;
	}
};
var $author$project$Api$Provider$Plan$One$upcomingPricingVersion = function (_v0) {
	var record = _v0.b;
	return record.aap;
};
var $author$project$Api$Provider$Plan$SubsequentPlan$update = F4(
	function (apiClient, planId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$SubsequentPlan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId))));
	});
var $author$project$Components$Plan$BasicForm$FieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$BasicForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$BasicForm$Image = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Components$Plan$BasicForm$NoChange = {$: 1};
var $author$project$Components$Plan$BasicForm$RegistrationFeePricingField = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId = function (_v0) {
	var form = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		function (id) {
			return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
		},
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Components$ResourceFilter$Category$value,
			$author$project$Utils$Form$fields(form).cJ));
};
var $author$project$Components$ResourceFilter$Category$selectedName = function (model) {
	var _v0 = model.G0;
	switch (_v0.$) {
		case 3:
			return 'Unassigned';
		case 0:
			var resource = _v0.a;
			return resource.zh;
		case 2:
			return 'All';
		default:
			return 'Unassigned';
	}
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryName = function (_v0) {
	var form = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		'Unassigned',
		A2(
			$elm$core$Maybe$map,
			$author$project$Components$ResourceFilter$Category$selectedName,
			$author$project$Utils$Form$fields(form).cJ));
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$FieldUpdated = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$updateField = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var currency = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{QW: currency}),
					$elm$core$Platform$Cmd$none,
					field);
			case 1:
				var currency = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Tr: currency}),
					$elm$core$Platform$Cmd$none,
					field);
			default:
				var ruleType = field.a;
				if (!ruleType) {
					var bool = !fields.YY.QW.Ot;
					return _Utils_Tuple3(
						_Utils_update(
							fields,
							{
								YY: {
									QW: {Ot: bool},
									Tr: fields.YY.Tr
								}
							}),
						$elm$core$Platform$Cmd$none,
						field);
				} else {
					var bool = !fields.YY.Tr.Ot;
					return _Utils_Tuple3(
						_Utils_update(
							fields,
							{
								YY: {
									QW: fields.YY.QW,
									Tr: {Ot: bool}
								}
							}),
						$elm$core$Platform$Cmd$none,
						field);
				}
		}
	});
var $author$project$Utils$Form$updateWithCmdAndEvent = F3(
	function (updater, field_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		var _v1 = A2(updater, field_, fields_);
		var updated = _v1.a;
		var cmd = _v1.b;
		var event = _v1.c;
		return _Utils_Tuple3(
			A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_),
			cmd,
			event);
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$update = F3(
	function (apiClient, msg, _v0) {
		var form = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$RegistrationFeePricingFields$updateField, field, form);
			var newForm = _v2.a;
			var newFormCmd = _v2.b;
			var event = _v2.c;
			return {EC: newFormCmd, ac5: event, y8: newForm, as: _List_Nil};
		} else {
			var categoryMsg = msg.a;
			var fields = $author$project$Utils$Form$fields(form);
			var _v3 = fields.cJ;
			if (!_v3.$) {
				var categoryResourceFilter = _v3.a;
				var result = A3($author$project$Components$ResourceFilter$Category$update, apiClient, categoryMsg, categoryResourceFilter);
				var newFields = _Utils_update(
					fields,
					{
						cJ: $elm$core$Maybe$Just(result.y8)
					});
				var newForm = A2($author$project$Utils$Form$set, newFields, form);
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, result.EC),
					ac5: $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents($elm$core$Maybe$Nothing),
					y8: newForm,
					as: result.as
				};
			} else {
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents($elm$core$Maybe$Nothing),
					y8: form,
					as: _List_Nil
				};
			}
		}
	});
var $author$project$Components$Plan$BasicForm$toggleRule = F4(
	function (maybePlan, rule, bool, fields) {
		var rules = fields.YY;
		var newValue = F2(
			function (enabled, getter) {
				if (!maybePlan.$) {
					var plan = maybePlan.a;
					return enabled ? getter(plan) : $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
		return _Utils_update(
			fields,
			{
				T3: A2(newValue, bool, $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths),
				YY: _Utils_update(
					rules,
					{
						T3: {Ot: bool}
					})
			});
	});
var $author$project$Currency$divide = F2(
	function (_int, currency) {
		return A2(
			$elm$core$Maybe$withDefault,
			currency,
			A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				A2(
					$elm$core$Maybe$map,
					function (currency_) {
						return (currency_ / _int) | 0;
					},
					$author$project$Currency$toInt(currency))));
	});
var $author$project$Components$Plan$BasicForm$resetSponsorFeeDealAmountInCents = F2(
	function (defaultPeriod, sponsorFeeDealAmountInCents) {
		switch (defaultPeriod) {
			case 'annual':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Currency$multiply(12),
					sponsorFeeDealAmountInCents);
			case 'month':
				return A2(
					$elm$core$Maybe$map,
					$author$project$Currency$divide(12),
					sponsorFeeDealAmountInCents);
			default:
				return sponsorFeeDealAmountInCents;
		}
	});
var $author$project$Components$Plan$BasicForm$updateDefaultPeriod = F3(
	function (maybePlan, defaultPeriod, fields) {
		var sponsorFeeDealAmountInCents = function () {
			if (!maybePlan.$) {
				var plan = maybePlan.a;
				return ($author$project$Api$Provider$Plan$One$planType(plan) === 1) ? A2($author$project$Components$Plan$BasicForm$resetSponsorFeeDealAmountInCents, defaultPeriod, fields.Hi) : fields.Hi;
			} else {
				return fields.Hi;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				fields,
				{Nf: defaultPeriod, Hi: sponsorFeeDealAmountInCents}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Plan$BasicForm$updateField = F5(
	function (_v0, _v1, maybePlan, field, form) {
		switch (field.$) {
			case 0:
				var name = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{zh: name}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 2:
				var buyable = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Kh: buyable}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 20:
				var registrationFeeName = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Bq: registrationFeeName}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 21:
				var registrationFeeDescription = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Bp: registrationFeeDescription}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 1:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Iq: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 3:
				var bool = field.a;
				var defaultPeriod = bool ? 'annual' : 'month';
				var _v3 = A3($author$project$Components$Plan$BasicForm$updateDefaultPeriod, maybePlan, defaultPeriod, form);
				var fields = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					fields,
					cmd,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 4:
				var bool = field.a;
				var _v4 = A3(
					$author$project$Components$Plan$BasicForm$updateDefaultPeriod,
					maybePlan,
					'month',
					_Utils_update(
						form,
						{J0: bool}));
				var fields = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					fields,
					cmd,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 19:
				var currency = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Hi: currency}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 5:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{w5: string}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 6:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							w4: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{qo: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 22:
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{lY: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{iy: !form.iy}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 9:
				var percentage = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{y9: percentage}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 10:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{za: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 11:
				var percentage = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Bf: percentage}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 12:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Bg: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 13:
				var percentage = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{B6: percentage}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 14:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{B7: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 15:
				var percentage = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{vn: percentage}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 16:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{vo: bool}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 17:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							T3: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 18:
				var rule = field.a;
				var bool = field.b;
				return _Utils_Tuple3(
					A4($author$project$Components$Plan$BasicForm$toggleRule, maybePlan, rule, bool, form),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			case 23:
				return _Utils_Tuple3(
					form,
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
			default:
				var _int = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							p4: $elm$core$Maybe$Just(string),
							ms: _int,
							QN: $elm$core$Maybe$Just(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$BasicForm$FieldUpdated(field));
		}
	});
var $author$project$Components$Plan$BasicForm$update = F4(
	function (apiClient, msg, _v0, maybePlan) {
		var settings = _v0.a;
		var form = _v0.b;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v2 = A3(
					$author$project$Utils$Form$updateWithCmdAndEvent,
					A3($author$project$Components$Plan$BasicForm$updateField, apiClient, settings, maybePlan),
					field,
					form);
				var newForm = _v2.a;
				var cmd = _v2.b;
				var event = _v2.c;
				return {
					EC: cmd,
					ac5: event,
					y8: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
					as: _List_Nil
				};
			case 1:
				var registrationFeeMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(form);
				var result = A3($author$project$Components$Plan$Form$RegistrationFeePricingFields$update, apiClient, registrationFeeMsg, fields.c9);
				var updatedFields = _Utils_update(
					fields,
					{
						Bo: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(result.y8),
						sl: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryName(result.y8),
						c9: result.y8
					});
				var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, result.EC),
					ac5: function () {
						var _v3 = result.ac5;
						var field = _v3;
						return $author$project$Components$Plan$BasicForm$FieldUpdated(
							$author$project$Components$Plan$BasicForm$RegistrationFeePricingField(field));
					}(),
					y8: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
					as: result.as
				};
			case 3:
				var pictures = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var task = _v4.a;
							var size = _v4.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Plan$BasicForm$FormUpdated,
									$author$project$Components$Plan$BasicForm$Image(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (picture) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(picture),
									$elm$file$File$size(picture));
							},
							$elm$core$List$head(pictures))));
				return {
					EC: cmd,
					ac5: $author$project$Components$Plan$BasicForm$NoChange,
					y8: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, form),
					as: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(form);
				var _v5 = A3($author$project$Components$TranslatedRichText$update, 'plan-description-editor', subMsg, fields.Nx);
				var newDescription = _v5.a;
				var descCmd = _v5.b;
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{Nx: newDescription}),
					form);
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$DescriptionMsg, descCmd),
					ac5: $author$project$Components$Plan$BasicForm$NoChange,
					y8: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Added = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Closed = {$: 1};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlan = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$AddCoveragePlanModal$None = {$: 0};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate = F2(
	function (field, fields) {
		var coveragePlan = field;
		return _Utils_update(
			fields,
			{L5: coveragePlan});
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanValidation = 0;
var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.L5;
			},
			_Utils_Tuple2(0, 'Please pick a coverage plan'))
		]));
var $author$project$Components$ResourceFilter$CoveragePlan$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Plan$Form$AddCoveragePlanModal$Closed, y8: model, as: _List_Nil};
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var coveragePlan = _v4.L5;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Components$Plan$Form$AddCoveragePlanModal$None,
							A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$Added, coveragePlan)),
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Plan$Form$AddCoveragePlanModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			default:
				var subMsg = msg.a;
				var coveragePlanResourceResult = A3($author$project$Components$ResourceFilter$CoveragePlan$update, apiClient, subMsg, model.wU);
				var newForm = function () {
					var _v5 = coveragePlanResourceResult.ac5;
					_v5$2:
					while (true) {
						if ((!_v5.$) && (!_v5.a.$)) {
							switch (_v5.a.a.$) {
								case 0:
									var coveragePlan = _v5.a.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate,
										$elm$core$Maybe$Just(coveragePlan),
										model.PB);
								case 2:
									var _v6 = _v5.a.a;
									return A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate, $elm$core$Maybe$Nothing, model.PB);
								default:
									break _v5$2;
							}
						} else {
							break _v5$2;
						}
					}
					return model.PB;
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg, coveragePlanResourceResult.EC),
					ac5: $author$project$Components$Plan$Form$AddCoveragePlanModal$None,
					y8: _Utils_update(
						model,
						{wU: coveragePlanResourceResult.y8, PB: newForm}),
					as: coveragePlanResourceResult.as
				};
		}
	});
var $author$project$Components$Plan$Form$ConfirmUpdateModal$Closed = 1;
var $author$project$Components$Plan$Form$ConfirmUpdateModal$Confirmed = 2;
var $author$project$Components$Plan$Form$ConfirmUpdateModal$None = 0;
var $author$project$Components$Plan$Form$ConfirmUpdateModal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{VS: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 2:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			default:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$SetPeriodMaximumInCentsEdited = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingTypeToggled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$toggleRule = F4(
	function (rule, bool, fields, maybePlan) {
		var rules = fields.YY;
		var newValue = F2(
			function (enabled, getter) {
				return enabled ? getter(maybePlan) : $elm$core$Maybe$Nothing;
			});
		switch (rule) {
			case 0:
				return _Utils_update(
					fields,
					{
						xB: A2(
							newValue,
							bool,
							$elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$familyNumChildrenIncluded)),
						YY: _Utils_update(
							rules,
							{
								xB: {Ot: bool}
							})
					});
			case 1:
				return _Utils_update(
					fields,
					{
						wQ: A2(
							newValue,
							bool,
							function (_v1) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 0, true, $elm$core$Maybe$Nothing);
							}),
						YY: _Utils_update(
							rules,
							{
								wQ: {Ot: bool}
							})
					});
			case 2:
				return _Utils_update(
					fields,
					{
						xA: A2(
							newValue,
							bool,
							function (_v2) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 2, true, $elm$core$Maybe$Nothing);
							}),
						YY: _Utils_update(
							rules,
							{
								xA: {Ot: bool}
							})
					});
			case 3:
				return _Utils_update(
					fields,
					{
						YY: _Utils_update(
							rules,
							{
								Cn: {Ot: bool}
							}),
						Cn: A2(
							newValue,
							bool,
							function (_v3) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 1, true, $elm$core$Maybe$Nothing);
							})
					});
			case 4:
				return _Utils_update(
					fields,
					{
						tK: A2(
							newValue,
							bool,
							function (_v4) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 4, true, $elm$core$Maybe$Nothing);
							}),
						YY: _Utils_update(
							rules,
							{
								tK: {Ot: bool}
							})
					});
			case 5:
				return _Utils_update(
					fields,
					{
						v4: A2(
							newValue,
							bool,
							function (_v5) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 5, true, $elm$core$Maybe$Nothing);
							}),
						YY: _Utils_update(
							rules,
							{
								v4: {Ot: bool}
							})
					});
			case 6:
				return _Utils_update(
					fields,
					{
						zC: A2(
							newValue,
							bool,
							$elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed)),
						YY: _Utils_update(
							rules,
							{
								zC: {Ot: bool}
							})
					});
			case 7:
				return _Utils_update(
					fields,
					{
						tJ: A2(
							newValue,
							bool,
							function (_v6) {
								return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 3, true, $elm$core$Maybe$Nothing);
							}),
						YY: _Utils_update(
							rules,
							{
								tJ: {Ot: bool}
							})
					});
			default:
				return _Utils_update(
					fields,
					{
						v3: A2(
							newValue,
							bool,
							$elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$childrenAgeLimit)),
						YY: _Utils_update(
							rules,
							{
								v3: {Ot: bool}
							})
					});
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField = F3(
	function (maybePlan, field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple3(
					fields,
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingTypeToggled(string));
			case 1:
				var rule = field.a;
				var bool = field.b;
				return _Utils_Tuple3(
					A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$toggleRule, rule, bool, fields, maybePlan),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 2:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							xB: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 3:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							zC: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 4:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							v3: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 5:
				var type_ = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_Tuple3(
					function (_v2) {
						var getter = _v2.a;
						var setter = _v2.b;
						return setter(
							A2(
								$elm$core$Maybe$map,
								function (familyDiscountRule) {
									switch (period) {
										case 'month':
											return _Utils_update(
												familyDiscountRule,
												{Ub: currency, Uc: true});
										case 'quarter':
											return _Utils_update(
												familyDiscountRule,
												{XA: currency, XB: true});
										case 'semi_annual':
											return _Utils_update(
												familyDiscountRule,
												{Zn: currency, Zo: true});
										case 'annual':
											return _Utils_update(
												familyDiscountRule,
												{I9: currency, Ja: true});
										default:
											return familyDiscountRule;
									}
								},
								getter(fields)));
					}(
						function () {
							switch (type_) {
								case 0:
									return _Utils_Tuple2(
										function ($) {
											return $.wQ;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{wQ: familyDiscountRule});
										});
								case 1:
									return _Utils_Tuple2(
										function ($) {
											return $.Cn;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{Cn: familyDiscountRule});
										});
								case 2:
									return _Utils_Tuple2(
										function ($) {
											return $.xA;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{xA: familyDiscountRule});
										});
								case 3:
									return _Utils_Tuple2(
										function ($) {
											return $.tJ;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{tJ: familyDiscountRule});
										});
								case 4:
									return _Utils_Tuple2(
										function ($) {
											return $.tK;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{tK: familyDiscountRule});
										});
								default:
									return _Utils_Tuple2(
										function ($) {
											return $.v4;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{v4: familyDiscountRule});
										});
							}
						}()),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 8:
				var period = field.a;
				return _Utils_Tuple3(
					function (_v4) {
						var getter = _v4.a;
						var setter = _v4.b;
						return setter(
							A2(
								$elm$core$Maybe$map,
								function (familyDiscountRule) {
									switch (period) {
										case 'month':
											return _Utils_update(
												familyDiscountRule,
												{Uc: true});
										case 'quarter':
											return _Utils_update(
												familyDiscountRule,
												{XB: true});
										case 'semi_annual':
											return _Utils_update(
												familyDiscountRule,
												{Zo: true});
										case 'annual':
											return _Utils_update(
												familyDiscountRule,
												{Ja: true});
										default:
											return familyDiscountRule;
									}
								},
								getter(fields)));
					}(
						_Utils_Tuple2(
							function ($) {
								return $.xA;
							},
							function (familyDiscountRule) {
								return _Utils_update(
									fields,
									{xA: familyDiscountRule});
							})),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			case 6:
				var type_ = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					function (_v7) {
						var getter = _v7.a;
						var setter = _v7.b;
						return setter(
							A2(
								$elm$core$Maybe$map,
								function (familyDiscountRule) {
									switch (period) {
										case 'month':
											return _Utils_update(
												familyDiscountRule,
												{zc: true});
										case 'quarter':
											return _Utils_update(
												familyDiscountRule,
												{Bh: true});
										case 'semi_annual':
											return _Utils_update(
												familyDiscountRule,
												{B8: true});
										case 'annual':
											return _Utils_update(
												familyDiscountRule,
												{vp: true});
										default:
											return familyDiscountRule;
									}
								},
								getter(fields)));
					}(
						function () {
							switch (type_) {
								case 0:
									return _Utils_Tuple2(
										function ($) {
											return $.wQ;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{wQ: familyDiscountRule});
										});
								case 1:
									return _Utils_Tuple2(
										function ($) {
											return $.Cn;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{Cn: familyDiscountRule});
										});
								case 2:
									return _Utils_Tuple2(
										function ($) {
											return $.xA;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{xA: familyDiscountRule});
										});
								case 3:
									return _Utils_Tuple2(
										function ($) {
											return $.tJ;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{tJ: familyDiscountRule});
										});
								case 4:
									return _Utils_Tuple2(
										function ($) {
											return $.tK;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{tK: familyDiscountRule});
										});
								default:
									return _Utils_Tuple2(
										function ($) {
											return $.v4;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{v4: familyDiscountRule});
										});
							}
						}()),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
			default:
				var type_ = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					function (_v10) {
						var getter = _v10.a;
						var setter = _v10.b;
						return setter(
							A2(
								$elm$core$Maybe$map,
								function (familyDiscountRule) {
									switch (period) {
										case 'month':
											return _Utils_update(
												familyDiscountRule,
												{Uc: false, zc: false});
										case 'quarter':
											return _Utils_update(
												familyDiscountRule,
												{XB: false, Bh: false});
										case 'semi_annual':
											return _Utils_update(
												familyDiscountRule,
												{Zo: false, B8: false});
										case 'annual':
											return _Utils_update(
												familyDiscountRule,
												{Ja: false, vp: false});
										default:
											return familyDiscountRule;
									}
								},
								getter(fields)));
					}(
						function () {
							switch (type_) {
								case 0:
									return _Utils_Tuple2(
										function ($) {
											return $.wQ;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{wQ: familyDiscountRule});
										});
								case 1:
									return _Utils_Tuple2(
										function ($) {
											return $.Cn;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{Cn: familyDiscountRule});
										});
								case 2:
									return _Utils_Tuple2(
										function ($) {
											return $.xA;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{xA: familyDiscountRule});
										});
								case 3:
									return _Utils_Tuple2(
										function ($) {
											return $.tJ;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{tJ: familyDiscountRule});
										});
								case 4:
									return _Utils_Tuple2(
										function ($) {
											return $.tK;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{tK: familyDiscountRule});
										});
								default:
									return _Utils_Tuple2(
										function ($) {
											return $.v4;
										},
										function (familyDiscountRule) {
											return _Utils_update(
												fields,
												{v4: familyDiscountRule});
										});
							}
						}()),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
		}
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$update = F3(
	function (msg, _v0, maybePlan) {
		var form = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField(maybePlan),
				field,
				form);
			var newForm = _v2.a;
			var newFormCmd = _v2.b;
			var event = _v2.c;
			return {EC: newFormCmd, ac5: event, y8: newForm, as: _List_Nil};
		} else {
			var defaultPeriod = msg.a;
			var _v3 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField(maybePlan),
				$author$project$Components$Plan$Form$FamilyMembershipPricingFields$SetPeriodMaximumInCentsEdited(defaultPeriod),
				form);
			var newForm = _v3.a;
			var newFormCmd = _v3.b;
			var event = _v3.c;
			return {EC: newFormCmd, ac5: event, y8: newForm, as: _List_Nil};
		}
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$SetAllRateRulePeriodAmountInCentsEdited = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedMembershipPricingToggled = {$: 1};
var $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited = F2(
	function (period, rateRule) {
		switch (period) {
			case 'month':
				return _Utils_update(
					rateRule,
					{f5: true});
			case 'quarter':
				return _Utils_update(
					rateRule,
					{gr: true});
			case 'semi_annual':
				return _Utils_update(
					rateRule,
					{gG: true});
			case 'annual':
				return _Utils_update(
					rateRule,
					{e_: true});
			default:
				return rateRule;
		}
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$updateField = F3(
	function (_v0, field, fields) {
		switch (field.$) {
			case 0:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{QU: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 1:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{L$: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 2:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{O7: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 3:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Z8: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 4:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{_a: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 5:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{O9: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 6:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Io: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 7:
				var rateRule = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Ip: rateRule}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 8:
				var age = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Pv: age}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 9:
				var adults = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{O6: adults}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 10:
				var children = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{PZ: children}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 11:
				var revenueType = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{_r: revenueType}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 14:
				var enabled = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{_b: enabled}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 15:
				var enabled = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{Pa: enabled}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
			case 12:
				var ruleType = field.a;
				switch (ruleType) {
					case 0:
						var rules = fields.YY;
						var bool = !rules.Pv.Ot;
						return _Utils_Tuple3(
							_Utils_update(
								fields,
								{
									YY: _Utils_update(
										rules,
										{
											Pv: {Ot: bool}
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
					case 1:
						var rules = fields.YY;
						var bool = !rules.O6.Ot;
						return _Utils_Tuple3(
							_Utils_update(
								fields,
								{
									YY: _Utils_update(
										rules,
										{
											O6: {Ot: bool}
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
					default:
						var rules = fields.YY;
						var bool = !rules.PZ.Ot;
						return _Utils_Tuple3(
							_Utils_update(
								fields,
								{
									YY: _Utils_update(
										rules,
										{
											PZ: {Ot: bool}
										})
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
				}
			case 13:
				return _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedMembershipPricingToggled);
			case 16:
				var type_ = field.a;
				var period = field.b;
				var currency = field.c;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						fields,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)),
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var getter = _v4.a;
							var setter = _v4.b;
							var fixedRateRule = getter(fields);
							var updatedFixedRateRule = function () {
								switch (period) {
									case 'month':
										return _Utils_update(
											fixedRateRule,
											{T8: currency, f5: true});
									case 'quarter':
										return _Utils_update(
											fixedRateRule,
											{Xw: currency, gr: true});
									case 'semi_annual':
										return _Utils_update(
											fixedRateRule,
											{Zj: currency, gG: true});
									case 'annual':
										return _Utils_update(
											fixedRateRule,
											{I5: currency, e_: true});
									default:
										return fixedRateRule;
								}
							}();
							var rateRuleUpdatedEvent = function () {
								switch (type_.$) {
									case 0:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated(updatedFixedRateRule);
									case 1:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated(updatedFixedRateRule);
									case 2:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated(updatedFixedRateRule);
									case 3:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated(updatedFixedRateRule);
									case 4:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated(updatedFixedRateRule);
									case 5:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated(updatedFixedRateRule);
									case 6:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated(updatedFixedRateRule);
									case 7:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated(updatedFixedRateRule);
									default:
										return field;
								}
							}();
							return _Utils_Tuple3(
								setter(updatedFixedRateRule),
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(rateRuleUpdatedEvent));
						},
						function () {
							switch (type_.$) {
								case 0:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.QU;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{QU: fixedRateRule});
											}));
								case 1:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.L$;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{L$: fixedRateRule});
											}));
								case 2:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Z8;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Z8: fixedRateRule});
											}));
								case 3:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.O7;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{O7: fixedRateRule});
											}));
								case 4:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $._a;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{_a: fixedRateRule});
											}));
								case 5:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.O9;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{O9: fixedRateRule});
											}));
								case 6:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Io;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Io: fixedRateRule});
											}));
								case 7:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Ip;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Ip: fixedRateRule});
											}));
								case 8:
									return $elm$core$Maybe$Nothing;
								case 9:
									return $elm$core$Maybe$Nothing;
								default:
									return $elm$core$Maybe$Nothing;
							}
						}()));
			case 17:
				var type_ = field.a;
				var period = field.b;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						fields,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)),
					A2(
						$elm$core$Maybe$map,
						function (_v8) {
							var getter = _v8.a;
							var setter = _v8.b;
							var fixedRateRule = getter(fields);
							var updatedFixedRateRule = function () {
								switch (period) {
									case 'month':
										return _Utils_update(
											fixedRateRule,
											{F7: true});
									case 'quarter':
										return _Utils_update(
											fixedRateRule,
											{Xx: true});
									case 'semi_annual':
										return _Utils_update(
											fixedRateRule,
											{Zk: true});
									case 'annual':
										return _Utils_update(
											fixedRateRule,
											{I6: true});
									default:
										return fixedRateRule;
								}
							}();
							return _Utils_Tuple3(
								setter(updatedFixedRateRule),
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
						},
						function () {
							switch (type_.$) {
								case 0:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.QU;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{QU: fixedRateRule});
											}));
								case 1:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.L$;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{L$: fixedRateRule});
											}));
								case 2:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Z8;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Z8: fixedRateRule});
											}));
								case 3:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.O7;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{O7: fixedRateRule});
											}));
								case 4:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $._a;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{_a: fixedRateRule});
											}));
								case 5:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.O9;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{O9: fixedRateRule});
											}));
								case 6:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Io;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Io: fixedRateRule});
											}));
								case 7:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Ip;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Ip: fixedRateRule});
											}));
								case 8:
									return $elm$core$Maybe$Nothing;
								case 9:
									return $elm$core$Maybe$Nothing;
								default:
									return $elm$core$Maybe$Nothing;
							}
						}()));
			case 18:
				var type_ = field.a;
				var period = field.b;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(
						fields,
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)),
					A2(
						$elm$core$Maybe$map,
						function (_v11) {
							var getter = _v11.a;
							var setter = _v11.b;
							var fixedRateRule = getter(fields);
							var updatedFixedRateRule = function () {
								switch (period) {
									case 'month':
										return _Utils_update(
											fixedRateRule,
											{T8: $elm$core$Maybe$Nothing, f5: false, F7: false});
									case 'quarter':
										return _Utils_update(
											fixedRateRule,
											{Xw: $elm$core$Maybe$Nothing, gr: false, Xx: false});
									case 'semi_annual':
										return _Utils_update(
											fixedRateRule,
											{Zj: $elm$core$Maybe$Nothing, gG: false, Zk: false});
									case 'annual':
										return _Utils_update(
											fixedRateRule,
											{I5: $elm$core$Maybe$Nothing, e_: false, I6: false});
									default:
										return fixedRateRule;
								}
							}();
							var rateRuleUpdatedEvent = function () {
								switch (type_.$) {
									case 0:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated(updatedFixedRateRule);
									case 1:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated(updatedFixedRateRule);
									case 2:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated(updatedFixedRateRule);
									case 3:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated(updatedFixedRateRule);
									case 4:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated(updatedFixedRateRule);
									case 5:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated(updatedFixedRateRule);
									case 6:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated(updatedFixedRateRule);
									case 7:
										return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated(updatedFixedRateRule);
									default:
										return field;
								}
							}();
							return _Utils_Tuple3(
								setter(updatedFixedRateRule),
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(rateRuleUpdatedEvent));
						},
						function () {
							switch (type_.$) {
								case 0:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.QU;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{QU: fixedRateRule});
											}));
								case 1:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.L$;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{L$: fixedRateRule});
											}));
								case 2:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Z8;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Z8: fixedRateRule});
											}));
								case 3:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.O7;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{O7: fixedRateRule});
											}));
								case 4:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $._a;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{_a: fixedRateRule});
											}));
								case 5:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.O9;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{O9: fixedRateRule});
											}));
								case 6:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Io;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Io: fixedRateRule});
											}));
								case 7:
									return $elm$core$Maybe$Just(
										_Utils_Tuple2(
											function ($) {
												return $.Ip;
											},
											function (fixedRateRule) {
												return _Utils_update(
													fields,
													{Ip: fixedRateRule});
											}));
								case 8:
									return $elm$core$Maybe$Nothing;
								case 9:
									return $elm$core$Maybe$Nothing;
								default:
									return $elm$core$Maybe$Nothing;
							}
						}()));
			default:
				var defaultPeriod = field.a;
				var updatedFields = _Utils_update(
					fields,
					{
						Io: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.Io),
						Ip: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.Ip),
						L$: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.L$),
						O7: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.O7),
						O9: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.O9),
						QU: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.QU),
						Z8: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.Z8),
						_a: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields._a)
					});
				return _Utils_Tuple3(
					updatedFields,
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
		}
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$update = F3(
	function (sharedFields, msg, _v0) {
		var form = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$GroupTierPricingFields$updateField(sharedFields),
				field,
				form);
			var newForm = _v2.a;
			var newFormCmd = _v2.b;
			var event = _v2.c;
			return {EC: newFormCmd, ac5: event, y8: newForm, as: _List_Nil};
		} else {
			var defaultPeriod = msg.a;
			var _v3 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$GroupTierPricingFields$updateField(sharedFields),
				$author$project$Components$Plan$Form$GroupTierPricingFields$SetAllRateRulePeriodAmountInCentsEdited(defaultPeriod),
				form);
			var newForm = _v3.a;
			var newFormCmd = _v3.b;
			var event = _v3.c;
			return {EC: newFormCmd, ac5: event, y8: newForm, as: _List_Nil};
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$SetAgeRateRulePeriodAmountInCentsEdited = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FixedMembershipPricingToggled = {$: 1};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveRanges = F5(
	function (fromGetter, fromSetter, toGetter, toSetter, range) {
		if ($elm$core$List$isEmpty(range)) {
			return range;
		} else {
			var minimum = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					fromGetter,
					$elm$core$List$head(range)));
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, current) {
						var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
						var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
						var newTo = function () {
							var _v1 = _Utils_Tuple2(
								next,
								toGetter(current));
							if (_v1.a.$ === 1) {
								var _v2 = _v1.a;
								return $elm$core$Maybe$Nothing;
							} else {
								if (_v1.b.$ === 1) {
									var _v3 = _v1.b;
									return toGetter(current);
								} else {
									var currentTo = _v1.b.a;
									var currentFrom = fromGetter(current);
									return (_Utils_cmp(currentTo, currentFrom) < 1) ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
								}
							}
						}();
						var newFrom = function () {
							var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
							if (!_v0.$) {
								var _int = _v0.a;
								return _int + 1;
							} else {
								return minimum;
							}
						}();
						return A2(
							toSetter,
							newTo,
							A2(fromSetter, newFrom, current));
					}),
				range);
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveAgeRanges = A4(
	$author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveRanges,
	function (item) {
		return (!item.aai) ? (item.PH * 12) : item.PH;
	},
	F2(
		function (from, item) {
			return (!item.aai) ? _Utils_update(
				item,
				{
					PH: $elm$core$Basics$ceiling(from / 12)
				}) : _Utils_update(
				item,
				{PH: from});
		}),
	function (item) {
		return (!item.aai) ? A2(
			$elm$core$Maybe$map,
			function (age) {
				return age * 12;
			},
			item.$I) : item.$I;
	},
	F2(
		function (to, item) {
			return (!item.aai) ? _Utils_update(
				item,
				{
					$I: A2(
						$elm$core$Maybe$map,
						function (age) {
							return $elm$core$Basics$ceiling(age / 12);
						},
						to)
				}) : _Utils_update(
				item,
				{$I: to});
		}));
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$lastRuleIsInYears = function (rules) {
	var _v0 = $elm_community$list_extra$List$Extra$last(rules);
	if (!_v0.$) {
		var lastRule = _v0.a;
		return (!(!lastRule.aai)) ? A2(
			$author$project$Utils$List$updateLast,
			function (rule) {
				return _Utils_update(
					rule,
					{aai: 0});
			},
			rules) : rules;
	} else {
		return rules;
	}
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules = function (rules) {
	return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveAgeRanges(
		$author$project$Components$Plan$Form$IndividualMembershipPricingFields$lastRuleIsInYears(rules));
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths = 23;
var $author$project$Components$Plan$Form$AgeRateRuleField$startingFrom = F2(
	function (defaultPeriod, base) {
		return function (ageRateRule) {
			switch (defaultPeriod) {
				case 'month':
					var updatedPeriodRates = ageRateRule.c7;
					return _Utils_update(
						ageRateRule,
						{
							c7: _Utils_update(
								updatedPeriodRates,
								{T8: base.c7.T8})
						});
				case 'quarter':
					var updatedPeriodRates = ageRateRule.c7;
					return _Utils_update(
						ageRateRule,
						{
							c7: _Utils_update(
								updatedPeriodRates,
								{Xw: base.c7.Xw})
						});
				case 'semi_annual':
					var updatedPeriodRates = ageRateRule.c7;
					return _Utils_update(
						ageRateRule,
						{
							c7: _Utils_update(
								updatedPeriodRates,
								{Zj: base.c7.Zj})
						});
				case 'annual':
					var updatedPeriodRates = ageRateRule.c7;
					return _Utils_update(
						ageRateRule,
						{
							c7: _Utils_update(
								updatedPeriodRates,
								{I5: base.c7.I5})
						});
				default:
					return ageRateRule;
			}
		}(
			{
				L_: $elm$core$Maybe$Nothing,
				PH: A2($elm$core$Maybe$withDefault, 0, base.$I) + 1,
				c7: {
					I5: $elm$core$Maybe$Nothing,
					e_: false,
					I6: false,
					T8: $elm$core$Maybe$Just($author$project$Currency$zero),
					f5: false,
					F7: false,
					Xw: $elm$core$Maybe$Nothing,
					gr: false,
					Xx: false,
					Zj: $elm$core$Maybe$Nothing,
					gG: false,
					Zk: false
				},
				$I: $elm$core$Maybe$Nothing,
				aai: 0
			});
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField = F3(
	function (sharedFields, field, fields) {
		switch (field.$) {
			case 0:
				var _v1 = function () {
					var _v2 = $elm_community$list_extra$List$Extra$last(fields.IL);
					if (_v2.$ === 1) {
						return _Utils_Tuple2($author$project$Components$Plan$Form$AgeRateRuleField$empty, $elm$core$Maybe$Nothing);
					} else {
						var lastAgeRateRule = _v2.a;
						var newLastAgeRateRule_ = _Utils_update(
							lastAgeRateRule,
							{
								$I: $elm$core$Maybe$Just(lastAgeRateRule.PH + 19)
							});
						return _Utils_Tuple2(
							A2($author$project$Components$Plan$Form$AgeRateRuleField$startingFrom, sharedFields.Nf, newLastAgeRateRule_),
							$elm$core$Maybe$Just(newLastAgeRateRule_));
					}
				}();
				var newAgeRateRule = _v1.a;
				var newLastAgeRateRule = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A2(
									$author$project$Utils$List$prepend,
									_List_fromArray(
										[newAgeRateRule]),
									A2(
										$author$project$Utils$List$updateLast,
										function (last) {
											return A2($elm$core$Maybe$withDefault, last, newLastAgeRateRule);
										},
										fields.IL)))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 1:
				var index = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A2($elm_community$list_extra$List$Extra$removeAt, index, fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 2:
				var index = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										return _Utils_update(
											ageRateRule,
											{
												$I: $elm$core$String$toInt(string)
											});
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 3:
				var index = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var unit = $author$project$Api$Provider$RateRule$Shared$stringToUnit(string);
										return _Utils_update(
											ageRateRule,
											{
												$I: (unit === 1) ? A2(
													$elm$core$Maybe$map,
													function (age) {
														return A2($elm$core$Basics$min, age, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths);
													},
													ageRateRule.$I) : ageRateRule.$I,
												aai: unit
											});
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 11:
				var period = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A2(
									$elm$core$List$map,
									function (ageRateRule) {
										var updatedPeriodRates = ageRateRule.c7;
										switch (period) {
											case 'month':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{f5: true})
													});
											case 'quarter':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{gr: true})
													});
											case 'semi_annual':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{gG: true})
													});
											case 'annual':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{e_: true})
													});
											default:
												return ageRateRule;
										}
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 4:
				var index = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var updatedPeriodRates = ageRateRule.c7;
										switch (period) {
											case 'month':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{T8: currency, f5: true})
													});
											case 'quarter':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{Xw: currency, gr: true})
													});
											case 'semi_annual':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{Zj: currency, gG: true})
													});
											case 'annual':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{I5: currency, e_: true})
													});
											default:
												return ageRateRule;
										}
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 5:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var updatedPeriodRates = ageRateRule.c7;
										switch (period) {
											case 'month':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{F7: true})
													});
											case 'quarter':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{Xx: true})
													});
											case 'semi_annual':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{Zk: true})
													});
											case 'annual':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{I6: true})
													});
											default:
												return ageRateRule;
										}
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 6:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var updatedPeriodRates = ageRateRule.c7;
										switch (period) {
											case 'month':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{f5: false, F7: false})
													});
											case 'quarter':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{gr: false, Xx: false})
													});
											case 'semi_annual':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{gG: false, Zk: false})
													});
											case 'annual':
												return _Utils_update(
													ageRateRule,
													{
														c7: _Utils_update(
															updatedPeriodRates,
															{e_: false, I6: false})
													});
											default:
												return ageRateRule;
										}
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 7:
				var index = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var _v7 = ageRateRule.L_;
										if (!_v7.$) {
											var coupleRule = _v7.a;
											var updatedPeriodRates = coupleRule.c7;
											var updatedCoupleRule = function () {
												switch (period) {
													case 'month':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{T8: currency, f5: true})
															});
													case 'quarter':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{Xw: currency, gr: true})
															});
													case 'semi_annual':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{Zj: currency, gG: true})
															});
													case 'annual':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{I5: currency, e_: true})
															});
													default:
														return coupleRule;
												}
											}();
											return _Utils_update(
												ageRateRule,
												{
													L_: $elm$core$Maybe$Just(updatedCoupleRule)
												});
										} else {
											return ageRateRule;
										}
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 8:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var _v9 = ageRateRule.L_;
										if (!_v9.$) {
											var coupleRule = _v9.a;
											var updatedPeriodRates = coupleRule.c7;
											var updatedCoupleRule = function () {
												switch (period) {
													case 'month':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{F7: true})
															});
													case 'quarter':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{Xx: true})
															});
													case 'semi_annual':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{Zk: true})
															});
													case 'annual':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{I6: true})
															});
													default:
														return coupleRule;
												}
											}();
											return _Utils_update(
												ageRateRule,
												{
													L_: $elm$core$Maybe$Just(updatedCoupleRule)
												});
										} else {
											return ageRateRule;
										}
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			case 9:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(
								A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (ageRateRule) {
										var _v11 = ageRateRule.L_;
										if (!_v11.$) {
											var coupleRule = _v11.a;
											var updatedPeriodRates = coupleRule.c7;
											var updatedCoupleRule = function () {
												switch (period) {
													case 'month':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{f5: false, F7: false})
															});
													case 'quarter':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{gr: false, Xx: false})
															});
													case 'semi_annual':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{gG: false, Zk: false})
															});
													case 'annual':
														return _Utils_update(
															coupleRule,
															{
																c7: _Utils_update(
																	updatedPeriodRates,
																	{e_: false, I6: false})
															});
													default:
														return coupleRule;
												}
											}();
											return _Utils_update(
												ageRateRule,
												{
													L_: $elm$core$Maybe$Just(updatedCoupleRule)
												});
										} else {
											return ageRateRule;
										}
									},
									fields.IL))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
			default:
				return _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FixedMembershipPricingToggled);
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$update = F3(
	function (sharedFields, msg, _v0) {
		var form = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField(sharedFields),
				field,
				form);
			var newForm = _v2.a;
			var newFormCmd = _v2.b;
			var event = _v2.c;
			return {EC: newFormCmd, ac5: event, y8: newForm, as: _List_Nil};
		} else {
			var defaultPeriod = msg.a;
			var _v3 = A3(
				$author$project$Utils$Form$updateWithCmdAndEvent,
				$author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField(sharedFields),
				$author$project$Components$Plan$Form$IndividualMembershipPricingFields$SetAgeRateRulePeriodAmountInCentsEdited(defaultPeriod),
				form);
			var newForm = _v3.a;
			var newFormCmd = _v3.b;
			var event = _v3.c;
			return {EC: newFormCmd, ac5: event, y8: newForm, as: _List_Nil};
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$FieldUpdated = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$SpecialRateField$empty = {I5: $elm$core$Maybe$Nothing, e_: false, I6: false, Me: true, NB: false, adR: $elm$core$Maybe$Nothing, RJ: true, T8: $elm$core$Maybe$Nothing, f5: false, F7: false, zh: '', Xw: $elm$core$Maybe$Nothing, gr: false, Xx: false, Zj: $elm$core$Maybe$Nothing, gG: false, Zk: false};
var $author$project$Components$Plan$Form$SpecialRatesFields$updateField = F3(
	function (_v0, field, fields) {
		switch (field.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							_o: _Utils_ap(
								fields._o,
								_List_fromArray(
									[$author$project$Components$Plan$Form$SpecialRateField$empty]))
						}),
					$elm$core$Platform$Cmd$none,
					field);
			case 1:
				var index = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							_o: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									return _Utils_update(
										specialRate,
										{NB: true});
								},
								fields._o)
						}),
					$elm$core$Platform$Cmd$none,
					field);
			case 2:
				var index = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							_o: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									return _Utils_update(
										specialRate,
										{zh: string});
								},
								fields._o)
						}),
					$elm$core$Platform$Cmd$none,
					field);
			case 3:
				var index = field.a;
				var period = field.b;
				var currency = field.c;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							_o: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									switch (period) {
										case 'month':
											return _Utils_update(
												specialRate,
												{T8: currency, f5: true});
										case 'quarter':
											return _Utils_update(
												specialRate,
												{Xw: currency, gr: true});
										case 'semi_annual':
											return _Utils_update(
												specialRate,
												{Zj: currency, gG: true});
										case 'annual':
											return _Utils_update(
												specialRate,
												{I5: currency, e_: true});
										default:
											return specialRate;
									}
								},
								fields._o)
						}),
					$elm$core$Platform$Cmd$none,
					field);
			case 4:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							_o: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									switch (period) {
										case 'month':
											return _Utils_update(
												specialRate,
												{F7: true});
										case 'quarter':
											return _Utils_update(
												specialRate,
												{Xx: true});
										case 'semi_annual':
											return _Utils_update(
												specialRate,
												{Zk: true});
										case 'annual':
											return _Utils_update(
												specialRate,
												{I6: true});
										default:
											return specialRate;
									}
								},
								fields._o)
						}),
					$elm$core$Platform$Cmd$none,
					field);
			default:
				var index = field.a;
				var period = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							_o: A3(
								$elm_community$list_extra$List$Extra$updateAt,
								index,
								function (specialRate) {
									switch (period) {
										case 'month':
											return _Utils_update(
												specialRate,
												{f5: false, F7: false});
										case 'quarter':
											return _Utils_update(
												specialRate,
												{gr: false, Xx: false});
										case 'semi_annual':
											return _Utils_update(
												specialRate,
												{gG: false, Zk: false});
										case 'annual':
											return _Utils_update(
												specialRate,
												{e_: false, I6: false});
										default:
											return specialRate;
									}
								},
								fields._o)
						}),
					$elm$core$Platform$Cmd$none,
					field);
		}
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$update = F3(
	function (sharedFields, msg, _v0) {
		var form = _v0;
		var field = msg;
		var _v2 = A3(
			$author$project$Components$Plan$Form$SpecialRatesFields$updateField,
			sharedFields,
			field,
			$author$project$Utils$Form$fields(form));
		var updatedFields = _v2.a;
		var cmd = _v2.b;
		var event = _v2.c;
		return {
			EC: cmd,
			ac5: event,
			y8: A2($author$project$Utils$Form$set, updatedFields, form),
			as: _List_Nil
		};
	});
var $author$project$Components$ResourceFilter$Plan$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Plan$Form$updateDateInputFormField = F6(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var dateInputEvent = _v0.c;
		var newForm = A2(
			$elm$core$Maybe$map,
			function (_v1) {
				var plan = _v1.a;
				var form = _v1.b;
				var newForm_ = function () {
					if (dateInputEvent.$ === 1) {
						var date = dateInputEvent.a;
						var field_ = toField(date);
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Plan$Form$formFieldsUpdate(plan),
							field_,
							form);
					} else {
						return form;
					}
				}();
				return _Utils_Tuple2(plan, newForm_);
			},
			model.PB);
		return _Utils_Tuple3(
			A2(
				dateInputSetter,
				newDateInput,
				_Utils_update(
					model,
					{PB: newForm})),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			_List_Nil);
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$DefaultPeriodUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod = F3(
	function (defaultPeriod, maybePlan, _v0) {
		var form = _v0;
		return A3(
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$update,
			$author$project$Components$Plan$Form$FamilyMembershipPricingFields$DefaultPeriodUpdated(defaultPeriod),
			form,
			maybePlan);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$DefaultPeriodUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod = F3(
	function (sharedFields, defaultPeriod, _v0) {
		var form = _v0;
		return A3(
			$author$project$Components$Plan$Form$GroupTierPricingFields$update,
			sharedFields,
			$author$project$Components$Plan$Form$GroupTierPricingFields$DefaultPeriodUpdated(defaultPeriod),
			form);
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$DefaultPeriodUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod = F3(
	function (sharedFields, defaultPeriod, _v0) {
		var form = _v0;
		return A3(
			$author$project$Components$Plan$Form$IndividualMembershipPricingFields$update,
			sharedFields,
			$author$project$Components$Plan$Form$IndividualMembershipPricingFields$DefaultPeriodUpdated(defaultPeriod),
			form);
	});
var $author$project$Components$Plan$Form$calculateOpts = function (field) {
	var _v0 = function () {
		switch (field.$) {
			case 0:
				return _Utils_Tuple2(false, false);
			case 1:
				return _Utils_Tuple2(true, true);
			case 2:
				return _Utils_Tuple2(true, true);
			case 3:
				return _Utils_Tuple2(true, true);
			case 4:
				return _Utils_Tuple2(false, false);
			case 5:
				return _Utils_Tuple2(false, false);
			case 6:
				return _Utils_Tuple2(false, false);
			case 7:
				return _Utils_Tuple2(false, false);
			case 8:
				return _Utils_Tuple2(false, false);
			case 11:
				return _Utils_Tuple2(false, false);
			case 12:
				return _Utils_Tuple2(false, false);
			case 9:
				return _Utils_Tuple2(false, false);
			case 10:
				return _Utils_Tuple2(false, false);
			case 13:
				return _Utils_Tuple2(false, false);
			case 14:
				return _Utils_Tuple2(false, false);
			case 15:
				return _Utils_Tuple2(false, false);
			case 16:
				return _Utils_Tuple2(false, false);
			case 17:
				return _Utils_Tuple2(false, false);
			case 18:
				return _Utils_Tuple2(false, false);
			case 19:
				return _Utils_Tuple2(false, false);
			case 20:
				return _Utils_Tuple2(false, false);
			case 21:
				return _Utils_Tuple2(false, false);
			case 22:
				return _Utils_Tuple2(false, false);
			case 23:
				return _Utils_Tuple2(false, false);
			case 24:
				return _Utils_Tuple2(false, false);
			case 25:
				return _Utils_Tuple2(false, false);
			case 26:
				return _Utils_Tuple2(false, false);
			case 27:
				return _Utils_Tuple2(true, false);
			case 28:
				return _Utils_Tuple2(false, true);
			case 29:
				return _Utils_Tuple2(false, true);
			case 30:
				return _Utils_Tuple2(false, true);
			case 31:
				return _Utils_Tuple2(true, true);
			case 32:
				return _Utils_Tuple2(true, true);
			case 33:
				return _Utils_Tuple2(false, true);
			case 34:
				return _Utils_Tuple2(false, true);
			case 35:
				return _Utils_Tuple2(true, true);
			case 36:
				return _Utils_Tuple2(false, true);
			case 37:
				return _Utils_Tuple2(true, true);
			case 38:
				return _Utils_Tuple2(true, true);
			case 39:
				return _Utils_Tuple2(false, true);
			case 40:
				return _Utils_Tuple2(true, true);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var shouldCalculate_ = _v0.a;
	var validateCalculateFields = _v0.b;
	return {ZP: shouldCalculate_, aaM: validateCalculateFields};
};
var $author$project$Components$Plan$Form$showWarningModalIfFieldChanged = function (field) {
	switch (field.$) {
		case 0:
			return false;
		case 19:
			return false;
		default:
			return true;
	}
};
var $author$project$Components$Plan$Form$updateForm = F4(
	function (model, plan, field, form) {
		var newForm = A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Plan$Form$formFieldsUpdate(plan),
			field,
			form);
		return A4(
			$author$project$Components$Plan$Form$calculate,
			plan,
			newForm,
			$author$project$Components$Plan$Form$calculateOpts(field),
			_Utils_update(
				model,
				{
					PB: $elm$core$Maybe$Just(
						_Utils_Tuple2(plan, newForm)),
					oq: $author$project$Components$Plan$Form$showWarningModalIfFieldChanged(field)
				}));
	});
var $author$project$Api$Provider$SubsequentPlan$One$changeAfterMonths = function (_v0) {
	var record = _v0.b;
	return record.KN;
};
var $author$project$Api$Provider$SubsequentPlan$One$changeOnDate = function (_v0) {
	var record = _v0.b;
	return record.KO;
};
var $author$project$Api$Provider$Plan$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$SubsequentPlan$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$SubsequentPlan$One$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$SubsequentPlan$Min$id(min);
};
var $author$project$Api$Provider$Plan$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$SubsequentPlan$One$toPlan = function (_v0) {
	var record = _v0.b;
	return record.$J;
};
var $author$project$Api$Provider$SubsequentPlan$Min$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$SubsequentPlan$One$type_ = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$SubsequentPlan$Min$type_(min);
};
var $author$project$Components$Plan$Form$PlanChange$updateFromSubsequentPlan = F2(
	function (subsequentPlan, planChange) {
		var params = planChange.Vx;
		var toPlan = $author$project$Api$Provider$SubsequentPlan$One$toPlan(subsequentPlan);
		return _Utils_update(
			planChange,
			{
				Vx: _Utils_update(
					params,
					{
						KN: $author$project$Api$Provider$SubsequentPlan$One$changeAfterMonths(subsequentPlan),
						KO: $author$project$Api$Provider$SubsequentPlan$One$changeOnDate(subsequentPlan),
						adR: $elm$core$Maybe$Just(
							$author$project$Api$Provider$SubsequentPlan$One$id(subsequentPlan)),
						$J: A2(
							$elm$core$Maybe$map,
							function (toPlan_) {
								return {
									adR: $author$project$Api$Provider$Plan$Min$id(toPlan_),
									zh: $author$project$Api$Provider$Plan$Min$name(toPlan_)
								};
							},
							toPlan),
						ahI: $author$project$Api$Provider$SubsequentPlan$One$type_(subsequentPlan)
					})
			});
	});
var $author$project$Components$Plan$Form$updateSuccess = function (model) {
	var route = model.WI ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.F_);
	return _Utils_Tuple3(
		model,
		route,
		_List_fromArray(
			[
				A2($author$project$OutMsg$ShowToast, 3, 'Your pricing has been updated')
			]));
};
var $author$project$Components$Plan$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var loadSubsequentPlan = msg.a;
				var response = msg.b;
				return A2(
					$author$project$Utils$Tuple3$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									loadSubsequentPlan ? A2($author$project$Components$Plan$Form$fetchSubsequentPlan, apiClient, model.adR) : $elm$core$Platform$Cmd$none
								]));
					},
					A3($author$project$Components$Plan$Form$resetParamsOnScope, apiClient, response, model));
			case 1:
				var response = msg.a;
				var _v2 = model.PB;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var plan = _v3.a;
					var form = _v3.b;
					var _v4 = $author$project$Utils$Form$fields(form);
					var planChange = _v4.ju;
					_v5$2:
					while (true) {
						switch (response.$) {
							case 3:
								var subsequentPlan = response.a;
								var _v6 = A4(
									$author$project$Components$Plan$Form$updateForm,
									model,
									plan,
									$author$project$Components$Plan$Form$PlanChange(
										A2($author$project$Components$Plan$Form$PlanChange$updateFromSubsequentPlan, subsequentPlan, planChange)),
									form);
								var newModel = _v6.a;
								var formCmd = _v6.b;
								return _Utils_Tuple3(newModel, formCmd, _List_Nil);
							case 2:
								if (response.a.$ === 5) {
									var _v7 = response.a;
									var params = planChange.Vx;
									var _v8 = $author$project$Utils$Form$fields(form);
									var contractExpires = _v8.LP;
									var planChangeType = contractExpires ? 2 : 1;
									var newParams = _Utils_update(
										params,
										{ahI: planChangeType});
									var _v9 = A4(
										$author$project$Components$Plan$Form$updateForm,
										model,
										plan,
										$author$project$Components$Plan$Form$PlanChange(
											_Utils_update(
												planChange,
												{Vx: newParams})),
										form);
									var newModel = _v9.a;
									var formCmd = _v9.b;
									return _Utils_Tuple3(newModel, formCmd, _List_Nil);
								} else {
									break _v5$2;
								}
							default:
								break _v5$2;
						}
					}
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var field = msg.a;
				var _v10 = model.PB;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var plan = _v11.a;
					var form = _v11.b;
					var _v12 = A4($author$project$Components$Plan$Form$updateForm, model, plan, field, form);
					var newModel = _v12.a;
					var formCmd = _v12.b;
					return _Utils_Tuple3(newModel, formCmd, _List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var planFormMsg = msg.a;
				var _v13 = model.PB;
				if (!_v13.$) {
					var _v14 = _v13.a;
					var plan = _v14.a;
					var form = _v14.b;
					var _v15 = $author$project$Utils$Form$fields(form);
					var basicPlan = _v15.aA;
					var familyMembershipPricingForm = _v15.cU;
					var membershipPricingForm = _v15.cX;
					var groupTierPricingForm = _v15.i;
					var newBasicPlanResult = A4(
						$author$project$Components$Plan$BasicForm$update,
						apiClient,
						planFormMsg,
						basicPlan,
						$elm$core$Maybe$Just(plan));
					var _v16 = function () {
						var _v17 = newBasicPlanResult.ac5;
						if (_v17.$ === 1) {
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Plan$Form$formFieldsUpdate(plan),
								$author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.y8),
								form);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										PB: $elm$core$Maybe$Just(
											_Utils_Tuple2(plan, newForm))
									}),
								$elm$core$Platform$Cmd$none);
						} else {
							var field = _v17.a;
							if (field.$ === 3) {
								var defaultPeriod = field.a;
								var tempForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Plan$Form$formFieldsUpdate(plan),
									$author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.y8),
									form);
								var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, tempForm);
								var defaultPeriodString = defaultPeriod ? 'annual' : 'month';
								var familyMembershipPricingResult = A3(
									$author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod,
									defaultPeriodString,
									$elm$core$Maybe$Just(plan),
									familyMembershipPricingForm);
								var groupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, groupTierPricingForm);
								var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, membershipPricingForm);
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Plan$Form$formFieldsUpdate(plan),
									$author$project$Components$Plan$Form$GroupTierPricingFields(groupTierPricingResult.y8),
									A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Plan$Form$formFieldsUpdate(plan),
										$author$project$Components$Plan$Form$MembershipPricingFields(newMembershipPricingResult.y8),
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Plan$Form$formFieldsUpdate(plan),
											$author$project$Components$Plan$Form$FamilyMembershipPricingFields(familyMembershipPricingResult.y8),
											tempForm)));
								return A5(
									$author$project$Components$Plan$Form$calculateAfterValidation,
									model,
									plan,
									newForm,
									$author$project$Components$Plan$BasicForm$calculateOpts(field),
									true);
							} else {
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Plan$Form$formFieldsUpdate(plan),
									$author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.y8),
									form);
								return A5(
									$author$project$Components$Plan$Form$calculateAfterValidation,
									model,
									plan,
									newForm,
									$author$project$Components$Plan$BasicForm$calculateOpts(field),
									$author$project$Components$Plan$BasicForm$showWarningModal(field));
							}
						}
					}();
					var newModel = _v16.a;
					var formCmd = _v16.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$BasicPlanFormUpdated, newBasicPlanResult.EC)
								])),
						newBasicPlanResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var planFormMsg = msg.a;
				var _v19 = model.PB;
				if (!_v19.$) {
					var _v20 = _v19.a;
					var plan = _v20.a;
					var form = _v20.b;
					var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
					var _v21 = $author$project$Utils$Form$fields(form);
					var membershipPricingForm = _v21.cX;
					var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, planFormMsg, membershipPricingForm);
					var _v22 = function () {
						var _v23 = newMembershipPricingResult.ac5;
						if (!_v23.$) {
							var field = _v23.a;
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Plan$Form$formFieldsUpdate(plan),
								$author$project$Components$Plan$Form$MembershipPricingFields(newMembershipPricingResult.y8),
								form);
							return A5(
								$author$project$Components$Plan$Form$calculateAfterValidation,
								model,
								plan,
								newForm,
								$author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field),
								true);
						} else {
							return A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$ToggleFixedMembershipPricing, form);
						}
					}();
					var newModel = _v22.a;
					var formCmd = _v22.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.EC)
								])),
						newMembershipPricingResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var planFormMsg = msg.a;
				var _v24 = model.PB;
				if (!_v24.$) {
					var _v25 = _v24.a;
					var plan = _v25.a;
					var form = _v25.b;
					var _v26 = $author$project$Utils$Form$fields(form);
					var familyMembershipPricingForm = _v26.cU;
					var newFamilyMembershipPricingResult = A3(
						$author$project$Components$Plan$Form$FamilyMembershipPricingFields$update,
						planFormMsg,
						familyMembershipPricingForm,
						$elm$core$Maybe$Just(plan));
					var _v27 = function () {
						var _v28 = newFamilyMembershipPricingResult.ac5;
						if (!_v28.$) {
							var groupPricingType = _v28.a;
							return A4(
								$author$project$Components$Plan$Form$updateForm,
								model,
								plan,
								$author$project$Components$Plan$Form$GroupPricingType(groupPricingType),
								form);
						} else {
							var field = _v28.a;
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Plan$Form$formFieldsUpdate(plan),
								$author$project$Components$Plan$Form$FamilyMembershipPricingFields(newFamilyMembershipPricingResult.y8),
								form);
							return A5(
								$author$project$Components$Plan$Form$calculateAfterValidation,
								model,
								plan,
								newForm,
								$author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field),
								true);
						}
					}();
					var newModel = _v27.a;
					var formCmd = _v27.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.EC)
								])),
						newFamilyMembershipPricingResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var planFormMsg = msg.a;
				var _v29 = model.PB;
				if (!_v29.$) {
					var _v30 = _v29.a;
					var plan = _v30.a;
					var form = _v30.b;
					var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
					var _v31 = $author$project$Utils$Form$fields(form);
					var groupTierPricingForm = _v31.i;
					var newGroupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$update, sharedFields, planFormMsg, groupTierPricingForm);
					var _v32 = function () {
						var _v33 = newGroupTierPricingResult.ac5;
						if (!_v33.$) {
							var field = _v33.a;
							var currentFields = $author$project$Utils$Form$fields(form);
							var updatedFields = _Utils_update(
								currentFields,
								{i: newGroupTierPricingResult.y8});
							var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
							return A5(
								$author$project$Components$Plan$Form$calculateAfterValidation,
								model,
								plan,
								newForm,
								$author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts(field),
								true);
						} else {
							return A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$ToggleFixedMembershipPricing, form);
						}
					}();
					var newModel = _v32.a;
					var formCmd = _v32.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.EC)
								])),
						newGroupTierPricingResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var planFormMsg = msg.a;
				var _v34 = model.PB;
				if (!_v34.$) {
					var _v35 = _v34.a;
					var plan = _v35.a;
					var form = _v35.b;
					var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
					var _v36 = $author$project$Utils$Form$fields(form);
					var specialRatesForm = _v36.de;
					var newSpecialRatesResult = A3($author$project$Components$Plan$Form$SpecialRatesFields$update, sharedFields, planFormMsg, specialRatesForm);
					var _v37 = function () {
						var _v38 = newSpecialRatesResult.ac5;
						var field = _v38;
						var currentFields = $author$project$Utils$Form$fields(form);
						var updatedFields = _Utils_update(
							currentFields,
							{de: newSpecialRatesResult.y8});
						var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
						return A5(
							$author$project$Components$Plan$Form$calculateAfterValidation,
							model,
							plan,
							newForm,
							$author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field),
							true);
					}();
					var newModel = _v37.a;
					var formCmd = _v37.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$SpecialRatesFieldsUpdated, newSpecialRatesResult.EC)
								])),
						newSpecialRatesResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var plan = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple2(plan, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var plan = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple2(plan, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$Plan$delete,
						apiClient,
						$author$project$Api$Provider$Plan$One$id(plan),
						$author$project$Components$Plan$Form$PlanDeleted(plan)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{fm: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var plan = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.F_),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Plan removed')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fm: $elm$core$Maybe$Just(
									_Utils_Tuple2(plan, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var _v40 = model.PB;
				if (!_v40.$) {
					var _v41 = _v40.a;
					var plan = _v41.a;
					var form = _v41.b;
					var newValidForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.WF, form);
					var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, newValidForm);
					var _v42 = A2(
						$author$project$Utils$Form$validate,
						A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.cO, model.oK, model.jv, plan),
						newValidForm);
					if (!_v42.$) {
						var _v43 = _v42.a;
						var newForm = _v43.a;
						var validFormFields = _v43.b;
						var _v44 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var planChange = _v44.ju;
						if (model.oq || planChange.bU) {
							var _v45 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
							var contractExpires = _v45.LP;
							var _v46 = A5(
								$author$project$Components$Plan$Form$ConfirmUpdateModal$init,
								apiClient,
								model.WF,
								plan,
								{LP: contractExpires},
								planChange);
							var confirmUpdateModal = _v46.a;
							var confirmUpdateModalCmd = _v46.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										hQ: $elm$core$Maybe$Just(
											_Utils_Tuple2(validFormFields, confirmUpdateModal)),
										PB: $elm$core$Maybe$Just(
											_Utils_Tuple2(plan, newForm))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$ConfirmUpdateModalMsg, confirmUpdateModalCmd),
								_List_Nil);
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										PB: $elm$core$Maybe$Just(
											_Utils_Tuple2(plan, newForm)),
										jY: $author$project$Api$Data$Loading
									}),
								A3($author$project$Components$Plan$Form$saveItem, apiClient, model.adR, validFormFields),
								_List_Nil);
						}
					} else {
						var newForm = _v42.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(
										_Utils_Tuple2(plan, newForm)),
									jY: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var response = msg.a;
				var _v47 = model.PB;
				if (!_v47.$) {
					var _v48 = _v47.a;
					var form = _v48.b;
					if (response.$ === 3) {
						var _v50 = $author$project$Utils$Form$fields(form);
						var planChange = _v50.ju;
						if (planChange.bU) {
							var apiFields = {
								KN: planChange.Vx.KN,
								KO: planChange.Vx.KO,
								$J: A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.adR;
									},
									planChange.Vx.$J)
							};
							return _Utils_Tuple3(
								model,
								A4($author$project$Api$Provider$Plan$SubsequentPlan$update, apiClient, model.adR, apiFields, $author$project$Components$Plan$Form$SubsequentPlanUpdated),
								_List_Nil);
						} else {
							return $author$project$Components$Plan$Form$updateSuccess(model);
						}
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var subMsg = msg.a;
				var _v51 = model.hQ;
				if (!_v51.$) {
					var _v52 = _v51.a;
					var validFormFields = _v52.a;
					var confirmUpdateModal = _v52.b;
					var confirmUpdateModalResult = A2($author$project$Components$Plan$Form$ConfirmUpdateModal$update, subMsg, confirmUpdateModal);
					var _v53 = function () {
						var _v54 = confirmUpdateModalResult.ac5;
						switch (_v54) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(validFormFields, confirmUpdateModalResult.y8)),
									model.jY,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.jY, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Components$Plan$Form$saveItem, apiClient, model.adR, validFormFields));
						}
					}();
					var newConfirmUpdateModal = _v53.a;
					var saveRequest = _v53.b;
					var saveItemCmd = _v53.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hQ: newConfirmUpdateModal, jY: saveRequest}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$ConfirmUpdateModalMsg, confirmUpdateModalResult.EC),
									saveItemCmd
								])),
						confirmUpdateModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var validFormFields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3($author$project$Components$Plan$Form$updatePlanRequest, apiClient, model.adR, validFormFields),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var response = msg.a;
				if (response.$ === 3) {
					return $author$project$Components$Plan$Form$updateSuccess(model);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 16:
				var debounceMsg = msg.a;
				var _v57 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Plan$Form$previewDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Plan$Form$debounceCalculate),
					debounceMsg,
					model.em);
				var newDebouncer = _v57.a;
				var cmd = _v57.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{em: newDebouncer}),
					cmd,
					_List_Nil);
			case 17:
				var formFields = msg.a;
				var previousPreviewId = model.afU.a;
				var previewId = previousPreviewId + 1;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							afU: _Utils_Tuple2(previewId, $author$project$Api$Data$Loading)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A6(
								$author$project$Api$Provider$Plan$calculate,
								apiClient,
								_List_fromArray(
									[1]),
								'plan_preview_' + $elm$core$String$fromInt(previewId),
								model.adR,
								$author$project$Components$Plan$Form$updatePlanFields(formFields),
								$author$project$Components$Plan$Form$GotPreview(previewId)),
								$elm$http$Http$cancel(
								'plan_preview_' + $elm$core$String$fromInt(previousPreviewId))
							])),
					_List_Nil);
			case 18:
				var previewId = msg.a;
				var response = msg.b;
				return _Utils_eq(model.afU.a, previewId) ? A3($author$project$Components$Plan$Form$resetParamsOnScope, apiClient, response, model) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 19:
				var _v58 = model.PB;
				if (!_v58.$) {
					var _v59 = _v58.a;
					var form = _v59.b;
					var _v60 = $author$project$Utils$Form$fields(form);
					var coveragePlan = _v60.L5;
					var _v61 = A2(
						$author$project$Components$Plan$Form$AddCoveragePlanModal$init,
						apiClient,
						A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$coveragePlanId, coveragePlan));
					var addCoveragePlanModal = _v61.a;
					var addCoveragePlanModalCmd = _v61.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hj: $elm$core$Maybe$Just(addCoveragePlanModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModalMsg, addCoveragePlanModalCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var subMsg = msg.a;
				var _v62 = model.PB;
				if (!_v62.$) {
					var _v63 = _v62.a;
					var plan = _v63.a;
					var form = _v63.b;
					var _v64 = model.hj;
					if (!_v64.$) {
						var addCoveragePlanModal = _v64.a;
						var addCoveragePlanModalResult = A3($author$project$Components$Plan$Form$AddCoveragePlanModal$update, apiClient, subMsg, addCoveragePlanModal);
						var _v65 = function () {
							var _v66 = addCoveragePlanModalResult.ac5;
							switch (_v66.$) {
								case 0:
									return _Utils_Tuple3(
										model,
										$elm$core$Platform$Cmd$none,
										$elm$core$Maybe$Just(addCoveragePlanModalResult.y8));
								case 1:
									return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
								default:
									var coveragePlan = _v66.a;
									return A2(
										$author$project$Utils$Tuple3$fromTuple2,
										$elm$core$Maybe$Nothing,
										A4(
											$author$project$Components$Plan$Form$updateForm,
											model,
											plan,
											$author$project$Components$Plan$Form$CoveragePlan(
												$elm$core$Maybe$Just(
													$author$project$Components$Plan$Form$CoveragePlanAll(coveragePlan))),
											form));
							}
						}();
						var newModel = _v65.a;
						var formCmd = _v65.b;
						var newAddCoveragePlanModal = _v65.c;
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{hj: newAddCoveragePlanModal}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModalMsg, addCoveragePlanModalResult.EC),
										formCmd
									])),
							addCoveragePlanModalResult.as);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 21:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Plan$Form$updateDateInputFormField,
					model,
					function ($) {
						return $.r5;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{r5: newDateInput});
						}),
					subMsg,
					$author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg,
					$author$project$Components$Plan$Form$PlanChangeChangeOnDate);
			case 22:
				var subMsg = msg.a;
				var _v67 = model.gn;
				if (!_v67.$) {
					var planChangeToPlanResourceFilter = _v67.a;
					var planChangeToPlanResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planChangeToPlanResourceFilter);
					var newForm = function () {
						var _v68 = _Utils_Tuple2(model.PB, planChangeToPlanResourceFilterResult.ac5);
						if (((!_v68.a.$) && (!_v68.b.$)) && (!_v68.b.a.$)) {
							if (!_v68.b.a.a.$) {
								var _v69 = _v68.a.a;
								var plan = _v69.a;
								var form = _v69.b;
								var newPlan = _v68.b.a.a.a;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										plan,
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Plan$Form$formFieldsUpdate(plan),
											$author$project$Components$Plan$Form$PlanChangeToPlan(
												$elm$core$Maybe$Just(newPlan)),
											form)));
							} else {
								var _v70 = _v68.a.a;
								var plan = _v70.a;
								var form = _v70.b;
								return $elm$core$Maybe$Just(
									_Utils_Tuple2(
										plan,
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Plan$Form$formFieldsUpdate(plan),
											$author$project$Components$Plan$Form$PlanChangeToPlan($elm$core$Maybe$Nothing),
											form)));
							}
						} else {
							return model.PB;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: newForm,
								gn: $elm$core$Maybe$Just(planChangeToPlanResourceFilterResult.y8)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg, planChangeToPlanResourceFilterResult.EC),
						planChangeToPlanResourceFilterResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var _v71 = model.PB;
				if (!_v71.$) {
					var _v72 = _v71.a;
					var plan = _v72.a;
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New(
								{
									adR: $author$project$Api$Provider$Plan$One$id(plan)
								})),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var _v73 = model.PB;
				if (!_v73.$) {
					var _v74 = _v73.a;
					var plan = _v74.a;
					var _v75 = $author$project$Api$Provider$Plan$One$upcomingPricingVersion(plan);
					if (!_v75.$) {
						var pricingVersion = _v75.a;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String(
									{
										adR: $author$project$Api$Provider$Plan$One$id(plan),
										afY: $author$project$Api$Provider$PricingVersion$Shared$id(pricingVersion)
									})),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$CompanyPlans$Id_String$update = F2(
	function (msg, model) {
		return A2(
			$author$project$Utils$Tuple3$mapFirst,
			function (planForm) {
				return _Utils_update(
					model,
					{ny: planForm});
			},
			A3($author$project$Components$Plan$Form$update, model.D5, msg, model.ny));
	});
var $author$project$Components$Plan$Form$DeletePlan = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Plan$Form$Save = {$: 11};
var $author$project$Api$Provider$Plan$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.RJ;
};
var $author$project$Api$Provider$Plan$One$isDestroyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$isDestroyable(shared);
};
var $author$project$Ui$Link$Mailto = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Link$mailto = F3(
	function (mailto_, options, content) {
		return A2(
			$author$project$Ui$Link$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$Mailto(mailto_),
				options),
			content);
	});
var $author$project$Api$Provider$Plan$One$usedInScheduledPlanChanges = function (_v0) {
	var record = _v0.b;
	return record.aay;
};
var $author$project$Components$Plan$Form$AddCoveragePlanModal$Save = {$: 0};
var $author$project$Components$ResourceFilter$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ResourceFilter$errors = $author$project$Components$ResourceFilter$Errors;
var $author$project$Components$ResourceFilter$Invalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$invalid = $author$project$Components$ResourceFilter$Invalid;
var $author$project$Components$ResourceFilter$CoveragePlan$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Plan$Form$AddCoveragePlanModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Plan$Form$AddCoveragePlanModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						(_Utils_eq(model.adR, $elm$core$Maybe$Nothing) ? 'Add' : 'Change') + ' Coverage Plan')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$horizontal,
								$author$project$Ui$Form$onSubmit($author$project$Components$Plan$Form$AddCoveragePlanModal$Save)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8),
										$author$project$Ui$Form$Group$label('Coverage Plan'),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg,
										A2(
											$author$project$Components$ResourceFilter$CoveragePlan$view,
											_List_fromArray(
												[
													$author$project$Components$ResourceFilter$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
													$author$project$Components$ResourceFilter$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.PB))
												]),
											model.wU))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$AddCoveragePlanModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						function () {
						var verb = _Utils_eq(model.adR, $elm$core$Maybe$Nothing) ? 'Add' : 'Update';
						return A3(
							$author$project$Ui$Button$view,
							{abp: verb},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$AddCoveragePlanModal$Save)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(verb)
								]));
					}()
					]))
			]));
};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$Confirm = {$: 1};
var $author$project$Api$Provider$Plan$Shared$activeCompaniesCount = function (_v0) {
	var record = _v0;
	return record.Id;
};
var $author$project$Api$Provider$Plan$One$activeCompaniesCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$activeCompaniesCount(shared);
};
var $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount = function (_v0) {
	var record = _v0;
	return record.Ig;
};
var $author$project$Api$Provider$Plan$One$activeMembershipPatientsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount(shared);
};
var $author$project$Components$Plan$Form$ConfirmUpdateModal$maxPatientsCount = 100;
var $author$project$Ui$Types$Sm = 1;
var $author$project$Ui$Spinner$small = $author$project$Ui$Spinner$Size(1);
var $author$project$Api$Provider$Practice$Shared$usesSponsors = function (_v0) {
	var record = _v0;
	return record.aaH;
};
var $author$project$Api$Provider$Practice$One$usesSponsors = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$usesSponsors(shared);
};
var $author$project$Formatters$String$sponsorize = F2(
	function (practice, string) {
		if ($author$project$Api$Provider$Practice$One$usesSponsors(practice)) {
			switch (string) {
				case 'employee':
					return 'member';
				case 'Employee':
					return 'Member';
				case 'employees':
					return 'members';
				case 'employer':
					return 'sponsor';
				case 'employers':
					return 'sponsors';
				case 'Employer':
					return 'Sponsor';
				case 'Employers':
					return 'Sponsors';
				case 'Company':
					return 'Sponsor';
				case 'Companies':
					return 'Sponsors';
				case 'Employer Invoices':
					return 'Sponsor Invoices';
				default:
					return string;
			}
		} else {
			return string;
		}
	});
var $author$project$Components$Plan$Form$ConfirmUpdateModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Plan$Form$ConfirmUpdateModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Confirm updates')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Updated membership pricing')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You\'re about to update membership pricing which may affect the rates of '),
										$elm$html$Html$text(
										A2(
											$author$project$Formatters$String$pluralize,
											'patient',
											$author$project$Api$Provider$Plan$One$activeMembershipPatientsCount(model.GH))),
										(!$author$project$Api$Provider$Plan$One$planType(model.GH)) ? A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('across '),
												$elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													A2($author$project$Formatters$String$sponsorize, model.WF, 'employer'),
													$author$project$Api$Provider$Plan$One$activeCompaniesCount(model.GH)))
											])) : $author$project$Utils$Html$empty,
										$elm$html$Html$text(' on their next bill unless they have a manual rate set.')
									])),
								model.Vx.LP ? A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Note: these pricing changes will apply to patients on this plan immediately, not at the end of their contract period.')
									])) : $author$project$Utils$Html$empty
							])),
						model.ju.bU ? A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Added plan change')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You have enabled a plan change effective '),
										function () {
										var _v0 = model.ju.Vx.ahI;
										switch (_v0) {
											case 1:
												var changeAfterMonths = A2($elm$core$Maybe$withDefault, 0, model.ju.Vx.KN);
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Formatters$String$pluralize, 'month', changeAfterMonths)),
															$elm$html$Html$text(' after the membership starts.')
														]));
											case 0:
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('on '),
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'N/A',
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																	model.ju.Vx.KO)))
														]));
											default:
												var contractPeriodInMonths = A2($elm$core$Maybe$withDefault, 0, model.ju.Vx.LQ);
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths)),
															$elm$html$Html$text(' after the membership starts.')
														]));
										}
									}(),
										function () {
										var _v1 = model.VS;
										switch (_v1.$) {
											case 3:
												var patientsCount = _v1.a;
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													function () {
														if (!patientsCount.$) {
															if (!patientsCount.a) {
																return _List_fromArray(
																	[
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('No patients with this plan will be transitioned to the new plan if you confirm this.')
																	]);
															} else {
																var count = patientsCount.a;
																return _List_fromArray(
																	[
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text(
																		A2($author$project$Formatters$String$pluralize, 'patient', count)),
																		$elm$html$Html$text(' with this plan will be immediately transitioned to the new plan if you confirm this. '),
																		$elm$html$Html$text('You will receive an email with an attachment containing the patient ids of the patients affected.')
																	]);
															}
														} else {
															return _List_fromArray(
																[
																	$author$project$Utils$Html$noBreakSpace,
																	$elm$html$Html$text('More than '),
																	$elm$html$Html$text(
																	A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Components$Plan$Form$ConfirmUpdateModal$maxPatientsCount)),
																	$elm$html$Html$text(' with this plan will be immediately transitioned to the new plan if you confirm this. '),
																	$elm$html$Html$text('You will receive an email with an attachment containing the patient ids of the patients affected.')
																]);
														}
													}());
											case 0:
												return $author$project$Utils$Html$empty;
											default:
												return $author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small]));
										}
									}()
									]))
							])) : $author$project$Utils$Html$empty,
						model.ju.jL ? A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Removed plan change')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You have removed the plan change. '),
										$elm$html$Html$text('All the memberships that were already transitioned to the new plan will not be moved back.')
									]))
							])) : $author$project$Utils$Html$empty
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ConfirmUpdateModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Confirm updates'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ConfirmUpdateModal$Confirm)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirm updates')
							]))
					]))
			]));
};
var $author$project$Components$Plan$Form$modal = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.fm;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var plan = _v1.a;
					var deleteRequest = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Plan$Form$DeleteHiConfirmClosed(plan),
						A2(
							$elm$core$List$cons,
							$author$project$Components$HiConfirm$noun('plan'),
							A2(
								$elm$core$List$cons,
								$author$project$Components$HiConfirm$verb('delete'),
								A2(
									$elm$core$List$cons,
									$author$project$Components$HiConfirm$loading(
										_Utils_eq(deleteRequest, $author$project$Api$Data$Loading)),
									$author$project$Api$Provider$Plan$One$usedInScheduledPlanChanges(plan) ? _List_fromArray(
										[
											$author$project$Components$HiConfirm$customMessage(
											_List_fromArray(
												[
													$elm$html$Html$text('This plan is used in scheduled plan changes. Deleting it will remove those scheduled changes from existing and new memberships.')
												]))
										]) : _List_Nil))));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.hQ;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var confirmUpdateModal = _v3.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Plan$Form$ConfirmUpdateModalMsg,
						$author$project$Components$Plan$Form$ConfirmUpdateModal$view(confirmUpdateModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v4 = model.hj;
				if (!_v4.$) {
					var addCoveragePlanModal = _v4.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Plan$Form$AddCoveragePlanModalMsg,
						$author$project$Components$Plan$Form$AddCoveragePlanModal$view(addCoveragePlanModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Ui$FlexGrid$offsetSm = $author$project$Ui$FlexGrid$Offset(1);
var $author$project$Ui$Panel$OnlyBorderLeft = {$: 3};
var $author$project$Ui$Panel$onlyBorderLeft = $author$project$Ui$Panel$OnlyBorderLeft;
var $author$project$Components$Plan$Form$viewBackButton = function (listRoute) {
	return A3(
		$author$project$Ui$Link$route,
		listRoute,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Back')
			]));
};
var $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory = {$: 8};
var $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription = {$: 22};
var $author$project$Components$Plan$BasicForm$RegistrationFeeDescription = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Plan$BasicForm$RegistrationFeeName = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Plan$BasicForm$Addon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Feature$MultipleRetailMemberships = 17;
var $author$project$Ui$Form$Group$LabelHelp = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Group$labelHelp = $author$project$Ui$Form$Group$LabelHelp;
var $author$project$Components$Plan$BasicForm$viewAddonPlanField = F3(
	function (form, settings, forCompany) {
		var hasMultipleMemberships = A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, settings.WF);
		var showAddonToggle = hasMultipleMemberships && (settings.ym && (!forCompany));
		if (showAddonToggle) {
			var _v0 = $author$project$Utils$Form$fields(form);
			var addon = _v0.Iq;
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Enrollment Settings')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$offsetLabel,
								$author$project$Ui$Form$Group$labelSpanSm(5),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label('Add-On Plan'),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$labelHelp(
								$elm$html$Html$text('Patients can enroll in multiple add-ons at once'))
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(addon),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Addon))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Plan$BasicForm$BillsAtEndOfPeriod = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$BasicForm$DefaultChargeDescription = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Plan$BasicForm$DefaultChargeName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Plan$BasicForm$EditDefaultChargeDescription = {$: 7};
var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonths = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonthsRule = 0;
var $author$project$Components$Plan$BasicForm$ToggleRule = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Ui$Form$PeriodInMonthsInput$view = function (_v0) {
	var value = _v0.aaN;
	var onInput = _v0.afc;
	var invalid = _v0.q$;
	var errors = _v0.fE;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$group(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
								$author$project$Ui$Form$Input$onInput(onInput),
								$author$project$Ui$Form$Input$invalid(invalid)
							])),
						$author$project$Ui$Form$Input$addon(
						_List_fromArray(
							[
								(A2($elm$core$Maybe$withDefault, 0, value) === 1) ? $elm$html$Html$text('month') : $elm$html$Html$text('months')
							]))
					])),
				$author$project$Utils$FormErrors$view(errors)
			]));
};
var $author$project$Ui$SupportDocumentLink$view = function (supportDocumenUrl) {
	return A3(
		$author$project$Ui$Link$externalHref,
		supportDocumenUrl,
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_Nil,
						'Click to Learn More',
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 5)
							]))
					]))
			]));
};
var $author$project$Components$Plan$BasicForm$DefaultPeriod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Plan$Meta$allPeriodCodes = function (_v0) {
	var meta = _v0;
	return meta.IT;
};
var $author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes = _List_fromArray(
	['month', 'quarter', 'semi_annual', 'annual']);
var $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercent = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Plan$BasicForm$AnnualAllowed = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Plan$BasicForm$MonthAllowed = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercent = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Plan$BasicForm$QuarterAllowed = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercent = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Plan$BasicForm$SemiAnnualAllowed = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ui$Form$PercentageInput$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$PercentageInput$invalid = $author$project$Ui$Form$PercentageInput$Invalid;
var $author$project$Ui$FlexGrid$None = 0;
var $author$project$Ui$FlexGrid$noGutter = $author$project$Ui$FlexGrid$Gutter(0);
var $author$project$Ui$Form$PercentageInput$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$PercentageInput$onInput = $author$project$Ui$Form$PercentageInput$OnInput;
var $author$project$Ui$FlexGrid$rowItemsEnd = $author$project$Ui$FlexGrid$RowElement($author$project$Ui$Element$itemsEnd);
var $author$project$Ui$Form$PercentageInput$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$PercentageInput$value = $author$project$Ui$Form$PercentageInput$Value;
var $author$project$Ui$Form$PercentageInput$defaultOptions = {fE: _List_Nil, ap: _List_Nil, q$: false, aaN: $elm$core$Maybe$Nothing};
var $author$project$Percentage$fromString = $elm$core$Basics$identity;
var $author$project$Ui$Form$PercentageInput$inputHandler = function (handler) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Utils$String$toMaybe,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($author$project$Percentage$fromString),
			handler));
};
var $author$project$Percentage$toString = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Ui$Form$PercentageInput$inputValue = function (percentage) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Percentage$toString, percentage));
};
var $author$project$Ui$Form$PercentageInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$onInput(
										$author$project$Ui$Form$PercentageInput$inputHandler(handler)),
									record.ap)
							});
					case 1:
						var percentage = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$value(
										$author$project$Ui$Form$PercentageInput$inputValue(percentage)),
									record.ap),
								aaN: percentage
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{q$: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
					case 4:
						var string = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$placeholder(string),
									record.ap)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$disabled(bool),
									record.ap)
							});
				}
			}),
		$author$project$Ui$Form$PercentageInput$defaultOptions,
		options);
};
var $author$project$Ui$Form$PercentageInput$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$PercentageInput$optionsToRecord(options);
	return $author$project$Ui$Form$Input$group(
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$invalid(optionsRecord.q$),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$errors(optionsRecord.fE),
						A2($elm$core$List$cons, $author$project$Ui$Form$Input$number, optionsRecord.ap)))),
				$author$project$Ui$Form$Input$addon(
				_List_fromArray(
					[
						$elm$html$Html$text('%')
					]))
			]));
};
var $author$project$Components$Plan$BasicForm$viewPeriodField = F3(
	function (defaultPeriod, form, periodCode) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			switch (periodCode) {
				case 'month':
					return _Utils_Tuple2(fields.za, $author$project$Components$Plan$BasicForm$MonthAllowed);
				case 'quarter':
					return _Utils_Tuple2(fields.Bg, $author$project$Components$Plan$BasicForm$QuarterAllowed);
				case 'semi_annual':
					return _Utils_Tuple2(fields.B7, $author$project$Components$Plan$BasicForm$SemiAnnualAllowed);
				case 'annual':
					return _Utils_Tuple2(fields.vo, $author$project$Components$Plan$BasicForm$AnnualAllowed);
				default:
					return _Utils_Tuple2(fields.za, $author$project$Components$Plan$BasicForm$MonthAllowed);
			}
		}();
		var on = _v0.a;
		var field = _v0.b;
		return (!_Utils_eq(periodCode, defaultPeriod)) ? A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsEnd, $author$project$Ui$FlexGrid$noGutter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4),
									$author$project$Ui$FlexGrid$offsetSm(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small]),
											_List_fromArray(
												[$author$project$Utils$Html$noBreakSpace])),
											$elm$html$Html$text(
											$author$project$Formatters$String$humanize(periodCode)),
											$elm$html$Html$text('ly')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(2),
									$author$project$Ui$FlexGrid$justifyLeft
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(on),
											$author$project$Ui$ToggleSwitch$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, field))
										]))
								])),
							function () {
							if (on) {
								var _v2 = function () {
									switch (periodCode) {
										case 'month':
											return _Utils_Tuple3(fields.y9, $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent, 1);
										case 'quarter':
											return _Utils_Tuple3(fields.Bf, $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercent, 2);
										case 'semi_annual':
											return _Utils_Tuple3(fields.B6, $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercent, 3);
										case 'annual':
											return _Utils_Tuple3(fields.vn, $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercent, 4);
										default:
											return _Utils_Tuple3(fields.y9, $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent, 1);
									}
								}();
								var adjustmentPercentage = _v2.a;
								var adjustmentField = _v2.b;
								var adjustmentValidation = _v2.c;
								return A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													function () {
													switch (defaultPeriod) {
														case 'month':
															return $elm$html$Html$text('Default Discount');
														case 'annual':
															return $elm$html$Html$text('Default Surcharge');
														default:
															return $author$project$Utils$Html$empty;
													}
												}()
												])),
											$author$project$Ui$Form$PercentageInput$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$PercentageInput$value(adjustmentPercentage),
													$author$project$Ui$Form$PercentageInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, adjustmentField)),
													$author$project$Ui$Form$PercentageInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, adjustmentValidation, form))
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, adjustmentValidation, form))
										]));
							} else {
								return $author$project$Ui$FlexGrid$none;
							}
						}()
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Plan$BasicForm$viewBillingPeriodsFields = F3(
	function (practiceIsOnboarding, maybePlan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var billsAtEndOfPeriod = _v0.J0;
		var defaultPeriod = _v0.Nf;
		var formGroupOptions = _Utils_ap(
			billsAtEndOfPeriod ? _List_fromArray(
				[
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text('You can only bill monthly when billing at the end of the period'))
				]) : _List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label(
					practiceIsOnboarding ? 'Default Billing Period is month' : 'Default Billing Period'),
					$author$project$Ui$Form$Group$labelClass('')
				]));
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Form$Group$view,
				formGroupOptions,
				_List_fromArray(
					[
						practiceIsOnboarding ? $author$project$Utils$Html$empty : $author$project$Ui$Button$group(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Select annual period'},
								_List_fromArray(
									[
										$author$project$Ui$Button$disabled(billsAtEndOfPeriod),
										$author$project$Ui$Button$active(defaultPeriod === 'annual'),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Plan$BasicForm$FormUpdated(
											$author$project$Components$Plan$BasicForm$DefaultPeriod(true)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Annual')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Select monthly period'},
								_List_fromArray(
									[
										$author$project$Ui$Button$disabled(billsAtEndOfPeriod),
										$author$project$Ui$Button$active(defaultPeriod !== 'annual'),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Plan$BasicForm$FormUpdated(
											$author$project$Components$Plan$BasicForm$DefaultPeriod(false)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Month')
									]))
							]))
					])),
			function () {
				if (!billsAtEndOfPeriod) {
					var allPeriodCodes = function () {
						if (!maybePlan.$) {
							var plan = maybePlan.a;
							var meta = $author$project$Api$Provider$Plan$One$meta(plan);
							return $author$project$Api$Provider$Plan$Meta$allPeriodCodes(meta);
						} else {
							return $author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes;
						}
					}();
					return A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Additional billing periods'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									(defaultPeriod === 'month') ? $elm$html$Html$text('Offer a percentage off pre-paid memberships') : $elm$html$Html$text('Set a surcharge for shorter billing periods'))
								]),
							_List_Nil),
						A2(
							$elm$core$List$map,
							A2($author$project$Components$Plan$BasicForm$viewPeriodField, defaultPeriod, form),
							allPeriodCodes));
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Plan$BasicForm$viewBillingOptionsFields = F3(
	function (practiceIsOnboarding, maybePlan, form) {
		var isMcePlan = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
		var forCompany = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (plan) {
					return !$author$project$Api$Provider$Plan$One$planType(plan);
				},
				maybePlan));
		var editingPlan = !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing);
		var showForm = (!forCompany) && (editingPlan && ((!practiceIsOnboarding) && (!isMcePlan)));
		var _v0 = $author$project$Utils$Form$fields(form);
		var billsAtEndOfPeriod = _v0.J0;
		var rules = _v0.YY;
		var minimumEnrollmentPeriodInMonths = _v0.T3;
		var defaultPeriod = _v0.Nf;
		var defaultChargeName = _v0.w5;
		var defaultChargeDescription = _v0.w4;
		var editingDefaultChargeDescription = _v0.qo;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						$elm$core$List$singleton(
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Do you want to allow patients to pay you in advance?')
										])),
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
								]))),
						function () {
						if (showForm) {
							var disableToggle = function () {
								if (!maybePlan.$) {
									var plan = maybePlan.a;
									return $author$project$Api$Provider$Plan$One$activeMembershipPatientsCount(plan) > 0;
								} else {
									return false;
								}
							}();
							return $elm$core$List$singleton(
								A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Bill at the End of the Billing Period'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('This will only impact newly created memberships'))
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(billsAtEndOfPeriod),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$BillsAtEndOfPeriod)),
													$author$project$Ui$ToggleSwitch$disabled(disableToggle)
												]))
										])));
						} else {
							return _List_Nil;
						}
					}(),
						isMcePlan ? _List_Nil : A3($author$project$Components$Plan$BasicForm$viewBillingPeriodsFields, practiceIsOnboarding, maybePlan, form),
						showForm ? $elm$core$List$singleton(
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Minimum Initial Enrollment Period'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('You may prevent patients from cancelling for up to 12 months')),
									$author$project$Ui$Form$Group$required(rules.T3.Ot)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(4)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.T3.Ot),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$BasicForm$FormUpdated,
																		$author$project$Components$Plan$BasicForm$ToggleRule(0)))
																]))
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(8)
												]),
											_List_fromArray(
												[
													rules.T3.Ot ? $author$project$Ui$Form$PeriodInMonthsInput$view(
													{
														fE: A2($author$project$Utils$Form$validationErrors, 5, form),
														q$: A2($author$project$Utils$Form$hasValidationErrors, 5, form),
														afc: A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonths),
														aaN: minimumEnrollmentPeriodInMonths
													}) : $author$project$Utils$Html$empty
												]))
										]))
								]))) : _List_Nil,
						(editingPlan && (!practiceIsOnboarding)) ? $elm$core$List$singleton(
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Invoice Detail'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('How would you like these charges to be shown on your invoices?')),
									$author$project$Ui$Form$Group$required(rules.T3.Ot)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(12)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text('Charge Name')
														])),
													$author$project$Ui$Form$Input$group(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$addon(
															_List_fromArray(
																[
																	(defaultPeriod === 'month') ? $elm$html$Html$text('Monthly') : $elm$html$Html$text('Annual')
																])),
															$author$project$Ui$Form$Input$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$value(defaultChargeName),
																	$author$project$Ui$Form$Input$onInput(
																	A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$DefaultChargeName)),
																	$author$project$Ui$Form$Input$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 6, form))
																]))
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 6, form))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(12)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text('Charge Description')
														])),
													editingDefaultChargeDescription ? $author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$value(
															A2($elm$core$Maybe$withDefault, '', defaultChargeDescription)),
															$author$project$Ui$Form$Input$onInput(
															A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$DefaultChargeDescription)),
															$author$project$Ui$Form$Input$phi(true),
															$author$project$Ui$Form$Input$placeholder('None')
														])) : A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Edit default charge description'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$pull(1),
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Plan$BasicForm$FormUpdated($author$project$Components$Plan$BasicForm$EditDefaultChargeDescription))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Edit')
																])),
															function () {
															if (!defaultChargeDescription.$) {
																var defaultChargeDescription_ = defaultChargeDescription.a;
																return A2(
																	$author$project$Ui$Typography$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(defaultChargeDescription_)
																		]));
															} else {
																return A2(
																	$author$project$Ui$Typography$span,
																	_List_fromArray(
																		[$author$project$Ui$Typography$muted]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('None')
																		]));
															}
														}()
														]))
												]))
										]))
								]))) : _List_Nil
					])));
	});
var $author$project$Components$Plan$BasicForm$ImageUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$BasicForm$viewImageField = F2(
	function (errors, currentImageUrl) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label('Plan Image'),
					$author$project$Ui$Form$Group$labelClass('')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Components$Plan$BasicForm$ImageUploaded)
						])),
					function () {
					if (!currentImageUrl.$) {
						if (currentImageUrl.a === '') {
							return $author$project$Utils$Html$empty;
						} else {
							var url = currentImageUrl.a;
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Image$fromSrc,
										{I1: 'Plan image'},
										url,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(100)
											]))
									]));
						}
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$FormErrors$view(errors)
				]));
	});
var $author$project$Components$Plan$BasicForm$Buyable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$BasicForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$BasicForm$viewNameAndDescriptionFields = F4(
	function (fields, nameErrors, forCompany, buyableEditable) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Plan Name & Description')
						])),
					(!forCompany) ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('This will be displayed to your patients when they enroll through online signup')
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Plan Name'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.zh),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Name)),
									$author$project$Ui$Form$Input$invalid(
									!$elm$core$List$isEmpty(nameErrors)),
									$author$project$Ui$Form$Input$errors(nameErrors)
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$Plan$BasicForm$DescriptionMsg,
					A2(
						$author$project$Components$TranslatedRichText$view,
						{acT: 'plan-description-editor', aej: 'Plan Description', ae0: true},
						fields.Nx)),
					buyableEditable ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Allow members to enroll via Patient Portal'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.Kh),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Buyable))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCentsRule = 0;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCentsRule = 1;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$Category$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields = F4(
	function (parentFormData, onParentFieldMsg, onComponentMsg, _v0) {
		var form = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Registration Fees')
								])),
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Fee for Individual'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(fields.YY.QW.Ot)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.YY.QW.Ot),
													$author$project$Ui$ToggleSwitch$onChange(
													function (_v1) {
														return onComponentMsg(
															$author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated(
																$author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule(0)));
													})
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									_List_fromArray(
										[
											fields.YY.QW.Ot ? A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$CurrencyInput$value(fields.QW),
															$author$project$Ui$Form$CurrencyInput$onInput(
															A2(
																$elm$core$Basics$composeL,
																A2($elm$core$Basics$composeL, onComponentMsg, $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated),
																$author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents)),
															$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, form))
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 0, form))
												])) : $author$project$Utils$Html$empty
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Max fee for family'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(fields.YY.Tr.Ot)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.YY.Tr.Ot),
													$author$project$Ui$ToggleSwitch$onChange(
													function (_v2) {
														return onComponentMsg(
															$author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated(
																$author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule(1)));
													})
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									_List_fromArray(
										[
											fields.YY.Tr.Ot ? A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$CurrencyInput$value(fields.Tr),
															$author$project$Ui$Form$CurrencyInput$onInput(
															A2(
																$elm$core$Basics$composeL,
																A2($elm$core$Basics$composeL, onComponentMsg, $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated),
																$author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCents)),
															$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 1, form))
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 1, form))
												])) : $author$project$Utils$Html$empty
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Invoice Detail'),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('How would you like these charges to be shown on your invoices?')),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Charge Name')
												])),
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(parentFormData.Bq),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, onParentFieldMsg, parentFormData.afk)),
													$author$project$Ui$Form$Input$invalid(parentFormData.adG)
												])),
											$author$project$Utils$FormErrors$view(parentFormData.agd)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label(''),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Charge Description')
												])),
											parentFormData.lY ? A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$value(parentFormData.Bp),
															$author$project$Ui$Form$Input$onInput(
															A2($elm$core$Basics$composeL, onParentFieldMsg, parentFormData.afj)),
															$author$project$Ui$Form$Input$invalid(false),
															$author$project$Ui$Form$Input$placeholder('None')
														])),
													$author$project$Utils$FormErrors$view(_List_Nil)
												])) : A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Edit registration fee description'},
													_List_fromArray(
														[
															$author$project$Ui$Button$pull(1),
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$onClick(
															onParentFieldMsg(parentFormData.ae7))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														])),
													function () {
													var _v3 = $author$project$Utils$String$toMaybe(parentFormData.Bp);
													if (!_v3.$) {
														var description = _v3.a;
														return A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text(description)
																]));
													} else {
														return A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text('None')
																]));
													}
												}()
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label(''),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Charge Category')
												])),
											function () {
											if (!parentFormData.iy) {
												return A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Edit registration fee category'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$pull(1),
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																	$author$project$Ui$Button$onClick(
																	onParentFieldMsg(parentFormData.ae6))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Edit')
																])),
															A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text(parentFormData.KM)
																]))
														]));
											} else {
												var _v4 = fields.cJ;
												if (!_v4.$) {
													var categoryResourceFilter = _v4.a;
													return A2(
														$elm$html$Html$map,
														onComponentMsg,
														A2(
															$elm$html$Html$map,
															$author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg,
															A2($author$project$Components$ResourceFilter$Category$view, _List_Nil, categoryResourceFilter)));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}
										}()
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCents = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes = function (_v0) {
	var meta = _v0;
	return meta.IZ;
};
var $author$project$Api$Period$numberOfMonths = function (_v0) {
	var period = _v0;
	return period.ji;
};
var $author$project$Api$Period$Period = $elm$core$Basics$identity;
var $author$project$Api$Period$list = _List_fromArray(
	[
		{lc: 'monthly', K3: 'month', ji: 1, nQ: 'Monthly'},
		{lc: 'quarterly', K3: 'quarter', ji: 3, nQ: 'Quarterly'},
		{lc: 'semi-annually', K3: 'semi_annual', ji: 6, nQ: 'Semi-Annual'},
		{lc: 'annually', K3: 'annual', ji: 12, nQ: 'Annual'}
	]);
var $author$project$Api$Period$retrieve = function (code_) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (_v0) {
			var period = _v0;
			return _Utils_eq(period.K3, code_);
		},
		$author$project$Api$Period$list);
};
var $author$project$Components$Plan$BasicForm$fixedFeeAmountForPeriod = F4(
	function (fields, defaultPeriod, sponsorFeeDealAmountInCents, periodCode) {
		var period = $author$project$Api$Period$retrieve(periodCode);
		var periodInMonths = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $author$project$Api$Period$numberOfMonths, period));
		var amount = function (amount_) {
			return (defaultPeriod === 'annual') ? ((amount_ / 12) | 0) : amount_;
		}(
			periodInMonths * A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, sponsorFeeDealAmountInCents)));
		var adjustment = _Utils_eq(defaultPeriod, periodCode) ? 0 : function (adjustment_) {
			return (defaultPeriod === 'month') ? (adjustment_ * (-1)) : adjustment_;
		}(
			function () {
				switch (periodCode) {
					case 'month':
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.y9));
					case 'quarter':
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Bf));
					case 'semi_annual':
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.B6));
					case 'annual':
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.vn));
					default:
						return 0;
				}
			}());
		return $elm$core$Basics$round(amount * (1 + (adjustment / 100)));
	});
var $author$project$Components$Plan$BasicForm$viewPeriod = F4(
	function (fields, defaultPeriod, sponsorFeeDealAmountInCents, allowedPeriod) {
		return (!_Utils_eq(defaultPeriod, allowedPeriod)) ? A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(12)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(allowedPeriod)),
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								A4($author$project$Components$Plan$BasicForm$fixedFeeAmountForPeriod, fields, defaultPeriod, sponsorFeeDealAmountInCents, allowedPeriod)))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Plan$BasicForm$viewSponsorFeeDealFields = F3(
	function (practiceIsOnboarding, plan, form) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		var allowedPeriodCodes = $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta);
		var fields = $author$project$Utils$Form$fields(form);
		var defaultPeriod = fields.Nf;
		var sponsorFeeDealAmountInCents = fields.Hi;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Amount'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(defaultPeriod)),
									$elm$html$Html$text(' rate')
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(sponsorFeeDealAmountInCents),
											$author$project$Ui$Form$CurrencyInput$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCents)),
											$author$project$Ui$Form$CurrencyInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 7, form))
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 7, form))
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A3($author$project$Components$Plan$BasicForm$viewPeriod, fields, defaultPeriod, sponsorFeeDealAmountInCents),
								allowedPeriodCodes))
						])),
				A3(
					$author$project$Components$Plan$BasicForm$viewBillingPeriodsFields,
					practiceIsOnboarding,
					$elm$core$Maybe$Just(plan),
					form)));
	});
var $author$project$Components$Plan$BasicForm$view = F2(
	function (_v0, maybePlan) {
		var settings = _v0.a;
		var form = _v0.b;
		var planType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
		var forCompany = !planType;
		var fields = $author$project$Utils$Form$fields(form);
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		var buyableEditable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 23, settings.WF);
		return _List_fromArray(
			[
				A4(
				$author$project$Components$Plan$BasicForm$viewNameAndDescriptionFields,
				fields,
				errorsFor(0),
				forCompany,
				buyableEditable),
				buyableEditable ? A2(
				$author$project$Components$Plan$BasicForm$viewImageField,
				errorsFor(10),
				fields.p4) : $author$project$Utils$Html$empty,
				$author$project$Utils$Html$noBreakSpace,
				A3($author$project$Components$Plan$BasicForm$viewAddonPlanField, form, settings, forCompany),
				$author$project$Utils$Html$noBreakSpace,
				A4(
				$author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields,
				{
					KM: fields.sl,
					iy: fields.iy,
					lY: fields.lY,
					adG: A2($author$project$Utils$Form$hasValidationErrors, 8, form),
					ae6: $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory,
					ae7: $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription,
					afj: $author$project$Components$Plan$BasicForm$RegistrationFeeDescription,
					afk: $author$project$Components$Plan$BasicForm$RegistrationFeeName,
					Bp: fields.Bp,
					Bq: fields.Bq,
					agd: A2($author$project$Utils$Form$validationErrors, 8, form)
				},
				$author$project$Components$Plan$BasicForm$FormUpdated,
				$author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg,
				fields.c9),
				function () {
				if (planType === 1) {
					if (!maybePlan.$) {
						var plan = maybePlan.a;
						return A3($author$project$Components$Plan$BasicForm$viewSponsorFeeDealFields, settings.WI, plan, form);
					} else {
						return $author$project$Utils$Html$empty;
					}
				} else {
					return A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A3($author$project$Components$Plan$BasicForm$viewBillingOptionsFields, settings.WI, maybePlan, form)
							]));
				}
			}()
			]);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedRule = 1;
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleEnabled = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitRule = 0;
var $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedRule = 2;
var $author$project$Ui$Icon$Random = 59;
var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleEnabled = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleFixedMembershipPricing = {$: 13};
var $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$McePricing$One$coupleRates = function (_v0) {
	var record = _v0;
	return record.L0;
};
var $author$project$Api$Provider$McePricing$One$familyRates = function (_v0) {
	var record = _v0;
	return record.O8;
};
var $author$project$Utils$RateRule$groupTierCode = F2(
	function (retail, type_) {
		if (retail) {
			switch (type_.$) {
				case 0:
					return 'MEM';
				case 1:
					return 'MSP';
				case 2:
					return 'MCH';
				case 3:
					return 'FAM';
				case 4:
					return '';
				case 5:
					return '';
				case 6:
					return '';
				case 8:
					return '';
				case 9:
					return '';
				case 7:
					return '';
				default:
					return '';
			}
		} else {
			switch (type_.$) {
				case 0:
					return 'EMP';
				case 1:
					return 'ESP';
				case 2:
					return 'ECH';
				case 3:
					return 'FAM';
				case 4:
					return '';
				case 5:
					return '';
				case 6:
					return '';
				case 8:
					return '';
				case 9:
					return '';
				case 7:
					return '';
				default:
					return '';
			}
		}
	});
var $author$project$Utils$RateRule$groupTierName = function (type_) {
	switch (type_.$) {
		case 0:
			return 'Primary';
		case 1:
			return 'Primary + Spouse';
		case 2:
			return 'Primary + Children';
		case 3:
			return 'Family';
		case 4:
			return 'Primary + 1 Child';
		case 5:
			return 'Primary + Spouse + 1 Child';
		case 6:
			return 'Additional Adult Rate';
		case 7:
			return 'Additional Child Rate';
		case 8:
			return 'Age Based';
		case 9:
			return 'Age Based Couple';
		default:
			var name = type_.a;
			return name;
	}
};
var $author$project$Api$Provider$McePricing$One$individualRates = function (_v0) {
	var record = _v0;
	return record.QV;
};
var $author$project$Ui$Form$Group$labelHtml = A2($elm$core$Basics$composeR, $author$project$Ui$Form$Group$Html, $author$project$Ui$Form$Group$Label);
var $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates = function (_v0) {
	var record = _v0;
	return record.Z9;
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncluded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAdultsLimitField = F5(
	function (label, enabled, value, form, onToggle) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text('Turn off for no limit'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4),
									$author$project$Ui$FlexGrid$justifyLeft
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(enabled),
											$author$project$Ui$ToggleSwitch$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
												$elm$core$Basics$always(onToggle)))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(8)
								]),
							enabled ? _List_fromArray(
								[
									$author$project$Ui$Form$Input$group(
									A2(
										$author$project$Ui$Form$Input$withPreAddon,
										'Up to and including',
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
												$author$project$Ui$Form$Input$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncluded),
													$elm$core$String$toInt)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, form))
											]))),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, form))
								]) : _List_Nil)
						]))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimit = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAgeLimitField = F5(
	function (label, enabled, value, form, onToggle) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text('Turn off for no limit. Children above the age limit will be billed as adults'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4),
									$author$project$Ui$FlexGrid$justifyLeft
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(enabled),
											$author$project$Ui$ToggleSwitch$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
												$elm$core$Basics$always(onToggle)))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(8)
								]),
							enabled ? _List_fromArray(
								[
									$author$project$Ui$Form$Input$group(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
													$author$project$Ui$Form$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimit),
														$elm$core$String$toInt)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, form))
												])),
											$author$project$Ui$Form$Input$addon(
											_List_fromArray(
												[
													$elm$html$Html$text('& under')
												]))
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, form))
								]) : _List_Nil)
						]))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncluded = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewChildrenLimitField = F5(
	function (label, enabled, value, form, onToggle) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text('Turn off for no limit'))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4),
									$author$project$Ui$FlexGrid$justifyLeft
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(enabled),
											$author$project$Ui$ToggleSwitch$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
												$elm$core$Basics$always(onToggle)))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(8)
								]),
							enabled ? _List_fromArray(
								[
									$author$project$Ui$Form$Input$group(
									A2(
										$author$project$Ui$Form$Input$withPreAddon,
										'Up to and including',
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
												$author$project$Ui$Form$Input$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncluded),
													$elm$core$String$toInt)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, form))
											]))),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, form))
								]) : _List_Nil)
						]))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCents = F3(
	function (a, b, c) {
		return {$: 16, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsEdit = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsReset = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRulePeriod = F5(
	function (defaultPeriod, form, rule, isDiscount, period) {
		var _v0 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
				case 'quarter':
					return _Utils_Tuple3(rule.Xw, rule.Xx, rule.gr);
				case 'semi_annual':
					return _Utils_Tuple3(rule.Zj, rule.Zk, rule.gG);
				case 'annual':
					return _Utils_Tuple3(rule.I5, rule.I6, rule.e_);
				default:
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
			}
		}();
		var periodAmountInCents = _v0.a;
		var editingPeriod = _v0.b;
		var periodEdited = _v0.c;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
								rule.U2(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.GF(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.GF(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated(
												rule.Yu(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated(
												rule.N8(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRule = F5(
	function (defaultPeriod, form, periods, rule, isDiscount) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRulePeriod, defaultPeriod, form, rule, isDiscount),
			periods);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule = F4(
	function (defaultPeriod, plan, form, fixedRateRule) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		return A5(
			$author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRule,
			defaultPeriod,
			form,
			$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta),
			{
				I5: fixedRateRule.I5,
				e_: fixedRateRule.e_,
				I6: fixedRateRule.I6,
				N8: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsEdit(fixedRateRule.ahI),
				T8: fixedRateRule.T8,
				f5: fixedRateRule.f5,
				F7: fixedRateRule.F7,
				U2: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCents(fixedRateRule.ahI),
				GF: function (period) {
					return A2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation, fixedRateRule.ahI, period);
				},
				Xw: fixedRateRule.Xw,
				gr: fixedRateRule.gr,
				Xx: fixedRateRule.Xx,
				Yu: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsReset(fixedRateRule.ahI),
				Zj: fixedRateRule.Zj,
				gG: fixedRateRule.gG,
				Zk: fixedRateRule.Zk
			},
			false);
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Typography$ControlLabel = {$: 14};
var $author$project$Ui$Typography$controlLabel = $author$project$Ui$Typography$ControlLabel;
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewRateSplitSection = F2(
	function (fields, form) {
		var currentFields = $author$project$Utils$Form$fields(form);
		var splitRevenueType = currentFields._r;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Rate Split')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('For memberships with more than one member, choose how the rate will be split.')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offset(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$controlLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text('With Spouse')
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Radio$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Radio$value(splitRevenueType === 'even_children'),
													$author$project$Ui$Form$Radio$onCheck(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
														$elm$core$Basics$always(
															$author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_children'))))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('The spouse receives the \"Primary + Spouse\" minus the \"Primary\" rate.'),
													function () {
													var _v0 = _Utils_Tuple2(
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.L$.T8),
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.QU.T8));
													if ((!_v0.a.$) && (!_v0.b.$)) {
														var coupleMonthAmountInCents = _v0.a.a;
														var individualMonthAmountInCents = _v0.b.a;
														return A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Assign the primary member a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(individualMonthAmountInCents)),
																	$elm$html$Html$text(', and the spouse a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(coupleMonthAmountInCents - individualMonthAmountInCents)),
																	$elm$html$Html$text('.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Radio$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Radio$value(splitRevenueType === 'even_adult_children'),
													$author$project$Ui$Form$Radio$onCheck(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
														$elm$core$Basics$always(
															$author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_adult_children'))))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Primary and spouse split the the \"Primary + Spouse\" rate.'),
													function () {
													var _v1 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.L$.T8);
													if (!_v1.$) {
														var coupleMonthAmountInCents = _v1.a;
														var halfCoupleRate = $elm$core$Basics$floor(coupleMonthAmountInCents / 2);
														return A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Assign the primary member a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(coupleMonthAmountInCents - halfCoupleRate)),
																	$elm$html$Html$text(', and the spouse a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(halfCoupleRate)),
																	$elm$html$Html$text('.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$controlLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text('With Children')
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Checkbox$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Checkbox$value(splitRevenueType !== 'even_all'),
													$author$project$Ui$Form$Checkbox$disabled(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Split the remaining rate evenly among the children'),
													function () {
													var _v2 = _Utils_Tuple2(
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.QU.T8),
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Z8.T8));
													if ((!_v2.a.$) && (!_v2.b.$)) {
														var individualMonthAmountInCents = _v2.a.a;
														var singleParentMonthAmountInCents = _v2.b.a;
														return A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('For single parents, assign the children a combined rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(singleParentMonthAmountInCents - individualMonthAmountInCents)),
																	$elm$html$Html$text(' divided evenly between them.'),
																	$elm$html$Html$text('If there\'s only one child, assign them the entire '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(singleParentMonthAmountInCents - individualMonthAmountInCents)),
																	$elm$html$Html$text('.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}(),
													function () {
													var _v3 = _Utils_Tuple2(
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.O7.T8),
														A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.L$.T8));
													if ((!_v3.a.$) && (!_v3.b.$)) {
														var familyMonthAmountInCents = _v3.a.a;
														var coupleMonthAmountInCents = _v3.b.a;
														return A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('For families, assign the children a combined rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(familyMonthAmountInCents - coupleMonthAmountInCents)),
																	$elm$html$Html$text(' divided evenly between them.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$controlLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text('Everyone')
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Radio$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Radio$value(splitRevenueType === 'even_all'),
													$author$project$Ui$Form$Radio$onCheck(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated,
														$elm$core$Basics$always(
															$author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_all'))))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Divide the group rate evenly across all members.'),
													function () {
													var _v4 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.O7.T8);
													if (!_v4.$) {
														var familyMonthAmountInCents = _v4.a;
														return A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
															_List_fromArray(
																[
																	$elm$html$Html$text('For a family of four, they will each receive a rate of '),
																	$elm$html$Html$text(
																	$author$project$Utils$Currency$fromInt(
																		$elm$core$Basics$round(familyMonthAmountInCents / 4))),
																	$elm$html$Html$text('. If the family rate does not divide evenly, some individual rates will be '),
																	$elm$html$Html$text('adjusted by a few pennies so that the individual rates will sum to the group rate.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Api$Provider$McePricing$One$getLowestAgeBandPrice = function (ageBands) {
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.Ba;
		},
		$elm$core$List$head(ageBands));
};
var $author$project$Api$Provider$Plan$One$mcePricing = function (_v0) {
	var record = _v0.b;
	return record.Ty;
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewMceLowestAgeBandValue = function (mceLowestAgeBandValue) {
	return $author$project$Ui$Form$CurrencyInput$view(
		_List_fromArray(
			[
				function () {
				if (!mceLowestAgeBandValue.$) {
					var mceValue_ = mceLowestAgeBandValue.a;
					return $author$project$Ui$Form$CurrencyInput$value(
						$elm$core$Maybe$Just(
							$author$project$Currency$fromInt(mceValue_)));
				} else {
					return $author$project$Ui$Form$CurrencyInput$value($elm$core$Maybe$Nothing);
				}
			}(),
				$author$project$Ui$Form$CurrencyInput$disabled(true)
			]));
};
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing = F5(
	function (plan, defaultPeriod, fixedRateRule, mceRateRule, form) {
		var _v0 = $author$project$Api$Provider$Plan$One$mcePricing(plan);
		if (!_v0.$) {
			var maybePricing = _v0.a;
			return $elm$core$List$singleton(
				$author$project$Components$Plan$Form$GroupTierPricingFields$viewMceLowestAgeBandValue(
					A2(
						$elm$core$Maybe$andThen,
						$author$project$Api$Provider$McePricing$One$getLowestAgeBandPrice,
						A2($elm$core$Maybe$map, mceRateRule, maybePricing))));
		} else {
			return A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, defaultPeriod, plan, form, fixedRateRule);
		}
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$viewGroupTierPricingFieldsWithSharedFields = F3(
	function (sharedFields, plan, _v0) {
		var form = _v0;
		var forCompany = !$author$project$Api$Provider$Plan$One$planType(plan);
		var fourTierHelpUrl = forCompany ? 'https://support.hint.com/employers/four-tier-pricing' : 'https://support.hint.com/account-configuration/four-tier-pricing-for-patients';
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Group Tier Pricing'),
							$author$project$Utils$Html$noBreakSpace,
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							$author$project$Ui$SupportDocumentLink$view(fourTierHelpUrl))
						])),
					$author$project$Api$Provider$Plan$One$isMcePlan(plan) ? $author$project$Utils$Html$empty : A3(
					$author$project$Ui$Button$view,
					{abp: ' Switch to Individual Rates with Discounts'},
					_List_fromArray(
						[
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated($author$project$Components$Plan$Form$GroupTierPricingFields$ToggleFixedMembershipPricing))
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 59),
							$elm$html$Html$text(' Switch to Individual Rates with Discounts')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Group Tier pricing assigns one of the defined tiers to every primary member and their dependents.')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Individual)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Utils$RateRule$groupTierCode,
												$author$project$Api$Provider$Plan$One$planType(plan) === 2,
												$author$project$Api$RateRuleType$Individual))
										]))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nf, fields.QU, $author$project$Api$Provider$McePricing$One$individualRates, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Couple)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Utils$RateRule$groupTierCode,
												$author$project$Api$Provider$Plan$One$planType(plan) === 2,
												$author$project$Api$RateRuleType$Couple))
										]))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nf, fields.L$, $author$project$Api$Provider$McePricing$One$coupleRates, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$FamilyWithSingleChild)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Utils$RateRule$groupTierCode,
												$author$project$Api$Provider$Plan$One$planType(plan) === 2,
												$author$project$Api$RateRuleType$FamilyWithSingleChild))
										]))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.Pa),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleEnabled)),
													$author$project$Ui$ToggleSwitch$disabled(
													$author$project$Api$Provider$Plan$One$isMcePlan(plan))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									fields.Pa ? A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nf, fields.O9, $author$project$Api$Provider$McePricing$One$familyRates, form) : _List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$SingleParent)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Utils$RateRule$groupTierCode,
												$author$project$Api$Provider$Plan$One$planType(plan) === 2,
												$author$project$Api$RateRuleType$SingleParent))
										]))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nf, fields.Z8, $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$SingleParentWithSingleChild)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Utils$RateRule$groupTierCode,
												$author$project$Api$Provider$Plan$One$planType(plan) === 2,
												$author$project$Api$RateRuleType$SingleParentWithSingleChild))
										]))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields._b),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleEnabled)),
													$author$project$Ui$ToggleSwitch$disabled(
													$author$project$Api$Provider$Plan$One$isMcePlan(plan))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									fields._b ? A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nf, fields._a, $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates, form) : _List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Family)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Utils$RateRule$groupTierCode,
												$author$project$Api$Provider$Plan$One$planType(plan) === 2,
												$author$project$Api$RateRuleType$Family))
										]))
								])),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nf, fields.O7, $author$project$Api$Provider$McePricing$One$familyRates, form))
								]))
						])),
					A5(
					$author$project$Components$Plan$Form$GroupTierPricingFields$viewAgeLimitField,
					'Children Age Limit',
					fields.YY.Pv.Ot,
					fields.Pv,
					form,
					$author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(0)),
					A5(
					$author$project$Components$Plan$Form$GroupTierPricingFields$viewAdultsLimitField,
					'Limit Adults in Family Plan',
					fields.YY.O6.Ot,
					fields.O6,
					form,
					$author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(1)),
					fields.YY.O6.Ot ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$AdditionalAdult)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Utils$RateRule$groupTierCode,
												$author$project$Api$Provider$Plan$One$planType(plan) === 2,
												$author$project$Api$RateRuleType$AdditionalAdult))
										]))
								])),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('For group that don\'t fall into tiers above (i.e. 3 adults)'))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, sharedFields.Nf, plan, form, fields.Io))
								]))
						])) : $elm$html$Html$text(''),
					A5(
					$author$project$Components$Plan$Form$GroupTierPricingFields$viewChildrenLimitField,
					'Limit Children in Family Plan',
					fields.YY.PZ.Ot,
					fields.PZ,
					form,
					$author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(2)),
					fields.YY.PZ.Ot ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$labelHtml(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$AdditionalChild)),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Utils$RateRule$groupTierCode,
												$author$project$Api$Provider$Plan$One$planType(plan) === 2,
												$author$project$Api$RateRuleType$AdditionalChild))
										]))
								])),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('For groups that exceed the children limit'))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_Nil),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, sharedFields.Nf, plan, form, fields.Ip))
								]))
						])) : $elm$html$Html$text(''),
					A2($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateSplitSection, fields, form)
				]));
	});
var $author$project$Components$Plan$Form$GroupTierPricingFields$view = F3(
	function (sharedFields, maybePlan, groupTierPricingForm) {
		if (!maybePlan.$) {
			var plan = maybePlan.a;
			return A3($author$project$Components$Plan$Form$GroupTierPricingFields$viewGroupTierPricingFieldsWithSharedFields, sharedFields, plan, groupTierPricingForm);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAdd = {$: 0};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ToggleFixedMembershipPricing = {$: 10};
var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$rulesetHasGaps = function (rules) {
	if ($elm$core$List$length(rules) <= 1) {
		return false;
	} else {
		var pairs = A2(
			$elm_community$list_extra$List$Extra$zip,
			rules,
			A2($elm$core$List$drop, 1, rules));
		return A2(
			$elm$core$List$any,
			function (_v0) {
				var current = _v0.a;
				var next = _v0.b;
				var _v1 = current.$I;
				if (_v1.$ === 1) {
					return false;
				} else {
					var currentTo = _v1.a;
					if (_Utils_eq(current.aai, next.aai)) {
						return _Utils_cmp(currentTo + 1, next.PH) < 0;
					} else {
						var nextFromMonths = (!next.aai) ? (next.PH * 12) : next.PH;
						var currentToMonths = (!current.aai) ? (currentTo * 12) : currentTo;
						return _Utils_cmp(currentToMonths + 1, nextFromMonths) < 0;
					}
				}
			},
			pairs);
	}
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCents = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsEdit = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsReset = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleRemove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleToAge = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleUnit = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Feature$AgeTieredCoupleRates = 20;
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCents = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsEdit = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsReset = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleToAgeOptions = function (unit) {
	var maxAge = function () {
		if (unit === 1) {
			return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths;
		} else {
			return 150;
		}
	}();
	return A2(
		$elm$core$List$map,
		function (age) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(age)),
				$elm$core$String$fromInt(age));
		},
		A2($elm$core$List$range, 0, maxAge));
};
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleUnitOptions = _List_fromArray(
	[
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Api$Provider$RateRule$Shared$unitToString(1)),
		'Months'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Api$Provider$RateRule$Shared$unitToString(0)),
		'Years')
	]);
var $author$project$Api$Employer$Practice$One$featureEnabled = F2(
	function (feature, _v0) {
		var record = _v0;
		return A2(
			$elm$core$List$member,
			$author$project$Api$Feature$toString(feature),
			record.Pd);
	});
var $author$project$Api$Practice$featureEnabled = F2(
	function (feature, practice) {
		if (!practice.$) {
			var practice_ = practice.a;
			return A2($author$project$Api$Provider$Practice$One$featureEnabled, feature, practice_);
		} else {
			var practice_ = practice.a;
			return A2($author$project$Api$Employer$Practice$One$featureEnabled, feature, practice_);
		}
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$isUnitEditable = F2(
	function (rules, index) {
		var prevAgeRateRule = A2($elm_community$list_extra$List$Extra$getAt, index - 1, rules);
		var nextAgeRateRule = A2($elm_community$list_extra$List$Extra$getAt, index + 1, rules);
		var isPrevRuleYears = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (rule) {
					return !rule.aai;
				},
				prevAgeRateRule));
		var isNextRuleMonths = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (unit) {
					return unit === 1;
				},
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.aai;
					},
					nextAgeRateRule)));
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(rules) - 1);
		return (!isLast) && ((!isPrevRuleYears) && (!isNextRuleMonths));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRulePeriod = F7(
	function (_v0, form, editingPlan, rule, isDiscount, isCouplePricing, period) {
		var defaultPeriod = _v0.Nf;
		var _v1 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
				case 'quarter':
					return _Utils_Tuple3(rule.Xw, rule.Xx, rule.gr);
				case 'semi_annual':
					return _Utils_Tuple3(rule.Zj, rule.Zk, rule.gG);
				case 'annual':
					return _Utils_Tuple3(rule.I5, rule.I6, rule.e_);
				default:
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
			}
		}();
		var periodAmountInCents = _v1.a;
		var editingPeriod = _v1.b;
		var periodEdited = _v1.c;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							isCouplePricing ? $elm$html$Html$text('Couple ') : $elm$html$Html$text(''),
							isCouplePricing ? $elm$html$Html$text(
							$elm$core$String$toLower(
								$author$project$Formatters$String$humanize(period))) : $elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated,
								rule.U2(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.GF(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.GF(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					(!editingPlan) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated(
												rule.Yu(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated(
												rule.N8(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule = F7(
	function (sharedFields, form, _v0, periods, rule, isDiscount, isCouplePricing) {
		var editingPlan = _v0.Ob;
		return A2(
			$elm$core$List$map,
			A6($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRulePeriod, sharedFields, form, editingPlan, rule, isDiscount, isCouplePricing),
			periods);
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAgeRateRule = F6(
	function (sharedFields, practice, maybePlan, form, index, ageRateRule) {
		var periodCodes = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes,
			A2(
				$elm$core$Maybe$map,
				function (plan) {
					return $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(
						$author$project$Api$Provider$Plan$One$meta(plan));
				},
				maybePlan));
		var isFirst = !index;
		var _v0 = $author$project$Utils$Form$fields(form);
		var ageRateRules = _v0.IL;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									_List_fromArray(
										[$author$project$Utils$Html$noBreakSpace])),
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(ageRateRule.PH))
										]))
								]))
						]),
						function () {
						if (_Utils_eq(ageRateRule.$I, $elm$core$Maybe$Nothing)) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small]),
											_List_fromArray(
												[$author$project$Utils$Html$noBreakSpace])),
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('All')
												]))
										]))
								]);
						} else {
							var isLast = _Utils_eq(
								$elm$core$List$length(ageRateRules) - 1,
								index);
							return isLast ? _List_Nil : _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small]),
											_List_fromArray(
												[$author$project$Utils$Html$noBreakSpace])),
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, ageRateRule.$I)),
													$author$project$Ui$Form$Select$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated,
														$author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleToAge(index)))
												]),
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleToAgeOptions(ageRateRule.aai))
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									_List_fromArray(
										[$author$project$Utils$Html$noBreakSpace])),
									A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$isUnitEditable, ageRateRules, index) ? A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$RateRule$Shared$unitToString(ageRateRule.aai))),
											$author$project$Ui$Form$Select$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated,
												$author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleUnit(index)))
										]),
									$author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleUnitOptions) : A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('capitalize')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$RateRule$Shared$unitToString(ageRateRule.aai))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									_List_fromArray(
										[$author$project$Utils$Html$noBreakSpace])),
									(!isFirst) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Remove age rule'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated(
												$author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleRemove(index))),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Remove')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							$elm$core$List$concat(
								_List_fromArray(
									[
										A7(
										$author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule,
										sharedFields,
										form,
										{
											Ob: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
										},
										periodCodes,
										{
											I5: ageRateRule.c7.I5,
											e_: ageRateRule.c7.e_,
											I6: ageRateRule.c7.I6,
											N8: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsEdit(index),
											T8: ageRateRule.c7.T8,
											f5: ageRateRule.c7.f5,
											F7: ageRateRule.c7.F7,
											U2: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCents(index),
											GF: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation(index),
											Xw: ageRateRule.c7.Xw,
											gr: ageRateRule.c7.gr,
											Xx: ageRateRule.c7.Xx,
											Yu: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsReset(index),
											Zj: ageRateRule.c7.Zj,
											gG: ageRateRule.c7.gG,
											Zk: ageRateRule.c7.Zk
										},
										false,
										false),
										function () {
										if (A2(
											$author$project$Api$Practice$featureEnabled,
											20,
											$author$project$Api$Practice$Provider(practice))) {
											var _v1 = ageRateRule.L_;
											if (!_v1.$) {
												var coupleRule = _v1.a;
												return A2(
													$elm$core$List$cons,
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($elm$html$Html$Attributes$style, 'margin-top', '20px')
															]),
														_List_Nil),
													A7(
														$author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule,
														sharedFields,
														form,
														{
															Ob: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
														},
														periodCodes,
														{
															I5: coupleRule.c7.I5,
															e_: coupleRule.c7.e_,
															I6: coupleRule.c7.I6,
															N8: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsEdit(index),
															T8: coupleRule.c7.T8,
															f5: coupleRule.c7.f5,
															F7: coupleRule.c7.F7,
															U2: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCents(index),
															GF: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation(index),
															Xw: coupleRule.c7.Xw,
															gr: coupleRule.c7.gr,
															Xx: coupleRule.c7.Xx,
															Yu: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsReset(index),
															Zj: coupleRule.c7.Zj,
															gG: coupleRule.c7.gG,
															Zk: coupleRule.c7.Zk
														},
														false,
														true));
											} else {
												return _List_Nil;
											}
										} else {
											return _List_Nil;
										}
									}()
									])))
						])
					])));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewIndividualMembershipPricingFields = F4(
	function (sharedFields, practice, maybePlan, _v0) {
		var form = _v0;
		var _v1 = $author$project$Utils$Form$fields(form);
		var ageRateRules = _v1.IL;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Individual Membership Rates'),
							$author$project$Utils$Html$noBreakSpace,
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Utils$FeatureGate$gate,
							7,
							$author$project$Api$Practice$Provider(practice),
							function () {
								if (!maybePlan.$) {
									return A3(
										$author$project$Ui$Button$view,
										{abp: 'Switch to group tier pricing'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated($author$project$Components$Plan$Form$IndividualMembershipPricingFields$ToggleFixedMembershipPricing))
											]),
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 59),
												$elm$html$Html$text(' Switch to Group tier pricing')
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Set one individual rate or age based rates with the option for family or group discounts.')
								]))
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var messageStyle = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$rulesetHasGaps(
								$author$project$Utils$Form$fields(form).IL) ? '' : 'invisible';
							return A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$warning]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(messageStyle)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('We noticed a gap between your age tiers. Patients whose ages don\'t match any tier will automatically be charged the first tier price. You can adjust the ranges before saving.')
											]))
									]));
						}()
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(11),
									$author$project$Ui$FlexGrid$offsetSm(1)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Table$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('From Age')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('To Age')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Units')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_Nil),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(4)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Rate')
												]))
										]),
									A2(
										$elm$core$List$indexedMap,
										A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAgeRateRule, sharedFields, practice, maybePlan, form),
										ageRateRules),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$row,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Table$cell,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Add age range'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated($author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAdd)),
																	$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Range')
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$view = F4(
	function (sharedFields, practice, maybePlan, _v0) {
		var form = _v0;
		return A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewIndividualMembershipPricingFields, sharedFields, practice, maybePlan, form);
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$FormUpdated = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAdd = {$: 0};
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCents = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsEdit = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsReset = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateName = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateRemove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SvgIcon$Minus = 68;
var $author$project$Ui$SvgIcon$minus = $author$project$Ui$SvgIcon$viewIcon(68);
var $author$project$Ui$Table$None = {$: 0};
var $author$project$Ui$Table$none = $author$project$Ui$Table$None;
var $author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRulePeriod = F5(
	function (defaultPeriod, form, rule, isDiscount, period) {
		var _v0 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
				case 'quarter':
					return _Utils_Tuple3(rule.Xw, rule.Xx, rule.gr);
				case 'semi_annual':
					return _Utils_Tuple3(rule.Zj, rule.Zk, rule.gG);
				case 'annual':
					return _Utils_Tuple3(rule.I5, rule.I6, rule.e_);
				default:
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
			}
		}();
		var periodAmountInCents = _v0.a;
		var editingPeriod = _v0.b;
		var periodEdited = _v0.c;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$identity,
								rule.U2(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.GF(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.GF(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											rule.Yu(period))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											rule.N8(period))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRule = F5(
	function (defaultPeriod, form, periods, rule, isDiscount) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRulePeriod, defaultPeriod, form, rule, isDiscount),
			periods);
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$viewSpecialRateFields = F4(
	function (plan, form, index, specialRate) {
		return specialRate.NB ? $author$project$Ui$Table$none : A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[$author$project$Utils$Html$noBreakSpace])),
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(specialRate.zh),
									$author$project$Ui$Form$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Basics$identity,
										$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateName(index))),
									$author$project$Ui$Form$Input$placeholder('Student Rate'),
									$author$project$Ui$Form$Input$invalid(
									A2(
										$author$project$Utils$Form$hasValidationErrors,
										$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index),
										form)),
									$author$project$Ui$Form$Input$errors(
									A2(
										$author$project$Utils$Form$validationErrors,
										$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index),
										form))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[$author$project$Utils$Html$noBreakSpace])),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$active(!specialRate.RJ)
										]),
									'Cannot be removed because active members are on it.',
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Remove special rate'},
											_List_fromArray(
												[
													$author$project$Ui$Button$disabled(!specialRate.RJ),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateRemove(index)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$minus)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Remove')
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A5(
						$author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRule,
						$author$project$Api$Provider$Plan$One$defaultPeriod(plan),
						form,
						$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(
							$author$project$Api$Provider$Plan$One$meta(plan)),
						{
							I5: specialRate.I5,
							e_: specialRate.e_,
							I6: specialRate.I6,
							N8: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsEdit(index),
							T8: specialRate.T8,
							f5: specialRate.f5,
							F7: specialRate.F7,
							U2: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCents(index),
							GF: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation(index),
							Xw: specialRate.Xw,
							gr: specialRate.gr,
							Xx: specialRate.Xx,
							Yu: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsReset(index),
							Zj: specialRate.Zj,
							gG: specialRate.gG,
							Zk: specialRate.Zk
						},
						false))
				]));
	});
var $author$project$Components$Plan$Form$SpecialRatesFields$view = F2(
	function (plan, _v0) {
		var form = _v0;
		var _v1 = $author$project$Utils$Form$fields(form);
		var specialRates = _v1._o;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Special Rates')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('If the rates above do not fully cover your fee schedule, you can define special rates below (e.g., \"College Student\"). You can then manually apply these on a per-person basis. They will also be displayed on patient invoices in place of the charge\'s name.')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(11),
									$author$project$Ui$FlexGrid$offsetSm(1)
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$Table$view,
									_List_fromArray(
										[
											$author$project$Ui$Table$zeroState(
											_List_fromArray(
												[
													$elm$html$Html$text('No special rates on this plan.')
												]))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(6)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(2)
												]),
											_List_Nil),
											A2(
											$author$project$Ui$Table$header,
											_List_fromArray(
												[
													$author$project$Ui$Table$cellSpan(4)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Rate')
												]))
										]),
									A2(
										$elm$core$List$indexedMap,
										A2($author$project$Components$Plan$Form$SpecialRatesFields$viewSpecialRateFields, plan, form),
										specialRates),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$row,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Table$cell,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Add special rate'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAdd),
																	$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Special Rate')
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$MaximumAge = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Plan$Form$MinimumAge = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Plan$Form$ToggleMaximumAge = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Plan$Form$ToggleMinimumAge = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Plan$Form$ageRestrictionOptions = A2(
	$elm$core$List$map,
	function (age) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(age)),
			$elm$core$String$fromInt(age));
	},
	A2($elm$core$List$range, 0, 150));
var $author$project$Components$Plan$Form$viewAgeRestrictionsFields = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var editMinimumAge = _v0.xj;
	var editMaximumAge = _v0.xi;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Age restrictions')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Patients above or below these age limits will not be able to enroll in this plan online. Your practice staff will see a warning if they try to enroll patients outside the age range.')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Minimum Age'),
						$author$project$Ui$Form$Group$labelClass('')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_fromArray(
							[$author$project$Ui$FlexGrid$rowItemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4),
										$author$project$Ui$FlexGrid$justifyLeft
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(editMinimumAge),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ToggleMinimumAge))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(8)
									]),
								_List_fromArray(
									[
										function () {
										if (editMinimumAge) {
											var _v1 = $author$project$Utils$Form$fields(form);
											var minimumAge = _v1.T1;
											return A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, minimumAge)),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$MinimumAge))
													]),
												$author$project$Components$Plan$Form$ageRestrictionOptions);
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Maximum Age'),
						$author$project$Ui$Form$Group$labelClass('')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_fromArray(
							[$author$project$Ui$FlexGrid$rowItemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4),
										$author$project$Ui$FlexGrid$justifyLeft
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(editMaximumAge),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ToggleMaximumAge))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(8)
									]),
								_List_fromArray(
									[
										function () {
										if (editMaximumAge) {
											var _v2 = $author$project$Utils$Form$fields(form);
											var maximumAge = _v2.Tu;
											return A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, maximumAge)),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$MaximumAge))
													]),
												$author$project$Components$Plan$Form$ageRestrictionOptions);
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					]))
			]));
};
var $author$project$Components$Plan$Form$ContractExpires = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Plan$Form$ContractEmailsEnabled = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Plan$Form$ContractPeriodInMonths = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Plan$Form$ContractRenewalEmailLeadTime = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Plan$Form$ContractType = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Plan$Meta$contractTypes = function (_v0) {
	var meta = _v0;
	return meta.LS;
};
var $author$project$Components$Plan$Form$contractTypeOptions = function (planMeta) {
	var contractTypes = $author$project$Api$Provider$Plan$Meta$contractTypes(planMeta);
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose an action'),
		A2(
			$elm$core$List$map,
			function (type_) {
				var typeString = $author$project$Api$ContractType$toString(type_);
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(typeString),
					$author$project$Formatters$String$titleize(
						$author$project$Formatters$String$humanize(typeString)));
			},
			contractTypes));
};
var $author$project$Components$Plan$Form$viewContractExpiresFields = F2(
	function (plan, form) {
		var planMeta = $author$project$Api$Provider$Plan$One$meta(plan);
		var _v0 = $author$project$Utils$Form$fields(form);
		var contractPeriodInMonths = _v0.LQ;
		var contractType = _v0.EI;
		var contractEmailsEnabled = _v0.LO;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Contract Period'),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$PeriodInMonthsInput$view(
						{
							fE: A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, form),
							q$: A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, form),
							afc: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractPeriodInMonths),
							aaN: contractPeriodInMonths
						}),
						A2($author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid, plan, contractPeriodInMonths) ? A2(
						$author$project$Ui$Alert$danger,
						_List_fromArray(
							[
								$author$project$Ui$Alert$margin(20)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[$author$project$Ui$Typography$small]),
								_List_fromArray(
									[
										$elm$html$Html$text('The contract period should be a multiple of the longest billing period. For example, for a membership with annual billing, the contract can be 12, 24, 36, etc. months long.')
									]))
							])) : $author$project$Utils$Html$empty
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Default Behavior at End of Contract'),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								A2($elm$core$Maybe$map, $author$project$Api$ContractType$toString, contractType)),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractType)),
								$author$project$Ui$Form$Select$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractTypeValidation, form)),
								$author$project$Ui$Form$Select$errors(
								A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractTypeValidation, form))
							]),
						$author$project$Components$Plan$Form$contractTypeOptions(planMeta))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Send Renewal Email'),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$labelHelp(
						$elm$html$Html$text('If set to off, we will not email patients regarding their renewal or termination'))
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(contractEmailsEnabled),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractEmailsEnabled))
							]))
					])),
				function () {
				if (contractEmailsEnabled) {
					var _v1 = $author$project$Utils$Form$fields(form);
					var contractRenewalEmailLeadTime = _v1.LR;
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$offsetLabel,
								$author$project$Ui$Form$Group$labelSpanSm(5),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label('Renewal email lead time'),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$group(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, contractRenewalEmailLeadTime))),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTime)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, form))
											])),
										$author$project$Ui$Form$Input$addon(
										_List_fromArray(
											[
												(A2($elm$core$Maybe$withDefault, 0, contractRenewalEmailLeadTime) === 1) ? $elm$html$Html$text('day') : $elm$html$Html$text('days')
											]))
									])),
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, form))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]);
	});
var $author$project$Components$Plan$Form$viewContractPeriodFields = F2(
	function (plan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var contractExpires = _v0.LP;
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Contract Period'),
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/setting-a-contract-length'))
							]))
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Contract Expiration'),
							$author$project$Ui$Form$Group$labelClass('')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(contractExpires),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractExpires))
								]))
						])),
				contractExpires ? A2($author$project$Components$Plan$Form$viewContractExpiresFields, plan, form) : _List_Nil));
	});
var $author$project$Components$Plan$Form$OpenCoveragePlanModal = {$: 19};
var $author$project$Api$Provider$CoveragePlan$Shared$coverageRules = function (_v0) {
	var record = _v0;
	return record.acd;
};
var $author$project$Api$Provider$CoveragePlan$All$coverageRules = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoveragePlan$Shared$coverageRules(shared);
};
var $author$project$Api$Provider$CoveragePlan$One$coverageRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoveragePlan$Shared$coverageRules(shared);
};
var $author$project$Components$Plan$Form$coveragePlanCoverageRules = function (coveragePlan) {
	if (!coveragePlan.$) {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_);
	} else {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$All$coverageRules(coveragePlan_);
	}
};
var $author$project$Api$Provider$CoveragePlan$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoveragePlan$Shared$name(shared);
};
var $author$project$Components$Plan$Form$coveragePlanName = function (coveragePlan) {
	if (!coveragePlan.$) {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$One$name(coveragePlan_);
	} else {
		var coveragePlan_ = coveragePlan.a;
		return $author$project$Api$Provider$CoveragePlan$All$name(coveragePlan_);
	}
};
var $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton = A3(
	$author$project$Ui$Button$view,
	{abp: 'Delete plan coverage'},
	_List_fromArray(
		[
			$author$project$Ui$Button$pull(1),
			$author$project$Ui$Button$size(0),
			$author$project$Ui$Button$link,
			$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
			$author$project$Ui$Button$onClick(
			$author$project$Components$Plan$Form$FormUpdated(
				$author$project$Components$Plan$Form$CoveragePlan($elm$core$Maybe$Nothing))),
			$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Delete')
		]));
var $author$project$Components$Plan$Form$viewCoveragePlanUndoButton = F2(
	function (originalCoveragePlan, action) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Undo ' + action},
			_List_fromArray(
				[
					$author$project$Ui$Button$pull(1),
					$author$project$Ui$Button$size(0),
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Plan$Form$FormUpdated(
						$author$project$Components$Plan$Form$CoveragePlan(
							$elm$core$Maybe$Just(
								$author$project$Components$Plan$Form$CoveragePlanOne(originalCoveragePlan))))),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Undo '),
					$elm$html$Html$text(action)
				]));
	});
var $author$project$Components$CoverageRuleDescription$One = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage = function (_v0) {
	var record = _v0;
	return record.afD;
};
var $author$project$Api$Provider$CoverageRule$One$patientContributionPercentage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage = function (_v0) {
	var record = _v0;
	return record.ag4;
};
var $author$project$Api$Provider$CoverageRule$One$sponsorContributionPercentage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(shared);
};
var $author$project$Components$CoverageRuleDescription$coveredBy = function (coverageRule) {
	var sponsorContributionPercentage = function () {
		if (!coverageRule.$) {
			var shared = coverageRule.a;
			return $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(shared);
		} else {
			var one = coverageRule.a;
			return $author$project$Api$Provider$CoverageRule$One$sponsorContributionPercentage(one);
		}
	}();
	var patientContributionPercentage = function () {
		if (!coverageRule.$) {
			var shared = coverageRule.a;
			return $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(shared);
		} else {
			var one = coverageRule.a;
			return $author$project$Api$Provider$CoverageRule$One$patientContributionPercentage(one);
		}
	}();
	var _v0 = _Utils_Tuple2(patientContributionPercentage, sponsorContributionPercentage);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var patientContributionPercentage_ = _v0.a.a;
		var sponsorContributionPercentage_ = _v0.b.a;
		return (_Utils_cmp(patientContributionPercentage_, sponsorContributionPercentage_) > 0) ? 'patient' : 'sponsor';
	} else {
		return 'sponsor';
	}
};
var $author$project$Ui$Typography$Underline = 0;
var $author$project$Ui$Typography$underline = $author$project$Ui$Typography$Decoration(0);
var $author$project$Components$CoverageRuleDescription$highlightText = F2(
	function (string, shouldHighlightText) {
		return shouldHighlightText ? A2(
			$author$project$Ui$Typography$strong,
			_List_fromArray(
				[$author$project$Ui$Typography$underline]),
			_List_fromArray(
				[
					$elm$html$Html$text(string)
				])) : $elm$html$Html$text(string);
	});
var $author$project$Api$Provider$CoverageRule$Shared$All = 0;
var $author$project$Api$Provider$CoverageRule$Shared$UnderPrice = 1;
var $author$project$Api$Provider$CoverageRule$Shared$includedOption = function (_v0) {
	var record = _v0;
	if (record.agA === 'included') {
		var _v1 = record.I2;
		if (!_v1.$) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$CoverageRule$One$includedOption = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$item = function (_v0) {
	var record = _v0;
	return record.FU;
};
var $author$project$Api$Provider$CoverageRule$One$item = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$item(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$CoverageRule$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$percentage = function (_v0) {
	var record = _v0;
	return record.afJ;
};
var $author$project$Api$Provider$CoverageRule$One$percentage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$percentage(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Bd;
};
var $author$project$Api$Provider$CoverageRule$One$quantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$quantity(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$ruleType = function (_v0) {
	var record = _v0;
	return record.agA;
};
var $author$project$Api$Provider$CoverageRule$One$ruleType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$ruleType(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$BeginningOfYear = 0;
var $author$project$Api$Provider$CoverageRule$Shared$MembershipRenewalDate = 1;
var $author$project$Api$Provider$CoverageRule$Shared$timePeriod = function (_v0) {
	var record = _v0;
	var _v1 = record.aht;
	_v1$2:
	while (true) {
		if (!_v1.$) {
			switch (_v1.a) {
				case 'beginning_of_year':
					return $elm$core$Maybe$Just(0);
				case 'membership_renewal_date':
					return $elm$core$Maybe$Just(1);
				default:
					break _v1$2;
			}
		} else {
			break _v1$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Api$Provider$CoverageRule$One$timePeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$timePeriod(shared);
};
var $author$project$Components$CoverageRuleDescription$ruleTypeText = F2(
	function (coverageRule, shouldHighlightText) {
		var ruleType = function () {
			if (!coverageRule.$) {
				var shared = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$Shared$ruleType(shared);
			} else {
				var one = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$One$ruleType(one);
			}
		}();
		var amountInCents = $author$project$Utils$Currency$fromInt(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				function (coverageRule_) {
					if (!coverageRule_.$) {
						var shared = coverageRule_.a;
						return $author$project$Api$Provider$CoverageRule$Shared$amountInCents(shared);
					} else {
						var one = coverageRule_.a;
						return $author$project$Api$Provider$CoverageRule$One$amountInCents(one);
					}
				}(coverageRule)));
		switch (ruleType) {
			case 'pass_through':
				return _List_fromArray(
					[
						$elm$html$Html$text(' will be')
					]);
			case 'included':
				var includedOption = function () {
					if (!coverageRule.$) {
						var shared = coverageRule.a;
						return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
					} else {
						var one = coverageRule.a;
						return $author$project$Api$Provider$CoverageRule$One$includedOption(one);
					}
				}();
				var amountText = function () {
					if (!includedOption.$) {
						if (includedOption.a === 1) {
							var _v2 = includedOption.a;
							return ' if they cost less than ' + amountInCents;
						} else {
							var _v3 = includedOption.a;
							return '';
						}
					} else {
						return '';
					}
				}();
				return _List_fromArray(
					[
						$elm$html$Html$text(' are '),
						A2($author$project$Components$CoverageRuleDescription$highlightText, 'included', shouldHighlightText),
						$elm$html$Html$text(' in the membership at no additional charge'),
						A2($author$project$Components$CoverageRuleDescription$highlightText, amountText, shouldHighlightText)
					]);
			case 'flat_amount':
				return _List_fromArray(
					[
						$elm$html$Html$text(' will be '),
						A2($author$project$Components$CoverageRuleDescription$highlightText, amountInCents, shouldHighlightText)
					]);
			case 'discounted':
				var percentage = $author$project$Formatters$Float$toPercentage(
					A2(
						$elm$core$Maybe$withDefault,
						0.0,
						function (coverageRule_) {
							if (!coverageRule_.$) {
								var shared = coverageRule_.a;
								return $author$project$Api$Provider$CoverageRule$Shared$percentage(shared);
							} else {
								var one = coverageRule_.a;
								return $author$project$Api$Provider$CoverageRule$One$percentage(one);
							}
						}(coverageRule)));
				return _List_fromArray(
					[
						$elm$html$Html$text(' will receive a '),
						A2($author$project$Components$CoverageRuleDescription$highlightText, 'discount of ', shouldHighlightText),
						A2($author$project$Components$CoverageRuleDescription$highlightText, percentage, shouldHighlightText),
						$elm$html$Html$text(' with the amount due')
					]);
			case 'surcharge':
				return _List_fromArray(
					[
						$elm$html$Html$text(' will have a surcharge of '),
						A2($author$project$Components$CoverageRuleDescription$highlightText, amountInCents, shouldHighlightText),
						$elm$html$Html$text(' added to the charge, the amount due will be')
					]);
			case 'limited_quantity':
				var quantity = A2(
					$elm$core$Maybe$withDefault,
					0,
					function (coverageRule_) {
						if (!coverageRule_.$) {
							var shared = coverageRule_.a;
							return $author$project$Api$Provider$CoverageRule$Shared$quantity(shared);
						} else {
							var one = coverageRule_.a;
							return $author$project$Api$Provider$CoverageRule$One$quantity(one);
						}
					}(coverageRule));
				var _v6 = function () {
					var _v7 = function (coverageRule_) {
						if (!coverageRule_.$) {
							var shared = coverageRule_.a;
							return $author$project$Api$Provider$CoverageRule$Shared$timePeriod(shared);
						} else {
							var one = coverageRule_.a;
							return $author$project$Api$Provider$CoverageRule$One$timePeriod(one);
						}
					}(coverageRule);
					if (!_v7.$) {
						if (!_v7.a) {
							var _v9 = _v7.a;
							return _Utils_Tuple2('', 'Jan 1st');
						} else {
							var _v10 = _v7.a;
							return _Utils_Tuple2('patient\'s ', 'membership renewal date');
						}
					} else {
						return _Utils_Tuple2('', '');
					}
				}();
				var timePeriodSubject = _v6.a;
				var timePeriod = _v6.b;
				return _List_fromArray(
					[
						$elm$html$Html$text(' are limited to a quantity of '),
						A2(
						$author$project$Components$CoverageRuleDescription$highlightText,
						A2($author$project$Formatters$String$pluralize, 'unit', quantity),
						shouldHighlightText),
						$elm$html$Html$text(' per period resetting on '),
						$elm$html$Html$text(timePeriodSubject),
						A2($author$project$Components$CoverageRuleDescription$highlightText, timePeriod, shouldHighlightText),
						$elm$html$Html$text(', additional units will be')
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$Components$CoverageRuleDescription$view = F2(
	function (coverageRule, shouldHighlightText) {
		var item = function () {
			if (!coverageRule.$) {
				var shared = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$Shared$item(shared);
			} else {
				var one = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$One$item(one);
			}
		}();
		var itemName = function () {
			if (item.$ === 1) {
				var category = item.a;
				return 'All ' + $author$project$Formatters$String$pluralOf(
					$author$project$Api$Provider$Category$Shared$name(category));
			} else {
				var chargeItem = item.a;
				return $author$project$Formatters$String$pluralOf(
					$author$project$Api$Provider$ChargeItem$Shared$name(chargeItem));
			}
		}();
		var includedOption = function () {
			if (!coverageRule.$) {
				var shared = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
			} else {
				var one = coverageRule.a;
				return $author$project$Api$Provider$CoverageRule$One$includedOption(one);
			}
		}();
		var coveredByText = function () {
			if (!includedOption.$) {
				var includedOption_ = includedOption.a;
				if (includedOption_ === 1) {
					return _List_fromArray(
						[
							$elm$html$Html$text(', those above are paid for by the '),
							A3(
							$elm$core$Basics$apR,
							$author$project$Components$CoverageRuleDescription$coveredBy(coverageRule),
							$author$project$Components$CoverageRuleDescription$highlightText,
							shouldHighlightText)
						]);
				} else {
					return _List_Nil;
				}
			} else {
				return _List_fromArray(
					[
						$elm$html$Html$text(' paid for by the '),
						A3(
						$elm$core$Basics$apR,
						$author$project$Components$CoverageRuleDescription$coveredBy(coverageRule),
						$author$project$Components$CoverageRuleDescription$highlightText,
						shouldHighlightText)
					]);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2($author$project$Components$CoverageRuleDescription$highlightText, itemName, shouldHighlightText),
				_Utils_ap(
					A2($author$project$Components$CoverageRuleDescription$ruleTypeText, coverageRule, shouldHighlightText),
					coveredByText)));
	});
var $author$project$Components$Plan$Form$viewCoverageRule = function (coverageRule) {
	return A2(
		$author$project$Ui$Form$Static$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Components$CoverageRuleDescription$view,
				$author$project$Components$CoverageRuleDescription$One(coverageRule),
				true)
			]));
};
var $author$project$Components$Plan$Form$viewCoveragePlanFields = F2(
	function (plan, form) {
		var originalCoveragePlan = function () {
			var _v14 = $author$project$Api$Provider$Plan$One$coveragePlan(plan);
			if (!_v14.$) {
				var coveragePlan_ = _v14.a;
				return coveragePlan_;
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = $author$project$Utils$Form$fields(form);
		var coveragePlan = _v0.L5;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Coverage')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Select charge items that will be covered with this plan.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Manage Coverage Plans')
												])),
											((!_Utils_eq(coveragePlan, $elm$core$Maybe$Nothing)) || (!_Utils_eq(originalCoveragePlan, $elm$core$Maybe$Nothing))) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Change coverage plan'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$OpenCoveragePlanModal)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Change Coverage Plan')
												])) : A3(
											$author$project$Ui$Button$view,
											{abp: 'Add coverage plan'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$OpenCoveragePlanModal),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add Coverage Plan')
												]))
										]))
								]))
						])),
					((!_Utils_eq(coveragePlan, $elm$core$Maybe$Nothing)) || (!_Utils_eq(originalCoveragePlan, $elm$core$Maybe$Nothing))) ? A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(11),
									$author$project$Ui$FlexGrid$offset(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(3)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel]),
													_List_fromArray(
														[
															$elm$html$Html$text('Coverage Plan')
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel]),
													_List_fromArray(
														[
															$elm$html$Html$text('Included charges')
														]))
												]))
										])),
									A2(
									$author$project$Ui$ListGroup$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$ListGroup$item,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(3)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Form$Static$view,
																	_List_Nil,
																	_List_fromArray(
																		[
																			function () {
																			var _v1 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
																			if (!_v1.a.$) {
																				var coveragePlan_ = _v1.a.a;
																				return $elm$html$Html$text(
																					$author$project$Components$Plan$Form$coveragePlanName(coveragePlan_));
																			} else {
																				if (!_v1.b.$) {
																					var _v2 = _v1.a;
																					return $elm$html$Html$text('Removed');
																				} else {
																					var _v3 = _v1.a;
																					var _v4 = _v1.b;
																					return $author$project$Utils$Html$empty;
																				}
																			}
																		}()
																		]))
																])),
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(7)
																]),
															function () {
																var _v5 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
																if (!_v5.a.$) {
																	var coveragePlan_ = _v5.a.a;
																	return A2(
																		$elm$core$List$map,
																		$author$project$Components$Plan$Form$viewCoverageRule,
																		$author$project$Components$Plan$Form$coveragePlanCoverageRules(coveragePlan_));
																} else {
																	if (!_v5.b.$) {
																		var _v6 = _v5.a;
																		return _List_Nil;
																	} else {
																		var _v7 = _v5.a;
																		var _v8 = _v5.b;
																		return _List_Nil;
																	}
																}
															}()),
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(2)
																]),
															_List_fromArray(
																[
																	function () {
																	var _v9 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
																	if (!_v9.a.$) {
																		if (!_v9.b.$) {
																			var coveragePlan_ = _v9.a.a;
																			var originalCoveragePlan_ = _v9.b.a;
																			return (!_Utils_eq(
																				$author$project$Components$Plan$Form$coveragePlanId(coveragePlan_),
																				$author$project$Api$Provider$CoveragePlan$One$id(originalCoveragePlan_))) ? A2($author$project$Components$Plan$Form$viewCoveragePlanUndoButton, originalCoveragePlan_, 'Chgange') : $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton;
																		} else {
																			var _v11 = _v9.b;
																			return $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton;
																		}
																	} else {
																		if (!_v9.b.$) {
																			var _v10 = _v9.a;
																			var originalCoveragePlan_ = _v9.b.a;
																			return A2($author$project$Components$Plan$Form$viewCoveragePlanUndoButton, originalCoveragePlan_, 'Delete');
																		} else {
																			var _v12 = _v9.a;
																			var _v13 = _v9.b;
																			return $author$project$Utils$Html$empty;
																		}
																	}
																}()
																]))
														]))
												]))
										]))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$AdditionalAdultDiscountRule = 7;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$AdditionalChildDiscountRule = 4;
var $author$project$Ui$Padding$Bottom_1 = 8;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitRule = 8;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenOnlyDiscountRule = 5;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$CoupleDiscountRule = 1;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRule = 2;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncluded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedRule = 0;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedRule = 6;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$SingleParentDiscountRule = 3;
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCents = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsEdit = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsReset = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRulePeriod = F6(
	function (_v0, form, editingPlan, rule, isDiscount, period) {
		var defaultPeriod = _v0.Nf;
		var _v1 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
				case 'quarter':
					return _Utils_Tuple3(rule.Xw, rule.Xx, rule.gr);
				case 'semi_annual':
					return _Utils_Tuple3(rule.Zj, rule.Zk, rule.gG);
				case 'annual':
					return _Utils_Tuple3(rule.I5, rule.I6, rule.e_);
				default:
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
			}
		}();
		var periodAmountInCents = _v1.a;
		var editingPeriod = _v1.b;
		var periodEdited = _v1.c;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
								rule.U2(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.GF(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.GF(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					(!editingPlan) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated(
												rule.Yu(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated(
												rule.N8(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRule = F6(
	function (sharedFields, form, _v0, periods, rule, isDiscount) {
		var editingPlan = _v0.Ob;
		return A2(
			$elm$core$List$map,
			A5($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRulePeriod, sharedFields, form, editingPlan, rule, isDiscount),
			periods);
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule = F4(
	function (sharedFields, maybePlan, form, familyDiscountRule) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule_) {
					var periodCodes = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$meta, sharedFields.GH)));
					return A6(
						$author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRule,
						sharedFields,
						form,
						{
							Ob: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
						},
						periodCodes,
						{
							I5: familyDiscountRule_.I9,
							e_: familyDiscountRule_.Ja,
							I6: familyDiscountRule_.vp,
							N8: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsEdit(familyDiscountRule_.ahI),
							T8: familyDiscountRule_.Ub,
							f5: familyDiscountRule_.Uc,
							F7: familyDiscountRule_.zc,
							U2: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCents(familyDiscountRule_.ahI),
							GF: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(familyDiscountRule_.ahI),
							Xw: familyDiscountRule_.XA,
							gr: familyDiscountRule_.XB,
							Xx: familyDiscountRule_.Bh,
							Yu: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsReset(familyDiscountRule_.ahI),
							Zj: familyDiscountRule_.Zn,
							gG: familyDiscountRule_.Zo,
							Zk: familyDiscountRule_.B8
						},
						false);
				},
				familyDiscountRule));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyMembershipPricingFields = F3(
	function (sharedFields, maybePlan, _v0) {
		var form = _v0;
		var _v1 = $author$project$Utils$Form$fields(form);
		var rules = _v1.YY;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if (!maybePlan.$) {
						return A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$padding(8)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Switch to group discounts'},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated(
												$author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingType('group')))
										]),
									_List_fromArray(
										[
											A2($author$project$Ui$Icon$view, _List_Nil, 59),
											$elm$html$Html$text(' Switch to Group Discounts')
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Couple Rate'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('Up to 2 adults of any age, no children')),
							$author$project$Ui$Form$Group$required(rules.wQ.Ot)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(rules.wQ.Ot),
													$author$project$Ui$ToggleSwitch$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(1)))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									function () {
										if (rules.wQ.Ot) {
											var _v3 = $author$project$Utils$Form$fields(form);
											var coupleDiscountRule = _v3.wQ;
											return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, coupleDiscountRule);
										} else {
											return _List_Nil;
										}
									}())
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Family Rate'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('Up to 2 adults of any age, plus children')),
							$author$project$Ui$Form$Group$required(rules.xA.Ot)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(rules.xA.Ot),
													$author$project$Ui$ToggleSwitch$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(2)))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									function () {
										if (rules.xA.Ot) {
											var _v4 = $author$project$Utils$Form$fields(form);
											var familyDiscountRule = _v4.xA;
											return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, familyDiscountRule);
										} else {
											return _List_Nil;
										}
									}())
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Single Parent Rate'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('One adult of any age, plus children')),
							$author$project$Ui$Form$Group$required(rules.Cn.Ot)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$justifyLeft
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(rules.Cn.Ot),
													$author$project$Ui$ToggleSwitch$onChange(
													A2(
														$elm$core$Basics$composeL,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
														$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(3)))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8)
										]),
									function () {
										if (rules.Cn.Ot) {
											var _v5 = $author$project$Utils$Form$fields(form);
											var singleParentDiscountRule = _v5.Cn;
											return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, singleParentDiscountRule);
										} else {
											return _List_Nil;
										}
									}())
								]))
						])),
					function () {
					if (rules.xA.Ot || rules.Cn.Ot) {
						var _v6 = $author$project$Utils$Form$fields(form);
						var familyNumChildrenIncluded = _v6.xB;
						var childrenAgeLimit = _v6.v3;
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Limit Children in Family Plans'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off for no limit')),
											$author$project$Ui$Form$Group$required(rules.xB.Ot)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.xB.Ot),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(0)))
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(8)
														]),
													rules.xB.Ot ? _List_fromArray(
														[
															$author$project$Ui$Form$Input$group(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$addon(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Up to and including')
																		])),
																	$author$project$Ui$Form$Input$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Input$value(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2($elm$core$Maybe$map, $elm$core$String$fromInt, familyNumChildrenIncluded))),
																			$author$project$Ui$Form$Input$onInput(
																			A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncluded)),
																			$author$project$Ui$Form$Input$invalid(
																			A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, form))
																		]))
																])),
															$author$project$Utils$FormErrors$view(
															A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, form))
														]) : _List_Nil)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Additional Child Rate'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off to use the individual rate')),
											$author$project$Ui$Form$Group$required(rules.tK.Ot)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(4)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$small]),
															_List_fromArray(
																[$author$project$Utils$Html$noBreakSpace])),
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.tK.Ot),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(4)))
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(8)
														]),
													function () {
														if (rules.tK.Ot) {
															var _v7 = $author$project$Utils$Form$fields(form);
															var additionalChildDiscountRule = _v7.tK;
															return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, additionalChildDiscountRule);
														} else {
															return _List_fromArray(
																[$author$project$Utils$Html$empty]);
														}
													}())
												]))
										])),
									rules.xB.Ot ? A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Number of Additional Children Allowed'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off for no limit')),
											$author$project$Ui$Form$Group$required(rules.zC.Ot)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.zC.Ot),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(6)))
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(8)
														]),
													function () {
														if (rules.zC.Ot) {
															var _v8 = $author$project$Utils$Form$fields(form);
															var numberAdditionalChildrenAllowed = _v8.zC;
															return _List_fromArray(
																[
																	$author$project$Ui$Form$Input$group(
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Input$addon(
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Up to and including')
																				])),
																			$author$project$Ui$Form$Input$view(
																			_List_fromArray(
																				[
																					$author$project$Ui$Form$Input$value(
																					A2(
																						$elm$core$Maybe$withDefault,
																						'',
																						A2($elm$core$Maybe$map, $elm$core$String$fromInt, numberAdditionalChildrenAllowed))),
																					$author$project$Ui$Form$Input$onInput(
																					A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowed)),
																					$author$project$Ui$Form$Input$invalid(
																					A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, form))
																				]))
																		])),
																	$author$project$Utils$FormErrors$view(
																	A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, form))
																]);
														} else {
															return _List_Nil;
														}
													}())
												]))
										])) : $author$project$Utils$Html$empty,
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Additional Adult Rate'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off to use the individual rate')),
											$author$project$Ui$Form$Group$required(rules.tJ.Ot)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(4)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[$author$project$Ui$Typography$small]),
															_List_fromArray(
																[$author$project$Utils$Html$noBreakSpace])),
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.tJ.Ot),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(7)))
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(8)
														]),
													function () {
														if (rules.tJ.Ot) {
															var _v9 = $author$project$Utils$Form$fields(form);
															var additionalAdultDiscountRule = _v9.tJ;
															return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, additionalAdultDiscountRule);
														} else {
															return _List_Nil;
														}
													}())
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Maximum Age of Child'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Turn off for no limit')),
											$author$project$Ui$Form$Group$required(rules.v3.Ot)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.v3.Ot),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(8)))
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(8)
														]),
													rules.v3.Ot ? _List_fromArray(
														[
															$author$project$Ui$Form$Input$group(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$addon(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Up to and including')
																		])),
																	$author$project$Ui$Form$Input$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Input$value(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2($elm$core$Maybe$map, $elm$core$String$fromInt, childrenAgeLimit))),
																			$author$project$Ui$Form$Input$onInput(
																			A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimit)),
																			$author$project$Ui$Form$Input$invalid(
																			A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, form))
																		]))
																])),
															$author$project$Utils$FormErrors$view(
															A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, form))
														]) : _List_Nil)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Children Only Rate'),
											$author$project$Ui$Form$Group$labelClass(''),
											$author$project$Ui$Form$Group$labelHelp(
											$elm$html$Html$text('Children enrolling independently without an adult')),
											$author$project$Ui$Form$Group$required(rules.v4.Ot)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(4)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(rules.v4.Ot),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated,
																		$author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(5)))
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanSm(8)
														]),
													function () {
														if (rules.v4.Ot) {
															var _v10 = $author$project$Utils$Form$fields(form);
															var childrenOnlyDiscountRule = _v10.v4;
															return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, childrenOnlyDiscountRule);
														} else {
															return _List_fromArray(
																[$author$project$Utils$Html$empty]);
														}
													}())
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$view = F3(
	function (sharedFields, maybePlan, _v0) {
		var form = _v0;
		return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyMembershipPricingFields, sharedFields, maybePlan, form);
	});
var $author$project$Components$Plan$Form$DiscountsEnabled = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Form$Radio$Inline = {$: 2};
var $author$project$Ui$Form$Radio$inline = $author$project$Ui$Form$Radio$Inline;
var $author$project$Components$Plan$Form$viewFamilyDiscountsToggle = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var discountsEnabled = _v0.xg;
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Do you offer discounts to family members who enroll together?'),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(discountsEnabled),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Plan$Form$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Plan$Form$DiscountsEnabled(true))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Yes')
											]))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(!discountsEnabled),
										$author$project$Ui$Form$Radio$inline,
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Plan$Form$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Plan$Form$DiscountsEnabled(false))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('No')
											]))
									]))
							]))
					])),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Components$Plan$Form$viewFamilyMembershipPricing = F3(
	function (sharedFields, plan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var familyMembershipPricingForm = _v0.cU;
		var discountsEnabled = _v0.xg;
		return A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Plan$Form$viewFamilyDiscountsToggle(form),
					discountsEnabled ? A2(
					$elm$html$Html$map,
					$author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated,
					A3(
						$author$project$Components$Plan$Form$FamilyMembershipPricingFields$view,
						sharedFields,
						$elm$core$Maybe$Just(plan),
						familyMembershipPricingForm)) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Plan$Form$AppliesGroupDiscountInTiers = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$Plan$Form$GroupDiscountRuleAdd = {$: 31};
var $author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCents = F3(
	function (a, b, c) {
		return {$: 35, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsEdit = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsReset = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleFromSize = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRulePercentOff = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffEdit = F2(
	function (a, b) {
		return {$: 39, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffReset = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Components$Plan$Form$GroupDiscountRuleRemove = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Plan$Form$GroupDiscountRuleToSize = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Components$Plan$Form$groupDiscountRuleSizeOptions = function (start) {
	return A2(
		$elm$core$List$map,
		function (size) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(size)),
				A2($author$project$Formatters$String$pluralize, 'Member', size));
		},
		A2($elm$core$List$range, start, 9));
};
var $author$project$Components$Plan$Form$viewAmountInCentsPricingRulePeriod = F4(
	function (form, rule, isDiscount, period) {
		var _v0 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
				case 'quarter':
					return _Utils_Tuple3(rule.Xw, rule.Xx, rule.gr);
				case 'semi_annual':
					return _Utils_Tuple3(rule.Zj, rule.Zk, rule.gG);
				case 'annual':
					return _Utils_Tuple3(rule.I5, rule.I6, rule.e_);
				default:
					return _Utils_Tuple3(rule.T8, rule.F7, rule.f5);
			}
		}();
		var periodAmountInCents = _v0.a;
		var editingPeriod = _v0.b;
		var periodEdited = _v0.c;
		var _v2 = $author$project$Utils$Form$fields(form);
		var basicPlan = _v2.aA;
		var _v3 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		var defaultPeriod = _v3.Nf;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$FormUpdated,
								rule.U2(period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.GF(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.GF(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									periodEdited ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Reset period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated(
												rule.Yu(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Reset')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit period amount'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated(
												rule.N8(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$viewAmountInCentsPricingRule = F4(
	function (form, periods, rule, isDiscount) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Components$Plan$Form$viewAmountInCentsPricingRulePeriod, form, rule, isDiscount),
			periods);
	});
var $author$project$Percentage$format = function (percentage) {
	var _v0 = $author$project$Percentage$toFloat(percentage);
	if (!_v0.$) {
		var _float = _v0.a;
		return $elm$core$String$fromFloat(_float) + '%';
	} else {
		return 'N/A';
	}
};
var $author$project$Components$Plan$Form$viewPercentOffPricingRulePeriod = F4(
	function (form, rule, isDiscount, period) {
		var _v0 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(rule.Ug, rule.m6, rule.Uh);
				case 'quarter':
					return _Utils_Tuple3(rule.XE, rule.si, rule.XF);
				case 'semi_annual':
					return _Utils_Tuple3(rule.Zr, rule.sG, rule.Zs);
				case 'annual':
					return _Utils_Tuple3(rule.Jd, rule.pw, rule.Je);
				default:
					return _Utils_Tuple3(rule.Ug, rule.m6, rule.Uh);
			}
		}();
		var periodPercentOff = _v0.a;
		var editingPeriod = _v0.b;
		var periodEdited = _v0.c;
		var _v2 = $author$project$Utils$Form$fields(form);
		var basicPlan = _v2.aA;
		var _v3 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		var defaultPeriod = _v3.Nf;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
						])),
					$author$project$Ui$Form$PercentageInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$PercentageInput$value(periodPercentOff),
							$author$project$Ui$Form$PercentageInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Plan$Form$FormUpdated,
								rule.U3(period))),
							$author$project$Ui$Form$PercentageInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								rule.GG(period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Utils$Form$validationErrors,
						rule.GG(period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(12)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Percentage$format(
										A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, periodPercentOff))),
									isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit period percent off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated(
												rule.N9(period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									periodEdited ? A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$pull(1)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Reset period percent off'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Plan$Form$FormUpdated(
														rule.Yv(period)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset')
												])),
											$author$project$Utils$Html$noBreakSpace
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Form$viewPercentOffPricingRule = F4(
	function (form, periods, rule, isDiscount) {
		return A2(
			$elm$core$List$map,
			A3($author$project$Components$Plan$Form$viewPercentOffPricingRulePeriod, form, rule, isDiscount),
			periods);
	});
var $author$project$Components$Plan$Form$viewGroupDiscountRule = F4(
	function (plan, form, index, groupDiscountRule) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		var isFirst = !index;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					isFirst ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$elm$core$String$fromInt(groupDiscountRule.PJ))),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Plan$Form$FormUpdated,
										$author$project$Components$Plan$Form$GroupDiscountRuleFromSize(index)))
								]),
							$author$project$Components$Plan$Form$groupDiscountRuleSizeOptions(0))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(groupDiscountRule.PJ))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					(!_Utils_eq(groupDiscountRule.$K, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, groupDiscountRule.$K)),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Plan$Form$FormUpdated,
										$author$project$Components$Plan$Form$GroupDiscountRuleToSize(index)))
								]),
							$author$project$Components$Plan$Form$groupDiscountRuleSizeOptions(groupDiscountRule.PJ))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('All Members')
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							(!isFirst) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Remove group disount rule'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$Plan$Form$FormUpdated(
										$author$project$Components$Plan$Form$GroupDiscountRuleRemove(index))),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v0 = groupDiscountRule.Km;
						switch (_v0) {
							case 'amount_off_in_cents':
								return A4(
									$author$project$Components$Plan$Form$viewAmountInCentsPricingRule,
									form,
									$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta),
									{
										I5: groupDiscountRule.I7,
										e_: groupDiscountRule.I8,
										I6: groupDiscountRule.D3,
										N8: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsEdit(index),
										T8: groupDiscountRule.T9,
										f5: groupDiscountRule.Ua,
										F7: groupDiscountRule.F8,
										U2: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCents(index),
										GF: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation(index),
										Xw: groupDiscountRule.Xy,
										gr: groupDiscountRule.Xz,
										Xx: groupDiscountRule.GV,
										Yu: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsReset(index),
										Zj: groupDiscountRule.Zl,
										gG: groupDiscountRule.Zm,
										Zk: groupDiscountRule.G8
									},
									true);
							case 'percent_off':
								return A4(
									$author$project$Components$Plan$Form$viewPercentOffPricingRule,
									form,
									$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta),
									{
										Jd: groupDiscountRule.Jd,
										Je: groupDiscountRule.Je,
										pw: groupDiscountRule.pw,
										N9: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffEdit(index),
										Ug: groupDiscountRule.Ug,
										Uh: groupDiscountRule.Uh,
										m6: groupDiscountRule.m6,
										U3: $author$project$Components$Plan$Form$GroupDiscountRulePercentOff(index),
										GG: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation(index),
										XE: groupDiscountRule.XE,
										XF: groupDiscountRule.XF,
										si: groupDiscountRule.si,
										Yv: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffReset(index),
										Zr: groupDiscountRule.Zr,
										Zs: groupDiscountRule.Zs,
										sG: groupDiscountRule.sG
									},
									true);
							default:
								return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Plan$Form$viewGroupMembershipPricingFields = F2(
	function (plan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var appliesGroupDiscountInTiers = _v0.Jj;
		var groupDiscountRules = _v0.PW;
		var discountsEnabled = _v0.xg;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Plan$Form$viewFamilyDiscountsToggle(form),
					function () {
					if (discountsEnabled) {
						var groupDiscountRulesCalculatedBy = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Km;
							},
							$elm$core$List$head(groupDiscountRules));
						var allowNewGroupRule = A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								function (lastFromSize) {
									return _Utils_cmp(lastFromSize, $author$project$Components$Plan$Form$maxGroupFromSize) < 0;
								},
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.PJ;
									},
									$elm_community$list_extra$List$Extra$last(groupDiscountRules))));
						return A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(8)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Switch to family rates'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Plan$Form$FormUpdated(
														$author$project$Components$Plan$Form$GroupPricingType('family')))
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$Icon$view, _List_Nil, 59),
													$elm$html$Html$text(' Switch to Family Rates')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$offset(1)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Radio$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Radio$value(appliesGroupDiscountInTiers),
																	$author$project$Ui$Form$Radio$onCheck(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FormUpdated,
																		$elm$core$Basics$always(
																			$author$project$Components$Plan$Form$AppliesGroupDiscountInTiers(true))))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Apply Discounts in Tiers.'),
																	A2(
																	$author$project$Ui$Typography$div,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Per member discount will apply to members depending on which range they are in')
																		]))
																]))
														])),
													A2(
													$author$project$Ui$Typography$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Radio$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Radio$value(!appliesGroupDiscountInTiers),
																	$author$project$Ui$Form$Radio$onCheck(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$Plan$Form$FormUpdated,
																		$elm$core$Basics$always(
																			$author$project$Components$Plan$Form$AppliesGroupDiscountInTiers(false))))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Apply Same Discount to Entire Group'),
																	A2(
																	$author$project$Ui$Typography$div,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Per member discount from the last added member will apply to all members in group')
																		]))
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Default Discount Type'),
											$author$project$Ui$Form$Group$labelClass('')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Select percentage base discount calculation'},
													_List_fromArray(
														[
															$author$project$Ui$Button$active(
															_Utils_eq(
																groupDiscountRulesCalculatedBy,
																$elm$core$Maybe$Just('percent_off'))),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Plan$Form$FormUpdated(
																$author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy(true)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('%')
														])),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Select fixed discount rate'},
													_List_fromArray(
														[
															$author$project$Ui$Button$active(
															!_Utils_eq(
																groupDiscountRulesCalculatedBy,
																$elm$core$Maybe$Just('percent_off'))),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Plan$Form$FormUpdated(
																$author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy(false)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('$')
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(11),
													$author$project$Ui$FlexGrid$offsetSm(1)
												]),
											_List_fromArray(
												[
													A4(
													$author$project$Ui$Table$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(3)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('From')
																])),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(3)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('To')
																])),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(2)
																]),
															_List_Nil),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(4)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Discount per Member')
																]))
														]),
													A2(
														$elm$core$List$indexedMap,
														A2($author$project$Components$Plan$Form$viewGroupDiscountRule, plan, form),
														groupDiscountRules),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Table$row,
															_List_Nil,
															_List_fromArray(
																[
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2(
																	$author$project$Ui$Table$cell,
																	_List_Nil,
																	_List_fromArray(
																		[
																			allowNewGroupRule ? A3(
																			$author$project$Ui$Button$view,
																			{abp: 'Add group range discount rule'},
																			_List_fromArray(
																				[
																					$author$project$Ui$Button$onClick(
																					$author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$GroupDiscountRuleAdd)),
																					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Add Range')
																				])) : $author$project$Utils$Html$empty
																		]))
																]))
														]))
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Plan$Form$Iua = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Plan$Meta$iuaOptions = function (_v0) {
	var meta = _v0;
	return meta.Sp;
};
var $author$project$Components$Plan$Form$iuaOptions = function (meta) {
	return A2(
		$elm$core$List$map,
		function (iua) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(iua),
				$author$project$Formatters$String$titleize(iua));
		},
		$author$project$Api$Provider$Plan$Meta$iuaOptions(meta));
};
var $author$project$Components$Plan$Form$viewIuaOptionsFields = F2(
	function (plan, form) {
		var meta = $author$project$Api$Provider$Plan$One$meta(plan);
		var _v0 = $author$project$Utils$Form$fields(form);
		var iua = _v0.So;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Initial Unshareable Amount')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('IUA'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(iua),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$Iua))
								]),
							$author$project$Components$Plan$Form$iuaOptions(meta))
						]))
				]));
	});
var $author$project$Components$Plan$Form$PlanChangeAdd = {$: 24};
var $author$project$Components$Plan$Form$PlanChangeChangeAfterMonths = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeRemove = {$: 25};
var $author$project$Components$Plan$Form$PlanChangeType = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Plan$Form$PlanChangeUndoRemove = {$: 26};
var $author$project$Components$DateInput$Errors = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$DateInput$errors = $author$project$Components$DateInput$Errors;
var $author$project$Components$DateInput$Invalid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$DateInput$invalid = $author$project$Components$DateInput$Invalid;
var $author$project$Components$ResourceFilter$Plan$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Plan$Form$viewPlanChangeFields = F3(
	function (changeOnDateInput, toPlanResourceFilter, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var planChange = _v0.ju;
		var _v1 = planChange.Vx;
		var type_ = _v1.ahI;
		var changeAfterMonths = _v1.KN;
		var changeOnDate = _v1.KO;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Plan Change')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$offsetLabel,
							$author$project$Ui$Form$Group$labelSpanSm(5),
							$author$project$Ui$Form$Group$inputSpanSm(6),
							$author$project$Ui$Form$Group$label('Plan Change'),
							$author$project$Ui$Form$Group$labelClass(''),
							$author$project$Ui$Form$Group$labelHelp(
							$elm$html$Html$text('You may schedule this membership plan to change into another existing membership plan automatically'))
						]),
					_List_fromArray(
						[
							((!_Utils_eq(planChange.Vx.adR, $elm$core$Maybe$Nothing)) || planChange.bU) ? A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									((!_Utils_eq(planChange.Vx.adR, $elm$core$Maybe$Nothing)) && (!planChange.jL)) ? $elm$html$Html$text('Scheduled') : $author$project$Utils$Html$empty,
									(_Utils_eq(planChange.Vx.adR, $elm$core$Maybe$Nothing) && planChange.bU) ? $elm$html$Html$text('Active') : $author$project$Utils$Html$empty,
									planChange.jL ? $elm$html$Html$text('Removed') : $author$project$Utils$Html$empty,
									planChange.jL ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Undo plan removal'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeUndoRemove))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Undo')
										])) : A3(
									$author$project$Ui$Button$view,
									{abp: 'Remove plan change'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeRemove))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Remove')
										]))
								])) : $author$project$Utils$Html$empty,
							(_Utils_eq(planChange.Vx.adR, $elm$core$Maybe$Nothing) && (!planChange.bU)) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Add plan change'},
							_List_fromArray(
								[
									$author$project$Ui$Button$pull(1),
									$author$project$Ui$Button$onClick(
									$author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeAdd)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add plan change')
								])) : $author$project$Utils$Html$empty
						])),
					((!planChange.jL) && ((!_Utils_eq(planChange.Vx.adR, $elm$core$Maybe$Nothing)) || planChange.bU)) ? A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Effective date'),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									(type_ === 2) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(12)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													function () {
														var _v2 = planChange.Vx.LQ;
														if (!_v2.$) {
															var contractPeriodInMonths = _v2.a;
															return _List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths))
																]);
														} else {
															return _List_fromArray(
																[
																	$elm$html$Html$text('Contract period')
																]);
														}
													}())
												]))
										]) : ((!_Utils_eq(planChange.Vx.adR, $elm$core$Maybe$Nothing)) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(12)
												]),
											_List_fromArray(
												[
													function () {
													switch (type_) {
														case 1:
															return A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			A2(
																				$elm$core$Maybe$map,
																				$author$project$Formatters$String$pluralize('month'),
																				changeAfterMonths))),
																		$elm$html$Html$text(' since member starts')
																	]));
														case 0:
															return A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			A2(
																				$elm$core$Maybe$map,
																				$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																				changeOnDate)))
																	]));
														default:
															return $author$project$Utils$Html$empty;
													}
												}()
												]))
										]) : _List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(6)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$ButtonSelect$view(
													{
														ae4: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PlanChangeType),
														zY: _List_fromArray(
															[
																A2($author$project$Ui$Form$ButtonSelect$option, 1, 'Periods of months'),
																A2($author$project$Ui$Form$ButtonSelect$option, 0, 'Date')
															]),
														aaN: type_
													})
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(6)
												]),
											_List_fromArray(
												[
													function () {
													switch (type_) {
														case 1:
															return $author$project$Ui$Form$PeriodInMonthsInput$view(
																{
																	fE: A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, form),
																	q$: A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, form),
																	afc: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonths),
																	aaN: changeAfterMonths
																});
														case 0:
															return A2(
																$elm$html$Html$map,
																$author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg,
																A2(
																	$author$project$Components$DateInput$view,
																	_List_fromArray(
																		[
																			$author$project$Components$DateInput$value(changeOnDate),
																			$author$project$Components$DateInput$invalid(
																			A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, form)),
																			$author$project$Components$DateInput$errors(
																			A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, form))
																		]),
																	changeOnDateInput));
														default:
															return $author$project$Utils$Html$empty;
													}
												}()
												]))
										])))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('New plan'),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									function () {
									if (!_Utils_eq(planChange.Vx.adR, $elm$core$Maybe$Nothing)) {
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.zh;
															},
															planChange.Vx.$J)))
												]));
									} else {
										if (!toPlanResourceFilter.$) {
											var toPlanResourceFilter_ = toPlanResourceFilter.a;
											return A2(
												$elm$html$Html$map,
												$author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Plan$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeToPlanValidation, form)),
															$author$project$Components$ResourceFilter$errors(
															A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeToPlanValidation, form))
														]),
													toPlanResourceFilter_));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}
								}()
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Plan$Form$EditPricingVersion = {$: 24};
var $author$project$Components$Plan$Form$PricingEffectivenessTypeChanged = function (a) {
	return {$: 41, a: a};
};
var $author$project$Api$Feature$PricingVersions = 21;
var $author$project$Components$Plan$Form$ScheduleNewPriceChange = {$: 23};
var $author$project$Api$Provider$PricingVersion$Shared$effectiveDate = function (_v0) {
	var record = _v0;
	return record.Od;
};
var $author$project$Components$Plan$Form$viewPriceChangeSection = F3(
	function (practice, plan, formFields) {
		if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 21, practice)) {
			var _v0 = $author$project$Api$Provider$Plan$One$upcomingPricingVersion(plan);
			if (!_v0.$) {
				var pricingVersion = _v0.a;
				return A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Price Change')
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Price Change'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('You may schedule the pricing for this membership plan to change automatically.'))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Scheduled, Effective starting ' + A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$PricingVersion$Shared$effectiveDate(pricingVersion))),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Edit price change'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$pull(1),
													$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$EditPricingVersion)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												]))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('When should members see this new pricing?'),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$ButtonSelect$view(
									{
										ae4: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PricingEffectivenessTypeChanged),
										zY: _List_fromArray(
											[
												A2($author$project$Ui$Form$ButtonSelect$option, 0, 'On First Bill after Effective Date'),
												formFields.LP ? A2($author$project$Ui$Form$ButtonSelect$option, 1, 'On Contract Renewal') : A2($author$project$Ui$Form$ButtonSelect$option, 2, 'On Members\' Anniversary')
											]),
										aaN: formFields.W0
									})
								]))
						]));
			} else {
				return A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Price Change')
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$offsetLabel,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(6),
									$author$project$Ui$Form$Group$label('Price Change'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('You may schedule the pricing for this membership plan to change automatically.'))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Schedule price change'},
											_List_fromArray(
												[
													$author$project$Ui$Button$pull(1),
													$author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ScheduleNewPriceChange),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Schedule Price Change')
												]))
										]))
								]))
						]));
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Plan$Form$TobaccoSurchargeInCents = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Plan$Form$TobaccoSurchargePercentage = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Plan$Form$TobaccoSurchargeType = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Plan$Form$viewTobaccoSurchargeFields = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var tobaccoSurchargeType = _v0.$O;
	var percentageTobaccoSurchargeType = _Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing) || (_Utils_eq(
		tobaccoSurchargeType,
		$elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(
		tobaccoSurchargeType,
		$elm$core$Maybe$Just('percentage_per_membership')));
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Tobacco Surcharge')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$label('Tobacco surcharge'),
						$author$project$Ui$Form$Group$labelClass('')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$ButtonSelect$view(
						{
							ae4: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeType),
							zY: _List_fromArray(
								[
									A2($author$project$Ui$Form$ButtonSelect$option, $elm$core$Maybe$Nothing, 'Disabled'),
									A2(
									$author$project$Ui$Form$ButtonSelect$option,
									percentageTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_member') : $elm$core$Maybe$Just('fixed_per_member'),
									'Per member'),
									A2(
									$author$project$Ui$Form$ButtonSelect$option,
									percentageTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_membership') : $elm$core$Maybe$Just('fixed_per_membership'),
									'Per membership')
								]),
							aaN: tobaccoSurchargeType
						})
					])),
				function () {
				if (!_Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing)) {
					var perMemberTobaccoSurchargeType = _Utils_eq(
						tobaccoSurchargeType,
						$elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(
						tobaccoSurchargeType,
						$elm$core$Maybe$Just('fixed_per_member'));
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$offsetLabel,
								$author$project$Ui$Form$Group$labelSpanSm(5),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label('Surcharge type'),
								$author$project$Ui$Form$Group$labelClass('')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$ButtonSelect$view(
								{
									ae4: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeType),
									zY: _List_fromArray(
										[
											A2(
											$author$project$Ui$Form$ButtonSelect$option,
											perMemberTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_member') : $elm$core$Maybe$Just('percentage_per_membership'),
											'Percentage'),
											A2(
											$author$project$Ui$Form$ButtonSelect$option,
											perMemberTobaccoSurchargeType ? $elm$core$Maybe$Just('fixed_per_member') : $elm$core$Maybe$Just('fixed_per_membership'),
											'Fixed')
										]),
									aaN: tobaccoSurchargeType
								})
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				if (!_Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing)) {
					var label = percentageTobaccoSurchargeType ? 'Percentage' : 'Amount';
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$offsetLabel,
								$author$project$Ui$Form$Group$labelSpanSm(5),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label(label),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$required(true)
							]),
						function () {
							if (percentageTobaccoSurchargeType) {
								var _v1 = $author$project$Utils$Form$fields(form);
								var tobaccoSurchargePercentage = _v1.$N;
								return _List_fromArray(
									[
										$author$project$Ui$Form$PercentageInput$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$PercentageInput$value(tobaccoSurchargePercentage),
												$author$project$Ui$Form$PercentageInput$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargePercentage)),
												$author$project$Ui$Form$PercentageInput$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, form))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, form))
									]);
							} else {
								var _v2 = $author$project$Utils$Form$fields(form);
								var tobaccoSurchargeInCents = _v2.$M;
								return _List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$CurrencyInput$value(tobaccoSurchargeInCents),
												$author$project$Ui$Form$CurrencyInput$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeInCents)),
												$author$project$Ui$Form$CurrencyInput$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation, form))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation, form))
									]);
							}
						}());
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Plan$Form$viewForm = F3(
	function (model, plan, form) {
		var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
		var planType = $author$project$Api$Provider$Plan$One$planType(plan);
		var _v0 = $author$project$Utils$Form$fields(form);
		var basicPlan = _v0.aA;
		var membershipPricingForm = _v0.cX;
		var allBasicFields = A2(
			$elm$core$List$map,
			$elm$html$Html$map($author$project$Components$Plan$Form$BasicPlanFormUpdated),
			A2(
				$author$project$Components$Plan$BasicForm$view,
				basicPlan,
				$elm$core$Maybe$Just(plan)));
		return $elm$core$List$concat(
			_List_fromArray(
				[
					allBasicFields,
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								(sharedFields.P_ === 'fixed_pricing') ? A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										A2(
										$elm$html$Html$map,
										$author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated,
										A3(
											$author$project$Components$Plan$Form$GroupTierPricingFields$view,
											sharedFields,
											$elm$core$Maybe$Just(plan),
											$author$project$Utils$Form$fields(form).i))
									])) : A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										A2(
										$elm$html$Html$map,
										$author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated,
										A4(
											$author$project$Components$Plan$Form$IndividualMembershipPricingFields$view,
											sharedFields,
											model.WF,
											$elm$core$Maybe$Just(plan),
											membershipPricingForm))
									])),
								(sharedFields.P_ === 'family') ? A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										A3($author$project$Components$Plan$Form$viewFamilyMembershipPricing, sharedFields, plan, form)
									])) : $author$project$Utils$Html$empty,
								(sharedFields.P_ === 'group') ? A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										A2($author$project$Components$Plan$Form$viewGroupMembershipPricingFields, plan, form)
									])) : $author$project$Utils$Html$empty
							])),
						model.WI ? A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$padding(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Well$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$info]),
										_List_fromArray(
											[
												$elm$html$Html$text('If you\'re looking for additional options, or have more than one plan, you can access advanced settings after saving your plan.')
											]))
									]))
							])) : $author$project$Utils$Html$empty
					]),
					(planType === 1) ? _List_fromArray(
					[$author$project$Utils$Html$empty]) : ((!model.WI) ? _List_fromArray(
					[
						(!$author$project$Api$Provider$Plan$One$isMcePlan(plan)) ? A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2($author$project$Components$Plan$Form$viewCoveragePlanFields, plan, form)
							])) : $author$project$Utils$Html$empty,
						model.oK ? A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Components$Plan$Form$viewTobaccoSurchargeFields(form)
							])) : $author$project$Utils$Html$empty,
						$author$project$Api$Provider$Plan$One$isMcePlan(plan) ? A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2($author$project$Components$Plan$Form$viewIuaOptionsFields, plan, form)
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								(!$author$project$Api$Provider$Plan$One$isMcePlan(plan)) ? A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Components$Plan$Form$viewAgeRestrictionsFields(form)
									])) : $author$project$Utils$Html$empty,
								function () {
								if (A2(
									$author$project$Utils$FeatureGate$gateAvailable,
									7,
									$author$project$Api$Practice$Provider(model.WF))) {
									var forCompany = !$author$project$Api$Provider$Plan$One$planType(plan);
									return A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$HorizontalRule$view(_List_Nil),
												$author$project$Ui$Typography$heading(
												_List_fromArray(
													[
														$elm$html$Html$text('Advanced Pricing Rules')
													])),
												$author$project$Utils$Html$noBreakSpace,
												((!forCompany) && (!$author$project$Api$Provider$Plan$One$isMcePlan(plan))) ? A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												A2($author$project$Components$Plan$Form$viewContractPeriodFields, plan, form)) : $author$project$Utils$Html$empty,
												model.jv ? A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												_List_fromArray(
													[
														A3($author$project$Components$Plan$Form$viewPlanChangeFields, model.r5, model.gn, form)
													])) : $author$project$Utils$Html$empty,
												A3(
												$author$project$Components$Plan$Form$viewPriceChangeSection,
												model.WF,
												plan,
												$author$project$Utils$Form$fields(form)),
												function () {
												if (!$author$project$Api$Provider$Plan$One$isMcePlan(plan)) {
													var _v1 = $author$project$Utils$Form$fields(form);
													var specialRatesForm = _v1.de;
													return A2(
														$elm$html$Html$map,
														$author$project$Components$Plan$Form$SpecialRatesFieldsUpdated,
														A2($author$project$Components$Plan$Form$SpecialRatesFields$view, plan, specialRatesForm));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]) : _List_fromArray(
					[$author$project$Utils$Html$empty]))
				]));
	});
var $author$project$Components$Plan$Form$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			$author$project$Components$Plan$Form$modal(model),
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$horizontal,
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$onSubmit($author$project$Components$Plan$Form$Save)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					model.WI ? _List_fromArray(
						[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							function () {
								var _v1 = model.PB;
								if (!_v1.$) {
									var _v2 = _v1.a;
									var plan = _v2.a;
									var form = _v2.b;
									return A3($author$project$Components$Plan$Form$viewForm, model, plan, form);
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]))
										]);
								}
							}()),
							A2(
							$author$project$Ui$Panel$footer,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol]),
							function () {
								var _v3 = model.PB;
								if (!_v3.$) {
									var _v4 = _v3.a;
									var plan = _v4.a;
									var form = _v4.b;
									return _List_fromArray(
										[
											$author$project$Utils$Form$hasAnyValidationError(form) ? A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$offsetSm(3),
															$author$project$Ui$FlexGrid$spanSm(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Alert$danger,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Please review the errors above')
																]))
														]))
												])) : $author$project$Utils$Html$empty,
											$author$project$Api$Provider$Plan$One$isMcePlan(plan) ? A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$offsetSm(3),
															$author$project$Ui$FlexGrid$spanSm(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Alert$danger,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('This plan requires special pricing. '),
																	$elm$html$Html$text('If you have questions or need to make changes, please contact us at '),
																	A3(
																	$author$project$Ui$Link$mailto,
																	'support@hint.com',
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('support@hint.com')
																		]))
																]))
														]))
												])) : $author$project$Utils$Html$empty,
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
											_List_fromArray(
												[
													$author$project$Components$Plan$Form$viewBackButton(model.F_),
													$author$project$Api$Provider$Plan$One$isDestroyable(plan) ? A3(
													$author$project$Ui$Button$view,
													{abp: 'Delete plan'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$onClick(
															$author$project$Components$Plan$Form$DeletePlan(plan)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														])) : $author$project$Utils$Html$empty,
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Save plan'},
													_List_fromArray(
														[
															$author$project$Ui$Button$primary,
															$author$project$Ui$Button$submit,
															$author$project$Ui$Button$loading(
															_Utils_eq(model.jY, $author$project$Api$Data$Loading))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Save Plan')
														]))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											$author$project$Components$Plan$Form$viewBackButton(model.F_)
										]);
								}
							}())
						]))
				]))
		]);
};
var $author$project$Pages$Admin$CompanyPlans$Id_String$view = function (model) {
	return {
		e5: $author$project$Components$Plan$Form$view(model.ny),
		$G: 'Admin | Sponsor Plans'
	};
};
var $author$project$Pages$Admin$CompanyPlans$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CompanyPlans$Id_String$init, aer: $author$project$Pages$Admin$CompanyPlans$Id_String$load, agD: $author$project$Pages$Admin$CompanyPlans$Id_String$save, ahd: $author$project$Pages$Admin$CompanyPlans$Id_String$subscriptions, aaq: $author$project$Pages$Admin$CompanyPlans$Id_String$update, ahP: $author$project$Pages$Admin$CompanyPlans$Id_String$view});
var $author$project$Pages$Admin$CompanyPlans$New$NewMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$Plans$New$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Plans$New$formFieldsInit = function (type_) {
	return {LU: $elm$core$Maybe$Nothing, zh: '', ahI: type_};
};
var $author$project$Components$Admin$Plans$New$initPlanResourceFilter = F3(
	function (apiClient, session, planType) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						AS: _List_fromArray(
							[planType])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'None'});
			});
	});
var $author$project$Components$Admin$Plans$New$init = F5(
	function (apiClient, session, planType, listRoute, editRoute) {
		var _v0 = A3($author$project$Components$Admin$Plans$New$initPlanResourceFilter, apiClient, session, planType);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				E5: editRoute,
				PB: $author$project$Utils$Form$init(
					$author$project$Components$Admin$Plans$New$formFieldsInit(planType)),
				F_: listRoute,
				GH: $author$project$Api$Data$NotAsked,
				jw: planResourceFilter,
				Wp: planType,
				ZD: session
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterCmd));
	});
var $author$project$Pages$Admin$CompanyPlans$New$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var _v3 = A5($author$project$Components$Admin$Plans$New$init, apiClient, session, 0, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String);
		var form = _v3.a;
		var newCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd));
	});
var $author$project$Pages$Admin$CompanyPlans$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CompanyPlans$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CompanyPlans$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Plans$New$CopyFrom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Plans$New$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Plan$createBasic = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'plan',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'plan_type',
										$elm$json$Json$Encode$string(
											$author$project$Api$PlanType$toString(fields.Wp))),
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(fields.zh))
									])))
						]),
						function () {
						var _v0 = fields.LU;
						if (!_v0.$) {
							var id_ = _v0.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'copy_from',
									$author$project$Utils$Encode$association(id_))
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
	});
var $author$project$Components$Admin$Plans$New$createPlan = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Plan$createBasic,
			apiClient,
			{LU: fields.LU, zh: fields.zh, Wp: fields.ahI},
			$author$project$Components$Admin$Plans$New$Created);
	});
var $author$project$Components$Admin$Plans$New$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{LU: string});
			default:
				var type_ = field.a;
				return _Utils_update(
					fields,
					{ahI: type_});
		}
	});
var $author$project$Components$Admin$Plans$New$NameValidation = 0;
var $author$project$Components$Admin$Plans$New$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a plan name.'))
		]));
var $author$project$Components$ResourceFilter$Plan$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Admin$Plans$New$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Plans$New$formFieldsUpdate, field, model.PB);
				var _v2 = function () {
					if (field.$ === 2) {
						var planType = field.a;
						return A3($author$project$Components$Admin$Plans$New$initPlanResourceFilter, apiClient, model.ZD, planType);
					} else {
						return _Utils_Tuple2(model.jw, $elm$core$Platform$Cmd$none);
					}
				}();
				var planResourceFilter = _v2.a;
				var planResourceFilterCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm, jw: planResourceFilter}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterCmd),
					_List_Nil);
			case 1:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Plans$New$formFieldsValidator, model.PB);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm, GH: $author$project$Api$Data$Loading}),
						A2($author$project$Components$Admin$Plans$New$createPlan, apiClient, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var plan = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{GH: response}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							model.E5(
								{
									adR: $author$project$Api$Provider$Plan$One$id(plan)
								})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Plan successfully created.'),
								$author$project$OutMsg$RefreshPractice
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{GH: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var planResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jw);
				var modelAfterEvent = function () {
					var _v7 = planResourceFilterResult.ac5;
					if (!_v7.$) {
						if (!_v7.a.$) {
							return _Utils_update(
								model,
								{
									PB: A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$Plans$New$formFieldsUpdate,
										$author$project$Components$Admin$Plans$New$CopyFrom(
											$author$project$Components$ResourceFilter$Plan$value(planResourceFilterResult.y8)),
										model.PB)
								});
						} else {
							var _v8 = _v7.a;
							return model;
						}
					} else {
						return model;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						modelAfterEvent,
						{jw: planResourceFilterResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterResult.EC),
					planResourceFilterResult.as);
		}
	});
var $author$project$Pages$Admin$CompanyPlans$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$New$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var newCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd),
			outMsgs);
	});
var $author$project$Components$Admin$Plans$New$Create = {$: 1};
var $author$project$Components$Admin$Plans$New$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Plans$New$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Plans$New$Type = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Plans$New$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$Admin$Plans$New$Create),
				$author$project$Ui$Form$horizontal
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Create New Plan')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Name your plan'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$autofocus(true),
												$author$project$Ui$Form$Input$value(fields.zh),
												$author$project$Ui$Form$Input$placeholder('New Membership Type'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$Plans$New$FormUpdated, $author$project$Components$Admin$Plans$New$Name)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
												$author$project$Ui$Form$Input$errors(
												A2($author$project$Utils$Form$validationErrors, 0, model.PB))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Copy plan details from'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Admin$Plans$New$PlanResourceFilterMsg,
										A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.jw))
									])),
								(fields.ahI !== 2) ? A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Plan Type'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Button$group(
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Select per member type '},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(!fields.ahI),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Admin$Plans$New$FormUpdated(
															$author$project$Components$Admin$Plans$New$Type(0)))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Per member')
													])),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Select fixed fee type '},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(fields.ahI === 1),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Admin$Plans$New$FormUpdated(
															$author$project$Components$Admin$Plans$New$Type(1)))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Fixed fee')
													]))
											]))
									])) : $author$project$Utils$Html$empty
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								model.F_,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Create new plan'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$loading(
										_Utils_eq(model.GH, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Create New Plan')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$CompanyPlans$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$New$view(model.PB))
			]),
		$G: 'Admin | Sponsor Plans'
	};
};
var $author$project$Pages$Admin$CompanyPlans$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CompanyPlans$New$init, aer: $author$project$Pages$Admin$CompanyPlans$New$load, agD: $author$project$Pages$Admin$CompanyPlans$New$save, ahd: $author$project$Pages$Admin$CompanyPlans$New$subscriptions, aaq: $author$project$Pages$Admin$CompanyPlans$New$update, ahP: $author$project$Pages$Admin$CompanyPlans$New$view});
var $author$project$Pages$Admin$CompanyPlans$Top$ListMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$Plans$List$GotPlans = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Plan$Pricing = 0;
var $author$project$Components$Admin$Plans$List$fetchPlans = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Plan$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						Fc: _List_fromArray(
							[0]),
						afy: model.afy,
						AS: model.AS,
						af_: model.af_
					});
			},
			$author$project$Components$Admin$Plans$List$GotPlans);
	});
var $author$project$Components$Admin$Plans$List$init = function (apiClient) {
	return function (session) {
		return function (userIsAdmin) {
			return function (planTypes) {
				return function (listRoute) {
					return function (newRoute) {
						return function (editRoute) {
							return function (help) {
								return function (query) {
									return function (_v0) {
										return function (practice) {
											var isOnboarding = _v0.aJ;
											var q = A2($elm$core$Dict$get, 'q', query);
											var allowMultipleRetailMemberships = A2(
												$elm$core$Maybe$withDefault,
												false,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships, practice));
											var model = {
												IW: allowMultipleRetailMemberships,
												E5: editRoute,
												Qm: help,
												aJ: isOnboarding,
												F_: listRoute,
												Ge: newRoute,
												afy: $author$project$Api$Pagination$initFromQuery(query),
												AS: planTypes,
												Wq: $author$project$Api$Data$Loading,
												WF: practice,
												af_: q,
												sA: $author$project$Ui$SearchInput$init(q),
												ZD: session,
												DF: userIsAdmin
											};
											return _Utils_Tuple2(
												model,
												A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, model));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Admin$CompanyPlans$Top$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var query = _v1.Bi;
		var _v2 = $author$project$Components$Admin$Plans$List$init(apiClient)(session)(
			$author$project$Api$Platform$User$Shared$isAdmin(
				$author$project$Api$Platform$Session$One$user(session)))(
			_List_fromArray(
				[0, 1, 3]))($author$project$Spa$Generated$Route$Admin__CompanyPlans__Top)($author$project$Spa$Generated$Route$Admin__CompanyPlans__New)($author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String)(_List_Nil)(query)(
			{aJ: false})(
			$elm$core$Maybe$Just(practice));
		var list = _v2.a;
		var listCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, rh: list},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
	});
var $author$project$Pages$Admin$CompanyPlans$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CompanyPlans$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CompanyPlans$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$Plans$List$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Practice$One$practiceOnboarding = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.WJ;
	});
var $author$project$Api$Provider$PracticeOnboarding$AccountStep$toString = function (stepType) {
	switch (stepType) {
		case 0:
			return 'not_started';
		case 1:
			return 'contact_info';
		case 2:
			return 'membership_pricing';
		case 3:
			return 'patient_agreements';
		case 4:
			return 'users_setup';
		case 5:
			return 'communications_setup';
		case 6:
			return 'legal_setup';
		case 7:
			return 'setup_completed';
		default:
			return 'setup_completed';
	}
};
var $author$project$Components$Admin$Plans$List$PracticeOnboardingUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice_onboardings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath);
};
var $author$project$Api$Provider$PracticeOnboarding$updateAccountStep = F4(
	function (apiClient, accountStep, id, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_onboarding',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'account_step',
								$elm$json$Json$Encode$string(accountStep))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
	});
var $author$project$Components$Admin$Plans$List$updatePracticeOnboarding = F3(
	function (apiClient, onboardId, accountStep) {
		return A4($author$project$Api$Provider$PracticeOnboarding$updateAccountStep, apiClient, accountStep, onboardId, $author$project$Components$Admin$Plans$List$PracticeOnboardingUpdated);
	});
var $author$project$Components$Admin$Plans$List$completePlansStep = F2(
	function (apiClient, practice) {
		var _v0 = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$PracticeOnboarding$Shared$id,
			$author$project$Api$Provider$Practice$One$practiceOnboarding(practice));
		if (!_v0.$) {
			var onboardId = _v0.a;
			return A3(
				$author$project$Components$Admin$Plans$List$updatePracticeOnboarding,
				apiClient,
				onboardId,
				$author$project$Api$Provider$PracticeOnboarding$AccountStep$toString(2));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Provider$Practice$disableMultipleRetailMemberships = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['multiple_retail_memberships', 'disable']),
					$author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Api$Provider$Practice$enableMultipleRetailMemberships = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['multiple_retail_memberships', 'enable']),
					$author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Components$Admin$Plans$List$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(model.F_)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Admin$Plans$List$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								Wq: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Wq: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								afy: $author$project$Api$Pagination$reset(model.afy),
								Wq: $author$project$Api$Data$Loading,
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, qModel),
										$author$project$Components$Admin$Plans$List$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$List$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, Wq: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, newModel),
								$author$project$Components$Admin$Plans$List$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var _v5 = model.WF;
				if (!_v5.$) {
					var practice = _v5.a;
					return _Utils_Tuple3(
						model,
						A2($author$project$Components$Admin$Plans$List$completePlansStep, apiClient, practice),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents),
						_List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					model,
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans__New),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var enabled = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{IW: enabled}),
					enabled ? A2($author$project$Api$Provider$Practice$enableMultipleRetailMemberships, apiClient, $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated) : A2($author$project$Api$Provider$Practice$disableMultipleRetailMemberships, apiClient, $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[$author$project$OutMsg$RefreshPractice]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{IW: !model.IW}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$CompanyPlans$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.D5, subMsg, model.rh);
		var list = _v1.a;
		var listCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: list}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd),
			outMsgs);
	});
var $author$project$Components$Admin$Plans$List$AddAnother = {$: 4};
var $author$project$Components$Admin$Plans$List$NextStep = {$: 3};
var $author$project$Components$Admin$Plans$List$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Skeleton$card = $author$project$Ui$Skeleton$view('card');
var $author$project$Ui$FlexGrid$mt2 = $author$project$Ui$FlexGrid$RowElement($author$project$Ui$Element$mt2);
var $author$project$Api$FeatureGate$MultipleRetailMemberships = 13;
var $author$project$Components$Admin$Plans$List$ToggleAllowMultipleRetailMemberships = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$FlexGrid$mb4 = $author$project$Ui$FlexGrid$RowElement($author$project$Ui$Element$mb4);
var $author$project$Ui$FlexGrid$mt4 = $author$project$Ui$FlexGrid$RowElement($author$project$Ui$Element$mt4);
var $author$project$Components$Admin$Plans$List$viewAllowMultipleRetailMembershipsSetting = function (model) {
	var isGateAvailable = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Practice$Provider,
				$author$project$Utils$FeatureGate$gateAvailable(13)),
			model.WF));
	if (isGateAvailable) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(model.IW),
					$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$Plans$List$ToggleAllowMultipleRetailMemberships)
				]));
		var labelHelp = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Patients can join more than one active retail membership at the same time, each with its own billing rules and member settings.')
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text('Note: Multiple employer-sponsored memberships, networks, and affiliate practices are not yet supported.')
						]))
				]));
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mt4, $author$project$Ui$FlexGrid$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Allow patients to enroll in multiple retail memberships'),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(4),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Period$billName = function (_v0) {
	var period = _v0;
	return period.lc;
};
var $author$project$Api$Provider$Plan$Shared$default = function (_v0) {
	var record = _v0;
	return record.M5;
};
var $author$project$Api$Provider$Plan$All$default = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$default(shared);
};
var $elm_community$string_extra$String$Extra$ellipsisWith = F3(
	function (howLong, append, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			howLong) < 1) ? string : _Utils_ap(
			A2(
				$elm$core$String$left,
				howLong - $elm$core$String$length(append),
				string),
			append);
	});
var $elm_community$string_extra$String$Extra$ellipsis = F2(
	function (howLong, string) {
		return A3($elm_community$string_extra$String$Extra$ellipsisWith, howLong, '...', string);
	});
var $author$project$Formatters$String$ellipsis = $elm_community$string_extra$String$Extra$ellipsis;
var $author$project$Api$Provider$Plan$Shared$periods = function (_v0) {
	var record = _v0;
	return A2($elm$core$List$filterMap, $author$project$Api$Period$retrieve, record.D1);
};
var $author$project$Api$Provider$Plan$All$periods = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$periods(shared);
};
var $elm_community$string_extra$String$Extra$toSentenceBaseCase = function (list) {
	_v0$2:
	while (true) {
		if (list.b) {
			if (!list.b.b) {
				var x = list.a;
				return x;
			} else {
				if (!list.b.b.b) {
					var x = list.a;
					var _v1 = list.b;
					var y = _v1.a;
					return x + (' and ' + y);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return '';
};
var $elm_community$string_extra$String$Extra$toSentenceHelper = F3(
	function (lastPart, sentence, list) {
		toSentenceHelper:
		while (true) {
			if (!list.b) {
				return sentence;
			} else {
				if (!list.b.b) {
					var x = list.a;
					return _Utils_ap(
						sentence,
						_Utils_ap(lastPart, x));
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$lastPart = lastPart,
						$temp$sentence = sentence + (', ' + x),
						$temp$list = xs;
					lastPart = $temp$lastPart;
					sentence = $temp$sentence;
					list = $temp$list;
					continue toSentenceHelper;
				}
			}
		}
	});
var $elm_community$string_extra$String$Extra$toSentence = function (list) {
	if ((list.b && list.b.b) && list.b.b.b) {
		var x = list.a;
		var _v1 = list.b;
		var y = _v1.a;
		var _v2 = _v1.b;
		var z = _v2.a;
		var more = _v2.b;
		return A3(
			$elm_community$string_extra$String$Extra$toSentenceHelper,
			' and ',
			x + (', ' + y),
			A2($elm$core$List$cons, z, more));
	} else {
		return $elm_community$string_extra$String$Extra$toSentenceBaseCase(list);
	}
};
var $author$project$Formatters$String$toSentence = $elm_community$string_extra$String$Extra$toSentence;
var $author$project$Api$RateRule$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$RateRule$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Plan$Shared$ageRateRules = function (_v0) {
	var record = _v0;
	return record.IL;
};
var $author$project$Api$Employer$Plan$All$ageRateRules = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$ageRateRules(shared);
};
var $author$project$Api$Employer$Plan$One$ageRateRules = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$ageRateRules(shared);
};
var $author$project$Api$Provider$Plan$All$ageRateRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$ageRateRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
};
var $author$project$Api$Plan$ageRateRules = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$ageRateRules(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$ageRateRules(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$ageRateRules(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$ageRateRules(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$ageRateRules(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$ageRateRules(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$List$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$ageRateRules(plan_));
	}
};
var $author$project$Api$Employer$Company$One$billAffiliateRate = function (_v0) {
	var record = _v0.b;
	return record.JW;
};
var $author$project$Api$Provider$Company$Shared$billAffiliateRate = function (_v0) {
	var record = _v0;
	return record.JW;
};
var $author$project$Api$Provider$Company$One$billAffiliateRate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$billAffiliateRate(shared);
};
var $author$project$Api$Company$billAffiliateRate = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$billAffiliateRate(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$billAffiliateRate(company_);
	}
};
var $author$project$Api$Network$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Network$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Practice$One$network = function (_v0) {
	var record = _v0;
	return record.Uo;
};
var $author$project$Api$Provider$Practice$One$network = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Uo;
	});
var $author$project$Api$Practice$network = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Network$Shared$Provider,
			$author$project$Api$Provider$Practice$One$network(practice_));
	} else {
		var practice_ = practice.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Network$Shared$Employer,
			$author$project$Api$Employer$Practice$One$network(practice_));
	}
};
var $author$project$Api$Employer$Network$Shared$ratesFromAffiliate = function (_v0) {
	var record = _v0;
	return record.XN;
};
var $author$project$Api$Provider$Network$Shared$ratesFromAffiliate = function (_v0) {
	var record = _v0;
	return record.XN;
};
var $author$project$Api$Network$Shared$ratesFromAffiliate = function (network) {
	if (!network.$) {
		var network_ = network.a;
		return $author$project$Api$Provider$Network$Shared$ratesFromAffiliate(network_);
	} else {
		var network_ = network.a;
		return $author$project$Api$Employer$Network$Shared$ratesFromAffiliate(network_);
	}
};
var $author$project$Components$Plan$Summary$Pricing$billAffiliateRate = F2(
	function (practice, company) {
		var network = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2($elm$core$Maybe$map, $author$project$Api$Practice$network, practice));
		var ratesFromAffiliate = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$ratesFromAffiliate, network));
		var billAffiliateRateCompanySetting = function () {
			if (!company.$) {
				var company_ = company.a;
				return $author$project$Api$Company$billAffiliateRate(company_);
			} else {
				return false;
			}
		}();
		return ratesFromAffiliate && billAffiliateRateCompanySetting;
	});
var $author$project$Api$Employer$Plan$Shared$coupleRateRule = function (_v0) {
	var record = _v0;
	return record.L$;
};
var $author$project$Api$Employer$Plan$All$coupleRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$coupleRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$coupleRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$coupleRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
};
var $author$project$Api$Plan$coupleRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$coupleRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$coupleRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$coupleRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$coupleRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$coupleRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$coupleRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$coupleRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$familyRateRule = function (_v0) {
	var record = _v0;
	return record.O7;
};
var $author$project$Api$Employer$Plan$All$familyRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$familyRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$familyRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
};
var $author$project$Api$Plan$familyRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$familyRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$familyRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$familyRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$familyRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$familyRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$familyRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$familyRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record.O9;
};
var $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
};
var $author$project$Api$Plan$familyWithSingleChildRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$familyWithSingleChildRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$familyWithSingleChildRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$familyWithSingleChildRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record.Pa;
};
var $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Plan$familyWithSingleChildRateRuleEnabled = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRuleEnabled(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRuleEnabled(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRuleEnabled(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRuleEnabled(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$groupPricingType = function (_v0) {
	var record = _v0;
	return record.P_;
};
var $author$project$Api$Employer$Plan$All$groupPricingType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$groupPricingType(shared);
};
var $author$project$Api$Employer$Plan$One$groupPricingType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$groupPricingType(shared);
};
var $author$project$Api$Provider$Plan$All$groupPricingType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$groupPricingType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
};
var $author$project$Api$Plan$groupPricingType = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$groupPricingType(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$groupPricingType(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$groupPricingType(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$groupPricingType(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$groupPricingType(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$groupPricingType(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$groupPricingType(plan_);
	}
};
var $author$project$Api$Provider$Plan$Shared$discountRules = function (_v0) {
	var record = _v0;
	return record.NL;
};
var $author$project$Api$Provider$Plan$All$discountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
};
var $author$project$Api$Provider$Plan$One$discountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$discountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
};
var $author$project$Api$Plan$hasDiscountRules = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$Shared$discountRules(plan_));
		case 1:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$SharedWithContractInfo$discountRules(plan_));
		case 4:
			return false;
		case 2:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$All$discountRules(plan_));
		case 6:
			return false;
		case 3:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$One$discountRules(plan_));
		default:
			return false;
	}
};
var $author$project$Api$Provider$Plan$All$specialRates = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
};
var $author$project$Api$Plan$hasSpecialRates = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$Shared$specialRates(plan_));
		case 1:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(plan_));
		case 4:
			return false;
		case 2:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$All$specialRates(plan_));
		case 6:
			return false;
		case 3:
			var plan_ = plan.a;
			return !$elm$core$List$isEmpty(
				$author$project$Api$Provider$Plan$One$specialRates(plan_));
		default:
			return false;
	}
};
var $author$project$Api$Employer$Plan$Shared$individualRateRule = function (_v0) {
	var record = _v0;
	return record.QU;
};
var $author$project$Api$Employer$Plan$All$individualRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$individualRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$individualRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$individualRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
};
var $author$project$Api$Plan$individualRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$individualRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$individualRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$individualRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$individualRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$individualRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$individualRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$individualRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.QW;
};
var $author$project$Api$Employer$Plan$All$individualRegistrationFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(shared);
};
var $author$project$Api$Employer$Plan$One$individualRegistrationFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(shared);
};
var $author$project$Api$Provider$Plan$All$individualRegistrationFeeInCents = function (_v0) {
	var record = _v0.b;
	return record.QW;
};
var $author$project$Api$Plan$individualRegistrationFeeInCents = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$individualRegistrationFeeInCents(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$individualRegistrationFeeInCents(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$individualRegistrationFeeInCents(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.Tr;
};
var $author$project$Api$Employer$Plan$All$maxRegistrationFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(shared);
};
var $author$project$Api$Employer$Plan$One$maxRegistrationFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(shared);
};
var $author$project$Api$Provider$Plan$All$maxRegistrationFeeInCents = function (_v0) {
	var record = _v0.b;
	return record.Tr;
};
var $author$project$Api$Plan$maxRegistrationFeeInCents = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$maxRegistrationFeeInCents(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$maxRegistrationFeeInCents(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$maxRegistrationFeeInCents(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$periods = function (_v0) {
	var record = _v0;
	return A2($elm$core$List$filterMap, $author$project$Api$Period$retrieve, record.D1);
};
var $author$project$Api$Employer$Plan$All$periods = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$periods(shared);
};
var $author$project$Api$Employer$Plan$One$periods = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$periods(shared);
};
var $author$project$Api$Provider$Plan$One$periods = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$periods(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$periods = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$periods(shared);
};
var $author$project$Api$Plan$periods = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$periods(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$periods(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$periods(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$periods(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$periods(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$periods(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$periods(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$planType = function (_v0) {
	var record = _v0;
	return record.Wp;
};
var $author$project$Api$Employer$Plan$All$planType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$planType(shared);
};
var $author$project$Api$Employer$Plan$One$planType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$planType(shared);
};
var $author$project$Api$Provider$Plan$All$planType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$planType(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$planType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$planType(shared);
};
var $author$project$Api$Plan$planType = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$planType(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$planType(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$planType(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$planType(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$planType(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$planType(plan_);
	}
};
var $author$project$Api$Period$rateName = function (_v0) {
	var period = _v0;
	return period.nQ;
};
var $author$project$Api$Employer$Plan$Shared$singleParentRateRule = function (_v0) {
	var record = _v0;
	return record.Z8;
};
var $author$project$Api$Employer$Plan$All$singleParentRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$singleParentRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$singleParentRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
};
var $author$project$Api$Plan$singleParentRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$singleParentRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$singleParentRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$singleParentRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$singleParentRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$singleParentRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$singleParentRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule = function (_v0) {
	var record = _v0;
	return record._a;
};
var $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
};
var $author$project$Api$Plan$singleParentWithSingleChildRateRule = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRule(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRule(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRule(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Provider,
				$author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$RateRule$Shared$Employer,
				$author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRule(plan_));
	}
};
var $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var record = _v0;
	return record._b;
};
var $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRuleEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
};
var $author$project$Api$Plan$singleParentWithSingleChildRateRuleEnabled = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRuleEnabled(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan_);
	}
};
var $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents = function (_v0) {
	var record = _v0;
	return record.adr;
};
var $author$project$Api$PricingStructure$fixedAmountInCents = function (pricingStructure) {
	var pricingStructure_ = pricingStructure;
	return $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(pricingStructure_);
};
var $author$project$Api$Provider$PricingStructure$Shared$percentage = function (_v0) {
	var record = _v0;
	return record.afJ;
};
var $author$project$Api$PricingStructure$percentage = function (pricingStructure) {
	var pricingStructure_ = pricingStructure;
	return $author$project$Api$Provider$PricingStructure$Shared$percentage(pricingStructure_);
};
var $author$project$Api$PricingStructure$ProviderShared = $elm$core$Basics$identity;
var $author$project$Api$Provider$Plan$Shared$pricingFrom = function (_v0) {
	var record = _v0;
	return record.W1;
};
var $author$project$Api$Provider$Plan$All$pricingFrom = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
};
var $author$project$Api$Provider$Plan$One$pricingFrom = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$pricingFrom = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
};
var $author$project$Api$Plan$pricingFrom = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$author$project$Api$Provider$Plan$Shared$pricingFrom(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$pricingFrom(plan_));
		case 4:
			return $elm$core$Maybe$Nothing;
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$author$project$Api$Provider$Plan$All$pricingFrom(plan_));
		case 6:
			return $elm$core$Maybe$Nothing;
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$author$project$Api$Provider$Plan$One$pricingFrom(plan_));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Plan$Summary$Percentage$view = function (plan) {
	var pricingFrom = $author$project$Api$Plan$pricingFrom(plan);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, $author$project$Api$PricingStructure$percentage, $author$project$Formatters$Float$toPercentage),
							pricingFrom)))
				])),
			function () {
			var _v0 = A2($elm$core$Maybe$map, $author$project$Api$PricingStructure$fixedAmountInCents, pricingFrom);
			if (!_v0.$) {
				var fixedAmountInCents = _v0.a;
				return A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							(fixedAmountInCents >= 0) ? $elm$html$Html$text(' + ') : $elm$html$Html$text(' - '),
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$elm$core$Basics$abs(fixedAmountInCents)))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			_List_fromArray(
				[
					$elm$html$Html$text(' per member')
				]))
		]);
};
var $author$project$Api$Employer$SponsorFeeDeal$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$SponsorFeeDeal$Shared$amountInCents = function (sponsorFeeDeal) {
	if (!sponsorFeeDeal.$) {
		var sponsorFeeDeal_ = sponsorFeeDeal.a;
		return $author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents(sponsorFeeDeal_);
	} else {
		var sponsorFeeDeal_ = sponsorFeeDeal.a;
		return $author$project$Api$Employer$SponsorFeeDeal$Shared$amountInCents(sponsorFeeDeal_);
	}
};
var $author$project$Api$SponsorFeeDeal$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$SponsorFeeDeal$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal = function (_v0) {
	var record = _v0;
	return record._u;
};
var $author$project$Api$Employer$Plan$All$sponsorFeeDeal = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Api$Employer$Plan$One$sponsorFeeDeal = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Api$Provider$Plan$All$sponsorFeeDeal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$sponsorFeeDeal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
};
var $author$project$Api$Plan$sponsorFeeDeal = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Provider,
				$author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(plan_));
		case 1:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Provider,
				$author$project$Api$Provider$Plan$SharedWithContractInfo$sponsorFeeDeal(plan_));
		case 4:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Employer,
				$author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(plan_));
		case 2:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Provider,
				$author$project$Api$Provider$Plan$All$sponsorFeeDeal(plan_));
		case 6:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Employer,
				$author$project$Api$Employer$Plan$All$sponsorFeeDeal(plan_));
		case 3:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Provider,
				$author$project$Api$Provider$Plan$One$sponsorFeeDeal(plan_));
		default:
			var plan_ = plan.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$SponsorFeeDeal$Shared$Employer,
				$author$project$Api$Employer$Plan$One$sponsorFeeDeal(plan_));
	}
};
var $author$project$Components$Plan$Summary$SponsorFeeDeal$view = F2(
	function (companyPricing, plan) {
		var fixedFee = A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Fixed Fee')
						]))
				]));
		return _List_fromArray(
			[
				companyPricing ? A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(5)
							]),
						_List_fromArray(
							[fixedFee]))
					])) : fixedFee,
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Api$SponsorFeeDeal$Shared$amountInCents, $author$project$Utils$Currency$fromInt),
								$author$project$Api$Plan$sponsorFeeDeal(plan))))
					]))
			]);
	});
var $author$project$Formatters$Int$ageRangeMonths = F2(
	function (fromAge, toAge) {
		if (_Utils_eq(
			$elm$core$Maybe$Just(fromAge),
			toAge)) {
			return (!fromAge) ? 'First month' : ($elm$core$String$fromInt(fromAge) + ' months');
		} else {
			if ((!fromAge) && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) {
				return 'All ages';
			} else {
				var ageRange_ = (!fromAge) ? 'Birth' : (((fromAge === 1) && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) ? ($elm$core$String$fromInt(fromAge) + ' month') : ($elm$core$String$fromInt(fromAge) + ' months'));
				if (!toAge.$) {
					var toAge_ = toAge.a;
					return ageRange_ + (' to ' + ($elm$core$String$fromInt(toAge_) + ' months'));
				} else {
					return ageRange_ + ' and up';
				}
			}
		}
	});
var $author$project$Formatters$Int$ageRangeYears = F2(
	function (fromAge, toAge) {
		if (_Utils_eq(
			$elm$core$Maybe$Just(fromAge),
			toAge)) {
			return (!fromAge) ? 'First year' : ('Age ' + $elm$core$String$fromInt(fromAge));
		} else {
			if ((!fromAge) && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) {
				return 'All ages';
			} else {
				var ageRange_ = (!fromAge) ? 'Birth' : (((fromAge === 1) && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) ? ('Age ' + $elm$core$String$fromInt(fromAge)) : ('Ages ' + $elm$core$String$fromInt(fromAge)));
				if (!toAge.$) {
					var toAge_ = toAge.a;
					return ageRange_ + (' to ' + $elm$core$String$fromInt(toAge_));
				} else {
					return ageRange_ + ' and up';
				}
			}
		}
	});
var $author$project$Formatters$Int$ageRange = F3(
	function (fromAge, toAge, unit) {
		if (!unit) {
			return A2($author$project$Formatters$Int$ageRangeYears, fromAge, toAge);
		} else {
			return A2($author$project$Formatters$Int$ageRangeMonths, fromAge, toAge);
		}
	});
var $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes = function (_v0) {
	var record = _v0;
	return record.D1;
};
var $author$project$Api$Employer$Plan$All$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Employer$Plan$One$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes = function (_v0) {
	var record = _v0;
	return record.D1;
};
var $author$project$Api$Provider$Plan$All$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$allowedBillingPeriodCodes = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
};
var $author$project$Api$Plan$allowedBillingPeriodCodes = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$allowedBillingPeriodCodes(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$allowedBillingPeriodCodes(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$allowedBillingPeriodCodes(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$allowedBillingPeriodCodes(plan_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$annualAmountInCents = function (_v0) {
	var record = _v0;
	return record.I5;
};
var $author$project$Api$RateRule$Shared$annualAmountInCents = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$annualAmountInCents(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$annualAmountInCents(rateRule_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$monthAmountInCents = function (_v0) {
	var record = _v0;
	return record.T8;
};
var $author$project$Api$RateRule$Shared$monthAmountInCents = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$monthAmountInCents(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$monthAmountInCents(rateRule_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$quarterAmountInCents = function (_v0) {
	var record = _v0;
	return record.Xw;
};
var $author$project$Api$RateRule$Shared$quarterAmountInCents = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$quarterAmountInCents(rateRule_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$semiAnnualAmountInCents = function (_v0) {
	var record = _v0;
	return record.Zj;
};
var $author$project$Api$RateRule$Shared$semiAnnualAmountInCents = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$semiAnnualAmountInCents(rateRule_);
	}
};
var $author$project$Components$Plan$Summary$Pricing$amountForPeriodCode = F2(
	function (ageRateRule, code) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			function () {
				switch (code) {
					case 'month':
						return $author$project$Api$RateRule$Shared$monthAmountInCents(ageRateRule);
					case 'quarter':
						return $author$project$Api$RateRule$Shared$quarterAmountInCents(ageRateRule);
					case 'semi_annual':
						return $author$project$Api$RateRule$Shared$semiAnnualAmountInCents(ageRateRule);
					case 'annual':
						return $author$project$Api$RateRule$Shared$annualAmountInCents(ageRateRule);
					default:
						return $elm$core$Maybe$Nothing;
				}
			}());
	});
var $author$project$Api$Period$code = function (_v0) {
	var period = _v0;
	return period.K3;
};
var $author$project$Api$Employer$RateRule$Shared$fromAge = function (_v0) {
	var record = _v0;
	return record.PH;
};
var $author$project$Api$RateRule$Shared$fromAge = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$fromAge(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$fromAge(rateRule_);
	}
};
var $author$project$Api$Employer$Plan$Shared$period = function (_v0) {
	var record = _v0;
	return $author$project$Api$Period$retrieve(record.Nf);
};
var $author$project$Api$Employer$Plan$All$period = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$period(shared);
};
var $author$project$Api$Employer$Plan$One$period = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$period(shared);
};
var $author$project$Api$Provider$Plan$All$period = function (_v0) {
	var record = _v0.b;
	return $author$project$Api$Period$retrieve(record.Nf);
};
var $author$project$Api$Provider$Plan$One$period = function (_v0) {
	var record = _v0.b;
	return $author$project$Api$Period$retrieve(record.Nf);
};
var $author$project$Api$Plan$period = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$period(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$period(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$period(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$period(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$period(plan_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$toAge = function (_v0) {
	var record = _v0;
	return record.$I;
};
var $author$project$Api$RateRule$Shared$toAge = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$toAge(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$toAge(rateRule_);
	}
};
var $author$project$Api$Employer$RateRule$Shared$unit = function (_v0) {
	var record = _v0;
	return record.aai;
};
var $author$project$Api$RateRule$Shared$unit = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$unit(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$unit(rateRule_);
	}
};
var $author$project$Components$Plan$Summary$Pricing$viewAgeRateRule = F2(
	function (plan, ageRateRule) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(8)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A3(
								$author$project$Formatters$Int$ageRange,
								$author$project$Api$RateRule$Shared$fromAge(ageRateRule),
								$author$project$Api$RateRule$Shared$toAge(ageRateRule),
								$author$project$Api$RateRule$Shared$unit(ageRateRule)))
						])),
					function () {
					var _v0 = _Utils_Tuple2(
						$author$project$Api$Plan$period(plan),
						$elm$core$List$head(
							$author$project$Api$Plan$allowedBillingPeriodCodes(plan)));
					if (!_v0.a.$) {
						var period = _v0.a.a;
						var amountInCents = A2(
							$author$project$Components$Plan$Summary$Pricing$amountForPeriodCode,
							ageRateRule,
							$author$project$Api$Period$code(period));
						return A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('numeric')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(amountInCents))
										]))
								]));
					} else {
						if (!_v0.b.$) {
							var _v1 = _v0.a;
							var allowedBillingPeriodCode = _v0.b.a;
							var amountInCents = A2($author$project$Components$Plan$Summary$Pricing$amountForPeriodCode, ageRateRule, allowedBillingPeriodCode);
							return A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(4)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('numeric')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(amountInCents))
											]))
									]));
						} else {
							var _v2 = _v0.a;
							var _v3 = _v0.b;
							return $author$project$Ui$FlexGrid$none;
						}
					}
				}()
				]));
	});
var $author$project$Api$Employer$RateRule$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$RateRule$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$RateRule$Shared$type_ = function (rateRule) {
	if (!rateRule.$) {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Provider$RateRule$Shared$type_(rateRule_);
	} else {
		var rateRule_ = rateRule.a;
		return $author$project$Api$Employer$RateRule$Shared$type_(rateRule_);
	}
};
var $author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule = F2(
	function (retailPlan, rateRule) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(8)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Utils$RateRule$groupTierName,
									A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$type_, rateRule)))),
							$author$project$Utils$Html$noBreakSpace,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-label-md text-muted')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Utils$RateRule$groupTierCode(retailPlan),
											A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$type_, rateRule))))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(4)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('numeric')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										A2(
											$elm$core$Maybe$withDefault,
											0,
											A2($elm$core$Maybe$andThen, $author$project$Api$RateRule$Shared$monthAmountInCents, rateRule))))
								]))
						]))
				]));
	});
var $author$project$Components$Plan$Summary$Pricing$viewRegistrationFee = F2(
	function (individualRegistrationFeeInCents, maxRegistrationFeeInCents) {
		var hasMaxRegistrationFeeInCents = $author$project$Utils$Maybe$toBool(maxRegistrationFeeInCents);
		var hasIndividualRegistrationFeeInCents = $author$project$Utils$Maybe$toBool(individualRegistrationFeeInCents);
		return (hasIndividualRegistrationFeeInCents || hasMaxRegistrationFeeInCents) ? A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Registration Fees: '),
					function () {
					if (!individualRegistrationFeeInCents.$) {
						var individualRegistrationFeeInCents_ = individualRegistrationFeeInCents.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(individualRegistrationFeeInCents_)),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(' per individual')
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					(hasIndividualRegistrationFeeInCents && hasMaxRegistrationFeeInCents) ? $elm$html$Html$text(' or ') : $author$project$Utils$Html$empty,
					function () {
					if (!maxRegistrationFeeInCents.$) {
						var maxRegistrationFeeInCents_ = maxRegistrationFeeInCents.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(maxRegistrationFeeInCents_)),
									$elm$html$Html$text(' Max')
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Plan$Summary$Pricing$view = F3(
	function (plan, practice, company) {
		var _v0 = $author$project$Api$Plan$planType(plan);
		switch (_v0) {
			case 4:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Percentage Retainer Pricing')
												]))
										]))
								]),
								$author$project$Components$Plan$Summary$Percentage$view(plan)
							])));
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					A2($author$project$Components$Plan$Summary$SponsorFeeDeal$view, false, plan));
			default:
				var showbillAffiliateRateText = A2($author$project$Components$Plan$Summary$Pricing$billAffiliateRate, practice, company);
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if ($author$project$Api$Plan$groupPricingType(plan) !== 'fixed_pricing') {
								var ageRateRules = $author$project$Api$Plan$ageRateRules(plan);
								return A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									$elm$core$List$concat(
										_List_fromArray(
											[
												_List_fromArray(
												[
													($elm$core$List$length(ageRateRules) > 1) ? A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			A2(
																				$elm$core$Maybe$withDefault,
																				'',
																				A2(
																					$elm$core$Maybe$map,
																					A2($elm$core$Basics$composeR, $author$project$Api$Period$rateName, $author$project$Formatters$String$titleize),
																					$elm$core$List$head(
																						$author$project$Api$Plan$periods(plan))))),
																			$elm$html$Html$text(' Age Based Pricing')
																		]))
																])),
															showbillAffiliateRateText ? A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(4)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('numeric')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Will be billed the affiliate rate')
																		]))
																])) : A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(4)
																]),
															_List_Nil)
														])) : (($elm$core$List$length(ageRateRules) === 1) ? A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(8)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$strong,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Individual Pricing')
																		]))
																])),
															showbillAffiliateRateText ? A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(4)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('numeric')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Will be billed the affiliate rate')
																		]))
																])) : A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(4)
																]),
															_List_Nil)
														])) : $author$project$Utils$Html$empty)
												]),
												(!showbillAffiliateRateText) ? A2(
												$elm$core$List$map,
												$author$project$Components$Plan$Summary$Pricing$viewAgeRateRule(plan),
												ageRateRules) : _List_Nil
											])));
							} else {
								return A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(8)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Group Tier Pricing')
																]))
														])),
													showbillAffiliateRateText ? A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(4)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('numeric')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Will be billed the affiliate rate')
																]))
														])) : A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(4)
														]),
													_List_Nil)
												])),
											function () {
											if (showbillAffiliateRateText) {
												return $author$project$Utils$Html$empty;
											} else {
												var retailPlan = $author$project$Api$Plan$planType(plan) === 2;
												return A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$individualRateRule(plan)),
															A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$coupleRateRule(plan)),
															$author$project$Api$Plan$singleParentWithSingleChildRateRuleEnabled(plan) ? A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$singleParentWithSingleChildRateRule(plan)) : $author$project$Utils$Html$empty,
															A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$singleParentRateRule(plan)),
															$author$project$Api$Plan$familyWithSingleChildRateRuleEnabled(plan) ? A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$familyWithSingleChildRateRule(plan)) : $author$project$Utils$Html$empty,
															A2(
															$author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule,
															retailPlan,
															$author$project$Api$Plan$familyRateRule(plan))
														]));
											}
										}()
										]));
							}
						}(),
							($author$project$Api$Plan$hasDiscountRules(plan) && ($author$project$Api$Plan$groupPricingType(plan) === 'family')) ? A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Family Discounts Available')
								])) : $author$project$Utils$Html$empty,
							($author$project$Api$Plan$hasDiscountRules(plan) && ($author$project$Api$Plan$groupPricingType(plan) === 'group')) ? A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Group Discounts Available')
								])) : $author$project$Utils$Html$empty,
							$author$project$Api$Plan$hasSpecialRates(plan) ? A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Special Rates Available')
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Components$Plan$Summary$Pricing$viewRegistrationFee,
							$author$project$Api$Plan$individualRegistrationFeeInCents(plan),
							$author$project$Api$Plan$maxRegistrationFeeInCents(plan))
						]));
		}
	});
var $author$project$Api$Provider$Plan$All$activeCompaniesCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$activeCompaniesCount(shared);
};
var $author$project$Api$Provider$Plan$All$activeMembershipPatientsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount(shared);
};
var $author$project$Ui$Typography$Badge = {$: 11};
var $author$project$Ui$Typography$badge = $author$project$Ui$Typography$Badge;
var $author$project$Components$Admin$Plans$List$viewBadge = function (plan) {
	var _v0 = function () {
		var _v1 = $author$project$Api$Provider$Plan$All$planType(plan);
		switch (_v1) {
			case 2:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Plan$All$activeMembershipPatientsCount(plan)),
					'Active patients on this plan');
			case 0:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Plan$All$activeCompaniesCount(plan)),
					'Active companies on this plan');
			default:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, '');
		}
	}();
	var count = _v0.a;
	var tooltip = _v0.b;
	if (!count.$) {
		var count_ = count.a;
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			tooltip,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$badge]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(count_))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Link$Disabled = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Link$disabled = $author$project$Ui$Link$Disabled;
var $author$project$Api$Provider$Plan$Shared$isAffiliate = function (_v0) {
	return false;
};
var $author$project$Api$Provider$Plan$All$isAffiliate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$isAffiliate(shared);
};
var $author$project$Components$Admin$Plans$List$viewEditLink = F2(
	function (model, plan) {
		var disableEdit = $author$project$Api$Provider$Plan$All$isAffiliate(plan) && (!model.DF);
		var editLink = A3(
			$author$project$Ui$Link$route,
			model.E5(
				{
					adR: $author$project$Api$Provider$Plan$All$id(plan)
				}),
			_List_fromArray(
				[
					$author$project$Ui$Link$buttonDefault,
					$author$project$Ui$Link$disabled(disableEdit)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('View / Edit')
				]));
		return disableEdit ? A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Contact us to change this plan',
			_List_fromArray(
				[editLink])) : editLink;
	});
var $author$project$Components$Admin$Plans$List$viewPlanSummary = F2(
	function (model, plan) {
		var name_ = $author$project$Api$Provider$Plan$All$name(plan);
		var maxLength = $author$project$Api$Provider$Plan$All$default(plan) ? 32 : 40;
		var name = (_Utils_cmp(
			$elm$core$String$length(name_),
			maxLength) > 0) ? A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			name_,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Formatters$String$ellipsis, maxLength, name_))
				])) : $elm$html$Html$text(name_);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[name])),
									$author$project$Components$Admin$Plans$List$viewBadge(plan)
								])),
							$author$project$Api$Provider$Plan$All$default(plan) ? A2(
							$author$project$Ui$Badge$view,
							_List_fromArray(
								[$author$project$Ui$Badge$primary]),
							_List_fromArray(
								[
									$elm$html$Html$text('Default')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Can bill '),
											$elm$html$Html$text(
											$author$project$Formatters$String$toSentence(
												A2(
													$elm$core$List$map,
													$author$project$Api$Period$billName,
													$author$project$Api$Provider$Plan$All$periods(plan))))
										])),
									A3(
									$author$project$Components$Plan$Summary$Pricing$view,
									$author$project$Api$Plan$ProviderAll(plan),
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing),
									model.aJ ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$pull(1)
										]),
									_List_fromArray(
										[
											A2($author$project$Components$Admin$Plans$List$viewEditLink, model, plan)
										])),
									$author$project$Ui$Clearfix$view,
									$author$project$Api$Provider$Plan$All$default(plan) ? A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											$elm$html$Html$text('This is your default for new memberships and online signup')
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Plans$List$viewPlan = F2(
	function (model, plan) {
		return A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(6)
				]),
			_List_fromArray(
				[
					A2($author$project$Components$Admin$Plans$List$viewPlanSummary, model, plan)
				]));
	});
var $author$project$Components$Admin$Plans$List$view = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		model.aJ ? _List_fromArray(
			[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Membership pricing plans')
									])),
								model.aJ ? $author$project$Utils$Html$empty : A3(
								$author$project$Ui$Link$route,
								model.Ge,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$pull(1),
										$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Plan')
									]))
							])),
						$elm$core$List$isEmpty(model.Qm) ? $author$project$Utils$Html$empty : A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							model.Qm)),
						model.aJ ? $author$project$Utils$Html$empty : $author$project$Components$Admin$Plans$List$viewAllowMultipleRetailMembershipsSetting(model),
						model.aJ ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$FlexGrid$row,
						_List_fromArray(
							[$author$project$Ui$FlexGrid$mt2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(12)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$Plans$List$SearchInputMsg,
												A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						function () {
							var _v0 = model.Wq;
							if (_v0.$ === 3) {
								var plans = _v0.a;
								return A2(
									$elm$core$List$map,
									$author$project$Components$Admin$Plans$List$viewPlan(model),
									plans);
							} else {
								return A2(
									$elm$core$List$repeat,
									10,
									A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(6)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$span(4)
															])),
														$author$project$Ui$Skeleton$card(_List_Nil)
													]))
											])));
							}
						}())
					])),
				model.aJ ? A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Add another plan'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Plans$List$AddAnother)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add Another')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Go to next step'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Plans$List$NextStep)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next')
							]))
					])) : A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Admin$Plans$List$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Api$Data$isSuccess(model.Wq))
								]),
							model.afy))
					]))
			]));
};
var $author$project$Pages$Admin$CompanyPlans$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$List$view(model.rh))
			]),
		$G: 'Admin | Sponsor Plans'
	};
};
var $author$project$Pages$Admin$CompanyPlans$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CompanyPlans$Top$init, aer: $author$project$Pages$Admin$CompanyPlans$Top$load, agD: $author$project$Pages$Admin$CompanyPlans$Top$save, ahd: $author$project$Pages$Admin$CompanyPlans$Top$subscriptions, aaq: $author$project$Pages$Admin$CompanyPlans$Top$update, ahP: $author$project$Pages$Admin$CompanyPlans$Top$view});
var $author$project$Pages$Admin$Coupons$ArchivedDropdownMsg = function (a) {
	return {$: 15, a: a};
};
var $elm_community$string_extra$String$Extra$replaceSlice = F4(
	function (substitution, start, end, string) {
		return _Utils_ap(
			A3($elm$core$String$slice, 0, start, string),
			_Utils_ap(
				substitution,
				A3(
					$elm$core$String$slice,
					end,
					$elm$core$String$length(string),
					string)));
	});
var $author$project$Utils$Url$addParams = F2(
	function (url, qparams) {
		var urlDoesNotHaveQueryParams = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$isEmpty,
				A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.Bi;
					},
					$elm$url$Url$fromString(url))));
		var querySeparator = urlDoesNotHaveQueryParams ? '?' : '&';
		var queryString = A4(
			$elm_community$string_extra$String$Extra$replaceSlice,
			querySeparator,
			0,
			1,
			$elm$url$Url$Builder$toQuery(qparams));
		return _Utils_ap(url, queryString);
	});
var $author$project$Pages$Admin$Coupons$buildCouponUrl = F2(
	function (memberPortalSignupUrl, code) {
		return A2(
			$author$project$Utils$Url$addParams,
			memberPortalSignupUrl,
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'coupon', code)
				]));
	});
var $author$project$Pages$Admin$Coupons$GotCoupons = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Coupon$couponsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['coupons']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Coupon$All$Coupon = $elm$core$Basics$identity;
var $author$project$Api$Common$Coupon$Shared$Coupon = $elm$core$Basics$identity;
var $author$project$Api$Common$Coupon$Shared$Record = function (id) {
	return function (code) {
		return function (description) {
			return function (percentOff) {
				return function (amountOffInCents) {
					return function (applyToEachPatient) {
						return function (createdAt) {
							return function (isRedeemable) {
								return function (redeemableFrom) {
									return function (redeemableUntil) {
										return function (durationInMonths) {
											return function (isArchived) {
												return {I3: amountOffInCents, Jl: applyToEachPatient, K3: code, Mf: createdAt, Nx: description, N4: durationInMonths, adR: id, Rx: isArchived, R2: isRedeemable, Wb: percentOff, X_: redeemableFrom, X$: redeemableUntil};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Coupon$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_archived',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'duration_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'redeemable_until',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'redeemable_from',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_redeemable',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_at',
						$elm_community$json_extra$Json$Decode$Extra$datetime,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'apply_to_each_patient',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'amount_off_in_cents',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'percent_off',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'description',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'code',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Common$Coupon$Shared$Record)))))))))))));
var $author$project$Api$Common$Coupon$Shared$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Coupon$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Coupon$All$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Coupon$Shared$decode,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Coupon$listDefaults = {
	Jn: $elm$core$Maybe$Nothing,
	Fi: $elm$core$Maybe$Nothing,
	adR: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	GY: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'code', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$Coupon$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Coupon$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Jn;
				if (!_v0.$) {
					var bool = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'archived', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.GY;
				if (!_v1.$) {
					var bool = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'redeemable', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.af_;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Coupon$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Coupon$All$decode),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Coupon$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponsPath)));
	});
var $author$project$Pages$Admin$Coupons$fetchCoupons = function (model) {
	return A3(
		$author$project$Api$Provider$Coupon$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					Jn: $elm$core$Maybe$Just(model.Jn)
				});
		},
		$author$project$Pages$Admin$Coupons$GotCoupons);
};
var $author$project$Utils$Bool$fromString = function (string) {
	switch (string) {
		case 'true':
			return $elm$core$Maybe$Just(true);
		case 'false':
			return $elm$core$Maybe$Just(false);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Practice$One$memberPortalSignupUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.TA;
	});
var $author$project$Pages$Admin$Coupons$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.Bi;
		var archived = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Utils$Bool$fromString,
				A2($elm$core$Dict$get, 'archived', query)));
		var model = {
			D5: shared.D5,
			Jn: archived,
			k$: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'archived-dropdown-filter', ahx: $author$project$Pages$Admin$Coupons$ArchivedDropdownMsg})),
			hw: $elm$core$Maybe$Nothing,
			aV: $elm$core$Set$empty,
			L1: $elm$core$Maybe$Nothing,
			EJ: $author$project$Pages$Admin$Coupons$buildCouponUrl(
				$author$project$Api$Provider$Practice$One$memberPortalSignupUrl(practice)),
			wR: $author$project$Api$Data$Loading,
			cO: shared.cO
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$Coupons$fetchCoupons(model));
	});
var $author$project$Pages$Admin$Coupons$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Coupons$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Coupons$CancelEdit = {$: 3};
var $author$project$Pages$Admin$Coupons$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$subscriptions = function (_v0) {
	var coupon = _v0.L1;
	var archivingCoupon = _v0.hw;
	var archivedDropdown = _v0.k$;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Coupons$CancelEdit)),
					coupon)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Coupons$HiConfirmClosed),
					archivingCoupon)),
				$author$project$Ui$NewDropdown$subscriptions(archivedDropdown)
			]));
};
var $author$project$Pages$Admin$Coupons$Archived = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$GotCoupon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Coupons$RedeemableFrom = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$RedeemableUntil = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$Unarchived = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$Provider$Coupon$couponPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Coupon$couponsPath);
};
var $author$project$Api$Provider$Coupon$couponArchivePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['archive']),
		$author$project$Api$Provider$Coupon$couponPath(id_));
};
var $author$project$Api$Provider$Coupon$One$Coupon = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Coupon$One$Record = function (meta) {
	return {TU: meta};
};
var $author$project$Api$Provider$Coupon$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Coupon$Meta$MetaRecord = F5(
	function (code, percentOff, durationInMonths, redeemableFrom, redeemableUntil) {
		return {K3: code, N4: durationInMonths, Wb: percentOff, X_: redeemableFrom, X$: redeemableUntil};
	});
var $author$project$Api$Provider$Coupon$Meta$EditableRecord = function (editable) {
	return {Oa: editable};
};
var $author$project$Api$Provider$Coupon$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$Meta$EditableRecord));
var $author$project$Api$Provider$Coupon$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'redeemable_until',
	$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'redeemable_from',
		$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'duration_in_months',
			$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'percent_off',
				$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'code',
					$author$project$Api$Provider$Coupon$Meta$editableRecordDecoder,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$Meta$MetaRecord))))));
var $author$project$Api$Provider$Coupon$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Coupon$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Coupon$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Coupon$Meta$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$One$Record));
var $author$project$Api$Provider$Coupon$One$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Coupon$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Coupon$Shared$decode,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$One$Coupon)));
var $author$project$Api$Provider$Coupon$archive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Coupon$couponArchivePath(id_)));
	});
var $author$project$Api$Common$Coupon$Shared$amountOffInCents = function (_v0) {
	var record = _v0;
	return record.I3;
};
var $author$project$Api$Provider$Coupon$One$amountOffInCents = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$amountOffInCents(common);
};
var $author$project$Api$Common$Coupon$Shared$applyToEachPatient = function (_v0) {
	var record = _v0;
	return record.Jl;
};
var $author$project$Api$Provider$Coupon$One$applyToEachPatient = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$applyToEachPatient(common);
};
var $author$project$Api$Common$Coupon$Shared$code = function (_v0) {
	var record = _v0;
	return record.K3;
};
var $author$project$Api$Provider$Coupon$One$code = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$code(common);
};
var $author$project$Api$Common$Coupon$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$Coupon$One$description = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$description(common);
};
var $author$project$Api$Common$Coupon$Shared$durationInMonths = function (_v0) {
	var record = _v0;
	return record.N4;
};
var $author$project$Api$Provider$Coupon$One$durationInMonths = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$durationInMonths(common);
};
var $author$project$Api$Common$Coupon$Shared$percentOff = function (_v0) {
	var record = _v0;
	return record.Wb;
};
var $author$project$Api$Provider$Coupon$One$percentOff = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$percentOff(common);
};
var $author$project$Api$Common$Coupon$Shared$redeemableFrom = function (_v0) {
	var record = _v0;
	return record.X_;
};
var $author$project$Api$Provider$Coupon$One$redeemableFrom = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$redeemableFrom(common);
};
var $author$project$Api$Common$Coupon$Shared$redeemableUntil = function (_v0) {
	var record = _v0;
	return record.X$;
};
var $author$project$Api$Provider$Coupon$One$redeemableUntil = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$redeemableUntil(common);
};
var $author$project$Pages$Admin$Coupons$formFieldsFromCoupon = function (coupon) {
	var _v0 = $author$project$Components$DateInput$init;
	var redeemableUntilDateInput = _v0.a;
	var redeemableUntilDateInputCmd = _v0.b;
	var _v1 = $author$project$Components$DateInput$init;
	var redeemableFromDateInput = _v1.a;
	var redeemableFromDateInputCmd = _v1.b;
	return _Utils_Tuple2(
		{
			I3: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$Coupon$One$amountOffInCents(coupon)),
			Jl: $author$project$Api$Provider$Coupon$One$applyToEachPatient(coupon),
			K3: $author$project$Api$Provider$Coupon$One$code(coupon),
			Nx: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Coupon$One$description(coupon)),
			N4: $author$project$Api$Provider$Coupon$One$durationInMonths(coupon),
			Wb: A2(
				$elm$core$Maybe$map,
				$author$project$Percentage$fromFloat,
				$author$project$Api$Provider$Coupon$One$percentOff(coupon)),
			X_: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Coupon$One$redeemableFrom(coupon)),
			nR: redeemableFromDateInput,
			X$: $author$project$Api$Provider$Coupon$One$redeemableUntil(coupon),
			nS: redeemableUntilDateInput
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(redeemableFromDateInput),
					redeemableFromDateInputCmd),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(redeemableUntilDateInput),
					redeemableUntilDateInputCmd)
				])));
};
var $author$project$Pages$Admin$Coupons$formFieldsInit = function (today) {
	var _v0 = $author$project$Components$DateInput$init;
	var redeemableUntilDateInput = _v0.a;
	var redeemableUntilDateInputCmd = _v0.b;
	var _v1 = $author$project$Components$DateInput$init;
	var redeemableFromDateInput = _v1.a;
	var redeemableFromDateInputCmd = _v1.b;
	return _Utils_Tuple2(
		{
			I3: $elm$core$Maybe$Nothing,
			Jl: true,
			K3: '',
			Nx: '',
			N4: $elm$core$Maybe$Nothing,
			Wb: $elm$core$Maybe$Nothing,
			X_: $elm$core$Maybe$Just(today),
			nR: redeemableFromDateInput,
			X$: $elm$core$Maybe$Nothing,
			nS: redeemableUntilDateInput
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(redeemableFromDateInput),
					redeemableFromDateInputCmd),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(redeemableUntilDateInput),
					redeemableUntilDateInputCmd)
				])));
};
var $author$project$Pages$Admin$Coupons$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{K3: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{Nx: string});
			case 2:
				var _float = field.a;
				return _Utils_update(
					fields,
					{Wb: _float});
			case 3:
				var _int = field.a;
				return _Utils_update(
					fields,
					{I3: _int});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Jl: A2(
							$elm$core$Maybe$withDefault,
							true,
							$author$project$Utils$Bool$fromString(string))
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						N4: $elm$core$String$toInt(string)
					});
			case 6:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{X_: date, nR: dateInput});
			default:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{X$: date, nS: dateInput});
		}
	});
var $author$project$Pages$Admin$Coupons$RedeemableFromValidation = 2;
var $author$project$Pages$Admin$Coupons$CodeValidation = 0;
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$Utils$Regex$matches = F2(
	function (userRegex, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return false;
		} else {
			var regex = _v0.a;
			return A2($elm$regex$Regex$contains, regex, string);
		}
	});
var $author$project$Utils$Validate$doesNotMatchRegex = F2(
	function (string, regex) {
		return !A2($author$project$Utils$Regex$matches, regex, string);
	});
var $author$project$Pages$Admin$Coupons$validateCode = function (fields) {
	return $rtfeldman$elm_validate$Validate$isBlank(fields.K3) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter a code.')
		]) : (A2($author$project$Utils$Validate$doesNotMatchRegex, fields.K3, '^[a-zA-Z\\d]+$') ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Coupons can only include numbers and letters. Please remove any spaces or punctuation.')
		]) : _List_Nil);
};
var $author$project$Pages$Admin$Coupons$DiscountValidation = 1;
var $author$project$Pages$Admin$Coupons$validateDiscount = function (fields) {
	var _v0 = _Utils_Tuple2(fields.I3, fields.Wb);
	if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a discount.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Admin$Coupons$RedeemableUntilValidation = 3;
var $author$project$Pages$Admin$Coupons$validateRedeemableUntil = function (fields) {
	var _v0 = _Utils_Tuple2(fields.X_, fields.X$);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var redeemableFrom = _v0.a.a;
		var redeemableUntil = _v0.b.a;
		return (A2($justinmimbs$date$Date$compare, redeemableUntil, redeemableFrom) !== 2) ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'Coupon must be active for at least one day.')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Admin$Coupons$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateCode),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.X_;
			},
			_Utils_Tuple2(2, 'Please enter an start date.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateDiscount),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateRedeemableUntil)
		]));
var $author$project$Api$Common$Coupon$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Coupon$All$id = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$id(common);
};
var $author$project$Api$Common$Coupon$Shared$isArchived = function (_v0) {
	var record = _v0;
	return record.Rx;
};
var $author$project$Api$Provider$Coupon$All$isArchived = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$isArchived(common);
};
var $author$project$Api$Provider$Coupon$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Coupon$couponPath(id_)));
	});
var $author$project$Pages$Admin$Coupons$Created = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Coupons$apiFields = function (fields) {
	return {
		I3: fields.I3,
		Jl: fields.Jl,
		K3: fields.K3,
		Nx: fields.Nx,
		N4: fields.N4,
		Wb: A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Wb),
		X_: fields.X_,
		X$: fields.X$
	};
};
var $author$project$Api$Provider$Coupon$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'coupon',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(fields.K3)),
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(fields.Nx)),
								_Utils_Tuple2(
								'percent_off',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.Wb)),
								_Utils_Tuple2(
								'amount_off_in_cents',
								A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I3)),
								_Utils_Tuple2(
								'redeemable_from',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.X_)),
								_Utils_Tuple2(
								'redeemable_until',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.X$)),
								_Utils_Tuple2(
								'duration_in_months',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.N4)),
								_Utils_Tuple2(
								'apply_to_each_patient',
								$elm$json$Json$Encode$bool(fields.Jl))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponsPath)));
	});
var $author$project$Pages$Admin$Coupons$createCoupon = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Coupon$create,
			apiClient,
			$author$project$Pages$Admin$Coupons$apiFields(fields),
			$author$project$Pages$Admin$Coupons$Created);
	});
var $author$project$Api$Provider$Coupon$One$id = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Coupon$Shared$id(common);
};
var $author$project$Pages$Admin$Coupons$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Coupon$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'coupon',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(fields.K3)),
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(fields.Nx)),
								_Utils_Tuple2(
								'percent_off',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.Wb)),
								_Utils_Tuple2(
								'amount_off_in_cents',
								A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I3)),
								_Utils_Tuple2(
								'redeemable_from',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.X_)),
								_Utils_Tuple2(
								'redeemable_until',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.X$)),
								_Utils_Tuple2(
								'duration_in_months',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.N4)),
								_Utils_Tuple2(
								'apply_to_each_patient',
								$elm$json$Json$Encode$bool(fields.Jl))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Coupon$couponPath(id_))));
	});
var $author$project$Pages$Admin$Coupons$updateCoupon = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Coupon$update,
			apiClient,
			id,
			$author$project$Pages$Admin$Coupons$apiFields(fields),
			$author$project$Pages$Admin$Coupons$Updated);
	});
var $author$project$Pages$Admin$Coupons$saveCoupon = F3(
	function (apiClient, coupon, formFields) {
		if (!coupon.$) {
			var coupon_ = coupon.a;
			return A3(
				$author$project$Pages$Admin$Coupons$updateCoupon,
				apiClient,
				$author$project$Api$Provider$Coupon$One$id(coupon_),
				formFields);
		} else {
			return A2($author$project$Pages$Admin$Coupons$createCoupon, apiClient, formFields);
		}
	});
var $author$project$Api$Provider$Coupon$couponUnarchivePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['unarchive']),
		$author$project$Api$Provider$Coupon$couponPath(id_));
};
var $author$project$Api$Provider$Coupon$unarchive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Coupon$One$decode,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Coupon$couponUnarchivePath(id_)));
	});
var $author$project$Pages$Admin$Coupons$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = model.L1;
		if (!_v0.$) {
			var _v1 = _v0.a;
			var id = _v1.a;
			var form = _v1.b;
			var coupon = _v1.c;
			var _v2 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
			var newDateInput = _v2.a;
			var subCmd = _v2.b;
			var event = _v2.c;
			var newForm = function () {
				if (event.$ === 1) {
					var date = event.a;
					return A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Admin$Coupons$formFieldsUpdate,
						A2(field, newDateInput, date),
						form);
				} else {
					var fields = $author$project$Utils$Form$fields(form);
					return A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Admin$Coupons$formFieldsUpdate,
						A2(
							field,
							newDateInput,
							fieldGetter(fields)),
						form);
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						L1: $elm$core$Maybe$Just(
							_Utils_Tuple3(id, newForm, coupon))
					}),
				A2(
					$elm$core$Platform$Cmd$map,
					toMsg(newDateInput),
					subCmd),
				_List_Nil);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$Admin$Coupons$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$url$Url$Builder$string,
			'archived',
			$author$project$Utils$Bool$toString(model.Jn))
		]);
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Coupons)
				]),
			queryParams));
};
var $author$project$Pages$Admin$Coupons$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = $author$project$Pages$Admin$Coupons$formFieldsInit(model.cO);
				var fields = _v1.a;
				var fieldsCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							L1: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(fields),
									$author$project$Api$Data$NotAsked))
						}),
					fieldsCmd,
					_List_Nil);
			case 6:
				var field = msg.a;
				var _v2 = model.L1;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var coupon = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Coupons$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L1: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, coupon))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var form = msg.a;
				var coupon = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Coupons$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L1: $elm$core$Maybe$Just(
									_Utils_Tuple3(coupon, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$Coupons$saveCoupon, model.D5, coupon, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L1: $elm$core$Maybe$Just(
									_Utils_Tuple3(coupon, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var coupon = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$Coupon$retrieve,
						model.D5,
						$author$project$Api$Provider$Coupon$All$id(coupon),
						$author$project$Pages$Admin$Coupons$GotCoupon),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var coupon = response.a;
					var _v7 = $author$project$Pages$Admin$Coupons$formFieldsFromCoupon(coupon);
					var fields = _v7.a;
					var fieldsCmd = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L1: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										$elm$core$Maybe$Just(coupon),
										$author$project$Utils$Form$init(fields),
										$author$project$Api$Data$NotAsked))
							}),
						fieldsCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L1: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{wR: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var response = msg.a;
				var _v8 = model.L1;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var id = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{L1: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Coupons$fetchCoupons(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Coupon successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									L1: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v11 = model.L1;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var id = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{L1: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Coupons$fetchCoupons(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Coupon successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									L1: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aV: A2($elm$core$Set$remove, id, model.aV),
									wR: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Coupons$fetchCoupons(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'The coupon was successfully archived')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aV: A2($elm$core$Set$remove, id, model.aV)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aV: A2($elm$core$Set$remove, id, model.aV),
									wR: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Coupons$fetchCoupons(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'The coupon was successfully unarchived')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aV: A2($elm$core$Set$remove, id, model.aV)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var coupon = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hw: $elm$core$Maybe$Just(coupon)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var coupon = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$Coupon$All$id(coupon);
					var cmd = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? A3(
						$author$project$Api$Provider$Coupon$unarchive,
						model.D5,
						id,
						$author$project$Pages$Admin$Coupons$Unarchived(id)) : A3(
						$author$project$Api$Provider$Coupon$archive,
						model.D5,
						id,
						$author$project$Pages$Admin$Coupons$Archived(id));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hw: $elm$core$Maybe$Nothing,
								aV: A2($elm$core$Set$insert, id, model.aV)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hw: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Pages$Admin$Coupons$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg,
					$author$project$Pages$Admin$Coupons$RedeemableFrom,
					function ($) {
						return $.X_;
					});
			case 14:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Pages$Admin$Coupons$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg,
					$author$project$Pages$Admin$Coupons$RedeemableUntil,
					function ($) {
						return $.X$;
					});
			case 15:
				var subMsg = msg.a;
				var _v16 = A2($author$project$Ui$NewDropdown$update, subMsg, model.k$);
				var dropdown = _v16.a;
				var dropdownCmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k$: dropdown}),
					dropdownCmd,
					_List_Nil);
			default:
				var archived = msg.a;
				var newModel = _Utils_update(
					model,
					{Jn: archived, wR: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Coupons$fetchCoupons(newModel),
								$author$project$Pages$Admin$Coupons$updateUrl(newModel)
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Coupons$New = {$: 0};
var $author$project$Pages$Admin$Coupons$ArchivedSelected = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$Coupons$archivedDropdownOptions = function (archived) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(!archived),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Admin$Coupons$ArchivedSelected(false))
				]),
			$elm$html$Html$text('Current')),
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(archived),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Admin$Coupons$ArchivedSelected(true))
				]),
			$elm$html$Html$text('Archived'))
		]);
};
var $author$project$Pages$Admin$Coupons$viewArchivedDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				model.Jn ? 'Archived' : 'Current')
			]),
		$author$project$Pages$Admin$Coupons$archivedDropdownOptions(model.Jn),
		model.k$);
};
var $author$project$Pages$Admin$Coupons$AmountOffInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Coupons$ApplyToEachPatient = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Coupons$Code = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Coupons$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Coupons$DurationInMonths = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Coupons$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Coupons$PercentOff = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Coupons$Save = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$Coupons$applyToEachPatientOptions = _List_fromArray(
	[
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('true'),
		'once for each patient'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('false'),
		'once per membership')
	]);
var $author$project$Api$Provider$Coupon$Meta$codeEditable = function (_v0) {
	var meta = _v0;
	return meta.K3.Oa;
};
var $author$project$Ui$Form$PercentageInput$Disabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$PercentageInput$disabled = $author$project$Ui$Form$PercentageInput$Disabled;
var $author$project$Api$Provider$Coupon$Meta$durationInMonthsEditable = function (_v0) {
	var meta = _v0;
	return meta.N4.Oa;
};
var $author$project$Ui$Form$Select$Inline = {$: 8};
var $author$project$Ui$Form$Select$inline = $author$project$Ui$Form$Select$Inline;
var $author$project$Api$Provider$Coupon$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Provider$Coupon$Meta$percentOffEditable = function (_v0) {
	var meta = _v0;
	return meta.Wb.Oa;
};
var $author$project$Ui$Form$PercentageInput$Placeholder = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$PercentageInput$placeholder = $author$project$Ui$Form$PercentageInput$Placeholder;
var $author$project$Api$Provider$Coupon$Meta$redeemableFromEditable = function (_v0) {
	var meta = _v0;
	return meta.X_.Oa;
};
var $author$project$Api$Provider$Coupon$Meta$redeemableUntilEditable = function (_v0) {
	var meta = _v0;
	return meta.X$.Oa;
};
var $author$project$Ui$Form$PeriodInMonthsSelect$selectOptions = F2(
	function (noneLabel, options) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				noneLabel),
			A2(
				$elm$core$List$map,
				function (month) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(month)),
						$elm$core$String$fromInt(month));
				},
				options));
	});
var $author$project$Ui$Form$PeriodInMonthsSelect$view = function (_v0) {
	var value = _v0.aaN;
	var onChange = _v0.ae4;
	var noneLabel = _v0.UL;
	var options = _v0.zY;
	return $author$project$Ui$Form$Input$group(
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, value)),
						$author$project$Ui$Form$Select$onChange(onChange)
					]),
				A2($author$project$Ui$Form$PeriodInMonthsSelect$selectOptions, noneLabel, options)),
				$author$project$Ui$Form$Input$addon(
				_List_fromArray(
					[
						(A2($elm$core$Maybe$withDefault, 0, value) === 1) ? $elm$html$Html$text('month') : $elm$html$Html$text('months')
					]))
			]));
};
var $author$project$Pages$Admin$Coupons$viewDiscount = F3(
	function (percentOff, amountOffInCents, applyToEachPatient) {
		var _v0 = _Utils_Tuple2(percentOff, amountOffInCents);
		if (!_v0.a.$) {
			var percentOff_ = _v0.a.a;
			return _List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromFloat(percentOff_) + '% off')
				]);
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var amountOffInCents_ = _v0.b.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Currency$format(amountOffInCents_)),
						$elm$html$Html$text(' / '),
						applyToEachPatient ? $elm$html$Html$text('patient') : $elm$html$Html$text('membership')
					]);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return _List_Nil;
			}
		}
	});
var $author$project$Pages$Admin$Coupons$viewDuration = function (durationInMonths) {
	if (!durationInMonths.$) {
		var durationInMonths_ = durationInMonths.a;
		return $elm$html$Html$text(
			A2($author$project$Formatters$String$pluralize, 'month', durationInMonths_));
	} else {
		return $elm$html$Html$text('unlimited');
	}
};
var $author$project$Pages$Admin$Coupons$viewCouponModal = F4(
	function (couponUrl, coupon, saveRequest, form) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Coupon',
			S_: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$id, coupon),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$Coupons$CancelEdit,
			U0: $elm$core$Basics$always(
				A2($author$project$Pages$Admin$Coupons$Save, form, coupon))
		};
		var isNew = !$author$project$Utils$Maybe$toBool(coupon);
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(isNew),
							$author$project$Ui$Form$Group$label('Coupon Code')
						]),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Coupon$Meta$codeEditable,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.K3),
									$author$project$Ui$Form$Input$placeholder('gethealthy'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$Code)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(fields.K3)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Nx),
									$author$project$Ui$Form$Input$placeholder('Marketing Campaign in Get Healthy Magazine'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$Description))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Monthly Discount'),
							$author$project$Ui$Form$Group$required(isNew)
						]),
					A2(
						$elm$core$Maybe$withDefault,
						true,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Coupon$Meta$percentOffEditable,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$PercentageInput$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$PercentageInput$value(fields.Wb),
													$author$project$Ui$Form$PercentageInput$placeholder('5.5'),
													$author$project$Ui$Form$PercentageInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$PercentOff)),
													$author$project$Ui$Form$PercentageInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
													$author$project$Ui$Form$PercentageInput$disabled(
													$author$project$Utils$Maybe$toBool(fields.I3))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(2)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$em,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('or')
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$value(fields.I3),
													$author$project$Ui$Form$CurrencyInput$placeholder('7.50'),
													$author$project$Ui$Form$CurrencyInput$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$AmountOffInCents)),
													$author$project$Ui$Form$CurrencyInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
													$author$project$Ui$Form$CurrencyInput$disabled(
													$author$project$Utils$Maybe$toBool(fields.Wb))
												]))
										]))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 1, form)),
							function () {
							var _v0 = fields.I3;
							if (!_v0.$) {
								return A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('This coupon to apply'),
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(
														$author$project$Utils$Bool$toString(fields.Jl))),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$ApplyToEachPatient)),
													$author$project$Ui$Form$Select$inline
												]),
											$author$project$Pages$Admin$Coupons$applyToEachPatientOptions)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							A3(
								$author$project$Pages$Admin$Coupons$viewDiscount,
								A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Wb),
								fields.I3,
								fields.Jl))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Coupon Duration')
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Coupon$Meta$durationInMonthsEditable,
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
							[
								$author$project$Ui$Form$PeriodInMonthsSelect$view(
								{
									UL: 'Unlimited',
									ae4: A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$DurationInMonths),
									zY: A2($elm$core$List$range, 1, 12),
									aaN: fields.N4
								})
							]) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$Admin$Coupons$viewDuration(fields.N4)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Time period monthly discount is applied.')
									]))
							]))),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(isNew),
							$author$project$Ui$Form$Group$label('Start Date')
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Coupon$Meta$redeemableFromEditable,
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(fields.nR),
								A2(
									$author$project$Components$DateInput$view,
									_List_fromArray(
										[
											$author$project$Components$DateInput$value(fields.X_),
											$author$project$Components$DateInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
											$author$project$Components$DateInput$errors(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]),
									fields.nR))
							]) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
												fields.X_)))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Date coupon can first be redeemed.')
									]))
							]))),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('End Date')
						]),
					_Utils_ap(
						A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Coupon$Meta$redeemableUntilEditable,
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(fields.nS),
								A2(
									$author$project$Components$DateInput$view,
									_List_fromArray(
										[
											$author$project$Components$DateInput$value(fields.X$),
											$author$project$Components$DateInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
											$author$project$Components$DateInput$errors(
											A2($author$project$Utils$Form$validationErrors, 3, form))
										]),
									fields.nS))
							]) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'none',
											A2(
												$elm$core$Maybe$map,
												$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
												fields.X$)))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Last day coupon can be redeemed. Leave blank for no end date.')
									]))
							]))),
					($elm$core$String$length(fields.K3) > 0) ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Signup URL')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									couponUrl(fields.K3),
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											couponUrl(fields.K3))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Link to your Online Signup page with this coupon applied')
										]))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Api$Common$Coupon$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Coupon$All$createdAt = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$createdAt(common);
};
var $author$project$Pages$Admin$Coupons$sortCoupons = function (coupons) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortBy,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Coupon$All$createdAt, $elm$time$Time$posixToMillis),
			coupons));
};
var $author$project$Pages$Admin$Coupons$Archive = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$Coupons$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Coupon$All$amountOffInCents = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$amountOffInCents(common);
};
var $author$project$Api$Provider$Coupon$All$applyToEachPatient = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$applyToEachPatient(common);
};
var $author$project$Api$Provider$Coupon$All$code = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$code(common);
};
var $author$project$Api$Provider$Coupon$All$durationInMonths = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$durationInMonths(common);
};
var $author$project$Api$Common$Coupon$Shared$isRedeemable = function (_v0) {
	var record = _v0;
	return record.R2;
};
var $author$project$Api$Provider$Coupon$All$isRedeemable = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$isRedeemable(common);
};
var $author$project$Api$Provider$Coupon$All$percentOff = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$percentOff(common);
};
var $author$project$Api$Provider$Coupon$All$redeemableFrom = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$redeemableFrom(common);
};
var $author$project$Api$Provider$Coupon$All$redeemableUntil = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Coupon$Shared$redeemableUntil(common);
};
var $author$project$Pages$Admin$Coupons$viewCoupon = F2(
	function (archivingCoupons, coupon) {
		var status = $author$project$Api$Provider$Coupon$All$isRedeemable(coupon) ? 'redeemable' : 'not_redeemable';
		var id = $author$project$Api$Provider$Coupon$All$id(coupon);
		var loading = A2($elm$core$Set$member, id, archivingCoupons);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Coupon$All$code(coupon))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A3(
						$author$project$Pages$Admin$Coupons$viewDiscount,
						$author$project$Api$Provider$Coupon$All$percentOff(coupon),
						A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$Coupon$All$amountOffInCents(coupon)),
						$author$project$Api$Provider$Coupon$All$applyToEachPatient(coupon))),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$Coupon$All$redeemableFrom(coupon)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$Coupon$All$redeemableUntil(coupon);
							if (!_v0.$) {
								var redeemableUntil = _v0.a;
								return $elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, redeemableUntil));
							} else {
								return $elm$html$Html$text('none');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Admin$Coupons$viewDuration(
							$author$project$Api$Provider$Coupon$All$durationInMonths(coupon))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, status)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit coupon'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$disabled(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Coupons$Edit(coupon)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									function () {
									var verb = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? 'Unarchive' : 'Archive';
									return A3(
										$author$project$Ui$Button$view,
										{abp: verb + ' coupon'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$size(0),
												$author$project$Ui$Button$loading(loading),
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Admin$Coupons$Archive(coupon))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(verb)
											]));
								}()
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Coupons$viewPanelTable = function (model) {
	var action = model.Jn ? 'archived' : 'unarchived';
	var _v0 = function () {
		var _v1 = model.wR;
		if (_v1.$ === 3) {
			var coupons_ = _v1.a;
			return _Utils_Tuple2(false, coupons_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var coupons = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You dont have any ' + (action + ' coupons.'))
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Coupon Code')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Amount Off')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Start Date')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('End Date')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Duration')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Status')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Coupons$viewCoupon(model.aV),
			$author$project$Pages$Admin$Coupons$sortCoupons(coupons)),
		_List_Nil);
};
var $author$project$Pages$Admin$Coupons$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.L1;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var coupon = _v1.a;
					var form = _v1.b;
					var saveRequest = _v1.c;
					return A4($author$project$Pages$Admin$Coupons$viewCouponModal, model.EJ, coupon, saveRequest, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.hw;
				if (!_v2.$) {
					var coupon = _v2.a;
					var action = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? 'unarchive' : 'archive';
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Coupons$HiConfirmClosed(coupon),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('You\'re about to ' + (action + ' this coupon'))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Coupons')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Create new coupon'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$Coupons$New),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Coupon')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(4),
												$author$project$Ui$FlexGrid$spanSm(2),
												$author$project$Ui$FlexGrid$spanMd(3)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Admin$Coupons$viewArchivedDropdown(model)
											]))
									]))
							])),
						$author$project$Pages$Admin$Coupons$viewPanelTable(model)
					]))
			]),
		$G: 'Admin | Coupons'
	};
};
var $author$project$Pages$Admin$Coupons$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Coupons$init, aer: $author$project$Pages$Admin$Coupons$load, agD: $author$project$Pages$Admin$Coupons$save, ahd: $author$project$Pages$Admin$Coupons$subscriptions, aaq: $author$project$Pages$Admin$Coupons$update, ahP: $author$project$Pages$Admin$Coupons$view});
var $author$project$Pages$Admin$CoveragePlans$Id_String$CoveragePlanFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoveragePlans$Form$GotPlans = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$fetchPlans = F2(
	function (apiClient, model) {
		var params = function (d) {
			return _Utils_update(
				d,
				{
					Ea: $elm$core$Maybe$Just(
						A2($elm$core$Maybe$withDefault, '', model.adR)),
					afy: model.afy,
					af_: model.r6,
					ag1: $author$project$Api$Sort$init
				});
		};
		return A3($author$project$Api$Provider$Plan$list, apiClient, params, $author$project$Components$Admin$CoveragePlans$Form$GotPlans);
	});
var $author$project$Components$Admin$CoveragePlans$Form$formFieldsInit = {abd: false, zh: '', Wq: _List_Nil};
var $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm_community$list_extra$List$Extra$indexedFoldr = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _v0) {
				var i = _v0.a;
				var thisAcc = _v0.b;
				return _Utils_Tuple2(
					i - 1,
					A3(func, i, x, thisAcc));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(
				$elm$core$List$length(list) - 1,
				acc),
			list).b;
	});
var $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Creating = 0;
var $author$project$Components$Admin$CoverageRules$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Viewing = 2;
var $author$project$Api$Provider$CoverageRule$Shared$category = function (_v0) {
	var record = _v0;
	return record.Ex;
};
var $author$project$Api$Provider$CoverageRule$One$category = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$category(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$Patient = 0;
var $author$project$Components$Admin$CoverageRules$Form$initFormFields = {I2: $elm$core$Maybe$Nothing, dz: 0, adR: $elm$core$Maybe$Nothing, FU: $elm$core$Maybe$Nothing, q9: 'charge_category', afJ: $elm$core$Maybe$Nothing, Bd: $elm$core$Maybe$Nothing, agA: $elm$core$Maybe$Nothing, aht: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$CoverageRule$Shared$Sponsor = 1;
var $author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy = F2(
	function (patientPercentage, sponsorPercentage) {
		var _v0 = _Utils_Tuple2(patientPercentage, sponsorPercentage);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var patientContributionPercentage_ = _v0.a.a;
			var sponsorContributionPercentage_ = _v0.b.a;
			return (_Utils_cmp(patientContributionPercentage_, sponsorContributionPercentage_) > 0) ? 0 : 1;
		} else {
			return 0;
		}
	});
var $author$project$Api$Provider$CoverageRule$Shared$coveredBy = function (_v0) {
	var record = _v0;
	return A2($author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy, record.afD, record.ag4);
};
var $author$project$Api$Provider$CoverageRule$One$coveredBy = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$coveredBy(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CoverageRule$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$id(shared);
};
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue = function (ruleTypeOption) {
	var id = ruleTypeOption.adR;
	return $elm$core$Maybe$Just(id);
};
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption = function (ruleTypeOption) {
	var includedOption = ruleTypeOption.d4;
	return includedOption;
};
var $author$project$Components$Admin$CoverageRules$Form$RuleType = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions = _List_fromArray(
	[
		{
		adR: 'included',
		d4: $elm$core$Maybe$Just(0),
		zh: 'Included at no additional cost'
	},
		{
		adR: 'included',
		d4: $elm$core$Maybe$Just(1),
		zh: 'Included if they cost less than'
	},
		{adR: 'discounted', d4: $elm$core$Maybe$Nothing, zh: 'Discounted'},
		{adR: 'surcharge', d4: $elm$core$Maybe$Nothing, zh: 'Surcharged'},
		{adR: 'flat_amount', d4: $elm$core$Maybe$Nothing, zh: 'Charged a flat amount'},
		{adR: 'pass_through', d4: $elm$core$Maybe$Nothing, zh: 'Passed through at cost'},
		{adR: 'limited_quantity', d4: $elm$core$Maybe$Nothing, zh: 'Limited to a quantity'}
	]);
var $author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule = function (coverageRule) {
	var timePeriod = $author$project$Api$Provider$CoverageRule$One$timePeriod(coverageRule);
	var ruleType = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (option) {
				return _Utils_eq(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(option)),
					$author$project$Api$Provider$CoverageRule$One$ruleType(coverageRule)) && _Utils_eq(
					$author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption(option),
					$author$project$Api$Provider$CoverageRule$One$includedOption(coverageRule));
			},
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions));
	var quantity = $author$project$Api$Provider$CoverageRule$One$quantity(coverageRule);
	var percentage = $author$project$Api$Provider$CoverageRule$One$percentage(coverageRule);
	var id = $author$project$Api$Provider$CoverageRule$One$id(coverageRule);
	var coveredBy = $author$project$Api$Provider$CoverageRule$One$coveredBy(coverageRule);
	var amountInCents = A2(
		$elm$core$Maybe$map,
		$author$project$Currency$fromInt,
		$author$project$Api$Provider$CoverageRule$One$amountInCents(coverageRule));
	var _v0 = function () {
		var _v1 = $author$project$Api$Provider$CoverageRule$One$item(coverageRule);
		if (_v1.$ === 1) {
			var category_ = _v1.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					{
						adR: $author$project$Api$Provider$Category$Shared$id(category_),
						zh: $author$project$Api$Provider$Category$Shared$name(category_)
					}),
				'charge_category');
		} else {
			var chargeItem = _v1.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					{
						adR: $author$project$Api$Provider$ChargeItem$Shared$id(chargeItem),
						zh: $author$project$Api$Provider$ChargeItem$Shared$name(chargeItem)
					}),
				'charge_item');
		}
	}();
	var item = _v0.a;
	var itemType = _v0.b;
	return {
		I2: amountInCents,
		dz: coveredBy,
		adR: $elm$core$Maybe$Just(id),
		FU: item,
		q9: itemType,
		afJ: percentage,
		Bd: quantity,
		agA: ruleType,
		aht: timePeriod
	};
};
var $author$project$Api$Provider$CoverageRule$One$unpublishedCoveredBy = function (_v0) {
	var record = _v0.b;
	var _v1 = record.HI;
	if (!_v1.$) {
		var unpublishedRule_ = _v1.a;
		return A2(
			$author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy,
			$author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(unpublishedRule_),
			$author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(unpublishedRule_));
	} else {
		return 0;
	}
};
var $author$project$Api$Provider$CoverageRule$One$unpublishedRule = function (_v0) {
	var record = _v0.b;
	return record.HI;
};
var $author$project$Components$Admin$CoverageRules$Form$initUnpublishedRuleForm = function (coverageRule) {
	var coverageRuleFields = $author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule(coverageRule);
	var initForm = function (unpublishedRule) {
		var unpublishedRuleId = $author$project$Api$Provider$CoverageRule$Shared$id(unpublishedRule);
		return _Utils_eq(
			coverageRuleFields.adR,
			$elm$core$Maybe$Just(unpublishedRuleId)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Utils$Form$init(
				_Utils_update(
					coverageRuleFields,
					{
						I2: A2(
							$elm$core$Maybe$map,
							$author$project$Currency$fromInt,
							$author$project$Api$Provider$CoverageRule$Shared$amountInCents(unpublishedRule)),
						dz: $author$project$Api$Provider$CoverageRule$One$unpublishedCoveredBy(coverageRule),
						adR: $elm$core$Maybe$Just(unpublishedRuleId),
						afJ: $author$project$Api$Provider$CoverageRule$Shared$percentage(unpublishedRule)
					})));
	};
	return A2(
		$elm$core$Maybe$andThen,
		initForm,
		$author$project$Api$Provider$CoverageRule$One$unpublishedRule(coverageRule));
};
var $author$project$Api$Provider$CoverageRule$Shared$isPublished = function (_v0) {
	var record = _v0;
	return record.Xo;
};
var $author$project$Api$Provider$CoverageRule$One$isPublished = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$isPublished(shared);
};
var $author$project$Components$Admin$CoverageRules$Form$ruleIsUnpublished = function (coverageRule) {
	return $elm$core$Maybe$Just(
		!$author$project$Api$Provider$CoverageRule$One$isPublished(coverageRule));
};
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle = function (ruleTypeOption) {
	var name = ruleTypeOption.zh;
	return name;
};
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToLabel = function (ruleTypeOption) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle(ruleTypeOption))
		]);
};
var $author$project$Components$Admin$CoverageRules$Form$wasCreatedWithoutPublishing = function (coverageRule) {
	return $elm$core$Maybe$Just(
		_Utils_eq(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (r) {
						return $author$project$Api$Provider$CoverageRule$Shared$id(r);
					},
					$author$project$Api$Provider$CoverageRule$One$unpublishedRule(coverageRule))),
			$author$project$Api$Provider$CoverageRule$One$id(coverageRule)));
};
var $author$project$Components$Admin$CoverageRules$Form$init = F6(
	function (apiClient, session, maybeCoverageRule, coveragePlanId, _v0, coverageRuleUsage) {
		var readOnly = _v0.XO;
		var ruleTypeSelect = $author$project$Ui$Form$SearchableSelect$init(
			{adR: 'ruleType', ahw: $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToLabel, ahA: $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle, g0: $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue});
		var newUnpublishedRule = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$wasCreatedWithoutPublishing, maybeCoverageRule));
		var wasDeleted = (!newUnpublishedRule) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleIsUnpublished, maybeCoverageRule));
		var editMode = _Utils_eq(maybeCoverageRule, $elm$core$Maybe$Nothing) ? 0 : 2;
		var category_ = A2(
			$elm$core$Maybe$map,
			function (categoryMin) {
				return {
					adR: $author$project$Api$Provider$Category$Min$id(categoryMin),
					zh: $author$project$Api$Provider$Category$Min$name(categoryMin)
				};
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$CoverageRule$One$category, maybeCoverageRule));
		var _v1 = function () {
			if (!maybeCoverageRule.$) {
				var coverageRule = maybeCoverageRule.a;
				return _Utils_Tuple3(
					$author$project$Utils$Form$init(
						$author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule(coverageRule)),
					$author$project$Components$Admin$CoverageRules$Form$initUnpublishedRuleForm(coverageRule),
					A2(
						$elm$core$Task$perform,
						$author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected,
						$elm$core$Task$succeed(coverageRule)));
			} else {
				return _Utils_Tuple3(
					$author$project$Utils$Form$init($author$project$Components$Admin$CoverageRules$Form$initFormFields),
					$elm$core$Maybe$Nothing,
					$elm$core$Platform$Cmd$none);
			}
		}();
		var form = _v1.a;
		var editedForm = _v1.b;
		var resourceFilterPreSelectCmd = _v1.c;
		var _v3 = A3(
			$author$project$Components$ResourceFilter$ChargeItem$init,
			apiClient,
			function (opts) {
				return _Utils_update(
					opts,
					{
						q9: $elm$core$Maybe$Just('item')
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Charge Item'});
			});
		var chargeItemResourceFilter = _v3.a;
		var chargeItemResourceFilterCmd = _v3.b;
		var _v4 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Category'});
			});
		var categoryResourceFilter = _v4.a;
		var categoryResourceFilterCmd = _v4.b;
		return _Utils_Tuple2(
			{Ex: category_, cJ: categoryResourceFilter, cK: chargeItemResourceFilter, wT: coveragePlanId, L6: maybeCoverageRule, EK: coverageRuleUsage, aF: wasDeleted, aH: editMode, PB: form, cd: newUnpublishedRule, XO: readOnly, n4: ruleTypeSelect, BY: $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions, ZD: session, L: editedForm},
			(editMode === 2) ? resourceFilterPreSelectCmd : $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						resourceFilterPreSelectCmd
					])));
	});
var $author$project$Api$Provider$CoverageRuleUsage$Shared$coverageRule = function (_v0) {
	var record = _v0;
	return record.L6;
};
var $author$project$Api$Provider$CoverageRuleUsage$All$coverageRule = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoverageRuleUsage$Shared$coverageRule(shared);
};
var $author$project$Components$Admin$CoveragePlans$Rules$selectCoverageRuleUsage = F2(
	function (coverageRule, coverageRuleUsages) {
		return A2(
			$elm$core$Maybe$andThen,
			function (coverageRuleUsages_) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (usage) {
							return _Utils_eq(
								$author$project$Api$Provider$CoverageRule$One$id(
									$author$project$Api$Provider$CoverageRuleUsage$All$coverageRule(usage)),
								$author$project$Api$Provider$CoverageRule$One$id(coverageRule));
						},
						coverageRuleUsages_));
			},
			coverageRuleUsages);
	});
var $author$project$Components$Admin$CoveragePlans$Rules$init = F6(
	function (apiClient, session, coveragePlanId, coverageRules, coverageRuleUsages, _v0) {
		var readOnly = _v0.XO;
		var filteredRules = readOnly ? A2($elm$core$List$filter, $author$project$Api$Provider$CoverageRule$One$isPublished, coverageRules) : coverageRules;
		var _v1 = A3(
			$elm_community$list_extra$List$Extra$indexedFoldr,
			F3(
				function (index, rule, _v2) {
					var forms = _v2.a;
					var cmds = _v2.b;
					var _v3 = A6(
						$author$project$Components$Admin$CoverageRules$Form$init,
						apiClient,
						session,
						$elm$core$Maybe$Just(rule),
						coveragePlanId,
						{XO: readOnly},
						A2($author$project$Components$Admin$CoveragePlans$Rules$selectCoverageRuleUsage, rule, coverageRuleUsages));
					var form = _v3.a;
					var cmd = _v3.b;
					var cmd_ = A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index),
						cmd);
					return _Utils_Tuple2(
						A2($elm$core$List$cons, form, forms),
						A2($elm$core$List$cons, cmd_, cmds));
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			filteredRules);
		var coverageRuleForms = _v1.a;
		var cmds_ = _v1.b;
		return _Utils_Tuple2(
			{wT: coveragePlanId, L7: coverageRuleUsages, acd: coverageRuleForms, XO: readOnly, ZD: session},
			$elm$core$Platform$Cmd$batch(cmds_));
	});
var $author$project$Components$Admin$CoveragePlans$Form$initPagination = A2($author$project$Api$Pagination$withItemsPerPage, 5, $author$project$Api$Pagination$init);
var $author$project$Api$Provider$CoveragePlan$coveragePlanPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$CoveragePlan$coveragePlansPath);
};
var $author$project$Api$Provider$CoveragePlan$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CoveragePlan$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_)));
	});
var $author$project$Components$Admin$CoveragePlans$Form$init = F4(
	function (apiClient, session, practice, id) {
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				var cmd = A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
				return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, cmd);
			} else {
				var _v2 = A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					apiClient,
					session,
					$elm$core$Maybe$Nothing,
					_List_Nil,
					$elm$core$Maybe$Nothing,
					{XO: false});
				var coverageRulesModel_ = _v2.a;
				var coverageRulesCmd_ = _v2.b;
				var cmd = A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverageRulesCmd_);
				return _Utils_Tuple3(
					$elm$core$Maybe$Just($author$project$Components$Admin$CoveragePlans$Form$formFieldsInit),
					$elm$core$Maybe$Just(coverageRulesModel_),
					cmd);
			}
		}();
		var formFields = _v0.a;
		var coverageRules = _v0.b;
		var command = _v0.c;
		var model = {
			L4: $elm$core$Maybe$Nothing,
			L5: $elm$core$Maybe$Nothing,
			acd: coverageRules,
			h4: $jinjor$elm_debounce$Debounce$init,
			PB: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
			adR: id,
			afy: $author$project$Components$Admin$CoveragePlans$Form$initPagination,
			go: _List_Nil,
			r6: $elm$core$Maybe$Nothing,
			Wq: $author$project$Api$Data$Loading,
			WF: practice,
			B0: false,
			sD: false,
			ZD: session
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						command,
						A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, model)
					])));
	});
var $author$project$Pages$Admin$CoveragePlans$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var params = _v1.Vx;
		var _v2 = A4(
			$author$project$Components$Admin$CoveragePlans$Form$init,
			apiClient,
			session,
			practice,
			$elm$core$Maybe$Just(params.adR));
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$CoveragePlans$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $elm$core$Basics$xor = _Basics_xor;
var $author$project$Components$Admin$CoverageRules$Form$isUnpublished = function (_v0) {
	var model = _v0;
	return (!_Utils_eq(model.L, $elm$core$Maybe$Nothing)) || (model.cd !== model.aF);
};
var $author$project$Components$Admin$CoveragePlans$Rules$unpublishedRulesExists = function (model) {
	return A2(
		$elm$core$List$any,
		function (rule) {
			return $author$project$Components$Admin$CoverageRules$Form$isUnpublished(rule);
		},
		model.acd);
};
var $author$project$Components$Admin$CoveragePlans$Form$save = F2(
	function (_v0, shared) {
		var model = _v0;
		var pendingChangesExists = (!model.B0) && A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$unpublishedRulesExists, model.acd));
		return _Utils_update(
			shared,
			{
				afI: pendingChangesExists ? $elm$core$Maybe$Just('You have draft changes to your coverage plan. If you would like to publish these changes, click the publish button at the bottom of the page.') : $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$Admin$CoveragePlans$Id_String$save = F2(
	function (_v0, shared) {
		var form = _v0.PB;
		return A2($author$project$Components$Admin$CoveragePlans$Form$save, form, shared);
	});
var $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Close = {$: 0};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageDocuments$UploadModal$Close);
};
var $author$project$Components$Admin$CoverageDocuments$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg,
				$author$project$Components$Admin$CoverageDocuments$UploadModal$subscriptions(model.cM)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fm)))
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$AttemptedCancel = {$: 13};
var $author$project$Components$Admin$CoverageRules$Form$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = model.aH;
	switch (_v1) {
		case 0:
			return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel);
		case 1:
			return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel);
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Admin$CoveragePlans$Rules$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, rule) {
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index),
						$author$project$Components$Admin$CoverageRules$Form$subscriptions(rule));
				}),
			model.acd));
};
var $author$project$Components$Admin$CoveragePlans$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.acd))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$subscriptions, model.L4)))
			]));
};
var $author$project$Pages$Admin$CoveragePlans$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$CoveragePlans$Form$subscriptions(model.PB));
};
var $author$project$Components$Admin$CoveragePlans$Form$AllPlans = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$PlanAdd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$PlanRemove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CoveragePlan$One$coverageDocuments = function (_v0) {
	var record = _v0.b;
	return record.L4;
};
var $author$project$Components$Admin$CoveragePlans$Form$DebounceMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$debounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(300),
	ahG: $author$project$Components$Admin$CoveragePlans$Form$DebounceMsg
};
var $author$project$Components$Admin$CoveragePlans$Form$TextDebounced = {$: 12};
var $author$project$Components$Admin$CoveragePlans$Form$debounceText = function (text) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$Admin$CoveragePlans$Form$TextDebounced;
		},
		$elm$core$Task$succeed(text));
};
var $author$project$Api$Provider$CoveragePlan$One$plans = function (_v0) {
	var record = _v0.b;
	return record.Wq;
};
var $author$project$Components$Admin$CoveragePlans$Form$formFieldsFromItem = function (coveragePlan) {
	return {
		abd: false,
		zh: $author$project$Api$Provider$CoveragePlan$One$name(coveragePlan),
		Wq: A2(
			$elm$core$List$map,
			function (plan) {
				return {
					adR: $author$project$Api$Provider$Plan$Min$id(plan),
					zh: $author$project$Api$Provider$Plan$Min$name(plan)
				};
			},
			$author$project$Api$Provider$CoveragePlan$One$plans(coveragePlan))
	};
};
var $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var plan = field.a;
				var plan_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (plan__) {
						return _Utils_eq(plan__.adR, plan.adR);
					},
					fields.Wq);
				var plans = function () {
					if (!plan_.$) {
						return fields.Wq;
					} else {
						return A2(
							$elm$core$List$cons,
							{adR: plan.adR, zh: plan.zh},
							fields.Wq);
					}
				}();
				return _Utils_update(
					fields,
					{Wq: plans});
			case 2:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						Wq: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (plan) {
								return _Utils_eq(plan.adR, id);
							},
							fields.Wq)
					});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{abd: bool});
		}
	});
var $author$project$Components$Admin$CoveragePlans$Form$NameValidation = 0;
var $author$project$Components$Admin$CoveragePlans$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Components$Admin$CoverageDocuments$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageDocument$Shared$fileName = function (_v0) {
	var record = _v0;
	return record.Pm;
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$initFormFields = function (coverageDocument) {
	if (!coverageDocument.$) {
		var coverageDocument_ = coverageDocument.a;
		return {
			adn: $elm$core$Maybe$Nothing,
			Pm: $author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument_)
		};
	} else {
		return {adn: $elm$core$Maybe$Nothing, Pm: ''};
	}
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$init = F2(
	function (coveragePlanId, coverageDocument) {
		var fields = $author$project$Components$Admin$CoverageDocuments$UploadModal$initFormFields(coverageDocument);
		return {
			p_: coverageDocument,
			wT: coveragePlanId,
			PB: $author$project$Utils$Form$init(fields),
			jY: $author$project$Api$Data$NotAsked
		};
	});
var $author$project$Components$Admin$CoverageDocuments$Form$init = F5(
	function (_v0, session, coveragePlanId, coverageDocuments, displayUploadModal) {
		return _Utils_Tuple2(
			{
				cM: A2($author$project$Components$Admin$CoverageDocuments$UploadModal$init, coveragePlanId, $elm$core$Maybe$Nothing),
				L4: coverageDocuments,
				wT: coveragePlanId,
				fm: $elm$core$Maybe$Nothing,
				io: displayUploadModal,
				ZD: session
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Admin$CoveragePlans$Form$onSaved = F3(
	function (response, model, successMsg) {
		var _v0 = model.PB;
		if (!_v0.$) {
			if (response.$ === 3) {
				var coveragePlan = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{B0: true}),
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top),
					_List_fromArray(
						[
							A2(
							$author$project$OutMsg$ShowToast,
							3,
							_Utils_ap(
								$author$project$Api$Provider$CoveragePlan$One$name(coveragePlan),
								successMsg))
						]));
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Admin$CoveragePlans$Form$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$CoveragePlan$save = F4(
	function (apiClient, maybeId, fields, toMsg) {
		var encodeCoverageRule = function (coverageRule) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.adR)),
						_Utils_Tuple2(
						'amount_in_cents',
						A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, coverageRule.I2)),
						_Utils_Tuple2(
						'time_period',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.aht)),
						_Utils_Tuple2(
						'quantity',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, coverageRule.Bd)),
						_Utils_Tuple2(
						'percentage',
						$elm$json$Json$Encode$string(coverageRule.afJ)),
						_Utils_Tuple2(
						'patient_contribution_percentage',
						$elm$json$Json$Encode$string(coverageRule.afD)),
						_Utils_Tuple2(
						'sponsor_contribution_percentage',
						$elm$json$Json$Encode$string(coverageRule.ag4)),
						_Utils_Tuple2(
						'rule_type',
						$elm$json$Json$Encode$string(coverageRule.agA)),
						_Utils_Tuple2(
						'item',
						$author$project$Utils$Encode$typedAssociation(coverageRule.FU))
					]));
		};
		var encodedCoverageRules = function () {
			if (!maybeId.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'coverage_rules',
						A2($elm$json$Json$Encode$list, encodeCoverageRule, fields.acd))
					]);
			}
		}();
		var body_ = $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(fields.zh)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'plans',
						A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Wq)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'all_plans',
							$elm$json$Json$Encode$bool(fields.abd)),
						encodedCoverageRules))));
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4(
				$author$project$Api$Data$put,
				apiClient,
				$author$project$Api$Provider$CoveragePlan$One$decoder,
				toMsg,
				A2(
					$author$project$Api$Data$requestWithJson,
					body_,
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_))));
		} else {
			return A4(
				$author$project$Api$Data$post,
				apiClient,
				$author$project$Api$Provider$CoveragePlan$One$decoder,
				toMsg,
				A2(
					$author$project$Api$Data$requestWithJson,
					body_,
					$author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlansPath)));
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$isDeleted = function (_v0) {
	var model = _v0;
	return model.aF;
};
var $author$project$Components$Admin$CoverageRules$Form$formToParams = F3(
	function (form, deleted, publishedRule) {
		var fields = $author$project$Utils$Form$fields(form);
		var itemId = function () {
			var _v5 = fields.FU;
			if (!_v5.$) {
				var item = _v5.a;
				return item.adR;
			} else {
				return '';
			}
		}();
		var percentage = $elm$core$String$fromFloat(
			A2($elm$core$Maybe$withDefault, 0.0, fields.afJ));
		var ruleType = function () {
			var _v4 = fields.agA;
			if (!_v4.$) {
				var ruleType_ = _v4.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType_));
			} else {
				return '';
			}
		}();
		var timePeriod = function () {
			var _v1 = fields.aht;
			if (!_v1.$) {
				if (!_v1.a) {
					var _v2 = _v1.a;
					return $elm$core$Maybe$Just('beginning_of_year');
				} else {
					var _v3 = _v1.a;
					return $elm$core$Maybe$Just('membership_renewal_date');
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.agA);
		var amountInCents = ((ruleType === 'included') && _Utils_eq(
			typeIncludedOption,
			$elm$core$Maybe$Just(0))) ? $elm$core$Maybe$Nothing : fields.I2;
		var _v0 = (!fields.dz) ? _Utils_Tuple2('100', '0') : _Utils_Tuple2('0', '100');
		var patientContribution = _v0.a;
		var sponsorContribution = _v0.b;
		return {
			I2: amountInCents,
			NA: deleted,
			adR: fields.adR,
			FU: {
				adR: $elm$core$Maybe$Just(itemId),
				ahI: $elm$core$Maybe$Just(fields.q9)
			},
			afD: patientContribution,
			afJ: percentage,
			Xp: publishedRule,
			Bd: fields.Bd,
			agA: ruleType,
			ag4: sponsorContribution,
			aht: timePeriod
		};
	});
var $author$project$Components$Admin$CoverageRules$Form$toParams = function (_v0) {
	var model = _v0;
	return A3($author$project$Components$Admin$CoverageRules$Form$formToParams, model.PB, model.aF, $elm$core$Maybe$Nothing);
};
var $author$project$Components$Admin$CoveragePlans$Rules$toParams = function (model) {
	var notDeletedRules = A2(
		$elm$core$List$filter,
		function (rule) {
			return !$author$project$Components$Admin$CoverageRules$Form$isDeleted(rule);
		},
		model.acd);
	return A2($elm$core$List$map, $author$project$Components$Admin$CoverageRules$Form$toParams, notDeletedRules);
};
var $author$project$Components$Admin$CoveragePlans$Form$saveCoveragePlan = F4(
	function (apiClient, maybeId, formFields, coverageRules) {
		var msg = function () {
			if (!maybeId.$) {
				return $author$project$Components$Admin$CoveragePlans$Form$Updated;
			} else {
				return $author$project$Components$Admin$CoveragePlans$Form$Created;
			}
		}();
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {
			abd: fields.abd,
			acd: $author$project$Components$Admin$CoveragePlans$Rules$toParams(coverageRules),
			zh: fields.zh,
			Wq: A2(
				$elm$core$List$map,
				function (plan) {
					return plan.adR;
				},
				fields.Wq)
		};
		return A4($author$project$Api$Provider$CoveragePlan$save, apiClient, maybeId, apiFields, msg);
	});
var $author$project$Components$Admin$CoverageDocuments$Form$DeletedCoverageDocument = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Admin$CoverageDocuments$Form$DocumentDeleted = 1;
var $author$project$Components$Admin$CoverageDocuments$Form$DocumentSaved = 2;
var $author$project$Components$Admin$CoverageDocuments$Form$None = 0;
var $author$project$Api$Provider$CoverageDocument$coverageDocumentsPath = function (coveragePlanId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['coverage_documents']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[coveragePlanId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['coverage_plans']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CoverageDocument$delete = F4(
	function (apiClient, coveragePlanId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id]),
					$author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId))));
	});
var $author$project$Api$Provider$CoverageDocument$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Closed = 0;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$File = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileNameValidation = 1;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileValidation = 0;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$None = 1;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$UploadCreated = 2;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$UploadUpdated = 3;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Created = function (a) {
	return {$: 4, a: a};
};
var $elm_community$string_extra$String$Extra$clean = function (string) {
	return $elm$core$String$trim(
		A3(
			$elm$regex$Regex$replace,
			$elm_community$string_extra$String$Extra$regexFromString('\\s\\s+'),
			$elm$core$Basics$always(' '),
			string));
};
var $author$project$Api$Data$Multipart = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Data$requestMultipartBody = F2(
	function (parts, _v0) {
		var request = _v0;
		return _Utils_update(
			request,
			{
				e5: $elm$core$Maybe$Just(
					$author$project$Api$Data$Multipart(parts))
			});
	});
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Api$Provider$CoverageDocument$createUpload = F4(
	function (apiClient, coveragePlanId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				function () {
					var _v0 = fields.adn;
					if (!_v0.$) {
						var file = _v0.a;
						return _List_fromArray(
							[
								A2($elm$http$Http$filePart, 'coverage_document[pdf_upload]', file),
								A2($elm$http$Http$stringPart, 'coverage_document[file_name]', fields.Pm)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId))));
	});
var $author$project$Components$Admin$CoverageDocuments$UploadModal$createUpload = F3(
	function (apiClient, coveragePlanId, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var file = _v0.adn;
		var fileName = _v0.Pm;
		return A4(
			$author$project$Api$Provider$CoverageDocument$createUpload,
			apiClient,
			coveragePlanId,
			{
				adn: file,
				Pm: $elm_community$string_extra$String$Extra$clean(fileName)
			},
			$author$project$Components$Admin$CoverageDocuments$UploadModal$Created);
	});
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CoverageDocument$update = F5(
	function (apiClient, coveragePlanId, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'coverage_document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'file_name',
								$elm$json$Json$Encode$string(fields.Pm))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[id]),
						$author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId)))));
	});
var $author$project$Components$Admin$CoverageDocuments$UploadModal$editUpload = F4(
	function (apiClient, coveragePlanId, coverageDocument, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var fileName = _v0.Pm;
		return A5(
			$author$project$Api$Provider$CoverageDocument$update,
			apiClient,
			coveragePlanId,
			$author$project$Api$Provider$CoverageDocument$Shared$id(coverageDocument),
			{
				Pm: $elm_community$string_extra$String$Extra$clean(fileName)
			},
			$author$project$Components$Admin$CoverageDocuments$UploadModal$Updated);
	});
var $elm$file$File$name = _File_name;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var file = field.a;
			var newFileName = $rtfeldman$elm_validate$Validate$isBlank(fields.Pm) ? A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $elm$file$File$name, file)) : fields.Pm;
			return _Utils_update(
				fields,
				{adn: file, Pm: newFileName});
		} else {
			var fileName = field.a;
			return _Utils_update(
				fields,
				{Pm: fileName});
		}
	});
var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.adn;
			},
			_Utils_Tuple2(0, 'Please select a file.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Pm;
			},
			_Utils_Tuple2(1, 'Please enter a file name.'))
		]));
var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidatorForEdit = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Pm;
			},
			_Utils_Tuple2(1, 'Please enter a file name.'))
		]));
var $author$project$Components$Admin$CoverageDocuments$UploadModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 1:
				var files = msg.a;
				var file = $elm$core$List$head(files);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate,
					$author$project$Components$Admin$CoverageDocuments$UploadModal$File(file),
					model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 3:
				var _v2 = function () {
					var _v3 = model.p_;
					if (!_v3.$) {
						var coverageDocument_ = _v3.a;
						return _Utils_Tuple2(
							A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidatorForEdit, model.PB),
							A3($author$project$Components$Admin$CoverageDocuments$UploadModal$editUpload, apiClient, model.wT, coverageDocument_));
					} else {
						return _Utils_Tuple2(
							A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidator, model.PB),
							A2($author$project$Components$Admin$CoverageDocuments$UploadModal$createUpload, apiClient, model.wT));
					}
				}();
				var formValidationResult = _v2.a;
				var cmdToExecute = _v2.b;
				if (!formValidationResult.$) {
					var _v5 = formValidationResult.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return {
						EC: cmdToExecute(validFormFields),
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm, jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = formValidationResult.a;
					var errorList = A2(
						$elm$core$List$append,
						A2($author$project$Utils$Form$validationErrors, 1, newForm),
						A2($author$project$Utils$Form$validationErrors, 0, newForm));
					var errorMsg = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(errorList));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, errorMsg)
							])
					};
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Document successfully uploaded.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 3,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Document successfully updated.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Admin$CoverageDocuments$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var coverageDocument = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple2(coverageDocument, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 1:
				var coverageDocument = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					EC: A4(
						$author$project$Api$Provider$CoverageDocument$delete,
						apiClient,
						model.wT,
						$author$project$Api$Provider$CoverageDocument$Shared$id(coverageDocument),
						$author$project$Components$Admin$CoverageDocuments$Form$DeletedCoverageDocument(coverageDocument)),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple2(coverageDocument, $author$project$Api$Data$Loading))
						}),
					as: _List_Nil
				} : {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{fm: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 2:
				var coverageDocument = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Document removed')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								fm: $elm$core$Maybe$Just(
									_Utils_Tuple2(coverageDocument, response))
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var subMsg = msg.a;
				var uploadModalResult = A3($author$project$Components$Admin$CoverageDocuments$UploadModal$update, apiClient, subMsg, model.cM);
				var _v3 = uploadModalResult.ac5;
				switch (_v3) {
					case 0:
						return {
							EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.EC),
							ac5: 0,
							y8: _Utils_update(
								model,
								{cM: uploadModalResult.y8, io: false}),
							as: uploadModalResult.as
						};
					case 1:
						return {
							EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.EC),
							ac5: 0,
							y8: _Utils_update(
								model,
								{cM: uploadModalResult.y8}),
							as: uploadModalResult.as
						};
					case 2:
						return {
							EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.EC),
							ac5: 2,
							y8: _Utils_update(
								model,
								{cM: uploadModalResult.y8, io: false}),
							as: uploadModalResult.as
						};
					default:
						return {
							EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.EC),
							ac5: 2,
							y8: _Utils_update(
								model,
								{cM: uploadModalResult.y8, io: false}),
							as: uploadModalResult.as
						};
				}
			default:
				var coverageDocument = msg.a;
				var newModdal = A2(
					$author$project$Components$Admin$CoverageDocuments$UploadModal$init,
					model.wT,
					$elm$core$Maybe$Just(coverageDocument));
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{cM: newModdal, io: true}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$Editing = 1;
var $author$project$Components$Admin$CoverageRules$Form$Id = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$ItemAdd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Restored = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$RuleTypeSelectMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$RuleTypeUpdate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Deleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$Provider$CoverageRule$coverageRulesPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['coverage_rules']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['coverage_plans']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CoverageRule$coverageRulePath = F2(
	function (coveragePlanId, coverageRuleId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[coverageRuleId]),
			$author$project$Api$Provider$CoverageRule$coverageRulesPath(coveragePlanId));
	});
var $author$project$Api$Provider$CoverageRule$delete = F4(
	function (apiClient, coveragePlanId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_)));
	});
var $author$project$Api$Provider$CoverageRule$unpublish = F4(
	function (apiClient, coveragePlanId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unpublish']),
					A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
	});
var $author$project$Components$Admin$CoverageRules$Form$deleteRule = F4(
	function (apiClient, model, coveragePlanId, coverageRuleId) {
		var fields = $author$project$Utils$Form$fields(model.PB);
		var _v0 = fields.adR;
		if (!_v0.$) {
			var id_ = _v0.a;
			return (model.cd || (!_Utils_eq(coverageRuleId, id_))) ? A4(
				$author$project$Api$Provider$CoverageRule$delete,
				apiClient,
				coveragePlanId,
				coverageRuleId,
				$author$project$Components$Admin$CoverageRules$Form$Deleted(coverageRuleId)) : A4(
				$author$project$Api$Provider$CoverageRule$unpublish,
				apiClient,
				coveragePlanId,
				coverageRuleId,
				$author$project$Components$Admin$CoverageRules$Form$Deleted(coverageRuleId));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$ruleTypeId = function (ruleType) {
	if (!ruleType.$) {
		var ruleTypeOption = ruleType.a;
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleTypeOption));
	} else {
		return '';
	}
};
var $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate = F2(
	function (field, form) {
		switch (field.$) {
			case 0:
				var id = field.a;
				return _Utils_update(
					form,
					{adR: id});
			case 1:
				var ruleTypeOption = field.a;
				var timePeriod = ($author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleTypeOption) === 'limited_quantity') ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing;
				var itemType = ($author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleTypeOption) === 'limited_quantity') ? 'charge_item' : form.q9;
				return _Utils_update(
					form,
					{q9: itemType, agA: ruleTypeOption, aht: timePeriod});
			case 6:
				var coveredBy = field.a;
				return _Utils_update(
					form,
					{dz: coveredBy});
			case 7:
				var timePeriod = field.a;
				return _Utils_update(
					form,
					{
						aht: $elm$core$Maybe$Just(timePeriod)
					});
			case 8:
				var quantity = field.a;
				return _Utils_update(
					form,
					{
						Bd: $elm$core$String$toInt(quantity)
					});
			case 3:
				var amountInCents = field.a;
				return _Utils_update(
					form,
					{I2: amountInCents});
			case 4:
				var percentage = field.a;
				return _Utils_update(
					form,
					{
						afJ: $elm$core$String$toFloat(percentage)
					});
			case 2:
				var item = field.a;
				return _Utils_update(
					form,
					{FU: item});
			default:
				var itemType = field.a;
				return _Utils_update(
					form,
					{FU: $elm$core$Maybe$Nothing, q9: itemType});
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$RuleTypeValidation = 0;
var $author$project$Components$Admin$CoverageRules$Form$AmountInCentsValidation = 4;
var $author$project$Components$Admin$CoverageRules$Form$validateAmountInCents = function (_v0) {
	var ruleType = _v0.agA;
	var amountInCents = _v0.I2;
	var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, ruleType);
	var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
	var isUnderPriceIncluded = (typeId === 'included') && _Utils_eq(
		typeIncludedOption,
		$elm$core$Maybe$Just(1));
	var isRequired = isUnderPriceIncluded || ((typeId === 'flat_amount') || (typeId === 'surcharge'));
	return A2(
		$author$project$Utils$Validate$isInvalidCurrency,
		{
			abi: !isRequired,
			yQ: $elm$core$Maybe$Nothing,
			TZ: $elm$core$Maybe$Just(0)
		},
		amountInCents) ? _List_fromArray(
		[
			_Utils_Tuple2(4, 'Please enter a valid amount.')
		]) : _List_Nil;
};
var $author$project$Components$Admin$CoverageRules$Form$CategoryValidation = 2;
var $author$project$Components$Admin$CoverageRules$Form$ChargeItemValidation = 1;
var $author$project$Components$Admin$CoverageRules$Form$ItemTypeValidation = 3;
var $author$project$Components$Admin$CoverageRules$Form$validateForm = function (form) {
	var _v0 = _Utils_Tuple2(form.q9, form.FU);
	_v0$3:
	while (true) {
		if (_v0.b.$ === 1) {
			switch (_v0.a) {
				case 'charge_category':
					var _v1 = _v0.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(2, 'Please pick a category.')
						]);
				case 'charge_item':
					var _v2 = _v0.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(1, 'Please pick a charge item.')
						]);
				case '':
					var _v3 = _v0.b;
					return _List_fromArray(
						[
							_Utils_Tuple2(3, 'Please pick a category or item.')
						]);
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return _List_Nil;
};
var $author$project$Components$Admin$CoverageRules$Form$PercentageValidation = 6;
var $author$project$Components$Admin$CoverageRules$Form$validatePercentage = function (_v0) {
	var ruleType = _v0.agA;
	var percentage = _v0.afJ;
	var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
	var _v1 = _Utils_Tuple2(typeId, percentage);
	if ((_v1.a === 'discounted') && (_v1.b.$ === 1)) {
		var _v2 = _v1.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(6, 'Please pick a valid quantity.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$CoverageRules$Form$QuantityValidation = 5;
var $author$project$Components$Admin$CoverageRules$Form$validateQuantity = function (_v0) {
	var ruleType = _v0.agA;
	var quantity = _v0.Bd;
	var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
	var _v1 = _Utils_Tuple2(typeId, quantity);
	if ((_v1.a === 'limited_quantity') && (_v1.b.$ === 1)) {
		var _v2 = _v1.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(5, 'Please pick a valid quantity.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$CoverageRules$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.agA;
			},
			_Utils_Tuple2(0, 'Please pick a coverage rule.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateAmountInCents),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateQuantity),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validatePercentage),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateForm)
		]));
var $author$project$Components$ResourceFilter$ChargeItem$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bb);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bb: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Provider$CoverageRule$publish = F4(
	function (apiClient, coveragePlanId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['publish']),
					A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
	});
var $author$project$Components$Admin$CoverageRules$Form$GotChargeItem = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$formChanged = F2(
	function (form, updatedForm) {
		var unpublishedFields = $author$project$Utils$Form$fields(updatedForm);
		var publishedFields = $author$project$Utils$Form$fields(form);
		var original = _Utils_update(
			publishedFields,
			{adR: $elm$core$Maybe$Nothing});
		var changed = _Utils_update(
			unpublishedFields,
			{adR: $elm$core$Maybe$Nothing});
		return !_Utils_eq(original, changed);
	});
var $author$project$Api$Provider$CoverageRule$save = F5(
	function (apiClient, coveragePlanId, maybeId, coverageRule, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.adR)),
					_Utils_Tuple2(
					'amount_in_cents',
					A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, coverageRule.I2)),
					_Utils_Tuple2(
					'percentage',
					$elm$json$Json$Encode$string(coverageRule.afJ)),
					_Utils_Tuple2(
					'time_period',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.aht)),
					_Utils_Tuple2(
					'quantity',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, coverageRule.Bd)),
					_Utils_Tuple2(
					'patient_contribution_percentage',
					$elm$json$Json$Encode$string(coverageRule.afD)),
					_Utils_Tuple2(
					'sponsor_contribution_percentage',
					$elm$json$Json$Encode$string(coverageRule.ag4)),
					_Utils_Tuple2(
					'rule_type',
					$elm$json$Json$Encode$string(coverageRule.agA)),
					_Utils_Tuple2(
					'item',
					$author$project$Utils$Encode$typedAssociation(coverageRule.FU)),
					_Utils_Tuple2(
					'published_rule',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.Xp))
							])))
				]));
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4(
				$author$project$Api$Data$put,
				apiClient,
				$author$project$Api$Provider$CoverageRule$One$decoder,
				toMsg,
				A2(
					$author$project$Api$Data$requestWithJson,
					body,
					$author$project$Api$Data$requestTo(
						A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
		} else {
			return A4(
				$author$project$Api$Data$post,
				apiClient,
				$author$project$Api$Provider$CoverageRule$One$decoder,
				toMsg,
				A2(
					$author$project$Api$Data$requestWithJson,
					body,
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$CoverageRule$coverageRulesPath(coveragePlanId))));
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$saveOrDeleteUnpublishedRule = F3(
	function (apiClient, model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = _Utils_Tuple2(model.wT, model.L);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var coveragePlanId = _v0.a.a;
					var unpublishedForm = _v0.b.a;
					var unpublishedFields = $author$project$Utils$Form$fields(unpublishedForm);
					var fieldsChanged = A2($author$project$Components$Admin$CoverageRules$Form$formChanged, model.PB, unpublishedForm);
					var revertedChanges = (!fieldsChanged) && ((!_Utils_eq(unpublishedFields.adR, $elm$core$Maybe$Nothing)) && (!model.cd));
					var cmd = function () {
						if (revertedChanges) {
							return A4(
								$author$project$Components$Admin$CoverageRules$Form$deleteRule,
								apiClient,
								model,
								coveragePlanId,
								A2($elm$core$Maybe$withDefault, '', unpublishedFields.adR));
						} else {
							if (fieldsChanged) {
								var coverageRule = A3(
									$author$project$Components$Admin$CoverageRules$Form$formToParams,
									form,
									model.aF,
									$author$project$Utils$Form$fields(model.PB).adR);
								return A5($author$project$Api$Provider$CoverageRule$save, apiClient, coveragePlanId, fields.adR, coverageRule, $author$project$Components$Admin$CoverageRules$Form$Updated);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}
					}();
					return _Utils_Tuple3(model, cmd, _List_Nil);
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var unpublishedForm = _v0.b.a;
					var _v2 = function () {
						var _v3 = fields.FU;
						if (!_v3.$) {
							var item = _v3.a;
							return (fields.q9 === 'charge_item') ? _Utils_Tuple2(
								A3($author$project$Api$Provider$ChargeItem$retrieve, apiClient, item.adR, $author$project$Components$Admin$CoverageRules$Form$GotChargeItem),
								$elm$core$Maybe$Nothing) : _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(
									{adR: item.adR, zh: item.zh}));
						} else {
							return _Utils_Tuple2($elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						}
					}();
					var cmd = _v2.a;
					var category_ = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ex: category_, aH: 2, PB: unpublishedForm, L: $elm$core$Maybe$Nothing}),
						cmd,
						_List_Nil);
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Components$Admin$CoverageRules$Form$searchRuleTypes = function (query) {
	return A2(
		$elm$core$List$filter,
		function (option) {
			var ruleType = option;
			return A2($elm$core$String$contains, query, ruleType.zh);
		},
		$author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions);
};
var $author$project$Components$Admin$CoverageRules$Form$updateForms = F2(
	function (model, field) {
		var updateField = function (form) {
			return A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate, field, form);
		};
		if (model.aH === 2) {
			return _Utils_update(
				model,
				{
					PB: updateField(model.PB)
				});
		} else {
			var initEditForm = function () {
				var _v0 = model.L;
				if (!_v0.$) {
					var editForm = _v0.a;
					return editForm;
				} else {
					var idUpdate = model.cd ? $author$project$Components$Admin$CoverageRules$Form$Id(
						$author$project$Utils$Form$fields(model.PB).adR) : $author$project$Components$Admin$CoverageRules$Form$Id($elm$core$Maybe$Nothing);
					return A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate, idUpdate, model.PB);
				}
			}();
			var updatedForm = updateField(initEditForm);
			return _Utils_update(
				model,
				{
					L: $elm$core$Maybe$Just(updatedForm)
				});
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 3:
				var field = msg.a;
				var updatedForm = A2($author$project$Components$Admin$CoverageRules$Form$updateForms, model, field);
				var _v2 = A3(
					$author$project$Components$ResourceFilter$ChargeItem$init,
					apiClient,
					function (opts) {
						return _Utils_update(
							opts,
							{
								q9: $elm$core$Maybe$Just('item')
							});
					},
					function (d) {
						return _Utils_update(
							d,
							{D0: 'Select a Charge Item'});
					});
				var chargeItemResourceFilter = _v2.a;
				var chargeItemResourceFilterCmd = _v2.b;
				var _v3 = A3(
					$author$project$Components$ResourceFilter$Category$init,
					apiClient,
					model.ZD,
					function (d) {
						return _Utils_update(
							d,
							{D0: 'Select a Category'});
					});
				var categoryResourceFilter = _v3.a;
				var categoryResourceFilterCmd = _v3.b;
				var _v4 = function () {
					if (field.$ === 5) {
						return _Utils_Tuple2(
							_Utils_update(
								updatedForm,
								{cJ: categoryResourceFilter, cK: chargeItemResourceFilter}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd)
									])));
					} else {
						return _Utils_Tuple2(updatedForm, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(newModel, cmd, _List_Nil);
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					var chargeItem = response.a;
					var _v7 = $author$project$Api$Provider$ChargeItem$One$category(chargeItem);
					if (!_v7.$) {
						var oneCategory = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Ex: $elm$core$Maybe$Just(
										{
											adR: $author$project$Api$Provider$Category$Shared$id(oneCategory),
											zh: $author$project$Api$Provider$Category$Shared$name(oneCategory)
										})
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 4:
				var _v8 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Admin$CoverageRules$Form$formFieldsValidator,
					A2($elm$core$Maybe$withDefault, model.PB, model.L));
				if (!_v8.$) {
					var _v9 = _v8.a;
					var form = _v9.a;
					return A3($author$project$Components$Admin$CoverageRules$Form$saveOrDeleteUnpublishedRule, apiClient, model, form);
				} else {
					var form = _v8.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L: $elm$core$Maybe$Just(form)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 6:
				var resourceFilterPreSelectCmd = function () {
					var _v12 = model.L6;
					if (!_v12.$) {
						var coverageRule = _v12.a;
						return A2(
							$elm$core$Task$perform,
							$author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected,
							$elm$core$Task$succeed(coverageRule));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v10 = A3(
					$author$project$Components$ResourceFilter$ChargeItem$init,
					apiClient,
					function (opts) {
						return _Utils_update(
							opts,
							{
								q9: $elm$core$Maybe$Just('item')
							});
					},
					function (d) {
						return _Utils_update(
							d,
							{D0: 'Select a Charge Item'});
					});
				var chargeItemResourceFilter = _v10.a;
				var chargeItemResourceFilterCmd = _v10.b;
				var _v11 = A3(
					$author$project$Components$ResourceFilter$Category$init,
					apiClient,
					model.ZD,
					function (d) {
						return _Utils_update(
							d,
							{D0: 'Select a Category'});
					});
				var categoryResourceFilter = _v11.a;
				var categoryResourceFilterCmd = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cJ: categoryResourceFilter, cK: chargeItemResourceFilter, aH: 1}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
								resourceFilterPreSelectCmd
							])),
					_List_Nil);
			case 7:
				var maybeCoverageRuleId = msg.a;
				var deleted = _Utils_eq(model.wT, $elm$core$Maybe$Nothing) && _Utils_eq(maybeCoverageRuleId, $elm$core$Maybe$Nothing);
				var cmd = function () {
					var _v13 = _Utils_Tuple2(model.wT, maybeCoverageRuleId);
					if ((!_v13.a.$) && (!_v13.b.$)) {
						var coveragePlanId = _v13.a.a;
						var coverageRuleId = _v13.b.a;
						return A4($author$project$Components$Admin$CoverageRules$Form$deleteRule, apiClient, model, coveragePlanId, coverageRuleId);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aF: deleted, L: $elm$core$Maybe$Nothing}),
					cmd,
					_List_Nil);
			case 0:
				var selectMsg = msg.a;
				var _v14 = A2($author$project$Ui$Form$SearchableSelect$update, selectMsg, model.n4);
				var selectModel = _v14.a;
				var selectCmd = _v14.b;
				var event = _v14.c;
				var modelAfterEvent = function () {
					_v15$2:
					while (true) {
						if (!event.$) {
							switch (event.a.$) {
								case 0:
									var ruleType = event.a.a;
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$RuleTypeUpdate(ruleType));
								case 1:
									var string = event.a.a;
									return _Utils_update(
										model,
										{
											BY: $author$project$Components$Admin$CoverageRules$Form$searchRuleTypes(string)
										});
								default:
									break _v15$2;
							}
						} else {
							break _v15$2;
						}
					}
					return model;
				}();
				return _Utils_Tuple3(
					_Utils_update(
						modelAfterEvent,
						{n4: selectModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$RuleTypeSelectMsg, selectCmd),
					_List_Nil);
			case 5:
				var coverageRule = msg.a;
				var _v16 = $author$project$Api$Provider$CoverageRule$One$item(coverageRule);
				if (_v16.$ === 1) {
					var category_ = _v16.a;
					var _v17 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$Category$extraItems(
							_List_fromArray(
								[
									{
									adR: $author$project$Api$Provider$Category$Shared$id(category_),
									zh: $author$project$Api$Provider$Category$Shared$name(category_)
								}
								])),
						A2(
							$author$project$Components$ResourceFilter$Category$preSelectedId,
							$elm$core$Maybe$Just(
								$author$project$Api$Provider$Category$Shared$id(category_)),
							model.cJ));
					var categoryResourceFilter = _v17.a;
					var categoryResourceFilterCmd = _v17.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cJ: categoryResourceFilter}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						_List_Nil);
				} else {
					var chargeItem = _v16.a;
					var _v18 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$ChargeItem$extraItems(
							_List_fromArray(
								[
									{
									adR: $author$project$Api$Provider$ChargeItem$Shared$id(chargeItem),
									zh: $author$project$Api$Provider$ChargeItem$Shared$name(chargeItem)
								}
								])),
						A2(
							$author$project$Components$ResourceFilter$ChargeItem$preSelectedId,
							$elm$core$Maybe$Just(
								$author$project$Api$Provider$ChargeItem$Shared$id(chargeItem)),
							model.cK));
					var chargeItemResourceFilter = _v18.a;
					var chargeItemResourceFilterCmd = _v18.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cK: chargeItemResourceFilter}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						_List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cJ);
				var newModelForms = function () {
					var _v19 = categoryResourceResult.ac5;
					_v19$2:
					while (true) {
						if ((!_v19.$) && (!_v19.a.$)) {
							switch (_v19.a.a.$) {
								case 0:
									var category_ = _v19.a.a.a;
									var item = $elm$core$Maybe$Just(
										{adR: category_.adR, zh: category_.zh});
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
								case 4:
									var preSelectedItem = _v19.a.a.a;
									var item = $elm$core$Maybe$Just(
										{adR: preSelectedItem.aaN, zh: preSelectedItem.aej});
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
								default:
									break _v19$2;
							}
						} else {
							break _v19$2;
						}
					}
					return model;
				}();
				var newModel = _Utils_update(
					newModelForms,
					{cJ: categoryResourceResult.y8});
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceResult.EC),
					categoryResourceResult.as);
			case 2:
				var subMsg = msg.a;
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cK);
				var newModelForms = function () {
					var _v20 = chargeItemResourceResult.ac5;
					_v20$2:
					while (true) {
						if ((!_v20.$) && (!_v20.a.$)) {
							switch (_v20.a.a.$) {
								case 0:
									var chargeItem = _v20.a.a.a;
									var item = $elm$core$Maybe$Just(
										{adR: chargeItem.adR, zh: chargeItem.zh});
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
								case 4:
									var preSelectedItem = _v20.a.a.a;
									var item = $elm$core$Maybe$Just(
										{adR: preSelectedItem.aaN, zh: preSelectedItem.aej});
									return A2(
										$author$project$Components$Admin$CoverageRules$Form$updateForms,
										model,
										$author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
								default:
									break _v20$2;
							}
						} else {
							break _v20$2;
						}
					}
					return model;
				}();
				var newModel = _Utils_update(
					newModelForms,
					{cK: chargeItemResourceResult.y8});
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.EC),
					chargeItemResourceResult.as);
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var coverageRule = response.a;
					var _v22 = model.L;
					if (!_v22.$) {
						var editedForm_ = _v22.a;
						var updatedForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate,
							$author$project$Components$Admin$CoverageRules$Form$Id(
								$elm$core$Maybe$Just(
									$author$project$Api$Provider$CoverageRule$One$id(coverageRule))),
							editedForm_);
						var newModel = _Utils_update(
							model,
							{aH: 2});
						var coverageRuleCategory = A2(
							$elm$core$Maybe$map,
							function (category_) {
								return {
									adR: $author$project$Api$Provider$Category$Min$id(category_),
									zh: $author$project$Api$Provider$Category$Min$name(category_)
								};
							},
							$author$project$Api$Provider$CoverageRule$One$category(coverageRule));
						return model.cd ? _Utils_Tuple3(
							_Utils_update(
								newModel,
								{Ex: coverageRuleCategory, PB: updatedForm, cd: true, L: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil) : _Utils_Tuple3(
							_Utils_update(
								newModel,
								{
									Ex: coverageRuleCategory,
									L: $elm$core$Maybe$Just(updatedForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var id_ = msg.a;
				var response = msg.b;
				var publishedFields = $author$project$Utils$Form$fields(model.PB);
				var _v23 = _Utils_Tuple2(response, publishedFields.adR);
				if ((_v23.a.$ === 3) && (!_v23.b.$)) {
					var _v24 = _v23.a;
					var coverageRuleId = _v23.b.a;
					if (_Utils_eq(coverageRuleId, id_)) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aF: true}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var _v25 = model.L;
						if (!_v25.$) {
							var editedForm_ = _v25.a;
							var unpublishedFields = $author$project$Utils$Form$fields(editedForm_);
							return _Utils_eq(
								A2($elm$core$Maybe$withDefault, '', unpublishedFields.adR),
								id_) ? _Utils_Tuple3(
								_Utils_update(
									model,
									{L: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								_List_Nil) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						}
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var coverageRuleId = msg.a;
				var cmd = function () {
					var _v26 = model.wT;
					if (!_v26.$) {
						var coveragePlanId = _v26.a;
						return A4($author$project$Api$Provider$CoverageRule$publish, apiClient, coveragePlanId, coverageRuleId, $author$project$Components$Admin$CoverageRules$Form$Restored);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 11:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aF: false}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var _v27 = model.aH;
				switch (_v27) {
					case 0:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aF: true, aH: 2}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aH: 2, L: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Admin$CoveragePlans$Rules$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var index = msg.a;
			var subMsg = msg.b;
			var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, model.acd);
			if (!_v1.$) {
				var coverageRuleForm = _v1.a;
				var _v2 = A3($author$project$Components$Admin$CoverageRules$Form$update, apiClient, subMsg, coverageRuleForm);
				var updatedCoverageRuleForm = _v2.a;
				var subCmd = _v2.b;
				var subOutMsg = _v2.c;
				var coverageRules = A3($elm_community$list_extra$List$Extra$setAt, index, updatedCoverageRuleForm, model.acd);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{acd: coverageRules}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index),
						subCmd),
					subOutMsg);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var _v3 = A6(
				$author$project$Components$Admin$CoverageRules$Form$init,
				apiClient,
				model.ZD,
				$elm$core$Maybe$Nothing,
				model.wT,
				{XO: model.XO},
				$elm$core$Maybe$Nothing);
			var newForm = _v3.a;
			var cmd = _v3.b;
			var coverageRules = _Utils_ap(
				model.acd,
				_List_fromArray(
					[newForm]));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{acd: coverageRules}),
				A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(
						$elm$core$List$length(model.acd)),
					cmd),
				_List_Nil);
		}
	});
var $author$project$Api$Pagination$withTotalCount = F2(
	function (totalCount, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{oN: totalCount});
	});
var $author$project$Components$Admin$CoveragePlans$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var coveragePlan = response.a;
					var _v3 = A6(
						$author$project$Components$Admin$CoveragePlans$Rules$init,
						apiClient,
						model.ZD,
						model.adR,
						$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan),
						$elm$core$Maybe$Nothing,
						{XO: false});
					var coverageRules = _v3.a;
					var coverateRulesCmd = _v3.b;
					var _v4 = A5(
						$author$project$Components$Admin$CoverageDocuments$Form$init,
						apiClient,
						model.ZD,
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan),
						$author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan),
						false);
					var coverageDocuments = _v4.a;
					var coverageDocumentsCmd = _v4.b;
					var cmd = $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverateRulesCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, coverageDocumentsCmd)
							]));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L4: $elm$core$Maybe$Just(coverageDocuments),
								L5: $elm$core$Maybe$Just(coveragePlan),
								acd: $elm$core$Maybe$Just(coverageRules),
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$CoveragePlans$Form$formFieldsFromItem(coveragePlan)))
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var field = msg.a;
				var _v5 = model.PB;
				if (!_v5.$) {
					var form = _v5.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v6 = _Utils_Tuple2(model.PB, model.acd);
				if ((!_v6.a.$) && (!_v6.b.$)) {
					var form = _v6.a.a;
					var coverageRules = _v6.b.a;
					var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoveragePlans$Form$formFieldsValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var newForm = _v8.a;
						var validFormFields = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							A4($author$project$Components$Admin$CoveragePlans$Form$saveCoveragePlan, apiClient, model.adR, validFormFields, coverageRules),
							_List_Nil);
					} else {
						var newForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				return A3($author$project$Components$Admin$CoveragePlans$Form$onSaved, response, model, ' was successfully created.');
			case 4:
				var response = msg.a;
				return A3($author$project$Components$Admin$CoveragePlans$Form$onSaved, response, model, ' was successfully updated.');
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var plans = response.a;
					var headers = response.b;
					var totalCount = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$String$toInt,
							A2($elm$core$Dict$get, 'x-total-count', headers)));
					var planRecords = A2(
						$elm$core$List$map,
						function (plan) {
							return {
								adR: $author$project$Api$Provider$Plan$All$id(plan),
								zh: $author$project$Api$Provider$Plan$All$name(plan)
							};
						},
						plans);
					var pagination = A2($author$project$Api$Pagination$withTotalCount, totalCount, model.afy);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: pagination,
								go: _Utils_ap(model.go, planRecords),
								Wq: response
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Wq: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var allPlans = msg.a;
				var _v10 = model.PB;
				if (!_v10.$) {
					var form = _v10.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate,
						$author$project$Components$Admin$CoveragePlans$Form$AllPlans(allPlans),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								sD: allPlans
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var plan = msg.a;
				var enabled = msg.b;
				var newForm = enabled ? A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate,
						$author$project$Components$Admin$CoveragePlans$Form$PlanAdd(plan)),
					model.PB) : A2(
					$elm$core$Maybe$map,
					A2(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate,
						$author$project$Components$Admin$CoveragePlans$Form$PlanRemove(plan.adR)),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, newModel),
					_List_Nil);
			case 13:
				var subMsg = msg.a;
				var _v11 = model.acd;
				if (!_v11.$) {
					var coverageRules = _v11.a;
					var _v12 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, coverageRules);
					var newCoverageRulesForm = _v12.a;
					var coverageRulesCmd = _v12.b;
					var coverageRulesOutMsgs = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								acd: $elm$core$Maybe$Just(newCoverageRulesForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverageRulesCmd),
						coverageRulesOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var query = msg.a;
				var _v13 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$CoveragePlans$Form$debounceConfig, query, model.h4);
				var debounce = _v13.a;
				var cmd = _v13.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							h4: debounce,
							r6: $elm$core$Maybe$Just(query)
						}),
					cmd,
					_List_Nil);
			case 11:
				var dMsg = msg.a;
				var _v14 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Admin$CoveragePlans$Form$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$CoveragePlans$Form$debounceText),
					dMsg,
					model.h4);
				var debounce = _v14.a;
				var cmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h4: debounce}),
					cmd,
					_List_Nil);
			case 12:
				var newModel = _Utils_update(
					model,
					{afy: $author$project$Components$Admin$CoveragePlans$Form$initPagination, go: _List_Nil});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, newModel),
					_List_Nil);
			case 14:
				var _v15 = model.L5;
				if (!_v15.$) {
					var coveragePlan_ = _v15.a;
					var _v16 = A5(
						$author$project$Components$Admin$CoverageDocuments$Form$init,
						apiClient,
						model.ZD,
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_),
						$author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan_),
						true);
					var coverageDocumentForm = _v16.a;
					var coverageDocumentsCmd = _v16.b;
					var newModel = _Utils_update(
						model,
						{
							L4: $elm$core$Maybe$Just(coverageDocumentForm)
						});
					return _Utils_Tuple3(
						newModel,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, coverageDocumentsCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v17 = model.L4;
				if (!_v17.$) {
					var coverageDocuments_ = _v17.a;
					var result = A3($author$project$Components$Admin$CoverageDocuments$Form$update, apiClient, subMsg, coverageDocuments_);
					var retrievePlan = function () {
						var _v18 = _Utils_Tuple2(model.adR, result.ac5);
						_v18$2:
						while (true) {
							if (!_v18.a.$) {
								switch (_v18.b) {
									case 1:
										var id_ = _v18.a.a;
										var _v19 = _v18.b;
										return A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
									case 2:
										var id_ = _v18.a.a;
										var _v20 = _v18.b;
										return A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
									default:
										break _v18$2;
								}
							} else {
								break _v18$2;
							}
						}
						return $elm$core$Platform$Cmd$none;
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L4: $elm$core$Maybe$Just(result.y8)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, result.EC),
									retrievePlan
								])),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$CoveragePlans$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$CoveragePlans$Form$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Admin$CoveragePlans$Form$AttemptedSubmit = {$: 2};
var $author$project$Components$Admin$CoveragePlans$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoveragePlans$Form$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$category = function (_v0) {
	var model = _v0;
	return model.Ex;
};
var $author$project$Components$Admin$CoveragePlans$Rules$allCategories = function (coverageRuleFormsWithIndex) {
	return A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.zh;
		},
		A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function ($) {
				return $.adR;
			},
			A2(
				$elm$core$List$filterMap,
				$author$project$Components$Admin$CoverageRules$Form$category,
				A2(
					$elm$core$List$map,
					function (tuple) {
						return tuple.a;
					},
					coverageRuleFormsWithIndex))));
};
var $author$project$Components$Admin$CoverageRules$Form$isReallyDeleted = function (_v0) {
	var model = _v0;
	return model.aF && (_Utils_eq(model.wT, $elm$core$Maybe$Nothing) || model.cd);
};
var $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleAdded = {$: 1};
var $author$project$Components$Admin$CoveragePlans$Rules$viewAddCoverageRuleButton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Add coverage rule'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleAdded),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Coverage Rule')
				]))
		]));
var $author$project$Ui$ListGroup$Header = 4;
var $author$project$Components$Admin$CoveragePlans$Rules$isRuleInCategory = F2(
	function (ruleForm, categoryId) {
		var _v0 = $author$project$Components$Admin$CoverageRules$Form$category(ruleForm);
		if (!_v0.$) {
			var cat = _v0.a;
			return _Utils_eq(cat.adR, categoryId);
		} else {
			return false;
		}
	});
var $author$project$Ui$ListGroup$Style = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ListGroup$style = $author$project$Ui$ListGroup$Style;
var $author$project$Components$Admin$CoverageRules$Form$AttemptedSubmit = {$: 4};
var $author$project$Components$Admin$CoverageRules$Form$editingForm = function (model) {
	var _v0 = model.L;
	if (!_v0.$) {
		var editedForm = _v0.a;
		return editedForm;
	} else {
		return model.PB;
	}
};
var $author$project$Components$Admin$CoverageRules$Form$AmountInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$Percentage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewAmountOrPercentageInput = F2(
	function (fields, form) {
		var _v0 = fields.agA;
		if (!_v0.$) {
			var ruleType = _v0.a;
			var currencyInput = A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label('Amount')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$CurrencyInput$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$value(fields.I2),
								$author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
								$author$project$Ui$Form$CurrencyInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
								$author$project$Ui$Form$CurrencyInput$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$AmountInCents))
							]))
					]));
			var _v1 = $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType);
			_v1$4:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a) {
						case 'flat_amount':
							return currencyInput;
						case 'surcharge':
							return currencyInput;
						case 'discounted':
							return A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(3),
										$author$project$Ui$Form$Group$inputSpanSm(9),
										$author$project$Ui$Form$Group$label('Percentage')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$group(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														$elm$core$String$fromFloat(
															A2($elm$core$Maybe$withDefault, 0, fields.afJ))),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$Percentage)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 6, form))
													])),
												$author$project$Ui$Form$Input$addon(
												_List_fromArray(
													[
														$elm$html$Html$text('%')
													]))
											]))
									]));
						case 'included':
							var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.agA);
							return _Utils_eq(
								typeIncludedOption,
								$elm$core$Maybe$Just(1)) ? currencyInput : $author$project$Utils$Html$empty;
						default:
							break _v1$4;
					}
				} else {
					break _v1$4;
				}
			}
			return $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$viewCategoryResourceFilter = F2(
	function (categoryResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Category$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, form))
					]),
				categoryResourceFilter));
	});
var $author$project$Components$Admin$CoverageRules$Form$viewChargeItemResourceFilter = F2(
	function (chargeItemResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$ChargeItem$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form))
					]),
				chargeItemResourceFilter));
	});
var $author$project$Components$Admin$CoverageRules$Form$viewChargeItemOrCategoryFilter = F3(
	function (model, form, isEditing) {
		var fields = $author$project$Utils$Form$fields(form);
		var isCategory = fields.q9 === 'charge_category';
		var chargeLabel = isCategory ? 'Charge category' : 'Charge Item';
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label(chargeLabel)
				]),
			_List_fromArray(
				[
					isEditing ? (isCategory ? A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Category$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(isEditing)
							]),
						model.cJ)) : A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$ChargeItem$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(isEditing)
							]),
						model.cK))) : (isCategory ? A2($author$project$Components$Admin$CoverageRules$Form$viewCategoryResourceFilter, model.cJ, form) : A2($author$project$Components$Admin$CoverageRules$Form$viewChargeItemResourceFilter, model.cK, form))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$CoveredBy = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewCoveredBy = function (coveredBy) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Amount Due Paid For By')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Radio$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Radio$value(!coveredBy),
								$author$project$Ui$Form$Radio$onCheck(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
									$elm$core$Basics$always(
										$author$project$Components$Admin$CoverageRules$Form$CoveredBy(0))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Patient')
							])),
						A2(
						$author$project$Ui$Form$Radio$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Radio$value(coveredBy === 1),
								$author$project$Ui$Form$Radio$onCheck(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
									$elm$core$Basics$always(
										$author$project$Components$Admin$CoverageRules$Form$CoveredBy(1))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Sponsor')
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$ItemType = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Radio$Disabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Radio$disabled = $author$project$Ui$Form$Radio$Disabled;
var $author$project$Components$Admin$CoverageRules$Form$viewItemType = F2(
	function (form, isEditing) {
		var fields = $author$project$Utils$Form$fields(form);
		var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.agA);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Applies To')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$value(fields.q9 === 'charge_category'),
									$author$project$Ui$Form$Radio$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
										$elm$core$Basics$always(
											$author$project$Components$Admin$CoverageRules$Form$ItemType('charge_category')))),
									$author$project$Ui$Form$Radio$disabled(
									isEditing || ($author$project$Components$Admin$CoverageRules$Form$ruleTypeId(fields.agA) === 'limited_quantity'))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Charge Category')
										]))
								])),
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$value(fields.q9 === 'charge_item'),
									$author$project$Ui$Form$Radio$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
										$elm$core$Basics$always(
											$author$project$Components$Admin$CoverageRules$Form$ItemType('charge_item')))),
									$author$project$Ui$Form$Radio$disabled(
									isEditing || _Utils_eq(
										typeIncludedOption,
										$elm$core$Maybe$Just(1)))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Charge Item')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$Quantity = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewQuantity = F3(
	function (quantity, form, isEditing) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Quantity')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							$elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, 0, quantity))),
							$author$project$Ui$Form$Input$phi(true),
							$author$project$Ui$Form$Input$disabled(isEditing),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$Quantity))
						]))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$disableSelectItem = F2(
	function (itemType, ruleTypeOption) {
		var _v0 = _Utils_Tuple3(
			itemType,
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeId(
				$elm$core$Maybe$Just(ruleTypeOption)),
			$author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption(ruleTypeOption));
		_v0$2:
		while (true) {
			switch (_v0.a) {
				case 'charge_item':
					if (((_v0.b === 'included') && (!_v0.c.$)) && (_v0.c.a === 1)) {
						var _v1 = _v0.c.a;
						return true;
					} else {
						break _v0$2;
					}
				case 'charge_category':
					if (_v0.b === 'limited_quantity') {
						return true;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return false;
	});
var $author$project$Ui$Form$SearchableSelect$Item$Disabled = $elm$core$Basics$identity;
var $author$project$Ui$Form$SearchableSelect$Item$disabled = $elm$core$Basics$identity;
var $author$project$Components$Admin$CoverageRules$Form$viewRuleType = F3(
	function (model, form, isEditing) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Coverage Rule')
				]),
			_List_fromArray(
				[
					isEditing ? A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoverageRules$Form$RuleTypeSelectMsg,
					A3(
						$author$project$Ui$Form$SearchableSelect$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$SearchableSelect$value(fields.agA),
								$author$project$Ui$Form$SearchableSelect$disabled(isEditing)
							]),
						_List_Nil,
						model.n4)) : A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoverageRules$Form$RuleTypeSelectMsg,
					A3(
						$author$project$Ui$Form$SearchableSelect$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$SearchableSelect$value(fields.agA),
								$author$project$Ui$Form$SearchableSelect$placeholder('Select Coverage Rule'),
								$author$project$Ui$Form$SearchableSelect$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form))
							]),
						A2(
							$elm$core$List$map,
							function (ruleTypeOption) {
								return A2(
									$author$project$Ui$Form$SearchableSelect$Item$new,
									_List_fromArray(
										[
											$author$project$Ui$Form$SearchableSelect$Item$disabled(
											A2($author$project$Components$Admin$CoverageRules$Form$disableSelectItem, fields.q9, ruleTypeOption))
										]),
									ruleTypeOption);
							},
							model.BY),
						model.n4))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder = F2(
	function (shouldUnderlineText, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var includedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.agA);
		var itemName = function () {
			var _v1 = fields.FU;
			if (!_v1.$) {
				var item = _v1.a;
				return item.zh;
			} else {
				return '';
			}
		}();
		var ruleType = function () {
			var _v0 = fields.agA;
			if (!_v0.$) {
				var ruleType_ = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType_));
			} else {
				return '';
			}
		}();
		return {
			I2: fields.I2,
			dz: (!fields.dz) ? 'patient' : 'sponsor',
			d4: includedOption,
			aei: itemName,
			q9: fields.q9,
			afJ: fields.afJ,
			Bd: fields.Bd,
			agA: ruleType,
			agW: shouldUnderlineText,
			aht: fields.aht
		};
	});
var $author$project$Components$CoverageRuleSentence$formatPercentage = function (percentage) {
	if (!percentage.$) {
		var percentage_ = percentage.a;
		return $author$project$Formatters$Float$toPercentage(percentage_);
	} else {
		return '___%';
	}
};
var $author$project$Components$CoverageRuleSentence$formatRuleItemName = function (record) {
	var pluralName = $author$project$Formatters$String$pluralOf(record.aei);
	return (record.q9 === 'charge_category') ? ('All ' + pluralName) : pluralName;
};
var $author$project$Components$CoverageRuleSentence$spanText = function (string) {
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text(string),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Components$CoverageRuleSentence$strongText = F2(
	function (string, shouldUnderlineText) {
		return shouldUnderlineText ? A2(
			$author$project$Ui$Typography$strong,
			_List_fromArray(
				[$author$project$Ui$Typography$underline]),
			_List_fromArray(
				[
					$elm$html$Html$text(string)
				])) : A2(
			$author$project$Ui$Typography$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(string)
				]));
	});
var $author$project$Components$CoverageRuleSentence$viewDiscounted = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('will receive a'),
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			'discount of ' + $author$project$Components$CoverageRuleSentence$formatPercentage(record.afJ),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('with the amount due paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.dz, record.agW)
		]);
};
var $author$project$Components$CoverageRuleSentence$formatAmount = function (amountInCents) {
	if (!amountInCents.$) {
		var amountInCents_ = amountInCents.a;
		return $author$project$Currency$format(amountInCents_);
	} else {
		return '$___';
	}
};
var $author$project$Components$CoverageRuleSentence$viewFlatAmount = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('will be'),
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatAmount(record.I2),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.dz, record.agW)
		]);
};
var $author$project$Components$CoverageRuleSentence$viewIncludedAll = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('are'),
			A2($author$project$Components$CoverageRuleSentence$strongText, 'included', record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('in the membership at no additional charge')
		]);
};
var $author$project$Components$CoverageRuleSentence$noBreakSpaceRight = function (string) {
	return $elm$html$Html$text(
		_Utils_ap(string, $author$project$Utils$String$noBreakSpace));
};
var $author$project$Components$CoverageRuleSentence$viewIncludedUnderPrice = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('are'),
			A2($author$project$Components$CoverageRuleSentence$strongText, 'included', record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('in the membership at no additional charge if they cost less than'),
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatAmount(record.I2),
			record.agW),
			$author$project$Components$CoverageRuleSentence$noBreakSpaceRight(','),
			$author$project$Components$CoverageRuleSentence$noBreakSpaceRight('those above are paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.dz, record.agW)
		]);
};
var $author$project$Components$CoverageRuleSentence$viewIncluded = function (record) {
	var _v0 = record.d4;
	if (!_v0.$) {
		if (!_v0.a) {
			var _v1 = _v0.a;
			return $author$project$Components$CoverageRuleSentence$viewIncludedAll(record);
		} else {
			var _v2 = _v0.a;
			return $author$project$Components$CoverageRuleSentence$viewIncludedUnderPrice(record);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CoverageRuleSentence$viewLimitedQuantity = function (record) {
	var quantity = function () {
		var _v4 = record.Bd;
		if (!_v4.$) {
			var quantity_ = _v4.a;
			return A2($author$project$Formatters$String$pluralize, 'unit', quantity_);
		} else {
			return '___ units';
		}
	}();
	var _v0 = function () {
		var _v1 = record.aht;
		if (!_v1.$) {
			if (!_v1.a) {
				var _v2 = _v1.a;
				return _Utils_Tuple2('', 'Jan 1st,');
			} else {
				var _v3 = _v1.a;
				return _Utils_Tuple2(' the patient\'s', 'membership renewal date,');
			}
		} else {
			return _Utils_Tuple2('', '');
		}
	}();
	var subject = _v0.a;
	var timePeriod = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('are'),
			A2($author$project$Components$CoverageRuleSentence$strongText, 'limited to a quantity', record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('of'),
			A2($author$project$Components$CoverageRuleSentence$strongText, quantity, record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('per period resetting on' + subject),
			A2($author$project$Components$CoverageRuleSentence$strongText, timePeriod, record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('additional units will be paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.dz, record.agW)
		]);
};
var $author$project$Components$CoverageRuleSentence$viewPassThrough = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('will be paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.dz, record.agW)
		]);
};
var $author$project$Components$CoverageRuleSentence$viewSurcharge = function (record) {
	return _List_fromArray(
		[
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatRuleItemName(record),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('will have a surcharge of'),
			A2(
			$author$project$Components$CoverageRuleSentence$strongText,
			$author$project$Components$CoverageRuleSentence$formatAmount(record.I2),
			record.agW),
			$author$project$Components$CoverageRuleSentence$spanText('added to the charge, the amount due will be paid for by the'),
			A2($author$project$Components$CoverageRuleSentence$strongText, record.dz, record.agW)
		]);
};
var $author$project$Components$CoverageRuleSentence$view = function (record) {
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		function () {
			var _v0 = record.agA;
			switch (_v0) {
				case 'included':
					return $author$project$Components$CoverageRuleSentence$viewIncluded(record);
				case 'flat_amount':
					return $author$project$Components$CoverageRuleSentence$viewFlatAmount(record);
				case 'discounted':
					return $author$project$Components$CoverageRuleSentence$viewDiscounted(record);
				case 'surcharge':
					return $author$project$Components$CoverageRuleSentence$viewSurcharge(record);
				case 'pass_through':
					return $author$project$Components$CoverageRuleSentence$viewPassThrough(record);
				case 'limited_quantity':
					return $author$project$Components$CoverageRuleSentence$viewLimitedQuantity(record);
				default:
					return _List_Nil;
			}
		}());
};
var $author$project$Components$Admin$CoverageRules$Form$viewSentencePreview = F2(
	function (fields, form) {
		var _v0 = _Utils_Tuple2(fields.FU, fields.agA);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(3),
								$author$project$Ui$Form$Group$inputSpanSm(9),
								$author$project$Ui$Form$Group$label('Preview')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$CoverageRuleSentence$view(
										A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, false, form))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$CoverageRules$Form$TimePeriod = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$viewTimePeriod = F2(
	function (timePeriod, isEditing) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Time period')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Time-period resetting on:'),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$value(
									_Utils_eq(
										timePeriod,
										$elm$core$Maybe$Just(0))),
									$author$project$Ui$Form$Radio$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
										$elm$core$Basics$always(
											$author$project$Components$Admin$CoverageRules$Form$TimePeriod(0)))),
									$author$project$Ui$Form$Radio$disabled(isEditing)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Jan 1st')
								])),
							A2(
							$author$project$Ui$Form$Radio$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Radio$value(
									_Utils_eq(
										timePeriod,
										$elm$core$Maybe$Just(1))),
									$author$project$Ui$Form$Radio$onCheck(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$CoverageRules$Form$FormUpdated,
										$elm$core$Basics$always(
											$author$project$Components$Admin$CoverageRules$Form$TimePeriod(1)))),
									$author$project$Ui$Form$Radio$disabled(isEditing)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Renewal Date')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm = function (model) {
	var submitVerb = function () {
		var _v1 = model.aH;
		switch (_v1) {
			case 0:
				return 'Create';
			case 1:
				return 'Save';
			default:
				return '';
		}
	}();
	var modalTitle = function () {
		var _v0 = model.aH;
		switch (_v0) {
			case 0:
				return 'Add Coverage Rule';
			case 1:
				return 'Edit Coverage Rule';
			default:
				return '';
		}
	}();
	var isEditing = model.aH === 1;
	var form = $author$project$Components$Admin$CoverageRules$Form$editingForm(model);
	var fields = $author$project$Utils$Form$fields(form);
	var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(fields.agA);
	var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.agA);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$CoverageRules$Form$AttemptedCancel,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(modalTitle)
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2($author$project$Components$Admin$CoverageRules$Form$viewItemType, form, isEditing),
						A3($author$project$Components$Admin$CoverageRules$Form$viewChargeItemOrCategoryFilter, model, form, isEditing),
						A3($author$project$Components$Admin$CoverageRules$Form$viewRuleType, model, form, isEditing),
						A2($author$project$Components$Admin$CoverageRules$Form$viewAmountOrPercentageInput, fields, form),
						(typeId === 'limited_quantity') ? A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A3($author$project$Components$Admin$CoverageRules$Form$viewQuantity, fields.Bd, form, isEditing),
								A2($author$project$Components$Admin$CoverageRules$Form$viewTimePeriod, fields.aht, isEditing)
							])) : $author$project$Utils$Html$empty,
						((typeId === '') || ((typeId === 'included') && (!_Utils_eq(
						typeIncludedOption,
						$elm$core$Maybe$Just(1))))) ? $author$project$Utils$Html$empty : $author$project$Components$Admin$CoverageRules$Form$viewCoveredBy(fields.dz),
						A2($author$project$Components$Admin$CoverageRules$Form$viewSentencePreview, fields, form)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: submitVerb},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedSubmit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(submitVerb)
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$AttemptedCancelDelete = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$CoverageRules$Form$cancelDelete = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var _v0 = fields.adR;
	if (!_v0.$) {
		var id_ = _v0.a;
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Cancel deletion'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$CoverageRules$Form$AttemptedCancelDelete(id_))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel Deletion')
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$CoverageRules$Form$AttemptedDelete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$SvgIcon$UnpublishedRuleArrow = 2;
var $author$project$Ui$SvgIcon$unpublishedRuleArrow = $author$project$Ui$SvgIcon$viewIcon(2);
var $author$project$Components$Admin$CoverageRules$Form$unpublishedTag = _List_fromArray(
	[
		$author$project$Utils$Html$noBreakSpace,
		$author$project$Utils$Html$noBreakSpace,
		A2($author$project$Ui$Badge$fromString, _List_Nil, 'unpublished_change')
	]);
var $author$project$Components$Admin$CoverageRules$Form$unpublishedSentence = function (editedForm) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('coverage-rule__unpublished')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('coverage-rule__unpublished__arrow')
					]),
				_List_fromArray(
					[
						$author$project$Ui$SvgIcon$unpublishedRuleArrow(_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('coverage-rule__unpublished__warning')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(10)
											]),
										A2(
											$elm$core$List$cons,
											$author$project$Components$CoverageRuleSentence$view(
												A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, true, editedForm)),
											$author$project$Components$Admin$CoverageRules$Form$unpublishedTag)),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(2),
												$author$project$Ui$FlexGrid$justifyRight
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Cancel change'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$size(0),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Admin$CoverageRules$Form$AttemptedDelete(
															$author$project$Utils$Form$fields(editedForm).adR))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel Change')
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Api$Provider$CoverageRuleUsage$Shared$coveredCharges = function (_v0) {
	var record = _v0;
	return record.L9;
};
var $author$project$Api$Provider$CoverageRuleUsage$All$coveredCharges = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoverageRuleUsage$Shared$coveredCharges(shared);
};
var $author$project$Api$Provider$CoverageRule$Shared$itemName = function (_v0) {
	var record = _v0;
	var _v1 = record.FU;
	if (!_v1.$) {
		var i = _v1.a;
		return $author$project$Api$Provider$ChargeItem$Shared$name(i);
	} else {
		var cat = _v1.a;
		return $author$project$Api$Provider$Category$Shared$name(cat);
	}
};
var $author$project$Api$Provider$CoverageRule$One$itemName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CoverageRule$Shared$itemName(shared);
};
var $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItems = function (_v0) {
	var record = _v0;
	return record.X7;
};
var $author$project$Api$Provider$CoverageRuleUsage$All$remainingItems = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItems(shared);
};
var $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItemsUntil = function (_v0) {
	var record = _v0;
	return record.X8;
};
var $author$project$Api$Provider$CoverageRuleUsage$All$remainingItemsUntil = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItemsUntil(shared);
};
var $author$project$Api$Provider$CoveredCharge$Min$coveredDate = function (_v0) {
	var record = _v0;
	return record.Ma;
};
var $author$project$Api$Provider$CoveredCharge$Min$quantity = function (_v0) {
	var record = _v0;
	return record.Bd;
};
var $author$project$Components$CoverageRuleUsage$viewCoveredCharge = function (coveredCharge) {
	var quantity = $author$project$Api$Provider$CoveredCharge$Min$quantity(coveredCharge);
	var date = $author$project$Api$Provider$CoveredCharge$Min$coveredDate(coveredCharge);
	var string = $justinmimbs$date$Date$toIsoString(date) + (' - ' + (A2($author$project$Formatters$String$pluralize, 'unit', quantity) + ' utilized'));
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('timeline__item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Components$CoverageRuleUsage$viewCoveredCharges = function (coveredCharges) {
	return $elm$core$List$isEmpty(coveredCharges) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Popover$view,
				_List_fromArray(
					[$author$project$Ui$Popover$dark, $author$project$Ui$Popover$sm]),
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 5)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Popover$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('timeline mb-0 mt-05 ml-1')
									]),
								A2($elm$core$List$map, $author$project$Components$CoverageRuleUsage$viewCoveredCharge, coveredCharges))
							]))
					]))
			]));
};
var $author$project$Components$CoverageRuleUsage$view = function (coverageRuleUsage) {
	var remainingQuantity = A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Api$Provider$CoverageRuleUsage$All$remainingItems(coverageRuleUsage));
	var itemName = $author$project$Api$Provider$CoverageRule$One$itemName(
		$author$project$Api$Provider$CoverageRuleUsage$All$coverageRule(coverageRuleUsage));
	var remainingDescriptionPrefix = $elm$core$String$fromInt(remainingQuantity) + (' included ' + itemName);
	var description = function () {
		switch (remainingQuantity) {
			case 0:
				var remainingItemsUntil = A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Provider$CoverageRuleUsage$All$remainingItemsUntil(coverageRuleUsage));
				return 'All included ' + (itemName + (' have been used until ' + remainingItemsUntil));
			case 1:
				return remainingDescriptionPrefix + ' remains';
			default:
				return remainingDescriptionPrefix + ' remain';
		}
	}();
	return A2(
		$author$project$Ui$Typography$span,
		_List_fromArray(
			[$author$project$Ui$Typography$small]),
		_List_fromArray(
			[
				$elm$html$Html$text(description),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Components$CoverageRuleUsage$viewCoveredCharges(
				$author$project$Api$Provider$CoverageRuleUsage$All$coveredCharges(coverageRuleUsage))
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$AttemptedEdit = {$: 6};
var $author$project$Components$Admin$CoverageRules$Form$cannotBeEdited = F2(
	function (form, unpublishedForm) {
		var fields = $author$project$Utils$Form$fields(form);
		var ruleType = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue, fields.agA);
		var isIncluded = A2(
			$elm$core$Maybe$map,
			function (r) {
				return r === 'included';
			},
			ruleType);
		return (A2($elm$core$Maybe$withDefault, false, isIncluded) && (fields.q9 === 'charge_item')) || (!_Utils_eq(unpublishedForm, $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Admin$CoverageRules$Form$viewRuleActions = F2(
	function (form, unpublishedForm) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Edit rule'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedEdit),
						$author$project$Ui$Button$disabled(
						A2($author$project$Components$Admin$CoverageRules$Form$cannotBeEdited, form, unpublishedForm)),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Edit')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Delete rule'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$CoverageRules$Form$AttemptedDelete(fields.adR)),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Delete')
					]))
			]);
	});
var $author$project$Components$Admin$CoverageRules$Form$viewSentence = function (model) {
	var unpublishedTagIfUnpublished = (model.aF || model.cd) ? A2($author$project$Ui$Typography$span, _List_Nil, $author$project$Components$Admin$CoverageRules$Form$unpublishedTag) : $author$project$Utils$Html$empty;
	var sentenceOptions = model.aF ? _List_fromArray(
		[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$gray]) : _List_Nil;
	var emptySecondRow = A2($author$project$Ui$FlexGrid$row, _List_Nil, _List_Nil);
	var _v0 = model.XO ? _Utils_Tuple2(12, 0) : _Utils_Tuple2(10, 2);
	var gridSentenceSpace = _v0.a;
	var gridActionsSpace = _v0.b;
	var _v1 = _Utils_Tuple2(model.PB, model.L);
	var form = _v1.a;
	var editedForm = _v1.b;
	var sentenceRow = _List_fromArray(
		[
			$author$project$Components$CoverageRuleSentence$view(
			A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, true, form))
		]);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(gridSentenceSpace)
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Typography$span, sentenceOptions, sentenceRow),
								unpublishedTagIfUnpublished,
								function () {
								var _v2 = model.EK;
								if (!_v2.$) {
									var coverageRuleUsage = _v2.a;
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Components$CoverageRuleUsage$view(coverageRuleUsage)
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(gridActionsSpace),
								$author$project$Ui$FlexGrid$justifyRight
							]),
						model.aF ? $author$project$Components$Admin$CoverageRules$Form$cancelDelete(form) : ((!model.XO) ? A2($author$project$Components$Admin$CoverageRules$Form$viewRuleActions, form, editedForm) : _List_Nil))
					])),
				function () {
				if (!editedForm.$) {
					var editedForm_ = editedForm.a;
					return model.cd ? emptySecondRow : ((!model.XO) ? $author$project$Components$Admin$CoverageRules$Form$unpublishedSentence(editedForm_) : emptySecondRow);
				} else {
					return emptySecondRow;
				}
			}()
			]));
};
var $author$project$Components$Admin$CoverageRules$Form$view = function (_v0) {
	var model = _v0;
	var _v1 = model.aH;
	switch (_v1) {
		case 0:
			return $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm(model);
		case 1:
			return $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm(model);
		default:
			return $author$project$Components$Admin$CoverageRules$Form$viewSentence(model);
	}
};
var $author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow = F2(
	function (ruleForm, index) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index),
					$author$project$Components$Admin$CoverageRules$Form$view(ruleForm))
				]));
	});
var $author$project$Components$Admin$CoveragePlans$Rules$viewCategorizedCoverageRuleForms = F2(
	function (categories, coverageRuleFormsWithIndex) {
		return A2(
			$elm$core$List$concatMap,
			function (category) {
				var rulesInThisCategory = A2(
					$elm$core$List$filter,
					function (tuple) {
						return A2($author$project$Components$Admin$CoveragePlans$Rules$isRuleInCategory, tuple.a, category.adR);
					},
					coverageRuleFormsWithIndex);
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$ListGroup$item,
						_List_fromArray(
							[
								$author$project$Ui$ListGroup$style(4)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$toUpper(category.zh))
							])),
					A2(
						$elm$core$List$map,
						function (tuple) {
							return A2($author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow, tuple.a, tuple.b);
						},
						rulesInThisCategory));
			},
			categories);
	});
var $author$project$Ui$FontWeight$Normal = 1;
var $author$project$Ui$Icon$QuestionUncolored = 6;
var $author$project$Ui$Typography$FontWeight = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ui$Typography$fontWeight = $author$project$Ui$Typography$FontWeight;
var $author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageTooltip = A2(
	$author$project$Ui$Typography$div,
	_List_fromArray(
		[
			$author$project$Ui$Typography$pull(1)
		]),
	_List_fromArray(
		[
			A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Uncategorized rules are charge items that are not associated with a charge category. You can assign a category to your charge items under Admin -> Charges & Taxes.',
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 6)
						]))
				])),
			$author$project$Utils$Html$noBreakSpace,
			A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[
					$author$project$Ui$Typography$fontWeight(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('What are uncategorized coverage rules?')
				]))
		]));
var $author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageRuleForms = function (ruleForms) {
	return $elm$core$List$isEmpty(ruleForms) ? _List_Nil : A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[
					$author$project$Ui$ListGroup$style(4)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('UNCATEGORIZED'),
					$author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageTooltip
				])),
		A2(
			$elm$core$List$map,
			function (tuple) {
				return A2($author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow, tuple.a, tuple.b);
			},
			ruleForms));
};
var $author$project$Components$Admin$CoveragePlans$Rules$view = function (model) {
	var activeCoverageRuleFormsWithIndex = A2(
		$elm$core$List$filter,
		function (tuple) {
			return !$author$project$Components$Admin$CoverageRules$Form$isReallyDeleted(tuple.a);
		},
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, rule) {
					return _Utils_Tuple2(rule, index);
				}),
			model.acd));
	var categories = $author$project$Components$Admin$CoveragePlans$Rules$allCategories(activeCoverageRuleFormsWithIndex);
	var uncategorizedCoverageRuleFormsWithIndex = A2(
		$elm$core$List$filter,
		function (tuple) {
			return _Utils_eq(
				$author$project$Components$Admin$CoverageRules$Form$category(tuple.a),
				$elm$core$Maybe$Nothing);
		},
		activeCoverageRuleFormsWithIndex);
	return A2(
		$author$project$Ui$ListGroup$view,
		_List_Nil,
		_Utils_ap(
			A2($author$project$Components$Admin$CoveragePlans$Rules$viewCategorizedCoverageRuleForms, categories, activeCoverageRuleFormsWithIndex),
			_Utils_ap(
				$author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageRuleForms(uncategorizedCoverageRuleFormsWithIndex),
				model.XO ? _List_Nil : _List_fromArray(
					[$author$project$Components$Admin$CoveragePlans$Rules$viewAddCoverageRuleButton]))));
};
var $author$project$Components$Admin$CoveragePlans$Form$AddDocumentUpload = {$: 14};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$File$Pdf = 2;
var $author$project$Components$Admin$CoverageDocuments$UploadModal$Save = {$: 3};
var $author$project$Components$Admin$CoverageDocuments$UploadModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$CoverageDocuments$UploadModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						_Utils_eq(model.p_, $elm$core$Maybe$Nothing) ? 'Upload PDF Document' : 'Edit PDF Document')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Admin$CoverageDocuments$UploadModal$Save),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('File'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4)
									]),
								_List_fromArray(
									[
										function () {
										var _v1 = model.p_;
										if (!_v1.$) {
											var coverageDocument_ = _v1.a;
											return A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$padding(6),
														$author$project$Ui$Typography$margin(21)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[
																$author$project$Ui$Typography$margin(11)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument_))
															]))
													]));
										} else {
											return $author$project$Ui$Form$File$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$File$accept(2),
														$author$project$Ui$Form$File$onInput($author$project$Components$Admin$CoverageDocuments$UploadModal$FileUploaded)
													]));
										}
									}()
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true),
										$author$project$Ui$Form$Group$label('Visible PDF File Name')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.Pm),
												$author$project$Ui$Form$Input$phi(true),
												$author$project$Ui$Form$Input$placeholder('File Name'),
												$author$project$Ui$Form$Input$autofocus(true),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageDocuments$UploadModal$FormUpdated, $author$project$Components$Admin$CoverageDocuments$UploadModal$FileName)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 1, model.PB))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageDocuments$UploadModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Save upload'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageDocuments$UploadModal$Save),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoverageDocuments$Form$modal = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.fm;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var coverageDocument = _v2.a;
					var deleteRequest = _v2.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed(coverageDocument),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$noun('document'),
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Are you sure you want to delete ' + $author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument))
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.io ? A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg,
				$author$project$Components$Admin$CoverageDocuments$UploadModal$view(model.cM)) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$Admin$CoverageDocuments$Form$Delete = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$Form$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$CoverageDocuments$Form$viewListActions = function (coverageDocument) {
	return A2(
		$author$project$Ui$FlexGrid$column,
		_List_fromArray(
			[
				$author$project$Ui$FlexGrid$spanSm(2)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$pull(1)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Edit coverage document'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Admin$CoverageDocuments$Form$Edit(coverageDocument))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Delete coverage document'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Admin$CoverageDocuments$Form$Delete(coverageDocument))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete')
									]))
							]))
					]))
			]));
};
var $author$project$Api$Provider$CoverageDocument$Shared$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Components$Admin$CoverageDocuments$Form$viewListItems = function (coverageDocument) {
	return A2(
		$author$project$Ui$FlexGrid$column,
		_List_fromArray(
			[
				$author$project$Ui$FlexGrid$spanSm(10)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						$author$project$Api$Provider$CoverageDocument$Shared$url(coverageDocument),
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument)),
								$elm$html$Html$text('  '),
								$author$project$Ui$SvgIcon$launch(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$sm]))
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoverageDocuments$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Admin$CoverageDocuments$Form$modal(model),
				$elm$core$List$isEmpty(model.L4) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (coverageDocument) {
								return A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$Admin$CoverageDocuments$Form$viewListItems(coverageDocument),
											$author$project$Components$Admin$CoverageDocuments$Form$viewListActions(coverageDocument)
										]));
							},
							model.L4))
					]))
			]));
};
var $author$project$Components$Admin$CoveragePlans$Form$viewCoverageDocuments = function (model) {
	var _v0 = model.adR;
	if (!_v0.$) {
		var coverageDocumentList = function () {
			var _v1 = _Utils_Tuple2(model.L4, model.L5);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var coveragePlan = _v1.b.a;
				return $author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan);
			} else {
				return _List_Nil;
			}
		}();
		var addButton = A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Upload pdf document'},
							_List_fromArray(
								[
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
									$author$project$Ui$Button$onClick($author$project$Components$Admin$CoveragePlans$Form$AddDocumentUpload)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Upload Pdf Document')
								]))
						]))
				]));
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Benefit Overview Documents')
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$modal, model.L4))),
					A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					$elm$core$List$isEmpty(coverageDocumentList) ? _List_fromArray(
						[addButton]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$ListGroup$item,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg,
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$Utils$Html$empty,
										A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$view, model.L4)))
								])),
							addButton
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$CoveragePlans$Form$PlanSearched = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$ListGroup$Clearfix = {$: 1};
var $author$project$Ui$ListGroup$clearfix = $author$project$Ui$ListGroup$Clearfix;
var $author$project$Ui$ListGroup$Note = {$: 2};
var $author$project$Ui$ListGroup$note = $author$project$Ui$ListGroup$Note;
var $author$project$Components$Admin$CoveragePlans$Form$searchInput = function (planSearchQuery) {
	return A2(
		$author$project$Ui$ListGroup$item,
		_List_fromArray(
			[$author$project$Ui$ListGroup$clearfix, $author$project$Ui$ListGroup$note]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$onInput($author$project$Components$Admin$CoveragePlans$Form$PlanSearched),
						$author$project$Ui$Form$Input$placeholder('Search...'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', planSearchQuery))
					]))
			]));
};
var $author$project$Components$Admin$CoveragePlans$Form$SelectedAllPlans = function (a) {
	return {$: 6, a: a};
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Components$Admin$CoveragePlans$Form$selectAllOption = function (selectAllPlans) {
	return A2(
		$author$project$Ui$ListGroup$item,
		_List_fromArray(
			[$author$project$Ui$ListGroup$clearfix, $author$project$Ui$ListGroup$note]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(selectAllPlans),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$CoveragePlans$Form$SelectedAllPlans)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								selectAllPlans ? 'Unselect All' : 'Select All')
							]))
					]))
			]));
};
var $author$project$Components$Admin$CoveragePlans$Form$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Pagination$More$CurrentPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Pagination$More$currentPage = $author$project$Ui$Pagination$More$CurrentPage;
var $author$project$Ui$Pagination$More$ItemsPerPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Pagination$More$itemsPerPage = $author$project$Ui$Pagination$More$ItemsPerPage;
var $author$project$Ui$Pagination$More$OnClick = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Pagination$More$onClick = $author$project$Ui$Pagination$More$OnClick;
var $author$project$Ui$Pagination$More$TotalCount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Pagination$More$totalCount = $author$project$Ui$Pagination$More$TotalCount;
var $author$project$Ui$Pagination$More$defaultOptions = {bV: 0, mM: 0, S_: false, zI: $elm$core$Maybe$Nothing, oN: 0};
var $author$project$Ui$Pagination$More$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var _int = option.a;
						return _Utils_update(
							record,
							{oN: _int});
					case 1:
						var _int = option.a;
						return _Utils_update(
							record,
							{mM: _int});
					case 2:
						var _int = option.a;
						return _Utils_update(
							record,
							{bV: _int});
					case 3:
						var toMsg = option.a;
						return _Utils_update(
							record,
							{
								zI: $elm$core$Maybe$Just(toMsg)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{S_: bool});
				}
			}),
		$author$project$Ui$Pagination$More$defaultOptions,
		options);
};
var $author$project$Ui$Pagination$More$viewPageSpan = F3(
	function (label, maybeMsg, pageNumber) {
		var attributes = function () {
			if (!maybeMsg.$) {
				var msg = maybeMsg.a;
				return _List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						msg(pageNumber))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$span,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('clickable'),
				attributes),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Ui$Pagination$More$view = function (options) {
	var optionsRecord = $author$project$Ui$Pagination$More$optionsToRecord(options);
	if (optionsRecord.S_) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Spinner$view(
					_List_fromArray(
						[$author$project$Ui$Spinner$small]))
				]));
	} else {
		var totalRemaining = optionsRecord.oN - (optionsRecord.bV * optionsRecord.mM);
		if (totalRemaining < 0) {
			return $author$project$Utils$Html$empty;
		} else {
			var linkText = 'Show more (' + ($elm$core$String$fromInt(totalRemaining) + ' hidden)');
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3($author$project$Ui$Pagination$More$viewPageSpan, linkText, optionsRecord.zI, optionsRecord.bV + 1)
					]));
		}
	}
};
var $author$project$Api$Pagination$viewAsShowMore = F2(
	function (options, _v0) {
		var model = _v0;
		return $author$project$Ui$Pagination$More$view(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Pagination$More$totalCount(model.oN),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Pagination$More$itemsPerPage(model.mM),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Pagination$More$currentPage(model.bV),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Pagination$More$onClick($elm$core$Basics$identity),
							options)))));
	});
var $author$project$Components$Admin$CoveragePlans$Form$showMoreItem = F2(
	function (totalRemaining, pagination) {
		return (!(!totalRemaining)) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[$author$project$Ui$ListGroup$clearfix, $author$project$Ui$ListGroup$note]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Admin$CoveragePlans$Form$PaginationMsg,
						A2($author$project$Api$Pagination$viewAsShowMore, _List_Nil, pagination))
					]))
			]) : _List_Nil;
	});
var $author$project$Components$Admin$CoveragePlans$Form$SelectedPlan = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Admin$CoveragePlans$Form$planInCoveragePlan = F2(
	function (plans, plan) {
		return A2(
			$elm$core$List$member,
			plan.adR,
			A2(
				$elm$core$List$map,
				function (planRecord) {
					return planRecord.adR;
				},
				plans));
	});
var $author$project$Components$Admin$CoveragePlans$Form$viewPlan = F3(
	function (fields, selectAllPlans, plan) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[$author$project$Ui$ListGroup$clearfix, $author$project$Ui$ListGroup$note]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(
							selectAllPlans || A2($author$project$Components$Admin$CoveragePlans$Form$planInCoveragePlan, fields.Wq, plan)),
							$author$project$Ui$Form$Checkbox$onCheck(
							$author$project$Components$Admin$CoveragePlans$Form$SelectedPlan(plan))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(plan.zh)
						]))
				]));
	});
var $author$project$Components$Admin$CoveragePlans$Form$viewPlans = F2(
	function (model, form) {
		var _v0 = model.Wq;
		if (_v0.$ === 3) {
			var headers = _v0.b;
			var searchItem = $author$project$Components$Admin$CoveragePlans$Form$searchInput(model.r6);
			if ($elm$core$List$length(model.go) > 0) {
				var totalCount = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$String$toInt,
						A2($elm$core$Dict$get, 'x-total-count', headers)));
				var totalRemaining = totalCount - $elm$core$List$length(model.go);
				var fields = $author$project$Utils$Form$fields(form);
				return A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									searchItem,
									$author$project$Components$Admin$CoveragePlans$Form$selectAllOption(model.sD)
								]),
								A2(
								$elm$core$List$map,
								A2($author$project$Components$Admin$CoveragePlans$Form$viewPlan, fields, model.sD),
								model.go),
								A2($author$project$Components$Admin$CoveragePlans$Form$showMoreItem, totalRemaining, model.afy)
							])));
			} else {
				return A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					_List_fromArray(
						[
							searchItem,
							A2(
							$author$project$Ui$ListGroup$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('No plans found')
								]))
						]));
			}
		} else {
			return A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[
						$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(_List_Nil)
					]));
		}
	});
var $author$project$Components$Admin$CoveragePlans$Form$viewForm = F2(
	function (model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label('Coverage Plan Name')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.zh),
								$author$project$Ui$Form$Input$autofocus(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoveragePlans$Form$FormUpdated, $author$project$Components$Admin$CoveragePlans$Form$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Connected Membership Plans')
					]),
				_List_fromArray(
					[
						A2($author$project$Components$Admin$CoveragePlans$Form$viewPlans, model, form)
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Covered Charge Categories & Items')
					])),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$view, model.acd))),
				$author$project$Components$Admin$CoveragePlans$Form$viewCoverageDocuments(model)
			]);
	});
var $author$project$Components$Admin$CoveragePlans$Form$view = function (_v0) {
	var model = _v0;
	var newRecord = function () {
		var _v2 = model.adR;
		if (!_v2.$) {
			return false;
		} else {
			return true;
		}
	}();
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$Admin$CoveragePlans$Form$AttemptedSubmit)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(
										newRecord ? 'New Coverage Plan' : 'Edit Coverage Plan')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v1 = model.PB;
							if (!_v1.$) {
								var form = _v1.a;
								return A2($author$project$Components$Admin$CoveragePlans$Form$viewForm, model, form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Publish coverage plan'},
								_List_fromArray(
									[$author$project$Ui$Button$primary, $author$project$Ui$Button$submit]),
								_List_fromArray(
									[
										$elm$html$Html$text('Publish')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$CoveragePlans$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$CoveragePlans$Form$view(model.PB))
			]),
		$G: 'Admin | Coverage Plans'
	};
};
var $author$project$Pages$Admin$CoveragePlans$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CoveragePlans$Id_String$init, aer: $author$project$Pages$Admin$CoveragePlans$Id_String$load, agD: $author$project$Pages$Admin$CoveragePlans$Id_String$save, ahd: $author$project$Pages$Admin$CoveragePlans$Id_String$subscriptions, aaq: $author$project$Pages$Admin$CoveragePlans$Id_String$update, ahP: $author$project$Pages$Admin$CoveragePlans$Id_String$view});
var $author$project$Pages$Admin$CoveragePlans$New$CoveragePlanFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$CoveragePlans$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var _v2 = A4($author$project$Components$Admin$CoveragePlans$Form$init, apiClient, session, practice, $elm$core$Maybe$Nothing);
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$CoveragePlans$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CoveragePlans$New$save = F2(
	function (_v0, shared) {
		var form = _v0.PB;
		return A2($author$project$Components$Admin$CoveragePlans$Form$save, form, shared);
	});
var $author$project$Pages$Admin$CoveragePlans$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$CoveragePlans$Form$subscriptions(model.PB));
};
var $author$project$Pages$Admin$CoveragePlans$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$CoveragePlans$Form$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$CoveragePlans$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$CoveragePlans$Form$view(model.PB))
			]),
		$G: 'Admin | Coverage Plans'
	};
};
var $author$project$Pages$Admin$CoveragePlans$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CoveragePlans$New$init, aer: $author$project$Pages$Admin$CoveragePlans$New$load, agD: $author$project$Pages$Admin$CoveragePlans$New$save, ahd: $author$project$Pages$Admin$CoveragePlans$New$subscriptions, aaq: $author$project$Pages$Admin$CoveragePlans$New$update, ahP: $author$project$Pages$Admin$CoveragePlans$New$view});
var $author$project$Pages$Admin$CoveragePlans$Top$GotList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CoveragePlans$Top$fetchList = function (model) {
	return A3(
		$author$project$Api$Provider$CoveragePlan$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, af_: model.af_, ag1: model.ag1});
		},
		$author$project$Pages$Admin$CoveragePlans$Top$GotList);
};
var $author$project$Pages$Admin$CoveragePlans$Top$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var query = _v3.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: apiClient,
			ic: $elm$core$Maybe$Nothing,
			dN: $elm$core$Set$empty,
			iZ: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$CoveragePlans$Top$fetchList(model));
	});
var $author$project$Pages$Admin$CoveragePlans$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CoveragePlans$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$CoveragePlans$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed),
				$author$project$Api$Provider$CoveragePlan$All$id),
			model.ic));
};
var $author$project$Pages$Admin$CoveragePlans$Top$Deleted = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$CoveragePlan$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_)));
	});
var $author$project$Pages$Admin$CoveragePlans$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__CoveragePlans__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$CoveragePlans$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iZ: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2($elm$core$Set$remove, id, model.dN),
									iZ: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$CoveragePlans$Top$fetchList(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Coverage plan successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2($elm$core$Set$remove, id, model.dN)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$CoveragePlans$Top$fetchList(newModel),
								$author$project$Pages$Admin$CoveragePlans$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$CoveragePlans$Top$fetchList(newModel),
								$author$project$Pages$Admin$CoveragePlans$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var deletingItem = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Just(deletingItem)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Nothing,
							dN: A2($elm$core$Set$insert, id, model.dN)
						}),
					A3(
						$author$project$Api$Provider$CoveragePlan$delete,
						model.D5,
						id,
						$author$project$Pages$Admin$CoveragePlans$Top$Deleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ic: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								iZ: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$CoveragePlans$Top$fetchList(qModel),
										$author$project$Pages$Admin$CoveragePlans$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$CoveragePlans$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$CoveragePlans$Top$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$CoveragePlans$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name'),
		A3($author$project$Api$Column$init, 'charges', false, 'Included charges')
	]);
var $author$project$Pages$Admin$CoveragePlans$Top$Delete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CoveragePlans$Top$viewCoverageRule = function (coverageRule) {
	return A2(
		$author$project$Ui$Form$Static$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Components$CoverageRuleDescription$view,
				$author$project$Components$CoverageRuleDescription$One(coverageRule),
				false)
			]));
};
var $author$project$Pages$Admin$CoveragePlans$Top$viewItem = F2(
	function (deletingItems, coveragePlan) {
		var id = $author$project$Api$Provider$CoveragePlan$All$id(coveragePlan);
		var loading = A2($elm$core$Set$member, id, deletingItems);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$CoveragePlan$All$name(coveragePlan))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Admin$CoveragePlans$Top$viewCoverageRule,
						$author$project$Api$Provider$CoveragePlan$All$coverageRules(coveragePlan))),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String(
										{adR: id}),
									_List_fromArray(
										[
											$author$project$Ui$Link$sm,
											$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete coverage plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$size(0),
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$CoveragePlans$Top$Delete(coveragePlan)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CoveragePlans$Top$viewPanelTable = function (model) {
	var _v0 = function () {
		var _v1 = model.iZ;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No coverage plans found.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$CoveragePlans$Top$SortTable)),
					$author$project$Pages$Admin$CoveragePlans$Top$columns),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$CoveragePlans$Top$viewItem(model.dN),
			items),
		_List_Nil);
};
var $author$project$Pages$Admin$CoveragePlans$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.ic;
				if (!_v0.$) {
					var item = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed(
							$author$project$Api$Provider$CoveragePlan$All$id(item)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('coverage plan'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$CoveragePlan$All$name(item) + ' and remove it from all existing plans')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Coverage Plans')
											])),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__CoveragePlans__New,
										_List_fromArray(
											[
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Coverage Plan')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
													]))
											]))
									]))
							])),
						$author$project$Pages$Admin$CoveragePlans$Top$viewPanelTable(model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$CoveragePlans$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.iZ))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Coverage Plans'
	};
};
var $author$project$Pages$Admin$CoveragePlans$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CoveragePlans$Top$init, aer: $author$project$Pages$Admin$CoveragePlans$Top$load, agD: $author$project$Pages$Admin$CoveragePlans$Top$save, ahd: $author$project$Pages$Admin$CoveragePlans$Top$subscriptions, aaq: $author$project$Pages$Admin$CoveragePlans$Top$update, ahP: $author$project$Pages$Admin$CoveragePlans$Top$view});
var $author$project$Pages$Admin$CreditCategories$GotCreditCategories = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CreditCategory$creditCategoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['credit_categories']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CreditCategory$All$CreditCategory = $elm$core$Basics$identity;
var $author$project$Api$Provider$CreditCategory$Shared$CreditCategory = $elm$core$Basics$identity;
var $author$project$Api$Provider$CreditCategory$Shared$Record = F7(
	function (id, name, canSetAmount, amountInCents, canSetExpiration, expiresInDays, isDestroyable) {
		return {I2: amountInCents, KC: canSetAmount, KD: canSetExpiration, O_: expiresInDays, adR: id, RJ: isDestroyable, zh: name};
	});
var $author$project$Api$Provider$CreditCategory$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_destroyable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'expires_in_days',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'can_set_expiration',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount_in_cents',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'can_set_amount',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$CreditCategory$Shared$Record))))))));
var $author$project$Api$Provider$CreditCategory$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CreditCategory$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CreditCategory$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CreditCategory$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CreditCategory$listDefaults = {
	adR: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$CreditCategory$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CreditCategory$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$CreditCategory$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CreditCategory$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CreditCategory$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CreditCategory$creditCategoriesPath)));
	});
var $author$project$Pages$Admin$CreditCategories$fetchCreditCategories = function (model) {
	return A3(
		$author$project$Api$Provider$CreditCategory$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, af_: model.af_, ag1: model.ag1});
		},
		$author$project$Pages$Admin$CreditCategories$GotCreditCategories);
};
var $author$project$Pages$Admin$CreditCategories$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var query = _v3.Bi;
		var model = {
			D5: apiClient,
			cN: $author$project$Api$Data$Loading,
			Mj: $elm$core$Maybe$Nothing,
			dK: $elm$core$Set$empty,
			ib: $elm$core$Maybe$Nothing,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			af_: A2($elm$core$Dict$get, 'q', query),
			sA: $author$project$Ui$SearchInput$init(
				A2($elm$core$Dict$get, 'q', query)),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model));
	});
var $author$project$Pages$Admin$CreditCategories$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$CreditCategories$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit = {$: 3};
var $author$project$Pages$Admin$CreditCategories$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$CreditCategories$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit)),
					model.Mj)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CreditCategories$HiConfirmClosed),
					model.ib))
			]));
};
var $author$project$Pages$Admin$CreditCategories$CreditCategoryDeleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Admin$CreditCategories$SearchInputMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$CreditCategory$creditCategoryPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$CreditCategory$creditCategoriesPath);
};
var $author$project$Api$Provider$CreditCategory$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CreditCategory$creditCategoryPath(id_)));
	});
var $author$project$Api$Provider$CreditCategory$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$CreditCategory$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$CreditCategory$Shared$canSetAmount = function (_v0) {
	var record = _v0;
	return record.KC;
};
var $author$project$Api$Provider$CreditCategory$All$canSetAmount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$canSetAmount(shared);
};
var $author$project$Api$Provider$CreditCategory$Shared$canSetExpiration = function (_v0) {
	var record = _v0;
	return record.KD;
};
var $author$project$Api$Provider$CreditCategory$All$canSetExpiration = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$canSetExpiration(shared);
};
var $author$project$Api$Provider$CreditCategory$Shared$expiresInDays = function (_v0) {
	var record = _v0;
	return record.O_;
};
var $author$project$Api$Provider$CreditCategory$All$expiresInDays = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$expiresInDays(shared);
};
var $author$project$Api$Provider$CreditCategory$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$CreditCategory$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$name(shared);
};
var $author$project$Pages$Admin$CreditCategories$formFieldsFromCreditCategory = function (creditCategory) {
	return {
		I2: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$CreditCategory$All$amountInCents(creditCategory)),
		KC: $author$project$Api$Provider$CreditCategory$All$canSetAmount(creditCategory),
		KD: $author$project$Api$Provider$CreditCategory$All$canSetExpiration(creditCategory),
		O_: $author$project$Api$Provider$CreditCategory$All$expiresInDays(creditCategory),
		zh: $author$project$Api$Provider$CreditCategory$All$name(creditCategory)
	};
};
var $author$project$Pages$Admin$CreditCategories$formFieldsInit = {I2: $elm$core$Maybe$Nothing, KC: true, KD: true, O_: $elm$core$Maybe$Nothing, zh: ''};
var $author$project$Pages$Admin$CreditCategories$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var _int = field.a;
				return _Utils_update(
					fields,
					{I2: _int});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						O_: $elm$core$String$toInt(string)
					});
		}
	});
var $author$project$Pages$Admin$CreditCategories$NameValidation = 0;
var $author$project$Pages$Admin$CreditCategories$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Provider$CreditCategory$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CreditCategory$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$id(shared);
};
var $author$project$Api$Provider$CreditCategory$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$name(shared);
};
var $author$project$Pages$Admin$CreditCategories$CreditCategoryCreated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CreditCategory$One$CreditCategory = $elm$core$Basics$identity;
var $author$project$Api$Provider$CreditCategory$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CreditCategory$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CreditCategory$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'credit_category',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							_Utils_ap(
								function () {
									var _v0 = fields.I2;
									if (!_v0.$) {
										var amountInCents_ = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'amount_in_cents',
												$author$project$Currency$encode(amountInCents_))
											]);
									} else {
										return _List_Nil;
									}
								}(),
								function () {
									var _v1 = fields.O_;
									if (!_v1.$) {
										var expiresInDays_ = _v1.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'expires_in_days',
												$elm$json$Json$Encode$int(expiresInDays_))
											]);
									} else {
										return _List_Nil;
									}
								}()))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CreditCategory$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CreditCategory$creditCategoriesPath)));
	});
var $author$project$Pages$Admin$CreditCategories$createCreditCategory = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {I2: fields.I2, O_: fields.O_, zh: fields.zh};
		return A3($author$project$Api$Provider$CreditCategory$create, apiClient, apiFields, $author$project$Pages$Admin$CreditCategories$CreditCategoryCreated);
	});
var $author$project$Pages$Admin$CreditCategories$CreditCategoryUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$CreditCategory$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'credit_category',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'amount_in_cents',
								A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I2)),
								_Utils_Tuple2(
								'expires_in_days',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.O_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CreditCategory$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CreditCategory$creditCategoryPath(id_))));
	});
var $author$project$Pages$Admin$CreditCategories$updateCreditCategory = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {I2: fields.I2, O_: fields.O_, zh: fields.zh};
		return A4($author$project$Api$Provider$CreditCategory$update, apiClient, id, apiFields, $author$project$Pages$Admin$CreditCategories$CreditCategoryUpdated);
	});
var $author$project$Pages$Admin$CreditCategories$saveCreditCategory = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$CreditCategories$updateCreditCategory, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$CreditCategories$createCreditCategory, apiClient, formFields);
		}
	});
var $author$project$Pages$Admin$CreditCategories$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__CreditCategories)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$CreditCategories$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cN: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cN: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Mj: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$CreditCategories$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var creditCategory = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Mj: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$CreditCategory$All$id(creditCategory)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$CreditCategories$formFieldsFromCreditCategory(creditCategory)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Mj: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				var _v2 = model.Mj;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var creditCategory = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CreditCategories$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Mj: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, creditCategory))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CreditCategories$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Mj: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$CreditCategories$saveCreditCategory, model.D5, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Mj: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 5:
				var creditCategory = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ib: $elm$core$Maybe$Just(creditCategory)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var response = msg.a;
				var _v6 = model.Mj;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						var creditCategory = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cN: $author$project$Api$Data$Loading, Mj: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$CreditCategory$One$name(creditCategory))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Mj: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v9 = model.Mj;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var creditCategory = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cN: $author$project$Api$Data$Loading, Mj: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$CreditCategory$One$name(creditCategory) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Mj: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var creditCategory = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cN: $author$project$Api$Data$Loading,
									dK: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$CreditCategory$All$id(creditCategory),
										model.dK)
								}),
							$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$CreditCategory$All$name(creditCategory) + ' was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dK: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$CreditCategory$All$id(creditCategory),
										model.dK)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var creditCategory = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$CreditCategory$All$id(creditCategory);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dK: A2($elm$core$Set$insert, id, model.dK),
								ib: $elm$core$Maybe$Nothing
							}),
						A3(
							$author$project$Api$Provider$CreditCategory$delete,
							model.D5,
							id,
							$author$project$Pages$Admin$CreditCategories$CreditCategoryDeleted(creditCategory)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ib: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{cN: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(newModel),
								$author$project$Pages$Admin$CreditCategories$updateUrl(newModel)
							])),
					_List_Nil);
			case 13:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(newModel),
								$author$project$Pages$Admin$CreditCategories$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v13 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v13.a;
				var searchInputCmd = _v13.b;
				var searchInputEvent = _v13.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v14 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								cN: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$CreditCategories$fetchCreditCategories(qModel),
										$author$project$Pages$Admin$CreditCategories$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v14.a;
				var cmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$CreditCategories$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$CreditCategories$NewCreditCategory = {$: 1};
var $author$project$Pages$Admin$CreditCategories$PaginationMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$CreditCategories$AmountInCents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$CreditCategories$ExpiresInDays = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$CreditCategories$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$CreditCategories$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$CreditCategories$SaveCreditCategory = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$CreditCategories$viewCreditCategoryModal = F3(
	function (id, form, creditCategory) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Credit Category',
			S_: _Utils_eq(creditCategory, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit,
			U0: $author$project$Pages$Admin$CreditCategories$SaveCreditCategory(form)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var name = _v0.zh;
		var amountInCents = _v0.I2;
		var expiresInDays = _v0.O_;
		var canSetAmount = _v0.KC;
		var canSetExpiration = _v0.KD;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Refer a Friend'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Amount')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$value(amountInCents),
									$author$project$Ui$Form$CurrencyInput$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$AmountInCents)),
									$author$project$Ui$Form$CurrencyInput$placeholder('25.00'),
									$author$project$Ui$Form$CurrencyInput$disabled(!canSetAmount)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Expiration')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, expiresInDays))),
											$author$project$Ui$Form$Input$placeholder('60'),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$ExpiresInDays)),
											$author$project$Ui$Form$Input$disabled(!canSetExpiration)
										])),
									$author$project$Ui$Form$Input$addon(
									_List_fromArray(
										[
											$elm$html$Html$text('days')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$CreditCategories$SortTable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$CreditCategories$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name'),
		A3($author$project$Api$Column$init, 'amount', false, 'Amount'),
		A3($author$project$Api$Column$init, 'expiration', false, 'Expiration')
	]);
var $author$project$Pages$Admin$CreditCategories$help = _List_fromArray(
	[
		$elm$html$Html$text('Credit categories let you easily create and track similar credits by prefilling repeated fields. '),
		$elm$html$Html$text('You cannot add credits to an account without first adding credit categories. '),
		$elm$html$Html$text('Amount and expiration are optional fields. '),
		$elm$html$Html$text('For more information see our '),
		A3(
		$author$project$Ui$Link$externalHref,
		'https://support.hint.com/account-configuration/adding-and-applying-credits',
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				$elm$html$Html$text('help docs')
			])),
		$elm$html$Html$text('.')
	]);
var $author$project$Pages$Admin$CreditCategories$DeleteCreditCategory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$CreditCategories$EditCreditCategory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CreditCategory$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.RJ;
};
var $author$project$Api$Provider$CreditCategory$All$isDestroyable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CreditCategory$Shared$isDestroyable(shared);
};
var $author$project$Pages$Admin$CreditCategories$viewCreditCategory = F2(
	function (deletingCreditCategories, creditCategory) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$CreditCategory$All$name(creditCategory))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$CreditCategory$All$amountInCents(creditCategory);
							if (!_v0.$) {
								var amountInCents = _v0.a;
								return $elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(amountInCents));
							} else {
								return $elm$html$Html$text('No prefilled amount');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = $author$project$Api$Provider$CreditCategory$All$expiresInDays(creditCategory);
							if (!_v1.$) {
								var expiresInDays = _v1.a;
								return $elm$html$Html$text(
									A2($author$project$Formatters$String$pluralize, 'day', expiresInDays));
							} else {
								return $elm$html$Html$text('Does not expire');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Edit credit category'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Admin$CreditCategories$EditCreditCategory(creditCategory)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Edit')
								])),
							function () {
							if ($author$project$Api$Provider$CreditCategory$All$isDestroyable(creditCategory)) {
								var id = $author$project$Api$Provider$CreditCategory$All$id(creditCategory);
								var loading = A2($elm$core$Set$member, id, deletingCreditCategories);
								return A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete credit category'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$size(0),
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$CreditCategories$DeleteCreditCategory(creditCategory)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Admin$CreditCategories$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.cN;
		if (_v1.$ === 3) {
			var creditCategories_ = _v1.a;
			return _Utils_Tuple2(false, creditCategories_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var creditCategories = _v0.b;
	return _List_fromArray(
		[
			A2($author$project$Ui$Typography$p, _List_Nil, $author$project$Pages$Admin$CreditCategories$help),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Admin$CreditCategories$SearchInputMsg,
							A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('None, add a category to be able to create credits.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$CreditCategories$SortTable)),
						$author$project$Pages$Admin$CreditCategories$columns),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$header,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Tooltip$view,
											_List_Nil,
											'Upload from CSV',
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Admin__Credits__Upload,
													_List_fromArray(
														[
															$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$upload),
															$author$project$Ui$Link$ariaLabel('Upload')
														]),
													_List_Nil)
												]))
										]))
								]))
						])
					])),
			A2(
				$elm$core$List$map,
				$author$project$Pages$Admin$CreditCategories$viewCreditCategory(model.dK),
				creditCategories),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$CreditCategories$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.Mj;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var creditCategory = _v1.c;
					return A3($author$project$Pages$Admin$CreditCategories$viewCreditCategoryModal, id, form, creditCategory);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ib;
				if (!_v2.$) {
					var creditCategory = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$CreditCategories$HiConfirmClosed(creditCategory),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('credit category'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$CreditCategory$All$name(creditCategory) + '. This will not affect outstanding credits')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										$elm$html$Html$text('Credit Categories')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Create new credit category'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$pull(1),
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$CreditCategories$NewCreditCategory),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Credit Category')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$CreditCategories$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$CreditCategories$PaginationMsg,
								A2($author$project$Api$Pagination$view, _List_Nil, model.afy))
							]))
					]))
			]),
		$G: 'Admin | Credit Categories'
	};
};
var $author$project$Pages$Admin$CreditCategories$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$CreditCategories$init, aer: $author$project$Pages$Admin$CreditCategories$load, agD: $author$project$Pages$Admin$CreditCategories$save, ahd: $author$project$Pages$Admin$CreditCategories$subscriptions, aaq: $author$project$Pages$Admin$CreditCategories$update, ahP: $author$project$Pages$Admin$CreditCategories$view});
var $author$project$Api$Upload$Resource$Credit = 0;
var $author$project$Pages$Admin$Credits$Upload$UploadFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Credits$Upload$init = F4(
	function (_v0, _v1, shared, _v2) {
		var _v3 = A4($author$project$Components$Upload$Form$init, shared.Hy, shared.D5, 0, $elm$core$Maybe$Nothing);
		var uploadForm = _v3.a;
		var uploadFormCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: uploadForm},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
	});
var $author$project$Pages$Admin$Credits$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Credits$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Credits$Upload$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Upload$Form$subscriptions(model.PB));
};
var $author$project$Pages$Admin$Credits$Upload$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Upload$Form$update, model.D5, subMsg, model.PB);
		var uploadForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: uploadForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsgs);
	});
var $author$project$Pages$Admin$Credits$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(12)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Import Patient Credits Information')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$identity,
										A2($author$project$Components$Upload$Form$view, model.D5, model.PB))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Credits$Upload$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A2($author$project$Components$Upload$Form$modal, model.D5, model.PB)),
				$author$project$Pages$Admin$Credits$Upload$viewBody(model)
			]),
		$G: 'Admin | Credits'
	};
};
var $author$project$Pages$Admin$Credits$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Credits$Upload$init, aer: $author$project$Pages$Admin$Credits$Upload$load, agD: $author$project$Pages$Admin$Credits$Upload$save, ahd: $author$project$Pages$Admin$Credits$Upload$subscriptions, aaq: $author$project$Pages$Admin$Credits$Upload$update, ahP: $author$project$Pages$Admin$Credits$Upload$view});
var $author$project$Pages$Admin$DataExport$Id_String$GotDataExports = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$DataExportGroup$dataExportGroupsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['data_export_groups']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$DataExportGroup$dataExportGroupPath = function (dataExportGroupId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[dataExportGroupId]),
		$author$project$Api$Provider$DataExportGroup$dataExportGroupsPath);
};
var $author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath = function (dataExportGroupId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['data_exports']),
		$author$project$Api$Provider$DataExportGroup$dataExportGroupPath(dataExportGroupId));
};
var $author$project$Api$Provider$DataExport$All$DataExport = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$DataExport$Shared$DataExport = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExport$Shared$Record = F8(
	function (id, exportFileName, encrypted, status, exportedAt, errorMessage, exportGenerated, dataExportConfiguration) {
		return {MK: dataExportConfiguration, Ov: encrypted, ON: errorMessage, O1: exportFileName, O2: exportGenerated, O3: exportedAt, adR: id, ag7: status};
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$DataExportConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportConfiguration$Shared$Record = function (id) {
	return function (enabled) {
		return function (contactEmail) {
			return function (contactPhone) {
				return function (destination) {
					return function (sftpHost) {
						return function (sftpPort) {
							return function (sftpUsername) {
								return function (s3Bucket) {
									return function (s3Region) {
										return function (encryptionKey) {
											return function (encryptionRecipient) {
												return function (testExportFileName) {
													return function (incrementalMode) {
														return function (excludeDefaultTables) {
															return function (manualExportPerformed) {
																return function (fileNameFormat) {
																	return {LK: contactEmail, LM: contactPhone, Nz: destination, Ot: enabled, Ow: encryptionKey, Ox: encryptionRecipient, OR: excludeDefaultTables, Pn: fileNameFormat, adR: id, QT: incrementalMode, Tf: manualExportPerformed, YZ: s3Bucket, Y_: s3Region, ZI: sftpHost, ZJ: sftpPort, ZK: sftpUsername, $z: testExportFileName};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'file_name_format',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'manual_export_performed',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'exclude_default_tables',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'incremental_mode',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'test_export_file_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'encryption_recipient',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'encryption_key',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								's3_region',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									's3_bucket',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'sftp_username',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'sftp_port',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'sftp_host',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'destination',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'contact_phone',
														$elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'contact_email',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'enabled',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportConfiguration$Shared$Record))))))))))))))))));
var $author$project$Api$Provider$DataExportConfiguration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportConfiguration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data_export_configuration',
	$author$project$Api$Provider$DataExportConfiguration$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'export_generated',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'exported_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'encrypted',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'export_file_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$Shared$Record)))))))));
var $author$project$Api$Provider$DataExport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExport$All$Record = function (entityName) {
	return {OJ: entityName};
};
var $author$project$Api$Provider$DataExport$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'entity_name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$All$Record));
var $author$project$Api$Provider$DataExport$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExport$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$DataExport$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$All$DataExport)));
var $author$project$Api$Provider$DataExportGroup$DataExport$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$DataExportGroup$DataExport$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$DataExportGroup$DataExport$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$DataExportGroup$DataExport$list = F4(
	function (apiClient, dataExportGroupId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$DataExportGroup$DataExport$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath(dataExportGroupId))));
	});
var $author$project$Pages$Admin$DataExport$Id_String$fetchDataExports = function (model) {
	return A4(
		$author$project$Api$Provider$DataExportGroup$DataExport$list,
		model.D5,
		model.adR,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, ag1: model.ag1});
		},
		$author$project$Pages$Admin$DataExport$Id_String$GotDataExports);
};
var $author$project$Pages$Admin$DataExport$Id_String$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var params = _v2.Vx;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: shared.D5,
			MM: $author$project$Api$Data$Loading,
			adR: params.adR,
			FR: $author$project$Shared$isHintAdmin(shared),
			afy: $author$project$Api$Pagination$initFromQuery(query),
			af_: q,
			jM: $elm$core$Maybe$Nothing,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: $author$project$Api$Sort$initFromQuery(query),
			Hy: shared.Hy
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(model));
	});
var $author$project$Pages$Admin$DataExport$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExport$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close = {$: 0};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close);
};
var $author$project$Pages$Admin$DataExport$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg),
			A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$subscriptions, model.jM)));
};
var $author$project$Pages$Admin$DataExport$Id_String$GotSignedFileUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$init = F2(
	function (dataExportGroupId, dataExport) {
		return {hP: false, w0: dataExport, ET: dataExportGroupId, nW: $author$project$Api$Data$NotAsked};
	});
var $author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath = F2(
	function (dataExportGroupId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath(dataExportGroupId));
	});
var $author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrlDecoder = A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string);
var $author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrl = F4(
	function (apiClient, dataExportGroupId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrlDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_file_url']),
					A2($author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath, dataExportGroupId, id_))));
	});
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Closed = 1;
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$GotRemoveResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$None = 0;
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Removed = 2;
var $author$project$Api$Provider$DataExport$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$DataExport$Shared$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.adR;
	});
var $author$project$Api$Provider$DataExport$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$id(shared);
};
var $author$project$Api$Provider$DataExport$One$DataExport = 0;
var $author$project$Api$Provider$DataExport$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$DataExportGroup$DataExport$removeFromDestination = F4(
	function (apiClient, dataExportGroupId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DataExport$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['remove_from_destination']),
					A2($author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath, dataExportGroupId, id))));
	});
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				return model.hP ? {
					EC: A4(
						$author$project$Api$Provider$DataExportGroup$DataExport$removeFromDestination,
						apiClient,
						model.ET,
						$author$project$Api$Provider$DataExport$All$id(model.w0),
						$author$project$Components$Admin$DataExport$RemoveFromDestinationModal$GotRemoveResponse),
					ac5: 0,
					y8: _Utils_update(
						model,
						{nW: $author$project$Api$Data$Loading}),
					as: _List_Nil
				} : {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{nW: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Export removed.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{nW: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var bool = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{hP: bool}),
					as: _List_Nil
				};
		}
	});
var $author$project$Pages$Admin$DataExport$Id_String$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Admin__DataExport__Id_String(
						{adR: model.adR}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$DataExport$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								MM: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{MM: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(newModel),
								$author$project$Pages$Admin$DataExport$Id_String$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(newModel),
								$author$project$Pages$Admin$DataExport$Id_String$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var dataExportId = msg.a;
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrl, model.D5, model.adR, dataExportId, $author$project$Pages$Admin$DataExport$Id_String$GotSignedFileUrl),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var dataExport = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jM: $elm$core$Maybe$Just(
								A2($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$init, model.adR, dataExport))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = model.jM;
				if (!_v3.$) {
					var removeFromDestinationModal = _v3.a;
					var result = A3($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$update, model.D5, subMsg, removeFromDestinationModal);
					var _v4 = function () {
						var _v5 = result.ac5;
						switch (_v5) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(result.y8),
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									$author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(model));
						}
					}();
					var updatedRemoveFromDestinationModal = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jM: updatedRemoveFromDestinationModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg, result.EC)
								])),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$DataExport$Id_String$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Remove = {$: 1};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$ConfirmUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewConfirmInput = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.hP),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$ConfirmUpdated)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('By checking this box I confirm that I have verified that the files to be removed'),
								$elm$html$Html$text('and the destination server accurate.')
							]))
					])),
				$author$project$Utils$FormErrors$view(
				model.hP ? _List_Nil : _List_fromArray(
					['Please confirm that the files to be removed and the destination server and path are accurate.']))
			]));
};
var $author$project$Api$Provider$DataExport$Shared$dataExportConfiguration = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.MK;
	});
var $author$project$Api$Provider$DataExport$All$dataExportConfiguration = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$dataExportConfiguration(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$destination = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Nz;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.YZ;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$s3Region = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Y_;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.ZI;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.ZJ;
	});
var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.ZK;
	});
var $author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription = function (dataExportConfiguration) {
	var _v0 = $author$project$Api$Provider$DataExportConfiguration$Shared$destination(dataExportConfiguration);
	switch (_v0) {
		case 'sftp':
			return 'sftp://' + (A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername(dataExportConfiguration)) + ('@' + (A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost(dataExportConfiguration)) + (':' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$fromInt,
					$author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort(dataExportConfiguration)))))));
		case 's3':
			return 's3://' + (A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$DataExportConfiguration$Shared$s3Region(dataExportConfiguration)) + ('/' + A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(dataExportConfiguration))));
		default:
			return 'unknown destination';
	}
};
var $author$project$Api$Provider$DataExport$All$entityName = function (_v0) {
	var record = _v0.b;
	return record.OJ;
};
var $author$project$Api$Provider$DataExport$Shared$exportFileName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.O1;
	});
var $author$project$Api$Provider$DataExport$All$exportFileName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$exportFileName(shared);
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewPreview = function (dataExport) {
	var dataExportConfiguration = $author$project$Api$Provider$DataExport$All$dataExportConfiguration(dataExport);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('The platform will remove the following files from the given destination.')
					])),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Entity Name: ')
					])),
				$elm$html$Html$text(
				$author$project$Api$Provider$DataExport$All$entityName(dataExport)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Destination: ')
					])),
				$elm$html$Html$text(
				$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Files: ')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Provider$DataExport$All$exportFileName(dataExport)))
							]))
					]))
			]));
};
var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Remove From Destination')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewPreview(model.w0),
						$author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewConfirmInput(model)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Remove From Destination'},
						_List_fromArray(
							[
								$author$project$Ui$Button$pull(1),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Remove),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
								$author$project$Ui$Button$disabled(!model.hP),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.nW, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Remove From Destination')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$DataExport$Id_String$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$DataExport$Id_String$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
		A3($author$project$Api$Column$init, 'export_file_name', true, 'Export File Name'),
		A3($author$project$Api$Column$init, 'encrypted', true, 'Encrypted'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'exported_at', true, 'Exported At'),
		A3($author$project$Api$Column$init, 'error_message', false, 'Error Message')
	]);
var $author$project$Components$Admin$DataExportConfiguration$Help$view = A2(
	$author$project$Ui$Typography$p,
	_List_fromArray(
		[$author$project$Ui$Typography$muted]),
	_List_fromArray(
		[
			$elm$html$Html$text('See our '),
			A3(
			$author$project$Ui$Link$externalHref,
			'https://docs.google.com/document/d/1s8wgwrN-Ltlw6r0w_g7WflS7DLZS4SFARQBgKxCYvfs/edit?tab=t.0',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('developer documentation')
				])),
			$elm$html$Html$text(' and'),
			A3(
			$author$project$Ui$Link$externalHref,
			'https://miro.com/app/board/uXjVIg-hLbw=/?moveToWidget=3458764635611947784&cot=14',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('ERD Schema')
				])),
			$elm$html$Html$text(' for standard Data Exporter tables.')
		]));
var $author$project$Formatters$Time$DateTime__Full = 4;
var $author$project$Pages$Admin$DataExport$Id_String$OpenFileDocument = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$DataExport$Id_String$OpenRemoveFromDestinationModal = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$DataExport$Shared$encrypted = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.Ov;
	});
var $author$project$Api$Provider$DataExport$All$encrypted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$encrypted(shared);
};
var $author$project$Api$Provider$DataExport$Shared$errorMessage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.ON;
	});
var $author$project$Api$Provider$DataExport$All$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$DataExport$Shared$exportGenerated = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.O2;
	});
var $author$project$Api$Provider$DataExport$All$exportGenerated = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$exportGenerated(shared);
};
var $author$project$Api$Provider$DataExport$Shared$exportedAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.O3;
	});
var $author$project$Api$Provider$DataExport$All$exportedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$exportedAt(shared);
};
var $author$project$Api$Provider$DataExport$Shared$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExport$Shared$record,
	function ($) {
		return $.ag7;
	});
var $author$project$Api$Provider$DataExport$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExport$Shared$status(shared);
};
var $author$project$Pages$Admin$DataExport$Id_String$viewDataExport = F3(
	function (timeFormatter, isHintAdmin, dataExport) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(
								$author$project$Api$Provider$DataExport$All$dataExportConfiguration(dataExport)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$DataExport$All$exportFileName(dataExport)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Bool$toString(
										$author$project$Api$Provider$DataExport$All$encrypted(dataExport)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$DataExport$All$status(dataExport))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(4),
									$author$project$Api$Provider$DataExport$All$exportedAt(dataExport))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$DataExport$All$errorMessage(dataExport)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							(isHintAdmin && $author$project$Api$Provider$DataExport$All$exportGenerated(dataExport)) ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$pull(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									'Download file',
									_List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$button,
											{abp: 'Download file'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$DataExport$Id_String$OpenFileDocument(
														$author$project$Api$Provider$DataExport$All$id(dataExport))),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$export)
												]),
											_List_Nil)
										]))
								])) : $author$project$Utils$Html$empty,
							(isHintAdmin && ($author$project$Api$Provider$DataExport$All$status(dataExport) === 'exported')) ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$pull(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									'Remove from destination',
									_List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$button,
											{abp: 'Remove from destination'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$DataExport$Id_String$OpenRemoveFromDestinationModal(dataExport))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove from destination')
												]))
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Admin$DataExport$Id_String$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.MM;
		if (_v1.$ === 3) {
			var dataExports_ = _v1.a;
			return _Utils_Tuple2(false, dataExports_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var dataExports = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage exports.'),
					$author$project$Components$Admin$DataExportConfiguration$Help$view
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No exports found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$DataExport$Id_String$SortTable)),
						$author$project$Pages$Admin$DataExport$Id_String$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Admin$DataExport$Id_String$viewDataExport, model.Hy, model.FR),
				dataExports),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$DataExport$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$view, model.jM))),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Admin__DataExport__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Exports')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(model.adR)
												]))
										])))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$DataExport$Id_String$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.MM;
								if (_v0.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$DataExport$Id_String$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.afy));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		$G: 'Admin | Data Exporter | Exports'
	};
};
var $author$project$Pages$Admin$DataExport$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$DataExport$Id_String$init, aer: $author$project$Pages$Admin$DataExport$Id_String$load, agD: $author$project$Pages$Admin$DataExport$Id_String$save, ahd: $author$project$Pages$Admin$DataExport$Id_String$subscriptions, aaq: $author$project$Pages$Admin$DataExport$Id_String$update, ahP: $author$project$Pages$Admin$DataExport$Id_String$view});
var $author$project$Pages$Admin$DataExport$Top$GotDataExportGroups = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$DataExportGroup$All$DataExportGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$DataExportGroup$Shared$DataExportGroup = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportGroup$Shared$Record = F3(
	function (id, timestamp, dataExportConfiguration) {
		return {MK: dataExportConfiguration, adR: id, $E: timestamp};
	});
var $author$project$Api$Provider$DataExportGroup$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data_export_configuration',
	$author$project$Api$Provider$DataExportConfiguration$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'timestamp',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$Shared$Record))));
var $author$project$Api$Provider$DataExportGroup$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportGroup$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExportGroup$All$Record = F2(
	function (entityName, dataExports) {
		return {MM: dataExports, OJ: entityName};
	});
var $author$project$Api$Provider$DataExportGroup$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data_exports',
	$elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'entity_name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$All$Record)));
var $author$project$Api$Provider$DataExportGroup$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportGroup$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$DataExportGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$All$DataExportGroup)));
var $author$project$Api$Provider$DataExportGroup$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$DataExportGroup$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$DataExportGroup$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$DataExportGroup$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$DataExportGroup$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$DataExportGroup$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportGroup$dataExportGroupsPath)));
	});
var $author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups = function (model) {
	return A3(
		$author$project$Api$Provider$DataExportGroup$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, ag1: model.ag1});
		},
		$author$project$Pages$Admin$DataExport$Top$GotDataExportGroups);
};
var $author$project$Pages$Admin$DataExport$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: shared.D5,
			lK: $author$project$Api$Data$Loading,
			FR: $author$project$Shared$isHintAdmin(shared),
			afy: $author$project$Api$Pagination$initFromQuery(query),
			af_: q,
			jM: $elm$core$Maybe$Nothing,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'timestamp',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hy: shared.Hy
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(model));
	});
var $author$project$Pages$Admin$DataExport$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExport$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close = {$: 0};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close);
};
var $author$project$Pages$Admin$DataExport$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg),
			A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$subscriptions, model.jM)));
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$init = function (dataExportGroup) {
	return {hP: false, w1: dataExportGroup, nW: $author$project$Api$Data$NotAsked};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Closed = 1;
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$GotRemoveResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$None = 0;
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Removed = 2;
var $author$project$Api$Provider$DataExportGroup$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$DataExportGroup$Shared$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportGroup$Shared$record,
	function ($) {
		return $.adR;
	});
var $author$project$Api$Provider$DataExportGroup$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExportGroup$Shared$id(shared);
};
var $author$project$Api$Provider$DataExportGroup$One$DataExportGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$DataExportGroup$One$Record = F2(
	function (entityName, dataExports) {
		return {MM: dataExports, OJ: entityName};
	});
var $author$project$Api$Provider$DataExportGroup$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'data_exports',
	$elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'entity_name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$One$Record)));
var $author$project$Api$Provider$DataExportGroup$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportGroup$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$DataExportGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$One$DataExportGroup)));
var $author$project$Api$Provider$DataExportGroup$removeFromDestination = F3(
	function (apiClient, dataExportGroupId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DataExportGroup$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['remove_from_destination']),
					$author$project$Api$Provider$DataExportGroup$dataExportGroupPath(dataExportGroupId))));
	});
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				return model.hP ? {
					EC: A3(
						$author$project$Api$Provider$DataExportGroup$removeFromDestination,
						apiClient,
						$author$project$Api$Provider$DataExportGroup$All$id(model.w1),
						$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$GotRemoveResponse),
					ac5: 0,
					y8: _Utils_update(
						model,
						{nW: $author$project$Api$Data$Loading}),
					as: _List_Nil
				} : {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{nW: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Export removed.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{nW: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var bool = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{hP: bool}),
					as: _List_Nil
				};
		}
	});
var $author$project$Pages$Admin$DataExport$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__DataExport__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$DataExport$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lK: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lK: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(newModel),
								$author$project$Pages$Admin$DataExport$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(newModel),
								$author$project$Pages$Admin$DataExport$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var dataExportGroup = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jM: $elm$core$Maybe$Just(
								$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$init(dataExportGroup))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = model.jM;
				if (!_v2.$) {
					var removeFromDestinationModal = _v2.a;
					var result = A3($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$update, model.D5, subMsg, removeFromDestinationModal);
					var updatedRemoveFromDestinationModal = function () {
						var _v3 = result.ac5;
						switch (_v3) {
							case 0:
								return $elm$core$Maybe$Just(result.y8);
							case 1:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jM: updatedRemoveFromDestinationModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg, result.EC),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$DataExport$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Remove = {$: 1};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$ConfirmUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewConfirmInput = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.hP),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$ConfirmUpdated)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('By checking this box I confirm that I have verified that the files to be removed'),
								$elm$html$Html$text('and the destination server accurate.')
							]))
					])),
				$author$project$Utils$FormErrors$view(
				model.hP ? _List_Nil : _List_fromArray(
					['Please confirm that the files to be removed and the destination server and path are accurate.']))
			]));
};
var $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportGroup$Shared$record,
	function ($) {
		return $.MK;
	});
var $author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration(shared);
};
var $author$project$Api$Provider$DataExportGroup$All$dataExports = function (_v0) {
	var record = _v0.b;
	return record.MM;
};
var $author$project$Api$Provider$DataExportGroup$All$entityName = function (_v0) {
	var record = _v0.b;
	return record.OJ;
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewDataExport = function (dataExport) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					$author$project$Api$Provider$DataExport$Shared$exportFileName(dataExport)))
			]));
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewPreview = function (dataExportGroup) {
	var dataExportConfiguration = $author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration(dataExportGroup);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('The platform will remove the following files from the given destination.')
					])),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Entity Name: ')
					])),
				$elm$html$Html$text(
				$author$project$Api$Provider$DataExportGroup$All$entityName(dataExportGroup)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Destination: ')
					])),
				$elm$html$Html$text(
				$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Files: ')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewDataExport,
					$author$project$Api$Provider$DataExportGroup$All$dataExports(dataExportGroup)))
			]));
};
var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Remove From Destination')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewPreview(model.w1),
						$author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewConfirmInput(model)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Remove From Destination'},
						_List_fromArray(
							[
								$author$project$Ui$Button$pull(1),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Remove),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
								$author$project$Ui$Button$disabled(!model.hP),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.nW, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Remove From Destination')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$DataExport$Top$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$DataExport$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
		A3($author$project$Api$Column$init, 'timestamp', true, 'Exported At')
	]);
var $author$project$Pages$Admin$DataExport$Top$OpenRemoveFromDestinationModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$DataExportGroup$Shared$timestamp = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportGroup$Shared$record,
	function ($) {
		return $.$E;
	});
var $author$project$Api$Provider$DataExportGroup$All$timestamp = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExportGroup$Shared$timestamp(shared);
};
var $author$project$Pages$Admin$DataExport$Top$viewDataExportGroup = F3(
	function (timeFormatter, isHintAdmin, dataExportGroup) {
		var withLink = function (contents) {
			return A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__DataExport__Id_String(
					{
						adR: $author$project$Api$Provider$DataExportGroup$All$id(dataExportGroup)
					}),
				_List_Nil,
				contents);
		};
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							withLink(
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(
										$author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration(dataExportGroup)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							withLink(
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										4,
										$author$project$Api$Provider$DataExportGroup$All$timestamp(dataExportGroup)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							isHintAdmin ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$pull(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									'Remove from destination',
									_List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$button,
											{abp: 'Remove from destination'},
											_List_fromArray(
												[
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$DataExport$Top$OpenRemoveFromDestinationModal(dataExportGroup))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove from destination')
												]))
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Admin$DataExport$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.lK;
		if (_v1.$ === 3) {
			var dataExportGroups_ = _v1.a;
			return _Utils_Tuple2(false, dataExportGroups_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var dataExportGroups = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage exports.'),
					$author$project$Components$Admin$DataExportConfiguration$Help$view
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No exports found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$DataExport$Top$SortTable)),
						$author$project$Pages$Admin$DataExport$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Admin$DataExport$Top$viewDataExportGroup, model.Hy, model.FR),
				dataExportGroups),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$DataExport$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$view, model.jM))),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Exports')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$DataExport$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.lK;
								if (_v0.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$DataExport$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.afy));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		$G: 'Admin | Data Exporter | Exports'
	};
};
var $author$project$Pages$Admin$DataExport$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$DataExport$Top$init, aer: $author$project$Pages$Admin$DataExport$Top$load, agD: $author$project$Pages$Admin$DataExport$Top$save, ahd: $author$project$Pages$Admin$DataExport$Top$subscriptions, aaq: $author$project$Pages$Admin$DataExport$Top$update, ahP: $author$project$Pages$Admin$DataExport$Top$view});
var $author$project$Pages$Admin$DataExportSettings$Id_String$DataExportConfigurationFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfiguration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$PhoneInput$require = F2(
	function (required, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{agk: required});
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput = function (maybePhone) {
	return A2(
		$author$project$Components$PhoneInput$require,
		true,
		A3(
			$author$project$Components$PhoneInput$init,
			'data-export-configuration-contact-phone-input',
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					{Gj: '', agc: 0, ahI: $author$project$Api$Common$Phone$Shared$Mobile},
					A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone))
				]),
			function (opts) {
				return _Utils_update(
					opts,
					{abk: false, yQ: 1});
			}));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$emptyFormFieldsInit = function (isHintAdmin) {
	return {
		LK: $elm$core$Maybe$Nothing,
		LM: $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput($elm$core$Maybe$Nothing),
		Nz: $elm$core$Maybe$Nothing,
		Ot: false,
		iB: false,
		Ow: $elm$core$Maybe$Nothing,
		Ox: $elm$core$Maybe$Nothing,
		OR: !isHintAdmin,
		Pn: $elm$core$Maybe$Just(':timestamp:/:file_name:'),
		mu: false,
		Tf: false,
		YZ: $elm$core$Maybe$Nothing,
		Y_: $elm$core$Maybe$Nothing,
		ZI: $elm$core$Maybe$Nothing,
		ZJ: $elm$core$Maybe$Nothing,
		Ha: $elm$core$Maybe$Nothing,
		sH: false,
		ZK: $elm$core$Maybe$Nothing
	};
};
var $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['data_export_configurations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath);
};
var $author$project$Api$Provider$DataExportConfiguration$One$DataExportConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportConfiguration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportConfiguration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExportConfiguration$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$DataExportConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id)));
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$init = F4(
	function (apiClient, isHintAdmin, id, singleton) {
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple3(
					$elm$core$Maybe$Nothing,
					$author$project$Api$Data$Loading,
					A3($author$project$Api$Provider$DataExportConfiguration$retrieve, apiClient, id_, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfiguration));
			} else {
				return _Utils_Tuple3(
					$elm$core$Maybe$Just(
						$author$project$Utils$Form$init(
							$author$project$Components$Admin$DataExportConfiguration$Form$emptyFormFieldsInit(isHintAdmin))),
					$author$project$Api$Data$NotAsked,
					$elm$core$Platform$Cmd$none);
			}
		}();
		var form = _v0.a;
		var dataExportConfiguration = _v0.b;
		var retrieveCmd = _v0.c;
		var model = {MK: dataExportConfiguration, iE: $elm$core$Maybe$Nothing, PB: form, adR: id, FR: isHintAdmin, jY: $author$project$Api$Data$NotAsked, sV: singleton, kt: $elm$core$Maybe$Nothing};
		return _Utils_Tuple2(model, retrieveCmd);
	});
var $author$project$Pages$Admin$DataExportSettings$Id_String$init = F4(
	function (_v0, _v1, shared, _v2) {
		var params = _v2.Vx;
		var query = _v2.Bi;
		var singleton = _Utils_eq(
			A2($elm$core$Dict$get, 'singleton', query),
			$elm$core$Maybe$Just('true'));
		var _v3 = A4(
			$author$project$Components$Admin$DataExportConfiguration$Form$init,
			shared.D5,
			$author$project$Shared$isHintAdmin(shared),
			$elm$core$Maybe$Just(params.adR),
			singleton);
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$DataExportSettings$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExportSettings$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Close = {$: 0};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportConfiguration$ExportModal$Close);
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close = {$: 0};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close);
};
var $author$project$Components$PhoneInput$subscriptions = function (_v0) {
	var model = _v0;
	var phones = $author$project$Utils$Form$fields(model.PB);
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var typeDropdown = _v1.b;
				var regionDropdown = _v1.c;
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$subscriptions(typeDropdown),
							$author$project$Ui$NewDropdown$subscriptions(regionDropdown)
						]));
			},
			phones));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions, model.kt))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions, model.iE))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg),
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$PhoneInput$subscriptions,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.LM;
							},
							A2($elm$core$Maybe$map, $author$project$Utils$Form$fields, model.PB)))))
			]));
};
var $author$project$Pages$Admin$DataExportSettings$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$DataExportConfiguration$Form$subscriptions(model.PB));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$None = {$: 0};
var $author$project$Components$Admin$DataExportConfiguration$Form$Saved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$Phone$Shared$typeEncoder = function (type__) {
	switch (type__.$) {
		case 0:
			return $elm$json$Json$Encode$string('mobile');
		case 1:
			return $elm$json$Json$Encode$string('home');
		case 2:
			return $elm$json$Json$Encode$string('office');
		default:
			var otherDescription = type__.a;
			return $elm$json$Json$Encode$string(otherDescription);
	}
};
var $author$project$Api$Common$Phone$Shared$encode = function (phone) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'type',
				$author$project$Api$Common$Phone$Shared$typeEncoder(phone.ahI)),
				_Utils_Tuple2(
				'number',
				$elm$json$Json$Encode$string(phone.Gj)),
				_Utils_Tuple2(
				'us_formattable',
				$elm$json$Json$Encode$bool(phone.HM))
			]));
};
var $author$project$Api$Provider$DataExportConfiguration$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'data_export_configuration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(fields.Ot)),
								_Utils_Tuple2(
								'contact_email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.LK)),
								_Utils_Tuple2(
								'contact_phone',
								A2($author$project$Utils$Encode$nullable, $author$project$Api$Common$Phone$Shared$encode, fields.LM)),
								_Utils_Tuple2(
								'destination',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Nz)),
								_Utils_Tuple2(
								'sftp_host',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZI)),
								_Utils_Tuple2(
								'sftp_port',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.ZJ)),
								_Utils_Tuple2(
								'sftp_username',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZK)),
								_Utils_Tuple2(
								'sftp_private_key',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Ha)),
								_Utils_Tuple2(
								's3_bucket',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.YZ)),
								_Utils_Tuple2(
								's3_region',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Y_)),
								_Utils_Tuple2(
								'encryption_key',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Ow)),
								_Utils_Tuple2(
								'encryption_recipient',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Ox)),
								_Utils_Tuple2(
								'incremental_mode',
								$elm$json$Json$Encode$bool(fields.QT)),
								_Utils_Tuple2(
								'exclude_default_tables',
								$elm$json$Json$Encode$bool(fields.OR)),
								_Utils_Tuple2(
								'file_name_format',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Pn))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DataExportConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath)));
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString = function (destination) {
	if (!destination) {
		return 'sftp';
	} else {
		return 's3';
	}
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$contactEmail = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.LK;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$contactEmail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$contactEmail(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$contactPhone = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.LM;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$contactPhone = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$contactPhone(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$destination = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$destination(shared);
};
var $author$project$Components$Admin$DataExportConfiguration$Form$S3 = 1;
var $author$project$Components$Admin$DataExportConfiguration$Form$Sftp = 0;
var $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString = function (string) {
	switch (string) {
		case 'sftp':
			return $elm$core$Maybe$Just(0);
		case 's3':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$enabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Ot;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$enabled(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionKey = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Ow;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$encryptionKey = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionKey(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionRecipient = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Ox;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$encryptionRecipient = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionRecipient(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$excludeDefaultTables = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.OR;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$excludeDefaultTables = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$excludeDefaultTables(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$fileNameFormat = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Pn;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$fileNameFormat = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$fileNameFormat(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$incrementalMode = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.QT;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$incrementalMode = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$incrementalMode(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$manualExportPerformed = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.Tf;
	});
var $author$project$Api$Provider$DataExportConfiguration$One$manualExportPerformed = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$manualExportPerformed(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$s3Bucket = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$s3Region = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$s3Region(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$sftpHost = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$sftpPort = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$One$sftpUsername = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername(shared);
};
var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit = function (dataExportConfiguration) {
	var encryptionKey = $author$project$Api$Provider$DataExportConfiguration$One$encryptionKey(dataExportConfiguration);
	return {
		LK: $author$project$Api$Provider$DataExportConfiguration$One$contactEmail(dataExportConfiguration),
		LM: $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput(
			$author$project$Api$Provider$DataExportConfiguration$One$contactPhone(dataExportConfiguration)),
		Nz: $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString(
			$author$project$Api$Provider$DataExportConfiguration$One$destination(dataExportConfiguration)),
		Ot: $author$project$Api$Provider$DataExportConfiguration$One$enabled(dataExportConfiguration),
		iB: !_Utils_eq(encryptionKey, $elm$core$Maybe$Nothing),
		Ow: encryptionKey,
		Ox: $author$project$Api$Provider$DataExportConfiguration$One$encryptionRecipient(dataExportConfiguration),
		OR: $author$project$Api$Provider$DataExportConfiguration$One$excludeDefaultTables(dataExportConfiguration),
		Pn: $elm$core$Maybe$Just(
			$author$project$Api$Provider$DataExportConfiguration$One$fileNameFormat(dataExportConfiguration)),
		mu: $author$project$Api$Provider$DataExportConfiguration$One$incrementalMode(dataExportConfiguration),
		Tf: $author$project$Api$Provider$DataExportConfiguration$One$manualExportPerformed(dataExportConfiguration),
		YZ: $author$project$Api$Provider$DataExportConfiguration$One$s3Bucket(dataExportConfiguration),
		Y_: $author$project$Api$Provider$DataExportConfiguration$One$s3Region(dataExportConfiguration),
		ZI: $author$project$Api$Provider$DataExportConfiguration$One$sftpHost(dataExportConfiguration),
		ZJ: $author$project$Api$Provider$DataExportConfiguration$One$sftpPort(dataExportConfiguration),
		Ha: $elm$core$Maybe$Nothing,
		sH: true,
		ZK: $author$project$Api$Provider$DataExportConfiguration$One$sftpUsername(dataExportConfiguration)
	};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ot: bool});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						LK: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var phone = field.a;
				return _Utils_update(
					fields,
					{LM: phone});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Nz: $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString(string)
					});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ZI: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var _int = field.a;
				return _Utils_update(
					fields,
					{
						ZJ: $elm$core$String$toInt(_int)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ZK: $author$project$Utils$String$toMaybe(string)
					});
			case 7:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ha: $author$project$Utils$String$toMaybe(string)
					});
			case 8:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						YZ: $author$project$Utils$String$toMaybe(string)
					});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Y_: $author$project$Utils$String$toMaybe(string)
					});
			case 10:
				var bool = field.a;
				return _Utils_update(
					fields,
					{iB: bool});
			case 11:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ow: $author$project$Utils$String$toMaybe(string)
					});
			case 12:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ox: $author$project$Utils$String$toMaybe(string)
					});
			case 13:
				var bool = field.a;
				return _Utils_update(
					fields,
					{mu: bool});
			case 14:
				var bool = field.a;
				return _Utils_update(
					fields,
					{OR: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Pn: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$GotPreview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportConfiguration$export = F4(
	function (apiClient, id, _v0, toMsg) {
		var preview = _v0.afU;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'preview',
					$elm$json$Json$Encode$bool(preview))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DataExportGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['export']),
						$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id)))));
	});
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$init = F2(
	function (apiClient, dataExportConfigurationId) {
		return _Utils_Tuple2(
			{hP: false, ES: dataExportConfigurationId, ma: $author$project$Api$Data$NotAsked, sd: $author$project$Api$Data$Loading},
			A4(
				$author$project$Api$Provider$DataExportConfiguration$export,
				apiClient,
				dataExportConfigurationId,
				{afU: true},
				$author$project$Components$Admin$DataExportConfiguration$ExportModal$GotPreview));
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$NotTested = {$: 0};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init = function (dataExportConfiguration) {
	return {MK: dataExportConfiguration, ku: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$NotTested};
};
var $author$project$Api$Provider$DataExportConfiguration$One$toShared = function (_v0) {
	var shared = _v0;
	return shared;
};
var $author$project$Api$Provider$DataExportConfiguration$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'data_export_configuration',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(fields.Ot)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'contact_email',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.LK)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'contact_phone',
										A2($author$project$Utils$Encode$nullable, $author$project$Api$Common$Phone$Shared$encode, fields.LM)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'destination',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Nz)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'sftp_host',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZI)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'sftp_port',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.ZJ)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'sftp_username',
														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ZK)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															's3_bucket',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.YZ)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																's3_region',
																A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Y_)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'encryption_key',
																	A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Ow)),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'encryption_recipient',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Ox)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'incremental_mode',
																			$elm$json$Json$Encode$bool(fields.QT)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'exclude_default_tables',
																				$elm$json$Json$Encode$bool(fields.OR)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'file_name_format',
																					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Pn)),
																				_Utils_eq(fields.Ha, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray(
																					[
																						_Utils_Tuple2(
																						'sftp_private_key',
																						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Ha))
																					])))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$DataExportConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id))));
	});
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Closed = 1;
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Exported = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Exporting = 2;
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$None = 0;
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 2:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{sd: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 1:
				return model.hP ? {
					EC: A4(
						$author$project$Api$Provider$DataExportConfiguration$export,
						apiClient,
						model.ES,
						{afU: false},
						$author$project$Components$Admin$DataExportConfiguration$ExportModal$Exported),
					ac5: 0,
					y8: _Utils_update(
						model,
						{ma: $author$project$Api$Data$Loading}),
					as: _List_Nil
				} : {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{ma: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Export is being generated.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{ma: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var bool = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{hP: bool}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Closed = 1;
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Failed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$None = 0;
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Success = {$: 2};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Testing = {$: 1};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnectionResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.adR;
	});
var $author$project$Api$Provider$DataExportConfiguration$testConnection = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$elm$json$Json$Decode$bool,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['test_connection']),
					$author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id))));
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$testConnectionCmd = F2(
	function (apiClient, dataExportConfiguration) {
		return A3(
			$author$project$Api$Provider$DataExportConfiguration$testConnection,
			apiClient,
			$author$project$Api$Provider$DataExportConfiguration$Shared$id(dataExportConfiguration),
			$author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnectionResponse);
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				return {
					EC: A2($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$testConnectionCmd, apiClient, model.MK),
					ac5: 0,
					y8: _Utils_update(
						model,
						{ku: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Testing}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{ku: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Success}),
							as: _List_Nil
						};
					case 2:
						var error = response.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									ku: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Failed(
										$author$project$Api$Data$errorToString(error))
								}),
							as: _List_Nil
						};
					default:
						return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmailValidation = 0;
var $author$project$Components$Admin$DataExportConfiguration$Form$DestinationValidation = 2;
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKeyValidation = 9;
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipientValidation = 10;
var $author$project$Components$Admin$DataExportConfiguration$Form$S3BucketValidation = 7;
var $author$project$Components$Admin$DataExportConfiguration$Form$S3RegionValidation = 8;
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpHostValidation = 3;
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPortValidation = 4;
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsernameValidation = 5;
var $rtfeldman$elm_validate$Validate$validEmail = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{abS: true, aeK: false},
		'^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$'));
var $rtfeldman$elm_validate$Validate$isValidEmail = function (email) {
	return A2($elm$regex$Regex$contains, $rtfeldman$elm_validate$Validate$validEmail, email);
};
var $author$project$Utils$Validate$isInvalidEmail = F2(
	function (options, email) {
		if (!email.$) {
			var email_ = email.a;
			return $rtfeldman$elm_validate$Validate$isBlank(email_) ? (!options.abh) : (!$rtfeldman$elm_validate$Validate$isValidEmail(email_));
		} else {
			return !options.abh;
		}
	});
var $author$project$Utils$Validate$ifInvalidEmail = F3(
	function (options, subjectToEmail, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return A2(
					$author$project$Utils$Validate$isInvalidEmail,
					options,
					subjectToEmail(subject));
			},
			error);
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneValidation = 1;
var $author$project$Components$Admin$DataExportConfiguration$Form$validatePhone = function (_v0) {
	var contactPhone = _v0.LM;
	return $author$project$Components$PhoneInput$hasErrors(contactPhone) ? _List_fromArray(
		[
			_Utils_Tuple2(1, '')
		]) : _List_Nil;
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKeyValidation = 6;
var $author$project$Components$Admin$DataExportConfiguration$Form$validateSftpPrivateKey = function (_v0) {
	var sftpPrivateKey = _v0.Ha;
	var sftpPrivateKeyAlreadySaved = _v0.sH;
	return (_Utils_eq(sftpPrivateKey, $elm$core$Maybe$Nothing) && (!sftpPrivateKeyAlreadySaved)) ? _List_fromArray(
		[
			_Utils_Tuple2(6, 'Please enter an SFTP private key.')
		]) : _List_Nil;
};
var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsValidator = F2(
	function (destination, encryptionEnabled) {
		return $rtfeldman$elm_validate$Validate$all(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A3(
							$author$project$Utils$Validate$ifInvalidEmail,
							{abh: false},
							function ($) {
								return $.LK;
							},
							_Utils_Tuple2(0, 'Please enter a contact email.')),
							$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$DataExportConfiguration$Form$validatePhone),
							A2(
							$rtfeldman$elm_validate$Validate$ifNothing,
							function ($) {
								return $.Nz;
							},
							_Utils_Tuple2(2, 'Please select a destination.'))
						]),
						function () {
						if (!destination.$) {
							if (!destination.a) {
								var _v1 = destination.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.ZI;
										},
										_Utils_Tuple2(3, 'Please enter an SFTP host.')),
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.ZJ;
										},
										_Utils_Tuple2(4, 'Please enter an SFTP port.')),
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.ZK;
										},
										_Utils_Tuple2(5, 'Please enter an SFTP username.')),
										$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$DataExportConfiguration$Form$validateSftpPrivateKey)
									]);
							} else {
								var _v2 = destination.a;
								return _List_fromArray(
									[
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.YZ;
										},
										_Utils_Tuple2(7, 'Please enter an S3 bucket.')),
										A2(
										$rtfeldman$elm_validate$Validate$ifNothing,
										function ($) {
											return $.Y_;
										},
										_Utils_Tuple2(8, 'Please enter an S3 region.'))
									]);
							}
						} else {
							return _List_Nil;
						}
					}(),
						encryptionEnabled ? _List_fromArray(
						[
							A2(
							$rtfeldman$elm_validate$Validate$ifNothing,
							function ($) {
								return $.Ow;
							},
							_Utils_Tuple2(9, 'Please enter an encryption key.')),
							A2(
							$rtfeldman$elm_validate$Validate$ifNothing,
							function ($) {
								return $.Ox;
							},
							_Utils_Tuple2(10, 'Please enter an encryption recipient.'))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$validate = function (model) {
	var _v0 = model.PB;
	if (!_v0.$) {
		var form = _v0.a;
		var fields = $author$project$Utils$Form$fields(form);
		var formWithValidatedPhone = A2(
			$author$project$Utils$Form$set,
			_Utils_update(
				fields,
				{
					LM: $author$project$Components$PhoneInput$validate(fields.LM)
				}),
			form);
		var _v1 = fields;
		var destination = _v1.Nz;
		var encryptionEnabled = _v1.iB;
		return A2(
			$elm$core$Result$mapError,
			function (validatedForm) {
				return _Utils_update(
					model,
					{
						PB: $elm$core$Maybe$Just(validatedForm)
					});
			},
			A2(
				$elm$core$Result$map,
				function (_v2) {
					var validatedForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(validatedForm)
							}),
						validFormFields);
				},
				A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Admin$DataExportConfiguration$Form$formFieldsValidator, destination, encryptionEnabled),
					formWithValidatedPhone)));
	} else {
		return $elm$core$Result$Err(model);
	}
};
var $author$project$Components$Admin$DataExportConfiguration$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var dataExportConfiguration = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: _Utils_update(
							model,
							{
								MK: response,
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit(dataExportConfiguration)))
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var field = msg.a;
				var _v3 = model.PB;
				if (!_v3.$) {
					var form = _v3.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None, y8: model, as: _List_Nil};
				}
			case 2:
				var _v4 = $author$project$Components$Admin$DataExportConfiguration$Form$validate(model);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newModel = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var phoneNumber = A2(
						$elm$core$Maybe$map,
						$author$project$Utils$Phone$toRecord,
						$elm$core$List$head(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Components$PhoneInput$getPhones(fields.LM))));
					var apiFields = {
						LK: fields.LK,
						LM: phoneNumber,
						Nz: A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, fields.Nz),
						Ot: fields.Ot,
						Ow: fields.Ow,
						Ox: fields.Ox,
						OR: fields.OR,
						Pn: fields.Pn,
						QT: fields.mu,
						YZ: fields.YZ,
						Y_: fields.Y_,
						ZI: fields.ZI,
						ZJ: fields.ZJ,
						Ha: fields.Ha,
						ZK: fields.ZK
					};
					var cmd = function () {
						var _v6 = model.adR;
						if (!_v6.$) {
							var id = _v6.a;
							return A4($author$project$Api$Provider$DataExportConfiguration$update, apiClient, id, apiFields, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved);
						} else {
							return A3($author$project$Api$Provider$DataExportConfiguration$create, apiClient, apiFields, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved);
						}
					}();
					return {
						EC: cmd,
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: _Utils_update(
							newModel,
							{jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newModel = _v4.a;
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None, y8: newModel, as: _List_Nil};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var dataExportConfiguration = response.a;
					var successMsg = function () {
						var _v8 = model.adR;
						if (!_v8.$) {
							return 'Settings updated successfully';
						} else {
							return 'Settings created successfully';
						}
					}();
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$Saved(dataExportConfiguration),
						y8: _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit(dataExportConfiguration))),
								jY: response
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, successMsg)
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var _v9 = model.MK;
				if (_v9.$ === 3) {
					var dataExportConfiguration = _v9.a;
					var modalModel = $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init(
						$author$project$Api$Provider$DataExportConfiguration$One$toShared(dataExportConfiguration));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: _Utils_update(
							model,
							{
								kt: $elm$core$Maybe$Just(modalModel)
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None, y8: model, as: _List_Nil};
				}
			case 5:
				var subMsg = msg.a;
				var _v10 = model.kt;
				if (!_v10.$) {
					var modalModel = _v10.a;
					var testConnectionModalResult = A3($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update, apiClient, subMsg, modalModel);
					var testConnectionModal = function () {
						var _v11 = testConnectionModalResult.ac5;
						if (!_v11) {
							return $elm$core$Maybe$Just(testConnectionModalResult.y8);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg, testConnectionModalResult.EC),
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: _Utils_update(
							model,
							{kt: testConnectionModal}),
						as: testConnectionModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None, y8: model, as: _List_Nil};
				}
			case 6:
				var subMsg = msg.a;
				var _v12 = model.PB;
				if (!_v12.$) {
					var form = _v12.a;
					var _v13 = $author$project$Utils$Form$fields(form);
					var contactPhone = _v13.LM;
					var _v14 = A2($author$project$Components$PhoneInput$update, subMsg, contactPhone);
					var phoneInput = _v14.a;
					var cmd = _v14.b;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate,
						$author$project$Components$Admin$DataExportConfiguration$Form$ContactPhone(phoneInput),
						form);
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg, cmd),
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None, y8: model, as: _List_Nil};
				}
			case 7:
				var _v15 = function () {
					var _v16 = model.adR;
					if (!_v16.$) {
						var id = _v16.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg),
							A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A2($author$project$Components$Admin$DataExportConfiguration$ExportModal$init, apiClient, id)));
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				}();
				var exportModal = _v15.a;
				var exportModalCmd = _v15.b;
				return {
					EC: exportModalCmd,
					ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
					y8: _Utils_update(
						model,
						{iE: exportModal}),
					as: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v17 = model.iE;
				if (!_v17.$) {
					var exportModal = _v17.a;
					var exportModalResult = A3($author$project$Components$Admin$DataExportConfiguration$ExportModal$update, apiClient, subMsg, exportModal);
					var updatedExportModal = function () {
						var _v18 = exportModalResult.ac5;
						switch (_v18) {
							case 0:
								return $elm$core$Maybe$Just(exportModalResult.y8);
							case 1:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg, exportModalResult.EC),
						ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None,
						y8: _Utils_update(
							model,
							{iE: updatedExportModal}),
						as: exportModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$DataExportConfiguration$Form$None, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Pages$Admin$DataExportSettings$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var dataExportConfigurationFormResult = A3($author$project$Components$Admin$DataExportConfiguration$Form$update, model.D5, subMsg, model.PB);
		var cmd = function () {
			var _v1 = dataExportConfigurationFormResult.ac5;
			if (_v1.$ === 1) {
				return $elm$core$Platform$Cmd$none;
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: dataExportConfigurationFormResult.y8}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dataExportConfigurationFormResult.EC),
						cmd
					])),
			dataExportConfigurationFormResult.as);
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$UpdateDataExportConfiguration = {$: 2};
var $author$project$Components$Admin$DataExportConfiguration$Form$backRoute = function (model) {
	return model.sV ? $author$project$Spa$Generated$Route$Admin__DataExport__Top : $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top;
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Export = {$: 1};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$ConfirmUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewConfirmInput = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.hP),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExportConfiguration$ExportModal$ConfirmUpdated)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('By checking this box I confirm that I have verified that both'),
								$elm$html$Html$text(' the files to be sent and the destination server and path are accurate')
							]))
					]))
			]));
};
var $author$project$Api$Provider$DataExportGroup$One$dataExportConfiguration = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration(shared);
};
var $author$project$Api$Provider$DataExportGroup$One$dataExports = function (_v0) {
	var record = _v0.b;
	return record.MM;
};
var $author$project$Api$Provider$DataExportGroup$One$entityName = function (_v0) {
	var record = _v0.b;
	return record.OJ;
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewDataExport = function (dataExport) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					$author$project$Api$Provider$DataExport$Shared$exportFileName(dataExport)))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewPreview = function (previewRequest) {
	if (previewRequest.$ === 3) {
		var dataExportGroup = previewRequest.a;
		var dataExportConfiguration = $author$project$Api$Provider$DataExportGroup$One$dataExportConfiguration(dataExportGroup);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-2')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('The platform will send the following files to the given destination.')
						])),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Entity Name: ')
						])),
					$elm$html$Html$text(
					$author$project$Api$Provider$DataExportGroup$One$entityName(dataExportGroup)),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Destination: ')
						])),
					$elm$html$Html$text(
					$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Files: ')
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Admin$DataExportConfiguration$ExportModal$viewDataExport,
						$author$project$Api$Provider$DataExportGroup$One$dataExports(dataExportGroup)))
				]));
	} else {
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil)
				]));
	}
};
var $author$project$Components$Admin$DataExportConfiguration$ExportModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$DataExportConfiguration$ExportModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Export Now')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$ExportModal$viewPreview(model.sd),
						$author$project$Components$Admin$DataExportConfiguration$ExportModal$viewConfirmInput(model)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$ExportModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Export Now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$pull(1),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$ExportModal$Export),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
								$author$project$Ui$Button$disabled(!model.hP),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.ma, $author$project$Api$Data$Loading) || _Utils_eq(model.sd, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Export Now')
							]))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnection = {$: 1};
var $author$project$Ui$Typography$b = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$b,
			$author$project$Ui$Typography$optionsToAttributes(options),
			content);
	});
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$Ui$Typography$pre = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$pre,
			$author$project$Ui$Typography$optionsToAttributes(options),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($elm$core$Basics$never),
				content));
	});
var $author$project$Ui$Typography$PreWrap = {$: 15};
var $author$project$Ui$Typography$preWrap = $author$project$Ui$Typography$PreWrap;
var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3BucketPolicy = function (bucketName) {
	return A3($elm$core$String$replace, 'NAME_OF_BUCKET', bucketName, '\n{\n  "Version": "2012-10-17",\n  "Statement": [\n    {\n      "Sid": "HintDataExport",\n      "Effect": "Allow",\n      "Principal": {\n        "AWS": "arn:aws:iam::540645937361:root"\n      },\n      "Action": [\n        "s3:GetObject",\n        "s3:PutObject"\n      ],\n      "Resource": [\n        "arn:aws:s3:::NAME_OF_BUCKET",\n        "arn:aws:s3:::NAME_OF_BUCKET/*"\n      ]\n    }\n  ]\n}\n    ');
};
var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3Guide = function (dataExportConfiguration) {
	var bucketName = A2(
		$elm$core$Maybe$withDefault,
		'NAME_OF_BUCKET',
		$author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(dataExportConfiguration));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('S3 Configuration Steps')
					])),
				A2(
				$author$project$Ui$OrderedList$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$OrderedList$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Create an S3 bucket named \"'),
								$elm$html$Html$text(bucketName),
								$elm$html$Html$text('\". '),
								A2(
								$author$project$Ui$Typography$b,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Do not use Access Control Lists (ACLS). ')
									])),
								A2(
								$author$project$Ui$Alert$warning,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You are responsible for the security of your bucket, including requiring encryption at rest, '),
										$elm$html$Html$text('object locks and replication as appropriate.')
									]))
							])),
						A2(
						$author$project$Ui$OrderedList$item,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Apply the IAM policy below to the bucket'),
								A2(
								$author$project$Ui$Typography$pre,
								_List_fromArray(
									[$author$project$Ui$Typography$preWrap]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3BucketPolicy(bucketName))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$view = function (dataExportConfiguration) {
	var _v0 = $author$project$Api$Provider$DataExportConfiguration$Shared$destination(dataExportConfiguration);
	switch (_v0) {
		case 's3':
			return $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3Guide(dataExportConfiguration);
		case 'sftp':
			return $author$project$Utils$Html$empty;
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$DataExportConfiguration$Shared$testExportFileName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$DataExportConfiguration$Shared$record,
	function ($) {
		return $.$z;
	});
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestFileDetails = function (dataExportConfiguration) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('The platform will try to send a test to verify your data export configuration.')
					])),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Destination: ')
					])),
				$elm$html$Html$text(
				$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Path: ')
					])),
				$elm$html$Html$text(
				$author$project$Api$Provider$DataExportConfiguration$Shared$testExportFileName(dataExportConfiguration))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestStatus = function (testResult) {
	switch (testResult.$) {
		case 0:
			return $author$project$Utils$Html$empty;
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$info,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Testing connection...')
							]))
					]));
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$success,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Connection test successful!')
							]))
					]));
		default:
			var message = testResult.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Connection test failed. Please check your configuration and try again.'),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error: ')
											])),
										$elm$html$Html$text(message)
									]))
							]))
					]));
	}
};
var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Test Connection')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestFileDetails(model.MK),
						$author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$view(model.MK),
						$author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestStatus(model.ku)
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
						function () {
						var _v0 = model.ku;
						if (_v0.$ === 1) {
							return A3(
								$author$project$Ui$Button$view,
								{abp: 'Testing connection'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$loading(true),
										$author$project$Ui$Button$disabled(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Testing...')
									]));
						} else {
							return A3(
								$author$project$Ui$Button$view,
								{abp: 'Test connection'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnection)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Test Connection')
									]));
						}
					}()
					]))
			]));
};
var $author$project$Ui$Padding$Left_0_5 = 2;
var $author$project$Components$Admin$DataExportConfiguration$Form$OpenExportModal = {$: 7};
var $author$project$Utils$Form$dirty = function (_v0) {
	var originalFields = _v0.a;
	var fields_ = _v0.c;
	return !_Utils_eq(originalFields, fields_);
};
var $author$project$Ui$Button$md = $author$project$Ui$Button$Size(1);
var $author$project$Ui$Tooltip$Padding = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Tooltip$padding = $author$project$Ui$Tooltip$Padding;
var $author$project$Components$Admin$DataExportConfiguration$Form$viewExportButton = function (model) {
	var disabled = _Utils_eq(model.adR, $elm$core$Maybe$Nothing) || A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Utils$Form$dirty, model.PB));
	return A3(
		$author$project$Ui$Tooltip$view,
		_List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(0),
				$author$project$Ui$Tooltip$active(disabled),
				$author$project$Ui$Tooltip$wide,
				$author$project$Ui$Tooltip$padding(2)
			]),
		'You must save the settings before you can export data.',
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Export Now'},
				_List_fromArray(
					[
						$author$project$Ui$Button$pull(1),
						$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$Form$OpenExportModal),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
						$author$project$Ui$Button$disabled(disabled),
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$md
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Export Now')
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Input$Email = {$: 4};
var $author$project$Ui$Form$Input$email = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Email);
var $author$project$Components$Admin$DataExportConfiguration$Form$viewContactEmailInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var contactEmail = _v0.LK;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Contact Email'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', contactEmail)),
						$author$project$Ui$Form$Input$placeholder('example@example.com'),
						$author$project$Ui$Form$Input$email,
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmail)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewContactPhoneInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var contactPhone = _v0.LM;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Contact Phone'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg,
				$author$project$Components$PhoneInput$view(contactPhone))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$Destination = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$destinationOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var destination = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, destination),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2($elm$core$Maybe$Nothing, 'Select a destination'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just(0),
			'SFTP'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just(1),
			'S3')
		]));
var $author$project$Components$Admin$DataExportConfiguration$Form$viewDestinationInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var destination = _v0.Nz;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Destination')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, destination)),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$Destination)),
						$author$project$Ui$Form$Select$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
						$author$project$Ui$Form$Select$errors(
						A2($author$project$Utils$Form$validationErrors, 2, form))
					]),
				$author$project$Components$Admin$DataExportConfiguration$Form$destinationOptions)
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$Enabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewEnabledInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var enabled = _v0.Ot;
	var manualExportPerformed = _v0.Tf;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Enabled')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(enabled),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$Enabled)),
						$author$project$Ui$ToggleSwitch$disabled(!manualExportPerformed)
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Enables data export files to send daily.')
					])),
				(!manualExportPerformed) ? A2(
				$author$project$Ui$Alert$warning,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('A manual export has to be performed before enabling daily exports.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Click the '),
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('\"Export Now\"')
							])),
						$elm$html$Html$text(' button below to perform a manual export.')
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionEnabled = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionEnabledInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var encryptionEnabled = _v0.iB;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Encryption Enabled')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(encryptionEnabled),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionEnabled))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('When encryption is enabled, the data will be encrypted before it is sent to the destination.')
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKey = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Form$Textarea$Errors = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Textarea$errors = $author$project$Ui$Form$Textarea$Errors;
var $author$project$Ui$Form$Textarea$Invalid = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Textarea$invalid = $author$project$Ui$Form$Textarea$Invalid;
var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionKeyInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var encryptionKey = _v0.Ow;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Encryption Key'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$value(
						A2($elm$core$Maybe$withDefault, '', encryptionKey)),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKey)),
						$author$project$Ui$Form$Textarea$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 9, form)),
						$author$project$Ui$Form$Textarea$errors(
						A2($author$project$Utils$Form$validationErrors, 9, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipient = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionRecipientInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var encryptionRecipient = _v0.Ox;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Encryption Recipient'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', encryptionRecipient)),
						$author$project$Ui$Form$Input$placeholder('example@example.com'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipient)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 10, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 10, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$ExcludeDefaultTables = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewExcludeDefaultTablesInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var excludeDefaultTables = _v0.OR;
	return A2(
		$author$project$Ui$HinterOnly$formGroup,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Exclude Default Tables')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(excludeDefaultTables),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$ExcludeDefaultTables))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('By default, all tables from data export will be sent.'),
						$author$project$Utils$Html$noBreakSpace,
						$elm$html$Html$text('When this is enabled, only the custom tables will be sent.')
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormat = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormatValidation = 11;
var $author$project$Components$Admin$DataExportConfiguration$Form$viewFileNameFormatInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var fileNameFormat = _v0.Pn;
	var destination = _v0.Nz;
	return A2(
		$author$project$Ui$HinterOnly$formGroup,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('File Name Format')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', fileNameFormat)),
						$author$project$Ui$Form$Input$placeholder(':timestamp:/:file_name:'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormat)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 11, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 11, form))
					])),
				function () {
				if (!destination.$) {
					var destination_ = destination.a;
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('By default, the export will be placed in '),
								function () {
								if (!destination_) {
									return $elm$html$Html$text('the home directory of the SFTP user.');
								} else {
									return $elm$html$Html$text('the root of the S3 bucket.');
								}
							}(),
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('Only change this if the customers request the file to be placed in a specific directory.'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('If that happens add the requested path as prefix to whats already there.'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('Example: '),
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(':timestamp:/:file_name:')
									])),
								$elm$html$Html$text(' becomes '),
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('/requested/path/:timestamp:/:file_name:')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$Incremental = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewIncrementalInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var incremental = _v0.mu;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Sync Mode')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Full'},
						_List_fromArray(
							[
								$author$project$Ui$Button$active(!incremental),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated(
									$author$project$Components$Admin$DataExportConfiguration$Form$Incremental(false)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Full')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Incremental'},
						_List_fromArray(
							[
								$author$project$Ui$Button$active(incremental),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated(
									$author$project$Components$Admin$DataExportConfiguration$Form$Incremental(true)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Incremental')
							]))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Full: ')
							])),
						$elm$html$Html$text('Each daily file includes all records.')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Incremental: ')
							])),
						$elm$html$Html$text('Each daily file includes records that have been created, updated, or deleted within the past 7 days. The first export of the month includes all records.')
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$S3Bucket = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewS3BucketInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var s3Bucket = _v0.YZ;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('S3 Bucket'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', s3Bucket)),
						$author$project$Ui$Form$Input$placeholder('S3 Bucket'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$S3Bucket)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 7, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 7, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$S3Region = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$s3RegionOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var region = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			region,
			_Utils_ap(
				label,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (region_) {
							return ' (' + (region_ + ')');
						},
						region))));
	},
	_List_fromArray(
		[
			_Utils_Tuple2($elm$core$Maybe$Nothing, 'Select a region'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('us-east-1'),
			'US East (N. Virginia)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('us-east-2'),
			'US East (Ohio)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('us-west-1'),
			'US West (N. California)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('us-west-2'),
			'US West (Oregon)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('af-south-1'),
			'Africa (Cape Town)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-east-1'),
			'Asia Pacific (Hong Kong)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-south-2'),
			'Asia Pacific (Hyderabad)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-3'),
			'Asia Pacific (Jakarta)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-5'),
			'Asia Pacific (Malaysia)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-4'),
			'Asia Pacific (Melbourne)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-south-1'),
			'Asia Pacific (Mumbai)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-northeast-3'),
			'Asia Pacific (Osaka)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-northeast-2'),
			'Asia Pacific (Seoul)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-1'),
			'Asia Pacific (Singapore)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-2'),
			'Asia Pacific (Sydney)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-east-2'),
			'Asia Pacific (Taipei)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-southeast-7'),
			'Asia Pacific (Thailand)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ap-northeast-1'),
			'Asia Pacific (Tokyo)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ca-central-1'),
			'Canada (Central)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('ca-west-1'),
			'Canada West (Calgary)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-central-1'),
			'Europe (Frankfurt)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-west-1'),
			'Europe (Ireland)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-west-2'),
			'Europe (London)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-south-1'),
			'Europe (Milan)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-west-3'),
			'Europe (Paris)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-south-2'),
			'Europe (Spain)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-north-1'),
			'Europe (Stockholm)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('eu-central-2'),
			'Europe (Zurich)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('il-central-1'),
			'Israel (Tel Aviv)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('mx-central-1'),
			'Mexico (Central)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('me-south-1'),
			'Middle East (Bahrain)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('me-central-1'),
			'Middle East (UAE)'),
			_Utils_Tuple2(
			$elm$core$Maybe$Just('sa-east-1'),
			'South America (São Paulo)')
		]));
var $author$project$Components$Admin$DataExportConfiguration$Form$viewS3RegionInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var s3Region = _v0.Y_;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('S3 Region'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(s3Region),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$S3Region)),
						$author$project$Ui$Form$Select$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 8, form)),
						$author$project$Ui$Form$Select$errors(
						A2($author$project$Utils$Form$validationErrors, 8, form))
					]),
				$author$project$Components$Admin$DataExportConfiguration$Form$s3RegionOptions)
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpHost = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpHostInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var sftpHost = _v0.ZI;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('SFTP Host'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', sftpHost)),
						$author$project$Ui$Form$Input$placeholder('sftp.example.com'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpHost)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 3, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPort = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPortInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var sftpPort = _v0.ZJ;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('SFTP Port'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $elm$core$String$fromInt, sftpPort))),
						$author$project$Ui$Form$Input$placeholder('22'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpPort)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 4, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKey = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPrivateKeyInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var sftpPrivateKey = _v0.Ha;
	var sftpPrivateKeyAlreadySaved = _v0.sH;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('SFTP Private Key'),
				$author$project$Ui$Form$Group$required(!sftpPrivateKeyAlreadySaved)
			]),
		_List_fromArray(
			[
				sftpPrivateKeyAlreadySaved ? A2(
				$author$project$Ui$Alert$warning,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Your SFTP private key is saved. Use the space below to edit or change the key.')
					])) : $author$project$Utils$Html$empty,
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$value(
						A2($elm$core$Maybe$withDefault, '', sftpPrivateKey)),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKey)),
						$author$project$Ui$Form$Textarea$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 6, form)),
						$author$project$Ui$Form$Textarea$errors(
						A2($author$project$Utils$Form$validationErrors, 6, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsername = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpUsernameInput = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var sftpUsername = _v0.ZK;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('SFTP Username'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', sftpUsername)),
						$author$project$Ui$Form$Input$placeholder('username'),
						$author$project$Ui$Form$Input$autofocus(true),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsername)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 5, form))
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$viewForm = F2(
	function (isHintAdmin, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var destination = _v0.Nz;
		var encryptionEnabled = _v0.iB;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewEnabledInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewContactEmailInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewContactPhoneInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewDestinationInput(form)
					]),
					function () {
					if (!destination.$) {
						if (!destination.a) {
							var _v2 = destination.a;
							return _List_fromArray(
								[
									$author$project$Components$Admin$DataExportConfiguration$Form$viewSftpHostInput(form),
									$author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPortInput(form),
									$author$project$Components$Admin$DataExportConfiguration$Form$viewSftpUsernameInput(form),
									$author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPrivateKeyInput(form)
								]);
						} else {
							var _v3 = destination.a;
							return _List_fromArray(
								[
									$author$project$Components$Admin$DataExportConfiguration$Form$viewS3BucketInput(form),
									$author$project$Components$Admin$DataExportConfiguration$Form$viewS3RegionInput(form)
								]);
						}
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionEnabledInput(form)
					]),
					encryptionEnabled ? _List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionKeyInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionRecipientInput(form)
					]) : _List_Nil,
					_List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewIncrementalInput(form)
					]),
					isHintAdmin ? _List_fromArray(
					[
						$author$project$Components$Admin$DataExportConfiguration$Form$viewExcludeDefaultTablesInput(form),
						$author$project$Components$Admin$DataExportConfiguration$Form$viewFileNameFormatInput(form)
					]) : _List_Nil
				]));
	});
var $author$project$Components$Admin$DataExportConfiguration$Form$viewSaveButton = function (model) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Save settings'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$submit,
				$author$project$Ui$Button$loading(
				_Utils_eq(model.jY, $author$project$Api$Data$Loading))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Save')
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$TestConnection = {$: 4};
var $author$project$Ui$SvgIcon$TestConnection = 69;
var $author$project$Ui$SvgIcon$testConnection = $author$project$Ui$SvgIcon$viewIcon(69);
var $author$project$Components$Admin$DataExportConfiguration$Form$viewTestConnectionButton = function (model) {
	var disabled = function () {
		var _v0 = model.adR;
		if (!_v0.$) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$Utils$Form$dirty, model.PB));
		} else {
			return true;
		}
	}();
	return A3(
		$author$project$Ui$Tooltip$view,
		_List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(0),
				$author$project$Ui$Tooltip$active(disabled),
				$author$project$Ui$Tooltip$wide,
				$author$project$Ui$Tooltip$padding(2)
			]),
		'You must save the settings before you can test the connection.',
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Test Connection'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$Form$TestConnection),
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$testConnection),
						$author$project$Ui$Button$disabled(disabled)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Test Connection')
					]))
			]));
};
var $author$project$Components$Admin$DataExportConfiguration$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view, model.kt))),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$view, model.iE))),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Components$Admin$DataExportConfiguration$Form$UpdateDataExportConfiguration)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$titleWithButton,
										_List_fromArray(
											[
												function () {
												var _v1 = _Utils_Tuple2(model.adR, model.sV);
												if (!_v1.a.$) {
													if (_v1.b) {
														return $author$project$Utils$Html$empty;
													} else {
														return $elm$html$Html$text('Edit');
													}
												} else {
													var _v2 = _v1.a;
													return $elm$html$Html$text('Add data export settings');
												}
											}()
											]),
										_List_fromArray(
											[
												model.sV ? $author$project$Utils$Html$empty : A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$pull(1)
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Link$route,
														$author$project$Components$Admin$DataExportConfiguration$Form$backRoute(model),
														_List_Nil,
														_List_fromArray(
															[
																A2($author$project$Ui$Icon$view, _List_Nil, 2)
															]))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v3 = model.PB;
									if (!_v3.$) {
										var form = _v3.a;
										return A2($author$project$Components$Admin$DataExportConfiguration$Form$viewForm, model.FR, form);
									} else {
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Components$Admin$DataExportConfiguration$Form$backRoute(model),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Back')
											])),
										$author$project$Components$Admin$DataExportConfiguration$Form$viewSaveButton(model),
										$author$project$Components$Admin$DataExportConfiguration$Form$viewTestConnectionButton(model),
										$author$project$Components$Admin$DataExportConfiguration$Form$viewExportButton(model)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$DataExportSettings$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$DataExportConfiguration$Form$view(model.PB))
			]),
		$G: 'Admin | Data Exporter | Settings'
	};
};
var $author$project$Pages$Admin$DataExportSettings$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$DataExportSettings$Id_String$init, aer: $author$project$Pages$Admin$DataExportSettings$Id_String$load, agD: $author$project$Pages$Admin$DataExportSettings$Id_String$save, ahd: $author$project$Pages$Admin$DataExportSettings$Id_String$subscriptions, aaq: $author$project$Pages$Admin$DataExportSettings$Id_String$update, ahP: $author$project$Pages$Admin$DataExportSettings$Id_String$view});
var $author$project$Pages$Admin$DataExportSettings$New$DataExportConfigurationFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$DataExportSettings$New$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var singleton = _Utils_eq(
			A2($elm$core$Dict$get, 'singleton', query),
			$elm$core$Maybe$Just('true'));
		var _v3 = A4(
			$author$project$Components$Admin$DataExportConfiguration$Form$init,
			shared.D5,
			$author$project$Shared$isHintAdmin(shared),
			$elm$core$Maybe$Nothing,
			singleton);
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form, sV: singleton},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$DataExportSettings$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExportSettings$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$DataExportSettings$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$DataExportConfiguration$Form$subscriptions(model.PB));
};
var $author$project$Api$Provider$DataExportConfiguration$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$id(shared);
};
var $author$project$Pages$Admin$DataExportSettings$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var dataExportConfigurationFormResult = A3($author$project$Components$Admin$DataExportConfiguration$Form$update, model.D5, subMsg, model.PB);
		var cmd = function () {
			var _v1 = dataExportConfigurationFormResult.ac5;
			if (_v1.$ === 1) {
				var dataExportConfiguration = _v1.a;
				return A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'singleton',
								model.sV ? 'true' : 'false')
							])),
					$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String(
						{
							adR: $author$project$Api$Provider$DataExportConfiguration$One$id(dataExportConfiguration)
						}));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: dataExportConfigurationFormResult.y8}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dataExportConfigurationFormResult.EC),
						cmd
					])),
			dataExportConfigurationFormResult.as);
	});
var $author$project$Pages$Admin$DataExportSettings$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$DataExportConfiguration$Form$view(model.PB))
			]),
		$G: 'Admin | Data Exporter | Settings'
	};
};
var $author$project$Pages$Admin$DataExportSettings$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$DataExportSettings$New$init, aer: $author$project$Pages$Admin$DataExportSettings$New$load, agD: $author$project$Pages$Admin$DataExportSettings$New$save, ahd: $author$project$Pages$Admin$DataExportSettings$New$subscriptions, aaq: $author$project$Pages$Admin$DataExportSettings$New$update, ahP: $author$project$Pages$Admin$DataExportSettings$New$view});
var $author$project$Pages$Admin$DataExportSettings$Top$GotDataExportConfigurations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$DataExportConfiguration$All$DataExportConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$DataExportConfiguration$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DataExportConfiguration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DataExportConfiguration$listDefaults = {afy: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$DataExportConfiguration$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$DataExportConfiguration$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.afy);
};
var $author$project$Api$Provider$DataExportConfiguration$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$DataExportConfiguration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$DataExportConfiguration$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath)));
	});
var $author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations = function (model) {
	return A3(
		$author$project$Api$Provider$DataExportConfiguration$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy});
		},
		$author$project$Pages$Admin$DataExportSettings$Top$GotDataExportConfigurations);
};
var $author$project$Pages$Admin$DataExportSettings$Top$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var query = _v3.Bi;
		var model = {
			D5: apiClient,
			qc: $author$project$Api$Data$NotAsked,
			iE: $elm$core$Maybe$Nothing,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			kt: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations(model));
	});
var $author$project$Pages$Admin$DataExportSettings$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$DataExportSettings$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$DataExportSettings$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions, model.kt))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions, model.iE)))
			]));
};
var $author$project$Api$Provider$DataExportConfiguration$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$id(shared);
};
var $author$project$Api$Provider$DataExportConfiguration$All$toShared = function (_v0) {
	var shared = _v0;
	return shared;
};
var $author$project$Pages$Admin$DataExportSettings$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__DataExportSettings__Top)
				]),
			$author$project$Api$Pagination$toPageQuery(model.afy)));
};
var $author$project$Pages$Admin$DataExportSettings$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var dataExportConfigurations = response.a;
					var headers = response.b;
					var cmd = function () {
						var _v2 = _Utils_Tuple2(
							$elm$core$List$length(dataExportConfigurations),
							$elm$core$List$head(dataExportConfigurations));
						_v2$2:
						while (true) {
							switch (_v2.a) {
								case 0:
									return A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2('singleton', 'true')
												])),
										$author$project$Spa$Generated$Route$Admin__DataExportSettings__New);
								case 1:
									if (!_v2.b.$) {
										var dataExportConfiguration = _v2.b.a;
										return A2(
											$author$project$Utils$Route$navigate,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2('singleton', 'true')
													])),
											$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String(
												{
													adR: $author$project$Api$Provider$DataExportConfiguration$All$id(dataExportConfiguration)
												}));
									} else {
										break _v2$2;
									}
								default:
									break _v2$2;
							}
						}
						return $elm$core$Platform$Cmd$none;
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								qc: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations(newModel),
								$author$project$Pages$Admin$DataExportSettings$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var dataExportConfiguration = msg.a;
				var modalModel = $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init(
					$author$project$Api$Provider$DataExportConfiguration$All$toShared(dataExportConfiguration));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kt: $elm$core$Maybe$Just(modalModel)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v3 = model.kt;
				if (!_v3.$) {
					var modalModel = _v3.a;
					var testConnectionModalResult = A3($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update, model.D5, subMsg, modalModel);
					var testConnectionModal = function () {
						var _v4 = testConnectionModalResult.ac5;
						if (!_v4) {
							return $elm$core$Maybe$Just(testConnectionModalResult.y8);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kt: testConnectionModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg, testConnectionModalResult.EC),
						testConnectionModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var id = msg.a;
				var _v5 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$elm$core$Maybe$Just,
						A2($author$project$Components$Admin$DataExportConfiguration$ExportModal$init, model.D5, id)));
				var exportModal = _v5.a;
				var exportModalCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iE: exportModal}),
					exportModalCmd,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v6 = model.iE;
				if (!_v6.$) {
					var exportModal = _v6.a;
					var exportModalResult = A3($author$project$Components$Admin$DataExportConfiguration$ExportModal$update, model.D5, subMsg, exportModal);
					var updatedExportModal = function () {
						var _v7 = exportModalResult.ac5;
						switch (_v7) {
							case 0:
								return $elm$core$Maybe$Just(exportModalResult.y8);
							case 1:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iE: updatedExportModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg, exportModalResult.EC),
						exportModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$DataExportSettings$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Column$NonSortable = {$: 1};
var $author$project$Pages$Admin$DataExportSettings$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
		A3($author$project$Api$Column$init, 'enabled', false, 'Enabled')
	]);
var $author$project$Pages$Admin$DataExportSettings$Top$OpenExportModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$DataExportSettings$Top$TestConnection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$DataExportConfiguration$All$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DataExportConfiguration$Shared$enabled(shared);
};
var $author$project$Pages$Admin$DataExportSettings$Top$viewDataExportConfiguration = function (dataExportConfiguration) {
	var id = $author$project$Api$Provider$DataExportConfiguration$All$id(dataExportConfiguration);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(
							$author$project$Api$Provider$DataExportConfiguration$All$toShared(dataExportConfiguration)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toString(
									$author$project$Api$Provider$DataExportConfiguration$All$enabled(dataExportConfiguration)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$minWidth('11rem'),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String(
							{adR: id}),
						_List_fromArray(
							[
								$author$project$Ui$Link$sm,
								$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Test Connection'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Admin$DataExportSettings$Top$TestConnection(dataExportConfiguration)),
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$testConnection)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Test Connection')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Export Now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$pull(1),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Admin$DataExportSettings$Top$OpenExportModal(id)),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Export Now')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$DataExportSettings$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.qc;
		if (_v1.$ === 3) {
			var dataExportConfigurations_ = _v1.a;
			return _Utils_Tuple2(false, dataExportConfigurations_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var dataExportConfigurations = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage settings.')
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No settings found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
						$author$project$Pages$Admin$DataExportSettings$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Admin$DataExportSettings$Top$viewDataExportConfiguration, dataExportConfigurations),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$DataExportSettings$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view, model.kt))),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg),
					A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$view, model.iE))),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__DataExportSettings__New,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$pull(1),
										$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New Data Exporter')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$DataExportSettings$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.qc;
								if (_v0.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$DataExportSettings$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.afy));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		$G: 'Admin | Data Exporter | Settings'
	};
};
var $author$project$Pages$Admin$DataExportSettings$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$DataExportSettings$Top$init, aer: $author$project$Pages$Admin$DataExportSettings$Top$load, agD: $author$project$Pages$Admin$DataExportSettings$Top$save, ahd: $author$project$Pages$Admin$DataExportSettings$Top$subscriptions, aaq: $author$project$Pages$Admin$DataExportSettings$Top$update, ahP: $author$project$Pages$Admin$DataExportSettings$Top$view});
var $author$project$Pages$Admin$Developers$ApiKeys$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$One$hasManagedPartner = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Qa;
	});
var $author$project$Api$Provider$ManagedPartner$One$ManagedPartner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ManagedPartner$Shared$ManagedPartner = $elm$core$Basics$identity;
var $author$project$Api$Provider$ManagedPartner$Shared$Record = F3(
	function (id, webhooksSignatureApiKey, sandboxEnabled) {
		return {adR: id, Y0: sandboxEnabled, aaZ: webhooksSignatureApiKey};
	});
var $author$project$Api$Provider$ApiKey$Shared$ApiKey = $elm$core$Basics$identity;
var $author$project$Api$Provider$ApiKey$Shared$Record = F6(
	function (id, token, label, createdAt, lastUsedAt, deactivatedAt) {
		return {Mf: createdAt, M0: deactivatedAt, adR: id, aej: label, SF: lastUsedAt, $Q: token};
	});
var $author$project$Api$Provider$ApiKey$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deactivated_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'last_used_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'label',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'token',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$ApiKey$Shared$Record)))))));
var $author$project$Api$Provider$ApiKey$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ApiKey$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sandbox_enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'webhooks_signature_api_key',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$ApiKey$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$Shared$Record))));
var $author$project$Api$Provider$ManagedPartner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ManagedPartner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$One$Record = function (integration) {
	return {Q4: integration};
};
var $author$project$Api$Provider$Integration$Shared$Integration = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Shared$Record = F3(
	function (id, status, authorizationCode) {
		return {JC: authorizationCode, adR: id, ag7: status};
	});
var $author$project$Api$Provider$Integration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'authorization_code',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Shared$Record))));
var $author$project$Api$Provider$Integration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'integration',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Integration$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$One$Record));
var $author$project$Api$Provider$ManagedPartner$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ManagedPartner$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ManagedPartner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$One$ManagedPartner)));
var $author$project$Api$Provider$ManagedPartner$managedPartnerPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ManagedPartner$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$managedPartnerPath));
	});
var $author$project$Pages$Admin$Developers$ApiKeys$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{D5: shared.D5, iU: $elm$core$Maybe$Nothing, rm: $author$project$Api$Data$Loading, jk: $elm$core$Maybe$Nothing, Hy: shared.Hy},
			$author$project$Api$Provider$Practice$One$hasManagedPartner(practice) ? A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.D5, $author$project$Pages$Admin$Developers$ApiKeys$GotManagedPartner) : A2(
				$author$project$Utils$Route$navigate,
				$elm$core$Dict$empty,
				A2($author$project$Permission$homeStateFor, session, shared.adN)));
	});
var $author$project$Pages$Admin$Developers$ApiKeys$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$ApiKeys$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$CancelEdit = {$: 4};
var $author$project$Components$Developers$ManageApiKeys$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Developers$ManageApiKeys$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Developers$ManageApiKeys$CancelEdit)),
					model.FU)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Developers$ManageApiKeys$HiConfirmClosed),
					model.ic))
			]));
};
var $author$project$Pages$Admin$Developers$ApiKeys$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageApiKeys$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg)),
					model.jk)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageApiKeys$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg)),
					model.iU))
			]));
};
var $author$project$Components$Developers$ManageApiKeys$Integration = 1;
var $author$project$Components$Developers$ManageApiKeys$Partner = 0;
var $author$project$Components$Developers$ManageApiKeys$GotManagedPartner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Model = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageApiKeys$GotApiKeys = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'api_keys']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ApiKey$All$ApiKey = $elm$core$Basics$identity;
var $author$project$Api$Provider$ApiKey$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ApiKey$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$ApiKey$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ApiKey$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'integration', 'api_keys']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ApiKey$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath));
	});
var $author$project$Components$Developers$ManageApiKeys$fetchApiKeys = F2(
	function (apiClient, owner) {
		if (!owner) {
			return A2($author$project$Api$Provider$ManagedPartner$ApiKey$list, apiClient, $author$project$Components$Developers$ManageApiKeys$GotApiKeys);
		} else {
			return A2($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$list, apiClient, $author$project$Components$Developers$ManageApiKeys$GotApiKeys);
		}
	});
var $author$project$Components$Developers$ManageApiKeys$init = F3(
	function (apiClient, timeFormatter, owner) {
		var model = {bN: $author$project$Api$Data$Loading, ic: $elm$core$Maybe$Nothing, FU: $elm$core$Maybe$Nothing, rm: $author$project$Api$Data$NotAsked, Vp: owner, Hy: timeFormatter, bE: $elm$core$Set$empty, dl: $elm$core$Set$empty};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, owner),
						function () {
						if (!owner) {
							return A2($author$project$Api$Provider$ManagedPartner$retrieve, apiClient, $author$project$Components$Developers$ManageApiKeys$GotManagedPartner);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}()
					])));
	});
var $author$project$Api$Provider$ManagedPartner$One$integration = function (_v0) {
	var record = _v0.b;
	return record.Q4;
};
var $author$project$Components$Developers$ManageApiKeys$Created = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Deleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$WebhooksSignatureApiKeyUpdated = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Ports$Clipboard$clipboardCopyPort = _Platform_outgoingPort('clipboardCopyPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Clipboard$copy = function (string) {
	return $author$project$Ports$Clipboard$clipboardCopyPort(string);
};
var $author$project$Api$Provider$ApiKey$One$ApiKey = 0;
var $author$project$Api$Provider$ApiKey$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$ManagedPartner$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath);
};
var $author$project$Api$Provider$ManagedPartner$ApiKey$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath(id_)));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath);
};
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath(id_)));
	});
var $author$project$Api$Provider$ApiKey$Shared$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Provider$ApiKey$All$label = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$label(shared);
};
var $author$project$Components$Developers$ManageApiKeys$formFieldsFromItem = function (apiKey) {
	return {
		aej: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$ApiKey$All$label(apiKey))
	};
};
var $author$project$Components$Developers$ManageApiKeys$formFieldsInit = {aej: ''};
var $author$project$Components$Developers$ManageApiKeys$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{aej: string});
	});
var $author$project$Components$Developers$ManageApiKeys$ApiKeyLabelValidation = 0;
var $author$project$Components$Developers$ManageApiKeys$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.aej;
			},
			_Utils_Tuple2(0, 'Please enter a label.'))
		]));
var $author$project$Api$Provider$ApiKey$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$ApiKey$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$id(shared);
};
var $author$project$Api$Provider$ManagedPartner$ApiKey$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath(id_))));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								$elm$json$Json$Encode$string(params.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath(id_))));
	});
var $author$project$Api$Provider$ManagedPartner$updateWebhooksSignatureApiKey = F3(
	function (apiClient, id_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhooks_signature_api_key',
					$author$project$Utils$Encode$association(id_))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ManagedPartner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['webhooks_signature_api_key']),
						$author$project$Api$Provider$ManagedPartner$managedPartnerPath))));
	});
var $author$project$Components$Developers$ManageApiKeys$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bN: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rm: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Developers$ManageApiKeys$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var apiKey = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(apiKey),
									$author$project$Utils$Form$init(
										$author$project$Components$Developers$ManageApiKeys$formFieldsFromItem(apiKey)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v2 = model.FU;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var maybeApiKey = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										maybeApiKey,
										A3($author$project$Utils$Form$update, $author$project$Components$Developers$ManageApiKeys$formFieldsUpdate, field, form),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var maybeApiKey = msg.a;
				var form = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Developers$ManageApiKeys$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var validatedForm = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var cmd = function () {
						if (maybeApiKey.$ === 1) {
							var _v7 = model.Vp;
							if (!_v7) {
								return A3(
									$author$project$Api$Provider$ManagedPartner$ApiKey$create,
									apiClient,
									{aej: fields.aej},
									$author$project$Components$Developers$ManageApiKeys$Created);
							} else {
								return A3(
									$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$create,
									apiClient,
									{aej: fields.aej},
									$author$project$Components$Developers$ManageApiKeys$Created);
							}
						} else {
							var apiKey = maybeApiKey.a;
							var _v8 = model.Vp;
							if (!_v8) {
								return A4(
									$author$project$Api$Provider$ManagedPartner$ApiKey$update,
									apiClient,
									$author$project$Api$Provider$ApiKey$All$id(apiKey),
									{aej: fields.aej},
									$author$project$Components$Developers$ManageApiKeys$Updated);
							} else {
								return A4(
									$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$update,
									apiClient,
									$author$project$Api$Provider$ApiKey$All$id(apiKey),
									{aej: fields.aej},
									$author$project$Components$Developers$ManageApiKeys$Updated);
							}
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeApiKey, validatedForm, $author$project$Api$Data$Loading))
							}),
						cmd,
						_List_Nil);
				} else {
					var validatedForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeApiKey, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v9 = model.FU;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var maybeApiKey = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bN: $author$project$Api$Data$Loading, FU: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.Vp),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'API key created.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeApiKey, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v12 = model.FU;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var maybeApiKey = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bN: $author$project$Api$Data$Loading, FU: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.Vp),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'API key updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeApiKey, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var apiKey = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Just(apiKey)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var apiKey = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var deleteCmd = function () {
						var _v15 = model.Vp;
						if (!_v15) {
							return A3(
								$author$project$Api$Provider$ManagedPartner$ApiKey$delete,
								apiClient,
								$author$project$Api$Provider$ApiKey$All$id(apiKey),
								$author$project$Components$Developers$ManageApiKeys$Deleted);
						} else {
							return A3(
								$author$project$Api$Provider$ManagedPartner$Integration$ApiKey$delete,
								apiClient,
								$author$project$Api$Provider$ApiKey$All$id(apiKey),
								$author$project$Components$Developers$ManageApiKeys$Deleted);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						deleteCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bN: $author$project$Api$Data$Loading}),
						A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.Vp),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'API key deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				var apiKey = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bE: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$ApiKey$All$id(apiKey),
								model.bE)
						}),
					A3(
						$author$project$Api$Provider$ManagedPartner$updateWebhooksSignatureApiKey,
						apiClient,
						$author$project$Api$Provider$ApiKey$All$id(apiKey),
						$author$project$Components$Developers$ManageApiKeys$WebhooksSignatureApiKeyUpdated(apiKey)),
					_List_Nil);
			case 13:
				var apiKey = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rm: response,
								bE: A2(
									$elm$core$Set$remove,
									$author$project$Api$Provider$ApiKey$All$id(apiKey),
									model.bE)
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Webhooks signature API key updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bE: A2(
									$elm$core$Set$remove,
									$author$project$Api$Provider$ApiKey$All$id(apiKey),
									model.bE)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var tokenStr = msg.a;
				var visibleApiKeyTokens = A2($elm$core$Set$member, tokenStr, model.dl) ? A2($elm$core$Set$remove, tokenStr, model.dl) : A2($elm$core$Set$insert, tokenStr, model.dl);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dl: visibleApiKeyTokens}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var tokenStr = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(tokenStr),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard.')
						]));
		}
	});
var $author$project$Pages$Admin$Developers$ApiKeys$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var managedPartner = response.a;
					var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
					if (!_v2.$) {
						var _v3 = A3($author$project$Components$Developers$ManageApiKeys$init, model.D5, model.Hy, 0);
						var partnerApiKeys = _v3.a;
						var partnerCmd = _v3.b;
						var _v4 = A3($author$project$Components$Developers$ManageApiKeys$init, model.D5, model.Hy, 1);
						var integrationApiKeys = _v4.a;
						var integrationCmd = _v4.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									iU: $elm$core$Maybe$Just(integrationApiKeys),
									rm: response,
									jk: $elm$core$Maybe$Just(partnerApiKeys)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg, partnerCmd),
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg, integrationCmd)
									])),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rm: response}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v5 = model.jk;
				if (!_v5.$) {
					var partnerApiKeys = _v5.a;
					var _v6 = A3($author$project$Components$Developers$ManageApiKeys$update, model.D5, subMsg, partnerApiKeys);
					var updated = _v6.a;
					var cmd = _v6.b;
					var outMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								jk: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v7 = model.iU;
				if (!_v7.$) {
					var integrationApiKeys = _v7.a;
					var _v8 = A3($author$project$Components$Developers$ManageApiKeys$update, model.D5, subMsg, integrationApiKeys);
					var updated = _v8.a;
					var cmd = _v8.b;
					var outMsgs = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iU: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Developers$ManageApiKeys$CopyToken = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Delete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Edit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$New = {$: 2};
var $author$project$Components$Developers$ManageApiKeys$ToggleToken = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$UseForWebhooksSignature = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Icon$EyeClose = 55;
var $author$project$Ui$Icon$EyeOpen = 56;
var $author$project$Ui$SvgIcon$Copy = 15;
var $author$project$Ui$SvgIcon$copy = $author$project$Ui$SvgIcon$viewIcon(15);
var $author$project$Api$Provider$ApiKey$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$ApiKey$All$createdAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$createdAt(shared);
};
var $author$project$Api$Provider$ApiKey$Shared$deactivatedAt = function (_v0) {
	var record = _v0;
	return record.M0;
};
var $author$project$Api$Provider$ApiKey$All$deactivatedAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$deactivatedAt(shared);
};
var $author$project$Api$Provider$ApiKey$Shared$lastUsedAt = function (_v0) {
	var record = _v0;
	return record.SF;
};
var $author$project$Api$Provider$ApiKey$All$lastUsedAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$lastUsedAt(shared);
};
var $author$project$Api$Provider$ApiKey$Shared$token = function (_v0) {
	var record = _v0;
	return record.$Q;
};
var $author$project$Api$Provider$ApiKey$All$token = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ApiKey$Shared$token(shared);
};
var $author$project$Components$Developers$ManageApiKeys$viewDeleteButton = F4(
	function (disabled, loading, apiKey, onDelete) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$active(disabled),
					$author$project$Ui$Tooltip$padding(2)
				]),
			'Can\'t remove the API key used for webhooks signature.',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Delete API key'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$loading(loading),
							$author$project$Ui$Button$onClick(
							onDelete(apiKey)),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
							$author$project$Ui$Button$disabled(disabled)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						]))
				]));
	});
var $author$project$Components$Developers$ManageApiKeys$viewEditButton = F3(
	function (loading, apiKey, onEdit) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Edit API key'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					onEdit(apiKey)),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
					$author$project$Ui$Button$loading(loading)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Edit')
				]));
	});
var $author$project$Components$Developers$ManageApiKeys$viewApiKeyRow = F2(
	function (config, apiKey) {
		var tokenStr = $author$project$Api$Provider$ApiKey$All$token(apiKey);
		var visible = A2($elm$core$Set$member, tokenStr, config.dl);
		var statusBadge = function () {
			var _v2 = $author$project$Api$Provider$ApiKey$All$deactivatedAt(apiKey);
			if (!_v2.$) {
				return A2(
					$author$project$Ui$Badge$view,
					_List_fromArray(
						[$author$project$Ui$Badge$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deactivated')
						]));
			} else {
				return A2(
					$author$project$Ui$Badge$view,
					_List_fromArray(
						[$author$project$Ui$Badge$success]),
					_List_fromArray(
						[
							$elm$html$Html$text('Active')
						]));
			}
		}();
		var loading = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$ApiKey$All$id(apiKey),
			config.bE);
		var _v0 = visible ? _Utils_Tuple2(55, 'Hide token') : _Utils_Tuple2(56, 'Show token');
		var visibleIcon = _v0.a;
		var visibleAriaLabel = _v0.b;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'—',
								$author$project$Api$Provider$ApiKey$All$label(apiKey)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							visible ? _List_fromArray(
								[
									$elm$html$Html$text(tokenStr)
								]) : _List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$String$repeat,
										$elm$core$String$length(tokenStr) - 4,
										'•')),
									$elm$html$Html$text(
									A2($elm$core$String$right, 4, tokenStr))
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: visibleAriaLabel},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									config.Go(tokenStr)),
									$author$project$Ui$Button$margin(10)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[$author$project$Ui$Icon$clickable]),
									visibleIcon)
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Copy token'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									config.Gn(tokenStr)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
									$author$project$Ui$Button$margin(10)
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								config.Hy,
								5,
								$author$project$Api$Provider$ApiKey$All$createdAt(apiKey)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Never',
								A2(
									$elm$core$Maybe$map,
									config.Hy(5),
									$author$project$Api$Provider$ApiKey$All$lastUsedAt(apiKey))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[statusBadge])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					function () {
						var _v1 = config.Gp;
						if (!_v1.$) {
							var onUseForWebhooksSignature = _v1.a;
							var isWebhooksSignatureKey = _Utils_eq(
								$elm$core$Maybe$Just(
									$author$project$Api$Provider$ApiKey$All$id(apiKey)),
								config.HQ);
							return isWebhooksSignatureKey ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$view,
									_List_fromArray(
										[$author$project$Ui$Badge$info]),
									_List_fromArray(
										[
											$elm$html$Html$text('Webhooks Signature')
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(2)
										]),
									_List_fromArray(
										[
											A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, apiKey, config.rG)
										])),
									A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, true, loading, apiKey, config.rF)
								]) : _List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Use API key for webhooks signature'},
									_List_fromArray(
										[
											$author$project$Ui$Button$secondary,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											onUseForWebhooksSignature(apiKey)),
											$author$project$Ui$Button$loading(loading)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Use for webhooks signature')
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(2)
										]),
									_List_fromArray(
										[
											A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, apiKey, config.rG)
										])),
									A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, false, loading, apiKey, config.rF)
								]);
						} else {
							return _List_fromArray(
								[
									A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, apiKey, config.rG),
									A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, false, loading, apiKey, config.rF)
								]);
						}
					}())
				]));
	});
var $author$project$Components$Developers$ManageApiKeys$viewApiKeysTable = function (config) {
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any API keys yet.')
					])),
				$author$project$Ui$Table$loading(config.S_)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Label')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Token')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Created')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Last Used')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Status')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Developers$ManageApiKeys$viewApiKeyRow(config),
			config.bN),
		_List_Nil);
};
var $author$project$Components$Developers$ManageApiKeys$ApiKeyLabel = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageApiKeys$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Developers$ManageApiKeys$Save = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Developers$ManageApiKeys$viewCreateEditModal = F3(
	function (maybeApiKey, form, request) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'API Key',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Provider$ApiKey$All$id, maybeApiKey),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Developers$ManageApiKeys$CancelEdit,
			U0: $elm$core$Basics$always(
				A2($author$project$Components$Developers$ManageApiKeys$Save, maybeApiKey, form))
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Label')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.aej),
									$author$project$Ui$Form$Input$placeholder('e.g. Production'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Developers$ManageApiKeys$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Api$Provider$ManagedPartner$Shared$webhooksSignatureApiKey = function (_v0) {
	var record = _v0;
	return record.aaZ;
};
var $author$project$Api$Provider$ManagedPartner$One$webhooksSignatureApiKey = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ManagedPartner$Shared$webhooksSignatureApiKey(shared);
};
var $author$project$Components$Developers$ManageApiKeys$view = function (_v0) {
	var model = _v0;
	var webhooksSignatureId = function () {
		var _v7 = model.rm;
		if (_v7.$ === 3) {
			var mp = _v7.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$ApiKey$Shared$id,
				$author$project$Api$Provider$ManagedPartner$One$webhooksSignatureApiKey(mp));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var _v1 = function () {
		var _v2 = model.Vp;
		if (!_v2) {
			return _Utils_Tuple2(
				'API Keys',
				$elm$core$Maybe$Just($author$project$Components$Developers$ManageApiKeys$UseForWebhooksSignature));
		} else {
			return _Utils_Tuple2('Integration API Keys', $elm$core$Maybe$Nothing);
		}
	}();
	var panelTitle = _v1.a;
	var onUseForWebhooksSignature = _v1.b;
	return _List_fromArray(
		[
			function () {
			var _v3 = model.FU;
			if (!_v3.$) {
				var _v4 = _v3.a;
				var maybeApiKey = _v4.a;
				var form = _v4.b;
				var request = _v4.c;
				return A3($author$project$Components$Developers$ManageApiKeys$viewCreateEditModal, maybeApiKey, form, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v5 = model.ic;
			if (!_v5.$) {
				var apiKey = _v5.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Developers$ManageApiKeys$HiConfirmClosed(apiKey),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('API key'),
							$author$project$Components$HiConfirm$detail(
							A2(
								$elm$core$Maybe$withDefault,
								'API Key',
								$author$project$Api$Provider$ApiKey$All$label(apiKey)))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									$elm$html$Html$text(panelTitle)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'New API key'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageApiKeys$New),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New API Key')
										]))
								]))
						])),
					$author$project$Components$Developers$ManageApiKeys$viewApiKeysTable(
					{
						bN: function () {
							var _v6 = model.bN;
							if (_v6.$ === 3) {
								var keys = _v6.a;
								return keys;
							} else {
								return _List_Nil;
							}
						}(),
						S_: _Utils_eq(model.bN, $author$project$Api$Data$Loading),
						Gn: $author$project$Components$Developers$ManageApiKeys$CopyToken,
						rF: $author$project$Components$Developers$ManageApiKeys$Delete,
						rG: $author$project$Components$Developers$ManageApiKeys$Edit,
						Go: $author$project$Components$Developers$ManageApiKeys$ToggleToken,
						Gp: onUseForWebhooksSignature,
						Hy: model.Hy,
						bE: model.bE,
						dl: model.dl,
						HQ: webhooksSignatureId
					})
				]))
		]);
};
var $author$project$Ui$Skeleton$spanSm = $author$project$Ui$Skeleton$Span(1);
var $author$project$Components$Developers$ManageApiKeys$skeleton = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$titleWithButton,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanMd(5)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanSm(3)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			A2(
				$elm$core$List$repeat,
				3,
				$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[$author$project$Ui$Skeleton$block]))))
		]));
var $author$project$Pages$Admin$Developers$ApiKeys$viewSkeleton = A2($elm$core$List$repeat, 2, $author$project$Components$Developers$ManageApiKeys$skeleton);
var $author$project$Pages$Admin$Developers$ApiKeys$view = function (model) {
	return {
		e5: function () {
			var _v0 = model.rm;
			if (_v0.$ === 1) {
				return $author$project$Pages$Admin$Developers$ApiKeys$viewSkeleton;
			} else {
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Developers$ManageApiKeys$view,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg))),
								model.jk)),
							A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Developers$ManageApiKeys$view,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg))),
								model.iU))
						]));
			}
		}(),
		$G: 'Admin | Developers | API Keys'
	};
};
var $author$project$Pages$Admin$Developers$ApiKeys$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Developers$ApiKeys$init, aer: $author$project$Pages$Admin$Developers$ApiKeys$load, agD: $author$project$Pages$Admin$Developers$ApiKeys$save, ahd: $author$project$Pages$Admin$Developers$ApiKeys$subscriptions, aaq: $author$project$Pages$Admin$Developers$ApiKeys$update, ahP: $author$project$Pages$Admin$Developers$ApiKeys$view});
var $author$project$Pages$Admin$Developers$GetStarted$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Developers$GetStarted$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{D5: shared.D5, lD: $author$project$Api$Data$NotAsked, rm: $author$project$Api$Data$Loading},
			A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.D5, $author$project$Pages$Admin$Developers$GetStarted$GotManagedPartner));
	});
var $author$project$Pages$Admin$Developers$GetStarted$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$GetStarted$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Developers$GetStarted$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Developers$GetStarted$GotCreateIntegration = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$ManagedPartner$Integration$integrationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'integration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Integration$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Integration$Shared$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$integrationPath));
	});
var $author$project$Pages$Admin$Developers$GetStarted$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var managedPartner = response.a;
					var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
					if (!_v2.$) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rm: response}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rm: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lD: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$ManagedPartner$Integration$create, model.D5, $author$project$Pages$Admin$Developers$GetStarted$GotCreateIntegration),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lD: response}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lD: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Developers$GetStarted$ClickedGetStarted = {$: 1};
var $author$project$Pages$Admin$Developers$GetStarted$viewGetStarted = function (loading) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Your integration is not set up yet. Click the button below to create your integration and get access to API keys and webhook endpoints.')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Get started'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Pages$Admin$Developers$GetStarted$ClickedGetStarted),
						$author$project$Ui$Button$loading(loading)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Get Started')
					]))
			]));
};
var $author$project$Pages$Admin$Developers$GetStarted$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Get Started with Developer Settings')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$Developers$GetStarted$viewGetStarted(
								_Utils_eq(model.lD, $author$project$Api$Data$Loading))
							]))
					]))
			]),
		$G: 'Admin | Developers | Get Started'
	};
};
var $author$project$Pages$Admin$Developers$GetStarted$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Developers$GetStarted$init, aer: $author$project$Pages$Admin$Developers$GetStarted$load, agD: $author$project$Pages$Admin$Developers$GetStarted$save, ahd: $author$project$Pages$Admin$Developers$GetStarted$subscriptions, aaq: $author$project$Pages$Admin$Developers$GetStarted$update, ahP: $author$project$Pages$Admin$Developers$GetStarted$view});
var $author$project$Pages$Admin$Developers$Sandboxes$SandboxesMsg = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageSandboxes$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$GotSandboxPartners = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Partner$All$Partner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Partner$Shared$Partner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Partner$Shared$Record = F2(
	function (name, logoUrl) {
		return {S8: logoUrl, zh: name};
	});
var $author$project$Api$Provider$Partner$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'logo_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$Shared$Record)));
var $author$project$Api$Provider$Partner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Partner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Partner$All$Record = F2(
	function (id, organizationId) {
		return {adR: id, aft: organizationId};
	});
var $author$project$Api$Provider$Partner$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$All$Record)));
var $author$project$Api$Provider$Partner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Partner$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Partner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$All$Partner)));
var $author$project$Api$Provider$ManagedPartner$Sandbox$Partner$sandboxPartnersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'sandboxes', 'partners']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Sandbox$Partner$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Partner$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$sandboxPartnersPath));
	});
var $author$project$Api$Provider$Practice$All$Practice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practice$Min$Practice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Practice$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$Min$Record)));
var $author$project$Api$Provider$Practice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practice$All$Record = function (organizationId) {
	return {aft: organizationId};
};
var $author$project$Api$Provider$Practice$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$All$Record));
var $author$project$Api$Provider$Practice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practice$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Practice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$All$Practice)));
var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'sandboxes', 'practices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Practice$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath));
	});
var $author$project$Components$Developers$ManageSandboxes$init = function (apiClient) {
	return _Utils_Tuple2(
		{bK: $elm$core$Maybe$Nothing, bL: $elm$core$Maybe$Nothing, rm: $author$project$Api$Data$Loading, sx: $author$project$Api$Data$Loading, sy: $author$project$Api$Data$Loading},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$ManagedPartner$retrieve, apiClient, $author$project$Components$Developers$ManageSandboxes$GotManagedPartner),
					A2($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPartners),
					A2($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices)
				])));
};
var $author$project$Pages$Admin$Developers$Sandboxes$init = F4(
	function (session, practice, shared, _v0) {
		if ($author$project$Api$Provider$Practice$One$hasManagedPartner(practice)) {
			var _v1 = $author$project$Components$Developers$ManageSandboxes$init(shared.D5);
			var sandboxesModel = _v1.a;
			var sandboxesCmd = _v1.b;
			return _Utils_Tuple2(
				{
					D5: shared.D5,
					jX: $elm$core$Maybe$Just(sandboxesModel)
				},
				A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, sandboxesCmd));
		} else {
			return _Utils_Tuple2(
				{D5: shared.D5, jX: $elm$core$Maybe$Nothing},
				A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$empty,
					A2($author$project$Permission$homeStateFor, session, shared.adN)));
		}
	});
var $author$project$Pages$Admin$Developers$Sandboxes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$Sandboxes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Developers$ManageSandboxes$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Developers$Sandboxes$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Components$Developers$ManageSandboxes$subscriptions,
				$elm$core$Platform$Sub$map($elm$core$Basics$identity)),
			model.jX));
};
var $author$project$OutMsg$GoToRouteAndReloadAction = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$SandboxPartnerCreated = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Developers$ManageSandboxes$SandboxPracticeCreated = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$OutMsg$SwitchToOrganization = F3(
	function (a, b, c) {
		return {$: 15, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Partner$One$Partner = 0;
var $author$project$Api$Provider$Partner$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$ManagedPartner$Sandbox$Partner$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(params.zh))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$sandboxPartnersPath)));
	});
var $author$project$Api$Provider$Practice$IdAndName$Practice = 0;
var $author$project$Api$Provider$Practice$IdAndName$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(params.zh))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$IdAndName$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath)));
	});
var $author$project$Components$Developers$ManageSandboxes$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rm: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sx: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sy: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bK: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just('Sandbox'),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bK: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var name = msg.a;
				var _v2 = model.bK;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var request = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bK: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(name),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var _v4 = model.bK;
				if ((!_v4.$) && (!_v4.a.a.$)) {
					var _v5 = _v4.a;
					var name = _v5.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bK: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										$author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$ManagedPartner$Sandbox$Partner$create,
							apiClient,
							{zh: name},
							$author$project$Components$Developers$ManageSandboxes$SandboxPartnerCreated(name)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var name = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bK: $elm$core$Maybe$Nothing, sx: $author$project$Api$Data$Loading}),
						A2($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPartners),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sandbox added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bK: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bL: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just('Sandbox Practice'),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bL: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var name = msg.a;
				var _v7 = model.bL;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var request = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bL: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(name),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var _v9 = model.bL;
				if ((!_v9.$) && (!_v9.a.a.$)) {
					var _v10 = _v9.a;
					var name = _v10.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bL: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										$author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$ManagedPartner$Sandbox$Practice$create,
							apiClient,
							{zh: name},
							$author$project$Components$Developers$ManageSandboxes$SandboxPracticeCreated(name)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var name = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bL: $elm$core$Maybe$Nothing, sy: $author$project$Api$Data$Loading}),
						A2($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sandbox practice added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bL: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var organizationId = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3(
							$author$project$OutMsg$SwitchToOrganization,
							organizationId,
							$elm$core$Maybe$Nothing,
							$author$project$OutMsg$GoToRouteAndReloadAction($author$project$Spa$Generated$Route$Patients__Top))
						]));
		}
	});
var $author$project$Pages$Admin$Developers$Sandboxes$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = model.jX;
		if (!_v1.$) {
			var sandboxes = _v1.a;
			var _v2 = A3($author$project$Components$Developers$ManageSandboxes$update, model.D5, subMsg, sandboxes);
			var updated = _v2.a;
			var cmd = _v2.b;
			var outMsgs = _v2.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						jX: $elm$core$Maybe$Just(updated)
					}),
				A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
				outMsgs);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Developers$ManageSandboxes$skeleton = A2(
	$author$project$Ui$FlexGrid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(6)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$titleWithButton,
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanMd(5)
												]))
										]),
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$input(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanSm(3)
												]))
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							A2(
								$elm$core$List$repeat,
								3,
								$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[$author$project$Ui$Skeleton$block]))))
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(6)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$titleWithButton,
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanMd(5)
												]))
										]),
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$input(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanSm(3)
												]))
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							A2(
								$elm$core$List$repeat,
								3,
								$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[$author$project$Ui$Skeleton$block]))))
						]))
				]))
		]));
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerClosed = {$: 4};
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerNameUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$SaveSandboxPartner = {$: 6};
var $author$project$Components$Developers$ManageSandboxes$viewAddSandboxPartnerModal = F2(
	function (name, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Sandbox Partner')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', name)),
											$author$project$Ui$Form$Input$onInput($author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerNameUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(name, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Name is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add Sandbox Partner'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$SaveSandboxPartner),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Sandbox Partner')
								]))
						]))
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed = {$: 9};
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeNameUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Developers$ManageSandboxes$SaveSandboxPractice = {$: 11};
var $author$project$Components$Developers$ManageSandboxes$viewAddSandboxPracticeModal = F2(
	function (name, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Sandbox Practice')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', name)),
											$author$project$Ui$Form$Input$onInput($author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeNameUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(name, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Name is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add Sandbox Practice'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$SaveSandboxPractice),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Sandbox Practice')
								]))
						]))
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPartner = {$: 3};
var $author$project$Api$Provider$ManagedPartner$Shared$sandboxEnabled = function (_v0) {
	var record = _v0;
	return record.Y0;
};
var $author$project$Api$Provider$ManagedPartner$One$sandboxEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ManagedPartner$Shared$sandboxEnabled(shared);
};
var $author$project$Components$Developers$ManageSandboxes$SwitchToSandbox = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$ManagedPartner$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$ManagedPartner$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ManagedPartner$Shared$id(shared);
};
var $author$project$Api$Provider$Partner$All$id = function (_v0) {
	var record = _v0.b;
	return record.adR;
};
var $author$project$Api$Provider$Partner$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Partner$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Partner$Shared$name(shared);
};
var $author$project$Api$Provider$Partner$All$organizationId = function (_v0) {
	var record = _v0.b;
	return record.aft;
};
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPartnerRow = F2(
	function (managedPartner, sandboxPartner) {
		var sandboxName = $author$project$Api$Provider$Partner$All$name(sandboxPartner);
		var isCurrentSandbox = _Utils_eq(
			$author$project$Api$Provider$Partner$All$id(sandboxPartner),
			$author$project$Api$Provider$ManagedPartner$One$id(managedPartner));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sandboxName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							isCurrentSandbox ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Button$view,
							{abp: 'Switch' + sandboxName},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Developers$ManageSandboxes$SwitchToSandbox(
										$author$project$Api$Provider$Partner$All$organizationId(sandboxPartner)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Switch')
								]))
						]))
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPartnersTable = F2(
	function (managedPartner, model) {
		var _v0 = function () {
			var _v1 = model.sx;
			if (_v1.$ === 3) {
				var partners = _v1.a;
				return _Utils_Tuple2(false, partners);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var sandboxPartners = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('You don\'t have any sandbox partners')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Developers$ManageSandboxes$viewSandboxPartnerRow(managedPartner),
				sandboxPartners),
			_List_Nil);
	});
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPartners = F2(
	function (managedPartner, model) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									$elm$html$Html$text('Sandbox Partners')
								]),
							_List_fromArray(
								[
									$author$project$Api$Provider$ManagedPartner$One$sandboxEnabled(managedPartner) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Add sandbox partner'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPartner)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Sandbox Partner')
										])) : $author$project$Utils$Html$empty
								]))
						])),
					A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPartnersTable, managedPartner, model)
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$NewSandboxPractice = {$: 8};
var $author$project$Api$Provider$Practice$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Practice$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Practice$Min$id(min);
};
var $author$project$Api$Provider$Practice$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Practice$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Practice$Min$name(min);
};
var $author$project$Api$Provider$Practice$All$organizationId = function (_v0) {
	var record = _v0.b;
	return record.aft;
};
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPracticeRow = F2(
	function (managedPartner, sandboxPractice) {
		var sandboxName = $author$project$Api$Provider$Practice$All$name(sandboxPractice);
		var isCurrentSandbox = _Utils_eq(
			$author$project$Api$Provider$Practice$All$id(sandboxPractice),
			$author$project$Api$Provider$ManagedPartner$One$id(managedPartner));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sandboxName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							isCurrentSandbox ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Button$view,
							{abp: 'Switch' + sandboxName},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Developers$ManageSandboxes$SwitchToSandbox(
										$author$project$Api$Provider$Practice$All$organizationId(sandboxPractice)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Switch')
								]))
						]))
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPracticesTable = F2(
	function (managedPartner, model) {
		var _v0 = function () {
			var _v1 = model.sy;
			if (_v1.$ === 3) {
				var practices = _v1.a;
				return _Utils_Tuple2(false, practices);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var sandboxPractices = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('You don\'t have any sandbox practices')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Developers$ManageSandboxes$viewSandboxPracticeRow(managedPartner),
				sandboxPractices),
			_List_Nil);
	});
var $author$project$Components$Developers$ManageSandboxes$viewSandboxPractices = F2(
	function (managedPartner, model) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									$elm$html$Html$text('Sandbox Practices')
								]),
							_List_fromArray(
								[
									$author$project$Api$Provider$ManagedPartner$One$sandboxEnabled(managedPartner) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Add sandbox practice'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPractice)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Sandbox Practice')
										])) : $author$project$Utils$Html$empty
								]))
						])),
					A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPracticesTable, managedPartner, model)
				]));
	});
var $author$project$Components$Developers$ManageSandboxes$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.bK;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var name = _v2.a;
				var request = _v2.b;
				return A2($author$project$Components$Developers$ManageSandboxes$viewAddSandboxPartnerModal, name, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.bL;
			if (!_v3.$) {
				var _v4 = _v3.a;
				var name = _v4.a;
				var request = _v4.b;
				return A2($author$project$Components$Developers$ManageSandboxes$viewAddSandboxPracticeModal, name, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v5 = model.rm;
			if (_v5.$ === 3) {
				var managedPartner = _v5.a;
				return A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPartners, managedPartner, model)
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPractices, managedPartner, model)
								]))
						]));
			} else {
				return $author$project$Components$Developers$ManageSandboxes$skeleton;
			}
		}()
		]);
};
var $author$project$Pages$Admin$Developers$Sandboxes$view = function (model) {
	return {
		e5: function () {
			var _v0 = model.jX;
			if (_v0.$ === 1) {
				return _List_fromArray(
					[$author$project$Components$Developers$ManageSandboxes$skeleton]);
			} else {
				var sandboxes = _v0.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($elm$core$Basics$identity),
					$author$project$Components$Developers$ManageSandboxes$view(sandboxes));
			}
		}(),
		$G: 'Admin | Developers | Sandboxes'
	};
};
var $author$project$Pages$Admin$Developers$Sandboxes$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Developers$Sandboxes$init, aer: $author$project$Pages$Admin$Developers$Sandboxes$load, agD: $author$project$Pages$Admin$Developers$Sandboxes$save, ahd: $author$project$Pages$Admin$Developers$Sandboxes$subscriptions, aaq: $author$project$Pages$Admin$Developers$Sandboxes$update, ahP: $author$project$Pages$Admin$Developers$Sandboxes$view});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$GotManagedPartner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Developers$WebhookEndpoints$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{D5: shared.D5, iV: $elm$core$Maybe$Nothing, rm: $author$project$Api$Data$Loading, jn: $elm$core$Maybe$Nothing, Hy: shared.Hy},
			$author$project$Api$Provider$Practice$One$hasManagedPartner(practice) ? A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.D5, $author$project$Pages$Admin$Developers$WebhookEndpoints$GotManagedPartner) : A2(
				$author$project$Utils$Route$navigate,
				$elm$core$Dict$empty,
				A2($author$project$Permission$homeStateFor, session, shared.adN)));
	});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit = {$: 3};
var $author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit)),
					model.FU)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed),
					model.ic))
			]));
};
var $author$project$Pages$Admin$Developers$WebhookEndpoints$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageWebhookEndpoints$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg)),
					model.jn)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Developers$ManageWebhookEndpoints$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg)),
					model.iV))
			]));
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Integration = 1;
var $author$project$Components$Developers$ManageWebhookEndpoints$Partner = 0;
var $author$project$Components$Developers$ManageWebhookEndpoints$Model = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$WebhookEndpoint$All$WebhookEndpoint = $elm$core$Basics$identity;
var $author$project$Api$Provider$WebhookEndpoint$Shared$WebhookEndpoint = $elm$core$Basics$identity;
var $author$project$Api$Provider$WebhookEndpoint$Shared$Record = F4(
	function (id, webhookUrl, createdAt, lastDeliveredAt) {
		return {Mf: createdAt, adR: id, Sx: lastDeliveredAt, aaW: webhookUrl};
	});
var $author$project$Api$Provider$WebhookEndpoint$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_delivered_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'webhook_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$WebhookEndpoint$Shared$Record)))));
var $author$project$Api$Provider$WebhookEndpoint$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$WebhookEndpoint$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$WebhookEndpoint$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$WebhookEndpoint$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'integration', 'webhook_endpoints']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$WebhookEndpoint$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath));
	});
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['managed_partner', 'webhook_endpoints']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$WebhookEndpoint$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints = F2(
	function (apiClient, owner) {
		if (!owner) {
			return A2($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$list, apiClient, $author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints);
		} else {
			return A2($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$list, apiClient, $author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints);
		}
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$init = F3(
	function (apiClient, timeFormatter, owner) {
		return _Utils_Tuple2(
			{ic: $elm$core$Maybe$Nothing, FU: $elm$core$Maybe$Nothing, Vp: owner, Hy: timeFormatter, hf: $author$project$Api$Data$Loading},
			A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, owner));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Deleted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Updated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$WebhookEndpoint$One$WebhookEndpoint = 0;
var $author$project$Api$Provider$WebhookEndpoint$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aaW))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aaW))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath(id_)));
	});
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath(id_)));
	});
var $author$project$Api$Provider$WebhookEndpoint$Shared$webhookUrl = function (_v0) {
	var record = _v0;
	return record.aaW;
};
var $author$project$Api$Provider$WebhookEndpoint$All$webhookUrl = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$webhookUrl(shared);
};
var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsFromItem = function (endpoint) {
	return {
		aaW: $author$project$Api$Provider$WebhookEndpoint$All$webhookUrl(endpoint)
	};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsInit = {aaW: ''};
var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{aaW: string});
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$WebhookUrlValidation = 0;
var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.aaW;
			},
			_Utils_Tuple2(0, 'Please enter a URL.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (f) {
				return $elm$core$String$isEmpty(f.aaW) || A2($elm$core$String$startsWith, 'https://', f.aaW);
			},
			_Utils_Tuple2(0, 'URL must start with https://.'))
		]));
var $author$project$Api$Provider$WebhookEndpoint$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$WebhookEndpoint$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$id(shared);
};
var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aaW))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath(id_))));
	});
var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$update = F4(
	function (apiClient, id_, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aaW))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath(id_))));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hf: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Developers$ManageWebhookEndpoints$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var endpoint = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(endpoint),
									$author$project$Utils$Form$init(
										$author$project$Components$Developers$ManageWebhookEndpoints$formFieldsFromItem(endpoint)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				var _v2 = model.FU;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var maybeEndpoint = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										maybeEndpoint,
										A3($author$project$Utils$Form$update, $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsUpdate, field, form),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var maybeEndpoint = msg.a;
				var form = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var validatedForm = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var cmd = function () {
						if (maybeEndpoint.$ === 1) {
							var _v7 = model.Vp;
							if (!_v7) {
								return A3(
									$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$create,
									apiClient,
									{aaW: fields.aaW},
									$author$project$Components$Developers$ManageWebhookEndpoints$Created);
							} else {
								return A3(
									$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$create,
									apiClient,
									{aaW: fields.aaW},
									$author$project$Components$Developers$ManageWebhookEndpoints$Created);
							}
						} else {
							var endpoint = maybeEndpoint.a;
							var _v8 = model.Vp;
							if (!_v8) {
								return A4(
									$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$update,
									apiClient,
									$author$project$Api$Provider$WebhookEndpoint$All$id(endpoint),
									{aaW: fields.aaW},
									$author$project$Components$Developers$ManageWebhookEndpoints$Updated);
							} else {
								return A4(
									$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$update,
									apiClient,
									$author$project$Api$Provider$WebhookEndpoint$All$id(endpoint),
									{aaW: fields.aaW},
									$author$project$Components$Developers$ManageWebhookEndpoints$Updated);
							}
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeEndpoint, validatedForm, $author$project$Api$Data$Loading))
							}),
						cmd,
						_List_Nil);
				} else {
					var validatedForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeEndpoint, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v9 = model.FU;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var maybeEndpoint = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, hf: $author$project$Api$Data$Loading}),
							A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.Vp),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint added.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeEndpoint, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v12 = model.FU;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var maybeEndpoint = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, hf: $author$project$Api$Data$Loading}),
							A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.Vp),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeEndpoint, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var endpoint = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Just(endpoint)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var endpoint = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var deleteCmd = function () {
						var _v15 = model.Vp;
						if (!_v15) {
							return A3(
								$author$project$Api$Provider$ManagedPartner$WebhookEndpoint$delete,
								apiClient,
								$author$project$Api$Provider$WebhookEndpoint$All$id(endpoint),
								$author$project$Components$Developers$ManageWebhookEndpoints$Deleted);
						} else {
							return A3(
								$author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$delete,
								apiClient,
								$author$project$Api$Provider$WebhookEndpoint$All$id(endpoint),
								$author$project$Components$Developers$ManageWebhookEndpoints$Deleted);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						deleteCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: $author$project$Api$Data$Loading}),
						A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.Vp),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Developers$WebhookEndpoints$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var managedPartner = response.a;
					var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
					if (!_v2.$) {
						var _v3 = A3($author$project$Components$Developers$ManageWebhookEndpoints$init, model.D5, model.Hy, 0);
						var partnerWebhookEndpoints = _v3.a;
						var partnerCmd = _v3.b;
						var _v4 = A3($author$project$Components$Developers$ManageWebhookEndpoints$init, model.D5, model.Hy, 1);
						var integrationWebhookEndpoints = _v4.a;
						var integrationCmd = _v4.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									iV: $elm$core$Maybe$Just(integrationWebhookEndpoints),
									rm: response,
									jn: $elm$core$Maybe$Just(partnerWebhookEndpoints)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg, partnerCmd),
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg, integrationCmd)
									])),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rm: response}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v5 = model.jn;
				if (!_v5.$) {
					var partnerWebhookEndpoints = _v5.a;
					var _v6 = A3($author$project$Components$Developers$ManageWebhookEndpoints$update, model.D5, subMsg, partnerWebhookEndpoints);
					var updated = _v6.a;
					var cmd = _v6.b;
					var outMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								jn: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v7 = model.iV;
				if (!_v7.$) {
					var integrationWebhookEndpoints = _v7.a;
					var _v8 = A3($author$project$Components$Developers$ManageWebhookEndpoints$update, model.D5, subMsg, integrationWebhookEndpoints);
					var updated = _v8.a;
					var cmd = _v8.b;
					var outMsgs = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iV: $elm$core$Maybe$Just(updated)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$New = {$: 1};
var $author$project$Components$Developers$ManageWebhookEndpoints$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Save = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$WebhookUrl = $elm$core$Basics$identity;
var $author$project$Components$Developers$ManageWebhookEndpoints$viewCreateEditModal = F3(
	function (maybeEndpoint, form, request) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Webhook Endpoint',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Provider$WebhookEndpoint$All$id, maybeEndpoint),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit,
			U0: $elm$core$Basics$always(
				A2($author$project$Components$Developers$ManageWebhookEndpoints$Save, maybeEndpoint, form))
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('URL')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.aaW),
									$author$project$Ui$Form$Input$placeholder('https://example.com/webhook'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Developers$ManageWebhookEndpoints$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$Delete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Developers$ManageWebhookEndpoints$Edit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$WebhookEndpoint$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$WebhookEndpoint$All$createdAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$createdAt(shared);
};
var $author$project$Api$Provider$WebhookEndpoint$Shared$lastDeliveredAt = function (_v0) {
	var record = _v0;
	return record.Sx;
};
var $author$project$Api$Provider$WebhookEndpoint$All$lastDeliveredAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$WebhookEndpoint$Shared$lastDeliveredAt(shared);
};
var $author$project$Components$Developers$ManageWebhookEndpoints$viewWebhookRow = F2(
	function (timeFormatter, endpoint) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$WebhookEndpoint$All$webhookUrl(endpoint))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								timeFormatter,
								5,
								$author$project$Api$Provider$WebhookEndpoint$All$createdAt(endpoint)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'Never',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(5),
									$author$project$Api$Provider$WebhookEndpoint$All$lastDeliveredAt(endpoint))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Edit webhook endpoint'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Developers$ManageWebhookEndpoints$Edit(endpoint)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Edit')
								])),
							$author$project$Utils$Html$noBreakSpace,
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Delete webhook endpoint'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Developers$ManageWebhookEndpoints$Delete(endpoint)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Components$Developers$ManageWebhookEndpoints$view = function (_v0) {
	var model = _v0;
	var panelTitle = function () {
		var _v5 = model.Vp;
		if (!_v5) {
			return 'Webhook Endpoints';
		} else {
			return 'Integration Webhook Endpoints';
		}
	}();
	return _List_fromArray(
		[
			function () {
			var _v1 = model.FU;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var maybeEndpoint = _v2.a;
				var form = _v2.b;
				var request = _v2.c;
				return A3($author$project$Components$Developers$ManageWebhookEndpoints$viewCreateEditModal, maybeEndpoint, form, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.ic;
			if (!_v3.$) {
				var endpoint = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed(endpoint),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('webhook endpoint'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Provider$WebhookEndpoint$All$webhookUrl(endpoint))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									$elm$html$Html$text(panelTitle)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add webhook endpoint'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Components$Developers$ManageWebhookEndpoints$New),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Endpoint')
										]))
								]))
						])),
					A4(
					$author$project$Ui$Panel$table,
					_List_fromArray(
						[
							$author$project$Ui$Table$zeroState(
							_List_fromArray(
								[
									$elm$html$Html$text('You don\'t have any webhook endpoints yet.')
								])),
							$author$project$Ui$Table$loading(
							_Utils_eq(model.hf, $author$project$Api$Data$Loading))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$header,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('URL')
								])),
							A2(
							$author$project$Ui$Table$header,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Created')
								])),
							A2(
							$author$project$Ui$Table$header,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Last Delivered')
								])),
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						]),
					function () {
						var _v4 = model.hf;
						if (_v4.$ === 3) {
							var endpoints = _v4.a;
							return A2(
								$elm$core$List$map,
								$author$project$Components$Developers$ManageWebhookEndpoints$viewWebhookRow(model.Hy),
								endpoints);
						} else {
							return _List_Nil;
						}
					}(),
					_List_Nil)
				]))
		]);
};
var $author$project$Components$Developers$ManageWebhookEndpoints$skeleton = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$titleWithButton,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanMd(5)
								]))
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanSm(3)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			A2(
				$elm$core$List$repeat,
				3,
				$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[$author$project$Ui$Skeleton$block]))))
		]));
var $author$project$Pages$Admin$Developers$WebhookEndpoints$viewSkeleton = A2($elm$core$List$repeat, 2, $author$project$Components$Developers$ManageWebhookEndpoints$skeleton);
var $author$project$Pages$Admin$Developers$WebhookEndpoints$view = function (model) {
	return {
		e5: function () {
			var _v0 = model.rm;
			if (_v0.$ === 1) {
				return $author$project$Pages$Admin$Developers$WebhookEndpoints$viewSkeleton;
			} else {
				return $elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Developers$ManageWebhookEndpoints$view,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg))),
								model.jn)),
							A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Components$Developers$ManageWebhookEndpoints$view,
									$elm$core$List$map(
										$elm$html$Html$map($author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg))),
								model.iV))
						]));
			}
		}(),
		$G: 'Admin | Developers | Webhook Endpoints'
	};
};
var $author$project$Pages$Admin$Developers$WebhookEndpoints$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Developers$WebhookEndpoints$init, aer: $author$project$Pages$Admin$Developers$WebhookEndpoints$load, agD: $author$project$Pages$Admin$Developers$WebhookEndpoints$save, ahd: $author$project$Pages$Admin$Developers$WebhookEndpoints$subscriptions, aaq: $author$project$Pages$Admin$Developers$WebhookEndpoints$update, ahP: $author$project$Pages$Admin$Developers$WebhookEndpoints$view});
var $author$project$Pages$Admin$Documents$Id_String$DocumentFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$Documents$Form$GotItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Documents$Form$LanguageDropdownMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$Documents$Form$Model = $elm$core$Basics$identity;
var $author$project$Api$Feature$MultiLanguage = 10;
var $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$File = 1;
var $author$project$Api$Provider$Document$AcceptanceType$TypeName = 1;
var $author$project$Components$Admin$Documents$Form$formFieldsInit = function (practice) {
	return _Utils_Tuple2(
		{
			HX: 'I have read and agree to the ' + $author$project$Api$Provider$Practice$One$name(practice),
			HY: 1,
			Ic: true,
			EG: $elm$core$Maybe$Nothing,
			dY: $elm$core$Maybe$Nothing,
			NY: _List_Nil,
			NZ: $elm$core$Maybe$Just('Agreement'),
			xh: 1,
			qG: 0,
			Po: $elm$core$Maybe$Nothing,
			qM: false,
			SW: $elm$core$Maybe$Nothing,
			zh: '',
			Wp: 2,
			agk: true,
			ZW: true,
			ag7: 'published',
			aaa: _List_Nil
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$ResourceFilter$Location$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$All$Location = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Location$Shared$Location = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$Shared$Record = function (id) {
	return function (name) {
		return function (onlineSignupVisibility) {
			return function (businessLocation) {
				return function (virtual) {
					return function (phoneNumber) {
						return function (address) {
							return function (locationGroup) {
								return function (affiliation) {
									return function (isMaster) {
										return function (isSynced) {
											return {It: address, IJ: affiliation, Kg: businessLocation, adR: id, RQ: isMaster, Sa: isSynced, rj: locationGroup, zh: name, U8: onlineSignupVisibility, Wh: phoneNumber, aaS: virtual};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Affiliate$AffiliateMin$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliate$AffiliateMin$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Affiliate$AffiliateMin$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$AffiliateMin$Record)));
var $author$project$Api$Provider$Affiliate$AffiliateMin$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$AffiliateMin$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Location$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_synced',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_master',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'affiliation',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location_group',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$LocationGroup$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'phone_number',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'virtual',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'business_location',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'online_signup_visibility',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Shared$Record))))))))))));
var $author$project$Api$Provider$Location$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Location$All$Record = F2(
	function (hasPatients, meta) {
		return {Qb: hasPatients, TU: meta};
	});
var $author$project$Api$Provider$Location$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$Meta$MetaRecord = function (actions) {
	return {tF: actions};
};
var $author$project$Api$Provider$Location$Meta$ActionsRecord = function (_delete) {
	return {Np: _delete};
};
var $author$project$Api$Provider$Location$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'delete',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Meta$ActionsRecord));
var $author$project$Api$Provider$Location$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Location$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Meta$MetaRecord));
var $author$project$Api$Provider$Location$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Location$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'meta',
	$author$project$Api$Provider$Location$Meta$decoder,
	A3(
		$author$project$Api$Expandable$expandable,
		'has_patients',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$All$Record)));
var $author$project$Api$Provider$Location$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Location$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$All$Location)));
var $author$project$Api$Provider$Location$expandToString = function (expand) {
	return 'meta';
};
var $author$project$Api$Provider$Location$listDefaults = {
	DZ: $elm$core$Maybe$Nothing,
	Fc: _List_Nil,
	adR: $elm$core$Maybe$Nothing,
	rj: $elm$core$Maybe$Nothing,
	Gr: $elm$core$Maybe$Nothing,
	afy: $elm$core$Maybe$Nothing,
	afS: $elm$core$Maybe$Nothing,
	af_: $elm$core$Maybe$Nothing,
	Hc: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$Location$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Location$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.rj;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location_group', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.afy;
				if (!_v3.$) {
					var pagination = _v3.a;
					return $author$project$Api$Pagination$toApiParams(pagination);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				function () {
				var _v4 = options.Gr;
				if (!_v4.$) {
					var bool = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'online_signup', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.Hc;
				if (!_v5.$) {
					var ident = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'signup_page', ident)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.afS;
				if (!_v6.$) {
					var ident = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', ident)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v7 = options.DZ;
				if (!_v7.$) {
					var ident = _v7.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'affiliate', ident)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Location$expandToString, options.Fc)
			]));
};
var $author$project$Api$Provider$Location$locationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['locations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Location$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Location$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Location$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Location$locationsPath)));
	});
var $author$project$Components$ResourceFilter$Location$list = $author$project$Api$Provider$Location$list;
var $author$project$Api$Affiliate$AffiliateMin$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Location$Shared$affiliation = function (_v0) {
	var record = _v0;
	return record.IJ;
};
var $author$project$Api$Provider$Location$All$affiliation = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$affiliation(shared);
};
var $author$project$Api$Provider$Location$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Location$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$id(shared);
};
var $author$project$Api$Provider$Location$Shared$isMaster = function (_v0) {
	var record = _v0;
	return record.RQ;
};
var $author$project$Api$Provider$Location$All$isMaster = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$isMaster(shared);
};
var $author$project$Api$Provider$Location$Shared$isSynced = function (_v0) {
	var record = _v0;
	return record.Sa;
};
var $author$project$Api$Provider$Location$All$isSynced = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$isSynced(shared);
};
var $author$project$Api$Provider$Location$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Location$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$Location$resourceFromAll = function (location) {
	return {
		IJ: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Location$All$affiliation(location)),
		adR: $author$project$Api$Provider$Location$All$id(location),
		RQ: $author$project$Api$Provider$Location$All$isMaster(location),
		Sa: $author$project$Api$Provider$Location$All$isSynced(location),
		zh: $author$project$Api$Provider$Location$All$name(location)
	};
};
var $author$project$Components$ResourceFilter$Location$fetchResources = F6(
	function (locationGroupId, listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Location$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							rj: locationGroupId,
							afy: $elm$core$Maybe$Just(pagination),
							af_: query
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Location$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Location$retrieveResource = F5(
	function (locationGroupId, listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Location$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id),
							rj: locationGroupId,
							afy: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Location$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Location$selectId = 'locations';
var $author$project$Components$SyncedIcon$Master = 0;
var $author$project$Components$SyncedIcon$Role = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$SyncedIcon$master = $author$project$Components$SyncedIcon$Role(0);
var $author$project$Components$SyncedIcon$SyncStatus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$SyncedIcon$status = $author$project$Components$SyncedIcon$SyncStatus;
var $author$project$Components$SyncedIcon$Synced = 1;
var $author$project$Components$SyncedIcon$synced = $author$project$Components$SyncedIcon$Role(1);
var $author$project$Components$ResourceFilter$Location$toTitle = function ($) {
	return $.zh;
};
var $author$project$Ui$SvgIcon$Current = 4;
var $author$project$Ui$SvgIcon$currentColor = $author$project$Ui$SvgIcon$IconColor(4);
var $author$project$Ui$SvgIcon$SyncedTo = 0;
var $author$project$Ui$SvgIcon$syncedTo = $author$project$Ui$SvgIcon$viewIcon(0);
var $author$project$Components$SyncedIcon$defaultOptions = {hM: $author$project$Ui$SvgIcon$currentColor, QG: $author$project$Ui$SvgIcon$syncedTo, S_: false, ag_: $author$project$Ui$SvgIcon$base};
var $author$project$Ui$SvgIcon$Primary = 1;
var $author$project$Ui$SvgIcon$primary = $author$project$Ui$SvgIcon$IconColor(1);
var $author$project$Ui$SvgIcon$SyncedFrom = 1;
var $author$project$Ui$SvgIcon$syncedFrom = $author$project$Ui$SvgIcon$viewIcon(1);
var $author$project$Components$SyncedIcon$optionToRecord = F2(
	function (option, record) {
		switch (option.$) {
			case 2:
				var _v1 = option.a;
				return _Utils_update(
					record,
					{ag_: $author$project$Ui$SvgIcon$base});
			case 0:
				if (!option.a) {
					var _v2 = option.a;
					return _Utils_update(
						record,
						{QG: $author$project$Ui$SvgIcon$syncedTo});
				} else {
					var _v3 = option.a;
					return _Utils_update(
						record,
						{QG: $author$project$Ui$SvgIcon$syncedFrom});
				}
			default:
				if (option.a.$ === 1) {
					var _v4 = option.a;
					return record;
				} else {
					var status_ = option.a.a;
					switch (status_) {
						case 2:
							return _Utils_update(
								record,
								{hM: $author$project$Ui$SvgIcon$primary});
						case 1:
							return _Utils_update(
								record,
								{hM: $author$project$Ui$SvgIcon$currentColor});
						case 3:
							return _Utils_update(
								record,
								{hM: $author$project$Ui$SvgIcon$danger});
						default:
							return _Utils_update(
								record,
								{hM: $author$project$Ui$SvgIcon$info});
					}
				}
		}
	});
var $author$project$Components$SyncedIcon$view = function (options) {
	var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$SyncedIcon$optionToRecord, $author$project$Components$SyncedIcon$defaultOptions, options);
	return optionsRecord.S_ ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		optionsRecord.QG(
			_List_fromArray(
				[optionsRecord.hM, optionsRecord.ag_])));
};
var $author$project$Components$ResourceFilter$Location$toLabel = function (resource) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceX2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$ResourceFilter$Location$toTitle(resource))
						])),
					resource.RQ ? $author$project$Components$SyncedIcon$view(
					_List_fromArray(
						[
							$author$project$Components$SyncedIcon$master,
							$author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
						])) : $elm$html$Html$text(''),
					resource.Sa ? $author$project$Components$SyncedIcon$view(
					_List_fromArray(
						[
							$author$project$Components$SyncedIcon$synced,
							$author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
						])) : $elm$html$Html$text('')
				]))
		]);
};
var $author$project$Components$ResourceFilter$Location$toValue = function ($) {
	return $.adR;
};
var $author$project$Components$ResourceFilter$Location$init = F4(
	function (apiClient, locationGroupId, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: A2($author$project$Components$ResourceFilter$Location$fetchResources, locationGroupId, listOptionals),
				adR: $author$project$Components$ResourceFilter$Location$selectId,
				gx: 'Location',
				st: A2($author$project$Components$ResourceFilter$Location$retrieveResource, locationGroupId, listOptionals),
				ahw: $author$project$Components$ResourceFilter$Location$toLabel,
				ahA: $author$project$Components$ResourceFilter$Location$toTitle,
				g0: $author$project$Components$ResourceFilter$Location$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$Documents$Form$initPlanResourceFilter = F3(
	function (apiClient, session, planType) {
		var planTypes = (!planType) ? _List_fromArray(
			[0, 1]) : _List_fromArray(
			[2, 3]);
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{AS: planTypes});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Plan'});
			});
	});
var $author$project$Api$Provider$Document$One$Document = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Document$Shared$Document = $elm$core$Basics$identity;
var $author$project$Api$Provider$Document$Shared$Record = function (id) {
	return function (documentType) {
		return function (name) {
			return function (active) {
				return function (showOnSignup) {
					return function (required) {
						return function (documentAgreementsCount) {
							return function (acceptanceText) {
								return function (acceptanceType) {
									return function (status) {
										return {HX: acceptanceText, HY: acceptanceType, Ic: active, NX: documentAgreementsCount, NZ: documentType, adR: id, zh: name, agk: required, ZW: showOnSignup, ag7: status};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Document$AcceptanceType$ClickBox = 0;
var $author$project$Api$Provider$Document$AcceptanceType$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'click_box':
				return $elm$json$Json$Decode$succeed(0);
			case 'type_name':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported document -> acceptance type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Document$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'acceptance_type',
		$author$project$Api$Provider$Document$AcceptanceType$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'acceptance_text',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'document_agreements_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'required',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'show_on_signup',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'active',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'document_type',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$Shared$Record)))))))))));
var $author$project$Api$Provider$Document$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Document$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Document$One$Record = F3(
	function (currentDocumentVersion, documentScopes, translations) {
		return {aci: currentDocumentVersion, NY: documentScopes, aaa: translations};
	});
var $author$project$Api$Provider$DocumentVersion$Shared$DocumentVersion = $elm$core$Basics$identity;
var $author$project$Api$Provider$DocumentVersion$Shared$Record = F5(
	function (id, documentVersionType, content, linkUrl, createdAt) {
		return {EG: content, Mf: createdAt, xh: documentVersionType, adR: id, SW: linkUrl};
	});
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$Link = 0;
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$Text = 2;
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'file':
				return $elm$json$Json$Decode$succeed(1);
			case 'text':
				return $elm$json$Json$Decode$succeed(2);
			case 'link':
				return $elm$json$Json$Decode$succeed(0);
			default:
				return $elm$json$Json$Decode$fail('Unsupported document version -> document version type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$DocumentVersion$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'link_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'content',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'document_version_type',
				$author$project$Api$Provider$DocumentVersion$DocumentVersionType$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$DocumentVersion$Shared$Record))))));
var $author$project$Api$Provider$DocumentVersion$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DocumentVersion$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Translation$All$Record = F4(
	function (id, content, field, language) {
		return {EG: content, Pk: field, adR: id, yu: language};
	});
var $author$project$Api$Provider$Translation$All$Translation = $elm$core$Basics$identity;
var $author$project$Api$Provider$Translation$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'language',
		$author$project$Language$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'field',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'content',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Translation$All$Record))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DocumentScope$Shared$DocumentScope = $elm$core$Basics$identity;
var $author$project$Api$Provider$DocumentScope$Shared$Record = F3(
	function (scopeIdent, scopeName, scopeType) {
		return {Y8: scopeIdent, Y9: scopeName, Za: scopeType};
	});
var $author$project$Api$Provider$DocumentScope$Shared$Location = 1;
var $author$project$Api$Provider$DocumentScope$Shared$Plan = 0;
var $author$project$Api$Provider$DocumentScope$Shared$scopeTypeDecoder = function (string) {
	switch (string) {
		case 'Plan':
			return $elm$json$Json$Decode$succeed(0);
		case 'Location':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail('Unsupported document scope -> scope type: ' + string);
	}
};
var $author$project$Api$Provider$DocumentScope$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'scope_type',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$DocumentScope$Shared$scopeTypeDecoder, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'scope_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'scope_ident',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$DocumentScope$Shared$Record))));
var $author$project$Api$Provider$DocumentScope$Shared$sharedDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DocumentScope$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Document$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'translations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Translation$All$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'document_scopes',
		$elm$json$Json$Decode$list($author$project$Api$Provider$DocumentScope$Shared$sharedDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current_document_version',
			$author$project$Api$Provider$DocumentVersion$Shared$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$One$Record))));
var $author$project$Api$Provider$Document$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Document$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Document$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$One$Document)));
var $author$project$Api$Provider$Document$documentsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['documents']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Document$documentPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Document$documentsPath);
};
var $author$project$Api$Provider$Document$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Document$documentPath(id_)));
	});
var $author$project$Components$Admin$Documents$Form$init = F5(
	function (apiClient, session, id, practice, _v0) {
		var isOnboarding = _v0.aJ;
		var multiLanguage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice);
		var _v1 = A3($author$project$Components$Admin$Documents$Form$initPlanResourceFilter, apiClient, session, 2);
		var planResourceFilter = _v1.a;
		var planResourceFilterCmd = _v1.b;
		var _v2 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Location'});
			});
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$Document$retrieve, apiClient, id_, $author$project$Components$Admin$Documents$Form$GotItem));
			} else {
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					$author$project$Components$Admin$Documents$Form$formFieldsInit(practice));
			}
		}();
		var formFields = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{
				wX: $elm$core$Maybe$Nothing,
				lT: multiLanguage ? $elm$core$Maybe$Just(
					$author$project$Ui$NewDropdown$init(
						$author$project$Ui$NewDropdown$defaultConfig(
							{adR: 'document-content-language-dropdown', ahx: $author$project$Components$Admin$Documents$Form$LanguageDropdownMsg}))) : $elm$core$Maybe$Nothing,
				fx: $author$project$Language$english,
				PB: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
				adR: id,
				Rx: false,
				aJ: isOnboarding,
				rl: locationResourceFilter,
				jw: planResourceFilter,
				WF: practice,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				ag7: 'published',
				g3: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Pages$Admin$Documents$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var params = _v1.Vx;
		var _v2 = A5(
			$author$project$Components$Admin$Documents$Form$init,
			apiClient,
			session,
			$elm$core$Maybe$Just(params.adR),
			practice,
			{aJ: false});
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$Documents$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Documents$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$Documents$Form$Content = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Admin$Documents$Form$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Documents$Form$Ignore = {$: 0};
var $author$project$Components$Admin$Documents$Form$TranslationsInputMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Admin$Documents$Form$documentContentEditorId = 'document-content-editor';
var $author$project$Components$TranslationsInput$ModalClosed = {$: 0};
var $author$project$Components$TranslationsInput$subscriptions = function (_v0) {
	var open = _v0.U9;
	var languageDropdown = _v0.mP;
	return open ? (languageDropdown.U9 ? $author$project$Ui$NewDropdown$subscriptions(languageDropdown) : $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$TranslationsInput$ModalClosed)) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Documents$Form$subscriptions = function (_v0) {
	var translationInput = _v0.g3;
	var documentTranslationLanguage = _v0.fx;
	var documentTranslationDropdown = _v0.lT;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$TranslationsInput$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$Admin$Documents$Form$TranslationsInputMsg)),
					translationInput)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2($elm$core$Maybe$map, $author$project$Ui$NewDropdown$subscriptions, documentTranslationDropdown)),
				$author$project$Ports$CKEditor$onChange(
				F2(
					function (elementId, value) {
						return _Utils_eq(elementId, $author$project$Components$Admin$Documents$Form$documentContentEditorId) ? A2(
							$elm$core$Basics$composeL,
							$author$project$Components$Admin$Documents$Form$FormUpdated,
							$author$project$Components$Admin$Documents$Form$Content(documentTranslationLanguage))(value) : $author$project$Components$Admin$Documents$Form$Ignore;
					}))
			]));
};
var $author$project$Pages$Admin$Documents$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$Documents$Form$subscriptions(model.PB));
};
var $author$project$Components$Admin$Documents$Form$Archived = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$Documents$Form$DocumentScopeAdd = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$Documents$Form$DocumentVersionType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Documents$Form$File = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$Documents$Form$GotSignedFileUrl = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$Documents$Form$Save = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Documents$Form$Unarchived = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$Document$documentArchivePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['archive']),
		$author$project$Api$Provider$Document$documentPath(id_));
};
var $author$project$Api$Provider$Document$archive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Document$documentArchivePath(id_)));
	});
var $author$project$Components$Admin$Documents$Form$contentByLanguage = F2(
	function (language, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var content = _v0.EG;
		var translations = _v0.aaa;
		return _Utils_eq(language, $author$project$Language$english) ? content : A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.EG;
			},
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (t) {
					return _Utils_eq(t.yu, language) && (t.Pk === 'content');
				},
				translations));
	});
var $author$project$Api$Provider$Document$One$currentDocumentVersion = function (_v0) {
	var record = _v0.b;
	return record.aci;
};
var $author$project$Components$TranslationsInput$Document = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$TranslationsInput$document = $author$project$Components$TranslationsInput$Document;
var $author$project$Api$Provider$Document$Shared$acceptanceText = function (_v0) {
	var record = _v0;
	return record.HX;
};
var $author$project$Api$Provider$Document$One$acceptanceText = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$acceptanceText(shared);
};
var $author$project$Api$Provider$Document$Shared$acceptanceType = function (_v0) {
	var record = _v0;
	return record.HY;
};
var $author$project$Api$Provider$Document$One$acceptanceType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$acceptanceType(shared);
};
var $author$project$Api$Provider$Document$Shared$active = function (_v0) {
	var record = _v0;
	return record.Ic;
};
var $author$project$Api$Provider$Document$One$active = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$active(shared);
};
var $author$project$Api$Provider$DocumentVersion$Shared$content = function (_v0) {
	var record = _v0;
	return record.EG;
};
var $author$project$Api$Provider$Translation$All$content = function (_v0) {
	var translation = _v0;
	return translation.EG;
};
var $author$project$Api$Provider$Document$One$documentScopes = function (_v0) {
	var record = _v0.b;
	return record.NY;
};
var $author$project$Api$Provider$Document$Shared$documentType = function (_v0) {
	var record = _v0;
	return record.NZ;
};
var $author$project$Api$Provider$Document$One$documentType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$documentType(shared);
};
var $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType = function (_v0) {
	var record = _v0;
	return record.xh;
};
var $author$project$Api$Provider$Translation$All$field = function (_v0) {
	var translation = _v0;
	return translation.Pk;
};
var $author$project$Api$Provider$Translation$All$language = function (_v0) {
	var translation = _v0;
	return translation.yu;
};
var $author$project$Api$Provider$DocumentVersion$Shared$linkUrl = function (_v0) {
	var record = _v0;
	return record.SW;
};
var $author$project$Api$Provider$Document$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Document$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$name(shared);
};
var $author$project$Api$Provider$Document$Shared$required = function (_v0) {
	var record = _v0;
	return record.agk;
};
var $author$project$Api$Provider$Document$One$required = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$required(shared);
};
var $author$project$Api$Provider$DocumentScope$Shared$scopeIdent = function (_v0) {
	var record = _v0;
	return record.Y8;
};
var $author$project$Api$Provider$DocumentScope$Shared$scopeName = function (_v0) {
	var record = _v0;
	return record.Y9;
};
var $author$project$Api$Provider$DocumentScope$Shared$scopeType = function (_v0) {
	var record = _v0;
	return record.Za;
};
var $author$project$Api$Provider$Document$Shared$showOnSignup = function (_v0) {
	var record = _v0;
	return record.ZW;
};
var $author$project$Api$Provider$Document$One$showOnSignup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$showOnSignup(shared);
};
var $author$project$Api$Provider$Document$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Document$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$status(shared);
};
var $author$project$Api$Provider$Document$One$translations = function (_v0) {
	var record = _v0.b;
	return record.aaa;
};
var $author$project$Components$Admin$Documents$Form$formFieldsFromItem = function (document) {
	var documentScopes = A2(
		$elm$core$List$map,
		function (documentScope) {
			return {
				Y8: $author$project$Api$Provider$DocumentScope$Shared$scopeIdent(documentScope),
				Y9: $author$project$Api$Provider$DocumentScope$Shared$scopeName(documentScope),
				Za: $author$project$Api$Provider$DocumentScope$Shared$scopeType(documentScope)
			};
		},
		$author$project$Api$Provider$Document$One$documentScopes(document));
	var currentDocumentVersion = $author$project$Api$Provider$Document$One$currentDocumentVersion(document);
	var documentVersionType = $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType(currentDocumentVersion);
	var content = $author$project$Api$Provider$DocumentVersion$Shared$content(currentDocumentVersion);
	var cmd = (documentVersionType === 2) ? A3(
		$author$project$Ports$CKEditor$replace,
		$author$project$Components$Admin$Documents$Form$documentContentEditorId,
		A2($elm$core$Maybe$withDefault, '', content),
		_List_Nil) : $elm$core$Platform$Cmd$none;
	return _Utils_Tuple2(
		{
			HX: $author$project$Api$Provider$Document$One$acceptanceText(document),
			HY: $author$project$Api$Provider$Document$One$acceptanceType(document),
			Ic: $author$project$Api$Provider$Document$One$active(document),
			EG: content,
			dY: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$DocumentScope$Shared$scopeType,
				$elm$core$List$head(
					$author$project$Api$Provider$Document$One$documentScopes(document))),
			NY: documentScopes,
			NZ: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Document$One$documentType(document)),
			xh: documentVersionType,
			qG: 0,
			Po: $elm$core$Maybe$Nothing,
			qM: documentVersionType === 1,
			SW: $author$project$Api$Provider$DocumentVersion$Shared$linkUrl(currentDocumentVersion),
			zh: $author$project$Api$Provider$Document$One$name(document),
			Wp: 2,
			agk: $author$project$Api$Provider$Document$One$required(document),
			ZW: $author$project$Api$Provider$Document$One$showOnSignup(document),
			ag7: $author$project$Api$Provider$Document$One$status(document),
			aaa: A2(
				$elm$core$List$map,
				function (t) {
					return {
						EG: $author$project$Api$Provider$Translation$All$content(t),
						Pk: $author$project$Api$Provider$Translation$All$field(t),
						yu: $author$project$Api$Provider$Translation$All$language(t)
					};
				},
				$author$project$Api$Provider$Document$One$translations(document))
		},
		cmd);
};
var $author$project$Components$Admin$Documents$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						NZ: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 2:
				var documentVersionType = field.a;
				return _Utils_update(
					fields,
					{xh: documentVersionType});
			case 3:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						qG: _int,
						Po: $elm$core$Maybe$Just(string),
						qM: true
					});
			case 4:
				var language = field.a;
				var string = field.b;
				if (_Utils_eq(language, $author$project$Language$english)) {
					return _Utils_update(
						fields,
						{
							EG: $author$project$Utils$String$toMaybe(string)
						});
				} else {
					var translations = A2(
						$elm$core$List$cons,
						{EG: string, Pk: 'content', yu: language},
						A2(
							$elm$core$List$filter,
							function (t) {
								return !(_Utils_eq(t.yu, language) && (t.Pk === 'content'));
							},
							fields.aaa));
					return _Utils_update(
						fields,
						{aaa: translations});
				}
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						SW: $author$project$Utils$String$toMaybe(string)
					});
			case 6:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ic: bool});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ZW: bool});
			case 8:
				var documentScopeType = field.a;
				return _Utils_update(
					fields,
					{dY: documentScopeType, NY: _List_Nil});
			case 9:
				var planType = field.a;
				return _Utils_update(
					fields,
					{Wp: planType});
			case 10:
				var scopeType = field.a;
				var id = field.b;
				var name = field.c;
				var documentScope = A2(
					$elm_community$list_extra$List$Extra$find,
					function (documentScope_) {
						return _Utils_eq(documentScope_.Za, scopeType) && _Utils_eq(documentScope_.Y8, id);
					},
					fields.NY);
				var documentScopes = function () {
					if (!documentScope.$) {
						return fields.NY;
					} else {
						return A2(
							$elm$core$List$cons,
							{Y8: id, Y9: name, Za: scopeType},
							fields.NY);
					}
				}();
				return _Utils_update(
					fields,
					{NY: documentScopes});
			case 11:
				var scopeType = field.a;
				var id = field.b;
				var documentScopes = A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (documentScope) {
						return _Utils_eq(documentScope.Za, scopeType) && _Utils_eq(documentScope.Y8, id);
					},
					fields.NY);
				return _Utils_update(
					fields,
					{NY: documentScopes});
			case 12:
				var bool = field.a;
				return _Utils_update(
					fields,
					{agk: bool, ZW: bool || fields.ZW});
			case 13:
				var string = field.a;
				return _Utils_update(
					fields,
					{HY: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{HX: string});
		}
	});
var $author$project$Components$Admin$Documents$Form$DocumentTypeValidation = 0;
var $author$project$Components$Admin$Documents$Form$NameValidation = 1;
var $author$project$Components$Admin$Documents$Form$ContentValidation = 4;
var $author$project$Components$Admin$Documents$Form$validateContent = function (fields) {
	var invalid = _Utils_Tuple2(4, 'Please enter some text');
	var _v0 = _Utils_Tuple2(fields.xh, fields.EG);
	if (_v0.a === 2) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var content = _v0.b.a;
			return $elm$core$String$isEmpty(content) ? _List_fromArray(
				[invalid]) : _List_Nil;
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return _List_fromArray(
				[invalid]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$Documents$Form$DocumentScopesValidation = 5;
var $author$project$Components$Admin$Documents$Form$validateDocumentScopes = function (fields) {
	var invalid = function (scopeName) {
		return _Utils_Tuple2(5, 'Please specify at least one ' + (scopeName + '.'));
	};
	var _v0 = _Utils_Tuple2(
		fields.dY,
		$elm$core$List$isEmpty(fields.NY));
	_v0$2:
	while (true) {
		if (!_v0.a.$) {
			if (!_v0.a.a) {
				if (_v0.b) {
					var _v1 = _v0.a.a;
					return _List_fromArray(
						[
							invalid('plan')
						]);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b) {
					var _v2 = _v0.a.a;
					return _List_fromArray(
						[
							invalid('location')
						]);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return _List_Nil;
};
var $author$project$Components$Admin$Documents$Form$FileValidation = 3;
var $author$project$Components$Admin$Documents$Form$maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Admin$Documents$Form$validateFile = function (fields) {
	var _v0 = _Utils_Tuple2(fields.xh, fields.qM);
	if (_v0.a === 1) {
		if (_v0.b) {
			var _v1 = _v0.a;
			return (_Utils_cmp(fields.qG, $author$project$Components$Admin$Documents$Form$maxFileBytesSize) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(3, 'That file is too large! Our maximum file size is 5 mb.')
				]) : _List_Nil;
		} else {
			var _v2 = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(3, 'Please upload a file')
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$Documents$Form$UrlValidation = 2;
var $author$project$Components$Admin$Documents$Form$validateUrl = function (fields) {
	var invalid = _Utils_Tuple2(2, 'URL must start with https://');
	var _v0 = _Utils_Tuple2(fields.xh, fields.SW);
	if (!_v0.a) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var linkUrl = _v0.b.a;
			return A2($elm$core$String$startsWith, 'https://', linkUrl) ? _List_Nil : _List_fromArray(
				[invalid]);
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return _List_fromArray(
				[invalid]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$Documents$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.NZ;
			},
			_Utils_Tuple2(0, 'Please pick a document type.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(1, 'Please enter a name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateUrl),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateFile),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateContent),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateDocumentScopes)
		]));
var $author$project$Api$Provider$Document$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Document$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$id(shared);
};
var $author$project$Api$Provider$DocumentVersion$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$TranslationsInput$LanguageDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$TranslationsInput$init = function (translatable_) {
	var availableLanguages = _List_fromArray(
		[$author$project$Language$spanish]);
	return {
		vB: availableLanguages,
		PB: $elm$core$Maybe$Nothing,
		yu: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Language$spanish,
			$elm$core$List$head(availableLanguages)),
		mP: $author$project$Ui$NewDropdown$init(
			$author$project$Ui$NewDropdown$defaultConfig(
				{adR: 'translations-language-dropdown', ahx: $author$project$Components$TranslationsInput$LanguageDropdownMsg})),
		U9: false,
		g2: translatable_,
		aaa: $author$project$Api$Data$NotAsked
	};
};
var $author$project$Components$Admin$Documents$Form$isDocumentArchived = function (status) {
	return status === 'archived';
};
var $author$project$Components$Admin$Documents$Form$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$Documents$Form$ResetAndAddAnother = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$Documents$Form$apiFields = function (fields) {
	return {
		HX: fields.HX,
		HY: fields.HY,
		Ic: fields.Ic,
		EG: fields.EG,
		NY: A2(
			$elm$core$List$map,
			function (documentScope) {
				return {Y8: documentScope.Y8, Za: documentScope.Za};
			},
			fields.NY),
		NZ: A2($elm$core$Maybe$withDefault, '', fields.NZ),
		xh: fields.xh,
		adn: fields.Po,
		zh: fields.zh,
		agk: fields.agk,
		ZW: fields.ZW,
		ag7: fields.ag7,
		aaa: fields.aaa,
		aav: fields.SW
	};
};
var $author$project$Api$Provider$Document$encodeTranslations = $elm$json$Json$Encode$list(
	function (t) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'field',
					$elm$json$Json$Encode$string(t.Pk)),
					_Utils_Tuple2(
					'content',
					$elm$json$Json$Encode$string(t.EG)),
					_Utils_Tuple2(
					'language',
					$elm$json$Json$Encode$string(
						$author$project$Language$toValue(t.yu)))
				]));
	});
var $author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString = function (scopeType_) {
	if (!scopeType_) {
		return 'Plan';
	} else {
		return 'Location';
	}
};
var $author$project$Api$Provider$Document$AcceptanceType$toString = function (acceptanceType_) {
	if (!acceptanceType_) {
		return 'click_box';
	} else {
		return 'type_name';
	}
};
var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString = function (documentVersionType_) {
	switch (documentVersionType_) {
		case 0:
			return 'link';
		case 1:
			return 'file';
		default:
			return 'text';
	}
};
var $author$project$Api$Provider$Document$create = F3(
	function (apiClient, fields, toMsg) {
		var documentVersion = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document_version_type',
					$elm$json$Json$Encode$string(
						$author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString(fields.xh))),
					function () {
					var _v1 = fields.xh;
					switch (_v1) {
						case 1:
							return _Utils_Tuple2(
								'file',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adn));
						case 0:
							return _Utils_Tuple2(
								'url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aav));
						default:
							return _Utils_Tuple2(
								'content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.EG));
					}
				}()
				]));
		var documentScopes_ = A2(
			$elm$json$Json$Encode$list,
			function (_v0) {
				var scopeType = _v0.Za;
				var scopeIdent = _v0.Y8;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'scope_type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString(scopeType))),
							_Utils_Tuple2(
							'scope_ident',
							$elm$json$Json$Encode$string(scopeIdent))
						]));
			},
			fields.NY);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'required',
								$elm$json$Json$Encode$bool(fields.agk)),
								_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(fields.Ic)),
								_Utils_Tuple2(
								'show_on_signup',
								$elm$json$Json$Encode$bool(fields.ZW)),
								_Utils_Tuple2(
								'acceptance_text',
								$elm$json$Json$Encode$string(fields.HX)),
								_Utils_Tuple2(
								'document_type',
								$elm$json$Json$Encode$string(fields.NZ)),
								_Utils_Tuple2(
								'acceptance_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Provider$Document$AcceptanceType$toString(fields.HY))),
								_Utils_Tuple2('document_scopes', documentScopes_),
								_Utils_Tuple2('document_version', documentVersion),
								_Utils_Tuple2(
								'status',
								$elm$json$Json$Encode$string(fields.ag7)),
								_Utils_Tuple2(
								'translations',
								$author$project$Api$Provider$Document$encodeTranslations(fields.aaa))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentsPath)));
	});
var $author$project$Components$Admin$Documents$Form$createItem = F3(
	function (apiClient, formFields, addAnother) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var createMsg = addAnother ? $author$project$Components$Admin$Documents$Form$ResetAndAddAnother : $author$project$Components$Admin$Documents$Form$Created;
		return A3(
			$author$project$Api$Provider$Document$create,
			apiClient,
			$author$project$Components$Admin$Documents$Form$apiFields(fields),
			createMsg);
	});
var $author$project$Components$Admin$Documents$Form$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Document$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var documentVersion = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document_version_type',
					$elm$json$Json$Encode$string(
						$author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString(fields.xh))),
					function () {
					var _v1 = fields.xh;
					switch (_v1) {
						case 1:
							return _Utils_Tuple2(
								'file',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adn));
						case 0:
							return _Utils_Tuple2(
								'url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aav));
						default:
							return _Utils_Tuple2(
								'content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.EG));
					}
				}()
				]));
		var documentScopes_ = A2(
			$elm$json$Json$Encode$list,
			function (_v0) {
				var scopeType = _v0.Za;
				var scopeIdent = _v0.Y8;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'scope_type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString(scopeType))),
							_Utils_Tuple2(
							'scope_ident',
							$elm$json$Json$Encode$string(scopeIdent))
						]));
			},
			fields.NY);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'required',
								$elm$json$Json$Encode$bool(fields.agk)),
								_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(fields.Ic)),
								_Utils_Tuple2(
								'show_on_signup',
								$elm$json$Json$Encode$bool(fields.ZW)),
								_Utils_Tuple2(
								'acceptance_text',
								$elm$json$Json$Encode$string(fields.HX)),
								_Utils_Tuple2(
								'document_type',
								$elm$json$Json$Encode$string(fields.NZ)),
								_Utils_Tuple2(
								'acceptance_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Provider$Document$AcceptanceType$toString(fields.HY))),
								_Utils_Tuple2('document_scopes', documentScopes_),
								_Utils_Tuple2('document_version', documentVersion),
								_Utils_Tuple2(
								'translations',
								$author$project$Api$Provider$Document$encodeTranslations(fields.aaa))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Document$documentPath(id_))));
	});
var $author$project$Components$Admin$Documents$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Document$update,
			apiClient,
			id,
			$author$project$Components$Admin$Documents$Form$apiFields(fields),
			$author$project$Components$Admin$Documents$Form$Updated);
	});
var $author$project$Components$Admin$Documents$Form$saveItem = F4(
	function (apiClient, maybeId, formFields, addAnother) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Admin$Documents$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A3($author$project$Components$Admin$Documents$Form$createItem, apiClient, formFields, addAnother);
		}
	});
var $author$project$Api$Provider$DocumentVersion$documentVersionsPath = function (documentId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['document_versions']),
		$author$project$Api$Provider$Document$documentPath(documentId));
};
var $author$project$Api$Provider$DocumentVersion$documentVersionPath = F2(
	function (documentId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$DocumentVersion$documentVersionsPath(documentId));
	});
var $author$project$Api$Provider$DocumentVersion$signedFileUrlDecoder = A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string);
var $author$project$Api$Provider$DocumentVersion$signedFileUrl = F4(
	function (apiClient, documentId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$DocumentVersion$signedFileUrlDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_file_url']),
					A2($author$project$Api$Provider$DocumentVersion$documentVersionPath, documentId, id_))));
	});
var $author$project$Components$Admin$Documents$Form$PracticeOnboardingUpdated = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Admin$Documents$Form$updatePracticeOnboarding = F3(
	function (apiClient, onboardId, accountStep) {
		return A4($author$project$Api$Provider$PracticeOnboarding$updateAccountStep, apiClient, accountStep, onboardId, $author$project$Components$Admin$Documents$Form$PracticeOnboardingUpdated);
	});
var $author$project$Components$Admin$Documents$Form$skipDocumentsSetup = F2(
	function (apiClient, practice) {
		var onboardId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$id,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
		return A3(
			$author$project$Components$Admin$Documents$Form$updatePracticeOnboarding,
			apiClient,
			onboardId,
			$author$project$Api$Provider$PracticeOnboarding$AccountStep$toString(3));
	});
var $author$project$Api$Provider$Document$documentUnarchivePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['unarchive']),
		$author$project$Api$Provider$Document$documentPath(id_));
};
var $author$project$Api$Provider$Document$unarchive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Document$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Document$documentUnarchivePath(id_)));
	});
var $author$project$Components$ResourceFilter$Location$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$TranslationsInput$Content = $elm$core$Basics$identity;
var $author$project$Components$TranslationsInput$TranslationCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$TranslationsInput$TranslationDeleted = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$TranslationsInput$TranslationUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$TranslationsInput$findTranslation = F3(
	function (lang, field, translations) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (t) {
					return _Utils_eq(
						$author$project$Api$Provider$Translation$All$language(t),
						lang) && _Utils_eq(
						$author$project$Api$Provider$Translation$All$field(t),
						field);
				},
				translations));
	});
var $author$project$Api$Provider$Translation$All$id = function (_v0) {
	var translation = _v0;
	return translation.adR;
};
var $author$project$Components$TranslationsInput$andInitForm = F4(
	function (field, defaultContent, translations, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var translation = A3($author$project$Components$TranslationsInput$findTranslation, model.yu, field, translations);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					PB: $elm$core$Maybe$Just(
						$author$project$Utils$Form$init(
							{
								EG: A2(
									$elm$core$Maybe$withDefault,
									defaultContent,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Translation$All$content, translation)),
								Pk: field,
								adR: A2($elm$core$Maybe$map, $author$project$Api$Provider$Translation$All$id, translation)
							})),
					U9: true
				}),
			cmd);
	});
var $author$project$Components$TranslationsInput$GotTranslations = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Api$Translation$listOptionsToParams = function (params) {
	return _List_fromArray(
		[
			A2($author$project$Api$Param$string, 'translatable_id', params.Dy),
			A2($author$project$Api$Param$string, 'translatable_type', params.Dz)
		]);
};
var $author$project$Api$Translation$translationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['translations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Translation$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Translation$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Translation$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Translation$translationsPath)));
	});
var $author$project$Components$TranslationsInput$translatableToId = function (translatable_) {
	switch (translatable_.$) {
		case 0:
			var id = translatable_.a;
			return id;
		case 1:
			var id = translatable_.a;
			return id;
		default:
			return '';
	}
};
var $author$project$Components$TranslationsInput$translatableToResource = function (translatable_) {
	switch (translatable_.$) {
		case 0:
			return 'lead_sources';
		case 1:
			return 'documents';
		default:
			return 'practices';
	}
};
var $author$project$Components$TranslationsInput$andOpenModal = F4(
	function (client, field, defaultContent, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = model.aaa;
		switch (_v1.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: true}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3(
								$author$project$Api$Translation$list,
								client,
								{
									Dy: $author$project$Components$TranslationsInput$translatableToId(model.g2),
									Dz: $author$project$Components$TranslationsInput$translatableToResource(model.g2)
								},
								A2($author$project$Components$TranslationsInput$GotTranslations, field, defaultContent))
							])));
			case 3:
				var translations = _v1.a;
				return A4(
					$author$project$Components$TranslationsInput$andInitForm,
					field,
					defaultContent,
					translations,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{U9: true}),
						cmd));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: true}),
					cmd);
		}
	});
var $author$project$Api$Translation$encodeCreateFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'translation',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'translatable_id',
							$elm$json$Json$Encode$string(fields.Dy)),
							_Utils_Tuple2(
							'translatable_type',
							$elm$json$Json$Encode$string(fields.Dz)),
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(fields.Pk)),
							_Utils_Tuple2(
							'content',
							$elm$json$Json$Encode$string(fields.EG)),
							_Utils_Tuple2(
							'language',
							$elm$json$Json$Encode$string(
								$author$project$Language$toValue(fields.yu)))
						])))
			]));
};
var $author$project$Api$Translation$create = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Translation$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Translation$encodeCreateFields(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Translation$translationsPath)));
	});
var $author$project$Api$Translation$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Provider$Translation$All$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id]),
					$author$project$Api$Translation$translationsPath)));
	});
var $author$project$Api$Translation$encodeUpdateFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'translation',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'field',
							$elm$json$Json$Encode$string(fields.Pk)),
							_Utils_Tuple2(
							'content',
							$elm$json$Json$Encode$string(fields.EG)),
							_Utils_Tuple2(
							'language',
							$elm$json$Json$Encode$string(
								$author$project$Language$toValue(fields.yu)))
						])))
			]));
};
var $author$project$Api$Translation$update = F4(
	function (apiClient, id, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Translation$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Translation$encodeUpdateFields(fields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[id]),
						$author$project$Api$Translation$translationsPath))));
	});
var $author$project$Components$TranslationsInput$updateFormFields = F2(
	function (field, form) {
		var content = field;
		return _Utils_update(
			form,
			{EG: content});
	});
var $author$project$Components$TranslationsInput$update = F3(
	function (client, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: false}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var field = msg.a;
				var defaultContent = msg.b;
				return A4(
					$author$project$Components$TranslationsInput$andOpenModal,
					client,
					field,
					defaultContent,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 2:
				var field = msg.a;
				var defaultContent = msg.b;
				var response = msg.c;
				return function (modelCmd) {
					if (response.$ === 3) {
						var translations = response.a;
						return A4($author$project$Components$TranslationsInput$andInitForm, field, defaultContent, translations, modelCmd);
					} else {
						return modelCmd;
					}
				}(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{aaa: response}),
						$elm$core$Platform$Cmd$none));
			case 7:
				var translationId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: false}),
					A3($author$project$Api$Translation$delete, client, translationId, $author$project$Components$TranslationsInput$TranslationDeleted));
			case 3:
				var content = msg.a;
				var _v2 = model.PB;
				if (!_v2.$) {
					var form = _v2.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									A3($author$project$Utils$Form$update, $author$project$Components$TranslationsInput$updateFormFields, content, form))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var translation = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							PB: $elm$core$Maybe$Nothing,
							U9: false,
							aaa: function () {
								if (translation.$ === 3) {
									var translation_ = translation.a;
									return A2(
										$author$project$Api$Data$map,
										function (translations) {
											return A2($elm$core$List$cons, translation_, translations);
										},
										model.aaa);
								} else {
									return model.aaa;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var translation = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							PB: $elm$core$Maybe$Nothing,
							U9: false,
							aaa: function () {
								if (translation.$ === 3) {
									var translation_ = translation.a;
									return A2(
										$author$project$Api$Data$map,
										function (translations) {
											return A2(
												$elm$core$List$map,
												function (t) {
													return _Utils_eq(
														$author$project$Api$Provider$Translation$All$id(t),
														$author$project$Api$Provider$Translation$All$id(translation_)) ? translation_ : t;
												},
												translations);
										},
										model.aaa);
								} else {
									return model.aaa;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var translation = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aaa: function () {
								if (translation.$ === 3) {
									var translation_ = translation.a;
									return A2(
										$author$project$Api$Data$map,
										function (translations) {
											return A2(
												$elm$core$List$filterMap,
												function (t) {
													return _Utils_eq(
														$author$project$Api$Provider$Translation$All$id(t),
														$author$project$Api$Provider$Translation$All$id(translation_)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(t);
												},
												translations);
										},
										model.aaa);
								} else {
									return model.aaa;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var _v6 = model.PB;
				if (!_v6.$) {
					var form = _v6.a;
					return A2(
						$elm$core$Tuple$pair,
						model,
						function (_v7) {
							var id = _v7.adR;
							var content = _v7.EG;
							var field = _v7.Pk;
							if (!id.$) {
								var id_ = id.a;
								var body = {EG: content, Pk: field, yu: model.yu};
								return A4($author$project$Api$Translation$update, client, id_, body, $author$project$Components$TranslationsInput$TranslationUpdated);
							} else {
								var body = {
									EG: content,
									Pk: field,
									yu: model.yu,
									Dy: $author$project$Components$TranslationsInput$translatableToId(model.g2),
									Dz: $author$project$Components$TranslationsInput$translatableToResource(model.g2)
								};
								return A3($author$project$Api$Translation$create, client, body, $author$project$Components$TranslationsInput$TranslationCreated);
							}
						}(
							$author$project$Utils$Form$fields(form)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var dropdownMsg = msg.a;
				var _v9 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.mP);
				var dropdown = _v9.a;
				var dropdownCmd = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mP: dropdown}),
					dropdownCmd);
			default:
				var language = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{PB: $elm$core$Maybe$Nothing, yu: language}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Admin$Documents$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var document = response.a;
					var translationInput = $author$project$Components$TranslationsInput$init(
						$author$project$Components$TranslationsInput$document(
							$author$project$Api$Provider$Document$One$id(document)));
					var status = $author$project$Api$Provider$Document$One$status(document);
					var currentDocumentVersion = $author$project$Api$Provider$Document$One$currentDocumentVersion(document);
					var _v3 = $author$project$Components$Admin$Documents$Form$formFieldsFromItem(document);
					var formFields = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								wX: $elm$core$Maybe$Just(
									$author$project$Api$Provider$DocumentVersion$Shared$id(currentDocumentVersion)),
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(formFields)),
								Rx: $author$project$Components$Admin$Documents$Form$isDocumentArchived(status),
								ag7: status,
								g3: $elm$core$Maybe$Just(translationInput)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var field = msg.a;
				var _v4 = model.PB;
				if (!_v4.$) {
					var form = _v4.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field, form);
					var cmd = function () {
						if (_Utils_eq(
							field,
							$author$project$Components$Admin$Documents$Form$DocumentVersionType(2))) {
							var content = A2($author$project$Components$Admin$Documents$Form$contentByLanguage, model.fx, newForm);
							return A3(
								$author$project$Ports$CKEditor$replace,
								$author$project$Components$Admin$Documents$Form$documentContentEditorId,
								A2($elm$core$Maybe$withDefault, '', content),
								_List_Nil);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v5 = function () {
						if (field.$ === 9) {
							var planType = field.a;
							return A3($author$project$Components$Admin$Documents$Form$initPlanResourceFilter, apiClient, model.ZD, planType);
						} else {
							return _Utils_Tuple2(model.jw, $elm$core$Platform$Cmd$none);
						}
					}();
					var planResourceFilter = _v5.a;
					var planResourceFilterCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								jw: planResourceFilter
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceFilterCmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v7) {
							var task = _v7.a;
							var size = _v7.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Admin$Documents$Form$FormUpdated,
									$author$project$Components$Admin$Documents$Form$File(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 4:
				var addAnother = msg.a;
				var _v8 = model.PB;
				if (!_v8.$) {
					var form = _v8.a;
					var _v9 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Documents$Form$formFieldsValidator, form);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var newForm = _v10.a;
						var validFormFields = _v10.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							A4($author$project$Components$Admin$Documents$Form$saveItem, apiClient, model.adR, validFormFields, addAnother),
							_List_Nil);
					} else {
						var newForm = _v9.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$always(
							$author$project$Components$Admin$Documents$Form$Save(true)),
						$elm$core$Task$succeed($elm$core$Basics$identity)),
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v11 = model.PB;
				if (!_v11.$) {
					if (response.$ === 3) {
						var document = response.a;
						return _Utils_Tuple3(
							model,
							model.aJ ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Document$One$name(document))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v13 = model.PB;
				if (!_v13.$) {
					if (response.$ === 3) {
						var document = response.a;
						var _v15 = A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							$author$project$Components$Admin$Documents$Form$formFieldsInit(model.WF));
						var formFields = _v15.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
									jY: response
								}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Document$One$name(document))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v16 = model.PB;
				if (!_v16.$) {
					if (response.$ === 3) {
						var document = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Document$One$name(document) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jw);
				var newForm = function () {
					var _v18 = planResourceResult.ac5;
					if (((!_v18.$) && (!_v18.a.$)) && (!_v18.a.a.$)) {
						var plan = _v18.a.a.a;
						var field = A3(
							$author$project$Components$Admin$Documents$Form$DocumentScopeAdd,
							0,
							$author$project$Api$Plan$id(plan),
							$author$project$Api$Plan$name(plan));
						return A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm, jw: planResourceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceResult.EC),
					planResourceResult.as);
			case 10:
				var subMsg = msg.a;
				var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.rl);
				var newForm = function () {
					var _v19 = locationResourceResult.ac5;
					if (((!_v19.$) && (!_v19.a.$)) && (!_v19.a.a.$)) {
						var location = _v19.a.a.a;
						var field = A3($author$project$Components$Admin$Documents$Form$DocumentScopeAdd, 1, location.adR, location.zh);
						return A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm, rl: locationResourceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg, locationResourceResult.EC),
					locationResourceResult.as);
			case 11:
				var documentId = msg.a;
				var documentVersionId = msg.b;
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Provider$DocumentVersion$signedFileUrl, apiClient, documentId, documentVersionId, $author$project$Components$Admin$Documents$Form$GotSignedFileUrl),
					_List_Nil);
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var _v21 = model.adR;
				if (!_v21.$) {
					var id_ = _v21.a;
					return _Utils_Tuple3(
						model,
						A3($author$project$Api$Provider$Document$archive, apiClient, id_, $author$project$Components$Admin$Documents$Form$Archived),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var response = msg.a;
				var _v22 = model.PB;
				if (!_v22.$) {
					if (response.$ === 3) {
						var document = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Document$One$name(document) + ' was successfully archived.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var _v24 = model.adR;
				if (!_v24.$) {
					var id_ = _v24.a;
					return _Utils_Tuple3(
						model,
						A3($author$project$Api$Provider$Document$unarchive, apiClient, id_, $author$project$Components$Admin$Documents$Form$Unarchived),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var response = msg.a;
				var _v25 = model.PB;
				if (!_v25.$) {
					if (response.$ === 3) {
						var document = response.a;
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Document$One$name(document) + ' was successfully unarchived.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 17:
				return _Utils_Tuple3(
					model,
					A2($author$project$Components$Admin$Documents$Form$skipDocumentsSetup, apiClient, model.WF),
					_List_Nil);
			case 18:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var msg_ = msg.a;
				var _v28 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.g3, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$Maybe$Just),
						A2(
							$elm$core$Maybe$map,
							A2($author$project$Components$TranslationsInput$update, apiClient, msg_),
							model.g3)));
				var translationInput = _v28.a;
				var translationsCmd = _v28.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g3: translationInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$TranslationsInputMsg, translationsCmd),
					_List_Nil);
			case 20:
				var dropdownMsg = msg.a;
				var _v29 = model.lT;
				if (!_v29.$) {
					var dropdown = _v29.a;
					var _v30 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, dropdown);
					var newDropdown = _v30.a;
					var dropdownCmd = _v30.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lT: $elm$core$Maybe$Just(newDropdown)
							}),
						dropdownCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var lang = msg.a;
				var _v31 = model.PB;
				if (!_v31.$) {
					var form = _v31.a;
					var fields = $author$project$Utils$Form$fields(form);
					var ckEditorCmd = function () {
						if (fields.xh === 2) {
							var content = A2($author$project$Components$Admin$Documents$Form$contentByLanguage, lang, form);
							return A2(
								$author$project$Ports$CKEditor$setData,
								$author$project$Components$Admin$Documents$Form$documentContentEditorId,
								A2($elm$core$Maybe$withDefault, '', content));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fx: lang}),
						ckEditorCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fx: lang}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Documents$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Admin$Documents$Form$Archive = {$: 13};
var $author$project$Ui$Button$warning = $author$project$Ui$Button$Styled(4);
var $author$project$Components$Admin$Documents$Form$viewArchiveButton = function (model) {
	var _v0 = model.ag7;
	if (_v0 === 'unpublished') {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Archive document'},
			_List_fromArray(
				[
					$author$project$Ui$Button$warning,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$Archive)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Archive')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$Documents$Form$AcceptanceText = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$Documents$Form$Active = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$Documents$Form$DocumentType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Documents$Form$FileUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Documents$Form$LanguageSelected = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Admin$Documents$Form$LinkUrl = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Documents$Form$Name = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Documents$Form$OpenFileDocument = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Admin$Documents$Form$Required = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$Documents$Form$ShowOnSignup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$TranslationsInput$DefaultContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TranslationsInput$default = $author$project$Components$TranslationsInput$DefaultContent;
var $author$project$Components$Admin$Documents$Form$documentTypes = _List_fromArray(
	['Contract', 'Agreement', 'Terms and Conditions']);
var $author$project$Components$Admin$Documents$Form$documentTypeOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Select a Document Type'),
	A2(
		$elm$core$List$map,
		function (documentType) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(documentType),
				documentType);
		},
		$author$project$Components$Admin$Documents$Form$documentTypes));
var $author$project$Ui$Element$FlexAuto = {$: 12};
var $author$project$Ui$Element$flexAuto = $author$project$Ui$Element$FlexAuto;
var $author$project$Ui$Well$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Well$small = $author$project$Ui$Well$Size(1);
var $author$project$Components$ResourceFilter$Location$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$TranslationsInput$ModalOpened = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$TranslationsInput$String = 0;
var $author$project$Components$TranslationsInput$defaultOptions = {wM: 0, w6: ''};
var $author$project$Components$TranslationsInput$ContentChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$TranslationsInput$RemovedTranslation = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$TranslationsInput$TranslationSubmitted = {$: 4};
var $author$project$Components$TranslationsInput$LanguageSelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$TranslationsInput$viewLanguageSelect = function (_v0) {
	var languageDropdown = _v0.mP;
	var language = _v0.yu;
	var availableLanguages = _v0.vB;
	var languageToItem = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(lang, language)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$TranslationsInput$LanguageSelected(lang))
				]),
			$elm$html$Html$text(
				$author$project$Language$toLabel(lang)));
	};
	var items = A2($elm$core$List$map, languageToItem, availableLanguages);
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Language$toLabel(language))
			]),
		items,
		languageDropdown);
};
var $author$project$Components$TranslationsInput$viewForm = F3(
	function (optionsRecord, form, model) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$TranslationsInput$TranslationSubmitted)
				]),
			_List_fromArray(
				[
					($elm$core$List$length(model.vB) > 1) ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Now Editing')
						]),
					_List_fromArray(
						[
							$author$project$Components$TranslationsInput$viewLanguageSelect(model)
						])) : $elm$html$Html$text(''),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = optionsRecord.wM;
							if (!_v0) {
								return $author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.EG),
											$author$project$Ui$Form$Input$onInput($author$project$Components$TranslationsInput$ContentChanged)
										]));
							} else {
								return $author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$value(fields.EG),
											$author$project$Ui$Form$Textarea$onInput($author$project$Components$TranslationsInput$ContentChanged)
										]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Cancel and close modal'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$TranslationsInput$ModalClosed)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v1 = fields.adR;
											if (!_v1.$) {
												var translationId = _v1.a;
												return A3(
													$author$project$Ui$Button$view,
													{abp: 'Remove translation'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$onClick(
															$author$project$Components$TranslationsInput$RemovedTranslation(translationId))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Remove')
														]));
											} else {
												return $elm$html$Html$text('');
											}
										}(),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Save translation'},
											_List_fromArray(
												[$author$project$Ui$Button$submit, $author$project$Ui$Button$primary]),
											_List_fromArray(
												[
													$elm$html$Html$text('Save')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$TranslationsInput$viewModal = F2(
	function (optionsRecord, model) {
		return model.U9 ? A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$TranslationsInput$ModalClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(
							'Edit ' + ($author$project$Language$toLabel(model.yu) + ' Translation'))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							var _v0 = model.PB;
							if (!_v0.$) {
								var form_ = _v0.a;
								return A3($author$project$Components$TranslationsInput$viewForm, optionsRecord, form_, model);
							} else {
								return $elm$html$Html$text('');
							}
						}()
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Components$TranslationsInput$view = F3(
	function (field, options, model) {
		var optionsRecord = A3(
			$elm$core$List$foldl,
			F2(
				function (option, acc) {
					if (!option.$) {
						var defaultContent = option.a;
						return _Utils_update(
							acc,
							{w6: defaultContent});
					} else {
						var contentType = option.a;
						return _Utils_update(
							acc,
							{wM: contentType});
					}
				}),
			$author$project$Components$TranslationsInput$defaultOptions,
			options);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$inlineBlock]),
			_List_fromArray(
				[
					A2($author$project$Components$TranslationsInput$viewModal, optionsRecord, model),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Edit translation'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							A2($author$project$Components$TranslationsInput$ModalOpened, field, optionsRecord.w6)),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$translate)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Edit Translation')
						]))
				]));
	});
var $author$project$Components$Admin$Documents$Form$AcceptanceType = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton = F4(
	function (currentAcceptanceType, acceptanceType, label, isDisabled) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentAcceptanceType, acceptanceType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$Documents$Form$FormUpdated(
						$author$project$Components$Admin$Documents$Form$AcceptanceType(acceptanceType))),
					$author$project$Ui$Button$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$Documents$Form$DocumentScopeRemove = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Admin$Documents$Form$viewDocumentScope = function (documentScope) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(documentScope.Y9),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Remove ' + documentScope.Y9},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$size(0),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$Documents$Form$FormUpdated(
							A2($author$project$Components$Admin$Documents$Form$DocumentScopeRemove, documentScope.Za, documentScope.Y8))),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$Documents$Form$DocumentScopeType = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton = F4(
	function (currentDocumentScopeType, documentScopeType, label, isDisabled) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentDocumentScopeType, documentScopeType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$Documents$Form$FormUpdated(
						$author$project$Components$Admin$Documents$Form$DocumentScopeType(documentScopeType))),
					$author$project$Ui$Button$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton = F4(
	function (currentDocumentVersionType, documentVersionType, label, isDisabled) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentDocumentVersionType, documentVersionType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$Documents$Form$FormUpdated(
						$author$project$Components$Admin$Documents$Form$DocumentVersionType(documentVersionType))),
					$author$project$Ui$Button$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$Documents$Form$PlanType = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$Documents$Form$viewPlanTypeButton = F4(
	function (currentPlanType, planType, label, isDisabled) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentPlanType, planType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$Documents$Form$FormUpdated(
						$author$project$Components$Admin$Documents$Form$PlanType(planType))),
					$author$project$Ui$Button$disabled(isDisabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$Documents$Form$viewForm = F2(
	function (model, form) {
		var isFormDisabled = model.Rx;
		var fields = $author$project$Utils$Form$fields(form);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$label('Document')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(4)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(fields.NZ),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$DocumentType)),
														$author$project$Ui$Form$Select$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
														$author$project$Ui$Form$Select$errors(
														A2($author$project$Utils$Form$validationErrors, 0, form)),
														$author$project$Ui$Form$Select$disabled(isFormDisabled)
													]),
												$author$project$Components$Admin$Documents$Form$documentTypeOptions)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(fields.zh),
														$author$project$Ui$Form$Input$placeholder('Name of Document, e.g. \"Member Contract\"'),
														$author$project$Ui$Form$Input$autofocus(true),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Name)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 1, form)),
														$author$project$Ui$Form$Input$disabled(isFormDisabled)
													]))
											]))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Choose the type of document and how it will be shown throughout the application, e.g. \" Member contract \".')
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$label('Upload Document')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(9)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Button$group(
												_List_fromArray(
													[
														A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.xh, 1, 'Upload a PDF document', isFormDisabled),
														A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.xh, 2, 'Copy & paste text', isFormDisabled),
														A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.xh, 0, 'Link to a document', isFormDisabled)
													]))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(3)
											]),
										_List_fromArray(
											[
												function () {
												var _v0 = _Utils_Tuple2(model.lT, fields.xh === 2);
												if ((!_v0.a.$) && _v0.b) {
													var dropdown = _v0.a.a;
													var languageToItem = function (lang) {
														return A2(
															$author$project$Ui$NewDropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$NewDropdown$selected(
																	_Utils_eq(lang, model.fx)),
																	$author$project$Ui$NewDropdown$onSelect(
																	$author$project$Components$Admin$Documents$Form$LanguageSelected(lang))
																]),
															$elm$html$Html$text(
																$author$project$Language$toLabel(lang)));
													};
													var items = A2(
														$elm$core$List$map,
														languageToItem,
														_List_fromArray(
															[$author$project$Language$english, $author$project$Language$spanish]));
													return A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$flexMd, $author$project$Ui$Element$flexAuto]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$mr2]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$label,
																		_List_fromArray(
																			[$author$project$Ui$Typography$hintLabel]),
																		_List_fromArray(
																			[
																				$author$project$Ui$SvgIcon$translate(_List_Nil),
																				$author$project$Utils$Html$noBreakSpace,
																				$elm$html$Html$text('Now editing')
																			]))
																	])),
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$flexAuto]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$Ui$NewDropdown$viewSelect,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Language$toLabel(model.fx))
																			]),
																		items,
																		dropdown)
																	]))
															]));
												} else {
													return $elm$html$Html$text('');
												}
											}()
											]))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('')
							]),
						_List_fromArray(
							[
								function () {
								var _v1 = fields.xh;
								switch (_v1) {
									case 1:
										return A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(6)
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$File$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$File$accept(2),
																	$author$project$Ui$Form$File$onInput($author$project$Components$Admin$Documents$Form$FileUploaded),
																	$author$project$Ui$Form$File$disabled(isFormDisabled)
																])),
															$author$project$Utils$FormErrors$view(
															A2($author$project$Utils$Form$validationErrors, 3, form))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(6)
														]),
													_List_fromArray(
														[
															function () {
															var _v2 = _Utils_Tuple3(model.adR, model.wX, fields.Po);
															if (((!_v2.a.$) && (!_v2.b.$)) && (_v2.c.$ === 1)) {
																var id = _v2.a.a;
																var currentDocumentVersionId = _v2.b.a;
																var _v3 = _v2.c;
																return A3(
																	$author$project$Ui$Button$view,
																	{abp: 'View file'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$link,
																			$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																			$author$project$Ui$Button$onClick(
																			A2($author$project$Components$Admin$Documents$Form$OpenFileDocument, id, currentDocumentVersionId))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('View file')
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}()
														]))
												]));
									case 2:
										return A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(12)
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Textarea$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Textarea$id($author$project$Components$Admin$Documents$Form$documentContentEditorId),
																	$author$project$Ui$Form$Textarea$disabled(isFormDisabled)
																])),
															$author$project$Utils$FormErrors$view(
															A2($author$project$Utils$Form$validationErrors, 4, form))
														]))
												]));
									default:
										return A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(12)
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$value(
																	A2($elm$core$Maybe$withDefault, '', fields.SW)),
																	$author$project$Ui$Form$Input$placeholder('https://www.practice.com/patient-terms-and-conditions'),
																	$author$project$Ui$Form$Input$onInput(
																	A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$LinkUrl)),
																	$author$project$Ui$Form$Input$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
																	$author$project$Ui$Form$Input$errors(
																	A2($author$project$Utils$Form$validationErrors, 2, form)),
																	$author$project$Ui$Form$Input$disabled(isFormDisabled)
																]))
														]))
												]));
								}
							}()
							])),
						model.aJ ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Published')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.Ic),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Active)),
										$author$project$Ui$ToggleSwitch$disabled(isFormDisabled)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Only published documents can be viewed and accepted within this platform.')
									]))
							])),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						model.aJ ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Show on Online Signup')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.ZW),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$ShowOnSignup)),
										$author$project$Ui$ToggleSwitch$disabled((!fields.Ic) || (fields.agk || isFormDisabled))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Enable this to allow acceptance of the document through Online Signup.')
									]))
							])),
						model.aJ ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Visible')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										A4($author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton, fields.dY, $elm$core$Maybe$Nothing, 'Everyone', isFormDisabled),
										A4(
										$author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton,
										fields.dY,
										$elm$core$Maybe$Just(0),
										'Specific Plans',
										isFormDisabled),
										A4(
										$author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton,
										fields.dY,
										$elm$core$Maybe$Just(1),
										'Specific Locations',
										isFormDisabled)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Show this document all the time, or only to people enrolling for specific plans / locations')
									]))
							]))
					]),
					function () {
					var _v4 = _Utils_Tuple2(fields.dY, model.aJ);
					if (_v4.b) {
						return _List_fromArray(
							[$author$project$Utils$Html$empty]);
					} else {
						if (!_v4.a.$) {
							if (!_v4.a.a) {
								var _v5 = _v4.a.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Plans Type')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Button$group(
												_List_fromArray(
													[
														A4($author$project$Components$Admin$Documents$Form$viewPlanTypeButton, fields.Wp, 2, 'Retail', isFormDisabled),
														A4($author$project$Components$Admin$Documents$Form$viewPlanTypeButton, fields.Wp, 0, 'Employers', isFormDisabled)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Restrict To Plans')
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Plan$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
															$author$project$Components$ResourceFilter$errors(
															A2($author$project$Utils$Form$validationErrors, 5, form)),
															$author$project$Components$ResourceFilter$disabled(isFormDisabled)
														]),
													model.jw)),
											A2($elm$core$List$map, $author$project$Components$Admin$Documents$Form$viewDocumentScope, fields.NY)))
									]);
							} else {
								var _v6 = _v4.a.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Restrict To Locations')
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Location$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
															$author$project$Components$ResourceFilter$errors(
															A2($author$project$Utils$Form$validationErrors, 5, form)),
															$author$project$Components$ResourceFilter$disabled(isFormDisabled)
														]),
													model.rl)),
											A2($elm$core$List$map, $author$project$Components$Admin$Documents$Form$viewDocumentScope, fields.NY)))
									]);
							}
						} else {
							return _List_Nil;
						}
					}
				}(),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Required for Online Signup')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.agk),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Required)),
										$author$project$Ui$ToggleSwitch$disabled((!fields.Ic) || isFormDisabled)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Block online signup unless document is accepted.')
									]))
							])),
						model.aJ ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Acceptance type')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										A4($author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton, fields.HY, 0, 'Checking a checkbox', isFormDisabled),
										A4($author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton, fields.HY, 1, 'Typing patient name', isFormDisabled)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Choose how the document can be accepted through Online Signup')
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Acceptance text')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mr2, $author$project$Ui$Element$flexAuto]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(fields.HX),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$AcceptanceText)),
														$author$project$Ui$Form$Input$disabled(isFormDisabled)
													]))
											])),
										A2(
										$elm$html$Html$map,
										$author$project$Components$Admin$Documents$Form$TranslationsInputMsg,
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Utils$Html$empty,
											A2(
												$elm$core$Maybe$map,
												A2(
													$author$project$Components$TranslationsInput$view,
													'acceptance_text',
													_List_fromArray(
														[
															$author$project$Components$TranslationsInput$default(fields.HX)
														])),
												model.g3)))
									])),
								model.aJ ? $author$project$Utils$Html$empty : A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('You can change the text we use on the signup page.'),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text('Here\'s how it will look: ')
									])),
								model.aJ ? $author$project$Utils$Html$empty : A2(
								$author$project$Ui$Well$view,
								_List_fromArray(
									[$author$project$Ui$Well$small]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Checkbox$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Checkbox$disabled(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(fields.HX),
												$author$project$Utils$Html$noBreakSpace,
												A3(
												$author$project$Ui$Button$view,
												{abp: fields.zh},
												_List_fromArray(
													[$author$project$Ui$Button$link]),
												_List_fromArray(
													[
														$elm$html$Html$text(fields.zh)
													]))
											]))
									]))
							]))
					])
				]));
	});
var $author$project$Components$Admin$Documents$Form$SaveAndAddAnother = {$: 5};
var $author$project$Components$Admin$Documents$Form$SkipDocumentsSetup = {$: 17};
var $author$project$Components$Admin$Documents$Form$viewOnboardingButtons = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Skip documents setup'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$pull(0),
						$author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$SkipDocumentsSetup)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Skip')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsEnd]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Save and add another document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$SaveAndAddAnother)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save & Add Another')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Save document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$Documents$Form$Save(false))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Admin$Documents$Form$viewSaveButton = function (model) {
	return model.Rx ? $author$project$Utils$Html$empty : A3(
		$author$project$Ui$Button$view,
		{
			abp: function () {
				var _v0 = model.adR;
				if (!_v0.$) {
					return 'Update document';
				} else {
					return 'Create document';
				}
			}()
		},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$loading(
				_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
				$author$project$Ui$Button$onClick(
				$author$project$Components$Admin$Documents$Form$Save(false))
			]),
		_List_fromArray(
			[
				function () {
				var _v1 = model.adR;
				if (!_v1.$) {
					return $elm$html$Html$text('Update');
				} else {
					return $elm$html$Html$text('Create');
				}
			}()
			]));
};
var $author$project$Components$Admin$Documents$Form$Unarchive = {$: 15};
var $author$project$Components$Admin$Documents$Form$viewUnarchiveButton = function (model) {
	return model.Rx ? A3(
		$author$project$Ui$Button$view,
		{abp: 'Unarchive document'},
		_List_fromArray(
			[
				$author$project$Ui$Button$warning,
				$author$project$Ui$Button$loading(
				_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
				$author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$Unarchive)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Unarchive')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$Documents$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				model.aJ ? _List_fromArray(
					[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										function () {
										var _v1 = model.adR;
										if (!_v1.$) {
											return $elm$html$Html$text('Edit');
										} else {
											return $elm$html$Html$text('Add your patient agreement');
										}
									}()
									]),
								_List_fromArray(
									[
										model.aJ ? $author$project$Utils$Html$empty : A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$pull(1)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Admin__Documents__Top,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$Ui$Icon$view, _List_Nil, 2)
													]))
											]))
									])),
								function () {
								var _v2 = model.adR;
								if (!_v2.$) {
									return $author$project$Utils$Html$empty;
								} else {
									return A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add a document that can be e-signed by patient during Online Signup. Don\'t have an agreement yet? Click '),
												A3(
												$author$project$Ui$Link$externalHref,
												'https://support.hint.com/en/articles/4045458-sample-patient-agreement',
												_List_fromArray(
													[$author$project$Ui$Link$targetBlank]),
												_List_fromArray(
													[
														$elm$html$Html$text('here')
													])),
												$elm$html$Html$text(' to download our sample patient agreement.')
											]));
								}
							}()
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v3 = model.PB;
							if (!_v3.$) {
								var form = _v3.a;
								return A2($author$project$Components$Admin$Documents$Form$viewForm, model, form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						model.aJ ? A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Admin$Documents$Form$viewOnboardingButtons(model)
							])) : A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Documents__Top,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									])),
								$author$project$Components$Admin$Documents$Form$viewSaveButton(model),
								$author$project$Components$Admin$Documents$Form$viewArchiveButton(model),
								$author$project$Components$Admin$Documents$Form$viewUnarchiveButton(model)
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Documents$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Documents$Form$view(model.PB))
			]),
		$G: 'Admin | Documents'
	};
};
var $author$project$Pages$Admin$Documents$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Documents$Id_String$init, aer: $author$project$Pages$Admin$Documents$Id_String$load, agD: $author$project$Pages$Admin$Documents$Id_String$save, ahd: $author$project$Pages$Admin$Documents$Id_String$subscriptions, aaq: $author$project$Pages$Admin$Documents$Id_String$update, ahP: $author$project$Pages$Admin$Documents$Id_String$view});
var $author$project$Pages$Admin$Documents$New$DocumentFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Documents$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var _v2 = A5(
			$author$project$Components$Admin$Documents$Form$init,
			apiClient,
			session,
			$elm$core$Maybe$Nothing,
			practice,
			{aJ: false});
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$Documents$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Documents$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Documents$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$Documents$Form$subscriptions(model.PB));
};
var $author$project$Pages$Admin$Documents$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Documents$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Documents$Form$view(model.PB))
			]),
		$G: 'Admin | Documents'
	};
};
var $author$project$Pages$Admin$Documents$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Documents$New$init, aer: $author$project$Pages$Admin$Documents$New$load, agD: $author$project$Pages$Admin$Documents$New$save, ahd: $author$project$Pages$Admin$Documents$New$subscriptions, aaq: $author$project$Pages$Admin$Documents$New$update, ahP: $author$project$Pages$Admin$Documents$New$view});
var $author$project$Pages$Admin$Documents$Top$GotDocuments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Document$All$Document = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Document$All$Record = F2(
	function (currentDocumentVersion, documentScopes) {
		return {aci: currentDocumentVersion, NY: documentScopes};
	});
var $author$project$Api$Provider$Document$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'document_scopes',
	$elm$json$Json$Decode$list($author$project$Api$Provider$DocumentScope$Shared$sharedDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'current_document_version',
		$author$project$Api$Provider$DocumentVersion$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$All$Record)));
var $author$project$Api$Provider$Document$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Document$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Document$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$All$Document)));
var $author$project$Api$Provider$Document$listDefaults = {afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Document$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Document$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Document$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Document$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Document$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentsPath)));
	});
var $author$project$Pages$Admin$Documents$Top$fetchDocuments = function (model) {
	return A3(
		$author$project$Api$Provider$Document$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, af_: model.af_, ag1: model.ag1});
		},
		$author$project$Pages$Admin$Documents$Top$GotDocuments);
};
var $author$project$Pages$Admin$Documents$Top$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var query = _v3.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: apiClient,
			bX: $elm$core$Maybe$Nothing,
			fo: $elm$core$Set$empty,
			bq: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$Documents$Top$fetchDocuments(model));
	});
var $author$project$Pages$Admin$Documents$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Documents$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Documents$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Provider$Document$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$id(shared);
};
var $author$project$Pages$Admin$Documents$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Documents$Top$HiConfirmClosed),
				$author$project$Api$Provider$Document$All$id),
			model.bX));
};
var $author$project$Pages$Admin$Documents$Top$DocumentDeleted = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Documents$Top$SearchInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Document$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Document$documentPath(id_)));
	});
var $author$project$Pages$Admin$Documents$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Documents__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Admin$Documents$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bq: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bq: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									fo: A2($elm$core$Set$remove, id, model.fo),
									bq: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Documents$Top$fetchDocuments(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Document successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									fo: A2($elm$core$Set$remove, id, model.fo)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Documents$Top$fetchDocuments(newModel),
								$author$project$Pages$Admin$Documents$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Documents$Top$fetchDocuments(newModel),
								$author$project$Pages$Admin$Documents$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bX: $elm$core$Maybe$Nothing,
							fo: A2($elm$core$Set$insert, id, model.fo)
						}),
					A3(
						$author$project$Api$Provider$Document$delete,
						model.D5,
						id,
						$author$project$Pages$Admin$Documents$Top$DocumentDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{bX: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								bq: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Documents$Top$fetchDocuments(qModel),
										$author$project$Pages$Admin$Documents$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Documents$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Documents$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Document$Shared$documentAgreementsCount = function (_v0) {
	var record = _v0;
	return record.NX;
};
var $author$project$Api$Provider$Document$All$documentAgreementsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$documentAgreementsCount(shared);
};
var $author$project$Api$Provider$Document$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$name(shared);
};
var $author$project$Pages$Admin$Documents$Top$deleteMessage = function (document) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You\'re about to delete document '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Document$All$name(document))
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This will permanently delete '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$Document$All$documentAgreementsCount(document)))
								])),
							$elm$html$Html$text(' signed agreement(s) from patients. If you\'d like to retain your existing patient documents, please unpublish this document instead.')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Are you sure you want to delete this document?')
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Documents$Top$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Documents$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Document Name'),
		A3($author$project$Api$Column$init, 'visible', false, 'Visible'),
		A3($author$project$Api$Column$init, 'show_on_signup', true, 'Shown on Signup'),
		A3($author$project$Api$Column$init, 'required', true, 'Required'),
		A3($author$project$Api$Column$init, 'status', true, 'Status')
	]);
var $author$project$Pages$Admin$Documents$Top$documentScopeToString = function (scopeType) {
	if (scopeType === 1) {
		return 'Locations: ';
	} else {
		return 'Plans: ';
	}
};
var $author$project$Api$Provider$Document$All$documentScopes = function (_v0) {
	var all = _v0.b;
	return all.NY;
};
var $author$project$Pages$Admin$Documents$Top$listDocumentScopes = function (documentScopes) {
	return A2(
		$elm$core$String$join,
		', ',
		A2($elm$core$List$map, $author$project$Api$Provider$DocumentScope$Shared$scopeName, documentScopes));
};
var $author$project$Api$Provider$Document$All$required = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$required(shared);
};
var $author$project$Api$Provider$Document$All$showOnSignup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$showOnSignup(shared);
};
var $author$project$Api$Provider$Document$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Document$Shared$status(shared);
};
var $author$project$Pages$Admin$Documents$Top$viewDocument = function (document) {
	var id = $author$project$Api$Provider$Document$All$id(document);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$Document$All$name(document))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						function () {
							var _v0 = $elm$core$List$head(
								$author$project$Api$Provider$Document$All$documentScopes(document));
							if (!_v0.$) {
								var documentScope = _v0.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Admin$Documents$Top$documentScopeToString(
													$author$project$Api$Provider$DocumentScope$Shared$scopeType(documentScope)))
											])),
										$elm$html$Html$text(
										$author$project$Pages$Admin$Documents$Top$listDocumentScopes(
											$author$project$Api$Provider$Document$All$documentScopes(document)))
									]);
							} else {
								return _List_fromArray(
									[
										$elm$html$Html$text('Everyone')
									]);
							}
						}())
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toString(
									$author$project$Api$Provider$Document$All$showOnSignup(document)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toString(
									$author$project$Api$Provider$Document$All$required(document)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Provider$Document$All$status(document))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$minWidth('11rem'),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Documents__Id_String(
							{adR: id}),
						_List_fromArray(
							[
								$author$project$Ui$Link$sm,
								$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Documents$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.bq;
		if (_v1.$ === 3) {
			var documents_ = _v1.a;
			return _Utils_Tuple2(false, documents_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var documents = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$elm$html$Html$text('Manage who can see your documents - published documents are available to all users in the app, and each document can be configured to be viewable and/or required during online signup. To learn more, see our '),
					A3(
					$author$project$Ui$Link$externalHref,
					'https://support.hint.com/online-signup/adding-multiple-patient-contracts-or-agreements',
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank]),
					_List_fromArray(
						[
							$elm$html$Html$text('support article.')
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Documents$Top$SearchInputMsg,
									A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No documents found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$Documents$Top$SortTable)),
						$author$project$Pages$Admin$Documents$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Admin$Documents$Top$viewDocument, documents),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$Documents$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.bX;
				if (!_v0.$) {
					var document = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Documents$Top$HiConfirmClosed(
							$author$project$Api$Provider$Document$All$id(document)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('document'),
								$author$project$Components$HiConfirm$customMessage(
								$author$project$Pages$Admin$Documents$Top$deleteMessage(document))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										$elm$html$Html$text('Documents')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__Documents__New,
										_List_fromArray(
											[
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$pull(1),
												$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Document')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$Documents$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v1 = model.bq;
								if (_v1.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$Documents$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.afy));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		$G: 'Admin | Documents'
	};
};
var $author$project$Pages$Admin$Documents$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Documents$Top$init, aer: $author$project$Pages$Admin$Documents$Top$load, agD: $author$project$Pages$Admin$Documents$Top$save, ahd: $author$project$Pages$Admin$Documents$Top$subscriptions, aaq: $author$project$Pages$Admin$Documents$Top$update, ahP: $author$project$Pages$Admin$Documents$Top$view});
var $author$project$Pages$Admin$Elation$Link$GotElation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Elation$StepHeader$Link = 1;
var $author$project$Components$Admin$Elation$StepHeader$init = function (currentStep) {
	return {EP: currentStep, dX: $elm$core$Maybe$Nothing};
};
var $author$project$Api$Provider$ElationConfiguration$One$ElationConfiguration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ElationConfiguration$Shared$ElationConfiguration = $elm$core$Basics$identity;
var $author$project$Api$Provider$ElationConfiguration$Shared$Record = F5(
	function (status, allowNewPatientCreation, sendEligibilityStatusTag, elationPracticeName, elationPracticeId) {
		return {IX: allowNewPatientCreation, Oi: elationPracticeId, Oj: elationPracticeName, Zt: sendEligibilityStatusTag, ag7: status};
	});
var $author$project$Api$Provider$ElationConfiguration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'elation_practice_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'elation_practice_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'send_eligibility_status_tag',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'allow_new_patient_creation',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$Shared$Record))))));
var $author$project$Api$Provider$ElationConfiguration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ElationConfiguration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ElationConfiguration$One$Record = function (practitionersCount) {
	return {WR: practitionersCount};
};
var $author$project$Api$Provider$ElationConfiguration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practitioners_count',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$One$Record));
var $author$project$Api$Provider$ElationConfiguration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ElationConfiguration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ElationConfiguration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$One$ElationConfiguration)));
var $author$project$Api$Provider$Integration$Elation$elationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['elation_configuration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Integration$Elation$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$ElationConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath));
	});
var $author$project$Pages$Admin$Elation$Link$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				iA: $author$project$Api$Data$Loading,
				PB: $elm$core$Maybe$Nothing,
				qT: shared.qT,
				jY: $author$project$Api$Data$NotAsked,
				ki: $author$project$Components$Admin$Elation$StepHeader$init(1)
			},
			A2($author$project$Api$Provider$Integration$Elation$retrieve, shared.D5, $author$project$Pages$Admin$Elation$Link$GotElation));
	});
var $author$project$Pages$Admin$Elation$Link$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Elation$Link$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Elation$Link$StepHeaderMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Elation$StepHeader$HiConfirmClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Elation$StepHeader$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Admin$Elation$StepHeader$HiConfirmClosed)),
			model.dX));
};
var $author$project$Pages$Admin$Elation$Link$subscriptions = function (_v0) {
	var stepHeader = _v0.ki;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Elation$Link$StepHeaderMsg,
		$author$project$Components$Admin$Elation$StepHeader$subscriptions(stepHeader));
};
var $author$project$Pages$Admin$Elation$Link$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Integration$Elation$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elation_configuration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'username',
								$elm$json$Json$Encode$string(fields.ahN)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(fields.afC)),
								_Utils_Tuple2(
								'client_id',
								$elm$json$Json$Encode$string(fields.ab1)),
								_Utils_Tuple2(
								'client_secret',
								$elm$json$Json$Encode$string(fields.ab2))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ElationConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath)));
	});
var $author$project$Pages$Admin$Elation$Link$createElation = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$Integration$Elation$create, apiClient, fields, $author$project$Pages$Admin$Elation$Link$Created);
	});
var $author$project$Pages$Admin$Elation$Link$formFieldsInit = {ab1: '', ab2: '', afC: '', ahN: ''};
var $author$project$Pages$Admin$Elation$Link$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{ahN: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{afC: string});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{ab1: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{ab2: string});
		}
	});
var $author$project$Pages$Admin$Elation$Link$ClientIdValidation = 2;
var $author$project$Pages$Admin$Elation$Link$ClientSecretValidation = 3;
var $author$project$Pages$Admin$Elation$Link$PasswordValidation = 1;
var $author$project$Pages$Admin$Elation$Link$UserNameValidation = 0;
var $author$project$Pages$Admin$Elation$Link$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ahN;
			},
			_Utils_Tuple2(0, 'Please enter an api key')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.afC;
			},
			_Utils_Tuple2(1, 'Please enter a password')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ab1;
			},
			_Utils_Tuple2(2, 'Please enter a client id')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ab2;
			},
			_Utils_Tuple2(3, 'Please enter a client secret'))
		]));
var $author$project$Pages$Admin$Elation$Link$setIntegration = F2(
	function (elationConfiguration, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{iA: elationConfiguration}),
			A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Elation__Overview));
	});
var $author$project$Components$Admin$Elation$StepHeader$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Integration$Elation$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath));
	});
var $author$project$Components$Admin$Elation$StepHeader$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dX: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dX: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
						}),
					A2($author$project$Api$Provider$Integration$Elation$delete, apiClient, $author$project$Components$Admin$Elation$StepHeader$Disabled),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{dX: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dX: $elm$core$Maybe$Nothing}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Elation__Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been disabled.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dX: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Elation$Link$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A2($author$project$Pages$Admin$Elation$Link$setIntegration, response, model));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											iA: response,
											PB: $elm$core$Maybe$Just(
												$author$project$Utils$Form$init($author$project$Pages$Admin$Elation$Link$formFieldsInit))
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iA: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var field = msg.a;
				var _v3 = model.PB;
				if (!_v3.$) {
					var form = _v3.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Elation$Link$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v4 = model.PB;
				if (!_v4.$) {
					var form = _v4.a;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Elation$Link$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							A2($author$project$Pages$Admin$Elation$Link$createElation, model.D5, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return A2(
						$author$project$Utils$Tuple3$fromTuple2,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation credentials have been saved.')
							]),
						A2($author$project$Pages$Admin$Elation$Link$setIntegration, response, model));
				} else {
					var _v8 = model.PB;
					if (!_v8.$) {
						var form = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(form),
									jY: response
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			default:
				var subMsg = msg.a;
				var _v9 = A3($author$project$Components$Admin$Elation$StepHeader$update, model.D5, subMsg, model.ki);
				var stepHeader = _v9.a;
				var subCmd = _v9.b;
				var subOutMsg = _v9.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ki: stepHeader}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Elation$Link$StepHeaderMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Ui$Image$ElationEMRBlueLogo = 7;
var $author$project$Pages$Admin$Elation$Link$Save = {$: 2};
var $author$project$Components$Admin$Elation$StepHeader$modal = function (model) {
	var _v0 = model.dX;
	if (!_v0.$) {
		var disablingRequest = _v0.a;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Admin$Elation$StepHeader$HiConfirmClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text('Please confirm you would like to deactivate the Elation integration.')
						])),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(disablingRequest, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$Elation$StepHeader$Initial = 0;
var $author$project$Components$Admin$Elation$StepHeader$Overview = 3;
var $author$project$Components$Admin$Elation$StepHeader$Providers = 2;
var $author$project$Components$Admin$Elation$StepHeader$all = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Components$Admin$Elation$StepHeader$inBreadcrumbsAs = function (step) {
	switch (step) {
		case 0:
			return '';
		case 1:
			return 'Connect Account';
		case 2:
			return 'Link Providers';
		default:
			return 'Overview';
	}
};
var $author$project$Components$Admin$Elation$StepHeader$showOnBreadcrumbs = function (step_) {
	switch (step_) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Admin$Elation$StepHeader$skeleton = function () {
	var stepToBreadcrumbSkeleton = A2(
		$elm$core$Basics$composeR,
		$author$project$Components$Admin$Elation$StepHeader$inBreadcrumbsAs,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Ui$Skeleton$spanFromText,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Ui$Skeleton$text,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$singleton,
						$author$project$Ui$HorizontalBreadcrumb$item(_List_Nil))))));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton('Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('Inactive')
									]))
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$HorizontalBreadcrumb$view,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalBreadcrumb$margin(21),
						$author$project$Ui$HorizontalBreadcrumb$padding(1)
					]),
				A2(
					$elm$core$List$map,
					stepToBreadcrumbSkeleton,
					A2($elm$core$List$filter, $author$project$Components$Admin$Elation$StepHeader$showOnBreadcrumbs, $author$project$Components$Admin$Elation$StepHeader$all)))
			]));
}();
var $author$project$Components$Admin$Elation$StepHeader$Disable = {$: 0};
var $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeId = function (_v0) {
	var record = _v0;
	return record.Oi;
};
var $author$project$Api$Provider$ElationConfiguration$One$elationPracticeId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeId(shared);
};
var $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeName = function (_v0) {
	var record = _v0;
	return record.Oj;
};
var $author$project$Api$Provider$ElationConfiguration$One$elationPracticeName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeName(shared);
};
var $author$project$Api$Provider$ElationConfiguration$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$ElationConfiguration$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$status(shared);
};
var $author$project$Components$Admin$Elation$StepHeader$viewStatus = F2(
	function (status, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($author$project$Ui$Badge$fromString, _List_Nil, status),
						content))
				]));
	});
var $author$project$Components$Admin$Elation$StepHeader$breadcrumbsDisabled = function (step) {
	switch (step) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		default:
			return false;
	}
};
var $author$project$Components$Admin$Elation$StepHeader$stepIndex = function (step_) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm_community$list_extra$List$Extra$findIndex,
			function (currentStep_) {
				return _Utils_eq(step_, currentStep_);
			},
			$author$project$Components$Admin$Elation$StepHeader$all));
};
var $author$project$Components$Admin$Elation$StepHeader$stepIsDisabled = F2(
	function (currentStep, step) {
		return $author$project$Components$Admin$Elation$StepHeader$breadcrumbsDisabled(step) || (_Utils_cmp(
			$author$project$Components$Admin$Elation$StepHeader$stepIndex(currentStep),
			$author$project$Components$Admin$Elation$StepHeader$stepIndex(step)) < 0);
	});
var $author$project$Components$Admin$Elation$StepHeader$stepRoute = function (step) {
	switch (step) {
		case 0:
			return $author$project$Spa$Generated$Route$Admin__Elation__Top;
		case 1:
			return $author$project$Spa$Generated$Route$Admin__Elation__Link;
		case 2:
			return $author$project$Spa$Generated$Route$Admin__Elation__Providers;
		default:
			return $author$project$Spa$Generated$Route$Admin__Elation__Overview;
	}
};
var $author$project$Components$Admin$Elation$StepHeader$viewStepBreadcrumb = F2(
	function (currentStep, step) {
		var isCurrent = _Utils_eq(step, currentStep);
		return A2(
			$author$project$Ui$HorizontalBreadcrumb$item,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalBreadcrumb$current(isCurrent),
					$author$project$Ui$HorizontalBreadcrumb$disabled(
					$author$project$Components$Admin$Elation$StepHeader$breadcrumbsDisabled(step))
				]),
			_List_fromArray(
				[
					(isCurrent || A2($author$project$Components$Admin$Elation$StepHeader$stepIsDisabled, currentStep, step)) ? A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Admin$Elation$StepHeader$inBreadcrumbsAs(step))
						])) : A3(
					$author$project$Ui$Link$route,
					$author$project$Components$Admin$Elation$StepHeader$stepRoute(step),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$Admin$Elation$StepHeader$inBreadcrumbsAs(step))
						]))
				]));
	});
var $author$project$Components$Admin$Elation$StepHeader$view = F2(
	function (elationConfiguration, model) {
		var elationConfiguration_ = $author$project$Api$Data$toMaybe(elationConfiguration);
		var status = A2(
			$elm$core$Maybe$withDefault,
			'pending',
			A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$status, elationConfiguration_));
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Components$Admin$Elation$StepHeader$viewStatus,
					status,
					_List_fromArray(
						[
							function () {
							var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ElationConfiguration$One$elationPracticeName, elationConfiguration_);
							if (!_v0.$) {
								var elationPracticeName = _v0.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$margin(11)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('at '),
											$elm$html$Html$text(elationPracticeName),
											$elm$html$Html$text(' (Practice ID: '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ElationConfiguration$One$elationPracticeId, elationConfiguration_))),
											$elm$html$Html$text(')')
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							$author$project$Utils$Maybe$toBool(elationConfiguration_) ? A3(
							$author$project$Ui$Button$view,
							{abp: ' Deactivate integration'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Elation$StepHeader$Disable),
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$pull(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Deactivate the integration')
								])) : $author$project$Utils$Html$empty
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$HorizontalBreadcrumb$view,
					_List_fromArray(
						[
							$author$project$Ui$HorizontalBreadcrumb$margin(21),
							$author$project$Ui$HorizontalBreadcrumb$padding(1)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Admin$Elation$StepHeader$viewStepBreadcrumb(model.EP),
						A2($elm$core$List$filter, $author$project$Components$Admin$Elation$StepHeader$showOnBreadcrumbs, $author$project$Components$Admin$Elation$StepHeader$all))),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Pages$Admin$Elation$Link$ClientId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Elation$Link$ClientSecret = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Elation$Link$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Elation$Link$Password = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Elation$Link$UserName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$PasswordInput$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$PasswordInput$errors = $author$project$Ui$Form$PasswordInput$Errors;
var $author$project$Ui$Form$PasswordInput$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$PasswordInput$invalid = $author$project$Ui$Form$PasswordInput$Invalid;
var $author$project$Ui$Form$PasswordInput$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$PasswordInput$onInput = $author$project$Ui$Form$PasswordInput$OnInput;
var $author$project$Ui$Form$PasswordInput$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$PasswordInput$value = $author$project$Ui$Form$PasswordInput$Value;
var $author$project$Ui$Form$PasswordInput$defaultOptions = {fE: _List_Nil, ap: _List_Nil, q$: false, r4: 'Password', Cu: $elm$core$Maybe$Nothing, aaN: $elm$core$Maybe$Nothing, DQ: false};
var $author$project$Ui$Form$PasswordInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$onInput(handler),
									record.ap)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								ap: A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$value(string),
									record.ap),
								aaN: $elm$core$Maybe$Just(string)
							});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{q$: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
					case 4:
						var maybeStrength = option.a;
						return _Utils_update(
							record,
							{Cu: maybeStrength});
					case 5:
						var string = option.a;
						return _Utils_update(
							record,
							{r4: string});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{DQ: bool});
				}
			}),
		$author$project$Ui$Form$PasswordInput$defaultOptions,
		options);
};
var $author$project$Ui$Form$Input$Password = {$: 5};
var $author$project$Ui$Form$Input$password = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Password);
var $author$project$Utils$PasswordStrength$suggestions = function (_v0) {
	var record = _v0;
	return record.ahe;
};
var $author$project$Ui$ProgressBar$Danger = {$: 4};
var $author$project$Ui$ProgressBar$danger = $author$project$Ui$ProgressBar$Danger;
var $author$project$Utils$PasswordStrength$strength = function (_v0) {
	var record = _v0;
	return record.aha;
};
var $author$project$Ui$ProgressBar$Success = {$: 2};
var $author$project$Ui$ProgressBar$success = $author$project$Ui$ProgressBar$Success;
var $author$project$Ui$ProgressBar$Bar = $elm$core$Basics$identity;
var $author$project$Ui$ProgressBar$bar = function (options) {
	return options;
};
var $author$project$Ui$ProgressBar$defaultOptions = {EB: _List_Nil, Cj: false, ahT: 0};
var $author$project$Ui$ProgressBar$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'progress-bar-striped', record.EB)
							});
					case 1:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'active', record.EB)
							});
					case 2:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'progress-bar-success', record.EB)
							});
					case 3:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'progress-bar-info', record.EB)
							});
					case 4:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'progress-bar-danger', record.EB)
							});
					case 5:
						return _Utils_update(
							record,
							{
								EB: A2($elm$core$List$cons, 'progress-bar-warning', record.EB)
							});
					case 6:
						return _Utils_update(
							record,
							{Cj: true});
					default:
						var _float = option.a;
						return _Utils_update(
							record,
							{ahT: _float});
				}
			}),
		$author$project$Ui$ProgressBar$defaultOptions,
		options);
};
var $author$project$Ui$ProgressBar$viewBar = function (_v0) {
	var options = _v0;
	var optionsRecord = $author$project$Ui$ProgressBar$optionsToRecord(options);
	var width_ = optionsRecord.ahT;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('progress-bar'),
				$elm$html$Html$Attributes$class(
				A2($elm$core$String$join, ' ', optionsRecord.EB)),
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromFloat(width_) + '%'),
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-valuenow',
				$elm$core$String$fromFloat(width_)),
				A2($elm$html$Html$Attributes$attribute, 'aria-valuemin', '0'),
				A2($elm$html$Html$Attributes$attribute, 'aria-valuemax', '100')
			]),
		optionsRecord.Cj ? _List_fromArray(
			[
				$elm$html$Html$text(
				A2($myrho$elm_round$Round$round, 2, width_) + '%')
			]) : _List_Nil);
};
var $author$project$Ui$ProgressBar$stacked = function (bars) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('progress')
			]),
		A2($elm$core$List$map, $author$project$Ui$ProgressBar$viewBar, bars));
};
var $author$project$Ui$ProgressBar$view = function (options) {
	return $author$project$Ui$ProgressBar$stacked(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$bar(options)
			]));
};
var $author$project$Ui$ProgressBar$Warning = {$: 5};
var $author$project$Ui$ProgressBar$warning = $author$project$Ui$ProgressBar$Warning;
var $author$project$Ui$ProgressBar$Width = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$ProgressBar$width = $author$project$Ui$ProgressBar$Width;
var $author$project$Ui$Form$PasswordInput$viewProgressBar = function (passwordStrength) {
	var _v0 = function () {
		var _v1 = $author$project$Utils$PasswordStrength$strength(passwordStrength);
		switch (_v1) {
			case 1:
				return _Utils_Tuple2(1, $author$project$Ui$ProgressBar$danger);
			case 2:
				return _Utils_Tuple2(2, $author$project$Ui$ProgressBar$danger);
			case 3:
				return _Utils_Tuple2(3, $author$project$Ui$ProgressBar$warning);
			case 4:
				return _Utils_Tuple2(4, $author$project$Ui$ProgressBar$success);
			default:
				return _Utils_Tuple2(0, $author$project$Ui$ProgressBar$danger);
		}
	}();
	var width = _v0.a;
	var style = _v0.b;
	return $author$project$Ui$ProgressBar$view(
		_List_fromArray(
			[
				$author$project$Ui$ProgressBar$width((25 * width) + 5),
				style
			]));
};
var $author$project$Ui$Form$PasswordInput$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$PasswordInput$optionsToRecord(options);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$phi(true),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Form$Input$withFeedback(optionsRecord.DQ),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$password,
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Input$invalid(optionsRecord.q$),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Input$errors(optionsRecord.fE),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$Input$placeholder(optionsRecord.r4),
												optionsRecord.ap)))))))
					]),
					function () {
					var _v0 = optionsRecord.Cu;
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var passwordStrength = _v0.a;
						return _List_fromArray(
							[
								$author$project$Ui$Form$PasswordInput$viewProgressBar(passwordStrength),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/user-account-setup/password-creation-and-reset',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Tooltip$view,
												_List_fromArray(
													[
														$author$project$Ui$Tooltip$placement(0)
													]),
												'Click to Learn More',
												_List_fromArray(
													[
														A2($author$project$Ui$Icon$view, _List_Nil, 5)
													]))
											])),
										$elm$core$List$isEmpty(
										$author$project$Utils$PasswordStrength$suggestions(passwordStrength)) ? $author$project$Utils$Html$empty : A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												'Tip: ' + A2(
													$elm$core$String$join,
													' ',
													$author$project$Utils$PasswordStrength$suggestions(passwordStrength)))
											]))
									]))
							]);
					}
				}()
				])));
};
var $author$project$Pages$Admin$Elation$Link$viewConfigureInfo = A2(
	$author$project$Ui$Typography$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('To configure this integration, contact the Elation Integrations team  at '),
			A3(
			$author$project$Ui$Link$mailto,
			'integrations@elationhealth.com',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('integrations@elationhealth.com')
				])),
			$elm$html$Html$text(' and request an Elation-Hint API integration.')
		]));
var $author$project$Pages$Admin$Elation$Link$viewLinkStep = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Connect Elation Account')
					])),
				$author$project$Pages$Admin$Elation$Link$viewConfigureInfo,
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Username'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.ahN),
								$author$project$Ui$Form$Input$autoComplete(false),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Elation$Link$FormUpdated, $author$project$Pages$Admin$Elation$Link$UserName)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Password'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$PasswordInput$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$PasswordInput$value(fields.afC),
								$author$project$Ui$Form$PasswordInput$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Elation$Link$FormUpdated, $author$project$Pages$Admin$Elation$Link$Password)),
								$author$project$Ui$Form$PasswordInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
								$author$project$Ui$Form$PasswordInput$errors(
								A2($author$project$Utils$Form$validationErrors, 1, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Client Id'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.ab1),
								$author$project$Ui$Form$Input$autoComplete(false),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Elation$Link$FormUpdated, $author$project$Pages$Admin$Elation$Link$ClientId)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Client Secret'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.ab2),
								$author$project$Ui$Form$Input$autoComplete(false),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Elation$Link$FormUpdated, $author$project$Pages$Admin$Elation$Link$ClientSecret)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 3, form))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Elation$Link$viewLinkStepFooter = function (saveRequest) {
	return A2(
		$author$project$Ui$Panel$footer,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Got to next step'},
				_List_fromArray(
					[
						$author$project$Ui$Button$submit,
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Next')
					]))
			]));
};
var $author$project$Pages$Admin$Elation$Link$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Elation$Link$StepHeaderMsg,
				$author$project$Components$Admin$Elation$StepHeader$modal(model.ki)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Elation$Link$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Image$view,
										model.qT,
										{I1: 'ElationEMR Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										7)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										var _v0 = model.iA;
										if (_v0.$ === 1) {
											return $author$project$Components$Admin$Elation$StepHeader$skeleton;
										} else {
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Elation$Link$StepHeaderMsg,
												A2($author$project$Components$Admin$Elation$StepHeader$view, model.iA, model.ki));
										}
									}(),
										function () {
										var _v1 = model.PB;
										if (!_v1.$) {
											var form = _v1.a;
											return $author$project$Pages$Admin$Elation$Link$viewLinkStep(form);
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									])),
								$author$project$Pages$Admin$Elation$Link$viewLinkStepFooter(model.jY)
							]))
					]))
			]),
		$G: 'Integrations | Elation Health'
	};
};
var $author$project$Pages$Admin$Elation$Link$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Elation$Link$init, aer: $author$project$Pages$Admin$Elation$Link$load, agD: $author$project$Pages$Admin$Elation$Link$save, ahd: $author$project$Pages$Admin$Elation$Link$subscriptions, aaq: $author$project$Pages$Admin$Elation$Link$update, ahP: $author$project$Pages$Admin$Elation$Link$view});
var $author$project$Pages$Admin$Elation$Overview$GotElation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Elation$Overview$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				iA: $author$project$Api$Data$Loading,
				qT: shared.qT,
				jY: $author$project$Api$Data$NotAsked,
				ki: $author$project$Components$Admin$Elation$StepHeader$init(3)
			},
			A2($author$project$Api$Provider$Integration$Elation$retrieve, shared.D5, $author$project$Pages$Admin$Elation$Overview$GotElation));
	});
var $author$project$Pages$Admin$Elation$Overview$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Elation$Overview$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Elation$Overview$StepHeaderMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Elation$Overview$subscriptions = function (_v0) {
	var stepHeader = _v0.ki;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Elation$Overview$StepHeaderMsg,
		$author$project$Components$Admin$Elation$StepHeader$subscriptions(stepHeader));
};
var $author$project$Pages$Admin$Elation$Overview$Activated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Elation$Overview$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Integration$Elation$activate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ElationConfiguration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$Integration$Elation$elationPath)));
	});
var $author$project$Api$Provider$ElationConfiguration$Shared$allowNewPatientCreation = function (_v0) {
	var record = _v0;
	return record.IX;
};
var $author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$allowNewPatientCreation(shared);
};
var $author$project$Api$Provider$ElationConfiguration$Shared$sendEligibilityStatusTag = function (_v0) {
	var record = _v0;
	return record.Zt;
};
var $author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ElationConfiguration$Shared$sendEligibilityStatusTag(shared);
};
var $author$project$Api$Provider$Integration$Elation$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elation_configuration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'allow_new_patient_creation',
								$elm$json$Json$Encode$bool(fields.IX)),
								_Utils_Tuple2(
								'send_eligibility_status_tag',
								$elm$json$Json$Encode$bool(fields.Zt))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ElationConfiguration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath)));
	});
var $author$project$Pages$Admin$Elation$Overview$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{iA: response}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{iA: response}),
									A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Elation__Top),
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iA: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Elation$activate, model.D5, $author$project$Pages$Admin$Elation$Overview$Activated),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iA: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been activated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var allowNewPatientCreation = msg.a;
				var sendEligibilityStatusTag = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag,
						$author$project$Api$Data$toMaybe(model.iA)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Integration$Elation$update,
						model.D5,
						{IX: allowNewPatientCreation, Zt: sendEligibilityStatusTag},
						$author$project$Pages$Admin$Elation$Overview$Updated),
					_List_Nil);
			case 4:
				var sendEligibilityStatusTag = msg.a;
				var allowNewPatientCreation = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation,
						$author$project$Api$Data$toMaybe(model.iA)));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Integration$Elation$update,
						model.D5,
						{IX: allowNewPatientCreation, Zt: sendEligibilityStatusTag},
						$author$project$Pages$Admin$Elation$Overview$Updated),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iA: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration have been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v5 = A3($author$project$Components$Admin$Elation$StepHeader$update, model.D5, subMsg, model.ki);
				var stepHeader = _v5.a;
				var subCmd = _v5.b;
				var subOutMsg = _v5.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ki: stepHeader}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Elation$Overview$StepHeaderMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Elation$Overview$Activate = {$: 1};
var $author$project$Pages$Admin$Elation$Overview$ToggleEligibilityStatusTag = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Elation$Overview$ToggleNewPatientCreation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ElationConfiguration$One$practitionersCount = function (_v0) {
	var record = _v0.b;
	return record.WR;
};
var $author$project$Pages$Admin$Elation$Overview$viewOverviewStep = function (model) {
	var elationConfiguration = $author$project$Api$Data$toMaybe(model.iA);
	var practitionersCount = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanFromText('100')
				])),
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Provider$ElationConfiguration$One$practitionersCount,
				A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$html$Html$text)),
			elationConfiguration));
	var sendEligibilityStatusTag = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag, elationConfiguration));
	var allowNewPatientCreation = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation, elationConfiguration));
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Number of Providers Linked'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[practitionersCount]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Create patients from Elation'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(allowNewPatientCreation),
								$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$Elation$Overview$ToggleNewPatientCreation),
								$author$project$Ui$ToggleSwitch$disabled(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							])),
						allowNewPatientCreation ? A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Update linked patients with changes from Elation Health. If a patient is '),
										$elm$html$Html$text('not found, create a new record in Hint. This is suggested for direct '),
										$elm$html$Html$text('care practices.')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Note: Only patients assigned to Elation physicians linked to Hint '),
										$elm$html$Html$text('will be created in Hint.')
									]))
							])) : A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('Update linked patients with changes from Elation Health. If a patient is '),
								$elm$html$Html$text('not found, '),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text('do not create')
									])),
								$elm$html$Html$text(' a record in Hint. This is suggested for hybrid practices '),
								$elm$html$Html$text('that have both fee-for-service as well as direct care patients.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Send Eligibility Status tag'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(sendEligibilityStatusTag),
								$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$Elation$Overview$ToggleEligibilityStatusTag),
								$author$project$Ui$ToggleSwitch$disabled(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('When enabled, the Eligibility Status tag will be sent to Elation Health '),
								$elm$html$Html$text('during patient synchronization.')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Elation$Overview$viewOverviewStepFooter = function (model) {
	var status = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$ElationConfiguration$One$status,
		$author$project$Api$Data$toMaybe(model.iA));
	return (!_Utils_eq(
		status,
		$elm$core$Maybe$Just('active'))) ? A2(
		$author$project$Ui$Panel$footer,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Activate integration'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Pages$Admin$Elation$Overview$Activate),
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.jY, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Activate')
					]))
			])) : $author$project$Ui$Panel$none;
};
var $author$project$Pages$Admin$Elation$Overview$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Elation$Overview$StepHeaderMsg,
				$author$project$Components$Admin$Elation$StepHeader$modal(model.ki)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Elation$Overview$Activate)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Image$view,
										model.qT,
										{I1: 'ElationEMR Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										7)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										var _v0 = model.iA;
										if (_v0.$ === 3) {
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Elation$Overview$StepHeaderMsg,
												A2($author$project$Components$Admin$Elation$StepHeader$view, model.iA, model.ki));
										} else {
											return $author$project$Components$Admin$Elation$StepHeader$skeleton;
										}
									}(),
										$author$project$Pages$Admin$Elation$Overview$viewOverviewStep(model)
									])),
								$author$project$Pages$Admin$Elation$Overview$viewOverviewStepFooter(model)
							]))
					]))
			]),
		$G: 'Integrations | Elation Health'
	};
};
var $author$project$Pages$Admin$Elation$Overview$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Elation$Overview$init, aer: $author$project$Pages$Admin$Elation$Overview$load, agD: $author$project$Pages$Admin$Elation$Overview$save, ahd: $author$project$Pages$Admin$Elation$Overview$subscriptions, aaq: $author$project$Pages$Admin$Elation$Overview$update, ahP: $author$project$Pages$Admin$Elation$Overview$view});
var $author$project$Pages$Admin$Elation$Providers$GotElation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Admin$Elation$Providers$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				ix: $elm$core$Set$empty,
				iA: $author$project$Api$Data$Loading,
				lZ: $author$project$Api$Data$NotAsked,
				l_: $author$project$Api$Data$NotAsked,
				qT: shared.qT,
				jY: $author$project$Api$Data$NotAsked,
				ki: $author$project$Components$Admin$Elation$StepHeader$init(2)
			},
			A2(
				$author$project$Api$Provider$Integration$Elation$retrieve,
				shared.D5,
				$author$project$Pages$Admin$Elation$Providers$GotElation(true)));
	});
var $author$project$Pages$Admin$Elation$Providers$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Elation$Providers$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Elation$Providers$StepHeaderMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$Elation$Providers$subscriptions = function (_v0) {
	var stepHeader = _v0.ki;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Elation$Providers$StepHeaderMsg,
		$author$project$Components$Admin$Elation$StepHeader$subscriptions(stepHeader));
};
var $author$project$Pages$Admin$Elation$Providers$GotElationProviderMappings = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Elation$Providers$GotElationProviders = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Elation$Providers$GotProviderMapping = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Elation$Provider$All$Provider = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$Provider = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Elation$Provider$Shared$Record)));
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Elation$Provider$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Elation$Provider$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Elation$Provider$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Elation$Provider$providersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['providers']),
	$author$project$Api$Provider$Integration$Elation$elationPath);
var $author$project$Api$Provider$Integration$Elation$Provider$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Elation$Provider$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$Provider$providersPath));
	});
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$ProviderMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$ProviderMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$Record = F3(
	function (id, name, externalId) {
		return {ade: externalId, adR: id, zh: name};
	});
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'external_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$Record))));
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['provider_mappings']),
	$author$project$Api$Provider$Integration$Elation$elationPath);
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Elation$ProviderMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath));
	});
var $author$project$Pages$Admin$Elation$Providers$resetHintProviders = function (model) {
	return _Utils_update(
		model,
		{ix: $elm$core$Set$empty});
};
var $author$project$Pages$Admin$Elation$Providers$fetchProvidersData = function (model) {
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{lZ: $author$project$Api$Data$Loading, l_: $author$project$Api$Data$Loading}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$Integration$Elation$Provider$list, model.D5, $author$project$Pages$Admin$Elation$Providers$GotElationProviders),
					A2($author$project$Api$Provider$Integration$Elation$ProviderMapping$list, model.D5, $author$project$Pages$Admin$Elation$Providers$GotElationProviderMappings)
				])));
};
var $author$project$Pages$Admin$Elation$Providers$setIntegration = F3(
	function (elationConfiguration, fetchProviders, model) {
		return (fetchProviders ? $author$project$Pages$Admin$Elation$Providers$fetchProvidersData : function (model_) {
			return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
		})(
			_Utils_update(
				model,
				{iA: elationConfiguration}));
	});
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$One$ProviderMapping = 0;
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath);
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'provider_mapping',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'external_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ade))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Integration$Elation$ProviderMapping$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingPath(id))));
	});
var $author$project$Pages$Admin$Elation$Providers$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var fetchProviders = msg.a;
				var response = msg.b;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A3($author$project$Pages$Admin$Elation$Providers$setIntegration, response, fetchProviders, model));
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{iA: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iA: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l_: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						$author$project$Pages$Admin$Elation$Providers$resetHintProviders(
							_Utils_update(
								model,
								{lZ: response})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iA: $author$project$Api$Data$Loading}),
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Elation__Overview),
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l_: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Integration$Elation$Provider$list, model.D5, $author$project$Pages$Admin$Elation$Providers$GotElationProviders),
					_List_Nil);
			case 5:
				var elationProviderMapping = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ix: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping),
								model.ix)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var elationProviderMapping = msg.a;
				var elationProviderId = msg.b;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Integration$Elation$ProviderMapping$update,
						model.D5,
						$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping),
						{
							ade: $author$project$Utils$String$toMaybe(elationProviderId)
						},
						$author$project$Pages$Admin$Elation$Providers$GotProviderMapping),
					_List_Nil);
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Provider$Integration$Elation$ProviderMapping$list, model.D5, $author$project$Pages$Admin$Elation$Providers$GotElationProviderMappings),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation provider have been updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v5 = A3($author$project$Components$Admin$Elation$StepHeader$update, model.D5, subMsg, model.ki);
				var stepHeader = _v5.a;
				var subCmd = _v5.b;
				var subOutMsg = _v5.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ki: stepHeader}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Elation$Providers$StepHeaderMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Elation$Providers$CompleteProviders = {$: 3};
var $author$project$Pages$Admin$Elation$Providers$RefreshElationProviders = {$: 4};
var $author$project$Pages$Admin$Elation$Providers$EditElationProviderMapping = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Elation$Providers$UpdateProviderMapping = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Integration$Elation$Provider$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$Provider$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$Elation$Provider$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Integration$Elation$Provider$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$Provider$Shared$name(shared);
};
var $author$project$Pages$Admin$Elation$Providers$elationProvidersOptions = function (elationProviders) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(true)
				]),
			$elm$core$Maybe$Nothing,
			'Choose Elation Provider'),
		A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Unlink this Provider'),
			A2(
				$elm$core$List$map,
				function (elationProvider) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$Integration$Elation$Provider$All$id(elationProvider))),
						$author$project$Api$Provider$Integration$Elation$Provider$All$name(elationProvider));
				},
				elationProviders)));
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ade;
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$externalId(shared);
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$name(shared);
};
var $author$project$Pages$Admin$Elation$Providers$viewElationProviderMapping = F3(
	function (editingProviderMappings, elationProviders, elationProviderMapping) {
		var isEditingElationProviderMapping = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping),
			editingProviderMappings);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(6)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hint provider: '),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$name(elationProviderMapping))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(1)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[$author$project$Ui$Icon$textMuted]),
									17)
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Elation provider: ')
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(3)
								]),
							_List_fromArray(
								[
									function () {
									if (isEditingElationProviderMapping) {
										return A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId(elationProviderMapping)),
													$author$project$Ui$Form$Select$onChange(
													$author$project$Pages$Admin$Elation$Providers$UpdateProviderMapping(elationProviderMapping))
												]),
											$author$project$Pages$Admin$Elation$Providers$elationProvidersOptions(elationProviders));
									} else {
										var elationProvider = A2(
											$elm_community$list_extra$List$Extra$find,
											function (elationProvider_) {
												return _Utils_eq(
													$elm$core$Maybe$Just(
														$elm$core$String$fromInt(
															$author$project$Api$Provider$Integration$Elation$Provider$All$id(elationProvider_))),
													$author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId(elationProviderMapping));
											},
											elationProviders);
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$bold]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'Not linked',
																A2($elm$core$Maybe$map, $author$project$Api$Provider$Integration$Elation$Provider$All$name, elationProvider)))
														])),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Edit provider mapping'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$Elation$Providers$EditElationProviderMapping(elationProviderMapping)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]));
									}
								}()
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Admin$Elation$Providers$viewProvidersListSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	A2(
		$elm$core$List$repeat,
		10,
		A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$rowItemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Hint Provider: ')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8),
											$author$project$Ui$Skeleton$spanMd(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(2)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Elation provider: ')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))));
var $author$project$Pages$Admin$Elation$Providers$viewProvidersStepSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(9),
							$author$project$Ui$FlexGrid$spanMd(8),
							$author$project$Ui$FlexGrid$spanSm(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Link Providers')
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Link providers in Hint with their records in Elation Health.')
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(3),
							$author$project$Ui$FlexGrid$spanMd(4),
							$author$project$Ui$FlexGrid$spanSm(5),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Refresh Elation Providers')
								]))
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			$author$project$Pages$Admin$Elation$Providers$viewProvidersListSkeleton
		]));
var $author$project$Pages$Admin$Elation$Providers$viewProvidersStep = function (model) {
	var _v0 = _Utils_Tuple2(model.l_, model.lZ);
	if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
		var _v1 = _v0.a;
		var elationProviders = _v1.a;
		var _v2 = _v0.b;
		var elationProviderMappings = _v2.a;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(9),
									$author$project$Ui$FlexGrid$spanMd(8),
									$author$project$Ui$FlexGrid$spanSm(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Link Providers')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Link providers in Hint with their records in Elation Health. '),
											$elm$html$Html$text('A patient is required to have a linked provider assigned in Hint for a new chart to be created in Elation. '),
											$elm$html$Html$text('If a patient does not have a linked provider assigned in Hint, they will not sync to elation.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(3),
									$author$project$Ui$FlexGrid$spanMd(4),
									$author$project$Ui$FlexGrid$spanSm(5),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Refresh Elation Providers'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Pages$Admin$Elation$Providers$RefreshElationProviders),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Refresh Elation Providers')
										]))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						A2($author$project$Pages$Admin$Elation$Providers$viewElationProviderMapping, model.ix, elationProviders),
						elationProviderMappings))
				]));
	} else {
		return $author$project$Pages$Admin$Elation$Providers$viewProvidersStepSkeleton;
	}
};
var $author$project$Pages$Admin$Elation$Providers$viewProvidersStepFooter = A2(
	$author$project$Ui$Panel$footer,
	_List_fromArray(
		[$author$project$Ui$Element$justifyCenter]),
	_List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Go to next step'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Pages$Admin$Elation$Providers$CompleteProviders),
					$author$project$Ui$Button$primary
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Next')
				]))
		]));
var $author$project$Pages$Admin$Elation$Providers$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Elation$Providers$StepHeaderMsg,
				$author$project$Components$Admin$Elation$StepHeader$modal(model.ki)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Elation$Providers$CompleteProviders)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Image$view,
										model.qT,
										{I1: 'ElationEMR Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										7)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										var _v0 = model.iA;
										if (_v0.$ === 1) {
											return $author$project$Components$Admin$Elation$StepHeader$skeleton;
										} else {
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Elation$Providers$StepHeaderMsg,
												A2($author$project$Components$Admin$Elation$StepHeader$view, model.iA, model.ki));
										}
									}(),
										$author$project$Pages$Admin$Elation$Providers$viewProvidersStep(model)
									])),
								$author$project$Pages$Admin$Elation$Providers$viewProvidersStepFooter
							]))
					]))
			]),
		$G: 'Integrations | Elation Health'
	};
};
var $author$project$Pages$Admin$Elation$Providers$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Elation$Providers$init, aer: $author$project$Pages$Admin$Elation$Providers$load, agD: $author$project$Pages$Admin$Elation$Providers$save, ahd: $author$project$Pages$Admin$Elation$Providers$subscriptions, aaq: $author$project$Pages$Admin$Elation$Providers$update, ahP: $author$project$Pages$Admin$Elation$Providers$view});
var $author$project$Pages$Admin$Elation$Top$GotElation = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Elation$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{D5: shared.D5, iA: $author$project$Api$Data$Loading, qT: shared.qT},
			A2($author$project$Api$Provider$Integration$Elation$retrieve, shared.D5, $elm$core$Basics$identity));
	});
var $author$project$Pages$Admin$Elation$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Elation$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Elation$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Elation$Top$update = F2(
	function (msg, model) {
		var response = msg;
		_v1$2:
		while (true) {
			switch (response.$) {
				case 3:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iA: response}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Elation__Overview),
						_List_Nil);
				case 2:
					if (response.a.$ === 5) {
						var _v2 = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{iA: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						break _v1$2;
					}
				default:
					break _v1$2;
			}
		}
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{iA: response}),
			$elm$core$Platform$Cmd$none,
			$author$project$OutMsg$handleErrorResponse(response));
	});
var $author$project$Pages$Admin$Elation$Top$viewConfigureInfo = A2(
	$author$project$Ui$Typography$p,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('To configure this integration, contact the Elation Integrations team  at '),
			A3(
			$author$project$Ui$Link$mailto,
			'integrations@elationhealth.com',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('integrations@elationhealth.com')
				])),
			$elm$html$Html$text(' and request an Elation-HintOS API integration.')
		]));
var $author$project$Pages$Admin$Elation$Top$viewStatus = F2(
	function (status, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($author$project$Ui$Badge$fromString, _List_Nil, status),
						content))
				]));
	});
var $author$project$Pages$Admin$Elation$Top$viewInitialStep = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			A2($author$project$Pages$Admin$Elation$Top$viewStatus, 'inactive', _List_Nil),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Admin__Elation__Link,
					_List_fromArray(
						[$author$project$Ui$Link$buttonPrimary]),
					_List_fromArray(
						[
							$elm$html$Html$text('Enable Elation Integration')
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('About'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://www.elationhealth.com/',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('Elation')
										])),
									$elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, '),
									$elm$html$Html$text('and act upon relevant clinical information to care for your patients. ')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Our integration with Elation will automatically create and synchronize patient contact, '),
									$elm$html$Html$text('demographic and membership information between Hint and Elation.')
								])),
							$author$project$Pages$Admin$Elation$Top$viewConfigureInfo,
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Hint provides this integration only as a convenience to you. '),
									$elm$html$Html$text('Elation is solely responsible for its service, content and policies, '),
									$elm$html$Html$text('including those related to privacy and security. '),
									$elm$html$Html$text('Please review Elation\'s Terms of Service and Privacy Policy '),
									$elm$html$Html$text('to ensure they meet your business and legal requirements.')
								]))
						]))
				]))
		]));
var $author$project$Pages$Admin$Elation$Top$viewInitialStepSkeleton = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('inactive')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Enable Elation Integration')
						]))
				])),
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSkeleton('About'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(8)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(7)
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(8)
								]))
						]))
				]))
		]));
var $author$project$Pages$Admin$Elation$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Image$view,
										model.qT,
										{I1: 'ElationEMR Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										7)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v0 = model.iA;
									if (_v0.$ === 1) {
										return _List_fromArray(
											[$author$project$Pages$Admin$Elation$Top$viewInitialStepSkeleton]);
									} else {
										return _List_fromArray(
											[$author$project$Pages$Admin$Elation$Top$viewInitialStep]);
									}
								}()),
								$author$project$Ui$Panel$none
							]))
					]))
			]),
		$G: 'Integrations | Elation Health'
	};
};
var $author$project$Pages$Admin$Elation$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Elation$Top$init, aer: $author$project$Pages$Admin$Elation$Top$load, agD: $author$project$Pages$Admin$Elation$Top$save, ahd: $author$project$Pages$Admin$Elation$Top$subscriptions, aaq: $author$project$Pages$Admin$Elation$Top$update, ahP: $author$project$Pages$Admin$Elation$Top$view});
var $author$project$Pages$Admin$ElationLegacy$GotElation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Elation$One$Elation = $elm$core$Basics$identity;
var $author$project$Api$Provider$Elation$One$Record = F3(
	function (status, userName, isSyncing) {
		return {Sb: isSyncing, ag7: status, ahN: userName};
	});
var $author$project$Api$Provider$Elation$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_syncing',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'username',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Elation$One$Record))));
var $author$project$Api$Provider$Elation$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Elation$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Elation$elationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['elation']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Elation$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Elation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath));
	});
var $author$project$Pages$Admin$ElationLegacy$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{D5: shared.D5, fu: false, fB: $author$project$Api$Data$Loading, PB: $elm$core$Maybe$Nothing, qT: shared.qT, oG: $author$project$Api$Data$NotAsked},
			A2($author$project$Api$Provider$Elation$retrieve, shared.D5, $author$project$Pages$Admin$ElationLegacy$GotElation));
	});
var $author$project$Pages$Admin$ElationLegacy$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ElationLegacy$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ElationLegacy$HiConfirmClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$subscriptions = function (_v0) {
	var disabling = _v0.fu;
	return disabling ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$ElationLegacy$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$ElationLegacy$Disabled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$Synced = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Elation$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'elation',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'username',
								$elm$json$Json$Encode$string(fields.ahN)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(fields.afC))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Elation$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath)));
	});
var $author$project$Pages$Admin$ElationLegacy$createElation = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$Elation$create, apiClient, fields, $author$project$Pages$Admin$ElationLegacy$Created);
	});
var $author$project$Api$Provider$Elation$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Provider$Elation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath));
	});
var $author$project$Api$Provider$Elation$One$userName = function (_v0) {
	var record = _v0;
	return record.ahN;
};
var $author$project$Pages$Admin$ElationLegacy$formFieldsInit = function (elation) {
	return {
		afC: '',
		ahN: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Elation$One$userName(elation))
	};
};
var $author$project$Pages$Admin$ElationLegacy$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{ahN: string});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{afC: string});
		}
	});
var $author$project$Pages$Admin$ElationLegacy$PasswordValidation = 1;
var $author$project$Pages$Admin$ElationLegacy$UserNameValidation = 0;
var $author$project$Pages$Admin$ElationLegacy$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.ahN;
			},
			_Utils_Tuple2(0, 'Please enter an api key')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.afC;
			},
			_Utils_Tuple2(1, 'Please enter a password'))
		]));
var $author$project$Pages$Admin$ElationLegacy$Poll = {$: 1};
var $author$project$Api$Provider$Elation$One$isSyncing = function (_v0) {
	var record = _v0;
	return record.Sb;
};
var $author$project$Pages$Admin$ElationLegacy$poll = function (elation) {
	return $author$project$Api$Provider$Elation$One$isSyncing(elation) ? A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Pages$Admin$ElationLegacy$Poll;
		},
		$elm$core$Process$sleep(2000)) : $elm$core$Platform$Cmd$none;
};
var $author$project$Api$Provider$Elation$One$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Elation$sync = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Elation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync']),
					$author$project$Api$Provider$Elation$elationPath)));
	});
var $author$project$Pages$Admin$ElationLegacy$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var elation = response.a;
					var form = ($author$project$Api$Provider$Elation$One$status(elation) === 'disabled') ? $elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Utils$Form$init(
								$author$project$Pages$Admin$ElationLegacy$formFieldsInit(elation)),
							$author$project$Api$Data$NotAsked)) : $elm$core$Maybe$Nothing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fB: response, PB: form}),
						$author$project$Pages$Admin$ElationLegacy$poll(elation),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Elation$retrieve, model.D5, $author$project$Pages$Admin$ElationLegacy$GotElation),
					_List_Nil);
			case 2:
				var field = msg.a;
				var _v2 = model.PB;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var form = _v3.a;
					var saveRequest = _v3.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$ElationLegacy$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, saveRequest))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v4 = model.PB;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var form = _v5.a;
					var saveRequest = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$ElationLegacy$formFieldsValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var newForm = _v7.a;
						var validFormFields = _v7.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
								}),
							A2($author$project$Pages$Admin$ElationLegacy$createElation, model.D5, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v6.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, saveRequest))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fB: response, PB: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation credentials have been saved.')
							]));
				} else {
					var _v9 = model.PB;
					if (!_v9.$) {
						var _v10 = _v9.a;
						var form = _v10.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oG: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Elation$sync, model.D5, $author$project$Pages$Admin$ElationLegacy$Synced),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var elation = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oG: $author$project$Api$Data$NotAsked}),
						$author$project$Pages$Admin$ElationLegacy$poll(elation),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oG: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fu: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Elation$delete, model.D5, $author$project$Pages$Admin$ElationLegacy$Disabled),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{fu: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var elation = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fu: false,
								fB: response,
								PB: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$Form$init(
											$author$project$Pages$Admin$ElationLegacy$formFieldsInit(elation)),
										$author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been disabled.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fu: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Ui$Image$ElationEMRLogo = 1;
var $author$project$Pages$Admin$ElationLegacy$Save = {$: 3};
var $author$project$Pages$Admin$ElationLegacy$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$Password = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$UserName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$ElationLegacy$viewDisabledBody = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Elation API Key'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.ahN),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ElationLegacy$FormUpdated, $author$project$Pages$Admin$ElationLegacy$UserName)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Password'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$PasswordInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$PasswordInput$value(fields.afC),
							$author$project$Ui$Form$PasswordInput$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ElationLegacy$FormUpdated, $author$project$Pages$Admin$ElationLegacy$Password)),
							$author$project$Ui$Form$PasswordInput$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Ui$Form$PasswordInput$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://www.elationemr.com',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('Elation')
										])),
									$elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, and act upon relevant clinical information to care for your patients.')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Our integration with Elation will automatically create and synchronize patient demographic, membership, and insurance information created here with Elation.'),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('To configure this integration, contact the Elation team and ask for your Elation API Key & Password.')
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We provide this integration only as a convenience to you. Elation is solely responsible for its service, content and policies, including those related to privacy and security. Please review Elation\'s Terms of Service, and Privacy Policy to ensure they meet your business and legal requirements.')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$ElationLegacy$viewDisabledFooter = function (saveRequest) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Edit and enable'},
				_List_fromArray(
					[
						$author$project$Ui$Button$submit,
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Save & Enable')
					]))
			]));
};
var $author$project$Pages$Admin$ElationLegacy$Disable = {$: 7};
var $author$project$Pages$Admin$ElationLegacy$Sync = {$: 5};
var $author$project$Pages$Admin$ElationLegacy$viewEnabledBody = F2(
	function (model, elation) {
		var status = ($author$project$Api$Provider$Elation$One$status(elation) === 'enabled') ? 'connected' : $author$project$Api$Provider$Elation$One$status(elation);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Badge$fromString, _List_Nil, status)
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('To stop syncing or change your credentials please '),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Disable integration'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$ElationLegacy$Disable),
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('disable this integration.')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Elation API Key'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Elation$One$userName(elation)))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Password'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('************')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Failures'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__Top,
								_List_fromArray(
									[
										$author$project$Ui$Link$routeParams(
										_List_fromArray(
											[
												A2($elm$url$Url$Builder$string, 'filter', 'with_failed_sync')
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('See failed records here.')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Push to Elation'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Push out of sync records'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.oG, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Pages$Admin$ElationLegacy$Sync)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Push out of sync records')
							]))
					]))
			]);
	});
var $author$project$Pages$Admin$ElationLegacy$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				model.fu ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Admin$ElationLegacy$HiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('disable'),
						$author$project$Components$HiConfirm$noun('elation integration')
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$ElationLegacy$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Image$view,
										model.qT,
										{I1: 'ElationEMR Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										1)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v0 = model.fB;
									if (_v0.$ === 3) {
										var elation = _v0.a;
										var _v1 = model.PB;
										if (!_v1.$) {
											var _v2 = _v1.a;
											var form = _v2.a;
											return $author$project$Pages$Admin$ElationLegacy$viewDisabledBody(form);
										} else {
											return A2($author$project$Pages$Admin$ElationLegacy$viewEnabledBody, model, elation);
										}
									} else {
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]))
											]);
									}
								}()),
								function () {
								var _v3 = model.fB;
								if (_v3.$ === 3) {
									var _v4 = model.PB;
									if (!_v4.$) {
										var _v5 = _v4.a;
										var saveRequest = _v5.b;
										return A2(
											$author$project$Ui$Panel$footer,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Pages$Admin$ElationLegacy$viewDisabledFooter(saveRequest)
												]));
									} else {
										return $author$project$Ui$Panel$none;
									}
								} else {
									return $author$project$Ui$Panel$none;
								}
							}()
							]))
					]))
			]),
		$G: 'Integrations | Elation Health'
	};
};
var $author$project$Pages$Admin$ElationLegacy$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$ElationLegacy$init, aer: $author$project$Pages$Admin$ElationLegacy$load, agD: $author$project$Pages$Admin$ElationLegacy$save, ahd: $author$project$Pages$Admin$ElationLegacy$subscriptions, aaq: $author$project$Pages$Admin$ElationLegacy$update, ahP: $author$project$Pages$Admin$ElationLegacy$view});
var $author$project$Pages$Admin$Features$BetaFeaturesMsg = $elm$core$Basics$identity;
var $author$project$Components$Hinter$BetaFeatures$Practice = 0;
var $author$project$Components$Hinter$BetaFeatures$GotFeatures = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$BetaFeatures$Model = $elm$core$Basics$identity;
var $author$project$Components$Hinter$BetaFeatures$basePath = function (owner) {
	return $author$project$Api$Data$providerPath;
};
var $author$project$Api$Common$Feature$Shared$Feature = $elm$core$Basics$identity;
var $author$project$Api$Common$Feature$Shared$Record = F3(
	function (id, name, enabled) {
		return {Ot: enabled, adR: id, zh: name};
	});
var $author$project$Api$Common$Feature$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'enabled',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Feature$Shared$Record))));
var $author$project$Api$Common$Feature$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Feature$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Feature$featuresPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['features']),
		basePath);
};
var $author$project$Api$Common$Feature$list = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Feature$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Common$Feature$featuresPath(basePath)));
	});
var $author$project$Components$Hinter$BetaFeatures$init = F2(
	function (apiClient, owner) {
		return _Utils_Tuple2(
			{Pd: $author$project$Api$Data$Loading, Vp: owner},
			A3(
				$author$project$Api$Common$Feature$list,
				$author$project$Components$Hinter$BetaFeatures$basePath(owner),
				apiClient,
				$author$project$Components$Hinter$BetaFeatures$GotFeatures));
	});
var $author$project$Pages$Admin$Features$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var _v4 = A2($author$project$Components$Hinter$BetaFeatures$init, apiClient, 0);
		var betaFeatures = _v4.a;
		var betaFeaturesCmd = _v4.b;
		return _Utils_Tuple2(
			{D5: apiClient, la: betaFeatures},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, betaFeaturesCmd));
	});
var $author$project$Pages$Admin$Features$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Features$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Hinter$BetaFeatures$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Features$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Hinter$BetaFeatures$subscriptions(model.la));
};
var $author$project$Components$Hinter$BetaFeatures$GotEnableResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$Feature$enable = F5(
	function (basePath, apiClient, featureId, enabledStatus, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'feature',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(featureId)),
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(enabledStatus))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Common$Feature$Shared$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[featureId]),
						$author$project$Api$Common$Feature$featuresPath(basePath)))));
	});
var $author$project$Api$Common$Feature$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ot;
};
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$Api$Common$Feature$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Hinter$BetaFeatures$replaceUpdated = F2(
	function (newFeature, feature) {
		return _Utils_eq(
			$author$project$Api$Common$Feature$Shared$id(feature),
			$author$project$Api$Common$Feature$Shared$id(newFeature)) ? newFeature : feature;
	});
var $author$project$Components$Hinter$BetaFeatures$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var id = msg.a;
				var enabled = msg.b;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$Common$Feature$enable,
						$author$project$Components$Hinter$BetaFeatures$basePath(model.Vp),
						apiClient,
						id,
						enabled,
						$author$project$Components$Hinter$BetaFeatures$GotEnableResponse),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var feature = response.a;
					var newFeatures = A2(
						$author$project$Api$Data$map,
						$elm$core$List$map(
							$author$project$Components$Hinter$BetaFeatures$replaceUpdated(feature)),
						model.Pd);
					var newModel = _Utils_update(
						model,
						{Pd: newFeatures});
					var message = $author$project$Api$Common$Feature$Shared$enabled(feature) ? 'Feature enabled!' : 'Feature disabled!';
					return _Utils_Tuple3(
						newModel,
						$elm$browser$Browser$Navigation$reload,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, message),
								function () {
								var _v3 = model.Vp;
								return $author$project$OutMsg$RefreshPractice;
							}()
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Pd: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Pages$Admin$Features$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Hinter$BetaFeatures$update, model.D5, subMsg, model.la);
		var betaFeatures = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{la: betaFeatures}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Components$Hinter$BetaFeatures$ChangeFeature = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Common$Feature$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$Hinter$BetaFeatures$viewFeature = function (feature) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Common$Feature$Shared$name(feature))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(
										$author$project$Api$Common$Feature$Shared$enabled(feature)),
										$author$project$Ui$ToggleSwitch$onChange(
										$author$project$Components$Hinter$BetaFeatures$ChangeFeature(
											$author$project$Api$Common$Feature$Shared$id(feature)))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Hinter$BetaFeatures$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Beta Features')
							]))
					])),
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$loading(
						!$author$project$Api$Data$isSuccess(model.Pd))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Enabled')
							]))
					]),
				function () {
					var _v1 = model.Pd;
					if (_v1.$ === 3) {
						var features = _v1.a;
						return A2($elm$core$List$map, $author$project$Components$Hinter$BetaFeatures$viewFeature, features);
					} else {
						return _List_Nil;
					}
				}(),
				_List_Nil)
			]));
};
var $author$project$Pages$Admin$Features$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Hinter$BetaFeatures$view(model.la))
			]),
		$G: 'Admin | Beta Features'
	};
};
var $author$project$Pages$Admin$Features$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Features$init, aer: $author$project$Pages$Admin$Features$load, agD: $author$project$Pages$Admin$Features$save, ahd: $author$project$Pages$Admin$Features$subscriptions, aaq: $author$project$Pages$Admin$Features$update, ahP: $author$project$Pages$Admin$Features$view});
var $author$project$Pages$Admin$HipaaAuthorizations$None = {$: 0};
var $author$project$Pages$Admin$HipaaAuthorizations$GotPatients = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Patient$WithoutHipaaAuthorization = {$: 5};
var $author$project$Api$Provider$Patient$All$Patient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$Shared$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$Shared$Record = function (id) {
	return function (age) {
		return function (archived) {
			return function (autopay) {
				return function (chosenFirstName) {
					return function (chosenLastName) {
						return function (chosenMiddleName) {
							return function (chosenTitle) {
								return function (chosenSuffix) {
									return function (dob) {
										return function (email) {
											return function (firstName) {
												return function (gender) {
													return function (genderIdentity) {
														return function (genderOther) {
															return function (hipaaAuthorizationAccepted) {
																return function (hipaaAuthorizationAcceptedAt) {
																	return function (joinedPracticeDate) {
																		return function (lastName) {
																			return function (leadSourceOther) {
																				return function (membershipStatus) {
																					return function (middleName) {
																						return function (name) {
																							return function (phones) {
																								return function (pronoun) {
																									return function (sex) {
																										return function (syncToEmr) {
																											return function (usesTobacco) {
																												return function (engagementStatus) {
																													return {IK: age, Jn: archived, JI: autopay, KX: chosenFirstName, KY: chosenLastName, KZ: chosenMiddleName, K_: chosenSuffix, K$: chosenTitle, acQ: dob, Oo: email, OB: engagementStatus, Pu: firstName, PO: gender, PP: genderIdentity, PQ: genderOther, Qy: hipaaAuthorizationAccepted, Qz: hipaaAuthorizationAcceptedAt, adR: id, Sq: joinedPracticeDate, SA: lastName, SJ: leadSourceOther, TL: membershipStatus, TX: middleName, zh: name, Wi: phones, Xh: pronoun, ZH: sex, $j: syncToEmr, aaI: usesTobacco};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Patient$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'engagement_status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'uses_tobacco',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sync_to_emr',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sex',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pronoun',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$author$project$Api$Expandable$expandable,
						'phones',
						$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'middle_name',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'membership_status',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'lead_source_other',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'joined_practice_date',
												$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'hipaa_authorization_accepted_at',
													$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'hipaa_authorization_accepted',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'gender_other',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'gender_identity',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'gender',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'first_name',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'email',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'dob',
																				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'chosen_suffix',
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'chosen_title',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'chosen_middle_name',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'chosen_last_name',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'chosen_first_name',
																									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'autopay',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'archived',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'age',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'id',
																													$elm$json$Json$Decode$string,
																													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Shared$Record))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Patient$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$All$Record = function (sponsorName) {
	return function (flaggedNotesCount) {
		return function (isMaster) {
			return function (isSynced) {
				return function (isAffiliated) {
					return function (affiliateSyncStatus) {
						return function (networkSyncStatus) {
							return function (practitioner) {
								return function (location) {
									return function (membershipPatients) {
										return function (membershipThrough) {
											return {II: affiliateSyncStatus, Py: flaggedNotesCount, Rw: isAffiliated, RQ: isMaster, Sa: isSynced, aet: location, TF: membershipPatients, TM: membershipThrough, Ut: networkSyncStatus, afS: practitioner, _y: sponsorName};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$Record = F4(
	function (status, startDate, membership, plan) {
		return {ja: membership, GH: plan, _E: startDate, ag7: status};
	});
var $author$project$Api$Provider$Membership$Min$Membership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Min$Record = F3(
	function (id, status, isPrimary) {
		return {adR: id, aeg: isPrimary, ag7: status};
	});
var $author$project$Api$Provider$Membership$Min$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'is_primary',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Min$Record))));
var $author$project$Api$Provider$Membership$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership',
		$author$project$Api$Provider$Membership$Min$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_date',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientAll$Record)))));
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$ForPatientAll$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$Min$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$Min$Record = F5(
	function (id, name, email, dob, age) {
		return {IK: age, acQ: dob, Oo: email, adR: id, zh: name};
	});
var $author$project$Api$Provider$Patient$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'age',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dob',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Min$Record))))));
var $author$project$Api$Provider$Patient$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$SyncStatus$Failed = 3;
var $author$project$Api$Provider$Patient$SyncStatus$Inactive = 0;
var $author$project$Api$Provider$Patient$SyncStatus$Pending = 1;
var $author$project$Api$Provider$Patient$SyncStatus$Synced = 2;
var $author$project$Api$Provider$Patient$SyncStatus$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'inactive':
				return $elm$json$Json$Decode$succeed(0);
			case 'pending':
				return $elm$json$Json$Decode$succeed(1);
			case 'synced':
				return $elm$json$Json$Decode$succeed(2);
			case 'failed':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unexpected sync status ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Practitioner$Min$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practitioner$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Practitioner$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Min$Record)));
var $author$project$Api$Provider$Practitioner$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_through',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_patients',
		$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForPatientAll$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'location',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practitioner',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'network_sync_status',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'affiliate_sync_status',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_affiliated',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_synced',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_master',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'flagged_notes_count',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'sponsor_name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$All$Record))))))))))));
var $author$project$Api$Provider$Patient$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$All$Patient)));
var $author$project$Api$Provider$Patient$filterToString = function (filter) {
	switch (filter.$) {
		case 0:
			switch (filter.a) {
				case 0:
					var _v1 = filter.a;
					return 'current_membership';
				case 2:
					var _v2 = filter.a;
					return 'future_membership';
				case 3:
					var _v3 = filter.a;
					return 'with_unconfirmed_membership';
				case 1:
					var _v4 = filter.a;
					return 'inactive';
				default:
					var _v5 = filter.a;
					return 'archived';
			}
		case 1:
			if (filter.a) {
				return 'with_autopay';
			} else {
				return 'without_autopay';
			}
		case 2:
			return 'active_membership';
		case 3:
			return 'past_due_customer_invoices';
		case 4:
			return 'account_owner_without_payment_info';
		case 5:
			return 'without_hipaa_authorization';
		case 6:
			return 'without_email';
		case 7:
			return 'with_flagged_notes';
		case 8:
			return 'with_failed_integrations';
		case 9:
			return 'with_unsynced_integrations';
		case 10:
			return 'new_activations_since_date';
		case 11:
			return 'new_terminations_since_date';
		case 12:
			return 'with_upcoming_birthday';
		case 13:
			switch (filter.a) {
				case 0:
					var _v6 = filter.a;
					return 'currently_engaged';
				case 1:
					var _v7 = filter.a;
					return 'previously_engaged';
				default:
					var _v8 = filter.a;
					return 'never_engaged';
			}
		case 14:
			return 'with_bounced_emails';
		default:
			return 'with_unsubscribed_emails';
	}
};
var $author$project$Api$Provider$Patient$listDefaults = {IJ: $elm$core$Maybe$Nothing, ab9: $elm$core$Maybe$Nothing, Fi: _List_Nil, adR: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, rj: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, GH: $elm$core$Maybe$Nothing, afS: $elm$core$Maybe$Nothing, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Patient$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Patient$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Fi;
				if (!_v0.b) {
					return _List_Nil;
				} else {
					var filters = _v0;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							A2(
								$elm$core$String$join,
								',',
								A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters)))
						]);
				}
			}(),
				function () {
				var _v1 = options.af_;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.adR;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.ab9;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'company', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.GH;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'plan', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.rj;
				if (!_v5.$) {
					var string = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location_group', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.aet;
				if (!_v6.$) {
					var string = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v7 = options.afS;
				if (!_v7.$) {
					var string = _v7.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				function () {
				var _v8 = options.IJ;
				if (!_v8.$) {
					var string = _v8.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'affiliation', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Patient$patientsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patients']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Patient$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Patient$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Patient$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath)));
	});
var $author$project$Pages$Admin$HipaaAuthorizations$fetchPatients = function (model) {
	return A3(
		$author$project$Api$Provider$Patient$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					Fi: _List_fromArray(
						[$author$project$Api$Provider$Patient$WithoutHipaaAuthorization]),
					afy: model.afy
				});
		},
		$author$project$Pages$Admin$HipaaAuthorizations$GotPatients);
};
var $author$project$Pages$Admin$HipaaAuthorizations$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var model = {aT: $author$project$Pages$Admin$HipaaAuthorizations$None, D5: apiClient, rC: 0, afy: $author$project$Api$Pagination$init, Ap: $author$project$Api$Data$Loading, nz: false};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model));
	});
var $author$project$Pages$Admin$HipaaAuthorizations$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$HipaaAuthorizations$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed = {$: 4};
var $author$project$Pages$Admin$HipaaAuthorizations$subscriptions = function (_v0) {
	var acceptingFor = _v0.aT;
	if (!acceptingFor.$) {
		return $elm$core$Platform$Sub$none;
	} else {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed);
	}
};
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForAll = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForOne = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Admin$HipaaAuthorizations$All = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$HipaaAuthorizations$One = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$One$Patient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$One$Record = function (requestPayInfoSentAt) {
	return function (requestPendingDocumentsAcceptanceSentAt) {
		return function (location) {
			return function (practitioner) {
				return function (company) {
					return function (companyAccounts) {
						return function (payer) {
							return function (payees) {
								return function (age) {
									return function (membershipThrough) {
										return function (flaggedNotesCount) {
											return function (isMaster) {
												return function (isSynced) {
													return function (isAffiliated) {
														return function (syncedRecordId) {
															return function (network) {
																return function (masterRecordId) {
																	return function (affiliate) {
																		return function (affiliateSyncStatus) {
																			return function (networkSyncStatus) {
																				return function (overdueAmountInCents) {
																					return function (title) {
																						return function (stripeLink) {
																							return function (phones) {
																								return function (usesBillingAddress) {
																									return function (address) {
																										return function (billingAddress) {
																											return function (ssn) {
																												return function (knownPractice) {
																													return function (dpcPatient) {
																														return function (assignedAffiliation) {
																															return function (preferredLanguage) {
																																return function (leadSource) {
																																	return function (accountAccessSentAt) {
																																		return function (lastPortalAccessedAt) {
																																			return function (mergedInto) {
																																				return function (healthInsurance) {
																																					return function (companyRegistrations) {
																																						return function (owedInCents) {
																																							return function (creditInCents) {
																																								return function (creditExpiresSoon) {
																																									return function (defaultSource) {
																																										return function (sourcesCount) {
																																											return function (integrations) {
																																												return function (customForms) {
																																													return function (hasPaymentMethod) {
																																														return function (profilePictureUrl) {
																																															return function (createdAt) {
																																																return function (suffix) {
																																																	return function (emergencyContact) {
																																																		return function (exemptFromCreditCardFees) {
																																																			return function (shouldChargeCreditCardFees) {
																																																				return {H4: accountAccessSentAt, It: address, DZ: affiliate, II: affiliateSyncStatus, IK: age, Jp: assignedAffiliation, JZ: billingAddress, ab9: company, Lt: companyAccounts, Lz: companyRegistrations, Mf: createdAt, Mk: creditExpiresSoon, Ml: creditInCents, MC: customForms, Nl: defaultSource, N$: dpcPatient, Oq: emergencyContact, OS: exemptFromCreditCardFees, Py: flaggedNotesCount, Qc: hasPaymentMethod, Qj: healthInsurance, Ra: integrations, Rw: isAffiliated, RQ: isMaster, Sa: isSynced, Ss: knownPractice, SC: lastPortalAccessedAt, SH: leadSource, aet: location, To: masterRecordId, TM: membershipThrough, TT: mergedInto, Uo: network, Ut: networkSyncStatus, Vm: overdueAmountInCents, Vo: owedInCents, VU: payees, GD: payer, Wi: phones, afS: practitioner, WV: preferredLanguage, Xg: profilePictureUrl, Yh: requestPayInfoSentAt, Yi: requestPendingDocumentsAcceptanceSentAt, ZQ: shouldChargeCreditCardFees, _l: sourcesCount, _C: ssn, _X: stripeLink, _8: suffix, $m: syncedRecordId, $G: title, aaC: usesBillingAddress};
																																																			};
																																																		};
																																																	};
																																																};
																																															};
																																														};
																																													};
																																												};
																																											};
																																										};
																																									};
																																								};
																																							};
																																						};
																																					};
																																				};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Patient$One$BankAccount_ = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Patient$One$bankAccountDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BankAccount$One$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$BankAccount_));
var $author$project$Api$Provider$Patient$One$Card_ = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Patient$One$cardDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Card$One$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Card_));
var $author$project$Api$Common$EmergencyContact$Shared$EmergencyContact = $elm$core$Basics$identity;
var $author$project$Api$Common$EmergencyContact$Shared$Record = F7(
	function (id, name, firstName, lastName, relationship, email, phone) {
		return {Oo: email, Pu: firstName, adR: id, SA: lastName, zh: name, Wg: phone, X6: relationship};
	});
var $author$project$Api$Common$EmergencyContact$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'phone',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'relationship',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'last_name',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'first_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Common$EmergencyContact$Shared$Record))))))));
var $author$project$Api$Common$EmergencyContact$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$EmergencyContact$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$SocialSecurityNumber$Masked$SocialSecurityNumber = $elm$core$Basics$identity;
var $author$project$Api$Common$SocialSecurityNumber$Masked$MaskedRecord = function (maskedNumber) {
	return {Tn: maskedNumber};
};
var $author$project$Api$Common$SocialSecurityNumber$Masked$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'masked_number',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$SocialSecurityNumber$Masked$MaskedRecord));
var $author$project$Api$Common$SocialSecurityNumber$Masked$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$SocialSecurityNumber$Masked$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$Min$Company = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$Min$Record = F3(
	function (id, name, companyType) {
		return {LA: companyType, adR: id, zh: name};
	});
var $author$project$Api$Company$CompanyType$Child = 1;
var $author$project$Api$Company$CompanyType$Network = 0;
var $author$project$Api$Company$CompanyType$Parent = 2;
var $author$project$Api$Company$CompanyType$Standalone = 3;
var $author$project$Api$Company$CompanyType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'network':
				return $elm$json$Json$Decode$succeed(0);
			case 'child':
				return $elm$json$Json$Decode$succeed(1);
			case 'parent':
				return $elm$json$Json$Decode$succeed(2);
			case 'standalone':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var somethingElse = string;
				return $elm$json$Json$Decode$fail('Unknown Company -> company_type: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Company$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company_type',
	$author$project$Api$Company$CompanyType$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$Min$Record))));
var $author$project$Api$Provider$Company$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAccount$ForPatient$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAccount$Shared$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAccount$Min$CompanyAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyAccount$Min$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$CompanyAccount$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Min$Record));
var $author$project$Api$Provider$CompanyAccount$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAccount$Shared$Record = F5(
	function (isEligible, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, needsApproval) {
		return {Ok: eligibilityEndDate, Ol: eligibilityStartDate, RK: isEligible, Um: needsApproval, ahp: terminationRequestedAt};
	});
var $author$project$Api$Provider$CompanyAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'needs_approval',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligibility_end_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eligibility_start_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'termination_requested_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_eligible',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Shared$Record))))));
var $author$project$Api$Provider$CompanyAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAccount$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Shared$CompanyAccount)));
var $author$project$Api$Provider$CompanyAccount$ForPatient$Record = F3(
	function (company, subscriber, companyRegistrations) {
		return {ab9: company, Lz: companyRegistrations, _3: subscriber};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$Shared$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyRegistration$Shared$Record = F8(
	function (id, type_, isSubscriber, externalId, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, membershipEndDate) {
		return {Ok: eligibilityEndDate, Ol: eligibilityStartDate, ade: externalId, adR: id, R8: isSubscriber, TE: membershipEndDate, ahp: terminationRequestedAt, ahI: type_};
	});
var $author$project$Api$Provider$CompanyRegistration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligibility_end_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eligibility_start_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'termination_requested_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'external_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_subscriber',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$Shared$Record)))))))));
var $author$project$Api$Provider$CompanyRegistration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$Record = F2(
	function (patient, isCurrentMember) {
		return {RE: isCurrentMember, VM: patient};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_current_member',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'patient',
		$author$project$Api$Provider$Patient$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$Record)));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$CompanyRegistration)));
var $author$project$Api$Provider$CompanyAccount$ForPatient$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company_registrations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'subscriber',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'company',
			$author$project$Api$Provider$Company$Min$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$ForPatient$Record))));
var $author$project$Api$Provider$CompanyAccount$ForPatient$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$ForPatient$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$ForPatient$CompanyAccount)));
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$Record = function (account) {
	return {H3: account};
};
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForPatientOne$Record));
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$ForPatientOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForPatientOne$CompanyRegistration)));
var $author$project$Api$Provider$FormResponse$One$FormResponse = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$FormResponse$Shared$FormResponse = $elm$core$Basics$identity;
var $author$project$Api$Provider$FormResponse$Shared$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$FormResponse$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$Shared$Record));
var $author$project$Api$Provider$FormResponse$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FormResponse$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FormResponse$One$Record = F2(
	function (form, formResponseItems) {
		return {PB: form, PD: formResponseItems};
	});
var $author$project$Api$Provider$FormResponseItem$Shared$FormResponseItem = $elm$core$Basics$identity;
var $author$project$Api$Provider$FormResponseItem$Shared$Record = F3(
	function (id, formItemId, answer) {
		return {Jf: answer, Fm: formItemId, adR: id};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Api$Provider$FormResponseItem$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'answer',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
		_List_fromArray(
			['form_item', 'id']),
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponseItem$Shared$Record))));
var $author$project$Api$Provider$FormResponseItem$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FormResponseItem$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FormResponse$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'form_response_items',
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($author$project$Api$Provider$FormResponseItem$Shared$decoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'form',
		$author$project$Api$Provider$Form$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$One$Record)));
var $author$project$Api$Provider$FormResponse$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FormResponse$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$FormResponse$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$One$FormResponse)));
var $author$project$Api$Provider$HealthInsurance$Shared$HealthInsurance = $elm$core$Basics$identity;
var $author$project$Api$Provider$HealthInsurance$Shared$Record = F5(
	function (memberId, groupId, payerName, highDeductible, carrier) {
		return {KJ: carrier, PY: groupId, Qq: highDeductible, Tz: memberId, VV: payerName};
	});
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$HealthInsuranceCarrier = $elm$core$Basics$identity;
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$Record = F4(
	function (id, collectGroupId, collectHighDeductible, collectMemberId) {
		return {La: collectGroupId, Lb: collectHighDeductible, Le: collectMemberId, adR: id};
	});
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_member_id',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'collect_high_deductible',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'collect_group_id',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$HealthInsuranceCarrier$Shared$Record)))));
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$HealthInsuranceCarrier$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$HealthInsurance$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carrier',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'high_deductible',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payer_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'group_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'member_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$HealthInsurance$Shared$Record))))));
var $author$project$Api$Provider$HealthInsurance$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$HealthInsurance$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$KnownPractice$Shared$KnownPractice = $elm$core$Basics$identity;
var $author$project$Api$Provider$KnownPractice$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$KnownPractice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$KnownPractice$Shared$Record)));
var $author$project$Api$Provider$KnownPractice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$KnownPractice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LeadSource$Shared$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Provider$LeadSource$Shared$SharedRecord = F4(
	function (id, name, showOnOnlineSignup, patientsCount) {
		return {adR: id, zh: name, VS: patientsCount, ZV: showOnOnlineSignup};
	});
var $author$project$Api$Provider$LeadSource$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patients_count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'show_on_online_signup',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$LeadSource$Shared$SharedRecord)))));
var $author$project$Api$Provider$LeadSource$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LeadSource$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Organization$Shared$Organization = $elm$core$Basics$identity;
var $author$project$Api$Provider$Organization$Min$Organization = $elm$core$Basics$identity;
var $author$project$Api$Provider$Organization$Min$Record = F3(
	function (type_, id, name) {
		return {adR: id, zh: name, ahI: type_};
	});
var $author$project$Api$Provider$Organization$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Api$OrganizationType$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Organization$Min$Record))));
var $author$project$Api$Provider$Organization$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Organization$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Organization$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Organization$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$DpcPatient$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$DpcPatient$Record = function (status) {
	return {ag7: status};
};
var $author$project$Api$Provider$Patient$DpcPatient$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$DpcPatient$Record));
var $author$project$Api$Provider$Patient$DpcPatient$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$DpcPatient$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practitioner$Shared$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practitioner$Shared$Record = function (id) {
	return function (name) {
		return function (isMaster) {
			return function (isSynced) {
				return function (onlineSignupVisibility) {
					return function (isProvider) {
						return function (acceptsEnrollmentsFromEmployer) {
							return function (acceptsEnrollmentsFromRetail) {
								return function (panelSize) {
									return function (panelSizeLimit) {
										return function (email) {
											return function (autoDetermineOnlineSignupVisibilityFromPanelSize) {
												return function (maxPatientAge) {
													return function (minPatientAge) {
														return function (education) {
															return function (syncedPatientsCount) {
																return function (elationPhysicianId) {
																	return function (bio) {
																		return function (photoUrl) {
																			return function (gender) {
																				return function (genderOther) {
																					return function (npi) {
																						return function (openingsSize) {
																							return function (meta) {
																								return function (affiliation) {
																									return function (practiceName) {
																										return function (practitionerType) {
																											return {pg: acceptsEnrollmentsFromEmployer, ph: acceptsEnrollmentsFromRetail, IJ: affiliation, JE: autoDetermineOnlineSignupVisibilityFromPanelSize, J2: bio, Oc: education, Oh: elationPhysicianId, Oo: email, PO: gender, PQ: genderOther, adR: id, RQ: isMaster, R1: isProvider, Sa: isSynced, Tq: maxPatientAge, TU: meta, T$: minPatientAge, zh: name, UP: npi, U8: onlineSignupVisibility, Vb: openingsSize, Vv: panelSize, Vw: panelSizeLimit, Wk: photoUrl, afQ: practiceName, WP: practitionerType, $l: syncedPatientsCount};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Practitioner$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practitioner$Meta$MetaFields = function (bio) {
	return function (education) {
		return function (email) {
			return function (gender) {
				return function (treatsAge) {
					return function (name) {
						return function (npi) {
							return function (photo) {
								return function (panelSizeLimit) {
									return function (specialtyNames) {
										return function (locations) {
											return {J2: bio, Oc: education, Oo: email, PO: gender, S4: locations, zh: name, UP: npi, Vw: panelSizeLimit, Wj: photo, _q: specialtyNames, aab: treatsAge};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Utils$MetaFields$Editable = {$: 0};
var $author$project$Utils$MetaFields$NonEditable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$MetaFields$decodeEditable = A2(
	$elm$json$Json$Decode$andThen,
	function (editable) {
		return editable ? $elm$json$Json$Decode$succeed($author$project$Utils$MetaFields$Editable) : A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'explanation',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Utils$MetaFields$NonEditable));
	},
	A2($elm$json$Json$Decode$field, 'editable', $elm$json$Json$Decode$bool));
var $author$project$Api$Provider$Practitioner$Meta$decodeMetaFields = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'locations',
	$author$project$Utils$MetaFields$decodeEditable,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'specialty_names',
		$author$project$Utils$MetaFields$decodeEditable,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'panel_size_limit',
			$author$project$Utils$MetaFields$decodeEditable,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'photo',
				$author$project$Utils$MetaFields$decodeEditable,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'npi',
					$author$project$Utils$MetaFields$decodeEditable,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$author$project$Utils$MetaFields$decodeEditable,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'treats_age',
							$author$project$Utils$MetaFields$decodeEditable,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gender',
								$author$project$Utils$MetaFields$decodeEditable,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'email',
									$author$project$Utils$MetaFields$decodeEditable,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'education',
										$author$project$Utils$MetaFields$decodeEditable,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'bio',
											$author$project$Utils$MetaFields$decodeEditable,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Meta$MetaFields))))))))))));
var $author$project$Api$Provider$Practitioner$Meta$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Meta$decodeMetaFields,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Gender$Female = 1;
var $author$project$Api$Gender$Intersex = 2;
var $author$project$Api$Gender$Male = 0;
var $author$project$Api$Gender$Other = 3;
var $author$project$Api$Gender$genderDecoder = function (string) {
	switch (string) {
		case 'male':
			return $elm$json$Json$Decode$succeed(0);
		case 'female':
			return $elm$json$Json$Decode$succeed(1);
		case 'intersex':
			return $elm$json$Json$Decode$succeed(2);
		case 'other':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail('Unsupported gender: ' + string);
	}
};
var $author$project$Api$Gender$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$Gender$genderDecoder, $elm$json$Json$Decode$string);
var $author$project$Api$Provider$Npi$Shared$Npi = $elm$core$Basics$identity;
var $author$project$Api$Provider$Npi$Shared$Record = F5(
	function (number, type_, organizationName, firstName, lastName) {
		return {Pu: firstName, SA: lastName, Gj: number, Ve: organizationName, ahI: type_};
	});
var $author$project$Api$Provider$Npi$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'first_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'organization_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'number',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Npi$Shared$Record))))));
var $author$project$Api$Provider$Npi$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Npi$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practitioner$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'practitioner_type',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'practice_name',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'affiliation',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'meta',
				$author$project$Api$Provider$Practitioner$Meta$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'openings_size',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'npi',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Npi$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'gender_other',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gender',
								$elm$json$Json$Decode$nullable($author$project$Api$Gender$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'photo_url',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'bio',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'elation_physician_id',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'synced_patients_count',
												$elm$json$Json$Decode$int,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'education',
													$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
													_List_Nil,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'min_patient_age',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'max_patient_age',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'auto_determine_online_signup_visibility_from_panel_size',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'email',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'panel_size_limit',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'panel_size',
																			$elm$json$Json$Decode$int,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'accepts_enrollments_from_retail',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'accepts_enrollments_from_employer',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'is_provider',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'online_signup_visibility',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'is_synced',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'is_master',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'name',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'id',
																											$elm$json$Json$Decode$string,
																											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Shared$Record))))))))))))))))))))))))))));
var $author$project$Api$Provider$Practitioner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FormResponse$One$form = function (_v0) {
	var record = _v0.b;
	return record.PB;
};
var $author$project$Api$Provider$CustomForm$FormAnswer = $elm$core$Basics$identity;
var $author$project$Api$Provider$FormResponseItem$Shared$answer = function (_v0) {
	var record = _v0;
	return record.Jf;
};
var $author$project$Api$Provider$FormResponseItem$Shared$formItemId = function (_v0) {
	var record = _v0;
	return record.Fm;
};
var $author$project$Api$Provider$FormResponse$One$formResponseItems = function (_v0) {
	var record = _v0.b;
	return record.PD;
};
var $author$project$Api$Provider$FormResponseItem$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CustomForm$formItemToFormQuestion = F2(
	function (formResponse, formItem) {
		var allResponseItems = $author$project$Api$Provider$FormResponse$One$formResponseItems(formResponse);
		var responseItems = function () {
			if (!allResponseItems.$) {
				var responseItems_ = allResponseItems.a;
				return A2(
					$elm$core$List$filter,
					function (responseItem) {
						return _Utils_eq(
							$author$project$Api$Provider$FormResponseItem$Shared$formItemId(responseItem),
							$author$project$Api$Provider$FormItem$Shared$id(formItem));
					},
					responseItems_);
			} else {
				return _List_Nil;
			}
		}();
		if ($elm$core$List$isEmpty(responseItems)) {
			return {
				px: _List_Nil,
				adR: $author$project$Api$Provider$FormItem$Shared$id(formItem),
				$G: $author$project$Api$Provider$FormItem$Shared$title(formItem),
				ahI: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType(
					$author$project$Api$Provider$FormItem$Shared$type_(formItem))
			};
		} else {
			var toFormAnswer = F2(
				function (id_, answer) {
					return {NA: $elm$core$Maybe$Nothing, adR: id_, $A: answer};
				});
			var answers_ = A2(
				$elm$core$List$map,
				function (item) {
					return A2(
						toFormAnswer,
						$author$project$Api$Provider$FormResponseItem$Shared$id(item),
						$author$project$Api$Provider$FormResponseItem$Shared$answer(item));
				},
				responseItems);
			return {
				px: answers_,
				adR: $author$project$Api$Provider$FormItem$Shared$id(formItem),
				$G: $author$project$Api$Provider$FormItem$Shared$title(formItem),
				ahI: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType(
					$author$project$Api$Provider$FormItem$Shared$type_(formItem))
			};
		}
	});
var $author$project$Api$Provider$FormResponse$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$FormResponse$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$FormResponse$Shared$id(shared);
};
var $author$project$Api$Provider$CustomForm$initFromFormResponse = function (formResponse) {
	var form = $author$project$Api$Provider$FormResponse$One$form(formResponse);
	var formItems = $author$project$Api$Provider$Form$Shared$items(form);
	var questions_ = A2(
		$elm$core$List$map,
		function (formItem) {
			return A2($author$project$Api$Provider$CustomForm$formItemToFormQuestion, formResponse, formItem);
		},
		formItems);
	return {
		xI: $author$project$Api$Provider$FormResponse$One$id(formResponse),
		adR: $author$project$Api$Provider$Form$Shared$id(form),
		zh: $author$project$Api$Provider$Form$Shared$name(form),
		Bj: questions_
	};
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Api$Provider$ExternalRecord$ExternalRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$ExternalRecord$Record = F4(
	function (conflicts, errorMessage, source, status) {
		return {LH: conflicts, ON: errorMessage, Hg: source, ag7: status};
	});
var $author$project$Api$Provider$ExternalRecord$Conflict = F3(
	function (name, ours, theirs) {
		return {zh: name, afx: ours, ahq: theirs};
	});
var $author$project$Api$Provider$ExternalRecord$conflictDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'theirs',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ours',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$ExternalRecord$Conflict))));
var $author$project$Api$Provider$ExternalRecord$Failed = 2;
var $author$project$Api$Provider$ExternalRecord$Inactive = 1;
var $author$project$Api$Provider$ExternalRecord$Pending = 3;
var $author$project$Api$Provider$ExternalRecord$Processing = 5;
var $author$project$Api$Provider$ExternalRecord$Skipped = 4;
var $author$project$Api$Provider$ExternalRecord$Successful = 0;
var $author$project$Api$Provider$ExternalRecord$statusCodeDecoder = function (string) {
	switch (string) {
		case 'successful':
			return $elm$json$Json$Decode$succeed(0);
		case 'inactive':
			return $elm$json$Json$Decode$succeed(1);
		case 'failed':
			return $elm$json$Json$Decode$succeed(2);
		case 'pending':
			return $elm$json$Json$Decode$succeed(3);
		case 'skipped':
			return $elm$json$Json$Decode$succeed(4);
		case 'processing':
			return $elm$json$Json$Decode$succeed(5);
		default:
			return $elm$json$Json$Decode$fail('Unsupported external record status: ' + string);
	}
};
var $author$project$Api$Provider$ExternalRecord$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$ExternalRecord$statusCodeDecoder, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'conflicts',
				$elm$json$Json$Decode$nullable(
					$elm$json$Json$Decode$list($author$project$Api$Provider$ExternalRecord$conflictDecoder)),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$ExternalRecord$Record)))));
var $author$project$Api$Provider$ExternalRecord$statusDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ExternalRecord$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'should_charge_credit_card_fees',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'exempt_from_credit_card_fees',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'emergency_contact',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$EmergencyContact$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'suffix',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'profile_picture_url',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'has_payment_method',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'form_responses',
								A2(
									$elm$json$Json$Decode$map,
									$elm$core$List$map($author$project$Api$Provider$CustomForm$initFromFormResponse),
									$elm$json$Json$Decode$list($author$project$Api$Provider$FormResponse$One$decoder)),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'integrations',
									$elm$json$Json$Decode$list($author$project$Api$Provider$ExternalRecord$statusDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'sources_count',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'default_source',
											$elm$json$Json$Decode$nullable(
												$elm$json$Json$Decode$oneOf(
													_List_fromArray(
														[$author$project$Api$Provider$Patient$One$cardDecoder, $author$project$Api$Provider$Patient$One$bankAccountDecoder]))),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'credit_expires_soon',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'credit_in_cents',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'owed_in_cents',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'company_registrations',
															$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForPatientOne$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'health_insurance',
																$elm$json$Json$Decode$nullable($author$project$Api$Provider$HealthInsurance$Shared$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'merged_into',
																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'last_portal_accessed_at',
																		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'account_access_sent_at',
																			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'lead_source',
																				$elm$json$Json$Decode$nullable($author$project$Api$Provider$LeadSource$Shared$decoder),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'preferred_language',
																					$author$project$Language$decode,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'assigned_affiliation',
																						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder),
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'dpc_patient',
																							$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$DpcPatient$decoder),
																							$elm$core$Maybe$Nothing,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'known_practice',
																								$elm$json$Json$Decode$nullable($author$project$Api$Provider$KnownPractice$Shared$decoder),
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'ssn',
																									$elm$json$Json$Decode$nullable($author$project$Api$Common$SocialSecurityNumber$Masked$decoder),
																									$elm$core$Maybe$Nothing,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'billing_address',
																										$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'address',
																											$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'uses_billing_address',
																												$elm$json$Json$Decode$bool,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'phones',
																													$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'stripe_link',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'title',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'overdue_in_cents',
																																$elm$json$Json$Decode$int,
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																	'network_sync_status',
																																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder),
																																	$elm$core$Maybe$Nothing,
																																	A4(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																		'affiliate_sync_status',
																																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder),
																																		$elm$core$Maybe$Nothing,
																																		A4(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																			'affiliate',
																																			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Shared$decoder),
																																			$elm$core$Maybe$Nothing,
																																			A4(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																																				_List_fromArray(
																																					['master_record', 'id']),
																																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																				$elm$core$Maybe$Nothing,
																																				A4(
																																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																					'network',
																																					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Shared$decoder),
																																					$elm$core$Maybe$Nothing,
																																					A4(
																																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
																																						_List_fromArray(
																																							['synced_record', 'id']),
																																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																																						$elm$core$Maybe$Nothing,
																																						A3(
																																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																							'is_affiliated',
																																							$elm$json$Json$Decode$bool,
																																							A3(
																																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																								'is_synced',
																																								$elm$json$Json$Decode$bool,
																																								A3(
																																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																									'is_master',
																																									$elm$json$Json$Decode$bool,
																																									A3(
																																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																										'flagged_notes_count',
																																										$elm$json$Json$Decode$int,
																																										A3(
																																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																											'membership_through',
																																											$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
																																											A3(
																																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																												'age',
																																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																												A3(
																																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																													'payees',
																																													$elm$json$Json$Decode$list($author$project$Api$Provider$Patient$Shared$decoder),
																																													A3(
																																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																														'payer',
																																														$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
																																														A3(
																																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																															'company_accounts',
																																															$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAccount$ForPatient$decoder),
																																															A3(
																																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																'company',
																																																$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
																																																A3(
																																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																	'practitioner',
																																																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder),
																																																	A3(
																																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																		'location',
																																																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Shared$decoder),
																																																		A3(
																																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																			'request_pending_documents_acceptance_sent_at',
																																																			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																																																			A3(
																																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																																				'request_pay_info_sent_at',
																																																				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																																																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Record)))))))))))))))))))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Patient$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Patient)));
var $author$project$Api$Provider$Patient$patientPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Patient$patientsPath);
};
var $author$project$Api$Provider$Patient$acceptHipaaAuthorization = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['accept_hipaa_authorization']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$acceptHipaaAuthorizationAll = F2(
	function (apiClient, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'do_all',
					$elm$json$Json$Encode$bool(true))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['accept_hipaa_authorization']),
						$author$project$Api$Provider$Patient$patientsPath))));
	});
var $author$project$Api$Provider$Patient$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.adR;
};
var $author$project$Api$Provider$Patient$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$id(shared);
};
var $author$project$Api$Provider$Patient$Shared$name = function (_v0) {
	var shared = _v0;
	return shared.zh;
};
var $author$project$Api$Provider$Patient$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$name(shared);
};
var $author$project$Pages$Admin$HipaaAuthorizations$FetchPatients = {$: 9};
var $author$project$Pages$Admin$HipaaAuthorizations$pollPatients = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Pages$Admin$HipaaAuthorizations$FetchPatients;
	},
	$elm$core$Process$sleep(1000));
var $author$project$Pages$Admin$HipaaAuthorizations$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					var totalCount = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$String$toInt,
							A2($elm$core$Dict$get, 'x-total-count', headers)));
					var cmd = (model.nz && (totalCount > 0)) ? $author$project$Pages$Admin$HipaaAuthorizations$pollPatients : $elm$core$Platform$Cmd$none;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rC: totalCount,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								Ap: response,
								nz: model.nz && (totalCount > 0)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ap: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(newModel),
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aT: $author$project$Pages$Admin$HipaaAuthorizations$All($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var patient = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aT: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, $author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aT: $author$project$Pages$Admin$HipaaAuthorizations$None}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aT: $author$project$Pages$Admin$HipaaAuthorizations$All($author$project$Api$Data$Loading)
						}),
					A2($author$project$Api$Provider$Patient$acceptHipaaAuthorizationAll, model.D5, $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForAll),
					_List_Nil);
			case 6:
				var patient = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aT: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, $author$project$Api$Data$Loading)
						}),
					A3(
						$author$project$Api$Provider$Patient$acceptHipaaAuthorization,
						model.D5,
						$author$project$Api$Provider$Patient$All$id(patient),
						$author$project$Pages$Admin$HipaaAuthorizations$AcceptedForOne(patient)),
					_List_Nil);
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aT: $author$project$Pages$Admin$HipaaAuthorizations$None, Ap: $author$project$Api$Data$Loading, nz: true}),
						$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Accepting HIPAA for all patients. This may take a couple moments...')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aT: $author$project$Pages$Admin$HipaaAuthorizations$All(response)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var patient = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aT: $author$project$Pages$Admin$HipaaAuthorizations$None, Ap: $author$project$Api$Data$Loading}),
						$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'You successfully accepted the ePHI waiver. ' + ($author$project$Api$Provider$Patient$All$name(patient) + ' will now receive notifications.'))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aT: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, response)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Ap: $author$project$Api$Data$Loading}),
					$author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptForAll = {$: 5};
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptForOne = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal = F3(
	function (numberPatientsNotAuthorized, patient, response) {
		var _v0 = function () {
			if (!patient.$) {
				var patient_ = patient.a;
				return _Utils_Tuple2(
					$author$project$Pages$Admin$HipaaAuthorizations$AcceptForOne(patient_),
					A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Patient$All$name(patient_))
							])));
			} else {
				return _Utils_Tuple2(
					$author$project$Pages$Admin$HipaaAuthorizations$AcceptForAll,
					$elm$html$Html$text('All'));
			}
		}();
		var buttonMsg = _v0.a;
		var buttonSubject = _v0.b;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Authorization to commmunicate over non-encrypted media')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							function () {
								if (!patient.$) {
									var patient_ = patient.a;
									return _List_fromArray(
										[
											$elm$html$Html$text('You have received authorization from '),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Patient$All$name(patient_))
												])),
											$elm$html$Html$text(' that allow us to send non-encrypted communications to '),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Patient$All$name(patient_))
												])),
											$elm$html$Html$text(' that may include Protected Health Information. '),
											$elm$html$Html$text('This is not reversible.')
										]);
								} else {
									return _List_fromArray(
										[
											$elm$html$Html$text('You have received authorization from '),
											$elm$html$Html$text(
											A2($author$project$Formatters$String$pluralize, 'patient', numberPatientsNotAuthorized)),
											$elm$html$Html$text(' that allow us to send non-encrypted communications to each of them that may include Protected Health Information. '),
											$elm$html$Html$text('This is not reversible.')
										]);
								}
							}()),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Do you have a signed copy of the non-encrypted communications waiver from '),
									function () {
									if (!patient.$) {
										var patient_ = patient.a;
										return A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Patient$All$name(patient_))
												]));
									} else {
										return $elm$html$Html$text('all of these patients');
									}
								}()
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Accept ePHI'},
							_List_fromArray(
								[
									$author$project$Ui$Button$success,
									$author$project$Ui$Button$onClick(buttonMsg),
									$author$project$Ui$Button$loading(
									_Utils_eq(response, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes, Accept for '),
									buttonSubject
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptingForAll = {$: 2};
var $author$project$Pages$Admin$HipaaAuthorizations$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$HipaaAuthorizations$AcceptingForOne = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Patient$Shared$email = function (_v0) {
	var shared = _v0;
	return shared.Oo;
};
var $author$project$Api$Provider$Patient$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$email(shared);
};
var $author$project$Pages$Admin$HipaaAuthorizations$viewPatient = function (patient) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Patient$All$name(patient))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Patient$All$email(patient)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'accept ePHI waiver'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$pull(1),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Admin$HipaaAuthorizations$AcceptingForOne(patient))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Accept ePHI waiver')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$HipaaAuthorizations$viewPanel = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$titleWithButton,
						_List_fromArray(
							[
								$elm$html$Html$text('ePHI Communication Waivers')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Accept for all patients'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$pull(1),
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$HipaaAuthorizations$AcceptingForAll)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept for All Patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = model.Ap;
						if (_v0.$ === 3) {
							var patients = _v0.a;
							return $elm$core$List$isEmpty(patients) ? $author$project$Utils$Html$empty : A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The following patients have not authorized our system to send them unencrypted electronic '),
										$elm$html$Html$text('communications which may contain Protected Health Information, such as emails about invoices and receipts.'),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text('We will not send emails or other electronic notifications which '),
										$elm$html$Html$text('may contain Protected Health Information to these patients.')
									]));
						} else {
							return $author$project$Ui$Spinner$view(_List_Nil);
						}
					}(),
						A4(
						$author$project$Ui$Table$view,
						_List_fromArray(
							[
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('All of your active patients have agreed to allow all email communications from this platform, so they should be receiving notifications from our system.')
									])),
								$author$project$Ui$Table$loading(
								_Utils_eq(model.Ap, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Patient')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Email')
									])),
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							]),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$map($author$project$Pages$Admin$HipaaAuthorizations$viewPatient),
								$author$project$Api$Data$toMaybe(model.Ap))),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$HipaaAuthorizations$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Api$Data$isSuccess(model.Ap))
								]),
							model.afy))
					]))
			]));
};
var $author$project$Pages$Admin$HipaaAuthorizations$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.aT;
				switch (_v0.$) {
					case 1:
						var id = _v0.a;
						var response = _v0.b;
						return A3(
							$author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal,
							model.rC,
							$elm$core$Maybe$Just(id),
							response);
					case 2:
						var response = _v0.a;
						return A3($author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal, model.rC, $elm$core$Maybe$Nothing, response);
					default:
						return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Pages$Admin$HipaaAuthorizations$viewPanel(model)
			]),
		$G: 'Admin | ePHI Waivers'
	};
};
var $author$project$Pages$Admin$HipaaAuthorizations$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$HipaaAuthorizations$init, aer: $author$project$Pages$Admin$HipaaAuthorizations$load, agD: $author$project$Pages$Admin$HipaaAuthorizations$save, ahd: $author$project$Pages$Admin$HipaaAuthorizations$subscriptions, aaq: $author$project$Pages$Admin$HipaaAuthorizations$update, ahP: $author$project$Pages$Admin$HipaaAuthorizations$view});
var $author$project$Pages$Admin$Integrations$Slug_String$GotIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Integration$One$Integration = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$Partner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$Record = F9(
	function (active, authType, email, integrationDescription, supportUrl, marketingUrl, signupUrl, productDescription, postActivationRedirectUrl) {
		return {Ic: active, Jy: authType, Oo: email, Q5: integrationDescription, Tl: marketingUrl, WA: postActivationRedirectUrl, Xb: productDescription, Z6: signupUrl, $a: supportUrl};
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'post_activation_redirect_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'product_description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'signup_url',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'marketing_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'support_url',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'integration_description',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'email',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'auth_type',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'active',
									$elm$json$Json$Decode$bool,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$ForIntegrationOne$Record))))))))));
var $author$project$Api$Provider$Partner$ForIntegrationOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Partner$ForIntegrationOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Partner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$ForIntegrationOne$Partner)));
var $author$project$Api$Provider$Integration$One$Record = F6(
	function (connectionUrl, addon, partnerApp, product, autoGrantPartnerAppAccess, defaultPartnerAppRole) {
		return {Iq: addon, abq: autoGrantPartnerAppAccess, LI: connectionUrl, acA: defaultPartnerAppRole, VB: partnerApp, W8: product};
	});
var $author$project$Api$Common$Marketplace$Product$Shared$Product = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Shared$Record = function (slug) {
	return function (name) {
		return function (distributionType) {
			return function (listingStatus) {
				return function (summary) {
					return function (iconUrl) {
						return function (builtByName) {
							return function (builtByUrl) {
								return function (featured) {
									return function (type_) {
										return function (categories) {
											return {Kd: builtByName, Ke: builtByUrl, KL: categories, NS: distributionType, Pc: featured, QH: iconUrl, SZ: listingStatus, zh: name, _c: slug, _9: summary, ahI: type_};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Marketplace$Product$Category$Category = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Category$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Common$Marketplace$Product$Category$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Category$Record))));
var $author$project$Api$Common$Marketplace$Product$DistributionType$Public = 0;
var $author$project$Api$Common$Marketplace$Product$DistributionType$Unlisted = 1;
var $author$project$Api$Common$Marketplace$Product$DistributionType$fromString = function (string) {
	switch (string) {
		case 'public':
			return $elm$core$Maybe$Just(0);
		case 'unlisted':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$DistributionType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Api$Common$Marketplace$Product$DistributionType$fromString(string);
		if (!_v0.$) {
			var distributionType = _v0.a;
			return $elm$json$Json$Decode$succeed(distributionType);
		} else {
			return $elm$json$Json$Decode$fail('Invalid distribution type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$ProductType$App = 0;
var $author$project$Api$Common$Marketplace$Product$ProductType$Integration = 1;
var $author$project$Api$Common$Marketplace$Product$ProductType$Solution = 2;
var $author$project$Api$Common$Marketplace$Product$ProductType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'app':
				return $elm$json$Json$Decode$succeed(0);
			case 'integration':
				return $elm$json$Json$Decode$succeed(1);
			case 'solution':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var other = str;
				return $elm$json$Json$Decode$fail('Unknown product type: ' + other);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$Status$Beta = 4;
var $author$project$Api$Common$Marketplace$Product$Status$ComingSoon = 3;
var $author$project$Api$Common$Marketplace$Product$Status$Decommissioned = 8;
var $author$project$Api$Common$Marketplace$Product$Status$Deprecated = 7;
var $author$project$Api$Common$Marketplace$Product$Status$Hidden = 0;
var $author$project$Api$Common$Marketplace$Product$Status$Live = 5;
var $author$project$Api$Common$Marketplace$Product$Status$Researching = 2;
var $author$project$Api$Common$Marketplace$Product$Status$Sunsetting = 6;
var $author$project$Api$Common$Marketplace$Product$Status$Unpublished = 1;
var $author$project$Api$Common$Marketplace$Product$Status$fromString = function (string) {
	switch (string) {
		case 'hidden':
			return $elm$core$Maybe$Just(0);
		case 'unpublished':
			return $elm$core$Maybe$Just(1);
		case 'researching':
			return $elm$core$Maybe$Just(2);
		case 'coming_soon':
			return $elm$core$Maybe$Just(3);
		case 'beta':
			return $elm$core$Maybe$Just(4);
		case 'live':
			return $elm$core$Maybe$Just(5);
		case 'sunsetting':
			return $elm$core$Maybe$Just(6);
		case 'deprecated':
			return $elm$core$Maybe$Just(7);
		case 'decommissioned':
			return $elm$core$Maybe$Just(8);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$Status$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Api$Common$Marketplace$Product$Status$fromString(string);
		if (!_v0.$) {
			var status = _v0.a;
			return $elm$json$Json$Decode$succeed(status);
		} else {
			return $elm$json$Json$Decode$fail('Invalid status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'categories',
	$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$author$project$Api$Common$Marketplace$Product$ProductType$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'featured',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'built_by_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'built_by_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'icon_url',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'summary',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'listing_status',
								$author$project$Api$Common$Marketplace$Product$Status$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'distribution_type',
									$author$project$Api$Common$Marketplace$Product$DistributionType$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'slug',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Shared$Record))))))))))));
var $author$project$Api$Common$Marketplace$Product$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$PartnerApp$Shared$PartnerApp = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$Shared$Record = F5(
	function (id, name, anchors, partner, partnerRoles) {
		return {D2: anchors, adR: id, zh: name, Vz: partner, VG: partnerRoles};
	});
var $author$project$Api$Common$Partner$Min$Partner = $elm$core$Basics$identity;
var $author$project$Api$Common$Partner$Min$Record = function (slug) {
	return {_c: slug};
};
var $author$project$Api$Common$Partner$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'slug',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Partner$Min$Record));
var $author$project$Api$Common$Partner$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Partner$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$PartnerApp$Anchor$Anchor = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$Anchor$Record = F5(
	function (id, type_, corePageIconUrl, corePageIconLabel, settingsLabel) {
		return {LW: corePageIconLabel, LX: corePageIconUrl, adR: id, ZE: settingsLabel, ahI: type_};
	});
var $author$project$Api$Common$PartnerApp$Anchor$ClinicalInteraction = 1;
var $author$project$Api$Common$PartnerApp$Anchor$CorePage = 0;
var $author$project$Api$Common$PartnerApp$Anchor$Settings = 2;
var $author$project$Api$Common$PartnerApp$Anchor$anchorTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (typeString) {
		switch (typeString) {
			case 'core_page':
				return $elm$json$Json$Decode$succeed(0);
			case 'clinical_interaction':
				return $elm$json$Json$Decode$succeed(1);
			case 'settings':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown anchor type: ' + typeString);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Api$Common$PartnerApp$Anchor$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'settings_label',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'core_page_icon_label',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'core_page_icon_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
					$author$project$Api$Common$PartnerApp$Anchor$anchorTypeDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Common$PartnerApp$Anchor$Record)))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$PartnerApp$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'partner_roles',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'partner',
		$author$project$Api$Common$Partner$Min$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'anchors',
			$elm$json$Json$Decode$list($author$project$Api$Common$PartnerApp$Anchor$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Common$PartnerApp$Shared$Record))))));
var $author$project$Api$Common$PartnerApp$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$PartnerApp$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Addon$Shared$Addon = $elm$core$Basics$identity;
var $author$project$Api$Provider$Addon$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Addon$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'default_partner_app_role',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'auto_grant_partner_app_access',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'product',
			$author$project$Api$Common$Marketplace$Product$Shared$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'partner_app',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$PartnerApp$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'addon',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Addon$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'connection_url',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$One$Record)))))));
var $author$project$Api$Provider$Integration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Integration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Partner$ForIntegrationOne$decoder,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			$author$project$Api$Provider$Integration$Shared$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$One$Integration))));
var $author$project$Api$Provider$Integration$integrationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['integrations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Integration$integrationPath = function (slugOrId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[slugOrId]),
		$author$project$Api$Provider$Integration$integrationsPath);
};
var $author$project$Api$Provider$Integration$retrieve = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Integration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Integration$integrationPath(slug)));
	});
var $author$project$Pages$Admin$Integrations$Slug_String$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var params = _v2.Vx;
		return _Utils_Tuple2(
			{bH: $elm$core$Maybe$Nothing, D5: apiClient, dC: $elm$core$Maybe$Nothing, Q4: $author$project$Api$Data$Loading, c5: $elm$core$Maybe$Nothing, ZD: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Ports$Navigation$pushUrl(
						$author$project$Spa$Generated$Route$toString(
							$author$project$Spa$Generated$Route$Marketplace__Slug_String(
								{_c: params._c}))),
						A3($author$project$Api$Provider$Integration$retrieve, apiClient, params._c, $author$project$Pages$Admin$Integrations$Slug_String$GotIntegration)
					])));
	});
var $author$project$Pages$Admin$Integrations$Slug_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Integrations$Slug_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Integrations$Slug_String$ActivateHiConfirmClosed = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Admin$Integrations$Slug_String$DeactivateHiConfirmClosed = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit = {$: 9};
var $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$ResourceFilter$PracticeUser$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$PracticeUser$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Admin$PartnerApp$Team$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg,
				$author$project$Components$ResourceFilter$PracticeUser$subscriptions(model.el)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit)),
					model.A))
			]));
};
var $author$project$Components$Admin$PartnerApp$Manage$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.cn;
				if (!_v1.$) {
					var partnerAppTeam = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg,
						$author$project$Components$Admin$PartnerApp$Team$subscriptions(partnerAppTeam));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Ui$Nav$subscriptions(model.m8)
			]));
};
var $author$project$Pages$Admin$Integrations$Slug_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Integrations$Slug_String$ActivateHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.bH))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Integrations$Slug_String$DeactivateHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.dC))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$PartnerApp$Manage$subscriptions, model.c5)))
			]));
};
var $author$project$Pages$Admin$Integrations$Slug_String$Activated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Admin$Integrations$Slug_String$Deactivated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$Integrations$Slug_String$PartnerActivated = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$Integration$activate = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Integration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$Integration$integrationPath(id))));
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$authType = function (_v0) {
	var record = _v0.b;
	return record.Jy;
};
var $author$project$Api$Provider$Integration$One$authType = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$authType(partner);
};
var $author$project$Api$Provider$Integration$connect = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Integration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['connect']),
					$author$project$Api$Provider$Integration$integrationPath(id))));
	});
var $author$project$Api$Provider$Integration$One$connectionUrl = function (_v0) {
	var record = _v0.c;
	return record.LI;
};
var $author$project$Api$Provider$Integration$deactivate = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Integration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deactivate']),
					$author$project$Api$Provider$Integration$integrationPath(id))));
	});
var $author$project$Api$Provider$Integration$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Integration$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$id(shared);
};
var $author$project$Components$Admin$PartnerApp$Manage$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$PartnerApp$Manage$NavMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$PartnerApp$Manage$Team = 0;
var $author$project$Components$Admin$PartnerApp$Manage$PartnerAppSettingsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Manage$SettingsModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Manage$TeamModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$PartnerApp$Settings$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$PartnerApp$Settings$MountSettingsSurface = 0;
var $author$project$Api$Common$PartnerApp$Anchor$isSettings = function (_v0) {
	var record = _v0;
	var _v1 = record.ahI;
	if (_v1 === 2) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Common$PartnerApp$Shared$settingsAnchor = function (_v0) {
	var record = _v0;
	return A2($elm_community$list_extra$List$Extra$find, $author$project$Api$Common$PartnerApp$Anchor$isSettings, record.D2);
};
var $author$project$Components$Admin$PartnerApp$Settings$init = function (partnerApp) {
	var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp);
	return _Utils_Tuple2(
		{VB: partnerApp},
		function () {
			if (!settingsAnchor.$) {
				return A2(
					$elm$core$Task$perform,
					function (_v1) {
						return 0;
					},
					$elm$core$Process$sleep(1000));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}());
};
var $author$project$Components$Admin$PartnerApp$Team$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$PartnerApp$Team$GotTeamMembers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$PartnerApp$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PartnerAppUser$All$PartnerAppUser = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PartnerAppUser$Shared$PartnerAppUser = $elm$core$Basics$identity;
var $author$project$Api$Provider$PartnerAppUser$Shared$Record = F3(
	function (id, email, partnerRoles) {
		return {Oo: email, adR: id, VG: partnerRoles};
	});
var $author$project$Api$Provider$PartnerAppUser$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'partner_roles',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'email',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$Shared$Record))));
var $author$project$Api$Provider$PartnerAppUser$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PartnerAppUser$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PartnerAppUser$All$Record = function (practiceUser) {
	return {WL: practiceUser};
};
var $author$project$Api$Provider$PracticeUser$Shared$PracticeUser = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeUser$Shared$Record = function (id) {
	return function (email) {
		return function (role) {
			return function (notificationsEnabled) {
				return function (invitationPending) {
					return function (isOwner) {
						return function (isDestroyable) {
							return function (restrictedByGroups) {
								return function (user) {
									return function (reportRestricted) {
										return {Oo: email, adR: id, Rf: invitationPending, RJ: isDestroyable, RX: isOwner, UO: notificationsEnabled, Yd: reportRestricted, Yy: restrictedByGroups, agy: role, aaz: user};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$User$One$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$User$One$Record = function (mfaStatus) {
	return {TW: mfaStatus};
};
var $author$project$Api$Provider$User$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mfa_status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$User$One$Record));
var $author$project$Api$Provider$User$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$User$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$User$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$User$One$User)));
var $author$project$Api$Provider$PracticeUser$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'report_restricted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$One$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'restricted_by_groups',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_destroyable',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_owner',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'invitation_pending',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'notifications_enabled',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'role',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'email',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$Shared$Record)))))))))));
var $author$project$Api$Provider$PracticeUser$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeUser$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PartnerAppUser$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice_user',
	$author$project$Api$Provider$PracticeUser$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$All$Record));
var $author$project$Api$Provider$PartnerAppUser$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PartnerAppUser$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PartnerAppUser$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$All$PartnerAppUser)));
var $author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsDefaults = {afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$PartnerApp$partnerAppsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_apps']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PartnerApp$partnerAppPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$PartnerApp$partnerAppsPath);
};
var $author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath = function (partnerAppId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['team_members']),
		$author$project$Api$Provider$PartnerApp$partnerAppPath(partnerAppId));
};
var $author$project$Api$Provider$PartnerApp$TeamMember$list = F4(
	function (apiClient, partnerAppId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PartnerAppUser$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId))));
	});
var $author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$PartnerApp$TeamMember$list,
			apiClient,
			$author$project$Api$Common$PartnerApp$Shared$id(model.VB),
			function (d) {
				return _Utils_update(
					d,
					{afy: model.afy, af_: model.af_, ag1: model.ag1});
			},
			$author$project$Components$Admin$PartnerApp$Team$GotTeamMembers);
	});
var $author$project$Api$Provider$TeamMember$Accepted = 0;
var $author$project$Api$Provider$PracticeUser$All$PracticeUser = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeUser$All$Record = F2(
	function (invitationUrl, locationGroups) {
		return {Rg: invitationUrl, S$: locationGroups};
	});
var $author$project$Api$Provider$LocationGroup$Min$LocationGroup = $elm$core$Basics$identity;
var $author$project$Api$Provider$LocationGroup$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$LocationGroup$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeUser$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location_groups',
	$elm$json$Json$Decode$list($author$project$Api$Provider$LocationGroup$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invitation_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$All$Record)));
var $author$project$Api$Provider$PracticeUser$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeUser$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PracticeUser$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$All$PracticeUser)));
var $author$project$Api$Provider$TeamMember$filterToString = function (filter) {
	return 'accepted';
};
var $author$project$Api$Provider$TeamMember$listOptionalsDefaults = {Fi: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$TeamMember$listOptionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$TeamMember$listOptionalsDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Fi;
				if (!_v2.$) {
					var filter = _v2.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							$author$project$Api$Provider$TeamMember$filterToString(filter))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$TeamMember$teamMembersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['team_members']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$TeamMember$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeUser$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$TeamMember$listOptionalsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
	});
var $author$project$Components$ResourceFilter$PracticeUser$list = $author$project$Api$Provider$TeamMember$list;
var $author$project$Components$ResourceFilter$PracticeUser$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$PracticeUser$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$PracticeUser$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$PracticeUser$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$PracticeUser$selectId = 'practice-users';
var $author$project$Api$Provider$PracticeUser$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$PracticeUser$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$email(shared);
};
var $author$project$Api$Provider$User$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$User$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$User$Shared$name(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$user = function (_v0) {
	var record = _v0;
	return record.aaz;
};
var $author$project$Api$Provider$PracticeUser$All$user = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$user(shared);
};
var $author$project$Components$ResourceFilter$PracticeUser$toTitle = function (resource) {
	var user = $author$project$Api$Provider$PracticeUser$All$user(resource);
	if (!user.$) {
		var user_ = user.a;
		return $author$project$Api$Provider$User$One$name(user_);
	} else {
		return $author$project$Api$Provider$PracticeUser$All$email(resource);
	}
};
var $author$project$Components$ResourceFilter$PracticeUser$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$PracticeUser$toTitle(resource))
		]);
};
var $author$project$Api$Provider$PracticeUser$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PracticeUser$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$PracticeUser$toValue = $author$project$Api$Provider$PracticeUser$All$id;
var $author$project$Components$ResourceFilter$PracticeUser$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$PracticeUser$fetchResources(listOptionals),
				adR: $author$project$Components$ResourceFilter$PracticeUser$selectId,
				gx: 'User',
				st: $author$project$Components$ResourceFilter$PracticeUser$retrieveResource(listOptionals),
				ahw: $author$project$Components$ResourceFilter$PracticeUser$toLabel,
				ahA: $author$project$Components$ResourceFilter$PracticeUser$toTitle,
				g0: $author$project$Components$ResourceFilter$PracticeUser$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter = function (apiClient) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg),
		A3(
			$author$project$Components$ResourceFilter$PracticeUser$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						Fi: $elm$core$Maybe$Just(0)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select A User', aeZ: false});
			}));
};
var $author$project$Api$Provider$Integration$One$autoGrantPartnerAppAccess = function (_v0) {
	var record = _v0.c;
	return record.abq;
};
var $author$project$Api$Provider$Integration$One$defaultPartnerAppRole = function (_v0) {
	var record = _v0.c;
	return record.acA;
};
var $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration = function (integration) {
	return {
		abq: $author$project$Api$Provider$Integration$One$autoGrantPartnerAppAccess(integration),
		acA: $author$project$Api$Provider$Integration$One$defaultPartnerAppRole(integration)
	};
};
var $author$project$Components$Admin$PartnerApp$Team$init = F4(
	function (apiClient, integration, partnerApp, currentUser) {
		var _v0 = $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter(apiClient);
		var practiceUserResourceFilter = _v0.a;
		var practiceUserResourceFilterCmd = _v0.b;
		var model = {
			EQ: currentUser,
			lQ: $elm$core$Maybe$Nothing,
			dU: $elm$core$Set$empty,
			Q4: integration,
			afy: $author$project$Api$Pagination$init,
			VB: partnerApp,
			el: practiceUserResourceFilter,
			af_: $elm$core$Maybe$Nothing,
			sA: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
			dd: $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration(integration),
			od: $author$project$Api$Data$NotAsked,
			ag1: A3($author$project$Api$Sort$withDefault, 'user_first_name', 0, $author$project$Api$Sort$init),
			A: $elm$core$Maybe$Nothing,
			eK: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
						practiceUserResourceFilterCmd
					])));
	});
var $author$project$Components$Admin$PartnerApp$Manage$initSectionModel = F5(
	function (apiClient, integration, partnerApp, currentUser, section) {
		if (!section) {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$Admin$PartnerApp$Manage$TeamModel,
					A4($author$project$Components$Admin$PartnerApp$Team$init, apiClient, integration, partnerApp, currentUser)));
		} else {
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Manage$PartnerAppSettingsMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$Admin$PartnerApp$Manage$SettingsModel,
					$author$project$Components$Admin$PartnerApp$Settings$init(partnerApp)));
		}
	});
var $author$project$Components$Admin$PartnerApp$Manage$init = F4(
	function (apiClient, integration, partnerApp, currentUser) {
		var _v0 = A5($author$project$Components$Admin$PartnerApp$Manage$initSectionModel, apiClient, integration, partnerApp, currentUser, 0);
		var section = _v0.a;
		var sectionCmd = _v0.b;
		var _v1 = A2($author$project$Ui$Nav$init, 'partner-app-manage-nav', $author$project$Components$Admin$PartnerApp$Manage$NavMsg);
		var nav = _v1.a;
		var navCmd = _v1.b;
		var model = {EQ: currentUser, Q4: integration, m8: nav, VB: partnerApp, cn: section};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[navCmd, sectionCmd])));
	});
var $author$project$Api$Provider$Partner$ForIntegrationOne$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Partner$Shared$name(shared);
};
var $author$project$Api$Provider$Integration$One$name = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$name(partner);
};
var $author$project$Api$Provider$Integration$One$partnerApp = function (_v0) {
	var record = _v0.c;
	return record.VB;
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$postActivationRedirectUrl = function (_v0) {
	var record = _v0.b;
	return record.WA;
};
var $author$project$Api$Provider$Integration$One$postActivationRedirectUrl = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$postActivationRedirectUrl(partner);
};
var $author$project$Api$Provider$Integration$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Integration$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$status(shared);
};
var $author$project$Ports$PartnerApps$partnerAppsMount = _Platform_outgoingPort(
	'partnerAppsMount',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'appId',
					$elm$json$Json$Encode$string($.abn)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.adR)),
					_Utils_Tuple2(
					'type_',
					$elm$json$Json$Encode$string($.ahI))
				]));
	});
var $author$project$Ports$PartnerApps$mount = F2(
	function (id, options) {
		return $author$project$Ports$PartnerApps$partnerAppsMount(
			{abn: options.abn, adR: id, ahI: options.ahI});
	});
var $author$project$Components$Admin$PartnerApp$Settings$update = F2(
	function (msg, _v0) {
		var model = _v0;
		return _Utils_Tuple3(
			model,
			A2(
				$author$project$Ports$PartnerApps$mount,
				'partner-app-settings',
				{
					abn: $author$project$Api$Common$PartnerApp$Shared$id(model.VB),
					ahI: 'settings'
				}),
			_List_Nil);
	});
var $author$project$Components$Admin$PartnerApp$Team$IntegrationUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$PracticeUser = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SettingsSaved = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$TeamMemberDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath = F2(
	function (partnerAppId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId));
	});
var $author$project$Api$Provider$PartnerApp$TeamMember$delete = F4(
	function (apiClient, partnerAppId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath, partnerAppId, id)));
	});
var $author$project$Api$Provider$PartnerAppUser$Shared$partnerRoles = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Provider$PartnerAppUser$All$partnerRoles = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PartnerAppUser$Shared$partnerRoles(shared);
};
var $author$project$Api$Provider$PartnerAppUser$All$practiceUser = function (_v0) {
	var record = _v0.b;
	return record.WL;
};
var $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromShared = function (practiceUser) {
	return {
		adR: $author$project$Api$Provider$PracticeUser$Shared$id(practiceUser)
	};
};
var $author$project$Components$Admin$PartnerApp$Team$formFieldsFromTeamMember = function (teamMember) {
	var practiceUser = $author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember);
	return {
		ge: $elm$core$List$head(
			$author$project$Api$Provider$PartnerAppUser$All$partnerRoles(teamMember)),
		afR: _List_fromArray(
			[
				$author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromShared(practiceUser)
			])
	};
};
var $author$project$Components$Admin$PartnerApp$Team$formFieldsInit = {ge: $elm$core$Maybe$Nothing, afR: _List_Nil};
var $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var practiceUsers = field.a;
			return _Utils_update(
				fields,
				{afR: practiceUsers});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					ge: $author$project$Utils$String$toMaybe(string)
				});
		}
	});
var $author$project$Components$Admin$PartnerApp$Team$PracticeUserValidation = 0;
var $rtfeldman$elm_validate$Validate$ifEmptyList = F2(
	function (subjectToList, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $elm$core$List$isEmpty(
					subjectToList(subject));
			},
			error);
	});
var $author$project$Components$Admin$PartnerApp$Team$PartnerRoleValidation = 1;
var $author$project$Api$Common$PartnerApp$Shared$partnerRoles = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Components$Admin$PartnerApp$Team$validatePartnerRole = F2(
	function (partnerApp, fields) {
		return $elm$core$List$isEmpty(
			$author$project$Api$Common$PartnerApp$Shared$partnerRoles(partnerApp)) ? _List_Nil : (_Utils_eq(fields.ge, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please pick a role.')
			]) : _List_Nil);
	});
var $author$project$Components$Admin$PartnerApp$Team$formFieldsValidator = function (partnerApp) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifEmptyList,
				function ($) {
					return $.afR;
				},
				_Utils_Tuple2(0, 'Please pick at least one user.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Admin$PartnerApp$Team$validatePartnerRole(partnerApp))
			]));
};
var $author$project$Components$Admin$PartnerApp$Team$None = {$: 0};
var $author$project$Components$Admin$PartnerApp$Team$noEvent = F3(
	function (m, c, o) {
		return {EC: c, ac5: $author$project$Components$Admin$PartnerApp$Team$None, y8: m, as: o};
	});
var $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll = function (practiceUser) {
	return {
		adR: $author$project$Api$Provider$PracticeUser$All$id(practiceUser)
	};
};
var $author$project$Components$Admin$PartnerApp$Team$TeamMemberCreated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$PartnerAppUser$One$PartnerAppUser = 0;
var $author$project$Api$Provider$PartnerAppUser$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$PartnerApp$TeamMember$bulkCreate = F4(
	function (apiClient, partnerAppId, fields, toMsg) {
		var encodeTeamMember = function (practiceUser) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'practice_user',
						$author$project$Utils$Encode$association(practiceUser)),
						_Utils_Tuple2(
						'partner_roles',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.VG))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_members',
					A2($elm$json$Json$Encode$list, encodeTeamMember, fields.afR))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PartnerAppUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk_create']),
						$author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId)))));
	});
var $author$project$Components$Admin$PartnerApp$Team$createTeamMember = F3(
	function (apiClient, partnerApp, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$PartnerApp$TeamMember$bulkCreate,
			apiClient,
			$author$project$Api$Common$PartnerApp$Shared$id(partnerApp),
			{
				VG: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, fields.ge)),
				afR: A2(
					$elm$core$List$map,
					function ($) {
						return $.adR;
					},
					fields.afR)
			},
			$author$project$Components$Admin$PartnerApp$Team$TeamMemberCreated);
	});
var $author$project$Components$Admin$PartnerApp$Team$TeamMemberUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$PartnerApp$TeamMember$update = F5(
	function (apiClient, partnerAppId, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'partner_roles',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.VG))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PartnerAppUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath, partnerAppId, id_))));
	});
var $author$project$Components$Admin$PartnerApp$Team$updateTeamMember = F4(
	function (apiClient, partnerApp, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5(
			$author$project$Api$Provider$PartnerApp$TeamMember$update,
			apiClient,
			$author$project$Api$Common$PartnerApp$Shared$id(partnerApp),
			id,
			{
				VG: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $elm$core$List$singleton, fields.ge))
			},
			$author$project$Components$Admin$PartnerApp$Team$TeamMemberUpdated);
	});
var $author$project$Components$Admin$PartnerApp$Team$saveTeamMember = F4(
	function (apiClient, partnerApp, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A4($author$project$Components$Admin$PartnerApp$Team$updateTeamMember, apiClient, partnerApp, id, formFields);
		} else {
			return A3($author$project$Components$Admin$PartnerApp$Team$createTeamMember, apiClient, partnerApp, formFields);
		}
	});
var $author$project$Components$Admin$PartnerApp$Team$setAutoGrant = F2(
	function (value, form) {
		return _Utils_update(
			form,
			{abq: value});
	});
var $author$project$Components$Admin$PartnerApp$Team$setDefaultRole = F2(
	function (value, form) {
		return _Utils_update(
			form,
			{acA: value});
	});
var $author$project$Api$Provider$Integration$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'integration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'auto_grant_partner_app_access',
								$elm$json$Json$Encode$bool(fields.abq)),
								_Utils_Tuple2(
								'default_partner_app_role',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.acA))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Integration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$integrationPath(id))));
	});
var $author$project$Components$ResourceFilter$PracticeUser$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Admin$PartnerApp$Team$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								eK: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1),
						eK: $author$project$Api$Data$Loading
					});
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					newModel,
					A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, newModel),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, eK: $author$project$Api$Data$Loading});
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					newModel,
					A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, newModel),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q,
								eK: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, qModel));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 4:
				var _v6 = $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter(apiClient);
				var practiceUserResourceFilter = _v6.a;
				var practiceUserResourceFilterCmd = _v6.b;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							el: practiceUserResourceFilter,
							A: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Admin$PartnerApp$Team$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					practiceUserResourceFilterCmd,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v7 = model.A;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var teamMember = _v8.a;
					var form = _v8.b;
					var request = _v8.c;
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										teamMember,
										A3($author$project$Utils$Form$update, $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate, field, form),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var form = msg.a;
				var teamMember = msg.b;
				var id = msg.c;
				var _v9 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Admin$PartnerApp$Team$formFieldsValidator(model.VB),
					form);
				if (!_v9.$) {
					var _v10 = _v9.a;
					var newForm = _v10.a;
					var validFormFields = _v10.b;
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Components$Admin$PartnerApp$Team$saveTeamMember, apiClient, model.VB, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v9.a;
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v11 = model.A;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var teamMember = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{A: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
								]));
					} else {
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{
									A: $elm$core$Maybe$Just(
										_Utils_Tuple3(teamMember, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var teamMember = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							A: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(teamMember),
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$PartnerApp$Team$formFieldsFromTeamMember(teamMember)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{A: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var response = msg.a;
				var _v14 = model.A;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var id = _v15.a;
					var form = _v15.b;
					if (response.$ === 3) {
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{A: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
								]));
					} else {
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{
									A: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var teamMember = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							lQ: $elm$core$Maybe$Just(teamMember)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							lQ: $elm$core$Maybe$Nothing,
							dU: A2($elm$core$Set$insert, id, model.dU)
						}),
					A4(
						$author$project$Api$Provider$PartnerApp$TeamMember$delete,
						apiClient,
						$author$project$Api$Common$PartnerApp$Shared$id(model.VB),
						id,
						$author$project$Components$Admin$PartnerApp$Team$TeamMemberDeleted(id)),
					_List_Nil) : A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{lQ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{
									dU: A2($elm$core$Set$remove, id, model.dU),
									eK: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
								]));
					case 2:
						return A3(
							$author$project$Components$Admin$PartnerApp$Team$noEvent,
							_Utils_update(
								model,
								{
									dU: A2($elm$core$Set$remove, id, model.dU)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var subMsg = msg.a;
				var practiceUserResourceResult = A3($author$project$Components$ResourceFilter$PracticeUser$update, apiClient, subMsg, model.el);
				var _v18 = model.A;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var id = _v19.a;
					var form = _v19.b;
					var request = _v19.c;
					var newForm = function () {
						var _v20 = practiceUserResourceResult.ac5;
						if (!_v20.$) {
							if (!_v20.a.$) {
								switch (_v20.a.a.$) {
									case 2:
										var _v21 = _v20.a.a;
										return A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate,
											$author$project$Components$Admin$PartnerApp$Team$PracticeUser(_List_Nil),
											form);
									case 0:
										var practiceUser = _v20.a.a.a;
										return A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate,
											$author$project$Components$Admin$PartnerApp$Team$PracticeUser(
												_List_fromArray(
													[
														$author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll(practiceUser)
													])),
											form);
									case 1:
										var practiceUsers = _v20.a.a.a;
										return A3(
											$author$project$Utils$Form$update,
											$author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate,
											$author$project$Components$Admin$PartnerApp$Team$PracticeUser(
												A2($elm$core$List$map, $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll, practiceUsers)),
											form);
									default:
										return form;
								}
							} else {
								var _v22 = _v20.a;
								return form;
							}
						} else {
							return form;
						}
					}();
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{
								el: practiceUserResourceResult.y8,
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg, practiceUserResourceResult.EC),
						_List_Nil);
				} else {
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{el: practiceUserResourceResult.y8}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg, practiceUserResourceResult.EC),
						_List_Nil);
				}
			case 15:
				var value = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							dd: A2($author$project$Components$Admin$PartnerApp$Team$setAutoGrant, value, model.dd)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var value = msg.a;
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{
							dd: A2(
								$author$project$Components$Admin$PartnerApp$Team$setDefaultRole,
								$author$project$Utils$String$toMaybe(value),
								model.dd)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				return A3(
					$author$project$Components$Admin$PartnerApp$Team$noEvent,
					_Utils_update(
						model,
						{od: $author$project$Api$Data$Loading}),
					A4(
						$author$project$Api$Provider$Integration$update,
						apiClient,
						$author$project$Api$Provider$Integration$One$id(model.Q4),
						model.dd,
						$author$project$Components$Admin$PartnerApp$Team$SettingsSaved),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var integration = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$PartnerApp$Team$IntegrationUpdated(integration),
						y8: _Utils_update(
							model,
							{
								Q4: integration,
								dd: $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration(integration),
								od: $author$project$Api$Data$NotAsked
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Settings saved')
							])
					};
				} else {
					return A3(
						$author$project$Components$Admin$PartnerApp$Team$noEvent,
						_Utils_update(
							model,
							{od: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Admin$PartnerApp$Manage$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v2 = model.cn;
				if (!_v2.$) {
					var partnerAppTeam = _v2.a;
					var result = A3($author$project$Components$Admin$PartnerApp$Team$update, apiClient, subMsg, partnerAppTeam);
					var integration = function () {
						var _v3 = result.ac5;
						if (_v3.$ === 1) {
							var updated = _v3.a;
							return updated;
						} else {
							return model.Q4;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Q4: integration,
								cn: $author$project$Components$Admin$PartnerApp$Manage$TeamModel(result.y8)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg, result.EC),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v4 = model.cn;
				if (_v4.$ === 1) {
					var partnerAppSettings = _v4.a;
					var _v5 = A2($author$project$Components$Admin$PartnerApp$Settings$update, subMsg, partnerAppSettings);
					var partnerAppSettings_ = _v5.a;
					var partnerAppSettingsCmd = _v5.b;
					var partnerAppSettingsOutMsgs = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cn: $author$project$Components$Admin$PartnerApp$Manage$SettingsModel(partnerAppSettings_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Manage$PartnerAppSettingsMsg, partnerAppSettingsCmd),
						partnerAppSettingsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var navMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Manage$NavMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newNav) {
								return _Utils_update(
									model,
									{m8: newNav});
							},
							A2($author$project$Ui$Nav$update, navMsg, model.m8))));
			default:
				var section = msg.a;
				var _v6 = A5($author$project$Components$Admin$PartnerApp$Manage$initSectionModel, apiClient, model.Q4, model.VB, model.EQ, section);
				var sectionModel = _v6.a;
				var sectionCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cn: sectionModel}),
					sectionCmd,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Integrations$Slug_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var integration = response.a;
					var _v2 = function () {
						var _v3 = _Utils_Tuple2(
							$author$project$Api$Provider$Integration$One$status(integration),
							$author$project$Api$Provider$Integration$One$partnerApp(integration));
						if ((_v3.a === 'active') && (!_v3.b.$)) {
							var partnerApp = _v3.b.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$elm$core$Maybe$Just,
									A4(
										$author$project$Components$Admin$PartnerApp$Manage$init,
										model.D5,
										integration,
										partnerApp,
										$author$project$Api$Platform$Session$One$user(model.ZD))));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var partnerAppManage = _v2.a;
					var partnerAppManageCmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Q4: response, c5: partnerAppManage}),
						partnerAppManageCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Q4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var integration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bH: $elm$core$Maybe$Just(
								_Utils_Tuple2(integration, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var integration = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bH: $elm$core$Maybe$Just(
								_Utils_Tuple2(integration, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$Integration$activate,
						model.D5,
						$author$project$Api$Provider$Integration$One$id(integration),
						$author$project$Pages$Admin$Integrations$Slug_String$Activated(integration)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var integration = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var integration_ = response.a;
					var activatingIntegration = ($author$project$Api$Provider$Integration$One$authType(integration_) === 'automatic_headless') ? $elm$core$Maybe$Just(
						_Utils_Tuple2(integration_, response)) : $elm$core$Maybe$Nothing;
					var _v5 = function () {
						var _v6 = _Utils_Tuple2(
							$author$project$Api$Provider$Integration$One$status(integration_),
							$author$project$Api$Provider$Integration$One$partnerApp(integration_));
						if ((_v6.a === 'active') && (!_v6.b.$)) {
							var partnerApp = _v6.b.a;
							return A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$elm$core$Maybe$Just,
									A4(
										$author$project$Components$Admin$PartnerApp$Manage$init,
										model.D5,
										integration_,
										partnerApp,
										$author$project$Api$Platform$Session$One$user(model.ZD))));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var partnerAppManage = _v5.a;
					var partnerAppManageCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bH: activatingIntegration, Q4: response, c5: partnerAppManage}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									partnerAppManageCmd,
									function () {
									var _v7 = _Utils_Tuple2(
										$author$project$Api$Provider$Integration$One$authType(integration_),
										$author$project$Api$Provider$Integration$One$connectionUrl(integration_));
									_v7$2:
									while (true) {
										switch (_v7.a) {
											case 'automatic_redirect':
												if (!_v7.b.$) {
													var connectionUrl = _v7.b.a;
													return $author$project$Ports$Navigation$openInNewWindow(connectionUrl);
												} else {
													break _v7$2;
												}
											case 'automatic_headless':
												return A3(
													$author$project$Api$Provider$Integration$connect,
													model.D5,
													$author$project$Api$Provider$Integration$One$id(integration_),
													$author$project$Pages$Admin$Integrations$Slug_String$PartnerActivated(integration_));
											default:
												break _v7$2;
										}
									}
									return $elm$core$Platform$Cmd$none;
								}()
								])),
						($author$project$Api$Provider$Integration$One$authType(integration_) === 'automatic_headless') ? _List_Nil : _List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Integration$One$name(integration) + ' activated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bH: $elm$core$Maybe$Just(
									_Utils_Tuple2(integration, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var integration = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bH: $elm$core$Maybe$Nothing, Q4: response}),
						function () {
							var _v9 = _Utils_Tuple2(
								$author$project$Api$Provider$Integration$One$authType(integration),
								$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
							if ((_v9.a === 'automatic_headless') && (!_v9.b.$)) {
								var postActivationRedirectUrl = _v9.b.a;
								return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Integration$One$name(integration) + ' activated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bH: $elm$core$Maybe$Just(
									_Utils_Tuple2(integration, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var integration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dC: $elm$core$Maybe$Just(
								_Utils_Tuple2(integration, $author$project$Api$Data$NotAsked)),
							c5: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var integration = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dC: $elm$core$Maybe$Just(
								_Utils_Tuple2(integration, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$Integration$deactivate,
						model.D5,
						$author$project$Api$Provider$Integration$One$id(integration),
						$author$project$Pages$Admin$Integrations$Slug_String$Deactivated(integration)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{dC: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var integration = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dC: $elm$core$Maybe$Nothing, Q4: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Integration$One$name(integration) + ' deactivated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dC: $elm$core$Maybe$Just(
									_Utils_Tuple2(integration, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v11 = model.c5;
				if (!_v11.$) {
					var partnerAppManage = _v11.a;
					var _v12 = A3($author$project$Components$Admin$PartnerApp$Manage$update, model.D5, subMsg, partnerAppManage);
					var partnerAppManage_ = _v12.a;
					var partnerAppManageCmd = _v12.b;
					var partnerAppManageOutMsgs = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c5: $elm$core$Maybe$Just(partnerAppManage_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg, partnerAppManageCmd),
						partnerAppManageOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate = function (integration) {
	return ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_redirect') || ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless');
};
var $author$project$Pages$Admin$Integrations$Slug_String$disclaimerMessage = function (integration) {
	var name = $author$project$Api$Provider$Integration$One$name(integration);
	var message = _List_fromArray(
		[
			$elm$html$Html$text('We provide this integration only as a convenience to you. '),
			$elm$html$Html$text(name),
			$elm$html$Html$text(' is solely responsible for its service, content and policies, including those related to privacy and security. Please review '),
			$elm$html$Html$text(name),
			$elm$html$Html$text('’s Terms of Service, and Privacy Policy to ensure they meet your business and legal requirements.')
		]);
	return $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration) ? A2(
		$elm$core$List$cons,
		$elm$html$Html$text('You are about to be redirected to '),
		A2(
			$elm$core$List$cons,
			$elm$html$Html$text(name),
			A2(
				$elm$core$List$cons,
				$elm$html$Html$text('’s login page. Sign in with your '),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$text(name),
					A2(
						$elm$core$List$cons,
						$elm$html$Html$text(' credentials, and they should provide you with next steps, if any.'),
						A2(
							$elm$core$List$cons,
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
								$elm$core$List$cons,
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								message))))))) : message;
};
var $author$project$Components$Admin$PartnerApp$Team$DeleteConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Api$Provider$PartnerAppUser$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$PartnerAppUser$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PartnerAppUser$Shared$email(shared);
};
var $author$project$Api$Provider$PartnerAppUser$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PartnerAppUser$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PartnerAppUser$Shared$id(shared);
};
var $author$project$Components$Admin$PartnerApp$Team$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$PartnerRole = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SaveTeamMember = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Components$ResourceFilter$Multi = {$: 6};
var $author$project$Components$ResourceFilter$multi = $author$project$Components$ResourceFilter$Multi;
var $author$project$Components$Admin$PartnerApp$Team$roleOptions = F2(
	function (emptyLabel, roles) {
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, emptyLabel),
			A2(
				$elm$core$List$map,
				function (role) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(role),
						$author$project$Formatters$String$titleize(
							$author$project$Formatters$String$humanize(role)));
				},
				roles));
	});
var $author$project$Components$ResourceFilter$PracticeUser$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Ui$Margin$Bottom_0_25 = 1;
var $author$project$Ui$Button$mb2 = $author$project$Ui$Button$Margin(1);
var $author$project$Ui$SvgIcon$SpacedLeft = {$: 3};
var $author$project$Ui$SvgIcon$spacedLeft = $author$project$Ui$SvgIcon$SpacedLeft;
var $author$project$Components$ResourceFilter$viewMultiSelected_ = F2(
	function (model, items) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return A3(
					$author$project$Ui$Button$view,
					{abp: 'Remove selection'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick(
							$author$project$Components$ResourceFilter$DropdownItemChecked(
								A2(
									$author$project$Components$ResourceFilter$toggleItemSelection,
									$author$project$Components$ResourceFilter$Many(items),
									item))),
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$mb2
						]),
					A2(
						$elm$core$List$map,
						$elm$html$Html$map($elm$core$Basics$never),
						_List_fromArray(
							[
								$elm$html$Html$text(
								model.ahA(item)),
								$author$project$Ui$SvgIcon$cross(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$spacedLeft]))
							])));
			},
			items);
	});
var $author$project$Components$ResourceFilter$viewMultiSelected = F2(
	function (choice, model) {
		switch (choice.$) {
			case 3:
				return _List_fromArray(
					[
						$elm$html$Html$text('No ' + model.gx),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Remove selection'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Components$ResourceFilter$DropdownItemChecked($author$project$Components$ResourceFilter$All)),
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$mb2
							]),
						_List_fromArray(
							[
								$author$project$Ui$SvgIcon$cross(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$spacedLeft]))
							]))
					]);
			case 2:
				return _List_Nil;
			case 4:
				return _List_Nil;
			case 0:
				var item = choice.a;
				return A2(
					$author$project$Components$ResourceFilter$viewMultiSelected_,
					model,
					_List_fromArray(
						[item]));
			case 5:
				return _List_Nil;
			default:
				var items = choice.a;
				return A2($author$project$Components$ResourceFilter$viewMultiSelected_, model, items);
		}
	});
var $author$project$Components$ResourceFilter$PracticeUser$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$Admin$PartnerApp$Team$viewTeamMemberModal = F4(
	function (model, teamMember, request, form) {
		var partnerRoles = $author$project$Api$Common$PartnerApp$Shared$partnerRoles(model.VB);
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Team Member',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Provider$PartnerAppUser$All$id, teamMember),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit,
			U0: A2($author$project$Components$Admin$PartnerApp$Team$SaveTeamMember, form, teamMember)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('User'),
							$author$project$Ui$Form$Group$required(
							_Utils_eq(teamMember, $elm$core$Maybe$Nothing))
						]),
					_List_fromArray(
						[
							function () {
							if (!teamMember.$) {
								var teamMember_ = teamMember.a;
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$User$One$name,
													$author$project$Api$Provider$PracticeUser$Shared$user(
														$author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember_)))))
										]));
							} else {
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$map,
											$author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$PracticeUser$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
														$author$project$Components$ResourceFilter$errors(
														A2($author$project$Utils$Form$validationErrors, 0, form)),
														$author$project$Components$ResourceFilter$multi
													]),
												model.el)),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg),
											$author$project$Components$ResourceFilter$PracticeUser$viewMultiSelected(model.el))));
							}
						}(),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					function () {
					if ($elm$core$List$isEmpty(partnerRoles)) {
						return $author$project$Utils$Html$empty;
					} else {
						var fields = $author$project$Utils$Form$fields(form);
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Role')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(fields.ge),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Admin$PartnerApp$Team$FormUpdated, $author$project$Components$Admin$PartnerApp$Team$PartnerRole)),
											$author$project$Ui$Form$Select$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
											$author$project$Ui$Form$Select$errors(
											A2($author$project$Utils$Form$validationErrors, 1, form))
										]),
									A2(
										$author$project$Components$Admin$PartnerApp$Team$roleOptions,
										'Pick a role',
										$author$project$Api$Common$PartnerApp$Shared$partnerRoles(model.VB)))
								]));
					}
				}()
				]));
	});
var $author$project$Components$Admin$PartnerApp$Team$modal = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.A;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var teamMember = _v2.a;
				var form = _v2.b;
				var request = _v2.c;
				return A4($author$project$Components$Admin$PartnerApp$Team$viewTeamMemberModal, model, teamMember, request, form);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.lQ;
			if (!_v3.$) {
				var teamMember = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Admin$PartnerApp$Team$DeleteConfirmClosed(
						$author$project$Api$Provider$PartnerAppUser$All$id(teamMember)),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('remove'),
							$author$project$Components$HiConfirm$noun('team member'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Provider$PartnerAppUser$All$email(teamMember))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}()
		]);
};
var $author$project$Components$Admin$PartnerApp$Manage$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.cn;
	if (!_v1.$) {
		var partnerAppTeam = _v1.a;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg),
				$author$project$Components$Admin$PartnerApp$Team$modal(partnerAppTeam)));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Integrations$Slug_String$Activate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Integrations$Slug_String$Deactivate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$active = function (_v0) {
	var record = _v0.b;
	return record.Ic;
};
var $author$project$Api$Provider$Integration$One$active = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$active(partner);
};
var $author$project$Api$Provider$Integration$One$addon = function (_v0) {
	var record = _v0.c;
	return record.Iq;
};
var $author$project$Api$Provider$Integration$Shared$authorizationCode = function (_v0) {
	var record = _v0;
	return record.JC;
};
var $author$project$Api$Provider$Integration$One$authorizationCode = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$authorizationCode(shared);
};
var $author$project$Ui$Typography$AuthorizationCode = {$: 21};
var $author$project$Ui$Typography$authorizationCode = $author$project$Ui$Typography$AuthorizationCode;
var $author$project$Api$Provider$Partner$ForIntegrationOne$email = function (_v0) {
	var record = _v0.b;
	return record.Oo;
};
var $author$project$Api$Provider$Integration$One$email = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$email(partner);
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$integrationDescription = function (_v0) {
	var record = _v0.b;
	return record.Q5;
};
var $author$project$Api$Provider$Integration$One$integrationDescription = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$integrationDescription(partner);
};
var $author$project$Pages$Admin$Integrations$Slug_String$isZion = function (integration) {
	return $author$project$Api$Provider$Integration$One$name(integration) === 'Zion Health';
};
var $author$project$Api$Provider$Partner$Shared$logoUrl = function (_v0) {
	var record = _v0;
	return record.S8;
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$logoUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Partner$Shared$logoUrl(shared);
};
var $author$project$Api$Provider$Integration$One$logoUrl = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$logoUrl(partner);
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$marketingUrl = function (_v0) {
	var record = _v0.b;
	return record.Tl;
};
var $author$project$Api$Provider$Integration$One$marketingUrl = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$marketingUrl(partner);
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$productDescription = function (_v0) {
	var record = _v0.b;
	return record.Xb;
};
var $author$project$Api$Provider$Integration$One$productDescription = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$productDescription(partner);
};
var $author$project$Pages$Admin$Integrations$Slug_String$showIntegrateButton = function (integration) {
	return ($author$project$Api$Provider$Integration$One$status(integration) === 'inactive') && ($author$project$Api$Provider$Integration$One$active(integration) && $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration));
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$signupUrl = function (_v0) {
	var record = _v0.b;
	return record.Z6;
};
var $author$project$Api$Provider$Integration$One$signupUrl = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$signupUrl(partner);
};
var $author$project$Api$Provider$Partner$ForIntegrationOne$supportUrl = function (_v0) {
	var record = _v0.b;
	return record.$a;
};
var $author$project$Api$Provider$Integration$One$supportUrl = function (_v0) {
	var partner = _v0.b;
	return $author$project$Api$Provider$Partner$ForIntegrationOne$supportUrl(partner);
};
var $author$project$Api$Provider$Addon$Min$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Api$Provider$Addon$Shared$url = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Addon$Min$url(min);
};
var $author$project$Components$Admin$PartnerApp$Manage$Settings = 1;
var $author$project$Components$Admin$PartnerApp$Manage$sections = function (partnerApp) {
	return A2(
		$elm$core$List$cons,
		0,
		(!_Utils_eq(
			$author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp),
			$elm$core$Maybe$Nothing)) ? _List_fromArray(
			[1]) : _List_Nil);
};
var $author$project$Components$Admin$PartnerApp$Manage$SectionChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Common$PartnerApp$Anchor$settingsLabel = function (_v0) {
	var record = _v0;
	var _v1 = record.ahI;
	switch (_v1) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return record.ZE;
	}
};
var $author$project$Components$Admin$PartnerApp$Manage$sectionName = F2(
	function (partnerApp, section) {
		if (!section) {
			return 'Manage User Access';
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				'Settings',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$PartnerApp$Anchor$settingsLabel,
					$author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp)));
		}
	});
var $author$project$Components$Admin$PartnerApp$Manage$sectionsToNavItem = F3(
	function (partnerApp, currentSection, section) {
		var isActive = function () {
			var _v0 = _Utils_Tuple2(currentSection, section);
			_v0$2:
			while (true) {
				if (!_v0.a.$) {
					if (!_v0.b) {
						var _v1 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				} else {
					if (_v0.b === 1) {
						var _v2 = _v0.b;
						return true;
					} else {
						break _v0$2;
					}
				}
			}
			return false;
		}();
		return A2(
			$author$project$Ui$Nav$item,
			_List_fromArray(
				[
					$author$project$Ui$Nav$activeItem(isActive),
					$author$project$Ui$Nav$onItemClick(
					$author$project$Components$Admin$PartnerApp$Manage$SectionChanged(section))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Components$Admin$PartnerApp$Manage$sectionName, partnerApp, section))
				]));
	});
var $author$project$Components$Admin$PartnerApp$Settings$view = function (_v0) {
	var model = _v0;
	var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(model.VB);
	if (!settingsAnchor.$) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('partner-app-settings-wrapper'),
					$elm$html$Html$Attributes$id('partner-app-settings')
				]),
			_List_Nil);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Admin$PartnerApp$Team$AddTeamMember = {$: 4};
var $author$project$Components$Admin$PartnerApp$Team$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SortTable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$columns = function (partnerApp) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, 'email', false, 'Email'),
			$elm$core$List$isEmpty(
				$author$project$Api$Common$PartnerApp$Shared$partnerRoles(partnerApp)) ? _List_Nil : _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'custom_partner_role', false, 'Partner Role')
				])));
};
var $author$project$Ui$Element$FullWidth = {$: 15};
var $author$project$Ui$Element$fullWidth = $author$project$Ui$Element$FullWidth;
var $author$project$Components$Admin$PartnerApp$Team$AutoGrantChanged = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$DefaultRoleChanged = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Admin$PartnerApp$Team$SaveSettings = {$: 17};
var $author$project$Components$Admin$PartnerApp$Team$viewSettings = function (model) {
	var settingsLoading = _Utils_eq(model.od, $author$project$Api$Data$Loading);
	var partnerRoles = $author$project$Api$Common$PartnerApp$Shared$partnerRoles(model.VB);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Access Settings')
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(6),
								$author$project$Ui$Form$Group$inputSpan(6),
								$author$project$Ui$Form$Group$label('Automatically grant access to new team members')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(model.dd.abq),
										$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$PartnerApp$Team$AutoGrantChanged)
									]))
							])),
						$elm$core$List$isEmpty(partnerRoles) ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(6),
								$author$project$Ui$Form$Group$inputSpan(6),
								$author$project$Ui$Form$Group$label('Default role for new team members')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(model.dd.acA),
										$author$project$Ui$Form$Select$onChange($author$project$Components$Admin$PartnerApp$Team$DefaultRoleChanged)
									]),
								A2($author$project$Components$Admin$PartnerApp$Team$roleOptions, 'No default role', partnerRoles))
							]))
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Save access settings'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(settingsLoading),
								$author$project$Ui$Button$onClick($author$project$Components$Admin$PartnerApp$Team$SaveSettings)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Admin$PartnerApp$Team$EditTeamMember = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Table$Info = 2;
var $author$project$Ui$Padding$Left_2 = 3;
var $author$project$Components$Admin$PartnerApp$Team$OpenDeleteConfirm = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Platform$User$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Ui$Table$Styled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Table$styled = $author$project$Ui$Table$Styled;
var $author$project$Components$Admin$PartnerApp$Team$viewTeamMember = F4(
	function (currentUser, partnerApp, deletingTeamMembers, teamMember) {
		var isCurrentUser = _Utils_eq(
			$author$project$Api$Provider$PartnerAppUser$All$email(teamMember),
			$author$project$Api$Platform$User$Shared$email(currentUser));
		var rowOptions = isCurrentUser ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(2)
			]) : _List_Nil;
		var id = $author$project$Api$Provider$PartnerAppUser$All$id(teamMember);
		var loading = A2($elm$core$Set$member, id, deletingTeamMembers);
		return A2(
			$author$project$Ui$Table$row,
			rowOptions,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$User$One$name,
											$author$project$Api$Provider$PracticeUser$Shared$user(
												$author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember)))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$PartnerAppUser$All$email(teamMember))
								]))
						]),
						$elm$core$List$isEmpty(
						$author$project$Api$Common$PartnerApp$Shared$partnerRoles(partnerApp)) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize),
											$elm$core$List$head(
												$author$project$Api$Provider$PartnerAppUser$All$partnerRoles(teamMember)))))
								]))
						]),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[$author$project$Ui$Table$textRight]),
							_List_fromArray(
								[
									$elm$core$List$isEmpty(
									$author$project$Api$Common$PartnerApp$Shared$partnerRoles(partnerApp)) ? $author$project$Utils$Html$empty : A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$disabled(
											loading || (!$author$project$Api$Platform$User$Shared$isAdmin(currentUser))),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$PartnerApp$Team$EditTeamMember(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$PartnerApp$Team$OpenDeleteConfirm(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
											$author$project$Ui$Button$padding(3)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						])
					])));
	});
var $author$project$Components$Admin$PartnerApp$Team$view = function (_v0) {
	var model = _v0;
	var _v1 = function () {
		var _v2 = model.eK;
		if (_v2.$ === 3) {
			var teamMembers_ = _v2.a;
			return _Utils_Tuple2(false, teamMembers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v1.a;
	var teamMembers = _v1.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Admin$PartnerApp$Team$viewSettings(model),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$fullWidth]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$PartnerApp$Team$SearchInputMsg,
												A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Add user'},
										_List_fromArray(
											[
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
												$author$project$Ui$Button$onClick($author$project$Components$Admin$PartnerApp$Team$AddTeamMember)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add User')
											]))
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$verticalCentered,
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('No users are allowed to access this integration.')
									])),
								$author$project$Ui$Table$loading(loading)
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									A2(
									$elm$core$List$map,
									$author$project$Api$Column$view(
										A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Admin$PartnerApp$Team$SortTable)),
									$author$project$Components$Admin$PartnerApp$Team$columns(model.VB)),
									_List_fromArray(
									[
										A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
									])
								])),
						A2(
							$elm$core$List$map,
							A3($author$project$Components$Admin$PartnerApp$Team$viewTeamMember, model.EQ, model.VB, model.dU),
							teamMembers),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$PartnerApp$Team$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.eK))
										]),
									model.afy))
							]))
					]))
			]));
};
var $author$project$Components$Admin$PartnerApp$Manage$toPane = function (sectionModel) {
	if (!sectionModel.$) {
		var partnerAppTeam = sectionModel.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg,
			$author$project$Components$Admin$PartnerApp$Team$view(partnerAppTeam));
	} else {
		var partnerAppSettings = sectionModel.a;
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Admin$PartnerApp$Manage$PartnerAppSettingsMsg,
							$author$project$Components$Admin$PartnerApp$Settings$view(partnerAppSettings))
						]))
				]));
	}
};
var $author$project$Components$Admin$PartnerApp$Manage$view = function (_v0) {
	var model = _v0;
	var sectionNavItems = A2(
		$elm$core$List$map,
		A2($author$project$Components$Admin$PartnerApp$Manage$sectionsToNavItem, model.VB, model.cn),
		$author$project$Components$Admin$PartnerApp$Manage$sections(model.VB));
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('layout-header')
							]),
						_List_fromArray(
							[
								A3($author$project$Ui$Nav$view, _List_Nil, sectionNavItems, model.m8)
							])),
						$author$project$Components$Admin$PartnerApp$Manage$toPane(model.cn)
					]))
			]));
};
var $author$project$Pages$Admin$Integrations$Slug_String$viewPanel = F2(
	function (model, integration) {
		var supportUrl = $author$project$Api$Provider$Integration$One$supportUrl(integration);
		var status = $author$project$Api$Provider$Integration$One$status(integration);
		var name = $author$project$Api$Provider$Integration$One$name(integration);
		var marketingUrl = $author$project$Api$Provider$Integration$One$marketingUrl(integration);
		var email = $author$project$Api$Provider$Integration$One$email(integration);
		var deactivateStates = _List_fromArray(
			['active', 'pending', 'requested']);
		var addon = $author$project$Api$Provider$Integration$One$addon(integration);
		var addonUrl = A2($elm$core$Maybe$map, $author$project$Api$Provider$Addon$Shared$url, addon);
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = A2(
								$elm$core$Maybe$andThen,
								$author$project$Utils$String$toMaybe,
								$author$project$Api$Provider$Integration$One$logoUrl(integration));
							if (!_v0.$) {
								var url = _v0.a;
								return A3(
									$author$project$Ui$Image$fromSrc,
									{I1: name},
									url,
									_List_fromArray(
										[
											$author$project$Ui$Image$height(30)
										]));
							} else {
								return $author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Status'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Ui$Badge$fromString, _List_Nil, status),
											A2($elm$core$List$member, status, deactivateStates) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Cancel integration'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$pull(1),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Integrations$Slug_String$Deactivate(integration))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel Integration')
												])) : $author$project$Utils$Html$empty
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(''),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v1 = _Utils_Tuple2(
												$author$project$Api$Provider$Integration$One$active(integration),
												status);
											_v1$2:
											while (true) {
												if (!_v1.a) {
													switch (_v1.b) {
														case 'inactive':
															return A2(
																$author$project$Ui$Alert$info,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('This isn\'t ready yet! But you can let us know you\'d like this integration by requesting it below. This does not commit you to actually integrating with them.')
																	]));
														case 'requested':
															return A2(
																$author$project$Ui$Alert$success,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Thanks for letting us know! We\'ll keep you posted on progress towards this integration.')
																	]));
														default:
															break _v1$2;
													}
												} else {
													break _v1$2;
												}
											}
											return $author$project$Utils$Html$empty;
										}(),
											$author$project$Pages$Admin$Integrations$Slug_String$showIntegrateButton(integration) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Integrate with ' + name},
											_List_fromArray(
												[
													$author$project$Ui$Button$primary,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Integrations$Slug_String$Activate(integration))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Integrate with ' + name)
												])) : $author$project$Utils$Html$empty,
											((status === 'inactive') && (!$author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration))) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Integration with' + name},
											_List_fromArray(
												[
													$author$project$Ui$Button$primary,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Integrations$Slug_String$Activate(integration))
												]),
											_List_fromArray(
												[
													$author$project$Api$Provider$Integration$One$active(integration) ? $elm$html$Html$text('Integrate') : $elm$html$Html$text('I\'m Interested in Integrating'),
													$elm$html$Html$text(' with '),
													$elm$html$Html$text(name)
												])) : $author$project$Utils$Html$empty,
											(status === 'active') ? A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$success]),
											_List_fromArray(
												[
													$elm$html$Html$text('Congratulations! You\'ve successfully integrated with '),
													$elm$html$Html$text(name)
												])) : $author$project$Utils$Html$empty,
											((status === 'pending') && $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration)) ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$em,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('If you haven\'t been contacted by '),
																	$elm$html$Html$text(name),
																	$elm$html$Html$text(' about next steps for this integration, then something probably went wrong.')
																]))
														])),
													A3(
													$author$project$Ui$Link$externalHref,
													A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Api$Provider$Integration$One$connectionUrl(integration)),
													_List_fromArray(
														[$author$project$Ui$Link$targetBlank, $author$project$Ui$Link$buttonPrimary]),
													_List_fromArray(
														[
															$elm$html$Html$text('Try again')
														]))
												])) : $author$project$Utils$Html$empty
										]))
								])),
							function () {
							var _v2 = _Utils_Tuple2(status, addonUrl);
							if ((_v2.a === 'active') && (!_v2.b.$)) {
								var addonUrl_ = _v2.b.a;
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Signup Url'),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$pre,
													_List_fromArray(
														[$author$project$Ui$Typography$authorizationCode]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($elm$core$Maybe$withDefault, 'N/A', addonUrl_))
														])),
													A2(
													$author$project$Ui$Typography$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Give this unique link to your patients who wish to join '),
															$elm$html$Html$text(name),
															$elm$html$Html$text('.')
														])),
													A2(
													$author$project$Ui$Typography$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('To add '),
															$elm$html$Html$text(name),
															$elm$html$Html$text(' enrollment to your signup pages, check off the '),
															$elm$html$Html$text(name),
															$elm$html$Html$text(' box on the signup pages in your '),
															A3(
															$author$project$Ui$Link$externalHref,
															$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__SignupPages__Top),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Online Signup')
																])),
															$elm$html$Html$text(' settings.')
														]))
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							((status === 'pending') && ($author$project$Api$Provider$Integration$One$active(integration) && (!$author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration)))) ? A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Authorization Code'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$pre,
											_List_fromArray(
												[$author$project$Ui$Typography$authorizationCode]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														$author$project$Api$Provider$Integration$One$authorizationCode(integration)))
												])),
											A2(
											$author$project$Ui$Alert$warning,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$em,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(name),
															$elm$html$Html$text(' does not support automatic integrations yet. Please email them at'),
															A3(
															$author$project$Ui$Link$mailto,
															A2($elm$core$Maybe$withDefault, '', email),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($elm$core$Maybe$withDefault, '', email))
																])),
															$elm$html$Html$text(' and they can provide you with next steps.')
														]))
												]))
										]))
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('About'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									function () {
										if (!addon.$) {
											return _List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'',
																$author$project$Api$Provider$Integration$One$productDescription(integration)))
														]))
												]);
										} else {
											return _List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$p,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'No information provided yet. Please contact ' + (name + ' for more.'),
																$author$project$Api$Provider$Integration$One$productDescription(integration)))
														])),
													($author$project$Utils$Maybe$toBool(marketingUrl) || $author$project$Utils$Maybe$toBool(
													$author$project$Api$Provider$Integration$One$signupUrl(integration))) ? A2(
													$author$project$Ui$Typography$p,
													_List_Nil,
													_List_fromArray(
														[
															function () {
															var _v4 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, marketingUrl);
															if (!_v4.$) {
																var marketingUrl_ = _v4.a;
																return A2(
																	$author$project$Ui$Typography$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Learn more '),
																			A3(
																			$author$project$Ui$Link$externalHref,
																			marketingUrl_,
																			_List_fromArray(
																				[$author$project$Ui$Link$targetBlank]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('here')
																				])),
																			$elm$html$Html$text('.')
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}(),
															$author$project$Utils$Html$noBreakSpace,
															function () {
															var _v5 = A2(
																$elm$core$Maybe$andThen,
																$author$project$Utils$String$toMaybe,
																$author$project$Api$Provider$Integration$One$signupUrl(integration));
															if (!_v5.$) {
																var signupUrl = _v5.a;
																return A2(
																	$author$project$Ui$Typography$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Signup '),
																			A3(
																			$author$project$Ui$Link$externalHref,
																			signupUrl,
																			_List_fromArray(
																				[$author$project$Ui$Link$targetBlank]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('here')
																				])),
																			$elm$html$Html$text('.')
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}()
														])) : $author$project$Utils$Html$empty
												]);
										}
									}())
								])),
							function () {
							if (!addon.$) {
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label(name + ' Resources'),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											$author$project$Pages$Admin$Integrations$Slug_String$isZion(integration) ? _List_fromArray(
												[
													$elm$html$Html$text('For resources about membership in the Zion Health healthshare, '),
													A3(
													$author$project$Ui$Link$externalHref,
													A2($elm$core$Maybe$withDefault, '', marketingUrl),
													_List_fromArray(
														[$author$project$Ui$Link$targetBlank]),
													_List_fromArray(
														[
															$elm$html$Html$text('click here')
														])),
													$elm$html$Html$text('.')
												]) : _List_Nil)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							$author$project$Utils$Maybe$toBool(addon) ? A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Support'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('If you need any support from '),
											$elm$html$Html$text(name),
											$elm$html$Html$text(', '),
											$author$project$Pages$Admin$Integrations$Slug_String$isZion(integration) ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('email '),
													A3(
													$author$project$Ui$Link$mailto,
													A2($elm$core$Maybe$withDefault, '', email),
													_List_fromArray(
														[$author$project$Ui$Link$targetBlank]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2($elm$core$Maybe$withDefault, '', email))
														])),
													$elm$html$Html$text('.')
												])) : $author$project$Utils$Html$empty
										]))
								])) : $author$project$Utils$Html$empty,
							(!$author$project$Utils$Maybe$toBool(addon)) ? A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('What To Expect'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'No information provided yet. Please contact ' + (name + ' for more.'),
												A2(
													$elm$core$Maybe$andThen,
													$author$project$Utils$String$toMaybe,
													$author$project$Api$Provider$Integration$One$integrationDescription(integration))))
										]))
								])) : $author$project$Utils$Html$empty,
							((!$author$project$Utils$Maybe$toBool(addon)) && ($author$project$Utils$Maybe$toBool(supportUrl) || $author$project$Utils$Maybe$toBool(email))) ? A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Support'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('If you need any support from '),
											$elm$html$Html$text(name),
											$elm$html$Html$text(','),
											function () {
											var _v7 = _Utils_Tuple2(supportUrl, email);
											if (!_v7.a.$) {
												var supportUrl_ = _v7.a.a;
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(' please go '),
															A3(
															$author$project$Ui$Link$externalHref,
															supportUrl_,
															_List_fromArray(
																[$author$project$Ui$Link$targetBlank]),
															_List_fromArray(
																[
																	$elm$html$Html$text('here')
																])),
															$elm$html$Html$text('.')
														]));
											} else {
												if (!_v7.b.$) {
													var _v8 = _v7.a;
													var email_ = _v7.b.a;
													return A2(
														$author$project$Ui$Typography$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(' please click '),
																A3(
																$author$project$Ui$Link$mailto,
																email_,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('here')
																	])),
																$elm$html$Html$text('.')
															]));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}
										}()
										]))
								])) : $author$project$Utils$Html$empty,
							function () {
							var _v9 = model.c5;
							if (!_v9.$) {
								var partnerAppManage = _v9.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg,
									$author$project$Components$Admin$PartnerApp$Manage$view(partnerAppManage));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Admin$Integrations$Slug_String$view = function (model) {
	var integrationName = function () {
		var _v7 = model.Q4;
		if (_v7.$ === 3) {
			var integration = _v7.a;
			return $author$project$Api$Provider$Integration$One$name(integration);
		} else {
			return '';
		}
	}();
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.bH;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var integration = _v1.a;
					var request = _v1.b;
					var verbPrefix = $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration) ? 'Connect with ' : 'Enable ';
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Integrations$Slug_String$ActivateHiConfirmClosed(integration),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb(
								_Utils_ap(
									verbPrefix,
									$author$project$Api$Provider$Integration$One$name(integration))),
								$author$project$Components$HiConfirm$customMessage(
								$author$project$Pages$Admin$Integrations$Slug_String$disclaimerMessage(integration)),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(request, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.dC;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var integration = _v3.a;
					var request = _v3.b;
					var status = $author$project$Api$Provider$Integration$One$status(integration);
					var _v4 = (status === 'active') ? _Utils_Tuple2(
						'deactivate',
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to deactivate '),
								$elm$html$Html$text(
								$author$project$Api$Provider$Integration$One$name(integration)),
								$elm$html$Html$text('? This will immediately cease the integration, and reactivating may take time.')
							])) : (((status === 'pending') || (status === 'requested')) ? _Utils_Tuple2(
						'cancel integration',
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to cancel your pending integration with '),
								$elm$html$Html$text(
								$author$project$Api$Provider$Integration$One$name(integration)),
								$elm$html$Html$text('?')
							])) : _Utils_Tuple2('', _List_Nil));
					var verb = _v4.a;
					var customMessage = _v4.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Integrations$Slug_String$DeactivateHiConfirmClosed(integration),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb(verb),
								$author$project$Components$HiConfirm$customMessage(customMessage),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(request, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.c5;
				if (!_v5.$) {
					var partnerAppManage = _v5.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg,
						$author$project$Components$Admin$PartnerApp$Manage$modal(partnerAppManage));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v6 = model.Q4;
				if (_v6.$ === 3) {
					var integration = _v6.a;
					return A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$horizontal,
								$author$project$Ui$Form$autocomplete(true),
								$author$project$Ui$Form$noValidate(true)
							]),
						_List_fromArray(
							[
								A2($author$project$Pages$Admin$Integrations$Slug_String$viewPanel, model, integration)
							]));
				} else {
					return A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]),
		$G: 'Integrations | ' + integrationName
	};
};
var $author$project$Pages$Admin$Integrations$Slug_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Integrations$Slug_String$init, aer: $author$project$Pages$Admin$Integrations$Slug_String$load, agD: $author$project$Pages$Admin$Integrations$Slug_String$save, ahd: $author$project$Pages$Admin$Integrations$Slug_String$subscriptions, aaq: $author$project$Pages$Admin$Integrations$Slug_String$update, ahP: $author$project$Pages$Admin$Integrations$Slug_String$view});
var $author$project$Pages$Admin$InternalSettings$GotCurrentGroup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$InternalSettings$GotGroups = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$ManagementGroup$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['management_groups']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ManagementGroup$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ManagementGroup$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$listPath));
	});
var $author$project$Pages$Admin$InternalSettings$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		return _Utils_Tuple2(
			{D5: apiClient, p3: $elm$core$Maybe$Nothing, xL: _List_Nil},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$ManagementGroup$getCurrent, apiClient, $author$project$Pages$Admin$InternalSettings$GotCurrentGroup),
						A2($author$project$Api$Provider$ManagementGroup$list, apiClient, $author$project$Pages$Admin$InternalSettings$GotGroups)
					])));
	});
var $author$project$Pages$Admin$InternalSettings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$InternalSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$InternalSettings$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$InternalSettings$ManagementGroupSaved = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ManagementGroup$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$ManagementGroup$update = F3(
	function (apiClient, id, toMsg) {
		var params = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$elm$json$Json$Decode$maybe($author$project$Api$Provider$ManagementGroup$Shared$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath)));
	});
var $author$project$Pages$Admin$InternalSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var dataGroup = msg.a;
				switch (dataGroup.$) {
					case 3:
						var group = dataGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									p3: $elm$core$Maybe$Just(group)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = dataGroup.a;
						if (error.$ === 5) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{p3: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(dataGroup));
						}
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataGroup));
				}
			case 1:
				var dataGroups = msg.a;
				if (dataGroups.$ === 3) {
					var groups = dataGroups.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{xL: groups}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataGroups));
				}
			case 2:
				var groupId = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Provider$ManagementGroup$update, model.D5, groupId, $author$project$Pages$Admin$InternalSettings$ManagementGroupSaved),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					if (!response.a.$) {
						var group = response.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully updated management group to ' + $author$project$Api$Provider$ManagementGroup$Shared$name(group))
								]));
					} else {
						var _v5 = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully removed management group')
								]));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$InternalSettings$ManagementGroupSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$ManagementGroup$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Pages$Admin$InternalSettings$managementGroupOptions = function (model) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'None'),
		A2(
			$elm$core$List$map,
			function (managementGroup) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$ManagementGroup$Shared$id(managementGroup)),
					$author$project$Api$Provider$ManagementGroup$Shared$name(managementGroup));
			},
			model.xL));
};
var $author$project$Pages$Admin$InternalSettings$viewManagementGroupSelection = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Management Group'),
				$author$project$Ui$Form$Group$labelSpanMd(3),
				$author$project$Ui$Form$Group$inputSpanMd(4),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						A2($elm$core$Maybe$map, $author$project$Api$Provider$ManagementGroup$Shared$id, model.p3)),
						$author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$InternalSettings$ManagementGroupSelected)
					]),
				$author$project$Pages$Admin$InternalSettings$managementGroupOptions(model))
			]));
};
var $author$project$Pages$Admin$InternalSettings$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Internal Settings')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$InternalSettings$viewManagementGroupSelection(model)
							]))
					]))
			]),
		$G: 'Admin | Internal Settings'
	};
};
var $author$project$Pages$Admin$InternalSettings$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$InternalSettings$init, aer: $author$project$Pages$Admin$InternalSettings$load, agD: $author$project$Pages$Admin$InternalSettings$save, ahd: $author$project$Pages$Admin$InternalSettings$subscriptions, aaq: $author$project$Pages$Admin$InternalSettings$update, ahP: $author$project$Pages$Admin$InternalSettings$view});
var $author$project$Pages$Admin$InvoiceSettings$GotCompanyInvoiceSetting = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$GotPaymentSourceSetting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Practice$One$companyInvoiceSetting = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lu;
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.adR;
};
var $author$project$Api$Provider$PaymentSourceSetting$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.adR;
};
var $author$project$Api$Provider$Practice$One$paymentSourceSetting = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.V4;
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['company_invoice_settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingsPath);
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$ForPractice = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$Record = function (invoiceUpcomingAutoSend) {
	return function (invoiceAutoSend) {
		return function (invoiceAutoSendDay) {
			return function (invoiceAutoSendMonth) {
				return function (invoiceAutoIssue) {
					return function (invoiceAutoIssueDay) {
						return function (invoiceAutoIssueMonth) {
							return function (invoiceDueDay) {
								return function (invoiceDueMonth) {
									return function (invoiceAutoPay) {
										return function (invoiceAutoPayDay) {
											return function (invoiceAutoPayMonth) {
												return function (invoiceGracePeriodDays) {
													return function (chargePhiDetailsEnabled) {
														return function (chargePhiDetailsUpdatedAt) {
															return function (chargePhiDetailsUpdatedBy) {
																return function (chargeRouteToRecurringInvoice) {
																	return function (billingEnabled) {
																		return function (billingStartDate) {
																			return function (hideSponsorInvoices) {
																				return {Eg: billingEnabled, J$: billingStartDate, KR: chargePhiDetailsEnabled, KS: chargePhiDetailsUpdatedAt, KT: chargePhiDetailsUpdatedBy, Ey: chargeRouteToRecurringInvoice, Qp: hideSponsorInvoices, Ri: invoiceAutoIssue, Rj: invoiceAutoIssueDay, FK: invoiceAutoIssueMonth, Rk: invoiceAutoPay, FL: invoiceAutoPayDay, FM: invoiceAutoPayMonth, Rl: invoiceAutoSend, Rm: invoiceAutoSendDay, FN: invoiceAutoSendMonth, Ro: invoiceDueDay, FO: invoiceDueMonth, FP: invoiceGracePeriodDays, FQ: invoiceUpcomingAutoSend};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthAfter = 2;
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthBefore = 0;
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthOfTheInvoice = 1;
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString = function (option) {
	switch (option) {
		case 'month_before':
			return $elm$core$Maybe$Just(0);
		case 'month_of_the_invoice':
			return $elm$core$Maybe$Just(1);
		case 'month_after':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
		if (!_v0.$) {
			var option = _v0.a;
			return $elm$json$Json$Decode$succeed(option);
		} else {
			return $elm$json$Json$Decode$fail('Unsupported month configuration option: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hide_sponsor_invoices',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'billing_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'charge_route_to_recurring_invoice',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge_phi_details_updated_by',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'charge_phi_details_updated_at',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'charge_phi_details_enabled',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_grace_period_days',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'invoice_auto_pay_month',
									$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'invoice_auto_pay_day',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'invoice_auto_pay',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'invoice_due_month',
												$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'invoice_due_day',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'invoice_auto_issue_month',
														$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'invoice_auto_issue_day',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'invoice_auto_issue',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'invoice_auto_send_month',
																	$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'invoice_auto_send_day',
																		$elm$json$Json$Decode$int,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'invoice_auto_send',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'invoice_upcoming_auto_send',
																				$elm$json$Json$Decode$bool,
																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$Record)))))))))))))))))))));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id_)));
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$ForPractice = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$Record = F3(
	function (acceptsAch, acceptsCards, acceptsAmex) {
		return {H_: acceptsAch, H$: acceptsAmex, H0: acceptsCards};
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accepts_amex',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accepts_cards',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'accepts_ach',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$ForPractice$Record))));
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentSourceSetting$ForPractice$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['payment_source_settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingsPath);
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id_)));
	});
var $author$project$Pages$Admin$InvoiceSettings$init = F4(
	function (_v0, practice, shared, _v1) {
		var paymentSettingId = $author$project$Api$Provider$PaymentSourceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$paymentSourceSetting(practice));
		var companySettingId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				Lu: $author$project$Api$Data$Loading,
				cO: shared.cO,
				PB: $elm$core$Maybe$Nothing,
				iL: false,
				adR: companySettingId,
				FR: $author$project$Shared$isHintAdmin(shared),
				aL: $elm$core$Maybe$Nothing,
				rY: paymentSettingId,
				V4: $author$project$Api$Data$Loading,
				WF: practice
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, shared.D5, companySettingId, $author$project$Pages$Admin$InvoiceSettings$GotCompanyInvoiceSetting),
						A3($author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve, shared.D5, paymentSettingId, $author$project$Pages$Admin$InvoiceSettings$GotPaymentSourceSetting)
					])));
	});
var $author$project$Pages$Admin$InvoiceSettings$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cO: shared.cO}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$InvoiceSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$subscriptions = function (_v0) {
	var hiConfirmOpen = _v0.iL;
	return hiConfirmOpen ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$InvoiceSettings$updateMonthOptionField = F3(
	function (monthOption, updateField, fields) {
		return A2(
			$elm$core$Maybe$withDefault,
			fields,
			A2(
				$elm$core$Maybe$map,
				updateField,
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
	});
var $author$project$Pages$Admin$InvoiceSettings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{FQ: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Rl: bool});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rm: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
			case 3:
				var monthOption = field.a;
				return A2(
					$elm$core$Maybe$withDefault,
					fields,
					A2(
						$elm$core$Maybe$map,
						function (option) {
							return _Utils_update(
								fields,
								{FN: option});
						},
						$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ri: bool});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Rj: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
			case 6:
				var monthOption = field.a;
				return A2(
					$elm$core$Maybe$withDefault,
					fields,
					A2(
						$elm$core$Maybe$map,
						function (option) {
							return _Utils_update(
								fields,
								{FK: option});
						},
						$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
			case 7:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ro: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
			case 8:
				var monthOption = field.a;
				return A2(
					$elm$core$Maybe$withDefault,
					fields,
					A2(
						$elm$core$Maybe$map,
						function (option) {
							return _Utils_update(
								fields,
								{FO: option});
						},
						$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
			case 9:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Rk: bool});
			case 10:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						FL: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(string))
					});
			case 11:
				var monthOption = field.a;
				return A3(
					$author$project$Pages$Admin$InvoiceSettings$updateMonthOptionField,
					monthOption,
					function (option) {
						return _Utils_update(
							fields,
							{FM: option});
					},
					fields);
			case 12:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						FP: A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(string))
					});
			case 13:
				var bool = field.a;
				return _Utils_update(
					fields,
					{KR: bool});
			case 14:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ey: bool});
			case 15:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Eg: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Qp: bool});
		}
	});
var $author$project$Pages$Admin$InvoiceSettings$IssueDateValidation = 0;
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt = function (option) {
	switch (option) {
		case 0:
			return -1;
		case 1:
			return 0;
		default:
			return 1;
	}
};
var $author$project$Pages$Admin$InvoiceSettings$isOnOrAfter = F2(
	function (_v0, _v1) {
		var firstDay = _v0.a;
		var firstMonth = _v0.b;
		var secondDay = _v1.a;
		var secondMonth = _v1.b;
		var secondMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(secondMonth);
		var firstMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(firstMonth);
		return _Utils_eq(firstMonthInt, secondMonthInt) ? (_Utils_cmp(firstDay, secondDay) < 1) : (_Utils_cmp(firstMonthInt, secondMonthInt) < 0);
	});
var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate = function (form) {
	return (form.Rk && form.Ri) ? A2(
		$author$project$Pages$Admin$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(form.Rj, form.FK),
		_Utils_Tuple2(form.FL, form.FM)) : true;
};
var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate,
	_Utils_Tuple2(0, 'The Issue date must be before or on the autopay date'));
var $author$project$Pages$Admin$InvoiceSettings$AutoPayDateValidation = 1;
var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate = function (form) {
	return (form.Rl && form.Rk) ? A2(
		$author$project$Pages$Admin$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(form.Rm, form.FN),
		_Utils_Tuple2(form.FL, form.FM)) : true;
};
var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(1, 'The autopay date must be on or after the Invoice Created notification date'));
var $author$project$Pages$Admin$InvoiceSettings$DueDateValidation = 2;
var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate = function (form) {
	return form.Rk ? A2(
		$author$project$Pages$Admin$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(form.FL, form.FM),
		_Utils_Tuple2(form.Ro, form.FO)) : true;
};
var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate,
	_Utils_Tuple2(2, 'The invoice must be due on or after the autopay date'));
var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate = function (form) {
	return (form.Rk || (!form.Rl)) ? true : A2(
		$author$project$Pages$Admin$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(form.Rm, form.FN),
		_Utils_Tuple2(form.Ro, form.FO));
};
var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(2, 'The invoice must be due on or after the Invoice Created notification date'));
var $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingValidation = 3;
var $author$project$Pages$Admin$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function (_v0) {
		var invoiceUpcomingAutoSend = _v0.FQ;
		var invoiceAutoSend = _v0.Rl;
		return invoiceUpcomingAutoSend ? invoiceAutoSend : true;
	},
	_Utils_Tuple2(3, 'This notification can only be enabled if the Invoice Created notification is also enabled'));
var $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Pages$Admin$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator, $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator, $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator, $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator, $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator]));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled = function (_v0) {
	var forPractice = _v0;
	return forPractice.Eg;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled = function (_v0) {
	var forPractice = _v0;
	return forPractice.KR;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ey;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices = function (_v0) {
	var forPractice = _v0;
	return forPractice.Qp;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ri;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Rj;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth = function (_v0) {
	var forPractice = _v0;
	return forPractice.FK;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Rk;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay = function (_v0) {
	var forPractice = _v0;
	return forPractice.FL;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth = function (_v0) {
	var forPractice = _v0;
	return forPractice.FM;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend = function (_v0) {
	var forPractice = _v0;
	return forPractice.Rl;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Rm;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth = function (_v0) {
	var forPractice = _v0;
	return forPractice.FN;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay = function (_v0) {
	var forPractice = _v0;
	return forPractice.Ro;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth = function (_v0) {
	var forPractice = _v0;
	return forPractice.FO;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays = function (_v0) {
	var forPractice = _v0;
	return forPractice.FP;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend = function (_v0) {
	var forPractice = _v0;
	return forPractice.FQ;
};
var $author$project$Pages$Admin$InvoiceSettings$initFormFields = function (companyInvoiceSetting) {
	return _Utils_Tuple2(
		{
			Eg: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(companyInvoiceSetting),
			KR: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled(companyInvoiceSetting),
			Ey: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice(companyInvoiceSetting),
			Qp: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices(companyInvoiceSetting),
			Ri: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue(companyInvoiceSetting),
			Rj: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay(companyInvoiceSetting),
			FK: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth(companyInvoiceSetting),
			Rk: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay(companyInvoiceSetting),
			FL: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay(companyInvoiceSetting),
			FM: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth(companyInvoiceSetting),
			Rl: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend(companyInvoiceSetting),
			Rm: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay(companyInvoiceSetting),
			FN: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth(companyInvoiceSetting),
			Ro: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay(companyInvoiceSetting),
			FO: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth(companyInvoiceSetting),
			FP: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays(companyInvoiceSetting),
			FQ: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend(companyInvoiceSetting)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch = function (_v0) {
	var forPractice = _v0;
	return forPractice.H_;
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex = function (_v0) {
	var forPractice = _v0;
	return forPractice.H$;
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards = function (_v0) {
	var forPractice = _v0;
	return forPractice.H0;
};
var $author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields = function (paymentSourceSetting) {
	return {
		H_: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch(paymentSourceSetting),
		H$: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex(paymentSourceSetting),
		H0: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards(paymentSourceSetting)
	};
};
var $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{H_: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{H$: bool, H0: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{H$: bool});
		}
	});
var $author$project$Pages$Admin$InvoiceSettings$AcceptsAmexValidation = 0;
var $author$project$Pages$Admin$InvoiceSettings$sponsorAcceptsAllCards = function (form) {
	return !((!form.H0) && form.H$);
};
var $author$project$Pages$Admin$InvoiceSettings$acceptsAmexValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Admin$InvoiceSettings$sponsorAcceptsAllCards,
	_Utils_Tuple2(0, 'If the sponsor does not accept cards they cannot accept Amex'));
var $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Pages$Admin$InvoiceSettings$acceptsAmexValidator]));
var $author$project$Pages$Admin$InvoiceSettings$CompanyInvoiceSettingUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString = function (option) {
	switch (option) {
		case 0:
			return 'month_before';
		case 1:
			return 'month_of_the_invoice';
		default:
			return 'month_after';
	}
};
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder = function (monthOption) {
	return $elm$json$Json$Encode$string(
		$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(monthOption));
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company_invoice_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'invoice_upcoming_auto_send',
								$elm$json$Json$Encode$bool(fields.FQ)),
								_Utils_Tuple2(
								'invoice_auto_send',
								$elm$json$Json$Encode$bool(fields.Rl)),
								_Utils_Tuple2(
								'invoice_auto_send_day',
								$elm$json$Json$Encode$int(fields.Rm)),
								_Utils_Tuple2(
								'invoice_auto_send_month',
								$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.FN)),
								_Utils_Tuple2(
								'invoice_auto_issue',
								$elm$json$Json$Encode$bool(fields.Ri)),
								_Utils_Tuple2(
								'invoice_auto_issue_day',
								$elm$json$Json$Encode$int(fields.Rj)),
								_Utils_Tuple2(
								'invoice_auto_issue_month',
								$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.FK)),
								_Utils_Tuple2(
								'invoice_due_day',
								$elm$json$Json$Encode$int(fields.Ro)),
								_Utils_Tuple2(
								'invoice_due_month',
								$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.FO)),
								_Utils_Tuple2(
								'invoice_auto_pay',
								$elm$json$Json$Encode$bool(fields.Rk)),
								_Utils_Tuple2(
								'invoice_auto_pay_day',
								$elm$json$Json$Encode$int(fields.FL)),
								_Utils_Tuple2(
								'invoice_auto_pay_month',
								$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.FM)),
								_Utils_Tuple2(
								'invoice_grace_period_days',
								$elm$json$Json$Encode$int(fields.FP)),
								_Utils_Tuple2(
								'charge_phi_details_enabled',
								$elm$json$Json$Encode$bool(fields.KR)),
								_Utils_Tuple2(
								'charge_route_to_recurring_invoice',
								$elm$json$Json$Encode$bool(fields.Ey)),
								_Utils_Tuple2(
								'billing_enabled',
								$elm$json$Json$Encode$bool(fields.Eg)),
								_Utils_Tuple2(
								'hide_sponsor_invoices',
								$elm$json$Json$Encode$bool(fields.Qp))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id))));
	});
var $author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting = F3(
	function (apiClient, id, formFields) {
		var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var flattenedForm = {Eg: validated.Eg, KR: validated.KR, Ey: validated.Ey, Qp: validated.Qp, Ri: validated.Ri, Rj: validated.Rj, FK: validated.FK, Rk: validated.Rk, FL: validated.FL, FM: validated.FM, Rl: validated.Rl, Rm: validated.Rm, FN: validated.FN, Ro: validated.Ro, FO: validated.FO, FP: validated.FP, FQ: validated.FQ};
		return A4($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$update, apiClient, id, flattenedForm, $author$project$Pages$Admin$InvoiceSettings$CompanyInvoiceSettingUpdated);
	});
var $author$project$Pages$Admin$InvoiceSettings$PaymentSourceSettingUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_source_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'accepts_ach',
								$elm$json$Json$Encode$bool(fields.H_)),
								_Utils_Tuple2(
								'accepts_cards',
								$elm$json$Json$Encode$bool(fields.H0)),
								_Utils_Tuple2(
								'accepts_amex',
								$elm$json$Json$Encode$bool(fields.H$))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id))));
	});
var $author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting = F3(
	function (apiClient, id, formFields) {
		return A4(
			$author$project$Api$Provider$PaymentSourceSetting$ForPractice$update,
			apiClient,
			id,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Admin$InvoiceSettings$PaymentSourceSettingUpdated);
	});
var $author$project$Pages$Admin$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting = function (model) {
	var _v0 = _Utils_Tuple2(model.PB, model.aL);
	if (!_v0.a.$) {
		if (_v0.b.$ === 1) {
			var form = _v0.a.a;
			var _v1 = _v0.b;
			var _v2 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator, form);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var newForm = _v3.a;
				var validFormFields = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Lu: $author$project$Api$Data$Loading,
							PB: $elm$core$Maybe$Just(newForm)
						}),
					A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.D5, model.adR, validFormFields),
					_List_Nil);
			} else {
				var newForm = _v2.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: $elm$core$Maybe$Just(newForm)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		} else {
			var form = _v0.a.a;
			var paymentForm = _v0.b.a;
			var _v4 = _Utils_Tuple2(
				A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator, form),
				A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator, paymentForm));
			if (!_v4.a.$) {
				if (!_v4.b.$) {
					var _v5 = _v4.a.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					var _v6 = _v4.b.a;
					var newPaymentForm = _v6.a;
					var validPaymentFormFields = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Lu: $author$project$Api$Data$Loading,
								PB: $elm$core$Maybe$Just(newForm),
								aL: $elm$core$Maybe$Just(newPaymentForm),
								V4: $author$project$Api$Data$Loading
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.D5, model.adR, validFormFields),
									A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.D5, model.rY, validPaymentFormFields)
								])),
						_List_Nil);
				} else {
					var _v7 = _v4.a.a;
					var newForm = _v7.a;
					var validFormFields = _v7.b;
					var newPaymentForm = _v4.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Lu: $author$project$Api$Data$Loading,
								PB: $elm$core$Maybe$Just(newForm),
								aL: $elm$core$Maybe$Just(newPaymentForm)
							}),
						A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.D5, model.adR, validFormFields),
						_List_Nil);
				}
			} else {
				if (!_v4.b.$) {
					var newForm = _v4.a.a;
					var _v8 = _v4.b.a;
					var newPaymentForm = _v8.a;
					var validPaymentFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								aL: $elm$core$Maybe$Just(newPaymentForm),
								V4: $author$project$Api$Data$Loading
							}),
						A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.D5, model.rY, validPaymentFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a.a;
					var newPaymentForm = _v4.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								aL: $elm$core$Maybe$Just(newPaymentForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			}
		}
	} else {
		if (!_v0.b.$) {
			var _v9 = _v0.a;
			var paymentForm = _v0.b.a;
			var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator, paymentForm);
			if (!_v10.$) {
				var _v11 = _v10.a;
				var newForm = _v11.a;
				var validFormFields = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(newForm),
							V4: $author$project$Api$Data$Loading
						}),
					A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.D5, model.rY, validFormFields),
					_List_Nil);
			} else {
				var newForm = _v10.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(newForm)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		} else {
			var _v12 = _v0.a;
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	}
};
var $author$project$Pages$Admin$InvoiceSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var companyInvoiceSetting = response.a;
					var _v2 = $author$project$Pages$Admin$InvoiceSettings$initFormFields(companyInvoiceSetting);
					var fields = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Lu: response,
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(fields))
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Lu: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var paymentSourceSetting = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aL: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields(paymentSourceSetting))),
								V4: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var companyInvoiceSetting = response.a;
					var _v5 = $author$project$Pages$Admin$InvoiceSettings$initFormFields(companyInvoiceSetting);
					var fields = _v5.a;
					var cmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Lu: response,
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(fields))
							}),
						cmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice settings updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Lu: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var paymentSourceSetting = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aL: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields(paymentSourceSetting))),
								V4: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment options settings updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var field = msg.a;
				var _v7 = model.PB;
				if (!_v7.$) {
					var form = _v7.a;
					return function (newForm) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}(
						$author$project$Utils$Form$fromValidateResult(
							A2(
								$author$project$Utils$Form$validate,
								$author$project$Pages$Admin$InvoiceSettings$formFieldsValidator,
								A3($author$project$Utils$Form$update, $author$project$Pages$Admin$InvoiceSettings$formFieldsUpdate, field, form))));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var field = msg.a;
				var _v8 = model.aL;
				if (!_v8.$) {
					var form = _v8.a;
					return function (newForm) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aL: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}(
						A3($author$project$Utils$Form$update, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsUpdate, field, form));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iL: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var confirmed = msg.a;
				return confirmed ? $author$project$Pages$Admin$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting(
					_Utils_update(
						model,
						{iL: false})) : _Utils_Tuple3(
					_Utils_update(
						model,
						{iL: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$InvoiceSettings$HiConfirmOpened = {$: 6};
var $author$project$Ui$Link$ButtonSecondary = 3;
var $author$project$Ui$Link$buttonSecondary = $author$project$Ui$Link$Style(3);
var $author$project$Api$Feature$DisableSponsorBilling = 7;
var $author$project$Api$FeatureGate$SponsorAdHocInvoices = 3;
var $author$project$Pages$Admin$InvoiceSettings$ChargeRouteToRecurringInvoice = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$FlexGrid$offsetMd = $author$project$Ui$FlexGrid$Offset(2);
var $author$project$Pages$Admin$InvoiceSettings$viewChargeRouteToRecurringInvoice = function (fields) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Add Service Charges to Membership Invoices')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('When point-of-care service charges are paid for by the employer, '),
										$elm$html$Html$text('automatically add these charges to the employer\'s next draft membership invoice. If this setting is disabled, '),
										$elm$html$Html$text('service charges will be added to a separate service invoice.')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$offsetMd(9),
														$author$project$Ui$FlexGrid$spanMd(3),
														$author$project$Ui$FlexGrid$justifyRight
													]),
												_List_fromArray(
													[
														$author$project$Ui$ToggleSwitch$view(
														_List_fromArray(
															[
																$author$project$Ui$ToggleSwitch$on(fields.Ey),
																$author$project$Ui$ToggleSwitch$onChange(
																A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$ChargeRouteToRecurringInvoice))
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$InvoiceSettings$BillingEnabled = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewEnableBillingToggle = F2(
	function (isHintAdmin, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.Eg),
										$author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$BillingEnabled))
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$Admin$InvoiceSettings$viewEnableBilling = F2(
	function (isHintAdmin, form) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Billing (Hinter only)')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We will bill sponsors when this setting is enabled. When this setting is disabled, we will not bill sponsors, but are still tracking employee eligibility')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							A2($author$project$Pages$Admin$InvoiceSettings$viewEnableBillingToggle, isHintAdmin, form))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$HideSponsorInvoices = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoicesToggle = F2(
	function (isHintAdmin, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.Qp),
										$author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$HideSponsorInvoices))
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoices = F2(
	function (isHintAdmin, form) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Hide Sponsor Invoice Tab (Hinter only)')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('When billing is disabled for sponsors, the Invoices tab will be hidden in the employer portal.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							A2($author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoicesToggle, isHintAdmin, form))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$ChargePhiDetailsEnabled = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedAt = function (_v0) {
	var forPractice = _v0;
	return forPractice.KS;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedBy = function (_v0) {
	var forPractice = _v0;
	return forPractice.KT;
};
var $author$project$Api$Provider$User$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Pages$Admin$InvoiceSettings$viewIncludeChargeDetails = F3(
	function (fields, model, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Include Full Charge Details')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Allow the '),
											$elm$html$Html$text(sponsorized),
											$elm$html$Html$text(' to see full charge details and patient names when viewing or downloading the invoice. '),
											$elm$html$Html$text('Since these details may contain protected health information, this setting is off by default.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Api$Data$toMaybe(model.Lu);
									if (!_v0.$) {
										var companyInvoiceSetting = _v0.a;
										var _v1 = $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedAt(companyInvoiceSetting);
										if (!_v1.$) {
											var chargePhiDetailsUpdatedAt = _v1.a;
											return A2(
												$author$project$Ui$FlexGrid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$FlexGrid$column,
														_List_fromArray(
															[
																$author$project$Ui$FlexGrid$spanMd(12)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$muted,
																		$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Updated by '),
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			A2(
																				$elm$core$Maybe$map,
																				$author$project$Api$Provider$User$Min$name,
																				$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedBy(companyInvoiceSetting)))),
																		$elm$html$Html$text(' on '),
																		$elm$html$Html$text(
																		A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargePhiDetailsUpdatedAt))
																	]))
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[$author$project$Ui$FlexGrid$justifyRight]),
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$view(
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$on(fields.KR),
															$author$project$Ui$ToggleSwitch$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$ChargePhiDetailsEnabled))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPay = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayDay = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayMonth = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$daysOfMonth = A2($elm$core$List$range, 1, 31);
var $author$project$Formatters$Int$ordinal = function (_int) {
	var ordinalSuffix = function (n) {
		var n_ = $elm$core$Basics$abs(n);
		if (((A2($elm$core$Basics$modBy, 100, n_) / 10) | 0) === 1) {
			return 'th';
		} else {
			var _v0 = A2($elm$core$Basics$modBy, 10, n_);
			switch (_v0) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
		}
	};
	return _Utils_ap(
		$elm$core$String$fromInt(_int),
		ordinalSuffix(_int));
};
var $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions = A2(
	$elm$core$List$map,
	function (day) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(day)),
			$author$project$Formatters$Int$ordinal(day));
	},
	$author$project$Pages$Admin$InvoiceSettings$daysOfMonth);
var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate = _List_fromArray(
	[0, 1, 2]);
var $author$project$Pages$Admin$InvoiceSettings$monthOptions = A2(
	$elm$core$List$map,
	function (option) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)),
			$author$project$Formatters$String$humanize(
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)));
	},
	$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate);
var $author$project$Pages$Admin$InvoiceSettings$viewErrorRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$danger,
										$author$project$Ui$Typography$small,
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceAutoPayDate = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Scheduled Autopay Date')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Payment for the full amount of all issued invoices will be automatically attempted on the specified date. ' + ('Payments will not be processed for non-issued invoices. This date is visible to the  ' + (sponsorized + '.')))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$offsetMd(1),
															$author$project$Ui$FlexGrid$spanMd(5)
														]),
													_List_fromArray(
														[
															fields.Rk ? A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.FM))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayMonth)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 1, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(3)
														]),
													_List_fromArray(
														[
															fields.Rk ? A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$elm$core$String$fromInt(fields.FL))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayDay)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 1, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions) : $author$project$Utils$Html$empty
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(3)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(fields.Rk),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPay))
																]))
														]))
												])),
											A2($author$project$Utils$Form$hasValidationErrors, 1, form) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
												A2($author$project$Utils$Form$validationErrors, 1, form))) : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSend = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendDay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendMonth = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceCreated = F2(
	function (fields, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Notification: Invoice Created')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Sent to '),
											$elm$html$Html$text(
											$author$project$Formatters$String$pluralOf(sponsorized)),
											$elm$html$Html$text(' on the specified day. Invoices can be sent regardless'),
											$elm$html$Html$text(' of whether they are still in draft or have been issued.')
										])),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Notifications__Company,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('View and customize the notification')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$offsetMd(1),
													$author$project$Ui$FlexGrid$spanMd(5)
												]),
											_List_fromArray(
												[
													fields.Rl ? A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															$elm$core$Maybe$Just(
																$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.FN))),
															$author$project$Ui$Form$Select$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendMonth))
														]),
													$author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanMd(3)
												]),
											_List_fromArray(
												[
													fields.Rl ? A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															$elm$core$Maybe$Just(
																$elm$core$String$fromInt(fields.Rm))),
															$author$project$Ui$Form$Select$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendDay))
														]),
													$author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions) : $author$project$Utils$Html$empty
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanMd(3)
												]),
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$view(
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$on(fields.Rl),
															$author$project$Ui$ToggleSwitch$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSend))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceDueDay = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceDueMonth = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$invoiceDueDayOptions = $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions;
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceDueDate = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Due Date')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('The day when the invoice is considered \"due\". This date is visible to the ' + (sponsorized + ' and printed on the invoice.'))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$offsetMd(4),
															$author$project$Ui$FlexGrid$spanMd(5)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.FO))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceDueMonth)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 2, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$monthOptions)
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(3)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$elm$core$String$fromInt(fields.Ro))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceDueDay)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 2, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$invoiceDueDayOptions)
														]))
												])),
											A2($author$project$Utils$Form$hasValidationErrors, 2, form) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
												A2($author$project$Utils$Form$validationErrors, 2, form))) : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceGracePeriodDays = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceGracePeriod = function (fields) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Grace Period')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('If the invoice is not yet paid after the grace period passes, '),
										$elm$html$Html$text('each employee\'s membership status will be set to \"unpaid\" '),
										$elm$html$Html$text('and the invoice will be considered \"overdue\". The grace period starts after the due date.')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$offsetMd(6),
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$group(
														A2(
															$author$project$Ui$Form$Input$withPreAddon,
															'# of days',
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$value(
																	$elm$core$String$fromInt(fields.FP)),
																	$author$project$Ui$Form$Input$onInput(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceGracePeriodDays))
																])))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueDay = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueMonth = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$invoiceAutoIssueDayOptions = $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions;
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceIssueDate = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Scheduled Issue Date')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Invoices will be automatically issued on the specified date, locking charges in place and preventing ' + ($author$project$Formatters$String$pluralOf(sponsorized) + (' from making any changes. Once issued, ' + (sponsorized + ' can pay invoices manually, or invoices will be automatically processed based on the Scheduled Autopay Date settings.'))))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$offsetMd(1),
															$author$project$Ui$FlexGrid$spanMd(5)
														]),
													_List_fromArray(
														[
															fields.Ri ? A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.FK))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueMonth)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 0, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(3)
														]),
													_List_fromArray(
														[
															fields.Ri ? A2(
															$author$project$Ui$Form$Select$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Select$value(
																	$elm$core$Maybe$Just(
																		$elm$core$String$fromInt(fields.Rj))),
																	$author$project$Ui$Form$Select$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueDay)),
																	$author$project$Ui$Form$Select$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 0, form))
																]),
															$author$project$Pages$Admin$InvoiceSettings$invoiceAutoIssueDayOptions) : $author$project$Utils$Html$empty
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(3)
														]),
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$view(
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$on(fields.Ri),
																	$author$project$Ui$ToggleSwitch$onChange(
																	A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssue))
																]))
														]))
												])),
											A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2(
											$elm$html$Html$div,
											_List_Nil,
											A2(
												$elm$core$List$map,
												$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
												A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingAutoSend = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceUpcoming = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Notification: Invoice Upcoming')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Sent to '),
											$elm$html$Html$text(
											$author$project$Formatters$String$pluralOf(sponsorized)),
											$elm$html$Html$text(' to let them know when to expect an invoice. '),
											$elm$html$Html$text('This notification is sent 1 week prior to the “Invoice Created” notification')
										])),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__Notifications__Company,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('View and customize the notification')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$offsetMd(9),
													$author$project$Ui$FlexGrid$spanMd(3),
													$author$project$Ui$FlexGrid$justifyRight
												]),
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$view(
													_List_fromArray(
														[
															$author$project$Ui$ToggleSwitch$on(fields.FQ),
															$author$project$Ui$ToggleSwitch$onChange(
															A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingAutoSend))
														]))
												]))
										])),
									A2($author$project$Utils$Form$hasValidationErrors, 3, form) ? A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
										A2($author$project$Utils$Form$validationErrors, 3, form))) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Ui$Timeline$ASC = 0;
var $author$project$Components$InvoiceSetting$Timeline$createTimelineDate = F3(
	function (today, eventMonth, eventDay) {
		return function (date) {
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				eventDay);
		}(
			A3(
				$justinmimbs$date$Date$add,
				1,
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(eventMonth) + 1,
				today));
	});
var $author$project$Pages$Admin$InvoiceSettings$createTimelineEventAttributes = F2(
	function (form, today) {
		var createTimelineDate = $author$project$Components$InvoiceSetting$Timeline$createTimelineDate(today);
		var dueDate = A2(createTimelineDate, form.FO, form.Ro);
		var unpaidDate = A3(
			$justinmimbs$date$Date$add,
			3,
			form.FP,
			A2(createTimelineDate, form.FO, form.Ro));
		var upcomingDate = A3(
			$justinmimbs$date$Date$add,
			2,
			-1,
			A2(createTimelineDate, form.FN, form.Rm));
		var autopayDate = A2(createTimelineDate, form.FM, form.FL);
		var autoSendDate = A2(createTimelineDate, form.FN, form.Rm);
		var autoIssueDate = A2(createTimelineDate, form.FK, form.Rj);
		return _List_fromArray(
			[
				_Utils_Tuple3(form.FQ && form.Rl, upcomingDate, 'Send \"Upcoming\" email'),
				_Utils_Tuple3(form.Rl, autoSendDate, 'Send \"Created\" email'),
				_Utils_Tuple3(form.Ri, autoIssueDate, 'Issue Invoice'),
				_Utils_Tuple3(form.Rk, autopayDate, 'Autopay Invoice'),
				_Utils_Tuple3(true, dueDate, 'Due Date'),
				_Utils_Tuple3(true, unpaidDate, 'Employees show as unpaid')
			]);
	});
var $author$project$Components$InvoiceSetting$Timeline$createTimelineEvent = function (_v0) {
	var eventDate = _v0.a;
	var event = _v0.b;
	return {MO: eventDate, acn: $elm$core$Maybe$Nothing, Nx: event};
};
var $author$project$Components$InvoiceSetting$Timeline$isEnabled = function (_v0) {
	var bool = _v0.a;
	var date = _v0.b;
	var string = _v0.c;
	return bool ? $elm$core$Maybe$Just(
		_Utils_Tuple2(date, string)) : $elm$core$Maybe$Nothing;
};
var $author$project$Components$InvoiceSetting$Timeline$createTimelineEvents = function (eventsData) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$InvoiceSetting$Timeline$createTimelineEvent,
		A2($elm$core$List$filterMap, $author$project$Components$InvoiceSetting$Timeline$isEnabled, eventsData));
};
var $elm_community$list_extra$List$Extra$unconsLast = function (list) {
	var _v0 = $elm$core$List$reverse(list);
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var last_ = _v0.a;
		var rest = _v0.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(
				last_,
				$elm$core$List$reverse(rest)));
	}
};
var $author$project$Ui$Timeline$mergeSortedEvents = function (events) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (currentEvent, newEvents) {
				var _v0 = $elm_community$list_extra$List$Extra$unconsLast(newEvents);
				if (!_v0.$) {
					var _v1 = _v0.a;
					var lastEvent = _v1.a;
					var firstBunch = _v1.b;
					return _Utils_eq(currentEvent.MO, lastEvent.MO) ? A2(
						$elm$core$List$append,
						firstBunch,
						_List_fromArray(
							[
								{MO: currentEvent.MO, acn: currentEvent.acn, Nx: lastEvent.Nx + (', ' + currentEvent.Nx)}
							])) : A2(
						$elm$core$List$append,
						firstBunch,
						_List_fromArray(
							[lastEvent, currentEvent]));
				} else {
					return _List_fromArray(
						[currentEvent]);
				}
			}),
		_List_Nil,
		events);
};
var $author$project$Ui$Timeline$compareEvents = F2(
	function (event1, event2) {
		return A2($justinmimbs$date$Date$compare, event1.MO, event2.MO);
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Ui$Timeline$sort = F2(
	function (sorting, events) {
		if (!sorting) {
			return A2($elm$core$List$sortWith, $author$project$Ui$Timeline$compareEvents, events);
		} else {
			return $elm$core$List$reverse(
				A2($elm$core$List$sortWith, $author$project$Ui$Timeline$compareEvents, events));
		}
	});
var $author$project$Formatters$Date$MonthAndDay = {$: 1};
var $author$project$Ui$Timeline$viewTimelineEvent = function (event) {
	var dateHtml = function () {
		var _v0 = event.acn;
		if (!_v0.$) {
			var dateDescription = _v0.a;
			return A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text(dateDescription)
					]));
		} else {
			return A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDay, event.MO))
					]));
		}
	}();
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('timeline__item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('timeline__item-content')
					]),
				_List_fromArray(
					[
						dateHtml,
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(event.Nx)
							]))
					]))
			]));
};
var $author$project$Ui$Timeline$view = F2(
	function (sorting, events) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline timeline--lg timeline--horizontal')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Ui$Timeline$viewTimelineEvent,
				$author$project$Ui$Timeline$mergeSortedEvents(
					A2($author$project$Ui$Timeline$sort, sorting, events))));
	});
var $author$project$Pages$Admin$InvoiceSettings$viewTimeline = F2(
	function (currentDate, fields) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Timeline$view,
									0,
									$author$project$Components$InvoiceSetting$Timeline$createTimelineEvents(
										A2($author$project$Pages$Admin$InvoiceSettings$createTimelineEventAttributes, fields, currentDate)))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$viewForm = F2(
	function (model, form) {
		var sponsorized = A2($author$project$Formatters$String$sponsorize, model.WF, 'employer');
		var fields = $author$project$Utils$Form$fields(form);
		var hideSponsorInvoicesSection = (!fields.Eg) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoices, model.FR, form)
				])) : $author$project$Utils$Html$empty;
		var enableBillingSection = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.WF) ? (((!model.FR) && fields.Eg) ? $author$project$Utils$Html$empty : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$InvoiceSettings$viewEnableBilling, model.FR, form)
				]))) : $author$project$Utils$Html$empty;
		return _List_fromArray(
			[
				A2($author$project$Pages$Admin$InvoiceSettings$viewTimeline, model.cO, fields),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				enableBillingSection,
				hideSponsorInvoicesSection,
				A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceUpcoming, fields, form, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2($author$project$Pages$Admin$InvoiceSettings$viewInvoiceCreated, fields, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceIssueDate, fields, form, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceAutoPayDate, fields, form, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceDueDate, fields, form, sponsorized),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Pages$Admin$InvoiceSettings$viewInvoiceGracePeriod(fields),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewIncludeChargeDetails, fields, model, sponsorized),
				A3(
				$author$project$Utils$FeatureGate$gate,
				3,
				$author$project$Api$Practice$Provider(model.WF),
				$author$project$Pages$Admin$InvoiceSettings$viewChargeRouteToRecurringInvoice(fields))
			]);
	});
var $author$project$Pages$Admin$InvoiceSettings$AcceptsAch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$AcceptsAmex = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$AcceptsCards = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Typography$titleSm = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				$elm$html$Html$h5,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('text-title-sm text-main'),
					$author$project$Ui$Typography$optionsToAttributes(options)),
				content));
	});
var $author$project$Pages$Admin$InvoiceSettings$viewPaymentOptions = F3(
	function (fields, form, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Payment Options')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Choose payment options available to  ' + (sponsorized + 's.'))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1 pl-1')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$titleSm,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Accept Bank Accounts')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-05')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$offsetMd(9),
																	$author$project$Ui$FlexGrid$spanMd(3),
																	$author$project$Ui$FlexGrid$justifyRight
																]),
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$ToggleSwitch$on(fields.H_),
																			$author$project$Ui$ToggleSwitch$onChange(
																			A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsAch))
																		]))
																]))
														]))
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$titleSm,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Accept Credit Cards')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-05')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$offsetMd(9),
																	$author$project$Ui$FlexGrid$spanMd(3),
																	$author$project$Ui$FlexGrid$justifyRight
																]),
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$ToggleSwitch$on(fields.H0),
																			$author$project$Ui$ToggleSwitch$onChange(
																			A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsCards))
																		]))
																]))
														]))
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$titleSm,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Accept American Express')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-05')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$offsetMd(9),
																	$author$project$Ui$FlexGrid$spanMd(3),
																	$author$project$Ui$FlexGrid$justifyRight
																]),
															_List_fromArray(
																[
																	$author$project$Ui$ToggleSwitch$view(
																	_List_fromArray(
																		[
																			$author$project$Ui$ToggleSwitch$on(fields.H$),
																			$author$project$Ui$ToggleSwitch$onChange(
																			A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsAmex)),
																			$author$project$Ui$ToggleSwitch$disabled(!fields.H0)
																		]))
																]))
														])),
													A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2(
													$elm$html$Html$div,
													_List_Nil,
													A2(
														$elm$core$List$map,
														$author$project$Pages$Admin$InvoiceSettings$viewErrorRow,
														A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$InvoiceSettings$viewPaymentSettingsForm = F2(
	function (model, form) {
		var sponsorized = A2($author$project$Formatters$String$sponsorize, model.WF, 'employer');
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Admin$InvoiceSettings$viewPaymentOptions, fields, form, sponsorized)
			]);
	});
var $author$project$Pages$Admin$InvoiceSettings$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[$author$project$Ui$Form$horizontal]),
				_List_fromArray(
					[
						model.iL ? A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('Confirm'),
								$author$project$Components$HiConfirm$noun('Global Settings'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'You are changing the global ' + (A2($author$project$Formatters$String$sponsorize, model.WF, 'employer') + (' settings only. This will not affect any ' + (A2($author$project$Formatters$String$sponsorize, model.WF, 'employers') + ' that have setting overrides in place.'))))
									]))
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Example of Upcoming Month')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										function () {
											var _v0 = model.PB;
											if (!_v0.$) {
												var form = _v0.a;
												return A2($author$project$Pages$Admin$InvoiceSettings$viewForm, model, form);
											} else {
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$div,
														_List_fromArray(
															[
																$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Spinner$view(_List_Nil)
															]))
													]);
											}
										}()),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										function () {
											var _v1 = model.aL;
											if (!_v1.$) {
												var form = _v1.a;
												return A2($author$project$Pages$Admin$InvoiceSettings$viewPaymentSettingsForm, model, form);
											} else {
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$div,
														_List_fromArray(
															[
																$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Spinner$view(_List_Nil)
															]))
													]);
											}
										}())
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__Practice,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										function () {
										if ($author$project$Utils$Maybe$toBool(model.PB)) {
											var nonSubmittable = function () {
												var _v2 = model.PB;
												if (!_v2.$) {
													var form = _v2.a;
													return $author$project$Utils$Form$hasAnyValidationError(form);
												} else {
													return true;
												}
											}();
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'Update invoice settings'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$loading(
														_Utils_eq(model.Lu, $author$project$Api$Data$Loading)),
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$InvoiceSettings$HiConfirmOpened),
														$author$project$Ui$Button$disabled(nonSubmittable)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					]))
			]),
		$G: 'Admin | Invoice Settings'
	};
};
var $author$project$Pages$Admin$InvoiceSettings$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$InvoiceSettings$init, aer: $author$project$Pages$Admin$InvoiceSettings$load, agD: $author$project$Pages$Admin$InvoiceSettings$save, ahd: $author$project$Pages$Admin$InvoiceSettings$subscriptions, aaq: $author$project$Pages$Admin$InvoiceSettings$update, ahP: $author$project$Pages$Admin$InvoiceSettings$view});
var $author$project$Pages$Admin$LeadSources$GotItems = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$LeadSource$All$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Provider$LeadSource$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LeadSource$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LeadSource$leadSourcesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['lead_sources']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$LeadSource$listDefaults = {adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$LeadSource$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$LeadSource$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$LeadSource$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$LeadSource$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$LeadSource$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$LeadSource$leadSourcesPath)));
	});
var $author$project$Pages$Admin$LeadSources$fetchItems = function (model) {
	return A3(
		$author$project$Api$Provider$LeadSource$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy});
		},
		$author$project$Pages$Admin$LeadSources$GotItems);
};
var $author$project$Pages$Admin$LeadSources$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var model = {D5: apiClient, ic: $elm$core$Maybe$Nothing, dN: $elm$core$Set$empty, FU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading, afy: $author$project$Api$Pagination$init, eM: _List_Nil};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$LeadSources$fetchItems(model));
	});
var $author$project$Pages$Admin$LeadSources$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$LeadSources$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$LeadSources$CancelEdit = {$: 3};
var $author$project$Pages$Admin$LeadSources$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$LeadSources$TranslationsInputMsg = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$LeadSources$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$LeadSources$CancelEdit)),
					model.FU)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$LeadSources$HiConfirmClosed),
					model.ic)),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (input) {
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Admin$LeadSources$TranslationsInputMsg(input.g2),
							$author$project$Components$TranslationsInput$subscriptions(input));
					},
					model.eM))
			]));
};
var $author$project$Pages$Admin$LeadSources$Deleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$Provider$LeadSource$leadSourcePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$LeadSource$leadSourcesPath);
};
var $author$project$Api$Provider$LeadSource$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$LeadSource$leadSourcePath(id_)));
	});
var $author$project$Api$Provider$LeadSource$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$LeadSource$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$name(shared);
};
var $author$project$Api$Provider$LeadSource$Shared$showOnOnlineSignup = function (_v0) {
	var record = _v0;
	return record.ZV;
};
var $author$project$Api$Provider$LeadSource$All$showOnOnlineSignup = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$showOnOnlineSignup(shared);
};
var $author$project$Pages$Admin$LeadSources$formFieldsFromItem = function (item) {
	return {
		zh: $author$project$Api$Provider$LeadSource$All$name(item),
		ZV: $author$project$Api$Provider$LeadSource$All$showOnOnlineSignup(item)
	};
};
var $author$project$Pages$Admin$LeadSources$formFieldsInit = {zh: '', ZV: false};
var $author$project$Pages$Admin$LeadSources$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{zh: string});
		} else {
			var bool = field.a;
			return _Utils_update(
				fields,
				{ZV: bool});
		}
	});
var $author$project$Pages$Admin$LeadSources$NameValidation = 0;
var $author$project$Pages$Admin$LeadSources$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Provider$LeadSource$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$LeadSource$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$id(shared);
};
var $author$project$Components$TranslationsInput$LeadSource = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TranslationsInput$leadSource = $author$project$Components$TranslationsInput$LeadSource;
var $author$project$Api$Provider$LeadSource$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$name(shared);
};
var $author$project$Pages$Admin$LeadSources$Created = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$LeadSource$One$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Provider$LeadSource$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LeadSource$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LeadSource$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lead_source',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'show_on_online_signup',
								$elm$json$Json$Encode$bool(fields.ZV))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$LeadSource$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$LeadSource$leadSourcesPath)));
	});
var $author$project$Pages$Admin$LeadSources$createItem = F2(
	function (apiClient, formFields) {
		return A3(
			$author$project$Api$Provider$LeadSource$create,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Admin$LeadSources$Created);
	});
var $author$project$Pages$Admin$LeadSources$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$LeadSource$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'lead_source',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'show_on_online_signup',
								$elm$json$Json$Encode$bool(fields.ZV))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$LeadSource$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$LeadSource$leadSourcePath(id_))));
	});
var $author$project$Pages$Admin$LeadSources$updateItem = F3(
	function (apiClient, id, formFields) {
		return A4(
			$author$project$Api$Provider$LeadSource$update,
			apiClient,
			id,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Admin$LeadSources$Updated);
	});
var $author$project$Pages$Admin$LeadSources$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$LeadSources$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$LeadSources$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$TranslationsInput$translatable = function ($) {
	return $.g2;
};
var $author$project$Pages$Admin$LeadSources$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var items = response.a;
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iZ: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								eM: A2(
									$elm$core$List$map,
									function (item) {
										return $author$project$Components$TranslationsInput$init(
											$author$project$Components$TranslationsInput$leadSource(
												$author$project$Api$Provider$LeadSource$All$id(item)));
									},
									items)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iZ: response, eM: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$LeadSources$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$LeadSource$All$id(item)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$LeadSources$formFieldsFromItem(item)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				var _v2 = model.FU;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var item = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$LeadSources$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$LeadSources$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$LeadSources$saveItem, model.D5, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 5:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var response = msg.a;
				var _v6 = model.FU;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$LeadSources$fetchItems(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$LeadSource$One$name(item))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v9 = model.FU;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$LeadSources$fetchItems(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$LeadSource$One$name(item) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$LeadSource$All$id(item),
										model.dN),
									iZ: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$LeadSources$fetchItems(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$LeadSource$All$name(item) + ' was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$LeadSource$All$id(item),
										model.dN)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$LeadSource$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ic: $elm$core$Maybe$Nothing,
								dN: A2($elm$core$Set$insert, id, model.dN)
							}),
						A3(
							$author$project$Api$Provider$LeadSource$delete,
							model.D5,
							id,
							$author$project$Pages$Admin$LeadSources$Deleted(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var translatable = msg.a;
				var msg_ = msg.b;
				var maybeUpdate = A2(
					$elm$core$Maybe$map,
					A2($author$project$Components$TranslationsInput$update, model.D5, msg_),
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (input) {
								return _Utils_eq(
									$author$project$Components$TranslationsInput$translatable(input),
									translatable);
							},
							model.eM)));
				if (maybeUpdate.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var _v14 = maybeUpdate.a;
					var translationInput = _v14.a;
					var translationsCmd = _v14.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eM: A2(
									$elm$core$List$map,
									function (input) {
										return _Utils_eq(
											$author$project$Components$TranslationsInput$translatable(translationInput),
											$author$project$Components$TranslationsInput$translatable(input)) ? translationInput : input;
									},
									model.eM)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Admin$LeadSources$TranslationsInputMsg(translatable),
							translationsCmd),
						_List_Nil);
				}
			default:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Admin$LeadSources$fetchItems(newModel),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$LeadSources$New = {$: 1};
var $author$project$Pages$Admin$LeadSources$PaginationMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$LeadSources$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$LeadSources$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$LeadSources$Save = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$LeadSources$ShowOnOnlineSignup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$LeadSources$viewEditModal = F3(
	function (id, form, item) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Lead Source',
			S_: _Utils_eq(item, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$LeadSources$CancelEdit,
			U0: $author$project$Pages$Admin$LeadSources$Save(form)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var name = _v0.zh;
		var showOnOnlineSignup = _v0.ZV;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Online Ad'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$LeadSources$FormUpdated, $author$project$Pages$Admin$LeadSources$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Show On Online Signup')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(showOnOnlineSignup),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$LeadSources$FormUpdated, $author$project$Pages$Admin$LeadSources$ShowOnOnlineSignup))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$LeadSources$help = $elm$core$String$concat(
	_List_fromArray(
		['Use lead sources to track where new patients are coming from, whether they were a former patient, ', 'heard about you from a friend, from a website, or from specific marketing. The lead sources ', 'can be chosen on online signup or assigned directly to a patient. Our signup pages also allow ', 'specifying a specific lead source using a custom URL, which allows you to track signups ', 'from a specific email or landing page.']));
var $author$project$Pages$Admin$LeadSources$Delete = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$LeadSources$Edit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$TranslationsInput$forTranslatable = F2(
	function (translatable_, inputs) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (input) {
					return _Utils_eq(input.g2, translatable_);
				},
				inputs));
	});
var $author$project$Pages$Admin$LeadSources$isOther = function (item) {
	return $author$project$Api$Provider$LeadSource$All$name(item) === 'Other';
};
var $author$project$Ui$Element$ml2 = $author$project$Ui$Element$Margin('ml-2');
var $author$project$Api$Provider$LeadSource$Shared$patientsCount = function (_v0) {
	var record = _v0;
	return record.VS;
};
var $author$project$Api$Provider$LeadSource$All$patientsCount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$LeadSource$Shared$patientsCount(shared);
};
var $author$project$Pages$Admin$LeadSources$viewItem = F3(
	function (deletingItems, translationInputs, item) {
		var id = $author$project$Api$Provider$LeadSource$All$id(item);
		var translatable = $author$project$Components$TranslationsInput$leadSource(id);
		var translationInput = A2($author$project$Components$TranslationsInput$forTranslatable, translatable, translationInputs);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$LeadSource$All$name(item)),
							function () {
							if (!translationInput.$) {
								var input = translationInput.a;
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$ml2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Admin$LeadSources$TranslationsInputMsg(input.g2),
											A3(
												$author$project$Components$TranslationsInput$view,
												'name',
												_List_fromArray(
													[
														$author$project$Components$TranslationsInput$default(
														$author$project$Api$Provider$LeadSource$All$name(item))
													]),
												input))
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Formatters$Bool$toString(
									$author$project$Api$Provider$LeadSource$All$showOnOnlineSignup(item))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$LeadSource$All$patientsCount(item)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if ($author$project$Pages$Admin$LeadSources$isOther(item)) {
							return _List_Nil;
						} else {
							var loading = A2($elm$core$Set$member, id, deletingItems);
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Edit lead source'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$LeadSources$Edit(item)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Delete lead source'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$LeadSources$Delete(item)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										]))
								]);
						}
					}())
				]));
	});
var $author$project$Pages$Admin$LeadSources$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.iZ;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text($author$project$Pages$Admin$LeadSources$help)
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no lead sources.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Show on online signup')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Patients count')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Admin$LeadSources$viewItem, model.dN, model.eM),
				items),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$LeadSources$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.FU;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var item = _v1.c;
					return A3($author$project$Pages$Admin$LeadSources$viewEditModal, id, form, item);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ic;
				if (!_v2.$) {
					var item = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$LeadSources$HiConfirmClosed(item),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('lead source'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$LeadSource$All$name(item))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Lead Source')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'New lead source'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$LeadSources$New),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Lead Source')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$LeadSources$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$LeadSources$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.iZ))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Lead Sources'
	};
};
var $author$project$Pages$Admin$LeadSources$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$LeadSources$init, aer: $author$project$Pages$Admin$LeadSources$load, agD: $author$project$Pages$Admin$LeadSources$save, ahd: $author$project$Pages$Admin$LeadSources$subscriptions, aaq: $author$project$Pages$Admin$LeadSources$update, ahP: $author$project$Pages$Admin$LeadSources$view});
var $author$project$Pages$Admin$Locations$GotLocationGroups = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Report$Location = 20;
var $author$project$Pages$Admin$Locations$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toPageQuery(model.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toQuery(model.ag1),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Admin$Locations$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Locations)
			]),
		$author$project$Pages$Admin$Locations$urlParams(model));
};
var $author$project$Pages$Admin$Locations$GotList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Location$Meta = 0;
var $author$project$Pages$Admin$Locations$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Fc: _List_fromArray(
					[0]),
				afy: $elm$core$Maybe$Just(model.afy),
				af_: model.af_,
				ag1: model.ag1
			});
	};
};
var $author$project$Pages$Admin$Locations$fetchList = function (model) {
	return A3(
		$author$project$Api$Provider$Location$list,
		model.D5,
		$author$project$Pages$Admin$Locations$fetchParams(model),
		$author$project$Pages$Admin$Locations$GotList);
};
var $author$project$Components$Admin$Location$DeleteModal$Closed = {$: 0};
var $author$project$Components$Admin$Location$DeleteModal$init = $author$project$Components$Admin$Location$DeleteModal$Closed;
var $author$project$Components$LinkedRecords$Closed = {$: 0};
var $author$project$Components$LinkedRecords$init = $author$project$Components$LinkedRecords$Closed;
var $author$project$Api$Provider$LocationGroup$All$LocationGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$LocationGroup$All$AllRecord = F2(
	function (locationsCount, integrationRecords) {
		return {Q8: integrationRecords, S5: locationsCount};
	});
var $author$project$Api$Provider$IntegrationRecord$One$IntegrationRecord = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$IntegrationRecord$Shared$IntegrationRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$IntegrationRecord$Shared$Record = F7(
	function (integrationSyncStatus, integrationLastSyncedAt, integrationRecordId, unsyncedReason, errorMessage, webLink, meta) {
		return {ON: errorMessage, Q6: integrationLastSyncedAt, Q7: integrationRecordId, Q9: integrationSyncStatus, TU: meta, aal: unsyncedReason, aaV: webLink};
	});
var $author$project$Api$IntegrationRecord$Status$Enabled = 3;
var $author$project$Api$IntegrationRecord$Status$Errored = 2;
var $author$project$Api$IntegrationRecord$Status$Synced = 0;
var $author$project$Api$IntegrationRecord$Status$Unsynced = 1;
var $author$project$Api$IntegrationRecord$Status$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'synced':
				return $elm$json$Json$Decode$succeed(0);
			case 'unsynced':
				return $elm$json$Json$Decode$succeed(1);
			case 'errored':
				return $elm$json$Json$Decode$succeed(2);
			case 'enabled':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unsupported integration record status: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$IntegrationRecord$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$IntegrationRecord$Meta$Record = function (actions) {
	return {tF: actions};
};
var $author$project$Api$Provider$IntegrationRecord$Meta$Action = F3(
	function (name, description, available) {
		return {abs: available, Nx: description, zh: name};
	});
var $author$project$Api$Provider$IntegrationRecord$Meta$CopyToClipboard = 1;
var $author$project$Api$Provider$IntegrationRecord$Meta$EditPartnerId = 3;
var $author$project$Api$Provider$IntegrationRecord$Meta$ForcePushData = 2;
var $author$project$Api$Provider$IntegrationRecord$Meta$Unlink = 0;
var $author$project$Api$Provider$IntegrationRecord$Meta$actionNameDecoder = function (string) {
	switch (string) {
		case 'unlink':
			return $elm$json$Json$Decode$succeed(0);
		case 'copy_to_clipboard':
			return $elm$json$Json$Decode$succeed(1);
		case 'force_push_data':
			return $elm$json$Json$Decode$succeed(2);
		case 'edit_partner_id':
			return $elm$json$Json$Decode$succeed(3);
		default:
			return $elm$json$Json$Decode$fail('Unsupported integration record action: ' + string);
	}
};
var $author$project$Api$Provider$IntegrationRecord$Meta$actionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'available',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$IntegrationRecord$Meta$actionNameDecoder, $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Meta$Action))));
var $author$project$Api$Provider$IntegrationRecord$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$Meta$actionDecoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Meta$Record));
var $author$project$Api$Provider$IntegrationRecord$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$IntegrationRecord$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$IntegrationRecord$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$IntegrationRecord$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'integration_web_link',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'unsynced_reason',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'integration_record_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'integration_last_synced_at',
						$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'integration_sync_status',
							$author$project$Api$IntegrationRecord$Status$decode,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Shared$Record))))))));
var $author$project$Api$Provider$IntegrationRecord$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$IntegrationRecord$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$IntegrationRecord$One$Athena = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$IntegrationRecord$One$None = {$: 1};
var $author$project$Api$Provider$IntegrationRecord$One$Record = F2(
	function (integration, metadata) {
		return {Q4: integration, TV: metadata};
	});
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$Integration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Partner$Shared$decoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Integration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$SharedWithInlinePartner$Integration)));
var $author$project$Api$Provider$IntegrationRecord$One$MetadataRecord = function (localPatientId) {
	return {aes: localPatientId};
};
var $author$project$Api$Provider$IntegrationRecord$One$metadataDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'athena_local_patient_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$MetadataRecord));
var $author$project$Api$Provider$IntegrationRecord$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metadata',
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $author$project$Api$Provider$IntegrationRecord$One$Athena, $author$project$Api$Provider$IntegrationRecord$One$metadataDecoder),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$None)
			])),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'integration',
		$author$project$Api$Provider$Integration$SharedWithInlinePartner$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$Record)));
var $author$project$Api$Provider$IntegrationRecord$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$IntegrationRecord$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$IntegrationRecord$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$IntegrationRecord)));
var $author$project$Api$Provider$LocationGroup$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'integration_records',
	$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locations_count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$LocationGroup$All$AllRecord)));
var $author$project$Api$Provider$LocationGroup$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LocationGroup$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$LocationGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$LocationGroup$All$LocationGroup)));
var $author$project$Api$Provider$LocationGroup$expandToString = function (expand) {
	return 'integration_records';
};
var $author$project$Api$Provider$LocationGroup$listDefaults = {
	Fc: _List_Nil,
	adR: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$LocationGroup$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$LocationGroup$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$LocationGroup$expandToString, options.Fc),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$LocationGroup$locationGroupsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['location_groups']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$LocationGroup$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$LocationGroup$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$LocationGroup$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$LocationGroup$locationGroupsPath)));
	});
var $author$project$Pages$Admin$Locations$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: shared.D5,
			h7: $author$project$Components$Admin$Location$DeleteModal$init,
			ic: $elm$core$Maybe$Nothing,
			dN: $elm$core$Set$empty,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 20}),
			FR: $author$project$Shared$isHintAdmin(shared),
			FU: $elm$core$Maybe$Nothing,
			iZ: $author$project$Api$Data$Loading,
			mS: $author$project$Components$LinkedRecords$init,
			S$: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Locations$fetchList(model),
						A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
						A3($author$project$Api$Provider$LocationGroup$list, model.D5, $elm$core$Basics$identity, $author$project$Pages$Admin$Locations$GotLocationGroups)
					])));
	});
var $author$project$Pages$Admin$Locations$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Locations$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Locations$AddressInputMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Locations$CancelEdit = {$: 9};
var $author$project$Pages$Admin$Locations$DeleteModalMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$Locations$ExportCsvMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$Locations$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Admin$Locations$LinkedRecordsMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Admin$Locations$PhoneInputMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$AddressInput$AddressSuggestionsReceived = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$AddressInput$PlaceDetailsReceived = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ports$GooglePlaces$googlePlacesAutocompleteSuggestionsResponse = _Platform_incomingPort(
	'googlePlacesAutocompleteSuggestionsResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (suggestions) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return $elm$json$Json$Decode$succeed(
						{adR: id, ahe: suggestions});
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'suggestions', $elm$json$Json$Decode$value)));
var $author$project$Ports$GooglePlaces$autocompleteSuggestionsResponse = function (decoder) {
	return $author$project$Ports$GooglePlaces$googlePlacesAutocompleteSuggestionsResponse(decoder);
};
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$AutocompleteSuggestion = F3(
	function (description, placeId, types) {
		return {Nx: description, Wm: placeId, ahJ: types};
	});
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'types',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'place_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$AutocompleteSuggestion$AutocompleteSuggestion))));
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$decodeList = $elm$json$Json$Decode$list($author$project$Api$GoogleMaps$AutocompleteSuggestion$decoder);
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$onGetAutocompleteSuggestionsResponse = function (toMsg) {
	return $author$project$Ports$GooglePlaces$autocompleteSuggestionsResponse(
		function (_v0) {
			var id = _v0.adR;
			var suggestions = _v0.ahe;
			return A2(
				toMsg,
				id,
				A2(
					$elm$core$Result$mapError,
					$elm$json$Json$Decode$errorToString,
					A2($elm$json$Json$Decode$decodeValue, $author$project$Api$GoogleMaps$AutocompleteSuggestion$decodeList, suggestions)));
		});
};
var $author$project$Api$GoogleMaps$Place$Place = F5(
	function (addressComponents, formattedAddress, name, placeId, types) {
		return {DW: addressComponents, adx: formattedAddress, zh: name, Wm: placeId, ahJ: types};
	});
var $author$project$Api$GoogleMaps$Place$AddressComponent = F3(
	function (longName, shortName, types) {
		return {S9: longName, ZN: shortName, ahJ: types};
	});
var $author$project$Api$GoogleMaps$Place$OtherComponent = 37;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel1 = 5;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel2 = 6;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel3 = 7;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel4 = 8;
var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel5 = 9;
var $author$project$Api$GoogleMaps$Place$Airport = 23;
var $author$project$Api$GoogleMaps$Place$BusStation = 33;
var $author$project$Api$GoogleMaps$Place$ColloquialArea = 10;
var $author$project$Api$GoogleMaps$Place$Country = 4;
var $author$project$Api$GoogleMaps$Place$Establishment = 29;
var $author$project$Api$GoogleMaps$Place$Floor = 27;
var $author$project$Api$GoogleMaps$Place$Intersection = 2;
var $author$project$Api$GoogleMaps$Place$Locality = 11;
var $author$project$Api$GoogleMaps$Place$NaturalFeature = 22;
var $author$project$Api$GoogleMaps$Place$Neighborhood = 18;
var $author$project$Api$GoogleMaps$Place$Park = 24;
var $author$project$Api$GoogleMaps$Place$Parking = 31;
var $author$project$Api$GoogleMaps$Place$PointOfInterest = 30;
var $author$project$Api$GoogleMaps$Place$Political = 3;
var $author$project$Api$GoogleMaps$Place$PostBox = 25;
var $author$project$Api$GoogleMaps$Place$PostalCode = 21;
var $author$project$Api$GoogleMaps$Place$PostalCodeSuffix = 36;
var $author$project$Api$GoogleMaps$Place$PostalTown = 32;
var $author$project$Api$GoogleMaps$Place$Premise = 19;
var $author$project$Api$GoogleMaps$Place$Room = 28;
var $author$project$Api$GoogleMaps$Place$Route = 1;
var $author$project$Api$GoogleMaps$Place$StreetAddress = 0;
var $author$project$Api$GoogleMaps$Place$StreetNumber = 26;
var $author$project$Api$GoogleMaps$Place$Sublocality = 12;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel1 = 13;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel2 = 14;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel3 = 15;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel4 = 16;
var $author$project$Api$GoogleMaps$Place$SublocalityLevel5 = 17;
var $author$project$Api$GoogleMaps$Place$Subpremise = 20;
var $author$project$Api$GoogleMaps$Place$TrainStation = 34;
var $author$project$Api$GoogleMaps$Place$TransitStation = 35;
var $author$project$Api$GoogleMaps$Place$componentTypeList = _List_fromArray(
	[
		_Utils_Tuple2('street_address', 0),
		_Utils_Tuple2('route', 1),
		_Utils_Tuple2('intersection', 2),
		_Utils_Tuple2('political', 3),
		_Utils_Tuple2('country', 4),
		_Utils_Tuple2('administrative_area_level_1', 5),
		_Utils_Tuple2('administrative_area_level_2', 6),
		_Utils_Tuple2('administrative_area_level_3', 7),
		_Utils_Tuple2('administrative_area_level_4', 8),
		_Utils_Tuple2('administrative_area_level_5', 9),
		_Utils_Tuple2('colloquial_area', 10),
		_Utils_Tuple2('locality', 11),
		_Utils_Tuple2('sublocality', 12),
		_Utils_Tuple2('sublocality_level_1', 13),
		_Utils_Tuple2('sublocality_level_2', 14),
		_Utils_Tuple2('sublocality_level_3', 15),
		_Utils_Tuple2('sublocality_level_4', 16),
		_Utils_Tuple2('sublocality_level_5', 17),
		_Utils_Tuple2('neighborhood', 18),
		_Utils_Tuple2('premise', 19),
		_Utils_Tuple2('subpremise', 20),
		_Utils_Tuple2('postal_code', 21),
		_Utils_Tuple2('natural_feature', 22),
		_Utils_Tuple2('airport', 23),
		_Utils_Tuple2('park', 24),
		_Utils_Tuple2('post_box', 25),
		_Utils_Tuple2('street_number', 26),
		_Utils_Tuple2('floor', 27),
		_Utils_Tuple2('room', 28),
		_Utils_Tuple2('establishment', 29),
		_Utils_Tuple2('point_of_interest', 30),
		_Utils_Tuple2('parking', 31),
		_Utils_Tuple2('postal_town', 32),
		_Utils_Tuple2('bus_station', 33),
		_Utils_Tuple2('train_station', 34),
		_Utils_Tuple2('transit_station', 35),
		_Utils_Tuple2('postal_code_suffix', 36)
	]);
var $author$project$Api$GoogleMaps$Place$componentTypeMap = $elm$core$Dict$fromList($author$project$Api$GoogleMaps$Place$componentTypeList);
var $author$project$Api$GoogleMaps$Place$stringToComponentType = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		37,
		A2($elm$core$Dict$get, str, $author$project$Api$GoogleMaps$Place$componentTypeMap));
};
var $author$project$Api$GoogleMaps$Place$mapComponentType = A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Api$GoogleMaps$Place$stringToComponentType);
var $author$project$Api$GoogleMaps$Place$typeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$GoogleMaps$Place$mapComponentType, $elm$json$Json$Decode$string);
var $author$project$Api$GoogleMaps$Place$typeListDecoder = $elm$json$Json$Decode$list($author$project$Api$GoogleMaps$Place$typeDecoder);
var $author$project$Api$GoogleMaps$Place$decodeAddressComponent = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'types',
	$author$project$Api$GoogleMaps$Place$typeListDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'short_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'long_name',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$Place$AddressComponent))));
var $author$project$Api$GoogleMaps$Place$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'types',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'place_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'formatted_address',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address_components',
					$elm$json$Json$Decode$list($author$project$Api$GoogleMaps$Place$decodeAddressComponent),
					$elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$Place$Place))))));
var $author$project$Ports$GooglePlaces$googlePlacesPlaceDetailsResponse = _Platform_incomingPort(
	'googlePlacesPlaceDetailsResponse',
	A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (address) {
					return $elm$json$Json$Decode$succeed(
						{It: address, adR: id});
				},
				A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)));
var $author$project$Ports$GooglePlaces$placeDetailsResponse = function (handler) {
	return $author$project$Ports$GooglePlaces$googlePlacesPlaceDetailsResponse(handler);
};
var $author$project$Api$GoogleMaps$Place$onGetPlaceDetailsResponse = function (toMsg) {
	return $author$project$Ports$GooglePlaces$placeDetailsResponse(
		function (_v0) {
			var id = _v0.adR;
			var address = _v0.It;
			return A2(
				toMsg,
				id,
				A2(
					$elm$core$Result$mapError,
					$elm$json$Json$Decode$errorToString,
					A2($elm$json$Json$Decode$decodeString, $author$project$Api$GoogleMaps$Place$decoder, address)));
		});
};
var $author$project$Components$AddressInput$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(model.ho),
				$author$project$Api$GoogleMaps$AutocompleteSuggestion$onGetAutocompleteSuggestionsResponse($author$project$Components$AddressInput$AddressSuggestionsReceived),
				$author$project$Api$GoogleMaps$Place$onGetPlaceDetailsResponse($author$project$Components$AddressInput$PlaceDetailsReceived)
			]));
};
var $author$project$Components$Admin$Location$DeleteModal$CloseModal = {$: 0};
var $author$project$Components$Admin$Location$DeleteModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Location$DeleteModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$LinkedRecords$CloseModal = {$: 1};
var $author$project$Components$LinkedRecords$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$LinkedRecords$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Admin$Locations$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.FU;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var form = _v1.b;
					var _v2 = $author$project$Utils$Form$fields(form);
					var phone = _v2.Wg;
					var address = _v2.It;
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Pages$Admin$Locations$PhoneInputMsg,
								$author$project$Components$PhoneInput$subscriptions(phone)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Pages$Admin$Locations$AddressInputMsg,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Sub$none,
									A2($elm$core$Maybe$map, $author$project$Components$AddressInput$subscriptions, address)))
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Locations$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Locations$LinkedRecordsMsg,
				$author$project$Components$LinkedRecords$subscriptions(model.mS)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Locations$DeleteModalMsg,
				$author$project$Components$Admin$Location$DeleteModal$subscriptions(model.h7)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Locations$CancelEdit)),
					model.FU)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Locations$HiConfirmClosed),
					model.ic))
			]));
};
var $author$project$Pages$Admin$Locations$Address = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Locations$Deleted = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Admin$Locations$Phone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Locations$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Location$locationPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Location$locationsPath);
};
var $author$project$Api$Provider$Location$delete = F4(
	function (apiClient, id_, reassignToLocation, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				function () {
					if (!reassignToLocation.$) {
						var string = reassignToLocation.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'reassign_to_location_id', string)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Location$locationPath(id_))));
	});
var $author$project$Pages$Admin$Locations$initPhoneInput = function (phoneNumber) {
	var phone = A2(
		$elm$core$Maybe$map,
		A2($author$project$Components$PhoneInput$initPhone, $author$project$Api$Common$Phone$Shared$Office, 0),
		phoneNumber);
	return A3(
		$author$project$Components$PhoneInput$init,
		'location-phone-input',
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2($elm$core$Maybe$map, $elm$core$List$singleton, phone)),
		function (d) {
			return _Utils_update(
				d,
				{
					Ik: true,
					abk: false,
					acB: $author$project$Api$Common$Phone$Shared$Office,
					yQ: 1,
					nT: _List_fromArray(
						[0])
				});
		});
};
var $author$project$Pages$Admin$Locations$formFieldsForBusinessLocation = function (name) {
	return _Utils_Tuple2(
		{
			It: $elm$core$Maybe$Nothing,
			Kg: true,
			rj: $elm$core$Maybe$Nothing,
			zh: name,
			U8: true,
			Wg: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
			aaS: false
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Api$Provider$Location$Shared$businessLocation = function (_v0) {
	var record = _v0;
	return record.Kg;
};
var $author$project$Api$Provider$Location$All$businessLocation = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$businessLocation(shared);
};
var $author$project$Api$Common$LocationGroup$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Common$LocationGroup$Shared$id = function (_v0) {
	var min = _v0;
	return $author$project$Api$Common$LocationGroup$Min$id(min);
};
var $author$project$Api$Provider$Location$Shared$locationGroup = function (_v0) {
	var record = _v0;
	return record.rj;
};
var $author$project$Api$Provider$Location$All$locationGroup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$locationGroup(shared);
};
var $author$project$Api$Provider$Location$Shared$onlineSignupVisibility = function (_v0) {
	var record = _v0;
	return record.U8;
};
var $author$project$Api$Provider$Location$All$onlineSignupVisibility = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$onlineSignupVisibility(shared);
};
var $author$project$Api$Provider$Location$Shared$virtual = function (_v0) {
	var record = _v0;
	return record.aaS;
};
var $author$project$Api$Provider$Location$All$virtual = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$virtual(shared);
};
var $author$project$Pages$Admin$Locations$formFieldsFromBusinessLocation = function (location) {
	return _Utils_Tuple2(
		{
			It: $elm$core$Maybe$Nothing,
			Kg: $author$project$Api$Provider$Location$All$businessLocation(location),
			rj: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$LocationGroup$Shared$id,
				$author$project$Api$Provider$Location$All$locationGroup(location)),
			zh: $author$project$Api$Provider$Location$All$name(location),
			U8: $author$project$Api$Provider$Location$All$onlineSignupVisibility(location),
			Wg: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
			aaS: $author$project$Api$Provider$Location$All$virtual(location)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Api$Provider$Location$Shared$address = function (_v0) {
	var record = _v0;
	return record.It;
};
var $author$project$Api$Provider$Location$All$address = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$address(shared);
};
var $author$project$Api$Common$Address$Shared$country = function (_v0) {
	var record = _v0;
	return record.pZ;
};
var $author$project$Components$AddressInput$formFieldsFromMaybeAddress = function (address) {
	return {
		cw: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line1, address),
		eW: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line2, address),
		pT: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$city, address),
		pZ: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$country, address),
		sZ: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$state, address),
		tC: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, address)
	};
};
var $author$project$Components$AddressInput$Address1DropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AddressInput$Model = $elm$core$Basics$identity;
var $author$project$Components$AddressInput$initFromFields = F2(
	function (id, fields) {
		return _Utils_Tuple2(
			{
				ho: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: id + '-address1-dropdown', ahx: $author$project$Components$AddressInput$Address1DropdownMsg})),
				h4: $jinjor$elm_debounce$Debounce$init,
				PB: $author$project$Utils$Form$init(fields),
				adR: id,
				agk: false,
				aP: true,
				ahe: _List_Nil
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$AddressInput$initFromApi = F2(
	function (id, address) {
		return A2(
			$author$project$Components$AddressInput$initFromFields,
			id,
			$author$project$Components$AddressInput$formFieldsFromMaybeAddress(address));
	});
var $author$project$Api$Provider$Location$Shared$phoneNumber = function (_v0) {
	var record = _v0;
	return record.Wh;
};
var $author$project$Api$Provider$Location$All$phoneNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Location$Shared$phoneNumber(shared);
};
var $author$project$Components$AddressInput$withRequired = F2(
	function (required_, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{agk: required_});
	});
var $author$project$Pages$Admin$Locations$formFieldsFromItem = function (location) {
	var _v0 = A2(
		$author$project$Components$AddressInput$initFromApi,
		'location-' + $author$project$Api$Provider$Location$All$id(location),
		$author$project$Api$Provider$Location$All$address(location));
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			It: $elm$core$Maybe$Just(
				A2(
					$author$project$Components$AddressInput$withRequired,
					!$author$project$Api$Provider$Location$All$virtual(location),
					addressInput)),
			Kg: $author$project$Api$Provider$Location$All$businessLocation(location),
			rj: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$LocationGroup$Shared$id,
				$author$project$Api$Provider$Location$All$locationGroup(location)),
			zh: $author$project$Api$Provider$Location$All$name(location),
			U8: $author$project$Api$Provider$Location$All$onlineSignupVisibility(location),
			Wg: $author$project$Pages$Admin$Locations$initPhoneInput(
				$author$project$Api$Provider$Location$All$phoneNumber(location)),
			aaS: $author$project$Api$Provider$Location$All$virtual(location)
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd));
};
var $author$project$Components$AddressInput$formFieldsInit = {cw: $elm$core$Maybe$Nothing, eW: $elm$core$Maybe$Nothing, pT: $elm$core$Maybe$Nothing, pZ: $elm$core$Maybe$Nothing, sZ: $elm$core$Maybe$Nothing, tC: $elm$core$Maybe$Nothing};
var $author$project$Components$AddressInput$init = function (id) {
	return A2($author$project$Components$AddressInput$initFromFields, id, $author$project$Components$AddressInput$formFieldsInit);
};
var $author$project$Pages$Admin$Locations$formFieldsInit = function () {
	var _v0 = $author$project$Components$AddressInput$init('new-location');
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			It: $elm$core$Maybe$Just(
				A2($author$project$Components$AddressInput$withRequired, true, addressInput)),
			Kg: false,
			rj: $elm$core$Maybe$Nothing,
			zh: '',
			U8: true,
			Wg: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
			aaS: false
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd));
}();
var $author$project$Pages$Admin$Locations$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						It: A2(
							$elm$core$Maybe$map,
							$author$project$Components$AddressInput$withRequired(!bool),
							fields.It),
						aaS: bool
					});
			case 3:
				var string = field.a;
				var locationGroup = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
				return _Utils_update(
					fields,
					{rj: locationGroup});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{U8: bool});
			case 4:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Wg: phone});
			default:
				var address = field.a;
				return _Utils_update(
					fields,
					{
						It: $elm$core$Maybe$Just(address)
					});
		}
	});
var $author$project$Pages$Admin$Locations$NameValidation = 0;
var $author$project$Pages$Admin$Locations$AddressValidation = 2;
var $author$project$Components$AddressInput$AddressValidation = 0;
var $author$project$Components$AddressInput$hasAnyAddressData = F2(
	function (showCountry, fields) {
		return $author$project$Utils$Maybe$toBool(fields.cw) || ($author$project$Utils$Maybe$toBool(fields.pT) || ($author$project$Utils$Maybe$toBool(fields.sZ) || ($author$project$Utils$Maybe$toBool(fields.tC) || (showCountry && $author$project$Utils$Maybe$toBool(fields.pZ)))));
	});
var $author$project$Components$AddressInput$validateAddress1 = F2(
	function (config, fields) {
		var effectiveRequired = config.mG || A2($author$project$Components$AddressInput$hasAnyAddressData, config.aP, fields);
		return (effectiveRequired && (!$author$project$Utils$Maybe$toBool(fields.cw))) ? _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please enter an address.')
			]) : _List_Nil;
	});
var $author$project$Components$AddressInput$validateAddress1MaxLength = function (_v0) {
	var address1 = _v0.cw;
	if (!address1.$) {
		var value = address1.a;
		return ($elm$core$String$length(value) > 50) ? _List_fromArray(
			[
				_Utils_Tuple2(0, 'Address line 1 must be 50 characters or less.')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$AddressInput$validateAddress2MaxLength = function (_v0) {
	var address2 = _v0.eW;
	if (!address2.$) {
		var value = address2.a;
		return ($elm$core$String$length(value) > 50) ? _List_fromArray(
			[
				_Utils_Tuple2(0, 'Address line 2 must be 50 characters or less.')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$AddressInput$CityValidation = 1;
var $author$project$Components$AddressInput$validateCity = F2(
	function (config, fields) {
		var effectiveRequired = config.mG || A2($author$project$Components$AddressInput$hasAnyAddressData, config.aP, fields);
		return (effectiveRequired && (!$author$project$Utils$Maybe$toBool(fields.pT))) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a city.')
			]) : _List_Nil;
	});
var $author$project$Components$AddressInput$StateValidation = 2;
var $author$project$Components$AddressInput$validateState = F2(
	function (config, fields) {
		var effectiveRequired = config.mG || A2($author$project$Components$AddressInput$hasAnyAddressData, config.aP, fields);
		return (effectiveRequired && (!$author$project$Utils$Maybe$toBool(fields.sZ))) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter a state.')
			]) : _List_Nil;
	});
var $author$project$Components$AddressInput$ZipValidation = 3;
var $author$project$Components$AddressInput$validateZip = F2(
	function (config, fields) {
		var effectiveRequired = config.mG || A2($author$project$Components$AddressInput$hasAnyAddressData, config.aP, fields);
		return (effectiveRequired && (!$author$project$Utils$Maybe$toBool(fields.tC))) ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please enter a zip code.')
			]) : _List_Nil;
	});
var $author$project$Components$AddressInput$formFieldsValidator = function (config) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$AddressInput$validateAddress1(config)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateAddress1MaxLength),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateAddress2MaxLength),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$AddressInput$validateCity(config)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$AddressInput$validateState(config)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$AddressInput$validateZip(config))
			]));
};
var $author$project$Components$AddressInput$validateForm = function (model) {
	var config = {mG: model.agk, aP: model.aP};
	var _v0 = A2(
		$author$project$Utils$Form$validate,
		$author$project$Components$AddressInput$formFieldsValidator(config),
		model.PB);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.a;
		return _Utils_Tuple2(form, true);
	} else {
		var form = _v0.a;
		return _Utils_Tuple2(form, false);
	}
};
var $author$project$Components$AddressInput$isValid = function (_v0) {
	var model = _v0;
	return $author$project$Components$AddressInput$validateForm(model).b;
};
var $author$project$Pages$Admin$Locations$validateAddress = function (fields) {
	var _v0 = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$isValid, fields.It);
	if ((!_v0.$) && (!_v0.a)) {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter an address')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Admin$Locations$LocationGroupValidation = 1;
var $author$project$Pages$Admin$Locations$validateLocationGroup = F2(
	function (requireGroupForLocations, fields) {
		var _v0 = _Utils_Tuple2(requireGroupForLocations, fields.rj);
		if (_v0.a && (_v0.b.$ === 1)) {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please pick a location group')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$Locations$PhoneValidation = 3;
var $author$project$Pages$Admin$Locations$validatePhone = function (fields) {
	var _v0 = $author$project$Components$PhoneInput$getPhones(fields.Wg);
	if (!_v0.$) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please enter a valid phone')
			]);
	}
};
var $author$project$Pages$Admin$Locations$formFieldsValidator = function (requireGroupForLocations) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.zh;
				},
				_Utils_Tuple2(0, 'Please enter a name.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Admin$Locations$validateLocationGroup(requireGroupForLocations)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Locations$validateAddress),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Locations$validatePhone)
			]));
};
var $author$project$Api$Provider$Location$All$hasPatients = function (_v0) {
	var record = _v0.b;
	return record.Qb;
};
var $author$project$Api$Provider$Location$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Location$Shared$name(shared);
};
var $author$project$Components$Admin$Location$DeleteModal$Open = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Admin$Location$DeleteModal$Reassign = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment = {$: 1};
var $author$project$Components$Admin$Location$DeleteModal$open = F2(
	function (location, remainingLocations) {
		var action = $elm$core$List$isEmpty(remainingLocations) ? $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment : $author$project$Components$Admin$Location$DeleteModal$Reassign($elm$core$Maybe$Nothing);
		return A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, $author$project$Api$Data$NotAsked);
	});
var $author$project$Api$Provider$Practice$One$requireGroupForLocations = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agj;
	});
var $author$project$Pages$Admin$Locations$Created = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$Location$One$Location = $elm$core$Basics$identity;
var $author$project$Api$Provider$Location$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Location$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Address$Shared$encode = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'line1',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.rf)),
				_Utils_Tuple2(
				'line2',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.yy)),
				_Utils_Tuple2(
				'city',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.pT)),
				_Utils_Tuple2(
				'state',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.sZ)),
				_Utils_Tuple2(
				'zip',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.tC)),
				_Utils_Tuple2(
				'country',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.pZ))
			]));
};
var $author$project$Api$Provider$Location$create = F3(
	function (apiClient, fields, toMsg) {
		var addressField = function () {
			var _v0 = fields.It;
			if (!_v0.$) {
				var address__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'address',
						$author$project$Api$Common$Address$Shared$encode(address__))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'online_signup_visibility',
									$elm$json$Json$Encode$bool(fields.U8)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'phone_number',
										A2(
											$author$project$Utils$Encode$nullable,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.Gj;
												},
												$elm$json$Json$Encode$string),
											fields.Wg)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'virtual',
											$elm$json$Json$Encode$bool(fields.aaS)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'business_location',
												$elm$json$Json$Encode$bool(fields.Kg)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'location_group',
													A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.rj)),
												addressField))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Location$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Location$locationsPath)));
	});
var $author$project$Components$AddressInput$getAddress = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return {pT: fields.pT, pZ: fields.pZ, rf: fields.cw, yy: fields.eW, sZ: fields.sZ, tC: fields.tC};
};
var $author$project$Pages$Admin$Locations$locationFromFields = function (fields) {
	var phone = A2(
		$elm$core$Maybe$andThen,
		$elm$core$List$head,
		$author$project$Components$PhoneInput$getPhones(fields.Wg));
	var address = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$getAddress, fields.It);
	return {It: address, Kg: fields.Kg, rj: fields.rj, zh: fields.zh, U8: fields.U8, Wg: phone, aaS: fields.aaS};
};
var $author$project$Pages$Admin$Locations$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Location$create,
			apiClient,
			$author$project$Pages$Admin$Locations$locationFromFields(fields),
			$author$project$Pages$Admin$Locations$Created);
	});
var $author$project$Pages$Admin$Locations$Updated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$Location$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var addressField = function () {
			var _v0 = fields.It;
			if (!_v0.$) {
				var address__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'address',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'line1',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.rf)),
									_Utils_Tuple2(
									'line2',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.yy)),
									_Utils_Tuple2(
									'city',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.pT)),
									_Utils_Tuple2(
									'state',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.sZ)),
									_Utils_Tuple2(
									'zip',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.tC)),
									_Utils_Tuple2(
									'country',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.pZ))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'online_signup_visibility',
									$elm$json$Json$Encode$bool(fields.U8)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'phone_number',
										A2(
											$author$project$Utils$Encode$nullable,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.Gj;
												},
												$elm$json$Json$Encode$string),
											fields.Wg)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'virtual',
											$elm$json$Json$Encode$bool(fields.aaS)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'business_location',
												$elm$json$Json$Encode$bool(fields.Kg)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'location_group',
													A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.rj)),
												addressField))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Location$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Location$locationPath(id_))));
	});
var $author$project$Pages$Admin$Locations$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Location$update,
			apiClient,
			id,
			$author$project$Pages$Admin$Locations$locationFromFields(fields),
			$author$project$Pages$Admin$Locations$Updated);
	});
var $author$project$Pages$Admin$Locations$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$Locations$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$Locations$createItem, apiClient, formFields);
		}
	});
var $author$project$Api$Provider$Practice$One$trackPatientsByLocation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$$;
	});
var $author$project$Components$AddressInput$Address1 = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$AddressInput$PerformSearch = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$AddressInput$debounceAddress = function (address) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$AddressInput$PerformSearch,
		$elm$core$Task$succeed(address));
};
var $author$project$Components$AddressInput$DebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$AddressInput$debounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(300),
	ahG: $author$project$Components$AddressInput$DebounceMsg
};
var $author$project$Components$AddressInput$formFieldsUpdate = F2(
	function (field, form) {
		switch (field.$) {
			case 0:
				var address1 = field.a;
				return _Utils_update(
					form,
					{cw: address1});
			case 1:
				var address2 = field.a;
				return _Utils_update(
					form,
					{eW: address2});
			case 2:
				var city = field.a;
				return _Utils_update(
					form,
					{pT: city});
			case 3:
				var state = field.a;
				return _Utils_update(
					form,
					{sZ: state});
			case 4:
				var zip = field.a;
				return _Utils_update(
					form,
					{tC: zip});
			default:
				var country = field.a;
				return _Utils_update(
					form,
					{pZ: country});
		}
	});
var $author$project$Ports$GooglePlaces$AddressWithId = F2(
	function (address, id) {
		return {It: address, adR: id};
	});
var $author$project$Ports$GooglePlaces$googlePlacesGetAutocompleteSuggestions = _Platform_outgoingPort(
	'googlePlacesGetAutocompleteSuggestions',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'address',
					$elm$json$Json$Encode$string($.It)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.adR))
				]));
	});
var $author$project$Ports$GooglePlaces$getAutocompleteSuggestions = function (addressQuery) {
	return $author$project$Ports$GooglePlaces$googlePlacesGetAutocompleteSuggestions(addressQuery);
};
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$getAutocompleteSuggestions = function (_v0) {
	var searchTerm = _v0.agI;
	var id = _v0.adR;
	return $author$project$Ports$GooglePlaces$getAutocompleteSuggestions(
		A2($author$project$Ports$GooglePlaces$AddressWithId, searchTerm, id));
};
var $author$project$Ports$GooglePlaces$PlaceWithId = F2(
	function (placeId, id) {
		return {adR: id, Wm: placeId};
	});
var $author$project$Ports$GooglePlaces$googlePlacesGetPlaceDetails = _Platform_outgoingPort(
	'googlePlacesGetPlaceDetails',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.adR)),
					_Utils_Tuple2(
					'placeId',
					$elm$json$Json$Encode$string($.Wm))
				]));
	});
var $author$project$Ports$GooglePlaces$getPlaceDetails = function (details) {
	return $author$project$Ports$GooglePlaces$googlePlacesGetPlaceDetails(details);
};
var $author$project$Api$GoogleMaps$Place$getPlaceDetails = function (_v0) {
	var placeId = _v0.Wm;
	var id = _v0.adR;
	return $author$project$Ports$GooglePlaces$getPlaceDetails(
		A2($author$project$Ports$GooglePlaces$PlaceWithId, placeId, id));
};
var $author$project$Api$GoogleMaps$AutocompleteSuggestion$placeId = function (suggestion) {
	return suggestion.Wm;
};
var $author$project$Components$AddressInput$Address2 = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$AddressInput$City = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$AddressInput$Country = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$AddressInput$State = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AddressInput$Zip = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$GoogleMaps$Place$getComponentLongName = F2(
	function (place, componentType) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.S9;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (c) {
						return A2($elm$core$List$member, componentType, c.ahJ);
					},
					place.DW)));
	});
var $author$project$Utils$String$ifEmptyThen = F2(
	function (thenStr, str) {
		return $author$project$Utils$String$isBlank(str) ? thenStr : str;
	});
var $author$project$Components$AddressInput$cityString = function (place) {
	var subLocality = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 12));
	var locality = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 11));
	return A2($author$project$Utils$String$ifEmptyThen, subLocality, locality);
};
var $author$project$Components$AddressInput$countryString = function (place) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 4));
};
var $author$project$Api$GoogleMaps$Place$getComponentShortName = F2(
	function (place, componentType) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ZN;
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (c) {
						return A2($elm$core$List$member, componentType, c.ahJ);
					},
					place.DW)));
	});
var $author$project$Components$AddressInput$stateString = function (place) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentShortName, place, 5));
};
var $author$project$Components$AddressInput$zipString = function (place) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 21));
};
var $author$project$Components$AddressInput$updateFormByPlace = F3(
	function (place, form, showCountry) {
		return (showCountry ? A2(
			$author$project$Utils$Form$update,
			$author$project$Components$AddressInput$formFieldsUpdate,
			$author$project$Components$AddressInput$Country(
				$author$project$Utils$String$toMaybe(
					$author$project$Components$AddressInput$countryString(place)))) : $elm$core$Basics$identity)(
			A3(
				$author$project$Utils$Form$update,
				$author$project$Components$AddressInput$formFieldsUpdate,
				$author$project$Components$AddressInput$Zip(
					$author$project$Utils$String$toMaybe(
						$author$project$Components$AddressInput$zipString(place))),
				A3(
					$author$project$Utils$Form$update,
					$author$project$Components$AddressInput$formFieldsUpdate,
					$author$project$Components$AddressInput$State(
						$author$project$Utils$String$toMaybe(
							$author$project$Components$AddressInput$stateString(place))),
					A3(
						$author$project$Utils$Form$update,
						$author$project$Components$AddressInput$formFieldsUpdate,
						$author$project$Components$AddressInput$City(
							$author$project$Utils$String$toMaybe(
								$author$project$Components$AddressInput$cityString(place))),
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$AddressInput$formFieldsUpdate,
							$author$project$Components$AddressInput$Address2(
								$author$project$Utils$String$toMaybe('')),
							A3(
								$author$project$Utils$Form$update,
								$author$project$Components$AddressInput$formFieldsUpdate,
								$author$project$Components$AddressInput$Address1(
									$author$project$Utils$String$toMaybe(place.zh)),
								form))))));
	});
var $author$project$Components$AddressInput$validate = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{
			PB: $author$project$Components$AddressInput$validateForm(model).a
		});
};
var $author$project$Components$AddressInput$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var address = msg.a.a;
					var updatedModel = _Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$AddressInput$formFieldsUpdate,
								$author$project$Components$AddressInput$Address1(address),
								model.PB)
						});
					var _v2 = function () {
						if (!address.$) {
							var addressText = address.a;
							return A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$AddressInput$debounceConfig, addressText, model.h4);
						} else {
							return _Utils_Tuple2(model.h4, $elm$core$Platform$Cmd$none);
						}
					}();
					var debounce = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							updatedModel,
							{h4: debounce}),
						cmd,
						_List_Nil);
				} else {
					var field = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, field, model.PB)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				return _Utils_Tuple3(
					$author$project$Components$AddressInput$validate(model),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var wasOpen = model.ho.U9;
				var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, model.ho);
				var address1Dropdown = _v4.a;
				var cmd = _v4.b;
				var updatedModel = _Utils_update(
					model,
					{ho: address1Dropdown});
				return (wasOpen && (!address1Dropdown.U9)) ? _Utils_Tuple3(
					$author$project$Components$AddressInput$validate(updatedModel),
					cmd,
					_List_Nil) : _Utils_Tuple3(updatedModel, cmd, _List_Nil);
			case 4:
				var debounceMsg = msg.a;
				var _v5 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$AddressInput$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$AddressInput$debounceAddress),
					debounceMsg,
					model.h4);
				var debounce = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h4: debounce}),
					cmd,
					_List_Nil);
			case 5:
				var searchTerm = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Api$GoogleMaps$AutocompleteSuggestion$getAutocompleteSuggestions(
						{adR: model.adR, agI: searchTerm}),
					_List_Nil);
			case 2:
				var id = msg.a;
				var placeResult = msg.b;
				if (_Utils_eq(id, model.adR)) {
					if (!placeResult.$) {
						var place = placeResult.a;
						var newForm = A3($author$project$Components$AddressInput$updateFormByPlace, place, model.PB, model.aP);
						var newModel = _Utils_update(
							model,
							{PB: newForm});
						return _Utils_Tuple3(
							$author$project$Components$AddressInput$validate(newModel),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var error = placeResult.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$DecodeFailed(error)
								]));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var id = msg.a;
				var suggestionsResult = msg.b;
				if (_Utils_eq(id, model.adR)) {
					if (!suggestionsResult.$) {
						var suggestions = suggestionsResult.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ahe: suggestions}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var error = suggestionsResult.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ahe: _List_Nil}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$DecodeFailed(error)
								]));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var suggestion = msg.a;
				var updatedModel = _Utils_update(
					model,
					{
						PB: A3(
							$author$project$Utils$Form$update,
							$author$project$Components$AddressInput$formFieldsUpdate,
							$author$project$Components$AddressInput$Address1(
								$elm$core$Maybe$Just(suggestion.Nx)),
							model.PB),
						ahe: _List_Nil
					});
				return _Utils_Tuple3(
					updatedModel,
					$author$project$Api$GoogleMaps$Place$getPlaceDetails(
						{
							adR: model.adR,
							Wm: $author$project$Api$GoogleMaps$AutocompleteSuggestion$placeId(suggestion)
						}),
					_List_Nil);
		}
	});
var $author$project$Components$Admin$Location$DeleteModal$Deleted = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$Location$DeleteModal$LocationDeleted = 1;
var $author$project$Components$Admin$Location$DeleteModal$None = 0;
var $author$project$Components$Admin$Location$DeleteModal$isValid = function (action) {
	if (!action.$) {
		var newLocation = action.a;
		return $author$project$Utils$Maybe$toBool(newLocation);
	} else {
		return true;
	}
};
var $author$project$Components$Admin$Location$DeleteModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Admin$Location$DeleteModal$Closed, as: _List_Nil};
			case 2:
				var action = msg.a;
				if (model.$ === 1) {
					var location = model.a;
					var remainingLocations = model.b;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, $author$project$Api$Data$NotAsked),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Admin$Location$DeleteModal$Closed, as: _List_Nil};
				}
			case 4:
				var id = msg.a;
				if (model.$ === 1) {
					var location = model.a;
					var remainingLocations = model.b;
					var action = model.c;
					var response = model.d;
					if (!action.$) {
						var newLocation = A2(
							$elm_community$list_extra$List$Extra$find,
							function (location_) {
								return _Utils_eq(
									id,
									$author$project$Api$Provider$Location$All$id(location_));
							},
							remainingLocations);
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: A4(
								$author$project$Components$Admin$Location$DeleteModal$Open,
								location,
								remainingLocations,
								$author$project$Components$Admin$Location$DeleteModal$Reassign(newLocation),
								response),
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment, response),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Admin$Location$DeleteModal$Closed, as: _List_Nil};
				}
			case 1:
				if (model.$ === 1) {
					var location = model.a;
					var remainingLocations = model.b;
					var action = model.c;
					if ($author$project$Components$Admin$Location$DeleteModal$isValid(action)) {
						var newLocation = function () {
							if (!action.$) {
								var newLocation_ = action.a;
								return newLocation_;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return {
							EC: A4(
								$author$project$Api$Provider$Location$delete,
								apiClient,
								$author$project$Api$Provider$Location$All$id(location),
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, newLocation),
								$author$project$Components$Admin$Location$DeleteModal$Deleted(newLocation)),
							ac5: 0,
							y8: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, $author$project$Api$Data$Loading),
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, $author$project$Api$Data$NotAsked),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Admin$Location$DeleteModal$Closed, as: _List_Nil};
				}
			default:
				var newLocation = msg.a;
				var response = msg.b;
				if (model.$ === 1) {
					var location = model.a;
					var remainingLocations = model.b;
					var action = model.c;
					switch (response.$) {
						case 3:
							var message = function () {
								if (!newLocation.$) {
									var newLocation_ = newLocation.a;
									return $elm$core$String$concat(
										_List_fromArray(
											[
												' All patients currently assigned to ',
												$author$project$Api$Provider$Location$All$name(location),
												' will be assigned to ',
												$author$project$Api$Provider$Location$All$name(newLocation_),
												'.',
												'For large volumes of patients, this may take a few minutes behind the scenes.'
											]));
								} else {
									return '';
								}
							}();
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 1,
								y8: $author$project$Components$Admin$Location$DeleteModal$Closed,
								as: _List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										$author$project$Api$Provider$Location$All$name(location) + (' was successfully removed.' + message)),
										$author$project$OutMsg$RefreshPractice
									])
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: A4($author$project$Components$Admin$Location$DeleteModal$Open, location, remainingLocations, action, response),
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Admin$Location$DeleteModal$Closed, as: _List_Nil};
				}
		}
	});
var $author$project$Components$LinkedRecords$GotLinkedRecords = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$LinkedRecords$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$LinkedRecord$All$LinkedRecord = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$LinkedRecord$Shared$LinkedRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$LinkedRecord$Shared$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$LinkedRecord$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$Shared$Record));
var $author$project$Api$Provider$LinkedRecord$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LinkedRecord$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LinkedRecord$All$AllRecord = function (practice) {
	return {WF: practice};
};
var $author$project$Api$Provider$LinkedRecord$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Provider$Practice$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$All$AllRecord));
var $author$project$Api$Provider$LinkedRecord$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LinkedRecord$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$LinkedRecord$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$All$LinkedRecord)));
var $author$project$Api$Provider$LinkedRecord$linkablePath = function (linkable) {
	var id_ = linkable;
	return $author$project$Api$Provider$Location$locationPath(id_);
};
var $author$project$Api$Provider$LinkedRecord$linkedRecordsPath = function (linkable) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['linked_records']),
		$author$project$Api$Provider$LinkedRecord$linkablePath(linkable));
};
var $author$project$Api$Provider$LinkedRecord$list = F3(
	function (apiClient, linkable, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$LinkedRecord$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$LinkedRecord$linkedRecordsPath(linkable)));
	});
var $author$project$Components$LinkedRecords$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var linkable = msg.a;
				return _Utils_Tuple3(
					$author$project$Components$LinkedRecords$Open($author$project$Api$Data$Loading),
					A3($author$project$Api$Provider$LinkedRecord$list, apiClient, linkable, $author$project$Components$LinkedRecords$GotLinkedRecords),
					_List_Nil);
			case 1:
				return _Utils_Tuple3($author$project$Components$LinkedRecords$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
			default:
				var response = msg.a;
				if (model.$ === 1) {
					return _Utils_Tuple3(
						$author$project$Components$LinkedRecords$Open(response),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Locations$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iZ: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								iZ: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Locations$fetchList(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						iZ: $author$project$Api$Data$Loading,
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Locations$fetchList(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{iZ: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Locations$fetchList(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S$: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 5:
				var _v5 = $author$project$Pages$Admin$Locations$formFieldsInit;
				var formFields = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 6:
				var _v6 = $author$project$Pages$Admin$Locations$formFieldsForBusinessLocation(
					$author$project$Api$Provider$Practice$One$name(model.WF));
				var formFields = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 8:
				var item = msg.a;
				var _v7 = $author$project$Pages$Admin$Locations$formFieldsFromItem(item);
				var formFields = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Location$All$id(item)),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 7:
				var item = msg.a;
				var _v8 = $author$project$Pages$Admin$Locations$formFieldsFromBusinessLocation(item);
				var formFields = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Location$All$id(item)),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var field = msg.a;
				var _v9 = model.FU;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					var item = _v10.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Locations$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var form = msg.a;
				var id = msg.b;
				var fields = $author$project$Utils$Form$fields(form);
				var address = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$validate, fields.It);
				var newForm = function () {
					if (!address.$) {
						var address_ = address.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Pages$Admin$Locations$formFieldsUpdate,
							$author$project$Pages$Admin$Locations$Address(address_),
							form);
					} else {
						return form;
					}
				}();
				var _v11 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$Admin$Locations$formFieldsValidator(
						$author$project$Api$Provider$Practice$One$requireGroupForLocations(model.WF)),
					newForm);
				if (!_v11.$) {
					var _v12 = _v11.a;
					var validatedForm = _v12.a;
					var validFormFields = _v12.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$Locations$saveItem, model.D5, id, validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v11.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var item = msg.a;
				var locations = msg.b;
				if (($elm$core$List$length(locations) === 1) && $author$project$Api$Provider$Practice$One$trackPatientsByLocation(model.WF)) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'Practice tracks patients by locations. Can\'t delete last one.')
							]));
				} else {
					var _v14 = _Utils_Tuple2(
						A2(
							$author$project$Api$Expandable$withDefault,
							true,
							$author$project$Api$Provider$Location$All$hasPatients(item)),
						$author$project$Api$Provider$Location$All$isMaster(item) || $author$project$Api$Provider$Location$All$isSynced(item));
					if (_v14.a) {
						if (_v14.b) {
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 2, 'This location is currently part of an affiliation. Please contact us to unlink this location prior to deletion')
									]));
						} else {
							var remainingLocations = A2(
								$elm$core$List$filter,
								function (remainingLocation) {
									return !_Utils_eq(
										$author$project$Api$Provider$Location$All$id(item),
										$author$project$Api$Provider$Location$All$id(remainingLocation));
								},
								locations);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										h7: A2($author$project$Components$Admin$Location$DeleteModal$open, item, remainingLocations)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						}
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ic: $elm$core$Maybe$Just(item)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				}
			case 13:
				var response = msg.a;
				var _v15 = model.FU;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var id = _v16.a;
					var form = _v16.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$Locations$fetchList(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Location$One$name(item)),
									$author$project$OutMsg$RefreshPractice
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var response = msg.a;
				var _v18 = model.FU;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var id = _v19.a;
					var form = _v19.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$Locations$fetchList(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Location$One$name(item) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$Location$All$id(item),
										model.dN),
									iZ: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Locations$fetchList(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Location$All$name(item) + ' was successfully removed.'),
									$author$project$OutMsg$RefreshPractice
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$Location$All$id(item),
										model.dN)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$Location$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ic: $elm$core$Maybe$Nothing,
								dN: A2($elm$core$Set$insert, id, model.dN)
							}),
						A4(
							$author$project$Api$Provider$Location$delete,
							model.D5,
							id,
							$elm$core$Maybe$Nothing,
							$author$project$Pages$Admin$Locations$Deleted(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 17:
				var subMsg = msg.a;
				var _v22 = A3($author$project$Components$LinkedRecords$update, model.D5, subMsg, model.mS);
				var linkedRecords = _v22.a;
				var subCmd = _v22.b;
				var subOutMsg = _v22.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mS: linkedRecords}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$LinkedRecordsMsg, subCmd),
					subOutMsg);
			case 18:
				var subMsg = msg.a;
				var _v23 = model.FU;
				if (!_v23.$) {
					var _v24 = _v23.a;
					var id = _v24.a;
					var form = _v24.b;
					var item = _v24.c;
					var _v25 = $author$project$Utils$Form$fields(form);
					var phone = _v25.Wg;
					var _v26 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
					var phoneInput = _v26.a;
					var phoneCmd = _v26.b;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Admin$Locations$formFieldsUpdate,
						$author$project$Pages$Admin$Locations$Phone(phoneInput),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$PhoneInputMsg, phoneCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var subMsg = msg.a;
				var _v27 = model.FU;
				if (!_v27.$) {
					var _v28 = _v27.a;
					var id = _v28.a;
					var form = _v28.b;
					var item = _v28.c;
					var _v29 = $author$project$Utils$Form$fields(form);
					var address = _v29.It;
					if (!address.$) {
						var address_ = address.a;
						var _v31 = A2($author$project$Components$AddressInput$update, subMsg, address_);
						var addressInputModel = _v31.a;
						var addressInputCmd = _v31.b;
						var outMsgs = _v31.c;
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Pages$Admin$Locations$formFieldsUpdate,
							$author$project$Pages$Admin$Locations$Address(addressInputModel),
							form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, newForm, item))
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd),
							outMsgs);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$Location$DeleteModal$update, model.D5, subMsg, model.h7);
				var _v32 = function () {
					var _v33 = result.ac5;
					if (_v33 === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{iZ: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$Locations$fetchList(model));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v32.a;
				var cmd = _v32.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{h7: result.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$DeleteModalMsg, result.EC)
							])),
					result.as);
			default:
				var subMsg = msg.a;
				var _v34 = A3($author$project$Components$ExportCsv$update, model.D5, subMsg, model.l9);
				var exportCsv = _v34.a;
				var subCmd = _v34.b;
				var subOutMsg = _v34.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Admin$Locations$New = {$: 5};
var $author$project$Pages$Admin$Locations$NewBusinessAddress = {$: 6};
var $author$project$Pages$Admin$Locations$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Practice$One$hasBusinessLocation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.Kg;
		},
		$author$project$Utils$Maybe$toBool));
var $author$project$Api$Provider$LinkedRecord$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$LinkedRecord$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$LinkedRecord$Shared$id(shared);
};
var $author$project$Api$Provider$LinkedRecord$All$practice = function (_v0) {
	var record = _v0.b;
	return record.WF;
};
var $author$project$Components$LinkedRecords$viewLinkedRecord = function (linkedRecord) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$Practice$Min$name(
							$author$project$Api$Provider$LinkedRecord$All$practice(linkedRecord)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$LinkedRecord$All$id(linkedRecord))
					]))
			]));
};
var $author$project$Components$LinkedRecords$viewTable = function (linkedRecords) {
	var _v0 = function () {
		if (linkedRecords.$ === 3) {
			var list = linkedRecords.a;
			return _Utils_Tuple2(false, list);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var linkedRecords_ = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(loading),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No linked records.')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Practice Name')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Linked Record ID')
					]))
			]),
		A2($elm$core$List$map, $author$project$Components$LinkedRecords$viewLinkedRecord, linkedRecords_),
		_List_Nil);
};
var $author$project$Components$LinkedRecords$modal = function (model) {
	if (model.$ === 1) {
		var linkedRecords = model.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$LinkedRecords$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Linked Records')
								]))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$author$project$Components$LinkedRecords$viewTable(linkedRecords)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Components$LinkedRecords$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$Location$DeleteModal$Delete = {$: 1};
var $author$project$Components$Admin$Location$DeleteModal$UpdateAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Location$DeleteModal$UpdateNewLocation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Location$DeleteModal$locationOptions = function (locations) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a location...'),
		A2(
			$elm$core$List$map,
			function (location) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Location$All$id(location)),
					$author$project$Api$Provider$Location$All$name(location));
			},
			locations));
};
var $author$project$Components$Admin$Location$DeleteModal$viewModal = F4(
	function (location, remainingLocations, action, request) {
		var _v0 = function () {
			if (!action.$) {
				return _Utils_Tuple2(true, false);
			} else {
				return _Utils_Tuple2(false, true);
			}
		}();
		var reassignActive = _v0.a;
		var removeAssignmentActive = _v0.b;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Admin$Location$DeleteModal$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('What would you like to do with patients assigned to this location?')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Action'),
									$author$project$Ui$Form$Group$labelSpan(2),
									$author$project$Ui$Form$Group$inputSpan(10)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Button$group(
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Reasign to new location'},
											_List_fromArray(
												[
													$author$project$Ui$Button$active(reassignActive),
													$author$project$Ui$Button$disabled(
													$elm$core$List$isEmpty(remainingLocations)),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Admin$Location$DeleteModal$UpdateAction(
														$author$project$Components$Admin$Location$DeleteModal$Reassign($elm$core$Maybe$Nothing)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reassign')
												])),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Remove location assignment'},
											_List_fromArray(
												[
													$author$project$Ui$Button$active(removeAssignmentActive),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Admin$Location$DeleteModal$UpdateAction($author$project$Components$Admin$Location$DeleteModal$RemoveAssignment))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove assignment')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pt-05')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													function () {
													if (!action.$) {
														return $elm$html$Html$text(
															'All patients currently assigned to ' + ($author$project$Api$Provider$Location$All$name(location) + ' will be assigned to the location selected below'));
													} else {
														return $elm$html$Html$text(
															'All patients currently assigned to ' + ($author$project$Api$Provider$Location$All$name(location) + ' will no longer be assigned to a location'));
													}
												}()
												]))
										])),
									function () {
									if (!action.$) {
										var newLocation = action.a;
										var newLocationInvalid = !$author$project$Utils$Maybe$toBool(newLocation);
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pt-05')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, newLocation)),
															$author$project$Ui$Form$Select$onChange($author$project$Components$Admin$Location$DeleteModal$UpdateNewLocation),
															$author$project$Ui$Form$Select$invalid(newLocationInvalid),
															$author$project$Ui$Form$Select$errors(
															newLocationInvalid ? _List_fromArray(
																['Please pick a location for reassignment']) : _List_Nil)
														]),
													$author$project$Components$Admin$Location$DeleteModal$locationOptions(remainingLocations))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Location$DeleteModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Delete location'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Location$DeleteModal$Delete),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Location$DeleteModal$view = function (model) {
	if (model.$ === 1) {
		var location = model.a;
		var remainingLocations = model.b;
		var action = model.c;
		var request = model.d;
		return A4($author$project$Components$Admin$Location$DeleteModal$viewModal, location, remainingLocations, action, request);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Locations$FormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Locations$LocationGroup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Locations$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Locations$OnlineSignupVisibility = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Locations$Save = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Admin$Locations$Virtual = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Select$Loading = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Select$loading = $author$project$Ui$Form$Select$Loading;
var $author$project$Api$Provider$LocationGroup$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$LocationGroup$Shared$id(shared);
};
var $author$project$Api$Common$LocationGroup$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Common$LocationGroup$Shared$name = function (_v0) {
	var min = _v0;
	return $author$project$Api$Common$LocationGroup$Min$name(min);
};
var $author$project$Api$Provider$LocationGroup$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$LocationGroup$Shared$name(shared);
};
var $author$project$Pages$Admin$Locations$locationGroupOptions = function (locationGroups) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'None'),
		A2(
			$elm$core$List$map,
			function (locationGroup) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$LocationGroup$All$id(locationGroup)),
					$author$project$Api$Provider$LocationGroup$All$name(locationGroup));
			},
			locationGroups));
};
var $author$project$Components$AddressInput$CountryValidation = 4;
var $author$project$Components$AddressInput$FieldBlurred = {$: 1};
var $author$project$Components$AddressInput$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$AddressInput$SuggestionSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Input$AriaLabel = function (a) {
	return {$: 24, a: a};
};
var $author$project$Ui$Form$Input$ariaLabel = $author$project$Ui$Form$Input$AriaLabel;
var $author$project$Ui$NewDropdown$ComboboxPlaceholder = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$NewDropdown$comboboxPlaceholder = $author$project$Ui$NewDropdown$ComboboxPlaceholder;
var $author$project$Ui$Form$Input$MaxLength = function (a) {
	return {$: 21, a: a};
};
var $author$project$Ui$Form$Input$maxLength = $author$project$Ui$Form$Input$MaxLength;
var $author$project$Components$AddressInput$defaultOptions = {dW: false};
var $author$project$Components$AddressInput$updateOptionsRecord = F2(
	function (option, options) {
		var bool = option;
		return _Utils_update(
			options,
			{dW: bool});
	});
var $author$project$Components$AddressInput$optionsListToRecord = function (optionsList) {
	return A3($elm$core$List$foldl, $author$project$Components$AddressInput$updateOptionsRecord, $author$project$Components$AddressInput$defaultOptions, optionsList);
};
var $author$project$Components$AddressInput$validationGroupElementId = F2(
	function (modelId, validationGroup) {
		switch (validationGroup) {
			case 0:
				return modelId + '-address';
			case 1:
				return modelId + '-city';
			case 2:
				return modelId + '-state';
			case 3:
				return modelId + '-zip';
			default:
				return modelId + '-country';
		}
	});
var $author$project$Ui$NewDropdown$ComboboxInputFocused = {$: 2};
var $author$project$Ui$NewDropdown$ComboboxInputTyped = {$: 1};
var $author$project$Ui$NewDropdown$comboboxTriggerKeyHandlers = F2(
	function (onEnterMsg, toMsg) {
		return A2(
			$elm$html$Html$Events$custom,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					var andPreventDefault = $elm$json$Json$Decode$map(
						function (msg_) {
							return {aeD: msg_, A9: true, Cs: true};
						});
					switch (key) {
						case 'ArrowDown':
							return andPreventDefault(
								$elm$json$Json$Decode$succeed(
									toMsg(
										$author$project$Ui$NewDropdown$ArrowPressed(1))));
						case 'ArrowUp':
							return andPreventDefault(
								$elm$json$Json$Decode$succeed(
									toMsg(
										$author$project$Ui$NewDropdown$ArrowPressed(0))));
						case 'Enter':
							if (!onEnterMsg.$) {
								var msg = onEnterMsg.a;
								return andPreventDefault(
									$elm$json$Json$Decode$succeed(msg));
							} else {
								return $elm$json$Json$Decode$fail('ignore');
							}
						default:
							return $elm$json$Json$Decode$succeed(
								{
									aeD: toMsg($author$project$Ui$NewDropdown$ComboboxInputTyped),
									A9: false,
									Cs: false
								});
					}
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
	});
var $author$project$Ui$NewDropdown$decodePressedKey = F2(
	function (expectedKey, toMsg) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (key) {
				return _Utils_eq(key, expectedKey) ? $elm$json$Json$Decode$succeed(toMsg) : $elm$json$Json$Decode$fail('ignore');
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	});
var $author$project$Ui$NewDropdown$onEnterUp = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'keyup',
		A2(
			$elm$json$Json$Decode$map,
			function (msg_) {
				return {aeD: msg_, A9: true, Cs: true};
			},
			A2($author$project$Ui$NewDropdown$decodePressedKey, 'Enter', msg)));
};
var $author$project$Ui$NewDropdown$viewCombobox = F4(
	function (options, inputOptions, items, model) {
		var toMsg = model.ahx;
		var optionsRecord = $author$project$Ui$NewDropdown$optionsToRecord(options);
		var errorDescription = $elm$core$List$isEmpty(optionsRecord.fE) ? _List_Nil : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$attribute,
				'aria-describedby',
				A2($elm$core$String$join, '. ', optionsRecord.fE))
			]);
		var ariaInvalid = (optionsRecord.q$ || (!$elm$core$List$isEmpty(optionsRecord.fE))) ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-dropdown'),
					$elm$html$Html$Attributes$id(model.adR),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('new-dropdown--open', model.U9 && ((!optionsRecord.dW) && (!optionsRecord.sk))),
							_Utils_Tuple2(
							'new-dropdown--invalid',
							optionsRecord.q$ || (!$elm$core$List$isEmpty(optionsRecord.fE))),
							_Utils_Tuple2('new-dropdown--disabled', optionsRecord.dW),
							_Utils_Tuple2('new-dropdown--readonly', optionsRecord.sk)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$class('new-dropdown__trigger new-dropdown__trigger--input'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$id(model.adR + '-trigger'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$type_('text'),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$autocomplete(false),
									A2(
										$elm$core$List$cons,
										A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox'),
										A2(
											$elm$core$List$cons,
											$elm$html$Html$Events$onFocus(
												toMsg($author$project$Ui$NewDropdown$ComboboxInputFocused)),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$type_('combobox'),
												A2(
													$elm$core$List$cons,
													$elm$html$Html$Events$onInput(inputOptions.afc),
													A2(
														$elm$core$List$cons,
														$elm$html$Html$Attributes$placeholder(optionsRecord.v7),
														A2(
															$elm$core$List$cons,
															$elm$html$Html$Attributes$value(inputOptions.aaN),
															A2(
																$elm$core$List$cons,
																A2(
																	$elm$html$Html$Attributes$attribute,
																	'aria-expanded',
																	model.U9 ? 'true' : 'false'),
																A2(
																	$elm$core$List$cons,
																	$elm$core$String$isEmpty(optionsRecord.abp) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.abp),
																	A2(
																		$elm$core$List$cons,
																		A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'options-list'),
																		A2(
																			$elm$core$List$cons,
																			model.U9 ? A2(
																				$elm$html$Html$Attributes$map,
																				toMsg,
																				$author$project$Ui$NewDropdown$onEnterUp($author$project$Ui$NewDropdown$DropdownButtonClicked)) : $elm$html$Html$Attributes$class(''),
																			_Utils_ap(
																				optionsRecord.dW ? _List_fromArray(
																					[
																						A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true'),
																						$elm$html$Html$Attributes$disabled(true)
																					]) : (optionsRecord.sk ? _List_fromArray(
																					[
																						$elm$html$Html$Attributes$readonly(true)
																					]) : _List_fromArray(
																					[
																						A2(
																						$author$project$Ui$NewDropdown$comboboxTriggerKeyHandlers,
																						model.U9 ? inputOptions.ae8 : $elm$core$Maybe$Nothing,
																						toMsg)
																					])),
																				_Utils_ap(errorDescription, ariaInvalid)))))))))))))))),
					_List_Nil),
					(optionsRecord.dW || optionsRecord.sk) ? $elm$html$Html$text('') : ($elm$core$List$isEmpty(items) ? $elm$html$Html$text('') : A3($author$project$Ui$NewDropdown$viewMenu, toMsg, model, items))
				]));
	});
var $author$project$Components$AddressInput$view = F2(
	function (options, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Components$AddressInput$optionsListToRecord(options);
		var _v1 = model.aP ? _Utils_Tuple3(7, 5, 4) : _Utils_Tuple3(5, 4, 3);
		var cityColumnSize = _v1.a;
		var stateColumnSize = _v1.b;
		var zipColumnSize = _v1.c;
		var _v2 = $author$project$Utils$Form$fields(model.PB);
		var address1 = _v2.cw;
		var address2 = _v2.eW;
		var city = _v2.pT;
		var state = _v2.sZ;
		var zip = _v2.tC;
		var country = _v2.pZ;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.adR)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('select')
										]),
									_List_fromArray(
										[
											A4(
											$author$project$Ui$NewDropdown$viewCombobox,
											_List_fromArray(
												[
													$author$project$Ui$NewDropdown$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
													$author$project$Ui$NewDropdown$disabled(optionsRecord.dW),
													$author$project$Ui$NewDropdown$comboboxPlaceholder('Address line 1')
												]),
											{
												ae8: A2(
													$elm$core$Maybe$map,
													$author$project$Components$AddressInput$SuggestionSelected,
													$elm$core$List$head(model.ahe)),
												afc: A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Address1),
													$author$project$Utils$String$toMaybe),
												aaN: A2($elm$core$Maybe$withDefault, '', address1)
											},
											A2(
												$elm$core$List$map,
												function (suggestion) {
													return A2(
														$author$project$Ui$NewDropdown$item,
														_List_fromArray(
															[
																$author$project$Ui$NewDropdown$onSelect(
																$author$project$Components$AddressInput$SuggestionSelected(suggestion))
															]),
														$elm$html$Html$text(suggestion.Nx));
												},
												model.ahe),
											model.ho)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 0, model.PB))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', address2)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Address2),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$disabled(optionsRecord.dW),
											$author$project$Ui$Form$Input$placeholder('Address line 2'),
											$author$project$Ui$Form$Input$ariaLabel('Address line 2'),
											$author$project$Ui$Form$Input$maxLength(50),
											$author$project$Ui$Form$Input$autoComplete(false),
											$author$project$Ui$Form$Input$autoCorrect(false),
											$author$project$Ui$Form$Input$autoCapitalize(false),
											$author$project$Ui$Form$Input$spellCheck(false),
											$author$project$Ui$Form$Input$phi(true)
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(cityColumnSize)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$id(
											A2($author$project$Components$AddressInput$validationGroupElementId, model.adR, 1)),
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', city)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$City),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
											$author$project$Ui$Form$Input$disabled(optionsRecord.dW),
											$author$project$Ui$Form$Input$placeholder('City'),
											$author$project$Ui$Form$Input$ariaLabel('City')
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 1, model.PB))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(stateColumnSize)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$id(
											A2($author$project$Components$AddressInput$validationGroupElementId, model.adR, 2)),
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', state)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$State),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB)),
											$author$project$Ui$Form$Input$disabled(optionsRecord.dW),
											$author$project$Ui$Form$Input$placeholder('State'),
											$author$project$Ui$Form$Input$ariaLabel('State')
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 2, model.PB))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(zipColumnSize)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$id(
											A2($author$project$Components$AddressInput$validationGroupElementId, model.adR, 3)),
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', zip)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Zip),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
											$author$project$Ui$Form$Input$disabled(optionsRecord.dW),
											$author$project$Ui$Form$Input$placeholder('Zip Code'),
											$author$project$Ui$Form$Input$ariaLabel('Zip Code'),
											$author$project$Ui$Form$Input$autoComplete(false),
											$author$project$Ui$Form$Input$autoCorrect(false),
											$author$project$Ui$Form$Input$autoCapitalize(false),
											$author$project$Ui$Form$Input$spellCheck(false)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 3, model.PB))
								])),
							model.aP ? A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$id(
											A2($author$project$Components$AddressInput$validationGroupElementId, model.adR, 4)),
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', country)),
											$author$project$Ui$Form$Input$onInput(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Country),
												$author$project$Utils$String$toMaybe)),
											$author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 4, model.PB)),
											$author$project$Ui$Form$Input$disabled(optionsRecord.dW),
											$author$project$Ui$Form$Input$placeholder('Country'),
											$author$project$Ui$Form$Input$ariaLabel('Country')
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 4, model.PB))
								])) : A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$empty]))
						]))
				]));
	});
var $author$project$Pages$Admin$Locations$viewModal = F4(
	function (model, id, form, item) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Location',
			S_: _Utils_eq(item, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$Locations$CancelEdit,
			U0: $author$project$Pages$Admin$Locations$Save(form)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			var _v1 = model.S$;
			if (_v1.$ === 3) {
				var locationGroups_ = _v1.a;
				return _Utils_Tuple2(false, locationGroups_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var locationGroupsLoading = _v0.a;
		var locationGroups = _v0.b;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.zh),
									$author$project$Ui$Form$Input$placeholder('Location Name'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Virtual')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.aaS),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$Virtual))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Address'),
							$author$project$Ui$Form$Group$required(!fields.aaS)
						]),
					_List_fromArray(
						[
							function () {
							var _v2 = fields.It;
							if (!_v2.$) {
								var addressInput = _v2.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Locations$AddressInputMsg,
									A2($author$project$Components$AddressInput$view, _List_Nil, addressInput));
							} else {
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											$author$project$Utils$Html$empty,
											A2(
												$elm$core$Maybe$map,
												$author$project$Components$AddressDisplay$view,
												$author$project$Api$Provider$Practice$One$address(model.WF))),
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('You can edit this address on the '),
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Admin__Practice,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Admin > Account page')
														]))
												]))
										]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Group'),
							$author$project$Ui$Form$Group$required(
							$author$project$Api$Provider$Practice$One$requireGroupForLocations(model.WF))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(fields.rj),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$LocationGroup)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form)),
									$author$project$Ui$Form$Select$loading(locationGroupsLoading)
								]),
							$author$project$Pages$Admin$Locations$locationGroupOptions(locationGroups))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Phone')
						]),
					function () {
						var _v3 = _Utils_Tuple2(
							fields.Kg,
							$elm$core$List$head(
								$author$project$Api$Provider$Practice$One$phones(model.WF)));
						if (_v3.a) {
							if (!_v3.b.$) {
								var phone = _v3.b.a;
								var _v4 = $author$project$Api$Common$Phone$Shared$number(phone);
								if (!_v4.$) {
									var number = _v4.a;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Formatters$Phone$format(number)),
													$elm$html$Html$text(
													' (' + ($author$project$Formatters$PhoneType$toString(
														$author$project$Api$Common$Phone$Shared$type_(phone)) + ')'))
												]))
										]);
								} else {
									return _List_Nil;
								}
							} else {
								var _v5 = _v3.b;
								return _List_Nil;
							}
						} else {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Locations$PhoneInputMsg,
									$author$project$Components$PhoneInput$view(fields.Wg)),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 3, form))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Allow Online Signup')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.U8),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$OnlineSignupVisibility))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Locations$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Locations$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name'),
		A3($author$project$Api$Column$init, '', false, 'Address'),
		A3($author$project$Api$Column$init, '', false, 'Phone'),
		A3($author$project$Api$Column$init, '', false, 'Group'),
		A3($author$project$Api$Column$init, 'online_signup_visibility', true, 'Online signup')
	]);
var $author$project$Pages$Admin$Locations$Delete = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$Locations$Edit = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$Locations$EditBusinessItemClicked = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$LinkedRecord$Location = $elm$core$Basics$identity;
var $author$project$Ui$Icon$Link = 25;
var $author$project$Components$LinkedRecords$OpenModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$LinkedRecords$button = function (linkable) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Link record'},
		_List_fromArray(
			[
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$onClick(
				$author$project$Components$LinkedRecords$OpenModal(linkable))
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$Icon$view, _List_Nil, 25)
			]));
};
var $author$project$Api$Provider$Location$Meta$deleteAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Np;
};
var $author$project$Api$Expandable$map = F2(
	function (f, expandable_) {
		if (!expandable_.$) {
			var a = expandable_.a;
			return $author$project$Api$Expandable$Expanded(
				f(a));
		} else {
			return $author$project$Api$Expandable$NotExpanded;
		}
	});
var $author$project$Api$Provider$Location$All$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Pages$Admin$Locations$viewItem = F3(
	function (model, items, item) {
		var id = $author$project$Api$Provider$Location$All$id(item);
		var loading = A2($elm$core$Set$member, id, model.dN);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Location$All$name(item)),
							$author$project$Utils$Html$noBreakSpace,
							model.FR ? A2(
							$elm$html$Html$map,
							$author$project$Pages$Admin$Locations$LinkedRecordsMsg,
							$author$project$Components$LinkedRecords$button(id)) : $author$project$Utils$Html$empty,
							$author$project$Api$Provider$Location$All$businessLocation(item) ? A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text('Business Location')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = _Utils_Tuple2(
								$author$project$Api$Provider$Location$All$virtual(item),
								$author$project$Api$Provider$Location$All$address(item));
							if (_v0.a) {
								return A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Virtual location')
										]));
							} else {
								if (!_v0.b.$) {
									var address = _v0.b.a;
									return $author$project$Components$AddressDisplay$view(address);
								} else {
									var _v1 = _v0.b;
									return $elm$html$Html$text('N/A');
								}
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Phone$format,
											$author$project$Api$Provider$Location$All$phoneNumber(item))))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Common$LocationGroup$Shared$name,
									$author$project$Api$Provider$Location$All$locationGroup(item))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Api$Provider$Location$All$onlineSignupVisibility(item) ? A2($author$project$Ui$Icon$view, _List_Nil, 18) : A2($author$project$Ui$Icon$view, _List_Nil, 19)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit location'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Api$Provider$Location$All$businessLocation(item) ? $author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Locations$EditBusinessItemClicked(item)) : $author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Locations$Edit(item)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete location'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											A2($author$project$Pages$Admin$Locations$Delete, item, items)),
											$author$project$Ui$Button$disabled(
											!A2(
												$author$project$Api$Expandable$withDefault,
												false,
												A2(
													$author$project$Api$Expandable$map,
													$author$project$Api$Provider$Location$Meta$deleteAction,
													$author$project$Api$Provider$Location$All$meta(item)))),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Locations$viewPanelTable = function (model) {
	var _v0 = function () {
		var _v1 = model.iZ;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no locations.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$Locations$SortTable)),
					$author$project$Pages$Admin$Locations$columns),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$pull(1)
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Pages$Admin$Locations$viewItem, model, items),
			items),
		_List_Nil);
};
var $author$project$Pages$Admin$Locations$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Locations$LinkedRecordsMsg,
				$author$project$Components$LinkedRecords$modal(model.mS)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Locations$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					model.D5,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$path($author$project$Api$Provider$Location$locationsPath),
							$author$project$Components$ExportCsv$params(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Location$listOptionsToParams, $author$project$Pages$Admin$Locations$fetchParams)(model))
						]),
					model.l9)),
				function () {
				var _v0 = model.FU;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var item = _v1.c;
					return A4($author$project$Pages$Admin$Locations$viewModal, model, id, form, item);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ic;
				if (!_v2.$) {
					var item = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Locations$HiConfirmClosed(item),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('location'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$Location$All$name(item))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Locations$DeleteModalMsg,
				$author$project$Components$Admin$Location$DeleteModal$view(model.h7)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										$elm$html$Html$text('Locations')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Add new location'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$pull(1),
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$Locations$New),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Location')
											])),
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$pull(1)
											]),
										_List_fromArray(
											[$author$project$Utils$Html$noBreakSpace])),
										$author$project$Api$Provider$Practice$One$hasBusinessLocation(model.WF) ? $author$project$Utils$Html$empty : A3(
										$author$project$Ui$Button$view,
										{abp: 'Include primary business address as a location'},
										_List_fromArray(
											[
												$author$project$Ui$Button$pull(1),
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$Locations$NewBusinessAddress)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Include primary business address as a location')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Admin$Locations$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
													]))
											]))
									]))
							])),
						$author$project$Pages$Admin$Locations$viewPanelTable(model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Locations$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.iZ))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Locations'
	};
};
var $author$project$Pages$Admin$Locations$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Locations$init, aer: $author$project$Pages$Admin$Locations$load, agD: $author$project$Pages$Admin$Locations$save, ahd: $author$project$Pages$Admin$Locations$subscriptions, aaq: $author$project$Pages$Admin$Locations$update, ahP: $author$project$Pages$Admin$Locations$view});
var $author$project$Pages$Admin$Mailgun$GotMailgun = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Mailgun$formFieldsInit = {Oo: '', xl: ''};
var $author$project$Api$Provider$Mailgun$One$Mailgun = $elm$core$Basics$identity;
var $author$project$Api$Provider$Mailgun$One$Record = F5(
	function (status, domain, email, sendingDnsRecords, meta) {
		return {N_: domain, Oo: email, TU: meta, Zv: sendingDnsRecords, ag7: status};
	});
var $author$project$Api$Provider$Mailgun$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Mailgun$Meta$MetaRecord = function (actions) {
	return {tF: actions};
};
var $author$project$Api$Provider$Mailgun$Meta$ActionsRecord = F2(
	function (setup, verify) {
		return {ZF: setup, aaP: verify};
	});
var $author$project$Api$Provider$Mailgun$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'verify',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'setup',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$Meta$ActionsRecord)));
var $author$project$Api$Provider$Mailgun$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Mailgun$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$Meta$MetaRecord));
var $author$project$Api$Provider$Mailgun$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Mailgun$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$SendingDnsRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$Record = F4(
	function (valid, recordType, name, value) {
		return {zh: name, XX: recordType, aaL: valid, aaN: value};
	});
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'value',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'record_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'valid',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$SendingDnsRecord$Record)))));
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Mailgun$SendingDnsRecord$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Mailgun$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Mailgun$Meta$decoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sending_dns_records',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Mailgun$SendingDnsRecord$decoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'domain',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$One$Record))))));
var $author$project$Api$Provider$Mailgun$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Mailgun$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Mailgun$mailgunPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['mailgun']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Mailgun$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Mailgun$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Mailgun$mailgunPath));
	});
var $author$project$Api$Provider$Practice$Shared$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Api$Provider$Practice$One$url = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$url(shared);
};
var $author$project$Pages$Admin$Mailgun$init = F4(
	function (_v0, practice, shared, _v1) {
		var domain = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.adO;
			},
			A2(
				$elm$core$Maybe$andThen,
				$elm$url$Url$fromString,
				$author$project$Api$Provider$Practice$One$url(practice)));
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				N_: domain,
				w: false,
				PB: $author$project$Utils$Form$init($author$project$Pages$Admin$Mailgun$formFieldsInit),
				qT: shared.qT,
				FR: $author$project$Shared$isHintAdmin(shared),
				mV: $author$project$Api$Data$Loading,
				oe: $author$project$Api$Data$NotAsked,
				pa: $author$project$Api$Data$NotAsked
			},
			A2($author$project$Api$Provider$Mailgun$retrieve, shared.D5, $author$project$Pages$Admin$Mailgun$GotMailgun));
	});
var $author$project$Pages$Admin$Mailgun$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Mailgun$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Mailgun$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Mailgun$Verified = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Mailgun$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{Oo: string});
		} else {
			var domain = field.a;
			var string = field.b;
			return _Utils_update(
				fields,
				{Oo: string + ('@' + domain), xl: string});
		}
	});
var $author$project$Pages$Admin$Mailgun$EmailValidation = 0;
var $author$project$Pages$Admin$Mailgun$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Oo;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email'))
		]));
var $author$project$Pages$Admin$Mailgun$GotSetup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Mailgun$setup = F3(
	function (apiClient, email_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email_))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Mailgun$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['setup']),
						$author$project$Api$Provider$Mailgun$mailgunPath))));
	});
var $author$project$Pages$Admin$Mailgun$setupMailgun = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$Mailgun$setup, apiClient, fields.Oo, $author$project$Pages$Admin$Mailgun$GotSetup);
	});
var $author$project$Api$Provider$Mailgun$verify = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Mailgun$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['verify']),
					$author$project$Api$Provider$Mailgun$mailgunPath)));
	});
var $author$project$Pages$Admin$Mailgun$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mV: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Mailgun$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Mailgun$formFieldsValidator, model.PB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm, oe: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$Mailgun$setupMailgun, model.D5, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								w: false,
								PB: $author$project$Utils$Form$init($author$project$Pages$Admin$Mailgun$formFieldsInit),
								mV: response,
								oe: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your mailgun credentials have been saved.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oe: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pa: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Mailgun$verify, model.D5, $author$project$Pages$Admin$Mailgun$Verified),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mV: response, pa: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your dns records are being verified.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pa: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{w: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Ui$Image$MailgunLogo = 3;
var $author$project$Pages$Admin$Mailgun$EditEmail = {$: 6};
var $author$project$Pages$Admin$Mailgun$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Mailgun$EmailLocalPart = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Mailgun$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Mailgun$Setup = {$: 2};
var $author$project$Pages$Admin$Mailgun$Verify = {$: 4};
var $author$project$Api$Provider$Mailgun$One$domain = function (_v0) {
	var record = _v0;
	return record.N_;
};
var $author$project$Api$Provider$Mailgun$One$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$Mailgun$One$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Api$Provider$Mailgun$One$sendingDnsRecords = function (_v0) {
	var record = _v0;
	return record.Zv;
};
var $author$project$Api$Provider$Mailgun$Meta$setupAaction = function (_v0) {
	var meta = _v0;
	return meta.tF.ZF;
};
var $author$project$Api$Provider$Mailgun$One$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Mailgun$Meta$verifyAction = function (_v0) {
	var meta = _v0;
	return meta.tF.aaP;
};
var $author$project$Ui$Icon$Missing = 20;
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$name = function (_v0) {
	var sendingDnsRecord = _v0;
	return sendingDnsRecord.zh;
};
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$recordType = function (_v0) {
	var sendingDnsRecord = _v0;
	return sendingDnsRecord.XX;
};
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$valid = function (_v0) {
	var sendingDnsRecord = _v0;
	return sendingDnsRecord.aaL;
};
var $author$project$Api$Provider$Mailgun$SendingDnsRecord$value = function (_v0) {
	var sendingDnsRecord = _v0;
	return sendingDnsRecord.aaN;
};
var $author$project$Pages$Admin$Mailgun$viewSendingDnsRecord = function (sendingDnsRecord) {
	return _List_fromArray(
		[
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Record Configured: '),
							($author$project$Api$Provider$Mailgun$SendingDnsRecord$valid(sendingDnsRecord) === 'valid') ? A2($author$project$Ui$Icon$view, _List_Nil, 18) : A2($author$project$Ui$Icon$view, _List_Nil, 20)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Record Type: '),
							A2(
							$author$project$Ui$Typography$pre,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Mailgun$SendingDnsRecord$recordType(sendingDnsRecord))
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hostname: '),
							A2(
							$author$project$Ui$Typography$pre,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Mailgun$SendingDnsRecord$name(sendingDnsRecord))
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Value: '),
							A2(
							$author$project$Ui$Typography$pre,
							_List_fromArray(
								[$author$project$Ui$Typography$preWrap]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Mailgun$SendingDnsRecord$value(sendingDnsRecord))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Mailgun$viewPanelBody = F2(
	function (model, mailgun) {
		var meta = $author$project$Api$Provider$Mailgun$One$meta(mailgun);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Provider$Mailgun$One$status(mailgun)),
								function () {
								var _v0 = model.N_;
								if (_v0.$ === 1) {
									return A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('You do not have a website setup on your practice, please add that '),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Admin__Practice,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('here')
													])),
												$elm$html$Html$text(' before configuring Mailgun.')
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							])),
						($author$project$Api$Provider$Mailgun$Meta$setupAaction(meta) && ((!model.w) && $author$project$Utils$Maybe$toBool(model.N_))) ? A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Integrate with mailgun'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$EditEmail)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Integrate with Mailgun')
									]))
							])) : $author$project$Utils$Html$empty
					])),
				function () {
				var _v1 = _Utils_Tuple2(
					$author$project$Api$Provider$Mailgun$One$status(mailgun) === 'active',
					$author$project$Api$Provider$Mailgun$Meta$verifyAction(meta));
				if (_v1.a) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('DNS Settings'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 18),
										$elm$html$Html$text(' Correctly configured')
									]))
							]));
				} else {
					if (_v1.b) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('DNS Settings'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Please set the following DNS records up on your website\'s DNS server.  For more information on how to do that '),
											A3(
											$author$project$Ui$Link$externalHref,
											'https://support.hint.com/integrations/mailgun-integration',
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('click here')
												])),
											$elm$html$Html$text(' . This may take 24-48 hours for the changes to take effect.')
										])),
								A2(
									$elm$core$List$cons,
									A3(
										$author$project$Ui$Button$view,
										{abp: 'Check dns records'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$Verify),
												$author$project$Ui$Button$loading(
												_Utils_eq(model.pa, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Check DNS records now')
											])),
									A2(
										$elm$core$List$concatMap,
										$author$project$Pages$Admin$Mailgun$viewSendingDnsRecord,
										$author$project$Api$Provider$Mailgun$One$sendingDnsRecords(mailgun)))));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}
			}(),
				function () {
				var _v2 = $author$project$Api$Provider$Mailgun$One$domain(mailgun);
				if (!_v2.$) {
					var domain = _v2.a;
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Domain'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(domain)
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				($author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$Mailgun$One$email(mailgun)) || model.w) ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Email'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						function () {
						var _v3 = _Utils_Tuple2(model.w, model.N_);
						if (_v3.a && (!_v3.b.$)) {
							var domain = _v3.b.a;
							var fields = $author$project$Utils$Form$fields(model.PB);
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('You must be able to receive email at this address for patients to be able to reply to emails. '),
												$elm$html$Html$text('If you want to use another email address and it is at a domain you own (not @gmail.com, @outlook.com, etc) contact us.')
											])),
										model.FR ? $author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.Oo),
												$author$project$Ui$Form$Input$autoComplete(false),
												$author$project$Ui$Form$Input$placeholder('billing@example.com'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Mailgun$FormUpdated, $author$project$Pages$Admin$Mailgun$Email)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB))
											])) : $author$project$Ui$Form$Input$group(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(fields.xl),
														$author$project$Ui$Form$Input$autoComplete(false),
														$author$project$Ui$Form$Input$placeholder('billing'),
														$author$project$Ui$Form$Input$onInput(
														A2(
															$elm$core$Basics$composeL,
															$author$project$Pages$Admin$Mailgun$FormUpdated,
															$author$project$Pages$Admin$Mailgun$EmailLocalPart(domain))),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB))
													])),
												$author$project$Ui$Form$Input$addon(
												_List_fromArray(
													[
														$elm$html$Html$text('@' + domain)
													]))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 0, model.PB)),
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Setup mailgun integration'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$Setup),
														$author$project$Ui$Button$loading(
														_Utils_eq(model.oe, $author$project$Api$Data$Loading))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Setup')
													]))
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						(!model.w) ? A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Mailgun$One$email(mailgun)))
							])) : $author$project$Utils$Html$empty
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('About'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Our Mailgun integration allows you to customize the domain and email address for notifications that are sent from our platform.')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Learn more '),
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/integrations/mailgun-integration',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('here')
											])),
										$elm$html$Html$text('.')
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$Admin$Mailgun$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Image$view,
										model.qT,
										{I1: 'Mailgun Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										3)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v0 = model.mV;
									if (_v0.$ === 3) {
										var mailgun = _v0.a;
										return A2($author$project$Pages$Admin$Mailgun$viewPanelBody, model, mailgun);
									} else {
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]))
											]);
									}
								}())
							]))
					]))
			]),
		$G: 'Integrations | Mailgun'
	};
};
var $author$project$Pages$Admin$Mailgun$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Mailgun$init, aer: $author$project$Pages$Admin$Mailgun$load, agD: $author$project$Pages$Admin$Mailgun$save, ahd: $author$project$Pages$Admin$Mailgun$subscriptions, aaq: $author$project$Pages$Admin$Mailgun$update, ahP: $author$project$Pages$Admin$Mailgun$view});
var $author$project$Pages$Admin$Notes$NotesMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Practice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Notes$FlaggedDropdownMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Notes$Model = $elm$core$Basics$identity;
var $author$project$Components$Notes$GotNotes = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Note$All$Note = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Shared$Note = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Shared$Record = F6(
	function (id, content, flagged, createdAt, createdBy, meta) {
		return {EG: content, Mf: createdAt, Mg: createdBy, Fj: flagged, adR: id, TU: meta};
	});
var $author$project$Api$Provider$Note$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Meta$MetaRecord = function (editable) {
	return {Oa: editable};
};
var $author$project$Api$Provider$Note$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Note$Meta$MetaRecord));
var $author$project$Api$Provider$Note$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Note$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Note$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Note$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_by',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'flagged',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'content',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Note$Shared$Record)))))));
var $author$project$Api$Provider$Note$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Note$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Note$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Note$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Note$listDefaults = {Fj: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Note$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Note$listDefaults);
	var _v0 = options.Fj;
	if (!_v0.$) {
		var bool = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$bool, 'flagged', bool)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$Note$practicePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practice', id_]),
		$author$project$Api$Data$providerPath);
};
var $author$project$Api$Provider$Note$notablePath = function (notable) {
	switch (notable.$) {
		case 0:
			var id_ = notable.a;
			return $author$project$Api$Provider$Note$practicePath(id_);
		case 1:
			var id_ = notable.a;
			return $author$project$Api$Provider$Company$companyPath(id_);
		default:
			var id_ = notable.a;
			return $author$project$Api$Provider$Patient$patientPath(id_);
	}
};
var $author$project$Api$Provider$Note$notesPath = function (notable) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['notes']),
		$author$project$Api$Provider$Note$notablePath(notable));
};
var $author$project$Api$Provider$Note$list = F4(
	function (apiClient, notable, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Note$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Note$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Note$notesPath(notable))));
	});
var $author$project$Components$Notes$fetchNotes = F2(
	function (apiClient, model) {
		return A4($author$project$Api$Provider$Note$list, apiClient, model.jg, $elm$core$Basics$identity, $author$project$Components$Notes$GotNotes);
	});
var $author$project$Components$Notes$All = 0;
var $author$project$Components$Notes$Flagged = 1;
var $author$project$Components$Notes$Unflagged = 2;
var $author$project$Components$Notes$flaggedOptionFromQuery = function (queryString) {
	_v0$2:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'flagged':
					return 1;
				case 'unflagged':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Components$Notes$init = F6(
	function (apiClient, timeFormatter, baseRoute, query, notable, isPracticeAdmin) {
		var model = {
			Ec: baseRoute,
			ie: $elm$core$Maybe$Nothing,
			dP: $elm$core$Set$empty,
			Fj: $author$project$Components$Notes$flaggedOptionFromQuery(
				A2($elm$core$Dict$get, 'flagged', query)),
			mi: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'flagged-dropdown-filter', ahx: $author$project$Components$Notes$FlaggedDropdownMsg})),
			d2: $elm$core$Set$empty,
			FS: isPracticeAdmin,
			jg: notable,
			S: $elm$core$Maybe$Nothing,
			jh: $author$project$Api$Data$Loading,
			Hy: timeFormatter
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Components$Notes$fetchNotes, apiClient, model));
	});
var $author$project$Pages$Admin$Notes$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A6(
			$author$project$Components$Notes$init,
			shared.D5,
			shared.Hy,
			$author$project$Spa$Generated$Route$Admin__Notes,
			query,
			$author$project$Api$Provider$Note$Practice(
				$author$project$Api$Provider$Practice$One$id(practice)),
			$author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
		var notes = _v1.a;
		var notesCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: notes},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
	});
var $author$project$Pages$Admin$Notes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Notes$CancelNoteEdit = {$: 11};
var $author$project$Components$Notes$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Notes$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.S;
				if (!_v1.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Notes$CancelNoteEdit);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Notes$HiConfirmClosed),
					model.ie)),
				$author$project$Ui$NewDropdown$subscriptions(model.mi)
			]));
};
var $author$project$Pages$Admin$Notes$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Notes$subscriptions(model.rh));
};
var $author$project$Components$Notes$NoteDeleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Notes$NoteFlagged = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$Note$notePath = F2(
	function (notable, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Note$notesPath(notable));
	});
var $author$project$Api$Provider$Note$delete = F4(
	function (apiClient, notable, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Note$notePath, notable, id_)));
	});
var $author$project$Api$Provider$Note$One$Note = 0;
var $author$project$Api$Provider$Note$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Note$flag = F5(
	function (apiClient, notable, id_, flagged_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'note',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'flagged',
								$elm$json$Json$Encode$bool(flagged_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Note$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Note$notePath, notable, id_))));
	});
var $author$project$Api$Provider$Note$Shared$content = function (_v0) {
	var record = _v0;
	return record.EG;
};
var $author$project$Api$Provider$Note$All$content = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$content(shared);
};
var $author$project$Components$Notes$formFieldsFromNote = function (note) {
	return $author$project$Api$Provider$Note$All$content(note);
};
var $author$project$Components$Notes$formFieldsInit = '';
var $author$project$Components$Notes$formFieldsUpdate = F2(
	function (field, _v0) {
		var string = field;
		return string;
	});
var $author$project$Components$Notes$ContentValidation = 0;
var $author$project$Components$Notes$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter some content.'))
		]));
var $author$project$Api$Provider$Note$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Note$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$id(shared);
};
var $author$project$Components$Notes$NoteCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Note$create = F4(
	function (apiClient, notable, content_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'note',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'content',
								$elm$json$Json$Encode$string(content_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Note$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Note$notesPath(notable))));
	});
var $author$project$Components$Notes$createNote = F3(
	function (apiClient, notable, formFields) {
		var content = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Note$create, apiClient, notable, content, $author$project$Components$Notes$NoteCreated);
	});
var $author$project$Components$Notes$NoteUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Note$update = F5(
	function (apiClient, notable, id_, content_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'note',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'content',
								$elm$json$Json$Encode$string(content_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Note$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Note$notePath, notable, id_))));
	});
var $author$project$Components$Notes$updateNote = F4(
	function (apiClient, notable, id, formFields) {
		var content = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5($author$project$Api$Provider$Note$update, apiClient, notable, id, content, $author$project$Components$Notes$NoteUpdated);
	});
var $author$project$Components$Notes$saveNote = F4(
	function (apiClient, notable, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A4($author$project$Components$Notes$updateNote, apiClient, notable, id, formFields);
		} else {
			return A3($author$project$Components$Notes$createNote, apiClient, notable, formFields);
		}
	});
var $author$project$Components$Notes$flaggedOptionToValue = function (option) {
	switch (option) {
		case 1:
			return 'flagged';
		case 2:
			return 'unflagged';
		default:
			return '';
	}
};
var $author$project$Components$Notes$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			function () {
			var _v0 = model.Fj;
			if (!_v0) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					A2(
						$elm$url$Url$Builder$string,
						'flagged',
						$author$project$Components$Notes$flaggedOptionToValue(model.Fj)));
			}
		}()
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(model.Ec)
				]),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Components$Notes$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jh: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							S: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Notes$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var field = msg.a;
				var _v2 = model.S;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var note = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Notes$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								S: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, note))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var id = msg.a;
				var bool = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d2: A2($elm$core$Set$insert, id, model.d2)
						}),
					A5(
						$author$project$Api$Provider$Note$flag,
						apiClient,
						model.jg,
						id,
						bool,
						$author$project$Components$Notes$NoteFlagged(id)),
					_List_Nil);
			case 4:
				var note = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							S: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Note$All$id(note)),
									$author$project$Utils$Form$init(
										$author$project$Components$Notes$formFieldsFromNote(note)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ie: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v4 = model.S;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var id = _v5.a;
					var form = _v5.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{S: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Notes$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully created')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									S: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									d2: A2($elm$core$Set$remove, id, model.d2),
									jh: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$Notes$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully updated')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									d2: A2($elm$core$Set$remove, id, model.d2)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v8 = model.S;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var id = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{S: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Notes$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									S: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dP: A2($elm$core$Set$remove, id, model.dP),
									jh: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$Notes$fetchNotes, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Note successfully deleted')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dP: A2($elm$core$Set$remove, id, model.dP)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ie: $elm$core$Maybe$Nothing,
							dP: A2($elm$core$Set$insert, id, model.dP)
						}),
					A4(
						$author$project$Api$Provider$Note$delete,
						apiClient,
						model.jg,
						id,
						$author$project$Components$Notes$NoteDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ie: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var form = msg.a;
				var id = msg.b;
				var _v12 = A2($author$project$Utils$Form$validate, $author$project$Components$Notes$formFieldsValidator, form);
				if (!_v12.$) {
					var _v13 = _v12.a;
					var newForm = _v13.a;
					var validFormFields = _v13.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								S: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Components$Notes$saveNote, apiClient, model.jg, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v12.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								S: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var subMsg = msg.a;
				var _v14 = A2($author$project$Ui$NewDropdown$update, subMsg, model.mi);
				var dropdown = _v14.a;
				var dropdownCmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mi: dropdown}),
					dropdownCmd,
					_List_Nil);
			default:
				var flagged = msg.a;
				var newModel = _Utils_update(
					model,
					{Fj: flagged, jh: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Notes$fetchNotes, apiClient, newModel),
								$author$project$Components$Notes$updateUrl(newModel)
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Notes$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Notes$update, model.D5, subMsg, model.rh);
		var notes = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: notes}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Notes$NewNote = {$: 1};
var $author$project$Api$Provider$Note$Shared$flagged = function (_v0) {
	var record = _v0;
	return record.Fj;
};
var $author$project$Api$Provider$Note$All$flagged = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$flagged(shared);
};
var $author$project$Components$Notes$filterNotes = F2(
	function (flagged, notes) {
		return A2(
			$elm$core$List$filter,
			function (note) {
				switch (flagged) {
					case 0:
						return true;
					case 1:
						return $author$project$Api$Provider$Note$All$flagged(note);
					default:
						return !$author$project$Api$Provider$Note$All$flagged(note);
				}
			},
			notes);
	});
var $author$project$Components$Notes$FlaggedFiltered = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Notes$flaggedOptionToLabel = function (option) {
	switch (option) {
		case 1:
			return 'Flagged';
		case 2:
			return 'Unflagged';
		default:
			return 'All Notes';
	}
};
var $author$project$Components$Notes$flaggedDropdownOptions = function (currentFlaggedOption) {
	var flaggedOptionToItem = function (option) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentFlaggedOption, option)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Notes$FlaggedFiltered(option))
				]),
			$elm$html$Html$text(
				$author$project$Components$Notes$flaggedOptionToLabel(option)));
	};
	return A2(
		$elm$core$List$cons,
		flaggedOptionToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				flaggedOptionToItem,
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Components$Notes$viewFlaggedDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Notes$flaggedOptionToLabel(model.Fj))
			]),
		$author$project$Components$Notes$flaggedDropdownOptions(model.Fj),
		model.mi);
};
var $author$project$Components$Notes$DeleteNote = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Notes$EditNote = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Notes$FlagNote = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$Note$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Note$All$createdAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Note$Shared$createdBy = function (_v0) {
	var record = _v0;
	return record.Mg;
};
var $author$project$Api$Provider$Note$All$createdBy = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$createdBy(shared);
};
var $author$project$Api$Provider$Note$Meta$editable = function (_v0) {
	var meta = _v0;
	return meta.Oa;
};
var $author$project$Ui$SvgIcon$Flag = 42;
var $author$project$Ui$SvgIcon$flag = $author$project$Ui$SvgIcon$viewIcon(42);
var $author$project$Api$Provider$Note$Shared$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Api$Provider$Note$All$meta = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Note$Shared$meta(shared);
};
var $author$project$Ui$OverflowWrap$WrapWord = 3;
var $author$project$Ui$OverflowWrap$wrapWord = 3;
var $author$project$Components$Notes$viewNote = F5(
	function (timeFormatter, flaggingNotes, deletingNotes, note, isPracticeAdmin) {
		var id = $author$project$Api$Provider$Note$All$id(note);
		var loading = A2($elm$core$Set$member, id, flaggingNotes) || A2($elm$core$Set$member, id, deletingNotes);
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[$author$project$Ui$ListGroup$clearfix, $author$project$Ui$ListGroup$note]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true),
											$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$wrapWord),
											$author$project$Ui$Typography$preWrap
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Note$All$content(note))
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$User$Shared$name,
													$author$project$Api$Provider$Note$All$createdBy(note)))),
											$elm$html$Html$text(' commented on '),
											$elm$html$Html$text(
											A2(
												timeFormatter,
												5,
												$author$project$Api$Provider$Note$All$createdAt(note)))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											function () {
											var noteFlagged = $author$project$Api$Provider$Note$All$flagged(note);
											var verb = noteFlagged ? 'Unflag' : 'Flag';
											return A3(
												$author$project$Ui$Button$view,
												{abp: verb + ' note'},
												_List_fromArray(
													[
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$loading(loading),
														$author$project$Ui$Button$onClick(
														A2($author$project$Components$Notes$FlagNote, id, !noteFlagged)),
														$author$project$Ui$Button$styled(
														noteFlagged ? 1 : 0),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$flag)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(verb)
													]));
										}(),
											$author$project$Api$Provider$Note$Meta$editable(
											$author$project$Api$Provider$Note$All$meta(note)) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Edit note'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Notes$EditNote(note)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])) : $author$project$Utils$Html$empty,
											($author$project$Api$Provider$Note$Meta$editable(
											$author$project$Api$Provider$Note$All$meta(note)) || isPracticeAdmin) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Delete note'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$danger,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Notes$DeleteNote(id))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												])) : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Notes$Content = $elm$core$Basics$identity;
var $author$project$Components$Notes$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Notes$SaveNote = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Notes$viewNoteModal = F3(
	function (maybeId, note, form) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Note',
			S_: _Utils_eq(note, $author$project$Api$Data$Loading),
			Tv: maybeId,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Notes$CancelNoteEdit,
			U0: $author$project$Components$Notes$SaveNote(form)
		};
		var content = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Content')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(content),
									$author$project$Ui$Form$Textarea$phi(true),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Notes$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Components$Notes$viewNoteSkeleton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(3)
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(6)
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(7)
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$span(6)
						]))
				]))
		]));
var $author$project$Components$Notes$noun = function (notable) {
	switch (notable.$) {
		case 0:
			return 'practice';
		case 1:
			return 'company';
		default:
			return 'patient';
	}
};
var $author$project$Components$Notes$zeroStateText = F2(
	function (notable, flagged) {
		return 'This ' + ($author$project$Components$Notes$noun(notable) + (' has no ' + ($author$project$Components$Notes$flaggedOptionToValue(flagged) + ' notes')));
	});
var $author$project$Components$Notes$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.S;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var id = _v2.a;
				var form = _v2.b;
				var note = _v2.c;
				return A3($author$project$Components$Notes$viewNoteModal, id, note, form);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.ie;
			if (!_v3.$) {
				var id = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Notes$HiConfirmClosed(id),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('note')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Notes')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add new note'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$onClick($author$project$Components$Notes$NewNote),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New Note')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(4)
										]),
									_List_fromArray(
										[
											$author$project$Components$Notes$viewFlaggedDropdown(model)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v4 = model.jh;
							if (_v4.$ === 3) {
								var notes = _v4.a;
								var filteredNotes = A2($author$project$Components$Notes$filterNotes, model.Fj, notes);
								return $elm$core$List$isEmpty(filteredNotes) ? A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Components$Notes$zeroStateText, model.jg, model.Fj))
										])) : A2(
									$author$project$Ui$ListGroup$view,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (note) {
											return A5($author$project$Components$Notes$viewNote, model.Hy, model.d2, model.dP, note, model.FS);
										},
										filteredNotes));
							} else {
								return A2(
									$author$project$Ui$ListGroup$view,
									_List_Nil,
									A2($elm$core$List$repeat, 5, $author$project$Components$Notes$viewNoteSkeleton));
							}
						}()
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Notes$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Notes$view(model.rh)),
		$G: 'Admin | Notes'
	};
};
var $author$project$Pages$Admin$Notes$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Notes$init, aer: $author$project$Pages$Admin$Notes$load, agD: $author$project$Pages$Admin$Notes$save, ahd: $author$project$Pages$Admin$Notes$subscriptions, aaq: $author$project$Pages$Admin$Notes$update, ahP: $author$project$Pages$Admin$Notes$view});
var $author$project$Pages$Admin$Notifications$Company$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Company = 3;
var $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$GotPracticeNotificationSettings = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$NotificationSetting$Membership = 1;
var $author$project$Api$Provider$NotificationSetting$All$NotificationSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$NotificationSetting$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$NotificationSetting$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$NotificationSetting$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath(companyId)));
	});
var $author$project$Api$Provider$NotificationSetting$categoryToString = function (category) {
	switch (category) {
		case 0:
			return 'patient';
		case 1:
			return 'membership';
		case 2:
			return 'practice';
		case 3:
			return 'company';
		default:
			return 'employee';
	}
};
var $author$project$Api$Provider$NotificationSetting$categoryToParams = function (category) {
	if (category === 2) {
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'category_name', 'practice')
			]);
	} else {
		return _List_fromArray(
			[
				A2(
				$author$project$Api$Param$string,
				'category_name',
				$author$project$Api$Provider$NotificationSetting$categoryToString(category)),
				A2($author$project$Api$Param$string, 'sender_type', 'practice')
			]);
	}
};
var $author$project$Api$Provider$NotificationSetting$listDefaults = {Ex: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$NotificationSetting$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$NotificationSetting$listDefaults);
	var _v0 = options.Ex;
	if (!_v0.$) {
		var category = _v0.a;
		return $author$project$Api$Provider$NotificationSetting$categoryToParams(category);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$NotificationSetting$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$NotificationSetting$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$NotificationSetting$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$NotificationSetting$notificationSettingsPath)));
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$fetchAllNotificationSettings = F2(
	function (apiClient, model) {
		var _v0 = model.aB;
		if (_v0.$ === 1) {
			var companyId = _v0.a;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Api$Provider$NotificationSetting$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									Ex: $elm$core$Maybe$Just(1)
								});
						},
						$author$project$Components$Admin$NotificationSetting$AdminTable$GotPracticeNotificationSettings),
						A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings)
					]));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings = F2(
	function (apiClient, model) {
		var _v0 = model.aB;
		if (_v0.$ === 1) {
			var id = _v0.a;
			return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, id, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
		} else {
			return A3(
				$author$project$Api$Provider$NotificationSetting$list,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							Ex: $elm$core$Maybe$Just(model.Ex)
						});
				},
				$author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
		}
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$Closed = {$: 0};
var $author$project$Components$Admin$NotificationSetting$MassEmail$init = $author$project$Components$Admin$NotificationSetting$MassEmail$Closed;
var $author$project$Components$Admin$NotificationSetting$AdminTable$init = F4(
	function (apiClient, session, context, category) {
		var model = {Ex: category, aB: context, S_: true, m$: $author$project$Components$Admin$NotificationSetting$MassEmail$init, rr: false, UN: $elm$core$Maybe$Nothing, a9: _List_Nil, r8: $author$project$Api$Data$Loading, afU: $elm$core$Maybe$Nothing, ZD: session, Cg: false};
		return _Utils_Tuple2(
			model,
			function () {
				if (!context.$) {
					return A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings, apiClient, model);
				} else {
					return A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchAllNotificationSettings, apiClient, model);
				}
			}());
	});
var $author$project$Pages$Admin$Notifications$Company$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var _v3 = A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 3);
		var adminTable = _v3.a;
		var adminTableCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, rh: adminTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Company$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Company$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$Close = {$: 1};
var $author$project$Components$Admin$NotificationSetting$MassEmail$subscriptions = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$MassEmail$Close);
		default:
			return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$MassEmail$Close);
	}
};
var $author$project$Components$Admin$NotificationSetting$Preview$CloseModal = {$: 0};
var $author$project$Components$Admin$NotificationSetting$Preview$subscriptions = function (model) {
	return model.U9 ? $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.U9;
					},
					model.fy);
				if ((!_v0.$) && _v0.a) {
					return $elm$core$Platform$Sub$none;
				} else {
					return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$Preview$CloseModal);
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2($elm$core$Maybe$map, $author$project$Ui$NewDropdown$subscriptions, model.fy))
			])) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.afU;
				if (!_v0.$) {
					var preview = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg,
						$author$project$Components$Admin$NotificationSetting$Preview$subscriptions(preview));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg,
				$author$project$Components$Admin$NotificationSetting$MassEmail$subscriptions(model.m$)),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (_v2) {
						var setting = _v2.a;
						var customize = _v2.b;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(setting),
							$author$project$Components$Admin$NotificationSetting$Customize$subscriptions(customize));
					},
					A2(
						$elm$core$List$map,
						function (_v1) {
							var setting = _v1.a;
							var customize = _v1.c;
							return A2($elm$core$Tuple$pair, setting, customize);
						},
						model.a9)))
			]));
};
var $author$project$Pages$Admin$Notifications$Company$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rh));
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideRemoved = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$NotificationSetting$All$disableable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$disableable(shared);
};
var $author$project$Api$Provider$NotificationSetting$All$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$enabled(shared);
};
var $author$project$Api$Provider$NotificationSetting$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$id(shared);
};
var $author$project$Components$Admin$NotificationSetting$Toggle$allGetters = {NH: $author$project$Api$Provider$NotificationSetting$All$disableable, Ot: $author$project$Api$Provider$NotificationSetting$All$enabled, adR: $author$project$Api$Provider$NotificationSetting$All$id};
var $author$project$Api$Provider$NotificationSetting$Shared$customEnabled = function (_v0) {
	var record = _v0;
	return record.MB;
};
var $author$project$Api$Provider$NotificationSetting$All$customEnabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$customEnabled(shared);
};
var $author$project$Components$Admin$NotificationSetting$Preview$LanguageDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$NotificationSetting$All$isTranslatable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable(shared);
};
var $author$project$Components$Admin$NotificationSetting$Preview$GotPreview = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting = F3(
	function (client, language, model) {
		var _v0 = model.aB;
		if (_v0.$ === 1) {
			var companyId = _v0.a;
			return A5(
				$author$project$Api$Provider$Company$NotificationSetting$preview,
				client,
				companyId,
				$author$project$Api$Provider$NotificationSetting$All$id(model.UN),
				{e5: $elm$core$Maybe$Nothing, yu: language, Hp: $elm$core$Maybe$Nothing},
				$author$project$Components$Admin$NotificationSetting$Preview$GotPreview(language));
		} else {
			return A4(
				$author$project$Api$Provider$NotificationSetting$preview,
				client,
				$author$project$Api$Provider$NotificationSetting$All$id(model.UN),
				{e5: $elm$core$Maybe$Nothing, yu: language, Hp: $elm$core$Maybe$Nothing},
				$author$project$Components$Admin$NotificationSetting$Preview$GotPreview(language));
		}
	});
var $author$project$Components$Admin$NotificationSetting$Preview$init = F4(
	function (client, multiLanguage, notificationSetting, context) {
		var language = $author$project$Language$english;
		var model = {
			aB: context,
			fy: (multiLanguage && $author$project$Api$Provider$NotificationSetting$All$isTranslatable(notificationSetting)) ? $elm$core$Maybe$Just(
				$author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'preview-language-dropdown', ahx: $author$project$Components$Admin$NotificationSetting$Preview$LanguageDropdownMsg}))) : $elm$core$Maybe$Nothing,
			yu: language,
			UN: notificationSetting,
			U9: true,
			afU: A2(
				$elm$core$Dict$singleton,
				$author$project$Language$toValue(language),
				$author$project$Api$Data$Loading)
		};
		return _Utils_Tuple2(
			model,
			A3($author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting, client, language, model));
	});
var $author$project$Api$Provider$NotificationSetting$All$toShared = function (_v0) {
	var shared = _v0;
	return shared;
};
var $author$project$Components$Admin$NotificationSetting$Customize$initFromAll = F2(
	function (notificationSettingAll, context) {
		return A2(
			$author$project$Components$Admin$NotificationSetting$Customize$init,
			$author$project$Api$Provider$NotificationSetting$All$toShared(notificationSettingAll),
			context);
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipEndedId = 'patient_membership_ended';
var $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipMemberRemovedId = 'patient_membership_member_removed';
var $author$project$Components$Admin$NotificationSetting$AdminTable$overridableCompanyToggleIds = _List_fromArray(
	[$author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipEndedId, $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipMemberRemovedId]);
var $author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle = function (id) {
	return A2($elm$core$List$member, id, $author$project$Components$Admin$NotificationSetting$AdminTable$overridableCompanyToggleIds);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$Previewing = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$GotPatientsWithoutEmail = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Patient$WithoutEmail = {$: 6};
var $author$project$Api$Pagination$empty = A2($author$project$Api$Pagination$withItemsPerPage, 0, $author$project$Api$Pagination$init);
var $author$project$Components$Admin$NotificationSetting$MassEmail$fetchPatientsWithoutEmail = function (apiClient) {
	return A3(
		$author$project$Api$Provider$Patient$list,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					Fi: _List_fromArray(
						[$author$project$Api$Provider$Patient$WithoutEmail]),
					afy: $author$project$Api$Pagination$empty
				});
		},
		$author$project$Components$Admin$NotificationSetting$MassEmail$GotPatientsWithoutEmail);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment = function (selected) {
	return {agL: $elm$core$Maybe$Nothing, ag: selected};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields = {
	hh: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
	hi: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
	iQ: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
	iR: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false)
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						hh: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
					});
			case 1:
				var string = field.a;
				var _v1 = fields;
				var activeRetail = _v1.hh;
				return _Utils_update(
					fields,
					{
						hh: _Utils_update(
							activeRetail,
							{
								agL: $elm$core$Maybe$Just(string)
							})
					});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						hi: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
					});
			case 3:
				var string = field.a;
				var _v2 = fields;
				var activeSponsored = _v2.hi;
				return _Utils_update(
					fields,
					{
						hi: _Utils_update(
							activeSponsored,
							{
								agL: $elm$core$Maybe$Just(string)
							})
					});
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						iQ: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
					});
			case 5:
				var string = field.a;
				var _v3 = fields;
				var inactiveRetail = _v3.iQ;
				return _Utils_update(
					fields,
					{
						iQ: _Utils_update(
							inactiveRetail,
							{
								agL: $elm$core$Maybe$Just(string)
							})
					});
			case 6:
				var bool = field.a;
				return _Utils_update(
					fields,
					{
						iR: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
					});
			default:
				var string = field.a;
				var _v4 = fields;
				var inactiveSponsored = _v4.iR;
				return _Utils_update(
					fields,
					{
						iR: _Utils_update(
							inactiveSponsored,
							{
								agL: $elm$core$Maybe$Just(string)
							})
					});
		}
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$SegmentsValidation = 0;
var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailValidation = 1;
var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredValidation = 2;
var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailValidation = 3;
var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredValidation = 4;
var $author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments = function (fields) {
	return A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var segment = _v0.a;
			var validationGroup = _v0.b;
			return segment.ag ? $elm$core$Maybe$Just(
				_Utils_Tuple2(segment, validationGroup)) : $elm$core$Maybe$Nothing;
		},
		_List_fromArray(
			[
				_Utils_Tuple2(fields.hh, 1),
				_Utils_Tuple2(fields.hi, 2),
				_Utils_Tuple2(fields.iQ, 3),
				_Utils_Tuple2(fields.iR, 4)
			]));
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$validatePatientsOneOffEmailSegments = function (fields) {
	var selectedSegments_ = $author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments(fields);
	return $elm$core$List$isEmpty(selectedSegments_) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please check at least one.')
		]) : A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var segment = _v0.a;
			var validationGroup = _v0.b;
			return (segment.ag && _Utils_eq(segment.agL, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
				_Utils_Tuple2(validationGroup, 'Please pick one.')) : $elm$core$Maybe$Nothing;
		},
		selectedSegments_);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsValidator = function (type_) {
	return $rtfeldman$elm_validate$Validate$all(
		(type_ === 'patients_one_off_email') ? _List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$NotificationSetting$MassEmail$validatePatientsOneOffEmailSegments)
			]) : _List_Nil);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Company$Notification$notificationsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['notifications']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$Notification$bulk = F5(
	function (apiClient, type_, segments, companyId, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(type_)),
								_Utils_Tuple2(
								'segments',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, segments))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk']),
						$author$project$Api$Provider$Company$Notification$notificationsPath(companyId)))));
	});
var $author$project$Api$Provider$Notification$notificationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['notifications']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Notification$bulk = F4(
	function (apiClient, type_, segments, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(type_)),
								_Utils_Tuple2(
								'segments',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, segments))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk']),
						$author$project$Api$Provider$Notification$notificationsPath))));
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$sendBulkNotification = F3(
	function (client, shared, segments) {
		var _v0 = shared.aB;
		if (_v0.$ === 1) {
			var id = _v0.a;
			return A5(
				$author$project$Api$Provider$Company$Notification$bulk,
				client,
				$author$project$Api$Provider$NotificationSetting$All$id(shared.UN),
				segments,
				id,
				$author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification);
		} else {
			return A4(
				$author$project$Api$Provider$Notification$bulk,
				client,
				$author$project$Api$Provider$NotificationSetting$All$id(shared.UN),
				segments,
				$author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification);
		}
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$update = F4(
	function (apiClient, msg, model, context) {
		switch (msg.$) {
			case 0:
				var session = msg.a;
				var notificationSetting = msg.b;
				var shared = {aB: context, UN: notificationSetting, nm: $author$project$Api$Data$Loading, ZD: session};
				var formFields = $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields;
				return _Utils_Tuple3(
					A2(
						$author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments,
						shared,
						$author$project$Utils$Form$init(formFields)),
					$author$project$Components$Admin$NotificationSetting$MassEmail$fetchPatientsWithoutEmail(apiClient),
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v1 = _Utils_Tuple2(model, response);
				if (_v1.a.$ === 1) {
					var _v2 = _v1.a;
					var shared = _v2.a;
					var notificationForm = _v2.b;
					return _Utils_Tuple3(
						A2(
							$author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments,
							_Utils_update(
								shared,
								{nm: response}),
							notificationForm),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				return _Utils_Tuple3($author$project$Components$Admin$NotificationSetting$MassEmail$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
			case 2:
				if (model.$ === 1) {
					var shared = model.a;
					var notificationForm = model.b;
					var _v4 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsValidator(
							$author$project$Api$Provider$NotificationSetting$All$id(shared.UN)),
						notificationForm);
					if (!_v4.$) {
						var _v5 = _v4.a;
						var validFormFields = _v5.b;
						var segments = A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.agL;
							},
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$first,
								$author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments(
									$rtfeldman$elm_validate$Validate$fromValid(validFormFields))));
						return _Utils_Tuple3(
							A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, $author$project$Api$Data$NotAsked),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var newForm = _v4.a;
						return _Utils_Tuple3(
							A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, shared, newForm),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var field = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var notificationForm = model.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsUpdate, field, notificationForm);
					return _Utils_Tuple3(
						A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, shared, newForm),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				if (model.$ === 2) {
					var shared = model.a;
					var formFields = $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields;
					return _Utils_Tuple3(
						A2(
							$author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments,
							shared,
							$author$project$Utils$Form$init(formFields)),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				if (model.$ === 2) {
					var shared = model.a;
					var segments = model.b;
					return _Utils_Tuple3(
						A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, $author$project$Api$Data$Loading),
						A3($author$project$Components$Admin$NotificationSetting$MassEmail$sendBulkNotification, apiClient, shared, segments),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (model.$ === 2) {
					var shared = model.a;
					var segments = model.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							$author$project$Components$Admin$NotificationSetting$MassEmail$Closed,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Notifications are being sent.')
								]));
					} else {
						return _Utils_Tuple3(
							A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, response),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Admin$NotificationSetting$Preview$update = F3(
	function (client, msg, model) {
		switch (msg.$) {
			case 3:
				var dropdownMsg = msg.a;
				var _v1 = model.fy;
				if (!_v1.$) {
					var dropdown = _v1.a;
					var _v2 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, dropdown);
					var newDropdown = _v2.a;
					var dropdownCmd = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fy: $elm$core$Maybe$Just(newDropdown)
							}),
						dropdownCmd);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: false}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var language = msg.a;
				var _v3 = function () {
					var _v4 = A2(
						$elm$core$Dict$get,
						$author$project$Language$toValue(language),
						model.afU);
					if (_v4.$ === 1) {
						return _Utils_Tuple2(
							A3(
								$elm$core$Dict$insert,
								$author$project$Language$toValue(language),
								$author$project$Api$Data$Loading,
								model.afU),
							A3($author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting, client, language, model));
					} else {
						return _Utils_Tuple2(model.afU, $elm$core$Platform$Cmd$none);
					}
				}();
				var preview = _v3.a;
				var previewCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{yu: language, afU: preview}),
					previewCmd);
			default:
				var language = msg.a;
				var preview = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							afU: A3(
								$elm$core$Dict$insert,
								$author$project$Language$toValue(language),
								preview,
								model.afU)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Admin$NotificationSetting$Customize$withAdminUser = F2(
	function (isAdmin, model) {
		return _Utils_update(
			model,
			{DF: isAdmin});
	});
var $author$project$Components$Admin$NotificationSetting$Customize$withMultiLanguage = F2(
	function (multiLanguage, model) {
		return _Utils_update(
			model,
			{rr: multiLanguage});
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var notificationSettings = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								S_: false,
								a9: A2(
									$elm$core$List$map,
									function (notificationSetting) {
										return _Utils_Tuple3(
											notificationSetting,
											A2($author$project$Components$Admin$NotificationSetting$Toggle$init, $author$project$Components$Admin$NotificationSetting$Toggle$allGetters, notificationSetting),
											A2(
												$author$project$Components$Admin$NotificationSetting$Customize$withMultiLanguage,
												model.rr,
												A2(
													$author$project$Components$Admin$NotificationSetting$Customize$withAdminUser,
													$author$project$Api$Platform$User$Shared$isAdmin(
														$author$project$Api$Platform$Session$One$user(model.ZD)),
													A2($author$project$Components$Admin$NotificationSetting$Customize$initFromAll, notificationSetting, model.aB))));
									},
									notificationSettings)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false, a9: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{r8: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var notificationSetting = msg.a;
				var _v3 = A4($author$project$Components$Admin$NotificationSetting$Preview$init, apiClient, model.rr, notificationSetting, model.aB);
				var preview = _v3.a;
				var previewCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							afU: $elm$core$Maybe$Just(preview)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg, previewCmd),
					_List_Nil);
			case 3:
				var currentSetting = msg.a;
				var subMsg = msg.b;
				var id = $author$project$Api$Provider$NotificationSetting$All$id(currentSetting);
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil),
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var customizeNotification = _v5.c;
							var result = A3($author$project$Components$Admin$NotificationSetting$Customize$update, apiClient, subMsg, customizeNotification);
							var _v6 = function () {
								var _v7 = result.ac5;
								if (_v7 === 1) {
									return _Utils_Tuple2(
										true,
										A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings, apiClient, model));
								} else {
									return _Utils_Tuple2(false, $elm$core$Platform$Cmd$none);
								}
							}();
							var loading = _v6.a;
							var cmd = _v6.b;
							return function (settings) {
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{S_: loading, a9: settings}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												$elm$core$Platform$Cmd$map,
												$author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(currentSetting),
												result.EC),
												cmd
											])),
									result.as);
							}(
								A3(
									$elm_community$list_extra$List$Extra$updateIf,
									function (_v8) {
										var notificationSetting_ = _v8.a;
										return _Utils_eq(
											$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting_),
											id);
									},
									function (_v9) {
										var notificationSetting_ = _v9.a;
										var toggleNotification = _v9.b;
										return _Utils_Tuple3(notificationSetting_, toggleNotification, result.y8);
									},
									model.a9));
						},
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (_v4) {
								var notificationSetting = _v4.a;
								return _Utils_eq(
									$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting),
									id);
							},
							model.a9)));
			case 4:
				var id = msg.a;
				var toggleNotification = msg.b;
				var subMsg = msg.c;
				var refetchCmd = function () {
					if ($author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle(id)) {
						var _v13 = model.aB;
						if (_v13.$ === 1) {
							var companyId = _v13.a;
							return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v10 = A4($author$project$Components$Admin$NotificationSetting$Toggle$update, apiClient, model.aB, subMsg, toggleNotification);
				var toggleNotification_ = _v10.a;
				var subCmd = _v10.b;
				var subOutMsg = _v10.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a9: A3(
								$elm_community$list_extra$List$Extra$updateIf,
								function (_v11) {
									var notificationSetting_ = _v11.a;
									return _Utils_eq(
										$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting_),
										id);
								},
								function (_v12) {
									var notificationSetting_ = _v12.a;
									var translateInput = _v12.c;
									return _Utils_Tuple3(notificationSetting_, toggleNotification_, translateInput);
								},
								model.a9)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification_),
								subCmd),
								refetchCmd
							])),
					subOutMsg);
			case 5:
				var id = msg.a;
				var companySetting = A2(
					$elm$core$Maybe$map,
					function (_v18) {
						var ns = _v18.a;
						return ns;
					},
					A2(
						$elm_community$list_extra$List$Extra$find,
						function (_v17) {
							var ns = _v17.a;
							return _Utils_eq(
								$author$project$Api$Provider$NotificationSetting$All$id(ns),
								id);
						},
						model.a9));
				var hasOverride = function () {
					if (!companySetting.$) {
						var company = companySetting.a;
						return !_Utils_eq(
							$author$project$Api$Provider$NotificationSetting$All$customEnabled(company),
							$elm$core$Maybe$Nothing);
					} else {
						return false;
					}
				}();
				var cmd = function () {
					if (hasOverride) {
						var _v14 = model.aB;
						if (_v14.$ === 1) {
							var companyId = _v14.a;
							return A5(
								$author$project$Api$Provider$Company$NotificationSetting$reset,
								apiClient,
								companyId,
								id,
								{yu: $author$project$Language$english},
								$author$project$Components$Admin$NotificationSetting$AdminTable$OverrideRemoved);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					} else {
						var _v15 = _Utils_Tuple2(model.aB, companySetting);
						if ((_v15.a.$ === 1) && (!_v15.b.$)) {
							var companyId = _v15.a.a;
							var company = _v15.b.a;
							var currentValue = $author$project$Api$Provider$NotificationSetting$All$enabled(company);
							return A5($author$project$Api$Provider$Company$NotificationSetting$toggle, apiClient, companyId, id, currentValue, $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideCreated);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}
				}();
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 8:
				var subMsg = msg.a;
				var _v19 = A4($author$project$Components$Admin$NotificationSetting$MassEmail$update, apiClient, subMsg, model.m$, model.aB);
				var massEmail = _v19.a;
				var massEmailCmd = _v19.b;
				var massEmailOutMsgs = _v19.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S_: false, m$: massEmail}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg, massEmailCmd),
					massEmailOutMsgs);
			case 9:
				var previewMsg = msg.a;
				var _v20 = model.afU;
				if (!_v20.$) {
					var preview = _v20.a;
					return A2(
						$author$project$Utils$Tuple3$fromTuple2,
						_List_Nil,
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg),
							A2(
								$elm$core$Tuple$mapFirst,
								function (prev) {
									return _Utils_update(
										model,
										{
											afU: $elm$core$Maybe$Just(prev)
										});
								},
								A3($author$project$Components$Admin$NotificationSetting$Preview$update, apiClient, previewMsg, preview))));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var refetchCmd = function () {
						var _v22 = model.aB;
						if (_v22.$ === 1) {
							var companyId = _v22.a;
							return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						model,
						refetchCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Override created. You can now customize this setting.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var refetchCmd = function () {
						var _v24 = model.aB;
						if (_v24.$ === 1) {
							var companyId = _v24.a;
							return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						model,
						refetchCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Override removed. Now using practice default.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Notifications$Company$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.D5, subMsg, model.rh);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Api$Provider$NotificationSetting$Shared$bodyExample = function (_v0) {
	var record = _v0;
	return record.J3;
};
var $author$project$Api$Provider$NotificationSetting$All$bodyExample = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$bodyExample(shared);
};
var $author$project$Api$Provider$NotificationSetting$Shared$subjectExample = function (_v0) {
	var record = _v0;
	return record._0;
};
var $author$project$Api$Provider$NotificationSetting$All$subjectExample = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$subjectExample(shared);
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveRetail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Checkbox$Errors = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Checkbox$errors = $author$project$Ui$Form$Checkbox$Errors;
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveRetailPatients = F2(
	function (form, activeRetail) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(activeRetail.ag),
										$author$project$Ui$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveRetail)),
										$author$project$Ui$Form$Checkbox$errors(
										A2($author$project$Utils$Form$validationErrors, 1, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Retail patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(11),
								$author$project$Ui$FlexGrid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											activeRetail.agL,
											$elm$core$Maybe$Just('all_active_retail'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment('all_active_retail')))),
										$author$project$Ui$Form$Radio$disabled(!activeRetail.ag)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('All retail patients.'),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Primary and dependent patients associated with an active/pending retail membership.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(11),
								$author$project$Ui$FlexGrid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											activeRetail.agL,
											$elm$core$Maybe$Just('active_retail_membership_owners'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment('active_retail_membership_owners')))),
										$author$project$Ui$Form$Radio$disabled(!activeRetail.ag)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership owners only.'),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Only the patients who pay for an active/pending retail membership (includes membership owners who are only payers).')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveSponsored = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveSponsoredPatients = F2(
	function (form, activeSponsored) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(activeSponsored.ag),
										$author$project$Ui$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveSponsored)),
										$author$project$Ui$Form$Checkbox$errors(
										A2($author$project$Utils$Form$validationErrors, 2, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sponsored patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(11),
								$author$project$Ui$FlexGrid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											activeSponsored.agL,
											$elm$core$Maybe$Just('all_active_sponsored'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment('all_active_sponsored')))),
										$author$project$Ui$Form$Radio$disabled(!activeSponsored.ag)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('All sponsored patients.'),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Primary and dependent patients associated with an active/pending employer- or network-sponsored membership.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(11),
								$author$project$Ui$FlexGrid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											activeSponsored.agL,
											$elm$core$Maybe$Just('active_sponsored_membership_owners'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment('active_sponsored_membership_owners')))),
										$author$project$Ui$Form$Radio$disabled(!activeSponsored.ag)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership owners only.'),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Only primary active employee or primary member of the network-sponsored membership.')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveRetail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveRetailPatients = F2(
	function (form, inactiveRetail) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(inactiveRetail.ag),
										$author$project$Ui$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveRetail)),
										$author$project$Ui$Form$Checkbox$errors(
										A2($author$project$Utils$Form$validationErrors, 3, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Retail patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(11),
								$author$project$Ui$FlexGrid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											inactiveRetail.agL,
											$elm$core$Maybe$Just('all_inactive_retail'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment('all_inactive_retail')))),
										$author$project$Ui$Form$Radio$disabled(!inactiveRetail.ag)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('All retail patients.'),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Primary and dependent inactive patients on an inactive retail membership.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(11),
								$author$project$Ui$FlexGrid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											inactiveRetail.agL,
											$elm$core$Maybe$Just('inactive_retail_membership_owners'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment('inactive_retail_membership_owners')))),
										$author$project$Ui$Form$Radio$disabled(!inactiveRetail.ag)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership owners only.'),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Only inactive patients who have previously owned a membership or are a payer on an active membership.')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveSponsored = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveSponsoredPatients = F2(
	function (form, inactiveSponsored) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(inactiveSponsored.ag),
										$author$project$Ui$Form$Checkbox$onCheck(
										A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveSponsored)),
										$author$project$Ui$Form$Checkbox$errors(
										A2($author$project$Utils$Form$validationErrors, 4, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sponsored patients')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(11),
								$author$project$Ui$FlexGrid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											inactiveSponsored.agL,
											$elm$core$Maybe$Just('all_inactive_sponsored'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment('all_inactive_sponsored')))),
										$author$project$Ui$Form$Radio$disabled(!inactiveSponsored.ag)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('All sponsored patients.'),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Primary and dependent inactive patients associated with a network or employer sponsor.')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(11),
								$author$project$Ui$FlexGrid$offset(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(
										_Utils_eq(
											inactiveSponsored.agL,
											$elm$core$Maybe$Just('inactive_sponsored_membership_owners'))),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment('inactive_sponsored_membership_owners')))),
										$author$project$Ui$Form$Radio$disabled(!inactiveSponsored.ag)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership owners only.'),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text('Only primary inactive employee or primary member of the network-sponsored membership.')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection = F2(
	function (patientsWithoutEmail, segments) {
		var patientsWithoutEmailCount = function () {
			if (patientsWithoutEmail.$ === 3) {
				var headers = patientsWithoutEmail.b;
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$String$toInt,
						A2($elm$core$Dict$get, 'x-total-count', headers)));
			} else {
				return 0;
			}
		}();
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						(patientsWithoutEmailCount > 0) ? A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Note:')
									])),
								$elm$html$Html$text(' We cannot email patients who are missing an email address. You have '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__Top,
								_List_fromArray(
									[
										$author$project$Ui$Link$routeParams(
										_List_fromArray(
											[
												A2($elm$url$Url$Builder$string, 'filter', 'without_email')
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Formatters$String$pluralize, 'patient', patientsWithoutEmailCount))
									])),
								$elm$html$Html$text(' without an email address.')
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Select the recipients of your email')
							]))
					])),
			segments);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewPatientsOneOffEmailContent = F2(
	function (form, shared) {
		var resource = shared.aB;
		var _v0 = $author$project$Utils$Form$fields(form);
		var activeRetail = _v0.hh;
		var inactiveRetail = _v0.iQ;
		var activeSponsored = _v0.hi;
		var inactiveSponsored = _v0.iR;
		return A2(
			$author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection,
			shared.nm,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Active Patients')
						])),
					_Utils_eq(resource, $author$project$Api$Provider$Notification$PracticeContext) ? A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveRetailPatients, form, activeRetail)) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveSponsoredPatients, form, activeSponsored)),
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Inactive Patients')
						])),
					_Utils_eq(resource, $author$project$Api$Provider$Notification$PracticeContext) ? A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveRetailPatients, form, inactiveRetail)) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveSponsoredPatients, form, inactiveSponsored))
				]));
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewPreview = F2(
	function (subject, body) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Subject Line')
					]),
				_List_fromArray(
					[subject])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Body')
					]),
				_List_fromArray(
					[body]))
			]);
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModalBody = function (model) {
	switch (model.$) {
		case 0:
			return _List_Nil;
		case 2:
			var shared = model.a;
			var delivery = model.c;
			return _Utils_ap(
				A2(
					$author$project$Components$Admin$NotificationSetting$MassEmail$viewPreview,
					A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$NotificationSetting$All$subjectExample(shared.UN))
									]))
							])),
					A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('notification-email-layout')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Api$HtmlTemplate$view,
										$author$project$Api$Phi$displayAttr,
										$author$project$Api$Provider$NotificationSetting$All$bodyExample(shared.UN))
									]))
							]))),
				_List_fromArray(
					[
						function () {
						if (delivery.$ === 2) {
							var error = delivery.a;
							return A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error sending email')
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(
										$author$project$Api$Data$errorToString(error))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]));
		default:
			var shared = model.a;
			var form = model.b;
			var _v2 = $author$project$Api$Provider$NotificationSetting$All$id(shared.UN);
			switch (_v2) {
				case 'patient_setup_payment_information':
					return A2(
						$author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection,
						shared.nm,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$disabled(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Employees')
													])),
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$disabled(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Patients')
													])),
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$disabled(true),
														$author$project$Ui$Form$Checkbox$value(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Membership Owners')
													])),
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$disabled(true),
														$author$project$Ui$Form$Checkbox$value(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Missing Payment Information')
													]))
											]))
									]))
							]));
				case 'provider_and_location_selection_request':
					var patientsWithoutEmailCount = function () {
						var _v3 = shared.nm;
						if (_v3.$ === 3) {
							var headers = _v3.b;
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$String$toInt,
									A2($elm$core$Dict$get, 'x-total-count', headers)));
						} else {
							return 0;
						}
					}();
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									(patientsWithoutEmailCount > 0) ? A2(
									$author$project$Ui$Alert$danger,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Note:')
												])),
											$elm$html$Html$text(' We cannot email patients who are missing an email address. You have '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__Top,
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(
													_List_fromArray(
														[
															A2($elm$url$Url$Builder$string, 'filter', 'without_email')
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($author$project$Formatters$String$pluralize, 'patient', patientsWithoutEmailCount))
												])),
											$elm$html$Html$text(' without an email address.')
										])) : $author$project$Utils$Html$empty
								]))
						]);
				case 'patients_one_off_email':
					return A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewPatientsOneOffEmailContent, form, shared);
				default:
					return _List_Nil;
			}
	}
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$Preview = {$: 2};
var $author$project$Components$Admin$NotificationSetting$MassEmail$SelectSegments = {$: 3};
var $author$project$Components$Admin$NotificationSetting$MassEmail$Send = {$: 5};
var $author$project$Utils$FormErrors$alert = F2(
	function (style, errorList) {
		return $elm$core$List$isEmpty(errorList) ? $author$project$Utils$Html$empty : A3(
			$author$project$Ui$Alert$view,
			style,
			_List_fromArray(
				[
					$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textCenter)
				]),
			A2($elm$core$List$map, $elm$html$Html$text, errorList));
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModalFooter = function (model) {
	return $elm$core$List$singleton(
		A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$gap2]),
			function () {
				switch (model.$) {
					case 0:
						return _List_Nil;
					case 2:
						var request = model.c;
						var loading = function () {
							if (request.$ === 1) {
								return true;
							} else {
								return false;
							}
						}();
						return _List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$SelectSegments)
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 43),
										$elm$html$Html$text('Back')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Email patients'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$Send),
										$author$project$Ui$Button$loading(loading),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Email Patients')
									]))
							]);
					default:
						var form = model.b;
						return _List_fromArray(
							[
								A2(
								$author$project$Utils$FormErrors$alert,
								2,
								A2($author$project$Utils$Form$validationErrors, 0, form)),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Preview before sending'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$Preview)
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 44),
										$elm$html$Html$text(' Preview Before Sending')
									]))
							]);
				}
			}()));
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$NotificationSetting$MassEmail$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Send Mass Email')
					])),
				$author$project$Ui$Modal$body(
				$author$project$Components$Admin$NotificationSetting$MassEmail$viewModalBody(model)),
				$author$project$Ui$Modal$footer(
				$author$project$Components$Admin$NotificationSetting$MassEmail$viewModalFooter(model))
			]));
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$modal = function (model) {
	switch (model.$) {
		case 0:
			return $author$project$Utils$Html$empty;
		case 1:
			return $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal(model);
		default:
			return $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal(model);
	}
};
var $author$project$Components$Admin$NotificationSetting$Preview$LanguageSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$NotificationSetting$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$description(shared);
};
var $author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml(shared);
};
var $author$project$Components$Admin$NotificationSetting$Preview$viewSkeleton = _List_fromArray(
	[
		$author$project$Ui$Skeleton$text(_List_Nil),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Subject Line')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Well$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('Skeleton subject')
							]))
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Body')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Well$view,
				_List_Nil,
				A2(
					$elm$core$List$repeat,
					10,
					$author$project$Ui$Skeleton$text(_List_Nil)))
			]))
	]);
var $author$project$Components$Admin$NotificationSetting$Preview$view = function (model) {
	return model.U9 ? A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$NotificationSetting$Preview$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						$author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml(model.UN))
					])),
				$author$project$Ui$Modal$body(
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$NotificationSetting$All$description(model.UN))
							])),
					A2(
						$elm$core$List$cons,
						function () {
							var _v0 = model.fy;
							if (!_v0.$) {
								var dropdown = _v0.a;
								var languageToItem = function (lang) {
									return A2(
										$author$project$Ui$NewDropdown$item,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$selected(
												_Utils_eq(lang, model.yu)),
												$author$project$Ui$NewDropdown$onSelect(
												$author$project$Components$Admin$NotificationSetting$Preview$LanguageSelected(lang))
											]),
										$elm$html$Html$text(
											$author$project$Language$toLabel(lang)));
								};
								var items = A2(
									$elm$core$List$map,
									languageToItem,
									_List_fromArray(
										[$author$project$Language$english, $author$project$Language$spanish]));
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Viewing'),
											$author$project$Ui$Form$Group$labelSpan(2),
											$author$project$Ui$Form$Group$inputSpan(4)
										]),
									_List_fromArray(
										[
											A4(
											$author$project$Ui$NewDropdown$viewSelect,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Language$toLabel(model.yu))
												]),
											items,
											dropdown)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
						function () {
							var _v1 = A2(
								$elm$core$Dict$get,
								$author$project$Language$toValue(model.yu),
								model.afU);
							if ((!_v1.$) && (_v1.a.$ === 3)) {
								var _v2 = _v1.a;
								var preview = _v2.a;
								var subject = $author$project$Api$Provider$NotificationSettingPreview$subject(preview);
								var body = $author$project$Api$Provider$NotificationSettingPreview$body(preview);
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Subject'),
												$author$project$Ui$Form$Group$labelSpan(2)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Well$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(subject)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Body'),
												$author$project$Ui$Form$Group$labelSpan(2)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Well$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('notification-email-layout')
															]),
														_List_fromArray(
															[
																A2($author$project$Api$HtmlTemplate$view, _List_Nil, body)
															]))
													]))
											]))
									]);
							} else {
								return $author$project$Components$Admin$NotificationSetting$Preview$viewSkeleton;
							}
						}()))),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Preview$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							]))
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$ViewNotificationSetting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$NotificationSetting$MassEmail$OpenModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Admin$NotificationSetting$MassEmail$supportedNotificationTypeIds = _List_fromArray(
	['patient_setup_payment_information', 'patients_one_off_email', 'provider_and_location_selection_request']);
var $author$project$Components$Admin$NotificationSetting$MassEmail$button = F2(
	function (session, notificationSetting) {
		var canSendMassEmail = A2(
			$elm$core$List$member,
			$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting),
			$author$project$Components$Admin$NotificationSetting$MassEmail$supportedNotificationTypeIds);
		return canSendMassEmail ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Send Email'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick(
					A2($author$project$Components$Admin$NotificationSetting$MassEmail$OpenModal, session, notificationSetting))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Send Email')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewDunningScheduleLink = F2(
	function (notificationSettingId, showCustomizeDunningFeature) {
		var invoiceSettingLink = A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Schedule')
				]));
		var _v0 = _Utils_Tuple2(notificationSettingId, showCustomizeDunningFeature);
		_v0$2:
		while (true) {
			if (_v0.b) {
				switch (_v0.a) {
					case 'patient_charge_failed':
						return invoiceSettingLink;
					case 'patient_charge_failed_followup':
						return invoiceSettingLink;
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$ToggleOverrideToggleVisibility = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$getNotificationSettingById = F2(
	function (id, data) {
		if (data.$ === 3) {
			var settings = data.a;
			return A2(
				$elm_community$list_extra$List$Extra$find,
				function (setting) {
					return _Utils_eq(
						$author$project$Api$Provider$NotificationSetting$All$id(setting),
						id);
				},
				settings);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewCompanyOverrideToggle = F3(
	function (id, toggleNotification, model) {
		var viewToggle = A2(
			$elm$html$Html$map,
			A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification),
			$author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
		var practiceSettingsLoaded = function () {
			var _v4 = model.r8;
			if (_v4.$ === 3) {
				return true;
			} else {
				return false;
			}
		}();
		if (!practiceSettingsLoaded) {
			return viewToggle;
		} else {
			var companySetting = A2(
				$elm$core$Maybe$map,
				function (_v3) {
					var ns = _v3.a;
					return ns;
				},
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (_v2) {
						var ns = _v2.a;
						return _Utils_eq(
							$author$project$Api$Provider$NotificationSetting$All$id(ns),
							id);
					},
					model.a9));
			if (companySetting.$ === 1) {
				return $author$project$Utils$Html$empty;
			} else {
				var company = companySetting.a;
				var hasOverride = !_Utils_eq(
					$author$project$Api$Provider$NotificationSetting$All$customEnabled(company),
					$elm$core$Maybe$Nothing);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col items-start gap-2')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if (hasOverride) {
										return viewToggle;
									} else {
										var practiceSetting = A2($author$project$Components$Admin$NotificationSetting$AdminTable$getNotificationSettingById, id, model.r8);
										if (!practiceSetting.$) {
											var practice = practiceSetting.a;
											return A2(
												$author$project$Ui$Typography$title,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$NotificationSetting$All$enabled(practice) ? 'On' : 'Off')
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}
								}()
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('w-36')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{
										abp: hasOverride ? 'Remove override' : 'Override'
									},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$NotificationSetting$AdminTable$ToggleOverrideToggleVisibility(id))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											hasOverride ? 'Remove override' : 'Override')
										]))
								]))
						]));
			}
		}
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewOverrideToggle = F3(
	function (id, toggleNotification, model) {
		var _v0 = model.aB;
		if (_v0.$ === 1) {
			return $author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle(id) ? A3($author$project$Components$Admin$NotificationSetting$AdminTable$viewCompanyOverrideToggle, id, toggleNotification, model) : A2(
				$elm$html$Html$map,
				A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification),
				$author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
		} else {
			return A2(
				$elm$html$Html$map,
				A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification),
				$author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
		}
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewSettingsLink = function (notificationSettingId) {
	var invoiceSettingLink = A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Admin__InvoiceSettings,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Manage Sponsor Invoice Settings')
			]));
	switch (notificationSettingId) {
		case 'employer_invoice_created':
			return invoiceSettingLink;
		case 'employer_invoice_generating':
			return invoiceSettingLink;
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewNotificationSetting = F5(
	function (session, showCustomizeDunningFeature, index, _v0, model) {
		var notificationSetting = _v0.a;
		var toggleNotification = _v0.b;
		var customizeModel = _v0.c;
		var id = $author$project$Api$Provider$NotificationSetting$All$id(notificationSetting);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(id)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(index + 1) + (' - ' + $author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml(notificationSetting)))
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$NotificationSetting$All$description(notificationSetting)),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									($author$project$Api$Provider$NotificationSetting$All$id(notificationSetting) === 'patients_one_off_email') ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Learn how to customize a message '),
											A3(
											$author$project$Ui$Link$externalHref,
											'http://support.hint.com/en/articles/3864748-custom-notifications',
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('here')
												]))
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'View notification setting'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$NotificationSetting$AdminTable$ViewNotificationSetting(notificationSetting))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View')
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(notificationSetting),
									$author$project$Components$Admin$NotificationSetting$Customize$button(customizeModel)),
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg,
									A2($author$project$Components$Admin$NotificationSetting$MassEmail$button, session, notificationSetting)),
									A2(
									$author$project$Components$Admin$NotificationSetting$AdminTable$viewDunningScheduleLink,
									$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting),
									showCustomizeDunningFeature)
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(notificationSetting),
							$author$project$Components$Admin$NotificationSetting$Customize$modal(customizeModel))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Components$Admin$NotificationSetting$AdminTable$viewOverrideToggle, id, toggleNotification, model),
							$author$project$Components$Admin$NotificationSetting$AdminTable$viewSettingsLink(
							$author$project$Api$Provider$NotificationSetting$All$id(notificationSetting))
						]))
				]));
	});
var $author$project$Components$Admin$NotificationSetting$AdminTable$viewTable = function (model) {
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(model.S_)
			]),
		_List_Nil,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, item) {
					return A5($author$project$Components$Admin$NotificationSetting$AdminTable$viewNotificationSetting, model.ZD, model.Cg, index, item, model);
				}),
			model.a9),
		_List_Nil);
};
var $author$project$Components$Admin$NotificationSetting$AdminTable$view = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.afU;
			if (!_v0.$) {
				var preview = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg,
					$author$project$Components$Admin$NotificationSetting$Preview$view(preview));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg,
			$author$project$Components$Admin$NotificationSetting$MassEmail$modal(model.m$)),
			$author$project$Components$Admin$NotificationSetting$AdminTable$viewTable(model)
		]);
};
var $author$project$Pages$Admin$Notifications$Company$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Employer Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to any employers who are sponsoring employee memberships.')
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$identity),
								$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rh))))
					]))
			]),
		$G: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Company$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Notifications$Company$init, aer: $author$project$Pages$Admin$Notifications$Company$load, agD: $author$project$Pages$Admin$Notifications$Company$save, ahd: $author$project$Pages$Admin$Notifications$Company$subscriptions, aaq: $author$project$Pages$Admin$Notifications$Company$update, ahP: $author$project$Pages$Admin$Notifications$Company$view});
var $author$project$Pages$Admin$Notifications$Employee$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Employee = 4;
var $author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature = F2(
	function (multiLanguage, model) {
		return _Utils_update(
			model,
			{rr: multiLanguage});
	});
var $author$project$Pages$Admin$Notifications$Employee$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var multilanguageEnabled = A2(
			$author$project$Api$Practice$featureEnabled,
			10,
			$author$project$Api$Practice$Provider(practice));
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled),
			A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 4));
		var adminTable = _v2.a;
		var adminTableCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, rh: adminTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Employee$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Employee$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Employee$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rh));
};
var $author$project$Pages$Admin$Notifications$Employee$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.D5, subMsg, model.rh);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Notifications$Employee$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Employee Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to any patients who are being sponsored by their employers. '),
										$elm$html$Html$text('They will also receive any patient emails that don\'t relate to payment of their memberships.')
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$identity),
								$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rh))))
					]))
			]),
		$G: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Employee$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Notifications$Employee$init, aer: $author$project$Pages$Admin$Notifications$Employee$load, agD: $author$project$Pages$Admin$Notifications$Employee$save, ahd: $author$project$Pages$Admin$Notifications$Employee$subscriptions, aaq: $author$project$Pages$Admin$Notifications$Employee$update, ahP: $author$project$Pages$Admin$Notifications$Employee$view});
var $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Zu;
	});
var $author$project$Pages$Admin$Notifications$Membership$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var multilanguageEnabled = A2(
			$author$project$Api$Practice$featureEnabled,
			10,
			$author$project$Api$Practice$Provider(practice));
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled),
			A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 1));
		var adminTable = _v2.a;
		var adminTableCmd = _v2.b;
		return _Utils_Tuple2(
			{
				kW: adminTable,
				D5: apiClient,
				WF: $author$project$Api$Data$NotAsked,
				Zu: $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification(practice)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Membership$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Membership$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Membership$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Notifications$Membership$AdminTableMsg,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.kW));
};
var $author$project$Pages$Admin$Notifications$Membership$GotPractice = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Practice$updateSendZeroRevenueMembershipNotification = F3(
	function (apiClient, bool, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'send_zero_revenue_membership_notification',
								$elm$json$Json$Encode$bool(bool))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Notifications$Membership$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.D5, subMsg, model.kW);
				var adminTable = _v1.a;
				var subCmd = _v1.b;
				var subOutMsg = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kW: adminTable}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg, subCmd),
					subOutMsg);
			case 1:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WF: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$Practice$updateSendZeroRevenueMembershipNotification, model.D5, !bool, $author$project$Pages$Admin$Notifications$Membership$GotPractice),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								WF: response,
								Zu: $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification(practice)
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your membership notifications have been updated'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WF: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Notifications$Membership$SendZeroRevenueMembershipNotificationChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Checkbox$Loading = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Checkbox$loading = $author$project$Ui$Form$Checkbox$Loading;
var $author$project$Pages$Admin$Notifications$Membership$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Membership Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to your patients automatically. Please remember, we do not send emails to patients without an ePHI waiver. '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See who hasn\'t signed an ePHI waiver here.')
											]))
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Form$Checkbox$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Checkbox$value(!model.Zu),
											$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$Admin$Notifications$Membership$SendZeroRevenueMembershipNotificationChanged),
											$author$project$Ui$Form$Checkbox$loading(
											_Utils_eq(model.WF, $author$project$Api$Data$Loading))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Don\'t send membership payment notifications to $0 memberships')
												]))
										])),
								A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Pages$Admin$Notifications$Membership$AdminTableMsg),
									$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.kW)))))
					]))
			]),
		$G: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Membership$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Notifications$Membership$init, aer: $author$project$Pages$Admin$Notifications$Membership$load, agD: $author$project$Pages$Admin$Notifications$Membership$save, ahd: $author$project$Pages$Admin$Notifications$Membership$subscriptions, aaq: $author$project$Pages$Admin$Notifications$Membership$update, ahP: $author$project$Pages$Admin$Notifications$Membership$view});
var $author$project$Pages$Admin$Notifications$Patient$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$FeatureGate$CustomizeDunningSchedule = 10;
var $author$project$Api$Provider$NotificationSetting$Patient = 0;
var $author$project$Components$Admin$NotificationSetting$AdminTable$withCustomizeDunningFeature = F2(
	function (showCustomizeDunningFeature, model) {
		return _Utils_update(
			model,
			{Cg: showCustomizeDunningFeature});
	});
var $author$project$Pages$Admin$Notifications$Patient$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var multiLanguageEnable = A2(
			$author$project$Api$Practice$featureEnabled,
			10,
			$author$project$Api$Practice$Provider(practice));
		var customDunningEnabled = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			10,
			$author$project$Api$Practice$Provider(practice));
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multiLanguageEnable),
			A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Components$Admin$NotificationSetting$AdminTable$withCustomizeDunningFeature(customDunningEnabled),
				A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 0)));
		var adminTable = _v2.a;
		var adminTableCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, rh: adminTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Patient$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Patient$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Patient$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rh));
};
var $author$project$Pages$Admin$Notifications$Patient$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.D5, subMsg, model.rh);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Notifications$Patient$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Patient Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to your patients automatically. '),
										$elm$html$Html$text('Please remember, we will not automatically send emails that contain personal information to patients without the ePHI waiver. '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See who hasn\'t signed an ePHI waiver here.')
											]))
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$identity),
								$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rh))))
					]))
			]),
		$G: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Patient$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Notifications$Patient$init, aer: $author$project$Pages$Admin$Notifications$Patient$load, agD: $author$project$Pages$Admin$Notifications$Patient$save, ahd: $author$project$Pages$Admin$Notifications$Patient$subscriptions, aaq: $author$project$Pages$Admin$Notifications$Patient$update, ahP: $author$project$Pages$Admin$Notifications$Patient$view});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$GotDunningSchedule = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$DunningSchedule$One$DunningSchedule = $elm$core$Basics$identity;
var $author$project$Api$Provider$DunningSchedule$Shared$DunningSchedule = $elm$core$Basics$identity;
var $author$project$Api$Provider$DunningSchedule$Shared$Record = function (ruleList) {
	return {YW: ruleList};
};
var $author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$ScheduleBreakDown = F2(
	function (action, delayInDaysFromDunningStart) {
		return {DV: action, acE: delayInDaysFromDunningStart};
	});
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$AttemptInvoicePayment = 0;
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$DunningFailed = 3;
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$SendDunningNotification = 1;
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$SendDunningNotificationFollowup = 2;
var $author$project$Api$Provider$DunningSchedule$ScheduleAction$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (stringAction) {
		switch (stringAction) {
			case 'AttemptInvoicePayment':
				return $elm$json$Json$Decode$succeed(0);
			case 'SendDunningNotification':
				return $elm$json$Json$Decode$succeed(1);
			case 'SendDunningNotificationFollowup':
				return $elm$json$Json$Decode$succeed(2);
			case 'DunningFailed':
				return $elm$json$Json$Decode$succeed(3);
			default:
				var unsupported = stringAction;
				return $elm$json$Json$Decode$fail('unsupported action type ' + unsupported);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'delay_in_days_from_dunning_start',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'action',
		$author$project$Api$Provider$DunningSchedule$ScheduleAction$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$ScheduleBreakDown)));
var $author$project$Api$Provider$DunningSchedule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'schedule',
	$elm$json$Json$Decode$list($author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$DunningSchedule$Shared$Record));
var $author$project$Api$Provider$DunningSchedule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DunningSchedule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DunningSchedule$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DunningSchedule$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DunningSchedule$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$DunningSchedule$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['dunning_schedules']),
					$author$project$Api$Data$providerPath)));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$fetchDunningSchedule = function (apiClient) {
	return A2($author$project$Api$Provider$DunningSchedule$retrieve, apiClient, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$GotDunningSchedule);
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		return _Utils_Tuple2(
			{D5: apiClient, aj: _List_Nil, O: _List_Nil, fE: _List_Nil, WF: practice, eC: $author$project$Api$Data$Loading, ZD: session},
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$fetchDunningSchedule(apiClient));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$Failed = 0;
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$BothEmailsSameDay = {$: 1};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$bothEmailsSameDayValidation = F2(
	function (chargeFailedList, chargeFailedFollowupToValidateList) {
		var chargeFailedDelaysInDays = A2(
			$elm$core$List$map,
			function ($) {
				return $.acE;
			},
			A2($elm$core$List$map, $elm$core$Tuple$first, chargeFailedList));
		var onSameDay = function (item) {
			return A2($elm$core$List$member, item.acE, chargeFailedDelaysInDays);
		};
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var item = _v0.a;
				var errors = _v0.b;
				return _Utils_Tuple2(
					item,
					_Utils_ap(
						errors,
						onSameDay(item) ? _List_fromArray(
							[$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$BothEmailsSameDay]) : _List_Nil));
			},
			chargeFailedFollowupToValidateList);
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ScheduleCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$DunningSchedule$scheduleActionToStringEncoder = function (action) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (action) {
				case 0:
					return 'AttemptInvoicePayment';
				case 1:
					return 'SendDunningNotification';
				case 2:
					return 'SendDunningNotificationFollowup';
				default:
					return 'DunningFailed';
			}
		}());
};
var $author$project$Api$Provider$DunningSchedule$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'dunning_schedule',
					A2(
						$elm$json$Json$Encode$list,
						function (_v0) {
							var action = _v0.DV;
							var delayInDaysFromDunningStart = _v0.acE;
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'action',
										$author$project$Api$Provider$DunningSchedule$scheduleActionToStringEncoder(action)),
										_Utils_Tuple2(
										'delay_in_days_from_dunning_start',
										$elm$json$Json$Encode$int(delayInDaysFromDunningStart))
									]));
						},
						fields))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$DunningSchedule$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['dunning_schedules']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction = F2(
	function (schedule, action) {
		return A2(
			$elm$core$List$map,
			function (item) {
				return _Utils_Tuple2(item, _List_Nil);
			},
			A2(
				$elm$core$List$filter,
				function (listItem) {
					return _Utils_eq(listItem.DV, action);
				},
				schedule));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunction = F2(
	function (a, b) {
		var _v0 = _Utils_Tuple2(a.DV, b.DV);
		if (_v0.a === 3) {
			var _v1 = _v0.a;
			return 2;
		} else {
			if (_v0.b === 3) {
				var _v2 = _v0.b;
				return 0;
			} else {
				return (_Utils_cmp(a.acE, b.acE) < 0) ? 0 : ((_Utils_cmp(a.acE, b.acE) > 0) ? 2 : ((!a.DV) ? 0 : 2));
			}
		}
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createSchedule = F4(
	function (apiClient, currentSchedule, chargeFailedSchedule, chargeFailedFollowupSchedule) {
		var dunningFailedSchedule = A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, currentSchedule, 3);
		var attemptPaymentSchedule = A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, currentSchedule, 0);
		var unorderedSchedule = _Utils_ap(
			attemptPaymentSchedule,
			_Utils_ap(
				chargeFailedSchedule,
				_Utils_ap(chargeFailedFollowupSchedule, dunningFailedSchedule)));
		var newSchedule = A2(
			$elm$core$List$sortWith,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunction,
			A2($elm$core$List$map, $elm$core$Tuple$first, unorderedSchedule));
		return A3($author$project$Api$Provider$DunningSchedule$create, apiClient, newSchedule, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ScheduleCreated);
	});
var $author$project$Api$Provider$DunningSchedule$Shared$ruleList = function (_v0) {
	var record = _v0;
	return record.YW;
};
var $author$project$Api$Provider$DunningSchedule$One$ruleList = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$DunningSchedule$Shared$ruleList(shared);
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$SameEmailForSameDay = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$validateSameDayEmail = F2(
	function (validatingItem, list) {
		return function (errors) {
			return _Utils_Tuple2(validatingItem, errors);
		}(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var index = _v1.a;
					return $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$SameEmailForSameDay(
						$elm$core$String$fromInt(index));
				},
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var item = _v0.b;
						return _Utils_eq(item.acE, validatingItem.acE);
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, item) {
								return _Utils_Tuple2(index + 1, item);
							}),
						$elm$core$List$reverse(list)))));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation = function (scheduleList) {
	var _v0 = $elm$core$List$reverse(scheduleList);
	if (!_v0.b) {
		return _List_Nil;
	} else {
		var last = _v0.a;
		var rest = _v0.b;
		var validatedLast = A2(
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$validateSameDayEmail,
			last.a,
			A2($elm$core$List$map, $elm$core$Tuple$first, rest));
		var unReversed = $elm$core$List$reverse(rest);
		return _Utils_ap(
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(unReversed),
			_List_fromArray(
				[validatedLast]));
	}
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var schedule = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aj: A2(
									$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
									$author$project$Api$Provider$DunningSchedule$One$ruleList(schedule),
									2),
								O: A2(
									$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
									$author$project$Api$Provider$DunningSchedule$One$ruleList(schedule),
									1),
								eC: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eC: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 1:
				var index = msg.a;
				var newDelayInDaysString = msg.b;
				var newRule = {
					DV: 1,
					acE: A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(newDelayInDaysString))
				};
				var newSchedule = A3(
					$elm_community$list_extra$List$Extra$setAt,
					index,
					_Utils_Tuple2(newRule, _List_Nil),
					model.O);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{O: newSchedule}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var index = msg.a;
				var newDelayInDaysString = msg.b;
				var newRule = {
					DV: 2,
					acE: A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(newDelayInDaysString))
				};
				var newSchedule = A3(
					$elm_community$list_extra$List$Extra$setAt,
					index,
					_Utils_Tuple2(newRule, _List_Nil),
					model.aj);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aj: newSchedule}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var validatedChargeFailedSchedule = $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(model.O);
				var validatedChargeFailedFollowupScheedule = A2(
					$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$bothEmailsSameDayValidation,
					model.O,
					$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(model.aj));
				var chargeFailedScheduleErrors = A2($elm$core$List$concatMap, $elm$core$Tuple$second, validatedChargeFailedSchedule);
				var chargeFailedFollowupScheduleErrors = A2($elm$core$List$concatMap, $elm$core$Tuple$second, validatedChargeFailedFollowupScheedule);
				var _v2 = function () {
					var _v3 = _Utils_Tuple2(chargeFailedScheduleErrors, chargeFailedFollowupScheduleErrors);
					if ((!_v3.a.b) && (!_v3.b.b)) {
						var currentSchedule = function () {
							var _v4 = model.eC;
							if (_v4.$ === 3) {
								var schedule = _v4.a;
								return $author$project$Api$Provider$DunningSchedule$One$ruleList(schedule);
							} else {
								return _List_Nil;
							}
						}();
						return _Utils_Tuple2(
							A4($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createSchedule, model.D5, currentSchedule, validatedChargeFailedSchedule, validatedChargeFailedFollowupScheedule),
							_List_Nil);
					} else {
						return _Utils_Tuple2(
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'Unable to save the schedule. Please check the errors.')
								]));
					}
				}();
				var createCmd = _v2.a;
				var outMsgs = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aj: validatedChargeFailedFollowupScheedule, O: validatedChargeFailedSchedule}),
					createCmd,
					outMsgs);
			case 3:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var schedule = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aj: A2(
										$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
										$author$project$Api$Provider$DunningSchedule$One$ruleList(schedule),
										2),
									O: A2(
										$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
										$author$project$Api$Provider$DunningSchedule$One$ruleList(schedule),
										1),
									eC: response
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Schedule succesfully updated')
								]));
					case 2:
						var errors = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eC: response}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Api$Data$errorToString(errors))
								]));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eC: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 4:
				var scheduleType = msg.a;
				if (!scheduleType) {
					var initialDelay = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$add(1),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.acE;
								},
								A2(
									$elm$core$Maybe$map,
									$elm$core$Tuple$first,
									$elm$core$List$head(
										$elm$core$List$reverse(model.O))))));
					var chargeFailedSchedule = _Utils_ap(
						model.O,
						_List_fromArray(
							[
								_Utils_Tuple2(
								{DV: 1, acE: initialDelay},
								_List_Nil)
							]));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{O: chargeFailedSchedule}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var chargeFailedFollowupSchedule = _Utils_ap(
						model.aj,
						_List_fromArray(
							[
								_Utils_Tuple2(
								{DV: 2, acE: 0},
								_List_Nil)
							]));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aj: chargeFailedFollowupSchedule}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var index = msg.a;
				var scheduleType = msg.b;
				if (!scheduleType) {
					var chargeFailedSchedule = A2($elm_community$list_extra$List$Extra$removeAt, index, model.O);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{O: chargeFailedSchedule}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var chargeFailedFollowupSchedule = A2($elm_community$list_extra$List$Extra$removeAt, index, model.aj);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aj: chargeFailedFollowupSchedule}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ValidateAndCreateSchedule = {$: 6};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays = F2(
	function (a, b) {
		return (_Utils_cmp(a.acE, b.acE) < 0) ? 0 : ((_Utils_cmp(a.acE, b.acE) > 0) ? 2 : 1);
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$didScheduleChange = F3(
	function (original, chargeFailedSchedule, chargeFailedFollowupSchedule) {
		var orderedOriginalFollowup = A2(
			$elm$core$List$sortWith,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays,
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
					$author$project$Api$Provider$DunningSchedule$One$ruleList(original),
					2)));
		var orderedOriginalChargeFailed = A2(
			$elm$core$List$sortWith,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays,
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction,
					$author$project$Api$Provider$DunningSchedule$One$ruleList(original),
					1)));
		var orderedNewFollowup = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays, chargeFailedFollowupSchedule);
		var orderedNewChargeFailed = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays, chargeFailedSchedule);
		return (!_Utils_eq(orderedOriginalChargeFailed, orderedNewChargeFailed)) || (!_Utils_eq(orderedOriginalFollowup, orderedNewFollowup));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBreadcrumbs = A2(
	$elm$html$Html$map,
	$elm$core$Basics$never,
	A2(
		$author$project$Ui$Breadcrumb$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Breadcrumb$item,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Notifications__Patient,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Patient Notifications')
							]))
					])),
				A2(
				$author$project$Ui$Breadcrumb$item,
				_List_fromArray(
					[
						$author$project$Ui$Breadcrumb$active(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Schedule \"Charge Failed\" emails and follow-ups')
					]))
			])));
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$AddEmailToScheduleButtonClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$Followup = 1;
var $author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart = function (rule) {
	return rule.acE;
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText = function (error) {
	if (!error.$) {
		var emailName = error.a;
		return 'You have already scheduled the Email #' + (emailName + ' to go out on this day.');
	} else {
		return 'You have scheduled both emails to go out on this day. Please adjust the schedule and update.';
	}
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewFirstNotification = F2(
	function (delayInDays, _v0) {
		var scheduleAction = _v0.a;
		var errors = _v0.b;
		var updateSchedule = (scheduleAction === 1) ? $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule(0) : $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule(0);
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Email #' + $elm$core$String$fromInt(1))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$group(
									A2(
										$author$project$Ui$Form$Input$withPreAddon,
										'# of days after a failed charge',
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												$elm$core$String$fromInt(delayInDays)),
												$author$project$Ui$Form$Input$onInput(updateSchedule),
												$author$project$Ui$Form$Input$number
											]))),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (error) {
											return A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$danger]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText(error))
													]));
										},
										errors))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$DeleteEmailFromScheduleButtonClicked = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotification = F3(
	function (index, delayInDays, _v0) {
		var scheduleAction = _v0.a;
		var errors = _v0.b;
		var _v1 = (scheduleAction === 1) ? _Utils_Tuple2(
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule(index + 1),
			0) : _Utils_Tuple2(
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule(index + 1),
			1);
		var updateSchedule = _v1.a;
		var emailType = _v1.b;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Email #' + $elm$core$String$fromInt(index + 2))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mt2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(11)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$group(
													A2(
														$author$project$Ui$Form$Input$withPreAddon,
														'# of days after a failed charge',
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$value(
																$elm$core$String$fromInt(delayInDays)),
																$author$project$Ui$Form$Input$onInput(updateSchedule),
																$author$project$Ui$Form$Input$number
															])))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(1)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Delete email from schedule'},
											_List_fromArray(
												[
													$author$project$Ui$Button$secondary,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
													$author$project$Ui$Button$onClick(
													A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$DeleteEmailFromScheduleButtonClicked, index + 1, emailType))
												]),
											_List_Nil)
										]))
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (error) {
									return A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[$author$project$Ui$Typography$danger]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText(error))
											]));
								},
								errors))
						]))
				]));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications = F2(
	function (notifications, notificationType) {
		var _v0 = (notificationType === 1) ? _Utils_Tuple3('1 - Charge Failed', 'Sent to patients if they have a failed charge.', 0) : _Utils_Tuple3('2 - Charge Failed (Follow-up)', 'Sent to patients if they have a failed charge and we have already sent them an email, but received no response. This email is usually sent as a final reminder prior to membership termination.', 1);
		var headerText = _v0.a;
		var helpText = _v0.b;
		var scheduleType = _v0.c;
		var _v1 = function () {
			if (!notifications.b) {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
			} else {
				var first_ = notifications.a;
				var rest_ = notifications.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(first_),
					rest_);
			}
		}();
		var maybeFirst = _v1.a;
		var rest = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb2]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text(headerText)
												]))
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$helpText]),
									_List_fromArray(
										[
											$elm$html$Html$text(helpText)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$hintLabel,
											$author$project$Ui$Typography$margin(17)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Schedule')
										]))
								])),
							function () {
							if (!maybeFirst.$) {
								var _v4 = maybeFirst.a;
								var first = _v4.a;
								var errors = _v4.b;
								return A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(10)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewFirstNotification,
											$author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart(first),
											_Utils_Tuple2(first.DV, errors))
										]));
							} else {
								return A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(10)
										]),
									_List_Nil);
							}
						}(),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_Nil),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(10)
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, _v5) {
										var item = _v5.a;
										var errors = _v5.b;
										return A3(
											$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotification,
											index,
											$author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart(item),
											_Utils_Tuple2(item.DV, errors));
									}),
								rest))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(2)
								]),
							_List_Nil),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(2)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add email to schedule'},
									_List_fromArray(
										[
											$author$project$Ui$Button$secondary,
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$AddEmailToScheduleButtonClicked(scheduleType))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Email to Schedule')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent = function (_v0) {
	var eventDate = _v0.a;
	var eventDay = _v0.b;
	var event = _v0.c;
	return {
		MO: eventDate,
		acn: $elm$core$Maybe$Just(
			$elm$core$String$fromInt(eventDay) + ' days after a failed charge'),
		Nx: event
	};
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes = function (scheduleBreakdown) {
	var eventDescription = function () {
		var _v0 = scheduleBreakdown.DV;
		switch (_v0) {
			case 1:
				return 'Send \"Charge Failed\"';
			case 2:
				return 'Send \"Charge Failed (Follow-up)\"';
			default:
				return 'Unknown';
		}
	}();
	var eventDate = $justinmimbs$date$Date$fromRataDie(scheduleBreakdown.acE);
	return _Utils_Tuple3(eventDate, scheduleBreakdown.acE, eventDescription);
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewTimeline = F2(
	function (chargeFailedSchedule, chargeFailedFollowupSchedule) {
		var chargeFailedFollowupEvents = A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent,
			A2($elm$core$List$map, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes, chargeFailedFollowupSchedule));
		var chargeFailedEvents = A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent,
			A2($elm$core$List$map, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes, chargeFailedSchedule));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-6 -mb-8')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Timeline$view,
					0,
					_Utils_ap(chargeFailedEvents, chargeFailedFollowupEvents))
				]));
	});
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBreadcrumbs,
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Schedule \"Charge Failed\" emails and follow-ups')
								])),
							A2(
							$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewTimeline,
							A2($elm$core$List$map, $elm$core$Tuple$first, model.O),
							A2($elm$core$List$map, $elm$core$Tuple$first, model.aj))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications, model.O, 1),
							A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications, model.aj, 2)
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Notifications__Patient,
							_List_fromArray(
								[$author$project$Ui$Link$buttonDefault]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							function () {
							var _v0 = model.eC;
							if (_v0.$ === 3) {
								var schedule = _v0.a;
								var scheduleChanged = A3(
									$author$project$Pages$Admin$Notifications$Patient$DunningSchedule$didScheduleChange,
									schedule,
									A2($elm$core$List$map, $elm$core$Tuple$first, model.O),
									A2($elm$core$List$map, $elm$core$Tuple$first, model.aj));
								return A3(
									$author$project$Ui$Button$view,
									{abp: 'Update schedule'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ValidateAndCreateSchedule),
											$author$project$Ui$Button$disabled(!scheduleChanged)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Update Schedule')
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$view = function (model) {
	return {
		e5: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBody(model),
		$G: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$init, aer: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$load, agD: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$save, ahd: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$subscriptions, aaq: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$update, ahP: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$view});
var $author$project$Pages$Admin$Notifications$Practice$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$NotificationSetting$Practice = 2;
var $author$project$Pages$Admin$Notifications$Practice$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var _v3 = A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 2);
		var adminTable = _v3.a;
		var adminTableCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, rh: adminTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Admin$Notifications$Practice$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Practice$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Practice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rh));
};
var $author$project$Pages$Admin$Notifications$Practice$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.D5, subMsg, model.rh);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Notifications$Practice$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Practice Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to members of your team.')
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$ul,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Admins, Managers, Staff and Staff Limited users are expected to receive all of the following email notifications, if enabled.')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Reports Only users will not receive any of the following email notifications.')
												])),
											A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Read Only users will only receive the new patient email notifications.')
												]))
										])),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$italic]),
										_List_fromArray(
											[
												$elm$html$Html$text('Note: If a role is restricted by location groups, the user will only receive the emails with content relevant to their assigned location groups. If the role is not restricted by location groups, they are expected to receive all email notifications.')
											])),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($elm$core$Basics$identity),
										$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rh))))))
					]))
			]),
		$G: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Practice$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Notifications$Practice$init, aer: $author$project$Pages$Admin$Notifications$Practice$load, agD: $author$project$Pages$Admin$Notifications$Practice$save, ahd: $author$project$Pages$Admin$Notifications$Practice$subscriptions, aaq: $author$project$Pages$Admin$Notifications$Practice$update, ahP: $author$project$Pages$Admin$Notifications$Practice$view});
var $author$project$Api$Provider$Practice$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$Practice$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$email(shared);
};
var $author$project$Api$Provider$Practice$One$emailReplyAddress = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.acV;
	});
var $author$project$Api$Provider$Practice$One$footer = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.adv;
	});
var $author$project$Api$Provider$Practice$One$greetsFormally = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.adE;
	});
var $author$project$Api$Provider$Practice$One$salutation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agC;
	});
var $author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields = function (practice) {
	return {
		acV: $author$project$Api$Provider$Practice$One$emailReplyAddress(practice),
		adv: $author$project$Api$Provider$Practice$One$footer(practice),
		adE: $author$project$Api$Provider$Practice$One$greetsFormally(practice),
		agC: $author$project$Api$Provider$Practice$One$salutation(practice)
	};
};
var $author$project$Components$TranslationsInput$Practice = {$: 2};
var $author$project$Components$TranslationsInput$practice = $author$project$Components$TranslationsInput$Practice;
var $author$project$Pages$Admin$Notifications$Settings$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.D5;
		return _Utils_Tuple2(
			{
				D5: apiClient,
				fA: false,
				PB: $author$project$Utils$Form$init(
					$author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields(practice)),
				Gc: A2(
					$author$project$Api$Practice$featureEnabled,
					10,
					$author$project$Api$Practice$Provider(practice)),
				WF: $author$project$Api$Data$NotAsked,
				r7: $author$project$Api$Provider$Practice$One$email(practice),
				oR: $author$project$Components$TranslationsInput$init($author$project$Components$TranslationsInput$practice)
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Notifications$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg,
		$author$project$Components$TranslationsInput$subscriptions(model.oR));
};
var $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						acV: $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{agC: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{adE: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{adv: string});
		}
	});
var $author$project$Pages$Admin$Notifications$Settings$EmailValidation = 0;
var $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: true},
			function ($) {
				return $.acV;
			},
			_Utils_Tuple2(0, 'Please enter a valid email.'))
		]));
var $author$project$Pages$Admin$Notifications$Settings$GotPractice = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Practice$resetPracticeEmailReplyAddress = F2(
	function (apiClient, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('email_reply_address', $elm$json$Json$Encode$null)
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Notifications$Settings$resetPracticeEmailReplyAddress = function (apiClient) {
	return A2($author$project$Api$Provider$Practice$resetPracticeEmailReplyAddress, apiClient, $author$project$Pages$Admin$Notifications$Settings$GotPractice);
};
var $author$project$Api$Provider$Practice$updateNotificationsSettings = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email_reply_address',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.acV)),
								_Utils_Tuple2(
								'salutation',
								$elm$json$Json$Encode$string(fields.agC)),
								_Utils_Tuple2(
								'greets_formally',
								$elm$json$Json$Encode$bool(fields.adE)),
								_Utils_Tuple2(
								'footer',
								$elm$json$Json$Encode$string(fields.adv))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Notifications$Settings$updatePractice = F2(
	function (apiClient, formFields) {
		return A3(
			$author$project$Api$Provider$Practice$updateNotificationsSettings,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Admin$Notifications$Settings$GotPractice);
	});
var $author$project$Pages$Admin$Notifications$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fA: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WF: $author$project$Api$Data$Loading}),
					$author$project$Pages$Admin$Notifications$Settings$resetPracticeEmailReplyAddress(model.D5),
					_List_Nil);
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsUpdate, field, model.PB);
				var validatedForm = function () {
					var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator, newForm);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var form = _v2.a;
						return form;
					} else {
						var form = _v1.a;
						return form;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: validatedForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator, model.PB);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm, WF: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$Notifications$Settings$updatePractice, model.D5, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fA: false,
								PB: $author$project$Utils$Form$init(
									$author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields(practice)),
								WF: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your practice\'s notification settings have been updated'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$TranslationsInput$update, model.D5, subMsg, model.oR);
				var translationsInput = _v6.a;
				var translationsInputCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oR: translationsInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg, translationsInputCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Notifications$Settings$EditEmailReplyAddress = {$: 0};
var $author$project$Pages$Admin$Notifications$Settings$EmailReplyAddress = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$Footer = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$GreetsFormally = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Notifications$Settings$ResetEmailReplyAddress = {$: 1};
var $author$project$Pages$Admin$Notifications$Settings$Salutation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$Save = 16;
var $author$project$Pages$Admin$Notifications$Settings$UpdatePractice = {$: 3};
var $author$project$Pages$Admin$Notifications$Settings$canEditEmail = F2(
	function (emailReplyAddress, model) {
		var practiceEmailIsEmpty = $elm$core$String$isEmpty(
			A2($elm$core$Maybe$withDefault, '', model.r7));
		var emailReplyAddressIsEmpty = $elm$core$String$isEmpty(
			A2($elm$core$Maybe$withDefault, '', emailReplyAddress));
		var _v0 = _Utils_Tuple3(model.fA, emailReplyAddressIsEmpty, practiceEmailIsEmpty);
		if (_v0.a) {
			return false;
		} else {
			if (_v0.b && _v0.c) {
				return false;
			} else {
				return true;
			}
		}
	});
var $author$project$Pages$Admin$Notifications$Settings$greetsFormallyDescription = function (greetsFormally) {
	return $elm$html$Html$text(
		greetsFormally ? $elm$core$String$concat(
			_List_fromArray(
				['Recipient will be addressed using their title if it has been specified. ', 'If title has not been specified, but gender has been specified, they will be addressed using \"Mr.\" or \"Ms.\". ', 'If neither title or gender has been specified, they will be addressed using their first name.'])) : 'Recipient will be addressed by their first name.');
};
var $author$project$Pages$Admin$Notifications$Settings$hintDefaultEmail = 'hello@hint.com';
var $author$project$Components$TranslationsInput$ContentType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$TranslationsInput$Text = 1;
var $author$project$Components$TranslationsInput$textarea = $author$project$Components$TranslationsInput$ContentType(1);
var $author$project$Pages$Admin$Notifications$Settings$viewPanel = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var emailReplyAddress = _v0.acV;
	var salutation = _v0.agC;
	var greetsFormally = _v0.adE;
	var footer = _v0.adv;
	var email = function () {
		var _v6 = _Utils_Tuple3(model.fA, emailReplyAddress, model.r7);
		if (_v6.a) {
			return A2($elm$core$Maybe$withDefault, '', emailReplyAddress);
		} else {
			if (!_v6.b.$) {
				var emailReplyAddress_ = _v6.b.a;
				return emailReplyAddress_;
			} else {
				if (!_v6.c.$) {
					var practiceEmail = _v6.c.a;
					return practiceEmail;
				} else {
					var _v7 = _v6.b;
					var _v8 = _v6.c;
					return $author$project$Pages$Admin$Notifications$Settings$hintDefaultEmail;
				}
			}
		}
	}();
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[$author$project$Ui$Form$horizontal]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Notification Settings')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Email Address')
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Reply-to Email Address'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$offsetLabel,
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$group(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$placeholder('example@mail.com'),
														$author$project$Ui$Form$Input$value(email),
														$author$project$Ui$Form$Input$disabled(!model.fA),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$EmailReplyAddress)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB))
													])),
												$author$project$Ui$Form$Input$addon(
												_List_fromArray(
													[
														A2($author$project$Pages$Admin$Notifications$Settings$canEditEmail, emailReplyAddress, model) ? A3(
														$author$project$Ui$Button$view,
														{abp: 'Edit email replay address'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$EditEmailReplyAddress)
															]),
														_List_fromArray(
															[
																A2($author$project$Ui$Icon$view, _List_Nil, 16),
																$elm$html$Html$text(' Edit')
															])) : $author$project$Utils$Html$empty
													]))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 0, model.PB)),
										function () {
										if (model.fA) {
											return $author$project$Utils$Html$empty;
										} else {
											var emailDescription = function () {
												var _v1 = _Utils_Tuple2(emailReplyAddress, model.r7);
												if (_v1.b.$ === 1) {
													if (_v1.a.$ === 1) {
														var _v2 = _v1.a;
														var _v3 = _v1.b;
														return _List_fromArray(
															[
																$elm$html$Html$text('You do not have a contact email set for your practice. '),
																$elm$html$Html$text('Once set, we will send emails from this address on your behalf. '),
																$elm$html$Html$text('You can set this email on the '),
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Admin__Practice,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Admin > General')
																	])),
																$elm$html$Html$text(' settings page.')
															]);
													} else {
														var _v5 = _v1.b;
														return _List_fromArray(
															[
																$elm$html$Html$text('We are sending emails from a custom email address.  You can edit this address above.'),
																A2($elm$html$Html$br, _List_Nil, _List_Nil),
																$elm$html$Html$text('You do not have a contact email set for your practice. Please set one on the '),
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Admin__Practice,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Admin > General')
																	])),
																$elm$html$Html$text(' settings page. '),
																$elm$html$Html$text('Once set you can return here to configure emails to be sent from your practice’s contact email.')
															]);
													}
												} else {
													if (_v1.a.$ === 1) {
														var _v4 = _v1.a;
														return _List_fromArray(
															[
																$elm$html$Html$text('We are sending emails from your practice\'s email address on your behalf. '),
																$elm$html$Html$text('You can change this email on the '),
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Admin__Practice,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Admin > General')
																	])),
																$elm$html$Html$text(' settings page.'),
																A2($elm$html$Html$br, _List_Nil, _List_Nil),
																$elm$html$Html$text('If you want to use a different email address to send emails click the edit button above.')
															]);
													} else {
														var practiceEmail_ = _v1.b.a;
														return _List_fromArray(
															[
																$elm$html$Html$text('We are sending emails from an email that is different than your practice’s contact email address. '),
																$elm$html$Html$text('You can edit this email above, or reset it to use your practice’s contact email. '),
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Reset to ' + practiceEmail_},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$link,
																		$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																		$author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$ResetEmailReplyAddress)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Reset to ' + practiceEmail_)
																	]))
															]);
													}
												}
											}();
											return A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												emailDescription);
										}
									}()
									])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Greeting')
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Salutation'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$offsetLabel,
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(salutation),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$Salutation))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Use recipient\'s title and last name?'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$offsetLabel,
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(greetsFormally),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$GreetsFormally))
											])),
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$author$project$Pages$Admin$Notifications$Settings$greetsFormallyDescription(greetsFormally)
											]))
									])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Closing')
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Content'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$offsetLabel,
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Textarea$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Textarea$rows(5),
												$author$project$Ui$Form$Textarea$value(footer),
												$author$project$Ui$Form$Textarea$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$Footer))
											])),
										model.Gc ? A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg,
										A3(
											$author$project$Components$TranslationsInput$view,
											'footer',
											_List_fromArray(
												[
													$author$project$Components$TranslationsInput$default(footer),
													$author$project$Components$TranslationsInput$textarea
												]),
											model.oR)) : $elm$html$Html$text('')
									]))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Practice,
								_List_fromArray(
									[$author$project$Ui$Link$buttonSecondary]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Save settings'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$loading(
										_Utils_eq(model.WF, $author$project$Api$Data$Loading)),
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$UpdatePractice)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Notifications$Settings$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$Admin$Notifications$Settings$viewPanel(model)
			]),
		$G: 'Admin | Notifications'
	};
};
var $author$project$Pages$Admin$Notifications$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Notifications$Settings$init, aer: $author$project$Pages$Admin$Notifications$Settings$load, agD: $author$project$Pages$Admin$Notifications$Settings$save, ahd: $author$project$Pages$Admin$Notifications$Settings$subscriptions, aaq: $author$project$Pages$Admin$Notifications$Settings$update, ahP: $author$project$Pages$Admin$Notifications$Settings$view});
var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $agustinrhcp$elm_datepicker$DatePicker$initFromDate = function (date) {
	return {
		a4: $elm$core$Maybe$Just(date),
		fG: false,
		ca: $elm$core$Maybe$Nothing,
		U9: false,
		jt: 0,
		$P: date
	};
};
var $author$project$Components$DateInput$initFromDate = function (currentDate) {
	var datePicker = $agustinrhcp$elm_datepicker$DatePicker$initFromDate(currentDate);
	return {lM: datePicker};
};
var $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ab$;
	});
var $author$project$Api$Provider$Practice$One$collectLocationOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ab7;
	});
var $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lg;
	});
var $author$project$Api$Provider$Practice$One$collectSSNOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lh;
	});
var $author$project$Api$Provider$Practice$One$defaultPatientsPreferredLanguage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Ne;
	});
var $author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.acD;
	});
var $author$project$Api$Provider$Practice$One$engagementThreshold = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ac3;
	});
var $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.afA;
	});
var $author$project$Api$Provider$Practice$One$passthroughFeesCutoffEnabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.afB;
	});
var $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agn;
	});
var $author$project$Api$Provider$Practice$One$requiresLocation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Ym;
	});
var $author$project$Api$Provider$Practice$One$requiresPatientEmail = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Yo;
	});
var $author$project$Api$Provider$Practice$One$requiresPatientMobile = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Yp;
	});
var $author$project$Api$Provider$Practice$One$requiresPractitioner = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Yr;
	});
var $author$project$Api$Provider$Practice$One$requiresSSN = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Ys;
	});
var $author$project$Api$Provider$Practice$One$ssnEnabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $._D;
	});
var $author$project$Pages$Admin$Patients$mapFormFields = function (practice) {
	return {
		ab$: $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice),
		ab7: $author$project$Api$Provider$Practice$One$collectLocationOnSignup(practice),
		Lg: $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice),
		Lh: $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice),
		acC: $author$project$Api$Provider$Practice$One$defaultPatientsPreferredLanguage(practice),
		acD: $author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter(practice),
		ac3: $elm$core$String$fromInt(
			$author$project$Api$Provider$Practice$One$engagementThreshold(practice)),
		afA: $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice),
		afB: $author$project$Api$Provider$Practice$One$passthroughFeesCutoffEnabled(practice),
		agj: $author$project$Api$Provider$Practice$One$requireGroupForLocations(practice),
		agn: $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies(practice),
		Ym: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
		Yo: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
		Yp: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
		Yr: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
		Ys: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
		_D: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
		$$: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice)
	};
};
var $author$project$Pages$Admin$Patients$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.D5;
		var _v3 = function () {
			var _v4 = $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice);
			if (!_v4.$) {
				var date = _v4.a;
				return _Utils_Tuple2(
					$author$project$Components$DateInput$initFromDate(date),
					$elm$core$Platform$Cmd$none);
			} else {
				return $author$project$Components$DateInput$init;
			}
		}();
		var dateInputModel = _v3.a;
		var dateInputMsg = _v3.b;
		var model = {
			D5: apiClient,
			l4: $jinjor$elm_debounce$Debounce$init,
			adm: $author$project$Pages$Admin$Patients$mapFormFields(practice),
			rQ: dateInputModel,
			WF: practice
		};
		return _Utils_Tuple2(
			model,
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(dateInputModel),
				dateInputMsg));
	});
var $author$project$Pages$Admin$Patients$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Patients$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Patients$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Patients$GotEnableResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDate = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Patients$EngagementThresholdDebounced = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Patients$debouncePriceCheck = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Pages$Admin$Patients$EngagementThresholdDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Pages$Admin$Patients$EngagementThresholdDebouncedMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(300),
	ahG: $author$project$Pages$Admin$Patients$EngagementThresholdDebouncedMsg
};
var $author$project$Pages$Admin$Patients$updateField = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						Lh: enabled ? 2 : fields.Lh,
						Ys: enabled
					});
			case 2:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						ab7: enabled ? 2 : fields.ab7,
						Ym: enabled
					});
			case 5:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						Lg: enabled ? 2 : fields.Lg,
						Yr: enabled
					});
			case 6:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						ab7: enabled ? fields.ab7 : 0,
						Ym: enabled && fields.Ym,
						$$: enabled
					});
			case 0:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{
						Lh: enabled ? fields.Lh : 0,
						Ys: enabled && fields.Ys,
						_D: enabled
					});
			case 7:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{ab$: enabled});
			case 3:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{Yo: enabled});
			case 4:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{Yp: enabled});
			case 8:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{agn: enabled});
			case 9:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{afB: enabled});
			case 10:
				var date = field.a;
				return _Utils_update(
					fields,
					{afA: date});
			case 11:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{agj: enabled});
			case 12:
				var threshold = field.a;
				return _Utils_update(
					fields,
					{ac3: threshold});
			case 13:
				var language = field.a;
				return _Utils_update(
					fields,
					{acC: language});
			default:
				var enabled = field.a;
				return _Utils_update(
					fields,
					{acD: enabled});
		}
	});
var $author$project$Api$CollectOnSignup$encoder = function (customType) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (customType) {
				case 0:
					return 'no';
				case 1:
					return 'optional';
				case 2:
					return 'require';
				case 3:
					return 'default';
				default:
					return 'yes';
			}
		}());
};
var $author$project$Api$Provider$Practice$updateSettings = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'ssn_enabled',
								$elm$json$Json$Encode$bool(fields._D)),
								_Utils_Tuple2(
								'requires_ssn',
								$elm$json$Json$Encode$bool(fields.Ys)),
								_Utils_Tuple2(
								'requires_patient_email',
								$elm$json$Json$Encode$bool(fields.Yo)),
								_Utils_Tuple2(
								'requires_patient_mobile',
								$elm$json$Json$Encode$bool(fields.Yp)),
								_Utils_Tuple2(
								'requires_practitioner',
								$elm$json$Json$Encode$bool(fields.Yr)),
								_Utils_Tuple2(
								'requires_location',
								$elm$json$Json$Encode$bool(fields.Ym)),
								_Utils_Tuple2(
								'require_default_location_for_companies',
								$elm$json$Json$Encode$bool(fields.agn)),
								_Utils_Tuple2(
								'require_group_for_locations',
								$elm$json$Json$Encode$bool(fields.agj)),
								_Utils_Tuple2(
								'track_patients_by_location',
								$elm$json$Json$Encode$bool(fields.$$)),
								_Utils_Tuple2(
								'charge_patients_credit_card_fees',
								$elm$json$Json$Encode$bool(fields.ab$)),
								_Utils_Tuple2(
								'passthrough_fees_cutoff_enabled',
								$elm$json$Json$Encode$bool(fields.afB)),
								_Utils_Tuple2(
								'passthrough_fees_cutoff_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.afA)),
								_Utils_Tuple2(
								'engagement_threshold',
								$elm$json$Json$Encode$int(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(fields.ac3)))),
								_Utils_Tuple2(
								'collect_ssn_on_signup',
								$author$project$Api$CollectOnSignup$encoder(fields.Lh)),
								_Utils_Tuple2(
								'collect_practitioner_on_signup',
								$author$project$Api$CollectOnSignup$encoder(fields.Lg)),
								_Utils_Tuple2(
								'collect_location_on_signup',
								$author$project$Api$CollectOnSignup$encoder(fields.ab7)),
								_Utils_Tuple2(
								'default_patients_preferred_language',
								$elm$json$Json$Encode$string(
									$author$project$Language$toValue(fields.acC))),
								_Utils_Tuple2(
								'default_to_active_patients_filter',
								$elm$json$Json$Encode$bool(fields.acD))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Patients$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newFields = A2(
					$author$project$Pages$Admin$Patients$updateField,
					field,
					$author$project$Pages$Admin$Patients$mapFormFields(model.WF));
				if (field.$ === 12) {
					var threshold = field.a;
					var updateSettingsCmd = ($elm$core$String$length(threshold) > 0) ? A3($author$project$Api$Provider$Practice$updateSettings, model.D5, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse) : $elm$core$Platform$Cmd$none;
					var _v2 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig, updateSettingsCmd, model.l4);
					var newDebouncer = _v2.a;
					var cmd = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{l4: newDebouncer, adm: newFields}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{adm: newFields}),
						A3($author$project$Api$Provider$Practice$updateSettings, model.D5, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse),
						_List_Nil);
				}
			case 1:
				var debounceMsg = msg.a;
				var _v3 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Pages$Admin$Patients$debouncePriceCheck),
					debounceMsg,
					model.l4);
				var newDebouncer = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l4: newDebouncer}),
					cmd,
					_List_Nil);
			case 2:
				var cmd = msg.a;
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 3:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var practice = response.a;
						var message = 'Your practice has been updated';
						var _v5 = function () {
							var _v6 = $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice);
							if (!_v6.$) {
								var date = _v6.a;
								return _Utils_Tuple2(
									$author$project$Components$DateInput$initFromDate(date),
									$elm$core$Platform$Cmd$none);
							} else {
								return $author$project$Components$DateInput$init;
							}
						}();
						var dateInputModel = _v5.a;
						var dateInputMsg = _v5.b;
						var newModel = _Utils_update(
							model,
							{
								adm: $author$project$Pages$Admin$Patients$mapFormFields(practice),
								rQ: dateInputModel,
								WF: practice
							});
						return _Utils_Tuple3(
							newModel,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(dateInputModel),
								dateInputMsg),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, message),
									$author$project$OutMsg$PracticeUpdated(response)
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									adm: $author$project$Pages$Admin$Patients$mapFormFields(model.WF)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var newFields = A2(
					$author$project$Pages$Admin$Patients$updateField,
					$author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees(true),
					model.adm);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{adm: newFields}),
					A3($author$project$Api$Provider$Practice$updateSettings, model.D5, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse),
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Provider$Practice$updateSettings, model.D5, model.adm, $author$project$Pages$Admin$Patients$GotEnableResponse),
					_List_Nil);
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v7 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
				var newDateInput = _v7.a;
				var subCmd = _v7.b;
				var event = _v7.c;
				var updatedDate = function () {
					if (event.$ === 1) {
						var date = event.a;
						return date;
					} else {
						return model.adm.afA;
					}
				}();
				var newFields = A2(
					$author$project$Pages$Admin$Patients$updateField,
					$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDate(updatedDate),
					model.adm);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{adm: newFields, rQ: newDateInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(newDateInput),
						subCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Patients$FieldChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Patients$PassthroughCreditCardFeesAgreeAndEnableClicked = {$: 4};
var $author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset = F5(
	function (offset, label, labelHelp, toggleSwitch, content) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(8 - offset),
							$author$project$Ui$FlexGrid$offset(offset)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_Nil),
						content)),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(4),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	});
var $author$project$Pages$Admin$Patients$settingToggleWithContent = F4(
	function (label, labelHelp, toggleSwitch, content) {
		return A5($author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset, 0, label, labelHelp, toggleSwitch, content);
	});
var $author$project$Pages$Admin$Patients$settingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A4($author$project$Pages$Admin$Patients$settingToggleWithContent, label, labelHelp, toggleSwitch, _List_Nil);
	});
var $author$project$Api$Feature$PassthroughCreditCardFees = 13;
var $author$project$Pages$Admin$Patients$showChargePatientsCreditCardFees = function (practice) {
	return A2($author$project$Api$Provider$Practice$One$featureEnabled, 13, practice) || ($author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice) || ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest'));
};
var $author$project$Ui$Icon$Disabled = 36;
var $author$project$Ui$Icon$OkCircle = 24;
var $author$project$Ui$Element$gap4 = $author$project$Ui$Element$Gap(4);
var $author$project$Ui$Panel$Subtle = {$: 4};
var $author$project$Ui$Panel$subtle = $author$project$Ui$Panel$Subtle;
var $author$project$Pages$Admin$Patients$viewExpandedWarningWell = F3(
	function (enabled, message, extraHtmlBody) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$view,
							_List_fromArray(
								[$author$project$Ui$Panel$subtle]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$body,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap4]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															enabled ? A2($author$project$Ui$Icon$view, _List_Nil, 36) : A2($author$project$Ui$Icon$view, _List_Nil, 24)
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(message),
															A2(
															$elm$core$Maybe$withDefault,
															$elm$html$Html$text(''),
															extraHtmlBody)
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateUpdateButtonClicked = {$: 5};
var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffEnabled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Patients$viewPassthroughFeesCutoff = F3(
	function (practice, fields, passthroughFeesCutoffDateInput) {
		if ($author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice)) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.afB),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$PassthroughFeesCutoffEnabled))
					]));
			var labelHelp = $elm$html$Html$text('When enabled, patients created prior to this date will not be surcharged for credit card fees.');
			var dateDirty = _Utils_eq(
				fields.afA,
				$author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice));
			return A5(
				$author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset,
				1,
				'Apply only to new patients',
				A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
				toggleSwitch,
				$elm$core$List$singleton(
					A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(passthroughFeesCutoffDateInput),
								A2(
									$author$project$Components$DateInput$view,
									_List_fromArray(
										[
											$author$project$Components$DateInput$value(fields.afA)
										]),
									passthroughFeesCutoffDateInput)),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Update cutoff date'},
								_List_fromArray(
									[
										$author$project$Ui$Button$styled(2),
										$author$project$Ui$Button$onClick($author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateUpdateButtonClicked),
										$author$project$Ui$Button$disabled(dateDirty)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Update Cutoff Date')
									]))
							]))));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Admin$Patients$viewChargePatientsCreditCardFees = F3(
	function (practice, fields, passthroughFeesCutoffDateInput) {
		if ($author$project$Pages$Admin$Patients$showChargePatientsCreditCardFees(practice)) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.ab$),
						$author$project$Ui$ToggleSwitch$disabled(!fields.ab$),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees))
					]));
			var labelHelp = $elm$html$Html$text('Patients paying with a credit card will be responsible for any applicable credit card fees.');
			return _List_fromArray(
				[
					A3(
					$author$project$Pages$Admin$Patients$settingToggle,
					'Surcharge patients for credit card fees',
					A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
					toggleSwitch),
					A3($author$project$Pages$Admin$Patients$viewPassthroughFeesCutoff, practice, fields, passthroughFeesCutoffDateInput),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Pages$Admin$Patients$viewExpandedWarningWell,
									!fields.ab$,
									' To enable this, you must first agree to our legal terms.',
									$elm$core$Maybe$Just(
										A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('By enabling this feature, I affirm that our surcharge policy will comply with applicable laws and credit card network regulations.')
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('I acknowledge that Hint Health is not responsible for compliance of our surcharge policy. Hint Health advises that we seek the advice of a competent attorney or accountant licensed to practice in our jurisdiction before implementing a surcharge policy.')
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$span(3)
																]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Button$view,
																	{abp: 'Agree and enable'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$pull(0),
																			$author$project$Ui$Button$disabled(fields.ab$),
																			$author$project$Ui$Button$styled(2),
																			$author$project$Ui$Button$onClick($author$project$Pages$Admin$Patients$PassthroughCreditCardFeesAgreeAndEnableClicked)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Agree & Enable')
																		]))
																]))
														]))
												]))))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$Patients$DefaultPreferredLanguage = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$LanguageInput$OnChange = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LanguageInput$onChange = $author$project$Components$LanguageInput$OnChange;
var $author$project$Components$LanguageInput$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$LanguageInput$value = $author$project$Components$LanguageInput$Value;
var $author$project$Language$fromString = function (string) {
	switch (string) {
		case 'en':
			return 0;
		case 'es':
			return 1;
		default:
			return 0;
	}
};
var $author$project$Components$LanguageInput$OptionsRecord = F2(
	function (value, onChange) {
		return {ae4: onChange, aaN: value};
	});
var $author$project$Components$LanguageInput$optionsToRecord = A2(
	$elm$core$List$foldl,
	F2(
		function (option, record) {
			if (!option.$) {
				var val = option.a;
				return _Utils_update(
					record,
					{
						aaN: $elm$core$Maybe$Just(val)
					});
			} else {
				var handler = option.a;
				return _Utils_update(
					record,
					{
						ae4: $elm$core$Maybe$Just(handler)
					});
			}
		}),
	A2($author$project$Components$LanguageInput$OptionsRecord, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
var $author$project$Components$LanguageInput$view = function (options) {
	var optionsRecord = $author$project$Components$LanguageInput$optionsToRecord(options);
	return A2(
		$author$project$Ui$Form$Select$view,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Language$toValue,
						A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Ui$Form$Select$value)),
					optionsRecord.aaN),
					A2(
					$elm$core$Maybe$map,
					$author$project$Ui$Form$Select$onChange,
					A2(
						$elm$core$Maybe$map,
						function (handler) {
							return A2($elm$core$Basics$composeL, handler, $author$project$Language$fromString);
						},
						optionsRecord.ae4))
				])),
		A2(
			$elm$core$List$map,
			function (option) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Language$toValue(option)),
					$author$project$Language$toLabel(option));
			},
			_List_fromArray(
				[$author$project$Language$english, $author$project$Language$spanish])));
};
var $author$project$Pages$Admin$Patients$viewDefaultPreferredLanguage = F2(
	function (practice, fields) {
		return A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice) ? A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Default preferred language'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelHelp(
									A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Default preferred language for new patients')
											]))),
									$author$project$Ui$Form$Group$labelSpan(10),
									$author$project$Ui$Form$Group$inputSpan(2),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('This language will be set, by default, on all new patients created. Changing the default language will not impact any existing patients language settings and will only be used moving forward.\n                            '))
								]),
							_List_fromArray(
								[
									$author$project$Components$LanguageInput$view(
									_List_fromArray(
										[
											$author$project$Components$LanguageInput$value(fields.acC),
											$author$project$Components$LanguageInput$onChange(
											A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Patients$DefaultPreferredLanguage, $author$project$Pages$Admin$Patients$FieldChanged))
										]))
								]))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Pages$Admin$Patients$DefaultToActivePatientsFilter = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Admin$Patients$viewDefaultToActivePatientsFilter = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.acD),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$DefaultToActivePatientsFilter))
			]));
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Whether or not the patient list will default to showing only active patients.')
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Default to active patients filter',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$SSNEnabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Patients$viewEnableSSN = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields._D),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$SSNEnabled))
			]));
	var labelHelp = fields._D ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Collection of SSN for patients is enabled')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To change signup SSN collection see ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Signup,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							]))
					]))
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Collection of SSN for patients is disabled')
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Enable SSN',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$EngagementThreshold = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$FeatureGate$EngagementTracking = 11;
var $author$project$Api$Provider$Practice$Shared$isAffiliate = function (_v0) {
	var record = _v0;
	return record.Rv;
};
var $author$project$Api$Provider$Practice$One$isAffiliate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$isAffiliate(shared);
};
var $author$project$Api$Provider$Practice$Shared$isNetwork = function (_v0) {
	var record = _v0;
	return record.RV;
};
var $author$project$Api$Provider$Practice$One$isNetwork = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$isNetwork(shared);
};
var $author$project$Pages$Admin$Patients$viewEngagementThreshold = F2(
	function (practice, fields) {
		var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
		var gateIsAvailable = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			11,
			$author$project$Api$Practice$Provider(practice));
		if (gateIsAvailable || practiceIsAffiliateOrNetwork) {
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('\n                        Set the number of months after receiving a service that the patient will\n                        switch from Currently Engaged to Previously Engaged.\n                        ')
					]));
			var disableInput = (!gateIsAvailable) && practiceIsAffiliateOrNetwork;
			var inputValue = disableInput ? '12' : fields.ac3;
			return A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$required(true),
										$author$project$Ui$Form$Group$label('Engagement Threshold'),
										$author$project$Ui$Form$Group$labelClass(''),
										$author$project$Ui$Form$Group$labelHelp(labelHelp),
										$author$project$Ui$Form$Group$clearfix,
										$author$project$Ui$Form$Group$labelSpan(10),
										$author$project$Ui$Form$Group$inputSpan(2)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$group(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(inputValue),
														$author$project$Ui$Form$Input$number,
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$EngagementThreshold)),
														$author$project$Ui$Form$Input$withFeedback(true),
														$author$project$Ui$Form$Input$disabled(disableInput)
													])),
												$author$project$Ui$Form$Input$addon(
												_List_fromArray(
													[
														$elm$html$Html$text('months')
													]))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$Practice$One$hasLocations = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.TU;
		},
		function ($) {
			return $.P8;
		}));
var $author$project$Pages$Admin$Patients$viewLocationsWarning = function (practice) {
	return ($author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice) && (!$author$project$Api$Provider$Practice$One$hasLocations(practice))) ? A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(12)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You are tracking patients by location but don\'t have any locations setup yet. Go ')
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Locations,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' to setup locations.')
									]))
							]))
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Pages$Admin$Patients$RequiresDefaultLocationForCompanies = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.P3;
	});
var $author$project$Pages$Admin$Patients$viewWarningWell = F2(
	function (enabled, message) {
		return A3(
			$author$project$Pages$Admin$Patients$viewExpandedWarningWell,
			enabled,
			message,
			$elm$core$Maybe$Just($author$project$Utils$Html$empty));
	});
var $author$project$Pages$Admin$Patients$viewRequireCompanyDefaultLocation = F2(
	function (practice, fields) {
		if (fields.$$) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.agn),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresDefaultLocationForCompanies)),
						$author$project$Ui$ToggleSwitch$disabled(
						$author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation(practice))
					]));
			var labelHelp = fields.agn ? A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text('A default location is required on all companies.')
					])) : A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('A default location can optionally be set on a company. When a patient is created without a location no location will be assigned. ')
							])),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Patients without a location assigned may not be synced to partners')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' until one is assigned.')
							]))
					]));
			return _List_fromArray(
				[
					A3(
					$author$project$Pages$Admin$Patients$settingToggle,
					'Require companies to have a default location',
					A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
					toggleSwitch),
					A2(
					$author$project$Pages$Admin$Patients$viewWarningWell,
					$author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation(practice),
					' To enable this, ensure that every company has a default location assigned.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$Patients$RequireGroupForLocations = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.P9;
	});
var $author$project$Pages$Admin$Patients$viewRequireGroupInLocations = F2(
	function (practice, fields) {
		if (fields.$$) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.agj),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequireGroupForLocations)),
						$author$project$Ui$ToggleSwitch$disabled(
						$author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup(practice))
					]));
			var labelHelp = fields.agj ? A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text('A group is required on all locations.')
					])) : A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('A group can optionally be set on a location. ')
							])),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Patient in locations without a group assigned may not be synced to partners')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' until one is assigned.')
							]))
					]));
			return _List_fromArray(
				[
					A3($author$project$Pages$Admin$Patients$settingToggle, 'Require every location to have a group assigned', labelHelp, toggleSwitch),
					A2(
					$author$project$Pages$Admin$Patients$viewWarningWell,
					$author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup(practice),
					' To enable this, ensure that every location has a group assigned.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Admin$Patients$RequiresLocation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Patients$viewRequireLocationSelection = F2(
	function (practice, fields) {
		if (fields.$$) {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.Ym),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresLocation)),
						$author$project$Ui$ToggleSwitch$disabled(
						!$author$project$Api$Provider$Practice$One$hasLocations(practice))
					]));
			var labelHelpRequiresLocation = $author$project$Api$Provider$Practice$One$requiresLocation(practice) ? A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Locations will be collected and required always.')
					])) : A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = fields.ab7;
						switch (_v0) {
							case 0:
								return $elm$html$Html$text('Locations are optional. If enabled, this will enforce collection on signup.');
							case 2:
								return $elm$html$Html$text('Locations are required during online signup.');
							default:
								return $elm$html$Html$text('');
						}
					}()
					]));
			var labelHelpHasLocations = (!$author$project$Api$Provider$Practice$One$hasLocations(practice)) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This practice has no locations. You need to add some ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Locations,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' to enable this feature.')
							]))
					])) : $elm$html$Html$text('');
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[labelHelpHasLocations, labelHelpRequiresLocation]));
			return A3(
				$author$project$Pages$Admin$Patients$settingToggle,
				'Require location selection for every patient',
				A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
				toggleSwitch);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Admin$Patients$RequiresPatientEmail = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Patients$viewRequirePatientEmailSelection = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.Yo),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPatientEmail))
			]));
	var labelHelp = fields.Yo ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Email is required when creating or updating any patient in app or on signup.')
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Email can be collected but is not required for all patients.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Email is required only for the primary member on signup.')
					]))
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Require email for every patient',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$RequiresPatientMobile = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Patients$viewRequirePatientMobileSelection = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.Yp),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPatientMobile))
			]));
	var labelHelp = fields.Yp ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Mobile phone is required when creating or updating any patient in app or on signup.')
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Mobile phone can be collected but is not required for all patients.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Any phone type is required only for the primary member on signup.')
					]))
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Require a mobile phone number for every patient',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$RequiresPractitioner = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Practice$One$hasPractitioners = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.TU;
		},
		function ($) {
			return $.Qe;
		}));
var $author$project$Pages$Admin$Patients$viewRequireProviderSelection = F2(
	function (practice, fields) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(fields.Yr),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPractitioner)),
					$author$project$Ui$ToggleSwitch$disabled(
					!$author$project$Api$Provider$Practice$One$hasPractitioners(practice))
				]));
		var labelHelp = fields.Yr ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Providers will be collected and required.')
				])) : ($author$project$Api$Provider$Practice$One$hasPractitioners(practice) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = fields.Lg;
							switch (_v0) {
								case 0:
									return $elm$html$Html$text('Providers will not be collected during signup.');
								case 1:
									return $elm$html$Html$text('Providers are optional during signup.');
								case 2:
									return $elm$html$Html$text('Providers are required during signup only.');
								default:
									return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If enabled, this will enforce collection. ')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Signup,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('See here')
								]))
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This practice has no providers. You need to add some')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Providers__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' to enable this feature.')
								]))
						]))
				])));
		return A3(
			$author$project$Pages$Admin$Patients$settingToggle,
			'Require provider selection for every patient',
			A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
			toggleSwitch);
	});
var $author$project$Pages$Admin$Patients$RequiresSSN = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Patients$viewRequireSSNSelection = function (fields) {
	if (fields._D) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(fields.Ys),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresSSN))
				]));
		var labelHelp = fields.Ys ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('When editing a patient, entering a SSN will be always required')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('SSN collection will be enforced on signup.')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('SSN on patients is optional.')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = fields.Lh;
							switch (_v0) {
								case 0:
									return $elm$html$Html$text('SSN collection is disabled on signup.');
								case 1:
									return $elm$html$Html$text('SSN collection is optional on signup.');
								case 2:
									return $elm$html$Html$text('SSN collection is required on signup.');
								default:
									return $elm$html$Html$text('');
							}
						}()
						]))
				]));
		return A3(
			$author$project$Pages$Admin$Patients$settingToggle,
			'Require SSN selection for every patient',
			A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
			toggleSwitch);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Admin$Patients$TrackPatientsByLocation = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Patients$viewTrackLocation = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.$$),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$TrackPatientsByLocation))
			]));
	var labelHelp = fields.$$ ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = fields.ab7;
						switch (_v0) {
							case 0:
								return $elm$html$Html$text('Locations for patients can be assigned but are not collected during signup.');
							case 2:
								return $elm$html$Html$text('Locations for patients can be assigned and are required during signup.');
							default:
								return $elm$html$Html$text('');
						}
					}()
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To change signup location collection see  ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Signup,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							]))
					]))
			])) : A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Location support is not enabled. If toggled, you can track patients by location.')
			]));
	return A3(
		$author$project$Pages$Admin$Patients$settingToggle,
		'Track patients by location',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$Patients$view = function (_v0) {
	var practice = _v0.WF;
	var fields = _v0.adm;
	var passthroughFeesCutoffDateInput = _v0.rQ;
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Patients')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$author$project$Pages$Admin$Patients$viewLocationsWarning(practice),
							A2(
								$elm$core$List$cons,
								$author$project$Pages$Admin$Patients$viewEnableSSN(fields),
								A2(
									$elm$core$List$cons,
									$author$project$Pages$Admin$Patients$viewRequireSSNSelection(fields),
									A2(
										$elm$core$List$cons,
										$author$project$Pages$Admin$Patients$viewRequirePatientEmailSelection(fields),
										A2(
											$elm$core$List$cons,
											$author$project$Pages$Admin$Patients$viewRequirePatientMobileSelection(fields),
											A2(
												$elm$core$List$cons,
												A2($author$project$Pages$Admin$Patients$viewRequireProviderSelection, practice, fields),
												_Utils_ap(
													A3($author$project$Pages$Admin$Patients$viewChargePatientsCreditCardFees, practice, fields, passthroughFeesCutoffDateInput),
													A2(
														$elm$core$List$cons,
														$author$project$Pages$Admin$Patients$viewTrackLocation(fields),
														A2(
															$elm$core$List$cons,
															A2($author$project$Pages$Admin$Patients$viewRequireLocationSelection, practice, fields),
															_Utils_ap(
																A2($author$project$Pages$Admin$Patients$viewRequireCompanyDefaultLocation, practice, fields),
																_Utils_ap(
																	A2($author$project$Pages$Admin$Patients$viewRequireGroupInLocations, practice, fields),
																	_List_fromArray(
																		[
																			A2($author$project$Pages$Admin$Patients$viewEngagementThreshold, practice, fields),
																			A2($author$project$Pages$Admin$Patients$viewDefaultPreferredLanguage, practice, fields),
																			$author$project$Pages$Admin$Patients$viewDefaultToActivePatientsFilter(fields)
																		])))))))))))))
					]))
			]),
		$G: 'Admin | Patient Settings'
	};
};
var $author$project$Pages$Admin$Patients$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Patients$init, aer: $author$project$Pages$Admin$Patients$load, agD: $author$project$Pages$Admin$Patients$save, ahd: $author$project$Pages$Admin$Patients$subscriptions, aaq: $author$project$Pages$Admin$Patients$update, ahP: $author$project$Pages$Admin$Patients$view});
var $author$project$Api$Provider$Report$PaymentMethodImport = 24;
var $author$project$Pages$Admin$PaymentMethodImport$Pending = 1;
var $author$project$Pages$Admin$PaymentMethodImport$StatusDropdownMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$GotPaymentMethodImports = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PaymentMethodMigration$All$PaymentMethodMigration = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentMethodMigration$One$PaymentMethodMigration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PaymentMethodMigration$Shared$PaymentMethodMigration = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentMethodMigration$Shared$Record = F7(
	function (id, status, sourceProcessor, migrationId, sourceCustomerId, sourcePaymentMethodId, description) {
		return {Nx: description, adR: id, TY: migrationId, _g: sourceCustomerId, _h: sourcePaymentMethodId, _i: sourceProcessor, ag7: status};
	});
var $author$project$Api$Provider$PaymentMethodMigration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'source_payment_method_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'source_customer_id',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'migration_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'source_processor',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$Shared$Record))))))));
var $author$project$Api$Provider$PaymentMethodMigration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentMethodMigration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentMethodMigration$One$Record = F2(
	function (owner, metadata) {
		return {TV: metadata, Vp: owner};
	});
var $author$project$Api$Common$Payable$Owner$Min$Owner = $elm$core$Basics$identity;
var $author$project$Api$Common$Payable$Owner$Min$Record = F3(
	function (id, name, type_) {
		return {adR: id, zh: name, ahI: type_};
	});
var $author$project$Api$Common$Payable$Owner$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Owner$Min$Record))));
var $author$project$Api$Common$Payable$Owner$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Payable$Owner$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentMethodMigration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'metadata',
	$elm$json$Json$Decode$value,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'owner',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$One$Record)));
var $author$project$Api$Provider$PaymentMethodMigration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentMethodMigration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PaymentMethodMigration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$One$PaymentMethodMigration)));
var $author$project$Api$Provider$PaymentMethodMigration$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentMethodMigration$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentMethodImport$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$PaymentMethodImport$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$PaymentMethodImport$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ag7;
				if (!_v0.$) {
					var status = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', status)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['payment_method_imports']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PaymentMethodImport$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PaymentMethodMigration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$PaymentMethodImport$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath)));
	});
var $author$project$Pages$Admin$PaymentMethodImport$statusOptionToValue = function (option) {
	switch (option) {
		case 1:
			return $elm$core$Maybe$Just('pending');
		case 2:
			return $elm$core$Maybe$Just('imported');
		case 3:
			return $elm$core$Maybe$Just('ignored');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations = F2(
	function (apiClient, model) {
		var optionals = function (d) {
			return _Utils_update(
				d,
				{
					afy: model.afy,
					ag1: model.ag1,
					ag7: $author$project$Pages$Admin$PaymentMethodImport$statusOptionToValue(model.ag7)
				});
		};
		return A3($author$project$Api$Provider$PaymentMethodImport$list, apiClient, optionals, $author$project$Pages$Admin$PaymentMethodImport$GotPaymentMethodImports);
	});
var $author$project$Pages$Admin$PaymentMethodImport$init = F4(
	function (session, _v0, shared, _v1) {
		var model = {
			D5: shared.D5,
			Eq: A3($author$project$Permission$canGoTo, session, shared.adN, 17),
			Er: A3($author$project$Permission$canGoTo, session, shared.adN, 44),
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 24}),
			d3: $elm$core$Maybe$Nothing,
			iP: $elm$core$Maybe$Nothing,
			FR: $author$project$Shared$isHintAdmin(shared),
			afy: $author$project$Api$Pagination$init,
			ch: $author$project$Api$Data$Loading,
			ag1: $author$project$Api$Sort$init,
			ag7: 1,
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'status-dropdown-filter', ahx: $author$project$Pages$Admin$PaymentMethodImport$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, shared.D5, model));
	});
var $author$project$Pages$Admin$PaymentMethodImport$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$PaymentMethodImport$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Close = {$: 0};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$PaymentMethodImport$ImportModal$Close);
};
var $author$project$Pages$Admin$PaymentMethodImport$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var paymentMethodMigration = _v0.a;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							$author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed(paymentMethodMigration));
					},
					model.d3)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg),
					A2(
						$elm$core$Maybe$map,
						function (importModal) {
							return $author$project$Components$Admin$PaymentMethodImport$ImportModal$subscriptions(importModal);
						},
						model.iP))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9))
			]));
};
var $author$project$Pages$Admin$PaymentMethodImport$GotIgnoreResponse = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$PaymentMethodMigration$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$id(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$id(one);
};
var $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath);
};
var $author$project$Api$Provider$PaymentMethodImport$ignore = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PaymentMethodMigration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['ignore']),
					$author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath(id))));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$Company$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$All$Company = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Shared$Company = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$Shared$Record = function (id) {
	return function (name) {
		return function (companyType) {
			return function (createdAt) {
				return function (periodInMonths) {
					return function (allowCustomMembershipPlan) {
						return function (postSignupButtonLabel) {
							return function (postSignupMessage) {
								return function (postSignupRedirectUrl) {
									return function (redirectsPostSignup) {
										return function (requiresEmployeeDivisions) {
											return function (showPostSignupFooterButton) {
												return function (customPostSignupPage) {
													return function (stripeLink) {
														return function (nextInvoiceDate) {
															return function (inactive) {
																return function (backBillPeriods) {
																	return function (limitBackBill) {
																		return function (billAffiliateRate) {
																			return {IV: allowCustomMembershipPlan, JP: backBillPeriods, JW: billAffiliateRate, LA: companyType, Mf: createdAt, MH: customPostSignupPage, adR: id, QR: inactive, SS: limitBackBill, zh: name, UF: nextInvoiceDate, Wc: periodInMonths, WB: postSignupButtonLabel, WC: postSignupMessage, WD: postSignupRedirectUrl, X1: redirectsPostSignup, Yl: requiresEmployeeDivisions, ZX: showPostSignupFooterButton, _X: stripeLink};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Company$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bill_affiliate_rate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'limit_back_bill',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'back_bill_periods',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'inactive',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'next_invoice_date',
					$elm$json$Json$Decode$maybe($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'stripe_link',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'custom_post_signup_page',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'show_post_signup_footer_button',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'requires_employee_divisions',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'redirects_post_signup',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'post_signup_redirect_url',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'post_signup_message',
												$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'post_signup_button_label',
													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'allow_custom_membership_plan',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'period_in_months',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'created_at',
																$elm_community$json_extra$Json$Decode$Extra$datetime,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'company_type',
																	$author$project$Api$Company$CompanyType$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'name',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$Shared$Record))))))))))))))))))));
var $author$project$Api$Provider$Company$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$All$Record = F8(
	function (status, flaggedNotesCount, usesEmployeeDivisions, eligibleCount, enrolledCount, needsApprovalCount, owedInCents, plans) {
		return {On: eligibleCount, OE: enrolledCount, Py: flaggedNotesCount, Un: needsApprovalCount, Vo: owedInCents, Wq: plans, ag7: status, aaF: usesEmployeeDivisions};
	});
var $author$project$Api$Provider$Company$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'plans',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Plan$Shared$decoder),
	A3(
		$author$project$Api$Expandable$expandable,
		'owed_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$author$project$Api$Expandable$expandable,
			'needs_approval_count',
			$elm$json$Json$Decode$int,
			A3(
				$author$project$Api$Expandable$expandable,
				'enrolled_count',
				$elm$json$Json$Decode$int,
				A3(
					$author$project$Api$Expandable$expandable,
					'eligible_count',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uses_employee_divisions',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'flagged_notes_count',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$All$Record)))))))));
var $author$project$Api$Provider$Company$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Company$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$All$Company)));
var $author$project$Api$Provider$Company$expandToString = function (expand) {
	switch (expand) {
		case 0:
			return 'plans';
		case 1:
			return 'eligible_count';
		case 2:
			return 'enrolled_count';
		case 3:
			return 'needs_approval_count';
		default:
			return 'owed_in_cents';
	}
};
var $author$project$Api$Provider$Company$listDefaults = {
	Fc: _List_Nil,
	Fi: $elm$core$Maybe$Nothing,
	adR: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	GH: $elm$core$Maybe$Nothing,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
	Hj: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Company$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Company$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Fi;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.GH;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'plans', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.Hj;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'sponsor_type', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Company$expandToString, options.Fc),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Company$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Company$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Company$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companiesPath)));
	});
var $author$project$Components$ResourceFilter$Company$list = $author$project$Api$Provider$Company$list;
var $author$project$Components$ResourceFilter$Company$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Company$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Company$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Company$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Company$selectId = 'companies';
var $author$project$Api$Provider$Company$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Company$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$Company$toTitle = $author$project$Api$Provider$Company$All$name;
var $author$project$Components$ResourceFilter$Company$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Company$toTitle(resource))
		]);
};
var $author$project$Api$Provider$Company$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Company$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$Company$toValue = $author$project$Api$Provider$Company$All$id;
var $author$project$Components$ResourceFilter$Company$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$Company$fetchResources, adR: $author$project$Components$ResourceFilter$Company$selectId, gx: 'Sponsor', st: $author$project$Components$ResourceFilter$Company$retrieveResource, ahw: $author$project$Components$ResourceFilter$Company$toLabel, ahA: $author$project$Components$ResourceFilter$Company$toTitle, g0: $author$project$Components$ResourceFilter$Company$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$Patient$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Patient$list = $author$project$Api$Provider$Patient$list;
var $author$project$Components$ResourceFilter$Patient$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Patient$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Patient$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Patient$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Api$Provider$Patient$Shared$age = function (_v0) {
	var shared = _v0;
	return shared.IK;
};
var $author$project$Api$Provider$Patient$All$age = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$age(shared);
};
var $author$project$Api$Provider$Patient$Shared$membershipStatus = function (_v0) {
	var shared = _v0;
	return shared.TL;
};
var $author$project$Api$Provider$Patient$All$membershipStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
};
var $author$project$Ui$Badge$SizeSm = {$: 2};
var $author$project$Ui$Badge$sm = $author$project$Ui$Badge$SizeSm;
var $author$project$Components$ResourceFilter$Patient$toLabel = function (resource) {
	return A2(
		$elm$core$List$intersperse,
		A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mr-2')
				]),
			_List_Nil),
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					$elm$html$Html$text(
						$author$project$Api$Provider$Patient$All$name(resource))),
					A2(
					$elm$core$Maybe$map,
					function (age) {
						return $elm$html$Html$text(age);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$fromInt,
						$author$project$Api$Provider$Patient$All$age(resource))),
					$elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Badge$fromString,
						_List_fromArray(
							[$author$project$Ui$Badge$sm]),
						$author$project$Api$Provider$Patient$All$membershipStatus(resource)))
				])));
};
var $author$project$Components$ResourceFilter$Patient$toTitle = function (resource) {
	return _Utils_ap(
		$author$project$Api$Provider$Patient$All$name(resource),
		_Utils_ap(
			function () {
				var _v0 = $author$project$Api$Provider$Patient$All$age(resource);
				if (!_v0.$) {
					var age = _v0.a;
					return ' - ' + $elm$core$String$fromInt(age);
				} else {
					return '';
				}
			}(),
			(!$elm$core$String$isEmpty(
				$author$project$Api$Provider$Patient$All$membershipStatus(resource))) ? (' - ' + $author$project$Formatters$String$humanize(
				$author$project$Api$Provider$Patient$All$membershipStatus(resource))) : ''));
};
var $author$project$Components$ResourceFilter$Patient$toValue = $author$project$Api$Provider$Patient$All$id;
var $author$project$Components$ResourceFilter$Patient$initWithId = F3(
	function (selectId_, apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$Patient$fetchResources, adR: selectId_, gx: 'Patient', st: $author$project$Components$ResourceFilter$Patient$retrieveResource, ahw: $author$project$Components$ResourceFilter$Patient$toLabel, ahA: $author$project$Components$ResourceFilter$Patient$toTitle, g0: $author$project$Components$ResourceFilter$Patient$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$Patient$selectId = 'patients';
var $author$project$Components$ResourceFilter$Patient$init = $author$project$Components$ResourceFilter$Patient$initWithId($author$project$Components$ResourceFilter$Patient$selectId);
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientOwnerType = 1;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$initFormFields = {ab9: $elm$core$Maybe$Nothing, QP: false, ef: 1, VM: $elm$core$Maybe$Nothing};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$init = F2(
	function (apiClient, paymentMethodMigration) {
		var _v0 = A2(
			$author$project$Components$ResourceFilter$Patient$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Patient'});
			});
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		var _v1 = A2(
			$author$project$Components$ResourceFilter$Company$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select an Employer'});
			});
		var companyResourceFilter = _v1.a;
		var companyResourceFilterCmd = _v1.b;
		return _Utils_Tuple2(
			{
				pV: companyResourceFilter,
				PB: $author$project$Utils$Form$init($author$project$Components$Admin$PaymentMethodImport$ImportModal$initFormFields),
				mt: $author$project$Api$Data$NotAsked,
				rU: patientResourceFilter,
				rV: paymentMethodMigration
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg, patientResourceFilterCmd)
					])));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Closed = 1;
var $author$project$Api$Provider$PaymentMethodImport$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$GotImportReponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Imported = 2;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$None = 0;
var $author$project$Api$Provider$PaymentMethodImport$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var ownerType = field.a;
				return _Utils_update(
					fields,
					{ef: ownerType});
			case 1:
				var company = field.a;
				return _Utils_update(
					fields,
					{ab9: company});
			case 2:
				var patient = field.a;
				return _Utils_update(
					fields,
					{VM: patient});
			default:
				var importAllForOwner = field.a;
				return _Utils_update(
					fields,
					{QP: importAllForOwner});
		}
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyValidation = 0;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$validateCompany = function (fields) {
	var _v0 = _Utils_Tuple2(fields.ef, fields.ab9);
	if (!_v0.a) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please select an employer.')
				]);
		} else {
			var _v3 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientValidation = 1;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$validatePatient = function (fields) {
	var _v0 = _Utils_Tuple2(fields.ef, fields.VM);
	if (_v0.a === 1) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please select a patient.')
				]);
		} else {
			var _v3 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$PaymentMethodImport$ImportModal$validatePatient),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$PaymentMethodImport$ImportModal$validateCompany)
		]));
var $author$project$Api$Provider$PaymentMethodImport$import_ = F4(
	function (apiClient, id, _v0, toMsg) {
		var owner = _v0.Vp;
		var importAllForOwner = _v0.QP;
		var _v1 = function () {
			if (!owner.$) {
				var patientId = owner.a;
				return _Utils_Tuple2('patient', patientId);
			} else {
				var companyId = owner.a;
				return _Utils_Tuple2('company', companyId);
			}
		}();
		var ownerType = _v1.a;
		var ownerId = _v1.b;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'owner',
					$author$project$Utils$Encode$typedAssociation(
						{
							adR: $elm$core$Maybe$Just(ownerId),
							ahI: $elm$core$Maybe$Just(ownerType)
						})),
					_Utils_Tuple2(
					'import_all_for_owner',
					$elm$json$Json$Encode$bool(importAllForOwner))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PaymentMethodMigration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['import']),
						$author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath(id)))));
	});
var $author$project$Components$ResourceFilter$Company$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$Patient$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 2:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var id = $author$project$Api$Provider$PaymentMethodMigration$All$id(model.rV);
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var ownerType = _v4.ef;
					var company = _v4.ab9;
					var patient = _v4.VM;
					var importAllForOwner = _v4.QP;
					var owner = function () {
						if (ownerType === 1) {
							var patientId = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$All$id, patient));
							return $author$project$Api$Provider$PaymentMethodImport$Patient(patientId);
						} else {
							var companyId = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$All$id, company));
							return $author$project$Api$Provider$PaymentMethodImport$Company(companyId);
						}
					}();
					var importParams = {QP: importAllForOwner, Vp: owner};
					return {
						EC: A4($author$project$Api$Provider$PaymentMethodImport$import_, apiClient, id, importParams, $author$project$Components$Admin$PaymentMethodImport$ImportModal$GotImportReponse),
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm, mt: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{mt: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully imported.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{mt: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pV);
				var newForm = function () {
					var _v7 = companyResourceResult.ac5;
					_v7$2:
					while (true) {
						if ((!_v7.$) && (!_v7.a.$)) {
							switch (_v7.a.a.$) {
								case 0:
									var company = _v7.a.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$Company(
											$elm$core$Maybe$Just(company)),
										model.PB);
								case 2:
									var _v8 = _v7.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$Company($elm$core$Maybe$Nothing),
										model.PB);
								default:
									break _v7$2;
							}
						} else {
							break _v7$2;
						}
					}
					return model.PB;
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg, companyResourceResult.EC),
					ac5: 0,
					y8: _Utils_update(
						model,
						{pV: companyResourceResult.y8, PB: newForm}),
					as: companyResourceResult.as
				};
			default:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rU);
				var newForm = function () {
					var _v9 = patientResourceResult.ac5;
					_v9$2:
					while (true) {
						if ((!_v9.$) && (!_v9.a.$)) {
							switch (_v9.a.a.$) {
								case 0:
									var patient = _v9.a.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient(
											$elm$core$Maybe$Just(patient)),
										model.PB);
								case 2:
									var _v10 = _v9.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate,
										$author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient($elm$core$Maybe$Nothing),
										model.PB);
								default:
									break _v9$2;
							}
						} else {
							break _v9$2;
						}
					}
					return model.PB;
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg, patientResourceResult.EC),
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm, rU: patientResourceResult.y8}),
					as: patientResourceResult.as
				};
		}
	});
var $author$project$Pages$Admin$PaymentMethodImport$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								ch: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ch: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: A2($author$project$Api$Pagination$update, subMsg, model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.D5, newModel),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.D5, newModel),
					_List_Nil);
			case 3:
				var paymentMethodMigration = msg.a;
				var _v2 = A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$init, model.D5, paymentMethodMigration);
				var importModal = _v2.a;
				var importModalCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iP: $elm$core$Maybe$Just(importModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg, importModalCmd),
					_List_Nil);
			case 4:
				var importModalMsg = msg.a;
				var _v3 = model.iP;
				if (!_v3.$) {
					var importModal = _v3.a;
					var importModalResult = A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$update, model.D5, importModalMsg, importModal);
					var _v4 = function () {
						var _v5 = importModalResult.ac5;
						switch (_v5) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(importModalResult.y8),
									model.ch,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ch, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.D5, model));
						}
					}();
					var newImportModal = _v4.a;
					var paymentMethodImports = _v4.b;
					var paymentMethodImportsCmd = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iP: newImportModal, ch: paymentMethodImports}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg, importModalResult.EC),
									paymentMethodImportsCmd
								])),
						importModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var paymentMethodMigration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d3: $elm$core$Maybe$Just(
								_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var paymentMethodMigration = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$PaymentMethodMigration$All$id(paymentMethodMigration);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								d3: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$PaymentMethodImport$ignore,
							model.D5,
							id,
							$author$project$Pages$Admin$PaymentMethodImport$GotIgnoreResponse(paymentMethodMigration)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d3: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var paymentMethodMigration = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d3: $elm$core$Maybe$Nothing, ch: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.D5, model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully ignored.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								d3: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var dropdown = _v7.a;
				var dropdownCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 9:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						ch: $author$project$Api$Data$Loading,
						ag7: status
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.D5, newModel),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v8 = A3($author$project$Components$ExportCsv$update, model.D5, subMsg, model.l9);
				var exportCsv = _v8.a;
				var subCmd = _v8.b;
				var subOutMsgs = _v8.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg, subCmd),
					subOutMsgs);
		}
	});
var $author$project$Pages$Admin$PaymentMethodImport$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$paymentMethodImportsColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, '', false, 'Status'),
		A3($author$project$Api$Column$init, '', false, 'Owner'),
		A3($author$project$Api$Column$init, '', false, 'Source Processor'),
		A3($author$project$Api$Column$init, '', false, 'Migration ID'),
		A3($author$project$Api$Column$init, '', false, 'Source Customer ID'),
		A3($author$project$Api$Column$init, '', false, 'Source Payment Method ID'),
		A3($author$project$Api$Column$init, '', false, 'Description'),
		A3($author$project$Api$Column$init, '', false, 'Metadata')
	]);
var $author$project$Components$ExportCsv$Report = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ExportCsv$report = $author$project$Components$ExportCsv$Report;
var $author$project$Api$Data$totalCount = function (data) {
	if (data.$ === 3) {
		var headers = data.b;
		return A2(
			$elm$core$Maybe$andThen,
			$elm$core$String$toInt,
			A2($elm$core$Dict$get, 'x-total-count', headers));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyOwnerType = 0;
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Import = {$: 2};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$ImportAllForOwner = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceCustomerId = function (_v0) {
	var record = _v0;
	return record._g;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$sourceCustomerId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceCustomerId(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$sourceCustomerId(one);
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourcePaymentMethodId = function (_v0) {
	var record = _v0;
	return record._h;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$sourcePaymentMethodId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourcePaymentMethodId(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$sourcePaymentMethodId(one);
};
var $author$project$Components$ResourceFilter$Company$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewCompanyResourceFilter = F2(
	function (companyResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Company$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]),
				companyResourceFilter));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$OwnerType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton = F3(
	function (currentOwnerType, ownerType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select owner type ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentOwnerType, ownerType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated(
						$author$project$Components$Admin$PaymentMethodImport$ImportModal$OwnerType(ownerType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$ResourceFilter$Patient$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewPatientResourceFilter = F2(
	function (patientResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Patient$view,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]),
				patientResourceFilter));
	});
var $author$project$Components$Admin$PaymentMethodImport$ImportModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$PaymentMethodImport$ImportModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Import Payment Method '),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId(model.rV)))
							]))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Admin$PaymentMethodImport$ImportModal$Import),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Owner Type'),
										$author$project$Ui$Form$Group$labelSpan(3),
										$author$project$Ui$Form$Group$inputSpan(9)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Button$group(
										_List_fromArray(
											[
												A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton, fields.ef, 1, 'Patient'),
												A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton, fields.ef, 0, 'Employer')
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Owner'),
										$author$project$Ui$Form$Group$labelSpan(3),
										$author$project$Ui$Form$Group$inputSpan(9),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										function () {
										var _v1 = fields.ef;
										if (_v1 === 1) {
											return A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewPatientResourceFilter, model.rU, model.PB);
										} else {
											return A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewCompanyResourceFilter, model.pV, model.PB);
										}
									}()
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpan(3),
										$author$project$Ui$Form$Group$inputSpan(9),
										$author$project$Ui$Form$Group$label('')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Checkbox$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Checkbox$value(fields.QP),
												$author$project$Ui$Form$Checkbox$onCheck(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated, $author$project$Components$Admin$PaymentMethodImport$ImportModal$ImportAllForOwner))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Apply same owner for all '),
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													$author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId(model.rV)))
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel action'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Admin$PaymentMethodImport$ImportModal$Close)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Import payment method'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Components$Admin$PaymentMethodImport$ImportModal$Import),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
												$author$project$Ui$Button$loading(
												_Utils_eq(model.mt, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Import')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$PaymentMethodImport$Ignore = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$Import = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$description(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$description = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$description(one);
};
var $author$project$Api$Common$Payable$Owner$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$metadata = function (_v0) {
	var record = _v0.b;
	return record.TV;
};
var $author$project$Api$Provider$PaymentMethodMigration$All$metadata = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$metadata(one);
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$migrationId = function (_v0) {
	var record = _v0;
	return record.TY;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$migrationId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$migrationId(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$migrationId = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$migrationId(one);
};
var $author$project$Api$Common$Payable$Owner$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$owner = function (_v0) {
	var record = _v0.b;
	return record.Vp;
};
var $author$project$Api$Provider$PaymentMethodMigration$All$owner = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$owner(one);
};
var $the_sett$elm_pretty_printer$Pretty$Text = function (a) {
	return {$: 3, a: a};
};
var $the_sett$elm_pretty_printer$Pretty$string = $the_sett$elm_pretty_printer$Pretty$Text;
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$boolToDoc = function (bool) {
	return bool ? $the_sett$elm_pretty_printer$Pretty$string('true') : $the_sett$elm_pretty_printer$Pretty$string('false');
};
var $the_sett$elm_pretty_printer$Pretty$Concatenate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $the_sett$elm_pretty_printer$Pretty$append = F2(
	function (doc1, doc2) {
		return A2(
			$the_sett$elm_pretty_printer$Pretty$Concatenate,
			function (_v0) {
				return doc1;
			},
			function (_v1) {
				return doc2;
			});
	});
var $the_sett$elm_pretty_printer$Pretty$char = function (c) {
	return $the_sett$elm_pretty_printer$Pretty$Text(
		$elm$core$String$fromChar(c));
};
var $the_sett$elm_pretty_printer$Pretty$Line = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $the_sett$elm_pretty_printer$Pretty$line = A2($the_sett$elm_pretty_printer$Pretty$Line, ' ', '');
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBracket = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$line,
	$the_sett$elm_pretty_printer$Pretty$char(']'));
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$commaLine = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$char(','),
	$the_sett$elm_pretty_printer$Pretty$line);
var $the_sett$elm_pretty_printer$Pretty$Empty = {$: 0};
var $the_sett$elm_pretty_printer$Pretty$empty = $the_sett$elm_pretty_printer$Pretty$Empty;
var $the_sett$elm_pretty_printer$Pretty$join = F2(
	function (sep, docs) {
		join:
		while (true) {
			if (!docs.b) {
				return $the_sett$elm_pretty_printer$Pretty$empty;
			} else {
				if (!docs.a.$) {
					var _v1 = docs.a;
					var ds = docs.b;
					var $temp$sep = sep,
						$temp$docs = ds;
					sep = $temp$sep;
					docs = $temp$docs;
					continue join;
				} else {
					var d = docs.a;
					var ds = docs.b;
					var step = F2(
						function (x, rest) {
							if (!x.$) {
								return rest;
							} else {
								var doc = x;
								return A2(
									$the_sett$elm_pretty_printer$Pretty$append,
									sep,
									A2($the_sett$elm_pretty_printer$Pretty$append, doc, rest));
							}
						});
					var spersed = A3($elm$core$List$foldr, step, $the_sett$elm_pretty_printer$Pretty$empty, ds);
					return A2($the_sett$elm_pretty_printer$Pretty$append, d, spersed);
				}
			}
		}
	});
var $the_sett$elm_pretty_printer$Pretty$Nest = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $the_sett$elm_pretty_printer$Pretty$nest = F2(
	function (depth, doc) {
		return A2(
			$the_sett$elm_pretty_printer$Pretty$Nest,
			depth,
			function (_v0) {
				return doc;
			});
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$openBracket = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$char('['),
	$the_sett$elm_pretty_printer$Pretty$line);
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$listToDoc = F2(
	function (indent, list) {
		return $elm$core$List$isEmpty(list) ? $the_sett$elm_pretty_printer$Pretty$string('[]') : A2(
			$the_sett$elm_pretty_printer$Pretty$append,
			A2(
				$the_sett$elm_pretty_printer$Pretty$nest,
				indent,
				A2(
					$the_sett$elm_pretty_printer$Pretty$append,
					$ThinkAlexandria$elm_pretty_print_json$Json$Print$openBracket,
					A2($the_sett$elm_pretty_printer$Pretty$join, $ThinkAlexandria$elm_pretty_print_json$Json$Print$commaLine, list))),
			$ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBracket);
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$nullToDoc = function (maybeDoc) {
	if (!maybeDoc.$) {
		var doc = maybeDoc.a;
		return doc;
	} else {
		return $the_sett$elm_pretty_printer$Pretty$string('null');
	}
};
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$numberToDoc = function (num) {
	return $the_sett$elm_pretty_printer$Pretty$string(
		$elm$core$String$fromFloat(num));
};
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBrace = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$line,
	$the_sett$elm_pretty_printer$Pretty$char('}'));
var $the_sett$elm_pretty_printer$Pretty$space = $the_sett$elm_pretty_printer$Pretty$char(' ');
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$colonSpace = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$char(':'),
	$the_sett$elm_pretty_printer$Pretty$space);
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$openBrace = A2(
	$the_sett$elm_pretty_printer$Pretty$append,
	$the_sett$elm_pretty_printer$Pretty$char('{'),
	$the_sett$elm_pretty_printer$Pretty$line);
var $the_sett$elm_pretty_printer$Pretty$surround = F3(
	function (left, right, doc) {
		return A2(
			$the_sett$elm_pretty_printer$Pretty$append,
			A2($the_sett$elm_pretty_printer$Pretty$append, left, doc),
			right);
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc = function (s) {
	return A3(
		$the_sett$elm_pretty_printer$Pretty$surround,
		$the_sett$elm_pretty_printer$Pretty$char('\"'),
		$the_sett$elm_pretty_printer$Pretty$char('\"'),
		$the_sett$elm_pretty_printer$Pretty$string(s));
};
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$objectToDoc = F2(
	function (indent, pairs) {
		return $elm$core$List$isEmpty(pairs) ? $the_sett$elm_pretty_printer$Pretty$string('{}') : A2(
			$the_sett$elm_pretty_printer$Pretty$append,
			A2(
				$the_sett$elm_pretty_printer$Pretty$nest,
				indent,
				A2(
					$the_sett$elm_pretty_printer$Pretty$append,
					$ThinkAlexandria$elm_pretty_print_json$Json$Print$openBrace,
					A2(
						$the_sett$elm_pretty_printer$Pretty$join,
						A2(
							$the_sett$elm_pretty_printer$Pretty$append,
							$the_sett$elm_pretty_printer$Pretty$char(','),
							$the_sett$elm_pretty_printer$Pretty$line),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var key = _v0.a;
								var doc = _v0.b;
								return A2(
									$the_sett$elm_pretty_printer$Pretty$append,
									$ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc(key),
									A2($the_sett$elm_pretty_printer$Pretty$append, $ThinkAlexandria$elm_pretty_print_json$Json$Print$colonSpace, doc));
							},
							pairs)))),
			$ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBrace);
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc = function (indent) {
	return A2(
		$elm$json$Json$Decode$map,
		$ThinkAlexandria$elm_pretty_print_json$Json$Print$nullToDoc,
		$elm$json$Json$Decode$maybe(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc, $elm$json$Json$Decode$string),
						A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$numberToDoc, $elm$json$Json$Decode$float),
						A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$boolToDoc, $elm$json$Json$Decode$bool),
						A2(
						$elm$json$Json$Decode$map,
						$ThinkAlexandria$elm_pretty_print_json$Json$Print$listToDoc(indent),
						$elm$json$Json$Decode$lazy(
							function (_v0) {
								return $elm$json$Json$Decode$list(
									$ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent));
							})),
						A2(
						$elm$json$Json$Decode$map,
						$ThinkAlexandria$elm_pretty_print_json$Json$Print$objectToDoc(indent),
						$elm$json$Json$Decode$lazy(
							function (_v1) {
								return $elm$json$Json$Decode$keyValuePairs(
									$ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent));
							}))
					]))));
};
var $the_sett$elm_pretty_printer$Pretty$NLine = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $the_sett$elm_pretty_printer$Pretty$NNil = {$: 0};
var $the_sett$elm_pretty_printer$Pretty$NText = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $the_sett$elm_pretty_printer$Pretty$fits = F2(
	function (w, normal) {
		fits:
		while (true) {
			if (w < 0) {
				return false;
			} else {
				switch (normal.$) {
					case 0:
						return true;
					case 1:
						var text = normal.a;
						var innerNormal = normal.b;
						var $temp$w = w - $elm$core$String$length(text),
							$temp$normal = innerNormal(0);
						w = $temp$w;
						normal = $temp$normal;
						continue fits;
					default:
						return true;
				}
			}
		}
	});
var $the_sett$elm_pretty_printer$Pretty$better = F4(
	function (w, k, doc, doc2Fn) {
		return A2($the_sett$elm_pretty_printer$Pretty$fits, w - k, doc) ? doc : doc2Fn(0);
	});
var $the_sett$elm_pretty_printer$Pretty$best = F3(
	function (width, startCol, x) {
		var be = F3(
			function (w, k, docs) {
				be:
				while (true) {
					if (!docs.b) {
						return $the_sett$elm_pretty_printer$Pretty$NNil;
					} else {
						switch (docs.a.b.$) {
							case 0:
								var _v1 = docs.a;
								var i = _v1.a;
								var _v2 = _v1.b;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = ds;
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
							case 1:
								var _v3 = docs.a;
								var i = _v3.a;
								var _v4 = _v3.b;
								var doc = _v4.a;
								var doc2 = _v4.b;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										i,
										doc(0)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											i,
											doc2(0)),
										ds));
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
							case 2:
								var _v5 = docs.a;
								var i = _v5.a;
								var _v6 = _v5.b;
								var j = _v6.a;
								var doc = _v6.b;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										i + j,
										doc(0)),
									ds);
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
							case 3:
								var _v7 = docs.a;
								var i = _v7.a;
								var text = _v7.b.a;
								var ds = docs.b;
								return A2(
									$the_sett$elm_pretty_printer$Pretty$NText,
									text,
									function (_v8) {
										return A3(
											be,
											w,
											k + $elm$core$String$length(text),
											ds);
									});
							case 4:
								var _v9 = docs.a;
								var i = _v9.a;
								var _v10 = _v9.b;
								var vsep = _v10.b;
								var ds = docs.b;
								return A3(
									$the_sett$elm_pretty_printer$Pretty$NLine,
									i,
									vsep,
									function (_v11) {
										return A3(
											be,
											w,
											i + $elm$core$String$length(vsep),
											ds);
									});
							case 5:
								var _v12 = docs.a;
								var i = _v12.a;
								var _v13 = _v12.b;
								var doc = _v13.a;
								var doc2 = _v13.b;
								var ds = docs.b;
								return A4(
									$the_sett$elm_pretty_printer$Pretty$better,
									w,
									k,
									A3(
										be,
										w,
										k,
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(i, doc),
											ds)),
									function (_v14) {
										return A3(
											be,
											w,
											k,
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(i, doc2),
												ds));
									});
							case 6:
								var _v15 = docs.a;
								var i = _v15.a;
								var fn = _v15.b.a;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										i,
										fn(i)),
									ds);
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
							default:
								var _v16 = docs.a;
								var i = _v16.a;
								var fn = _v16.b.a;
								var ds = docs.b;
								var $temp$w = w,
									$temp$k = k,
									$temp$docs = A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										i,
										fn(k)),
									ds);
								w = $temp$w;
								k = $temp$k;
								docs = $temp$docs;
								continue be;
						}
					}
				}
			});
		return A3(
			be,
			width,
			startCol,
			_List_fromArray(
				[
					_Utils_Tuple2(0, x)
				]));
	});
var $the_sett$elm_pretty_printer$Pretty$copy = F2(
	function (i, s) {
		return (!i) ? '' : _Utils_ap(
			s,
			A2($the_sett$elm_pretty_printer$Pretty$copy, i - 1, s));
	});
var $the_sett$elm_pretty_printer$Pretty$layout = function (normal) {
	var layoutInner = F2(
		function (normal2, acc) {
			layoutInner:
			while (true) {
				switch (normal2.$) {
					case 0:
						return acc;
					case 1:
						var text = normal2.a;
						var innerNormal = normal2.b;
						var $temp$normal2 = innerNormal(0),
							$temp$acc = A2($elm$core$List$cons, text, acc);
						normal2 = $temp$normal2;
						acc = $temp$acc;
						continue layoutInner;
					default:
						var i = normal2.a;
						var sep = normal2.b;
						var innerNormal = normal2.c;
						var norm = innerNormal(0);
						if (norm.$ === 2) {
							var $temp$normal2 = innerNormal(0),
								$temp$acc = A2($elm$core$List$cons, '\n' + sep, acc);
							normal2 = $temp$normal2;
							acc = $temp$acc;
							continue layoutInner;
						} else {
							var $temp$normal2 = innerNormal(0),
								$temp$acc = A2(
								$elm$core$List$cons,
								'\n' + (A2($the_sett$elm_pretty_printer$Pretty$copy, i, ' ') + sep),
								acc);
							normal2 = $temp$normal2;
							acc = $temp$acc;
							continue layoutInner;
						}
				}
			}
		});
	return $elm$core$String$concat(
		$elm$core$List$reverse(
			A2(layoutInner, normal, _List_Nil)));
};
var $the_sett$elm_pretty_printer$Pretty$pretty = F2(
	function (w, doc) {
		return $the_sett$elm_pretty_printer$Pretty$layout(
			A3($the_sett$elm_pretty_printer$Pretty$best, w, 0, doc));
	});
var $ThinkAlexandria$elm_pretty_print_json$Json$Print$prettyValue = F2(
	function (_v0, json) {
		var columns = _v0.Ll;
		var indent = _v0.ad_;
		return A2(
			$elm$core$Result$mapError,
			$elm$json$Json$Decode$errorToString,
			A2(
				$elm$core$Result$map,
				$the_sett$elm_pretty_printer$Pretty$pretty(columns),
				A2(
					$elm$json$Json$Decode$decodeValue,
					$ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent),
					json)));
	});
var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceProcessor = function (_v0) {
	var record = _v0;
	return record._i;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$sourceProcessor = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceProcessor(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$sourceProcessor = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$sourceProcessor(one);
};
var $author$project$Api$Provider$PaymentMethodMigration$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$PaymentMethodMigration$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PaymentMethodMigration$Shared$status(shared);
};
var $author$project$Api$Provider$PaymentMethodMigration$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PaymentMethodMigration$One$status(one);
};
var $author$project$Api$Common$Payable$Owner$Min$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Pages$Admin$PaymentMethodImport$viewPaymentMethodImport = F3(
	function (canGoToPatients, canGoToCompany, paymentMethodMigration) {
		var owner = $author$project$Api$Provider$PaymentMethodMigration$All$owner(paymentMethodMigration);
		var ownerName = A2(
			$elm$core$Maybe$withDefault,
			'N/A',
			A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, owner));
		var ownerPath = A2(
			$elm$core$Maybe$andThen,
			function (owner_) {
				var _v1 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
				switch (_v1) {
					case 'Patient':
						return canGoToPatients ? $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
								{
									VN: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
								})) : $elm$core$Maybe$Nothing;
					case 'Company':
						return canGoToCompany ? $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
								{
									ff: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
								})) : $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			owner);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (!ownerPath.$) {
								var ownerPath_ = ownerPath.a;
								return A3(
									$author$project$Ui$Link$route,
									ownerPath_,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(ownerName)
										]));
							} else {
								return $elm$html$Html$text(ownerName);
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$PaymentMethodMigration$All$sourceProcessor(paymentMethodMigration))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$PaymentMethodMigration$All$migrationId(paymentMethodMigration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId(paymentMethodMigration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId(paymentMethodMigration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								$author$project$Api$Provider$PaymentMethodMigration$All$description(paymentMethodMigration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$pre,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'max-width', '400px'),
									A2($elm$html$Html$Attributes$style, 'max-height', '100px')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Result$withDefault,
										'',
										A2(
											$ThinkAlexandria$elm_pretty_print_json$Json$Print$prettyValue,
											{Ll: 10, ad_: 2},
											$author$project$Api$Provider$PaymentMethodMigration$All$metadata(paymentMethodMigration))))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$pull(1)
								]),
							_List_fromArray(
								[
									(($author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'missing_in_hint') || ($author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'ignored')) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Import payment method'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$size(0),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$PaymentMethodImport$Import(paymentMethodMigration)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Import')
										])) : $author$project$Utils$Html$empty,
									($author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'missing_in_hint') ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Ignore payment method'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$size(0),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$PaymentMethodImport$Ignore(paymentMethodMigration)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ignore')
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$PaymentMethodImport$All = 0;
var $author$project$Pages$Admin$PaymentMethodImport$Ignored = 3;
var $author$project$Pages$Admin$PaymentMethodImport$Imported = 2;
var $author$project$Pages$Admin$PaymentMethodImport$StatusFiltered = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel = function (option) {
	switch (option) {
		case 1:
			return 'Pending';
		case 2:
			return 'Imported';
		case 3:
			return 'Ignored';
		default:
			return 'All';
	}
};
var $author$project$Pages$Admin$PaymentMethodImport$statusDropdownOptions = function (currentStatusOption) {
	var statusOptionToItem = function (option) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentStatusOption, option)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Admin$PaymentMethodImport$StatusFiltered(option))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel(option)));
	};
	return A2(
		$elm$core$List$cons,
		statusOptionToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				statusOptionToItem,
				_List_fromArray(
					[1, 2, 3]))));
};
var $author$project$Pages$Admin$PaymentMethodImport$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel(model.ag7))
			]),
		$author$project$Pages$Admin$PaymentMethodImport$statusDropdownOptions(model.ag7),
		model.oA);
};
var $author$project$Pages$Admin$PaymentMethodImport$viewBody = function (model) {
	var _v0 = function () {
		var _v1 = model.ch;
		if (_v1.$ === 3) {
			var paymentMethodImports_ = _v1.a;
			return _Utils_Tuple2(false, paymentMethodImports_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var paymentMethodImports = _v0.b;
	return _List_fromArray(
		[
			function () {
			var _v2 = model.iP;
			if (!_v2.$) {
				var importModal = _v2.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg,
					$author$project$Components$Admin$PaymentMethodImport$ImportModal$view(importModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.d3;
			if (!_v3.$) {
				var _v4 = _v3.a;
				var paymentMethodMigration = _v4.a;
				var ignoreRequest = _v4.b;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed(paymentMethodMigration),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('ignore'),
							$author$project$Components$HiConfirm$noun('payment method migration'),
							$author$project$Components$HiConfirm$loading(
							_Utils_eq(ignoreRequest, $author$project$Api$Data$Loading)),
							$author$project$Components$HiConfirm$customMessage(
							_List_fromArray(
								[
									$elm$html$Html$text('You are about to ignore this payment method migration. You can review and import ignored payment methods later.')
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg,
			A3(
				$author$project$Components$ExportCsv$modal,
				model.D5,
				_List_fromArray(
					[
						$author$project$Components$ExportCsv$report(
						$author$project$Api$Data$totalCount(model.ch))
					]),
				model.l9)),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Payment Method Import')
								]))
						])),
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(4)
										]),
									_List_fromArray(
										[
											$author$project$Pages$Admin$PaymentMethodImport$viewStatusDropdown(model)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Table$view,
							_List_fromArray(
								[
									$author$project$Ui$Table$loading(loading),
									$author$project$Ui$Table$zeroState(
									_List_fromArray(
										[
											$elm$html$Html$text('All payment methods are migrated to Hint Payments!')
										]))
								]),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									$author$project$Api$Column$view(
										A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$PaymentMethodImport$SortTable)),
									$author$project$Pages$Admin$PaymentMethodImport$paymentMethodImportsColumns),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$pull(1)
													]),
												_List_fromArray(
													[
														A2($elm$html$Html$map, $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg, $author$project$Components$ExportCsv$button),
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload,
														_List_fromArray(
															[
																$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$upload),
																$author$project$Ui$Link$ariaLabel('Import from CSV')
															]),
														_List_Nil)
													]))
											]))
									])),
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Admin$PaymentMethodImport$viewPaymentMethodImport, model.Er, model.Eq),
								paymentMethodImports),
							_List_Nil)
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Admin$PaymentMethodImport$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.afy))
						]))
				]))
		]);
};
var $author$project$Pages$Admin$PaymentMethodImport$view = function (model) {
	return {
		e5: $author$project$Pages$Admin$PaymentMethodImport$viewBody(model),
		$G: 'Admin | Payment Method Import'
	};
};
var $author$project$Pages$Admin$PaymentMethodImport$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$PaymentMethodImport$init, aer: $author$project$Pages$Admin$PaymentMethodImport$load, agD: $author$project$Pages$Admin$PaymentMethodImport$save, ahd: $author$project$Pages$Admin$PaymentMethodImport$subscriptions, aaq: $author$project$Pages$Admin$PaymentMethodImport$update, ahP: $author$project$Pages$Admin$PaymentMethodImport$view});
var $author$project$Api$Upload$Resource$PaymentMethodImport = 6;
var $author$project$Pages$Admin$PaymentMethodImport$Upload$UploadFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$PaymentMethodImport$Upload$init = F4(
	function (_v0, _v1, shared, _v2) {
		var _v3 = A4($author$project$Components$Upload$Form$init, shared.Hy, shared.D5, 6, $elm$core$Maybe$Nothing);
		var uploadForm = _v3.a;
		var uploadFormCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: uploadForm},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
	});
var $author$project$Pages$Admin$PaymentMethodImport$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$PaymentMethodImport$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$PaymentMethodImport$Upload$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Upload$Form$subscriptions(model.PB));
};
var $author$project$Pages$Admin$PaymentMethodImport$Upload$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Upload$Form$update, model.D5, subMsg, model.PB);
		var uploadForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: uploadForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsgs);
	});
var $author$project$Pages$Admin$PaymentMethodImport$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$titleWithButton,
						_List_fromArray(
							[
								$elm$html$Html$text('Upload Payment Method Imports')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$pull(1)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 2)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$identity,
						A2($author$project$Components$Upload$Form$view, model.D5, model.PB))
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_fromArray(
					[$author$project$Ui$Element$justifyCenter]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
						_List_fromArray(
							[$author$project$Ui$Link$buttonDefault]),
						_List_fromArray(
							[
								$elm$html$Html$text('Back')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$PaymentMethodImport$Upload$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A2($author$project$Components$Upload$Form$modal, model.D5, model.PB)),
				$author$project$Pages$Admin$PaymentMethodImport$Upload$viewBody(model)
			]),
		$G: 'Admin | Payment Method Import'
	};
};
var $author$project$Pages$Admin$PaymentMethodImport$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$PaymentMethodImport$Upload$init, aer: $author$project$Pages$Admin$PaymentMethodImport$Upload$load, agD: $author$project$Pages$Admin$PaymentMethodImport$Upload$save, ahd: $author$project$Pages$Admin$PaymentMethodImport$Upload$subscriptions, aaq: $author$project$Pages$Admin$PaymentMethodImport$Upload$update, ahP: $author$project$Pages$Admin$PaymentMethodImport$Upload$view});
var $author$project$Pages$Admin$PaymentProcessing$PaymentProcessingMsg = $elm$core$Basics$identity;
var $author$project$Components$PaymentProcessing$CreateAccount = {$: 2};
var $author$project$Components$PaymentProcessing$GotRainforestAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus = function (a) {
	return {$: 44, a: a};
};
var $author$project$Components$PaymentProcessing$Loading = {$: 0};
var $author$project$Components$PaymentProcessing$Model = $elm$core$Basics$identity;
var $author$project$Components$PaymentProcessing$StripeConnecting = {$: 3};
var $author$project$Api$Feature$StripeEmbeddedOnboarding = 28;
var $author$project$Api$Provider$Practice$Shared$hasStripeAccount = function (_v0) {
	var record = _v0;
	return record.Qi;
};
var $author$project$Api$Provider$Practice$One$hasStripeAccount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$hasStripeAccount(shared);
};
var $author$project$Api$Provider$Practice$StripeAccount$OnboardingStatus = F2(
	function (detailsSubmitted, clientSecret) {
		return {ab2: clientSecret, acJ: detailsSubmitted};
	});
var $author$project$Api$Provider$Practice$StripeAccount$onboardingStatusDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Api$Provider$Practice$StripeAccount$OnboardingStatus,
	A2($elm$json$Json$Decode$field, 'details_submitted', $elm$json$Json$Decode$bool),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'client_secret', $elm$json$Json$Decode$string)));
var $author$project$Api$Provider$Practice$StripeAccount$onboardingStatus = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$StripeAccount$onboardingStatusDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['onboarding_status']),
					$author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
	});
var $author$project$Api$Provider$RainforestAccount$One$RainforestAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$RainforestAccount$Shared$RainforestAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$RainforestAccount$Shared$Record = function (status) {
	return {ag7: status};
};
var $author$project$Api$Provider$RainforestAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$Shared$Record));
var $author$project$Api$Provider$RainforestAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RainforestAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$RainforestAccount$One$Record = function (merchantId) {
	return function (merchantApplicationId) {
		return function (merchantApplicationStatus) {
			return function (statementDescriptor) {
				return function (depositAccountLast4) {
					return function (depositAccountRoutingNumber) {
						return function (depositAccountBankName) {
							return function (depositAccountAccountType) {
								return function (platformTokenMigrationCompletedAt) {
									return function (depositFrequency) {
										return {Nt: depositAccountAccountType, Nu: depositAccountBankName, Nv: depositAccountLast4, Nw: depositAccountRoutingNumber, acH: depositFrequency, TP: merchantApplicationId, TQ: merchantApplicationStatus, TR: merchantId, Ws: platformTokenMigrationCompletedAt, _J: statementDescriptor};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$RainforestAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deposit_frequency',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'platform_token_migration_completed_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deposit_account_account_type',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deposit_account_bank_name',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'deposit_account_routing_number',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'deposit_account_last_4',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'statement_descriptor',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'merchant_application_status',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'merchant_application_id',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'merchant_id',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$One$Record)))))))))));
var $author$project$Api$Provider$RainforestAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RainforestAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$RainforestAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$One$RainforestAccount)));
var $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['rainforest_account']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$RainforestAccount$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Components$PaymentProcessing$GotBankAccountsOnStripe = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$StripePaymentMethodMigration = $elm$core$Basics$identity;
var $author$project$Api$Provider$StripePaymentMethodMigration$All$Record = function (id) {
	return function (type_) {
		return function (sourceBrand) {
			return function (lastFour) {
				return function (isDefault) {
					return function (lastUsedAt) {
						return function (requestPayInfoSentAt) {
							return function (owner) {
								return function (createdAt) {
									return function (label) {
										return function (name) {
											return function (expMonth) {
												return function (expYear) {
													return function (errorMessage) {
														return function (lastPaymentErrorMessage) {
															return function (zip) {
																return function (createdVia) {
																	return function (status) {
																		return function (createdByName) {
																			return function (funding) {
																				return function (paymentProcessor) {
																					return {Mf: createdAt, Mh: createdByName, Mi: createdVia, ON: errorMessage, ac9: expMonth, ada: expYear, PK: funding, adR: id, RI: isDefault, aej: label, Sz: lastFour, SB: lastPaymentErrorMessage, SF: lastUsedAt, zh: name, Vp: owner, V0: paymentProcessor, Yh: requestPayInfoSentAt, _f: sourceBrand, ag7: status, ahI: type_, tC: zip};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_processor',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'funding',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_by_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_via',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'zip',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'last_payment_error_message',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'error_message',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'exp_year',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'exp_month',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'label',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'created_at',
													$elm_community$json_extra$Json$Decode$Extra$datetime,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'owner',
														$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'request_pay_info_sent_at',
															$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'last_used_at',
																$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'is_default',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'last_four',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'payment_method_brand',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'type',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'id',
																					$elm$json$Json$Decode$string,
																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$StripePaymentMethodMigration$All$Record))))))))))))))))))))));
var $author$project$Api$Provider$StripePaymentMethodMigration$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$StripePaymentMethodMigration$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$StripePaymentMethodMigration$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$StripePaymentMethodMigration$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['stripe_payment_method_migrations']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$StripePaymentMethodMigration$bankAccounts = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$StripePaymentMethodMigration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bank_accounts']),
						$author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
	});
var $author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe = F2(
	function (apiClient, model) {
		var optionals = function (d) {
			return _Utils_update(
				d,
				{afy: model.e3, ag1: model.k9});
		};
		return A3($author$project$Api$Provider$StripePaymentMethodMigration$bankAccounts, apiClient, optionals, $author$project$Components$PaymentProcessing$GotBankAccountsOnStripe);
	});
var $author$project$Components$PaymentProcessing$GotCardsOnStripe = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$StripePaymentMethodMigration$cards = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$StripePaymentMethodMigration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['cards']),
						$author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
	});
var $author$project$Components$PaymentProcessing$retrieveCardsOnStripe = F2(
	function (apiClient, model) {
		var optionals = function (d) {
			return _Utils_update(
				d,
				{afy: model.e9, ag1: model.ll});
		};
		return A3($author$project$Api$Provider$StripePaymentMethodMigration$cards, apiClient, optionals, $author$project$Components$PaymentProcessing$GotCardsOnStripe);
	});
var $author$project$Components$PaymentProcessing$init = F5(
	function (session, practice, shared, _v0, _v1) {
		var isOnboarding = _v1.aJ;
		var isStripeEmbedded = A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice);
		var _v2 = isStripeEmbedded ? ($author$project$Api$Provider$Practice$One$hasStripeAccount(practice) ? _Utils_Tuple2(
			$author$project$Components$PaymentProcessing$StripeConnecting,
			A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, shared.D5, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus)) : _Utils_Tuple2($author$project$Components$PaymentProcessing$CreateAccount, $elm$core$Platform$Cmd$none)) : _Utils_Tuple2(
			$author$project$Components$PaymentProcessing$Loading,
			A2($author$project$Api$Provider$Practice$RainforestAccount$retrieve, shared.D5, $author$project$Components$PaymentProcessing$GotRainforestAccount));
		var initialStatus = _v2.a;
		var initialCmd = _v2.b;
		var model = {
			cB: $author$project$Api$Data$Loading,
			e3: $author$project$Api$Pagination$init,
			k9: A3($author$project$Api$Sort$withDefault, 'last_used_at', 1, $author$project$Api$Sort$init),
			Eq: A3($author$project$Permission$canGoTo, session, shared.adN, 17),
			Er: A3($author$project$Permission$canGoTo, session, shared.adN, 44),
			cI: $author$project$Api$Data$Loading,
			e9: $author$project$Api$Pagination$init,
			ll: A3($author$project$Api$Sort$withDefault, 'last_used_at', 1, $author$project$Api$Sort$init),
			dF: $elm$core$Maybe$Nothing,
			fm: $author$project$Api$Data$NotAsked,
			dQ: $elm$core$Maybe$Nothing,
			l2: $author$project$Api$Data$NotAsked,
			qT: shared.qT,
			FR: $author$project$Shared$isHintAdmin(shared),
			aJ: isOnboarding,
			yW: false,
			jd: $elm$core$Maybe$Nothing,
			WF: practice,
			cm: $author$project$Api$Data$Loading,
			Bl: $author$project$Rainforest$isSandbox(shared.sj),
			eu: $elm$core$Maybe$Nothing,
			ev: $elm$core$Maybe$Nothing,
			jR: $elm$core$Maybe$Nothing,
			n5: $author$project$Api$Data$NotAsked,
			ZD: session,
			Cc: $elm$core$Maybe$Nothing,
			ka: $elm$core$Maybe$Nothing,
			ag7: initialStatus,
			gT: false,
			oG: $author$project$Api$Data$NotAsked,
			Hy: shared.Hy,
			o$: $author$project$Api$Data$NotAsked,
			aaz: $author$project$Api$Platform$Session$One$user(session)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						initialCmd,
						A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, shared.D5, model),
						A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, shared.D5, model)
					])));
	});
var $author$project$Pages$Admin$PaymentProcessing$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5(
			$author$project$Components$PaymentProcessing$init,
			session,
			practice,
			shared,
			query,
			{aJ: false});
		var paymentProcessing = _v1.a;
		var paymentProcessingCmd = _v1.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				FR: $author$project$Shared$isHintAdmin(shared),
				np: paymentProcessing
			},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentProcessingCmd));
	});
var $author$project$Pages$Admin$PaymentProcessing$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$PaymentProcessing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$PaymentProcessing$DeleteHiConfirmClosed = F3(
	function (a, b, c) {
		return {$: 22, a: a, b: b, c: c};
	});
var $author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed = F3(
	function (a, b, c) {
		return {$: 24, a: a, b: b, c: c};
	});
var $author$project$Components$PaymentProcessing$ResetAccountModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$PaymentProcessing$StripeHiConfirmClosed = function (a) {
	return {$: 47, a: a};
};
var $author$project$Components$PaymentProcessing$StripeOnboardingExited = {$: 45};
var $author$project$Ports$Stripe$stripePortOnboardingExited = _Platform_incomingPort(
	'stripePortOnboardingExited',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Stripe$onOnboardingExited = function (msg) {
	return $author$project$Ports$Stripe$stripePortOnboardingExited(
		$elm$core$Basics$always(msg));
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal = {$: 0};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal);
};
var $author$project$Components$Rainforest$ResetAccountModal$Close = {$: 0};
var $author$project$Components$Rainforest$ResetAccountModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$ResetAccountModal$Close);
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Close = {$: 0};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateApplicationEventModal$Close);
};
var $author$project$Components$PaymentProcessing$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg)),
					model.ka)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$ResetAccountModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$ResetAccountModalMsg)),
					model.jR)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var deletingPaymentMethodType = _v1.a;
						var deletingPaymentMethod = _v1.b;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							A2($author$project$Components$PaymentProcessing$DeleteHiConfirmClosed, deletingPaymentMethodType, deletingPaymentMethod));
					},
					model.dQ)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var requestingUpdatePaymentMethodType = _v2.a;
						var requestingUpdatePaymentMethod = _v2.b;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							A2($author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed, requestingUpdatePaymentMethodType, requestingUpdatePaymentMethod));
					},
					model.ev)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$MigrateBackToStripeModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg)),
					model.jd)),
				function () {
				var _v3 = model.ag7;
				if (_v3.$ === 4) {
					return $author$project$Ports$Stripe$onOnboardingExited($author$project$Components$PaymentProcessing$StripeOnboardingExited);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				model.gT ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$PaymentProcessing$StripeHiConfirmClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$PaymentProcessing$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PaymentProcessing$subscriptions(model.np));
};
var $author$project$Components$PaymentProcessing$Deleted = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Components$PaymentProcessing$DeletedAll = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$DepositFrequencyUpdated = function (a) {
	return {$: 41, a: a};
};
var $author$project$Components$PaymentProcessing$GotConnectedToStripe = function (a) {
	return {$: 43, a: a};
};
var $author$project$Components$PaymentProcessing$GotDeleteRainforestAccount = function (a) {
	return {$: 37, a: a};
};
var $author$project$Components$PaymentProcessing$GotPractice = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PaymentProcessing$GotRainforestAccountCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentProcessing$GotRainforestAccountEnabled = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PaymentProcessing$GotRunPlatformMigration = function (a) {
	return {$: 35, a: a};
};
var $author$project$Components$PaymentProcessing$HasRainforestAccountAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentProcessing$PaymentInfoUpdated = F3(
	function (a, b, c) {
		return {$: 25, a: a, b: b, c: c};
	});
var $author$project$Components$PaymentProcessing$RequestedPaymentInfoUpdateAll = F2(
	function (a, b) {
		return {$: 31, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$StripeConnected = {$: 5};
var $author$project$Components$PaymentProcessing$StripeDisconnected = function (a) {
	return {$: 48, a: a};
};
var $author$project$Components$PaymentProcessing$StripeEmbeddedOnboarding = {$: 4};
var $author$project$Components$PaymentProcessing$Synced = function (a) {
	return {$: 33, a: a};
};
var $author$project$Api$Provider$StripePaymentMethodMigration$bulkDelete = F3(
	function (apiClient, paymentMethodType, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_method_type',
					$elm$json$Json$Encode$string(paymentMethodType))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk_delete']),
						$author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$bulkRequestPayInfoUpdate = F3(
	function (apiClient, paymentMethodType, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_method_type',
					$elm$json$Json$Encode$string(paymentMethodType))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bulk_request_pay_info']),
						$author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
	});
var $author$project$Components$PaymentProcessing$PracticeOnboardingUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$complete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['complete']),
					$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
	});
var $author$project$Components$PaymentProcessing$completeSetup = F2(
	function (apiClient, practice) {
		var onboardId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$id,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
		return A3($author$project$Api$Provider$PracticeOnboarding$complete, apiClient, onboardId, $author$project$Components$PaymentProcessing$PracticeOnboardingUpdated);
	});
var $author$project$Api$Provider$Practice$RainforestAccount$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Api$Provider$Practice$StripeAccount$createAccount = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath));
	});
var $author$project$Api$Provider$BankAccount$bankAccountPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$BankAccount$bankAccountsPath(basePath));
	});
var $author$project$Api$Provider$BankAccount$delete = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)));
	});
var $author$project$Api$Provider$Card$cardPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Card$cardsPath(basePath));
	});
var $author$project$Api$Provider$Card$delete = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Card$cardPath, basePath, id_)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Api$Provider$Practice$StripeAccount$disconnect = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['disconnect']),
					$author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$enable = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['enable']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$All$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$MigrateBackToStripeModal$init = {m4: $author$project$Api$Data$NotAsked, ro: false};
var $author$project$Components$Rainforest$ResetAccountModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$ResetAccountModal$init = function (reset) {
	return _Utils_Tuple2(
		{jc: $elm$core$Maybe$Nothing, so: $author$project$Api$Data$NotAsked, G$: reset},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus = 'COMPLETED';
var $author$project$Components$Rainforest$SimulateApplicationEventModal$reviewTypes = _List_fromArray(
	['BUSINESS_NAME_TIN', 'BUSINESS_VERIFICATION', 'FINANCIAL_1', 'FINANCIAL_2', 'DEPOSIT_METHOD_1', 'OWNER_1_NAME_SSN', 'OWNER_2_NAME_SSN', 'OWNER_3_NAME_SSN', 'OWNER_4_NAME_SSN']);
var $author$project$Components$Rainforest$SimulateApplicationEventModal$init = function (simulateStatusChange) {
	return _Utils_Tuple2(
		{
			so: $author$project$Api$Data$NotAsked,
			n1: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (reviewType) {
						return _Utils_Tuple2(reviewType, false);
					},
					$author$project$Components$Rainforest$SimulateApplicationEventModal$reviewTypes)),
			Hd: simulateStatusChange,
			ag7: $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Ports$Stripe$stripePortMountAccountOnboardingComponent = _Platform_outgoingPort(
	'stripePortMountAccountOnboardingComponent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.be)),
					_Utils_Tuple2(
					'stripeClientSecret',
					$elm$json$Json$Encode$string($.oC))
				]));
	});
var $author$project$Ports$Stripe$mountAccountOnboardingComponent = F2(
	function (selector, stripeClientSecret) {
		return $author$project$Ports$Stripe$stripePortMountAccountOnboardingComponent(
			{be: selector, oC: stripeClientSecret});
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$All$owner = function (_v0) {
	var record = _v0;
	return record.Vp;
};
var $author$project$Components$PaymentProcessing$PrefilledWithFakeData = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Provider$Practice$RainforestAccount$fakePrefill = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['fake_prefill']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Components$PaymentProcessing$prefillWithFakeData = function (apiClient) {
	return A2($author$project$Api$Provider$Practice$RainforestAccount$fakePrefill, apiClient, $author$project$Components$PaymentProcessing$PrefilledWithFakeData);
};
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$RequestPaymentInfo = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$Record = function (requestPayInfoSentAt) {
	return {Yh: requestPayInfoSentAt};
};
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'request_pay_info_sent_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$RequestPaymentInfoOne$Record));
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$RequestPaymentInfoOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$requestPaymentInfo = F4(
	function (apiClient, id_, replacesPaymentMethodId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			function () {
				if (!replacesPaymentMethodId.$) {
					var replacesPaymentMethodId_ = replacesPaymentMethodId.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'replaces_payment_method_id',
							$elm$json$Json$Encode$string(replacesPaymentMethodId_))
						]);
				} else {
					return _List_Nil;
				}
			}());
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$RequestPaymentInfoOne$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['request_payment_info']),
						$author$project$Api$Provider$Patient$patientPath(id_)))));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$reset = F3(
	function (apiClient, merchantName, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'merchant_name',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, merchantName))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reset']),
						$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Api$Provider$Practice$expandToString = function (expand) {
	if (!expand) {
		return 'signup_settings';
	} else {
		return 'default_plan';
	}
};
var $author$project$Api$Provider$Practice$retrieveDefaults = {Fc: _List_Nil};
var $author$project$Api$Provider$Practice$retrieveOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Practice$retrieveDefaults);
	return _List_fromArray(
		[
			A2(
			$author$project$Api$Param$list,
			'expand',
			A2($elm$core$List$map, $author$project$Api$Provider$Practice$expandToString, options.Fc))
		]);
};
var $author$project$Api$Provider$Practice$retrieve = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Practice$retrieveOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Components$PaymentProcessing$GotSetupSessionKey = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$RainforestAccount$One$record = function (_v0) {
	var record_ = _v0.b;
	return record_;
};
var $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.TQ;
	});
var $author$project$Api$Provider$Practice$RainforestAccount$setup = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			A2($elm$json$Json$Decode$field, 'session_key', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['setup']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Components$PaymentProcessing$retrieveSetupSessionKey = F2(
	function (apiClient, rainforestAccount) {
		return ($author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount) !== 'completed') ? A2($author$project$Api$Provider$Practice$RainforestAccount$setup, apiClient, $author$project$Components$PaymentProcessing$GotSetupSessionKey) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Api$Provider$Practice$RainforestAccount$runPlatformMigration = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['run_platform_migration']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$simulateStatusChange = F4(
	function (apiClient, status, reviewTypes, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(status)),
					_Utils_Tuple2(
					'review_types',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, reviewTypes))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate_status_change']),
						$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$sync = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync']),
					$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Provider$Practice$RainforestAccount$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rainforest_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'deposit_frequency',
								$elm$json$Json$Encode$string(fields.acH))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Components$Rainforest$MigrateBackToStripeModal$Closed = 2;
var $author$project$Components$Rainforest$MigrateBackToStripeModal$GotMigrateBackToStripeResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigratedBackToStripe = 1;
var $author$project$Components$Rainforest$MigrateBackToStripeModal$None = 0;
var $author$project$Api$Provider$Practice$RainforestAccount$migrateBackToStripe = F3(
	function (apiClient, migratePaymentMethods, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'migrate_payment_methods',
					$elm$json$Json$Encode$bool(migratePaymentMethods))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['migrate_back_to_stripe']),
						$author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Components$Rainforest$MigrateBackToStripeModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
			case 1:
				var migratePaymentMethods = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{ro: migratePaymentMethods}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: A3($author$project$Api$Provider$Practice$RainforestAccount$migrateBackToStripe, apiClient, model.ro, $author$project$Components$Rainforest$MigrateBackToStripeModal$GotMigrateBackToStripeResponse),
					ac5: 0,
					y8: _Utils_update(
						model,
						{m4: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{m4: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Reverted to Stripe successfully')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{m4: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Rainforest$ResetAccountModal$Closed = {$: 1};
var $author$project$Components$Rainforest$ResetAccountModal$GotReset = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Rainforest$ResetAccountModal$None = {$: 0};
var $author$project$Components$Rainforest$ResetAccountModal$Reseted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Rainforest$ResetAccountModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var string = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Rainforest$ResetAccountModal$None,
					y8: _Utils_update(
						model,
						{
							jc: $author$project$Utils$String$toMaybe(string)
						}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: A3(model.G$, apiClient, model.jc, $author$project$Components$Rainforest$ResetAccountModal$GotReset),
					ac5: $author$project$Components$Rainforest$ResetAccountModal$None,
					y8: _Utils_update(
						model,
						{so: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: A2($author$project$Components$Rainforest$ResetAccountModal$Reseted, rainforestAccount, response),
						y8: _Utils_update(
							model,
							{so: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Application Status Changed')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Rainforest$ResetAccountModal$None,
						y8: _Utils_update(
							model,
							{so: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Rainforest$ResetAccountModal$Closed, y8: model, as: _List_Nil};
		}
	});
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Closed = 1;
var $author$project$Components$Rainforest$SimulateApplicationEventModal$GotSimulate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$None = 0;
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Simulated = 2;
var $author$project$Components$Rainforest$SimulateApplicationEventModal$statuses = _List_fromArray(
	['COMPLETED', 'DECLINED', 'NEEDS_INFORMATION']);
var $author$project$Components$Rainforest$SimulateApplicationEventModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var inputStatus = msg.a;
				var selectedStatus = A2(
					$elm_community$list_extra$List$Extra$find,
					function (status_) {
						return _Utils_eq(status_, inputStatus);
					},
					$author$project$Components$Rainforest$SimulateApplicationEventModal$statuses);
				var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus, selectedStatus);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{ag7: status}),
					as: _List_Nil
				};
			case 2:
				var reviewType = msg.a;
				var value = msg.b;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							n1: A3($elm$core$Dict$insert, reviewType, value, model.n1)
						}),
					as: _List_Nil
				};
			case 3:
				var reviewTypes_ = function () {
					var _v2 = model.ag7;
					if (_v2 === 'NEEDS_INFORMATION') {
						return A2(
							$elm$core$List$filterMap,
							function (_v3) {
								var reviewType = _v3.a;
								var value = _v3.b;
								return value ? $elm$core$Maybe$Just(reviewType) : $elm$core$Maybe$Nothing;
							},
							$elm$core$Dict$toList(model.n1));
					} else {
						return _List_Nil;
					}
				}();
				return {
					EC: A4(model.Hd, apiClient, model.ag7, reviewTypes_, $author$project$Components$Rainforest$SimulateApplicationEventModal$GotSimulate),
					ac5: 0,
					y8: _Utils_update(
						model,
						{so: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{so: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Application Status Changed')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{so: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
		}
	});
var $author$project$Components$PaymentProcessing$update = F3(
	function (msg, _v0, apiClient) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v2$2:
				while (true) {
					switch (response.$) {
						case 3:
							var rainforestAccount = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cm: response,
										ag7: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
									}),
								A2($author$project$Components$PaymentProcessing$retrieveSetupSessionKey, apiClient, rainforestAccount),
								_List_fromArray(
									[$author$project$OutMsg$RefreshPractice]));
						case 2:
							if (response.a.$ === 5) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{ag7: $author$project$Components$PaymentProcessing$CreateAccount}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ag7: $author$project$Components$PaymentProcessing$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$create, apiClient, $author$project$Components$PaymentProcessing$GotRainforestAccountCreated),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cm: response,
								ag7: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
							}),
						A2($author$project$Components$PaymentProcessing$retrieveSetupSessionKey, apiClient, rainforestAccount),
						_List_fromArray(
							[$author$project$OutMsg$RefreshPractice]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ag7: $author$project$Components$PaymentProcessing$CreateAccount}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var sessionKey = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Cc: $elm$core$Maybe$Just(sessionKey)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				return _Utils_Tuple3(
					model,
					A2($author$project$Components$PaymentProcessing$completeSetup, apiClient, model.WF),
					_List_Nil);
			case 6:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{yW: true}),
					model.aJ ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
								A2($author$project$Components$PaymentProcessing$completeSetup, apiClient, model.WF)
							])) : $elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Payment Processing Application submited')
						]));
			case 10:
				var _v7 = $author$project$Components$Rainforest$SimulateApplicationEventModal$init($author$project$Api$Provider$Practice$RainforestAccount$simulateStatusChange);
				var simulateApplicationEventModal = _v7.a;
				var simulateApplicationEventModalCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ka: $elm$core$Maybe$Just(simulateApplicationEventModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg, simulateApplicationEventModalCmd),
					_List_Nil);
			case 11:
				var simulateApplicationEventModalMsg = msg.a;
				var _v8 = model.ka;
				if (!_v8.$) {
					var simulateApplicationEventModal = _v8.a;
					var simulateApplicationEventModalResult = A3($author$project$Components$Rainforest$SimulateApplicationEventModal$update, apiClient, simulateApplicationEventModalMsg, simulateApplicationEventModal);
					var simulateApplicationEventModal_ = function () {
						var _v9 = simulateApplicationEventModalResult.ac5;
						switch (_v9) {
							case 1:
								return $elm$core$Maybe$Nothing;
							case 2:
								return $elm$core$Maybe$Nothing;
							default:
								return $elm$core$Maybe$Just(simulateApplicationEventModalResult.y8);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ka: simulateApplicationEventModal_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg, simulateApplicationEventModalResult.EC),
						simulateApplicationEventModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var _v10 = $author$project$Components$Rainforest$ResetAccountModal$init($author$project$Api$Provider$Practice$RainforestAccount$reset);
				var resetAccountModal = _v10.a;
				var resetAccountModalCmd = _v10.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jR: $elm$core$Maybe$Just(resetAccountModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$ResetAccountModalMsg, resetAccountModalCmd),
					_List_Nil);
			case 13:
				var resetAccountModalMsg = msg.a;
				var _v11 = model.jR;
				if (!_v11.$) {
					var resetAccountModal = _v11.a;
					var resetAccountModalResult = A3($author$project$Components$Rainforest$ResetAccountModal$update, apiClient, resetAccountModalMsg, resetAccountModal);
					var _v12 = function () {
						var _v13 = resetAccountModalResult.ac5;
						switch (_v13.$) {
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ag7, model.cm);
							case 2:
								var rainforestAccount_ = _v13.a;
								var rainforestAccountResponse = _v13.b;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount_),
									rainforestAccountResponse);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(resetAccountModalResult.y8),
									model.ag7,
									model.cm);
						}
					}();
					var resetAccountModal_ = _v12.a;
					var status = _v12.b;
					var rainforestAccount = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cm: rainforestAccount, jR: resetAccountModal_, ag7: status}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$ResetAccountModalMsg, resetAccountModalResult.EC),
						resetAccountModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l2: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$enable, apiClient, $author$project$Components$PaymentProcessing$GotRainforestAccountEnabled),
					_List_Nil);
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								l2: $author$project$Api$Data$NotAsked,
								cm: response,
								ag7: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
							}),
						A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Components$PaymentProcessing$GotPractice),
						_List_fromArray(
							[
								$author$project$OutMsg$RefreshPractice,
								A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account enabled')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{l2: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WF: practice}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				return _Utils_Tuple3(
					model,
					$author$project$Components$PaymentProcessing$prefillWithFakeData(apiClient),
					_List_Nil);
			case 15:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 17:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cB: response,
								e3: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.e3)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cI: response,
								e9: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.e9)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cI: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 18:
				var paymentMethodType = msg.a;
				var subMsg = msg.b;
				var newModel = function () {
					if (!paymentMethodType) {
						return _Utils_update(
							model,
							{
								e9: A2($author$project$Api$Pagination$update, subMsg, model.e9)
							});
					} else {
						return _Utils_update(
							model,
							{
								e3: A2($author$project$Api$Pagination$update, subMsg, model.e3)
							});
					}
				}();
				return _Utils_Tuple3(
					newModel,
					function () {
						if (!paymentMethodType) {
							return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
						} else {
							return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
						}
					}(),
					_List_Nil);
			case 19:
				var paymentMethodType = msg.a;
				var columnId = msg.b;
				var newModel = function () {
					if (!paymentMethodType) {
						return _Utils_update(
							model,
							{
								ll: A2($author$project$Api$Sort$update, columnId, model.ll)
							});
					} else {
						return _Utils_update(
							model,
							{
								k9: A2($author$project$Api$Sort$update, columnId, model.k9)
							});
					}
				}();
				return _Utils_Tuple3(
					newModel,
					function () {
						if (!paymentMethodType) {
							return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
						} else {
							return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
						}
					}(),
					_List_Nil);
			case 20:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dQ: $elm$core$Maybe$Just(
								_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 22:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				var confirmed = msg.c;
				if (confirmed) {
					var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
					var ownerPath = A2(
						$elm$core$Maybe$andThen,
						function (owner_) {
							var _v25 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
							switch (_v25) {
								case 'Patient':
									return $elm$core$Maybe$Just(
										$author$project$Api$Provider$Patient$patientPath(
											$author$project$Api$Common$Payable$Owner$Min$id(owner_)));
								case 'Company':
									return $elm$core$Maybe$Just(
										$author$project$Api$Provider$Company$companyPath(
											$author$project$Api$Common$Payable$Owner$Min$id(owner_)));
								default:
									return $elm$core$Maybe$Nothing;
							}
						},
						owner);
					var id = $author$project$Api$Provider$StripePaymentMethodMigration$All$id(paymentMethod);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dQ: $elm$core$Maybe$Just(
									_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$Loading))
							}),
						function () {
							var _v22 = _Utils_Tuple2(ownerPath, paymentMethodType);
							if (!_v22.a.$) {
								if (!_v22.b) {
									var ownerPath_ = _v22.a.a;
									var _v23 = _v22.b;
									return A4(
										$author$project$Api$Provider$Card$delete,
										ownerPath_,
										apiClient,
										id,
										A2($author$project$Components$PaymentProcessing$Deleted, paymentMethodType, paymentMethod));
								} else {
									var ownerPath_ = _v22.a.a;
									var _v24 = _v22.b;
									return A4(
										$author$project$Api$Provider$BankAccount$delete,
										ownerPath_,
										apiClient,
										id,
										A2($author$project$Components$PaymentProcessing$Deleted, paymentMethodType, paymentMethod));
								}
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dQ: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 21:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var newModel = function () {
						if (!paymentMethodType) {
							return _Utils_update(
								model,
								{cI: $author$project$Api$Data$Loading});
						} else {
							return _Utils_update(
								model,
								{cB: $author$project$Api$Data$Loading});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{dQ: $elm$core$Maybe$Nothing}),
						function () {
							if (!paymentMethodType) {
								return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
							} else {
								return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
							}
						}(),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully removed.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dQ: $elm$core$Maybe$Just(
									_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 23:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ev: $elm$core$Maybe$Just(
								_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 24:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				var confirmed = msg.c;
				if (confirmed) {
					var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ev: $elm$core$Maybe$Just(
									_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$Loading))
							}),
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								function (owner_) {
									var _v29 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
									switch (_v29) {
										case 'Patient':
											var id = $author$project$Api$Provider$StripePaymentMethodMigration$All$id(paymentMethod);
											return A4(
												$author$project$Api$Provider$Patient$requestPaymentInfo,
												apiClient,
												$author$project$Api$Common$Payable$Owner$Min$id(owner_),
												$elm$core$Maybe$Just(id),
												A2($author$project$Components$PaymentProcessing$PaymentInfoUpdated, paymentMethodType, paymentMethod));
										case 'Company':
											return $elm$core$Platform$Cmd$none;
										default:
											return $elm$core$Platform$Cmd$none;
									}
								},
								owner)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ev: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 25:
				var paymentMethodType = msg.a;
				var paymentMethod = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var newModel = function () {
						if (!paymentMethodType) {
							return _Utils_update(
								model,
								{cI: $author$project$Api$Data$Loading});
						} else {
							return _Utils_update(
								model,
								{cB: $author$project$Api$Data$Loading});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{ev: $elm$core$Maybe$Nothing}),
						function () {
							if (!paymentMethodType) {
								return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
							} else {
								return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
							}
						}(),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Request to update payment method was successfully sent.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ev: $elm$core$Maybe$Just(
									_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 26:
				var paymentMethodType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dF: $elm$core$Maybe$Just(
								_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 27:
				var paymentMethodType = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var paymentMethodType_ = function () {
						if (!paymentMethodType) {
							return 'card';
						} else {
							return 'bank_account';
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dF: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$StripePaymentMethodMigration$bulkDelete,
							apiClient,
							paymentMethodType_,
							$author$project$Components$PaymentProcessing$DeletedAll(paymentMethodType)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dF: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 28:
				var paymentMethodType = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var newModel = function () {
						if (!paymentMethodType) {
							return _Utils_update(
								model,
								{cI: $author$project$Api$Data$Loading});
						} else {
							return _Utils_update(
								model,
								{cB: $author$project$Api$Data$Loading});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{dF: $elm$core$Maybe$Nothing}),
						function () {
							if (!paymentMethodType) {
								return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
							} else {
								return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
							}
						}(),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Deleting all payment methods . This may take a couple moments...')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dF: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 29:
				var paymentMethodType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eu: $elm$core$Maybe$Just(
								_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 30:
				var paymentMethodType = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var paymentMethodType_ = function () {
						if (!paymentMethodType) {
							return 'card';
						} else {
							return 'bank_account';
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eu: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$Loading))
							}),
						A3(
							$author$project$Api$Provider$StripePaymentMethodMigration$bulkRequestPayInfoUpdate,
							apiClient,
							paymentMethodType_,
							$author$project$Components$PaymentProcessing$RequestedPaymentInfoUpdateAll(paymentMethodType)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eu: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 31:
				var paymentMethodType = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var newModel = function () {
						if (!paymentMethodType) {
							return _Utils_update(
								model,
								{cI: $author$project$Api$Data$Loading});
						} else {
							return _Utils_update(
								model,
								{cB: $author$project$Api$Data$Loading});
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{eu: $elm$core$Maybe$Nothing}),
						function () {
							if (!paymentMethodType) {
								return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
							} else {
								return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
							}
						}(),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sending request to update all payment methods . This may take a couple moments...')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eu: $elm$core$Maybe$Just(
									_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 32:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oG: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$sync, apiClient, $author$project$Components$PaymentProcessing$Synced),
					_List_Nil);
			case 33:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cm: response,
								ag7: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount),
								oG: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sync with Rainforest was successful.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oG: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 34:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n5: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$runPlatformMigration, apiClient, $author$project$Components$PaymentProcessing$GotRunPlatformMigration),
					_List_Nil);
			case 35:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								n5: response,
								ag7: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Platform migration was started.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{n5: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 36:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fm: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$RainforestAccount$delete, apiClient, $author$project$Components$PaymentProcessing$GotDeleteRainforestAccount),
					_List_Nil);
			case 37:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fm: $author$project$Api$Data$NotAsked, ag7: $author$project$Components$PaymentProcessing$CreateAccount}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account was successfully deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 38:
				var migrateBackToStripeModal = $author$project$Components$Rainforest$MigrateBackToStripeModal$init;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jd: $elm$core$Maybe$Just(migrateBackToStripeModal)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 39:
				var subMsg = msg.a;
				var _v44 = model.jd;
				if (!_v44.$) {
					var migrateBackToStripeModal = _v44.a;
					var migrateBackToStripeModalResult = A3($author$project$Components$Rainforest$MigrateBackToStripeModal$update, apiClient, subMsg, migrateBackToStripeModal);
					var _v45 = function () {
						var _v46 = migrateBackToStripeModalResult.ac5;
						switch (_v46) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(migrateBackToStripeModalResult.y8),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 2:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Components$PaymentProcessing$GotPractice),
									_List_fromArray(
										[$author$project$OutMsg$RefreshPractice]));
						}
					}();
					var updatedMigrateBackToStripeModal = _v45.a;
					var cmd = _v45.b;
					var outMsgs = _v45.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jd: updatedMigrateBackToStripeModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg, migrateBackToStripeModalResult.EC)
								])),
						_Utils_ap(outMsgs, migrateBackToStripeModalResult.as));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 40:
				var depositFrequency = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{o$: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Practice$RainforestAccount$update,
						apiClient,
						{acH: depositFrequency},
						$author$project$Components$PaymentProcessing$DepositFrequencyUpdated),
					_List_Nil);
			case 41:
				var response = msg.a;
				if (response.$ === 3) {
					var rainforestAccount = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cm: response,
								ag7: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount),
								o$: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Deposit frequency was successfully updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 42:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ag7: $author$project$Components$PaymentProcessing$StripeConnecting}),
					A2($author$project$Api$Provider$Practice$StripeAccount$createAccount, apiClient, $author$project$Components$PaymentProcessing$GotConnectedToStripe),
					_List_Nil);
			case 43:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WF: practice, ag7: $author$project$Components$PaymentProcessing$StripeConnecting}),
						A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, apiClient, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus),
						_List_fromArray(
							[
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ag7: $author$project$Components$PaymentProcessing$CreateAccount}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 44:
				var response = msg.a;
				if (response.$ === 3) {
					var detailsSubmitted = response.a.acJ;
					var clientSecret = response.a.ab2;
					if (detailsSubmitted) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ag7: $author$project$Components$PaymentProcessing$StripeConnected}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						if (!clientSecret.$) {
							var secret = clientSecret.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{ag7: $author$project$Components$PaymentProcessing$StripeEmbeddedOnboarding}),
								A2($author$project$Ports$Stripe$mountAccountOnboardingComponent, '#stripe-account-onboarding', secret),
								_List_Nil);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						}
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ag7: $author$project$Components$PaymentProcessing$CreateAccount}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 45:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ag7: $author$project$Components$PaymentProcessing$StripeConnecting}),
					A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, apiClient, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus),
					_List_Nil);
			case 46:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gT: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 47:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$StripeAccount$disconnect, apiClient, $author$project$Components$PaymentProcessing$StripeDisconnected),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{gT: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 48:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WF: practice, ag7: $author$project$Components$PaymentProcessing$CreateAccount, gT: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been disconnected.'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gT: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$open(model.ZD),
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$PaymentProcessing$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PaymentProcessing$update, subMsg, model.np, model.D5);
		var paymentProcessing = _v1.a;
		var paymentProcessingCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{np: paymentProcessing}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentProcessingCmd),
			outMsgs);
	});
var $author$project$Components$PaymentProcessing$DeleteAllHiConfirmClosed = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$DeleteRainforestAccount = {$: 36};
var $author$project$Components$PaymentProcessing$OpenResetAccountModal = {$: 12};
var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAllHiConfirmClosed = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$Sync = {$: 32};
var $author$project$Components$HiConfirm$ButtonStyle = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$HiConfirm$buttonStyle = $author$project$Components$HiConfirm$ButtonStyle;
var $author$project$Api$Provider$RainforestAccount$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$RainforestAccount$Shared$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$Shared$record,
	function ($) {
		return $.ag7;
	});
var $author$project$Api$Provider$RainforestAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RainforestAccount$Shared$status(shared);
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigrateBackToStripe = {$: 2};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigratePaymentMethodsChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$MigrateBackToStripeModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Migrate back to Stripe')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Migrate the practice back to to Stripe.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Migrate Payment Methods'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(model.ro),
										$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Rainforest$MigrateBackToStripeModal$MigratePaymentMethodsChanged)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Also migrate payment methods to back to Stripe.')
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Revert to Stripe'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$MigrateBackToStripeModal$MigrateBackToStripe),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.m4, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Migrate back to Stripe')
							]))
					]))
			]));
};
var $author$project$Components$Rainforest$ResetAccountModal$MerchantNameChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$ResetAccountModal$Reset = {$: 2};
var $author$project$Components$Rainforest$ResetAccountModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$ResetAccountModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Reset Rainforest Account')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This will:'),
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Remove the current link between the practice and Rainforest')
											])),
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create a new Rainforest Merchant with the given name')
											])),
										A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Link the practice to the new Rainforest Merchant')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Merchant Name'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', model.jc)),
										$author$project$Ui$Form$Input$onInput($author$project$Components$Rainforest$ResetAccountModal$MerchantNameChanged),
										$author$project$Ui$Form$Input$invalid(
										_Utils_eq(model.jc, $elm$core$Maybe$Nothing)),
										$author$project$Ui$Form$Input$errors(
										_Utils_eq(model.jc, $elm$core$Maybe$Nothing) ? _List_fromArray(
											['Merchant name is required']) : _List_Nil)
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('This is the name of the Rainforest Merchant that will be created. '),
										$elm$html$Html$text('By default we use the practice id as the merchant name but since we cannot reuse merchant names, '),
										$elm$html$Html$text('we will need provide a new name here. '),
										A2(
										$author$project$Ui$Typography$b,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Suggestion is to use the practice id followed by a dash with the number of merchants we have created for this practice.'),
												$elm$html$Html$text('Example: pra-abc1234-2')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$ResetAccountModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Reset Rainforest Account'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.so, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$ResetAccountModal$Reset)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reset')
							]))
					]))
			]));
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$ReviewTypeSelected = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Rainforest$SimulateApplicationEventModal$Simulate = {$: 3};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$StatusSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Rainforest$SimulateApplicationEventModal$statusOptions = A2(
	$elm$core$List$map,
	function (status) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(status),
			status);
	},
	$author$project$Components$Rainforest$SimulateApplicationEventModal$statuses);
var $author$project$Components$Rainforest$SimulateApplicationEventModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Rainforest$SimulateApplicationEventModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Simulate Application Status Change')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('In the production environment, this step is handled through callback events. In Staging, Feature, and Dev environments, it can be simulated.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Status'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(model.ag7)),
										$author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateApplicationEventModal$StatusSelected)
									]),
								$author$project$Components$Rainforest$SimulateApplicationEventModal$statusOptions)
							])),
						(model.ag7 === 'NEEDS_INFORMATION') ? A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Review Types'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$clearfix
							]),
						A2(
							$elm$core$List$map,
							function (_v1) {
								var reviewType = _v1.a;
								var value = _v1.b;
								return A2(
									$author$project$Ui$Form$Checkbox$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Checkbox$value(value),
											$author$project$Ui$Form$Checkbox$onCheck(
											$author$project$Components$Rainforest$SimulateApplicationEventModal$ReviewTypeSelected(reviewType))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(reviewType)
										]));
							},
							$elm$core$Dict$toList(model.n1))) : $author$project$Utils$Html$empty
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateApplicationEventModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Simulate application event'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.so, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateApplicationEventModal$Simulate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Simulate')
							]))
					]))
			]));
};
var $author$project$Components$PaymentProcessing$viewCreateAccountBody = F2(
	function (isOnboarding, isStripeEmbedded) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(
						isOnboarding ? '' : 'Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$inputSpanMd(6)
					]),
				_List_fromArray(
					[
						isOnboarding ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
							])),
						isStripeEmbedded ? A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Connect your Stripe account to start accepting payments through Hint.')
							])) : A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This platform streamlines the process of accepting patient payments by providing a secure, compliant, and efficient solution.'),
								$elm$html$Html$text(' To configure your Payment Processing account, click \"Connect\".')
							]))
					]))
			]);
	});
var $author$project$Components$PaymentProcessing$ConnectToStripe = {$: 42};
var $author$project$Components$PaymentProcessing$CreateRainforestAccount = {$: 1};
var $author$project$Components$PaymentProcessing$SkipSetup = {$: 5};
var $author$project$Components$PaymentProcessing$viewCreateAccountFooter = function (_v0) {
	var model = _v0;
	var isStripeEmbedded = A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, model.WF);
	var connectButton = isStripeEmbedded ? A3(
		$author$project$Ui$Button$view,
		{abp: 'Connect to Stripe'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$ConnectToStripe)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Connect to Stripe')
			])) : A3(
		$author$project$Ui$Button$view,
		{abp: 'Connect account'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$CreateRainforestAccount)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Connect')
			]));
	return model.aJ ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Skip account creation'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$pull(0),
					$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$SkipSetup)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Skip')
				])),
			connectButton
		]) : _List_fromArray(
		[connectButton]);
};
var $author$project$Components$PaymentProcessing$EnableRainforest = {$: 7};
var $author$project$Components$PaymentProcessing$MerchantOnboardingSubmitted = {$: 3};
var $author$project$Components$PaymentProcessing$MigrateBackToStripe = {$: 38};
var $author$project$Components$PaymentProcessing$OpenSimulateModal = {$: 10};
var $author$project$Components$PaymentProcessing$RunPlatformMigration = {$: 34};
var $author$project$Components$PaymentProcessing$applicationIsProcessing = F2(
	function (rainforestAccount, _v0) {
		var merchantOnboardingSubmitted = _v0.yW;
		return merchantOnboardingSubmitted || ('processing' === $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount));
	});
var $author$project$Api$Provider$RainforestAccount$One$depositAccountAccountType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Nt;
	});
var $author$project$Api$Provider$RainforestAccount$One$depositAccountBankName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Nu;
	});
var $author$project$Api$Provider$RainforestAccount$One$depositAccountLast4 = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Nv;
	});
var $author$project$Api$Provider$RainforestAccount$One$depositAccountRoutingNumber = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Nw;
	});
var $author$project$Api$Provider$RainforestAccount$One$depositFrequency = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.acH;
	});
var $author$project$Ui$HinterOnly$linkRoute = F3(
	function (route, options, content) {
		return A3(
			$author$project$Ui$Link$route,
			route,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$icon($author$project$Ui$HinterOnly$icon),
				options),
			content);
	});
var $author$project$Api$Provider$RainforestAccount$One$merchantApplicationId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.TP;
	});
var $author$project$Api$Provider$RainforestAccount$One$merchantId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.TR;
	});
var $author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $.Ws;
	});
var $author$project$Api$Provider$RainforestAccount$One$statementDescriptor = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$RainforestAccount$One$record,
	function ($) {
		return $._J;
	});
var $author$project$Ui$Alert$textLeft = $author$project$Ui$Alert$Alignment($author$project$Ui$Alignment$textLeft);
var $author$project$WebComponents$Rainforest$MerchantOnboarding$view = F2(
	function (msg, data) {
		return A3(
			$elm$html$Html$node,
			'rainforest-merchant-onboarding',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'session-key', data.agS),
					A2($elm$html$Html$Attributes$attribute, 'merchant-id', data.TR),
					A2($elm$html$Html$Attributes$attribute, 'merchant-application-id', data.TP),
					A2($elm$html$Html$Attributes$attribute, 'hide-display-header', ''),
					A2(
					$elm$html$Html$Events$on,
					'submitted',
					$elm$json$Json$Decode$succeed(msg)),
					A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
					A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
					A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
					A2($elm$html$Html$Attributes$attribute, 'terms-and-conditions-url', 'https://www.hint.com/terms-processing')
				]),
			_List_Nil);
	});
var $author$project$Components$PaymentProcessing$UpdateDepositFrequency = function (a) {
	return {$: 40, a: a};
};
var $author$project$Components$PaymentProcessing$viewDepositFrequencyButton = F4(
	function (updateRequest, currentDepositFrequency, depositFrequency, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentDepositFrequency, depositFrequency)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$PaymentProcessing$UpdateDepositFrequency(depositFrequency)),
					$author$project$Ui$Button$loading(
					_Utils_eq(updateRequest, $author$project$Api$Data$Loading))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$PaymentProcessing$viewInProgressAlert = A2(
	$author$project$Ui$Alert$info,
	_List_fromArray(
		[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Setup Hint Payments')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('To start processing payments in Hint, please complete the form below. It takes about 5–10 minutes and requires key details like your account’s contact info, tax ID, bank details, and ownership info (including SSN).')
				]))
		]));
var $author$project$Components$PaymentProcessing$viewInReviewAlert = A2(
	$author$project$Ui$Alert$info,
	_List_fromArray(
		[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Application Submitted — Under Review')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Thank you for submitting your payment setup form! We’re currently reviewing your details — this usually takes a few business days. No action is needed right now.')
				]))
		]));
var $author$project$Components$PaymentProcessing$viewHasAccountBody = F2(
	function (rainforestAccount, _v0) {
		var model = _v0;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					model.aJ ? _List_Nil : _List_fromArray(
					[
						function () {
						var _v1 = $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
						switch (_v1) {
							case 'created':
								return $author$project$Components$PaymentProcessing$viewInProgressAlert;
							case 'in_progress':
								return $author$project$Components$PaymentProcessing$viewInProgressAlert;
							case 'processing':
								return $author$project$Components$PaymentProcessing$viewInReviewAlert;
							case 'in_review':
								return $author$project$Components$PaymentProcessing$viewInReviewAlert;
							case 'needs_information':
								return A2(
									$author$project$Ui$Alert$info,
									_List_fromArray(
										[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Action Needed — More Info Required')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('To finish setting up Hint Payments, we need a bit more information. Please use the form below to provide the missing details. Once submitted, we’ll review and confirm your setup — usually within a few business days. We’ll notify you by email when it\'s complete.')
												]))
										]));
							case 'completed':
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Status'),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Provider$RainforestAccount$One$status(rainforestAccount))
												]))
										]));
							default:
								return $elm$html$Html$text('');
						}
					}()
					]),
					function () {
					var _v2 = $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
					if (_v2 === 'completed') {
						return $elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Statement Descriptor'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$statementDescriptor(rainforestAccount)))
													]))
											])),
										model.FR ? A2(
										$author$project$Ui$HinterOnly$formGroup,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Deposit Frequency'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Button$group(
												_List_fromArray(
													[
														A4(
														$author$project$Components$PaymentProcessing$viewDepositFrequencyButton,
														model.o$,
														$author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount),
														'daily',
														'Daily'),
														A4(
														$author$project$Components$PaymentProcessing$viewDepositFrequencyButton,
														model.o$,
														$author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount),
														'weekly',
														'Weekly'),
														A4(
														$author$project$Components$PaymentProcessing$viewDepositFrequencyButton,
														model.o$,
														$author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount),
														'monthly',
														'Monthly'),
														A4(
														$author$project$Components$PaymentProcessing$viewDepositFrequencyButton,
														model.o$,
														$author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount),
														'disabled',
														'Disabled')
													])),
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$helpBlock]),
												_List_fromArray(
													[
														$elm$html$Html$text('Deposits will be processed on '),
														function () {
														var _v3 = $author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount);
														switch (_v3) {
															case 'daily':
																return $elm$html$Html$text('each US banking day');
															case 'weekly':
																return $elm$html$Html$text('the first US banking day of the week');
															case 'monthly':
																return $elm$html$Html$text('the first US banking day of the month');
															case 'disabled':
																return $elm$html$Html$text('never');
															default:
																return $elm$html$Html$text('N/A');
														}
													}()
													]))
											])) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Deposit Account'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														_List_fromArray(
															[
																$elm$html$Html$text('Bank Name: ')
															])),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$depositAccountBankName(rainforestAccount)))
													])),
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														_List_fromArray(
															[
																$elm$html$Html$text('Last 4: ')
															])),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$depositAccountLast4(rainforestAccount)))
													])),
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														_List_fromArray(
															[
																$elm$html$Html$text('Routing Number: ')
															])),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$depositAccountRoutingNumber(rainforestAccount)))
													])),
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														_List_fromArray(
															[
																$elm$html$Html$text('Account Type: ')
															])),
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															$author$project$Api$Provider$RainforestAccount$One$depositAccountAccountType(rainforestAccount)))
													]))
											]))
									]),
									model.FR ? _List_fromArray(
									[
										A2(
										$author$project$Ui$HinterOnly$formGroup,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Payment Processor'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$core$Maybe$withDefault,
														$author$project$Utils$Html$empty,
														A4(
															$author$project$Utils$PaymentProcessor$toBadge,
															true,
															true,
															model.WF,
															A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$paymentProcessor, $elm$core$Maybe$Just))),
														($author$project$Api$Provider$Practice$One$paymentProcessor(model.WF) !== 'rainforest') ? A3(
														$author$project$Ui$HinterOnly$button,
														{abp: 'Switch payment processor to rainforest'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$loading(
																_Utils_eq(model.l2, $author$project$Api$Data$Loading)),
																$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$EnableRainforest)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Switch to Rainforest')
															])) : ($author$project$Api$Provider$Practice$One$hasStripeAccount(model.WF) ? A3(
														$author$project$Ui$HinterOnly$button,
														{abp: 'Migrate back to stripe'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$MigrateBackToStripe)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Migrate back to Stripe')
															])) : $author$project$Utils$Html$empty),
														A3(
														$author$project$Ui$HinterOnly$linkRoute,
														$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Manage Payment Sources Import')
															]))
													]))
											])),
										A2(
										$author$project$Ui$HinterOnly$formGroup,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Rainforest Merchant ID'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Provider$RainforestAccount$One$merchantId(rainforestAccount)))
													]))
											])),
										A2(
										$author$project$Ui$HinterOnly$formGroup,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Platform Migration Completed At'),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanSm(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															A2(
																$elm$core$Maybe$map,
																model.Hy(1),
																$author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt(rainforestAccount)))),
														_Utils_eq(
														$author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt(rainforestAccount),
														$elm$core$Maybe$Nothing) ? A3(
														$author$project$Ui$HinterOnly$button,
														{abp: 'Run platform migration'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$loading(
																_Utils_eq(model.n5, $author$project$Api$Data$Loading)),
																$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$RunPlatformMigration)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Run platform migration')
															])) : $author$project$Utils$Html$empty
													]))
											]))
									]) : _List_Nil
								]));
					} else {
						return _List_fromArray(
							[
								model.aJ ? $author$project$Utils$Html$empty : A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Application Status'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$fromString,
												_List_Nil,
												$author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount))
											]))
									])),
								(model.FR && (model.Bl && A2($author$project$Components$PaymentProcessing$applicationIsProcessing, rainforestAccount, model))) ? A2(
								$author$project$Ui$HinterOnly$formGroup,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8),
										$author$project$Ui$Form$Group$label('')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Simulate status change'},
												_List_fromArray(
													[
														$author$project$Ui$Button$secondary,
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$OpenSimulateModal)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Simulate Status Change')
													]))
											]))
									])) : $author$project$Utils$Html$empty
							]);
					}
				}(),
					function () {
					var _v4 = _Utils_Tuple3(
						A2($author$project$Components$PaymentProcessing$applicationIsProcessing, rainforestAccount, model),
						$author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount),
						model.Cc);
					_v4$1:
					while (true) {
						if (_v4.a) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label(''),
											$author$project$Ui$Form$Group$labelSpanSm(4),
											$author$project$Ui$Form$Group$inputSpanMd(12),
											$author$project$Ui$Form$Group$inputSpanSm(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Your payment processing account is under review, we will notify you when it\'s approved or if more information is needed.')
														]))
												]))
										]))
								]);
						} else {
							if (!_v4.c.$) {
								if (_v4.b === 'completed') {
									break _v4$1;
								} else {
									var setupSessionKey = _v4.c.a;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label(''),
													model.aJ ? $author$project$Ui$Form$Group$labelSpanSm(0) : $author$project$Ui$Form$Group$labelSpanSm(4),
													model.aJ ? $author$project$Ui$Form$Group$inputSpanMd(12) : $author$project$Ui$Form$Group$inputSpanMd(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$WebComponents$Rainforest$MerchantOnboarding$view,
													$author$project$Components$PaymentProcessing$MerchantOnboardingSubmitted,
													{
														TP: A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Provider$RainforestAccount$One$merchantApplicationId(rainforestAccount)),
														TR: A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Provider$RainforestAccount$One$merchantId(rainforestAccount)),
														agS: setupSessionKey
													})
												]))
										]);
								}
							} else {
								if (_v4.b === 'completed') {
									break _v4$1;
								} else {
									var _v5 = _v4.c;
									return _List_Nil;
								}
							}
						}
					}
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(''),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanMd(12),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('You can review your patient payment report ')
												])),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__PaymentApplications,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('here')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('.')
												]))
										]))
								]))
						]);
				}()
				]));
	});
var $author$project$Components$PaymentProcessing$PrefillWithFakeDataClicked = {$: 14};
var $author$project$Components$PaymentProcessing$viewHasAccountFooter = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(
					model.FR && model.Bl,
					A2($author$project$Api$Data$map, $author$project$Api$Provider$RainforestAccount$One$status, model.cm));
				if ((_v0.a && (_v0.b.$ === 3)) && (_v0.b.a === 'pending')) {
					var _v1 = _v0.b;
					return A3(
						$author$project$Ui$HinterOnly$button,
						{abp: 'Prefill with fake data'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$PrefillWithFakeDataClicked)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Prefill')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.aJ ? A3(
				$author$project$Ui$Button$view,
				{abp: 'Skip and finish later'},
				_List_fromArray(
					[
						$author$project$Ui$Button$secondary,
						$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$SkipSetup)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Finish Later')
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$PaymentProcessing$viewLoadingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[
				$author$project$Ui$Typography$helpBlock,
				$author$project$Ui$Typography$muted,
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$Icon$view, _List_Nil, 8)
			]))
	]);
var $author$project$Components$PaymentProcessing$DisconnectStripe = {$: 46};
var $author$project$Components$PaymentProcessing$ShowStripeSupportChat = {$: 49};
var $author$project$Ui$HinterOnly$linkHref = F3(
	function (externalHref_, options, content) {
		return A3(
			$author$project$Ui$Link$externalHref,
			externalHref_,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$icon($author$project$Ui$HinterOnly$icon),
				options),
			content);
	});
var $author$project$Api$Provider$Practice$Shared$stripeLink = function (_v0) {
	var record = _v0;
	return record._X;
};
var $author$project$Api$Provider$Practice$One$stripeLink = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$stripeLink(shared);
};
var $author$project$Components$Stripe$ConnectedView$view = function (config) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'connected'),
							config.FR ? A3(
							$author$project$Ui$HinterOnly$button,
							{abp: 'Disconnect from stripe'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$pull(1),
									$author$project$Ui$Button$onClick(config.ae5)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Disconnect From Stripe')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('You can review your patient payment report '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__PaymentApplications,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							$elm$html$Html$text(' and our latest negotiated transaction fees '),
							A3(
							$author$project$Ui$Link$externalHref,
							'http://www.hint.com/pricing#stripe',
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							$elm$html$Html$text('.'),
							$elm$html$Html$text('If you would like to disable this integration please '),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'contact us'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$onClick(config.afm)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('contact us')
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							function () {
								if (config.FR) {
									var stripeLink = A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Practice$One$stripeLink(config.WF));
									return _List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$linkHref,
											stripeLink,
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text(' View on Stripe')
												]))
										]);
								} else {
									return _List_Nil;
								}
							}())
						]))
				]))
		]);
};
var $author$project$Components$PaymentProcessing$viewStripeConnectedBody = function (model) {
	return $author$project$Components$Stripe$ConnectedView$view(
		{FR: model.FR, ae5: $author$project$Components$PaymentProcessing$DisconnectStripe, afm: $author$project$Components$PaymentProcessing$ShowStripeSupportChat, WF: model.WF});
};
var $author$project$Components$PaymentProcessing$viewStripeConnectingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Status'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, 'connecting')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 8)
					]))
			]))
	]);
var $author$project$Components$PaymentProcessing$viewStripeEmbeddedOnboardingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Alert$warning,
		_List_fromArray(
			[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
		_List_fromArray(
			[
				$elm$html$Html$text('STEP ONE: To get started, verify your new Stripe account through the link sent to your practice\'s email address. Then proceed to complete the form below.')
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$id('stripe-account-onboarding')
			]),
		_List_Nil)
	]);
var $author$project$Components$PaymentProcessing$BankAccount = 1;
var $author$project$Ui$Padding$Bottom_3 = 9;
var $author$project$Components$PaymentProcessing$Card = 0;
var $author$project$Components$PaymentProcessing$DeleteAll = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$PaymentProcessing$PaginationMsg = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAll = function (a) {
	return {$: 29, a: a};
};
var $author$project$Components$PaymentProcessing$SortTable = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Api$Data$getIntFromHeaders = F2(
	function (data, headerName) {
		if (data.$ === 3) {
			var headers = data.b;
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, headerName, headers));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$PaymentProcessing$paymentMethodsOnStripeColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, '', false, 'Owner'),
		A3($author$project$Api$Column$init, '', false, 'Payment Method'),
		A3($author$project$Api$Column$init, '', false, 'Status'),
		A3($author$project$Api$Column$init, 'last_used_at', true, 'Last Used'),
		A3($author$project$Api$Column$init, '', false, '')
	]);
var $author$project$Ui$SvgIcon$Send = 37;
var $author$project$Ui$SvgIcon$send = $author$project$Ui$SvgIcon$viewIcon(37);
var $author$project$Components$PaymentProcessing$Delete = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdate = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Api$Provider$StripePaymentMethodMigration$All$isDefault = function (_v0) {
	var record = _v0;
	return record.RI;
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastUsedAt = function (_v0) {
	var record = _v0;
	return record.SF;
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$paymentMethodBrand = function (_v0) {
	var record = _v0;
	return record._f;
};
var $author$project$Api$Provider$StripePaymentMethodMigration$All$requestPayInfoSentAt = function (_v0) {
	var record = _v0;
	return record.Yh;
};
var $author$project$Components$PaymentSourceDisplayer$StripePaymentMethodMigration = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$stripePaymentMethodMigration = $author$project$Components$PaymentSourceDisplayer$StripePaymentMethodMigration;
var $author$project$Components$PaymentProcessing$viewPaymentMethodOnStripe = F5(
	function (timeFormatter, canGoToPatients, canGoToCompany, paymentMethodType, paymentMethod) {
		var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
		var ownerName = A2(
			$elm$core$Maybe$withDefault,
			'N/A',
			A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, owner));
		var ownerPath = A2(
			$elm$core$Maybe$andThen,
			function (owner_) {
				var _v3 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
				switch (_v3) {
					case 'Patient':
						return canGoToPatients ? $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
								{
									VN: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
								})) : $elm$core$Maybe$Nothing;
					case 'Company':
						return canGoToCompany ? $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
								{
									ff: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
								})) : $elm$core$Maybe$Nothing;
					default:
						return $elm$core$Maybe$Nothing;
				}
			},
			owner);
		var lastFour = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour(paymentMethod));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (!ownerPath.$) {
								var ownerPath_ = ownerPath.a;
								return A3(
									$author$project$Ui$Link$route,
									ownerPath_,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(ownerName)
										]));
							} else {
								return $elm$html$Html$text(ownerName);
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$StripePaymentMethodMigration$All$paymentMethodBrand(paymentMethod) + (' ' + lastFour))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$PaymentSourceDisplayer$view,
							timeFormatter,
							_List_fromArray(
								[
									$author$project$Components$PaymentSourceDisplayer$stripePaymentMethodMigration(paymentMethod),
									$author$project$Components$PaymentSourceDisplayer$showProcessor(false)
								])),
							$author$project$Api$Provider$StripePaymentMethodMigration$All$isDefault(paymentMethod) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Never',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(1),
											$author$project$Api$Provider$StripePaymentMethodMigration$All$lastUsedAt(paymentMethod))))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$pull(1),
									$author$project$Ui$Typography$padding(2)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete payment method'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$size(0),
											$author$project$Ui$Button$onClick(
											A2($author$project$Components$PaymentProcessing$Delete, paymentMethodType, paymentMethod)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								])),
							function () {
							var _v1 = A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$type_, owner);
							_v1$2:
							while (true) {
								if (!_v1.$) {
									switch (_v1.a) {
										case 'Patient':
											var lastRequestSent = function () {
												var _v2 = $author$project$Api$Provider$StripePaymentMethodMigration$All$requestPayInfoSentAt(paymentMethod);
												if (!_v2.$) {
													var patientRequestInfoSentAt_ = _v2.a;
													var sentAt = A2(timeFormatter, 1, patientRequestInfoSentAt_);
													return A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
														_List_fromArray(
															[
																$elm$html$Html$text('Last request sent ' + (sentAt + '.'))
															]));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}();
											return A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$pull(1)
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{abp: 'Request new payment information'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$size(0),
																$author$project$Ui$Button$onClick(
																A2($author$project$Components$PaymentProcessing$RequestPaymentInfoUpdate, paymentMethodType, paymentMethod)),
																$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Request new payment information')
															])),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														lastRequestSent
													]));
										case 'Company':
											return A3(
												$author$project$Ui$Tooltip$view,
												_List_Nil,
												'Please reach out to the company directly',
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{abp: 'Request new payment information'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$size(0),
																$author$project$Ui$Button$disabled(true),
																$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Request new payment information')
															]))
													]));
										default:
											break _v1$2;
									}
								} else {
									break _v1$2;
								}
							}
							return $author$project$Utils$Html$empty;
						}()
						]))
				]));
	});
var $author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe = F2(
	function (model, paymentMethodType) {
		var _v0 = function () {
			if (!paymentMethodType) {
				return _Utils_Tuple3(model.cI, model.ll, model.e9);
			} else {
				return _Utils_Tuple3(model.cB, model.k9, model.e3);
			}
		}();
		var paymentMethodsOnStripe = _v0.a;
		var sort = _v0.b;
		var pagination = _v0.c;
		var onStripeCount = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($author$project$Api$Data$getIntFromHeaders, paymentMethodsOnStripe, 'x-total-count'));
		if (onStripeCount > 0) {
			var title = function () {
				if (!paymentMethodType) {
					return 'Cards';
				} else {
					return 'Bank Accounts';
				}
			}();
			var onRainforestCount = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($author$project$Api$Data$getIntFromHeaders, paymentMethodsOnStripe, 'x-on-rainforest-count'));
			var totalCount = onStripeCount + onRainforestCount;
			var _v2 = function () {
				if (paymentMethodsOnStripe.$ === 3) {
					var list_ = paymentMethodsOnStripe.a;
					return _Utils_Tuple2(false, list_);
				} else {
					return _Utils_Tuple2(true, _List_Nil);
				}
			}();
			var loading = _v2.a;
			var list = _v2.b;
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$pull(0)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$bold]),
										_List_fromArray(
											[
												$elm$html$Html$text(title)
											])),
										$elm$html$Html$text(' - '),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$info]),
										_List_fromArray(
											[
												$elm$html$Html$text('Total Payment Methods: '),
												$elm$html$Html$text(
												$elm$core$String$fromInt(totalCount))
											])),
										$elm$html$Html$text(' - '),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$success]),
										_List_fromArray(
											[
												$elm$html$Html$text('Live on Hint Payments: '),
												$elm$html$Html$text(
												$elm$core$String$fromInt(onRainforestCount))
											])),
										$elm$html$Html$text(' - '),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$danger]),
										_List_fromArray(
											[
												$elm$html$Html$text('Remaining on Stripe: '),
												$elm$html$Html$text(
												$elm$core$String$fromInt(onStripeCount))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$pull(1)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Request all payment methods'},
								_List_fromArray(
									[
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$loading(
										_Utils_eq(
											$elm$core$Maybe$Just($author$project$Api$Data$Loading),
											A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.eu))),
										$author$project$Ui$Button$onClick(
										$author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAll(paymentMethodType)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Request All')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Delete all payment methods'},
								_List_fromArray(
									[
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$loading(
										_Utils_eq(
											$elm$core$Maybe$Just($author$project$Api$Data$Loading),
											A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.dF))),
										$author$project$Ui$Button$onClick(
										$author$project$Components$PaymentProcessing$DeleteAll(paymentMethodType)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete All')
									]))
							])),
						$author$project$Ui$Clearfix$view,
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$padding(8)
							]),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$author$project$Ui$Table$view,
										_List_fromArray(
											[
												$author$project$Ui$Table$loading(loading),
												$author$project$Ui$Table$zeroState(
												_List_fromArray(
													[
														$elm$html$Html$text('All payment methods are migrated to Hint Payments!')
													]))
											]),
										A2(
											$elm$core$List$map,
											$author$project$Api$Column$view(
												A2(
													$author$project$Api$Column$Sortable,
													sort,
													$author$project$Components$PaymentProcessing$SortTable(paymentMethodType))),
											$author$project$Components$PaymentProcessing$paymentMethodsOnStripeColumns),
										A2(
											$elm$core$List$map,
											A4($author$project$Components$PaymentProcessing$viewPaymentMethodOnStripe, model.Hy, model.Er, model.Eq, paymentMethodType),
											list),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$PaymentProcessing$PaginationMsg(paymentMethodType),
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(loading)
												]),
											pagination))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$PaymentProcessing$viewStripePaymentSourceMigration = function (model) {
	var hasPaymentMethodsOnStripe = function () {
		var _v0 = _Utils_Tuple2(model.cI, model.cB);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var cardsOnStripe_ = _v1.a;
			var _v2 = _v0.b;
			var bankAccountsOnStripe_ = _v2.a;
			return (!$elm$core$List$isEmpty(cardsOnStripe_)) || (!$elm$core$List$isEmpty(bankAccountsOnStripe_));
		} else {
			return false;
		}
	}();
	return hasPaymentMethodsOnStripe ? A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Stripe Payment Source Migration')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpText]),
				_List_fromArray(
					[
						$elm$html$Html$text('Your transition to Hint Payments is nearly complete.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Some patient payment sources are still on Stripe and may process there until migration is finished. '),
						$elm$html$Html$text('Use this dashboard to review or delete outdated sources, or request updated info to help wrap up your migration sooner.')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text('Note: This list excludes archived patients and companies')
					])),
				A2($author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe, model, 0),
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[
						$author$project$Ui$Typography$padding(9)
					]),
				_List_Nil),
				A2($author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe, model, 1)
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$PaymentProcessing$view = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.dQ;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var paymentMethodType = _v2.a;
					var paymentMethod = _v2.b;
					var deletingRequest = _v2.c;
					return A2(
						$author$project$Components$HiConfirm$modal,
						A2($author$project$Components$PaymentProcessing$DeleteHiConfirmClosed, paymentMethodType, paymentMethod),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('payment method'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deletingRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.ev;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var paymentMethodType = _v4.a;
					var paymentMethod = _v4.b;
					var requestingRequest = _v4.c;
					return A2(
						$author$project$Components$HiConfirm$modal,
						A2($author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed, paymentMethodType, paymentMethod),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('request'),
								$author$project$Components$HiConfirm$noun('payment info update'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('You are about to send an email asking the patient to update this payment method.')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(requestingRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.dF;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var paymentMethodType = _v6.a;
					var deletingRequest = _v6.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$PaymentProcessing$DeleteAllHiConfirmClosed(paymentMethodType),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete all'),
								$author$project$Components$HiConfirm$noun('payment methods'),
								$author$project$Components$HiConfirm$buttonStyle(5),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deletingRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v7 = model.eu;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var paymentMethodType = _v8.a;
					var requestingRequest = _v8.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAllHiConfirmClosed(paymentMethodType),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('request'),
								$author$project$Components$HiConfirm$noun('payment info update'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('You are about to send emails asking patients to update all payment methods .')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(requestingRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateApplicationEventModal$view,
						$elm$html$Html$map($author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg)),
					model.ka)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$ResetAccountModal$view,
						$elm$html$Html$map($author$project$Components$PaymentProcessing$ResetAccountModalMsg)),
					model.jR)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$MigrateBackToStripeModal$view,
						$elm$html$Html$map($author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg)),
					model.jd)),
				model.gT ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Components$PaymentProcessing$StripeHiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								$elm$html$Html$text('WARNING: You\'re about to remove your ability to process credit cards and bank accounts! Please be sure this is what you want to do. If you reconnect the same Stripe account, then all existing cards / bank accounts will remain intact. Otherwise, they will not. Either way, this application will not be able to process any electronic transactions for you while you\'re account is disconnected.')
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						model.aJ ? _List_fromArray(
							[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														model.aJ ? $elm$html$Html$text('Setup Payment Processing') : $elm$html$Html$text('Payment Processing')
													])),
												function () {
												if (model.FR) {
													var _v9 = model.ag7;
													if (_v9.$ === 1) {
														var rainforestAccount = _v9.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$HinterOnly$button,
																	{abp: 'Sync with Rainforest'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$secondary,
																			$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$Sync),
																			$author$project$Ui$Button$loading(
																			_Utils_eq(model.oG, $author$project$Api$Data$Loading))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Sync with Rainforest')
																		])),
																	A3(
																	$author$project$Ui$HinterOnly$button,
																	{abp: 'Reset Rainforest account'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$secondary,
																			$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$OpenResetAccountModal)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Reset Rainforest account')
																		])),
																	($author$project$Api$Provider$RainforestAccount$One$status(rainforestAccount) === 'canceled') ? A3(
																	$author$project$Ui$HinterOnly$button,
																	{abp: 'Delete Rainforest account'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$danger,
																			$author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$DeleteRainforestAccount),
																			$author$project$Ui$Button$loading(
																			_Utils_eq(model.fm, $author$project$Api$Data$Loading))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Delete Rainforest account')
																		])) : $author$project$Utils$Html$empty
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											])),
										model.aJ ? A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('Set up your Payment Processing account to start accepting payments.')
											])) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_Utils_ap(
									function () {
										var _v10 = model.ag7;
										switch (_v10.$) {
											case 0:
												return $author$project$Components$PaymentProcessing$viewLoadingBody;
											case 1:
												var rainforestAccount = _v10.a;
												return A2($author$project$Components$PaymentProcessing$viewHasAccountBody, rainforestAccount, model);
											case 2:
												return A2(
													$author$project$Components$PaymentProcessing$viewCreateAccountBody,
													model.aJ,
													A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, model.WF));
											case 3:
												return $author$project$Components$PaymentProcessing$viewStripeConnectingBody;
											case 4:
												return $author$project$Components$PaymentProcessing$viewStripeEmbeddedOnboardingBody;
											default:
												return $author$project$Components$PaymentProcessing$viewStripeConnectedBody(model);
										}
									}(),
									(($author$project$Api$Provider$Practice$One$paymentProcessor(model.WF) === 'rainforest') && (!model.aJ)) ? _List_fromArray(
										[
											$author$project$Components$PaymentProcessing$viewStripePaymentSourceMigration(model)
										]) : _List_Nil)),
								function () {
								var _v11 = model.ag7;
								switch (_v11.$) {
									case 2:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[
													model.aJ ? $author$project$Ui$Element$spaceBetween : $author$project$Ui$Element$justifyCenter,
													$author$project$Ui$Element$gap4
												]),
											$author$project$Components$PaymentProcessing$viewCreateAccountFooter(model));
									case 1:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap4]),
											_List_fromArray(
												[
													$author$project$Components$PaymentProcessing$viewHasAccountFooter(model)
												]));
									default:
										return $author$project$Ui$Panel$none;
								}
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$PaymentProcessing$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$PaymentProcessing$view(model.np))
			]),
		$G: 'Admin | Payment Processing'
	};
};
var $author$project$Pages$Admin$PaymentProcessing$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$PaymentProcessing$init, aer: $author$project$Pages$Admin$PaymentProcessing$load, agD: $author$project$Pages$Admin$PaymentProcessing$save, ahd: $author$project$Pages$Admin$PaymentProcessing$subscriptions, aaq: $author$project$Pages$Admin$PaymentProcessing$update, ahP: $author$project$Pages$Admin$PaymentProcessing$view});
var $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Closed = {$: 0};
var $author$project$Components$CreatePaymentMethodModal$init = $author$project$Components$CreatePaymentMethodModal$Closed;
var $author$project$Components$Practice$PaymentSources$init = F6(
	function (session, practice, imageStore, timeFormatter, isHintAdmin, rainforestEnv) {
		return _Utils_Tuple2(
			{pD: $author$project$Api$Data$Loading, pN: $author$project$Api$Data$Loading, lB: $author$project$Components$CreatePaymentMethodModal$init, fr: $elm$core$Maybe$Nothing, dR: $elm$core$Set$empty, qT: imageStore, FR: isHintAdmin, WF: practice, sj: rainforestEnv, ZD: session, Hy: timeFormatter},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$PaymentSources$GotBankAccounts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$PaymentSources$GotCards = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$PaymentSources$loadData = function (apiClient) {
	return _Utils_Tuple3(
		$author$project$Api$Data$Loading,
		$author$project$Api$Data$Loading,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$PaymentSources$GotCards),
					A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$PaymentSources$GotBankAccounts)
				])));
};
var $author$project$Pages$Admin$PaymentSources$init = F4(
	function (session, practice, shared, _v0) {
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var _v1 = A6($author$project$Components$Practice$PaymentSources$init, session, practice, shared.qT, shared.Hy, isHintAdmin, shared.sj);
		var practicePaymentSources = _v1.a;
		var practicePaymentSourcesCmd = _v1.b;
		var _v2 = $author$project$Pages$Admin$PaymentSources$loadData(shared.D5);
		var cards = _v2.a;
		var bankAccounts = _v2.b;
		var cmd = _v2.c;
		return _Utils_Tuple2(
			{D5: shared.D5, pD: bankAccounts, pN: cards, FR: isHintAdmin, aK: $elm$core$Maybe$Nothing, WF: practice, cj: practicePaymentSources, ZD: session, Hy: shared.Hy},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg, practicePaymentSourcesCmd)
					])));
	});
var $author$project$Pages$Admin$PaymentSources$load = F2(
	function (shared, model) {
		var _v0 = shared.ZD;
		if (_v0.$ === 3) {
			var session = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ZD: session}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Admin$PaymentSources$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$PaymentSources$CancelEdit = {$: 4};
var $author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Close = {$: 1};
var $author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotLocalStorageItem = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotStripeCardPaymentMethod = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$StripeElementTypeChanged = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ports$Stripe$stripePortOnSetupIntentChange = _Platform_incomingPort('stripePortOnSetupIntentChange', $elm$json$Json$Decode$string);
var $author$project$Ports$Stripe$onSetupIntentChanged = function (elementType) {
	return $author$project$Ports$Stripe$stripePortOnSetupIntentChange(elementType);
};
var $author$project$Ports$Stripe$StripeSetupIntentResponse = F3(
	function (selector, paymentMethod, error) {
		return {xs: error, VZ: paymentMethod, be: selector};
	});
var $author$project$Ports$Stripe$StripeCardPaymentMethod = function (id) {
	return {adR: id};
};
var $author$project$Ports$Stripe$stripePaymentMethodFromSetupIntentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_method',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Ports$Stripe$StripeCardPaymentMethod));
var $author$project$Ports$Stripe$stripeSetupIntentResponseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'setup_intent',
		$elm$json$Json$Decode$maybe($author$project$Ports$Stripe$stripePaymentMethodFromSetupIntentDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selector',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Ports$Stripe$StripeSetupIntentResponse))));
var $author$project$Ports$Stripe$decodeStripeSetupIntentResponse = F2(
	function (msg, response) {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$Stripe$stripeSetupIntentResponseDecoder, response);
		if (!_v0.$) {
			var setupIntentResponse = _v0.a;
			var _v1 = setupIntentResponse.VZ;
			if (_v1.$ === 1) {
				var _v2 = setupIntentResponse.xs;
				if (_v2.$ === 1) {
					return msg(
						$elm$core$Result$Err(''));
				} else {
					var error = _v2.a;
					return msg(
						$elm$core$Result$Err(error));
				}
			} else {
				var setupIntent = _v1.a;
				return msg(
					$elm$core$Result$Ok(setupIntent));
			}
		} else {
			return msg(
				$elm$core$Result$Err('Something went wrong, please try again.'));
		}
	});
var $author$project$Ports$Stripe$stripePortOnSetupIntentConfirmed = _Platform_incomingPort('stripePortOnSetupIntentConfirmed', $elm$json$Json$Decode$value);
var $author$project$Ports$Stripe$onSetupIntentConfirmed = function (response) {
	return $author$project$Ports$Stripe$stripePortOnSetupIntentConfirmed(
		$author$project$Ports$Stripe$decodeStripeSetupIntentResponse(response));
};
var $author$project$Components$CreatePaymentMethodModal$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				if (model.$ === 1) {
					return $author$project$Ports$Stripe$onSetupIntentConfirmed($author$project$Components$CreatePaymentMethodModal$GotStripeCardPaymentMethod);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				if (model.$ === 1) {
					var connectingModal = model.a.hT;
					if (!connectingModal.$) {
						var justConnectingModal = connectingModal.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg,
							$author$project$Components$CardReader$ConnectingModal$subscriptions(justConnectingModal));
					} else {
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CreatePaymentMethodModal$Close);
					}
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Ports$LocalStorage$gotItem($author$project$Components$CreatePaymentMethodModal$GotLocalStorageItem),
				$author$project$Ports$Stripe$onSetupIntentChanged($author$project$Components$CreatePaymentMethodModal$StripeElementTypeChanged)
			]));
};
var $author$project$Components$Practice$PaymentSources$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg,
		$author$project$Components$CreatePaymentMethodModal$subscriptions(model.lB));
};
var $author$project$Pages$Admin$PaymentSources$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg,
				$author$project$Components$Practice$PaymentSources$subscriptions(model.cj)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$PaymentSources$CancelEdit)),
					model.aK))
			]));
};
var $author$project$Pages$Admin$PaymentSources$formFieldsFromPaymentCategory = function (paymentCategory) {
	return {Ex: paymentCategory.Ex, Hg: paymentCategory.Nl};
};
var $author$project$Pages$Admin$PaymentSources$formFieldsUpdate = F3(
	function (sources, field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{
				Hg: A2(
					$elm_community$list_extra$List$Extra$find,
					function (source) {
						return _Utils_eq(
							$author$project$Api$Source$id(source),
							string);
					},
					sources)
			});
	});
var $author$project$Pages$Admin$PaymentSources$SourceValidation = 0;
var $author$project$Pages$Admin$PaymentSources$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Hg;
			},
			_Utils_Tuple2(0, 'Please pick a source.'))
		]));
var $author$project$Components$Practice$PaymentSources$initBankAccounts = F2(
	function (bankAccounts, model) {
		return _Utils_update(
			model,
			{pD: bankAccounts});
	});
var $author$project$Components$Practice$PaymentSources$initCards = F2(
	function (cards, model) {
		return _Utils_update(
			model,
			{pN: cards});
	});
var $author$project$Components$Practice$PaymentSources$Deleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Practice$PaymentSources$None = 2;
var $author$project$Components$Practice$PaymentSources$PaymentMethodCreated = 0;
var $author$project$Components$Practice$PaymentSources$PaymentMethodDeleted = 1;
var $author$project$Api$Employer$BankAccount$bankAccountPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Employer$BankAccount$bankAccountsPath(basePath));
	});
var $author$project$Api$Employer$BankAccount$delete = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_)));
	});
var $author$project$Api$BankAccount$delete = F5(
	function (basePath, apiClient, session, bankAccount, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$BankAccount$delete,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			toMsg) : A4(
			$author$project$Api$Provider$BankAccount$delete,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			toMsg);
	});
var $author$project$Api$Employer$Card$cardPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Employer$Card$cardsPath(basePath));
	});
var $author$project$Api$Employer$Card$delete = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$Card$cardPath, basePath, id_)));
	});
var $author$project$Api$Card$delete = F5(
	function (basePath, apiClient, session, card, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$Card$delete,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			toMsg) : A4(
			$author$project$Api$Provider$Card$delete,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			toMsg);
	});
var $author$project$Api$Source$delete = F5(
	function (basePath, apiClient, session, source, toMsg) {
		switch (source.$) {
			case 0:
				var card = source.a;
				return A5($author$project$Api$Card$delete, basePath, apiClient, session, card, toMsg);
			case 1:
				var bankAccount = source.a;
				return A5($author$project$Api$BankAccount$delete, basePath, apiClient, session, bankAccount, toMsg);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$CreatePaymentMethodModal$BankAccount = 0;
var $author$project$Components$CreatePaymentMethodModal$Card = 1;
var $author$project$Components$CreatePaymentMethodModal$CardReader = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotCardReaders = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotPaymentInfoUpdate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$GotSetupConfig = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Loading = {$: 0};
var $author$project$Components$CreatePaymentMethodModal$None = 1;
var $author$project$Components$CreatePaymentMethodModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$PaymentMethodCreatedEvent = 0;
var $author$project$Components$CreatePaymentMethodModal$Rainforest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Stripe = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished = {$: 9};
var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Employer$Company$One$acceptsAmex = function (_v0) {
	var one = _v0.b;
	return one.H$;
};
var $author$project$Api$Provider$Company$One$acceptsAmex = function (_v0) {
	var record = _v0.b;
	return record.H$;
};
var $author$project$Api$Company$acceptsAmex = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$acceptsAmex(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$acceptsAmex(company_);
	}
};
var $author$project$Components$CreatePaymentMethodModal$acceptsAmex = F2(
	function (owner, session) {
		if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			return true;
		} else {
			if (!owner.$) {
				var company = owner.a;
				return $author$project$Api$Company$acceptsAmex(company);
			} else {
				return true;
			}
		}
	});
var $author$project$Components$CreatePaymentMethodModal$andNoop = function (model) {
	return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
};
var $0ui$elm_task_parallel$Task$Parallel$ItemLoaded = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $0ui$elm_task_parallel$Task$Parallel$ListState = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $0ui$elm_task_parallel$Task$Parallel$routeTo = F2(
	function (successMsg, failureMsg) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$Task$andThen(
				A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $elm$core$Result$Ok)),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Task$onError(
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $elm$core$Result$Err)),
				$elm$core$Task$perform(
					function (result) {
						if (!result.$) {
							var a = result.a;
							return successMsg(a);
						} else {
							var err = result.a;
							return failureMsg(err);
						}
					})));
	});
var $0ui$elm_task_parallel$Task$Parallel$attemptList = function (_v0) {
	var tasks = _v0.$q;
	var onUpdates = _v0.U4;
	var onSuccess = _v0.U1;
	var onFailure = _v0.U$;
	return _Utils_Tuple2(
		A2(
			$0ui$elm_task_parallel$Task$Parallel$ListState,
			onSuccess,
			A2(
				$elm$core$List$map,
				$elm$core$Basics$always($elm$core$Maybe$Nothing),
				tasks)),
		$elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, task) {
						return A3(
							$0ui$elm_task_parallel$Task$Parallel$routeTo,
							A2(
								$elm$core$Basics$composeL,
								onUpdates,
								$0ui$elm_task_parallel$Task$Parallel$ItemLoaded(index)),
							onFailure,
							task);
					}),
				tasks)));
};
var $author$project$Ports$Stripe$StripeElementsOptions = {};
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $author$project$Ports$Stripe$stripePortBuildAndMountElementWithSetupIntent = _Platform_outgoingPort(
	'stripePortBuildAndMountElementWithSetupIntent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'acceptAmex',
					$elm$json$Json$Encode$bool($.DU)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.zh)),
					_Utils_Tuple2(
					'options',
					function ($) {
						return $elm$json$Json$Encode$object(_List_Nil);
					}($.zY)),
					_Utils_Tuple2(
					'practiceStripePublicKey',
					function ($) {
						return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
					}($.GO)),
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.be)),
					_Utils_Tuple2(
					'setupIntentSecret',
					$elm$json$Json$Encode$string($.G9)),
					_Utils_Tuple2(
					'zip',
					$elm$json$Json$Encode$string($.tC))
				]));
	});
var $author$project$Ports$Stripe$buildAndMountElementWithSetupIntent = F6(
	function (practiceStripePublicKey, setupIntentSecret, selector, acceptAmex, name, zip) {
		return $author$project$Ports$Stripe$stripePortBuildAndMountElementWithSetupIntent(
			{DU: acceptAmex, zh: name, zY: $author$project$Ports$Stripe$StripeElementsOptions, GO: practiceStripePublicKey, be: selector, G9: setupIntentSecret, tC: zip});
	});
var $author$project$Api$Employer$Company$One$address = function (_v0) {
	var record = _v0.b;
	return record.It;
};
var $author$project$Api$Provider$Company$One$address = function (_v0) {
	var record = _v0.b;
	return record.It;
};
var $author$project$Api$Company$address = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$address(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$address(company_);
	}
};
var $author$project$Api$Employer$Practice$One$address = function (_v0) {
	var record = _v0;
	return record.It;
};
var $author$project$Api$Practice$address = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$address(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$address(practice_);
	}
};
var $author$project$Api$Provider$Patient$One$address = function (_v0) {
	var record = _v0.b;
	return record.It;
};
var $author$project$Api$Provider$Patient$One$billingAddress = function (_v0) {
	var record = _v0.b;
	return record.JZ;
};
var $author$project$Api$Employer$Company$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$Company$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$name(shared);
};
var $author$project$Api$Provider$Company$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$name(shared);
};
var $author$project$Api$Company$name = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$name(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$name(company_);
	}
};
var $author$project$Api$Employer$Practice$One$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Practice$name = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$name(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$name(practice_);
	}
};
var $author$project$Api$Provider$Patient$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$name(shared);
};
var $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner = function (owner) {
	switch (owner.$) {
		case 1:
			var practice = owner.a;
			var zip = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Address$Shared$zip,
					$author$project$Api$Practice$address(practice)));
			return _Utils_Tuple2(
				$author$project$Api$Practice$name(practice),
				zip);
		case 0:
			var company = owner.a;
			var zip = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Address$Shared$zip,
					$author$project$Api$Company$address(company)));
			return _Utils_Tuple2(
				$author$project$Api$Company$name(company),
				zip);
		default:
			var patient = owner.a;
			var billing = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Address$Shared$zip,
					$author$project$Api$Provider$Patient$One$billingAddress(patient)));
			var zip = (!$elm$core$String$isEmpty(billing)) ? billing : A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Address$Shared$zip,
					$author$project$Api$Provider$Patient$One$address(patient)));
			return _Utils_Tuple2(
				$author$project$Api$Provider$Patient$One$name(patient),
				zip);
	}
};
var $author$project$Components$CreatePaymentMethodModal$stripeElementId = 'card-element';
var $author$project$Api$Employer$Practice$One$stripePublishableKey = function (_v0) {
	var record = _v0;
	return record._Z;
};
var $author$project$Api$Provider$Practice$Shared$stripePublishableKey = function (_v0) {
	var record = _v0;
	return record._Z;
};
var $author$project$Api$Provider$Practice$One$stripePublishableKey = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$stripePublishableKey(shared);
};
var $author$project$Api$Practice$stripePublishableKey = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$stripePublishableKey(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$stripePublishableKey(practice_);
	}
};
var $author$project$Components$CreatePaymentMethodModal$buildStripeElement = F4(
	function (practice, clientSecret, owner, session) {
		var _v0 = $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner(owner);
		var name = _v0.a;
		var zip = _v0.b;
		return A6(
			$author$project$Ports$Stripe$buildAndMountElementWithSetupIntent,
			$author$project$Api$Practice$stripePublishableKey(practice),
			clientSecret,
			'#' + $author$project$Components$CreatePaymentMethodModal$stripeElementId,
			A2($author$project$Components$CreatePaymentMethodModal$acceptsAmex, owner, session),
			name,
			zip);
	});
var $author$project$Components$CreatePaymentMethodModal$cardParamsFromReader = function (readCard) {
	return {
		KI: $elm$core$Maybe$Nothing,
		Mi: $elm$core$Maybe$Just(readCard.Mi),
		Sz: $elm$core$Maybe$Nothing,
		U7: $elm$core$Maybe$Just(readCard.U7),
		V1: readCard.V1
	};
};
var $author$project$Ports$Stripe$stripePortConfirmSetupIntent = _Platform_outgoingPort(
	'stripePortConfirmSetupIntent',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'options',
					function ($) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'billingOptions',
									function ($) {
										return A3(
											$elm$core$Maybe$destruct,
											$elm$json$Json$Encode$null,
											function ($) {
												return $elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'name',
															$elm$json$Json$Encode$string($.zh))
														]));
											},
											$);
									}($.abE))
								]));
					}($.zY)),
					_Utils_Tuple2(
					'selector',
					$elm$json$Json$Encode$string($.be))
				]));
	});
var $author$project$Ports$Stripe$confirmSetupIntent = F2(
	function (selector, options) {
		return $author$project$Ports$Stripe$stripePortConfirmSetupIntent(
			{zY: options, be: selector});
	});
var $author$project$Components$CreatePaymentMethodModal$Created = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$CreatePaymentMethodModal$createCardFromReader = F5(
	function (basePath, apiClient, session, categories, cardParams) {
		return A5(
			$author$project$Api$Card$create,
			basePath,
			apiClient,
			session,
			cardParams,
			$author$project$Components$CreatePaymentMethodModal$Created(categories));
	});
var $author$project$Components$CreatePaymentMethodModal$PaymentMethodCreated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$PaymentMethod$PaymentMethod = $elm$core$Basics$identity;
var $author$project$Api$PaymentMethod$SharedRecordBankAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$PaymentMethod$bankAccountOneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$SharedRecordBankAccount, $author$project$Api$Provider$BankAccount$Shared$decoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$PaymentMethod$SharedRecordCard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$PaymentMethod$cardOneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$SharedRecordCard, $author$project$Api$Provider$Card$Shared$decoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$PaymentMethod$oneDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Api$PaymentMethod$cardOneDecoder, $author$project$Api$PaymentMethod$bankAccountOneDecoder]));
var $author$project$Api$PaymentMethod$paymentMethodsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['payment_methods']),
		basePath);
};
var $author$project$Api$PaymentMethod$create = F5(
	function (basePath, apiClient, param, setAsDefault, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_method',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							$author$project$Api$PaymentProcessorParams$encode(param),
							function () {
								if (!setAsDefault.$) {
									var value = setAsDefault.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'set_as_default',
											$elm$json$Json$Encode$bool(value))
										]);
								} else {
									return _List_Nil;
								}
							}())))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$PaymentMethod$oneDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$PaymentMethod$paymentMethodsPath(basePath))));
	});
var $author$project$Components$CreatePaymentMethodModal$createPaymentMethod = F5(
	function (basePath, apiClient, paymentMethodParams, categories, setAsDefault) {
		return A5(
			$author$project$Api$PaymentMethod$create,
			basePath,
			apiClient,
			paymentMethodParams,
			$elm$core$Maybe$Just(setAsDefault),
			$author$project$Components$CreatePaymentMethodModal$PaymentMethodCreated(categories));
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var y = xs.a;
			var ys = xs.b;
			return _Utils_eq(x, y) ? ys : A2(
				$elm$core$List$cons,
				y,
				A2($elm_community$list_extra$List$Extra$remove, x, ys));
		}
	});
var $author$project$Components$CreatePaymentMethodModal$formFieldsUpdate = F3(
	function (cardReaders, field, fields) {
		switch (field.$) {
			case 0:
				var cardInput = field.a;
				return _Utils_update(
					fields,
					{cH: cardInput});
			case 1:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						abR: A2(
							$elm_community$list_extra$List$Extra$find,
							function (cardReader_) {
								return _Utils_eq(
									$author$project$Api$Provider$CardReader$All$id(cardReader_),
									id);
							},
							cardReaders)
					});
			case 2:
				var category = field.a;
				var bool = field.b;
				var categories = bool ? A2($elm$core$List$cons, category, fields.KL) : A2($elm_community$list_extra$List$Extra$remove, category, fields.KL);
				return _Utils_update(
					fields,
					{KL: categories});
			case 3:
				var brand = field.a;
				return _Utils_update(
					fields,
					{vX: brand});
			default:
				var value = field.a;
				return _Utils_update(
					fields,
					{gI: value});
		}
	});
var $author$project$Components$CreatePaymentMethodModal$NameValidation = 0;
var $author$project$Components$CreatePaymentMethodModal$CardBrandValidation = 2;
var $author$project$Components$CreatePaymentMethodModal$validateCardBrand = F3(
	function (processorConfig, acceptsAmex_, fields) {
		var _v0 = _Utils_Tuple3(processorConfig, acceptsAmex_, fields.vX);
		if (((_v0.a.$ === 2) && (!_v0.b)) && (_v0.c === 'AMERICAN_EXPRESS')) {
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'American Express is not accepted.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$CreatePaymentMethodModal$CardReaderValidation = 1;
var $author$project$Components$CreatePaymentMethodModal$validateCardReader = function (fields) {
	var _v0 = _Utils_Tuple2(fields.cH, fields.abR);
	if ((_v0.a === 1) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please pick a card reader.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CreatePaymentMethodModal$formFieldsValidator = F2(
	function (processorConfig, acceptsAmex_) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.zh;
					},
					_Utils_Tuple2(0, 'Please enter a name.')),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CreatePaymentMethodModal$validateCardReader),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$CreatePaymentMethodModal$validateCardBrand, processorConfig, acceptsAmex_))
				]));
	});
var $author$project$Api$Provider$Card$All$one_ = function (_v0) {
	var one = _v0;
	return one;
};
var $author$project$Api$Provider$Card$One$shared_ = function (_v0) {
	var shared = _v0.a;
	return shared;
};
var $author$project$Api$PaymentMethod$fromCardAll = function (card) {
	return $author$project$Api$PaymentMethod$SharedRecordCard(
		$author$project$Api$Provider$Card$One$shared_(
			$author$project$Api$Provider$Card$All$one_(card)));
};
var $author$project$Api$PaymentMethod$fromCardOne = function (card) {
	return $author$project$Api$PaymentMethod$SharedRecordCard(
		$author$project$Api$Provider$Card$One$shared_(card));
};
var $author$project$Api$PaymentMethod$Rainforest = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$PaymentMethod$RainforestSetupConfig = F3(
	function (sessionKey, paymentMethodConfigId, allowedMethods) {
		return {abl: allowedMethods, afH: paymentMethodConfigId, agS: sessionKey};
	});
var $author$project$Api$PaymentMethod$Stripe = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$PaymentMethod$setupDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$json$Json$Decode$andThen,
			function (processor) {
				switch (processor) {
					case 'stripe':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Api$PaymentMethod$Stripe,
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['stripe_client_secret']),
								$elm$json$Json$Decode$string));
					case 'rainforest':
						return A2(
							$elm$json$Json$Decode$map,
							$author$project$Api$PaymentMethod$Rainforest,
							A4(
								$elm$json$Json$Decode$map3,
								$author$project$Api$PaymentMethod$RainforestSetupConfig,
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['session_key']),
									$elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['payment_method_config_id']),
									$elm$json$Json$Decode$string),
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['allowed_methods']),
									$elm$json$Json$Decode$string)));
					default:
						return $elm$json$Json$Decode$fail('Unsupported processor ' + processor);
				}
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['payment_processor']),
				$elm$json$Json$Decode$string)),
			A2(
			$elm$json$Json$Decode$map,
			$author$project$Api$PaymentMethod$Stripe,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['stripe_client_secret']),
				$elm$json$Json$Decode$string))
		]));
var $author$project$Api$PaymentMethod$getClientSecret = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$PaymentMethod$setupDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['setup']),
					$author$project$Api$PaymentMethod$paymentMethodsPath(basePath))));
	});
var $author$project$Api$Employer$Company$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$Company$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$id(shared);
};
var $author$project$Api$Provider$Company$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$id(shared);
};
var $author$project$Api$Company$id = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$id(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$id(company_);
	}
};
var $author$project$Api$Employer$Practice$One$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Practice$id = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$id(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$id(practice_);
	}
};
var $author$project$Api$Provider$Patient$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$id(shared);
};
var $author$project$Components$CreatePaymentMethodModal$Manual = 0;
var $author$project$Api$Provider$Source$Defaults$HintCustomer = 0;
var $author$project$Api$Provider$Source$Defaults$Network = 1;
var $author$project$Api$Practice$isNetwork = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$isNetwork(practice_);
	} else {
		return false;
	}
};
var $author$project$Components$Practice$PaymentCategoriesPicker$allCategories = function (practice) {
	return A2(
		$elm$core$List$cons,
		0,
		$author$project$Api$Practice$isNetwork(practice) ? _List_fromArray(
			[1]) : _List_Nil);
};
var $author$project$Components$CreatePaymentMethodModal$initFormFields = F4(
	function (practice, owner, session, processorConfig) {
		var processorElement = function () {
			switch (processorConfig.$) {
				case 1:
					var clientSecret = processorConfig.a;
					return A4($author$project$Components$CreatePaymentMethodModal$buildStripeElement, practice, clientSecret, owner, session);
				case 2:
					return $elm$core$Platform$Cmd$none;
				default:
					return $elm$core$Platform$Cmd$none;
			}
		}();
		var _v0 = $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner(owner);
		var name = _v0.a;
		return _Utils_Tuple2(
			{
				vX: '',
				cH: 0,
				abR: $elm$core$Maybe$Nothing,
				KL: function () {
					if (owner.$ === 1) {
						var prac = owner.a;
						return $author$project$Components$Practice$PaymentCategoriesPicker$allCategories(prac);
					} else {
						return _List_Nil;
					}
				}(),
				zh: name,
				gI: true
			},
			processorElement);
	});
var $author$project$Api$Employer$Company$One$acceptsAch = function (_v0) {
	var record = _v0.b;
	return record.H_;
};
var $author$project$Api$Provider$Company$One$acceptsAch = function (_v0) {
	var record = _v0.b;
	return record.H_;
};
var $author$project$Api$Company$acceptsAch = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$acceptsAch(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$acceptsAch(company_);
	}
};
var $author$project$Components$CreatePaymentMethodModal$acceptsAch = F2(
	function (owner, session) {
		if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			return true;
		} else {
			if (!owner.$) {
				var company = owner.a;
				return $author$project$Api$Company$acceptsAch(company);
			} else {
				return true;
			}
		}
	});
var $author$project$Api$Employer$Company$One$acceptsCards = function (_v0) {
	var record = _v0.b;
	return record.H0;
};
var $author$project$Api$Provider$Company$One$acceptsCards = function (_v0) {
	var record = _v0.b;
	return record.H0;
};
var $author$project$Api$Company$acceptsCards = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$acceptsCards(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$acceptsCards(company_);
	}
};
var $author$project$Components$CreatePaymentMethodModal$acceptsCards = F2(
	function (owner, session) {
		if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			return true;
		} else {
			if (!owner.$) {
				var company = owner.a;
				return $author$project$Api$Company$acceptsCards(company);
			} else {
				return true;
			}
		}
	});
var $author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled = F2(
	function (owner, session) {
		return (!A2($author$project$Components$CreatePaymentMethodModal$acceptsCards, owner, session)) && (!A2($author$project$Components$CreatePaymentMethodModal$acceptsAch, owner, session));
	});
var $author$project$Api$Provider$Patient$One$requestPayInfoSentAt = function (_v0) {
	var record = _v0.b;
	return record.Yh;
};
var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt = function (_v0) {
	var record = _v0;
	return record.Yh;
};
var $author$project$Api$Data$stringifyPath = function (_v0) {
	var path = _v0;
	return $elm$core$String$concat(path);
};
var $author$project$Ports$Rainforest$rainforestSubmitPaymentMethod = _Platform_outgoingPort(
	'rainforestSubmitPaymentMethod',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Rainforest$submitPaymentMethod = $author$project$Ports$Rainforest$rainforestSubmitPaymentMethod(0);
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $author$project$Api$Provider$Source$Defaults$categoryName = function (category) {
	if (!category) {
		return 'hint_customer';
	} else {
		return 'network';
	}
};
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{abf: false, e5: r.e5, OT: r.agq, iJ: r.iJ, F6: r.F6, HA: r.HA, tn: $elm$core$Maybe$Nothing, aav: r.aav});
};
var $author$project$Api$Data$taskResolver = F2(
	function (decoder, response) {
		var result = A2($author$project$Api$Data$handleJsonResponse, decoder, response);
		if (!result.$) {
			var _v1 = result.a;
			var value = _v1.a;
			var headers = _v1.b;
			return $elm$core$Result$Ok(
				A2($author$project$Api$Data$Success, value, headers));
		} else {
			var error = result.a;
			return $elm$core$Result$Err(
				$author$project$Api$Data$Failure(error));
		}
	});
var $author$project$Api$Data$taskRequest = F4(
	function (method, client, decoder, request) {
		return $elm$http$Http$task(
			{
				e5: $author$project$Api$Data$requestBody(request),
				iJ: A2($author$project$Api$Data$requestHeaders, client, request),
				F6: $elm$core$String$toUpper(method),
				agq: $elm$http$Http$stringResolver(
					$author$project$Api$Data$taskResolver(decoder)),
				HA: $elm$core$Maybe$Nothing,
				aav: A2($author$project$Api$Data$requestToUrl, client, request)
			});
	});
var $author$project$Api$Data$postTask = $author$project$Api$Data$taskRequest('post');
var $author$project$Api$Provider$BankAccount$updateDefaultTask = F4(
	function (basePath, apiClient, id_, category) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$string(
						$author$project$Api$Provider$Source$Defaults$categoryName(category)))
				]));
		return A3(
			$author$project$Api$Data$postTask,
			apiClient,
			$author$project$Api$Provider$BankAccount$Shared$decoder,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['default']),
						A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)))));
	});
var $author$project$Api$Provider$Card$updateDefaultTask = F4(
	function (basePath, apiClient, id_, category) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					$elm$json$Json$Encode$string(
						$author$project$Api$Provider$Source$Defaults$categoryName(category)))
				]));
		return A3(
			$author$project$Api$Data$postTask,
			apiClient,
			$author$project$Api$Provider$Card$Shared$decoder,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['default']),
						A2($author$project$Api$Provider$Card$cardPath, basePath, id_)))));
	});
var $author$project$Api$PaymentMethod$updateDefaultTask = F4(
	function (basePath, apiClient, paymentMethod, category) {
		if (!paymentMethod.$) {
			var card = paymentMethod.a;
			return A2(
				$elm$core$Task$mapError,
				function (dataSuccesCard) {
					return A2(
						$author$project$Api$Data$map,
						function (card_) {
							return $author$project$Api$PaymentMethod$SharedRecordCard(card_);
						},
						dataSuccesCard);
				},
				A2(
					$elm$core$Task$map,
					function (dataSuccesCard) {
						return A2(
							$author$project$Api$Data$map,
							function (card_) {
								return $author$project$Api$PaymentMethod$SharedRecordCard(card_);
							},
							dataSuccesCard);
					},
					A4(
						$author$project$Api$Provider$Card$updateDefaultTask,
						basePath,
						apiClient,
						$author$project$Api$Provider$Card$Shared$id(card),
						category)));
		} else {
			var bankAccount = paymentMethod.a;
			return A2(
				$elm$core$Task$mapError,
				function (dataSuccesBankAccount) {
					return A2(
						$author$project$Api$Data$map,
						function (bankAccount_) {
							return $author$project$Api$PaymentMethod$SharedRecordBankAccount(bankAccount_);
						},
						dataSuccesBankAccount);
				},
				A2(
					$elm$core$Task$map,
					function (dataSuccesBankAccount) {
						return A2(
							$author$project$Api$Data$map,
							function (bankAccount_) {
								return $author$project$Api$PaymentMethod$SharedRecordBankAccount(bankAccount_);
							},
							dataSuccesBankAccount);
					},
					A4(
						$author$project$Api$Provider$BankAccount$updateDefaultTask,
						basePath,
						apiClient,
						$author$project$Api$Provider$BankAccount$Shared$id(bankAccount),
						category)));
		}
	});
var $0ui$elm_task_parallel$Task$Parallel$toCmd = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Task$succeed,
			$elm$core$Task$perform($elm$core$Basics$identity))),
	$elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none));
var $0ui$elm_task_parallel$Task$Parallel$updateList = F2(
	function (_v0, _v1) {
		var onSuccess = _v0.a;
		var items = _v0.b;
		var index = _v1.a;
		var newItem = _v1.b;
		var updatedItems = A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, maybeItem) {
					return _Utils_eq(i, index) ? $elm$core$Maybe$Just(newItem) : maybeItem;
				}),
			items);
		return A2(
			$elm$core$List$any,
			$elm$core$Basics$eq($elm$core$Maybe$Nothing),
			updatedItems) ? _Utils_Tuple2(
			A2($0ui$elm_task_parallel$Task$Parallel$ListState, onSuccess, updatedItems),
			$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			A2($0ui$elm_task_parallel$Task$Parallel$ListState, onSuccess, updatedItems),
			$0ui$elm_task_parallel$Task$Parallel$toCmd(
				$elm$core$Maybe$Just(
					onSuccess(
						A2($elm$core$List$filterMap, $elm$core$Basics$identity, updatedItems)))));
	});
var $author$project$Components$CreatePaymentMethodModal$CardBrand = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$updateRainforest = F5(
	function (apiClient, basePath, msg, config, model) {
		switch (msg.$) {
			case 0:
				var rainforestId = msg.a;
				var _v1 = $author$project$Utils$Form$fields(model.PB);
				var setAsDefault = _v1.gI;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							at: $author$project$Components$CreatePaymentMethodModal$Rainforest(config)
						}),
					A5(
						$author$project$Components$CreatePaymentMethodModal$createPaymentMethod,
						basePath,
						apiClient,
						$author$project$Api$PaymentProcessorParams$rainforestParams(rainforestId),
						_List_Nil,
						setAsDefault));
			case 1:
				var isValid = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							at: $author$project$Components$CreatePaymentMethodModal$Rainforest(
								_Utils_update(
									config,
									{yl: isValid}))
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							at: $author$project$Components$CreatePaymentMethodModal$Rainforest(
								_Utils_update(
									config,
									{cW: false}))
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var elementType = msg.a;
				var selectedPaymentOption = function () {
					switch (elementType) {
						case 'ACH':
							return 0;
						case 'CARD':
							return 1;
						default:
							return 1;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							at: $author$project$Components$CreatePaymentMethodModal$Rainforest(config),
							dc: selectedPaymentOption
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var brand = msg.a;
				var field = $author$project$Components$CreatePaymentMethodModal$CardBrand(brand);
				var cardReaders = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.hG));
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders),
					field,
					model.PB);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$CreatePaymentMethodModal$update = F3(
	function (apiClient, msg, model) {
		if (model.$ === 1) {
			var open = model.a;
			switch (msg.$) {
				case 1:
					return $author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Closed);
				case 17:
					var elementType = msg.a;
					var _v2 = open.at;
					if (_v2.$ === 1) {
						var selectedPaymentOption = function () {
							switch (elementType) {
								case 'us_bank_account':
									return 0;
								case 'card':
									return 1;
								default:
									return 1;
							}
						}();
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{dc: selectedPaymentOption})));
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
					}
				case 2:
					var field = msg.a;
					var cmd = function () {
						var _v4 = _Utils_Tuple2(field, open.at);
						if (((!_v4.a.$) && (!_v4.a.a)) && (_v4.b.$ === 1)) {
							var _v5 = _v4.a.a;
							var secret = _v4.b.a;
							return A4($author$project$Components$CreatePaymentMethodModal$buildStripeElement, open.WF, secret, open.Vp, open.ZD);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var cardReaders = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$Api$Data$toMaybe(open.hG));
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders),
						field,
						open.PB);
					return {
						EC: cmd,
						ac5: 1,
						y8: $author$project$Components$CreatePaymentMethodModal$Open(
							_Utils_update(
								open,
								{PB: newForm})),
						as: _List_Nil
					};
				case 3:
					var _v6 = A2(
						$author$project$Utils$Form$validate,
						A2(
							$author$project$Components$CreatePaymentMethodModal$formFieldsValidator,
							open.at,
							A2($author$project$Components$CreatePaymentMethodModal$acceptsAmex, open.Vp, open.ZD)),
						open.PB);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var newForm = _v7.a;
						var validFormFields = _v7.b;
						var _v8 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var cardInput = _v8.cH;
						var cardReader = _v8.abR;
						var _v9 = function () {
							var _v10 = _Utils_Tuple2(cardInput, cardReader);
							if (!_v10.a) {
								var _v11 = _v10.a;
								var portCall = function () {
									var _v12 = open.at;
									switch (_v12.$) {
										case 1:
											return A2(
												$author$project$Ports$Stripe$confirmSetupIntent,
												'#' + $author$project$Components$CreatePaymentMethodModal$stripeElementId,
												{abE: $elm$core$Maybe$Nothing});
										case 2:
											return $author$project$Ports$Rainforest$submitPaymentMethod;
										default:
											return $elm$core$Platform$Cmd$none;
									}
								}();
								return _Utils_Tuple3($elm$core$Maybe$Nothing, portCall, $author$project$Api$Data$Loading);
							} else {
								if (!_v10.b.$) {
									var _v13 = _v10.a;
									var cardReader_ = _v10.b.a;
									var owner = function () {
										var _v14 = open.Vp;
										switch (_v14.$) {
											case 0:
												var company = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Company(
													$author$project$Api$Company$id(company));
											case 1:
												var practice = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Practice(
													$author$project$Api$Practice$id(practice));
											default:
												var patient = _v14.a;
												return $author$project$Components$CardReader$ConnectingModal$Patient(
													$author$project$Api$Provider$Patient$One$id(patient));
										}
									}();
									return A2(
										$author$project$Utils$Tuple3$fromTuple2,
										open.jY,
										A3(
											$elm$core$Tuple$mapBoth,
											$elm$core$Maybe$Just,
											$elm$core$Platform$Cmd$map($author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg),
											A7($author$project$Components$CardReader$ConnectingModal$init, apiClient, open.ZD, open.FR, open.sj, cardReader_, owner, true)));
								} else {
									var _v15 = _v10.a;
									var _v16 = _v10.b;
									return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, open.jY);
								}
							}
						}();
						var connectingModal = _v9.a;
						var cmd = _v9.b;
						var saveRequest = _v9.c;
						return {
							EC: cmd,
							ac5: 1,
							y8: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{hT: connectingModal, PB: newForm, jY: saveRequest})),
							as: _List_Nil
						};
					} else {
						var newForm = _v6.a;
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{PB: newForm})));
					}
				case 4:
					var cardPaymentMethodResult = msg.a;
					if (!cardPaymentMethodResult.$) {
						var stripeCardPaymentMethod = cardPaymentMethodResult.a;
						var params = $author$project$Api$PaymentProcessorParams$stripeParams(stripeCardPaymentMethod.adR);
						var _v18 = $author$project$Utils$Form$fields(open.PB);
						var categories = _v18.KL;
						var setAsDefault = _v18.gI;
						return {
							EC: A5($author$project$Components$CreatePaymentMethodModal$createPaymentMethod, open.vD, apiClient, params, categories, setAsDefault),
							ac5: 1,
							y8: model,
							as: _List_Nil
						};
					} else {
						var errorMessage = cardPaymentMethodResult.a;
						var errorString = A2($elm$core$String$contains, 'billing_details[name]', errorMessage) ? 'Please enter a valid card holder name.' : errorMessage;
						return {
							EC: A3($author$project$Api$PaymentMethod$getClientSecret, open.vD, apiClient, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig),
							ac5: 1,
							y8: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{jY: $author$project$Api$Data$NotAsked})),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, errorString)
								])
						};
					}
				case 5:
					var categories = msg.a;
					var response = msg.b;
					if (response.$ === 3) {
						var card = response.a;
						var _v20 = $author$project$Utils$Form$fields(open.PB);
						var setAsDefault = _v20.gI;
						var tasks = function () {
							if (setAsDefault) {
								switch (card.$) {
									case 0:
										var card_ = card.a;
										return A2(
											$elm$core$List$map,
											function (category) {
												return A4(
													$author$project$Api$PaymentMethod$updateDefaultTask,
													open.vD,
													apiClient,
													$author$project$Api$PaymentMethod$fromCardOne(card_),
													category);
											},
											categories);
									case 1:
										var card_ = card.a;
										return A2(
											$elm$core$List$map,
											function (category) {
												return A4(
													$author$project$Api$PaymentMethod$updateDefaultTask,
													open.vD,
													apiClient,
													$author$project$Api$PaymentMethod$fromCardAll(card_),
													category);
											},
											categories);
									case 2:
										return _List_Nil;
									default:
										return _List_Nil;
								}
							} else {
								return _List_Nil;
							}
						}();
						var _v21 = $elm$core$List$isEmpty(tasks) ? _Utils_Tuple2(
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Task$perform,
								function (_v22) {
									return $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished;
								},
								$elm$time$Time$now)) : A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							$0ui$elm_task_parallel$Task$Parallel$attemptList(
								{
									U$: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed,
									U1: $elm$core$Basics$always($author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished),
									U4: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated,
									$q: tasks
								}));
						var updateDefaultsState = _v21.a;
						var updateDefaultsCmd = _v21.b;
						return {
							EC: updateDefaultsCmd,
							ac5: 1,
							y8: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{o_: updateDefaultsState})),
							as: _List_Nil
						};
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{jY: response})));
					}
				case 6:
					var categories = msg.a;
					var response = msg.b;
					switch (response.$) {
						case 3:
							var paymentMethod = response.a;
							var tasks = function () {
								if ($author$project$Api$Data$stringifyPath(open.vD) === 'employer') {
									return _List_Nil;
								} else {
									var _v27 = $author$project$Utils$Form$fields(open.PB);
									var setAsDefault = _v27.gI;
									return setAsDefault ? A2(
										$elm$core$List$map,
										function (category) {
											return A4($author$project$Api$PaymentMethod$updateDefaultTask, open.vD, apiClient, paymentMethod, category);
										},
										categories) : _List_Nil;
								}
							}();
							var _v25 = $elm$core$List$isEmpty(tasks) ? _Utils_Tuple2(
								$elm$core$Maybe$Nothing,
								A2(
									$elm$core$Task$perform,
									function (_v26) {
										return $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished;
									},
									$elm$time$Time$now)) : A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								$0ui$elm_task_parallel$Task$Parallel$attemptList(
									{
										U$: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed,
										U1: $elm$core$Basics$always($author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished),
										U4: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated,
										$q: tasks
									}));
							var updateDefaultsState = _v25.a;
							var updateDefaultsCmd = _v25.b;
							return {
								EC: updateDefaultsCmd,
								ac5: 1,
								y8: $author$project$Components$CreatePaymentMethodModal$Open(
									_Utils_update(
										open,
										{o_: updateDefaultsState})),
								as: _List_Nil
							};
						case 2:
							return {
								EC: A3($author$project$Api$PaymentMethod$getClientSecret, open.vD, apiClient, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig),
								ac5: 1,
								y8: $author$project$Components$CreatePaymentMethodModal$Open(
									_Utils_update(
										open,
										{jY: $author$project$Api$Data$NotAsked})),
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 1,
								y8: model,
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
					}
				case 7:
					var updateDefaultsMsg = msg.a;
					var _v28 = function () {
						var _v29 = open.o_;
						if (!_v29.$) {
							var updateDefaultsState_ = _v29.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A2($0ui$elm_task_parallel$Task$Parallel$updateList, updateDefaultsState_, updateDefaultsMsg));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var newUpdateDefaultsState = _v28.a;
					var updateDefaultsCmd = _v28.b;
					return {
						EC: updateDefaultsCmd,
						ac5: 1,
						y8: $author$project$Components$CreatePaymentMethodModal$Open(
							_Utils_update(
								open,
								{o_: newUpdateDefaultsState})),
						as: _List_Nil
					};
				case 8:
					var response = msg.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				case 9:
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: $author$project$Components$CreatePaymentMethodModal$Closed,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment Method successfully added.')
							])
					};
				case 10:
					var response = msg.a;
					return {
						EC: $author$project$Ports$LocalStorage$getItem('last-used-card-reader'),
						ac5: 1,
						y8: $author$project$Components$CreatePaymentMethodModal$Open(
							_Utils_update(
								open,
								{hG: response})),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				case 11:
					var _v30 = msg.a;
					var key = _v30.a;
					var value = _v30.b;
					var _v31 = _Utils_Tuple2(key, value);
					if ((_v31.a === 'last-used-card-reader') && (!_v31.b.$)) {
						var lastUsedCardReaderId = _v31.b.a;
						var cardReaders = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							$author$project$Api$Data$toMaybe(open.hG));
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders),
							$author$project$Components$CreatePaymentMethodModal$CardReader(lastUsedCardReaderId),
							open.PB);
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{PB: newForm})));
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
					}
				case 12:
					var subMsg = msg.a;
					var _v32 = open.hT;
					if (!_v32.$) {
						var connectingModal = _v32.a;
						var connectingModalResult = A3($author$project$Components$CardReader$ConnectingModal$update, apiClient, subMsg, connectingModal);
						var _v33 = function () {
							var _v34 = connectingModalResult.ac5;
							switch (_v34.$) {
								case 1:
									var card = _v34.a;
									var cardParams = $author$project$Components$CreatePaymentMethodModal$cardParamsFromReader(card);
									var _v35 = $author$project$Utils$Form$fields(open.PB);
									var categories = _v35.KL;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										$author$project$Api$Data$Loading,
										A5($author$project$Components$CreatePaymentMethodModal$createCardFromReader, open.vD, apiClient, open.ZD, categories, cardParams));
								case 0:
									return _Utils_Tuple3($elm$core$Maybe$Nothing, open.jY, $elm$core$Platform$Cmd$none);
								default:
									return _Utils_Tuple3(
										$elm$core$Maybe$Just(connectingModalResult.y8),
										open.jY,
										$elm$core$Platform$Cmd$none);
							}
						}();
						var connectingModal_ = _v33.a;
						var saveRequest = _v33.b;
						var cmd = _v33.c;
						return {
							EC: $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg, connectingModalResult.EC),
										cmd
									])),
							ac5: 1,
							y8: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{hT: connectingModal_, jY: saveRequest})),
							as: connectingModalResult.as
						};
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
					}
				case 0:
					return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
				case 13:
					var response = msg.a;
					if (response.$ === 3) {
						var setup = response.a;
						var config = function () {
							if (!setup.$) {
								var secret = setup.a;
								return $author$project$Components$CreatePaymentMethodModal$Stripe(secret);
							} else {
								var sessionKey = setup.a.agS;
								var paymentMethodConfigId = setup.a.afH;
								var allowedMethods = setup.a.abl;
								return $author$project$Components$CreatePaymentMethodModal$Rainforest(
									{abl: allowedMethods, cW: true, yl: false, afH: paymentMethodConfigId, agS: sessionKey});
							}
						}();
						var _v37 = A4($author$project$Components$CreatePaymentMethodModal$initFormFields, open.WF, open.Vp, open.ZD, config);
						var formFields = _v37.a;
						var formFieldsCmd = _v37.b;
						return {
							EC: $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										formFieldsCmd,
										$author$project$Ports$LocalStorage$getItem('last-used-card-reader')
									])),
							ac5: 1,
							y8: $author$project$Components$CreatePaymentMethodModal$Open(
								_Utils_update(
									open,
									{
										PB: $author$project$Utils$Form$init(formFields),
										cW: false,
										at: config
									})),
							as: _List_Nil
						};
					} else {
						return function (res) {
							return _Utils_update(
								res,
								{
									as: $author$project$OutMsg$handleErrorResponse(response)
								});
						}(
							$author$project$Components$CreatePaymentMethodModal$andNoop(
								$author$project$Components$CreatePaymentMethodModal$Open(
									_Utils_update(
										open,
										{cW: false}))));
					}
				case 16:
					var rainforestMsg = msg.a;
					var _v39 = open.at;
					if (_v39.$ === 2) {
						var config = _v39.a;
						return function (_v40) {
							var m = _v40.a;
							var cmd = _v40.b;
							return {EC: cmd, ac5: 1, y8: m, as: _List_Nil};
						}(
							A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Components$CreatePaymentMethodModal$Open,
								A5($author$project$Components$CreatePaymentMethodModal$updateRainforest, apiClient, open.vD, rainforestMsg, config, open)));
					} else {
						return $author$project$Components$CreatePaymentMethodModal$andNoop(
							$author$project$Components$CreatePaymentMethodModal$Open(open));
					}
				case 14:
					var cmd = function () {
						var _v41 = open.Vp;
						if (_v41.$ === 2) {
							var patient = _v41.a;
							return A4(
								$author$project$Api$Provider$Patient$requestPaymentInfo,
								apiClient,
								$author$project$Api$Provider$Patient$One$id(patient),
								$elm$core$Maybe$Nothing,
								$author$project$Components$CreatePaymentMethodModal$GotPaymentInfoUpdate);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return {EC: cmd, ac5: 1, y8: model, as: _List_Nil};
				default:
					var response = msg.a;
					if (response.$ === 3) {
						var requestPayInfo = response.a;
						var _v43 = open.Vp;
						if (_v43.$ === 2) {
							var patient = _v43.a;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 1,
								y8: $author$project$Components$CreatePaymentMethodModal$Open(
									_Utils_update(
										open,
										{
											Ao: $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt(requestPayInfo)
										})),
								as: _List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										'An email has been sent to ' + ($author$project$Api$Provider$Patient$One$name(patient) + ' requesting new payment information.'))
									])
							};
						} else {
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 1,
								y8: model,
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						}
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: model,
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
			}
		} else {
			if (!msg.$) {
				var openOptions = msg.a;
				var useCardReaders = openOptions.tv && $author$project$Api$Practice$usesCardReaders(openOptions.WF);
				var patientRequestInfoSentAt = function () {
					var _v46 = openOptions.Vp;
					if (_v46.$ === 2) {
						var patient = _v46.a;
						return $author$project$Api$Provider$Patient$One$requestPayInfoSentAt(patient);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var cardReaderCmd = useCardReaders ? A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Components$CreatePaymentMethodModal$GotCardReaders) : $elm$core$Platform$Cmd$none;
				var _v45 = A4($author$project$Components$CreatePaymentMethodModal$initFormFields, openOptions.WF, openOptions.Vp, openOptions.ZD, $author$project$Components$CreatePaymentMethodModal$Loading);
				var formFields = _v45.a;
				var formFieldsCmd = _v45.b;
				var open = {
					vD: openOptions.vD,
					hG: $author$project$Api$Data$Loading,
					hT: $elm$core$Maybe$Nothing,
					PB: $author$project$Utils$Form$init(formFields),
					qT: openOptions.qT,
					FR: openOptions.FR,
					cW: true,
					Vp: openOptions.Vp,
					Ao: patientRequestInfoSentAt,
					WF: openOptions.WF,
					at: $author$project$Components$CreatePaymentMethodModal$Loading,
					sj: openOptions.sj,
					jY: $author$project$Api$Data$NotAsked,
					dc: 1,
					ZD: openOptions.ZD,
					Hy: openOptions.Hy,
					o_: $elm$core$Maybe$Nothing,
					tv: useCardReaders
				};
				var setupIntentCmd = (!A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, openOptions.Vp, openOptions.ZD)) ? A3($author$project$Api$PaymentMethod$getClientSecret, open.vD, apiClient, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig) : $elm$core$Platform$Cmd$none;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[formFieldsCmd, cardReaderCmd, setupIntentCmd])),
					ac5: 1,
					y8: $author$project$Components$CreatePaymentMethodModal$Open(
						_Utils_update(
							open,
							{
								cW: !A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, openOptions.Vp, openOptions.ZD)
							})),
					as: _List_Nil
				};
			} else {
				return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
			}
		}
	});
var $author$project$Components$Practice$PaymentSources$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var createPaymentMethodModalResult = A3($author$project$Components$CreatePaymentMethodModal$update, apiClient, subMsg, model.lB);
				var _v1 = function () {
					var _v2 = createPaymentMethodModalResult.ac5;
					if (!_v2) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{pD: $author$project$Api$Data$Loading, pN: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$none,
							0);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 2);
					}
				}();
				var newModel = _v1.a;
				var cmd = _v1.b;
				var event = _v1.c;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg, createPaymentMethodModalResult.EC),
								cmd
							])),
					ac5: event,
					y8: _Utils_update(
						newModel,
						{lB: createPaymentMethodModalResult.y8}),
					as: createPaymentMethodModalResult.as
				};
			case 1:
				var source = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 2,
					y8: _Utils_update(
						model,
						{
							fr: $elm$core$Maybe$Just(source)
						}),
					as: _List_Nil
				};
			case 3:
				var source = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					EC: A5(
						$author$project$Api$Source$delete,
						$author$project$Api$Data$providerPath,
						apiClient,
						model.ZD,
						source,
						$author$project$Components$Practice$PaymentSources$Deleted(source)),
					ac5: 2,
					y8: _Utils_update(
						model,
						{
							fr: $elm$core$Maybe$Nothing,
							dR: A2(
								$elm$core$Set$insert,
								$author$project$Api$Source$id(source),
								model.dR)
						}),
					as: _List_Nil
				} : {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 2,
					y8: _Utils_update(
						model,
						{fr: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			default:
				var source = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: _Utils_update(
								model,
								{
									pD: $author$project$Api$Data$Loading,
									pN: $author$project$Api$Data$Loading,
									fr: $elm$core$Maybe$Nothing,
									dR: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.dR)
								}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Source successfully deleted')
								])
						};
					case 2:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: _Utils_update(
								model,
								{
									dR: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.dR)
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Pages$Admin$PaymentSources$Updated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$BankAccount$EmployerOne = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$BankAccount$ProviderOne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$BankAccount$updateDefault = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$BankAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['default']),
					A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_))));
	});
var $author$project$Api$Provider$BankAccount$updateDefault = F5(
	function (basePath, apiClient, id_, category, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					A2(
						$author$project$Utils$Encode$nullable,
						$elm$json$Json$Encode$string,
						A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$categoryName, category)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BankAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['default']),
						A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)))));
	});
var $author$project$Api$BankAccount$updateDefault = F6(
	function (basePath, apiClient, session, bankAccount, category, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$BankAccount$updateDefault,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$BankAccount$EmployerOne))) : A5(
			$author$project$Api$Provider$BankAccount$updateDefault,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			category,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$BankAccount$ProviderOne)));
	});
var $author$project$Api$Employer$Card$updateDefault = F4(
	function (basePath, apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Card$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['default']),
					A2($author$project$Api$Employer$Card$cardPath, basePath, id_))));
	});
var $author$project$Api$Provider$Card$updateDefault = F5(
	function (basePath, apiClient, id_, category, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'category',
					A2(
						$author$project$Utils$Encode$nullable,
						$elm$json$Json$Encode$string,
						A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$categoryName, category)))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['default']),
						A2($author$project$Api$Provider$Card$cardPath, basePath, id_)))));
	});
var $author$project$Api$Card$updateDefault = F6(
	function (basePath, apiClient, session, card, category, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$Card$updateDefault,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A5(
			$author$project$Api$Provider$Card$updateDefault,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			category,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
	});
var $author$project$Api$Source$updateDefault = F6(
	function (basePath, apiClient, session, source, category, toMsg) {
		switch (source.$) {
			case 0:
				var card = source.a;
				return A6(
					$author$project$Api$Card$updateDefault,
					basePath,
					apiClient,
					session,
					card,
					category,
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$author$project$Api$Data$map($author$project$Api$Source$Card)));
			case 1:
				var bankAccount = source.a;
				return A6(
					$author$project$Api$BankAccount$updateDefault,
					basePath,
					apiClient,
					session,
					bankAccount,
					category,
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$author$project$Api$Data$map($author$project$Api$Source$BankAccount)));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pages$Admin$PaymentSources$updateSource = F3(
	function (apiClient, session, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var _v0 = fields.Hg;
		if (!_v0.$) {
			var source = _v0.a;
			return A6(
				$author$project$Api$Source$updateDefault,
				$author$project$Api$Data$providerPath,
				apiClient,
				session,
				source,
				$elm$core$Maybe$Just(fields.Ex),
				$author$project$Pages$Admin$PaymentSources$Updated);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pages$Admin$PaymentSources$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							pN: response,
							cj: A2($author$project$Components$Practice$PaymentSources$initCards, response, model.cj)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							pD: response,
							cj: A2($author$project$Components$Practice$PaymentSources$initBankAccounts, response, model.cj)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var sources = msg.a;
				var paymentCategory = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aK: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									sources,
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$PaymentSources$formFieldsFromPaymentCategory(paymentCategory)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var field = msg.a;
				var _v1 = model.aK;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var sources = _v2.a;
					var form = _v2.b;
					var paymentCategory = _v2.c;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Admin$PaymentSources$formFieldsUpdate(sources),
						field,
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aK: $elm$core$Maybe$Just(
									_Utils_Tuple3(sources, newForm, paymentCategory))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aK: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v3 = model.aK;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var sources = _v4.a;
					var form = _v4.b;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$PaymentSources$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aK: $elm$core$Maybe$Just(
										_Utils_Tuple3(sources, newForm, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Pages$Admin$PaymentSources$updateSource, model.D5, model.ZD, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aK: $elm$core$Maybe$Just(
										_Utils_Tuple3(sources, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v7 = model.aK;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var sources = _v8.a;
					var form = _v8.b;
					if (response.$ === 3) {
						var _v10 = $author$project$Pages$Admin$PaymentSources$loadData(model.D5);
						var cards = _v10.a;
						var bankAccounts = _v10.b;
						var cmd = _v10.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{pD: bankAccounts, pN: cards, aK: $elm$core$Maybe$Nothing}),
							cmd,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Default source successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aK: $elm$core$Maybe$Just(
										_Utils_Tuple3(sources, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var practicePaymentSourcesResult = A3($author$project$Components$Practice$PaymentSources$update, model.D5, subMsg, model.cj);
				var _v11 = function () {
					var _v12 = practicePaymentSourcesResult.ac5;
					switch (_v12) {
						case 0:
							return $author$project$Pages$Admin$PaymentSources$loadData(model.D5);
						case 1:
							return $author$project$Pages$Admin$PaymentSources$loadData(model.D5);
						default:
							return _Utils_Tuple3(model.pN, model.pD, $elm$core$Platform$Cmd$none);
					}
				}();
				var cards = _v11.a;
				var bankAccounts = _v11.b;
				var cmd = _v11.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pD: bankAccounts, pN: cards, cj: practicePaymentSourcesResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg, practicePaymentSourcesResult.EC),
								cmd
							])),
					practicePaymentSourcesResult.as);
		}
	});
var $author$project$Api$Platform$Organization$Shared$isNetwork = function (_v0) {
	var record = _v0.b;
	return record.RV;
};
var $author$project$Components$CreatePaymentMethodModal$Approved = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$CardBrandUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Category = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$CreatePaymentMethodModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Loaded = {$: 2};
var $author$project$Components$CreatePaymentMethodModal$MethodUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$RainforestMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Reader = 1;
var $author$project$Components$CreatePaymentMethodModal$Save = {$: 3};
var $author$project$Components$CreatePaymentMethodModal$SetAsDefault = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Margin$Top_0_75 = 7;
var $author$project$Components$CreatePaymentMethodModal$ValidityChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$cardReaderLabel = F2(
	function (showProcessor, cardReader) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3(
						$author$project$Utils$PaymentProcessor$toLabel,
						showProcessor,
						cardReader,
						A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just)),
						$elm$core$Maybe$Just(
						$author$project$Api$Provider$CardReader$All$label(cardReader))
					])));
	});
var $author$project$Components$CreatePaymentMethodModal$cardReaderOptions = F2(
	function (showProcessor, cardReaders) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Choose a card reader...'),
			A2(
				$elm$core$List$map,
				function (cardReader) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$CardReader$All$id(cardReader)),
						A2($author$project$Components$CreatePaymentMethodModal$cardReaderLabel, showProcessor, cardReader));
				},
				cardReaders));
	});
var $author$project$Ui$HorizontalRule$Double = 0;
var $author$project$Ui$HorizontalRule$double = $author$project$Ui$HorizontalRule$Style(0);
var $author$project$Api$Employer$Practice$One$hasPaymentProcessorAccount = function (_v0) {
	var record = _v0;
	return record.Qd;
};
var $author$project$Api$Practice$hasPaymentProcessorAccount = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$hasPaymentProcessorAccount(practice_);
	}
};
var $author$project$Ui$Types$Lg = 3;
var $author$project$Ui$Spinner$large = $author$project$Ui$Spinner$Size(3);
var $author$project$Api$Platform$Session$One$organizationIsAdminPractice = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq(0),
			A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.Vd))) && (record.agy === 'practice_admin');
};
var $author$project$Utils$PaymentProcessor$toSetupAlert = F2(
	function (practice, prefix) {
		return A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!prefix.$) {
							var prefix_ = prefix.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(prefix_),
									$elm$html$Html$text(', please')
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text('Please')
								]);
						}
					}(),
						_List_fromArray(
						[
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text('setup'),
							$author$project$Utils$Html$noBreakSpace
						]),
						(($author$project$Api$Practice$paymentProcessor(practice) === 'stripe') && (!A2($author$project$Api$Practice$featureEnabled, 28, practice))) ? _List_fromArray(
						[
							$elm$html$Html$text('your '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Stripe,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Stripe integration')
								])),
							$elm$html$Html$text('.')
						]) : _List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__PaymentProcessing,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Payment Processing')
								])),
							$elm$html$Html$text('.')
						])
					])));
	});
var $author$project$Api$Provider$Source$Defaults$categoryLabel = function (category) {
	if (!category) {
		return 'Hint Payments';
	} else {
		return 'Affiliate Payments';
	}
};
var $author$project$Components$Practice$PaymentCategoriesPicker$viewPaymentCategory = F3(
	function (categories, toMsg, category) {
		var checked = $author$project$Utils$Maybe$toBool(
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (category_) {
					return _Utils_eq(category_, category);
				},
				categories));
		return A2(
			$author$project$Ui$Form$Checkbox$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Checkbox$value(checked),
					$author$project$Ui$Form$Checkbox$onCheck(
					toMsg(category))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Source$Defaults$categoryLabel(category))
				]));
	});
var $author$project$Components$Practice$PaymentCategoriesPicker$view = F3(
	function (practice, currentCategories, toMsg) {
		return $author$project$Api$Practice$isNetwork(practice) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$double])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Set default for following categories')
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb4]),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Practice$PaymentCategoriesPicker$viewPaymentCategory, currentCategories, toMsg),
						$author$project$Components$Practice$PaymentCategoriesPicker$allCategories(practice)))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$WebComponents$Rainforest$Payment$approvedDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A2(
		$elm$json$Json$Decode$index,
		0,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['data', 'payment_method_id']),
			$elm$json$Json$Decode$string)));
var $author$project$WebComponents$Rainforest$Payment$cardBrandUpdatedDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
var $author$project$WebComponents$Rainforest$Payment$methodUpdatedDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
var $author$project$WebComponents$Rainforest$Payment$view = F2(
	function (_v0, data) {
		var onApproved = _v0.ae1;
		var onInvalid = _v0.afd;
		var onValid = _v0.afp;
		var onLoaded = _v0.aff;
		var onMethodUpdated = _v0.afg;
		var onCardBrandUpdated = _v0.ae3;
		return A3(
			$elm$html$Html$node,
			'rainforest-payment',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'session-key', data.agS),
					A2($elm$html$Html$Attributes$attribute, 'payment-method-config-id', data.afH),
					A2($elm$html$Html$Attributes$attribute, 'allowed-methods', data.abl),
					A2($elm$html$Html$Attributes$attribute, 'hide-button', ''),
					A2(
					$elm$html$Html$Events$on,
					'approved',
					A2($elm$json$Json$Decode$map, onApproved, $author$project$WebComponents$Rainforest$Payment$approvedDecoder)),
					A2(
					$elm$html$Html$Events$on,
					'valid',
					$elm$json$Json$Decode$succeed(onValid)),
					A2(
					$elm$html$Html$Events$on,
					'invalid',
					$elm$json$Json$Decode$succeed(onInvalid)),
					A2(
					$elm$html$Html$Events$on,
					'loaded',
					$elm$json$Json$Decode$succeed(onLoaded)),
					A2(
					$elm$html$Html$Events$on,
					'method-updated',
					A2($elm$json$Json$Decode$map, onMethodUpdated, $author$project$WebComponents$Rainforest$Payment$methodUpdatedDecoder)),
					A2(
					$elm$html$Html$Events$on,
					'card-brand-updated',
					A2($elm$json$Json$Decode$map, onCardBrandUpdated, $author$project$WebComponents$Rainforest$Payment$cardBrandUpdatedDecoder)),
					A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
					A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
					A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
					A2($elm$html$Html$Attributes$attribute, 'style-placeholder-text', 'true')
				]),
			_List_Nil);
	});
var $author$project$Components$CreatePaymentMethodModal$CardInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$viewCardInputButton = F3(
	function (currentCardInput, cardInput, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCardInput, cardInput)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$CreatePaymentMethodModal$FormUpdated(
						$author$project$Components$CreatePaymentMethodModal$CardInput(cardInput)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Ui$Margin$Bottom_0 = 0;
var $author$project$Ui$Image$SampleCheck = 4;
var $author$project$Components$CreatePaymentMethodModal$viewCheckTooltipHelper = function (imageStore) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Ui$Margin$toClass(8),
				$author$project$Ui$Margin$toClass(0)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Popover$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Where are these numbers on a check?'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Where are these numbers on a check?')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Popover$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Image$view,
								imageStore,
								{I1: 'Example check showing routing number on bottom left and account number in center bottom'},
								_List_Nil,
								4)
							]))
					]))
			]));
};
var $author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$mb2]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(12)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('To initiate an ACH charge, the Operating Rules of the National Automated '),
									$elm$html$Html$text('Clearing House Associations (NACHA) require you to have your customer\'s consent '),
									$elm$html$Html$text('to debit or credit their bank account and initiate a charge over the ACH network. '),
									$elm$html$Html$text('You must be capable of producing copies of your customer\'s authorization if requested.')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('A breach of the NACHA rules makes you potentially liable for regulatory penalties '),
											$elm$html$Html$text('and fees, as well as a reversal of any related transaction. ')
										])),
									$elm$html$Html$text('For details on the rules that the NACHA requires, '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://www.nacha.org/newrules'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('visit their site.')
										])),
									$elm$html$Html$text(' See our '),
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href('https://www.hint.com/terms'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('terms')
										])),
									$elm$html$Html$text(' for more information.')
								]))
						]))
				]))
		]));
var $author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer = F4(
	function (showCardDisclaimer, showHintDisclaimer, practice, selectedPaymentOption) {
		var _v0 = _Utils_Tuple3(selectedPaymentOption, showCardDisclaimer, showHintDisclaimer);
		_v0$2:
		while (true) {
			if (_v0.a === 1) {
				if (_v0.b) {
					var _v1 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$inputSpanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$warning]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Using a credit card will cost the provider an additional 2% in processing fees for your memberships. ')
												])),
											$elm$html$Html$text('Please consider using your bank account instead.')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$inputSpanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('By entering your account information you authorize '),
											$elm$html$Html$text(
											$author$project$Api$Practice$name(practice)),
											$elm$html$Html$text(' to electronically debit and credit your account on a recurring basis as set forth in the contract. '),
											$elm$html$Html$text('You understand you can contact '),
											$elm$html$Html$text(
											$author$project$Api$Practice$name(practice)),
											$elm$html$Html$text(' to revoke this authorization at any time.')
										]))
								]))
						]);
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.c) {
					var _v2 = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$inputSpanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('By entering your account information you authorize this platform to electronically debit and credit your account on '),
											$elm$html$Html$text('a recurring basis as set forth in the contract. You understand you can contact us to revoke '),
											$elm$html$Html$text('this authorization at any time.')
										]))
								]))
						]);
				} else {
					break _v0$2;
				}
			}
		}
		return _List_fromArray(
			[$author$project$Utils$Html$empty]);
	});
var $author$project$Components$CreatePaymentMethodModal$RequestForPaymentInfo = {$: 14};
var $author$project$Components$CreatePaymentMethodModal$viewSendRequestToPatient = F3(
	function (patient, patientRequestInfoSentAt, timeFormatter) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Send request to patient'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$CreatePaymentMethodModal$RequestForPaymentInfo),
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Send request to patient')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('We will email '),
											$elm$html$Html$text(
											$author$project$Api$Provider$Patient$One$name(patient)),
											$elm$html$Html$text(' a form to update their payment method and provide this authorization.')
										]))
								]))
						])),
					function () {
					if (!patientRequestInfoSentAt.$) {
						var requestPayInfoSentAt = patientRequestInfoSentAt.a;
						return A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$elm$html$Html$text('Last request for payment source sent '),
													$elm$html$Html$text(
													A2(timeFormatter, 1, requestPayInfoSentAt)),
													$elm$html$Html$text('.')
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$CreatePaymentMethodModal$viewAddCardModal = function (open) {
	var showPaymentDisclaimers = $author$project$Api$Platform$Session$One$organizationIsCompany(open.ZD);
	var showContactPatientBox = function () {
		var _v17 = open.dc;
		if (!_v17) {
			return true;
		} else {
			return false;
		}
	}();
	var paymentProcessingEnabled = function () {
		var _v16 = open.Vp;
		if (_v16.$ === 1) {
			return true;
		} else {
			return $author$project$Api$Practice$hasPaymentProcessorAccount(open.WF);
		}
	}();
	var modalTitle = 'Add Payment Method';
	var fields = $author$project$Utils$Form$fields(open.PB);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(true),
				$author$project$Ui$Form$onSubmit($author$project$Components$CreatePaymentMethodModal$Save)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$CreatePaymentMethodModal$Close,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title(modalTitle)
							])),
						$author$project$Ui$Modal$body(
						A2(
							$elm$core$List$cons,
							function () {
								var _v0 = _Utils_Tuple3(showContactPatientBox, paymentProcessingEnabled, showPaymentDisclaimers);
								if (!_v0.b) {
									if (!_v0.c) {
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mb4]),
											_List_fromArray(
												[
													A2(
													$author$project$Utils$PaymentProcessor$toSetupAlert,
													open.WF,
													$elm$core$Maybe$Just('In order to add payment options'))
												]));
									} else {
										return A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mb4]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Alert$info,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Your account is not configured to allow credit cards.')
														]))
												]));
									}
								} else {
									if (_v0.a) {
										return $author$project$Utils$Html$empty;
									} else {
										return $author$project$Utils$Html$empty;
									}
								}
							}(),
							A2(
								$elm$core$List$cons,
								function () {
									var _v1 = open.Vp;
									if (_v1.$ === 2) {
										var patient = _v1.a;
										return A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											_List_fromArray(
												[
													A3($author$project$Components$CreatePaymentMethodModal$viewSendRequestToPatient, patient, open.Ao, open.Hy),
													$author$project$Ui$HorizontalRule$view(
													_List_fromArray(
														[$author$project$Ui$HorizontalRule$double]))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
								A2(
									$elm$core$List$cons,
									function () {
										var _v2 = _Utils_Tuple2(open.tv, showPaymentDisclaimers);
										if (_v2.a && (!_v2.b)) {
											var manualInputOptionText = 'Enter Information Here';
											var cardReaderOptionText = 'Use Card Reader';
											return A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Source')
																	]))
															])),
														A2(
														$author$project$Ui$Typography$p,
														_List_fromArray(
															[$author$project$Ui$Typography$muted]),
														_List_fromArray(
															[
																$elm$html$Html$text('How would you like to add a payment method? ')
															])),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$inputSpanMd(12),
																$author$project$Ui$Form$Group$clearfix
															]),
														_List_fromArray(
															[
																$author$project$Ui$Button$group(
																_List_fromArray(
																	[
																		A3($author$project$Components$CreatePaymentMethodModal$viewCardInputButton, fields.cH, 0, manualInputOptionText),
																		A3($author$project$Components$CreatePaymentMethodModal$viewCardInputButton, fields.cH, 1, cardReaderOptionText)
																	]))
															])),
														$author$project$Ui$HorizontalRule$view(
														_List_fromArray(
															[$author$project$Ui$HorizontalRule$double]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
									_Utils_ap(
										function () {
											var _v3 = fields.cH;
											if (!_v3) {
												var loading = open.cW || function () {
													var _v9 = open.at;
													if (_v9.$ === 2) {
														var config = _v9.a;
														return config.cW;
													} else {
														return false;
													}
												}();
												return _List_fromArray(
													[
														$author$project$Utils$Html$empty,
														A2(
														$author$project$Ui$Form$Group$view,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('stripe-card')
																	]),
																_List_fromArray(
																	[
																		loading ? A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('spinner-modal')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Ui$Spinner$view(
																				_List_fromArray(
																					[$author$project$Ui$Spinner$large]))
																			])) : $elm$html$Html$text(''),
																		function () {
																		var _v4 = open.at;
																		switch (_v4.$) {
																			case 0:
																				return $elm$html$Html$text('');
																			case 1:
																				return A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$elm$html$Html$Attributes$id($author$project$Components$CreatePaymentMethodModal$stripeElementId)
																						]),
																					_List_Nil);
																			default:
																				var config = _v4.a;
																				var _v5 = config;
																				var sessionKey = _v5.agS;
																				var paymentMethodConfigId = _v5.afH;
																				var allowedMethods = _v5.abl;
																				return A2(
																					$elm$html$Html$div,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$author$project$WebComponents$Rainforest$Payment$view,
																							{
																								ae1: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$Approved, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
																								ae3: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$CardBrandUpdated, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
																								afd: $author$project$Components$CreatePaymentMethodModal$RainforestMsg(
																									$author$project$Components$CreatePaymentMethodModal$ValidityChanged(false)),
																								aff: $author$project$Components$CreatePaymentMethodModal$RainforestMsg($author$project$Components$CreatePaymentMethodModal$Loaded),
																								afg: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$MethodUpdated, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
																								afp: $author$project$Components$CreatePaymentMethodModal$RainforestMsg(
																									$author$project$Components$CreatePaymentMethodModal$ValidityChanged(true))
																							},
																							{abl: allowedMethods, afH: paymentMethodConfigId, agS: sessionKey}),
																							$author$project$Utils$FormErrors$view(
																							A2($author$project$Utils$Form$validationErrors, 2, open.PB))
																						]));
																		}
																	}(),
																		function () {
																		var showCheckHelperText = function () {
																			var _v8 = open.Vp;
																			switch (_v8.$) {
																				case 2:
																					return $author$project$Api$Platform$Session$One$organizationIsAdminPractice(open.ZD);
																				case 0:
																					return $author$project$Api$Platform$Session$One$organizationIsAdminPractice(open.ZD);
																				default:
																					return false;
																			}
																		}();
																		var _v6 = _Utils_Tuple2(open.dc, showCheckHelperText);
																		if ((!_v6.a) && _v6.b) {
																			var _v7 = _v6.a;
																			return $author$project$Components$CreatePaymentMethodModal$viewCheckTooltipHelper(open.qT);
																		} else {
																			return $author$project$Utils$Html$empty;
																		}
																	}()
																	]))
															]))
													]);
											} else {
												return $elm$core$List$singleton(
													A2(
														$author$project$Ui$Form$Group$view,
														_List_Nil,
														function () {
															var _v10 = open.hG;
															if (_v10.$ === 3) {
																var cardReaders = _v10.a;
																return $elm$core$List$isEmpty(cardReaders) ? _List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Alert$danger,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('There are no card readers available. Please '),
																				A3(
																				$author$project$Ui$Link$route,
																				$author$project$Spa$Generated$Route$Admin__CardReaders,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text('add a card reader')
																					])),
																				$elm$html$Html$text(' now.')
																			]))
																	]) : _List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Select$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Select$value(
																				A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, fields.abR)),
																				$author$project$Ui$Form$Select$onChange(
																				A2($elm$core$Basics$composeL, $author$project$Components$CreatePaymentMethodModal$FormUpdated, $author$project$Components$CreatePaymentMethodModal$CardReader)),
																				$author$project$Ui$Form$Select$invalid(
																				A2($author$project$Utils$Form$hasValidationErrors, 1, open.PB)),
																				$author$project$Ui$Form$Select$errors(
																				A2($author$project$Utils$Form$validationErrors, 1, open.PB))
																			]),
																		A2($author$project$Components$CreatePaymentMethodModal$cardReaderOptions, open.FR, cardReaders)),
																		A2(
																		$author$project$Ui$Typography$p,
																		_List_fromArray(
																			[$author$project$Ui$Typography$muted]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Tap payments such as Apple Pay & Google Pay are not supported at this time.')
																			]))
																	]);
															} else {
																return _List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$div,
																		_List_fromArray(
																			[
																				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
																			]),
																		_List_fromArray(
																			[
																				$author$project$Ui$Spinner$view(_List_Nil)
																			]))
																	]);
															}
														}()));
											}
										}(),
										_Utils_ap(
											function () {
												if (showPaymentDisclaimers) {
													var _v11 = open.Vp;
													if (!_v11.$) {
														return A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, showPaymentDisclaimers, true, open.WF, open.dc);
													} else {
														return A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, false, true, open.WF, open.dc);
													}
												} else {
													return _List_Nil;
												}
											}(),
											function () {
												var _v12 = open.Vp;
												switch (_v12.$) {
													case 2:
														var nachaDisclaimerElements = function () {
															var _v13 = open.dc;
															if (!_v13) {
																return (!fields.cH) ? _List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Element$view,
																		_List_fromArray(
																			[$author$project$Ui$Element$mt4, $author$project$Ui$Element$mb2]),
																		_List_fromArray(
																			[$author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer]))
																	]) : _List_fromArray(
																	[$author$project$Utils$Html$empty]);
															} else {
																return _List_fromArray(
																	[$author$project$Utils$Html$empty]);
															}
														}();
														return A2(
															$elm$core$List$cons,
															A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$mt4, $author$project$Ui$Element$mb2]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Checkbox$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Checkbox$value(fields.gI),
																				$author$project$Ui$Form$Checkbox$onCheck(
																				A2($elm$core$Basics$composeL, $author$project$Components$CreatePaymentMethodModal$FormUpdated, $author$project$Components$CreatePaymentMethodModal$SetAsDefault))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Set as the default payment method for this patient')
																			]))
																	])),
															nachaDisclaimerElements);
													case 0:
														return (!$author$project$Api$Platform$Session$One$organizationIsCompany(open.ZD)) ? _List_fromArray(
															[$author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer]) : (A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, open.Vp, open.ZD) ? _List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$div,
																_List_fromArray(
																	[$author$project$Ui$Typography$warning]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$strong,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('The practice has disabled adding payment information for this account. Contact the practice administrator for more information.')
																			]))
																	]))
															]) : _List_fromArray(
															[$author$project$Utils$Html$empty]));
													default:
														var practice = _v12.a;
														return _List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$author$project$Ui$Margin$toClass(7)
																	]),
																A2(
																	$elm$core$List$cons,
																	A3(
																		$author$project$Components$Practice$PaymentCategoriesPicker$view,
																		practice,
																		fields.KL,
																		F2(
																			function (c, b) {
																				return $author$project$Components$CreatePaymentMethodModal$FormUpdated(
																					A2($author$project$Components$CreatePaymentMethodModal$Category, c, b));
																			})),
																	A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, false, true, practice, open.dc)))
															]);
												}
											}())))))),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$CreatePaymentMethodModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								function () {
								var valid = function () {
									var _v14 = _Utils_Tuple2(fields.cH, open.at);
									if ((!_v14.a) && (_v14.b.$ === 2)) {
										var _v15 = _v14.a;
										var conf = _v14.b.a;
										return conf.yl;
									} else {
										return true;
									}
								}();
								var disabled = (!valid) || A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, open.Vp, open.ZD);
								return A3(
									$author$project$Ui$Button$view,
									{abp: modalTitle},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$submit,
											$author$project$Ui$Button$loading(
											_Utils_eq(open.jY, $author$project$Api$Data$Loading)),
											$author$project$Ui$Button$disabled(disabled)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(modalTitle)
										]));
							}()
							]))
					]))
			]));
};
var $author$project$Components$CreatePaymentMethodModal$modal = function (model) {
	if (model.$ === 1) {
		var open = model.a;
		var _v1 = open.hT;
		if (!_v1.$) {
			var connectingModal = _v1.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg,
				$author$project$Components$CardReader$ConnectingModal$view(connectingModal));
		} else {
			return $author$project$Components$CreatePaymentMethodModal$viewAddCardModal(open);
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Practice$PaymentSources$modal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg,
				$author$project$Components$CreatePaymentMethodModal$modal(model.lB))
			]));
};
var $author$project$Api$Provider$Source$Defaults$network = function (_v0) {
	var record = _v0;
	return record.Uo;
};
var $author$project$Api$Source$defaultNetworkBankAccount = function (bankAccounts) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Source$BankAccount,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$BankAccount$ProviderAll,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (bankAccount) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Source$Defaults$network,
							$author$project$Api$Provider$BankAccount$All$defaults(bankAccount)));
				},
				bankAccounts)));
};
var $author$project$Api$Source$defaultNetworkCard = function (cards) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Source$Card,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Card$ProviderAll,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (card) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Source$Defaults$network,
							$author$project$Api$Provider$Card$All$defaults(card)));
				},
				cards)));
};
var $author$project$Api$Source$defaultNetworkSource = F2(
	function (cards, bankAccounts) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Api$Source$defaultNetworkCard(cards),
						$author$project$Api$Source$defaultNetworkBankAccount(bankAccounts)
					])));
	});
var $author$project$Pages$Admin$PaymentSources$paymentCategories = F3(
	function (isNetwork, cards, bankAccounts) {
		return A2(
			$elm$core$List$cons,
			{
				Ex: 0,
				Nl: A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts)
			},
			isNetwork ? _List_fromArray(
				[
					{
					Ex: 1,
					Nl: A2($author$project$Api$Source$defaultNetworkSource, cards, bankAccounts)
				}
				]) : _List_Nil);
	});
var $author$project$Components$Practice$PaymentSources$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$CreatePaymentMethodModal$Practice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$OpenModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$button = function (openOptions) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Add payment method'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(
				$author$project$Components$CreatePaymentMethodModal$OpenModal(openOptions)),
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Add Payment Method')
			]));
};
var $author$project$Api$Employer$BankAccount$Shared$bankName = function (_v0) {
	var record = _v0;
	return record.JR;
};
var $author$project$Api$Employer$BankAccount$One$bankName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$BankAccount$Shared$bankName(shared);
};
var $author$project$Api$Employer$BankAccount$All$bankName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$bankName(one);
};
var $author$project$Api$Provider$BankAccount$Shared$bankName = function (_v0) {
	var record = _v0;
	return record.JR;
};
var $author$project$Api$Provider$BankAccount$One$bankName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BankAccount$Shared$bankName(shared);
};
var $author$project$Api$Provider$BankAccount$All$bankName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$bankName(one);
};
var $author$project$Api$BankAccount$bankName = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$bankName(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$bankName(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$bankName(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$bankName(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$Shared$cardType = function (_v0) {
	var record = _v0;
	return record.KI;
};
var $author$project$Api$Employer$Card$One$cardType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Card$Shared$cardType(shared);
};
var $author$project$Api$Employer$Card$All$cardType = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$cardType(one);
};
var $author$project$Api$Provider$Card$Shared$cardType = function (_v0) {
	var record = _v0;
	return record.KI;
};
var $author$project$Api$Provider$Card$One$cardType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Card$Shared$cardType(shared);
};
var $author$project$Api$Provider$Card$All$cardType = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$cardType(one);
};
var $author$project$Api$Card$cardType = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$cardType(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$cardType(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$cardType(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$cardType(card_);
	}
};
var $author$project$Api$Source$detail = function (source) {
	var _v0 = function () {
		switch (source.$) {
			case 1:
				var bankAccount = source.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$BankAccount$bankName(bankAccount)),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$lastFour(source)));
			case 0:
				var card = source.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Card$cardType(card)),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$lastFour(source)));
			default:
				var source_ = source.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						'external',
						$author$project$Api$Common$Source$Shared$type_(source_)),
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$lastFour(source)));
		}
	}();
	var prefix = _v0.a;
	var lastFour_ = _v0.b;
	return prefix + (' *' + lastFour_);
};
var $author$project$Api$Source$noun = function (source) {
	switch (source.$) {
		case 1:
			return 'bank account';
		case 0:
			return 'card';
		default:
			var source_ = source.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'external',
				$author$project$Api$Common$Source$Shared$type_(source_));
	}
};
var $author$project$Api$Provider$Practice$One$stripeCustomerLink = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $._U;
	});
var $author$project$Components$Practice$PaymentSources$Delete = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Practice$PaymentSources$canDeleteSource = F3(
	function (source, maybeDefaultSource, maybeDefaultNetworkSource) {
		return !A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$map,
					function (defaultNetworkSource) {
						return _Utils_eq(
							$author$project$Api$Source$id(defaultNetworkSource),
							$author$project$Api$Source$id(source));
					},
					maybeDefaultNetworkSource),
				A2(
					$elm$core$Maybe$map,
					function (defaultSource) {
						return _Utils_eq(
							$author$project$Api$Source$id(defaultSource),
							$author$project$Api$Source$id(source));
					},
					maybeDefaultSource)));
	});
var $author$project$Components$Practice$PaymentSources$viewSource = F7(
	function (timeFormatter, isHintAdmin, deletingSources, maybeDefaultSource, maybeDefaultNetworkSource, canManageSources, source) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$PaymentSourceDisplayer$view,
									timeFormatter,
									_List_fromArray(
										[
											$author$project$Components$PaymentSourceDisplayer$source(
											$elm$core$Maybe$Just(source)),
											$author$project$Components$PaymentSourceDisplayer$showProcessor(isHintAdmin)
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									function () {
									if (canManageSources && A3($author$project$Components$Practice$PaymentSources$canDeleteSource, source, maybeDefaultSource, maybeDefaultNetworkSource)) {
										var loading = A2(
											$elm$core$Set$member,
											$author$project$Api$Source$id(source),
											deletingSources);
										return A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Delete payment source'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Practice$PaymentSources$Delete(source))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Practice$PaymentSources$view = F2(
	function (model, canManageSources) {
		var openOptions = {
			vD: $author$project$Api$Data$providerPath,
			qT: model.qT,
			FR: model.FR,
			Vp: $author$project$Components$CreatePaymentMethodModal$Practice(
				$author$project$Api$Practice$Provider(model.WF)),
			WF: $author$project$Api$Practice$Provider(model.WF),
			sj: model.sj,
			ZD: model.ZD,
			Hy: model.Hy,
			tv: false
		};
		var loading = !($author$project$Api$Data$isSuccess(model.pN) && $author$project$Api$Data$isSuccess(model.pD));
		var createPaymentMethodButton = A2(
			$elm$html$Html$map,
			$author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg,
			$author$project$Components$CreatePaymentMethodModal$button(openOptions));
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.pN, model.pD);
			if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
				var _v2 = _v1.a;
				var cards = _v2.a;
				var _v3 = _v1.b;
				var bankAccounts = _v3.a;
				return _Utils_Tuple3(
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Api$Source$createdAt,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Maybe$map($elm$time$Time$posixToMillis),
									$elm$core$Maybe$withDefault(0))),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll),
									cards),
								A2(
									$elm$core$List$map,
									A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll),
									bankAccounts)))),
					A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts),
					A2($author$project$Api$Source$defaultNetworkSource, cards, bankAccounts));
			} else {
				return _Utils_Tuple3(_List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		}();
		var sources = _v0.a;
		var defaultSource = _v0.b;
		var defaultNetworkSource = _v0.c;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Practice Payment Sources')
										])),
									function () {
									if (model.FR) {
										var maybeStripeCustomerLink = $author$project$Api$Provider$Practice$One$stripeCustomerLink(model.WF);
										return A2(
											$elm$core$Maybe$withDefault,
											$author$project$Utils$Html$empty,
											A2(
												$elm$core$Maybe$map,
												function (stripeCustomerLink) {
													return A3(
														$author$project$Ui$HinterOnly$linkHref,
														stripeCustomerLink,
														_List_fromArray(
															[$author$project$Ui$Link$targetBlank]),
														_List_fromArray(
															[
																$elm$html$Html$text(' View on Stripe')
															]));
												},
												maybeStripeCustomerLink));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							createPaymentMethodButton
						])),
					function () {
					var _v4 = model.fr;
					if (!_v4.$) {
						var source = _v4.a;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Components$Practice$PaymentSources$HiConfirmClosed(source),
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('delete'),
									$author$project$Components$HiConfirm$noun(
									$author$project$Api$Source$noun(source)),
									$author$project$Components$HiConfirm$detail(
									$author$project$Api$Source$detail(source))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					loading ? A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Spinner$view(_List_Nil)
						])) : A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					$elm$core$List$isEmpty(sources) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$ListGroup$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You have not added any credit cards or bank accounts.')
								]))
						]) : A2(
						$elm$core$List$map,
						A6($author$project$Components$Practice$PaymentSources$viewSource, model.Hy, model.FR, model.dR, defaultSource, defaultNetworkSource, canManageSources),
						sources))
				]));
	});
var $author$project$Pages$Admin$PaymentSources$Edit = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Admin$PaymentSources$viewPaymentCategory = F4(
	function (timeFormatter, showProcessor, sources, paymentCategory) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Source$Defaults$categoryLabel(paymentCategory.Ex))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$PaymentSourceDisplayer$view,
							timeFormatter,
							_List_fromArray(
								[
									$author$project$Components$PaymentSourceDisplayer$source(paymentCategory.Nl),
									$author$project$Components$PaymentSourceDisplayer$limitedView(true),
									$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
									$author$project$Components$PaymentSourceDisplayer$showProcessor(showProcessor)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$core$List$isEmpty(sources) ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Button$view,
							{abp: 'Edit payment source'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$pull(1),
									$author$project$Ui$Button$onClick(
									A2($author$project$Pages$Admin$PaymentSources$Edit, sources, paymentCategory))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Edit Payment Source')
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$PaymentSources$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$PaymentSources$Source = $elm$core$Basics$identity;
var $author$project$Pages$Admin$PaymentSources$Update = {$: 5};
var $author$project$Pages$Admin$PaymentSources$sourceName = function (source_) {
	var _v0 = $author$project$Api$Source$name(source_);
	if (!_v0.$) {
		var label = _v0.a;
		return $elm$core$Maybe$Just(label);
	} else {
		return $author$project$Api$Source$type_(source_);
	}
};
var $author$project$Pages$Admin$PaymentSources$sourceLabel = F2(
	function (showProcessor, source) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, source, $author$project$Api$Source$paymentProcessor),
						A2(
						$elm$core$Maybe$map,
						$author$project$Formatters$String$titleize,
						$author$project$Pages$Admin$PaymentSources$sourceName(source)),
						A2(
						$elm$core$Maybe$map,
						function (lastFour) {
							return ' * ' + lastFour;
						},
						$author$project$Api$Source$lastFour(source))
					])));
	});
var $author$project$Pages$Admin$PaymentSources$sourceOptions = F2(
	function (showProcessor, sources) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Choose a source...'),
			A2(
				$elm$core$List$map,
				function (source) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Source$id(source)),
						A2($author$project$Pages$Admin$PaymentSources$sourceLabel, showProcessor, source));
				},
				sources));
	});
var $author$project$Pages$Admin$PaymentSources$viewPaymentCategoryModal = F4(
	function (showProcessor, sources, form, updateRequest) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Payment Source',
			S_: _Utils_eq(updateRequest, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(''),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$PaymentSources$CancelEdit,
			U0: $elm$core$Basics$always($author$project$Pages$Admin$PaymentSources$Update)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Category')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Source$Defaults$categoryLabel(fields.Ex))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Payment Source'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $author$project$Api$Source$id, fields.Hg)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$PaymentSources$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]),
							A2($author$project$Pages$Admin$PaymentSources$sourceOptions, showProcessor, sources))
						]))
				]));
	});
var $author$project$Pages$Admin$PaymentSources$view = function (model) {
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(model.pN, model.pD);
		if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
			var _v2 = _v1.a;
			var cards = _v2.a;
			var _v3 = _v1.b;
			var bankAccounts = _v3.a;
			return _Utils_Tuple3(
				false,
				$elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$Source$createdAt,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($elm$time$Time$posixToMillis),
								$elm$core$Maybe$withDefault(0))),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll),
								cards),
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll),
								bankAccounts)))),
				A3(
					$author$project$Pages$Admin$PaymentSources$paymentCategories,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Platform$Session$One$organization,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map($author$project$Api$Platform$Organization$Shared$isNetwork),
							$elm$core$Maybe$withDefault(false)))(model.ZD),
					cards,
					bankAccounts));
		} else {
			return _Utils_Tuple3(true, _List_Nil, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var sources = _v0.b;
	var paymentCategories_ = _v0.c;
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg,
				$author$project$Components$Practice$PaymentSources$modal(model.cj)),
				function () {
				var _v4 = model.aK;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var sources_ = _v5.a;
					var form = _v5.b;
					var updateRequest = _v5.c;
					return A4($author$project$Pages$Admin$PaymentSources$viewPaymentCategoryModal, model.FR, sources_, form, updateRequest);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg,
								A2($author$project$Components$Practice$PaymentSources$view, model.cj, true)),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Categories')
									])),
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$loading(loading)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Category')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Payment Source')
											])),
										A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
									]),
								A2(
									$elm$core$List$map,
									A3($author$project$Pages$Admin$PaymentSources$viewPaymentCategory, model.Hy, model.FR, sources),
									paymentCategories_),
								_List_Nil)
							]))
					]))
			]),
		$G: 'Admin | Payment Sources'
	};
};
var $author$project$Pages$Admin$PaymentSources$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$PaymentSources$init, aer: $author$project$Pages$Admin$PaymentSources$load, agD: $author$project$Pages$Admin$PaymentSources$save, ahd: $author$project$Pages$Admin$PaymentSources$subscriptions, aaq: $author$project$Pages$Admin$PaymentSources$update, ahP: $author$project$Pages$Admin$PaymentSources$view});
var $author$project$Pages$Admin$Plans$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var timeZone = _v0.Hz;
		var currentDate = _v0.cO;
		var hinterViewOff = _v0.adN;
		var query = _v1.Bi;
		var params = _v1.Vx;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (planForm) {
				return {D5: apiClient, ny: planForm};
			},
			A9(
				$author$project$Components$Plan$Form$init,
				apiClient,
				timeZone,
				currentDate,
				session,
				practice,
				query,
				$author$project$Spa$Generated$Route$Admin__Plans__Top,
				params.adR,
				{adN: hinterViewOff, WI: false}));
	});
var $author$project$Pages$Admin$Plans$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Plans$Id_String$subscriptions = function (model) {
	return $author$project$Components$Plan$Form$subscriptions(model.ny);
};
var $author$project$Pages$Admin$Plans$Id_String$update = F2(
	function (msg, model) {
		return A2(
			$author$project$Utils$Tuple3$mapFirst,
			function (planForm) {
				return _Utils_update(
					model,
					{ny: planForm});
			},
			A3($author$project$Components$Plan$Form$update, model.D5, msg, model.ny));
	});
var $author$project$Pages$Admin$Plans$Id_String$view = function (model) {
	return {
		e5: $author$project$Components$Plan$Form$view(model.ny),
		$G: 'Admin | Membership Plans'
	};
};
var $author$project$Pages$Admin$Plans$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Plans$Id_String$init, aer: $author$project$Pages$Admin$Plans$Id_String$load, agD: $author$project$Pages$Admin$Plans$Id_String$save, ahd: $author$project$Pages$Admin$Plans$Id_String$subscriptions, aaq: $author$project$Pages$Admin$Plans$Id_String$update, ahP: $author$project$Pages$Admin$Plans$Id_String$view});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$FormMsg = $elm$core$Basics$identity;
var $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PricingVersions$Form$GotCurrentDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingVersions$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PricingVersion$One$PricingVersion = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PricingVersion$One$Record = function (plan) {
	return {GH: plan};
};
var $author$project$Api$Provider$PricingVersion$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$One$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$One$Record));
var $author$project$Api$Provider$PricingVersion$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingVersion$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PricingVersion$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$One$PricingVersion)));
var $author$project$Api$Provider$PricingVersion$pricingVersionsPath = function (planId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['plans', planId, 'pricing_versions']),
		$author$project$Api$Data$providerPath);
};
var $author$project$Api$Provider$PricingVersion$new = F3(
	function (apiClient, planId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PricingVersion$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['new']),
					$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
	});
var $author$project$Api$Provider$PricingVersion$retrieve = F4(
	function (apiClient, planId, pricingVersionId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PricingVersion$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[pricingVersionId]),
					$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
	});
var $author$project$Components$PricingVersions$Form$fetchPricingVersion = F3(
	function (apiClient, planId, pricingVersionId) {
		if (!pricingVersionId.$) {
			var pricingVersionId_ = pricingVersionId.a;
			return A4($author$project$Api$Provider$PricingVersion$retrieve, apiClient, planId, pricingVersionId_, $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion);
		} else {
			return A3($author$project$Api$Provider$PricingVersion$new, apiClient, planId, $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion);
		}
	});
var $author$project$Components$PricingVersions$Form$init = F4(
	function (apiClient, settings, _v0, pricingVersionId) {
		var _v1 = $author$project$Components$DateInput$init;
		var effectiveDateInput = _v1.a;
		var effectiveDateCmd = _v1.b;
		return _Utils_Tuple2(
			{
				k: $author$project$Api$Data$Loading,
				JT: settings.JT,
				cO: $elm$core$Maybe$Nothing,
				iz: effectiveDateInput,
				PB: $elm$core$Maybe$Nothing,
				FU: $author$project$Api$Data$NotAsked,
				F_: settings.F_,
				WF: settings.WF,
				afU: _Utils_Tuple2(0, $author$project$Api$Data$NotAsked),
				em: $jinjor$elm_debounce$Debounce$init,
				nH: $author$project$Api$Data$Loading,
				afY: pricingVersionId,
				ZD: settings.ZD,
				gO: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Components$PricingVersions$Form$fetchPricingVersion, apiClient, settings.JT, pricingVersionId),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg, effectiveDateCmd),
						A2($elm$core$Task$perform, $author$project$Components$PricingVersions$Form$GotCurrentDate, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		var settings = {JT: params.adR, F_: $author$project$Spa$Generated$Route$Admin__Plans__Top, WF: practice, ZD: session};
		var _v1 = A4($author$project$Components$PricingVersions$Form$init, shared.D5, settings, params.adR, $elm$core$Maybe$Nothing);
		var form = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form, WF: practice, ZD: session, Cd: shared},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{Cd: shared}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PricingVersions$Form$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			function (form) {
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$PricingVersions$Form$BasicPlanFormUpdated,
					$author$project$Components$Plan$BasicForm$subscriptions(form.aA));
			},
			model.PB));
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PricingVersions$Form$subscriptions(model.PB));
};
var $author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PricingVersions$Form$GotPreview = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PricingVersions$Form$PricingVersionCreated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$PricingVersions$Form$PricingVersionUpdated = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing = {$: 10};
var $author$project$Api$Provider$PricingVersion$encodeFields = function (fields) {
	var planFields = fields.Wn;
	var baseFields = _List_fromArray(
		[
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string(fields.zh)),
			_Utils_Tuple2(
			'effective_date',
			$elm$json$Json$Encode$string(fields.Od)),
			_Utils_Tuple2(
			'registration_fee_name',
			$elm$json$Json$Encode$string(fields.Bq)),
			_Utils_Tuple2(
			'registration_fee_description',
			$elm$json$Json$Encode$string(fields.Bp)),
			_Utils_Tuple2(
			'registration_fee_category',
			A2(
				$author$project$Utils$Encode$nullable,
				function (id) {
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(id))
							]));
				},
				fields.Bo)),
			_Utils_Tuple2(
			'discounts_enabled',
			$elm$json$Json$Encode$bool(fields.xg)),
			_Utils_Tuple2(
			'group_pricing_type',
			$elm$json$Json$Encode$string(fields.P_)),
			_Utils_Tuple2(
			'split_revenue_type',
			$elm$json$Json$Encode$string(planFields._r)),
			_Utils_Tuple2(
			'applies_group_discount_in_tiers',
			$elm$json$Json$Encode$bool(fields.Jj)),
			_Utils_Tuple2(
			'single_parent_with_single_child_rate_rule_enabled',
			$elm$json$Json$Encode$bool(planFields._b)),
			_Utils_Tuple2(
			'family_with_single_child_rate_rule_enabled',
			$elm$json$Json$Encode$bool(planFields.Pa)),
			_Utils_Tuple2(
			'group_discount_rules_calculated_by',
			function () {
				var _v0 = fields.PX;
				if (!_v0.$) {
					var calculatedBy = _v0.a;
					return $elm$json$Json$Encode$string(calculatedBy);
				} else {
					return $elm$json$Json$Encode$string('percent_off');
				}
			}()),
			_Utils_Tuple2(
			'children_age_limit',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.v3)),
			_Utils_Tuple2(
			'family_num_children_included',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.xB)),
			_Utils_Tuple2(
			'family_num_adults_included',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.O6)),
			_Utils_Tuple2(
			'fixed_children_age_limit',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.Pv)),
			_Utils_Tuple2(
			'group_pricing_family_num_children_included',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.PZ)),
			_Utils_Tuple2(
			'number_additional_children_allowed',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.zC)),
			_Utils_Tuple2(
			'default_charge_name',
			$elm$json$Json$Encode$string(planFields.w5)),
			_Utils_Tuple2(
			'default_charge_description',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, planFields.w4)),
			_Utils_Tuple2(
			'individual_registration_fee_in_cents',
			A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, planFields.QW)),
			_Utils_Tuple2(
			'max_registration_fee_in_cents',
			A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, planFields.Tr)),
			_Utils_Tuple2(
			'minimum_enrollment_period_in_months',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.T3)),
			_Utils_Tuple2(
			'individual_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.QU)),
			_Utils_Tuple2(
			'couple_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.L$)),
			_Utils_Tuple2(
			'family_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.O7)),
			_Utils_Tuple2(
			'single_parent_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.Z8)),
			_Utils_Tuple2(
			'single_parent_with_single_child_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields._a)),
			_Utils_Tuple2(
			'family_with_single_child_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.O9)),
			_Utils_Tuple2(
			'additional_adult_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.Io)),
			_Utils_Tuple2(
			'additional_child_rate_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.Ip)),
			_Utils_Tuple2(
			'couple_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.wQ)),
			_Utils_Tuple2(
			'family_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.xA)),
			_Utils_Tuple2(
			'single_parent_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.Cn)),
			_Utils_Tuple2(
			'additional_adult_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.tJ)),
			_Utils_Tuple2(
			'additional_child_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.tK)),
			_Utils_Tuple2(
			'children_only_discount_rule',
			A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.v4)),
			_Utils_Tuple2(
			'group_discount_rules',
			A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields, planFields.PW)),
			_Utils_Tuple2(
			'special_rates',
			A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeSpecialRateFields, planFields._o)),
			_Utils_Tuple2(
			'age_rate_rules',
			A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, planFields.IL))
		]);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'pricing_version',
				$elm$json$Json$Encode$object(baseFields))
			]));
};
var $author$project$Api$Provider$PricingVersion$calculate = F7(
	function (apiClient, planId, pricingVersionId, expand, tracker, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$PricingVersion$encodeFields(fields),
				A2(
					$author$project$Api$Data$requestWithTracker,
					tracker,
					A2(
						$author$project$Api$Data$requestWithQuery,
						_List_fromArray(
							[
								A2(
								$author$project$Api$Param$list,
								'expand',
								A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
							]),
						$author$project$Api$Data$requestTo(
							A2(
								$author$project$Api$Data$pathAppend,
								_List_fromArray(
									[pricingVersionId, 'calculate']),
								$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId)))))));
	});
var $author$project$Components$PricingVersions$Form$formFields = function (form) {
	return {Jj: form.Jj, aA: form.aA, xg: form.xg, Od: form.Od, aI: form.aI, cU: form.cU, PW: form.PW, PX: form.PX, P_: form.P_, i: form.i, cX: form.cX, zh: form.zh, o: form.o, de: form.de};
};
var $author$project$Components$PricingVersions$Form$PreviewDebouncedMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$PricingVersions$Form$previewDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$PricingVersions$Form$PreviewDebouncedMsg
};
var $author$project$Components$PricingVersions$Form$validateEffectiveDate = F2(
	function (touched, maybeDate) {
		if (!touched) {
			return _List_Nil;
		} else {
			if (maybeDate.$ === 1) {
				return _List_fromArray(
					['Please enter an effective date.']);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$PricingVersions$Form$validatePricingVersionName = function (name) {
	var trimmedName = $elm$core$String$trim(name);
	return $elm$core$String$isEmpty(trimmedName) ? _List_fromArray(
		['Please enter a name.']) : _List_Nil;
};
var $author$project$Components$PricingVersions$Form$validateForm = F3(
	function (_v0, _v1, form) {
		var specialRatesHasErrors = function () {
			var _v2 = form.de;
			if (!_v2.$) {
				var specialRatesForm = _v2.a;
				return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
			} else {
				return false;
			}
		}();
		var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.zh);
		var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(form.cX);
		var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(form.i);
		var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(form.cU);
		var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, form.aI, form.Od);
		var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(form.aA);
		return $elm$core$List$isEmpty(nameErrors) && ($elm$core$List$isEmpty(effectiveDateErrors) && ((!basicPlanHasErrors) && ((!individualPricingHasErrors) && ((!familyPricingHasErrors) && ((!groupTierPricingHasErrors) && (!specialRatesHasErrors))))));
	});
var $author$project$Components$PricingVersions$Form$calculate = F4(
	function (model, plan, form, opts) {
		var isValid = (!opts.aaM) || A3(
			$author$project$Components$PricingVersions$Form$validateForm,
			$elm$core$Maybe$Just(plan),
			model.WF,
			form);
		var _v0 = (opts.ZP && isValid) ? A3(
			$jinjor$elm_debounce$Debounce$push,
			$author$project$Components$PricingVersions$Form$previewDebounceConfig,
			$author$project$Components$PricingVersions$Form$formFields(form),
			model.em) : _Utils_Tuple2(model.em, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			function () {
				if (opts.ZP && isValid) {
					return _Utils_update(
						model,
						{
							PB: $elm$core$Maybe$Just(form),
							em: newDebouncer
						});
				} else {
					if (!isValid) {
						var previewId = model.afU.a + 1;
						return _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(form),
								afU: _Utils_Tuple2(previewId, $author$project$Api$Data$NotAsked),
								em: newDebouncer
							});
					} else {
						return _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(form),
								em: newDebouncer
							});
					}
				}
			}(),
			cmd);
	});
var $author$project$Api$Provider$PricingVersion$create = F4(
	function (apiClient, planId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$PricingVersion$encodeFields(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
	});
var $author$project$Components$PricingVersions$Form$PreviewDebounced = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$PricingVersions$Form$debounceCalculate = function (pricingFormFields) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$PricingVersions$Form$PreviewDebounced,
		$elm$core$Task$succeed(pricingFormFields));
};
var $author$project$Api$Provider$PricingVersion$One$effectiveDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$effectiveDate(shared);
};
var $author$project$Components$PricingVersions$Form$exclusiveRanges = F5(
	function (fromGetter, fromSetter, toGetter, toSetter, range) {
		if ($elm$core$List$isEmpty(range)) {
			return range;
		} else {
			var minimum = A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					fromGetter,
					$elm$core$List$head(range)));
			return A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, current) {
						var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
						var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
						var newTo = function () {
							var _v1 = _Utils_Tuple2(
								next,
								toGetter(current));
							if (_v1.a.$ === 1) {
								var _v2 = _v1.a;
								return $elm$core$Maybe$Nothing;
							} else {
								if (_v1.b.$ === 1) {
									var _v3 = _v1.b;
									return toGetter(current);
								} else {
									var currentTo = _v1.b.a;
									var currentFrom = fromGetter(current);
									return (_Utils_cmp(currentTo, currentFrom) < 1) ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
								}
							}
						}();
						var newFrom = function () {
							var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
							if (!_v0.$) {
								var _int = _v0.a;
								return _int + 1;
							} else {
								return minimum;
							}
						}();
						return A2(
							toSetter,
							newTo,
							A2(fromSetter, newFrom, current));
					}),
				range);
		}
	});
var $author$project$Components$PricingVersions$Form$exclusiveSizeRanges = A4(
	$author$project$Components$PricingVersions$Form$exclusiveRanges,
	function ($) {
		return $.PJ;
	},
	F2(
		function (from, item) {
			return _Utils_update(
				item,
				{PJ: from});
		}),
	function ($) {
		return $.$K;
	},
	F2(
		function (to, item) {
			return _Utils_update(
				item,
				{$K: to});
		}));
var $author$project$Components$PricingVersions$Form$initFormFieldsWithSpecialRates = F6(
	function (apiClient, session, practice, plan, maybePricingVersion, currentSpecialRatesForm) {
		var specialRatesForm = $elm$core$Maybe$Just(
			A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, currentSpecialRatesForm, plan, $elm$core$Maybe$Nothing));
		var membershipPricingForm = A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var groupTierPricingForm = A2($author$project$Components$Plan$Form$GroupTierPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var groupDiscountRules = A2(
			$elm$core$List$map,
			$author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer,
			$author$project$Api$Provider$Plan$One$groupDiscountRules(plan));
		var familyMembershipPricingForm = A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
		var _v0 = A6(
			$author$project$Components$Plan$BasicForm$fill,
			practice,
			plan,
			false,
			false,
			$elm$core$Maybe$Just(
				_Utils_Tuple2(apiClient, session)),
			maybePricingVersion);
		var basicPlanForm = _v0.a;
		var basicPlanCmd = _v0.b;
		return _Utils_Tuple2(
			{
				Jj: A2(
					$elm$core$Maybe$withDefault,
					false,
					$author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan)),
				aA: basicPlanForm,
				xg: $author$project$Api$Provider$Plan$One$discountsEnabled(plan),
				Od: $elm$core$Maybe$Nothing,
				aI: false,
				cU: familyMembershipPricingForm,
				PW: groupDiscountRules,
				PX: $elm$core$Maybe$Just('percent_off'),
				P_: $author$project$Api$Provider$Plan$One$groupPricingType(plan),
				i: groupTierPricingForm,
				cX: membershipPricingForm,
				zh: '',
				o: false,
				de: specialRatesForm
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, basicPlanCmd));
	});
var $author$project$Api$Provider$PricingVersion$Shared$discountsEnabled = function (_v0) {
	var record = _v0;
	return record.xg;
};
var $author$project$Api$Provider$PricingVersion$One$discountsEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$discountsEnabled(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$groupDiscountRules = function (_v0) {
	var record = _v0;
	return record.PW;
};
var $author$project$Api$Provider$PricingVersion$One$groupDiscountRules = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$groupDiscountRules(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$groupPricingType = function (_v0) {
	var record = _v0;
	return record.P_;
};
var $author$project$Api$Provider$PricingVersion$One$groupPricingType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$groupPricingType(shared);
};
var $author$project$Api$Provider$PricingVersion$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$PricingVersion$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PricingVersion$Shared$name(shared);
};
var $author$project$Api$Provider$PricingVersion$One$plan = function (_v0) {
	var record = _v0.b;
	return record.GH;
};
var $author$project$Components$PricingVersions$Form$initFormFromPricingVersion = F6(
	function (apiClient, session, pricingVersion, plan, practice, currentDate) {
		var loadedGroupDiscountRules = A2(
			$elm$core$List$map,
			$author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer,
			$author$project$Api$Provider$PricingVersion$One$groupDiscountRules(pricingVersion));
		var groupDiscountRules = $elm$core$List$isEmpty(loadedGroupDiscountRules) ? _List_fromArray(
			[
				$author$project$Components$Plan$Form$GroupDiscountRuleField$default(
				$author$project$Api$Provider$Plan$One$defaultPeriod(
					$author$project$Api$Provider$PricingVersion$One$plan(pricingVersion)))
			]) : loadedGroupDiscountRules;
		var groupDiscountRulesCalculatedBy = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Km;
			},
			$elm$core$List$head(groupDiscountRules));
		var defaultName = function () {
			if (!currentDate.$) {
				var date = currentDate.a;
				return $elm$core$String$fromInt(
					$justinmimbs$date$Date$year(date) + 1) + ' Pricing';
			} else {
				return '2025 Pricing';
			}
		}();
		var pricingVersionName = A2(
			$elm$core$Maybe$withDefault,
			defaultName,
			$author$project$Api$Provider$PricingVersion$One$name(pricingVersion));
		var _v0 = A6(
			$author$project$Components$Plan$BasicForm$fill,
			practice,
			plan,
			false,
			false,
			$elm$core$Maybe$Just(
				_Utils_Tuple2(apiClient, session)),
			$elm$core$Maybe$Just(pricingVersion));
		var basicPlan = _v0.a;
		var basicPlanCmd = _v0.b;
		return _Utils_Tuple2(
			{
				Jj: A2(
					$elm$core$Maybe$withDefault,
					true,
					$author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers(pricingVersion)),
				aA: basicPlan,
				xg: $author$project$Api$Provider$PricingVersion$One$discountsEnabled(pricingVersion),
				Od: $elm$core$Maybe$Just(
					$author$project$Api$Provider$PricingVersion$One$effectiveDate(pricingVersion)),
				aI: false,
				cU: A2(
					$author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill,
					plan,
					$elm$core$Maybe$Just(pricingVersion)),
				PW: groupDiscountRules,
				PX: groupDiscountRulesCalculatedBy,
				P_: $author$project$Api$Provider$PricingVersion$One$groupPricingType(pricingVersion),
				i: A2(
					$author$project$Components$Plan$Form$GroupTierPricingFields$fill,
					plan,
					$elm$core$Maybe$Just(pricingVersion)),
				cX: A2(
					$author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill,
					plan,
					$elm$core$Maybe$Just(pricingVersion)),
				zh: pricingVersionName,
				o: false,
				de: $elm$core$Maybe$Just(
					A3(
						$author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm,
						$elm$core$Maybe$Nothing,
						plan,
						$elm$core$Maybe$Just(pricingVersion)))
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, basicPlanCmd));
	});
var $author$project$Components$PricingVersions$Form$initSharedFields = F2(
	function (maybePlan, form) {
		var basicPlanFields = $author$project$Components$Plan$BasicForm$formFields(form.aA);
		return {Nf: basicPlanFields.Nf, P_: form.P_, GH: maybePlan};
	});
var $author$project$Components$PricingVersions$Form$maxGroupFromSize = 10;
var $author$project$Components$PricingVersions$Form$planRoute = function (planId) {
	return $author$project$Spa$Generated$Route$Admin__Plans__Id_String(
		{adR: planId});
};
var $author$project$Api$Provider$PricingVersion$update = F5(
	function (apiClient, planId, pricingVersionId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$PricingVersion$encodeFields(fields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[pricingVersionId]),
						$author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId)))));
	});
var $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate = function (pricingFormFields) {
	var specialRatesFormFields = function () {
		var _v0 = pricingFormFields.de;
		if (!_v0.$) {
			var specialRatesForm = _v0.a;
			return $author$project$Components$Plan$Form$SpecialRatesFields$formFields(specialRatesForm);
		} else {
			return {_o: _List_Nil};
		}
	}();
	var groupTierPricingFormFields = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(pricingFormFields.i);
	var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(pricingFormFields.cU);
	var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(pricingFormFields.aA);
	var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.c9);
	return {
		tJ: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {I9: rule.I9, Ja: rule.Ja, Ub: rule.Ub, Uc: rule.Uc, XA: rule.XA, XB: rule.XB, Zn: rule.Zn, Zo: rule.Zo};
			},
			familyMembershipPricingFormFields.YY.tJ.Ot ? familyMembershipPricingFormFields.tJ : $elm$core$Maybe$Nothing),
		Io: groupTierPricingFormFields.YY.O6.Ot ? $elm$core$Maybe$Just(
			{I5: groupTierPricingFormFields.Io.I5, e_: groupTierPricingFormFields.Io.e_, T8: groupTierPricingFormFields.Io.T8, f5: groupTierPricingFormFields.Io.f5, Xw: groupTierPricingFormFields.Io.Xw, gr: groupTierPricingFormFields.Io.gr, Zj: groupTierPricingFormFields.Io.Zj, gG: groupTierPricingFormFields.Io.gG}) : $elm$core$Maybe$Nothing,
		tK: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {I9: rule.I9, Ja: rule.Ja, Ub: rule.Ub, Uc: rule.Uc, XA: rule.XA, XB: rule.XB, Zn: rule.Zn, Zo: rule.Zo};
			},
			familyMembershipPricingFormFields.YY.tK.Ot ? familyMembershipPricingFormFields.tK : $elm$core$Maybe$Nothing),
		Ip: groupTierPricingFormFields.YY.PZ.Ot ? $elm$core$Maybe$Just(
			{I5: groupTierPricingFormFields.Ip.I5, e_: groupTierPricingFormFields.Ip.e_, T8: groupTierPricingFormFields.Ip.T8, f5: groupTierPricingFormFields.Ip.f5, Xw: groupTierPricingFormFields.Ip.Xw, gr: groupTierPricingFormFields.Ip.gr, Zj: groupTierPricingFormFields.Ip.Zj, gG: groupTierPricingFormFields.Ip.gG}) : $elm$core$Maybe$Nothing,
		Iq: basicPlanFormFields.Iq,
		IL: function () {
			var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(pricingFormFields.cX);
			var ageRateRules = membershipPricingFormFields.IL;
			return A2(
				$elm$core$List$map,
				function (ageRateRule) {
					return {
						I5: ageRateRule.c7.I5,
						e_: ageRateRule.c7.e_,
						L_: A2(
							$elm$core$Maybe$map,
							function (coupleRule) {
								return {I5: coupleRule.c7.I5, e_: coupleRule.c7.e_, T8: coupleRule.c7.T8, f5: coupleRule.c7.f5, Xw: coupleRule.c7.Xw, gr: coupleRule.c7.gr, Zj: coupleRule.c7.Zj, gG: coupleRule.c7.gG};
							},
							ageRateRule.L_),
						PH: $elm$core$Maybe$Just(ageRateRule.PH),
						T8: ageRateRule.c7.T8,
						f5: ageRateRule.c7.f5,
						Xw: ageRateRule.c7.Xw,
						gr: ageRateRule.c7.gr,
						Zj: ageRateRule.c7.Zj,
						gG: ageRateRule.c7.gG,
						$I: ageRateRule.$I,
						aai: ageRateRule.aai
					};
				},
				ageRateRules);
		}(),
		vn: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.vn),
		vo: basicPlanFormFields.vo,
		Jj: pricingFormFields.Jj,
		J0: basicPlanFormFields.J0,
		Kh: basicPlanFormFields.Kh,
		v3: familyMembershipPricingFormFields.v3,
		v4: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {I9: rule.I9, Ja: rule.Ja, Ub: rule.Ub, Uc: rule.Uc, XA: rule.XA, XB: rule.XB, Zn: rule.Zn, Zo: rule.Zo};
			},
			familyMembershipPricingFormFields.YY.v4.Ot ? familyMembershipPricingFormFields.v4 : $elm$core$Maybe$Nothing),
		LO: false,
		LP: false,
		LQ: $elm$core$Maybe$Nothing,
		LR: $elm$core$Maybe$Nothing,
		EI: $elm$core$Maybe$Nothing,
		wQ: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {I9: rule.I9, Ja: rule.Ja, Ub: rule.Ub, Uc: rule.Uc, XA: rule.XA, XB: rule.XB, Zn: rule.Zn, Zo: rule.Zo};
			},
			familyMembershipPricingFormFields.YY.wQ.Ot ? familyMembershipPricingFormFields.wQ : $elm$core$Maybe$Nothing),
		L$: $elm$core$Maybe$Just(
			{I5: groupTierPricingFormFields.L$.I5, e_: groupTierPricingFormFields.L$.e_, T8: groupTierPricingFormFields.L$.T8, f5: groupTierPricingFormFields.L$.f5, Xw: groupTierPricingFormFields.L$.Xw, gr: groupTierPricingFormFields.L$.gr, Zj: groupTierPricingFormFields.L$.Zj, gG: groupTierPricingFormFields.L$.gG}),
		L5: $elm$core$Maybe$Nothing,
		w4: basicPlanFormFields.w4,
		w5: basicPlanFormFields.w5,
		Nf: basicPlanFormFields.Nf,
		E1: $elm$core$Dict$empty,
		xg: pricingFormFields.xg,
		xA: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {I9: rule.I9, Ja: rule.Ja, Ub: rule.Ub, Uc: rule.Uc, XA: rule.XA, XB: rule.XB, Zn: rule.Zn, Zo: rule.Zo};
			},
			familyMembershipPricingFormFields.YY.xA.Ot ? familyMembershipPricingFormFields.xA : $elm$core$Maybe$Nothing),
		O6: groupTierPricingFormFields.YY.O6.Ot ? groupTierPricingFormFields.O6 : $elm$core$Maybe$Nothing,
		xB: familyMembershipPricingFormFields.xB,
		O7: $elm$core$Maybe$Just(
			{I5: groupTierPricingFormFields.O7.I5, e_: groupTierPricingFormFields.O7.e_, T8: groupTierPricingFormFields.O7.T8, f5: groupTierPricingFormFields.O7.f5, Xw: groupTierPricingFormFields.O7.Xw, gr: groupTierPricingFormFields.O7.gr, Zj: groupTierPricingFormFields.O7.Zj, gG: groupTierPricingFormFields.O7.gG}),
		O9: groupTierPricingFormFields.Pa ? $elm$core$Maybe$Just(
			{I5: groupTierPricingFormFields.O9.I5, e_: groupTierPricingFormFields.O9.e_, T8: groupTierPricingFormFields.O9.T8, f5: groupTierPricingFormFields.O9.f5, Xw: groupTierPricingFormFields.O9.Xw, gr: groupTierPricingFormFields.O9.gr, Zj: groupTierPricingFormFields.O9.Zj, gG: groupTierPricingFormFields.O9.gG}) : $elm$core$Maybe$Nothing,
		Pa: groupTierPricingFormFields.Pa,
		Pv: groupTierPricingFormFields.YY.Pv.Ot ? groupTierPricingFormFields.Pv : $elm$core$Maybe$Nothing,
		PW: A2(
			$elm$core$List$map,
			function (groupDiscountRule) {
				return {
					I7: groupDiscountRule.I7,
					I8: groupDiscountRule.I8,
					Jd: groupDiscountRule.Jd,
					Je: groupDiscountRule.Je,
					Km: groupDiscountRule.Km,
					PJ: $elm$core$Maybe$Just(groupDiscountRule.PJ),
					T9: groupDiscountRule.T9,
					Ua: groupDiscountRule.Ua,
					Ug: groupDiscountRule.Ug,
					Uh: groupDiscountRule.Uh,
					Xy: groupDiscountRule.Xy,
					Xz: groupDiscountRule.Xz,
					XE: groupDiscountRule.XE,
					XF: groupDiscountRule.XF,
					Zl: groupDiscountRule.Zl,
					Zm: groupDiscountRule.Zm,
					Zr: groupDiscountRule.Zr,
					Zs: groupDiscountRule.Zs,
					$K: groupDiscountRule.$K
				};
			},
			pricingFormFields.PW),
		PZ: groupTierPricingFormFields.YY.PZ.Ot ? groupTierPricingFormFields.PZ : $elm$core$Maybe$Nothing,
		P_: pricingFormFields.P_,
		QN: $elm$core$Maybe$Nothing,
		QU: $elm$core$Maybe$Just(
			{I5: groupTierPricingFormFields.QU.I5, e_: groupTierPricingFormFields.QU.e_, T8: groupTierPricingFormFields.QU.T8, f5: groupTierPricingFormFields.QU.f5, Xw: groupTierPricingFormFields.QU.Xw, gr: groupTierPricingFormFields.QU.gr, Zj: groupTierPricingFormFields.QU.Zj, gG: groupTierPricingFormFields.QU.gG}),
		QW: registrationFeeFields.YY.QW.Ot ? registrationFeeFields.QW : $elm$core$Maybe$Nothing,
		So: $elm$core$Maybe$Nothing,
		Tr: registrationFeeFields.YY.Tr.Ot ? registrationFeeFields.Tr : $elm$core$Maybe$Nothing,
		Tu: $elm$core$Maybe$Nothing,
		T1: $elm$core$Maybe$Nothing,
		T3: basicPlanFormFields.T3,
		y9: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.y9),
		za: basicPlanFormFields.za,
		zh: basicPlanFormFields.zh,
		zC: familyMembershipPricingFormFields.zC,
		W0: 0,
		Bf: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bf),
		Bg: basicPlanFormFields.Bg,
		Bo: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(basicPlanFormFields.c9),
		Bp: basicPlanFormFields.Bp,
		Bq: basicPlanFormFields.Bq,
		B6: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.B6),
		B7: basicPlanFormFields.B7,
		Cn: A2(
			$elm$core$Maybe$map,
			function (rule) {
				return {I9: rule.I9, Ja: rule.Ja, Ub: rule.Ub, Uc: rule.Uc, XA: rule.XA, XB: rule.XB, Zn: rule.Zn, Zo: rule.Zo};
			},
			familyMembershipPricingFormFields.YY.Cn.Ot ? familyMembershipPricingFormFields.Cn : $elm$core$Maybe$Nothing),
		Z8: $elm$core$Maybe$Just(
			{I5: groupTierPricingFormFields.Z8.I5, e_: groupTierPricingFormFields.Z8.e_, T8: groupTierPricingFormFields.Z8.T8, f5: groupTierPricingFormFields.Z8.f5, Xw: groupTierPricingFormFields.Z8.Xw, gr: groupTierPricingFormFields.Z8.gr, Zj: groupTierPricingFormFields.Z8.Zj, gG: groupTierPricingFormFields.Z8.gG}),
		_a: groupTierPricingFormFields._b ? $elm$core$Maybe$Just(
			{I5: groupTierPricingFormFields._a.I5, e_: groupTierPricingFormFields._a.e_, T8: groupTierPricingFormFields._a.T8, f5: groupTierPricingFormFields._a.f5, Xw: groupTierPricingFormFields._a.Xw, gr: groupTierPricingFormFields._a.gr, Zj: groupTierPricingFormFields._a.Zj, gG: groupTierPricingFormFields._a.gG}) : $elm$core$Maybe$Nothing,
		_b: groupTierPricingFormFields._b,
		_o: A2(
			$elm$core$List$map,
			function (specialRate) {
				return {I5: specialRate.I5, e_: specialRate.e_, Me: specialRate.Me, NB: specialRate.NB, adR: specialRate.adR, T8: specialRate.T8, f5: specialRate.f5, zh: specialRate.zh, Xw: specialRate.Xw, gr: specialRate.gr, Zj: specialRate.Zj, gG: specialRate.gG};
			},
			A2(
				$elm$core$List$filter,
				function (specialRate) {
					return !specialRate.NB;
				},
				specialRatesFormFields._o)),
		_r: groupTierPricingFormFields._r,
		Hi: basicPlanFormFields.Hi,
		$M: $author$project$Currency$zero,
		$N: $author$project$Percentage$zero,
		$O: $elm$core$Maybe$Nothing
	};
};
var $author$project$Components$PricingVersions$Form$updatePlanFieldsForSave = function (pricingFormFields) {
	var specialRatesFormFields = function () {
		var _v0 = pricingFormFields.de;
		if (!_v0.$) {
			var specialRatesForm = _v0.a;
			return $author$project$Components$Plan$Form$SpecialRatesFields$formFields(specialRatesForm);
		} else {
			return {_o: _List_Nil};
		}
	}();
	var planFieldsForCalculate = $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate(pricingFormFields);
	return _Utils_update(
		planFieldsForCalculate,
		{
			_o: A2(
				$elm$core$List$map,
				function (specialRate) {
					return {I5: specialRate.I5, e_: specialRate.e_, Me: specialRate.Me, NB: specialRate.NB, adR: specialRate.adR, T8: specialRate.T8, f5: specialRate.f5, zh: specialRate.zh, Xw: specialRate.Xw, gr: specialRate.gr, Zj: specialRate.Zj, gG: specialRate.gG};
				},
				specialRatesFormFields._o)
		});
};
var $author$project$Components$PricingVersions$Form$validateFormFields = F3(
	function (maybePlan, practice, form) {
		var validatedBasicPlan = function () {
			var _v8 = A2($author$project$Components$Plan$BasicForm$validate, form.aA, maybePlan);
			if (!_v8.$) {
				var _v9 = _v8.a;
				var newForm_ = _v9.a;
				return newForm_;
			} else {
				var newForm_ = _v8.a;
				return newForm_;
			}
		}();
		var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
		var validatedFamilyMembershipPricingForm = function () {
			var _v6 = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate, form.cU, sharedFields, maybePlan);
			if (!_v6.$) {
				var _v7 = _v6.a;
				var newForm_ = _v7.a;
				return newForm_;
			} else {
				var newForm_ = _v6.a;
				return newForm_;
			}
		}();
		var validatedGroupTierPricingForm = function () {
			var _v4 = A3($author$project$Components$Plan$Form$GroupTierPricingFields$validate, sharedFields, form.i, maybePlan);
			if (!_v4.$) {
				var _v5 = _v4.a;
				var newForm_ = _v5.a;
				return newForm_;
			} else {
				var newForm_ = _v4.a;
				return newForm_;
			}
		}();
		var validatedIndividualMembershipPricingForm = function () {
			var _v2 = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate, sharedFields, form.cX, maybePlan);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var newForm_ = _v3.a;
				return newForm_;
			} else {
				var newForm_ = _v2.a;
				return newForm_;
			}
		}();
		var validatedSpecialRatesForm = A2(
			$elm$core$Maybe$map,
			function (specialRatesForm) {
				var _v0 = A4($author$project$Components$Plan$Form$SpecialRatesFields$validate, sharedFields, practice, specialRatesForm, maybePlan);
				if (!_v0.$) {
					var _v1 = _v0.a;
					var newForm_ = _v1.a;
					return newForm_;
				} else {
					var newForm_ = _v0.a;
					return newForm_;
				}
			},
			form.de);
		return _Utils_update(
			form,
			{aA: validatedBasicPlan, cU: validatedFamilyMembershipPricingForm, i: validatedGroupTierPricingForm, cX: validatedIndividualMembershipPricingForm, de: validatedSpecialRatesForm});
	});
var $author$project$Components$PricingVersions$Form$update = F3(
	function (apiClient, msg, _v0) {
		update:
		while (true) {
			var model = _v0;
			switch (msg.$) {
				case 1:
					var currentDate = msg.a;
					var currentYear = $justinmimbs$date$Date$year(currentDate);
					var nextYear = currentYear + 1;
					var newName = $elm$core$String$fromInt(nextYear) + ' Pricing';
					var newForm = A2(
						$elm$core$Maybe$map,
						function (form) {
							return _Utils_update(
								form,
								{zh: newName});
						},
						model.PB);
					var updatedItem = function () {
						var _v2 = model.FU;
						if (_v2.$ === 3) {
							var pricingVersion = _v2.a;
							var meta = _v2.b;
							return A2(
								$author$project$Api$Data$Success,
								_Utils_update(
									pricingVersion,
									{zh: newName}),
								meta);
						} else {
							var other = _v2;
							return other;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cO: $elm$core$Maybe$Just(currentDate),
								PB: newForm,
								FU: updatedItem
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 0:
					var pricingVersionData = msg.a;
					if (pricingVersionData.$ === 3) {
						var pricingVersion = pricingVersionData.a;
						var meta = pricingVersionData.b;
						var updatedEffectiveDateInput = function () {
							var _v7 = model.afY;
							if (!_v7.$) {
								return $author$project$Components$DateInput$initFromDate(
									$author$project$Api$Provider$PricingVersion$One$effectiveDate(pricingVersion));
							} else {
								return model.iz;
							}
						}();
						var plan = $author$project$Api$Provider$PricingVersion$One$plan(pricingVersion);
						var planData = A2($author$project$Api$Data$Success, plan, meta);
						var _v4 = A6($author$project$Components$PricingVersions$Form$initFormFromPricingVersion, apiClient, model.ZD, pricingVersion, plan, model.WF, model.cO);
						var initialForm = _v4.a;
						var initCmd = _v4.b;
						var finalForm = function () {
							var _v5 = model.PB;
							if (!_v5.$) {
								var existingForm = _v5.a;
								return _Utils_update(
									initialForm,
									{Od: existingForm.Od, aI: existingForm.aI, zh: existingForm.zh, o: existingForm.o});
							} else {
								var _v6 = model.afY;
								if (!_v6.$) {
									return initialForm;
								} else {
									return _Utils_update(
										initialForm,
										{Od: $elm$core$Maybe$Nothing});
								}
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									k: planData,
									iz: updatedEffectiveDateInput,
									PB: $elm$core$Maybe$Just(finalForm),
									nH: pricingVersionData
								}),
							initCmd,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									k: A2($author$project$Api$Data$map, $author$project$Api$Provider$PricingVersion$One$plan, pricingVersionData),
									nH: pricingVersionData
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				case 2:
					var name = msg.a;
					var _v8 = model.PB;
					if (!_v8.$) {
						var form = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(
										_Utils_update(
											form,
											{zh: name, o: false}))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 3:
					var subMsg = msg.a;
					var _v9 = A2($author$project$Components$DateInput$update, subMsg, model.iz);
					var newDateInput = _v9.a;
					var subCmd = _v9.b;
					var dateInputEvent = _v9.c;
					var newForm = A2(
						$elm$core$Maybe$map,
						function (form) {
							if (dateInputEvent.$ === 1) {
								var date = dateInputEvent.a;
								return _Utils_update(
									form,
									{Od: date, aI: true});
							} else {
								return form;
							}
						},
						model.PB);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iz: newDateInput, PB: newForm}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg, subCmd),
						_List_Nil);
				case 9:
					var formField = msg.a;
					switch (formField.$) {
						case 0:
							var enabled = formField.a;
							var _v12 = _Utils_Tuple2(model.PB, model.k);
							if ((!_v12.a.$) && (_v12.b.$ === 3)) {
								var form = _v12.a.a;
								var _v13 = _v12.b;
								var plan = _v13.a;
								var newForm = _Utils_update(
									form,
									{xg: enabled});
								var calculateOpts = {ZP: true, aaM: false};
								return function (_v14) {
									var newModel = _v14.a;
									var cmd = _v14.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 1:
							var groupPricingType = formField.a;
							var _v15 = _Utils_Tuple2(model.PB, model.k);
							if ((!_v15.a.$) && (_v15.b.$ === 3)) {
								var form = _v15.a.a;
								var _v16 = _v15.b;
								var plan = _v16.a;
								var newForm = _Utils_update(
									form,
									{P_: groupPricingType});
								var calculateOpts = {ZP: true, aaM: false};
								return function (_v17) {
									var newModel = _v17.a;
									var cmd = _v17.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 2:
							var applies = formField.a;
							var _v18 = _Utils_Tuple2(model.PB, model.k);
							if ((!_v18.a.$) && (_v18.b.$ === 3)) {
								var form = _v18.a.a;
								var _v19 = _v18.b;
								var plan = _v19.a;
								var newForm = _Utils_update(
									form,
									{Jj: applies});
								var calculateOpts = {ZP: true, aaM: false};
								return function (_v20) {
									var newModel = _v20.a;
									var cmd = _v20.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 3:
							var isPercent = formField.a;
							var _v21 = model.PB;
							if (!_v21.$) {
								var form = _v21.a;
								var calculatedBy = isPercent ? 'percent_off' : 'amount_off_in_cents';
								var updatedGroupDiscountRules = A2(
									$elm$core$List$map,
									function (groupDiscountRule) {
										return _Utils_update(
											groupDiscountRule,
											{Km: calculatedBy});
									},
									form.PW);
								var newForm = _Utils_update(
									form,
									{
										PW: updatedGroupDiscountRules,
										PX: $elm$core$Maybe$Just(calculatedBy)
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 4:
							var _v22 = model.PB;
							if (!_v22.$) {
								var form = _v22.a;
								var updatedGroupDiscountRules = A2(
									$elm$core$Maybe$withDefault,
									form.PW,
									A2(
										$elm$core$Maybe$map,
										function (_v24) {
											var newGroupDiscountRule = _v24.a;
											var newLastGroupDiscountRule = _v24.b;
											return A2(
												$author$project$Utils$List$prepend,
												_List_fromArray(
													[newGroupDiscountRule]),
												A2(
													$author$project$Utils$List$updateLast,
													function (last) {
														return A2($elm$core$Maybe$withDefault, last, newLastGroupDiscountRule);
													},
													form.PW));
										},
										A2(
											$elm$core$Maybe$map,
											function (lastGroupDiscountRule) {
												var lastToSize = (_Utils_cmp(lastGroupDiscountRule.PJ + 1, $author$project$Components$PricingVersions$Form$maxGroupFromSize - 1) > 0) ? ($author$project$Components$PricingVersions$Form$maxGroupFromSize - 1) : (lastGroupDiscountRule.PJ + 1);
												var newLastGroupDiscountRule_ = _Utils_update(
													lastGroupDiscountRule,
													{
														$K: $elm$core$Maybe$Just(lastToSize)
													});
												var _v23 = $author$project$Components$Plan$BasicForm$formFields(form.aA);
												var defaultPeriod = _v23.Nf;
												return _Utils_Tuple2(
													A2($author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom, defaultPeriod, newLastGroupDiscountRule_),
													$elm$core$Maybe$Just(newLastGroupDiscountRule_));
											},
											$elm_community$list_extra$List$Extra$last(form.PW))));
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 8:
							var index = formField.a;
							var period = formField.b;
							var currency = formField.c;
							var _v25 = model.PB;
							if (!_v25.$) {
								var form = _v25.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{T9: currency, Ua: true});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{Xy: currency, Xz: true});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{Zl: currency, Zm: true});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{I7: currency, I8: true});
											default:
												return groupDiscountRule;
										}
									},
									form.PW);
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								var cmd = function () {
									if (currency.$ === 1) {
										return $elm$core$Platform$Cmd$none;
									} else {
										var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
										return $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 11:
							var index = formField.a;
							var period = formField.b;
							var percentage = formField.c;
							var _v28 = model.PB;
							if (!_v28.$) {
								var form = _v28.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{Ug: percentage, Uh: true});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{XE: percentage, XF: true});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{Zr: percentage, Zs: true});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{Jd: percentage, Je: true});
											default:
												return groupDiscountRule;
										}
									},
									form.PW);
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								var cmd = function () {
									if (percentage.$ === 1) {
										return $elm$core$Platform$Cmd$none;
									} else {
										var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
										return $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 5:
							var index = formField.a;
							var _v31 = _Utils_Tuple2(model.PB, model.k);
							if ((!_v31.a.$) && (_v31.b.$ === 3)) {
								var form = _v31.a.a;
								var _v32 = _v31.b;
								var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(
									A2($elm_community$list_extra$List$Extra$removeAt, index, form.PW));
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
								var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 6:
							var index = formField.a;
							var string = formField.b;
							var _v33 = _Utils_Tuple2(model.PB, model.k);
							if ((!_v33.a.$) && (_v33.b.$ === 3)) {
								var form = _v33.a.a;
								var _v34 = _v33.b;
								var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(
									A3(
										$elm_community$list_extra$List$Extra$updateAt,
										index,
										function (groupDiscountRule) {
											return _Utils_update(
												groupDiscountRule,
												{
													PJ: A2(
														$elm$core$Maybe$withDefault,
														0,
														$elm$core$String$toInt(string))
												});
										},
										form.PW));
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
								var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 7:
							var index = formField.a;
							var string = formField.b;
							var _v35 = _Utils_Tuple2(model.PB, model.k);
							if ((!_v35.a.$) && (_v35.b.$ === 3)) {
								var form = _v35.a.a;
								var _v36 = _v35.b;
								var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(
									A3(
										$elm_community$list_extra$List$Extra$updateAt,
										index,
										function (groupDiscountRule) {
											return _Utils_update(
												groupDiscountRule,
												{
													$K: $elm$core$String$toInt(string)
												});
										},
										form.PW));
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
								var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									cmd,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 9:
							var index = formField.a;
							var period = formField.b;
							var _v37 = model.PB;
							if (!_v37.$) {
								var form = _v37.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{F8: true});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{GV: true});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{G8: true});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{D3: true});
											default:
												return _Utils_update(
													groupDiscountRule,
													{F8: true});
										}
									},
									form.PW);
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 12:
							var index = formField.a;
							var period = formField.b;
							var _v39 = model.PB;
							if (!_v39.$) {
								var form = _v39.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{m6: true});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{si: true});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{sG: true});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{pw: true});
											default:
												return _Utils_update(
													groupDiscountRule,
													{m6: true});
										}
									},
									form.PW);
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						case 10:
							var index = formField.a;
							var period = formField.b;
							var _v41 = _Utils_Tuple2(model.PB, model.k);
							if ((!_v41.a.$) && (_v41.b.$ === 3)) {
								var form = _v41.a.a;
								var _v42 = _v41.b;
								var plan = _v42.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{T9: $elm$core$Maybe$Nothing, Ua: false, F8: false});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{Xy: $elm$core$Maybe$Nothing, Xz: false, GV: false});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{Zl: $elm$core$Maybe$Nothing, Zm: false, G8: false});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{I7: $elm$core$Maybe$Nothing, I8: false, D3: false});
											default:
												return groupDiscountRule;
										}
									},
									form.PW);
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								var calculateOpts = {ZP: true, aaM: false};
								return function (_v43) {
									var newModel = _v43.a;
									var cmd = _v43.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
						default:
							var index = formField.a;
							var period = formField.b;
							var _v45 = _Utils_Tuple2(model.PB, model.k);
							if ((!_v45.a.$) && (_v45.b.$ === 3)) {
								var form = _v45.a.a;
								var _v46 = _v45.b;
								var plan = _v46.a;
								var updatedGroupDiscountRules = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (groupDiscountRule) {
										switch (period) {
											case 'month':
												return _Utils_update(
													groupDiscountRule,
													{Ug: $elm$core$Maybe$Nothing, Uh: false, m6: false});
											case 'quarter':
												return _Utils_update(
													groupDiscountRule,
													{XE: $elm$core$Maybe$Nothing, XF: false, si: false});
											case 'semi_annual':
												return _Utils_update(
													groupDiscountRule,
													{Zr: $elm$core$Maybe$Nothing, Zs: false, sG: false});
											case 'annual':
												return _Utils_update(
													groupDiscountRule,
													{Jd: $elm$core$Maybe$Nothing, Je: false, pw: false});
											default:
												return groupDiscountRule;
										}
									},
									form.PW);
								var newForm = _Utils_update(
									form,
									{PW: updatedGroupDiscountRules, o: false});
								var calculateOpts = {ZP: true, aaM: false};
								return function (_v47) {
									var newModel = _v47.a;
									var cmd = _v47.b;
									return _Utils_Tuple3(newModel, cmd, _List_Nil);
								}(
									A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
							} else {
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							}
					}
				case 4:
					var planFormMsg = msg.a;
					var _v49 = _Utils_Tuple2(model.PB, model.k);
					if ((!_v49.a.$) && (_v49.b.$ === 3)) {
						var form = _v49.a.a;
						var _v50 = _v49.b;
						var plan = _v50.a;
						var newBasicPlanResult = A4(
							$author$project$Components$Plan$BasicForm$update,
							apiClient,
							planFormMsg,
							form.aA,
							$elm$core$Maybe$Just(plan));
						var _v51 = function () {
							var _v52 = newBasicPlanResult.ac5;
							if (_v52.$ === 1) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(
												_Utils_update(
													form,
													{aA: newBasicPlanResult.y8}))
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								var field = _v52.a;
								var newForm = _Utils_update(
									form,
									{aA: newBasicPlanResult.y8});
								if (field.$ === 3) {
									var defaultPeriod = field.a;
									var sharedFields = A2(
										$author$project$Components$PricingVersions$Form$initSharedFields,
										$elm$core$Maybe$Just(plan),
										newForm);
									var defaultPeriodString = defaultPeriod ? 'annual' : 'month';
									var familyMembershipPricingResult = A3(
										$author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod,
										defaultPeriodString,
										$elm$core$Maybe$Just(plan),
										form.cU);
									var groupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, form.i);
									var individualMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, form.cX);
									var finalForm = _Utils_update(
										newForm,
										{cU: familyMembershipPricingResult.y8, i: groupTierPricingResult.y8, cX: individualMembershipPricingResult.y8});
									var newFormFields = $author$project$Components$PricingVersions$Form$formFields(finalForm);
									var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{
												PB: $elm$core$Maybe$Just(finalForm)
											}),
										cmd);
								} else {
									var calculateOpts = $author$project$Components$Plan$BasicForm$calculateOpts(field);
									return calculateOpts.ZP ? A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts) : _Utils_Tuple2(
										_Utils_update(
											model,
											{
												PB: $elm$core$Maybe$Just(newForm)
											}),
										$elm$core$Platform$Cmd$none);
								}
							}
						}();
						var newModel = _v51.a;
						var formCmd = _v51.b;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										formCmd,
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, newBasicPlanResult.EC)
									])),
							newBasicPlanResult.as);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 8:
					var planFormMsg = msg.a;
					var _v54 = _Utils_Tuple2(model.PB, model.k);
					if ((!_v54.a.$) && (_v54.b.$ === 3)) {
						var form = _v54.a.a;
						var _v55 = _v54.b;
						var plan = _v55.a;
						var specialRatesForm = function () {
							var _v58 = form.de;
							if (!_v58.$) {
								var existingForm = _v58.a;
								return existingForm;
							} else {
								var maybePricingVersion = function () {
									var _v59 = model.nH;
									if (_v59.$ === 3) {
										var pricingVersion = _v59.a;
										return $elm$core$Maybe$Just(pricingVersion);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								return A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, $elm$core$Maybe$Nothing, plan, maybePricingVersion);
							}
						}();
						var sharedFields = A2(
							$author$project$Components$PricingVersions$Form$initSharedFields,
							$elm$core$Maybe$Just(plan),
							form);
						var newSpecialRatesResult = A3($author$project$Components$Plan$Form$SpecialRatesFields$update, sharedFields, planFormMsg, specialRatesForm);
						var _v56 = function () {
							var _v57 = newSpecialRatesResult.ac5;
							var field = _v57;
							var newForm = _Utils_update(
								form,
								{
									de: $elm$core$Maybe$Just(newSpecialRatesResult.y8)
								});
							return $author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field).ZP ? A4(
								$author$project$Components$PricingVersions$Form$calculate,
								model,
								plan,
								newForm,
								$author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field)) : _Utils_Tuple2(
								_Utils_update(
									model,
									{
										PB: $elm$core$Maybe$Just(newForm)
									}),
								$elm$core$Platform$Cmd$none);
						}();
						var newModel = _v56.a;
						var formCmd = _v56.b;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated, newSpecialRatesResult.EC),
										formCmd
									])),
							newSpecialRatesResult.as);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 5:
					var planFormMsg = msg.a;
					var _v60 = _Utils_Tuple2(model.PB, model.k);
					if ((!_v60.a.$) && (_v60.b.$ === 3)) {
						var form = _v60.a.a;
						var _v61 = _v60.b;
						var plan = _v61.a;
						var sharedFields = A2(
							$author$project$Components$PricingVersions$Form$initSharedFields,
							$elm$core$Maybe$Just(plan),
							form);
						var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, planFormMsg, form.cX);
						var _v62 = function () {
							var _v63 = newMembershipPricingResult.ac5;
							if (!_v63.$) {
								var field = _v63.a;
								var newForm = _Utils_update(
									form,
									{cX: newMembershipPricingResult.y8});
								return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field).ZP ? A4(
									$author$project$Components$PricingVersions$Form$calculate,
									model,
									plan,
									newForm,
									$author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field)) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none);
							} else {
								var newForm = _Utils_update(
									form,
									{cX: newMembershipPricingResult.y8});
								var _v64 = A3(
									$author$project$Components$PricingVersions$Form$update,
									apiClient,
									$author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing,
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}));
								var updatedModel = _v64.a;
								var updatedCmd = _v64.b;
								return _Utils_Tuple2(updatedModel, updatedCmd);
							}
						}();
						var newModel = _v62.a;
						var formCmd = _v62.b;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.EC),
										formCmd
									])),
							newMembershipPricingResult.as);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 6:
					var planFormMsg = msg.a;
					var _v65 = _Utils_Tuple2(model.PB, model.k);
					if ((!_v65.a.$) && (_v65.b.$ === 3)) {
						var form = _v65.a.a;
						var _v66 = _v65.b;
						var plan = _v66.a;
						var newFamilyMembershipPricingResult = A3(
							$author$project$Components$Plan$Form$FamilyMembershipPricingFields$update,
							planFormMsg,
							form.cU,
							$elm$core$Maybe$Just(plan));
						var _v67 = function () {
							var _v68 = newFamilyMembershipPricingResult.ac5;
							if (!_v68.$) {
								var groupPricingType = _v68.a;
								var newForm = _Utils_update(
									form,
									{cU: newFamilyMembershipPricingResult.y8});
								var finalForm = _Utils_update(
									newForm,
									{P_: groupPricingType});
								return A4(
									$author$project$Components$PricingVersions$Form$calculate,
									model,
									plan,
									finalForm,
									{ZP: true, aaM: false});
							} else {
								var field = _v68.a;
								var newForm = _Utils_update(
									form,
									{cU: newFamilyMembershipPricingResult.y8});
								return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field).ZP ? A4(
									$author$project$Components$PricingVersions$Form$calculate,
									model,
									plan,
									newForm,
									$author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field)) : _Utils_Tuple2(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none);
							}
						}();
						var newModel = _v67.a;
						var formCmd = _v67.b;
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.EC),
										formCmd
									])),
							newFamilyMembershipPricingResult.as);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 7:
					var planFormMsg = msg.a;
					var _v69 = model.PB;
					if (!_v69.$) {
						var form = _v69.a;
						var maybePlan = function () {
							var _v76 = model.k;
							if (_v76.$ === 3) {
								var plan = _v76.a;
								return $elm$core$Maybe$Just(plan);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
						var newGroupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$update, sharedFields, planFormMsg, form.i);
						var newForm = _Utils_update(
							form,
							{i: newGroupTierPricingResult.y8});
						var _v70 = newGroupTierPricingResult.ac5;
						if (_v70.$ === 1) {
							var $temp$apiClient = apiClient,
								$temp$msg = $author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing,
								$temp$_v0 = _Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								});
							apiClient = $temp$apiClient;
							msg = $temp$msg;
							_v0 = $temp$_v0;
							continue update;
						} else {
							var field = _v70.a;
							var updatedModel = _Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								});
							var calculateOpts = $author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts(field);
							var shouldActuallyCalculate = function () {
								if (field.$ === 12) {
									var ruleType = field.a;
									var tierFormFields = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(newForm.i);
									switch (ruleType) {
										case 0:
											return !_Utils_eq(tierFormFields.Pv, $elm$core$Maybe$Nothing);
										case 1:
											return !_Utils_eq(tierFormFields.O6, $elm$core$Maybe$Nothing);
										default:
											return !_Utils_eq(tierFormFields.PZ, $elm$core$Maybe$Nothing);
									}
								} else {
									return calculateOpts.ZP;
								}
							}();
							var _v71 = function () {
								if (shouldActuallyCalculate) {
									var _v72 = model.k;
									if (_v72.$ === 3) {
										var plan = _v72.a;
										var updateResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, sharedFields.Nf, newGroupTierPricingResult.y8);
										var calculatedForm = _Utils_update(
											newForm,
											{i: updateResult.y8});
										var _v73 = A4($author$project$Components$PricingVersions$Form$calculate, updatedModel, plan, calculatedForm, calculateOpts);
										var calcModel = _v73.a;
										var calcCmd = _v73.b;
										return _Utils_Tuple2(
											calcModel,
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.EC),
														A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, updateResult.EC),
														calcCmd
													])));
									} else {
										return _Utils_Tuple2(
											updatedModel,
											A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.EC));
									}
								} else {
									return _Utils_Tuple2(
										updatedModel,
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.EC));
								}
							}();
							var calculatedModel = _v71.a;
							var calculatedCmd = _v71.b;
							return _Utils_Tuple3(calculatedModel, calculatedCmd, newGroupTierPricingResult.as);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 10:
					var _v77 = _Utils_Tuple2(model.PB, model.k);
					if ((!_v77.a.$) && (_v77.b.$ === 3)) {
						var form = _v77.a.a;
						var _v78 = _v77.b;
						var plan = _v78.a;
						var newGroupPricingType = (form.P_ === 'fixed_pricing') ? 'family' : 'fixed_pricing';
						var newForm = _Utils_update(
							form,
							{P_: newGroupPricingType});
						var calculateOpts = {ZP: true, aaM: false};
						return function (_v79) {
							var newModel = _v79.a;
							var cmd = _v79.b;
							return _Utils_Tuple3(newModel, cmd, _List_Nil);
						}(
							A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 11:
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Components$PricingVersions$Form$planRoute(model.JT)),
						_List_Nil);
				case 12:
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 2, 'dummy delete')
							]));
				case 13:
					var _v80 = _Utils_Tuple2(model.PB, model.k);
					if ((!_v80.a.$) && (_v80.b.$ === 3)) {
						var form = _v80.a.a;
						var _v81 = _v80.b;
						var plan = _v81.a;
						var validatedForm = A3(
							$author$project$Components$PricingVersions$Form$validateFormFields,
							$elm$core$Maybe$Just(plan),
							model.WF,
							form);
						var specialRatesHasErrors = function () {
							var _v83 = validatedForm.de;
							if (!_v83.$) {
								var specialRatesForm = _v83.a;
								return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
							} else {
								return false;
							}
						}();
						var newForm = _Utils_update(
							validatedForm,
							{aI: true, o: true});
						var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(validatedForm.zh);
						var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(validatedForm.cX);
						var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(validatedForm.i);
						var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(validatedForm.cU);
						var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, true, validatedForm.Od);
						var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(validatedForm.aA);
						var hasErrors = (!($elm$core$List$isEmpty(nameErrors) && $elm$core$List$isEmpty(effectiveDateErrors))) || (basicPlanHasErrors || (individualPricingHasErrors || (familyPricingHasErrors || (groupTierPricingHasErrors || specialRatesHasErrors))));
						if (hasErrors) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										PB: $elm$core$Maybe$Just(newForm),
										gO: true
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							var pricingVersionName = newForm.zh;
							var planUpdateFields = function () {
								var isCreate = _Utils_eq(model.afY, $elm$core$Maybe$Nothing);
								var fields = $author$project$Components$PricingVersions$Form$updatePlanFieldsForSave(
									$author$project$Components$PricingVersions$Form$formFields(newForm));
								return isCreate ? _Utils_update(
									fields,
									{
										_o: A2(
											$elm$core$List$map,
											function (sr) {
												return _Utils_update(
													sr,
													{Me: true, NB: false, adR: $elm$core$Maybe$Nothing});
											},
											A2(
												$elm$core$List$filter,
												function (sr) {
													return !sr.NB;
												},
												fields._o))
									}) : fields;
							}();
							var planId = $author$project$Api$Provider$Plan$One$id(plan);
							var effectiveDateString = A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, newForm.Od));
							var currentBasicPlanFields = $author$project$Components$Plan$BasicForm$formFields(newForm.aA);
							var editedRegistrationFeeCategoryId = $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(currentBasicPlanFields.c9);
							var editedRegistrationFeeDescription = currentBasicPlanFields.Bp;
							var editedRegistrationFeeName = currentBasicPlanFields.Bq;
							var createFields = {Jj: newForm.Jj, xg: newForm.xg, Od: effectiveDateString, PX: newForm.PX, P_: newForm.P_, zh: pricingVersionName, Wn: planUpdateFields, Bo: editedRegistrationFeeCategoryId, Bp: editedRegistrationFeeDescription, Bq: editedRegistrationFeeName};
							var saveCmd = function () {
								var _v82 = model.afY;
								if (!_v82.$) {
									var pvId = _v82.a;
									return A5($author$project$Api$Provider$PricingVersion$update, apiClient, planId, pvId, createFields, $author$project$Components$PricingVersions$Form$PricingVersionUpdated);
								} else {
									return A4($author$project$Api$Provider$PricingVersion$create, apiClient, planId, createFields, $author$project$Components$PricingVersions$Form$PricingVersionCreated);
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										PB: $elm$core$Maybe$Just(newForm),
										gO: false
									}),
								saveCmd,
								_List_Nil);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 14:
					var response = msg.a;
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								model,
								A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Components$PricingVersions$Form$planRoute(model.JT)),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Price change created successfully')
									]));
						case 2:
							var error = response.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										1,
										$author$project$Ui$Toast$serverError(error))
									]));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 15:
					var response = msg.a;
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								model,
								A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Components$PricingVersions$Form$planRoute(model.JT)),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Price change updated successfully')
									]));
						case 2:
							var error = response.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										1,
										$author$project$Ui$Toast$serverError(error))
									]));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 16:
					var subMsg = msg.a;
					var _v86 = A4(
						$jinjor$elm_debounce$Debounce$update,
						$author$project$Components$PricingVersions$Form$previewDebounceConfig,
						$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$PricingVersions$Form$debounceCalculate),
						subMsg,
						model.em);
					var newDebouncer = _v86.a;
					var debouncerCmd = _v86.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{em: newDebouncer}),
						debouncerCmd,
						_List_Nil);
				case 17:
					var pricingFormFields = msg.a;
					var _v87 = model.k;
					if (_v87.$ === 3) {
						var previousPreviewId = model.afU.a;
						var previewId = previousPreviewId + 1;
						var tracker = 'pricing_version_preview_' + $elm$core$String$fromInt(previewId);
						var planUpdateFields = $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate(pricingFormFields);
						var calculateCmd = function () {
							var _v88 = model.afY;
							if (!_v88.$) {
								var pvId = _v88.a;
								var effectiveDateString = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, pricingFormFields.Od));
								var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(pricingFormFields.aA);
								var createFields = {
									Jj: pricingFormFields.Jj,
									xg: pricingFormFields.xg,
									Od: effectiveDateString,
									PX: pricingFormFields.PX,
									P_: pricingFormFields.P_,
									zh: pricingFormFields.zh,
									Wn: planUpdateFields,
									Bo: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(basicPlanFormFields.c9),
									Bp: basicPlanFormFields.Bp,
									Bq: basicPlanFormFields.Bq
								};
								return A7(
									$author$project$Api$Provider$PricingVersion$calculate,
									apiClient,
									model.JT,
									pvId,
									_List_fromArray(
										[1]),
									tracker,
									createFields,
									$author$project$Components$PricingVersions$Form$GotPreview(previewId));
							} else {
								return A6(
									$author$project$Api$Provider$Plan$calculate,
									apiClient,
									_List_fromArray(
										[1]),
									tracker,
									model.JT,
									planUpdateFields,
									$author$project$Components$PricingVersions$Form$GotPreview(previewId));
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									afU: _Utils_Tuple2(previewId, $author$project$Api$Data$Loading)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										calculateCmd,
										$elm$http$Http$cancel(
										'pricing_version_preview_' + $elm$core$String$fromInt(previousPreviewId))
									])),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				default:
					var previewId = msg.a;
					var response = msg.b;
					if (_Utils_eq(model.afU.a, previewId)) {
						switch (response.$) {
							case 3:
								var calculatedPlan = response.a;
								var maybePricingVersion = function () {
									var _v93 = model.nH;
									if (_v93.$ === 3) {
										var pv = _v93.a;
										return $elm$core$Maybe$Just(pv);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								var currentSpecialRatesForm = A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.de;
									},
									model.PB);
								var _v90 = A6($author$project$Components$PricingVersions$Form$initFormFieldsWithSpecialRates, apiClient, model.ZD, model.WF, calculatedPlan, maybePricingVersion, currentSpecialRatesForm);
								var calculatedForm = _v90.a;
								var calculatedFormCmd = _v90.b;
								var newForm = function () {
									var _v91 = model.PB;
									if (!_v91.$) {
										var existingForm = _v91.a;
										return _Utils_update(
											calculatedForm,
											{
												aA: existingForm.aA,
												xg: existingForm.xg,
												Od: existingForm.Od,
												aI: existingForm.aI,
												PW: A3(
													$elm$core$List$map2,
													F2(
														function (calculated, existing) {
															var isPercentValid = function (maybePercent) {
																if (!maybePercent.$) {
																	var percent = maybePercent.a;
																	return A2(
																		$author$project$Percentage$isValid,
																		{
																			yQ: $elm$core$Maybe$Just(100),
																			TZ: $elm$core$Maybe$Just(0)
																		},
																		percent);
																} else {
																	return true;
																}
															};
															return _Utils_update(
																calculated,
																{
																	I8: existing.I8,
																	D3: false,
																	Jd: (existing.Je && (!isPercentValid(existing.Jd))) ? existing.Jd : calculated.Jd,
																	Je: existing.Je,
																	pw: false,
																	Ua: existing.Ua,
																	F8: false,
																	Ug: (existing.Uh && (!isPercentValid(existing.Ug))) ? existing.Ug : calculated.Ug,
																	Uh: existing.Uh,
																	m6: false,
																	Xz: existing.Xz,
																	GV: false,
																	XE: (existing.XF && (!isPercentValid(existing.XE))) ? existing.XE : calculated.XE,
																	XF: existing.XF,
																	si: false,
																	Zm: existing.Zm,
																	G8: false,
																	Zr: (existing.Zs && (!isPercentValid(existing.Zr))) ? existing.Zr : calculated.Zr,
																	Zs: existing.Zs,
																	sG: false
																});
														}),
													calculatedForm.PW,
													existingForm.PW),
												zh: existingForm.zh,
												o: existingForm.o
											});
									} else {
										return calculatedForm;
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm),
											afU: _Utils_Tuple2(previewId, response)
										}),
									calculatedFormCmd,
									_List_Nil);
							case 2:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											afU: _Utils_Tuple2(previewId, response)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 1:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											afU: _Utils_Tuple2(previewId, response)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							default:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											afU: _Utils_Tuple2(previewId, response)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
			}
		}
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PricingVersions$Form$update, model.D5, subMsg, model.PB);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$PricingVersions$Form$Delete = {$: 12};
var $author$project$Components$PricingVersions$Form$NavigateBack = {$: 11};
var $author$project$Components$PricingVersions$Form$Save = {$: 13};
var $author$project$Ui$Button$Close = {$: 12};
var $author$project$Ui$Button$close = $author$project$Ui$Button$Close;
var $author$project$Components$PricingVersions$Form$hasAnyValidationErrors = F3(
	function (_v0, _v1, form) {
		var specialRatesHasErrors = function () {
			var _v2 = form.de;
			if (!_v2.$) {
				var specialRatesForm = _v2.a;
				return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
			} else {
				return false;
			}
		}();
		var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.zh);
		var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(form.cX);
		var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(form.i);
		var groupDiscountRulesHaveErrors = false;
		var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(form.cU);
		var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, form.aI, form.Od);
		var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(form.aA);
		return (!($elm$core$List$isEmpty(nameErrors) && $elm$core$List$isEmpty(effectiveDateErrors))) || (basicPlanHasErrors || (individualPricingHasErrors || (familyPricingHasErrors || (groupTierPricingHasErrors || (specialRatesHasErrors || groupDiscountRulesHaveErrors)))));
	});
var $author$project$Components$PricingVersions$Form$NameChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$BasicForm$hasRegistrationFeeNameError = function (_v0) {
	var form = _v0.b;
	return A2($author$project$Utils$Form$hasValidationErrors, 8, form);
};
var $author$project$Components$Plan$BasicForm$registrationFeeNameErrors = function (_v0) {
	var form = _v0.b;
	return A2($author$project$Utils$Form$validationErrors, 8, form);
};
var $author$project$Components$PricingVersions$Form$viewBasicPlanFieldsForPricingVersion = F2(
	function (basicPlan, _v0) {
		var fields = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		return _List_fromArray(
			[
				A4(
				$author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields,
				{
					KM: fields.sl,
					iy: fields.iy,
					lY: fields.lY,
					adG: $author$project$Components$Plan$BasicForm$hasRegistrationFeeNameError(basicPlan),
					ae6: $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory,
					ae7: $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription,
					afj: $author$project$Components$Plan$BasicForm$RegistrationFeeDescription,
					afk: $author$project$Components$Plan$BasicForm$RegistrationFeeName,
					Bp: fields.Bp,
					Bq: fields.Bq,
					agd: $author$project$Components$Plan$BasicForm$registrationFeeNameErrors(basicPlan)
				},
				$author$project$Components$Plan$BasicForm$FormUpdated,
				$author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg,
				fields.c9)
			]);
	});
var $author$project$Components$PricingVersions$Form$DiscountsEnabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingVersions$Form$FormUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle = function (form) {
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Do you offer discounts to family members who enroll together?'),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(form.xg),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$PricingVersions$Form$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$PricingVersions$Form$DiscountsEnabled(true))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Yes')
											]))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(!form.xg),
										$author$project$Ui$Form$Radio$inline,
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$PricingVersions$Form$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$PricingVersions$Form$DiscountsEnabled(false))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('No')
											]))
									]))
							]))
					])),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Components$PricingVersions$Form$viewFamilyMembershipPricing = F3(
	function (sharedFields, plan, form) {
		var discountsEnabled = form.xg;
		return A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle(form),
					function () {
					if (discountsEnabled) {
						var familyMembershipPricingForm = form.cU;
						return A2(
							$elm$html$Html$map,
							$author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated,
							A3(
								$author$project$Components$Plan$Form$FamilyMembershipPricingFields$view,
								sharedFields,
								$elm$core$Maybe$Just(plan),
								familyMembershipPricingForm));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAdd = {$: 4};
var $author$project$Components$PricingVersions$Form$GroupPricingType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleFromSize = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleRemove = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleToSize = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions = function (start) {
	return A2(
		$elm$core$List$map,
		function (size) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(size)),
				A2($author$project$Formatters$String$pluralize, 'Member', size));
		},
		A2($elm$core$List$range, start, 9));
};
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCents = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsEdit = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsReset = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$validateGroupDiscountRuleAmountOffInCents = F3(
	function (index, period, form) {
		var groupDiscountRule = A2($elm_community$list_extra$List$Extra$getAt, index, form.PW);
		var defaultPeriod = function () {
			var basicFields = $author$project$Components$Plan$BasicForm$formFields(form.aA);
			return (basicFields.Nf === 'annual') ? 'annual' : 'month';
		}();
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(groupDiscountRule, period);
			_v1$4:
			while (true) {
				if (!_v1.a.$) {
					switch (_v1.b) {
						case 'month':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.T9, rule.Ua);
						case 'quarter':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.Xy, rule.Xz);
						case 'semi_annual':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.Zl, rule.Zm);
						case 'annual':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.I7, rule.I8);
						default:
							break _v1$4;
					}
				} else {
					break _v1$4;
				}
			}
			return _Utils_Tuple2($elm$core$Maybe$Nothing, false);
		}();
		var periodAmount = _v0.a;
		var periodEdited = _v0.b;
		if (_Utils_eq(defaultPeriod, period) || periodEdited) {
			if (periodAmount.$ === 1) {
				return _List_fromArray(
					['Please enter an amount.']);
			} else {
				var amount = periodAmount.a;
				var min = 0;
				var max = 999999999;
				var amountInt = A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Currency$toInt(amount));
				return ((_Utils_cmp(amountInt, min) < 0) || (_Utils_cmp(amountInt, max) > 0)) ? _List_fromArray(
					[
						'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.')))
					]) : _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$PricingVersions$Form$validateGroupDiscountRulePercentOff = F3(
	function (index, period, form) {
		var groupDiscountRule = A2($elm_community$list_extra$List$Extra$getAt, index, form.PW);
		var defaultPeriod = function () {
			var basicFields = $author$project$Components$Plan$BasicForm$formFields(form.aA);
			return (basicFields.Nf === 'annual') ? 'annual' : 'month';
		}();
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(groupDiscountRule, period);
			_v1$4:
			while (true) {
				if (!_v1.a.$) {
					switch (_v1.b) {
						case 'month':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.Ug, rule.Uh);
						case 'quarter':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.XE, rule.XF);
						case 'semi_annual':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.Zr, rule.Zs);
						case 'annual':
							var rule = _v1.a.a;
							return _Utils_Tuple2(rule.Jd, rule.Je);
						default:
							break _v1$4;
					}
				} else {
					break _v1$4;
				}
			}
			return _Utils_Tuple2($elm$core$Maybe$Nothing, false);
		}();
		var periodPercent = _v0.a;
		var periodEdited = _v0.b;
		if (_Utils_eq(defaultPeriod, period) || periodEdited) {
			if (periodPercent.$ === 1) {
				return _List_fromArray(
					['Please enter a percentage.']);
			} else {
				var percent = periodPercent.a;
				var min = 0;
				var max = 100;
				return (!A2(
					$author$project$Percentage$isValid,
					{
						yQ: $elm$core$Maybe$Just(max),
						TZ: $elm$core$Maybe$Just(min)
					},
					percent)) ? _List_fromArray(
					[
						'Please enter a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.')))
					]) : _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$PricingVersions$Form$validationErrors = F2(
	function (validationGroup, form) {
		if (!validationGroup.$) {
			var index = validationGroup.a;
			var period = validationGroup.b;
			return form.o ? A3($author$project$Components$PricingVersions$Form$validateGroupDiscountRuleAmountOffInCents, index, period, form) : _List_Nil;
		} else {
			var index = validationGroup.a;
			var period = validationGroup.b;
			return form.o ? A3($author$project$Components$PricingVersions$Form$validateGroupDiscountRulePercentOff, index, period, form) : _List_Nil;
		}
	});
var $author$project$Components$PricingVersions$Form$hasValidationErrors = F2(
	function (validationGroup, form) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$PricingVersions$Form$validationErrors, validationGroup, form));
	});
var $author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRulePeriodForPricingVersions = F5(
	function (_v0, form, index, groupDiscountRule, period) {
		var _v1 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(groupDiscountRule.T9, groupDiscountRule.F8, groupDiscountRule.Ua);
				case 'quarter':
					return _Utils_Tuple3(groupDiscountRule.Xy, groupDiscountRule.GV, groupDiscountRule.Xz);
				case 'semi_annual':
					return _Utils_Tuple3(groupDiscountRule.Zl, groupDiscountRule.G8, groupDiscountRule.Zm);
				case 'annual':
					return _Utils_Tuple3(groupDiscountRule.I7, groupDiscountRule.D3, groupDiscountRule.I8);
				default:
					return _Utils_Tuple3(groupDiscountRule.T9, groupDiscountRule.F8, groupDiscountRule.Ua);
			}
		}();
		var periodAmountInCents = _v1.a;
		var editingPeriod = _v1.b;
		var periodEdited = _v1.c;
		var _v3 = $author$project$Components$Plan$BasicForm$formFields(form.aA);
		var defaultPeriod = _v3.Nf;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							$elm$html$Html$text(' discount')
						])),
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$PricingVersions$Form$FormUpdated,
								A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCents, index, period))),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Components$PricingVersions$Form$hasValidationErrors,
								A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation, index, period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Components$PricingVersions$Form$validationErrors,
						A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation, index, period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(12)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									function () {
										if (!periodAmountInCents.$) {
											var amount = periodAmountInCents.a;
											return $author$project$Currency$format(amount);
										} else {
											return '$0.00';
										}
									}()),
									$elm$html$Html$text(' off'),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit period amount off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick(
											$author$project$Components$PricingVersions$Form$FormUpdated(
												A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsEdit, index, period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									periodEdited ? A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$pull(1)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Reset period amount off'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Components$PricingVersions$Form$FormUpdated(
														A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsReset, index, period)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset')
												])),
											$author$project$Utils$Html$noBreakSpace
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRuleForPricingVersions = F5(
	function (plan, form, periods, index, groupDiscountRule) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRulePeriodForPricingVersions, plan, form, index, groupDiscountRule),
			periods);
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOff = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffEdit = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffReset = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$PricingVersions$Form$viewPercentOffPricingRulePeriodForPricingVersions = F5(
	function (_v0, form, index, groupDiscountRule, period) {
		var _v1 = function () {
			switch (period) {
				case 'month':
					return _Utils_Tuple3(groupDiscountRule.Ug, groupDiscountRule.m6, groupDiscountRule.Uh);
				case 'quarter':
					return _Utils_Tuple3(groupDiscountRule.XE, groupDiscountRule.si, groupDiscountRule.XF);
				case 'semi_annual':
					return _Utils_Tuple3(groupDiscountRule.Zr, groupDiscountRule.sG, groupDiscountRule.Zs);
				case 'annual':
					return _Utils_Tuple3(groupDiscountRule.Jd, groupDiscountRule.pw, groupDiscountRule.Je);
				default:
					return _Utils_Tuple3(groupDiscountRule.Ug, groupDiscountRule.m6, groupDiscountRule.Uh);
			}
		}();
		var periodPercentOff = _v1.a;
		var editingPeriod = _v1.b;
		var periodEdited = _v1.c;
		var _v3 = $author$project$Components$Plan$BasicForm$formFields(form.aA);
		var defaultPeriod = _v3.Nf;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			(_Utils_eq(defaultPeriod, period) || editingPeriod) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$humanize(period)),
							$elm$html$Html$text(' discount')
						])),
					$author$project$Ui$Form$PercentageInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$PercentageInput$value(periodPercentOff),
							$author$project$Ui$Form$PercentageInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$PricingVersions$Form$FormUpdated,
								A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOff, index, period))),
							$author$project$Ui$Form$PercentageInput$invalid(
							A2(
								$author$project$Components$PricingVersions$Form$hasValidationErrors,
								A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation, index, period),
								form))
						])),
					$author$project$Utils$FormErrors$view(
					A2(
						$author$project$Components$PricingVersions$Form$validationErrors,
						A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation, index, period),
						form))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(12)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(period)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									function () {
										if (!periodPercentOff.$) {
											var percentage = periodPercentOff.a;
											return $author$project$Percentage$format(percentage);
										} else {
											return '0%';
										}
									}()),
									$elm$html$Html$text(' off'),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit period percent off'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick(
											$author$project$Components$PricingVersions$Form$FormUpdated(
												A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffEdit, index, period)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									periodEdited ? A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$pull(1)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Reset period percent off'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Components$PricingVersions$Form$FormUpdated(
														A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffReset, index, period)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset')
												])),
											$author$project$Utils$Html$noBreakSpace
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Components$PricingVersions$Form$viewPercentOffPricingRuleForPricingVersions = F5(
	function (plan, form, periods, index, groupDiscountRule) {
		return A2(
			$elm$core$List$map,
			A4($author$project$Components$PricingVersions$Form$viewPercentOffPricingRulePeriodForPricingVersions, plan, form, index, groupDiscountRule),
			periods);
	});
var $author$project$Components$PricingVersions$Form$viewGroupDiscountRule = F4(
	function (plan, form, index, groupDiscountRule) {
		var isFirst = !index;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					isFirst ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$elm$core$String$fromInt(groupDiscountRule.PJ))),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PricingVersions$Form$FormUpdated,
										$author$project$Components$PricingVersions$Form$GroupDiscountRuleFromSize(index)))
								]),
							$author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions(0))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(groupDiscountRule.PJ))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					(!_Utils_eq(groupDiscountRule.$K, $elm$core$Maybe$Nothing)) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, groupDiscountRule.$K)),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PricingVersions$Form$FormUpdated,
										$author$project$Components$PricingVersions$Form$GroupDiscountRuleToSize(index)))
								]),
							$author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions(groupDiscountRule.PJ))
						]) : _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('All Members')
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_Nil),
							(!isFirst) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Remove group disount rule'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$PricingVersions$Form$FormUpdated(
										$author$project$Components$PricingVersions$Form$GroupDiscountRuleRemove(index))),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v0 = groupDiscountRule.Km;
						switch (_v0) {
							case 'amount_off_in_cents':
								return A5(
									$author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRuleForPricingVersions,
									plan,
									form,
									$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(
										$author$project$Api$Provider$Plan$One$meta(plan)),
									index,
									groupDiscountRule);
							case 'percent_off':
								return A5(
									$author$project$Components$PricingVersions$Form$viewPercentOffPricingRuleForPricingVersions,
									plan,
									form,
									$author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(
										$author$project$Api$Provider$Plan$One$meta(plan)),
									index,
									groupDiscountRule);
							default:
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('Not set')
											]))
									]);
						}
					}())
				]));
	});
var $author$project$Components$PricingVersions$Form$viewGroupMembershipPricingFields = F2(
	function (plan, form) {
		var discountsEnabled = form.xg;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle(form),
					function () {
					if (discountsEnabled) {
						var groupDiscountRules = form.PW;
						var groupDiscountRulesCalculatedBy = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Km;
							},
							$elm$core$List$head(groupDiscountRules));
						var appliesGroupDiscountInTiers = form.Jj;
						var allowNewGroupRule = A2(
							$elm$core$Maybe$withDefault,
							true,
							A2(
								$elm$core$Maybe$map,
								function (lastFromSize) {
									return _Utils_cmp(lastFromSize, $author$project$Components$PricingVersions$Form$maxGroupFromSize) < 0;
								},
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.PJ;
									},
									$elm_community$list_extra$List$Extra$last(groupDiscountRules))));
						return A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(8)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Switch to family rates'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Components$PricingVersions$Form$FormUpdated(
														$author$project$Components$PricingVersions$Form$GroupPricingType('family')))
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$Icon$view, _List_Nil, 59),
													$elm$html$Html$text(' Switch to Family Rates')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$offset(1)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Radio$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Radio$value(appliesGroupDiscountInTiers),
																	$author$project$Ui$Form$Radio$onCheck(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$PricingVersions$Form$FormUpdated,
																		$elm$core$Basics$always(
																			$author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers(true))))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Apply Discounts in Tiers.'),
																	A2(
																	$author$project$Ui$Typography$div,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Per member discount will apply to members depending on which range they are in')
																		]))
																]))
														])),
													A2(
													$author$project$Ui$Typography$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Form$Radio$view,
															_List_fromArray(
																[
																	$author$project$Ui$Form$Radio$value(!appliesGroupDiscountInTiers),
																	$author$project$Ui$Form$Radio$onCheck(
																	A2(
																		$elm$core$Basics$composeL,
																		$author$project$Components$PricingVersions$Form$FormUpdated,
																		$elm$core$Basics$always(
																			$author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers(false))))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Apply Same Discount to Entire Group'),
																	A2(
																	$author$project$Ui$Typography$div,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Per member discount from the last added member will apply to all members in group')
																		]))
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$offsetLabel,
											$author$project$Ui$Form$Group$labelSpanSm(5),
											$author$project$Ui$Form$Group$inputSpanSm(6),
											$author$project$Ui$Form$Group$label('Default Discount Type'),
											$author$project$Ui$Form$Group$labelClass('')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Select percentage base discount calculation'},
													_List_fromArray(
														[
															$author$project$Ui$Button$active(
															_Utils_eq(
																groupDiscountRulesCalculatedBy,
																$elm$core$Maybe$Just('percent_off'))),
															$author$project$Ui$Button$onClick(
															$author$project$Components$PricingVersions$Form$FormUpdated(
																$author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy(true)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('%')
														])),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Select fixed discount rate'},
													_List_fromArray(
														[
															$author$project$Ui$Button$active(
															!_Utils_eq(
																groupDiscountRulesCalculatedBy,
																$elm$core$Maybe$Just('percent_off'))),
															$author$project$Ui$Button$onClick(
															$author$project$Components$PricingVersions$Form$FormUpdated(
																$author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy(false)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('$')
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanSm(11),
													$author$project$Ui$FlexGrid$offsetSm(1)
												]),
											_List_fromArray(
												[
													A4(
													$author$project$Ui$Table$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(3)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('From')
																])),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(3)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('To')
																])),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(2)
																]),
															_List_Nil),
															A2(
															$author$project$Ui$Table$header,
															_List_fromArray(
																[
																	$author$project$Ui$Table$cellSpan(4)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Discount per Member')
																]))
														]),
													A2(
														$elm$core$List$indexedMap,
														A2($author$project$Components$PricingVersions$Form$viewGroupDiscountRule, plan, form),
														groupDiscountRules),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Table$row,
															_List_Nil,
															_List_fromArray(
																[
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
																	A2(
																	$author$project$Ui$Table$cell,
																	_List_Nil,
																	_List_fromArray(
																		[
																			allowNewGroupRule ? A3(
																			$author$project$Ui$Button$view,
																			{abp: 'Add group range discount rule'},
																			_List_fromArray(
																				[
																					$author$project$Ui$Button$onClick(
																					$author$project$Components$PricingVersions$Form$FormUpdated($author$project$Components$PricingVersions$Form$GroupDiscountRuleAdd)),
																					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Add Range')
																				])) : $author$project$Utils$Html$empty
																		]))
																]))
														]))
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$PricingVersions$Form$viewForm = F3(
	function (model, _v0, form) {
		var nameErrors = model.gO ? $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.zh) : _List_Nil;
		var maybePlan = function () {
			var _v9 = model.k;
			if (_v9.$ === 3) {
				var plan = _v9.a;
				return $elm$core$Maybe$Just(plan);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
		var pricingFields = _List_fromArray(
			[
				(sharedFields.P_ === 'fixed_pricing') ? A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$elm$html$Html$map,
						$author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated,
						A3(
							$author$project$Components$Plan$Form$GroupTierPricingFields$view,
							sharedFields,
							function () {
								var _v3 = model.k;
								if (_v3.$ === 3) {
									var plan = _v3.a;
									return $elm$core$Maybe$Just(plan);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}(),
							form.i))
					])) : A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$elm$html$Html$map,
						$author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated,
						A4(
							$author$project$Components$Plan$Form$IndividualMembershipPricingFields$view,
							sharedFields,
							model.WF,
							function () {
								var _v4 = model.k;
								if (_v4.$ === 3) {
									var plan = _v4.a;
									return $elm$core$Maybe$Just(plan);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}(),
							form.cX))
					])),
				(sharedFields.P_ === 'family') ? A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						function () {
						var _v5 = model.k;
						if (_v5.$ === 3) {
							var plan = _v5.a;
							return A3($author$project$Components$PricingVersions$Form$viewFamilyMembershipPricing, sharedFields, plan, form);
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])) : $author$project$Utils$Html$empty,
				(sharedFields.P_ === 'group') ? A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						function () {
						var _v6 = model.k;
						if (_v6.$ === 3) {
							var plan = _v6.a;
							return A2($author$project$Components$PricingVersions$Form$viewGroupMembershipPricingFields, plan, form);
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v7 = _Utils_Tuple2(form.de, model.k);
				if ((!_v7.a.$) && (_v7.b.$ === 3)) {
					var specialRatesForm = _v7.a.a;
					var _v8 = _v7.b;
					var plan = _v8.a;
					return A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$map,
								$author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated,
								A2($author$project$Components$Plan$Form$SpecialRatesFields$view, plan, specialRatesForm))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
		var effectiveDateErrors = model.gO ? A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, true, form.Od) : _List_Nil;
		var basicPlanFields = A2(
			$elm$core$List$map,
			$elm$html$Html$map($author$project$Components$PricingVersions$Form$BasicPlanFormUpdated),
			A2(
				$author$project$Components$PricingVersions$Form$viewBasicPlanFieldsForPricingVersion,
				form.aA,
				function () {
					var _v2 = model.k;
					if (_v2.$ === 3) {
						var plan = _v2.a;
						return $elm$core$Maybe$Just(plan);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}()));
		var basicFields = _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$labelHtml(
						_List_fromArray(
							[
								$elm$html$Html$text('Name of Pricing Version '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-danger')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									]))
							])),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$labelHelp(
						$elm$html$Html$text('This will not be displayed to patients.'))
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(form.zh),
								$author$project$Ui$Form$Input$onInput($author$project$Components$PricingVersions$Form$NameChanged),
								$author$project$Ui$Form$Input$placeholder(
								function () {
									var _v1 = model.cO;
									if (!_v1.$) {
										var currentDate = _v1.a;
										return $elm$core$String$fromInt(
											$justinmimbs$date$Date$year(currentDate) + 1) + ' Pricing';
									} else {
										return '2025 Pricing';
									}
								}()),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(nameErrors)),
								$author$project$Ui$Form$Input$errors(nameErrors)
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(5),
						$author$project$Ui$Form$Group$inputSpanSm(6),
						$author$project$Ui$Form$Group$labelHtml(
						_List_fromArray(
							[
								$elm$html$Html$text('Effective Date '),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-danger')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									]))
							])),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$labelHelp(
						$elm$html$Html$text('The day your new pricing will start to go into effect.'))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$PricingVersions$Form$EffectiveDateInputMsg,
						A2(
							$author$project$Components$DateInput$view,
							_List_fromArray(
								[
									$author$project$Components$DateInput$value(form.Od),
									$author$project$Components$DateInput$invalid(
									!$elm$core$List$isEmpty(effectiveDateErrors)),
									$author$project$Components$DateInput$errors(effectiveDateErrors)
								]),
							model.iz))
					]))
			]);
		return $elm$core$List$concat(
			_List_fromArray(
				[basicFields, basicPlanFields, pricingFields]));
	});
var $author$project$Components$PricingVersions$Form$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$horizontal,
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$onSubmit($author$project$Components$PricingVersions$Form$Save)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$titleWithButton,
									_List_fromArray(
										[
											$elm$html$Html$text('Schedule Pricing Change')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Close'},
											_List_fromArray(
												[
													$author$project$Ui$Button$close,
													$author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$NavigateBack)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('×')
												]))
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							function () {
								var _v1 = _Utils_Tuple3(model.FU, model.k, model.PB);
								_v1$2:
								while (true) {
									_v1$4:
									while (true) {
										switch (_v1.b.$) {
											case 3:
												switch (_v1.a.$) {
													case 3:
														if (!_v1.c.$) {
															var _v2 = _v1.a;
															var pricingVersion = _v2.a;
															var _v3 = _v1.b;
															var form = _v1.c.a;
															return A3($author$project$Components$PricingVersions$Form$viewForm, model, pricingVersion, form);
														} else {
															break _v1$4;
														}
													case 0:
														if (!_v1.c.$) {
															var _v4 = _v1.a;
															var _v5 = _v1.b;
															var form = _v1.c.a;
															return A3(
																$author$project$Components$PricingVersions$Form$viewForm,
																model,
																{adR: '', zh: form.zh},
																form);
														} else {
															break _v1$4;
														}
													case 2:
														break _v1$2;
													default:
														break _v1$4;
												}
											case 2:
												if (_v1.a.$ === 2) {
													break _v1$2;
												} else {
													return _List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[
																	$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Error loading base plan')
																]))
														]);
												}
											default:
												if (_v1.a.$ === 2) {
													break _v1$2;
												} else {
													break _v1$4;
												}
										}
									}
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]))
										]);
								}
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Error loading pricing version')
											]))
									]);
							}()),
							A2(
							$author$project$Ui$Panel$footer,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol]),
							function () {
								var _v6 = _Utils_Tuple3(model.FU, model.k, model.PB);
								_v6$2:
								while (true) {
									if ((_v6.b.$ === 3) && (!_v6.c.$)) {
										switch (_v6.a.$) {
											case 3:
												var _v7 = _v6.a;
												var _v8 = _v6.b;
												var plan = _v8.a;
												var form = _v6.c.a;
												return _List_fromArray(
													[
														(model.gO && A3(
														$author$project$Components$PricingVersions$Form$hasAnyValidationErrors,
														$elm$core$Maybe$Just(plan),
														model.WF,
														form)) ? A2(
														$author$project$Ui$FlexGrid$row,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$FlexGrid$column,
																_List_fromArray(
																	[
																		$author$project$Ui$FlexGrid$offsetSm(3),
																		$author$project$Ui$FlexGrid$spanSm(6)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Alert$danger,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Please review the errors above')
																			]))
																	]))
															])) : $author$project$Utils$Html$empty,
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Link$route,
																$author$project$Components$PricingVersions$Form$planRoute(model.JT),
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Back')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Delete pricing version'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$danger,
																		$author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Delete),
																		$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Delete')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Save pricing version'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$primary,
																		$author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Save)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Save Changes')
																	]))
															]))
													]);
											case 0:
												var _v9 = _v6.a;
												var _v10 = _v6.b;
												var plan = _v10.a;
												var form = _v6.c.a;
												return _List_fromArray(
													[
														(model.gO && A3(
														$author$project$Components$PricingVersions$Form$hasAnyValidationErrors,
														$elm$core$Maybe$Just(plan),
														model.WF,
														form)) ? A2(
														$author$project$Ui$FlexGrid$row,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$FlexGrid$column,
																_List_fromArray(
																	[
																		$author$project$Ui$FlexGrid$offsetSm(3),
																		$author$project$Ui$FlexGrid$spanSm(6)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Alert$danger,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Please review the errors above')
																			]))
																	]))
															])) : $author$project$Utils$Html$empty,
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Link$route,
																$author$project$Components$PricingVersions$Form$planRoute(model.JT),
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Back')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Save Change'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$primary,
																		$author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Save)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Save Change')
																	]))
															]))
													]);
											default:
												break _v6$2;
										}
									} else {
										break _v6$2;
									}
								}
								return _List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Components$PricingVersions$Form$planRoute(model.JT),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Back')
											]))
									]);
							}())
						]))
				]))
		]);
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$PricingVersions$Form$view(model.PB)),
		$G: 'New Pricing Version'
	};
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$init, aer: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$load, agD: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$save, ahd: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$subscriptions, aaq: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$update, ahP: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$view});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$FormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		var settings = {JT: params.adR, F_: $author$project$Spa$Generated$Route$Admin__Plans__Top, WF: practice, ZD: session};
		var _v1 = A4(
			$author$project$Components$PricingVersions$Form$init,
			shared.D5,
			settings,
			params.adR,
			$elm$core$Maybe$Just(params.afY));
		var form = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form, WF: practice, ZD: session, Cd: shared},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{Cd: shared}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PricingVersions$Form$subscriptions(model.PB));
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PricingVersions$Form$update, model.D5, subMsg, model.PB);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$PricingVersions$Form$view(model.PB)),
		$G: 'Edit Pricing Version'
	};
};
var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$init, aer: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$load, agD: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$save, ahd: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$subscriptions, aaq: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$update, ahP: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$view});
var $author$project$Pages$Admin$Plans$New$NewMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Plans$New$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var _v3 = A5($author$project$Components$Admin$Plans$New$init, apiClient, session, 2, $author$project$Spa$Generated$Route$Admin__Plans__Top, $author$project$Spa$Generated$Route$Admin__Plans__Id_String);
		var _new = _v3.a;
		var newCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: _new},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd));
	});
var $author$project$Pages$Admin$Plans$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Plans$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Plans$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$New$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var newCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd),
			outMsgs);
	});
var $author$project$Pages$Admin$Plans$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$New$view(model.PB))
			]),
		$G: 'Admin | Membership Plans'
	};
};
var $author$project$Pages$Admin$Plans$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Plans$New$init, aer: $author$project$Pages$Admin$Plans$New$load, agD: $author$project$Pages$Admin$Plans$New$save, ahd: $author$project$Pages$Admin$Plans$New$subscriptions, aaq: $author$project$Pages$Admin$Plans$New$update, ahP: $author$project$Pages$Admin$Plans$New$view});
var $author$project$Pages$Admin$Plans$Top$ListMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Plans$Top$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var query = _v1.Bi;
		var planTypes = _List_fromArray(
			[2, 3]);
		var _v2 = $author$project$Components$Admin$Plans$List$init(apiClient)(session)(
			$author$project$Api$Platform$User$Shared$isAdmin(
				$author$project$Api$Platform$Session$One$user(session)))(planTypes)($author$project$Spa$Generated$Route$Admin__Plans__Top)($author$project$Spa$Generated$Route$Admin__Plans__New)($author$project$Spa$Generated$Route$Admin__Plans__Id_String)(
			_List_fromArray(
				[
					$elm$html$Html$text('You can change your default plan by editing your default signup page '),
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Admin__SignupPages__Top,
					_List_fromArray(
						[$author$project$Ui$Link$sm]),
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$elm$html$Html$text('.')
				]))(query)(
			{aJ: false})(
			$elm$core$Maybe$Just(practice));
		var list = _v2.a;
		var listCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, rh: list},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
	});
var $author$project$Pages$Admin$Plans$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Plans$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Plans$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Plans$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.D5, subMsg, model.rh);
		var list = _v1.a;
		var listCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: list}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd),
			outMsgs);
	});
var $author$project$Pages$Admin$Plans$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$List$view(model.rh))
			]),
		$G: 'Admin | Membership Plans'
	};
};
var $author$project$Pages$Admin$Plans$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Plans$Top$init, aer: $author$project$Pages$Admin$Plans$Top$load, agD: $author$project$Pages$Admin$Plans$Top$save, ahd: $author$project$Pages$Admin$Plans$Top$subscriptions, aaq: $author$project$Pages$Admin$Plans$Top$update, ahP: $author$project$Pages$Admin$Plans$Top$view});
var $author$project$Pages$Admin$Practice$AccountFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$Closed = {$: 0};
var $author$project$Components$Admin$Practice$DeactivateModal$init = $author$project$Components$Admin$Practice$DeactivateModal$Closed;
var $author$project$Components$Practice$AccountForm$EmrDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Practice$AccountForm$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$defaultMembershipStartDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Nc;
	});
var $author$project$Components$Practice$AccountForm$AddressInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Practice$One$ein = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Of;
	});
var $author$project$Api$Provider$Practice$One$emr = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.acY;
	});
var $author$project$Api$Provider$Practice$One$emrOther = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ac_;
	});
var $author$project$Components$Practice$AccountForm$initPhoneInput = function (phones) {
	return A3(
		$author$project$Components$PhoneInput$init,
		'practice-phone-input',
		A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones),
		function (d) {
			return _Utils_update(
				d,
				{Ik: true, acB: $author$project$Api$Common$Phone$Shared$Office, yQ: 1, agk: true});
		});
};
var $author$project$Api$Provider$Practice$Shared$logoUrl = function (_v0) {
	var record = _v0;
	return record.S8;
};
var $author$project$Api$Provider$Practice$One$logoUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$logoUrl(shared);
};
var $author$project$Api$WhitelabelSetting$patientFacingFaviconPngUrl = function (_v0) {
	var record = _v0;
	return record.GB;
};
var $author$project$Api$Provider$Practice$One$sessionTimeoutInMinutes = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.agT;
	});
var $author$project$Components$AddressInput$withHiddenCountry = F2(
	function (hiddenCountry, _v0) {
		var model = _v0;
		return hiddenCountry ? _Utils_update(
			model,
			{aP: false}) : _Utils_update(
			model,
			{aP: true});
	});
var $author$project$Components$Practice$AccountForm$formFieldsFromPractice = F3(
	function (addressIsRequired, practice, dataWhitelabelSettings) {
		var faviconUrl = function () {
			if (dataWhitelabelSettings.$ === 3) {
				var whitelabelSettings = dataWhitelabelSettings.a;
				return $author$project$Api$WhitelabelSetting$patientFacingFaviconPngUrl(whitelabelSettings);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = A2(
			$author$project$Components$AddressInput$initFromApi,
			'practice',
			$author$project$Api$Provider$Practice$One$address(practice));
		var addressInput = _v0.a;
		var addressInputCmd = _v0.b;
		return _Utils_Tuple2(
			{
				It: A2(
					$author$project$Components$AddressInput$withHiddenCountry,
					true,
					A2($author$project$Components$AddressInput$withRequired, addressIsRequired, addressInput)),
				wY: faviconUrl,
				Mu: $author$project$Api$Provider$Practice$One$logoUrl(practice),
				Of: $author$project$Api$Provider$Practice$One$ein(practice),
				Oo: $author$project$Api$Provider$Practice$One$email(practice),
				acY: $author$project$Api$Provider$Practice$One$emr(practice),
				ac_: $author$project$Api$Provider$Practice$One$emrOther(practice),
				Fg: 0,
				xC: $elm$core$Maybe$Nothing,
				F0: 0,
				S8: $elm$core$Maybe$Nothing,
				zh: $author$project$Api$Provider$Practice$One$name(practice),
				Wg: $author$project$Components$Practice$AccountForm$initPhoneInput(
					$author$project$Api$Provider$Practice$One$phones(practice)),
				agT: $author$project$Api$Provider$Practice$One$sessionTimeoutInMinutes(practice),
				aav: $author$project$Api$Provider$Practice$One$url(practice)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$AddressInputMsg, addressInputCmd));
	});
var $author$project$Components$Practice$AccountForm$init = F4(
	function (practice, dataWhitelabelSetting, sharedModel, _v0) {
		var isOnboarding = _v0.aJ;
		var onboardingClinical = _v0.U6;
		var hasClinical = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice) || onboardingClinical;
		var defaultMembershipStartDate = $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice);
		var currentDate = sharedModel.cO;
		var addressIsRequired = hasClinical || (A2($justinmimbs$date$Date$compare, defaultMembershipStartDate, currentDate) !== 2);
		var _v1 = A3($author$project$Components$Practice$AccountForm$formFieldsFromPractice, addressIsRequired, practice, dataWhitelabelSetting);
		var formFields = _v1.a;
		var formFieldsCmd = _v1.b;
		return _Utils_Tuple2(
			{
				DX: addressIsRequired,
				D5: sharedModel.D5,
				cO: currentDate,
				MZ: $author$project$Components$Admin$Practice$DeactivateModal$init,
				h8: false,
				l1: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'emr', ahx: $author$project$Components$Practice$AccountForm$EmrDropdownMsg})),
				PB: $author$project$Utils$Form$init(formFields),
				mm: hasClinical,
				FR: $author$project$Shared$isHintAdmin(sharedModel),
				aJ: isOnboarding,
				WF: practice,
				jY: $author$project$Api$Data$NotAsked
			},
			formFieldsCmd);
	});
var $author$project$Pages$Admin$Practice$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A4(
			$author$project$Components$Practice$AccountForm$init,
			practice,
			shared.aa1,
			shared,
			{aJ: false, U6: false});
		var accountFormModel = _v1.a;
		var accountFormCmd = _v1.b;
		return _Utils_Tuple2(
			{
				cu: accountFormModel,
				D5: shared.D5,
				MZ: $author$project$Components$Admin$Practice$DeactivateModal$init,
				h8: false,
				FR: $author$project$Shared$isHintAdmin(shared),
				WF: practice,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				Cd: shared
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, accountFormCmd));
	});
var $author$project$Pages$Admin$Practice$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Practice$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Practice$DeactivateModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Practice$HiConfirmClosed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$CloseModal = {$: 0};
var $author$project$Components$Admin$Practice$DeactivateModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Practice$DeactivateModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Practice$AccountForm$PhoneInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Practice$AccountForm$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Utils$Form$fields(model.PB);
	var phone = _v1.Wg;
	var address = _v1.It;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Practice$AccountForm$AddressInputMsg,
				$author$project$Components$AddressInput$subscriptions(address)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Practice$AccountForm$PhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(phone)),
				$author$project$Ui$NewDropdown$subscriptions(model.l1)
			]));
};
var $author$project$Pages$Admin$Practice$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Practice$AccountFormMsg,
				$author$project$Components$Practice$AccountForm$subscriptions(model.cu)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Practice$DeactivateModalMsg,
				$author$project$Components$Admin$Practice$DeactivateModal$subscriptions(model.MZ)),
				model.h8 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$Practice$HiConfirmClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Admin$Practice$Deleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$OutMsg$WhitelabelSettingsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Practice$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath));
	});
var $author$project$Ports$Session$logoutPort = _Platform_outgoingPort(
	'logoutPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'redirect',
					$elm$json$Json$Encode$bool($.af6))
				]));
	});
var $author$project$Ports$Session$logout = function (options) {
	return $author$project$Ports$Session$logoutPort(options);
};
var $author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Admin$Practice$DeactivateModal$Open = F6(
	function (a, b, c, d, e, f) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$Api$Provider$Practice$Shared$cancellationReasonOther = function (_v0) {
	var record = _v0;
	return record.abN;
};
var $author$project$Api$Provider$Practice$One$cancellationReasonOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$cancellationReasonOther(shared);
};
var $author$project$Api$Provider$Practice$Shared$deactivateOn = function (_v0) {
	var record = _v0;
	return record.M_;
};
var $author$project$Api$Provider$Practice$One$deactivateOn = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$deactivateOn(shared);
};
var $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons = _List_fromArray(
	['Practice closed', 'Practice closed [Retired]', 'Lost to competitor: AtlasMD', 'Lost to competitor: Cerbo', 'Lost to competitor: Elation', 'Lost to competitor: Other', 'Never onboarded', 'Merged Hint accounts', 'Abandoned membership model', 'Deactivated freemium affiliate', 'Pricing rollout 2024', 'Dormant Account', 'Unknown']);
var $author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason = A2(
	$elm$core$Maybe$withDefault,
	'',
	$elm$core$List$head($author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons));
var $author$project$Components$Admin$Practice$DeactivateModal$open = function (practice) {
	var cancellationReason = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason,
		$author$project$Api$Provider$Practice$One$cancellationReasonOther(practice));
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		A6(
			$author$project$Components$Admin$Practice$DeactivateModal$Open,
			practice,
			false,
			$author$project$Api$Data$NotAsked,
			$author$project$Api$Provider$Practice$One$deactivateOn(practice),
			dateInput,
			cancellationReason),
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg(dateInput),
			dateInputCmd));
};
var $author$project$Pages$Admin$Practice$WhitelabelSettingRetrieved = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$WhitelabelSetting$WhitelabelSetting = $elm$core$Basics$identity;
var $author$project$Api$WhitelabelSetting$Record = F8(
	function (practiceFacingLogoUrl, practiceFacingLogoAltText, practiceFacingFaviconIcoUrl, practiceFacingFaviconPngUrl, practiceFacingFaviconAppleUrl, patientFacingFaviconPngUrl, brandName, branded) {
		return {Ek: brandName, El: branded, GB: patientFacingFaviconPngUrl, GJ: practiceFacingFaviconAppleUrl, GK: practiceFacingFaviconIcoUrl, GL: practiceFacingFaviconPngUrl, GM: practiceFacingLogoAltText, GN: practiceFacingLogoUrl};
	});
var $author$project$Api$WhitelabelSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'branded',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'brand_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient_facing_favicon_png_url',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practice_facing_favicon_apple_url',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'practice_facing_favicon_png_url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'practice_facing_favicon_ico_url',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'practice_facing_logo_alt_text',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'practice_facing_logo_url',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Api$WhitelabelSetting$Record)))))))));
var $author$project$Api$WhitelabelSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$WhitelabelSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$WhitelabelSetting$employerWhitelabelSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['whitelabel_settings']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$WhitelabelSetting$employerRetrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$WhitelabelSetting$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$WhitelabelSetting$employerWhitelabelSettingsPath));
	});
var $author$project$Api$WhitelabelSetting$providerWhitelabelSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['whitelabel_settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$WhitelabelSetting$providerRetrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$WhitelabelSetting$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$WhitelabelSetting$providerWhitelabelSettingsPath));
	});
var $author$project$Api$WhitelabelSetting$retrieve = F3(
	function (apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$WhitelabelSetting$employerRetrieve, apiClient, toMsg) : A2($author$project$Api$WhitelabelSetting$providerRetrieve, apiClient, toMsg);
	});
var $author$project$Pages$Admin$Practice$retrieveWhitelabelSetting = F3(
	function (practice, apiClient, session) {
		return A3(
			$author$project$Api$WhitelabelSetting$retrieve,
			apiClient,
			session,
			$author$project$Pages$Admin$Practice$WhitelabelSettingRetrieved(practice));
	});
var $author$project$Components$Admin$Practice$DeactivateModal$Deactivated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$None = {$: 0};
var $author$project$Components$Admin$Practice$DeactivateModal$PracticeDeactivated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Practice$deactivate = F5(
	function (apiClient, removePracticeUsers, maybeDate, cancellationReason, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'remove_practice_users',
					$elm$json$Json$Encode$bool(removePracticeUsers)),
					_Utils_Tuple2(
					'deactivation_date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, maybeDate)),
					_Utils_Tuple2(
					'cancellation_reason_other',
					$elm$json$Json$Encode$string(cancellationReason))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['deactivate']),
						$author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Components$Admin$Practice$DeactivateModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$Practice$DeactivateModal$None, y8: $author$project$Components$Admin$Practice$DeactivateModal$Closed, as: _List_Nil};
			case 2:
				var bool = msg.a;
				if (model.$ === 1) {
					var practitioner = model.a;
					var maybeDate = model.d;
					var dateInput = model.e;
					var cancellationReason = model.f;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$Practice$DeactivateModal$None,
						y8: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, bool, $author$project$Api$Data$NotAsked, maybeDate, dateInput, cancellationReason),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$Practice$DeactivateModal$None, y8: $author$project$Components$Admin$Practice$DeactivateModal$Closed, as: _List_Nil};
				}
			case 4:
				var dateInputModel = msg.a;
				var dateInputMsg = msg.b;
				var _v2 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
				var newDateInput = _v2.a;
				var subCmd = _v2.b;
				var event = _v2.c;
				if (model.$ === 1) {
					var practitioner = model.a;
					var removePracticeUsers = model.b;
					var data = model.c;
					var currentMaybeDate = model.d;
					var cancellationReason = model.f;
					if (event.$ === 1) {
						var maybeDate = event.a;
						return {
							EC: subCmd,
							ac5: $author$project$Components$Admin$Practice$DeactivateModal$None,
							y8: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, data, maybeDate, newDateInput, cancellationReason),
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$Admin$Practice$DeactivateModal$None,
							y8: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, data, currentMaybeDate, newDateInput, cancellationReason),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$Practice$DeactivateModal$None, y8: $author$project$Components$Admin$Practice$DeactivateModal$Closed, as: _List_Nil};
				}
			case 5:
				var inputReason = msg.a;
				if (model.$ === 1) {
					var practitioner = model.a;
					var removePracticeUsers = model.b;
					var maybeDate = model.d;
					var dateInput = model.e;
					var selectedCancellationReason = A2(
						$elm_community$list_extra$List$Extra$getAt,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(inputReason)),
						$author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons);
					var cancellationReason = A2($elm$core$Maybe$withDefault, $author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason, selectedCancellationReason);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$Practice$DeactivateModal$None,
						y8: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, $author$project$Api$Data$NotAsked, maybeDate, dateInput, cancellationReason),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$Practice$DeactivateModal$None, y8: $author$project$Components$Admin$Practice$DeactivateModal$Closed, as: _List_Nil};
				}
			case 1:
				if (model.$ === 1) {
					var practitioner = model.a;
					var removePracticeUsers = model.b;
					var maybeDate = model.d;
					var dateInput = model.e;
					var cancellationReason = model.f;
					return {
						EC: A5($author$project$Api$Provider$Practice$deactivate, apiClient, removePracticeUsers, maybeDate, cancellationReason, $author$project$Components$Admin$Practice$DeactivateModal$Deactivated),
						ac5: $author$project$Components$Admin$Practice$DeactivateModal$None,
						y8: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, $author$project$Api$Data$Loading, maybeDate, dateInput, cancellationReason),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$Practice$DeactivateModal$None, y8: $author$project$Components$Admin$Practice$DeactivateModal$Closed, as: _List_Nil};
				}
			default:
				var response = msg.a;
				if (model.$ === 1) {
					var practitioner = model.a;
					var removePracticeUsers = model.b;
					var maybeDate = model.d;
					var dateInput = model.e;
					var cancellationReason = model.f;
					switch (response.$) {
						case 3:
							var practice = response.a;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: $author$project$Components$Admin$Practice$DeactivateModal$PracticeDeactivated(practice),
								y8: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Practice has been deactivated/scheduled for deactivation'),
										$author$project$OutMsg$PracticeUpdated(response)
									])
							};
						case 2:
							var error = response.a;
							var errorString = $author$project$Api$Data$errorToString(error);
							var errorMessage = $elm$core$String$isEmpty(errorString) ? 'This practice cannot be deactivated. Please contact us for more information.' : errorString;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: $author$project$Components$Admin$Practice$DeactivateModal$None,
								y8: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, response, maybeDate, dateInput, cancellationReason),
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 1, errorMessage)
									])
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$Practice$DeactivateModal$None, y8: model, as: _List_Nil};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$Practice$DeactivateModal$None, y8: $author$project$Components$Admin$Practice$DeactivateModal$Closed, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Practice$AccountForm$Address = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Practice$AccountForm$Emr = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Practice$AccountForm$EmrOther = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Practice$AccountForm$Favicon = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Practice$AccountForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Practice$AccountForm$Logo = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Practice$AccountForm$Phone = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Practice$AccountForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aav: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						Mu: $elm$core$Maybe$Just(string),
						F0: _int,
						S8: $elm$core$Maybe$Just(string)
					});
			case 3:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						wY: $elm$core$Maybe$Just(string),
						Fg: _int,
						xC: $elm$core$Maybe$Just(string)
					});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Oo: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Of: $author$project$Utils$String$toMaybe(string)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						agT: $elm$core$String$toInt(string)
					});
			case 7:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Wg: phone});
			case 8:
				var address = field.a;
				return _Utils_update(
					fields,
					{It: address});
			case 9:
				var maybeEmr = field.a;
				return _Utils_update(
					fields,
					{acY: maybeEmr});
			default:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{ac_: maybeString});
		}
	});
var $author$project$Components$Practice$AccountForm$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v2 = $author$project$Utils$Form$fields(model.PB);
				var address = _v2.It;
				var _v3 = A2($author$project$Components$AddressInput$update, subMsg, address);
				var addressInputModel = _v3.a;
				var addressInputCmd = _v3.b;
				var outMsgs = _v3.c;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Practice$AccountForm$formFieldsUpdate,
					$author$project$Components$Practice$AccountForm$Address(addressInputModel),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$AddressInputMsg, addressInputCmd),
					outMsgs);
			case 1:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var task = _v4.a;
							var size = _v4.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Practice$AccountForm$FormUpdated,
									$author$project$Components$Practice$AccountForm$Logo(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 2:
				var favicon = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var task = _v5.a;
							var size = _v5.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Practice$AccountForm$FormUpdated,
									$author$project$Components$Practice$AccountForm$Favicon(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(favicon))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v6 = $author$project$Utils$Form$fields(model.PB);
				var phone = _v6.Wg;
				var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v7.a;
				var phoneCmd = _v7.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Practice$AccountForm$formFieldsUpdate,
					$author$project$Components$Practice$AccountForm$Phone(phoneInput),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$PhoneInputMsg, phoneCmd),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$NewDropdown$update, subMsg, model.l1);
				var newDropdown = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l1: newDropdown}),
					cmd,
					_List_Nil);
			default:
				var emrOption = msg.a;
				var newForm = function () {
					if (!emrOption.$) {
						var emr = emrOption.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Practice$AccountForm$formFieldsUpdate,
							$author$project$Components$Practice$AccountForm$EmrOther($elm$core$Maybe$Nothing),
							A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Practice$AccountForm$formFieldsUpdate,
								$author$project$Components$Practice$AccountForm$Emr(
									$elm$core$Maybe$Just(emr)),
								model.PB));
					} else {
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Practice$AccountForm$formFieldsUpdate,
							$author$project$Components$Practice$AccountForm$Emr($elm$core$Maybe$Nothing),
							model.PB);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Practice$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Practice$AccountForm$practiceFromFields = function (fields) {
	var phones = A2(
		$elm$core$List$map,
		$author$project$Utils$Phone$toRecord,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Components$PhoneInput$getPhones(fields.Wg)));
	var address = $author$project$Components$AddressInput$getAddress(fields.It);
	return {It: address, Of: fields.Of, Oo: fields.Oo, acY: fields.acY, ac_: fields.ac_, adj: fields.xC, S7: fields.S8, zh: fields.zh, Wi: phones, agT: fields.agT, aav: fields.aav};
};
var $author$project$Api$Provider$Practice$Emr$toValue = function (_v0) {
	var id = _v0.adR;
	return id;
};
var $author$project$Api$Provider$Practice$update = F3(
	function (apiClient, fields, toMsg) {
		var phones_ = A2(
			$elm$json$Json$Encode$list,
			function (phone) {
				return $author$project$Api$Common$Phone$Shared$encode(phone);
			},
			fields.Wi);
		var logo_ = function () {
			var _v1 = fields.S7;
			if (!_v1.$) {
				var base64 = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'logo',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var favicon_ = function () {
			var _v0 = fields.adj;
			if (!_v0.$) {
				var base64 = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'favicon',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var address_ = $author$project$Api$Common$Address$Shared$encode(fields.It);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'url',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aav)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'email',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oo)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'ein',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Of)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'session_timeout_in_minutes',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.agT)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2('address', address_),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2('phones', phones_),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'emr',
															A2(
																$author$project$Utils$Encode$nullable,
																A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$Emr$toValue, $elm$json$Json$Encode$string),
																fields.acY)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'emr_other',
																A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ac_)),
															_Utils_ap(logo_, favicon_))))))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$Practice$updatePractice = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$update,
			apiClient,
			$author$project$Components$Practice$AccountForm$practiceFromFields(fields),
			$author$project$Pages$Admin$Practice$Updated);
	});
var $author$project$Components$Practice$AccountForm$LogoValidation = 2;
var $author$project$Components$Practice$AccountForm$NameValidation = 0;
var $author$project$Components$Practice$AccountForm$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Practice$AccountForm$AddressValidation = 6;
var $author$project$Components$Practice$AccountForm$validateAddress = F2(
	function (_v0, fields) {
		return (!$author$project$Components$AddressInput$isValid(fields.It)) ? _List_fromArray(
			[
				_Utils_Tuple2(6, 'Please enter a valid address.')
			]) : _List_Nil;
	});
var $author$project$Components$Practice$AccountForm$EinValidation = 5;
var $author$project$Ui$Form$Ein$einFormat = '^(?!00|[01][789]|2[89]|[4678]9|7[08]|9[67])\\d\\d\\d{7}$';
var $author$project$Components$Practice$AccountForm$validateEin = function (fields) {
	var _v0 = fields.Of;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var ein = _v0.a;
		return A2($author$project$Utils$Regex$matches, $author$project$Ui$Form$Ein$einFormat, ein) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(5, 'Please enter a valid EIN.')
			]);
	}
};
var $author$project$Components$Practice$AccountForm$EmailValidation = 3;
var $author$project$Components$Practice$AccountForm$validateEmail = F2(
	function (model, fields) {
		var _v0 = fields.Oo;
		if (_v0.$ === 1) {
			return (model.mm && model.aJ) ? _List_fromArray(
				[
					_Utils_Tuple2(3, 'Please enter an email.')
				]) : _List_Nil;
		} else {
			var email = _v0.a;
			return $rtfeldman$elm_validate$Validate$isValidEmail(email) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(3, 'Please enter a valid email.')
				]);
		}
	});
var $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutesValidation = 4;
var $author$project$Components$Practice$AccountForm$validateSessionTimeout = function (fields) {
	var invalid = _List_fromArray(
		[
			_Utils_Tuple2(4, 'Please enter a number between 5 and 480.')
		]);
	var _v0 = fields.agT;
	if (!_v0.$) {
		var sessionTimeoutInMinutes = _v0.a;
		return ((sessionTimeoutInMinutes < 5) || (sessionTimeoutInMinutes > 480)) ? invalid : _List_Nil;
	} else {
		return invalid;
	}
};
var $author$project$Components$Practice$AccountForm$UrlValidation = 1;
var $author$project$Utils$Url$validUrlRegex = '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,10}(:[0-9]{1,5})?(\\/.*)?$';
var $author$project$Components$Practice$AccountForm$validateUrl = F2(
	function (model, fields) {
		var _v0 = fields.aav;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var url = _v0.a;
			return ((!model.aJ) && ((!A2($author$project$Utils$Regex$matches, $author$project$Utils$Url$validUrlRegex, url)) && (!$elm$core$String$isEmpty(url)))) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a valid URL.')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Practice$AccountForm$formFieldsValidator = function (model) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.zh;
				},
				_Utils_Tuple2(0, 'Please enter a name.')),
				A3(
				$author$project$Utils$Validate$ifIntGreaterThan,
				function ($) {
					return $.F0;
				},
				$author$project$Components$Practice$AccountForm$maxLogoBytesSize,
				_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Practice$AccountForm$validateUrl(model)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Practice$AccountForm$validateEmail(model)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Practice$AccountForm$validateAddress(model)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateEin),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateSessionTimeout)
			]));
};
var $author$project$Components$Practice$AccountForm$validate = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	var address = $author$project$Components$AddressInput$validate(fields.It);
	var newForm = A3(
		$author$project$Utils$Form$update,
		$author$project$Components$Practice$AccountForm$formFieldsUpdate,
		$author$project$Components$Practice$AccountForm$Address(address),
		model.PB);
	return A2(
		$elm$core$Result$mapError,
		function (validatedForm) {
			return _Utils_update(
				model,
				{PB: validatedForm});
		},
		A2(
			$elm$core$Result$map,
			function (_v1) {
				var validatedForm = _v1.a;
				var validFormFields = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{PB: validatedForm}),
					validFormFields);
			},
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$Practice$AccountForm$formFieldsValidator(model),
				newForm)));
};
var $author$project$Pages$Admin$Practice$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Practice$AccountForm$update, subMsg, model.cu);
				var accountFormModel = _v1.a;
				var accountFormCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cu: accountFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, accountFormCmd),
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h8: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h8: false, jY: $author$project$Api$Data$NotAsked}),
						$author$project$Ports$Session$logout(
							{af6: true}),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Practice has been deleted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h8: false, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var _v3 = $author$project$Components$Practice$AccountForm$validate(model.cu);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var validatedForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cu: validatedForm, jY: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$Practice$updatePractice, model.D5, validFormFields),
						_List_Nil);
				} else {
					var formErrors = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cu: formErrors, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Provider$Practice$delete, model.D5, $author$project$Pages$Admin$Practice$Deleted),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{h8: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						A3($author$project$Pages$Admin$Practice$retrieveWhitelabelSetting, practice, model.D5, model.ZD),
						_List_fromArray(
							[
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var practice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var _v7 = A4(
						$author$project$Components$Practice$AccountForm$init,
						practice,
						response,
						model.Cd,
						{aJ: false, U6: false});
					var form = _v7.a;
					var cmds = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cu: form}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, cmds),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
								$author$project$OutMsg$WhitelabelSettingsUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var _v8 = $author$project$Components$Admin$Practice$DeactivateModal$open(model.WF);
				var deactivateModalModel = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{MZ: deactivateModalModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$DeactivateModalMsg, cmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$Practice$DeactivateModal$update, model.D5, subMsg, model.MZ);
				var newModel = function () {
					var _v9 = result.ac5;
					if (_v9.$ === 1) {
						var practice = _v9.a;
						return _Utils_update(
							model,
							{WF: practice});
					} else {
						return model;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{MZ: result.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$DeactivateModalMsg, result.EC),
					result.as);
		}
	});
var $author$project$Pages$Admin$Practice$Deactivate = {$: 6};
var $author$project$Pages$Admin$Practice$Delete = {$: 1};
var $author$project$Pages$Admin$Practice$FormSubmitted = {$: 3};
var $author$project$Api$Provider$Practice$Shared$deactivated = function (_v0) {
	var record = _v0;
	return record.M$;
};
var $author$project$Api$Provider$Practice$One$deactivated = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$deactivated(shared);
};
var $author$project$Components$Admin$Practice$DeactivateModal$CancellationReasonSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$Deactivate = {$: 1};
var $author$project$Components$Admin$Practice$DeactivateModal$RemovePracticeUsersUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasonOptions = A2(
	$elm$core$List$indexedMap,
	F2(
		function (index, reason) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(index)),
				reason);
		}),
	$author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons);
var $author$project$Components$Admin$Practice$DeactivateModal$viewModal = F6(
	function (practice, removePracticeUsers, request, maybeDate, dateInput, cancellationReason) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Admin$Practice$DeactivateModal$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Deactivate Practice')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('You\'re about to deactivate Practice '),
											$elm$html$Html$text(
											$author$project$Api$Provider$Practice$One$name(practice)),
											$elm$html$Html$text(' which stops all billing, payments and notifications. Admins will still be able to login to export data and download reports. This action cannot be undone.')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Prevent users from accessing the Practice'),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$labelSpanSm(8),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(removePracticeUsers),
											$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$Practice$DeactivateModal$RemovePracticeUsersUpdated)
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Schedule Deactivation Date'),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$labelSpanSm(8),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg(dateInput),
									A2(
										$author$project$Components$DateInput$view,
										_List_fromArray(
											[
												$author$project$Components$DateInput$value(maybeDate)
											]),
										dateInput))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Cancellation Reason'),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$labelSpanSm(8),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(cancellationReason)),
											$author$project$Ui$Form$Select$onChange($author$project$Components$Admin$Practice$DeactivateModal$CancellationReasonSelected)
										]),
									$author$project$Components$Admin$Practice$DeactivateModal$cancellationReasonOptions)
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Practice$DeactivateModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Deactivate practice'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Practice$DeactivateModal$Deactivate)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Deactivate Practice')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Practice$DeactivateModal$view = function (model) {
	if (model.$ === 1) {
		var practitioner = model.a;
		var removePracticeUsers = model.b;
		var request = model.c;
		var maybeDate = model.d;
		var dateInput = model.e;
		var cancellationReason = model.f;
		return A6($author$project$Components$Admin$Practice$DeactivateModal$viewModal, practitioner, removePracticeUsers, request, maybeDate, dateInput, cancellationReason);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Practice$AccountForm$Ein = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Practice$AccountForm$Email = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Practice$AccountForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutes = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Practice$AccountForm$Url = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Ein$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Ein$errors = $author$project$Ui$Form$Ein$Errors;
var $author$project$Ui$Form$Ein$Invalid = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Ein$invalid = function (bool) {
	return $author$project$Ui$Form$Ein$Invalid(bool);
};
var $author$project$Ui$Form$Ein$OnInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Ein$onInput = $author$project$Ui$Form$Ein$OnInput;
var $author$project$Ui$Form$Ein$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Ein$value = $author$project$Ui$Form$Ein$Value;
var $author$project$Ui$Form$Ein$einMask = '##-#######';
var $author$project$Ui$Form$Ein$einPattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Ui$Form$Ein$einMask);
var $author$project$Ui$Form$Input$OnMaskedInput = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Input$onMaskedInput = $author$project$Ui$Form$Input$OnMaskedInput;
var $author$project$Ui$Form$Ein$defaultOptions = {fE: _List_Nil, q$: false, afc: $elm$core$Maybe$Nothing, r4: $elm$core$Maybe$Nothing, aaN: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$Ein$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								afc: $elm$core$Maybe$Just(handler)
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{aaN: string});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{q$: bool});
					case 3:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
					default:
						var string = option.a;
						return _Utils_update(
							record,
							{
								r4: $elm$core$Maybe$Just(string)
							});
				}
			}),
		$author$project$Ui$Form$Ein$defaultOptions,
		options);
};
var $author$project$Ui$Form$Ein$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$Ein$optionsToRecord(options);
	var value_ = A2($elm$core$Maybe$withDefault, '', optionsRecord.aaN);
	var onInput_ = function () {
		var _v0 = optionsRecord.afc;
		if (!_v0.$) {
			var handler = _v0.a;
			return _List_fromArray(
				[
					A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Ui$Form$Ein$einPattern, value_, handler)
				]);
		} else {
			return _List_Nil;
		}
	}();
	return $author$project$Ui$Form$Input$view(
		A2(
			$elm$core$List$cons,
			$author$project$Ui$Form$Input$autoComplete(false),
			A2(
				$elm$core$List$cons,
				A2($author$project$Ui$Form$Input$maskedValue, $author$project$Ui$Form$Ein$einPattern, value_),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$invalid(optionsRecord.q$),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$errors(optionsRecord.fE),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$placeholder(
								A2($elm$core$Maybe$withDefault, '', optionsRecord.r4)),
							onInput_))))));
};
var $author$project$Components$Practice$AccountForm$EmrSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Practice$Emr$toLabel = function (_v0) {
	var name = _v0.zh;
	return name;
};
var $author$project$Api$Provider$Practice$Emr$toOption = function (_v0) {
	var option = _v0.ae;
	return option;
};
var $author$project$Components$Practice$AccountForm$viewEmrSelect = F2(
	function (model, fields) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9),
					$author$project$Ui$Form$Group$label('EMR')
				]),
			_List_fromArray(
				[
					function () {
					var items = A2(
						$elm$core$List$map,
						function (emr) {
							return A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$Practice$AccountForm$EmrSelected(
											$elm$core$Maybe$Just(emr))),
										$author$project$Ui$NewDropdown$selected(
										_Utils_eq(
											fields.acY,
											$elm$core$Maybe$Just(emr)))
									]),
								$elm$html$Html$text(
									$author$project$Api$Provider$Practice$Emr$toLabel(emr)));
						},
						$author$project$Api$Provider$Practice$Emr$options);
					var currentLabel = function () {
						var _v0 = fields.acY;
						if (!_v0.$) {
							var emr = _v0.a;
							return $author$project$Api$Provider$Practice$Emr$toLabel(emr);
						} else {
							return 'Select an EMR';
						}
					}();
					return A4(
						$author$project$Ui$NewDropdown$viewSelect,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(currentLabel)
							]),
						items,
						model.l1);
				}(),
					_Utils_eq(
					A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$toOption, fields.acY),
					$elm$core$Maybe$Just(13)) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mt-2')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.ac_)),
									$author$project$Ui$Form$Input$onInput(
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$EmrOther),
										$author$project$Utils$String$toMaybe))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Practice$AccountForm$FaviconUploaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Practice$AccountForm$LogoUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Practice$AccountForm$viewLogos = F3(
	function (_v0, form, isOnboarding) {
		var currentLogoUrl = _v0.Mu;
		var currentFaviconUrl = _v0.wY;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mt-2 mb-2')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Logo')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Recommended size: 400x200 px or larger.'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Supported image file: JPG, PNG')
										])),
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(0),
											$author$project$Ui$Form$File$onInput($author$project$Components$Practice$AccountForm$LogoUploaded),
											$author$project$Ui$Form$File$empty(true)
										])),
									function () {
									if (!currentLogoUrl.$) {
										if (currentLogoUrl.a === '') {
											return $author$project$Utils$Html$empty;
										} else {
											var url = currentLogoUrl.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Image$fromSrc,
														{I1: 'Uploaded image'},
														url,
														_List_fromArray(
															[
																$author$project$Ui$Image$height(50)
															])),
														$author$project$Utils$FormErrors$view(
														A2($author$project$Utils$Form$validationErrors, 2, form))
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							isOnboarding ? A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_Nil) : A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Browser Tab Image (Favicon)')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Recommended size: 260x260 px or larger.'),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$elm$html$Html$text('Supported image file: PNG')
										])),
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(0),
											$author$project$Ui$Form$File$onInput($author$project$Components$Practice$AccountForm$FaviconUploaded),
											$author$project$Ui$Form$File$empty(true)
										])),
									function () {
									if (!currentFaviconUrl.$) {
										if (currentFaviconUrl.a === '') {
											return $author$project$Utils$Html$empty;
										} else {
											var url = currentFaviconUrl.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Image$fromSrc,
														{I1: 'Uploaded favicon'},
														url,
														_List_fromArray(
															[
																$author$project$Ui$Image$height(50)
															]))
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Practice$AccountForm$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Name'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.zh),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, model.PB))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Website')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', fields.aav)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Url)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 1, model.PB))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Practice Logo'),
						$author$project$Ui$Form$Group$labelHelp(
						A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text('Shown to Patients')
								])))
					]),
				_List_fromArray(
					[
						A3($author$project$Components$Practice$AccountForm$viewLogos, fields, model.PB, model.aJ)
					])),
				(model.aJ && model.mm) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Practice Phone')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Practice$AccountForm$PhoneInputMsg,
						$author$project$Components$PhoneInput$view(fields.Wg))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Practice Email'),
						$author$project$Ui$Form$Group$required(model.mm && model.aJ)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', fields.Oo)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Email)),
								$author$project$Ui$Form$Input$placeholder('contact@mypractice.com'),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 3, model.PB))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Bussiness Address'),
						$author$project$Ui$Form$Group$required(model.DX)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Practice$AccountForm$AddressInputMsg,
						A2($author$project$Components$AddressInput$view, _List_Nil, fields.It))
					])),
				model.aJ ? $author$project$Utils$Html$empty : A2($author$project$Components$Practice$AccountForm$viewEmrSelect, model, fields),
				(model.aJ && model.mm) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Employer Identification Number (EIN)')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Ein$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Ein$value(fields.Of),
								$author$project$Ui$Form$Ein$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Ein)),
								$author$project$Ui$Form$Ein$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 5, model.PB)),
								$author$project$Ui$Form$Ein$errors(
								A2($author$project$Utils$Form$validationErrors, 5, model.PB))
							]))
					])),
				model.aJ ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpan(9),
						$author$project$Ui$Form$Group$label('Auto Logout After'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.agT))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutes)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 4, model.PB))
									])),
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('minutes')
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 4, model.PB)),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpText]),
						_List_fromArray(
							[
								$elm$html$Html$text('In order to protect your patients\' data when you are not using the app, the application will log you out after this number of minutes.')
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Practice$view = function (model) {
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	return {
		e5: _List_fromArray(
			[
				function () {
				if (model.h8) {
					var practiceName = $author$project$Api$Provider$Practice$One$name(model.WF);
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Practice$HiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun(practiceName),
								$author$project$Components$HiConfirm$loading(loading),
								$author$project$Components$HiConfirm$detail(' and disable all login access')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$Practice$DeactivateModalMsg,
				$author$project$Components$Admin$Practice$DeactivateModal$view(model.MZ)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Practice$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Practice')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mb4]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$muted]),
														_List_fromArray(
															[
																$elm$html$Html$text('The practice info on this page will be used for invoicing, patient billing inquiries and automated notifications')
															]))
													])),
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Admin$Practice$AccountFormMsg,
												$author$project$Components$Practice$AccountForm$view(model.cu)),
												function () {
												var _v0 = model.jY;
												if (_v0.$ === 2) {
													var error = _v0.a;
													return A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$mt4]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Alert$danger,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Api$Data$errorToString(error))
																	]))
															]));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										function () {
										var _v1 = _Utils_Tuple2(
											model.FR,
											$author$project$Api$Provider$Practice$One$deactivated(model.WF));
										if (_v1.a) {
											if (!_v1.b) {
												return A3(
													$author$project$Ui$HinterOnly$button,
													{abp: 'Deactivate practice'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$onClick($author$project$Pages$Admin$Practice$Deactivate)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Deactivate')
														]));
											} else {
												return A3(
													$author$project$Ui$HinterOnly$button,
													{abp: 'Delete practice'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$onClick($author$project$Pages$Admin$Practice$Delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]));
											}
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Update practice'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Update')
											]))
									]))
							]))
					]))
			]),
		$G: 'Admin | Practice'
	};
};
var $author$project$Pages$Admin$Practice$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Practice$init, aer: $author$project$Pages$Admin$Practice$load, agD: $author$project$Pages$Admin$Practice$save, ahd: $author$project$Pages$Admin$Practice$subscriptions, aaq: $author$project$Pages$Admin$Practice$update, ahP: $author$project$Pages$Admin$Practice$view});
var $author$project$Pages$Admin$ProviderGroups$GotLocationGroups = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$LocationGroup$IntegrationRecords = 0;
var $author$project$Pages$Admin$ProviderGroups$fetchLocationGroups = function (model) {
	return A3(
		$author$project$Api$Provider$LocationGroup$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					Fc: _List_fromArray(
						[0])
				});
		},
		$author$project$Pages$Admin$ProviderGroups$GotLocationGroups);
};
var $author$project$Pages$Admin$ProviderGroups$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.D5;
		var model = {
			D5: apiClient,
			id: $elm$core$Maybe$Nothing,
			dO: $elm$core$Set$empty,
			rj: $elm$core$Maybe$Nothing,
			S$: $author$project$Api$Data$Loading,
			agj: $author$project$Api$Provider$Practice$One$requireGroupForLocations(practice)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model));
	});
var $author$project$Pages$Admin$ProviderGroups$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ProviderGroups$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit = {$: 3};
var $author$project$Pages$Admin$ProviderGroups$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$ProviderGroups$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit)),
					model.rj)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ProviderGroups$HiConfirmClosed),
					model.id))
			]));
};
var $author$project$Pages$Admin$ProviderGroups$LocationGroupDeleted = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$Provider$LocationGroup$locationGroupPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$LocationGroup$locationGroupsPath);
};
var $author$project$Api$Provider$LocationGroup$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$LocationGroup$locationGroupPath(id_)));
	});
var $author$project$Pages$Admin$ProviderGroups$formFieldsFromLocationGroup = function (locationGroup) {
	return $author$project$Api$Provider$LocationGroup$All$name(locationGroup);
};
var $author$project$Pages$Admin$ProviderGroups$formFieldsInit = '';
var $author$project$Pages$Admin$ProviderGroups$formFieldsUpdate = F2(
	function (field, _v0) {
		var name = field;
		return name;
	});
var $author$project$Pages$Admin$ProviderGroups$NameValidation = 0;
var $author$project$Pages$Admin$ProviderGroups$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Provider$LocationGroup$All$locationsCount = function (_v0) {
	var record = _v0.b;
	return record.S5;
};
var $author$project$Api$Provider$LocationGroup$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$LocationGroup$Shared$name(shared);
};
var $author$project$Pages$Admin$ProviderGroups$LocationGroupCreated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$LocationGroup$One$LocationGroup = $elm$core$Basics$identity;
var $author$project$Api$Provider$LocationGroup$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$LocationGroup$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$LocationGroup$create = F3(
	function (apiClient, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$LocationGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$LocationGroup$locationGroupsPath)));
	});
var $author$project$Pages$Admin$ProviderGroups$createLocationGroup = F2(
	function (apiClient, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Provider$LocationGroup$create, apiClient, name, $author$project$Pages$Admin$ProviderGroups$LocationGroupCreated);
	});
var $author$project$Pages$Admin$ProviderGroups$LocationGroupUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$LocationGroup$update = F4(
	function (apiClient, id_, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$LocationGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$LocationGroup$locationGroupPath(id_))));
	});
var $author$project$Pages$Admin$ProviderGroups$updateLocationGroup = F3(
	function (apiClient, id, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$LocationGroup$update, apiClient, id, name, $author$project$Pages$Admin$ProviderGroups$LocationGroupUpdated);
	});
var $author$project$Pages$Admin$ProviderGroups$saveLocationGroup = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$ProviderGroups$updateLocationGroup, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$ProviderGroups$createLocationGroup, apiClient, formFields);
		}
	});
var $author$project$Pages$Admin$ProviderGroups$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							rj: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Admin$ProviderGroups$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var locationGroup = msg.a;
				return (($author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0) && model.agj) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							id: $elm$core$Maybe$Just(locationGroup)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var locationGroup = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							id: $elm$core$Maybe$Nothing,
							dO: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$LocationGroup$All$id(locationGroup),
								model.dO)
						}),
					A3(
						$author$project$Api$Provider$LocationGroup$delete,
						model.D5,
						$author$project$Api$Provider$LocationGroup$All$id(locationGroup),
						$author$project$Pages$Admin$ProviderGroups$LocationGroupDeleted(locationGroup)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{id: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var locationGroup = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							rj: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$LocationGroup$All$id(locationGroup)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$ProviderGroups$formFieldsFromLocationGroup(locationGroup)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var form = msg.a;
				var id = msg.b;
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$ProviderGroups$formFieldsValidator, form);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rj: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$ProviderGroups$saveLocationGroup, model.D5, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rj: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rj: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var dataLocationGroups = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S$: dataLocationGroups}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(dataLocationGroups));
			case 6:
				var field = msg.a;
				var _v3 = model.rj;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var id = _v4.a;
					var form = _v4.b;
					var locationGroup = _v4.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$ProviderGroups$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rj: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, locationGroup))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var dataLocationGroup = msg.a;
				var _v5 = model.rj;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var id = _v6.a;
					var form = _v6.b;
					if (dataLocationGroup.$ === 3) {
						var locationGroup = dataLocationGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rj: $elm$core$Maybe$Nothing, S$: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$LocationGroup$One$name(locationGroup))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									rj: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, dataLocationGroup))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataLocationGroup));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var dataLocationGroup = msg.a;
				var _v8 = model.rj;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var id = _v9.a;
					var form = _v9.b;
					if (dataLocationGroup.$ === 3) {
						var locationGroup = dataLocationGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{rj: $elm$core$Maybe$Nothing, S$: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$LocationGroup$One$name(locationGroup) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									rj: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, dataLocationGroup))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataLocationGroup));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var locationGroup = msg.a;
				var dataLocationGroup = msg.b;
				switch (dataLocationGroup.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dO: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$LocationGroup$All$id(locationGroup),
										model.dO),
									S$: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$LocationGroup$All$name(locationGroup) + ' was successfully removed.')
								]));
					case 2:
						var error = dataLocationGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dO: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$LocationGroup$All$id(locationGroup),
										model.dO)
								}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(dataLocationGroup)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$ProviderGroups$NewLocationGroup = {$: 0};
var $author$project$Pages$Admin$ProviderGroups$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$ProviderGroups$Name = $elm$core$Basics$identity;
var $author$project$Pages$Admin$ProviderGroups$SaveLocationGroup = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Admin$ProviderGroups$viewLocationGroupModal = F3(
	function (id, form, locationGroup) {
		var name = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Location Group',
			S_: _Utils_eq(locationGroup, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit,
			U0: $author$project$Pages$Admin$ProviderGroups$SaveLocationGroup(form)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Description'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Downtown Clinic'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ProviderGroups$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Admin$ProviderGroups$DeleteLocationGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$ProviderGroups$EditLocationGroup = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$LocationGroup$All$integrationRecords = function (_v0) {
	var record = _v0.b;
	return record.Q8;
};
var $author$project$Api$Provider$IntegrationRecord$One$integration = function (_v0) {
	var record = _v0.b;
	return record.Q4;
};
var $author$project$Api$Provider$IntegrationRecord$Shared$integrationSyncStatus = function (_v0) {
	var record = _v0;
	return record.Q9;
};
var $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$integrationSyncStatus(shared);
};
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$name = function (_v0) {
	var inlinePartner = _v0.b;
	return $author$project$Api$Provider$Partner$Shared$name(inlinePartner);
};
var $author$project$Api$IntegrationRecord$Status$toString = function (status) {
	switch (status) {
		case 0:
			return 'synced';
		case 1:
			return 'unsynced';
		case 2:
			return 'errored';
		default:
			return 'enabled';
	}
};
var $author$project$Pages$Admin$ProviderGroups$viewIntegrationRecord = function (integrationRecord) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('spaced-out small')
			]),
		function () {
			var _v0 = $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus(integrationRecord);
			if (!_v0) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Integration$SharedWithInlinePartner$name(
									$author$project$Api$Provider$IntegrationRecord$One$integration(integrationRecord)))
							])),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						A2($elm$core$Basics$composeR, $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus, $author$project$Api$IntegrationRecord$Status$toString)(integrationRecord))
					]);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Pages$Admin$ProviderGroups$viewLocationGroup = F3(
	function (requireGroupForLocations, deletingLocationGroups, locationGroup) {
		var preventDelete = ($author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0) && requireGroupForLocations;
		var integrationRecords = A2(
			$author$project$Api$Expandable$withDefault,
			_List_Nil,
			$author$project$Api$Provider$LocationGroup$All$integrationRecords(locationGroup));
		var id = $author$project$Api$Provider$LocationGroup$All$id(locationGroup);
		var deleting = A2($elm$core$Set$member, id, deletingLocationGroups);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$text(
							$author$project$Api$Provider$LocationGroup$All$name(locationGroup)),
						A2($elm$core$List$map, $author$project$Pages$Admin$ProviderGroups$viewIntegrationRecord, integrationRecords))),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit location group'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$ProviderGroups$EditLocationGroup(locationGroup)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete location group'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$size(0),
											$author$project$Ui$Button$disabled(preventDelete),
											$author$project$Ui$Button$loading(deleting),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$ProviderGroups$DeleteLocationGroup(locationGroup)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$ProviderGroups$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.S$;
		if (_v1.$ === 3) {
			var locationGroups_ = _v1.a;
			return _Utils_Tuple2(false, locationGroups_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var locationGroups = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no Location Groups.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						function () {
						var label = 'Add a Location Group here';
						return A3(
							$author$project$Ui$Button$view,
							{abp: label},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$ProviderGroups$NewLocationGroup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					}()
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		A2(
			$elm$core$List$map,
			A2($author$project$Pages$Admin$ProviderGroups$viewLocationGroup, model.agj, model.dO),
			locationGroups),
		_List_Nil);
};
var $author$project$Pages$Admin$ProviderGroups$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.rj;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var locationGroup = _v1.c;
					return A3($author$project$Pages$Admin$ProviderGroups$viewLocationGroupModal, id, form, locationGroup);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.id;
				if (!_v2.$) {
					var locationGroup = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$ProviderGroups$HiConfirmClosed(locationGroup),
						_Utils_ap(
							($author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0) ? _List_fromArray(
								[
									$author$project$Components$HiConfirm$sentence(
									'It is currently assigned to ' + (A2(
										$author$project$Formatters$String$pluralize,
										'location',
										$author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup)) + '. Are you sure?'))
								]) : _List_Nil,
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('delete'),
									$author$project$Components$HiConfirm$noun('location group')
								])));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										$elm$html$Html$text('Location Groups')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Add new location group'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$pull(1),
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$ProviderGroups$NewLocationGroup),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Location Group')
											]))
									])),
								A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Lets you assign a group to any location')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$ProviderGroups$viewPanelBody(model)
							]))
					]))
			]),
		$G: 'Admin | Location Groups'
	};
};
var $author$project$Pages$Admin$ProviderGroups$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$ProviderGroups$init, aer: $author$project$Pages$Admin$ProviderGroups$load, agD: $author$project$Pages$Admin$ProviderGroups$save, ahd: $author$project$Pages$Admin$ProviderGroups$subscriptions, aaq: $author$project$Pages$Admin$ProviderGroups$update, ahP: $author$project$Pages$Admin$ProviderGroups$view});
var $author$project$Pages$Admin$Providers$Top$GotElationPhysicians = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GotLocations = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GotPracticeSettings = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GotSpecialties = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GotList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practitioner$Locations = 0;
var $author$project$Api$Provider$Practitioner$All$Practitioner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practitioner$All$Record = F2(
	function (specialties, locations) {
		return {S4: locations, _p: specialties};
	});
var $author$project$Api$Provider$Practitioner$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'locations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Location$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'specialties',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$All$Record)));
var $author$project$Api$Provider$Practitioner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Practitioner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$All$Practitioner)));
var $author$project$Api$Provider$Practitioner$expandToString = function (expand) {
	if (!expand) {
		return 'locations';
	} else {
		return 'practice_extras';
	}
};
var $author$project$Api$Provider$Practitioner$listDefaults = {
	pg: $elm$core$Maybe$Nothing,
	ph: $elm$core$Maybe$Nothing,
	DZ: $elm$core$Maybe$Nothing,
	Fc: _List_Nil,
	adR: $elm$core$Maybe$Nothing,
	aet: $elm$core$Maybe$Nothing,
	rj: $elm$core$Maybe$Nothing,
	Gr: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	Hc: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Provider$Practitioner$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Practitioner$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.rj;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location_group', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.aet;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.Gr;
				if (!_v4.$) {
					var bool = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'online_signup', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.pg;
				if (!_v5.$) {
					var bool = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'accepts_enrollments_from_employer', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.ph;
				if (!_v6.$) {
					var bool = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'accepts_enrollments_from_retail', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v7 = options.DZ;
				if (!_v7.$) {
					var string = _v7.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'affiliate', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v8 = options.Hc;
				if (!_v8.$) {
					var ident = _v8.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'signup_page', ident)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Practitioner$expandToString, options.Fc),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Practitioner$practitionersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practitioners']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Practitioner$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Practitioner$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$practitionersPath)));
	});
var $author$project$Pages$Admin$Providers$Top$fetchList = function (model) {
	return A3(
		$author$project$Api$Provider$Practitioner$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					Fc: _List_fromArray(
						[0]),
					afy: model.afy,
					af_: model.af_
				});
		},
		$author$project$Pages$Admin$Providers$Top$GotList);
};
var $author$project$Pages$Admin$Providers$Top$GotPracticeProviderCount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount = function (model) {
	return A3(
		$author$project$Api$Provider$Practitioner$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					afy: A2($author$project$Api$Pagination$withItemsPerPage, 1, $author$project$Api$Pagination$init)
				});
		},
		$author$project$Pages$Admin$Providers$Top$GotPracticeProviderCount);
};
var $author$project$Components$Admin$Practitioner$DeleteModal$Closed = {$: 0};
var $author$project$Components$Admin$Practitioner$DeleteModal$init = $author$project$Components$Admin$Practitioner$DeleteModal$Closed;
var $author$project$Api$Provider$ElationPhysician$All$ElationPhysician = $elm$core$Basics$identity;
var $author$project$Api$Provider$ElationPhysician$All$AllRecord = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$ElationPhysician$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationPhysician$All$AllRecord)));
var $author$project$Api$Provider$ElationPhysician$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ElationPhysician$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Practitioner$ElationPhysician$elationPhysiciansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['elation_physicians']),
	$author$project$Api$Provider$Practitioner$practitionersPath);
var $author$project$Api$Provider$Practitioner$ElationPhysician$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ElationPhysician$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$ElationPhysician$elationPhysiciansPath));
	});
var $author$project$Api$Provider$Specialty$All$Specialty = $elm$core$Basics$identity;
var $author$project$Api$Provider$Specialty$Shared$Specialty = $elm$core$Basics$identity;
var $author$project$Api$Provider$Specialty$Shared$Record = function (name) {
	return {zh: name};
};
var $author$project$Api$Provider$Specialty$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Specialty$Shared$Record));
var $author$project$Api$Provider$Specialty$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Specialty$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Specialty$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Specialty$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Specialty$specialtiesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['specialties']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Specialty$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Specialty$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Specialty$specialtiesPath));
	});
var $author$project$Api$Provider$PracticeSettings$One$PracticeSettings = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeSettings$One$Record = function (showNpi) {
	return {ZU: showNpi};
};
var $author$project$Api$Provider$PracticeSettings$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'show_npi',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeSettings$One$Record));
var $author$project$Api$Provider$PracticeSettings$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeSettings$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeSettings$practiceSettingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice/settings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticeSettings$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticeSettings$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeSettings$practiceSettingsPath));
	});
var $author$project$Pages$Admin$Providers$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var rawUrl = _v0.af3;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			aU: $elm$core$Maybe$Nothing,
			D5: shared.D5,
			h7: $author$project$Components$Admin$Practitioner$DeleteModal$init,
			ic: $elm$core$Maybe$Nothing,
			dN: $elm$core$Set$empty,
			Nq: $elm$core$Set$empty,
			xk: $author$project$Api$Data$Loading,
			FR: $author$project$Shared$isHintAdmin(shared),
			FU: $elm$core$Maybe$Nothing,
			iZ: $author$project$Api$Data$Loading,
			mS: $author$project$Components$LinkedRecords$init,
			S4: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			r9: $elm$core$Maybe$Nothing,
			sa: $author$project$Api$Data$Loading,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			_p: $author$project$Api$Data$Loading,
			aav: rawUrl
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Providers$Top$fetchList(model),
						$author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model),
						A3($author$project$Api$Provider$Location$list, shared.D5, $elm$core$Basics$identity, $author$project$Pages$Admin$Providers$Top$GotLocations),
						A2($author$project$Api$Provider$Specialty$list, shared.D5, $author$project$Pages$Admin$Providers$Top$GotSpecialties),
						A2($author$project$Api$Provider$Practitioner$ElationPhysician$list, shared.D5, $author$project$Pages$Admin$Providers$Top$GotElationPhysicians),
						A2($author$project$Api$Provider$PracticeSettings$retrieve, shared.D5, $author$project$Pages$Admin$Providers$Top$GotPracticeSettings)
					])));
	});
var $author$project$Pages$Admin$Providers$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Providers$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Providers$Top$CancelAddLocation = {$: 23};
var $author$project$Pages$Admin$Providers$Top$CancelEdit = {$: 8};
var $author$project$Pages$Admin$Providers$Top$DeleteModalMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Providers$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Admin$Practitioner$DeleteModal$CloseModal = {$: 0};
var $author$project$Components$Admin$Practitioner$DeleteModal$subscriptions = function (modal) {
	if (modal.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Practitioner$DeleteModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Admin$Providers$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg,
				$author$project$Components$LinkedRecords$subscriptions(model.mS)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Providers$Top$DeleteModalMsg,
				$author$project$Components$Admin$Practitioner$DeleteModal$subscriptions(model.h7)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Providers$Top$CancelAddLocation)),
					model.aU)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Providers$Top$CancelEdit)),
					model.FU)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Providers$Top$HiConfirmClosed),
					model.ic))
			]));
};
var $author$project$Pages$Admin$Providers$Top$Deleted = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$FormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Providers$Top$LocationAdded = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Photo = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$PracticeSettingsUpdated = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Admin$Providers$Top$SearchInputMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Api$Provider$Practitioner$practitionerPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Practitioner$practitionersPath);
};
var $author$project$Api$Provider$Practitioner$Location$locationsPath = function (practitionerId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['locations']),
		$author$project$Api$Provider$Practitioner$practitionerPath(practitionerId));
};
var $author$project$Api$Provider$Practitioner$Location$create = F4(
	function (apiClient, practitionerId, id, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'location',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(id))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Location$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Practitioner$Location$locationsPath(practitionerId))));
	});
var $author$project$Api$Provider$Practitioner$delete = F4(
	function (apiClient, id_, reassignToPractitioner, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				function () {
					if (!reassignToPractitioner.$) {
						var string = reassignToPractitioner.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'reassign_to_practitioner_id', string)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Practitioner$practitionerPath(id_))));
	});
var $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromEmployer = function (_v0) {
	var record = _v0;
	return record.pg;
};
var $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromEmployer = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromEmployer(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromRetail = function (_v0) {
	var record = _v0;
	return record.ph;
};
var $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromRetail = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromRetail(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$autoDetermineOnlineSignupVisibilityFromPanelSize = function (_v0) {
	var record = _v0;
	return record.JE;
};
var $author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$autoDetermineOnlineSignupVisibilityFromPanelSize(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$bio = function (_v0) {
	var record = _v0;
	return record.J2;
};
var $author$project$Api$Provider$Practitioner$All$bio = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$bio(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$education = function (_v0) {
	var record = _v0;
	return record.Oc;
};
var $author$project$Api$Provider$Practitioner$All$education = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$education(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$elationPhysicianId = function (_v0) {
	var record = _v0;
	return record.Oh;
};
var $author$project$Api$Provider$Practitioner$All$elationPhysicianId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$elationPhysicianId(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$Practitioner$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$email(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$gender = function (_v0) {
	var record = _v0;
	return record.PO;
};
var $author$project$Api$Provider$Practitioner$All$gender = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$gender(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$genderOther = function (_v0) {
	var record = _v0;
	return record.PQ;
};
var $author$project$Api$Provider$Practitioner$All$genderOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$genderOther(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$isProvider = function (_v0) {
	var record = _v0;
	return record.R1;
};
var $author$project$Api$Provider$Practitioner$All$isProvider = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$isProvider(shared);
};
var $author$project$Api$Provider$Practitioner$All$locations = function (_v0) {
	var record = _v0.b;
	return record.S4;
};
var $author$project$Api$Provider$Practitioner$Shared$maxPatientAge = function (_v0) {
	var record = _v0;
	return record.Tq;
};
var $author$project$Api$Provider$Practitioner$All$maxPatientAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$maxPatientAge(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Api$Provider$Practitioner$All$meta = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$meta(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$minPatientAge = function (_v0) {
	var record = _v0;
	return record.T$;
};
var $author$project$Api$Provider$Practitioner$All$minPatientAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$minPatientAge(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Practitioner$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$name(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$npi = function (_v0) {
	var record = _v0;
	return record.UP;
};
var $author$project$Api$Provider$Practitioner$All$npi = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$npi(shared);
};
var $author$project$Api$Provider$Npi$Shared$number = function (_v0) {
	var record = _v0;
	return record.Gj;
};
var $author$project$Api$Provider$Practitioner$Shared$onlineSignupVisibility = function (_v0) {
	var record = _v0;
	return record.U8;
};
var $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$onlineSignupVisibility(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$panelSize = function (_v0) {
	var record = _v0;
	return record.Vv;
};
var $author$project$Api$Provider$Practitioner$All$panelSize = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$panelSize(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$panelSizeLimit = function (_v0) {
	var record = _v0;
	return record.Vw;
};
var $author$project$Api$Provider$Practitioner$All$panelSizeLimit = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$panelSizeLimit(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$photoUrl = function (_v0) {
	var record = _v0;
	return record.Wk;
};
var $author$project$Api$Provider$Practitioner$All$photoUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$photoUrl(shared);
};
var $author$project$Api$Provider$Practitioner$All$specialties = function (_v0) {
	var record = _v0.b;
	return record._p;
};
var $author$project$Api$Provider$Practitioner$Shared$syncedPatientsCount = function (_v0) {
	var record = _v0;
	return record.$l;
};
var $author$project$Api$Provider$Practitioner$All$syncedPatientsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$syncedPatientsCount(shared);
};
var $author$project$Pages$Admin$Providers$Top$formFieldsFromItem = function (item) {
	var locationsList = A2(
		$author$project$Api$Expandable$withDefault,
		_List_Nil,
		$author$project$Api$Provider$Practitioner$All$locations(item));
	var emptyList = _List_fromArray(
		['']);
	var locations = $elm$core$List$isEmpty(locationsList) ? emptyList : A2(
		$elm$core$List$map,
		function (location) {
			return $author$project$Api$Provider$Location$Shared$id(location);
		},
		locationsList);
	var specialties = $elm$core$List$isEmpty(
		$author$project$Api$Provider$Practitioner$All$specialties(item)) ? emptyList : $author$project$Api$Provider$Practitioner$All$specialties(item);
	var education = $elm$core$List$isEmpty(
		$author$project$Api$Provider$Practitioner$All$education(item)) ? emptyList : $author$project$Api$Provider$Practitioner$All$education(item);
	return {
		pg: $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromEmployer(item),
		ph: $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromRetail(item),
		JE: $author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize(item),
		J2: $author$project$Api$Provider$Practitioner$All$bio(item),
		p6: $author$project$Api$Provider$Practitioner$All$photoUrl(item),
		Oc: education,
		Oh: $author$project$Api$Provider$Practitioner$All$elationPhysicianId(item),
		Oo: $author$project$Api$Provider$Practitioner$All$email(item),
		PO: $author$project$Api$Provider$Practitioner$All$gender(item),
		PQ: $author$project$Api$Provider$Practitioner$All$genderOther(item),
		R1: $author$project$Api$Provider$Practitioner$All$isProvider(item),
		S4: locations,
		Tq: $author$project$Api$Provider$Practitioner$All$maxPatientAge(item),
		TU: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practitioner$All$meta(item)),
		T$: $author$project$Api$Provider$Practitioner$All$minPatientAge(item),
		zh: $author$project$Api$Provider$Practitioner$All$name(item),
		UP: $author$project$Api$Provider$Practitioner$All$isProvider(item) ? A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Npi$Shared$number,
			$author$project$Api$Provider$Practitioner$All$npi(item)) : $elm$core$Maybe$Nothing,
		U8: $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility(item),
		Vv: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practitioner$All$panelSize(item)),
		Vw: $author$project$Api$Provider$Practitioner$All$panelSizeLimit(item),
		r3: 0,
		Wk: $elm$core$Maybe$Nothing,
		_p: specialties,
		$l: $author$project$Api$Provider$Practitioner$All$syncedPatientsCount(item)
	};
};
var $author$project$Pages$Admin$Providers$Top$formFieldsInit = {
	pg: true,
	ph: true,
	JE: false,
	J2: $elm$core$Maybe$Nothing,
	p6: $elm$core$Maybe$Nothing,
	Oc: _List_fromArray(
		['']),
	Oh: $elm$core$Maybe$Nothing,
	Oo: $elm$core$Maybe$Nothing,
	PO: $elm$core$Maybe$Nothing,
	PQ: $elm$core$Maybe$Nothing,
	R1: true,
	S4: _List_fromArray(
		['']),
	Tq: $elm$core$Maybe$Nothing,
	TU: $elm$core$Maybe$Nothing,
	T$: $elm$core$Maybe$Nothing,
	zh: '',
	UP: $elm$core$Maybe$Nothing,
	U8: true,
	Vv: $elm$core$Maybe$Nothing,
	Vw: $elm$core$Maybe$Nothing,
	r3: 0,
	Wk: $elm$core$Maybe$Nothing,
	_p: _List_fromArray(
		['']),
	$l: 0
};
var $author$project$Pages$Admin$Providers$Top$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 23:
				var bool = field.a;
				return _Utils_update(
					fields,
					{pg: bool});
			case 24:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ph: bool});
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						J2: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var gender = field.a;
				return _Utils_update(
					fields,
					{
						PO: $elm$core$Maybe$Just(gender)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						PQ: $author$project$Utils$String$toMaybe(string)
					});
			case 4:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						p6: $elm$core$Maybe$Just(string),
						r3: _int,
						Wk: $elm$core$Maybe$Just(string)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Oo: $author$project$Utils$String$toMaybe(string)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						T$: $elm$core$String$toInt(string)
					});
			case 7:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Tq: $elm$core$String$toInt(string)
					});
			case 8:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						_p: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields._p)
					});
			case 9:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						S4: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields.S4)
					});
			case 11:
				return _Utils_update(
					fields,
					{
						S4: _Utils_ap(
							fields.S4,
							_List_fromArray(
								['']))
					});
			case 12:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						S4: A2($elm_community$list_extra$List$Extra$removeAt, index, fields.S4)
					});
			case 10:
				return _Utils_update(
					fields,
					{
						_p: _Utils_ap(
							fields._p,
							_List_fromArray(
								['']))
					});
			case 13:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						_p: A2($elm_community$list_extra$List$Extra$removeAt, index, fields._p)
					});
			case 14:
				var index = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						Oc: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields.Oc)
					});
			case 15:
				return _Utils_update(
					fields,
					{
						Oc: _Utils_ap(
							fields.Oc,
							_List_fromArray(
								['']))
					});
			case 16:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						Oc: A2($elm_community$list_extra$List$Extra$removeAt, index, fields.Oc)
					});
			case 17:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Oh: $author$project$Utils$String$toMaybe(string)
					});
			case 18:
				var string = field.a;
				var panelSizeLimit = $elm$core$String$toInt(string);
				var onlineSignupVisibility = function () {
					var _v1 = _Utils_Tuple3(fields.JE, fields.Vv, panelSizeLimit);
					if ((_v1.a && (!_v1.b.$)) && (!_v1.c.$)) {
						var panelSize = _v1.b.a;
						var panelSizeLimit_ = _v1.c.a;
						return _Utils_cmp(panelSize, panelSizeLimit_) < 0;
					} else {
						return fields.U8;
					}
				}();
				return _Utils_update(
					fields,
					{U8: onlineSignupVisibility, Vw: panelSizeLimit});
			case 19:
				var bool = field.a;
				var onlineSignupVisibility = function () {
					var _v2 = _Utils_Tuple2(fields.Vv, fields.Vw);
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var panelSize = _v2.a.a;
						var panelSizeLimit = _v2.b.a;
						return _Utils_cmp(panelSize, panelSizeLimit) < 0;
					} else {
						return fields.U8;
					}
				}();
				return _Utils_update(
					fields,
					{JE: bool, U8: onlineSignupVisibility});
			case 20:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						UP: $author$project$Utils$String$toMaybe(string)
					});
			case 21:
				var bool = field.a;
				return _Utils_update(
					fields,
					{U8: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{R1: !bool});
		}
	});
var $author$project$Pages$Admin$Providers$Top$NameValidation = 0;
var $author$project$Pages$Admin$Providers$Top$PhotoValidation = 2;
var $author$project$Pages$Admin$Providers$Top$maxPhotoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Pages$Admin$Providers$Top$LocationsValidation = 3;
var $author$project$Pages$Admin$Providers$Top$validateLocations = function (fields) {
	return _Utils_eq(
		fields.S4,
		_List_fromArray(
			[''])) ? _List_fromArray(
		[
			_Utils_Tuple2(3, 'Please enter at least one location.')
		]) : _List_Nil;
};
var $author$project$Pages$Admin$Providers$Top$NpiValidation = 1;
var $author$project$Utils$MetaFields$alwaysEditable = $author$project$Utils$MetaFields$Editable;
var $author$project$Utils$MetaFields$isEditable = function (editable) {
	if (!editable.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Utils$MetaFields$isUneditable = A2($elm$core$Basics$composeR, $author$project$Utils$MetaFields$isEditable, $elm$core$Basics$not);
var $ahstro$elm_luhn$Helpers$checksum = F2(
	function (checkDigit, sum) {
		return (!A2($elm$core$Basics$modBy, 10, sum + checkDigit)) ? $elm$core$Result$Ok(true) : $elm$core$Result$Err('Incorrect checksum');
	});
var $ahstro$elm_luhn$Helpers$doubleAtEvenIndices = $elm$core$List$indexedMap(
	F2(
		function (index, num) {
			return (!A2($elm$core$Basics$modBy, 2, index)) ? (num * 2) : num;
		}));
var $ahstro$elm_luhn$Helpers$keepUnder10 = function (num) {
	return (num >= 10) ? (num - 9) : num;
};
var $ahstro$elm_luhn$Helpers$notEmpty = function (nums) {
	return $elm$core$List$isEmpty(nums) ? $elm$core$Result$Err('Input string is only check digit') : $elm$core$Result$Ok(nums);
};
var $ahstro$elm_luhn$Helpers$toListOfInt = function (strings) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (numberString, acc) {
				var _v0 = $elm$core$String$toInt(numberString);
				if (!_v0.$) {
					var num = _v0.a;
					return A2(
						$elm$core$Result$map,
						$elm$core$List$cons(num),
						acc);
				} else {
					return $elm$core$Result$Err('Not a number: ' + numberString);
				}
			}),
		$elm$core$Result$Ok(_List_Nil),
		$elm$core$List$reverse(strings));
};
var $ahstro$elm_luhn$Luhn$validate = function (numberString) {
	var numbers = $ahstro$elm_luhn$Helpers$toListOfInt(
		$elm$core$List$reverse(
			A2($elm$core$String$split, '', numberString)));
	var checkDigit = A2(
		$elm$core$Result$withDefault,
		0,
		A2(
			$elm$core$Result$andThen,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Result$fromMaybe('Input string is empty'),
				$elm$core$List$head),
			numbers));
	return A2(
		$elm$core$Result$map,
		function (_v0) {
			return numberString;
		},
		A2(
			$elm$core$Result$andThen,
			$ahstro$elm_luhn$Helpers$checksum(checkDigit),
			A2(
				$elm$core$Result$map,
				$elm$core$List$sum,
				A2(
					$elm$core$Result$map,
					$elm$core$List$map($ahstro$elm_luhn$Helpers$keepUnder10),
					A2(
						$elm$core$Result$map,
						$ahstro$elm_luhn$Helpers$doubleAtEvenIndices,
						A2(
							$elm$core$Result$andThen,
							$ahstro$elm_luhn$Helpers$notEmpty,
							A2(
								$elm$core$Result$andThen,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Result$fromMaybe('Input string is empty'),
									$elm$core$List$tail),
								numbers)))))));
};
var $ahstro$elm_luhn$Luhn$isValid = function (numberString) {
	var _v0 = $ahstro$elm_luhn$Luhn$validate(numberString);
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Practitioner$Meta$npi = function (_v0) {
	var fields = _v0;
	return fields.UP;
};
var $author$project$Pages$Admin$Providers$Top$validateNpi = function (fields) {
	var npiValidationMessage = _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please enter a valid npi.')
		]);
	var editable = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$MetaFields$alwaysEditable,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Meta$npi, fields.TU));
	var _v0 = _Utils_Tuple2(
		fields.UP,
		$author$project$Utils$MetaFields$isUneditable(editable));
	if (!_v0.b) {
		if (!_v0.a.$) {
			var npi = _v0.a.a;
			return (($elm$core$String$length(npi) === 10) && $ahstro$elm_luhn$Luhn$isValid('80840' + npi)) ? _List_Nil : npiValidationMessage;
		} else {
			var _v1 = _v0.a;
			return fields.R1 ? npiValidationMessage : _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Admin$Providers$Top$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Providers$Top$validateNpi),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Providers$Top$validateLocations),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.r3;
			},
			$author$project$Pages$Admin$Providers$Top$maxPhotoBytesSize,
			_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
		]));
var $author$project$Pages$Admin$Providers$Top$hasMoreThanOnePracticeProvider = F2(
	function (model, practitioners) {
		var _v0 = model.r9;
		if (!_v0.$) {
			var count = _v0.a;
			return count > 1;
		} else {
			return $elm$core$List$length(practitioners) > 1;
		}
	});
var $author$project$Api$Provider$Practitioner$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Practitioner$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$id(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$isSynced = function (_v0) {
	var record = _v0;
	return record.Sa;
};
var $author$project$Api$Provider$Practitioner$All$isSynced = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$isSynced(shared);
};
var $author$project$Api$Provider$Practitioner$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Practitioner$Shared$name(shared);
};
var $author$project$Components$Admin$Practitioner$DeleteModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Practitioner$DeleteModal$Reassign = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$Practitioner$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Practitioner$list = $author$project$Api$Provider$Practitioner$list;
var $author$project$Api$Provider$Practitioner$Shared$affiliation = function (_v0) {
	var record = _v0;
	return record.IJ;
};
var $author$project$Api$Provider$Practitioner$All$affiliation = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$affiliation(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$isMaster = function (_v0) {
	var record = _v0;
	return record.RQ;
};
var $author$project$Api$Provider$Practitioner$All$isMaster = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$isMaster(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$openingsSize = function (_v0) {
	var record = _v0;
	return record.Vb;
};
var $author$project$Api$Provider$Practitioner$All$openingsSize = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$openingsSize(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$practiceName = function (_v0) {
	var record = _v0;
	return record.afQ;
};
var $author$project$Api$Provider$Practitioner$All$practiceName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$practiceName(shared);
};
var $author$project$Api$Provider$Practitioner$Shared$practitionerType = function (_v0) {
	var record = _v0;
	return record.WP;
};
var $author$project$Api$Provider$Practitioner$All$practitionerType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practitioner$Shared$practitionerType(shared);
};
var $author$project$Components$ResourceFilter$Practitioner$resourceFromAll = function (practitioner) {
	return {
		IJ: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Practitioner$All$affiliation(practitioner)),
		adR: $author$project$Api$Provider$Practitioner$All$id(practitioner),
		RQ: $author$project$Api$Provider$Practitioner$All$isMaster(practitioner),
		Sa: $author$project$Api$Provider$Practitioner$All$isSynced(practitioner),
		zh: $author$project$Api$Provider$Practitioner$All$name(practitioner),
		Vb: $author$project$Api$Provider$Practitioner$All$openingsSize(practitioner),
		afQ: $author$project$Api$Provider$Practitioner$All$practiceName(practitioner),
		WP: $author$project$Api$Provider$Practitioner$All$practitionerType(practitioner)
	};
};
var $author$project$Components$ResourceFilter$Practitioner$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Practitioner$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Practitioner$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Practitioner$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Practitioner$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Practitioner$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Practitioner$selectId = 'practitioners';
var $author$project$Components$ResourceFilter$Practitioner$openings = function (resource) {
	var _v0 = resource.Vb;
	if (!_v0.$) {
		if (!_v0.a) {
			return 'Full';
		} else {
			var size = _v0.a;
			return A2($author$project$Formatters$String$pluralize, 'opening', size);
		}
	} else {
		return 'No panel limit';
	}
};
var $author$project$Components$ResourceFilter$Practitioner$panelLimit = function (resource) {
	var _v0 = resource.Vb;
	if (!_v0.$) {
		if (!_v0.a) {
			return 'No Slots';
		} else {
			var size = _v0.a;
			return $elm$core$String$fromInt(size) + ' Slots';
		}
	} else {
		return 'No limit';
	}
};
var $author$project$Components$ResourceFilter$Practitioner$extraText = function (resource) {
	var practitionerType_ = resource.WP;
	var practiceName_ = resource.afQ;
	return ($elm$core$String$isEmpty(practiceName_) && $elm$core$String$isEmpty(practitionerType_)) ? $elm$core$Maybe$Just(
		$author$project$Components$ResourceFilter$Practitioner$openings(resource)) : $elm$core$Maybe$Just(
		practitionerType_ + (' | ' + (A2($elm$core$String$left, 50, practiceName_) + (' [ ' + ($author$project$Components$ResourceFilter$Practitioner$panelLimit(resource) + ' ]')))));
};
var $author$project$Components$ResourceFilter$Practitioner$toTitle = function ($) {
	return $.zh;
};
var $author$project$Components$ResourceFilter$Practitioner$toLabel = function (resource) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceX2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceX2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$ResourceFilter$Practitioner$toTitle(resource))
								])),
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									resource.RQ ? $author$project$Components$SyncedIcon$view(
									_List_fromArray(
										[
											$author$project$Components$SyncedIcon$master,
											$author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
										])) : $elm$html$Html$text(''),
									resource.Sa ? $author$project$Components$SyncedIcon$view(
									_List_fromArray(
										[
											$author$project$Components$SyncedIcon$synced,
											$author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
										])) : $elm$html$Html$text('')
								]))
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						function (info) {
							return A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$small]),
								_List_fromArray(
									[
										$elm$html$Html$text(info)
									]));
						},
						$author$project$Components$ResourceFilter$Practitioner$extraText(resource)))
				]))
		]);
};
var $author$project$Components$ResourceFilter$Practitioner$toValue = function ($) {
	return $.adR;
};
var $author$project$Components$ResourceFilter$Practitioner$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$Practitioner$fetchResources(listOptionals),
				adR: $author$project$Components$ResourceFilter$Practitioner$selectId,
				gx: 'Provider',
				st: $author$project$Components$ResourceFilter$Practitioner$retrieveResource(listOptionals),
				ahw: $author$project$Components$ResourceFilter$Practitioner$toLabel,
				ahA: $author$project$Components$ResourceFilter$Practitioner$toTitle,
				g0: $author$project$Components$ResourceFilter$Practitioner$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$open = F4(
	function (apiClient, practitioner, hasSyncedPatients, hasMoreThanOnePractitioner) {
		var action = $author$project$Components$Admin$Practitioner$DeleteModal$Reassign($elm$core$Maybe$Nothing);
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{
						D0: 'Choose a practitioner...',
						ac6: $elm$core$Maybe$Just(
							$author$project$Api$Provider$Practitioner$All$id(practitioner))
					});
			});
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		var localState = {DV: action, xN: hasMoreThanOnePractitioner, Fv: hasSyncedPatients, afS: practitioner, jC: practitionerResourceFilter, so: $author$project$Api$Data$NotAsked};
		return _Utils_Tuple2(
			$author$project$Components$Admin$Practitioner$DeleteModal$Open(localState),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd));
	});
var $author$project$Pages$Admin$Providers$Top$Created = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$Practitioner$One$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practitioner$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Gender$toString = function (gender) {
	switch (gender) {
		case 0:
			return 'male';
		case 1:
			return 'female';
		case 2:
			return 'intersex';
		default:
			return 'other';
	}
};
var $author$project$Api$Gender$encode = function (gender) {
	return A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$Gender$toString)(gender);
};
var $author$project$Api$Provider$Practitioner$create = F3(
	function (apiClient, fields, toMsg) {
		var photo_ = function () {
			var _v1 = fields.Wj;
			if (!_v1.$) {
				var base64 = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'photo',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var npi_ = function () {
			var _v0 = fields.UP;
			if (!_v0.$) {
				var number = _v0.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'number',
							$elm$json$Json$Encode$string(number))
						]));
			} else {
				return $elm$json$Json$Encode$null;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practitioner',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'accepts_enrollments_from_employer',
									$elm$json$Json$Encode$bool(fields.pg)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'accepts_enrollments_from_retail',
										$elm$json$Json$Encode$bool(fields.ph)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'min_patient_age',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.T$)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'max_patient_age',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Tq)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'panel_size_limit',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Vw)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'auto_determine_online_signup_visibility_from_panel_size',
														$elm$json$Json$Encode$bool(fields.JE)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'elation_physician_id',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oh)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'email',
																A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oo)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'bio',
																	A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.J2)),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'gender',
																		A2($author$project$Utils$Encode$nullable, $author$project$Api$Gender$encode, fields.PO)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'gender_other',
																			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.PQ)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'education',
																				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.Oc)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'specialties',
																					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields._p)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'locations',
																						A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.S4)),
																					A2(
																						$elm$core$List$cons,
																						_Utils_Tuple2('npi', npi_),
																						A2(
																							$elm$core$List$cons,
																							_Utils_Tuple2(
																								'online_signup_visibility',
																								$elm$json$Json$Encode$bool(fields.U8)),
																							A2(
																								$elm$core$List$cons,
																								_Utils_Tuple2(
																									'is_provider',
																									$elm$json$Json$Encode$bool(fields.R1)),
																								photo_))))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practitioner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$practitionersPath)));
	});
var $author$project$Pages$Admin$Providers$Top$practitionerFromFields = function (fields) {
	return {
		pg: fields.pg,
		ph: fields.ph,
		JE: fields.JE,
		J2: fields.J2,
		Oc: fields.Oc,
		Oh: fields.Oh,
		Oo: fields.Oo,
		PO: fields.PO,
		PQ: fields.PQ,
		R1: fields.R1,
		S4: fields.S4,
		Tq: fields.Tq,
		T$: fields.T$,
		zh: fields.zh,
		UP: fields.R1 ? fields.UP : $elm$core$Maybe$Nothing,
		U8: fields.U8,
		Vw: fields.Vw,
		Wj: fields.Wk,
		_p: fields._p
	};
};
var $author$project$Pages$Admin$Providers$Top$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practitioner$create,
			apiClient,
			$author$project$Pages$Admin$Providers$Top$practitionerFromFields(fields),
			$author$project$Pages$Admin$Providers$Top$Created);
	});
var $author$project$Pages$Admin$Providers$Top$Updated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$Practitioner$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var photo_ = function () {
			var _v1 = fields.Wj;
			if (!_v1.$) {
				var base64 = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'photo',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var npi_ = function () {
			var _v0 = fields.UP;
			if (!_v0.$) {
				var number = _v0.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'number',
							$elm$json$Json$Encode$string(number))
						]));
			} else {
				return $elm$json$Json$Encode$null;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practitioner',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'accepts_enrollments_from_employer',
									$elm$json$Json$Encode$bool(fields.pg)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'accepts_enrollments_from_retail',
										$elm$json$Json$Encode$bool(fields.ph)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'min_patient_age',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.T$)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'max_patient_age',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Tq)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'panel_size_limit',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Vw)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'auto_determine_online_signup_visibility_from_panel_size',
														$elm$json$Json$Encode$bool(fields.JE)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'elation_physician_id',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oh)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2(
																'email',
																A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oo)),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2(
																	'bio',
																	A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.J2)),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'gender',
																		A2($author$project$Utils$Encode$nullable, $author$project$Api$Gender$encode, fields.PO)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'gender_other',
																			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.PQ)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'education',
																				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.Oc)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'specialties',
																					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields._p)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'locations',
																						A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.S4)),
																					A2(
																						$elm$core$List$cons,
																						_Utils_Tuple2('npi', npi_),
																						A2(
																							$elm$core$List$cons,
																							_Utils_Tuple2(
																								'online_signup_visibility',
																								$elm$json$Json$Encode$bool(fields.U8)),
																							A2(
																								$elm$core$List$cons,
																								_Utils_Tuple2(
																									'is_provider',
																									$elm$json$Json$Encode$bool(fields.R1)),
																								photo_))))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practitioner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Practitioner$practitionerPath(id_))));
	});
var $author$project$Pages$Admin$Providers$Top$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Practitioner$update,
			apiClient,
			id,
			$author$project$Pages$Admin$Providers$Top$practitionerFromFields(fields),
			$author$project$Pages$Admin$Providers$Top$Updated);
	});
var $author$project$Pages$Admin$Providers$Top$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Pages$Admin$Providers$Top$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Pages$Admin$Providers$Top$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$Deleted = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$None = 0;
var $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerDeleted = 1;
var $author$project$Components$Admin$Practitioner$DeleteModal$isValid = function (action) {
	if (!action.$) {
		var practitionerId = action.a;
		return $author$project$Utils$Maybe$toBool(practitionerId);
	} else {
		return true;
	}
};
var $author$project$Components$ResourceFilter$Practitioner$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$update = F3(
	function (apiClient, msg, modal) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, a8: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, as: _List_Nil};
			case 2:
				var action = msg.a;
				if (modal.$ === 1) {
					var state = modal.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						a8: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
							_Utils_update(
								state,
								{DV: action, so: $author$project$Api$Data$NotAsked})),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, a8: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, as: _List_Nil};
				}
			case 1:
				if (modal.$ === 1) {
					var state = modal.a;
					if ($author$project$Components$Admin$Practitioner$DeleteModal$isValid(state.DV)) {
						var newPractitionerId = function () {
							var _v3 = state.DV;
							if (!_v3.$) {
								var practitionerId = _v3.a;
								return practitionerId;
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return {
							EC: A4(
								$author$project$Api$Provider$Practitioner$delete,
								apiClient,
								$author$project$Api$Provider$Practitioner$All$id(state.afS),
								newPractitionerId,
								$author$project$Components$Admin$Practitioner$DeleteModal$Deleted(newPractitionerId)),
							ac5: 0,
							a8: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
								_Utils_update(
									state,
									{so: $author$project$Api$Data$Loading})),
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							a8: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
								_Utils_update(
									state,
									{so: $author$project$Api$Data$NotAsked})),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, a8: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, as: _List_Nil};
				}
			case 3:
				var newPractitionerId = msg.a;
				var response = msg.b;
				if (modal.$ === 1) {
					var state = modal.a;
					switch (response.$) {
						case 3:
							var message = function () {
								if (!newPractitionerId.$) {
									var newPractitionerName = function () {
										var _v7 = state.jC.G0;
										if (!_v7.$) {
											var resource = _v7.a;
											return resource.zh;
										} else {
											return 'the selected provider';
										}
									}();
									return $elm$core$String$concat(
										_List_fromArray(
											[
												' All patients currently assigned to ',
												$author$project$Api$Provider$Practitioner$All$name(state.afS),
												' will be assigned to ',
												newPractitionerName,
												'.',
												'For large volumes of patients, this may take a few minutes behind the scenes.'
											]));
								} else {
									return '';
								}
							}();
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 1,
								a8: $author$project$Components$Admin$Practitioner$DeleteModal$Closed,
								as: _List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										$author$project$Api$Provider$Practitioner$All$name(state.afS) + (' was successfully removed.' + message)),
										$author$project$OutMsg$RefreshPractice
									])
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								a8: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
									_Utils_update(
										state,
										{so: response})),
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: 0, a8: modal, as: _List_Nil};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, a8: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, as: _List_Nil};
				}
			default:
				var subMsg = msg.a;
				if (modal.$ === 1) {
					var state = modal.a;
					var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, state.jC);
					var newAction = function () {
						var _v9 = practitionerResourceResult.ac5;
						_v9$2:
						while (true) {
							if ((!_v9.$) && (!_v9.a.$)) {
								switch (_v9.a.a.$) {
									case 0:
										var resource = _v9.a.a.a;
										return $author$project$Components$Admin$Practitioner$DeleteModal$Reassign(
											$elm$core$Maybe$Just(resource.adR));
									case 2:
										var _v10 = _v9.a.a;
										return state.DV;
									default:
										break _v9$2;
								}
							} else {
								break _v9$2;
							}
						}
						return state.DV;
					}();
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
						ac5: 0,
						a8: $author$project$Components$Admin$Practitioner$DeleteModal$Open(
							_Utils_update(
								state,
								{DV: newAction, jC: practitionerResourceResult.y8})),
						as: practitionerResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, a8: $author$project$Components$Admin$Practitioner$DeleteModal$Closed, as: _List_Nil};
				}
		}
	});
var $author$project$Api$Provider$PracticeSettings$updateShowNpi = F3(
	function (apiClient, showNpi_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_settings',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'show_npi',
								$elm$json$Json$Encode$bool(showNpi_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PracticeSettings$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeSettings$practiceSettingsPath)));
	});
var $author$project$Pages$Admin$Providers$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[model.aav.VL]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Pages$Admin$Providers$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iZ: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var response = msg.a;
				var practiceProviderCount = function () {
					if (response.$ === 3) {
						var practitioners = response.a;
						var headers = response.b;
						return $elm$core$Maybe$Just(
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$List$length(practitioners),
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$String$toInt,
									A2($elm$core$Dict$get, 'x-total-count', headers))));
					} else {
						return model.r9;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{r9: practiceProviderCount}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_p: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{xk: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sa: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 6:
				var formFields = $author$project$Pages$Admin$Providers$Top$formFieldsInit;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var item = msg.a;
				var formFields = $author$project$Pages$Admin$Providers$Top$formFieldsFromItem(item);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Practitioner$All$id(item)),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var photos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v3) {
							var task = _v3.a;
							var size = _v3.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Pages$Admin$Providers$Top$FormUpdated,
									$author$project$Pages$Admin$Providers$Top$Photo(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (photo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(photo),
									$elm$file$File$size(photo));
							},
							$elm$core$List$head(photos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 10:
				var field = msg.a;
				var _v4 = model.FU;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var id = _v5.a;
					var form = _v5.b;
					var item = _v5.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Providers$Top$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var form = msg.a;
				var id = msg.b;
				var _v6 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Providers$Top$formFieldsValidator, form);
				if (!_v6.$) {
					var _v7 = _v6.a;
					var validatedForm = _v7.a;
					var validFormFields = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Admin$Providers$Top$saveItem, model.D5, id, validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v6.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var item = msg.a;
				var practitioners = msg.b;
				var hasMoreThanOnePractitioner = A2($author$project$Pages$Admin$Providers$Top$hasMoreThanOnePracticeProvider, model, practitioners);
				if ((!hasMoreThanOnePractitioner) && (!(!$author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(model.WF)))) {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'Practice collects practitioners during signup. Can\'t delete last one.')
							]));
				} else {
					if ($author$project$Api$Provider$Practitioner$All$isSynced(item)) {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 2, 'This provider is currently part of an affiliation. Please contact Hint to unlink this provider prior to deletion.')
								]));
					} else {
						var fields = $author$project$Pages$Admin$Providers$Top$formFieldsFromItem(item);
						var hasSyncedPatients = fields.$l > 0;
						var _v8 = A4($author$project$Components$Admin$Practitioner$DeleteModal$open, model.D5, item, hasSyncedPatients, hasMoreThanOnePractitioner);
						var deleteModal = _v8.a;
						var deleteModalCmd = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{h7: deleteModal}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$DeleteModalMsg, deleteModalCmd),
							_List_Nil);
					}
				}
			case 13:
				var response = msg.a;
				var _v9 = model.FU;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Providers$Top$fetchList(model),
										$author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
									])),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Practitioner$One$name(item)),
									$author$project$OutMsg$RefreshPractice
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var response = msg.a;
				var _v12 = model.FU;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						var item = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading}),
							$author$project$Pages$Admin$Providers$Top$fetchList(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Practitioner$One$name(item) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$Practitioner$All$id(item),
										model.dN),
									iZ: $author$project$Api$Data$Loading
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Providers$Top$fetchList(model),
										$author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
									])),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Practitioner$All$name(item) + ' was successfully removed.'),
									$author$project$OutMsg$RefreshPractice
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$Practitioner$All$id(item),
										model.dN)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aU: $elm$core$Maybe$Just(
								_Utils_Tuple3(item, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 20:
				var string = msg.a;
				var _v16 = model.aU;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var item = _v17.a;
					var request = _v17.c;
					var locationId = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aU: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, locationId, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 21:
				var _v18 = model.aU;
				if ((!_v18.$) && (!_v18.a.b.$)) {
					var _v19 = _v18.a;
					var item = _v19.a;
					var locationId = _v19.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aU: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										item,
										$elm$core$Maybe$Just(locationId),
										$author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Api$Provider$Practitioner$Location$create,
							model.D5,
							$author$project$Api$Provider$Practitioner$All$id(item),
							locationId,
							$author$project$Pages$Admin$Providers$Top$LocationAdded),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 22:
				var response = msg.a;
				var _v20 = model.aU;
				if ((!_v20.$) && (!_v20.a.b.$)) {
					var _v21 = _v20.a;
					var item = _v21.a;
					var locationId = _v21.b.a;
					switch (response.$) {
						case 3:
							var location = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{aU: $elm$core$Maybe$Nothing, iZ: $author$project$Api$Data$Loading}),
								$author$project$Pages$Admin$Providers$Top$fetchList(model),
								_List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										$author$project$Api$Provider$Location$One$name(location) + (' was successfully added to ' + ($author$project$Api$Provider$Practitioner$All$name(item) + '.')))
									]));
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aU: $elm$core$Maybe$Just(
											_Utils_Tuple3(
												item,
												$elm$core$Maybe$Just(locationId),
												response))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$Practitioner$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ic: $elm$core$Maybe$Nothing,
								dN: A2($elm$core$Set$insert, id, model.dN)
							}),
						A4(
							$author$project$Api$Provider$Practitioner$delete,
							model.D5,
							id,
							$elm$core$Maybe$Nothing,
							$author$project$Pages$Admin$Providers$Top$Deleted(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 17:
				var subMsg = msg.a;
				var _v23 = A3($author$project$Components$LinkedRecords$update, model.D5, subMsg, model.mS);
				var linkedRecords = _v23.a;
				var subCmd = _v23.b;
				var subOutMsg = _v23.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mS: linkedRecords}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg, subCmd),
					subOutMsg);
			case 18:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$Practitioner$DeleteModal$update, model.D5, subMsg, model.h7);
				var _v24 = function () {
					var _v25 = result.ac5;
					if (_v25 === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{iZ: $author$project$Api$Data$Loading}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Providers$Top$fetchList(model),
										$author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v24.a;
				var cmd = _v24.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{h7: result.a8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$DeleteModalMsg, result.EC)
							])),
					result.as);
			case 24:
				var bool = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Provider$PracticeSettings$updateShowNpi, model.D5, bool, $author$project$Pages$Admin$Providers$Top$PracticeSettingsUpdated),
					_List_Nil);
			case 25:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{iZ: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Providers$Top$fetchList(newModel),
								$author$project$Pages$Admin$Providers$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 26:
				var subMsg = msg.a;
				var _v26 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v26.a;
				var searchInputCmd = _v26.b;
				var searchInputEvent = _v26.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v27 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								iZ: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Providers$Top$fetchList(qModel),
										$author$project$Pages$Admin$Providers$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v27.a;
				var cmd = _v27.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var newModel = _Utils_update(
						model,
						{sa: response});
					var message = 'Your practice has been updated';
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, message)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Providers$Top$New = {$: 6};
var $author$project$Pages$Admin$Providers$Top$PaginationMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Admin$Practitioner$DeleteModal$Delete = {$: 1};
var $author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment = {$: 1};
var $author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$Practitioner$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$ResourceFilter$Practitioner$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Admin$Practitioner$DeleteModal$viewModal = function (state) {
	var action = state.xN ? state.DV : $author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment;
	var _v0 = function () {
		if (!action.$) {
			return _Utils_Tuple2(true, false);
		} else {
			return _Utils_Tuple2(false, true);
		}
	}();
	var reassignActive = _v0.a;
	var removeAssignmentActive = _v0.b;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$Practitioner$DeleteModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('What would you like to do with patients assigned to this provider?')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Action'),
								$author$project$Ui$Form$Group$labelSpan(2),
								$author$project$Ui$Form$Group$inputSpan(10)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Reassign to a different provider'},
										_List_fromArray(
											[
												$author$project$Ui$Button$active(reassignActive),
												$author$project$Ui$Button$disabled(!state.xN),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction(
													$author$project$Components$Admin$Practitioner$DeleteModal$Reassign($elm$core$Maybe$Nothing)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reassign')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Remove assignment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$active(removeAssignmentActive),
												$author$project$Ui$Button$disabled(state.Fv),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction($author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Remove assignment')
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pt-05')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												function () {
												if (!action.$) {
													return $elm$html$Html$text(
														'All patients currently assigned to ' + ($author$project$Api$Provider$Practitioner$All$name(state.afS) + ' will be assigned to the provider selected below'));
												} else {
													return $elm$html$Html$text(
														'All patients currently assigned to ' + ($author$project$Api$Provider$Practitioner$All$name(state.afS) + ' will no longer be assigned to a provider'));
												}
											}()
											]))
									])),
								function () {
								if (!action.$) {
									var invalidPractitioner = function () {
										var _v4 = $author$project$Components$ResourceFilter$Practitioner$value(state.jC);
										if (!_v4.$) {
											return false;
										} else {
											return true;
										}
									}();
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pt-05')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Practitioner$view,
													_List_fromArray(
														[
															invalidPractitioner ? $author$project$Components$ResourceFilter$errors(
															_List_fromArray(
																['Please pick a provider for reassignment'])) : $author$project$Components$ResourceFilter$errors(_List_Nil)
														]),
													state.jC))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Practitioner$DeleteModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Delete provider'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(state.so, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Admin$Practitioner$DeleteModal$Delete),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete')
							]))
					]))
			]));
};
var $author$project$Components$Admin$Practitioner$DeleteModal$view = function (modal) {
	if (modal.$ === 1) {
		var state = modal.a;
		return $author$project$Components$Admin$Practitioner$DeleteModal$viewModal(state);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Providers$Top$LocationSelected = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Admin$Providers$Top$SaveLocation = {$: 21};
var $author$project$Pages$Admin$Providers$Top$locationOptions = F2(
	function (practitioner, locations) {
		var practitionerLocationIds = A2(
			$elm$core$List$map,
			$author$project$Api$Provider$Location$Shared$id,
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$Practitioner$All$locations(practitioner)));
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Pick a location'),
			A2(
				$elm$core$List$map,
				function (location) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Location$All$id(location)),
						$author$project$Api$Provider$Location$All$name(location));
				},
				A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (location) {
						return A2(
							$elm$core$List$member,
							$author$project$Api$Provider$Location$All$id(location),
							practitionerLocationIds);
					},
					locations)));
	});
var $author$project$Pages$Admin$Providers$Top$viewAddLocationModal = F4(
	function (model, item, locationId, request) {
		var _v0 = function () {
			var _v1 = model.S4;
			if (_v1.$ === 3) {
				var locations_ = _v1.a;
				return _Utils_Tuple2(false, locations_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var locationLoading = _v0.a;
		var locations = _v0.b;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Admin$Providers$Top$CancelAddLocation,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(
							'Add location to ' + $author$project$Api$Provider$Practitioner$All$name(item))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							if ($elm$core$List$isEmpty(locations)) {
								return A2(
									$author$project$Ui$Alert$warning,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have no locations, '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Admin__Locations,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('add them here first')
												]))
										]));
							} else {
								var invalid = !$author$project$Utils$Maybe$toBool(locationId);
								return A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(locationId),
											$author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$Providers$Top$LocationSelected),
											$author$project$Ui$Form$Select$invalid(invalid),
											$author$project$Ui$Form$Select$loading(locationLoading)
										]),
									A2($author$project$Pages$Admin$Providers$Top$locationOptions, item, locations));
							}
						}()
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$CancelAddLocation)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add location'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$SaveLocation),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add')
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Save = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Api$Provider$Practitioner$Meta$bio = function (_v0) {
	var fields = _v0;
	return fields.J2;
};
var $author$project$Api$Provider$Practitioner$Meta$education = function (_v0) {
	var fields = _v0;
	return fields.Oc;
};
var $author$project$Api$Provider$Practice$Shared$elationEnabled = function (_v0) {
	var record = _v0;
	return record.Og;
};
var $author$project$Api$Provider$Practice$One$elationEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$elationEnabled(shared);
};
var $author$project$Api$Provider$Practitioner$Meta$email = function (_v0) {
	var fields = _v0;
	return fields.Oo;
};
var $author$project$Api$Provider$Practitioner$Meta$gender = function (_v0) {
	var fields = _v0;
	return fields.PO;
};
var $author$project$Api$Provider$Practitioner$Meta$locations = function (_v0) {
	var fields = _v0;
	return fields.S4;
};
var $author$project$Api$Provider$Practitioner$Meta$name = function (_v0) {
	var fields = _v0;
	return fields.zh;
};
var $author$project$Api$Provider$Practitioner$Meta$panelSizeLimit = function (_v0) {
	var fields = _v0;
	return fields.Vw;
};
var $author$project$Api$Provider$Practitioner$Meta$photo = function (_v0) {
	var fields = _v0;
	return fields.Wj;
};
var $author$project$Api$Provider$Practitioner$Meta$specialtyNames = function (_v0) {
	var fields = _v0;
	return fields._q;
};
var $author$project$Api$Provider$Practitioner$Meta$treatsAge = function (_v0) {
	var fields = _v0;
	return fields.aab;
};
var $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromEmployer = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromRetail = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewAcceptsEnrollmentsForm = F2(
	function (acceptsEnrollmentsFromEmployer, acceptsEnrollmentsFromRetail) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$inputSpan(9),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$label('Accepting Enrollments From')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(acceptsEnrollmentsFromEmployer),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromEmployer))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Employer')
						])),
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(acceptsEnrollmentsFromRetail),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromRetail))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Retail')
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Bio = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$MetaFields$explanation = function (metaField) {
	if (!metaField.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var explanation_ = metaField.a;
		return explanation_;
	}
};
var $author$project$Pages$Admin$Providers$Top$withinTooltipIf = F2(
	function (maybeExplanation, content) {
		if (!maybeExplanation.$) {
			var explanation = maybeExplanation.a;
			return A3(
				$author$project$Ui$Tooltip$view,
				_List_Nil,
				explanation,
				_List_fromArray(
					[content]));
		} else {
			return content;
		}
	});
var $author$project$Pages$Admin$Providers$Top$viewBio = F2(
	function (bio, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Bio')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$value(
								A2($elm$core$Maybe$withDefault, '', bio)),
								$author$project$Ui$Form$Textarea$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Bio)),
								$author$project$Ui$Form$Textarea$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$AddEducation = {$: 15};
var $author$project$Pages$Admin$Providers$Top$Education = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$RemoveEducation = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewEducation = F4(
	function (educations, editable, index, education) {
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(educations) - 1);
		var isFirst = !index;
		var label = isFirst ? 'Education' : '';
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(label)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(education),
										$author$project$Ui$Form$Input$onInput(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Admin$Providers$Top$FormUpdated,
											$author$project$Pages$Admin$Providers$Top$Education(index))),
										$author$project$Ui$Form$Input$placeholder('Stanford Medical School'),
										$author$project$Ui$Form$Input$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									]))),
							($elm$core$List$length(educations) > 1) ? A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A3(
								$author$project$Ui$Button$view,
								{abp: 'Remove education'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$Providers$Top$FormUpdated(
											$author$project$Pages$Admin$Providers$Top$RemoveEducation(index))),
										$author$project$Ui$Button$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$minus)
									]),
								_List_Nil)) : $author$project$Utils$Html$empty,
							isLast ? A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A3(
								$author$project$Ui$Button$view,
								{abp: 'Add education'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddEducation)),
										$author$project$Ui$Button$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_Nil)) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$ElationPhysicianId = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$ElationPhysician$All$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$ElationPhysician$All$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Pages$Admin$Providers$Top$elationPhysicianOptions = function (elationPhysicians) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'None'),
		A2(
			$elm$core$List$map,
			function (elationPhysician) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$ElationPhysician$All$id(elationPhysician)),
					$author$project$Api$Provider$ElationPhysician$All$name(elationPhysician));
			},
			elationPhysicians));
};
var $author$project$Pages$Admin$Providers$Top$viewElationSync = F2(
	function (elationPhysicianId, elationPhysicians) {
		var _v0 = function () {
			if (elationPhysicians.$ === 3) {
				var physicians = elationPhysicians.a;
				return _Utils_Tuple2(false, physicians);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var elationPhysiciansLoading = _v0.a;
		var elationPhysicians_ = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Elation Sync')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(elationPhysicianId),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$ElationPhysicianId)),
							$author$project$Ui$Form$Select$disabled(
							$elm$core$List$isEmpty(elationPhysicians_)),
							$author$project$Ui$Form$Select$loading(elationPhysiciansLoading)
						]),
					$author$project$Pages$Admin$Providers$Top$elationPhysicianOptions(elationPhysicians_))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Email = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewEmail = F2(
	function (email, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Email')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', email)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Email)),
								$author$project$Ui$Form$Input$placeholder('dr.mccoy@example.com'),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Gender = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Providers$Top$GenderOther = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Gender$Disabled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Gender$disabled = $author$project$Ui$Form$Gender$Disabled;
var $author$project$Ui$Form$Gender$Gender = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Gender$gender = $author$project$Ui$Form$Gender$Gender;
var $author$project$Ui$Form$Gender$GenderOther = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Gender$genderOther = $author$project$Ui$Form$Gender$GenderOther;
var $author$project$Ui$Form$Gender$OnGenderChange = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Gender$onGenderChange = $author$project$Ui$Form$Gender$OnGenderChange;
var $author$project$Ui$Form$Gender$OnGenderOtherChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Gender$onGenderOtherChange = $author$project$Ui$Form$Gender$OnGenderOtherChange;
var $author$project$Ui$Form$Gender$defaultOptions = {vw: _List_Nil, dW: false, fE: _List_Nil, PO: $elm$core$Maybe$Nothing, PQ: $elm$core$Maybe$Nothing, q$: false, zJ: $elm$core$Maybe$Nothing, zK: $elm$core$Maybe$Nothing};
var $author$project$Ui$Form$Gender$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$id(string),
									record.vw)
							});
					case 3:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								zJ: $elm$core$Maybe$Just(handler)
							});
					case 4:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								zK: $elm$core$Maybe$Just(handler)
							});
					case 1:
						var gender_ = option.a;
						return _Utils_update(
							record,
							{PO: gender_});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{PQ: string});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{dW: bool});
					case 6:
						var bool = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('feedback-errored', bool)
											])),
									record.vw),
								q$: bool
							});
					default:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
				}
			}),
		$author$project$Ui$Form$Gender$defaultOptions,
		options);
};
var $author$project$Ui$Form$Gender$viewGenderOption = F2(
	function (options, gender_) {
		var genderString = $author$project$Api$Gender$toString(gender_);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('radio-inline')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$type_('radio'),
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$name('gender'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(genderString),
								A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$checked(
										_Utils_eq(
											$elm$core$Maybe$Just(gender_),
											options.PO)),
									A2(
										$elm$core$List$cons,
										$elm$html$Html$Attributes$disabled(options.dW),
										function () {
											var _v0 = options.zJ;
											if (!_v0.$) {
												var handler = _v0.a;
												return _List_fromArray(
													[
														$elm$html$Html$Events$onInput(
														A2(
															$elm$core$Basics$composeL,
															handler,
															$elm$core$Basics$always(gender_)))
													]);
											} else {
												return _List_Nil;
											}
										}()))))),
					_List_Nil),
					$elm$html$Html$text(
					$author$project$Formatters$String$titleize(genderString))
				]));
	});
var $author$project$Ui$Form$Gender$view = function (options) {
	var optionsRecord = $author$project$Ui$Form$Gender$optionsToRecord(options);
	var genderOptions = _List_fromArray(
		[0, 1, 3]);
	var radios = A2(
		$elm$core$List$map,
		$author$project$Ui$Form$Gender$viewGenderOption(optionsRecord),
		genderOptions);
	var genderExplanation = $elm$core$Maybe$Nothing;
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						if (!genderExplanation.$) {
							var genderExplanation_ = genderExplanation.a;
							return A3($author$project$Ui$Tooltip$view, _List_Nil, genderExplanation_, radios);
						} else {
							return A2($elm$html$Html$div, _List_Nil, radios);
						}
					}()
					])),
				_Utils_eq(
				optionsRecord.PO,
				$elm$core$Maybe$Just(3)) ? A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$placeholder('Description'),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Form$Input$autoComplete(false),
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', optionsRecord.PQ)),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Input$disabled(optionsRecord.dW),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Input$phi(true),
											function () {
												var _v1 = optionsRecord.zK;
												if (!_v1.$) {
													var handler = _v1.a;
													return _List_fromArray(
														[
															$author$project$Ui$Form$Input$onInput(handler)
														]);
												} else {
													return _List_Nil;
												}
											}()))))))
					])) : $author$project$Ui$FlexGrid$none
			]));
};
var $author$project$Pages$Admin$Providers$Top$viewGender = F3(
	function (gender, genderOther, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Gender')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Gender$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Gender$gender(gender),
								$author$project$Ui$Form$Gender$genderOther(genderOther),
								$author$project$Ui$Form$Gender$onGenderChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Gender)),
								$author$project$Ui$Form$Gender$onGenderOtherChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$GenderOther)),
								$author$project$Ui$Form$Gender$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$AddLocationItem = {$: 11};
var $author$project$Pages$Admin$Providers$Top$Location = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$RemoveLocationItem = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Admin$Providers$Top$locationDropdownOptions = F3(
	function (allLocations, locations, location) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Select'),
			A2(
				$elm$core$List$map,
				function (location_) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Location$All$id(location_)),
						$author$project$Api$Provider$Location$All$name(location_));
				},
				A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (location_) {
						return (!_Utils_eq(
							$author$project$Api$Provider$Location$All$id(location_),
							location)) && A2(
							$elm$core$List$member,
							$author$project$Api$Provider$Location$All$id(location_),
							locations);
					},
					allLocations)));
	});
var $author$project$Pages$Admin$Providers$Top$viewLocationsDropdown = F7(
	function (form, allLocationsLoading, allLocations, locations, editable, index, location) {
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(locations) - 1);
		var isFirst = !index;
		var label = isFirst ? 'Locations' : '';
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(location)),
										$author$project$Ui$Form$Select$onChange(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Pages$Admin$Providers$Top$FormUpdated,
											$author$project$Pages$Admin$Providers$Top$Location(index))),
										$author$project$Ui$Form$Select$loading(allLocationsLoading),
										$author$project$Ui$Form$Select$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
										$author$project$Ui$Form$Select$errors(
										A2($author$project$Utils$Form$validationErrors, 3, form)),
										$author$project$Ui$Form$Select$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									]),
								A3($author$project$Pages$Admin$Providers$Top$locationDropdownOptions, allLocations, locations, location))),
							(($elm$core$List$length(locations) > 1) && $author$project$Utils$MetaFields$isEditable(editable)) ? A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A3(
								$author$project$Ui$Button$view,
								{abp: 'Remove Location'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable)),
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$Providers$Top$FormUpdated(
											$author$project$Pages$Admin$Providers$Top$RemoveLocationItem(index))),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$minus)
									]),
								_List_Nil)) : $author$project$Utils$Html$empty,
							isLast ? A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							A3(
								$author$project$Ui$Button$view,
								{abp: 'Add Location'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddLocationItem)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
										$author$project$Ui$Button$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									]),
								_List_Nil)) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$IsProvider = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Npi = function (a) {
	return {$: 20, a: a};
};
var $author$project$Ui$Form$Checkbox$Inline = {$: 7};
var $author$project$Ui$Form$Checkbox$inline = $author$project$Ui$Form$Checkbox$Inline;
var $author$project$Pages$Admin$Providers$Top$viewNPI = F4(
	function (isProvider, npi, editable, errors) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('NPI'),
					$author$project$Ui$Form$Group$required(isProvider)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', npi)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Npi)),
								$author$project$Ui$Form$Input$maxLength(10),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(errors)),
								$author$project$Ui$Form$Input$errors(errors),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							]))),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(!isProvider),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$IsProvider)),
								$author$project$Ui$Form$Checkbox$inline,
								$author$project$Ui$Form$Checkbox$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Not a provider, does not have an NPI')
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewName = F3(
	function (name, editable, errors) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Name'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(name),
								$author$project$Ui$Form$Input$placeholder('Dr. Leonard McCoy, MD'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Name)),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(errors)),
								$author$project$Ui$Form$Input$errors(errors),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							])))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$AutoDetermineOnlineSignupVisibilityFromPanelSize = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Providers$Top$OnlineSignupVisibility = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewOnlineSignup = F2(
	function (onlineSignupVisibility, autoDetermineOnlineSignupVisibilityFromPanelSize) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Online Signup')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(onlineSignupVisibility),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$OnlineSignupVisibility)),
							$author$project$Ui$ToggleSwitch$disabled(autoDetermineOnlineSignupVisibilityFromPanelSize)
						])),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(autoDetermineOnlineSignupVisibilityFromPanelSize),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AutoDetermineOnlineSignupVisibilityFromPanelSize)),
							$author$project$Ui$Form$Checkbox$inline
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Auto determine from panel size')
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$PanelSizeLimit = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewPanelSize = F4(
	function (autoDetermineOnlineSignupVisibilityFromPanelSize, panelSizeLimit, panelSize, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Panel Size Limit'),
					$author$project$Ui$Form$Group$required(autoDetermineOnlineSignupVisibilityFromPanelSize)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(editable),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$number,
								$author$project$Ui$Form$Input$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, panelSizeLimit))),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$PanelSizeLimit)),
								$author$project$Ui$Form$Input$placeholder('No Limit'),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(editable))
							]))),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$helpText]),
					_List_fromArray(
						[
							$elm$html$Html$text('Current Panel Size: '),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, panelSize)))
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$viewPhoto = F2(
	function (currentPhotoUrl, errors) {
		if (!currentPhotoUrl.$) {
			var url = currentPhotoUrl.a;
			return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9),
						$author$project$Ui$Form$Group$label('')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Image$fromSrc,
						{I1: 'Provider photo'},
						url,
						_List_fromArray(
							[
								$author$project$Ui$Image$height(100)
							])),
						$author$project$Utils$FormErrors$view(errors)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Admin$Providers$Top$PhotoUploaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewPhotoLabel = function (editable) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Photo')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
				$author$project$Utils$MetaFields$explanation(editable),
				$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Pages$Admin$Providers$Top$PhotoUploaded),
							$author$project$Ui$Form$File$empty(true),
							$author$project$Ui$Form$File$disabled(
							$author$project$Utils$MetaFields$isUneditable(editable))
						])))
			]));
};
var $author$project$Pages$Admin$Providers$Top$AddSpecialty = {$: 10};
var $author$project$Pages$Admin$Providers$Top$RemoveSpecialty = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Specialty = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$Specialty$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Specialty$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Specialty$Shared$name(shared);
};
var $author$project$Pages$Admin$Providers$Top$specialtyOptions = F3(
	function (allSpecialties, specialties, specialty) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				''),
			A2(
				$elm$core$List$map,
				function (specialty_) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Specialty$All$name(specialty_)),
						$author$project$Api$Provider$Specialty$All$name(specialty_));
				},
				A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (specialty_) {
						return (!_Utils_eq(
							$author$project$Api$Provider$Specialty$All$name(specialty_),
							specialty)) && A2(
							$elm$core$List$member,
							$author$project$Api$Provider$Specialty$All$name(specialty_),
							specialties);
					},
					allSpecialties)));
	});
var $author$project$Pages$Admin$Providers$Top$viewSpecialty = F6(
	function (allSpecialtiesLoading, allSpecialties, specialties, editable, index, specialty) {
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(specialties) - 1);
		var isFirst = !index;
		var label = isFirst ? 'Specialties' : '';
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(label)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex space-between')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
									$author$project$Utils$MetaFields$explanation(editable),
									A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(specialty)),
												$author$project$Ui$Form$Select$onChange(
												A2(
													$elm$core$Basics$composeL,
													$author$project$Pages$Admin$Providers$Top$FormUpdated,
													$author$project$Pages$Admin$Providers$Top$Specialty(index))),
												$author$project$Ui$Form$Select$loading(allSpecialtiesLoading),
												$author$project$Ui$Form$Select$disabled(
												$author$project$Utils$MetaFields$isUneditable(editable))
											]),
										A3($author$project$Pages$Admin$Providers$Top$specialtyOptions, allSpecialties, specialties, specialty))),
									($elm$core$List$length(specialties) > 1) ? A2(
									$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
									$author$project$Utils$MetaFields$explanation(editable),
									A3(
										$author$project$Ui$Button$view,
										{abp: 'Remove specialty'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Admin$Providers$Top$FormUpdated(
													$author$project$Pages$Admin$Providers$Top$RemoveSpecialty(index))),
												$author$project$Ui$Button$disabled(
												$author$project$Utils$MetaFields$isUneditable(editable)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$minus),
												$author$project$Ui$Button$sm
											]),
										_List_Nil)) : $author$project$Utils$Html$empty,
									isLast ? A2(
									$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
									$author$project$Utils$MetaFields$explanation(editable),
									A3(
										$author$project$Ui$Button$view,
										{abp: 'Add speciality'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddSpecialty)),
												$author$project$Ui$Button$disabled(
												$author$project$Utils$MetaFields$isUneditable(editable)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
												$author$project$Ui$Button$sm
											]),
										_List_Nil)) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$MaxPatientAge = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Providers$Top$MinPatientAge = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Providers$Top$viewTreatsAge = F3(
	function (minPatientAge, maxPatientAge, editable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Treats Ages')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, minPatientAge))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$MinPatientAge)),
										$author$project$Ui$Form$Input$placeholder('0'),
										$author$project$Ui$Form$Input$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									]))),
							A2(
							$author$project$Ui$Typography$label,
							_List_fromArray(
								[$author$project$Ui$Typography$controlLabel]),
							_List_fromArray(
								[
									$elm$html$Html$text('To')
								])),
							A2(
							$author$project$Pages$Admin$Providers$Top$withinTooltipIf,
							$author$project$Utils$MetaFields$explanation(editable),
							$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$number,
										$author$project$Ui$Form$Input$value(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $elm$core$String$fromInt, maxPatientAge))),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$MaxPatientAge)),
										$author$project$Ui$Form$Input$placeholder('100'),
										$author$project$Ui$Form$Input$disabled(
										$author$project$Utils$MetaFields$isUneditable(editable))
									])))
						]))
				]));
	});
var $author$project$Pages$Admin$Providers$Top$viewModal = F4(
	function (model, id, form, item) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Provider',
			S_: _Utils_eq(item, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$Providers$Top$CancelEdit,
			U0: $author$project$Pages$Admin$Providers$Top$Save(form)
		};
		var ifTrue = F2(
			function (bool, field) {
				return bool ? field : $author$project$Utils$Html$empty;
			});
		var fields = $author$project$Utils$Form$fields(form);
		var meta = function (accessor) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$MetaFields$alwaysEditable,
				A2($elm$core$Maybe$map, accessor, fields.TU));
		};
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		var _v0 = function () {
			var _v1 = model._p;
			if (_v1.$ === 3) {
				var specialties_ = _v1.a;
				return _Utils_Tuple2(false, specialties_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var specialtiesLoading = _v0.a;
		var specialties = _v0.b;
		var _v2 = function () {
			var _v3 = model.S4;
			if (_v3.$ === 3) {
				var locations_ = _v3.a;
				return _Utils_Tuple2(false, locations_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var locationsLoading = _v2.a;
		var locations = _v2.b;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A3(
							$author$project$Pages$Admin$Providers$Top$viewName,
							fields.zh,
							meta($author$project$Api$Provider$Practitioner$Meta$name),
							errorsFor(0)),
							A4(
							$author$project$Pages$Admin$Providers$Top$viewNPI,
							fields.R1,
							fields.UP,
							meta($author$project$Api$Provider$Practitioner$Meta$npi),
							errorsFor(1)),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewBio,
							fields.J2,
							meta($author$project$Api$Provider$Practitioner$Meta$bio)),
							A3(
							$author$project$Pages$Admin$Providers$Top$viewGender,
							fields.PO,
							fields.PQ,
							meta($author$project$Api$Provider$Practitioner$Meta$gender)),
							$author$project$Pages$Admin$Providers$Top$viewPhotoLabel(
							meta($author$project$Api$Provider$Practitioner$Meta$photo)),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewPhoto,
							fields.p6,
							errorsFor(2)),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewEmail,
							fields.Oo,
							meta($author$project$Api$Provider$Practitioner$Meta$email)),
							A3(
							$author$project$Pages$Admin$Providers$Top$viewTreatsAge,
							fields.T$,
							fields.Tq,
							meta($author$project$Api$Provider$Practitioner$Meta$treatsAge))
						]),
						A2(
						$elm$core$List$indexedMap,
						A4(
							$author$project$Pages$Admin$Providers$Top$viewSpecialty,
							specialtiesLoading,
							specialties,
							fields._p,
							meta($author$project$Api$Provider$Practitioner$Meta$specialtyNames)),
						fields._p),
						A2(
						$elm$core$List$indexedMap,
						A2(
							$author$project$Pages$Admin$Providers$Top$viewEducation,
							fields.Oc,
							meta($author$project$Api$Provider$Practitioner$Meta$education)),
						fields.Oc),
						A2(
						$elm$core$List$indexedMap,
						A5(
							$author$project$Pages$Admin$Providers$Top$viewLocationsDropdown,
							form,
							locationsLoading,
							locations,
							fields.S4,
							meta($author$project$Api$Provider$Practitioner$Meta$locations)),
						fields.S4),
						_List_fromArray(
						[
							A2(
							ifTrue,
							$author$project$Api$Provider$Practice$One$elationEnabled(model.WF),
							A2($author$project$Pages$Admin$Providers$Top$viewElationSync, fields.Oh, model.xk)),
							A2($author$project$Pages$Admin$Providers$Top$viewOnlineSignup, fields.U8, fields.JE),
							A4(
							$author$project$Pages$Admin$Providers$Top$viewPanelSize,
							fields.JE,
							fields.Vw,
							fields.Vv,
							meta($author$project$Api$Provider$Practitioner$Meta$panelSizeLimit)),
							A2($author$project$Pages$Admin$Providers$Top$viewAcceptsEnrollmentsForm, fields.pg, fields.ph)
						])
					])));
	});
var $author$project$Pages$Admin$Providers$Top$NpiSettingChanged = function (a) {
	return {$: 24, a: a};
};
var $author$project$Api$Provider$PracticeSettings$One$showNpi = function (_v0) {
	var record = _v0;
	return record.ZU;
};
var $author$project$Pages$Admin$Providers$Top$viewEnableNpiToggle = function (practiceSettings) {
	var labelHelp = $elm$html$Html$text('A providers\'s NPI will be displayed on invoices and other communications with customers such as patients or employers');
	var _v0 = function () {
		switch (practiceSettings.$) {
			case 2:
				return _Utils_Tuple3(false, true, false);
			case 3:
				var settings = practiceSettings.a;
				return _Utils_Tuple3(
					false,
					false,
					$author$project$Api$Provider$PracticeSettings$One$showNpi(settings));
			default:
				return _Utils_Tuple3(true, true, false);
		}
	}();
	var loading = _v0.a;
	var disabled = _v0.b;
	var on = _v0.c;
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Display NPI to customers'),
								$author$project$Ui$Form$Group$labelHelp(labelHelp),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$labelSpan(8),
								$author$project$Ui$Form$Group$inputSpan(4),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(on),
												$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$Providers$Top$NpiSettingChanged),
												$author$project$Ui$ToggleSwitch$disabled(disabled || loading)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Providers$Top$AddLocation = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Providers$Top$Delete = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Admin$Providers$Top$Edit = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Practice$Shared$subdomain = function (_v0) {
	var record = _v0;
	return record._$;
};
var $author$project$Api$Provider$Practice$One$subdomain = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$subdomain(shared);
};
var $author$project$Pages$Admin$Providers$Top$customUrl = F2(
	function (practice, practitioner) {
		return 'https://' + ($author$project$Api$Provider$Practice$One$subdomain(practice) + ('.hint.com/signup?practitioner=' + $author$project$Api$Provider$Practitioner$All$id(practitioner)));
	});
var $author$project$Api$Provider$Npi$Shared$firstName = function (_v0) {
	var record = _v0;
	return record.Pu;
};
var $author$project$Api$Provider$Npi$Shared$lastName = function (_v0) {
	var record = _v0;
	return record.SA;
};
var $author$project$Api$Provider$Npi$Shared$organizationName = function (_v0) {
	var record = _v0;
	return record.Ve;
};
var $author$project$Api$Provider$Npi$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Pages$Admin$Providers$Top$npiName = function (npi) {
	var _v0 = $author$project$Api$Provider$Npi$Shared$type_(npi);
	if ((!_v0.$) && (_v0.a === 'organization')) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Npi$Shared$organizationName(npi));
	} else {
		var _v1 = _Utils_Tuple2(
			$author$project$Api$Provider$Npi$Shared$firstName(npi),
			$author$project$Api$Provider$Npi$Shared$lastName(npi));
		if ((!_v1.a.$) && (!_v1.b.$)) {
			var firstName = _v1.a.a;
			var lastName = _v1.b.a;
			return firstName + (' ' + lastName);
		} else {
			return '';
		}
	}
};
var $author$project$Pages$Admin$Providers$Top$viewField_ = F2(
	function (labelOption, content) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					labelOption,
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$labelSpanMd(2),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$inputSpanMd(10)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$Form$Static$view, _List_Nil, content)
				]));
	});
var $author$project$Pages$Admin$Providers$Top$viewField = function (label) {
	return $author$project$Pages$Admin$Providers$Top$viewField_(
		$author$project$Ui$Form$Group$label(label));
};
var $author$project$Pages$Admin$Providers$Top$viewLocation = function (location) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$phi(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Location$Shared$name(location)),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Pages$Admin$Providers$Top$viewItem = F3(
	function (model, items, item) {
		var panelSizeLimit = A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			$author$project$Api$Provider$Practitioner$All$panelSizeLimit(item));
		var onlineSignupVisibility = $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility(item);
		var locations = A2(
			$author$project$Api$Expandable$withDefault,
			_List_Nil,
			$author$project$Api$Provider$Practitioner$All$locations(item));
		var id = $author$project$Api$Provider$Practitioner$All$id(item);
		var loading = A2($elm$core$Set$member, id, model.dN);
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$heading(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Practitioner$All$name(item))
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Tooltip$view,
											_List_Nil,
											'active patient count',
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$badge]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(
																$author$project$Api$Provider$Practitioner$All$panelSize(item)))
														]))
												]))
										])),
									$author$project$Api$Provider$Practitioner$All$isMaster(item) ? $author$project$Components$SyncedIcon$view(
									_List_fromArray(
										[$author$project$Components$SyncedIcon$master])) : $author$project$Utils$Html$empty,
									$author$project$Api$Provider$Practitioner$All$isSynced(item) ? $author$project$Components$SyncedIcon$view(
									_List_fromArray(
										[$author$project$Components$SyncedIcon$synced])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit provider'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Providers$Top$Edit(item)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete provider'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											A2($author$project$Pages$Admin$Providers$Top$Delete, item, items)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceY2]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Online Signup',
							_List_fromArray(
								[
									onlineSignupVisibility ? A2($author$project$Ui$Icon$view, _List_Nil, 18) : A2($author$project$Ui$Icon$view, _List_Nil, 19),
									$author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize(item) ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											onlineSignupVisibility ? $elm$html$Html$text(
											' Automatically set by panel size. Disabled after panel reaches ' + (A2($elm$core$Maybe$withDefault, 'N/A', panelSizeLimit) + '.')) : $elm$html$Html$text(
											' Automatically set by panel size. Re-enabled after panel drops below ' + (A2($elm$core$Maybe$withDefault, 'N/A', panelSizeLimit) + '.'))
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Treats ages',
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'0',
										A2(
											$elm$core$Maybe$map,
											$elm$core$String$fromInt,
											$author$project$Api$Provider$Practitioner$All$minPatientAge(item))) + (' to ' + A2(
										$elm$core$Maybe$withDefault,
										'max',
										A2(
											$elm$core$Maybe$map,
											$elm$core$String$fromInt,
											$author$project$Api$Provider$Practitioner$All$maxPatientAge(item)))))
								])),
							function () {
							var _v0 = $author$project$Api$Provider$Practitioner$All$email(item);
							if (!_v0.$) {
								var email = _v0.a;
								return A2(
									$author$project$Pages$Admin$Providers$Top$viewField,
									'Email',
									_List_fromArray(
										[
											$elm$html$Html$text(email)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							$elm$core$List$isEmpty(
							$author$project$Api$Provider$Practitioner$All$specialties(item)) ? $author$project$Utils$Html$empty : A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Specialties',
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$toSentence(
										$author$project$Api$Provider$Practitioner$All$specialties(item)))
								])),
							$elm$core$List$isEmpty(
							$author$project$Api$Provider$Practitioner$All$education(item)) ? $author$project$Utils$Html$empty : A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Education',
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$toSentence(
										$author$project$Api$Provider$Practitioner$All$education(item)))
								])),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Locations',
							_Utils_ap(
								$elm$core$List$isEmpty(locations) ? _List_fromArray(
									[
										$elm$html$Html$text('None')
									]) : A2($elm$core$List$map, $author$project$Pages$Admin$Providers$Top$viewLocation, locations),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										$author$project$Api$Provider$Practitioner$All$isSynced(item) ? _List_Nil : _List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Add location'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Admin$Providers$Top$AddLocation(item))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add Location')
													]))
											]))
									]))),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Custom Signup URL',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									A2($author$project$Pages$Admin$Providers$Top$customUrl, model.WF, item),
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Pages$Admin$Providers$Top$customUrl, model.WF, item))
										]))
								])),
							A2(
							$author$project$Pages$Admin$Providers$Top$viewField,
							'Panel Limit',
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, 'None', panelSizeLimit))
								])),
							function () {
							if ($author$project$Api$Provider$Practice$One$elationEnabled(model.WF)) {
								var _v1 = $author$project$Api$Provider$Practitioner$All$elationPhysicianId(item);
								if (!_v1.$) {
									return A2(
										$author$project$Pages$Admin$Providers$Top$viewField,
										'Elation',
										_List_fromArray(
											[
												A2($author$project$Ui$Badge$fromString, _List_Nil, 'synced')
											]));
								} else {
									return A2(
										$author$project$Pages$Admin$Providers$Top$viewField,
										'Elation',
										_List_fromArray(
											[
												A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
											]));
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							function () {
							if ($author$project$Api$Provider$Practitioner$All$isProvider(item)) {
								var _v2 = $author$project$Api$Provider$Practitioner$All$npi(item);
								if (!_v2.$) {
									var npi = _v2.a;
									return A2(
										$author$project$Pages$Admin$Providers$Top$viewField,
										'NPI',
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$Npi$Shared$number(npi))
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2(
																$elm$core$Maybe$map,
																$author$project$Formatters$String$humanize,
																$author$project$Api$Provider$Npi$Shared$type_(npi))))
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Pages$Admin$Providers$Top$npiName(npi))
													]))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Ui$ListGroup$body = function (contents) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group-item-text')
			]),
		contents);
};
var $author$project$Pages$Admin$Providers$Top$viewFieldSkeleton = function (label) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$singleton,
		$author$project$Pages$Admin$Providers$Top$viewField_(
			$author$project$Ui$Form$Group$labelSkeleton(label)));
};
var $author$project$Pages$Admin$Providers$Top$viewItemSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h3,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Provider Name')
						]))
				])),
			$author$project$Ui$ListGroup$body(
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Online Signup',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('  ')
							]))),
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Treats ages',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(3)
							]))),
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Location',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(2)
							]))),
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Custom Signup URL',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(6)
							]))),
					A2(
					$author$project$Pages$Admin$Providers$Top$viewFieldSkeleton,
					'Panel Item',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('100')
							])))
				]))
		]));
var $author$project$Pages$Admin$Providers$Top$viewSearch = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(8),
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$Providers$Top$SearchInputMsg,
										A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
									]))
							]))
					]))
			]));
};
var $author$project$Ui$ListGroup$ZeroState = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ListGroup$zeroState = $author$project$Ui$ListGroup$ZeroState;
var $author$project$Pages$Admin$Providers$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.iZ;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return _List_fromArray(
		[
			$author$project$Pages$Admin$Providers$Top$viewEnableNpiToggle(model.sa),
			$author$project$Pages$Admin$Providers$Top$viewSearch(model),
			loading ? A2(
			$author$project$Ui$ListGroup$view,
			_List_Nil,
			A2(
				$elm$core$List$repeat,
				10,
				A2(
					$author$project$Ui$ListGroup$item,
					_List_Nil,
					$elm$core$List$singleton($author$project$Pages$Admin$Providers$Top$viewItemSkeleton)))) : A2(
			$author$project$Ui$ListGroup$view,
			_List_fromArray(
				[
					$author$project$Ui$ListGroup$zeroState('You have no providers.')
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Admin$Providers$Top$viewItem, model, items),
				items))
		]);
};
var $author$project$Pages$Admin$Providers$Top$view = function (model) {
	return {
		e5: function () {
			var loading = function () {
				var _v5 = model.iZ;
				if (_v5.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg,
					$author$project$Components$LinkedRecords$modal(model.mS)),
					function () {
					var _v0 = model.FU;
					if (!_v0.$) {
						var _v1 = _v0.a;
						var id = _v1.a;
						var form = _v1.b;
						var item = _v1.c;
						return A4($author$project$Pages$Admin$Providers$Top$viewModal, model, id, form, item);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v2 = model.ic;
					if (!_v2.$) {
						var item = _v2.a;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Pages$Admin$Providers$Top$HiConfirmClosed(item),
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('delete'),
									$author$project$Components$HiConfirm$noun('provider'),
									$author$project$Components$HiConfirm$detail(
									$author$project$Api$Provider$Practitioner$All$name(item))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Admin$Providers$Top$DeleteModalMsg,
					$author$project$Components$Admin$Practitioner$DeleteModal$view(model.h7)),
					function () {
					var _v3 = model.aU;
					if (!_v3.$) {
						var _v4 = _v3.a;
						var item = _v4.a;
						var locationId = _v4.b;
						var request = _v4.c;
						return A4($author$project$Pages$Admin$Providers$Top$viewAddLocationModal, model, item, locationId, request);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$titleWithButton,
									_List_fromArray(
										[
											$elm$html$Html$text('Providers')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pull-right')
												]),
											_List_fromArray(
												[
													model.FR ? A3(
													$author$project$Ui$HinterOnly$linkRoute,
													$author$project$Spa$Generated$Route$Admin__Providers__Upload,
													_List_fromArray(
														[
															$author$project$Ui$Link$buttonDefault,
															$author$project$Ui$Link$ariaLabel('Upload')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Upload from CSV')
														])) : $author$project$Utils$Html$empty,
													$author$project$Utils$Html$noBreakSpace,
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Add new provider'},
													_List_fromArray(
														[
															$author$project$Ui$Button$default,
															$author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$New),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('New Provider')
														]))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							$author$project$Pages$Admin$Providers$Top$viewPanelBody(model)),
							A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Providers$Top$PaginationMsg,
									A2(
										$author$project$Api$Pagination$view,
										_List_fromArray(
											[
												$author$project$Ui$Pagination$List$loading(loading)
											]),
										model.afy))
								]))
						]))
				]);
		}(),
		$G: 'Admin | Providers'
	};
};
var $author$project$Pages$Admin$Providers$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Providers$Top$init, aer: $author$project$Pages$Admin$Providers$Top$load, agD: $author$project$Pages$Admin$Providers$Top$save, ahd: $author$project$Pages$Admin$Providers$Top$subscriptions, aaq: $author$project$Pages$Admin$Providers$Top$update, ahP: $author$project$Pages$Admin$Providers$Top$view});
var $author$project$Api$Upload$Resource$Practitioner = 2;
var $author$project$Pages$Admin$Providers$Upload$UploadFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$Providers$Upload$init = F4(
	function (_v0, _v1, shared, _v2) {
		var _v3 = A4($author$project$Components$Upload$Form$init, shared.Hy, shared.D5, 2, $elm$core$Maybe$Nothing);
		var uploadForm = _v3.a;
		var uploadFormCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: uploadForm},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
	});
var $author$project$Pages$Admin$Providers$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Providers$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Providers$Upload$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Upload$Form$subscriptions(model.PB));
};
var $author$project$Pages$Admin$Providers$Upload$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Upload$Form$update, model.D5, subMsg, model.PB);
		var uploadForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: uploadForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsgs);
	});
var $author$project$Pages$Admin$Providers$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(12)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Upload Providers')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$identity,
										A2($author$project$Components$Upload$Form$view, model.D5, model.PB))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Providers$Upload$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A2($author$project$Components$Upload$Form$modal, model.D5, model.PB)),
				$author$project$Pages$Admin$Providers$Upload$viewBody(model)
			]),
		$G: 'Admin | Providers'
	};
};
var $author$project$Pages$Admin$Providers$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Providers$Upload$init, aer: $author$project$Pages$Admin$Providers$Upload$load, agD: $author$project$Pages$Admin$Providers$Upload$save, ahd: $author$project$Pages$Admin$Providers$Upload$subscriptions, aaq: $author$project$Pages$Admin$Providers$Upload$update, ahP: $author$project$Pages$Admin$Providers$Upload$view});
var $author$project$Pages$Admin$Quickbooks$Top$GotQuickbooksIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Quickbooks$Top$Initial = {$: 0};
var $author$project$Api$Feature$QuickbooksBypassPmpmCheck = 4;
var $author$project$Api$Provider$Practice$One$feePlanType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Pg;
	});
var $author$project$Api$Provider$QuickbooksIntegration$One$QuickbooksIntegration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$QuickbooksIntegration$Shared$QuickbooksIntegration = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksIntegration$Shared$Record = function (status) {
	return {ag7: status};
};
var $author$project$Api$Provider$QuickbooksIntegration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$Shared$Record));
var $author$project$Api$Provider$QuickbooksIntegration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksIntegration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$QuickbooksIntegration$One$Record = F7(
	function (oauthConnectionUrl, errorsCount, syncDepositsAvailableOnOrAfter, depositAccountExtid, discrepancyAccountExtid, feeAccountExtid, uncategorizedAccountExtid) {
		return {acG: depositAccountExtid, acO: discrepancyAccountExtid, OO: errorsCount, adk: feeAccountExtid, UV: oauthConnectionUrl, $g: syncDepositsAvailableOnOrAfter, ahK: uncategorizedAccountExtid};
	});
var $author$project$Api$Provider$QuickbooksIntegration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uncategorized_account_extid',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'fee_account_extid',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'discrepancy_account_extid',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deposit_account_extid',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sync_deposits_available_on_or_after',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'errors_count',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'oauth_connection_url',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$One$Record))))))));
var $author$project$Api$Provider$QuickbooksIntegration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksIntegration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$QuickbooksIntegration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$One$QuickbooksIntegration)));
var $author$project$Api$Provider$Integration$Quickbooks$quickbooksPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['quickbooks_integration']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Integration$Quickbooks$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath));
	});
var $author$project$Pages$Admin$Quickbooks$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				hz: $elm$core$Maybe$Nothing,
				vR: ($author$project$Api$Provider$Practice$One$feePlanType(practice) === 1) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 4, practice),
				fl: $elm$core$Maybe$Nothing,
				PB: $elm$core$Maybe$Nothing,
				qT: shared.qT,
				WF: practice,
				Bi: query,
				c8: $author$project$Api$Data$Loading,
				gs: $elm$core$Maybe$Nothing,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				_M: $author$project$Pages$Admin$Quickbooks$Top$Initial
			},
			A2($author$project$Api$Provider$Integration$Quickbooks$retrieve, shared.D5, $author$project$Pages$Admin$Quickbooks$Top$GotQuickbooksIntegration));
	});
var $author$project$Pages$Admin$Quickbooks$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Quickbooks$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Quickbooks$Top$AuthorizeOnQuickbooksHiConfirmClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Quickbooks$Top$DeactivateHiConfirmClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$Quickbooks$Top$QuickbooksMappingsMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$CancelEdit = {$: 4};
var $author$project$Components$Admin$Quickbooks$Mappings$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Quickbooks$Mappings$CancelEdit)),
			model.w));
};
var $author$project$Pages$Admin$Quickbooks$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Quickbooks$Top$QuickbooksMappingsMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$Quickbooks$Mappings$subscriptions, model.gs))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$Quickbooks$Top$AuthorizeOnQuickbooksHiConfirmClosed)),
					model.hz)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$Quickbooks$Top$DeactivateHiConfirmClosed)),
					model.fl))
			]));
};
var $author$project$Pages$Admin$Quickbooks$Top$Activated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Quickbooks$Top$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Quickbooks$Top$Date = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$Admin$Quickbooks$Top$DateInputMsg = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Admin$Quickbooks$Top$Deactivated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$Quickbooks$Top$Overview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Integration$Quickbooks$activate = F3(
	function (apiClient, syncDepositsAvailableOnOrAfter, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sync_deposits_available_on_or_after',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, syncDepositsAvailableOnOrAfter))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['activate']),
						$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath))));
	});
var $author$project$Api$Provider$Integration$Quickbooks$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath));
	});
var $author$project$Api$Provider$Integration$Quickbooks$deactivate = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deactivate']),
					$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath)));
	});
var $author$project$Pages$Admin$Quickbooks$Top$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{qd: dateInput, $g: date});
	});
var $author$project$Pages$Admin$Quickbooks$Top$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Api$Provider$Integration$Quickbooks$Account$CategoryMatching = 0;
var $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading = {$: 0};
var $author$project$Api$Provider$Integration$Quickbooks$Account$accountssPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['accounts']),
	$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath);
var $author$project$Api$Provider$QuickbooksAccount$All$QuickbooksAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksAccount$Min$QuickbooksAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksAccount$Min$Record = F2(
	function (extid, name) {
		return {adf: extid, zh: name};
	});
var $author$project$Api$Provider$QuickbooksAccount$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'extid',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksAccount$Min$Record)));
var $author$project$Api$Provider$QuickbooksAccount$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksAccount$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$QuickbooksAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksAccount$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Quickbooks$Account$defaults = {ahI: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Integration$Quickbooks$Account$typeToString = function (type_) {
	switch (type_) {
		case 0:
			return 'category_matching';
		case 1:
			return 'deposit_matching';
		default:
			return 'fee_matching';
	}
};
var $author$project$Api$Provider$Integration$Quickbooks$Account$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Integration$Quickbooks$Account$defaults);
	var _v0 = options.ahI;
	if (!_v0.$) {
		var type_ = _v0.a;
		return _List_fromArray(
			[
				A2(
				$author$project$Api$Param$string,
				'type',
				$author$project$Api$Provider$Integration$Quickbooks$Account$typeToString(type_))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$Integration$Quickbooks$Account$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$QuickbooksAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Integration$Quickbooks$Account$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$Account$accountssPath)));
	});
var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['category_mappings']),
	$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath);
var $author$project$Api$Provider$QuickbooksCategoryMapping$All$QuickbooksCategoryMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$QuickbooksCategoryMapping = $elm$core$Basics$identity;
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$Record = F2(
	function (category, quickbooksAccount) {
		return {Ex: category, XG: quickbooksAccount};
	});
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'quickbooks_account',
	$author$project$Api$Provider$QuickbooksAccount$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'category',
		$author$project$Api$Provider$Category$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksCategoryMapping$Shared$Record)));
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksCategoryMapping$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$QuickbooksCategoryMapping$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$QuickbooksCategoryMapping$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$QuickbooksCategoryMapping$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$init = F4(
	function (apiClient, session, practice, quickbooksIntegration) {
		return _Utils_Tuple2(
			{hH: $author$project$Api$Data$Loading, ln: _List_Nil, lS: $author$project$Api$Data$Loading, w: $elm$core$Maybe$Nothing, md: $author$project$Api$Data$Loading, gb: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading, WF: practice, nO: $author$project$Api$Data$Loading, c8: quickbooksIntegration, ZD: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Api$Provider$Integration$Quickbooks$Account$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									ahI: $elm$core$Maybe$Just(0)
								});
						},
						$author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(0)),
						A2($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list, apiClient, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings)
					])));
	});
var $author$project$Api$Provider$QuickbooksIntegration$One$syncDepositsAvailableOnOrAfter = function (_v0) {
	var record = _v0.b;
	return record.$g;
};
var $author$project$Pages$Admin$Quickbooks$Top$initFormFields = function (quickbooksIntegration) {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			qd: dateInput,
			$g: $author$project$Api$Provider$QuickbooksIntegration$One$syncDepositsAvailableOnOrAfter(quickbooksIntegration)
		},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$Admin$Quickbooks$Top$DateInputMsg(dateInput),
			dateInputCmd));
};
var $author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl = function (_v0) {
	var record = _v0.b;
	return record.UV;
};
var $author$project$Pages$Admin$Quickbooks$Top$Downloading = {$: 1};
var $author$project$Pages$Admin$Quickbooks$Top$GotAuthorization = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Integration$Quickbooks$authorize = F5(
	function (apiClient, code, state, realmId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(code)),
					_Utils_Tuple2(
					'state',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, state)),
					_Utils_Tuple2(
					'realmId',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, realmId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['authorize']),
						$author$project$Api$Provider$Integration$Quickbooks$quickbooksPath))));
	});
var $author$project$Pages$Admin$Quickbooks$Top$sendOauthSuccessDataToBackend = function (model) {
	var _v0 = A2($elm$core$Dict$get, 'code', model.Bi);
	if (!_v0.$) {
		var code = _v0.a;
		var state = A2($elm$core$Dict$get, 'state', model.Bi);
		var realmId = A2($elm$core$Dict$get, 'realmId', model.Bi);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{jY: $author$project$Api$Data$Loading, _M: $author$project$Pages$Admin$Quickbooks$Top$Downloading}),
			A5($author$project$Api$Provider$Integration$Quickbooks$authorize, model.D5, code, state, realmId, $author$project$Pages$Admin$Quickbooks$Top$GotAuthorization));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Api$Provider$QuickbooksIntegration$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$QuickbooksIntegration$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$QuickbooksIntegration$Shared$status(shared);
};
var $author$project$Components$Admin$Quickbooks$Mappings$AccountSaved = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Integration$Quickbooks$Account$DepositMatching = 1;
var $author$project$Components$Admin$Quickbooks$Mappings$EditingAccount = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$Quickbooks$Mappings$EditingMapping = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Integration$Quickbooks$Account$FeeMatching = 2;
var $author$project$Components$Admin$Quickbooks$Mappings$QuickbooksCategoryMappingSaved = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid = function (_v0) {
	var record = _v0.b;
	return record.acG;
};
var $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid = function (_v0) {
	var record = _v0.b;
	return record.acO;
};
var $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid = function (_v0) {
	var record = _v0.b;
	return record.adk;
};
var $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid = function (_v0) {
	var record = _v0.b;
	return record.ahK;
};
var $author$project$Components$Admin$Quickbooks$Mappings$accountToParam = F2(
	function (account, quickbooksIntegration) {
		switch (account) {
			case 2:
				return $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid(quickbooksIntegration);
			case 1:
				return $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid(quickbooksIntegration);
			case 0:
				return $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid(quickbooksIntegration);
			default:
				return $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid(quickbooksIntegration);
		}
	});
var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsInit = F2(
	function (account, quickbooksIntegration) {
		return {
			adf: A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, account, quickbooksIntegration),
			zh: $elm$core$Maybe$Nothing,
			Bk: _List_Nil
		};
	});
var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		var extid = $author$project$Utils$String$toMaybe(string);
		var quickbooksAccount = A2(
			$elm_community$list_extra$List$Extra$find,
			function (quickbooksAccount_) {
				return _Utils_eq(quickbooksAccount_.adf, extid);
			},
			fields.Bk);
		return _Utils_update(
			fields,
			{
				adf: extid,
				zh: A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.zh;
					},
					quickbooksAccount)
			});
	});
var $author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid = '__blank';
var $author$project$Components$Admin$Quickbooks$Mappings$blankAccountData = {
	adf: $elm$core$Maybe$Just($author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid),
	zh: $elm$core$Maybe$Just('Not assigned - will not sync')
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$category = function (_v0) {
	var record = _v0;
	return record.Ex;
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$All$category = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$category(shared);
};
var $author$project$Api$Provider$QuickbooksAccount$Min$extid = function (_v0) {
	var record = _v0;
	return record.adf;
};
var $author$project$Api$Provider$QuickbooksAccount$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$quickbooksAccount = function (_v0) {
	var record = _v0;
	return record.XG;
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$quickbooksAccount(shared);
};
var $author$project$Components$Admin$Quickbooks$Mappings$mappingFormFieldsInit = F2(
	function (quickbooksCategoryMapping, quickbooksAccounts) {
		var name = $author$project$Api$Provider$QuickbooksAccount$Min$name(
			$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
		var extid = $author$project$Api$Provider$QuickbooksAccount$Min$extid(
			$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
		return {adf: extid, zh: name, Bk: quickbooksAccounts};
	});
var $author$project$Api$Provider$QuickbooksAccount$All$extid = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$QuickbooksAccount$Min$extid(min);
};
var $author$project$Api$Provider$QuickbooksAccount$All$name = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$QuickbooksAccount$Min$name(min);
};
var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountToAccountData = function (quickbooksAccount) {
	return {
		adf: $author$project$Api$Provider$QuickbooksAccount$All$extid(quickbooksAccount),
		zh: $author$project$Api$Provider$QuickbooksAccount$All$name(quickbooksAccount)
	};
};
var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData = function (quickbooksAccounts) {
	return A2($elm$core$List$map, $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountToAccountData, quickbooksAccounts);
};
var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksCategoryMappingFields = function (formFields) {
	return {adf: formFields.adf, zh: formFields.zh};
};
var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksFields = F3(
	function (account, formFields, quickbooksIntegration) {
		var fields = {
			acG: $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid(quickbooksIntegration),
			acO: $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid(quickbooksIntegration),
			adk: $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid(quickbooksIntegration),
			ahK: $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid(quickbooksIntegration)
		};
		switch (account) {
			case 2:
				return _Utils_update(
					fields,
					{acO: formFields.adf});
			case 1:
				return _Utils_update(
					fields,
					{adk: formFields.adf});
			case 0:
				return _Utils_update(
					fields,
					{acG: formFields.adf});
			default:
				return _Utils_update(
					fields,
					{ahK: formFields.adf});
		}
	});
var $author$project$Components$Admin$Quickbooks$Mappings$ExtidValidation = 0;
var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.adf;
			},
			_Utils_Tuple2(0, 'Please pick a quickbooks account.'))
		]));
var $author$project$Components$Admin$Quickbooks$Mappings$saveForm = F6(
	function (currentExtid, _v0, form, toCmd, toEditing, model) {
		var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsValidator, form);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var newForm = _v2.a;
			var validFormFields = _v2.b;
			var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
			var extid = _Utils_eq(
				formFields.adf,
				$elm$core$Maybe$Just($author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid)) ? $elm$core$Maybe$Nothing : formFields.adf;
			var _v3 = _Utils_eq(extid, currentExtid) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2(
				toCmd,
				newForm,
				_Utils_update(
					formFields,
					{adf: extid}));
			var editing = _v3.a;
			var cmd = _v3.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{w: editing}),
				cmd,
				_List_Nil);
		} else {
			var newForm = _v1.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						w: $elm$core$Maybe$Just(
							A2(toEditing, newForm, $author$project$Api$Data$NotAsked))
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Components$Admin$Quickbooks$Mappings$DepositAccount = 0;
var $author$project$Components$Admin$Quickbooks$Mappings$DiscrepancyAccount = 2;
var $author$project$Components$Admin$Quickbooks$Mappings$FeeAccount = 1;
var $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$UncategorizedAccount = 3;
var $author$project$Components$Admin$Quickbooks$Mappings$accountNameFromId = F2(
	function (model, id) {
		return A2(
			$elm$core$Maybe$andThen,
			function (id_) {
				var feeMatchingAccounts = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.md));
				var depositMatchingAccounts = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.lS));
				var categoryMatchingAccounts = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.hH));
				var quickbooksAccount = A2(
					$elm_community$list_extra$List$Extra$find,
					function (quickbooksAccount_) {
						return _Utils_eq(
							$author$project$Api$Provider$QuickbooksAccount$All$extid(quickbooksAccount_),
							$elm$core$Maybe$Just(id_));
					},
					A2(
						$elm$core$List$append,
						categoryMatchingAccounts,
						A2($elm$core$List$append, feeMatchingAccounts, depositMatchingAccounts)));
				return A2($elm$core$Maybe$andThen, $author$project$Api$Provider$QuickbooksAccount$All$name, quickbooksAccount);
			},
			id);
	});
var $author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId = F2(
	function (model, id) {
		if (!id.$) {
			var id_ = id.a;
			return {
				adf: $elm$core$Maybe$Just(id_),
				zh: A2($author$project$Components$Admin$Quickbooks$Mappings$accountNameFromId, model, id)
			};
		} else {
			return $author$project$Components$Admin$Quickbooks$Mappings$blankAccountData;
		}
	});
var $author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings = function (model) {
	var _v0 = _Utils_Tuple3(model.lS, model.md, model.hH);
	if (((_v0.a.$ === 3) && (_v0.b.$ === 3)) && (_v0.c.$ === 3)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		var _v3 = _v0.c;
		var otherMappings = {
			Ns: A2(
				$author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId,
				model,
				A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 0, model.c8)),
			NN: A2(
				$author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId,
				model,
				A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 2, model.c8)),
			Pe: A2(
				$author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId,
				model,
				A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 1, model.c8)),
			aag: A2(
				$author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId,
				model,
				A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 3, model.c8))
		};
		return _Utils_update(
			model,
			{
				gb: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoaded(otherMappings)
			});
	} else {
		return _Utils_update(
			model,
			{gb: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading});
	}
};
var $author$project$Api$Provider$Integration$Quickbooks$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'discrepancy_account_extid',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.acO)),
					_Utils_Tuple2(
					'deposit_account_extid',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.acG)),
					_Utils_Tuple2(
					'fee_account_extid',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adk)),
					_Utils_Tuple2(
					'uncategorized_account_extid',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahK))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$QuickbooksIntegration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath)));
	});
var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath);
};
var $author$project$Api$Provider$QuickbooksCategoryMapping$One$QuickbooksCategoryMapping = 0;
var $author$project$Api$Provider$QuickbooksCategoryMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'quickbooks_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'extid',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adf)),
								_Utils_Tuple2(
								'name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.zh))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$QuickbooksCategoryMapping$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingPath(id))));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nO: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var type_ = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var quickbooksAccounts = response.a;
					switch (type_) {
						case 0:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										hH: response,
										ln: A2(
											$elm$core$List$cons,
											$author$project$Components$Admin$Quickbooks$Mappings$blankAccountData,
											$author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(quickbooksAccounts))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3(
											$author$project$Api$Provider$Integration$Quickbooks$Account$list,
											apiClient,
											function (d) {
												return _Utils_update(
													d,
													{
														ahI: $elm$core$Maybe$Just(1)
													});
											},
											$author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(1)),
											A3(
											$author$project$Api$Provider$Integration$Quickbooks$Account$list,
											apiClient,
											function (d) {
												return _Utils_update(
													d,
													{
														ahI: $elm$core$Maybe$Just(2)
													});
											},
											$author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(2))
										])),
								_List_Nil);
						case 1:
							return _Utils_Tuple3(
								$author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(
									_Utils_update(
										model,
										{lS: response})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						default:
							return _Utils_Tuple3(
								$author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(
									_Utils_update(
										model,
										{md: response})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var account = msg.a;
				var form = $author$project$Utils$Form$init(
					A2($author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsInit, account, model.c8));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							w: $elm$core$Maybe$Just(
								A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, form, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var field = msg.a;
				var _v4 = model.w;
				if (!_v4.$) {
					if (!_v4.a.$) {
						var _v5 = _v4.a;
						var account = _v5.a;
						var form = _v5.b;
						var saveRequest = _v5.c;
						var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate, field, form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									w: $elm$core$Maybe$Just(
										A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, newForm, saveRequest))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var _v6 = _v4.a;
						var quickbooksCategoryMapping = _v6.a;
						var form = _v6.b;
						var saveRequest = _v6.c;
						var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate, field, form);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									w: $elm$core$Maybe$Just(
										A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, newForm, saveRequest))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{w: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v7 = model.w;
				if (!_v7.$) {
					if (!_v7.a.$) {
						var _v8 = _v7.a;
						var account = _v8.a;
						var form = _v8.b;
						var currentExtid = A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, account, model.c8);
						var accountName = function () {
							switch (account) {
								case 2:
									return 'discrepancy';
								case 1:
									return 'fee';
								case 0:
									return 'deposit';
								default:
									return 'uncategorize';
							}
						}();
						return A6(
							$author$project$Components$Admin$Quickbooks$Mappings$saveForm,
							currentExtid,
							accountName,
							form,
							F2(
								function (newForm, formFields) {
									var fields = A3($author$project$Components$Admin$Quickbooks$Mappings$quickbooksFields, account, formFields, model.c8);
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(
											A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, newForm, $author$project$Api$Data$Loading)),
										A3($author$project$Api$Provider$Integration$Quickbooks$update, apiClient, fields, $author$project$Components$Admin$Quickbooks$Mappings$AccountSaved));
								}),
							$author$project$Components$Admin$Quickbooks$Mappings$EditingAccount(account),
							model);
					} else {
						var _v10 = _v7.a;
						var quickbooksCategoryMapping = _v10.a;
						var form = _v10.b;
						var currentExtid = $author$project$Api$Provider$QuickbooksAccount$Min$extid(
							$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
						return A6(
							$author$project$Components$Admin$Quickbooks$Mappings$saveForm,
							currentExtid,
							'revenue',
							form,
							F2(
								function (newForm, formFields) {
									var id = $author$project$Api$Provider$Category$Min$id(
										$author$project$Api$Provider$QuickbooksCategoryMapping$All$category(quickbooksCategoryMapping));
									var fields = $author$project$Components$Admin$Quickbooks$Mappings$quickbooksCategoryMappingFields(formFields);
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(
											A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, newForm, $author$project$Api$Data$Loading)),
										A4($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$update, apiClient, id, fields, $author$project$Components$Admin$Quickbooks$Mappings$QuickbooksCategoryMappingSaved));
								}),
							$author$project$Components$Admin$Quickbooks$Mappings$EditingMapping(quickbooksCategoryMapping),
							model);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v11 = model.w;
				if ((!_v11.$) && (!_v11.a.$)) {
					var _v12 = _v11.a;
					var account = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						var quickbooksIntegration = response.a;
						return _Utils_Tuple3(
							$author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(
								_Utils_update(
									model,
									{w: $elm$core$Maybe$Nothing, c8: quickbooksIntegration})),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Quickbooks account successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									w: $elm$core$Maybe$Just(
										A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, form, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var quickbooksCategoryMapping = msg.a;
				var form = $author$project$Utils$Form$init(
					A2($author$project$Components$Admin$Quickbooks$Mappings$mappingFormFieldsInit, quickbooksCategoryMapping, model.ln));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							w: $elm$core$Maybe$Just(
								A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, form, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				var _v14 = model.w;
				if ((!_v14.$) && (_v14.a.$ === 1)) {
					var _v15 = _v14.a;
					var quickbooksCategoryMapping = _v15.a;
					var form = _v15.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							$author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(
								_Utils_update(
									model,
									{w: $elm$core$Maybe$Nothing, nO: $author$project$Api$Data$Loading})),
							A2($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list, apiClient, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Quickbooks account successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									w: $elm$core$Maybe$Just(
										A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, form, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Admin$Quickbooks$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var quickbooksIntegration = response.a;
							var status = $author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration);
							var step = ((status === 'pending') || (status === 'active')) ? $author$project$Pages$Admin$Quickbooks$Top$Overview(quickbooksIntegration) : $author$project$Pages$Admin$Quickbooks$Top$Initial;
							var _v2 = ((status === 'pending') || (status === 'active')) ? A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A4($author$project$Components$Admin$Quickbooks$Mappings$init, model.D5, model.ZD, model.WF, quickbooksIntegration)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							var quickbooksMappings = _v2.a;
							var quickbooksMappingsCmd = _v2.b;
							var _v3 = (status === 'pending') ? A2(
								$elm$core$Tuple$mapFirst,
								A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Utils$Form$init),
								$author$project$Pages$Admin$Quickbooks$Top$initFormFields(quickbooksIntegration)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							var form = _v3.a;
							var formCmd = _v3.b;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A2(
									$elm$core$Tuple$mapSecond,
									function (cmd) {
										return $elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													formCmd,
													cmd,
													A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Quickbooks$Top$QuickbooksMappingsMsg, quickbooksMappingsCmd)
												]));
									},
									$author$project$Pages$Admin$Quickbooks$Top$sendOauthSuccessDataToBackend(
										_Utils_update(
											model,
											{PB: form, c8: response, gs: quickbooksMappings, _M: step}))));
						case 2:
							if (response.a.$ === 5) {
								var _v4 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{c8: response, _M: $author$project$Pages$Admin$Quickbooks$Top$Initial}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c8: response, _M: $author$project$Pages$Admin$Quickbooks$Top$Initial}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hz: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var confirmed = msg.a;
				if (confirmed) {
					var oauthConnectionUrl = A2(
						$elm$core$Maybe$andThen,
						$author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl,
						$author$project$Api$Data$toMaybe(model.c8));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hz: $elm$core$Maybe$Just($author$project$Api$Data$Loading),
								jY: $author$project$Api$Data$Loading
							}),
						function () {
							if (!oauthConnectionUrl.$) {
								var oauthConnectionUrl_ = oauthConnectionUrl.a;
								return $author$project$Ports$Navigation$openInNewWindow(oauthConnectionUrl_);
							} else {
								return A2($author$project$Api$Provider$Integration$Quickbooks$create, model.D5, $author$project$Pages$Admin$Quickbooks$Top$Created);
							}
						}(),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hz: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var quickbooksIntegration = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c8: response}),
						function () {
							var _v7 = $author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl(quickbooksIntegration);
							if (!_v7.$) {
								var oauthConnectionUrl = _v7.a;
								return $author$project$Ports$Navigation$openInNewWindow(oauthConnectionUrl);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c8: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var query = A2(
						$elm$core$Dict$remove,
						'realmId',
						A2(
							$elm$core$Dict$remove,
							'state',
							A2($elm$core$Dict$remove, 'code', model.Bi)));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Bi: query, c8: $author$project$Api$Data$Loading, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Utils$Route$navigate, query, $author$project$Spa$Generated$Route$Admin__Quickbooks__Top),
									A2($author$project$Api$Provider$Integration$Quickbooks$retrieve, model.D5, $author$project$Pages$Admin$Quickbooks$Top$GotQuickbooksIntegration)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c8: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var _v9 = model.PB;
				if (!_v9.$) {
					var form = _v9.a;
					var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Quickbooks$Top$formFieldsValidator, form);
					if (!_v10.$) {
						var _v11 = _v10.a;
						var newForm = _v11.a;
						var validFields = _v11.b;
						var _v12 = $rtfeldman$elm_validate$Validate$fromValid(validFields);
						var syncDepositsAvailableOnOrAfter = _v12.$g;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							A3($author$project$Api$Provider$Integration$Quickbooks$activate, model.D5, syncDepositsAvailableOnOrAfter, $author$project$Pages$Admin$Quickbooks$Top$Activated),
							_List_Nil);
					} else {
						var newForm = _v10.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var outMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your quickbooks integration has been activated')
							]);
					} else {
						return $author$project$OutMsg$handleErrorResponse(response);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c8: response, jY: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					outMsgs);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fl: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var confirm = msg.a;
				return confirm ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fl: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
						}),
					A2($author$project$Api$Provider$Integration$Quickbooks$deactivate, model.D5, $author$project$Pages$Admin$Quickbooks$Top$Deactivated),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{fl: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var response = msg.a;
				var outMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your quickbooks integration has been deactivated')
							]);
					} else {
						return $author$project$OutMsg$handleErrorResponse(response);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fl: $elm$core$Maybe$Nothing, c8: response, _M: $author$project$Pages$Admin$Quickbooks$Top$Initial}),
					$elm$core$Platform$Cmd$none,
					outMsgs);
			case 10:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v15 = model.PB;
				if (!_v15.$) {
					var form = _v15.a;
					var _v16 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
					var newDateInput = _v16.a;
					var subCmd = _v16.b;
					var event = _v16.c;
					var newForm = function () {
						if (event.$ === 1) {
							var date = event.a;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Admin$Quickbooks$Top$formFieldsUpdate,
								A2($author$project$Pages$Admin$Quickbooks$Top$Date, newDateInput, date),
								form);
						} else {
							var _v18 = $author$project$Utils$Form$fields(form);
							var syncDepositsAvailableOnOrAfter = _v18.$g;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Admin$Quickbooks$Top$formFieldsUpdate,
								A2($author$project$Pages$Admin$Quickbooks$Top$Date, newDateInput, syncDepositsAvailableOnOrAfter),
								form);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Admin$Quickbooks$Top$DateInputMsg(newDateInput),
							subCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v19 = model.gs;
				if (!_v19.$) {
					var quickbooksMappings = _v19.a;
					var _v20 = A3($author$project$Components$Admin$Quickbooks$Mappings$update, model.D5, subMsg, quickbooksMappings);
					var quickbooksMappings_ = _v20.a;
					var quickbooksMappingsCmd = _v20.b;
					var quickbooksMappingsOutMsgs = _v20.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gs: $elm$core$Maybe$Just(quickbooksMappings_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Quickbooks$Top$QuickbooksMappingsMsg, quickbooksMappingsCmd),
						quickbooksMappingsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Ui$Image$QuickBooksLogo = 8;
var $author$project$Pages$Admin$Quickbooks$Top$initialStepSkeleton = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$spanFromText('inactive')
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(4)
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('About'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(10)
							]))
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('How it works'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$block,
								$author$project$Ui$Skeleton$span(6)
							])),
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$block,
								$author$project$Ui$Skeleton$span(7)
							])),
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$block,
								$author$project$Ui$Skeleton$span(10)
							]))
					]))
			]))
	]);
var $author$project$Components$Admin$Quickbooks$Mappings$AccountFormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$Extid = $elm$core$Basics$identity;
var $author$project$Components$Admin$Quickbooks$Mappings$Save = {$: 5};
var $author$project$Components$Admin$Quickbooks$Mappings$quickBooksAccountOptions = function (quickbooksAccounts) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Select a QuickBooks Account'),
		A2(
			$elm$core$List$map,
			function (quickbooksAccount) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					quickbooksAccount.adf,
					A2($elm$core$Maybe$withDefault, 'N/A', quickbooksAccount.zh));
			},
			quickbooksAccounts));
};
var $author$project$Components$Admin$Quickbooks$Mappings$viewForm = F3(
	function (form, quickbooksAccounts, saveRequest) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Account',
			S_: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(''),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Admin$Quickbooks$Mappings$CancelEdit,
			U0: $elm$core$Basics$always($author$project$Components$Admin$Quickbooks$Mappings$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('QuickBooks account'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(fields.adf),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$Quickbooks$Mappings$AccountFormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]),
							$author$project$Components$Admin$Quickbooks$Mappings$quickBooksAccountOptions(quickbooksAccounts))
						]))
				]));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.w;
	if (!_v1.$) {
		if (!_v1.a.$) {
			var _v2 = _v1.a;
			var account = _v2.a;
			var form = _v2.b;
			var saveRequest = _v2.c;
			var quickbooksAccounts = function () {
				switch (account) {
					case 0:
						return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(model.lS)));
					case 1:
						return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(model.md)));
					case 2:
						return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(model.hH)));
					default:
						return model.ln;
				}
			}();
			return A3($author$project$Components$Admin$Quickbooks$Mappings$viewForm, form, quickbooksAccounts, saveRequest);
		} else {
			var _v4 = _v1.a;
			var form = _v4.b;
			var saveRequest = _v4.c;
			return A3($author$project$Components$Admin$Quickbooks$Mappings$viewForm, form, model.ln, saveRequest);
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$HiConfirm$TitleizeNoun = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HiConfirm$titleizeNoun = $author$project$Components$HiConfirm$TitleizeNoun;
var $author$project$Pages$Admin$Quickbooks$Top$viewStatus = function (status) {
	return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
};
var $author$project$Pages$Admin$Quickbooks$Top$viewStatusLeft = F2(
	function (status, content) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Typography$label,
					_List_fromArray(
						[$author$project$Ui$Typography$controlLabel]),
					_List_fromArray(
						[
							$elm$html$Html$text('Status ')
						])),
				A2(
					$elm$core$List$cons,
					$author$project$Utils$Html$noBreakSpace,
					A2(
						$elm$core$List$cons,
						$author$project$Pages$Admin$Quickbooks$Top$viewStatus(status),
						A2($elm$core$List$cons, $author$project$Utils$Html$noBreakSpace, content)))));
	});
var $author$project$Pages$Admin$Quickbooks$Top$viewDownloadingStep = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			A2($author$project$Pages$Admin$Quickbooks$Top$viewStatusLeft, 'downloading', _List_Nil),
			$elm$html$Html$text('We are loading your accounts from QuickBooks. After that, you\'ll be able to connect those with Hint categories.'),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil)
				]))
		]));
var $author$project$Pages$Admin$Quickbooks$Top$AuthorizeOnQuickbooks = {$: 1};
var $author$project$Ui$Button$Background = 9;
var $author$project$Ui$Image$QuickBooksConnectButton = 9;
var $author$project$Ui$Padding$X_1 = 10;
var $author$project$Ui$Image$Class = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Image$class = $author$project$Ui$Image$Class;
var $author$project$Ui$OrderedList$Margin = $elm$core$Basics$identity;
var $author$project$Ui$OrderedList$margin = $elm$core$Basics$identity;
var $author$project$Ui$OrderedList$Padding = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$OrderedList$padding = $author$project$Ui$OrderedList$Padding;
var $author$project$Pages$Admin$Quickbooks$Top$viewInitialStep = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				(!model.vR) ? A2(
				$author$project$Ui$Alert$info,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Your current plan does not support this integration')
											])),
										A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Contact our customer success team to learn more about the required pricing scheme and update your plan.')
											]))
									]))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$Quickbooks$Top$viewStatus('inactive')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Connect to quickbooks online'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Admin$Quickbooks$Top$AuthorizeOnQuickbooks),
								$author$project$Ui$Button$disabled(!model.vR),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$styled(9)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Image$view,
								model.qT,
								{I1: 'Connect to QuickBooks Online button'},
								_List_fromArray(
									[
										$author$project$Ui$Image$class('w-72')
									]),
								9)
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('About'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Save time allocating your revenue and expenses to the correct QuickBooks accounts by connecting Hint to QuickBooks Online.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(' How it works'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$OrderedList$view,
								_List_fromArray(
									[
										$author$project$Ui$OrderedList$padding(10)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$OrderedList$item,
										_List_fromArray(
											[
												$author$project$Ui$OrderedList$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Log in to QuickBooks Online and give Hint permission to access your account.')
											])),
										A2(
										$author$project$Ui$OrderedList$item,
										_List_fromArray(
											[
												$author$project$Ui$OrderedList$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Match your Hint revenue and expense categories to the appropriate accounts in QuickBooks.')
											])),
										A2(
										$author$project$Ui$OrderedList$item,
										_List_fromArray(
											[
												$author$project$Ui$OrderedList$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Hint starts syncing, which means Hint will automatically split your deposits into the appropriate accounts in QuickBooks. All you need to do is reconcile your transactions as usual!')
											]))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Need help? '),
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/integrations/quickbooks-online-integration',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('Read the Knowledge Base article.')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Quickbooks$Top$Activate = {$: 5};
var $author$project$Pages$Admin$Quickbooks$Top$viewOverviewFooter = F2(
	function (model, quickbooksIntegration) {
		return ($author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration) === 'pending') ? A2(
			$author$project$Ui$Panel$footer,
			_List_fromArray(
				[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyCenter]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Activate integration'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Pages$Admin$Quickbooks$Top$Activate),
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$loading(
							_Utils_eq(model.jY, $author$project$Api$Data$Loading))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Activate')
						]))
				])) : $author$project$Ui$Panel$none;
	});
var $author$project$Pages$Admin$Quickbooks$Top$Deactivate = {$: 7};
var $author$project$Api$Provider$QuickbooksIntegration$One$errorsCount = function (_v0) {
	var record = _v0.b;
	return record.OO;
};
var $author$project$Components$Admin$Quickbooks$Mappings$hasUnmappedCategories = function (quickbooksCategoryMappings) {
	return A2(
		$elm$core$List$any,
		function (quickbooksCategoryMapping) {
			return !$author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$QuickbooksAccount$Min$extid(
					$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping)));
		},
		quickbooksCategoryMappings);
};
var $author$project$Ui$Form$Group$LabelInsideControl = {$: 11};
var $author$project$Ui$Form$Group$labelInsideControl = $author$project$Ui$Form$Group$LabelInsideControl;
var $elm$html$Html$u = _VirtualDom_node('u');
var $author$project$Ui$Typography$u = F2(
	function (options, content) {
		return A2(
			$elm$html$Html$u,
			$author$project$Ui$Typography$optionsToAttributes(options),
			content);
	});
var $author$project$Components$Admin$Quickbooks$Mappings$EditAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$viewAccount = F2(
	function (account, otherMappings) {
		var label = function () {
			switch (account) {
				case 0:
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Deposit Amounts')
								]))
						]);
				case 1:
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Transaction Fees')
								]))
						]);
				case 2:
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Discrepancy Amounts')
								]))
						]);
				default:
					return _List_fromArray(
						[
							$elm$html$Html$text('Hint category: '),
							$author$project$Ui$SvgIcon$minus(_List_Nil)
						]);
			}
		}();
		var info = function () {
			switch (account) {
				case 0:
					return 'Map this to your \"Undeposited Funds\" account.';
				case 1:
					return 'The cost to you to process transactions through this platform and its partners.';
				case 2:
					return 'We’ll use this account to balance out discrepancies between this platform and your bank deposits, usually caused by payment disputes.';
				default:
					return 'Includes charges that haven\'t been assigned to a category in this platform. You can leave this unmatched in order to stop deposits with uncategorized charges from syncing.';
			}
		}();
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_Utils_ap(
								label,
								_List_fromArray(
									[
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text(info)
											]))
									])))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[$author$project$Ui$Icon$textMuted]),
									17)
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('QuickBooks account:')
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(4)
						]),
					_List_fromArray(
						[
							function () {
							if (otherMappings.$ === 1) {
								var discrepancyAccount = otherMappings.a.NN;
								var feeAccount = otherMappings.a.Pe;
								var depositAccount = otherMappings.a.Ns;
								var uncategorizedAccount = otherMappings.a.aag;
								var otherMapping = function () {
									switch (account) {
										case 2:
											return discrepancyAccount;
										case 1:
											return feeAccount;
										case 0:
											return depositAccount;
										default:
											return uncategorizedAccount;
									}
								}();
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$Maybe$withDefault, 'N/A', otherMapping.zh)),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Eddit account'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Admin$Quickbooks$Mappings$EditAccount(account)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												]))
										]));
							} else {
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(4)
												]))
										]));
							}
						}()
						]))
				]));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$EditQuickbooksCategoryMapping = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccount = F2(
	function (loading, quickbooksCategoryMapping) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Hint category: '),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Category$Min$name(
												$author$project$Api$Provider$QuickbooksCategoryMapping$All$category(quickbooksCategoryMapping)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[$author$project$Ui$Icon$textMuted]),
									17)
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('QuickBooks account:')
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(4)
						]),
					_List_fromArray(
						[
							function () {
							if (loading) {
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(4)
												]))
										]));
							} else {
								var quickbooksAccount = $author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping);
								return A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											$author$project$Utils$Maybe$toBool(
												$author$project$Api$Provider$QuickbooksAccount$Min$extid(quickbooksAccount)) ? _List_Nil : _List_fromArray(
												[$author$project$Ui$Typography$italic]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'Not assigned - will not sync',
														$author$project$Api$Provider$QuickbooksAccount$Min$name(
															$author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping))))
												])),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Edit category mapping'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Admin$Quickbooks$Mappings$EditQuickbooksCategoryMapping(quickbooksCategoryMapping)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												]))
										]));
							}
						}()
						]))
				]));
	});
var $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccountSkeleton = A2(
	$author$project$Ui$FlexGrid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(4)
								]))
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(2)
				]),
			_List_Nil),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(2)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(8)
										]))
								]))
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$span(3)
								]))
						]))
				]))
		]));
var $author$project$Components$Admin$Quickbooks$Mappings$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Other Accounts'),
						$author$project$Ui$Form$Group$labelInsideControl
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The below accounts allow us to ensure we can correctly auto-match revenue from this platform with deposits in QuickBooks.')
							]))
					])),
				A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 0, model.gb),
				A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 1, model.gb),
				A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 2, model.gb),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Income Accounts'),
						$author$project$Ui$Form$Group$labelInsideControl
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Match each revenue category from this platform (on the left) to the desired income account in QuickBooks (on the right). '),
								A2(
								$author$project$Ui$Typography$u,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You must create your desired income accounts in QuickBooks prior to the matching process.')
									])),
								$elm$html$Html$text(' Every category on the left must be matched in order to activate the integration.')
							]))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				function () {
					var _v1 = model.nO;
					if (_v1.$ === 3) {
						var quickbooksCategoryMappings = _v1.a;
						var loadingQuickbooksAccounts = !$author$project$Utils$Maybe$toBool(
							$author$project$Api$Data$toMaybe(model.hH));
						return A2(
							$elm$core$List$map,
							$author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccount(loadingQuickbooksAccounts),
							quickbooksCategoryMappings);
					} else {
						return A2($elm$core$List$repeat, 10, $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccountSkeleton);
					}
				}()),
				A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 3, model.gb),
				function () {
				var _v2 = model.nO;
				if (_v2.$ === 3) {
					var quickbooksCategoryMappings = _v2.a;
					return $author$project$Components$Admin$Quickbooks$Mappings$hasUnmappedCategories(quickbooksCategoryMappings) ? A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Deposits with transactions in unmatched platform categories won\'t appear on QuickBooks.')
							])) : $author$project$Utils$Html$empty;
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$Admin$Quickbooks$Top$viewSyncForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Start syncing on'),
						$author$project$Ui$Form$Group$labelInsideControl,
						$author$project$Ui$Form$Group$inputSpanMd(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Hint will begin syncing transaction information for deposits made on or after this date. '),
								$elm$html$Html$text('We recommend selecting a date in the future to prevent the integration from affecting past '),
								$elm$html$Html$text('deposits that had already been reconciled in QuickBooks.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$inputSpanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Quickbooks$Top$DateInputMsg(fields.qd),
						A2(
							$author$project$Components$DateInput$view,
							_List_fromArray(
								[
									$author$project$Components$DateInput$value(fields.$g)
								]),
							fields.qd))
					]))
			]));
};
var $author$project$Pages$Admin$Quickbooks$Top$viewOverviewStep = F2(
	function (model, quickbooksIntegration) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Admin$Quickbooks$Top$viewStatusLeft,
					$author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Deactivate quickbooks integratoins'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Admin$Quickbooks$Top$Deactivate),
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$pull(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Deactivate the integration')
								])),
							($author$project$Api$Provider$QuickbooksIntegration$One$errorsCount(quickbooksIntegration) > 0) ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$danger]),
							_List_fromArray(
								[
									A2($author$project$Ui$Icon$view, _List_Nil, 19),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$String$pluralize,
												'deposit',
												$author$project$Api$Provider$QuickbooksIntegration$One$errorsCount(quickbooksIntegration))),
											$elm$html$Html$text(' failed to sync in the last 180 days. '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__Custom__Id_String(
												{adR: 'rpt-xrMXbiUetHe1'}),
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('View errors on the report.')
												]))
										]))
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('')
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = model.gs;
							if (!_v0.$) {
								var quickbooksMappings = _v0.a;
								return A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Quickbooks$Top$QuickbooksMappingsMsg,
									$author$project$Components$Admin$Quickbooks$Mappings$view(quickbooksMappings));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					function () {
					var _v1 = model.PB;
					if (!_v1.$) {
						var form = _v1.a;
						return $author$project$Pages$Admin$Quickbooks$Top$viewSyncForm(form);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Pages$Admin$Quickbooks$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.hz;
				if (!_v0.$) {
					var autorizeRequest = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Quickbooks$Top$AuthorizeOnQuickbooksHiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('connect'),
								$author$project$Components$HiConfirm$titleizeNoun(false),
								$author$project$Components$HiConfirm$noun('to QuickBooks Online'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Hint provides this integration only as a convenience to you. QuickBooks is solely responsible for its service, content and policies, including those related to privacy and security. Please review QuickBooks\' Terms of Service, and Privacy Policy to ensure they meet your business and legal requirements.')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(autorizeRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.gs;
				if (!_v1.$) {
					var quickbooksMappings = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Admin$Quickbooks$Top$QuickbooksMappingsMsg,
						$author$project$Components$Admin$Quickbooks$Mappings$modal(quickbooksMappings));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.fl;
				if (!_v2.$) {
					var deactivate = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Quickbooks$Top$DeactivateHiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('disconnect'),
								$author$project$Components$HiConfirm$noun('Quickbooks'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deactivate, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Image$view,
								model.qT,
								{I1: 'QuickBooks Online Logo'},
								_List_fromArray(
									[
										$author$project$Ui$Image$width(200)
									]),
								8)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v3 = model.c8;
							if (_v3.$ === 1) {
								return $author$project$Pages$Admin$Quickbooks$Top$initialStepSkeleton;
							} else {
								return _List_fromArray(
									[
										function () {
										var _v4 = model._M;
										switch (_v4.$) {
											case 0:
												return $author$project$Pages$Admin$Quickbooks$Top$viewInitialStep(model);
											case 1:
												return $author$project$Pages$Admin$Quickbooks$Top$viewDownloadingStep;
											default:
												var quickbooksIntegration = _v4.a;
												return A2($author$project$Pages$Admin$Quickbooks$Top$viewOverviewStep, model, quickbooksIntegration);
										}
									}()
									]);
							}
						}()),
						function () {
						var _v5 = model._M;
						switch (_v5.$) {
							case 0:
								return $author$project$Ui$Panel$none;
							case 1:
								return $author$project$Ui$Panel$none;
							default:
								var quickbooksIntegration = _v5.a;
								return A2($author$project$Pages$Admin$Quickbooks$Top$viewOverviewFooter, model, quickbooksIntegration);
						}
					}()
					]))
			]),
		$G: 'Integrations | Quickbooks'
	};
};
var $author$project$Pages$Admin$Quickbooks$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Quickbooks$Top$init, aer: $author$project$Pages$Admin$Quickbooks$Top$load, agD: $author$project$Pages$Admin$Quickbooks$Top$save, ahd: $author$project$Pages$Admin$Quickbooks$Top$subscriptions, aaq: $author$project$Pages$Admin$Quickbooks$Top$update, ahP: $author$project$Pages$Admin$Quickbooks$Top$view});
var $author$project$Spa$Page$applicationPrivate = function (page) {
	return {
		ad0: F2(
			function (shared, url) {
				var _v0 = shared.ZD;
				switch (_v0.$) {
					case 3:
						var session = _v0.a;
						return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) ? _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								A2($author$project$Permission$homeStateFor, session, shared.adN)),
							_List_Nil) : A2(
							$author$project$Utils$Tuple3$mapFirst,
							$author$project$Spa$Page$SessionLoaded,
							A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A3(page.ad0, session, shared, url)));
					case 1:
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 0:
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$author$project$Ports$Session$authorize(
								{af6: true}),
							_List_Nil);
					default:
						return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		aer: F2(
			function (shared, model) {
				var _v1 = _Utils_Tuple2(shared.ZD, model);
				_v1$2:
				while (true) {
					if (!_v1.b.$) {
						switch (_v1.a.$) {
							case 3:
								var _v2 = _v1.a;
								var session = _v2.a;
								var url = _v1.b.a;
								if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) {
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										A2(
											$author$project$Utils$Route$navigate,
											$elm$core$Dict$empty,
											A2($author$project$Permission$homeStateFor, session, shared.adN)),
										_List_Nil);
								} else {
									var _v3 = A3(page.ad0, session, shared, url);
									var pageModel = _v3.a;
									var cmd = _v3.b;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoaded(pageModel),
										cmd,
										_List_Nil);
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$fromTuple2,
						_List_Nil,
						A2(
							$elm$core$Tuple$mapFirst,
							$author$project$Spa$Page$SessionLoaded,
							A2(
								page.aer,
								shared,
								_Utils_update(
									modelWithSession,
									{D5: shared.D5}))));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		agD: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.agD, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		ahd: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahd(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		aaq: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.aaq, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		ahP: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahP(modelWithSession);
			} else {
				return {e5: $author$project$Components$BlankPage$view, $G: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Admin$ScheduledJobs$GotScheduledJobs = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$ScheduledJob$ScheduledJob = $elm$core$Basics$identity;
var $author$project$Api$ScheduledJob$OptionsRecord = function (description) {
	return {Nx: description};
};
var $author$project$Api$ScheduledJob$optionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$ScheduledJob$OptionsRecord));
var $author$project$Api$ScheduledJob$itemDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (a) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (b) {
				return A2(
					$elm$json$Json$Decode$map,
					function (c) {
						return _Utils_Tuple3(a, b, c);
					},
					A2($elm$json$Json$Decode$index, 2, $author$project$Api$ScheduledJob$optionsRecordDecoder));
			},
			A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
	},
	A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
var $author$project$Api$ScheduledJob$scheduledJobDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$ScheduledJob$itemDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$ScheduledJob$scheduledJobsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['scheduled_jobs']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$ScheduledJob$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$ScheduledJob$scheduledJobDecoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$ScheduledJob$scheduledJobsPath));
	});
var $author$project$Pages$Admin$ScheduledJobs$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.D5;
		return _Utils_Tuple2(
			{D5: apiClient, sz: $author$project$Api$Data$Loading, oS: $elm$core$Maybe$Nothing},
			A2($author$project$Api$ScheduledJob$list, apiClient, $author$project$Pages$Admin$ScheduledJobs$GotScheduledJobs));
	});
var $author$project$Pages$Admin$ScheduledJobs$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$ScheduledJobs$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Admin$ScheduledJobs$subscriptions = function (_v0) {
	var triggerScheduledJobIndex = _v0.oS;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed),
			triggerScheduledJobIndex));
};
var $author$project$Pages$Admin$ScheduledJobs$GotTriggerResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$ScheduledJob$trigger = F3(
	function (apiClient, scheduledJobId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'scheduled_job',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$int(scheduledJobId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$ScheduledJob$scheduledJobsPath)));
	});
var $author$project$Pages$Admin$ScheduledJobs$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var index = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							oS: $elm$core$Maybe$Just(index)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var index = msg.a;
				var confirmed = msg.b;
				var cmd = confirmed ? A3($author$project$Api$ScheduledJob$trigger, model.D5, index, $author$project$Pages$Admin$ScheduledJobs$GotTriggerResponse) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oS: $elm$core$Maybe$Nothing}),
					cmd,
					_List_Nil);
			case 0:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Job Enqueued!')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var dataScheduledJobs = msg.a;
				var newModel = _Utils_update(
					model,
					{sz: dataScheduledJobs});
				if (dataScheduledJobs.$ === 2) {
					var error = dataScheduledJobs.a;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error)),
							$author$project$OutMsg$reportDecodeError(dataScheduledJobs)));
				} else {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$ScheduledJobs$TriggerScheduledJob = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$ScheduledJob$cron = function (_v0) {
	var _v1 = _v0;
	var cron_ = _v1.a;
	return cron_;
};
var $author$project$Pages$Admin$ScheduledJobs$cronGuruLink = function (cron) {
	return 'https://crontab.guru/#' + A3($elm$core$String$replace, ' ', '_', cron);
};
var $author$project$Api$ScheduledJob$description = function (_v0) {
	var _v1 = _v0;
	var optionsRecord = _v1.c;
	return optionsRecord.Nx;
};
var $author$project$Api$ScheduledJob$name = function (_v0) {
	var _v1 = _v0;
	var name_ = _v1.b;
	return name_;
};
var $author$project$Pages$Admin$ScheduledJobs$viewScheduledJobs = F2(
	function (index, scheduledJob) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$ScheduledJob$description(scheduledJob))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$ScheduledJob$name(scheduledJob))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$externalHref,
							$author$project$Pages$Admin$ScheduledJobs$cronGuruLink(
								$author$project$Api$ScheduledJob$cron(scheduledJob)),
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$ScheduledJob$cron(scheduledJob))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Enqueue scheduled job now'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Admin$ScheduledJobs$TriggerScheduledJob(index))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Enqueue Now')
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$ScheduledJobs$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.oS;
				if (!_v0.$) {
					var index = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed(index),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Are you sure you want to enqueue this job?')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Scheduled Jobs')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$loading(
										!$author$project$Api$Data$isSuccess(model.sz))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Description')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Worker Name')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Cron Schedule')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('')
											]))
									]),
								function () {
									var _v1 = model.sz;
									if (_v1.$ === 3) {
										var scheduledJobs = _v1.a;
										return A2($elm$core$List$indexedMap, $author$project$Pages$Admin$ScheduledJobs$viewScheduledJobs, scheduledJobs);
									} else {
										return _List_Nil;
									}
								}(),
								_List_Nil)
							]))
					]))
			]),
		$G: 'Admin | Scheduled Jobs'
	};
};
var $author$project$Pages$Admin$ScheduledJobs$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Admin$ScheduledJobs$init, aer: $author$project$Pages$Admin$ScheduledJobs$load, agD: $author$project$Pages$Admin$ScheduledJobs$save, ahd: $author$project$Pages$Admin$ScheduledJobs$subscriptions, aaq: $author$project$Pages$Admin$ScheduledJobs$update, ahP: $author$project$Pages$Admin$ScheduledJobs$view});
var $author$project$Api$Provider$Practice$One$membershipCancellationEnabled = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.aeB;
	});
var $author$project$Pages$Admin$SelfService$mapFormFields = function (practice) {
	return {
		aeB: $author$project$Api$Provider$Practice$One$membershipCancellationEnabled(practice)
	};
};
var $author$project$Pages$Admin$SelfService$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		return _Utils_Tuple2(
			{
				D5: apiClient,
				adm: $author$project$Pages$Admin$SelfService$mapFormFields(practice),
				WF: practice,
				ZD: session
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SelfService$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SelfService$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$SelfService$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$SelfService$MembershipCancellationToggled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$SelfService$updateField = F2(
	function (field, fields) {
		var enabled = field;
		return _Utils_update(
			fields,
			{aeB: enabled});
	});
var $author$project$Api$Provider$Practice$updateMembershipCancellationEnabled = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'membership_cancellation_enabled',
								$elm$json$Json$Encode$bool(fields.aeB))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Admin$SelfService$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var field = msg.a;
			var newFields = A2(
				$author$project$Pages$Admin$SelfService$updateField,
				field,
				$author$project$Pages$Admin$SelfService$mapFormFields(model.WF));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{adm: newFields}),
				A3($author$project$Api$Provider$Practice$updateMembershipCancellationEnabled, model.D5, newFields, $author$project$Pages$Admin$SelfService$MembershipCancellationToggled),
				_List_Nil);
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var practice = response.a;
				var newModel = _Utils_update(
					model,
					{
						adm: $author$project$Pages$Admin$SelfService$mapFormFields(practice),
						WF: practice
					});
				var message = 'Your practice has been updated';
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, message),
							$author$project$OutMsg$PracticeUpdated(response)
						]));
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Api$Provider$Practice$One$selfServiceRequestAccessUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Zi;
	});
var $author$project$Pages$Admin$SelfService$selfServiceUrl = function (practice) {
	return $author$project$Api$Provider$Practice$One$selfServiceRequestAccessUrl(practice);
};
var $author$project$Pages$Admin$SelfService$FieldChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$SelfService$MembershipCancellationEnabled = $elm$core$Basics$identity;
var $author$project$Pages$Admin$SelfService$settingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$labelSpan(9),
									$author$project$Ui$Form$Group$inputSpan(3),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_Nil)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(3),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	});
var $author$project$Pages$Admin$SelfService$viewMembershipCancellationSetting = function (fields) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(fields.aeB),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Admin$SelfService$FieldChanged, $elm$core$Basics$identity))
			]));
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Some states require that canceling a subscription must be as easy as signing up. If you offer online sign-up, be sure to check your state laws to stay compliant.')
					]))
			]));
	return A3(
		$author$project$Pages$Admin$SelfService$settingToggle,
		'Allow patients to cancel via patient portal',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Admin$SelfService$view = function (_v0) {
	var practice = _v0.WF;
	var fields = _v0.adm;
	return {
		e5: function () {
			var url = $author$project$Pages$Admin$SelfService$selfServiceUrl(practice);
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Patient Portal')
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Add this custom URL to your website to allow patients to manage their invoices, payment methods, plan members, and agreements.')
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$labelSpan(3),
													$author$project$Ui$Form$Group$inputSpan(4),
													$author$project$Ui$Form$Group$label('Patient Portal Self-Service URL')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$externalHref,
															url,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(url)
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(12)
												]),
											_List_fromArray(
												[
													$author$project$Ui$HorizontalRule$view(
													_List_fromArray(
														[$author$project$Ui$HorizontalRule$thin])),
													$author$project$Utils$Html$noBreakSpace,
													$author$project$Pages$Admin$SelfService$viewMembershipCancellationSetting(fields),
													$author$project$Utils$Html$noBreakSpace
												]))
										]))
								]))
						]))
				]);
		}(),
		$G: 'Admin | Self-Service'
	};
};
var $author$project$Pages$Admin$SelfService$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$SelfService$init, aer: $author$project$Pages$Admin$SelfService$load, agD: $author$project$Pages$Admin$SelfService$save, ahd: $author$project$Pages$Admin$SelfService$subscriptions, aaq: $author$project$Pages$Admin$SelfService$update, ahP: $author$project$Pages$Admin$SelfService$view});
var $author$project$Pages$Admin$Signup$GotCurrentDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Signup$InitPractice = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Signup$GotDefaultSignupPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$SignupPage$All$SignupPage = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupPage$Shared$SignupPage = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupPage$Shared$Record = function (id) {
	return function (slug) {
		return function (_default) {
			return function (active) {
				return function (type_) {
					return function (url) {
						return function (baseUrl) {
							return function (isDestroyable) {
								return function (acceptsNewSignup) {
									return function (limitAvailablePractitioners) {
										return function (limitAvailableLocations) {
											return function (limitAvailableLocationGroups) {
												return function (useCustomSettings) {
													return function (redirectsPostSignup) {
														return function (postSignupRedirectUrl) {
															return function (postSignupMessage) {
																return function (showPostSignupFooterButton) {
																	return function (postSignupButtonLabel) {
																		return function (chargeItem) {
																			return function (signupPagePlans) {
																				return function (addons) {
																					return {H1: acceptsNewSignup, Ic: active, Is: addons, abx: baseUrl, lp: chargeItem, M5: _default, adR: id, RJ: isDestroyable, SP: limitAvailableLocationGroups, SQ: limitAvailableLocations, SR: limitAvailablePractitioners, WB: postSignupButtonLabel, WC: postSignupMessage, WD: postSignupRedirectUrl, X1: redirectsPostSignup, ZX: showPostSignupFooterButton, Z4: signupPagePlans, _c: slug, ahI: type_, aav: url, aaw: useCustomSettings};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$SignupPagePlan$Shared$SignupPagePlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupPagePlan$Shared$Record = F2(
	function (id, plan) {
		return {adR: id, GH: plan};
	});
var $author$project$Api$Provider$SignupPagePlan$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPagePlan$Shared$Record)));
var $author$project$Api$Provider$SignupPagePlan$Shared$sharedDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPagePlan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupPage$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'addons',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Addon$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'signup_page_plans',
		$elm$json$Json$Decode$list($author$project$Api$Provider$SignupPagePlan$Shared$sharedDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge_item',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$ChargeItem$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'post_signup_button_label',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'show_post_signup_footer_button',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'post_signup_message',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'post_signup_redirect_url',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'redirects_post_signup',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'use_custom_settings',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'limit_available_location_groups',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'limit_available_locations',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'limit_available_practitioners',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'accepts_new_signup',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'is_destroyable',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'base_url',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'url',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'type',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'active',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'default',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'slug',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'id',
																					$elm$json$Json$Decode$string,
																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$Shared$Record))))))))))))))))))))));
var $author$project$Api$Provider$SignupPage$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPage$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupPage$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPage$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SignupPage$signupPagesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['signup_pages']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$SignupPage$getDefault = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$SignupPage$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$bool, 'default', true)
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
	});
var $author$project$Pages$Admin$Signup$getDefaultSignupPage = function (model) {
	return A2($author$project$Api$Provider$SignupPage$getDefault, model.D5, $author$project$Pages$Admin$Signup$GotDefaultSignupPage);
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$postSignupButtonLabel = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.WB;
	});
var $author$project$Api$Provider$Practice$One$postSignupMessage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.WC;
	});
var $author$project$Api$Provider$Practice$One$postSignupRedirectUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.WD;
	});
var $author$project$Api$Provider$Practice$One$redirectsPostSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.X1;
	});
var $author$project$Api$Provider$Practice$One$showPostSignupFooterButton = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.ZX;
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsInit = function (practice) {
	return {
		WB: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Practice$One$postSignupButtonLabel(practice)),
		WC: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Practice$One$postSignupMessage(practice)),
		WD: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Practice$One$postSignupRedirectUrl(practice)),
		X1: $author$project$Api$Provider$Practice$One$redirectsPostSignup(practice),
		ZX: $author$project$Api$Provider$Practice$One$showPostSignupFooterButton(practice)
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init = function (practice) {
	return {
		ij: $elm$core$Set$empty,
		fE: _List_Nil,
		PB: $author$project$Utils$Form$init(
			$author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsInit(practice)),
		oY: $jinjor$elm_debounce$Debounce$init
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$allowPayerOnBehalfOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.IY;
	});
var $author$project$Api$Provider$Practice$One$allowedZipCodesOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.I0;
	});
var $author$project$Api$Provider$Practice$One$autoConfirmSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.JD;
	});
var $author$project$Api$Provider$Practice$One$collectAddressOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.K7;
	});
var $author$project$Api$Provider$Practice$One$collectBillingAddressOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.K8;
	});
var $author$project$Api$Provider$Practice$One$collectBrokerOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.K9;
	});
var $author$project$Api$Provider$Practice$One$collectInsuranceOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lc;
	});
var $author$project$Api$Provider$Practice$One$collectLeadSourceOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Ld;
	});
var $author$project$Api$Provider$Practice$One$mergeDuplicatePatientsOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.TS;
	});
var $author$project$Api$Provider$Practice$One$minEnrollAge = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.T_;
	});
var $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.WX;
	});
var $author$project$Api$Provider$Practice$One$restrictZipCodesOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Yx;
	});
var $author$project$Api$Provider$Practice$One$startDateSelectableOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $._F;
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsInit = function (practice) {
	var minEnrollAge = $author$project$Api$Provider$Practice$One$minEnrollAge(practice);
	return {
		IY: $author$project$Api$Provider$Practice$One$allowPayerOnBehalfOnSignup(practice),
		pv: $author$project$Api$Provider$Practice$One$allowedZipCodesOnSignup(practice),
		k7: $author$project$Api$Provider$Practice$One$autoConfirmSignup(practice),
		K7: $author$project$Api$Provider$Practice$One$collectAddressOnSignup(practice),
		K8: $author$project$Api$Provider$Practice$One$collectBillingAddressOnSignup(practice),
		K9: $author$project$Api$Provider$Practice$One$collectBrokerOnSignup(practice),
		Lc: $author$project$Api$Provider$Practice$One$collectInsuranceOnSignup(practice),
		Ld: $author$project$Api$Provider$Practice$One$collectLeadSourceOnSignup(practice),
		ab7: $author$project$Api$Provider$Practice$One$collectLocationOnSignup(practice),
		Lg: $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice),
		Lh: $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice),
		SG: $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice),
		TS: $author$project$Api$Provider$Practice$One$mergeDuplicatePatientsOnSignup(practice),
		T_: minEnrollAge,
		m5: $author$project$Utils$Maybe$toBool(minEnrollAge),
		WX: $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup(practice),
		gy: $author$project$Api$Provider$Practice$One$restrictZipCodesOnSignup(practice),
		_F: $author$project$Api$Provider$Practice$One$startDateSelectableOnSignup(practice)
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed = {$: 0};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$init = $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed;
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Practice$One$acceptsAch = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.H_;
	});
var $author$project$Api$Provider$Practice$Shared$acceptsAmex = function (_v0) {
	var record = _v0;
	return record.H$;
};
var $author$project$Api$Provider$Practice$One$acceptsAmex = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$acceptsAmex(shared);
};
var $author$project$Api$Provider$Practice$Shared$acceptsCards = function (_v0) {
	var record = _v0;
	return record.H0;
};
var $author$project$Api$Provider$Practice$One$acceptsCards = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$acceptsCards(shared);
};
var $author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lf;
	});
var $author$project$Api$Provider$Practice$Shared$encourageAch = function (_v0) {
	var record = _v0;
	return record.Ou;
};
var $author$project$Api$Provider$Practice$One$encourageAch = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$encourageAch(shared);
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsInit = function (practice) {
	return {
		H_: $author$project$Api$Provider$Practice$One$acceptsAch(practice),
		H$: $author$project$Api$Provider$Practice$One$acceptsAmex(practice),
		H0: $author$project$Api$Provider$Practice$One$acceptsCards(practice),
		Lf: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup(practice)),
		Ou: $author$project$Api$Provider$Practice$One$encourageAch(practice)
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$init = function (practice) {
	var form = $author$project$Utils$Form$init(
		$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsInit(practice));
	var fields = $author$project$Utils$Form$fields(form);
	var model = {
		PB: form,
		WF: practice,
		GQ: $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup(practice),
		sJ: !fields.H$
	};
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Ui$TagsInput$init = function (id) {
	return {adR: id, qR: false, cV: '', sN: false};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$init = function (practice) {
	var _v0 = $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$init(practice);
	var paymentSourceComponentModel = _v0.a;
	return {
		lo: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$init,
		ij: $elm$core$Set$empty,
		fE: _List_Nil,
		PB: $author$project$Utils$Form$init(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsInit(practice)),
		rZ: paymentSourceComponentModel,
		WF: practice,
		tc: $author$project$Ui$TagsInput$init('restrict-by-zip-codes'),
		oY: $jinjor$elm_debounce$Debounce$init
	};
};
var $author$project$Api$Provider$SignupSettings$Min$customJavascriptText = function (_v0) {
	var record = _v0;
	return record.MD;
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsInit = function (fields) {
	return {
		qb: fields.qb,
		Z3: A2($elm$core$Maybe$withDefault, '', fields.Z3),
		_$: fields._$
	};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$init = function (fields) {
	return {
		ij: $elm$core$Set$empty,
		fE: _List_Nil,
		PB: $author$project$Utils$Form$init(
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsInit(fields)),
		s6: $author$project$Api$Data$NotAsked,
		oY: $jinjor$elm_debounce$Debounce$init
	};
};
var $author$project$Api$Provider$Practice$One$signupPageNotFoundRedirectUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Z3;
	});
var $author$project$Api$Provider$Practice$One$signupSettings = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Z5;
	});
var $author$project$Api$Expandable$toMaybe = function (expandable_) {
	if (!expandable_.$) {
		var a = expandable_.a;
		return $elm$core$Maybe$Just(a);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Admin$Signup$initSignupPageComponent = function (practice) {
	return $author$project$Components$Admin$GlobalSignupSettings$SignupPage$init(
		{
			qb: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$SignupSettings$Min$customJavascriptText,
					$author$project$Api$Expandable$toMaybe(
						$author$project$Api$Provider$Practice$One$signupSettings(practice)))),
			Z3: $author$project$Api$Provider$Practice$One$signupPageNotFoundRedirectUrl(practice),
			_$: $author$project$Api$Provider$Practice$One$subdomain(practice)
		});
};
var $author$project$Api$Provider$Practice$SignupSettings = 0;
var $author$project$Pages$Admin$Signup$practiceOptionals = function (optionals) {
	return _Utils_update(
		optionals,
		{
			Fc: _List_fromArray(
				[0])
		});
};
var $author$project$Pages$Admin$Signup$init = F4(
	function (session, practice, shared, _v0) {
		var settingsComponentModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice);
		var confirmationComponentModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice);
		var model = {
			D5: shared.D5,
			hR: confirmationComponentModel,
			cO: $elm$core$Maybe$Nothing,
			Nk: $elm$core$Maybe$Nothing,
			FR: $author$project$Shared$isHintAdmin(shared),
			WF: $author$project$Api$Data$Loading,
			ZD: session,
			j4: settingsComponentModel,
			gP: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$Practice$retrieve, shared.D5, $author$project$Pages$Admin$Signup$practiceOptionals, $author$project$Pages$Admin$Signup$InitPractice),
						$author$project$Pages$Admin$Signup$getDefaultSignupPage(model),
						A2($elm$core$Task$perform, $author$project$Pages$Admin$Signup$GotCurrentDate, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Pages$Admin$Signup$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Signup$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Signup$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Signup$ConfirmationComponentMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Signup$SettingsComponentMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Signup$SignupPageComponentMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$OnChange = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate = function (field) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges,
		$elm$core$Task$succeed(field));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors = function (model) {
	return _Utils_update(
		model,
		{fE: _List_Nil});
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup = function (bool) {
	return _Utils_Tuple2(
		'redirects_post_signup',
		$elm$json$Json$Encode$bool(bool));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeField = F2(
	function (model, field) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'post_signup_button_label',
							$elm$json$Json$Encode$string(string))
						]));
			case 1:
				var string = field.a;
				var _v1 = $author$project$Utils$Form$fields(model.PB);
				var redirectsPostSignup = _v1.X1;
				return $elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'post_signup_redirect_url',
							$elm$json$Json$Encode$string(string)),
						redirectsPostSignup ? _List_fromArray(
							[
								$author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup(redirectsPostSignup)
							]) : _List_Nil));
			case 2:
				var bool = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'show_post_signup_footer_button',
							$elm$json$Json$Encode$bool(bool))
						]));
			case 3:
				var bool = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							$author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup(bool)
						]));
			default:
				var string = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'post_signup_message',
							$elm$json$Json$Encode$string(string))
						]));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$CustomButtonUrlValidation = 0;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabelValidation = 1;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessageValidation = 4;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignupValidation = 3;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButtonValidation = 2;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldValidationGroup = function (field) {
	switch (field.$) {
		case 1:
			return 0;
		case 0:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup = F2(
	function (validation, errors) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var errValidation = _v0.a;
				var errMessage = _v0.b;
				return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
			},
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors = F2(
	function (validationGroup, errors) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup, validationGroup, errors));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldHasErrors = F2(
	function (model, field) {
		var errored = A2(
			$author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors,
			$author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldValidationGroup(field),
			model.fE);
		if (field.$ === 3) {
			var redirectsPostSignup = field.a;
			return redirectsPostSignup ? (errored || A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors, 0, model.fE)) : errored;
		} else {
			return errored;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName = function (field) {
	switch (field.$) {
		case 0:
			return 'postSignupButtonLabel';
		case 1:
			return 'customButtonUrl';
		case 2:
			return 'showPostSignupFooterButton';
		case 3:
			return 'redirectsPostSignup';
		default:
			return 'postSignupMessage';
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$isFieldDirty = F2(
	function (field, model) {
		return A2(
			$elm$core$Set$member,
			$author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field),
			model.ij);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$debounceUpdateForField = function (field) {
	switch (field.$) {
		case 0:
			return true;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$UpdateDebounceMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$UpdateDebounceMsg
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$processUpdate = F2(
	function (field, model) {
		if ($author$project$Components$Admin$GlobalSignupSettings$Confirmation$debounceUpdateForField(field)) {
			var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig, field, model.oY);
			var debounceModel = _v0.a;
			var debounceCmd = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{oY: debounceModel}),
				debounceCmd);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate(field));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldDirty = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				ij: A2(
					$elm$core$Set$insert,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field),
					model.ij)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldPristine = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				ij: A2(
					$elm$core$Set$remove,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field),
					model.ij)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{WB: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{WD: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ZX: bool});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{X1: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{WC: string});
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateField = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				PB: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsUpdate, field, model.PB)
			});
	});
var $author$project$Utils$Maybe$isNothing = function (maybe) {
	if (!maybe.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Utils$Validate$isInvalidUrlStricter = function (url) {
	return $elm$core$String$isEmpty(url) ? false : $author$project$Utils$Maybe$isNothing(
		$elm$url$Url$fromString(url));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validateCustomButtonUrl = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var postSignupRedirectUrl = _v0.WD;
	var redirectsPostSignup = _v0.X1;
	return (redirectsPostSignup && $author$project$Utils$String$isBlank(postSignupRedirectUrl)) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'cannot be blank')
		]) : ($author$project$Utils$Validate$isInvalidUrlStricter(postSignupRedirectUrl) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'is not a valid URL')
		]) : _List_Nil);
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$Confirmation$validateCustomButtonUrl)
		]));
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validate = function (model) {
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					model,
					{fE: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$validator,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors(model)))));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var modelWithForm = A2(
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldDirty,
					field,
					A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateField, field, model));
				var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$processUpdate, field, modelWithForm);
				var newModel = _v2.a;
				var updateCmd = _v2.b;
				return _Utils_Tuple3(newModel, updateCmd, $elm$core$Maybe$Nothing);
			case 1:
				var debounceMsg = msg.a;
				var _v3 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate),
					debounceMsg,
					model.oY);
				var newDebouncer = _v3.a;
				var debounceCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oY: newDebouncer}),
					debounceCmd,
					$elm$core$Maybe$Nothing);
			default:
				var field = msg.a;
				var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validate(model);
				if (A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$isFieldDirty, field, model) && (!A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldHasErrors, validatedModel, field))) {
					var pristineModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors(
						A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldPristine, field, model));
					return _Utils_Tuple3(
						pristineModel,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeField, pristineModel, field)));
				} else {
					return _Utils_Tuple3(validatedModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowedZipCodes = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$LaunchDate = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$OnChange = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge = {$: 3};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate = function (field) {
	_v0$2:
	while (true) {
		switch (field.$) {
			case 16:
				return A2(
					$elm$core$Task$perform,
					$elm$core$Basics$identity,
					$elm$core$Task$succeed($author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge));
			case 15:
				if (field.a) {
					return $elm$core$Platform$Cmd$none;
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges,
		$elm$core$Task$succeed(field));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue = F2(
	function (forceRequire, collectAddressOption) {
		return forceRequire ? 2 : collectAddressOption;
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress = function (collectOption) {
	return _Utils_Tuple2(
		'collect_address_on_signup',
		$author$project$Api$CollectOnSignup$encoder(collectOption));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject = F2(
	function (key, value) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(key, value)
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField = F2(
	function (model, field) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return (!bool) ? $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'auto_confirm_signups',
							$elm$json$Json$Encode$bool(bool)),
							_Utils_Tuple2(
							'prepay_first_payment_on_signup',
							$elm$json$Json$Encode$bool(false))
						])) : A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'auto_confirm_signups',
					$elm$json$Json$Encode$bool(bool));
			case 1:
				var bool = field.a;
				return bool ? $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'prepay_first_payment_on_signup',
							$elm$json$Json$Encode$bool(bool)),
							_Utils_Tuple2(
							'collect_payment_source_on_signup',
							$author$project$Api$CollectOnSignup$encoder(2))
						])) : A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'prepay_first_payment_on_signup',
					$elm$json$Json$Encode$bool(bool));
			case 2:
				var bool = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'merge_duplicate_patients_on_online_signup',
					$elm$json$Json$Encode$bool(bool));
			case 3:
				var restrict = field.a;
				var _v1 = $author$project$Utils$Form$fields(model.PB);
				var collectAddressOnSignup = _v1.K7;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'restrict_zip_codes_on_signup',
							$elm$json$Json$Encode$bool(restrict)),
							$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress(
							A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue, restrict, collectAddressOnSignup))
						]));
			case 4:
				var zipCodes = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'allowed_zip_codes_on_signup',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, zipCodes));
			case 5:
				var collectOption = field.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress(collectOption)
						]));
			case 6:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_billing_address_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 7:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_practitioner_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 8:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_location_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 9:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_ssn_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 10:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_lead_source_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 11:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_broker_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 12:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'allows_payer_on_behalf_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 13:
				var bool = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'start_date_selectable_on_signup',
					$elm$json$Json$Encode$bool(bool));
			case 14:
				var collectOption = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'collect_insurance_on_signup',
					$author$project$Api$CollectOnSignup$encoder(collectOption));
			case 15:
				return $elm$json$Json$Encode$null;
			case 16:
				var maybeAge = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'min_enroll_age',
					A2(
						$author$project$Utils$Encode$nullable,
						$elm$json$Json$Encode$int,
						$elm$core$String$toInt(maybeAge)));
			default:
				var date = field.a;
				return A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject,
					'launch_date',
					$author$project$Utils$Date$encode(date));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString = function (minEnrollAge) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $elm$core$String$fromInt, minEnrollAge));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeValidation = 0;
var $author$project$Components$Admin$GlobalSignupSettings$Settings$NoValidation = 1;
var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldValidationGroup = function (field) {
	if (field.$ === 16) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$errorsForGroup = F2(
	function (validation, errors) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var errValidation = _v0.a;
				var errMessage = _v0.b;
				return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
			},
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$groupHasErrors = F2(
	function (validationGroup, errors) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$Admin$GlobalSignupSettings$Settings$errorsForGroup, validationGroup, errors));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldHasErrors = F2(
	function (field, errors) {
		return A2(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$groupHasErrors,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$fieldValidationGroup(field),
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$hasErrors = function (model) {
	return !$elm$core$List$isEmpty(model.fE);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString = function (field) {
	if (field.$ === 16) {
		return 'minEnrollAge';
	} else {
		return '';
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$isFieldDirty = F2(
	function (field, model) {
		return A2(
			$elm$core$Set$member,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field),
			model.ij);
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$GotToday = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$open = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, $elm$core$Maybe$Nothing, dateInput, $elm$core$Maybe$Nothing),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$GotToday, $justinmimbs$date$Date$today),
					A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg(dateInput),
					dateInputCmd)
				])));
}();
var $author$project$Components$Admin$GlobalSignupSettings$Settings$debounceUpdateForField = function (field) {
	if (field.$ === 16) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$UpdateDebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Admin$GlobalSignupSettings$Settings$UpdateDebounceMsg
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$processUpdate = F2(
	function (field, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$debounceUpdateForField(field),
			field);
		if (_v0.a) {
			var _v1 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig, field, model.oY);
			var debounceModel = _v1.a;
			var debounceCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{oY: debounceModel}),
				debounceCmd);
		} else {
			if (_v0.b.$ === 15) {
				if (_v0.b.a) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated,
							$elm$core$Task$succeed(
								$author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge(''))));
				}
			} else {
				return _Utils_Tuple2(
					model,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate(field));
			}
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldDirty = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				ij: A2(
					$elm$core$Set$insert,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field),
					model.ij)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldPristine = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				ij: A2(
					$elm$core$Set$remove,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field),
					model.ij)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$LaunchDateChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None = {$: 0};
var $author$project$Api$Provider$Practice$changeLaunchDate = F3(
	function (apiClient, maybeDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'new_launch_date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, maybeDate))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['launch_date']),
						$author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, y8: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, as: _List_Nil};
			case 3:
				var dateInputModel = msg.a;
				var dateInputMsg = msg.b;
				var _v1 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
				var newDateInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				if (model.$ === 1) {
					var maybeToday = model.c;
					if (event.$ === 1) {
						var maybeDate = event.a;
						return {
							EC: subCmd,
							ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
							y8: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, newDateInput, maybeToday),
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
							y8: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, $elm$core$Maybe$Nothing, newDateInput, maybeToday),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, y8: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, as: _List_Nil};
				}
			case 1:
				if (model.$ === 1) {
					var maybeDate = model.a;
					var dateInput = model.b;
					var maybeToday = model.c;
					return {
						EC: A3($author$project$Api$Provider$Practice$changeLaunchDate, apiClient, maybeDate, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateChanged),
						ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
						y8: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, dateInput, maybeToday),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, y8: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, as: _List_Nil};
				}
			case 2:
				var response = msg.a;
				if (model.$ === 1) {
					var maybeDate = model.a;
					var dateInput = model.b;
					var maybeToday = model.c;
					switch (response.$) {
						case 3:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$LaunchDateChanged(maybeDate),
								y8: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed,
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Practice launch date has been Updated'),
										$author$project$OutMsg$PracticeUpdated(response)
									])
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
								y8: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, dateInput, maybeToday),
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 1, 'Practice launch date cannot be changed. Please contact us for more information.')
									])
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, y8: model, as: _List_Nil};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, y8: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, as: _List_Nil};
				}
			default:
				var today = msg.a;
				if (model.$ === 1) {
					var maybeDate = model.a;
					var dateInput = model.b;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
						y8: A3(
							$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open,
							maybeDate,
							dateInput,
							$elm$core$Maybe$Just(today)),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None, y8: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$OnChange = $elm$core$Basics$identity;
var $author$project$Api$CollectOnSignup$encoderMaybe = function (maybeCustomType) {
	if (!maybeCustomType.$) {
		var customType = maybeCustomType.a;
		return $author$project$Api$CollectOnSignup$encoder(customType);
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$encodeForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'collect_payment_source_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields.Lf)),
				_Utils_Tuple2(
				'accepts_ach',
				$elm$json$Json$Encode$bool(fields.H_)),
				_Utils_Tuple2(
				'accepts_cards',
				$elm$json$Json$Encode$bool(fields.H0)),
				_Utils_Tuple2(
				'encourage_ach',
				$elm$json$Json$Encode$bool(fields.Ou)),
				_Utils_Tuple2(
				'accepts_amex',
				$elm$json$Json$Encode$bool(fields.H$))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var collectSignupRequirement = field.a;
				if (!collectSignupRequirement.$) {
					var value = collectSignupRequirement.a;
					if (!value) {
						return _Utils_update(
							fields,
							{
								H_: false,
								H$: false,
								H0: false,
								Lf: $elm$core$Maybe$Just(value),
								Ou: false
							});
					} else {
						return _Utils_update(
							fields,
							{
								H_: true,
								H0: true,
								Lf: $elm$core$Maybe$Just(value)
							});
					}
				} else {
					return fields;
				}
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{H_: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{H0: bool});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ou: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{H$: bool});
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var field = msg;
		var newModel = function () {
			if ((field.$ === 4) && (!field.a)) {
				return _Utils_update(
					model,
					{sJ: true});
			} else {
				return _Utils_update(
					model,
					{sJ: false});
			}
		}();
		var form = A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsUpdate, field, model.PB);
		return _Utils_Tuple3(
			_Utils_update(
				newModel,
				{PB: form}),
			$elm$core$Platform$Cmd$none,
			$elm$core$Maybe$Just(
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$encodeForm(form)));
	});
var $author$project$Ui$TagsInput$TagRemoved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$TagsInput$TagAdded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$TagsInput$mask = function (pattern_) {
	return $agustinrhcp$elm_mask$Mask$fromString(pattern_);
};
var $author$project$Ui$TagsInput$tagFitsPattern = F2(
	function (maybePattern, tag) {
		if (!maybePattern.$) {
			var pattern_ = maybePattern.a;
			var maskedTag = A2(
				$agustinrhcp$elm_mask$Mask$mask,
				$author$project$Ui$TagsInput$mask(pattern_),
				tag);
			return _Utils_eq(maskedTag, tag) && _Utils_eq(
				$elm$core$String$length(maskedTag),
				$elm$core$String$length(pattern_));
		} else {
			return true;
		}
	});
var $author$project$Ui$TagsInput$isTagValid = F3(
	function (maybePattern, tags_, tag) {
		var trimmed = $elm$core$String$trim(tag);
		return A2($author$project$Ui$TagsInput$tagFitsPattern, maybePattern, trimmed) && (!A2($elm$core$List$member, trimmed, tags_));
	});
var $author$project$Ui$TagsInput$submitInput = F4(
	function (ignoreNextInputUpdate, pattern_, tags_, model) {
		var valid = A3($author$project$Ui$TagsInput$isTagValid, pattern_, tags_, model.cV);
		var newModel = _Utils_update(
			model,
			{qR: ignoreNextInputUpdate, sN: !valid});
		return valid ? _Utils_Tuple3(
			_Utils_update(
				newModel,
				{cV: ''}),
			$elm$core$Platform$Cmd$none,
			$elm$core$Maybe$Just(
				$author$project$Ui$TagsInput$TagAdded(model.cV))) : _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
	});
var $author$project$Ui$TagsInput$updateInputValue = F2(
	function (newValue, model) {
		var modelAfterSubmit = _Utils_update(
			model,
			{qR: false});
		var newModel = model.qR ? modelAfterSubmit : _Utils_update(
			modelAfterSubmit,
			{
				cV: $elm$core$String$trim(newValue),
				sN: false
			});
		return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
	});
var $author$project$Ui$TagsInput$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var str = msg.a;
				return A2($author$project$Ui$TagsInput$updateInputValue, str, model);
			case 0:
				var str = msg.a;
				return A2($author$project$Ui$TagsInput$updateInputValue, str, model);
			case 2:
				var pattern_ = msg.a;
				var tags_ = msg.b;
				var key = msg.c;
				switch (key) {
					case 13:
						return A4($author$project$Ui$TagsInput$submitInput, false, pattern_, tags_, model);
					case 32:
						return A4($author$project$Ui$TagsInput$submitInput, true, pattern_, tags_, model);
					case 188:
						return A4($author$project$Ui$TagsInput$submitInput, true, pattern_, tags_, model);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 3:
				var pattern_ = msg.a;
				var tags_ = msg.b;
				return A4($author$project$Ui$TagsInput$submitInput, false, pattern_, tags_, model);
			default:
				var tag = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(
						$author$project$Ui$TagsInput$TagRemoved(tag)));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return (!bool) ? _Utils_update(
					fields,
					{k7: bool, WX: false}) : _Utils_update(
					fields,
					{k7: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{WX: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{TS: bool});
			case 3:
				var restrict = field.a;
				return _Utils_update(
					fields,
					{gy: restrict});
			case 4:
				var zipCodes = field.a;
				return _Utils_update(
					fields,
					{pv: zipCodes});
			case 5:
				var collectAddress = field.a;
				return _Utils_update(
					fields,
					{K7: collectAddress});
			case 6:
				var collectShippingAddress = field.a;
				return _Utils_update(
					fields,
					{K8: collectShippingAddress});
			case 7:
				var collectPractitioner = field.a;
				return _Utils_update(
					fields,
					{Lg: collectPractitioner});
			case 8:
				var collectLocation = field.a;
				return _Utils_update(
					fields,
					{ab7: collectLocation});
			case 9:
				var collectSSN = field.a;
				return _Utils_update(
					fields,
					{Lh: collectSSN});
			case 10:
				var collectLeadSource = field.a;
				return _Utils_update(
					fields,
					{Ld: collectLeadSource});
			case 11:
				var collectBroker = field.a;
				return _Utils_update(
					fields,
					{K9: collectBroker});
			case 12:
				var allowPayerOnBehalfOnSignup = field.a;
				return _Utils_update(
					fields,
					{IY: allowPayerOnBehalfOnSignup});
			case 13:
				var startDateSelectableOnSignup = field.a;
				return _Utils_update(
					fields,
					{_F: startDateSelectableOnSignup});
			case 14:
				var collectOption = field.a;
				return _Utils_update(
					fields,
					{Lc: collectOption});
			case 15:
				var bool = field.a;
				return _Utils_update(
					fields,
					{m5: bool});
			case 16:
				var age = field.a;
				return _Utils_update(
					fields,
					{
						T_: $elm$core$String$toInt(age)
					});
			default:
				var date = field.a;
				return _Utils_update(
					fields,
					{SG: date});
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$updateField = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				PB: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsUpdate, field, model.PB)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$clearErrors = function (model) {
	return _Utils_update(
		model,
		{fE: _List_Nil});
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$validateMinEnrollAge = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var minEnrollAge = _v0.T_;
	var minEnrollAgeEnabled = _v0.m5;
	var _v1 = _Utils_Tuple2(minEnrollAge, minEnrollAgeEnabled);
	if ((_v1.a.$ === 1) && _v1.b) {
		var _v2 = _v1.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'min enroll age is required')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$Settings$validateMinEnrollAge)
		]));
var $author$project$Components$Admin$GlobalSignupSettings$Settings$validate = function (model) {
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					model,
					{fE: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$validator,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$clearErrors(model)))));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var modelWithForm = A2(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldDirty,
					field,
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$updateField, field, model));
				var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$processUpdate, field, modelWithForm);
				var newModel = _v2.a;
				var updateCmd = _v2.b;
				return _Utils_Tuple3(newModel, updateCmd, $elm$core$Maybe$Nothing);
			case 5:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$TagsInput$update, subMsg, model.tc);
				var newTagsInput = _v3.a;
				var tagsInputMsg = _v3.b;
				var maybeEvent = _v3.c;
				var modelWithComponent = _Utils_update(
					model,
					{tc: newTagsInput});
				var _v4 = $author$project$Utils$Form$fields(modelWithComponent.PB);
				var restrictZipCodes = _v4.gy;
				var allowedZipCodes = _v4.pv;
				var _v5 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(modelWithComponent, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (event) {
							var newZips = function () {
								if (!event.$) {
									var tag = event.a;
									return _Utils_ap(
										allowedZipCodes,
										_List_fromArray(
											[tag]));
								} else {
									var tag = event.a;
									return A2($elm_community$list_extra$List$Extra$remove, tag, allowedZipCodes);
								}
							}();
							var newZipsField = $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowedZipCodes(newZips);
							var modelWithField = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$updateField, newZipsField, modelWithComponent);
							return _Utils_Tuple2(
								modelWithField,
								(restrictZipCodes && $elm$core$List$isEmpty(newZips)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField, modelWithField, newZipsField)));
						},
						maybeEvent));
				var newModel = _v5.a;
				var saveEvent = _v5.b;
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg, tagsInputMsg),
					saveEvent);
			case 1:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$update, subMsg, model.rZ);
				var newComponentModel = _v7.a;
				var updateCmd = _v7.b;
				var maybeEvent = _v7.c;
				var event = A2(
					$elm$core$Maybe$map,
					function (event_) {
						var field = event_;
						return field;
					},
					maybeEvent);
				var modelWithComponent = _Utils_update(
					model,
					{rZ: newComponentModel});
				return _Utils_Tuple3(
					modelWithComponent,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg, updateCmd),
					event);
			case 2:
				var field = msg.a;
				var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$validate(model);
				return (A2($author$project$Components$Admin$GlobalSignupSettings$Settings$isFieldDirty, field, model) && (!A2($author$project$Components$Admin$GlobalSignupSettings$Settings$fieldHasErrors, field, validatedModel.fE))) ? _Utils_Tuple3(
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldPristine, field, model),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(
						A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField, validatedModel, field))) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
			case 3:
				var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$validate(model);
				if ($author$project$Components$Admin$GlobalSignupSettings$Settings$hasErrors(validatedModel)) {
					return _Utils_Tuple3(validatedModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				} else {
					var _v9 = $author$project$Utils$Form$fields(model.PB);
					var minEnrollAge = _v9.T_;
					return _Utils_Tuple3(
						validatedModel,
						A2(
							$elm$core$Task$perform,
							$author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges,
							$elm$core$Task$succeed(
								$author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge(
									$author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString(minEnrollAge)))),
						$elm$core$Maybe$Nothing);
				}
			case 4:
				var debounceMsg = msg.a;
				var _v10 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate),
					debounceMsg,
					model.oY);
				var newDebouncer = _v10.a;
				var debounceCmd = _v10.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oY: newDebouncer}),
					debounceCmd,
					$elm$core$Maybe$Nothing);
			case 6:
				var _v11 = $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$open;
				var launchDateModal = _v11.a;
				var cmd = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lo: launchDateModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg, cmd),
					$elm$core$Maybe$Nothing);
			default:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$update, apiClient, subMsg, model.lo);
				var cmd = function () {
					var _v12 = result.ac5;
					if ((_v12.$ === 1) && (!_v12.a.$)) {
						var dateStart = _v12.a.a;
						return A2(
							$elm$core$Task$perform,
							$author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated,
							$elm$core$Task$succeed(
								$author$project$Components$Admin$GlobalSignupSettings$Settings$LaunchDate(dateStart)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lo: result.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg, result.EC)
							])),
					$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$OnChange = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainChecked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate = function (field) {
	if (!field.$) {
		return A2(
			$elm$core$Task$perform,
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain,
			$elm$core$Task$succeed(field));
	} else {
		return A2(
			$elm$core$Task$perform,
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges,
			$elm$core$Task$succeed(field));
	}
};
var $author$project$Api$Provider$Practice$Subdomains$subdomainsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['subdomains', 'new']),
	$author$project$Api$Provider$Practice$practicePath);
var $author$project$Api$Provider$Practice$Subdomains$checkSubdomain = F3(
	function (apiClient, toMsg, subdomain) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'subdomain[name]', subdomain)
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$Subdomains$subdomainsPath)));
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors = function (model) {
	return _Utils_update(
		model,
		{fE: _List_Nil});
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName = function (field) {
	switch (field.$) {
		case 0:
			return 'subdomain';
		case 1:
			return 'signup_page_not_found_redirect_url';
		default:
			return 'custom_javascript_text';
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$encodeField = function (field) {
	var fieldName_ = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field);
	switch (field.$) {
		case 0:
			var subdomain = field.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						fieldName_,
						$elm$json$Json$Encode$string(subdomain))
					]));
		case 1:
			var url = field.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						fieldName_,
						$elm$json$Json$Encode$string(url))
					]));
		default:
			var text = field.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'signup_settings',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									fieldName_,
									$elm$json$Json$Encode$string(text))
								])))
					]));
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascriptValidation = 2;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrlValidation = 1;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainValidation = 0;
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldValidationGroup = function (field) {
	switch (field.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup = F2(
	function (validation, errors) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var errValidation = _v0.a;
				var errMessage = _v0.b;
				return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
			},
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors = F2(
	function (validationGroup, errors) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, validationGroup, errors));
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldHasErrors = F2(
	function (field, errors) {
		return A2(
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors,
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldValidationGroup(field),
			errors);
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty = F2(
	function (field, model) {
		return A2(
			$elm$core$Set$member,
			$author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field),
			model.ij);
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$debounceUpdateForField = function (field) {
	switch (field.$) {
		case 0:
			return true;
		case 1:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$UpdateDebounceMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Admin$GlobalSignupSettings$SignupPage$UpdateDebounceMsg
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$processUpdate = F2(
	function (field, model) {
		if ($author$project$Components$Admin$GlobalSignupSettings$SignupPage$debounceUpdateForField(field)) {
			var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig, field, model.oY);
			var debounceModel = _v0.a;
			var debounceCmd = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{oY: debounceModel}),
				debounceCmd);
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate(field));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldDirty = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				ij: A2(
					$elm$core$Set$insert,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field),
					model.ij)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldPristine = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				ij: A2(
					$elm$core$Set$remove,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field),
					model.ij)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var subdomain = field.a;
				return _Utils_update(
					fields,
					{_$: subdomain});
			case 1:
				var url = field.a;
				return _Utils_update(
					fields,
					{Z3: url});
			default:
				var text = field.a;
				return _Utils_update(
					fields,
					{qb: text});
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateField = F2(
	function (field, model) {
		return _Utils_update(
			model,
			{
				PB: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsUpdate, field, model.PB)
			});
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateCustomJavascript = function (_v0) {
	return _List_Nil;
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSignupPageNotFoundRedirectUrl = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var signupPageNotFoundRedirectUrl = _v0.Z3;
	return $author$project$Utils$Validate$isInvalidUrlStricter(signupPageNotFoundRedirectUrl) ? _List_fromArray(
		[
			_Utils_Tuple2(1, 'is not a valid URL')
		]) : _List_Nil;
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$parseErrorString = F2(
	function (token, errorString) {
		var tokenSingular = $elm$core$String$trim(token) + ' ';
		var tokenPlural = 'and ' + tokenSingular;
		return A2(
			$elm$core$List$map,
			function (err) {
				return A3($elm$core$String$replace, tokenSingular, '', err);
			},
			A2($elm$core$String$split, tokenPlural, errorString));
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSubdomain = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var subdomain = _v0._$;
	if ($author$project$Utils$String$isBlank(subdomain)) {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'cannot be blank')
			]);
	} else {
		var _v1 = model.s6;
		switch (_v1.$) {
			case 2:
				var error = _v1.a;
				return A2(
					$elm$core$List$map,
					function (errString) {
						return _Utils_Tuple2(0, errString);
					},
					A2(
						$author$project$Components$Admin$GlobalSignupSettings$SignupPage$parseErrorString,
						'Subdomain ',
						$author$project$Api$Data$errorToString(error)));
			case 1:
				return _List_fromArray(
					[
						_Utils_Tuple2(0, 'is being checked')
					]);
			default:
				return _List_Nil;
		}
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSubdomain),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSignupPageNotFoundRedirectUrl),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateCustomJavascript)
		]));
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate = function (model) {
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					model,
					{fE: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$validator,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors(model)))));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var modelWithForm = A2(
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldDirty,
					field,
					A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateField, field, model));
				var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$processUpdate, field, modelWithForm);
				var newModel = _v2.a;
				var updateCmd = _v2.b;
				return _Utils_Tuple3(newModel, updateCmd, $elm$core$Maybe$Nothing);
			case 1:
				var field = msg.a;
				if (A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty, field, model)) {
					var _v3 = $author$project$Utils$Form$fields(model.PB);
					var subdomain = _v3._$;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s6: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Provider$Practice$Subdomains$checkSubdomain, apiClient, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainChecked, subdomain),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 2:
				var data = msg.a;
				var modelWithData = _Utils_update(
					model,
					{s6: data});
				switch (data.$) {
					case 3:
						var _v5 = $author$project$Utils$Form$fields(modelWithData.PB);
						var subdomain = _v5._$;
						return _Utils_Tuple3(
							modelWithData,
							A2(
								$elm$core$Task$perform,
								$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges,
								$elm$core$Task$succeed(
									$author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain(subdomain))),
							$elm$core$Maybe$Nothing);
					case 2:
						return _Utils_Tuple3(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate(modelWithData),
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Nothing);
					default:
						return _Utils_Tuple3(modelWithData, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 3:
				var debounceMsg = msg.a;
				var _v6 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate),
					debounceMsg,
					model.oY);
				var newDebouncer = _v6.a;
				var debounceCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oY: newDebouncer}),
					debounceCmd,
					$elm$core$Maybe$Nothing);
			default:
				var field = msg.a;
				var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate(model);
				if (A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty, field, model) && (!A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldHasErrors, field, validatedModel.fE))) {
					var pristineModel = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors(
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldPristine, field, model));
					return _Utils_Tuple3(
						pristineModel,
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$encodeField(field)));
				} else {
					return _Utils_Tuple3(validatedModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Pages$Admin$Signup$PracticeUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Signup$updatePractice = F2(
	function (model, encodedValue) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('practice', encodedValue)
				]));
		return A4(
			$author$project$Api$Data$patch,
			model.D5,
			$author$project$Api$Provider$Practice$One$decoder,
			$author$project$Pages$Admin$Signup$PracticeUpdated,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithQuery,
					$author$project$Api$Provider$Practice$retrieveOptionsToParams($author$project$Pages$Admin$Signup$practiceOptionals),
					$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Pages$Admin$Signup$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$update, subMsg, model.hR);
				var newComponentModel = _v1.a;
				var updateCmd = _v1.b;
				var maybeEvent = _v1.c;
				var modelWithComponent = _Utils_update(
					model,
					{hR: newComponentModel});
				var practiceUpdateCmd = function () {
					if (!maybeEvent.$) {
						var encodedChange = maybeEvent.a;
						return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					modelWithComponent,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$ConfirmationComponentMsg, updateCmd),
								practiceUpdateCmd
							])),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var signupPages = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Nk: $elm$core$List$head(signupPages)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = A3($author$project$Components$Admin$GlobalSignupSettings$SignupPage$update, model.D5, subMsg, model.gP);
				var newComponentModel = _v4.a;
				var componentUpdateCmd = _v4.b;
				var maybeEvent = _v4.c;
				var modelWithComponent = _Utils_update(
					model,
					{gP: newComponentModel});
				var practiceUpdateCmd = function () {
					if (!maybeEvent.$) {
						var encodedChange = maybeEvent.a;
						return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					modelWithComponent,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$SignupPageComponentMsg, componentUpdateCmd),
								practiceUpdateCmd
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$Admin$GlobalSignupSettings$Settings$update, model.D5, subMsg, model.j4);
				var newComponentModel = _v6.a;
				var componentUpdateCmd = _v6.b;
				var maybeEvent = _v6.c;
				var modelWithComponent = _Utils_update(
					model,
					{j4: newComponentModel});
				var practiceUpdateCmd = function () {
					if (!maybeEvent.$) {
						var encodedChange = maybeEvent.a;
						return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					modelWithComponent,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$SettingsComponentMsg, componentUpdateCmd),
								practiceUpdateCmd
							])),
					_List_Nil);
			case 4:
				var response = msg.a;
				var modelWithPractice = _Utils_update(
					model,
					{WF: response});
				if (response.$ === 3) {
					var practice = response.a;
					var modelWithComponents = _Utils_update(
						modelWithPractice,
						{
							gP: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
						});
					return _Utils_Tuple3(
						modelWithComponents,
						$author$project$Pages$Admin$Signup$getDefaultSignupPage(modelWithComponents),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						modelWithPractice,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var modelWithComponents = _Utils_update(
						model,
						{
							hR: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice),
							WF: response,
							j4: $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice),
							gP: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
						});
					return _Utils_Tuple3(
						modelWithComponents,
						$author$project$Pages$Admin$Signup$getDefaultSignupPage(modelWithComponents),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					var newModel = function () {
						var _v10 = model.WF;
						if (_v10.$ === 3) {
							var practice = _v10.a;
							return _Utils_update(
								model,
								{
									hR: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice),
									j4: $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice),
									gP: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
								});
						} else {
							return model;
						}
					}();
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var currentDate = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: $elm$core$Maybe$Just(currentDate)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Api$Provider$SignupPage$Shared$baseUrl = function (_v0) {
	var record = _v0;
	return record.abx;
};
var $author$project$Api$Provider$SignupPage$All$baseUrl = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$baseUrl(shared);
};
var $author$project$Pages$Admin$Signup$help = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[$author$project$Ui$Typography$small]),
		_List_fromArray(
			[
				$elm$html$Html$text('at '),
				A3(
				$author$project$Ui$Link$externalHref,
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.Nk)),
				_List_fromArray(
					[$author$project$Ui$Link$targetBlank]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.Nk)))
					]))
			]));
};
var $author$project$Components$LoadingPage$view = _List_fromArray(
	[
		A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Spinner$view(_List_Nil)
			]))
	]);
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelHelp(labelHelp),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$clearfix,
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$labelSpan(7),
					$author$project$Ui$Form$Group$offsetLabel
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewAutoRedirectToggle = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var redirectsPostSignup = _v0.X1;
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignup))
			]));
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle,
		'Auto Redirect to External Site',
		$elm$html$Html$text(''),
		toggleSwitch);
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonText = F4(
	function (practice, model, redirectsPostSignup, showPostSignupFooterButton) {
		if ((!redirectsPostSignup) && showPostSignupFooterButton) {
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'If left blank, button will read \"Go to ' + ($author$project$Api$Provider$Practice$One$name(practice) + ' Website\".'))
							]))
					]));
			var _v0 = $author$project$Utils$Form$fields(model.PB);
			var postSignupButtonLabel = _v0.WB;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(7),
						$author$project$Ui$Form$Group$label('Custom Button Text'),
						$author$project$Ui$Form$Group$labelHelp(labelHelp),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$clearfix
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(postSignupButtonLabel),
								$author$project$Ui$Form$Input$placeholder(
								'Go to ' + ($author$project$Api$Provider$Practice$One$name(practice) + ' Website')),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel)),
								$author$project$Ui$Form$Input$onBlur(
								$author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges(
									$author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel(postSignupButtonLabel))),
								$author$project$Ui$Form$Input$withFeedback(true)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$Alert = 9;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewErrorRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 9),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$margin(10),
										$author$project$Ui$Typography$muted
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									]))
							]))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonUrl = F4(
	function (practice, model, redirectsPostSignup, showPostSignupFooterButton) {
		if ((!redirectsPostSignup) && (!showPostSignupFooterButton)) {
			return $author$project$Utils$Html$empty;
		} else {
			var labelHelp = redirectsPostSignup ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Practice,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Account')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(').')
							]))
					]));
			var _v0 = redirectsPostSignup ? _Utils_Tuple2('Redirect URL', true) : _Utils_Tuple2('Custom Button URL', false);
			var title = _v0.a;
			var required = _v0.b;
			var _v1 = $author$project$Utils$Form$fields(model.PB);
			var postSignupRedirectUrl = _v1.WD;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(7),
						$author$project$Ui$Form$Group$label(title),
						$author$project$Ui$Form$Group$labelHelp(labelHelp),
						$author$project$Ui$Form$Group$required(required),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$clearfix
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(postSignupRedirectUrl),
								$author$project$Ui$Form$Input$placeholder(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Practice$One$url(practice))),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors, 0, model.fE)),
								$author$project$Ui$Form$Input$onBlur(
								$author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges(
									$author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl(postSignupRedirectUrl))),
								$author$project$Ui$Form$Input$withFeedback(true)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewErrorRow,
							A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup, 0, model.fE)))
					]));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Textarea$OnBlur = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Textarea$onBlur = $author$project$Ui$Form$Textarea$OnBlur;
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomMessage = F2(
	function (model, redirectsPostSignup) {
		if (redirectsPostSignup) {
			return $author$project$Utils$Html$empty;
		} else {
			var labelHelpText = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('If left blank, the default message is \"We are thrilled to have you as a new member! Expect to receive an invoice once your membership is confirmed.\"')
					]));
			var _v0 = $author$project$Utils$Form$fields(model.PB);
			var postSignupMessage = _v0.WC;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$offsetLabel,
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(7),
						$author$project$Ui$Form$Group$label('Custom Message for Plan Signup Pages'),
						$author$project$Ui$Form$Group$labelClass(''),
						$author$project$Ui$Form$Group$labelHelp(labelHelpText),
						$author$project$Ui$Form$Group$clearfix
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$placeholder('If you have any questions feel free to call our office at (333) 123-4567.'),
								$author$project$Ui$Form$Textarea$value(postSignupMessage),
								$author$project$Ui$Form$Textarea$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage)),
								$author$project$Ui$Form$Textarea$onBlur(
								$author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges(
									$author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage(postSignupMessage)))
							]))
					]));
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButton = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewPostSignupButtonToggle = F2(
	function (redirectsPostSignup, showPostSignupFooterButton) {
		if (redirectsPostSignup) {
			return $author$project$Utils$Html$empty;
		} else {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButton))
					]));
			var labelHelpText = showPostSignupFooterButton ? 'A button is displayed that can be configured below with a custom text and URL.' : 'No button will be shown, and employee should be instructed to close their current signup tab.';
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(labelHelpText)
					]));
			return A3(
				$author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle,
				'Show Redirect Button on Confirmation',
				A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
				toggleSwitch);
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$view = F2(
	function (practice, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(model.PB);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Confirmation Page')
								]))
						])),
					$author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewAutoRedirectToggle(model),
					A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomMessage, model, fields.X1),
					A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewPostSignupButtonToggle, fields.X1, fields.ZX),
					A4($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonText, practice, model, fields.X1, fields.ZX),
					A4($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonUrl, practice, model, fields.X1, fields.ZX)
				]));
	});
var $author$project$Pages$Admin$Signup$viewConfirmationComponent = F2(
	function (practice, confirmationComponent) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Signup$ConfirmationComponentMsg,
			A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$view, practice, confirmationComponent));
	});
var $author$project$Pages$Admin$Signup$viewMemberAgreementsText = A2(
	$author$project$Ui$FlexGrid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$offset(1)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You can add and configure your Agreements  '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Documents__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								]))
						]))
				]))
		]));
var $author$project$Pages$Admin$Signup$viewMemberAgreementsSection = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$mb4]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Member Agreements')
						]))
				])),
			$author$project$Pages$Admin$Signup$viewMemberAgreementsText
		]));
var $author$project$Components$Admin$GlobalSignupSettings$Settings$futureLaunchDate = F2(
	function (currentDate, defaultMembershipStartDate) {
		var _v0 = A2($justinmimbs$date$Date$compare, defaultMembershipStartDate, currentDate);
		if (_v0 === 2) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$StartDateSelectable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix,
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[toggleSwitch]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowFutureStartDate = function (startDateSelectableOnSignup) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(startDateSelectableOnSignup),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$StartDateSelectable))
			]));
	var labelHelpText = startDateSelectableOnSignup ? 'The patient can choose any day in the future to start their membership.' : 'The member will not get a choice and the membership will start the day the form is submitted.';
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(labelHelpText)
			]));
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle,
		'Allow Future Start Dates',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowPayerOnBehalf = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField = function (fieldName) {
	switch (fieldName) {
		case 'CollectAddress':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectBillingAddress':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectPractitioner':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectLocation':
			return _List_fromArray(
				[0, 2]);
		case 'CollectSSN':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectLeadSource':
			return _List_fromArray(
				[0, 1, 2]);
		case 'CollectBroker':
			return _List_fromArray(
				[0, 1, 2]);
		case 'AllowPayerOnBehalf':
			return _List_fromArray(
				[0, 4, 3, 2]);
		case 'CollectInsurance':
			return _List_fromArray(
				[0, 4]);
		default:
			return _List_Nil;
	}
};
var $author$project$Api$CollectOnSignup$label = function (collectOnSignup) {
	switch (collectOnSignup) {
		case 0:
			return 'No';
		case 1:
			return 'Optional';
		case 2:
			return 'Require';
		case 3:
			return 'Yes (and set as default)';
		default:
			return 'Yes';
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignupButton = F4(
	function (currentCollectOnSignup, selectedCollectOnSignup, disabled, toFieldMsg) {
		var label = $author$project$Api$CollectOnSignup$label(selectedCollectOnSignup);
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated(
						toFieldMsg(selectedCollectOnSignup))),
					$author$project$Ui$Button$disabled(disabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup = F6(
	function (collectOnSignup, label, labelHelp, disabled, collectOptionsList, toFieldMsg) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											A2(
												$elm$core$List$map,
												function (option) {
													return A4($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignupButton, collectOnSignup, option, disabled, toFieldMsg);
												},
												collectOptionsList))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowNonMemberPayer = function (collectOption) {
	var labelHelpText = function () {
		switch (collectOption) {
			case 0:
				return 'The payer will be also enrolled as patient.';
			case 4:
				return 'The payer can choose to not be enrolled as a patient, but will be enrolled by default.';
			case 3:
				return 'The payer can choose to be enrolled as a patient, but will not be enrolled by default.';
			case 2:
				return 'The payer will not be enrolled as patient.';
			default:
				return '';
		}
	}();
	return A6(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
		collectOption,
		'Allow non-member payers',
		$elm$html$Html$text(labelHelpText),
		false,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('AllowPayerOnBehalf'),
		$author$project$Components$Admin$GlobalSignupSettings$Settings$AllowPayerOnBehalf);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$AutoConfirmMembership = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAutoConfirmMembership = F3(
	function (futureLaunch, defaultMembershipStartDate, autoConfirmMembership) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(autoConfirmMembership),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$AutoConfirmMembership))
				]));
		var labelHelpText = function () {
			var _v0 = _Utils_Tuple2(autoConfirmMembership, futureLaunch);
			if (_v0.a) {
				if (_v0.b) {
					return 'Memberships will be charged on ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', defaultMembershipStartDate);
				} else {
					return 'Memberships will be charged immediately.';
				}
			} else {
				return 'Memberships will be charged once confirmed.';
			}
		}();
		var labelHelp = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(labelHelpText)
				]));
		return A3(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle,
			'Auto Confirm Memberships',
			A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
			toggleSwitch);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectAddress = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectAddress = F2(
	function (restrictZipCodes, collectOption) {
		var collectOptionOverride = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue, restrictZipCodes, collectOption);
		var labelHelpText = function () {
			switch (collectOptionOverride) {
				case 0:
					return 'Addresses will not be collected.';
				case 1:
					return 'Addresses are optional and can be left blank.';
				case 2:
					return 'An address is required for each member.';
				default:
					return '';
			}
		}();
		return A6(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
			collectOptionOverride,
			'Collect Address',
			$elm$html$Html$text(labelHelpText),
			restrictZipCodes,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectAddress'),
			$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectAddress);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBroker = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectBroker = function (collectOption) {
	var labelHelpText = function () {
		switch (collectOption) {
			case 0:
				return 'Brokers will not be collected.';
			case 1:
				return 'Brokers are optional and can be left blank.';
			case 2:
				return 'A broker is required for each member.';
			default:
				return '';
		}
	}();
	return A6(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
		collectOption,
		'Collect Broker',
		$elm$html$Html$text(labelHelpText),
		false,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectBroker'),
		$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBroker);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectInsurance = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectInsurance = function (collectOption) {
	var labelHelpText = function () {
		switch (collectOption) {
			case 0:
				return 'Insurance (or an alternative) will not be collected.';
			case 4:
				return 'Insurance (or an alternative) will be collected, patients can answer they don\'t have coverage.';
			default:
				return '';
		}
	}();
	return A6(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
		collectOption,
		'Collect Insurance',
		$elm$html$Html$text(labelHelpText),
		false,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectInsurance'),
		$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectInsurance);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLeadSource = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLeadSource = function (collectOption) {
	var labelHelpText = function () {
		switch (collectOption) {
			case 0:
				return 'Lead sources will not be collected.';
			case 1:
				return 'Lead sources are optional and can be left blank.';
			case 2:
				return 'A lead source is required for each member.';
			default:
				return '';
		}
	}();
	return A6(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
		collectOption,
		'Collect Lead Source',
		$elm$html$Html$text(labelHelpText),
		false,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectLeadSource'),
		$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLeadSource);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLocation = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectLocationHelp = F2(
	function (collectLocationEditable, collectOption) {
		if (collectLocationEditable) {
			return $elm$html$Html$text(
				function () {
					switch (collectOption) {
						case 0:
							return 'Locations will not be collected.';
						case 2:
							return 'A location is required for each member.';
						default:
							return '';
					}
				}());
		} else {
			switch (collectOption) {
				case 0:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This practice has no locations. You can add some ')
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Locations,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('.')
									]))
							]));
				case 2:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This practice requires all members to have a location, you can change this setting ')
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Patients,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('.')
									]))
							]));
				default:
					return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Api$Provider$Practice$One$isCollectLocationOnSignupEditable = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.TU;
		},
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.ab7;
			},
			function ($) {
				return $.Oa;
			})));
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLocation = F2(
	function (practice, collectOption) {
		var showCollectLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		if (showCollectLocation) {
			var collectLocationEditable = $author$project$Api$Provider$Practice$One$isCollectLocationOnSignupEditable(practice);
			var labelHelp = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectLocationHelp, collectLocationEditable, collectOption);
			return A6(
				$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
				collectOption,
				'Collect Location',
				labelHelp,
				!collectLocationEditable,
				$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectLocation'),
				$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLocation);
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectPractitioner = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectProviderHelp = F3(
	function (collectProviderEditable, hasProviders, collectOption) {
		return collectProviderEditable ? $elm$html$Html$text(
			function () {
				switch (collectOption) {
					case 0:
						return 'Providers will not be collected.';
					case 1:
						return 'Providers are optional and can be left blank.';
					case 2:
						return 'A provider is required for each member.';
					default:
						return '';
				}
			}()) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					hasProviders ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This practice has no providers. You can add some ')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Providers__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('.')
								]))
						])),
					(collectOption === 2) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This practice requires all members to have a provider, you can change this setting ')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Patients,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('.')
								]))
						])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Api$Provider$Practice$One$isCollectPractitionerOnSignupEditable = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.TU;
		},
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.Lg;
			},
			function ($) {
				return $.Oa;
			})));
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectProvider = F2(
	function (practice, collectOption) {
		var hasProviders = $author$project$Api$Provider$Practice$One$hasPractitioners(practice);
		var collectProviderEditable = $author$project$Api$Provider$Practice$One$isCollectPractitionerOnSignupEditable(practice);
		var labelHelp = A3($author$project$Components$Admin$GlobalSignupSettings$Settings$collectProviderHelp, collectProviderEditable, hasProviders, collectOption);
		return A6(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
			collectOption,
			'Collect Provider',
			labelHelp,
			!collectProviderEditable,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectPractitioner'),
			$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectPractitioner);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectSSN = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectSSN = F2(
	function (requiresSSN, collectOption) {
		var labelHelpText = function () {
			switch (collectOption) {
				case 0:
					return 'SSN will not be collected.';
				case 1:
					return 'SSN are optional and can be left blank.';
				case 2:
					return 'A SSN is required for each member. This will prevent people without SSNs from signing up.';
				default:
					return '';
			}
		}();
		var labelHelp = requiresSSN ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(labelHelpText)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('SSN is required for every patient, you can change this setting '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Patients,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('here.')
								]))
						]))
				])) : $elm$html$Html$text(labelHelpText);
		return A6(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
			collectOption,
			'Collect SSN',
			labelHelp,
			requiresSSN,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectSSN'),
			$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectSSN);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBillingAddress = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectShippingAddress = F2(
	function (disabled, collectOption) {
		var labelHelpText = function () {
			switch (collectOption) {
				case 0:
					return 'Shipping addresses will not be collected.';
				case 1:
					return 'Shipping addresses are optional and can be left blank.';
				case 2:
					return 'A shipping address is required for each member.';
				default:
					return '';
			}
		}();
		return A6(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup,
			collectOption,
			'Collect Shipping Address',
			$elm$html$Html$text(labelHelpText),
			disabled,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectBillingAddress'),
			$author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBillingAddress);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModal = {$: 6};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$ChangeLaunchDate = {$: 1};
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal = {$: 0};
var $author$project$Components$DateInput$DisabledPickerDates = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$DateInput$disabledPickerDates = $author$project$Components$DateInput$DisabledPickerDates;
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$viewModal = F3(
	function (maybeDate, dateInput, today) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Change Launch Date')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Changing your launch date will not automatically change the membership start date or invoice date for any paid memberships. All pending and unpaid memberships will receive new membership start and bill dates. All unpaid membership invoices will be voided. '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__Invoices,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Click here')
												])),
											$elm$html$Html$text(' to view paid invoices.')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Launch Date'),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$labelSpanSm(8),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$inputSpanSm(4),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg(dateInput),
									A2(
										$author$project$Components$DateInput$view,
										_List_fromArray(
											[
												$author$project$Components$DateInput$value(maybeDate),
												$author$project$Components$DateInput$disabledPickerDates(
												function (date) {
													return A2($author$project$Utils$Date$isBefore, date, today);
												})
											]),
										dateInput))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Change launch date'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$ChangeLaunchDate),
									$author$project$Ui$Button$disabled(
									_Utils_eq(maybeDate, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Launch Date')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$view = function (model) {
	if (model.$ === 1) {
		var maybeDate = model.a;
		var dateInput = model.b;
		var maybeToday = model.c;
		if (!maybeToday.$) {
			var today = maybeToday.a;
			return A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$viewModal, maybeDate, dateInput, today);
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewModal = function (changeLaunchDateModal) {
	if (!changeLaunchDateModal.$) {
		var modal = changeLaunchDateModal.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg,
			$author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMembershipStartDate = F4(
	function (futureLaunch, defaultMembershipStartDate, isHinter, changeLaunchDateModal) {
		var shouldShowStartDate = futureLaunch || isHinter;
		if (shouldShowStartDate) {
			var startDate = A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, defaultMembershipStartDate);
			return A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(11),
								$author$project$Ui$FlexGrid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Membership Start Date'),
										$author$project$Ui$Form$Group$labelHelp(
										$elm$html$Html$text('Memberships will start on your launch date.')),
										$author$project$Ui$Form$Group$labelClass(''),
										$author$project$Ui$Form$Group$clearfix,
										$author$project$Ui$Form$Group$labelSpan(8),
										$author$project$Ui$Form$Group$inputSpan(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$justifyRight]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(startDate),
														$author$project$Utils$Html$noBreakSpace
													])),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Edit Launch Date'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModal),
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$margin(10),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Edit Launch Date')
													]))
											]))
									])),
								$author$project$Components$Admin$GlobalSignupSettings$Settings$viewModal(changeLaunchDateModal)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$MergeInactivePatients = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMergeInactivePatients = function (mergeDuplicatePatientsOnSignup) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(mergeDuplicatePatientsOnSignup),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MergeInactivePatients))
			]));
	var labelHelpText = mergeDuplicatePatientsOnSignup ? '\n                If a signup matches an inactive patient by name and date of birth,\n                that patient will be re-enrolled and have their payment, contract, and insurance information updated.\n                If a signup matches an active patient,\n                an error will be shown directing the prospective patient to contact the practice.\n                ' : 'Always create new patients.';
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(labelHelpText)
			]));
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle,
		'Merge with Matching Inactive Patients',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMinEnrollmentAge = F2(
	function (minEnrollmentAge, minEnrollAgeEnabled) {
		return minEnrollAgeEnabled ? A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(10),
							$author$project$Ui$FlexGrid$offsetSm(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Minimum Enroll Age'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix,
									$author$project$Ui$Form$Group$labelSpan(9),
									$author$project$Ui$Form$Group$inputSpan(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													$author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString(minEnrollmentAge)),
													$author$project$Ui$Form$Input$number,
													$author$project$Ui$Form$Input$placeholder('18'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge)),
													$author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge),
													$author$project$Ui$Form$Input$withFeedback(true)
												]))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$CollectPaymentSourceOnSignup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$FormUpdated = $elm$core$Basics$identity;
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton = F6(
	function (collectOnSignupButtonEnabled, currentCollectOnSignup, selectedCollectOnSignup, toMsg, toFieldMsg, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
					$author$project$Ui$Button$onClick(
					toMsg(
						toFieldMsg(selectedCollectOnSignup))),
					$author$project$Ui$Button$disabled(!collectOnSignupButtonEnabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignup = F8(
	function (collectOnSignupButtonEnabled, collectOnSignup, label, labelHelp, viewPracticeDefault, childrenContent, toMsg, toFieldMsg) {
		var extraCollectOption = viewPracticeDefault ? _List_fromArray(
			[
				A6($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton, collectOnSignupButtonEnabled, collectOnSignup, $elm$core$Maybe$Nothing, toMsg, toFieldMsg, 'Practice Default')
			]) : _List_Nil;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											A2(
												$elm$core$List$cons,
												A6(
													$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton,
													collectOnSignupButtonEnabled,
													collectOnSignup,
													$elm$core$Maybe$Just(0),
													toMsg,
													toFieldMsg,
													'No'),
												A2(
													$elm$core$List$cons,
													A6(
														$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton,
														collectOnSignupButtonEnabled,
														collectOnSignup,
														$elm$core$Maybe$Just(1),
														toMsg,
														toFieldMsg,
														'Optional'),
													A2(
														$elm$core$List$cons,
														A6(
															$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton,
															collectOnSignupButtonEnabled,
															collectOnSignup,
															$elm$core$Maybe$Just(2),
															toMsg,
															toFieldMsg,
															'Require'),
														extraCollectOption))))
										]))
								])),
						childrenContent))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelHelp(labelHelp),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$clearfix,
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpan(7),
					$author$project$Ui$Form$Group$inputSpan(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[toggleSwitch]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch = F3(
	function (practiceSetting, disabled, toFieldMsg) {
		return $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(practiceSetting),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $elm$core$Basics$identity, toFieldMsg)),
					$author$project$Ui$ToggleSwitch$disabled(disabled)
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAchToggle = function (fields) {
	var disableToggle = function () {
		var _v0 = fields.Lf;
		if ((!_v0.$) && (!_v0.a)) {
			var _v1 = _v0.a;
			return true;
		} else {
			return !fields.H0;
		}
	}();
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle,
		'Accept Bank Accounts',
		$elm$html$Html$text(''),
		A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.H_, disableToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAch));
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAmex = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAmexWarning = function (showAmexWarning) {
	return showAmexWarning ? A2(
		$author$project$Ui$Alert$warning,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('If members have already added American Express cards, these will still continue to be charged, but members will not be allowed to add new American Express cards.')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAmexToggle = F2(
	function (fields, showAmexWarning) {
		if (fields.H0) {
			var showDisabledToggle = function () {
				var _v0 = fields.Lf;
				if ((!_v0.$) && (!_v0.a)) {
					var _v1 = _v0.a;
					return true;
				} else {
					return false;
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle,
						'Accept American Express',
						$elm$html$Html$text(''),
						A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.H$, showDisabledToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAmex)),
						$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAmexWarning(showAmexWarning)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsCards = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsCardsToggle = function (fields) {
	var disableToggle = function () {
		var _v0 = fields.Lf;
		if ((!_v0.$) && (!_v0.a)) {
			var _v1 = _v0.a;
			return true;
		} else {
			return !fields.H_;
		}
	}();
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle,
		'Accept Credit Cards',
		$elm$html$Html$text(''),
		A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.H0, disableToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsCards));
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$EncourageAch = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewEncourageAchToggle = function (fields) {
	if (fields.H_ && fields.H0) {
		var showDisabledToggle = function () {
			var _v0 = fields.Lf;
			if ((!_v0.$) && (!_v0.a)) {
				var _v1 = _v0.a;
				return true;
			} else {
				return false;
			}
		}();
		var encourageMembersText = fields.Ou ? 'When both bank accounts and credit cards are accepted, a small note would be added to the credit cards form on signup.' : '';
		return A3(
			$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle,
			'Encourage Members to Choose Bank Account',
			$elm$html$Html$text(encourageMembersText),
			A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.Ou, showDisabledToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$EncourageAch));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewPaymentSourceAcceptedOptions = F3(
	function (fields, hasActivePaymentProcessorAccount, showAmexWarning) {
		return ($author$project$Utils$Maybe$isNothing(fields.Lf) || (!hasActivePaymentProcessorAccount)) ? _List_Nil : _List_fromArray(
			[
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAchToggle(fields),
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsCardsToggle(fields),
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewEncourageAchToggle(fields),
				A2($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAmexToggle, fields, showAmexWarning)
			]);
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectPaymentSource = F4(
	function (fields, hasActivePaymentProcessorAccount, prepayFirstPayment, showAmexWarning) {
		var practiceSetting = A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewPaymentSourceAcceptedOptions, fields, hasActivePaymentProcessorAccount, showAmexWarning);
		var labelHelpText = function () {
			var _v0 = fields.Lf;
			_v0$3:
			while (true) {
				if (!_v0.$) {
					switch (_v0.a) {
						case 0:
							var _v1 = _v0.a;
							return 'Payment Source will not be collected.';
						case 1:
							var _v2 = _v0.a;
							return 'Payment Source is optional and can be left blank.';
						case 2:
							var _v3 = _v0.a;
							return 'A Payment Source is required.';
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			}
			return '';
		}();
		var collectOnSignupButtonEnabled = (!prepayFirstPayment) && hasActivePaymentProcessorAccount;
		return A8(
			$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignup,
			collectOnSignupButtonEnabled,
			fields.Lf,
			'Collect Payment Source',
			$elm$html$Html$text(labelHelpText),
			false,
			practiceSetting,
			$elm$core$Basics$identity,
			$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$CollectPaymentSourceOnSignup);
	});
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewStripeAccountWarning = function (practice) {
	return $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(5),
						$author$project$Ui$FlexGrid$offsetSm(1)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Utils$PaymentProcessor$toSetupAlert,
						$author$project$Api$Practice$Provider(practice),
						$elm$core$Maybe$Just('In order to collect payment sources'))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$view = function (_v0) {
	var model = _v0;
	var hasActivePaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(model.WF);
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb4]),
		_List_fromArray(
			[
				A4($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectPaymentSource, fields, hasActivePaymentProcessorAccount, model.GQ, model.sJ),
				$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewStripeAccountWarning(model.WF)
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewPaymentSource = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg,
		$author$project$Components$Admin$GlobalSignupSettings$PaymentSource$view(model.rZ));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$PrepayFirstPaymentOnSignup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggleOffset = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix,
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4),
									$author$project$Ui$Form$Group$offsetLabel
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[toggleSwitch]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewPrepayFirstPaymentOnSignup = F2(
	function (prepayFirstPaymentOnSignup, autoConfirmMembership) {
		var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(prepayFirstPaymentOnSignup),
					$author$project$Ui$ToggleSwitch$onChange(
					A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$PrepayFirstPaymentOnSignup)),
					$author$project$Ui$ToggleSwitch$disabled(!autoConfirmMembership)
				]));
		var labelHelp = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('This allows you to collect a prepayment when your practice is launching in the future or for patients who select a future membership start date from the sign-up form. When enabled, the patient\'s first membership invoice will be paid upon submission of the sign-up form. ')
				]));
		return A3(
			$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggleOffset,
			'Prepay First Payment',
			A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
			toggleSwitch);
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeEnabled = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictEnrollmentAge = function (minEnrollAgeEnabled) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(minEnrollAgeEnabled),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeEnabled))
			]));
	var labelHelpText = minEnrollAgeEnabled ? 'Under-age patients cannot be enrolled into a membership without an active adult also enrolled.' : 'Do not restrict patient enrollment into a membership based on age. Plans restrictions still apply.';
	var labelHelp = A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(labelHelpText)
			]));
	return A3(
		$author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle,
		'Restrict enrollment by age',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$RestrictZipCodes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$TagsInput$Pattern = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$TagsInput$pattern = $author$project$Ui$TagsInput$Pattern;
var $author$project$Ui$TagsInput$Required = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$TagsInput$required = $author$project$Ui$TagsInput$Required;
var $author$project$Ui$TagsInput$Tags = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$TagsInput$tags = $author$project$Ui$TagsInput$Tags;
var $author$project$Ui$TagsInput$defaultOptions = {gg: $elm$core$Maybe$Nothing, agk: false, gW: _List_Nil};
var $author$project$Ui$TagsInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var tags_ = option.a;
						return _Utils_update(
							record,
							{gW: tags_});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								gg: $elm$core$Maybe$Just(string)
							});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{agk: bool});
				}
			}),
		$author$project$Ui$TagsInput$defaultOptions,
		options);
};
var $author$project$Ui$TagsInput$InputBlur = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$TagsInput$InputChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$TagsInput$InputKeyDown = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Ui$TagsInput$MaskedInputChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Input$OnKeyDown = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Form$Input$onKeyDown = $author$project$Ui$Form$Input$OnKeyDown;
var $author$project$Ui$TagsInput$viewInput = F2(
	function (options, model) {
		return $author$project$Ui$Form$Input$view(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Input$onKeyDown(
					A2($author$project$Ui$TagsInput$InputKeyDown, options.gg, options.gW)),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$onBlur(
						A2($author$project$Ui$TagsInput$InputBlur, options.gg, options.gW)),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$invalid(
							model.sN && (!A3($author$project$Ui$TagsInput$isTagValid, options.gg, options.gW, model.cV))),
						function () {
							var _v0 = options.gg;
							if (!_v0.$) {
								var pattern_ = _v0.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Input$maskedValue,
										$author$project$Ui$TagsInput$mask(pattern_),
										model.cV),
										A3(
										$author$project$Ui$Form$Input$onMaskedInput,
										$author$project$Ui$TagsInput$mask(pattern_),
										model.cV,
										$author$project$Ui$TagsInput$MaskedInputChanged),
										$author$project$Ui$Form$Input$placeholder(pattern_ + ',')
									]);
							} else {
								return _List_fromArray(
									[
										$author$project$Ui$Form$Input$value(model.cV),
										$author$project$Ui$Form$Input$onInput($author$project$Ui$TagsInput$InputChanged),
										$author$project$Ui$Form$Input$placeholder('tag name,')
									]);
							}
						}()))));
	});
var $author$project$Ui$TagsInput$maskedTags = F2(
	function (maybePattern, tags_) {
		return A2(
			$elm$core$List$filter,
			$author$project$Ui$TagsInput$tagFitsPattern(maybePattern),
			tags_);
	});
var $author$project$Utils$String$notBlank = function (string) {
	return !$author$project$Utils$String$isBlank(string);
};
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
};
var $author$project$Ui$TagsInput$filterTags = F2(
	function (maybePattern, tags_) {
		return A2(
			$author$project$Ui$TagsInput$maskedTags,
			maybePattern,
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$filter,
					$author$project$Utils$String$notBlank,
					A2($elm$core$List$map, $elm$core$String$trim, tags_))));
	});
var $author$project$Ui$TagsInput$RemoveTag = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Icon$Size = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Icon$extraSmall = $author$project$Ui$Icon$Size(0);
var $author$project$Ui$TagsInput$viewTag = function (tag) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('tag-item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(tag),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-05'),
						$elm$html$Html$Events$onClick(
						$author$project$Ui$TagsInput$RemoveTag(tag))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Icon$view,
						_List_fromArray(
							[$author$project$Ui$Icon$extraSmall]),
						2)
					]))
			]));
};
var $author$project$Ui$TagsInput$viewTags = function (options) {
	var filteredTags = A2($author$project$Ui$TagsInput$filterTags, options.gg, options.gW);
	return A2($elm$core$List$map, $author$project$Ui$TagsInput$viewTag, filteredTags);
};
var $author$project$Ui$TagsInput$view = F2(
	function (options, model) {
		var optionsRecord = $author$project$Ui$TagsInput$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tags-list'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'invalid',
							optionsRecord.agk && $elm$core$List$isEmpty(optionsRecord.gW))
						])),
					$elm$html$Html$Attributes$id(model.adR)
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Ui$TagsInput$viewInput, optionsRecord, model),
				$author$project$Ui$TagsInput$viewTags(optionsRecord)));
	});
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowedZipCodes = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var restrictZipCodes = _v0.gy;
	var allowedZipCodes = _v0.pv;
	return restrictZipCodes ? A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$label('Allowed Zip Codes'),
				$author$project$Ui$Form$Group$labelHelp(
				$elm$html$Html$text('Zip codes can be copy/pasted into this field as long as they are separated by commas.')),
				$author$project$Ui$Form$Group$labelClass(''),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg,
				A2(
					$author$project$Ui$TagsInput$view,
					_List_fromArray(
						[
							$author$project$Ui$TagsInput$tags(allowedZipCodes),
							$author$project$Ui$TagsInput$pattern('#####'),
							$author$project$Ui$TagsInput$required(true)
						]),
					model.tc))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictZipCodes = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var restrictZipCodes = _v0.gy;
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$offsetSm(1),
						$author$project$Ui$FlexGrid$spanSm(11)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Restrict by Zip Codes'),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(restrictZipCodes),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$RestrictZipCodes))
											]))
									]))
							])),
						$author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowedZipCodes(model)
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$Settings$view = F4(
	function (currentDate, practice, isHintAdmin, _v0) {
		var model = _v0;
		var requiresSSN = $author$project$Api$Provider$Practice$One$requiresSSN(practice);
		var fields = $author$project$Utils$Form$fields(model.PB);
		var defaultMembershipStartDate = $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice);
		var futureLaunch = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$futureLaunchDate, currentDate, defaultMembershipStartDate);
		var changeLaunchDateModal = model.lo;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Admin')
								]))
						])),
					A4(
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewMembershipStartDate,
					futureLaunch,
					defaultMembershipStartDate,
					isHintAdmin,
					$elm$core$Maybe$Just(changeLaunchDateModal)),
					A3($author$project$Components$Admin$GlobalSignupSettings$Settings$viewAutoConfirmMembership, futureLaunch, defaultMembershipStartDate, fields.k7),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewPrepayFirstPaymentOnSignup, fields.WX, fields.k7),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewMergeInactivePatients(fields.TS),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewPaymentSource(model),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictZipCodes(model),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectAddress, fields.gy, fields.K7),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectShippingAddress, fields.gy, fields.K8),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectProvider, practice, fields.Lg),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLocation, practice, fields.ab7),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectInsurance(fields.Lc),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectSSN, requiresSSN, fields.Lh),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLeadSource(fields.Ld),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectBroker(fields.K9),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowFutureStartDate(fields._F),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictEnrollmentAge(fields.m5),
					A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewMinEnrollmentAge, fields.T_, fields.m5),
					$author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowNonMemberPayer(fields.IY)
				]));
	});
var $author$project$Pages$Admin$Signup$viewSettingsComponent = F4(
	function (currentDate, practice, settingsComponent, isHintAdmin) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Signup$SettingsComponentMsg,
			A4($author$project$Components$Admin$GlobalSignupSettings$Settings$view, currentDate, practice, isHintAdmin, settingsComponent));
	});
var $author$project$Api$Feature$CustomJsOnSignupPages = 8;
var $author$project$Utils$Html$htmlIf = F2(
	function (ifCondition, element) {
		return ifCondition ? element : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewAddCustomJavascript = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var customJavascript = _v0.qb;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$label('Add Custom Javascript'),
				$author$project$Ui$Form$Group$labelHelp(
				$elm$html$Html$text('Please review your signup pages to confirm that your code is valid.')),
				$author$project$Ui$Form$Group$labelClass(''),
				$author$project$Ui$Form$Group$clearfix
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$rows(5),
						$author$project$Ui$Form$Textarea$value(customJavascript),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript)),
						$author$project$Ui$Form$Textarea$invalid(
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 2, model.fE)),
						$author$project$Ui$Form$Textarea$onBlur(
						$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript(customJavascript))),
						$author$project$Ui$Form$Textarea$errors(
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 2, model.fE))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewCustomUrl = function (practice) {
	var signupUrl = $author$project$Api$Provider$Practice$One$memberPortalSignupUrl(practice);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$label('Custom Url'),
				$author$project$Ui$Form$Group$labelClass(''),
				$author$project$Ui$Form$Group$clearfix
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						signupUrl,
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text(signupUrl)
							]))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewPracticeName = function (practice) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$label('Practice Name'),
				$author$project$Ui$Form$Group$labelClass(''),
				$author$project$Ui$Form$Group$clearfix
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Practice$One$name(practice))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Input$Url = {$: 3};
var $author$project$Ui$Form$Input$url = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Url);
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 9),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$margin(10),
										$author$project$Ui$Typography$muted
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									]))
							]))
					]))
			]));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSignupPageNotFoundRedirectUrl = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var signupPageNotFoundRedirectUrl = _v0.Z3;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$offsetLabel,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(7),
				$author$project$Ui$Form$Group$label('Signup Page Not Found Url'),
				$author$project$Ui$Form$Group$labelHelp(
				$elm$html$Html$text('When a patient tries to use a signup page that is no longer\n            live or never existed they will be shown a message including the practice\'s phone,\n            email and this url.')),
				$author$project$Ui$Form$Group$labelClass(''),
				$author$project$Ui$Form$Group$clearfix
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(signupPageNotFoundRedirectUrl),
						$author$project$Ui$Form$Input$url,
						$author$project$Ui$Form$Input$placeholder('https://www.mypractice.com'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 1, model.fE)),
						$author$project$Ui$Form$Input$onBlur(
						$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl(signupPageNotFoundRedirectUrl))),
						$author$project$Ui$Form$Input$withFeedback(true)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow,
					A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 1, model.fE)))
			]));
};
var $author$project$Utils$Regex$replace = F3(
	function (userRegex, newString, string) {
		var _v0 = $elm$regex$Regex$fromString(userRegex);
		if (_v0.$ === 1) {
			return string;
		} else {
			var regex = _v0.a;
			return A3(
				$elm$regex$Regex$replace,
				regex,
				function (_v1) {
					return newString;
				},
				string);
		}
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$subdomainify = function (practice) {
	return A3(
		$author$project$Utils$Regex$replace,
		'[^\\w-]',
		'',
		A3(
			$author$project$Utils$Regex$replace,
			' ',
			'-',
			$elm$core$String$toLower(
				$author$project$Api$Provider$Practice$One$name(practice))));
};
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSubdomain = F2(
	function (practice, model) {
		var _v0 = $author$project$Utils$Form$fields(model.PB);
		var subdomain = _v0._$;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$offsetLabel,
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(7),
					$author$project$Ui$Form$Group$label('Subdomain'),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$clearfix
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(subdomain),
							$author$project$Ui$Form$Input$placeholder(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$subdomainify(practice)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 0, model.fE)),
							$author$project$Ui$Form$Input$onBlur(
							$author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain(
								$author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain(subdomain))),
							$author$project$Ui$Form$Input$withFeedback(true)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow,
						A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 0, model.fE)))
				]));
	});
var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$view = F2(
	function (practice, _v0) {
		var model = _v0;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Signup Page')
								]))
						])),
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewPracticeName(practice),
					A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSubdomain, practice, model),
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewCustomUrl(practice),
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSignupPageNotFoundRedirectUrl(model),
					A2(
					$author$project$Utils$Html$htmlIf,
					A2($author$project$Api$Provider$Practice$One$featureEnabled, 8, practice),
					$author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewAddCustomJavascript(model))
				]));
	});
var $author$project$Pages$Admin$Signup$viewSignupPageComponent = F2(
	function (practice, signupPageComponent) {
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Signup$SignupPageComponentMsg,
			A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$view, practice, signupPageComponent));
	});
var $author$project$Pages$Admin$Signup$viewPanelBody = function (model) {
	var _v0 = _Utils_Tuple2(model.WF, model.cO);
	if ((_v0.a.$ === 3) && (!_v0.b.$)) {
		var _v1 = _v0.a;
		var practice = _v1.a;
		var currentDate = _v0.b.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Pages$Admin$Signup$viewSignupPageComponent, practice, model.gP),
					A4($author$project$Pages$Admin$Signup$viewSettingsComponent, currentDate, practice, model.j4, model.FR),
					$author$project$Pages$Admin$Signup$viewMemberAgreementsSection,
					A2($author$project$Pages$Admin$Signup$viewConfirmationComponent, practice, model.hR)
				]));
	} else {
		return A2($elm$html$Html$div, _List_Nil, $author$project$Components$LoadingPage$view);
	}
};
var $author$project$Pages$Admin$Signup$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Member Signup Form')
									])),
								$author$project$Pages$Admin$Signup$help(model)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$Signup$viewPanelBody(model)
							]))
					]))
			]),
		$G: 'Admin | Signup Settings'
	};
};
var $author$project$Pages$Admin$Signup$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Signup$init, aer: $author$project$Pages$Admin$Signup$load, agD: $author$project$Pages$Admin$Signup$save, ahd: $author$project$Pages$Admin$Signup$subscriptions, aaq: $author$project$Pages$Admin$Signup$update, ahP: $author$project$Pages$Admin$Signup$view});
var $author$project$Pages$Admin$SignupPages$Id_String$FormMsg = $elm$core$Basics$identity;
var $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$CompanyPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$RetailPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$formFieldsInit = function (companyId) {
	return {Ic: true, Is: _List_Nil, lp: $elm$core$Maybe$Nothing, ff: companyId, SP: false, SQ: false, SR: false, S$: _List_Nil, S4: _List_Nil, WB: $elm$core$Maybe$Nothing, WC: $elm$core$Maybe$Nothing, WD: $elm$core$Maybe$Nothing, WQ: _List_Nil, X1: false, ZX: false, Z4: _List_Nil, _c: '', ahI: 'signup', aaw: false};
};
var $author$project$Components$ResourceFilter$CompanyPlan$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$CompanyPlan$EmployerAll = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$CompanyPlan$ProviderAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$CompanyPlan$companyPlansPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['company_plans']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$CompanyPlan$All$CompanyPlan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyPlan$Shared$CompanyPlan = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyPlan$Shared$Record = F3(
	function (id, availableForEnrollment, isDefault) {
		return {JJ: availableForEnrollment, adR: id, RI: isDefault};
	});
var $author$project$Api$Employer$CompanyPlan$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_default',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'available_for_enrollment',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$Shared$Record))));
var $author$project$Api$Employer$CompanyPlan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyPlan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyPlan$All$Record = function (plan) {
	return {GH: plan};
};
var $author$project$Api$Employer$CompanyPlan$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Employer$Plan$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$All$Record));
var $author$project$Api$Employer$CompanyPlan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyPlan$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyPlan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$All$CompanyPlan)));
var $author$project$Api$Employer$CompanyPlan$expandToString = function (expand) {
	return 'pricing';
};
var $author$project$Api$Employer$CompanyPlan$listDefaults = {Fc: _List_Nil, adR: $elm$core$Maybe$Nothing};
var $author$project$Api$Employer$CompanyPlan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$CompanyPlan$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.adR;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				_List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Employer$CompanyPlan$expandToString, options.Fc))
				])
			]));
};
var $author$project$Api$Employer$CompanyPlan$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$CompanyPlan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$CompanyPlan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyPlan$companyPlansPath)));
	});
var $author$project$Api$Provider$CompanyPlan$companyPlansPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['company_plans']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$CompanyPlan$All$CompanyPlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyPlan$One$CompanyPlan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyPlan$Shared$CompanyPlan = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyPlan$Shared$Record = F3(
	function (id, availableForEnrollment, isDefault) {
		return {JJ: availableForEnrollment, adR: id, RI: isDefault};
	});
var $author$project$Api$Provider$CompanyPlan$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_default',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'available_for_enrollment',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$Shared$Record))));
var $author$project$Api$Provider$CompanyPlan$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyPlan$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyPlan$One$Record = function (plan) {
	return {GH: plan};
};
var $author$project$Api$Provider$CompanyPlan$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$One$Record));
var $author$project$Api$Provider$CompanyPlan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyPlan$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyPlan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$One$CompanyPlan)));
var $author$project$Api$Provider$CompanyPlan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyPlan$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyPlan$expandToString = function (expand) {
	return 'pricing';
};
var $author$project$Api$Provider$CompanyPlan$listDefaults = {Fc: _List_Nil, adR: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$CompanyPlan$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CompanyPlan$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.adR;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				_List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Provider$CompanyPlan$expandToString, options.Fc))
				])
			]));
};
var $author$project$Api$Provider$CompanyPlan$list = F4(
	function (apiClient, companyId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyPlan$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CompanyPlan$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId))));
	});
var $author$project$Api$Employer$CompanyPlan$Pricing = 0;
var $author$project$Api$CompanyPlan$expandToEmployer = function (expand) {
	return 0;
};
var $author$project$Api$CompanyPlan$listDefaults = {Fc: _List_Nil, adR: $elm$core$Maybe$Nothing};
var $author$project$Api$CompanyPlan$optionalsToEmployer = function (optionals) {
	var options = optionals($author$project$Api$CompanyPlan$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				Fc: A2($elm$core$List$map, $author$project$Api$CompanyPlan$expandToEmployer, options.Fc),
				adR: options.adR
			});
	};
};
var $author$project$Api$Provider$CompanyPlan$Pricing = 0;
var $author$project$Api$CompanyPlan$expandToProvider = function (expand) {
	return 0;
};
var $author$project$Api$CompanyPlan$optionalsToProvider = function (optionals) {
	var options = optionals($author$project$Api$CompanyPlan$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				Fc: A2($elm$core$List$map, $author$project$Api$CompanyPlan$expandToProvider, options.Fc),
				adR: options.adR
			});
	};
};
var $author$project$Api$CompanyPlan$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyPlan$list,
			apiClient,
			$author$project$Api$CompanyPlan$optionalsToEmployer(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CompanyPlan$EmployerAll)))) : A4(
			$author$project$Api$Provider$CompanyPlan$list,
			apiClient,
			companyId,
			$author$project$Api$CompanyPlan$optionalsToProvider(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CompanyPlan$ProviderAll))));
	});
var $author$project$Components$ResourceFilter$CompanyPlan$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return A5($author$project$Api$CompanyPlan$list, apiClient, session, companyId, optionals, toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyPlan$fetchResources = F6(
	function (session, companyId, toMsg, apiClient, _v0, _v1) {
		return A5($author$project$Components$ResourceFilter$CompanyPlan$list, apiClient, session, companyId, $elm$core$Basics$identity, toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyPlan$retrieveResource = F5(
	function (session, companyId, toMsg, apiClient, id) {
		return A5(
			$author$project$Components$ResourceFilter$CompanyPlan$list,
			apiClient,
			session,
			companyId,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyPlan$selectId = 'company_plans';
var $author$project$Api$Plan$EmployerShared = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Plan$ProviderShared = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyPlan$All$plan = function (_v0) {
	var record = _v0.b;
	return record.GH;
};
var $author$project$Api$Provider$CompanyPlan$One$plan = function (_v0) {
	var record = _v0.b;
	return record.GH;
};
var $author$project$Api$Provider$CompanyPlan$All$plan = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyPlan$One$plan(one);
};
var $author$project$Api$CompanyPlan$plan = function (companyPlan) {
	switch (companyPlan.$) {
		case 0:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Plan$ProviderShared(
				$author$project$Api$Provider$CompanyPlan$One$plan(companyPlan_));
		case 1:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Plan$ProviderShared(
				$author$project$Api$Provider$CompanyPlan$All$plan(companyPlan_));
		default:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Plan$EmployerShared(
				$author$project$Api$Employer$CompanyPlan$All$plan(companyPlan_));
	}
};
var $author$project$Components$ResourceFilter$CompanyPlan$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$CompanyPlan$plan, $author$project$Api$Plan$name);
var $author$project$Components$ResourceFilter$CompanyPlan$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CompanyPlan$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$CompanyPlan$toValue = A2($elm$core$Basics$composeR, $author$project$Api$CompanyPlan$plan, $author$project$Api$Plan$id);
var $author$project$Components$ResourceFilter$CompanyPlan$init = F4(
	function (apiClient, session, companyId, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: A2($author$project$Components$ResourceFilter$CompanyPlan$fetchResources, session, companyId),
				adR: $author$project$Components$ResourceFilter$CompanyPlan$selectId,
				gx: 'Plan',
				st: A2($author$project$Components$ResourceFilter$CompanyPlan$retrieveResource, session, companyId),
				ahw: $author$project$Components$ResourceFilter$CompanyPlan$toLabel,
				ahA: $author$project$Components$ResourceFilter$CompanyPlan$toTitle,
				g0: $author$project$Components$ResourceFilter$CompanyPlan$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$LocationGroup$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$LocationGroup$list = $author$project$Api$Provider$LocationGroup$list;
var $author$project$Components$ResourceFilter$LocationGroup$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$LocationGroup$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$LocationGroup$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$LocationGroup$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$LocationGroup$selectId = 'location_groups';
var $author$project$Components$ResourceFilter$LocationGroup$toTitle = $author$project$Api$Provider$LocationGroup$All$name;
var $author$project$Components$ResourceFilter$LocationGroup$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$LocationGroup$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$LocationGroup$toValue = $author$project$Api$Provider$LocationGroup$All$id;
var $author$project$Components$ResourceFilter$LocationGroup$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$LocationGroup$fetchResources, adR: $author$project$Components$ResourceFilter$LocationGroup$selectId, gx: 'Group', st: $author$project$Components$ResourceFilter$LocationGroup$retrieveResource, ahw: $author$project$Components$ResourceFilter$LocationGroup$toLabel, ahA: $author$project$Components$ResourceFilter$LocationGroup$toTitle, g0: $author$project$Components$ResourceFilter$LocationGroup$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Provider$SignupPage$One$SignupPage = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$SignupPage$One$Record = F3(
	function (practitioners, locations, locationGroups) {
		return {S$: locationGroups, S4: locations, WQ: practitioners};
	});
var $author$project$Api$Provider$SignupPage$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location_groups',
	$elm$json$Json$Decode$list($author$project$Api$Common$LocationGroup$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'locations',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Location$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'practitioners',
			$elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$Shared$decoder),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$One$Record))));
var $author$project$Api$Provider$SignupPage$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPage$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$SignupPage$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$One$SignupPage)));
var $author$project$Api$Provider$SignupPage$signupPagePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$SignupPage$signupPagesPath);
};
var $author$project$Api$Provider$SignupPage$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$SignupPage$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$SignupPage$signupPagePath(id_)));
	});
var $author$project$Components$Admin$SignupPages$Form$init = F6(
	function (apiClient, session, practice, id, companyId, query) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						Gr: $elm$core$Maybe$Just(true)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Provider'});
			});
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		var _v1 = function () {
			if (!companyId.$) {
				var id_ = companyId.a;
				return A3(
					$elm$core$Tuple$mapBoth,
					function (companyPlanModel) {
						return $author$project$Components$Admin$SignupPages$Form$CompanyPlan(companyPlanModel);
					},
					function (companyPlanCmd) {
						return A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg, companyPlanCmd);
					},
					A4(
						$author$project$Components$ResourceFilter$CompanyPlan$init,
						apiClient,
						session,
						id_,
						function (d) {
							return _Utils_update(
								d,
								{D0: 'Select a Plan'});
						}));
			} else {
				return A3(
					$elm$core$Tuple$mapBoth,
					function (retailModel) {
						return $author$project$Components$Admin$SignupPages$Form$RetailPlan(retailModel);
					},
					function (retailCmd) {
						return A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg, retailCmd);
					},
					A4(
						$author$project$Components$ResourceFilter$Plan$init,
						apiClient,
						session,
						function (d) {
							return _Utils_update(
								d,
								{
									AS: _List_fromArray(
										[2, 3])
								});
						},
						function (d) {
							return _Utils_update(
								d,
								{D0: 'Select a Plan'});
						}));
			}
		}();
		var planResourceFilter = _v1.a;
		var planResourceFilterCmd = _v1.b;
		var _v3 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			function (d) {
				return _Utils_update(
					d,
					{
						Gr: $elm$core$Maybe$Just(true)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Location'});
			});
		var locationResourceFilter = _v3.a;
		var locationResourceFilterCmd = _v3.b;
		var _v4 = A2(
			$author$project$Components$ResourceFilter$LocationGroup$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Location Group'});
			});
		var locationGroupResourceFilter = _v4.a;
		var locationGroupResourceFilterCmd = _v4.b;
		var _v5 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$SignupPage$retrieve, apiClient, id_, $author$project$Components$Admin$SignupPages$Form$GotItem));
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						$author$project$Utils$Form$init(
							$author$project$Components$Admin$SignupPages$Form$formFieldsInit(companyId))),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var form = _v5.a;
		var cmd = _v5.b;
		var _v7 = A3(
			$author$project$Components$ResourceFilter$ChargeItem$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Charge'});
			});
		var chargeItemResourceFilter = _v7.a;
		var chargeItemResourceFilterCmd = _v7.b;
		return _Utils_Tuple2(
			{cK: chargeItemResourceFilter, ff: companyId, PB: form, adR: id, rk: locationGroupResourceFilter, rl: locationResourceFilter, jw: planResourceFilter, WF: practice, jC: practitionerResourceFilter, Bi: query, jY: $author$project$Api$Data$NotAsked},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						planResourceFilterCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg, locationGroupResourceFilterCmd)
					])));
	});
var $author$project$Pages$Admin$SignupPages$Id_String$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var params = _v1.Vx;
		var query = _v1.Bi;
		var _v2 = A6(
			$author$project$Components$Admin$SignupPages$Form$init,
			apiClient,
			session,
			practice,
			$elm$core$Maybe$Just(params.adR),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(query));
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Admin$SignupPages$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SignupPages$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$SignupPages$Id_String$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$SignupPages$Form$ChargeItem = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$CompanyPlanAdd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationAdd = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationGroupAdd = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PlanAdd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PractitionerAdd = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Practice$One$addons = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Is;
	});
var $author$project$Api$Provider$SignupPage$Shared$chargeItem = function (_v0) {
	var record = _v0;
	return record.lp;
};
var $author$project$Api$Provider$SignupPage$One$chargeItem = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$chargeItem(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$active = function (_v0) {
	var record = _v0;
	return record.Ic;
};
var $author$project$Api$Provider$SignupPage$One$active = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$active(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$addons = function (_v0) {
	var record = _v0;
	return record.Is;
};
var $author$project$Api$Provider$SignupPage$One$addons = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$addons(shared);
};
var $author$project$Api$Provider$Addon$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Addon$Shared$id = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Addon$Min$id(min);
};
var $author$project$Api$Provider$SignupPagePlan$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.adR;
};
var $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocationGroups = function (_v0) {
	var record = _v0;
	return record.SP;
};
var $author$project$Api$Provider$SignupPage$One$limitAvailableLocationGroups = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocationGroups(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocations = function (_v0) {
	var record = _v0;
	return record.SQ;
};
var $author$project$Api$Provider$SignupPage$One$limitAvailableLocations = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocations(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$limitAvailablePractitioners = function (_v0) {
	var record = _v0;
	return record.SR;
};
var $author$project$Api$Provider$SignupPage$One$limitAvailablePractitioners = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$limitAvailablePractitioners(shared);
};
var $author$project$Api$Provider$SignupPage$One$locationGroups = function (_v0) {
	var record = _v0.b;
	return record.S$;
};
var $author$project$Api$Provider$SignupPage$One$locations = function (_v0) {
	var record = _v0.b;
	return record.S4;
};
var $author$project$Api$Provider$Addon$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Addon$Shared$name = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Addon$Min$name(min);
};
var $author$project$Api$Provider$SignupPagePlan$Shared$plan = function (_v0) {
	var shared = _v0;
	return shared.GH;
};
var $author$project$Api$Provider$SignupPage$Shared$postSignupButtonLabel = function (_v0) {
	var record = _v0;
	return record.WB;
};
var $author$project$Api$Provider$SignupPage$One$postSignupButtonLabel = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$postSignupButtonLabel(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$postSignupMessage = function (_v0) {
	var record = _v0;
	return record.WC;
};
var $author$project$Api$Provider$SignupPage$One$postSignupMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$postSignupMessage(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$postSignupRedirectUrl = function (_v0) {
	var record = _v0;
	return record.WD;
};
var $author$project$Api$Provider$SignupPage$One$postSignupRedirectUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$postSignupRedirectUrl(shared);
};
var $author$project$Api$Provider$SignupPage$One$practitioners = function (_v0) {
	var record = _v0.b;
	return record.WQ;
};
var $author$project$Api$Provider$SignupPage$Shared$redirectsPostSignup = function (_v0) {
	var record = _v0;
	return record.X1;
};
var $author$project$Api$Provider$SignupPage$One$redirectsPostSignup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$redirectsPostSignup(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$showPostSignupFooterButton = function (_v0) {
	var record = _v0;
	return record.ZX;
};
var $author$project$Api$Provider$SignupPage$One$showPostSignupFooterButton = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$showPostSignupFooterButton(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$signupPagePlans = function (_v0) {
	var record = _v0;
	return record.Z4;
};
var $author$project$Api$Provider$SignupPage$One$signupPagePlans = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$signupPagePlans(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$slug = function (_v0) {
	var record = _v0;
	return record._c;
};
var $author$project$Api$Provider$SignupPage$One$slug = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$slug(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$SignupPage$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$type_(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$useCustomSettings = function (_v0) {
	var record = _v0;
	return record.aaw;
};
var $author$project$Api$Provider$SignupPage$One$useCustomSettings = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$SignupPage$Shared$useCustomSettings(shared);
};
var $author$project$Components$Admin$SignupPages$Form$formFieldsFromItem = F2(
	function (item, companyId) {
		return {
			Ic: $author$project$Api$Provider$SignupPage$One$active(item),
			Is: A2(
				$elm$core$List$map,
				function (addon) {
					return {
						adR: $author$project$Api$Provider$Addon$Shared$id(addon),
						zh: $author$project$Api$Provider$Addon$Shared$name(addon)
					};
				},
				$author$project$Api$Provider$SignupPage$One$addons(item)),
			lp: A2(
				$elm$core$Maybe$map,
				function (chargeItem) {
					return {
						adR: $author$project$Api$Provider$ChargeItem$Min$id(chargeItem),
						zh: $author$project$Api$Provider$ChargeItem$Min$name(chargeItem),
						$u: false
					};
				},
				$author$project$Api$Provider$SignupPage$One$chargeItem(item)),
			ff: companyId,
			SP: $author$project$Api$Provider$SignupPage$One$limitAvailableLocationGroups(item),
			SQ: $author$project$Api$Provider$SignupPage$One$limitAvailableLocations(item),
			SR: $author$project$Api$Provider$SignupPage$One$limitAvailablePractitioners(item),
			S$: A2(
				$elm$core$List$map,
				function (locationGroup) {
					return {
						adR: $author$project$Api$Common$LocationGroup$Shared$id(locationGroup),
						zh: $author$project$Api$Common$LocationGroup$Shared$name(locationGroup)
					};
				},
				$author$project$Api$Provider$SignupPage$One$locationGroups(item)),
			S4: A2(
				$elm$core$List$map,
				function (location) {
					return {
						adR: $author$project$Api$Provider$Location$Shared$id(location),
						zh: $author$project$Api$Provider$Location$Shared$name(location)
					};
				},
				$author$project$Api$Provider$SignupPage$One$locations(item)),
			WB: $author$project$Api$Provider$SignupPage$One$postSignupButtonLabel(item),
			WC: $author$project$Api$Provider$SignupPage$One$postSignupMessage(item),
			WD: $author$project$Api$Provider$SignupPage$One$postSignupRedirectUrl(item),
			WQ: A2(
				$elm$core$List$map,
				function (practitioner) {
					return {
						adR: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
						zh: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
					};
				},
				$author$project$Api$Provider$SignupPage$One$practitioners(item)),
			X1: $author$project$Api$Provider$SignupPage$One$redirectsPostSignup(item),
			ZX: $author$project$Api$Provider$SignupPage$One$showPostSignupFooterButton(item),
			Z4: A2(
				$elm$core$List$map,
				function (signupPagePlan) {
					return {
						adR: $elm$core$Maybe$Just(
							$author$project$Api$Provider$SignupPagePlan$Shared$id(signupPagePlan)),
						afN: $author$project$Api$Provider$Plan$Min$id(
							$author$project$Api$Provider$SignupPagePlan$Shared$plan(signupPagePlan)),
						Wo: $author$project$Api$Provider$Plan$Min$name(
							$author$project$Api$Provider$SignupPagePlan$Shared$plan(signupPagePlan))
					};
				},
				$author$project$Api$Provider$SignupPage$One$signupPagePlans(item)),
			_c: $author$project$Api$Provider$SignupPage$One$slug(item),
			ahI: $author$project$Api$Provider$SignupPage$One$type_(item),
			aaw: $author$project$Api$Provider$SignupPage$One$useCustomSettings(item)
		};
	});
var $author$project$Formatters$String$slugify = function (string) {
	return A3(
		$author$project$Utils$Regex$replace,
		'-+$',
		'',
		A3(
			$author$project$Utils$Regex$replace,
			'^-+',
			'',
			A3(
				$author$project$Utils$Regex$replace,
				'\\-\\-+',
				'-',
				A3(
					$author$project$Utils$Regex$replace,
					'[^\\w\\-]+',
					'',
					A3(
						$author$project$Utils$Regex$replace,
						'\\s+',
						'-',
						$elm$core$String$toLower(string))))));
};
var $author$project$Components$Admin$SignupPages$Form$defaultSlug = F2(
	function (signupPagePlans, currentSlug) {
		var _v0 = _Utils_Tuple2(
			$elm$core$List$length(signupPagePlans),
			$elm$core$List$head(signupPagePlans));
		if ((_v0.a === 1) && (!_v0.b.$)) {
			var signupPagePlan = _v0.b.a;
			return $author$project$Formatters$String$slugify(signupPagePlan.Wo);
		} else {
			return currentSlug;
		}
	});
var $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate = F3(
	function (addons, field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{ahI: string});
			case 1:
				var plan = field.a;
				var plan_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (plan__) {
						return _Utils_eq(
							plan__.afN,
							$author$project$Api$Plan$id(plan));
					},
					fields.Z4);
				var signupPagePlans = function () {
					if (!plan_.$) {
						return fields.Z4;
					} else {
						return A2(
							$elm$core$List$cons,
							{
								adR: $elm$core$Maybe$Nothing,
								afN: $author$project$Api$Plan$id(plan),
								Wo: $author$project$Api$Plan$name(plan)
							},
							fields.Z4);
					}
				}();
				return _Utils_update(
					fields,
					{
						Z4: signupPagePlans,
						_c: A2($author$project$Components$Admin$SignupPages$Form$defaultSlug, signupPagePlans, fields._c)
					});
			case 2:
				var companyPlan = field.a;
				var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
				var signupPagePlan = A2(
					$elm_community$list_extra$List$Extra$find,
					function (signupPagePlan_) {
						return _Utils_eq(
							signupPagePlan_.afN,
							$author$project$Api$Plan$id(plan));
					},
					fields.Z4);
				var signupPagePlans = function () {
					if (!signupPagePlan.$) {
						return fields.Z4;
					} else {
						return A2(
							$elm$core$List$cons,
							{
								adR: $elm$core$Maybe$Nothing,
								afN: $author$project$Api$Plan$id(plan),
								Wo: $author$project$Api$Plan$name(plan)
							},
							fields.Z4);
					}
				}();
				var newSlug = $elm$core$String$isEmpty(fields._c) ? A2($author$project$Components$Admin$SignupPages$Form$defaultSlug, signupPagePlans, fields._c) : fields._c;
				return _Utils_update(
					fields,
					{Z4: signupPagePlans, _c: newSlug});
			case 3:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						Z4: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (signupPagePlan) {
								return _Utils_eq(signupPagePlan.afN, id);
							},
							fields.Z4)
					});
			case 4:
				var chargeItem = field.a;
				return _Utils_update(
					fields,
					{
						lp: A2(
							$elm$core$Maybe$map,
							function (chargeItem_) {
								return {adR: chargeItem_.adR, zh: chargeItem_.zh, $u: chargeItem_.$u};
							},
							chargeItem)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{_c: string});
			case 6:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ic: bool});
			case 7:
				var id = field.a;
				var addon = A2(
					$elm_community$list_extra$List$Extra$find,
					function (addon_) {
						return _Utils_eq(
							$author$project$Api$Provider$Addon$Min$id(addon_),
							id);
					},
					addons);
				var addons_ = function () {
					if (!addon.$) {
						var addon_ = addon.a;
						return A2(
							$elm$core$List$cons,
							{
								adR: $author$project$Api$Provider$Addon$Min$id(addon_),
								zh: $author$project$Api$Provider$Addon$Min$name(addon_)
							},
							fields.Is);
					} else {
						return fields.Is;
					}
				}();
				return _Utils_update(
					fields,
					{Is: addons_});
			case 8:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						Is: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (addon) {
								return _Utils_eq(addon.adR, id);
							},
							fields.Is)
					});
			case 9:
				var bool = field.a;
				return _Utils_update(
					fields,
					{SR: bool});
			case 10:
				var practitioner = field.a;
				var practitioner_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (practitioner__) {
						return _Utils_eq(practitioner__.adR, practitioner.adR);
					},
					fields.WQ);
				var practitioners = function () {
					if (!practitioner_.$) {
						return fields.WQ;
					} else {
						return A2(
							$elm$core$List$cons,
							{adR: practitioner.adR, zh: practitioner.zh},
							fields.WQ);
					}
				}();
				return _Utils_update(
					fields,
					{WQ: practitioners});
			case 11:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						WQ: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (practitioner) {
								return _Utils_eq(practitioner.adR, id);
							},
							fields.WQ)
					});
			case 12:
				var bool = field.a;
				return _Utils_update(
					fields,
					{SQ: bool});
			case 13:
				var bool = field.a;
				return _Utils_update(
					fields,
					{SP: bool});
			case 14:
				var location = field.a;
				var location_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (location__) {
						return _Utils_eq(location__.adR, location.adR);
					},
					fields.S4);
				var locations = function () {
					if (!location_.$) {
						return fields.S4;
					} else {
						return A2(
							$elm$core$List$cons,
							{adR: location.adR, zh: location.zh},
							fields.S4);
					}
				}();
				return _Utils_update(
					fields,
					{S4: locations});
			case 15:
				var locationGroup = field.a;
				var locationGroup_ = A2(
					$elm_community$list_extra$List$Extra$find,
					function (locationGroup__) {
						return _Utils_eq(
							locationGroup__.adR,
							$author$project$Api$Provider$LocationGroup$All$id(locationGroup));
					},
					fields.S$);
				var locationGroups = function () {
					if (!locationGroup_.$) {
						return fields.S$;
					} else {
						return A2(
							$elm$core$List$cons,
							{
								adR: $author$project$Api$Provider$LocationGroup$All$id(locationGroup),
								zh: $author$project$Api$Provider$LocationGroup$All$name(locationGroup)
							},
							fields.S$);
					}
				}();
				return _Utils_update(
					fields,
					{S$: locationGroups});
			case 16:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						S4: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (location) {
								return _Utils_eq(location.adR, id);
							},
							fields.S4)
					});
			case 17:
				var id = field.a;
				return _Utils_update(
					fields,
					{
						S$: A2(
							$elm_community$list_extra$List$Extra$filterNot,
							function (locationGroup) {
								return _Utils_eq(locationGroup.adR, id);
							},
							fields.S$)
					});
			case 18:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aaw: bool});
			case 19:
				var bool = field.a;
				return _Utils_update(
					fields,
					{X1: bool});
			case 20:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						WD: $author$project$Utils$String$toMaybe(string)
					});
			case 21:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						WC: $author$project$Utils$String$toMaybe(string)
					});
			case 22:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ZX: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						WB: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Admin$SignupPages$Form$SlugValidation = 0;
var $author$project$Utils$Validate$ifShorterThan = F3(
	function (subjectToString, min, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _Utils_cmp(
					$elm$core$String$length(
						subjectToString(subject)),
					min) < 0;
			},
			error);
	});
var $author$project$Components$Admin$SignupPages$Form$ChargeItemValidation = 2;
var $author$project$Components$Admin$SignupPages$Form$validateChargeItem = function (fields) {
	var _v0 = _Utils_Tuple2(fields.ahI, fields.lp);
	if (_v0.a === 'checkout') {
		if (!_v0.b.$) {
			var chargeItem = _v0.b.a;
			return chargeItem.$u ? _List_fromArray(
				[
					_Utils_Tuple2(2, 'We are unable to support collecting sales tax through checkout pages due to the complexity of sales & use tax laws throughout the country. Please select a different item for your signup page.')
				]) : _List_Nil;
		} else {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please pick a charge')
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrlValidation = 3;
var $author$project$Utils$Validate$isInvalidUrl = function (url) {
	return $elm$core$String$isEmpty(url) ? false : (!(A2($elm$core$String$startsWith, 'http://', url) || A2($elm$core$String$startsWith, 'https://', url)));
};
var $author$project$Components$Admin$SignupPages$Form$validatePostSignupRedirectUrl = function (fields) {
	var _v0 = _Utils_Tuple2(fields.X1, fields.WD);
	if (_v0.b.$ === 1) {
		if (_v0.a) {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(3, 'Please enter an url')
				]);
		} else {
			var _v2 = _v0.b;
			return _List_Nil;
		}
	} else {
		var postSignupRedirectUrl = _v0.b.a;
		return $author$project$Utils$Validate$isInvalidUrl(postSignupRedirectUrl) ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'URL must start with http:// or https://')
			]) : _List_Nil;
	}
};
var $author$project$Components$Admin$SignupPages$Form$SignupPagePlansValidation = 1;
var $author$project$Components$Admin$SignupPages$Form$validateSignupPagePlans = function (fields) {
	var _v0 = _Utils_Tuple2(
		fields.ahI,
		$elm$core$List$isEmpty(fields.Z4));
	if ((_v0.a === 'signup') && _v0.b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please select at least one plan')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Admin$SignupPages$Form$validateSlugPattern = function (fields) {
	return $elm$core$String$isEmpty(fields._c) ? _List_Nil : (A2($author$project$Utils$Regex$matches, '^[a-z0-9](?:-?[a-z0-9])*$', fields._c) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(0, 'Must have only lowercase letters, numbers and dashes')
		]));
};
var $author$project$Components$Admin$SignupPages$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateSignupPagePlans),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateChargeItem),
			A3(
			$author$project$Utils$Validate$ifShorterThan,
			function ($) {
				return $._c;
			},
			4,
			_Utils_Tuple2(0, 'Must be 4 or more letters')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateSlugPattern),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validatePostSignupRedirectUrl)
		]));
var $author$project$Components$Admin$SignupPages$Form$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$SignupPage$create = F3(
	function (apiClient, fields, toMsg) {
		var encodeSignupPagePlan = function (signupPagePlan) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, signupPagePlan.adR)),
						_Utils_Tuple2(
						'plan',
						$author$project$Utils$Encode$association(signupPagePlan.afN))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signup_page',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(fields.Ic)),
								_Utils_Tuple2(
								'slug',
								$elm$json$Json$Encode$string(fields._c)),
								_Utils_Tuple2(
								'use_custom_settings',
								$elm$json$Json$Encode$bool(fields.aaw)),
								_Utils_Tuple2(
								'post_signup_message',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WC)),
								_Utils_Tuple2(
								'post_signup_redirect_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WD)),
								_Utils_Tuple2(
								'post_signup_button_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WB)),
								_Utils_Tuple2(
								'redirects_post_signup',
								$elm$json$Json$Encode$bool(fields.X1)),
								_Utils_Tuple2(
								'show_post_signup_footer_button',
								$elm$json$Json$Encode$bool(fields.ZX)),
								_Utils_Tuple2(
								'limit_available_practitioners',
								$elm$json$Json$Encode$bool(fields.SR)),
								_Utils_Tuple2(
								'limit_available_locations',
								$elm$json$Json$Encode$bool(fields.SQ)),
								_Utils_Tuple2(
								'limit_available_location_groups',
								$elm$json$Json$Encode$bool(fields.SP)),
								_Utils_Tuple2(
								'charge_item',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.lp)),
								_Utils_Tuple2(
								'signup_page_plans',
								A2($elm$json$Json$Encode$list, encodeSignupPagePlan, fields.Z4)),
								_Utils_Tuple2(
								'addons',
								A2(
									$elm$json$Json$Encode$list,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Utils$Encode$association,
										function ($) {
											return $.adR;
										}),
									fields.Is)),
								_Utils_Tuple2(
								'practitioners',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.WQ)),
								_Utils_Tuple2(
								'locations',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.S4)),
								_Utils_Tuple2(
								'location_groups',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.S$)),
								_Utils_Tuple2(
								'company',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ab9))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$SignupPage$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
	});
var $author$project$Components$Admin$SignupPages$Form$signupFormFields = function (fields) {
	return {
		Ic: fields.Ic,
		Is: A2(
			$elm$core$List$map,
			function (addon) {
				return {adR: addon.adR};
			},
			fields.Is),
		lp: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.adR;
			},
			fields.lp),
		ab9: fields.ff,
		SP: fields.SP,
		SQ: fields.SQ,
		SR: fields.SR,
		S$: A2(
			$elm$core$List$map,
			function ($) {
				return $.adR;
			},
			fields.S$),
		S4: A2(
			$elm$core$List$map,
			function ($) {
				return $.adR;
			},
			fields.S4),
		WB: fields.WB,
		WC: fields.WC,
		WD: fields.WD,
		WQ: A2(
			$elm$core$List$map,
			function ($) {
				return $.adR;
			},
			fields.WQ),
		X1: fields.X1,
		ZX: fields.ZX,
		Z4: A2(
			$elm$core$List$map,
			function (signupPagePlan) {
				return {adR: signupPagePlan.adR, afN: signupPagePlan.afN};
			},
			fields.Z4),
		_c: fields._c,
		aaw: fields.aaw
	};
};
var $author$project$Components$Admin$SignupPages$Form$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$SignupPage$create,
			apiClient,
			$author$project$Components$Admin$SignupPages$Form$signupFormFields(fields),
			$author$project$Components$Admin$SignupPages$Form$Created);
	});
var $author$project$Components$Admin$SignupPages$Form$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$SignupPage$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var encodeSignupPagePlan = function (signupPagePlan) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, signupPagePlan.adR)),
						_Utils_Tuple2(
						'plan',
						$author$project$Utils$Encode$association(signupPagePlan.afN))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signup_page',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(fields.Ic)),
								_Utils_Tuple2(
								'slug',
								$elm$json$Json$Encode$string(fields._c)),
								_Utils_Tuple2(
								'use_custom_settings',
								$elm$json$Json$Encode$bool(fields.aaw)),
								_Utils_Tuple2(
								'post_signup_message',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WC)),
								_Utils_Tuple2(
								'post_signup_redirect_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WD)),
								_Utils_Tuple2(
								'post_signup_button_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WB)),
								_Utils_Tuple2(
								'redirects_post_signup',
								$elm$json$Json$Encode$bool(fields.X1)),
								_Utils_Tuple2(
								'show_post_signup_footer_button',
								$elm$json$Json$Encode$bool(fields.ZX)),
								_Utils_Tuple2(
								'limit_available_practitioners',
								$elm$json$Json$Encode$bool(fields.SR)),
								_Utils_Tuple2(
								'limit_available_locations',
								$elm$json$Json$Encode$bool(fields.SQ)),
								_Utils_Tuple2(
								'limit_available_location_groups',
								$elm$json$Json$Encode$bool(fields.SP)),
								_Utils_Tuple2(
								'charge_item',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.lp)),
								_Utils_Tuple2(
								'signup_page_plans',
								A2($elm$json$Json$Encode$list, encodeSignupPagePlan, fields.Z4)),
								_Utils_Tuple2(
								'addons',
								A2(
									$elm$json$Json$Encode$list,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Utils$Encode$association,
										function ($) {
											return $.adR;
										}),
									fields.Is)),
								_Utils_Tuple2(
								'practitioners',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.WQ)),
								_Utils_Tuple2(
								'locations',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.S4)),
								_Utils_Tuple2(
								'location_groups',
								A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.S$)),
								_Utils_Tuple2(
								'company',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ab9))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$SignupPage$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$SignupPage$signupPagePath(id_))));
	});
var $author$project$Components$Admin$SignupPages$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$SignupPage$update,
			apiClient,
			id,
			$author$project$Components$Admin$SignupPages$Form$signupFormFields(fields),
			$author$project$Components$Admin$SignupPages$Form$Updated);
	});
var $author$project$Components$Admin$SignupPages$Form$saveItem = F3(
	function (apiClient, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A3($author$project$Components$Admin$SignupPages$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Admin$SignupPages$Form$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$Admin$SignupPages$Form$saveRoute = function (companyId) {
	if (!companyId.$) {
		var id_ = companyId.a;
		return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
			{ff: id_});
	} else {
		return $author$project$Spa$Generated$Route$Admin__SignupPages__Top;
	}
};
var $author$project$Components$ResourceFilter$CompanyPlan$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$LocationGroup$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Admin$SignupPages$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var signupPage = response.a;
					var chargeItem = $author$project$Api$Provider$SignupPage$One$chargeItem(signupPage);
					var _v3 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$ChargeItem$extraItems(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (chargeItem_) {
										return _List_fromArray(
											[
												{
												adR: $author$project$Api$Provider$ChargeItem$Min$id(chargeItem_),
												zh: $author$project$Api$Provider$ChargeItem$Min$name(chargeItem_)
											}
											]);
									},
									chargeItem))),
						A2(
							$author$project$Components$ResourceFilter$ChargeItem$preSelectedId,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Min$id, chargeItem),
							model.cK));
					var chargeItemResourceFilter = _v3.a;
					var chargeItemResourceFilterCmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cK: chargeItemResourceFilter,
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										A2($author$project$Components$Admin$SignupPages$Form$formFieldsFromItem, signupPage, model.ff)))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var _v4 = model.PB;
				if (!_v4.$) {
					var form = _v4.a;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$SignupPages$Form$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							A3($author$project$Components$Admin$SignupPages$Form$saveItem, apiClient, model.adR, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var field = msg.a;
				var _v7 = model.PB;
				if (!_v7.$) {
					var form = _v7.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
							$author$project$Api$Provider$Practice$One$addons(model.WF)),
						field,
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Components$Admin$SignupPages$Form$saveRoute(model.ff)),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Successfully created page')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var queryParams = A2($elm$core$Maybe$withDefault, $elm$core$Dict$empty, model.Bi);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						A2(
							$author$project$Utils$Route$navigate,
							queryParams,
							$author$project$Components$Admin$SignupPages$Form$saveRoute(model.ff)),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Page was successfully updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var subMsg = msg.a;
				var _v10 = model.jw;
				if (!_v10.$) {
					var resourceFilter = _v10.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, resourceFilter);
					var newForm = function () {
						var _v11 = planResourceResult.ac5;
						if (((!_v11.$) && (!_v11.a.$)) && (!_v11.a.a.$)) {
							var plan = _v11.a.a.a;
							return A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Utils$Form$update,
									$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
										$author$project$Api$Provider$Practice$One$addons(model.WF)),
									$author$project$Components$Admin$SignupPages$Form$PlanAdd(plan)),
								model.PB);
						} else {
							return model.PB;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: newForm,
								jw: $author$project$Components$Admin$SignupPages$Form$RetailPlan(planResourceResult.y8)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg, planResourceResult.EC),
						planResourceResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var subMsg = msg.a;
				var _v12 = model.jw;
				if (_v12.$ === 1) {
					var resourceFilter = _v12.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$CompanyPlan$update, apiClient, subMsg, resourceFilter);
					var newForm = function () {
						var _v13 = planResourceResult.ac5;
						if (((!_v13.$) && (!_v13.a.$)) && (!_v13.a.a.$)) {
							var companyPlan = _v13.a.a.a;
							return A2(
								$elm$core$Maybe$map,
								A2(
									$author$project$Utils$Form$update,
									$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
										$author$project$Api$Provider$Practice$One$addons(model.WF)),
									$author$project$Components$Admin$SignupPages$Form$CompanyPlanAdd(companyPlan)),
								model.PB);
						} else {
							return model.PB;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: newForm,
								jw: $author$project$Components$Admin$SignupPages$Form$CompanyPlan(planResourceResult.y8)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg, planResourceResult.EC),
						planResourceResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var subMsg = msg.a;
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cK);
				var newForm = function () {
					var _v14 = chargeItemResourceResult.ac5;
					_v14$2:
					while (true) {
						if ((!_v14.$) && (!_v14.a.$)) {
							switch (_v14.a.a.$) {
								case 0:
									var chargeItem = _v14.a.a.a;
									return A2(
										$elm$core$Maybe$map,
										A2(
											$author$project$Utils$Form$update,
											$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
												$author$project$Api$Provider$Practice$One$addons(model.WF)),
											$author$project$Components$Admin$SignupPages$Form$ChargeItem(
												$elm$core$Maybe$Just(chargeItem))),
										model.PB);
								case 2:
									var _v15 = _v14.a.a;
									return A2(
										$elm$core$Maybe$map,
										A2(
											$author$project$Utils$Form$update,
											$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
												$author$project$Api$Provider$Practice$One$addons(model.WF)),
											$author$project$Components$Admin$SignupPages$Form$ChargeItem($elm$core$Maybe$Nothing)),
										model.PB);
								default:
									break _v14$2;
							}
						} else {
							break _v14$2;
						}
					}
					return model.PB;
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cK: chargeItemResourceResult.y8, PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.EC),
					chargeItemResourceResult.as);
			case 8:
				var subMsg = msg.a;
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.jC);
				var newForm = function () {
					var _v16 = practitionerResourceResult.ac5;
					if (((!_v16.$) && (!_v16.a.$)) && (!_v16.a.a.$)) {
						var practitioner = _v16.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
									$author$project$Api$Provider$Practice$One$addons(model.WF)),
								$author$project$Components$Admin$SignupPages$Form$PractitionerAdd(practitioner)),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm, jC: practitionerResourceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
					practitionerResourceResult.as);
			case 9:
				var subMsg = msg.a;
				var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.rl);
				var newForm = function () {
					var _v17 = locationResourceResult.ac5;
					if (((!_v17.$) && (!_v17.a.$)) && (!_v17.a.a.$)) {
						var location = _v17.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
									$author$project$Api$Provider$Practice$One$addons(model.WF)),
								$author$project$Components$Admin$SignupPages$Form$LocationAdd(location)),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm, rl: locationResourceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg, locationResourceResult.EC),
					locationResourceResult.as);
			default:
				var subMsg = msg.a;
				var locationGroupResourceResult = A3($author$project$Components$ResourceFilter$LocationGroup$update, apiClient, subMsg, model.rk);
				var newForm = function () {
					var _v18 = locationGroupResourceResult.ac5;
					if (((!_v18.$) && (!_v18.a.$)) && (!_v18.a.a.$)) {
						var locationGroup = _v18.a.a.a;
						return A2(
							$elm$core$Maybe$map,
							A2(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$Form$formFieldsUpdate(
									$author$project$Api$Provider$Practice$One$addons(model.WF)),
								$author$project$Components$Admin$SignupPages$Form$LocationGroupAdd(locationGroup)),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm, rk: locationGroupResourceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg, locationGroupResourceResult.EC),
					locationGroupResourceResult.as);
		}
	});
var $author$project$Pages$Admin$SignupPages$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.D5, subMsg, model.PB);
		var newForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Admin$SignupPages$Form$Save = {$: 2};
var $author$project$Components$Admin$SignupPages$Form$isChargeItemSelected = function (chargeItem) {
	return $author$project$Utils$Maybe$toBool(chargeItem);
};
var $author$project$Components$Admin$SignupPages$Form$isPlanSelected = function (signupPagePlans) {
	return !$elm$core$List$isEmpty(signupPagePlans);
};
var $author$project$Components$Admin$SignupPages$Form$isBillingOptionMethod = F2(
	function (signupPagePlans, chargeItem) {
		return $author$project$Components$Admin$SignupPages$Form$isPlanSelected(signupPagePlans) || $author$project$Components$Admin$SignupPages$Form$isChargeItemSelected(chargeItem);
	});
var $author$project$Components$Admin$SignupPages$Form$isPostSignupRedirectionCompleted = F2(
	function (redirectsPostSignup, postSignupRedirectUrl) {
		return (!redirectsPostSignup) || $author$project$Utils$Maybe$toBool(postSignupRedirectUrl);
	});
var $author$project$Components$Admin$SignupPages$Form$isSlugSelected = function (slug) {
	return !$author$project$Utils$String$isBlank(slug);
};
var $author$project$Components$Admin$SignupPages$Form$canSave = function (fields) {
	return A2($author$project$Components$Admin$SignupPages$Form$isBillingOptionMethod, fields.Z4, fields.lp) && ($author$project$Components$Admin$SignupPages$Form$isSlugSelected(fields._c) && A2($author$project$Components$Admin$SignupPages$Form$isPostSignupRedirectionCompleted, fields.X1, fields.WD));
};
var $author$project$Components$Admin$SignupPages$Form$cancelRoute = function (companyId) {
	if (!companyId.$) {
		var id_ = companyId.a;
		return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
			{ff: id_});
	} else {
		return $author$project$Spa$Generated$Route$Admin__SignupPages__Top;
	}
};
var $author$project$Api$Provider$Practice$One$locationGroupsCount = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.S0;
	});
var $author$project$Components$ResourceFilter$CompanyPlan$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Admin$SignupPages$Form$viewPlanFilter = F2(
	function (planFilter, form) {
		if (!planFilter.$) {
			var planResourceFilter = planFilter.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Plan$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Components$ResourceFilter$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]),
					planResourceFilter));
		} else {
			var companyPlanFilter = planFilter.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$CompanyPlan$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Components$ResourceFilter$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]),
					companyPlanFilter));
		}
	});
var $author$project$Components$Admin$SignupPages$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PlanRemove = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewSignupPagePlan = F2(
	function (signupPagePlans, signupPagePlan) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(signupPagePlan.Wo),
					($elm$core$List$length(signupPagePlans) > 1) ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Delete signup page plan'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Admin$SignupPages$Form$FormUpdated(
								$author$project$Components$Admin$SignupPages$Form$PlanRemove(signupPagePlan.afN))),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
						]),
					_List_Nil) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$viewBillingMethod = F4(
	function (fields, planResourceFilter, chargeItemResourceFilter, form) {
		return (fields.ahI === 'signup') ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Plan'),
					$author$project$Ui$Form$Group$required(true)
				]),
			A2(
				$elm$core$List$cons,
				A2($author$project$Components$Admin$SignupPages$Form$viewPlanFilter, planResourceFilter, form),
				A2(
					$elm$core$List$map,
					$author$project$Components$Admin$SignupPages$Form$viewSignupPagePlan(fields.Z4),
					fields.Z4))) : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Charge'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$ChargeItem$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
								$author$project$Components$ResourceFilter$errors(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]),
						chargeItemResourceFilter))
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrl = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewCustomButtonUrl = function (postSignupRedirectUrlInput) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Custom Button URL')
			]),
		_List_fromArray(
			[
				postSignupRedirectUrlInput,
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Practice,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Account')
							])),
						$elm$html$Html$text(').')
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$PostSignupButtonLabel = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewPostSignupButtonLabel = F2(
	function (postSignupButtonLabel, practiceName) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Custom Button Text')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('Go to ' + (practiceName + ' Website')),
							$author$project$Ui$Form$Input$maxLength(30),
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', postSignupButtonLabel)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupButtonLabel))
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text('If left blank, button will read \"Go to '),
							$elm$html$Html$text(practiceName),
							$elm$html$Html$text(' Website\".')
						]))
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$ShowPostSignupFooterButton = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewPostSignupFooterButton = function (showPostSignupFooterButton) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Show Redirect Button on Confirmation')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$ShowPostSignupFooterButton))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						showPostSignupFooterButton ? $elm$html$Html$text('A button is displayed that can be configured below with a custom text and URL.') : $elm$html$Html$text('No button will be shown, and user should be instructed to close their current signup tab.')
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$PostSignupMessage = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewPostSignupMessage = function (postSignupMessage) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Custom Message')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$placeholder('If you have any questions feel free to call our office at (333) 123-4567.'),
						$author$project$Ui$Form$Textarea$value(
						A2($elm$core$Maybe$withDefault, '', postSignupMessage)),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupMessage))
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$RedirectsPostSignup = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewRedirectPostSignup = function (redirectsPostSignup) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Auto Redirect to External Site')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$RedirectsPostSignup))
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewRedirectUrl = function (postSignupRedirectUrlInput) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Redirect URL'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[postSignupRedirectUrlInput]));
};
var $author$project$Components$Admin$SignupPages$Form$viewCustomSettings = F3(
	function (fields, practice, form) {
		var postSignupRedirectUrlInput = $author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$url,
					$author$project$Ui$Form$Input$placeholder(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Provider$Practice$One$url(practice))),
					$author$project$Ui$Form$Input$value(
					A2($elm$core$Maybe$withDefault, '', fields.WD)),
					$author$project$Ui$Form$Input$onInput(
					A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrl)),
					$author$project$Ui$Form$Input$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
					$author$project$Ui$Form$Input$errors(
					A2($author$project$Utils$Form$validationErrors, 3, form))
				]));
		return A2(
			$elm$core$List$cons,
			$author$project$Components$Admin$SignupPages$Form$viewRedirectPostSignup(fields.X1),
			fields.X1 ? _List_fromArray(
				[
					$author$project$Components$Admin$SignupPages$Form$viewRedirectUrl(postSignupRedirectUrlInput)
				]) : _List_fromArray(
				[
					$author$project$Components$Admin$SignupPages$Form$viewPostSignupMessage(fields.WC),
					$author$project$Components$Admin$SignupPages$Form$viewPostSignupFooterButton(fields.ZX),
					fields.ZX ? A2(
					$author$project$Components$Admin$SignupPages$Form$viewPostSignupButtonLabel,
					fields.WB,
					$author$project$Api$Provider$Practice$One$name(practice)) : $author$project$Utils$Html$empty,
					fields.ZX ? $author$project$Components$Admin$SignupPages$Form$viewCustomButtonUrl(postSignupRedirectUrlInput) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$UseCustomSettings = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewEnableConfirmationSettings = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Enable Confirmation Settings')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(fields.aaw),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$UseCustomSettings))
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocationGroups = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$ResourceFilter$LocationGroup$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Admin$SignupPages$Form$LocationGroupRemove = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewLocationGroup = function (locationGroup) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(locationGroup.zh),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Remove location group'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$size(0),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$SignupPages$Form$FormUpdated(
							$author$project$Components$Admin$SignupPages$Form$LocationGroupRemove(locationGroup.adR))),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewLocationGroupSettings = F2(
	function (fields, locationGroupResourceFilter) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Enable Location Group Settings')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.SP),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocationGroups))
						])),
					fields.SP ? A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Providers assigned to a location within one of the groups selected will be available during enrollment.')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$LocationGroup$view, _List_Nil, locationGroupResourceFilter)),
							A2(
								$elm$core$List$map,
								$author$project$Components$Admin$SignupPages$Form$viewLocationGroup,
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.zh;
									},
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_update(
												p,
												{
													zh: $elm$core$String$trim(p.zh)
												});
										},
										fields.S$)))))) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocations = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$LocationRemove = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewLocation = function (location) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(location.zh),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Remove location'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$size(0),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$SignupPages$Form$FormUpdated(
							$author$project$Components$Admin$SignupPages$Form$LocationRemove(location.adR))),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewLocationSettings = F2(
	function (fields, locationResourceFilter) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Enable Location Settings')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.SQ),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocations))
						])),
					fields.SQ ? A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Selected location(s) will display on the patient\'s enrollment page.')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Location$view, _List_Nil, locationResourceFilter)),
							A2(
								$elm$core$List$map,
								$author$project$Components$Admin$SignupPages$Form$viewLocation,
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.zh;
									},
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_update(
												p,
												{
													zh: $elm$core$String$trim(p.zh)
												});
										},
										fields.S4)))))) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Ui$Icon$Checkout = 22;
var $author$project$Ui$Icon$Plan = 21;
var $author$project$Components$Admin$SignupPages$Form$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$buttonStyle = F2(
	function (type_, currentType_) {
		return _Utils_eq(type_, currentType_) ? 1 : 0;
	});
var $author$project$Components$Admin$SignupPages$Form$viewPageType = F2(
	function (id, fields) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Signup / Checkout')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Select plan signup page'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(
							A2($author$project$Components$Admin$SignupPages$Form$buttonStyle, 'signup', fields.ahI)),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Admin$SignupPages$Form$FormUpdated(
								$author$project$Components$Admin$SignupPages$Form$Type('signup'))),
							$author$project$Ui$Button$disabled(
							$author$project$Utils$Maybe$toBool(id))
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 21)
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Select checkout page'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(
							A2($author$project$Components$Admin$SignupPages$Form$buttonStyle, 'checkout', fields.ahI)),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Admin$SignupPages$Form$FormUpdated(
								$author$project$Components$Admin$SignupPages$Form$Type('checkout'))),
							$author$project$Ui$Button$disabled(
							$author$project$Utils$Maybe$toBool(id))
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 22)
						]))
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$LimitAvailablePractitioners = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$PractitionerRemove = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewPractitioner = function (practitioner) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(practitioner.zh),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Remove practitioner'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$size(0),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$SignupPages$Form$FormUpdated(
							$author$project$Components$Admin$SignupPages$Form$PractitionerRemove(practitioner.adR))),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewProviderSettings = F2(
	function (fields, practitionerResourceFilter) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Enable Provider Settings')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.SR),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailablePractitioners))
						])),
					fields.SR ? A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Selected provider(s) will display on the patient\'s enrollment page.')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, practitionerResourceFilter)),
							A2(
								$elm$core$List$map,
								$author$project$Components$Admin$SignupPages$Form$viewPractitioner,
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.zh;
									},
									A2(
										$elm$core$List$map,
										function (p) {
											return _Utils_update(
												p,
												{
													zh: $elm$core$String$trim(p.zh)
												});
										},
										fields.WQ)))))) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$Slug = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewSlug = F2(
	function (fields, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Url'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$addon(
							_List_fromArray(
								[
									(fields.ahI === 'signup') ? $elm$html$Html$text('signup/') : $elm$html$Html$text('checkout/')
								])),
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields._c),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$Slug))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 0, form))
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$Active = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewStatus = F2(
	function (fields, practice) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Live')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.Ic),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$Active))
						])),
					(!$author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice)) ? A3(
					$author$project$Ui$Tooltip$view,
					_List_Nil,
					'The Signup Page will remain inactive until you finish setting up Payment Processing',
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$author$project$Utils$Html$noBreakSpace,
									A2($author$project$Ui$Icon$view, _List_Nil, 5)
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Admin$SignupPages$Form$AddonAdd = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$addonOptions = F2(
	function (addons, currentAddons) {
		var signupPageAddonIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.adR;
			},
			currentAddons);
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Select an Addon'),
			A2(
				$elm$core$List$map,
				function (addon) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Addon$Min$id(addon)),
						$author$project$Api$Provider$Addon$Min$name(addon));
				},
				A2(
					$elm_community$list_extra$List$Extra$filterNot,
					function (addon) {
						return A2(
							$elm$core$List$member,
							$author$project$Api$Provider$Addon$Min$id(addon),
							signupPageAddonIds);
					},
					addons)));
	});
var $author$project$Components$Admin$SignupPages$Form$AddonRemove = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$SignupPages$Form$viewAddon = function (addon) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(addon.zh),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Delete addon'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$size(0),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Admin$SignupPages$Form$FormUpdated(
							$author$project$Components$Admin$SignupPages$Form$AddonRemove(addon.adR))),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Admin$SignupPages$Form$viewWrapAround = F3(
	function (fields, companyId, practice) {
		var practiceAddons = $author$project$Api$Provider$Practice$One$addons(practice);
		return ($elm$core$List$isEmpty(practiceAddons) || $author$project$Utils$Maybe$toBool(companyId)) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Wrap-Arounds')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$AddonAdd))
						]),
					A2($author$project$Components$Admin$SignupPages$Form$addonOptions, practiceAddons, fields.Is)),
				A2($elm$core$List$map, $author$project$Components$Admin$SignupPages$Form$viewAddon, fields.Is)));
	});
var $author$project$Components$Admin$SignupPages$Form$viewForm = F2(
	function (model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$core$List$cons,
			$author$project$Utils$Maybe$isNothing(model.ff) ? A2($author$project$Components$Admin$SignupPages$Form$viewPageType, model.adR, fields) : $author$project$Utils$Html$empty,
			A2(
				$elm$core$List$cons,
				A4($author$project$Components$Admin$SignupPages$Form$viewBillingMethod, fields, model.jw, model.cK, form),
				A2(
					$elm$core$List$cons,
					A2($author$project$Components$Admin$SignupPages$Form$viewSlug, fields, form),
					A2(
						$elm$core$List$cons,
						A2($author$project$Components$Admin$SignupPages$Form$viewStatus, fields, model.WF),
						A2(
							$elm$core$List$cons,
							A3($author$project$Components$Admin$SignupPages$Form$viewWrapAround, fields, model.ff, model.WF),
							A2(
								$elm$core$List$cons,
								($author$project$Api$Provider$Practice$One$locationGroupsCount(model.WF) > 0) ? A2($author$project$Components$Admin$SignupPages$Form$viewLocationGroupSettings, fields, model.rk) : $author$project$Utils$Html$empty,
								A2(
									$elm$core$List$cons,
									A2($author$project$Components$Admin$SignupPages$Form$viewLocationSettings, fields, model.rl),
									A2(
										$elm$core$List$cons,
										A2($author$project$Components$Admin$SignupPages$Form$viewProviderSettings, fields, model.jC),
										A2(
											$elm$core$List$cons,
											$author$project$Components$Admin$SignupPages$Form$viewEnableConfirmationSettings(fields),
											fields.aaw ? A3($author$project$Components$Admin$SignupPages$Form$viewCustomSettings, fields, model.WF, form) : _List_Nil)))))))));
	});
var $author$project$Components$Admin$SignupPages$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$Admin$SignupPages$Form$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										function () {
										var _v1 = model.adR;
										if (!_v1.$) {
											return $elm$html$Html$text('Edit Signup Page');
										} else {
											return $elm$html$Html$text('New Signup Page');
										}
									}()
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$pull(1)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Admin__SignupPages__Top,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$Ui$Icon$view, _List_Nil, 2)
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v2 = model.PB;
							if (!_v2.$) {
								var form = _v2.a;
								return A2($author$project$Components$Admin$SignupPages$Form$viewForm, model, form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Components$Admin$SignupPages$Form$cancelRoute(model.ff),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									])),
								function () {
								var verb = function () {
									var _v4 = model.adR;
									if (!_v4.$) {
										return 'Update';
									} else {
										return 'Create';
									}
								}();
								var allowSave = function () {
									var _v3 = model.PB;
									if (!_v3.$) {
										var form = _v3.a;
										return $author$project$Components$Admin$SignupPages$Form$canSave(
											$author$project$Utils$Form$fields(form));
									} else {
										return true;
									}
								}();
								return A3(
									$author$project$Ui$Button$view,
									{abp: verb},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$Save),
											$author$project$Ui$Button$loading(
											_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
											$author$project$Ui$Button$disabled(!allowSave)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(verb)
										]));
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$SignupPages$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$SignupPages$Form$view(model.PB))
			]),
		$G: 'Admin | Signup Pages'
	};
};
var $author$project$Pages$Admin$SignupPages$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$SignupPages$Id_String$init, aer: $author$project$Pages$Admin$SignupPages$Id_String$load, agD: $author$project$Pages$Admin$SignupPages$Id_String$save, ahd: $author$project$Pages$Admin$SignupPages$Id_String$subscriptions, aaq: $author$project$Pages$Admin$SignupPages$Id_String$update, ahP: $author$project$Pages$Admin$SignupPages$Id_String$view});
var $author$project$Pages$Admin$SignupPages$New$FormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Admin$SignupPages$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var _v2 = A6($author$project$Components$Admin$SignupPages$Form$init, apiClient, session, practice, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
	});
var $author$project$Pages$Admin$SignupPages$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SignupPages$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$SignupPages$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$SignupPages$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var formCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd),
			outMsgs);
	});
var $author$project$Pages$Admin$SignupPages$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$SignupPages$Form$view(model.PB))
			]),
		$G: 'Admin | Signup Pages'
	};
};
var $author$project$Pages$Admin$SignupPages$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$SignupPages$New$init, aer: $author$project$Pages$Admin$SignupPages$New$load, agD: $author$project$Pages$Admin$SignupPages$New$save, ahd: $author$project$Pages$Admin$SignupPages$New$subscriptions, aaq: $author$project$Pages$Admin$SignupPages$New$update, ahP: $author$project$Pages$Admin$SignupPages$New$view});
var $author$project$Pages$Admin$SignupPages$Top$GotItems = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$SignupPage$listDefaults = {
	ff: $elm$core$Maybe$Nothing,
	afy: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
};
var $author$project$Api$Provider$SignupPage$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$SignupPage$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ff;
				if (!_v0.$) {
					var companyId = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'company_id', companyId)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.afy;
				if (!_v1.$) {
					var pagination = _v1.a;
					return $author$project$Api$Pagination$toApiParams(pagination);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$SignupPage$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$SignupPage$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$SignupPage$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
	});
var $author$project$Pages$Admin$SignupPages$Top$fetchItems = function (model) {
	return A3(
		$author$project$Api$Provider$SignupPage$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					afy: $elm$core$Maybe$Just(model.afy)
				});
		},
		$author$project$Pages$Admin$SignupPages$Top$GotItems);
};
var $author$project$Pages$Admin$SignupPages$Top$GotDefault = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$getDefault = function (model) {
	return A2($author$project$Api$Provider$SignupPage$getDefault, model.D5, $author$project$Pages$Admin$SignupPages$Top$GotDefault);
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$init = $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed;
var $author$project$Pages$Admin$SignupPages$Top$init = F4(
	function (_v0, practice, _v1, _v2) {
		var apiClient = _v1.D5;
		var query = _v2.Bi;
		var model = {
			Is: $author$project$Api$Provider$Practice$One$addons(practice),
			D5: apiClient,
			fk: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$init(apiClient),
			Nk: $elm$core$Maybe$Nothing,
			ic: $elm$core$Maybe$Nothing,
			dN: $elm$core$Set$empty,
			iZ: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			AU: $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice),
			oZ: $author$project$Api$Data$NotAsked
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$SignupPages$Top$fetchItems(model),
						$author$project$Pages$Admin$SignupPages$Top$getDefault(model)
					])));
	});
var $author$project$Pages$Admin$SignupPages$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$SignupPages$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal = {$: 0};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$Broker$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Broker$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$ResourceFilter$LeadSource$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$LeadSource$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$ResourceFilter$Location$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$ResourceFilter$Practitioner$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$subscriptions = function (model) {
	if (model.$ === 1) {
		var open_ = model.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal),
					$author$project$Ui$NewDropdown$subscriptions(open_.ld),
					$author$project$Ui$NewDropdown$subscriptions(open_.lz),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg,
					$author$project$Components$ResourceFilter$Practitioner$subscriptions(open_.jC)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg,
					$author$project$Components$ResourceFilter$Location$subscriptions(open_.rl)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg,
					$author$project$Components$ResourceFilter$LeadSource$subscriptions(open_.mQ)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg,
					$author$project$Components$ResourceFilter$Broker$subscriptions(open_.lf))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Admin$SignupPages$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg,
				$author$project$Components$Admin$SignupPages$CustomizeUrlModal$subscriptions(model.fk)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed),
					model.ic))
			]));
};
var $author$project$Pages$Admin$SignupPages$Top$DefaultSignupPageUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$Deleted = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Provider$SignupPage$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$SignupPage$signupPagePath(id_)));
	});
var $author$project$Api$Provider$SignupPage$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$SignupPage$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$id(shared);
};
var $author$project$Api$Provider$SignupPage$makeDefault = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$SignupPage$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['default']),
					$author$project$Api$Provider$SignupPage$signupPagePath(id_))));
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotCoupons = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotSignupPageOne = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsInit = {pF: $elm$core$Maybe$Nothing, vJ: $elm$core$Maybe$Nothing, L1: $elm$core$Maybe$Nothing, SH: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, afS: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Broker$brokersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['brokers']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Broker$All$Broker = $elm$core$Basics$identity;
var $author$project$Api$Provider$Broker$Shared$Broker = $elm$core$Basics$identity;
var $author$project$Api$Provider$Broker$Shared$Record = F4(
	function (id, name, endedOn, brokerAccount) {
		return {vK: brokerAccount, OA: endedOn, adR: id, zh: name};
	});
var $author$project$Api$Provider$BrokerAccount$Shared$BrokerAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerAccount$Shared$Record = F5(
	function (id, name, retailEnabled, multipleBrokers, ratePeriodSchedule) {
		return {adR: id, Uk: multipleBrokers, zh: name, XK: ratePeriodSchedule, agv: retailEnabled};
	});
var $author$project$Api$Provider$RatePeriodSchedule$Shared$RatePeriodSchedule = $elm$core$Basics$identity;
var $author$project$Api$Provider$RatePeriodSchedule$Shared$Record = function (intervals) {
	return {ad4: intervals};
};
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$RatePeriodScheduleInterval = $elm$core$Basics$identity;
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$Record = F2(
	function (intervalInMonths, pricingStructure) {
		return {ad3: intervalInMonths, W2: pricingStructure};
	});
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pricing_structure',
	$author$project$Api$Provider$PricingStructure$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'interval_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$RatePeriodScheduleInterval$Shared$Record)));
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$RatePeriodSchedule$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'intervals',
	$elm$json$Json$Decode$list($author$project$Api$Provider$RatePeriodScheduleInterval$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$RatePeriodSchedule$Shared$Record));
var $author$project$Api$Provider$RatePeriodSchedule$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RatePeriodSchedule$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rate_period_schedule',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$RatePeriodSchedule$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'multiple_brokers',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'retail_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$Shared$Record))))));
var $author$project$Api$Provider$BrokerAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Broker$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'broker_account',
	$author$project$Api$Provider$BrokerAccount$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ended_on',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Broker$Shared$Record)))));
var $author$project$Api$Provider$Broker$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Broker$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Broker$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Broker$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Broker$listDefaults = {vK: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, QR: $elm$core$Maybe$Nothing, Gg: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, G2: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Broker$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Broker$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.G2;
				if (!_v2.$) {
					var bool = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'retail', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.QR;
				if (!_v3.$) {
					var bool = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'inactive', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.vK;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker_account', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.Gg;
				if (!_v5.$) {
					var bool = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'no_end', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Broker$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Broker$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Broker$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Broker$brokersPath)));
	});
var $author$project$Components$ResourceFilter$Broker$list = $author$project$Api$Provider$Broker$list;
var $author$project$Components$ResourceFilter$Broker$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Broker$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Broker$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Broker$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Broker$selectId = 'brokers';
var $author$project$Api$Provider$Broker$Shared$brokerAccount = function (_v0) {
	var record = _v0;
	return record.vK;
};
var $author$project$Api$Provider$Broker$All$brokerAccount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$brokerAccount(shared);
};
var $author$project$Api$Provider$Broker$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Broker$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$name(shared);
};
var $author$project$Api$Provider$BrokerAccount$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$ResourceFilter$Broker$toTitle = function (resource) {
	return $author$project$Api$Provider$Broker$All$name(resource) + (' - ' + $author$project$Api$Provider$BrokerAccount$Shared$name(
		$author$project$Api$Provider$Broker$All$brokerAccount(resource)));
};
var $author$project$Components$ResourceFilter$Broker$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Broker$toTitle(resource))
		]);
};
var $author$project$Api$Provider$Broker$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Broker$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$Broker$toValue = $author$project$Api$Provider$Broker$All$id;
var $author$project$Components$ResourceFilter$Broker$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$Broker$fetchResources(listOptionals),
				adR: $author$project$Components$ResourceFilter$Broker$selectId,
				gx: 'Broker',
				st: $author$project$Components$ResourceFilter$Broker$retrieveResource(listOptionals),
				ahw: $author$project$Components$ResourceFilter$Broker$toLabel,
				ahA: $author$project$Components$ResourceFilter$Broker$toTitle,
				g0: $author$project$Components$ResourceFilter$Broker$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$LeadSource$list = $author$project$Api$Provider$LeadSource$list;
var $author$project$Components$ResourceFilter$LeadSource$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$LeadSource$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$LeadSource$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$LeadSource$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$LeadSource$selectId = 'lead-sources';
var $author$project$Components$ResourceFilter$LeadSource$toTitle = function (resource) {
	return $author$project$Api$Provider$LeadSource$All$name(resource);
};
var $author$project$Components$ResourceFilter$LeadSource$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$LeadSource$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$LeadSource$toValue = $author$project$Api$Provider$LeadSource$All$id;
var $author$project$Components$ResourceFilter$LeadSource$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$LeadSource$fetchResources(listOptionals),
				adR: $author$project$Components$ResourceFilter$LeadSource$selectId,
				gx: 'Lead Source',
				st: $author$project$Components$ResourceFilter$LeadSource$retrieveResource(listOptionals),
				ahw: $author$project$Components$ResourceFilter$LeadSource$toLabel,
				ahA: $author$project$Components$ResourceFilter$LeadSource$toTitle,
				g0: $author$project$Components$ResourceFilter$LeadSource$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$open = F2(
	function (signupPage, model) {
		if (!model.$) {
			var apiClient = model.a;
			var _v1 = A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							Gr: $elm$core$Maybe$Just(true),
							Hc: $elm$core$Maybe$Just(
								$author$project$Api$Provider$SignupPage$All$id(signupPage))
						});
				},
				function (d) {
					return _Utils_update(
						d,
						{D0: 'None'});
				});
			var practitionerResourceFilter = _v1.a;
			var practitionerResourceFilterCmd = _v1.b;
			var _v2 = A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				$elm$core$Maybe$Nothing,
				function (d) {
					return _Utils_update(
						d,
						{
							Gr: $elm$core$Maybe$Just(true),
							Hc: $elm$core$Maybe$Just(
								$author$project$Api$Provider$SignupPage$All$id(signupPage))
						});
				},
				function (d) {
					return _Utils_update(
						d,
						{D0: 'None'});
				});
			var locationResourceFilter = _v2.a;
			var locationResourceFilterCmd = _v2.b;
			var _v3 = A3(
				$author$project$Components$ResourceFilter$LeadSource$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'None'});
				});
			var leadSourceResourceFilter = _v3.a;
			var leadSourceResourceFilterCmd = _v3.b;
			var _v4 = A3(
				$author$project$Components$ResourceFilter$Broker$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							G2: $elm$core$Maybe$Just(true)
						});
				},
				function (d) {
					return _Utils_update(
						d,
						{D0: 'None'});
				});
			var brokerResourceFilter = _v4.a;
			var brokerResourceFilterCmd = _v4.b;
			return _Utils_Tuple2(
				$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
					{
						IZ: $elm$core$Maybe$Nothing,
						ld: $author$project$Ui$NewDropdown$init(
							$author$project$Ui$NewDropdown$defaultConfig(
								{adR: 'billing-period-dropdown-filter', ahx: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodDropdownMsg})),
						lf: brokerResourceFilter,
						lz: $author$project$Ui$NewDropdown$init(
							$author$project$Ui$NewDropdown$defaultConfig(
								{adR: 'coupon-dropdown-filter', ahx: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponDropdownMsg})),
						wR: $author$project$Api$Data$Loading,
						PB: $author$project$Utils$Form$init($author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsInit),
						mQ: leadSourceResourceFilter,
						rl: locationResourceFilter,
						jC: practitionerResourceFilter,
						Hc: signupPage
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3(
							$author$project$Api$Provider$Coupon$list,
							apiClient,
							function (d) {
								return _Utils_update(
									d,
									{
										GY: $elm$core$Maybe$Just(true)
									});
							},
							$author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotCoupons),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg, locationResourceFilterCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg, brokerResourceFilterCmd),
							A3(
							$author$project$Api$Provider$SignupPage$retrieve,
							apiClient,
							$author$project$Api$Provider$SignupPage$All$id(signupPage),
							$author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotSignupPageOne)
						])));
		} else {
			var open_ = model.a;
			return _Utils_Tuple2(
				$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(open_),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriod = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Broker = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Coupon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotPlanAllowedCodes = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSource = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Location = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Practitioner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{afS: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{aet: string});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{pF: string});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{L1: string});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{SH: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{vJ: string});
		}
	});
var $author$project$Components$ResourceFilter$Broker$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$LeadSource$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$Broker$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$ResourceFilter$LeadSource$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$ResourceFilter$Location$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$update = F3(
	function (apiClient, msg, model) {
		if (!model.$) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var open_ = model.a;
			switch (msg.$) {
				case 0:
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed(apiClient),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 1:
					var subMsg = msg.a;
					var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, open_.jC);
					var newForm = function () {
						var _v2 = practitionerResourceResult.ac5;
						if ((!_v2.$) && (!_v2.a.$)) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Practitioner(
									$author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.y8)),
								open_.PB);
						} else {
							return open_.PB;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{PB: newForm, jC: practitionerResourceResult.y8})),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
						practitionerResourceResult.as);
				case 2:
					var subMsg = msg.a;
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, open_.rl);
					var newForm = function () {
						var _v3 = locationResourceResult.ac5;
						if ((!_v3.$) && (!_v3.a.$)) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Location(
									$author$project$Components$ResourceFilter$Location$value(locationResourceResult.y8)),
								open_.PB);
						} else {
							return open_.PB;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{PB: newForm, rl: locationResourceResult.y8})),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg, locationResourceResult.EC),
						locationResourceResult.as);
				case 3:
					var subMsg = msg.a;
					var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, open_.ld);
					var billingPeriodDropdown = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{ld: billingPeriodDropdown})),
						cmd,
						_List_Nil);
				case 4:
					var selectedPeriod = msg.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriod(selectedPeriod),
						open_.PB);
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{PB: newForm})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 5:
					var response = msg.a;
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{wR: response})),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				case 12:
					var response = msg.a;
					var planIds = function () {
						if (response.$ === 3) {
							var sp = response.a;
							return A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeR, $author$project$Api$Provider$SignupPagePlan$Shared$plan, $author$project$Api$Provider$Plan$Min$id),
								$author$project$Api$Provider$SignupPage$One$signupPagePlans(sp));
						} else {
							return _List_Nil;
						}
					}();
					var planFetchCmds = $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (id_) {
								return A4($author$project$Api$Provider$Plan$retrieve, apiClient, id_, _List_Nil, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotPlanAllowedCodes);
							},
							planIds));
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(open_),
						planFetchCmds,
						$author$project$OutMsg$handleErrorResponse(response));
				case 11:
					var response = msg.a;
					var newAllowed = function () {
						if (response.$ === 3) {
							var plan = response.a;
							return $elm_community$list_extra$List$Extra$unique(
								$author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes(plan));
						} else {
							return _List_Nil;
						}
					}();
					var merged = function () {
						var _v6 = open_.IZ;
						if (!_v6.$) {
							var existing = _v6.a;
							return $elm_community$list_extra$List$Extra$unique(
								_Utils_ap(existing, newAllowed));
						} else {
							return newAllowed;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{
									IZ: $elm$core$Maybe$Just(merged)
								})),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				case 6:
					var subMsg = msg.a;
					var _v8 = A2($author$project$Ui$NewDropdown$update, subMsg, open_.lz);
					var couponDropdown = _v8.a;
					var cmd = _v8.b;
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{lz: couponDropdown})),
						cmd,
						_List_Nil);
				case 7:
					var selectedCoupon = msg.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Coupon(selectedCoupon),
						open_.PB);
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{PB: newForm})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 8:
					var subMsg = msg.a;
					var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, open_.mQ);
					var newForm = function () {
						var _v9 = leadSourceResourceResult.ac5;
						if ((!_v9.$) && (!_v9.a.$)) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSource(
									$author$project$Components$ResourceFilter$LeadSource$value(leadSourceResourceResult.y8)),
								open_.PB);
						} else {
							return open_.PB;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{PB: newForm, mQ: leadSourceResourceResult.y8})),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg, leadSourceResourceResult.EC),
						leadSourceResourceResult.as);
				case 9:
					var subMsg = msg.a;
					var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, open_.lf);
					var newForm = function () {
						var _v10 = brokerResourceResult.ac5;
						if ((!_v10.$) && (!_v10.a.$)) {
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Broker(
									$author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.y8)),
								open_.PB);
						} else {
							return open_.PB;
						}
					}();
					return _Utils_Tuple3(
						$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(
							_Utils_update(
								open_,
								{lf: brokerResourceResult.y8, PB: newForm})),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg, brokerResourceResult.EC),
						brokerResourceResult.as);
				default:
					var url = msg.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Clipboard$copy(url),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
							]));
			}
		}
	});
var $author$project$Pages$Admin$SignupPages$Top$updateUrl = function (model) {
	var queryParams = _List_Nil;
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__SignupPages__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Pages$Admin$SignupPages$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								iZ: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var signupPages = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Nk: $elm$core$List$head(signupPages)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$SignupPages$Top$fetchItems(newModel),
								$author$project$Pages$Admin$SignupPages$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oZ: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$SignupPage$makeDefault, model.D5, id, $author$project$Pages$Admin$SignupPages$Top$DefaultSignupPageUpdated),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iZ: $author$project$Api$Data$Loading, oZ: response}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Admin$SignupPages$Top$fetchItems(model),
									$author$project$Pages$Admin$SignupPages$Top$getDefault(model)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Default page updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oZ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 5:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$SignupPage$All$id(item),
										model.dN),
									iZ: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$SignupPages$Top$fetchItems(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Page was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$SignupPage$All$id(item),
										model.dN)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$SignupPage$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ic: $elm$core$Maybe$Nothing,
								dN: A2($elm$core$Set$insert, id, model.dN)
							}),
						A3(
							$author$project$Api$Provider$SignupPage$delete,
							model.D5,
							id,
							$author$project$Pages$Admin$SignupPages$Top$Deleted(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var item = msg.a;
				var _v5 = A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$open, item, model.fk);
				var customizeUrl = _v5.a;
				var customizeUrlCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fk: customizeUrl}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg, customizeUrlCmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$update, model.D5, subMsg, model.fk);
				var customizeUrl = _v6.a;
				var customizeUrlCmd = _v6.b;
				var outMsgs = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fk: customizeUrl}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg, customizeUrlCmd),
					outMsgs);
		}
	});
var $author$project$Api$FeatureGate$MultipleSignupPages = 0;
var $author$project$Pages$Admin$SignupPages$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$UpdateDefaultSignupPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$SignupPage$All$slug = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$slug(shared);
};
var $author$project$Pages$Admin$SignupPages$Top$defaultPageOptions = F2(
	function (items, _default) {
		var allItems = function () {
			if (!_default.$) {
				var defaultSignupPage = _default.a;
				return A2(
					$elm$core$List$cons,
					defaultSignupPage,
					A2(
						$elm$core$List$filter,
						function (item) {
							return !_Utils_eq(
								$author$project$Api$Provider$SignupPage$All$id(item),
								$author$project$Api$Provider$SignupPage$All$id(defaultSignupPage));
						},
						items));
			} else {
				return items;
			}
		}();
		return A2(
			$elm$core$List$map,
			function (item) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$SignupPage$All$id(item)),
					'/signup/' + $author$project$Api$Provider$SignupPage$All$slug(item));
			},
			allItems);
	});
var $author$project$Ui$Form$Select$Size = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Form$Select$size = $author$project$Ui$Form$Select$Size;
var $author$project$Pages$Admin$SignupPages$Top$help = function (model) {
	var _v0 = model.iZ;
	if (_v0.$ === 3) {
		var items = _v0.a;
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[$author$project$Ui$Typography$small]),
			_List_fromArray(
				[
					$elm$html$Html$text('Available at '),
					A3(
					$author$project$Ui$Link$externalHref,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.Nk)),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.Nk)))
						])),
					$elm$html$Html$text(' which will redirect to '),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-inline')
						]),
					_List_fromArray(
						[
							($elm$core$List$length(items) > 1) ? A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$inline,
									$author$project$Ui$Form$Select$size(1),
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$id, model.Nk)),
									$author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$SignupPages$Top$UpdateDefaultSignupPage),
									$author$project$Ui$Form$Select$loading(
									_Utils_eq(model.oZ, $author$project$Api$Data$Loading))
								]),
							A2($author$project$Pages$Admin$SignupPages$Top$defaultPageOptions, items, model.Nk)) : $elm$html$Html$text(
							'/signup/' + A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$slug, model.Nk)))
						]))
				]));
	} else {
		return $author$project$Ui$Spinner$view(_List_Nil);
	}
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Copy = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$SignupPage$Shared$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Api$Provider$SignupPage$All$url = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$url(shared);
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$buildUrl = F2(
	function (signupPage, fields) {
		var queryParams = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('practitioner'),
					fields.afS),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('location'),
					fields.aet),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('billing_period'),
					fields.pF),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('coupon'),
					fields.L1),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('lead'),
					fields.SH),
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('broker'),
					fields.vJ)
				]));
		if ($elm$core$List$isEmpty(queryParams)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var signupPageUrl = $author$project$Api$Provider$SignupPage$All$url(signupPage);
			return $elm$core$Maybe$Just(
				A2($author$project$Utils$Url$addParams, signupPageUrl, queryParams));
		}
	});
var $author$project$Api$Provider$SignupPage$All$type_ = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$type_(shared);
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName = function (billName) {
	return A3(
		$elm$core$String$replace,
		'-',
		'_',
		$elm$core$String$toLower(billName));
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewBillingPeriodDropdown = F2(
	function (model, billingPeriod) {
		var loading = _Utils_eq(model.IZ, $elm$core$Maybe$Nothing);
		var items = function () {
			if (loading) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$NewDropdown$item,
						_List_Nil,
						$elm$html$Html$text('Loading...'))
					]);
			} else {
				var allowedCodes = A2($elm$core$Maybe$withDefault, _List_Nil, model.IZ);
				var periods = A2(
					$elm$core$List$filter,
					function (p) {
						return A2(
							$elm$core$List$member,
							$author$project$Api$Period$code(p),
							allowedCodes);
					},
					$author$project$Api$Period$list);
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected($elm$core$Maybe$Nothing))
							]),
						$elm$html$Html$text('None')),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$NewDropdown$separator,
						A2(
							$elm$core$List$map,
							function (p) {
								var periodValue = $author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName(
									$author$project$Api$Period$billName(p));
								var periodLabel = $elm_community$string_extra$String$Extra$toSentenceCase(
									$author$project$Api$Period$billName(p));
								return A2(
									$author$project$Ui$NewDropdown$item,
									_List_fromArray(
										[
											$author$project$Ui$NewDropdown$onSelect(
											$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected(
												$elm$core$Maybe$Just(periodValue))),
											$author$project$Ui$NewDropdown$selected(
											_Utils_eq(
												billingPeriod,
												$elm$core$Maybe$Just(periodValue)))
										]),
									$elm$html$Html$text(periodLabel));
							},
							periods)));
			}
		}();
		var currentLabel = function () {
			if (!billingPeriod.$) {
				var period = billingPeriod.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'None',
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Api$Period$billName, $elm_community$string_extra$String$Extra$toSentenceCase),
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (p) {
									return _Utils_eq(
										$author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName(
											$author$project$Api$Period$billName(p)),
										period);
								},
								$author$project$Api$Period$list))));
			} else {
				return 'None';
			}
		}();
		return A4(
			$author$project$Ui$NewDropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(currentLabel)
				]),
			items,
			model.ld);
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewCouponDropdown = F2(
	function (model, coupon) {
		var items = function () {
			var _v1 = model.wR;
			if (_v1.$ === 3) {
				var coupons = _v1.a;
				return A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected($elm$core$Maybe$Nothing))
							]),
						$elm$html$Html$text('None')),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$NewDropdown$separator,
						A2(
							$elm$core$List$map,
							function (couponItem) {
								var couponCode = $author$project$Api$Provider$Coupon$All$code(couponItem);
								return A2(
									$author$project$Ui$NewDropdown$item,
									_List_fromArray(
										[
											$author$project$Ui$NewDropdown$onSelect(
											$author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected(
												$elm$core$Maybe$Just(couponCode))),
											$author$project$Ui$NewDropdown$selected(
											_Utils_eq(
												coupon,
												$elm$core$Maybe$Just(couponCode)))
										]),
									$elm$html$Html$text(couponCode));
							},
							coupons)));
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$NewDropdown$item,
						_List_Nil,
						$elm$html$Html$text('Loading...'))
					]);
			}
		}();
		var currentLabel = function () {
			if (!coupon.$) {
				var couponCode = coupon.a;
				return couponCode;
			} else {
				return 'None';
			}
		}();
		return A4(
			$author$project$Ui$NewDropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(currentLabel)
				]),
			items,
			model.lz);
	});
var $author$project$Components$ResourceFilter$Broker$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$ResourceFilter$LeadSource$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$ResourceFilter$Location$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$ResourceFilter$Practitioner$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var url = A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$buildUrl, model.Hc, fields);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Customize URL')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Edit the form below to generate a unique URL to send to your patients.')
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Patient & Billing')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('This information will be displayed to the patient, but can not be changed.')
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Practitioner')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Practitioner$viewNew, _List_Nil, model.jC))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Location')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Location$viewNew, _List_Nil, model.rl))
							])),
						($author$project$Api$Provider$SignupPage$All$type_(model.Hc) === 'signup') ? A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Billing Period')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewBillingPeriodDropdown, model, fields.pF)
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Coupon')
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewCouponDropdown, model, fields.L1)
							])),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Sales & Marketing')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('This information will be recorded but will not be displayed to the patient.')
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Lead Source')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$LeadSource$viewNew, _List_Nil, model.mQ))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$label('Broker')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg,
								A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_Nil, model.lf))
							])),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Once applying a form from above, copy the new url below or test it by '),
										function () {
										if (!url.$) {
											var url_ = url.a;
											return A3(
												$author$project$Ui$Link$externalHref,
												url_,
												_List_fromArray(
													[$author$project$Ui$Link$targetBlank]),
												_List_fromArray(
													[
														$elm$html$Html$text('clicking here')
													]));
										} else {
											return $elm$html$Html$text('clicking here');
										}
									}(),
										$elm$html$Html$text('.')
									])),
								$author$project$Ui$Form$Input$group(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2($elm$core$Maybe$withDefault, '', url)),
												$author$project$Ui$Form$Input$disabled(true)
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Copy url'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$disabled(
												!$author$project$Utils$Maybe$toBool(url)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Admin$SignupPages$CustomizeUrlModal$Copy(
													A2($elm$core$Maybe$withDefault, '', url)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Copy')
											]))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('The url generated below is not stored, but can be re-created here at any time.')
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Done')
							]))
					]))
			]));
};
var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$view = function (model) {
	if (model.$ === 1) {
		var open_ = model.a;
		return $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewModal(open_);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$SignupPages$Top$viewNewSignupPageButton = A3(
	$author$project$Ui$Link$route,
	$author$project$Spa$Generated$Route$Admin__SignupPages__New,
	_List_fromArray(
		[
			$author$project$Ui$Link$buttonDefault,
			$author$project$Ui$Link$pull(1),
			$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('New Signup Page')
		]));
var $author$project$Pages$Admin$SignupPages$Top$CustomizeUrl = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$SignupPages$Top$Delete = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$SignupPage$Shared$acceptsNewSignup = function (_v0) {
	var record = _v0;
	return record.H1;
};
var $author$project$Api$Provider$SignupPage$All$acceptsNewSignup = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$acceptsNewSignup(shared);
};
var $author$project$Api$Provider$SignupPage$All$active = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$active(shared);
};
var $author$project$Api$Provider$SignupPage$All$addons = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$addons(shared);
};
var $author$project$Api$Pagination$currentPageNumber = function (_v0) {
	var model = _v0;
	return model.bV;
};
var $author$project$Api$Provider$SignupPage$Shared$default = function (_v0) {
	var record = _v0;
	return record.M5;
};
var $author$project$Api$Provider$SignupPage$All$default = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$default(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$listSignupPagePlans = function (signupPage) {
	return $author$project$Formatters$String$toSentence(
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$SignupPagePlan$Shared$plan, $author$project$Api$Provider$Plan$Min$name),
			$author$project$Api$Provider$SignupPage$Shared$signupPagePlans(signupPage)));
};
var $author$project$Api$Provider$SignupPage$Shared$displayName = function (signupPage) {
	return ($author$project$Api$Provider$SignupPage$Shared$type_(signupPage) === 'checkout') ? A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$ChargeItem$Min$name,
			$author$project$Api$Provider$SignupPage$Shared$chargeItem(signupPage))) : $author$project$Api$Provider$SignupPage$Shared$listSignupPagePlans(signupPage);
};
var $author$project$Api$Provider$SignupPage$All$displayName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$displayName(shared);
};
var $author$project$Api$Provider$SignupPage$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.RJ;
};
var $author$project$Api$Provider$SignupPage$All$isDestroyable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SignupPage$Shared$isDestroyable(shared);
};
var $author$project$Pages$Admin$SignupPages$Top$listSignupPageAddons = function (addons) {
	return $author$project$Formatters$String$toSentence(
		A2($elm$core$List$map, $author$project$Api$Provider$Addon$Shared$name, addons));
};
var $author$project$Ui$OverflowWrap$WordBreakAll = 4;
var $author$project$Ui$OverflowWrap$wordBreakAll = 4;
var $author$project$Pages$Admin$SignupPages$Top$viewItem = F2(
	function (model, item) {
		var status = (model.AU && ($author$project$Api$Provider$SignupPage$All$active(item) && $author$project$Api$Provider$SignupPage$All$acceptsNewSignup(item))) ? 'live' : ((!$author$project$Api$Provider$SignupPage$All$acceptsNewSignup(item)) ? 'error' : 'inactive');
		var id = $author$project$Api$Provider$SignupPage$All$id(item);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_Nil,
									_List_fromArray(
										[
											($author$project$Api$Provider$SignupPage$All$type_(item) === 'checkout') ? A2($author$project$Ui$Icon$view, _List_Nil, 22) : A2($author$project$Ui$Icon$view, _List_Nil, 21)
										])),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$SignupPage$All$displayName(item))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$wordBreakAll)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$externalHref,
											$author$project$Api$Provider$SignupPage$All$url(item),
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$SignupPage$All$url(item))
												]))
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Customize URL'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$SignupPages$Top$CustomizeUrl(item))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Customize URL')
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, status)
								]))
						]),
						$elm$core$List$isEmpty(model.Is) ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Admin$SignupPages$Top$listSignupPageAddons(
										$author$project$Api$Provider$SignupPage$All$addons(item)))
								]))
						]),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Admin__SignupPages__Id_String(
												{adR: id}),
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(
													_List_fromArray(
														[
															A2(
															$elm$url$Url$Builder$string,
															'page',
															$elm$core$String$fromInt(
																$author$project$Api$Pagination$currentPageNumber(model.afy)))
														])),
													$author$project$Ui$Link$sm,
													$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											$author$project$Api$Provider$SignupPage$All$default(item) ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Badge$fromString, _List_Nil, 'default')
												])) : $author$project$Utils$Html$empty,
											function () {
											if ($author$project$Api$Provider$SignupPage$All$isDestroyable(item)) {
												var loading = A2($elm$core$Set$member, id, model.dN);
												return A3(
													$author$project$Ui$Button$view,
													{abp: 'Delete signup page'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$size(0),
															$author$project$Ui$Button$loading(loading),
															$author$project$Ui$Button$onClick(
															$author$project$Pages$Admin$SignupPages$Top$Delete(item)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Delete')
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))
								]))
						])
					])));
	});
var $author$project$Pages$Admin$SignupPages$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.iZ;
		if (_v1.$ === 3) {
			var items_ = _v1.a;
			return _Utils_Tuple2(false, items_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('There are no signup pages.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Plan / Charge')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Url')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Status')
							]))
					]),
					$elm$core$List$isEmpty(model.Is) ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Wrap-Arounds Enabled')
							]))
					]),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Admin$SignupPages$Top$viewItem(model),
			items),
		_List_Nil);
};
var $author$project$Pages$Admin$SignupPages$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.ic;
				if (!_v0.$) {
					var item = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed(item),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('signup page'),
								$author$project$Components$HiConfirm$detail('. It will no longer be available for new patients to sign up')
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg,
				$author$project$Components$Admin$SignupPages$CustomizeUrlModal$view(model.fk)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								model.AU ? $author$project$Utils$Html$empty : A2(
								$author$project$Utils$PaymentProcessor$toSetupAlert,
								$author$project$Api$Practice$Provider(model.WF),
								$elm$core$Maybe$Just('In order to enable signup pages')),
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										$elm$html$Html$text('Signup Pages')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Utils$FeatureGate$gate,
										0,
										$author$project$Api$Practice$Provider(model.WF),
										$author$project$Pages$Admin$SignupPages$Top$viewNewSignupPageButton)
									])),
								$author$project$Pages$Admin$SignupPages$Top$help(model)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Admin$SignupPages$Top$viewPanelBody(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$SignupPages$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.iZ))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Signup Pages'
	};
};
var $author$project$Pages$Admin$SignupPages$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$SignupPages$Top$init, aer: $author$project$Pages$Admin$SignupPages$Top$load, agD: $author$project$Pages$Admin$SignupPages$Top$save, ahd: $author$project$Pages$Admin$SignupPages$Top$subscriptions, aaq: $author$project$Pages$Admin$SignupPages$Top$update, ahP: $author$project$Pages$Admin$SignupPages$Top$view});
var $author$project$Pages$Admin$Stripe$StripeMsg = $elm$core$Basics$identity;
var $author$project$Components$Stripe$Connected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Stripe$Connecting = {$: 0};
var $author$project$Components$Stripe$CreateStripeAccount = {$: 3};
var $author$project$Components$Stripe$FailedToConnect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Stripe$HasStripeAccount = {$: 2};
var $author$project$Components$Stripe$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$Shared$accountStep = function (_v0) {
	var record = _v0;
	return record.H6;
};
var $author$project$Api$Provider$Practice$StripeAccount$connect = F3(
	function (apiClient, code, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'stripe_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'code',
								$elm$json$Json$Encode$string(code))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
	});
var $author$project$Components$Stripe$init = F5(
	function (session, practice, shared, query, _v0) {
		var isOnboarding = _v0.aJ;
		var setupCompleted = A2(
			$elm$core$Maybe$withDefault,
			7,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$accountStep,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice))) === 7;
		var shouldRedirectToPracticeSetupStripe = (!setupCompleted) && (!isOnboarding);
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(
				A2($elm$core$Dict$get, 'error', query),
				shouldRedirectToPracticeSetupStripe);
			if (!_v2.b) {
				if (!_v2.a.$) {
					return _Utils_Tuple2(
						$author$project$Components$Stripe$FailedToConnect(
							A2($elm$core$Dict$get, 'error_description', query)),
						$elm$core$Platform$Cmd$none);
				} else {
					var _v3 = _v2.a;
					var _v4 = A2($elm$core$Dict$get, 'code', query);
					if (!_v4.$) {
						var string = _v4.a;
						return _Utils_Tuple2(
							$author$project$Components$Stripe$Connecting,
							A3($author$project$Api$Provider$Practice$StripeAccount$connect, shared.D5, string, $author$project$Components$Stripe$Connected));
					} else {
						return $author$project$Api$Provider$Practice$One$hasStripeAccount(practice) ? _Utils_Tuple2($author$project$Components$Stripe$HasStripeAccount, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Components$Stripe$CreateStripeAccount, $elm$core$Platform$Cmd$none);
					}
				}
			} else {
				return _Utils_Tuple2(
					$author$project$Components$Stripe$CreateStripeAccount,
					A2($author$project$Utils$Route$navigate, query, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing));
			}
		}();
		var status = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{
				fv: false,
				qT: shared.qT,
				FR: $author$project$Shared$isHintAdmin(shared),
				aJ: isOnboarding,
				WF: practice,
				ZD: session,
				ag7: status,
				aaz: $author$project$Api$Platform$Session$One$user(session)
			},
			cmd);
	});
var $author$project$Pages$Admin$Stripe$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5(
			$author$project$Components$Stripe$init,
			session,
			practice,
			shared,
			query,
			{aJ: false});
		var stripe = _v1.a;
		var stripeCmd = _v1.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				FR: $author$project$Shared$isHintAdmin(shared),
				oB: stripe
			},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, stripeCmd));
	});
var $author$project$Pages$Admin$Stripe$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Stripe$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Stripe$HiConfirmClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Stripe$subscriptions = function (_v0) {
	var model = _v0;
	return model.fv ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Stripe$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Admin$Stripe$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Stripe$subscriptions(model.oB));
};
var $author$project$Components$Stripe$Disconnected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Stripe$PracticeOnboardingUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Stripe$skipStripeSetup = F2(
	function (apiClient, practice) {
		var onboardId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$id,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
		return A3($author$project$Api$Provider$PracticeOnboarding$complete, apiClient, onboardId, $author$project$Components$Stripe$PracticeOnboardingUpdated);
	});
var $author$project$Components$Stripe$update = F3(
	function (msg, _v0, apiClient) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v2$2:
				while (true) {
					switch (response.$) {
						case 3:
							var practice = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{WF: practice, ag7: $author$project$Components$Stripe$HasStripeAccount}),
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been connected.'),
										$author$project$OutMsg$PracticeUpdated(response)
									]));
						case 2:
							if (response.a.$ === 6) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											ag7: $author$project$Components$Stripe$FailedToConnect($elm$core$Maybe$Nothing)
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$OutMsg$handleErrorResponse(response));
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fv: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					model,
					A2($author$project$Components$Stripe$skipStripeSetup, apiClient, model.WF),
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					model,
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
					_List_Nil);
			case 7:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$StripeAccount$disconnect, apiClient, $author$project$Components$Stripe$Disconnected),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{fv: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fv: false, WF: practice, ag7: $author$project$Components$Stripe$CreateStripeAccount}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been disconnected.'),
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fv: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$open(model.ZD),
					_List_Nil);
			default:
				var status = $author$project$Api$Provider$Practice$One$hasStripeAccount(model.WF) ? $author$project$Components$Stripe$HasStripeAccount : $author$project$Components$Stripe$CreateStripeAccount;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ag7: status}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Admin$Stripe$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Stripe$update, subMsg, model.oB, model.D5);
		var stripe = _v1.a;
		var stripeCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{oB: stripe}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, stripeCmd),
			outMsgs);
	});
var $author$project$Ui$Image$StripeLogo = 2;
var $author$project$Components$Stripe$viewConnectingBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Status'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, 'connecting')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 8)
					]))
			]))
	]);
var $author$project$Components$Stripe$viewCreateStripeAccountBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Status'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Stripe is a global payments platform that instantly enables business of all sizes to accept and process payments online. Our negotiated volume discount with Stripe can be reviewed '),
						A3(
						$author$project$Ui$Link$externalHref,
						'http://www.hint.com/pricing#stripe',
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						$elm$html$Html$text('.')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('To configure this integration click \'Connect to Stripe\' and you will have the option of creating, or connecting to an existing Stripe account.')
					]))
			]))
	]);
var $author$project$Components$Stripe$SkipStripeSetup = {$: 6};
var $author$project$Api$Platform$User$Shared$firstName = function (_v0) {
	var record = _v0;
	return record.Pu;
};
var $author$project$Api$Platform$User$Shared$lastName = function (_v0) {
	var record = _v0;
	return record.SA;
};
var $author$project$Api$Provider$Practice$Shared$stripeClientId = function (_v0) {
	var record = _v0;
	return record._R;
};
var $author$project$Api$Provider$Practice$One$stripeClientId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$stripeClientId(shared);
};
var $author$project$Components$Stripe$stripeConnectBaseUrl = 'https://connect.stripe.com/oauth/authorize';
var $author$project$Api$Common$Address$Shared$stripeCountryCode = function (_v0) {
	var record = _v0;
	return record._T;
};
var $author$project$Components$Stripe$stripeConnectUrl = function (_v0) {
	var model = _v0;
	var practiceAddress = $author$project$Api$Provider$Practice$One$address(model.WF);
	var stripeUser = _List_fromArray(
		[
			_Utils_Tuple2(
			'first_name',
			$author$project$Api$Platform$User$Shared$firstName(model.aaz)),
			_Utils_Tuple2(
			'last_name',
			$author$project$Api$Platform$User$Shared$lastName(model.aaz)),
			_Utils_Tuple2(
			'email',
			$author$project$Api$Platform$User$Shared$email(model.aaz)),
			_Utils_Tuple2(
			'phone_number',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$Phone$Shared$number,
					$elm$core$List$head(
						$author$project$Api$Provider$Practice$One$phones(model.WF))))),
			_Utils_Tuple2(
			'url',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Practice$One$url(model.WF))),
			_Utils_Tuple2('product_description', 'Primary and urgent care services at a fixed monthly price'),
			_Utils_Tuple2(
			'business_name',
			$author$project$Api$Provider$Practice$One$name(model.WF)),
			_Utils_Tuple2('business_type', 'sole_prop'),
			_Utils_Tuple2(
			'street_address',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line1, practiceAddress))),
			_Utils_Tuple2(
			'city',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$city, practiceAddress))),
			_Utils_Tuple2(
			'zip',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, practiceAddress))),
			_Utils_Tuple2(
			'state',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$state, practiceAddress))),
			_Utils_Tuple2(
			'country',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$stripeCountryCode, practiceAddress)))
		]);
	var queryParams = A2(
		$elm$core$List$cons,
		A2(
			$elm$url$Url$Builder$string,
			'client_id',
			$author$project$Api$Provider$Practice$One$stripeClientId(model.WF)),
		A2(
			$elm$core$List$cons,
			A2($elm$url$Url$Builder$string, 'response_type', 'code'),
			A2(
				$elm$core$List$cons,
				A2($elm$url$Url$Builder$string, 'scope', 'read_write'),
				A2(
					$elm$core$List$map,
					function (_v1) {
						var key = _v1.a;
						var value = _v1.b;
						return A2($elm$url$Url$Builder$string, 'stripe_user[' + (key + ']'), value);
					},
					stripeUser))));
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[$author$project$Components$Stripe$stripeConnectBaseUrl]),
		queryParams);
};
var $author$project$Components$Stripe$viewCreateStripeAccountFooter = function (model) {
	return model.aJ ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Skip setting up stripe'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$pull(0),
					$author$project$Ui$Button$onClick($author$project$Components$Stripe$SkipStripeSetup)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Skip')
				])),
			($author$project$Api$Provider$Practice$One$paymentProcessor(model.WF) === 'stripe') ? A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Components$Stripe$stripeConnectUrl(model),
			_List_fromArray(
				[$author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Connect to Stripe')
				])) : $author$project$Utils$Html$empty
		]) : (($author$project$Api$Provider$Practice$One$paymentProcessor(model.WF) === 'stripe') ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Components$Stripe$stripeConnectUrl(model),
			_List_fromArray(
				[$author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Connect to Stripe')
				]))
		]) : _List_Nil);
};
var $author$project$Components$Stripe$viewFailedToConnectBody = function (errorDescription) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Status'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, 'failed')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$author$project$Utils$FormErrors$view(
							_List_fromArray(
								[
									A2($elm$core$Maybe$withDefault, '', errorDescription)
								]))
						]))
				]))
		]);
};
var $author$project$Components$Stripe$Reset = {$: 5};
var $author$project$Components$Stripe$viewFailedToConnectFooter = function (model) {
	return _List_fromArray(
		[
			model.aJ ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Skip setting up stripe'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$pull(0),
					$author$project$Ui$Button$onClick($author$project$Components$Stripe$SkipStripeSetup)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Skip')
				])) : $author$project$Utils$Html$empty,
			A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Admin__Stripe,
			_List_fromArray(
				[
					$author$project$Ui$Link$buttonPrimary,
					$author$project$Ui$Link$onClick($author$project$Components$Stripe$Reset)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Start over')
				]))
		]);
};
var $author$project$Components$Stripe$Disconnect = {$: 1};
var $author$project$Components$Stripe$ShowSupportChat = {$: 4};
var $author$project$Components$Stripe$viewHasStripeAccountBody = function (model) {
	return $author$project$Components$Stripe$ConnectedView$view(
		{FR: model.FR, ae5: $author$project$Components$Stripe$Disconnect, afm: $author$project$Components$Stripe$ShowSupportChat, WF: model.WF});
};
var $author$project$Components$Stripe$PracticeOnboardingRedirect = {$: 8};
var $author$project$Components$Stripe$viewHasStripeAccountFooter = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					model.aJ ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Go to next step'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$pull(1),
							$author$project$Ui$Button$onClick($author$project$Components$Stripe$PracticeOnboardingRedirect)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Next')
						])) : $author$project$Utils$Html$empty
				]))
		]);
};
var $author$project$Components$Stripe$view = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				model.fv ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Components$Stripe$HiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								$elm$html$Html$text('WARNING: You\'re about to remove your ability to process credit cards and bank accounts! Please be sure this is what you want to do. If you reconnect the same Stripe account, then all existing cards / bank accounts will remain intact. Otherwise, they will not. Either way, this application will not be able to process any electronic transactions for you while you\'re account is disconnected.')
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						model.aJ ? _List_fromArray(
							[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Setup Stripe Account')
											])),
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('We partner with Stripe for secure payments, and setting up your Stripe account is a necessary step to ensure you can receive payments. This step takes about 10 minutes to complete.')
											])),
										($author$project$Api$Provider$Practice$One$paymentProcessor(model.WF) !== 'stripe') ? A2(
										$author$project$Ui$Alert$warning,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Connecting to Stripe its not possible for practices using Hint Payments.')
											])) : $author$project$Utils$Html$empty,
										A4(
										$author$project$Ui$Image$view,
										model.qT,
										{I1: 'Stripe Logo'},
										_List_fromArray(
											[
												$author$project$Ui$Image$width(200)
											]),
										2)
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v1 = model.ag7;
									switch (_v1.$) {
										case 0:
											return $author$project$Components$Stripe$viewConnectingBody;
										case 1:
											var description = _v1.a;
											return $author$project$Components$Stripe$viewFailedToConnectBody(description);
										case 2:
											return $author$project$Components$Stripe$viewHasStripeAccountBody(model);
										default:
											return $author$project$Components$Stripe$viewCreateStripeAccountBody;
									}
								}()),
								function () {
								var _v2 = model.ag7;
								switch (_v2.$) {
									case 1:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
											$author$project$Components$Stripe$viewFailedToConnectFooter(model));
									case 3:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
											$author$project$Components$Stripe$viewCreateStripeAccountFooter(model));
									case 2:
										return A2(
											$author$project$Ui$Panel$footer,
											_List_fromArray(
												[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
											$author$project$Components$Stripe$viewHasStripeAccountFooter(model));
									default:
										return $author$project$Ui$Panel$none;
								}
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Admin$Stripe$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Stripe$view(model.oB))
			]),
		$G: 'Integrations | Stripe'
	};
};
var $author$project$Pages$Admin$Stripe$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Stripe$init, aer: $author$project$Pages$Admin$Stripe$load, agD: $author$project$Pages$Admin$Stripe$save, ahd: $author$project$Pages$Admin$Stripe$subscriptions, aaq: $author$project$Pages$Admin$Stripe$update, ahP: $author$project$Pages$Admin$Stripe$view});
var $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Taxes$TaxProfilesMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$GotData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$TaxJurisdiction$All$TaxJurisdiction = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxJurisdiction$Shared$TaxJurisdiction = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxJurisdiction$Shared$Record = F3(
	function (id, name, rate) {
		return {adR: id, zh: name, XJ: rate};
	});
var $author$project$Api$Provider$TaxJurisdiction$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rate',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxJurisdiction$Shared$Record))));
var $author$project$Api$Provider$TaxJurisdiction$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxJurisdiction$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxJurisdiction$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxJurisdiction$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['tax_jurisdictions']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$TaxJurisdiction$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$TaxJurisdiction$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions = function (apiClient) {
	return A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxJurisdictions$GotData);
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$init = function (apiClient) {
	var model = {$8: $elm$core$Maybe$Nothing, dS: $elm$core$Set$empty, te: $elm$core$Maybe$Nothing, $s: $author$project$Api$Data$Loading};
	return _Utils_Tuple2(
		model,
		$author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient));
};
var $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxProfiles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$TaxProfile$All$TaxProfile = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxProfile$One$TaxProfile = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$TaxProfile$Shared$TaxProfile = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxProfile$Shared$Record = F3(
	function (id, name, rate) {
		return {adR: id, zh: name, XJ: rate};
	});
var $author$project$Api$Provider$TaxProfile$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rate',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$Shared$Record))));
var $author$project$Api$Provider$TaxProfile$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxProfile$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxProfile$One$Record = function (taxJurisdictions) {
	return {$s: taxJurisdictions};
};
var $author$project$Api$Provider$TaxProfile$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tax_jurisdictions',
	$elm$json$Json$Decode$list($author$project$Api$Provider$TaxJurisdiction$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$One$Record));
var $author$project$Api$Provider$TaxProfile$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxProfile$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$TaxProfile$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$One$TaxProfile)));
var $author$project$Api$Provider$TaxProfile$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxProfile$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxProfile$taxProfilesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['tax_profiles']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$TaxProfile$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$TaxProfile$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$TaxProfile$taxProfilesPath));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles = function (apiClient) {
	return A2($author$project$Api$Provider$TaxProfile$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxProfiles);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$init = function (apiClient) {
	var model = {ig: $elm$core$Maybe$Nothing, dT: $elm$core$Set$empty, $s: $author$project$Api$Data$Loading, $t: $elm$core$Maybe$Nothing, g_: $author$project$Api$Data$Loading};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions),
					$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient)
				])));
};
var $author$project$Pages$Admin$Taxes$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var _v4 = $author$project$Components$Admin$Taxes$TaxProfiles$init(apiClient);
		var taxProfiles = _v4.a;
		var taxProfilesCmd = _v4.b;
		var _v5 = $author$project$Components$Admin$Taxes$TaxJurisdictions$init(apiClient);
		var taxJurisdictions = _v5.a;
		var taxJurisdictionsCmd = _v5.b;
		return _Utils_Tuple2(
			{D5: apiClient, $s: taxJurisdictions, g_: taxProfiles},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, taxProfilesCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg, taxJurisdictionsCmd)
					])));
	});
var $author$project$Pages$Admin$Taxes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Taxes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit = {$: 2};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit)),
					model.te)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed),
					model.$8))
			]));
};
var $author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit = {$: 4};
var $author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.$t;
				if (!_v1.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed),
					model.ig))
			]));
};
var $author$project$Pages$Admin$Taxes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg,
				$author$project$Components$Admin$Taxes$TaxJurisdictions$subscriptions(model.$s)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Admin$Taxes$TaxProfilesMsg,
				$author$project$Components$Admin$Taxes$TaxProfiles$subscriptions(model.g_))
			]));
};
var $author$project$Components$Admin$Taxes$TaxProfiles$taxJurisdictionsUpdated = F2(
	function (apiClient, _v0) {
		var model = _v0;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{$s: $author$project$Api$Data$Loading, g_: $author$project$Api$Data$Loading}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions),
						$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient)
					])));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Deleted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$None = 0;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$TaxJurisdictionsUpdated = 1;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$TaxJurisdiction$One$TaxJurisdiction = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxJurisdiction$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxJurisdiction$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$TaxJurisdiction$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tax_jurisdiction',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'rate',
								$elm$json$Json$Encode$float(fields.XJ))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$TaxJurisdiction$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath)));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$create = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {
			zh: fields.zh,
			XJ: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.XJ))
		};
		return A3($author$project$Api$Provider$TaxJurisdiction$create, apiClient, apiFields, $author$project$Components$Admin$Taxes$TaxJurisdictions$Created);
	});
var $author$project$Api$Provider$TaxJurisdiction$taxJurisdictionPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath);
};
var $author$project$Api$Provider$TaxJurisdiction$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$TaxJurisdiction$taxJurisdictionPath(id_)));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsInit = {zh: '', XJ: $elm$core$Maybe$Nothing};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{zh: string});
		} else {
			var _float = field.a;
			return _Utils_update(
				fields,
				{XJ: _float});
		}
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$NameValidation = 0;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$RateValidation = 1;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.XJ;
			},
			_Utils_Tuple2(1, 'Please enter a rate.'))
		]));
var $author$project$Api$Provider$TaxJurisdiction$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$TaxJurisdiction$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$TaxJurisdiction$Shared$id(shared);
};
var $author$project$Api$Provider$TaxJurisdiction$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$TaxJurisdiction$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$TaxJurisdiction$Shared$name(shared);
};
var $author$project$Api$Provider$TaxJurisdiction$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$TaxJurisdiction$Shared$name(shared);
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{$s: response}),
					as: $author$project$OutMsg$reportDecodeError(response)
				};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							te: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{te: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 3:
				var field = msg.a;
				var _v2 = model.te;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var taxJurisdiction = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								te: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, taxJurisdiction))
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 5:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return {
						EC: A2($author$project$Components$Admin$Taxes$TaxJurisdictions$create, apiClient, validFormFields),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								te: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						as: _List_Nil
					};
				} else {
					var newForm = _v4.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								te: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						as: _List_Nil
					};
				}
			case 4:
				var taxJurisdiction = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							$8: $elm$core$Maybe$Just(taxJurisdiction)
						}),
					as: _List_Nil
				};
			case 6:
				var response = msg.a;
				var _v6 = model.te;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						var taxJurisdiction = response.a;
						return {
							EC: $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient),
							ac5: 1,
							y8: _Utils_update(
								model,
								{te: $elm$core$Maybe$Nothing, $s: $author$project$Api$Data$Loading}),
							as: _List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$TaxJurisdiction$One$name(taxJurisdiction))
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									te: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 7:
				var taxJurisdiction = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return {
							EC: $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient),
							ac5: 1,
							y8: _Utils_update(
								model,
								{
									dS: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction),
										model.dS),
									$s: $author$project$Api$Data$Loading
								}),
							as: _List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction) + ' was successfully removed.')
								])
						};
					case 2:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									dS: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction),
										model.dS)
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			default:
				var taxJurisdiction = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
					return {
						EC: A3(
							$author$project$Api$Provider$TaxJurisdiction$delete,
							apiClient,
							id,
							$author$project$Components$Admin$Taxes$TaxJurisdictions$Deleted(taxJurisdiction)),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								$8: $elm$core$Maybe$Nothing,
								dS: A2($elm$core$Set$insert, id, model.dS)
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{$8: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				}
		}
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$Deleted = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$Provider$TaxProfile$taxProfilePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$TaxProfile$taxProfilesPath);
};
var $author$project$Api$Provider$TaxProfile$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$TaxProfile$taxProfilePath(id_)));
	});
var $author$project$Api$Provider$TaxProfile$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$TaxProfile$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$TaxProfile$Shared$name(shared);
};
var $author$project$Api$Provider$TaxProfile$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$name(one);
};
var $author$project$Api$Provider$TaxProfile$One$taxJurisdictions = function (_v0) {
	var record = _v0.b;
	return record.$s;
};
var $author$project$Api$Provider$TaxProfile$All$taxJurisdictions = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$taxJurisdictions(one);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsFromTaxProfile = function (taxProfile) {
	return {
		zh: $author$project$Api$Provider$TaxProfile$All$name(taxProfile),
		$s: $elm$core$Set$fromList(
			A2(
				$elm$core$List$map,
				$author$project$Api$Provider$TaxJurisdiction$Shared$id,
				$author$project$Api$Provider$TaxProfile$All$taxJurisdictions(taxProfile)))
	};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsInit = {zh: '', $s: $elm$core$Set$empty};
var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{zh: string});
		} else {
			var id = field.a;
			var bool = field.b;
			var taxJurisdictions = bool ? A2($elm$core$Set$insert, id, fields.$s) : A2($elm$core$Set$remove, id, fields.$s);
			return _Utils_update(
				fields,
				{$s: taxJurisdictions});
		}
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$NameValidation = 0;
var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Provider$TaxProfile$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$TaxProfile$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$TaxProfile$Shared$id(shared);
};
var $author$project$Api$Provider$TaxProfile$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$id(one);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Created = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Set$foldl = F3(
	function (func, initialState, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (key, _v1, state) {
					return A2(func, key, state);
				}),
			initialState,
			dict);
	});
var $elm$json$Json$Encode$set = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$Set$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Api$Provider$TaxProfile$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tax_profile',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'tax_jurisdictions',
								A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, fields.$s))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$TaxProfile$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TaxProfile$taxProfilesPath)));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$create = F2(
	function (apiClient, formFields) {
		return A3(
			$author$project$Api$Provider$TaxProfile$create,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Components$Admin$Taxes$TaxProfiles$Created);
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$Updated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$TaxProfile$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'tax_profile',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'tax_jurisdictions',
								A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, fields.$s))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$TaxProfile$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$TaxProfile$taxProfilePath(id_))));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$updateTaxProfile = F3(
	function (apiClient, id, formFields) {
		return A4(
			$author$project$Api$Provider$TaxProfile$update,
			apiClient,
			id,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Components$Admin$Taxes$TaxProfiles$Updated);
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$save = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Admin$Taxes$TaxProfiles$updateTaxProfile, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Admin$Taxes$TaxProfiles$create, apiClient, formFields);
		}
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{$s: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g_: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							$t: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Admin$Taxes$TaxProfiles$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var taxProfile = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							$t: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$TaxProfile$All$id(taxProfile)),
									$author$project$Utils$Form$init(
										$author$project$Components$Admin$Taxes$TaxProfiles$formFieldsFromTaxProfile(taxProfile)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{$t: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var field = msg.a;
				var _v2 = model.$t;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var taxProfile = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$t: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, taxProfile))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$t: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Components$Admin$Taxes$TaxProfiles$save, apiClient, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$t: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 6:
				var taxProfile = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ig: $elm$core$Maybe$Just(taxProfile)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var response = msg.a;
				var _v6 = model.$t;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					if (response.$ === 3) {
						var taxProfile = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{$t: $elm$core$Maybe$Nothing, g_: $author$project$Api$Data$Loading}),
							$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$TaxProfile$One$name(taxProfile))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									$t: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v9 = model.$t;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var taxProfile = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{$t: $elm$core$Maybe$Nothing, g_: $author$project$Api$Data$Loading}),
							$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$TaxProfile$One$name(taxProfile) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									$t: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var taxProfile = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dT: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$TaxProfile$All$id(taxProfile),
										model.dT),
									g_: $author$project$Api$Data$Loading
								}),
							$author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$TaxProfile$All$name(taxProfile) + ' was successfully removed.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dT: A2(
										$elm$core$Set$remove,
										$author$project$Api$Provider$TaxProfile$All$id(taxProfile),
										model.dT)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var taxProfile = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$TaxProfile$All$id(taxProfile);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ig: $elm$core$Maybe$Nothing,
								dT: A2($elm$core$Set$insert, id, model.dT)
							}),
						A3(
							$author$project$Api$Provider$TaxProfile$delete,
							apiClient,
							id,
							$author$project$Components$Admin$Taxes$TaxProfiles$Deleted(taxProfile)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ig: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Taxes$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A3($author$project$Components$Admin$Taxes$TaxProfiles$update, model.D5, subMsg, model.g_);
			var taxProfiles = _v1.a;
			var subCmd = _v1.b;
			var subOutMsg = _v1.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{g_: taxProfiles}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, subCmd),
				subOutMsg);
		} else {
			var subMsg = msg.a;
			var result = A3($author$project$Components$Admin$Taxes$TaxJurisdictions$update, model.D5, subMsg, model.$s);
			var _v2 = function () {
				var _v3 = result.ac5;
				if (!_v3) {
					return _Utils_Tuple2(model.g_, $elm$core$Platform$Cmd$none);
				} else {
					return A2($author$project$Components$Admin$Taxes$TaxProfiles$taxJurisdictionsUpdated, model.D5, model.g_);
				}
			}();
			var taxProfiles = _v2.a;
			var taxProfilesCmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{$s: result.y8, g_: taxProfiles}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, taxProfilesCmd),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg, result.EC)
						])),
				result.as);
		}
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$New = {$: 1};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$help = _List_fromArray(
	[
		$elm$html$Html$text('Tax jurisdictions represent each individual area that levies a sales tax. '),
		$elm$html$Html$text('These include states, counties, cities, and municipalities. For more information, please refer to our '),
		A3(
		$author$project$Ui$Link$externalHref,
		'https://support.hint.com/account-configuration/creating-sales-tax-profiles-and-jurisdictions',
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				$elm$html$Html$text('help docs')
			])),
		$elm$html$Html$text('.')
	]);
var $author$project$Ui$Element$Small = 1;
var $author$project$Ui$Element$textSm = $author$project$Ui$Element$Text(1);
var $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Rate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Save = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Ui$Form$PercentageInput$Errors = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$PercentageInput$errors = $author$project$Ui$Form$PercentageInput$Errors;
var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewModal = F3(
	function (id, form, taxJurisdiction) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Sales Tax Jurisdiction',
			S_: _Utils_eq(taxJurisdiction, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit,
			U0: $author$project$Components$Admin$Taxes$TaxJurisdictions$Save(form)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var name = _v0.zh;
		var rate = _v0.XJ;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('City of San Francisco, CA'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated, $author$project$Components$Admin$Taxes$TaxJurisdictions$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Rate'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$PercentageInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$PercentageInput$value(rate),
									$author$project$Ui$Form$PercentageInput$placeholder('1.25'),
									$author$project$Ui$Form$PercentageInput$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated, $author$project$Components$Admin$Taxes$TaxJurisdictions$Rate)),
									$author$project$Ui$Form$PercentageInput$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$PercentageInput$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$Delete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$TaxJurisdiction$Shared$rate = function (_v0) {
	var record = _v0;
	return record.XJ;
};
var $author$project$Api$Provider$TaxJurisdiction$All$rate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$TaxJurisdiction$Shared$rate(shared);
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewTaxJurisdiction = F2(
	function (deletingTaxJurisdictions, taxJurisdiction) {
		var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
		var loading = A2($elm$core$Set$member, id, deletingTaxJurisdictions);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(
								$author$project$Api$Provider$TaxJurisdiction$All$rate(taxJurisdiction)) + '%')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Delete tax jurisdiction'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$size(0),
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									$author$project$Components$Admin$Taxes$TaxJurisdictions$Delete(taxJurisdiction)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.$s;
		if (_v1.$ === 3) {
			var taxJurisdictions_ = _v1.a;
			return _Utils_Tuple2(false, taxJurisdictions_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var taxJurisdictions = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('None')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Rate')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Admin$Taxes$TaxJurisdictions$viewTaxJurisdiction(model.dS),
				taxJurisdictions),
			_List_Nil)
		]);
};
var $author$project$Components$Admin$Taxes$TaxJurisdictions$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.te;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var id = _v2.a;
				var form = _v2.b;
				var taxJurisdiction = _v2.c;
				return A3($author$project$Components$Admin$Taxes$TaxJurisdictions$viewModal, id, form, taxJurisdiction);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.$8;
			if (!_v3.$) {
				var taxJurisdiction = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed(taxJurisdiction),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('jurisdiction'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction) + 'and remove it from existing profiles. This will effect draft invoices using those tax profiles.')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Sales Tax Jurisdictions')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
									$author$project$Components$Admin$Taxes$TaxJurisdictions$help)
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'New tax jurisdiction'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxJurisdictions$New),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New Tax Jurisdiction')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					$author$project$Components$Admin$Taxes$TaxJurisdictions$viewPanelBody(model))
				]))
		]);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$New = {$: 2};
var $author$project$Components$Admin$Taxes$TaxProfiles$help = _List_fromArray(
	[
		$elm$html$Html$text('Tax profiles represent a collection of tax jurisdictions. In order to collect tax, you will assign '),
		$elm$html$Html$text('a profile to an invoice.  The profile determines the total sales tax rate that will be applied. '),
		$elm$html$Html$text('For more information, please refer to our '),
		A3(
		$author$project$Ui$Link$externalHref,
		'https://support.hint.com/account-configuration/creating-sales-tax-profiles-and-jurisdictions',
		_List_fromArray(
			[$author$project$Ui$Link$targetBlank]),
		_List_fromArray(
			[
				$elm$html$Html$text('help docs')
			])),
		$elm$html$Html$text('.')
	]);
var $author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Save = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$TaxJurisdictions = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdictionToggleSwitch = F2(
	function (taxJurisdictions, taxJurisdiction) {
		var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
		var taxJurisdictionEnabled = A2($elm$core$Set$member, id, taxJurisdictions);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(taxJurisdictionEnabled),
							$author$project$Ui$ToggleSwitch$onChange(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated,
								$author$project$Components$Admin$Taxes$TaxProfiles$TaxJurisdictions(id)))
						])),
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text(
					$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction)),
					$elm$html$Html$text(' - '),
					$elm$html$Html$text(
					$elm$core$String$fromFloat(
						$author$project$Api$Provider$TaxJurisdiction$All$rate(taxJurisdiction)) + '%')
				]));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$viewModal = F4(
	function (taxJurisdictions, id, form, taxProfile) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Tax Profile',
			S_: _Utils_eq(taxProfile, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit,
			U0: $author$project$Components$Admin$Taxes$TaxProfiles$Save(form)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Name')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.zh),
									$author$project$Ui$Form$Input$placeholder('San Francisco'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated, $author$project$Components$Admin$Taxes$TaxProfiles$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Jurisdictions')
						]),
					function () {
						if (taxJurisdictions.$ === 3) {
							var taxJurisdictions_ = taxJurisdictions.a;
							return $elm$core$List$isEmpty(taxJurisdictions_) ? _List_fromArray(
								[
									$elm$html$Html$text('You have not created any tax jurisdictions. Please add the appropriate jurisdictions then select them here.')
								]) : A2(
								$elm$core$List$map,
								$author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdictionToggleSwitch(fields.$s),
								taxJurisdictions_);
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$small]))
										]))
								]);
						}
					}())
				]));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$Delete = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$Taxes$TaxProfiles$Edit = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$TaxProfile$Shared$rate = function (_v0) {
	var record = _v0;
	return record.XJ;
};
var $author$project$Api$Provider$TaxProfile$One$rate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$TaxProfile$Shared$rate(shared);
};
var $author$project$Api$Provider$TaxProfile$All$rate = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$rate(one);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdiction = function (taxJurisdiction) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[$author$project$Ui$Typography$small]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$TaxJurisdiction$Shared$name(taxJurisdiction)),
				$elm$html$Html$text(' - '),
				$elm$html$Html$text(
				$elm$core$String$fromFloat(
					$author$project$Api$Provider$TaxJurisdiction$Shared$rate(taxJurisdiction)) + '%')
			]));
};
var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxProfile = F2(
	function (deletingTaxProfiles, taxProfile) {
		var id = $author$project$Api$Provider$TaxProfile$All$id(taxProfile);
		var loading = A2($elm$core$Set$member, id, deletingTaxProfiles);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$TaxProfile$All$name(taxProfile))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromFloat(
								$author$project$Api$Provider$TaxProfile$All$rate(taxProfile)) + '%')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdiction,
						$author$project$Api$Provider$TaxProfile$All$taxJurisdictions(taxProfile))),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit tax profile'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$Taxes$TaxProfiles$Edit(taxProfile)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit tax profile'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$size(0),
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Admin$Taxes$TaxProfiles$Delete(taxProfile)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Admin$Taxes$TaxProfiles$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.g_;
		if (_v1.$ === 3) {
			var taxProfiles_ = _v1.a;
			return _Utils_Tuple2(false, taxProfiles_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var taxProfiles = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('None'),
							A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$elm$core$List$isEmpty,
								$author$project$Api$Data$toMaybe(model.$s))) ? $elm$html$Html$text(', please add a tax jursidiction below first.') : $author$project$Utils$Html$empty
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Name')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Rate')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Jurisdictions')
						])),
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Admin$Taxes$TaxProfiles$viewTaxProfile(model.dT),
				taxProfiles),
			_List_Nil)
		]);
};
var $author$project$Components$Admin$Taxes$TaxProfiles$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			function () {
			var _v1 = model.$t;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var id = _v2.a;
				var form = _v2.b;
				var taxProfile = _v2.c;
				return A4($author$project$Components$Admin$Taxes$TaxProfiles$viewModal, model.$s, id, form, taxProfile);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.ig;
			if (!_v3.$) {
				var taxProfile = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed(taxProfile),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('profile'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Provider$TaxProfile$All$name(taxProfile) + ' and make it unavailable as an option. This will not effect issued invoices.')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Sales Tax Profiles')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
									$author$project$Components$Admin$Taxes$TaxProfiles$help)
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'New tax profile'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxProfiles$New),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New Tax Profile')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					$author$project$Components$Admin$Taxes$TaxProfiles$viewPanelBody(model))
				]))
		]);
};
var $author$project$Pages$Admin$Taxes$view = function (model) {
	return {
		e5: _Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Admin$Taxes$TaxProfilesMsg),
				$author$project$Components$Admin$Taxes$TaxProfiles$view(model.g_)),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg),
				$author$project$Components$Admin$Taxes$TaxJurisdictions$view(model.$s))),
		$G: 'Admin | Sales Tax'
	};
};
var $author$project$Pages$Admin$Taxes$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Taxes$init, aer: $author$project$Pages$Admin$Taxes$load, agD: $author$project$Pages$Admin$Taxes$save, ahd: $author$project$Pages$Admin$Taxes$subscriptions, aaq: $author$project$Pages$Admin$Taxes$update, ahP: $author$project$Pages$Admin$Taxes$view});
var $author$project$Pages$Admin$Team$GotLocationGroups = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Team$GotRoles = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$Practice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Team$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Team)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Pages$Admin$Team$GotTeamMembers = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Team$fetchTeamMembers = function (model) {
	return A3(
		$author$project$Api$Provider$TeamMember$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, af_: model.af_, ag1: model.ag1});
		},
		$author$project$Pages$Admin$Team$GotTeamMembers);
};
var $author$project$Api$Provider$Practice$One$hasOwner = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.Vp;
		},
		$author$project$Utils$Maybe$toBool));
var $author$project$Components$Admin$ToogleOrganizationMfa$Model = $elm$core$Basics$identity;
var $author$project$Components$Admin$ToogleOrganizationMfa$init = F2(
	function (session, organization) {
		return {
			EQ: $author$project$Api$Platform$Session$One$user(session),
			Vd: organization,
			ZD: session,
			tq: $author$project$Api$Data$NotAsked,
			o1: $author$project$Api$Data$NotAsked
		};
	});
var $author$project$Api$Common$Role$All$Role = $elm$core$Basics$identity;
var $author$project$Api$Common$Role$Shared$Role = $elm$core$Basics$identity;
var $author$project$Api$Common$Role$Shared$Record = F2(
	function (name, permissionSets) {
		return {zh: name, Wf: permissionSets};
	});
var $author$project$Api$Common$Role$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'permission_sets',
	$elm$json$Json$Decode$list($author$project$Api$Common$PermissionSet$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Role$Shared$Record)));
var $author$project$Api$Common$Role$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Role$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Role$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Role$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Role$rolesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['roles']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Role$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Role$rolesPath));
	});
var $author$project$Pages$Admin$Team$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			tM: !$author$project$Api$Provider$Practice$One$hasOwner(practice),
			D5: shared.D5,
			EQ: $author$project$Api$Platform$Session$One$user(session),
			lQ: $elm$core$Maybe$Nothing,
			dU: $elm$core$Set$empty,
			$9: $elm$core$Maybe$Nothing,
			adM: shared.adM,
			FR: $author$project$Shared$isHintAdmin(shared),
			S$: $author$project$Api$Data$Loading,
			ea: $elm$core$Set$empty,
			afw: shared.adu.afw,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			af_: q,
			BX: $author$project$Api$Data$Loading,
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'user_first_name',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			A: $elm$core$Maybe$Nothing,
			eK: $author$project$Api$Data$Loading,
			tl: A2(
				$author$project$Components$Admin$ToogleOrganizationMfa$init,
				session,
				$author$project$Components$Admin$ToogleOrganizationMfa$Practice(practice))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Admin$Team$fetchTeamMembers(model),
						A2($author$project$Api$Provider$Role$list, shared.D5, $author$project$Pages$Admin$Team$GotRoles),
						A3($author$project$Api$Provider$LocationGroup$list, shared.D5, $elm$core$Basics$identity, $author$project$Pages$Admin$Team$GotLocationGroups),
						A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Admin$Team$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Team$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Team$CancelTeamMemberEdit = {$: 4};
var $author$project$Pages$Admin$Team$DeleteConfirmClosed = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$DisableMfaConfirmClosed = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$subscriptions = function (_v0) {
	var teamMember = _v0.A;
	var deletingTeamMember = _v0.lQ;
	var disablingMfaTeamMember = _v0.$9;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Team$CancelTeamMemberEdit)),
					teamMember)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Team$DeleteConfirmClosed),
						$author$project$Api$Provider$PracticeUser$All$id),
					deletingTeamMember)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Team$DisableMfaConfirmClosed),
					disablingMfaTeamMember))
			]));
};
var $author$project$Pages$Admin$Team$GotInvitation = F3(
	function (a, b, c) {
		return {$: 22, a: a, b: b, c: c};
	});
var $author$project$Pages$Admin$Team$InviteLinkMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Admin$Team$MfaStatus = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Admin$Team$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Admin$Team$TeamMemberAdminCompleted = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$TeamMemberDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$TeamMemberMfaDisabled = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Admin$Team$ToogleOrganizationMfa = function (a) {
	return {$: 23, a: a};
};
var $author$project$Api$Provider$TeamMember$teamMemberPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$TeamMember$teamMembersPath);
};
var $author$project$Api$Provider$TeamMember$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$TeamMember$teamMemberPath(id_)));
	});
var $author$project$Api$Provider$TeamMember$disableMfa = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['mfa']),
					$author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Api$Provider$LocationGroup$Min$id = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$LocationGroup$Min$id(common);
};
var $author$project$Api$Provider$PracticeUser$All$locationGroups = function (_v0) {
	var record = _v0.b;
	return record.S$;
};
var $author$project$Api$Provider$User$One$mfaStatus = function (_v0) {
	var record = _v0.b;
	return record.TW;
};
var $author$project$Pages$Admin$Team$mfaStatus = function (teamMember) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$PracticeUser$All$user, teamMember);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$Api$Provider$User$One$mfaStatus(user);
	} else {
		return 'invite pending';
	}
};
var $author$project$Api$Provider$PracticeUser$Shared$notificationsEnabled = function (_v0) {
	var record = _v0;
	return record.UO;
};
var $author$project$Api$Provider$PracticeUser$All$notificationsEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$notificationsEnabled(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$reportRestricted = function (_v0) {
	var record = _v0;
	return record.Yd;
};
var $author$project$Api$Provider$PracticeUser$All$reportRestricted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$reportRestricted(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$restrictedByGroups = function (_v0) {
	var record = _v0;
	return record.Yy;
};
var $author$project$Api$Provider$PracticeUser$All$restrictedByGroups = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$restrictedByGroups(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$role = function (_v0) {
	var record = _v0;
	return record.agy;
};
var $author$project$Api$Provider$PracticeUser$All$role = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$role(shared);
};
var $author$project$Pages$Admin$Team$formFieldsFromTeamMember = function (teamMember) {
	var locationGroups = $elm$core$Set$fromList(
		A2(
			$elm$core$List$map,
			$author$project$Api$Provider$LocationGroup$Min$id,
			$author$project$Api$Provider$PracticeUser$All$locationGroups(teamMember)));
	return {
		abx: '',
		Oo: $author$project$Api$Provider$PracticeUser$All$email(teamMember),
		ad9: false,
		S$: locationGroups,
		TW: $author$project$Pages$Admin$Team$mfaStatus(
			$elm$core$Maybe$Just(teamMember)),
		UO: $author$project$Api$Provider$PracticeUser$All$notificationsEnabled(teamMember),
		Yd: $author$project$Api$Provider$PracticeUser$All$reportRestricted(teamMember),
		Yy: $author$project$Api$Provider$PracticeUser$All$restrictedByGroups(teamMember),
		agy: $author$project$Api$Provider$PracticeUser$All$role(teamMember)
	};
};
var $author$project$Pages$Admin$Team$formFieldsInit = function (origin) {
	return {
		abx: origin + '/join/',
		Oo: '',
		ad9: true,
		S$: $elm$core$Set$empty,
		TW: $author$project$Pages$Admin$Team$mfaStatus($elm$core$Maybe$Nothing),
		UO: true,
		Yd: false,
		Yy: false,
		agy: ''
	};
};
var $author$project$Pages$Admin$Team$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Oo: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{Yy: fields.Yy && (string !== 'admin'), agy: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{UO: bool});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Yy: bool});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{TW: string});
			case 6:
				var id = field.a;
				var bool = field.b;
				var locationGroups = bool ? A2($elm$core$Set$insert, id, fields.S$) : A2($elm$core$Set$remove, id, fields.S$);
				return _Utils_update(
					fields,
					{S$: locationGroups});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ad9: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Yd: bool});
		}
	});
var $author$project$Pages$Admin$Team$EmailValidation = 0;
var $author$project$Pages$Admin$Team$RoleValidation = 1;
var $author$project$Pages$Admin$Team$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Oo;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.agy;
			},
			_Utils_Tuple2(1, 'Please pick a role.'))
		]));
var $author$project$Api$Provider$PracticeUser$One$PracticeUser = 0;
var $author$project$Api$Provider$PracticeUser$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$TeamMember$invite = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['invite']),
					$author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Api$Provider$TeamMember$makeSuperAdmin = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_super_admin']),
					$author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Pages$Admin$Team$TeamMemberCreated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$TeamMember$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base_url',
								$elm$json$Json$Encode$string(fields.abx)),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(fields.Oo)),
								_Utils_Tuple2(
								'role',
								$elm$json$Json$Encode$string(fields.agy)),
								_Utils_Tuple2(
								'notifications_enabled',
								$elm$json$Json$Encode$bool(fields.UO)),
								_Utils_Tuple2(
								'restricted_by_groups',
								$elm$json$Json$Encode$bool(fields.Yy)),
								_Utils_Tuple2(
								'location_groups',
								A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, fields.S$)),
								_Utils_Tuple2(
								'report_restricted',
								$elm$json$Json$Encode$bool(fields.Yd))
							]))),
					_Utils_Tuple2(
					'invite',
					$elm$json$Json$Encode$bool(fields.ad9))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
	});
var $author$project$Pages$Admin$Team$createTeamMember = F3(
	function (apiClient, _v0, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$TeamMember$create,
			apiClient,
			{abx: fields.abx, Oo: fields.Oo, ad9: fields.ad9, S$: fields.S$, UO: fields.UO, Yd: fields.Yd, Yy: fields.Yy, agy: fields.agy},
			$author$project$Pages$Admin$Team$TeamMemberCreated);
	});
var $author$project$Pages$Admin$Team$TeamMemberUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$TeamMember$encodeLicense = function (license) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'license_number',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '', license.Gj))),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '', license.sZ))),
				_Utils_Tuple2(
				'expiration',
				$elm$json$Json$Encode$string(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Utils$Date$toIsoString, license.adc.a))))
			]));
};
var $author$project$Components$TeamForm$providerStatusToString = function (status) {
	switch (status) {
		case 0:
			return 'full_time';
		case 1:
			return 'part_time';
		default:
			return 'no_provider';
	}
};
var $author$project$Api$Provider$TeamMember$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var providerStatusValue = A2($elm$core$Maybe$map, $author$project$Components$TeamForm$providerStatusToString, fields.Xm);
		var encodeMaskedDate = function (stringDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				$elm$core$Result$toMaybe(
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Date$encode,
						$author$project$Utils$Date$fromUsString(
							A2(
								$agustinrhcp$elm_mask$Mask$mask,
								$agustinrhcp$elm_mask$Mask$fromString('##/##/####'),
								stringDate)))));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									A3($author$project$Utils$Encode$optional, 'role', $elm$json$Json$Encode$string, fields.agy),
									A3($author$project$Utils$Encode$optional, 'notifications_enabled', $elm$json$Json$Encode$bool, fields.UO),
									A3($author$project$Utils$Encode$optional, 'restricted_by_groups', $elm$json$Json$Encode$bool, fields.Yy),
									A3(
									$author$project$Utils$Encode$optional,
									'location_groups',
									$elm$json$Json$Encode$set($author$project$Utils$Encode$association),
									fields.S$),
									A3($author$project$Utils$Encode$optional, 'report_restricted', $elm$json$Json$Encode$bool, fields.Yd),
									A3($author$project$Utils$Encode$optional, 'phone_number', $elm$json$Json$Encode$string, fields.Wh),
									A3($author$project$Utils$Encode$optional, 'npi', $elm$json$Json$Encode$string, fields.UP),
									A3($author$project$Utils$Encode$optional, 'prescriber_type', $elm$json$Json$Encode$string, fields.W_),
									A3($author$project$Utils$Encode$optional, 'dob', encodeMaskedDate, fields.MR),
									A3($author$project$Utils$Encode$optional, 'education_degree', $elm$json$Json$Encode$string, fields.No),
									A3(
									$author$project$Utils$Encode$optional,
									'dea_licenses',
									$elm$json$Json$Encode$list($author$project$Api$Provider$TeamMember$encodeLicense),
									$elm$core$List$isEmpty(fields.w3) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.w3)),
									A3($author$project$Utils$Encode$optional, 'provider_status', $elm$json$Json$Encode$string, providerStatusValue),
									A3(
									$author$project$Utils$Encode$optional,
									'state_licenses',
									$elm$json$Json$Encode$list($author$project$Api$Provider$TeamMember$encodeLicense),
									$elm$core$List$isEmpty(fields.Cr) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.Cr))
								]))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Pages$Admin$Team$updateTeamMember = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$TeamMember$update,
			apiClient,
			id,
			{
				MR: $elm$core$Maybe$Nothing,
				w3: _List_Nil,
				No: $elm$core$Maybe$Nothing,
				S$: $elm$core$Maybe$Just(fields.S$),
				UO: $elm$core$Maybe$Just(fields.UO),
				UP: $elm$core$Maybe$Nothing,
				Wh: $elm$core$Maybe$Nothing,
				W_: $elm$core$Maybe$Nothing,
				Xm: $elm$core$Maybe$Nothing,
				Yd: $elm$core$Maybe$Just(fields.Yd),
				Yy: $elm$core$Maybe$Just(fields.Yy),
				agy: $elm$core$Maybe$Just(fields.agy),
				Cr: _List_Nil
			},
			$author$project$Pages$Admin$Team$TeamMemberUpdated);
	});
var $author$project$Pages$Admin$Team$saveTeamMember = F4(
	function (apiClient, adminOnly, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A3($author$project$Pages$Admin$Team$updateTeamMember, apiClient, id, formFields);
		} else {
			return A3($author$project$Pages$Admin$Team$createTeamMember, apiClient, adminOnly, formFields);
		}
	});
var $author$project$Components$Admin$ToogleOrganizationMfa$GotPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$GotPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$None = {$: 0};
var $author$project$Components$Admin$ToogleOrganizationMfa$Partner = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$PartnerUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$OutMsg$PartnerUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$ToogleOrganizationMfa$PracticeUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$One$Partner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$Partner$Shared$Partner = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$Shared$Record = function (id) {
	return function (name) {
		return function (organizationId) {
			return function (requiresMfa) {
				return function (slug) {
					return function (marketingUrl) {
						return function (signupUrl) {
							return function (supportUrl) {
								return function (redirectUrl) {
									return function (productDescription) {
										return function (integrationDescription) {
											return function (authType) {
												return function (logoUrl) {
													return function (marketplaceIconUrl) {
														return function (email) {
															return function (technicalEmail) {
																return function (usesIntegrationRecords) {
																	return function (active) {
																		return function (archived) {
																			return function (webhooksDisabled) {
																				return function (webhooksPaused) {
																					return function (maxRequestsPperMinute) {
																						return function (practicesReadOnly) {
																							return function (listenedEvents) {
																								return function (unmuteSelfWebhooks) {
																									return function (postActivationRedirectUrl) {
																										return function (sandboxEnabled) {
																											return function (productType) {
																												return function (websiteUrl) {
																													return {Ic: active, Jn: archived, Jy: authType, Oo: email, adR: id, Q5: integrationDescription, SY: listenedEvents, S8: logoUrl, Tl: marketingUrl, Tm: marketplaceIconUrl, Ts: maxRequestsPperMinute, zh: name, aft: organizationId, WA: postActivationRedirectUrl, WN: practicesReadOnly, Xb: productDescription, GT: productType, X0: redirectUrl, Yn: requiresMfa, Y0: sandboxEnabled, Z6: signupUrl, _c: slug, $a: supportUrl, $w: technicalEmail, aak: unmuteSelfWebhooks, aaG: usesIntegrationRecords, aaX: webhooksDisabled, aaY: webhooksPaused, aa_: websiteUrl};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Partner$Partner$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'website_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'product_type',
		$author$project$Api$Common$Marketplace$Product$ProductType$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sandbox_enabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'post_activation_redirect_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'unmute_self_webhooks',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'listened_events',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'practices_read_only',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'max_requests_per_minute',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'webhooks_paused',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'webhooks_disabled',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'archived',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'active',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'uses_integration_records',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'technical_email',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'email',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'marketplace_icon_url',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'logo_url',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'auth_type',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'integration_description',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'product_description',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'redirect_url',
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'support_url',
																						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'signup_url',
																							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'marketing_url',
																								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'slug',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'requires_mfa',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'organization_id',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'name',
																												$elm$json$Json$Decode$string,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'id',
																													$elm$json$Json$Decode$string,
																													$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$Shared$Record))))))))))))))))))))))))))))));
var $author$project$Api$Partner$Partner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Partner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Partner$One$Record = function (webhooksSignatureApiKey) {
	return function (sandboxOf) {
		return function (hasSandboxPartners) {
			return function (hasSandboxPractices) {
				return function (product) {
					return function (productOverview) {
						return function (productHighlights) {
							return function (productQuotes) {
								return function (productLinks) {
									return function (productDataFlows) {
										return function (managedBy) {
											return function (productCategories) {
												return function (customPartnerAgreementFileName) {
													return function (addendumAgreementFileName) {
														return function (customApiAccessAgreementFileName) {
															return function (customBaaAgreementFileName) {
																return function (partnerDocumentAgreement) {
																	return function (addendumDocumentAgreement) {
																		return function (apiAccessDocumentAgreement) {
																			return function (address) {
																				return function (baaType) {
																					return function (baaDocumentAgreement) {
																						return {Im: addendumAgreementFileName, In: addendumDocumentAgreement, It: address, Jh: apiAccessDocumentAgreement, JN: baaDocumentAgreement, JO: baaType, Mz: customApiAccessAgreementFileName, MA: customBaaAgreementFileName, MG: customPartnerAgreementFileName, Qf: hasSandboxPartners, Qg: hasSandboxPractices, Td: managedBy, VC: partnerDocumentAgreement, W8: product, W9: productCategories, Xa: productDataFlows, Xc: productHighlights, Xd: productLinks, Xe: productOverview, Xf: productQuotes, Y1: sandboxOf, aaZ: webhooksSignatureApiKey};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Partner$ApiKey$Shared$ApiKey = $elm$core$Basics$identity;
var $author$project$Api$Partner$ApiKey$Shared$Record = F6(
	function (id, token, createdAt, lastUsedAt, deactivatedAt, label) {
		return {Mf: createdAt, M0: deactivatedAt, adR: id, aej: label, SF: lastUsedAt, $Q: token};
	});
var $author$project$Api$Partner$ApiKey$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'label',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deactivated_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_used_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'token',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$Shared$Record)))))));
var $author$project$Api$Partner$ApiKey$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$ApiKey$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$BaaType$Contractor = 0;
var $author$project$Api$Partner$BaaType$Independent = 1;
var $author$project$Api$Partner$BaaType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'contractor':
				return $elm$json$Json$Decode$succeed(0);
			case 'independent':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unsupported BAA type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$DocumentAgreement$Shared$DocumentAgreement = $elm$core$Basics$identity;
var $author$project$Api$Partner$DocumentAgreement$Shared$Record = F2(
	function (signedAt, user) {
		return {Z$: signedAt, aaz: user};
	});
var $author$project$Api$Partner$User$Shared$User = $elm$core$Basics$identity;
var $author$project$Api$Partner$User$Shared$Record = F2(
	function (name, isAdmin) {
		return {Ru: isAdmin, zh: name};
	});
var $author$project$Api$Partner$User$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_admin',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$User$Shared$Record)));
var $author$project$Api$Partner$User$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$User$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$DocumentAgreement$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'signed_by',
	$author$project$Api$Partner$User$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'signed_at',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$DocumentAgreement$Shared$Record)));
var $author$project$Api$Partner$DocumentAgreement$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$DocumentAgreement$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProduct$Shared$PartnerProduct = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProduct$Shared$Record = function (id) {
	return function (slug) {
		return function (distributionType) {
			return function (status) {
				return function (featured) {
					return function (name) {
						return function (summary) {
							return function (builtByName) {
								return function (builtByUrl) {
									return function (type_) {
										return {Kd: builtByName, Ke: builtByUrl, NS: distributionType, Pc: featured, adR: id, zh: name, _c: slug, ag7: status, _9: summary, ahI: type_};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Partner$PartnerProduct$Shared$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$author$project$Api$Common$Marketplace$Product$ProductType$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'built_by_url',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'built_by_name',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'summary',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'featured',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								$author$project$Api$Common$Marketplace$Product$Status$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'distribution_type',
									$author$project$Api$Common$Marketplace$Product$DistributionType$decoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'slug',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$Shared$Record))))))))))));
var $author$project$Api$Partner$PartnerProductCategory$Shared$PartnerProductCategory = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductCategory$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Partner$PartnerProductCategory$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductCategory$Shared$Record)));
var $author$project$Api$Partner$PartnerProductCategory$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductCategory$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductCategory$One$decoder = $author$project$Api$Partner$PartnerProductCategory$Shared$decoder;
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$PartnerProductDataFlow = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$Record = F4(
	function (id, hintName, partnerName, syncDirection) {
		return {Qx: hintName, adR: id, VE: partnerName, $h: syncDirection};
	});
var $author$project$Api$Common$Marketplace$Product$SyncDirection$Bidirectional = 2;
var $author$project$Api$Common$Marketplace$Product$SyncDirection$FromHint = 0;
var $author$project$Api$Common$Marketplace$Product$SyncDirection$ToHint = 1;
var $author$project$Api$Common$Marketplace$Product$SyncDirection$fromString = function (string) {
	switch (string) {
		case 'from_hint':
			return $elm$core$Maybe$Just(0);
		case 'to_hint':
			return $elm$core$Maybe$Just(1);
		case 'bidirectional':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$SyncDirection$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Common$Marketplace$Product$SyncDirection$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Unsupported sync direction')))),
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sync_direction',
	$author$project$Api$Common$Marketplace$Product$SyncDirection$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'partner_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hint_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductDataFlow$Shared$Record)))));
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductDataFlow$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductHighlight$Shared$PartnerProductHighlight = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductHighlight$Shared$Record = F4(
	function (id, title, description, imageUrl) {
		return {Nx: description, adR: id, QN: imageUrl, $G: title};
	});
var $author$project$Api$Partner$PartnerProductHighlight$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductHighlight$Shared$Record)))));
var $author$project$Api$Partner$PartnerProductHighlight$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductHighlight$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductLink$Shared$PartnerProductLink = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductLink$Shared$Record = F7(
	function (id, title, linkType, value, utmCampaign, utmContent, composedUrl) {
		return {LG: composedUrl, adR: id, SV: linkType, $G: title, aaJ: utmCampaign, aaK: utmContent, aaN: value};
	});
var $author$project$Api$Common$Marketplace$Product$LinkType$Email = 1;
var $author$project$Api$Common$Marketplace$Product$LinkType$Phone = 2;
var $author$project$Api$Common$Marketplace$Product$LinkType$Url = 0;
var $author$project$Api$Common$Marketplace$Product$LinkType$fromString = function (string) {
	switch (string) {
		case 'url':
			return $elm$core$Maybe$Just(0);
		case 'email':
			return $elm$core$Maybe$Just(1);
		case 'phone':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$LinkType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Common$Marketplace$Product$LinkType$fromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Unsupported link type')))),
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$PartnerProductLink$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'composed_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'utm_content',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'utm_campaign',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'value',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'link_type',
					$author$project$Api$Common$Marketplace$Product$LinkType$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'title',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductLink$Shared$Record))))))));
var $author$project$Api$Partner$PartnerProductLink$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductLink$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductOverview$Shared$ProductOverview = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductOverview$Shared$Record = F2(
	function (description, images) {
		return {Nx: description, QO: images};
	});
var $author$project$Api$Partner$ProductImage$Shared$ProductImage = $elm$core$Basics$identity;
var $author$project$Api$Partner$ProductImage$Shared$Record = F3(
	function (id, alt, url) {
		return {I1: alt, adR: id, aav: url};
	});
var $author$project$Api$Partner$ProductImage$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'file_url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'alt',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$ProductImage$Shared$Record)))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductOverview$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'images',
	$elm$json$Json$Decode$list($author$project$Api$Partner$ProductImage$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductOverview$Shared$Record)));
var $author$project$Api$Partner$PartnerProductOverview$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductOverview$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductQuote$Shared$PartnerProductQuote = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductQuote$Shared$Record = F5(
	function (id, text, author, authorTitle, authorImageUrl) {
		return {Jz: author, JA: authorImageUrl, JB: authorTitle, adR: id, $A: text};
	});
var $author$project$Api$Partner$PartnerProductQuote$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'author_image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'author_title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'author',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'text',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductQuote$Shared$Record))))));
var $author$project$Api$Partner$PartnerProductQuote$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductQuote$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Partner$One$ManagedByManagementGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$One$ManagedByPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$ManagementGroup$Min$ManagementGroup = $elm$core$Basics$identity;
var $author$project$Api$Partner$ManagementGroup$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Partner$ManagementGroup$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$ManagementGroup$Min$Record)));
var $author$project$Api$Partner$ManagementGroup$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$ManagementGroup$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Practice$Min$Practice = $elm$core$Basics$identity;
var $author$project$Api$Partner$Practice$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Partner$Practice$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Min$Record)));
var $author$project$Api$Partner$Practice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Practice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Partner$One$managedByDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (managedByType) {
		if (managedByType.$ === 1) {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (managedByType.a) {
				case 'Practice':
					return A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'managed_by',
							$author$project$Api$Partner$Practice$Min$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$ManagedByPractice)));
				case 'ManagementGroup':
					return A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'managed_by',
							$author$project$Api$Partner$ManagementGroup$Min$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$ManagedByManagementGroup)));
				default:
					var somethingElse = managedByType.a;
					return $elm$json$Json$Decode$fail('Unsupported managed by type ' + somethingElse);
			}
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['managed_by_type']),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Partner$Partner$One$SandboxOfPartner = 1;
var $author$project$Api$Partner$Partner$One$SandboxOfPractice = 0;
var $author$project$Api$Partner$Partner$One$sandboxOfDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (sandboxOfType) {
		if (sandboxOfType.$ === 1) {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		} else {
			switch (sandboxOfType.a) {
				case 'Practice':
					return $elm$json$Json$Decode$succeed(
						$elm$core$Maybe$Just(0));
				case 'Partner':
					return $elm$json$Json$Decode$succeed(
						$elm$core$Maybe$Just(1));
				default:
					var somethingElse = sandboxOfType.a;
					return $elm$json$Json$Decode$fail('Unsupported sandbox of type ' + somethingElse);
			}
		}
	},
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['sandbox_of_type']),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Partner$Partner$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'baa_document_agreement',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'baa_type',
		$elm$json$Json$Decode$nullable($author$project$Api$Partner$BaaType$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'address',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'api_access_document_agreement',
				$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'addendum_document_agreement',
					$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'partner_document_agreement',
						$elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'custom_baa_agreement_file_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'custom_api_access_agreement_file_name',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'addendum_agreement_file_name',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'custom_partner_agreement_file_name',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'product_categories',
											$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductCategory$One$decoder),
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
												$author$project$Api$Partner$Partner$One$managedByDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'product_data_flows',
													$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductDataFlow$Shared$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'product_links',
														$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductLink$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'product_quotes',
															$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductQuote$Shared$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'product_highlights',
																$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductHighlight$Shared$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'product_overview',
																	$elm$json$Json$Decode$nullable($author$project$Api$Partner$PartnerProductOverview$Shared$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'product',
																		$elm$json$Json$Decode$nullable($author$project$Api$Partner$PartnerProduct$Shared$decoder),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'has_sandbox_practices',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'has_sandbox_partners',
																				$elm$json$Json$Decode$bool,
																				A2(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
																					$author$project$Api$Partner$Partner$One$sandboxOfDecoder,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'webhooks_signature_api_key',
																						$elm$json$Json$Decode$nullable($author$project$Api$Partner$ApiKey$Shared$decoder),
																						$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$Record)))))))))))))))))))))));
var $author$project$Api$Partner$Partner$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Partner$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$Partner$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$Partner)));
var $author$project$Api$Data$partnerPath = $author$project$Api$Data$newPath(
	_List_fromArray(
		['partner']));
var $author$project$Api$Partner$Partner$partnerPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Partner$updateMfaRequirement = F3(
	function (apiClient, requiresMfa_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'requires_mfa',
								$elm$json$Json$Encode$bool(requiresMfa_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Api$Provider$Practice$updateMfaRequirement = F3(
	function (apiClient, requiresMfa_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'requires_mfa',
								$elm$json$Json$Encode$bool(requiresMfa_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Components$Admin$ToogleOrganizationMfa$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var bool = msg.a;
				var _v2 = model.Vd;
				if (!_v2.$) {
					return {
						EC: A3($author$project$Api$Provider$Practice$updateMfaRequirement, apiClient, bool, $author$project$Components$Admin$ToogleOrganizationMfa$GotPractice),
						ac5: $author$project$Components$Admin$ToogleOrganizationMfa$None,
						y8: _Utils_update(
							model,
							{o1: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					return {
						EC: A3($author$project$Api$Partner$Partner$updateMfaRequirement, apiClient, bool, $author$project$Components$Admin$ToogleOrganizationMfa$GotPartner),
						ac5: $author$project$Components$Admin$ToogleOrganizationMfa$None,
						y8: _Utils_update(
							model,
							{tq: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$ToogleOrganizationMfa$PracticeUpdated(practice),
						y8: _Utils_update(
							model,
							{
								Vd: $author$project$Components$Admin$ToogleOrganizationMfa$Practice(practice),
								o1: response
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
								$author$project$OutMsg$PracticeUpdated(response)
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$ToogleOrganizationMfa$None,
						y8: _Utils_update(
							model,
							{o1: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$ToogleOrganizationMfa$PartnerUpdated(partner),
						y8: _Utils_update(
							model,
							{
								Vd: $author$project$Components$Admin$ToogleOrganizationMfa$Partner(partner),
								tq: response
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your partner has been updated'),
								$author$project$OutMsg$PartnerUpdated(response)
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Admin$ToogleOrganizationMfa$None,
						y8: _Utils_update(
							model,
							{tq: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$InviteLink$update = function (msg) {
	var inviteUrl = msg;
	return _Utils_Tuple2(
		$author$project$Ports$Clipboard$copy(inviteUrl),
		_List_fromArray(
			[
				A2($author$project$OutMsg$ShowToast, 3, 'Copied invite link to clipboard')
			]));
};
var $author$project$Pages$Admin$Team$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{BX: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S$: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							A: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$Team$formFieldsInit(model.afw)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var field = msg.a;
				var _v1 = model.A;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var teamMember = _v2.a;
					var form = _v2.b;
					var request = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Team$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var form = msg.a;
				var teamMember = msg.b;
				var id = msg.c;
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Team$formFieldsValidator, form);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Pages$Admin$Team$saveTeamMember, model.D5, model.tM, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							A: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(teamMember),
									$author$project$Utils$Form$init(
										$author$project$Pages$Admin$Team$formFieldsFromTeamMember(teamMember)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{A: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								eK: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eK: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v6.a;
				var searchInputCmd = _v6.b;
				var searchInputEvent = _v6.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v7 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q,
								eK: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Admin$Team$fetchTeamMembers(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, eK: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Team$fetchTeamMembers(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1),
						eK: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Admin$Team$fetchTeamMembers(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 11:
				var response = msg.a;
				var _v9 = model.A;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var teamMember = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{A: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									A: $elm$core$Maybe$Just(
										_Utils_Tuple3(teamMember, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var response = msg.a;
				var _v12 = model.A;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{A: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Admin$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									A: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dU: A2($elm$core$Set$remove, id, model.dU),
									eK: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Admin$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dU: A2($elm$core$Set$remove, id, model.dU)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lQ: $elm$core$Maybe$Just(teamMember)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lQ: $elm$core$Maybe$Nothing,
							dU: A2($elm$core$Set$insert, id, model.dU)
						}),
					A3(
						$author$project$Api$Provider$TeamMember$delete,
						model.D5,
						id,
						$author$project$Pages$Admin$Team$TeamMemberDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{lQ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							$9: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var id = msg.a;
				var confirmed = msg.b;
				var _v16 = model.A;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var teamMember = _v17.a;
					var form = _v17.b;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$9: $elm$core$Maybe$Nothing,
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, form, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Api$Provider$TeamMember$disableMfa, model.D5, id, $author$project$Pages$Admin$Team$TeamMemberMfaDisabled),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{$9: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var response = msg.a;
				var _v18 = model.A;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var teamMember = _v19.a;
					var form = _v19.b;
					switch (response.$) {
						case 3:
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Admin$Team$formFieldsUpdate,
								$author$project$Pages$Admin$Team$MfaStatus('inactive'),
								form);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										A: $elm$core$Maybe$Just(
											_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked)),
										eK: $author$project$Api$Data$Loading
									}),
								$author$project$Pages$Admin$Team$fetchTeamMembers(model),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Team member mfa successfully disabled')
									]));
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										A: $elm$core$Maybe$Just(
											_Utils_Tuple3(teamMember, form, $author$project$Api$Data$NotAsked))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$TeamMember$invite,
						model.D5,
						$author$project$Api$Provider$PracticeUser$All$id(teamMember),
						A2(
							$author$project$Pages$Admin$Team$GotInvitation,
							$author$project$Api$Provider$PracticeUser$All$email(teamMember),
							false)),
					_List_Nil);
			case 20:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$TeamMember$invite,
						model.D5,
						$author$project$Api$Provider$PracticeUser$All$id(teamMember),
						A2(
							$author$project$Pages$Admin$Team$GotInvitation,
							$author$project$Api$Provider$PracticeUser$All$email(teamMember),
							true)),
					_List_Nil);
			case 22:
				var email = msg.a;
				var isReinvite = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var prefix = isReinvite ? 'A new' : 'An';
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eK: $author$project$Api$Data$Loading}),
						$author$project$Pages$Admin$Team$fetchTeamMembers(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, prefix + (' invitation is being sent to ' + email))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 21:
				var subMsg = msg.a;
				var _v22 = $author$project$Components$InviteLink$update(subMsg);
				var inviteLinkCmd = _v22.a;
				var inviteLinkOutMsg = _v22.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$InviteLinkMsg, inviteLinkCmd),
					inviteLinkOutMsg);
			case 23:
				var subMsg = msg.a;
				var toogleOrganizationMfaResult = A3($author$project$Components$Admin$ToogleOrganizationMfa$update, model.D5, subMsg, model.tl);
				var newModel = function () {
					var _v23 = toogleOrganizationMfaResult.ac5;
					switch (_v23.$) {
						case 0:
							return model;
						case 1:
							var practice = _v23.a;
							return _Utils_update(
								model,
								{WF: practice});
						default:
							return model;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{tl: toogleOrganizationMfaResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$ToogleOrganizationMfa, toogleOrganizationMfaResult.EC),
					toogleOrganizationMfaResult.as);
			case 24:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ea: A2($elm$core$Set$insert, id, model.ea)
						}),
					A3(
						$author$project$Api$Provider$TeamMember$makeSuperAdmin,
						model.D5,
						id,
						$author$project$Pages$Admin$Team$TeamMemberAdminCompleted(id)),
					_List_Nil);
			default:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ea: A2($elm$core$Set$remove, id, model.ea)
								}),
							$author$project$Pages$Admin$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member is now an admin')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ea: A2($elm$core$Set$remove, id, model.ea)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Admin$Team$NewTeamMember = {$: 2};
var $author$project$Pages$Admin$Team$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Team$buildIdentityProviderUrl = F2(
	function (hintEnv, organizationId) {
		var envPath = function () {
			_v0$2:
			while (true) {
				if (!hintEnv.$) {
					switch (hintEnv.a) {
						case 0:
							var _v1 = hintEnv.a;
							return 'production';
						case 1:
							var _v2 = hintEnv.a;
							return 'staging';
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return 'development';
		}();
		return 'https://portal.frontegg.com/' + (envPath + ('/backoffice/accounts/' + organizationId));
	});
var $author$project$Api$Provider$Practice$One$organizationId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.aft;
	});
var $author$project$Pages$Admin$Team$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Admin$Team$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'),
		A3($author$project$Api$Column$init, 'email', false, 'Email'),
		A3($author$project$Api$Column$init, 'role', true, 'Role'),
		A3($author$project$Api$Column$init, 'notifications', false, 'Notifications'),
		A3($author$project$Api$Column$init, 'mfa', false, 'MFA')
	]);
var $author$project$Components$Admin$ToogleOrganizationMfa$ToogleMfa = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$User$Shared$isMfaActive = function (_v0) {
	var record = _v0;
	return record.RT;
};
var $author$project$Api$Partner$Partner$Shared$requiresMfa = function (_v0) {
	var record = _v0;
	return record.Yn;
};
var $author$project$Api$Partner$Partner$One$requiresMfa = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$requiresMfa(shared);
};
var $author$project$Api$Provider$Practice$One$requiresMfa = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Yn;
	});
var $author$project$Components$Admin$ToogleOrganizationMfa$view = function (_v0) {
	var model = _v0;
	var requiresMfa = function () {
		var _v1 = model.Vd;
		if (!_v1.$) {
			var practice = _v1.a;
			return $author$project$Api$Provider$Practice$One$requiresMfa(practice);
		} else {
			var partner = _v1.a;
			return $author$project$Api$Partner$Partner$One$requiresMfa(partner);
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Require Multi-factor authentication (MFA)'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(requiresMfa),
						$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$ToogleOrganizationMfa$ToogleMfa),
						$author$project$Ui$ToggleSwitch$disabled(
						(!$author$project$Api$Platform$User$Shared$isMfaActive(model.EQ)) || _Utils_eq(model.o1, $author$project$Api$Data$Loading))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add an extra layer of security to your account by requiring users to enter a one-time '),
						$elm$html$Html$text('authentication code in addition to their password. Enabling this will require all the '),
						$elm$html$Html$text('users to enable MFA in order to access this application.')
					])),
				(!$author$project$Api$Platform$User$Shared$isMfaActive(model.EQ)) ? A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('You need to enable MFA before making it required. Enable it '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Mfa,
						_List_fromArray(
							[
								$author$project$Ui$Link$routeParams(
								_List_fromArray(
									[
										A2($elm$url$Url$Builder$string, 'requiresMfaPrerequisite', 'true')
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						$elm$html$Html$text('.')
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Pages$Admin$Team$EditTeamMember = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Team$InviteTeamMember = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Admin$Team$MakeSuperAdmin = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Admin$Team$OpenDeleteConfirm = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$InviteLink$PracticeUser = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Team$ReInviteTeamMember = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Provider$PracticeUser$All$isHinter = function (_v0) {
	var shared = _v0.a;
	return A2(
		$elm$core$String$contains,
		'@hint.com',
		$author$project$Api$Provider$PracticeUser$Shared$email(shared));
};
var $author$project$Api$Provider$User$Shared$isAdmin = function (_v0) {
	var record = _v0;
	return record.Ru;
};
var $author$project$Api$Provider$User$One$isAdmin = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$User$Shared$isAdmin(shared);
};
var $author$project$Api$Provider$PracticeUser$All$isSuperAdmin = function (practiceUser) {
	var _v0 = $author$project$Api$Provider$PracticeUser$All$user(practiceUser);
	if (_v0.$ === 1) {
		return false;
	} else {
		var user_ = _v0.a;
		return $author$project$Api$Provider$PracticeUser$All$isHinter(practiceUser) && $author$project$Api$Provider$User$One$isAdmin(user_);
	}
};
var $author$project$Pages$Admin$Team$canMakeSuperAdmin = F2(
	function (teamMember, isHintAdmin) {
		return isHintAdmin && ($author$project$Api$Provider$PracticeUser$All$isHinter(teamMember) && ($author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$PracticeUser$All$user(teamMember)) && (!$author$project$Api$Provider$PracticeUser$All$isSuperAdmin(teamMember))));
	});
var $author$project$Api$Provider$PracticeUser$Shared$invitationPending = function (_v0) {
	var record = _v0;
	return record.Rf;
};
var $author$project$Api$Provider$PracticeUser$All$invitationPending = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$invitationPending(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.RJ;
};
var $author$project$Api$Provider$PracticeUser$All$isDestroyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$isDestroyable(shared);
};
var $author$project$Api$Provider$PracticeUser$Shared$isOwner = function (_v0) {
	var record = _v0;
	return record.RX;
};
var $author$project$Api$Provider$PracticeUser$All$isOwner = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PracticeUser$Shared$isOwner(shared);
};
var $author$project$Components$InviteLink$CopyToClipboard = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerUser$Shared$invitationPending = function (_v0) {
	var record = _v0;
	return record.Rf;
};
var $author$project$Api$Partner$PartnerUser$All$invitationPending = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$invitationPending(shared);
};
var $author$project$Api$Provider$CompanyAdmin$Shared$invitationPending = function (_v0) {
	var record = _v0;
	return record.Rf;
};
var $author$project$Api$Provider$CompanyAdmin$One$invitationPending = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$invitationPending(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$invitationPending = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$invitationPending(one);
};
var $author$project$Api$Partner$PartnerUser$All$invitationUrl = function (_v0) {
	var record = _v0.b;
	return record.Rg;
};
var $author$project$Api$Provider$CompanyAdmin$One$invitationUrl = function (_v0) {
	var record = _v0.b;
	return record.Rg;
};
var $author$project$Api$Provider$CompanyAdmin$All$invitationUrl = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$invitationUrl(one);
};
var $author$project$Api$Provider$PracticeUser$All$invitationUrl = function (_v0) {
	var record = _v0.b;
	return record.Rg;
};
var $author$project$Components$InviteLink$view = function (admin) {
	var _v0 = function () {
		switch (admin.$) {
			case 0:
				var companyAdmin = admin.a;
				return _Utils_Tuple2(
					$author$project$Api$Provider$CompanyAdmin$All$invitationPending(companyAdmin),
					$author$project$Api$Provider$CompanyAdmin$All$invitationUrl(companyAdmin));
			case 1:
				var practiceUser = admin.a;
				return _Utils_Tuple2(
					$author$project$Api$Provider$PracticeUser$All$invitationPending(practiceUser),
					$author$project$Api$Provider$PracticeUser$All$invitationUrl(practiceUser));
			default:
				var partnerUser = admin.a;
				return _Utils_Tuple2(
					$author$project$Api$Partner$PartnerUser$All$invitationPending(partnerUser),
					$author$project$Api$Partner$PartnerUser$All$invitationUrl(partnerUser));
		}
	}();
	var invitationPending = _v0.a;
	var invitationUrl = _v0.b;
	return (invitationPending && (!_Utils_eq(invitationUrl, $elm$core$Maybe$Nothing))) ? A3(
		$author$project$Ui$Button$view,
		{abp: 'Copy invite link'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
				$author$project$Ui$Button$onClick(
				A2($elm$core$Maybe$withDefault, '', invitationUrl)),
				$author$project$Ui$Button$size(0),
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Copy Invite Link')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Admin$Team$viewTeamMember = F5(
	function (currentUser, deletingTeamMembers, makingAdminTeamMembers, currentUserIsHintAdmin, teamMember) {
		var notificationsStatus = $author$project$Api$Provider$PracticeUser$All$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
		var memberIsOwner = $author$project$Api$Provider$PracticeUser$All$isOwner(teamMember);
		var isCurrentUser = _Utils_eq(
			$author$project$Api$Provider$PracticeUser$All$email(teamMember),
			$author$project$Api$Platform$User$Shared$email(currentUser));
		var rowOptions = isCurrentUser ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(2)
			]) : _List_Nil;
		var id = $author$project$Api$Provider$PracticeUser$All$id(teamMember);
		var loading = A2($elm$core$Set$member, id, deletingTeamMembers) || A2($elm$core$Set$member, id, makingAdminTeamMembers);
		return A2(
			$author$project$Ui$Table$row,
			rowOptions,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('11em')
						]),
					function () {
						var _v0 = $author$project$Api$Provider$PracticeUser$All$user(teamMember);
						if (!_v0.$) {
							var user = _v0.a;
							var memberIsHintAdmin = $author$project$Api$Provider$PracticeUser$All$isSuperAdmin(teamMember);
							var isOwnerOrAdminLabel = function () {
								var _v1 = _Utils_Tuple3(memberIsOwner, memberIsHintAdmin, currentUserIsHintAdmin);
								if (_v1.a) {
									if (_v1.b) {
										if (_v1.c) {
											return $elm$html$Html$text(' (owner | admin)');
										} else {
											return $elm$html$Html$text(' (owner)');
										}
									} else {
										return $elm$html$Html$text(' (owner)');
									}
								} else {
									if (_v1.b && _v1.c) {
										return $elm$html$Html$text(' (admin)');
									} else {
										return $author$project$Utils$Html$empty;
									}
								}
							}();
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$User$One$name(user))
										])),
									isOwnerOrAdminLabel
								]);
						} else {
							var isOwnerLabel = memberIsOwner ? $elm$html$Html$text(' (owner)') : $author$project$Utils$Html$empty;
							return $author$project$Api$Provider$PracticeUser$All$invitationPending(teamMember) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Invitation Pending'),
											isOwnerLabel
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Resend invite email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Team$ReInviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resend')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Admin$Team$InviteLinkMsg,
											$author$project$Components$InviteLink$view(
												$author$project$Components$InviteLink$PracticeUser(teamMember)))
										]))
								]) : _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Not Invited'),
											isOwnerLabel
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Send invite email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Team$InviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send),
													$author$project$Ui$Button$sm
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Send Invite')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Admin$Team$InviteLinkMsg,
											$author$project$Components$InviteLink$view(
												$author$project$Components$InviteLink$PracticeUser(teamMember)))
										]))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$PracticeUser$All$email(teamMember))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Formatters$String$humanize(
									$author$project$Api$Provider$PracticeUser$All$role(teamMember))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Pages$Admin$Team$mfaStatus(
								$elm$core$Maybe$Just(teamMember)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2($author$project$Pages$Admin$Team$canMakeSuperAdmin, teamMember, currentUserIsHintAdmin) ? A3(
									$author$project$Ui$HinterOnly$button,
									{abp: 'Make admin'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$disabled(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Team$MakeSuperAdmin(
												$author$project$Api$Provider$PracticeUser$All$id(teamMember)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Make admin')
										])) : $author$project$Utils$Html$empty,
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$disabled(
											loading || (memberIsOwner && (!$author$project$Api$Platform$User$Shared$isAdmin(currentUser)))),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Team$EditTeamMember(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									($author$project$Api$Provider$PracticeUser$All$isDestroyable(teamMember) && (!isCurrentUser)) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete team member'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Admin$Team$OpenDeleteConfirm(teamMember)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Pages$Admin$Team$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.eK;
		if (_v1.$ === 3) {
			var teamMembers_ = _v1.a;
			return _Utils_Tuple2(false, teamMembers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var teamMembers = _v0.b;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingSm(
			_List_fromArray(
				[
					$elm$html$Html$text('Security')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Admin$Team$ToogleOrganizationMfa,
			$author$project$Components$Admin$ToogleOrganizationMfa$view(model.tl)),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Members')
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Admin$Team$SearchInputMsg,
									A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no team members.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Admin$Team$SortTable)),
						$author$project$Pages$Admin$Team$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A4($author$project$Pages$Admin$Team$viewTeamMember, model.EQ, model.dU, model.ea, model.FR),
				teamMembers),
			_List_Nil)
		]);
};
var $author$project$Pages$Admin$Team$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Admin$Team$FormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Admin$Team$Invite = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Admin$Team$NotificationsEnabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Admin$Team$OpenDisableMfaConfirm = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Admin$Team$RestrictedByGroups = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Admin$Team$Role = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Admin$Team$SaveTeamMember = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Api$Common$Role$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Common$Role$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Role$Shared$name(shared);
};
var $author$project$Api$Common$Role$Shared$permissionSets = function (_v0) {
	var record = _v0;
	return record.Wf;
};
var $author$project$Api$Common$Role$All$permissionSets = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Role$Shared$permissionSets(shared);
};
var $author$project$Pages$Admin$Team$roleOptions = F2(
	function (adminOnly, roles) {
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Pick a role'),
			A2(
				$elm$core$List$map,
				function (role) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Common$Role$All$name(role)),
						$author$project$Formatters$String$titleize(
							$author$project$Formatters$String$humanize(
								$author$project$Api$Common$Role$All$name(role))));
				},
				A2(
					$elm$core$List$filter,
					function (role) {
						return (!adminOnly) || ($author$project$Api$Common$Role$All$name(role) === 'admin');
					},
					roles)));
	});
var $author$project$Ui$Element$textCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textCenter);
var $author$project$Ui$FlexGrid$textCenter = $author$project$Ui$FlexGrid$Element($author$project$Ui$Element$textCenter);
var $author$project$Pages$Admin$Team$LocationGroups = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Admin$Team$viewLocationGroup = F2(
	function (locationGroups, locationGroup) {
		var id = $author$project$Api$Provider$LocationGroup$All$id(locationGroup);
		var locationGroupEnabled = A2($elm$core$Set$member, id, locationGroups);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(locationGroupEnabled),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Pages$Admin$Team$FormUpdated,
								$author$project$Pages$Admin$Team$LocationGroups(id)))
						]),
					_List_fromArray(
						[
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text(
							$author$project$Api$Provider$LocationGroup$All$name(locationGroup))
						]))
				]));
	});
var $author$project$Pages$Admin$Team$viewPermissionSet = F2(
	function (index, permissionSet) {
		var hasEvenIndex = !A2($elm$core$Basics$modBy, 2, index);
		var gridOptions = hasEvenIndex ? _List_fromArray(
			[
				$author$project$Ui$FlexGrid$offsetSm(2),
				$author$project$Ui$FlexGrid$spanSm(4),
				$author$project$Ui$FlexGrid$span(6)
			]) : _List_fromArray(
			[
				$author$project$Ui$FlexGrid$spanSm(5),
				$author$project$Ui$FlexGrid$justifyRight
			]);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				gridOptions,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Formatters$String$humanize(
											$author$project$Api$Common$PermissionSet$Shared$name(permissionSet)))
									])),
								$author$project$Api$Common$PermissionSet$Shared$enabled(permissionSet) ? A2($author$project$Ui$Icon$view, _List_Nil, 18) : A2($author$project$Ui$Icon$view, _List_Nil, 20)
							]))
					]))
			]);
	});
var $author$project$Api$Feature$ReportAccess = 9;
var $author$project$Pages$Admin$Team$ReportRestricted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Team$viewReportAccessSection = F3(
	function (practice, permissions, fields) {
		var featureIsEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 9, practice);
		var canViewReports = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$PermissionSet$Shared$enabled,
				A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Common$PermissionSet$Shared$name,
						$elm$core$Basics$eq('view_reports')),
					permissions)));
		return (featureIsEnabled && ((fields.agy !== 'admin') && canViewReports)) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Restrict report access')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.Yd),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$ReportRestricted))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Admin$Team$viewTeamMemberModal = F4(
	function (model, teamMember, request, form) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Team Member',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$id, teamMember),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Admin$Team$CancelTeamMemberEdit,
			U0: A2($author$project$Pages$Admin$Team$SaveTeamMember, form, teamMember)
		};
		var isNewTeamMember = !$author$project$Utils$Maybe$toBool(teamMember);
		var isCurrentUser = _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$email, teamMember),
			$elm$core$Maybe$Just(
				$author$project$Api$Platform$User$Shared$email(model.EQ)));
		var roleDisabled = isCurrentUser || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$isOwner, teamMember));
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			var _v1 = model.BX;
			if (_v1.$ === 3) {
				var list = _v1.a;
				return _Utils_Tuple2(list, false);
			} else {
				return _Utils_Tuple2(_List_Nil, true);
			}
		}();
		var roles_ = _v0.a;
		var rolesLoading = _v0.b;
		var permissionSets = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$Role$All$permissionSets,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (role) {
						return _Utils_eq(
							$author$project$Api$Common$Role$All$name(role),
							fields.agy);
					},
					roles_)));
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(isNewTeamMember),
							$author$project$Ui$Form$Group$label('Email')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Oo),
									$author$project$Ui$Form$Input$placeholder('email@example.com'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Email)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form)),
									$author$project$Ui$Form$Input$disabled(!isNewTeamMember)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Role')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(fields.agy)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Role)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form)),
									$author$project$Ui$Form$Select$loading(rolesLoading),
									$author$project$Ui$Form$Select$disabled(roleDisabled)
								]),
							A2($author$project$Pages$Admin$Team$roleOptions, model.tM, roles_)),
							roleDisabled ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$info]),
							_List_fromArray(
								[
									$elm$html$Html$text('You cannot change your own role.')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Notifications')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.UO),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$NotificationsEnabled))
								]))
						])),
					isNewTeamMember ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Send invitation')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.ad9),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Invite))
								]))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('MFA')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, fields.TW),
									$author$project$Utils$Html$noBreakSpace,
									function () {
									if (!teamMember.$) {
										var teamMember_ = teamMember.a;
										return ((fields.TW === 'active') && (!isCurrentUser)) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Reset MFA device'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Admin$Team$OpenDisableMfaConfirm(
														$author$project$Api$Provider$PracticeUser$All$id(teamMember_)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset MFA device')
												])) : $author$project$Utils$Html$empty;
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$mb4, $author$project$Ui$FlexGrid$mt4]),
					$elm$core$List$concat(
						A2($elm$core$List$indexedMap, $author$project$Pages$Admin$Team$viewPermissionSet, permissionSets))),
					(fields.agy !== 'admin') ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Restrict by location groups')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.Yy),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$RestrictedByGroups))
								]))
						])) : $author$project$Utils$Html$empty,
					fields.Yy ? A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offset(4),
									$author$project$Ui$FlexGrid$span(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Which location groups\' patients should they be able to see?')
										]))
								])),
						function () {
							var _v3 = model.S$;
							if (_v3.$ === 3) {
								var locationGroups = _v3.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$offset(4),
												$author$project$Ui$FlexGrid$span(8)
											]),
										A2(
											$elm$core$List$map,
											$author$project$Pages$Admin$Team$viewLocationGroup(fields.S$),
											locationGroups))
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$offset(4),
												$author$project$Ui$FlexGrid$span(8),
												$author$project$Ui$FlexGrid$textCenter
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}())) : $author$project$Utils$Html$empty,
					A3($author$project$Pages$Admin$Team$viewReportAccessSection, model.WF, permissionSets, fields)
				]));
	});
var $author$project$Pages$Admin$Team$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.A;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var teamMember = _v1.a;
					var form = _v1.b;
					var request = _v1.c;
					return A4($author$project$Pages$Admin$Team$viewTeamMemberModal, model, teamMember, request, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.lQ;
				if (!_v2.$) {
					var teamMember = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Team$DeleteConfirmClosed(
							$author$project$Api$Provider$PracticeUser$All$id(teamMember)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('team member'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Provider$PracticeUser$All$email(teamMember))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.$9;
				if (!_v3.$) {
					var id = _v3.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Admin$Team$DisableMfaConfirmClosed(id),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('reset'),
								$author$project$Components$HiConfirm$noun('MFA device'),
								$author$project$Components$HiConfirm$titleizeNoun(false),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Resetting the MFA device for this user will log them out of all sessions and require them to setup a new MFA device the next time they login.')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Team')
													])),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														$elm$html$Html$text('Changing settings within the Admin section requires \"Admin\" privileges. Non admin users can\n        view the settings but cannot change them.')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												model.FR ? A3(
												$author$project$Ui$HinterOnly$linkHref,
												A2(
													$author$project$Pages$Admin$Team$buildIdentityProviderUrl,
													model.adM,
													$author$project$Api$Provider$Practice$One$organizationId(model.WF)),
												_List_fromArray(
													[
														$author$project$Ui$Link$targetBlank,
														$author$project$Ui$Link$buttonDefault,
														$author$project$Ui$Link$ariaLabel('Open Identity Provider in new tab')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Identity Provider')
													])) : $author$project$Utils$Html$empty,
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Add new member'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$NewTeamMember),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Admin$Team$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Admin$Team$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.eK))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Team'
	};
};
var $author$project$Pages$Admin$Team$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Team$init, aer: $author$project$Pages$Admin$Team$load, agD: $author$project$Pages$Admin$Team$save, ahd: $author$project$Pages$Admin$Team$subscriptions, aaq: $author$project$Pages$Admin$Team$update, ahP: $author$project$Pages$Admin$Team$view});
var $author$project$Pages$Admin$Team$New$TeamFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TeamForm$EmrRoleDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$TeamForm$Model = $elm$core$Basics$identity;
var $author$project$Components$TeamForm$DeaStateDropdownMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$TeamForm$MultiDeaExpirationMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$TeamForm$StateLicenseExpirationMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$TeamForm$StateLicenseStateDropdownMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$TeamForm$initLicense = F3(
	function (usingClinical, dropdownId, toDropdownMsg) {
		if (usingClinical) {
			var _v0 = $author$project$Components$DateInput$init;
			var initialLicenseExpiration = _v0.a;
			var initialLicenseExpirationCmd = _v0.b;
			return _Utils_Tuple2(
				_List_fromArray(
					[
						{
						adc: _Utils_Tuple2($elm$core$Maybe$Nothing, initialLicenseExpiration),
						Gj: $elm$core$Maybe$Nothing,
						sZ: $elm$core$Maybe$Nothing,
						bg: $author$project$Ui$NewDropdown$init(
							$author$project$Ui$NewDropdown$defaultConfig(
								{
									adR: dropdownId,
									ahx: toDropdownMsg(0)
								})),
						bC: ''
					}
					]),
				initialLicenseExpirationCmd);
		} else {
			return _Utils_Tuple2(_List_Nil, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$TeamForm$initPhone = F3(
	function (requirePhone, isOnboarding, maybePhone) {
		var phoneToUse = isOnboarding ? A2(
			$elm$core$Maybe$withDefault,
			{Gj: '', agc: 0, ahI: $author$project$Api$Common$Phone$Shared$Mobile},
			A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone)) : {Gj: '', agc: 0, ahI: $author$project$Api$Common$Phone$Shared$Mobile};
		return A2(
			$author$project$Components$PhoneInput$require,
			requirePhone,
			A3(
				$author$project$Components$PhoneInput$init,
				'new-team-member-phone',
				_List_fromArray(
					[phoneToUse]),
				function (opts) {
					return _Utils_update(
						opts,
						{abk: false, acN: true, yQ: 1});
				}));
	});
var $author$project$Api$Platform$User$Shared$phones = function (_v0) {
	var record = _v0;
	return record.Wi;
};
var $author$project$Components$TeamForm$formFieldsFromTeamMember = F3(
	function (user, usingClinical, isOnboarding) {
		var _v0 = A3($author$project$Components$TeamForm$initLicense, usingClinical, 'state-dropdown-0', $author$project$Components$TeamForm$StateLicenseStateDropdownMsg);
		var initialLicense = _v0.a;
		var initialLicenseExpirationCmd = _v0.b;
		var _v1 = A3($author$project$Components$TeamForm$initLicense, usingClinical, 'dea-dropdown-0', $author$project$Components$TeamForm$DeaStateDropdownMsg);
		var initialDea = _v1.a;
		var initialDeaExpirationCmd = _v1.b;
		return _Utils_Tuple2(
			{
				MR: $elm$core$Maybe$Nothing,
				w3: initialDea,
				No: $elm$core$Maybe$Nothing,
				Oo: isOnboarding ? $author$project$Api$Platform$User$Shared$email(user) : '',
				ac$: $elm$core$Maybe$Nothing,
				Pu: isOnboarding ? $author$project$Api$Platform$User$Shared$firstName(user) : '',
				SA: isOnboarding ? $author$project$Api$Platform$User$Shared$lastName(user) : '',
				UP: $elm$core$Maybe$Nothing,
				Wg: A3(
					$author$project$Components$TeamForm$initPhone,
					usingClinical,
					isOnboarding,
					$elm$core$List$head(
						$author$project$Api$Platform$User$Shared$phones(user))),
				W_: $elm$core$Maybe$Nothing,
				Xm: $elm$core$Maybe$Nothing,
				Cr: initialLicense
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$TeamForm$StateLicenseExpirationMsg(0),
						initialLicenseExpirationCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$TeamForm$MultiDeaExpirationMsg(0),
						initialDeaExpirationCmd)
					])));
	});
var $author$project$Components$TeamForm$init = F4(
	function (today, session, practice, _v0) {
		var usingClinicalEmr = _v0.di;
		var isOnboarding = _v0.aJ;
		var emrRoleDropdown = $author$project$Ui$NewDropdown$init(
			$author$project$Ui$NewDropdown$defaultConfig(
				{adR: 'emr-role-dropdown', ahx: $author$project$Components$TeamForm$EmrRoleDropdownMsg}));
		var _v1 = A3(
			$author$project$Components$TeamForm$formFieldsFromTeamMember,
			$author$project$Api$Platform$Session$One$user(session),
			usingClinicalEmr,
			isOnboarding);
		var formFields = _v1.a;
		var formFieldsCmd = _v1.b;
		return _Utils_Tuple2(
			{
				qr: emrRoleDropdown,
				PB: $author$project$Utils$Form$init(formFields),
				aJ: isOnboarding,
				WF: practice,
				ZD: session,
				$P: today,
				aaz: $author$project$Api$Platform$Session$One$user(session),
				di: usingClinicalEmr
			},
			formFieldsCmd);
	});
var $author$project$Pages$Admin$Team$New$init = F4(
	function (session, practice, shared, _v0) {
		var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice);
		var _v1 = A4(
			$author$project$Components$TeamForm$init,
			shared.cO,
			session,
			practice,
			{aJ: false, di: usingClinicalEmr});
		var teamFormModel = _v1.a;
		var teamFormCmd = _v1.b;
		return _Utils_Tuple2(
			{abc: false, D5: shared.D5, Op: shared.adu.acW, PB: teamFormModel, WF: practice, nF: 0, nM: $author$project$Api$Data$NotAsked, jY: $author$project$Api$Data$NotAsked, ZD: session, on: false},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$New$TeamFormMsg, teamFormCmd));
	});
var $author$project$Pages$Admin$Team$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Admin$Team$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Admin$Team$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Utils$EmrRole$Admin = 0;
var $author$project$Pages$Admin$Team$New$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$EmrRole$toString = function (role) {
	switch (role) {
		case 0:
			return 'admin';
		case 1:
			return 'provider';
		default:
			return 'employee';
	}
};
var $author$project$Api$Provider$TeamMember$encodeEmrRole = function (emrRole) {
	return $author$project$Utils$EmrRole$toString(emrRole);
};
var $author$project$Api$Provider$TeamMember$createWithClinicalData = F3(
	function (apiClient, fields, toMsg) {
		var providerStatusValue = A2($elm$core$Maybe$map, $author$project$Components$TeamForm$providerStatusToString, fields.Xm);
		var encodeMaskedDate = function (stringDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				$elm$core$Result$toMaybe(
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Date$encode,
						$author$project$Utils$Date$fromUsString(
							A2(
								$agustinrhcp$elm_mask$Mask$mask,
								$agustinrhcp$elm_mask$Mask$fromString('##/##/####'),
								stringDate)))));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										_Utils_Tuple2(
										'first_name',
										$elm$json$Json$Encode$string(fields.Pu)),
										_Utils_Tuple2(
										'last_name',
										$elm$json$Json$Encode$string(fields.SA)),
										_Utils_Tuple2(
										'email',
										$elm$json$Json$Encode$string(fields.Oo)),
										_Utils_Tuple2(
										'emr_role',
										$elm$json$Json$Encode$string(
											$author$project$Api$Provider$TeamMember$encodeEmrRole(fields.ac$))),
										_Utils_Tuple2(
										'agreed_to_terms',
										$elm$json$Json$Encode$bool(fields.abc))
									]),
									A3($author$project$Utils$Encode$optional, 'phone_number', $elm$json$Json$Encode$string, fields.Wh),
									A3($author$project$Utils$Encode$optional, 'prescriber_type', $elm$json$Json$Encode$string, fields.W_),
									A3($author$project$Utils$Encode$optional, 'dob', encodeMaskedDate, fields.MR),
									A3($author$project$Utils$Encode$optional, 'education_degree', $elm$json$Json$Encode$string, fields.No),
									A3($author$project$Utils$Encode$optional, 'npi', $elm$json$Json$Encode$string, fields.UP),
									A3(
									$author$project$Utils$Encode$optional,
									'dea_licenses',
									$elm$json$Json$Encode$list($author$project$Api$Provider$TeamMember$encodeLicense),
									$elm$core$List$isEmpty(fields.w3) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.w3)),
									A3($author$project$Utils$Encode$optional, 'provider_status', $elm$json$Json$Encode$string, providerStatusValue),
									A3(
									$author$project$Utils$Encode$optional,
									'state_licenses',
									$elm$json$Json$Encode$list($author$project$Api$Provider$TeamMember$encodeLicense),
									$elm$core$List$isEmpty(fields.Cr) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.Cr))
								]))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
	});
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam = function (prescriberType) {
	switch (prescriberType) {
		case 0:
			return 'Provider';
		case 1:
			return 'POBNoReview';
		case 2:
			return 'POBSomeReview';
		default:
			return 'StaffUser';
	}
};
var $author$project$Components$TeamForm$teamMemberFormFields = function (fields) {
	var prescriberTypeValue = A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam, fields.W_);
	var phone = A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$String$toMaybe,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Gj;
			},
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Phone$toRecord,
				$elm$core$List$head(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$Components$PhoneInput$getPhones(fields.Wg))))));
	return {MR: fields.MR, w3: fields.w3, No: fields.No, Oo: fields.Oo, ac$: fields.ac$, Pu: fields.Pu, SA: fields.SA, UP: fields.UP, Wh: phone, W_: prescriberTypeValue, Xm: fields.Xm, Cr: fields.Cr};
};
var $author$project$Pages$Admin$Team$New$createTeamMember = F2(
	function (model, validFormFields) {
		var fields = $author$project$Components$TeamForm$teamMemberFormFields(
			$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
		return A3(
			$author$project$Api$Provider$TeamMember$createWithClinicalData,
			model.D5,
			{
				abc: model.abc,
				MR: fields.MR,
				w3: fields.w3,
				No: fields.No,
				Oo: fields.Oo,
				ac$: A2($elm$core$Maybe$withDefault, 0, fields.ac$),
				Pu: fields.Pu,
				SA: fields.SA,
				UP: fields.UP,
				Wh: fields.Wh,
				W_: fields.W_,
				Xm: fields.Xm,
				Cr: fields.Cr
			},
			$author$project$Pages$Admin$Team$New$Created);
	});
var $author$project$Pages$Admin$Team$New$ProductPricingReceived = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PracticePricing$Product$ProductPricing = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticePricing$Product$Record = F2(
	function (requiresPayment, priceInCents) {
		return {Ba: priceInCents, Yq: requiresPayment};
	});
var $author$project$Api$Provider$PracticePricing$Product$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'price_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'requires_payment',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$Product$Record)));
var $author$project$Api$Provider$PracticePricing$Product$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PracticePricing$Product$recordDecoder);
var $author$project$Api$Provider$PracticePricing$Product$productsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice', 'pricing', 'products']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticePricing$Product$productPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$PracticePricing$Product$productsPath);
};
var $author$project$Api$Provider$PracticePricing$Product$retrieve = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticePricing$Product$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticePricing$Product$productPath(productId)));
	});
var $author$project$Pages$Admin$Team$New$fetchProductPricing = function (model) {
	return A3($author$project$Api$Provider$PracticePricing$Product$retrieve, model.D5, 'clinician', $author$project$Pages$Admin$Team$New$ProductPricingReceived);
};
var $author$project$Api$Provider$PracticePricing$Product$priceInCents = function (_v0) {
	var record = _v0;
	return record.Ba;
};
var $author$project$Api$Provider$PracticePricing$Product$requiresPayment = function (_v0) {
	var record = _v0;
	return record.Yq;
};
var $author$project$Pages$Admin$Team$New$shouldFetchProductPricing = function (validFormFields) {
	var fields = $author$project$Components$TeamForm$teamMemberFormFields(
		$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
	var _v0 = _Utils_Tuple2(fields.Xm, fields.W_);
	if ((((!_v0.a.$) && (!_v0.a.a)) && (!_v0.b.$)) && (_v0.b.a === 'Provider')) {
		var _v1 = _v0.a.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$TeamForm$DeaExpirationAt = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$TeamForm$DeaStateDropdownAt = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Components$TeamForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TeamForm$Phone = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$TeamForm$PhoneInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$TeamForm$StateLicenseExpirationAt = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$TeamForm$StateLicenseStateDropdownAt = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$Provider = 0;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider = function (prescriberType) {
	return !prescriberType;
};
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$provider = 0;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$StaffUser = 3;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff = 3;
var $author$project$Components$TeamForm$calculateDefaultPrescriberType = F2(
	function (currentPrescriberType, providerStatus) {
		if (providerStatus === 2) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff),
				A2(
					$elm$core$Maybe$map,
					function (prescriberType) {
						return $author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider(prescriberType) ? $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff) : currentPrescriberType;
					},
					currentPrescriberType));
		} else {
			return $author$project$Utils$Maybe$isNothing(currentPrescriberType) ? $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$provider) : currentPrescriberType;
		}
	});
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$POBNoReview = 1;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$POBSomeReview = 2;
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$fromParam = function (stepTypeParam) {
	switch (stepTypeParam) {
		case 'Provider':
			return 0;
		case 'POBNoReview':
			return 1;
		case 'POBSomeReview':
			return 2;
		default:
			return 3;
	}
};
var $author$project$Utils$EmrRole$Provider = 1;
var $author$project$Utils$EmrRole$Staff = 2;
var $author$project$Utils$EmrRole$fromString = function (str) {
	switch (str) {
		case 'admin':
			return $elm$core$Maybe$Just(0);
		case 'provider':
			return $elm$core$Maybe$Just(1);
		case 'employee':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$TeamForm$removeAt = F2(
	function (index, list) {
		return _Utils_ap(
			A2($elm$core$List$take, index, list),
			A2($elm$core$List$drop, index + 1, list));
	});
var $author$project$Components$TeamForm$updateItemAt = F3(
	function (index, updateFn, items) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (i, item) {
					return _Utils_eq(i, index) ? updateFn(item) : item;
				}),
			items);
	});
var $author$project$Components$TeamForm$formFieldsUpdate = F3(
	function (today, field, fields) {
		switch (field.$) {
			case 0:
				var firstName = field.a;
				return _Utils_update(
					fields,
					{Pu: firstName});
			case 1:
				var lastName = field.a;
				return _Utils_update(
					fields,
					{SA: lastName});
			case 2:
				var email = field.a;
				return _Utils_update(
					fields,
					{Oo: email});
			case 3:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Wg: phone});
			case 4:
				var status = field.a;
				var prescriberType = A2($author$project$Components$TeamForm$calculateDefaultPrescriberType, fields.W_, status);
				return _Utils_update(
					fields,
					{
						W_: prescriberType,
						Xm: $elm$core$Maybe$Just(status)
					});
			case 5:
				var roleString = field.a;
				return _Utils_update(
					fields,
					{
						ac$: $author$project$Utils$EmrRole$fromString(roleString)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						UP: $author$project$Utils$String$toMaybe(string)
					});
			case 7:
				var prescriberTypeValue = field.a;
				var prescriberType = $elm$core$String$isEmpty(prescriberTypeValue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					$author$project$Api$Provider$PracticeOnboarding$PrescriberType$fromParam(prescriberTypeValue));
				return _Utils_update(
					fields,
					{W_: prescriberType});
			case 8:
				var dob = field.a;
				return _Utils_update(
					fields,
					{
						MR: $elm$core$Maybe$Just(dob)
					});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						No: $author$project$Utils$String$toMaybe(string)
					});
			case 10:
				var index = field.a;
				var value = field.b;
				return _Utils_update(
					fields,
					{
						w3: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{
										Gj: $author$project$Utils$String$toMaybe(value)
									});
							},
							fields.w3)
					});
			case 11:
				var index = field.a;
				var value = field.b;
				return _Utils_update(
					fields,
					{
						w3: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{
										sZ: $elm$core$Maybe$Just(value)
									});
							},
							fields.w3)
					});
			case 12:
				var index = field.a;
				var _v1 = field.b;
				var date = _v1.a;
				var model = _v1.b;
				return _Utils_update(
					fields,
					{
						w3: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{
										adc: _Utils_Tuple2(date, model)
									});
							},
							fields.w3)
					});
			case 13:
				var newExpiration = $author$project$Components$DateInput$initFromDate(today);
				return _Utils_update(
					fields,
					{
						w3: _Utils_ap(
							fields.w3,
							_List_fromArray(
								[
									{
									adc: _Utils_Tuple2($elm$core$Maybe$Nothing, newExpiration),
									Gj: $elm$core$Maybe$Nothing,
									sZ: $elm$core$Maybe$Nothing,
									bg: $author$project$Ui$NewDropdown$init(
										$author$project$Ui$NewDropdown$defaultConfig(
											{
												adR: 'dea-dropdown-' + $elm$core$String$fromInt(
													$elm$core$List$length(fields.w3)),
												ahx: $author$project$Components$TeamForm$DeaStateDropdownMsg(
													$elm$core$List$length(fields.w3))
											})),
									bC: ''
								}
								]))
					});
			case 14:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						w3: A2($author$project$Components$TeamForm$removeAt, index, fields.w3)
					});
			case 15:
				var index = field.a;
				var dropdown = field.b;
				return _Utils_update(
					fields,
					{
						w3: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{bg: dropdown});
							},
							fields.w3)
					});
			case 16:
				var index = field.a;
				var search = field.b;
				return _Utils_update(
					fields,
					{
						w3: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{bC: search});
							},
							fields.w3)
					});
			case 17:
				var index = field.a;
				var value = field.b;
				return _Utils_update(
					fields,
					{
						Cr: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{
										Gj: $author$project$Utils$String$toMaybe(value)
									});
							},
							fields.Cr)
					});
			case 18:
				var index = field.a;
				var value = field.b;
				return _Utils_update(
					fields,
					{
						Cr: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{
										sZ: $elm$core$Maybe$Just(value)
									});
							},
							fields.Cr)
					});
			case 19:
				var index = field.a;
				var _v2 = field.b;
				var date = _v2.a;
				var model = _v2.b;
				return _Utils_update(
					fields,
					{
						Cr: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{
										adc: _Utils_Tuple2(date, model)
									});
							},
							fields.Cr)
					});
			case 20:
				var newExpiration = $author$project$Components$DateInput$initFromDate(today);
				return _Utils_update(
					fields,
					{
						Cr: _Utils_ap(
							fields.Cr,
							_List_fromArray(
								[
									{
									adc: _Utils_Tuple2($elm$core$Maybe$Nothing, newExpiration),
									Gj: $elm$core$Maybe$Nothing,
									sZ: $elm$core$Maybe$Nothing,
									bg: $author$project$Ui$NewDropdown$init(
										$author$project$Ui$NewDropdown$defaultConfig(
											{
												adR: 'state-dropdown-' + $elm$core$String$fromInt(
													$elm$core$List$length(fields.Cr)),
												ahx: $author$project$Components$TeamForm$StateLicenseStateDropdownMsg(
													$elm$core$List$length(fields.Cr))
											})),
									bC: ''
								}
								]))
					});
			case 21:
				var index = field.a;
				return _Utils_update(
					fields,
					{
						Cr: A2($author$project$Components$TeamForm$removeAt, index, fields.Cr)
					});
			case 22:
				var index = field.a;
				var dropdown = field.b;
				return _Utils_update(
					fields,
					{
						Cr: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{bg: dropdown});
							},
							fields.Cr)
					});
			default:
				var index = field.a;
				var search = field.b;
				return _Utils_update(
					fields,
					{
						Cr: A3(
							$author$project$Components$TeamForm$updateItemAt,
							index,
							function (license) {
								return _Utils_update(
									license,
									{bC: search});
							},
							fields.Cr)
					});
		}
	});
var $author$project$Components$TeamForm$formFieldsUpdateWithCmd = F3(
	function (today, field, fields) {
		return _Utils_Tuple2(
			A3($author$project$Components$TeamForm$formFieldsUpdate, today, field, fields),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Utils$Form$updateWithCmd = F3(
	function (updater, field_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		var _v1 = A2(updater, field_, fields_);
		var updated = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_),
			cmd);
	});
var $author$project$Components$TeamForm$update = F3(
	function (msg, _v0, _v1) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v3 = A3(
					$author$project$Utils$Form$updateWithCmd,
					$author$project$Components$TeamForm$formFieldsUpdateWithCmd(model.$P),
					field,
					model.PB);
				var newForm = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$FormUpdated, cmd),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v4 = $author$project$Utils$Form$fields(model.PB);
				var phone = _v4.Wg;
				var _v5 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v5.a;
				var phoneCmd = _v5.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$TeamForm$formFieldsUpdate(model.$P),
					$author$project$Components$TeamForm$Phone(phoneInput),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$PhoneInputMsg, phoneCmd),
					_List_Nil);
			case 2:
				var index = msg.a;
				var subMsg = msg.b;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var license = A2(
					$elm$core$Maybe$withDefault,
					{
						adc: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
						Gj: $elm$core$Maybe$Nothing,
						sZ: $elm$core$Maybe$Nothing,
						bg: $author$project$Ui$NewDropdown$init(
							$author$project$Ui$NewDropdown$defaultConfig(
								{
									adR: 'dea-dropdown-' + $elm$core$String$fromInt(index),
									ahx: $author$project$Components$TeamForm$DeaStateDropdownMsg(index)
								})),
						bC: ''
					},
					$elm$core$List$head(
						A2($elm$core$List$drop, index, fields.w3)));
				var _v6 = license.adc;
				var prevValue = _v6.a;
				var prevInput = _v6.b;
				var _v7 = A2($author$project$Components$DateInput$update, subMsg, prevInput);
				var dateInput = _v7.a;
				var dateInputCmd = _v7.b;
				var event = _v7.c;
				var newValue = function () {
					if (event.$ === 1) {
						var date = event.a;
						return date;
					} else {
						return prevValue;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$TeamForm$formFieldsUpdate(model.$P),
								A2(
									$author$project$Components$TeamForm$DeaExpirationAt,
									index,
									_Utils_Tuple2(newValue, dateInput)),
								model.PB)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$TeamForm$MultiDeaExpirationMsg(index),
						dateInputCmd),
					_List_Nil);
			case 3:
				var index = msg.a;
				var dropdownMsg = msg.b;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var license = A2(
					$elm$core$Maybe$withDefault,
					{
						adc: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
						Gj: $elm$core$Maybe$Nothing,
						sZ: $elm$core$Maybe$Nothing,
						bg: $author$project$Ui$NewDropdown$init(
							$author$project$Ui$NewDropdown$defaultConfig(
								{
									adR: 'dea-dropdown-' + $elm$core$String$fromInt(index),
									ahx: $author$project$Components$TeamForm$DeaStateDropdownMsg(index)
								})),
						bC: ''
					},
					$elm$core$List$head(
						A2($elm$core$List$drop, index, fields.w3)));
				var _v9 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, license.bg);
				var newDropdown = _v9.a;
				var dropdownCmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$TeamForm$formFieldsUpdate(model.$P),
								A2($author$project$Components$TeamForm$DeaStateDropdownAt, index, newDropdown),
								model.PB)
						}),
					dropdownCmd,
					_List_Nil);
			case 4:
				var index = msg.a;
				var subMsg = msg.b;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var license = A2(
					$elm$core$Maybe$withDefault,
					{
						adc: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
						Gj: $elm$core$Maybe$Nothing,
						sZ: $elm$core$Maybe$Nothing,
						bg: $author$project$Ui$NewDropdown$init(
							$author$project$Ui$NewDropdown$defaultConfig(
								{
									adR: 'state-dropdown-' + $elm$core$String$fromInt(index),
									ahx: $author$project$Components$TeamForm$StateLicenseStateDropdownMsg(index)
								})),
						bC: ''
					},
					$elm$core$List$head(
						A2($elm$core$List$drop, index, fields.Cr)));
				var _v10 = license.adc;
				var prevValue = _v10.a;
				var prevInput = _v10.b;
				var _v11 = A2($author$project$Components$DateInput$update, subMsg, prevInput);
				var dateInput = _v11.a;
				var dateInputCmd = _v11.b;
				var event = _v11.c;
				var newValue = function () {
					if (event.$ === 1) {
						var date = event.a;
						return date;
					} else {
						return prevValue;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$TeamForm$formFieldsUpdate(model.$P),
								A2(
									$author$project$Components$TeamForm$StateLicenseExpirationAt,
									index,
									_Utils_Tuple2(newValue, dateInput)),
								model.PB)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$TeamForm$StateLicenseExpirationMsg(index),
						dateInputCmd),
					_List_Nil);
			case 5:
				var index = msg.a;
				var dropdownMsg = msg.b;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var license = A2(
					$elm$core$Maybe$withDefault,
					{
						adc: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
						Gj: $elm$core$Maybe$Nothing,
						sZ: $elm$core$Maybe$Nothing,
						bg: $author$project$Ui$NewDropdown$init(
							$author$project$Ui$NewDropdown$defaultConfig(
								{
									adR: 'state-dropdown-' + $elm$core$String$fromInt(index),
									ahx: $author$project$Components$TeamForm$StateLicenseStateDropdownMsg(index)
								})),
						bC: ''
					},
					$elm$core$List$head(
						A2($elm$core$List$drop, index, fields.Cr)));
				var _v13 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, license.bg);
				var newDropdown = _v13.a;
				var dropdownCmd = _v13.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: A3(
								$author$project$Utils$Form$update,
								$author$project$Components$TeamForm$formFieldsUpdate(model.$P),
								A2($author$project$Components$TeamForm$StateLicenseStateDropdownAt, index, newDropdown),
								model.PB)
						}),
					dropdownCmd,
					_List_Nil);
			default:
				var dropdownMsg = msg.a;
				var _v14 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.qr);
				var newDropdown = _v14.a;
				var dropdownCmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qr: newDropdown}),
					dropdownCmd,
					_List_Nil);
		}
	});
var $author$project$Components$TeamForm$EmailValidation = 10;
var $author$project$Components$TeamForm$PhoneValidation = 11;
var $author$project$Components$TeamForm$DateOfBirthValidation = 2;
var $author$project$Components$TeamForm$datePattern = $agustinrhcp$elm_mask$Mask$fromString('##/##/####');
var $author$project$Components$TeamForm$validateDateOfBirth = F2(
	function (requiresDOB, _v0) {
		var dateOfBirth = _v0.MR;
		if (dateOfBirth.$ === 1) {
			return requiresDOB ? _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please enter a valid date of birth.')
				]) : _List_Nil;
		} else {
			var dob = dateOfBirth.a;
			var _v2 = $author$project$Utils$Date$fromUsString(
				A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$TeamForm$datePattern, dob));
			if (_v2.$ === 1) {
				return _List_fromArray(
					[
						_Utils_Tuple2(2, '')
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$TeamForm$DeaValidation = 6;
var $author$project$Components$TeamForm$deaNumberValid = function (deaNumber) {
	var remainingChars = A3($elm$core$String$slice, 2, 9, deaNumber);
	var firstChar = A2($elm$core$String$left, 1, deaNumber);
	var isFirstCharLetter = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$isAlpha,
			$elm$core$List$head(
				$elm$core$String$toList(firstChar))));
	var areRemainingCharsNumbers = A2(
		$elm$core$List$all,
		$elm$core$Char$isDigit,
		$elm$core$String$toList(remainingChars));
	return ($elm$core$String$length(deaNumber) >= 9) && (isFirstCharLetter && areRemainingCharsNumbers);
};
var $author$project$Utils$String$isMaybeNotBlank = function (maybeString) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Utils$String$notBlank, maybeString));
};
var $author$project$Components$TeamForm$validateLicenseFields = function (_v0) {
	var number = _v0.Gj;
	var state = _v0.sZ;
	var expiration = _v0.adc;
	var today = _v0.$P;
	var validationGroup = _v0.dj;
	var numberValidator = _v0.Gk;
	var licenseType = _v0.FY;
	var skipIfEmpty = _v0.He;
	var hasState = $author$project$Utils$String$isMaybeNotBlank(state);
	var hasNumber = $author$project$Utils$String$isMaybeNotBlank(number);
	var hasExpiration = !_Utils_eq(expiration, $elm$core$Maybe$Nothing);
	var anyFieldFilled = hasNumber || (hasState || hasExpiration);
	if (skipIfEmpty && (!anyFieldFilled)) {
		return _List_Nil;
	} else {
		var missingFieldErrors = (!(hasNumber && (hasState && hasExpiration))) ? _List_fromArray(
			[
				_Utils_Tuple2(validationGroup, 'Please complete all ' + (licenseType + ' fields.'))
			]) : _List_Nil;
		var formatErrors = function () {
			if (!number.$) {
				var licenseNumber = number.a;
				var _v3 = numberValidator(licenseNumber);
				if (!_v3.$) {
					var errorMsg = _v3.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(validationGroup, errorMsg)
						]);
				} else {
					return _List_Nil;
				}
			} else {
				return _List_Nil;
			}
		}();
		var expirationErrors = function () {
			if (!expiration.$) {
				var date = expiration.a;
				return A2($author$project$Utils$Date$isBefore, date, today) ? _List_fromArray(
					[
						_Utils_Tuple2(
						validationGroup,
						$elm$core$String$toUpper(licenseType) + ' expiration date cannot be in the past.')
					]) : _List_Nil;
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_ap(
			missingFieldErrors,
			_Utils_ap(formatErrors, expirationErrors));
	}
};
var $author$project$Components$TeamForm$validateDeaNumbers = F3(
	function (allowsDea, today, fields) {
		if (allowsDea && _Utils_eq(
			fields.W_,
			$elm$core$Maybe$Just(0))) {
			var numberValidator = function (deaNumber) {
				return (!$author$project$Components$TeamForm$deaNumberValid(deaNumber)) ? $elm$core$Maybe$Just('Please enter a valid DEA number in the format AB1234567.') : $elm$core$Maybe$Nothing;
			};
			return A2(
				$elm$core$List$concatMap,
				function (license) {
					return $author$project$Components$TeamForm$validateLicenseFields(
						{adc: license.adc.a, FY: 'DEA', Gj: license.Gj, Gk: numberValidator, He: true, sZ: license.sZ, $P: today, dj: 6});
				},
				fields.w3);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$TeamForm$DegreeValidation = 5;
var $author$project$Components$TeamForm$validateDegree = F2(
	function (requiresDegree, fields) {
		if (requiresDegree && _Utils_eq(
			fields.W_,
			$elm$core$Maybe$Just(0))) {
			var _v0 = A2($elm$core$Maybe$withDefault, '', fields.No);
			if (_v0 === '') {
				return _List_fromArray(
					[
						_Utils_Tuple2(5, 'Please enter your degree.')
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$TeamForm$EmrRoleValidation = 4;
var $author$project$Components$TeamForm$validateEmrRole = F2(
	function (requiresEmrRole, fields) {
		return (requiresEmrRole && $author$project$Utils$Maybe$isNothing(fields.ac$)) ? _List_fromArray(
			[
				_Utils_Tuple2(4, 'Please select an EMR role.')
			]) : _List_Nil;
	});
var $author$project$Components$TeamForm$FirstNameValidation = 8;
var $author$project$Components$TeamForm$validateFirstName = function (fields) {
	return $elm$core$String$isEmpty(fields.Pu) ? _List_fromArray(
		[
			_Utils_Tuple2(8, 'First name is required.')
		]) : _List_Nil;
};
var $author$project$Components$TeamForm$LastNameValidation = 9;
var $author$project$Components$TeamForm$validateLastName = function (fields) {
	return $elm$core$String$isEmpty(fields.SA) ? _List_fromArray(
		[
			_Utils_Tuple2(9, 'Last name is required.')
		]) : _List_Nil;
};
var $author$project$Components$TeamForm$NpiValidation = 1;
var $author$project$Components$TeamForm$npiPrefix = '80840';
var $author$project$Components$TeamForm$validateNpi = function (fields) {
	var npiValidationMessage = _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please enter a valid NPI number.')
		]);
	var _v0 = fields.UP;
	if (!_v0.$) {
		var npi = _v0.a;
		return (($elm$core$String$length(npi) === 10) && $ahstro$elm_luhn$Luhn$isValid(
			_Utils_ap($author$project$Components$TeamForm$npiPrefix, npi))) ? _List_Nil : npiValidationMessage;
	} else {
		var requiresNpi = function () {
			var _v1 = fields.Xm;
			if (!_v1.$) {
				switch (_v1.a) {
					case 0:
						var _v2 = _v1.a;
						return true;
					case 1:
						var _v3 = _v1.a;
						return true;
					default:
						var _v4 = _v1.a;
						return false;
				}
			} else {
				return false;
			}
		}();
		return requiresNpi ? npiValidationMessage : _List_Nil;
	}
};
var $author$project$Components$TeamForm$PrescriberTypeValidation = 0;
var $author$project$Components$TeamForm$validatePrescriberType = F2(
	function (requiresPrescriberType, fields) {
		var _v0 = fields.W_;
		if (!_v0.$) {
			return _List_Nil;
		} else {
			return requiresPrescriberType ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please choose a prescriber type.')
				]) : _List_Nil;
		}
	});
var $author$project$Components$TeamForm$ProviderStatusValidation = 3;
var $author$project$Components$TeamForm$validateProviderStatus = function (fields) {
	var _v0 = fields.Xm;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please select a care provider status.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$TeamForm$StateLicenseValidation = 7;
var $author$project$Components$TeamForm$validateStateLicenseFields = function (_v0) {
	var number = _v0.Gj;
	var state = _v0.sZ;
	var expiration = _v0.adc;
	var today = _v0.$P;
	var isAlphanumeric = function (str) {
		return A2(
			$elm$core$String$all,
			function (_char) {
				return $elm$core$Char$isAlphaNum(_char);
			},
			str);
	};
	var numberValidator = function (licenseNumber) {
		return (!isAlphanumeric(licenseNumber)) ? $elm$core$Maybe$Just('State license numbers must contain only letters and numbers.') : $elm$core$Maybe$Nothing;
	};
	return $author$project$Components$TeamForm$validateLicenseFields(
		{adc: expiration, FY: 'state license', Gj: number, Gk: numberValidator, He: false, sZ: state, $P: today, dj: 7});
};
var $author$project$Components$TeamForm$validateStateLicense = F3(
	function (requiresLicense, today, fields) {
		return (requiresLicense && _Utils_eq(
			fields.W_,
			$elm$core$Maybe$Just(0))) ? ($elm$core$List$isEmpty(fields.Cr) ? _List_fromArray(
			[
				_Utils_Tuple2(7, 'Please add at least one state license.')
			]) : A2(
			$elm$core$List$concatMap,
			function (license) {
				return $author$project$Components$TeamForm$validateStateLicenseFields(
					{adc: license.adc.a, Gj: license.Gj, sZ: license.sZ, $P: today});
			},
			fields.Cr)) : _List_Nil;
	});
var $author$project$Components$TeamForm$formFieldsValidator = F3(
	function (usingClinicalEmr, isOnboarding, today) {
		var validatePhone = function (_v0) {
			var phone = _v0.Wg;
			return ($author$project$Components$PhoneInput$hasErrors(phone) && usingClinicalEmr) ? _List_fromArray(
				[
					_Utils_Tuple2(11, '')
				]) : _List_Nil;
		};
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateFirstName),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateLastName),
					A3(
					$author$project$Utils$Validate$ifInvalidEmail,
					{abh: false},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Oo;
						},
						$elm$core$Maybe$Just),
					_Utils_Tuple2(10, 'Please enter a valid email')),
					$rtfeldman$elm_validate$Validate$fromErrors(validatePhone),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$TeamForm$validateDateOfBirth(usingClinicalEmr)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateProviderStatus),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$TeamForm$validatePrescriberType(usingClinicalEmr)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateNpi),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$TeamForm$validateEmrRole(usingClinicalEmr && (!isOnboarding))),
					$rtfeldman$elm_validate$Validate$fromErrors(
					$author$project$Components$TeamForm$validateDegree(usingClinicalEmr)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$TeamForm$validateDeaNumbers, usingClinicalEmr, today)),
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$TeamForm$validateStateLicense, usingClinicalEmr, today))
				]));
	});
var $author$project$Components$TeamForm$validate = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	var form_ = A2(
		$author$project$Utils$Form$set,
		_Utils_update(
			fields,
			{
				Wg: $author$project$Components$PhoneInput$validate(fields.Wg)
			}),
		model.PB);
	return A2(
		$elm$core$Result$mapError,
		function (validatedForm) {
			return _Utils_update(
				model,
				{PB: validatedForm});
		},
		A2(
			$elm$core$Result$map,
			function (_v1) {
				var validatedForm = _v1.a;
				var validFormFields = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{PB: validatedForm}),
					validFormFields);
			},
			A2(
				$author$project$Utils$Form$validate,
				A3($author$project$Components$TeamForm$formFieldsValidator, model.di, model.aJ, model.$P),
				form_)));
};
var $author$project$Pages$Admin$Team$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$TeamForm$update, subMsg, model.PB, model.D5);
				var teamFormModel = _v1.a;
				var teamFormCmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: teamFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$New$TeamFormMsg, teamFormCmd),
					outMsgs);
			case 1:
				var _v2 = $author$project$Components$TeamForm$validate(model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var validFormFields = _v3.b;
					return $author$project$Pages$Admin$Team$New$shouldFetchProductPricing(validFormFields) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm}),
						$author$project$Pages$Admin$Team$New$fetchProductPricing(model),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$Team$New$createTeamMember, model, validFormFields),
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var _v4 = $author$project$Components$TeamForm$validate(model.PB);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var validatedForm = _v5.a;
					var validFormFields = _v5.b;
					return model.abc ? _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Admin$Team$New$createTeamMember, model, validFormFields),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var erroredForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: erroredForm, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Team member created successfully')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{abc: value}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var pricing = response.a;
					if ($author$project$Api$Provider$PracticePricing$Product$requiresPayment(pricing)) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									nF: $author$project$Api$Provider$PracticePricing$Product$priceInCents(pricing),
									nM: response,
									on: true
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var _v8 = $author$project$Components$TeamForm$validate(model.PB);
						if (!_v8.$) {
							var _v9 = _v8.a;
							var validatedForm = _v9.a;
							var validFormFields = _v9.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										PB: validatedForm,
										nF: $author$project$Api$Provider$PracticePricing$Product$priceInCents(pricing),
										nM: response,
										jY: $author$project$Api$Data$Loading,
										on: false
									}),
								A2($author$project$Pages$Admin$Team$New$createTeamMember, model, validFormFields),
								_List_Nil);
						} else {
							var erroredForm = _v8.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{PB: erroredForm, nM: response}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						}
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nM: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'New team members cannot be added at this time. Please reach out to our Customer Success team to learn more.')
							]));
				}
		}
	});
var $author$project$Pages$Admin$Team$New$CreateTeamMember = {$: 2};
var $author$project$Pages$Admin$Team$New$FormSubmitted = {$: 1};
var $author$project$Components$TeamForm$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$TeamForm$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$TeamForm$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Group$Invalid = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$Group$invalid = $author$project$Ui$Form$Group$Invalid;
var $author$project$Components$TeamForm$FullTimeProvider = 0;
var $author$project$Components$TeamForm$NonProvider = 2;
var $author$project$Components$TeamForm$PartTimeProvider = 1;
var $author$project$Components$TeamForm$ProviderStatus = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$TeamForm$viewCareProviderStatusSelection = F2(
	function (form, fields) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Care Provider Status'),
					$author$project$Ui$Form$Group$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 3, form))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(
											_Utils_eq(
												fields.Xm,
												$elm$core$Maybe$Just(0))),
											$author$project$Ui$Form$Radio$inline,
											$author$project$Ui$Form$Radio$onCheck(
											function (_v0) {
												return $author$project$Components$TeamForm$FormUpdated(
													$author$project$Components$TeamForm$ProviderStatus(0));
											})
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[
													$author$project$Ui$Typography$margin(0)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Full-Time Provider')
												])),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sees patients 3 or more days a week')
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(
											_Utils_eq(
												fields.Xm,
												$elm$core$Maybe$Just(1))),
											$author$project$Ui$Form$Radio$inline,
											$author$project$Ui$Form$Radio$onCheck(
											function (_v1) {
												return $author$project$Components$TeamForm$FormUpdated(
													$author$project$Components$TeamForm$ProviderStatus(1));
											})
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[
													$author$project$Ui$Typography$margin(0)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Part-Time Provider')
												])),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sees patients less than 3 days a week')
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(
											_Utils_eq(
												fields.Xm,
												$elm$core$Maybe$Just(2))),
											$author$project$Ui$Form$Radio$inline,
											$author$project$Ui$Form$Radio$onCheck(
											function (_v2) {
												return $author$project$Components$TeamForm$FormUpdated(
													$author$project$Components$TeamForm$ProviderStatus(2));
											})
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Not a Provider')
												]))
										]))
								]))
						])),
					A2($author$project$Utils$Form$hasValidationErrors, 3, form) ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' ',
								A2($author$project$Utils$Form$validationErrors, 3, form)))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$TeamForm$AddDea = {$: 13};
var $author$project$Components$TeamForm$DeaNumberAt = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$TeamForm$DeaStateAt = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$TeamForm$DeaStateSearchAt = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$TeamForm$RemoveDea = function (a) {
	return {$: 14, a: a};
};
var $author$project$Utils$State$codes = A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Utils$State$list);
var $author$project$Components$DateInput$Position = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$DateInput$above = $author$project$Components$DateInput$Position(1);
var $author$project$Components$DateInput$Placeholder = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$DateInput$placeholder = $author$project$Components$DateInput$Placeholder;
var $author$project$Components$TeamForm$viewExpirationDateInput = function (_v0) {
	var placeholder = _v0.r4;
	var value = _v0.aaN;
	var dateInputModel = _v0.EV;
	var today = _v0.$P;
	var hasValidationErrors = _v0.Fw;
	var toMsg = _v0.ahx;
	return A2(
		$elm$html$Html$map,
		toMsg,
		A2(
			$author$project$Components$DateInput$view,
			_List_fromArray(
				[
					$author$project$Components$DateInput$placeholder(placeholder),
					$author$project$Components$DateInput$value(value),
					$author$project$Components$DateInput$above,
					$author$project$Components$DateInput$disabledPickerDates(
					function (date) {
						return A2($author$project$Utils$Date$isBefore, date, today);
					}),
					$author$project$Components$DateInput$invalid(hasValidationErrors)
				]),
			dateInputModel));
};
var $author$project$Components$TeamForm$viewLicenseRow = F5(
	function (config, form, today, index, license) {
		var toStateOption = function (abbr) {
			return A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$TeamForm$FormUpdated(
							A2(config.zQ, index, abbr))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							license.sZ,
							$elm$core$Maybe$Just(abbr)))
					]),
				$elm$html$Html$text(abbr));
		};
		var searchInput = $author$project$Ui$NewDropdown$input(
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onInput(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Components$TeamForm$FormUpdated,
						config.zP(index))),
					$author$project$Ui$NewDropdown$value(license.bC),
					$author$project$Ui$NewDropdown$placeholder('Search states...')
				]));
		var inputAttributes = A2(
			$elm$core$List$cons,
			$author$project$Ui$Form$Input$value(
				A2($elm$core$Maybe$withDefault, '', license.Gj)),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Input$onInput(
					A2(
						$elm$core$Basics$composeL,
						$author$project$Components$TeamForm$FormUpdated,
						config.zM(index))),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$placeholder(config.zD),
					config.ya ? _List_fromArray(
						[
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, config.dj, form))
						]) : _List_Nil)));
		var contains = function (state) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(license.bC),
				$elm$core$String$toLower(state));
		};
		var filteredStates = A2($elm$core$List$filter, contains, $author$project$Utils$State$codes);
		var dropdownOptions = A2(
			$elm$core$List$cons,
			searchInput,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2($elm$core$List$map, toStateOption, filteredStates)));
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(inputAttributes)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Ui$NewDropdown$viewSelect,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, config.dj, form))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, 'State', license.sZ))
								]),
							dropdownOptions,
							license.bg)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(5)
						]),
					_List_fromArray(
						[
							(index > 0) ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mr2, $author$project$Ui$Element$flexAuto]),
									_List_fromArray(
										[
											$author$project$Components$TeamForm$viewExpirationDateInput(
											{
												EV: license.adc.b,
												Fw: A2($author$project$Utils$Form$hasValidationErrors, config.dj, form),
												r4: 'Expiration Date',
												ahx: config.qA(index),
												$P: today,
												aaN: license.adc.a
											})
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: config.Br},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Components$TeamForm$FormUpdated(
												config.zO(index))),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
											$author$project$Ui$Button$margin(11),
											$author$project$Ui$Button$link
										]),
									_List_Nil)
								])) : $author$project$Components$TeamForm$viewExpirationDateInput(
							{
								EV: license.adc.b,
								Fw: A2($author$project$Utils$Form$hasValidationErrors, config.dj, form),
								r4: 'Expiration Date',
								ahx: config.qA(index),
								$P: today,
								aaN: license.adc.a
							})
						]))
				]));
	});
var $author$project$Components$TeamForm$viewDeaRow = F4(
	function (form, today, index, license) {
		return A5(
			$author$project$Components$TeamForm$viewLicenseRow,
			{qA: $author$project$Components$TeamForm$MultiDeaExpirationMsg, ya: true, zD: 'AB1234567', zM: $author$project$Components$TeamForm$DeaNumberAt, zO: $author$project$Components$TeamForm$RemoveDea, zP: $author$project$Components$TeamForm$DeaStateSearchAt, zQ: $author$project$Components$TeamForm$DeaStateAt, Br: 'Remove DEA', dj: 6},
			form,
			today,
			index,
			license);
	});
var $author$project$Components$TeamForm$viewDeaFields = F4(
	function (usingClinicalEmr, form, fields, today) {
		var showDea = _Utils_eq(
			fields.W_,
			$elm$core$Maybe$Just(0));
		return (usingClinicalEmr && showDea) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$label('DEA Number'),
					$author$project$Ui$Form$Group$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 6, form))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A2($author$project$Components$TeamForm$viewDeaRow, form, today),
						fields.w3)),
					A2($author$project$Utils$Form$hasValidationErrors, 6, form) ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' ',
								A2($author$project$Utils$Form$validationErrors, 6, form)))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[
							$author$project$Ui$Typography$margin(8)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add another DEA Number'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$AddDea)),
									$author$project$Ui$Button$link
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add another DEA number')
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$TeamForm$Degree = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$TeamForm$viewDegreeField = F3(
	function (usingClinicalEmr, form, fields) {
		var showDegree = _Utils_eq(
			fields.W_,
			$elm$core$Maybe$Just(0));
		return (usingClinicalEmr && showDegree) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Degree')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.No)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$Degree)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 5, form))
						])),
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('This information will appear with e-signatures exactly as entered.')
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$TeamForm$DateOfBirth = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$TeamForm$viewDobField = F3(
	function (usingClinicalEmr, form, fields) {
		return usingClinicalEmr ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$label('Date of Birth'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
							A2(
							$author$project$Ui$Form$Input$maskedValue,
							$author$project$Components$TeamForm$datePattern,
							A2($elm$core$Maybe$withDefault, '', fields.MR)),
							A3(
							$author$project$Ui$Form$Input$onMaskedInput,
							$author$project$Components$TeamForm$datePattern,
							A2($elm$core$Maybe$withDefault, '', fields.MR),
							A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$DateOfBirth)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 2, form))
						])),
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$helpText, $author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('Date of birth is required for access to prescription information.')
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$TeamForm$EmrRole = function (a) {
	return {$: 5, a: a};
};
var $author$project$Utils$EmrRole$all = _List_fromArray(
	[0, 1, 2]);
var $author$project$Utils$EmrRole$toDisplayString = function (role) {
	switch (role) {
		case 0:
			return 'Admin';
		case 1:
			return 'Provider';
		default:
			return 'Staff';
	}
};
var $author$project$Components$TeamForm$viewEmrRoleField = F4(
	function (isOnboarding, form, fields, emrRoleDropdown) {
		if (!isOnboarding) {
			var selectedRole = A2(
				$elm$core$Maybe$withDefault,
				'Select a role',
				A2($elm$core$Maybe$map, $author$project$Utils$EmrRole$toDisplayString, fields.ac$));
			var roleOptions = A2(
				$elm$core$List$map,
				function (role) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$TeamForm$FormUpdated(
									$author$project$Components$TeamForm$EmrRole(
										$author$project$Utils$EmrRole$toString(role))))
							]),
						$elm$html$Html$text(
							$author$project$Utils$EmrRole$toDisplayString(role)));
				},
				$author$project$Utils$EmrRole$all);
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(2),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label('EMR Role'),
						$author$project$Ui$Form$Group$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 4, form))
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$NewDropdown$viewSelect,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 4, form))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(selectedRole)
							]),
						roleOptions,
						emrRoleDropdown),
						A2($author$project$Utils$Form$hasValidationErrors, 4, form) ? A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$danger]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$String$join,
									' ',
									A2($author$project$Utils$Form$validationErrors, 4, form)))
							])) : $author$project$Utils$Html$empty
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$TeamForm$Npi = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$TeamForm$viewNpiField = F2(
	function (form, fields) {
		var showNpi = function () {
			var _v0 = fields.Xm;
			if (!_v0.$) {
				if (_v0.a === 2) {
					var _v1 = _v0.a;
					return false;
				} else {
					return true;
				}
			} else {
				return false;
			}
		}();
		return showNpi ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('NPI')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.UP)),
							$author$project$Ui$Form$Input$placeholder('1234567890'),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$Npi)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$TeamForm$PrescriberTypeField = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$list = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toString = function (prescriberType) {
	switch (prescriberType) {
		case 0:
			return 'Prescriber';
		case 1:
			return 'Prescribe on Behalf of (No Review Required, Non-Controlled Substances Only)';
		case 2:
			return 'Prescribe on Behalf of (Review Required, Non-Controlled Substances Only)';
		default:
			return 'Staff';
	}
};
var $author$project$Components$TeamForm$prescriberTypeOptions = function (currentProviderStatus) {
	var options = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Api$Provider$PracticeOnboarding$PrescriberType$list,
		A2(
			$elm$core$Maybe$map,
			function (providerStatus) {
				return (providerStatus === 2) ? A2(
					$elm$core$List$filter,
					function (prescriberType) {
						return !$author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider(prescriberType);
					},
					$author$project$Api$Provider$PracticeOnboarding$PrescriberType$list) : $author$project$Api$Provider$PracticeOnboarding$PrescriberType$list;
			},
			currentProviderStatus));
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Select a Prescriber Type'),
		A2(
			$elm$core$List$map,
			function (prescriberType) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam(prescriberType)),
					$author$project$Api$Provider$PracticeOnboarding$PrescriberType$toString(prescriberType));
			},
			options));
};
var $author$project$Components$TeamForm$viewPrescriberTypeField = F3(
	function (usingClinicalEmr, form, fields) {
		var providerStatusSelected = function () {
			var _v0 = fields.Xm;
			if (!_v0.$) {
				return true;
			} else {
				return false;
			}
		}();
		if (usingClinicalEmr && providerStatusSelected) {
			var prescriberTypeValue = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam, fields.W_));
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(2),
						$author$project$Ui$Form$Group$required(usingClinicalEmr),
						$author$project$Ui$Form$Group$label('Prescriber Type')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(prescriberTypeValue)),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$PrescriberTypeField)),
								$author$project$Ui$Form$Select$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Select$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]),
						$author$project$Components$TeamForm$prescriberTypeOptions(fields.Xm))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$TeamForm$AddStateLicense = {$: 20};
var $author$project$Components$TeamForm$RemoveStateLicense = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$TeamForm$StateLicenseNumberAt = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$TeamForm$StateLicenseStateAt = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$TeamForm$StateLicenseStateSearchAt = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Components$TeamForm$viewStateLicenseRow = F4(
	function (form, today, index, license) {
		return A5(
			$author$project$Components$TeamForm$viewLicenseRow,
			{qA: $author$project$Components$TeamForm$StateLicenseExpirationMsg, ya: false, zD: 'A12345', zM: $author$project$Components$TeamForm$StateLicenseNumberAt, zO: $author$project$Components$TeamForm$RemoveStateLicense, zP: $author$project$Components$TeamForm$StateLicenseStateSearchAt, zQ: $author$project$Components$TeamForm$StateLicenseStateAt, Br: 'Remove state license', dj: 7},
			form,
			today,
			index,
			license);
	});
var $author$project$Components$TeamForm$viewStateLicenseFields = F4(
	function (usingClinicalEmr, form, fields, today) {
		var showStateLicense = _Utils_eq(
			fields.W_,
			$elm$core$Maybe$Just(0));
		return (usingClinicalEmr && showStateLicense) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(2),
					$author$project$Ui$Form$Group$inputSpanSm(10),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('State License'),
					$author$project$Ui$Form$Group$invalid(
					A2($author$project$Utils$Form$hasValidationErrors, 7, form))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A2($author$project$Components$TeamForm$viewStateLicenseRow, form, today),
						fields.Cr)),
					A2($author$project$Utils$Form$hasValidationErrors, 7, form) ? A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$danger]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$String$join,
								' ',
								A2($author$project$Utils$Form$validationErrors, 7, form)))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[
							$author$project$Ui$Typography$margin(8)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add another state license'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$AddStateLicense)),
									$author$project$Ui$Button$link
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add another state license')
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$TeamForm$viewForm = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(2),
						$author$project$Ui$Form$Group$inputSpanSm(10),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label('Name'),
						$author$project$Ui$Form$Group$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 8, model.PB) || A2($author$project$Utils$Form$hasValidationErrors, 9, model.PB))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.Pu),
												$author$project$Ui$Form$Input$disabled(model.aJ),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 8, model.PB)),
												$author$project$Ui$Form$Input$onInput(
												function (newFirstName) {
													return $author$project$Components$TeamForm$FormUpdated(
														$author$project$Components$TeamForm$FirstName(newFirstName));
												}),
												$author$project$Ui$Form$Input$placeholder('First Name')
											])),
										A2($author$project$Utils$Form$hasValidationErrors, 8, model.PB) ? A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$danger]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$String$join,
													' ',
													A2($author$project$Utils$Form$validationErrors, 8, model.PB)))
											])) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.SA),
												$author$project$Ui$Form$Input$disabled(model.aJ),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 9, model.PB)),
												$author$project$Ui$Form$Input$onInput(
												function (newLastName) {
													return $author$project$Components$TeamForm$FormUpdated(
														$author$project$Components$TeamForm$LastName(newLastName));
												}),
												$author$project$Ui$Form$Input$placeholder('Last Name')
											])),
										A2($author$project$Utils$Form$hasValidationErrors, 9, model.PB) ? A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$danger]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$String$join,
													' ',
													A2($author$project$Utils$Form$validationErrors, 9, model.PB)))
											])) : $author$project$Utils$Html$empty
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(2),
						$author$project$Ui$Form$Group$inputSpanSm(10),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label('Email'),
						$author$project$Ui$Form$Group$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 10, model.PB))
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.Oo),
								$author$project$Ui$Form$Input$disabled(model.aJ),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 10, model.PB)),
								$author$project$Ui$Form$Input$onInput(
								function (newEmail) {
									return $author$project$Components$TeamForm$FormUpdated(
										$author$project$Components$TeamForm$Email(newEmail));
								})
							])),
						A2($author$project$Utils$Form$hasValidationErrors, 10, model.PB) ? A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$danger]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$String$join,
									' ',
									A2($author$project$Utils$Form$validationErrors, 10, model.PB)))
							])) : $author$project$Utils$Html$empty
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(2),
						$author$project$Ui$Form$Group$inputSpanSm(10),
						$author$project$Ui$Form$Group$required(model.di),
						$author$project$Ui$Form$Group$label('Phone'),
						$author$project$Ui$Form$Group$invalid(
						$author$project$Components$PhoneInput$hasErrors(fields.Wg))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$TeamForm$PhoneInputMsg,
						$author$project$Components$PhoneInput$view(fields.Wg))
					])),
				A3($author$project$Components$TeamForm$viewDobField, model.di, model.PB, fields),
				A2($author$project$Components$TeamForm$viewCareProviderStatusSelection, model.PB, fields),
				A4($author$project$Components$TeamForm$viewEmrRoleField, model.aJ, model.PB, fields, model.qr),
				A3($author$project$Components$TeamForm$viewPrescriberTypeField, model.di, model.PB, fields),
				A4($author$project$Components$TeamForm$viewStateLicenseFields, model.di, model.PB, fields, model.$P),
				A4($author$project$Components$TeamForm$viewDeaFields, model.di, model.PB, fields, model.$P),
				A3($author$project$Components$TeamForm$viewDegreeField, model.di, model.PB, fields),
				A2($author$project$Components$TeamForm$viewNpiField, model.PB, fields)
			]));
};
var $author$project$Components$TeamForm$view = function (_v0) {
	var model = _v0;
	return $author$project$Components$TeamForm$viewForm(model);
};
var $author$project$Ui$Margin$Bottom_10 = 4;
var $author$project$Ui$Element$m0 = $author$project$Ui$Element$Margin('m-0');
var $author$project$Ui$FlexGrid$m0 = $author$project$Ui$FlexGrid$Element($author$project$Ui$Element$m0);
var $author$project$Ui$HorizontalRule$Separator = 3;
var $author$project$Ui$HorizontalRule$separator = $author$project$Ui$HorizontalRule$Style(3);
var $author$project$Pages$Admin$Team$New$AgreedToTerms = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Admin$Team$New$viewAdditionalInfoFooter = A2(
	$author$project$Ui$Typography$p,
	_List_fromArray(
		[$author$project$Ui$Typography$muted]),
	_List_fromArray(
		[
			$elm$html$Html$text('Have any questions? '),
			A3(
			$author$project$Ui$Link$externalHref,
			'mailto:sales@hint.com',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Contact our sales team')
				])),
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(' or')
				])),
			A3(
			$author$project$Ui$Link$externalHref,
			'https://www.hint.com/clinical/pricing',
			_List_fromArray(
				[
					$author$project$Ui$Link$margin(11),
					$author$project$Ui$Link$targetBlank
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('view our pricing information')
				])),
			$elm$html$Html$text(' on our website.')
		]));
var $author$project$Pages$Admin$Team$New$viewConfirmationCheckbox = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.abc),
						$author$project$Ui$Form$Checkbox$required(true),
						$author$project$Ui$Form$Checkbox$onCheck(
						function (value) {
							return $author$project$Pages$Admin$Team$New$AgreedToTerms(value);
						})
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$flexMd]),
						_List_fromArray(
							[
								$elm$html$Html$text('I agree to these changes, subject to the previously agreed upon terms of service.'),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$danger]),
								_List_fromArray(
									[
										$elm$html$Html$text('*')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[
						$author$project$Ui$Typography$margin(8)
					]),
				_List_fromArray(
					[$author$project$Pages$Admin$Team$New$viewAdditionalInfoFooter]))
			]));
};
var $author$project$Pages$Admin$Team$New$viewPricing = function (model) {
	var _v0 = $author$project$Components$TeamForm$validate(model.PB);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var validFormFields = _v1.b;
		var fields = $author$project$Components$TeamForm$teamMemberFormFields(
			$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
		var clinicianName = fields.Pu + (' ' + fields.SA);
		return A3(
			$author$project$Ui$Element$custom,
			'h-[80vh]',
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$flexCol]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(7)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text('Add ' + clinicianName)
												]))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('You are at the clinician limit for your current plan.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(5),
									$author$project$Ui$FlexGrid$m0
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Alert$view,
									1,
									_List_fromArray(
										[
											$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanSm(9)
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Typography$headingSm(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Additional Clinician')
																		]))
																])),
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanSm(3),
																	$author$project$Ui$FlexGrid$justifyRight
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Typography$headingSm(
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Utils$Currency$fromIntNoDecimals(model.nF) + '/mo')
																		]))
																]))
														])),
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_fromArray(
														[$author$project$Ui$FlexGrid$mb4]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanSm(9)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_fromArray(
																		[$author$project$Ui$Typography$black]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Added to your next invoice')
																		])),
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_fromArray(
																		[
																			$author$project$Ui$Typography$black,
																			$author$project$Ui$Typography$margin(4)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Due today')
																		]))
																])),
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanSm(3)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_fromArray(
																		[
																			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Utils$Currency$fromInt(model.nF))
																		])),
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_fromArray(
																		[
																			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight),
																			$author$project$Ui$Typography$margin(4)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Utils$Currency$fromInt(0))
																		]))
																]))
														]))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											$author$project$Ui$HorizontalRule$view(
											_List_fromArray(
												[
													$author$project$Ui$HorizontalRule$margin(19),
													$author$project$Ui$HorizontalRule$separator
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Admin$Team$New$viewConfirmationCheckbox(model)
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Admin$Team$New$view = function (model) {
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Add Team Member')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										model.on ? $author$project$Pages$Admin$Team$New$viewPricing(model) : A2(
										$elm$html$Html$map,
										$author$project$Pages$Admin$Team$New$TeamFormMsg,
										$author$project$Components$TeamForm$view(model.PB))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										model.on ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Agree and save'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$New$CreateTeamMember),
														$author$project$Ui$Button$loading(loading),
														$author$project$Ui$Button$disabled(!model.abc)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Agree & Save')
													]))
											])) : A3(
										$author$project$Ui$Button$view,
										{abp: 'Save new team member'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(loading),
												$author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$New$FormSubmitted)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Save')
											]))
									]))
							]))
					]))
			]),
		$G: 'New Team Member'
	};
};
var $author$project$Pages$Admin$Team$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Admin$Team$New$init, aer: $author$project$Pages$Admin$Team$New$load, agD: $author$project$Pages$Admin$Team$New$save, ahd: $author$project$Pages$Admin$Team$New$subscriptions, aaq: $author$project$Pages$Admin$Team$New$update, ahP: $author$project$Pages$Admin$Team$New$view});
var $author$project$Pages$AffiliateBills$Top$BillsListMsg = $elm$core$Basics$identity;
var $author$project$Components$Affiliates$BillsList$DateRangeInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Affiliates$BillsList$GotNetwork = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Month = 2;
var $author$project$Utils$DateWithDefault$toDate = F3(
	function (currentDate, monthOffset, dateWithDefault) {
		var startOfMonth = A3(
			$justinmimbs$date$Date$add,
			1,
			monthOffset,
			A2($justinmimbs$date$Date$floor, 2, currentDate));
		switch (dateWithDefault.$) {
			case 0:
				var date = dateWithDefault.a;
				return date;
			case 1:
				return startOfMonth;
			default:
				return A3(
					$justinmimbs$date$Date$add,
					3,
					-1,
					A3($justinmimbs$date$Date$add, 1, 1, startOfMonth));
		}
	});
var $author$project$Utils$DateWithDefault$toQuery = F3(
	function (currentDate, monthOffset, dateWithDefault) {
		return $author$project$Utils$Date$toQuery(
			A3($author$project$Utils$DateWithDefault$toDate, currentDate, monthOffset, dateWithDefault));
	});
var $author$project$Components$Affiliates$BillsList$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(model.F_)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$DateRangeInput$defaultSettings = {
	kT: function (_v0) {
		return _List_Nil;
	},
	vm: false,
	wZ: _List_fromArray(
		[
			$author$project$Ui$FlexGrid$spanSm(4),
			$author$project$Ui$FlexGrid$span(6)
		]),
	adD: $elm$core$Maybe$Nothing,
	Fp: false,
	Fr: false,
	F9: 0,
	Ga: -11,
	ahu: $elm$core$Maybe$Nothing
};
var $author$project$Components$Affiliates$BillsList$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Affiliates$BillsList$GotAffiliateBills = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliate$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Affiliate$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$id(shared);
};
var $author$project$Api$Provider$AffiliateBill$affiliateBillsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['affiliate_bills']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$AffiliateBill$All$AffiliateBill = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$Shared$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$Min$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Invoice$Min$Record = F2(
	function (id, invoiceNumber) {
		return {adR: id, Rq: invoiceNumber};
	});
var $author$project$Api$Provider$Invoice$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice_number',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Min$Record)));
var $author$project$Api$Provider$Invoice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Invoice$Shared$Record = F7(
	function (invoiceDate, humanStatus, amountInCents, paidAt, paidInCents, dueInCents, dueDate) {
		return {I2: amountInCents, N1: dueDate, N2: dueInCents, QE: humanStatus, Rn: invoiceDate, Vt: paidAt, Vu: paidInCents};
	});
var $author$project$Api$Invoice$Status$BadDebt = {$: 4};
var $author$project$Api$Invoice$Status$Cancelled = {$: 5};
var $author$project$Api$Invoice$Status$Disputed = {$: 3};
var $author$project$Api$Invoice$Status$Draft = {$: 0};
var $author$project$Api$Invoice$Status$Issued = {$: 1};
var $author$project$Api$Invoice$Status$Other = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Invoice$Status$Overdue = {$: 6};
var $author$project$Api$Invoice$Status$Paid = {$: 2};
var $author$project$Api$Invoice$Status$Sent = {$: 8};
var $author$project$Api$Invoice$Status$Viewed = {$: 7};
var $author$project$Api$Invoice$Status$decode = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		switch (string) {
			case 'draft':
				return $author$project$Api$Invoice$Status$Draft;
			case 'issued':
				return $author$project$Api$Invoice$Status$Issued;
			case 'paid':
				return $author$project$Api$Invoice$Status$Paid;
			case 'disputed':
				return $author$project$Api$Invoice$Status$Disputed;
			case 'bad_debt':
				return $author$project$Api$Invoice$Status$BadDebt;
			case 'cancelled':
				return $author$project$Api$Invoice$Status$Cancelled;
			case 'overdue':
				return $author$project$Api$Invoice$Status$Overdue;
			case 'viewed':
				return $author$project$Api$Invoice$Status$Viewed;
			case 'sent':
				return $author$project$Api$Invoice$Status$Sent;
			default:
				return $author$project$Api$Invoice$Status$Other(string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Invoice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'due_date',
	$author$project$Utils$Date$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'paid_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paid_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'human_status',
						$author$project$Api$Invoice$Status$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'invoice_date',
							$author$project$Utils$Date$decode,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Shared$Record))))))));
var $author$project$Api$Provider$Invoice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Shared$Invoice)));
var $author$project$Api$Provider$AffiliateBill$All$Record = F4(
	function (numberOfDependents, numberOfEmployees, affiliate, practice) {
		return {DZ: affiliate, UR: numberOfDependents, US: numberOfEmployees, WF: practice};
	});
var $author$project$Api$Provider$Affiliate$Shared$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliate$Shared$Record = F3(
	function (id, name, status) {
		return {adR: id, zh: name, ag7: status};
	});
var $author$project$Api$Provider$Affiliate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$Shared$Record))));
var $author$project$Api$Provider$Affiliate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateBill$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Provider$Practice$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'affiliate',
		$author$project$Api$Provider$Affiliate$Shared$decoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
			_List_fromArray(
				['summary', 'active_lines', 'totals', 'count']),
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
				_List_fromArray(
					['summary', 'active_lines', 'totals', 'number_of_dependents']),
				$elm$json$Json$Decode$int,
				0,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateBill$All$Record)))));
var $author$project$Api$Provider$AffiliateBill$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateBill$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateBill$All$AffiliateBill)));
var $author$project$Api$Param$Date = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$Param$date = $author$project$Api$Param$Date;
var $author$project$Api$Provider$AffiliateBill$listDefaults = {DZ: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$AffiliateBill$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$AffiliateBill$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.DZ;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'affiliate', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Hl;
				if (!_v1.$) {
					var start_ = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'start', start_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.E9;
				if (!_v2.$) {
					var end_ = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'end', end_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$AffiliateBill$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateBill$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$AffiliateBill$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$AffiliateBill$affiliateBillsPath)));
	});
var $author$project$Components$Affiliates$BillsList$fetchAffiliateBills = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$AffiliateBill$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						DZ: A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliate$One$id, model.DZ),
						E9: A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
							model.E9),
						afy: model.afy,
						ag1: model.ag1,
						Hl: A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
							model.Hl)
					});
			},
			$author$project$Components$Affiliates$BillsList$GotAffiliateBills);
	});
var $author$project$Utils$DateWithDefault$DefaultEnd = {$: 2};
var $author$project$Utils$DateWithDefault$Date = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Date$fromIsoString = function (string) {
	return $elm$core$Result$toMaybe(
		$justinmimbs$date$Date$fromIsoString(string));
};
var $author$project$Utils$DateWithDefault$fromString = F2(
	function (_default, string) {
		if (string === 'default') {
			return $elm$core$Maybe$Just(_default);
		} else {
			return A2(
				$elm$core$Maybe$map,
				$author$project$Utils$DateWithDefault$Date,
				$author$project$Utils$Date$fromIsoString(string));
		}
	});
var $author$project$Utils$DateWithDefault$endFromQuery = function (query) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$DateWithDefault$fromString($author$project$Utils$DateWithDefault$DefaultEnd),
		A2($elm$core$Dict$get, 'end', query));
};
var $author$project$Utils$DateWithDefault$DefaultStart = {$: 1};
var $author$project$Utils$DateWithDefault$startFromQuery = function (query) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$DateWithDefault$fromString($author$project$Utils$DateWithDefault$DefaultStart),
		A2($elm$core$Dict$get, 'start', query));
};
var $author$project$Utils$DateWithDefault$fromQuery = function (query) {
	return _Utils_Tuple2(
		$author$project$Utils$DateWithDefault$startFromQuery(query),
		$author$project$Utils$DateWithDefault$endFromQuery(query));
};
var $author$project$Components$DateRangeInput$DropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$DateRangeInput$FromDatePickerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$DateRangeInput$GotCurrentDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$DateRangeInput$Model = $elm$core$Basics$identity;
var $author$project$Components$DateRangeInput$ToDatePickerMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$DateRangeInput$init = F2(
	function (id, settings) {
		var _v0 = $agustinrhcp$elm_datepicker$DatePicker$init;
		var toDatePicker = _v0.a;
		var toDatePickerCmd = _v0.b;
		var _v1 = $agustinrhcp$elm_datepicker$DatePicker$init;
		var fromDatePicker = _v1.a;
		var fromDatePickerCmd = _v1.b;
		return _Utils_Tuple2(
			{
				kT: $elm$core$Dict$empty,
				cO: $elm$core$Maybe$Nothing,
				fy: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: id + '-date-range-dropdown', ahx: $author$project$Components$DateRangeInput$DropdownMsg})),
				adD: $elm$core$Maybe$Nothing,
				qK: fromDatePicker,
				Gb: $elm$core$Dict$empty,
				zY: _List_Nil,
				gE: $elm$core$Maybe$Nothing,
				cq: settings,
				ahu: $elm$core$Maybe$Nothing,
				tk: toDatePicker
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DateRangeInput$FromDatePickerMsg, fromDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$DateRangeInput$ToDatePickerMsg, toDatePickerCmd),
						A2($elm$core$Task$perform, $author$project$Components$DateRangeInput$GotCurrentDate, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Api$Provider$Network$One$Network = $elm$core$Basics$identity;
var $author$project$Api$Provider$Network$One$Record = function (defaultSource) {
	return {Nl: defaultSource};
};
var $author$project$Api$Provider$Network$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'default_source',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Network$One$Record));
var $author$project$Api$Provider$Network$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Network$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Network$networkPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['network']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Network$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Network$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Network$networkPath));
	});
var $author$project$Components$Affiliates$BillsList$init = function (config) {
	var _v0 = $author$project$Utils$DateWithDefault$fromQuery(config.Bi);
	var start = _v0.a;
	var end = _v0.b;
	var _v1 = A2(
		$author$project$Components$DateRangeInput$init,
		'date-range-input',
		A2(
			$author$project$Components$Affiliates$BillsList$dateRangeInputSettings,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, config.cO, 0),
				start),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, config.cO, 0),
				end)));
	var dateRangeInput = _v1.a;
	var dateRangeInputCmd = _v1.b;
	var model = {
		DZ: config.DZ,
		hs: $author$project$Api$Data$Loading,
		vN: $author$project$Utils$Maybe$toBool(config.DZ),
		cO: config.cO,
		h3: dateRangeInput,
		E9: end,
		F_: config.F_,
		Uo: $author$project$Api$Data$Loading,
		afy: $author$project$Api$Pagination$initFromQuery(config.Bi),
		ag1: $author$project$Api$Sort$initFromQuery(config.Bi),
		Hl: start,
		Hy: config.Hy
	};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$BillsList$DateRangeInputMsg, dateRangeInputCmd),
					$author$project$Utils$Maybe$toBool(config.DZ) ? $elm$core$Platform$Cmd$none : A2($author$project$Api$Provider$Network$retrieve, config.D5, $author$project$Components$Affiliates$BillsList$GotNetwork),
					A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, config.D5, model),
					$author$project$Ports$Navigation$replaceUrl(
					$author$project$Components$Affiliates$BillsList$buildUrl(model))
				])));
};
var $author$project$Pages$AffiliateBills$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var _v3 = $author$project$Components$Affiliates$BillsList$init(
			{DZ: $elm$core$Maybe$Nothing, D5: shared.D5, cO: shared.cO, F_: $author$project$Spa$Generated$Route$AffiliateBills__Top, Bi: query, Hy: shared.Hy});
		var billsList = _v3.a;
		var billsListCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: billsList},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, billsListCmd));
	});
var $author$project$Pages$AffiliateBills$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$AffiliateBills$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$DateRangeInput$subscriptions = function (_v0) {
	var model = _v0;
	return $author$project$Ui$NewDropdown$subscriptions(model.fy);
};
var $author$project$Components$Affiliates$BillsList$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Affiliates$BillsList$DateRangeInputMsg,
		$author$project$Components$DateRangeInput$subscriptions(model.h3));
};
var $author$project$Pages$AffiliateBills$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Affiliates$BillsList$subscriptions(model.rh));
};
var $author$project$Utils$DateWithDefault$fromDate = $author$project$Utils$DateWithDefault$Date;
var $author$project$Components$DateRangeInput$None = {$: 0};
var $author$project$Components$DateRangeInput$buildAdditionalItemOption = function (additionalItem_) {
	return _Utils_Tuple2(
		additionalItem_.adR,
		_Utils_Tuple3(additionalItem_.aej, additionalItem_.Hl, additionalItem_.E9));
};
var $author$project$Components$DateRangeInput$buildAdditionalItems = function (additionalItems) {
	return $elm$core$Dict$fromList(
		A2($elm$core$List$map, $author$project$Components$DateRangeInput$buildAdditionalItemOption, additionalItems));
};
var $author$project$Components$DateRangeInput$customId = 'custom';
var $author$project$Components$DateRangeInput$buildCustomItem = F2(
	function (startDate, endDate) {
		return {E9: endDate, adR: $author$project$Components$DateRangeInput$customId, aej: 'Custom', Hl: startDate};
	});
var $author$project$Components$DateRangeInput$OptionSelected = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$DateRangeInput$buildEvent = F4(
	function (model, fromDate, toDate, label) {
		return (_Utils_eq(model.adD, fromDate) && _Utils_eq(model.ahu, toDate)) ? $author$project$Components$DateRangeInput$None : A3($author$project$Components$DateRangeInput$OptionSelected, fromDate, toDate, label);
	});
var $author$project$Components$DateRangeInput$buildMonthItem = function (_v0) {
	var id = _v0.a;
	var _v1 = _v0.b;
	var label = _v1.a;
	var monthStart = _v1.b;
	var monthEnd = _v1.c;
	return {E9: monthEnd, adR: id, aej: label, Hl: monthStart};
};
var $author$project$Components$DateRangeInput$buildMonthOptions = F2(
	function (monthRanges, additionalItems) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						{E9: $elm$core$Maybe$Nothing, adR: $author$project$Components$DateRangeInput$customId, aej: 'Custom', Hl: $elm$core$Maybe$Nothing}
					]),
					A2(
					$elm$core$List$map,
					function (_v0) {
						var id = _v0.a;
						var _v1 = _v0.b;
						var label = _v1.a;
						var start = _v1.b;
						var end = _v1.c;
						return {E9: end, adR: id, aej: label, Hl: start};
					},
					$elm$core$Dict$toList(additionalItems)),
					A2(
					$elm$core$List$map,
					function (_v6) {
						var id = _v6.a;
						var _v7 = _v6.b;
						var label = _v7.a;
						var start = _v7.b;
						var end = _v7.c;
						return {
							E9: $elm$core$Maybe$Just(end),
							adR: id,
							aej: label,
							Hl: $elm$core$Maybe$Just(start)
						};
					},
					$elm$core$List$reverse(
						A2(
							$elm$core$List$sortWith,
							F2(
								function (_v2, _v4) {
									var _v3 = _v2.b;
									var fromDate = _v3.b;
									var _v5 = _v4.b;
									var otherFromDate = _v5.b;
									return A2($justinmimbs$date$Date$compare, fromDate, otherFromDate);
								}),
							$elm$core$Dict$toList(monthRanges))))
				]));
	});
var $author$project$Components$DateRangeInput$buildMonthRange = F2(
	function (startMonth, index) {
		var monthStart = A3($justinmimbs$date$Date$add, 1, index, startMonth);
		var monthId = A2($justinmimbs$date$Date$format, 'MMMM yyyy', monthStart);
		var monthEnd = A3(
			$justinmimbs$date$Date$add,
			3,
			-1,
			A3($justinmimbs$date$Date$add, 1, 1, monthStart));
		return _Utils_Tuple2(
			monthId,
			_Utils_Tuple3(monthId, monthStart, monthEnd));
	});
var $author$project$Components$DateRangeInput$buildMonthRanges = F2(
	function (currentDate, settings) {
		var startMonth = A2($justinmimbs$date$Date$floor, 2, currentDate);
		var _v0 = settings.Fr ? _Utils_Tuple2(0, 12) : _Utils_Tuple2(settings.Ga, settings.F9);
		var rangeStart = _v0.a;
		var rangeEnd = _v0.b;
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$author$project$Components$DateRangeInput$buildMonthRange(startMonth),
				$elm$core$List$reverse(
					A2($elm$core$List$range, rangeStart, rangeEnd))));
	});
var $author$project$Components$DateRangeInput$formatWeekday = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Mon';
		case 1:
			return 'Tue';
		case 2:
			return 'Wed';
		case 3:
			return 'Thu';
		case 4:
			return 'Fri';
		case 5:
			return 'Sat';
		default:
			return 'Sun';
	}
};
var $author$project$Components$DateRangeInput$datePickerSettings = function () {
	var defaultSettings_ = $agustinrhcp$elm_datepicker$DatePicker$defaultSettings;
	return _Utils_update(
		defaultSettings_,
		{
			aco: $justinmimbs$date$Date$format('MM/dd/yyyy'),
			acr: $author$project$Components$DateRangeInput$formatWeekday,
			FA: _List_fromArray(
				[
					_Utils_Tuple2('form-control', true)
				]),
			afz: $author$project$Utils$Date$fromUsString,
			r4: 'mm/dd/yyyy'
		});
}();
var $author$project$Components$DateRangeInput$isCustomItem = function (maybeOption) {
	if (!maybeOption.$) {
		var item = maybeOption.a;
		return _Utils_eq(item.adR, $author$project$Components$DateRangeInput$customId);
	} else {
		return false;
	}
};
var $author$project$Components$DateRangeInput$defaultDateIfCustom = F4(
	function (model, selectedOption, getter, _default) {
		if ($author$project$Components$DateRangeInput$isCustomItem(selectedOption)) {
			var _v0 = getter(model);
			if (!_v0.$) {
				var currentDate = _v0.a;
				return $elm$core$Maybe$Just(currentDate);
			} else {
				return _default;
			}
		} else {
			return _default;
		}
	});
var $author$project$Components$DateRangeInput$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var currentDate = msg.a;
				var toDate = model.cq.ahu;
				var monthRanges = A2($author$project$Components$DateRangeInput$buildMonthRanges, currentDate, model.cq);
				var fromDate = model.cq.adD;
				var additionalItems = $author$project$Components$DateRangeInput$buildAdditionalItems(
					model.cq.kT(currentDate));
				var selectedOption = function () {
					var _v2 = _Utils_Tuple2(fromDate, toDate);
					if ((_v2.a.$ === 1) && (_v2.b.$ === 1)) {
						var _v3 = _v2.a;
						var _v4 = _v2.b;
						return $elm$core$Maybe$Nothing;
					} else {
						var selectedItem = A2(
							$elm$core$Maybe$withDefault,
							A2(
								$elm$core$Maybe$map,
								function (_v9) {
									var id = _v9.a;
									var _v10 = _v9.b;
									var label = _v10.a;
									var start = _v10.b;
									var end = _v10.c;
									return _Utils_Tuple2(
										id,
										_Utils_Tuple3(
											label,
											$elm$core$Maybe$Just(start),
											$elm$core$Maybe$Just(end)));
								},
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (_v7) {
										var _v8 = _v7.b;
										var start = _v8.b;
										var end = _v8.c;
										return _Utils_eq(
											$elm$core$Maybe$Just(start),
											fromDate) && _Utils_eq(
											$elm$core$Maybe$Just(end),
											toDate);
									},
									$elm$core$Dict$toList(monthRanges))),
							A2(
								$elm$core$Maybe$map,
								$elm$core$Maybe$Just,
								A2(
									$elm_community$list_extra$List$Extra$find,
									function (_v5) {
										var _v6 = _v5.b;
										var start = _v6.b;
										var end = _v6.c;
										return _Utils_eq(start, fromDate) && _Utils_eq(end, toDate);
									},
									$elm$core$Dict$toList(additionalItems))));
						return $elm$core$Maybe$Just(
							A2(
								$elm$core$Maybe$withDefault,
								A2($author$project$Components$DateRangeInput$buildCustomItem, fromDate, toDate),
								A2($elm$core$Maybe$map, $author$project$Components$DateRangeInput$buildMonthItem, selectedItem)));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kT: additionalItems,
							cO: $elm$core$Maybe$Just(currentDate),
							adD: fromDate,
							Gb: monthRanges,
							zY: A2($author$project$Components$DateRangeInput$buildMonthOptions, monthRanges, additionalItems),
							gE: selectedOption,
							ahu: toDate
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$DateRangeInput$None);
			case 1:
				var subMsg = msg.a;
				var _v11 = A3($agustinrhcp$elm_datepicker$DatePicker$update, $author$project$Components$DateRangeInput$datePickerSettings, subMsg, model.qK);
				var fromDatePicker = _v11.a;
				var fromDatePickerEvent = _v11.b;
				var fromDate = function () {
					_v12$2:
					while (true) {
						switch (fromDatePickerEvent.$) {
							case 2:
								var date = fromDatePickerEvent.a;
								return $elm$core$Maybe$Just(date);
							case 1:
								if (fromDatePickerEvent.a.$ === 1) {
									var _v13 = fromDatePickerEvent.a;
									return $elm$core$Maybe$Nothing;
								} else {
									break _v12$2;
								}
							default:
								break _v12$2;
						}
					}
					return model.adD;
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{adD: fromDate, qK: fromDatePicker}),
					$elm$core$Platform$Cmd$none,
					A4($author$project$Components$DateRangeInput$buildEvent, model, fromDate, model.ahu, 'Custom'));
			case 2:
				var subMsg = msg.a;
				var _v14 = A3($agustinrhcp$elm_datepicker$DatePicker$update, $author$project$Components$DateRangeInput$datePickerSettings, subMsg, model.tk);
				var toDatePicker = _v14.a;
				var toDatePickerEvent = _v14.b;
				var toDate = function () {
					_v15$2:
					while (true) {
						switch (toDatePickerEvent.$) {
							case 2:
								var date = toDatePickerEvent.a;
								return $elm$core$Maybe$Just(date);
							case 1:
								if (toDatePickerEvent.a.$ === 1) {
									var _v16 = toDatePickerEvent.a;
									return $elm$core$Maybe$Nothing;
								} else {
									break _v15$2;
								}
							default:
								break _v15$2;
						}
					}
					return model.ahu;
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ahu: toDate, tk: toDatePicker}),
					$elm$core$Platform$Cmd$none,
					A4($author$project$Components$DateRangeInput$buildEvent, model, model.adD, toDate, 'Custom'));
			case 3:
				var subMsg = msg.a;
				var _v17 = A2($author$project$Ui$NewDropdown$update, subMsg, model.fy);
				var dropdown = _v17.a;
				var cmd = _v17.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fy: dropdown}),
					cmd,
					$author$project$Components$DateRangeInput$None);
			default:
				var maybeItem = msg.a;
				var _v18 = function () {
					if (!maybeItem.$) {
						var item = maybeItem.a;
						return _Utils_Tuple3(item.Hl, item.E9, item.aej);
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, '');
					}
				}();
				var optionFromDate = _v18.a;
				var optionToDate = _v18.b;
				var selectedOptionLabel = _v18.c;
				var fromDate = A4(
					$author$project$Components$DateRangeInput$defaultDateIfCustom,
					model,
					maybeItem,
					function ($) {
						return $.adD;
					},
					optionFromDate);
				var toDate = A4(
					$author$project$Components$DateRangeInput$defaultDateIfCustom,
					model,
					maybeItem,
					function ($) {
						return $.ahu;
					},
					optionToDate);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{adD: fromDate, gE: maybeItem, ahu: toDate}),
					$elm$core$Platform$Cmd$none,
					A4($author$project$Components$DateRangeInput$buildEvent, model, fromDate, toDate, selectedOptionLabel));
		}
	});
var $author$project$Components$Affiliates$BillsList$updateUrl = A2($elm$core$Basics$composeR, $author$project$Components$Affiliates$BillsList$buildUrl, $author$project$Ports$Navigation$pushUrl);
var $author$project$Components$Affiliates$BillsList$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hs: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hs: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Uo: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
								$author$project$Components$Affiliates$BillsList$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
								$author$project$Components$Affiliates$BillsList$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v2.a;
				var subCmd = _v2.b;
				var event = _v2.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								hs: $author$project$Api$Data$Loading,
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
						$author$project$Components$Affiliates$BillsList$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$BillsList$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
		}
	});
var $author$project$Pages$AffiliateBills$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Affiliates$BillsList$update, model.D5, subMsg, model.rh);
		var billsList = _v1.a;
		var billsListCmd = _v1.b;
		var billsListOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: billsList}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, billsListCmd),
			billsListOutMsgs);
	});
var $author$project$Components$Affiliates$BillsList$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$BillsList$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$BillsList$columns = function (byAffiliate) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				(!byAffiliate) ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'name', false, 'Affiliate Name')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'invoice_date', true, 'Invoice Date'),
					A3($author$project$Api$Column$init, 'invoice_number', false, 'Bill Number'),
					A3($author$project$Api$Column$init, 'active_lives', false, 'Active Lives'),
					A3($author$project$Api$Column$init, 'amount_in_cents', false, 'Bill Amount'),
					A3($author$project$Api$Column$init, 'bill_status', false, 'Status')
				])
			]));
};
var $author$project$Api$Provider$Affiliate$One$defaultSource = function (_v0) {
	var record = _v0.b;
	return record.Nl;
};
var $author$project$Api$Provider$Network$One$defaultSource = function (_v0) {
	var record = _v0;
	return record.Nl;
};
var $author$project$Components$DateRangeInput$ItemSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$DateRangeInput$dropdownItems = F2(
	function (options, currentSelection) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$DateRangeInput$ItemSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentSelection, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All time')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$DateRangeInput$ItemSelected(
										$elm$core$Maybe$Just(item))),
									$author$project$Ui$NewDropdown$selected(
									_Utils_eq(
										currentSelection,
										$elm$core$Maybe$Just(item)))
								]),
							$elm$html$Html$text(item.aej));
					},
					options)));
	});
var $author$project$Ui$FlexGrid$Sm = 1;
var $author$project$Ui$FlexGrid$gutterSm = $author$project$Ui$FlexGrid$Gutter(1);
var $author$project$Components$DateRangeInput$view = function (_v0) {
	var model = _v0;
	var fullWithLength = model.cq.Fp ? 12 : 4;
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_fromArray(
			[$author$project$Ui$FlexGrid$gutterSm]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(fullWithLength)
					]),
				_List_fromArray(
					[
						function () {
						var placeholder = function () {
							var _v1 = model.gE;
							if (!_v1.$) {
								var item = _v1.a;
								return item.aej;
							} else {
								return 'All time';
							}
						}();
						return A4(
							$author$project$Ui$NewDropdown$viewSelect,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(placeholder)
								]),
							A2($author$project$Components$DateRangeInput$dropdownItems, model.zY, model.gE),
							model.fy);
					}()
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				model.cq.wZ,
				(model.cq.vm || $author$project$Components$DateRangeInput$isCustomItem(model.gE)) ? _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sr-only')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('From Date')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$DateRangeInput$FromDatePickerMsg,
								A3($agustinrhcp$elm_datepicker$DatePicker$view, model.adD, $author$project$Components$DateRangeInput$datePickerSettings, model.qK))
							]))
					]) : _List_Nil),
				(model.cq.vm || $author$project$Components$DateRangeInput$isCustomItem(model.gE)) ? A2(
				$author$project$Ui$FlexGrid$column,
				model.cq.wZ,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sr-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('To Date')
							])),
						A2(
						$elm$html$Html$map,
						$author$project$Components$DateRangeInput$ToDatePickerMsg,
						A3($agustinrhcp$elm_datepicker$DatePicker$view, model.ahu, $author$project$Components$DateRangeInput$datePickerSettings, model.tk))
					])) : $author$project$Ui$FlexGrid$none
			]));
};
var $author$project$Components$Affiliates$BillsList$viewSource = F2(
	function (timeFormatter, source) {
		if (!source.$) {
			var source_ = source.a;
			return A2(
				$author$project$Components$PracticeSourceDisplayer$view,
				timeFormatter,
				$elm$core$Maybe$Just(
					$author$project$Api$Source$Source(source_)));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$AffiliateBill$All$numberOfDependents = function (_v0) {
	var record = _v0.b;
	return record.UR;
};
var $author$project$Api$Provider$AffiliateBill$All$numberOfEmployees = function (_v0) {
	var record = _v0.b;
	return record.US;
};
var $author$project$Components$Affiliates$BillsList$activeLives = function (affiliateBill) {
	return $author$project$Api$Provider$AffiliateBill$All$numberOfDependents(affiliateBill) + $author$project$Api$Provider$AffiliateBill$All$numberOfEmployees(affiliateBill);
};
var $author$project$Api$Provider$AffiliateBill$All$affiliate = function (_v0) {
	var record = _v0.b;
	return record.DZ;
};
var $author$project$Api$Provider$Invoice$Shared$amountInCents = function (_v0) {
	var record = _v0.b;
	return record.I2;
};
var $author$project$Api$Provider$AffiliateBill$All$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Invoice$Shared$humanStatus = function (_v0) {
	var record = _v0.b;
	return record.QE;
};
var $author$project$Api$Provider$AffiliateBill$All$humanStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$humanStatus(shared);
};
var $author$project$Api$Provider$AffiliateBill$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$id(shared);
};
var $author$project$Api$Provider$Invoice$Shared$invoiceDate = function (_v0) {
	var record = _v0.b;
	return record.Rn;
};
var $author$project$Api$Provider$AffiliateBill$All$invoiceDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Provider$Invoice$Min$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Api$Provider$Invoice$Shared$invoiceNumber = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
};
var $author$project$Api$Provider$AffiliateBill$All$invoiceNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$AffiliateBill$All$practice = function (_v0) {
	var record = _v0.b;
	return record.WF;
};
var $author$project$Api$Invoice$Status$toString = function (status_) {
	switch (status_.$) {
		case 0:
			return 'draft';
		case 1:
			return 'issued';
		case 2:
			return 'paid';
		case 3:
			return 'disputed';
		case 4:
			return 'bad debt';
		case 5:
			return 'cancelled';
		case 6:
			return 'overdue';
		case 7:
			return 'viewed';
		case 8:
			return 'sent';
		default:
			var string = status_.a;
			return string;
	}
};
var $author$project$Api$Invoice$Status$toBadge = function (status_) {
	var badgeOption = function () {
		switch (status_.$) {
			case 7:
				return _List_fromArray(
					[$author$project$Ui$Badge$info]);
			case 2:
				return _List_fromArray(
					[$author$project$Ui$Badge$success]);
			case 6:
				return _List_fromArray(
					[$author$project$Ui$Badge$danger]);
			case 1:
				return _List_fromArray(
					[$author$project$Ui$Badge$warning]);
			case 8:
				return _List_fromArray(
					[$author$project$Ui$Badge$warning]);
			default:
				return _List_Nil;
		}
	}();
	return A2(
		$author$project$Ui$Badge$view,
		badgeOption,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Invoice$Status$toString(status_))
			]));
};
var $author$project$Components$Affiliates$BillsList$viewStatement = F2(
	function (model, affiliateBill) {
		var affiliateId = $author$project$Api$Provider$Affiliate$Shared$id(
			$author$project$Api$Provider$AffiliateBill$All$affiliate(affiliateBill));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						(!model.vN) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Practice$Min$name(
										$author$project$Api$Provider$AffiliateBill$All$practice(affiliateBill)))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String(
										{
											pp: affiliateId,
											adR: $author$project$Api$Provider$AffiliateBill$All$id(affiliateBill)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$MonthAndYear,
												$author$project$Api$Provider$AffiliateBill$All$invoiceDate(affiliateBill)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String(
										{
											pp: affiliateId,
											adR: $author$project$Api$Provider$AffiliateBill$All$id(affiliateBill)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('#'),
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Provider$AffiliateBill$All$invoiceNumber(affiliateBill)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Components$Affiliates$BillsList$activeLives(affiliateBill)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$AffiliateBill$All$amountInCents(affiliateBill)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Api$Invoice$Status$toBadge(
									$author$project$Api$Provider$AffiliateBill$All$humanStatus(affiliateBill))
								]))
						])
					])));
	});
var $author$project$Components$Affiliates$BillsList$view = function (model) {
	var _v0 = function () {
		var _v1 = model.hs;
		if (_v1.$ === 3) {
			var affiliateBills_ = _v1.a;
			return _Utils_Tuple2(false, affiliateBills_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var affiliateBills = _v0.b;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Affiliates$BillsList$DateRangeInputMsg,
										$author$project$Components$DateRangeInput$view(model.h3))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$pull(1)
											]),
										_List_fromArray(
											[
												function () {
												var _v2 = _Utils_Tuple2(model.DZ, model.Uo);
												if (!_v2.a.$) {
													var affiliate = _v2.a.a;
													return A2(
														$author$project$Components$Affiliates$BillsList$viewSource,
														model.Hy,
														$author$project$Api$Provider$Affiliate$One$defaultSource(affiliate));
												} else {
													if (_v2.b.$ === 3) {
														var _v3 = _v2.a;
														var _v4 = _v2.b;
														var network = _v4.a;
														return A2(
															$author$project$Components$Affiliates$BillsList$viewSource,
															model.Hy,
															$author$project$Api$Provider$Network$One$defaultSource(network));
													} else {
														var _v5 = _v2.a;
														return $author$project$Ui$Spinner$view(
															_List_fromArray(
																[$author$project$Ui$Spinner$small]));
													}
												}
											}()
											]))
									]))
							]))
					])),
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$verticalCentered,
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('No matching results.')
							])),
						$author$project$Ui$Table$loading(loading)
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$author$project$Api$Column$view(
								A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Affiliates$BillsList$SortTable)),
							$author$project$Components$Affiliates$BillsList$columns(model.vN)),
							_List_fromArray(
							[
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							])
						])),
				A2(
					$elm$core$List$map,
					$author$project$Components$Affiliates$BillsList$viewStatement(model),
					affiliateBills),
				_List_Nil),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Affiliates$BillsList$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Utils$Maybe$toBool(
										$author$project$Api$Data$toMaybe(model.hs)))
								]),
							model.afy))
					]))
			]));
};
var $author$project$Pages$AffiliateBills$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Affiliates$BillsList$view(model.rh))
			]),
		$G: 'Affiliates | Bills'
	};
};
var $author$project$Pages$AffiliateBills$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$AffiliateBills$Top$init, aer: $author$project$Pages$AffiliateBills$Top$load, agD: $author$project$Pages$AffiliateBills$Top$save, ahd: $author$project$Pages$AffiliateBills$Top$subscriptions, aaq: $author$project$Pages$AffiliateBills$Top$update, ahP: $author$project$Pages$AffiliateBills$Top$view});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$GotAffiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliate$affiliatesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['affiliates']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Affiliate$affiliatePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Affiliate$affiliatesPath);
};
var $author$project$Api$Provider$Affiliate$One$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliate$One$Record = F4(
	function (createdFrom, defaultSource, company, affiliatePractice) {
		return {IF: affiliatePractice, ab9: company, ach: createdFrom, Nl: defaultSource};
	});
var $author$project$Api$Provider$Affiliate$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'affiliate_practice',
	$author$project$Api$Provider$Practice$One$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'company',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'default_source',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_from',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$One$Record)))));
var $author$project$Api$Provider$Affiliate$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Affiliate$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$One$Affiliate)));
var $author$project$Api$Provider$Affiliate$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Affiliate$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliate$affiliatePath(id_)));
	});
var $author$project$Api$Pagination$withPrefix = F2(
	function (prefix, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{A7: prefix});
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$init = F4(
	function (session, _v0, shared, _v1) {
		var params = _v1.Vx;
		var query = _v1.Bi;
		return _Utils_Tuple2(
			{
				kY: $elm$core$Maybe$Nothing,
				pp: params.pp,
				D5: shared.D5,
				afy: A2(
					$author$project$Api$Pagination$fromQuery,
					query,
					A2($author$project$Api$Pagination$withPrefix, 'affiliate_actions_', $author$project$Api$Pagination$init)),
				Bi: query,
				ZD: session
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$Affiliate$retrieve, shared.D5, params.pp, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$GotAffiliate),
						$author$project$Shared$isHintAdmin(shared) ? $elm$core$Platform$Cmd$none : A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
							{pp: params.pp}))
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$AffiliateActionsList$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(model.F_)
			]),
		$author$project$Api$Pagination$toPageQuery(model.afy));
};
var $author$project$Components$Affiliates$AffiliateActionsList$GotAffiliateActions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$AffiliateAction$affiliatePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['affiliates']),
			$author$project$Api$Data$providerPath));
};
var $author$project$Api$Provider$AffiliateAction$affiliateActionsPath = function (affiliationId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_actions']),
		$author$project$Api$Provider$AffiliateAction$affiliatePath(affiliationId));
};
var $author$project$Api$Provider$AffiliateAction$All$AffiliateAction = $elm$core$Basics$identity;
var $author$project$Api$Provider$AffiliateAction$All$Record = F8(
	function (id, ident, contextMembershipIdent, targetIdent, actionType, actionData, status, errorMessage) {
		return {Ia: actionData, Ib: actionType, LN: contextMembershipIdent, ON: errorMessage, adR: id, adS: ident, ag7: status, $o: targetIdent};
	});
var $author$project$Api$Provider$AffiliateAction$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'error_message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'action_data',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'action_type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'target_ident',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'context_membership_ident',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'ident',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateAction$All$Record)))))))));
var $author$project$Api$Provider$AffiliateAction$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateAction$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateAction$listDefaults = {afy: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$AffiliateAction$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$AffiliateAction$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.afy);
};
var $author$project$Api$Provider$AffiliateAction$list = F4(
	function (apiClient, affiliationId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateAction$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$AffiliateAction$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$AffiliateAction$affiliateActionsPath(affiliationId))));
	});
var $author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions = function (_v0) {
	var apiClient = _v0.D5;
	var affiliateId = _v0.pp;
	var pagination = _v0.afy;
	return A4(
		$author$project$Api$Provider$AffiliateAction$list,
		apiClient,
		affiliateId,
		function (d) {
			return _Utils_update(
				d,
				{afy: pagination});
		},
		$author$project$Components$Affiliates$AffiliateActionsList$GotAffiliateActions);
};
var $author$project$Components$Affiliates$AffiliateActionsList$init = function (config) {
	var pagination = $author$project$Api$Pagination$initFromQuery(config.Bi);
	var model = {DZ: config.DZ, kX: $author$project$Api$Data$Loading, pp: config.pp, D5: config.D5, F_: config.F_, afy: pagination};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions(model),
					$author$project$Ports$Navigation$replaceUrl(
					$author$project$Components$Affiliates$AffiliateActionsList$buildUrl(model))
				])));
};
var $author$project$Components$Affiliates$AffiliateActionsList$updateUrl = A2($elm$core$Basics$composeR, $author$project$Components$Affiliates$AffiliateActionsList$buildUrl, $author$project$Ports$Navigation$pushUrl);
var $author$project$Components$Affiliates$AffiliateActionsList$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var headers = response.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kX: response,
							afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kX: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
			var newModel = _Utils_update(
				model,
				{afy: pagination});
			return _Utils_Tuple3(
				newModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions(newModel),
							$author$project$Components$Affiliates$AffiliateActionsList$updateUrl(newModel)
						])),
				_List_Nil);
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var affiliate = response.a;
				var _v2 = $author$project$Components$Affiliates$AffiliateActionsList$init(
					{
						DZ: $elm$core$Maybe$Just(affiliate),
						pp: model.pp,
						D5: model.D5,
						F_: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions(
							{pp: model.pp}),
						Bi: model.Bi
					});
				var affiliateActionsList = _v2.a;
				var affiliateActionsListCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kY: $elm$core$Maybe$Just(affiliateActionsList)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg, affiliateActionsListCmd),
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var _v3 = model.kY;
			if (!_v3.$) {
				var affiliateActionsList = _v3.a;
				var _v4 = A2($author$project$Components$Affiliates$AffiliateActionsList$update, subMsg, affiliateActionsList);
				var affiliateActionsList_ = _v4.a;
				var affiliateActionsListCmd = _v4.b;
				var affiliateActionsListOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kY: $elm$core$Maybe$Just(affiliateActionsList_)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg, affiliateActionsListCmd),
					affiliateActionsListOutMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Affiliates$AffiliateActionsList$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$AffiliateActionsList$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'id', false, 'ID'),
		A3($author$project$Api$Column$init, 'ident', false, 'Ident'),
		A3($author$project$Api$Column$init, 'context_membership_ident', false, 'Context Membership Ident'),
		A3($author$project$Api$Column$init, 'target_ident', false, 'Target Ident'),
		A3($author$project$Api$Column$init, 'action_type', false, 'Action Type'),
		A3($author$project$Api$Column$init, 'action_data', false, 'Action Data'),
		A3($author$project$Api$Column$init, 'status', false, 'Status'),
		A3($author$project$Api$Column$init, 'error_message', false, 'Error Message')
	]);
var $author$project$Api$Provider$AffiliateAction$All$actionData = function (_v0) {
	var record = _v0;
	return record.Ia;
};
var $author$project$Api$Provider$AffiliateAction$All$actionType = function (_v0) {
	var record = _v0;
	return record.Ib;
};
var $author$project$Api$Provider$AffiliateAction$All$contextMembershipIdent = function (_v0) {
	var record = _v0;
	return record.LN;
};
var $author$project$Api$Provider$AffiliateAction$All$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$AffiliateAction$All$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$AffiliateAction$All$ident = function (_v0) {
	var record = _v0;
	return record.adS;
};
var $author$project$Api$Provider$AffiliateAction$All$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$AffiliateAction$All$targetIdent = function (_v0) {
	var record = _v0;
	return record.$o;
};
var $author$project$Components$Affiliates$AffiliateActionsList$viewAffiliateAction = function (affiliateAction) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Provider$AffiliateAction$All$id(affiliateAction)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$ident(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$contextMembershipIdent(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$targetIdent(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$actionType(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$actionData(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$AffiliateAction$All$status(affiliateAction))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$AffiliateAction$All$errorMessage(affiliateAction)))
					]))
			]));
};
var $author$project$Components$Affiliates$AffiliateActionsList$view = function (model) {
	var _v0 = function () {
		var _v1 = model.kX;
		if (_v1.$ === 3) {
			var affiliateActions_ = _v1.a;
			return _Utils_Tuple2(false, affiliateActions_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var affiliateActions = _v0.b;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Affiliate Actions')
							]))
					])),
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$verticalCentered,
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('No matching results.')
							])),
						$author$project$Ui$Table$loading(loading)
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
							$author$project$Components$Affiliates$AffiliateActionsList$columns),
							_List_fromArray(
							[
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							])
						])),
				A2($elm$core$List$map, $author$project$Components$Affiliates$AffiliateActionsList$viewAffiliateAction, affiliateActions),
				_List_Nil),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Affiliates$AffiliateActionsList$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Utils$Maybe$toBool(
										$author$project$Api$Data$toMaybe(model.kX)))
								]),
							model.afy))
					]))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.kY;
				if (!_v0.$) {
					var affiliateActionsList = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg,
						$author$project$Components$Affiliates$AffiliateActionsList$view(affiliateActionsList));
				} else {
					return A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]),
		$G: 'Affiliates | Actions'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$init, aer: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$load, agD: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$save, ahd: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$subscriptions, aaq: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$update, ahP: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$GotAffiliate = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple2(
			{D5: shared.D5, fO: $elm$core$Maybe$Nothing},
			A3(
				$author$project$Api$Provider$Affiliate$retrieve,
				shared.D5,
				params.pp,
				A4($author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$GotAffiliate, session, practice, shared, params.adR)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$AuditTrailLogMsg = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Invoice$CompanyEmailModalMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$Invoice$CreatePaymentModalMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Invoice$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Invoice$DownloadInvoiceMsg = function (a) {
	return {$: 34, a: a};
};
var $author$project$Components$Invoice$DownloadUnavailableModalClosed = {$: 35};
var $author$project$Components$Invoice$InvoiceLinesTableMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Invoice$InvoiceSummaryMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Invoice$PaymentsHistoryMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Invoice$ReturnToDraftHiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Invoice$VoidHiConfirmClosed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$AuditTrailLog$isOpen = function (model) {
	return $author$project$Ui$Popover$isOpen(model.aM);
};
var $author$project$Components$AuditTrailLog$subscriptions = function (model) {
	return $author$project$Ui$Popover$subscriptions(model.aM);
};
var $author$project$Components$CompanyEmailModal$Close = {$: 0};
var $author$project$Components$CompanyEmailModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CompanyEmailModal$Close);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close = {$: 0};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close);
};
var $author$project$Components$ResourceFilter$Plan$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Invoice$InvoiceLinesTable$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$subscriptions, model.hq))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fq))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				$author$project$Ui$NewDropdown$subscriptions(model.l0),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Platform$Sub$map($author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg),
					A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Plan$subscriptions, model.jw))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.cJ))
			]));
};
var $author$project$Components$Invoice$Summary$CloseDeltaModal = {$: 5};
var $author$project$Components$Invoice$Summary$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = model.nj;
	if (!_v1.$) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$Summary$CloseDeltaModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Invoice$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(model.lV),
				function () {
				var _v1 = model.d6;
				if (!_v1.$) {
					var invoiceLinesTable = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Invoice$InvoiceLinesTableMsg,
						$author$project$Components$Invoice$InvoiceLinesTable$subscriptions(invoiceLinesTable));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.hN;
				if (!_v2.$) {
					var companyEmailModal = _v2.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Invoice$CompanyEmailModalMsg,
						$author$project$Components$CompanyEmailModal$subscriptions(companyEmailModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v3 = model.fP;
				if (!_v3.$) {
					var invoiceSummary = _v3.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Invoice$InvoiceSummaryMsg,
						$author$project$Components$Invoice$Summary$subscriptions(invoiceSummary));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$PaymentsHistoryMsg,
				$author$project$Components$Invoice$PaymentsHistory$subscriptions(model.jq)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$CreatePaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.lC))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Invoice$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.iq)),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$DownloadUnavailableModalClosed),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$VoidHiConfirmClosed),
					model.ty)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$ReturnToDraftHiConfirmClosed),
					model.ey)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed),
					model.ec)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$DeleteHiConfirmClosed),
					model.h8)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$andThen,
					function (auditTrailLog) {
						return $author$project$Components$AuditTrailLog$isOpen(auditTrailLog) ? $elm$core$Maybe$Just(
							A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Invoice$AuditTrailLogMsg,
								$author$project$Components$AuditTrailLog$subscriptions(auditTrailLog))) : $elm$core$Maybe$Nothing;
					},
					model.hy))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$subscriptions = function (model) {
	var _v0 = model.fO;
	if (!_v0.$) {
		var invoiceComponent = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg,
			$author$project$Components$Invoice$subscriptions(invoiceComponent));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Invoice$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliate$One$company = function (_v0) {
	var record = _v0.b;
	return record.ab9;
};
var $author$project$Components$Invoice$DropdownMenuMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$Model = $elm$core$Basics$identity;
var $author$project$Api$Feature$VirtualBankAccount = 11;
var $author$project$Components$Invoice$VirtualBankAccountsComponentMsg = function (a) {
	return {$: 37, a: a};
};
var $author$project$Api$Provider$Company$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$VirtualBankAccounts$Invoice$GotVirtualBankAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$VirtualBankAccount$EmployerAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$VirtualBankAccount$ProviderAll = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$VirtualBankAccount = $elm$core$Basics$identity;
var $author$project$Api$Employer$VirtualBankAccount$Shared$Record = function (id) {
	return function (abaBankName) {
		return function (abaAccountNumber) {
			return function (abaRoutingtNumber) {
				return function (contactEmail) {
					return function (swiftAccountNumber) {
						return function (swiftCode) {
							return function (swiftBankName) {
								return function (balanceInCents) {
									return function (createdAt) {
										return {HU: abaAccountNumber, HV: abaBankName, HW: abaRoutingtNumber, abw: balanceInCents, LK: contactEmail, Mf: createdAt, adR: id, $b: swiftAccountNumber, $c: swiftBankName, $d: swiftCode};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'balance_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'swift_bank_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'swift_code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'swift_account_number',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contact_email',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'aba_routing_number',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'aba_account_number',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'aba_bank_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$VirtualBankAccount$Shared$Record)))))))))));
var $author$project$Api$Employer$VirtualBankAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$VirtualBankAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$VirtualBankAccount$virtualBankAccountsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['virtual_bank_accounts']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$VirtualBankAccount$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$VirtualBankAccount$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$VirtualBankAccount$virtualBankAccountsPath));
	});
var $author$project$Api$Provider$VirtualBankAccount$Shared$VirtualBankAccount = $elm$core$Basics$identity;
var $author$project$Api$Provider$VirtualBankAccount$Shared$Record = function (id) {
	return function (abaBankName) {
		return function (abaAccountNumber) {
			return function (abaRoutingtNumber) {
				return function (contactEmail) {
					return function (swiftAccountNumber) {
						return function (swiftCode) {
							return function (swiftBankName) {
								return function (balanceInCents) {
									return function (createdAt) {
										return {HU: abaAccountNumber, HV: abaBankName, HW: abaRoutingtNumber, abw: balanceInCents, LK: contactEmail, Mf: createdAt, adR: id, $b: swiftAccountNumber, $c: swiftBankName, $d: swiftCode};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'balance_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'swift_bank_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'swift_code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'swift_account_number',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contact_email',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'aba_routing_number',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'aba_account_number',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'aba_bank_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$VirtualBankAccount$Shared$Record)))))))))));
var $author$project$Api$Provider$VirtualBankAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$VirtualBankAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['virtual_bank_accounts']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[companyId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['companies']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$VirtualBankAccount$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$VirtualBankAccount$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId)));
	});
var $author$project$Api$VirtualBankAccount$list = F4(
	function (session, apiClient, companyId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2(
			$author$project$Api$Employer$VirtualBankAccount$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$VirtualBankAccount$EmployerAll)))) : A3(
			$author$project$Api$Provider$VirtualBankAccount$list,
			apiClient,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$VirtualBankAccount$ProviderAll))));
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$loadData = F3(
	function (session, apiClient, companyId) {
		return _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A4($author$project$Api$VirtualBankAccount$list, session, apiClient, companyId, $author$project$Components$Company$VirtualBankAccounts$Invoice$GotVirtualBankAccounts));
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$init = F4(
	function (companyId, session, practice, _v0) {
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var _v1 = A3($author$project$Components$Company$VirtualBankAccounts$Invoice$loadData, session, apiClient, companyId);
		var virtualBankAccounts = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{JS: false, ff: companyId, adN: hinterViewOff, WF: practice, ZD: session, DL: virtualBankAccounts},
			cmd);
	});
var $author$project$Components$Invoice$InvoiceDateInputMsg = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceDueDateInputMsg = F2(
	function (a, b) {
		return {$: 32, a: a, b: b};
	});
var $author$project$Components$Invoice$initFormFields = function (today) {
	var _v0 = $author$project$Components$DateInput$init;
	var invoiceDateInput = _v0.a;
	var invoiceDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{Rn: today, mz: invoiceDateInput, iW: today, mA: invoiceDateInput},
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$InvoiceDateInputMsg(invoiceDateInput),
				invoiceDateInputCmd),
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$InvoiceDueDateInputMsg(invoiceDateInput),
				invoiceDateInputCmd)
			]));
};
var $author$project$Api$Provider$AffiliateBill$affiliateBillPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$AffiliateBill$affiliateBillsPath);
};
var $author$project$Api$Employer$Invoice$invoicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['invoices']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Invoice$invoicePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Employer$Invoice$invoicesPath);
};
var $author$project$Api$Provider$Company$Invoice$invoicesPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['invoices']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$Invoice$invoicePath = F2(
	function (companyId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Company$Invoice$invoicesPath(companyId));
	});
var $author$project$Api$Company$Invoice$invoicePath = F3(
	function (session, companyId, id) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Invoice$invoicePath(id) : A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id);
	});
var $author$project$Components$Invoice$paymentsBasePath = F2(
	function (session, invoiceType) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id);
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A3($author$project$Api$Company$Invoice$invoicePath, session, companyId, id);
		}
	});
var $author$project$Components$Invoice$GotIntegrationRecords = function (a) {
	return {$: 38, a: a};
};
var $author$project$Api$Provider$IntegrationRecord$All$IntegrationRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$IntegrationRecord$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$IntegrationRecord$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Company$Invoice$integrationRecords = F5(
	function (apiClient, session, companyId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['integration_records']),
					A3($author$project$Api$Company$Invoice$invoicePath, session, companyId, id_))));
	});
var $author$project$Components$Invoice$retrieveIntegrationRecords = F4(
	function (isHintAdmin, apiClient, session, invoiceType) {
		var _v0 = _Utils_Tuple2(isHintAdmin, invoiceType);
		if (_v0.a && (_v0.b.$ === 1)) {
			var _v1 = _v0.b;
			var companyId = _v1.a;
			var id = _v1.b;
			return A5($author$project$Api$Company$Invoice$integrationRecords, apiClient, session, companyId, id, $author$project$Components$Invoice$GotIntegrationRecords);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Invoice$GotCompanyInvoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Invoice$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Invoice$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Invoice$One$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Invoice$Shared$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Employer$Invoice$Shared$Record = function (id) {
	return function (invoiceDate) {
		return function (invoiceNumber) {
			return function (humanStatus) {
				return function (amountInCents) {
					return function (paidAt) {
						return function (paidInCents) {
							return function (dueDate) {
								return function (dueInCents) {
									return function (description) {
										return {I2: amountInCents, Nx: description, N1: dueDate, N2: dueInCents, QE: humanStatus, adR: id, Rn: invoiceDate, Rq: invoiceNumber, Vt: paidAt, Vu: paidInCents};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Invoice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'due_date',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paid_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'paid_at',
					$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'human_status',
							$author$project$Api$Invoice$Status$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_number',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'invoice_date',
									$author$project$Utils$Date$decode,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Shared$Record)))))))))));
var $author$project$Api$Employer$Invoice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Invoice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$One$Record = function (willAutoPay) {
	return function (autoPayDate) {
		return function (isPayable) {
			return function (discountSavingsInCents) {
				return function (securePdfInlineToken) {
					return function (securePdfWithChargeDetailsToken) {
						return function (source) {
							return function (payments) {
								return function (meta) {
									return function (recurring) {
										return {JF: autoPayDate, NM: discountSavingsInCents, RZ: isPayable, TU: meta, V5: payments, XY: recurring, Ze: securePdfInlineToken, Zf: securePdfWithChargeDetailsToken, Hg: source, aa4: willAutoPay};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Invoice$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Employer$Invoice$Meta$Record = F2(
	function (actions, reportingPeriodIsLocked) {
		return {tF: actions, Ye: reportingPeriodIsLocked};
	});
var $author$project$Api$Employer$Invoice$Meta$ActionsRecord = F6(
	function (canCancel, createPayment, markAsPaid, issue, canAdjust, hideChargeDetails) {
		return {Kn: canAdjust, Ko: canCancel, Mc: createPayment, Qo: hideChargeDetails, Sh: issue, Ti: markAsPaid};
	});
var $author$project$Api$Employer$Invoice$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hide_charge_details',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'can_adjust',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'issue',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'mark_as_paid',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'create_payment',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'can_cancel',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Meta$ActionsRecord)))))));
var $author$project$Api$Employer$Invoice$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reporting_period_is_locked',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Employer$Invoice$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Meta$Record)));
var $author$project$Api$Employer$Invoice$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Invoice$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'recurring',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'meta',
		$author$project$Api$Employer$Invoice$Meta$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payments',
			$elm$json$Json$Decode$list($author$project$Api$Employer$Payment$One$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'source',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'secure_pdf_with_charge_details_token',
					$author$project$Api$File$Token$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'secure_pdf_inline_token',
						$author$project$Api$File$Token$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'discount_savings_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_payable',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'auto_pay_date',
									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'will_auto_pay',
										$elm$json$Json$Decode$bool,
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$One$Record)))))))))));
var $author$project$Api$Employer$Invoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Invoice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Invoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$One$Invoice)));
var $author$project$Api$Employer$Invoice$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Invoice$invoicePath(id)));
	});
var $author$project$Api$Provider$Invoice$One$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$One$Record = function (willAutoPay) {
	return function (autoPayDate) {
		return function (securePdfInlineToken) {
			return function (securePdfWithChargeDetailsToken) {
				return function (viewingAsAffiliate) {
					return function (isUpdating) {
						return function (isPayable) {
							return function (periodInMonths) {
								return function (discountSavingsInCents) {
									return function (source) {
										return function (payments) {
											return function (meta) {
												return function (recurring) {
													return function (createdAt) {
														return {JF: autoPayDate, Mf: createdAt, NM: discountSavingsInCents, RZ: isPayable, Sg: isUpdating, TU: meta, V5: payments, Wc: periodInMonths, XY: recurring, Ze: securePdfInlineToken, Zf: securePdfWithChargeDetailsToken, Hg: source, aaR: viewingAsAffiliate, aa4: willAutoPay};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Invoice$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Invoice$Meta$Record = F2(
	function (actions, reportingPeriodIsLocked) {
		return {tF: actions, Ye: reportingPeriodIsLocked};
	});
var $author$project$Api$Provider$Invoice$Meta$ActionsRecord = function (canCancel) {
	return function (canDraftAndDestroyCurrentDraft) {
		return function (canMarkAsBadDebt) {
			return function (canReverseBadDebt) {
				return function (issue) {
					return function (canMakeViewable) {
						return function (canNotify) {
							return function (createPayment) {
								return function (markAsPaid) {
									return function (canAdjust) {
										return function (canDelete) {
											return {Kn: canAdjust, Ko: canCancel, Kp: canDelete, Kr: canDraftAndDestroyCurrentDraft, Kx: canMakeViewable, Ky: canMarkAsBadDebt, Kz: canNotify, KB: canReverseBadDebt, Mc: createPayment, Sh: issue, Ti: markAsPaid};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Invoice$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'can_delete',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'can_adjust',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'mark_as_paid',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'create_payment',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'can_notify',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'can_make_viewable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'issue',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'can_reverse_bad_debt',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'can_mark_as_bad_debt',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'can_draft_and_destroy_current_draft',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'can_cancel',
											$elm$json$Json$Decode$bool,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Meta$ActionsRecord))))))))))));
var $author$project$Api$Provider$Invoice$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reporting_period_is_locked',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Provider$Invoice$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Meta$Record)));
var $author$project$Api$Provider$Invoice$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Payment$SharedWithRefunds$Payment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Payment$SharedWithRefunds$Record = F2(
	function (refunds, dispute) {
		return {NQ: dispute, X3: refunds};
	});
var $author$project$Api$Provider$Payment$SharedWithRefunds$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'dispute',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Dispute$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'refunds',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Refund$Shared$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$SharedWithRefunds$Record)));
var $author$project$Api$Provider$Payment$SharedWithRefunds$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Payment$SharedWithRefunds$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Payment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$SharedWithRefunds$Payment)));
var $author$project$Api$Provider$Invoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recurring',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'meta',
			$author$project$Api$Provider$Invoice$Meta$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'payments',
				$elm$json$Json$Decode$list($author$project$Api$Provider$Payment$SharedWithRefunds$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'source',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'discount_savings_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'period_in_months',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_payable',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_updating',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'viewing_as_affiliate',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'secure_pdf_with_charge_details_token',
											$author$project$Api$File$Token$decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'secure_pdf_inline_token',
												$author$project$Api$File$Token$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'auto_pay_date',
													$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'will_auto_pay',
														$elm$json$Json$Decode$bool,
														$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$One$Record)))))))))))))));
var $author$project$Api$Provider$Invoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$One$Invoice)));
var $author$project$Api$Provider$Company$Invoice$retrieve = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id)));
	});
var $author$project$Api$Company$Invoice$retrieve = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Invoice$retrieve,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Invoice$retrieve,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Api$Provider$AffiliateBill$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id)));
	});
var $author$project$Components$Invoice$retrieveInvoice = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$retrieve,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$GotCompanyInvoice,
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5($author$project$Api$Company$Invoice$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$GotCompanyInvoice);
		}
	});
var $author$project$Ui$NewDropdown$TopRight = 4;
var $author$project$Ui$NewDropdown$toTopRight = function (config) {
	return _Utils_update(
		config,
		{xb: 4});
};
var $author$project$Components$Invoice$init = function (config) {
	var practice = config.WF;
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(
			config.ab9,
			A2($author$project$Api$Practice$featureEnabled, 11, practice));
		if ((!_v1.a.$) && _v1.b) {
			var company = _v1.a.a;
			var companyId = function () {
				if (!company.$) {
					var company_ = company.a;
					return $author$project$Api$Provider$Company$Min$id(company_);
				} else {
					var company_ = company.a;
					return $author$project$Api$Company$id(company_);
				}
			}();
			var _v2 = A4($author$project$Components$Company$VirtualBankAccounts$Invoice$init, companyId, config.ZD, practice, config.Cd);
			var model_ = _v2.a;
			var cmd_ = _v2.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(model_),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$VirtualBankAccountsComponentMsg, cmd_));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	}();
	var virtualBankAccountModel = _v0.a;
	var virtualBankAccountCmd = _v0.b;
	var _v4 = $author$project$Components$Invoice$initFormFields(config.Cd.cO);
	var fields = _v4.a;
	return _Utils_Tuple2(
		{
			cv: $author$project$Utils$Form$init(fields),
			k0: config.k0,
			hy: $elm$core$Maybe$Nothing,
			ab9: config.ab9,
			hN: $elm$core$Maybe$Nothing,
			lC: $elm$core$Maybe$Nothing,
			cO: config.Cd.cO,
			h8: $elm$core$Maybe$Nothing,
			iq: $author$project$Components$Invoice$DownloadFile$init(config.Cd.aav),
			lV: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$toTopRight(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'invoice-actions-dropdown-menu', ahx: $author$project$Components$Invoice$DropdownMenuMsg}))),
			Q8: $author$project$Api$Data$Loading,
			Rh: $author$project$Api$Data$Loading,
			yf: $elm$core$Maybe$Nothing,
			d6: $elm$core$Maybe$Nothing,
			fP: $elm$core$Maybe$Nothing,
			Rr: config.Rr,
			FR: $author$project$Shared$isHintAdmin(config.Cd),
			F_: config.F_,
			ec: $elm$core$Maybe$Nothing,
			r$: config.r$,
			jq: A4(
				$author$project$Components$Invoice$PaymentsHistory$init,
				config.Cd.Hy,
				A2($author$project$Components$Invoice$paymentsBasePath, config.ZD, config.Rr),
				config.ZD,
				true),
			WF: practice,
			sj: config.Cd.sj,
			ey: $elm$core$Maybe$Nothing,
			jY: $author$project$Api$Data$NotAsked,
			ZD: config.ZD,
			oj: false,
			ok: false,
			ol: false,
			Hy: config.Cd.Hy,
			aav: config.Cd.aav,
			tx: virtualBankAccountModel,
			ty: $elm$core$Maybe$Nothing
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Components$Invoice$retrieveInvoice, config.D5, config.ZD, config.Rr),
					virtualBankAccountCmd,
					A4(
					$author$project$Components$Invoice$retrieveIntegrationRecords,
					$author$project$Shared$isHintAdmin(config.Cd),
					config.D5,
					config.ZD,
					config.Rr)
				])));
};
var $author$project$Components$Invoice$Summary$Affiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$Summary$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$GotSummary = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$InvoiceDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceDueDate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Common$Invoice$Summary$allLines = function (_v0) {
	var record = _v0;
	return record.IR;
};
var $author$project$Api$Common$Invoice$Summary$AllLines$count = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.Dx.LY);
};
var $author$project$Api$Provider$Invoice$One$createdAt = function (_v0) {
	var record = _v0.b;
	return record.Mf;
};
var $author$project$Api$Invoice$One$createdAt = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Invoice$One$createdAt(invoice_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Invoice$Deleted = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Invoice$delete = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id)));
	});
var $author$project$Api$Company$Invoice$delete = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Company$Invoice$delete, apiClient, companyId, id, toMsg);
	});
var $author$project$Api$Provider$AffiliateBill$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id)));
	});
var $author$project$Components$Invoice$delete = F4(
	function (apiClient, session, invoiceType, invoice) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$delete,
				apiClient,
				id,
				$author$project$Components$Invoice$Deleted(invoice));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5(
				$author$project$Api$Company$Invoice$delete,
				apiClient,
				session,
				companyId,
				id,
				$author$project$Components$Invoice$Deleted(invoice));
		}
	});
var $author$project$Api$Employer$Invoice$Shared$dueDate = function (_v0) {
	var record = _v0;
	return record.N1;
};
var $author$project$Api$Employer$Invoice$One$dueDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$dueDate(shared);
};
var $author$project$Api$Provider$Invoice$Shared$dueDate = function (_v0) {
	var record = _v0.b;
	return record.N1;
};
var $author$project$Api$Provider$Invoice$One$dueDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$dueDate(shared);
};
var $author$project$Api$Invoice$One$dueDate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$dueDate(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$dueDate(invoice_);
	}
};
var $author$project$Api$Provider$Invoice$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Employer$Invoice$Shared$invoiceDate = function (_v0) {
	var record = _v0;
	return record.Rn;
};
var $author$project$Api$Employer$Invoice$One$invoiceDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Invoice$One$invoiceDate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$date(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$invoiceDate(invoice_);
	}
};
var $author$project$Components$Invoice$formFieldsFromInvoice = function (invoice) {
	var _v0 = $author$project$Components$DateInput$init;
	var invoiceDateInput = _v0.a;
	var invoiceDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			Rn: $author$project$Api$Invoice$One$invoiceDate(invoice),
			mz: invoiceDateInput,
			iW: $author$project$Api$Invoice$One$dueDate(invoice),
			mA: invoiceDateInput
		},
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$InvoiceDateInputMsg(invoiceDateInput),
				invoiceDateInputCmd),
				A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Invoice$InvoiceDueDateInputMsg(invoiceDateInput),
				invoiceDateInputCmd)
			]));
};
var $author$project$Components$AuditTrailLog$PopoverMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AuditTrailLog$init = F7(
	function (session, url, timeFormatter, resource, resourceId, resourceCreatedAt, filter) {
		return {
			pz: $author$project$Api$Data$Loading,
			Fi: filter,
			afy: $author$project$Api$Pagination$init,
			aM: A3($author$project$Ui$Popover$init, 'audit-history', false, $author$project$Components$AuditTrailLog$PopoverMsg),
			G0: resource,
			BV: resourceCreatedAt,
			G1: resourceId,
			ZD: session,
			cr: _List_Nil,
			Hy: timeFormatter,
			Dw: 0,
			aav: url
		};
	});
var $author$project$Api$Provider$Report$AffiliateBillLine = 5;
var $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$GotEmployeeDivisions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Report$InvoiceLine = 4;
var $author$project$Api$Employer$Company$Shared$allowCustomMembershipPlan = function (_v0) {
	var record = _v0;
	return record.IV;
};
var $author$project$Api$Employer$Company$One$allowCustomMembershipPlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$allowCustomMembershipPlan(shared);
};
var $author$project$Api$Provider$Company$Shared$allowCustomMembershipPlan = function (_v0) {
	var record = _v0;
	return record.IV;
};
var $author$project$Api$Provider$Company$One$allowCustomMembershipPlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$allowCustomMembershipPlan(shared);
};
var $author$project$Api$Company$allowCustomMembershipPlan = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$allowCustomMembershipPlan(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$allowCustomMembershipPlan(company_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return false;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$allowCustomMembershipPlan(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$companyId = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					var company__ = company_.a;
					return $author$project$Api$Provider$Company$Min$id(company__);
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$id(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$GotInvoiceLines = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$EmployeeDivision$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$EmployeeDivision$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$EmployeeDivision$Shared$id(shared);
};
var $author$project$Api$Provider$EmployeeDivision$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$EmployeeDivision$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$EmployeeDivision$Shared$id(shared);
};
var $author$project$Api$EmployeeDivision$All$id = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$id(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$id(employeeDivision_);
	}
};
var $author$project$Api$Provider$InvoiceLine$All$InvoiceLine = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$InvoiceLine$Shared$InvoiceLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$InvoiceLine$Shared$Record = F3(
	function (id, date, amountInCents) {
		return {I2: amountInCents, MO: date, adR: id};
	});
var $author$project$Api$Provider$InvoiceLine$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$Shared$Record))));
var $author$project$Api$Provider$InvoiceLine$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceLine$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InvoiceLine$All$Record = function (endDate) {
	return function (patientName) {
		return function (dependentCount) {
			return function (chargeDescription) {
				return function (categoryName) {
					return function (shouldHideAmount) {
						return function (shouldShowMoreInfo) {
							return function (employeeDivision) {
								return function (plan) {
									return function (charges) {
										return function (createdBy) {
											return {KM: categoryName, KQ: chargeDescription, KU: charges, Mg: createdBy, Nr: dependentCount, E8: employeeDivision, qs: endDate, VR: patientName, GH: plan, ZR: shouldHideAmount, ZS: shouldShowMoreInfo};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$Record = F2(
	function (isLocked, meta) {
		return {RP: isLocked, TU: meta};
	});
var $author$project$Api$Provider$Charge$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$Meta$Record = function (patient) {
	return function (name) {
		return function (quantity) {
			return function (quantityUom) {
				return function (priceInCents) {
					return function (category) {
						return function (description) {
							return function (practitioner) {
								return function (date) {
									return function (endDate) {
										return function (location) {
											return function (actions) {
												return {tF: actions, Ex: category, MO: date, Nx: description, qs: endDate, aet: location, zh: name, VM: patient, afS: practitioner, Ba: priceInCents, Bd: quantity, Be: quantityUom};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Charge$Meta$ActionsRecord = F3(
	function (edit, destroy, revisable) {
		return {NA: destroy, N6: edit, YL: revisable};
	});
var $author$project$Api$Provider$Charge$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'revisable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'destroy',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'edit',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$ActionsRecord))));
var $author$project$Api$Provider$Charge$Meta$EditableRecord = function (editable) {
	return {Oa: editable};
};
var $author$project$Api$Provider$Charge$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$EditableRecord));
var $author$project$Api$Provider$Charge$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Charge$Meta$actionsRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'location',
		$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'date',
				$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'practitioner',
					$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'category',
							$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'price_in_cents',
								$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'quantity_uom',
									$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'quantity',
										$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'patient',
												$author$project$Api$Provider$Charge$Meta$editableRecordDecoder,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$Record)))))))))))));
var $author$project$Api$Provider$Charge$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Charge$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_locked',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForInvoiceLineAll$Record)));
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$ForInvoiceLineAll$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$EmployeeDivision$Shared$EmployeeDivision = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmployeeDivision$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$EmployeeDivision$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$Shared$Record)));
var $author$project$Api$Provider$EmployeeDivision$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmployeeDivision$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Session$Shared$Session = $elm$core$Basics$identity;
var $author$project$Api$Provider$Session$Shared$Record = F2(
	function (user, organization) {
		return {Vd: organization, aaz: user};
	});
var $author$project$Api$Provider$Session$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$author$project$Api$Provider$User$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Session$Shared$Record)));
var $author$project$Api$Provider$Session$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Session$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InvoiceLine$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_by',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Session$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Charge$ForInvoiceLineAll$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'plan',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'employee_division',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'should_show_more_info',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'should_hide_amount',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'category_name',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'charge_description',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'dependent_count',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'patient_name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'end_date',
											$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$All$Record))))))))))));
var $author$project$Api$Provider$InvoiceLine$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceLine$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$InvoiceLine$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$All$InvoiceLine)));
var $author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath = function (invoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['invoice_lines']),
		$author$project$Api$Employer$Invoice$invoicePath(invoiceId));
};
var $author$project$Api$Common$InvoiceLine$ListOptionals$defaults = {Ex: $elm$core$Maybe$Nothing, E8: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, GH: $elm$core$Maybe$Nothing, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Common$InvoiceLine$ListOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$InvoiceLine$ListOptionals$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Ex;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'category', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.GH;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'plan', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.E8;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'employee_division', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.afy),
				$author$project$Api$Sort$toParams(options.ag1)
			]));
};
var $author$project$Api$Employer$Invoice$InvoiceLine$list = F4(
	function (apiClient, invoiceId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath(invoiceId))));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath = F2(
	function (companyId, invoiceId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['invoice_lines']),
			A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$list = F5(
	function (apiClient, companyId, invoiceId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath, companyId, invoiceId))));
	});
var $author$project$Api$Company$Invoice$InvoiceLine$list = F6(
	function (apiClient, session, companyId, invoiceId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Invoice$InvoiceLine$list, apiClient, invoiceId, optionals, toMsg) : A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$list, apiClient, companyId, invoiceId, optionals, toMsg);
	});
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath = function (affiliateBillId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['invoice_lines']),
		$author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId));
};
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$list = F4(
	function (apiClient, affiliateBillId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath(affiliateBillId))));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines = F2(
	function (apiClient, model) {
		var list = function () {
			var _v0 = model.Rr;
			if (_v0.$ === 1) {
				var companyId_ = _v0.a;
				var id = _v0.b;
				return A4($author$project$Api$Company$Invoice$InvoiceLine$list, apiClient, model.ZD, companyId_, id);
			} else {
				var id = _v0.b;
				return A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$list, apiClient, id);
			}
		}();
		return A2(
			list,
			function (d) {
				return _Utils_update(
					d,
					{
						Ex: model.fa,
						E8: A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$All$id, model.E8),
						afy: model.afy,
						GH: model.afN,
						af_: model.af_,
						ag1: model.ag1
					});
			},
			$author$project$Components$Invoice$InvoiceLinesTable$GotInvoiceLines);
	});
var $author$project$Api$EmployeeDivision$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$EmployeeDivision$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$EmployeeDivision$All$EmployeeDivision = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$EmployeeDivision$Shared$EmployeeDivision = $elm$core$Basics$identity;
var $author$project$Api$Employer$EmployeeDivision$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Employer$EmployeeDivision$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$Shared$Record)));
var $author$project$Api$Employer$EmployeeDivision$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$EmployeeDivision$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$EmployeeDivision$All$Record = F3(
	function (assignedAccounts, eligibleAccounts, enrolledAccounts) {
		return {Jo: assignedAccounts, Om: eligibleAccounts, OD: enrolledAccounts};
	});
var $author$project$Api$Employer$EmployeeDivision$All$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'enrolled_accounts_count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligible_accounts_count',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'assigned_accounts_count',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$All$Record))));
var $author$project$Api$Employer$EmployeeDivision$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$EmployeeDivision$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$EmployeeDivision$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$All$EmployeeDivision)));
var $author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['employee_divisions']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$EmployeeDivision$expandToString = function (expand) {
	return 'count';
};
var $author$project$Api$Employer$EmployeeDivision$listDefaults = {Fc: _List_Nil};
var $author$project$Api$Employer$EmployeeDivision$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$EmployeeDivision$listDefaults);
	return _List_fromArray(
		[
			A2(
			$author$project$Api$Param$list,
			'expand',
			A2($elm$core$List$map, $author$project$Api$Employer$EmployeeDivision$expandToString, options.Fc))
		]);
};
var $author$project$Api$Employer$EmployeeDivision$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$EmployeeDivision$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$EmployeeDivision$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
	});
var $author$project$Api$Provider$EmployeeDivision$All$EmployeeDivision = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$EmployeeDivision$All$Record = F3(
	function (assignedAccounts, eligibleAccounts, enrolledAccounts) {
		return {Jo: assignedAccounts, Om: eligibleAccounts, OD: enrolledAccounts};
	});
var $author$project$Api$Provider$EmployeeDivision$All$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'enrolled_accounts_count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligible_accounts_count',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'assigned_accounts_count',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			$elm$core$Maybe$Nothing,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$All$Record))));
var $author$project$Api$Provider$EmployeeDivision$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmployeeDivision$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$EmployeeDivision$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$All$EmployeeDivision)));
var $author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['employee_divisions']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$EmployeeDivision$expandToString = function (expand) {
	return 'count';
};
var $author$project$Api$Provider$Company$EmployeeDivision$listDefaults = {Fc: _List_Nil};
var $author$project$Api$Provider$Company$EmployeeDivision$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Company$EmployeeDivision$listDefaults);
	return _List_fromArray(
		[
			A2(
			$author$project$Api$Param$list,
			'expand',
			A2($elm$core$List$map, $author$project$Api$Provider$Company$EmployeeDivision$expandToString, options.Fc))
		]);
};
var $author$project$Api$Provider$Company$EmployeeDivision$list = F4(
	function (apiClient, companyId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$EmployeeDivision$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Company$EmployeeDivision$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
	});
var $author$project$Api$Employer$EmployeeDivision$Count = 0;
var $author$project$Api$EmployeeDivision$expandToEmployer = function (expand) {
	return 0;
};
var $author$project$Api$EmployeeDivision$listDefaults = {Fc: _List_Nil};
var $author$project$Api$EmployeeDivision$optionalsToEmployer = function (optionals) {
	var options = optionals($author$project$Api$EmployeeDivision$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				Fc: A2($elm$core$List$map, $author$project$Api$EmployeeDivision$expandToEmployer, options.Fc)
			});
	};
};
var $author$project$Api$Provider$Company$EmployeeDivision$Count = 0;
var $author$project$Api$EmployeeDivision$expandToProvider = function (expand) {
	return 0;
};
var $author$project$Api$EmployeeDivision$optionalsToProvider = function (optionals) {
	var options = optionals($author$project$Api$EmployeeDivision$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				Fc: A2($elm$core$List$map, $author$project$Api$EmployeeDivision$expandToProvider, options.Fc)
			});
	};
};
var $author$project$Api$EmployeeDivision$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$EmployeeDivision$list,
			apiClient,
			$author$project$Api$EmployeeDivision$optionalsToEmployer(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$EmployeeDivision$All$Employer)))) : A4(
			$author$project$Api$Provider$Company$EmployeeDivision$list,
			apiClient,
			companyId,
			$author$project$Api$EmployeeDivision$optionalsToProvider(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$EmployeeDivision$All$Provider))));
	});
var $author$project$Api$Employer$Invoice$One$recurring = function (_v0) {
	var record = _v0.b;
	return record.XY;
};
var $author$project$Api$Provider$Invoice$One$recurring = function (_v0) {
	var record = _v0.b;
	return record.XY;
};
var $author$project$Api$Invoice$One$recurring = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$recurring(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$recurring(invoice_);
	}
};
var $author$project$Api$Employer$Company$Shared$usesEmployeeDivisions = function (_v0) {
	var record = _v0;
	return record.aaF;
};
var $author$project$Api$Employer$Company$One$usesEmployeeDivisions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$usesEmployeeDivisions(shared);
};
var $author$project$Api$Provider$Company$One$usesEmployeeDivisions = function (_v0) {
	var record = _v0.b;
	return record.aaF;
};
var $author$project$Api$Company$usesEmployeeDivisions = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$usesEmployeeDivisions(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$usesEmployeeDivisions(company_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return false;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$usesEmployeeDivisions(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$init = F7(
	function (currentDate, apiClient, session, practice, company, invoiceType, invoice) {
		var resource = function () {
			if (invoiceType.$ === 1) {
				return 4;
			} else {
				return 5;
			}
		}();
		var q = $elm$core$Maybe$Nothing;
		var _v0 = $author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(company) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A4(
				$author$project$Components$ResourceFilter$Plan$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{
							D9: $elm$core$Maybe$Just(
								$author$project$Components$Invoice$InvoiceLinesTable$companyId(company))
						});
				},
				function (d) {
					return _Utils_update(
						d,
						{D0: 'All Plans'});
				})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Categories', UL: 'Unassigned', aeZ: true});
			});
		var categoryResourceFilter = _v1.a;
		var categoryResourceFilterCmd = _v1.b;
		var model = {
			hq: $elm$core$Maybe$Nothing,
			fa: $elm$core$Maybe$Nothing,
			cJ: categoryResourceFilter,
			ab9: company,
			cO: currentDate,
			fq: $elm$core$Maybe$Nothing,
			dM: $elm$core$Set$empty,
			E8: $elm$core$Maybe$Nothing,
			l0: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'employee-division-dropdown-filter', ahx: $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionDropdownMsg})),
			xp: $author$project$Api$Data$Loading,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: resource}),
			Rh: invoice,
			aq: $author$project$Api$Data$Loading,
			Rr: invoiceType,
			afy: $author$project$Api$Pagination$init,
			ei: $elm$core$Dict$empty,
			afN: $elm$core$Maybe$Nothing,
			jw: planResourceFilter,
			WF: practice,
			af_: q,
			Bn: $author$project$Api$Invoice$One$recurring(invoice),
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			ag1: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, model),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg, planResourceFilterCmd),
						$author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(company) ? A5(
						$author$project$Api$EmployeeDivision$list,
						apiClient,
						session,
						$author$project$Components$Invoice$InvoiceLinesTable$companyId(company),
						function (d) {
							return d;
						},
						$author$project$Components$Invoice$InvoiceLinesTable$GotEmployeeDivisions) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Components$Invoice$Summary$GotDelta = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$Summary$Model = $elm$core$Basics$identity;
var $author$project$Components$Invoice$Summary$EmployeeDivision = 1;
var $author$project$Components$Invoice$Summary$Plan = 0;
var $author$project$Components$Invoice$Summary$Sponsor = 2;
var $author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return false;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$allowCustomMembershipPlan(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return false;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$usesEmployeeDivisions(company__);
				}
			},
			company));
};
var $author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines = function (_v0) {
	var record = _v0;
	return record._v;
};
var $author$project$Components$Invoice$Summary$groupBy = F3(
	function (company, summary, showSponsor) {
		return showSponsor ? $elm$core$Maybe$Just(2) : ($author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(company) ? $elm$core$Maybe$Just(0) : (($author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions(company) && $elm$core$List$isEmpty(
			$author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines(summary))) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$init = function (recurringInvoice) {
	return {Bn: recurringInvoice, gM: false};
};
var $author$project$Api$Common$Invoice$Delta$Delta = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Delta$Record = F2(
	function (added, removed) {
		return {Il: added, Yb: removed};
	});
var $author$project$Api$Provider$InvoicePatient$Shared$InvoicePatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$InvoicePatient$Shared$Record = F4(
	function (name, startDate, endDate, owner) {
		return {qs: endDate, zh: name, Vp: owner, _E: startDate};
	});
var $author$project$Api$Provider$InvoicePatient$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'owner',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'end_date',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_date',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoicePatient$Shared$Record)))));
var $author$project$Api$Provider$InvoicePatient$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoicePatient$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Delta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'removed',
	$elm$json$Json$Decode$list($author$project$Api$Provider$InvoicePatient$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'added',
		$elm$json$Json$Decode$list($author$project$Api$Provider$InvoicePatient$Shared$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Delta$Record)));
var $author$project$Api$Common$Invoice$Delta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Delta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$Delta$deltaPath = function (invoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['delta']),
		$author$project$Api$Employer$Invoice$invoicePath(invoiceId));
};
var $author$project$Api$Employer$Invoice$Delta$retrieve = F3(
	function (apiClient, invoiceId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Delta$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Invoice$Delta$deltaPath(invoiceId)));
	});
var $author$project$Api$Provider$Company$Invoice$Delta$deltaPath = F2(
	function (companyId, invoiceId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['delta']),
			A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId));
	});
var $author$project$Api$Provider$Company$Invoice$Delta$retrieve = F4(
	function (apiClient, companyId, invoiceId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Delta$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Company$Invoice$Delta$deltaPath, companyId, invoiceId)));
	});
var $author$project$Api$Company$Invoice$Delta$retrieve = F5(
	function (apiClient, session, companyId, invoiceId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$Delta$retrieve, apiClient, invoiceId, toMsg) : A4($author$project$Api$Provider$Company$Invoice$Delta$retrieve, apiClient, companyId, invoiceId, toMsg);
	});
var $author$project$Api$Provider$AffiliateBill$Delta$deltaPath = function (affiliateBillId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['delta']),
		$author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId));
};
var $author$project$Api$Provider$AffiliateBill$Delta$retrieve = F3(
	function (apiClient, affiliateBillId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Delta$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$AffiliateBill$Delta$deltaPath(affiliateBillId)));
	});
var $author$project$Api$Employer$Company$Shared$companyType = function (_v0) {
	var record = _v0;
	return record.LA;
};
var $author$project$Api$Employer$Company$One$companyType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$companyType(shared);
};
var $author$project$Api$Provider$Company$Shared$companyType = function (_v0) {
	var record = _v0;
	return record.LA;
};
var $author$project$Api$Provider$Company$One$companyType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$companyType(shared);
};
var $author$project$Api$Company$companyType = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$companyType(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$companyType(company_);
	}
};
var $author$project$Api$Provider$Company$Min$companyType = function (_v0) {
	var record = _v0;
	return record.LA;
};
var $author$project$Components$Invoice$Summary$companyType = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Api$Provider$Company$Min$companyType(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$companyType(company__);
			}
		},
		company);
};
var $author$project$Components$Invoice$Summary$companyIsNetwork = function (company) {
	return _Utils_eq(
		$author$project$Components$Invoice$Summary$companyType(company),
		$elm$core$Maybe$Just(0));
};
var $author$project$Components$Invoice$Summary$showSponsorBreakdown = F3(
	function (invoiceType, session, company) {
		var organizationIsPractice = $author$project$Api$Platform$Session$One$organizationIsAdminPractice(session);
		var isAffiliateBill = function () {
			if (!invoiceType.$) {
				return true;
			} else {
				return false;
			}
		}();
		return organizationIsPractice && ($author$project$Components$Invoice$Summary$companyIsNetwork(company) || isAffiliateBill);
	});
var $author$project$Components$Invoice$Summary$init = F8(
	function (apiClient, session, timeFormatter, practice, company, invoiceType, invoice, summary) {
		var recurringInvoice = $author$project$Api$Invoice$One$recurring(invoice);
		var organizationIsPractice = $author$project$Api$Platform$Session$One$organizationIsAdminPractice(session);
		var groupBy_ = A3(
			$author$project$Components$Invoice$Summary$groupBy,
			company,
			summary,
			A3($author$project$Components$Invoice$Summary$showSponsorBreakdown, invoiceType, session, company));
		return _Utils_Tuple2(
			{
				ab9: company,
				w8: $author$project$Api$Data$Loading,
				fK: groupBy_,
				Rh: invoice,
				Rr: invoiceType,
				rK: $author$project$Components$Invoice$Summary$OtherChargesSummary$init(recurringInvoice),
				nj: $elm$core$Maybe$Nothing,
				WF: practice,
				ZD: session,
				gL: false,
				gN: organizationIsPractice && (!_Utils_eq(groupBy_, $elm$core$Maybe$Nothing)),
				_9: summary,
				Hy: timeFormatter
			},
			function () {
				if (!invoiceType.$) {
					var id = invoiceType.a;
					return A3($author$project$Api$Provider$AffiliateBill$Delta$retrieve, apiClient, id, $author$project$Components$Invoice$Summary$GotDelta);
				} else {
					var companyId = invoiceType.a;
					var id = invoiceType.b;
					return A5($author$project$Api$Company$Invoice$Delta$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$Summary$GotDelta);
				}
			}());
	});
var $author$project$Api$Provider$Notification$EmployerInvoiceCreated = 1;
var $author$project$Components$CompanyEmailModal$Loading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Notification$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CompanyEmailModal$GotPreview = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Notification$One$Notification = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Notification$Shared$Notification = $elm$core$Basics$identity;
var $author$project$Api$Provider$Notification$Shared$Record = F9(
	function (subject, body, attemptedAt, failedAt, recipientEmail, shortDescription, errorMessage, clickedAt, openedAt) {
		return {Jv: attemptedAt, e5: body, K0: clickedAt, ON: errorMessage, O5: failedAt, Va: openedAt, XV: recipientEmail, ZL: shortDescription, Hp: subject};
	});
var $author$project$Api$Provider$Notification$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'opened_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'clicked_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'short_description',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'recipient_email',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'failed_at',
						$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'attempted_at',
							$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'body',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'subject',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$Shared$Record))))))))));
var $author$project$Api$Provider$Notification$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Notification$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Notification$One$Record = F3(
	function (subjectHtml, bodyHtml, shortDescriptionHtml) {
		return {J4: bodyHtml, ZM: shortDescriptionHtml, _1: subjectHtml};
	});
var $author$project$Api$Provider$Notification$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'short_description_html',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'body_html',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'subject_html',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$One$Record))));
var $author$project$Api$Provider$Notification$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Notification$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Notification$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$One$Notification)));
var $author$project$Api$Provider$Notification$previewNotificationPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['preview']),
	$author$project$Api$Provider$Notification$notificationsPath);
var $author$project$Api$Provider$Notification$typeToString = function (type_) {
	if (!type_) {
		return 'customer_invoice';
	} else {
		return 'employer_invoice_created';
	}
};
var $author$project$Api$Provider$Notification$preview = F6(
	function (apiClient, type_, recipient, contextId, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'context_id',
							$elm$json$Json$Encode$string(contextId)),
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Provider$Notification$typeToString(type_)))
						]),
						function () {
						if (!recipient.$) {
							var patientId = recipient.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'patient',
									$elm$json$Json$Encode$string(patientId))
								]);
						} else {
							var companyId = recipient.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'company',
									$elm$json$Json$Encode$string(companyId))
								]);
						}
					}(),
						function () {
						var _v1 = fields.Hp;
						if (!_v1.$) {
							var string = _v1.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'subject',
									$elm$json$Json$Encode$string(string))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = fields.e5;
						if (!_v2.$) {
							var string = _v2.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'body',
									$elm$json$Json$Encode$string(string))
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Notification$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Notification$previewNotificationPath)));
	});
var $author$project$Components$CompanyEmailModal$previewNotification = F3(
	function (apiClient, shared, formFields) {
		var fields = function () {
			var _v1 = A2($elm$core$Maybe$map, $rtfeldman$elm_validate$Validate$fromValid, formFields);
			if (!_v1.$) {
				var fields_ = _v1.a;
				return {e5: fields_.e5, Hp: fields_.Hp};
			} else {
				return {e5: $elm$core$Maybe$Nothing, Hp: $elm$core$Maybe$Nothing};
			}
		}();
		var _v0 = shared;
		var type_ = _v0.ahI;
		var contextId = _v0.wN;
		var recipient = _v0.Bm;
		return A6(
			$author$project$Api$Provider$Notification$preview,
			apiClient,
			type_,
			$author$project$Api$Provider$Notification$Company(
				$author$project$Api$Provider$Company$One$id(recipient)),
			contextId,
			fields,
			$author$project$Components$CompanyEmailModal$GotPreview);
	});
var $author$project$Components$CompanyEmailModal$init = F6(
	function (apiClient, type_, contextId, recipient, header, beforeSend) {
		var shared = {Ee: beforeSend, wN: contextId, qN: header, Bm: recipient, ahI: type_};
		return _Utils_Tuple2(
			$author$project$Components$CompanyEmailModal$Loading(shared),
			A3($author$project$Components$CompanyEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing));
	});
var $author$project$Api$Provider$Company$Invoice$makeViewable = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_viewable']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$makeViewable = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$makeViewable,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Components$Invoice$makeViewable = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			return function (_v1) {
				return $elm$core$Platform$Cmd$none;
			};
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A4($author$project$Api$Company$Invoice$makeViewable, apiClient, session, companyId, id);
		}
	});
var $author$project$Components$Invoice$initCompanyEmailModal = F4(
	function (apiClient, model, invoice, makeViewable_) {
		var _v0 = model.ab9;
		if (((!_v0.$) && (_v0.a.$ === 1)) && (!_v0.a.a.$)) {
			var company = _v0.a.a.a;
			var _v1 = makeViewable_ ? _Utils_Tuple2(
				$elm$core$Maybe$Just(
					$elm$core$String$concat(
						_List_fromArray(
							[
								'Sending this invoice to ',
								$author$project$Api$Provider$Company$One$name(company),
								' will make it available on their employer portal, and will also send them the email below. ',
								'Invoices can be shared while still in draft mode.'
							]))),
				$elm$core$Maybe$Just(
					A3($author$project$Components$Invoice$makeViewable, apiClient, model.ZD, model.Rr))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			var header = _v1.a;
			var cmd = _v1.b;
			var _v2 = A6(
				$author$project$Components$CompanyEmailModal$init,
				apiClient,
				1,
				$author$project$Api$Invoice$One$id(invoice),
				company,
				header,
				cmd);
			var companyEmailModal = _v2.a;
			var companyEmailModalCmd = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						hN: $elm$core$Maybe$Just(companyEmailModal)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CompanyEmailModalMsg, companyEmailModalCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Invoice$CreatePaymentModal$AffiliateBill = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Invoice$CreatePaymentModal$Invoice = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Company$companyPath = F2(
	function (session, companyId) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(companyId);
	});
var $author$project$Components$Invoice$sourceBasePath = F2(
	function (session, invoiceType) {
		if (!invoiceType.$) {
			var affiliateId = invoiceType.a;
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
		} else {
			var companyId = invoiceType.a;
			return $elm$core$Maybe$Just(
				A2($author$project$Api$Company$companyPath, session, companyId));
		}
	});
var $author$project$Components$Invoice$initCreatePaymentModal = F4(
	function (apiClient, model, invoice, external) {
		var createPaymentModalInvoice = function () {
			var _v1 = model.Rr;
			if (!_v1.$) {
				var affiliateId = _v1.a;
				return A2($author$project$Components$Invoice$CreatePaymentModal$AffiliateBill, affiliateId, invoice);
			} else {
				var companyId = _v1.a;
				return A2($author$project$Components$Invoice$CreatePaymentModal$Invoice, companyId, invoice);
			}
		}();
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.cO)(model.Hy)(
			A2($author$project$Components$Invoice$paymentsBasePath, model.ZD, model.Rr))(
			A2($author$project$Components$Invoice$sourceBasePath, model.ZD, model.Rr))(apiClient)(model.ZD)(model.WF)(model.FR)(model.sj)(
			function (d) {
				return _Utils_update(
					d,
					{O4: external, oo: model.FR});
			})(createPaymentModalInvoice);
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					lC: $elm$core$Maybe$Just(createPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$invoiceLinesTableCompany = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$ProviderMin(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$EmployerOrProviderCompany(company__);
			}
		},
		company);
};
var $author$project$Components$Invoice$InvoiceLinesTable$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$invoiceLinesTableInvoiceType = function (invoiceType) {
	if (!invoiceType.$) {
		var affiliateId = invoiceType.a;
		var id = invoiceType.b;
		return A2($author$project$Components$Invoice$InvoiceLinesTable$Affiliate, affiliateId, id);
	} else {
		var companyId = invoiceType.a;
		var id = invoiceType.b;
		return A2($author$project$Components$Invoice$InvoiceLinesTable$Company, companyId, id);
	}
};
var $author$project$Components$Invoice$Summary$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$Summary$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$invoiceSummaryCompany = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Components$Invoice$Summary$ProviderMin(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Components$Invoice$Summary$EmployerOrProviderCompany(company__);
			}
		},
		company);
};
var $author$project$Api$Provider$Invoice$One$isUpdating = function (_v0) {
	var record = _v0.b;
	return record.Sg;
};
var $author$project$Api$Invoice$One$isUpdating = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$isUpdating(invoice_);
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$Issued = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Employer$Invoice$issue = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['issue']),
					$author$project$Api$Employer$Invoice$invoicePath(id))));
	});
var $author$project$Api$Provider$Company$Invoice$issue = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['issue']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$issue = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Invoice$issue,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Invoice$issue,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Api$Provider$AffiliateBill$issue = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['issue']),
					$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
	});
var $author$project$Components$Invoice$issue = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$issue,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$Issued,
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5($author$project$Api$Company$Invoice$issue, apiClient, session, companyId, id, $author$project$Components$Invoice$Issued);
		}
	});
var $author$project$Components$Invoice$MarkedAsBadDebt = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Invoice$markAsBadDebt = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['mark_as_bad_debt']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$markAsBadDebt = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$markAsBadDebt,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Components$Invoice$markAsBadDebt = F4(
	function (apiClient, session, invoiceType, invoice) {
		if (!invoiceType.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5(
				$author$project$Api$Company$Invoice$markAsBadDebt,
				apiClient,
				session,
				companyId,
				id,
				$author$project$Components$Invoice$MarkedAsBadDebt(invoice));
		}
	});
var $author$project$Components$Invoice$PollInvoiceStatus = {$: 33};
var $author$project$Components$Invoice$pollInvoiceForStatus = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Components$Invoice$PollInvoiceStatus;
	},
	$elm$core$Process$sleep(2000));
var $author$project$Api$Common$Invoice$Summary$Summary = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$Record = F9(
	function (sponsorFeeDealLines, activeLines, allLines, byPlan, byEmployeeDivision, bySponsor, membershipAdjustmentLines, nonMembershipAdjustmentLines, byCategory) {
		return {Ie: activeLines, IR: allLines, Ki: byCategory, Kj: byEmployeeDivision, Kk: byPlan, Kl: bySponsor, TC: membershipAdjustmentLines, UK: nonMembershipAdjustmentLines, _v: sponsorFeeDealLines};
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$ActiveLines = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Record = function (totals) {
	return {Dx: totals};
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$TotalsRecord = F3(
	function (count, numberOfDependents, amountInCents) {
		return {I2: amountInCents, LY: count, UR: numberOfDependents};
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number_of_dependents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'count',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$TotalsRecord))));
var $author$project$Api$Common$Invoice$Summary$ActiveLines$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totals',
	$author$project$Api$Common$Invoice$Summary$ActiveLines$totalsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$Record));
var $author$project$Api$Common$Invoice$Summary$ActiveLines$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$ActiveLines$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$AllLines$AllLines = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$AllLines$Record = function (totals) {
	return {Dx: totals};
};
var $author$project$Api$Common$Invoice$Summary$AllLines$TotalsRecord = F2(
	function (amountInCents, count) {
		return {I2: amountInCents, LY: count};
	});
var $author$project$Api$Common$Invoice$Summary$AllLines$totalsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$AllLines$TotalsRecord)));
var $author$project$Api$Common$Invoice$Summary$AllLines$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totals',
	$author$project$Api$Common$Invoice$Summary$AllLines$totalsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$AllLines$Record));
var $author$project$Api$Common$Invoice$Summary$AllLines$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$AllLines$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$ByCategory$ByCategory = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$ByCategory$Record = function (nonMembershipAdjustmentLines) {
	return {UK: nonMembershipAdjustmentLines};
};
var $author$project$Api$Common$Invoice$Summary$ByCategory$NonMembershipAdjustmentLinesRecord = function (rows) {
	return {YQ: rows};
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Row = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Record = F3(
	function (count, amountInCents, categoryName) {
		return {I2: amountInCents, KM: categoryName, LY: count};
	});
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'category_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'count',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Record))));
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ByCategory$NonMembershipAdjustmentLinesRecord));
var $author$project$Api$Common$Invoice$Summary$ByCategory$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'non_membership_adjustment_lines',
	$author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ByCategory$Record));
var $author$project$Api$Common$Invoice$Summary$ByCategory$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$ByCategory$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$Grouped$Grouped = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$Grouped$Record = F2(
	function (activeLines, membershipAdjustmentLines) {
		return {Ie: activeLines, TC: membershipAdjustmentLines};
	});
var $author$project$Api$Common$Invoice$Summary$Grouped$ActiveLinesRecord = function (rows) {
	return {YQ: rows};
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Row = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Record = F6(
	function (count, amountInCents, numberOfDependents, planName, divisionName, companyName) {
		return {I2: amountInCents, Lw: companyName, LY: count, NV: divisionName, UR: numberOfDependents, Wo: planName};
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'company_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'division_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'plan_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'number_of_dependents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'count',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Record)))))));
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$ActiveLines$Row$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$ActiveLinesRecord));
var $author$project$Api$Common$Invoice$Summary$Grouped$MembershipAdjustmentLinesRecord = function (rows) {
	return {YQ: rows};
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Row = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Record = F7(
	function (count, amountInCents, planName, divisionName, companyName, numberOfOtherCharges, numberOfMembershipCharges) {
		return {I2: amountInCents, Lw: companyName, LY: count, NV: divisionName, UT: numberOfMembershipCharges, UU: numberOfOtherCharges, Wo: planName};
	});
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'number_of_membership_charges',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number_of_other_charges',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'company_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'division_name',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'plan_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'count',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Record))))))));
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$MembershipAdjustmentLinesRecord));
var $author$project$Api$Common$Invoice$Summary$Grouped$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_adjustment_lines',
	$author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'active_lines',
		$author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$Record)));
var $author$project$Api$Common$Invoice$Summary$Grouped$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$Grouped$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$MembershipAdjustmentLines = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Record = function (totals) {
	return {Dx: totals};
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$TotalsRecord = F4(
	function (count, amountInCents, numberOfOtherCharges, numberOfMembershipCharges) {
		return {I2: amountInCents, LY: count, UT: numberOfMembershipCharges, UU: numberOfOtherCharges};
	});
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'number_of_membership_charges',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'number_of_other_charges',
		$elm$json$Json$Decode$int,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'amount_in_cents',
			$elm$json$Json$Decode$int,
			0,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'count',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$TotalsRecord)))));
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totals',
	$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Record));
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$NonMembershipAdjustmentLines = $elm$core$Basics$identity;
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Record = function (totals) {
	return {Dx: totals};
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$TotalsRecord = F2(
	function (count, amountInCents) {
		return {I2: amountInCents, LY: count};
	});
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'amount_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$TotalsRecord)));
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'totals',
	$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Record));
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$SponsorFeeDealLine = 0;
var $author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Common$Invoice$Summary$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'by_category',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$ByCategory$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'non_membership_adjustment_lines',
		$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'membership_adjustment_lines',
			$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'by_sponsor',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'by_employee_division',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'by_plan',
						$elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'all_lines',
							$author$project$Api$Common$Invoice$Summary$AllLines$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'active_lines',
								$author$project$Api$Common$Invoice$Summary$ActiveLines$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sponsor_fee_deal_lines',
									$elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$decoder),
									$elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Record))))))))));
var $author$project$Api$Common$Invoice$Summary$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Invoice$Summary$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$Summary$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Summary$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['summary']),
					$author$project$Api$Employer$Invoice$invoicePath(id))));
	});
var $author$project$Api$Provider$Invoice$Summary$retrieve = F4(
	function (apiClient, companyId, invoiceId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Summary$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['summary']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId))));
	});
var $author$project$Api$Company$Invoice$Summary$retrieve = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$Summary$retrieve, apiClient, id, toMsg) : A4($author$project$Api$Provider$Invoice$Summary$retrieve, apiClient, companyId, id, toMsg);
	});
var $author$project$Api$Provider$AffiliateBill$Summary$retrieve = F3(
	function (apiClient, affiliateBillId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Invoice$Summary$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['summary']),
					$author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId))));
	});
var $author$project$Components$Invoice$GotCompanyInvoiceStatus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$retrieveInvoiceStatus = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$retrieve,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$GotCompanyInvoiceStatus,
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5($author$project$Api$Company$Invoice$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$GotCompanyInvoiceStatus);
		}
	});
var $author$project$Components$Invoice$ReturnedToDraft = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Invoice$returnToDraft = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['return_to_draft']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$returnToDraft = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$returnToDraft,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Api$Provider$AffiliateBill$returnToDraft = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['return_to_draft']),
					$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
	});
var $author$project$Components$Invoice$returnToDraft = F4(
	function (apiClient, session, invoiceType, invoice) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$returnToDraft,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$ReturnedToDraft(invoice),
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5(
				$author$project$Api$Company$Invoice$returnToDraft,
				apiClient,
				session,
				companyId,
				id,
				$author$project$Components$Invoice$ReturnedToDraft(invoice));
		}
	});
var $author$project$Components$Invoice$ReversedBadDebt = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$Company$Invoice$reverseBadDebt = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reverse_bad_debt']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$reverseBadDebt = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$reverseBadDebt,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Components$Invoice$reverseBadDebt = F3(
	function (apiClient, session, invoiceType) {
		if (!invoiceType.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5($author$project$Api$Company$Invoice$reverseBadDebt, apiClient, session, companyId, id, $author$project$Components$Invoice$ReversedBadDebt);
		}
	});
var $author$project$Components$AuditTrailLog$GotAudits = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Audit$Audit = $elm$core$Basics$identity;
var $author$project$Api$Audit$AuditRecord = F7(
	function (id, name, createdAt, whodunnit, crumbs, role, aggregate) {
		return {vj: aggregate, Mf: createdAt, Mo: crumbs, adR: id, zh: name, agy: role, aa2: whodunnit};
	});
var $author$project$Api$Audit$Crumb$Crumb = F4(
	function (createdAt, item, diff, verb) {
		return {Mf: createdAt, NG: diff, FU: item, aaO: verb};
	});
var $author$project$Api$Audit$Crumb$Plain = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Audit$Crumb$Record = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Audit$Crumb$Linkable = F5(
	function (id, label, routeParts, type_, extraUrl) {
		return {adh: extraUrl, adR: id, aej: label, agz: routeParts, ahI: type_};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Api$Audit$Crumb$linkableDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Api$Audit$Crumb$Linkable,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['id']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['label']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['route_parts']),
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['type']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['extra_url']),
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Audit$Crumb$decodeChange = A2(
	$elm$json$Json$Decode$andThen,
	function (changesList) {
		if ((changesList.b && changesList.b.b) && (!changesList.b.b.b)) {
			var from = changesList.a;
			var _v1 = changesList.b;
			var to = _v1.a;
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2(from, to));
		} else {
			return $elm$json$Json$Decode$fail('Expected changes to be of length 2');
		}
	},
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$nullable(
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$map, $author$project$Api$Audit$Crumb$Plain, $elm$json$Json$Decode$string),
						A2(
						$elm$json$Json$Decode$map,
						$author$project$Api$Audit$Crumb$Plain,
						A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)),
						A2(
						$elm$json$Json$Decode$map,
						$author$project$Api$Audit$Crumb$Plain,
						A2($elm$json$Json$Decode$map, $author$project$Formatters$Bool$toString, $elm$json$Json$Decode$bool)),
						A2($elm$json$Json$Decode$map, $author$project$Api$Audit$Crumb$Record, $author$project$Api$Audit$Crumb$linkableDecoder)
					])))));
var $author$project$Api$Audit$Crumb$Create = 0;
var $author$project$Api$Audit$Crumb$Delete = 2;
var $author$project$Api$Audit$Crumb$Update = 1;
var $author$project$Api$Audit$Crumb$decodeEvent = A2(
	$elm$json$Json$Decode$andThen,
	function (stringEvent) {
		switch (stringEvent) {
			case 'create':
				return $elm$json$Json$Decode$succeed(0);
			case 'update':
				return $elm$json$Json$Decode$succeed(1);
			case 'destroy':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var unsupported = stringEvent;
				return $elm$json$Json$Decode$fail('unsupported event type ' + unsupported);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Audit$Crumb$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'event',
	$author$project$Api$Audit$Crumb$decodeEvent,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'object_changes',
		$elm$json$Json$Decode$keyValuePairs($author$project$Api$Audit$Crumb$decodeChange),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'item',
			$author$project$Api$Audit$Crumb$linkableDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				$elm$json$Json$Decode$succeed($author$project$Api$Audit$Crumb$Crumb)))));
var $author$project$Api$Audit$Whodunnit = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Audit$decodeWhodunnit = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Audit$Whodunnit)));
var $author$project$Api$Audit$auditRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'aggregate',
	$elm$json$Json$Decode$maybe($author$project$Api$Audit$Crumb$linkableDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'request_session_role',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'crumbs',
			$elm$json$Json$Decode$list($author$project$Api$Audit$Crumb$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'whodunnit',
				$author$project$Api$Audit$decodeWhodunnit,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Audit$AuditRecord))))))));
var $author$project$Api$Audit$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Audit$auditRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Audit$listDefaults = {
	Fi: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	G0: $elm$core$Maybe$Nothing,
	G1: $elm$core$Maybe$Nothing,
	Hg: $elm$core$Maybe$Just('request')
};
var $author$project$Api$Audit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Audit$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Pagination$toApiParams(options.afy),
				function () {
				var _v0 = options.Hg;
				if (!_v0.$) {
					var source_ = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'source', source_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.G0;
				if (!_v1.$) {
					var resource_ = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'resource', resource_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.G1;
				if (!_v2.$) {
					var resourceId_ = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'resource_id', resourceId_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.Fi;
				if (!_v3.$) {
					var filter_ = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', filter_)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Audit$list = F3(
	function (apiClient, query, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Audit$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Audit$listOptionsToParams(query),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['audits']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Components$AuditTrailLog$fetchAudits = F2(
	function (apiClient, optionals) {
		return A3($author$project$Api$Audit$list, apiClient, optionals, $author$project$Components$AuditTrailLog$GotAudits);
	});
var $author$project$Components$AuditTrailLog$optionalsFromModel = function (_v0) {
	var pagination = _v0.afy;
	var resource = _v0.G0;
	var resourceId = _v0.G1;
	var filter = _v0.Fi;
	return function (d) {
		return _Utils_update(
			d,
			{Fi: filter, afy: pagination, G0: resource, G1: resourceId});
	};
};
var $author$project$Components$AuditTrailLog$setPagination = function (model) {
	var _v0 = model.pz;
	if (_v0.$ === 3) {
		var records = _v0.a;
		var headers = _v0.b;
		return _Utils_update(
			model,
			{
				afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
				cr: _Utils_ap(model.cr, records)
			});
	} else {
		return model;
	}
};
var $author$project$Components$AuditTrailLog$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var showingAuditDetails = $author$project$Ui$Popover$isOpen(model.aM) ? model.cr : _List_Nil;
				var popover = A3(
					$author$project$Ui$Popover$init,
					'audit-history',
					!$author$project$Ui$Popover$isOpen(model.aM),
					$author$project$Components$AuditTrailLog$PopoverMsg);
				var pagination = $author$project$Ui$Popover$isOpen(model.aM) ? $author$project$Api$Pagination$init : model.afy;
				var auditsCmd = $author$project$Ui$Popover$isOpen(model.aM) ? $elm$core$Platform$Cmd$none : A2(
					$author$project$Components$AuditTrailLog$fetchAudits,
					apiClient,
					$author$project$Components$AuditTrailLog$optionalsFromModel(model));
				return {
					EC: auditsCmd,
					y8: _Utils_update(
						model,
						{afy: pagination, aM: popover, cr: showingAuditDetails}),
					as: _List_Nil
				};
			case 1:
				var paginationMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, paginationMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return {
					EC: A2(
						$author$project$Components$AuditTrailLog$fetchAudits,
						apiClient,
						$author$project$Components$AuditTrailLog$optionalsFromModel(newModel)),
					y8: newModel,
					as: _List_Nil
				};
			case 2:
				var audits = msg.a;
				var totalAuditsCount = function () {
					if (audits.$ === 3) {
						var headers = audits.b;
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$String$toInt,
								A2($elm$core$Dict$get, 'x-total-count', headers)));
					} else {
						return 0;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$none,
					y8: $author$project$Components$AuditTrailLog$setPagination(
						_Utils_update(
							model,
							{pz: audits, Dw: totalAuditsCount})),
					as: $author$project$OutMsg$handleErrorResponse(audits)
				};
			default:
				var subMsg = msg.a;
				var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aM);
				var pagination = $author$project$Ui$Popover$isOpen(model.aM) ? $author$project$Api$Pagination$init : model.afy;
				return {
					EC: $elm$core$Platform$Cmd$none,
					y8: _Utils_update(
						model,
						{afy: pagination, aM: popoverModel}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$update = F3(
	function (_v0, msg, _v1) {
		var model = _v1;
		if (!msg.$) {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{DL: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		} else {
			var field = msg.a;
			var copiedText = msg.b;
			return _Utils_Tuple3(
				model,
				$author$project$Ports$Clipboard$copy(copiedText),
				_List_fromArray(
					[
						A2($author$project$OutMsg$ShowToast, 3, field + ' copied to clipboard')
					]));
		}
	});
var $author$project$Components$CompanyEmailModal$BeforeSent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CompanyEmailModal$Closed = 0;
var $author$project$Components$CompanyEmailModal$Delivered = 1;
var $author$project$Components$CompanyEmailModal$Editing = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Components$CompanyEmailModal$None = 2;
var $author$project$Components$CompanyEmailModal$Open = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$CompanyEmailModal$GotDelivery = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Notification$Shared$body = function (_v0) {
	var record = _v0;
	return record.e5;
};
var $author$project$Api$Provider$Notification$One$body = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$body(shared);
};
var $author$project$Api$Provider$Notification$create = F6(
	function (apiClient, type_, recipient, contextId, fields, toMsg) {
		var body_ = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'notification',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'context_id',
								$elm$json$Json$Encode$string(contextId)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'type',
									$elm$json$Json$Encode$string(
										$author$project$Api$Provider$Notification$typeToString(type_))),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'subject',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Hp)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'body',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.e5)),
										function () {
											if (!recipient.$) {
												var patientId = recipient.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'patient',
														$elm$json$Json$Encode$string(patientId))
													]);
											} else {
												var companyId = recipient.a;
												return _List_fromArray(
													[
														_Utils_Tuple2(
														'company',
														$elm$json$Json$Encode$string(companyId))
													]);
											}
										}()))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Notification$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body_,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Notification$notificationsPath)));
	});
var $author$project$Api$Provider$Notification$Shared$subject = function (_v0) {
	var record = _v0;
	return record.Hp;
};
var $author$project$Api$Provider$Notification$One$subject = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$subject(shared);
};
var $author$project$Components$CompanyEmailModal$createNotification = F3(
	function (apiClient, _v0, preview) {
		var type_ = _v0.ahI;
		var contextId = _v0.wN;
		var recipient = _v0.Bm;
		return A6(
			$author$project$Api$Provider$Notification$create,
			apiClient,
			type_,
			$author$project$Api$Provider$Notification$Company(
				$author$project$Api$Provider$Company$One$id(recipient)),
			contextId,
			{
				e5: $author$project$Api$Provider$Notification$One$body(preview),
				Hp: $author$project$Api$Provider$Notification$One$subject(preview)
			},
			$author$project$Components$CompanyEmailModal$GotDelivery);
	});
var $author$project$Components$CompanyEmailModal$initNotificationFormFields = function (notification) {
	return {
		e5: $author$project$Api$Provider$Notification$One$body(notification),
		Hp: $author$project$Api$Provider$Notification$One$subject(notification)
	};
};
var $author$project$Components$CompanyEmailModal$notificationFormFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					Hp: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					e5: $author$project$Utils$String$toMaybe(string)
				});
		}
	});
var $author$project$Components$CompanyEmailModal$BodyValidation = 1;
var $author$project$Components$CompanyEmailModal$SubjectValidation = 0;
var $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Hp;
			},
			_Utils_Tuple2(0, 'Please enter a valid subject')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.e5;
			},
			_Utils_Tuple2(1, 'Please enter a valid body'))
		]));
var $author$project$Components$CompanyEmailModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 1:
				if (model.$ === 2) {
					var shared = model.a;
					var notificationForm = model.b;
					var preview = model.c;
					var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator, notificationForm);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var newForm = _v3.a;
						var validFormFields = _v3.b;
						return {
							EC: A3(
								$author$project$Components$CompanyEmailModal$previewNotification,
								apiClient,
								shared,
								$elm$core$Maybe$Just(validFormFields)),
							ac5: 2,
							y8: A3($author$project$Components$CompanyEmailModal$Editing, shared, newForm, $author$project$Api$Data$Loading),
							as: _List_Nil
						};
					} else {
						var newForm = _v2.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: A3($author$project$Components$CompanyEmailModal$Editing, shared, newForm, preview),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
				}
			case 2:
				if (model.$ === 1) {
					var shared = model.a;
					var preview = model.b;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: A3(
							$author$project$Components$CompanyEmailModal$Editing,
							shared,
							$author$project$Utils$Form$init(
								$author$project$Components$CompanyEmailModal$initNotificationFormFields(preview)),
							$author$project$Api$Data$NotAsked),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
				}
			case 3:
				if (model.$ === 1) {
					var shared = model.a;
					var preview = model.b;
					return {
						EC: function () {
							var _v6 = shared.Ee;
							if (!_v6.$) {
								var beforeSend = _v6.a;
								return beforeSend($author$project$Components$CompanyEmailModal$BeforeSent);
							} else {
								return A3($author$project$Components$CompanyEmailModal$createNotification, apiClient, shared, preview);
							}
						}(),
						ac5: 2,
						y8: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$Loading),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
				}
			case 4:
				var response = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var preview = model.b;
					if (response.$ === 3) {
						return {
							EC: A3($author$project$Components$CompanyEmailModal$createNotification, apiClient, shared, preview),
							ac5: 2,
							y8: model,
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
				}
			case 5:
				var response = msg.a;
				var _v9 = _Utils_Tuple2(model, response);
				switch (_v9.a.$) {
					case 0:
						if (_v9.b.$ === 3) {
							var shared = _v9.a.a;
							var _v10 = _v9.b;
							var preview = _v10.a;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 2,
								y8: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
								as: _List_Nil
							};
						} else {
							var shared = _v9.a.a;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$CompanyEmailModal$Loading(shared),
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						}
					case 2:
						if (_v9.b.$ === 3) {
							var _v11 = _v9.a;
							var shared = _v11.a;
							var _v12 = _v9.b;
							var preview = _v12.a;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 2,
								y8: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
								as: _List_Nil
							};
						} else {
							var _v13 = _v9.a;
							var shared = _v13.a;
							var notificationForm = _v13.b;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 2,
								y8: A3($author$project$Components$CompanyEmailModal$Editing, shared, notificationForm, response),
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						}
					default:
						return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
				}
			case 6:
				var field = msg.a;
				if (model.$ === 2) {
					var shared = model.a;
					var notificationForm = model.b;
					var preview = model.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CompanyEmailModal$notificationFormFieldsUpdate, field, notificationForm);
					var validatedForm = function () {
						var _v15 = A2($author$project$Utils$Form$validate, $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator, newForm);
						if (!_v15.$) {
							var _v16 = _v15.a;
							var form = _v16.a;
							return form;
						} else {
							var form = _v15.a;
							return form;
						}
					}();
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: A3($author$project$Components$CompanyEmailModal$Editing, shared, validatedForm, preview),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
				}
			default:
				var response = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var preview = model.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: model,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'This email is being sent')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, response),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 2, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Affiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$InvoiceLinesChanged = 0;
var $author$project$Components$Invoice$InvoiceLinesTable$None = 1;
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath = F2(
	function (affiliateBillId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath(affiliateBillId));
	});
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$delete = F4(
	function (apiClient, affiliateBillId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath, affiliateBillId, id)));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath = F3(
	function (companyId, invoiceId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			A2($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath, companyId, invoiceId));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$delete = F5(
	function (apiClient, companyId, invoiceId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A3($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath, companyId, invoiceId, id)));
	});
var $author$project$Api$Provider$InvoiceLine$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$InvoiceLine$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceLine$Shared$id(shared);
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$init = F4(
	function (session, invoiceType, usesEmployeeDivisions, invoiceLine) {
		return {wS: $author$project$Api$Data$NotAsked, q0: invoiceLine, fN: $author$project$Api$Data$NotAsked, Rr: invoiceType, ZD: session, om: false, aaF: usesEmployeeDivisions};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$adjustmentModalCompany = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ProviderMin(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EmployerOrProviderCompany(company__);
			}
		},
		company);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCategories = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit = F5(
	function (apiClient, showItemTypeInTitle, session, today, category) {
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false});
			});
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false});
			});
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = $author$project$Components$DateInput$init;
		var endDateInput = _v3.a;
		var endDateInputCmd = _v3.b;
		var _v4 = A4(
			$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
			showItemTypeInTitle,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'None', IS: false, adB: true, adC: '', aeZ: false});
			});
		var chargeItemResourceFilter = _v4.a;
		var chargeItemResourceFilterCmd = _v4.b;
		var _v5 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false});
			});
		var categoryResourceFilter = _v5.a;
		var categoryResourceFilterCmd = _v5.b;
		return _Utils_Tuple2(
			{
				Ex: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$All$id, category),
				cJ: categoryResourceFilter,
				lp: $elm$core$Maybe$Nothing,
				cK: chargeItemResourceFilter,
				Nx: '',
				NI: 0,
				NJ: false,
				qs: $elm$core$Maybe$Nothing,
				qu: endDateInput,
				adR: $elm$core$Maybe$Nothing,
				aet: $elm$core$Maybe$Nothing,
				rl: locationResourceFilter,
				zh: $elm$core$Maybe$Nothing,
				VM: $elm$core$Maybe$Nothing,
				afS: $elm$core$Maybe$Nothing,
				jC: practitionerResourceFilter,
				Ba: $elm$core$Maybe$Nothing,
				W$: $elm$core$Maybe$Nothing,
				Bd: $elm$core$Maybe$Just(1),
				Be: $elm$core$Maybe$Nothing,
				_E: $elm$core$Maybe$Just(today),
				kg: startDateInput,
				$u: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$Account$companyAccountsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['accounts']),
		basePath);
};
var $author$project$Api$Provider$CompanyAccount$All$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAccount$All$Record = function (registrations) {
	return function (subscriber) {
		return function (division) {
			return function (membershipStartDate) {
				return function (defaultEnrollmentStartDate) {
					return function (invoicedThroughDate) {
						return function (membershipEndDate) {
							return function (status) {
								return function (plan) {
									return function (meta) {
										return {M7: defaultEnrollmentStartDate, NT: division, Rs: invoicedThroughDate, TE: membershipEndDate, TK: membershipStartDate, TU: meta, GH: plan, age: registrations, ag7: status, _3: subscriber};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CompanyAccount$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyAccount$Meta$Record = F2(
	function (actions, membership) {
		return {tF: actions, ja: membership};
	});
var $author$project$Api$Provider$CompanyAccount$Meta$ActionsRecord = F3(
	function (needsApproval, canEnroll, isEligible) {
		return {Ks: canEnroll, RK: isEligible, Um: needsApproval};
	});
var $author$project$Api$Provider$CompanyAccount$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eligible',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enroll',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'needs_approval',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$ActionsRecord))));
var $author$project$Api$Provider$CompanyAccount$Meta$MembershipRecord = F3(
	function (billFromDate, billingStartDate, endDate) {
		return {JX: billFromDate, J$: billingStartDate, qs: endDate};
	});
var $author$project$Api$Provider$CompanyAccount$Meta$EndDateRecord = F4(
	function (defaultValue, maxWithoutBilling, min, minWithoutProration) {
		return {Nm: defaultValue, Tt: maxWithoutBilling, TZ: min, T0: minWithoutProration};
	});
var $author$project$Api$Provider$CompanyAccount$Meta$endDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'min_without_proration',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'max_without_billing',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_value',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$EndDateRecord)))));
var $author$project$Api$Provider$CompanyAccount$Meta$membershipRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$author$project$Api$Provider$CompanyAccount$Meta$endDateRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bill_from_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$MembershipRecord))));
var $author$project$Api$Provider$CompanyAccount$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership',
	$author$project$Api$Provider$CompanyAccount$Meta$membershipRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Provider$CompanyAccount$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$Record)));
var $author$project$Api$Provider$CompanyAccount$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$Record = F5(
	function (patient, account, status, membershipStartDate, meta) {
		return {H3: account, TK: membershipStartDate, TU: meta, VM: patient, ag7: status};
	});
var $author$project$Api$Provider$Meta$CompanyRegistration$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Meta$CompanyRegistration$Record = function (actions) {
	return {tF: actions};
};
var $author$project$Api$Provider$Meta$CompanyRegistration$ActionsRecord = F3(
	function (enroll, needsApproval, isEligible) {
		return {OC: enroll, RK: isEligible, Um: needsApproval};
	});
var $author$project$Api$Provider$Meta$CompanyRegistration$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eligible',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'needs_approval',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enroll',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Meta$CompanyRegistration$ActionsRecord))));
var $author$project$Api$Provider$Meta$CompanyRegistration$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Provider$Meta$CompanyRegistration$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Meta$CompanyRegistration$Record));
var $author$project$Api$Provider$Meta$CompanyRegistration$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Meta$CompanyRegistration$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Meta$CompanyRegistration$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'account',
				$author$project$Api$Provider$CompanyAccount$Min$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patient',
					$author$project$Api$Provider$Patient$Min$decoder,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$Record))))));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration)));
var $author$project$Api$Provider$CompanyAccount$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$CompanyAccount$Meta$decoder,
	A3(
		$author$project$Api$Expandable$expandable,
		'plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membership_end_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invoiced_through_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_enrollment_start_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'membership_start_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'division',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'subscriber',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'registrations',
										$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$decoder),
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$All$Record)))))))))));
var $author$project$Api$Provider$CompanyAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$All$CompanyAccount)));
var $author$project$Api$Provider$Company$Account$expandToString = function (expand) {
	switch (expand) {
		case 2:
			return 'plan';
		case 1:
			return 'registrations';
		default:
			return 'membership_patients';
	}
};
var $author$project$Api$Provider$Company$Account$listDefaults = {Fc: _List_Nil, Fi: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Company$Account$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Company$Account$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var q = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', q)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Fi;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Company$Account$expandToString, options.Fc),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Company$Account$list = F4(
	function (apiClient, basePath, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Company$Account$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$Account$companyAccountsPath(basePath))));
	});
var $author$project$Api$Provider$CompanyAccount$All$registrations = function (_v0) {
	var record = _v0.b;
	return record.age;
};
var $author$project$Components$ResourceFilter$CompanyRegistration$list = F4(
	function (apiClient, basePath, optionals, toMsg) {
		return A4(
			$author$project$Api$Provider$Company$Account$list,
			apiClient,
			basePath,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$concatMap($author$project$Api$Provider$CompanyAccount$All$registrations))));
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$fetchResources = F6(
	function (basePath, listOptionals, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$CompanyRegistration$list,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$retrieveResource = F5(
	function (basePath, listOptionals, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$CompanyRegistration$list,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$selectId = 'company-reigstrations';
var $author$project$Api$Provider$Patient$Min$name = function (_v0) {
	var min = _v0;
	return min.zh;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Components$ResourceFilter$CompanyRegistration$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$name);
var $author$project$Components$ResourceFilter$CompanyRegistration$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CompanyRegistration$toTitle(resource))
		]);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$CompanyRegistration$toValue = $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id;
var $author$project$Components$ResourceFilter$CompanyRegistration$init = F4(
	function (apiClient, basePath, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: A2($author$project$Components$ResourceFilter$CompanyRegistration$fetchResources, basePath, listOptionals),
				adR: $author$project$Components$ResourceFilter$CompanyRegistration$selectId,
				gx: 'Registration',
				st: A2($author$project$Components$ResourceFilter$CompanyRegistration$retrieveResource, basePath, listOptionals),
				ahw: $author$project$Components$ResourceFilter$CompanyRegistration$toLabel,
				ahA: $author$project$Components$ResourceFilter$CompanyRegistration$toTitle,
				g0: $author$project$Components$ResourceFilter$CompanyRegistration$toValue
			},
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{Ch: false});
				}));
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Provider$InvoiceLine$One$InvoiceLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$InvoiceLine$One$Record = F3(
	function (status, charges, companyAccount) {
		return {KU: charges, Lr: companyAccount, ag7: status};
	});
var $author$project$Api$Provider$Charge$One$Charge = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$Shared$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$Shared$Record = function (id) {
	return function (name) {
		return function (issuedSubtotalInCents) {
			return function (subtotalInCents) {
				return function (totalInCents) {
					return function (description) {
						return function (issuedPriceInCents) {
							return function (priceInCents) {
								return function (issuedQuantity) {
									return function (quantity) {
										return function (discountOverridden) {
											return function (discountInCents) {
												return function (date) {
													return function (endDate) {
														return function (taxable) {
															return function (type_) {
																return function (isPersisted) {
																	return {MO: date, Nx: description, NI: discountInCents, NJ: discountOverridden, qs: endDate, adR: id, R$: isPersisted, Sj: issuedPriceInCents, Sk: issuedQuantity, Sm: issuedSubtotalInCents, zh: name, Ba: priceInCents, Bd: quantity, _7: subtotalInCents, $u: taxable, $X: totalInCents, ahI: type_};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Charge$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_persisted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'taxable',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'end_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'date',
					$author$project$Utils$Date$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'discount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'discount_overridden',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'quantity',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'issued_quantity',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'price_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'issued_price_in_cents',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'description',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'total_in_cents',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'subtotal_in_cents',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'issued_subtotal_in_cents',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'name',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Shared$Record))))))))))))))))));
var $author$project$Api$Provider$Charge$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$One$Record = function (practitioner) {
	return function (location) {
		return function (priceUom) {
			return function (quantityUom) {
				return function (issuedQuantityUom) {
					return function (chargeItem) {
						return function (category) {
							return function (patient) {
								return function (invoice) {
									return function (isLocked) {
										return function (rulePayer) {
											return function (meta) {
												return function (prepaidCharges) {
													return function (consumedPrepaidCharges) {
														return {Ex: category, lp: chargeItem, LJ: consumedPrepaidCharges, Rh: invoice, RP: isLocked, Sl: issuedQuantityUom, aet: location, TU: meta, VM: patient, afS: practitioner, WW: prepaidCharges, W$: priceUom, Be: quantityUom, YX: rulePayer};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Charge$RulePayer$Patient = 1;
var $author$project$Api$Charge$RulePayer$Sponsor = 0;
var $author$project$Api$Charge$RulePayer$rulePayerDecoder = function (string) {
	switch (string) {
		case 'sponsor':
			return $elm$json$Json$Decode$succeed(0);
		case 'patient':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail('Unsupported charge rule payer: ' + string);
	}
};
var $author$project$Api$Charge$RulePayer$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$Charge$RulePayer$rulePayerDecoder, $elm$json$Json$Decode$string);
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Common$Payable$Invoice$Min$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Common$Payable$Invoice$Min$Record = F7(
	function (type_, id, invoiceNumber, status, date, humanStatus, paymentScheduledOn) {
		return {MO: date, QE: humanStatus, adR: id, Rq: invoiceNumber, V2: paymentScheduledOn, ag7: status, ahI: type_};
	});
var $author$project$Api$Common$Payable$Invoice$Type$CompanyInvoice = 0;
var $author$project$Api$Common$Payable$Invoice$Type$CustomerInvoice = 1;
var $author$project$Api$Common$Payable$Invoice$Type$PracticeInvoice = 2;
var $author$project$Api$Common$Payable$Invoice$Type$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'Invoice':
				return $elm$json$Json$Decode$succeed(0);
			case 'CustomerInvoice':
				return $elm$json$Json$Decode$succeed(1);
			case 'PracticeInvoice':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unsupported invoice type: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Payable$Invoice$Min$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'payment_scheduled_on',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'human_status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'date',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invoice_number',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$author$project$Api$Common$Payable$Invoice$Type$decoder,
							$elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$Min$Record))))))));
var $author$project$Api$Common$Payable$Invoice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Payable$Invoice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$Record = function (owner) {
	return {Vp: owner};
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'owner',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$MinWithOwner$Record));
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Payable$Invoice$MinWithOwner$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Payable$Invoice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$MinWithOwner$Invoice)));
var $author$project$Api$Provider$ChargeItem$ForCharge$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$ForCharge$Record = function (uom) {
	return {aam: uom};
};
var $author$project$Api$Provider$ChargeItem$ForCharge$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uom',
	$author$project$Api$Provider$Uom$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForCharge$Record));
var $author$project$Api$Provider$ChargeItem$ForCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$ForCharge$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForCharge$ChargeItem)));
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Patient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Record = F2(
	function (practitioner, location) {
		return {aet: location, afS: practitioner};
	});
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Record)));
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Patient)));
var $author$project$Api$Provider$PrepaidCharge$PrepaidCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PrepaidCharge$PrepaidChargeRecord = F6(
	function (id, originalQuantity, remainingQuantity, priceInCents, chargeItem, charge) {
		return {abU: charge, lp: chargeItem, adR: id, Vi: originalQuantity, Ba: priceInCents, X9: remainingQuantity};
	});
var $author$project$Api$Provider$PrepaidCharge$Charge = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$PrepaidCharge$chargeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PrepaidCharge$Charge)));
var $author$project$Api$Provider$PrepaidCharge$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'charge',
		A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Api$Provider$PrepaidCharge$chargeDecoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge_item',
			$author$project$Api$Provider$ChargeItem$Min$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'price_in_cents',
				$author$project$Currency$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'remaining_quantity',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'original_quantity',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$PrepaidCharge$PrepaidChargeRecord))))))));
var $author$project$Api$Provider$Charge$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'consumed_prepaid_charges',
	$elm$json$Json$Decode$list($author$project$Api$Provider$PrepaidCharge$decoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'prepaid_charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PrepaidCharge$decoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'meta',
			$author$project$Api$Provider$Charge$Meta$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rule_payer',
				$elm$json$Json$Decode$nullable($author$project$Api$Charge$RulePayer$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_locked',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'invoice',
						$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'patient',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'category',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'charge_item',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$ChargeItem$ForCharge$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'issued_quantity_uom',
										$author$project$Api$Provider$Uom$Shared$decoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'quantity_uom',
											$author$project$Api$Provider$Uom$Shared$decoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'price_uom',
												$author$project$Api$Provider$Uom$Shared$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'location',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'practitioner',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder),
														$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$One$Record)))))))))))))));
var $author$project$Api$Provider$Charge$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Charge$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$One$Charge)));
var $author$project$Api$Provider$CompanyAccount$One$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAccount$One$Record = F6(
	function (division, subscriber, selectedPlan, memberships, membershipPlan, registrations) {
		return {NT: division, TI: membershipPlan, TN: memberships, age: registrations, Zh: selectedPlan, _3: subscriber};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$Record = function (patient) {
	return {VM: patient};
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$Record));
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$Membership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$Record = function (membershipPatients) {
	return {TF: membershipPatients};
};
var $author$project$Api$Provider$MembershipPatient$Min$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipPatient$Min$Record = F2(
	function (name, periodRateInCents) {
		return {zh: name, Wd: periodRateInCents};
	});
var $author$project$Api$Provider$MembershipPatient$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'period_rate_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$Min$Record)));
var $author$project$Api$Provider$MembershipPatient$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_patients',
	$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$ForCompanyAccountOne$Record));
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$ForCompanyAccountOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'registrations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'memberships',
			$elm$json$Json$Decode$list($author$project$Api$Provider$Membership$ForCompanyAccountOne$decoder),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'selected_plan',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subscriber',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'division',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$All$decoder),
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$One$Record)))))));
var $author$project$Api$Provider$CompanyAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$One$CompanyAccount)));
var $author$project$Api$Provider$InvoiceLine$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company_account',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Charge$One$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$One$Record))));
var $author$project$Api$Provider$InvoiceLine$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceLine$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve = F4(
	function (apiClient, affiliateBillId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$InvoiceLine$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath, affiliateBillId, id)));
	});
var $author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve = F5(
	function (apiClient, companyId, invoiceId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$InvoiceLine$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A3($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath, companyId, invoiceId, id)));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$init = F7(
	function (apiClient, currentDate, session, practice, company, invoiceType, invoiceLineId) {
		var companyRegistrationsBasePath = function () {
			if (invoiceType.$ === 1) {
				var companyId_ = invoiceType.a;
				return $author$project$Api$Provider$Company$companyPath(companyId_);
			} else {
				var affiliateId = invoiceType.a;
				return $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId);
			}
		}();
		var _v0 = A4(
			$author$project$Components$ResourceFilter$CompanyRegistration$init,
			apiClient,
			companyRegistrationsBasePath,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'None', aeZ: false});
			});
		var companyRegistrationResourceFilter = _v0.a;
		var companyRegistrationResourceFilterCmd = _v0.b;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(invoiceLineId, invoiceType);
			if (!_v2.a.$) {
				if (_v2.b.$ === 1) {
					var invoiceLineId_ = _v2.a.a;
					var _v3 = _v2.b;
					var companyId_ = _v3.a;
					var invoiceId = _v3.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve, apiClient, companyId_, invoiceId, invoiceLineId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine));
				} else {
					var invoiceLineId_ = _v2.a.a;
					var _v4 = _v2.b;
					var affiliateBillId = _v4.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A4($author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve, apiClient, affiliateBillId, invoiceLineId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine));
				}
			} else {
				if (_v2.b.$ === 1) {
					var _v5 = _v2.a;
					var _v6 = _v2.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A3(
							$author$project$Api$Provider$Category$list,
							apiClient,
							function (d) {
								return _Utils_update(
									d,
									{
										E$: $elm$core$Maybe$Just(true)
									});
							},
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCategories));
				} else {
					var _v7 = _v2.a;
					var _v8 = _v2.b;
					var _v9 = A5(
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit,
						apiClient,
						A2($author$project$Api$Practice$featureEnabled, 22, practice),
						session,
						currentDate,
						$elm$core$Maybe$Nothing);
					var formFields = _v9.a;
					var formFieldsCmd = _v9.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							$author$project$Utils$Form$init(formFields)),
						formFieldsCmd);
				}
			}
		}();
		var form = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{ab9: company, Lr: $author$project$Api$Data$NotAsked, hO: companyRegistrationResourceFilter, p$: false, cO: currentDate, NJ: false, PB: form, qU: false, q0: $author$project$Api$Data$NotAsked, q1: invoiceLineId, Rr: invoiceType, WF: practice, afU: $author$project$Api$Data$NotAsked, em: $jinjor$elm_debounce$Debounce$init, jY: $author$project$Api$Data$NotAsked, ZD: session},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceFilterCmd)
					])));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal = F3(
	function (apiClient, model, id) {
		var invoiceType = function () {
			var _v1 = model.Rr;
			if (!_v1.$) {
				var affiliateId = _v1.a;
				var affiliateBillId = _v1.b;
				return A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Affiliate, affiliateId, affiliateBillId);
			} else {
				var companyId_ = _v1.a;
				var invoiceId = _v1.b;
				return A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Company, companyId_, invoiceId);
			}
		}();
		var _v0 = A7(
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$init,
			apiClient,
			model.cO,
			model.ZD,
			model.WF,
			$author$project$Components$Invoice$InvoiceLinesTable$adjustmentModalCompany(model.ab9),
			invoiceType,
			id);
		var adjustmentModal = _v0.a;
		var adjustmentModalCmd = _v0.b;
		return {
			EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg, adjustmentModalCmd),
			ac5: 1,
			y8: _Utils_update(
				model,
				{
					hq: $elm$core$Maybe$Just(adjustmentModal)
				}),
			as: _List_Nil
		};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinePath = F2(
	function (invoiceId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath(invoiceId));
	});
var $author$project$Api$Employer$Invoice$InvoiceLine$retrieve = F4(
	function (apiClient, invoiceId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$InvoiceLine$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinePath, invoiceId, id)));
	});
var $author$project$Api$Company$Invoice$InvoiceLine$retrieve = F6(
	function (apiClient, session, companyId, invoiceId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Invoice$InvoiceLine$retrieve, apiClient, invoiceId, id, toMsg) : A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve, apiClient, companyId, invoiceId, id, toMsg);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine = F4(
	function (apiClient, session, invoiceType, invoiceLine) {
		if (invoiceType.$ === 1) {
			var companyId = invoiceType.a;
			var invoiceId = invoiceType.b;
			return A6(
				$author$project$Api$Company$Invoice$InvoiceLine$retrieve,
				apiClient,
				session,
				companyId,
				invoiceId,
				$author$project$Api$Provider$InvoiceLine$All$id(invoiceLine),
				$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails);
		} else {
			var invoiceId = invoiceType.a;
			return A4(
				$author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve,
				apiClient,
				invoiceId,
				$author$project$Api$Provider$InvoiceLine$All$id(invoiceLine),
				$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails);
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$refresh = F2(
	function (apiClient, model) {
		var _v0 = model.fN;
		if (_v0.$ === 3) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{fN: $author$project$Api$Data$Loading}),
				A4($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine, apiClient, model.ZD, model.Rr, model.q0));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$refreshPhiMoreInfo = F3(
	function (apiClient, phiMoreInfos, id) {
		if (!id.$) {
			var id_ = id.a;
			var _v1 = A2($elm$core$Dict$get, id_, phiMoreInfos);
			if (!_v1.$) {
				var phiMoreInfo = _v1.a;
				var _v2 = A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$refresh, apiClient, phiMoreInfo);
				var phiMoreInfo_ = _v2.a;
				var phiMoreInfoCmd = _v2.b;
				return _Utils_Tuple2(
					A3($elm$core$Dict$insert, id_, phiMoreInfo_, phiMoreInfos),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id_),
						phiMoreInfoCmd));
			} else {
				return _Utils_Tuple2(phiMoreInfos, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(phiMoreInfos, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Category = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated = {$: 3};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Closed = {$: 1};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDate = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotAffiliatePatient = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPatient = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$InvoiceLineUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None = {$: 0};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Location$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Practitioner$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDate = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$account = function (_v0) {
	var record = _v0.b;
	return record.H3;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPreview = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$Charge$Calculate$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$Calculate$Record = F7(
	function (priceInCents, discountInCents, subtotalInCents, issuedSubtotalInCents, routedInvoice, adjudicatedPayer, coveredCharges) {
		return {IA: adjudicatedPayer, L9: coveredCharges, NI: discountInCents, Sm: issuedSubtotalInCents, Ba: priceInCents, YO: routedInvoice, _7: subtotalInCents};
	});
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$AdjudicatedPayer = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$Record = F3(
	function (id, name, payerType) {
		return {adR: id, zh: name, VW: payerType};
	});
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$AdjudicatedPayer$One$Record))));
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$AdjudicatedPayer$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$RoutedInvoice$One$RoutedInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$RoutedInvoice$One$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$Charge$RoutedInvoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$RoutedInvoice$One$Record));
var $author$project$Api$Provider$Charge$RoutedInvoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$RoutedInvoice$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoveredCharge$All$CoveredCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveredCharge$All$Record = function (coverageRule) {
	return {L6: coverageRule};
};
var $author$project$Api$Provider$CoveredCharge$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coverage_rule',
	$author$project$Api$Provider$CoverageRule$Shared$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveredCharge$All$Record));
var $author$project$Api$Provider$CoveredCharge$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveredCharge$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$Calculate$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'covered_charges',
	$elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$All$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'adjudicated_payer',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$AdjudicatedPayer$One$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'routed_invoice',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$RoutedInvoice$One$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'issued_subtotal_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subtotal_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'discount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'price_in_cents',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Calculate$Record))))))));
var $author$project$Api$Provider$Charge$Calculate$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$Calculate$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$calculate = F4(
	function (basePath, apiClient, fields, toMsg) {
		var quantityUom = function () {
			var _v5 = fields.Be;
			if (!_v5.$) {
				var quantityUom_ = _v5.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'quantity_uom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$elm$json$Json$Encode$string(quantityUom_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var practitioner = function () {
			var _v4 = fields.afS;
			if (!_v4.$) {
				var practitioner_ = _v4.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'practitioner',
						$author$project$Utils$Encode$association(practitioner_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var patient = function () {
			var _v3 = fields.VM;
			if (!_v3.$) {
				var patient_ = _v3.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'patient',
						$author$project$Utils$Encode$association(patient_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var location = function () {
			var _v2 = fields.aet;
			if (!_v2.$) {
				var location_ = _v2.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'location',
						$author$project$Utils$Encode$association(location_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var chargeItem = function () {
			var _v1 = fields.lp;
			if (!_v1.$) {
				var chargeItem_ = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'charge_item',
						$author$project$Utils$Encode$association(chargeItem_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var category = function () {
			var _v0 = fields.Ex;
			if (!_v0.$) {
				var category_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'category',
						$author$project$Utils$Encode$association(category_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							patient,
							_Utils_ap(
								practitioner,
								_Utils_ap(
									chargeItem,
									_Utils_ap(
										category,
										_Utils_ap(
											location,
											_Utils_ap(
												quantityUom,
												_List_fromArray(
													[
														_Utils_Tuple2(
														'payer',
														A2(
															$author$project$Utils$Encode$nullable,
															$author$project$Utils$Encode$association,
															A2(
																$elm$core$Maybe$andThen,
																function ($) {
																	return $.adR;
																},
																fields.GD))),
														_Utils_Tuple2(
														'name',
														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.zh)),
														_Utils_Tuple2(
														'description',
														$elm$json$Json$Encode$string(fields.Nx)),
														_Utils_Tuple2(
														'charge_item',
														A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.lp)),
														_Utils_Tuple2(
														'quantity',
														$elm$json$Json$Encode$int(fields.Bd)),
														_Utils_Tuple2(
														'price_in_cents',
														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Ba)),
														_Utils_Tuple2(
														'date',
														A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.MO)),
														_Utils_Tuple2(
														'end_date',
														A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qs)),
														_Utils_Tuple2(
														'discount_overridden',
														$elm$json$Json$Encode$bool(fields.NJ))
													])))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Charge$Calculate$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['calculate']),
						basePath))));
	});
var $author$project$Api$Provider$Charge$chargesPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['charges']),
		basePath);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculateBasePath = function (invoiceType) {
	if (invoiceType.$ === 1) {
		return $author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath);
	} else {
		var affiliationId = invoiceType.a;
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['affiliate_charges']),
			$author$project$Api$Provider$Affiliate$affiliatePath(affiliationId));
	}
};
var $author$project$Api$Provider$Charge$Invoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$companyId = function (company) {
	if (!company.$) {
		var company__ = company.a;
		return $author$project$Api$Provider$Company$Min$id(company__);
	} else {
		var company__ = company.a;
		return $author$project$Api$Company$id(company__);
	}
};
var $author$project$Api$Provider$Charge$Calculate$discountInCents = function (_v0) {
	var record = _v0;
	return record.NI;
};
var $author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents = function (_v0) {
	var record = _v0;
	return record.Sm;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice = F2(
	function (model, fields) {
		var priceInCents = function () {
			if (!(!fields.NI)) {
				var _v0 = _Utils_Tuple2(fields.lp, model.afU);
				if (!_v0.a.$) {
					var chargeItem = _v0.a.a;
					return $elm$core$Maybe$Just(chargeItem.Ba | 0);
				} else {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var preview = _v2.a;
						return $elm$core$Maybe$Just(
							$author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
					} else {
						var _v3 = _v0.a;
						return $elm$core$Maybe$Just(
							fields.NI + A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Ba)));
					}
				}
			} else {
				return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Ba);
			}
		}();
		return {
			Ex: fields.Ex,
			lp: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				fields.lp),
			MO: fields._E,
			Nx: fields.Nx,
			NJ: fields.NJ,
			qs: fields.qs,
			Rh: $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing),
			aet: fields.aet,
			zh: fields.zh,
			VM: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				fields.VM),
			GD: A2(
				$elm$core$Maybe$map,
				function (company) {
					return {
						adR: $elm$core$Maybe$Just(
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$companyId(company)),
						ahI: $elm$core$Maybe$Just('company')
					};
				},
				model.ab9),
			afS: fields.afS,
			Ba: priceInCents,
			Bd: A2($elm$core$Maybe$withDefault, 1, fields.Bd),
			Be: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Be)
		};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebouncedMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebouncedMsg
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview = function (field) {
	switch (field.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return false;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return true;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields = function (fields) {
	return $author$project$Utils$Maybe$toBool(fields.zh) && (A2($elm$core$Maybe$withDefault, 0, fields.Bd) > 0);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview = F4(
	function (apiClient, field, form, model) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = ($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview(field) && $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields)) ? A3(
			$jinjor$elm_debounce$Debounce$push,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig,
			A4(
				$author$project$Api$Provider$Charge$calculate,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculateBasePath(model.Rr),
				apiClient,
				A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields),
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPreview),
			model.em) : _Utils_Tuple2(model.em, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview(field) && $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields)) ? _Utils_update(
				model,
				{afU: $author$project$Api$Data$Loading, em: newDebouncer}) : ((!$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields)) ? _Utils_update(
				model,
				{afU: $author$project$Api$Data$NotAsked, em: newDebouncer}) : _Utils_update(
				model,
				{em: newDebouncer})),
			cmd);
	});
var $author$project$Api$Provider$InvoiceLine$One$charges = function (_v0) {
	var record = _v0;
	return record.KU;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath = function (invoiceType) {
	if (invoiceType.$ === 1) {
		var companyId_ = invoiceType.a;
		var invoiceId = invoiceType.b;
		return A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId_, invoiceId);
	} else {
		var affiliateBillId = invoiceType.b;
		return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId);
	}
};
var $author$project$Api$Provider$InvoiceLine$One$companyAccount = function (_v0) {
	var record = _v0;
	return record.Lr;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebounced = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$debouncePreview = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Api$Provider$Charge$Shared$discountOverridden = function (_v0) {
	var record = _v0;
	return record.NJ;
};
var $author$project$Api$Provider$Charge$One$discountOverridden = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$discountOverridden(shared);
};
var $author$project$Components$ResourceFilter$CompanyRegistration$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aej: item.zh, aaN: item.adR};
			},
			list_);
		return _Utils_update(
			model,
			{
				bb: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bb)
			});
	});
var $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
};
var $author$project$Api$Provider$Charge$One$category = function (_v0) {
	var record = _v0.b;
	return record.Ex;
};
var $author$project$Api$Provider$Charge$One$chargeItem = function (_v0) {
	var record = _v0.b;
	return record.lp;
};
var $author$project$Api$Provider$Charge$Shared$date = function (_v0) {
	var record = _v0;
	return record.MO;
};
var $author$project$Api$Provider$Charge$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$date(shared);
};
var $author$project$Api$Provider$Charge$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$Charge$One$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$description(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
};
var $author$project$Api$Provider$Charge$Shared$discountInCents = function (_v0) {
	var record = _v0;
	return record.NI;
};
var $author$project$Api$Provider$Charge$One$discountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$discountInCents(shared);
};
var $author$project$Api$Provider$Charge$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Api$Provider$Charge$One$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$endDate(shared);
};
var $author$project$Components$ResourceFilter$Location$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aej: item.zh, aaN: item.adR};
			},
			list_);
		return _Utils_update(
			model,
			{
				bb: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bb)
			});
	});
var $author$project$Components$ResourceFilter$Practitioner$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aej: item.zh, aaN: item.adR};
			},
			list_);
		return _Utils_update(
			model,
			{
				bb: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bb)
			});
	});
var $author$project$Currency$fromMaybeInt = function (maybeInt) {
	return A2($elm$core$Maybe$map, $author$project$Currency$fromInt, maybeInt);
};
var $author$project$Api$Provider$Charge$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Charge$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$id(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$id(shared);
};
var $author$project$Api$Provider$Location$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$id(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$isPackage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared) === 1;
};
var $author$project$Api$Provider$Charge$One$location = function (_v0) {
	var record = _v0.b;
	return record.aet;
};
var $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
};
var $author$project$Api$Provider$Charge$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Charge$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$name(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
};
var $author$project$Api$Provider$Location$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$name(shared);
};
var $author$project$Api$Provider$Charge$One$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Api$Provider$Charge$One$practitioner = function (_v0) {
	var record = _v0.b;
	return record.afS;
};
var $author$project$Api$Provider$Charge$Shared$priceInCents = function (_v0) {
	var record = _v0;
	return record.Ba;
};
var $author$project$Api$Provider$Charge$One$priceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
};
var $author$project$Api$Provider$Charge$One$priceUom = function (_v0) {
	var record = _v0.b;
	return record.W$;
};
var $author$project$Api$Provider$Charge$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Bd;
};
var $author$project$Api$Provider$Charge$One$quantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$quantity(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
};
var $author$project$Api$Provider$Charge$One$quantityUom = function (_v0) {
	var record = _v0.b;
	return record.Be;
};
var $author$project$Api$Provider$ChargeItem$ForCharge$taxable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
};
var $author$project$Api$Provider$ChargeItem$ForCharge$uom = function (_v0) {
	var record = _v0.b;
	return record.aam;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsFromItem = F4(
	function (apiClient, showItemTypeInTitle, session, charge) {
		var practitioner = $author$project$Api$Provider$Charge$One$practitioner(charge);
		var patient = A2(
			$elm$core$Maybe$map,
			function (patient_) {
				return {
					adR: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
					zh: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
				};
			},
			$author$project$Api$Provider$Charge$One$patient(charge));
		var location = $author$project$Api$Provider$Charge$One$location(charge);
		var chargeItem = A2(
			$elm$core$Maybe$map,
			function (chargeItem_) {
				return {
					IN: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem_),
					Ex: $author$project$Api$Provider$Charge$One$category(charge),
					K3: $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem_),
					K5: $author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem_),
					Nx: $author$project$Api$Provider$ChargeItem$ForCharge$description(chargeItem_),
					adR: $author$project$Api$Provider$ChargeItem$ForCharge$id(chargeItem_),
					aef: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_),
					q9: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_) ? 1 : 0,
					Tg: $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem_),
					zh: $author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem_),
					Ba: $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents(chargeItem_),
					Xv: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem_),
					$u: $author$project$Api$Provider$ChargeItem$ForCharge$taxable(chargeItem_),
					$_: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem_),
					aam: $author$project$Api$Provider$ChargeItem$ForCharge$uom(chargeItem_)
				};
			},
			$author$project$Api$Provider$Charge$One$chargeItem(charge));
		var category = $author$project$Api$Provider$Charge$One$category(charge);
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Practitioner$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (practitioner_) {
							return _List_fromArray(
								[
									{
									adR: $author$project$Api$Provider$Practitioner$Shared$id(practitioner_),
									zh: $author$project$Api$Provider$Practitioner$Shared$name(practitioner_)
								}
								]);
						},
						practitioner))),
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Unassigned',
							aeZ: false,
							afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner)
						});
				}));
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Location$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (location_) {
							return _List_fromArray(
								[
									{
									adR: $author$project$Api$Provider$Location$Min$id(location_),
									zh: $author$project$Api$Provider$Location$Min$name(location_)
								}
								]);
						},
						location))),
			A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				$elm$core$Maybe$Nothing,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Unassigned',
							aeZ: false,
							afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location)
						});
				}));
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = $author$project$Components$DateInput$init;
		var endDateInput = _v3.a;
		var endDateInputCmd = _v3.b;
		var _v4 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$ChargeItem$setValue(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$ResourceFilter$FreeText(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$Charge$One$name(charge))),
					A2(
						$elm$core$Maybe$map,
						function (chargeItem_) {
							return $author$project$Components$ResourceFilter$One(
								{IN: chargeItem_.IN, Ex: chargeItem_.Ex, K3: chargeItem_.K3, K5: chargeItem_.K5, Nx: chargeItem_.Nx, adR: chargeItem_.adR, aef: chargeItem_.aef, q9: chargeItem_.q9, Tg: chargeItem_.Tg, zh: chargeItem_.zh, Ba: chargeItem_.Ba, Xv: chargeItem_.Xv, $u: chargeItem_.$u, $_: chargeItem_.$_, aam: chargeItem_.aam});
						},
						chargeItem))),
			A4(
				$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
				showItemTypeInTitle,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'None', IS: false, adB: true, adC: '', aeZ: false});
				}));
		var chargeItemResourceFilter = _v4.a;
		var chargeItemResourceFilterCmd = _v4.b;
		var _v5 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Category$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (category_) {
							return _List_fromArray(
								[
									{
									adR: $author$project$Api$Provider$Category$Shared$id(category_),
									zh: $author$project$Api$Provider$Category$Shared$name(category_)
								}
								]);
						},
						category))),
			A3(
				$author$project$Components$ResourceFilter$Category$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Unassigned',
							aeZ: false,
							afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category)
						});
				}));
		var categoryResourceFilter = _v5.a;
		var categoryResourceFilterCmd = _v5.b;
		return _Utils_Tuple2(
			{
				Ex: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Category$Shared$id,
					$author$project$Api$Provider$Charge$One$category(charge)),
				cJ: categoryResourceFilter,
				lp: chargeItem,
				cK: chargeItemResourceFilter,
				Nx: $author$project$Api$Provider$Charge$One$description(charge),
				NI: $author$project$Api$Provider$Charge$One$discountInCents(charge),
				NJ: $author$project$Api$Provider$Charge$One$discountOverridden(charge),
				qs: $author$project$Api$Provider$Charge$One$endDate(charge),
				qu: endDateInput,
				adR: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$id(charge)),
				aet: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Location$Min$id,
					$author$project$Api$Provider$Charge$One$location(charge)),
				rl: locationResourceFilter,
				zh: $author$project$Api$Provider$Charge$One$name(charge),
				VM: patient,
				afS: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Practitioner$Shared$id,
					$author$project$Api$Provider$Charge$One$practitioner(charge)),
				jC: practitionerResourceFilter,
				Ba: $author$project$Currency$fromMaybeInt(
					$author$project$Api$Provider$Charge$One$priceInCents(charge)),
				W$: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$priceUom(charge)),
				Bd: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$quantity(charge)),
				Be: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$quantityUom(charge)),
				_E: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$date(charge)),
				kg: startDateInput,
				$u: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$ChargeItem$ForCharge$taxable,
						$author$project$Api$Provider$Charge$One$chargeItem(charge)))
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Utils$Uom$matchRange = F2(
	function (fromDate, toDate) {
		var toDate_ = A3($justinmimbs$date$Date$add, 3, 1, toDate);
		var diff = A2($author$project$Utils$Uom$dateDiff, fromDate, toDate_);
		return (!(!diff.acs)) ? $author$project$Api$Provider$Uom$Shared$day : ((!diff.aeJ) ? $author$project$Api$Provider$Uom$Shared$year : ((!A2($elm$core$Basics$modBy, 6, diff.aeJ)) ? $author$project$Api$Provider$Uom$Shared$halfYear : ((!A2($elm$core$Basics$modBy, 3, diff.aeJ)) ? $author$project$Api$Provider$Uom$Shared$quarter : $author$project$Api$Provider$Uom$Shared$month)));
	});
var $author$project$Utils$Uom$dateUnitMultiplier = function (periodUnit) {
	switch (periodUnit) {
		case 0:
			return 1;
		case 1:
			return 1;
		case 2:
			return 3;
		case 3:
			return 6;
		default:
			return 1;
	}
};
var $author$project$Utils$Uom$toDateUnit = function (periodUnit) {
	switch (periodUnit) {
		case 0:
			return 3;
		case 1:
			return 1;
		case 2:
			return 1;
		case 3:
			return 1;
		default:
			return 0;
	}
};
var $author$project$Utils$Uom$withInfinityDefault = F2(
	function (_default, _float) {
		return $elm$core$Basics$isInfinite(_float) ? _default : _float;
	});
var $author$project$Utils$Uom$quantityBetween = F3(
	function (uom, fromDate, toDate) {
		var _v0 = _Utils_Tuple3(
			$author$project$Api$Provider$Uom$Shared$periodUnit(uom),
			$author$project$Api$Provider$Uom$Shared$periodQuantity(uom),
			toDate);
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var periodUnit = _v0.a.a;
			var periodQuantity = _v0.b.a;
			var toDate_ = _v0.c.a;
			var quantity = $elm$core$Basics$round(
				A2(
					$author$project$Utils$Uom$withInfinityDefault,
					1,
					(1 / ($author$project$Utils$Uom$dateUnitMultiplier(periodUnit) * periodQuantity)) * A3(
						$justinmimbs$date$Date$diff,
						$author$project$Utils$Uom$toDateUnit(periodUnit),
						fromDate,
						A3($justinmimbs$date$Date$add, 3, 1, toDate_))));
			return A2(
				$elm$core$Maybe$withDefault,
				1,
				$elm$core$List$maximum(
					_List_fromArray(
						[quantity, 1])));
		} else {
			return 0;
		}
	});
var $author$project$Utils$Uom$addTo = F3(
	function (date, uom, quantity) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Provider$Uom$Shared$periodUnit(uom),
			$author$project$Api$Provider$Uom$Shared$periodQuantity(uom));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var periodUnit = _v0.a.a;
			var periodQuantity = _v0.b.a;
			return A2(
				$elm$core$Maybe$map,
				A2($justinmimbs$date$Date$add, 3, -1),
				A2(
					$elm$core$Maybe$map,
					A2(
						$justinmimbs$date$Date$add,
						$author$project$Utils$Uom$toDateUnit(periodUnit),
						(periodQuantity * $author$project$Utils$Uom$dateUnitMultiplier(periodUnit)) * quantity),
					date));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Bd, fields.Be);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var quantity = _v0.a.a;
		var quantityUom = _v0.b.a;
		return _Utils_update(
			fields,
			{
				qs: A3($author$project$Utils$Uom$addTo, fields._E, quantityUom, quantity)
			});
	} else {
		return fields;
	}
};
var $author$project$Components$ResourceFilter$Category$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				G0: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$ResourceFilter$Location$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				G0: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$ResourceFilter$Practitioner$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				G0: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						lp: $elm$core$Maybe$Nothing,
						zh: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var chargeItem = field.a;
				var category = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.Ex;
					},
					chargeItem);
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(
					_Utils_update(
						fields,
						{
							Ex: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
							cJ: A2(
								$author$project$Components$ResourceFilter$Category$setValue,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return {
											adR: $author$project$Api$Provider$Category$Shared$id(category_),
											zh: $author$project$Api$Provider$Category$Shared$name(category_)
										};
									},
									category),
								fields.cJ),
							lp: chargeItem,
							Nx: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.Nx;
									},
									chargeItem)),
							zh: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.zh;
								},
								chargeItem),
							Ba: A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Ba;
									},
									$author$project$Currency$fromFloat),
								chargeItem),
							W$: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.aam;
								},
								chargeItem),
							Bd: $elm$core$Maybe$Just(1),
							Be: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.aam;
								},
								chargeItem)
						}));
			case 2:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{Ex: maybeString});
			case 3:
				var practitioner = field.a;
				return _Utils_update(
					fields,
					{
						afS: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							practitioner),
						jC: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitioner, fields.jC)
					});
			case 4:
				var location = field.a;
				return _Utils_update(
					fields,
					{
						aet: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							location),
						rl: A2($author$project$Components$ResourceFilter$Location$setValue, location, fields.rl)
					});
			case 5:
				var string = field.a;
				return _Utils_update(
					fields,
					{Nx: string});
			case 6:
				var string = field.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(
					_Utils_update(
						fields,
						{
							Bd: $elm$core$String$toInt(string)
						}));
			case 7:
				var string = field.a;
				var _v1 = $author$project$Utils$Uom$fromCode(string);
				if (!_v1.$) {
					var quantityUom = _v1.a;
					var quantity = function () {
						var _v2 = _Utils_Tuple2(fields._E, fields.qs);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var startDate = _v2.a.a;
							var endDate = _v2.b.a;
							return $elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom,
									startDate,
									$elm$core$Maybe$Just(endDate)));
						} else {
							return fields.Bd;
						}
					}();
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(
						_Utils_update(
							fields,
							{
								Bd: quantity,
								Be: $elm$core$Maybe$Just(quantityUom)
							}));
				} else {
					return _Utils_update(
						fields,
						{Be: $elm$core$Maybe$Nothing});
				}
			case 8:
				var dateInput = field.a;
				var date = field.b;
				return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(
					_Utils_update(
						fields,
						{_E: date, kg: dateInput}));
			case 9:
				var dateInput = field.a;
				var date = field.b;
				var _v3 = function () {
					var _v4 = _Utils_Tuple2(fields._E, date);
					if ((!_v4.a.$) && (!_v4.b.$)) {
						var startDate_ = _v4.a.a;
						var endDate = _v4.b.a;
						var startDate__ = (A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2) ? endDate : startDate_;
						var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(startDate__),
							$elm$core$Maybe$Just(quantityUom_),
							$elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom_,
									startDate__,
									$elm$core$Maybe$Just(endDate))));
					} else {
						return _Utils_Tuple3(fields._E, fields.Be, fields.Bd);
					}
				}();
				var startDate = _v3.a;
				var quantityUom = _v3.b;
				var quantity = _v3.c;
				return _Utils_update(
					fields,
					{qs: date, qu: dateInput, Bd: quantity, Be: quantityUom, _E: startDate});
			case 10:
				var _int = field.a;
				return _Utils_update(
					fields,
					{Ba: _int});
			case 11:
				var companyRegistration = field.a;
				return _Utils_update(
					fields,
					{
						VM: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.VM;
							},
							companyRegistration)
					});
			case 12:
				var bool = field.a;
				var priceInCents = bool ? fields.Ba : A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Ba;
						},
						$author$project$Currency$fromFloat),
					fields.lp);
				return _Utils_update(
					fields,
					{NJ: bool, Ba: priceInCents});
			default:
				var _int = field.a;
				return _Utils_update(
					fields,
					{NI: _int});
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemValidation = 0;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCentsValidation = 4;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateValidation = 2;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validateChargeItem = function (fields) {
	var _v0 = fields.lp;
	if (!_v0.$) {
		var chargeItem = _v0.a;
		return chargeItem.$u ? _List_fromArray(
			[
				_Utils_Tuple2(0, 'We do not support adding taxable charges to this invoice at this time. Please contact us to learn more.')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please pick a charge.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Ba;
			},
			_Utils_Tuple2(4, 'Please enter an amount.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validateChargeItem),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $._E;
			},
			_Utils_Tuple2(2, 'Please pick a date.'))
		]));
var $author$project$Api$Provider$CompanyAccount$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CompanyAccount$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Min$id(min);
};
var $author$project$Api$Provider$CompanyAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$Provider$Patient$Min$id = function (_v0) {
	var min = _v0;
	return min.adR;
};
var $author$project$Api$Provider$Patient$One$location = function (_v0) {
	var record = _v0.b;
	return record.aet;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Api$Provider$Patient$One$practitioner = function (_v0) {
	var record = _v0.b;
	return record.afS;
};
var $author$project$Api$Provider$CompanyAccount$One$registrations = function (_v0) {
	var record = _v0.b;
	return record.age;
};
var $author$project$Api$Affiliate$AffiliateMin$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Location$Shared$affiliation = function (_v0) {
	var record = _v0;
	return record.IJ;
};
var $author$project$Api$Location$Shared$affiliation = function (location) {
	if (!location.$) {
		var location_ = location.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Location$Shared$affiliation(location_));
	} else {
		var location_ = location.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Employer,
			$author$project$Api$Employer$Location$Shared$affiliation(location_));
	}
};
var $author$project$Api$Employer$Location$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Location$Shared$id = function (location) {
	if (!location.$) {
		var location_ = location.a;
		return $author$project$Api$Provider$Location$Shared$id(location_);
	} else {
		var location_ = location.a;
		return $author$project$Api$Employer$Location$Shared$id(location_);
	}
};
var $author$project$Api$Employer$Location$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Location$Shared$name = function (location) {
	if (!location.$) {
		var location_ = location.a;
		return $author$project$Api$Provider$Location$Shared$name(location_);
	} else {
		var location_ = location.a;
		return $author$project$Api$Employer$Location$Shared$name(location_);
	}
};
var $author$project$Components$ResourceFilter$Location$resourceFromShared = $elm$core$Maybe$map(
	function (location) {
		return {
			IJ: $author$project$Api$Location$Shared$affiliation(location),
			adR: $author$project$Api$Location$Shared$id(location),
			RQ: false,
			Sa: false,
			zh: $author$project$Api$Location$Shared$name(location)
		};
	});
var $author$project$Api$Employer$Practitioner$Shared$affiliation = function (_v0) {
	var record = _v0;
	return record.IJ;
};
var $author$project$Api$Practitioner$Shared$affiliation = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Practitioner$Shared$affiliation(practitioner_));
	} else {
		var practitioner_ = practitioner.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Employer,
			$author$project$Api$Employer$Practitioner$Shared$affiliation(practitioner_));
	}
};
var $author$project$Api$Employer$Practitioner$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Practitioner$Shared$id = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$id(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$id(practitioner_);
	}
};
var $author$project$Api$Employer$Practitioner$Shared$isMaster = function (_v0) {
	var record = _v0;
	return record.RQ;
};
var $author$project$Api$Practitioner$Shared$isMaster = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$isMaster(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$isMaster(practitioner_);
	}
};
var $author$project$Api$Employer$Practitioner$Shared$isSynced = function (_v0) {
	var record = _v0;
	return record.Sa;
};
var $author$project$Api$Practitioner$Shared$isSynced = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$isSynced(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$isSynced(practitioner_);
	}
};
var $author$project$Api$Employer$Practitioner$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Practitioner$Shared$name = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$name(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$name(practitioner_);
	}
};
var $author$project$Api$Employer$Practitioner$Shared$openingsSize = function (_v0) {
	var record = _v0;
	return record.Vb;
};
var $author$project$Api$Practitioner$Shared$openingsSize = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$openingsSize(practitioner_);
	} else {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Employer$Practitioner$Shared$openingsSize(practitioner_);
	}
};
var $author$project$Api$Practitioner$Shared$practiceName = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$practiceName(practitioner_);
	} else {
		return '';
	}
};
var $author$project$Api$Practitioner$Shared$practitionerType = function (practitioner) {
	if (!practitioner.$) {
		var practitioner_ = practitioner.a;
		return $author$project$Api$Provider$Practitioner$Shared$practitionerType(practitioner_);
	} else {
		return '';
	}
};
var $author$project$Components$ResourceFilter$Practitioner$resourceFromShared = $elm$core$Maybe$map(
	function (practitioner) {
		return {
			IJ: $author$project$Api$Practitioner$Shared$affiliation(practitioner),
			adR: $author$project$Api$Practitioner$Shared$id(practitioner),
			RQ: $author$project$Api$Practitioner$Shared$isMaster(practitioner),
			Sa: $author$project$Api$Practitioner$Shared$isSynced(practitioner),
			zh: $author$project$Api$Practitioner$Shared$name(practitioner),
			Vb: $author$project$Api$Practitioner$Shared$openingsSize(practitioner),
			afQ: $author$project$Api$Practitioner$Shared$practiceName(practitioner),
			WP: $author$project$Api$Practitioner$Shared$practitionerType(practitioner)
		};
	});
var $author$project$Api$Provider$Affiliates$AffiliatePatient$patientsPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_patients']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$AffiliatePatient$patientPath = F2(
	function (affiliateId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliates$AffiliatePatient$patientsPath(affiliateId));
	});
var $author$project$Api$Provider$Affiliates$AffiliatePatient$retrieve = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$Min$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Affiliates$AffiliatePatient$patientPath, affiliateId, patientId)));
	});
var $author$project$Api$Provider$Patient$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$patientPath(id_)));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeCreated = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$create = F4(
	function (basePath, apiClient, fields, toMsg) {
		var quantityUom = function () {
			var _v3 = fields.Be;
			if (!_v3.$) {
				var quantityUom_ = _v3.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'quantity_uom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$elm$json$Json$Encode$string(quantityUom_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var patient = function () {
			var _v2 = fields.VM;
			if (!_v2.$) {
				var patient_ = _v2.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'patient',
						$author$project$Utils$Encode$association(patient_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var invoice = function () {
			var _v1 = fields.Rh;
			if (!_v1.$) {
				var invoice_ = _v1.a;
				return A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, invoice_);
			} else {
				return $elm$json$Json$Encode$string('new');
			}
		}();
		var chargeItem = function () {
			var _v0 = fields.lp;
			if (!_v0.$) {
				var chargeItem_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'charge_item',
						$author$project$Utils$Encode$association(chargeItem_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							patient,
							_Utils_ap(
								chargeItem,
								_Utils_ap(
									quantityUom,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'payer',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, fields.GD)),
											_Utils_Tuple2('invoice', invoice),
											_Utils_Tuple2(
											'name',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.zh)),
											_Utils_Tuple2(
											'description',
											$elm$json$Json$Encode$string(fields.Nx)),
											_Utils_Tuple2(
											'charge_item',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.lp)),
											_Utils_Tuple2(
											'quantity',
											$elm$json$Json$Encode$int(fields.Bd)),
											_Utils_Tuple2(
											'price_in_cents',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Ba)),
											_Utils_Tuple2(
											'date',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.MO)),
											_Utils_Tuple2(
											'end_date',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qs)),
											_Utils_Tuple2(
											'practitioner',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afS)),
											_Utils_Tuple2(
											'location',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aet)),
											_Utils_Tuple2(
											'category',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Ex))
										]))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Charge$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Charge$chargesPath(basePath))));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$createCharge = F3(
	function (apiClient, model, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Charge$create,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.Rr),
			apiClient,
			A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields),
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeCreated(formFields));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$Charge$chargePath = F2(
	function (basePath, chargeId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[chargeId]),
			$author$project$Api$Provider$Charge$chargesPath(basePath));
	});
var $author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath = function (chargeId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['coverage_discounts']),
		A2($author$project$Api$Provider$Charge$chargePath, $author$project$Api$Data$providerPath, chargeId));
};
var $author$project$Api$Provider$Charge$CoverageDiscount$override = F3(
	function (apiClient, chargeId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Charge$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['override']),
					$author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId))));
	});
var $author$project$Api$Provider$Charge$CoverageDiscount$reset = F3(
	function (apiClient, chargeId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Charge$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reset']),
					$author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId))));
	});
var $author$project$Api$Provider$Charge$update = F5(
	function (basePath, apiClient, id, fields, toMsg) {
		var quantityUom = function () {
			var _v3 = fields.Be;
			if (!_v3.$) {
				var quantityUom_ = _v3.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'quantity_uom',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$elm$json$Json$Encode$string(quantityUom_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var patient = function () {
			var _v2 = fields.VM;
			if (!_v2.$) {
				var patient_ = _v2.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'patient',
						$author$project$Utils$Encode$association(patient_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var chargeItem = function () {
			var _v1 = fields.lp;
			if (!_v1.$) {
				var chargeItem_ = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'charge_item',
						$author$project$Utils$Encode$association(chargeItem_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var category = function () {
			var _v0 = fields.Ex;
			if (!_v0.$) {
				var category_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'category',
						$author$project$Utils$Encode$association(category_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							patient,
							_Utils_ap(
								chargeItem,
								_Utils_ap(
									category,
									_Utils_ap(
										quantityUom,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'name',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.zh)),
												_Utils_Tuple2(
												'description',
												$elm$json$Json$Encode$string(fields.Nx)),
												_Utils_Tuple2(
												'quantity',
												$elm$json$Json$Encode$int(fields.Bd)),
												_Utils_Tuple2(
												'price_in_cents',
												A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Ba)),
												_Utils_Tuple2(
												'date',
												A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.MO)),
												_Utils_Tuple2(
												'end_date',
												A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qs)),
												_Utils_Tuple2(
												'practitioner',
												A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afS)),
												_Utils_Tuple2(
												'location',
												A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aet))
											])))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Charge$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Charge$chargePath, basePath, id))));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge = F4(
	function (apiClient, model, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields);
		return (fields.NJ && (!model.NJ)) ? A3(
			$author$project$Api$Provider$Charge$CoverageDiscount$override,
			apiClient,
			id,
			A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset, id, apiFields)) : (((!fields.NJ) && model.NJ) ? A3(
			$author$project$Api$Provider$Charge$CoverageDiscount$reset,
			apiClient,
			id,
			A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset, id, apiFields)) : A5(
			$author$project$Api$Provider$Charge$update,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.Rr),
			apiClient,
			id,
			apiFields,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$save = F3(
	function (apiClient, model, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var id = _v0.adR;
		if (!id.$) {
			var id_ = id.a;
			return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge, apiClient, model, id_, formFields);
		} else {
			return A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$createCharge, apiClient, model, formFields);
		}
	});
var $author$project$Components$ResourceFilter$CompanyRegistration$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Common$Account$RetrieveOptionals$Memberships = 0;
var $author$project$Api$Provider$Affiliate$Account$companyAccountsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['accounts']),
		$author$project$Api$Provider$Affiliate$affiliatePath(companyId));
};
var $author$project$Api$Provider$Affiliate$Account$companyAccountPath = F2(
	function (companyId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliate$Account$companyAccountsPath(companyId));
	});
var $author$project$Api$Common$Account$RetrieveOptionals$expandToString = function (expand) {
	return 'memberships';
};
var $author$project$Api$Common$Account$RetrieveOptionals$retrieveDefaults = {Fc: _List_Nil};
var $author$project$Api$Common$Account$RetrieveOptionals$toParams = function (optionals) {
	var options = optionals($author$project$Api$Common$Account$RetrieveOptionals$retrieveDefaults);
	return _List_fromArray(
		[
			A2(
			$author$project$Api$Param$list,
			'expand',
			A2($elm$core$List$map, $author$project$Api$Common$Account$RetrieveOptionals$expandToString, options.Fc))
		]);
};
var $author$project$Api$Provider$Affiliate$Account$retrieve = F5(
	function (apiClient, companyId, id, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Account$RetrieveOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Affiliate$Account$companyAccountPath, companyId, id))));
	});
var $author$project$Api$Provider$Company$Account$companyAccountPath = F2(
	function (basePath, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Company$Account$companyAccountsPath(basePath));
	});
var $author$project$Api$Provider$Company$Account$retrieve = F5(
	function (apiClient, companyId, id, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Account$RetrieveOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Provider$Company$Account$companyAccountPath,
						$author$project$Api$Provider$Company$companyPath(companyId),
						id))));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$findRecentMembership = F3(
	function (apiClient, field, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var companyRegistrationId = function () {
			if (field.$ === 11) {
				var companyRegistration = field.a;
				return A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.eR;
					},
					companyRegistration);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return _Utils_Tuple2(
			$author$project$Utils$Maybe$toBool(companyRegistrationId) ? _Utils_update(
				model,
				{Lr: $author$project$Api$Data$Loading}) : model,
			function () {
				if (!companyRegistrationId.$) {
					var companyRegistrationId_ = companyRegistrationId.a;
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								function () {
								var _v2 = model.Rr;
								if (!_v2.$) {
									var affiliateId = _v2.a;
									return A5(
										$author$project$Api$Provider$Affiliate$Account$retrieve,
										apiClient,
										affiliateId,
										companyRegistrationId_,
										function (d) {
											return _Utils_update(
												d,
												{
													Fc: _List_fromArray(
														[0])
												});
										},
										$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount);
								} else {
									var companyId_ = _v2.a;
									return A5(
										$author$project$Api$Provider$Company$Account$retrieve,
										apiClient,
										companyId_,
										companyRegistrationId_,
										function (d) {
											return _Utils_update(
												d,
												{
													Fc: _List_fromArray(
														[0])
												});
										},
										$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount);
								}
							}()
							]));
				} else {
					return cmd;
				}
			}());
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm = F4(
	function (apiClient, model, field, form) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field, form);
		return A3(
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$findRecentMembership,
			apiClient,
			field,
			A4(
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview,
				apiClient,
				field,
				newForm,
				_Utils_update(
					model,
					{
						PB: $elm$core$Maybe$Just(newForm)
					})));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField = F7(
	function (apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = model.PB;
		if (!_v0.$) {
			var form = _v0.a;
			var _v1 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
			var newDateInput = _v1.a;
			var subCmd = _v1.b;
			var event = _v1.c;
			var dateField = function () {
				if (event.$ === 1) {
					var date = event.a;
					return A2(field, newDateInput, date);
				} else {
					var fields = $author$project$Utils$Form$fields(form);
					return A2(
						field,
						newDateInput,
						fieldGetter(fields));
				}
			}();
			var _v2 = A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, dateField, form);
			var newModel = _v2.a;
			var formCmd = _v2.b;
			return {
				EC: $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							formCmd,
							A2(
							$elm$core$Platform$Cmd$map,
							toMsg(newDateInput),
							subCmd)
						])),
				ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
				y8: newModel,
				as: _List_Nil
			};
		} else {
			return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: model, as: _List_Nil};
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountInCents = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Charge$Calculate$priceInCents = function (_v0) {
	var record = _v0;
	return record.Ba;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateFormFromPreview = F2(
	function (preview, form) {
		return A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountInCents(
				$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)),
			A3(
				$author$project$Utils$Form$update,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents(
					$elm$core$Maybe$Just(
						$author$project$Currency$fromInt(
							$author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))),
				form));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Closed, y8: model, as: _List_Nil};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
					y8: _Utils_update(
						model,
						{qU: !model.qU}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
					y8: _Utils_update(
						model,
						{p$: !model.p$}),
					as: _List_Nil
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var invoiceLine = response.a;
					var charge = $elm$core$List$head(
						$author$project$Api$Provider$InvoiceLine$One$charges(invoiceLine));
					var _v3 = function () {
						if (!charge.$) {
							var charge_ = charge.a;
							var registrations = A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$CompanyAccount$One$registrations,
									$author$project$Api$Provider$InvoiceLine$One$companyAccount(invoiceLine)));
							var patient = $author$project$Api$Provider$Charge$One$patient(charge_);
							var companyRegistrationsBasePath = function () {
								var _v8 = model.Rr;
								if (_v8.$ === 1) {
									var companyId_ = _v8.a;
									return $author$project$Api$Provider$Company$companyPath(companyId_);
								} else {
									var affiliateId = _v8.a;
									return $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId);
								}
							}();
							var chargePatientId = A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id,
								A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$patient, charge));
							var selectedRegistration = A2(
								$elm_community$list_extra$List$Extra$find,
								function (registration) {
									var registrationPatientId = $author$project$Api$Provider$Patient$Min$id(
										$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient(registration));
									return _Utils_eq(
										$elm$core$Maybe$Just(registrationPatientId),
										chargePatientId);
								},
								registrations);
							var formCompanyRegistration = A2(
								$elm$core$Maybe$map,
								function (selectedRegistration_) {
									var accountId = A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$CompanyAccount$One$id,
										$author$project$Api$Provider$InvoiceLine$One$companyAccount(invoiceLine));
									return {
										eR: accountId,
										VM: {
											adR: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient, $author$project$Api$Provider$Patient$Min$id)(selectedRegistration_),
											zh: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient, $author$project$Api$Provider$Patient$Min$name)(selectedRegistration_)
										}
									};
								},
								selectedRegistration);
							var _v5 = A4(
								$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsFromItem,
								apiClient,
								A2($author$project$Api$Practice$featureEnabled, 22, model.WF),
								model.ZD,
								charge_);
							var formFields = _v5.a;
							var formFieldsCmd = _v5.b;
							var form = $author$project$Utils$Form$init(formFields);
							var _v6 = A4(
								$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
								apiClient,
								model,
								$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration(formCompanyRegistration),
								form);
							var modelWithForm = _v6.a;
							var formCmd_ = _v6.b;
							var _v7 = A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Components$ResourceFilter$CompanyRegistration$extraItems(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											function (patient_) {
												return _List_fromArray(
													[
														{
														adR: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
														zh: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
													}
													]);
											},
											patient))),
								A4(
									$author$project$Components$ResourceFilter$CompanyRegistration$init,
									apiClient,
									companyRegistrationsBasePath,
									$elm$core$Basics$identity,
									function (d) {
										return _Utils_update(
											d,
											{
												D0: 'None',
												aeZ: false,
												afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id, patient)
											});
									}));
							var companyRegistrationResourceFilter = _v7.a;
							var companyRegistrationResourceFilterCmd = _v7.b;
							return _Utils_Tuple2(
								_Utils_update(
									modelWithForm,
									{hO: companyRegistrationResourceFilter}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											formFieldsCmd,
											formCmd_,
											A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceFilterCmd)
										])));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v3.a;
					var formCmd = _v3.b;
					return {
						EC: formCmd,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							newModel,
							{
								NJ: A2(
									$elm$core$Maybe$withDefault,
									false,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$discountOverridden, charge)),
								q0: response
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							model,
							{q0: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var categories = response.a;
					var category = $elm$core$List$head(categories);
					var _v10 = A5(
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit,
						apiClient,
						A2($author$project$Api$Practice$featureEnabled, 22, model.WF),
						model.ZD,
						model.cO,
						category);
					var formFields = _v10.a;
					var formFieldsCmd = _v10.b;
					var _v11 = A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Components$ResourceFilter$Category$extraItems(
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return _List_fromArray(
											[
												{
												adR: $author$project$Api$Provider$Category$All$id(category_),
												zh: $author$project$Api$Provider$Category$All$name(category_)
											}
											]);
									},
									category))),
						A2(
							$author$project$Components$ResourceFilter$Category$preSelectedId,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$All$id, category),
							formFields.cJ));
					var categoryResourceFilter = _v11.a;
					var categoryResourceFilterCmd = _v11.b;
					var form = $elm$core$Maybe$Just(
						$author$project$Utils$Form$init(
							_Utils_update(
								formFields,
								{cJ: categoryResourceFilter})));
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formFieldsCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd)
								])),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							model,
							{PB: form}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 5:
				var field = msg.a;
				var _v12 = model.PB;
				if (!_v12.$) {
					var form = _v12.a;
					var _v13 = A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, field, form);
					var newModel = _v13.a;
					var formCmd = _v13.b;
					return {EC: formCmd, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: newModel, as: _List_Nil};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: model, as: _List_Nil};
				}
			case 10:
				var debounceMsg = msg.a;
				var _v14 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$debouncePreview),
					debounceMsg,
					model.em);
				var newDebouncer = _v14.a;
				var cmd = _v14.b;
				return {
					EC: cmd,
					ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
					y8: _Utils_update(
						model,
						{em: newDebouncer}),
					as: _List_Nil
				};
			case 11:
				var cmd = msg.a;
				return {EC: cmd, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: model, as: _List_Nil};
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					var preview = response.a;
					var form = A2(
						$elm$core$Maybe$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateFormFromPreview(preview),
						model.PB);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							model,
							{PB: form, afU: response}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							model,
							{afU: response}),
						as: _List_Nil
					};
				}
			case 6:
				var _v16 = model.PB;
				if (!_v16.$) {
					var form = _v16.a;
					var _v17 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsValidator, form);
					if (!_v17.$) {
						var _v18 = _v17.a;
						var newForm = _v18.a;
						var validFormFields = _v18.b;
						return {
							EC: A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$save, apiClient, model, validFormFields),
							ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
							y8: _Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							as: _List_Nil
						};
					} else {
						var newForm = _v17.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
							y8: _Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: model, as: _List_Nil};
				}
			case 7:
				var fields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var charge = response.a;
					var id = $author$project$Api$Provider$Charge$One$id(charge);
					var eventName = 'Adjustment Added';
					return {
						EC: A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge, apiClient, model, id, fields),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, eventName)
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 8:
				var id = msg.a;
				var params = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					return {
						EC: A5(
							$author$project$Api$Provider$Charge$update,
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.Rr),
							apiClient,
							id,
							params,
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var eventName = 'Adjustment Updated';
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$InvoiceLineUpdated(
							A2($elm$core$Maybe$withDefault, '', model.q1)),
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, eventName)
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 13:
				var subMsg = msg.a;
				var _v22 = model.PB;
				if (!_v22.$) {
					var form = _v22.a;
					var fields = $author$project$Utils$Form$fields(form);
					var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, fields.cK);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{cK: chargeItemResourceResult.y8}),
						form);
					var _v23 = function () {
						var _v24 = chargeItemResourceResult.ac5;
						_v24$3:
						while (true) {
							if ((!_v24.$) && (!_v24.a.$)) {
								switch (_v24.a.a.$) {
									case 0:
										var chargeItem = _v24.a.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem(
												$elm$core$Maybe$Just(
													{IN: chargeItem.IN, Ex: chargeItem.Ex, K3: chargeItem.K3, K5: chargeItem.K5, Nx: chargeItem.Nx, adR: chargeItem.adR, aef: chargeItem.aef, q9: chargeItem.q9, Tg: chargeItem.Tg, zh: chargeItem.zh, Ba: chargeItem.Ba, Xv: chargeItem.Xv, $u: chargeItem.$u, $_: chargeItem.$_, aam: chargeItem.aam})),
											newForm);
									case 5:
										var string = _v24.a.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name(string),
											newForm);
									case 2:
										var _v25 = _v24.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem($elm$core$Maybe$Nothing),
											newForm);
									default:
										break _v24$3;
								}
							} else {
								break _v24$3;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none);
					}();
					var newModel = _v23.a;
					var formCmd = _v23.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.EC),
									formCmd
								])),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: newModel,
						as: chargeItemResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: model, as: _List_Nil};
				}
			case 14:
				var subMsg = msg.a;
				var _v26 = model.PB;
				if (!_v26.$) {
					var form = _v26.a;
					var fields = $author$project$Utils$Form$fields(form);
					var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.cJ);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{cJ: categoryResourceResult.y8}),
						form);
					var _v27 = function () {
						var _v28 = categoryResourceResult.ac5;
						if (!_v28.$) {
							if (!_v28.a.$) {
								return A4(
									$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
									apiClient,
									model,
									$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Category(
										$author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8)),
									newForm);
							} else {
								var _v29 = _v28.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											PB: $elm$core$Maybe$Just(newForm)
										}),
									$elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										PB: $elm$core$Maybe$Just(newForm)
									}),
								$elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v27.a;
					var formCmd = _v27.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceResult.EC),
									formCmd
								])),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: newModel,
						as: categoryResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: model, as: _List_Nil};
				}
			case 15:
				var subMsg = msg.a;
				var _v30 = model.PB;
				if (!_v30.$) {
					var form = _v30.a;
					var fields = $author$project$Utils$Form$fields(form);
					var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, fields.jC);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{jC: practitionerResourceResult.y8}),
						form);
					var _v31 = function () {
						var _v32 = practitionerResourceResult.ac5;
						_v32$2:
						while (true) {
							if ((!_v32.$) && (!_v32.a.$)) {
								switch (_v32.a.a.$) {
									case 0:
										var practitioner = _v32.a.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner(
												$elm$core$Maybe$Just(practitioner)),
											newForm);
									case 2:
										var _v33 = _v32.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner($elm$core$Maybe$Nothing),
											newForm);
									default:
										break _v32$2;
								}
							} else {
								break _v32$2;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none);
					}();
					var newModel = _v31.a;
					var formCmd = _v31.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
									formCmd
								])),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: newModel,
						as: practitionerResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: model, as: _List_Nil};
				}
			case 16:
				var subMsg = msg.a;
				var _v34 = model.PB;
				if (!_v34.$) {
					var form = _v34.a;
					var fields = $author$project$Utils$Form$fields(form);
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, fields.rl);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{rl: locationResourceResult.y8}),
						form);
					var _v35 = function () {
						var _v36 = locationResourceResult.ac5;
						_v36$2:
						while (true) {
							if ((!_v36.$) && (!_v36.a.$)) {
								switch (_v36.a.a.$) {
									case 0:
										var location = _v36.a.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location(
												$elm$core$Maybe$Just(location)),
											newForm);
									case 2:
										var _v37 = _v36.a.a;
										return A4(
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
											apiClient,
											model,
											$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location($elm$core$Maybe$Nothing),
											newForm);
									default:
										break _v36$2;
								}
							} else {
								break _v36$2;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none);
					}();
					var newModel = _v35.a;
					var formCmd = _v35.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceResult.EC),
									formCmd
								])),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: newModel,
						as: locationResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None, y8: model, as: _List_Nil};
				}
			case 17:
				var subMsg = msg.a;
				var companyRegistrationResourceResult = A3($author$project$Components$ResourceFilter$CompanyRegistration$update, apiClient, subMsg, model.hO);
				var _v38 = model.PB;
				if (!_v38.$) {
					var form = _v38.a;
					var _v39 = function () {
						var _v40 = companyRegistrationResourceResult.ac5;
						_v40$2:
						while (true) {
							if ((!_v40.$) && (!_v40.a.$)) {
								switch (_v40.a.a.$) {
									case 0:
										var companyRegistration = _v40.a.a.a;
										var patientId_ = A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$id)(companyRegistration);
										var formCompanyRegistration = {
											eR: $elm$core$Maybe$Just(
												A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$account, $author$project$Api$Provider$CompanyAccount$Min$id)(companyRegistration)),
											VM: {
												adR: patientId_,
												zh: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$name)(companyRegistration)
											}
										};
										return A2(
											$author$project$Utils$Tuple3$fromTuple2,
											$elm$core$Maybe$Just(patientId_),
											A4(
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
												apiClient,
												model,
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration(
													$elm$core$Maybe$Just(formCompanyRegistration)),
												form));
									case 2:
										var _v41 = _v40.a.a;
										return A2(
											$author$project$Utils$Tuple3$fromTuple2,
											$elm$core$Maybe$Nothing,
											A4(
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm,
												apiClient,
												model,
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration($elm$core$Maybe$Nothing),
												form));
									default:
										break _v40$2;
								}
							} else {
								break _v40$2;
							}
						}
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					}();
					var newModel = _v39.a;
					var formCmd = _v39.b;
					var patientId = _v39.c;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceResult.EC),
									formCmd,
									function () {
									if (!patientId.$) {
										var patientId_ = patientId.a;
										var _v43 = model.Rr;
										if (_v43.$ === 1) {
											return A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPatient);
										} else {
											var affiliateId = _v43.a;
											return A4($author$project$Api$Provider$Affiliates$AffiliatePatient$retrieve, apiClient, affiliateId, patientId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotAffiliatePatient);
										}
									} else {
										return $elm$core$Platform$Cmd$none;
									}
								}()
								])),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							newModel,
							{hO: companyRegistrationResourceResult.y8}),
						as: companyRegistrationResourceResult.as
					};
				} else {
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceResult.EC),
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							model,
							{hO: companyRegistrationResourceResult.y8}),
						as: _List_Nil
					};
				}
			case 18:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDate,
					function ($) {
						return $._E;
					});
			case 19:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDate,
					function ($) {
						return $.qs;
					});
			case 20:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
					y8: _Utils_update(
						model,
						{Lr: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 21:
				var response = msg.a;
				var _v44 = _Utils_Tuple2(response, model.PB);
				if ((_v44.a.$ === 3) && (!_v44.b.$)) {
					var _v45 = _v44.a;
					var patient = _v45.a;
					var form = _v44.b.a;
					var _v46 = function () {
						var _v47 = _Utils_Tuple2(
							$author$project$Api$Provider$Patient$One$location(patient),
							$author$project$Api$Provider$Patient$One$practitioner(patient));
						if (!_v47.a.$) {
							if (!_v47.b.$) {
								var location = _v47.a.a;
								var practitioner = _v47.b.a;
								var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location(
									$author$project$Components$ResourceFilter$Location$resourceFromShared(
										$elm$core$Maybe$Just(
											$author$project$Api$Location$Shared$Provider(location))));
								return _Utils_Tuple2(
									A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate,
										$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner(
											$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
												$elm$core$Maybe$Just(
													$author$project$Api$Practitioner$Shared$Provider(practitioner)))),
										A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form)),
									$elm$core$Maybe$Just(field_));
							} else {
								var location = _v47.a.a;
								var _v48 = _v47.b;
								var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location(
									$author$project$Components$ResourceFilter$Location$resourceFromShared(
										$elm$core$Maybe$Just(
											$author$project$Api$Location$Shared$Provider(location))));
								return _Utils_Tuple2(
									A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form),
									$elm$core$Maybe$Just(field_));
							}
						} else {
							if (!_v47.b.$) {
								var _v49 = _v47.a;
								var practitioner = _v47.b.a;
								var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner(
									$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
										$elm$core$Maybe$Just(
											$author$project$Api$Practitioner$Shared$Provider(practitioner))));
								return _Utils_Tuple2(
									A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form),
									$elm$core$Maybe$Just(field_));
							} else {
								var _v50 = _v47.a;
								var _v51 = _v47.b;
								return _Utils_Tuple2(form, $elm$core$Maybe$Nothing);
							}
						}
					}();
					var newForm = _v46.a;
					var field = _v46.b;
					var _v52 = function () {
						if (!field.$) {
							var field_ = field.a;
							return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview, apiClient, field_, newForm, model);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v52.a;
					var calculatePreviewCmd = _v52.b;
					return {
						EC: calculatePreviewCmd,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: _Utils_update(
							newModel,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
					y8: model,
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotCoverageDiscounts = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Charge$CoverageDiscount$list = F3(
	function (apiClient, chargeId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId)));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{om: !model.om}),
					function () {
						var _v1 = model.fN;
						if (_v1.$ === 3) {
							return $elm$core$Platform$Cmd$none;
						} else {
							return A4($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine, apiClient, model.ZD, model.Rr, model.q0);
						}
					}(),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var invoiceLine = response.a;
					var charge = $elm$core$List$head(
						$author$project$Api$Provider$InvoiceLine$One$charges(invoiceLine));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fN: response}),
						function () {
							var _v3 = _Utils_Tuple3(
								$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD),
								charge,
								model.Rr);
							if (((!_v3.a) && (!_v3.b.$)) && (_v3.c.$ === 1)) {
								var charge_ = _v3.b.a;
								var _v4 = _v3.c;
								return A3(
									$author$project$Api$Provider$Charge$CoverageDiscount$list,
									apiClient,
									$author$project$Api$Provider$Charge$One$id(charge_),
									$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotCoverageDiscounts);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fN: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{wS: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Invoice$InvoiceLinesTable$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var invoiceLines = response.a;
					var headers = response.b;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{
								aq: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								ei: $elm$core$Dict$fromList(
									A2(
										$elm$core$List$map,
										function (invoiceLine) {
											var invoiceType = function () {
												var _v2 = model.Rr;
												if (!_v2.$) {
													var affiliateBillId = _v2.b;
													return $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Affiliate(affiliateBillId);
												} else {
													var companyId_ = _v2.a;
													var invoiceId = _v2.b;
													return A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Company, companyId_, invoiceId);
												}
											}();
											var phiMoreInfo = A4(
												$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$init,
												model.ZD,
												invoiceType,
												$author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(model.ab9),
												invoiceLine);
											return _Utils_Tuple2(
												$author$project$Api$Provider$InvoiceLine$All$id(invoiceLine),
												phiMoreInfo);
										},
										invoiceLines))
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{aq: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{xp: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								aq: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, qModel));
					}
				}();
				var newModel = _v4.a;
				var cmd = _v4.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg, searchInputCmd),
								cmd
							])),
					ac5: 1,
					y8: _Utils_update(
						newModel,
						{sA: searchInput}),
					as: _List_Nil
				};
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{aq: $author$project$Api$Data$Loading, afy: pagination});
				return {
					EC: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
					ac5: 1,
					y8: newModel,
					as: _List_Nil
				};
			case 4:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						aq: $author$project$Api$Data$Loading,
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return {
					EC: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
					ac5: 1,
					y8: newModel,
					as: _List_Nil
				};
			case 5:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cJ);
				var categoryId = function () {
					var _v7 = categoryResourceResult.ac5;
					if (!_v7.$) {
						if (!_v7.a.$) {
							return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8);
						} else {
							var _v8 = _v7.a;
							return model.fa;
						}
					} else {
						return model.fa;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fa: categoryId, cJ: categoryResourceResult.y8});
				var _v6 = _Utils_eq(model.fa, newModel.fa) ? _Utils_Tuple2(model.aq, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel));
				var invoiceLines = _v6.a;
				var cmd = _v6.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg, categoryResourceResult.EC),
								cmd
							])),
					ac5: 1,
					y8: _Utils_update(
						newModel,
						{aq: invoiceLines}),
					as: categoryResourceResult.as
				};
			case 6:
				var subMsg = msg.a;
				var _v9 = model.jw;
				if (!_v9.$) {
					var planResourceFilter = _v9.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planResourceFilter);
					var planId = function () {
						var _v11 = planResourceResult.ac5;
						if (!_v11.$) {
							if (!_v11.a.$) {
								return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.y8);
							} else {
								var _v12 = _v11.a;
								return model.afN;
							}
						} else {
							return model.afN;
						}
					}();
					var newModel = _Utils_update(
						model,
						{
							afN: planId,
							jw: $elm$core$Maybe$Just(planResourceResult.y8)
						});
					var _v10 = _Utils_eq(model.afN, newModel.afN) ? _Utils_Tuple2(model.aq, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel));
					var invoiceLines = _v10.a;
					var cmd = _v10.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg, planResourceResult.EC),
									cmd
								])),
						ac5: 1,
						y8: _Utils_update(
							newModel,
							{aq: invoiceLines}),
						as: planResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 7:
				var subMsg = msg.a;
				var _v13 = A2($author$project$Ui$NewDropdown$update, subMsg, model.l0);
				var employeeDivisionDropdown = _v13.a;
				var cmd = _v13.b;
				return {
					EC: cmd,
					ac5: 1,
					y8: _Utils_update(
						model,
						{l0: employeeDivisionDropdown}),
					as: _List_Nil
				};
			case 8:
				var selectedDivision = msg.a;
				var newModel = _Utils_update(
					model,
					{
						E8: selectedDivision,
						aq: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				return {
					EC: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
					ac5: 1,
					y8: newModel,
					as: _List_Nil
				};
			case 9:
				return A3($author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal, apiClient, model, $elm$core$Maybe$Nothing);
			case 10:
				var invoiceLine = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{
							fq: $elm$core$Maybe$Just(
								_Utils_Tuple2(invoiceLine, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 11:
				var invoiceLine = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
					return {
						EC: function () {
							var _v14 = model.Rr;
							if (_v14.$ === 1) {
								var companyId_ = _v14.a;
								var invoiceId_ = _v14.b;
								return A5(
									$author$project$Api$Provider$Company$Invoice$InvoiceLine$delete,
									apiClient,
									companyId_,
									invoiceId_,
									id,
									$author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted(id));
							} else {
								var invoiceId_ = _v14.b;
								return A4(
									$author$project$Api$Provider$AffiliateBill$InvoiceLine$delete,
									apiClient,
									invoiceId_,
									id,
									$author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted(id));
							}
						}(),
						ac5: 1,
						y8: _Utils_update(
							model,
							{
								fq: $elm$core$Maybe$Just(
									_Utils_Tuple2(invoiceLine, $author$project$Api$Data$Loading)),
								dM: A2($elm$core$Set$insert, id, model.dM)
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{fq: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				}
			case 12:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return {
							EC: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, model),
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									fq: $elm$core$Maybe$Nothing,
									dM: A2($elm$core$Set$remove, id, model.dM),
									aq: $author$project$Api$Data$Loading
								}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Invoice line removed')
								])
						};
					case 2:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: _Utils_update(
								model,
								{
									dM: A2($elm$core$Set$remove, id, model.dM)
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 13:
				var invoiceLine = msg.a;
				var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
				return A3(
					$author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal,
					apiClient,
					model,
					$elm$core$Maybe$Just(id));
			case 14:
				var id = msg.a;
				var subMsg = msg.b;
				var _v16 = A2($elm$core$Dict$get, id, model.ei);
				if (!_v16.$) {
					var phiMoreInfo = _v16.a;
					var _v17 = A3($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$update, apiClient, subMsg, phiMoreInfo);
					var phiMoreInfo_ = _v17.a;
					var phiMoreInfoCmd = _v17.b;
					var phiMoreInfoOutMsgs = _v17.c;
					return {
						EC: A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id),
							phiMoreInfoCmd),
						ac5: 1,
						y8: _Utils_update(
							model,
							{
								ei: A3($elm$core$Dict$insert, id, phiMoreInfo_, model.ei)
							}),
						as: phiMoreInfoOutMsgs
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 15:
				var subMsg = msg.a;
				var _v18 = model.hq;
				if (!_v18.$) {
					var adjustmentModal = _v18.a;
					var adjustmentModalResult = A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$update, apiClient, subMsg, adjustmentModal);
					var _v19 = function () {
						var _v20 = adjustmentModalResult.ac5;
						switch (_v20.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(adjustmentModalResult.y8),
									1,
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, 1, $elm$core$Maybe$Nothing);
							case 2:
								var id = _v20.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									0,
									$elm$core$Maybe$Just(id));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, 0, $elm$core$Maybe$Nothing);
						}
					}();
					var adjustmentModal_ = _v19.a;
					var event = _v19.b;
					var toUpdateId = _v19.c;
					var _v21 = A3($author$project$Components$Invoice$InvoiceLinesTable$refreshPhiMoreInfo, apiClient, model.ei, toUpdateId);
					var phiMoreInfos = _v21.a;
					var phiMoreInfoCmd = _v21.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg, adjustmentModalResult.EC),
									phiMoreInfoCmd
								])),
						ac5: event,
						y8: _Utils_update(
							model,
							{hq: adjustmentModal_, ei: phiMoreInfos}),
						as: adjustmentModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 17:
				var subMsg = msg.a;
				var _v22 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v22.a;
				var outMsgs = _v22.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg, getFileCmdMsg),
					ac5: 1,
					y8: model,
					as: outMsgs
				};
			default:
				var subMsg = msg.a;
				var _v23 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v23.a;
				var subCmd = _v23.b;
				var subOutMsg = _v23.c;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg, subCmd),
					ac5: 1,
					y8: _Utils_update(
						model,
						{l9: exportCsv}),
					as: subOutMsg
				};
		}
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$update = F2(
	function (msg, model) {
		return _Utils_update(
			model,
			{gM: !model.gM});
	});
var $author$project$Components$Invoice$Summary$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var groupBy_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fK: $elm$core$Maybe$Just(groupBy_)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gN: !model.gN}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gL: !model.gL}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{w8: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 4:
				var delta = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nj: $elm$core$Maybe$Just(delta)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nj: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var otherChargesSummary = A2($author$project$Components$Invoice$Summary$OtherChargesSummary$update, subMsg, model.rK);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rK: otherChargesSummary}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Components$Invoice$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var dateInput = field.a;
			var date = field.b;
			return _Utils_update(
				fields,
				{Rn: date, mz: dateInput});
		} else {
			var dateInput = field.a;
			var date = field.b;
			return _Utils_update(
				fields,
				{iW: date, mA: dateInput});
		}
	});
var $author$project$Api$Provider$Company$Invoice$updateDates = F5(
	function (apiClient, companyId, id, _v0, toMsg) {
		var invoiceDate = _v0.Rn;
		var dueDate = _v0.N1;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'invoice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'date',
								$author$project$Utils$Date$encode(invoiceDate)),
								_Utils_Tuple2(
								'due_date',
								$author$project$Utils$Date$encode(dueDate))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$updateDates = F6(
	function (apiClient, session, companyId, id, dates, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A5(
			$author$project$Api$Provider$Company$Invoice$updateDates,
			apiClient,
			companyId,
			id,
			dates,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Components$Invoice$updateDateInputFormField = F7(
	function (apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var cmdInput = A2(
			$elm$core$Platform$Cmd$map,
			toMsg(newDateInput),
			subCmd);
		if (event.$ === 1) {
			var maybeDate = event.a;
			if (!maybeDate.$) {
				var date = maybeDate.a;
				var form = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.cv);
				var updateInvoiceCmd = function () {
					var _v3 = model.Rr;
					if (!_v3.$) {
						return $elm$core$Platform$Cmd$none;
					} else {
						var companyId = _v3.a;
						var id = _v3.b;
						var newFields = $author$project$Utils$Form$fields(form);
						var dateFields = {N1: newFields.iW, Rn: newFields.Rn};
						return A6($author$project$Api$Company$Invoice$updateDates, apiClient, model.ZD, companyId, id, dateFields, $author$project$Components$Invoice$GotCompanyInvoice);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cv: form, oj: false, ol: false}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmdInput, updateInvoiceCmd])),
					_List_Nil);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var fields = $author$project$Utils$Form$fields(model.cv);
			var form = A3(
				$author$project$Utils$Form$update,
				$author$project$Components$Invoice$formFieldsUpdate,
				A2(
					field,
					newDateInput,
					fieldGetter(fields)),
				model.cv);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{cv: form}),
				cmdInput,
				_List_Nil);
		}
	});
var $author$project$Components$Invoice$Voided = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Invoice$void = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['void']),
					A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
	});
var $author$project$Api$Company$Invoice$void = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$Company$Invoice$void,
			apiClient,
			companyId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
	});
var $author$project$Api$Provider$AffiliateBill$void = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['void']),
					$author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
	});
var $author$project$Components$Invoice$void = F4(
	function (apiClient, session, invoiceType, invoice) {
		if (!invoiceType.$) {
			var id = invoiceType.b;
			return A3(
				$author$project$Api$Provider$AffiliateBill$void,
				apiClient,
				id,
				A2(
					$elm$core$Basics$composeL,
					$author$project$Components$Invoice$Voided(invoice),
					$author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
		} else {
			var companyId = invoiceType.a;
			var id = invoiceType.b;
			return A5(
				$author$project$Api$Company$Invoice$void,
				apiClient,
				session,
				companyId,
				id,
				$author$project$Components$Invoice$Voided(invoice));
		}
	});
var $author$project$Components$Invoice$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					var auditTrailLog = A7(
						$author$project$Components$AuditTrailLog$init,
						model.ZD,
						model.aav,
						model.Hy,
						$elm$core$Maybe$Just('invoice'),
						$elm$core$Maybe$Just(
							$author$project$Api$Invoice$One$id(invoice)),
						$author$project$Api$Invoice$One$createdAt(invoice),
						$elm$core$Maybe$Nothing);
					var _v3 = A7(
						$author$project$Components$Invoice$InvoiceLinesTable$init,
						model.cO,
						apiClient,
						model.ZD,
						model.WF,
						$author$project$Components$Invoice$invoiceLinesTableCompany(model.ab9),
						$author$project$Components$Invoice$invoiceLinesTableInvoiceType(model.Rr),
						invoice);
					var invoiceLinesTable = _v3.a;
					var invoiceLinesTableCmd = _v3.b;
					var _v4 = $author$project$Components$Invoice$formFieldsFromInvoice(invoice);
					var fields = _v4.a;
					var fieldsCmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: $author$project$Utils$Form$init(fields),
								hy: $elm$core$Maybe$Just(auditTrailLog),
								Rh: response,
								d6: $elm$core$Maybe$Just(invoiceLinesTable)
							}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$cons,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTableMsg, invoiceLinesTableCmd),
								A2(
									$elm$core$List$cons,
									function () {
										var _v5 = model.Rr;
										if (_v5.$ === 1) {
											var companyId = _v5.a;
											var invoiceId = _v5.b;
											return A5($author$project$Api$Company$Invoice$Summary$retrieve, apiClient, model.ZD, companyId, invoiceId, $author$project$Components$Invoice$GotSummary);
										} else {
											var invoiceId = _v5.b;
											return A3($author$project$Api$Provider$AffiliateBill$Summary$retrieve, apiClient, invoiceId, $author$project$Components$Invoice$GotSummary);
										}
									}(),
									A2(
										$elm$core$List$cons,
										$author$project$Api$Invoice$One$isUpdating(invoice) ? $author$project$Components$Invoice$pollInvoiceForStatus : $elm$core$Platform$Cmd$none,
										fieldsCmd)))),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response}),
						$author$project$Api$Invoice$One$isUpdating(invoice) ? $author$project$Components$Invoice$pollInvoiceForStatus : A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.ZD, model.Rr),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				var _v7 = _Utils_Tuple2(response, model.Rh);
				if ((_v7.a.$ === 3) && (_v7.b.$ === 3)) {
					var _v8 = _v7.a;
					var summary = _v8.a;
					var _v9 = _v7.b;
					var invoice = _v9.a;
					var totalCount = $author$project$Api$Common$Invoice$Summary$AllLines$count(
						$author$project$Api$Common$Invoice$Summary$allLines(summary));
					var invoiceSummaryInvoiceType = function () {
						var _v11 = model.Rr;
						if (!_v11.$) {
							var id = _v11.b;
							return $author$project$Components$Invoice$Summary$Affiliate(id);
						} else {
							var companyId = _v11.a;
							var id = _v11.b;
							return A2($author$project$Components$Invoice$Summary$Company, companyId, id);
						}
					}();
					var _v10 = A8(
						$author$project$Components$Invoice$Summary$init,
						apiClient,
						model.ZD,
						model.Hy,
						model.WF,
						$author$project$Components$Invoice$invoiceSummaryCompany(model.ab9),
						invoiceSummaryInvoiceType,
						invoice,
						summary);
					var invoiceSummary = _v10.a;
					var invoiceSummaryCmd = _v10.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								yf: $elm$core$Maybe$Just(totalCount),
								fP: $elm$core$Maybe$Just(invoiceSummary)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceSummaryMsg, invoiceSummaryCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var subMsg = msg.a;
				var _v12 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lV);
				var dropdownMenu = _v12.a;
				var cmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lV: dropdownMenu}),
					cmd,
					_List_Nil);
			case 4:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4($author$project$Components$Invoice$initCompanyEmailModal, apiClient, model, invoice, false));
			case 5:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4(
						$author$project$Components$Invoice$initCompanyEmailModal,
						apiClient,
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						invoice,
						true));
			case 6:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ty: $elm$core$Maybe$Just(invoice)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var invoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jY: $author$project$Api$Data$Loading,
							ty: $elm$core$Maybe$Just(invoice)
						}),
					A4($author$project$Components$Invoice$void, apiClient, model.ZD, model.Rr, invoice),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ty: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var invoice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response, jY: $author$project$Api$Data$NotAsked, ty: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								jY: $author$project$Api$Data$NotAsked,
								ty: $elm$core$Maybe$Just(invoice)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ey: $elm$core$Maybe$Just(invoice)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var invoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ey: $elm$core$Maybe$Just(invoice),
							jY: $author$project$Api$Data$Loading
						}),
					A4($author$project$Components$Invoice$returnToDraft, apiClient, model.ZD, model.Rr, invoice),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ey: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var invoice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response, ey: $elm$core$Maybe$Nothing, jY: $author$project$Api$Data$NotAsked}),
						$author$project$Components$Invoice$pollInvoiceForStatus,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice returned to draft')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ey: $elm$core$Maybe$Just(invoice),
								jY: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ec: $elm$core$Maybe$Just(invoice)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var invoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ec: $elm$core$Maybe$Just(invoice),
							jY: $author$project$Api$Data$Loading
						}),
					A4($author$project$Components$Invoice$markAsBadDebt, apiClient, model.ZD, model.Rr, invoice),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ec: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var invoice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response, ec: $elm$core$Maybe$Nothing, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice marked as bad debt')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ec: $elm$core$Maybe$Just(invoice),
								jY: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 15:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3($author$project$Components$Invoice$reverseBadDebt, apiClient, model.ZD, model.Rr),
					_List_Nil);
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice returned to issued')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 17:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							h8: $elm$core$Maybe$Just(invoice)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var invoice = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							h8: $elm$core$Maybe$Just(invoice),
							jY: $author$project$Api$Data$Loading
						}),
					A4($author$project$Components$Invoice$delete, apiClient, model.ZD, model.Rr, invoice),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{h8: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 19:
				var invoice = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h8: $elm$core$Maybe$Nothing, jY: $author$project$Api$Data$NotAsked}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.F_),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice destroyed successfully')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								h8: $elm$core$Maybe$Just(invoice),
								jY: $author$project$Api$Data$NotAsked
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 20:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3($author$project$Components$Invoice$issue, apiClient, model.ZD, model.Rr),
					_List_Nil);
			case 21:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice issued')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 22:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4($author$project$Components$Invoice$initCreatePaymentModal, apiClient, model, invoice, false));
			case 23:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4($author$project$Components$Invoice$initCreatePaymentModal, apiClient, model, invoice, true));
			case 24:
				var subMsg = msg.a;
				var paymentsHistoryResult = A3($author$project$Components$Invoice$PaymentsHistory$update, apiClient, subMsg, model.jq);
				var _v19 = function () {
					var refreshInvoice = _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.ZD, model.Rr));
					var _v20 = paymentsHistoryResult.ac5;
					switch (_v20) {
						case 0:
							return _Utils_Tuple2(model.Rh, $elm$core$Platform$Cmd$none);
						case 1:
							return refreshInvoice;
						case 2:
							return refreshInvoice;
						case 3:
							return refreshInvoice;
						default:
							return refreshInvoice;
					}
				}();
				var invoice = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Rh: invoice, jq: paymentsHistoryResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$PaymentsHistoryMsg, paymentsHistoryResult.EC),
								cmd
							])),
					paymentsHistoryResult.as);
			case 25:
				var subMsg = msg.a;
				var _v21 = model.hN;
				if (!_v21.$) {
					var companyEmailModal = _v21.a;
					var companyEmailModalResult = A3($author$project$Components$CompanyEmailModal$update, apiClient, subMsg, companyEmailModal);
					var _v22 = function () {
						var _v23 = companyEmailModalResult.ac5;
						switch (_v23) {
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(companyEmailModalResult.y8),
									model.Rh,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.ZD, model.Rr));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, $elm$core$Platform$Cmd$none);
						}
					}();
					var companyEmailModal_ = _v22.a;
					var invoice = _v22.b;
					var cmd = _v22.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hN: companyEmailModal_, Rh: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CompanyEmailModalMsg, companyEmailModalResult.EC),
									cmd
								])),
						companyEmailModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 26:
				var subMsg = msg.a;
				var _v24 = model.lC;
				if (!_v24.$) {
					var createPaymentModal = _v24.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, apiClient, subMsg, createPaymentModal);
					var _v25 = function () {
						var _v26 = createPaymentModalResult.ac5;
						switch (_v26) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.y8),
									model.Rh,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.ZD, model.Rr));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v25.a;
					var invoice = _v25.b;
					var cmd = _v25.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lC: createPaymentModal_, Rh: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModalMsg, createPaymentModalResult.EC),
									cmd
								])),
						createPaymentModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 27:
				var subMsg = msg.a;
				var _v27 = model.fP;
				if (!_v27.$) {
					var invoiceSummary = _v27.a;
					var _v28 = A2($author$project$Components$Invoice$Summary$update, subMsg, invoiceSummary);
					var invoiceSummary_ = _v28.a;
					var invoiceSummaryCmd = _v28.b;
					var invoiceSummaryOutMsgs = _v28.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fP: $elm$core$Maybe$Just(invoiceSummary_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceSummaryMsg, invoiceSummaryCmd),
						invoiceSummaryOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 28:
				var subMsg = msg.a;
				var _v29 = model.d6;
				if (!_v29.$) {
					var invoiceLinesTable = _v29.a;
					var invoiceLinesTableResult = A3($author$project$Components$Invoice$InvoiceLinesTable$update, apiClient, subMsg, invoiceLinesTable);
					var _v30 = function () {
						var _v31 = invoiceLinesTableResult.ac5;
						if (_v31 === 1) {
							return _Utils_Tuple2(model.Rh, $elm$core$Platform$Cmd$none);
						} else {
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.ZD, model.Rr));
						}
					}();
					var invoice = _v30.a;
					var cmd = _v30.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Rh: invoice,
								d6: $elm$core$Maybe$Just(invoiceLinesTableResult.y8)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTableMsg, invoiceLinesTableResult.EC)
								])),
						invoiceLinesTableResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 29:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oj: !model.oj}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 31:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ol: !model.ol}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 30:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Invoice$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$InvoiceDateInputMsg,
					$author$project$Components$Invoice$InvoiceDate,
					function ($) {
						return $.Rn;
					});
			case 32:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Invoice$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Invoice$InvoiceDueDateInputMsg,
					$author$project$Components$Invoice$InvoiceDueDate,
					function ($) {
						return $.iW;
					});
			case 33:
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$Invoice$retrieveInvoiceStatus, apiClient, model.ZD, model.Rr),
					_List_Nil);
			case 34:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, apiClient, subMsg, model.iq);
				var showModal = function () {
					var _v32 = downloadInvoiceResult.ac5;
					switch (_v32) {
						case 2:
							return true;
						case 3:
							return false;
						default:
							return model.ok;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iq: downloadInvoiceResult.y8, ok: showModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$DownloadInvoiceMsg, downloadInvoiceResult.EC),
					downloadInvoiceResult.as);
			case 35:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ok: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 36:
				var subMsg = msg.a;
				var _v33 = model.hy;
				if (!_v33.$) {
					var auditTrailLog = _v33.a;
					var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, auditTrailLog);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hy: $elm$core$Maybe$Just(auditTrailLogResult.y8)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$AuditTrailLogMsg, auditTrailLogResult.EC),
						auditTrailLogResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 37:
				var subMsg = msg.a;
				var _v34 = function () {
					var _v35 = model.tx;
					if (!_v35.$) {
						var virtualBankAccountsComponent_ = _v35.a;
						var _v36 = A3($author$project$Components$Company$VirtualBankAccounts$Invoice$update, apiClient, subMsg, virtualBankAccountsComponent_);
						var virtualModel_ = _v36.a;
						var virtualCmd_ = _v36.b;
						var virtualOutMsgs_ = _v36.c;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(virtualModel_),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$VirtualBankAccountsComponentMsg, virtualCmd_),
							virtualOutMsgs_);
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}();
				var model_ = _v34.a;
				var cmd_ = _v34.b;
				var outMsgs_ = _v34.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tx: model_}),
					cmd_,
					outMsgs_);
			default:
				var integrationRecords = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Q8: integrationRecords}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(integrationRecords));
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var session = msg.a;
			var practice = msg.b;
			var shared = msg.c;
			var affiliateBillId = msg.d;
			var response = msg.e;
			if (response.$ === 3) {
				var affiliate = response.a;
				var _v2 = $author$project$Components$Invoice$init(
					{
						D5: model.D5,
						k0: true,
						ab9: A2(
							$elm$core$Maybe$map,
							$author$project$Components$Invoice$ProviderMin,
							$author$project$Api$Provider$Affiliate$One$company(affiliate)),
						Rr: A2(
							$author$project$Components$Invoice$Affiliate,
							$author$project$Api$Provider$Affiliate$One$id(affiliate),
							affiliateBillId),
						F_: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
							{
								pp: $author$project$Api$Provider$Affiliate$One$id(affiliate)
							}),
						r$: $elm$core$Maybe$Nothing,
						WF: $author$project$Api$Practice$Provider(practice),
						ZD: session,
						Cd: shared
					});
				var invoiceComponent = _v2.a;
				var invoiceComponentCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fO: $elm$core$Maybe$Just(invoiceComponent)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg, invoiceComponentCmd),
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fO: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var _v3 = model.fO;
			if (!_v3.$) {
				var invoiceComponent = _v3.a;
				var _v4 = A3($author$project$Components$Invoice$update, model.D5, subMsg, invoiceComponent);
				var invoiceComponent_ = _v4.a;
				var cmd = _v4.b;
				var outMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fO: $elm$core$Maybe$Just(invoiceComponent_)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg, cmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Components$Invoice$Delete = function (a) {
	return {$: 17, a: a};
};
var $author$project$Ui$Icon$Edit = 4;
var $author$project$Components$Invoice$Email = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$MakeViewableAndEmail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$MarkAsBadDebt = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Invoice$Pay = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Invoice$RecordPayment = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Invoice$ReturnToDraft = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Invoice$ReverseBadDebt = {$: 15};
var $author$project$Ui$Icon$StopAlt = 12;
var $author$project$Components$Invoice$Void = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Employer$Invoice$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Employer$Invoice$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Invoice$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$amountInCents(shared);
};
var $author$project$Api$Invoice$One$amountInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$amountInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$amountInCents(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$One$autoPayDate = function (_v0) {
	var record = _v0.b;
	return record.JF;
};
var $author$project$Api$Provider$Invoice$One$autoPayDate = function (_v0) {
	var record = _v0.b;
	return record.JF;
};
var $author$project$Api$Invoice$One$autoPayDate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$autoPayDate(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$autoPayDate(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Meta$canCancelAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Ko;
};
var $author$project$Api$Provider$Invoice$Meta$canCancelAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Ko;
};
var $author$project$Api$Invoice$Meta$canCancelAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canCancelAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$canCancelAction(meta_);
	}
};
var $author$project$Api$Provider$Invoice$Meta$canDelete = function (_v0) {
	var meta = _v0;
	return meta.tF.Kp;
};
var $author$project$Api$Invoice$Meta$canDelete = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canDelete(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canDraftAndDestroyCurrentDraftAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Kr;
};
var $author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canMakeViewableAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Kx;
};
var $author$project$Api$Invoice$Meta$canMakeViewableAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canMakeViewableAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canMarkAsBadDebtAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Ky;
};
var $author$project$Api$Invoice$Meta$canMarkAsBadDebtAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canMarkAsBadDebtAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canNotifyAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Kz;
};
var $author$project$Api$Invoice$Meta$canNotifyAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canNotifyAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Invoice$Meta$canReverseBadDebtAction = function (_v0) {
	var meta = _v0;
	return meta.tF.KB;
};
var $author$project$Api$Invoice$Meta$canReverseBadDebtAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canReverseBadDebtAction(meta_);
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$companyAddress = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Maybe$Nothing,
		A2(
			$elm$core$Maybe$andThen,
			function (company_) {
				if (!company_.$) {
					return $elm$core$Maybe$Nothing;
				} else {
					var company__ = company_.a;
					return $elm$core$Maybe$Just(
						$author$project$Api$Company$address(company__));
				}
			},
			company));
};
var $author$project$Api$Employer$Company$One$defaultSource = function (_v0) {
	var record = _v0.b;
	return record.Nl;
};
var $author$project$Api$Provider$Company$One$defaultSource = function (_v0) {
	var record = _v0.b;
	return record.Nl;
};
var $author$project$Api$Company$defaultSource = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$defaultSource(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$defaultSource(company_);
	}
};
var $author$project$Components$Invoice$companyDefaultSource = function (company) {
	return A2(
		$elm$core$Maybe$andThen,
		function (company_) {
			if (!company_.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$defaultSource(company__);
			}
		},
		company);
};
var $author$project$Api$Provider$Company$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$Invoice$companyName = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Api$Provider$Company$Min$name(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$name(company__);
			}
		},
		company);
};
var $author$project$Api$Employer$Company$One$phones = function (_v0) {
	var record = _v0.b;
	return record.Wi;
};
var $author$project$Api$Provider$Company$One$phones = function (_v0) {
	var record = _v0.b;
	return record.Wi;
};
var $author$project$Api$Company$phones = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$phones(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$phones(company_);
	}
};
var $author$project$Components$Invoice$companyPhones = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					return _List_Nil;
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$phones(company__);
				}
			},
			company));
};
var $author$project$Api$Employer$Invoice$Meta$createPaymentAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Mc;
};
var $author$project$Api$Provider$Invoice$Meta$createPaymentAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Mc;
};
var $author$project$Api$Invoice$Meta$createPaymentAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$createPaymentAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$createPaymentAction(meta_);
	}
};
var $author$project$Api$Employer$Invoice$Shared$humanStatus = function (_v0) {
	var record = _v0;
	return record.QE;
};
var $author$project$Api$Employer$Invoice$One$humanStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$humanStatus(shared);
};
var $author$project$Api$Provider$Invoice$One$humanStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$humanStatus(shared);
};
var $author$project$Api$Invoice$One$humanStatus = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$humanStatus(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$humanStatus(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Shared$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Api$Employer$Invoice$One$invoiceNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$Invoice$One$number = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Invoice$One$invoiceNumber = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$number(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$invoiceNumber(invoice_);
	}
};
var $author$project$Components$Invoice$isAPractice = function (session) {
	return !$author$project$Api$Platform$Session$One$organizationIsCompany(session);
};
var $author$project$Components$Invoice$isNetwork = function (company) {
	if (!company.$) {
		if (!company.a.$) {
			var company_ = company.a.a;
			return !$author$project$Api$Provider$Company$Min$companyType(company_);
		} else {
			var company_ = company.a.a;
			return !$author$project$Api$Company$companyType(company_);
		}
	} else {
		return false;
	}
};
var $author$project$Api$Employer$Invoice$One$isPayable = function (_v0) {
	var record = _v0.b;
	return record.RZ;
};
var $author$project$Api$Provider$Invoice$One$isPayable = function (_v0) {
	var record = _v0.b;
	return record.RZ;
};
var $author$project$Api$Invoice$One$isPayable = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$isPayable(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$isPayable(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Meta$issueAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Sh;
};
var $author$project$Api$Provider$Invoice$Meta$issueAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Sh;
};
var $author$project$Api$Invoice$Meta$issueAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$issueAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$issueAction(meta_);
	}
};
var $author$project$Api$Employer$Invoice$Meta$markAsPaidAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Ti;
};
var $author$project$Api$Provider$Invoice$Meta$markAsPaidAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Ti;
};
var $author$project$Api$Invoice$Meta$markAsPaidAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$markAsPaidAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$markAsPaidAction(meta_);
	}
};
var $author$project$Components$Invoice$maxInvoiceLinesForDetailsDownload = 750;
var $author$project$Api$Invoice$Meta$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Invoice$Meta$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Invoice$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Provider$Invoice$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Invoice$One$meta = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Invoice$Meta$Provider(
			$author$project$Api$Provider$Invoice$One$meta(invoice_));
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Invoice$Meta$Employer(
			$author$project$Api$Employer$Invoice$One$meta(invoice_));
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save = {$: 6};
var $author$project$Ui$Modal$Faq = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Modal$faq = function (contents) {
	return $author$project$Ui$Modal$Faq(contents);
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ToggleCreditFaqFaq = {$: 2};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ToggleIncidentalChargesFaq = {$: 1};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaq = F4(
	function (visible, toogle, title, contents) {
		return _List_fromArray(
			[
				A3(
				$author$project$Ui$Element$custom,
				'modal-faq__title',
				_List_fromArray(
					[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2, $author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Toggle faq visibility'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(toogle),
								$author$project$Ui$Button$icon(
								visible ? $author$project$Ui$SvgIcon$minus : $author$project$Ui$SvgIcon$add)
							]),
						_List_Nil),
						A2(
						$author$project$Ui$Typography$titleSm,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('How do I add '),
								$elm$html$Html$text(title),
								$elm$html$Html$text('?')
							]))
					])),
				visible ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				contents) : $elm$html$Html$text('')
			]);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaqs = function (model) {
	return _Utils_ap(
		A4(
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaq,
			model.qU,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ToggleIncidentalChargesFaq,
			'incidental charges',
			_List_fromArray(
				[
					$elm$html$Html$text('Search for the charge item from your preconfigured list or manually enter the details of the charge. '),
					$elm$html$Html$text('To add more than one, change the quantity field to auto-calculate the amount for a group of charges like flu shots or COVID tests.')
				])),
		A4(
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaq,
			model.p$,
			$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ToggleCreditFaqFaq,
			'credit',
			_List_fromArray(
				[
					$elm$html$Html$text('Search for the negative charge item from your preconfigured list or manually enter the details of the credit with a '),
					$elm$html$Html$text('negative (-) minus sign in front of the price (e.g. $-20).')
				])));
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateValidation = 3;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Quantity = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityUom = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityValidation = 1;
var $author$project$Api$Charge$PayerType$Sponsor = 1;
var $author$project$Components$DateInput$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$DateInput$disabled = $author$project$Components$DateInput$Disabled;
var $author$project$Ui$Typography$Display4 = {$: 26};
var $author$project$Ui$Typography$display4 = $author$project$Ui$Typography$Display4;
var $author$project$Api$Provider$InvoiceLine$One$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Charge$Calculate$subtotalInCents = function (_v0) {
	var record = _v0;
	return record._7;
};
var $author$project$Api$Employer$Practice$One$trackPatientsByLocation = function (_v0) {
	var record = _v0;
	return record.$$;
};
var $author$project$Api$Practice$trackPatientsByLocation = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$trackPatientsByLocation(practice_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$uomOptions = A2(
	$elm$core$List$map,
	function (uom_) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$Uom$Shared$code(uom_)),
			$author$project$Api$Provider$Uom$Shared$name(uom_));
	},
	$author$project$Api$Provider$Uom$list(
		function (d) {
			return _Utils_update(
				d,
				{
					HH: $elm$core$Maybe$Just('time')
				});
		}));
var $author$project$Components$InventoryWarning$LowStock = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$InventoryWarning$NotTracking = {$: 3};
var $author$project$Components$InventoryWarning$OutOfStock = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$InventoryWarning$Tracking = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$InventoryWarning$calculateStatus = F2(
	function (chargeItem, quantity) {
		var _v0 = _Utils_Tuple2(chargeItem, quantity);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var chargeItem_ = _v0.a.a;
			var quantity_ = _v0.b.a;
			var _v1 = function () {
				var _v2 = chargeItem_.IN;
				if (!_v2.$) {
					var alertQuantity_ = _v2.a;
					return _Utils_Tuple2(true, alertQuantity_);
				} else {
					return _Utils_Tuple2(false, 0);
				}
			}();
			var hasAlertQuantity = _v1.a;
			var alertQuantity = _v1.b;
			if (!chargeItem_.$_) {
				return $author$project$Components$InventoryWarning$NotTracking;
			} else {
				var existing = A2($elm$core$Maybe$withDefault, 0, chargeItem_.Xv);
				var remaining = existing - quantity_;
				return (remaining < 0) ? $author$project$Components$InventoryWarning$OutOfStock(existing) : ((!remaining) ? $author$project$Components$InventoryWarning$LowStock(remaining) : ((hasAlertQuantity && (_Utils_cmp(remaining, alertQuantity) < 1)) ? $author$project$Components$InventoryWarning$LowStock(remaining) : $author$project$Components$InventoryWarning$Tracking(remaining)));
			}
		} else {
			return $author$project$Components$InventoryWarning$NotTracking;
		}
	});
var $author$project$Components$InventoryWarning$viewLowStock = function (remaining) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[$author$project$Ui$Badge$warning]),
				_List_fromArray(
					[
						$elm$html$Html$text('Low Inventory')
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$author$project$Utils$Html$noBreakSpace,
						(!remaining) ? $author$project$Utils$Html$empty : $elm$html$Html$text('Only '),
						$elm$html$Html$text(
						A2($author$project$Formatters$String$pluralize, 'item', remaining)),
						$elm$html$Html$text(' will be left in stock')
					])),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Manage stock levels')
					]))
			]));
};
var $author$project$Components$InventoryWarning$viewOutOfStock = function (existing) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[$author$project$Ui$Badge$danger]),
				_List_fromArray(
					[
						$elm$html$Html$text('Out of Stock')
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$author$project$Utils$Html$noBreakSpace,
						$elm$html$Html$text('Not enough stock ('),
						$elm$html$Html$text(
						A2($author$project$Formatters$String$pluralize, 'item', existing)),
						$elm$html$Html$text(' in stock)')
					])),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Manage stock levels')
					]))
			]));
};
var $author$project$Components$InventoryWarning$viewTracking = function (remaining) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$author$project$Utils$Html$noBreakSpace,
						$elm$html$Html$text(
						A2($author$project$Formatters$String$pluralize, 'item', remaining)),
						$elm$html$Html$text(' will be left in stock')
					]))
			]));
};
var $author$project$Components$InventoryWarning$view = F2(
	function (chargeItem, quantity) {
		var status = A2($author$project$Components$InventoryWarning$calculateStatus, chargeItem, quantity);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					switch (status.$) {
						case 2:
							var existing = status.a;
							return $author$project$Components$InventoryWarning$viewOutOfStock(existing);
						case 1:
							var remaining = status.a;
							return $author$project$Components$InventoryWarning$viewLowStock(remaining);
						case 0:
							var remaining = status.a;
							return $author$project$Components$InventoryWarning$viewTracking(remaining);
						default:
							return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Api$Provider$Charge$Calculate$coveredCharges = function (_v0) {
	var record = _v0;
	return record.L9;
};
var $author$project$Components$CoverageRuleDescription$Shared = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CoveredCharge$All$coverageRule = function (_v0) {
	var shared = _v0;
	return shared.L6;
};
var $author$project$Components$Invoice$ChargeDiscount$viewCoveredCharge = function (coveredCharge) {
	var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coveredCharge);
	return A2(
		$author$project$Components$CoverageRuleDescription$view,
		$author$project$Components$CoverageRuleDescription$Shared(coverageRule),
		false);
};
var $author$project$Components$Invoice$ChargeDiscount$view = function (charge) {
	var discountInCents = $author$project$Api$Provider$Charge$Calculate$discountInCents(charge);
	if (!(!discountInCents)) {
		var issuedSubtotalInCents = $author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(charge);
		var coveredCharges = $author$project$Api$Provider$Charge$Calculate$coveredCharges(charge);
		return A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					(!$elm$core$List$isEmpty(coveredCharges)) ? A3(
					$author$project$Ui$Popover$view,
					_List_fromArray(
						[$author$project$Ui$Popover$lg]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 5)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Popover$body,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Components$Invoice$ChargeDiscount$viewCoveredCharge, coveredCharges))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(issuedSubtotalInCents + discountInCents))
						])),
					$author$project$Utils$Html$noBreakSpace
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$ResourceFilter$Style = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$ResourceFilter$style = $author$project$Components$ResourceFilter$Style;
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewCategoryFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var categoryResourceFilter = _v0.cJ;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Category'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Category$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0)
						]),
					categoryResourceFilter))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewChargeFormGroup = F2(
	function (model, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Charge Name'),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			function () {
				var _v0 = model.Rr;
				if (!_v0.$) {
					var _v1 = $author$project$Utils$Form$fields(form);
					var name = _v1.zh;
					return _List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', name)),
									$author$project$Ui$Form$Input$placeholder('e.g. Office Visit'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						]);
				} else {
					var _v2 = $author$project$Utils$Form$fields(form);
					var chargeItemResourceFilter = _v2.cK;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$ChargeItem$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Components$ResourceFilter$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]),
								chargeItemResourceFilter))
						]);
				}
			}());
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Description = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewDescriptionFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var description = _v0.Nx;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Description'),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$value(description),
						$author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Description))
					]))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewLocationFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var locationResourceFilter = _v0.rl;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Location'),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Location$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0)
						]),
					locationResourceFilter))
			]));
};
var $author$project$Api$Provider$Membership$ForCompanyAccountOne$membershipPatients = function (_v0) {
	var record = _v0;
	return record.TF;
};
var $author$project$Api$Provider$CompanyAccount$One$memberships = function (_v0) {
	var record = _v0.b;
	return record.TN;
};
var $author$project$Components$ResourceFilter$CompanyRegistration$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Api$Provider$MembershipPatient$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$MembershipPatient$Min$periodRateInCents = function (_v0) {
	var record = _v0;
	return record.Wd;
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewMembershipPatient = function (membershipPatient) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$phi(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$MembershipPatient$Min$name(membershipPatient)),
				$elm$html$Html$text(' - '),
				$elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Api$Provider$MembershipPatient$Min$periodRateInCents(membershipPatient))))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewPatientFormGroup = F2(
	function (model, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var patient = _v0.VM;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Patient'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$CompanyRegistration$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						model.hO)),
					function () {
					if (!patient.$) {
						var patient_ = patient.a;
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$titleSm,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Most Recent Membership Prices')
										])),
									function () {
									var _v2 = model.Lr;
									if (_v2.$ === 3) {
										var companyAccount = _v2.a;
										var membershipPatients = A2(
											$elm$core$Maybe$withDefault,
											_List_Nil,
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Membership$ForCompanyAccountOne$membershipPatients,
												$elm_community$list_extra$List$Extra$last(
													$author$project$Api$Provider$CompanyAccount$One$memberships(companyAccount))));
										return $elm$core$List$isEmpty(membershipPatients) ? $elm$html$Html$text('No recent memberships found for ' + patient_.zh) : A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											A2($elm$core$List$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewMembershipPatient, membershipPatients));
									} else {
										return $author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$small]));
									}
								}()
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewProviderFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var practitionerResourceFilter = _v0.jC;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Provider'),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Practitioner$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0)
						]),
					practitionerResourceFilter))
			]));
};
var $author$project$Components$ChargeRoutingWarning$Calculate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Charge$PayerType$Patient = 0;
var $author$project$Api$Provider$Charge$Calculate$adjudicatedPayer = function (_v0) {
	var record = _v0;
	return record.IA;
};
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$payerType = function (_v0) {
	var record = _v0;
	return record.VW;
};
var $author$project$Api$Charge$PayerType$adjudicatedType = function (preview) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Charge$AdjudicatedPayer$One$payerType,
		$author$project$Api$Provider$Charge$Calculate$adjudicatedPayer(preview));
};
var $author$project$Api$Charge$PayerType$toPayerType = function (maybeString) {
	if ((!maybeString.$) && (maybeString.a === 'company')) {
		return 1;
	} else {
		return 0;
	}
};
var $author$project$Api$Charge$PayerType$adjudicatedToSelectedPayer = F2(
	function (preview, selectedPayer) {
		return _Utils_eq(
			$author$project$Api$Charge$PayerType$toPayerType(
				$author$project$Api$Charge$PayerType$adjudicatedType(preview)),
			selectedPayer);
	});
var $author$project$Api$Provider$Charge$One$rulePayer = function (_v0) {
	var record = _v0.b;
	return record.YX;
};
var $author$project$Api$Charge$PayerType$toString = function (payerType) {
	if (!payerType) {
		return 'Patient';
	} else {
		return 'Sponsor';
	}
};
var $author$project$Api$Charge$RulePayer$toString = function (gender) {
	if (!gender) {
		return 'sponsor';
	} else {
		return 'patient';
	}
};
var $author$project$Components$ChargeRoutingWarning$view = F2(
	function (selectedPayer, charge) {
		var coveredCharges = function () {
			if (!charge.$) {
				var charge_ = charge.a;
				return $author$project$Api$Provider$Charge$Calculate$coveredCharges(charge_);
			} else {
				return _List_Nil;
			}
		}();
		var showWarning = function () {
			var _v1 = _Utils_Tuple2(coveredCharges, charge);
			if (!_v1.b.$) {
				var coveredCharges_ = _v1.a;
				var charge_ = _v1.b.a;
				return (!A2($author$project$Api$Charge$PayerType$adjudicatedToSelectedPayer, charge_, selectedPayer)) && ($elm$core$List$length(coveredCharges_) > 0);
			} else {
				if (!_v1.a.b) {
					var charge_ = _v1.b.a;
					var _v2 = $author$project$Api$Provider$Charge$One$rulePayer(charge_);
					if (!_v2.$) {
						var rulePayer = _v2.a;
						return !_Utils_eq(
							$author$project$Api$Charge$RulePayer$toString(rulePayer),
							$elm$core$String$toLower(
								$author$project$Api$Charge$PayerType$toString(selectedPayer)));
					} else {
						return false;
					}
				} else {
					return false;
				}
			}
		}();
		if (showWarning) {
			var inverse = function () {
				if (!selectedPayer) {
					return 1;
				} else {
					return 0;
				}
			}();
			return $elm$core$Maybe$Just(
				A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This charge is being added to the '),
							$elm$html$Html$text(
							$elm$core$String$toLower(
								$author$project$Api$Charge$PayerType$toString(selectedPayer))),
							$elm$html$Html$text('\'s invoice, but the membership rule specifies it should be paid for by the '),
							$elm$html$Html$text(
							$elm$core$String$toLower(
								$author$project$Api$Charge$PayerType$toString(inverse))),
							$elm$html$Html$text('.')
						])));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate = F2(
	function (selectedPayer, charge) {
		return A2(
			$author$project$Components$ChargeRoutingWarning$view,
			selectedPayer,
			$author$project$Components$ChargeRoutingWarning$Calculate(charge));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFormGroups = F2(
	function (model, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var isTimeBased = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq('time'),
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.aam;
						},
						$author$project$Api$Provider$Uom$Shared$unitClass),
					fields.lp)));
		var editingNotInDraft = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$neq('draft'),
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$InvoiceLine$One$status,
					$author$project$Api$Data$toMaybe(model.q0))));
		var discountNotRemoved = function () {
			var _v9 = $author$project$Api$Data$toMaybe(model.afU);
			if (!_v9.$) {
				var preview = _v9.a;
				return (!fields.NJ) && (!(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)));
			} else {
				return false;
			}
		}();
		return _List_fromArray(
			[
				A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewChargeFormGroup, model, form),
				function () {
				var _v0 = model.Rr;
				if (_v0.$ === 1) {
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewCategoryFormGroup(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.Rr;
				if (_v1.$ === 1) {
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewDescriptionFormGroup(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewPatientFormGroup, model, form),
				function () {
				var _v2 = model.Rr;
				if (_v2.$ === 1) {
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewProviderFormGroup(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = _Utils_Tuple2(
					model.Rr,
					$author$project$Api$Practice$trackPatientsByLocation(model.WF));
				if ((_v3.a.$ === 1) && _v3.b) {
					var _v4 = _v3.a;
					return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewLocationFormGroup(form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.Rr;
				if (_v5.$ === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label(
								isTimeBased ? 'Dates' : 'Date'),
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(fields.kg),
												A2(
													$author$project$Components$DateInput$view,
													_List_fromArray(
														[
															$author$project$Components$DateInput$value(fields._E),
															$author$project$Components$DateInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
															$author$project$Components$DateInput$errors(
															A2($author$project$Utils$Form$validationErrors, 2, form)),
															$author$project$Components$DateInput$disabled(editingNotInDraft)
														]),
													fields.kg))
											])),
										isTimeBased ? A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(fields.qu),
												A2(
													$author$project$Components$DateInput$view,
													_List_fromArray(
														[
															$author$project$Components$DateInput$value(fields.qs),
															$author$project$Components$DateInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
															$author$project$Components$DateInput$errors(
															A2($author$project$Utils$Form$validationErrors, 3, form)),
															$author$project$Components$DateInput$disabled(editingNotInDraft)
														]),
													fields.qu))
											])) : $author$project$Ui$FlexGrid$none
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v6 = model.Rr;
				if (_v6.$ === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('QTY'),
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$number,
														$author$project$Ui$Form$Input$value(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Bd))),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Quantity)),
														$author$project$Ui$Form$Input$disabled(editingNotInDraft),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 1, form)),
														$author$project$Ui$Form$Input$test('company-charge-quantity')
													]))
											])),
										isTimeBased ? A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Be)),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityUom)),
														$author$project$Ui$Form$Select$disabled(editingNotInDraft)
													]),
												$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$uomOptions)
											])) : $author$project$Ui$FlexGrid$none
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Components$InventoryWarning$view,
												A2(
													$elm$core$Maybe$map,
													function (chargeItem) {
														return {IN: chargeItem.IN, Xv: chargeItem.Xv, $_: chargeItem.$_};
													},
													fields.lp),
												fields.Bd)
											]))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Price'),
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$view(
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$CurrencyInput$value(fields.Ba),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
												A2(
													$elm$core$List$cons,
													$author$project$Ui$Form$CurrencyInput$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents)),
													A2(
														$elm$core$List$cons,
														$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
														A2(
															$elm$core$List$cons,
															$author$project$Ui$Form$CurrencyInput$disabled(editingNotInDraft || discountNotRemoved),
															function () {
																var _v7 = _Utils_Tuple2(
																	isTimeBased,
																	A2(
																		$elm$core$Maybe$map,
																		$elm$core$String$toLower,
																		A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, fields.W$)));
																if (_v7.a && (!_v7.b.$)) {
																	var name = _v7.b.a;
																	return _List_fromArray(
																		[
																			$author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
																		]);
																} else {
																	return _List_Nil;
																}
															}())))))),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 4, form)),
										((!editingNotInDraft) && discountNotRemoved) ? A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Remove membership rule'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick(
														$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated(
															$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden(true)))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Remove membership rule')
													]))
											])) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Amounts can be negative')
													]))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Total'),
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v8 = model.afU;
								switch (_v8.$) {
									case 3:
										var preview = _v8.a;
										if ((!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)) && (!fields.NJ)) {
											return $elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview)));
										} else {
											var discountRemoved = fields.NJ && (!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
											return A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$div,
														_List_fromArray(
															[$author$project$Ui$Typography$display4]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$Currency$fromInt(
																	$author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview)))
															])),
														(!(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview))) ? A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Total without membership: '),
																$author$project$Components$Invoice$ChargeDiscount$view(preview)
															])) : $author$project$Utils$Html$empty,
														discountRemoved ? A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Membership rule was removed')
															])) : $author$project$Utils$Html$empty,
														$author$project$Utils$Html$noBreakSpace,
														((!editingNotInDraft) && (discountRemoved && $author$project$Utils$Maybe$toBool(fields.lp))) ? A3(
														$author$project$Ui$Button$view,
														{abp: 'Revert to original'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																$author$project$Ui$Button$onClick(
																$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated(
																	$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden(false)))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Revert to original')
															])) : $author$project$Utils$Html$empty,
														A2(
														$elm$core$Maybe$withDefault,
														$elm$html$Html$text(''),
														A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, 1, preview))
													]));
										}
									case 1:
										return $author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$small]));
									default:
										return $elm$html$Html$text('N/A');
								}
							}()
							]))
					]))
			]);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								function () {
								var _v1 = model.q1;
								if (!_v1.$) {
									return $elm$html$Html$text('Update');
								} else {
									return $elm$html$Html$text('Add');
								}
							}(),
								$elm$html$Html$text(' Charge')
							]))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						function () {
						var _v2 = model.PB;
						if (!_v2.$) {
							var form = _v2.a;
							return A2(
								$author$project$Ui$Form$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save),
										$author$project$Ui$Form$horizontal
									]),
								A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFormGroups, model, form));
						} else {
							return A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Spinner$view(_List_Nil)
									]));
						}
					}()
					])),
				$author$project$Ui$Modal$faq(
				$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaqs(model)),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel and close'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										function () {
										var verb = function () {
											var _v3 = model.q1;
											if (!_v3.$) {
												return 'Update';
											} else {
												return 'Add';
											}
										}();
										return A3(
											$author$project$Ui$Button$view,
											{abp: verb},
											_List_fromArray(
												[
													$author$project$Ui$Button$fullWidth(true),
													$author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save),
													$author$project$Ui$Button$primary,
													$author$project$Ui$Button$loading(
													_Utils_eq(model.jY, $author$project$Api$Data$Loading))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(verb + ' Charge')
												]));
									}()
									]))
							]))
					]))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$modal = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.fq;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var invoiceLine = _v1.a;
					var deleteRequest = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed(invoiceLine),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('invoice line'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.hq;
				if (!_v2.$) {
					var adjustmentModal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg,
						$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$view(adjustmentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Api$Common$Invoice$Delta$added = function (_v0) {
	var record = _v0;
	return record.Il;
};
var $author$project$Api$Provider$InvoicePatient$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Api$Common$Invoice$Delta$removed = function (_v0) {
	var record = _v0;
	return record.Yb;
};
var $author$project$Api$Provider$InvoicePatient$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$InvoicePatient$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$InvoicePatient$Shared$owner = function (_v0) {
	var record = _v0;
	return record.Vp;
};
var $author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient = F3(
	function (timeFormatter, timeGetter, invoicePatient) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(5),
											timeGetter(invoicePatient))))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$InvoicePatient$Shared$name(invoicePatient))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Api$Provider$InvoicePatient$Shared$owner(invoicePatient);
									if (!_v0.$) {
										var owner = _v0.a;
										return A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$fontWeight(1),
													$author$project$Ui$Typography$gray
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Dependent of '),
													$elm$html$Html$text(
													$author$project$Api$Provider$Patient$Min$name(owner))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$PatientDeltaModal$view = F3(
	function (timeFormatter, close, delta) {
		var patientsRemoved = $author$project$Api$Common$Invoice$Delta$removed(delta);
		var patientsAdded = $author$project$Api$Common$Invoice$Delta$added(delta);
		return A3(
			$author$project$Ui$Modal$view,
			close,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Patient List Changes')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$title,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(patientsAdded))),
													$elm$html$Html$text(' Patients'),
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$fontWeight(1)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(' - added')
														]))
												])),
											($elm$core$List$length(patientsAdded) > 0) ? A2(
											$author$project$Ui$ListGroup$view,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2(
													$author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient,
													timeFormatter,
													A2($elm$core$Basics$composeR, $author$project$Api$Provider$InvoicePatient$Shared$startDate, $elm$core$Maybe$Just)),
												patientsAdded)) : $author$project$Utils$Html$empty
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$title,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(patientsRemoved))),
													$elm$html$Html$text(' Patients'),
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$fontWeight(1)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(' - removed')
														]))
												])),
											($elm$core$List$length(patientsRemoved) > 0) ? A2(
											$author$project$Ui$ListGroup$view,
											_List_Nil,
											A2(
												$elm$core$List$map,
												A2($author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient, timeFormatter, $author$project$Api$Provider$InvoicePatient$Shared$endDate),
												patientsRemoved)) : $author$project$Utils$Html$empty
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(close),
									$author$project$Ui$Button$primary
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.nj;
	if (!_v1.$) {
		var patientDelta = _v1.a;
		return A3($author$project$Components$Invoice$Summary$PatientDeltaModal$view, model.Hy, $author$project$Components$Invoice$Summary$CloseDeltaModal, patientDelta);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Employer$Invoice$Shared$paidAt = function (_v0) {
	var record = _v0;
	return record.Vt;
};
var $author$project$Api$Employer$Invoice$One$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$paidAt(shared);
};
var $author$project$Api$Provider$Invoice$Shared$paidAt = function (_v0) {
	var record = _v0.b;
	return record.Vt;
};
var $author$project$Api$Provider$Invoice$One$paidAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$paidAt(shared);
};
var $author$project$Api$Invoice$One$paidAt = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$paidAt(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$paidAt(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Shared$paidInCents = function (_v0) {
	var record = _v0;
	return record.Vu;
};
var $author$project$Api$Employer$Invoice$One$paidInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Invoice$Shared$paidInCents(shared);
};
var $author$project$Api$Provider$Invoice$Shared$paidInCents = function (_v0) {
	var record = _v0.b;
	return record.Vu;
};
var $author$project$Api$Provider$Invoice$One$paidInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Invoice$Shared$paidInCents(shared);
};
var $author$project$Api$Invoice$One$paidInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$paidInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$paidInCents(invoice_);
	}
};
var $author$project$Api$Payment$Provider_SharedWithRefunds = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Invoice$One$payments = function (_v0) {
	var record = _v0.b;
	return record.V5;
};
var $author$project$Api$Provider$Invoice$One$payments = function (_v0) {
	var record = _v0.b;
	return record.V5;
};
var $author$project$Api$Invoice$One$payments = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$Payment$Provider_SharedWithRefunds,
			$author$project$Api$Provider$Invoice$One$payments(invoice_));
	} else {
		var invoice_ = invoice.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$Payment$Employer_One,
			$author$project$Api$Employer$Invoice$One$payments(invoice_));
	}
};
var $author$project$Api$Employer$Practice$One$phones = function (_v0) {
	var record = _v0;
	return record.Wi;
};
var $author$project$Api$Practice$phones = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$phones(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$phones(practice_);
	}
};
var $author$project$Api$Employer$Invoice$One$securePdfInlineToken = function (_v0) {
	var record = _v0.b;
	return record.Ze;
};
var $author$project$Api$Provider$Invoice$One$securePdfInlineToken = function (_v0) {
	var record = _v0.b;
	return record.Ze;
};
var $author$project$Api$Invoice$One$securePdfInlineToken = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$securePdfInlineToken(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$securePdfInlineToken(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$One$securePdfWithChargeDetailsToken = function (_v0) {
	var record = _v0.b;
	return record.Zf;
};
var $author$project$Api$Provider$Invoice$One$securePdfWithChargeDetailsToken = function (_v0) {
	var record = _v0.b;
	return record.Zf;
};
var $author$project$Api$Invoice$One$securePdfInlineWithChargeDetailsToken = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$securePdfWithChargeDetailsToken(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$securePdfWithChargeDetailsToken(invoice_);
	}
};
var $author$project$Components$AuditTrailLog$Toggle = {$: 0};
var $author$project$Ui$Button$Badge = 10;
var $author$project$Ui$Button$badge = $author$project$Ui$Button$Styled(10);
var $author$project$Api$Audit$record_ = function (_v0) {
	var record = _v0;
	return record;
};
var $author$project$Api$Audit$createdAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Audit$record_,
	function ($) {
		return $.Mf;
	});
var $author$project$Api$Audit$extraUrl = function (audit) {
	var record = audit;
	var _v1 = record.vj;
	if (!_v1.$) {
		var aggregate = _v1.a;
		return aggregate.adh;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Components$AuditTrailLog$formatWhodunnit = function (email) {
	return A2(
		$elm$core$String$endsWith,
		'@hint.com',
		$elm$core$String$toLower(email)) ? 'System Admin' : email;
};
var $author$project$Components$AuditTrailLog$isLast = F2(
	function (audits, audit) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq(audit),
				$elm$core$List$head(
					$elm$core$List$reverse(audits))));
	});
var $author$project$Api$Audit$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Audit$record_,
	function ($) {
		return $.zh;
	});
var $author$project$Api$Audit$isOnlineSignup = function (trail) {
	return A2(
		$elm$core$String$contains,
		'OnlineEnrollment',
		$author$project$Api$Audit$name(trail));
};
var $author$project$Api$Audit$aggregateType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Audit$record_,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.vj;
		},
		$elm$core$Maybe$map(
			function ($) {
				return $.ahI;
			})));
var $author$project$Api$Audit$crumbs = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Audit$record_,
	function ($) {
		return $.Mo;
	});
var $author$project$Api$Audit$Crumb$label = function (crumb) {
	return crumb.FU.aej;
};
var $author$project$Api$Audit$Crumb$recordType = function (crumb) {
	return crumb.FU.ahI;
};
var $author$project$Api$Audit$Crumb$diff = function ($) {
	return $.NG;
};
var $author$project$Components$Auditing$Crumb$Helpers$isChangePresent = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	var _v1 = _Utils_Tuple2(from, to);
	if (!_v1.a.$) {
		return true;
	} else {
		if (!_v1.b.$) {
			return true;
		} else {
			return false;
		}
	}
};
var $author$project$Components$Auditing$Crumb$Helpers$getFieldName = function (_v0) {
	var field = _v0.a;
	var diff = _v0.b;
	return $author$project$Components$Auditing$Crumb$Helpers$isChangePresent(diff) ? $author$project$Formatters$String$humanize(field) : '';
};
var $elm$html$Html$s = _VirtualDom_node('s');
var $author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue = function (diffValue) {
	if (!diffValue.$) {
		var text = diffValue.a;
		return $elm$html$Html$text(text);
	} else {
		var linkable = diffValue.a;
		return $elm$html$Html$text(linkable.aej);
	}
};
var $author$project$Components$Auditing$Crumb$Helpers$processDiff = function (_v0) {
	var from = _v0.a;
	var to = _v0.b;
	var _v1 = _Utils_Tuple2(from, to);
	if (!_v1.a.$) {
		if (_v1.b.$ === 1) {
			var fromValue = _v1.a.a;
			var _v2 = _v1.b;
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' removed '),
						A2(
						$elm$html$Html$s,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(fromValue)
							]))
					]));
		} else {
			var fromValue = _v1.a.a;
			var toValue = _v1.b.a;
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' changed from '),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$s,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(fromValue)
									])),
								$elm$html$Html$text(' to '),
								$author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(toValue)
							]))
					]));
		}
	} else {
		if (!_v1.b.$) {
			var _v3 = _v1.a;
			var toValue = _v1.b.a;
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' added '),
						$author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(toValue)
					]));
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return $elm$html$Html$text('');
		}
	}
};
var $author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix = F2(
	function (prefix, _v0) {
		var field = _v0.a;
		var diff = _v0.b;
		var prefixText = $elm$core$String$isEmpty(prefix) ? $elm$html$Html$text('') : $elm$html$Html$text(prefix + '\'s ');
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					prefixText,
					$elm$core$String$isEmpty(prefix) ? $elm$html$Html$text(
					$author$project$Components$Auditing$Crumb$Helpers$getFieldName(
						_Utils_Tuple2(field, diff))) : $elm$html$Html$text(
					$elm$core$String$toLower(
						$author$project$Components$Auditing$Crumb$Helpers$getFieldName(
							_Utils_Tuple2(field, diff)))),
					$author$project$Components$Auditing$Crumb$Helpers$processDiff(diff)
				]));
	});
var $author$project$Components$Auditing$Crumb$Helpers$viewChange = $author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix('');
var $author$project$Components$Auditing$Crumb$Helpers$viewChanges = function (crumb) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('clearfix')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Components$Auditing$Crumb$Helpers$viewChange,
					$author$project$Api$Audit$Crumb$diff(crumb)))
			]));
};
var $author$project$Components$Auditing$Crumb$Address$view = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Address added')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Address deleted')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$Charge$view = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Charge added')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Charge deleted')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate = function (name) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was enrolled')
			]));
};
var $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated = function (name) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was terminated')
			]));
};
var $author$project$Components$Auditing$Crumb$Helpers$getDiffValue = F2(
	function (searchKey, crumb) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (_v0) {
						var key = _v0.a;
						return _Utils_eq(key, searchKey);
					},
					$author$project$Api$Audit$Crumb$diff(crumb))));
	});
var $author$project$Components$Auditing$Crumb$Helpers$getDiffValues = F2(
	function (searchKey, crumb) {
		var _v0 = A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v1) {
				var key = _v1.a;
				return _Utils_eq(key, searchKey);
			},
			$author$project$Api$Audit$Crumb$diff(crumb));
		if (!_v0.$) {
			var _v2 = _v0.a;
			var _v3 = _v2.b;
			var from = _v3.a;
			var to = _v3.b;
			var _v4 = _Utils_Tuple2(from, to);
			_v4$3:
			while (true) {
				if (!_v4.a.$) {
					if (!_v4.a.a.$) {
						if (!_v4.b.$) {
							if (!_v4.b.a.$) {
								var fromValue = _v4.a.a.a;
								var toValue = _v4.b.a.a;
								return _Utils_Tuple2(fromValue, toValue);
							} else {
								break _v4$3;
							}
						} else {
							var fromValue = _v4.a.a.a;
							var _v5 = _v4.b;
							return _Utils_Tuple2(fromValue, '');
						}
					} else {
						break _v4$3;
					}
				} else {
					if ((!_v4.b.$) && (!_v4.b.a.$)) {
						var _v6 = _v4.a;
						var toValue = _v4.b.a.a;
						return _Utils_Tuple2('', toValue);
					} else {
						break _v4$3;
					}
				}
			}
			return _Utils_Tuple2('', '');
		} else {
			return _Utils_Tuple2('', '');
		}
	});
var $author$project$Components$Auditing$Crumb$MembershipPatient$viewRestarted = function (name) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was re-enrolled')
			]));
};
var $author$project$Components$Auditing$Crumb$MembershipPatient$viewUpdate = function (crumb) {
	var name = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'status', crumb);
	var oldStatus = _v0.a;
	var newStatus = _v0.b;
	var _v1 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'start_date', crumb);
	var oldStartDate = _v1.a;
	var newStartDate = _v1.b;
	var isEnrolled = (oldStartDate === '') && (newStartDate !== '');
	var _v2 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'end_date', crumb);
	var oldEndDate = _v2.a;
	var newEndDate = _v2.b;
	if (isEnrolled) {
		return $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate(name);
	} else {
		if (oldStatus === 'ended') {
			return $author$project$Components$Auditing$Crumb$MembershipPatient$viewRestarted(name);
		} else {
			var isTerminated = (oldEndDate === '') && (newEndDate !== '');
			if ((newStatus === 'ended') || isTerminated) {
				return $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated(name);
			} else {
				var startDateDiff = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValue, 'start_date', crumb);
				var startDateValue = A2(
					$author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix,
					name,
					_Utils_Tuple2('start_date', startDateDiff));
				return A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[startDateValue]));
			}
		}
	}
};
var $author$project$Components$Auditing$Crumb$MembershipPatient$view = function (crumb) {
	var name = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate(name);
		case 1:
			return $author$project$Components$Auditing$Crumb$MembershipPatient$viewUpdate(crumb);
		default:
			return $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated(name);
	}
};
var $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeEligible = function (name) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was made eligible')
			]));
};
var $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeIneligible = function (name) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was removed from the company account')
			]));
};
var $author$project$Components$Auditing$Crumb$CompanyAccount$viewUpdate = function (crumb) {
	var name = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'termination_requested_at', crumb);
	var oldTerminationDate = _v0.a;
	var newTerminationDate = _v0.b;
	return ((oldTerminationDate !== '') && (newTerminationDate === '')) ? $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeEligible(name) : (((oldTerminationDate === '') && (newTerminationDate !== '')) ? $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeIneligible(name) : A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('')
			])));
};
var $author$project$Components$Auditing$Crumb$CompanyAccount$view = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Membership created')
					]));
		case 1:
			var _v1 = $author$project$Api$Audit$Crumb$recordType(crumb);
			if (_v1 === 'membership_patient') {
				return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
			} else {
				return $author$project$Components$Auditing$Crumb$CompanyAccount$viewUpdate(crumb);
			}
		default:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Membership deleted')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeEligible = function (name) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was made eligible')
			]));
};
var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeIneligible = function (name) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(name + ' was removed from the company account')
			]));
};
var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewUpdate = function (crumb) {
	var name = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'termination_requested_at', crumb);
	var oldTerminationDate = _v0.a;
	var newTerminationDate = _v0.b;
	return ((oldTerminationDate !== '') && (newTerminationDate === '')) ? $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeEligible(name) : (((oldTerminationDate === '') && (newTerminationDate !== '')) ? $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeIneligible(name) : A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('')
			])));
};
var $author$project$Components$Auditing$Crumb$CompanyRegistration$view = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Audit$Crumb$label(crumb) + ' was enrolled')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$CompanyRegistration$viewUpdate(crumb);
		default:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Audit$Crumb$label(crumb) + ' was unenrolled')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$CustomerInvoice$view = function (crumb) {
	var invoiceNumber = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Invoice ' + (invoiceNumber + ' was issued'))
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Invoice ' + (invoiceNumber + ' was deleted'))
					]));
	}
};
var $author$project$Components$Auditing$Crumb$Membership$viewCreate = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Membership created')
		]));
var $author$project$Components$Auditing$Crumb$Membership$viewDelete = A2(
	$author$project$Ui$Typography$div,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Membership terminated')
		]));
var $author$project$Components$Auditing$Crumb$Membership$viewUpdate = function (crumb) {
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'end_date', crumb);
	var oldEndDate = _v0.a;
	var newEndDate = _v0.b;
	return ((oldEndDate !== '') && (newEndDate === '')) ? $author$project$Components$Auditing$Crumb$Membership$viewCreate : (((oldEndDate === '') && (newEndDate !== '')) ? $author$project$Components$Auditing$Crumb$Membership$viewDelete : $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb));
};
var $author$project$Components$Auditing$Crumb$Membership$view = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return $author$project$Components$Auditing$Crumb$Membership$viewCreate;
		case 1:
			return $author$project$Components$Auditing$Crumb$Membership$viewUpdate(crumb);
		default:
			return $author$project$Components$Auditing$Crumb$Membership$viewDelete;
	}
};
var $author$project$Components$Auditing$Crumb$Phone$view = function (crumb) {
	var phoneType = $author$project$Api$Audit$Crumb$label(crumb);
	var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'number', crumb);
	var oldPhoneNumber = _v0.a;
	var newPhoneNumber = _v0.b;
	var _v1 = _Utils_Tuple2(crumb.aaO, oldPhoneNumber);
	switch (_v1.a) {
		case 0:
			var _v2 = _v1.a;
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(phoneType + (' ' + (newPhoneNumber + ' added')))
					]));
		case 1:
			if (_v1.b === '') {
				var _v3 = _v1.a;
				return A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(phoneType + (' ' + (newPhoneNumber + ' added')))
						]));
			} else {
				var _v4 = _v1.a;
				return A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(phoneType),
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(' changed from '),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$s,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(oldPhoneNumber)
												])),
											$elm$html$Html$text(' to '),
											$elm$html$Html$text(newPhoneNumber)
										]))
								]))
						]));
			}
		default:
			var _v5 = _v1.a;
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(phoneType + (' ' + (oldPhoneNumber + ' removed')))
					]));
	}
};
var $author$project$Components$Auditing$Crumb$view = function (crumb) {
	var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
	switch (_v0) {
		case 'company_registration':
			return $author$project$Components$Auditing$Crumb$CompanyRegistration$view(crumb);
		case 'company_account':
			return $author$project$Components$Auditing$Crumb$CompanyAccount$view(crumb);
		case 'charge':
			return $author$project$Components$Auditing$Crumb$Charge$view(crumb);
		case 'membership':
			return $author$project$Components$Auditing$Crumb$Membership$view(crumb);
		case 'membership_patient':
			return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
		case 'customer_invoice':
			return $author$project$Components$Auditing$Crumb$CustomerInvoice$view(crumb);
		case 'address':
			return $author$project$Components$Auditing$Crumb$Address$view(crumb);
		case 'phone':
			return $author$project$Components$Auditing$Crumb$Phone$view(crumb);
		default:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
	}
};
var $author$project$Components$Auditing$Trail$BankAccount$viewAll = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$BankAccount$view = function (trail) {
	var label = A2(
		$elm$core$Maybe$withDefault,
		'Bank Account',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Audit$Crumb$label,
			$elm$core$List$head(
				$author$project$Api$Audit$crumbs(trail))));
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'BankAccount Created':
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label + ' created')
					]));
		case 'BankAccount Deleted':
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label + ' deleted')
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$BankAccount$viewAll(trail));
	}
};
var $author$project$Components$Auditing$Trail$Card$viewAll = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Card$view = function (trail) {
	var label = A2(
		$elm$core$Maybe$withDefault,
		'Card',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Audit$Crumb$label,
			$elm$core$List$head(
				$author$project$Api$Audit$crumbs(trail))));
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'Card Created':
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label + ' created')
					]));
		case 'Card Deleted':
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label + ' deleted')
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Card$viewAll(trail));
	}
};
var $author$project$Components$Auditing$Trail$CompanyAccount$getCrumbList = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$CompanyAccount$viewAll = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Components$Auditing$Trail$CompanyAccount$getCrumbList(trail));
};
var $author$project$Components$Auditing$Trail$CompanyAccount$viewCreated = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Membership created')
		]));
var $author$project$Components$Auditing$Trail$CompanyAccount$viewDeleted = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Membership terminated')
		]));
var $author$project$Components$Auditing$Trail$CompanyAccount$viewEnrollmentApproved = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Enrollment Approved')
		]));
var $author$project$Components$Auditing$Trail$CompanyAccount$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'CompanyAccount Created':
			return $author$project$Components$Auditing$Trail$CompanyAccount$viewCreated;
		case 'CompanyAccount Unenrolled':
			return $author$project$Components$Auditing$Trail$CompanyAccount$viewDeleted;
		case 'CompanyAccount Approved':
			return $author$project$Components$Auditing$Trail$CompanyAccount$viewEnrollmentApproved;
		default:
			return $author$project$Components$Auditing$Trail$CompanyAccount$viewAll(trail);
	}
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewAll = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList(trail));
};
var $author$project$Api$Audit$label = function (audit) {
	var record = audit;
	var _v1 = record.vj;
	if (!_v1.$) {
		var aggregate = _v1.a;
		return aggregate.aej;
	} else {
		return '';
	}
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated = function (trail) {
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				'Invoice ' + ($author$project$Api$Audit$label(trail) + ' created'))
			]));
};
var $author$project$Api$Audit$Crumb$diffTypeToString = function (diffType) {
	if (!diffType.$) {
		var string = diffType.a;
		return $elm$core$Maybe$Just(string);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmount = function (trail) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$Maybe$andThen,
			function (crumb) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var key = _v0.a;
							return key === 'credit';
						},
						$author$project$Api$Audit$Crumb$diff(crumb)));
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (crumb) {
						return $author$project$Api$Audit$Crumb$recordType(crumb) === 'credit';
					},
					$author$project$Api$Audit$crumbs(trail)))));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper = F2(
	function (extractDiffType, trail) {
		var creditAmount = function () {
			var _v0 = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmount(trail);
			if (!_v0.$) {
				var diff = _v0.a;
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Audit$Crumb$diffTypeToString,
					extractDiffType(diff));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2($elm$core$Maybe$withDefault, '', creditAmount);
	});
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountApplied = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper(
	function (_v0) {
		var maybeDiffType = _v0.b;
		return maybeDiffType;
	});
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		A2(
			$elm$core$List$filter,
			function (crumb) {
				return $author$project$Api$Audit$Crumb$recordType(crumb) !== 'credit';
			},
			$author$project$Api$Audit$crumbs(trail)));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditApplied = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountApplied(trail) + ' credit applied')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit(trail))
			]));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountRemoved = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper(
	function (_v0) {
		var maybeDiffType = _v0.a;
		return maybeDiffType;
	});
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditRemoved = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountRemoved(trail) + ' credit removed')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit(trail))
			]));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewIssued = function (trail) {
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				'Invoice ' + ($author$project$Api$Audit$label(trail) + ' was issued'))
			]));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewReturnedToDraft = function (trail) {
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				'Invoice ' + ($author$project$Api$Audit$label(trail) + ' was returned to draft'))
			]));
};
var $author$project$Api$Audit$Crumb$event = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return 'create';
		case 1:
			return 'update';
		default:
			return 'delete';
	}
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewUpload = function (trail) {
	var isCustomerInvoiceCreate = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (crumb) {
				return $author$project$Api$Audit$Crumb$event(crumb) === 'create';
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (crumb) {
						return $author$project$Api$Audit$Crumb$recordType(crumb) === 'customer_invoice';
					},
					$author$project$Api$Audit$crumbs(trail)))));
	return isCustomerInvoiceCreate ? $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated(trail) : A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList(trail));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$viewVoided = function (trail) {
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				'Invoice ' + ($author$project$Api$Audit$label(trail) + ' was voided'))
			]));
};
var $author$project$Components$Auditing$Trail$CustomerInvoice$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'CustomerInvoice Returned to draft':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewReturnedToDraft(trail);
		case 'CustomerInvoice Issued':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewIssued(trail);
		case 'CustomerInvoice Created':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated(trail);
		case 'CustomerInvoice Voided':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewVoided(trail);
		case 'CSV Uploaded':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewUpload(trail);
		case 'CustomerInvoice Credits applied':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditApplied(trail);
		case 'CustomerInvoice Credits removed':
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditRemoved(trail);
		default:
			return $author$project$Components$Auditing$Trail$CustomerInvoice$viewAll(trail);
	}
};
var $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Invoice Auto-Issued')
		]));
var $author$project$Components$Auditing$Trail$Invoice$viewCreated = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Invoice Created')
		]));
var $author$project$Components$Auditing$Trail$Invoice$viewEmpty = $elm$html$Html$text('');
var $author$project$Components$Auditing$Trail$Invoice$viewIssued = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Invoice Issued')
		]));
var $author$project$Components$Auditing$Trail$Invoice$viewMarkedAsBadDebt = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Invoice marked as bad debt')
		]));
var $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Invoice Notification Sent')
		]));
var $author$project$Components$Auditing$Trail$Invoice$viewReturnedToDraft = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Invoice Returned to Draft')
		]));
var $author$project$Components$Auditing$Trail$Invoice$viewVoided = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Invoice Voided')
		]));
var $author$project$Components$Auditing$Trail$Invoice$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'Invoice Returned to draft':
			return $author$project$Components$Auditing$Trail$Invoice$viewReturnedToDraft;
		case 'Invoice Issued':
			return $author$project$Components$Auditing$Trail$Invoice$viewIssued;
		case 'Invoice Created':
			return $author$project$Components$Auditing$Trail$Invoice$viewCreated;
		case 'Invoice Voided':
			return $author$project$Components$Auditing$Trail$Invoice$viewVoided;
		case 'Notification Created':
			return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
		case 'Invoice Marked as bad debt':
			return $author$project$Components$Auditing$Trail$Invoice$viewMarkedAsBadDebt;
		case 'Invoice Notify upcoming':
			return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
		case 'Invoice Notify upcoming one worker':
			return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
		case 'Invoice Issue and or autopay':
			return $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued;
		case 'Invoice Issue and or autopay one worker':
			return $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued;
		default:
			return $author$project$Components$Auditing$Trail$Invoice$viewEmpty;
	}
};
var $author$project$Components$Auditing$Trail$Membership$getCrumbList = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Membership$viewAll = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		$author$project$Components$Auditing$Trail$Membership$getCrumbList(trail));
};
var $author$project$Components$Auditing$Trail$Membership$viewCancelled = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Membership terminated')
		]));
var $author$project$Components$Auditing$Trail$Membership$viewCreated = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Membership created')
		]));
var $author$project$Components$Auditing$Trail$Membership$viewCreatedViaOnlineSignup = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Created by patient')
		]));
var $author$project$Components$Auditing$Trail$Membership$viewEasUpload = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$CompanyAccount$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Membership$viewRestarted = function (trail) {
	var crumbList = A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				$elm$html$Html$text('Membership restarted')
			]),
		$author$project$Components$Auditing$Trail$Membership$getCrumbList(trail));
	return A2($elm$html$Html$div, _List_Nil, crumbList);
};
var $author$project$Components$Auditing$Crumb$MembershipUpload$view = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Membership created')
					]));
		case 1:
			var _v1 = $author$project$Api$Audit$Crumb$recordType(crumb);
			switch (_v1) {
				case 'membership':
					return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
				case 'membership_patient':
					return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
				default:
					return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
			}
		default:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Membership deleted')
					]));
	}
};
var $author$project$Components$Auditing$Trail$Membership$viewUpload = function (trail) {
	return A2(
		$elm$core$List$map,
		function (crumb) {
			var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
			switch (_v0) {
				case 'membership':
					return $author$project$Components$Auditing$Crumb$MembershipUpload$view(crumb);
				case 'membership_patient':
					return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
				default:
					return $elm$html$Html$text('');
			}
		},
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Membership$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'Membership Created':
			return $author$project$Components$Auditing$Trail$Membership$viewCreated;
		case 'Membership Cancelled':
			return $author$project$Components$Auditing$Trail$Membership$viewCancelled;
		case 'CSV Uploaded':
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Membership$viewUpload(trail));
		case 'EAS CSV Uploaded':
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Membership$viewEasUpload(trail));
		case 'Membership Updated':
			return $author$project$Components$Auditing$Trail$Membership$viewAll(trail);
		case 'Membership Restarted':
			return $author$project$Components$Auditing$Trail$Membership$viewRestarted(trail);
		case 'OnlineEnrollments Confirm Created':
			return $author$project$Components$Auditing$Trail$Membership$viewCreatedViaOnlineSignup;
		default:
			return $author$project$Components$Auditing$Trail$Membership$viewAll(trail);
	}
};
var $author$project$Components$Auditing$Trail$Patient$viewAll = function (trail) {
	return A2(
		$elm$core$List$map,
		$author$project$Components$Auditing$Crumb$view,
		$author$project$Api$Audit$crumbs(trail));
};
var $author$project$Components$Auditing$Trail$Patient$viewCreated = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Patient created')
		]));
var $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Created by patient')
		]));
var $author$project$Components$Auditing$Crumb$Patient$view = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient created')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient deleted')
					]));
	}
};
var $author$project$Components$Auditing$Crumb$PatientAffiliation$view = function (crumb) {
	var _v0 = crumb.aaO;
	switch (_v0) {
		case 0:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient affiliation created')
					]));
		case 1:
			return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
		default:
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient affiliation deleted')
					]));
	}
};
var $author$project$Components$Auditing$Trail$Patient$viewUpload = function (trail) {
	var isPatientCreate = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (crumb) {
				return $author$project$Api$Audit$Crumb$event(crumb) === 'create';
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (crumb) {
						return $author$project$Api$Audit$Crumb$recordType(crumb) === 'patient';
					},
					$author$project$Api$Audit$crumbs(trail)))));
	return isPatientCreate ? $author$project$Components$Auditing$Trail$Patient$viewCreated : A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (crumb) {
				var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
				switch (_v0) {
					case 'patient':
						return $author$project$Components$Auditing$Crumb$Patient$view(crumb);
					case 'address':
						return $author$project$Components$Auditing$Crumb$Address$view(crumb);
					case 'phone':
						return $author$project$Components$Auditing$Crumb$Phone$view(crumb);
					case 'patient_affiliation':
						return $author$project$Components$Auditing$Crumb$PatientAffiliation$view(crumb);
					default:
						return $author$project$Components$Auditing$Crumb$view(crumb);
				}
			},
			$author$project$Api$Audit$crumbs(trail)));
};
var $author$project$Components$Auditing$Trail$Patient$view = function (trail) {
	var _v0 = $author$project$Api$Audit$name(trail);
	switch (_v0) {
		case 'Patient Created':
			return $author$project$Components$Auditing$Trail$Patient$viewCreated;
		case 'CSV Uploaded':
			return $author$project$Components$Auditing$Trail$Patient$viewUpload(trail);
		case 'EAS CSV Uploaded':
			return $author$project$Components$Auditing$Trail$Patient$viewUpload(trail);
		case 'CompanyRegistration Created':
			return $author$project$Components$Auditing$Trail$Patient$viewCreated;
		case 'OnlineEnrollment Confirmed':
			return $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup;
		case 'OnlineEnrollments Member Created':
			return $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup;
		case 'CompanyRegistration Updated':
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Patient$viewAll(trail));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				$author$project$Components$Auditing$Trail$Patient$viewAll(trail));
	}
};
var $author$project$Components$Auditing$Trail$viewAll = function (trail) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$author$project$Components$Auditing$Crumb$view,
			$author$project$Api$Audit$crumbs(trail)));
};
var $author$project$Components$Auditing$Trail$view = function (trail) {
	var _v0 = _Utils_Tuple2(
		$author$project$Api$Audit$aggregateType(trail),
		$author$project$Api$Audit$name(trail));
	_v0$5:
	while (true) {
		_v0$6:
		while (true) {
			_v0$7:
			while (true) {
				if (!_v0.a.$) {
					switch (_v0.a.a) {
						case 'membership':
							return $author$project$Components$Auditing$Trail$Membership$view(trail);
						case 'patient':
							return $author$project$Components$Auditing$Trail$Patient$view(trail);
						case 'company_account':
							return $author$project$Components$Auditing$Trail$CompanyAccount$view(trail);
						case 'customer_invoice':
							return $author$project$Components$Auditing$Trail$CustomerInvoice$view(trail);
						case 'invoice':
							return $author$project$Components$Auditing$Trail$Invoice$view(trail);
						default:
							switch (_v0.b) {
								case 'Card Deleted':
									break _v0$5;
								case 'BankAccount Deleted':
									break _v0$6;
								default:
									break _v0$7;
							}
					}
				} else {
					switch (_v0.b) {
						case 'Card Deleted':
							break _v0$5;
						case 'BankAccount Deleted':
							break _v0$6;
						default:
							break _v0$7;
					}
				}
			}
			return $author$project$Components$Auditing$Trail$viewAll(trail);
		}
		return $author$project$Components$Auditing$Trail$BankAccount$view(trail);
	}
	return $author$project$Components$Auditing$Trail$Card$view(trail);
};
var $author$project$Api$Audit$whodunnit = function (audit) {
	return $author$project$Api$Audit$record_(audit).aa2.zh;
};
var $author$project$Components$AuditTrailLog$viewAudit = F3(
	function (timeFormatter, audits, audit) {
		var createdAt = A2(
			timeFormatter,
			0,
			$author$project$Api$Audit$createdAt(audit));
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Auditing$Trail$view(audit),
					function () {
					if ($author$project$Api$Audit$isOnlineSignup(audit)) {
						return A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(createdAt + ' via online signup')
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Api$Audit$extraUrl(audit)))
										]))
								]));
					} else {
						var whodunnit = $author$project$Components$AuditTrailLog$formatWhodunnit(
							$author$project$Api$Audit$whodunnit(audit));
						return A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text(createdAt + (' by ' + whodunnit))
								]));
					}
				}(),
					A2($author$project$Components$AuditTrailLog$isLast, audits, audit) ? $author$project$Utils$Html$empty : $author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin]))
				]));
	});
var $author$project$Components$AuditTrailLog$changeHistoryView = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_Nil,
		A2(
			$elm$core$List$map,
			A2($author$project$Components$AuditTrailLog$viewAudit, model.Hy, model.cr),
			model.cr));
};
var $author$project$Ui$SvgIcon$History = 51;
var $author$project$Ui$SvgIcon$history = $author$project$Ui$SvgIcon$viewIcon(51);
var $author$project$Components$AuditTrailLog$loadingView = A2(
	$author$project$Ui$Typography$div,
	_List_fromArray(
		[
			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
		]),
	_List_fromArray(
		[
			$author$project$Ui$Spinner$view(_List_Nil)
		]));
var $author$project$Ui$Popover$Medium = 2;
var $author$project$Ui$Popover$md = $author$project$Ui$Popover$Size(2);
var $author$project$Components$AuditTrailLog$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$AuditTrailLog$isCreatedBeforeOct2023 = function (resourceCreatedAt) {
	if (!resourceCreatedAt.$) {
		var createdAt = resourceCreatedAt.a;
		var oct1_2023 = $elm$time$Time$millisToPosix(1696118400000);
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(createdAt),
			$elm$time$Time$posixToMillis(oct1_2023)) < 0;
	} else {
		return false;
	}
};
var $author$project$Components$AuditTrailLog$showContactSupport = A2(
	$author$project$Ui$Typography$div,
	_List_fromArray(
		[$author$project$Ui$Typography$muted]),
	_List_fromArray(
		[
			$elm$html$Html$text('For information on changes prior to 10/1/2023 email '),
			A3(
			$author$project$Ui$Link$mailto,
			'support@hint.com',
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('support@hint.com')
				])),
			$elm$html$Html$text('.')
		]));
var $author$project$Components$AuditTrailLog$showNoHistory = function (resource) {
	var record = _Utils_eq(
		resource,
		$elm$core$Maybe$Just('request')) ? 'the payment methods' : A2(
		$elm$core$String$append,
		'this ',
		A3(
			$elm$core$String$replace,
			'_',
			' ',
			A2($elm$core$Maybe$withDefault, 'record', resource)));
	return A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[$author$project$Ui$Typography$muted]),
		_List_fromArray(
			[
				$elm$html$Html$text('No changes have been recorded for ' + (record + '.'))
			]));
};
var $author$project$Components$AuditTrailLog$showMoreItem = function (model) {
	if ($elm$core$List$isEmpty(model.cr)) {
		return $author$project$Components$AuditTrailLog$isCreatedBeforeOct2023(model.BV) ? $author$project$Components$AuditTrailLog$showContactSupport : $author$project$Components$AuditTrailLog$showNoHistory(model.G0);
	} else {
		var totalRemaining = model.Dw - $elm$core$List$length(model.cr);
		return (!(!totalRemaining)) ? A2(
			$elm$html$Html$map,
			$author$project$Components$AuditTrailLog$PaginationMsg,
			A2($author$project$Api$Pagination$viewAsShowMore, _List_Nil, model.afy)) : ($author$project$Components$AuditTrailLog$isCreatedBeforeOct2023(model.BV) ? A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					$author$project$Components$AuditTrailLog$showContactSupport
				])) : $author$project$Utils$Html$empty);
	}
};
var $author$project$Components$AuditTrailLog$view = function (model) {
	return A4(
		$author$project$Ui$Popover$viewAsClickable,
		_List_fromArray(
			[
				$author$project$Ui$Popover$md,
				$author$project$Ui$Popover$visible(
				$author$project$Ui$Popover$isOpen(model.aM))
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'See change history'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$AuditTrailLog$Toggle),
						$author$project$Ui$Button$badge,
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$history)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('See Change History')
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Popover$body,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = model.pz;
						if (_v0.$ === 3) {
							return $elm$core$List$isEmpty(model.cr) ? $author$project$Utils$Html$empty : $author$project$Components$AuditTrailLog$changeHistoryView(model);
						} else {
							return $author$project$Components$AuditTrailLog$loadingView;
						}
					}(),
						$author$project$Components$AuditTrailLog$showMoreItem(model)
					]))
			]),
		model.aM);
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$loadFromData = function (model) {
	var _v0 = model.DL;
	if (_v0.$ === 3) {
		var virtualBankAccounts_ = _v0.a;
		return virtualBankAccounts_;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Employer$VirtualBankAccount$Shared$abaAccountNumber = function (_v0) {
	var record = _v0;
	return record.HU;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber = function (_v0) {
	var record = _v0;
	return record.HU;
};
var $author$project$Api$VirtualBankAccount$abaAccountNumber = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$abaAccountNumber(vba_);
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$abaBankName = function (_v0) {
	var record = _v0;
	return record.HV;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName = function (_v0) {
	var record = _v0;
	return record.HV;
};
var $author$project$Api$VirtualBankAccount$abaBankName = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$abaBankName(vba_);
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$abaRoutingtNumber = function (_v0) {
	var record = _v0;
	return record.HW;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber = function (_v0) {
	var record = _v0;
	return record.HW;
};
var $author$project$Api$VirtualBankAccount$abaRoutingtNumber = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$abaRoutingtNumber(vba_);
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$swiftAccountNumber = function (_v0) {
	var record = _v0;
	return record.$b;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftAccountNumber = function (_v0) {
	var record = _v0;
	return record.$b;
};
var $author$project$Api$VirtualBankAccount$swiftAccountNumber = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$swiftAccountNumber(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$swiftAccountNumber(vba_);
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$swiftBankName = function (_v0) {
	var record = _v0;
	return record.$c;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftBankName = function (_v0) {
	var record = _v0;
	return record.$c;
};
var $author$project$Api$VirtualBankAccount$swiftBankName = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$swiftBankName(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$swiftBankName(vba_);
	}
};
var $author$project$Api$Employer$VirtualBankAccount$Shared$swiftCode = function (_v0) {
	var record = _v0;
	return record.$d;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode = function (_v0) {
	var record = _v0;
	return record.$d;
};
var $author$project$Api$VirtualBankAccount$swiftCode = function (vba) {
	if (!vba.$) {
		var vba_ = vba.a;
		return $author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(vba_);
	} else {
		var vba_ = vba.a;
		return $author$project$Api$Employer$VirtualBankAccount$Shared$swiftCode(vba_);
	}
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccountBox = function (virtualBankAccount) {
	return A3(
		$author$project$Ui$Alert$view,
		1,
		_List_fromArray(
			[
				$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
				$author$project$Ui$Alert$margin(25)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Bank Name')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$black,
												$author$project$Ui$Typography$margin(25)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$VirtualBankAccount$abaBankName(virtualBankAccount)),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Copy Bank Name'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
														$author$project$Ui$Button$onClick(
														A2(
															$author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard,
															'Bank Name',
															$author$project$Api$VirtualBankAccount$swiftBankName(virtualBankAccount)))
													]),
												_List_Nil)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Routing Number')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$black,
												$author$project$Ui$Typography$margin(25)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$VirtualBankAccount$abaRoutingtNumber(virtualBankAccount)),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Copy Routing Number'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
														$author$project$Ui$Button$onClick(
														A2(
															$author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard,
															'Routing Number',
															$author$project$Api$VirtualBankAccount$abaRoutingtNumber(virtualBankAccount)))
													]),
												_List_Nil)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Account Number')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$black,
												$author$project$Ui$Typography$margin(25)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$VirtualBankAccount$abaAccountNumber(virtualBankAccount)),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Copy Account Number'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
														$author$project$Ui$Button$onClick(
														A2(
															$author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard,
															'Account Number',
															$author$project$Api$VirtualBankAccount$swiftAccountNumber(virtualBankAccount)))
													]),
												_List_Nil)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('SWIFT code')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$black,
												$author$project$Ui$Typography$margin(25)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$VirtualBankAccount$swiftCode(virtualBankAccount)),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Copy SWIFT Code'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
														$author$project$Ui$Button$onClick(
														A2(
															$author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard,
															'Swift Code',
															$author$project$Api$VirtualBankAccount$swiftCode(virtualBankAccount)))
													]),
												_List_Nil)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccount = F2(
	function (payerName, virtualBankAccount) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Transfer Instructions'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('To complete payments to ' + (payerName + ', transfer funds from your banking institution to the bank account provided below. Bank Transfers can take up to five business days.')),
							A2($elm$html$Html$br, _List_Nil, _List_Nil)
						])),
					$author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccountBox(virtualBankAccount)
				]));
	});
var $author$project$Components$Company$VirtualBankAccounts$Invoice$view = F2(
	function (_v0, payerName) {
		var model = _v0;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccount(payerName),
				$author$project$Components$Company$VirtualBankAccounts$Invoice$loadFromData(model)));
	});
var $author$project$Components$CompanyEmailModal$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$CompanyEmailModal$Subject = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Notification$One$bodyHtml = function (_v0) {
	var record = _v0.b;
	return record.J4;
};
var $author$project$Api$Provider$Notification$One$subjectHtml = function (_v0) {
	var record = _v0.b;
	return record._1;
};
var $author$project$Components$CompanyEmailModal$viewPreview = F3(
	function (header, subject, body) {
		return _List_fromArray(
			[
				function () {
				if (!header.$) {
					var header_ = header.a;
					return A2(
						$author$project$Ui$Alert$info,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(header_)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email-preview')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Subject')
									])),
								subject,
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								body
							]))
					]))
			]);
	});
var $author$project$Components$CompanyEmailModal$viewModalBody = function (model) {
	switch (model.$) {
		case 0:
			var shared = model.a;
			return A3(
				$author$project$Components$CompanyEmailModal$viewPreview,
				shared.qN,
				$author$project$Ui$Spinner$view(_List_Nil),
				$author$project$Ui$Spinner$view(_List_Nil));
		case 1:
			var shared = model.a;
			var preview = model.b;
			var delivery = model.c;
			return _Utils_ap(
				A3(
					$author$project$Components$CompanyEmailModal$viewPreview,
					shared.qN,
					A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subject')
								]),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Notification$One$subjectHtml(preview))))),
					A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('body'),
								$author$project$Api$Phi$displayAttr),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Notification$One$bodyHtml(preview)))))),
				_List_fromArray(
					[
						function () {
						if (delivery.$ === 2) {
							var error = delivery.a;
							return A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error sending email')
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(
										$author$project$Api$Data$errorToString(error))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]));
		default:
			var shared = model.a;
			var notificationForm = model.b;
			var _v2 = $author$project$Utils$Form$fields(notificationForm);
			var subject = _v2.Hp;
			var body = _v2.e5;
			return A3(
				$author$project$Components$CompanyEmailModal$viewPreview,
				shared.qN,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', subject)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated, $author$project$Components$CompanyEmailModal$Subject)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, notificationForm)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, notificationForm))
								]))
						])),
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$rows(15),
											$author$project$Ui$Form$Textarea$value(
											A2($elm$core$Maybe$withDefault, '', body)),
											$author$project$Ui$Form$Textarea$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated, $author$project$Components$CompanyEmailModal$Body)),
											$author$project$Ui$Form$Textarea$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, notificationForm)),
											$author$project$Ui$Form$Textarea$errors(
											A2($author$project$Utils$Form$validationErrors, 1, notificationForm))
										]))
								]))
						])));
	}
};
var $author$project$Components$CompanyEmailModal$Edit = {$: 2};
var $author$project$Components$CompanyEmailModal$Preview = {$: 1};
var $author$project$Components$CompanyEmailModal$Send = {$: 3};
var $author$project$Components$CompanyEmailModal$viewCancelButton = A3(
	$author$project$Ui$Button$view,
	{abp: 'Cancel and close modal'},
	_List_fromArray(
		[
			$author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Close)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Cancel')
		]));
var $author$project$Components$CompanyEmailModal$viewModalFooter = function (model) {
	switch (model.$) {
		case 0:
			return _List_fromArray(
				[$author$project$Components$CompanyEmailModal$viewCancelButton]);
		case 1:
			var delivery = model.c;
			var deliveryLoading = function () {
				if (delivery.$ === 1) {
					return true;
				} else {
					return false;
				}
			}();
			return _List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Customize email'},
					_List_fromArray(
						[
							$author$project$Ui$Button$pull(0),
							$author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Edit)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Customize Email')
						])),
					$author$project$Components$CompanyEmailModal$viewCancelButton,
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Send email'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Send),
							$author$project$Ui$Button$loading(deliveryLoading)
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 11),
							$elm$html$Html$text(' Send Email')
						]))
				]);
		default:
			var preview = model.c;
			var loading = function () {
				if (preview.$ === 1) {
					return true;
				} else {
					return false;
				}
			}();
			return _List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Preview email'},
					_List_fromArray(
						[
							$author$project$Ui$Button$pull(0),
							$author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Preview),
							$author$project$Ui$Button$loading(loading)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Preview Email')
						])),
					$author$project$Components$CompanyEmailModal$viewCancelButton
				]);
	}
};
var $author$project$Components$CompanyEmailModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CompanyEmailModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Send via Email')
					])),
				$author$project$Ui$Modal$body(
				$author$project$Components$CompanyEmailModal$viewModalBody(model)),
				$author$project$Ui$Modal$footer(
				$author$project$Components$CompanyEmailModal$viewModalFooter(model))
			]));
};
var $author$project$Api$Employer$Invoice$Meta$hideChargeDetailsAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Qo;
};
var $author$project$Api$Invoice$Meta$hideChargeDetailsAction = function (meta) {
	if (!meta.$) {
		return false;
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$hideChargeDetailsAction(meta_);
	}
};
var $author$project$Components$ExportCsv$ReportParams = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ExportCsv$reportParams = $author$project$Components$ExportCsv$ReportParams;
var $author$project$Components$Invoice$InvoiceLinesTable$reportParams = function (model) {
	var _v0 = model.Rr;
	if (!_v0.$) {
		var affiliateBillId = _v0.b;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'affiliate_bill', affiliateBillId)
			]);
	} else {
		var companyId_ = _v0.a;
		var invoiceId = _v0.b;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$string, 'invoice', invoiceId),
				A2($author$project$Api$Param$string, 'company', companyId_)
			]);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$AddInvoiceLine = {$: 9};
var $author$project$Ui$Icon$Locked = 38;
var $author$project$Components$Invoice$InvoiceLinesTable$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$SortTable = function (a) {
	return {$: 4, a: a};
};
var $author$project$Formatters$String$affiliateMember = F2(
	function (memberString, companyType) {
		if (_Utils_eq(
			companyType,
			$elm$core$Maybe$Just(0))) {
			switch (memberString) {
				case 'employee':
					return 'primary member';
				case 'Employee':
					return 'Primary';
				case 'Employees':
					return 'Members';
				case 'Employees & Dependents':
					return 'Members';
				default:
					return memberString;
			}
		} else {
			return memberString;
		}
	});
var $author$project$Api$Employer$Invoice$Meta$canAdjustAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Kn;
};
var $author$project$Api$Provider$Invoice$Meta$canAdjustAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Kn;
};
var $author$project$Api$Invoice$Meta$canAdjustAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$canAdjustAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$canAdjustAction(meta_);
	}
};
var $author$project$Api$Column$withOption = F2(
	function (newOption, _v0) {
		var col = _v0;
		var options = col.zY;
		return _Utils_update(
			col,
			{
				zY: A2($elm$core$List$cons, newOption, options)
			});
	});
var $author$project$Components$Invoice$InvoiceLinesTable$columns = function (company) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'date', true, 'Date'),
					A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
					A3($author$project$Api$Column$init, 'description', false, 'Charge')
				]),
				$author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(company) ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'plan', true, 'Plan')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'category', false, 'Category'),
					A2(
					$author$project$Api$Column$withOption,
					$author$project$Ui$Table$textRight,
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'))
				])
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$companyType = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Api$Provider$Company$Min$companyType(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$companyType(company__);
			}
		},
		company);
};
var $author$project$Ui$SearchInput$Loading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$SearchInput$loading = $author$project$Ui$SearchInput$Loading;
var $author$project$Ui$SearchInput$Phi = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$SearchInput$phi = $author$project$Ui$SearchInput$Phi;
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$ProviderMin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$phiAlertCompany = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$ProviderMin(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$EmployerOrProviderCompany(company__);
			}
		},
		company);
};
var $author$project$Ui$SearchInput$Placeholder = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$SearchInput$placeholder = $author$project$Ui$SearchInput$Placeholder;
var $author$project$Api$Employer$Invoice$Meta$reportingPeriodIsLocked = function (_v0) {
	var meta = _v0;
	return meta.Ye;
};
var $author$project$Api$Provider$Invoice$Meta$reportingPeriodIsLocked = function (_v0) {
	var meta = _v0;
	return meta.Ye;
};
var $author$project$Api$Invoice$Meta$reportingPeriodIsLocked = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Invoice$Meta$reportingPeriodIsLocked(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$Invoice$Meta$reportingPeriodIsLocked(meta_);
	}
};
var $author$project$Ui$Table$Test = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Table$test = $author$project$Ui$Table$Test;
var $author$project$Api$Employer$Company$One$chargePhiDetailsEnabled = function (_v0) {
	var record = _v0.b;
	return record.KR;
};
var $author$project$Api$Provider$Company$One$chargePhiDetailsEnabled = function (_v0) {
	var record = _v0.b;
	return record.KR;
};
var $author$project$Api$Company$chargePhiDetailsEnabled = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$chargePhiDetailsEnabled(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$chargePhiDetailsEnabled(company_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$chargePhiDetailsEnabled = function (company) {
	if (!company.$) {
		if (!company.a.$) {
			return false;
		} else {
			var company_ = company.a.a;
			return $author$project$Api$Company$chargePhiDetailsEnabled(company_);
		}
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyId = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					var company__ = company_.a;
					return $author$project$Api$Provider$Company$Min$id(company__);
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$id(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				if (!company_.$) {
					var company__ = company_.a;
					return $author$project$Api$Provider$Company$Min$name(company__);
				} else {
					var company__ = company_.a;
					return $author$project$Api$Company$name(company__);
				}
			},
			company));
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyType = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			if (!company_.$) {
				var company__ = company_.a;
				return $author$project$Api$Provider$Company$Min$companyType(company__);
			} else {
				var company__ = company_.a;
				return $author$project$Api$Company$companyType(company__);
			}
		},
		company);
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForCompany = function (company) {
	return _Utils_eq(
		$author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyType(company),
		$elm$core$Maybe$Just(0)) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Alert$info,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Non-membership charges are not visible to '),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName(company))
					])),
				$elm$html$Html$text(' in the line items section. '),
				$elm$html$Html$text('Aggregate details by category are visible to '),
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName(company))
					])),
				$elm$html$Html$text(' in the summary section. '),
				$elm$html$Html$text('This is configurable in the '),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings(
					{
						ff: $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyId(company)
					}),
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('invoice settings')
					])),
				$elm$html$Html$text(' tab above.')
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForPractice = function (practice) {
	return A2(
		$author$project$Ui$Alert$info,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('In order to protect patient privacy all non-membership charge details are not visible. '),
								$elm$html$Html$text('Aggregate costs can be viewed in the summary section above by category of charge. '),
								$elm$html$Html$text('Please contact '),
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Practice$name(practice))
									])),
								$elm$html$Html$text(' for more info.')
							]))
					]))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$view = F3(
	function (session, practice, company) {
		return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$chargePhiDetailsEnabled(company) ? $author$project$Utils$Html$empty : ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForPractice(practice) : $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForCompany(company));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Category$viewNew, _List_Nil, categoryResourceFilter));
};
var $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Employer$EmployeeDivision$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$EmployeeDivision$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$EmployeeDivision$Shared$name(shared);
};
var $author$project$Api$Provider$EmployeeDivision$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$EmployeeDivision$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$EmployeeDivision$Shared$name(shared);
};
var $author$project$Api$EmployeeDivision$All$name = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$name(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$name(employeeDivision_);
	}
};
var $author$project$Components$Invoice$InvoiceLinesTable$viewEmployeeDivisionDropdown = function (model) {
	var items = function () {
		var _v1 = model.xp;
		if (_v1.$ === 3) {
			var employeeDivisions = _v1.a;
			return A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$NewDropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$onSelect(
							$author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected($elm$core$Maybe$Nothing))
						]),
					$elm$html$Html$text('All Divisions')),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$NewDropdown$separator,
					A2(
						$elm$core$List$map,
						function (division) {
							return A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected(
											$elm$core$Maybe$Just(division)))
									]),
								$elm$html$Html$text(
									$author$project$Api$EmployeeDivision$All$name(division)));
						},
						employeeDivisions)));
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$NewDropdown$item,
					_List_Nil,
					$elm$html$Html$text('Loading...'))
				]);
		}
	}();
	var currentLabel = function () {
		var _v0 = model.E8;
		if (!_v0.$) {
			var division = _v0.a;
			return $author$project$Api$EmployeeDivision$All$name(division);
		} else {
			return 'Division';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.l0);
};
var $author$project$Components$Invoice$InvoiceLinesTable$EditInvoiceLine = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Invoice$InvoiceLinesTable$RemoveInvoiceLine = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$InvoiceLine$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$InvoiceLine$All$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceLine$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$InvoiceLine$All$categoryName = function (_v0) {
	var record = _v0.b;
	return record.KM;
};
var $author$project$Api$Provider$InvoiceLine$All$chargeDescription = function (_v0) {
	var record = _v0.b;
	return record.KQ;
};
var $author$project$Api$Provider$InvoiceLine$All$charges = function (_v0) {
	var record = _v0.b;
	return record.KU;
};
var $author$project$Api$Provider$InvoiceLine$Shared$date = function (_v0) {
	var record = _v0;
	return record.MO;
};
var $author$project$Api$Provider$InvoiceLine$All$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceLine$Shared$date(shared);
};
var $author$project$Api$Provider$InvoiceLine$All$dependentCount = function (_v0) {
	var record = _v0.b;
	return record.Nr;
};
var $author$project$Api$Provider$Charge$Meta$destroyAction = function (_v0) {
	var meta = _v0;
	return meta.tF.NA;
};
var $author$project$Api$Provider$Charge$Meta$editAction = function (_v0) {
	var meta = _v0;
	return meta.tF.N6;
};
var $author$project$Api$Provider$InvoiceLine$All$endDate = function (_v0) {
	var record = _v0.b;
	return record.qs;
};
var $author$project$Api$Invoice$Status$isDraft = function (status) {
	return _Utils_eq(status, $author$project$Api$Invoice$Status$Draft);
};
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked = function (_v0) {
	var record = _v0;
	return record.RP;
};
var $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Ui$Table$NoBorder = {$: 1};
var $author$project$Ui$Table$noBorder = $author$project$Ui$Table$NoBorder;
var $author$project$Api$Provider$InvoiceLine$All$patientName = function (_v0) {
	var record = _v0.b;
	return record.VR;
};
var $author$project$Api$Provider$InvoiceLine$All$plan = function (_v0) {
	var record = _v0.b;
	return record.GH;
};
var $author$project$Api$Provider$InvoiceLine$All$shouldHideAmount = function (_v0) {
	var record = _v0.b;
	return record.ZR;
};
var $author$project$Formatters$ChargeItemCode$ChargeItemForCharge = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$ShowLess = 28;
var $author$project$Ui$Icon$ShowMore = 27;
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$ToggleShowMore = {$: 0};
var $author$project$Api$Provider$InvoiceLine$All$createdBy = function (_v0) {
	var record = _v0.b;
	return record.Mg;
};
var $author$project$Api$Provider$InvoiceLine$All$employeeDivision = function (_v0) {
	var record = _v0.b;
	return record.E8;
};
var $author$project$Api$Provider$Charge$One$issuedQuantityUom = function (_v0) {
	var record = _v0.b;
	return record.Sl;
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$humanizePriceAndQuantity = function (charge) {
	if (!charge.$) {
		var charge_ = charge.a;
		var priceUom = $author$project$Api$Provider$Charge$One$priceUom(charge_);
		var priceAndQuantity = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Currency$fromInt,
				$author$project$Api$Provider$Charge$One$priceInCents(charge_)));
		if ($author$project$Api$Provider$Uom$Shared$type_(priceUom) === 'Time') {
			var priceUomName = $elm$core$String$toLower(
				$author$project$Api$Provider$Uom$Shared$name(priceUom));
			var issuedQuantityUomName = $elm$core$String$toLower(
				$author$project$Api$Provider$Uom$Shared$name(
					$author$project$Api$Provider$Charge$One$issuedQuantityUom(charge_)));
			var issuedUomNameAndQty = A2(
				$author$project$Formatters$String$pluralize,
				issuedQuantityUomName,
				$author$project$Api$Provider$Charge$One$quantity(charge_));
			return priceAndQuantity + ('/' + (priceUomName + (' x ' + issuedUomNameAndQty)));
		} else {
			return priceAndQuantity + (' x ' + $elm$core$String$fromInt(
				$author$project$Api$Provider$Charge$One$quantity(charge_)));
		}
	} else {
		return '';
	}
};
var $author$project$Api$Provider$Organization$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Session$Shared$organization = function (_v0) {
	var record = _v0;
	return record.Vd;
};
var $author$project$Api$Provider$InvoiceLine$All$shouldShowMoreInfo = function (_v0) {
	var record = _v0.b;
	return record.ZS;
};
var $author$project$Api$Provider$Session$Shared$user = function (_v0) {
	var record = _v0;
	return record.aaz;
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewCoverageDiscount = function (coverageDiscount) {
	var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coverageDiscount);
	return A2(
		$author$project$Components$CoverageRuleDescription$view,
		$author$project$Components$CoverageRuleDescription$Shared(coverageRule),
		true);
};
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField = F2(
	function (label, value) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label + ': ')
						])),
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$view = function (model) {
	return $author$project$Api$Provider$InvoiceLine$All$shouldShowMoreInfo(model.q0) ? A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.om ? _Utils_Tuple2(
					'Less info ',
					A2($author$project$Ui$Icon$view, _List_Nil, 28)) : _Utils_Tuple2(
					'More info ',
					A2($author$project$Ui$Icon$view, _List_Nil, 27));
				var verb = _v0.a;
				var icon = _v0.b;
				return A3(
					$author$project$Ui$Button$view,
					{abp: verb},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$ToggleShowMore)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(verb),
							icon
						]));
			}(),
				function () {
				if (model.om) {
					var _v1 = function () {
						var _v2 = _Utils_Tuple3(
							$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD),
							model.fN,
							model.wS);
						if (_v2.b.$ === 3) {
							if ((!_v2.a) && (_v2.c.$ === 3)) {
								var _v3 = _v2.b;
								var invoiceLineDetails_ = _v3.a;
								var _v4 = _v2.c;
								var coverageDiscounts_ = _v4.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(invoiceLineDetails_),
									coverageDiscounts_);
							} else {
								var _v5 = _v2.b;
								var invoiceLineDetails_ = _v5.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(invoiceLineDetails_),
									_List_Nil);
							}
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
						}
					}();
					var invoiceLineDetails = _v1.a;
					var coverageDiscounts = _v1.b;
					return A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						function () {
							if (!invoiceLineDetails.$) {
								var invoiceLineDetails_ = invoiceLineDetails.a;
								var charge = $elm$core$List$head(
									$author$project$Api$Provider$InvoiceLine$One$charges(invoiceLineDetails_));
								var _v7 = function () {
									var _v8 = A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Maybe$Nothing,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$chargeItem, charge));
									if (!_v8.$) {
										var chargeItem = _v8.a;
										var manufacturer_ = $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem);
										var code_ = $author$project$Formatters$ChargeItemCode$toString(
											$author$project$Formatters$ChargeItemCode$ChargeItemForCharge(chargeItem));
										return _Utils_Tuple2(code_, manufacturer_);
									} else {
										return _Utils_Tuple2('', '');
									}
								}();
								var code = _v7.a;
								var manufacturer = _v7.b;
								return _List_fromArray(
									[
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Description',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$description, charge))),
										A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Code', code),
										A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Facility/Manufacturer', manufacturer),
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Provider',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Practitioner$Shared$name,
												A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$practitioner, charge)))),
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Location',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$location, charge)))),
										model.aaF ? A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Division',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$EmployeeDivision$Shared$name,
												$author$project$Api$Provider$InvoiceLine$All$employeeDivision(model.q0)))) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Price & Quantity',
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$humanizePriceAndQuantity(charge)),
										($elm$core$List$length(coverageDiscounts) > 0) ? A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Coverage: ')
													])),
												A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												A2($elm$core$List$map, $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewCoverageDiscount, coverageDiscounts))
											])) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField,
										'Added by',
										function () {
											var _v9 = $author$project$Api$Provider$InvoiceLine$All$createdBy(model.q0);
											if (!_v9.$) {
												var createdBy = _v9.a;
												return $author$project$Api$Provider$User$Min$name(
													$author$project$Api$Provider$Session$Shared$user(createdBy)) + (' from ' + A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$Organization$Min$name,
														$author$project$Api$Provider$Session$Shared$organization(createdBy))));
											} else {
												return 'a recurring charge on the Plan';
											}
										}())
									]);
							} else {
								return _List_fromArray(
									[
										$author$project$Ui$Spinner$view(
										_List_fromArray(
											[$author$project$Ui$Spinner$extraSmall]))
									]);
							}
						}());
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLine = F2(
	function (model, invoiceLine) {
		var maybeCharge = $elm$core$List$head(
			$author$project$Api$Provider$InvoiceLine$All$charges(invoiceLine));
		var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
		var loading = A2($elm$core$Set$member, id, model.dM);
		var canEditCharge = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Charge$Meta$editAction,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta, maybeCharge)));
		var canDestroyCharge = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Charge$Meta$destroyAction,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta, maybeCharge)));
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$author$project$Formatters$Date$toString,
											$author$project$Formatters$Date$Full,
											$author$project$Api$Provider$InvoiceLine$All$date(invoiceLine))),
										function () {
										var _v0 = $author$project$Api$Provider$InvoiceLine$All$endDate(invoiceLine);
										if (!_v0.$) {
											var endDate = _v0.a;
											return A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(' - '),
														$elm$html$Html$text(
														A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$InvoiceLine$All$patientName(invoiceLine)),
												($author$project$Api$Provider$InvoiceLine$All$dependentCount(invoiceLine) > 0) ? A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$small,
														$author$project$Ui$Typography$gray,
														$author$project$Ui$Typography$phi(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(' + '),
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$String$pluralize,
															'dependent',
															$author$project$Api$Provider$InvoiceLine$All$dependentCount(invoiceLine)))
													])) : $author$project$Utils$Html$empty
											]))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$InvoiceLine$All$chargeDescription(invoiceLine))
									]))
							]),
							$author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(model.ab9) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Plan$Shared$name,
												$author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))))
									]))
							]) : _List_Nil,
							_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'Unassigned',
											$author$project$Api$Provider$InvoiceLine$All$categoryName(invoiceLine)))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$bold,
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
											]),
										_List_fromArray(
											[
												$author$project$Api$Provider$InvoiceLine$All$shouldHideAmount(invoiceLine) ? $author$project$Utils$Html$empty : $elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$InvoiceLine$All$amountInCents(invoiceLine)))
											]))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_fromArray(
									[$author$project$Ui$Table$textRight]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
										_List_fromArray(
											[
												((!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))) && A2(
												$elm$core$Maybe$withDefault,
												false,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked, maybeCharge))) ? A3(
												$author$project$Ui$Popover$view,
												_List_Nil,
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{abp: 'This charge\'s reporting period is locked. And admin must unlock it to edit this charge.'},
														_List_fromArray(
															[
																$author$project$Ui$Button$disabled(true),
																$author$project$Ui$Button$size(0)
															]),
														_List_fromArray(
															[
																A2($author$project$Ui$Icon$view, _List_Nil, 38)
															]))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Popover$heading,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Locked')
															])),
														A2(
														$author$project$Ui$Popover$body,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('An admin must unlock this charge\'s reporting period before editing this charge.')
															]))
													])) : $author$project$Utils$Html$empty,
												((!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD)) && ((!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))) && ((!A2(
												$elm$core$Maybe$withDefault,
												false,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked, maybeCharge))) && canEditCharge))) ? A3(
												$author$project$Ui$Button$view,
												{abp: 'Edit invoice line'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$loading(loading),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Invoice$InvoiceLinesTable$EditInvoiceLine(invoiceLine)),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Edit')
													])) : $author$project$Utils$Html$empty,
												((!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD)) && ((!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))) && ($author$project$Api$Invoice$Status$isDraft(
												$author$project$Api$Invoice$One$humanStatus(model.Rh)) && canDestroyCharge))) ? A3(
												$author$project$Ui$Button$view,
												{abp: 'Delete invoice line'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$size(0),
														$author$project$Ui$Button$loading(loading),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Invoice$InvoiceLinesTable$RemoveInvoiceLine(invoiceLine)),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Delete')
													])) : $author$project$Utils$Html$empty
											]))
									]))
							])
						]))),
				A2(
				$author$project$Ui$Table$row,
				_List_fromArray(
					[$author$project$Ui$Table$noBorder]),
				_List_fromArray(
					[
						A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
						A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$colspan(5)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id),
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Utils$Html$empty,
									A2(
										$elm$core$Maybe$map,
										$author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$view,
										A2($elm$core$Dict$get, id, model.ei))))
							]))
					]))
			]);
	});
var $author$project$Components$ResourceFilter$Plan$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$viewPlanResourceFilter = function (planResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Plan$viewNew, _List_Nil, planResourceFilter));
};
var $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLines = function (model) {
	var invoiceMeta = $author$project$Api$Invoice$One$meta(model.Rh);
	var _v0 = function () {
		var _v1 = model.aq;
		if (_v1.$ === 3) {
			var invoiceLines_ = _v1.a;
			return _Utils_Tuple2(false, invoiceLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var invoiceLines = _v0.b;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						if (model.Bn) {
							var companyType_ = $author$project$Components$Invoice$InvoiceLinesTable$companyType(model.ab9);
							return $author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Enrolled '),
										$elm$html$Html$text(
										A2($author$project$Formatters$String$affiliateMember, 'Employees & Dependents', companyType_))
									]));
						} else {
							return $author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Line Items')
									]));
						}
					}(),
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(3)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg,
										A2(
											$author$project$Ui$SearchInput$view,
											_List_fromArray(
												[
													$author$project$Ui$SearchInput$phi(true),
													$author$project$Ui$SearchInput$placeholder('Search by employee name or amount'),
													$author$project$Ui$SearchInput$loading(loading)
												]),
											model.sA))
									])),
								function () {
								var _v2 = model.Rr;
								if (!_v2.$) {
									return $author$project$Ui$FlexGrid$none;
								} else {
									return A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Invoice$InvoiceLinesTable$viewCategoryResourceFilter(model.cJ)
											]));
								}
							}(),
								function () {
								var _v3 = model.jw;
								if (!_v3.$) {
									var planResourceFilter = _v3.a;
									return A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Invoice$InvoiceLinesTable$viewPlanResourceFilter(planResourceFilter)
											]));
								} else {
									return $author$project$Ui$FlexGrid$none;
								}
							}(),
								$author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(model.ab9) ? A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2)
									]),
								_List_fromArray(
									[
										$author$project$Components$Invoice$InvoiceLinesTable$viewEmployeeDivisionDropdown(model)
									])) : $author$project$Ui$FlexGrid$none,
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(3)
									]),
								_List_fromArray(
									[
										function () {
										if ((!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD)) && ($author$project$Api$Invoice$Meta$canAdjustAction(invoiceMeta) && (!$author$project$Api$Invoice$Meta$reportingPeriodIsLocked(invoiceMeta)))) {
											var verb = model.Bn ? 'Add Charge or Adjustment' : 'Add Charge';
											return A3(
												$author$project$Ui$Button$view,
												{abp: verb},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AddInvoiceLine),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(verb)
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										$author$project$Api$Invoice$Meta$reportingPeriodIsLocked(invoiceMeta) ? A3(
										$author$project$Ui$Popover$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Add charge or adjustment'},
												_List_fromArray(
													[
														$author$project$Ui$Button$disabled(true),
														$author$project$Ui$Button$fullWidth(true)
													]),
												_List_fromArray(
													[
														A2($author$project$Ui$Icon$view, _List_Nil, 38),
														$elm$html$Html$text(' Add Charge or Adjustment')
													]))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Popover$heading,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Locked')
													])),
												A2(
												$author$project$Ui$Popover$body,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('An admin must unlock this invoice\'s reporting period before adding charges or adjustments.')
													]))
											])) : $author$project$Utils$Html$empty
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$view,
						model.ZD,
						model.WF,
						$author$project$Components$Invoice$InvoiceLinesTable$phiAlertCompany(model.ab9))
					])),
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$loading(loading),
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('No matching results.')
							])),
						$author$project$Ui$Table$test('invoice-lines')
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Invoice$InvoiceLinesTable$SortTable)),
						$author$project$Components$Invoice$InvoiceLinesTable$columns(model.ab9)),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$header,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$empty]))
						])),
				A2(
					$elm$core$List$concatMap,
					$author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLine(model),
					invoiceLines),
				_List_Nil),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$InvoiceLinesTable$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(loading)
								]),
							model.afy))
					]))
			]));
};
var $author$project$Components$Invoice$InvoiceLinesTable$view = F2(
	function (apiClient, model) {
		var invoiceMeta = $author$project$Api$Invoice$One$meta(model.Rh);
		return _List_fromArray(
			[
				$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? $elm$html$Html$text('') : A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.aq)),
							$author$project$Components$ExportCsv$reportParams(
							$author$project$Components$Invoice$InvoiceLinesTable$reportParams(model))
						]),
					model.l9)),
				$author$project$Api$Invoice$Meta$hideChargeDetailsAction(invoiceMeta) ? $author$project$Utils$Html$empty : $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLines(model)
			]);
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummaryMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows = function (_v0) {
	var record = _v0;
	return record.Ie.YQ;
};
var $author$project$Api$Common$Invoice$Summary$byEmployeeDivision = function (_v0) {
	var record = _v0;
	return record.Kj;
};
var $author$project$Api$Common$Invoice$Summary$byPlan = function (_v0) {
	var record = _v0;
	return record.Kk;
};
var $author$project$Api$Common$Invoice$Summary$bySponsor = function (_v0) {
	var record = _v0;
	return record.Kl;
};
var $author$project$Components$Invoice$Summary$activeLinesFor = F2(
	function (summary, groupBy_) {
		switch (groupBy_) {
			case 0:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows,
						$author$project$Api$Common$Invoice$Summary$byPlan(summary)));
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows,
						$author$project$Api$Common$Invoice$Summary$byEmployeeDivision(summary)));
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows,
						$author$project$Api$Common$Invoice$Summary$bySponsor(summary)));
		}
	});
var $author$project$Api$Employer$Invoice$One$discountSavingsInCents = function (_v0) {
	var record = _v0.b;
	return record.NM;
};
var $author$project$Api$Provider$Invoice$One$discountSavingsInCents = function (_v0) {
	var record = _v0.b;
	return record.NM;
};
var $author$project$Api$Invoice$One$discountSavingsInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$discountSavingsInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$discountSavingsInCents(invoice_);
	}
};
var $author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines = function (_v0) {
	var record = _v0;
	return record.TC;
};
var $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows = function (_v0) {
	var record = _v0;
	return record.TC.YQ;
};
var $author$project$Components$Invoice$Summary$membershipAdjustmentLinesFor = F2(
	function (summary, groupBy_) {
		switch (groupBy_) {
			case 0:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows,
						$author$project$Api$Common$Invoice$Summary$byPlan(summary)));
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows,
						$author$project$Api$Common$Invoice$Summary$byEmployeeDivision(summary)));
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows,
						$author$project$Api$Common$Invoice$Summary$bySponsor(summary)));
		}
	});
var $author$project$Api$Common$Invoice$Summary$AllLines$totalAmountInCents = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.Dx.I2);
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount = function (_v0) {
	var record = _v0;
	return record.Dx.LY;
};
var $author$project$Api$Common$Invoice$Summary$byCategory = function (_v0) {
	var record = _v0;
	return record.Ki;
};
var $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows = function (_v0) {
	var record = _v0;
	return record.UK.YQ;
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName = function (_v0) {
	var record = _v0;
	return record.KM;
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$count = function (_v0) {
	var record = _v0;
	return record.LY;
};
var $author$project$Ui$Typography$Subtotal = {$: 23};
var $author$project$Ui$Typography$subtotal = $author$project$Ui$Typography$Subtotal;
var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine = F2(
	function (model, nonMembershipAdjustmentLineRow) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									model.Bn ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$info, $author$project$Ui$Typography$subtotal]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Unassigned',
												$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName(nonMembershipAdjustmentLineRow)))
										])) : A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Unassigned',
												$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName(nonMembershipAdjustmentLineRow)))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'charge',
										$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$count(nonMembershipAdjustmentLineRow)))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$numeric]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$amountInCents(nonMembershipAdjustmentLineRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonRecurringSummary = F2(
	function (summary, model) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var nonMembershipAdjustmentLines = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows,
							$author$project$Api$Common$Invoice$Summary$byCategory(summary)));
					return A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine(model),
							nonMembershipAdjustmentLines));
				}()
				]));
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$ToggleShowGroupCharges = 0;
var $author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines = function (_v0) {
	var record = _v0;
	return record.UK;
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalAmountInCents = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.Dx.I2);
};
var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount = function (_v0) {
	var record = _v0;
	return record.Dx.LY;
};
var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewRecurringSummary = F2(
	function (summary, model) {
		var _v0 = model.gM ? _Utils_Tuple2($author$project$Ui$SvgIcon$minus, 'Hide group charges') : _Utils_Tuple2($author$project$Ui$SvgIcon$add, 'Show group charges');
		var icon = _v0.a;
		var ariaLabel = _v0.b;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount(
					$author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary)) > 0) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(3)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: ariaLabel},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$onClick(0),
															$author$project$Ui$Button$icon(icon)
														]),
													_List_Nil),
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Typography$strong,
													_List_fromArray(
														[$author$project$Ui$Typography$info]),
													_List_fromArray(
														[
															$elm$html$Html$text('Other Charges')
														]))
												]))
										])),
									model.gM ? $author$project$Ui$FlexGrid$none : A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(4)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Formatters$String$pluralize,
														'charge',
														$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount(
															$author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary))))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(5)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$numeric]),
											_List_fromArray(
												[
													model.gM ? $author$project$Utils$Html$empty : A2(
													$author$project$Ui$Typography$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalAmountInCents(
																	$author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary))))
														]))
												]))
										]))
								]))
						])) : $author$project$Utils$Html$empty,
					function () {
					if (model.gM) {
						var nonMembershipAdjustmentLines = A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows,
								$author$project$Api$Common$Invoice$Summary$byCategory(summary)));
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								$author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine(model),
								nonMembershipAdjustmentLines));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Invoice$Summary$OtherChargesSummary$view = F2(
	function (summary, model) {
		return model.Bn ? A2($author$project$Components$Invoice$Summary$OtherChargesSummary$viewRecurringSummary, summary, model) : A2($author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonRecurringSummary, summary, model);
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$companyName = function (_v0) {
	var record = _v0;
	return record.Lw;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count = function (_v0) {
	var record = _v0;
	return record.LY;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$divisionName = function (_v0) {
	var record = _v0;
	return record.NV;
};
var $author$project$Components$Invoice$Summary$groupName = F5(
	function (groupBy_, activeLineRow, divisionName, planName, companyName) {
		switch (groupBy_) {
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					'No Division',
					divisionName(activeLineRow));
			case 0:
				return A2(
					$elm$core$Maybe$withDefault,
					'No Plan',
					planName(activeLineRow));
			default:
				return A2(
					$elm$core$Maybe$withDefault,
					'No Sponsor',
					companyName(activeLineRow));
		}
	});
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents = function (_v0) {
	var record = _v0;
	return record.UR;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$planName = function (_v0) {
	var record = _v0;
	return record.Wo;
};
var $author$project$Components$Invoice$Summary$viewActiveLine = F3(
	function (companyType_, groupBy_, activeLineRow) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$info, $author$project$Ui$Typography$subtotal]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A5($author$project$Components$Invoice$Summary$groupName, groupBy_, activeLineRow, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$divisionName, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$planName, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$companyName))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count(activeLineRow) > 0) ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$String$pluralize,
												A2($author$project$Formatters$String$affiliateMember, 'employee', companyType_),
												$author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count(activeLineRow))),
											($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents(activeLineRow) > 0) ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' and '),
													$elm$html$Html$text(
													A2(
														$author$project$Formatters$String$pluralize,
														'dependent',
														$author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents(activeLineRow)))
												])) : $author$project$Utils$Html$empty
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$numeric]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Common$Invoice$Summary$ActiveLines$Row$amountInCents(activeLineRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$GroupByUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$Summary$viewGroupByButton = F3(
	function (currentGroupBy, groupBy_, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentGroupBy, groupBy_)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Invoice$Summary$GroupByUpdated(groupBy_))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Invoice$Summary$viewGroupByButtonGroup = function (model) {
	var summary = model._9;
	var _v0 = model.fK;
	if (!_v0.$) {
		var groupBy_ = _v0.a;
		return ($author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(model.ab9) && ($author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions(model.ab9) && $elm$core$List$isEmpty(
			$author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines(summary)))) ? A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$pull(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Button$group(
					_List_fromArray(
						[
							A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 0, 'By Plan'),
							A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 1, 'By Division')
						]))
				])) : (($author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(model.ab9) && A3($author$project$Components$Invoice$Summary$showSponsorBreakdown, model.Rr, model.ZD, model.ab9)) ? A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$pull(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Button$group(
					_List_fromArray(
						[
							A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 0, 'By Plan'),
							A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 2, 'By Sponsor')
						]))
				])) : $author$project$Utils$Html$empty);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$companyName = function (_v0) {
	var record = _v0;
	return record.Lw;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$count = function (_v0) {
	var record = _v0;
	return record.LY;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$divisionName = function (_v0) {
	var record = _v0;
	return record.NV;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges = function (_v0) {
	var record = _v0;
	return record.UT;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges = function (_v0) {
	var record = _v0;
	return record.UU;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$planName = function (_v0) {
	var record = _v0;
	return record.Wo;
};
var $author$project$Components$Invoice$Summary$viewMembershipAdjustmentLine = F2(
	function (groupBy_, membershipAdjustmentLineRow) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$info, $author$project$Ui$Typography$subtotal]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A5($author$project$Components$Invoice$Summary$groupName, groupBy_, membershipAdjustmentLineRow, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$divisionName, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$planName, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$companyName))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow) > 0) ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow))),
											$elm$html$Html$text(' manual')
										])) : $author$project$Utils$Html$empty,
									$author$project$Utils$Html$noBreakSpace,
									(($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow) > 0) && ($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow) > 0)) ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow))),
											$elm$html$Html$text('and ')
										])) : $author$project$Utils$Html$empty,
									($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow) > 0) ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow))),
											$elm$html$Html$text(' automated')
										])) : $author$project$Utils$Html$empty,
									$author$project$Utils$Html$noBreakSpace,
									($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$count(membershipAdjustmentLineRow) === 1) ? $elm$html$Html$text('adjustment') : $elm$html$Html$text('adjustments')
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$numeric]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$amountInCents(membershipAdjustmentLineRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$ToggleShowGroupAdjustments = {$: 2};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalAmountInCents = function (_v0) {
	var record = _v0;
	return record.Dx.I2;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges = function (_v0) {
	var record = _v0;
	return record.Dx.UT;
};
var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges = function (_v0) {
	var record = _v0;
	return record.Dx.UU;
};
var $author$project$Components$Invoice$Summary$viewMembershipAdjustmentSummary = F2(
	function (model, summary) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v0 = model.fK;
											if (!_v0.$) {
												return A3(
													$author$project$Ui$Button$view,
													{abp: 'Show group adjustments'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$onClick($author$project$Components$Invoice$Summary$ToggleShowGroupAdjustments),
															$author$project$Ui$Button$icon(
															model.gL ? $author$project$Ui$SvgIcon$minus : $author$project$Ui$SvgIcon$add)
														]),
													_List_Nil);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2(
											$author$project$Ui$Typography$strong,
											_List_fromArray(
												[$author$project$Ui$Typography$info]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Membership Adjustments')
												]))
										]))
								])),
							model.gL ? $author$project$Ui$FlexGrid$none : A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount(
									$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges(
															$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)))),
													$elm$html$Html$text(' manual')
												])) : $author$project$Utils$Html$empty,
											$author$project$Utils$Html$noBreakSpace,
											(($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) && ($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0)) ? $elm$html$Html$text('and ') : $author$project$Utils$Html$empty,
											($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges(
															$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)))),
													$elm$html$Html$text(' automated')
												])) : $author$project$Utils$Html$empty,
											$author$project$Utils$Html$noBreakSpace,
											($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount(
											$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) === 1) ? $elm$html$Html$text('adjustment') : $elm$html$Html$text('adjustments')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$numeric]),
									_List_fromArray(
										[
											model.gL ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalAmountInCents(
															$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary))))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Summary$ShowDeltaModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$Summary$ToggleShowGroups = {$: 1};
var $author$project$Api$Common$Invoice$Summary$activeLines = function (_v0) {
	var record = _v0;
	return record.Ie;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalAmountInCents = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.Dx.I2);
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount = function (_v0) {
	var record = _v0;
	return record.Dx.LY;
};
var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, 0, record.Dx.UR);
};
var $author$project$Ui$SvgIcon$TrendingDown = 64;
var $author$project$Ui$SvgIcon$trendingDown = $author$project$Ui$SvgIcon$viewIcon(64);
var $author$project$Ui$SvgIcon$TrendingUp = 63;
var $author$project$Ui$SvgIcon$trendingUp = $author$project$Ui$SvgIcon$viewIcon(63);
var $author$project$Components$Invoice$Summary$viewRecurringSummary = function (model) {
	var summary = model._9;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = model.fK;
									if (!_v0.$) {
										return A3(
											$author$project$Ui$Button$view,
											{abp: 'Toggle group visibility'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick($author$project$Components$Invoice$Summary$ToggleShowGroups),
													$author$project$Ui$Button$icon(
													model.gN ? $author$project$Ui$SvgIcon$minus : $author$project$Ui$SvgIcon$add)
												]),
											_List_Nil);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$author$project$Ui$Typography$strong,
									_List_fromArray(
										[$author$project$Ui$Typography$info]),
									_List_fromArray(
										[
											$elm$html$Html$text(' Current Period')
										]))
								]))
						])),
					model.gN ? $author$project$Ui$FlexGrid$none : A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(3)
						]),
					function () {
						if ($author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount(
							$author$project$Api$Common$Invoice$Summary$activeLines(summary)) > 0) {
							var companyType_ = $author$project$Components$Invoice$Summary$companyType(model.ab9);
							return _List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										A2($author$project$Formatters$String$affiliateMember, 'employee', companyType_),
										$author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount(
											$author$project$Api$Common$Invoice$Summary$activeLines(summary)))),
									($author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents(
									$author$project$Api$Common$Invoice$Summary$activeLines(summary)) > 0) ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(' and '),
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$String$pluralize,
												'dependent',
												$author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents(
													$author$project$Api$Common$Invoice$Summary$activeLines(summary))))
										])) : $author$project$Utils$Html$empty
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(4)
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = model.w8;
							if (_v1.$ === 3) {
								var delta = _v1.a;
								return ($elm$core$List$isEmpty(
									$author$project$Api$Common$Invoice$Delta$added(delta)) && $elm$core$List$isEmpty(
									$author$project$Api$Common$Invoice$Delta$removed(delta))) ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$core$List$isEmpty(
											$author$project$Api$Common$Invoice$Delta$added(delta)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$success]),
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$trendingUp(_List_Nil),
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(
															$author$project$Api$Common$Invoice$Delta$added(delta)))),
													$elm$html$Html$text(' added')
												])),
											$elm$core$List$isEmpty(
											$author$project$Api$Common$Invoice$Delta$removed(delta)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$danger,
													$author$project$Ui$Typography$margin(10)
												]),
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$trendingDown(_List_Nil),
													$elm$html$Html$text(
													$elm$core$String$fromInt(
														$elm$core$List$length(
															$author$project$Api$Common$Invoice$Delta$removed(delta)))),
													$elm$html$Html$text(' removed')
												])),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'See changes'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$margin(10),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Invoice$Summary$ShowDeltaModal(delta))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('See changes')
												]))
										]));
							} else {
								return $author$project$Ui$Spinner$view(
									_List_fromArray(
										[$author$project$Ui$Spinner$small]));
							}
						}()
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$numeric]),
							_List_fromArray(
								[
									model.gN ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Common$Invoice$Summary$ActiveLines$totalAmountInCents(
													$author$project$Api$Common$Invoice$Summary$activeLines(summary))))
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Components$Invoice$Summary$viewSummary = function (model) {
	var summary = model._9;
	var recurring = $author$project$Api$Invoice$One$recurring(model.Rh);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Components$Invoice$Summary$viewGroupByButtonGroup(model),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Summary')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						recurring ? $author$project$Components$Invoice$Summary$viewRecurringSummary(model) : _List_Nil),
						function () {
						var _v0 = _Utils_Tuple2(model.fK, model.gN);
						if ((!_v0.a.$) && _v0.b) {
							var groupBy_ = _v0.a.a;
							var companyType_ = $author$project$Components$Invoice$Summary$companyType(model.ab9);
							return A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A2($author$project$Components$Invoice$Summary$viewActiveLine, companyType_, groupBy_),
									A2($author$project$Components$Invoice$Summary$activeLinesFor, summary, groupBy_)));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount(
						$author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0) ? A2($author$project$Components$Invoice$Summary$viewMembershipAdjustmentSummary, model, summary) : $author$project$Utils$Html$empty,
						function () {
						var _v1 = _Utils_Tuple2(model.fK, model.gL);
						if ((!_v1.a.$) && _v1.b) {
							var groupBy_ = _v1.a.a;
							return A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Components$Invoice$Summary$viewMembershipAdjustmentLine(groupBy_),
									A2($author$project$Components$Invoice$Summary$membershipAdjustmentLinesFor, summary, groupBy_)));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$Summary$OtherChargesSummaryMsg,
						A2($author$project$Components$Invoice$Summary$OtherChargesSummary$view, summary, model.rK)),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(3)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$strong,
												_List_fromArray(
													[$author$project$Ui$Typography$info]),
												_List_fromArray(
													[
														$elm$html$Html$text('Total')
													]))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(7),
												$author$project$Ui$FlexGrid$justifyRight
											]),
										($author$project$Api$Invoice$One$discountSavingsInCents(model.Rh) > 0) ? _List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$view,
												_List_fromArray(
													[$author$project$Ui$Badge$success]),
												_List_fromArray(
													[
														$elm$html$Html$text('Membership Savings: '),
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Invoice$One$discountSavingsInCents(model.Rh)))
													]))
											]) : _List_Nil),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(2)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$numeric, $author$project$Ui$Typography$bold]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Common$Invoice$Summary$AllLines$totalAmountInCents(
																$author$project$Api$Common$Invoice$Summary$allLines(summary))))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Invoice$Summary$view = function (_v0) {
	var model = _v0;
	var recurring = $author$project$Api$Invoice$One$recurring(model.Rh);
	return recurring ? $author$project$Components$Invoice$Summary$viewSummary(model) : (($author$project$Api$Common$Invoice$Summary$AllLines$count(
		$author$project$Api$Common$Invoice$Summary$allLines(model._9)) > 0) ? $author$project$Components$Invoice$Summary$viewSummary(model) : $author$project$Utils$Html$empty);
};
var $author$project$Components$Invoice$DownloadFile$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$DownloadFile$label = function (str) {
	return $author$project$Components$Invoice$DownloadFile$Label(str);
};
var $author$project$Components$Invoice$DownloadFile$Tooltip = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$DownloadFile$tooltip = function (bool) {
	return $author$project$Components$Invoice$DownloadFile$Tooltip(bool);
};
var $author$project$Components$Invoice$viewDownloadUnavailableWarningModal = function (_v0) {
	var showDownloadUnavailableWarningModal = _v0.ok;
	var invoice = _v0.Rh;
	var downloadInvoice = _v0.iq;
	var _v1 = _Utils_Tuple2(invoice, showDownloadUnavailableWarningModal);
	if ((_v1.a.$ === 3) && _v1.b) {
		var _v2 = _v1.a;
		var invoice_ = _v2.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Invoice$DownloadUnavailableModalClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Can not export to PDF')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The PDF file for this invoice would be more than 50 pages long and cannot be generated. Please download the summary only as a pdf and then export the charge details to excel.')
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel download'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Invoice$DownloadUnavailableModalClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							$author$project$Utils$Html$noBreakSpace,
							A2(
							$elm$html$Html$map,
							$author$project$Components$Invoice$DownloadInvoiceMsg,
							A4(
								$author$project$Components$Invoice$DownloadFile$view,
								downloadInvoice,
								$author$project$Api$Invoice$One$securePdfInlineToken(invoice_),
								_List_fromArray(
									[
										$author$project$Components$Invoice$DownloadFile$label('Download Summary'),
										$author$project$Components$Invoice$DownloadFile$tooltip(false)
									]),
								_List_fromArray(
									[$author$project$Ui$Button$primary])))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Invoice$DownloadFile$UnavailableOptionClicked = {$: 5};
var $author$project$Components$Invoice$DownloadFile$viewDownloadOption = function (_v0) {
	var token = _v0.a;
	var option = _v0.b;
	var action = option.abs ? $author$project$Components$Invoice$DownloadFile$DownloadFileClicked(token) : $author$project$Components$Invoice$DownloadFile$UnavailableOptionClicked;
	return A2(
		$author$project$Ui$NewDropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$onSelect(action)
			]),
		$elm$html$Html$text(option.aej));
};
var $author$project$Components$Invoice$DownloadFile$viewDropdown = F2(
	function (model, options) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$placement(0)
				]),
			'Download or print PDF',
			_List_fromArray(
				[
					A4(
					$author$project$Ui$NewDropdown$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Export to PDF '),
							$author$project$Ui$SvgIcon$export(_List_Nil)
						]),
					A2($elm$core$List$map, $author$project$Components$Invoice$DownloadFile$viewDownloadOption, options),
					model.fy),
					model.R0 ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Invoice$InvoiceLinesTable$exportCsvPath = F2(
	function (apiClient, model) {
		var path = A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['invoice_lines']),
			function () {
				var _v0 = model.Rr;
				if (!_v0.$) {
					var id = _v0.b;
					return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id);
				} else {
					var companyId_ = _v0.a;
					var id = _v0.b;
					return A3($author$project$Api$Company$Invoice$invoicePath, model.ZD, companyId_, id);
				}
			}());
		return A4($author$project$Api$Data$downloadUrl, apiClient, path, 0, _List_Nil);
	});
var $author$project$Components$Invoice$InvoiceLinesTable$viewExportButton = F3(
	function (client, label, model) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Export to Excel',
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg,
					A3(
						$author$project$Components$FileLink$view,
						{
							K1: client,
							PE: 0,
							aav: A2($author$project$Components$Invoice$InvoiceLinesTable$exportCsvPath, client, model)
						},
						_List_fromArray(
							[
								$author$project$Ui$Link$buttonDefault,
								$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$export)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Export to Excel')
							])))
				])) : A2(
			$elm$html$Html$map,
			$author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg,
			A2(
				$author$project$Components$ExportCsv$customButton,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])));
	});
var $author$project$Api$Provider$IntegrationRecord$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$IntegrationRecord$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$errorMessage(one);
};
var $author$project$Api$Provider$IntegrationRecord$All$integration = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$integration(one);
};
var $author$project$Api$Provider$IntegrationRecord$Shared$integrationLastSyncedAt = function (_v0) {
	var record = _v0;
	return record.Q6;
};
var $author$project$Api$Provider$IntegrationRecord$One$integrationLastSyncedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$integrationLastSyncedAt(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$integrationLastSyncedAt(one);
};
var $author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus(one);
};
var $author$project$Api$Provider$IntegrationRecord$Shared$unsyncedReason = function (_v0) {
	var record = _v0;
	return record.aal;
};
var $author$project$Api$Provider$IntegrationRecord$One$unsyncedReason = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$unsyncedReason(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$unsyncedReason(one);
};
var $author$project$Components$Invoice$viewIntegrationRecord = F2(
	function (timeFormatter, record) {
		var unsyncedReason = function () {
			var _v2 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
			if (!_v2.$) {
				var reason = _v2.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(reason)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var lastSyncedAt = function () {
			var _v1 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
			if (!_v1.$) {
				var time = _v1.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'on ' + A2(timeFormatter, 0, time))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$name(
			$author$project$Api$Provider$IntegrationRecord$All$integration(record));
		var errorMessage = function () {
			var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
			if (!_v0.$) {
				var message = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var additionalInfo = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control-static'),
					$elm$html$Html$Attributes$class('text-muted')
				]),
			_List_fromArray(
				[unsyncedReason, errorMessage, lastSyncedAt]));
		return A2(
			$author$project$Ui$HinterOnly$formGroup,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(integrationName),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsStart]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$IntegrationRecord$Status$toString(
										$author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record)))
								])),
							additionalInfo
						]))
				]));
	});
var $author$project$Components$Invoice$viewIntegrationRecords = F2(
	function (formatter, response) {
		if (response.$ === 3) {
			var integrationRecords = response.a;
			return A2(
				$elm$core$List$map,
				$author$project$Components$Invoice$viewIntegrationRecord(formatter),
				integrationRecords);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Invoice$EditDateButtonClicked = {$: 29};
var $author$project$Components$Invoice$editDateButton = F4(
	function (buttonText, recurring, status, message) {
		return ((!recurring) && $author$project$Api$Invoice$Status$isDraft(status)) ? A3(
			$author$project$Ui$Button$view,
			{abp: buttonText},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(message),
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$Invoice$One$periodInMonths = function (_v0) {
	var record = _v0.b;
	return record.Wc;
};
var $author$project$Api$Invoice$One$periodInMonths = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$periodInMonths(invoice_);
	} else {
		return 0;
	}
};
var $author$project$Components$Invoice$formatInvoiceDate = F2(
	function (invoice, recurring) {
		return _List_fromArray(
			[
				recurring ? $elm$html$Html$text(
				A2(
					$author$project$Formatters$Date$toString,
					$author$project$Formatters$Date$MonthAndYear,
					$author$project$Api$Invoice$One$invoiceDate(invoice))) : $elm$html$Html$text(
				A2(
					$author$project$Formatters$Date$toString,
					$author$project$Formatters$Date$Full,
					$author$project$Api$Invoice$One$invoiceDate(invoice))),
				(($author$project$Api$Invoice$One$periodInMonths(invoice) > 1) && recurring) ? A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' - '),
						$elm$html$Html$text(
						A2(
							$author$project$Formatters$Date$toString,
							$author$project$Formatters$Date$MonthAndYear,
							A3(
								$justinmimbs$date$Date$add,
								1,
								$author$project$Api$Invoice$One$periodInMonths(invoice) - 1,
								$author$project$Api$Invoice$One$invoiceDate(invoice))))
					])) : $author$project$Utils$Html$empty
			]);
	});
var $author$project$Components$Invoice$viewInvoiceDate = F3(
	function (invoice, showDateInput, fields) {
		var status = $author$project$Api$Invoice$One$humanStatus(invoice);
		var recurring = $author$project$Api$Invoice$One$recurring(invoice);
		return A2(
			$author$project$Ui$Form$Group$view,
			recurring ? _List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Invoice Period'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$clearfix
				]) : _List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Invoice Date'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$clearfix
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							function () {
							if (showDateInput) {
								return A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Invoice$InvoiceDateInputMsg(fields.mz),
											A2(
												$author$project$Components$DateInput$view,
												_List_fromArray(
													[
														$author$project$Components$DateInput$value(
														$elm$core$Maybe$Just(fields.Rn))
													]),
												fields.mz))
										]));
							} else {
								var dateWidth = recurring ? 6 : 3;
								return A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(dateWidth)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$strong,
													_List_Nil,
													A2($author$project$Components$Invoice$formatInvoiceDate, invoice, recurring))
												]))
										]));
							}
						}(),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									A4($author$project$Components$Invoice$editDateButton, 'Edit Invoice Date', recurring, status, $author$project$Components$Invoice$EditDateButtonClicked)
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$EditDueDateButtonClicked = {$: 31};
var $author$project$Components$Invoice$viewInvoiceDueDate = F3(
	function (invoice, showDueDateInput, fields) {
		var status = $author$project$Api$Invoice$One$humanStatus(invoice);
		var recurring = $author$project$Api$Invoice$One$recurring(invoice);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Due On'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$clearfix
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							showDueDateInput ? A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Invoice$InvoiceDueDateInputMsg(fields.mA),
									A2(
										$author$project$Components$DateInput$view,
										_List_fromArray(
											[
												$author$project$Components$DateInput$value(
												$elm$core$Maybe$Just(fields.iW))
											]),
										fields.mA))
								])) : A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Formatters$Date$toString,
														$author$project$Formatters$Date$Full,
														$author$project$Api$Invoice$One$dueDate(invoice)))
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4)
								]),
							_List_fromArray(
								[
									A4($author$project$Components$Invoice$editDateButton, 'Edit Due Date', recurring, status, $author$project$Components$Invoice$EditDueDateButtonClicked)
								]))
						]))
				]));
	});
var $author$project$Components$Invoice$Issue = {$: 20};
var $author$project$Api$Provider$Invoice$One$viewingAsAffiliate = function (_v0) {
	var record = _v0.b;
	return record.aaR;
};
var $author$project$Api$Invoice$One$viewingAsAffiliate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$viewingAsAffiliate(invoice_);
	} else {
		return false;
	}
};
var $author$project$Components$Invoice$viewIssueButton = F2(
	function (model, invoice) {
		var meta = $author$project$Api$Invoice$One$meta(invoice);
		return ($author$project$Api$Invoice$Meta$issueAction(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Issue invoice'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick($author$project$Components$Invoice$Issue)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$Icon$view, _List_Nil, 23),
					$author$project$Utils$Html$noBreakSpace,
					$author$project$Components$Invoice$isNetwork(model.ab9) ? $elm$html$Html$text('Approve ') : $elm$html$Html$text('Issue '),
					$elm$html$Html$text('Invoice')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Employer$Invoice$One$willAutoPay = function (_v0) {
	var record = _v0.b;
	return record.aa4;
};
var $author$project$Api$Provider$Invoice$One$willAutoPay = function (_v0) {
	var record = _v0.b;
	return record.aa4;
};
var $author$project$Api$Invoice$One$willAutoPay = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$One$willAutoPay(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$One$willAutoPay(invoice_);
	}
};
var $author$project$Components$Invoice$view = F2(
	function (apiClient, _v0) {
		var model = _v0;
		return _List_fromArray(
			[
				function () {
				var _v1 = model.ty;
				if (!_v1.$) {
					var invoice = _v1.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$VoidHiConfirmClosed(invoice),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('void'),
								$author$project$Components$HiConfirm$noun(
								'Invoice #' + $elm$core$String$fromInt(
									$author$project$Api$Invoice$One$invoiceNumber(invoice))),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.ey;
				if (!_v2.$) {
					var invoice = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$ReturnToDraftHiConfirmClosed(invoice),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('Return to draft'),
								$author$project$Components$HiConfirm$noun(
								'Invoice #' + $elm$core$String$fromInt(
									$author$project$Api$Invoice$One$invoiceNumber(invoice))),
								$author$project$Components$HiConfirm$detail('which will also delete the current draft invoice if any'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.ec;
				if (!_v3.$) {
					var invoice = _v3.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed(invoice),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('Mark'),
								$author$project$Components$HiConfirm$noun(
								'Invoice #' + $elm$core$String$fromInt(
									$author$project$Api$Invoice$One$invoiceNumber(invoice))),
								$author$project$Components$HiConfirm$detail('which will remove it from your outstanding invoices report'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v4 = model.h8;
				if (!_v4.$) {
					var invoice = _v4.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Invoice$DeleteHiConfirmClosed(invoice),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun(
								'Invoice #' + $elm$core$String$fromInt(
									$author$project$Api$Invoice$One$invoiceNumber(invoice))),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.hN;
				if (!_v5.$) {
					var companyEmailModal = _v5.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$CompanyEmailModalMsg,
						$author$project$Components$CompanyEmailModal$view(companyEmailModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v6 = model.lC;
				if (!_v6.$) {
					var createPaymentModal = _v6.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$CreatePaymentModalMsg,
						$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v7 = model.fP;
				if (!_v7.$) {
					var invoiceSummary = _v7.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$InvoiceSummaryMsg,
						$author$project$Components$Invoice$Summary$modal(invoiceSummary));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v8 = model.d6;
				if (!_v8.$) {
					var invoiceLinesTable = _v8.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Invoice$InvoiceLinesTableMsg,
						$author$project$Components$Invoice$InvoiceLinesTable$modal(invoiceLinesTable));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Components$Invoice$viewDownloadUnavailableWarningModal(model),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$PaymentsHistoryMsg,
				$author$project$Components$Invoice$PaymentsHistory$modal(model.jq)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v9 = model.Rh;
							if (_v9.$ === 3) {
								var invoice = _v9.a;
								var meta = $author$project$Api$Invoice$One$meta(invoice);
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$never,
										A2(
											$author$project$Ui$Breadcrumb$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															model.F_,
															_List_Nil,
															_List_fromArray(
																[
																	model.k0 ? $elm$html$Html$text('Bills') : $elm$html$Html$text('Invoices')
																]))
														])),
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_fromArray(
														[
															$author$project$Ui$Breadcrumb$active(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'#' + $elm$core$String$fromInt(
																$author$project$Api$Invoice$One$invoiceNumber(invoice)))
														]))
												]))),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Api$Invoice$One$isUpdating(invoice) ? A2(
										$author$project$Ui$Alert$warning,
										_List_fromArray(
											[$author$project$Ui$Alert$mb2]),
										_List_fromArray(
											[
												$elm$html$Html$text('We are updating the invoice with recent membership changes. The page will reload when the update completes.')
											])) : $author$project$Utils$Html$empty,
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$itemsCenter]),
														_List_fromArray(
															[
																$author$project$Ui$Typography$heading(
																_List_fromArray(
																	[
																		$elm$html$Html$text('Invoice #'),
																		$elm$html$Html$text(
																		$elm$core$String$fromInt(
																			$author$project$Api$Invoice$One$invoiceNumber(invoice)))
																	])),
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$ml2]),
																_List_fromArray(
																	[
																		A2(
																		$elm$core$Maybe$withDefault,
																		$author$project$Utils$Html$empty,
																		A2(
																			$elm$core$Maybe$map,
																			A2(
																				$elm$core$Basics$composeR,
																				$author$project$Components$AuditTrailLog$view,
																				$elm$html$Html$map($author$project$Components$Invoice$AuditTrailLogMsg)),
																			model.hy))
																	]))
															])),
														$author$project$Ui$Typography$headingSm(
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$Currency$fromInt(
																	$author$project$Api$Invoice$One$amountInCents(invoice))),
																$author$project$Utils$Html$noBreakSpace,
																$author$project$Api$Invoice$Status$toBadge(
																$author$project$Api$Invoice$One$humanStatus(invoice))
															]))
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A2($author$project$Components$Invoice$viewIssueButton, model, invoice),
														($author$project$Api$Invoice$Meta$canMakeViewableAction(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A3(
														$author$project$Ui$Tooltip$view,
														_List_Nil,
														'Email Invoice',
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Send invoice to employer'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$onClick(
																		$author$project$Components$Invoice$MakeViewableAndEmail(invoice)),
																		$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Send to employer')
																	]))
															])) : $author$project$Utils$Html$empty,
														$author$project$Api$Invoice$Meta$canNotifyAction(meta) ? A3(
														$author$project$Ui$Tooltip$view,
														_List_Nil,
														'Email Invoice',
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Email invoice'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$onClick(
																		$author$project$Components$Invoice$Email(invoice)),
																		$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Email')
																	]))
															])) : $author$project$Utils$Html$empty,
														function () {
														var chargesOptionAvailable = function (count) {
															return _Utils_cmp(count, $author$project$Components$Invoice$maxInvoiceLinesForDetailsDownload) < 0;
														}(
															A2($elm$core$Maybe$withDefault, 0, model.yf));
														return A2(
															$elm$html$Html$map,
															$author$project$Components$Invoice$DownloadInvoiceMsg,
															A2(
																$author$project$Components$Invoice$DownloadFile$viewDropdown,
																model.iq,
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		$author$project$Api$Invoice$One$securePdfInlineToken(invoice),
																		{
																			abs: true,
																			MQ: {Fu: '', F2: ''},
																			aej: 'Summary Only'
																		}),
																		_Utils_Tuple2(
																		$author$project$Api$Invoice$One$securePdfInlineWithChargeDetailsToken(invoice),
																		{
																			abs: chargesOptionAvailable,
																			MQ: {Fu: '', F2: ''},
																			aej: 'Summary and Charges'
																		})
																	])));
													}(),
														A2(
														$elm$core$Maybe$withDefault,
														$elm$html$Html$text(''),
														A2(
															$elm$core$Maybe$map,
															$elm$html$Html$map($author$project$Components$Invoice$InvoiceLinesTableMsg),
															A2(
																$elm$core$Maybe$map,
																A2($author$project$Components$Invoice$InvoiceLinesTable$viewExportButton, apiClient, 'Export to Excel'),
																model.d6)))
													]))
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6)
													]),
												_List_fromArray(
													[
														$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Pay To'),
																$author$project$Ui$Form$Group$labelSpan(4),
																$author$project$Ui$Form$Group$inputSpan(8)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$strong,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Api$Practice$name(model.WF))
																			])),
																		function () {
																		var _v10 = A2(
																			$elm$core$Maybe$andThen,
																			$author$project$Api$Common$Phone$Shared$number,
																			$elm$core$List$head(
																				$author$project$Api$Practice$phones(model.WF)));
																		if (!_v10.$) {
																			var phoneNumber = _v10.a;
																			return A2(
																				$author$project$Ui$Typography$div,
																				_List_fromArray(
																					[
																						$author$project$Ui$Typography$phi(true)
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						$author$project$Formatters$Phone$format(phoneNumber))
																					]));
																		} else {
																			return $author$project$Utils$Html$empty;
																		}
																	}(),
																		function () {
																		var _v11 = $author$project$Api$Practice$address(model.WF);
																		if (!_v11.$) {
																			var address = _v11.a;
																			return $author$project$Components$AddressDisplay$view(address);
																		} else {
																			return $author$project$Utils$Html$empty;
																		}
																	}()
																	]))
															])) : A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Payer'),
																$author$project$Ui$Form$Group$labelSpan(4),
																$author$project$Ui$Form$Group$inputSpan(8)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Form$Static$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$strong,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				A2(
																					$elm$core$Maybe$withDefault,
																					'',
																					$author$project$Components$Invoice$companyName(model.ab9))),
																				A2($elm$html$Html$br, _List_Nil, _List_Nil)
																			])),
																		A2(
																		$author$project$Ui$Typography$strong,
																		_List_Nil,
																		_List_fromArray(
																			[
																				function () {
																				var _v12 = A2(
																					$elm$core$Maybe$andThen,
																					$author$project$Api$Common$Phone$Shared$number,
																					$elm$core$List$head(
																						$author$project$Components$Invoice$companyPhones(model.ab9)));
																				if (!_v12.$) {
																					var phoneNumber = _v12.a;
																					return A2(
																						$author$project$Ui$Typography$div,
																						_List_fromArray(
																							[
																								$author$project$Ui$Typography$phi(true)
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Formatters$Phone$format(phoneNumber))
																							]));
																				} else {
																					return $author$project$Utils$Html$empty;
																				}
																			}(),
																				function () {
																				var _v13 = $author$project$Components$Invoice$companyAddress(model.ab9);
																				if (!_v13.$) {
																					var address = _v13.a;
																					return $author$project$Components$AddressDisplay$view(address);
																				} else {
																					return $author$project$Utils$Html$empty;
																				}
																			}()
																			]))
																	]))
															])),
														function () {
														var hasActiveInvoice = !A2(
															$elm$core$List$member,
															$author$project$Api$Invoice$Status$toString(
																$author$project$Api$Invoice$One$humanStatus(invoice)),
															_List_fromArray(
																['draft', 'paid', 'cancelled']));
														return hasActiveInvoice ? A2(
															$elm$core$Maybe$withDefault,
															$author$project$Utils$Html$empty,
															A2(
																$elm$core$Maybe$map,
																function (virtualBankAccountsComponent_) {
																	var payerName = $author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? $author$project$Api$Practice$name(model.WF) : A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		$author$project$Components$Invoice$companyName(model.ab9));
																	return A2(
																		$elm$html$Html$map,
																		$author$project$Components$Invoice$VirtualBankAccountsComponentMsg,
																		A2($author$project$Components$Company$VirtualBankAccounts$Invoice$view, virtualBankAccountsComponent_, payerName));
																},
																model.tx)) : $author$project$Utils$Html$empty;
													}(),
														A2($elm$html$Html$br, _List_Nil, _List_Nil)
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6)
													]),
												A2(
													$elm$core$List$cons,
													A3(
														$author$project$Components$Invoice$viewInvoiceDate,
														invoice,
														model.oj,
														$author$project$Utils$Form$fields(model.cv)),
													A2(
														$elm$core$List$cons,
														A3(
															$author$project$Components$Invoice$viewInvoiceDueDate,
															invoice,
															model.ol,
															$author$project$Utils$Form$fields(model.cv)),
														A2(
															$elm$core$List$cons,
															$author$project$Api$Invoice$One$recurring(invoice) ? A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$label('Autopay'),
																		$author$project$Ui$Form$Group$labelSpan(4),
																		$author$project$Ui$Form$Group$inputSpan(8),
																		$author$project$Ui$Form$Group$clearfix
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Static$view,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Typography$strong,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$author$project$Api$Invoice$One$willAutoPay(invoice) ? $elm$html$Html$text(
																						$author$project$Formatters$Bool$toString(
																							$author$project$Api$Invoice$One$willAutoPay(invoice)) + (', on ' + A2(
																							$elm$core$Maybe$withDefault,
																							'N/A',
																							A2(
																								$elm$core$Maybe$map,
																								$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																								$author$project$Api$Invoice$One$autoPayDate(invoice))))) : $elm$html$Html$text(
																						$author$project$Formatters$Bool$toString(
																							$author$project$Api$Invoice$One$willAutoPay(invoice))),
																						$author$project$Api$Invoice$One$willAutoPay(invoice) ? $author$project$Utils$Html$empty : A3(
																						$author$project$Ui$Tooltip$view,
																						_List_fromArray(
																							[$author$project$Ui$Tooltip$wide]),
																						'We will only try to autopay invoices if the company has a default payment source, autopay is enabled (see \"Invoice Settings\"), and no payment attempts have been made',
																						_List_fromArray(
																							[
																								$author$project$Utils$Html$noBreakSpace,
																								A2($author$project$Ui$Icon$view, _List_Nil, 5)
																							]))
																					]))
																			]))
																	])) : $author$project$Utils$Html$empty,
															A2(
																$elm$core$List$cons,
																$author$project$Api$Invoice$One$willAutoPay(invoice) ? A2(
																	$author$project$Ui$Form$Group$view,
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Group$label('Payment Source'),
																			$author$project$Ui$Form$Group$labelSpan(4),
																			$author$project$Ui$Form$Group$inputSpan(8),
																			$author$project$Ui$Form$Group$clearfix
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$Form$Static$view,
																			_List_Nil,
																			_List_fromArray(
																				[
																					function () {
																					var _v14 = $author$project$Api$Invoice$One$source(invoice);
																					if (!_v14.$) {
																						var source = _v14.a;
																						return A2(
																							$author$project$Components$PaymentSourceDisplayer$view,
																							model.Hy,
																							_List_fromArray(
																								[
																									$author$project$Components$PaymentSourceDisplayer$source(
																									$elm$core$Maybe$Just(
																										$author$project$Api$Source$Source(source))),
																									$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
																									$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																								]));
																					} else {
																						return A2(
																							$author$project$Ui$Badge$view,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('none')
																								]));
																					}
																				}()
																				]))
																		])) : $author$project$Utils$Html$empty,
																A2(
																	$elm$core$List$cons,
																	A2(
																		$author$project$Ui$Form$Group$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Group$label('Total Paid'),
																				$author$project$Ui$Form$Group$labelSpan(4),
																				$author$project$Ui$Form$Group$inputSpan(8),
																				$author$project$Ui$Form$Group$clearfix
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Form$Static$view,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Typography$strong,
																						_List_Nil,
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Utils$Currency$fromInt(
																									$author$project$Api$Invoice$One$paidInCents(invoice)))
																							])),
																						function () {
																						var _v15 = $author$project$Api$Invoice$One$paidAt(invoice);
																						if (!_v15.$) {
																							var paidAt = _v15.a;
																							return A2(
																								$author$project$Ui$Typography$span,
																								_List_fromArray(
																									[$author$project$Ui$Typography$small]),
																								_List_fromArray(
																									[
																										$author$project$Utils$Html$noBreakSpace,
																										$author$project$Api$Invoice$Status$toBadge(
																										$author$project$Api$Invoice$One$humanStatus(invoice)),
																										$elm$html$Html$text(
																										' on ' + A2(model.Hy, 2, paidAt))
																									]));
																						} else {
																							return $author$project$Utils$Html$empty;
																						}
																					}()
																					])),
																				A2(
																				$elm$html$Html$map,
																				$author$project$Components$Invoice$PaymentsHistoryMsg,
																				A2(
																					$author$project$Components$Invoice$PaymentsHistory$view,
																					{
																						abg: model.FR,
																						abj: $author$project$Components$Invoice$isAPractice(model.ZD) && (!model.k0),
																						FR: model.FR,
																						V5: $author$project$Api$Invoice$One$payments(invoice),
																						agZ: $author$project$Components$Invoice$isAPractice(model.ZD)
																					},
																					model.jq))
																			])),
																	A2(
																		$elm$core$List$cons,
																		A2(
																			$author$project$Ui$Form$Group$view,
																			_List_fromArray(
																				[
																					$author$project$Ui$Form$Group$label('Total Due'),
																					$author$project$Ui$Form$Group$labelSpan(4),
																					$author$project$Ui$Form$Group$inputSpan(8),
																					$author$project$Ui$Form$Group$clearfix
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$author$project$Ui$Form$Static$view,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$author$project$Ui$Typography$strong,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text(
																									$author$project$Utils$Currency$fromInt(
																										$author$project$Api$Invoice$One$dueInCents(invoice)))
																								]))
																						]))
																				])),
																		A2($author$project$Components$Invoice$viewIntegrationRecords, model.Hy, model.Q8))))))))
											])),
										function () {
										var _v16 = model.fP;
										if (!_v16.$) {
											var invoiceSummary = _v16.a;
											return A2(
												$elm$html$Html$map,
												$author$project$Components$Invoice$InvoiceSummaryMsg,
												$author$project$Components$Invoice$Summary$view(invoiceSummary));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt2]),
										function () {
											var _v17 = model.d6;
											if (!_v17.$) {
												var invoiceLinesTable = _v17.a;
												return A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Invoice$InvoiceLinesTableMsg),
													A2($author$project$Components$Invoice$InvoiceLinesTable$view, apiClient, invoiceLinesTable));
											} else {
												return _List_Nil;
											}
										}())
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyCenter]),
						function () {
							var _v18 = model.Rh;
							if (_v18.$ === 3) {
								var invoice = _v18.a;
								var meta = $author$project$Api$Invoice$One$meta(invoice);
								return _List_fromArray(
									[
										function () {
										if (($author$project$Api$Invoice$Meta$canCancelAction(meta) || ($author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta) || ($author$project$Api$Invoice$Meta$canMarkAsBadDebtAction(meta) || $author$project$Api$Invoice$Meta$canReverseBadDebtAction(meta)))) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) {
											var actions = A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												_List_fromArray(
													[
														$author$project$Api$Invoice$Meta$canCancelAction(meta) ? $elm$core$Maybe$Just(
														A2(
															$author$project$Ui$NewDropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$NewDropdown$onSelect(
																	$author$project$Components$Invoice$Void(invoice))
																]),
															A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2($author$project$Ui$Icon$view, _List_Nil, 10),
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Void')
																	])))) : $elm$core$Maybe$Nothing,
														$author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta) ? $elm$core$Maybe$Just(
														A2(
															$author$project$Ui$NewDropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$NewDropdown$onSelect(
																	$author$project$Components$Invoice$ReturnToDraft(invoice))
																]),
															A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2($author$project$Ui$Icon$view, _List_Nil, 13),
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Return To Draft')
																	])))) : $elm$core$Maybe$Nothing,
														$author$project$Api$Invoice$Meta$canMarkAsBadDebtAction(meta) ? $elm$core$Maybe$Just(
														A2(
															$author$project$Ui$NewDropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$NewDropdown$onSelect(
																	$author$project$Components$Invoice$MarkAsBadDebt(invoice))
																]),
															A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2($author$project$Ui$Icon$view, _List_Nil, 12),
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Bad Debt')
																	])))) : $elm$core$Maybe$Nothing,
														$author$project$Api$Invoice$Meta$canReverseBadDebtAction(meta) ? $elm$core$Maybe$Just(
														A2(
															$author$project$Ui$NewDropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$NewDropdown$onSelect($author$project$Components$Invoice$ReverseBadDebt)
																]),
															A2(
																$author$project$Ui$Element$view,
																_List_Nil,
																_List_fromArray(
																	[
																		A2($author$project$Ui$Icon$view, _List_Nil, 13),
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Return To Issued')
																	])))) : $elm$core$Maybe$Nothing
													]));
											return A4(
												$author$project$Ui$NewDropdown$view,
												_List_fromArray(
													[
														$author$project$Ui$NewDropdown$disabled(
														_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
														$author$project$Ui$NewDropdown$buttonWarning
													]),
												_List_fromArray(
													[
														A2($author$project$Ui$Icon$view, _List_Nil, 4),
														$author$project$Utils$Html$noBreakSpace,
														$elm$html$Html$text('Revise Invoice')
													]),
												actions,
												model.lV);
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										function () {
										if ($author$project$Api$Invoice$One$isPayable(invoice) && ((!$author$project$Utils$Maybe$toBool(
											$author$project$Components$Invoice$companyDefaultSource(model.ab9))) && ((!$author$project$Components$Invoice$isNetwork(model.ab9)) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))))) {
											var _v19 = model.r$;
											if (!_v19.$) {
												var paymentSourcesRoute = _v19.a;
												return A3(
													$author$project$Ui$Link$route,
													paymentSourcesRoute,
													_List_fromArray(
														[$author$project$Ui$Link$buttonDefault]),
													_List_fromArray(
														[
															$elm$html$Html$text('Add Payment Source')
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										$author$project$Api$Invoice$Meta$markAsPaidAction(meta) ? A3(
										$author$project$Ui$Button$view,
										{abp: 'Record payment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Invoice$RecordPayment(invoice))
											]),
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 23),
												$author$project$Utils$Html$noBreakSpace,
												$author$project$Components$Invoice$isNetwork(model.ab9) ? $elm$html$Html$text('Mark As Paid') : $elm$html$Html$text('Record Payment')
											])) : $author$project$Utils$Html$empty,
										($author$project$Api$Invoice$Meta$createPaymentAction(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A3(
										$author$project$Ui$Button$view,
										{abp: 'Process payment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$success,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Invoice$Pay(invoice)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$dollarSign)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Process Payment')
											])) : $author$project$Utils$Html$empty,
										($author$project$Api$Invoice$Meta$issueAction(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A2($author$project$Components$Invoice$viewIssueButton, model, invoice) : $author$project$Utils$Html$empty,
										($author$project$Api$Invoice$Meta$canDelete(meta) && (!$author$project$Api$Invoice$One$viewingAsAffiliate(invoice))) ? A3(
										$author$project$Ui$Button$view,
										{abp: 'Delete invoice'},
										_List_fromArray(
											[
												$author$project$Ui$Button$danger,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Invoice$Delete(invoice))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Delete')
											])) : $author$project$Utils$Html$empty
									]);
							} else {
								return _List_fromArray(
									[
										$author$project$Ui$Spinner$view(_List_Nil)
									]);
							}
						}())
					]))
			]);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$view = function (model) {
	return {
		e5: function () {
			var _v0 = model.fO;
			if (!_v0.$) {
				var invoiceComponent = _v0.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg),
					A2($author$project$Components$Invoice$view, model.D5, invoiceComponent));
			} else {
				return $author$project$Components$LoadingPage$view;
			}
		}(),
		$G: 'Affiliates | Bills'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$init, aer: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$load, agD: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$save, ahd: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$subscriptions, aaq: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$update, ahP: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$GotAffiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var params = _v2.Vx;
		return _Utils_Tuple2(
			{pp: params.pp, D5: shared.D5, hB: $elm$core$Maybe$Nothing, cO: shared.cO, Bi: query, Hy: shared.Hy},
			A3($author$project$Api$Provider$Affiliate$retrieve, shared.D5, params.pp, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$GotAffiliate));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$subscriptions = function (model) {
	var _v0 = model.hB;
	if (!_v0.$) {
		var billsList = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg,
			$author$project$Components$Affiliates$BillsList$subscriptions(billsList));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var affiliate = response.a;
				var _v2 = $author$project$Components$Affiliates$BillsList$init(
					{
						DZ: $elm$core$Maybe$Just(affiliate),
						D5: model.D5,
						cO: model.cO,
						F_: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
							{pp: model.pp}),
						Bi: model.Bi,
						Hy: model.Hy
					});
				var billsList = _v2.a;
				var billsListCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hB: $elm$core$Maybe$Just(billsList)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg, billsListCmd),
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var _v3 = model.hB;
			if (!_v3.$) {
				var billsList = _v3.a;
				var _v4 = A3($author$project$Components$Affiliates$BillsList$update, model.D5, subMsg, billsList);
				var billsList_ = _v4.a;
				var billsListCmd = _v4.b;
				var billsListOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hB: $elm$core$Maybe$Just(billsList_)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg, billsListCmd),
					billsListOutMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.hB;
				if (!_v0.$) {
					var billsList = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg,
						$author$project$Components$Affiliates$BillsList$view(billsList));
				} else {
					return A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]),
		$G: 'Affiliates | Bills'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$init, aer: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$load, agD: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$save, ahd: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$subscriptions, aaq: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$update, ahP: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$view});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotLocations = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Affiliates$Location$All$Location = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$Location$Min$Location = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$Location$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Affiliates$Location$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$Min$Record)));
var $author$project$Api$Provider$Affiliates$Location$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Location$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$Location$All$Record = F2(
	function (activeLives, affiliateLocation) {
		return {If: activeLives, ID: affiliateLocation};
	});
var $author$project$Api$Provider$Affiliates$Location$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'affiliate_location',
	$author$project$Api$Provider$Location$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'active_lives',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$All$Record)));
var $author$project$Api$Provider$Affiliates$Location$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Location$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Affiliates$Location$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$All$Location)));
var $author$project$Api$Provider$Affiliates$Location$locationsPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['locations']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$Location$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Location$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Location$list, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotLocations);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotPractitioners = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliates$Practitioner$All$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$Practitioner$All$Record = F4(
	function (id, name, activeLives, affiliatePractitioner) {
		return {If: activeLives, IG: affiliatePractitioner, adR: id, zh: name};
	});
var $author$project$Api$Provider$Affiliates$Practitioner$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'affiliate_practitioner',
	$author$project$Api$Provider$Practitioner$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'active_lives',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Practitioner$All$Record)))));
var $author$project$Api$Provider$Affiliates$Practitioner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Practitioner$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$Practitioner$practitionersPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practitioners']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$Practitioner$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Practitioner$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Practitioner$list, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotPractitioners);
};
var $author$project$Components$Affiliates$LinkRecordsModal$Closed = {$: 0};
var $author$project$Components$Affiliates$LinkRecordsModal$init = $author$project$Components$Affiliates$LinkRecordsModal$Closed;
var $author$project$Components$Affiliates$UnlinkRecordsModal$Closed = {$: 0};
var $author$project$Components$Affiliates$UnlinkRecordsModal$init = $author$project$Components$Affiliates$UnlinkRecordsModal$Closed;
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		var model = {
			pp: params.pp,
			D5: shared.D5,
			adN: shared.adN,
			mR: $author$project$Components$Affiliates$LinkRecordsModal$init,
			S4: $author$project$Api$Data$Loading,
			WF: practice,
			WQ: $author$project$Api$Data$Loading,
			ZD: session,
			ko: $elm$core$Maybe$Nothing,
			oX: $author$project$Components$Affiliates$UnlinkRecordsModal$init,
			HN: A2($author$project$Utils$User$isViewingAsHinter, session, shared.adN)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model),
						$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model)
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$CloseModal = {$: 5};
var $author$project$Components$Affiliates$LinkRecordsModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$LinkRecordsModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Affiliates$SyncPatientsModal$CloseModal = {$: 0};
var $author$project$Components$Affiliates$SyncPatientsModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$SyncPatientsModal$CloseModal);
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal = {$: 1};
var $author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg,
				$author$project$Components$Affiliates$LinkRecordsModal$subscriptions(model.mR)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Affiliates$SyncPatientsModal$subscriptions, model.ko))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg,
				$author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions(model.oX))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkedAllProviders = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Affiliates$SyncPatientsModal$Skip = 1;
var $author$project$Components$Affiliates$SyncPatientsModal$init = function (affiliateId) {
	return {DV: 1, kO: $author$project$Api$Data$NotAsked, pp: affiliateId};
};
var $author$project$Api$Provider$Affiliate$linkAllProviders = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['link_all_practitioners']),
					$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId))));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliateLocations = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliatePractitioners = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkLocations = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkPractitioners = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$Linked = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$LocationLinked = 2;
var $author$project$Components$Affiliates$LinkRecordsModal$None = 0;
var $author$project$Components$Affiliates$LinkRecordsModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$PractitionerLinked = 1;
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$id(min);
};
var $author$project$Api$Provider$Practitioner$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Practitioner$Affiliate$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Practitioner$Min$id(min);
};
var $author$project$Components$Affiliates$LinkRecordsModal$formFieldsUpdate = F3(
	function (model, field, fields) {
		switch (field.$) {
			case 0:
				var id = field.a;
				var affiliatePractitioners = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.pr));
				return _Utils_update(
					fields,
					{
						IG: A2(
							$elm_community$list_extra$List$Extra$find,
							function (practitioner) {
								return _Utils_eq(
									$author$project$Api$Provider$Practitioner$Affiliate$id(practitioner),
									id);
							},
							affiliatePractitioners)
					});
			case 1:
				var id = field.a;
				var affiliateLocations = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.pq));
				return _Utils_update(
					fields,
					{
						ID: A2(
							$elm_community$list_extra$List$Extra$find,
							function (location) {
								return _Utils_eq(
									$author$project$Api$Provider$Affiliates$AffiliateLocation$All$id(location),
									id);
							},
							affiliateLocations)
					});
			case 2:
				var id = field.a;
				var networkPractitioners = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.rv));
				return _Utils_update(
					fields,
					{
						ru: A2(
							$elm_community$list_extra$List$Extra$find,
							function (practitioner) {
								return _Utils_eq(
									$author$project$Api$Provider$Practitioner$All$id(practitioner),
									id);
							},
							networkPractitioners)
					});
			case 3:
				var id = field.a;
				var networkLocations = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(model.rt));
				return _Utils_update(
					fields,
					{
						rs: A2(
							$elm_community$list_extra$List$Extra$find,
							function (location) {
								return _Utils_eq(
									$author$project$Api$Provider$Location$All$id(location),
									id);
							},
							networkLocations)
					});
			default:
				var value = field.a;
				return _Utils_update(
					fields,
					{ta: value});
		}
	});
var $author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocationValidation = 1;
var $author$project$Components$Affiliates$LinkRecordsModal$validateAffiliateLocation = F2(
	function (resource, fields) {
		var _v0 = _Utils_Tuple2(resource, fields.ID);
		if ((_v0.a === 1) && (_v0.b.$ === 1)) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please pick a location.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitionerValidation = 0;
var $author$project$Components$Affiliates$LinkRecordsModal$validateAffiliatePractitioner = F2(
	function (resource, fields) {
		var _v0 = _Utils_Tuple2(resource, fields.IG);
		if ((!_v0.a) && (_v0.b.$ === 1)) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please pick a practitioner.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Affiliates$LinkRecordsModal$formFieldsValidator = function (resource) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Affiliates$LinkRecordsModal$validateAffiliatePractitioner(resource)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Affiliates$LinkRecordsModal$validateAffiliateLocation(resource))
			]));
};
var $author$project$Components$Affiliates$LinkRecordsModal$initFormFields = function (userIsHinter) {
	return {ID: $elm$core$Maybe$Nothing, IG: $elm$core$Maybe$Nothing, rs: $elm$core$Maybe$Nothing, ru: $elm$core$Maybe$Nothing, ta: userIsHinter};
};
var $author$project$Api$Provider$Affiliates$Location$link = F5(
	function (apiClient, affiliateId, affiliateLocationId, networkLocationId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'network_location_id',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, networkLocationId)),
					_Utils_Tuple2(
					'affiliate_location_id',
					$elm$json$Json$Encode$string(affiliateLocationId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId))));
	});
var $author$project$Api$Provider$Affiliates$Practitioner$link = F6(
	function (apiClient, affiliateId, affiliatePractitionerId, networkPractitionerId, syncToRentalNetworks, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'network_practitioner_id',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, networkPractitionerId)),
					_Utils_Tuple2(
					'affiliate_practitioner_id',
					$elm$json$Json$Encode$string(affiliatePractitionerId)),
					_Utils_Tuple2(
					'sync_to_rental_networks',
					$elm$json$Json$Encode$bool(syncToRentalNetworks))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId))));
	});
var $author$project$Api$Provider$Affiliates$AffiliateLocation$affiliateLocationsPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_locations']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$AffiliateLocation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$AffiliateLocation = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$Min$Record)));
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$AffiliateLocation$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$Record = function (synced) {
	return {$k: synced};
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'synced',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$All$Record));
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$AffiliateLocation$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Affiliates$AffiliateLocation$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$All$AffiliateLocation)));
var $author$project$Api$Provider$Affiliates$AffiliateLocation$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$AffiliateLocation$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$AffiliateLocation$affiliateLocationsPath(affiliateId)));
	});
var $author$project$Api$Provider$Affiliates$AffiliatePractitioner$affiliatePractitionersPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_practitioners']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Practitioner$Affiliate$Practitioner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practitioner$Affiliate$Record = function (synced) {
	return {$k: synced};
};
var $author$project$Api$Provider$Practitioner$Affiliate$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'synced',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Affiliate$Record));
var $author$project$Api$Provider$Practitioner$Affiliate$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Practitioner$Affiliate$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Practitioner$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Affiliate$Practitioner)));
var $author$project$Api$Provider$Affiliates$AffiliatePractitioner$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$Affiliate$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$AffiliatePractitioner$affiliatePractitionersPath(affiliateId)));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$update = F4(
	function (apiClient, msg, model, userIsHinter) {
		switch (msg.$) {
			case 0:
				var affiliateId = msg.a;
				var resource = msg.b;
				var form = $author$project$Utils$Form$init(
					$author$project$Components$Affiliates$LinkRecordsModal$initFormFields(userIsHinter));
				return {
					EC: function () {
						if (!resource) {
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Api$Provider$Affiliates$AffiliatePractitioner$list, apiClient, affiliateId, $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliatePractitioners),
										A3($author$project$Api$Provider$Practitioner$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkPractitioners)
									]));
						} else {
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Api$Provider$Affiliates$AffiliateLocation$list, apiClient, affiliateId, $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliateLocations),
										A3($author$project$Api$Provider$Location$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkLocations)
									]));
						}
					}(),
					ac5: 0,
					y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
						{pp: affiliateId, pq: $author$project$Api$Data$Loading, pr: $author$project$Api$Data$Loading, PB: form, rt: $author$project$Api$Data$Loading, rv: $author$project$Api$Data$Loading, G0: resource, jY: $author$project$Api$Data$NotAsked, HN: userIsHinter}),
					as: _List_Nil
				};
			case 1:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{pr: response})),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed, as: _List_Nil};
				}
			case 2:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{pq: response})),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed, as: _List_Nil};
				}
			case 3:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{rv: response})),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed, as: _List_Nil};
				}
			case 4:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{rt: response})),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed, as: _List_Nil};
				}
			case 5:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed, as: _List_Nil};
			case 6:
				var field = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Affiliates$LinkRecordsModal$formFieldsUpdate(openModel),
						field,
						openModel.PB);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
							_Utils_update(
								openModel,
								{PB: newForm})),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed, as: _List_Nil};
				}
			case 7:
				if (model.$ === 1) {
					var openModel = model.a;
					var _v8 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$Affiliates$LinkRecordsModal$formFieldsValidator(openModel.G0),
						openModel.PB);
					if (!_v8.$) {
						var _v9 = _v8.a;
						var newForm = _v9.a;
						var validFormFields = _v9.b;
						var cmd = function () {
							var _v10 = openModel.G0;
							if (!_v10) {
								var _v11 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
								var affiliatePractitioner = _v11.IG;
								var networkPractitioner = _v11.ru;
								var syncToRentalNetworks = _v11.ta;
								return A6(
									$author$project$Api$Provider$Affiliates$Practitioner$link,
									apiClient,
									openModel.pp,
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Affiliate$id, affiliatePractitioner)),
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$All$id, networkPractitioner),
									syncToRentalNetworks,
									$author$project$Components$Affiliates$LinkRecordsModal$Linked);
							} else {
								var _v12 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
								var affiliateLocation = _v12.ID;
								var networkLocation = _v12.rs;
								return A5(
									$author$project$Api$Provider$Affiliates$Location$link,
									apiClient,
									openModel.pp,
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id, affiliateLocation)),
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, networkLocation),
									$author$project$Components$Affiliates$LinkRecordsModal$Linked);
							}
						}();
						return {
							EC: cmd,
							ac5: 0,
							y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
								_Utils_update(
									openModel,
									{PB: newForm, jY: $author$project$Api$Data$Loading})),
							as: _List_Nil
						};
					} else {
						var newForm = _v8.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
								_Utils_update(
									openModel,
									{PB: newForm})),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed, as: _List_Nil};
				}
			default:
				var response = msg.a;
				if (model.$ === 1) {
					var openModel = model.a;
					switch (response.$) {
						case 3:
							var _v15 = function () {
								var _v16 = openModel.G0;
								if (!_v16) {
									return _Utils_Tuple2('Practitioner linked!', 1);
								} else {
									return _Utils_Tuple2('Location linked!', 2);
								}
							}();
							var message = _v15.a;
							var event = _v15.b;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: event,
								y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, message),
										$author$project$OutMsg$RefreshPractice
									])
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$Affiliates$LinkRecordsModal$Open(
									_Utils_update(
										openModel,
										{jY: response})),
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$LinkRecordsModal$Closed, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Affiliates$SyncPatientsModal$Activated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$SyncPatientsModal$ActivationSkiped = 3;
var $author$project$Components$Affiliates$SyncPatientsModal$AffiliateActivated = 2;
var $author$project$Components$Affiliates$SyncPatientsModal$Closed = 1;
var $author$project$Components$Affiliates$SyncPatientsModal$None = 0;
var $author$project$Api$Provider$Affiliate$activate = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Affiliate$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['activate']),
					$author$project$Api$Provider$Affiliate$affiliatePath(id_))));
	});
var $author$project$Components$Affiliates$SyncPatientsModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				var action = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{DV: action}),
					as: _List_Nil
				};
			case 2:
				var _v1 = function () {
					var _v2 = model.DV;
					if (!_v2) {
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							A3($author$project$Api$Provider$Affiliate$activate, apiClient, model.pp, $author$project$Components$Affiliates$SyncPatientsModal$Activated),
							0);
					} else {
						return _Utils_Tuple3(model.kO, $elm$core$Platform$Cmd$none, 3);
					}
				}();
				var activateRequest = _v1.a;
				var cmd = _v1.b;
				var event = _v1.c;
				return {
					EC: cmd,
					ac5: event,
					y8: _Utils_update(
						model,
						{kO: activateRequest}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sync synccessful')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{kO: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$LocationUnlinked = 2;
var $author$project$Components$Affiliates$UnlinkRecordsModal$None = 0;
var $author$project$Components$Affiliates$UnlinkRecordsModal$Open = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$PractitionerUnlinked = 1;
var $author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation = {$: 3};
var $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner = {$: 1};
var $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Affiliates$Location$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Affiliates$Location$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Affiliates$Location$Min$id(min);
};
var $author$project$Api$Provider$Affiliates$Practitioner$All$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$isValid = function (action) {
	switch (action.$) {
		case 0:
			var newPractitioner = action.b;
			return $author$project$Utils$Maybe$toBool(newPractitioner);
		case 2:
			var newLocation = action.b;
			return $author$project$Utils$Maybe$toBool(newLocation);
		case 1:
			return true;
		default:
			return true;
	}
};
var $author$project$Api$Provider$Affiliates$Location$locationPath = F2(
	function (affiliateId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId));
	});
var $author$project$Api$Provider$Affiliates$Location$unlink = F5(
	function (apiClient, affiliateId, id, reassignToId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			function () {
				if (!reassignToId.$) {
					var reassignToId_ = reassignToId.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'reassign_to_id',
							$elm$json$Json$Encode$string(reassignToId_))
						]);
				} else {
					return _List_Nil;
				}
			}());
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unlink']),
						A2($author$project$Api$Provider$Affiliates$Location$locationPath, affiliateId, id)))));
	});
var $author$project$Api$Provider$Affiliates$Practitioner$practitionerPath = F2(
	function (affiliateId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId));
	});
var $author$project$Api$Provider$Affiliates$Practitioner$unlink = F5(
	function (apiClient, affiliateId, id, reassignToId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			function () {
				if (!reassignToId.$) {
					var reassignToId_ = reassignToId.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'reassign_to_id',
							$elm$json$Json$Encode$string(reassignToId_))
						]);
				} else {
					return _List_Nil;
				}
			}());
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unlink']),
						A2($author$project$Api$Provider$Affiliates$Practitioner$practitionerPath, affiliateId, id)))));
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var affiliateId = msg.a;
				var resource = msg.b;
				var action = function () {
					if (!resource.$) {
						var remainingPractitioners = resource.b;
						return $elm$core$List$isEmpty(remainingPractitioners) ? $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner : A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, $elm$core$Maybe$Nothing);
					} else {
						var remainingLocations = resource.b;
						return $elm$core$List$isEmpty(remainingLocations) ? $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation : A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, $elm$core$Maybe$Nothing);
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$NotAsked),
					as: _List_Nil
				};
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, as: _List_Nil};
			case 3:
				var action = msg.a;
				if (model.$ === 1) {
					var practitioner = model.a;
					var remainingPractitioners = model.b;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, practitioner, remainingPractitioners, action, $author$project$Api$Data$NotAsked),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, as: _List_Nil};
				}
			case 5:
				var id = msg.a;
				if (model.$ === 1) {
					var affiliateId = model.a;
					var resource = model.b;
					var action = model.c;
					var response = model.d;
					switch (action.$) {
						case 0:
							var remainingPractitioners = action.a;
							var newPractitioner = A2(
								$elm_community$list_extra$List$Extra$find,
								function (practitioner_) {
									return _Utils_eq(
										id,
										$author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner_));
								},
								remainingPractitioners);
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: A4(
									$author$project$Components$Affiliates$UnlinkRecordsModal$Open,
									affiliateId,
									resource,
									A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, newPractitioner),
									response),
								as: _List_Nil
							};
						case 2:
							var remainingLocations = action.a;
							var newLocation = A2(
								$elm_community$list_extra$List$Extra$find,
								function (location) {
									return _Utils_eq(
										id,
										$author$project$Api$Provider$Affiliates$Location$All$id(location));
								},
								remainingLocations);
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: A4(
									$author$project$Components$Affiliates$UnlinkRecordsModal$Open,
									affiliateId,
									resource,
									A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, newLocation),
									response),
								as: _List_Nil
							};
						case 1:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner, response),
								as: _List_Nil
							};
						default:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation, response),
								as: _List_Nil
							};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, as: _List_Nil};
				}
			case 2:
				if (model.$ === 1) {
					var affiliateId = model.a;
					var resource = model.b;
					var action = model.c;
					if ($author$project$Components$Affiliates$UnlinkRecordsModal$isValid(action)) {
						var id = function () {
							if (!resource.$) {
								var practitioner = resource.a;
								return $author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner);
							} else {
								var location = resource.a;
								return $author$project$Api$Provider$Affiliates$Location$All$id(location);
							}
						}();
						var cmd = function () {
							switch (action.$) {
								case 0:
									var newPractitioner_ = action.b;
									return A5(
										$author$project$Api$Provider$Affiliates$Practitioner$unlink,
										apiClient,
										affiliateId,
										id,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Practitioner$All$id, newPractitioner_),
										$author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
								case 2:
									var newLocation_ = action.b;
									return A5(
										$author$project$Api$Provider$Affiliates$Location$unlink,
										apiClient,
										affiliateId,
										id,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Location$All$id, newLocation_),
										$author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
								case 1:
									return A5($author$project$Api$Provider$Affiliates$Practitioner$unlink, apiClient, affiliateId, id, $elm$core$Maybe$Nothing, $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
								default:
									return A5($author$project$Api$Provider$Affiliates$Location$unlink, apiClient, affiliateId, id, $elm$core$Maybe$Nothing, $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
							}
						}();
						return {
							EC: cmd,
							ac5: 0,
							y8: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$Loading),
							as: _List_Nil
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$NotAsked),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, as: _List_Nil};
				}
			default:
				var response = msg.a;
				if (model.$ === 1) {
					var affiliateId = model.a;
					var resource = model.b;
					var action = model.c;
					switch (response.$) {
						case 3:
							var _v10 = function () {
								if (!resource.$) {
									return _Utils_Tuple2('Practitioner unlinked!', 1);
								} else {
									return _Utils_Tuple2('Location unlinked!', 2);
								}
							}();
							var message = _v10.a;
							var event = _v10.b;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: event,
								y8: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed,
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, message),
										$author$project$OutMsg$RefreshPractice
									])
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, response),
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed, as: _List_Nil};
				}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WQ: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var unlinkRecordsModalResutl = A3($author$project$Components$Affiliates$UnlinkRecordsModal$update, model.D5, subMsg, model.oX);
				var _v1 = function () {
					var _v2 = unlinkRecordsModalResutl.ac5;
					switch (_v2) {
						case 0:
							return _Utils_Tuple3(model.WQ, model.S4, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple3(
								$author$project$Api$Data$Loading,
								model.S4,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model));
						default:
							return _Utils_Tuple3(
								model.WQ,
								$author$project$Api$Data$Loading,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model));
					}
				}();
				var practitioners = _v1.a;
				var locations = _v1.b;
				var cmd = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S4: locations, WQ: practitioners, oX: unlinkRecordsModalResutl.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg, unlinkRecordsModalResutl.EC),
								cmd
							])),
					unlinkRecordsModalResutl.as);
			case 3:
				var subMsg = msg.a;
				var linkRecordsModalResutl = A4($author$project$Components$Affiliates$LinkRecordsModal$update, model.D5, subMsg, model.mR, model.HN);
				var _v3 = function () {
					var _v4 = linkRecordsModalResutl.ac5;
					switch (_v4) {
						case 0:
							return _Utils_Tuple3(model.WQ, model.S4, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple3(
								$author$project$Api$Data$Loading,
								model.S4,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model));
						default:
							return _Utils_Tuple3(
								model.WQ,
								$author$project$Api$Data$Loading,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model));
					}
				}();
				var practitioners = _v3.a;
				var locations = _v3.b;
				var cmd = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mR: linkRecordsModalResutl.y8, S4: locations, WQ: practitioners}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg, linkRecordsModalResutl.EC),
								cmd
							])),
					linkRecordsModalResutl.as);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ko: $elm$core$Maybe$Just(
								$author$project$Components$Affiliates$SyncPatientsModal$init(model.pp))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v5 = model.ko;
				if (!_v5.$) {
					var syncPatientsModal = _v5.a;
					var syncPatientsModalResutl = A3($author$project$Components$Affiliates$SyncPatientsModal$update, model.D5, subMsg, syncPatientsModal);
					var _v6 = function () {
						var _v7 = syncPatientsModalResutl.ac5;
						switch (_v7) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(syncPatientsModalResutl.y8),
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							case 3:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
											{pp: model.pp})));
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
											{pp: model.pp})));
						}
					}();
					var syncPatientsModal_ = _v6.a;
					var cmd = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ko: syncPatientsModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg, syncPatientsModalResutl.EC),
									cmd
								])),
						syncPatientsModalResutl.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var cmd = A3($author$project$Api$Provider$Affiliate$linkAllProviders, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkedAllProviders);
				return _Utils_Tuple3(model, cmd, _List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'A job has been queued to link all providers, and an email will be sent to you when it\'s complete.'),
									$author$project$OutMsg$RefreshPractice
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatients = {$: 4};
var $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$Link = {$: 7};
var $author$project$Components$Affiliates$LinkRecordsModal$SyncToRentalNetworks = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$resourceName = function (resource) {
	if (!resource) {
		return 'provider';
	} else {
		return 'location';
	}
};
var $author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitioner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$name(min);
};
var $author$project$Api$Provider$Practitioner$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Practitioner$Affiliate$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Practitioner$Min$name(min);
};
var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$synced = function (_v0) {
	var record = _v0.b;
	return record.$k;
};
var $author$project$Api$Provider$Practitioner$Affiliate$synced = function (_v0) {
	var record = _v0.b;
	return record.$k;
};
var $author$project$Components$Affiliates$LinkRecordsModal$affiliateRecordOptions = F3(
	function (resource, practitioners, locations) {
		var affiliateRecords = function () {
			if (!resource) {
				return A2(
					$elm$core$List$map,
					function (practitioner) {
						return {
							adR: $author$project$Api$Provider$Practitioner$Affiliate$id(practitioner),
							Sa: A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practitioner$Affiliate$synced, $author$project$Utils$Maybe$toBool)(practitioner),
							zh: $author$project$Api$Provider$Practitioner$Affiliate$name(practitioner)
						};
					},
					practitioners);
			} else {
				return A2(
					$elm$core$List$map,
					function (location) {
						return {
							adR: $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id(location),
							Sa: A2($elm$core$Basics$composeR, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$synced, $author$project$Utils$Maybe$toBool)(location),
							zh: $author$project$Api$Provider$Affiliates$AffiliateLocation$All$name(location)
						};
					},
					locations);
			}
		}();
		var notSynced = A2(
			$elm_community$list_extra$List$Extra$filterNot,
			function ($) {
				return $.Sa;
			},
			affiliateRecords);
		var sortedNotSynced = function () {
			if (resource === 1) {
				return A2(
					$elm$core$List$sortBy,
					function (record) {
						return $elm$core$String$toLower(record.zh);
					},
					notSynced);
			} else {
				return notSynced;
			}
		}();
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Choose a ' + ($author$project$Components$Affiliates$LinkRecordsModal$resourceName(resource) + '...')),
			A2(
				$elm$core$List$map,
				function (affiliateRecord) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(affiliateRecord.adR),
						affiliateRecord.zh);
				},
				sortedNotSynced));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$viewAffiliateRecordSelect = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var _v0 = function () {
		var _v1 = _Utils_Tuple3(model.G0, model.pr, model.pq);
		if (!_v1.a) {
			if (_v1.b.$ === 3) {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				var list = _v3.a;
				return _Utils_Tuple3(false, list, _List_Nil);
			} else {
				var _v4 = _v1.a;
				return _Utils_Tuple3(true, _List_Nil, _List_Nil);
			}
		} else {
			if (_v1.c.$ === 3) {
				var _v5 = _v1.a;
				var _v6 = _v1.c;
				var list = _v6.a;
				return _Utils_Tuple3(false, _List_Nil, list);
			} else {
				var _v7 = _v1.a;
				return _Utils_Tuple3(true, _List_Nil, _List_Nil);
			}
		}
	}();
	var loading = _v0.a;
	var practitioners_ = _v0.b;
	var locations_ = _v0.c;
	var selectOptions = A3($author$project$Components$Affiliates$LinkRecordsModal$affiliateRecordOptions, model.G0, practitioners_, locations_);
	var _v8 = function () {
		var _v9 = model.G0;
		if (!_v9) {
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Affiliate$id, fields.IG),
				$author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitioner);
		} else {
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id, fields.ID),
				$author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocation);
		}
	}();
	var id = _v8.a;
	var field = _v8.b;
	var _v10 = function () {
		var _v11 = model.G0;
		if (!_v11) {
			return _Utils_Tuple2(
				A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB),
				A2($author$project$Utils$Form$validationErrors, 0, model.PB));
		} else {
			return _Utils_Tuple2(
				A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB),
				A2($author$project$Utils$Form$validationErrors, 1, model.PB));
		}
	}();
	var invalid = _v10.a;
	var errors = _v10.b;
	return ((!loading) && ($elm$core$List$length(selectOptions) === 1)) ? A2(
		$author$project$Ui$Alert$warning,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('No more affiliate '),
				$elm$html$Html$text(
				$author$project$Components$Affiliates$LinkRecordsModal$resourceName(model.G0)),
				$elm$html$Html$text('s')
			])) : A2(
		$author$project$Ui$Form$Select$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Select$value(id),
				$author$project$Ui$Form$Select$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, field)),
				$author$project$Ui$Form$Select$invalid(invalid),
				$author$project$Ui$Form$Select$errors(errors),
				$author$project$Ui$Form$Select$loading(loading)
			]),
		selectOptions);
};
var $author$project$Components$Affiliates$LinkRecordsModal$NetworkLocation = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$NetworkLocationValidation = 3;
var $author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitioner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitionerValidation = 2;
var $author$project$Components$Affiliates$LinkRecordsModal$networkRecordOptions = F3(
	function (resource, practitioners, locations) {
		var networkRecords = function () {
			if (!resource) {
				return A2(
					$elm$core$List$map,
					function (practitioner) {
						return {
							adR: $author$project$Api$Provider$Practitioner$All$id(practitioner),
							Sa: $author$project$Api$Provider$Practitioner$All$isSynced(practitioner),
							zh: $author$project$Api$Provider$Practitioner$All$name(practitioner)
						};
					},
					practitioners);
			} else {
				return A2(
					$elm$core$List$map,
					function (location) {
						return {
							adR: $author$project$Api$Provider$Location$All$id(location),
							Sa: $author$project$Api$Provider$Location$All$isSynced(location),
							zh: $author$project$Api$Provider$Location$All$name(location)
						};
					},
					locations);
			}
		}();
		var notSynced = A2(
			$elm_community$list_extra$List$Extra$filterNot,
			function ($) {
				return $.Sa;
			},
			networkRecords);
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Create new network ' + $author$project$Components$Affiliates$LinkRecordsModal$resourceName(resource)),
			A2(
				$elm$core$List$map,
				function (networkRecord) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(networkRecord.adR),
						networkRecord.zh);
				},
				notSynced));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$viewNetworkRecordSelect = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var _v0 = function () {
		var _v1 = _Utils_Tuple3(model.G0, model.rv, model.rt);
		if (!_v1.a) {
			if (_v1.b.$ === 3) {
				var _v2 = _v1.a;
				var _v3 = _v1.b;
				var list = _v3.a;
				return _Utils_Tuple3(false, list, _List_Nil);
			} else {
				var _v4 = _v1.a;
				return _Utils_Tuple3(true, _List_Nil, _List_Nil);
			}
		} else {
			if (_v1.c.$ === 3) {
				var _v5 = _v1.a;
				var _v6 = _v1.c;
				var list = _v6.a;
				return _Utils_Tuple3(false, _List_Nil, list);
			} else {
				var _v7 = _v1.a;
				return _Utils_Tuple3(true, _List_Nil, _List_Nil);
			}
		}
	}();
	var loading = _v0.a;
	var practitioners_ = _v0.b;
	var locations_ = _v0.c;
	var selectOptions = A3($author$project$Components$Affiliates$LinkRecordsModal$networkRecordOptions, model.G0, practitioners_, locations_);
	var _v8 = function () {
		var _v9 = model.G0;
		if (!_v9) {
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$All$id, fields.ru),
				$author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitioner);
		} else {
			return _Utils_Tuple2(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, fields.rs),
				$author$project$Components$Affiliates$LinkRecordsModal$NetworkLocation);
		}
	}();
	var id = _v8.a;
	var field = _v8.b;
	var _v10 = function () {
		var _v11 = model.G0;
		if (!_v11) {
			return _Utils_Tuple2(
				A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB),
				A2($author$project$Utils$Form$validationErrors, 2, model.PB));
		} else {
			return _Utils_Tuple2(
				A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB),
				A2($author$project$Utils$Form$validationErrors, 3, model.PB));
		}
	}();
	var invalid = _v10.a;
	var errors = _v10.b;
	return A2(
		$author$project$Ui$Form$Select$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Select$value(id),
				$author$project$Ui$Form$Select$onChange(
				A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, field)),
				$author$project$Ui$Form$Select$invalid(invalid),
				$author$project$Ui$Form$Select$errors(errors),
				$author$project$Ui$Form$Select$loading(loading)
			]),
		selectOptions);
};
var $author$project$Components$Affiliates$LinkRecordsModal$viewModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var showNetworkRecordSelect = function () {
		var _v3 = model.G0;
		if (!_v3) {
			return $author$project$Utils$Maybe$toBool(fields.IG);
		} else {
			return $author$project$Utils$Maybe$toBool(fields.ID);
		}
	}();
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Affiliates$LinkRecordsModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						'Link affiliate\'s ' + $author$project$Components$Affiliates$LinkRecordsModal$resourceName(model.G0))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label(
								function () {
									var _v0 = model.G0;
									if (!_v0) {
										return 'Affiliate Provider\'s Name';
									} else {
										return 'Affiliate Location\'s Name';
									}
								}()),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								$author$project$Components$Affiliates$LinkRecordsModal$viewAffiliateRecordSelect(model)
							])),
						showNetworkRecordSelect ? A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label(
								function () {
									var _v1 = model.G0;
									if (!_v1) {
										return 'Network Provider\'s Name';
									} else {
										return 'Network Location\'s Name';
									}
								}()),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								$author$project$Components$Affiliates$LinkRecordsModal$viewNetworkRecordSelect(model)
							])) : $author$project$Utils$Html$empty,
						function () {
						if (model.HN) {
							var _v2 = model.G0;
							if (!_v2) {
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8),
											$author$project$Ui$Form$Group$clearfix,
											$author$project$Ui$Form$Group$label('')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Checkbox$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Checkbox$value(fields.ta),
													$author$project$Ui$Form$Checkbox$onCheck(
													A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, $author$project$Components$Affiliates$LinkRecordsModal$SyncToRentalNetworks))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sync to all rental networks')
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Affiliates$LinkRecordsModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Save'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Affiliates$LinkRecordsModal$Link),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Affiliates$LinkRecordsModal$modal = function (model) {
	if (model.$ === 1) {
		var openModel = model.a;
		return $author$project$Components$Affiliates$LinkRecordsModal$viewModal(openModel);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$Unlink = {$: 2};
var $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Affiliates$Location$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Affiliates$Location$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Affiliates$Location$Min$name(min);
};
var $author$project$Api$Provider$Affiliates$Practitioner$All$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateNewPractitioner = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$locationOptions = function (locations) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a location...'),
		A2(
			$elm$core$List$map,
			function (location) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Affiliates$Location$All$id(location)),
					$author$project$Api$Provider$Affiliates$Location$All$name(location));
			},
			locations));
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$practitionerOptions = function (practitioners) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a practitioner...'),
		A2(
			$elm$core$List$map,
			function (practitioner) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner)),
					$author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner));
			},
			practitioners));
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$reassignOptions = function (resource) {
	if (!resource.$) {
		var remainingPractitioners = resource.b;
		return $author$project$Components$Affiliates$UnlinkRecordsModal$practitionerOptions(remainingPractitioners);
	} else {
		var remainingLocations = resource.b;
		return $author$project$Components$Affiliates$UnlinkRecordsModal$locationOptions(remainingLocations);
	}
};
var $author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect = F3(
	function (resource, id, invalid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pt-05')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(id),
							$author$project$Ui$Form$Select$onChange($author$project$Components$Affiliates$UnlinkRecordsModal$UpdateNewPractitioner),
							$author$project$Ui$Form$Select$invalid(invalid),
							$author$project$Ui$Form$Select$errors(
							function () {
								if (invalid) {
									var resourceName = function () {
										if (!resource.$) {
											return 'provider';
										} else {
											return 'location';
										}
									}();
									return _List_fromArray(
										['Please pick a ' + (resourceName + ' for reassignment')]);
								} else {
									return _List_Nil;
								}
							}())
						]),
					$author$project$Components$Affiliates$UnlinkRecordsModal$reassignOptions(resource))
				]));
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$viewModal = F3(
	function (resource, action, request) {
		var _v0 = function () {
			switch (action.$) {
				case 0:
					return _Utils_Tuple2(true, false);
				case 2:
					return _Utils_Tuple2(true, false);
				case 1:
					return _Utils_Tuple2(false, true);
				default:
					return _Utils_Tuple2(false, true);
			}
		}();
		var reassignActive = _v0.a;
		var terminateActive = _v0.b;
		var _v2 = function () {
			if (!resource.$) {
				var practitioner = resource.a;
				var remainingPractitioners = resource.b;
				return _Utils_Tuple2(
					$author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner),
					$elm$core$List$isEmpty(remainingPractitioners));
			} else {
				var location = resource.a;
				var remainingLocations = resource.b;
				return _Utils_Tuple2(
					$author$project$Api$Provider$Affiliates$Location$All$name(location),
					$elm$core$List$isEmpty(remainingLocations));
			}
		}();
		var name = _v2.a;
		var remainingResourcesEmpty = _v2.b;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('What would you like to do with ' + (name + '\'s patients?'))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(
									function () {
										if (!resource.$) {
											return 'Provider';
										} else {
											return 'Location';
										}
									}()),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(name)
												]))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Action'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8)
								]),
							_List_fromArray(
								[
									function () {
									var terminateAction = function () {
										if (!resource.$) {
											return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction($author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner);
										} else {
											return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction($author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation);
										}
									}();
									var reassignAction = function () {
										if (!resource.$) {
											var remainingPractitioners = resource.b;
											return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction(
												A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, $elm$core$Maybe$Nothing));
										} else {
											var remainingLocations = resource.b;
											return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction(
												A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, $elm$core$Maybe$Nothing));
										}
									}();
									var _v5 = function () {
										if (!resource.$) {
											return _Utils_Tuple2('Terminate', 'Provider');
										} else {
											return _Utils_Tuple2('Remove', 'Location');
										}
									}();
									var terminationVerb = _v5.a;
									var resourceName = _v5.b;
									return $author$project$Ui$Button$group(
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Reassign ' + resourceName},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(reassignActive),
														$author$project$Ui$Button$disabled(remainingResourcesEmpty),
														$author$project$Ui$Button$onClick(reassignAction)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Reassign')
													])),
												A3(
												$author$project$Ui$Button$view,
												{abp: terminationVerb + (' ' + resourceName)},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(terminateActive),
														$author$project$Ui$Button$onClick(terminateAction)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(terminationVerb)
													]))
											]));
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pt-05')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													function () {
													switch (action.$) {
														case 0:
															return $elm$html$Html$text('All patients will be switched to a different provider.');
														case 1:
															return $elm$html$Html$text('All affiliate memberships will be terminated. Your memberships are not affected.');
														case 2:
															return $elm$html$Html$text('All patients will be switched to a new location.');
														default:
															return $elm$html$Html$text('This location will be removed from all patients. The primary care clinic will not be removed.');
													}
												}()
												]))
										])),
									function () {
									switch (action.$) {
										case 0:
											var newPractitioner = action.b;
											var newPractitionerInvalid = !$author$project$Utils$Maybe$toBool(newPractitioner);
											return A3(
												$author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect,
												resource,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Practitioner$All$id, newPractitioner),
												newPractitionerInvalid);
										case 2:
											var newLocation = action.b;
											var newLocationInvalid = !$author$project$Utils$Maybe$toBool(newLocation);
											return A3(
												$author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect,
												resource,
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Location$All$id, newLocation),
												newLocationInvalid);
										case 1:
											return $author$project$Utils$Html$empty;
										default:
											return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Unlink'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Affiliates$UnlinkRecordsModal$Unlink),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Unlink')
								]))
						]))
				]));
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$modal = function (model) {
	if (model.$ === 1) {
		var resource = model.b;
		var action = model.c;
		var request = model.d;
		return A3($author$project$Components$Affiliates$UnlinkRecordsModal$viewModal, resource, action, request);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$Network$Shared$syncByAffiliation = function (_v0) {
	var record = _v0;
	return record.$f;
};
var $author$project$Components$Affiliates$SyncPatientsModal$Activate = 0;
var $author$project$Components$Affiliates$SyncPatientsModal$Save = {$: 2};
var $author$project$Components$Affiliates$SyncPatientsModal$UpdateAction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$SyncPatientsModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Affiliates$SyncPatientsModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Patients Syncing')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Patients Syncing'),
								$author$project$Ui$Form$Group$labelSpan(3),
								$author$project$Ui$Form$Group$inputSpan(9)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Radio$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Radio$value(model.DV === 1),
												$author$project$Ui$Form$Radio$onCheck(
												$elm$core$Basics$always(
													$author$project$Components$Affiliates$SyncPatientsModal$UpdateAction(1)))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Pend the Affiliation (recommended)')
													])),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														$elm$html$Html$text('Syncing will be turned on at a later date')
													]))
											]))
									])),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Radio$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Radio$value(!model.DV),
												$author$project$Ui$Form$Radio$onCheck(
												$elm$core$Basics$always(
													$author$project$Components$Affiliates$SyncPatientsModal$UpdateAction(0)))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Activate the Affiliation')
													])),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														$elm$html$Html$text('Patients will begin syncing immediately')
													]))
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$SyncPatientsModal$CloseModal)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Confirm patient sync'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.kO, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$SyncPatientsModal$Save),
												$author$project$Ui$Button$fullWidth(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Affiliates$LinkRecordsModal$Location = 1;
var $author$project$Components$Affiliates$LinkRecordsModal$OpenModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Affiliates$LinkRecordsModal$button_ = F3(
	function (affiliateId, resource, options) {
		var label = 'Add ' + function () {
			if (!resource) {
				return 'provider';
			} else {
				return 'location';
			}
		}();
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_Utils_ap(
				options,
				_List_fromArray(
					[
						$author$project$Ui$Button$styled(0),
						$author$project$Ui$Button$onClick(
						A2($author$project$Components$Affiliates$LinkRecordsModal$OpenModal, affiliateId, resource))
					])),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Affiliates$LinkRecordsModal$buttonSm = F2(
	function (affiliateId, resource) {
		return A3(
			$author$project$Components$Affiliates$LinkRecordsModal$button_,
			affiliateId,
			resource,
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
				]));
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$Location = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$Location$All$affiliateLocation = function (_v0) {
	var record = _v0.b;
	return record.ID;
};
var $author$project$Ui$SvgIcon$ArrowRight = 56;
var $author$project$Ui$SvgIcon$arrowRight = $author$project$Ui$SvgIcon$viewIcon(56);
var $author$project$Components$Affiliates$UnlinkRecordsModal$OpenModal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Affiliates$UnlinkRecordsModal$button = F2(
	function (affiliateId, resource) {
		var resourceName = function () {
			if (!resource.$) {
				return 'provider';
			} else {
				return 'location';
			}
		}();
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Unlink ' + resourceName},
			_List_fromArray(
				[
					$author$project$Ui$Button$size(0),
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick(
					A2($author$project$Components$Affiliates$UnlinkRecordsModal$OpenModal, affiliateId, resource)),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unlink')
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocation = F3(
	function (model, locations, location) {
		var remainingLocations = A2(
			$elm$core$List$filter,
			function (remainingLocation) {
				return !_Utils_eq(
					$author$project$Api$Provider$Affiliates$Location$All$id(location),
					$author$project$Api$Provider$Affiliates$Location$All$id(remainingLocation));
			},
			locations);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$padding(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Network: '),
									A2(
									$author$project$Ui$Typography$b,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(2)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Affiliates$Location$All$name(location))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$arrowRight(_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$padding(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Affiliate: '),
									A2(
									$author$project$Ui$Typography$b,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(2)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Location$Min$name(
												$author$project$Api$Provider$Affiliates$Location$All$affiliateLocation(location)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg,
							A2(
								$author$project$Components$Affiliates$UnlinkRecordsModal$button,
								model.pp,
								A2($author$project$Components$Affiliates$UnlinkRecordsModal$Location, location, remainingLocations)))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocationsTable = function (model) {
	var _v0 = function () {
		var _v1 = model.S4;
		if (_v1.$ === 3) {
			var locations_ = _v1.a;
			return _Utils_Tuple2(false, locations_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var locations = _v0.b;
	return _List_fromArray(
		[
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Locations')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create links between affiliate\'s locations and your network.')
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(loading),
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No linked locations.')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(5)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_Nil)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocation, model, locations),
				locations),
			_List_Nil),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg,
							A2($author$project$Components$Affiliates$LinkRecordsModal$buttonSm, model.pp, 1))
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text('You can add locations to your network from the affiliate\'s account.')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkAllProviders = {$: 6};
var $author$project$Components$Affiliates$LinkRecordsModal$Practitioner = 0;
var $author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner = function (_v0) {
	var record = _v0;
	return record.IG;
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitioner = F3(
	function (model, practitioners, practitioner) {
		var remainingPractitioners = A2(
			$elm$core$List$filter,
			function (remainingPractitioner) {
				return !_Utils_eq(
					$author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner),
					$author$project$Api$Provider$Affiliates$Practitioner$All$id(remainingPractitioner));
			},
			practitioners);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$padding(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Network: '),
									A2(
									$author$project$Ui$Typography$b,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(2)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$arrowRight(_List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$padding(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Affiliate: '),
									A2(
									$author$project$Ui$Typography$b,
									_List_fromArray(
										[
											$author$project$Ui$Typography$padding(2)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Practitioner$Min$name(
												$author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner(practitioner)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg,
							A2(
								$author$project$Components$Affiliates$UnlinkRecordsModal$button,
								model.pp,
								A2($author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner, practitioner, remainingPractitioners)))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitionersTable = function (model) {
	var isHinter = A2($author$project$Utils$User$isViewingAsHinter, model.ZD, model.adN);
	var _v0 = function () {
		var _v1 = model.WQ;
		if (_v1.$ === 3) {
			var practitioners_ = _v1.a;
			return _Utils_Tuple2(false, practitioners_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var practitioners = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Link Providers')
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create links between affiliate\'s providers and your network.')
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(loading),
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No linked providers.')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(5)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(1)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_Nil)
				]),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitioner, model, practitioners),
				practitioners),
			_List_Nil),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg,
							A2($author$project$Components$Affiliates$LinkRecordsModal$buttonSm, model.pp, 0))
						])),
					isHinter ? A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$HinterOnly$button,
							{abp: 'Add all providers'},
							_List_fromArray(
								[
									$author$project$Ui$Button$styled(0),
									$author$project$Ui$Button$size(0),
									$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkAllProviders)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add all providers')
								]))
						])) : A2($author$project$Ui$FlexGrid$column, _List_Nil, _List_Nil)
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text('You can add providers to your network from the affiliate\'s account.')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$view = function (model) {
	var network = $author$project$Api$Provider$Practice$One$network(model.WF);
	var syncByAffiliation = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network));
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg,
				$author$project$Components$Affiliates$UnlinkRecordsModal$modal(model.oX)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg,
				$author$project$Components$Affiliates$LinkRecordsModal$modal(model.mR)),
				function () {
				var _v0 = model.ko;
				if (!_v0.$) {
					var syncPatientsModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg,
						$author$project$Components$Affiliates$SyncPatientsModal$view(syncPatientsModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Manage affiliates')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__New,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Add new affiliate')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__New,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Create Affiliation')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													syncByAffiliation ? $elm$html$Html$text('Link Providers & Locations') : $elm$html$Html$text('Link Providers')
												]))
										]))),
							_Utils_ap(
								$author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitionersTable(model),
								syncByAffiliation ? $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocationsTable(model) : _List_Nil))),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								function () {
								var label = syncByAffiliation ? 'Link providers & locations' : 'Finish';
								return A3(
									$author$project$Ui$Button$view,
									{abp: label},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatients)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										]));
							}()
							]))
					]))
			]),
		$G: 'Affiliates'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$init, aer: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$load, agD: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$save, ahd: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$subscriptions, aaq: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$update, ahP: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$view});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotLocations = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Location$list, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotLocations);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotPractitioners = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Practitioner$list, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotPractitioners);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var params = _v1.Vx;
		var model = {
			pp: params.pp,
			D5: apiClient,
			mR: $author$project$Components$Affiliates$LinkRecordsModal$init,
			S4: $author$project$Api$Data$Loading,
			WF: practice,
			WQ: $author$project$Api$Data$Loading,
			oX: $author$project$Components$Affiliates$UnlinkRecordsModal$init,
			HN: A2($author$project$Utils$User$isViewingAsHinter, session, hinterViewOff)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model),
						$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model)
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg,
				$author$project$Components$Affiliates$LinkRecordsModal$subscriptions(model.mR)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg,
				$author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions(model.oX))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WQ: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var unlinkRecordsModalResutl = A3($author$project$Components$Affiliates$UnlinkRecordsModal$update, model.D5, subMsg, model.oX);
				var _v1 = function () {
					var _v2 = unlinkRecordsModalResutl.ac5;
					switch (_v2) {
						case 0:
							return _Utils_Tuple3(model.WQ, model.S4, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple3(
								$author$project$Api$Data$Loading,
								model.S4,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model));
						default:
							return _Utils_Tuple3(
								model.WQ,
								$author$project$Api$Data$Loading,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model));
					}
				}();
				var practitioners = _v1.a;
				var locations = _v1.b;
				var cmd = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S4: locations, WQ: practitioners, oX: unlinkRecordsModalResutl.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg, unlinkRecordsModalResutl.EC),
								cmd
							])),
					unlinkRecordsModalResutl.as);
			default:
				var subMsg = msg.a;
				var linkRecordsModalResutl = A4($author$project$Components$Affiliates$LinkRecordsModal$update, model.D5, subMsg, model.mR, model.HN);
				var _v3 = function () {
					var _v4 = linkRecordsModalResutl.ac5;
					switch (_v4) {
						case 0:
							return _Utils_Tuple3(model.WQ, model.S4, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple3(
								$author$project$Api$Data$Loading,
								model.S4,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model));
						default:
							return _Utils_Tuple3(
								model.WQ,
								$author$project$Api$Data$Loading,
								$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model));
					}
				}();
				var practitioners = _v3.a;
				var locations = _v3.b;
				var cmd = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mR: linkRecordsModalResutl.y8, S4: locations, WQ: practitioners}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg, linkRecordsModalResutl.EC),
								cmd
							])),
					linkRecordsModalResutl.as);
		}
	});
var $author$project$Components$Affiliates$LinkRecordsModal$button = F2(
	function (affiliateId, resource) {
		return A3(
			$author$project$Components$Affiliates$LinkRecordsModal$button_,
			affiliateId,
			resource,
			_List_fromArray(
				[
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$locationsColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'network_name', false, 'Network Location Name'),
		A3($author$project$Api$Column$init, 'affiliate_name', false, 'Affiliate Location Name'),
		A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
		A3($author$project$Api$Column$init, 'actions', false, '')
	]);
var $author$project$Api$Provider$Affiliates$Location$All$activeLives = function (_v0) {
	var record = _v0.b;
	return record.If;
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocation = F3(
	function (model, locations, location) {
		var remainingLocations = A2(
			$elm$core$List$filter,
			function (remainingLocation) {
				return !_Utils_eq(
					$author$project$Api$Provider$Affiliates$Location$All$id(location),
					$author$project$Api$Provider$Affiliates$Location$All$id(remainingLocation));
			},
			locations);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Affiliates$Location$All$name(location))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Location$Min$name(
								$author$project$Api$Provider$Affiliates$Location$All$affiliateLocation(location)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$Affiliates$Location$All$activeLives(location)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg,
							A2(
								$author$project$Components$Affiliates$UnlinkRecordsModal$button,
								model.pp,
								A2($author$project$Components$Affiliates$UnlinkRecordsModal$Location, location, remainingLocations)))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocationsTable = function (model) {
	var _v0 = function () {
		var _v1 = model.S4;
		if (_v1.$ === 3) {
			var locations_ = _v1.a;
			return _Utils_Tuple2(false, locations_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var locations = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(10)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Locations')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(2),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg,
							A2($author$project$Components$Affiliates$LinkRecordsModal$button, model.pp, 1))
						]))
				])),
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Manage links between affiliate locations and your network.')
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(loading),
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No linked locations.')
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$locationsColumns),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocation, model, locations),
				locations),
			_List_Nil)
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$practitionersColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'network_name', false, 'Network Provider Name'),
		A3($author$project$Api$Column$init, 'affiliate_name', false, 'Affiliate Provider Name'),
		A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
		A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
		A3($author$project$Api$Column$init, 'actions', false, '')
	]);
var $author$project$Api$Provider$Affiliates$Practitioner$All$activeLives = function (_v0) {
	var record = _v0;
	return record.If;
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitioner = F3(
	function (model, practitioners, practitioner) {
		var remainingPractitioners = A2(
			$elm$core$List$filter,
			function (remainingPractitioner) {
				return !_Utils_eq(
					$author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner),
					$author$project$Api$Provider$Affiliates$Practitioner$All$id(remainingPractitioner));
			},
			practitioners);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Practitioner$Min$name(
								$author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner(practitioner)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Provider$Affiliates$Practitioner$All$activeLives(practitioner)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg,
							A2(
								$author$project$Components$Affiliates$UnlinkRecordsModal$button,
								model.pp,
								A2($author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner, practitioner, remainingPractitioners)))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitionersTable = function (model) {
	var network = $author$project$Api$Provider$Practice$One$network(model.WF);
	var _v0 = function () {
		var _v1 = model.WQ;
		if (_v1.$ === 3) {
			var practitioners_ = _v1.a;
			return _Utils_Tuple2(false, practitioners_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var practitioners = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(10)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									false,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network)) ? $elm$html$Html$text('Providers') : $elm$html$Html$text('Linked Providers')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(2),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg,
							A2($author$project$Components$Affiliates$LinkRecordsModal$button, model.pp, 0))
						]))
				])),
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Manage links between affiliate providers and your network.')
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(loading),
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No linked providers.')
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$practitionersColumns),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitioner, model, practitioners),
				practitioners),
			_List_Nil)
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$view = function (model) {
	var network = $author$project$Api$Provider$Practice$One$network(model.WF);
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg,
				$author$project$Components$Affiliates$UnlinkRecordsModal$modal(model.oX)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg,
				$author$project$Components$Affiliates$LinkRecordsModal$modal(model.mR)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_Utils_ap(
							$author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitionersTable(model),
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network)) ? $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocationsTable(model) : _List_Nil))
					]))
			]),
		$G: 'Affiliates | Linked Providers'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$init, aer: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$load, agD: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$save, ahd: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$subscriptions, aaq: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$update, ahP: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString = function (statusType) {
	switch (statusType) {
		case 0:
			return 'active';
		case 1:
			return 'pending';
		default:
			return 'ended';
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_),
			$elm$core$List$isEmpty(model.g) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$url$Url$Builder$string,
				'filter',
				A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, model.g)))),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.ff),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('plan'),
			model.afN),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practitioner'),
			model.WO),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString, model.ag7))
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients(
					{pp: model.pp}))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$GotAffiliateCoveragePeriods = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				ab9: model.ff,
				Fi: model.g,
				afy: model.afy,
				GH: model.afN,
				afS: model.WO,
				af_: model.af_,
				ag7: A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString, model.ag7)
			});
	};
};
var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['affiliate_coverage_periods']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$AffiliateCoveragePeriod = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$AffiliateCoveragePeriod = $elm$core$Basics$identity;
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$Record = F3(
	function (status, enrollmentDate, terminationDate) {
		return {OG: enrollmentDate, ag7: status, $y: terminationDate};
	});
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'termination_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enrollment_date',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$Shared$Record))));
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateCoveragePeriod$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$Record = F8(
	function (affiliatePeriodInMonths, affiliateRateInCents, networkPeriodInMonths, networkRateInCents, patient, company, practitioner, rateRule) {
		return {IE: affiliatePeriodInMonths, IH: affiliateRateInCents, ab9: company, Uq: networkPeriodInMonths, Us: networkRateInCents, VM: patient, afS: practitioner, XL: rateRule};
	});
var $author$project$Api$Provider$RateRule$Min$RateRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$RateRule$Min$Record = F2(
	function (type_, name) {
		return {zh: name, ahI: type_};
	});
var $author$project$Api$Provider$RateRule$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Min$Record)));
var $author$project$Api$Provider$RateRule$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RateRule$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rate_rule',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'company',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patient',
				$author$project$Api$Provider$Patient$Min$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'network_rate_in_cents',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'network_period_in_months',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'affiliate_rate_in_cents',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'affiliate_period_in_months',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$All$Record)))))))));
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateCoveragePeriod$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$AffiliateCoveragePeriod$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$All$AffiliateCoveragePeriod)));
var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listDefaults = {ab9: $elm$core$Maybe$Nothing, Fi: _List_Nil, afy: $author$project$Api$Pagination$init, GH: $elm$core$Maybe$Nothing, afS: $elm$core$Maybe$Nothing, af_: $elm$core$Maybe$Nothing, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Fi;
				if (!_v1.b) {
					return _List_Nil;
				} else {
					var filters = _v1;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'filter',
							A2(
								$elm$core$String$join,
								',',
								A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters)))
						]);
				}
			}(),
				function () {
				var _v2 = options.ab9;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'company', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.GH;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'plan', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.afS;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.ag7;
				if (!_v5.$) {
					var string = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$list = F4(
	function (apiClient, affiliateId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateCoveragePeriod$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath(affiliateId))));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods = function (model) {
	return A4(
		$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$list,
		model.D5,
		model.pp,
		$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams(model),
		$author$project$Pages$Affiliates$AffiliateId_String$Patients$GotAffiliateCoveragePeriods);
};
var $author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo = {$: 4};
var $author$project$Api$Provider$Patient$Active = 0;
var $author$project$Api$Provider$Patient$ActiveMembership = {$: 2};
var $author$project$Api$Provider$Patient$Archived = 4;
var $author$project$Api$Provider$Patient$AutopayEnabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Patient$CurrentlyEngaged = 0;
var $author$project$Api$Provider$Patient$Engaged = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$Patient$Inactive = 1;
var $author$project$Api$Provider$Patient$NeverEngaged = 2;
var $author$project$Api$Provider$Patient$NewActivationsSinceDate = {$: 10};
var $author$project$Api$Provider$Patient$NewTerminationsSinceDate = {$: 11};
var $author$project$Api$Provider$Patient$PastDueCustomerInvoices = {$: 3};
var $author$project$Api$Provider$Patient$Pending = 2;
var $author$project$Api$Provider$Patient$PreviouslyEngaged = 1;
var $author$project$Api$Provider$Patient$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Patient$Unconfirmed = 3;
var $author$project$Api$Provider$Patient$WithBouncedEmail = {$: 14};
var $author$project$Api$Provider$Patient$WithFailedIntegrations = {$: 8};
var $author$project$Api$Provider$Patient$WithFlaggedNotes = {$: 7};
var $author$project$Api$Provider$Patient$WithUnsubscribedEmails = {$: 15};
var $author$project$Api$Provider$Patient$WithUnsyncedIntegrations = {$: 9};
var $author$project$Api$Provider$Patient$WithUpcomingBirthday = {$: 12};
var $author$project$Api$Provider$Patient$filterFromString = function (filter) {
	switch (filter) {
		case 'current_membership':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(0));
		case 'future_membership':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(2));
		case 'with_unconfirmed_membership':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(3));
		case 'inactive':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(1));
		case 'archived':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Status(4));
		case 'with_autopay':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$AutopayEnabled(true));
		case 'without_autopay':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$AutopayEnabled(false));
		case 'active_membership':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$ActiveMembership);
		case 'past_due_customer_invoices':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$PastDueCustomerInvoices);
		case 'account_owner_without_payment_info':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo);
		case 'without_hipaa_authorization':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithoutHipaaAuthorization);
		case 'without_email':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithoutEmail);
		case 'with_flagged_notes':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFlaggedNotes);
		case 'with_failed_sync':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFailedIntegrations);
		case 'with_failed_integrations':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFailedIntegrations);
		case 'with_unsynced_integrations':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUnsyncedIntegrations);
		case 'new_activations_since_date':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$NewActivationsSinceDate);
		case 'new_terminations_since_date':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$NewTerminationsSinceDate);
		case 'with_upcoming_birthday':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUpcomingBirthday);
		case 'currently_engaged':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Engaged(0));
		case 'previously_engaged':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Engaged(1));
		case 'never_engaged':
			return $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$Engaged(2));
		case 'with_bounced_emails':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithBouncedEmail);
		case 'with_unsubscribed_emails':
			return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUnsubscribedEmails);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$PatientFilter$DropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PatientFilter$init = $author$project$Ui$NewDropdown$init(
	$author$project$Ui$NewDropdown$defaultConfig(
		{adR: 'patient-filter', ahx: $author$project$Components$PatientFilter$DropdownMsg}));
var $author$project$Api$Practice$sponsorize = F2(
	function (practice, string) {
		if (!practice.$) {
			var practice_ = practice.a;
			return A2($author$project$Formatters$String$sponsorize, practice_, string);
		} else {
			return string;
		}
	});
var $author$project$Utils$Report$CompanyResourceFilter$init = F4(
	function (apiClient, optionals, practice, companyId) {
		return A2(
			$author$project$Components$ResourceFilter$Company$init,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'All ' + A2($author$project$Api$Practice$sponsorize, practice, 'Companies'),
							afT: companyId
						});
				}));
	});
var $author$project$Utils$Report$PlanResourceFilter$init = F4(
	function (apiClient, optionals, session, planId) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'All Plans', afT: planId});
				}));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Active = 0;
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Ended = 2;
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Pending = 1;
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$stringToStatusType = function (str) {
	switch (str) {
		case 'active':
			return $elm$core$Maybe$Just(0);
		case 'pending':
			return $elm$core$Maybe$Just(1);
		case 'ended':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var planId = A2($elm$core$Dict$get, 'plan', query);
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			shared.D5,
			function (d) {
				return _Utils_update(
					d,
					{
						DZ: $elm$core$Maybe$Just(params.pp)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Providers', aeZ: true});
			});
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A4(
			$author$project$Utils$Report$PlanResourceFilter$init,
			shared.D5,
			function (d) {
				return _Utils_update(
					d,
					{aeZ: true});
			},
			session,
			planId);
		var planResourceFilter = _v2.a;
		var planResourceFilterCmd = _v2.b;
		var _v3 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			shared.D5,
			function (d) {
				return _Utils_update(
					d,
					{aeZ: true});
			},
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v3.a;
		var companyResourceFilterCmd = _v3.b;
		var model = {
			cy: $author$project$Api$Data$Loading,
			pp: params.pp,
			D5: shared.D5,
			Er: A3($author$project$Permission$canGoTo, session, shared.adN, 44),
			ff: companyId,
			pV: companyResourceFilter,
			g: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$filterMap($author$project$Api$Provider$Patient$filterFromString),
					A2(
						$elm$core$Maybe$map,
						$elm$core$String$split(','),
						A2($elm$core$Dict$get, 'filter', query)))),
			FR: $author$project$Shared$isHintAdmin(shared),
			afy: $author$project$Api$Pagination$initFromQuery(query),
			jo: $author$project$Components$PatientFilter$init,
			afN: planId,
			jw: planResourceFilter,
			WF: practice,
			WO: A2($elm$core$Dict$get, 'practitioner', query),
			jC: practitionerResourceFilter,
			af_: q,
			ew: false,
			sA: $author$project$Ui$SearchInput$init(q),
			ag7: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$stringToStatusType,
				A2($elm$core$Dict$get, 'status', query)),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'status-dropdown-filter', ahx: $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(model),
						A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal = {$: 12};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PatientFilter$subscriptions = function (model) {
	return $author$project$Ui$NewDropdown$subscriptions(model);
};
var $author$project$Components$ResourceFilter$Company$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg,
				$author$project$Components$PatientFilter$subscriptions(model.jo)),
				model.ew ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal) : $elm$core$Platform$Sub$none,
				$author$project$Ui$NewDropdown$subscriptions(model.oA),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.jw)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.pV)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Practitioner$subscriptions(model.jC))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ResyncTriggered = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Affiliate$syncPlansAndFailedSyncs = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync_plans_and_failed_syncs']),
					$author$project$Api$Provider$Affiliate$affiliatePath(id_))));
	});
var $author$project$Components$PatientFilter$FilterSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PatientFilter$None = {$: 0};
var $author$project$Components$PatientFilter$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A2($author$project$Ui$NewDropdown$update, subMsg, model);
			var dropdown = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple3(dropdown, cmd, $author$project$Components$PatientFilter$None);
		} else {
			var patientFilter = msg.a;
			return _Utils_Tuple3(
				model,
				$elm$core$Platform$Cmd$none,
				$author$project$Components$PatientFilter$FilterSelected(patientFilter));
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale = F3(
	function (getter, currentModel, newModel) {
		var updatedModel = _Utils_eq(
			getter(currentModel),
			getter(newModel)) ? newModel : _Utils_update(
			newModel,
			{
				cy: $author$project$Api$Data$Loading,
				afy: $author$project$Api$Pagination$reset(newModel.afy)
			});
		return _Utils_eq(
			getter(currentModel),
			getter(newModel)) ? _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			updatedModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(updatedModel),
						A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(updatedModel)
					])));
	});
var $author$project$Components$ResourceFilter$Company$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cy: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cy: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								cy: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Components$PatientFilter$update, subMsg, model.jo);
				var patientFilter = _v5.a;
				var cmd = _v5.b;
				var event = _v5.c;
				if (event.$ === 1) {
					var selectedFilters = event.a;
					var newModel = _Utils_update(
						model,
						{
							cy: $author$project$Api$Data$Loading,
							g: selectedFilters,
							afy: $author$project$Api$Pagination$reset(model.afy),
							jo: patientFilter
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
									A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg, cmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jo: patientFilter}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg, cmd),
						_List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, model.D5, subMsg, model.pV);
				var companyId = function () {
					var _v8 = companyResourceResult.ac5;
					if (!_v8.$) {
						if (!_v8.a.$) {
							return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.y8);
						} else {
							var _v9 = _v8.a;
							return model.ff;
						}
					} else {
						return model.ff;
					}
				}();
				var _v7 = A3(
					$author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale,
					function ($) {
						return $.ff;
					},
					model,
					_Utils_update(
						model,
						{ff: companyId, pV: companyResourceResult.y8}));
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg, companyResourceResult.EC),
								cmd
							])),
					companyResourceResult.as);
			case 4:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.D5, subMsg, model.jw);
				var planId = function () {
					var _v11 = planResourceResult.ac5;
					if (!_v11.$) {
						if (!_v11.a.$) {
							return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.y8);
						} else {
							var _v12 = _v11.a;
							return model.afN;
						}
					} else {
						return model.afN;
					}
				}();
				var _v10 = A3(
					$author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale,
					function ($) {
						return $.afN;
					},
					model,
					_Utils_update(
						model,
						{afN: planId, jw: planResourceResult.y8}));
				var newModel = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg, planResourceResult.EC),
								cmd
							])),
					planResourceResult.as);
			case 5:
				var subMsg = msg.a;
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, model.D5, subMsg, model.jC);
				var practitionerId = function () {
					var _v14 = practitionerResourceResult.ac5;
					if (!_v14.$) {
						if (!_v14.a.$) {
							return $author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.y8);
						} else {
							var _v15 = _v14.a;
							return model.WO;
						}
					} else {
						return model.WO;
					}
				}();
				var _v13 = A3(
					$author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale,
					function ($) {
						return $.WO;
					},
					model,
					_Utils_update(
						model,
						{WO: practitionerId, jC: practitionerResourceResult.y8}));
				var newModel = _v13.a;
				var cmd = _v13.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
								cmd
							])),
					practitionerResourceResult.as);
			case 6:
				var subMsg = msg.a;
				var _v16 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var statusDropdown = _v16.a;
				var cmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: statusDropdown}),
					cmd,
					_List_Nil);
			case 7:
				var selectedStatus = msg.a;
				var newModel = _Utils_update(
					model,
					{
						cy: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						ag7: selectedStatus
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{cy: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ew: true}),
					A3($author$project$Api$Provider$Affiliate$syncPlansAndFailedSyncs, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$Patients$ResyncTriggered),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ew: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Re-sync triggered successfully')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ew: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ew: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ew: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v18 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v18.a;
				var outMsgs = _v18.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg, getFileCmdMsg),
					outMsgs);
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ShowResyncWarningModal = {$: 11};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$TriggerResync = {$: 9};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$columns = function (practice) {
	return _List_fromArray(
		[
			A3($author$project$Api$Column$init, 'name', false, 'Name'),
			A3($author$project$Api$Column$init, 'plan_type', false, 'Plan Type'),
			A3(
			$author$project$Api$Column$init,
			'company',
			false,
			A2($author$project$Formatters$String$sponsorize, practice, 'Employer')),
			A3($author$project$Api$Column$init, 'practitioner', false, 'Provider'),
			A3($author$project$Api$Column$init, 'affiliate_rate', false, 'Affiliate Rate'),
			A3($author$project$Api$Column$init, 'total_in_cents', false, 'Total Rate'),
			A3($author$project$Api$Column$init, 'status', false, 'Status')
		]);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$exportCsvPath = function (model) {
	var csvParams = A2(
		$elm$core$List$concatMap,
		$author$project$Api$Param$toQuery,
		$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams(
			$author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams(model)));
	return A4(
		$author$project$Api$Data$downloadUrl,
		model.D5,
		$author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath(model.pp),
		0,
		csvParams);
};
var $author$project$Components$PatientFilter$FilterSelected_ = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PatientFilter$isAutopayFilter = function (filter) {
	if (filter.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$PatientFilter$isEngagedFilter = function (filter) {
	if (filter.$ === 13) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$PatientFilter$isStatusFilter = function (filter) {
	if (!filter.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$PatientFilter$checkedItem = F2(
	function (filter, currentFilters) {
		return A2($elm$core$List$member, filter, currentFilters) ? A2(
			$elm$core$List$filter,
			function (current) {
				return !_Utils_eq(current, filter);
			},
			currentFilters) : A2(
			$elm$core$List$cons,
			filter,
			function () {
				switch (filter.$) {
					case 0:
						return A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isStatusFilter),
							currentFilters);
					case 1:
						return A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isAutopayFilter),
							currentFilters);
					case 13:
						return A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isEngagedFilter),
							currentFilters);
					default:
						return currentFilters;
				}
			}());
	});
var $author$project$Components$PatientFilter$clearCategoryFilters = F2(
	function (predicate, currentFilters) {
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, predicate),
			currentFilters);
	});
var $author$project$Components$PatientFilter$filterToLabel = function (filter) {
	switch (filter.$) {
		case 0:
			switch (filter.a) {
				case 0:
					var _v1 = filter.a;
					return 'Active Patients';
				case 2:
					var _v2 = filter.a;
					return 'Pending';
				case 3:
					var _v3 = filter.a;
					return 'Unconfirmed';
				case 1:
					var _v4 = filter.a;
					return 'Inactive';
				default:
					var _v5 = filter.a;
					return 'Archived Patients';
			}
		case 1:
			if (filter.a) {
				return 'Autopay Enabled';
			} else {
				return 'Autopay Disabled';
			}
		case 2:
			return 'Active and Paid';
		case 3:
			return 'Has Past Due Invoices';
		case 4:
			return 'No Payment Info';
		case 5:
			return 'No ePHI waiver';
		case 6:
			return 'No Email Address';
		case 7:
			return 'Has Flagged Notes';
		case 15:
			return 'Unsubscribed From Emails';
		case 14:
			return 'Has Bounced Emails';
		case 9:
			return 'Unsynced Integration';
		case 8:
			return 'Failed Sync';
		case 10:
			return 'New Activations';
		case 11:
			return 'New Terminations';
		case 12:
			return 'Upcoming Birthdays';
		default:
			switch (filter.a) {
				case 0:
					var _v6 = filter.a;
					return 'Currently Engaged';
				case 1:
					var _v7 = filter.a;
					return 'Previously Engaged';
				default:
					var _v8 = filter.a;
					return 'Never Engaged';
			}
	}
};
var $author$project$Ui$NewDropdown$Radio = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$radio = $author$project$Ui$NewDropdown$Radio;
var $author$project$Components$PatientFilter$dropdownItems = F2(
	function (practice, currentFilters) {
		var radioItem = function (filter) {
			return A2(
				$author$project$Ui$NewDropdown$radio,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onCheck(
						$elm$core$Basics$always(
							$author$project$Components$PatientFilter$FilterSelected_(
								A2($author$project$Components$PatientFilter$checkedItem, filter, currentFilters)))),
						$author$project$Ui$NewDropdown$checked(
						A2($elm$core$List$member, filter, currentFilters))
					]),
				$elm$html$Html$text(
					$author$project$Components$PatientFilter$filterToLabel(filter)));
		};
		var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
		var gateIsAvailable = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			11,
			$author$project$Api$Practice$Provider(practice));
		var engagementFilters = function () {
			if (gateIsAvailable || practiceIsAffiliateOrNetwork) {
				var anyEngagedItem = A2(
					$author$project$Ui$NewDropdown$radio,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$onCheck(
							$elm$core$Basics$always(
								$author$project$Components$PatientFilter$FilterSelected_(
									A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isEngagedFilter, currentFilters)))),
							$author$project$Ui$NewDropdown$checked(
							!A2($elm$core$List$any, $author$project$Components$PatientFilter$isEngagedFilter, currentFilters))
						]),
					$elm$html$Html$text('Any Engagement'));
				return _List_fromArray(
					[
						$author$project$Ui$NewDropdown$separator,
						anyEngagedItem,
						radioItem(
						$author$project$Api$Provider$Patient$Engaged(0)),
						radioItem(
						$author$project$Api$Provider$Patient$Engaged(1)),
						radioItem(
						$author$project$Api$Provider$Patient$Engaged(2))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var checkboxItem = function (filter) {
			return A2(
				$author$project$Ui$NewDropdown$checkbox,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onCheck(
						$elm$core$Basics$always(
							$author$project$Components$PatientFilter$FilterSelected_(
								A2($author$project$Components$PatientFilter$checkedItem, filter, currentFilters)))),
						$author$project$Ui$NewDropdown$checked(
						A2($elm$core$List$member, filter, currentFilters))
					]),
				$elm$html$Html$text(
					$author$project$Components$PatientFilter$filterToLabel(filter)));
		};
		var anyStatusItem = A2(
			$author$project$Ui$NewDropdown$radio,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onCheck(
					$elm$core$Basics$always(
						$author$project$Components$PatientFilter$FilterSelected_(
							A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isStatusFilter, currentFilters)))),
					$author$project$Ui$NewDropdown$checked(
					!A2($elm$core$List$any, $author$project$Components$PatientFilter$isStatusFilter, currentFilters))
				]),
			$elm$html$Html$text('Any Status'));
		var anyAutopayItem = A2(
			$author$project$Ui$NewDropdown$radio,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onCheck(
					$elm$core$Basics$always(
						$author$project$Components$PatientFilter$FilterSelected_(
							A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isAutopayFilter, currentFilters)))),
					$author$project$Ui$NewDropdown$checked(
					!A2($elm$core$List$any, $author$project$Components$PatientFilter$isAutopayFilter, currentFilters))
				]),
			$elm$html$Html$text('Any Autopay'));
		var baseFilters = _List_fromArray(
			[
				anyStatusItem,
				radioItem(
				$author$project$Api$Provider$Patient$Status(0)),
				radioItem(
				$author$project$Api$Provider$Patient$Status(2)),
				radioItem(
				$author$project$Api$Provider$Patient$Status(3)),
				radioItem(
				$author$project$Api$Provider$Patient$Status(1)),
				radioItem(
				$author$project$Api$Provider$Patient$Status(4)),
				$author$project$Ui$NewDropdown$separator,
				anyAutopayItem,
				radioItem(
				$author$project$Api$Provider$Patient$AutopayEnabled(true)),
				radioItem(
				$author$project$Api$Provider$Patient$AutopayEnabled(false)),
				$author$project$Ui$NewDropdown$separator,
				checkboxItem($author$project$Api$Provider$Patient$ActiveMembership),
				checkboxItem($author$project$Api$Provider$Patient$PastDueCustomerInvoices),
				checkboxItem($author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo),
				$author$project$Ui$NewDropdown$separator,
				checkboxItem($author$project$Api$Provider$Patient$WithoutHipaaAuthorization),
				checkboxItem($author$project$Api$Provider$Patient$WithoutEmail),
				checkboxItem($author$project$Api$Provider$Patient$WithFlaggedNotes),
				checkboxItem($author$project$Api$Provider$Patient$WithUnsubscribedEmails),
				checkboxItem($author$project$Api$Provider$Patient$WithBouncedEmail),
				$author$project$Ui$NewDropdown$separator,
				checkboxItem($author$project$Api$Provider$Patient$WithUnsyncedIntegrations),
				checkboxItem($author$project$Api$Provider$Patient$WithFailedIntegrations),
				$author$project$Ui$NewDropdown$separator,
				checkboxItem($author$project$Api$Provider$Patient$NewActivationsSinceDate),
				checkboxItem($author$project$Api$Provider$Patient$NewTerminationsSinceDate),
				checkboxItem($author$project$Api$Provider$Patient$WithUpcomingBirthday)
			]);
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$PatientFilter$FilterSelected_(_List_Nil)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentFilters, _List_Nil))
					]),
				$elm$html$Html$text('All Patients')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				_Utils_ap(baseFilters, engagementFilters)));
	});
var $author$project$Components$PatientFilter$view = F3(
	function (practice, value, model) {
		var placeholder = function () {
			if (!value.b) {
				return 'All Patients';
			} else {
				if (!value.b.b) {
					var single = value.a;
					return $author$project$Components$PatientFilter$filterToLabel(single);
				} else {
					var many = value;
					return $elm$core$String$fromInt(
						$elm$core$List$length(many)) + ' Selected';
				}
			}
		}();
		return A4(
			$author$project$Ui$NewDropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(placeholder)
				]),
			A2($author$project$Components$PatientFilter$dropdownItems, practice, value),
			model);
	});
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliatePeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.IE;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliateRateInCents = function (_v0) {
	var record = _v0.b;
	return record.IH;
};
var $author$project$Formatters$Int$asPeriod = function (periodInMonths) {
	switch (periodInMonths) {
		case 1:
			return 'Monthly';
		case 3:
			return 'Quarterly';
		case 6:
			return 'Semi-annually';
		case 12:
			return 'Annually';
		default:
			return '/ ' + $elm$core$String$fromInt(periodInMonths);
	}
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$company = function (_v0) {
	var record = _v0.b;
	return record.ab9;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$enrollmentDate = function (_v0) {
	var record = _v0;
	return record.OG;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$enrollmentDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$enrollmentDate(shared);
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$terminationDate = function (_v0) {
	var record = _v0;
	return record.$y;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$terminationDate(shared);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$dateForDisplay = function (affiliateCoveragePeriod) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Api$Provider$AffiliateCoveragePeriod$All$enrollmentDate(affiliateCoveragePeriod),
		$author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate(affiliateCoveragePeriod));
};
var $author$project$Api$Provider$RateRule$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.Uq;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkRateInCents = function (_v0) {
	var record = _v0.b;
	return record.Us;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$practitioner = function (_v0) {
	var record = _v0.b;
	return record.afS;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule = function (_v0) {
	var record = _v0.b;
	return record.XL;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$AffiliateCoveragePeriod$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$status(shared);
};
var $author$project$Api$Provider$RateRule$Min$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$verbFor = function (affiliateCoveragePeriod) {
	return $author$project$Utils$Maybe$toBool(
		$author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate(affiliateCoveragePeriod)) ? (($author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod) === 'ended') ? 'ended' : 'ending') : (($author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod) === 'pending') ? 'starting' : 'since');
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$viewAffiliateCoveragePeriod = F2(
	function (canGoToPatients, affiliateCoveragePeriod) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							function () {
								var _v0 = _Utils_Tuple2(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$AffiliateCoveragePeriod$All$patient(affiliateCoveragePeriod)),
									canGoToPatients);
								if (!_v0.a.$) {
									if (_v0.b) {
										var patient = _v0.a.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														VN: $author$project$Api$Provider$Patient$Min$id(patient)
													}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$Patient$Min$name(patient))
													]))
											]);
									} else {
										var patient = _v0.a.a;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$Patient$Min$name(patient))
											]);
									}
								} else {
									return _List_Nil;
								}
							}())
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									A2($elm$core$Basics$composeR, $author$project$Api$Provider$RateRule$Min$type_, $author$project$Formatters$String$humanize),
									$author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule(affiliateCoveragePeriod)))),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$RateRule$Min$name,
									$author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule(affiliateCoveragePeriod))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Company$Min$name,
									$author$project$Api$Provider$AffiliateCoveragePeriod$All$company(affiliateCoveragePeriod))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Practitioner$Min$name,
									$author$project$Api$Provider$AffiliateCoveragePeriod$All$practitioner(affiliateCoveragePeriod))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v1 = $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliateRateInCents(affiliateCoveragePeriod);
						if (!_v1.$) {
							var affiliateRateInCents = _v1.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(affiliateRateInCents)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Int$asPeriod(
										$author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliatePeriodInMonths(affiliateCoveragePeriod)))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v2 = $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkRateInCents(affiliateCoveragePeriod);
						if (!_v2.$) {
							var networkRateInCents = _v2.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(networkRateInCents)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Int$asPeriod(
										$author$project$Api$Provider$AffiliateCoveragePeriod$All$networkPeriodInMonths(affiliateCoveragePeriod)))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod)),
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Pages$Affiliates$AffiliateId_String$Patients$verbFor(affiliateCoveragePeriod)),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Pages$Affiliates$AffiliateId_String$Patients$dateForDisplay(affiliateCoveragePeriod)))
								]))
						]))
				]));
	});
var $author$project$Components$ResourceFilter$Company$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel = function (statusType) {
	switch (statusType) {
		case 0:
			return 'Active';
		case 1:
			return 'Pending';
		default:
			return 'Ended';
	}
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$viewStatusDropdown = function (model) {
	var currentLabel = function () {
		var _v0 = model.ag7;
		if (!_v0.$) {
			var statusType = _v0.a;
			return $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel(statusType);
		} else {
			return 'Status';
		}
	}();
	var allStatuses = _List_fromArray(
		[0, 1, 2]);
	var items = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected($elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Statuses')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				function (statusType) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected(
									$elm$core$Maybe$Just(statusType)))
							]),
						$elm$html$Html$text(
							$author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel(statusType)));
				},
				allStatuses)));
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.oA);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$view = function (model) {
	var _v0 = function () {
		var _v1 = model.cy;
		if (_v1.$ === 3) {
			var affiliateCoveragePeriods_ = _v1.a;
			return _Utils_Tuple2(false, affiliateCoveragePeriods_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var affiliateCoveragePeriods = _v0.b;
	return {
		e5: _List_fromArray(
			[
				model.ew ? A3(
				$author$project$Ui$Modal$view,
				$author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal,
				_List_fromArray(
					[
						$author$project$Ui$Modal$size(1)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Resync mapped plans and failed syncs')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Please don\'t execute the resync more than once an hour. If failures persist after the previous resync, contact the affiliates team instead of running this.')
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Resync mapped plans and failed syncs'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$TriggerResync)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Re-sync')
									]))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Patients')
											])),
										model.FR ? A3(
										$author$project$Ui$HinterOnly$button,
										{abp: 'Re-sync'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(0),
												$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$ShowResyncWarningModal),
												$author$project$Ui$Button$sm
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Re-sync')
											])) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg,
												A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanSm(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg,
												A3($author$project$Components$PatientFilter$view, model.WF, model.g, model.jo))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanSm(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Company$viewNew, _List_Nil, model.pV))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanSm(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Plan$viewNew, _List_Nil, model.jw))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanSm(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Practitioner$viewNew, _List_Nil, model.jC))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanSm(2)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Affiliates$AffiliateId_String$Patients$viewStatusDropdown(model)
											]))
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('No matching results.')
									]))
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$columns(model.WF)),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$pull(1)
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Tooltip$view,
													_List_Nil,
													'Export to CSV',
													_List_fromArray(
														[
															A2(
															$elm$html$Html$map,
															$author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg,
															A3(
																$author$project$Components$FileLink$view,
																{
																	K1: model.D5,
																	PE: 0,
																	aav: $author$project$Pages$Affiliates$AffiliateId_String$Patients$exportCsvPath(model)
																},
																_List_fromArray(
																	[
																		$author$project$Ui$Link$ariaLabel('Export Csv'),
																		$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$export)
																	]),
																_List_Nil))
														]))
												]))
										]))
								])),
						A2(
							$elm$core$List$map,
							$author$project$Pages$Affiliates$AffiliateId_String$Patients$viewAffiliateCoveragePeriod(model.Er),
							affiliateCoveragePeriods),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Affiliates$AffiliateId_String$Patients$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Affiliates | Patients'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Patients$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$AffiliateId_String$Patients$init, aer: $author$project$Pages$Affiliates$AffiliateId_String$Patients$load, agD: $author$project$Pages$Affiliates$AffiliateId_String$Patients$save, ahd: $author$project$Pages$Affiliates$AffiliateId_String$Patients$subscriptions, aaq: $author$project$Pages$Affiliates$AffiliateId_String$Patients$update, ahP: $author$project$Pages$Affiliates$AffiliateId_String$Patients$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotAffiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotPlans = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Affiliates$Plan$All$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$Plan$One$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliates$Plan$One$Record = F6(
	function (id, name, billingDate, _default, plan, networkPlans) {
		return {J_: billingDate, M5: _default, adR: id, zh: name, Ur: networkPlans, GH: plan};
	});
var $author$project$Api$Provider$Affiliates$Plan$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'network_plans',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Plan$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plan',
		$author$project$Api$Provider$Plan$One$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'default',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'billing_date',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Plan$One$Record)))))));
var $author$project$Api$Provider$Affiliates$Plan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Plan$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$Plan$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliates$Plan$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$Plan$plansPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['plans']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$Plan$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Plan$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans = function (model) {
	return A3($author$project$Api$Provider$Affiliates$Plan$list, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotPlans);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$init = F4(
	function (session, _v0, shared, _v1) {
		var params = _v1.Vx;
		var model = {
			DZ: $author$project$Api$Data$Loading,
			pp: params.pp,
			D5: shared.D5,
			ds: false,
			hZ: $elm$core$Maybe$Nothing,
			iu: $elm$core$Maybe$Nothing,
			FR: $author$project$Shared$isHintAdmin(shared),
			Wq: $author$project$Api$Data$Loading,
			av: $elm$core$Set$empty,
			ZD: session
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
						A3($author$project$Api$Provider$Affiliate$retrieve, shared.D5, params.pp, $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotAffiliate)
					])));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal = {$: 13};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal = {$: 0};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal);
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal = {$: 0};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$subscriptions, model.hZ))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$subscriptions, model.iu))),
				model.ds ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$AffiliationArchived = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Defaulted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Deleted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$OutMsg$GoToRouteAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Affiliate$One$affiliatePractice = function (_v0) {
	var record = _v0.b;
	return record.IF;
};
var $author$project$Api$Provider$Affiliate$archive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Affiliate$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['archive']),
					$author$project$Api$Provider$Affiliate$affiliatePath(id_))));
	});
var $author$project$Api$Provider$Affiliates$Plan$planPath = F2(
	function (affiliateId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId));
	});
var $author$project$Api$Provider$Affiliates$Plan$delete = F4(
	function (apiClient, affiliateId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)));
	});
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$Model = $elm$core$Basics$identity;
var $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$Fixed = 0;
var $author$project$Components$Affiliates$PercentagePlan$initFormFields = {adr: $elm$core$Maybe$Nothing, zh: $elm$core$Maybe$Nothing, afJ: $elm$core$Maybe$Nothing, afN: $elm$core$Maybe$Nothing, afX: 0};
var $author$project$Components$Affiliates$PercentagePlan$initPlanResourceFilter = F2(
	function (apiClient, session) {
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Plan'});
			});
	});
var $author$project$Components$Affiliates$PercentagePlan$init = F3(
	function (apiClient, session, affiliatePractice) {
		var _v0 = A2($author$project$Components$Affiliates$PercentagePlan$initPlanResourceFilter, apiClient, session);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				IF: affiliatePractice,
				PB: $author$project$Utils$Form$init($author$project$Components$Affiliates$PercentagePlan$initFormFields),
				jw: planResourceFilter
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg, planResourceFilterCmd));
	});
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$init = F3(
	function (apiClient, session, affiliateId) {
		var _v0 = A3($author$project$Components$Affiliates$PercentagePlan$init, apiClient, session, $elm$core$Maybe$Nothing);
		var percentagePlan = _v0.a;
		var percentagePlanCmd = _v0.b;
		return _Utils_Tuple2(
			{pp: affiliateId, js: percentagePlan, jY: $author$project$Api$Data$NotAsked},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg, percentagePlanCmd));
	});
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Affiliates$Plan$One$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Affiliates$Plan$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$id(one);
};
var $author$project$Api$Provider$Affiliates$Plan$One$networkPlans = function (_v0) {
	var record = _v0;
	return record.Ur;
};
var $author$project$Api$Provider$Affiliates$Plan$All$networkPlans = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(one);
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$init = F4(
	function (apiClient, session, affiliateId, plan) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						D8: $elm$core$Maybe$Just(affiliateId)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Plan'});
			});
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				kS: false,
				pp: affiliateId,
				adR: $author$project$Api$Provider$Affiliates$Plan$All$id(plan),
				d9: $author$project$Api$Data$NotAsked,
				Ur: $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan),
				jw: planResourceFilter,
				eN: $elm$core$Set$empty
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg, planResourceFilterCmd));
	});
var $author$project$Api$Provider$Affiliates$Plan$makeDefault = F4(
	function (apiClient, affiliateId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['default']),
					A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id))));
	});
var $author$project$Api$Provider$Affiliates$Plan$One$plan = function (_v0) {
	var record = _v0;
	return record.GH;
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$AffiliatePlanCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Closed = {$: 1};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None = {$: 0};
var $author$project$Api$Provider$Affiliates$Plan$create = F4(
	function (apiClient, affiliateId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pricing_type',
					$elm$json$Json$Encode$string(fields.afX)),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(fields.zh)),
					_Utils_Tuple2(
					'percentage',
					$elm$json$Json$Encode$float(fields.afJ)),
					_Utils_Tuple2(
					'fixed_amount_in_cents',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.adr)),
					_Utils_Tuple2(
					'default_plan',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.Nh))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Affiliates$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId))));
	});
var $author$project$Api$Provider$Affiliates$Plan$One$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$Affiliates$PercentagePlan$Plan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var plan = field.a;
				return _Utils_update(
					fields,
					{
						zh: $elm$core$Maybe$Nothing,
						afN: A2($elm$core$Maybe$map, $author$project$Api$Plan$id, plan)
					});
			case 0:
				var pricingType = field.a;
				return _Utils_update(
					fields,
					{afX: pricingType});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						zh: $author$project$Utils$String$toMaybe(string),
						afN: $elm$core$Maybe$Nothing
					});
			case 4:
				var _float = field.a;
				return _Utils_update(
					fields,
					{afJ: _float});
			default:
				var _int = field.a;
				return _Utils_update(
					fields,
					{adr: _int});
		}
	});
var $author$project$Components$Affiliates$PercentagePlan$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var field = msg.a;
			var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate, field, model.PB);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{PB: newForm}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			var subMsg = msg.a;
			var planResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jw);
			var modelAfterEvent = function () {
				var _v2 = planResourceFilterResult.ac5;
				if (!_v2.$) {
					if (!_v2.a.$) {
						if (!_v2.a.a.$) {
							var plan = _v2.a.a.a;
							return _Utils_update(
								model,
								{
									PB: A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate,
										$author$project$Components$Affiliates$PercentagePlan$Plan(
											$elm$core$Maybe$Just(plan)),
										model.PB)
								});
						} else {
							return _Utils_update(
								model,
								{
									PB: A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate,
										$author$project$Components$Affiliates$PercentagePlan$Plan($elm$core$Maybe$Nothing),
										model.PB)
								});
						}
					} else {
						var _v3 = _v2.a;
						return model;
					}
				} else {
					return model;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					modelAfterEvent,
					{jw: planResourceFilterResult.y8}),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg, planResourceFilterResult.EC),
				planResourceFilterResult.as);
		}
	});
var $author$project$Components$Affiliates$PercentagePlan$Exising = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$New = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$NameValidation = 1;
var $author$project$Components$Affiliates$PercentagePlan$validateName = function (fields) {
	var _v0 = _Utils_Tuple2(fields.afX, fields.zh);
	if ((_v0.a === 1) && (_v0.b.$ === 1)) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a name.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Affiliates$PercentagePlan$PercentageValidation = 2;
var $author$project$Components$Affiliates$PercentagePlan$validatePercentage = function (fields) {
	var _v0 = _Utils_Tuple2(
		fields.afX,
		A2(
			$author$project$Utils$Validate$isInvalidPercentage,
			{abi: false, yQ: $elm$core$Maybe$Nothing, TZ: $elm$core$Maybe$Nothing},
			fields.afJ));
	if ((_v0.a === 1) && _v0.b) {
		var _v1 = _v0.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter a percentage.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Affiliates$PercentagePlan$PlanValidation = 0;
var $author$project$Components$Affiliates$PercentagePlan$validatePlan = F2(
	function (affiliatePractice, fields) {
		var _v0 = _Utils_Tuple3(affiliatePractice, fields.afX, fields.afN);
		if (((!_v0.a.$) && (!_v0.b)) && (_v0.c.$ === 1)) {
			var _v1 = _v0.b;
			var _v2 = _v0.c;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please pick a plan.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Affiliates$PercentagePlan$formFieldsValidator = function (affiliatePractice) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Affiliates$PercentagePlan$validatePlan(affiliatePractice)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$PercentagePlan$validateName),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$PercentagePlan$validatePercentage)
			]));
};
var $author$project$Components$Affiliates$PercentagePlan$pricingTypeToString = function (pricingType) {
	if (!pricingType) {
		return 'fixed';
	} else {
		return 'percentage';
	}
};
var $author$project$Components$Affiliates$PercentagePlan$validate = function (_v0) {
	var model = _v0;
	var _v1 = A2(
		$author$project$Utils$Form$validate,
		$author$project$Components$Affiliates$PercentagePlan$formFieldsValidator(model.IF),
		model.PB);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var validatedForm = _v2.a;
		var validFormFields = _v2.b;
		var _v3 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var pricingType = _v3.afX;
		var planId = _v3.afN;
		var name = _v3.zh;
		var percentage = _v3.afJ;
		var fixedAmountInCents = _v3.adr;
		var percentagePlan = function () {
			if (!planId.$) {
				var planId_ = planId.a;
				return $author$project$Components$Affiliates$PercentagePlan$Exising(planId_);
			} else {
				return $author$project$Components$Affiliates$PercentagePlan$New(
					{
						adr: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fixedAmountInCents),
						zh: A2($elm$core$Maybe$withDefault, '', name),
						afJ: A2(
							$elm$core$Maybe$withDefault,
							0,
							A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, percentage)),
						afX: $author$project$Components$Affiliates$PercentagePlan$pricingTypeToString(pricingType)
					});
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{PB: validatedForm}),
			$elm$core$Maybe$Just(percentagePlan));
	} else {
		var validatedForm = _v1.a;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{PB: validatedForm}),
			$elm$core$Maybe$Nothing);
	}
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Closed, y8: model, as: _List_Nil};
			case 2:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Affiliates$PercentagePlan$update, apiClient, subMsg, model.js);
				var percentagePlan = _v1.a;
				var percentagePlanCmd = _v1.b;
				var percentagePlanOutMsgs = _v1.c;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg, percentagePlanCmd),
					ac5: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
					y8: _Utils_update(
						model,
						{js: percentagePlan}),
					as: percentagePlanOutMsgs
				};
			case 1:
				var _v2 = $author$project$Components$Affiliates$PercentagePlan$validate(model.js);
				var newPercentagePlan = _v2.a;
				var percentagePlanData = _v2.b;
				var _v3 = function () {
					if (!percentagePlanData.$) {
						var percentagePlanData_ = percentagePlanData.a;
						if (percentagePlanData_.$ === 1) {
							return _Utils_Tuple2(model.jY, $elm$core$Platform$Cmd$none);
						} else {
							var percentagePlanFields = percentagePlanData_.a;
							var fields = {
								Nh: $elm$core$Maybe$Just(true),
								adr: A2($elm$core$Maybe$map, $elm$core$Basics$negate, percentagePlanFields.adr),
								zh: percentagePlanFields.zh,
								afJ: percentagePlanFields.afJ,
								afX: percentagePlanFields.afX
							};
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A4($author$project$Api$Provider$Affiliates$Plan$create, apiClient, model.pp, fields, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Created));
						}
					} else {
						return _Utils_Tuple2(model.jY, $elm$core$Platform$Cmd$none);
					}
				}();
				var saveRequest = _v3.a;
				var cmd = _v3.b;
				return {
					EC: cmd,
					ac5: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
					y8: _Utils_update(
						model,
						{js: newPercentagePlan, jY: saveRequest}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var affiliatePlan = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$AffiliatePlanCreated(affiliatePlan),
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Affiliates$Plan$One$name(affiliatePlan) + ' plan added!')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AffiliatePlanUpdated = 2;
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Closed = 1;
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Linked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$None = 0;
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlinked = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliates$Plan$link = F5(
	function (apiClient, affiliateId, id, networkPlanId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'network_plan_id',
					$elm$json$Json$Encode$string(networkPlanId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Affiliates$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['link']),
						A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)))));
	});
var $author$project$Api$Provider$Affiliates$Plan$unlink = F5(
	function (apiClient, affiliateId, id, networkPlanId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'network_plan_id',
					$elm$json$Json$Encode$string(networkPlanId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Affiliates$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unlink']),
						A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)))));
	});
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{kS: true}),
					as: _List_Nil
				};
			case 2:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jw);
				var _v1 = function () {
					var _v2 = planResourceResult.ac5;
					if (((!_v2.$) && (!_v2.a.$)) && (!_v2.a.a.$)) {
						var plan = _v2.a.a.a;
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							A5(
								$author$project$Api$Provider$Affiliates$Plan$link,
								apiClient,
								model.pp,
								model.adR,
								$author$project$Api$Plan$id(plan),
								$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Linked));
					} else {
						return _Utils_Tuple2(model.d9, $elm$core$Platform$Cmd$none);
					}
				}();
				var linkRequest = _v1.a;
				var cmd = _v1.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg, planResourceResult.EC)
							])),
					ac5: 0,
					y8: _Utils_update(
						model,
						{d9: linkRequest, jw: planResourceResult.y8}),
					as: planResourceResult.as
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var plan = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{
								kS: false,
								d9: response,
								Ur: $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(plan)
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Network plan linked!')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{d9: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var plan = msg.a;
				var id = $author$project$Api$Provider$Plan$One$id(plan);
				return {
					EC: A5(
						$author$project$Api$Provider$Affiliates$Plan$unlink,
						apiClient,
						model.pp,
						model.adR,
						id,
						$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlinked(id)),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							eN: A2($elm$core$Set$insert, id, model.eN)
						}),
					as: _List_Nil
				};
			default:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var plan = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{
								d9: response,
								Ur: $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(plan),
								eN: A2($elm$core$Set$remove, id, model.eN)
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Network plan unlinked!')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								d9: response,
								eN: A2($elm$core$Set$remove, id, model.eN)
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{DZ: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Wq: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var _v1 = A3($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$init, model.D5, model.ZD, model.pp);
				var createNetworkPlanModal = _v1.a;
				var createNetworkPlanModalCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hZ: $elm$core$Maybe$Just(createNetworkPlanModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg, createNetworkPlanModalCmd),
					_List_Nil);
			case 3:
				var plan = msg.a;
				var _v2 = A4($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$init, model.D5, model.ZD, model.pp, plan);
				var editNetworkPlanModal = _v2.a;
				var editNetworkPlanModalCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							iu: $elm$core$Maybe$Just(editNetworkPlanModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg, editNetworkPlanModalCmd),
					_List_Nil);
			case 4:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							av: A2($elm$core$Set$insert, id, model.av)
						}),
					A4(
						$author$project$Api$Provider$Affiliates$Plan$delete,
						model.D5,
						model.pp,
						id,
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$Deleted(id)),
					_List_Nil);
			case 5:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Wq: $author$project$Api$Data$Loading,
								av: A2($elm$core$Set$remove, id, model.av)
							}),
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate plan deleted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								av: A2($elm$core$Set$remove, id, model.av)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							av: A2($elm$core$Set$insert, id, model.av)
						}),
					A4(
						$author$project$Api$Provider$Affiliates$Plan$makeDefault,
						model.D5,
						model.pp,
						id,
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$Defaulted(id)),
					_List_Nil);
			case 7:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Wq: $author$project$Api$Data$Loading,
								av: A2($elm$core$Set$remove, id, model.av)
							}),
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate plan is default')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								av: A2($elm$core$Set$remove, id, model.av)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var subMsg = msg.a;
				var _v5 = model.hZ;
				if (!_v5.$) {
					var createNetworkPlanModal = _v5.a;
					var createNetworkPlanModalResult = A3($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$update, model.D5, subMsg, createNetworkPlanModal);
					var _v6 = function () {
						var _v7 = createNetworkPlanModalResult.ac5;
						switch (_v7.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createNetworkPlanModalResult.y8),
									model.Wq,
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Wq, $elm$core$Maybe$Nothing);
							default:
								var plan = _v7.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$elm$core$Maybe$Just(plan));
						}
					}();
					var createNetworkPlanModal_ = _v6.a;
					var plans = _v6.b;
					var affiliatePlan = _v6.c;
					var _v8 = function () {
						if (!affiliatePlan.$) {
							var affiliatePlan_ = affiliatePlan.a;
							if ($author$project$Api$Provider$Plan$One$planType(
								$author$project$Api$Provider$Affiliates$Plan$One$plan(affiliatePlan_)) !== 4) {
								var planId = $author$project$Api$Provider$Plan$One$id(
									$author$project$Api$Provider$Affiliates$Plan$One$plan(affiliatePlan_));
								var affiliatePracticeId = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										A2($elm$core$Basics$composeR, $author$project$Api$Provider$Affiliate$One$affiliatePractice, $author$project$Api$Provider$Practice$One$organizationId),
										$author$project$Api$Data$toMaybe(model.DZ)));
								return _Utils_Tuple2(
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A3(
											$author$project$OutMsg$SwitchToOrganization,
											affiliatePracticeId,
											$elm$core$Maybe$Nothing,
											$author$project$OutMsg$GoToRouteAction(
												$author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String(
													{adR: planId})))
										]));
							} else {
								return _Utils_Tuple2(
									$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
									_List_Nil);
							}
						} else {
							return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
						}
					}();
					var cmd = _v8.a;
					var outMsgs = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hZ: createNetworkPlanModal_, Wq: plans}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg, createNetworkPlanModalResult.EC)
								])),
						_Utils_ap(outMsgs, createNetworkPlanModalResult.as));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var _v10 = model.iu;
				if (!_v10.$) {
					var editNetworkPlanModal = _v10.a;
					var editNetworkPlanModalResult = A3($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$update, model.D5, subMsg, editNetworkPlanModal);
					var _v11 = function () {
						var _v12 = editNetworkPlanModalResult.ac5;
						switch (_v12) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(editNetworkPlanModalResult.y8),
									model.Wq,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Wq, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(editNetworkPlanModalResult.y8),
									$author$project$Api$Data$Loading,
									$author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model));
						}
					}();
					var editNetworkPlanModal_ = _v11.a;
					var plans = _v11.b;
					var cmd = _v11.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iu: editNetworkPlanModal_, Wq: plans}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg, editNetworkPlanModalResult.EC)
								])),
						editNetworkPlanModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ds: true}),
					A3($author$project$Api$Provider$Affiliate$archive, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$Settings$AffiliationArchived),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{DZ: response, ds: false}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
								{pp: model.pp})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliation successfully archived')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ds: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ds: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ds: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$AddPlan = {$: 2};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$ArchiveAffiliationButtonClicked = {$: 11};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$ShowArchiveWarningModal = {$: 12};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$columns = function (isHintAdmin) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, '', false, 'Name'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, '', false, 'Billing Cycle'),
			A2(
				$elm$core$List$cons,
				A3($author$project$Api$Column$init, '', false, 'Billing Date'),
				A2(
					$elm$core$List$cons,
					A3($author$project$Api$Column$init, '', false, 'Affiliate Rate'),
					A2(
						$elm$core$List$cons,
						A3($author$project$Api$Column$init, '', false, 'Network Fee Plans'),
						isHintAdmin ? _List_fromArray(
							[
								A3($author$project$Api$Column$init, '', false, '')
							]) : _List_Nil)))));
};
var $author$project$Api$Provider$Affiliate$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Affiliate$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$status(shared);
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save = {$: 1};
var $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCentsValidation = 3;
var $author$project$Components$Affiliates$PercentagePlan$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$Name = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$Percentage = 1;
var $author$project$Components$Affiliates$PercentagePlan$PercentageField = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Platform$Practice$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Platform$Practice$One$name = function (_v0) {
	var min = _v0;
	return $author$project$Api$Platform$Practice$Min$name(min);
};
var $author$project$Components$Affiliates$PercentagePlan$PricingType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton = F3(
	function (currentPricingType, pricingType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentPricingType, pricingType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Affiliates$PercentagePlan$FormUpdated(
						$author$project$Components$Affiliates$PercentagePlan$PricingType(pricingType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Affiliates$PercentagePlan$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.IF;
				if (!_v1.$) {
					var affiliatePractice = _v1.a;
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Account Name'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Platform$Practice$One$name(affiliatePractice))
											]))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Payment Type')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								A3($author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton, fields.afX, 0, '$'),
								A3($author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton, fields.afX, 1, '%')
							]))
					])),
				function () {
				var _v2 = _Utils_Tuple2(model.IF, fields.afX);
				if ((!_v2.a.$) && (!_v2.b)) {
					var _v3 = _v2.b;
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Affiliate Fee Plan'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg,
								A2(
									$author$project$Components$ResourceFilter$Plan$view,
									_List_fromArray(
										[
											$author$project$Components$ResourceFilter$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
											$author$project$Components$ResourceFilter$errors(
											A2($author$project$Utils$Form$validationErrors, 0, model.PB))
										]),
									model.jw))
							]));
				} else {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(6),
								$author$project$Ui$Form$Group$label('Affiliate Fee Plan Name'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.zh)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$Name)),
										$author$project$Ui$Form$Input$placeholder('Affiliate Membership'),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 1, model.PB))
									]))
							]));
				}
			}(),
				function () {
				var _v4 = fields.afX;
				if (_v4 === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Amount paid to affiliate'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$PercentageInput$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$PercentageInput$value(fields.afJ),
										$author$project$Ui$Form$PercentageInput$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$PercentageField)),
										$author$project$Ui$Form$PercentageInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB)),
										$author$project$Ui$Form$PercentageInput$placeholder('10')
									])),
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, 2, model.PB))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = fields.afX;
				if (_v5 === 1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Amount subtracted per member'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$value(fields.adr),
										$author$project$Ui$Form$CurrencyInput$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCents)),
										$author$project$Ui$Form$CurrencyInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
										$author$project$Ui$Form$CurrencyInput$errors(
										A2($author$project$Utils$Form$validationErrors, 3, model.PB)),
										$author$project$Ui$Form$CurrencyInput$placeholder('10.00')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal,
		_List_fromArray(
			[
				$author$project$Ui$Modal$size(2)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('New Affiliate Fee Plan')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(true),
								$author$project$Ui$Form$onSubmit($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg,
								$author$project$Components$Affiliates$PercentagePlan$view(model.js))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Confirm plan'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save),
												$author$project$Ui$Button$fullWidth(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AddNew = {$: 1};
var $author$project$Components$ResourceFilter$Loading = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$loading = $author$project$Components$ResourceFilter$Loading;
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlink = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$viewNetworkPlan = F2(
	function (unlinkingPlans, networkPlan) {
		var loading = A2(
			$elm$core$Set$member,
			$author$project$Api$Provider$Plan$One$id(networkPlan),
			unlinkingPlans);
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Plan$One$name(networkPlan)),
					$author$project$Utils$Html$noBreakSpace,
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Delete plan'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$pull(1),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlink(networkPlan)),
							$author$project$Ui$Button$loading(loading),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Edit network fee plans')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(true),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Network fee plans'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(7)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$viewNetworkPlan(model.eN),
											model.Ur)),
										model.kS ? A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Plan$view,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$loading(
															_Utils_eq(model.d9, $author$project$Api$Data$Loading))
														]),
													model.jw))
											])) : $author$project$Utils$Html$empty,
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Add network plan'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AddNew),
												$author$project$Ui$Button$disabled(model.kS),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add network plan')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							]))
					]))
			]));
};
var $author$project$Api$Plan$ProviderOne = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Affiliates$Plan$One$billingDate = function (_v0) {
	var record = _v0;
	return record.J_;
};
var $author$project$Api$Provider$Affiliates$Plan$All$billingDate = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$billingDate(one);
};
var $author$project$Api$Provider$Affiliates$Plan$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$name(one);
};
var $author$project$Api$Provider$Affiliates$Plan$All$plan = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$plan(one);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewNetworkPlan = function (networkPlan) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Plan$One$name(networkPlan))
			]));
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Delete = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditPlan = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$MakeDefault = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Affiliates$Plan$One$default = function (_v0) {
	var record = _v0;
	return record.M5;
};
var $author$project$Api$Provider$Affiliates$Plan$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Affiliates$Plan$One$default(one);
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlanButtons = F3(
	function (isHintAdmin, savingPlans, plan) {
		if (isHintAdmin) {
			var id = $author$project$Api$Provider$Affiliates$Plan$All$id(plan);
			var loading = A2($elm$core$Set$member, id, savingPlans);
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{abp: 'Edit network fee plans'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$disabled(
											$author$project$Api$Provider$Affiliates$Plan$All$default(plan)),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Affiliates$AffiliateId_String$Settings$EditPlan(plan)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit network fee plans')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{abp: 'Delete network fee plans'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Affiliates$AffiliateId_String$Settings$Delete(id)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete affiliate fee plan')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Api$Provider$Affiliates$Plan$All$default(plan) ? A2(
									$author$project$Ui$Badge$view,
									_List_fromArray(
										[$author$project$Ui$Badge$primary]),
									_List_fromArray(
										[
											$elm$html$Html$text('Default')
										])) : $author$project$Utils$Html$empty,
									$author$project$Utils$Html$noBreakSpace,
									function () {
									if ($author$project$Api$Provider$Affiliates$Plan$All$default(plan)) {
										return $author$project$Utils$Html$empty;
									} else {
										var networkPlans = $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan);
										return $elm$core$List$isEmpty(networkPlans) ? A3(
											$author$project$Ui$HinterOnly$button,
											{abp: 'Make default'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Affiliates$AffiliateId_String$Settings$MakeDefault(id))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Make Default')
												])) : $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlan = F3(
	function (isHintAdmin, savingPlans, plan) {
		var networkPlans = $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Affiliates$Plan$All$name(plan))
						])),
				A2(
					$elm$core$List$cons,
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Affiliates$Plan$All$billingDate(plan)),
									$elm$html$Html$text(' day')
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Components$Plan$Summary$Pricing$view,
										$author$project$Api$Plan$ProviderOne(
											$author$project$Api$Provider$Affiliates$Plan$All$plan(plan)),
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Nothing)
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									$elm$core$List$isEmpty(networkPlans) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('None')
												]))
										]) : A2($elm$core$List$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewNetworkPlan, networkPlans)),
								A3($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlanButtons, isHintAdmin, savingPlans, plan)))))));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewBody = F2(
	function (model, affiliate) {
		var _v0 = function () {
			var _v1 = model.Wq;
			if (_v1.$ === 3) {
				var plans_ = _v1.a;
				return _Utils_Tuple2(false, plans_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var plans = _v0.b;
		return _List_fromArray(
			[
				function () {
				var _v2 = model.hZ;
				if (!_v2.$) {
					var createNetworkPlanModal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg,
						$author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$view(createNetworkPlanModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.iu;
				if (!_v3.$) {
					var editNetworkPlanModal = _v3.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg,
						$author$project$Components$Affiliates$Settings$EditNetworkPlanModal$view(editNetworkPlanModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$rowItemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(8)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Affiliate Fee Plans')
													]))
											])),
										function () {
										if (model.FR) {
											var isEnded = $author$project$Api$Provider$Affiliate$One$status(affiliate) === 'ended';
											return A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanSm(4),
														$author$project$Ui$FlexGrid$justifyRight
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$gap2]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Archive affiliation'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$danger,
																		$author$project$Ui$Button$disabled(isEnded),
																		$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$ShowArchiveWarningModal),
																		$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Archive Affiliation')
																	])),
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Add plan'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$AddPlan),
																		$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Add Plan')
																	]))
															]))
													]));
										} else {
											return $author$project$Ui$FlexGrid$none;
										}
									}()
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('This affiliate does not have any plans.')
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
							$author$project$Pages$Affiliates$AffiliateId_String$Settings$columns(model.FR)),
						A2(
							$elm$core$List$map,
							A2($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlan, model.FR, model.av),
							plans),
						_List_Nil)
					])),
				model.ds ? A3(
				$author$project$Ui$Modal$view,
				$author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal,
				_List_fromArray(
					[
						$author$project$Ui$Modal$size(1)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Archive affiliation')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to archive the affiliation?')
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Close warning modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Archive affiliation'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$ArchiveAffiliationButtonClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Archive')
									]))
							]))
					])) : $author$project$Utils$Html$empty
			]);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$view = function (model) {
	return {
		e5: function () {
			var _v0 = model.DZ;
			if (_v0.$ === 3) {
				var affiliate = _v0.a;
				return A2($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewBody, model, affiliate);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]))
					]);
			}
		}(),
		$G: 'Affiliates | Fee Plans'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$AffiliateId_String$Settings$init, aer: $author$project$Pages$Affiliates$AffiliateId_String$Settings$load, agD: $author$project$Pages$Affiliates$AffiliateId_String$Settings$save, ahd: $author$project$Pages$Affiliates$AffiliateId_String$Settings$subscriptions, aaq: $author$project$Pages$Affiliates$AffiliateId_String$Settings$update, ahP: $author$project$Pages$Affiliates$AffiliateId_String$Settings$view});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PracticeUser$Affiliate$PracticeUser = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeUser$Affiliate$Record = F7(
	function (id, email, role, notificationsEnabled, invitationPending, invitationUrl, user) {
		return {Oo: email, adR: id, Rf: invitationPending, Rg: invitationUrl, UO: notificationsEnabled, agy: role, aaz: user};
	});
var $author$project$Api$Provider$PracticeUser$Affiliate$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invitation_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invitation_pending',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'notifications_enabled',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'role',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'email',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$Affiliate$Record))))))));
var $author$project$Api$Provider$PracticeUser$Affiliate$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeUser$Affiliate$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Affiliates$TeamMember$teamMembersPath = function (affiliateId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['team_members']),
		$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
};
var $author$project$Api$Provider$Affiliates$TeamMember$list = F3(
	function (apiClient, affiliateId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PracticeUser$Affiliate$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Affiliates$TeamMember$teamMembersPath(affiliateId)));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var params = _v3.Vx;
		return _Utils_Tuple2(
			{pp: params.pp, D5: apiClient, j6: $elm$core$Set$empty, eK: $author$project$Api$Data$Loading},
			A3($author$project$Api$Provider$Affiliates$TeamMember$list, apiClient, params.pp, $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$GotInvitation = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$PracticeUser$Affiliate$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$PracticeUser$Affiliate$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Affiliate$invite = F4(
	function (apiClient, affiliateId, teamMemberId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member_id',
					$elm$json$Json$Encode$string(teamMemberId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['invite']),
						$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId)))));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eK: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var id = msg.a;
				var showInviteLinkFor = A2($elm$core$Set$member, id, model.j6) ? A2($elm$core$Set$remove, id, model.j6) : A2($elm$core$Set$insert, id, model.j6);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j6: showInviteLinkFor}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Affiliate$invite,
						model.D5,
						model.pp,
						$author$project$Api$Provider$PracticeUser$Affiliate$id(teamMember),
						$author$project$Pages$Affiliates$AffiliateId_String$Users$GotInvitation(
							$author$project$Api$Provider$PracticeUser$Affiliate$email(teamMember))),
					_List_Nil);
			default:
				var email = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eK: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Provider$Affiliates$TeamMember$list, model.D5, model.pp, $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'A new invitation is being sent to ' + email)
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name'),
		A3($author$project$Api$Column$init, 'email', false, 'Email'),
		A3($author$project$Api$Column$init, 'role', false, 'role'),
		A3($author$project$Api$Column$init, 'notifications', false, 'Notifications')
	]);
var $author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeUser$Affiliate$invitationPending = function (_v0) {
	var record = _v0;
	return record.Rf;
};
var $author$project$Api$Provider$PracticeUser$Affiliate$notificationsEnabled = function (_v0) {
	var record = _v0;
	return record.UO;
};
var $author$project$Api$Provider$PracticeUser$Affiliate$role = function (_v0) {
	var record = _v0;
	return record.agy;
};
var $author$project$Api$Provider$PracticeUser$Affiliate$user = function (_v0) {
	var record = _v0;
	return record.aaz;
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$ToggleInviteLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Popover$Hoverable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Popover$hoverable = $author$project$Ui$Popover$Hoverable;
var $author$project$Api$Provider$PracticeUser$Affiliate$invitationUrl = function (_v0) {
	var record = _v0;
	return record.Rg;
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$viewInviteLink = F2(
	function (visible, teamMember) {
		return A3(
			$author$project$Ui$Popover$view,
			_List_fromArray(
				[
					$author$project$Ui$Popover$visible(visible),
					$author$project$Ui$Popover$hoverable(false)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Show invite link'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$Affiliates$AffiliateId_String$Users$ToggleInviteLink(
								$author$project$Api$Provider$PracticeUser$Affiliate$id(teamMember)))
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 25),
							$elm$html$Html$text(' Show Invite Link')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Popover$heading,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Invite Directly')
						])),
					A2(
					$author$project$Ui$Popover$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$pre,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$PracticeUser$Affiliate$invitationUrl(teamMember)))
								]))
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$viewTeamMember = F2(
	function (showInviteLinkFor, teamMember) {
		var notificationsStatus = $author$project$Api$Provider$PracticeUser$Affiliate$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('11em')
						]),
					function () {
						var _v0 = $author$project$Api$Provider$PracticeUser$Affiliate$user(teamMember);
						if (!_v0.$) {
							var user = _v0.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$User$One$name(user))
										]))
								]);
						} else {
							var id = $author$project$Api$Provider$PracticeUser$Affiliate$id(teamMember);
							var showInviteLink = A2($elm$core$Set$member, id, showInviteLinkFor);
							return $author$project$Api$Provider$PracticeUser$Affiliate$invitationPending(teamMember) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Invitation Pending ')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Resend invitation email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resend')
												])),
											A2($author$project$Pages$Affiliates$AffiliateId_String$Users$viewInviteLink, showInviteLink, teamMember)
										]))
								]) : _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Not Invited ')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'send invitation email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember(teamMember))
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$Icon$view, _List_Nil, 11),
													$elm$html$Html$text(' Invite')
												])),
											A2($author$project$Pages$Affiliates$AffiliateId_String$Users$viewInviteLink, showInviteLink, teamMember)
										]))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$PracticeUser$Affiliate$email(teamMember))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Formatters$String$humanize(
									$author$project$Api$Provider$PracticeUser$Affiliate$role(teamMember))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
						]))
				]));
	});
var $author$project$Pages$Affiliates$AffiliateId_String$Users$view = function (model) {
	var _v0 = function () {
		var _v1 = model.eK;
		if (_v1.$ === 3) {
			var teamMembers_ = _v1.a;
			return _Utils_Tuple2(false, teamMembers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var teamMembers = _v0.b;
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Users')
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('This affiliate does not have any users.')
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
							$author$project$Pages$Affiliates$AffiliateId_String$Users$columns),
						A2(
							$elm$core$List$map,
							$author$project$Pages$Affiliates$AffiliateId_String$Users$viewTeamMember(model.j6),
							teamMembers),
						_List_Nil)
					]))
			]),
		$G: 'Affiliates | Users'
	};
};
var $author$project$Pages$Affiliates$AffiliateId_String$Users$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$AffiliateId_String$Users$init, aer: $author$project$Pages$Affiliates$AffiliateId_String$Users$load, agD: $author$project$Pages$Affiliates$AffiliateId_String$Users$save, ahd: $author$project$Pages$Affiliates$AffiliateId_String$Users$subscriptions, aaq: $author$project$Pages$Affiliates$AffiliateId_String$Users$update, ahP: $author$project$Pages$Affiliates$AffiliateId_String$Users$view});
var $author$project$Pages$Affiliates$Create$GotAffiliatePractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Practice$One$Practice = $elm$core$Basics$identity;
var $author$project$Api$Platform$Practice$Min$Practice = $elm$core$Basics$identity;
var $author$project$Api$Platform$Practice$Min$Record = F5(
	function (id, name, isDeactivated, flaggedNotesCount, requiresMfa) {
		return {Py: flaggedNotesCount, adR: id, RH: isDeactivated, zh: name, Yn: requiresMfa};
	});
var $author$project$Api$Platform$Practice$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requires_mfa',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'flagged_notes_count',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_deactivated',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$Min$Record))))));
var $author$project$Api$Platform$Practice$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Practice$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Practice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Practice$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$User$Practice$practicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practices']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Practice$practicePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Platform$User$Practice$practicesPath);
};
var $author$project$Api$Platform$User$Practice$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Platform$User$Practice$practicePath(id)));
	});
var $author$project$Pages$Affiliates$Create$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var query = _v1.Bi;
		var cmd = function () {
			var _v2 = A2($elm$core$Dict$get, 'affiliatePracticeId', query);
			if (!_v2.$) {
				var affiliatePracticeId = _v2.a;
				return A3($author$project$Api$Platform$User$Practice$retrieve, apiClient, affiliatePracticeId, $author$project$Pages$Affiliates$Create$GotAffiliatePractice);
			} else {
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__New);
			}
		}();
		return _Utils_Tuple2(
			{
				IF: $author$project$Api$Data$Loading,
				abb: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Dict$get, 'affiliatePracticeId', query)),
				D5: apiClient,
				js: $elm$core$Maybe$Nothing,
				WF: practice,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session
			},
			cmd);
	});
var $author$project$Pages$Affiliates$Create$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$Create$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$Create$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Affiliates$Create$AffiliateCreated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Affiliates$Create$AffiliatePlanCreated = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Affiliates$Create$PercentagePlanMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Affiliate$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'affiliation',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'affiliate_practice_id',
								$elm$json$Json$Encode$string(fields.abb)),
								_Utils_Tuple2(
								'plan_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.afN))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Affiliate$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliate$affiliatesPath)));
	});
var $author$project$Pages$Affiliates$Create$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var affiliatePractice = response.a;
						var _v2 = A3(
							$author$project$Components$Affiliates$PercentagePlan$init,
							model.D5,
							model.ZD,
							$elm$core$Maybe$Just(affiliatePractice));
						var percentagePlan = _v2.a;
						var percentagePlanCmd = _v2.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									IF: response,
									js: $elm$core$Maybe$Just(percentagePlan)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Create$PercentagePlanMsg, percentagePlanCmd),
							_List_Nil);
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{IF: response}),
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__New),
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{IF: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v3 = model.js;
				if (!_v3.$) {
					var percentagePlan = _v3.a;
					var _v4 = A3($author$project$Components$Affiliates$PercentagePlan$update, model.D5, subMsg, percentagePlan);
					var percentagePlan_ = _v4.a;
					var percentagePlanCmd = _v4.b;
					var percentagePlanOutMsgs = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								js: $elm$core$Maybe$Just(percentagePlan_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Create$PercentagePlanMsg, percentagePlanCmd),
						percentagePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v5 = model.js;
				if (!_v5.$) {
					var percentagePlan = _v5.a;
					var _v6 = $author$project$Components$Affiliates$PercentagePlan$validate(percentagePlan);
					var newPercentagePlan = _v6.a;
					var percentagePlanData = _v6.b;
					var _v7 = function () {
						if (!percentagePlanData.$) {
							var percentagePlanData_ = percentagePlanData.a;
							var planId = function () {
								if (percentagePlanData_.$ === 1) {
									var planId_ = percentagePlanData_.a;
									return $elm$core$Maybe$Just(planId_);
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}();
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3(
									$author$project$Api$Provider$Affiliate$create,
									model.D5,
									{abb: model.abb, afN: planId},
									$author$project$Pages$Affiliates$Create$AffiliateCreated(percentagePlanData_)));
						} else {
							return _Utils_Tuple2(model.jY, $elm$core$Platform$Cmd$none);
						}
					}();
					var saveRequest = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								js: $elm$core$Maybe$Just(newPercentagePlan),
								jY: saveRequest
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var percentagePlan = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var affiliate = response.a;
					var _v11 = function () {
						if (percentagePlan.$ === 1) {
							return _Utils_Tuple2(
								response,
								A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders(
										{
											pp: $author$project$Api$Provider$Affiliate$One$id(affiliate)
										})));
						} else {
							var percentagePlanFields = percentagePlan.a;
							var fields = {
								Nh: $elm$core$Maybe$Just(true),
								adr: A2($elm$core$Maybe$map, $elm$core$Basics$negate, percentagePlanFields.adr),
								zh: percentagePlanFields.zh,
								afJ: percentagePlanFields.afJ,
								afX: percentagePlanFields.afX
							};
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A4(
									$author$project$Api$Provider$Affiliates$Plan$create,
									model.D5,
									$author$project$Api$Provider$Affiliate$One$id(affiliate),
									fields,
									$author$project$Pages$Affiliates$Create$AffiliatePlanCreated(affiliate)));
						}
					}();
					var saveRequest = _v11.a;
					var cmd = _v11.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: saveRequest}),
						cmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate added!')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var affiliate = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var affiliatePlan = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders(
								{
									pp: $author$project$Api$Provider$Affiliate$One$id(affiliate)
								})),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Affiliates$Plan$One$name(affiliatePlan) + ' plan added!')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Affiliates$Create$Create = {$: 2};
var $author$project$Pages$Affiliates$Create$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Manage affiliates')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__New,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Add new affiliate')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Create Affiliation')
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text('Create affiliation')
													]))
											]))
									])),
								function () {
								var _v0 = model.js;
								if (!_v0.$) {
									var percentagePlan = _v0.a;
									return A2(
										$author$project$Ui$Form$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$noValidate(true),
												$author$project$Ui$Form$autocomplete(true),
												$author$project$Ui$Form$onSubmit($author$project$Pages$Affiliates$Create$Create),
												$author$project$Ui$Form$horizontal
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Affiliates$Create$PercentagePlanMsg,
												$author$project$Components$Affiliates$PercentagePlan$view(percentagePlan))
											]));
								} else {
									return A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]));
								}
							}()
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Affiliates__New,
								_List_fromArray(
									[$author$project$Ui$Link$buttonDefault]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Create affiliation'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick($author$project$Pages$Affiliates$Create$Create),
										$author$project$Ui$Button$loading(
										_Utils_eq(model.jY, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Create Affiliation')
									]))
							]))
					]))
			]),
		$G: 'Affiliates'
	};
};
var $author$project$Pages$Affiliates$Create$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$Create$init, aer: $author$project$Pages$Affiliates$Create$load, agD: $author$project$Pages$Affiliates$Create$save, ahd: $author$project$Pages$Affiliates$Create$subscriptions, aaq: $author$project$Pages$Affiliates$Create$update, ahP: $author$project$Pages$Affiliates$Create$view});
var $author$project$Api$Platform$User$Practice$Affiliates = 0;
var $author$project$Pages$Affiliates$New$GotPractices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Practice$All$Practice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Practice$All$Record = F4(
	function (address, organizationId, owner, productType) {
		return {It: address, aft: organizationId, Vp: owner, GT: productType};
	});
var $author$project$Api$Platform$User$Min$User = $elm$core$Basics$identity;
var $author$project$Api$Platform$User$Min$Record = F3(
	function (id, name, email) {
		return {Oo: email, adR: id, zh: name};
	});
var $author$project$Api$Platform$User$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$Min$Record))));
var $author$project$Api$Platform$User$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$User$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Practice$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'product_type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'owner',
		$elm$json$Json$Decode$nullable($author$project$Api$Platform$User$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'organization_id',
			$elm$json$Json$Decode$string,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'address',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$All$Record)))));
var $author$project$Api$Platform$Practice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Practice$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$Practice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$All$Practice)));
var $author$project$Api$Platform$User$Practice$expandToString = function (expand) {
	return 'affiliates';
};
var $author$project$Api$Platform$User$Practice$listDefaults = {
	D_: $elm$core$Maybe$Nothing,
	Fc: _List_Nil,
	Fi: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
	HD: $elm$core$Maybe$Nothing
};
var $author$project$Api$Platform$User$Practice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$Practice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Fi;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.HD;
				if (!_v2.$) {
					var bool = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'unaffiliated', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.D_;
				if (!_v3.$) {
					var bool = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'affiliated', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				_List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Platform$User$Practice$expandToString, options.Fc))
				]),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Platform$User$Practice$list = F4(
	function (apiClient, optionals, maybeTracker, toMsg) {
		var request = function (req) {
			if (!maybeTracker.$) {
				var tracker = maybeTracker.a;
				return A2($author$project$Api$Data$requestWithTracker, tracker, req);
			} else {
				return req;
			}
		}(
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$Practice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Practice$practicesPath)));
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Practice$All$decoder),
			toMsg,
			request);
	});
var $author$project$Pages$Affiliates$New$fetchData = function (model) {
	return A4(
		$author$project$Api$Platform$User$Practice$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					Fc: _List_fromArray(
						[0]),
					afy: model.afy,
					af_: model.af_,
					ag1: model.ag1,
					HD: $elm$core$Maybe$Just(true)
				});
		},
		$elm$core$Maybe$Nothing,
		$author$project$Pages$Affiliates$New$GotPractices);
};
var $author$project$Pages$Affiliates$New$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var query = _v3.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: apiClient,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			jB: $author$project$Api$Data$Loading,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Affiliates$New$fetchData(model));
	});
var $author$project$Pages$Affiliates$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Affiliates$New$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$New$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Affiliates__New)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Affiliates$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								jB: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								afy: $author$project$Api$Pagination$reset(model.afy),
								jB: $author$project$Api$Data$Loading,
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Affiliates$New$fetchData(qModel),
										$author$project$Pages$Affiliates$New$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$New$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, jB: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$New$fetchData(newModel),
								$author$project$Pages$Affiliates$New$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$New$fetchData(newModel),
								$author$project$Pages$Affiliates$New$updateUrl(newModel)
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Affiliates$New$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Affiliates$New$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$New$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Affiliate Name'),
		A3($author$project$Api$Column$init, 'address', false, 'Address')
	]);
var $author$project$Api$Platform$Practice$All$address = function (_v0) {
	var record = _v0.b;
	return record.It;
};
var $author$project$Api$Platform$Practice$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Platform$Practice$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$id(min);
};
var $author$project$Api$Platform$Practice$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$name(min);
};
var $author$project$Pages$Affiliates$New$viewPractice = function (practice) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Platform$Practice$All$name(practice))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = $author$project$Api$Platform$Practice$All$address(practice);
						if (!_v0.$) {
							var address = _v0.a;
							return $author$project$Components$AddressDisplay$view(address);
						} else {
							return $elm$html$Html$text('N/A');
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Affiliates__Create,
						_List_fromArray(
							[
								$author$project$Ui$Link$buttonDefault,
								$author$project$Ui$Link$sm,
								$author$project$Ui$Link$pull(1),
								$author$project$Ui$Link$routeParams(
								_List_fromArray(
									[
										A2(
										$elm$url$Url$Builder$string,
										'affiliatePracticeId',
										$author$project$Api$Platform$Practice$All$id(practice))
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Set up an affiliation')
							]))
					]))
			]));
};
var $author$project$Pages$Affiliates$New$view = function (model) {
	var _v0 = function () {
		var _v1 = model.jB;
		if (_v1.$ === 3) {
			var practices_ = _v1.a;
			return _Utils_Tuple2(false, practices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var practices = _v0.b;
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Affiliates__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Manage affiliates')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add new affiliate')
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(3)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text('Find new affiliate on this platform')
													]))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(3),
												$author$project$Ui$FlexGrid$offsetSm(6)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Hinter__NewPractice,
												_List_fromArray(
													[
														$author$project$Ui$Link$buttonDefault,
														$author$project$Ui$Link$pull(1),
														$author$project$Ui$Link$routeParams(
														_List_fromArray(
															[
																A2(
																$elm$url$Url$Builder$string,
																'affiliateWizard',
																$author$project$Utils$Bool$toString(true))
															])),
														$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Create new account')
													]))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Affiliates$New$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
													]))
											]))
									])),
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$loading(loading),
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('No matching results.')
											]))
									]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										$author$project$Api$Column$view(
											A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Affiliates$New$SortTable)),
										$author$project$Pages$Affiliates$New$columns),
									_List_fromArray(
										[
											A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
										])),
								A2($elm$core$List$map, $author$project$Pages$Affiliates$New$viewPractice, practices),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Affiliates$New$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Affiliates'
	};
};
var $author$project$Pages$Affiliates$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$New$init, aer: $author$project$Pages$Affiliates$New$load, agD: $author$project$Pages$Affiliates$New$save, ahd: $author$project$Pages$Affiliates$New$subscriptions, aaq: $author$project$Pages$Affiliates$New$update, ahP: $author$project$Pages$Affiliates$New$view});
var $author$project$Pages$Affiliates$Top$StatusDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Affiliates$Top$GotAffiliates = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Affiliate$All$Affiliate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Affiliate$All$Record = F4(
	function (activeLives, amountOwed, createdFrom, address) {
		return {If: activeLives, It: address, I4: amountOwed, ach: createdFrom};
	});
var $author$project$Api$Provider$Affiliate$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'address',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_from',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'amount_owed',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'active_lives',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$All$Record)))));
var $author$project$Api$Provider$Affiliate$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Affiliate$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$All$Affiliate)));
var $author$project$Api$Provider$Affiliate$listDefaults = {
	adR: $elm$core$Maybe$Nothing,
	aet: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	afS: $elm$core$Maybe$Nothing,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
	ag7: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Affiliate$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Affiliate$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.ag7;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				function () {
				var _v3 = options.afS;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'practitioner', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.aet;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'location', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Affiliate$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Affiliate$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Affiliate$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliate$affiliatesPath)));
	});
var $author$project$Pages$Affiliates$Top$statusToValue = function (status) {
	switch (status) {
		case 0:
			return 'active';
		case 1:
			return 'pending';
		default:
			return 'ended';
	}
};
var $author$project$Pages$Affiliates$Top$fetchData = function (model) {
	return A3(
		$author$project$Api$Provider$Affiliate$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					afy: model.afy,
					af_: model.af_,
					ag1: model.ag1,
					ag7: A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$Top$statusToValue, model.ag7)
				});
		},
		$author$project$Pages$Affiliates$Top$GotAffiliates);
};
var $author$project$Pages$Affiliates$Top$Active = 0;
var $author$project$Pages$Affiliates$Top$Ended = 2;
var $author$project$Pages$Affiliates$Top$Pending = 1;
var $author$project$Pages$Affiliates$Top$statusFromQuery = function (queryString) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (status) {
			return _Utils_eq(
				$author$project$Pages$Affiliates$Top$statusToValue(status),
				queryString);
		},
		_List_fromArray(
			[0, 1, 2]));
};
var $author$project$Pages$Affiliates$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			eX: $author$project$Api$Data$Loading,
			D5: shared.D5,
			FR: $author$project$Shared$isHintAdmin(shared),
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			ag7: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Affiliates$Top$statusFromQuery,
				A2($elm$core$Dict$get, 'status', query)),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'status-dropdown-filter', ahx: $author$project$Pages$Affiliates$Top$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Affiliates$Top$fetchData(model));
	});
var $author$project$Pages$Affiliates$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Affiliates$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Affiliates$Top$subscriptions = function (model) {
	return $author$project$Ui$NewDropdown$subscriptions(model.oA);
};
var $author$project$Pages$Affiliates$Top$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Affiliates$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Affiliates$Top$statusToValue,
				$elm$url$Url$Builder$string('status')),
			model.ag7)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Affiliates__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Affiliates$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eX: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eX: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								eX: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Affiliates$Top$fetchData(qModel),
										$author$project$Pages$Affiliates$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{eX: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$Top$fetchData(newModel),
								$author$project$Pages$Affiliates$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var dropdown = _v5.a;
				var dropdownCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 3:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{eX: $author$project$Api$Data$Loading, ag7: status});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$Top$fetchData(newModel),
								$author$project$Pages$Affiliates$Top$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Affiliates$Top$fetchData(newModel),
								$author$project$Pages$Affiliates$Top$updateUrl(newModel)
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Affiliates$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Affiliates$Top$SortTable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Affiliates$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Affiliate Name'),
		A3($author$project$Api$Column$init, 'address', false, 'Address'),
		A3($author$project$Api$Column$init, 'active_lives', false, 'Active Lives'),
		A3($author$project$Api$Column$init, 'amount_owed', false, 'Amount Owed'),
		A3($author$project$Api$Column$init, 'status', true, 'Status')
	]);
var $author$project$Api$Provider$Affiliate$All$activeLives = function (_v0) {
	var record = _v0.b;
	return record.If;
};
var $author$project$Api$Provider$Affiliate$All$address = function (_v0) {
	var record = _v0.b;
	return record.It;
};
var $author$project$Api$Provider$Affiliate$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$id(shared);
};
var $author$project$Api$Provider$Affiliate$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$status(shared);
};
var $author$project$Pages$Affiliates$Top$affiliateRoute = function (affiliate) {
	return ($author$project$Api$Provider$Affiliate$All$status(affiliate) === 'pending') ? $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders(
		{
			pp: $author$project$Api$Provider$Affiliate$All$id(affiliate)
		}) : $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
		{
			pp: $author$project$Api$Provider$Affiliate$All$id(affiliate)
		});
};
var $author$project$Api$Provider$Affiliate$All$amountOwed = function (_v0) {
	var record = _v0.b;
	return record.I4;
};
var $author$project$Api$Provider$Affiliate$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Affiliate$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$name(shared);
};
var $author$project$Pages$Affiliates$Top$viewAffiliate = function (affiliate) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Pages$Affiliates$Top$affiliateRoute(affiliate),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Provider$Affiliate$All$name(affiliate)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = $author$project$Api$Provider$Affiliate$All$address(affiliate);
						if (!_v0.$) {
							var address = _v0.a;
							return $author$project$Components$AddressDisplay$view(address);
						} else {
							return $elm$html$Html$text('N/A');
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Provider$Affiliate$All$activeLives(affiliate)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Provider$Affiliate$All$amountOwed(affiliate)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						$author$project$Api$Provider$Affiliate$All$status(affiliate))
					]))
			]));
};
var $author$project$Pages$Affiliates$Top$StatusSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Affiliates$Top$statusToLabel = function (status) {
	if (!status.$) {
		switch (status.a) {
			case 0:
				var _v1 = status.a;
				return 'Active';
			case 1:
				var _v2 = status.a;
				return 'Pending';
			default:
				var _v3 = status.a;
				return 'Ended';
		}
	} else {
		return 'All Status';
	}
};
var $author$project$Pages$Affiliates$Top$statusDropdownOptions = function (currentStatus) {
	var statusToItem = function (status) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Affiliates$Top$StatusSelected(status)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(status, currentStatus))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Affiliates$Top$statusToLabel(status)));
	};
	return A2(
		$elm$core$List$cons,
		statusToItem($elm$core$Maybe$Nothing),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, statusToItem),
				_List_fromArray(
					[0, 1, 2]))));
};
var $author$project$Pages$Affiliates$Top$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Affiliates$Top$statusToLabel(model.ag7))
			]),
		$author$project$Pages$Affiliates$Top$statusDropdownOptions(model.ag7),
		model.oA);
};
var $author$project$Pages$Affiliates$Top$view = function (model) {
	var _v0 = function () {
		var _v1 = model.eX;
		if (_v1.$ === 3) {
			var affiliates_ = _v1.a;
			return _Utils_Tuple2(false, affiliates_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var affiliates = _v0.b;
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(7)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Affiliates$Top$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
													]))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(2)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Affiliates$Top$viewStatusDropdown(model)
											])),
										model.FR ? A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(3)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$HinterOnly$linkRoute,
												$author$project$Spa$Generated$Route$Affiliates__New,
												_List_fromArray(
													[
														$author$project$Ui$Link$buttonDefault,
														$author$project$Ui$Link$pull(1),
														$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add new affiliate')
													]))
											])) : $author$project$Ui$FlexGrid$none
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('No matching results.')
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Api$Column$view(
								A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Affiliates$Top$SortTable)),
							$author$project$Pages$Affiliates$Top$columns),
						A2($elm$core$List$map, $author$project$Pages$Affiliates$Top$viewAffiliate, affiliates),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Affiliates$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Affiliates | Manage'
	};
};
var $author$project$Pages$Affiliates$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Affiliates$Top$init, aer: $author$project$Pages$Affiliates$Top$load, agD: $author$project$Pages$Affiliates$Top$save, ahd: $author$project$Pages$Affiliates$Top$subscriptions, aaq: $author$project$Pages$Affiliates$Top$update, ahP: $author$project$Pages$Affiliates$Top$view});
var $author$project$Pages$Apps$Slug_String$GotPartnerApp = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$One$PartnerApp = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$PartnerApp$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PartnerApp$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$PartnerApp$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id]),
					$author$project$Api$Provider$PartnerApp$partnerAppsPath)));
	});
var $author$project$Pages$Apps$Slug_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple2(
			{D5: shared.D5, VB: $author$project$Api$Data$Loading, WF: practice, ZD: session},
			A3($author$project$Api$Provider$PartnerApp$retrieve, shared.D5, params._c, $elm$core$Basics$identity));
	});
var $author$project$Pages$Apps$Slug_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Apps$Slug_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Apps$Slug_String$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Api$Common$PartnerApp$Anchor$isCorePage = function (_v0) {
	var record = _v0;
	var _v1 = record.ahI;
	if (!_v1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Common$PartnerApp$Shared$corePageAnchor = function (_v0) {
	var record = _v0;
	return A2($elm_community$list_extra$List$Extra$find, $author$project$Api$Common$PartnerApp$Anchor$isCorePage, record.D2);
};
var $author$project$Api$Common$PartnerApp$Shared$embedsCorePage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$PartnerApp$Shared$corePageAnchor,
	$elm$core$Basics$neq($elm$core$Maybe$Nothing));
var $author$project$Api$Common$PartnerApp$One$shared = function (_v0) {
	var shared_ = _v0;
	return shared_;
};
var $author$project$Api$Common$PartnerApp$One$embedsCorePage = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$embedsCorePage);
var $author$project$Api$Common$PartnerApp$One$id = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$id);
var $author$project$Pages$Apps$Slug_String$update = F2(
	function (msg, model) {
		var response = msg;
		if (response.$ === 3) {
			var app = response.a;
			var cmd = $author$project$Api$Common$PartnerApp$One$embedsCorePage(app) ? A2(
				$author$project$Ports$PartnerApps$mount,
				'partner-app',
				{
					abn: $author$project$Api$Common$PartnerApp$One$id(app),
					ahI: 'core_page'
				}) : $elm$core$Platform$Cmd$none;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{VB: response}),
				cmd,
				$author$project$OutMsg$handleErrorResponse(response));
		} else {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{VB: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Api$Common$PartnerApp$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Common$PartnerApp$One$name = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$name);
var $author$project$Pages$Apps$Slug_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('partner-app-wrapper'),
						$elm$html$Html$Attributes$id('partner-app')
					]),
				_List_Nil)
			]),
		$G: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$PartnerApp$One$name,
				$author$project$Api$Data$toMaybe(model.VB)))
	};
};
var $author$project$Pages$Apps$Slug_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Apps$Slug_String$init, aer: $author$project$Pages$Apps$Slug_String$load, agD: $author$project$Pages$Apps$Slug_String$save, ahd: $author$project$Pages$Apps$Slug_String$subscriptions, aaq: $author$project$Pages$Apps$Slug_String$update, ahP: $author$project$Pages$Apps$Slug_String$view});
var $author$project$Spa$Page$ignoreEffect = function (model) {
	return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
};
var $author$project$Spa$Page$static = function (view) {
	return {
		ad0: F2(
			function (_v0, url) {
				return _Utils_Tuple3(url, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aer: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v1) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: F2(
			function (_v2, model) {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		ahP: view
	};
};
var $author$project$Pages$Blank$view = function (_v0) {
	return {e5: _List_Nil, $G: ''};
};
var $author$project$Pages$Blank$page = $author$project$Spa$Page$static($author$project$Pages$Blank$view);
var $author$project$Pages$Calendar$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Calendar$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Calendar$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Calendar$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Calendar'};
};
var $author$project$Pages$Calendar$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Calendar$init,
		aer: $author$project$Pages$Calendar$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Calendar$update,
		ahP: $author$project$Pages$Calendar$view
	});
var $author$project$Pages$Charges$New$ChargeFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Charge$Form$CategoryResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Charge$Form$EndDateInputMsg = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Charge$Form$LocationResourceFilterMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Charge$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Charge$Form$PatientResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Charge$Form$PractitionerResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Charge$Form$RoutingFieldsMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Charge$Form$StartDateInputMsg = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Charge$Form$RoutingFields$GotCurrentDate = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$initFields = {aea: $elm$core$Maybe$Nothing, afG: $elm$core$Maybe$Nothing, VW: 0};
var $author$project$Components$Charge$Form$RoutingFields$init = F2(
	function (apiClient, practice) {
		var _v0 = A2($author$project$Components$ResourceFilter$Patient$init, apiClient, $elm$core$Basics$identity);
		var patientPayerFilter = _v0.a;
		return _Utils_Tuple2(
			{
				cO: $elm$core$Maybe$Nothing,
				cP: $author$project$Api$Data$NotAsked,
				adm: $author$project$Components$Charge$Form$RoutingFields$initFields,
				afy: A2($author$project$Api$Pagination$withItemsPerPage, 20, $author$project$Api$Pagination$init),
				VM: $author$project$Api$Data$NotAsked,
				VN: '',
				eg: patientPayerFilter,
				AI: false,
				WF: practice,
				afU: $author$project$Api$Data$NotAsked,
				jD: $author$project$Api$Data$NotAsked,
				gQ: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFields$GotCurrentDate, $justinmimbs$date$Date$today));
	});
var $author$project$Components$Charge$Form$initCategoryResourceFilter = F3(
	function (apiClient, session, excludeLabs) {
		var excludedCategoryTitles = excludeLabs ? $elm$core$Maybe$Just(
			_List_fromArray(
				['Labs'])) : $elm$core$Maybe$Nothing;
		return A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', ac7: excludedCategoryTitles});
			});
	});
var $author$project$Components$Charge$Form$initChargeItemResourceFilter = F2(
	function (apiClient, showItemTypeInTitle) {
		return A4(
			$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
			showItemTypeInTitle,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Charge Item', IS: false, adB: true, adC: '', adJ: true, adK: true, aeZ: false});
			});
	});
var $author$project$Components$Charge$Form$initFormFields = F4(
	function (today, startDateInput, endDateInput, categoryResourceFilter) {
		return {
			Ex: $elm$core$Maybe$Nothing,
			cJ: categoryResourceFilter,
			lp: $elm$core$Maybe$Nothing,
			MO: today,
			Nx: '',
			NI: 0,
			NJ: false,
			qs: $elm$core$Maybe$Nothing,
			qu: endDateInput,
			Rh: $elm$core$Maybe$Nothing,
			aet: $elm$core$Maybe$Nothing,
			zh: $elm$core$Maybe$Nothing,
			VM: $elm$core$Maybe$Nothing,
			GD: $elm$core$Maybe$Nothing,
			VW: 0,
			afS: $elm$core$Maybe$Nothing,
			Ba: $elm$core$Maybe$Nothing,
			W$: $elm$core$Maybe$Nothing,
			Bd: $elm$core$Maybe$Just(1),
			Be: $elm$core$Maybe$Nothing,
			_E: today,
			kg: startDateInput
		};
	});
var $author$project$Components$Charge$Form$initLocationResourceFilter = function (apiClient) {
	return A4(
		$author$project$Components$ResourceFilter$Location$init,
		apiClient,
		$elm$core$Maybe$Nothing,
		$elm$core$Basics$identity,
		function (d) {
			return _Utils_update(
				d,
				{D0: 'Unassigned', aeZ: false});
		});
};
var $author$project$Api$Provider$Patient$One$record_ = function (_v0) {
	var record = _v0.b;
	return record;
};
var $author$project$Api$Provider$Patient$One$age = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.IK;
	});
var $author$project$Components$ResourceFilter$Patient$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {
					aej: _Utils_ap(
						item.zh,
						_Utils_ap(
							function () {
								var _v0 = item.IK;
								if (!_v0.$) {
									var age = _v0.a;
									return ' - ' + $elm$core$String$fromInt(age);
								} else {
									return '';
								}
							}(),
							(!$elm$core$String$isEmpty(item.TL)) ? (' - ' + $author$project$Formatters$String$humanize(item.TL)) : '')),
					aaN: item.adR
				};
			},
			list_);
		return _Utils_update(
			model,
			{
				bb: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bb)
			});
	});
var $author$project$Api$Provider$Patient$One$membershipStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
};
var $author$project$Components$Charge$Form$initPatientResourceFilter = F2(
	function (apiClient, preselectedPatient) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Patient$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (patient_) {
							return _List_fromArray(
								[
									{
									IK: $author$project$Api$Provider$Patient$One$age(patient_),
									adR: $author$project$Api$Provider$Patient$One$id(patient_),
									TL: $author$project$Api$Provider$Patient$One$membershipStatus(patient_),
									zh: $author$project$Api$Provider$Patient$One$name(patient_)
								}
								]);
						},
						preselectedPatient))),
			A3(
				$author$project$Components$ResourceFilter$Patient$initWithId,
				'charge-form-patient',
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Select a Patient',
							IS: false,
							afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$One$id, preselectedPatient)
						});
				}));
	});
var $author$project$Components$Charge$Form$initPractitionerResourceFilter = function (apiClient) {
	return A3(
		$author$project$Components$ResourceFilter$Practitioner$init,
		apiClient,
		$elm$core$Basics$identity,
		function (d) {
			return _Utils_update(
				d,
				{D0: 'Unassigned'});
		});
};
var $author$project$Components$Charge$Form$PreloadedPatient = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Charge$Form$preloadPatient = F2(
	function (apiClient, preselectedPatientId) {
		return A3($author$project$Api$Provider$Patient$retrieve, apiClient, preselectedPatientId, $author$project$Components$Charge$Form$PreloadedPatient);
	});
var $author$project$Components$Charge$Form$init = F5(
	function (apiClient, session, practice, preselectedPatientId, _v0) {
		var currentDate = _v0.cO;
		var packageFeatureEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice);
		var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice);
		var _v1 = $author$project$Components$DateInput$init;
		var startDateInput = _v1.a;
		var startDateInputCmd = _v1.b;
		var _v2 = A2($author$project$Components$Charge$Form$RoutingFields$init, apiClient, practice);
		var routingFields = _v2.a;
		var routingFieldsCmd = _v2.b;
		var _v3 = function () {
			if (!preselectedPatientId.$) {
				var patId = preselectedPatientId.a;
				return _Utils_Tuple2(
					A2($author$project$Components$Charge$Form$preloadPatient, apiClient, patId),
					$author$project$Api$Data$Loading);
			} else {
				return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
			}
		}();
		var preloadPatientCmd = _v3.a;
		var preloadedPatientData = _v3.b;
		var _v5 = $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
		var practitionerResourceFilter = _v5.a;
		var practitionerResourceFilterCmd = _v5.b;
		var _v6 = A2($author$project$Components$Charge$Form$initPatientResourceFilter, apiClient, $elm$core$Maybe$Nothing);
		var patientResourceFilter = _v6.a;
		var patientResourceFilterCmd = _v6.b;
		var _v7 = $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
		var locationResourceFilter = _v7.a;
		var locationResourceFilterCmd = _v7.b;
		var _v8 = $author$project$Components$DateInput$init;
		var endDateInput = _v8.a;
		var endDateInputCmd = _v8.b;
		var _v9 = A2($author$project$Components$Charge$Form$initChargeItemResourceFilter, apiClient, packageFeatureEnabled);
		var chargeItemResourceFilter = _v9.a;
		var chargeItemResourceFilterCmd = _v9.b;
		var _v10 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, session, excludeLabs);
		var categoryResourceFilter = _v10.a;
		var categoryResourceFilterCmd = _v10.b;
		return _Utils_Tuple2(
			{
				abU: $author$project$Api$Data$NotAsked,
				e: $author$project$Utils$Form$init(
					A4(
						$author$project$Components$Charge$Form$initFormFields,
						$elm$core$Maybe$Just(currentDate),
						startDateInput,
						endDateInput,
						categoryResourceFilter)),
				cK: chargeItemResourceFilter,
				cO: currentDate,
				rl: locationResourceFilter,
				VM: $elm$core$Maybe$Nothing,
				rS: false,
				rU: patientResourceFilter,
				WF: practice,
				jC: practitionerResourceFilter,
				A8: preloadedPatientData,
				afU: $author$project$Api$Data$NotAsked,
				em: $jinjor$elm_debounce$Debounce$init,
				XO: false,
				n2: routingFields,
				ZD: session,
				gJ: false,
				kg: startDateInput,
				hd: true
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFieldsMsg, routingFieldsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Charge$Form$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Charge$Form$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						preloadPatientCmd
					])));
	});
var $author$project$Components$CustomerEmailModal$Closed = {$: 0};
var $author$project$Components$CustomerEmailModal$init = $author$project$Components$CustomerEmailModal$Closed;
var $author$project$Components$CustomerSchedulePaymentModal$Closed = {$: 0};
var $author$project$Components$CustomerSchedulePaymentModal$init = $author$project$Components$CustomerSchedulePaymentModal$Closed;
var $author$project$Components$Charge$Form$withPatientLocked = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{rS: true});
};
var $author$project$Pages$Charges$New$initEmbeddedChargeForm = function (model) {
	return $author$project$Components$Charge$Form$withPatientLocked(model);
};
var $author$project$Pages$Charges$New$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var preselectedPatientId = A2($elm$core$Dict$get, 'patient', query);
		var _v1 = A5($author$project$Components$Charge$Form$init, shared.D5, session, practice, preselectedPatientId, shared);
		var chargeForm = _v1.a;
		var chargeFormCmd = _v1.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				e: (shared.adu.acW ? $author$project$Pages$Charges$New$initEmbeddedChargeForm : $elm$core$Basics$identity)(chargeForm),
				lC: $elm$core$Maybe$Nothing,
				dA: _List_Nil,
				lH: $author$project$Components$CustomerEmailModal$init,
				q2: _List_Nil,
				FR: $author$project$Shared$isHintAdmin(shared),
				WF: practice,
				sj: shared.sj,
				sr: true,
				gA: $author$project$Components$CustomerSchedulePaymentModal$init,
				ZD: session,
				Cd: shared
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormCmd));
	});
var $author$project$Pages$Charges$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Charges$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Charges$New$CreatePaymentModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Charges$New$CustomerEmailModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Charges$New$SchedulePaymentModalMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$ResourceFilter$Patient$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Charge$Form$RoutingFields$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg,
		$author$project$Components$ResourceFilter$Patient$subscriptions(model.eg));
};
var $author$project$Components$ResourceFilter$ChargeItem$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Charge$Form$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Utils$Form$fields(model.e);
	var categoryResourceFilter = _v1.cJ;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$PatientResourceFilterMsg,
				$author$project$Components$ResourceFilter$Patient$subscriptions(model.rU)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$ChargeItemResourceFilterMsg,
				$author$project$Components$ResourceFilter$ChargeItem$subscriptions(model.cK)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(categoryResourceFilter)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$PractitionerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Practitioner$subscriptions(model.jC)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$LocationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Location$subscriptions(model.rl)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Charge$Form$RoutingFieldsMsg,
				$author$project$Components$Charge$Form$RoutingFields$subscriptions(model.n2))
			]));
};
var $author$project$Components$CustomerEmailModal$Close = {$: 1};
var $author$project$Components$CustomerEmailModal$subscriptions = function (model) {
	if (!model.$) {
		return $elm$core$Platform$Sub$none;
	} else {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerEmailModal$Close);
	}
};
var $author$project$Components$CustomerSchedulePaymentModal$CloseModal = {$: 0};
var $author$project$Components$CustomerSchedulePaymentModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerSchedulePaymentModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Charges$New$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Charges$New$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$subscriptions(model.lH)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Charges$New$SchedulePaymentModalMsg,
				$author$project$Components$CustomerSchedulePaymentModal$subscriptions(model.gA)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Charges$New$CreatePaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Invoice$CreatePaymentModal$subscriptions,
						A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.lC)))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Charges$New$ChargeFormMsg,
				$author$project$Components$Charge$Form$subscriptions(model.e)),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					function (invoice) {
						return $author$project$Ui$NewDropdown$subscriptions(invoice.lV);
					},
					model.q2))
			]));
};
var $author$project$Api$Provider$CustomerInvoice$Charges = 0;
var $author$project$Api$Provider$Notification$CustomerInvoice = 0;
var $author$project$Pages$Charges$New$Dropdown = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Charges$New$GotCustomerInvoice = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Pages$Charges$New$GotPatient = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Charges$New$Issue = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Charges$New$OpenEmail = 2;
var $author$project$Pages$Charges$New$OpenPaymentProcessing = 0;
var $author$project$Pages$Charges$New$OpenPaymentRecording = 1;
var $author$project$Pages$Charges$New$OpenSchedulePayment = 3;
var $author$project$Components$CustomerEmailModal$PatientOne = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Charges$New$SaveRequest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Charges$New$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Charge$Form$charge = function (_v0) {
	var model = _v0;
	return model.abU;
};
var $author$project$Pages$Charges$New$findInvoice = F2(
	function (invoices, invoiceId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (invoice) {
					return _Utils_eq(invoice.adR, invoiceId);
				},
				invoices));
	});
var $author$project$Pages$Charges$New$findDropdownMenu = F2(
	function (invoices, invoiceId) {
		return A2(
			$elm$core$Maybe$map,
			function (invoice) {
				return invoice.lV;
			},
			A2($author$project$Pages$Charges$New$findInvoice, invoices, invoiceId));
	});
var $author$project$Components$Charge$Form$hide = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{hd: false});
};
var $author$project$Api$Provider$CustomerInvoice$Shared$humanStatus = function (_v0) {
	var record = _v0;
	return record.QE;
};
var $author$project$Api$Provider$CustomerInvoice$One$humanStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$humanStatus(shared);
};
var $author$project$Api$Common$Payable$Invoice$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$id(min);
};
var $author$project$Api$Provider$Charge$One$invoice = function (_v0) {
	var record = _v0.b;
	return record.Rh;
};
var $author$project$Pages$Charges$New$isDraft = function (invoice) {
	return invoice.ag7 === 'draft';
};
var $author$project$Api$Provider$CustomerInvoice$customerInvoicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['customer_invoices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CustomerInvoice$customerInvoicePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$CustomerInvoice$customerInvoicesPath);
};
var $author$project$Api$Provider$CustomerInvoice$One$CustomerInvoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$CustomerInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$CustomerInvoice$Shared$Record = function (id) {
	return function (date) {
		return function (invoiceNumber) {
			return function (humanStatus) {
				return function (estimatedDueInCents) {
					return function (dueInCents) {
						return function (securePdfInlineToken) {
							return function (subtotalInCents) {
								return function (issuedTotalInCents) {
									return function (totalInCents) {
										return function (paidInCents) {
											return function (creditInCents) {
												return function (taxInCents) {
													return function (isPaymentScheduled) {
														return function (hasGoodPaymentSource) {
															return function (paymentScheduledOn) {
																return function (passthroughFeesInCents) {
																	return {Ml: creditInCents, MO: date, N2: dueInCents, OQ: estimatedDueInCents, P7: hasGoodPaymentSource, QE: humanStatus, adR: id, Rq: invoiceNumber, R_: isPaymentScheduled, Sn: issuedTotalInCents, Vu: paidInCents, VK: passthroughFeesInCents, V2: paymentScheduledOn, Ze: securePdfInlineToken, _7: subtotalInCents, $r: taxInCents, $X: totalInCents};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'passthrough_fees_in_cents',
	$elm$json$Json$Decode$int,
	0,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_scheduled_on',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'has_good_payment_source',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_payment_scheduled',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'tax_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'credit_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'paid_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'total_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'issued_total_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'subtotal_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'secure_pdf_inline_token',
											$elm$json$Json$Decode$nullable($author$project$Api$File$Token$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'due_in_cents',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'estimated_due_in_cents',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'human_status',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'invoice_number',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'date',
																$author$project$Utils$Date$decode,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$string,
																	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Shared$Record))))))))))))))))));
var $author$project$Api$Provider$CustomerInvoice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CustomerInvoice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CustomerInvoice$One$Record = function (lastSentAt) {
	return function (chargeGroup) {
		return function (meta) {
			return function (source) {
				return function (membershipPaymentSource) {
					return function (owner) {
						return function (location) {
							return function (taxProfile) {
								return function (charges) {
									return function (creditToAutoApplyInCents) {
										return function (transferredToCreditInCents) {
											return function (payments) {
												return function (adjustments) {
													return function (revisionNumber) {
														return function (voidReason) {
															return function (voidedAt) {
																return function (voidedByName) {
																	return function (probablePatients) {
																		return function (createdAt) {
																			return {IC: adjustments, abV: chargeGroup, KU: charges, Mf: createdAt, Mm: creditToAutoApplyInCents, SD: lastSentAt, aet: location, TH: membershipPaymentSource, TU: meta, Vp: owner, V5: payments, W3: probablePatients, YM: revisionNumber, Hg: source, $t: taxProfile, $6: transferredToCreditInCents, ahR: voidReason, aaT: voidedAt, aaU: voidedByName};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$CustomerInvoice$Meta$Record = F2(
	function (actions, taxProfile) {
		return {tF: actions, $t: taxProfile};
	});
var $author$project$Api$Provider$CustomerInvoice$Meta$ActionsRecord = function (paymentProcess) {
	return function (recordPayment) {
		return function (schedulePayment) {
			return function (schedulePartialPayments) {
				return function (markAsSent) {
					return function (markAsUnsent) {
						return function (returnToDraft) {
							return function (markAsBadDebt) {
								return function (reverseBadDebt) {
									return function (stopRetrying) {
										return function (applyCredits) {
											return function (removeCredits) {
												return function (destroy) {
													return function (issue) {
														return function (isRevisable) {
															return function (createAdjustment) {
																return function (transferToCredit) {
																	return function (reverseCreditTransfer) {
																		return function (update) {
																			return function (cancel) {
																				return {Jk: applyCredits, KF: cancel, Mb: createAdjustment, NA: destroy, aeh: isRevisable, Sh: issue, Th: markAsBadDebt, Tj: markAsSent, Tk: markAsUnsent, V$: paymentProcess, XW: recordPayment, Ya: removeCredits, YE: returnToDraft, YI: reverseBadDebt, YJ: reverseCreditTransfer, Y5: schedulePartialPayments, Y6: schedulePayment, _P: stopRetrying, $4: transferToCredit, aaq: update};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cancel',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'update',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reverse_credit_transfer',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'transfer_to_credit',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'create_adjustment',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_revisable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'issue',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'destroy',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'remove_credits',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'apply_credits',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'stop_retrying',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'reverse_bad_debt',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'mark_as_bad_debt',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'return_to_draft',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'mark_as_unsent',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'mark_as_sent',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'schedule_partial_payments',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'schedule_payment',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'payments_paid',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'payments_process',
																				$elm$json$Json$Decode$bool,
																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$ActionsRecord)))))))))))))))))))));
var $author$project$Api$Provider$CustomerInvoice$Meta$TaxProfileRecord = F2(
	function (viewable, editable) {
		return {Oa: editable, aaQ: viewable};
	});
var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'viewable',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$TaxProfileRecord)));
var $author$project$Api$Provider$CustomerInvoice$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tax_profile',
	$author$project$Api$Provider$CustomerInvoice$Meta$taxProfileRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Provider$CustomerInvoice$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$Record)));
var $author$project$Api$Provider$CustomerInvoice$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CustomerInvoice$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$InvoiceAdjustment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$InvoiceAdjustment$Shared$InvoiceAdjustment = $elm$core$Basics$identity;
var $author$project$Api$Provider$InvoiceAdjustment$Shared$Record = function (totalAdjustmentInCents) {
	return {ahC: totalAdjustmentInCents};
};
var $author$project$Api$Provider$InvoiceAdjustment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total_adjustment_in_cents',
	$elm$json$Json$Decode$int,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Shared$Record));
var $author$project$Api$Provider$InvoiceAdjustment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceAdjustment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$Record = F4(
	function (createdAt, position, reason, user) {
		return {Mf: createdAt, Wz: position, XP: reason, aaz: user};
	});
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'reason',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'position',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_at',
				$elm_community$json_extra$Json$Decode$Extra$datetime,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$Record)))));
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$InvoiceAdjustment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$InvoiceAdjustment)));
var $author$project$Api$Provider$CustomerInvoice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'created_at',
	$elm_community$json_extra$Json$Decode$Extra$datetime,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'probable_patients',
		$elm$json$Json$Decode$list($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'voided_by_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'voided_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'void_reason',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'revision_number',
						$elm$json$Json$Decode$int,
						A3(
							$author$project$Api$Expandable$expandable,
							'invoice_adjustments',
							$elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$decoder),
							A3(
								$author$project$Api$Expandable$expandable,
								'payments',
								$elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'transferred_to_credit_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'credit_to_auto_apply_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$author$project$Api$Expandable$expandable,
											'charges',
											$elm$json$Json$Decode$list($author$project$Api$Provider$Charge$One$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'tax_profile',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$TaxProfile$Shared$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'location',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'owner',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'membership_payment_source',
															$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'source',
																$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'meta',
																	$author$project$Api$Provider$CustomerInvoice$Meta$decoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'charge_group',
																		$elm$json$Json$Decode$nullable(
																			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string)),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'last_sent_at',
																			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
																			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$One$Record))))))))))))))))))));
var $author$project$Api$Provider$CustomerInvoice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CustomerInvoice$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CustomerInvoice$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$One$CustomerInvoice)));
var $author$project$Api$Provider$CustomerInvoice$expandToString = function (expand) {
	switch (expand) {
		case 0:
			return 'charges';
		case 1:
			return 'payments';
		case 2:
			return 'invoice_adjustments';
		case 3:
			return 'owner.phones';
		default:
			return 'membership_payment_source';
	}
};
var $author$project$Api$Provider$CustomerInvoice$issue = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['issue']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Components$Charge$Form$NewFormWithPatient = {$: 3};
var $author$project$Components$Charge$Form$newFormWithPatient = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always($author$project$Components$Charge$Form$NewFormWithPatient),
	$elm$core$Task$succeed($elm$core$Maybe$Nothing));
var $author$project$Components$CustomerEmailModal$Loading = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$CustomerEmailModal$NoRecipientEmail = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$Reports$Patient$oneId = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$CustomerEmailModal$recipientId = function (recipient) {
	switch (recipient.$) {
		case 0:
			var patient = recipient.a;
			return $author$project$Api$Provider$Reports$Patient$oneId(patient);
		case 1:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$One$id(patient);
		default:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$Shared$id(patient);
	}
};
var $author$project$Components$CustomerEmailModal$initPatientFormFields = function (patient) {
	return {
		Oo: '',
		VN: $author$project$Components$CustomerEmailModal$recipientId(patient)
	};
};
var $author$project$Components$CustomerEmailModal$GotPreview = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Notification$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerEmailModal$previewNotification = F3(
	function (apiClient, shared, formFields) {
		var fields = function () {
			var _v1 = A2($elm$core$Maybe$map, $rtfeldman$elm_validate$Validate$fromValid, formFields);
			if (!_v1.$) {
				var fields_ = _v1.a;
				return {e5: fields_.e5, Hp: fields_.Hp};
			} else {
				return {e5: $elm$core$Maybe$Nothing, Hp: $elm$core$Maybe$Nothing};
			}
		}();
		var _v0 = shared;
		var type_ = _v0.ahI;
		var contextId = _v0.wN;
		var recipient = _v0.Bm;
		return A6(
			$author$project$Api$Provider$Notification$preview,
			apiClient,
			type_,
			$author$project$Api$Provider$Notification$Patient(
				$author$project$Components$CustomerEmailModal$recipientId(recipient)),
			contextId,
			fields,
			$author$project$Components$CustomerEmailModal$GotPreview);
	});
var $author$project$Api$Provider$Patient$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$email(shared);
};
var $author$project$Api$Provider$Reports$Patient$oneEmail = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Components$CustomerEmailModal$recipientEmail = function (recipient) {
	switch (recipient.$) {
		case 0:
			var patient = recipient.a;
			return $author$project$Api$Provider$Reports$Patient$oneEmail(patient);
		case 1:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$One$email(patient);
		default:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$Shared$email(patient);
	}
};
var $author$project$Components$CustomerEmailModal$open = F6(
	function (apiClient, session, type_, contextId, recipient, _v0) {
		var shared = {wN: contextId, Bm: recipient, ZD: session, ahI: type_};
		var _v1 = $author$project$Components$CustomerEmailModal$recipientEmail(recipient);
		if (_v1.$ === 1) {
			return _Utils_Tuple2(
				A2(
					$author$project$Components$CustomerEmailModal$NoRecipientEmail,
					shared,
					$author$project$Utils$Form$init(
						$author$project$Components$CustomerEmailModal$initPatientFormFields(recipient))),
				$elm$core$Platform$Cmd$none);
		} else {
			if (_v1.a === '') {
				return _Utils_Tuple2(
					A2(
						$author$project$Components$CustomerEmailModal$NoRecipientEmail,
						shared,
						$author$project$Utils$Form$init(
							$author$project$Components$CustomerEmailModal$initPatientFormFields(recipient))),
					$elm$core$Platform$Cmd$none);
			} else {
				var email = _v1.a;
				return _Utils_Tuple2(
					A2($author$project$Components$CustomerEmailModal$Loading, shared, email),
					A3($author$project$Components$CustomerEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing));
			}
		}
	});
var $author$project$Components$CustomerSchedulePaymentModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerSchedulePaymentModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$CustomerSchedulePaymentModal$initFormFields = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{MO: $elm$core$Maybe$Nothing, qd: dateInput},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(dateInput),
			dateInputCmd));
}();
var $author$project$Components$CustomerSchedulePaymentModal$open = F2(
	function (invoiceId, currentDate) {
		var _v0 = $author$project$Components$CustomerSchedulePaymentModal$initFormFields;
		var fields = _v0.a;
		var fieldsCmd = _v0.b;
		var model = {
			cO: currentDate,
			PB: $author$project$Utils$Form$init(fields),
			aea: invoiceId,
			so: $author$project$Api$Data$NotAsked
		};
		return _Utils_Tuple2(
			$author$project$Components$CustomerSchedulePaymentModal$Open(model),
			fieldsCmd);
	});
var $author$project$Components$Charge$Form$readOnly = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{XO: true});
};
var $author$project$Pages$Charges$New$DropdownMenuMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(min);
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner = function (_v0) {
	var record = _v0.b;
	return record.Vp;
};
var $author$project$Api$Common$Payable$Invoice$Min$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$status = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$status(min);
};
var $author$project$Ui$NewDropdown$TopLeft = 3;
var $author$project$Ui$NewDropdown$toTopLeft = function (config) {
	return _Utils_update(
		config,
		{xb: 3});
};
var $author$project$Api$Common$Payable$Invoice$Min$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_ = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$type_(min);
};
var $author$project$Pages$Charges$New$buildInvoiceRecord = function (invoice) {
	return {
		lV: $author$project$Ui$NewDropdown$init(
			$author$project$Ui$NewDropdown$toTopLeft(
				$author$project$Ui$NewDropdown$defaultConfig(
					{
						adR: 'invoice-actions-dropdown-menu-' + $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
						ahx: $author$project$Pages$Charges$New$DropdownMenuMsg(
							$author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice))
					}))),
		adR: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
		Rq: $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice),
		Vp: $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice),
		jY: $author$project$Api$Data$NotAsked,
		ag7: $author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice),
		ahI: $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice)
	};
};
var $author$project$Pages$Charges$New$refreshInvoiceList = F2(
	function (invoices, maybeInvoice) {
		if (!maybeInvoice.$) {
			var invoice = maybeInvoice.a;
			var member = F2(
				function (record, i) {
					return _Utils_eq(i.adR, record.adR);
				});
			var invoiceRecord = $author$project$Pages$Charges$New$buildInvoiceRecord(invoice);
			return A2(
				$elm$core$List$any,
				member(invoiceRecord),
				invoices) ? A2(
				$elm$core$List$map,
				function (i) {
					return A2(member, invoiceRecord, i) ? invoiceRecord : i;
				},
				invoices) : A2($elm$core$List$cons, invoiceRecord, invoices);
		} else {
			return invoices;
		}
	});
var $author$project$Components$Charge$Form$ResetForm = {$: 2};
var $author$project$Components$Charge$Form$reset = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always($author$project$Components$Charge$Form$ResetForm),
	$elm$core$Task$succeed($elm$core$Maybe$Nothing));
var $author$project$Api$Provider$CustomerInvoice$retrieve = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))));
	});
var $author$project$Pages$Charges$New$retrieveInvoice = F2(
	function (apiClient, invoiceId) {
		return A4(
			$author$project$Api$Provider$CustomerInvoice$retrieve,
			apiClient,
			invoiceId,
			_List_Nil,
			A2($author$project$Pages$Charges$New$GotCustomerInvoice, invoiceId, $elm$core$Maybe$Nothing));
	});
var $author$project$Components$Charge$Form$Save = {$: 1};
var $author$project$Components$Charge$Form$save = A2(
	$elm$core$Task$perform,
	$elm$core$Basics$always($author$project$Components$Charge$Form$Save),
	$elm$core$Task$succeed($elm$core$Maybe$Nothing));
var $author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Charges$New$initCreatePaymentModal = F4(
	function (model, external, invoiceId, invoice) {
		var invoiceOwnerId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Maybe$map($author$project$Api$Common$Payable$Owner$Min$id),
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.Vp;
					},
					A2($author$project$Pages$Charges$New$findInvoice, model.q2, invoiceId))));
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.Cd.cO)(model.Cd.Hy)(
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))(
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$patientPath(invoiceOwnerId)))(model.Cd.D5)(model.ZD)(
			$author$project$Api$Practice$Provider(model.WF))(model.FR)(model.sj)(
			function (d) {
				return _Utils_update(
					d,
					{O4: external, oo: model.FR});
			})(
			A2($author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice, invoiceOwnerId, invoice));
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					lC: $elm$core$Maybe$Just(
						_Utils_Tuple2(
							createPaymentModal,
							$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Pages$Charges$New$showPaymentModal = F4(
	function (model, invoice, external, invoiceId) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil),
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Tuple3$fromTuple2(_List_Nil),
				A2(
					$elm$core$Maybe$map,
					A3($author$project$Pages$Charges$New$initCreatePaymentModal, model, external, invoiceId),
					$author$project$Api$Data$toMaybe(invoice.jY))));
	});
var $author$project$Components$Charge$Form$toggle = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{hd: !model.hd});
};
var $author$project$Pages$Charges$New$Email = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Charges$New$Pay = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Charges$New$SchedulePayment = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Charges$New$triggerAfterIssueAction = F2(
	function (afterIssueMsg, invoice) {
		switch (afterIssueMsg) {
			case 0:
				return A2(
					$elm$core$Task$perform,
					function (_v1) {
						return A2($author$project$Pages$Charges$New$Pay, invoice, false);
					},
					$elm$time$Time$now);
			case 1:
				return A2(
					$elm$core$Task$perform,
					function (_v2) {
						return A2($author$project$Pages$Charges$New$Pay, invoice, true);
					},
					$elm$time$Time$now);
			case 2:
				var _v3 = invoice.Vp;
				if (!_v3.$) {
					var owner = _v3.a;
					return A2(
						$elm$core$Task$perform,
						function (_v4) {
							return A2(
								$author$project$Pages$Charges$New$Email,
								$author$project$Api$Common$Payable$Owner$Min$id(owner),
								invoice);
						},
						$elm$time$Time$now);
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			default:
				return A2(
					$elm$core$Task$perform,
					function (_v5) {
						return $author$project$Pages$Charges$New$SchedulePayment(invoice);
					},
					$elm$time$Time$now);
		}
	});
var $author$project$Components$Charge$Form$Category = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Charge$Form$ChargeCreated = 1;
var $author$project$Components$Charge$Form$ChargeItem = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Charge$Form$EndDate = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Charge$Form$GotPatient = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$GotPreview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Charge$Form$Location = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Charge$Form$Name = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Charge$Form$None = 0;
var $author$project$Components$Charge$Form$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$PatientUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Charge$Form$Practitioner = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Charge$Form$StartDate = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Charge$Form$GotPreviewWithPayer = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Charge$Form$ChargeItemValidation = 1;
var $author$project$Components$Charge$Form$PatientValidation = 0;
var $author$project$Components$Charge$Form$PriceInCentsValidation = 3;
var $author$project$Components$Charge$Form$QuantityValidation = 2;
var $author$project$Components$Charge$Form$StartDateValidation = 4;
var $author$project$Components$Charge$Form$validateChargeItem = function (fields) {
	var _v0 = fields.lp;
	if (!_v0.$) {
		var chargeItem = _v0.a;
		var sponsorPayer = fields.VW === 1;
		return (chargeItem.$u && sponsorPayer) ? _List_fromArray(
			[
				_Utils_Tuple2(1, '')
			]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Charge$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.VM;
			},
			_Utils_Tuple2(0, 'Please select a patient.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(1, 'Please select a charge item.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Bd;
			},
			_Utils_Tuple2(2, 'Please enter a quantity.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Ba;
			},
			_Utils_Tuple2(3, 'Please enter an amount.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Charge$Form$validateChargeItem),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $._E;
			},
			_Utils_Tuple2(4, 'Please pick a date.'))
		]));
var $author$project$Components$Charge$Form$paramsWithPrice = F2(
	function (fields, previewData) {
		var priceInCents = function () {
			if (!(!fields.NI)) {
				var _v0 = _Utils_Tuple2(fields.lp, previewData);
				if (!_v0.a.$) {
					var chargeItem = _v0.a.a;
					return $elm$core$Maybe$Just(chargeItem.Ba | 0);
				} else {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var preview = _v2.a;
						return $elm$core$Maybe$Just(
							$author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
					} else {
						var _v3 = _v0.a;
						return $elm$core$Maybe$Just(
							fields.NI + A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Ba)));
					}
				}
			} else {
				return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Ba);
			}
		}();
		return {
			Ex: fields.Ex,
			lp: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				fields.lp),
			MO: fields._E,
			Nx: fields.Nx,
			NJ: fields.NJ,
			qs: fields.qs,
			Rh: $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing),
			aet: fields.aet,
			zh: fields.zh,
			VM: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				fields.VM),
			GD: $elm$core$Maybe$Nothing,
			afS: fields.afS,
			Ba: priceInCents,
			Bd: A2($elm$core$Maybe$withDefault, 1, fields.Bd),
			Be: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Be)
		};
	});
var $author$project$Api$Charge$PayerType$payerTypeParam = function (payerType) {
	if (!payerType) {
		return $elm$core$Maybe$Just('patient');
	} else {
		return $elm$core$Maybe$Just('company');
	}
};
var $author$project$Components$Charge$Form$calculatePreviewWithPayer = F2(
	function (apiClient, model) {
		var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Charge$Form$formFieldsValidator, model.e);
		if (!_v0.$) {
			var fields = $author$project$Utils$Form$fields(model.e);
			var params = A2($author$project$Components$Charge$Form$paramsWithPrice, fields, model.afU);
			var paramsWithPayer = _Utils_update(
				params,
				{
					GD: $elm$core$Maybe$Just(
						{
							adR: fields.GD,
							ahI: $author$project$Api$Charge$PayerType$payerTypeParam(fields.VW)
						})
				});
			return _List_fromArray(
				[
					A4(
					$author$project$Api$Provider$Charge$calculate,
					$author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath),
					apiClient,
					paramsWithPayer,
					$author$project$Components$Charge$Form$GotPreviewWithPayer),
					A2(
					$elm$core$Task$perform,
					$author$project$Components$Charge$Form$RoutingFieldsMsg,
					$elm$core$Task$succeed(
						$author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer($author$project$Api$Data$Loading)))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Charge$Form$GotChargeCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Charge$NewInvoice = {$: 1};
var $author$project$Api$Provider$Charge$RoutedInvoice$One$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Charge$Calculate$routedInvoice = function (_v0) {
	var record = _v0;
	return record.YO;
};
var $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId = function (preview) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$core$Maybe$withDefault,
			'new',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Charge$RoutedInvoice$One$id,
				$author$project$Api$Provider$Charge$Calculate$routedInvoice(preview))));
};
var $author$project$Components$Charge$Form$invoiceNotChanged = F2(
	function (previewData, fields) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (preview_) {
					return _Utils_eq(
						$author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview_),
						fields.Rh);
				},
				$author$project$Api$Data$toMaybe(previewData)));
	});
var $author$project$Components$Charge$Form$invoiceTypeParam = function (payertype) {
	if (!payertype) {
		return $elm$core$Maybe$Just('customer_invoice');
	} else {
		return $elm$core$Maybe$Just('company_invoice');
	}
};
var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId = function (preview) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Charge$AdjudicatedPayer$One$id,
		$author$project$Api$Provider$Charge$Calculate$adjudicatedPayer(preview));
};
var $author$project$Components$Charge$Form$payerNotChanged = F2(
	function (previewData, fields) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (preview_) {
					return _Utils_eq(
						$author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview_),
						fields.GD);
				},
				$author$project$Api$Data$toMaybe(previewData)));
	});
var $author$project$Components$Charge$Form$createParams = F2(
	function (fields, previewData) {
		var newSponsorInvoice = (fields.VW === 1) && _Utils_eq(
			fields.Rh,
			$elm$core$Maybe$Just('new'));
		var invoice = function () {
			if (A2($author$project$Components$Charge$Form$invoiceNotChanged, previewData, fields)) {
				return $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing);
			} else {
				var newPatientInvoice = (!fields.VW) && _Utils_eq(
					fields.Rh,
					$elm$core$Maybe$Just('new'));
				return (newSponsorInvoice || newPatientInvoice) ? $author$project$Api$Provider$Charge$NewInvoice : $author$project$Api$Provider$Charge$Invoice(
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(
							{
								adR: fields.Rh,
								ahI: $author$project$Components$Charge$Form$invoiceTypeParam(fields.VW)
							}),
						fields.Rh));
			}
		}();
		var payer = (A2($author$project$Components$Charge$Form$payerNotChanged, previewData, fields) || ((!_Utils_eq(
			invoice,
			$author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing))) && (!newSponsorInvoice))) ? $elm$core$Maybe$Nothing : A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				{
					adR: fields.GD,
					ahI: $author$project$Api$Charge$PayerType$payerTypeParam(fields.VW)
				}),
			fields.GD);
		var baseParams = A2($author$project$Components$Charge$Form$paramsWithPrice, fields, previewData);
		return _Utils_update(
			baseParams,
			{Rh: invoice, GD: payer});
	});
var $author$project$Components$Charge$Form$createCharge = F3(
	function (apiClient, model, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Charge$create,
			$author$project$Api$Data$providerPath,
			apiClient,
			A2($author$project$Components$Charge$Form$createParams, fields, model.afU),
			$author$project$Components$Charge$Form$GotChargeCreated);
	});
var $author$project$Components$Charge$Form$PreviewDebounced = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Charge$Form$debouncePreview = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Charge$Form$PreviewDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Components$Charge$Form$resetEndDate = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Bd, fields.Be);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var quantity = _v0.a.a;
		var quantityUom = _v0.b.a;
		return _Utils_update(
			fields,
			{
				qs: A3($author$project$Utils$Uom$addTo, fields._E, quantityUom, quantity)
			});
	} else {
		return fields;
	}
};
var $author$project$Components$Charge$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var patient = field.a;
				return _Utils_update(
					fields,
					{VM: patient});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ex: $elm$core$Maybe$Nothing,
						cJ: A2($author$project$Components$ResourceFilter$Category$setValue, $elm$core$Maybe$Nothing, fields.cJ),
						lp: $elm$core$Maybe$Nothing,
						NI: 0,
						zh: $elm$core$Maybe$Just(string),
						Ba: $elm$core$Maybe$Nothing
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{Nx: string});
			case 3:
				var item = field.a;
				var category = item.Ex;
				return $author$project$Components$Charge$Form$resetEndDate(
					_Utils_update(
						fields,
						{
							Ex: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
							cJ: A2(
								$author$project$Components$ResourceFilter$Category$setValue,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return {
											adR: $author$project$Api$Provider$Category$Shared$id(category_),
											zh: $author$project$Api$Provider$Category$Shared$name(category_)
										};
									},
									category),
								fields.cJ),
							lp: $elm$core$Maybe$Just(item),
							Nx: A2($elm$core$Maybe$withDefault, '', item.Nx),
							zh: $elm$core$Maybe$Just(item.zh),
							Ba: $elm$core$Maybe$Just(
								$author$project$Currency$fromFloat(item.Ba)),
							W$: $elm$core$Maybe$Just(item.aam),
							Be: $elm$core$Maybe$Just(item.aam)
						}));
			case 4:
				var string = field.a;
				return $author$project$Components$Charge$Form$resetEndDate(
					_Utils_update(
						fields,
						{
							Bd: $elm$core$String$toInt(string)
						}));
			case 5:
				var string = field.a;
				var _v1 = $author$project$Utils$Uom$fromCode(string);
				if (!_v1.$) {
					var quantityUom = _v1.a;
					var quantity = function () {
						var _v2 = _Utils_Tuple2(fields._E, fields.qs);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var startDate = _v2.a.a;
							var endDate = _v2.b.a;
							return $elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom,
									startDate,
									$elm$core$Maybe$Just(endDate)));
						} else {
							return fields.Bd;
						}
					}();
					return $author$project$Components$Charge$Form$resetEndDate(
						_Utils_update(
							fields,
							{
								Bd: quantity,
								Be: $elm$core$Maybe$Just(quantityUom)
							}));
				} else {
					return _Utils_update(
						fields,
						{Be: $elm$core$Maybe$Nothing});
				}
			case 6:
				var currency = field.a;
				return _Utils_update(
					fields,
					{Ba: currency});
			case 7:
				var _int = field.a;
				return _Utils_update(
					fields,
					{NI: _int});
			case 9:
				var routingFields = field.a;
				return _Utils_update(
					fields,
					{Rh: routingFields.aea, GD: routingFields.afG, VW: routingFields.VW});
			case 8:
				var bool = field.a;
				var priceInCents = bool ? fields.Ba : A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Ba;
						},
						$author$project$Currency$fromFloat),
					fields.lp);
				return _Utils_update(
					fields,
					{NJ: bool, Ba: priceInCents});
			case 10:
				var category = field.a;
				return _Utils_update(
					fields,
					{Ex: category});
			case 11:
				var practitioner = field.a;
				return _Utils_update(
					fields,
					{
						afS: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							practitioner)
					});
			case 12:
				var location = field.a;
				return _Utils_update(
					fields,
					{
						aet: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							location)
					});
			case 13:
				var dateInput = field.a;
				var date = field.b;
				return $author$project$Components$Charge$Form$resetEndDate(
					_Utils_update(
						fields,
						{_E: date, kg: dateInput}));
			default:
				var dateInput = field.a;
				var date = field.b;
				var _v3 = function () {
					var _v4 = _Utils_Tuple2(fields._E, date);
					if ((!_v4.a.$) && (!_v4.b.$)) {
						var startDate_ = _v4.a.a;
						var endDate = _v4.b.a;
						var startDate__ = (A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2) ? endDate : startDate_;
						var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(startDate__),
							$elm$core$Maybe$Just(quantityUom_),
							$elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom_,
									startDate__,
									$elm$core$Maybe$Just(endDate))));
					} else {
						return _Utils_Tuple3(fields._E, fields.Be, fields.Bd);
					}
				}();
				var startDate = _v3.a;
				var quantityUom = _v3.b;
				var quantity = _v3.c;
				return _Utils_update(
					fields,
					{qs: date, qu: dateInput, Bd: quantity, Be: quantityUom, _E: startDate});
		}
	});
var $author$project$Components$Charge$Form$GotChargeOverridden = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Charge$Form$overrideChargeDiscount = F3(
	function (apiClient, id, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return fields.NJ ? _Utils_Tuple2(
			A3($author$project$Api$Provider$Charge$CoverageDiscount$override, apiClient, id, $author$project$Components$Charge$Form$GotChargeOverridden),
			0) : _Utils_Tuple2($elm$core$Platform$Cmd$none, 1);
	});
var $author$project$Components$Charge$Form$PreviewDebouncedMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Charge$Form$previewDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Charge$Form$PreviewDebouncedMsg
};
var $author$project$Components$ResourceFilter$Patient$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				G0: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$Charge$Form$RoutingFields$GotPatient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$None = 0;
var $author$project$Api$Charge$PayerType$adjudicatedToSponsor = function (preview) {
	return $author$project$Api$Charge$PayerType$toPayerType(
		$author$project$Api$Charge$PayerType$adjudicatedType(preview)) === 1;
};
var $author$project$Api$Provider$CustomerInvoice$All$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId = function (invoices) {
	return $elm$core$Maybe$Just(
		A2(
			$elm$core$Maybe$withDefault,
			'new',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$CustomerInvoice$All$id,
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					$author$project$Api$Data$toMaybe(invoices)))));
};
var $author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId = F4(
	function (fields, dataCustomerInvoices, dataPreview, dataPreviewWithPayer) {
		if (dataPreview.$ === 3) {
			var preview = dataPreview.a;
			var _v1 = _Utils_Tuple2(
				fields.VW,
				$author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview));
			if (!_v1.a) {
				if (!_v1.b) {
					var _v2 = _v1.a;
					return _Utils_eq(
						fields.afG,
						$author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview)) ? $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview) : $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId(dataCustomerInvoices);
				} else {
					var _v3 = _v1.a;
					return $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId(dataCustomerInvoices);
				}
			} else {
				if (!_v1.b) {
					var _v4 = _v1.a;
					return A2(
						$elm$core$Maybe$andThen,
						$author$project$Components$Charge$Form$RoutingFields$routedInvoiceId,
						$author$project$Api$Data$toMaybe(dataPreviewWithPayer));
				} else {
					var _v5 = _v1.a;
					return $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview);
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Api$Provider$Patient$One$company = function (_v0) {
	var record = _v0.b;
	return record.ab9;
};
var $author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany = function (patient) {
	return $author$project$Api$Provider$Patient$One$company(patient);
};
var $author$project$Api$Provider$Patient$One$payer = function (_v0) {
	var record = _v0.b;
	return record.GD;
};
var $author$project$Components$Charge$Form$RoutingFields$patientPayerId = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$payer(patient);
	if (!_v0.$) {
		var payer = _v0.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$Min$id(payer));
	} else {
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$One$id(patient));
	}
};
var $author$project$Components$Charge$Form$RoutingFields$defaultPayerId = F3(
	function (payerType, dataPatient, dataPreview) {
		var _v0 = _Utils_Tuple2(dataPatient, dataPreview);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var patient = _v1.a;
			var _v2 = _v0.b;
			var preview = _v2.a;
			var _v3 = _Utils_Tuple2(
				payerType,
				$author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview));
			if (!_v3.a) {
				if (!_v3.b) {
					var _v4 = _v3.a;
					return $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview);
				} else {
					var _v5 = _v3.a;
					return $author$project$Components$Charge$Form$RoutingFields$patientPayerId(patient);
				}
			} else {
				if (!_v3.b) {
					var _v6 = _v3.a;
					return A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Company$Min$id,
						$author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany(patient));
				} else {
					var _v7 = _v3.a;
					return $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview);
				}
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Charge$Form$RoutingFields$GotCustomerInvoices = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$GotSponsorInvoices = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Invoice$All$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$All$Record = F6(
	function (invoiceDate, humanStatus, amountInCents, paidInCents, dueInCents, description) {
		return {I2: amountInCents, Nx: description, N2: dueInCents, QE: humanStatus, Rn: invoiceDate, Vu: paidInCents};
	});
var $author$project$Api$Provider$Invoice$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'paid_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'human_status',
					$author$project$Api$Invoice$Status$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'invoice_date',
						$author$project$Utils$Date$decode,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$All$Record)))))));
var $author$project$Api$Provider$Invoice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$All$Invoice)));
var $author$project$Api$Provider$Invoice$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Invoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Invoice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				function () {
				var _v0 = options.ag7;
				if (!_v0.$) {
					var list_ = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$list, 'status', list_)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$Company$Invoice$list = F4(
	function (apiClient, companyId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Invoice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Invoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$Invoice$invoicesPath(companyId))));
	});
var $author$project$Api$Provider$CustomerInvoice$All$CustomerInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$CustomerInvoice$All$Record = function (id) {
	return function (date) {
		return function (dueInCents) {
			return function (invoiceNumber) {
				return function (humanStatus) {
					return function (isPaymentScheduled) {
						return function (paymentScheduledOn) {
							return function (status) {
								return function (issuedTotalInCents) {
									return function (totalInCents) {
										return function (lastSentAt) {
											return function (paidAt) {
												return function (nextScheduledPaymentDate) {
													return {MO: date, N2: dueInCents, QE: humanStatus, adR: id, Rq: invoiceNumber, R_: isPaymentScheduled, Sn: issuedTotalInCents, SD: lastSentAt, UH: nextScheduledPaymentDate, Vt: paidAt, V2: paymentScheduledOn, ag7: status, $X: totalInCents};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'next_scheduled_payment_date',
	$elm$json$Json$Decode$maybe($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'paid_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_sent_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'total_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'issued_total_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'payment_scheduled_on',
							$elm$json$Json$Decode$maybe($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_payment_scheduled',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'human_status',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'invoice_number',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'due_in_cents',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'date',
												$author$project$Utils$Date$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$All$Record))))))))))))));
var $author$project$Api$Provider$CustomerInvoice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CustomerInvoice$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CustomerInvoice$listDefaults = {E9: $elm$core$Maybe$Nothing, Fc: _List_Nil, Vp: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$CustomerInvoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$CustomerInvoice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				function () {
				var _v0 = options.ag7;
				if (!_v0.$) {
					var list_ = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$list, 'status', list_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.Vp;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'owner', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Hl;
				if (!_v2.$) {
					var start_ = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'start', start_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.E9;
				if (!_v3.$) {
					var end_ = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'end', end_)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Provider$CustomerInvoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CustomerInvoice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$CustomerInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicesPath)));
	});
var $author$project$Components$Charge$Form$RoutingFields$listInvoices = F2(
	function (apiClient, model) {
		var _v0 = _Utils_Tuple2(model.adm.VW, model.adm.afG);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var options = function (d) {
						return _Utils_update(
							d,
							{
								Vp: model.adm.afG,
								afy: model.afy,
								ag7: $elm$core$Maybe$Just(
									_List_fromArray(
										['draft']))
							});
					};
					return A3($author$project$Api$Provider$CustomerInvoice$list, apiClient, options, $author$project$Components$Charge$Form$RoutingFields$GotCustomerInvoices);
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					var id = _v0.b.a;
					var options = function (d) {
						return _Utils_update(
							d,
							{
								afy: model.afy,
								ag7: $elm$core$Maybe$Just(
									_List_fromArray(
										['draft']))
							});
					};
					return A4($author$project$Api$Provider$Company$Invoice$list, apiClient, id, options, $author$project$Components$Charge$Form$RoutingFields$GotSponsorInvoices);
				} else {
					break _v0$2;
				}
			}
		}
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Components$Charge$Form$RoutingFields$PreviewWithPayerRequested = 1;
var $author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer = F2(
	function (payerType, dataPreview) {
		var _v0 = _Utils_Tuple2(payerType, dataPreview);
		if ((_v0.a === 1) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			var preview = _v2.a;
			return $author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview) ? 0 : 1;
		} else {
			return 0;
		}
	});
var $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading = function (model) {
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(model.adm.VW, model.adm.afG);
		_v1$2:
		while (true) {
			if (!_v1.a) {
				if (!_v1.b.$) {
					var _v2 = _v1.a;
					return _Utils_Tuple2($author$project$Api$Data$Loading, model.gQ);
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					return _Utils_Tuple2(model.cP, $author$project$Api$Data$Loading);
				} else {
					break _v1$2;
				}
			}
		}
		return _Utils_Tuple2(model.cP, model.gQ);
	}();
	var customerInvoices = _v0.a;
	var sponsorInvoices = _v0.b;
	return _Utils_update(
		model,
		{cP: customerInvoices, gQ: sponsorInvoices});
};
var $author$project$Components$Charge$Form$RoutingFields$initPatientPayerFilter = F2(
	function (apiClient, id) {
		return A2(
			$author$project$Components$ResourceFilter$Patient$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Patient', IS: false, afT: id, af_: id});
			});
	});
var $author$project$Components$Charge$Form$RoutingFields$updatePayerId = F2(
	function (payerId, fields) {
		return _Utils_update(
			fields,
			{afG: payerId});
	});
var $author$project$Components$Charge$Form$RoutingFields$updatePayerType = F2(
	function (payerType, fields) {
		return _Utils_eq(fields.VW, payerType) ? fields : _Utils_update(
			fields,
			{aea: $elm$core$Maybe$Nothing, afG: $elm$core$Maybe$Nothing, VW: payerType});
	});
var $author$project$Components$Charge$Form$RoutingFields$updateFromPreview = F4(
	function (apiClient, model, dataPreview, preview) {
		var newFields = A2(
			$author$project$Components$Charge$Form$RoutingFields$updatePayerId,
			$author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview),
			A2(
				$author$project$Components$Charge$Form$RoutingFields$updatePayerType,
				$author$project$Api$Charge$PayerType$toPayerType(
					$author$project$Api$Charge$PayerType$adjudicatedType(preview)),
				model.adm));
		var _v0 = function () {
			var _v1 = model.VM;
			if (_v1.$ === 3) {
				var patient = _v1.a;
				return A2(
					$author$project$Components$Charge$Form$RoutingFields$initPatientPayerFilter,
					apiClient,
					$author$project$Components$Charge$Form$RoutingFields$patientPayerId(patient));
			} else {
				return _Utils_Tuple2(model.eg, $elm$core$Platform$Cmd$none);
			}
		}();
		var newPatientPayerFilter = _v0.a;
		var newPatientPayerFilterCmd = _v0.b;
		var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(
			_Utils_update(
				model,
				{adm: newFields, eg: newPatientPayerFilter, afU: dataPreview}));
		return {
			EC: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, newPatientPayerFilterCmd),
						A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel)
					])),
			ac5: 0,
			y8: newModel,
			as: _List_Nil
		};
	});
var $author$project$Components$Charge$Form$RoutingFields$updateInvoiceId = F2(
	function (invoiceId, fields) {
		return _Utils_update(
			fields,
			{aea: invoiceId});
	});
var $author$project$Components$Charge$Form$RoutingFields$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var patientId = msg.a;
				return {
					EC: A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId, $author$project$Components$Charge$Form$RoutingFields$GotPatient),
					ac5: 0,
					y8: _Utils_update(
						model,
						{VM: $author$project$Api$Data$Loading, VN: patientId}),
					as: _List_Nil
				};
			case 1:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{VM: response}),
					as: _List_Nil
				};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var preview = response.a;
					return A4($author$project$Components$Charge$Form$RoutingFields$updateFromPreview, apiClient, model, response, preview);
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{afU: response}),
						as: _List_Nil
					};
				}
			case 3:
				var response = msg.a;
				var newFields = function () {
					if (response.$ === 3) {
						return A2(
							$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
							A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.adm, model.cP, model.afU, response),
							model.adm);
					} else {
						return model.adm;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{adm: newFields, jD: response}),
					as: _List_Nil
				};
			case 4:
				var response = msg.a;
				var newFields = A2(
					$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
					A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.adm, model.cP, model.afU, model.jD),
					model.adm);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{adm: newFields, gQ: response}),
					as: _List_Nil
				};
			case 5:
				var response = msg.a;
				var newFields = A2(
					$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
					A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.adm, response, model.afU, model.jD),
					model.adm);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{cP: response, adm: newFields}),
					as: _List_Nil
				};
			case 6:
				var payerType = msg.a;
				var newFields = A2(
					$author$project$Components$Charge$Form$RoutingFields$updatePayerId,
					A3($author$project$Components$Charge$Form$RoutingFields$defaultPayerId, payerType, model.VM, model.afU),
					A2($author$project$Components$Charge$Form$RoutingFields$updatePayerType, payerType, model.adm));
				var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(
					_Utils_update(
						model,
						{adm: newFields, AI: true}));
				return {
					EC: A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel),
					ac5: A2($author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer, payerType, model.afU),
					y8: newModel,
					as: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var patientPayerFilterResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.eg);
				var _v3 = _Utils_Tuple2(patientPayerFilterResult.ac5, model.adm.VW);
				if ((((!_v3.a.$) && (!_v3.a.a.$)) && (!_v3.a.a.a.$)) && (!_v3.b)) {
					var patient = _v3.a.a.a.a;
					var _v4 = _v3.b;
					var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(
						_Utils_update(
							model,
							{
								adm: A2(
									$author$project$Components$Charge$Form$RoutingFields$updatePayerId,
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Patient$All$id(patient)),
									model.adm),
								eg: patientPayerFilterResult.y8
							}));
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, patientPayerFilterResult.EC),
									A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel)
								])),
						ac5: 0,
						y8: newModel,
						as: patientPayerFilterResult.as
					};
				} else {
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, patientPayerFilterResult.EC),
						ac5: 0,
						y8: _Utils_update(
							model,
							{eg: patientPayerFilterResult.y8}),
						as: patientPayerFilterResult.as
					};
				}
			case 8:
				var payerId = msg.a;
				var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(
					_Utils_update(
						model,
						{
							adm: A2(
								$author$project$Components$Charge$Form$RoutingFields$updatePayerId,
								$elm$core$Maybe$Just(payerId),
								model.adm)
						}));
				return {
					EC: A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel),
					ac5: A2($author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer, 1, model.afU),
					y8: newModel,
					as: _List_Nil
				};
			case 9:
				var invoiceId = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							adm: A2(
								$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
								$elm$core$Maybe$Just(invoiceId),
								model.adm)
						}),
					as: _List_Nil
				};
			case 10:
				var invoiceId = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							adm: A2(
								$author$project$Components$Charge$Form$RoutingFields$updateInvoiceId,
								$elm$core$Maybe$Just(invoiceId),
								model.adm)
						}),
					as: _List_Nil
				};
			default:
				var currentDate = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							cO: $elm$core$Maybe$Just(currentDate)
						}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Charge$Form$GotPreview = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Charge$Form$shouldCalculatePreview = function (field) {
	switch (field.$) {
		case 0:
			return true;
		case 1:
			return false;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return true;
		case 7:
			return true;
		case 2:
			return false;
		case 13:
			return true;
		case 14:
			return true;
		case 10:
			return true;
		case 8:
			return true;
		case 9:
			return false;
		case 11:
			return false;
		default:
			return false;
	}
};
var $author$project$Components$Charge$Form$validPreviewFields = function (fields) {
	return $author$project$Utils$Maybe$toBool(fields.zh) && (A2($elm$core$Maybe$withDefault, 0, fields.Bd) > 0);
};
var $author$project$Components$Charge$Form$calculatePreview = F4(
	function (apiClient, field, form, model) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = ($author$project$Components$Charge$Form$shouldCalculatePreview(field) && $author$project$Components$Charge$Form$validPreviewFields(fields)) ? A2(
			$author$project$Utils$Tuple3$fromTuple2,
			A2(
				$elm$core$Task$perform,
				$author$project$Components$Charge$Form$RoutingFieldsMsg,
				$elm$core$Task$succeed(
					$author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$Loading))),
			A3(
				$jinjor$elm_debounce$Debounce$push,
				$author$project$Components$Charge$Form$previewDebounceConfig,
				A4(
					$author$project$Api$Provider$Charge$calculate,
					$author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath),
					apiClient,
					A2($author$project$Components$Charge$Form$paramsWithPrice, fields, model.afU),
					$author$project$Components$Charge$Form$GotPreview),
				model.em)) : _Utils_Tuple3(model.em, $elm$core$Platform$Cmd$none, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		var routingFieldsCmd = _v0.c;
		return _Utils_Tuple2(
			($author$project$Components$Charge$Form$shouldCalculatePreview(field) && $author$project$Components$Charge$Form$validPreviewFields(fields)) ? _Utils_update(
				model,
				{afU: $author$project$Api$Data$Loading, em: newDebouncer}) : ((!$author$project$Components$Charge$Form$validPreviewFields(fields)) ? _Utils_update(
				model,
				{afU: $author$project$Api$Data$NotAsked, em: newDebouncer}) : _Utils_update(
				model,
				{em: newDebouncer})),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, routingFieldsCmd])));
	});
var $author$project$Components$Charge$Form$updateForm = F4(
	function (apiClient, model, field, form) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, field, form);
		return A4(
			$author$project$Components$Charge$Form$calculatePreview,
			apiClient,
			field,
			newForm,
			_Utils_update(
				model,
				{e: newForm}));
	});
var $author$project$Components$Charge$Form$updateDateInputFormField = F7(
	function (apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var fields = $author$project$Utils$Form$fields(model.e);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var _v1 = function () {
			if (event.$ === 1) {
				var date = event.a;
				return _Utils_Tuple2(
					A2(field, newDateInput, date),
					!_Utils_eq(
						date,
						fieldGetter(fields)));
			} else {
				return _Utils_Tuple2(
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					false);
			}
		}();
		var dateField = _v1.a;
		var shouldPreview = _v1.b;
		var _v3 = shouldPreview ? A4($author$project$Components$Charge$Form$updateForm, apiClient, model, dateField, model.e) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					e: A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, dateField, model.e)
				}),
			$elm$core$Platform$Cmd$none);
		var newModel = _v3.a;
		var formCmd = _v3.b;
		return {
			EC: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formCmd,
						A2(
						$elm$core$Platform$Cmd$map,
						toMsg(newDateInput),
						subCmd)
					])),
			ac5: 0,
			y8: newModel,
			as: _List_Nil
		};
	});
var $author$project$Components$Charge$Form$updateFilters = F3(
	function (apiClient, patient, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				$author$project$Api$Provider$Patient$One$location(patient),
				$author$project$Api$Provider$Patient$One$practitioner(patient));
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var location = _v1.a.a;
					var practitioner = _v1.b.a;
					var practitionerResourceFilter_ = function (value) {
						return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, model.jC);
					}(
						$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
							$elm$core$Maybe$Just(
								$author$project$Api$Practitioner$Shared$Provider(practitioner))));
					var locationResourceFilter_ = function (value) {
						return A2($author$project$Components$ResourceFilter$Location$setValue, value, model.rl);
					}(
						$author$project$Components$ResourceFilter$Location$resourceFromShared(
							$elm$core$Maybe$Just(
								$author$project$Api$Location$Shared$Provider(location))));
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(locationResourceFilter_),
						$elm$core$Maybe$Just(practitionerResourceFilter_));
				} else {
					var location = _v1.a.a;
					var _v2 = _v1.b;
					var locationResourceFilter_ = function (value) {
						return A2($author$project$Components$ResourceFilter$Location$setValue, value, model.rl);
					}(
						$author$project$Components$ResourceFilter$Location$resourceFromShared(
							$elm$core$Maybe$Just(
								$author$project$Api$Location$Shared$Provider(location))));
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(locationResourceFilter_),
						$elm$core$Maybe$Nothing);
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var practitioner = _v1.b.a;
					var practitionerResourceFilter_ = function (value) {
						return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, model.jC);
					}(
						$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
							$elm$core$Maybe$Just(
								$author$project$Api$Practitioner$Shared$Provider(practitioner))));
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(practitionerResourceFilter_));
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				}
			}
		}();
		var locationResourceFilter = _v0.a;
		var practitionerResourceFilter = _v0.b;
		var _v6 = function () {
			if (!practitionerResourceFilter.$) {
				var filter = practitionerResourceFilter.a;
				return _Utils_Tuple2(filter, $elm$core$Platform$Cmd$none);
			} else {
				return $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
			}
		}();
		var newPractitionerResourceFilter = _v6.a;
		var newPractitionerResourceFilterCmd = _v6.b;
		var _v8 = function () {
			if (!locationResourceFilter.$) {
				var filter = locationResourceFilter.a;
				return _Utils_Tuple2(filter, $elm$core$Platform$Cmd$none);
			} else {
				return $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
			}
		}();
		var newLocationResourceFilter = _v8.a;
		var newLocationResourceFilterCmd = _v8.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{rl: newLocationResourceFilter, jC: newPractitionerResourceFilter}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, newLocationResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, newPractitionerResourceFilterCmd)
					])));
	});
var $author$project$Components$Charge$Form$DiscountInCents = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Charge$Form$PriceInCents = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Charge$Form$updateFormFromPreview = F2(
	function (preview, form) {
		return A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Charge$Form$formFieldsUpdate,
			$author$project$Components$Charge$Form$DiscountInCents(
				$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)),
			A3(
				$author$project$Utils$Form$update,
				$author$project$Components$Charge$Form$formFieldsUpdate,
				$author$project$Components$Charge$Form$PriceInCents(
					$elm$core$Maybe$Just(
						$author$project$Currency$fromInt(
							$author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))),
				form));
	});
var $author$project$Components$Charge$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v2 = A4($author$project$Components$Charge$Form$updateForm, apiClient, model, field, model.e);
				var newModel = _v2.a;
				var formCmd = _v2.b;
				return {EC: formCmd, ac5: 0, y8: newModel, as: _List_Nil};
			case 1:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Charge$Form$formFieldsValidator, model.e);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var form = _v4.a;
					var validFormFields = _v4.b;
					return {
						EC: A3($author$project$Components$Charge$Form$createCharge, apiClient, model, validFormFields),
						ac5: 0,
						y8: _Utils_update(
							model,
							{abU: $author$project$Api$Data$Loading, e: form}),
						as: _List_Nil
					};
				} else {
					var newForm = _v3.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{e: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var newPatientFilter = A2($author$project$Components$ResourceFilter$Patient$setValue, $elm$core$Maybe$Nothing, model.rU);
				var newChargeItemFilter = A2($author$project$Components$ResourceFilter$ChargeItem$setValue, $author$project$Components$ResourceFilter$All, model.cK);
				var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.WF);
				var _v5 = $author$project$Components$DateInput$init;
				var startDateInput = _v5.a;
				var startDateInputCmd = _v5.b;
				var _v6 = $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
				var practitionerResourceFilter = _v6.a;
				var practitionerResourceFilterCmd = _v6.b;
				var _v7 = $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
				var locationResourceFilter = _v7.a;
				var locationResourceFilterCmd = _v7.b;
				var _v8 = $author$project$Components$DateInput$init;
				var endDateInput = _v8.a;
				var endDateInputCmd = _v8.b;
				var _v9 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, model.ZD, excludeLabs);
				var categoryResourceFilter = _v9.a;
				var categoryResourceFilterCmd = _v9.b;
				var newModel = _Utils_update(
					model,
					{
						e: $author$project$Utils$Form$init(
							A4(
								$author$project$Components$Charge$Form$initFormFields,
								$elm$core$Maybe$Just(model.cO),
								startDateInput,
								endDateInput,
								categoryResourceFilter)),
						cK: newChargeItemFilter,
						rl: locationResourceFilter,
						rU: newPatientFilter,
						jC: practitionerResourceFilter,
						afU: $author$project$Api$Data$NotAsked
					});
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								$author$project$Components$Charge$Form$RoutingFieldsMsg,
								$elm$core$Task$succeed(
									$author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Charge$Form$StartDateInputMsg(startDateInput),
								startDateInputCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Charge$Form$EndDateInputMsg(endDateInput),
								endDateInputCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
							])),
					ac5: 0,
					y8: newModel,
					as: _List_Nil
				};
			case 3:
				var newChargeItemFilter = A2($author$project$Components$ResourceFilter$ChargeItem$setValue, $author$project$Components$ResourceFilter$All, model.cK);
				var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.WF);
				var _v10 = $author$project$Components$DateInput$init;
				var startDateInput = _v10.a;
				var startDateInputCmd = _v10.b;
				var _v11 = function () {
					var _v12 = model.VM;
					if (!_v12.$) {
						var patient = _v12.a;
						return A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, model);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var filtersMsg = _v11.b;
				var _v13 = $author$project$Components$DateInput$init;
				var endDateInput = _v13.a;
				var endDateInputCmd = _v13.b;
				var _v14 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, model.ZD, excludeLabs);
				var categoryResourceFilter = _v14.a;
				var categoryResourceFilterCmd = _v14.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Charge$Form$formFieldsUpdate,
					$author$project$Components$Charge$Form$Patient(
						$author$project$Utils$Form$fields(model.e).VM),
					$author$project$Utils$Form$init(
						A4(
							$author$project$Components$Charge$Form$initFormFields,
							$elm$core$Maybe$Just(model.cO),
							startDateInput,
							endDateInput,
							categoryResourceFilter)));
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								$author$project$Components$Charge$Form$RoutingFieldsMsg,
								$elm$core$Task$succeed(
									$author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Charge$Form$StartDateInputMsg(startDateInput),
								startDateInputCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$Charge$Form$EndDateInputMsg(endDateInput),
								endDateInputCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
								filtersMsg
							])),
					ac5: 0,
					y8: _Utils_update(
						model,
						{e: newForm, cK: newChargeItemFilter, afU: $author$project$Api$Data$NotAsked, XO: false, gJ: false, hd: true}),
					as: _List_Nil
				};
			case 4:
				var response = msg.a;
				var newForm = function () {
					if (response.$ === 3) {
						var preview = response.a;
						return A2($author$project$Components$Charge$Form$updateFormFromPreview, preview, model.e);
					} else {
						return model.e;
					}
				}();
				return {
					EC: A2(
						$elm$core$Task$perform,
						$author$project$Components$Charge$Form$RoutingFieldsMsg,
						$elm$core$Task$succeed(
							$author$project$Components$Charge$Form$RoutingFields$GotPreview(response))),
					ac5: 0,
					y8: _Utils_update(
						model,
						{e: newForm, afU: response}),
					as: _List_Nil
				};
			case 15:
				var response = msg.a;
				return {
					EC: A2(
						$elm$core$Task$perform,
						$author$project$Components$Charge$Form$RoutingFieldsMsg,
						$elm$core$Task$succeed(
							$author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer(response))),
					ac5: 0,
					y8: model,
					as: _List_Nil
				};
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var charge_ = response.a;
					var _v17 = A3(
						$author$project$Components$Charge$Form$overrideChargeDiscount,
						apiClient,
						$author$project$Api$Provider$Charge$One$id(charge_),
						model.e);
					var cmd = _v17.a;
					var event = _v17.b;
					return {
						EC: cmd,
						ac5: event,
						y8: _Utils_update(
							model,
							{abU: response, gJ: false}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{abU: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 13:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{abU: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 6:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rU);
				var patientUpdatedCmd = function () {
					var _v21 = patientResourceResult.ac5;
					if (((!_v21.$) && (!_v21.a.$)) && (!_v21.a.a.$)) {
						var patient = _v21.a.a.a;
						return A2(
							$elm$core$Task$perform,
							$author$project$Components$Charge$Form$RoutingFieldsMsg,
							$elm$core$Task$succeed(
								$author$project$Components$Charge$Form$RoutingFields$PatientUpdated(
									$author$project$Api$Provider$Patient$All$id(patient))));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var patientRequestCmd = function () {
					var _v20 = patientResourceResult.ac5;
					if (((!_v20.$) && (!_v20.a.$)) && (!_v20.a.a.$)) {
						var patient = _v20.a.a.a;
						var patientId = $author$project$Api$Provider$Patient$All$id(patient);
						return A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId, $author$project$Components$Charge$Form$GotPatient);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v18 = function () {
					var _v19 = patientResourceResult.ac5;
					if (((!_v19.$) && (!_v19.a.$)) && (!_v19.a.a.$)) {
						var patient = _v19.a.a.a;
						var formPatient = {
							adR: $author$project$Api$Provider$Patient$All$id(patient),
							zh: $author$project$Api$Provider$Patient$All$name(patient)
						};
						return A4(
							$author$project$Components$Charge$Form$updateForm,
							apiClient,
							model,
							$author$project$Components$Charge$Form$Patient(
								$elm$core$Maybe$Just(formPatient)),
							model.e);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v18.a;
				var formCmd = _v18.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								formCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceResult.EC),
								patientUpdatedCmd,
								patientRequestCmd
							])),
					ac5: 0,
					y8: _Utils_update(
						newModel,
						{rU: patientResourceResult.y8}),
					as: patientResourceResult.as
				};
			case 7:
				var subMsg = msg.a;
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cK);
				var _v22 = function () {
					var _v23 = chargeItemResourceResult.ac5;
					_v23$2:
					while (true) {
						if ((!_v23.$) && (!_v23.a.$)) {
							switch (_v23.a.a.$) {
								case 0:
									var chargeItem = _v23.a.a.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$ChargeItem(chargeItem),
										model.e);
								case 5:
									var string = _v23.a.a.a;
									var _v24 = A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Name(string),
										model.e);
									var newModel_ = _v24.a;
									var formCmd_ = _v24.b;
									return _Utils_Tuple2(
										_Utils_update(
											newModel_,
											{afU: $author$project$Api$Data$NotAsked}),
										$elm$core$Platform$Cmd$batch(
											_List_fromArray(
												[
													A2(
													$elm$core$Task$perform,
													$author$project$Components$Charge$Form$RoutingFieldsMsg,
													$elm$core$Task$succeed(
														$author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
													formCmd_
												])));
								default:
									break _v23$2;
							}
						} else {
							break _v23$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}();
				var newModel = _v22.a;
				var formCmd = _v22.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								formCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.EC)
							])),
					ac5: 0,
					y8: _Utils_update(
						newModel,
						{cK: chargeItemResourceResult.y8}),
					as: chargeItemResourceResult.as
				};
			case 8:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.e);
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.cJ);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{cJ: categoryResourceResult.y8}),
					model.e);
				var _v25 = function () {
					var _v26 = categoryResourceResult.ac5;
					if (!_v26.$) {
						if (!_v26.a.$) {
							return A4(
								$author$project$Components$Charge$Form$updateForm,
								apiClient,
								model,
								$author$project$Components$Charge$Form$Category(
									$author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8)),
								newForm);
						} else {
							var _v27 = _v26.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{e: newForm}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{e: newForm}),
							$elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v25.a;
				var formCmd = _v25.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceResult.EC),
								formCmd
							])),
					ac5: 0,
					y8: newModel,
					as: categoryResourceResult.as
				};
			case 9:
				var subMsg = msg.a;
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.jC);
				var _v28 = function () {
					var _v29 = practitionerResourceResult.ac5;
					_v29$2:
					while (true) {
						if ((!_v29.$) && (!_v29.a.$)) {
							switch (_v29.a.a.$) {
								case 0:
									var practitioner = _v29.a.a.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Practitioner(
											$elm$core$Maybe$Just(practitioner)),
										model.e);
								case 2:
									var _v30 = _v29.a.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Practitioner($elm$core$Maybe$Nothing),
										model.e);
								default:
									break _v29$2;
							}
						} else {
							break _v29$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}();
				var newModel = _v28.a;
				var formCmd = _v28.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								formCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceResult.EC)
							])),
					ac5: 0,
					y8: _Utils_update(
						newModel,
						{jC: practitionerResourceResult.y8}),
					as: practitionerResourceResult.as
				};
			case 10:
				var subMsg = msg.a;
				var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.rl);
				var _v31 = function () {
					var _v32 = locationResourceResult.ac5;
					_v32$2:
					while (true) {
						if ((!_v32.$) && (!_v32.a.$)) {
							switch (_v32.a.a.$) {
								case 0:
									var location = _v32.a.a.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Location(
											$elm$core$Maybe$Just(location)),
										model.e);
								case 2:
									var _v33 = _v32.a.a;
									return A4(
										$author$project$Components$Charge$Form$updateForm,
										apiClient,
										model,
										$author$project$Components$Charge$Form$Location($elm$core$Maybe$Nothing),
										model.e);
								default:
									break _v32$2;
							}
						} else {
							break _v32$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}();
				var newModel = _v31.a;
				var formCmd = _v31.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								formCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceResult.EC)
							])),
					ac5: 0,
					y8: _Utils_update(
						newModel,
						{rl: locationResourceResult.y8}),
					as: locationResourceResult.as
				};
			case 11:
				var debounceMsg = msg.a;
				var _v34 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Charge$Form$previewDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Charge$Form$debouncePreview),
					debounceMsg,
					model.em);
				var newDebouncer = _v34.a;
				var cmd = _v34.b;
				return {
					EC: cmd,
					ac5: 0,
					y8: _Utils_update(
						model,
						{em: newDebouncer}),
					as: _List_Nil
				};
			case 12:
				var cmd = msg.a;
				return {EC: cmd, ac5: 0, y8: model, as: _List_Nil};
			case 14:
				var subMsg = msg.a;
				var routingFieldsResult = A3($author$project$Components$Charge$Form$RoutingFields$update, apiClient, subMsg, model.n2);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Charge$Form$formFieldsUpdate,
					$author$project$Components$Charge$Form$RoutingFields(routingFieldsResult.y8.adm),
					model.e);
				var newModel = _Utils_update(
					model,
					{e: newForm, n2: routingFieldsResult.y8});
				var previewWithPayerCmds = function () {
					var _v35 = routingFieldsResult.ac5;
					if (_v35 === 1) {
						return A2($author$project$Components$Charge$Form$calculatePreviewWithPayer, apiClient, newModel);
					} else {
						return _List_Nil;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFieldsMsg, routingFieldsResult.EC),
							previewWithPayerCmds)),
					ac5: 0,
					y8: newModel,
					as: routingFieldsResult.as
				};
			case 16:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{gJ: !model.gJ}),
					as: _List_Nil
				};
			case 17:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Charge$Form$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Charge$Form$StartDateInputMsg,
					$author$project$Components$Charge$Form$StartDate,
					function ($) {
						return $._E;
					});
			case 18:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Charge$Form$updateDateInputFormField,
					apiClient,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Charge$Form$EndDateInputMsg,
					$author$project$Components$Charge$Form$EndDate,
					function ($) {
						return $.qs;
					});
			case 20:
				var response = msg.a;
				if (response.$ === 3) {
					var patient = response.a;
					var fields = $author$project$Utils$Form$fields(model.e);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{
								aet: A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Location$Shared$id,
									$author$project$Api$Provider$Patient$One$location(patient)),
								afS: A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Practitioner$Shared$id,
									$author$project$Api$Provider$Patient$One$practitioner(patient))
							}),
						model.e);
					var _v37 = A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, model);
					var newModel = _v37.a;
					var filtersMsg = _v37.b;
					return {
						EC: filtersMsg,
						ac5: 0,
						y8: _Utils_update(
							newModel,
							{
								e: newForm,
								VM: $elm$core$Maybe$Just(patient)
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				var modelWithResponse = _Utils_update(
					model,
					{A8: response});
				if (response.$ === 3) {
					var patient = response.a;
					var formPatient = {
						adR: $author$project$Api$Provider$Patient$One$id(patient),
						zh: $author$project$Api$Provider$Patient$One$name(patient)
					};
					var _v39 = A2(
						$author$project$Components$Charge$Form$initPatientResourceFilter,
						apiClient,
						$elm$core$Maybe$Just(patient));
					var patientResourceFilter = _v39.a;
					var patientResourceFilterCmd = _v39.b;
					var _v40 = A4(
						$author$project$Components$Charge$Form$updateForm,
						apiClient,
						modelWithResponse,
						$author$project$Components$Charge$Form$Patient(
							$elm$core$Maybe$Just(formPatient)),
						modelWithResponse.e);
					var modelWithForm = _v40.a;
					var formCmd = _v40.b;
					var _v41 = A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, modelWithForm);
					var modelWithFilters = _v41.a;
					var filtersCmd = _v41.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceFilterCmd),
									formCmd,
									filtersCmd,
									A2(
									$elm$core$Task$perform,
									$author$project$Components$Charge$Form$RoutingFieldsMsg,
									$elm$core$Task$succeed(
										$author$project$Components$Charge$Form$RoutingFields$PatientUpdated(
											$author$project$Api$Provider$Patient$One$id(patient))))
								])),
						ac5: 0,
						y8: _Utils_update(
							modelWithFilters,
							{
								VM: $elm$core$Maybe$Just(patient),
								rU: patientResourceFilter
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: modelWithResponse,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$CustomerEmailModal$Editing = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$CustomerEmailModal$Open = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$CustomerEmailModal$GotDelivery = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$CustomerEmailModal$createNotification = F3(
	function (apiClient, _v0, preview) {
		var type_ = _v0.ahI;
		var contextId = _v0.wN;
		var recipient = _v0.Bm;
		return A6(
			$author$project$Api$Provider$Notification$create,
			apiClient,
			type_,
			$author$project$Api$Provider$Notification$Patient(
				$author$project$Components$CustomerEmailModal$recipientId(recipient)),
			contextId,
			{
				e5: $author$project$Api$Provider$Notification$One$body(preview),
				Hp: $author$project$Api$Provider$Notification$One$subject(preview)
			},
			$author$project$Components$CustomerEmailModal$GotDelivery);
	});
var $author$project$Components$CustomerEmailModal$initNotificationFormFields = function (notification) {
	return {
		e5: $author$project$Api$Provider$Notification$One$body(notification),
		Hp: $author$project$Api$Provider$Notification$One$subject(notification)
	};
};
var $author$project$Components$CustomerEmailModal$notificationFormFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					Hp: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					e5: $author$project$Utils$String$toMaybe(string)
				});
		}
	});
var $author$project$Components$CustomerEmailModal$BodyValidation = 1;
var $author$project$Components$CustomerEmailModal$SubjectValidation = 0;
var $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Hp;
			},
			_Utils_Tuple2(0, 'Please enter a valid subject')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.e5;
			},
			_Utils_Tuple2(1, 'Please enter a valid body'))
		]));
var $author$project$Components$CustomerEmailModal$patientFormFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{Oo: string});
	});
var $author$project$Components$CustomerEmailModal$EmailValidation = 0;
var $author$project$Components$CustomerEmailModal$patientFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Oo;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email'))
		]));
var $author$project$Components$CustomerEmailModal$GotPatient = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Patient$updateEmail = F4(
	function (apiClient, id_, email_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(email_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Components$CustomerEmailModal$updatePatientEmail = F2(
	function (apiClient, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var patientId = _v0.VN;
		var email = _v0.Oo;
		return A4($author$project$Api$Provider$Patient$updateEmail, apiClient, patientId, email, $author$project$Components$CustomerEmailModal$GotPatient);
	});
var $author$project$Components$CustomerEmailModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var session = msg.a;
				var type_ = msg.b;
				var contextId = msg.c;
				var recipient = msg.d;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A6($author$project$Components$CustomerEmailModal$open, apiClient, session, type_, contextId, recipient, model));
			case 1:
				return _Utils_Tuple3($author$project$Components$CustomerEmailModal$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
			case 2:
				if (model.$ === 4) {
					var shared = model.a;
					var email = model.b;
					var notificationForm = model.c;
					var preview = model.d;
					var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator, notificationForm);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var newForm = _v3.a;
						var validFormFields = _v3.b;
						return _Utils_Tuple3(
							A4($author$project$Components$CustomerEmailModal$Editing, shared, email, newForm, $author$project$Api$Data$Loading),
							A3(
								$author$project$Components$CustomerEmailModal$previewNotification,
								apiClient,
								shared,
								$elm$core$Maybe$Just(validFormFields)),
							_List_Nil);
					} else {
						var newForm = _v2.a;
						return _Utils_Tuple3(
							A4($author$project$Components$CustomerEmailModal$Editing, shared, email, newForm, preview),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				if (model.$ === 3) {
					var shared = model.a;
					var email = model.b;
					var preview = model.c;
					return _Utils_Tuple3(
						A4(
							$author$project$Components$CustomerEmailModal$Editing,
							shared,
							email,
							$author$project$Utils$Form$init(
								$author$project$Components$CustomerEmailModal$initNotificationFormFields(preview)),
							$author$project$Api$Data$NotAsked),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				if (model.$ === 3) {
					var shared = model.a;
					var email = model.b;
					var preview = model.c;
					return _Utils_Tuple3(
						A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$Loading),
						A3($author$project$Components$CustomerEmailModal$createNotification, apiClient, shared, preview),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				if (model.$ === 1) {
					var shared = model.a;
					var patientForm = model.b;
					var _v7 = function () {
						var _v8 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$patientFormFieldsValidator, patientForm);
						if (!_v8.$) {
							var _v9 = _v8.a;
							var form = _v9.a;
							var validFormFields = _v9.b;
							return _Utils_Tuple2(
								form,
								A2($author$project$Components$CustomerEmailModal$updatePatientEmail, apiClient, validFormFields));
						} else {
							var form = _v8.a;
							return _Utils_Tuple2(form, $elm$core$Platform$Cmd$none);
						}
					}();
					var validatedForm = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple3(
						A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, validatedForm),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v10 = _Utils_Tuple2(model, response);
				switch (_v10.a.$) {
					case 2:
						if (_v10.b.$ === 3) {
							var _v11 = _v10.a;
							var shared = _v11.a;
							var email = _v11.b;
							var _v12 = _v10.b;
							var preview = _v12.a;
							return _Utils_Tuple3(
								A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$NotAsked),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							var _v13 = _v10.a;
							var shared = _v13.a;
							var email = _v13.b;
							return _Utils_Tuple3(
								A2($author$project$Components$CustomerEmailModal$Loading, shared, email),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					case 4:
						if (_v10.b.$ === 3) {
							var _v14 = _v10.a;
							var shared = _v14.a;
							var email = _v14.b;
							var _v15 = _v10.b;
							var preview = _v15.a;
							return _Utils_Tuple3(
								A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$NotAsked),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							var _v16 = _v10.a;
							var shared = _v16.a;
							var email = _v16.b;
							var notificationForm = _v16.c;
							return _Utils_Tuple3(
								A4($author$project$Components$CustomerEmailModal$Editing, shared, email, notificationForm, response),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var field = msg.a;
				if (model.$ === 4) {
					var shared = model.a;
					var email = model.b;
					var notificationForm = model.c;
					var preview = model.d;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerEmailModal$notificationFormFieldsUpdate, field, notificationForm);
					var validatedForm = function () {
						var _v18 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator, newForm);
						if (!_v18.$) {
							var _v19 = _v18.a;
							var form = _v19.a;
							return form;
						} else {
							var form = _v18.a;
							return form;
						}
					}();
					return _Utils_Tuple3(
						A4($author$project$Components$CustomerEmailModal$Editing, shared, email, validatedForm, preview),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var field = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var patientForm = model.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerEmailModal$patientFormFieldsUpdate, field, patientForm);
					var validatedForm = function () {
						var _v21 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$patientFormFieldsValidator, newForm);
						if (!_v21.$) {
							var _v22 = _v21.a;
							var form = _v22.a;
							return form;
						} else {
							var form = _v21.a;
							return form;
						}
					}();
					return _Utils_Tuple3(
						A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, validatedForm),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				if (model.$ === 1) {
					var shared = model.a;
					var patientForm = model.b;
					if (response.$ === 3) {
						var patient = response.a;
						return _Utils_Tuple3(
							A2(
								$author$project$Components$CustomerEmailModal$Loading,
								shared,
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Patient$One$email(patient))),
							A3($author$project$Components$CustomerEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Patient email updated')
								]));
					} else {
						return _Utils_Tuple3(
							A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, patientForm),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (model.$ === 3) {
					var shared = model.a;
					var email = model.b;
					var preview = model.c;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							$author$project$Components$CustomerEmailModal$Closed,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'This email is being sent')
								]));
					} else {
						return _Utils_Tuple3(
							A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, response),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Api$Provider$CustomerInvoice$Adjustments = 2;
var $author$project$Components$CustomerSchedulePaymentModal$Date = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$CustomerSchedulePaymentModal$None = {$: 0};
var $author$project$Api$Provider$CustomerInvoice$OwnerPhones = 3;
var $author$project$Components$CustomerSchedulePaymentModal$PaymentScheduled = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$CustomerInvoice$Payments = 1;
var $author$project$Components$CustomerSchedulePaymentModal$Scheduled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{MO: date, qd: dateInput});
	});
var $author$project$Components$CustomerSchedulePaymentModal$DateValidation = 0;
var $author$project$Components$CustomerSchedulePaymentModal$validateStartDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.MO;
		if (!_v0.$) {
			var date = _v0.a;
			return (A2($justinmimbs$date$Date$compare, currentDate, date) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a future date')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$CustomerSchedulePaymentModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$CustomerSchedulePaymentModal$validateStartDate(currentDate))
			]));
};
var $author$project$Api$Provider$CustomerInvoice$schedulePayment = F5(
	function (apiClient, id, date, expand, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, date))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2(
							$author$project$Api$Param$list,
							'expand',
							A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
						]),
					$author$project$Api$Data$requestTo(
						A2(
							$author$project$Api$Data$pathAppend,
							_List_fromArray(
								['schedule_payment']),
							$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))))));
	});
var $author$project$Components$CustomerSchedulePaymentModal$update = F3(
	function (apiClient, msg, model) {
		if (model.$ === 1) {
			var model_ = model.a;
			switch (msg.$) {
				case 0:
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$CustomerSchedulePaymentModal$None, y8: $author$project$Components$CustomerSchedulePaymentModal$Closed, as: _List_Nil};
				case 1:
					var _v2 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$CustomerSchedulePaymentModal$formFieldsValidator(model_.cO),
						model_.PB);
					if (!_v2.$) {
						var _v3 = _v2.a;
						var newForm = _v3.a;
						var validFormFields = _v3.b;
						var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var date = _v4.MO;
						return {
							EC: A5(
								$author$project$Api$Provider$CustomerInvoice$schedulePayment,
								apiClient,
								model_.aea,
								date,
								_List_fromArray(
									[0, 1, 2, 3]),
								$author$project$Components$CustomerSchedulePaymentModal$Scheduled),
							ac5: $author$project$Components$CustomerSchedulePaymentModal$None,
							y8: $author$project$Components$CustomerSchedulePaymentModal$Open(
								_Utils_update(
									model_,
									{PB: newForm, so: $author$project$Api$Data$Loading})),
							as: _List_Nil
						};
					} else {
						var newForm = _v2.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$CustomerSchedulePaymentModal$None,
							y8: $author$project$Components$CustomerSchedulePaymentModal$Open(
								_Utils_update(
									model_,
									{PB: newForm})),
							as: _List_Nil
						};
					}
				case 2:
					var response = msg.a;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: A2($author$project$Components$CustomerSchedulePaymentModal$PaymentScheduled, model_.aea, response),
							y8: $author$project$Components$CustomerSchedulePaymentModal$Closed,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Payment scheduled!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$CustomerSchedulePaymentModal$None,
							y8: model,
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				default:
					var dateInput = msg.a;
					var subMsg = msg.b;
					var _v6 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
					var newDateInput = _v6.a;
					var subCmd = _v6.b;
					var event = _v6.c;
					var newForm = function () {
						if (event.$ === 1) {
							var date = event.a;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate,
								A2($author$project$Components$CustomerSchedulePaymentModal$Date, newDateInput, date),
								model_.PB);
						} else {
							var fields = $author$project$Utils$Form$fields(model_.PB);
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate,
								A2($author$project$Components$CustomerSchedulePaymentModal$Date, newDateInput, fields.MO),
								model_.PB);
						}
					}();
					return {
						EC: A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(newDateInput),
							subCmd),
						ac5: $author$project$Components$CustomerSchedulePaymentModal$None,
						y8: $author$project$Components$CustomerSchedulePaymentModal$Open(
							_Utils_update(
								model_,
								{PB: newForm})),
						as: _List_Nil
					};
			}
		} else {
			return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$CustomerSchedulePaymentModal$None, y8: $author$project$Components$CustomerSchedulePaymentModal$Closed, as: _List_Nil};
		}
	});
var $author$project$Pages$Charges$New$updateField = F2(
	function (invoice, field) {
		switch (field.$) {
			case 0:
				var status = field.a;
				return _Utils_update(
					invoice,
					{ag7: status});
			case 1:
				var dropdownMenu = field.a;
				return _Utils_update(
					invoice,
					{lV: dropdownMenu});
			default:
				var response = field.a;
				return _Utils_update(
					invoice,
					{jY: response});
		}
	});
var $author$project$Pages$Charges$New$updateInvoice = F3(
	function (invoiceId, field, invoices) {
		return A2(
			$elm$core$List$map,
			function (invoice) {
				return _Utils_eq(invoice.adR, invoiceId) ? A2($author$project$Pages$Charges$New$updateField, invoice, field) : invoice;
			},
			invoices);
	});
var $author$project$Pages$Charges$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sr: true}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$save),
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sr: false}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$save),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var chargeFormResult = A3($author$project$Components$Charge$Form$update, model.D5, subMsg, model.e);
				var maybeInvoice = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Charge$One$invoice,
						$author$project$Api$Data$toMaybe(
							$author$project$Components$Charge$Form$charge(chargeFormResult.y8))));
				var invoiceRetrieveCmd = function () {
					if (!maybeInvoice.$) {
						var invoice = maybeInvoice.a;
						var _v7 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
						switch (_v7) {
							case 1:
								return A4(
									$author$project$Api$Provider$CustomerInvoice$retrieve,
									model.D5,
									$author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
									_List_Nil,
									A2(
										$author$project$Pages$Charges$New$GotCustomerInvoice,
										$author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
										$elm$core$Maybe$Nothing));
							case 0:
								return $elm$core$Platform$Cmd$none;
							default:
								return $elm$core$Platform$Cmd$none;
						}
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var _v1 = function () {
					var _v2 = chargeFormResult.ac5;
					if (_v2 === 1) {
						var _v3 = model.sr ? _Utils_Tuple2($author$project$Components$Charge$Form$reset, 'created') : _Utils_Tuple2($author$project$Components$Charge$Form$newFormWithPatient, 'added');
						var chargeFormCmd = _v3.a;
						var toastVerb = _v3.b;
						return _Utils_Tuple2(
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormCmd),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$elm$core$String$concat(
										_List_fromArray(
											['Charge ', toastVerb, '!'])))
								]));
					} else {
						return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
					}
				}();
				var resetCmd = _v1.a;
				var toastMsgs = _v1.b;
				var _v4 = function () {
					var _v5 = chargeFormResult.ac5;
					if (_v5 === 1) {
						var createdChargeForm = $author$project$Components$Charge$Form$readOnly(
							$author$project$Components$Charge$Form$hide(chargeFormResult.y8));
						return _Utils_Tuple2(
							_Utils_ap(
								model.dA,
								_List_fromArray(
									[createdChargeForm])),
							A2($author$project$Pages$Charges$New$refreshInvoiceList, model.q2, maybeInvoice));
					} else {
						return _Utils_Tuple2(model.dA, model.q2);
					}
				}();
				var createdCharges = _v4.a;
				var invoices = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e: chargeFormResult.y8, dA: createdCharges, q2: invoices}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormResult.EC),
								resetCmd,
								invoiceRetrieveCmd
							])),
					_Utils_ap(chargeFormResult.as, toastMsgs));
			case 3:
				return _Utils_Tuple3(
					model,
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top),
					_List_Nil);
			case 4:
				var invoiceId = msg.a;
				var subMsg = msg.b;
				var _v8 = A2($author$project$Pages$Charges$New$findDropdownMenu, model.q2, invoiceId);
				if (!_v8.$) {
					var invoiceDropdownMenu = _v8.a;
					var _v9 = A2($author$project$Ui$NewDropdown$update, subMsg, invoiceDropdownMenu);
					var dropdownMenu = _v9.a;
					var cmd = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								q2: A3(
									$author$project$Pages$Charges$New$updateInvoice,
									invoiceId,
									$author$project$Pages$Charges$New$Dropdown(dropdownMenu),
									model.q2)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var index = msg.a;
				var _v10 = A2($elm_community$list_extra$List$Extra$getAt, index, model.dA);
				if (!_v10.$) {
					var createdCharge = _v10.a;
					var updatedCreatedCharge = $author$project$Components$Charge$Form$toggle(createdCharge);
					var createdCharges = A3(
						$elm_community$list_extra$List$Extra$setAt,
						index,
						updatedCreatedCharge,
						A2(
							$elm$core$List$map,
							function (createdCharge_) {
								return $author$project$Components$Charge$Form$hide(createdCharge_);
							},
							model.dA));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dA: createdCharges}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var invoiceId = msg.a;
				var afterIssueMsg = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							q2: A3(
								$author$project$Pages$Charges$New$updateInvoice,
								invoiceId,
								$author$project$Pages$Charges$New$SaveRequest($author$project$Api$Data$Loading),
								model.q2)
						}),
					A4(
						$author$project$Api$Provider$CustomerInvoice$issue,
						model.D5,
						invoiceId,
						_List_fromArray(
							[0]),
						A2(
							$author$project$Pages$Charges$New$GotCustomerInvoice,
							invoiceId,
							$elm$core$Maybe$Just(afterIssueMsg))),
					_List_Nil);
			case 7:
				var invoiceId = msg.a;
				var maybeAfterIssueMsg = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var invoice = response.a;
					var invoicesUpdated = A3(
						$author$project$Pages$Charges$New$updateInvoice,
						invoiceId,
						$author$project$Pages$Charges$New$SaveRequest(response),
						A3(
							$author$project$Pages$Charges$New$updateInvoice,
							invoiceId,
							$author$project$Pages$Charges$New$Status(
								$author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice)),
							model.q2));
					var cmd = function () {
						var _v12 = _Utils_Tuple2(
							maybeAfterIssueMsg,
							A2($author$project$Pages$Charges$New$findInvoice, invoicesUpdated, invoiceId));
						if ((!_v12.a.$) && (!_v12.b.$)) {
							var afterIssueMsg = _v12.a.a;
							var invoice_ = _v12.b.a;
							return A2($author$project$Pages$Charges$New$triggerAfterIssueAction, afterIssueMsg, invoice_);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{q2: invoicesUpdated}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								q2: A3(
									$author$project$Pages$Charges$New$updateInvoice,
									invoiceId,
									$author$project$Pages$Charges$New$SaveRequest(response),
									model.q2)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var invoice = msg.a;
				var external = msg.b;
				return $author$project$Pages$Charges$New$isDraft(invoice) ? _Utils_Tuple3(
					model,
					A2(
						$elm$core$Task$perform,
						function (_v13) {
							var paymentMsgType = external ? 1 : 0;
							return A2($author$project$Pages$Charges$New$Issue, invoice.adR, paymentMsgType);
						},
						$elm$time$Time$now),
					_List_Nil) : A4($author$project$Pages$Charges$New$showPaymentModal, model, invoice, external, invoice.adR);
			case 9:
				var subMsg = msg.a;
				var _v14 = model.lC;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var createPaymentModal = _v15.a;
					var invoiceId = _v15.b;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.D5, subMsg, createPaymentModal);
					var _v16 = function () {
						var _v17 = createPaymentModalResult.ac5;
						switch (_v17) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(createPaymentModalResult.y8, invoiceId)),
									model.q2,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A3(
										$author$project$Pages$Charges$New$updateInvoice,
										invoiceId,
										$author$project$Pages$Charges$New$SaveRequest($author$project$Api$Data$Loading),
										model.q2),
									A2($author$project$Pages$Charges$New$retrieveInvoice, model.D5, invoiceId));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.q2, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v16.a;
					var invoices = _v16.b;
					var cmd = _v16.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lC: createPaymentModal_, q2: invoices}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CreatePaymentModalMsg, createPaymentModalResult.EC),
									cmd
								])),
						createPaymentModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var patientId = msg.a;
				var invoice = msg.b;
				var cmd = $author$project$Pages$Charges$New$isDraft(invoice) ? A2(
					$elm$core$Task$perform,
					function (_v18) {
						return A2($author$project$Pages$Charges$New$Issue, invoice.adR, 2);
					},
					$elm$time$Time$now) : A3(
					$author$project$Api$Provider$Patient$retrieve,
					model.D5,
					patientId,
					$author$project$Pages$Charges$New$GotPatient(invoice.adR));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 12:
				var invoiceId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var patient = response.a;
					var _v20 = A6(
						$author$project$Components$CustomerEmailModal$open,
						model.D5,
						model.ZD,
						0,
						invoiceId,
						$author$project$Components$CustomerEmailModal$PatientOne(patient),
						model.lH);
					var customerEmailModal = _v20.a;
					var customerEmailModalCmd = _v20.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lH: customerEmailModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CustomerEmailModalMsg, customerEmailModalCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var subMsg = msg.a;
				var _v21 = A3($author$project$Components$CustomerEmailModal$update, model.D5, subMsg, model.lH);
				var customerEmailModal = _v21.a;
				var subCmd = _v21.b;
				var subOutMsg = _v21.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lH: customerEmailModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CustomerEmailModalMsg, subCmd),
					subOutMsg);
			case 13:
				var invoice = msg.a;
				var _v22 = $author$project$Pages$Charges$New$isDraft(invoice) ? _Utils_Tuple2(
					model.gA,
					A2(
						$elm$core$Task$perform,
						function (_v23) {
							return A2($author$project$Pages$Charges$New$Issue, invoice.adR, 3);
						},
						$elm$time$Time$now)) : A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Pages$Charges$New$SchedulePaymentModalMsg),
					A2($author$project$Components$CustomerSchedulePaymentModal$open, invoice.adR, model.Cd.cO));
				var schedulePaymentModal = _v22.a;
				var schedulePaymentModalCmd = _v22.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gA: schedulePaymentModal}),
					schedulePaymentModalCmd,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var schedulePaymentResult = A3($author$project$Components$CustomerSchedulePaymentModal$update, model.D5, subMsg, model.gA);
				var invoices = function () {
					var _v24 = schedulePaymentResult.ac5;
					if (!_v24.$) {
						return model.q2;
					} else {
						var invoiceId = _v24.a;
						var invoice = _v24.b;
						return A3(
							$author$project$Pages$Charges$New$updateInvoice,
							invoiceId,
							$author$project$Pages$Charges$New$SaveRequest(invoice),
							model.q2);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{q2: invoices, gA: schedulePaymentResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$SchedulePaymentModalMsg, schedulePaymentResult.EC),
					schedulePaymentResult.as);
		}
	});
var $author$project$Components$CustomerEmailModal$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerEmailModal$Email = $elm$core$Basics$identity;
var $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CustomerEmailModal$PatientFormFieldUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CustomerEmailModal$Subject = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerEmailModal$UpdatePatientEmail = {$: 5};
var $author$project$Ui$Form$Inline = {$: 4};
var $author$project$Ui$Form$inline = $author$project$Ui$Form$Inline;
var $author$project$Api$Provider$Reports$Patient$oneName = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$CustomerEmailModal$recipientName = function (recipient) {
	switch (recipient.$) {
		case 0:
			var patient = recipient.a;
			return $author$project$Api$Provider$Reports$Patient$oneName(patient);
		case 1:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$One$name(patient);
		default:
			var patient = recipient.a;
			return $author$project$Api$Provider$Patient$Shared$name(patient);
	}
};
var $author$project$Components$CustomerEmailModal$viewPreview = F4(
	function (recipient, email, subject, body) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('email-preview')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'To ' + $author$project$Components$CustomerEmailModal$recipientName(recipient))
									])),
								$elm$html$Html$text('<' + (email + '>')),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Subject')
									])),
								subject,
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								body
							]))
					]))
			]);
	});
var $author$project$Components$CustomerEmailModal$viewModalBody = function (model) {
	switch (model.$) {
		case 0:
			return _List_Nil;
		case 1:
			var shared = model.a;
			var patientForm = model.b;
			var _v1 = $author$project$Utils$Form$fields(patientForm);
			var email = _v1.Oo;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Please add an email address for '),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$CustomerEmailModal$recipientName(shared.Bm))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('email-preview')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$inline,
											$author$project$Ui$Form$noValidate(true),
											$author$project$Ui$Form$autocomplete(false)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													'To ' + $author$project$Components$CustomerEmailModal$recipientName(shared.Bm))
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('< '),
													A2(
													$author$project$Ui$Form$Group$view,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$view(
															_List_fromArray(
																[
																	$author$project$Ui$Form$Input$placeholder('somebody@example.com'),
																	$author$project$Ui$Form$Input$value(email),
																	$author$project$Ui$Form$Input$onInput(
																	A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$PatientFormFieldUpdated, $elm$core$Basics$identity)),
																	$author$project$Ui$Form$Input$invalid(
																	A2($author$project$Utils$Form$hasValidationErrors, 0, patientForm))
																]))
														])),
													$elm$html$Html$text(' > '),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Save custom email'},
													_List_fromArray(
														[
															$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$UpdatePatientEmail)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Save')
														]))
												]))
										]))
								]))
						]))
				]);
		case 2:
			var shared = model.a;
			var email = model.b;
			return A4(
				$author$project$Components$CustomerEmailModal$viewPreview,
				shared.Bm,
				email,
				$author$project$Ui$Spinner$view(_List_Nil),
				$author$project$Ui$Spinner$view(_List_Nil));
		case 3:
			var shared = model.a;
			var email = model.b;
			var preview = model.c;
			var delivery = model.d;
			return _Utils_ap(
				A4(
					$author$project$Components$CustomerEmailModal$viewPreview,
					shared.Bm,
					email,
					A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subject')
								]),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Notification$One$subjectHtml(preview))))),
					A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$elm$html$Html$div,
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$class('body'),
								$author$project$Api$Phi$displayAttr),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$Notification$One$bodyHtml(preview)))))),
				_List_fromArray(
					[
						function () {
						if (delivery.$ === 2) {
							var error = delivery.a;
							return A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Error sending email')
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(
										$author$project$Api$Data$errorToString(error))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]));
		default:
			var shared = model.a;
			var email = model.b;
			var notificationForm = model.c;
			var _v3 = $author$project$Utils$Form$fields(notificationForm);
			var subject = _v3.Hp;
			var body = _v3.e5;
			return A4(
				$author$project$Components$CustomerEmailModal$viewPreview,
				shared.Bm,
				email,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', subject)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated, $author$project$Components$CustomerEmailModal$Subject)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, notificationForm)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, notificationForm))
								]))
						])),
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$rows(15),
											$author$project$Ui$Form$Textarea$value(
											A2($elm$core$Maybe$withDefault, '', body)),
											$author$project$Ui$Form$Textarea$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated, $author$project$Components$CustomerEmailModal$Body)),
											$author$project$Ui$Form$Textarea$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, notificationForm)),
											$author$project$Ui$Form$Textarea$errors(
											A2($author$project$Utils$Form$validationErrors, 1, notificationForm))
										]))
								]))
						])));
	}
};
var $author$project$Components$CustomerEmailModal$Edit = {$: 3};
var $author$project$Components$CustomerEmailModal$Preview = {$: 2};
var $author$project$Components$CustomerEmailModal$Send = {$: 4};
var $author$project$Components$CustomerEmailModal$viewCancelButton = A3(
	$author$project$Ui$Button$view,
	{abp: 'Cancel and close modal'},
	_List_fromArray(
		[
			$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Close)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Cancel')
		]));
var $author$project$Components$CustomerEmailModal$viewModalFooter = function (model) {
	return $elm$core$List$singleton(
		A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$gap2]),
			function () {
				switch (model.$) {
					case 0:
						return _List_Nil;
					case 1:
						return _List_fromArray(
							[$author$project$Components$CustomerEmailModal$viewCancelButton]);
					case 2:
						return _List_fromArray(
							[$author$project$Components$CustomerEmailModal$viewCancelButton]);
					case 3:
						var delivery = model.d;
						var deliveryLoading = function () {
							if (delivery.$ === 1) {
								return true;
							} else {
								return false;
							}
						}();
						return _List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Customize email'},
								_List_fromArray(
									[
										$author$project$Ui$Button$pull(0),
										$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Customize Email')
									])),
								$author$project$Components$CustomerEmailModal$viewCancelButton,
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Send email'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Send),
										$author$project$Ui$Button$loading(deliveryLoading)
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 11),
										$elm$html$Html$text('Send Email')
									]))
							]);
					default:
						var preview = model.d;
						var loading = function () {
							if (preview.$ === 1) {
								return true;
							} else {
								return false;
							}
						}();
						return _List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Preview email'},
								_List_fromArray(
									[
										$author$project$Ui$Button$pull(0),
										$author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Preview),
										$author$project$Ui$Button$loading(loading)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Preview Email')
									])),
								$author$project$Components$CustomerEmailModal$viewCancelButton
							]);
				}
			}()));
};
var $author$project$Components$CustomerEmailModal$viewModal = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CustomerEmailModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Send via Email')
					])),
				$author$project$Ui$Modal$body(
				$author$project$Components$CustomerEmailModal$viewModalBody(model)),
				$author$project$Ui$Modal$footer(
				$author$project$Components$CustomerEmailModal$viewModalFooter(model))
			]));
};
var $author$project$Components$CustomerEmailModal$modal = function (model) {
	if (!model.$) {
		return $author$project$Utils$Html$empty;
	} else {
		return $author$project$Components$CustomerEmailModal$viewModal(model);
	}
};
var $author$project$Components$CustomerSchedulePaymentModal$Schedule = {$: 1};
var $author$project$Components$CustomerSchedulePaymentModal$viewDate = F2(
	function (fields, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(6),
					$author$project$Ui$Form$Group$label('On Date')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(fields.qd),
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields.MO),
								$author$project$Components$DateInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Components$DateInput$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]),
						fields.qd))
				]));
	});
var $author$project$Components$CustomerSchedulePaymentModal$viewModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$CustomerSchedulePaymentModal$CloseModal,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Schedule Payment')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[$author$project$Ui$Form$horizontal]),
						_List_fromArray(
							[
								A2($author$project$Components$CustomerSchedulePaymentModal$viewDate, fields, model.PB)
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$CustomerSchedulePaymentModal$CloseModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Schedule payment'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.so, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$CustomerSchedulePaymentModal$Schedule)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Schedule Payment')
							]))
					]))
			]));
};
var $author$project$Components$CustomerSchedulePaymentModal$view = function (model) {
	if (model.$ === 1) {
		var model_ = model.a;
		return $author$project$Components$CustomerSchedulePaymentModal$viewModal(model_);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Charges$New$Save = {$: 0};
var $author$project$Components$Charge$Form$formReady = function (_v0) {
	var model = _v0;
	var _v1 = model.A8;
	switch (_v1.$) {
		case 0:
			return !model.rS;
		case 3:
			return true;
		default:
			return false;
	}
};
var $author$project$Ui$Element$Background = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Element$Primary50 = 0;
var $author$project$Ui$Element$bgPrimary50 = $author$project$Ui$Element$Background(0);
var $author$project$Api$Provider$Charge$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Components$Charge$Form$RoutingFields$PatientInvoiceSelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$SponsorInvoiceSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$Accessible$Grid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Accessible$labelSpanSm = A2($elm$core$Basics$composeR, $author$project$Ui$FlexGrid$spanSm, $author$project$Ui$Form$Accessible$Grid);
var $author$project$Api$Provider$CustomerInvoice$All$date = function (_v0) {
	var record = _v0;
	return record.MO;
};
var $author$project$Api$Provider$CustomerInvoice$All$humanStatus = function (_v0) {
	var record = _v0;
	return record.QE;
};
var $author$project$Components$Charge$Form$RoutingFields$invoiceLabel = F3(
	function (status, number, date) {
		return $elm_community$string_extra$String$Extra$humanize(status) + (' Invoice #' + ($elm$core$String$fromInt(number) + (' - Date ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date))));
	});
var $author$project$Api$Provider$CustomerInvoice$All$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Components$Charge$Form$RoutingFields$patientInvoiceSelectItems = F2(
	function (currentDate, dataCustomerInvoices) {
		if (dataCustomerInvoices.$ === 3) {
			var customerInvoices = dataCustomerInvoices.a;
			var newInvoice = A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just('new'),
				'Create a new draft invoice');
			var lastInvoice = $elm$core$List$head(
				$elm$core$List$reverse(customerInvoices));
			var lastInvoiceDate = function () {
				if (!lastInvoice.$) {
					var lastInvoice_ = lastInvoice.a;
					return $author$project$Api$Provider$CustomerInvoice$All$date(lastInvoice_);
				} else {
					return currentDate;
				}
			}();
			var label = function (invoice) {
				return A3(
					$author$project$Components$Charge$Form$RoutingFields$invoiceLabel,
					$author$project$Api$Provider$CustomerInvoice$All$humanStatus(invoice),
					$author$project$Api$Provider$CustomerInvoice$All$invoiceNumber(invoice),
					$author$project$Api$Provider$CustomerInvoice$All$date(invoice));
			};
			return (A3($justinmimbs$date$Date$diff, 3, lastInvoiceDate, currentDate) > 30) ? _List_fromArray(
				[newInvoice]) : _Utils_ap(
				A2(
					$elm$core$List$map,
					function (invoice) {
						return A3(
							$author$project$Ui$Form$Select$option,
							_List_Nil,
							$elm$core$Maybe$Just(
								$author$project$Api$Provider$CustomerInvoice$All$id(invoice)),
							label(invoice));
					},
					customerInvoices),
				_List_fromArray(
					[newInvoice]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Ui$Form$Accessible$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Accessible$required = $author$project$Ui$Form$Accessible$Required;
var $author$project$Ui$Form$Accessible$Select = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ui$Form$Accessible$select = $author$project$Ui$Form$Accessible$Select;
var $author$project$Ui$Form$Accessible$AccessibleInput = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Ui$FlexGrid$extractSpanValue = function (option) {
	extractSpanValue:
	while (true) {
		_v0$2:
		while (true) {
			switch (option.$) {
				case 0:
					var screenSize = option.a;
					var spanValue = option.b;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(screenSize, spanValue));
				case 2:
					if (option.a.a) {
						var _v1 = option.a;
						var innerOption = _v1.b;
						var $temp$option = innerOption;
						option = $temp$option;
						continue extractSpanValue;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$ScreenSize$Xl = 4;
var $author$project$Ui$FlexGrid$spanXl = $author$project$Ui$FlexGrid$Span(4);
var $author$project$Ui$FlexGrid$complementSpan = function (labelOptions) {
	var spanValues = A2($elm$core$List$filterMap, $author$project$Ui$FlexGrid$extractSpanValue, labelOptions);
	var createComplementarySpan = function (_v1) {
		var screenSize = _v1.a;
		var spanValue = _v1.b;
		switch (screenSize) {
			case 0:
				return $author$project$Ui$FlexGrid$span(12 - spanValue);
			case 1:
				return $author$project$Ui$FlexGrid$spanSm(12 - spanValue);
			case 2:
				return $author$project$Ui$FlexGrid$spanMd(12 - spanValue);
			case 3:
				return $author$project$Ui$FlexGrid$spanLg(12 - spanValue);
			default:
				return $author$project$Ui$FlexGrid$spanXl(12 - spanValue);
		}
	};
	return A2($elm$core$List$map, createComplementarySpan, spanValues);
};
var $author$project$Ui$Form$Accessible$defaultLabelOptions = {a5: _List_Nil, agk: false};
var $author$project$Ui$Form$Accessible$labelOptionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (opt, rec) {
				if (!opt.$) {
					var gridOption = opt.a;
					return _Utils_update(
						rec,
						{
							a5: A2($elm$core$List$cons, gridOption, rec.a5)
						});
				} else {
					var bool = opt.a;
					return _Utils_update(
						rec,
						{agk: bool});
				}
			}),
		$author$project$Ui$Form$Accessible$defaultLabelOptions,
		options);
};
var $author$project$Ui$Form$Accessible$defaultInputOptions = {fE: _List_Nil, a5: _List_Nil};
var $author$project$Ui$Form$Accessible$inputOptionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (opt, rec) {
				if (!opt.$) {
					var gridOption = opt.a;
					return _Utils_update(
						rec,
						{
							a5: A2($elm$core$List$cons, gridOption, rec.a5)
						});
				} else {
					var errors_ = opt.a;
					return _Utils_update(
						rec,
						{fE: errors_});
				}
			}),
		$author$project$Ui$Form$Accessible$defaultInputOptions,
		options);
};
var $author$project$Components$DateInput$HideErrors = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$DateInput$hideErrors = $author$project$Components$DateInput$HideErrors;
var $author$project$Ui$Form$CurrencyInput$HideErrors = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$CurrencyInput$hideErrors = $author$project$Ui$Form$CurrencyInput$HideErrors;
var $author$project$Ui$Form$Select$HideErrors = function (a) {
	return {$: 9, a: a};
};
var $author$project$Ui$Form$Select$hideErrors = $author$project$Ui$Form$Select$HideErrors;
var $author$project$Ui$Form$Textarea$HideErrors = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Form$Textarea$hideErrors = $author$project$Ui$Form$Textarea$HideErrors;
var $author$project$Components$ResourceFilter$AriaLabel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$ResourceFilter$ariaLabel = $author$project$Components$ResourceFilter$AriaLabel;
var $author$project$Ui$Form$Accessible$resourceFilterOptions = F2(
	function (label_, errors_) {
		return _List_fromArray(
			[
				$author$project$Components$ResourceFilter$errors(errors_),
				$author$project$Components$ResourceFilter$invalid(
				!$elm$core$List$isEmpty(errors_)),
				$author$project$Components$ResourceFilter$ariaLabel(label_)
			]);
	});
var $author$project$Components$ResourceFilter$ChargeItem$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$ResourceFilter$CreditCategory$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$CreditCategory$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$ResourceFilter$Patient$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Ui$Form$Accessible$viewInput = function (accessibleInput) {
	if (accessibleInput.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var labelText = accessibleInput.a;
		var inputOptions = accessibleInput.b;
		var input_ = accessibleInput.c;
		var optionsRecord = $author$project$Ui$Form$Accessible$inputOptionsToRecord(inputOptions);
		return A2(
			$elm$html$Html$label,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sr-only')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(labelText)
						])),
					function () {
					switch (input_.$) {
						case 0:
							var options = input_.a;
							return $author$project$Ui$Form$Input$view(
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Input$errors(optionsRecord.fE),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Input$invalid(
											!$elm$core$List$isEmpty(optionsRecord.fE)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Input$hideErrors(true),
											options))));
						case 1:
							var options = input_.a;
							return $author$project$Ui$Form$Textarea$view(
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Textarea$errors(optionsRecord.fE),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Textarea$invalid(
											!$elm$core$List$isEmpty(optionsRecord.fE)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Textarea$hideErrors(true),
											options))));
						case 2:
							var options = input_.a;
							return $author$project$Ui$Form$CurrencyInput$view(
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$CurrencyInput$errors(optionsRecord.fE),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$CurrencyInput$invalid(
											!$elm$core$List$isEmpty(optionsRecord.fE)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$CurrencyInput$hideErrors(true),
											options))));
						case 4:
							var options = input_.a;
							var items = input_.b;
							return A2(
								$author$project$Ui$Form$Select$view,
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Form$Select$errors(optionsRecord.fE),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Form$Select$invalid(
											!$elm$core$List$isEmpty(optionsRecord.fE)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Form$Select$hideErrors(true),
											options))),
								items);
						case 5:
							var options = input_.a;
							var trigger = input_.b;
							var items = input_.c;
							var model = input_.d;
							return A4(
								$author$project$Ui$NewDropdown$viewSelect,
								A2(
									$elm$core$List$cons,
									$author$project$Ui$NewDropdown$errors(optionsRecord.fE),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$NewDropdown$invalid(
											!$elm$core$List$isEmpty(optionsRecord.fE)),
										options)),
								trigger,
								items,
								model);
						case 6:
							var options = input_.a;
							var content = input_.b;
							return A2($author$project$Ui$Form$Checkbox$view, options, content);
						case 7:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$Patient$viewNew,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fE),
										options),
									model));
						case 8:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$ChargeItem$viewNew,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fE),
										options),
									model));
						case 9:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$Category$viewNew,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fE),
										options),
									model));
						case 10:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$Practitioner$viewNew,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fE),
										options),
									model));
						case 12:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$CreditCategory$viewNew,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fE),
										options),
									model));
						case 11:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$ResourceFilter$Location$viewNew,
									_Utils_ap(
										A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fE),
										options),
									model));
						case 3:
							var mapper = input_.a;
							var options = input_.b;
							var model = input_.c;
							return A2(
								$elm$html$Html$map,
								mapper,
								A2(
									$author$project$Components$DateInput$view,
									A2(
										$elm$core$List$cons,
										$author$project$Components$DateInput$errors(optionsRecord.fE),
										A2(
											$elm$core$List$cons,
											$author$project$Components$DateInput$invalid(
												!$elm$core$List$isEmpty(optionsRecord.fE)),
											A2(
												$elm$core$List$cons,
												$author$project$Components$DateInput$hideErrors(true),
												options))),
									model));
						default:
							var content = input_.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('new-form-group__static')
									]),
								content);
					}
				}(),
					function () {
					var _v2 = optionsRecord.fE;
					if (!_v2.b) {
						return $elm$html$Html$text('');
					} else {
						var errors_ = _v2;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (err) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'role', 'alert'),
												$elm$html$Html$Attributes$class('text-danger')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(err)
											]));
								},
								errors_));
					}
				}()
				]));
	}
};
var $author$project$Ui$Form$Accessible$viewGroupInput = function (accessibleInput) {
	if (accessibleInput.$ === 1) {
		return $author$project$Ui$FlexGrid$none;
	} else {
		var inputOptions = accessibleInput.b;
		var record = $author$project$Ui$Form$Accessible$inputOptionsToRecord(inputOptions);
		return A2(
			$author$project$Ui$FlexGrid$column,
			record.a5,
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$viewInput(accessibleInput)
				]));
	}
};
var $author$project$Ui$Form$Accessible$single = F4(
	function (legend, options, inputOptions, input_) {
		var optionsRecord = $author$project$Ui$Form$Accessible$labelOptionsToRecord(options);
		var complementarySpans = $author$project$Ui$FlexGrid$complementSpan(optionsRecord.a5);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-form-group')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							optionsRecord.a5,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-form-group__label'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('new-form-group__label--required', optionsRecord.agk)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(legend)
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							complementarySpans,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-form-group__content')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$Accessible$viewGroupInput(
													A3($author$project$Ui$Form$Accessible$AccessibleInput, legend, inputOptions, input_))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Api$Provider$Invoice$All$humanStatus = function (_v0) {
	var record = _v0.b;
	return record.QE;
};
var $author$project$Api$Provider$Invoice$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$id(min);
};
var $author$project$Api$Provider$Invoice$All$invoiceDate = function (_v0) {
	var record = _v0.b;
	return record.Rn;
};
var $author$project$Api$Provider$Invoice$All$invoiceNumber = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
};
var $author$project$Components$Charge$Form$RoutingFields$sponsorInvoiceSelectItems = function (dataInvoices) {
	if (dataInvoices.$ === 3) {
		var invoices = dataInvoices.a;
		var newInvoice = A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just('new'),
			'Create a new draft invoice');
		var label = function (invoice) {
			return A3(
				$author$project$Components$Charge$Form$RoutingFields$invoiceLabel,
				$author$project$Api$Invoice$Status$toString(
					$author$project$Api$Provider$Invoice$All$humanStatus(invoice)),
				$author$project$Api$Provider$Invoice$All$invoiceNumber(invoice),
				$author$project$Api$Provider$Invoice$All$invoiceDate(invoice));
		};
		var baseItems = A2(
			$elm$core$List$map,
			function (invoice) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Invoice$All$id(invoice)),
					label(invoice));
			},
			invoices);
		return _Utils_ap(
			baseItems,
			_List_fromArray(
				[newInvoice]));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Charge$Form$RoutingFields$viewInvoice = F2(
	function (model, readOnly) {
		var _v0 = _Utils_Tuple2(model.adm.VW, model.cO);
		_v0$2:
		while (true) {
			if (!_v0.a) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var currentDate = _v0.b.a;
					return A4(
						$author$project$Ui$Form$Accessible$single,
						'Invoice',
						_List_fromArray(
							[
								$author$project$Ui$Form$Accessible$labelSpanSm(4),
								$author$project$Ui$Form$Accessible$required(true)
							]),
						_List_Nil,
						A2(
							$author$project$Ui$Form$Accessible$select,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(model.adm.aea),
									$author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$PatientInvoiceSelected),
									$author$project$Ui$Form$Select$disabled(
									readOnly || _Utils_eq(model.cP, $author$project$Api$Data$Loading))
								]),
							A2($author$project$Components$Charge$Form$RoutingFields$patientInvoiceSelectItems, currentDate, model.cP)));
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					return A4(
						$author$project$Ui$Form$Accessible$single,
						'Invoice',
						_List_fromArray(
							[
								$author$project$Ui$Form$Accessible$labelSpanSm(4),
								$author$project$Ui$Form$Accessible$required(true)
							]),
						_List_Nil,
						A2(
							$author$project$Ui$Form$Accessible$select,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(model.adm.aea),
									$author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$SponsorInvoiceSelected),
									$author$project$Ui$Form$Select$disabled(
									readOnly || (_Utils_eq(model.gQ, $author$project$Api$Data$Loading) || _Utils_eq(model.jD, $author$project$Api$Data$Loading)))
								]),
							$author$project$Components$Charge$Form$RoutingFields$sponsorInvoiceSelectItems(model.gQ)));
				} else {
					break _v0$2;
				}
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$Charge$Form$RoutingFields$SponsorPayerSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Accessible$group = F3(
	function (legend, options, inputs) {
		var optionsRecord = $author$project$Ui$Form$Accessible$labelOptionsToRecord(options);
		var complementarySpans = $author$project$Ui$FlexGrid$complementSpan(optionsRecord.a5);
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('new-form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('new-form-group__legend')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(legend)
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							optionsRecord.a5,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-form-group__label'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('new-form-group__label--required', optionsRecord.agk)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(legend)
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							complementarySpans,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-form-group__content')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											A2($elm$core$List$map, $author$project$Ui$Form$Accessible$viewGroupInput, inputs))
										]))
								]))
						]))
				]));
	});
var $author$project$Ui$Form$Accessible$input = F3(
	function (labelText, options, input_) {
		return A3($author$project$Ui$Form$Accessible$AccessibleInput, labelText, options, input_);
	});
var $author$project$Ui$Form$Accessible$InputGrid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Accessible$inputSpanLg = A2($elm$core$Basics$composeR, $author$project$Ui$FlexGrid$spanLg, $author$project$Ui$Form$Accessible$InputGrid);
var $author$project$Ui$Form$Accessible$inputSpanMd = A2($elm$core$Basics$composeR, $author$project$Ui$FlexGrid$spanMd, $author$project$Ui$Form$Accessible$InputGrid);
var $author$project$Ui$Form$Accessible$inputSpanSm = A2($elm$core$Basics$composeR, $author$project$Ui$FlexGrid$spanSm, $author$project$Ui$Form$Accessible$InputGrid);
var $author$project$Ui$Form$Accessible$None = {$: 1};
var $author$project$Ui$Form$Accessible$none = $author$project$Ui$Form$Accessible$None;
var $author$project$Ui$Form$Accessible$PatientFilter = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$patientFilter = $author$project$Ui$Form$Accessible$PatientFilter;
var $author$project$Api$Provider$CompanyAccount$ForPatient$company = function (_v0) {
	var record = _v0.b;
	return record.ab9;
};
var $author$project$Api$Provider$Patient$One$companyAccounts = function (_v0) {
	var record = _v0.b;
	return record.Lt;
};
var $author$project$Components$Charge$Form$RoutingFields$sponsorPayerSelectItems = function (patientData) {
	if (patientData.$ === 3) {
		var patient = patientData.a;
		var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(patient);
		var companies = A2($elm$core$List$map, $author$project$Api$Provider$CompanyAccount$ForPatient$company, accounts);
		return A2(
			$elm$core$List$map,
			function (company) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Company$Min$id(company)),
					$author$project$Api$Provider$Company$Min$name(company));
			},
			companies);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Form$Accessible$Static = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Form$Accessible$static = function (content) {
	return $author$project$Ui$Form$Accessible$Static(content);
};
var $author$project$Components$Charge$Form$RoutingFields$PayerSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Charge$Form$RoutingFields$buttonStyle = F2(
	function (payer, selectedPayerType) {
		return _Utils_eq(payer, selectedPayerType) ? 1 : 0;
	});
var $author$project$Components$Charge$Form$RoutingFields$viewPayerButton = F3(
	function (payerType, selectedPayerType, disabled) {
		return A3(
			$author$project$Ui$Button$view,
			{
				abp: 'Select ' + $author$project$Api$Charge$PayerType$toString(payerType)
			},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(selectedPayerType, payerType)),
					$author$project$Ui$Button$styled(
					A2($author$project$Components$Charge$Form$RoutingFields$buttonStyle, payerType, selectedPayerType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Charge$Form$RoutingFields$PayerSelected(payerType)),
					$author$project$Ui$Button$disabled(disabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Charge$PayerType$toString(payerType))
				]));
	});
var $author$project$Components$Charge$Form$RoutingFields$viewPayer = F4(
	function (model, readOnly, preview, patient) {
		var warningContent = model.AI ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$Ui$Form$Accessible$none,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$singleton,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Ui$Form$Accessible$static,
						A2(
							$author$project$Ui$Form$Accessible$input,
							'',
							_List_fromArray(
								[
									$author$project$Ui$Form$Accessible$inputSpanSm(12)
								])))),
				A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, model.adm.VW, preview))) : $author$project$Ui$Form$Accessible$none;
		var sponsorDisabled = _Utils_eq(
			$author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany(patient),
			$elm$core$Maybe$Nothing);
		var payerFilterInput = function () {
			var _v0 = model.adm.VW;
			if (!_v0) {
				return A3(
					$author$project$Ui$Form$Accessible$patientFilter,
					$author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$disabled(readOnly)
						]),
					model.eg);
			} else {
				return A2(
					$author$project$Ui$Form$Accessible$select,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(model.adm.afG),
							$author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$SponsorPayerSelected),
							$author$project$Ui$Form$Select$disabled(
							$author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview) || _Utils_eq(model.VM, $author$project$Api$Data$Loading))
						]),
					$author$project$Components$Charge$Form$RoutingFields$sponsorPayerSelectItems(model.VM));
			}
		}();
		var buttonsDisabled = _Utils_eq(model.jD, $author$project$Api$Data$Loading) || readOnly;
		var payerButtonsContent = _List_fromArray(
			[
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 0, model.adm.VW, buttonsDisabled),
						sponsorDisabled ? A3(
						$author$project$Ui$Tooltip$view,
						_List_Nil,
						'The selected patient does not have any sponsors available.',
						_List_fromArray(
							[
								A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 1, model.adm.VW, true)
							])) : A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 1, model.adm.VW, buttonsDisabled)
					]))
			]);
		return A3(
			$author$project$Ui$Form$Accessible$group,
			'Payer',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					warningContent,
					A3(
					$author$project$Ui$Form$Accessible$input,
					'Type',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpanMd(4),
							$author$project$Ui$Form$Accessible$inputSpanLg(3)
						]),
					$author$project$Ui$Form$Accessible$static(payerButtonsContent)),
					A3(
					$author$project$Ui$Form$Accessible$input,
					'Selection',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpanMd(8),
							$author$project$Ui$Form$Accessible$inputSpanLg(9)
						]),
					payerFilterInput)
				]));
	});
var $author$project$Components$Charge$Form$RoutingFields$view = F2(
	function (model, readOnly) {
		var _v0 = _Utils_Tuple2(model.afU, model.VM);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var preview = _v1.a;
			var _v2 = _v0.b;
			var patient = _v2.a;
			return _List_fromArray(
				[
					A4($author$project$Components$Charge$Form$RoutingFields$viewPayer, model, readOnly, preview, patient),
					A2($author$project$Components$Charge$Form$RoutingFields$viewInvoice, model, readOnly)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Charge$Form$ToggleAdditionalDetails = {$: 16};
var $author$project$Components$Charge$Form$viewAdditionalDetails = function (showAdditionalDetails) {
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$inputSpanSm(6)
			]),
		$author$project$Ui$Form$Accessible$static(
			_List_fromArray(
				[
					function () {
					var label = showAdditionalDetails ? 'Hide additional charge details ' : 'See additional charge details ';
					return A3(
						$author$project$Ui$Button$view,
						{abp: label},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick($author$project$Components$Charge$Form$ToggleAdditionalDetails)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label),
								A2($author$project$Ui$Icon$view, _List_Nil, 27)
							]));
				}()
				])));
};
var $author$project$Ui$Form$Accessible$CategoryFilter = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$categoryFilter = $author$project$Ui$Form$Accessible$CategoryFilter;
var $author$project$Components$Charge$Form$viewCategory = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var categoryResourceFilter = _v0.cJ;
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'Category',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_Nil,
		A3(
			$author$project$Ui$Form$Accessible$categoryFilter,
			$author$project$Components$Charge$Form$CategoryResourceFilterMsg,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(0)
				]),
			categoryResourceFilter));
};
var $author$project$Ui$Form$Accessible$ChargeItemFilter = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$chargeItemFilter = $author$project$Ui$Form$Accessible$ChargeItemFilter;
var $author$project$Ui$Form$Accessible$Errors = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Accessible$errors = $author$project$Ui$Form$Accessible$Errors;
var $author$project$Components$Charge$Form$viewChargeItemInput = F3(
	function (chargeItemResourceFilter, readOnly_, form) {
		return A4(
			$author$project$Ui$Form$Accessible$single,
			'Charge Item',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$errors(
					A2($author$project$Utils$Form$validationErrors, 1, form))
				]),
			A3(
				$author$project$Ui$Form$Accessible$chargeItemFilter,
				$author$project$Components$Charge$Form$ChargeItemResourceFilterMsg,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$disabled(readOnly_)
					]),
				chargeItemResourceFilter));
	});
var $author$project$Components$Charge$Form$Description = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Charge$Form$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Textarea$Test = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Form$Textarea$test = function (dataTest) {
	return $author$project$Ui$Form$Textarea$Test(dataTest);
};
var $author$project$Ui$Form$Accessible$Textarea = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Form$Accessible$textarea = $author$project$Ui$Form$Accessible$Textarea;
var $author$project$Components$Charge$Form$viewDescription = function (fields) {
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'Description',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_Nil,
		$author$project$Ui$Form$Accessible$textarea(
			_List_fromArray(
				[
					$author$project$Ui$Form$Textarea$value(fields.Nx),
					$author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
					$author$project$Ui$Form$Textarea$onInput(
					A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$Description)),
					$author$project$Ui$Form$Textarea$test('charge-description')
				])));
};
var $author$project$Ui$Form$Accessible$LocationFilter = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$locationFilter = $author$project$Ui$Form$Accessible$LocationFilter;
var $author$project$Components$Charge$Form$viewLocation = function (locationResourceFilter) {
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'Location',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_Nil,
		A3(
			$author$project$Ui$Form$Accessible$locationFilter,
			$author$project$Components$Charge$Form$LocationResourceFilterMsg,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(0)
				]),
			locationResourceFilter));
};
var $author$project$Components$Charge$Form$viewPatientInput = F3(
	function (patientResourceFilter, readOnly_, form) {
		return A4(
			$author$project$Ui$Form$Accessible$single,
			'Patient',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$errors(
					A2($author$project$Utils$Form$validationErrors, 0, form))
				]),
			A3(
				$author$project$Ui$Form$Accessible$patientFilter,
				$author$project$Components$Charge$Form$PatientResourceFilterMsg,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$disabled(readOnly_)
					]),
				patientResourceFilter));
	});
var $author$project$Components$Charge$Form$DiscountOverridden = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$Accessible$CurrencyInput = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Accessible$currencyInput = $author$project$Ui$Form$Accessible$CurrencyInput;
var $author$project$Api$Provider$Charge$Meta$priceInCentsEditable = function (_v0) {
	var meta = _v0;
	return meta.Ba.Oa;
};
var $author$project$Ui$Form$CurrencyInput$Test = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$CurrencyInput$test = function (dataTest) {
	return $author$project$Ui$Form$CurrencyInput$Test(dataTest);
};
var $author$project$Components$Charge$Form$viewPriceInput = F6(
	function (fields, readyOnly, form, meta, preview, isTimeBased) {
		var hasDiscount = function () {
			var _v1 = $author$project$Api$Data$toMaybe(preview);
			if (!_v1.$) {
				var preview_ = _v1.a;
				return !(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview_));
			} else {
				return false;
			}
		}();
		var discountNotRemoved = (!fields.NJ) && hasDiscount;
		var staticContent = (discountNotRemoved && (!readyOnly)) ? A3(
			$author$project$Ui$Form$Accessible$input,
			'',
			_List_Nil,
			$author$project$Ui$Form$Accessible$static(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Remove membership rule'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Components$Charge$Form$FormUpdated(
									$author$project$Components$Charge$Form$DiscountOverridden(true)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Remove membership rule')
							]))
					]))) : $author$project$Ui$Form$Accessible$none;
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			A2(
				$elm$core$Maybe$withDefault,
				true,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.aef;
						}),
					fields.lp)),
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
		var currencyOptions = A2(
			$elm$core$List$cons,
			$author$project$Ui$Form$CurrencyInput$value(fields.Ba),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$CurrencyInput$disabled(hasDiscount || (readyOnly || (!canEdit))),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$CurrencyInput$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$PriceInCents)),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$CurrencyInput$test('charge-price'),
							function () {
								var _v0 = _Utils_Tuple2(
									isTimeBased,
									A2(
										$elm$core$Maybe$map,
										$elm$core$String$toLower,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, fields.W$)));
								if (_v0.a && (!_v0.b.$)) {
									var name = _v0.b.a;
									return _List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
										]);
								} else {
									return _List_Nil;
								}
							}())))));
		var priceInput = A3(
			$author$project$Ui$Form$Accessible$input,
			'Price',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$inputSpanSm(4),
					$author$project$Ui$Form$Accessible$errors(
					A2($author$project$Utils$Form$validationErrors, 3, form))
				]),
			$author$project$Ui$Form$Accessible$currencyInput(currencyOptions));
		return A3(
			$author$project$Ui$Form$Accessible$group,
			'Price',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[priceInput, staticContent]));
	});
var $author$project$Ui$Form$Accessible$PractitionerFilter = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$practitionerFilter = $author$project$Ui$Form$Accessible$PractitionerFilter;
var $author$project$Components$Charge$Form$viewProvider = function (practitionerResourceFilter) {
	return A4(
		$author$project$Ui$Form$Accessible$single,
		'Provider',
		_List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]),
		_List_Nil,
		A3(
			$author$project$Ui$Form$Accessible$practitionerFilter,
			$author$project$Components$Charge$Form$PractitionerResourceFilterMsg,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(0)
				]),
			practitionerResourceFilter));
};
var $author$project$Components$Charge$Form$Quantity = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Charge$Form$QuantityUom = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Accessible$inputSpan = A2($elm$core$Basics$composeR, $author$project$Ui$FlexGrid$span, $author$project$Ui$Form$Accessible$InputGrid);
var $author$project$Ui$Form$Accessible$labelSpan = A2($elm$core$Basics$composeR, $author$project$Ui$FlexGrid$span, $author$project$Ui$Form$Accessible$Grid);
var $author$project$Ui$Form$Accessible$TextInput = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Accessible$textInput = $author$project$Ui$Form$Accessible$TextInput;
var $author$project$Components$Charge$Form$viewQuantityInput = F4(
	function (fields, readOnly_, form, isTimeBased) {
		return A3(
			$author$project$Ui$Form$Accessible$group,
			'Quantity',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpan(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Form$Accessible$input,
					'Quantity',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpan(4),
							$author$project$Ui$Form$Accessible$errors(
							A2($author$project$Utils$Form$validationErrors, 2, form))
						]),
					$author$project$Ui$Form$Accessible$textInput(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$number,
								$author$project$Ui$Form$Input$value(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Bd))),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$Quantity)),
								$author$project$Ui$Form$Input$disabled(readOnly_),
								$author$project$Ui$Form$Input$test('charge-quantity')
							]))),
					function () {
					if (isTimeBased) {
						var uomOptions = A2(
							$elm$core$List$map,
							function (uom_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Uom$Shared$code(uom_)),
									$author$project$Api$Provider$Uom$Shared$name(uom_));
							},
							$author$project$Api$Provider$Uom$list(
								function (d) {
									return _Utils_update(
										d,
										{
											HH: $elm$core$Maybe$Just('time')
										});
								}));
						return A3(
							$author$project$Ui$Form$Accessible$input,
							'Time unit of measure',
							_List_fromArray(
								[
									$author$project$Ui$Form$Accessible$inputSpan(4)
								]),
							A2(
								$author$project$Ui$Form$Accessible$select,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Be)),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$QuantityUom)),
										$author$project$Ui$Form$Select$disabled(readOnly_)
									]),
								uomOptions));
					} else {
						return $author$project$Ui$Form$Accessible$none;
					}
				}()
				]));
	});
var $author$project$Ui$Form$Accessible$DateInput = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$dateInput = $author$project$Ui$Form$Accessible$DateInput;
var $author$project$Components$DateInput$Test = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$DateInput$test = function (dataTest) {
	return $author$project$Components$DateInput$Test(dataTest);
};
var $author$project$Components$Charge$Form$viewServiceDate = F4(
	function (fields, readOnly_, form, isTimeBased) {
		return A3(
			$author$project$Ui$Form$Accessible$group,
			isTimeBased ? 'Dates' : 'Date',
			_List_fromArray(
				[
					$author$project$Ui$Form$Accessible$labelSpanSm(4),
					$author$project$Ui$Form$Accessible$required(true)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Form$Accessible$input,
					'Start Date',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpan(6),
							$author$project$Ui$Form$Accessible$errors(
							A2($author$project$Utils$Form$validationErrors, 4, form))
						]),
					A3(
						$author$project$Ui$Form$Accessible$dateInput,
						$author$project$Components$Charge$Form$StartDateInputMsg(fields.kg),
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields._E),
								$author$project$Components$DateInput$disabled(readOnly_),
								$author$project$Components$DateInput$test('charge-date')
							]),
						fields.kg)),
					isTimeBased ? A3(
					$author$project$Ui$Form$Accessible$input,
					'End Date',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpan(6)
						]),
					A3(
						$author$project$Ui$Form$Accessible$dateInput,
						$author$project$Components$Charge$Form$EndDateInputMsg(fields.qu),
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields.qs),
								$author$project$Components$DateInput$disabled(readOnly_)
							]),
						fields.qu)) : $author$project$Ui$Form$Accessible$none
				]));
	});
var $author$project$Components$ChargeItemTaxableWarning$view = F2(
	function (selectedPayer, taxable) {
		var sponsorPayer = selectedPayer === 1;
		var showWarning = sponsorPayer && taxable;
		return showWarning ? A2(
			$author$project$Ui$Alert$danger,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Taxed charge items cannot be billed on a sponsor\'s invoice. Please contact support at support@hint.com to learn more.')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Charge$Form$viewTaxableWarning = function (fields) {
	var _v0 = fields.lp;
	if (!_v0.$) {
		var chargeItem = _v0.a;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(8),
								$author$project$Ui$FlexGrid$offsetSm(4)
							]),
						_List_fromArray(
							[
								A2($author$project$Components$ChargeItemTaxableWarning$view, fields.VW, chargeItem.$u)
							]))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Charge$Form$discountDetails = F3(
	function (fields, readyOnly, preview) {
		var discountRemoved = fields.NJ && (!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					(!(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview))) ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Total without membership: '),
							$author$project$Components$Invoice$ChargeDiscount$view(preview)
						])) : $author$project$Utils$Html$empty,
					discountRemoved ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Membership rule was removed')
						])) : $author$project$Utils$Html$empty,
					(discountRemoved && ($author$project$Utils$Maybe$toBool(fields.lp) && (!readyOnly))) ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Revert to original discount'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Charge$Form$FormUpdated(
								$author$project$Components$Charge$Form$DiscountOverridden(false)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Revert to original')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Charge$Form$viewTotal = F3(
	function (fields, readyOnly, model) {
		var labelOptions = _List_fromArray(
			[
				$author$project$Ui$Form$Accessible$labelSpanSm(4)
			]);
		var inputOptions = _List_fromArray(
			[
				$author$project$Ui$Form$Accessible$inputSpanSm(8)
			]);
		return A4(
			$author$project$Ui$Form$Accessible$single,
			'Total',
			labelOptions,
			inputOptions,
			$author$project$Ui$Form$Accessible$static(
				function () {
					var _v0 = model.afU;
					switch (_v0.$) {
						case 3:
							var preview = _v0.a;
							var total = $author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview));
							return ((!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)) && (!fields.NJ)) ? _List_fromArray(
								[
									$elm$html$Html$text(total)
								]) : _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$title,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(total)
												])),
											A3($author$project$Components$Charge$Form$discountDetails, fields, readyOnly, preview)
										]))
								]);
						case 1:
							return _List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('$100.00')
										]))
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$text('N/A')
								]);
					}
				}()));
	});
var $author$project$Components$Charge$Form$view = function (_v0) {
	var model = _v0;
	if (model.hd) {
		var routingFields = A2(
			$elm$core$List$map,
			$elm$html$Html$map($author$project$Components$Charge$Form$RoutingFieldsMsg),
			A2($author$project$Components$Charge$Form$RoutingFields$view, model.n2, model.XO));
		var meta = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Charge$One$meta,
			$author$project$Api$Data$toMaybe(model.abU));
		var fields = $author$project$Utils$Form$fields(model.e);
		var isTimeBased = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$isTimeBased, fields.Be));
		var taxWarning = $author$project$Components$Charge$Form$viewTaxableWarning(fields);
		var baseFields = _List_fromArray(
			[
				A3($author$project$Components$Charge$Form$viewPatientInput, model.rU, model.XO || model.rS, model.e),
				A3($author$project$Components$Charge$Form$viewChargeItemInput, model.cK, model.XO, model.e),
				A4($author$project$Components$Charge$Form$viewQuantityInput, fields, model.XO, model.e, isTimeBased),
				A6($author$project$Components$Charge$Form$viewPriceInput, fields, model.XO, model.e, meta, model.afU, isTimeBased),
				A3($author$project$Components$Charge$Form$viewTotal, fields, model.XO, model),
				(!model.XO) ? $author$project$Components$Charge$Form$viewAdditionalDetails(model.gJ) : $author$project$Utils$Html$empty
			]);
		var additionalFields = model.gJ ? _List_fromArray(
			[
				$author$project$Components$Charge$Form$viewCategory(model.e),
				$author$project$Components$Charge$Form$viewDescription(fields),
				A4($author$project$Components$Charge$Form$viewServiceDate, fields, model.XO, model.e, isTimeBased),
				$author$project$Components$Charge$Form$viewProvider(model.jC),
				$author$project$Components$Charge$Form$viewLocation(model.rl)
			]) : (model.XO ? _List_fromArray(
			[
				A4($author$project$Components$Charge$Form$viewServiceDate, fields, model.XO, model.e, isTimeBased)
			]) : _List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				baseFields,
				_Utils_ap(
					additionalFields,
					_Utils_ap(routingFields, taxWarning))));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Charges$New$isPaid = function (invoice) {
	return invoice.ag7 === 'paid';
};
var $author$project$Api$Provider$CustomerInvoice$Shared$hasGoodPaymentSource = function (_v0) {
	var record = _v0;
	return record.P7;
};
var $author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$hasGoodPaymentSource(shared);
};
var $author$project$Pages$Charges$New$issueLabel = F2(
	function (invoice, actionText) {
		return $author$project$Pages$Charges$New$isDraft(invoice) ? (' Issue & ' + actionText) : (' ' + actionText);
	});
var $author$project$Pages$Charges$New$viewPayAction = function (invoice) {
	var canCreatePayment = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource,
			$author$project$Api$Data$toMaybe(invoice.jY)));
	return canCreatePayment ? _List_fromArray(
		[
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					A2($author$project$Pages$Charges$New$Pay, invoice, false))
				]),
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 46),
						$elm$html$Html$text(
						A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Pay'))
					])))
		]) : _List_Nil;
};
var $author$project$Pages$Charges$New$viewRecordPaymentAction = function (invoice) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					A2($author$project$Pages$Charges$New$Pay, invoice, true))
				]),
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 23),
						$elm$html$Html$text(
						A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Record Payment'))
					])))
		]);
};
var $author$project$Api$Provider$CustomerInvoice$Shared$isPaymentScheduled = function (_v0) {
	var record = _v0;
	return record.R_;
};
var $author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$isPaymentScheduled(shared);
};
var $author$project$Pages$Charges$New$viewSchedulePaymentAction = function (invoice) {
	var hasScheduledPayment = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled,
			$author$project$Api$Data$toMaybe(invoice.jY)));
	return (!hasScheduledPayment) ? _List_fromArray(
		[
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Charges$New$SchedulePayment(invoice))
				]),
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 45),
						$elm$html$Html$text(
						A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Schedule Payment'))
					])))
		]) : _List_Nil;
};
var $author$project$Ui$Icon$Send = 54;
var $author$project$Pages$Charges$New$viewSendEmailAction = function (invoice) {
	var _v0 = invoice.Vp;
	if (!_v0.$) {
		var owner = _v0.a;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						A2(
							$author$project$Pages$Charges$New$Email,
							$author$project$Api$Common$Payable$Owner$Min$id(owner),
							invoice))
					]),
				A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 54),
							$elm$html$Html$text(
							A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Send email'))
						])))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Charges$New$viewInvoiceActions = function (invoice) {
	var _v0 = invoice.ahI;
	switch (_v0) {
		case 0:
			return $author$project$Utils$Html$empty;
		case 1:
			var actions = _Utils_ap(
				$author$project$Pages$Charges$New$viewPayAction(invoice),
				_Utils_ap(
					$author$project$Pages$Charges$New$viewRecordPaymentAction(invoice),
					_Utils_ap(
						$author$project$Pages$Charges$New$viewSchedulePaymentAction(invoice),
						$author$project$Pages$Charges$New$viewSendEmailAction(invoice))));
			return ($author$project$Pages$Charges$New$isPaid(invoice) || _Utils_eq(actions, _List_Nil)) ? $author$project$Utils$Html$empty : A4(
				$author$project$Ui$NewDropdown$view,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$disabled(
						_Utils_eq(invoice.jY, $author$project$Api$Data$Loading))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Invoice Actions')
					]),
				actions,
				invoice.lV);
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Charges$New$ToggleChargeDetails = function (a) {
	return {$: 6, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Charge$Shared$totalInCents = function (_v0) {
	var record = _v0;
	return record.$X;
};
var $author$project$Api$Provider$Charge$One$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
};
var $author$project$Components$Charge$Form$visible = function (_v0) {
	var model = _v0;
	return model.hd;
};
var $author$project$Pages$Charges$New$viewCharge = F2(
	function (index, createdCharge) {
		var charge = $author$project$Api$Data$toMaybe(
			$author$project$Components$Charge$Form$charge(createdCharge));
		var chargeName = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$name, charge)));
		var patientName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$patient, charge))));
		var totalInCents = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Currency$fromInt,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$totalInCents, charge)));
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[$author$project$Ui$Typography$primary]),
							_List_fromArray(
								[
									$elm$html$Html$text(totalInCents + (' — ' + (chargeName + (' for ' + patientName))))
								])),
							function () {
							var _v0 = $author$project$Components$Charge$Form$visible(createdCharge) ? _Utils_Tuple2(
								'Hide charge details ',
								A2($author$project$Ui$Icon$view, _List_Nil, 28)) : _Utils_Tuple2(
								'See charge details ',
								A2($author$project$Ui$Icon$view, _List_Nil, 27));
							var buttonLabel = _v0.a;
							var icon = _v0.b;
							return A3(
								$author$project$Ui$Button$view,
								{abp: buttonLabel},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$pull(1),
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Charges$New$ToggleChargeDetails(index))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(buttonLabel),
										icon
									]));
						}()
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Charges$New$ChargeFormMsg,
					$author$project$Components$Charge$Form$view(createdCharge))
				]));
	});
var $author$project$Pages$Charges$New$viewInvoiceCharges = F2(
	function (invoice, createdChargesWithIndex) {
		var createdChargesForInvoiceWithIndex = A2(
			$elm$core$List$filter,
			function (_v1) {
				var createdCharge = _v1.b;
				return _Utils_eq(
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Common$Payable$Invoice$MinWithOwner$id,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Charge$One$invoice,
								$author$project$Api$Data$toMaybe(
									$author$project$Components$Charge$Form$charge(createdCharge))))),
					$elm$core$Maybe$Just(invoice.adR));
			},
			createdChargesWithIndex);
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var index = _v0.a;
				var createdCharge = _v0.b;
				return A2($author$project$Pages$Charges$New$viewCharge, index, createdCharge);
			},
			createdChargesForInvoiceWithIndex);
	});
var $author$project$Pages$Charges$New$viewInvoiceLink = F4(
	function (invoiceId, invoiceType, invoiceNumber, ownerId) {
		var invoiceRoute = function () {
			switch (invoiceType) {
				case 0:
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
							{ff: ownerId, adR: invoiceId}));
				case 1:
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
							{aea: invoiceId, VN: ownerId}));
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A2(
				$elm$core$Maybe$map,
				function (partialLink) {
					return A2(
						partialLink,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(invoiceNumber)
							]));
				},
				A2($elm$core$Maybe$map, $author$project$Ui$Link$route, invoiceRoute)));
	});
var $author$project$Pages$Charges$New$viewOwnerLink = F3(
	function (invoiceType, ownerId, ownerName) {
		var ownerRoute = function () {
			switch (invoiceType) {
				case 0:
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
							{ff: ownerId}));
				case 1:
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{VN: ownerId}));
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A2(
				$elm$core$Maybe$map,
				function (partialLink) {
					return A2(
						partialLink,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(ownerName)
							]));
				},
				A2($elm$core$Maybe$map, $author$project$Ui$Link$route, ownerRoute)));
	});
var $author$project$Pages$Charges$New$viewInvoiceDetails = function (invoice) {
	var ownerName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, invoice.Vp));
	var ownerId = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$id, invoice.Vp));
	var invoiceType = invoice.ahI;
	var invoiceNumber = A2(
		$elm$core$String$append,
		'#',
		$elm$core$String$fromInt(invoice.Rq));
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Invoice '),
				A4($author$project$Pages$Charges$New$viewInvoiceLink, invoice.adR, invoiceType, invoiceNumber, ownerId),
				$elm$html$Html$text(' paid for by'),
				A3($author$project$Pages$Charges$New$viewOwnerLink, invoiceType, ownerId, ownerName),
				A2($author$project$Ui$Badge$fromString, _List_Nil, invoice.ag7)
			]));
};
var $author$project$Pages$Charges$New$viewInvoice = F2(
	function (createdCharges, invoice) {
		var createdChargesWithIndex = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, createdCharge) {
					return _Utils_Tuple2(index, createdCharge);
				}),
			createdCharges);
		return A2(
			$author$project$Ui$ListGroup$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$ListGroup$item,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Pages$Charges$New$viewInvoiceDetails(invoice),
									$author$project$Pages$Charges$New$viewInvoiceActions(invoice)
								]))
						])),
				A2($author$project$Pages$Charges$New$viewInvoiceCharges, invoice, createdChargesWithIndex)));
	});
var $author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice = function (model) {
	return $elm$core$List$isEmpty(model.q2) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
				$author$project$Ui$Typography$margin(7)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Charges$New$viewInvoice(model.dA),
			model.q2));
};
var $author$project$Pages$Charges$New$viewPanelBody = function (model) {
	return A2(
		$elm$core$List$append,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Charges$New$ChargeFormMsg,
						$author$project$Components$Charge$Form$view(model.e))
					]))
			]),
		(model.Cd.adu.acW && (!$elm$core$List$isEmpty(model.q2))) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_fromArray(
					[$author$project$Ui$Element$bgPrimary50]),
				_List_fromArray(
					[
						$author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice(model)
					]))
			]) : _List_Nil);
};
var $author$project$Pages$Charges$New$SaveAndAddAnother = {$: 1};
var $author$project$Components$Charge$Form$loading = function (_v0) {
	var model = _v0;
	return _Utils_eq(model.afU, $author$project$Api$Data$Loading);
};
var $author$project$Components$Charge$Form$saving = function (_v0) {
	var model = _v0;
	return _Utils_eq(model.abU, $author$project$Api$Data$Loading);
};
var $author$project$Pages$Charges$New$viewPanelFooter = function (model) {
	var formSaving = $author$project$Components$Charge$Form$saving(model.e);
	var formLoading = $author$project$Components$Charge$Form$loading(model.e);
	var _v0 = model.Cd.adu.acW ? _Utils_Tuple2('Add Another', 'Create') : _Utils_Tuple2('Save & Add Another', 'Save');
	var saveAndAddButtonLabel = _v0.a;
	var saveButtonLabel = _v0.b;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$footer,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: saveAndAddButtonLabel},
							_List_fromArray(
								[
									$author$project$Ui$Button$styled(0),
									$author$project$Ui$Button$disabled(formLoading),
									$author$project$Ui$Button$loading(formSaving),
									$author$project$Ui$Button$onClick($author$project$Pages$Charges$New$SaveAndAddAnother)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(saveAndAddButtonLabel)
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: saveButtonLabel},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$disabled(formLoading),
									$author$project$Ui$Button$loading(formSaving)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(saveButtonLabel)
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							model.Cd.adu.acW ? $author$project$Utils$Html$empty : $author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice(model)
						]))
				]))
		]);
};
var $author$project$Pages$Charges$New$Close = {$: 3};
var $author$project$Pages$Charges$New$viewPanelHeading = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$heading,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$titleWithButton,
				_List_fromArray(
					[
						$elm$html$Html$text('Create New Charges')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Close and go back'},
						_List_fromArray(
							[
								$author$project$Ui$Button$close,
								$author$project$Ui$Button$onClick($author$project$Pages$Charges$New$Close)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('×')
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$Charges$New$viewBody = function (model) {
	return $author$project$Components$Charge$Form$formReady(model.e) ? A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Pages$Charges$New$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				$elm$core$List$concat(
					_List_fromArray(
						[
							$author$project$Pages$Charges$New$viewPanelHeading,
							$author$project$Pages$Charges$New$viewPanelBody(model),
							$author$project$Pages$Charges$New$viewPanelFooter(model)
						])))
			])) : A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$margin(18)
			]),
		$author$project$Components$LoadingPage$view);
};
var $author$project$Pages$Charges$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Charges$New$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$modal(model.lH)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Charges$New$SchedulePaymentModalMsg,
				$author$project$Components$CustomerSchedulePaymentModal$view(model.gA)),
				function () {
				var _v0 = model.lC;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var createPaymentModal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Charges$New$CreatePaymentModalMsg,
						$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Pages$Charges$New$viewBody(model)
			]),
		$G: 'Charges'
	};
};
var $author$project$Pages$Charges$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Charges$New$init, aer: $author$project$Pages$Charges$New$load, agD: $author$project$Pages$Charges$New$save, ahd: $author$project$Pages$Charges$New$subscriptions, aaq: $author$project$Pages$Charges$New$update, ahP: $author$project$Pages$Charges$New$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$BrokerFormMsg = $elm$core$Basics$identity;
var $author$project$Components$Broker$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Broker$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Broker$Form$formFieldsInit = {zh: '', z_: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Broker$brokerPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Broker$brokersPath);
};
var $author$project$Api$Provider$Broker$One$Broker = $elm$core$Basics$identity;
var $author$project$Api$Provider$Broker$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Broker$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Broker$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Broker$brokerPath(id_)));
	});
var $author$project$Components$Broker$Form$init = F4(
	function (apiClient, session, brokerAccountId, id) {
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$Broker$retrieve, apiClient, id_, $author$project$Components$Broker$Form$GotItem));
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just($author$project$Components$Broker$Form$formFieldsInit),
					$elm$core$Platform$Cmd$none);
			}
		}();
		var formFields = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{
				bP: brokerAccountId,
				PB: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
				adR: id,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session
			},
			cmd);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var params = _v2.Vx;
		var _v3 = A4(
			$author$project$Components$Broker$Form$init,
			apiClient,
			session,
			params.bP,
			$elm$core$Maybe$Just(params.Eo));
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Api$Provider$Broker$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$name(shared);
};
var $author$project$Components$Broker$Form$formFieldsFromItem = function (broker) {
	return {
		zh: $author$project$Api$Provider$Broker$One$name(broker),
		z_: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Broker$One$name(broker))
	};
};
var $author$project$Components$Broker$Form$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{zh: string});
	});
var $author$project$Components$Broker$Form$NameValidation = 0;
var $author$project$Components$Broker$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Components$Broker$Form$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Broker$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'broker_account',
								$author$project$Utils$Encode$association(fields.vK))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Broker$brokersPath)));
	});
var $author$project$Components$Broker$Form$createItem = F3(
	function (apiClient, brokerAccountId, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {vK: brokerAccountId, zh: fields.zh};
		return A3($author$project$Api$Provider$Broker$create, apiClient, apiFields, $author$project$Components$Broker$Form$Created);
	});
var $author$project$Components$Broker$Form$Updated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Broker$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Broker$brokerPath(id_))));
	});
var $author$project$Components$Broker$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {zh: fields.zh};
		return A4($author$project$Api$Provider$Broker$update, apiClient, id, apiFields, $author$project$Components$Broker$Form$Updated);
	});
var $author$project$Components$Broker$Form$saveItem = F4(
	function (maybeId, apiClient, brokerAccountId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Broker$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A3($author$project$Components$Broker$Form$createItem, apiClient, brokerAccountId, formFields);
		}
	});
var $author$project$Components$Broker$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var broker = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										$author$project$Components$Broker$Form$formFieldsFromItem(broker)))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var field = msg.a;
				var _v3 = model.PB;
				if (!_v3.$) {
					var form = _v3.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Broker$Form$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var _v4 = model.PB;
				if (!_v4.$) {
					var form = _v4.a;
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$Broker$Form$formFieldsValidator, form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							A4($author$project$Components$Broker$Form$saveItem, model.adR, apiClient, model.bP, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var response = msg.a;
				var _v7 = model.PB;
				if (!_v7.$) {
					if (response.$ === 3) {
						var broker = response.a;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
									{bP: model.bP})),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Broker$One$name(broker))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v9 = model.PB;
				if (!_v9.$) {
					if (response.$ === 3) {
						var broker = response.a;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
									{bP: model.bP})),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Broker$One$name(broker) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Broker$Form$update, model.D5, subMsg, model.PB);
		var newModelForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newModelForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Broker$Form$Save = {$: 2};
var $author$project$Components$Broker$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Broker$Form$Name = $elm$core$Basics$identity;
var $author$project$Components$Broker$Form$viewForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$label('Name')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.zh),
							$author$project$Ui$Form$Input$placeholder('e.g. John Doe'),
							$author$project$Ui$Form$Input$autofocus(true),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Broker$Form$FormUpdated, $elm$core$Basics$identity)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]))
		]);
};
var $author$project$Components$Broker$Form$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Components$Broker$Form$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
														{bP: model.bP}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('All Brokers')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													function () {
													var _v1 = model.PB;
													if (!_v1.$) {
														var form = _v1.a;
														var _v2 = $author$project$Utils$Form$fields(form);
														var originalName = _v2.z_;
														return $elm$html$Html$text(
															A2($elm$core$Maybe$withDefault, 'Add New Broker', originalName));
													} else {
														return $author$project$Ui$Spinner$view(
															_List_fromArray(
																[$author$project$Ui$Spinner$extraSmall]));
													}
												}()
												]))
										]))),
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										function () {
										var _v3 = model.adR;
										if (!_v3.$) {
											return $elm$html$Html$text('Edit broker');
										} else {
											return $elm$html$Html$text('Add new broker');
										}
									}()
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v4 = model.PB;
							if (!_v4.$) {
								var form = _v4.a;
								return $author$project$Components$Broker$Form$viewForm(form);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
											{bP: model.bP}),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Back')
											])),
										function () {
										var verb = function () {
											var _v5 = model.adR;
											if (!_v5.$) {
												return 'Update';
											} else {
												return 'Create';
											}
										}();
										return A3(
											$author$project$Ui$Button$view,
											{abp: verb + ' broker'},
											_List_fromArray(
												[
													$author$project$Ui$Button$primary,
													$author$project$Ui$Button$submit,
													$author$project$Ui$Button$loading(
													_Utils_eq(model.jY, $author$project$Api$Data$Loading))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(verb)
												]));
									}()
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Broker$Form$view(model.PB))
			]),
		$G: 'Commissions | Brokers'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$GotBrokers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers = function (model) {
	return A3(
		$author$project$Api$Provider$Broker$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					vK: $elm$core$Maybe$Just(model.bP),
					QR: $elm$core$Maybe$Just(true),
					afy: model.afy,
					ag1: model.ag1
				});
		},
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$GotBrokers);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var query = _v2.Bi;
		var params = _v2.Vx;
		var model = {
			D5: apiClient,
			bP: params.bP,
			Ka: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			jS: $elm$core$Maybe$Nothing,
			ZD: session,
			ag1: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(model));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Broker$RestartModal$Close = {$: 1};
var $author$project$Components$Broker$RestartModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Broker$RestartModal$Close);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2($elm$core$Maybe$map, $author$project$Components$Broker$RestartModal$subscriptions, model.jS)));
};
var $author$project$Components$Broker$RestartModal$init = F2(
	function (session, broker) {
		return {vJ: broker, ZD: session, o$: $author$project$Api$Data$NotAsked};
	});
var $author$project$Components$Broker$RestartModal$BrokerRestarted = 2;
var $author$project$Components$Broker$RestartModal$Closed = 1;
var $author$project$Components$Broker$RestartModal$None = 0;
var $author$project$Components$Broker$RestartModal$Restarted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Broker$restart = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['restart']),
					$author$project$Api$Provider$Broker$brokerPath(id_))));
	});
var $author$project$Components$Broker$RestartModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 0:
				return {
					EC: A3(
						$author$project$Api$Provider$Broker$restart,
						apiClient,
						$author$project$Api$Provider$Broker$All$id(model.vJ),
						$author$project$Components$Broker$RestartModal$Restarted),
					ac5: 0,
					y8: _Utils_update(
						model,
						{o$: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker successfully restarted')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
						{bP: model.bP}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				$author$project$Api$Sort$toQuery(model.ag1))));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ka: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ka: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var broker = msg.a;
				var restartModal = A2($author$project$Components$Broker$RestartModal$init, model.ZD, broker);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jS: $elm$core$Maybe$Just(restartModal)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = model.jS;
				if (!_v2.$) {
					var restartModal = _v2.a;
					var restartModalResult = A3($author$project$Components$Broker$RestartModal$update, model.D5, subMsg, restartModal);
					var _v3 = function () {
						var _v4 = restartModalResult.ac5;
						switch (_v4) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(restartModalResult.y8),
									model.Ka,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Ka, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(model));
						}
					}();
					var restartModal_ = _v3.a;
					var brokers = _v3.b;
					var cmd = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ka: brokers, jS: restartModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg, restartModalResult.EC),
									cmd
								])),
						restartModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Broker$RestartModal$Restart = {$: 0};
var $author$project$Components$Broker$RestartModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Broker$RestartModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Restart Broker')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('Restarting this broker will not re-activate any old deals they may have been associated with '),
								$elm$html$Html$text('but will allow them to be used in new deals.')
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Broker$RestartModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Restart broker'},
						_List_fromArray(
							[
								$author$project$Ui$Button$danger,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.o$, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Broker$RestartModal$Restart)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Restart')
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name')
	]);
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$Restart = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Broker$Shared$endedOn = function (_v0) {
	var record = _v0;
	return record.OA;
};
var $author$project$Api$Provider$Broker$All$endedOn = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Broker$Shared$endedOn(shared);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewBroker = function (broker) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$bold]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Broker$All$name(broker)),
								function () {
								var _v0 = $author$project$Api$Provider$Broker$All$endedOn(broker);
								if (!_v0.$) {
									var endedOn = _v0.a;
									return A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(' on '),
												$elm$html$Html$text(
												A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endedOn))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$pull(1)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Restart broker'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$Restart(broker)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Restart')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.Ka;
		if (_v1.$ === 3) {
			var brokers_ = _v1.a;
			return _Utils_Tuple2(false, brokers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var brokers = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No ended brokers.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$SortTable)),
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewBroker, brokers),
			_List_Nil)
		]);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.jS;
				if (!_v0.$) {
					var restartModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg,
						$author$project$Components$Broker$RestartModal$view(restartModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
														{bP: model.bP}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Active Brokers')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ended Brokers')
												]))
										]))),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Ended Brokers')
									])),
								A2($elm$html$Html$br, _List_Nil, _List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v1 = model.Ka;
								if (_v1.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.afy));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		$G: 'Commissions | Brokers'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$BrokerFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var params = _v2.Vx;
		var _v3 = A4($author$project$Components$Broker$Form$init, apiClient, session, params.bP, $elm$core$Maybe$Nothing);
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Broker$Form$update, model.D5, subMsg, model.PB);
		var newModelForm = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newModelForm}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Broker$Form$view(model.PB))
			]),
		$G: 'Commissions | Brokers'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$GotBrokers = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers = function (model) {
	return A3(
		$author$project$Api$Provider$Broker$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					vK: $elm$core$Maybe$Just(model.bP),
					afy: model.afy,
					ag1: model.ag1
				});
		},
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$GotBrokers);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$init = F4(
	function (session, _v0, shared, _v1) {
		var query = _v1.Bi;
		var params = _v1.Vx;
		var model = {
			D5: shared.D5,
			bP: params.bP,
			Ka: $author$project$Api$Data$Loading,
			cO: shared.cO,
			fC: $elm$core$Maybe$Nothing,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			ZD: session,
			ag1: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(model));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Broker$EndModal$Close = {$: 1};
var $author$project$Components$Broker$EndModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Broker$EndModal$Close);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$subscriptions = function (_v0) {
	var endModal = _v0.fC;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2($elm$core$Maybe$map, $author$project$Components$Broker$EndModal$subscriptions, endModal)));
};
var $author$project$Components$Broker$EndModal$Broker = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Broker$EndModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Broker$EndModal$EndDateDateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Broker$EndModal$initFormFields = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var endDateDateInput = _v0.a;
	var endDateDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{qs: $elm$core$Maybe$Nothing, qt: endDateDateInput},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$Broker$EndModal$EndDateDateInputMsg(endDateDateInput),
			endDateDateInputCmd));
}();
var $author$project$Components$Broker$EndModal$init = F3(
	function (session, currentDate, resource) {
		var _v0 = $author$project$Components$Broker$EndModal$initFormFields;
		var fields = _v0.a;
		var fieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				cO: currentDate,
				PB: $author$project$Utils$Form$init(fields),
				G0: resource,
				ZD: session,
				o$: $author$project$Api$Data$NotAsked
			},
			fieldsCmd);
	});
var $author$project$Components$Broker$EndModal$BrokerAccountEnded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Broker$EndModal$BrokerEnded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Broker$EndModal$Closed = {$: 1};
var $author$project$Components$Broker$EndModal$EndDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Broker$EndModal$EndedBroker = {$: 2};
var $author$project$Components$Broker$EndModal$EndedBrokerAccount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Broker$EndModal$None = {$: 0};
var $author$project$Api$Provider$Broker$end = F4(
	function (apiClient, id_, endDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'ended_on',
								$author$project$Utils$Date$encode(endDate))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Broker$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['end']),
						$author$project$Api$Provider$Broker$brokerPath(id_)))));
	});
var $author$project$Api$Provider$BrokerAccount$brokerAccountsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['broker_accounts']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$BrokerAccount$brokerAccountPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$BrokerAccount$brokerAccountsPath);
};
var $author$project$Api$Provider$BrokerAccount$One$BrokerAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerAccount$One$Record = function (ein) {
	return function (singleBrokerName) {
		return function (addressLine1) {
			return function (addressLine2) {
				return function (addressCity) {
					return function (addressState) {
						return function (addressZip) {
							return function (addressCountry) {
								return function (futureRatePeriodScheduleStartDate) {
									return function (futureRatePeriodSchedule) {
										return function (meta) {
											return {Iu: addressCity, Iv: addressCountry, Iw: addressLine1, Ix: addressLine2, Iy: addressState, Iz: addressZip, Of: ein, PL: futureRatePeriodSchedule, PM: futureRatePeriodScheduleStartDate, TU: meta, Z7: singleBrokerName};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$BrokerAccount$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerAccount$Meta$Record = F3(
	function (destroyable, currentScheduleEnded, futureScheduleEnded) {
		return {Mx: currentScheduleEnded, NC: destroyable, PN: futureScheduleEnded};
	});
var $author$project$Api$Provider$BrokerAccount$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'future_schedule_ended',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'current_schedule_ended',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'destroyable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$Meta$Record))));
var $author$project$Api$Provider$BrokerAccount$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerAccount$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$BrokerAccount$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'future_rate_period_schedule',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$RatePeriodSchedule$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'future_rate_period_schedule_start_date',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'address_country',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'address_zip',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'address_state',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'address_city',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'address_line2',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'address_line1',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'single_broker_name',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'ein',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$One$Record))))))))))));
var $author$project$Api$Provider$BrokerAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BrokerAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$One$BrokerAccount)));
var $author$project$Api$Provider$BrokerAccount$end = F4(
	function (apiClient, id, endDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'end_date',
								$author$project$Utils$Date$encode(endDate))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['end']),
						$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)))));
	});
var $author$project$Components$Broker$EndModal$EndDateValidation = 0;
var $author$project$Components$Broker$EndModal$validateEndDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.qs;
		if (!_v0.$) {
			var endDate = _v0.a;
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
			return (A2($justinmimbs$date$Date$compare, yesterdayDate, endDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$Broker$EndModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Broker$EndModal$validateEndDate(currentDate))
			]));
};
var $author$project$Api$Provider$BrokerAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$BrokerAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$id(shared);
};
var $author$project$Components$Broker$EndModal$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{qs: date, qt: dateInput});
	});
var $author$project$Components$Broker$EndModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Broker$EndModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Broker$EndModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return {
			EC: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			ac5: $author$project$Components$Broker$EndModal$None,
			y8: _Utils_update(
				model,
				{PB: newForm}),
			as: _List_Nil
		};
	});
var $author$project$Components$Broker$EndModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Broker$EndModal$Closed, y8: model, as: _List_Nil};
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Broker$EndModal$formFieldsValidator(model.cO),
					model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var endDate = A2(
						$elm$core$Maybe$withDefault,
						model.cO,
						$rtfeldman$elm_validate$Validate$fromValid(validFormFields).qs);
					return {
						EC: function () {
							var _v4 = model.G0;
							if (!_v4.$) {
								var broker = _v4.a;
								return A4(
									$author$project$Api$Provider$Broker$end,
									apiClient,
									$author$project$Api$Provider$Broker$All$id(broker),
									endDate,
									$author$project$Components$Broker$EndModal$BrokerEnded);
							} else {
								var brokerAccount = _v4.a;
								return A4(
									$author$project$Api$Provider$BrokerAccount$end,
									apiClient,
									$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
									endDate,
									$author$project$Components$Broker$EndModal$BrokerAccountEnded);
							}
						}(),
						ac5: $author$project$Components$Broker$EndModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm, o$: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Broker$EndModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Broker$EndModal$EndedBroker,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker successfully ended')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Broker$EndModal$None,
						y8: _Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: function () {
							var _v7 = model.G0;
							if (_v7.$ === 1) {
								var brokerAccount = _v7.a;
								return $author$project$Components$Broker$EndModal$EndedBrokerAccount(brokerAccount);
							} else {
								return $author$project$Components$Broker$EndModal$None;
							}
						}(),
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Brokers and deals successfully ended')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Broker$EndModal$None,
						y8: _Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$Broker$EndModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Broker$EndModal$EndDateDateInputMsg,
					$author$project$Components$Broker$EndModal$EndDate,
					function ($) {
						return $.qs;
					});
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
						{bP: model.bP}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				$author$project$Api$Sort$toQuery(model.ag1))));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ka: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ka: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var broker = msg.a;
				var _v2 = A3(
					$author$project$Components$Broker$EndModal$init,
					model.ZD,
					model.cO,
					$author$project$Components$Broker$EndModal$Broker(broker));
				var endModal = _v2.a;
				var endModalCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fC: $elm$core$Maybe$Just(endModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg, endModalCmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v3 = model.fC;
				if (!_v3.$) {
					var endModal = _v3.a;
					var endModalResult = A3($author$project$Components$Broker$EndModal$update, model.D5, subMsg, endModal);
					var _v4 = function () {
						var _v5 = endModalResult.ac5;
						switch (_v5.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(endModalResult.y8),
									model.Ka,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Ka, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(model));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Ka, $elm$core$Platform$Cmd$none);
						}
					}();
					var endModal_ = _v4.a;
					var brokers = _v4.b;
					var cmd = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ka: brokers, fC: endModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg, endModalResult.EC),
									cmd
								])),
						endModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Broker$EndModal$End = {$: 0};
var $author$project$Components$Broker$EndModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Broker$EndModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						function () {
							var _v1 = model.G0;
							if (!_v1.$) {
								var broker = _v1.a;
								return 'End Broker ' + $author$project$Api$Provider$Broker$All$name(broker);
							} else {
								return 'End All Deals';
							}
						}())
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Broker$EndModal$End),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Date'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Broker$EndModal$EndDateDateInputMsg(fields.qt),
										A2(
											$author$project$Components$DateInput$view,
											_List_fromArray(
												[
													$author$project$Components$DateInput$value(fields.qs),
													$author$project$Components$DateInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
													$author$project$Components$DateInput$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.PB))
												]),
											fields.qt)),
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												function () {
												var _v2 = model.G0;
												if (!_v2.$) {
													return $elm$html$Html$text('Ending this broker will end all deals on the same date and delete any deals taking effect in the future.');
												} else {
													return $elm$html$Html$text('This will end all brokers and their deals on the same date, and delete any deals taking effect in the future.');
												}
											}()
											]))
									]))
							])),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Broker$EndModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'End broker and their deals'},
						_List_fromArray(
							[
								$author$project$Ui$Button$danger,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.o$, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Broker$EndModal$End)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('End')
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name')
	]);
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$End = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewBroker = F2(
	function (brokerAccountId, broker) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Broker$All$name(broker)),
									function () {
									var _v0 = $author$project$Api$Provider$Broker$All$endedOn(broker);
									if (!_v0.$) {
										var endedOn = _v0.a;
										return A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Badge$fromString, _List_Nil, 'deal_ending'),
													$elm$html$Html$text(' on '),
													$elm$html$Html$text(
													A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endedOn))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top(
										{
											bP: brokerAccountId,
											Eo: $author$project$Api$Provider$Broker$All$id(broker)
										}),
									_List_fromArray(
										[
											$author$project$Ui$Link$sm,
											$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									function () {
									var _v1 = $author$project$Api$Provider$Broker$All$endedOn(broker);
									if (_v1.$ === 1) {
										return A3(
											$author$project$Ui$Button$view,
											{abp: 'End broker'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$size(0),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$End(broker)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('End')
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.Ka;
		if (_v1.$ === 3) {
			var brokers_ = _v1.a;
			return _Utils_Tuple2(false, brokers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var brokers = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('It looks like you haven’t added any brokers yet. '),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New(
								{bP: model.bP}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create one')
								])),
							$elm$html$Html$text('?')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$SortTable)),
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewBroker(model.bP),
				brokers),
			_List_Nil)
		]);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.fC;
				if (!_v0.$) {
					var endModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg,
						$author$project$Components$Broker$EndModal$view(endModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(9)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Brokers')
													])),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('A broker represents an individual who brings in deals. We track commissions at the broker level and then group those commissions onto statements at the account level.')
													]))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(3),
												$author$project$Ui$FlexGrid$justifyRight
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended(
													{bP: model.bP}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('See Ended Brokers')
													])),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New(
													{bP: model.bP}),
												_List_fromArray(
													[
														$author$project$Ui$Link$buttonDefault,
														$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add Broker')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v1 = model.Ka;
								if (_v1.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.afy));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		$G: 'Commissions | Brokers'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$TypeDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString = function (dealType) {
	if (!dealType) {
		return 'Company';
	} else {
		return 'Membership';
	}
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('type'),
			A2($elm$core$Maybe$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString, model.ahI)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('broker'),
			model.Eo)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
					{bP: model.bP}))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerDeals = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$BrokerDeal$brokerDealsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['broker_deals']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$BrokerDeal$All$BrokerDeal = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerDeal$One$BrokerDeal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerDeal$Shared$BrokerDeal = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerDeal$Shared$Record = F2(
	function (id, endDate) {
		return {qs: endDate, adR: id};
	});
var $author$project$Api$Provider$BrokerDeal$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$Shared$Record)));
var $author$project$Api$Provider$BrokerDeal$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDeal$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerDeal$One$Record = F6(
	function (dealName, dealType, broker, rates, company, meta) {
		return {vJ: broker, ab9: company, M1: dealName, M2: dealType, TU: meta, XM: rates};
	});
var $author$project$Api$Provider$BrokerDeal$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerDeal$Meta$MetaRecord = F8(
	function (hasEndedRates, hasEndedDeal, dateEditable, restartable, isMembershipType, destroyable, editable, endable) {
		return {MP: dateEditable, NC: destroyable, Oa: editable, Oz: endable, P4: hasEndedDeal, P5: hasEndedRates, RS: isMembershipType, Yw: restartable};
	});
var $author$project$Api$Provider$BrokerDeal$Meta$metaRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'endable',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'editable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'destroyable',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_membership_type',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'restartable',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'date_editable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'has_ended_deal',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'has_ended_rates',
								$elm$json$Json$Decode$bool,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$Meta$MetaRecord)))))))));
var $author$project$Api$Provider$BrokerDeal$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDeal$Meta$metaRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$BrokerDealRate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$BrokerDealRate = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerDealRate$Shared$Record = F5(
	function (id, startDate, endDate, description, pricingStructure) {
		return {Nx: description, qs: endDate, adR: id, W2: pricingStructure, _E: startDate};
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pricing_structure',
	$author$project$Api$Provider$PricingStructure$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$Shared$Record))))));
var $author$project$Api$Provider$BrokerDealRate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDealRate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$Record = F2(
	function (isEnded, isFuture) {
		return {RL: isEnded, RN: isFuture};
	});
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_future',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_ended',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$Record)));
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BrokerDealRate$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$BrokerDealRate)));
var $author$project$Api$Provider$BrokerDeal$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$BrokerDeal$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'company',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rates',
			$elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'broker',
				$author$project$Api$Provider$Broker$Shared$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'deal_type',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'deal_name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$One$Record)))))));
var $author$project$Api$Provider$BrokerDeal$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDeal$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BrokerDeal$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$One$BrokerDeal)));
var $author$project$Api$Provider$BrokerDeal$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerDeal$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$BrokerDeal$listDefaults = {vJ: $elm$core$Maybe$Nothing, vK: $elm$core$Maybe$Nothing, ab9: $elm$core$Maybe$Nothing, QR: $elm$core$Maybe$Nothing, ja: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, ahI: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$BrokerDeal$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$BrokerDeal$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ab9;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'company', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.vK;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker_account', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.vJ;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.ja;
				if (!_v3.$) {
					var string = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'membership', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.ahI;
				if (!_v4.$) {
					var string = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'type', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.QR;
				if (!_v5.$) {
					var bool = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$bool, 'inactive', bool)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.af_;
				if (!_v6.$) {
					var string = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$BrokerDeal$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDeal$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$BrokerDeal$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDeal$brokerDealsPath)));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals = function (model) {
	return A3(
		$author$project$Api$Provider$BrokerDeal$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					vJ: model.Eo,
					vK: $elm$core$Maybe$Just(model.bP),
					afy: model.afy,
					af_: model.af_,
					ahI: A2($elm$core$Maybe$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString, model.ahI)
				});
		},
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerDeals);
};
var $author$project$Components$BrokerDeal$Table$init = F3(
	function (session, currentDate, options) {
		return {J9: _List_Nil, cO: currentDate, l3: options.l3, qI: options.qI, qJ: options.qJ, ZD: session, gK: $elm$core$Set$empty};
	});
var $author$project$Api$Provider$BrokerAccount$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Company = 0;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Membership = 1;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$stringToDealType = function (str) {
	switch (str) {
		case 'Company':
			return $elm$core$Maybe$Just(0);
		case 'Membership':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var brokerId = A2($elm$core$Dict$get, 'broker', query);
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Broker$init,
			shared.D5,
			function (d) {
				return _Utils_update(
					d,
					{
						vK: $elm$core$Maybe$Just(params.bP)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Brokers', afT: brokerId});
			});
		var brokerResourceFilter = _v1.a;
		var brokerResourceFilterCmd = _v1.b;
		var model = {
			D5: shared.D5,
			vK: $author$project$Api$Data$Loading,
			bP: params.bP,
			J9: $author$project$Api$Data$Loading,
			dt: A3(
				$author$project$Components$BrokerDeal$Table$init,
				session,
				shared.cO,
				{l3: false, qI: true, qJ: false}),
			Eo: brokerId,
			lf: brokerResourceFilter,
			hY: $elm$core$Maybe$Nothing,
			cO: shared.cO,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			Hz: shared.Hz,
			oU: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'type-dropdown-filter', ahx: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$TypeDropdownMsg})),
			ahI: A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$stringToDealType,
				A2($elm$core$Dict$get, 'type', query))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg, brokerResourceFilterCmd),
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model),
						A3($author$project$Api$Provider$BrokerAccount$retrieve, shared.D5, params.bP, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerAccount),
						A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Components$BrokerDeal$Table$load = F2(
	function (currentDate, model) {
		return _Utils_update(
			model,
			{cO: currentDate});
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dt: A2($author$project$Components$BrokerDeal$Table$load, shared.cO, model.dt)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Close = {$: 1};
var $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PricingStructureSelect$subscriptions = function (model) {
	return $author$project$Ui$NewDropdown$subscriptions(model.lU);
};
var $author$project$Components$BrokerDeal$CreateModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$CreateModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.pV)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(model.lf)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg,
				$author$project$Components$ResourceFilter$Patient$subscriptions(model.rU)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg,
				$author$project$Components$PricingStructureSelect$subscriptions(model.nG))
			]));
};
var $author$project$Components$BrokerDeal$Table$TimelineMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$EndModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$RestartModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$BrokerDeal$EndModal$Close = {$: 1};
var $author$project$Components$BrokerDeal$EndModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$EndModal$Close);
};
var $author$project$Components$BrokerDeal$RestartModal$Close = {$: 1};
var $author$project$Components$BrokerDeal$RestartModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$RestartModal$Close);
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Close = {$: 1};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDealRate$CreateUpdateModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg,
				$author$project$Components$PricingStructureSelect$subscriptions(model.nG))
			]));
};
var $author$project$Components$BrokerDeal$Timeline$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.e6;
				if (!_v0.$) {
					var brokerDealRateModal = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg,
						$author$project$Components$BrokerDealRate$CreateUpdateModal$subscriptions(brokerDealRateModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$Timeline$EndModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$EndModal$subscriptions, model.fC))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$BrokerDeal$Timeline$RestartModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$RestartModal$subscriptions, model.jS))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed)),
					model.fm)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.e7)))
			]));
};
var $author$project$Components$BrokerDeal$Table$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, _v0) {
					var timeline = _v0.b;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$BrokerDeal$Table$TimelineMsg(index),
						$author$project$Components$BrokerDeal$Timeline$subscriptions(timeline));
				}),
			model.J9));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$CreateModal$subscriptions, model.hY))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$subscriptions(model.dt)),
				$author$project$Ui$NewDropdown$subscriptions(model.oU),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(model.lf))
			]));
};
var $author$project$Components$BrokerDeal$CreateModal$Company = 0;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$BrokerDeal$One$broker = function (_v0) {
	var record = _v0.b;
	return record.vJ;
};
var $author$project$Api$Provider$BrokerDeal$All$broker = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$broker(one);
};
var $author$project$Api$Provider$BrokerDeal$One$company = function (_v0) {
	var record = _v0.b;
	return record.ab9;
};
var $author$project$Api$Provider$BrokerDeal$All$company = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$company(one);
};
var $author$project$Api$Provider$BrokerDeal$One$dealName = function (_v0) {
	var record = _v0.b;
	return record.M1;
};
var $author$project$Api$Provider$BrokerDeal$All$dealName = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$dealName(one);
};
var $author$project$Api$Provider$BrokerDeal$One$dealType = function (_v0) {
	var record = _v0.b;
	return record.M2;
};
var $author$project$Api$Provider$BrokerDeal$All$dealType = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$dealType(one);
};
var $author$project$Api$Provider$BrokerDeal$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Api$Provider$BrokerDeal$One$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDeal$Shared$endDate(shared);
};
var $author$project$Api$Provider$BrokerDeal$All$endDate = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$endDate(one);
};
var $author$project$Api$Provider$BrokerDeal$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$BrokerDeal$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDeal$Shared$id(shared);
};
var $author$project$Api$Provider$BrokerDeal$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$id(one);
};
var $author$project$Api$Provider$BrokerDeal$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Provider$BrokerDeal$All$meta = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$meta(one);
};
var $author$project$Api$Provider$BrokerDeal$One$rates = function (_v0) {
	var record = _v0.b;
	return record.XM;
};
var $author$project$Api$Provider$BrokerDeal$All$rates = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BrokerDeal$One$rates(one);
};
var $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll = function (brokerDeal) {
	return {
		vJ: $author$project$Api$Provider$BrokerDeal$All$broker(brokerDeal),
		ab9: $author$project$Api$Provider$BrokerDeal$All$company(brokerDeal),
		M1: $author$project$Api$Provider$BrokerDeal$All$dealName(brokerDeal),
		M2: $author$project$Api$Provider$BrokerDeal$All$dealType(brokerDeal),
		qs: $author$project$Api$Provider$BrokerDeal$All$endDate(brokerDeal),
		adR: $author$project$Api$Provider$BrokerDeal$All$id(brokerDeal),
		TU: $author$project$Api$Provider$BrokerDeal$All$meta(brokerDeal),
		XM: $author$project$Api$Provider$BrokerDeal$All$rates(brokerDeal)
	};
};
var $author$project$Components$BrokerDeal$CreateModal$Model = $elm$core$Basics$identity;
var $author$project$Components$BrokerDeal$CreateModal$One = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingStructureSelect$DropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingStructureSelect$GotPricingStructures = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PricingStructure$All$PricingStructure = $elm$core$Basics$identity;
var $author$project$Api$Provider$PricingStructure$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PricingStructure$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PricingStructure$pricingStructuresPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['pricing_structures']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PricingStructure$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PricingStructure$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PricingStructure$pricingStructuresPath));
	});
var $author$project$Components$PricingStructureSelect$init = function (apiClient) {
	return _Utils_Tuple2(
		{
			hm: false,
			lU: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'pricing-structure-dropdown-filter', ahx: $author$project$Components$PricingStructureSelect$DropdownMsg})),
			se: $author$project$Api$Data$Loading
		},
		A2($author$project$Api$Provider$PricingStructure$list, apiClient, $author$project$Components$PricingStructureSelect$GotPricingStructures));
};
var $author$project$Api$Provider$Membership$Shared$id = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, '', record.adR);
};
var $author$project$Api$Provider$Membership$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$id(shared);
};
var $author$project$Api$Provider$Membership$One$owner = function (_v0) {
	var record = _v0.b;
	return record.Vp;
};
var $author$project$Components$BrokerDeal$CreateModal$patientFromShared = function (patient) {
	return {
		adR: $author$project$Api$Provider$Patient$Shared$id(patient),
		TL: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient)
	};
};
var $author$project$Components$BrokerDeal$CreateModal$initFormFields = F4(
	function (dealType, company, membership, broker) {
		var patient = A2(
			$elm$core$Maybe$map,
			$author$project$Components$BrokerDeal$CreateModal$patientFromShared,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Membership$One$owner, membership));
		return _Utils_Tuple2(
			{
				aby: $elm$core$Maybe$Nothing,
				vJ: broker,
				ab9: company,
				M2: dealType,
				xu: $author$project$Utils$Maybe$toBool(
					A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Membership$One$owner, membership)),
				ja: membership,
				yS: A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$id, membership),
				VM: patient,
				W2: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$BrokerDeal$CreateModal$init = F5(
	function (apiClient, session, currentDate, timeZone, options) {
		var company = A2(
			$elm$core$Maybe$map,
			function (a) {
				return $author$project$Components$BrokerDeal$CreateModal$One(a);
			},
			options.ab9);
		var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
		var pricingStructureSelect = _v0.a;
		var pricingStructureSelectCmd = _v0.b;
		var _v1 = A2(
			$author$project$Components$ResourceFilter$Patient$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Patient'});
			});
		var patientResourceFilter = _v1.a;
		var patientResourceFilterCmd = _v1.b;
		var _v2 = A4($author$project$Components$BrokerDeal$CreateModal$initFormFields, options.M2, company, options.ja, options.vJ);
		var fields = _v2.a;
		var fieldsCmd = _v2.b;
		var _v3 = A2(
			$author$project$Components$ResourceFilter$Company$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select an Employer'});
			});
		var companyResourceFilter = _v3.a;
		var companyResourceFilterCmd = _v3.b;
		var _v4 = A3(
			$author$project$Components$ResourceFilter$Broker$init,
			apiClient,
			function (d) {
				return $author$project$Utils$Maybe$toBool(options.vK) ? _Utils_update(
					d,
					{
						vK: options.vK,
						Gg: $elm$core$Maybe$Just(true)
					}) : ($author$project$Utils$Maybe$toBool(options.ja) ? _Utils_update(
					d,
					{
						G2: $elm$core$Maybe$Just(true)
					}) : d);
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a broker'});
			});
		var brokerResourceFilter = _v4.a;
		var brokerResourceFilterCmd = _v4.b;
		return _Utils_Tuple2(
			{
				lf: brokerResourceFilter,
				Lp: options.Lp,
				ab9: company,
				pV: companyResourceFilter,
				cO: currentDate,
				PB: $author$project$Utils$Form$init(fields),
				rU: patientResourceFilter,
				nG: pricingStructureSelect,
				agv: options.agv,
				ZD: session,
				Hz: timeZone,
				o$: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						fieldsCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg, pricingStructureSelectCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg, brokerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg, patientResourceFilterCmd)
					])));
	});
var $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled = function (_v0) {
	var record = _v0;
	return record.agv;
};
var $author$project$Api$Provider$BrokerAccount$One$retailEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled(shared);
};
var $author$project$Components$BrokerDeal$CreateModal$All = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Broker = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$BrokerDealCreated = 2;
var $author$project$Components$BrokerDeal$CreateModal$Closed = 1;
var $author$project$Components$BrokerDeal$CreateModal$CompanyField = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$GotMembership = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$CreateModal$MembershipField = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$CreateModal$MembershipUpdated = 3;
var $author$project$Components$BrokerDeal$CreateModal$None = 0;
var $author$project$Components$BrokerDeal$CreateModal$Patient = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$PricingStructure = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$PricingType$encode = function (pricingType) {
	switch (pricingType.$) {
		case 0:
			return $elm$json$Json$Encode$string('percentage');
		case 1:
			return $elm$json$Json$Encode$string('fixed_amount_in_cents');
		case 2:
			return $elm$json$Json$Encode$string('percentage_and_fixed_amount');
		default:
			return $elm$json$Json$Encode$string('tiered');
	}
};
var $author$project$Api$SplitType$toString = function (splitType) {
	switch (splitType) {
		case 0:
			return 'all_members';
		case 1:
			return 'primary_only';
		default:
			return 'flat';
	}
};
var $author$project$Api$SplitType$encode = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$SplitType$toString);
var $author$project$Api$Provider$BrokerDeal$create = F3(
	function (apiClient, fields, toMsg) {
		var pricingStructure_ = function () {
			var _v0 = fields.W2;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var pricingStructure__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pricing_structure',
						$elm$json$Json$Encode$object(
							$elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v1 = pricingStructure__.adR;
										if (!_v1.$) {
											var string = _v1.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v2 = pricingStructure__.Nx;
										if (!_v2.$) {
											var string = _v2.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'description',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v3 = pricingStructure__.adr;
										if (!_v3.$) {
											var _int = _v3.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'fixed_amount_in_cents',
													$author$project$Currency$encode(_int))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v4 = pricingStructure__.afJ;
										if (!_v4.$) {
											var percentage = _v4.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'percentage',
													$author$project$Percentage$encode(percentage))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v5 = pricingStructure__.ag3;
										if (!_v5.$) {
											var splitType = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'split_type',
													$author$project$Api$SplitType$encode(splitType))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v6 = pricingStructure__.afX;
										if (!_v6.$) {
											var pricingType_ = _v6.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'pricing_type',
													$author$project$Api$PricingType$encode(pricingType_))
												]);
										} else {
											return _List_Nil;
										}
									}()
									]))))
					]);
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_deal',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'bill_from',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aby)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'company',
									A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ab9)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'membership',
										A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ja)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'broker',
											A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.vJ)),
										pricingStructure_))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDeal$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDeal$brokerDealsPath)));
	});
var $author$project$Components$BrokerDeal$CreateModal$createBrokerDeal = F2(
	function (apiClient, validFormFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var companyId = function (company_) {
			if (!company_.$) {
				var company = company_.a;
				return $author$project$Api$Provider$Company$One$id(company);
			} else {
				var company = company_.a;
				return $author$project$Api$Provider$Company$All$id(company);
			}
		};
		return A3(
			$author$project$Api$Provider$BrokerDeal$create,
			apiClient,
			{
				aby: fields.aby,
				vJ: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, fields.vJ),
				ab9: A2($elm$core$Maybe$map, companyId, fields.ab9),
				ja: A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$id, fields.ja),
				W2: fields.W2
			},
			$author$project$Components$BrokerDeal$CreateModal$Created);
	});
var $author$project$Components$BrokerDeal$CreateModal$Updated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$One$Membership = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Membership$Shared$Membership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Shared$Record = function (id) {
	return function (isSponsored) {
		return function (startDate) {
			return function (endDate) {
				return function (isConfirmed) {
					return function (isUpdatable) {
						return function (isRestartable) {
							return function (billDate) {
								return function (nextBillDate) {
									return function (billFromDate) {
										return function (fixedPeriodRateInCents) {
											return function (fixedRegistrationFeeInCents) {
												return function (minimumEnrollmentPeriodInMonths) {
													return function (minimumEnrollmentStartDate) {
														return function (minimumEnrollmentEndDate) {
															return function (contractType) {
																return function (contractExpires) {
																	return function (contractEndDate) {
																		return function (billsAtEndOfPeriod) {
																			return function (billingStartDate) {
																				return function (endDateFarInThePast) {
																					return {vG: billDate, JX: billFromDate, J$: billingStartDate, J0: billsAtEndOfPeriod, wO: contractEndDate, LP: contractExpires, EI: contractType, qs: endDate, Oy: endDateFarInThePast, Pw: fixedPeriodRateInCents, Px: fixedRegistrationFeeInCents, adR: id, RD: isConfirmed, R6: isRestartable, R7: isSponsored, Sf: isUpdatable, T2: minimumEnrollmentEndDate, T3: minimumEnrollmentPeriodInMonths, T4: minimumEnrollmentStartDate, UC: nextBillDate, _E: startDate};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Membership$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date_far_in_the_past',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bills_at_end_of_period',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'contract_end_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contract_expires',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contract_type',
						$elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'minimum_enrollment_end_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'minimum_enrollment_start_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'minimum_enrollment_period_in_months',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'fixed_registration_fee_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'fixed_period_rate_in_cents',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'bill_from_date',
												$author$project$Utils$Date$decode,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'next_bill_date',
													$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'bill_date',
														$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'is_restartable',
															$elm$json$Json$Decode$bool,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'is_updatable',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'is_confirmed',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'end_date',
																		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'start_date',
																			$author$project$Utils$Date$decode,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'is_sponsored',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'id',
																					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Shared$Record))))))))))))))))))))));
var $author$project$Api$Provider$Membership$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$One$Record = function (status) {
	return function (plan) {
		return function (membershipPatients) {
			return function (billedThroughDate) {
				return function (periodInMonths) {
					return function (periodRateInCents) {
						return function (isDestroyable) {
							return function (isCancellable) {
								return function (isConfirmable) {
									return function (shouldBeBilledUpToDate) {
										return function (autoRenew) {
											return function (revenueInCents) {
												return function (contractPeriodInMonths) {
													return function (finalBillingEndDate) {
														return function (neverBeenBilled) {
															return function (isSynced) {
																return function (owner) {
																	return function (upcomingAndOutstandingBills) {
																		return function (prepayOptions) {
																			return function (company) {
																				return function (companyAccount) {
																					return function (coupon) {
																						return function (brokerDeals) {
																							return function (cancellationReason) {
																								return function (cancellationReasonOther) {
																									return function (scheduledChange) {
																										return function (firstContract) {
																											return function (lastContract) {
																												return function (recurringCharges) {
																													return function (meta) {
																														return function (createdAt) {
																															return function (source) {
																																return {JH: autoRenew, JY: billedThroughDate, J9: brokerDeals, abM: cancellationReason, abN: cancellationReasonOther, ab9: company, Lr: companyAccount, LQ: contractPeriodInMonths, L1: coupon, Mf: createdAt, Pp: finalBillingEndDate, Pt: firstContract, RB: isCancellable, RC: isConfirmable, RJ: isDestroyable, Sa: isSynced, Sw: lastContract, TF: membershipPatients, TU: meta, Uu: neverBeenBilled, Vp: owner, Wc: periodInMonths, Wd: periodRateInCents, GH: plan, WY: prepayOptions, XZ: recurringCharges, YF: revenueInCents, Y7: scheduledChange, ZO: shouldBeBilledUpToDate, Hg: source, ag7: status, aan: upcomingAndOutstandingBills};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Membership$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Meta$Record = function (actions) {
	return function (owner) {
		return function (plan) {
			return function (startDate) {
				return function (billDate) {
					return function (nextBillDate) {
						return function (autoRenew) {
							return function (periodInMonths) {
								return function (minimumEnrollmentPeriodInMonths) {
									return function (membershipPatients) {
										return function (endDate) {
											return function (coupon) {
												return function (fixedRegistrationFeeInCents) {
													return function (fixedPeriodRateInCents) {
														return function (contractExpires) {
															return function (contractEndDate) {
																return function (contractPeriodInMonths) {
																	return function (contractType) {
																		return function (membershipScheduledChange) {
																			return function (membershipPatientsMaxCount) {
																				return function (recurringCharges) {
																					return function (paymentSource) {
																						return {tF: actions, JH: autoRenew, vG: billDate, wO: contractEndDate, LP: contractExpires, LQ: contractPeriodInMonths, EI: contractType, L1: coupon, qs: endDate, Pw: fixedPeriodRateInCents, Px: fixedRegistrationFeeInCents, TF: membershipPatients, TG: membershipPatientsMaxCount, TJ: membershipScheduledChange, T3: minimumEnrollmentPeriodInMonths, UC: nextBillDate, Vp: owner, V3: paymentSource, Wc: periodInMonths, GH: plan, XZ: recurringCharges, _E: startDate};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Membership$Meta$ActionsRecord = function (invoiceNow) {
	return {Rp: invoiceNow};
};
var $author$project$Api$Provider$Membership$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice_now',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ActionsRecord));
var $author$project$Api$Provider$Membership$Meta$BillDateRecord = F3(
	function (editable, min, values) {
		return {Oa: editable, TZ: min, o9: values};
	});
var $author$project$Api$Provider$Membership$Meta$billDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($author$project$Utils$Date$decode)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'editable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$BillDateRecord))));
var $author$project$Api$Provider$Membership$Meta$ContractEndDateRecord = F3(
	function (editable, _default, values) {
		return {M5: _default, Oa: editable, o9: values};
	});
var $author$project$Api$Provider$Membership$Meta$contractEndDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'default',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'editable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ContractEndDateRecord))));
var $author$project$Api$Provider$Membership$Meta$ContractTypeRecord = F2(
	function (editable, values) {
		return {Oa: editable, o9: values};
	});
var $author$project$Api$Provider$Membership$Meta$contractTypeRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$elm$json$Json$Decode$list($author$project$Api$ContractType$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'editable',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ContractTypeRecord)));
var $author$project$Api$Provider$Membership$Meta$EditableRecord = function (editable) {
	return {Oa: editable};
};
var $author$project$Api$Provider$Membership$Meta$editableRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'editable',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$EditableRecord));
var $author$project$Api$Provider$Membership$Meta$EndDateRecord = F5(
	function (sponsoredMinWithoutProration, sponsoredMaxWithoutBilling, sponsoredMin, defaultValue, retailValues) {
		return {Nm: defaultValue, YD: retailValues, _z: sponsoredMaxWithoutBilling, _A: sponsoredMin, _B: sponsoredMinWithoutProration};
	});
var $author$project$Api$Provider$Membership$Meta$endDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'retail_values',
	$elm$json$Json$Decode$list($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'default_value',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sponsored_min',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsored_max_without_billing',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'sponsored_min_without_proration',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$EndDateRecord))))));
var $author$project$Api$Provider$Membership$Meta$MembershipPatientsRecord = F5(
	function (patient, enrollmentRequestedOn, startDate, specialRate, fixedPeriodRateInCents) {
		return {OH: enrollmentRequestedOn, Pw: fixedPeriodRateInCents, VM: patient, _n: specialRate, _E: startDate};
	});
var $author$project$Api$Provider$Membership$Meta$membershipPatientsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'fixed_period_rate_in_cents',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'special_rate',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_date',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enrollment_requested_on',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patient',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$MembershipPatientsRecord))))));
var $author$project$Api$Provider$Membership$Meta$NextBillDateRecord = F3(
	function (editable, min, max) {
		return {Oa: editable, yQ: max, TZ: min};
	});
var $author$project$Api$Provider$Membership$Meta$nextBillDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'max',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'editable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$NextBillDateRecord))));
var $author$project$Api$Provider$Membership$Meta$StartDateRecord = F3(
	function (editable, min, max) {
		return {Oa: editable, yQ: max, TZ: min};
	});
var $author$project$Api$Provider$Membership$Meta$startDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'max',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'editable',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$StartDateRecord))));
var $author$project$Api$Provider$Membership$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payment_source',
	$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'recurring_charges',
		$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['membership_patients', 'max_count']),
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membership_scheduled_change',
				$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contract_type',
					$author$project$Api$Provider$Membership$Meta$contractTypeRecordDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'contract_period_in_months',
						$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'contract_end_date',
							$author$project$Api$Provider$Membership$Meta$contractEndDateRecordDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'contract_expires',
								$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fixed_period_rate_in_cents',
									$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'fixed_registration_fee_in_cents',
										$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'coupon',
											$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'end_date',
												$author$project$Api$Provider$Membership$Meta$endDateRecordDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'membership_patients',
													$author$project$Api$Provider$Membership$Meta$membershipPatientsRecordDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'minimum_enrollment_period_in_months',
														$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'period_in_months',
															$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'auto_renew',
																$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'next_bill_date',
																	$author$project$Api$Provider$Membership$Meta$nextBillDateRecordDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'bill_date',
																		$author$project$Api$Provider$Membership$Meta$billDateRecordDecoder,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'start_date',
																			$author$project$Api$Provider$Membership$Meta$startDateRecordDecoder,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'plan',
																				$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'owner',
																					$author$project$Api$Provider$Membership$Meta$editableRecordDecoder,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'actions',
																						$author$project$Api$Provider$Membership$Meta$actionsRecordDecoder,
																						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$Record)))))))))))))))))))))));
var $author$project$Api$Provider$Membership$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$Source$Record = function (id) {
	return function (type_) {
		return function (name) {
			return function (lastFour) {
				return function (status) {
					return function (funding) {
						return function (expMonth) {
							return function (expYear) {
								return function (zip) {
									return function (paymentProcessor) {
										return {ac9: expMonth, ada: expYear, PK: funding, adR: id, Sz: lastFour, zh: name, V0: paymentProcessor, ag7: status, ahI: type_, tC: zip};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Membership$Source$Source = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Source$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'zip',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'exp_year',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'exp_month',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'funding',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'status',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'last_four',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'type',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Source$Record))))))))))));
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$MembershipBill = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipBill$Shared$MembershipBill = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipBill$Shared$Record = F8(
	function (startDate, date, amountInCents, registrationFeeInCents, couponDiscountInCents, membershipAmountInCents, periodInMonths, couponDiscountMonths) {
		return {I2: amountInCents, L2: couponDiscountInCents, L3: couponDiscountMonths, MO: date, TD: membershipAmountInCents, Wc: periodInMonths, X5: registrationFeeInCents, _E: startDate};
	});
var $author$project$Api$Provider$MembershipBill$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'coupon_discount_months',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'period_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'membership_amount_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'coupon_discount_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'registration_fee_in_cents',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'start_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$Shared$Record)))))))));
var $author$project$Api$Provider$MembershipBill$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipBill$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$Record = F2(
	function (invoice, charges) {
		return {KU: charges, Rh: invoice};
	});
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$MembershipBillCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$Record = F3(
	function (amountInCents, name, quantity) {
		return {I2: amountInCents, zh: name, Bd: quantity};
	});
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'quantity',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'amount_in_cents',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$Record))));
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'charges',
	$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invoice',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipOne$Record)));
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipBill$ForMembershipOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$MembershipBill$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipOne$MembershipBill)));
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$MembershipBill = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$Record = function (periodInMonths) {
	return {Wc: periodInMonths};
};
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'period_in_months',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$Record));
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipContract$Shared$MembershipContract = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipContract$Shared$Record = F4(
	function (startDate, endDate, memo, isUpcoming) {
		return {qs: endDate, Se: isUpcoming, aeC: memo, _E: startDate};
	});
var $author$project$Api$Provider$MembershipContract$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_upcoming',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'memo',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$author$project$Utils$Date$decode,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipContract$Shared$Record)))));
var $author$project$Api$Provider$MembershipContract$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipContract$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$MembershipPatient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipPatient$Shared$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipPatient$Shared$Record = F8(
	function (id, startDate, endDate, effectiveEndDate, enrollmentRequestedOn, firstBillStartDate, status, membership) {
		return {Oe: effectiveEndDate, qs: endDate, OH: enrollmentRequestedOn, Ps: firstBillStartDate, adR: id, ja: membership, _E: startDate, ag7: status};
	});
var $author$project$Api$Provider$MembershipPatient$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership',
	$author$project$Api$Provider$Membership$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'first_bill_start_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enrollment_requested_on',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'effective_end_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'end_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'start_date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$Shared$Record)))))))));
var $author$project$Api$Provider$MembershipPatient$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$Record = function (revenueInCents) {
	return function (fixedPeriodRateInCents) {
		return function (memberType) {
			return function (patient) {
				return function (companyRegistration) {
					return function (cancellationReason) {
						return function (cancellationReasonOther) {
							return function (specialRate) {
								return function (rateRule) {
									return function (discountRule) {
										return {abM: cancellationReason, abN: cancellationReasonOther, Ly: companyRegistration, NK: discountRule, Pw: fixedPeriodRateInCents, TB: memberType, VM: patient, XL: rateRule, YF: revenueInCents, _n: specialRate};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$MemberRelationship$Child = 2;
var $author$project$Api$MemberRelationship$Employee = 0;
var $author$project$Api$MemberRelationship$Other = 3;
var $author$project$Api$MemberRelationship$Spouse = 1;
var $author$project$Api$MemberRelationship$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'employee':
				return $elm$json$Json$Decode$succeed(0);
			case 'spouse':
				return $elm$json$Json$Decode$succeed(1);
			case 'child':
				return $elm$json$Json$Decode$succeed(2);
			case 'other':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unsupported member relationship: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$CompanyRegistration$Meta$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyRegistration$Meta$Record = function (meta) {
	return {TU: meta};
};
var $author$project$Api$Provider$CompanyRegistration$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Provider$Meta$CompanyRegistration$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$Meta$Record));
var $author$project$Api$Provider$CompanyRegistration$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$DiscountRule$Min$DiscountRule = $elm$core$Basics$identity;
var $author$project$Api$Provider$DiscountRule$Min$Record = function (name) {
	return {zh: name};
};
var $author$project$Api$Provider$DiscountRule$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$DiscountRule$Min$Record));
var $author$project$Api$Provider$DiscountRule$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$DiscountRule$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SpecialRate$Min$SpecialRate = $elm$core$Basics$identity;
var $author$project$Api$Provider$SpecialRate$Min$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$SpecialRate$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$SpecialRate$Min$Record));
var $author$project$Api$Provider$SpecialRate$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SpecialRate$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'discount_rule',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rate_rule',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'special_rate',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$SpecialRate$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cancellation_reason_other',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'cancellation_reason',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$CancellationReason$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'company_registration',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyRegistration$Meta$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'patient',
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'member_type',
								$author$project$Api$MemberRelationship$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fixed_period_rate_in_cents',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'revenue_in_cents',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForMembershipOne$Record)))))))))));
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$ForMembershipOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$MembershipPatient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForMembershipOne$MembershipPatient)));
var $author$project$Api$Provider$MembershipScheduledChange$Shared$MembershipScheduledChange = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipScheduledChange$Shared$Record = F6(
	function (type_, id, effectiveDate, changeAfterMonths, changeOnDate, toPlan) {
		return {KN: changeAfterMonths, KO: changeOnDate, Od: effectiveDate, adR: id, $J: toPlan, ahI: type_};
	});
var $author$project$Api$Provider$MembershipScheduledChange$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'change_on_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'change_after_months',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'effective_date',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$author$project$Api$Provider$MembershipScheduledChange$Type$decoder,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipScheduledChange$Shared$Record)))))));
var $author$project$Api$Provider$MembershipScheduledChange$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipScheduledChange$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Plan$SharedWithContractInfo$Plan = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Plan$SharedWithContractInfo$Record = F3(
	function (contractExpires, contractPeriodInMonths, contractType) {
		return {LP: contractExpires, LQ: contractPeriodInMonths, EI: contractType};
	});
var $author$project$Api$Provider$Plan$SharedWithContractInfo$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contract_type',
	$elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'contract_period_in_months',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'contract_expires',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$SharedWithContractInfo$Record))));
var $author$project$Api$Provider$Plan$SharedWithContractInfo$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Plan$SharedWithContractInfo$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Plan$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$SharedWithContractInfo$Plan)));
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$RecurringCharge = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$RecurringCharge$Shared$RecurringCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$RecurringCharge$Shared$Record = function (id) {
	return function (name) {
		return function (periodsMax) {
			return function (periodInMonths) {
				return function (periodsRemaining) {
					return function (quantity) {
						return function (fixedDescription) {
							return function (fixedPriceInCents) {
								return function (startDate) {
									return function (nextBillDate) {
										return {ads: fixedDescription, adt: fixedPriceInCents, adR: id, zh: name, UC: nextBillDate, Wc: periodInMonths, We: periodsMax, afL: periodsRemaining, Bd: quantity, _E: startDate};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$RecurringCharge$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'next_bill_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start_date',
		$author$project$Utils$Date$decode,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fixed_price_in_cents',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fixed_description',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quantity',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'periods_remaining',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'period_in_months',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'periods_max',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										$elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$Shared$Record)))))))))));
var $author$project$Api$Provider$RecurringCharge$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RecurringCharge$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$Record = F4(
	function (patient, chargeItem, practitioner, uom) {
		return {lp: chargeItem, VM: patient, afS: practitioner, aam: uom};
	});
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$ChargeItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$Record = F2(
	function (description, priceInCents) {
		return {Nx: description, Ba: priceInCents};
	});
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'price_in_cents',
	$elm$json$Json$Decode$float,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForRecurringCharge$Record)));
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeItem$ForRecurringCharge$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeItem$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForRecurringCharge$ChargeItem)));
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uom',
	$author$project$Api$Provider$Uom$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge_item',
			$author$project$Api$Provider$ChargeItem$ForRecurringCharge$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patient',
				$author$project$Api$Provider$Patient$Min$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$ForMembershipOne$Record)))));
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$RecurringCharge$ForMembershipOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$RecurringCharge$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$ForMembershipOne$RecurringCharge)));
var $author$project$Api$Provider$Membership$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'source',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Membership$Source$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'meta',
			$author$project$Api$Provider$Membership$Meta$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'recurring_charges',
				$elm$json$Json$Decode$list($author$project$Api$Provider$RecurringCharge$ForMembershipOne$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'last_contract',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipContract$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'first_contract',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipContract$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'scheduled_change',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipScheduledChange$Shared$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'cancellation_reason_other',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'cancellation_reason',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$CancellationReason$Shared$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'broker_deals',
										$elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDeal$One$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'coupon',
											$elm$json$Json$Decode$nullable($author$project$Api$Common$Coupon$Shared$decode),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'company_account',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$Shared$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'company',
													$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Shared$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'prepay_options',
														$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'upcoming_and_outstanding_bills',
															$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBill$ForMembershipOne$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'owner',
																$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'is_synced',
																	$elm$json$Json$Decode$bool,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'never_been_billed',
																		$elm$json$Json$Decode$bool,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'final_billing_end_date',
																			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'contract_period_in_months',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'revenue_in_cents',
																					$elm$json$Json$Decode$int,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'auto_renew',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'should_be_billed_up_to_date',
																							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'is_confirmable',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'is_cancellable',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'is_destroyable',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'period_rate_in_cents',
																											$elm$json$Json$Decode$int,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'period_in_months',
																												$elm$json$Json$Decode$int,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'billed_through_date',
																													$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'membership_patients',
																														$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForMembershipOne$decoder),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'plan',
																															$author$project$Api$Provider$Plan$SharedWithContractInfo$decoder,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'status',
																																$elm$json$Json$Decode$string,
																																$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$One$Record)))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Membership$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Membership$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Membership$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$One$Membership)));
var $author$project$Api$Provider$Membership$membershipsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['memberships']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Membership$membershipPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$Membership$membershipsPath);
};
var $author$project$Api$Provider$Membership$addBrokerDeal = F4(
	function (apiClient, id, brokerDeals, toMsg) {
		var encodeBrokerDeal = function (brokerDeal) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, brokerDeal.adR)),
						_Utils_Tuple2(
						'bill_from',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, brokerDeal.aby)),
						_Utils_Tuple2(
						'broker',
						A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, brokerDeal.vJ))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'broker_deals',
								A2($elm$json$Json$Encode$list, encodeBrokerDeal, brokerDeals))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Membership$membershipPath(id))));
	});
var $author$project$Api$Provider$Membership$One$brokerDeals = function (_v0) {
	var record = _v0.b;
	return record.J9;
};
var $author$project$Components$BrokerDeal$CreateModal$updateMembership = F3(
	function (apiClient, membership, validFormFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var brokerDeals = _Utils_ap(
			A2(
				$elm$core$List$map,
				function (brokerDeal) {
					return {
						aby: $elm$core$Maybe$Nothing,
						vJ: $elm$core$Maybe$Just(
							$author$project$Api$Provider$Broker$Shared$id(
								$author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal))),
						adR: $elm$core$Maybe$Just(
							$author$project$Api$Provider$BrokerDeal$One$id(brokerDeal))
					};
				},
				$author$project$Api$Provider$Membership$One$brokerDeals(membership)),
			_List_fromArray(
				[
					{
					aby: fields.aby,
					vJ: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, fields.vJ),
					adR: $elm$core$Maybe$Nothing
				}
				]));
		return A4(
			$author$project$Api$Provider$Membership$addBrokerDeal,
			apiClient,
			$author$project$Api$Provider$Membership$One$id(membership),
			brokerDeals,
			$author$project$Components$BrokerDeal$CreateModal$Updated);
	});
var $author$project$Components$BrokerDeal$CreateModal$create = F2(
	function (apiClient, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var dealType = _v0.M2;
		var membership = _v0.ja;
		var _v1 = _Utils_Tuple2(dealType, membership);
		if (!_v1.a) {
			var _v2 = _v1.a;
			return A2($author$project$Components$BrokerDeal$CreateModal$createBrokerDeal, apiClient, validFormFields);
		} else {
			if (!_v1.b.$) {
				var _v3 = _v1.a;
				var membership_ = _v1.b.a;
				return A3($author$project$Components$BrokerDeal$CreateModal$updateMembership, apiClient, membership_, validFormFields);
			} else {
				var _v4 = _v1.a;
				var _v5 = _v1.b;
				return $elm$core$Platform$Cmd$none;
			}
		}
	});
var $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var pricingStructure = field.a;
				return _Utils_update(
					fields,
					{W2: pricingStructure});
			case 1:
				var dealType = field.a;
				return _Utils_update(
					fields,
					{M2: dealType});
			case 2:
				var company = field.a;
				return _Utils_update(
					fields,
					{ab9: company});
			case 3:
				var broker = field.a;
				return _Utils_update(
					fields,
					{vJ: broker});
			case 4:
				var patient = field.a;
				return _Utils_update(
					fields,
					{VM: patient});
			case 5:
				var membershipId = field.a;
				var membership = field.b;
				return _Utils_update(
					fields,
					{ja: membership, yS: membershipId});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aby: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$BrokerDeal$CreateModal$BrokerValidation = 2;
var $author$project$Components$BrokerDeal$CreateModal$CompanyValidation = 1;
var $author$project$Components$BrokerDeal$CreateModal$validateCompany = function (fields) {
	var _v0 = _Utils_Tuple2(fields.M2, fields.ab9);
	if (!_v0.a) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please select an employer.')
				]);
		} else {
			var _v3 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$BrokerDeal$CreateModal$MembershipValidation = 3;
var $author$project$Api$Provider$Membership$Shared$isSponsored = function (_v0) {
	var record = _v0;
	return record.R7;
};
var $author$project$Api$Provider$Membership$One$isSponsored = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$isSponsored(shared);
};
var $author$project$Components$BrokerDeal$CreateModal$validateMembership = function (fields) {
	var _v0 = _Utils_Tuple2(fields.M2, fields.ja);
	if (_v0.a === 1) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var membership = _v0.b.a;
			return $author$project$Api$Provider$Membership$One$isSponsored(membership) ? _List_fromArray(
				[
					_Utils_Tuple2(3, 'This is an employer sponsored membership that is not eligible for retail commission tracking. You can assign a broker to an employer by changing the category above to \"Employer\".')
				]) : _List_Nil;
		} else {
			var _v2 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v3 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$BrokerDeal$CreateModal$PatientValidation = 4;
var $author$project$Components$BrokerDeal$CreateModal$validatePatient = function (fields) {
	var _v0 = _Utils_Tuple2(fields.M2, fields.VM);
	if (_v0.a === 1) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(4, 'Please select a patient.')
				]);
		} else {
			var _v3 = _v0.a;
			var patient = _v0.b.a;
			return (patient.TL === 'inactive') ? _List_fromArray(
				[
					_Utils_Tuple2(4, 'Inactive membership (You can\'t assign broker to this patient).')
				]) : _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$BrokerDeal$CreateModal$PricingStructureValidation = 0;
var $author$project$Components$BrokerDeal$CreateModal$validatePricingStructure = function (fields) {
	var _v0 = _Utils_Tuple2(fields.M2, fields.W2);
	if (!_v0.a) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please select a broker commission rate.')
				]);
		} else {
			var _v3 = _v0.a;
			return _List_Nil;
		}
	} else {
		var _v4 = _v0.a;
		return _List_Nil;
	}
};
var $author$project$Components$BrokerDeal$CreateModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validatePatient),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validateMembership),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.vJ;
			},
			_Utils_Tuple2(2, 'Please select a broker.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validateCompany),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validatePricingStructure)
		]));
var $author$project$Api$Provider$Membership$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$membership = function (_v0) {
	var record = _v0;
	return record.ja;
};
var $author$project$Api$Provider$Patient$All$membershipPatients = function (_v0) {
	var record = _v0.b;
	return record.TF;
};
var $author$project$Components$BrokerDeal$CreateModal$patientFromAll = function (patient) {
	return {
		adR: $author$project$Api$Provider$Patient$All$id(patient),
		TL: $author$project$Api$Provider$Patient$All$membershipStatus(patient)
	};
};
var $author$project$Api$Provider$Membership$expandToString = function (expand) {
	return 'coverage_plan';
};
var $author$project$Api$Provider$Membership$retrieve = F4(
	function (apiClient, id_, expand, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Membership$membershipPath(id_))));
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Components$PricingStructureSelect$None = {$: 0};
var $author$project$Components$PricingStructureSelect$Selected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PricingStructure$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$PricingStructure$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$description(shared);
};
var $author$project$Api$Provider$PricingStructure$All$fixedAmountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(shared);
};
var $author$project$Api$Provider$PricingStructure$All$percentage = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$percentage(shared);
};
var $author$project$Api$Provider$PricingStructure$All$pricingType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$pricingType(shared);
};
var $author$project$Api$Provider$PricingStructure$Shared$splitType = function (_v0) {
	var record = _v0;
	return record.ag3;
};
var $author$project$Api$Provider$PricingStructure$All$splitType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$splitType(shared);
};
var $author$project$Components$PricingStructureSelect$existingPricingStructure = F2(
	function (pricingStructure, id) {
		return {
			Nx: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$description, pricingStructure),
			adr: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$fixedAmountInCents, pricingStructure)),
			adR: id,
			afJ: A2(
				$elm$core$Maybe$map,
				$author$project$Percentage$fromFloat,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$percentage, pricingStructure)),
			afX: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$pricingType, pricingStructure),
			ag3: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$splitType, pricingStructure)
		};
	});
var $author$project$Api$Provider$PricingStructure$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PricingStructure$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PricingStructure$Shared$id(shared);
};
var $author$project$Components$PricingStructureSelect$newPricingStructure = {
	Nx: $elm$core$Maybe$Nothing,
	adr: $elm$core$Maybe$Nothing,
	adR: $elm$core$Maybe$Nothing,
	afJ: $elm$core$Maybe$Nothing,
	afX: $elm$core$Maybe$Just($author$project$Api$PricingType$Percentage),
	ag3: $elm$core$Maybe$Just(0)
};
var $author$project$Components$PricingStructureSelect$updateNewPricingStructureField = F2(
	function (pricingStructure, field) {
		switch (field.$) {
			case 0:
				var pricingType = field.a;
				return _Utils_update(
					pricingStructure,
					{
						afX: $elm$core$Maybe$Just(pricingType)
					});
			case 1:
				var splitType = field.a;
				return _Utils_update(
					pricingStructure,
					{
						ag3: $elm$core$Maybe$Just(splitType)
					});
			case 2:
				var _int = field.a;
				return _Utils_update(
					pricingStructure,
					{adr: _int});
			default:
				var _float = field.a;
				return _Utils_update(
					pricingStructure,
					{afJ: _float});
		}
	});
var $author$project$Components$PricingStructureSelect$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lU);
				var dropdownFilter = _v1.a;
				var cmd = _v1.b;
				return {
					EC: cmd,
					ac5: $author$project$Components$PricingStructureSelect$None,
					y8: _Utils_update(
						model,
						{lU: dropdownFilter}),
					as: _List_Nil
				};
			case 1:
				var pricingStructureId = msg.a;
				var _v2 = function () {
					if (_Utils_eq(
						pricingStructureId,
						$elm$core$Maybe$Just(''))) {
						return _Utils_Tuple2(
							true,
							$author$project$Components$PricingStructureSelect$Selected(
								$elm$core$Maybe$Just($author$project$Components$PricingStructureSelect$newPricingStructure)));
					} else {
						var pricingStructure = A2(
							$elm_community$list_extra$List$Extra$find,
							function (item) {
								return _Utils_eq(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$PricingStructure$All$id(item)),
									pricingStructureId);
							},
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(model.se)));
						return _Utils_Tuple2(
							false,
							$author$project$Components$PricingStructureSelect$Selected(
								$elm$core$Maybe$Just(
									A2($author$project$Components$PricingStructureSelect$existingPricingStructure, pricingStructure, pricingStructureId))));
					}
				}();
				var addingNew = _v2.a;
				var event = _v2.b;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: event,
					y8: _Utils_update(
						model,
						{hm: addingNew}),
					as: _List_Nil
				};
			case 2:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PricingStructureSelect$None,
					y8: _Utils_update(
						model,
						{se: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			default:
				var pricingStructure = msg.a;
				var field = msg.b;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PricingStructureSelect$Selected(
						$elm$core$Maybe$Just(
							A2($author$project$Components$PricingStructureSelect$updateNewPricingStructureField, pricingStructure, field))),
					y8: model,
					as: _List_Nil
				};
		}
	});
var $author$project$Components$BrokerDeal$CreateModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$BrokerDeal$CreateModal$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					return {
						EC: A2($author$project$Components$BrokerDeal$CreateModal$create, apiClient, validFormFields),
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm, o$: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker commission successfully created')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 3,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker commission successfully created')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var subMsg = msg.a;
				var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.nG);
				var form = function () {
					var _v6 = pricingStructureSelectResult.ac5;
					if (!_v6.$) {
						return model.PB;
					} else {
						var pricingStructure = _v6.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
							$author$project$Components$BrokerDeal$CreateModal$PricingStructure(pricingStructure),
							model.PB);
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg, pricingStructureSelectResult.EC),
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: form, nG: pricingStructureSelectResult.y8}),
					as: pricingStructureSelectResult.as
				};
			case 5:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 6:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pV);
				var newForm = function () {
					var _v7 = companyResourceResult.ac5;
					_v7$2:
					while (true) {
						if ((!_v7.$) && (!_v7.a.$)) {
							switch (_v7.a.a.$) {
								case 0:
									var company = _v7.a.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$CompanyField(
											$elm$core$Maybe$Just(
												$author$project$Components$BrokerDeal$CreateModal$All(company))),
										model.PB);
								case 2:
									var _v8 = _v7.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$CompanyField($elm$core$Maybe$Nothing),
										model.PB);
								default:
									break _v7$2;
							}
						} else {
							break _v7$2;
						}
					}
					return model.PB;
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg, companyResourceResult.EC),
					ac5: 0,
					y8: _Utils_update(
						model,
						{pV: companyResourceResult.y8, PB: newForm}),
					as: companyResourceResult.as
				};
			case 7:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.lf);
				var newForm = function () {
					var _v9 = brokerResourceResult.ac5;
					_v9$2:
					while (true) {
						if ((!_v9.$) && (!_v9.a.$)) {
							switch (_v9.a.a.$) {
								case 0:
									var broker = _v9.a.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$Broker(
											$elm$core$Maybe$Just(broker)),
										model.PB);
								case 2:
									var _v10 = _v9.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$Broker($elm$core$Maybe$Nothing),
										model.PB);
								default:
									break _v9$2;
							}
						} else {
							break _v9$2;
						}
					}
					return model.PB;
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg, brokerResourceResult.EC),
					ac5: 0,
					y8: _Utils_update(
						model,
						{lf: brokerResourceResult.y8, PB: newForm}),
					as: brokerResourceResult.as
				};
			case 8:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rU);
				var _v11 = function () {
					var _v12 = patientResourceResult.ac5;
					_v12$2:
					while (true) {
						if ((!_v12.$) && (!_v12.a.$)) {
							switch (_v12.a.a.$) {
								case 0:
									var patient = _v12.a.a.a;
									var newForm_ = A3(
										$author$project$Utils$Form$update,
										$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
										$author$project$Components$BrokerDeal$CreateModal$Patient(
											$elm$core$Maybe$Just(
												$author$project$Components$BrokerDeal$CreateModal$patientFromAll(patient))),
										model.PB);
									var membershipPatients = $author$project$Api$Provider$Patient$All$membershipPatients(patient);
									var membershipId = A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Membership$Min$id,
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$MembershipPatient$ForPatientAll$membership,
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (membershipPatient_) {
													return _Utils_eq(
														$author$project$Api$Provider$MembershipPatient$ForPatientAll$status(membershipPatient_),
														$author$project$Api$Provider$Patient$All$membershipStatus(patient));
												},
												membershipPatients)));
									return _Utils_Tuple2(
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
											A2($author$project$Components$BrokerDeal$CreateModal$MembershipField, membershipId, $elm$core$Maybe$Nothing),
											newForm_),
										function () {
											if (!membershipId.$) {
												var id = membershipId.a;
												return A4(
													$author$project$Api$Provider$Membership$retrieve,
													apiClient,
													id,
													_List_Nil,
													$author$project$Components$BrokerDeal$CreateModal$GotMembership(id));
											} else {
												return $elm$core$Platform$Cmd$none;
											}
										}());
								case 2:
									var _v14 = _v12.a.a;
									return _Utils_Tuple2(
										A3(
											$author$project$Utils$Form$update,
											$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
											A2($author$project$Components$BrokerDeal$CreateModal$MembershipField, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
											A3(
												$author$project$Utils$Form$update,
												$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
												$author$project$Components$BrokerDeal$CreateModal$Patient($elm$core$Maybe$Nothing),
												model.PB)),
										$elm$core$Platform$Cmd$none);
								default:
									break _v12$2;
							}
						} else {
							break _v12$2;
						}
					}
					return _Utils_Tuple2(model.PB, $elm$core$Platform$Cmd$none);
				}();
				var newForm = _v11.a;
				var cmd = _v11.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg, patientResourceResult.EC),
								cmd
							])),
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm, rU: patientResourceResult.y8}),
					as: patientResourceResult.as
				};
			default:
				var membershipId = msg.a;
				var response = msg.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate,
					A2(
						$author$project$Components$BrokerDeal$CreateModal$MembershipField,
						$elm$core$Maybe$Just(membershipId),
						$author$project$Api$Data$toMaybe(response)),
					model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
		}
	});
var $author$project$Components$BrokerDeal$Table$BrokerDealDeleted = 1;
var $author$project$Components$BrokerDeal$Table$BrokerDealEnded = 3;
var $author$project$Components$BrokerDeal$Table$BrokerDealRateCanceled = 4;
var $author$project$Components$BrokerDeal$Table$BrokerDealRateCreated = 5;
var $author$project$Components$BrokerDeal$Table$BrokerDealRateUpdated = 6;
var $author$project$Components$BrokerDeal$Table$BrokerDealRestarted = 2;
var $author$project$Components$BrokerDeal$Table$None = 0;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealDeleted = 1;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealEnded = 3;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateCanceled = 4;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateCreated = 5;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateUpdated = 6;
var $author$project$Components$BrokerDeal$Timeline$BrokerDealRestarted = 2;
var $author$project$Components$BrokerDeal$Timeline$Canceled = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$Timeline$Deleted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$None = 0;
var $author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['broker_deal_rates']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$BrokerDealRate$brokerDealRatePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath);
};
var $author$project$Api$Provider$BrokerDealRate$One$BrokerDealRate = 0;
var $author$project$Api$Provider$BrokerDealRate$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$BrokerDealRate$cancel = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDealRate$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Provider$BrokerDealRate$brokerDealRatePath(id_))));
	});
var $author$project$Api$Provider$BrokerDeal$brokerDealPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$BrokerDeal$brokerDealsPath);
};
var $author$project$Api$Provider$BrokerDeal$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$BrokerDeal$brokerDealPath(id_)));
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$id(shared);
};
var $author$project$Components$BrokerDeal$EndModal$Model = $elm$core$Basics$identity;
var $author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$endDate(shared);
};
var $author$project$Components$BrokerDeal$EndModal$initFormFields = function (brokerDeal) {
	var endDate = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate,
		$elm$core$List$head(brokerDeal.XM));
	var _v0 = $author$project$Components$DateInput$init;
	var endDateDateInput = _v0.a;
	var endDateDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{qs: endDate, qt: endDateDateInput},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg(endDateDateInput),
			endDateDateInputCmd));
};
var $author$project$Components$BrokerDeal$EndModal$init = F4(
	function (session, currentDate, options, brokerDeal) {
		var _v0 = $author$project$Components$BrokerDeal$EndModal$initFormFields(brokerDeal);
		var fields = _v0.a;
		var fieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				J8: brokerDeal,
				vZ: options.vZ,
				cO: currentDate,
				PB: $author$project$Utils$Form$init(fields),
				ZD: session,
				o$: $author$project$Api$Data$NotAsked
			},
			fieldsCmd);
	});
var $author$project$Components$BrokerDeal$RestartModal$init = F2(
	function (session, brokerDeal) {
		return {J8: brokerDeal, ss: $author$project$Api$Data$NotAsked, ZD: session};
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Model = $elm$core$Basics$identity;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerDealRate$Shared$pricingStructure = function (_v0) {
	var record = _v0;
	return record.W2;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$pricingStructure = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$pricingStructure(shared);
};
var $author$project$Api$Provider$BrokerDealRate$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$startDate(shared);
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$initFormFields = F2(
	function (brokerDeal, brokerDealRate) {
		var startDate = A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate,
			$elm$core$List$head(brokerDeal.XM));
		var pricingStructure = $elm$core$Maybe$Just(
			A2(
				$author$project$Components$PricingStructureSelect$existingPricingStructure,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$PricingStructure$Shared$id,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$pricingStructure, brokerDealRate))));
		var _v0 = $author$project$Components$DateInput$init;
		var startDateDateInput = _v0.a;
		var startDateDateInputCmd = _v0.b;
		return _Utils_Tuple2(
			{W2: pricingStructure, _E: startDate, sY: startDateDateInput},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg(startDateDateInput),
				startDateDateInputCmd));
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$init = F5(
	function (apiClient, session, currentDate, brokerDeal, brokerDealRate) {
		var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
		var pricingStructureSelect = _v0.a;
		var pricingStructureSelectCmd = _v0.b;
		var _v1 = A2($author$project$Components$BrokerDealRate$CreateUpdateModal$initFormFields, brokerDeal, brokerDealRate);
		var fields = _v1.a;
		var fieldsCmd = _v1.b;
		return _Utils_Tuple2(
			{
				J8: brokerDeal,
				En: brokerDealRate,
				cO: currentDate,
				PB: $author$project$Utils$Form$init(fields),
				nG: pricingStructureSelect,
				ZD: session,
				o$: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						fieldsCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg, pricingStructureSelectCmd)
					])));
	});
var $author$project$Components$BrokerDeal$EndModal$BrokerDealEnded = 2;
var $author$project$Components$BrokerDeal$EndModal$Closed = 1;
var $author$project$Components$BrokerDeal$EndModal$EndDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$BrokerDeal$EndModal$Ended = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$BrokerDeal$EndModal$None = 0;
var $author$project$Api$Provider$BrokerDeal$end = F4(
	function (apiClient, id_, endDate_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_deal',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'end_date',
								$author$project$Utils$Date$encode(endDate_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDeal$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['end']),
						$author$project$Api$Provider$BrokerDeal$brokerDealPath(id_)))));
	});
var $author$project$Components$BrokerDeal$EndModal$EndDateValidation = 0;
var $author$project$Components$BrokerDeal$EndModal$validateEndDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.qs;
		if (!_v0.$) {
			var endDate = _v0.a;
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
			return (A2($justinmimbs$date$Date$compare, yesterdayDate, endDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$BrokerDeal$EndModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$BrokerDeal$EndModal$validateEndDate(currentDate))
			]));
};
var $author$project$Components$BrokerDeal$EndModal$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{qs: date, qt: dateInput});
	});
var $author$project$Components$BrokerDeal$EndModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDeal$EndModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDeal$EndModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return {
			EC: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			ac5: 0,
			y8: _Utils_update(
				model,
				{PB: newForm}),
			as: _List_Nil
		};
	});
var $author$project$Components$BrokerDeal$EndModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$BrokerDeal$EndModal$formFieldsValidator(model.cO),
					model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var endDate = _v4.qs;
					return {
						EC: A4(
							$author$project$Api$Provider$BrokerDeal$end,
							apiClient,
							model.J8.adR,
							A2($elm$core$Maybe$withDefault, model.cO, endDate),
							$author$project$Components$BrokerDeal$EndModal$Ended),
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm, o$: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully ended')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$BrokerDeal$EndModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg,
					$author$project$Components$BrokerDeal$EndModal$EndDate,
					function ($) {
						return $.qs;
					});
		}
	});
var $author$project$Components$BrokerDeal$RestartModal$BrokerDealRestarted = 2;
var $author$project$Components$BrokerDeal$RestartModal$Closed = 1;
var $author$project$Components$BrokerDeal$RestartModal$None = 0;
var $author$project$Components$BrokerDeal$RestartModal$Restarted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$BrokerDeal$restart = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDeal$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['restart']),
					$author$project$Api$Provider$BrokerDeal$brokerDealPath(id_))));
	});
var $author$project$Components$BrokerDeal$RestartModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 0:
				return {
					EC: A3($author$project$Api$Provider$BrokerDeal$restart, apiClient, model.J8.adR, $author$project$Components$BrokerDeal$RestartModal$Restarted),
					ac5: 0,
					y8: _Utils_update(
						model,
						{ss: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully restarted')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{ss: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$BrokerDealRateCreated = 3;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$BrokerDealRateUpdated = 2;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Closed = 1;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$None = 0;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var dateInput = field.a;
			var date = field.b;
			return _Utils_update(
				fields,
				{_E: date, sY: dateInput});
		} else {
			var pricingStructure = field.a;
			return _Utils_update(
				fields,
				{W2: pricingStructure});
		}
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureValidation = 1;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$validatePricingStructure = function (fields) {
	var _v0 = fields.W2;
	if (!_v0.$) {
		var pricingStructure = _v0.a;
		var _v1 = pricingStructure.adR;
		if (!_v1.$) {
			return _List_Nil;
		} else {
			var _v2 = _Utils_Tuple3(pricingStructure.afX, pricingStructure.afJ, pricingStructure.adr);
			_v2$2:
			while (true) {
				if (!_v2.a.$) {
					switch (_v2.a.a.$) {
						case 0:
							if (_v2.b.$ === 1) {
								var _v3 = _v2.a.a;
								var _v4 = _v2.b;
								return _List_fromArray(
									[
										_Utils_Tuple2(1, 'Please enter a number')
									]);
							} else {
								break _v2$2;
							}
						case 1:
							if (_v2.c.$ === 1) {
								var _v5 = _v2.a.a;
								var _v6 = _v2.c;
								return _List_fromArray(
									[
										_Utils_Tuple2(1, 'Please enter an amount')
									]);
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				} else {
					break _v2$2;
				}
			}
			return _List_Nil;
		}
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please pick or create a rate.')
			]);
	}
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateValidation = 0;
var $author$project$Components$BrokerDealRate$CreateUpdateModal$validateStartDate = F2(
	function (currentDate, fields) {
		var _v0 = fields._E;
		if (!_v0.$) {
			var startDate = _v0.a;
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
			return (A2($justinmimbs$date$Date$compare, yesterdayDate, startDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$BrokerDealRate$CreateUpdateModal$validateStartDate(currentDate)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDealRate$CreateUpdateModal$validatePricingStructure)
			]));
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Updated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$apiFields = F2(
	function (brokerDeal, formFields) {
		return {J8: brokerDeal.adR, W2: formFields.W2, _E: formFields._E};
	});
var $author$project$Api$Provider$BrokerDealRate$create = F3(
	function (apiClient, fields, toMsg) {
		var pricingStructure_ = function () {
			var _v0 = fields.W2;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var pricingStructure__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pricing_structure',
						$elm$json$Json$Encode$object(
							$elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v1 = pricingStructure__.adR;
										if (!_v1.$) {
											var string = _v1.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v2 = pricingStructure__.Nx;
										if (!_v2.$) {
											var string = _v2.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'description',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v3 = pricingStructure__.adr;
										if (!_v3.$) {
											var _int = _v3.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'fixed_amount_in_cents',
													$author$project$Currency$encode(_int))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v4 = pricingStructure__.afJ;
										if (!_v4.$) {
											var _float = _v4.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'percentage',
													$author$project$Percentage$encode(_float))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v5 = pricingStructure__.ag3;
										if (!_v5.$) {
											var splitType = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'split_type',
													$author$project$Api$SplitType$encode(splitType))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v6 = pricingStructure__.afX;
										if (!_v6.$) {
											var pricingType_ = _v6.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'pricing_type',
													$author$project$Api$PricingType$encode(pricingType_))
												]);
										} else {
											return _List_Nil;
										}
									}()
									]))))
					]);
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rate',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'broker_deal',
								$author$project$Utils$Encode$association(fields.J8)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'start_date',
									A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields._E)),
								pricingStructure_))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerDealRate$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath)));
	});
var $author$project$Api$Provider$BrokerDealRate$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var pricingStructure_ = function () {
			var _v0 = fields.W2;
			if (_v0.$ === 1) {
				return _List_Nil;
			} else {
				var pricingStructure__ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'pricing_structure',
						$elm$json$Json$Encode$object(
							$elm$core$List$concat(
								_List_fromArray(
									[
										function () {
										var _v1 = pricingStructure__.adR;
										if (!_v1.$) {
											var string = _v1.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v2 = pricingStructure__.Nx;
										if (!_v2.$) {
											var string = _v2.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'description',
													$elm$json$Json$Encode$string(string))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v3 = pricingStructure__.adr;
										if (!_v3.$) {
											var _int = _v3.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'fixed_amount_in_cents',
													$author$project$Currency$encode(_int))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v4 = pricingStructure__.afJ;
										if (!_v4.$) {
											var _float = _v4.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'percentage',
													$author$project$Percentage$encode(_float))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v5 = pricingStructure__.ag3;
										if (!_v5.$) {
											var splitType = _v5.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'split_type',
													$author$project$Api$SplitType$encode(splitType))
												]);
										} else {
											return _List_Nil;
										}
									}(),
										function () {
										var _v6 = pricingStructure__.afX;
										if (!_v6.$) {
											var pricingType_ = _v6.a;
											return _List_fromArray(
												[
													_Utils_Tuple2(
													'pricing_type',
													$author$project$Api$PricingType$encode(pricingType_))
												]);
										} else {
											return _List_Nil;
										}
									}()
									]))))
					]);
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'rate',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'broker_deal',
								$author$project$Utils$Encode$association(fields.J8)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'start_date',
									A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields._E)),
								pricingStructure_))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$BrokerDealRate$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$BrokerDealRate$brokerDealRatePath(id_))));
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$save = F4(
	function (apiClient, brokerDeal, brokerDealRate, validFormFields) {
		var apiFields_ = A2(
			$author$project$Components$BrokerDealRate$CreateUpdateModal$apiFields,
			brokerDeal,
			$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
		if (!brokerDealRate.$) {
			var brokerDealRate_ = brokerDealRate.a;
			return A4(
				$author$project$Api$Provider$BrokerDealRate$update,
				apiClient,
				$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id(brokerDealRate_),
				apiFields_,
				$author$project$Components$BrokerDealRate$CreateUpdateModal$Updated);
		} else {
			return A3($author$project$Api$Provider$BrokerDealRate$create, apiClient, apiFields_, $author$project$Components$BrokerDealRate$CreateUpdateModal$Created);
		}
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return {
			EC: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			ac5: 0,
			y8: _Utils_update(
				model,
				{PB: newForm}),
			as: _List_Nil
		};
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsValidator(model.cO),
					model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					return {
						EC: A4($author$project$Components$BrokerDealRate$CreateUpdateModal$save, apiClient, model.J8, model.En, validFormFields),
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm, o$: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 3,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal rate successfully added')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal rate successfully updated')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$BrokerDealRate$CreateUpdateModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg,
					$author$project$Components$BrokerDealRate$CreateUpdateModal$StartDate,
					function ($) {
						return $._E;
					});
			default:
				var subMsg = msg.a;
				var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.nG);
				var form = function () {
					var _v6 = pricingStructureSelectResult.ac5;
					if (!_v6.$) {
						return model.PB;
					} else {
						var pricingStructure = _v6.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate,
							$author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructure(pricingStructure),
							model.PB);
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg, pricingStructureSelectResult.EC),
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: form, nG: pricingStructureSelectResult.y8}),
					as: pricingStructureSelectResult.as
				};
		}
	});
var $author$project$Components$BrokerDeal$Timeline$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					as: _List_Nil
				};
			case 1:
				var confirmed = msg.a;
				return confirmed ? {
					EC: A3($author$project$Api$Provider$BrokerDeal$delete, apiClient, model.J8.adR, $author$project$Components$BrokerDeal$Timeline$Deleted),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
						}),
					as: _List_Nil
				} : {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{fm: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{fm: $elm$core$Maybe$Nothing}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully deleted')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								fm: $elm$core$Maybe$Just(response)
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var _v2 = A5($author$project$Components$BrokerDealRate$CreateUpdateModal$init, apiClient, model.ZD, model.cO, model.J8, $elm$core$Maybe$Nothing);
				var brokerDealRateModal = _v2.a;
				var brokerDealRateModalCmd = _v2.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							e6: $elm$core$Maybe$Just(brokerDealRateModal)
						}),
					as: _List_Nil
				};
			case 4:
				var brokerDealRate = msg.a;
				var _v3 = A5(
					$author$project$Components$BrokerDealRate$CreateUpdateModal$init,
					apiClient,
					model.ZD,
					model.cO,
					model.J8,
					$elm$core$Maybe$Just(brokerDealRate));
				var brokerDealRateModal = _v3.a;
				var brokerDealRateModalCmd = _v3.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							e6: $elm$core$Maybe$Just(brokerDealRateModal)
						}),
					as: _List_Nil
				};
			case 5:
				var subMsg = msg.a;
				var _v4 = model.e6;
				if (!_v4.$) {
					var brokerDealRateModal = _v4.a;
					var brokerDealRateModalResult = A3($author$project$Components$BrokerDealRate$CreateUpdateModal$update, apiClient, subMsg, brokerDealRateModal);
					var _v5 = function () {
						var _v6 = brokerDealRateModalResult.ac5;
						switch (_v6) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(brokerDealRateModalResult.y8),
									0);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 3:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 5);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 6);
						}
					}();
					var brokerDealRateModal_ = _v5.a;
					var event = _v5.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{e6: brokerDealRateModal_}),
						as: brokerDealRateModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				var brokerDealRate = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							e7: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerDealRate, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 7:
				var brokerDealRate = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					EC: A3(
						$author$project$Api$Provider$BrokerDealRate$cancel,
						apiClient,
						$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id(brokerDealRate),
						$author$project$Components$BrokerDeal$Timeline$Canceled(brokerDealRate)),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							e7: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerDealRate, $author$project$Api$Data$Loading))
						}),
					as: _List_Nil
				} : {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{e7: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 8:
				var brokerDealRate = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 4,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Rate successfully canceled')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								e7: $elm$core$Maybe$Just(
									_Utils_Tuple2(brokerDealRate, response))
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var _v8 = A4(
					$author$project$Components$BrokerDeal$EndModal$init,
					model.ZD,
					model.cO,
					{vZ: true},
					model.J8);
				var endModal = _v8.a;
				var endModalCmd = _v8.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fC: $elm$core$Maybe$Just(endModal)
						}),
					as: _List_Nil
				};
			case 10:
				var _v9 = A4(
					$author$project$Components$BrokerDeal$EndModal$init,
					model.ZD,
					model.cO,
					{vZ: false},
					model.J8);
				var endModal = _v9.a;
				var endModalCmd = _v9.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fC: $elm$core$Maybe$Just(endModal)
						}),
					as: _List_Nil
				};
			case 11:
				var subMsg = msg.a;
				var _v10 = model.fC;
				if (!_v10.$) {
					var endModal = _v10.a;
					var endModalResult = A3($author$project$Components$BrokerDeal$EndModal$update, apiClient, subMsg, endModal);
					var _v11 = function () {
						var _v12 = endModalResult.ac5;
						switch (_v12) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(endModalResult.y8),
									0);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 3);
						}
					}();
					var endModal_ = _v11.a;
					var event = _v11.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{fC: endModal_}),
						as: endModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 12:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							jS: $elm$core$Maybe$Just(
								A2($author$project$Components$BrokerDeal$RestartModal$init, model.ZD, model.J8))
						}),
					as: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v13 = model.jS;
				if (!_v13.$) {
					var restartModal = _v13.a;
					var restartModalResult = A3($author$project$Components$BrokerDeal$RestartModal$update, apiClient, subMsg, restartModal);
					var _v14 = function () {
						var _v15 = restartModalResult.ac5;
						switch (_v15) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(restartModalResult.y8),
									0);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 2);
						}
					}();
					var restartModal_ = _v14.a;
					var event = _v14.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$RestartModalMsg, restartModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{jS: restartModal_}),
						as: restartModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$BrokerDeal$Timeline$init = F4(
	function (session, currentDate, options, brokerDeal) {
		return {J8: brokerDeal, e6: $elm$core$Maybe$Nothing, e7: $elm$core$Maybe$Nothing, cO: currentDate, fm: $elm$core$Maybe$Nothing, fC: $elm$core$Maybe$Nothing, jS: $elm$core$Maybe$Nothing, ZD: session, agX: options.agX};
	});
var $author$project$Components$BrokerDeal$Table$withBrokerDeals = F2(
	function (brokerDeals, model) {
		return _Utils_update(
			model,
			{
				J9: A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, brokerDeal) {
							var showEndedOnTimeline = A2($elm$core$Set$member, index, model.gK);
							return _Utils_Tuple2(
								brokerDeal,
								A4(
									$author$project$Components$BrokerDeal$Timeline$init,
									model.ZD,
									model.cO,
									{agX: model.l3 || showEndedOnTimeline},
									brokerDeal));
						}),
					brokerDeals)
			});
	});
var $author$project$Components$BrokerDeal$Table$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var index = msg.a;
			return {
				EC: $elm$core$Platform$Cmd$none,
				ac5: 0,
				y8: function (deals) {
					var showEndedOnTimeline = A2($elm$core$Set$member, index, model.gK) ? A2($elm$core$Set$remove, index, model.gK) : A2($elm$core$Set$insert, index, model.gK);
					return A2(
						$author$project$Components$BrokerDeal$Table$withBrokerDeals,
						deals,
						_Utils_update(
							model,
							{gK: showEndedOnTimeline}));
				}(
					A2($elm$core$List$map, $elm$core$Tuple$first, model.J9)),
				as: _List_Nil
			};
		} else {
			var index = msg.a;
			var subMsg = msg.b;
			var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, model.J9);
			if (!_v1.$) {
				var _v2 = _v1.a;
				var brokerDeal = _v2.a;
				var timeline = _v2.b;
				var timelineResult = A3($author$project$Components$BrokerDeal$Timeline$update, apiClient, subMsg, timeline);
				var event = function () {
					var _v3 = timelineResult.ac5;
					switch (_v3) {
						case 0:
							return 0;
						case 1:
							return 1;
						case 2:
							return 2;
						case 3:
							return 3;
						case 4:
							return 4;
						case 5:
							return 5;
						default:
							return 6;
					}
				}();
				return {
					EC: A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$BrokerDeal$Table$TimelineMsg(index),
						timelineResult.EC),
					ac5: event,
					y8: _Utils_update(
						model,
						{
							J9: A3(
								$elm_community$list_extra$List$Extra$setAt,
								index,
								_Utils_Tuple2(brokerDeal, timelineResult.y8),
								model.J9)
						}),
					as: timelineResult.as
				};
			} else {
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{vK: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerDeals = response.a;
					var headers = response.b;
					var brokerDealsTable = A2(
						$author$project$Components$BrokerDeal$Table$withBrokerDeals,
						A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals),
						model.dt);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								J9: response,
								dt: brokerDealsTable,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{J9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var subMsg = msg.a;
				var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.D5, subMsg, model.dt);
				var _v2 = function () {
					var _v3 = brokerDealsTableResult.ac5;
					switch (_v3) {
						case 0:
							return _Utils_Tuple2(model.J9, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						case 4:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						case 5:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
					}
				}();
				var brokerDeals = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{J9: brokerDeals, dt: brokerDealsTableResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg, brokerDealsTableResult.EC),
								cmd
							])),
					brokerDealsTableResult.as);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oU);
				var typeDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oU: typeDropdown}),
					cmd,
					_List_Nil);
			case 6:
				var selectedType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						J9: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						ahI: selectedType
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, model.D5, subMsg, model.lf);
				var brokerId = function () {
					var _v6 = brokerResourceResult.ac5;
					if (!_v6.$) {
						if (!_v6.a.$) {
							return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.y8);
						} else {
							var _v7 = _v6.a;
							return model.Eo;
						}
					} else {
						return model.Eo;
					}
				}();
				var newModel = _Utils_update(
					model,
					{Eo: brokerId, lf: brokerResourceResult.y8});
				var _v5 = _Utils_eq(model.Eo, newModel.Eo) ? _Utils_Tuple2(model.J9, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var brokerDeals = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{J9: brokerDeals}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg, brokerResourceResult.EC),
								cmd
							])),
					brokerResourceResult.as);
			case 4:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v8.a;
				var searchInputCmd = _v8.b;
				var searchInputEvent = _v8.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v9 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								J9: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 8:
				var brokerAccount = msg.a;
				var _v11 = A5(
					$author$project$Components$BrokerDeal$CreateModal$init,
					model.D5,
					model.ZD,
					model.cO,
					model.Hz,
					{
						vJ: $elm$core$Maybe$Nothing,
						vK: $elm$core$Maybe$Just(
							$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount)),
						Lp: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.WF),
						ab9: $elm$core$Maybe$Nothing,
						M2: 0,
						ja: $elm$core$Maybe$Nothing,
						agv: $author$project$Api$Provider$BrokerAccount$One$retailEnabled(brokerAccount)
					});
				var createModal = _v11.a;
				var createModalCmd = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hY: $elm$core$Maybe$Just(createModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg, createModalCmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v12 = model.hY;
				if (!_v12.$) {
					var createModal = _v12.a;
					var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, model.D5, subMsg, createModal);
					var _v13 = function () {
						var _v14 = createModalResult.ac5;
						switch (_v14) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createModalResult.y8),
									model.J9,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.J9, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
						}
					}();
					var createModal_ = _v13.a;
					var brokerDeals = _v13.b;
					var cmd = _v13.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{J9: brokerDeals, hY: createModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg, createModalResult.EC),
									cmd
								])),
						createModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Create = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$BrokerDeal$Table$loading = $author$project$Ui$Table$loading;
var $author$project$Components$BrokerDeal$EndModal$End = {$: 0};
var $author$project$Components$BrokerDeal$EndModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$BrokerDeal$EndModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						model.vZ ? 'Edit Employer Deal' : 'End Employer Deal')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$EndModal$End),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Employer name'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.J8.ab9)))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Broker name'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$Broker$Shared$name(model.J8.vJ))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Date'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg(fields.qt),
										A2(
											$author$project$Components$DateInput$view,
											_List_fromArray(
												[
													$author$project$Components$DateInput$value(fields.qs),
													$author$project$Components$DateInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
													$author$project$Components$DateInput$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.PB))
												]),
											fields.qt)),
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('Ending this employer deal will stop commissions from being calculated on the date specified.'),
												$elm$html$Html$text(' If any future calculations exist they will be removed or reversed.')
											]))
									]))
							])),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$EndModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'End broker deal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.o$, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$EndModal$End)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('End')
							]))
					]))
			]));
};
var $author$project$Components$BrokerDeal$RestartModal$Restart = {$: 0};
var $author$project$Api$Provider$BrokerDealRate$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerDealRate$Shared$description(shared);
};
var $author$project$Components$BrokerDeal$RestartModal$view = function (model) {
	var rateDescription = A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description,
		$elm$core$List$head(model.J8.XM));
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$BrokerDeal$RestartModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Restart employer deal')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$RestartModal$Restart),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Employer name'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.J8.ab9)))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Rate'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '', rateDescription))
											])),
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('Restarting this broker on this deal will create all missing commission calculations'),
												$elm$html$Html$text(' for the entire life of the deal.')
											]))
									]))
							])),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$RestartModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Restart broker deal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.ss, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$RestartModal$Restart)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Restart')
							]))
					]))
			]));
};
var $author$project$Components$BrokerDealRate$CreateUpdateModal$Save = {$: 0};
var $author$project$Components$PricingStructureSelect$Errors = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PricingStructureSelect$errors = $author$project$Components$PricingStructureSelect$Errors;
var $author$project$Components$PricingStructureSelect$Invalid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PricingStructureSelect$invalid = $author$project$Components$PricingStructureSelect$Invalid;
var $author$project$Components$PricingStructureSelect$Value = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PricingStructureSelect$value = $author$project$Components$PricingStructureSelect$Value;
var $author$project$Components$PricingStructureSelect$defaultOptions = {fE: _List_Nil, mv: 8, q$: false, mN: 4, aaN: $elm$core$Maybe$Nothing};
var $author$project$Components$PricingStructureSelect$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var span = option.a;
						return _Utils_update(
							record,
							{mN: span});
					case 1:
						var span = option.a;
						return _Utils_update(
							record,
							{mv: span});
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{aaN: string});
					case 3:
						var bool = option.a;
						return _Utils_update(
							record,
							{q$: bool});
					default:
						var list = option.a;
						return _Utils_update(
							record,
							{fE: list});
				}
			}),
		$author$project$Components$PricingStructureSelect$defaultOptions,
		options);
};
var $author$project$Components$PricingStructureSelect$NewPricingStructureUpdated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$PricingStructureSelect$SplitType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingStructureSelect$viewSplitTypeButton = F3(
	function (pricingStructure, splitType, label) {
		var currentSplitType = A2($elm$core$Maybe$withDefault, 0, pricingStructure.ag3);
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentSplitType, splitType)),
					$author$project$Ui$Button$onClick(
					A2(
						$author$project$Components$PricingStructureSelect$NewPricingStructureUpdated,
						pricingStructure,
						$author$project$Components$PricingStructureSelect$SplitType(splitType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$PricingStructureSelect$viewCommissionType = F3(
	function (optionsRecord, model, value_) {
		return model.hm ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Commission Type'),
					$author$project$Ui$Form$Group$labelSpan(optionsRecord.mN),
					$author$project$Ui$Form$Group$inputSpan(optionsRecord.mv)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Button$group(
					_List_fromArray(
						[
							A3($author$project$Components$PricingStructureSelect$viewSplitTypeButton, value_, 0, 'All members'),
							A3($author$project$Components$PricingStructureSelect$viewSplitTypeButton, value_, 1, 'Primary member')
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$PricingStructureSelect$PricingStructureSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingStructureSelect$viewRateDropdown = F4(
	function (optionsRecord, model, loadingPricingStructures, pricingStructures) {
		var currentSelection = model.hm ? $elm$core$Maybe$Just('') : A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.adR;
			},
			optionsRecord.aaN);
		var items = function () {
			if (loadingPricingStructures) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$NewDropdown$item,
						_List_Nil,
						$elm$html$Html$text('Loading...'))
					]);
			} else {
				var addNewItem = A2(
					$author$project$Ui$NewDropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$onSelect(
							$author$project$Components$PricingStructureSelect$PricingStructureSelected(
								$elm$core$Maybe$Just(''))),
							$author$project$Ui$NewDropdown$selected(
							_Utils_eq(
								currentSelection,
								$elm$core$Maybe$Just('')))
						]),
					$elm$html$Html$text('Add new commission rate'));
				if ($elm$core$List$isEmpty(pricingStructures)) {
					return _List_fromArray(
						[addNewItem]);
				} else {
					var pricingStructureItems = A2(
						$elm$core$List$map,
						function (ps) {
							return A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$PricingStructureSelect$PricingStructureSelected(
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$PricingStructure$All$id(ps)))),
										$author$project$Ui$NewDropdown$selected(
										_Utils_eq(
											currentSelection,
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$PricingStructure$All$id(ps))))
									]),
								$elm$html$Html$text(
									$author$project$Api$Provider$PricingStructure$All$description(ps)));
						},
						pricingStructures);
					return A2(
						$elm$core$List$cons,
						addNewItem,
						A2($elm$core$List$cons, $author$project$Ui$NewDropdown$separator, pricingStructureItems));
				}
			}
		}();
		var currentLabel = function () {
			if (!currentSelection.$) {
				if (currentSelection.a === '') {
					return 'Add new commission rate';
				} else {
					var id = currentSelection.a;
					return A2(
						$elm$core$Maybe$withDefault,
						'Choose broker commission rate',
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$PricingStructure$All$description,
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (ps) {
									return _Utils_eq(
										$author$project$Api$Provider$PricingStructure$All$id(ps),
										id);
								},
								pricingStructures)));
				}
			} else {
				return 'Choose broker commission rate';
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Rate'),
					$author$project$Ui$Form$Group$labelSpan(optionsRecord.mN),
					$author$project$Ui$Form$Group$inputSpan(optionsRecord.mv),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Ui$NewDropdown$viewSelect,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(currentLabel)
						]),
					items,
					model.lU),
					(!model.hm) ? $author$project$Utils$FormErrors$view(optionsRecord.fE) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$PricingStructureSelect$FixedAmountInCents = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PricingStructureSelect$Percentage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PricingStructureSelect$PricingType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingStructureSelect$viewPricingTypeButton = F3(
	function (pricingStructure, pricingType, label) {
		var currentPricingType = A2($elm$core$Maybe$withDefault, $author$project$Api$PricingType$Percentage, pricingStructure.afX);
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$styled(
					_Utils_eq(currentPricingType, pricingType) ? 1 : 0),
					$author$project$Ui$Button$onClick(
					A2(
						$author$project$Components$PricingStructureSelect$NewPricingStructureUpdated,
						pricingStructure,
						$author$project$Components$PricingStructureSelect$PricingType(pricingType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$PricingStructureSelect$viewRetailRate = F3(
	function (optionsRecord, model, value_) {
		return model.hm ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Retail Rate'),
					$author$project$Ui$Form$Group$labelSpan(optionsRecord.mN),
					$author$project$Ui$Form$Group$inputSpan(optionsRecord.mv),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mr2]),
							_List_fromArray(
								[
									$author$project$Ui$Button$group(
									_List_fromArray(
										[
											A3($author$project$Components$PricingStructureSelect$viewPricingTypeButton, value_, $author$project$Api$PricingType$FixedAmountInCents, '$'),
											A3($author$project$Components$PricingStructureSelect$viewPricingTypeButton, value_, $author$project$Api$PricingType$Percentage, '%')
										]))
								])),
							_Utils_eq(
							value_.afX,
							$elm$core$Maybe$Just($author$project$Api$PricingType$FixedAmountInCents)) ? $author$project$Ui$Form$CurrencyInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$value(value_.adr),
									$author$project$Ui$Form$CurrencyInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PricingStructureSelect$NewPricingStructureUpdated(value_),
										$author$project$Components$PricingStructureSelect$FixedAmountInCents)),
									$author$project$Ui$Form$CurrencyInput$invalid(optionsRecord.q$),
									$author$project$Ui$Form$CurrencyInput$placeholder('10.00')
								])) : $author$project$Ui$Form$PercentageInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$PercentageInput$value(value_.afJ),
									$author$project$Ui$Form$PercentageInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$PricingStructureSelect$NewPricingStructureUpdated(value_),
										$author$project$Components$PricingStructureSelect$Percentage)),
									$author$project$Ui$Form$PercentageInput$invalid(optionsRecord.q$),
									$author$project$Ui$Form$PercentageInput$placeholder('10')
								]))
						])),
					$author$project$Utils$FormErrors$view(optionsRecord.fE)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$PricingStructureSelect$view = F2(
	function (options, model) {
		var optionsRecord = $author$project$Components$PricingStructureSelect$optionsToRecord(options);
		var value_ = A2($elm$core$Maybe$withDefault, $author$project$Components$PricingStructureSelect$newPricingStructure, optionsRecord.aaN);
		var _v0 = function () {
			var _v1 = model.se;
			if (_v1.$ === 3) {
				var pricingStructures_ = _v1.a;
				return _Utils_Tuple2(false, pricingStructures_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loadingPricingStructures = _v0.a;
		var pricingStructures = _v0.b;
		return _List_fromArray(
			[
				A4($author$project$Components$PricingStructureSelect$viewRateDropdown, optionsRecord, model, loadingPricingStructures, pricingStructures),
				A3($author$project$Components$PricingStructureSelect$viewCommissionType, optionsRecord, model, value_),
				A3($author$project$Components$PricingStructureSelect$viewRetailRate, optionsRecord, model, value_)
			]);
	});
var $author$project$Components$BrokerDealRate$CreateUpdateModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$BrokerDealRate$CreateUpdateModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Change employer deal')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$BrokerDealRate$CreateUpdateModal$Save),
								$author$project$Ui$Form$horizontal
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Employer name'),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															'',
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.J8.ab9)))
													]))
											]))
									]),
									A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg),
									A2(
										$author$project$Components$PricingStructureSelect$view,
										_List_fromArray(
											[
												$author$project$Components$PricingStructureSelect$value(fields.W2),
												$author$project$Components$PricingStructureSelect$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
												$author$project$Components$PricingStructureSelect$errors(
												A2($author$project$Utils$Form$validationErrors, 1, model.PB))
											]),
										model.nG)),
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Date'),
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$required(true)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg(fields.sY),
												A2(
													$author$project$Components$DateInput$view,
													_List_fromArray(
														[
															$author$project$Components$DateInput$value(fields._E),
															$author$project$Components$DateInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
															$author$project$Components$DateInput$errors(
															A2($author$project$Utils$Form$validationErrors, 0, model.PB))
														]),
													fields.sY)),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$helpBlock]),
												_List_fromArray(
													[
														$elm$html$Html$text('Change the broker\'s rate will update all commission calculations starting on the date specified.')
													]))
											])),
										$author$project$Ui$Clearfix$view
									])
								])))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDealRate$CreateUpdateModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Change broker deal rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.o$, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDealRate$CreateUpdateModal$Save)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Change Rate')
							]))
					]))
			]));
};
var $author$project$Components$BrokerDeal$Timeline$modal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.fm;
				if (!_v0.$) {
					var deleteRequest = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('broker deal'),
								$author$project$Components$HiConfirm$detail(
								model.J8.M1 + (' - ' + ($author$project$Api$Provider$Broker$Shared$name(model.J8.vJ) + ' and remove it from all existing invoices'))),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.e7;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var brokerDealRate = _v2.a;
					var cancelRequest = _v2.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed(brokerDealRate),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('cancel'),
								$author$project$Components$HiConfirm$noun('broker deal rate'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Are you sure you want to cancel this rate?')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.jS;
				if (!_v3.$) {
					var restartModal = _v3.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$BrokerDeal$Timeline$RestartModalMsg,
						$author$project$Components$BrokerDeal$RestartModal$view(restartModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v4 = model.fC;
				if (!_v4.$) {
					var endModal = _v4.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$BrokerDeal$Timeline$EndModalMsg,
						$author$project$Components$BrokerDeal$EndModal$view(endModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.e6;
				if (!_v5.$) {
					var brokerDealRateModal = _v5.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg,
						$author$project$Components$BrokerDealRate$CreateUpdateModal$view(brokerDealRateModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$BrokerDeal$Table$modal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, _v0) {
					var timeline = _v0.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$BrokerDeal$Table$TimelineMsg(index),
						$author$project$Components$BrokerDeal$Timeline$modal(timeline));
				}),
			model.J9));
};
var $author$project$Components$BrokerDeal$CreateModal$BillFrom = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Create = {$: 0};
var $author$project$Components$BrokerDeal$CreateModal$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$Membership = 1;
var $elm_community$list_extra$List$Extra$maximumBy = F2(
	function (f, ls) {
		var maxBy = F2(
			function (x, _v1) {
				var y = _v1.a;
				var fy = _v1.b;
				var fx = f(x);
				return (_Utils_cmp(fx, fy) > 0) ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
			});
		if (ls.b) {
			if (!ls.b.b) {
				var l_ = ls.a;
				return $elm$core$Maybe$Just(l_);
			} else {
				var l_ = ls.a;
				var ls_ = ls.b;
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$List$foldl,
						maxBy,
						_Utils_Tuple2(
							l_,
							f(l_)),
						ls_).a);
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$BrokerDeal$CreateModal$billFromDates = F3(
	function (currentDate, commissionsTrackingFrom, dealStartDate) {
		var startMonth = A2($justinmimbs$date$Date$floor, 2, currentDate);
		var dealDate = A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$floor(2),
			dealStartDate);
		var commissionDate = A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$floor(2),
			commissionsTrackingFrom);
		var allTimeDate = A2(
			$justinmimbs$date$Date$floor,
			2,
			A3($justinmimbs$date$Date$add, 1, -9, currentDate));
		var maxDate = A2(
			$elm_community$list_extra$List$Extra$maximumBy,
			$justinmimbs$date$Date$toRataDie,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(allTimeDate),
						commissionDate,
						dealDate
					])));
		var dateDuration = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				A2($justinmimbs$date$Date$diff, 1, currentDate),
				maxDate));
		return A2(
			$elm$core$List$map,
			function (index) {
				return A3($justinmimbs$date$Date$add, 1, index, startMonth);
			},
			$elm$core$List$reverse(
				A2($elm$core$List$range, dateDuration + 1, 0)));
	});
var $author$project$Components$BrokerDeal$CreateModal$billFromOptions = F3(
	function (currentDate, commissionsTrackingFrom, dealStartDate) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Start of the deal'),
			A2(
				$elm$core$List$map,
				function (billFrom) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Utils$Date$toIsoString(billFrom)),
						A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, billFrom));
				},
				A3($author$project$Components$BrokerDeal$CreateModal$billFromDates, currentDate, commissionsTrackingFrom, dealStartDate)));
	});
var $author$project$Api$Provider$Company$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Company$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Company$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$createdAt(shared);
};
var $author$project$Components$BrokerDeal$CreateModal$companyCreatedAt = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$createdAt(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$All$createdAt(company_);
	}
};
var $author$project$Components$PricingStructureSelect$InputGrid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PricingStructureSelect$inputSpan = $author$project$Components$PricingStructureSelect$InputGrid;
var $author$project$Components$PricingStructureSelect$LabelGrid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PricingStructureSelect$labelSpan = $author$project$Components$PricingStructureSelect$LabelGrid;
var $author$project$Api$Provider$Membership$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$Membership$One$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$startDate(shared);
};
var $author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter = F2(
	function (brokerResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Broker$viewNew,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 2, form))
					]),
				brokerResourceFilter));
	});
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths = function (_v0) {
	var record = _v0;
	return record.ad3;
};
var $author$project$Api$Provider$RatePeriodSchedule$Shared$intervals = function (_v0) {
	var record = _v0;
	return record.ad4;
};
var $author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule = function (_v0) {
	var record = _v0;
	return record.XK;
};
var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure = function (_v0) {
	var record = _v0;
	return record.W2;
};
var $author$project$Components$BrokerDeal$CreateModal$viewInterval = F3(
	function (intervals, index, interval) {
		var previous = A2($elm_community$list_extra$List$Extra$getAt, index - 1, intervals);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$muted,
							$author$project$Ui$Typography$margin(2)
						]),
					function () {
						if (previous.$ === 1) {
							return _List_fromArray(
								[
									$elm$html$Html$text('Start of the deal')
								]);
						} else {
							var previous_ = previous.a;
							return _List_fromArray(
								[
									$elm$html$Html$text('After '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$elm$core$String$fromInt,
											$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths(previous_)))),
									$elm$html$Html$text(' months')
								]);
						}
					}()),
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$PricingStructure$Shared$description(
								$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure(interval)))
						]))
				]));
	});
var $author$project$Components$BrokerDeal$CreateModal$viewBrokerTimeline = function (broker) {
	var intervals = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$RatePeriodSchedule$Shared$intervals,
			$author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule(
				$author$project$Api$Provider$Broker$All$brokerAccount(broker))));
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('timeline')
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$indexedMap,
					$author$project$Components$BrokerDeal$CreateModal$viewInterval(intervals),
					intervals),
					_List_fromArray(
					[
						A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('timeline__item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$muted,
										$author$project$Ui$Typography$margin(2)
									]),
								function () {
									var _v0 = A2(
										$elm$core$Maybe$andThen,
										$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths,
										$elm_community$list_extra$List$Extra$last(intervals));
									if (_v0.$ === 1) {
										return _List_fromArray(
											[
												$elm$html$Html$text('Recurring Deal')
											]);
									} else {
										var intervalInMonths = _v0.a;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(intervalInMonths)),
												$elm$html$Html$text(' months')
											]);
									}
								}())
							]))
					])
				])));
};
var $author$project$Components$BrokerDeal$CreateModal$viewCompanyResourceFilter = F2(
	function (companyResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Company$viewNew,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]),
				companyResourceFilter));
	});
var $author$project$Components$BrokerDeal$CreateModal$DealType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton = F3(
	function (currentDealType, dealType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select deal type ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentDealType, dealType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$BrokerDeal$CreateModal$FormUpdated(
						$author$project$Components$BrokerDeal$CreateModal$DealType(dealType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Api$Provider$Membership$One$membershipPatients = function (_v0) {
	var record = _v0.b;
	return record.TF;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Api$Provider$Membership$One$plan = function (_v0) {
	var record = _v0.b;
	return record.GH;
};
var $author$project$Components$BrokerDeal$CreateModal$viewMembership = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var membership = _v0.ja;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Membership ')
							])),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$gray]),
						_List_fromArray(
							[
								function () {
								if (!membership.$) {
									var membership_ = membership.a;
									return $elm$html$Html$text(
										$author$project$Api$Provider$Plan$SharedWithContractInfo$name(
											$author$project$Api$Provider$Membership$One$plan(membership_)));
								} else {
									return $author$project$Ui$Spinner$view(
										_List_fromArray(
											[$author$project$Ui$Spinner$extraSmall]));
								}
							}()
							]))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Members ')
							])),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$gray]),
						_List_fromArray(
							[
								function () {
								if (!membership.$) {
									var membership_ = membership.a;
									return $elm$html$Html$text(
										$author$project$Formatters$String$toSentence(
											A2(
												$elm$core$List$map,
												A2($elm$core$Basics$composeR, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name),
												$author$project$Api$Provider$Membership$One$membershipPatients(membership_))));
								} else {
									return $author$project$Ui$Spinner$view(
										_List_fromArray(
											[$author$project$Ui$Spinner$extraSmall]));
								}
							}()
							]))
					])),
				$author$project$Utils$FormErrors$view(
				A2($author$project$Utils$Form$validationErrors, 3, form))
			]));
};
var $author$project$Components$BrokerDeal$CreateModal$viewPatientResourceFilter = F2(
	function (patientResourceFilter, form) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg,
			A2(
				$author$project$Components$ResourceFilter$Patient$viewNew,
				_List_fromArray(
					[
						$author$project$Components$ResourceFilter$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
						$author$project$Components$ResourceFilter$errors(
						A2($author$project$Utils$Form$validationErrors, 4, form))
					]),
				patientResourceFilter));
	});
var $author$project$Components$BrokerDeal$CreateModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	var dealStartDate = function () {
		var _v6 = _Utils_Tuple3(fields.M2, fields.ab9, fields.ja);
		_v6$2:
		while (true) {
			if (!_v6.a) {
				if (!_v6.b.$) {
					var _v7 = _v6.a;
					var company = _v6.b.a;
					return $elm$core$Maybe$Just(
						A2(
							$justinmimbs$date$Date$fromPosix,
							model.Hz,
							$author$project$Components$BrokerDeal$CreateModal$companyCreatedAt(company)));
				} else {
					break _v6$2;
				}
			} else {
				if (!_v6.c.$) {
					var _v8 = _v6.a;
					var membership = _v6.c.a;
					return $elm$core$Maybe$Just(
						$author$project$Api$Provider$Membership$One$startDate(membership));
				} else {
					break _v6$2;
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	}();
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$BrokerDeal$CreateModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Create deal')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$CreateModal$Create),
								$author$project$Ui$Form$horizontal
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										function () {
										var _v1 = _Utils_Tuple2(model.agv, model.ab9);
										if (_v1.a && (_v1.b.$ === 1)) {
											var _v2 = _v1.b;
											return A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Deal Category'),
														$author$project$Ui$Form$Group$labelSpan(3),
														$author$project$Ui$Form$Group$inputSpan(9)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Button$group(
														_List_fromArray(
															[
																A3($author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton, fields.M2, 0, 'Employer'),
																A3($author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton, fields.M2, 1, 'Retail')
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]),
									function () {
									var _v3 = fields.M2;
									if (!_v3) {
										return $elm$core$List$concat(
											_List_fromArray(
												[
													_List_fromArray(
													[
														function () {
														var _v4 = model.ab9;
														if (!_v4.$) {
															return $author$project$Utils$Html$empty;
														} else {
															return A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$label('Employer name'),
																		$author$project$Ui$Form$Group$labelSpan(3),
																		$author$project$Ui$Form$Group$inputSpan(9),
																		$author$project$Ui$Form$Group$required(true)
																	]),
																_List_fromArray(
																	[
																		A2($author$project$Components$BrokerDeal$CreateModal$viewCompanyResourceFilter, model.pV, model.PB)
																	]));
														}
													}(),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Broker'),
																$author$project$Ui$Form$Group$labelSpan(3),
																$author$project$Ui$Form$Group$inputSpan(9),
																$author$project$Ui$Form$Group$required(true)
															]),
														_List_fromArray(
															[
																A2($author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter, model.lf, model.PB)
															]))
													]),
													A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg),
													A2(
														$author$project$Components$PricingStructureSelect$view,
														_List_fromArray(
															[
																$author$project$Components$PricingStructureSelect$value(fields.W2),
																$author$project$Components$PricingStructureSelect$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
																$author$project$Components$PricingStructureSelect$errors(
																A2($author$project$Utils$Form$validationErrors, 0, model.PB)),
																$author$project$Components$PricingStructureSelect$labelSpan(3),
																$author$project$Components$PricingStructureSelect$inputSpan(9)
															]),
														model.nG))
												]));
									} else {
										return _List_fromArray(
											[
												(!fields.xu) ? A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Patient Name'),
														$author$project$Ui$Form$Group$labelSpan(3),
														$author$project$Ui$Form$Group$inputSpan(9),
														$author$project$Ui$Form$Group$required(true)
													]),
												_List_fromArray(
													[
														A2($author$project$Components$BrokerDeal$CreateModal$viewPatientResourceFilter, model.rU, model.PB)
													])) : $author$project$Utils$Html$empty,
												((!fields.xu) && $author$project$Utils$Maybe$toBool(fields.yS)) ? $author$project$Components$BrokerDeal$CreateModal$viewMembership(model.PB) : $author$project$Utils$Html$empty,
												A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Broker'),
														$author$project$Ui$Form$Group$labelSpan(3),
														$author$project$Ui$Form$Group$inputSpan(9),
														$author$project$Ui$Form$Group$required(true)
													]),
												_List_fromArray(
													[
														A2($author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter, model.lf, model.PB)
													])),
												function () {
												var _v5 = fields.vJ;
												if (!_v5.$) {
													var broker = _v5.a;
													return A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Rate'),
																$author$project$Ui$Form$Group$labelSpan(3),
																$author$project$Ui$Form$Group$inputSpan(9)
															]),
														_List_fromArray(
															[
																$author$project$Components$BrokerDeal$CreateModal$viewBrokerTimeline(broker)
															]));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									}
								}(),
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Track From'),
												$author$project$Ui$Form$Group$labelSpan(3),
												$author$project$Ui$Form$Group$inputSpan(9)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(fields.aby),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$BrokerDeal$CreateModal$FormUpdated, $author$project$Components$BrokerDeal$CreateModal$BillFrom))
													]),
												A3($author$project$Components$BrokerDeal$CreateModal$billFromOptions, model.cO, model.Lp, dealStartDate))
											]))
									])
								]))),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$CreateModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Add broker deal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.o$, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$CreateModal$Create)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Components$BrokerDeal$Table$tableHeaders = F2(
	function (fromBrokerAccount, fromCompany) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					fromBrokerAccount ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Category')
							]))
					]) : _List_Nil,
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								fromBrokerAccount ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Broker')
							]))
					]),
					fromCompany ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Account')
							]))
					]) : _List_Nil,
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(6)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Rate')
							]))
					])
				]));
	});
var $author$project$Components$BrokerDeal$Table$ToogleEnded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$BrokerDeal$Meta$hasEndedRates = function (_v0) {
	var meta = _v0;
	return meta.P5;
};
var $author$project$Components$BrokerDeal$Timeline$AddBrokerDealRate = {$: 3};
var $author$project$Components$BrokerDeal$Timeline$AddEndDate = {$: 10};
var $author$project$Components$BrokerDeal$Timeline$CancelBrokerDealRate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$Delete = {$: 0};
var $author$project$Components$BrokerDeal$Timeline$EditBrokerDealRate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$Restart = {$: 12};
var $author$project$Components$BrokerDeal$Timeline$UpdateEndDate = {$: 9};
var $author$project$Ui$SvgIcon$calendar = $author$project$Ui$SvgIcon$viewIcon(53);
var $author$project$Api$Provider$BrokerDeal$Meta$dateEditable = function (_v0) {
	var meta = _v0;
	return meta.MP;
};
var $author$project$Api$Provider$BrokerDeal$Meta$destroyable = function (_v0) {
	var meta = _v0;
	return meta.NC;
};
var $author$project$Api$Provider$BrokerDeal$Meta$editable = function (_v0) {
	var meta = _v0;
	return meta.Oa;
};
var $author$project$Api$Provider$BrokerDeal$Meta$endable = function (_v0) {
	var meta = _v0;
	return meta.Oz;
};
var $author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal = function (_v0) {
	var meta = _v0;
	return meta.P4;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isFuture = function (_v0) {
	var record = _v0.b;
	return record.RN;
};
var $author$project$Api$Provider$BrokerDeal$Meta$isMembershipType = function (_v0) {
	var meta = _v0;
	return meta.RS;
};
var $author$project$Api$Provider$BrokerDeal$Meta$restartable = function (_v0) {
	var meta = _v0;
	return meta.Yw;
};
var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isEnded = function (_v0) {
	var record = _v0.b;
	return record.RL;
};
var $author$project$Components$BrokerDeal$Timeline$viewRate = F2(
	function (controls, brokerDealRate) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$muted,
							$author$project$Ui$Typography$margin(2)
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate(brokerDealRate);
							if (!_v0.$) {
								var startDate = _v0.a;
								return $elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate));
							} else {
								return $elm$html$Html$text('Start of the deal');
							}
						}()
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description(brokerDealRate)),
							controls(brokerDealRate)
						]))
				]));
	});
var $author$project$Components$BrokerDeal$Timeline$view = F5(
	function (showEnded, brokerDeal, controls1, controls2, brokerDealRateControls) {
		var rates = $elm$core$List$reverse(
			A2(
				$elm$core$List$filter,
				function (rate) {
					return (!$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isEnded(rate)) || showEnded;
				},
				brokerDeal.XM));
		var meta = brokerDeal.TU;
		var endDate = A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate,
			$elm$core$List$head(brokerDeal.XM));
		var hasEndDate = $author$project$Utils$Maybe$toBool(endDate);
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Components$BrokerDeal$Timeline$viewRate(brokerDealRateControls),
						rates),
						(hasEndDate || $author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal(meta)) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('timeline__item timeline__item--error')
								]),
							_List_fromArray(
								[
									function () {
									if (!endDate.$) {
										var endDate_ = endDate.a;
										return A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('End of deal: '),
													$elm$html$Html$text(
													A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate_))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									controls1
								]))
						]) : _List_Nil,
						(!hasEndDate) ? _List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('timeline__item')
								]),
							_List_fromArray(
								[
									controls2,
									$author$project$Api$Provider$BrokerDeal$Meta$isMembershipType(meta) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted mb-075')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Recurring Deal')
										])) : $author$project$Utils$Html$empty
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$BrokerDeal$Timeline$viewWithControls = function (model) {
	var meta = model.J8.TU;
	return A5(
		$author$project$Components$BrokerDeal$Timeline$view,
		model.agX,
		model.J8,
		A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					$author$project$Api$Provider$BrokerDeal$Meta$dateEditable(meta) ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Change broker deal end date'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$UpdateEndDate),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$calendar)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Change end date')
						])) : $author$project$Utils$Html$empty,
					$author$project$Api$Provider$BrokerDeal$Meta$restartable(meta) ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Restar broker deal'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$Restart),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Restart')
						])) : $author$project$Utils$Html$empty,
					$author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal(meta) ? A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$gray]),
					_List_fromArray(
						[
							$author$project$Api$Provider$BrokerDeal$Meta$isMembershipType(meta) ? $elm$html$Html$text('Membership has ended') : $elm$html$Html$text('Employer is inactive')
						])) : $author$project$Utils$Html$empty,
					$author$project$Api$Provider$BrokerDeal$Meta$destroyable(meta) ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Delete broker deal'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$Delete),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						])) : $author$project$Utils$Html$empty
				])),
		A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					$author$project$Api$Provider$BrokerDeal$Meta$editable(meta) ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Add deal rate'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$AddBrokerDealRate),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Rate Change')
						])) : $author$project$Utils$Html$empty,
					$author$project$Api$Provider$BrokerDeal$Meta$endable(meta) ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Add end date'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$AddEndDate),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add End Date')
						])) : $author$project$Utils$Html$empty
				])),
		function (brokerDealRate) {
			return $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isFuture(brokerDealRate) ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Edit rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$BrokerDeal$Timeline$EditBrokerDealRate(brokerDealRate)),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit Rate Change')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel deal rate change'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$BrokerDeal$Timeline$CancelBrokerDealRate(brokerDealRate)),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel Rate Change')
							]))
					])) : $author$project$Utils$Html$empty;
		});
};
var $author$project$Components$BrokerDeal$Table$viewBrokerDeal = F6(
	function (ended, fromBrokerAccount, fromCompany, model, index, _v0) {
		var brokerDeal = _v0.a;
		var timeline = _v0.b;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						fromBrokerAccount ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(brokerDeal.M1)
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(brokerDeal.M2)
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Broker$Shared$name(brokerDeal.vJ))
								]))
						]),
						fromCompany ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$BrokerAccount$Shared$name(
										$author$project$Api$Provider$Broker$Shared$brokerAccount(brokerDeal.vJ)))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if ((!ended) && $author$project$Api$Provider$BrokerDeal$Meta$hasEndedRates(brokerDeal.TU)) {
										var showEndedOnTimeline = A2($elm$core$Set$member, index, model.gK);
										var label = showEndedOnTimeline ? 'Hide expired rates' : 'See expired rates';
										return A3(
											$author$project$Ui$Button$view,
											{abp: label},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$size(0),
													$author$project$Ui$Button$onClick(
													$author$project$Components$BrokerDeal$Table$ToogleEnded(index))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(label)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$elm$html$Html$map,
									$author$project$Components$BrokerDeal$Table$TimelineMsg(index),
									$author$project$Components$BrokerDeal$Timeline$viewWithControls(timeline))
								]))
						])
					])));
	});
var $author$project$Components$BrokerDeal$Table$view = F2(
	function (options, model) {
		return A4(
			$author$project$Ui$Table$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							model.l3 ? $elm$html$Html$text('No ended deals.') : $elm$html$Html$text('No deals found.')
						])),
				options),
			A2($author$project$Components$BrokerDeal$Table$tableHeaders, model.qI, model.qJ),
			A2(
				$elm$core$List$indexedMap,
				A4($author$project$Components$BrokerDeal$Table$viewBrokerDeal, model.l3, model.qI, model.qJ, model),
				model.J9),
			_List_Nil);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewBrokerResourceFilter = function (brokerResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_Nil, brokerResourceFilter));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel = function (dealType) {
	if (!dealType) {
		return 'Employer';
	} else {
		return 'Retail';
	}
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewTypeDropdown = function (model) {
	var currentLabel = function () {
		var _v0 = model.ahI;
		if (!_v0.$) {
			var dealType = _v0.a;
			return $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel(dealType);
		} else {
			return 'Categories';
		}
	}();
	var allTypes = _List_fromArray(
		[0, 1]);
	var items = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected($elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Categories')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				function (dealType) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected(
									$elm$core$Maybe$Just(dealType)))
							]),
						$elm$html$Html$text(
							$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel(dealType)));
				},
				allTypes)));
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.oU);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$modal(model.dt)),
				function () {
				var _v0 = model.hY;
				if (!_v0.$) {
					var createModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg,
						$author$project$Components$BrokerDeal$CreateModal$view(createModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Active Deals')
											])),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals(
											{bP: model.bP}),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See Ended Deals')
											]))
									])),
								$author$project$Ui$Clearfix$view,
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(10)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('A deal represents the relationship between a broker and their commission. If you need to remove a deal, make sure that it is ended first.')
													]))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search deal')
														]),
													model.sA))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewBrokerResourceFilter(model.lf)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewTypeDropdown(model)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(2)
											]),
										_List_fromArray(
											[
												function () {
												var _v1 = model.vK;
												if (_v1.$ === 3) {
													var brokerAccount = _v1.a;
													return A3(
														$author$project$Ui$Button$view,
														{abp: 'Create deal'},
														_List_fromArray(
															[
																$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
																$author$project$Ui$Button$onClick(
																$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Create(brokerAccount))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Create Deal')
															]));
												} else {
													return $author$project$Ui$Skeleton$input(_List_Nil);
												}
											}()
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg,
								A2(
									$author$project$Components$BrokerDeal$Table$view,
									_List_fromArray(
										[
											$author$project$Components$BrokerDeal$Table$loading(
											!$author$project$Api$Data$isSuccess(model.J9))
										]),
									model.dt))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.J9))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Commissions | Broker Deals'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('broker'),
			model.Eo)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals(
					{bP: model.bP}))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$GotBrokerDeals = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals = function (model) {
	return A3(
		$author$project$Api$Provider$BrokerDeal$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					vJ: model.Eo,
					vK: $elm$core$Maybe$Just(model.bP),
					QR: $elm$core$Maybe$Just(true),
					afy: model.afy,
					af_: model.af_
				});
		},
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$GotBrokerDeals);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var brokerId = A2($elm$core$Dict$get, 'broker', query);
		var _v1 = A3(
			$author$project$Components$ResourceFilter$Broker$init,
			shared.D5,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Brokers', afT: brokerId});
			});
		var brokerResourceFilter = _v1.a;
		var brokerResourceFilterCmd = _v1.b;
		var model = {
			D5: shared.D5,
			bP: params.bP,
			J9: $author$project$Api$Data$Loading,
			dt: A3(
				$author$project$Components$BrokerDeal$Table$init,
				session,
				shared.cO,
				{l3: true, qI: true, qJ: false}),
			Eo: brokerId,
			lf: brokerResourceFilter,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg, brokerResourceFilterCmd),
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model),
						A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dt: A2($author$project$Components$BrokerDeal$Table$load, shared.cO, model.dt)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$subscriptions = function (_v0) {
	var brokerDealsTable = _v0.dt;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg,
		$author$project$Components$BrokerDeal$Table$subscriptions(brokerDealsTable));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerDeals = response.a;
					var headers = response.b;
					var brokerDealsTable = A2(
						$author$project$Components$BrokerDeal$Table$withBrokerDeals,
						A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals),
						model.dt);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								J9: response,
								dt: brokerDealsTable,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{J9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.D5, subMsg, model.dt);
				var _v2 = function () {
					var _v3 = brokerDealsTableResult.ac5;
					switch (_v3) {
						case 0:
							return _Utils_Tuple2(model.J9, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						case 4:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						case 5:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
					}
				}();
				var brokerDeals = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{J9: brokerDeals, dt: brokerDealsTableResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg, brokerDealsTableResult.EC),
								cmd
							])),
					brokerDealsTableResult.as);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v4.a;
				var searchInputCmd = _v4.b;
				var searchInputEvent = _v4.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v5 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								J9: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, model.D5, subMsg, model.lf);
				var brokerId = function () {
					var _v8 = brokerResourceResult.ac5;
					if (!_v8.$) {
						if (!_v8.a.$) {
							return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.y8);
						} else {
							var _v9 = _v8.a;
							return model.Eo;
						}
					} else {
						return model.Eo;
					}
				}();
				var newModel = _Utils_update(
					model,
					{Eo: brokerId, lf: brokerResourceResult.y8});
				var _v7 = _Utils_eq(model.Eo, newModel.Eo) ? _Utils_Tuple2(model.J9, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var brokerDeals = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{J9: brokerDeals}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg, brokerResourceResult.EC),
								cmd
							])),
					brokerResourceResult.as);
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$Button = 1;
var $author$project$Components$ResourceFilter$Broker$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$viewBrokerResourceFilter = function (brokerResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Broker$view,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1)
				]),
			brokerResourceFilter));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$modal(model.dt)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
														{bP: model.bP}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Active Deals')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ended Deals')
												]))
										]))),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Ended Deals')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search deal')
														]),
													model.sA))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(3)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$viewBrokerResourceFilter(model.lf)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg,
								A2(
									$author$project$Components$BrokerDeal$Table$view,
									_List_fromArray(
										[
											$author$project$Components$BrokerDeal$Table$loading(
											!$author$project$Api$Data$isSuccess(model.J9))
										]),
									model.dt))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.J9)))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Commissions | Broker Deals'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Statement$One$Statement = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Statement$Shared$Statement = $elm$core$Basics$identity;
var $author$project$Api$Provider$Statement$Shared$Record = F7(
	function (id, number, amountInCents, date, status, dueInCents, brokerAccount) {
		return {I2: amountInCents, vK: brokerAccount, MO: date, N2: dueInCents, adR: id, Gj: number, ag7: status};
	});
var $author$project$Api$Provider$Statement$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'broker_account',
	$author$project$Api$Provider$BrokerAccount$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'due_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'date',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'number',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$Shared$Record))))))));
var $author$project$Api$Provider$Statement$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Statement$One$Record = F4(
	function (brokersCount, dealsCount, securePdfInlineToken, payments) {
		return {Kb: brokersCount, M3: dealsCount, V5: payments, Ze: securePdfInlineToken};
	});
var $author$project$Api$Provider$Statement$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'payments',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'secure_pdf_inline_token',
		$author$project$Api$File$Token$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deals_count',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'brokers_count',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$One$Record)))));
var $author$project$Api$Provider$Statement$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Statement$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$One$Statement)));
var $author$project$Api$Provider$Statement$statementsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['statements']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Statement$statementPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Provider$Statement$statementsPath);
};
var $author$project$Api$Provider$Statement$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Statement$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Statement$statementPath(id)));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple2(
			{
				hq: $elm$core$Maybe$Nothing,
				D5: shared.D5,
				bP: params.bP,
				lC: $elm$core$Maybe$Nothing,
				cO: shared.cO,
				iq: $author$project$Components$Invoice$DownloadFile$init(shared.aav),
				FR: $author$project$Shared$isHintAdmin(shared),
				mJ: $author$project$Api$Data$NotAsked,
				jr: A4(
					$author$project$Components$PaymentsList$init,
					shared.Hy,
					$author$project$Api$Provider$Statement$statementPath(params.ag6),
					session,
					true),
				WF: practice,
				sj: shared.sj,
				ZD: session,
				Hm: $author$project$Api$Data$Loading,
				ag6: params.ag6,
				s8: $author$project$Api$Data$Loading,
				km: $elm$core$Dict$empty,
				Hy: shared.Hy
			},
			A3($author$project$Api$Provider$Statement$retrieve, shared.D5, params.ag6, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Close = {$: 0};
var $author$project$Components$Commissions$Statement$AdjustmentModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$Statement$AdjustmentModal$Close);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg,
				$author$project$Components$PaymentsList$subscriptions(model.jr)),
				function () {
				var _v0 = model.lC;
				if (!_v0.$) {
					var createPaymentModal = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg,
						$author$project$Components$Invoice$CreatePaymentModal$subscriptions(createPaymentModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v1 = model.hq;
				if (!_v1.$) {
					var adjustmentModal = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg,
						$author$project$Components$Commissions$Statement$AdjustmentModal$subscriptions(adjustmentModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Api$Provider$Statement$SummaryLine$Broker = 0;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotSummaryLines = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issued = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$Provider$Statement$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Statement$One$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$amountInCents(shared);
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Bonus = 0;
var $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory = 0;
var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsInit = F2(
	function (apiClient, brokerAccountId) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Broker$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						vK: $elm$core$Maybe$Just(brokerAccountId),
						Gg: $elm$core$Maybe$Just(true)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'None', aeZ: false});
			});
		var brokerResourceFilter = _v0.a;
		var brokerResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{I2: $elm$core$Maybe$Nothing, vJ: $elm$core$Maybe$Nothing, lf: brokerResourceFilter, Ex: $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory, aeC: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg, brokerResourceFilterCmd));
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$init = F3(
	function (apiClient, brokerAccountId, statement) {
		var _v0 = A2($author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsInit, apiClient, brokerAccountId);
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				NJ: false,
				PB: $author$project$Utils$Form$init(formFields),
				jY: $author$project$Api$Data$NotAsked,
				Hm: statement
			},
			formFieldsCmd);
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$init = F2(
	function (statement, summaryLine) {
		return {of: false, Hm: statement, Hr: summaryLine, s8: $author$project$Api$Data$NotAsked};
	});
var $author$project$Components$Invoice$CreatePaymentModal$ElectronicFundsTransfer = 3;
var $author$project$Components$Invoice$CreatePaymentModal$Statement = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$initCreatePaymentModal = F2(
	function (statement, model) {
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.cO)(model.Hy)(
			$author$project$Api$Provider$Statement$statementPath(model.ag6))($elm$core$Maybe$Nothing)(model.D5)(model.ZD)(
			$author$project$Api$Practice$Provider(model.WF))(model.FR)(model.sj)(
			function (d) {
				return _Utils_update(
					d,
					{
						O4: true,
						Fe: _List_fromArray(
							[0, 3, 4]),
						oo: model.FR
					});
			})(
			A2($author$project$Components$Invoice$CreatePaymentModal$Statement, model.bP, statement));
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					lC: $elm$core$Maybe$Just(createPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Api$Provider$Statement$issue = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statement',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'amount_in_cents',
								$elm$json$Json$Encode$int(fields.I2))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Statement$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['issue']),
						$author$project$Api$Provider$Statement$statementPath(id)))));
	});
var $author$project$Api$Provider$Statement$SummaryLine$All$SummaryLine = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Statement$SummaryLine$Shared$SummaryLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Statement$SummaryLine$Shared$Record = F6(
	function (membershipsCount, linesCount, patientsCount, payableAmountInCents, liabilityAmountInCents, totalRateAmountInCents) {
		return {SM: liabilityAmountInCents, ST: linesCount, TO: membershipsCount, VS: patientsCount, VT: payableAmountInCents, $Z: totalRateAmountInCents};
	});
var $author$project$Api$Provider$Statement$SummaryLine$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total_rate_amount_in_cents',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'liability_amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payable_amount_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patients_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'lines_count',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'memberships_count',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$Shared$Record)))))));
var $author$project$Api$Provider$Statement$SummaryLine$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$SummaryLine$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Statement$SummaryLine$All$Record = F6(
	function (payable, category, inStatementPeriod, categoryName, invoice, broker) {
		return {vJ: broker, Ex: category, KM: categoryName, QQ: inStatementPeriod, Rh: invoice, afF: payable};
	});
var $author$project$Api$Provider$Broker$Min$Broker = $elm$core$Basics$identity;
var $author$project$Api$Provider$Broker$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$Broker$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Broker$Min$Record)));
var $author$project$Api$Provider$Broker$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Broker$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Invoice$MinWithCompany$Invoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Invoice$MinWithCompany$Record = function (company) {
	return {ab9: company};
};
var $author$project$Api$Provider$Invoice$MinWithCompany$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company',
	$author$project$Api$Provider$Company$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$MinWithCompany$Record));
var $author$project$Api$Provider$Invoice$MinWithCompany$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Invoice$MinWithCompany$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Invoice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$MinWithCompany$Invoice)));
var $author$project$Api$Provider$Statement$SummaryLine$All$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'broker',
	$author$project$Api$Provider$Broker$Min$decoder,
	A3(
		$author$project$Api$Expandable$expandable,
		'invoice',
		$author$project$Api$Provider$Invoice$MinWithCompany$decoder,
		A3(
			$author$project$Api$Expandable$expandable,
			'category_name',
			$elm$json$Json$Decode$string,
			A3(
				$author$project$Api$Expandable$expandable,
				'in_statement_period',
				$elm$json$Json$Decode$bool,
				A3(
					$author$project$Api$Expandable$expandable,
					'category',
					$elm$json$Json$Decode$string,
					A3(
						$author$project$Api$Expandable$expandable,
						'payable',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$All$Record)))))));
var $author$project$Api$Provider$Statement$SummaryLine$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$SummaryLine$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Statement$SummaryLine$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$All$SummaryLine)));
var $author$project$Api$Provider$Statement$SummaryLine$expandToString = function (expand) {
	switch (expand) {
		case 0:
			return 'broker';
		case 1:
			return 'category_name';
		case 3:
			return 'period';
		case 4:
			return 'payable';
		default:
			return 'category_type';
	}
};
var $author$project$Api$Provider$Statement$SummaryLine$listDefaults = {Eo: $elm$core$Maybe$Nothing, Fc: _List_Nil};
var $author$project$Api$Provider$Statement$SummaryLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Statement$SummaryLine$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Eo;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker_id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Statement$SummaryLine$expandToString, options.Fc)
			]));
};
var $author$project$Api$Provider$Statement$SummaryLine$summaryLinesPath = function (statementId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['summary_lines']),
		$author$project$Api$Provider$Statement$statementPath(statementId));
};
var $author$project$Api$Provider$Statement$SummaryLine$list = F4(
	function (apiClient, statementId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Statement$SummaryLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Statement$SummaryLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Statement$SummaryLine$summaryLinesPath(statementId))));
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$AdjustmentCreated = 2;
var $author$project$Components$Commissions$Statement$AdjustmentModal$Broker = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Closed = 1;
var $author$project$Components$Commissions$Statement$AdjustmentModal$None = 0;
var $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCentsValidation = 1;
var $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerValidation = 0;
var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.vJ;
			},
			_Utils_Tuple2(0, 'Please pick a broker.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.I2;
			},
			_Utils_Tuple2(1, 'Please enter an amount.'))
		]));
var $author$project$Components$Commissions$Statement$AdjustmentModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Statement$Adjustment$adjustmentsPath = function (statementId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['adjustments']),
		$author$project$Api$Provider$Statement$statementPath(statementId));
};
var $author$project$Api$Provider$StatementAdjustment$One$StatementAdjustment = 0;
var $author$project$Api$Provider$StatementAdjustment$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Statement$Adjustment$create = F4(
	function (apiClient, statementId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'statement_adjustment',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'category',
								$elm$json$Json$Encode$string(fields.Ex)),
								_Utils_Tuple2(
								'broker',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.vJ)),
								_Utils_Tuple2(
								'amount_in_cents',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.I2)),
								_Utils_Tuple2(
								'memo',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aeC))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$StatementAdjustment$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Statement$Adjustment$adjustmentsPath(statementId))));
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$createParams = function (fields) {
	var category = function () {
		var _v0 = fields.Ex;
		switch (_v0) {
			case 0:
				return 'bonus';
			case 1:
				return 'correction';
			default:
				return 'other';
		}
	}();
	return {
		I2: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.I2),
		vJ: fields.vJ,
		Ex: category,
		aeC: fields.aeC
	};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$save = F3(
	function (apiClient, model, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Statement$Adjustment$create,
			apiClient,
			$author$project$Api$Provider$Statement$One$id(model.Hm),
			$author$project$Components$Commissions$Statement$AdjustmentModal$createParams(fields),
			$author$project$Components$Commissions$Statement$AdjustmentModal$Created);
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$Correction = 1;
var $author$project$Components$Commissions$Statement$AdjustmentModal$Other = 2;
var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryFromString = function (string) {
	switch (string) {
		case 'Bonus':
			return 0;
		case 'Correction':
			return 1;
		case 'Other':
			return 2;
		default:
			return $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory;
	}
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aeC: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ex: $author$project$Components$Commissions$Statement$AdjustmentModal$categoryFromString(string)
					});
			case 2:
				var broker = field.a;
				return _Utils_update(
					fields,
					{
						vJ: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, broker)
					});
			default:
				var _int = field.a;
				return _Utils_update(
					fields,
					{I2: _int});
		}
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$updateForm = F3(
	function (model, field, form) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsUpdate, field, form);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{PB: newForm}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				var field = msg.a;
				var _v2 = A3($author$project$Components$Commissions$Statement$AdjustmentModal$updateForm, model, field, model.PB);
				var newModel = _v2.a;
				var formCmd = _v2.b;
				return {EC: formCmd, ac5: 0, y8: newModel, as: _List_Nil};
			case 2:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsValidator, model.PB);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return {
						EC: A3($author$project$Components$Commissions$Statement$AdjustmentModal$save, apiClient, model, validFormFields),
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm, jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v3.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Statement Ajusted')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, fields.lf);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{lf: brokerResourceResult.y8}),
					model.PB);
				var _v6 = function () {
					var _v7 = brokerResourceResult.ac5;
					_v7$2:
					while (true) {
						if ((!_v7.$) && (!_v7.a.$)) {
							switch (_v7.a.a.$) {
								case 0:
									var broker = _v7.a.a.a;
									return A3(
										$author$project$Components$Commissions$Statement$AdjustmentModal$updateForm,
										model,
										$author$project$Components$Commissions$Statement$AdjustmentModal$Broker(
											$elm$core$Maybe$Just(broker)),
										newForm);
								case 2:
									var _v8 = _v7.a.a;
									return A3(
										$author$project$Components$Commissions$Statement$AdjustmentModal$updateForm,
										model,
										$author$project$Components$Commissions$Statement$AdjustmentModal$Broker($elm$core$Maybe$Nothing),
										newForm);
								default:
									break _v7$2;
							}
						} else {
							break _v7$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v6.a;
				var formCmd = _v6.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg, brokerResourceResult.EC),
								formCmd
							])),
					ac5: 0,
					y8: newModel,
					as: brokerResourceResult.as
				};
		}
	});
var $author$project$Api$Provider$Statement$SummaryLine$CategoryName = 1;
var $author$project$Api$Provider$Statement$SummaryLine$CategoryType = 2;
var $author$project$Components$Commissions$Statement$SummaryLine$Details$GotSummaryLines = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Statement$SummaryLine$Payable = 4;
var $author$project$Api$Provider$Statement$SummaryLine$Period = 3;
var $author$project$Api$Provider$Statement$SummaryLine$All$broker = function (_v0) {
	var record = _v0.b;
	return record.vJ;
};
var $author$project$Api$Provider$Statement$One$brokersCount = function (_v0) {
	var record = _v0.b;
	return record.Kb;
};
var $author$project$Api$Provider$Statement$One$dealsCount = function (_v0) {
	var record = _v0.b;
	return record.M3;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView = function (statement) {
	return _Utils_cmp(
		$author$project$Api$Provider$Statement$One$brokersCount(statement) * 10,
		$author$project$Api$Provider$Statement$One$dealsCount(statement)) > -1;
};
var $author$project$Api$Provider$Broker$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$retrieveSummaryLines = F3(
	function (apiClient, statement, summaryLine) {
		var expand = $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement) ? _List_fromArray(
			[1, 3, 4]) : _List_fromArray(
			[4, 3, 2]);
		var brokerId = $author$project$Api$Expandable$toMaybe(
			A2(
				$author$project$Api$Expandable$map,
				$author$project$Api$Provider$Broker$Min$id,
				$author$project$Api$Provider$Statement$SummaryLine$All$broker(summaryLine)));
		return A4(
			$author$project$Api$Provider$Statement$SummaryLine$list,
			apiClient,
			$author$project$Api$Provider$Statement$One$id(statement),
			function (d) {
				return _Utils_update(
					d,
					{Eo: brokerId, Fc: expand});
			},
			$author$project$Components$Commissions$Statement$SummaryLine$Details$GotSummaryLines);
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{of: !model.of}),
				function () {
					var _v1 = model.s8;
					if (_v1.$ === 3) {
						return $elm$core$Platform$Cmd$none;
					} else {
						return A3($author$project$Components$Commissions$Statement$SummaryLine$Details$retrieveSummaryLines, apiClient, model.Hm, model.Hr);
					}
				}(),
				_List_Nil);
		} else {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{s8: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var statement = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Hm: response}),
						A4(
							$author$project$Api$Provider$Statement$SummaryLine$list,
							model.D5,
							model.ag6,
							function (d) {
								return _Utils_update(
									d,
									{
										Fc: _List_fromArray(
											[0])
									});
							},
							$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotSummaryLines(statement)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Hm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var statement = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var summaryLines = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								s8: response,
								km: $elm$core$Dict$fromList(
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, summaryLine) {
												var summaryLineDetails = A2($author$project$Components$Commissions$Statement$SummaryLine$Details$init, statement, summaryLine);
												return _Utils_Tuple2(index, summaryLineDetails);
											}),
										summaryLines))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{s8: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var statement = msg.a;
				var _v3 = A3($author$project$Components$Commissions$Statement$AdjustmentModal$init, model.D5, model.bP, statement);
				var adjustmentModal = _v3.a;
				var adjustmentModalCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hq: $elm$core$Maybe$Just(adjustmentModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg, adjustmentModalCmd),
					_List_Nil);
			case 3:
				var statement = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mJ: $author$project$Api$Data$Loading}),
					A4(
						$author$project$Api$Provider$Statement$issue,
						model.D5,
						model.ag6,
						{
							I2: $author$project$Api$Provider$Statement$One$amountInCents(statement)
						},
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issued),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mJ: $author$project$Api$Data$NotAsked, Hm: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Statement issued')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mJ: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var statement = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$initCreatePaymentModal, statement, model));
			case 6:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.D5, subMsg, model.iq);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iq: downloadInvoiceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg, downloadInvoiceResult.EC),
					downloadInvoiceResult.as);
			case 7:
				var subMsg = msg.a;
				var paymentsListResult = A3($author$project$Components$PaymentsList$update, model.D5, subMsg, model.jr);
				var _v5 = function () {
					var _v6 = paymentsListResult.ac5;
					switch (_v6) {
						case 0:
							return _Utils_Tuple2(model.Hm, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.D5, model.ag6, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.D5, model.ag6, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.D5, model.ag6, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A3($author$project$Api$Provider$Statement$retrieve, model.D5, model.ag6, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
					}
				}();
				var statement = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jr: paymentsListResult.y8, Hm: statement}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg, paymentsListResult.EC),
								cmd
							])),
					paymentsListResult.as);
			case 8:
				var subMsg = msg.a;
				var _v7 = model.lC;
				if (!_v7.$) {
					var createPaymentModal = _v7.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.D5, subMsg, createPaymentModal);
					var _v8 = function () {
						var _v9 = createPaymentModalResult.ac5;
						switch (_v9) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.y8),
									model.Hm,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Api$Provider$Statement$retrieve, model.D5, model.ag6, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Hm, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v8.a;
					var statement = _v8.b;
					var cmd = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lC: createPaymentModal_, Hm: statement}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg, createPaymentModalResult.EC),
									cmd
								])),
						createPaymentModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var id = msg.a;
				var subMsg = msg.b;
				var _v10 = A2($elm$core$Dict$get, id, model.km);
				if (!_v10.$) {
					var summaryLineDetails = _v10.a;
					var _v11 = A3($author$project$Components$Commissions$Statement$SummaryLine$Details$update, model.D5, subMsg, summaryLineDetails);
					var summaryLineDetails_ = _v11.a;
					var summaryLineDetailsCmd = _v11.b;
					var summaryLineDetailsOutMsgs = _v11.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								km: A3($elm$core$Dict$insert, id, summaryLineDetails_, model.km)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(id),
							summaryLineDetailsCmd),
						summaryLineDetailsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v12 = model.hq;
				if (!_v12.$) {
					var adjustmentModal = _v12.a;
					var adjustmentModalResult = A3($author$project$Components$Commissions$Statement$AdjustmentModal$update, model.D5, subMsg, adjustmentModal);
					var _v13 = function () {
						var _v14 = adjustmentModalResult.ac5;
						switch (_v14) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(adjustmentModalResult.y8),
									model.Hm,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A3($author$project$Api$Provider$Statement$retrieve, model.D5, model.ag6, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Hm, $elm$core$Platform$Cmd$none);
						}
					}();
					var adjustmentModal_ = _v13.a;
					var statement = _v13.b;
					var cmd = _v13.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hq: adjustmentModal_, Hm: statement}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg, adjustmentModalResult.EC),
									cmd
								])),
						adjustmentModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Commissions$Statement$AdjustmentModal$Save = {$: 2};
var $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewAmountInCentsFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var amountInCents = _v0.I2;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Amount'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_fromArray(
					[$author$project$Ui$FlexGrid$rowItemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(6)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$CurrencyInput$value(amountInCents),
										$author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
										$author$project$Ui$Form$CurrencyInput$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCents)),
										$author$project$Ui$Form$CurrencyInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, form))
									])),
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, 1, form))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$muted,
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Amounts can be negative')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewBrokerFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var brokerResourceFilter = _v0.lf;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Broker'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Broker$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0),
							$author$project$Components$ResourceFilter$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Components$ResourceFilter$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]),
					brokerResourceFilter))
			]));
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Category = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$allCategories = _List_fromArray(
	[0, 1, 2]);
var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString = function (category) {
	switch (category) {
		case 0:
			return 'Bonus';
		case 1:
			return 'Correction';
		default:
			return 'Other';
	}
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryOptions = A2(
	$elm$core$List$map,
	function (category) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category)),
			$author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category));
	},
	$author$project$Components$Commissions$Statement$AdjustmentModal$allCategories);
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewCategoryFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var category = _v0.Ex;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Category'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(
							$author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category))),
						$author$project$Ui$Form$Select$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$Category))
					]),
				$author$project$Components$Commissions$Statement$AdjustmentModal$categoryOptions)
			]));
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$Memo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewMemoFormGroup = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var memo = _v0.aeC;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Memo'),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', memo)),
						$author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$Memo))
					]))
			]));
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$viewFormGroups = function (form) {
	return _List_fromArray(
		[
			$author$project$Components$Commissions$Statement$AdjustmentModal$viewCategoryFormGroup(form),
			$author$project$Components$Commissions$Statement$AdjustmentModal$viewBrokerFormGroup(form),
			$author$project$Components$Commissions$Statement$AdjustmentModal$viewAmountInCentsFormGroup(form),
			$author$project$Components$Commissions$Statement$AdjustmentModal$viewMemoFormGroup(form)
		]);
};
var $author$project$Components$Commissions$Statement$AdjustmentModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$Statement$AdjustmentModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Add Adjustment')
							]))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$Statement$AdjustmentModal$Save),
								$author$project$Ui$Form$horizontal
							]),
						$author$project$Components$Commissions$Statement$AdjustmentModal$viewFormGroups(model.PB))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$AdjustmentModal$Close)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Confirm adjustment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$AdjustmentModal$Save),
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.jY, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm Adjustment')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Adjust = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$FontWeight$Medium = 0;
var $author$project$Api$Provider$Statement$Shared$date = function (_v0) {
	var record = _v0;
	return record.MO;
};
var $author$project$Api$Provider$Statement$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$date(shared);
};
var $author$project$Api$Provider$Statement$Shared$number = function (_v0) {
	var record = _v0;
	return record.Gj;
};
var $author$project$Api$Provider$Statement$One$number = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$number(shared);
};
var $author$project$Api$Provider$Statement$One$securePdfInlineToken = function (_v0) {
	var record = _v0.b;
	return record.Ze;
};
var $author$project$Api$Provider$Statement$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Statement$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$Shared$status(shared);
};
var $author$project$Api$Provider$Statement$One$payments = function (_v0) {
	var record = _v0.b;
	return record.V5;
};
var $author$project$Components$PaymentsList$ShowCreatedBy = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentsList$showCreatedBy = $author$project$Components$PaymentsList$ShowCreatedBy;
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPaymentsList = F3(
	function (isHintAdmin, statement, paymentsList) {
		var payments = A2(
			$elm$core$List$map,
			$author$project$Api$Payment$Provider_One,
			$author$project$Api$Provider$Statement$One$payments(statement));
		return $elm$core$List$isEmpty(payments) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Payment History')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg,
							A3(
								$author$project$Components$PaymentsList$view,
								_List_fromArray(
									[
										$author$project$Components$PaymentsList$isHintAdmin(isHintAdmin),
										$author$project$Components$PaymentsList$allowRefunds(true),
										$author$project$Components$PaymentsList$showCreatedBy(true),
										$author$project$Components$PaymentsList$showRefundMemo(true)
									]),
								payments,
								paymentsList))
						]))
				]));
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$ToggleShow = {$: 0};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$button = function (model) {
	var icon = model.of ? $author$project$Ui$SvgIcon$minus : $author$project$Ui$SvgIcon$add;
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Toggle visibility'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
				$author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$SummaryLine$Details$ToggleShow),
				$author$project$Ui$Button$icon(icon)
			]),
		_List_Nil);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$membershipsCount = function (_v0) {
	var record = _v0;
	return record.TO;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$membershipsCount(shared);
};
var $author$project$Api$Provider$Broker$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$patientsCount = function (_v0) {
	var record = _v0;
	return record.VS;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$patientsCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$patientsCount(shared);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$payableAmountInCents = function (_v0) {
	var record = _v0;
	return record.VT;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$payableAmountInCents(shared);
};
var $author$project$Ui$Padding$Top_0_5 = 7;
var $author$project$Api$Provider$Statement$SummaryLine$All$inStatementPeriod = function (_v0) {
	var record = _v0.b;
	return record.QQ;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod = function (summaryLine) {
	return $author$project$Api$Expandable$toMaybe(
		$author$project$Api$Provider$Statement$SummaryLine$All$inStatementPeriod(summaryLine));
};
var $author$project$Ui$Well$NoBorder = {$: 3};
var $author$project$Ui$Well$noBorder = $author$project$Ui$Well$NoBorder;
var $author$project$Api$Provider$Statement$SummaryLine$All$payable = function (_v0) {
	var record = _v0.b;
	return record.afF;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$payable = function (summaryLine) {
	return $author$project$Api$Expandable$toMaybe(
		$author$project$Api$Provider$Statement$SummaryLine$All$payable(summaryLine));
};
var $author$project$Ui$Typography$Capitalized = 4;
var $author$project$Ui$Typography$capitalized = $author$project$Ui$Typography$Decoration(4);
var $author$project$Api$Provider$Statement$SummaryLine$All$categoryName = function (_v0) {
	var record = _v0.b;
	return record.KM;
};
var $author$project$Api$Provider$Invoice$MinWithCompany$company = function (_v0) {
	var record = _v0.b;
	return record.ab9;
};
var $author$project$Api$Provider$Invoice$MinWithCompany$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$id(min);
};
var $author$project$Api$Provider$Statement$SummaryLine$All$invoice = function (_v0) {
	var record = _v0.b;
	return record.Rh;
};
var $author$project$Api$Provider$Invoice$MinWithCompany$invoiceNumber = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$liabilityAmountInCents = function (_v0) {
	var record = _v0;
	return record.SM;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$liabilityAmountInCents(shared);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$linesCount = function (_v0) {
	var record = _v0;
	return record.ST;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$linesCount = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$linesCount(shared);
};
var $author$project$Api$Provider$Statement$SummaryLine$Shared$totalRateAmountInCents = function (_v0) {
	var record = _v0;
	return record.$Z;
};
var $author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Statement$SummaryLine$Shared$totalRateAmountInCents(shared);
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTableRow = F2(
	function (isOutstanding, summaryLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
							_v0$4:
							while (true) {
								if (!_v0.$) {
									switch (_v0.a) {
										case 'Retail':
											return $elm$html$Html$text('--');
										case 'bonus':
											return $author$project$Utils$Html$empty;
										case 'correction':
											return $author$project$Utils$Html$empty;
										case 'other':
											return $author$project$Utils$Html$empty;
										default:
											break _v0$4;
									}
								} else {
									break _v0$4;
								}
							}
							var _v1 = $author$project$Api$Provider$Statement$SummaryLine$All$invoice(summaryLine);
							if (!_v1.$) {
								var invoice = _v1.a;
								var invoiceNumber = $author$project$Api$Provider$Invoice$MinWithCompany$invoiceNumber(invoice);
								var invoiceId = $author$project$Api$Provider$Invoice$MinWithCompany$id(invoice);
								var companyId = $author$project$Api$Provider$Company$Min$id(
									$author$project$Api$Provider$Invoice$MinWithCompany$company(invoice));
								var invoiceRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
									{ff: companyId, adR: invoiceId});
								return A3(
									$author$project$Ui$Link$route,
									invoiceRoute,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'#' + $elm$core$String$fromInt(invoiceNumber))
										]));
							} else {
								return $elm$html$Html$text('N/A');
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$capitalized]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Api$Expandable$withDefault,
										'N/A',
										$author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v2 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
							_v2$3:
							while (true) {
								if (!_v2.$) {
									switch (_v2.a) {
										case 'bonus':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'correction':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'other':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										default:
											break _v2$3;
									}
								} else {
									break _v2$3;
								}
							}
							return A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											$author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
										$elm$html$Html$text(' primary '),
										$elm$html$Html$text(
										A2(
											$author$project$Formatters$String$pluralize,
											'patient',
											$author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
									]));
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v3 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
							_v3$3:
							while (true) {
								if (!_v3.$) {
									switch (_v3.a) {
										case 'bonus':
											return $author$project$Utils$Html$empty;
										case 'correction':
											return $author$project$Utils$Html$empty;
										case 'other':
											return $author$project$Utils$Html$empty;
										default:
											break _v3$3;
									}
								} else {
									break _v3$3;
								}
							}
							return $elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents(summaryLine))));
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var amountInCents = isOutstanding ? $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents(summaryLine) : $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine);
							return $elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(amountInCents));
						}()
						]))
				]));
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTable = F2(
	function (isOutstanding, summaryLines) {
		return A4(
			$author$project$Ui$Table$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(1)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Invoice')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Employer / Category')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deal')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Total rate')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Commission')
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTableRow(isOutstanding),
				summaryLines),
			_List_Nil);
	});
var $author$project$Api$Provider$Statement$SummaryLine$All$category = function (_v0) {
	var record = _v0.b;
	return record.Ex;
};
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTableRow = F2(
	function (isOutstanding, summaryLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine);
							_v0$2:
							while (true) {
								if (!_v0.$) {
									switch (_v0.a) {
										case 'Membership':
											return $elm$html$Html$text('Retail');
										case 'Company':
											return $elm$html$Html$text('Employer');
										default:
											break _v0$2;
									}
								} else {
									break _v0$2;
								}
							}
							return $elm$html$Html$text(
								A2(
									$author$project$Api$Expandable$withDefault,
									'N/A',
									$author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine)));
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = $author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine);
							_v1$5:
							while (true) {
								if (!_v1.$) {
									switch (_v1.a) {
										case 'bonus':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'correction':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'other':
											return $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'line',
													$author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
										case 'Membership':
											return A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
														$elm$html$Html$text(' primary '),
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$String$pluralize,
															'patient',
															$author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
													]));
										case 'Company':
											return A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
														$elm$html$Html$text(' primary '),
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$String$pluralize,
															'patient',
															$author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
													]));
										default:
											break _v1$5;
									}
								} else {
									break _v1$5;
								}
							}
							return $author$project$Utils$Html$empty;
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								A2(
									$elm$core$Maybe$withDefault,
									0,
									$author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents(summaryLine))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var amountInCents = isOutstanding ? $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents(summaryLine) : $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine);
							return $elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(amountInCents));
						}()
						]))
				]));
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTable = F2(
	function (isOutstanding, summaryLines) {
		return A4(
			$author$project$Ui$Table$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Category')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deal')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Total rate')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Commission')
						]))
				]),
			A2(
				$elm$core$List$map,
				$author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTableRow(isOutstanding),
				summaryLines),
			_List_Nil);
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable = F3(
	function (expanded, isOutstanding, summaryLines) {
		return expanded ? A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTable, isOutstanding, summaryLines) : A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTable, isOutstanding, summaryLines);
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTables = F2(
	function (statement, summaryLines) {
		var previousSummaryLines = A2(
			$elm$core$List$filter,
			function (summaryLine) {
				return _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod(summaryLine),
					$elm$core$Maybe$Just(false)) && _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine),
					$elm$core$Maybe$Just(true));
			},
			summaryLines);
		var outstandingSummaryLines = A2(
			$elm$core$List$filter,
			function (summaryLine) {
				return _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine),
					$elm$core$Maybe$Just(false));
			},
			summaryLines);
		var currentSummaryLines = A2(
			$elm$core$List$filter,
			function (summaryLine) {
				return _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod(summaryLine),
					$elm$core$Maybe$Just(true)) && _Utils_eq(
					$author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine),
					$elm$core$Maybe$Just(true));
			},
			summaryLines);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$core$List$isEmpty(currentSummaryLines) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Current')
										])),
									A3(
									$author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable,
									$author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement),
									false,
									currentSummaryLines)
								]))
						])),
					$elm$core$List$isEmpty(previousSummaryLines) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Previous')
										])),
									A3(
									$author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable,
									$author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement),
									false,
									previousSummaryLines)
								]))
						])),
					$elm$core$List$isEmpty(outstandingSummaryLines) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Well$view,
									_List_fromArray(
										[$author$project$Ui$Well$small, $author$project$Ui$Well$noBorder]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$padding(7)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Outstanding')
														])),
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$gray]),
													_List_fromArray(
														[
															$elm$html$Html$text('(not reflected in totals)')
														]))
												])),
											A3(
											$author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable,
											$author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement),
											true,
											outstandingSummaryLines)
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Commissions$Statement$SummaryLine$Details$view = function (model) {
	return model.of ? A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$padding(6)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.s8;
				if (_v0.$ === 3) {
					var summaryLines = _v0.a;
					return A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTables, model.Hm, summaryLines);
				} else {
					return $author$project$Ui$Spinner$view(
						_List_fromArray(
							[$author$project$Ui$Spinner$extraSmall]));
				}
			}()
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewSummaryLine = F3(
	function (summaryLinesDetails, index, summaryLine) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(index),
											A2(
												$elm$core$Maybe$withDefault,
												$author$project$Utils$Html$empty,
												A2(
													$elm$core$Maybe$map,
													$author$project$Components$Commissions$Statement$SummaryLine$Details$button,
													A2($elm$core$Dict$get, index, summaryLinesDetails)))),
											$author$project$Utils$Html$noBreakSpace,
											$elm$html$Html$text(
											A2(
												$author$project$Api$Expandable$withDefault,
												'N/A',
												A2(
													$author$project$Api$Expandable$map,
													$author$project$Api$Provider$Broker$Min$name,
													$author$project$Api$Provider$Statement$SummaryLine$All$broker(summaryLine))))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(5)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
									$elm$html$Html$text(' Primary, '),
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'Patient',
										$author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(3),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine)))
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(index),
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Commissions$Statement$SummaryLine$Details$view,
							A2($elm$core$Dict$get, index, summaryLinesDetails))))
				]));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelBody = F2(
	function (statement, model) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top(
														{bP: model.bP}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('All Statements')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'#' + $elm$core$String$fromInt(
														$author$project$Api$Provider$Statement$One$number(statement)))
												]))
										])))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(6),
								$author$project$Ui$FlexGrid$justifyRight
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg,
								A4(
									$author$project$Components$Invoice$DownloadFile$view,
									model.iq,
									$author$project$Api$Provider$Statement$One$securePdfInlineToken(statement),
									_List_Nil,
									_List_Nil))
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Statement  #'),
										$elm$html$Html$text(
										$elm$core$String$fromInt(
											$author$project$Api$Provider$Statement$One$number(statement)))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4),
										$author$project$Ui$FlexGrid$offsetSm(4),
										$author$project$Ui$FlexGrid$justifyRight
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$fontWeight(0)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$fromString,
												_List_Nil,
												$author$project$Api$Provider$Statement$One$status(statement))
											]))
									]))
							]))
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$label,
												_List_fromArray(
													[$author$project$Ui$Typography$controlLabel]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$Date$toString,
															$author$project$Formatters$Date$MonthAndYear,
															$author$project$Api$Provider$Statement$One$date(statement)))
													]))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4),
										$author$project$Ui$FlexGrid$offsetSm(4),
										$author$project$Ui$FlexGrid$justifyRight
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$label,
												_List_fromArray(
													[$author$project$Ui$Typography$controlLabel]),
												_List_fromArray(
													[
														$elm$html$Html$text('TOTAL AMOUNT')
													])),
												$author$project$Utils$Html$noBreakSpace,
												$author$project$Utils$Html$noBreakSpace,
												A2(
												$author$project$Ui$Typography$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Provider$Statement$One$amountInCents(statement)))
													])),
												($author$project$Api$Provider$Statement$One$status(statement) !== 'paid') ? A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$label,
														_List_fromArray(
															[$author$project$Ui$Typography$controlLabel]),
														_List_fromArray(
															[
																$elm$html$Html$text('AMOUNT DUE')
															])),
														$author$project$Utils$Html$noBreakSpace,
														$author$project$Utils$Html$noBreakSpace,
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$Currency$fromInt(
																	$author$project$Api$Provider$Statement$One$dueInCents(statement)))
															]))
													])) : $author$project$Utils$Html$empty
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(4)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Summary')
													]))
											])),
										($author$project$Api$Provider$Statement$One$status(statement) === 'draft') ? A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(4),
												$author$project$Ui$FlexGrid$offsetSm(4),
												$author$project$Ui$FlexGrid$justifyRight
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Adjust statement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$pull(1),
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Adjust(statement)),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Adjustment')
													]))
											])) : $author$project$Ui$FlexGrid$none
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.s8;
								if (_v0.$ === 3) {
									var summaryLines = _v0.a;
									return A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2(
											$elm$core$List$indexedMap,
											$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewSummaryLine(model.km),
											summaryLines));
								} else {
									return A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]));
								}
							}()
							]))
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Patient Level Calculations')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Commissions calculations for each patient can be viewed in the '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(
												_List_fromArray(
													[
														A2(
														$elm$url$Url$Builder$string,
														'statement',
														$author$project$Api$Provider$Statement$One$id(statement)),
														A2($elm$url$Url$Builder$string, 'payable', 'true')
													]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('statement lines report')
											])),
										$elm$html$Html$text('.')
									]))
							]))
					])),
				A3($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPaymentsList, model.FR, statement, model.jr)
			]);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issue = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$RecordPayment = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelFooter = F2(
	function (issueRequest, statement) {
		return A2(
			$author$project$Ui$Panel$footer,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
						]),
					_List_fromArray(
						[
							($author$project$Api$Provider$Statement$One$status(statement) === 'draft') ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Issue statement'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issue(statement)),
									$author$project$Ui$Button$loading(
									_Utils_eq(issueRequest, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Issue Statement')
								])) : $author$project$Utils$Html$empty,
							($author$project$Api$Provider$Statement$One$status(statement) === 'issued') ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Record payment'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(issueRequest, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$RecordPayment(statement))
								]),
							_List_fromArray(
								[
									A2($author$project$Ui$Icon$view, _List_Nil, 23),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text('Record Payment')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.lC;
				if (!_v0.$) {
					var createPaymentModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg,
						$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.hq;
				if (!_v1.$) {
					var adjustmentModal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg,
						$author$project$Components$Commissions$Statement$AdjustmentModal$view(adjustmentModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg,
				$author$project$Components$PaymentsList$modal(model.jr)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						function () {
							var _v2 = model.Hm;
							if (_v2.$ === 3) {
								var statement = _v2.a;
								return A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelBody, statement, model);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]))
									]);
							}
						}()),
						function () {
						var _v3 = model.Hm;
						if (_v3.$ === 3) {
							var statement = _v3.a;
							return A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelFooter, model.mJ, statement);
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]),
		$G: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$view});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$StatementsTableMsg = $elm$core$Basics$identity;
var $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Commissions$Statement$List$DateRangeInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$Statement$List$StatusDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$Statement$List$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Commissions$Statement$List$GotStatements = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Statement$All$Statement = $elm$core$Basics$identity;
var $author$project$Api$Provider$Statement$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Statement$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Statement$listDefaults = {vJ: $elm$core$Maybe$Nothing, vK: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Statement$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Statement$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.vK;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker_account', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.af_;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.adR;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v3 = options.Hl;
				if (!_v3.$) {
					var start_ = _v3.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'start', start_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v4 = options.E9;
				if (!_v4.$) {
					var end_ = _v4.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$date, 'end', end_)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v5 = options.ag7;
				if (!_v5.$) {
					var string = _v5.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v6 = options.vJ;
				if (!_v6.$) {
					var string = _v6.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'broker', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Statement$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Statement$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Statement$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Statement$statementsPath)));
	});
var $author$project$Components$Commissions$Statement$List$fetchStatements = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Statement$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						vJ: model.Eo,
						vK: model.bP,
						E9: A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
							model.E9),
						afy: model.afy,
						ag1: model.ag1,
						Hl: A2(
							$elm$core$Maybe$map,
							A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
							model.Hl),
						ag7: model.ag7
					});
			},
			$author$project$Components$Commissions$Statement$List$GotStatements);
	});
var $author$project$Components$ResourceFilter$BrokerAccount$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$BrokerAccount$All$BrokerAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerAccount$All$Record = function (brokers) {
	return {Ka: brokers};
};
var $author$project$Api$Provider$BrokerAccount$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'brokers',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Broker$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$All$Record));
var $author$project$Api$Provider$BrokerAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$BrokerAccount$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$BrokerAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$All$BrokerAccount)));
var $author$project$Api$Provider$BrokerAccount$listDefaults = {adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$BrokerAccount$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$BrokerAccount$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$BrokerAccount$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$BrokerAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$BrokerAccount$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountsPath)));
	});
var $author$project$Components$ResourceFilter$BrokerAccount$list = $author$project$Api$Provider$BrokerAccount$list;
var $author$project$Components$ResourceFilter$BrokerAccount$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$BrokerAccount$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$BrokerAccount$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$BrokerAccount$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$BrokerAccount$selectId = 'broker_accounts';
var $author$project$Api$Provider$BrokerAccount$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$BrokerAccount$toTitle = function (resource) {
	return $author$project$Api$Provider$BrokerAccount$All$name(resource);
};
var $author$project$Components$ResourceFilter$BrokerAccount$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$BrokerAccount$toTitle(resource))
		]);
};
var $author$project$Api$Provider$BrokerAccount$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$BrokerAccount$toValue = $author$project$Api$Provider$BrokerAccount$All$id;
var $author$project$Components$ResourceFilter$BrokerAccount$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$BrokerAccount$fetchResources(listOptionals),
				adR: $author$project$Components$ResourceFilter$BrokerAccount$selectId,
				gx: 'Broker Account',
				st: $author$project$Components$ResourceFilter$BrokerAccount$retrieveResource(listOptionals),
				ahw: $author$project$Components$ResourceFilter$BrokerAccount$toLabel,
				ahA: $author$project$Components$ResourceFilter$BrokerAccount$toTitle,
				g0: $author$project$Components$ResourceFilter$BrokerAccount$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Commissions$Statement$List$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.ag7),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('broker'),
			model.Eo),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('broker_account'),
			model.bP)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(model.F_)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Components$Commissions$Statement$List$init = function (config) {
	var brokerId = A2($elm$core$Dict$get, 'broker', config.Bi);
	var brokerAccountId = function () {
		var _v5 = _Utils_Tuple2(
			config.bP,
			A2($elm$core$Dict$get, 'broker_account', config.Bi));
		if (!_v5.a.$) {
			var fromConfig = _v5.a.a;
			return $elm$core$Maybe$Just(fromConfig);
		} else {
			if (!_v5.b.$) {
				var _v6 = _v5.a;
				var fromQuery = _v5.b.a;
				return $elm$core$Maybe$Just(fromQuery);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}
	}();
	var _v0 = $author$project$Utils$DateWithDefault$fromQuery(config.Bi);
	var start = _v0.a;
	var end = _v0.b;
	var _v1 = A2(
		$author$project$Components$DateRangeInput$init,
		'date-range-input',
		A2(
			$author$project$Components$Commissions$Statement$List$dateRangeInputSettings,
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, config.cO, 0),
				start),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, config.cO, 0),
				end)));
	var dateRangeInput = _v1.a;
	var dateRangeInputCmd = _v1.b;
	var _v2 = A3(
		$author$project$Components$ResourceFilter$Broker$init,
		config.D5,
		function () {
			var _v3 = config.bP;
			if (!_v3.$) {
				var accountId = _v3.a;
				return function (d) {
					return _Utils_update(
						d,
						{
							vK: $elm$core$Maybe$Just(accountId)
						});
				};
			} else {
				return $elm$core$Basics$identity;
			}
		}(),
		function (d) {
			return _Utils_update(
				d,
				{D0: 'All Brokers', afT: brokerId});
		});
	var brokerResourceFilter = _v2.a;
	var brokerResourceFilterCmd = _v2.b;
	var _v4 = A3(
		$author$project$Components$ResourceFilter$BrokerAccount$init,
		config.D5,
		$elm$core$Basics$identity,
		function (d) {
			return _Utils_update(
				d,
				{D0: 'All Broker Accounts', afT: brokerAccountId});
		});
	var brokerAccountResourceFilter = _v4.a;
	var brokerAccountResourceFilterCmd = _v4.b;
	var model = {
		bP: brokerAccountId,
		le: brokerAccountResourceFilter,
		Eo: brokerId,
		lf: brokerResourceFilter,
		pI: config.pI,
		pJ: config.pJ,
		pK: config.pK,
		cO: config.cO,
		h3: dateRangeInput,
		E9: end,
		F_: config.F_,
		afy: $author$project$Api$Pagination$initFromQuery(config.Bi),
		eG: config.eG,
		ag1: $author$project$Api$Sort$initFromQuery(config.Bi),
		Hl: start,
		bD: $author$project$Api$Data$Loading,
		ag7: A2($elm$core$Dict$get, 'status', config.Bi),
		oA: $author$project$Ui$NewDropdown$init(
			$author$project$Ui$NewDropdown$defaultConfig(
				{adR: 'status-dropdown-filter', ahx: $author$project$Components$Commissions$Statement$List$StatusDropdownMsg}))
	};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$DateRangeInputMsg, dateRangeInputCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg, brokerResourceFilterCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg, brokerAccountResourceFilterCmd),
					A2($author$project$Components$Commissions$Statement$List$fetchStatements, config.D5, model),
					$author$project$Components$Commissions$Statement$List$updateUrl(model)
				])));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var params = _v2.Vx;
		var _v3 = $author$project$Components$Commissions$Statement$List$init(
			{
				D5: shared.D5,
				bP: $elm$core$Maybe$Just(params.bP),
				pI: false,
				pJ: true,
				pK: false,
				cO: shared.cO,
				F_: $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top(
					{bP: params.bP}),
				Bi: query,
				eG: false
			});
		var statementsTable = _v3.a;
		var statementsTableCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: statementsTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd));
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$ResourceFilter$BrokerAccount$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Commissions$Statement$List$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$Statement$List$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				$author$project$Ui$NewDropdown$subscriptions(model.oA),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(model.lf)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg,
				$author$project$Components$ResourceFilter$BrokerAccount$subscriptions(model.le))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Commissions$Statement$List$subscriptions(model.rh));
};
var $author$project$Components$ResourceFilter$BrokerAccount$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$BrokerAccount$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Commissions$Statement$List$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								bD: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bD: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v2.a;
				var subCmd = _v2.b;
				var event = _v2.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
								bD: $author$project$Api$Data$Loading
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
						$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var statusDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: statusDropdown}),
					cmd,
					_List_Nil);
			case 5:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						bD: $author$project$Api$Data$Loading,
						ag7: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.lf);
				var brokerId = function () {
					var _v6 = brokerResourceResult.ac5;
					if (!_v6.$) {
						if (!_v6.a.$) {
							return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.y8);
						} else {
							var _v7 = _v6.a;
							return model.Eo;
						}
					} else {
						return model.Eo;
					}
				}();
				var newModel = _Utils_update(
					model,
					{Eo: brokerId, lf: brokerResourceResult.y8});
				var _v5 = _Utils_eq(model.Eo, newModel.Eo) ? _Utils_Tuple2(model.bD, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])));
				var statements = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{bD: statements}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg, brokerResourceResult.EC),
								cmd
							])),
					brokerResourceResult.as);
			default:
				var subMsg = msg.a;
				var brokerAccountResourceResult = A3($author$project$Components$ResourceFilter$BrokerAccount$update, apiClient, subMsg, model.le);
				var brokerAccountId = function () {
					var _v9 = brokerAccountResourceResult.ac5;
					if (!_v9.$) {
						if (!_v9.a.$) {
							return $author$project$Components$ResourceFilter$BrokerAccount$value(brokerAccountResourceResult.y8);
						} else {
							var _v10 = _v9.a;
							return model.bP;
						}
					} else {
						return model.bP;
					}
				}();
				var newModel = _Utils_update(
					model,
					{bP: brokerAccountId, le: brokerAccountResourceResult.y8});
				var _v8 = _Utils_eq(model.bP, newModel.bP) ? _Utils_Tuple2(model.bD, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
								$author$project$Components$Commissions$Statement$List$updateUrl(newModel)
							])));
				var statements = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{bD: statements}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg, brokerAccountResourceResult.EC),
								cmd
							])),
					brokerAccountResourceResult.as);
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Commissions$Statement$List$update, model.D5, subMsg, model.rh);
		var statementsTable = _v1.a;
		var statementsTableCmd = _v1.b;
		var statementsTableOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: statementsTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd),
			statementsTableOutMsgs);
	});
var $author$project$Components$Commissions$Statement$List$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$BrokerAccount$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Commissions$Statement$List$viewBrokerAccountResourceFilter = function (brokerAccountResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$BrokerAccount$viewNew, _List_Nil, brokerAccountResourceFilter));
};
var $author$project$Components$Commissions$Statement$List$viewBrokerResourceFilter = function (brokerResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_Nil, brokerResourceFilter));
};
var $author$project$Components$Commissions$Statement$List$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$Statement$List$columns = function (showAccount) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'number', true, 'Number')
				]),
				showAccount ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'broker_account', false, 'Broker Account')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'date', true, 'Period'),
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Bill Amount'),
					A3($author$project$Api$Column$init, 'status', true, 'Status')
				])
			]));
};
var $author$project$Api$Provider$Statement$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Statement$Shared$brokerAccount = function (_v0) {
	var record = _v0;
	return record.vK;
};
var $author$project$Api$Provider$Statement$All$brokerAccount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$brokerAccount(shared);
};
var $author$project$Api$Provider$Statement$All$date = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$date(shared);
};
var $author$project$Api$Provider$Statement$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$id(shared);
};
var $author$project$Api$Provider$Statement$All$number = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$number(shared);
};
var $author$project$Api$Provider$Statement$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Statement$Shared$status(shared);
};
var $author$project$Components$Commissions$Statement$List$viewStatement = F2(
	function (model, statement) {
		var brokerAccount = $author$project$Api$Provider$Statement$All$brokerAccount(statement);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									model.eG ? $author$project$Ui$Table$cellSpan(1) : $author$project$Ui$Table$cellSpan(2)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String(
										{
											bP: $author$project$Api$Provider$BrokerAccount$Shared$id(brokerAccount),
											ag6: $author$project$Api$Provider$Statement$All$id(statement)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('#'),
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$Provider$Statement$All$number(statement)))
										]))
								]))
						]),
						model.eG ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$cellSpan(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$BrokerAccount$Shared$name(brokerAccount))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									model.eG ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$MonthAndYear,
										$author$project$Api$Provider$Statement$All$date(statement)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									model.eG ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Statement$All$amountInCents(statement)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$cellSpan(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$Statement$All$status(statement))
								]))
						])
					])));
	});
var $author$project$Components$Commissions$Statement$List$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.bD;
		if (_v1.$ === 3) {
			var statements_ = _v1.a;
			return _Utils_Tuple2(false, statements_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var statements = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No statements found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Commissions$Statement$List$SortTable)),
				$author$project$Components$Commissions$Statement$List$columns(model.eG)),
			A2(
				$elm$core$List$map,
				$author$project$Components$Commissions$Statement$List$viewStatement(model),
				statements),
			_List_Nil)
		]);
};
var $author$project$Components$Commissions$Statement$List$StatusOptionSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Commissions$Statement$List$viewStatusDropdown = function (model) {
	var currentText = function () {
		var _v0 = model.ag7;
		_v0$3:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 'draft':
						return 'Draft';
					case 'issued':
						return 'Issued';
					case 'paid':
						return 'Paid';
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return 'Status';
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentText)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$Statement$List$StatusOptionSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(model.ag7, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All')),
				$author$project$Ui$NewDropdown$separator,
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$Statement$List$StatusOptionSelected(
							$elm$core$Maybe$Just('draft'))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							model.ag7,
							$elm$core$Maybe$Just('draft')))
					]),
				$elm$html$Html$text('Draft')),
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$Statement$List$StatusOptionSelected(
							$elm$core$Maybe$Just('issued'))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							model.ag7,
							$elm$core$Maybe$Just('issued')))
					]),
				$elm$html$Html$text('Issued')),
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$Statement$List$StatusOptionSelected(
							$elm$core$Maybe$Just('paid'))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							model.ag7,
							$elm$core$Maybe$Just('paid')))
					]),
				$elm$html$Html$text('Paid'))
			]),
		model.oA);
};
var $author$project$Components$Commissions$Statement$List$view = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('View Statements')
									]))
							])),
						model.pK ? A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(12)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Commissions$Statement$List$DateRangeInputMsg,
										$author$project$Components$DateRangeInput$view(model.h3))
									]))
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								model.pJ ? A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6),
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Components$Commissions$Statement$List$viewBrokerResourceFilter(model.lf)
									])) : $author$project$Ui$FlexGrid$none,
								model.pI ? A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6),
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Components$Commissions$Statement$List$viewBrokerAccountResourceFilter(model.le)
									])) : $author$project$Ui$FlexGrid$none,
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(2)
									]),
								_List_fromArray(
									[
										$author$project$Components$Commissions$Statement$List$viewStatusDropdown(model)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				$author$project$Components$Commissions$Statement$List$viewPanelBody(model)),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$Statement$List$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Utils$Maybe$toBool(
										$author$project$Api$Data$toMaybe(model.bD)))
								]),
							model.afy))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Commissions$Statement$List$view(model.rh))
			]),
		$G: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$view});
var $author$project$Components$Commissions$BrokerAccount$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsInit = function () {
	var _v0 = $author$project$Components$AddressInput$init('broker_account');
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{It: addressInput, Of: $elm$core$Maybe$Nothing, Uk: true, zh: '', Z7: $elm$core$Maybe$Nothing},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd));
}();
var $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule(shared);
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$pricingStructureFromApi = function (pricingStructure) {
	return {
		Nx: $elm$core$Maybe$Just(
			$author$project$Api$Provider$PricingStructure$Shared$description(pricingStructure)),
		adr: $elm$core$Maybe$Just(
			$author$project$Currency$fromInt(
				$author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(pricingStructure))),
		adR: $elm$core$Maybe$Just(
			$author$project$Api$Provider$PricingStructure$Shared$id(pricingStructure)),
		afJ: $elm$core$Maybe$Just(
			$author$project$Percentage$fromFloat(
				$author$project$Api$Provider$PricingStructure$Shared$percentage(pricingStructure))),
		afX: $elm$core$Maybe$Just(
			$author$project$Api$Provider$PricingStructure$Shared$pricingType(pricingStructure)),
		ag3: $elm$core$Maybe$Just(
			$author$project$Api$Provider$PricingStructure$Shared$splitType(pricingStructure))
	};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval = function (ratePeriodScheduleInterval) {
	return {
		ad3: $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths(ratePeriodScheduleInterval),
		W2: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$pricingStructureFromApi(
			$author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure(ratePeriodScheduleInterval))
	};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervalsFromApi = function (brokerAccount) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$List$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval),
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$RatePeriodSchedule$Shared$intervals,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule, brokerAccount)));
};
var $author$project$Api$Provider$BrokerAccount$Meta$currentScheduleEnded = function (_v0) {
	var record = _v0;
	return record.Mx;
};
var $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodSchedule = function (_v0) {
	var record = _v0.b;
	return record.PL;
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervalsFromApi = function (brokerAccount) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$List$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval),
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$RatePeriodSchedule$Shared$intervals,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodSchedule, brokerAccount)));
};
var $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodScheduleStartDate = function (_v0) {
	var record = _v0.b;
	return record.PM;
};
var $author$project$Api$Provider$BrokerAccount$Meta$futureScheduleEnded = function (_v0) {
	var record = _v0;
	return record.PN;
};
var $author$project$Api$Provider$BrokerAccount$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$init = F3(
	function (timeZone, currentDate, brokerAccount) {
		var futureStartDate_ = A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$fromPosix(timeZone),
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodScheduleStartDate, brokerAccount));
		var futureScheduleEnded = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$BrokerAccount$Meta$futureScheduleEnded,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$meta, brokerAccount)));
		var currentScheduleEnded = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$BrokerAccount$Meta$currentScheduleEnded,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$meta, brokerAccount)));
		return {
			eU: $elm$core$Maybe$Nothing,
			eV: $elm$core$Maybe$Nothing,
			hl: $elm$core$Maybe$Nothing,
			vK: brokerAccount,
			cE: $elm$core$Maybe$Nothing,
			cO: currentDate,
			al: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervalsFromApi(brokerAccount),
			Mx: currentScheduleEnded,
			iC: $elm$core$Maybe$Nothing,
			Q: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervalsFromApi(brokerAccount),
			PN: futureScheduleEnded,
			fI: futureStartDate_,
			agv: A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$retailEnabled, brokerAccount))
		};
	});
var $author$project$Components$Commissions$BrokerAccount$Form$init = F5(
	function (apiClient, timeZone, currentDate, session, id) {
		var _v0 = function () {
			if (!id.$) {
				var id_ = id.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					A3($author$project$Api$Provider$BrokerAccount$retrieve, apiClient, id_, $author$project$Components$Commissions$BrokerAccount$Form$GotItem));
			} else {
				var _v2 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsInit;
				var formFields = _v2.a;
				var formFieldsCmd = _v2.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_Tuple2(
							$author$project$Utils$Form$init(formFields),
							A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$init, timeZone, currentDate, $elm$core$Maybe$Nothing))),
					formFieldsCmd);
			}
		}();
		var form = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{e$: $elm$core$Maybe$Nothing, cO: currentDate, fm: $elm$core$Maybe$Nothing, fC: $elm$core$Maybe$Nothing, PB: form, adR: id, FU: $elm$core$Maybe$Nothing, jY: $author$project$Api$Data$NotAsked, ZD: session, Hz: timeZone, o0: $author$project$Api$Data$NotAsked},
			cmd);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var timeZone = _v1.Hz;
		var currentDate = _v1.cO;
		var params = _v2.Vx;
		var _v3 = A5(
			$author$project$Components$Commissions$BrokerAccount$Form$init,
			apiClient,
			timeZone,
			currentDate,
			session,
			$elm$core$Maybe$Just(params.bP));
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			cmd);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg,
				$author$project$Components$PricingStructureSelect$subscriptions(model.nG))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg,
				$author$project$Components$PricingStructureSelect$subscriptions(model.nG))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close);
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close);
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						function (_v0) {
							var retailModal = _v0.c;
							return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$subscriptions(retailModal);
						},
						model.eU))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var endDealModal = _v1.b;
							return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$subscriptions(endDealModal);
						},
						model.iC))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var changeModal = _v2.c;
							return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$subscriptions(changeModal);
						},
						model.eV))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$subscriptions, model.hl))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var isCurrent = _v3.a;
						var index = _v3.b;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed, isCurrent, index));
					},
					model.cE))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$subscriptions = function (_v0) {
	var archiveRequest = _v0.e$;
	var deleteRequest = _v0.fm;
	var endModal = _v0.fC;
	var form = _v0.PB;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				if (!endModal.$) {
					var justEndModal = endModal.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg,
						$author$project$Components$Broker$EndModal$subscriptions(justEndModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				if (!form.$) {
					var _v3 = form.a;
					var itemForm = _v3.a;
					var retailSchedule = _v3.b;
					var _v4 = $author$project$Utils$Form$fields(itemForm);
					var address = _v4.It;
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg,
								$author$project$Components$Commissions$BrokerAccount$RetailSchedule$subscriptions(retailSchedule)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg,
								$author$project$Components$AddressInput$subscriptions(address))
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, archiveRequest))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, deleteRequest)))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$subscriptions = function (model) {
	return $author$project$Components$Commissions$BrokerAccount$Form$subscriptions(model.PB);
};
var $author$project$Components$Commissions$BrokerAccount$Form$Address = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Archived = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Broker$EndModal$BrokerAccount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Deleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$BrokerAccount$archive = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['archive']),
					$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id))));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$RatePeriodScheduleCreated = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Api$Provider$RatePeriodSchedule$One$RatePeriodSchedule = 0;
var $author$project$Api$Provider$RatePeriodSchedule$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$encodePricingStructure = function (pricingStructure) {
	return $elm$json$Json$Encode$object(
		$elm$core$List$concat(
			_List_fromArray(
				[
					function () {
					var _v0 = pricingStructure.adR;
					if (!_v0.$) {
						var string = _v0.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(string))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v1 = pricingStructure.Nx;
					if (!_v1.$) {
						var string = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(string))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v2 = pricingStructure.adr;
					if (!_v2.$) {
						var _int = _v2.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'fixed_amount_in_cents',
								$author$project$Currency$encode(_int))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v3 = pricingStructure.afJ;
					if (!_v3.$) {
						var percentage = _v3.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'percentage',
								$author$project$Percentage$encode(percentage))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v4 = pricingStructure.ag3;
					if (!_v4.$) {
						var splitType = _v4.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'split_type',
								$author$project$Api$SplitType$encode(splitType))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v5 = pricingStructure.afX;
					if (!_v5.$) {
						var pricingType_ = _v5.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'pricing_type',
								$author$project$Api$PricingType$encode(pricingType_))
							]);
					} else {
						return _List_Nil;
					}
				}()
				])));
};
var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$ratePeriodSchedulesPath = function (brokerAccountId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['rate_period_schedules']),
		$author$project$Api$Provider$BrokerAccount$brokerAccountPath(brokerAccountId));
};
var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$create = F5(
	function (apiClient, brokerAccountId, brokerAccountFields, fields, toMsg) {
		var encodeInterval = function (interval) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'interval_in_months',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, interval.ad3)),
						_Utils_Tuple2(
						'pricing_structure',
						$author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$encodePricingStructure(interval.W2))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_account',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									function () {
									var _v0 = brokerAccountFields.agv;
									if (!_v0.$) {
										var retailEnabled = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'retail_enabled',
												$elm$json$Json$Encode$bool(retailEnabled))
											]);
									} else {
										return _List_Nil;
									}
								}(),
									function () {
									var _v1 = brokerAccountFields.PM;
									if (!_v1.$) {
										var futureRatePeriodScheduleStartDate = _v1.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'future_rate_period_schedule_start_date',
												$author$project$Utils$Date$encode(futureRatePeriodScheduleStartDate))
											]);
									} else {
										return _List_Nil;
									}
								}()
								])))),
					_Utils_Tuple2(
					'rate_period_schedule',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'intervals',
								A2($elm$json$Json$Encode$list, encodeInterval, fields.ad4))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$RatePeriodSchedule$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$ratePeriodSchedulesPath(brokerAccountId))));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule = F5(
	function (apiClient, isUpdate, brokerAccount, brokerAccountFields, intervals) {
		return A5(
			$author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$create,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
			brokerAccountFields,
			{ad4: intervals},
			A2($author$project$Components$Commissions$BrokerAccount$Form$RatePeriodScheduleCreated, isUpdate, brokerAccount));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals = function ($) {
	return $.al;
};
var $author$project$Api$Provider$BrokerAccount$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)));
	});
var $author$project$Api$Provider$BrokerAccount$One$addressCity = function (_v0) {
	var record = _v0.b;
	return record.Iu;
};
var $author$project$Api$Provider$BrokerAccount$One$addressCountry = function (_v0) {
	var record = _v0.b;
	return record.Iv;
};
var $author$project$Api$Provider$BrokerAccount$One$addressLine1 = function (_v0) {
	var record = _v0.b;
	return record.Iw;
};
var $author$project$Api$Provider$BrokerAccount$One$addressLine2 = function (_v0) {
	var record = _v0.b;
	return record.Ix;
};
var $author$project$Api$Provider$BrokerAccount$One$addressState = function (_v0) {
	var record = _v0.b;
	return record.Iy;
};
var $author$project$Api$Provider$BrokerAccount$One$addressZip = function (_v0) {
	var record = _v0.b;
	return record.Iz;
};
var $author$project$Api$Provider$BrokerAccount$One$ein = function (_v0) {
	var record = _v0.b;
	return record.Of;
};
var $author$project$Api$Provider$BrokerAccount$Shared$multipleBrokers = function (_v0) {
	var record = _v0;
	return record.Uk;
};
var $author$project$Api$Provider$BrokerAccount$One$multipleBrokers = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$multipleBrokers(shared);
};
var $author$project$Api$Provider$BrokerAccount$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$name(shared);
};
var $author$project$Api$Provider$BrokerAccount$One$singleBrokerName = function (_v0) {
	var record = _v0.b;
	return record.Z7;
};
var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem = function (brokerAccount) {
	var _v0 = A2(
		$author$project$Components$AddressInput$initFromFields,
		'broker_account',
		{
			cw: $author$project$Api$Provider$BrokerAccount$One$addressLine1(brokerAccount),
			eW: $author$project$Api$Provider$BrokerAccount$One$addressLine2(brokerAccount),
			pT: $author$project$Api$Provider$BrokerAccount$One$addressCity(brokerAccount),
			pZ: $author$project$Api$Provider$BrokerAccount$One$addressCountry(brokerAccount),
			sZ: $author$project$Api$Provider$BrokerAccount$One$addressState(brokerAccount),
			tC: $author$project$Api$Provider$BrokerAccount$One$addressZip(brokerAccount)
		});
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			It: addressInput,
			Of: $author$project$Api$Provider$BrokerAccount$One$ein(brokerAccount),
			Uk: $author$project$Api$Provider$BrokerAccount$One$multipleBrokers(brokerAccount),
			zh: $author$project$Api$Provider$BrokerAccount$One$name(brokerAccount),
			Z7: $author$project$Api$Provider$BrokerAccount$One$singleBrokerName(brokerAccount)
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd));
};
var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Of: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var address = field.a;
				return _Utils_update(
					fields,
					{It: address});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Uk: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Z7: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Commissions$BrokerAccount$Form$EinValidation = 1;
var $author$project$Components$Commissions$BrokerAccount$Form$NameValidation = 0;
var $author$project$Ui$Form$Ein$ifInvalid = F2(
	function (subjectToMaybe, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				var _v0 = subjectToMaybe(subject);
				if (!_v0.$) {
					var ein = _v0.a;
					return !A2($author$project$Utils$Regex$matches, $author$project$Ui$Form$Ein$einFormat, ein);
				} else {
					return false;
				}
			},
			error);
	});
var $author$project$Components$Commissions$BrokerAccount$Form$AddressValidation = 2;
var $author$project$Components$Commissions$BrokerAccount$Form$validateAddress = function (fields) {
	return $author$project$Components$AddressInput$isValid(fields.It) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(2, 'Please enter an address')
		]);
};
var $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerNameValidation = 3;
var $author$project$Components$Commissions$BrokerAccount$Form$validateSingleBrokerName = function (fields) {
	return fields.Uk ? _List_Nil : ($author$project$Utils$Maybe$toBool(fields.Z7) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(3, 'Please enter a broker name.')
		]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A2(
			$author$project$Ui$Form$Ein$ifInvalid,
			function ($) {
				return $.Of;
			},
			_Utils_Tuple2(1, 'Please enter a valid EIN or leave empty')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$Form$validateAddress),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$Form$validateSingleBrokerName)
		]));
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals = function ($) {
	return $.Q;
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureStartDate = function ($) {
	return $.fI;
};
var $author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate = function (brokerAccount) {
	var id = $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount);
	return $author$project$Api$Provider$BrokerAccount$One$multipleBrokers(brokerAccount) ? _Utils_Tuple2(
		A2(
			$author$project$Utils$Route$navigate,
			$elm$core$Dict$empty,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
				{bP: id})),
		_List_Nil) : _Utils_Tuple2(
		A2(
			$author$project$Utils$Route$navigate,
			$elm$core$Dict$empty,
			$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
				{bP: id})),
		_List_fromArray(
			[$author$project$OutMsg$RefreshPractice]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$apiFields = function (fields) {
	return {
		It: $author$project$Components$AddressInput$getAddress(fields.It),
		Of: fields.Of,
		Uk: fields.Uk,
		zh: fields.zh,
		Z7: fields.Z7
	};
};
var $author$project$Api$Common$Address$Shared$encodePartsWithPrefix = F2(
	function (prefix, address) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				prefix + 'city',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.pT)),
				_Utils_Tuple2(
				prefix + 'country',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.pZ)),
				_Utils_Tuple2(
				prefix + 'line1',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.rf)),
				_Utils_Tuple2(
				prefix + 'line2',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.yy)),
				_Utils_Tuple2(
				prefix + 'state',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.sZ)),
				_Utils_Tuple2(
				prefix + 'zip',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.tC))
			]);
	});
var $author$project$Api$Common$Address$Shared$encodeParts = $author$project$Api$Common$Address$Shared$encodePartsWithPrefix('address_');
var $author$project$Api$Provider$BrokerAccount$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_account',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'ein',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Of)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'multiple_brokers',
										$elm$json$Json$Encode$bool(fields.Uk)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'single_broker_name',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Z7)),
										$author$project$Api$Common$Address$Shared$encodeParts(fields.It)))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountsPath)));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$createItem = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$BrokerAccount$create,
			apiClient,
			$author$project$Components$Commissions$BrokerAccount$Form$apiFields(fields),
			$author$project$Components$Commissions$BrokerAccount$Form$Created);
	});
var $author$project$Components$Commissions$BrokerAccount$Form$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$BrokerAccount$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'broker_account',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'ein',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Of)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'multiple_brokers',
										$elm$json$Json$Encode$bool(fields.Uk)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'single_broker_name',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Z7)),
										$author$project$Api$Common$Address$Shared$encodeParts(fields.It)))))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$BrokerAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$BrokerAccount$brokerAccountPath(id))));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$updateItem = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$BrokerAccount$update,
			apiClient,
			id,
			$author$project$Components$Commissions$BrokerAccount$Form$apiFields(fields),
			$author$project$Components$Commissions$BrokerAccount$Form$Updated);
	});
var $author$project$Components$Commissions$BrokerAccount$Form$saveItem = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A3($author$project$Components$Commissions$BrokerAccount$Form$updateItem, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Commissions$BrokerAccount$Form$createItem, apiClient, formFields);
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$None = 0;
var $author$project$Formatters$Percentage$toString = function (currency) {
	var _v0 = $author$project$Percentage$toFloat(currency);
	if (!_v0.$) {
		var _float = _v0.a;
		return $author$project$Formatters$Float$toPercentage(_float);
	} else {
		return 'N/A';
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew = function (pricingStructure) {
	var _v0 = pricingStructure.adR;
	if (!_v0.$) {
		return {Nx: pricingStructure.Nx, adr: pricingStructure.adr, adR: pricingStructure.adR, afJ: pricingStructure.afJ, afX: pricingStructure.afX, ag3: pricingStructure.ag3};
	} else {
		var splitType = _Utils_eq(
			pricingStructure.ag3,
			$elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Just('for all members') : (_Utils_eq(
			pricingStructure.ag3,
			$elm$core$Maybe$Just(1)) ? $elm$core$Maybe$Just('for primary member') : $elm$core$Maybe$Nothing);
		var amount = function () {
			var _v2 = _Utils_Tuple3(pricingStructure.afX, pricingStructure.adr, pricingStructure.afJ);
			_v2$2:
			while (true) {
				if (!_v2.a.$) {
					switch (_v2.a.a.$) {
						case 1:
							if (!_v2.b.$) {
								var _v3 = _v2.a.a;
								var fixedAmountInCents = _v2.b.a;
								return $elm$core$Maybe$Just(
									$author$project$Currency$format(fixedAmountInCents));
							} else {
								break _v2$2;
							}
						case 0:
							if (!_v2.c.$) {
								var _v4 = _v2.a.a;
								var percentage = _v2.c.a;
								return $elm$core$Maybe$Just(
									$author$project$Formatters$Percentage$toString(percentage));
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				} else {
					break _v2$2;
				}
			}
			return $elm$core$Maybe$Nothing;
		}();
		var description = function () {
			var _v1 = _Utils_Tuple2(amount, splitType);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var amount_ = _v1.a.a;
				var splitType_ = _v1.b.a;
				return $elm$core$Maybe$Just(amount_ + (' ' + splitType_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return _Utils_update(
			pricingStructure,
			{Nx: description});
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval = F3(
	function (pricingStructure, intervalInMonths, intervals) {
		var interval = {
			ad3: $elm$core$Maybe$Nothing,
			W2: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
		};
		return function (newIntervals) {
			return A2(
				$elm$core$List$append,
				newIntervals,
				_List_fromArray(
					[interval]));
		}(
			A3(
				$elm_community$list_extra$List$Extra$updateAt,
				$elm$core$List$length(intervals) - 1,
				function (lastInterval) {
					return (!$elm$core$List$isEmpty(intervals)) ? _Utils_update(
						lastInterval,
						{ad3: intervalInMonths}) : lastInterval;
				},
				intervals));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$editFirstSchedule = F2(
	function (pricingStructure, intervals) {
		return A3(
			$elm_community$list_extra$List$Extra$updateAt,
			0,
			function (interval) {
				return _Utils_update(
					interval,
					{
						W2: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
					});
			},
			intervals);
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$editInterval = F4(
	function (pricingStructure, intervalInMonths, index, intervals) {
		return A3(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			function (interval) {
				return _Utils_update(
					interval,
					{
						W2: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
					});
			},
			A3(
				$elm_community$list_extra$List$Extra$updateAt,
				index - 1,
				function (interval) {
					return _Utils_update(
						interval,
						{ad3: intervalInMonths});
				},
				intervals));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$initFormFields = {W2: $elm$core$Maybe$Nothing};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init = function (apiClient) {
	var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
	var pricingStructureSelect = _v0.a;
	var pricingStructureSelectCmd = _v0.b;
	return _Utils_Tuple2(
		{
			PB: $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$initFormFields),
			nG: pricingStructureSelect
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg, pricingStructureSelectCmd));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$initFormFields = {ad3: $elm$core$Maybe$Nothing, W2: $elm$core$Maybe$Nothing};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init = function (apiClient) {
	var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
	var pricingStructureSelect = _v0.a;
	var pricingStructureSelectCmd = _v0.b;
	return _Utils_Tuple2(
		{
			PB: $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$initFormFields),
			nG: pricingStructureSelect
		},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg, pricingStructureSelectCmd));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$initFormFields = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var startDateDateInput = _v0.a;
	var startDateDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{_E: $elm$core$Maybe$Nothing, sY: startDateDateInput},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg(startDateDateInput),
			startDateDateInputCmd));
}();
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$init = function (currentDate) {
	var _v0 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$initFormFields;
	var fields = _v0.a;
	var fieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			cO: currentDate,
			PB: $author$project$Utils$Form$init(fields)
		},
		fieldsCmd);
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$initFormFields = {ad3: $elm$core$Maybe$Nothing};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$init = $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$initFormFields);
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval = F2(
	function (index, intervals) {
		var currentInterval = A2($elm_community$list_extra$List$Extra$getAt, index, intervals);
		return A2(
			$elm_community$list_extra$List$Extra$removeAt,
			index,
			A3(
				$elm_community$list_extra$List$Extra$updateAt,
				index - 1,
				function (interval) {
					return _Utils_update(
						interval,
						{
							ad3: A2(
								$elm$core$Maybe$andThen,
								function ($) {
									return $.ad3;
								},
								currentInterval)
						});
				},
				intervals));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructure = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$RetailRateAdded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsUpdate = F2(
	function (field, fields) {
		var pricingStructure = field;
		return _Utils_update(
			fields,
			{W2: pricingStructure});
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureValidation = 0;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$validatePricingStructure = function (fields) {
	var _v0 = fields.W2;
	if (!_v0.$) {
		var pricingStructure = _v0.a;
		var _v1 = pricingStructure.adR;
		if (!_v1.$) {
			return _List_Nil;
		} else {
			var _v2 = _Utils_Tuple3(pricingStructure.afX, pricingStructure.afJ, pricingStructure.adr);
			_v2$3:
			while (true) {
				if (_v2.a.$ === 1) {
					var _v3 = _v2.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(0, 'Please pick or create a rate.')
						]);
				} else {
					switch (_v2.a.a.$) {
						case 0:
							if (_v2.b.$ === 1) {
								var _v4 = _v2.a.a;
								var _v5 = _v2.b;
								return _List_fromArray(
									[
										_Utils_Tuple2(0, 'Please enter a number')
									]);
							} else {
								break _v2$3;
							}
						case 1:
							if (_v2.c.$ === 1) {
								var _v6 = _v2.a.a;
								var _v7 = _v2.c;
								return _List_fromArray(
									[
										_Utils_Tuple2(0, 'Please enter an amount')
									]);
							} else {
								break _v2$3;
							}
						default:
							break _v2$3;
					}
				}
			}
			return _List_Nil;
		}
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please pick or create a rate.')
			]);
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$validatePricingStructure)
		]));
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed, y8: model, as: _List_Nil};
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var event = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$RetailRateAdded,
							$rtfeldman$elm_validate$Validate$fromValid(validFormFields).W2));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: event,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			default:
				var subMsg = msg.a;
				var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.nG);
				var form = function () {
					var _v4 = pricingStructureSelectResult.ac5;
					if (!_v4.$) {
						return model.PB;
					} else {
						var pricingStructure = _v4.a;
						return A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsUpdate, pricingStructure, model.PB);
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg, pricingStructureSelectResult.EC),
					ac5: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None,
					y8: _Utils_update(
						model,
						{PB: form, nG: pricingStructureSelectResult.y8}),
					as: pricingStructureSelectResult.as
				};
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$RetailRateAdded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					ad3: $elm$core$String$toInt(string)
				});
		} else {
			var pricingStructure = field.a;
			return _Utils_update(
				fields,
				{W2: pricingStructure});
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonthsValidation = 1;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validateIntervalInMonths = function (fields) {
	var validationError = _Utils_Tuple2(1, 'Please enter a number greater than 0');
	var _v0 = fields.ad3;
	if (!_v0.$) {
		var intervalInMonths = _v0.a;
		return (intervalInMonths > 0) ? _List_Nil : _List_fromArray(
			[validationError]);
	} else {
		return _List_fromArray(
			[validationError]);
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureValidation = 0;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validatePricingStructure = function (fields) {
	var _v0 = fields.W2;
	if (!_v0.$) {
		var pricingStructure = _v0.a;
		var _v1 = pricingStructure.adR;
		if (!_v1.$) {
			return _List_Nil;
		} else {
			var _v2 = _Utils_Tuple3(pricingStructure.afX, pricingStructure.afJ, pricingStructure.adr);
			_v2$3:
			while (true) {
				if (_v2.a.$ === 1) {
					var _v3 = _v2.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(0, 'Please pick or create a rate.')
						]);
				} else {
					switch (_v2.a.a.$) {
						case 0:
							if (_v2.b.$ === 1) {
								var _v4 = _v2.a.a;
								var _v5 = _v2.b;
								return _List_fromArray(
									[
										_Utils_Tuple2(0, 'Please enter a number')
									]);
							} else {
								break _v2$3;
							}
						case 1:
							if (_v2.c.$ === 1) {
								var _v6 = _v2.a.a;
								var _v7 = _v2.c;
								return _List_fromArray(
									[
										_Utils_Tuple2(0, 'Please enter an amount')
									]);
							} else {
								break _v2$3;
							}
						default:
							break _v2$3;
					}
				}
			}
			return _List_Nil;
		}
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please pick or create a rate.')
			]);
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validateIntervalInMonths),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validatePricingStructure)
		]));
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed, y8: model, as: _List_Nil};
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var pricingStructure = _v4.W2;
					var intervalInMonths = _v4.ad3;
					var event = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed,
						A2(
							$elm$core$Maybe$map,
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$RetailRateAdded(intervalInMonths),
							pricingStructure));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: event,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var field = msg.a;
				var form = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
					y8: _Utils_update(
						model,
						{PB: form}),
					as: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.nG);
				var form = function () {
					var _v5 = pricingStructureSelectResult.ac5;
					if (!_v5.$) {
						return model.PB;
					} else {
						var pricingStructure = _v5.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate,
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructure(pricingStructure),
							model.PB);
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg, pricingStructureSelectResult.EC),
					ac5: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
					y8: _Utils_update(
						model,
						{PB: form, nG: pricingStructureSelectResult.y8}),
					as: pricingStructureSelectResult.as
				};
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Closed = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$DatePicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateValidation = 0;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$validateStartDate = F2(
	function (currentDate, fields) {
		var _v0 = fields._E;
		if (!_v0.$) {
			var startDate = _v0.a;
			return (A2($justinmimbs$date$Date$compare, currentDate, startDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date greater or equal than today')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$validateStartDate(currentDate))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate = F2(
	function (field, fields) {
		var dateInput = field.a;
		var date = field.b;
		return _Utils_update(
			fields,
			{_E: date, sY: dateInput});
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None);
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Closed);
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsValidator(model.cO),
					model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var startDate = A2(
						$elm$core$Maybe$withDefault,
						model.cO,
						$rtfeldman$elm_validate$Validate$fromValid(validFormFields)._E);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$DatePicked(startDate));
				} else {
					var newForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None);
				}
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg,
					$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDate,
					function ($) {
						return $._E;
					});
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed = {$: 1};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$RetailRateAdded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{
				ad3: $elm$core$String$toInt(string)
			});
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$IntervalInMonthsValidation = 0;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$validateIntervalInMonths = function (fields) {
	var validationError = _Utils_Tuple2(0, 'Please enter a number greater than 0');
	var _v0 = fields.ad3;
	if (!_v0.$) {
		var intervalInMonths = _v0.a;
		return (intervalInMonths > 0) ? _List_Nil : _List_fromArray(
			[validationError]);
	} else {
		return _List_fromArray(
			[validationError]);
	}
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$validateIntervalInMonths)
		]));
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$update = F2(
	function (msg, _v0) {
		var form = _v0;
		switch (msg.$) {
			case 1:
				return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed);
			case 0:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsValidator, form);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var intervalInMonths = _v4.ad3;
					var event = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed,
						A2($elm$core$Maybe$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$RetailRateAdded, intervalInMonths));
					return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, event);
				} else {
					var newForm = _v2.a;
					return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None);
				}
			default:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsUpdate, field, form);
				return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None);
		}
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init(apiClient);
				var addRetailModal = _v1.a;
				var addRetailModalCmd = _v1.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							eU: $elm$core$Maybe$Just(
								_Utils_Tuple3(true, true, addRetailModal))
						}),
					as: _List_Nil
				};
			case 1:
				var subMsg = msg.a;
				var _v2 = model.eU;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var resetIntervals = _v3.a;
					var isCurrent = _v3.b;
					var addRetailModal = _v3.c;
					var intervals = isCurrent ? model.al : model.Q;
					var addRetailModalResult = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$update, subMsg, addRetailModal);
					var _v4 = function () {
						var _v5 = _Utils_Tuple2(addRetailModalResult.ac5, resetIntervals);
						switch (_v5.a.$) {
							case 0:
								var _v6 = _v5.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple3(resetIntervals, isCurrent, addRetailModalResult.y8)),
									model.agv,
									intervals);
							case 1:
								if (_v5.b) {
									var _v7 = _v5.a;
									return _Utils_Tuple3($elm$core$Maybe$Nothing, false, intervals);
								} else {
									var _v8 = _v5.a;
									return _Utils_Tuple3($elm$core$Maybe$Nothing, model.agv, intervals);
								}
							default:
								if (_v5.b) {
									var pricingStructure = _v5.a.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										true,
										$elm$core$Maybe$Just(
											A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval, pricingStructure, $elm$core$Maybe$Nothing, _List_Nil)));
								} else {
									var pricingStructure = _v5.a.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										model.agv,
										$elm$core$Maybe$Just(
											A2(
												$author$project$Components$Commissions$BrokerAccount$RetailSchedule$editFirstSchedule,
												pricingStructure,
												A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
								}
						}
					}();
					var addRetailModal_ = _v4.a;
					var retailEnabled_ = _v4.b;
					var newIntervals = _v4.c;
					var newModel = isCurrent ? _Utils_update(
						model,
						{al: newIntervals}) : _Utils_update(
						model,
						{Q: newIntervals});
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalResult.EC),
						ac5: 0,
						y8: _Utils_update(
							newModel,
							{eU: addRetailModal_, agv: retailEnabled_}),
						as: addRetailModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 2:
				var isCurrent = msg.a;
				var index = msg.b;
				if (!index) {
					var _v9 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init(apiClient);
					var addRetailModal = _v9.a;
					var addRetailModalCmd = _v9.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalCmd),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								eU: $elm$core$Maybe$Just(
									_Utils_Tuple3(false, isCurrent, addRetailModal))
							}),
						as: _List_Nil
					};
				} else {
					var _v10 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init(apiClient);
					var addRetailRateChangeModal = _v10.a;
					var addRetailRateChangeModalCmd = _v10.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalCmd),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								eV: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										isCurrent,
										$elm$core$Maybe$Just(index),
										addRetailRateChangeModal))
							}),
						as: _List_Nil
					};
				}
			case 3:
				var isCurrent = msg.a;
				var intervals = isCurrent ? model.al : model.Q;
				var newIntervals = A2(
					$elm$core$Maybe$map,
					function (intervals_) {
						return A3(
							$elm_community$list_extra$List$Extra$updateAt,
							$elm$core$List$length(intervals_) - 1,
							function (lastInterval) {
								return _Utils_update(
									lastInterval,
									{ad3: $elm$core$Maybe$Nothing});
							},
							intervals_);
					},
					intervals);
				var newModel = isCurrent ? _Utils_update(
					model,
					{al: newIntervals, Mx: false}) : _Utils_update(
					model,
					{Q: newIntervals, PN: false});
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: newModel, as: _List_Nil};
			case 4:
				var isCurrent = msg.a;
				var _v11 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init(apiClient);
				var addRetailRateChangeModal = _v11.a;
				var addRetailRateChangeModalCmd = _v11.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							eV: $elm$core$Maybe$Just(
								_Utils_Tuple3(isCurrent, $elm$core$Maybe$Nothing, addRetailRateChangeModal))
						}),
					as: _List_Nil
				};
			case 5:
				var subMsg = msg.a;
				var _v12 = model.eV;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var isCurrent = _v13.a;
					var index = _v13.b;
					var addRetailRateChangeModal = _v13.c;
					var intervals = isCurrent ? model.al : model.Q;
					var addRetailRateChangeModalResult = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$update, subMsg, addRetailRateChangeModal);
					var _v14 = function () {
						var _v15 = _Utils_Tuple2(addRetailRateChangeModalResult.ac5, index);
						switch (_v15.a.$) {
							case 0:
								var _v16 = _v15.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(
										_Utils_Tuple3(isCurrent, index, addRetailRateChangeModalResult.y8)),
									intervals);
							case 1:
								var _v17 = _v15.a;
								return _Utils_Tuple2($elm$core$Maybe$Nothing, intervals);
							default:
								if (_v15.b.$ === 1) {
									var _v18 = _v15.a;
									var intervalInMonths = _v18.a;
									var pricingStructure = _v18.b;
									var _v19 = _v15.b;
									return _Utils_Tuple2(
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(
											A3(
												$author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval,
												pricingStructure,
												intervalInMonths,
												A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
								} else {
									var _v20 = _v15.a;
									var intervalInMonths = _v20.a;
									var pricingStructure = _v20.b;
									var index_ = _v15.b.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(
											A4(
												$author$project$Components$Commissions$BrokerAccount$RetailSchedule$editInterval,
												pricingStructure,
												intervalInMonths,
												index_,
												A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
								}
						}
					}();
					var addRetailRateChangeModal_ = _v14.a;
					var newIntervals = _v14.b;
					var newModel = isCurrent ? _Utils_update(
						model,
						{al: newIntervals}) : _Utils_update(
						model,
						{Q: newIntervals});
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalResult.EC),
						ac5: 0,
						y8: _Utils_update(
							newModel,
							{eV: addRetailRateChangeModal_}),
						as: addRetailRateChangeModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				var isCurrent = msg.a;
				var endDealModal = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$init;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							iC: $elm$core$Maybe$Just(
								_Utils_Tuple2(isCurrent, endDealModal))
						}),
					as: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var _v21 = model.iC;
				if (!_v21.$) {
					var _v22 = _v21.a;
					var isCurrent = _v22.a;
					var endDealModal = _v22.b;
					var _v23 = isCurrent ? _Utils_Tuple2(model.Mx, model.al) : _Utils_Tuple2(model.Mx, model.Q);
					var scheduleEnded = _v23.a;
					var intervals = _v23.b;
					var _v24 = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$update, subMsg, endDealModal);
					var endDealModal_ = _v24.a;
					var endDealModalCmd = _v24.b;
					var endDealModalEvent = _v24.c;
					var _v25 = function () {
						switch (endDealModalEvent.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(isCurrent, endDealModal_)),
									scheduleEnded,
									intervals);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, scheduleEnded, intervals);
							default:
								var intervalInMonths = endDealModalEvent.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									true,
									A2(
										$elm$core$Maybe$map,
										function (intervals_) {
											return A3(
												$elm_community$list_extra$List$Extra$updateAt,
												$elm$core$List$length(intervals_) - 1,
												function (lastInterval) {
													return _Utils_update(
														lastInterval,
														{
															ad3: $elm$core$Maybe$Just(intervalInMonths)
														});
												},
												intervals_);
										},
										intervals));
						}
					}();
					var newEndDealModal = _v25.a;
					var scheduleEnded_ = _v25.b;
					var newIntervals = _v25.c;
					var newModel = isCurrent ? _Utils_update(
						model,
						{al: newIntervals, Mx: scheduleEnded_}) : _Utils_update(
						model,
						{Q: newIntervals, PN: scheduleEnded_});
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg, endDealModalCmd),
						ac5: 0,
						y8: _Utils_update(
							newModel,
							{iC: newEndDealModal}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 8:
				var _v27 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$init(model.cO);
				var addScheduleModal = _v27.a;
				var addScheduleModalCmd = _v27.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg, addScheduleModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							hl: $elm$core$Maybe$Just(addScheduleModal)
						}),
					as: _List_Nil
				};
			case 9:
				var subMsg = msg.a;
				var _v28 = model.hl;
				if (!_v28.$) {
					var addScheduleModal = _v28.a;
					var _v29 = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$update, subMsg, addScheduleModal);
					var addScheduleModal_ = _v29.a;
					var addScheduleModalCmd = _v29.b;
					var addScheduleModalEvent = _v29.c;
					var _v30 = function () {
						switch (addScheduleModalEvent.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(addScheduleModal_),
									model.fI,
									model.Q);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.fI, model.Q);
							default:
								var date = addScheduleModalEvent.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just(date),
									model.al);
						}
					}();
					var addScheduleModal__ = _v30.a;
					var futureStartDate_ = _v30.b;
					var futureIntervals_ = _v30.c;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg, addScheduleModalCmd),
						ac5: 0,
						y8: _Utils_update(
							model,
							{hl: addScheduleModal__, Q: futureIntervals_, fI: futureStartDate_}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 10:
				var isCurrent = msg.a;
				var index = msg.b;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							cE: $elm$core$Maybe$Just(
								_Utils_Tuple2(isCurrent, index))
						}),
					as: _List_Nil
				};
			default:
				var isCurrent = msg.a;
				var index = msg.b;
				var confirmed = msg.c;
				if (confirmed) {
					var _v32 = _Utils_Tuple3(isCurrent, model.al, model.Q);
					_v32$2:
					while (true) {
						if (_v32.a) {
							if (!_v32.b.$) {
								var currentIntervals_ = _v32.b.a;
								return {
									EC: $elm$core$Platform$Cmd$none,
									ac5: 0,
									y8: _Utils_update(
										model,
										{
											cE: $elm$core$Maybe$Nothing,
											al: $elm$core$Maybe$Just(
												A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval, index, currentIntervals_))
										}),
									as: _List_Nil
								};
							} else {
								break _v32$2;
							}
						} else {
							if (!_v32.c.$) {
								var futureIntervals_ = _v32.c.a;
								return {
									EC: $elm$core$Platform$Cmd$none,
									ac5: 0,
									y8: _Utils_update(
										model,
										{
											cE: $elm$core$Maybe$Nothing,
											Q: $elm$core$Maybe$Just(
												A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval, index, futureIntervals_))
										}),
									as: _List_Nil
								};
							} else {
								break _v32$2;
							}
						}
					}
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{cE: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{cE: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				}
		}
	});
var $author$project$Components$Commissions$BrokerAccount$Form$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerAccount = response.a;
					var retailSchedule = A3(
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$init,
						model.Hz,
						model.cO,
						$elm$core$Maybe$Just(brokerAccount));
					var _v3 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem(brokerAccount);
					var formFields = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$Form$init(formFields),
										retailSchedule)),
								FU: $elm$core$Maybe$Just(brokerAccount)
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 1:
				var field = msg.a;
				var _v4 = model.PB;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var form = _v5.a;
					var retailSchedule = _v5.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, retailSchedule))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v6 = model.PB;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var form = _v7.a;
					var retailSchedule = _v7.b;
					var _v8 = $author$project$Utils$Form$fields(form);
					var address = _v8.It;
					var _v9 = A2($author$project$Components$AddressInput$update, subMsg, address);
					var addressInputModel = _v9.a;
					var addressInputCmd = _v9.b;
					var outMsgs = _v9.c;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate,
						$author$project$Components$Commissions$BrokerAccount$Form$Address(addressInputModel),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, retailSchedule))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v10 = model.PB;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var form = _v11.a;
					var retailSchedule = _v11.b;
					var _v12 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$Form$formFieldsValidator, form);
					if (!_v12.$) {
						var _v13 = _v12.a;
						var newForm = _v13.a;
						var validFormFields = _v13.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, retailSchedule)),
									jY: $author$project$Api$Data$Loading
								}),
							A3($author$project$Components$Commissions$BrokerAccount$Form$saveItem, apiClient, model.adR, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v12.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, retailSchedule)),
									jY: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				var _v14 = model.PB;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var retailSchedule = _v15.b;
					if (response.$ === 3) {
						var brokerAccount = response.a;
						var _v17 = function () {
							var _v18 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals(retailSchedule);
							if (!_v18.$) {
								var currentIntervals = _v18.a;
								return _Utils_Tuple2(
									A5(
										$author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule,
										apiClient,
										false,
										brokerAccount,
										{
											PM: $elm$core$Maybe$Nothing,
											agv: $elm$core$Maybe$Just(true)
										},
										currentIntervals),
									_List_Nil);
							} else {
								return $author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate(brokerAccount);
							}
						}();
						var cmd = _v17.a;
						var outMsgs = _v17.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							cmd,
							A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 3, 'Broker Account successfully created'),
								outMsgs));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var response = msg.a;
				var _v19 = model.PB;
				if (!_v19.$) {
					if (response.$ === 3) {
						var brokerAccount = response.a;
						var retailSchedule = A3(
							$author$project$Components$Commissions$BrokerAccount$RetailSchedule$init,
							model.Hz,
							model.cO,
							$elm$core$Maybe$Just(brokerAccount));
						var _v21 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem(brokerAccount);
						var formFields = _v21.a;
						var cmd = _v21.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$author$project$Utils$Form$init(formFields),
											retailSchedule)),
									jY: response
								}),
							cmd,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Broker Account updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var isUpdate = msg.a;
				var brokerAccount = msg.b;
				var response = msg.c;
				var _v22 = model.PB;
				if (!_v22.$) {
					if (response.$ === 3) {
						var _v24 = isUpdate ? _Utils_Tuple3($elm$core$Platform$Cmd$none, _List_Nil, 'Retail commission schedule updated') : A2(
							$author$project$Utils$Tuple3$fromTuple2,
							'Rate schedule successfully created',
							$author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate(brokerAccount));
						var cmd = _v24.a;
						var outMsgs = _v24.b;
						var messsage = _v24.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{PB: $elm$core$Maybe$Nothing, o0: $author$project$Api$Data$NotAsked}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										A3(
										$author$project$Api$Provider$BrokerAccount$retrieve,
										apiClient,
										$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
										$author$project$Components$Commissions$BrokerAccount$Form$GotItem)
									])),
							A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 3, messsage),
								outMsgs));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{o0: $author$project$Api$Data$NotAsked}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top(
									{
										bP: $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount)
									})),
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var brokerAccount = msg.a;
				var _v25 = model.PB;
				if (!_v25.$) {
					var _v26 = _v25.a;
					var retailSchedule = _v26.b;
					var _v27 = $author$project$Api$Provider$BrokerAccount$One$retailEnabled(brokerAccount) ? _Utils_Tuple2(
						{
							PM: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureStartDate(retailSchedule),
							agv: $elm$core$Maybe$Nothing
						},
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals(retailSchedule)) : _Utils_Tuple2(
						{
							PM: $elm$core$Maybe$Nothing,
							agv: $elm$core$Maybe$Just(true)
						},
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals(retailSchedule));
					var brokerAccountFields = _v27.a;
					var intervals = _v27.b;
					if (!intervals.$) {
						var intervals_ = intervals.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{o0: $author$project$Api$Data$Loading}),
							A5($author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule, apiClient, true, brokerAccount, brokerAccountFields, intervals_),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var brokerAccount = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							e$: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerAccount, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var brokerAccount = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							e$: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerAccount, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$BrokerAccount$archive,
						apiClient,
						$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
						$author$project$Components$Commissions$BrokerAccount$Form$Archived(brokerAccount)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{e$: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var brokerAccount = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker Account archived')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e$: $elm$core$Maybe$Just(
									_Utils_Tuple2(brokerAccount, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var brokerAccount = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerAccount, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var brokerAccount = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple2(brokerAccount, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$BrokerAccount$delete,
						apiClient,
						$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
						$author$project$Components$Commissions$BrokerAccount$Form$Deleted(brokerAccount)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{fm: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var brokerAccount = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Broker Account deleted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fm: $elm$core$Maybe$Just(
									_Utils_Tuple2(brokerAccount, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var brokerAccount = msg.a;
				var _v31 = A3(
					$author$project$Components$Broker$EndModal$init,
					model.ZD,
					model.cO,
					$author$project$Components$Broker$EndModal$BrokerAccount(brokerAccount));
				var endModal = _v31.a;
				var endModalCmd = _v31.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fC: $elm$core$Maybe$Just(endModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg, endModalCmd),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var _v32 = model.fC;
				if (!_v32.$) {
					var endModal = _v32.a;
					var endModalResult = A3($author$project$Components$Broker$EndModal$update, apiClient, subMsg, endModal);
					var _v33 = function () {
						var _v34 = endModalResult.ac5;
						switch (_v34.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(endModalResult.y8),
									model.PB,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.PB, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.PB, $elm$core$Platform$Cmd$none);
							default:
								var brokerAccount = _v34.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing,
									A3(
										$author$project$Api$Provider$BrokerAccount$retrieve,
										apiClient,
										$author$project$Api$Provider$BrokerAccount$One$id(brokerAccount),
										$author$project$Components$Commissions$BrokerAccount$Form$GotItem));
						}
					}();
					var endModal_ = _v33.a;
					var form = _v33.b;
					var cmd = _v33.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fC: endModal_, PB: form}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg, endModalResult.EC),
									cmd
								])),
						endModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var _v35 = model.PB;
				if (!_v35.$) {
					var _v36 = _v35.a;
					var form = _v36.a;
					var retailSchedule = _v36.b;
					var retailScheduleResult = A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$update, apiClient, subMsg, retailSchedule);
					var newForm = function () {
						var _v37 = retailScheduleResult.ac5;
						return form;
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, retailScheduleResult.y8))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg, retailScheduleResult.EC),
						retailScheduleResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$update = F2(
	function (msg, model) {
		var _v0 = A3($author$project$Components$Commissions$BrokerAccount$Form$update, model.D5, msg, model.PB);
		var form = _v0.a;
		var cmd = _v0.b;
		var outMsgs = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			cmd,
			outMsgs);
	});
var $author$project$Components$Commissions$BrokerAccount$Form$Save = {$: 3};
var $author$project$Components$Commissions$BrokerAccount$Form$button = function (model) {
	var label = function () {
		var _v0 = model.adR;
		if (!_v0.$) {
			return 'Update';
		} else {
			return 'Add new account';
		}
	}();
	return A3(
		$author$project$Ui$Button$view,
		{abp: label},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$loading(
				_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
				$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$Form$Save)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Add retail commission')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate),
								$author$project$Ui$Form$horizontal
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg),
							A2(
								$author$project$Components$PricingStructureSelect$view,
								_List_fromArray(
									[
										$author$project$Components$PricingStructureSelect$value(fields.W2),
										$author$project$Components$PricingStructureSelect$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
										$author$project$Components$PricingStructureSelect$errors(
										A2($author$project$Utils$Form$validationErrors, 0, model.PB))
									]),
								model.nG))),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancle and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Add retail rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonths = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Add retail commission')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate),
								$author$project$Ui$Form$horizontal
							]),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Number of months'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.ad3))),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$FormUpdated, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonths)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
												$author$project$Ui$Form$Input$errors(
												A2($author$project$Utils$Form$validationErrors, 1, model.PB))
											])),
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('Identify in how many months the rate should be changed')
											]))
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg),
								A2(
									$author$project$Components$PricingStructureSelect$view,
									_List_fromArray(
										[
											$author$project$Components$PricingStructureSelect$value(fields.W2),
											$author$project$Components$PricingStructureSelect$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
											$author$project$Components$PricingStructureSelect$errors(
											A2($author$project$Utils$Form$validationErrors, 0, model.PB))
										]),
									model.nG)))),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Add retail rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Confirm retail rate change')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('You are about to change the retail commission structure. This will not update the existing deals on this rate.')
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Effective date'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg(fields.sY),
										A2(
											$author$project$Components$DateInput$view,
											_List_fromArray(
												[
													$author$project$Components$DateInput$value(fields._E),
													$author$project$Components$DateInput$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
													$author$project$Components$DateInput$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.PB))
												]),
											fields.sY))
									]))
							])),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Revert to previous rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Revert to previous rate')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Change rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Change rate')
							]))
					]))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$IntervalInMonths = $elm$core$Basics$identity;
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$view = function (_v0) {
	var form = _v0;
	var fields = $author$project$Utils$Form$fields(form);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Add retail commission')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Number of months'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4),
										$author$project$Ui$Form$Group$required(true)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.ad3))),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$FormUpdated, $elm$core$Basics$identity)),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
												$author$project$Ui$Form$Input$errors(
												A2($author$project$Utils$Form$validationErrors, 0, form))
											])),
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('Identify in how many months the rate should be changed')
											]))
									]))
							])),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Add retail rate'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add')
							]))
					]))
			]));
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$modal = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.cE;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var isCurrent = _v1.a;
					var index = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed, isCurrent, index),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('cancel'),
								$author$project$Components$HiConfirm$noun('interval rate'),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Are you sure you want to cancel this rate?')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.hl;
				if (!_v2.$) {
					var addScheduleModal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$view(addScheduleModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.eU;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var addRetailModal = _v4.c;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$view(addRetailModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.eV;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var addRetailRateChangeModal = _v6.c;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$view(addRetailRateChangeModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v7 = model.iC;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var endDealModal = _v8.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$view(endDealModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$modal = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.e$;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var brokerAccount = _v1.a;
					var archiveRequest = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed(brokerAccount),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('This will end all brokers effective today and will archive the broker account.')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(archiveRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.fm;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var brokerAccount = _v3.a;
					var deleteRequest = _v3.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed(brokerAccount),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Once deleted this broker account can not be recovered.  All data, historical and current will be deleted.  To hide this broker account from view without deleting data it can be archived.')
									])),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v4 = model.fC;
				if (!_v4.$) {
					var endModal = _v4.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg,
						$author$project$Components$Broker$EndModal$view(endModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.PB;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var retailSchedule = _v6.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$modal(retailSchedule));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$Archive = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Ein = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$EndAllDeals = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$MultipleBrokers = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerName = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$Form$UpdateRetailCommissionSchedule = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$retailEnabled = function ($) {
	return $.agv;
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$ShowAddRetailModal = {$: 0};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$Cancel = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EditInterval = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval = F5(
	function (showControls, intervals, isCurrent, index, interval) {
		var previousInterval = A2($elm_community$list_extra$List$Extra$getAt, index - 1, intervals);
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('timeline__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$muted,
							$author$project$Ui$Typography$margin(2)
						]),
					function () {
						if (previousInterval.$ === 1) {
							return _List_fromArray(
								[
									$elm$html$Html$text('Start of the deal')
								]);
						} else {
							var previousInterval_ = previousInterval.a;
							return _List_fromArray(
								[
									$elm$html$Html$text('After '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2($elm$core$Maybe$map, $elm$core$String$fromInt, previousInterval_.ad3))),
									$elm$html$Html$text(' months')
								]);
						}
					}()),
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, 'N/A', interval.W2.Nx)),
							showControls ? A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var label = (!index) ? 'Edit Rate' : 'Edit Rate Change';
									return A3(
										$author$project$Ui$Button$view,
										{abp: label},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$margin(11),
												$author$project$Ui$Button$onClick(
												A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EditInterval, isCurrent, index)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(label)
											]));
								}(),
									(!index) ? $author$project$Utils$Html$empty : A3(
									$author$project$Ui$Button$view,
									{abp: 'Cancel rate change'},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$margin(11),
											$author$project$Ui$Button$onClick(
											A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$Cancel, isCurrent, index)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel Rate Change')
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDeal = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$RemoveEndDeal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions = F5(
	function (showRemoveEndDeal, showControls, scheduleEnded, isCurrent, intervals) {
		return _List_fromArray(
			[
				function () {
				if (scheduleEnded) {
					var lastInterval = $elm_community$list_extra$List$Extra$last(intervals);
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('timeline__item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$muted,
										$author$project$Ui$Typography$margin(2)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('End after '),
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'N/A',
											A2(
												$elm$core$Maybe$map,
												$elm$core$String$fromInt,
												A2(
													$elm$core$Maybe$andThen,
													function ($) {
														return $.ad3;
													},
													lastInterval)))),
										$elm$html$Html$text(' months')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				(scheduleEnded && showRemoveEndDeal) ? A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('timeline__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Remove end date'},
						_List_fromArray(
							[
								$author$project$Ui$Button$size(0),
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Commissions$BrokerAccount$RetailSchedule$RemoveEndDeal(isCurrent)),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Remove End Date')
							]))
					])) : $author$project$Utils$Html$empty,
				((!scheduleEnded) && showControls) ? A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('timeline__item')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Add rate change'},
								_List_fromArray(
									[
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$margin(11),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChange(isCurrent)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Rate Change')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'End the deal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$margin(11),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDeal(isCurrent)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('End The Deal')
									]))
							]))
					])) : $author$project$Utils$Html$empty
			]);
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewCurrentRatePeriodSchedule = F2(
	function (hasSavedSchedule, model) {
		var currentIntervals_ = A2($elm$core$Maybe$withDefault, _List_Nil, model.al);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Current retail schedule')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('timeline')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$indexedMap,
								A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval, !hasSavedSchedule, currentIntervals_, true),
								currentIntervals_),
								_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('timeline__item')
										]),
									_List_fromArray(
										[
											(hasSavedSchedule && (!model.Mx)) ? A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$muted,
													$author$project$Ui$Typography$margin(2)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Recurring Deal')
												])) : $author$project$Utils$Html$empty
										]))
								]),
								A5($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions, !hasSavedSchedule, !hasSavedSchedule, model.Mx, true, currentIntervals_)
							])))
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddNewSchedule = {$: 8};
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewFutureRatePeriodSchedule = F2(
	function (futureScheduleEnded, model) {
		var futureIntervals_ = A2($elm$core$Maybe$withDefault, _List_Nil, model.Q);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Future retail schedule')
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = model.fI;
					if (!_v0.$) {
						var futureStartDate_ = _v0.a;
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Updated rate starting from '),
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, futureStartDate_))
								]));
					} else {
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add new schedule'},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$margin(11),
											$author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddNewSchedule),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add new schedule')
										]))
								]));
					}
				}(),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('timeline')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$indexedMap,
								A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval, true, futureIntervals_, false),
								futureIntervals_),
								A5(
								$author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions,
								true,
								$author$project$Utils$Maybe$toBool(model.fI),
								futureScheduleEnded,
								false,
								futureIntervals_)
							])))
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$view = function (model) {
	var hasSavedSchedule = $author$project$Utils$Maybe$toBool(
		A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule, model.vK));
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Retail commission schedule')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Retail Commissions')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Enable commission on retail memberships')
							])),
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(model.agv),
								$author$project$Ui$ToggleSwitch$onChange(
								$elm$core$Basics$always($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ShowAddRetailModal)),
								$author$project$Ui$ToggleSwitch$disabled(model.agv)
							]))
					])),
				model.agv ? A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewCurrentRatePeriodSchedule, hasSavedSchedule, model) : $author$project$Utils$Html$empty,
				(model.agv && hasSavedSchedule) ? A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewFutureRatePeriodSchedule, model.PN, model) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Components$Commissions$BrokerAccount$Form$Delete = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$BrokerAccount$Meta$destroyable = function (_v0) {
	var record = _v0;
	return record.NC;
};
var $author$project$Components$Commissions$BrokerAccount$Form$viewDeleteButton = F2(
	function (brokerAccount, saveRequest) {
		return $author$project$Api$Provider$BrokerAccount$Meta$destroyable(
			$author$project$Api$Provider$BrokerAccount$One$meta(brokerAccount)) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Delete broker account'},
			_List_fromArray(
				[
					$author$project$Ui$Button$danger,
					$author$project$Ui$Button$loading(
					_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Commissions$BrokerAccount$Form$Delete(brokerAccount))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Delete')
				])) : A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Statements have been issued or paid so this broker account can no longer be deleted.  Archive this account to hide it from view.',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Delete broker account'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$disabled(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						]))
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$viewForm = F3(
	function (model, retailSchedule, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$label('Business Name')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(fields.zh),
										$author$project$Ui$Form$Input$placeholder('e.g. Heffernan Insurance Brokers'),
										$author$project$Ui$Form$Input$autofocus(true),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$Name)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('EIN')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Ein$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Ein$value(fields.Of),
										$author$project$Ui$Form$Ein$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$Ein)),
										$author$project$Ui$Form$Ein$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
										$author$project$Ui$Form$Ein$errors(
										A2($author$project$Utils$Form$validationErrors, 1, form))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Legal Address')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg,
								A2($author$project$Components$AddressInput$view, _List_Nil, fields.It))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$label('Multiple Brokers')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Will this account cover more than one broker?')
									])),
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.Uk),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$MultipleBrokers))
									]))
							]))
					]),
					fields.Uk ? _List_Nil : _List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$required(true),
								$author$project$Ui$Form$Group$label('Broker Name')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.Z7)),
										$author$project$Ui$Form$Input$placeholder('e.g. John Doe'),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerName)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 3, form))
									]))
							]))
					]),
					function () {
					var _v0 = model.adR;
					if (!_v0.$) {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(2),
												$author$project$Ui$FlexGrid$offsetSm(6)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$BrokerAccount$Form$button(model)
											]))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$elm$html$Html$map,
						$author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg,
						$author$project$Components$Commissions$BrokerAccount$RetailSchedule$view(retailSchedule)),
						function () {
						var _v1 = model.FU;
						if (!_v1.$) {
							var item = _v1.a;
							return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$retailEnabled(retailSchedule) ? A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(2),
												$author$project$Ui$FlexGrid$offsetSm(6)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Update retail schedule'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$loading(
														_Utils_eq(model.o0, $author$project$Api$Data$Loading)),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Commissions$BrokerAccount$Form$UpdateRetailCommissionSchedule(item)),
														$author$project$Ui$Button$disabled(
														$author$project$Api$Provider$BrokerAccount$One$retailEnabled(item) && (!$author$project$Utils$Maybe$toBool(
															$author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals(retailSchedule))))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													]))
											]))
									])) : $author$project$Utils$Html$empty;
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]),
					function () {
					var _v2 = model.FU;
					if (!_v2.$) {
						var item = _v2.a;
						return _List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Archive Broker Account')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$gray]),
								_List_fromArray(
									[
										$elm$html$Html$text('Archive this broker account to hide it from the list. If no statements are paid you may also delete this broker account; deleting an account will also delete all historical commission calculations and date, this cannot be undone.')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$gray]),
								_List_fromArray(
									[
										$elm$html$Html$text('Ending all deals will stop all future commission calculations, but will not archive the account. The end date can be today or in the future.')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Archive broker account'},
										_List_fromArray(
											[
												$author$project$Ui$Button$danger,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Commissions$BrokerAccount$Form$Archive(item))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Archive')
											])),
										A2($author$project$Components$Commissions$BrokerAccount$Form$viewDeleteButton, item, model.jY),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'End all deals for account'},
										_List_fromArray(
											[
												$author$project$Ui$Button$loading(
												_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
												$author$project$Ui$Button$onClick(
												$author$project$Components$Commissions$BrokerAccount$Form$EndAllDeals(item))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('End All Deals')
											]))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
	});
var $author$project$Components$Commissions$BrokerAccount$Form$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			$author$project$Components$Commissions$BrokerAccount$Form$modal(model),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									function () {
									var _v1 = model.adR;
									if (!_v1.$) {
										return $elm$html$Html$text('Broker Account Information');
									} else {
										return $elm$html$Html$text('Add New Broker Account');
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$horizontal,
									$author$project$Ui$Form$noValidate(true),
									$author$project$Ui$Form$autocomplete(false)
								]),
							function () {
								var _v2 = model.PB;
								if (!_v2.$) {
									var _v3 = _v2.a;
									var form = _v3.a;
									var retailSchedule = _v3.b;
									return A3($author$project$Components$Commissions$BrokerAccount$Form$viewForm, model, retailSchedule, form);
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]))
										]);
								}
							}())
						])),
					function () {
					var _v4 = model.adR;
					if (!_v4.$) {
						return $author$project$Ui$Panel$none;
					} else {
						return A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											$author$project$Components$Commissions$BrokerAccount$Form$button(model)
										]))
								]));
					}
				}()
				]))
		]);
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$view = function (model) {
	return {
		e5: $author$project$Components$Commissions$BrokerAccount$Form$view(model.PB),
		$G: 'Commissions | Broker Accounts'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$init, aer: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$load, agD: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$view});
var $author$project$Pages$Commissions$BrokerAccounts$New$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var timeZone = _v1.Hz;
		var currentDate = _v1.cO;
		var _v3 = A5($author$project$Components$Commissions$BrokerAccount$Form$init, apiClient, timeZone, currentDate, session, $elm$core$Maybe$Nothing);
		var form = _v3.a;
		var cmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			cmd);
	});
var $author$project$Pages$Commissions$BrokerAccounts$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$New$subscriptions = function (model) {
	return $author$project$Components$Commissions$BrokerAccount$Form$subscriptions(model.PB);
};
var $author$project$Pages$Commissions$BrokerAccounts$New$update = F2(
	function (msg, model) {
		var _v0 = A3($author$project$Components$Commissions$BrokerAccount$Form$update, model.D5, msg, model.PB);
		var form = _v0.a;
		var cmd = _v0.b;
		var outMsgs = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			cmd,
			outMsgs);
	});
var $author$project$Pages$Commissions$BrokerAccounts$New$view = function (model) {
	return {
		e5: $author$project$Components$Commissions$BrokerAccount$Form$view(model.PB),
		$G: 'Commissions | Broker Accounts'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$New$init, aer: $author$project$Pages$Commissions$BrokerAccounts$New$load, agD: $author$project$Pages$Commissions$BrokerAccounts$New$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$New$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$New$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$New$view});
var $author$project$Pages$Commissions$BrokerAccounts$Top$GotBrokerAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts = function (model) {
	return A3(
		$author$project$Api$Provider$BrokerAccount$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, af_: model.af_, ag1: model.ag1});
		},
		$author$project$Pages$Commissions$BrokerAccounts$Top$GotBrokerAccounts);
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$init = F4(
	function (_v0, _v1, _v2, _v3) {
		var apiClient = _v2.D5;
		var query = _v3.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: apiClient,
			hD: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(model));
	});
var $author$project$Pages$Commissions$BrokerAccounts$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$BrokerAccounts$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$BrokerAccounts$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hD: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hD: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(newModel),
								$author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								hD: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(qModel),
										$author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Commissions$BrokerAccounts$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Name'),
		A3($author$project$Api$Column$init, 'brokers', false, 'Brokers'),
		A3($author$project$Api$Column$init, 'retail_enabled', true, 'Retail Enabled')
	]);
var $author$project$Api$Provider$BrokerAccount$All$brokers = function (_v0) {
	var record = _v0.b;
	return record.Ka;
};
var $author$project$Api$Provider$BrokerAccount$All$retailEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled(shared);
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$viewBrokerAccount = function (brokerAccount) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
							{
								bP: $author$project$Api$Provider$BrokerAccount$All$id(brokerAccount)
							}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$BrokerAccount$All$name(brokerAccount))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$String$toSentence(
							A2(
								$elm$core$List$map,
								$author$project$Api$Provider$Broker$Shared$name,
								$author$project$Api$Provider$BrokerAccount$All$brokers(brokerAccount))))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$Bool$toString(
							$author$project$Api$Provider$BrokerAccount$All$retailEnabled(brokerAccount)))
					]))
			]));
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.hD;
		if (_v1.$ === 3) {
			var brokerAccounts_ = _v1.a;
			return _Utils_Tuple2(false, brokerAccounts_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var brokerAccounts = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					function () {
						var _v2 = model.af_;
						if (!_v2.$) {
							return _List_fromArray(
								[
									$elm$html$Html$text('No matching results. Please check your search query or '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('create a new broker account')
										])),
									$elm$html$Html$text('.')
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text('It looks like you haven’t added any broker accounts yet. '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Create one')
										])),
									$elm$html$Html$text('?')
								]);
						}
					}()),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Commissions$BrokerAccounts$Top$SortTable)),
						$author$project$Pages$Commissions$BrokerAccounts$Top$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Commissions$BrokerAccounts$Top$viewBrokerAccount, brokerAccounts),
			_List_Nil)
		]);
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Manage Broker Accounts')
											])),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
										_List_fromArray(
											[
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$pull(1),
												$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add Account')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(10)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('A broker account represents the business entity to which you will pay a commission.  You can add more than one broker to each account, but those brokers will not each receive a statement.')
													]))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search for account and broker names')
														]),
													model.sA))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Commissions$BrokerAccounts$Top$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.hD;
								if (_v0.$ === 3) {
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Commissions$BrokerAccounts$Top$PaginationMsg,
										A2($author$project$Api$Pagination$view, _List_Nil, model.afy));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		$G: 'Commissions | Broker Accounts'
	};
};
var $author$project$Pages$Commissions$BrokerAccounts$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$BrokerAccounts$Top$init, aer: $author$project$Pages$Commissions$BrokerAccounts$Top$load, agD: $author$project$Pages$Commissions$BrokerAccounts$Top$save, ahd: $author$project$Pages$Commissions$BrokerAccounts$Top$subscriptions, aaq: $author$project$Pages$Commissions$BrokerAccounts$Top$update, ahP: $author$project$Pages$Commissions$BrokerAccounts$Top$view});
var $author$project$Pages$Commissions$StatementLines$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Commissions$StatementLines$Summary = 1;
var $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Commissions$StatementLines$ByDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Commissions$StatementLines$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Commissions$StatementLines$PayableDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Report$StatementLine = 2;
var $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$QueryParameter$fromTuple = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return A2($elm$url$Url$Builder$string, key, value);
};
var $author$project$Utils$QueryParameter$fromList = function (list) {
	return A2($elm$core$List$map, $author$project$Utils$QueryParameter$fromTuple, list);
};
var $author$project$Utils$QueryParameter$fromDict = function (dict) {
	return $author$project$Utils$QueryParameter$fromList(
		$elm$core$Dict$toList(dict));
};
var $author$project$Components$Commissions$StatementLines$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('q'),
			model.af_),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('broker_account'),
			model.bP),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('statement'),
			model.ag6),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('broker'),
			model.Eo),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('company'),
			model.ff),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('payable'),
				$author$project$Utils$Bool$toString),
			model.afF),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.bQ)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Commissions$StatementLines$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				function () {
				var _v0 = model.bQ;
				if (!_v0.$) {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__StatementLines__Summary);
				} else {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__StatementLines__Top);
				}
			}()
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Components$Commissions$StatementLines$urlParams(model)))));
};
var $author$project$Components$Commissions$StatementLines$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Commissions$StatementLines$GotStatementLines = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Commissions$StatementLines$fetchStatementLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				vJ: model.Eo,
				vK: model.bP,
				ab9: model.ff,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				afy: model.afy,
				afF: model.afF,
				af_: model.af_,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				Hm: model.ag6
			});
	};
};
var $author$project$Api$Provider$StatementLine$All$StatementLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$StatementLine$All$Record = function (type_) {
	return function (dealType) {
		return function (date) {
			return function (statementNumber) {
				return function (payable) {
					return function (amountInCents) {
						return function (description) {
							return function (patient) {
								return function (owner) {
									return function (broker) {
										return function (statementAdjustment) {
											return function (charge) {
												return function (company) {
													return {I2: amountInCents, vJ: broker, abU: charge, ab9: company, MO: date, M2: dealType, Nx: description, Vp: owner, VM: patient, afF: payable, _I: statementAdjustment, _K: statementNumber, ahI: type_};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$BrokerDeal$DealType$Company = 0;
var $author$project$Api$Provider$BrokerDeal$DealType$Membership = 1;
var $author$project$Api$Provider$BrokerDeal$DealType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'Company':
				return $elm$json$Json$Decode$succeed(0);
			case 'Membership':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = string;
				return $elm$json$Json$Decode$fail('Unknown BrokerDeal.DealType: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$Charge$SharedWithInvoice$Charge = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$SharedWithInvoice$Record = function (invoice) {
	return {Rh: invoice};
};
var $author$project$Api$Provider$Charge$SharedWithInvoice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$SharedWithInvoice$Record));
var $author$project$Api$Provider$Charge$SharedWithInvoice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$SharedWithInvoice$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Charge$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$SharedWithInvoice$Charge)));
var $author$project$Api$Provider$StatementAdjustment$Min$StatementAdjustment = $elm$core$Basics$identity;
var $author$project$Api$Provider$StatementAdjustment$Min$Record = F2(
	function (category, memo) {
		return {Ex: category, aeC: memo};
	});
var $author$project$Api$Provider$StatementAdjustment$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'memo',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'category',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementAdjustment$Min$Record)));
var $author$project$Api$Provider$StatementAdjustment$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$StatementAdjustment$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$StatementLine$All$CommissionBillLine = 0;
var $author$project$Api$Provider$StatementLine$All$StatementAdjustmentLine = 1;
var $author$project$Api$Provider$StatementLine$All$typeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'CommissionBillLine':
				return $elm$json$Json$Decode$succeed(0);
			case 'StatementAdjustmentLine':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = string;
				return $elm$json$Json$Decode$fail('Unknown StatementLine.type: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$StatementLine$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company',
	$elm$json$Json$Decode$maybe($author$project$Api$Provider$Company$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charge',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$SharedWithInvoice$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'statement_adjustment',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$StatementAdjustment$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'broker',
				$author$project$Api$Provider$Broker$Shared$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'owner',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'patient',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'description',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'amount_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'payable',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'statement_number',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'date',
											$author$project$Utils$Date$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'deal_type',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$BrokerDeal$DealType$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'type',
													$author$project$Api$Provider$StatementLine$All$typeDecoder,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementLine$All$Record))))))))))))));
var $author$project$Api$Provider$StatementLine$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$StatementLine$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$StatementLine$listDefaults = {vJ: $elm$core$Maybe$Nothing, vK: $elm$core$Maybe$Nothing, ab9: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, afF: $elm$core$Maybe$Nothing, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, Hm: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$StatementLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$StatementLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.af_;
						if (!_v2.$) {
							var string = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'q', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.vK;
						if (!_v3.$) {
							var string = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'broker_account', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.Hm;
						if (!_v4.$) {
							var string = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'statement', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.vJ;
						if (!_v5.$) {
							var string = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'broker', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.ab9;
						if (!_v6.$) {
							var string = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'company', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v7 = options.afF;
						if (!_v7.$) {
							var bool = _v7.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$bool, 'payable', bool)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$StatementLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['statement_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$StatementLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$StatementLine$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$StatementLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$StatementLine$listPath)));
	});
var $author$project$Components$Commissions$StatementLines$fetchStatementLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$StatementLine$list,
			apiClient,
			$author$project$Components$Commissions$StatementLines$fetchStatementLinesParams(model),
			$author$project$Components$Commissions$StatementLines$GotStatementLines);
	});
var $author$project$Components$Commissions$StatementLines$GotSummary = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Commissions$StatementLines$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				vJ: model.Eo,
				vK: model.bP,
				ab9: model.ff,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				afF: model.afF,
				af_: model.af_,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				Hm: model.ag6
			});
	};
};
var $author$project$Api$Provider$Reports$Summary$Summary = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Summary$SummaryRecord = F3(
	function (type_, values, rows) {
		return {YQ: rows, ahI: type_, o9: values};
	});
var $author$project$Api$Provider$Reports$Summary$Row = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Summary$RowRecord = F4(
	function (type_, name, params, values) {
		return {zh: name, Vx: params, ahI: type_, o9: values};
	});
var $author$project$Api$Provider$Reports$Summary$SummaryValuesRecord = F5(
	function (amountInCents, hintFeeInCents, stripeFeeInCents, totalFeeInCents, count) {
		return {I2: amountInCents, LY: count, Qv: hintFeeInCents, _V: stripeFeeInCents, $V: totalFeeInCents};
	});
var $author$project$Api$Provider$Reports$Summary$summaryValuesDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'count',
	$elm$json$Json$Decode$int,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'total_fee_in_cents',
		$elm$json$Json$Decode$int,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'stripe_fee_in_cents',
			$elm$json$Json$Decode$int,
			0,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'hint_fee_in_cents',
				$elm$json$Json$Decode$int,
				0,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$SummaryValuesRecord))))));
var $author$project$Api$Provider$Reports$Summary$summaryRowRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'values',
	$author$project$Api$Provider$Reports$Summary$summaryValuesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'params',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'type',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$RowRecord)))));
var $author$project$Api$Provider$Reports$Summary$summaryRowDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Summary$summaryRowRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Summary$summaryRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Summary$summaryRowDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'values',
		$author$project$Api$Provider$Reports$Summary$summaryValuesDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$SummaryRecord))));
var $author$project$Api$Provider$Reports$Summary$summaryDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Summary$summaryRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Summary$summaryPath = function (listPath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['summary']),
		listPath);
};
var $author$project$Api$Provider$Reports$Summary$retrieve = F5(
	function (apiClient, listPath, by, params, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Reports$Summary$summaryDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				params,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2($author$project$Api$Param$string, 'by', by)
						]),
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$Reports$Summary$summaryPath(listPath)))));
	});
var $author$project$Api$Provider$StatementLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$StatementLine$listPath,
			by,
			$author$project$Api$Provider$StatementLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Commissions$StatementLines$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$StatementLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.bQ),
			$author$project$Components$Commissions$StatementLines$fetchSummaryParams(model),
			$author$project$Components$Commissions$StatementLines$GotSummary);
	});
var $author$project$Components$Commissions$StatementLines$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.ahI;
		if (!_v0) {
			return A2($author$project$Components$Commissions$StatementLines$fetchStatementLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Commissions$StatementLines$fetchSummary, apiClient, model),
						A2($author$project$Components$Commissions$StatementLines$fetchStatementLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Commissions$StatementLines$initBrokerFilter = F3(
	function (apiClient, brokerAccountId, brokerId) {
		return A3(
			$author$project$Components$ResourceFilter$Broker$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{vK: brokerAccountId});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Brokers', afT: brokerId});
			});
	});
var $author$project$Components$ResourceFilter$Statement$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Statement$list = $author$project$Api$Provider$Statement$list;
var $author$project$Components$ResourceFilter$Statement$fetchResources = F5(
	function (listOptionals, toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Statement$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Statement$retrieveResource = F4(
	function (listOptionals, toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Statement$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$Statement$selectId = 'statements';
var $author$project$Components$ResourceFilter$Statement$toTitle = function (resource) {
	return '#' + $elm$core$String$fromInt(
		$author$project$Api$Provider$Statement$All$number(resource));
};
var $author$project$Components$ResourceFilter$Statement$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Statement$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Statement$toValue = $author$project$Api$Provider$Statement$All$id;
var $author$project$Components$ResourceFilter$Statement$init = F3(
	function (apiClient, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$Statement$fetchResources(listOptionals),
				adR: $author$project$Components$ResourceFilter$Statement$selectId,
				gx: 'Statements',
				st: $author$project$Components$ResourceFilter$Statement$retrieveResource(listOptionals),
				ahw: $author$project$Components$ResourceFilter$Statement$toLabel,
				ahA: $author$project$Components$ResourceFilter$Statement$toTitle,
				g0: $author$project$Components$ResourceFilter$Statement$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Commissions$StatementLines$initStatementFilter = F3(
	function (apiClient, brokerAccountId, statementId) {
		return A3(
			$author$project$Components$ResourceFilter$Statement$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{vK: brokerAccountId});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Statements', afT: statementId});
			});
	});
var $author$project$Components$Commissions$StatementLines$PollStatus = {$: 15};
var $author$project$Components$Commissions$StatementLines$pollStatus = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return $author$project$Components$Commissions$StatementLines$PollStatus;
	},
	$elm$core$Process$sleep(2000));
var $author$project$Components$Commissions$StatementLines$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.cO;
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var statementId = A2($elm$core$Dict$get, 'statement', query);
		var q = A2($elm$core$Dict$get, 'q', query);
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var brokerId = A2($elm$core$Dict$get, 'broker', query);
		var brokerAccountId = A2($elm$core$Dict$get, 'broker_account', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var statementLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A3($author$project$Components$Commissions$StatementLines$initStatementFilter, apiClient, brokerAccountId, statementId);
		var statementResourceFilter = _v3.a;
		var statementResourceFilterCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Commissions$StatementLines$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v6.a;
		var companyResourceFilterCmd = _v6.b;
		var _v7 = A3($author$project$Components$Commissions$StatementLines$initBrokerFilter, apiClient, brokerAccountId, brokerId);
		var brokerResourceFilter = _v7.a;
		var brokerResourceFilterCmd = _v7.b;
		var _v8 = A3(
			$author$project$Components$ResourceFilter$BrokerAccount$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Broker Accounts', afT: brokerAccountId});
			});
		var brokerAccountResourceFilter = _v8.a;
		var brokerAccountResourceFilterCmd = _v8.b;
		var model = {
			bP: brokerAccountId,
			le: brokerAccountResourceFilter,
			Eo: brokerId,
			lf: brokerResourceFilter,
			bQ: A2($elm$core$Dict$get, 'by', query),
			lh: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'by-dropdown-filter', ahx: $author$project$Components$Commissions$StatementLines$ByDropdownMsg})),
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			ff: companyId,
			pV: companyResourceFilter,
			cO: currentDate,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 2}),
			q6: false,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			afF: A2(
				$elm$core$Maybe$andThen,
				$author$project$Utils$Bool$fromString,
				A2($elm$core$Dict$get, 'payable', query)),
			nn: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'payable-dropdown-filter', ahx: $author$project$Components$Commissions$StatementLines$PayableDropdownMsg})),
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'date',
				0,
				A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init)),
			Hl: start,
			ag6: statementId,
			p: statementLines,
			eI: statementResourceFilter,
			_9: summary,
			ahI: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg, brokerAccountResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
						$author$project$Components$Commissions$StatementLines$pollStatus
					])));
	});
var $author$project$Pages$Commissions$StatementLines$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Commissions$StatementLines$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Commissions$StatementLines$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$StatementLines$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Commissions$StatementLines$ExportCsvMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$ResourceFilter$Statement$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Commissions$StatementLines$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				$author$project$Ui$NewDropdown$subscriptions(model.nn),
				$author$project$Ui$NewDropdown$subscriptions(model.lh),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg,
				$author$project$Components$ResourceFilter$Statement$subscriptions(model.eI)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg,
				$author$project$Components$ResourceFilter$Broker$subscriptions(model.lf)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg,
				$author$project$Components$ResourceFilter$BrokerAccount$subscriptions(model.le)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.pV))
			]));
};
var $author$project$Pages$Commissions$StatementLines$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Commissions$StatementLines$subscriptions(model.jO));
};
var $author$project$Api$Provider$StatementLine$Done = 1;
var $author$project$Components$Commissions$StatementLines$GotStatus = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Commissions$StatementLines$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$StatementLine$Running = 0;
var $author$project$Api$Provider$StatementLine$StatusRecord = function (status) {
	return {ag7: status};
};
var $author$project$Api$Provider$StatementLine$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (record) {
		var _v0 = record.ag7;
		switch (_v0) {
			case 'running':
				return $elm$json$Json$Decode$succeed(0);
			case 'done':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = _v0;
				return $elm$json$Json$Decode$fail('Unsupported StatementLine -> Status: ' + somethingElse);
		}
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementLine$StatusRecord)));
var $author$project$Api$Provider$StatementLine$statusPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['status']),
	$author$project$Api$Provider$StatementLine$listPath);
var $author$project$Api$Provider$StatementLine$status = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$StatementLine$statusDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$StatementLine$statusPath));
	});
var $author$project$Components$ResourceFilter$Statement$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$Statement$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Commissions$StatementLines$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v1.a;
				var searchInputCmd = _v1.b;
				var searchInputEvent = _v1.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v2 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q,
								p: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, qModel),
										A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var brokerAccountResourceResult = A3($author$project$Components$ResourceFilter$BrokerAccount$update, apiClient, subMsg, model.le);
				var brokerAccountId = function () {
					var _v10 = brokerAccountResourceResult.ac5;
					if (!_v10.$) {
						if (!_v10.a.$) {
							return $author$project$Components$ResourceFilter$BrokerAccount$value(brokerAccountResourceResult.y8);
						} else {
							var _v11 = _v10.a;
							return model.bP;
						}
					} else {
						return model.bP;
					}
				}();
				var _v4 = function () {
					var _v5 = brokerAccountResourceResult.ac5;
					if (!_v5.$) {
						if (!_v5.a.$) {
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								$elm$core$Maybe$Nothing,
								A3($author$project$Components$Commissions$StatementLines$initStatementFilter, apiClient, brokerAccountId, $elm$core$Maybe$Nothing));
						} else {
							var _v6 = _v5.a;
							return _Utils_Tuple3(model.eI, $elm$core$Platform$Cmd$none, model.ag6);
						}
					} else {
						return _Utils_Tuple3(model.eI, $elm$core$Platform$Cmd$none, model.ag6);
					}
				}();
				var statementResourceFilter = _v4.a;
				var statementResourceFilterCmd = _v4.b;
				var statementId = _v4.c;
				var _v7 = function () {
					var _v8 = brokerAccountResourceResult.ac5;
					if ((!_v8.$) && (!_v8.a.$)) {
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							$elm$core$Maybe$Nothing,
							A3($author$project$Components$Commissions$StatementLines$initBrokerFilter, apiClient, brokerAccountId, $elm$core$Maybe$Nothing));
					} else {
						return _Utils_Tuple3(model.lf, $elm$core$Platform$Cmd$none, model.Eo);
					}
				}();
				var brokerResourceFilter = _v7.a;
				var brokerResourceFilterCmd = _v7.b;
				var brokerId = _v7.c;
				var newModel = _Utils_update(
					model,
					{bP: brokerAccountId, le: brokerAccountResourceResult.y8, Eo: brokerId, lf: brokerResourceFilter, ag6: statementId, eI: statementResourceFilter});
				var _v9 = (_Utils_eq(model.bP, newModel.bP) && (_Utils_eq(model.ag6, newModel.ag6) && _Utils_eq(model.Eo, newModel.Eo))) ? _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var statementLines = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{p: statementLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg, brokerAccountResourceResult.EC),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceFilterCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceFilterCmd),
								cmd
							])),
					brokerAccountResourceResult.as);
			case 3:
				var subMsg = msg.a;
				var statementResourceResult = A3($author$project$Components$ResourceFilter$Statement$update, apiClient, subMsg, model.eI);
				var statementId = function () {
					var _v13 = statementResourceResult.ac5;
					if (!_v13.$) {
						if (!_v13.a.$) {
							return $author$project$Components$ResourceFilter$Statement$value(statementResourceResult.y8);
						} else {
							var _v14 = _v13.a;
							return model.ag6;
						}
					} else {
						return model.ag6;
					}
				}();
				var newModel = _Utils_update(
					model,
					{ag6: statementId, eI: statementResourceResult.y8});
				var _v12 = _Utils_eq(model.ag6, newModel.ag6) ? _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var statementLines = _v12.a;
				var cmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{p: statementLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceResult.EC),
								cmd
							])),
					statementResourceResult.as);
			case 4:
				var subMsg = msg.a;
				var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.lf);
				var brokerId = function () {
					var _v16 = brokerResourceResult.ac5;
					if (!_v16.$) {
						if (!_v16.a.$) {
							return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.y8);
						} else {
							var _v17 = _v16.a;
							return model.Eo;
						}
					} else {
						return model.Eo;
					}
				}();
				var newModel = _Utils_update(
					model,
					{Eo: brokerId, lf: brokerResourceResult.y8});
				var _v15 = _Utils_eq(model.Eo, newModel.Eo) ? _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var statementLines = _v15.a;
				var cmd = _v15.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{p: statementLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceResult.EC),
								cmd
							])),
					brokerResourceResult.as);
			case 5:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pV);
				var companyId = function () {
					var _v19 = companyResourceResult.ac5;
					if (!_v19.$) {
						if (!_v19.a.$) {
							return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.y8);
						} else {
							var _v20 = _v19.a;
							return model.ff;
						}
					} else {
						return model.ff;
					}
				}();
				var newModel = _Utils_update(
					model,
					{ff: companyId, pV: companyResourceResult.y8});
				var _v18 = _Utils_eq(model.ff, newModel.ff) ? _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var statementLines = _v18.a;
				var cmd = _v18.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{p: statementLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg, companyResourceResult.EC),
								cmd
							])),
					companyResourceResult.as);
			case 6:
				var subMsg = msg.a;
				var _v21 = A2($author$project$Ui$NewDropdown$update, subMsg, model.nn);
				var payableDropdown = _v21.a;
				var cmd = _v21.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nn: payableDropdown}),
					cmd,
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v22 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lh);
				var byDropdown = _v22.a;
				var cmd = _v22.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lh: byDropdown}),
					cmd,
					_List_Nil);
			case 8:
				var payable = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						afF: payable,
						p: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bQ: by,
						afy: $author$project$Api$Pagination$reset(model.afy),
						p: $author$project$Api$Data$Loading
					});
				var cmds = function () {
					var _v23 = _Utils_Tuple2(model.ahI, newModel.bQ);
					if (!_v23.a) {
						if (!_v23.b.$) {
							var _v24 = _v23.a;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v25 = _v23.a;
							var _v26 = _v23.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v23.b.$ === 1) {
							var _v27 = _v23.a;
							var _v28 = _v23.b;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v29 = _v23.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v30 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v30.a;
				var subCmd = _v30.b;
				var event = _v30.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
								p: $author$project$Api$Data$Loading
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								p: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{p: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 12:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, p: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 13:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1),
						p: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 14:
				var subMsg = msg.a;
				var _v33 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v33.a;
				var subCmd = _v33.b;
				var subOutMsg = _v33.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$ExportCsvMsg, subCmd),
					subOutMsg);
			case 15:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$StatementLine$status, apiClient, $author$project$Components$Commissions$StatementLines$GotStatus),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var status = response.a;
					var isRunnningBackgroundJobs = status !== 1;
					var _v35 = (model.q6 && (!isRunnningBackgroundJobs)) ? _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, model)) : _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none);
					var statementLines = _v35.a;
					var cmd = _v35.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{q6: isRunnningBackgroundJobs, p: statementLines}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[$author$project$Components$Commissions$StatementLines$pollStatus, cmd])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$author$project$Components$Commissions$StatementLines$pollStatus,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Commissions$StatementLines$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Commissions$StatementLines$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Commissions$StatementLines$PaginationMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Commissions$StatementLines$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Commissions$StatementLines$viewBrokerAccountResourceFilter = function (brokerAccountResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$BrokerAccount$viewNew, _List_Nil, brokerAccountResourceFilter));
};
var $author$project$Components$Commissions$StatementLines$viewBrokerResourceFilter = function (brokerResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_Nil, brokerResourceFilter));
};
var $author$project$Components$Commissions$StatementLines$ByOptionSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Commissions$StatementLines$viewByDropdown = function (model) {
	var currentText = function () {
		var _v0 = model.bQ;
		_v0$2:
		while (true) {
			if (!_v0.$) {
				switch (_v0.a) {
					case 'broker_account':
						return 'Broker Account';
					case 'broker':
						return 'Broker';
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return 'Summarize by';
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentText)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$ByOptionSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(model.bQ, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
				$author$project$Ui$NewDropdown$separator,
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$ByOptionSelected(
							$elm$core$Maybe$Just('broker_account'))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							model.bQ,
							$elm$core$Maybe$Just('broker_account')))
					]),
				$elm$html$Html$text('Broker Account')),
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$ByOptionSelected(
							$elm$core$Maybe$Just('broker'))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							model.bQ,
							$elm$core$Maybe$Just('broker')))
					]),
				$elm$html$Html$text('Broker'))
			]),
		model.lh);
};
var $author$project$Components$Commissions$StatementLines$viewCompanyResourceFilter = function (companyResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Company$viewNew, _List_Nil, companyResourceFilter));
};
var $author$project$Components$Commissions$StatementLines$PayableOptionSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Commissions$StatementLines$viewPayableDropdown = function (model) {
	var currentText = function () {
		var _v0 = model.afF;
		if (!_v0.$) {
			if (_v0.a) {
				return 'Payable';
			} else {
				return 'Pending';
			}
		} else {
			return 'Status';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentText)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$PayableOptionSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(model.afF, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All')),
				$author$project$Ui$NewDropdown$separator,
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$PayableOptionSelected(
							$elm$core$Maybe$Just(true))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							model.afF,
							$elm$core$Maybe$Just(true)))
					]),
				$elm$html$Html$text('Payable')),
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Commissions$StatementLines$PayableOptionSelected(
							$elm$core$Maybe$Just(false))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							model.afF,
							$elm$core$Maybe$Just(false)))
					]),
				$elm$html$Html$text('Pending'))
			]),
		model.nn);
};
var $author$project$Components$ResourceFilter$Statement$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Commissions$StatementLines$viewStatementResourceFilter = function (statementResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg,
		A2($author$project$Components$ResourceFilter$Statement$viewNew, _List_Nil, statementResourceFilter));
};
var $author$project$Api$Provider$Reports$Summary$summaryRows = function (_v0) {
	var record = _v0;
	return record.YQ;
};
var $author$project$Api$Provider$Reports$Summary$summaryType = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents = function (_v0) {
	var record = _v0;
	return record.o9.I2;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowCount = function (_v0) {
	var record = _v0;
	return record.o9.LY;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowName = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$Api$Provider$Reports$Summary$summaryRowParams = function (_v0) {
	var record = _v0;
	return record.Vx;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowType = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Utils$Report$summaryRowTableParams = F2(
	function (urlParams, summaryRow) {
		return $author$project$Utils$QueryParameter$fromDict(
			A2(
				$elm$core$Dict$filter,
				F2(
					function (key, _v0) {
						return ($author$project$Api$Provider$Reports$Summary$summaryRowType(summaryRow) !== 'deposit') || ((key !== 'start') && (key !== 'end'));
					}),
				A2(
					$elm$core$Dict$remove,
					'by',
					A2(
						$elm$core$Dict$union,
						urlParams,
						$author$project$Api$Provider$Reports$Summary$summaryRowParams(summaryRow)))));
	});
var $author$project$Components$Commissions$StatementLines$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Commissions$StatementLines$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Unassigned',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'charge',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Commissions$StatementLines$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model._9)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model._9)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model._9)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Commission Lines')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Commissions$StatementLines$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Commissions$StatementLines$SortTable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Commissions$StatementLines$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'date', true, 'Date'),
		A3($author$project$Api$Column$init, 'statement', true, 'Statement'),
		A3($author$project$Api$Column$init, 'broker', false, 'Broker'),
		A3($author$project$Api$Column$init, 'reference', false, 'Reference'),
		A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
		A3($author$project$Api$Column$init, 'payable', true, 'Status'),
		A3($author$project$Api$Column$init, 'commission', false, 'Commission')
	]);
var $author$project$Api$Provider$StatementLine$All$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$StatementLine$All$broker = function (_v0) {
	var record = _v0;
	return record.vJ;
};
var $author$project$Api$Provider$StatementAdjustment$Min$category = function (_v0) {
	var record = _v0;
	return record.Ex;
};
var $author$project$Api$Provider$StatementLine$All$charge = function (_v0) {
	var record = _v0;
	return record.abU;
};
var $author$project$Api$Provider$StatementLine$All$company = function (_v0) {
	var record = _v0;
	return record.ab9;
};
var $author$project$Api$Common$Payable$Invoice$Min$date = function (_v0) {
	var record = _v0;
	return record.MO;
};
var $author$project$Api$Common$Payable$Invoice$MinWithOwner$date = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Common$Payable$Invoice$Min$date(min);
};
var $author$project$Api$Provider$StatementLine$All$date = function (_v0) {
	var record = _v0;
	return record.MO;
};
var $author$project$Api$Provider$StatementLine$All$dealType = function (_v0) {
	var record = _v0;
	return record.M2;
};
var $author$project$Api$Provider$StatementLine$All$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$Charge$SharedWithInvoice$invoice = function (_v0) {
	var record = _v0.b;
	return record.Rh;
};
var $author$project$Api$Provider$StatementAdjustment$Min$memo = function (_v0) {
	var record = _v0;
	return record.aeC;
};
var $author$project$Api$Provider$StatementLine$All$owner = function (_v0) {
	var record = _v0;
	return record.Vp;
};
var $author$project$Api$Provider$StatementLine$All$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Api$Provider$StatementLine$All$payable = function (_v0) {
	var record = _v0;
	return record.afF;
};
var $author$project$Api$Provider$StatementLine$All$statementAdjustment = function (_v0) {
	var record = _v0;
	return record._I;
};
var $author$project$Api$Provider$StatementLine$All$statementNumber = function (_v0) {
	var record = _v0;
	return record._K;
};
var $author$project$Api$Provider$Charge$SharedWithInvoice$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
};
var $author$project$Api$Provider$StatementLine$All$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Components$Commissions$StatementLines$viewRow = F2(
	function (canGoToPatients, statementLine) {
		var patientName = function (patient_) {
			return A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$Patient$Min$name(patient_))
					]));
		};
		var patient = $author$project$Api$Provider$StatementLine$All$patient(statementLine);
		var broker = $author$project$Api$Provider$StatementLine$All$broker(statementLine);
		var brokerAccount = $author$project$Api$Provider$Broker$Shared$brokerAccount(broker);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$StatementLine$All$date(statementLine)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$StatementLine$All$statementNumber(statementLine);
							if (!_v0.$) {
								var statementNumber = _v0.a;
								return A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'#' + $elm$core$String$fromInt(statementNumber))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top(
								{
									bP: $author$project$Api$Provider$BrokerAccount$Shared$id(brokerAccount),
									Eo: $author$project$Api$Provider$Broker$Shared$id(broker)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Broker$Shared$name(broker))
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$BrokerAccount$Shared$name(brokerAccount))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v1 = $author$project$Api$Provider$StatementLine$All$type_(statementLine);
						if (!_v1) {
							var owner = $author$project$Api$Provider$StatementLine$All$owner(statementLine);
							return _List_fromArray(
								[
									function () {
									var _v2 = _Utils_Tuple2(patient, canGoToPatients);
									if (!_v2.a.$) {
										if (_v2.b) {
											var patient_ = _v2.a.a;
											return A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														VN: $author$project$Api$Provider$Patient$Min$id(patient_)
													}),
												_List_Nil,
												_List_fromArray(
													[
														patientName(patient_)
													]));
										} else {
											var patient_ = _v2.a.a;
											return patientName(patient_);
										}
									} else {
										var _v3 = _v2.a;
										return $elm$html$Html$text('N/A');
									}
								}(),
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											_Utils_eq(
											A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, owner),
											A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, patient)) ? $elm$html$Html$text('Owns the membership') : $elm$html$Html$text(
											'Membership owner: ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, owner)))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Api$Provider$StatementAdjustment$Min$category, $author$project$Formatters$String$titleize),
											$author$project$Api$Provider$StatementLine$All$statementAdjustment(statementLine)))),
									$elm$html$Html$text(' Adjustment'),
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$String$ellipsis,
												30,
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Api$Provider$StatementAdjustment$Min$memo,
														$author$project$Api$Provider$StatementLine$All$statementAdjustment(statementLine)))))
										]))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v4 = $author$project$Api$Provider$StatementLine$All$type_(statementLine);
						if (!_v4) {
							var invoiceRoute = function (invoice_) {
								return A2(
									$elm$core$Maybe$andThen,
									function (dealType) {
										if (!dealType) {
											return A2(
												$elm$core$Maybe$map,
												function (invoiceOwner) {
													return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
														{
															ff: $author$project$Api$Common$Payable$Owner$Min$id(invoiceOwner),
															adR: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice_)
														});
												},
												$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice_));
										} else {
											var _v11 = _Utils_Tuple2(patient, canGoToPatients);
											if ((!_v11.a.$) && _v11.b) {
												var patient_ = _v11.a.a;
												return $elm$core$Maybe$Just(
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
														{
															aea: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice_),
															VN: $author$project$Api$Provider$Patient$Min$id(patient_)
														}));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}
									},
									$author$project$Api$Provider$StatementLine$All$dealType(statementLine));
							};
							var invoice = A2(
								$elm$core$Maybe$andThen,
								$author$project$Api$Provider$Charge$SharedWithInvoice$invoice,
								$author$project$Api$Provider$StatementLine$All$charge(statementLine));
							return _List_fromArray(
								[
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										var _v6 = invoiceRoute(invoice_);
										if (!_v6.$) {
											var invoiceRoute_ = _v6.a;
											return A3(
												$author$project$Ui$Link$route,
												invoiceRoute_,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														'#' + $elm$core$String$fromInt(
															$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice_)))
													]));
										} else {
											return $elm$html$Html$text(
												'#' + $elm$core$String$fromInt(
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice_)));
										}
									} else {
										return $elm$html$Html$text('N/A');
									}
								}(),
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(' on '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													A2(
														$elm$core$Basics$composeR,
														$author$project$Api$Common$Payable$Invoice$MinWithOwner$date,
														$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full)),
													invoice))),
											$elm$html$Html$text(' for '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													A2($elm$core$Basics$composeR, $author$project$Api$Provider$Charge$SharedWithInvoice$totalInCents, $author$project$Utils$Currency$fromInt),
													$author$project$Api$Provider$StatementLine$All$charge(statementLine))))
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											function () {
											var _v7 = $author$project$Api$Provider$StatementLine$All$dealType(statementLine);
											if (_v7.$ === 1) {
												return $elm$html$Html$text('N/A');
											} else {
												if (!_v7.a) {
													var _v8 = _v7.a;
													return $elm$html$Html$text(
														'For Employer: ' + A2(
															$elm$core$Maybe$withDefault,
															'N/A',
															A2(
																$elm$core$Maybe$map,
																$author$project$Api$Provider$Company$Min$name,
																$author$project$Api$Provider$StatementLine$All$company(statementLine))));
												} else {
													var _v9 = _v7.a;
													return $elm$html$Html$text('Retail Deal');
												}
											}
										}()
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$StatementLine$All$payable(statementLine) ? 'payable' : 'pending')
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$StatementLine$All$amountInCents(statementLine))),
							$author$project$Utils$Html$noBreakSpace,
							(!$author$project$Api$Provider$StatementLine$All$type_(statementLine)) ? A3(
							$author$project$Ui$Tooltip$view,
							_List_fromArray(
								[
									$author$project$Ui$Tooltip$placement(2)
								]),
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$StatementLine$All$description(statementLine)),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											A2($author$project$Ui$Icon$view, _List_Nil, 5)
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Commissions$StatementLines$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.p;
		if (_v1.$ === 3) {
			var statementLines_ = _v1.a;
			return _Utils_Tuple2(false, statementLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var statementLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Commissions$StatementLines$SortTable)),
					$author$project$Components$Commissions$StatementLines$columns),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$pull(1)
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Components$Commissions$StatementLines$viewRow(model.Er),
			statementLines),
		_List_Nil);
};
var $author$project$Components$Commissions$StatementLines$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Commissions$StatementLines$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$path($author$project$Api$Provider$StatementLine$listPath),
							$author$project$Components$ExportCsv$params(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$StatementLine$listOptionsToParams, $author$project$Components$Commissions$StatementLines$fetchStatementLinesParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.p;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Commissions$StatementLines$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total amount of statement lines generated for brokers')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Commissions$StatementLines$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.h3))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Commissions$StatementLines$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search for patient or membership owner name')
														]),
													model.sA))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewBrokerAccountResourceFilter(model.le)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewStatementResourceFilter(model.eI)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewBrokerResourceFilter(model.lf)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewCompanyResourceFilter(model.pV)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewPayableDropdown(model)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Commissions$StatementLines$viewByDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								model.q6 ? A2(
								$author$project$Ui$Alert$warning,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We are updating this report with recent invoice changes. The page will reload when the update completes.')
									])) : $author$project$Utils$Html$empty
							])),
						function () {
						var _v1 = model.ahI;
						if (!_v1) {
							return $author$project$Components$Commissions$StatementLines$viewTable(model);
						} else {
							return $author$project$Components$Commissions$StatementLines$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.ahI;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Commissions$StatementLines$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.p)))
												]),
											model.afy))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Commissions$StatementLines$Summary$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Commissions$StatementLines$view, model.D5, model.jO)),
		$G: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$StatementLines$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$StatementLines$Summary$init, aer: $author$project$Pages$Commissions$StatementLines$Summary$load, agD: $author$project$Pages$Commissions$StatementLines$Summary$save, ahd: $author$project$Pages$Commissions$StatementLines$Summary$subscriptions, aaq: $author$project$Pages$Commissions$StatementLines$Summary$update, ahP: $author$project$Pages$Commissions$StatementLines$Summary$view});
var $author$project$Pages$Commissions$StatementLines$Top$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Commissions$StatementLines$Table = 0;
var $author$project$Pages$Commissions$StatementLines$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Commissions$StatementLines$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Commissions$StatementLines$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$StatementLines$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$StatementLines$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Commissions$StatementLines$subscriptions(model.jO));
};
var $author$project$Pages$Commissions$StatementLines$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Commissions$StatementLines$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Commissions$StatementLines$Top$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Commissions$StatementLines$view, model.D5, model.jO)),
		$G: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$StatementLines$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$StatementLines$Top$init, aer: $author$project$Pages$Commissions$StatementLines$Top$load, agD: $author$project$Pages$Commissions$StatementLines$Top$save, ahd: $author$project$Pages$Commissions$StatementLines$Top$subscriptions, aaq: $author$project$Pages$Commissions$StatementLines$Top$update, ahP: $author$project$Pages$Commissions$StatementLines$Top$view});
var $author$project$Pages$Commissions$Statements$StatementsTableMsg = $elm$core$Basics$identity;
var $author$project$Pages$Commissions$Statements$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var _v3 = $author$project$Components$Commissions$Statement$List$init(
			{D5: shared.D5, bP: $elm$core$Maybe$Nothing, pI: true, pJ: false, pK: true, cO: shared.cO, F_: $author$project$Spa$Generated$Route$Commissions__Statements, Bi: query, eG: true});
		var statementsTable = _v3.a;
		var statementsTableCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: statementsTable},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd));
	});
var $author$project$Pages$Commissions$Statements$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Commissions$Statements$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Commissions$Statements$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Commissions$Statement$List$subscriptions(model.rh));
};
var $author$project$Pages$Commissions$Statements$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Commissions$Statement$List$update, model.D5, subMsg, model.rh);
		var statementsTable = _v1.a;
		var statementsTableCmd = _v1.b;
		var statementsTableOutMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: statementsTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd),
			statementsTableOutMsgs);
	});
var $author$project$Pages$Commissions$Statements$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Commissions$Statement$List$view(model.rh))
			]),
		$G: 'Commissions | Statements'
	};
};
var $author$project$Pages$Commissions$Statements$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Commissions$Statements$init, aer: $author$project$Pages$Commissions$Statements$load, agD: $author$project$Pages$Commissions$Statements$save, ahd: $author$project$Pages$Commissions$Statements$subscriptions, aaq: $author$project$Pages$Commissions$Statements$update, ahP: $author$project$Pages$Commissions$Statements$view});
var $author$project$OutMsg$RetrieveCompany = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Page$applicationCompanyOrEmployer = function (page) {
	return {
		ad0: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple3(shared.ZD, shared.WF, shared.ab9);
				_v0$3:
				while (true) {
					_v0$4:
					while (true) {
						_v0$5:
						while (true) {
							switch (_v0.a.$) {
								case 3:
									switch (_v0.b.$) {
										case 3:
											switch (_v0.c.$) {
												case 3:
													var _v1 = _v0.a;
													var session = _v1.a;
													var _v2 = _v0.b;
													var practice = _v2.a;
													var _v3 = _v0.c;
													var company = _v3.a;
													return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) ? _Utils_Tuple3(
														$author$project$Spa$Page$SessionLoading(url),
														A2(
															$author$project$Utils$Route$navigate,
															$elm$core$Dict$empty,
															A2($author$project$Permission$homeStateFor, session, shared.adN)),
														_List_Nil) : ((!_Utils_eq(
														url.Vx.ff,
														$author$project$Api$Company$id(company))) ? _Utils_Tuple3(
														$author$project$Spa$Page$SessionLoading(url),
														$elm$core$Platform$Cmd$none,
														_List_fromArray(
															[
																$author$project$OutMsg$RetrieveCompany(url.Vx.ff)
															])) : A2(
														$author$project$Utils$Tuple3$mapFirst,
														$author$project$Spa$Page$SessionLoaded,
														A2(
															$author$project$Utils$Tuple3$fromTuple2,
															_List_Nil,
															A5(page.ad0, session, practice, company, shared, url))));
												case 2:
													break _v0$4;
												default:
													break _v0$5;
											}
										case 2:
											break _v0$3;
										default:
											if (_v0.c.$ === 2) {
												break _v0$4;
											} else {
												break _v0$5;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								case 0:
									var _v4 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{af6: true}),
										_List_Nil);
								default:
									if (_v0.b.$ === 2) {
										break _v0$3;
									} else {
										if (_v0.c.$ === 2) {
											break _v0$4;
										} else {
											break _v0$5;
										}
									}
							}
						}
						var _v5 = url;
						var params = _v5.Vx;
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrieveCompany(params.ff)
								]));
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aer: F2(
			function (shared, model) {
				var _v6 = _Utils_Tuple3(shared.ZD, shared.WF, shared.ab9);
				_v6$1:
				while (true) {
					_v6$3:
					while (true) {
						_v6$4:
						while (true) {
							switch (_v6.a.$) {
								case 3:
									switch (_v6.b.$) {
										case 3:
											switch (_v6.c.$) {
												case 3:
													var _v7 = _v6.a;
													var session = _v7.a;
													var _v8 = _v6.b;
													var practice = _v8.a;
													var _v9 = _v6.c;
													var company = _v9.a;
													switch (model.$) {
														case 0:
															var url = model.a;
															if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) {
																return _Utils_Tuple3(
																	$author$project$Spa$Page$SessionLoading(url),
																	A2(
																		$author$project$Utils$Route$navigate,
																		$elm$core$Dict$empty,
																		A2($author$project$Permission$homeStateFor, session, shared.adN)),
																	_List_Nil);
															} else {
																var _v11 = A5(page.ad0, session, practice, company, shared, url);
																var pageModel = _v11.a;
																var cmd = _v11.b;
																return _Utils_Tuple3(
																	$author$project$Spa$Page$SessionLoaded(pageModel),
																	cmd,
																	_List_Nil);
															}
														case 1:
															var modelWithSession = model.a;
															return A2(
																$author$project$Utils$Tuple3$fromTuple2,
																_List_Nil,
																A2(
																	$elm$core$Tuple$mapFirst,
																	$author$project$Spa$Page$SessionLoaded,
																	A2(
																		page.aer,
																		shared,
																		_Utils_update(
																			modelWithSession,
																			{D5: shared.D5}))));
														default:
															return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
													}
												case 0:
													break _v6$1;
												default:
													break _v6$4;
											}
										case 2:
											if (!_v6.c.$) {
												break _v6$1;
											} else {
												break _v6$3;
											}
										default:
											if (!_v6.c.$) {
												break _v6$1;
											} else {
												break _v6$4;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								default:
									if (_v6.b.$ === 2) {
										break _v6$3;
									} else {
										break _v6$4;
									}
							}
						}
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				var _v12 = _v6.a;
				var _v13 = _v6.c;
				if (!model.$) {
					var url = model.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrieveCompany(url.Vx.ff)
							]));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		agD: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.agD, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		ahd: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahd(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		aaq: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.aaq, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		ahP: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahP(modelWithSession);
			} else {
				return {e5: $author$project$Components$BlankPage$view, $G: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$GotCompanyPlans = $elm$core$Basics$identity;
var $author$project$Api$CompanyPlan$Pricing = 0;
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$init = F5(
	function (session, practice, company, _v0, _v1) {
		var apiClient = _v0.D5;
		var params = _v1.Vx;
		return _Utils_Tuple2(
			{D5: apiClient, ab9: company, ak: $author$project$Api$Data$Loading, WF: practice},
			A5(
				$author$project$Api$CompanyPlan$list,
				apiClient,
				session,
				params.ff,
				function (d) {
					return _Utils_update(
						d,
						{
							Fc: _List_fromArray(
								[0])
						});
				},
				$elm$core$Basics$identity));
	});
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$update = F2(
	function (msg, model) {
		var response = msg;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{ak: response}),
			$elm$core$Platform$Cmd$none,
			$author$project$OutMsg$handleErrorResponse(response));
	});
var $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.Ng;
};
var $author$project$Api$Employer$Plan$All$defaultPeriodInMonths = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Employer$Plan$One$defaultPeriodInMonths = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.Ng;
};
var $author$project$Api$Provider$Plan$All$defaultPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$One$defaultPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$defaultPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
};
var $author$project$Api$Plan$defaultPeriodInMonths = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$defaultPeriodInMonths(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$defaultPeriodInMonths(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$defaultPeriodInMonths(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$defaultPeriodInMonths(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$defaultPeriodInMonths(plan_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$viewCompanyPlan = function (companyPlan) {
	var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Plan$name(plan))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = $elm$core$List$head(
							$author$project$Api$Plan$allowedBillingPeriodCodes(plan));
						if (!_v0.$) {
							var allowedBillingPeriodCode = _v0.a;
							return $elm$html$Html$text(
								$author$project$Formatters$String$titleize(allowedBillingPeriodCode) + 'ly');
						} else {
							return $elm$html$Html$text('N/A');
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$Int$ordinal(
							$author$project$Api$Plan$defaultPeriodInMonths(plan))),
						$elm$html$Html$text(' day')
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3($author$project$Components$Plan$Summary$Pricing$view, plan, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$view = function (model) {
	var _v0 = function () {
		var _v1 = model.ak;
		if (_v1.$ === 3) {
			var list = _v1.a;
			return _Utils_Tuple2(false, list);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var companyPlans = _v0.b;
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Affiliate Fee Plans')
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Name')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Billing cycle')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Billing date')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Rate')
									]))
							]),
						A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$viewCompanyPlan, companyPlans),
						_List_Nil)
					]))
			]),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Affiliate Fee Plans'
	};
};
var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$init, aer: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$load, agD: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$save, ahd: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$update, ahP: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$view});
var $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$GotData = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$UploadHeader$All$UploadHeader = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadHeader$Shared$UploadHeader = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadHeader$Shared$Record = F5(
	function (id, columnName, destination, required, ignored) {
		return {Lk: columnName, Nz: destination, adR: id, adU: ignored, agk: required};
	});
var $author$project$Api$Provider$UploadHeader$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'ignored',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'required',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'destination',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'column_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadHeader$Shared$Record))))));
var $author$project$Api$Provider$UploadHeader$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadHeader$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$UploadHeader$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadHeader$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['upload_headers']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$UploadHeader$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$UploadHeader$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId)));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders = function (model) {
	return A3(
		$author$project$Api$Provider$Company$UploadHeader$list,
		model.D5,
		$author$project$Api$Company$id(model.ab9),
		$author$project$Pages$Companies$CompanyId_String$Eas$GotData);
};
var $author$project$Api$FeedEnroller$EmployerAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$FeedEnroller$ProviderAll = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$FeedEnroller$All$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Employer$FeedEnroller$Shared$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Employer$FeedEnroller$Shared$Record = F9(
	function (id, publicSshKey, fileMatch, enabled, contactName, contactEmail, server, path, username) {
		return {LK: contactEmail, LL: contactName, Ot: enabled, Pl: fileMatch, adR: id, VL: path, Xn: publicSshKey, Zz: server, aaA: username};
	});
var $author$project$Api$Employer$FeedEnroller$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'username',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'server',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'contact_email',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contact_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enabled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'file_match',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'public_ssh_key',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Employer$FeedEnroller$Shared$Record))))))))));
var $author$project$Api$Employer$FeedEnroller$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$FeedEnroller$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$FeedEnroller$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$FeedEnroller$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$FeedEnroller$feedEnrollersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['feed_enrollers']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$FeedEnroller$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$FeedEnroller$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$FeedEnroller$feedEnrollersPath));
	});
var $author$project$Api$Provider$FeedEnroller$All$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Provider$FeedEnroller$Shared$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Provider$FeedEnroller$Shared$Record = F9(
	function (id, publicSshKey, fileMatch, enabled, contactName, contactEmail, server, path, username) {
		return {LK: contactEmail, LL: contactName, Ot: enabled, Pl: fileMatch, adR: id, VL: path, Xn: publicSshKey, Zz: server, aaA: username};
	});
var $author$project$Api$Provider$FeedEnroller$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'username',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'server',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'contact_email',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'contact_name',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'enabled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'file_match',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'public_ssh_key',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$FeedEnroller$Shared$Record))))))))));
var $author$project$Api$Provider$FeedEnroller$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FeedEnroller$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FeedEnroller$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FeedEnroller$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FeedEnroller$feedEnrollersPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['feed_enrollers']),
		basePath);
};
var $author$project$Api$Provider$FeedEnroller$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$FeedEnroller$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$FeedEnroller$feedEnrollersPath(
					$author$project$Api$Provider$Company$companyPath(companyId))));
	});
var $author$project$Api$FeedEnroller$list = F4(
	function (apiClient, session, companyId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2(
			$author$project$Api$Employer$FeedEnroller$list,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$FeedEnroller$EmployerAll)))) : A3(
			$author$project$Api$Provider$FeedEnroller$list,
			apiClient,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$FeedEnroller$ProviderAll))));
	});
var $author$project$Api$FeedEnroller$retrieve = F4(
	function (apiClient, session, companyId, toMsg) {
		return A4(
			$author$project$Api$FeedEnroller$list,
			apiClient,
			session,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($elm$core$List$head)));
	});
var $author$project$Api$Provider$UploadSetting$One$UploadSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$UploadSetting$One$Record = function (adoptCompanies) {
	return function (autoProcessTimer) {
		return function (createChildCompanies) {
			return function (createDivisions) {
				return function (endDateBuffer) {
					return function (fileGrowthThreshold) {
						return function (fileGrowthThresholdPct) {
							return function (inheritPlans) {
								return function (mapUnknownPlanValuesToCompanyDefaultPlan) {
									return function (nameMatch) {
										return function (restrictTerminationByOmissionToEmployees) {
											return function (restrictTerminationByOmissionToFeedPatients) {
												return function (terminateMembersByOmission) {
													return function (terminateMembersPct) {
														return function (terminateEligibilityByOmission) {
															return function (useUploadCreationDateAsEnrollmentDate) {
																return {aba: adoptCompanies, abr: autoProcessTimer, acf: createChildCompanies, acg: createDivisions, ac1: endDateBuffer, ado: fileGrowthThreshold, adp: fileGrowthThresholdPct, ad$: inheritPlans, aew: mapUnknownPlanValuesToCompanyDefaultPlan, aeL: nameMatch, ags: restrictTerminationByOmissionToEmployees, agt: restrictTerminationByOmissionToFeedPatients, ahm: terminateEligibilityByOmission, ahn: terminateMembersByOmission, aho: terminateMembersPct, ahL: useUploadCreationDateAsEnrollmentDate};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$UploadSetting$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'use_upload_creation_date_as_enrollment_date',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'terminate_eligibility_by_omission',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'terminate_members_pct',
			$elm$json$Json$Decode$float,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'terminate_members_by_omission',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'restrict_termination_by_omission_to_feed_patients',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'restrict_termination_by_omission_to_employees',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'name_match',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'map_unknown_plan_values_to_company_default_plan',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'inherit_plans',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'file_growth_threshold_pct',
										$elm$json$Json$Decode$float,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'file_growth_threshold',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'end_date_buffer',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'create_divisions',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'create_child_companies',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'auto_process_timer',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'adopt_companies',
																$elm$json$Json$Decode$bool,
																$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadSetting$One$Record)))))))))))))))));
var $author$project$Api$Provider$UploadSetting$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadSetting$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$UploadSetting$uploadSettingPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['upload_setting']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$UploadSetting$retrieve = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$UploadSetting$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$UploadSetting$uploadSettingPath(companyId)));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var model = {
			D5: shared.D5,
			ab9: company,
			acv: shared.adu.acv,
			dL: $elm$core$Maybe$Nothing,
			iH: $author$project$Api$Data$Loading,
			d0: $elm$core$Maybe$Nothing,
			d1: $author$project$Api$Data$NotAsked,
			FR: $author$project$Shared$isHintAdmin(shared),
			WF: practice,
			ZD: session,
			U: $elm$core$Maybe$Nothing,
			kE: $author$project$Api$Data$Loading,
			kG: $author$project$Api$Data$Loading,
			bF: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
						A4($author$project$Api$FeedEnroller$retrieve, shared.D5, session, params.ff, $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller),
						A3($author$project$Api$Provider$Company$UploadSetting$retrieve, shared.D5, params.ff, $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit = {$: 16};
var $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit)),
					model.U)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.dL)))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerDeleted = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$FeedEnroller$ProviderOne = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$FeedEnroller$One$FeedEnroller = $elm$core$Basics$identity;
var $author$project$Api$Provider$FeedEnroller$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$FeedEnroller$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$FeedEnroller$create = F4(
	function (apiClient, companyId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'skip_sftp_server',
					$elm$json$Json$Encode$bool(params.ag$)),
					_Utils_Tuple2(
					'feed_enroller',
					$elm$json$Json$Encode$object(_List_Nil))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$FeedEnroller$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$FeedEnroller$feedEnrollersPath(
						$author$project$Api$Provider$Company$companyPath(companyId)))));
	});
var $author$project$Api$FeedEnroller$create = F5(
	function (apiClient, session, companyId, params, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$FeedEnroller$create,
			apiClient,
			companyId,
			params,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$FeedEnroller$ProviderOne)));
	});
var $author$project$Api$Provider$FeedEnroller$feedEnrollerPath = F2(
	function (basePath, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$FeedEnroller$feedEnrollersPath(basePath));
	});
var $author$project$Api$Provider$FeedEnroller$delete = F4(
	function (apiClient, companyId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Provider$FeedEnroller$feedEnrollerPath,
					$author$project$Api$Provider$Company$companyPath(companyId),
					id)));
	});
var $author$project$Api$FeedEnroller$delete = F5(
	function (apiClient, session, companyId, id_, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$FeedEnroller$delete, apiClient, companyId, id_, toMsg);
	});
var $author$project$Api$Employer$FeedEnroller$Shared$contactEmail = function (_v0) {
	var record = _v0;
	return record.LK;
};
var $author$project$Api$Employer$FeedEnroller$All$contactEmail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$contactEmail(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$contactEmail = function (_v0) {
	var record = _v0;
	return record.LK;
};
var $author$project$Api$Provider$FeedEnroller$All$contactEmail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$contactEmail(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$contactEmail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$contactEmail(shared);
};
var $author$project$Api$FeedEnroller$contactEmail = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$contactEmail(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$contactEmail(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$contactEmail(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$contactName = function (_v0) {
	var record = _v0;
	return record.LL;
};
var $author$project$Api$Employer$FeedEnroller$All$contactName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$contactName(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$contactName = function (_v0) {
	var record = _v0;
	return record.LL;
};
var $author$project$Api$Provider$FeedEnroller$All$contactName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$contactName(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$contactName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$contactName(shared);
};
var $author$project$Api$FeedEnroller$contactName = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$contactName(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$contactName(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$contactName(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ot;
};
var $author$project$Api$Employer$FeedEnroller$All$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$enabled(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$enabled = function (_v0) {
	var record = _v0;
	return record.Ot;
};
var $author$project$Api$Provider$FeedEnroller$All$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$enabled(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$enabled = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$enabled(shared);
};
var $author$project$Api$FeedEnroller$enabled = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$enabled(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$enabled(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$enabled(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$fileMatch = function (_v0) {
	var record = _v0;
	return record.Pl;
};
var $author$project$Api$Employer$FeedEnroller$All$fileMatch = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$fileMatch(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$fileMatch = function (_v0) {
	var record = _v0;
	return record.Pl;
};
var $author$project$Api$Provider$FeedEnroller$All$fileMatch = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$fileMatch(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$fileMatch = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$fileMatch(shared);
};
var $author$project$Api$FeedEnroller$fileMatch = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$fileMatch(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$fileMatch(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$fileMatch(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$FeedEnroller$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$id(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$FeedEnroller$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$id(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$id(shared);
};
var $author$project$Api$FeedEnroller$id = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$id(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$id(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$id(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$path = function (_v0) {
	var record = _v0;
	return record.VL;
};
var $author$project$Api$Employer$FeedEnroller$All$path = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$path(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$path = function (_v0) {
	var record = _v0;
	return record.VL;
};
var $author$project$Api$Provider$FeedEnroller$All$path = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$path(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$path = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$path(shared);
};
var $author$project$Api$FeedEnroller$path = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$path(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$path(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$path(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$publicSshKey = function (_v0) {
	var record = _v0;
	return record.Xn;
};
var $author$project$Api$Employer$FeedEnroller$All$publicSshKey = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$publicSshKey(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey = function (_v0) {
	var record = _v0;
	return record.Xn;
};
var $author$project$Api$Provider$FeedEnroller$All$publicSshKey = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$publicSshKey = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey(shared);
};
var $author$project$Api$FeedEnroller$publicSshKey = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$publicSshKey(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$publicSshKey(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$publicSshKey(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$server = function (_v0) {
	var record = _v0;
	return record.Zz;
};
var $author$project$Api$Employer$FeedEnroller$All$server = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$server(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$server = function (_v0) {
	var record = _v0;
	return record.Zz;
};
var $author$project$Api$Provider$FeedEnroller$All$server = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$server(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$server = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$server(shared);
};
var $author$project$Api$FeedEnroller$server = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$server(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$server(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$server(feedEnroller_);
	}
};
var $author$project$Api$Employer$FeedEnroller$Shared$username = function (_v0) {
	var record = _v0;
	return record.aaA;
};
var $author$project$Api$Employer$FeedEnroller$All$username = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$FeedEnroller$Shared$username(shared);
};
var $author$project$Api$Provider$FeedEnroller$Shared$username = function (_v0) {
	var record = _v0;
	return record.aaA;
};
var $author$project$Api$Provider$FeedEnroller$All$username = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$username(shared);
};
var $author$project$Api$Provider$FeedEnroller$One$username = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$FeedEnroller$Shared$username(shared);
};
var $author$project$Api$FeedEnroller$username = function (feedEnroller) {
	switch (feedEnroller.$) {
		case 0:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$All$username(feedEnroller_);
		case 1:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Employer$FeedEnroller$All$username(feedEnroller_);
		default:
			var feedEnroller_ = feedEnroller.a;
			return $author$project$Api$Provider$FeedEnroller$One$username(feedEnroller_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsFromFeedEnroller = function (feedEnroller) {
	return {
		LK: $author$project$Api$FeedEnroller$contactEmail(feedEnroller),
		LL: $author$project$Api$FeedEnroller$contactName(feedEnroller),
		Ot: $author$project$Api$FeedEnroller$enabled(feedEnroller),
		Pl: $author$project$Api$FeedEnroller$fileMatch(feedEnroller),
		adR: $author$project$Api$FeedEnroller$id(feedEnroller),
		VL: $author$project$Api$FeedEnroller$path(feedEnroller),
		Xn: $author$project$Api$FeedEnroller$publicSshKey(feedEnroller),
		Zz: $author$project$Api$FeedEnroller$server(feedEnroller),
		aaA: $author$project$Api$FeedEnroller$username(feedEnroller)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Xn: $author$project$Utils$String$toMaybe(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{Pl: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ot: bool});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						LL: $author$project$Utils$String$toMaybe(string)
					});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						LK: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$FileMatchValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Pl;
			},
			_Utils_Tuple2(0, 'Please enter a file match.'))
		]));
var $author$project$Api$Provider$UploadHeader$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$UploadHeader$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$id(shared);
};
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderCreated = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Provider$UploadHeader$One$UploadHeader = 0;
var $author$project$Api$Provider$UploadHeader$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Company$UploadHeader$create = F4(
	function (apiClient, companyId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'upload_header',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'column_name',
								$elm$json$Json$Encode$string(fields.Lk))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$UploadHeader$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId))));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$createUploadHeader = F3(
	function (apiClient, company, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {Lk: fields.Lk};
		return A4(
			$author$project$Api$Provider$Company$UploadHeader$create,
			apiClient,
			$author$project$Api$Company$id(company),
			apiFields,
			$author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderCreated);
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderUpdated = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Provider$Company$UploadHeader$uploadHeaderPath = F2(
	function (companyId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId));
	});
var $author$project$Api$Provider$Company$UploadHeader$update = F5(
	function (apiClient, companyId, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'upload_header',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'column_name',
								$elm$json$Json$Encode$string(fields.Lk)),
								_Utils_Tuple2(
								'required',
								$elm$json$Json$Encode$bool(fields.agk)),
								_Utils_Tuple2(
								'ignored',
								$elm$json$Json$Encode$bool(fields.adU))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$UploadHeader$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$UploadHeader$uploadHeaderPath, companyId, id))));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$updateUploadHeader = F4(
	function (apiClient, company, id, formFields) {
		return A5(
			$author$project$Api$Provider$Company$UploadHeader$update,
			apiClient,
			$author$project$Api$Company$id(company),
			id,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderUpdated);
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$saveUploadHeader = F4(
	function (apiClient, maybeId, company, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Pages$Companies$CompanyId_String$Eas$updateUploadHeader, apiClient, company, id_, formFields);
		} else {
			return A3($author$project$Pages$Companies$CompanyId_String$Eas$createUploadHeader, apiClient, company, formFields);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$FeedEnroller$update = F5(
	function (apiClient, companyId, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'feed_enroller',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'enabled',
								$elm$json$Json$Encode$bool(params.Ot)),
								_Utils_Tuple2(
								'file_match',
								$elm$json$Json$Encode$string(params.Pl)),
								_Utils_Tuple2(
								'public_ssh_key',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.Xn)),
								_Utils_Tuple2(
								'contact_name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.LL)),
								_Utils_Tuple2(
								'contact_email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.LK))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$FeedEnroller$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Provider$FeedEnroller$feedEnrollerPath,
						$author$project$Api$Provider$Company$companyPath(companyId),
						id))));
	});
var $author$project$Api$FeedEnroller$update = F6(
	function (apiClient, session, companyId, id_, params, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A5(
			$author$project$Api$Provider$FeedEnroller$update,
			apiClient,
			companyId,
			id_,
			params,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$FeedEnroller$ProviderOne)));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$updateFeedEnroller = F5(
	function (apiClient, session, company, id, formFields) {
		var validFields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A6(
			$author$project$Api$FeedEnroller$update,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			id,
			{LK: validFields.LK, LL: validFields.LL, Ot: validFields.Ot, Pl: validFields.Pl, Xn: validFields.Xn},
			$author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerUpdated);
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$defaultAutoProcessTimer = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$defaultEndDateBuffer = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$defaultFileGrowthThresholdPct = $author$project$Percentage$fromFloat(0.5);
var $author$project$Pages$Companies$CompanyId_String$Eas$defaultTerminateMembersPct = $author$project$Percentage$fromFloat(0.05);
var $author$project$Api$Provider$Company$UploadSetting$update = F4(
	function (apiClient, companyId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'upload_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'adopt_companies',
								$elm$json$Json$Encode$bool(fields.aba)),
								_Utils_Tuple2(
								'auto_process_timer',
								$elm$json$Json$Encode$int(fields.abr)),
								_Utils_Tuple2(
								'create_child_companies',
								$elm$json$Json$Encode$bool(fields.acf)),
								_Utils_Tuple2(
								'create_divisions',
								$elm$json$Json$Encode$bool(fields.acg)),
								_Utils_Tuple2(
								'end_date_buffer',
								$elm$json$Json$Encode$int(fields.ac1)),
								_Utils_Tuple2(
								'file_growth_threshold',
								$elm$json$Json$Encode$bool(fields.ado)),
								_Utils_Tuple2(
								'file_growth_threshold_pct',
								$author$project$Percentage$encode(fields.adp)),
								_Utils_Tuple2(
								'inherit_plans',
								$elm$json$Json$Encode$bool(fields.ad$)),
								_Utils_Tuple2(
								'map_unknown_plan_values_to_company_default_plan',
								$elm$json$Json$Encode$bool(fields.aew)),
								_Utils_Tuple2(
								'name_match',
								$elm$json$Json$Encode$bool(fields.aeL)),
								_Utils_Tuple2(
								'restrict_termination_by_omission_to_employees',
								$elm$json$Json$Encode$bool(fields.ags)),
								_Utils_Tuple2(
								'restrict_termination_by_omission_to_feed_patients',
								$elm$json$Json$Encode$bool(fields.agt)),
								_Utils_Tuple2(
								'terminate_members_by_omission',
								$elm$json$Json$Encode$bool(fields.ahn)),
								_Utils_Tuple2(
								'terminate_eligibility_by_omission',
								$elm$json$Json$Encode$bool(fields.ahm)),
								_Utils_Tuple2(
								'terminate_members_pct',
								$author$project$Percentage$encode(fields.aho)),
								_Utils_Tuple2(
								'use_upload_creation_date_as_enrollment_date',
								$elm$json$Json$Encode$bool(fields.ahL))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$UploadSetting$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$UploadSetting$uploadSettingPath(companyId))));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$updateUploadSetting = F3(
	function (apiClient, company, formFields) {
		var validFields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Company$UploadSetting$update,
			apiClient,
			$author$project$Api$Company$id(company),
			{
				aba: validFields.aba,
				abr: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultAutoProcessTimer, validFields.abr),
				acf: validFields.acf,
				acg: validFields.acg,
				ac1: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultEndDateBuffer, validFields.ac1),
				ado: validFields.ado,
				adp: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultFileGrowthThresholdPct, validFields.adp),
				ad$: validFields.ad$,
				aew: validFields.aew,
				aeL: validFields.aeL,
				ags: validFields.ags,
				agt: validFields.agt,
				ahm: validFields.ahm,
				ahn: validFields.ahn,
				aho: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultTerminateMembersPct, validFields.aho),
				ahL: validFields.ahL
			},
			$author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingUpdated);
	});
var $author$project$Api$Provider$UploadHeader$Shared$columnName = function (_v0) {
	var record = _v0;
	return record.Lk;
};
var $author$project$Api$Provider$UploadHeader$All$columnName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$columnName(shared);
};
var $author$project$Api$Provider$UploadHeader$Shared$destination = function (_v0) {
	var record = _v0;
	return record.Nz;
};
var $author$project$Api$Provider$UploadHeader$All$destination = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$destination(shared);
};
var $author$project$Api$Provider$UploadHeader$Shared$ignored = function (_v0) {
	var record = _v0;
	return record.adU;
};
var $author$project$Api$Provider$UploadHeader$All$ignored = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$ignored(shared);
};
var $author$project$Api$Provider$UploadHeader$Shared$required = function (_v0) {
	var record = _v0;
	return record.agk;
};
var $author$project$Api$Provider$UploadHeader$All$required = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$UploadHeader$Shared$required(shared);
};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsFromUploadHeader = function (uploadHeader) {
	return {
		Lk: $author$project$Api$Provider$UploadHeader$All$columnName(uploadHeader),
		Nz: $author$project$Api$Provider$UploadHeader$All$destination(uploadHeader),
		adU: $author$project$Api$Provider$UploadHeader$All$ignored(uploadHeader),
		agk: $author$project$Api$Provider$UploadHeader$All$required(uploadHeader)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsInit = {Lk: '', Nz: '', adU: true, agk: false};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Lk: string});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{agk: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{adU: bool});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$ColumnNameValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Lk;
			},
			_Utils_Tuple2(0, 'Please enter a column name.'))
		]));
var $author$project$Api$Provider$UploadSetting$One$adoptCompanies = function (_v0) {
	var record = _v0;
	return record.aba;
};
var $author$project$Api$Provider$UploadSetting$One$autoProcessTimer = function (_v0) {
	var record = _v0;
	return record.abr;
};
var $author$project$Api$Provider$UploadSetting$One$createChildCompanies = function (_v0) {
	var record = _v0;
	return record.acf;
};
var $author$project$Api$Provider$UploadSetting$One$createDivisions = function (_v0) {
	var record = _v0;
	return record.acg;
};
var $author$project$Api$Provider$UploadSetting$One$endDateBuffer = function (_v0) {
	var record = _v0;
	return record.ac1;
};
var $author$project$Api$Provider$UploadSetting$One$fileGrowthThreshold = function (_v0) {
	var record = _v0;
	return record.ado;
};
var $author$project$Api$Provider$UploadSetting$One$fileGrowthThresholdPct = function (_v0) {
	var record = _v0;
	return record.adp;
};
var $author$project$Api$Provider$UploadSetting$One$inheritPlans = function (_v0) {
	var record = _v0;
	return record.ad$;
};
var $author$project$Api$Provider$UploadSetting$One$mapUnknownPlanValuesToCompanyDefaultPlan = function (_v0) {
	var record = _v0;
	return record.aew;
};
var $author$project$Api$Provider$UploadSetting$One$nameMatch = function (_v0) {
	var record = _v0;
	return record.aeL;
};
var $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToEmployees = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.ags);
};
var $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToFeedPatients = function (_v0) {
	var record = _v0;
	return record.agt;
};
var $author$project$Api$Provider$UploadSetting$One$terminateEligibilityByOmission = function (_v0) {
	var record = _v0;
	return record.ahm;
};
var $author$project$Api$Provider$UploadSetting$One$terminateMembersByOmission = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.ahn);
};
var $author$project$Api$Provider$UploadSetting$One$terminateMembersPct = function (_v0) {
	var record = _v0;
	return record.aho;
};
var $author$project$Api$Provider$UploadSetting$One$useUploadCreationDateAsEnrollmentDate = function (_v0) {
	var record = _v0;
	return record.ahL;
};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsFromUploadSetting = function (uploadSetting) {
	return {
		aba: $author$project$Api$Provider$UploadSetting$One$adoptCompanies(uploadSetting),
		abr: $elm$core$Maybe$Just(
			$author$project$Api$Provider$UploadSetting$One$autoProcessTimer(uploadSetting)),
		acf: $author$project$Api$Provider$UploadSetting$One$createChildCompanies(uploadSetting),
		acg: $author$project$Api$Provider$UploadSetting$One$createDivisions(uploadSetting),
		ac1: $elm$core$Maybe$Just(
			$author$project$Api$Provider$UploadSetting$One$endDateBuffer(uploadSetting)),
		ado: $author$project$Api$Provider$UploadSetting$One$fileGrowthThreshold(uploadSetting),
		adp: $elm$core$Maybe$Just(
			$author$project$Percentage$fromFloat(
				$author$project$Api$Provider$UploadSetting$One$fileGrowthThresholdPct(uploadSetting))),
		ad$: $author$project$Api$Provider$UploadSetting$One$inheritPlans(uploadSetting),
		aew: $author$project$Api$Provider$UploadSetting$One$mapUnknownPlanValuesToCompanyDefaultPlan(uploadSetting),
		aeL: $author$project$Api$Provider$UploadSetting$One$nameMatch(uploadSetting),
		ags: $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToEmployees(uploadSetting),
		agt: $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToFeedPatients(uploadSetting),
		ahm: $author$project$Api$Provider$UploadSetting$One$terminateEligibilityByOmission(uploadSetting),
		ahn: $author$project$Api$Provider$UploadSetting$One$terminateMembersByOmission(uploadSetting),
		aho: $elm$core$Maybe$Just(
			$author$project$Percentage$fromFloat(
				$author$project$Api$Provider$UploadSetting$One$terminateMembersPct(uploadSetting))),
		ahL: $author$project$Api$Provider$UploadSetting$One$useUploadCreationDateAsEnrollmentDate(uploadSetting)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aba: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{acf: bool});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{acg: bool});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ac1: $elm$core$String$toInt(string)
					});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ad$: bool});
			case 9:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aeL: bool});
			case 12:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ahn: bool});
			case 13:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ahm: bool});
			case 11:
				var bool = field.a;
				return _Utils_update(
					fields,
					{agt: bool});
			case 10:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ags: bool});
			case 5:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ado: bool});
			case 8:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aew: bool});
			case 14:
				var _float = field.a;
				return _Utils_update(
					fields,
					{aho: _float});
			case 6:
				var _float = field.a;
				return _Utils_update(
					fields,
					{adp: _float});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						abr: $elm$core$String$toInt(string)
					});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ahL: bool});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBufferValidation = 1;
var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPctValidation = 2;
var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPctValidation = 3;
var $author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage = F3(
	function (getter, validationGroup, fields) {
		var _v0 = getter(fields);
		if (!_v0.$) {
			var percentage = _v0.a;
			return A2(
				$author$project$Percentage$isValid,
				{yQ: $elm$core$Maybe$Nothing, TZ: $elm$core$Maybe$Nothing},
				percentage) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'Please enter a valid percentage.')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'Please enter a valid percentage.')
				]);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$validatePositive = F3(
	function (getter, validationGroup, fields) {
		var _v0 = getter(fields);
		if (!_v0.$) {
			var integer = _v0.a;
			return (integer >= 0) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'Please enter a valid number.')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'Please enter a valid number.')
				]);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage,
				function ($) {
					return $.aho;
				},
				3)),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage,
				function ($) {
					return $.adp;
				},
				2)),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Pages$Companies$CompanyId_String$Eas$validatePositive,
				function ($) {
					return $.ac1;
				},
				1))
		]));
var $author$project$Pages$Companies$CompanyId_String$Eas$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var feedEnroller = response.a;
					var form = A2(
						$elm$core$Maybe$map,
						function (feedEnroller_) {
							return _Utils_Tuple2(
								$author$project$Api$FeedEnroller$id(feedEnroller_),
								$author$project$Utils$Form$init(
									$author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsFromFeedEnroller(feedEnroller_)));
						},
						feedEnroller);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iH: response, d0: form}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iH: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				_v2$2:
				while (true) {
					switch (response.$) {
						case 3:
							var uploadSetting = response.a;
							var form = $author$project$Utils$Form$init(
								$author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsFromUploadSetting(uploadSetting));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										kG: response,
										bF: $elm$core$Maybe$Just(
											_Utils_Tuple2(form, $author$project$Api$Data$NotAsked))
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{kG: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v2$2;
							}
						default:
							break _v2$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kG: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kE: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 3:
				var field = msg.a;
				var _v4 = model.d0;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var id = _v5.a;
					var form = _v5.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								d0: $elm$core$Maybe$Just(
									_Utils_Tuple2(id, newForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d1: $author$project$Api$Data$Loading}),
					A5(
						$author$project$Api$FeedEnroller$create,
						model.D5,
						model.ZD,
						$author$project$Api$Company$id(model.ab9),
						{ag$: model.acv},
						$author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerCreated),
					_List_Nil);
			case 5:
				var _v6 = model.d0;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					var _v8 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsValidator, form);
					if (!_v8.$) {
						var _v9 = _v8.a;
						var newForm = _v9.a;
						var validFormFields = _v9.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									d0: $elm$core$Maybe$Just(
										_Utils_Tuple2(id, newForm)),
									d1: $author$project$Api$Data$Loading
								}),
							A5($author$project$Pages$Companies$CompanyId_String$Eas$updateFeedEnroller, model.D5, model.ZD, model.ab9, id, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									d0: $elm$core$Maybe$Just(
										_Utils_Tuple2(id, newForm))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var companyId = $author$project$Api$Company$id(model.ab9);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{iH: $author$project$Api$Data$Loading, d1: response, kE: $author$project$Api$Data$Loading, kG: $author$project$Api$Data$Loading}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
									A4($author$project$Api$FeedEnroller$retrieve, model.D5, model.ZD, companyId, $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller),
									A3($author$project$Api$Provider$Company$UploadSetting$retrieve, model.D5, companyId, $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'SFTP Server created.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d1: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d1: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'SFTP Server updated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{d1: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dL: $elm$core$Maybe$Just(
								_Utils_Tuple2(id, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dL: $elm$core$Maybe$Just(
								_Utils_Tuple2(id, $author$project$Api$Data$Loading))
						}),
					A5(
						$author$project$Api$FeedEnroller$delete,
						model.D5,
						model.ZD,
						$author$project$Api$Company$id(model.ab9),
						id,
						$author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{dL: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var id = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dL: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'SFTP server is being removed.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dL: $elm$core$Maybe$Just(
									_Utils_Tuple2(id, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var field = msg.a;
				var _v13 = model.bF;
				if (!_v13.$) {
					var _v14 = _v13.a;
					var form = _v14.a;
					var saveRequest = _v14.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bF: $elm$core$Maybe$Just(
									_Utils_Tuple2(newForm, saveRequest))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var _v15 = model.bF;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var form = _v16.a;
					var _v17 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsValidator, form);
					if (!_v17.$) {
						var _v18 = _v17.a;
						var newForm = _v18.a;
						var validFormFields = _v18.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bF: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Pages$Companies$CompanyId_String$Eas$updateUploadSetting, model.D5, model.ab9, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v17.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bF: $elm$core$Maybe$Just(
										_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var response = msg.a;
				var _v19 = model.bF;
				if (!_v19.$) {
					var _v20 = _v19.a;
					var form = _v20.a;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bF: $elm$core$Maybe$Just(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Upload settings updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bF: $elm$core$Maybe$Just(
										_Utils_Tuple2(form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							U: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				var uploadHeader = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							U: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$UploadHeader$All$id(uploadHeader)),
									$author$project$Utils$Form$init(
										$author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsFromUploadHeader(uploadHeader)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{U: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var field = msg.a;
				var _v22 = model.U;
				if (!_v22.$) {
					var _v23 = _v22.a;
					var id = _v23.a;
					var form = _v23.b;
					var uploadHeader = _v23.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								U: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, uploadHeader))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var form = msg.a;
				var id = msg.b;
				var _v24 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsValidator, form);
				if (!_v24.$) {
					var _v25 = _v24.a;
					var newForm = _v25.a;
					var validFormFields = _v25.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								U: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Pages$Companies$CompanyId_String$Eas$saveUploadHeader, model.D5, id, model.ab9, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v24.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								U: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 19:
				var response = msg.a;
				var _v26 = model.U;
				if (!_v26.$) {
					var _v27 = _v26.a;
					var id = _v27.a;
					var form = _v27.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{U: $elm$core$Maybe$Nothing, kE: $author$project$Api$Data$Loading}),
							$author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Upload header created.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									U: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v29 = model.U;
				if (!_v29.$) {
					var _v30 = _v29.a;
					var id = _v30.a;
					var form = _v30.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{U: $elm$core$Maybe$Nothing, kE: $author$project$Api$Data$Loading}),
							$author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Upload settings updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									U: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Layouts$Company$Uploads$companyIsChild = function (company) {
	return $author$project$Api$Company$companyType(company) === 1;
};
var $author$project$Api$Employer$Company$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Company$Min$id = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$Min$id(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$Min$id(company_);
	}
};
var $author$project$Api$Employer$Company$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Company$Min$name = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$Min$name(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$Min$name(company_);
	}
};
var $author$project$Api$Company$Min$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Min$fromEmployer = $author$project$Api$Company$Min$Employer;
var $author$project$Api$Company$Min$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Company$Min$fromProvider = $author$project$Api$Company$Min$Provider;
var $author$project$Api$Employer$Company$One$parent = function (_v0) {
	var record = _v0.b;
	return record.Vy;
};
var $author$project$Api$Provider$Company$One$parent = function (_v0) {
	var record = _v0.b;
	return record.Vy;
};
var $author$project$Api$Company$parent = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Company$Min$fromProvider,
			$author$project$Api$Provider$Company$One$parent(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Company$Min$fromEmployer,
			$author$project$Api$Employer$Company$One$parent(company_));
	}
};
var $author$project$Layouts$Company$Uploads$companyIsParent = function (company) {
	return $author$project$Api$Company$companyType(company) === 2;
};
var $author$project$Layouts$Company$Uploads$companyIsStandalone = function (company) {
	return $author$project$Api$Company$companyType(company) === 3;
};
var $author$project$Layouts$Company$Uploads$betaPageMessage = F2(
	function (feedEnroller, company) {
		return ($author$project$Utils$Maybe$toBool(feedEnroller) || $author$project$Layouts$Company$Uploads$companyIsParent(company)) ? 'This company is on an AutoSync. Any questions/concerns? Reach out to support@hint.com today!' : ($author$project$Layouts$Company$Uploads$companyIsStandalone(company) ? 'Interested in automating and unlocking more advanced features and support for your employee uploads? Reach out to support@hint.com today!' : '');
	});
var $author$project$Layouts$Company$Uploads$viewBetaPagePopover = F2(
	function (feedEnroller, company) {
		var betaPageMessage_ = function () {
			if (feedEnroller.$ === 3) {
				var feedEnroller_ = feedEnroller.a;
				return A2($author$project$Layouts$Company$Uploads$betaPageMessage, feedEnroller_, company);
			} else {
				return '';
			}
		}();
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[$author$project$Ui$Tooltip$wide]),
			betaPageMessage_,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$warning]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 9)
						]))
				]));
	});
var $author$project$Layouts$Company$Uploads$view = F6(
	function (session, practice, company, feedEnroller, contents, footer) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Employee Uploads'),
											$author$project$Utils$Html$noBreakSpace,
											(!$author$project$Layouts$Company$Uploads$companyIsChild(company)) ? A2($author$project$Layouts$Company$Uploads$viewBetaPagePopover, feedEnroller, company) : $author$project$Utils$Html$empty
										])),
									function () {
									var _v0 = $author$project$Api$Company$parent(company);
									if (!_v0.$) {
										var parent = _v0.a;
										return A2(
											$author$project$Ui$Alert$warning,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('This '),
													$elm$html$Html$text(
													A2($author$project$Api$Practice$sponsorize, practice, 'employer')),
													$elm$html$Html$text('\'s eligibility and enrollment information is administered by '),
													$author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$html$Html$text(
													$author$project$Api$Company$Min$name(parent)) : A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
														{
															ff: $author$project$Api$Company$Min$id(parent)
														}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Api$Company$Min$name(parent))
														])),
													$elm$html$Html$text(' please go to their account to view '),
													$elm$html$Html$text(
													A2($author$project$Api$Practice$sponsorize, practice, 'employee')),
													$elm$html$Html$text(' upload files.')
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]),
								contents
							]))),
					$elm$core$List$isEmpty(footer) ? $author$project$Ui$Panel$none : A2($author$project$Ui$Panel$footer, _List_Nil, footer)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$ContactEmail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$ContactName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$CreateFeedEnroller = {$: 4};
var $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnroller = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$Enabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FileMatch = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$PublicSshKey = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$SaveFeedEnroller = {$: 5};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewFeedEnroller = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('SFTP Server')
					])),
				function () {
				var _v0 = model.iH;
				if (_v0.$ === 3) {
					var _v1 = model.d0;
					if (!_v1.$) {
						var _v2 = _v1.a;
						var form = _v2.b;
						var fields = $author$project$Utils$Form$fields(form);
						return A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$horizontal,
									$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Eas$SaveFeedEnroller),
									$author$project$Ui$Form$noValidate(true),
									$author$project$Ui$Form$autocomplete(false)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('SSH Key')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Textarea$value(
													A2($elm$core$Maybe$withDefault, '', fields.Xn)),
													$author$project$Ui$Form$Textarea$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$PublicSshKey)),
													$author$project$Ui$Form$Textarea$placeholder('Begins with \'ssh-rsa\', \'ssh-dss\', \'ssh-ed25519\', \'ecdsa-sha2-nistp256\', \'ecdsa-sha2-nistp384\', or \'ecdsa-sha2-nistp521\''),
													$author$project$Ui$Form$Textarea$disabled(model.acv)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('File Regex Match'),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(fields.Pl),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$FileMatch)),
													$author$project$Ui$Form$Input$placeholder('Regular Expression to match files'),
													$author$project$Ui$Form$Input$disabled(model.acv),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
													$author$project$Ui$Form$Input$errors(
													A2($author$project$Utils$Form$validationErrors, 0, form))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('SFTP Server Address:Port')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(fields.Zz),
													$elm$html$Html$text(':22')
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('Path')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(fields.VL)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('Username')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(fields.aaA)
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(10),
											$author$project$Ui$Form$Group$label('Autoprocess')
										]),
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(fields.Ot),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Enabled))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(3),
											$author$project$Ui$Form$Group$label('Contact name')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($elm$core$Maybe$withDefault, '', fields.LL)),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ContactName))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(2),
											$author$project$Ui$Form$Group$inputSpan(3),
											$author$project$Ui$Form$Group$label('Contact email')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($elm$core$Maybe$withDefault, '', fields.LK)),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ContactEmail))
												]))
										])),
									model.FR ? A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$HinterOnly$button,
											{abp: 'Update SFTP server'},
											_List_fromArray(
												[$author$project$Ui$Button$primary, $author$project$Ui$Button$submit]),
											_List_fromArray(
												[
													$elm$html$Html$text('Update')
												])),
											A3(
											$author$project$Ui$HinterOnly$button,
											{abp: 'Remove SFTP server'},
											_List_fromArray(
												[
													$author$project$Ui$Button$danger,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnroller(fields.adR))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove SFTP Server')
												]))
										])) : $author$project$Utils$Html$empty
								]));
					} else {
						return model.FR ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{abp: 'Create SFTP Server'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$CreateFeedEnroller),
											$author$project$Ui$Button$loading(
											_Utils_eq(model.d1, $author$project$Api$Data$Loading))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Create SFTP Server')
										]))
								])) : $author$project$Utils$Html$empty;
					}
				} else {
					return A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$ColumnName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$Ignored = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$Required = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadHeader = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewModal = F3(
	function (id, form, uploadHeader) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Upload Header',
			S_: _Utils_eq(uploadHeader, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit,
			U0: $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadHeader(form)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var hasDestination = !$elm$core$String$isEmpty(fields.Nz);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Column Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Lk),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ColumnName)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Destination')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									hasDestination ? $elm$html$Html$text(
									$author$project$Formatters$String$titleize(fields.Nz)) : $elm$html$Html$text('N/A')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Required')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.agk),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Required)),
									$author$project$Ui$ToggleSwitch$disabled(
									(!$author$project$Utils$Maybe$toBool(id)) || (!hasDestination))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Ignored')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.adU),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Ignored)),
									$author$project$Ui$ToggleSwitch$disabled(
									(!$author$project$Utils$Maybe$toBool(id)) || (!hasDestination))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$NewUploadHeader = {$: 14};
var $author$project$Pages$Companies$CompanyId_String$Eas$EditUploadHeader = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewuUploadHeader = function (uploadHeader) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$UploadHeader$All$columnName(uploadHeader))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$String$titleize(
							$author$project$Api$Provider$UploadHeader$All$destination(uploadHeader)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$Bool$toString(
							$author$project$Api$Provider$UploadHeader$All$required(uploadHeader)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Formatters$Bool$toString(
							$author$project$Api$Provider$UploadHeader$All$ignored(uploadHeader)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Edit upload header'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$Eas$EditUploadHeader(uploadHeader)),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadHeaders = function (model) {
	var _v0 = function () {
		var _v1 = model.kE;
		if (_v1.$ === 3) {
			var uploadHeaders_ = _v1.a;
			return _Utils_Tuple2(
				false,
				A2($elm$core$List$sortBy, $author$project$Api$Provider$UploadHeader$All$destination, uploadHeaders_));
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploadHeaders = _v0.b;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Upload Headers')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'New upload header'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$NewUploadHeader),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('New Upload Header')
							]))
					])),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A4(
				$author$project$Ui$Table$view,
				_List_fromArray(
					[
						$author$project$Ui$Table$verticalCentered,
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('None')
							])),
						$author$project$Ui$Table$loading(loading)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Column name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Destination')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Required')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Ignored')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2)
							]),
						_List_Nil)
					]),
				A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$Eas$viewuUploadHeader, uploadHeaders),
				_List_Nil)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$AdoptCompanies = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimerValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$Eas$CreateChildCompanies = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$CreateDivisions = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBuffer = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThreshold = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPct = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$InheritPlans = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$MapUnknownPlanValuesToCompanyDefaultPlan = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$NameMatch = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToEmployees = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToFeedPatients = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting = {$: 12};
var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateEligibilityByOmission = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersByOmission = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPct = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$UseUploadCreationDateAsEnrollmentDate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField = F4(
	function (title, description, value, field) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(7),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$label(title),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text(description))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(value),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField = F8(
	function (title, description, placeholder, value, field, validationGroup, form, fieldLabel) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(7),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$label(title),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text(description))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field)),
											$author$project$Ui$Form$Input$number,
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, validationGroup, form)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
											$author$project$Ui$Form$Input$placeholder(placeholder)
										])),
									$author$project$Ui$Form$Input$addon(
									_List_fromArray(
										[
											$elm$html$Html$text(fieldLabel)
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField = F7(
	function (title, description, placeholder, value, field, validationGroup, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(7),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$label(title),
					$author$project$Ui$Form$Group$labelClass(''),
					$author$project$Ui$Form$Group$labelHelp(
					$elm$html$Html$text(description))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$Form$PercentageInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$PercentageInput$value(value),
									$author$project$Ui$Form$PercentageInput$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field)),
									$author$project$Ui$Form$PercentageInput$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, validationGroup, form)),
									$author$project$Ui$Form$PercentageInput$errors(
									A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
									$author$project$Ui$Form$PercentageInput$placeholder(placeholder)
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSetting = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Upload Settings')
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				function () {
					var _v0 = model.bF;
					if (!_v0.$) {
						var _v1 = _v0.a;
						var form = _v1.a;
						var saveRequest = _v1.b;
						var fields = $author$project$Utils$Form$fields(form);
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(11),
												$author$project$Ui$FlexGrid$offset(1)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$horizontal,
														$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting),
														$author$project$Ui$Form$noValidate(true),
														$author$project$Ui$Form$autocomplete(false)
													]),
												_List_fromArray(
													[
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Adopt Companies', 'When enabled, any companies that appear in the file that we were able to match by Name to an existing company, will automatically be adopted as a Child Company.', fields.aba, $author$project$Pages$Companies$CompanyId_String$Eas$AdoptCompanies),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Create Child Companies', 'When enabled, any new companies that appear in the file that we are unable to match to an existing Company, will be created as a Child Company (and support the same plan as the parent).', fields.acf, $author$project$Pages$Companies$CompanyId_String$Eas$CreateChildCompanies),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Create Divisions', 'When enabled, any new divisions that appear in the file that we are unable to match to an existing Division will be created as a Division for that Company.', fields.acg, $author$project$Pages$Companies$CompanyId_String$Eas$CreateDivisions),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Inherit Plans', 'When enabled, any plan names that appear in the file that are not supported by the Child Company but do match a plan supported by the Parent Company, will be adopted by the Child Company. If disabled, then those plans would map to the Company\'s default plan.', fields.ad$, $author$project$Pages$Companies$CompanyId_String$Eas$InheritPlans),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Name Match', 'When enabled, system will try to match patients on First Name, Last Name, and DOB when we cannot match based on external_id, nor SSN.', fields.aeL, $author$project$Pages$Companies$CompanyId_String$Eas$NameMatch),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Terminate Members By Omission', 'When enabled, we will terminate the memberships from the \'Missing Patients\' List as long as it does not exceed the TERMINATE MEMBERS PCT.', fields.ahn, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersByOmission),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Terminate Eligibility By Omission', 'When enabled, we will terminate patients\' eligibility from the \'Missing Patients\' List', fields.ahm, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateEligibilityByOmission),
														A7($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField, 'Terminate Members Pct', 'Default 5%. This percent is meant as a validation to ensure the Missing Patients list is not greater than expected. Specifically, when the percent of missing patients (out of total active members) is higher than this threshold, the system will Fail to Terminate and notify users to review the file for accuracy.', '0.01', fields.aho, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPct, 3, form),
														A8($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField, 'End Date Buffer', 'Default 0. A number of days to add to the end of a membership when that member is terminated', '0', fields.ac1, $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBuffer, 1, form, 'days'),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Restrict Termination By Omission To Feed Patients', 'When enabled, patients will only be terminated by omission if they previously appeared on an employee file (i.e. they have ea File System Import Identifier). When disabled, patients will be terminated by omission, regardless of whether or not they have ever appeared on an employee file.', fields.agt, $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToFeedPatients),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Restrict Termination By Omission To Employees', 'When enabled, the system will only check to see if employees are absent from the file. When disabled, the system will check if employees or dependents are absent from the file.', fields.ags, $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToEmployees),
														A8($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField, 'Auto Process Timer', 'This determines how long the system will hold off on processing a file if there are unmapped data values found. The idea here is that when it is >0, you have time to review the unmapped values and resolve them.', '4000', fields.abr, $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimer, 0, form, 'min'),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Review File Size Increases', 'When enabled, a new upload will be paused if it is larger than the previous processed upload by REVIEW FILE SIZE PCT.', fields.ado, $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThreshold),
														A7($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField, 'Review File Size Pct', 'Default 50%. When a new upload exceeds the previous completed upload by this threshold, the upload will be paused so the user can verify this increase was intended.', '0.5', fields.adp, $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPct, 2, form),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Map Unknown Plan Values To Company Default Plan', 'If enabled, unknown plan values in the file will be mapped to the Company\'s default plan.', fields.aew, $author$project$Pages$Companies$CompanyId_String$Eas$MapUnknownPlanValuesToCompanyDefaultPlan),
														A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Enroll By Presence', 'When enabled we will enroll patients that do not have start dates indicated in the file. Their start date will be determined using the company enrollment cutoff date. If a start date is included on any rows, we will use that date', fields.ahL, $author$project$Pages$Companies$CompanyId_String$Eas$UseUploadCreationDateAsEnrollmentDate)
													]))
											]))
									])),
								model.FR ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$HinterOnly$button,
										{abp: 'Update upload settings'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(1),
												$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting),
												$author$project$Ui$Button$loading(
												_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Update')
											]))
									])) : $author$project$Utils$Html$empty
							]);
					} else {
						return _List_Nil;
					}
				}())
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Eas$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.dL;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var deleteRequest = _v1.b;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed(id),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('sftp server'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.U;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var uploadHeader = _v3.c;
					return A3($author$project$Pages$Companies$CompanyId_String$Eas$viewModal, id, form, uploadHeader);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A6(
				$author$project$Layouts$Company$Uploads$view,
				model.ZD,
				model.WF,
				model.ab9,
				model.iH,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						$author$project$Pages$Companies$CompanyId_String$Eas$viewFeedEnroller(model),
						function () {
						var _v4 = model.kG;
						switch (_v4.$) {
							case 3:
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSetting(model),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$author$project$Pages$Companies$CompanyId_String$Eas$viewUploadHeaders(model)
										]));
							case 2:
								return $author$project$Utils$Html$empty;
							default:
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]));
						}
					}()
					]),
				_List_Nil)
			]),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Upload Settings'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Eas$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Eas$init, aer: $author$project$Pages$Companies$CompanyId_String$Eas$load, agD: $author$project$Pages$Companies$CompanyId_String$Eas$save, ahd: $author$project$Pages$Companies$CompanyId_String$Eas$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Eas$update, ahP: $author$project$Pages$Companies$CompanyId_String$Eas$view});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Feature$ManuallyDisableElationSync = 3;
var $author$project$Components$Employee$Form$Division = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Employee$Form$EligibilityDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Employee$Form$EmployeeForm = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Employee$Form$FieldUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Employee$Form$PatientFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Employee$Form$Plan = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Employee$Form$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Employee$Form$defaultEmployeeSettings = {Yl: false, BU: true, aaF: false};
var $author$project$Components$Patient$Form$defaultSettings = F3(
	function (currentDate, isNew, isEmployeeForm) {
		return {abD: false, abL: false, cO: currentDate, P8: false, Qe: false, q3: isEmployeeForm, iX: isNew, aeA: false, TU: $elm$core$Maybe$Nothing, rr: false, BT: false, ago: false, Ym: false, agp: false, Yr: false, Ys: false, _D: false, $f: false, ahB: false, $$: false, $1: false, DF: false};
	});
var $author$project$Components$Employee$Form$defaultSettings = F3(
	function (currentDate, isNew, employeeSettings) {
		return {
			xn: employeeSettings,
			VM: A3($author$project$Components$Patient$Form$defaultSettings, currentDate, isNew, true)
		};
	});
var $author$project$Components$EmployeeDependentTypeInput$empty = F2(
	function (session, company) {
		return _Utils_Tuple2(
			{ab9: company, fs: $elm$core$Maybe$Nothing, dV: $elm$core$Maybe$Nothing, ZD: session, ahI: 'employee'},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmployeeDivisionInput$empty = F3(
	function (session, companyId, apiClient) {
		return _Utils_Tuple2(
			{D5: apiClient, NT: $elm$core$Maybe$Nothing, xp: $author$project$Api$Data$Loading, agk: false, ZD: session},
			A5(
				$author$project$Api$EmployeeDivision$list,
				apiClient,
				session,
				companyId,
				function (d) {
					return d;
				},
				$author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions));
	});
var $author$project$Components$Patient$Form$Address = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Patient$Form$Affiliate = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Patient$Form$FieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$Form$HealthInsurance = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Patient$Form$JoinedPractice = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Patient$Form$KnownPractice = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Patient$Form$LeadSource = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Patient$Form$Location = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Patient$Form$PatientForm = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Practitioner$PracticeExtras = 1;
var $author$project$Components$Patient$Form$Practitioner = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Patient$Form$affiliateOptionals = F2(
	function (practitioner, location) {
		return function (d) {
			return _Utils_update(
				d,
				{aet: location, afS: practitioner});
		};
	});
var $author$project$Api$Employer$Company$One$defaultAffiliation = function (_v0) {
	var record = _v0.b;
	return record.M6;
};
var $author$project$Api$Provider$Company$One$defaultAffiliation = function (_v0) {
	var record = _v0.b;
	return record.M6;
};
var $author$project$Api$Company$defaultAffiliation = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Company$One$defaultAffiliation(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Employer,
			$author$project$Api$Employer$Company$One$defaultAffiliation(company_));
	}
};
var $author$project$Api$Location$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Company$One$defaultLocation = function (_v0) {
	var record = _v0.b;
	return record.M9;
};
var $author$project$Api$Provider$Company$One$defaultLocation = function (_v0) {
	var record = _v0.b;
	return record.M9;
};
var $author$project$Api$Company$defaultLocation = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Location$Shared$Provider,
			$author$project$Api$Provider$Company$One$defaultLocation(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Location$Shared$Employer,
			$author$project$Api$Employer$Company$One$defaultLocation(company_));
	}
};
var $author$project$Api$Practitioner$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Company$One$defaultPractitioner = function (_v0) {
	var record = _v0.b;
	return record.Nj;
};
var $author$project$Api$Provider$Company$One$defaultPractitioner = function (_v0) {
	var record = _v0.b;
	return record.Nj;
};
var $author$project$Api$Company$defaultPractitioner = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practitioner$Shared$Provider,
			$author$project$Api$Provider$Company$One$defaultPractitioner(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practitioner$Shared$Employer,
			$author$project$Api$Employer$Company$One$defaultPractitioner(company_));
	}
};
var $author$project$Components$AffiliateInput$FilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Affiliate$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Affiliate$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Affiliate$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Affiliate$affiliatesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['affiliates']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Affiliate$All$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Employer$Affiliate$Shared$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Employer$Affiliate$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Employer$Affiliate$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Affiliate$Shared$Record)));
var $author$project$Api$Employer$Affiliate$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Affiliate$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Affiliate$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Affiliate$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Affiliate$listDefaults = {
	adR: $elm$core$Maybe$Nothing,
	aet: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	afS: $elm$core$Maybe$Nothing,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
	ag7: $elm$core$Maybe$Nothing
};
var $author$project$Api$Employer$Affiliate$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$Affiliate$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.ag7;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Employer$Affiliate$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Affiliate$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$Affiliate$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Affiliate$affiliatesPath)));
	});
var $author$project$Api$Affiliate$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Affiliate$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Affiliate$All$Employer)))) : A3(
			$author$project$Api$Provider$Affiliate$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Affiliate$All$Provider))));
	});
var $author$project$Components$ResourceFilter$Affiliate$list = $author$project$Api$Affiliate$list;
var $author$project$Api$Employer$Affiliate$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$Affiliate$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Affiliate$Shared$id(shared);
};
var $author$project$Api$Affiliate$All$id = function (affiliate) {
	if (!affiliate.$) {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Provider$Affiliate$All$id(affiliate_);
	} else {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Employer$Affiliate$All$id(affiliate_);
	}
};
var $author$project$Api$Employer$Affiliate$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$Affiliate$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Affiliate$Shared$name(shared);
};
var $author$project$Api$Affiliate$All$name = function (affiliate) {
	if (!affiliate.$) {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Provider$Affiliate$All$name(affiliate_);
	} else {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Employer$Affiliate$All$name(affiliate_);
	}
};
var $author$project$Components$ResourceFilter$Affiliate$resourceFromAll = function (affiliate) {
	return {
		adR: $author$project$Api$Affiliate$All$id(affiliate),
		zh: $author$project$Api$Affiliate$All$name(affiliate)
	};
};
var $author$project$Components$ResourceFilter$Affiliate$fetchResources = F6(
	function (session, listOptionals, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$Affiliate$list,
			apiClient,
			session,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Affiliate$retrieveResource = F5(
	function (session, listOptionals, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$Affiliate$list,
			apiClient,
			session,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$Affiliate$selectId = 'affiliates';
var $author$project$Components$ResourceFilter$Affiliate$toTitle = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.zh;
	},
	$elm$core$Maybe$withDefault('N/A'));
var $author$project$Components$ResourceFilter$Affiliate$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Affiliate$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Affiliate$toValue = function ($) {
	return $.adR;
};
var $author$project$Components$ResourceFilter$Affiliate$init = F4(
	function (apiClient, session, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: A2($author$project$Components$ResourceFilter$Affiliate$fetchResources, session, listOptionals),
				adR: $author$project$Components$ResourceFilter$Affiliate$selectId,
				gx: 'Affiliate',
				st: A2($author$project$Components$ResourceFilter$Affiliate$retrieveResource, session, listOptionals),
				ahw: $author$project$Components$ResourceFilter$Affiliate$toLabel,
				ahA: $author$project$Components$ResourceFilter$Affiliate$toTitle,
				g0: $author$project$Components$ResourceFilter$Affiliate$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$AffiliateInput$empty = F3(
	function (apiClient, session, listOptionals) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Affiliate$init,
			apiClient,
			session,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false});
			});
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{Fi: filter, aaN: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Components$HealthInsuranceInput$FilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$HealthInsuranceInput$Model = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$InsuranceCarrierAlias$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$InsuranceCarrierAlias$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$InsuranceCarrierAlias$All$InsuranceCarrierAlias = $elm$core$Basics$identity;
var $author$project$Api$Employer$InsuranceCarrierAlias$One$InsuranceCarrierAlias = $elm$core$Basics$identity;
var $author$project$Api$Employer$InsuranceCarrierAlias$One$Record = F2(
	function (name, carrier) {
		return {KJ: carrier, zh: name};
	});
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$HealthInsuranceCarrier = $elm$core$Basics$identity;
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$Record = F4(
	function (id, collectGroupId, collectHighDeductible, collectMemberId) {
		return {La: collectGroupId, Lb: collectHighDeductible, Le: collectMemberId, adR: id};
	});
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_member_id',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'collect_high_deductible',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'collect_group_id',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Employer$HealthInsuranceCarrier$Shared$Record)))));
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$HealthInsuranceCarrier$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$InsuranceCarrierAlias$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carrier',
	$author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$InsuranceCarrierAlias$One$Record)));
var $author$project$Api$Employer$InsuranceCarrierAlias$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$InsuranceCarrierAlias$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$InsuranceCarrierAlias$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$InsuranceCarrierAlias$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$InsuranceCarrierAlias$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$InsuranceCarrierAlias$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				optionals,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['health_insurance_carrier_aliases']),
						$author$project$Api$Data$employerPath))));
	});
var $author$project$Api$Provider$InsuranceCarrierAlias$All$InsuranceCarrierAlias = $elm$core$Basics$identity;
var $author$project$Api$Provider$InsuranceCarrierAlias$One$InsuranceCarrierAlias = $elm$core$Basics$identity;
var $author$project$Api$Provider$InsuranceCarrierAlias$One$Record = F2(
	function (name, carrier) {
		return {KJ: carrier, zh: name};
	});
var $author$project$Api$Provider$InsuranceCarrierAlias$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carrier',
	$author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$InsuranceCarrierAlias$One$Record)));
var $author$project$Api$Provider$InsuranceCarrierAlias$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InsuranceCarrierAlias$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InsuranceCarrierAlias$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InsuranceCarrierAlias$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$InsuranceCarrierAlias$list = F3(
	function (apiClient, params, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$InsuranceCarrierAlias$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				params,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['health_insurance_carrier_aliases']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Api$InsuranceCarrierAlias$defaults = {adR: $elm$core$Maybe$Nothing, zh: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init};
var $author$project$Api$InsuranceCarrierAlias$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$InsuranceCarrierAlias$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.adR;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.zh;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'name', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$InsuranceCarrierAlias$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$InsuranceCarrierAlias$list,
			apiClient,
			$author$project$Api$InsuranceCarrierAlias$optionalsToParams(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$InsuranceCarrierAlias$All$Employer)))) : A3(
			$author$project$Api$Provider$InsuranceCarrierAlias$list,
			apiClient,
			$author$project$Api$InsuranceCarrierAlias$optionalsToParams(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$InsuranceCarrierAlias$All$Provider))));
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$list = $author$project$Api$InsuranceCarrierAlias$list;
var $author$project$Api$HealthInsuranceCarrier$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$HealthInsuranceCarrier$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$InsuranceCarrierAlias$One$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Employer$InsuranceCarrierAlias$One$carrier = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Employer$InsuranceCarrierAlias$One$record,
	function ($) {
		return $.KJ;
	});
var $author$project$Api$Employer$InsuranceCarrierAlias$All$one = function (_v0) {
	var one_ = _v0;
	return one_;
};
var $author$project$Api$Employer$InsuranceCarrierAlias$All$carrier = A2($elm$core$Basics$composeR, $author$project$Api$Employer$InsuranceCarrierAlias$All$one, $author$project$Api$Employer$InsuranceCarrierAlias$One$carrier);
var $author$project$Api$Provider$InsuranceCarrierAlias$One$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$InsuranceCarrierAlias$One$carrier = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$InsuranceCarrierAlias$One$record,
	function ($) {
		return $.KJ;
	});
var $author$project$Api$Provider$InsuranceCarrierAlias$All$one = function (_v0) {
	var one_ = _v0;
	return one_;
};
var $author$project$Api$Provider$InsuranceCarrierAlias$All$carrier = A2($elm$core$Basics$composeR, $author$project$Api$Provider$InsuranceCarrierAlias$All$one, $author$project$Api$Provider$InsuranceCarrierAlias$One$carrier);
var $author$project$Api$InsuranceCarrierAlias$All$carrier = function (carrierAlias) {
	if (!carrierAlias.$) {
		var carrierAlias_ = carrierAlias.a;
		return $author$project$Api$HealthInsuranceCarrier$Shared$Provider(
			$author$project$Api$Provider$InsuranceCarrierAlias$All$carrier(carrierAlias_));
	} else {
		var carrierAlias_ = carrierAlias.a;
		return $author$project$Api$HealthInsuranceCarrier$Shared$Employer(
			$author$project$Api$Employer$InsuranceCarrierAlias$All$carrier(carrierAlias_));
	}
};
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectGroupId = function (_v0) {
	var shared = _v0;
	return shared.La;
};
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectGroupId = function (_v0) {
	var shared = _v0;
	return shared.La;
};
var $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId = function (carrier) {
	if (!carrier.$) {
		var carrier_ = carrier.a;
		return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectGroupId(carrier_);
	} else {
		var carrier_ = carrier.a;
		return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectGroupId(carrier_);
	}
};
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectHighDeductible = function (_v0) {
	var shared = _v0;
	return shared.Lb;
};
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectHighDeductible = function (_v0) {
	var shared = _v0;
	return shared.Lb;
};
var $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible = function (carrier) {
	if (!carrier.$) {
		var carrier_ = carrier.a;
		return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier_);
	} else {
		var carrier_ = carrier.a;
		return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier_);
	}
};
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectMemberId = function (_v0) {
	var shared = _v0;
	return shared.Le;
};
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectMemberId = function (_v0) {
	var shared = _v0;
	return shared.Le;
};
var $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId = function (carrier) {
	if (!carrier.$) {
		var carrier_ = carrier.a;
		return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectMemberId(carrier_);
	} else {
		var carrier_ = carrier.a;
		return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectMemberId(carrier_);
	}
};
var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.adR;
};
var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.adR;
};
var $author$project$Api$HealthInsuranceCarrier$Shared$id = function (carrier) {
	if (!carrier.$) {
		var carrier_ = carrier.a;
		return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$id(carrier_);
	} else {
		var carrier_ = carrier.a;
		return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$id(carrier_);
	}
};
var $author$project$Api$Employer$InsuranceCarrierAlias$One$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Employer$InsuranceCarrierAlias$One$record,
	function ($) {
		return $.zh;
	});
var $author$project$Api$Employer$InsuranceCarrierAlias$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Employer$InsuranceCarrierAlias$All$one, $author$project$Api$Employer$InsuranceCarrierAlias$One$name);
var $author$project$Api$Provider$InsuranceCarrierAlias$One$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$InsuranceCarrierAlias$One$record,
	function ($) {
		return $.zh;
	});
var $author$project$Api$Provider$InsuranceCarrierAlias$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Provider$InsuranceCarrierAlias$All$one, $author$project$Api$Provider$InsuranceCarrierAlias$One$name);
var $author$project$Api$InsuranceCarrierAlias$All$name = function (carrierAlias) {
	if (!carrierAlias.$) {
		var carrierAlias_ = carrierAlias.a;
		return $author$project$Api$Provider$InsuranceCarrierAlias$All$name(carrierAlias_);
	} else {
		var carrierAlias_ = carrierAlias.a;
		return $author$project$Api$Employer$InsuranceCarrierAlias$All$name(carrierAlias_);
	}
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll = function (insuranceCarrierAlias) {
	var carrient = $author$project$Api$InsuranceCarrierAlias$All$carrier(insuranceCarrierAlias);
	return {
		Eu: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrient),
		KK: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrient),
		Ev: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrient),
		Ew: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrient),
		zh: $author$project$Api$InsuranceCarrierAlias$All$name(insuranceCarrierAlias)
	};
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$fetchResources = F5(
	function (session, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$InsuranceCarrierAlias$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{zh: query, afy: pagination});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$retrieveResource = F4(
	function (session, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$InsuranceCarrierAlias$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$selectId = 'insurance-carrier-alias';
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle = function ($) {
	return $.zh;
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toValue = function ($) {
	return $.zh;
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$init = F3(
	function (apiClient, session, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$fetchResources(session),
				adR: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$selectId,
				gx: 'Insurance Carrier',
				st: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$retrieveResource(session),
				ahw: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toLabel,
				ahA: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle,
				g0: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$HealthInsuranceInput$empty = F2(
	function (apiClient, session) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$InsuranceCarrierAlias$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a health insurance carrier', UL: 'Other (Enter insurance carrier name manually)', aeZ: true});
			});
		var insuranceCarrierAliasFilter = _v0.a;
		var insuranceCarrierAliasCmd = _v0.b;
		return _Utils_Tuple2(
			A3(
				$author$project$Components$HealthInsuranceInput$Model,
				insuranceCarrierAliasFilter,
				{dW: false},
				$elm$core$Maybe$Nothing),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, insuranceCarrierAliasCmd));
	});
var $author$project$Components$KnownPracticeInput$FilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$KnownPracticeInput$Model = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$ResourceFilter$KnownPractice$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$KnownPractice$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$KnownPractice$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$KnownPractice$All$KnownPractice = $elm$core$Basics$identity;
var $author$project$Api$Employer$KnownPractice$Shared$KnownPractice = $elm$core$Basics$identity;
var $author$project$Api$Employer$KnownPractice$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Employer$KnownPractice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$KnownPractice$Shared$Record)));
var $author$project$Api$Employer$KnownPractice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$KnownPractice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$KnownPractice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$KnownPractice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$KnownPractice$defaults = {adR: $elm$core$Maybe$Nothing, zh: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init};
var $author$project$Api$Employer$KnownPractice$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$KnownPractice$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.adR;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.zh;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'name', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Employer$KnownPractice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$KnownPractice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$KnownPractice$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['known_practices']),
						$author$project$Api$Data$employerPath))));
	});
var $author$project$Api$Provider$KnownPractice$All$KnownPractice = $elm$core$Basics$identity;
var $author$project$Api$Provider$KnownPractice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$KnownPractice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$KnownPractice$defaults = {adR: $elm$core$Maybe$Nothing, zh: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$KnownPractice$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$KnownPractice$defaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.adR;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.zh;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'name', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$KnownPractice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$KnownPractice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$KnownPractice$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['known_practices']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Api$KnownPractice$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$KnownPractice$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$KnownPractice$All$Employer)))) : A3(
			$author$project$Api$Provider$KnownPractice$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$KnownPractice$All$Provider))));
	});
var $author$project$Components$ResourceFilter$KnownPractice$list = $author$project$Api$KnownPractice$list;
var $author$project$Api$Employer$KnownPractice$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$KnownPractice$All$shared = function (_v0) {
	var shared_ = _v0;
	return shared_;
};
var $author$project$Api$Employer$KnownPractice$All$id = A2($elm$core$Basics$composeR, $author$project$Api$Employer$KnownPractice$All$shared, $author$project$Api$Employer$KnownPractice$Shared$id);
var $author$project$Api$Provider$KnownPractice$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$KnownPractice$Shared$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$KnownPractice$Shared$record,
	function ($) {
		return $.adR;
	});
var $author$project$Api$Provider$KnownPractice$All$shared = function (_v0) {
	var shared_ = _v0;
	return shared_;
};
var $author$project$Api$Provider$KnownPractice$All$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$KnownPractice$All$shared, $author$project$Api$Provider$KnownPractice$Shared$id);
var $author$project$Api$KnownPractice$All$id = function (knownPractice) {
	if (!knownPractice.$) {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Provider$KnownPractice$All$id(knownPractice_);
	} else {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Employer$KnownPractice$All$id(knownPractice_);
	}
};
var $author$project$Api$Employer$KnownPractice$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Employer$KnownPractice$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Employer$KnownPractice$All$shared, $author$project$Api$Employer$KnownPractice$Shared$name);
var $author$project$Api$Provider$KnownPractice$Shared$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$KnownPractice$Shared$record,
	function ($) {
		return $.zh;
	});
var $author$project$Api$Provider$KnownPractice$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Provider$KnownPractice$All$shared, $author$project$Api$Provider$KnownPractice$Shared$name);
var $author$project$Api$KnownPractice$All$name = function (knownPractice) {
	if (!knownPractice.$) {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Provider$KnownPractice$All$name(knownPractice_);
	} else {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Employer$KnownPractice$All$name(knownPractice_);
	}
};
var $author$project$Components$ResourceFilter$KnownPractice$resourceFromAll = function (knownPractice) {
	return {
		adR: $author$project$Api$KnownPractice$All$id(knownPractice),
		zh: $author$project$Api$KnownPractice$All$name(knownPractice)
	};
};
var $author$project$Components$ResourceFilter$KnownPractice$fetchResources = F5(
	function (session, toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$KnownPractice$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{zh: query, afy: pagination});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$KnownPractice$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$KnownPractice$retrieveResource = F4(
	function (session, toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$KnownPractice$list,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$KnownPractice$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$KnownPractice$selectId = 'known-practices';
var $author$project$Components$ResourceFilter$KnownPractice$toTitle = function ($) {
	return $.zh;
};
var $author$project$Components$ResourceFilter$KnownPractice$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$KnownPractice$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$KnownPractice$toValue = function ($) {
	return $.adR;
};
var $author$project$Components$ResourceFilter$KnownPractice$init = F3(
	function (apiClient, session, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: $author$project$Components$ResourceFilter$KnownPractice$fetchResources(session),
				adR: $author$project$Components$ResourceFilter$KnownPractice$selectId,
				gx: 'Known Practice',
				st: $author$project$Components$ResourceFilter$KnownPractice$retrieveResource(session),
				ahw: $author$project$Components$ResourceFilter$KnownPractice$toLabel,
				ahA: $author$project$Components$ResourceFilter$KnownPractice$toTitle,
				g0: $author$project$Components$ResourceFilter$KnownPractice$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$KnownPracticeInput$empty = F2(
	function (apiClient, session) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$KnownPractice$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a DPC practice', UL: 'Other (Enter your DPC manually)', aeZ: true});
			});
		var knownPracticeFilter = _v0.a;
		var knownPracticeCmd = _v0.b;
		return _Utils_Tuple2(
			A2($author$project$Components$KnownPracticeInput$Model, knownPracticeFilter, $elm$core$Maybe$Nothing),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, knownPracticeCmd));
	});
var $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$LeadSourceInput$initLeadSourceResourceFilter = F2(
	function (apiClient, preSelectedId) {
		return A3(
			$author$project$Components$ResourceFilter$LeadSource$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', afT: preSelectedId});
			});
	});
var $author$project$Components$LeadSourceInput$empty = function (apiClient) {
	var _v0 = A2($author$project$Components$LeadSourceInput$initLeadSourceResourceFilter, apiClient, $elm$core$Maybe$Nothing);
	var leadSourceResourceFilter = _v0.a;
	var leadSourceResourceFilterCmd = _v0.b;
	return _Utils_Tuple2(
		{dW: false, mQ: leadSourceResourceFilter, c2: $elm$core$Maybe$Nothing, ag: $elm$core$Maybe$Nothing},
		A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd));
};
var $author$project$Components$LocationInput$FilterMsg = $elm$core$Basics$identity;
var $author$project$Components$LocationInput$empty = F2(
	function (apiClient, listOptionals) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false});
			});
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{dW: false, Fi: filter, agk: false, aaN: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Components$NameInput$Model = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$NameInput$empty = A3(
	$author$project$Components$NameInput$Model,
	_List_Nil,
	{dW: false, ti: ''},
	{Pu: '', SA: '', TX: '', _8: $elm$core$Maybe$Nothing, $G: ''});
var $author$project$Components$PractitionerInput$FilterMsg = $elm$core$Basics$identity;
var $author$project$Components$PractitionerInput$empty = F2(
	function (apiClient, listOptionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false});
			});
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{dW: false, Fi: filter, agk: false, aaN: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Components$EmergencyContactInput$RelationshipDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$EmergencyContact$Shared$record = function (_v0) {
	var r = _v0;
	return r;
};
var $author$project$Api$Common$EmergencyContact$Shared$email = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.Oo;
	});
var $author$project$Components$EmergencyContactInput$initPhone = function (maybePhone) {
	return A3(
		$author$project$Components$PhoneInput$init,
		'emergency-contact-phone',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				{Gj: '', agc: 0, ahI: $author$project$Api$Common$Phone$Shared$Mobile},
				A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone))
			]),
		function (opts) {
			return _Utils_update(
				opts,
				{abk: false, yQ: 1});
		});
};
var $author$project$Components$EmergencyContactInput$empty = {
	Oo: '',
	Pu: '',
	SA: '',
	Wg: $author$project$Components$EmergencyContactInput$initPhone($elm$core$Maybe$Nothing),
	X6: $elm$core$Maybe$Nothing
};
var $author$project$Api$Common$EmergencyContact$Shared$firstName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.Pu;
	});
var $author$project$Api$Common$EmergencyContact$Shared$lastName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.SA;
	});
var $author$project$Api$Common$EmergencyContact$Shared$phone = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.Wg;
	});
var $author$project$Api$Common$EmergencyContact$Shared$relationship = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.X6;
	});
var $author$project$Components$EmergencyContactInput$Child = {$: 2};
var $author$project$Components$EmergencyContactInput$Grandparent = {$: 4};
var $author$project$Components$EmergencyContactInput$Guardian = {$: 5};
var $author$project$Components$EmergencyContactInput$Other = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$EmergencyContactInput$Parent = {$: 1};
var $author$project$Components$EmergencyContactInput$Sibling = {$: 3};
var $author$project$Components$EmergencyContactInput$Spouse = {$: 0};
var $author$project$Components$EmergencyContactInput$relationshipFromString = function (rel) {
	switch (rel) {
		case 'spouse':
			return $author$project$Components$EmergencyContactInput$Spouse;
		case 'parent':
			return $author$project$Components$EmergencyContactInput$Parent;
		case 'child':
			return $author$project$Components$EmergencyContactInput$Child;
		case 'sibling':
			return $author$project$Components$EmergencyContactInput$Sibling;
		case 'grandparent':
			return $author$project$Components$EmergencyContactInput$Grandparent;
		case 'guardian':
			return $author$project$Components$EmergencyContactInput$Guardian;
		default:
			return $author$project$Components$EmergencyContactInput$Other(rel);
	}
};
var $author$project$Components$EmergencyContactInput$init = function (patientEmergencyContact) {
	var relationshipDropdown = $author$project$Ui$NewDropdown$init(
		$author$project$Ui$NewDropdown$defaultConfig(
			{adR: 'emergency-contact-relationship-dropdown', ahx: $author$project$Components$EmergencyContactInput$RelationshipDropdownMsg}));
	var form = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Form$init($author$project$Components$EmergencyContactInput$empty),
		A2(
			$elm$core$Maybe$map,
			$author$project$Utils$Form$init,
			A2(
				$elm$core$Maybe$map,
				function (ec) {
					return {
						Oo: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Common$EmergencyContact$Shared$email(ec)),
						Pu: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Common$EmergencyContact$Shared$firstName(ec)),
						SA: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Common$EmergencyContact$Shared$lastName(ec)),
						Wg: $author$project$Components$EmergencyContactInput$initPhone(
							$author$project$Api$Common$EmergencyContact$Shared$phone(ec)),
						X6: A2(
							$elm$core$Maybe$map,
							$author$project$Components$EmergencyContactInput$relationshipFromString,
							$author$project$Api$Common$EmergencyContact$Shared$relationship(ec))
					};
				},
				patientEmergencyContact)));
	return {PB: form, nV: relationshipDropdown};
};
var $author$project$Components$LocationInput$setValueWithResource = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Fi: A2($author$project$Components$ResourceFilter$Location$setValue, resource, model.Fi),
				aaN: resource
			});
	});
var $author$project$Components$LocationInput$setValue = F2(
	function (location, model) {
		var resource = $author$project$Components$ResourceFilter$Location$resourceFromShared(location);
		return A2($author$project$Components$LocationInput$setValueWithResource, resource, model);
	});
var $author$project$Components$LocationInput$init = F3(
	function (apiClient, listOptionals, location) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$LocationInput$setValue(location),
			A2($author$project$Components$LocationInput$empty, apiClient, listOptionals));
	});
var $author$project$Components$PractitionerInput$setValueWithResource = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Fi: A2($author$project$Components$ResourceFilter$Practitioner$setValue, resource, model.Fi),
				aaN: resource
			});
	});
var $author$project$Components$PractitionerInput$setValue = F2(
	function (practitioner, model) {
		var resource = $author$project$Components$ResourceFilter$Practitioner$resourceFromShared(practitioner);
		return A2($author$project$Components$PractitionerInput$setValueWithResource, resource, model);
	});
var $author$project$Components$PractitionerInput$init = F3(
	function (apiClient, listOptionals, practitioner) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$PractitionerInput$setValue(practitioner),
			A2($author$project$Components$PractitionerInput$empty, apiClient, listOptionals));
	});
var $author$project$Api$SignupPage$Min$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$SignupPage$Min$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Company$One$defaultSignupPage = function (_v0) {
	var record = _v0.b;
	return record.Nk;
};
var $author$project$Api$Provider$Company$One$defaultSignupPage = function (_v0) {
	var record = _v0.b;
	return record.Nk;
};
var $author$project$Api$Company$defaultSignupPage = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$SignupPage$Min$Provider,
			$author$project$Api$Provider$Company$One$defaultSignupPage(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$SignupPage$Min$Employer,
			$author$project$Api$Employer$Company$One$defaultSignupPage(company_));
	}
};
var $author$project$Api$Employer$SignupPage$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$SignupPage$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$SignupPage$Min$id = function (signupPage) {
	if (!signupPage.$) {
		var sponsorFeeDeal_ = signupPage.a;
		return $author$project$Api$Provider$SignupPage$Min$id(sponsorFeeDeal_);
	} else {
		var sponsorFeeDeal_ = signupPage.a;
		return $author$project$Api$Employer$SignupPage$Min$id(sponsorFeeDeal_);
	}
};
var $author$project$Components$Patient$Form$practitionerSignupOptionals = F2(
	function (isEmployeeForm, company) {
		var page = isEmployeeForm ? A2(
			$elm$core$Maybe$map,
			function (pg) {
				return $author$project$Api$SignupPage$Min$id(pg);
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
		var _v0 = function () {
			if (!company.$) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(true),
					$elm$core$Maybe$Nothing);
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(true));
			}
		}();
		var acceptsEnrollmentsFromEmployer = _v0.a;
		var acceptsEnrollmentsFromRetail = _v0.b;
		return function (d) {
			return _Utils_update(
				d,
				{pg: acceptsEnrollmentsFromEmployer, ph: acceptsEnrollmentsFromRetail, Hc: page});
		};
	});
var $author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras = F5(
	function (isEmployeeForm, company, location, affiliate, expand) {
		var page = isEmployeeForm ? A2(
			$elm$core$Maybe$map,
			function (pg) {
				return $author$project$Api$SignupPage$Min$id(pg);
			},
			A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
		var _v0 = function () {
			if (!company.$) {
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(true),
					$elm$core$Maybe$Nothing);
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(true));
			}
		}();
		var acceptsEnrollmentsFromEmployer = _v0.a;
		var acceptsEnrollmentsFromRetail = _v0.b;
		return function (d) {
			return _Utils_update(
				d,
				{pg: acceptsEnrollmentsFromEmployer, ph: acceptsEnrollmentsFromRetail, DZ: affiliate, Fc: expand, aet: location, Hc: page});
		};
	});
var $author$project$Components$LocationInput$require = F2(
	function (required, input) {
		return _Utils_update(
			input,
			{agk: required});
	});
var $author$project$Components$PractitionerInput$require = F2(
	function (required, input) {
		return _Utils_update(
			input,
			{agk: required});
	});
var $author$project$Api$Employer$Affiliate$AffiliateMin$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Affiliate$AffiliateMin$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Affiliate$AffiliateMin$id = function (affiliate) {
	if (!affiliate.$) {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliate_);
	} else {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Employer$Affiliate$AffiliateMin$id(affiliate_);
	}
};
var $author$project$Api$Employer$Affiliate$AffiliateMin$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Affiliate$AffiliateMin$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Affiliate$AffiliateMin$name = function (affiliate) {
	if (!affiliate.$) {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Provider$Affiliate$AffiliateMin$name(affiliate_);
	} else {
		var affiliate_ = affiliate.a;
		return $author$project$Api$Employer$Affiliate$AffiliateMin$name(affiliate_);
	}
};
var $author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin = function (affiliate) {
	return {
		adR: $author$project$Api$Affiliate$AffiliateMin$id(affiliate),
		zh: $author$project$Api$Affiliate$AffiliateMin$name(affiliate)
	};
};
var $author$project$Components$ResourceFilter$Affiliate$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				G0: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$AffiliateInput$setValueWithResource = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				Fi: A2($author$project$Components$ResourceFilter$Affiliate$setValue, resource, model.Fi),
				aaN: resource
			});
	});
var $author$project$Components$AffiliateInput$setValue = F2(
	function (maybeAffiliate, model) {
		var resource = A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin, maybeAffiliate);
		return A2($author$project$Components$AffiliateInput$setValueWithResource, resource, model);
	});
var $author$project$Components$Patient$Form$signupOptionals = F2(
	function (isEmployeeForm, company) {
		return isEmployeeForm ? A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				function (page) {
					return function (d) {
						return _Utils_update(
							d,
							{
								Hc: $elm$core$Maybe$Just(
									$author$project$Api$SignupPage$Min$id(page))
							});
					};
				},
				A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company))) : $elm$core$Basics$identity;
	});
var $author$project$Components$Patient$Form$empty = F6(
	function (apiClient, session, currentDate, company, isEmployeeForm, settingsMapper) {
		var settings = settingsMapper(
			A3($author$project$Components$Patient$Form$defaultSettings, currentDate, true, isEmployeeForm));
		var practitionerOptionals = isEmployeeForm ? A2($author$project$Components$Patient$Form$practitionerSignupOptionals, isEmployeeForm, company) : A5(
			$author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras,
			isEmployeeForm,
			company,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing,
			_List_fromArray(
				[1]));
		var phonesInput = A3(
			$author$project$Components$PhoneInput$init,
			'patient-phones',
			_List_Nil,
			function (d) {
				return _Utils_update(
					d,
					{Ik: true});
			});
		var optionals = A2($author$project$Components$Patient$Form$signupOptionals, isEmployeeForm, company);
		var _v0 = function () {
			var _v1 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultPractitioner, company);
			if (!_v1.$) {
				var companyPractitioner = _v1.a;
				return A3(
					$author$project$Components$PractitionerInput$init,
					apiClient,
					practitionerOptionals,
					$elm$core$Maybe$Just(companyPractitioner));
			} else {
				return A2($author$project$Components$PractitionerInput$empty, apiClient, practitionerOptionals);
			}
		}();
		var practitioner = _v0.a;
		var practitionerCmd = _v0.b;
		var _v2 = function () {
			var _v3 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultLocation, company);
			if (!_v3.$) {
				var companyLocation = _v3.a;
				return A3(
					$author$project$Components$LocationInput$init,
					apiClient,
					optionals,
					$elm$core$Maybe$Just(companyLocation));
			} else {
				return A2($author$project$Components$LocationInput$empty, apiClient, optionals);
			}
		}();
		var location = _v2.a;
		var locationCmd = _v2.b;
		var _v4 = $author$project$Components$LeadSourceInput$empty(apiClient);
		var leadSource = _v4.a;
		var leadSourceCmd = _v4.b;
		var _v5 = A2($author$project$Components$KnownPracticeInput$empty, apiClient, session);
		var knownPractice = _v5.a;
		var knownPracticeCmd = _v5.b;
		var _v6 = A2($author$project$Components$HealthInsuranceInput$empty, apiClient, session);
		var healthInsurance = _v6.a;
		var healthInsuranceCmd = _v6.b;
		var _v7 = $author$project$Components$DateInput$init;
		var dateInput = _v7.a;
		var dateInputCmd = _v7.b;
		var _v8 = function () {
			var _v9 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultAffiliation, company);
			if (!_v9.$) {
				var companyAffiliation = _v9.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Components$AffiliateInput$setValue(
						$elm$core$Maybe$Just(companyAffiliation)),
					A3(
						$author$project$Components$AffiliateInput$empty,
						apiClient,
						session,
						A2($author$project$Components$Patient$Form$affiliateOptionals, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)));
			} else {
				return A3(
					$author$project$Components$AffiliateInput$empty,
					apiClient,
					session,
					A2($author$project$Components$Patient$Form$affiliateOptionals, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
			}
		}();
		var affiliate = _v8.a;
		var affiliateCmd = _v8.b;
		var _v10 = $author$project$Components$AddressInput$init('patient-address');
		var address = _v10.a;
		var addressCmd = _v10.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				$author$project$Utils$Form$init(
					{
						It: address,
						DZ: affiliate,
						JZ: $elm$core$Maybe$Nothing,
						bo: $elm$core$Maybe$Nothing,
						p7: $elm$core$Maybe$Nothing,
						MR: '',
						Oo: $elm$core$Maybe$Nothing,
						Oq: $author$project$Components$EmergencyContactInput$init($elm$core$Maybe$Nothing),
						PO: $elm$core$Maybe$Nothing,
						PP: $elm$core$Maybe$Nothing,
						PQ: $elm$core$Maybe$Nothing,
						Qj: healthInsurance,
						i_: _Utils_Tuple2($elm$core$Maybe$Nothing, dateInput),
						Ss: knownPractice,
						SH: leadSource,
						SK: $author$project$Components$NameInput$empty,
						aet: A2($author$project$Components$LocationInput$require, settings.Ym, location),
						Wi: A2($author$project$Components$PhoneInput$require, settings.agp, phonesInput),
						afS: A2($author$project$Components$PractitionerInput$require, settings.Yr, practitioner),
						WV: $author$project$Language$english,
						sg: 0,
						Xg: $elm$core$Maybe$Nothing,
						Xh: $elm$core$Maybe$Nothing,
						ZH: $elm$core$Maybe$Nothing,
						_C: '',
						$j: true,
						oL: $elm$core$Maybe$Nothing,
						aaC: false
					})),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
						addressCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
						knownPracticeCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
						practitionerCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
						locationCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
						affiliateCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
						leadSourceCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
						healthInsuranceCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice),
						dateInputCmd)
					])));
	});
var $author$project$Components$SponsorPlanInput$FilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$One$defaultPlan = function (_v0) {
	var record = _v0.b;
	return record.Nh;
};
var $author$project$Api$Provider$Company$One$defaultPlan = function (_v0) {
	var record = _v0.b;
	return record.Nh;
};
var $author$project$Api$Company$defaultPlan = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$ProviderShared,
			$author$project$Api$Provider$Company$One$defaultPlan(company_));
	} else {
		var company_ = company.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$EmployerShared,
			$author$project$Api$Employer$Company$One$defaultPlan(company_));
	}
};
var $author$project$Components$SponsorPlanInput$filterInit = F4(
	function (session, company, apiClient, planId) {
		return A4(
			$author$project$Components$ResourceFilter$CompanyPlan$init,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Plan', IS: false, aeZ: false, afT: planId});
			});
	});
var $author$project$Components$SponsorPlanInput$init = F3(
	function (session, company, apiClient) {
		var defaultPlanId = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$id,
			$author$project$Api$Company$defaultPlan(company));
		var _v0 = A4($author$project$Components$SponsorPlanInput$filterInit, session, company, apiClient, defaultPlanId);
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{dW: false, Fi: filter, agk: false, aaN: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Components$Employee$Form$nextFirstOfMonth = function (currentDate) {
	return $author$project$Utils$Date$toIsoString(
		A2($justinmimbs$date$Date$ceiling, 2, currentDate));
};
var $author$project$Components$EmployeeDivisionInput$require = F2(
	function (required, input) {
		return _Utils_update(
			input,
			{agk: required});
	});
var $author$project$Components$SponsorPlanInput$require = F2(
	function (required, input) {
		return _Utils_update(
			input,
			{agk: required});
	});
var $author$project$Components$Employee$Form$empty = F6(
	function (session, company, apiClient, currentDate, employeeMapper, patientMapper) {
		var isNew = true;
		var employeeSettings = employeeMapper($author$project$Components$Employee$Form$defaultEmployeeSettings);
		var _v0 = A2($author$project$Components$EmployeeDependentTypeInput$empty, session, company);
		var typeInput = _v0.a;
		var typeInputCmd = _v0.b;
		var _v1 = $author$project$Components$DateInput$init;
		var startDateInput = _v1.a;
		var startDateInputCmd = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$SponsorPlanInput$require(true),
			A3($author$project$Components$SponsorPlanInput$init, session, company, apiClient));
		var sponsorPlan = _v2.a;
		var sponsorPlanCmd = _v2.b;
		var _v3 = A6(
			$author$project$Components$Patient$Form$empty,
			apiClient,
			session,
			currentDate,
			$elm$core$Maybe$Just(company),
			true,
			patientMapper);
		var patientForm = _v3.a;
		var patientFormCmd = _v3.b;
		var _v4 = A3(
			$author$project$Components$EmployeeDivisionInput$empty,
			session,
			$author$project$Api$Company$id(company),
			apiClient);
		var divisionInput = _v4.a;
		var divisionInputCmd = _v4.b;
		var form = $author$project$Utils$Form$init(
			{
				NT: A2($author$project$Components$EmployeeDivisionInput$require, employeeSettings.Yl, divisionInput),
				cS: _Utils_Tuple2(
					$elm$core$Maybe$Just(currentDate),
					startDateInput),
				OC: $elm$core$Maybe$Just(true),
				ade: $elm$core$Maybe$Nothing,
				adR: $elm$core$Maybe$Nothing,
				iX: isNew,
				TK: $author$project$Components$Employee$Form$nextFirstOfMonth(currentDate),
				VM: patientForm,
				GH: A2($author$project$Components$SponsorPlanInput$require, employeeSettings.BU, sponsorPlan),
				ahI: typeInput
			});
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Employee$Form$EmployeeForm,
				A3($author$project$Components$Employee$Form$defaultSettings, currentDate, isNew, employeeSettings),
				form),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, patientFormCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
						typeInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
						sponsorPlanCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division),
						divisionInputCmd)
					])));
	});
var $author$project$Api$Employer$Practice$One$hasLocations = function (_v0) {
	var record = _v0;
	return record.TU.P8;
};
var $author$project$Api$Practice$hasLocations = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$hasLocations(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$hasLocations(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$hasPractitioners = function (_v0) {
	var record = _v0;
	return record.TU.Qe;
};
var $author$project$Api$Practice$hasPractitioners = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$hasPractitioners(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$hasPractitioners(practice_);
	}
};
var $author$project$Api$Provider$Practice$One$labelBillingAsShipping = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.St;
	});
var $author$project$Api$Practice$labelBillingAsShipping = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice_);
	} else {
		return false;
	}
};
var $author$project$Api$Employer$Company$Shared$requiresEmployeeDivisions = function (_v0) {
	var record = _v0;
	return record.Yl;
};
var $author$project$Api$Employer$Company$One$requiresEmployeeDivisions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$requiresEmployeeDivisions(shared);
};
var $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions = function (_v0) {
	var record = _v0;
	return record.Yl;
};
var $author$project$Api$Provider$Company$One$requiresEmployeeDivisions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions(shared);
};
var $author$project$Api$Company$requiresEmployeeDivisions = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$requiresEmployeeDivisions(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$requiresEmployeeDivisions(company_);
	}
};
var $author$project$Api$Employer$Practice$One$requiresLocation = function (_v0) {
	var record = _v0;
	return record.Ym;
};
var $author$project$Api$Practice$requiresLocation = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresLocation(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$requiresLocation(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$requiresPatientEmail = function (_v0) {
	var record = _v0;
	return record.Yo;
};
var $author$project$Api$Practice$requiresPatientEmail = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$requiresPatientEmail(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$requiresPatientMobile = function (_v0) {
	var record = _v0;
	return record.Yp;
};
var $author$project$Api$Practice$requiresPatientMobile = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$requiresPatientMobile(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$requiresPractitioner = function (_v0) {
	var record = _v0;
	return record.Yr;
};
var $author$project$Api$Practice$requiresPractitioner = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresPractitioner(practice_);
	} else {
		var practice_ = practice.a;
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			$author$project$Api$Employer$Practice$One$requiresPractitioner(practice_));
	}
};
var $author$project$Api$Employer$Practice$One$requiresSSN = function (_v0) {
	var record = _v0;
	return record.Ys;
};
var $author$project$Api$Practice$requiresSSN = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$requiresSSN(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$requiresSSN(practice_);
	}
};
var $author$project$Api$Employer$Practice$One$ssnEnabled = function (_v0) {
	var record = _v0;
	return record._D;
};
var $author$project$Api$Practice$ssnEnabled = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$ssnEnabled(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$ssnEnabled(practice_);
	}
};
var $author$project$Api$Employer$Network$Shared$syncByAffiliation = function (_v0) {
	var record = _v0;
	return record.$f;
};
var $author$project$Api$Network$Shared$syncByAffiliation = function (network) {
	if (!network.$) {
		var network_ = network.a;
		return $author$project$Api$Provider$Network$Shared$syncByAffiliation(network_);
	} else {
		var network_ = network.a;
		return $author$project$Api$Employer$Network$Shared$syncByAffiliation(network_);
	}
};
var $author$project$Api$Employer$Practice$One$transInclusivity = function (_v0) {
	var record = _v0;
	return record.$1;
};
var $author$project$Api$Provider$Practice$One$transInclusivity = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.$1;
	});
var $author$project$Api$Practice$transInclusivity = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$transInclusivity(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$transInclusivity(practice_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var _v1 = A6(
			$author$project$Components$Employee$Form$empty,
			session,
			company,
			shared.D5,
			shared.cO,
			function (employeeSettings) {
				return _Utils_update(
					employeeSettings,
					{
						Yl: $author$project$Api$Company$requiresEmployeeDivisions(company),
						aaF: $author$project$Api$Company$usesEmployeeDivisions(company)
					});
			},
			function (patientSettings) {
				return _Utils_update(
					patientSettings,
					{
						abD: $author$project$Api$Practice$labelBillingAsShipping(practice),
						abL: A2($author$project$Api$Practice$featureEnabled, 3, practice),
						P8: $author$project$Api$Practice$hasLocations(practice),
						Qe: $author$project$Api$Practice$hasPractitioners(practice),
						BT: true,
						ago: $author$project$Api$Practice$requiresPatientEmail(practice),
						Ym: $author$project$Api$Practice$requiresLocation(practice),
						agp: $author$project$Api$Practice$requiresPatientMobile(practice),
						Yr: $author$project$Api$Practice$requiresPractitioner(practice),
						Ys: $author$project$Api$Practice$requiresSSN(practice),
						_D: $author$project$Api$Practice$ssnEnabled(practice),
						$f: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Network$Shared$syncByAffiliation,
								$author$project$Api$Practice$network(practice))),
						ahB: A2($author$project$Api$Practice$featureEnabled, 2, practice),
						$$: $author$project$Api$Practice$trackPatientsByLocation(practice),
						$1: $author$project$Api$Practice$transInclusivity(practice),
						DF: A3($author$project$Permission$canGoTo, session, shared.adN, 0)
					});
			});
		var form = _v1.a;
		var formCmd = _v1.b;
		var model = {H3: $author$project$Api$Data$NotAsked, D5: shared.D5, ab9: company, an: form, adR: params.ff, afu: shared.afu, WF: practice, ZD: session, kj: false};
		return _Utils_Tuple2(
			model,
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg, formCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Employee$Form$Patient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$Form$BillingAddress = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Patient$Form$EmergencyContact = function (a) {
	return {$: 27, a: a};
};
var $author$project$Components$Patient$Form$Phones = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$EmergencyContactInput$FieldChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmergencyContactInput$Phone = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$EmergencyContactInput$subscriptions = function (_v0) {
	var form = _v0.PB;
	var relationshipDropdown = _v0.nV;
	var emergencyContact = $author$project$Utils$Form$fields(form);
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(relationshipDropdown),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone),
				$author$project$Components$PhoneInput$subscriptions(emergencyContact.Wg))
			]));
};
var $author$project$Components$Patient$Form$subscriptions = function (_v0) {
	var form = _v0.b;
	var _v1 = $author$project$Utils$Form$fields(form);
	var emergencyContact = _v1.Oq;
	var address = _v1.It;
	var billingAddress = _v1.JZ;
	var phones = _v1.Wi;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
				$author$project$Components$AddressInput$subscriptions(address)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$AddressInput$subscriptions, billingAddress))),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$EmergencyContact),
				$author$project$Components$EmergencyContactInput$subscriptions(emergencyContact)),
				A2(
				$elm$core$Platform$Sub$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones),
				$author$project$Components$PhoneInput$subscriptions(phones))
			]));
};
var $author$project$Components$Employee$Form$subscriptions = function (_v0) {
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$elm$core$Platform$Sub$map,
		A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Patient),
		$author$project$Components$Patient$Form$subscriptions(fields.VM));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg,
		$author$project$Components$Employee$Form$subscriptions(model.an));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyAccountCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$RegistrationEnrolled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$CompanyAccount$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyAccount$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$companyAccountsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['accounts']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$CompanyAccount$One$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyAccount$Shared$CompanyAccount = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyAccount$Shared$Record = F5(
	function (id, isEligible, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate) {
		return {Ok: eligibilityEndDate, Ol: eligibilityStartDate, adR: id, RK: isEligible, ahp: terminationRequestedAt};
	});
var $author$project$Api$Employer$CompanyAccount$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'eligibility_end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'eligibility_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'termination_requested_at',
			$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_eligible',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Shared$Record))))));
var $author$project$Api$Employer$CompanyAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyAccount$One$Record = F5(
	function (division, subscriber, selectedPlan, membershipPlan, registrations) {
		return {NT: division, TI: membershipPlan, age: registrations, Zh: selectedPlan, _3: subscriber};
	});
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$Record = function (patient) {
	return {VM: patient};
};
var $author$project$Api$Employer$Patient$Min$Patient = $elm$core$Basics$identity;
var $author$project$Api$Employer$Patient$Min$Record = F5(
	function (id, name, email, dob, age) {
		return {IK: age, acQ: dob, Oo: email, adR: id, zh: name};
	});
var $author$project$Api$Employer$Patient$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'age',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'dob',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$Min$Record))))));
var $author$project$Api$Employer$Patient$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Patient$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Employer$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$Record));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Patient$Shared$Patient = $elm$core$Basics$identity;
var $author$project$Api$Employer$Patient$Shared$Record = function (id) {
	return function (name) {
		return function (firstName) {
			return function (middleName) {
				return function (lastName) {
					return function (email) {
						return function (dob) {
							return function (sex) {
								return function (gender) {
									return function (genderIdentity) {
										return function (genderOther) {
											return function (pronoun) {
												return function (leadSourceOther) {
													return function (syncToEmr) {
														return function (joinedPracticeDate) {
															return function (usesTobacco) {
																return {acQ: dob, Oo: email, Pu: firstName, PO: gender, PP: genderIdentity, PQ: genderOther, adR: id, Sq: joinedPracticeDate, SA: lastName, SJ: leadSourceOther, TX: middleName, zh: name, Xh: pronoun, ZH: sex, $j: syncToEmr, aaI: usesTobacco};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Patient$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'uses_tobacco',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'joined_practice_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sync_to_emr',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'lead_source_other',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pronoun',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'gender_other',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'gender_identity',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gender',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sex',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'dob',
										$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'email',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'last_name',
												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'middle_name',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'first_name',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'name',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'id',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$Shared$Record)))))))))))))))));
var $author$project$Api$Employer$Patient$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Patient$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$Min$Plan = $elm$core$Basics$identity;
var $author$project$Api$Employer$Plan$Min$Record = F5(
	function (id, name, maximumAge, minimumAge, tobaccoSurchargeType) {
		return {adR: id, Tu: maximumAge, T1: minimumAge, zh: name, $O: tobaccoSurchargeType};
	});
var $author$project$Api$Employer$Plan$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'tobacco_surcharge_type',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'minimum_age',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'maximum_age',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$Plan$Min$Record))))));
var $author$project$Api$Employer$Plan$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Employer$Plan$Min$recordDecoder);
var $author$project$Api$Employer$CompanyAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'registrations',
	$elm$json$Json$Decode$list($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'selected_plan',
			$elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'subscriber',
				$elm$json$Json$Decode$nullable($author$project$Api$Employer$Patient$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'division',
					$elm$json$Json$Decode$nullable($author$project$Api$Employer$EmployeeDivision$All$decoder),
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$One$Record))))));
var $author$project$Api$Employer$CompanyAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$One$CompanyAccount)));
var $author$project$Api$Employer$CompanyAccount$create = F3(
	function (apiClient, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyAccount$companyAccountsPath)));
	});
var $author$project$Api$Provider$Company$Account$create = F4(
	function (apiClient, basePath, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$Account$companyAccountsPath(basePath))));
	});
var $author$project$Api$CompanyAccount$create = F5(
	function (apiClient, session, companyId, jsonBody, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$create,
			apiClient,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Account$create,
			apiClient,
			$author$project$Api$Provider$Company$companyPath(companyId),
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$CompanyRegistration$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyRegistration$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$companyAccountPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Employer$CompanyAccount$companyAccountsPath);
};
var $author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath = function (accountId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['registrations']),
		$author$project$Api$Employer$CompanyAccount$companyAccountPath(accountId));
};
var $author$project$Api$Employer$CompanyRegistration$One$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyRegistration$Shared$CompanyRegistration = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyRegistration$Shared$Record = F8(
	function (id, type_, isSubscriber, externalId, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, membershipEndDate) {
		return {Ok: eligibilityEndDate, Ol: eligibilityStartDate, ade: externalId, adR: id, R8: isSubscriber, TE: membershipEndDate, ahp: terminationRequestedAt, ahI: type_};
	});
var $author$project$Api$Employer$CompanyRegistration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'eligibility_end_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'eligibility_start_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'termination_requested_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'external_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_subscriber',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'type',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Shared$Record)))))))));
var $author$project$Api$Employer$CompanyRegistration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyRegistration$One$Record = function (patient) {
	return {VM: patient};
};
var $author$project$Api$Employer$CompanyRegistration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Employer$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$One$Record));
var $author$project$Api$Employer$CompanyRegistration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$One$CompanyRegistration)));
var $author$project$Api$Employer$CompanyRegistration$create = F4(
	function (apiClient, accountId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath(accountId))));
	});
var $author$project$Api$Provider$Company$Registration$companyRegistrationsPath = F2(
	function (companyId, companyAccountId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['registrations']),
			A2(
				$author$project$Api$Provider$Company$Account$companyAccountPath,
				$author$project$Api$Provider$Company$companyPath(companyId),
				companyAccountId));
	});
var $author$project$Api$Provider$CompanyRegistration$One$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyRegistration$One$Record = function (patient) {
	return {VM: patient};
};
var $author$project$Api$Provider$CompanyRegistration$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$One$Record));
var $author$project$Api$Provider$CompanyRegistration$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyRegistration$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$One$CompanyRegistration)));
var $author$project$Api$Provider$Company$Registration$create = F5(
	function (apiClient, companyId, companyAccountId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$Registration$companyRegistrationsPath, companyId, companyAccountId))));
	});
var $author$project$Api$CompanyRegistration$create = F6(
	function (apiClient, session, companyId, accountId, jsonBody, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyRegistration$create,
			apiClient,
			accountId,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Registration$create,
			apiClient,
			companyId,
			accountId,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Components$Patient$Form$PatientLinked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AffiliateInput$affiliateId = function (_v0) {
	var value = _v0.aaN;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.adR;
		},
		value);
};
var $author$project$Api$Employer$Affiliate$affiliatePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Employer$Affiliate$affiliatesPath);
};
var $author$project$Api$Employer$Affiliates$Patient$create = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'patient_id',
							$elm$json$Json$Encode$string(patientId))
						])),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['patients']),
						$author$project$Api$Employer$Affiliate$affiliatePath(affiliateId)))));
	});
var $author$project$Api$Provider$Affiliates$Patient$create = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'patient_id',
							$elm$json$Json$Encode$string(patientId))
						])),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['patients']),
						$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId)))));
	});
var $author$project$Api$Affiliates$Patient$create = F5(
	function (apiClient, session, affiliateId, patientId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Affiliates$Patient$create, apiClient, affiliateId, patientId, toMsg) : A4($author$project$Api$Provider$Affiliates$Patient$create, apiClient, affiliateId, patientId, toMsg);
	});
var $author$project$Api$Employer$Affiliates$Patient$delete = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['patients', patientId]),
					$author$project$Api$Employer$Affiliate$affiliatePath(affiliateId))));
	});
var $author$project$Api$Provider$Affiliates$Patient$delete = F4(
	function (apiClient, affiliateId, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['patients', patientId]),
					$author$project$Api$Provider$Affiliate$affiliatePath(affiliateId))));
	});
var $author$project$Api$Affiliates$Patient$delete = F5(
	function (apiClient, session, affiliateId, patientId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Affiliates$Patient$delete, apiClient, affiliateId, patientId, toMsg) : A4($author$project$Api$Provider$Affiliates$Patient$delete, apiClient, affiliateId, patientId, toMsg);
	});
var $author$project$Components$Patient$Form$createAffiliation = F5(
	function (authToken, session, patientId, affiliationId, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		return settings.$f ? A2(
			$elm$core$Maybe$withDefault,
			function () {
				if (affiliationId.$ === 1) {
					return {v$: false, EC: $elm$core$Platform$Cmd$none};
				} else {
					var affiliationId_ = affiliationId.a;
					return {
						v$: true,
						EC: A5($author$project$Api$Affiliates$Patient$delete, authToken, session, affiliationId_, patientId, $author$project$Components$Patient$Form$PatientLinked)
					};
				}
			}(),
			A2(
				$elm$core$Maybe$map,
				function (affiliateId) {
					return {
						v$: true,
						EC: A5($author$project$Api$Affiliates$Patient$create, authToken, session, affiliateId, patientId, $author$project$Components$Patient$Form$PatientLinked)
					};
				},
				$author$project$Components$AffiliateInput$affiliateId(
					$author$project$Utils$Form$fields(form).DZ))) : {v$: false, EC: $elm$core$Platform$Cmd$none};
	});
var $author$project$Api$Employer$Patient$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Patient$Min$id = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$id(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$id(patient_);
	}
};
var $author$project$Api$Patient$Min$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Patient$Min$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyRegistration$One$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Api$Provider$CompanyRegistration$One$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Api$CompanyRegistration$One$patient = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Provider(
			$author$project$Api$Provider$CompanyRegistration$One$patient(companyRegistration_));
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Employer(
			$author$project$Api$Employer$CompanyRegistration$One$patient(companyRegistration_));
	}
};
var $author$project$Components$Employee$Form$createEmployeeAffiliation = F4(
	function (authToken, session, registration, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		if (settings.VM.$f) {
			var patientId = $author$project$Api$Patient$Min$id(
				$author$project$Api$CompanyRegistration$One$patient(registration));
			var fields = $author$project$Utils$Form$fields(form);
			return A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Employee$Form$PatientFormMsg,
				A5($author$project$Components$Patient$Form$createAffiliation, authToken, session, patientId, $elm$core$Maybe$Nothing, fields.VM).EC);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$EmployeeDependentTypeInput$account = function (_v0) {
	var dependentOf = _v0.fs;
	return dependentOf;
};
var $author$project$Components$Employee$Form$dependentOf = function (_v0) {
	var form = _v0.b;
	return $author$project$Components$EmployeeDependentTypeInput$account(
		$author$project$Utils$Form$fields(form).ahI);
};
var $author$project$Components$EmployeeDivisionInput$encodeDivision = function (_v0) {
	var division = _v0.NT;
	if (!division.$) {
		var divisionId = division.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'division',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'id',
							$elm$json$Json$Encode$string(divisionId))
						])))
			]);
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2('division', $elm$json$Json$Encode$null)
			]);
	}
};
var $author$project$Components$Employee$Form$encodeAccount = F2(
	function (validFields, _v0) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		return function (encodedFields) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'account',
						$elm$json$Json$Encode$object(encodedFields))
					]));
		}(
			A2(
				$elm$core$List$append,
				$author$project$Components$EmployeeDivisionInput$encodeDivision(fields.NT),
				function () {
					var _v1 = fields.cS.a;
					if (!_v1.$) {
						var date = _v1.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'eligibility_start_date',
								$elm$json$Json$Encode$string(
									$author$project$Utils$Date$toIsoString(date)))
							]);
					} else {
						return _List_Nil;
					}
				}()));
	});
var $author$project$Components$SponsorPlanInput$encode = function (_v0) {
	var value = _v0.aaN;
	if (value.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var companyPlan = value.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Api$Plan$id(
							$author$project$Api$CompanyPlan$plan(companyPlan))))
				]));
	}
};
var $author$project$Components$EmployeeDependentTypeInput$selectedType = function (_v0) {
	var type_ = _v0.ahI;
	return type_;
};
var $author$project$Components$Employee$Form$encodeEnroll = F2(
	function (validFields, _v0) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		var encodedPlan = (fields.iX && ($author$project$Components$EmployeeDependentTypeInput$selectedType(fields.ahI) === 'employee')) ? _List_fromArray(
			[
				_Utils_Tuple2(
				'plan',
				$author$project$Components$SponsorPlanInput$encode(fields.GH))
			]) : _List_Nil;
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'membership_start_date',
					$elm$json$Json$Encode$string(fields.TK)),
				encodedPlan));
	});
var $author$project$Components$Patient$Form$datePattern = $agustinrhcp$elm_mask$Mask$fromString('##/##/####');
var $author$project$Components$AddressInput$encodeWithPrefix = F2(
	function (prefix, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(model.PB);
		return _List_fromArray(
			[
				_Utils_Tuple2(
				prefix + 'city',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.pT)),
				_Utils_Tuple2(
				prefix + 'country',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.pZ)),
				_Utils_Tuple2(
				prefix + 'line1',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.cw)),
				_Utils_Tuple2(
				prefix + 'line2',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.eW)),
				_Utils_Tuple2(
				prefix + 'state',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.sZ)),
				_Utils_Tuple2(
				prefix + 'zip',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.tC))
			]);
	});
var $author$project$Components$AddressInput$encode = $author$project$Components$AddressInput$encodeWithPrefix('address_');
var $author$project$Components$EmergencyContactInput$relationshipToValue = function (rel) {
	switch (rel.$) {
		case 0:
			return 'spouse';
		case 1:
			return 'parent';
		case 2:
			return 'child';
		case 3:
			return 'sibling';
		case 4:
			return 'grandparent';
		case 5:
			return 'guardian';
		default:
			return 'other';
	}
};
var $author$project$Components$EmergencyContactInput$encode = function (_v0) {
	var form = _v0.PB;
	var encodeEmptyAsNull = function (value) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Encode$string,
				$elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)));
	};
	var emergencyContact = $author$project$Utils$Form$fields(form);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'first_name',
				encodeEmptyAsNull(emergencyContact.Pu)),
				_Utils_Tuple2(
				'last_name',
				encodeEmptyAsNull(emergencyContact.SA)),
				_Utils_Tuple2(
				'relationship',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $author$project$Components$EmergencyContactInput$relationshipToValue, $elm$json$Json$Encode$string),
						emergencyContact.X6))),
				_Utils_Tuple2(
				'relationship_other',
				function (rel) {
					if ((!rel.$) && (rel.a.$ === 6)) {
						var other = rel.a.a;
						return $elm$json$Json$Encode$string(other);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}(emergencyContact.X6)),
				_Utils_Tuple2(
				'phone',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2(
						$elm$core$Maybe$map,
						function (phone) {
							return $elm$core$String$isEmpty(phone.Gj) ? $elm$json$Json$Encode$null : $author$project$Api$Common$Phone$Shared$encode(phone);
						},
						A2(
							$elm$core$Maybe$map,
							$author$project$Utils$Phone$toRecord,
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$List$head,
								$author$project$Components$PhoneInput$getPhones(emergencyContact.Wg)))))),
				_Utils_Tuple2(
				'email',
				encodeEmptyAsNull(emergencyContact.Oo))
			]));
};
var $author$project$Components$HealthInsuranceInput$encode = function (_v0) {
	var maybeCarrierAndInsurance = _v0.c;
	if (maybeCarrierAndInsurance.$ === 1) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('group_id', $elm$json$Json$Encode$null),
					_Utils_Tuple2('member_id', $elm$json$Json$Encode$null),
					_Utils_Tuple2('high_deductible', $elm$json$Json$Encode$null),
					_Utils_Tuple2('carrier', $elm$json$Json$Encode$null),
					_Utils_Tuple2('payer_name', $elm$json$Json$Encode$null)
				]));
	} else {
		var _v2 = maybeCarrierAndInsurance.a;
		var insuranceCarrier = _v2.a;
		var record = _v2.b;
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'group_id',
					A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Encode$null,
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.PY))),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'member_id',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.Tz))),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'high_deductible',
							A2(
								$elm$core$Maybe$withDefault,
								$elm$json$Json$Encode$null,
								A2($elm$core$Maybe$map, $elm$json$Json$Encode$bool, record.Qq))),
						function () {
							if (!insuranceCarrier.$) {
								var carrierAlias = insuranceCarrier.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										'carrier',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(carrierAlias.Ew))
												]))),
										_Utils_Tuple2(
										'payer_name',
										$elm$json$Json$Encode$string(carrierAlias.zh))
									]);
							} else {
								var name = insuranceCarrier.a.zh;
								return _List_fromArray(
									[
										_Utils_Tuple2('carrier', $elm$json$Json$Encode$null),
										_Utils_Tuple2(
										'payer_name',
										$elm$json$Json$Encode$string(name))
									]);
							}
						}()))));
	}
};
var $author$project$Components$KnownPracticeInput$encode = function (_v0) {
	var knowPractice = _v0.b;
	if (!knowPractice.$) {
		if (!knowPractice.a.$) {
			var knownPractice_ = knowPractice.a.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(knownPractice_.adR))
					]));
		} else {
			var name = knowPractice.a.a.zh;
			var website = knowPractice.a.a.DO;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'other',
						$elm$json$Json$Encode$string(name)),
						_Utils_Tuple2(
						'website',
						$elm$core$String$isEmpty(website) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(website))
					]));
		}
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Components$LeadSourceInput$encode = function (_v0) {
	var selected = _v0.ag;
	var other = _v0.c2;
	var strSelected = A2($elm$core$Maybe$withDefault, '', selected);
	return ($elm$core$String$length(strSelected) > 0) ? _List_fromArray(
		[
			_Utils_Tuple2(
			'lead_source',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(strSelected))
					]))),
			_Utils_Tuple2(
			'lead_source_other',
			A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, other)))
		]) : _List_fromArray(
		[
			_Utils_Tuple2('lead_source', $elm$json$Json$Encode$null),
			_Utils_Tuple2('lead_source_other', $elm$json$Json$Encode$null)
		]);
};
var $author$project$Components$LocationInput$encode = function (_v0) {
	var value = _v0.aaN;
	if (value.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var location = value.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(location.adR))
				]));
	}
};
var $author$project$Components$NameInput$encodeString = function (string) {
	if (string === '') {
		return $elm$json$Json$Encode$null;
	} else {
		return $elm$json$Json$Encode$string(string);
	}
};
var $author$project$Components$NameInput$encodeWithPrefix = F2(
	function (prefix, _v0) {
		var fields = _v0.c;
		var _v1 = fields;
		var title = _v1.$G;
		var firstName = _v1.Pu;
		var middleName = _v1.TX;
		var lastName = _v1.SA;
		var suffix = _v1._8;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				prefix + 'title',
				$author$project$Components$NameInput$encodeString(title)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					prefix + 'first_name',
					$author$project$Components$NameInput$encodeString(firstName)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						prefix + 'middle_name',
						$author$project$Components$NameInput$encodeString(middleName)),
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							prefix + 'last_name',
							$author$project$Components$NameInput$encodeString(lastName)),
						function () {
							if (!suffix.$) {
								var s = suffix.a;
								return _List_fromArray(
									[
										_Utils_Tuple2(
										prefix + 'suffix',
										$author$project$Components$NameInput$encodeString(s))
									]);
							} else {
								return _List_Nil;
							}
						}()))));
	});
var $author$project$Components$NameInput$encode = $author$project$Components$NameInput$encodeWithPrefix('');
var $author$project$Components$PractitionerInput$encode = function (_v0) {
	var value = _v0.aaN;
	if (value.$ === 1) {
		return $elm$json$Json$Encode$null;
	} else {
		var practitioner = value.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(practitioner.adR))
				]));
	}
};
var $author$project$Components$Patient$Form$encodeBillingAddress = function (maybeBillingAddress) {
	if (!maybeBillingAddress.$) {
		var billingAddress = maybeBillingAddress.a;
		return A2($author$project$Components$AddressInput$encodeWithPrefix, 'billing_address_', billingAddress);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Patient$Form$encodeGender = F2(
	function (maybeGender, genderOther) {
		if (!maybeGender.$) {
			if (maybeGender.a === 3) {
				var _v1 = maybeGender.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'gender',
						$elm$json$Json$Encode$string('other')),
						_Utils_Tuple2(
						'gender_other',
						A2(
							$elm$core$Maybe$withDefault,
							$elm$json$Json$Encode$null,
							A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, genderOther)))
					]);
			} else {
				var rest = maybeGender.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'gender',
						$elm$json$Json$Encode$string(
							$author$project$Api$Gender$toString(rest))),
						_Utils_Tuple2('gender_other', $elm$json$Json$Encode$null)
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Api$GenderIdentity$toString = function (genderIdentity) {
	switch (genderIdentity.$) {
		case 0:
			return 'man';
		case 1:
			return 'woman';
		case 2:
			return 'non-binary';
		case 3:
			return 'trans man';
		case 4:
			return 'trans woman';
		default:
			return 'not listed';
	}
};
var $author$project$Components$Patient$Form$encodeGenderIdentity = function (maybeGenderIdentity) {
	if (maybeGenderIdentity.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2('gender_identity', $elm$json$Json$Encode$null)
			]);
	} else {
		if (maybeGenderIdentity.a.$ === 5) {
			var other = maybeGenderIdentity.a.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'gender_identity',
					$elm$json$Json$Encode$string('not listed')),
					_Utils_Tuple2(
					'gender_other',
					$elm$json$Json$Encode$string(other))
				]);
		} else {
			var genderIdentity = maybeGenderIdentity.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'gender_identity',
					$elm$json$Json$Encode$string(
						$author$project$Api$GenderIdentity$toString(genderIdentity))),
					_Utils_Tuple2('gender_other', $elm$json$Json$Encode$null)
				]);
		}
	}
};
var $author$project$Components$Patient$Form$encodePhones = function (phones) {
	return A2(
		$elm$json$Json$Encode$list,
		A2($elm$core$Basics$composeR, $author$project$Utils$Phone$toRecord, $author$project$Api$Common$Phone$Shared$encode),
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Components$PhoneInput$getPhones(phones)));
};
var $author$project$Api$Pronoun$toString = function (pronoun) {
	switch (pronoun.$) {
		case 0:
			return 'He/Him/His';
		case 1:
			return 'She/Her/Hers';
		case 2:
			return 'They/Them/Theirs';
		default:
			return 'Not Listed';
	}
};
var $author$project$Components$Patient$Form$encodePronoun = function (maybePronoun) {
	if (maybePronoun.$ === 1) {
		return _Utils_Tuple2('pronoun', $elm$json$Json$Encode$null);
	} else {
		if (maybePronoun.a.$ === 3) {
			var other = maybePronoun.a.a;
			return _Utils_Tuple2(
				'pronoun',
				$elm$json$Json$Encode$string(other));
		} else {
			var pronoun = maybePronoun.a;
			return _Utils_Tuple2(
				'pronoun',
				$elm$json$Json$Encode$string(
					$author$project$Api$Pronoun$toString(pronoun)));
		}
	}
};
var $author$project$Components$Patient$Form$encodeSex = function (maybeSex) {
	if (!maybeSex.$) {
		var sex = maybeSex.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'sex',
				$elm$json$Json$Encode$string(
					$author$project$Api$Gender$toString(sex)))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Patient$Form$encodePatient = F2(
	function (validFields, _v0) {
		var settings = _v0.a;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		var encodeMaskedDate = function (stringDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Encode$null,
				$elm$core$Result$toMaybe(
					A2(
						$elm$core$Result$map,
						$author$project$Utils$Date$encode,
						$author$project$Utils$Date$fromUsString(
							A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$Patient$Form$datePattern, stringDate)))));
		};
		var appendIfSetting = F3(
			function (getter, appending, original) {
				return getter(settings) ? A2($elm$core$List$append, appending, original) : original;
			});
		var add = F2(
			function (item, list) {
				return _Utils_ap(
					list,
					_List_fromArray(
						[item]));
			});
		var addIfSetting = F3(
			function (getter, item, list) {
				return getter(settings) ? A2(add, item, list) : list;
			});
		var _v1 = fields;
		var billingAddress = _v1.JZ;
		var usesBillingAddress = _v1.aaC;
		var healthInsurance = _v1.Qj;
		var syncToEmr = _v1.$j;
		var profilePictureUrl = _v1.Xg;
		var profilePicture = function () {
			if (!profilePictureUrl.$) {
				var base64 = profilePictureUrl.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'profile_picture',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var _v2 = fields;
		var genderIdentity = _v2.PP;
		var sex = _v2.ZH;
		var address = _v2.It;
		var ssn = _v2._C;
		var knownPractice = _v2.Ss;
		var tobaccoUse = _v2.oL;
		var practitioner = _v2.afS;
		var location = _v2.aet;
		var _v3 = fields;
		var legalName = _v3.SK;
		var chosenName = _v3.bo;
		var email = _v3.Oo;
		var pronoun = _v3.Xh;
		var phones = _v3.Wi;
		var dateOfBirth = _v3.MR;
		var joinedPractice = _v3.i_;
		var leadSource = _v3.SH;
		var _v4 = fields;
		var preferredLanguage = _v4.WV;
		var emergencyContact = _v4.Oq;
		return function (encodedFields) {
			return _Utils_Tuple2(
				'patient',
				$elm$json$Json$Encode$object(encodedFields));
		}(
			A2(
				add,
				_Utils_Tuple2(
					'emergency_contact',
					$author$project$Components$EmergencyContactInput$encode(emergencyContact)),
				A3(
					addIfSetting,
					function ($) {
						return $.rr;
					},
					_Utils_Tuple2(
						'preferred_language',
						$elm$json$Json$Encode$string(
							$author$project$Language$toValue(preferredLanguage))),
					A2(
						$elm$core$List$append,
						profilePicture,
						A2(
							$elm$core$List$append,
							$author$project$Components$Patient$Form$encodeBillingAddress(billingAddress),
							A2(
								add,
								_Utils_Tuple2(
									'uses_billing_address',
									$elm$json$Json$Encode$bool(usesBillingAddress)),
								A2(
									$elm$core$List$append,
									$author$project$Components$AddressInput$encode(address),
									A3(
										addIfSetting,
										function ($) {
											return $.abL;
										},
										_Utils_Tuple2(
											'sync_to_emr',
											$elm$json$Json$Encode$bool(syncToEmr)),
										A2(
											add,
											_Utils_Tuple2(
												'phones',
												$author$project$Components$Patient$Form$encodePhones(phones)),
											A3(
												appendIfSetting,
												function ($) {
													return $.$1;
												},
												$author$project$Components$Patient$Form$encodeGenderIdentity(genderIdentity),
												A3(
													addIfSetting,
													function ($) {
														return $.$1;
													},
													$author$project$Components$Patient$Form$encodePronoun(pronoun),
													A3(
														appendIfSetting,
														function ($) {
															return $.$1;
														},
														$author$project$Components$Patient$Form$encodeSex(sex),
														A3(
															appendIfSetting,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.$1;
																},
																$elm$core$Basics$not),
															A2($author$project$Components$Patient$Form$encodeGender, fields.PO, fields.PQ),
															A2(
																add,
																_Utils_Tuple2(
																	'health_insurance',
																	$author$project$Components$HealthInsuranceInput$encode(healthInsurance)),
																A3(
																	addIfSetting,
																	function ($) {
																		return $.aeA;
																	},
																	_Utils_Tuple2(
																		'known_practice',
																		$author$project$Components$KnownPracticeInput$encode(knownPractice)),
																	A2(
																		$elm$core$List$append,
																		$author$project$Components$LeadSourceInput$encode(leadSource),
																		A2(
																			add,
																			_Utils_Tuple2(
																				'joined_practice_date',
																				A2(
																					$elm$core$Maybe$withDefault,
																					$elm$json$Json$Encode$null,
																					A2($elm$core$Maybe$map, $author$project$Utils$Date$encode, joinedPractice.a))),
																			A3(
																				addIfSetting,
																				function (_v6) {
																					var hasLocations = _v6.P8;
																					var trackPatientsByLocation = _v6.$$;
																					return hasLocations && trackPatientsByLocation;
																				},
																				_Utils_Tuple2(
																					'location',
																					$author$project$Components$LocationInput$encode(location)),
																				A3(
																					addIfSetting,
																					function ($) {
																						return $.Qe;
																					},
																					_Utils_Tuple2(
																						'practitioner',
																						$author$project$Components$PractitionerInput$encode(practitioner)),
																					A3(
																						addIfSetting,
																						function ($) {
																							return $.ahB;
																						},
																						_Utils_Tuple2(
																							'uses_tobacco',
																							A2(
																								$elm$core$Maybe$withDefault,
																								$elm$json$Json$Encode$null,
																								A2($elm$core$Maybe$map, $elm$json$Json$Encode$bool, tobaccoUse))),
																						A3(
																							addIfSetting,
																							function (_v5) {
																								var ssnEnabled = _v5._D;
																								var userIsAdmin = _v5.DF;
																								var isNew = _v5.iX;
																								return ssnEnabled && (userIsAdmin || isNew);
																							},
																							_Utils_Tuple2(
																								'ssn',
																								$elm$json$Json$Encode$object(
																									_List_fromArray(
																										[
																											_Utils_Tuple2(
																											'number',
																											$elm$json$Json$Encode$string(ssn))
																										]))),
																							A2(
																								add,
																								_Utils_Tuple2(
																									'dob',
																									encodeMaskedDate(dateOfBirth)),
																								A2(
																									add,
																									_Utils_Tuple2(
																										'email',
																										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, email)),
																									A2(
																										$elm$core$List$append,
																										A2(
																											$author$project$Components$NameInput$encodeWithPrefix,
																											'chosen_',
																											A2($elm$core$Maybe$withDefault, $author$project$Components$NameInput$empty, chosenName)),
																										$author$project$Components$NameInput$encode(legalName)))))))))))))))))))))))));
	});
var $author$project$Components$EmployeeDependentTypeInput$encodeType = function (_v0) {
	var type_ = _v0.ahI;
	return _Utils_Tuple2(
		'type',
		$elm$json$Json$Encode$string(type_));
};
var $author$project$Components$EmergencyContactInput$ContactIdentificationValidation = 0;
var $author$project$Components$EmergencyContactInput$EmailValidation = 2;
var $author$project$Components$EmergencyContactInput$PhoneValidation = 1;
var $author$project$Components$EmergencyContactInput$RelationshipOtherValidation = 3;
var $author$project$Components$EmergencyContactInput$formFieldsValidator = function () {
	var validatePhone = function (_v7) {
		var phone = _v7.Wg;
		return $author$project$Components$PhoneInput$hasErrors(phone) ? _List_fromArray(
			[
				_Utils_Tuple2(1, '')
			]) : _List_Nil;
	};
	var validateContact = function (_v6) {
		var firstName = _v6.Pu;
		var lastName = _v6.SA;
		var relationship = _v6.X6;
		var email = _v6.Oo;
		var phone = _v6.Wg;
		var relationshipIsNone = function () {
			if (relationship.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var nameIsEmpty = A2(
			$elm$core$List$all,
			$elm$core$String$isEmpty,
			_List_fromArray(
				[firstName, lastName]));
		var contactIsEmpty = function () {
			var number = A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Utils$Phone$toRecord,
					function ($) {
						return $.Gj;
					}),
				A2(
					$elm$core$Maybe$andThen,
					$elm$core$List$head,
					$author$project$Components$PhoneInput$getPhones(phone)));
			var _v4 = _Utils_Tuple2(number, email);
			if (((!_v4.a.$) && (_v4.a.a === '')) && (_v4.b === '')) {
				return true;
			} else {
				return false;
			}
		}();
		var _v3 = _Utils_Tuple2(nameIsEmpty && relationshipIsNone, contactIsEmpty);
		if (_v3.a) {
			if (_v3.b) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(0, 'Please enter at least one of first name, last name or relationship.')
					]);
			}
		} else {
			if (!_v3.b) {
				return _List_Nil;
			} else {
				return _List_Nil;
			}
		}
	};
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(validateContact),
				$rtfeldman$elm_validate$Validate$fromErrors(validatePhone),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function (_v0) {
					var email = _v0.Oo;
					return $rtfeldman$elm_validate$Validate$isBlank(email) || $rtfeldman$elm_validate$Validate$isValidEmail(email);
				},
				_Utils_Tuple2(2, 'Please enter a valid email.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function (_v1) {
					var relationship = _v1.X6;
					if (((!relationship.$) && (relationship.a.$ === 6)) && (relationship.a.a === '')) {
						return false;
					} else {
						return true;
					}
				},
				_Utils_Tuple2(3, 'Please enter relationship.'))
			]));
}();
var $author$project$Components$EmergencyContactInput$validateForm = function (form) {
	var emergencyContact = $author$project$Utils$Form$fields(form);
	var form_ = A2(
		$author$project$Utils$Form$set,
		_Utils_update(
			emergencyContact,
			{
				Wg: $author$project$Components$PhoneInput$validate(emergencyContact.Wg)
			}),
		form);
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$EmergencyContactInput$formFieldsValidator, form_);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var f = _v1.a;
		return _Utils_Tuple2(f, true);
	} else {
		var f = _v0.a;
		return _Utils_Tuple2(f, false);
	}
};
var $author$project$Components$EmergencyContactInput$validate = function (model) {
	return function (f) {
		return _Utils_update(
			model,
			{PB: f});
	}(
		$author$project$Components$EmergencyContactInput$validateForm(model.PB).a);
};
var $author$project$Components$NameInput$FirstNameValidation = 0;
var $author$project$Components$NameInput$validateFirstName = function (_v0) {
	var firstName = _v0.c.Pu;
	return $author$project$Utils$String$isBlank(firstName) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter first name')
		]) : _List_Nil;
};
var $author$project$Components$NameInput$LastNameValidation = 1;
var $author$project$Components$NameInput$validateLastName = function (_v0) {
	var lastName = _v0.c.SA;
	return $author$project$Utils$String$isBlank(lastName) ? _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please enter last name')
		]) : _List_Nil;
};
var $author$project$Components$NameInput$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$NameInput$validateFirstName),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$NameInput$validateLastName)
		]));
var $author$project$Components$NameInput$validate = function (_v0) {
	var options = _v0.b;
	var fields = _v0.c;
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return A3($author$project$Components$NameInput$Model, errors, options, fields);
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Components$NameInput$validator,
					A3($author$project$Components$NameInput$Model, _List_Nil, options, fields)))));
};
var $author$project$Components$Patient$Form$KnownPracticeValidation = 7;
var $author$project$Components$Patient$Form$LocationValidation = 9;
var $author$project$Components$Patient$Form$PractitionerValidation = 8;
var $author$project$Components$Patient$Form$SSNValidation = 6;
var $author$project$Components$Patient$Form$EmailValidation = 2;
var $author$project$Components$Patient$Form$emailValidator = function (requiresEmail) {
	return A3(
		$author$project$Utils$Validate$ifInvalidEmail,
		{abh: !requiresEmail},
		function ($) {
			return $.Oo;
		},
		_Utils_Tuple2(2, 'Please enter a valid email.'));
};
var $author$project$Components$Patient$Form$ProfilePictureValidation = 11;
var $author$project$Components$Patient$Form$computeMaxPictureBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Patient$Form$profilePictureValidator = A3(
	$author$project$Utils$Validate$ifIntGreaterThan,
	function ($) {
		return $.sg;
	},
	$author$project$Components$Patient$Form$computeMaxPictureBytesSize,
	_Utils_Tuple2(11, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'));
var $author$project$Components$KnownPracticeInput$validate = F2(
	function (getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (model) {
				var _v0 = getter(model);
				if ((!_v0.b.$) && (_v0.b.a.$ === 1)) {
					var name = _v0.b.a.a.zh;
					return $rtfeldman$elm_validate$Validate$isBlank(name);
				} else {
					return false;
				}
			},
			formatter('DPC name cannot be blank'));
	});
var $author$project$Components$LocationInput$validate = F3(
	function (isRequired, getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var value = _v0.aaN;
				var _v1 = _Utils_Tuple2(isRequired, value);
				if (_v1.a && (_v1.b.$ === 1)) {
					var _v2 = _v1.b;
					return false;
				} else {
					return true;
				}
			},
			formatter('Please select a location.'));
	});
var $author$project$Components$PractitionerInput$validate = F3(
	function (isRequired, getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var value = _v0.aaN;
				var _v1 = _Utils_Tuple2(isRequired, value);
				if (_v1.a && (_v1.b.$ === 1)) {
					var _v2 = _v1.b;
					return false;
				} else {
					return true;
				}
			},
			formatter('Please select a practitioner'));
	});
var $author$project$Utils$Validate$alwaysValid = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$SocialSecurityNumberInput$isComplete = function (ssn) {
	return $elm$core$String$length(ssn) === 9;
};
var $author$project$Components$SocialSecurityNumberInput$validate = F3(
	function (isRequired, getter, formatter) {
		var isRequired_ = isRequired ? A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function (model) {
				return getter(model);
			},
			formatter('Please enter SSN.')) : $author$project$Utils$Validate$alwaysValid;
		var containsNineDigits = A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var ssn = getter(model);
				return $elm$core$String$isEmpty(ssn) || $author$project$Components$SocialSecurityNumberInput$isComplete(ssn);
			},
			formatter('SSN must contain 9 digits.'));
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[isRequired_, containsNineDigits]));
	});
var $author$project$Components$Patient$Form$AddressValidation = 4;
var $author$project$Components$Patient$Form$validateAddress = function (_v0) {
	var address = _v0.It;
	return $author$project$Components$AddressInput$isValid(address) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(4, '')
		]);
};
var $author$project$Components$Patient$Form$BillingAddressValidation = 5;
var $author$project$Components$Patient$Form$validateBillingAddress = function (_v0) {
	var billingAddress = _v0.JZ;
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (address) {
				return $author$project$Components$AddressInput$isValid(address) ? _List_Nil : _List_fromArray(
					[
						_Utils_Tuple2(5, '')
					]);
			},
			billingAddress));
};
var $author$project$Components$Patient$Form$ChosenNameValidation = 1;
var $author$project$Components$NameInput$hasErrors = function (_v0) {
	var errors = _v0.a;
	return !$elm$core$List$isEmpty(errors);
};
var $author$project$Components$Patient$Form$validateChosenName = function (_v0) {
	var chosenName = _v0.bo;
	var nameHasErrors = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Components$NameInput$hasErrors, chosenName));
	return nameHasErrors ? _List_fromArray(
		[
			_Utils_Tuple2(1, '')
		]) : _List_Nil;
};
var $author$project$Components$Patient$Form$DateOfBirthValidation = 10;
var $author$project$Components$Patient$Form$validateDateOfBirth = F2(
	function (requiresDOB, _v0) {
		var dateOfBirth = _v0.MR;
		if (!$elm$core$String$length(dateOfBirth)) {
			return requiresDOB ? _List_fromArray(
				[
					_Utils_Tuple2(10, 'Please enter a date of birth.')
				]) : _List_Nil;
		} else {
			var _v1 = $author$project$Utils$Date$fromUsString(
				A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$Patient$Form$datePattern, dateOfBirth));
			if (_v1.$ === 1) {
				return _List_fromArray(
					[
						_Utils_Tuple2(10, '')
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$Patient$Form$EmergencyContactValidation = 12;
var $author$project$Components$EmergencyContactInput$isValid = function (_v0) {
	var form = _v0.PB;
	return $author$project$Components$EmergencyContactInput$validateForm(form).b;
};
var $author$project$Components$Patient$Form$validateEmergencyContact = function (_v0) {
	var emergencyContact = _v0.Oq;
	return $author$project$Components$EmergencyContactInput$isValid(emergencyContact) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(12, '')
		]);
};
var $author$project$Components$Patient$Form$LegalNameValidation = 0;
var $author$project$Components$Patient$Form$validateLegalName = function (_v0) {
	var legalName = _v0.SK;
	return $author$project$Components$NameInput$hasErrors(legalName) ? _List_fromArray(
		[
			_Utils_Tuple2(0, '')
		]) : _List_Nil;
};
var $author$project$Components$Patient$Form$PhonesValidation = 3;
var $author$project$Components$Patient$Form$validatePhones = function (_v0) {
	var phones = _v0.Wi;
	return $author$project$Components$PhoneInput$hasErrors(phones) ? _List_fromArray(
		[
			_Utils_Tuple2(3, '')
		]) : _List_Nil;
};
var $author$project$Components$Patient$Form$validator = function (_v0) {
	var requiresEmail = _v0.ago;
	var requiresDOB = _v0.BT;
	var ssnEnabled = _v0._D;
	var requiresSSN = _v0.Ys;
	var userIsAdmin = _v0.DF;
	var isNew = _v0.iX;
	var requiresPractitioner = _v0.Yr;
	var requiresLocation = _v0.Ym;
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$author$project$Components$Patient$Form$emailValidator(requiresEmail),
				A3(
				$author$project$Components$SocialSecurityNumberInput$validate,
				ssnEnabled && (requiresSSN && (userIsAdmin || isNew)),
				function ($) {
					return $._C;
				},
				function (error) {
					return _Utils_Tuple2(6, error);
				}),
				A2(
				$author$project$Components$KnownPracticeInput$validate,
				function ($) {
					return $.Ss;
				},
				function (error) {
					return _Utils_Tuple2(7, error);
				}),
				A3(
				$author$project$Components$PractitionerInput$validate,
				requiresPractitioner,
				function ($) {
					return $.afS;
				},
				function (error) {
					return _Utils_Tuple2(8, error);
				}),
				A3(
				$author$project$Components$LocationInput$validate,
				requiresLocation,
				function ($) {
					return $.aet;
				},
				function (error) {
					return _Utils_Tuple2(9, error);
				}),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateLegalName),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateChosenName),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validatePhones),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateAddress),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateBillingAddress),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateEmergencyContact),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Patient$Form$validateDateOfBirth(requiresDOB)),
				$author$project$Components$Patient$Form$profilePictureValidator
			]));
};
var $author$project$Components$Patient$Form$validate = function (_v0) {
	var settings = _v0.a;
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$elm$core$Result$mapError,
		$author$project$Components$Patient$Form$PatientForm(settings),
		A2(
			$elm$core$Result$map,
			$elm$core$Tuple$mapFirst(
				$author$project$Components$Patient$Form$PatientForm(settings)),
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$Patient$Form$validator(settings),
				A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{
							It: $author$project$Components$AddressInput$validate(fields.It),
							JZ: A2($elm$core$Maybe$map, $author$project$Components$AddressInput$validate, fields.JZ),
							bo: A2($elm$core$Maybe$map, $author$project$Components$NameInput$validate, fields.bo),
							Oq: $author$project$Components$EmergencyContactInput$validate(fields.Oq),
							SK: $author$project$Components$NameInput$validate(fields.SK),
							Wi: $author$project$Components$PhoneInput$validate(fields.Wi)
						}),
					form))));
};
var $author$project$Components$Employee$Form$encodeRegistration = F2(
	function (validFields, _v0) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
		var add = F2(
			function (item, list) {
				return _Utils_ap(
					list,
					_List_fromArray(
						[item]));
			});
		return function (encodedFields) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'registration',
						$elm$json$Json$Encode$object(encodedFields))
					]));
		}(
			A2(
				$elm$core$List$append,
				function () {
					var _v4 = fields.ade;
					if (!_v4.$) {
						var externalId = _v4.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'external_id',
								$elm$json$Json$Encode$string(externalId))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$append,
					function () {
						var _v3 = fields.cS.a;
						if (!_v3.$) {
							var date = _v3.a;
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'eligibility_start_date',
									$elm$json$Json$Encode$string(
										$author$project$Utils$Date$toIsoString(date)))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					A2(
						add,
						$author$project$Components$EmployeeDependentTypeInput$encodeType(fields.ahI),
						function () {
							var _v1 = $author$project$Components$Patient$Form$validate(fields.VM);
							if (!_v1.$) {
								var _v2 = _v1.a;
								var patientFields = _v2.b;
								return _List_fromArray(
									[
										A2($author$project$Components$Patient$Form$encodePatient, patientFields, fields.VM)
									]);
							} else {
								return _List_Nil;
							}
						}()))));
	});
var $author$project$Api$Employer$CompanyRegistration$companyRegistrationPath = F2(
	function (accountId, registrationId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[registrationId]),
			$author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath(accountId));
	});
var $author$project$Api$Employer$CompanyRegistration$enroll = F5(
	function (apiClient, accountId, registrationId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enroll']),
						A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)))));
	});
var $author$project$Api$Provider$Company$Registration$companyRegistrationPath = F3(
	function (companyId, companyAccountId, registrationId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[registrationId]),
			A2($author$project$Api$Provider$Company$Registration$companyRegistrationsPath, companyId, companyAccountId));
	});
var $author$project$Api$Provider$Company$Registration$enroll = F6(
	function (apiClient, companyId, companyAccountId, registrationId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enroll']),
						A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)))));
	});
var $author$project$Api$CompanyRegistration$enroll = F5(
	function (apiClient, session, _v0, jsonBody, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var registrationId = _v0.nU;
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$CompanyRegistration$enroll,
			apiClient,
			accountId,
			registrationId,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6(
			$author$project$Api$Provider$Company$Registration$enroll,
			apiClient,
			companyId,
			accountId,
			registrationId,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Api$Employer$CompanyAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$CompanyAccount$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyAccount$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$CompanyAccount$All$id = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$id(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$id(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyAccount$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$CompanyAccount$One$id = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$One$id(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$One$id(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$CompanyRegistration$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyRegistration$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$CompanyRegistration$One$id = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$One$id(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$One$id(companyRegistration_);
	}
};
var $author$project$Components$Employee$Form$shouldEnroll = function (_v0) {
	var form = _v0.b;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		$author$project$Utils$Form$fields(form).OC);
};
var $author$project$Api$Employer$CompanyAccount$All$defaultEnrollmentStartDate = function (_v0) {
	var record = _v0.b;
	return record.M7;
};
var $author$project$Api$Provider$CompanyAccount$All$defaultEnrollmentStartDate = function (_v0) {
	var record = _v0.b;
	return record.M7;
};
var $author$project$Api$CompanyAccount$All$defaultEnrollmentStartDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$defaultEnrollmentStartDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$defaultEnrollmentStartDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyAccount$All$invoicedThroughDate = function (_v0) {
	var record = _v0.b;
	return record.Rs;
};
var $author$project$Api$Provider$CompanyAccount$All$invoicedThroughDate = function (_v0) {
	var record = _v0.b;
	return record.Rs;
};
var $author$project$Api$CompanyAccount$All$invoicedThroughDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$invoicedThroughDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$invoicedThroughDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyAccount$All$membershipStartDate = function (_v0) {
	var record = _v0.b;
	return record.TK;
};
var $author$project$Api$Provider$CompanyAccount$All$membershipStartDate = function (_v0) {
	var record = _v0.b;
	return record.TK;
};
var $author$project$Api$CompanyAccount$All$membershipStartDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$membershipStartDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$membershipStartDate(companyAccount_);
	}
};
var $elm_community$maybe_extra$Maybe$Extra$orList = function (maybes) {
	orList:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (maybes.a.$ === 1) {
				var _v1 = maybes.a;
				var rest = maybes.b;
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue orList;
			} else {
				var answer = maybes.a.a;
				return $elm$core$Maybe$Just(answer);
			}
		}
	}
};
var $author$project$Components$Employee$Form$dependentStartDate = function (account) {
	return $elm_community$maybe_extra$Maybe$Extra$orList(
		_List_fromArray(
			[
				$author$project$Api$CompanyAccount$All$defaultEnrollmentStartDate(account),
				$author$project$Api$CompanyAccount$All$invoicedThroughDate(account),
				$author$project$Api$CompanyAccount$All$membershipStartDate(account)
			]));
};
var $author$project$Api$Employer$CompanyAccount$All$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Api$Provider$CompanyAccount$All$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Api$CompanyAccount$All$status = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$status(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$status(companyAccount_);
	}
};
var $author$project$Components$EmployeeDependentTypeInput$AccountSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$None = {$: 2};
var $author$project$Components$EmployeeDependentTypeInput$TypeSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$CompanyAccount$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$CompanyAccount$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyAccount$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$All$CompanyAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyAccount$All$Record = function (registrations) {
	return function (subscriber) {
		return function (division) {
			return function (membershipStartDate) {
				return function (defaultEnrollmentStartDate) {
					return function (invoicedThroughDate) {
						return function (membershipEndDate) {
							return function (status) {
								return function (plan) {
									return function (meta) {
										return {M7: defaultEnrollmentStartDate, NT: division, Rs: invoicedThroughDate, TE: membershipEndDate, TK: membershipStartDate, TU: meta, GH: plan, age: registrations, ag7: status, _3: subscriber};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$CompanyAccount$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyAccount$Meta$Record = F2(
	function (actions, membership) {
		return {tF: actions, ja: membership};
	});
var $author$project$Api$Employer$CompanyAccount$Meta$ActionsRecord = F3(
	function (needsApproval, canEnroll, isEligible) {
		return {Ks: canEnroll, RK: isEligible, Um: needsApproval};
	});
var $author$project$Api$Employer$CompanyAccount$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eligible',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enroll',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'needs_approval',
			$elm$json$Json$Decode$bool,
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$ActionsRecord))));
var $author$project$Api$Employer$CompanyAccount$Meta$MembershipRecord = F3(
	function (billFromDate, billingStartDate, endDate) {
		return {JX: billFromDate, J$: billingStartDate, qs: endDate};
	});
var $author$project$Api$Employer$CompanyAccount$Meta$EndDateRecord = F4(
	function (defaultValue, maxWithoutBilling, min, minWithoutProration) {
		return {Nm: defaultValue, Tt: maxWithoutBilling, TZ: min, T0: minWithoutProration};
	});
var $author$project$Api$Employer$CompanyAccount$Meta$endDateRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'min_without_proration',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'min',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'max_without_billing',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_value',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$EndDateRecord)))));
var $author$project$Api$Employer$CompanyAccount$Meta$membershipRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$author$project$Api$Employer$CompanyAccount$Meta$endDateRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'bill_from_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$MembershipRecord))));
var $author$project$Api$Employer$CompanyAccount$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership',
	$author$project$Api$Employer$CompanyAccount$Meta$membershipRecordDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'actions',
		$author$project$Api$Employer$CompanyAccount$Meta$actionsRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$Record)));
var $author$project$Api$Employer$CompanyAccount$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyAccount$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$Record = F4(
	function (patient, status, membershipStartDate, meta) {
		return {TK: membershipStartDate, TU: meta, VM: patient, ag7: status};
	});
var $author$project$Api$Employer$CompanyRegistration$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyRegistration$Meta$Record = function (actions) {
	return {tF: actions};
};
var $author$project$Api$Employer$CompanyRegistration$Meta$ActionsRecord = F2(
	function (canEnroll, isEligible) {
		return {Ks: canEnroll, RK: isEligible};
	});
var $author$project$Api$Employer$CompanyRegistration$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'eligible',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'enroll',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Meta$ActionsRecord)));
var $author$project$Api$Employer$CompanyRegistration$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Employer$CompanyRegistration$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Meta$Record));
var $author$project$Api$Employer$CompanyRegistration$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Employer$CompanyRegistration$Meta$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patient',
				$author$project$Api$Employer$Patient$Min$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$Record)))));
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyRegistration$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration)));
var $author$project$Api$Employer$CompanyAccount$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Employer$CompanyAccount$Meta$decoder,
	A3(
		$author$project$Api$Expandable$expandable,
		'plan',
		$elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'membership_end_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invoiced_through_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_enrollment_start_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'membership_start_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'division',
								$elm$json$Json$Decode$nullable($author$project$Api$Employer$EmployeeDivision$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'subscriber',
									$elm$json$Json$Decode$nullable($author$project$Api$Employer$Patient$Shared$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'registrations',
										$elm$json$Json$Decode$list($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$decoder),
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$All$Record)))))))))));
var $author$project$Api$Employer$CompanyAccount$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CompanyAccount$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$CompanyAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$All$CompanyAccount)));
var $author$project$Api$Employer$CompanyAccount$expandToString = function (expand) {
	if (expand === 1) {
		return 'plan';
	} else {
		return 'registrations';
	}
};
var $author$project$Api$Employer$CompanyAccount$listDefaults = {Fc: _List_Nil, Fi: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Employer$CompanyAccount$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$CompanyAccount$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var q = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', q)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.adR;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.Fi;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				A2($author$project$Api$Expandable$toParam, $author$project$Api$Employer$CompanyAccount$expandToString, options.Fc),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Employer$CompanyAccount$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$CompanyAccount$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$CompanyAccount$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyAccount$companyAccountsPath)));
	});
var $author$project$Api$Employer$CompanyAccount$Plan = 1;
var $author$project$Api$Employer$CompanyAccount$Registrations = 0;
var $author$project$Api$CompanyAccount$expandToEmployer = function (expand) {
	switch (expand) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just(0);
		default:
			return $elm$core$Maybe$Just(1);
	}
};
var $author$project$Api$CompanyAccount$listDefaults = {Fc: _List_Nil, Fi: $elm$core$Maybe$Nothing, adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$CompanyAccount$optionalsToEmployer = function (optionals) {
	var options = optionals($author$project$Api$CompanyAccount$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				Fc: A2($elm$core$List$filterMap, $author$project$Api$CompanyAccount$expandToEmployer, options.Fc),
				Fi: options.Fi,
				adR: options.adR,
				afy: options.afy,
				af_: options.af_,
				ag1: options.ag1
			});
	};
};
var $author$project$Api$Provider$Company$Account$MembershipPatients = 0;
var $author$project$Api$Provider$Company$Account$Plan = 2;
var $author$project$Api$Provider$Company$Account$Registrations = 1;
var $author$project$Api$CompanyAccount$expandToProvider = function (expand) {
	switch (expand) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Api$CompanyAccount$optionalsToProvider = function (optionals) {
	var options = optionals($author$project$Api$CompanyAccount$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{
				Fc: A2($elm$core$List$map, $author$project$Api$CompanyAccount$expandToProvider, options.Fc),
				Fi: options.Fi,
				adR: options.adR,
				afy: options.afy,
				af_: options.af_,
				ag1: options.ag1
			});
	};
};
var $author$project$Api$CompanyAccount$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$list,
			apiClient,
			$author$project$Api$CompanyAccount$optionalsToEmployer(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CompanyAccount$All$Employer)))) : A4(
			$author$project$Api$Provider$Company$Account$list,
			apiClient,
			$author$project$Api$Provider$Company$companyPath(companyId),
			$author$project$Api$CompanyAccount$optionalsToProvider(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CompanyAccount$All$Provider))));
	});
var $author$project$Components$ResourceFilter$CompanyAccount$list = $author$project$Api$CompanyAccount$list;
var $author$project$Components$ResourceFilter$CompanyAccount$fetchResources = F7(
	function (session, companyId, listOptionals, toMsg, apiClient, pagination, query) {
		return A5(
			$author$project$Components$ResourceFilter$CompanyAccount$list,
			apiClient,
			session,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{afy: pagination, af_: query});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyAccount$retrieveResource = F6(
	function (session, companyId, listOptionals, toMsg, apiClient, id) {
		return A5(
			$author$project$Components$ResourceFilter$CompanyAccount$list,
			apiClient,
			session,
			companyId,
			A2(
				$elm$core$Basics$composeL,
				listOptionals,
				function (d) {
					return _Utils_update(
						d,
						{
							adR: $elm$core$Maybe$Just(id)
						});
				}),
			toMsg);
	});
var $author$project$Components$ResourceFilter$CompanyAccount$selectId = 'accounts';
var $author$project$Api$Employer$Patient$Shared$name = function (_v0) {
	var shared = _v0;
	return shared.zh;
};
var $author$project$Api$Employer$CompanyAccount$All$subscriber = function (_v0) {
	var record = _v0.b;
	return record._3;
};
var $author$project$Api$Provider$CompanyAccount$All$subscriber = function (_v0) {
	var record = _v0.b;
	return record._3;
};
var $author$project$Api$CompanyAccount$All$subscriberName = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$Shared$name,
			$author$project$Api$Provider$CompanyAccount$All$subscriber(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Employer$Patient$Shared$name,
			$author$project$Api$Employer$CompanyAccount$All$subscriber(companyAccount_));
	}
};
var $author$project$Components$ResourceFilter$CompanyAccount$toTitle = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$CompanyAccount$All$subscriberName,
	$elm$core$Maybe$withDefault(''));
var $author$project$Components$ResourceFilter$CompanyAccount$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CompanyAccount$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$CompanyAccount$toValue = $author$project$Api$CompanyAccount$All$id;
var $author$project$Components$ResourceFilter$CompanyAccount$init = F5(
	function (apiClient, session, companyId, listOptionals, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{
				Pi: A3($author$project$Components$ResourceFilter$CompanyAccount$fetchResources, session, companyId, listOptionals),
				adR: $author$project$Components$ResourceFilter$CompanyAccount$selectId,
				gx: 'Company Account',
				st: A3($author$project$Components$ResourceFilter$CompanyAccount$retrieveResource, session, companyId, listOptionals),
				ahw: $author$project$Components$ResourceFilter$CompanyAccount$toLabel,
				ahA: $author$project$Components$ResourceFilter$CompanyAccount$toTitle,
				g0: $author$project$Components$ResourceFilter$CompanyAccount$toValue
			},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$CompanyAccount$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$EmployeeDependentTypeInput$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var type_ = msg.a;
			if (type_ === 'employee') {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fs: $elm$core$Maybe$Nothing, dV: $elm$core$Maybe$Nothing, ahI: type_}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$EmployeeDependentTypeInput$TypeSelected(type_));
			} else {
				var _v1 = A5(
					$author$project$Components$ResourceFilter$CompanyAccount$init,
					apiClient,
					model.ZD,
					$author$project$Api$Company$id(model.ab9),
					$elm$core$Basics$identity,
					function (d) {
						return _Utils_update(
							d,
							{D0: 'Select an Employee', IS: false, aeZ: false});
					});
				var dependentOfFilter = _v1.a;
				var dependentOfFilterCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dV: $elm$core$Maybe$Just(dependentOfFilter),
							ahI: type_
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg, dependentOfFilterCmd),
					$author$project$Components$EmployeeDependentTypeInput$TypeSelected(type_));
			}
		} else {
			var filterMsg = msg.a;
			var _v2 = model.dV;
			if (!_v2.$) {
				var dependentOfFilter_ = _v2.a;
				var newDependentOfResult = A3($author$project$Components$ResourceFilter$CompanyAccount$update, apiClient, filterMsg, dependentOfFilter_);
				var _v3 = function () {
					var _v4 = newDependentOfResult.ac5;
					if (((!_v4.$) && (!_v4.a.$)) && (!_v4.a.a.$)) {
						var dependentOf = _v4.a.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fs: $elm$core$Maybe$Just(dependentOf),
									dV: $elm$core$Maybe$Just(newDependentOfResult.y8)
								}),
							$author$project$Components$EmployeeDependentTypeInput$AccountSelected(dependentOf));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									dV: $elm$core$Maybe$Just(newDependentOfResult.y8)
								}),
							$author$project$Components$EmployeeDependentTypeInput$None);
					}
				}();
				var newModel = _v3.a;
				var event = _v3.b;
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg, newDependentOfResult.EC),
					event);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$EmployeeDependentTypeInput$None);
			}
		}
	});
var $author$project$Components$EmployeeDivisionInput$DivisionSelected = 0;
var $author$project$Components$EmployeeDivisionInput$None = 1;
var $author$project$Components$EmployeeDivisionInput$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var division = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						NT: ($elm$core$String$length(division) > 0) ? $elm$core$Maybe$Just(division) : $elm$core$Maybe$Nothing
					}),
				$elm$core$Platform$Cmd$none,
				0);
		} else {
			var response = msg.a;
			var requiresDivisions = function () {
				if (response.$ === 3) {
					var divisions = response.a;
					return !$elm$core$List$isEmpty(divisions);
				} else {
					return model.agk;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{xp: response, agk: requiresDivisions}),
				$elm$core$Platform$Cmd$none,
				1);
		}
	});
var $author$project$Components$Patient$Form$DateOfBirth = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$Form$ProfilePicture = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Components$Patient$Form$SSN = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Patient$Form$clearFieldErrors = F2(
	function (field, form) {
		switch (field.$) {
			case 18:
				return A2($author$project$Utils$Form$clearGroupErrors, 8, form);
			case 19:
				return A2($author$project$Utils$Form$clearGroupErrors, 9, form);
			default:
				return form;
		}
	});
var $author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber = function (_v0) {
	var record = _v0;
	return record.PF;
};
var $author$project$Components$Patient$Form$sixToEightDigitDate = F2(
	function (currentDate, inputValue) {
		var nextTwoDigitsYear = A2(
			$elm$core$String$right,
			2,
			$elm$core$String$fromInt(
				$justinmimbs$date$Date$year(currentDate) + 1));
		var _v0 = _Utils_Tuple2(
			A2($elm$core$String$left, 4, inputValue),
			A2($elm$core$String$right, 2, inputValue));
		var dayAndMonth = _v0.a;
		var twoDigitYear = _v0.b;
		var newYear = (_Utils_cmp(nextTwoDigitsYear, twoDigitYear) < 0) ? $elm$core$String$concat(
			_List_fromArray(
				['19', twoDigitYear])) : $elm$core$String$concat(
			_List_fromArray(
				['20', twoDigitYear]));
		return $elm$core$String$concat(
			_List_fromArray(
				[dayAndMonth, newYear]));
	});
var $author$project$Components$SocialSecurityNumberInput$ssnPattern = $agustinrhcp$elm_mask$Mask$fromString('###-##-####');
var $author$project$Api$GenderIdentity$NotListed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Pronoun$Other = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$AffiliateInput$initWithResource = F4(
	function (apiClient, session, listOptionals, resource) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$AffiliateInput$setValueWithResource(resource),
			A3($author$project$Components$AffiliateInput$empty, apiClient, session, listOptionals));
	});
var $author$project$Components$Patient$Form$buildAffiliateInput = F5(
	function (apiClient, session, currentResource, _v0, _v1) {
		var locationEnabledSetting = _v0.a;
		var practitionersEnabledSetting = _v0.b;
		var practitionerResource = _v1.a;
		var locationResource = _v1.b;
		var practitionerId = practitionersEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.adR;
			},
			practitionerResource) : $elm$core$Maybe$Nothing;
		var locationId = locationEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.adR;
			},
			locationResource) : $elm$core$Maybe$Nothing;
		var filteredAffiliateOptionals = A2($author$project$Components$Patient$Form$affiliateOptionals, practitionerId, locationId);
		return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, currentResource);
	});
var $author$project$Components$LocationInput$initWithResource = F3(
	function (apiClient, listOptionals, resource) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$LocationInput$setValueWithResource(resource),
			A2($author$project$Components$LocationInput$empty, apiClient, listOptionals));
	});
var $author$project$Components$Patient$Form$locationOptionals = F4(
	function (isEmployeeForm, company, practitioner, affiliate) {
		var signupPageValue = isEmployeeForm ? A2(
			$elm$core$Maybe$map,
			$author$project$Api$SignupPage$Min$id,
			A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
		return function (d) {
			return _Utils_update(
				d,
				{DZ: affiliate, afS: practitioner, Hc: signupPageValue});
		};
	});
var $author$project$Components$Patient$Form$buildLocationInput = F6(
	function (apiClient, isEmployeeForm, company, currentResource, _v0, _v1) {
		var affiliateEnabledSetting = _v0.a;
		var practitionersEnabledSetting = _v0.b;
		var practitionerResource = _v1.a;
		var affiliateResource = _v1.b;
		var practitionerId = practitionersEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.adR;
			},
			practitionerResource) : $elm$core$Maybe$Nothing;
		var affiliateId = affiliateEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.adR;
			},
			affiliateResource) : $elm$core$Maybe$Nothing;
		var filteredLocationOptionals = A4($author$project$Components$Patient$Form$locationOptionals, isEmployeeForm, company, practitionerId, affiliateId);
		return A3($author$project$Components$LocationInput$initWithResource, apiClient, filteredLocationOptionals, currentResource);
	});
var $author$project$Components$PractitionerInput$initWithResource = F3(
	function (apiClient, listOptionals, resource) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$PractitionerInput$setValueWithResource(resource),
			A2($author$project$Components$PractitionerInput$empty, apiClient, listOptionals));
	});
var $author$project$Components$Patient$Form$buildPractitionerInput = F6(
	function (apiClient, isEmployeeForm, company, currentResource, _v0, _v1) {
		var affiliateEnabledSetting = _v0.a;
		var locationEnabledSetting = _v0.b;
		var locationResource = _v1.a;
		var affiliateResource = _v1.b;
		var locationId = locationEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.adR;
			},
			locationResource) : $elm$core$Maybe$Nothing;
		var affiliateId = affiliateEnabledSetting ? A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.adR;
			},
			affiliateResource) : $elm$core$Maybe$Nothing;
		var filteredPractitionerOptionals = A5(
			$author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras,
			isEmployeeForm,
			company,
			locationId,
			affiliateId,
			_List_fromArray(
				[1]));
		return A3($author$project$Components$PractitionerInput$initWithResource, apiClient, filteredPractitionerOptionals, currentResource);
	});
var $author$project$Components$Patient$Form$selectSelectedAffiliation = F5(
	function (apiClient, session, affiliationResource, practitionerResource, locationResource) {
		var filteredAffiliateOptionals = A2(
			$author$project$Components$Patient$Form$affiliateOptionals,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				practitionerResource),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				locationResource));
		return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, affiliationResource);
	});
var $author$project$Components$Patient$Form$handleAffiliateSelect = F8(
	function (apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
		var affiliateEnabledSetting = _v0.a;
		var locationEnabledSetting = _v0.b;
		var practitionersEnabledSetting = _v0.c;
		var affiliate = _v1.a;
		var affiliateCmd = _v1.b;
		var filterPractitionerDropdown = F2(
			function (locationResource, affiliateResource) {
				return A6(
					$author$project$Components$Patient$Form$buildPractitionerInput,
					apiClient,
					isEmployeeForm,
					company,
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(affiliateEnabledSetting, locationEnabledSetting),
					_Utils_Tuple2(locationResource, affiliateResource));
			});
		var filterLocationDropdown = F2(
			function (practitionerResource, affiliateResource) {
				return A6(
					$author$project$Components$Patient$Form$buildLocationInput,
					apiClient,
					isEmployeeForm,
					company,
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(affiliateEnabledSetting, practitionersEnabledSetting),
					_Utils_Tuple2(practitionerResource, affiliateResource));
			});
		_v2$2:
		while (true) {
			if ((!event.$) && (!event.a.$)) {
				switch (event.a.a.$) {
					case 2:
						var _v3 = event.a.a;
						var _v4 = A5(
							$author$project$Components$Patient$Form$buildAffiliateInput,
							apiClient,
							session,
							$elm$core$Maybe$Nothing,
							_Utils_Tuple2(locationEnabledSetting, practitionersEnabledSetting),
							_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
						var initAffiliate = _v4.a;
						var initAffiliateCmd = _v4.b;
						return _Utils_Tuple3(
							A2(filterPractitionerDropdown, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
							A2(filterLocationDropdown, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
							_Utils_Tuple2(initAffiliate, initAffiliateCmd));
					case 0:
						return _Utils_eq(affiliate.aaN, form.DZ.aaN) ? _Utils_Tuple3(
							_Utils_Tuple2(form.afS, $elm$core$Platform$Cmd$none),
							_Utils_Tuple2(form.aet, $elm$core$Platform$Cmd$none),
							_Utils_Tuple2(affiliate, affiliateCmd)) : _Utils_Tuple3(
							A2(filterPractitionerDropdown, form.aet.aaN, affiliate.aaN),
							A2(filterLocationDropdown, form.afS.aaN, affiliate.aaN),
							A5($author$project$Components$Patient$Form$selectSelectedAffiliation, apiClient, session, affiliate.aaN, form.afS.aaN, form.aet.aaN));
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple3(
			_Utils_Tuple2(form.afS, $elm$core$Platform$Cmd$none),
			_Utils_Tuple2(form.aet, $elm$core$Platform$Cmd$none),
			_Utils_Tuple2(affiliate, affiliateCmd));
	});
var $author$project$Components$Patient$Form$selectAffiliationFromOtherResource = F4(
	function (apiClient, session, practitionerResource, locationResource) {
		var filteredAffiliateOptionals = A2(
			$author$project$Components$Patient$Form$affiliateOptionals,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				practitionerResource),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				locationResource));
		var affiliationResource = function () {
			var _v0 = _Utils_Tuple2(practitionerResource, locationResource);
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					return A2(
						$elm$core$Maybe$andThen,
						$elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.IJ;
							},
							practitionerResource));
				} else {
					var _v1 = _v0.b;
					return A2(
						$elm$core$Maybe$andThen,
						$elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.IJ;
							},
							practitionerResource));
				}
			} else {
				if (!_v0.b.$) {
					var _v2 = _v0.a;
					return A2(
						$elm$core$Maybe$andThen,
						$elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.IJ;
							},
							locationResource));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}();
		return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, affiliationResource);
	});
var $author$project$Components$Patient$Form$handleLocationSelect = F8(
	function (apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
		var affiliateEnabledSetting = _v0.a;
		var locationEnabledSetting = _v0.b;
		var hasPractitioners = _v0.c;
		var location = _v1.a;
		var locationCmd = _v1.b;
		var filterPractitionerDropdown = A6(
			$author$project$Components$Patient$Form$buildPractitionerInput,
			apiClient,
			isEmployeeForm,
			company,
			form.afS.aaN,
			_Utils_Tuple2(affiliateEnabledSetting, locationEnabledSetting),
			_Utils_Tuple2(location.aaN, form.DZ.aaN));
		_v2$2:
		while (true) {
			if ((!event.$) && (!event.a.$)) {
				switch (event.a.a.$) {
					case 2:
						var _v3 = event.a.a;
						var filterAffiliateDropdown = A5(
							$author$project$Components$Patient$Form$buildAffiliateInput,
							apiClient,
							session,
							form.DZ.aaN,
							_Utils_Tuple2(locationEnabledSetting, hasPractitioners),
							_Utils_Tuple2(form.afS.aaN, location.aaN));
						var _v4 = A6(
							$author$project$Components$Patient$Form$buildLocationInput,
							apiClient,
							isEmployeeForm,
							company,
							$elm$core$Maybe$Nothing,
							_Utils_Tuple2(affiliateEnabledSetting, hasPractitioners),
							_Utils_Tuple2(form.afS.aaN, form.DZ.aaN));
						var initLocation = _v4.a;
						var initLocationCmd = _v4.b;
						return _Utils_Tuple3(
							filterPractitionerDropdown,
							_Utils_Tuple2(initLocation, initLocationCmd),
							filterAffiliateDropdown);
					case 0:
						return _Utils_eq(location.aaN, form.aet.aaN) ? _Utils_Tuple3(
							_Utils_Tuple2(form.afS, $elm$core$Platform$Cmd$none),
							_Utils_Tuple2(location, locationCmd),
							_Utils_Tuple2(form.DZ, $elm$core$Platform$Cmd$none)) : _Utils_Tuple3(
							filterPractitionerDropdown,
							_Utils_Tuple2(location, locationCmd),
							A4($author$project$Components$Patient$Form$selectAffiliationFromOtherResource, apiClient, session, form.afS.aaN, location.aaN));
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple3(
			_Utils_Tuple2(form.afS, $elm$core$Platform$Cmd$none),
			_Utils_Tuple2(location, locationCmd),
			_Utils_Tuple2(form.DZ, $elm$core$Platform$Cmd$none));
	});
var $author$project$Components$Patient$Form$handlePractitionerSelect = F8(
	function (apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
		var syncByAffiliation = _v0.a;
		var locationEnabledSetting = _v0.b;
		var hasPractitioners = _v0.c;
		var practitioner = _v1.a;
		var practitionerCmd = _v1.b;
		var filterLocationDropDown = A6(
			$author$project$Components$Patient$Form$buildLocationInput,
			apiClient,
			isEmployeeForm,
			company,
			form.aet.aaN,
			_Utils_Tuple2(syncByAffiliation, hasPractitioners),
			_Utils_Tuple2(practitioner.aaN, form.DZ.aaN));
		_v2$2:
		while (true) {
			if ((!event.$) && (!event.a.$)) {
				switch (event.a.a.$) {
					case 2:
						var _v3 = event.a.a;
						var filterAffiliateDropdown = A5(
							$author$project$Components$Patient$Form$buildAffiliateInput,
							apiClient,
							session,
							form.DZ.aaN,
							_Utils_Tuple2(locationEnabledSetting, hasPractitioners),
							_Utils_Tuple2(practitioner.aaN, form.aet.aaN));
						var _v4 = A6(
							$author$project$Components$Patient$Form$buildPractitionerInput,
							apiClient,
							isEmployeeForm,
							company,
							$elm$core$Maybe$Nothing,
							_Utils_Tuple2(syncByAffiliation, locationEnabledSetting),
							_Utils_Tuple2(form.aet.aaN, form.DZ.aaN));
						var initPractitioner = _v4.a;
						var initPractitionerCmd = _v4.b;
						return _Utils_Tuple3(
							_Utils_Tuple2(initPractitioner, initPractitionerCmd),
							filterLocationDropDown,
							filterAffiliateDropdown);
					case 0:
						return _Utils_eq(practitioner.aaN, form.afS.aaN) ? _Utils_Tuple3(
							_Utils_Tuple2(practitioner, practitionerCmd),
							_Utils_Tuple2(form.aet, $elm$core$Platform$Cmd$none),
							_Utils_Tuple2(form.DZ, $elm$core$Platform$Cmd$none)) : _Utils_Tuple3(
							_Utils_Tuple2(practitioner, practitionerCmd),
							filterLocationDropDown,
							A4($author$project$Components$Patient$Form$selectAffiliationFromOtherResource, apiClient, session, practitioner.aaN, form.aet.aaN));
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple3(
			_Utils_Tuple2(practitioner, practitionerCmd),
			_Utils_Tuple2(form.aet, $elm$core$Platform$Cmd$none),
			_Utils_Tuple2(form.DZ, $elm$core$Platform$Cmd$none));
	});
var $author$project$Components$ResourceFilter$Affiliate$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$AffiliateInput$update = F3(
	function (apiClient, msg, input) {
		var filterMsg = msg;
		var _v1 = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, filterMsg, input.Fi);
		var model = _v1.y8;
		var cmd = _v1.EC;
		var event = _v1.ac5;
		return _Utils_Tuple3(
			function () {
				_v2$2:
				while (true) {
					if ((!event.$) && (!event.a.$)) {
						switch (event.a.a.$) {
							case 0:
								var affiliate = event.a.a.a;
								return _Utils_update(
									input,
									{
										Fi: model,
										aaN: $elm$core$Maybe$Just(affiliate)
									});
							case 2:
								var _v3 = event.a.a;
								return _Utils_update(
									input,
									{Fi: model, aaN: $elm$core$Maybe$Nothing});
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_update(
					input,
					{Fi: model});
			}(),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			event);
	});
var $author$project$Components$EmergencyContactInput$fieldChanged = F2(
	function (field, emergencyContact) {
		switch (field.$) {
			case 0:
				var firstName = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{Pu: firstName}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var lastName = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{SA: lastName}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var relationship = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{X6: relationship}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var email = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{Oo: email}),
					$elm$core$Platform$Cmd$none);
			default:
				var phoneMsg = field.a;
				var _v1 = A2($author$project$Components$PhoneInput$update, phoneMsg, emergencyContact.Wg);
				var phone = _v1.a;
				var phoneCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						emergencyContact,
						{Wg: phone}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone),
						phoneCmd));
		}
	});
var $author$project$Components$EmergencyContactInput$update = F2(
	function (msg, model) {
		if (msg.$ === 1) {
			var subMsg = msg.a;
			var _v1 = A2($author$project$Ui$NewDropdown$update, subMsg, model.nV);
			var dropdown = _v1.a;
			var dropdownCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{nV: dropdown}),
				dropdownCmd);
		} else {
			var field = msg.a;
			var _v2 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$EmergencyContactInput$fieldChanged, field, model.PB);
			var newForm = _v2.a;
			var formCmd = _v2.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				formCmd);
		}
	});
var $author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$HealthInsuranceInput$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HealthInsuranceInput$ifElse = F3(
	function (ifVal, elseVal, bool) {
		return bool ? ifVal : elseVal;
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$HealthInsuranceInput$updateRecord = F2(
	function (updateFn, model) {
		var filter = model.a;
		var options = model.b;
		var maybeCarrierAndInsurance = model.c;
		if (!maybeCarrierAndInsurance.$) {
			var _v1 = maybeCarrierAndInsurance.a;
			var carrier = _v1.a;
			var record = _v1.b;
			return A3(
				$author$project$Components$HealthInsuranceInput$Model,
				filter,
				options,
				$elm$core$Maybe$Just(
					_Utils_Tuple2(
						carrier,
						updateFn(record))));
		} else {
			return model;
		}
	});
var $author$project$Components$HealthInsuranceInput$update = F3(
	function (apiClient, msg, model) {
		var filter = model.a;
		var options = model.b;
		var healthInsurance = model.c;
		switch (msg.$) {
			case 0:
				var filterMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$InsuranceCarrierAlias$update, apiClient, filterMsg, filter);
				var event = result.ac5;
				var cmd = result.EC;
				var newFilter = result.y8;
				return _Utils_Tuple2(
					function () {
						if (!event.$) {
							if (!event.a.$) {
								switch (event.a.a.$) {
									case 0:
										var carrierAlias = event.a.a.a;
										var sameAlias = function () {
											if ((!healthInsurance.$) && (!healthInsurance.a.a.$)) {
												var _v3 = healthInsurance.a;
												var alias_ = _v3.a.a;
												return _Utils_eq(alias_.zh, carrierAlias.zh);
											} else {
												return false;
											}
										}();
										return sameAlias ? A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance) : A3(
											$author$project$Components$HealthInsuranceInput$Model,
											newFilter,
											options,
											$elm$core$Maybe$Just(
												_Utils_Tuple2(
													$author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias(carrierAlias),
													{
														PY: A3(
															$author$project$Components$HealthInsuranceInput$ifElse,
															$elm$core$Maybe$Just(''),
															$elm$core$Maybe$Nothing,
															carrierAlias.Eu),
														Qq: $elm$core$Maybe$Nothing,
														Tz: A3(
															$author$project$Components$HealthInsuranceInput$ifElse,
															$elm$core$Maybe$Just(''),
															$elm$core$Maybe$Nothing,
															carrierAlias.Ev),
														VV: $elm$core$Maybe$Nothing
													})));
									case 3:
										var _v4 = event.a.a;
										if ((!healthInsurance.$) && (healthInsurance.a.a.$ === 1)) {
											var _v6 = healthInsurance.a;
											return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance);
										} else {
											return A3(
												$author$project$Components$HealthInsuranceInput$Model,
												newFilter,
												options,
												$elm$core$Maybe$Just(
													_Utils_Tuple2(
														$author$project$Components$HealthInsuranceInput$Other(
															{zh: ''}),
														{
															PY: $elm$core$Maybe$Just(''),
															Qq: $elm$core$Maybe$Nothing,
															Tz: $elm$core$Maybe$Just(''),
															VV: $elm$core$Maybe$Just('')
														})));
										}
									case 2:
										var _v7 = event.a.a;
										return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, $elm$core$Maybe$Nothing);
									default:
										return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, $elm$core$Maybe$Nothing);
								}
							} else {
								var _v8 = event.a;
								return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance);
							}
						} else {
							return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance);
						}
					}(),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, cmd));
			case 1:
				var name = msg.a;
				if ((!healthInsurance.$) && (healthInsurance.a.a.$ === 1)) {
					var _v10 = healthInsurance.a;
					var other = _v10.a.a;
					var record = _v10.b;
					return _Utils_Tuple2(
						A3(
							$author$project$Components$HealthInsuranceInput$Model,
							filter,
							options,
							$elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Components$HealthInsuranceInput$Other(
										_Utils_update(
											other,
											{zh: name})),
									record))),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var memberId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$HealthInsuranceInput$updateRecord,
						function (record) {
							return _Utils_update(
								record,
								{
									Tz: $elm$core$Maybe$Just(memberId)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			case 4:
				var groupId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$HealthInsuranceInput$updateRecord,
						function (record) {
							return _Utils_update(
								record,
								{
									PY: $elm$core$Maybe$Just(groupId)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
			default:
				var highDeductible = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Components$HealthInsuranceInput$updateRecord,
						function (record) {
							return _Utils_update(
								record,
								{
									Qq: $elm$core$Maybe$Just(highDeductible)
								});
						},
						model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$KnownPracticeInput$KnownPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$KnownPracticeInput$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$KnownPractice$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$KnownPracticeInput$update = F3(
	function (apiClient, msg, _v0) {
		var filter = _v0.a;
		var knownPractice = _v0.b;
		switch (msg.$) {
			case 0:
				var filterMsg = msg.a;
				var _v2 = A3($author$project$Components$ResourceFilter$KnownPractice$update, apiClient, filterMsg, filter);
				var model = _v2.y8;
				var event = _v2.ac5;
				var cmd = _v2.EC;
				return _Utils_Tuple2(
					function () {
						_v3$3:
						while (true) {
							if (!event.$) {
								if (!event.a.$) {
									switch (event.a.a.$) {
										case 0:
											var knownPractice_ = event.a.a.a;
											return A2(
												$author$project$Components$KnownPracticeInput$Model,
												model,
												$elm$core$Maybe$Just(
													$author$project$Components$KnownPracticeInput$KnownPractice(knownPractice_)));
										case 3:
											var _v4 = event.a.a;
											return A2(
												$author$project$Components$KnownPracticeInput$Model,
												model,
												$elm$core$Maybe$Just(
													$author$project$Components$KnownPracticeInput$Other(
														{zh: '', DO: ''})));
										default:
											break _v3$3;
									}
								} else {
									break _v3$3;
								}
							} else {
								return A2($author$project$Components$KnownPracticeInput$Model, model, knownPractice);
							}
						}
						return A2($author$project$Components$KnownPracticeInput$Model, model, $elm$core$Maybe$Nothing);
					}(),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, cmd));
			case 1:
				var name = msg.a;
				if ((!knownPractice.$) && (knownPractice.a.$ === 1)) {
					var other = knownPractice.a.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$KnownPracticeInput$Model,
							filter,
							$elm$core$Maybe$Just(
								$author$project$Components$KnownPracticeInput$Other(
									_Utils_update(
										other,
										{zh: name})))),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$KnownPracticeInput$Model, filter, knownPractice),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var website = msg.a;
				if ((!knownPractice.$) && (knownPractice.a.$ === 1)) {
					var other = knownPractice.a.a;
					return _Utils_Tuple2(
						A2(
							$author$project$Components$KnownPracticeInput$Model,
							filter,
							$elm$core$Maybe$Just(
								$author$project$Components$KnownPracticeInput$Other(
									_Utils_update(
										other,
										{DO: website})))),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						A2($author$project$Components$KnownPracticeInput$Model, filter, knownPractice),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Components$LeadSourceInput$isOther = function (leadSource) {
	return $author$project$Api$Provider$LeadSource$All$name(leadSource) === 'Other';
};
var $author$project$Components$LeadSourceInput$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, model.mQ);
			var _v1 = function () {
				var _v2 = leadSourceResourceResult.ac5;
				_v2$2:
				while (true) {
					if ((!_v2.$) && (!_v2.a.$)) {
						switch (_v2.a.a.$) {
							case 0:
								var leadSource = _v2.a.a.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$LeadSource$All$id(leadSource)),
									function () {
										var _v3 = _Utils_Tuple2(
											$author$project$Components$LeadSourceInput$isOther(leadSource),
											model.c2);
										if (_v3.a) {
											if (!_v3.b.$) {
												return model.c2;
											} else {
												var _v4 = _v3.b;
												return $elm$core$Maybe$Just('');
											}
										} else {
											return $elm$core$Maybe$Nothing;
										}
									}());
							case 2:
								var _v5 = _v2.a.a;
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_Tuple2(model.ag, model.c2);
			}();
			var selected = _v1.a;
			var other = _v1.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{mQ: leadSourceResourceResult.y8, c2: other, ag: selected}),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceResult.EC),
				leadSourceResourceResult.as);
		} else {
			var other = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						c2: $elm$core$Maybe$Just(other)
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Components$LocationInput$update = F3(
	function (apiClient, msg, input) {
		var filterMsg = msg;
		var _v1 = A3($author$project$Components$ResourceFilter$Location$update, apiClient, filterMsg, input.Fi);
		var model = _v1.y8;
		var cmd = _v1.EC;
		var event = _v1.ac5;
		return _Utils_Tuple3(
			function () {
				_v2$2:
				while (true) {
					if ((!event.$) && (!event.a.$)) {
						switch (event.a.a.$) {
							case 0:
								var location = event.a.a.a;
								return _Utils_update(
									input,
									{
										Fi: model,
										aaN: $elm$core$Maybe$Just(location)
									});
							case 2:
								var _v3 = event.a.a;
								return _Utils_update(
									input,
									{Fi: model, aaN: $elm$core$Maybe$Nothing});
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_update(
					input,
					{Fi: model});
			}(),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			event);
	});
var $author$project$Components$NameInput$updateField = F2(
	function (field, _v0) {
		var errors = _v0.a;
		var options = _v0.b;
		var fields = _v0.c;
		return A3(
			$author$project$Components$NameInput$Model,
			errors,
			options,
			function () {
				switch (field.$) {
					case 0:
						var title = field.a;
						return _Utils_update(
							fields,
							{$G: title});
					case 1:
						var firstName = field.a;
						return _Utils_update(
							fields,
							{Pu: firstName});
					case 2:
						var middleName = field.a;
						return _Utils_update(
							fields,
							{TX: middleName});
					case 3:
						var lastName = field.a;
						return _Utils_update(
							fields,
							{SA: lastName});
					default:
						var suffix = field.a;
						return _Utils_update(
							fields,
							{_8: suffix});
				}
			}());
	});
var $author$project$Components$NameInput$update = F2(
	function (msg, model) {
		var field = msg;
		return A2($author$project$Components$NameInput$updateField, field, model);
	});
var $author$project$Components$PractitionerInput$update = F3(
	function (apiClient, msg, input) {
		var filterMsg = msg;
		var _v1 = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, filterMsg, input.Fi);
		var model = _v1.y8;
		var cmd = _v1.EC;
		var event = _v1.ac5;
		return _Utils_Tuple3(
			function () {
				_v2$2:
				while (true) {
					if ((!event.$) && (!event.a.$)) {
						switch (event.a.a.$) {
							case 0:
								var practitioner = event.a.a.a;
								return _Utils_update(
									input,
									{
										Fi: model,
										aaN: $elm$core$Maybe$Just(practitioner)
									});
							case 2:
								var _v3 = event.a.a;
								return _Utils_update(
									input,
									{Fi: model, aaN: $elm$core$Maybe$Nothing});
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_update(
					input,
					{Fi: model});
			}(),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			event);
	});
var $author$project$Components$Patient$Form$updateField = F6(
	function (apiClient, session, company, settings, field, form) {
		switch (field.$) {
			case 0:
				var nameInputMsg = field.a;
				var newName = A2($author$project$Components$NameInput$update, nameInputMsg, form.SK);
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{SK: newName}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var nameInputMsg = field.a;
				var _v1 = form.bo;
				if (!_v1.$) {
					var chosenName = _v1.a;
					var newName = A2($author$project$Components$NameInput$update, nameInputMsg, chosenName);
					return _Utils_Tuple3(
						_Utils_update(
							form,
							{
								bo: $elm$core$Maybe$Just(newName)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var gender = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							ZH: $elm$core$Maybe$Just(gender)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var gender = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							PO: $elm$core$Maybe$Just(gender)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var genderOther = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							PQ: $elm$core$Maybe$Just(genderOther)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var dob = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{MR: dob}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var email = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Oo: email}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var genderIdentity = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{PP: genderIdentity}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var other = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							PP: $elm$core$Maybe$Just(
								$author$project$Api$GenderIdentity$NotListed(other))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var pronoun = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Xh: pronoun}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var other = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							Xh: $elm$core$Maybe$Just(
								$author$project$Api$Pronoun$Other(other))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var phoneMsg = field.a;
				var _v2 = A2($author$project$Components$PhoneInput$update, phoneMsg, form.Wi);
				var updatedPhones = _v2.a;
				var phoneCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Wi: updatedPhones}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones),
						phoneCmd),
					_List_Nil);
			case 12:
				var addressMsg = field.a;
				var _v3 = A2($author$project$Components$AddressInput$update, addressMsg, form.It);
				var address = _v3.a;
				var addressCmd = _v3.b;
				var outMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{It: address}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
						addressCmd),
					outMsgs);
			case 13:
				var usesBillingAddress = field.a;
				if (usesBillingAddress) {
					var _v4 = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$AddressInput$init('patient-billing-address'),
						A2(
							$elm$core$Maybe$map,
							function (address_) {
								return _Utils_Tuple2(address_, $elm$core$Platform$Cmd$none);
							},
							form.JZ));
					var address = _v4.a;
					var addressCmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							form,
							{
								JZ: $elm$core$Maybe$Just(address),
								aaC: usesBillingAddress
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
							addressCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							form,
							{aaC: usesBillingAddress}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 14:
				var addressMsg = field.a;
				var _v5 = form.JZ;
				if (_v5.$ === 1) {
					return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var billingAddress = _v5.a;
					var _v6 = A2($author$project$Components$AddressInput$update, addressMsg, billingAddress);
					var address = _v6.a;
					var addressCmd = _v6.b;
					var outMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							form,
							{
								JZ: $elm$core$Maybe$Just(address)
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
							addressCmd),
						outMsgs);
				}
			case 15:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{_C: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var msg = field.a;
				var _v7 = A3($author$project$Components$KnownPracticeInput$update, apiClient, msg, form.Ss);
				var knownPractice = _v7.a;
				var knownPracticeCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Ss: knownPractice}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
						knownPracticeCmd),
					_List_Nil);
			case 17:
				var tobaccoUse = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{oL: tobaccoUse}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var msg = field.a;
				var _v8 = A3($author$project$Components$PractitionerInput$update, apiClient, msg, form.afS);
				var selectedPractitioner = _v8.a;
				var selectedPractitionerCmd = _v8.b;
				var event = _v8.c;
				var _v9 = function () {
					var locationEnabledSetting = settings.P8 && settings.$$;
					return A8(
						$author$project$Components$Patient$Form$handlePractitionerSelect,
						apiClient,
						session,
						company,
						form,
						event,
						_Utils_Tuple3(settings.$f, locationEnabledSetting, settings.Qe),
						settings.q3,
						_Utils_Tuple2(selectedPractitioner, selectedPractitionerCmd));
				}();
				var _v10 = _v9.a;
				var practitioner = _v10.a;
				var practitionerCmd = _v10.b;
				var _v11 = _v9.b;
				var location = _v11.a;
				var locationCmd = _v11.b;
				var _v12 = _v9.c;
				var affiliate = _v12.a;
				var affiliateCmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{DZ: affiliate, aet: location, afS: practitioner}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
								practitionerCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
								locationCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
								affiliateCmd)
							])),
					_List_Nil);
			case 19:
				var msg = field.a;
				var _v13 = A3($author$project$Components$LocationInput$update, apiClient, msg, form.aet);
				var selectedLocation = _v13.a;
				var selectedLocationCmd = _v13.b;
				var event = _v13.c;
				var _v14 = function () {
					var locationEnabledSetting = settings.P8 && settings.$$;
					return A8(
						$author$project$Components$Patient$Form$handleLocationSelect,
						apiClient,
						session,
						company,
						form,
						event,
						_Utils_Tuple3(settings.$f, locationEnabledSetting, settings.Qe),
						settings.q3,
						_Utils_Tuple2(selectedLocation, selectedLocationCmd));
				}();
				var _v15 = _v14.a;
				var practitioner = _v15.a;
				var practitionerCmd = _v15.b;
				var _v16 = _v14.b;
				var location = _v16.a;
				var locationCmd = _v16.b;
				var _v17 = _v14.c;
				var affiliate = _v17.a;
				var affiliateCmd = _v17.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{DZ: affiliate, aet: location, afS: practitioner}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
								practitionerCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
								locationCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
								affiliateCmd)
							])),
					_List_Nil);
			case 24:
				var msg = field.a;
				var _v18 = A3($author$project$Components$AffiliateInput$update, apiClient, msg, form.DZ);
				var selectedAffiliate = _v18.a;
				var selectedAffiliateCmd = _v18.b;
				var event = _v18.c;
				var _v19 = function () {
					var locationEnabledSetting = settings.P8 && settings.$$;
					return A8(
						$author$project$Components$Patient$Form$handleAffiliateSelect,
						apiClient,
						session,
						company,
						form,
						event,
						_Utils_Tuple3(settings.$f, locationEnabledSetting, settings.Qe),
						settings.q3,
						_Utils_Tuple2(selectedAffiliate, selectedAffiliateCmd));
				}();
				var _v20 = _v19.a;
				var practitioner = _v20.a;
				var practitionerCmd = _v20.b;
				var _v21 = _v19.b;
				var location = _v21.a;
				var locationCmd = _v21.b;
				var _v22 = _v19.c;
				var affiliate = _v22.a;
				var affiliateCmd = _v22.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{DZ: affiliate, aet: location, afS: practitioner}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
								affiliateCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
								practitionerCmd),
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
								locationCmd)
							])),
					_List_Nil);
			case 20:
				var dateInputMsg = field.a;
				var _v23 = form.i_;
				var prevValue = _v23.a;
				var prevInput = _v23.b;
				var _v24 = A2($author$project$Components$DateInput$update, dateInputMsg, prevInput);
				var dateInput = _v24.a;
				var dateInputCmd = _v24.b;
				var event = _v24.c;
				var newValue = function () {
					if (event.$ === 1) {
						var date = event.a;
						return date;
					} else {
						return prevValue;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							i_: _Utils_Tuple2(newValue, dateInput)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice),
						dateInputCmd),
					_List_Nil);
			case 21:
				var msg = field.a;
				var _v26 = A3($author$project$Components$LeadSourceInput$update, apiClient, msg, form.SH);
				var leadSource = _v26.a;
				var leadSourceCmd = _v26.b;
				var leadSourceOutMsgs = _v26.c;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{SH: leadSource}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
						leadSourceCmd),
					leadSourceOutMsgs);
			case 22:
				var msg = field.a;
				var _v27 = A3($author$project$Components$HealthInsuranceInput$update, apiClient, msg, form.Qj);
				var healthInsurance = _v27.a;
				var healthInsuranceCmd = _v27.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Qj: healthInsurance}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
						healthInsuranceCmd),
					_List_Nil);
			case 23:
				var sync = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{$j: sync}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 25:
				var _int = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							p7: $elm$core$Maybe$Just(string),
							sg: _int,
							Xg: $elm$core$Maybe$Just(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 26:
				var lang = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{WV: lang}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var emergencyContactMsg = field.a;
				var _v28 = A2($author$project$Components$EmergencyContactInput$update, emergencyContactMsg, form.Oq);
				var emergencyContact = _v28.a;
				var emergencyContactCmd = _v28.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{Oq: emergencyContact}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$EmergencyContact, $author$project$Components$Patient$Form$FieldUpdated),
						emergencyContactCmd),
					_List_Nil);
		}
	});
var $author$project$Utils$Form$updateWithCmdAndOutMsgs = F3(
	function (updater, field_, _v0) {
		var originalFields = _v0.a;
		var validated_ = _v0.b;
		var fields_ = _v0.c;
		var errors_ = _v0.d;
		var _v1 = A2(updater, field_, fields_);
		var updated = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_),
			cmd,
			outMsgs);
	});
var $author$project$Components$Patient$Form$update = F5(
	function (apiClient, session, company, msg, model) {
		var settings = model.a;
		var form = model.b;
		switch (msg.$) {
			case 1:
				var enable = msg.a;
				var fields = $author$project$Utils$Form$fields(form);
				var newFields = _Utils_update(
					fields,
					{
						bo: enable ? $elm$core$Maybe$Just($author$project$Components$NameInput$empty) : $elm$core$Maybe$Nothing
					});
				return _Utils_Tuple3(
					A2(
						$author$project$Components$Patient$Form$PatientForm,
						settings,
						A2($author$project$Utils$Form$set, newFields, form)),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var ssn = response.a;
					var ssnString = A2(
						$agustinrhcp$elm_mask$Mask$unMask,
						$author$project$Components$SocialSecurityNumberInput$ssnPattern,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber(ssn)));
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Components$Patient$Form$PatientForm(settings),
						A2(
							$author$project$Utils$Tuple3$mapFirst,
							$author$project$Components$Patient$Form$clearFieldErrors(
								$author$project$Components$Patient$Form$SSN(ssnString)),
							A3(
								$author$project$Utils$Form$updateWithCmdAndOutMsgs,
								A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings),
								$author$project$Components$Patient$Form$SSN(ssnString),
								form)));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 0:
				var field = msg.a;
				return A2(
					$author$project$Utils$Tuple3$mapFirst,
					$author$project$Components$Patient$Form$PatientForm(settings),
					A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Components$Patient$Form$clearFieldErrors(field),
						A3(
							$author$project$Utils$Form$updateWithCmdAndOutMsgs,
							A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings),
							field,
							form)));
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 4:
				var inputValue = $author$project$Utils$Form$fields(form).MR;
				var newValue = ($elm$core$String$length(inputValue) === 6) ? A2($author$project$Components$Patient$Form$sixToEightDigitDate, settings.cO, inputValue) : inputValue;
				return A2(
					$author$project$Utils$Tuple3$mapFirst,
					$author$project$Components$Patient$Form$PatientForm(settings),
					A3(
						$author$project$Utils$Form$updateWithCmdAndOutMsgs,
						A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings),
						$author$project$Components$Patient$Form$DateOfBirth(newValue),
						form));
			default:
				var pictures = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var task = _v2.a;
							var size = _v2.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Patient$Form$FieldUpdated,
									$author$project$Components$Patient$Form$ProfilePicture(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (picture) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(picture),
									$elm$file$File$size(picture));
							},
							$elm$core$List$head(pictures))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Components$SponsorPlanInput$update = F3(
	function (apiClient, msg, input) {
		var filterMsg = msg;
		var _v1 = A3($author$project$Components$ResourceFilter$CompanyPlan$update, apiClient, filterMsg, input.Fi);
		var model = _v1.y8;
		var cmd = _v1.EC;
		var event = _v1.ac5;
		return _Utils_Tuple3(
			function () {
				_v2$2:
				while (true) {
					if ((!event.$) && (!event.a.$)) {
						switch (event.a.a.$) {
							case 0:
								var companyPlan = event.a.a.a;
								return _Utils_update(
									input,
									{
										Fi: model,
										aaN: $elm$core$Maybe$Just(companyPlan)
									});
							case 2:
								var _v3 = event.a.a;
								return _Utils_update(
									input,
									{Fi: model, aaN: $elm$core$Maybe$Nothing});
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return _Utils_update(
					input,
					{Fi: model});
			}(),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			event);
	});
var $author$project$Components$Employee$Form$updateField = F6(
	function (apiClient, session, company, settings, field, form) {
		switch (field.$) {
			case 0:
				var typeMsg = field.a;
				var _v1 = A3($author$project$Components$EmployeeDependentTypeInput$update, apiClient, typeMsg, form.ahI);
				var newTypeInput = _v1.a;
				var newTypeInputCmd = _v1.b;
				var newTypeEvent = _v1.c;
				var _v2 = function () {
					switch (newTypeEvent.$) {
						case 1:
							var account = newTypeEvent.a;
							return _Utils_Tuple2(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Utils$Date$toIsoString,
										$author$project$Components$Employee$Form$dependentStartDate(account))),
								($author$project$Api$CompanyAccount$All$status(account) === 'enrolled') ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing);
						case 0:
							var type_ = newTypeEvent.a;
							return (type_ === 'employee') ? _Utils_Tuple2(
								$author$project$Components$Employee$Form$nextFirstOfMonth(settings.VM.cO),
								$elm$core$Maybe$Just(true)) : _Utils_Tuple2('', $elm$core$Maybe$Nothing);
						default:
							return _Utils_Tuple2(form.TK, form.OC);
					}
				}();
				var membershipStartDate = _v2.a;
				var enroll = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{OC: enroll, TK: membershipStartDate, ahI: newTypeInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
						newTypeInputCmd),
					_List_Nil);
			case 1:
				var patientFormMsg = field.a;
				var _v4 = A5($author$project$Components$Patient$Form$update, apiClient, session, company, patientFormMsg, form.VM);
				var newPatientForm = _v4.a;
				var newPatientFormCmd = _v4.b;
				var newPatientFormOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{VM: newPatientForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, newPatientFormCmd),
					newPatientFormOutMsgs);
			case 2:
				var sponsorPlanMsg = field.a;
				var _v5 = A3($author$project$Components$SponsorPlanInput$update, apiClient, sponsorPlanMsg, form.GH);
				var newPlanInput = _v5.a;
				var newPlanInputCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{GH: newPlanInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
						newPlanInputCmd),
					_List_Nil);
			case 3:
				var startDate = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{TK: startDate}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var dateInputMsg = field.a;
				var _v6 = form.cS;
				var prevValue = _v6.a;
				var prevInput = _v6.b;
				var _v7 = A2($author$project$Components$DateInput$update, dateInputMsg, prevInput);
				var dateInput = _v7.a;
				var dateInputCmd = _v7.b;
				var event = _v7.c;
				var newValue = function () {
					if (event.$ === 1) {
						var date = event.a;
						return date;
					} else {
						return prevValue;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							cS: _Utils_Tuple2(newValue, dateInput)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate),
						dateInputCmd),
					_List_Nil);
			case 5:
				var maybeBool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{OC: maybeBool}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var externalId = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{
							ade: $elm$core$Maybe$Just(externalId)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var divisionMsg = field.a;
				var _v9 = A2($author$project$Components$EmployeeDivisionInput$update, divisionMsg, form.NT);
				var divisionInput = _v9.a;
				var divisionInputCmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						form,
						{NT: divisionInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division),
						divisionInputCmd),
					_List_Nil);
		}
	});
var $author$project$Components$Employee$Form$update = F5(
	function (apiClient, session, company, msg, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		if (!msg.$) {
			var subMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$mapFirst,
				$author$project$Components$Employee$Form$EmployeeForm(settings),
				A3(
					$author$project$Utils$Form$updateWithCmdAndOutMsgs,
					A4($author$project$Components$Employee$Form$updateField, apiClient, session, company, settings),
					$author$project$Components$Employee$Form$Patient(subMsg),
					form));
		} else {
			var field = msg.a;
			return A2(
				$author$project$Utils$Tuple3$mapFirst,
				$author$project$Components$Employee$Form$EmployeeForm(settings),
				A3(
					$author$project$Utils$Form$updateWithCmdAndOutMsgs,
					A4($author$project$Components$Employee$Form$updateField, apiClient, session, company, settings),
					field,
					form));
		}
	});
var $author$project$Components$Employee$Form$EmployeeDivisionValidation = 4;
var $author$project$Components$Employee$Form$PlanFieldValidation = 2;
var $author$project$Components$Employee$Form$TypeFieldValidation = 0;
var $author$project$Components$EmployeeDependentTypeInput$validate = F2(
	function (getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var type_ = _v0.ahI;
				var dependentOf = _v0.fs;
				var _v1 = _Utils_Tuple2(type_, dependentOf);
				_v1$2:
				while (true) {
					if (_v1.b.$ === 1) {
						switch (_v1.a) {
							case 'spouse':
								var _v2 = _v1.b;
								return false;
							case 'child':
								var _v3 = _v1.b;
								return false;
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return true;
			},
			formatter('Please select an employee'));
	});
var $author$project$Components$EmployeeDivisionInput$validate = F2(
	function (getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var required = _v0.agk;
				var division = _v0.NT;
				var _v1 = _Utils_Tuple2(required, division);
				if (_v1.a && (_v1.b.$ === 1)) {
					var _v2 = _v1.b;
					return false;
				} else {
					return true;
				}
			},
			formatter('Please select an employee division.'));
	});
var $author$project$Components$SponsorPlanInput$validate = F2(
	function (getter, formatter) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (model) {
				var _v0 = getter(model);
				var required = _v0.agk;
				var value = _v0.aaN;
				var _v1 = _Utils_Tuple2(required, value);
				if (_v1.a && (_v1.b.$ === 1)) {
					var _v2 = _v1.b;
					return false;
				} else {
					return true;
				}
			},
			formatter('Please select a plan.'));
	});
var $author$project$Components$Employee$Form$EligibilityDateValidation = 3;
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Components$Employee$Form$validateEligibilityDate = F2(
	function (isNew, _v0) {
		var eligibilityDate = _v0.cS;
		var hasDate = $elm_community$maybe_extra$Maybe$Extra$isJust(eligibilityDate.a);
		return hasDate ? _List_Nil : (isNew ? _List_fromArray(
			[
				_Utils_Tuple2(3, 'Please select an eligibility date.')
			]) : _List_Nil);
	});
var $author$project$Components$Employee$Form$PatientFieldValidation = 1;
var $author$project$Components$Patient$Form$hasErrors = function (_v0) {
	var form = _v0.b;
	return $author$project$Utils$Form$hasAnyValidationError(form);
};
var $author$project$Components$Employee$Form$validatePatientFields = function (_v0) {
	var patient = _v0.VM;
	var hasErrors = $author$project$Components$Patient$Form$hasErrors(patient);
	return hasErrors ? _List_fromArray(
		[
			_Utils_Tuple2(1, '')
		]) : _List_Nil;
};
var $author$project$Components$Employee$Form$validator = F3(
	function (requiresDivisions, isNew, type_) {
		var typeValidator = isNew ? _List_fromArray(
			[
				A2(
				$author$project$Components$EmployeeDependentTypeInput$validate,
				function ($) {
					return $.ahI;
				},
				function (error) {
					return _Utils_Tuple2(0, error);
				})
			]) : _List_Nil;
		var planValidator = (isNew && (type_ === 'employee')) ? _List_fromArray(
			[
				A2(
				$author$project$Components$SponsorPlanInput$validate,
				function ($) {
					return $.GH;
				},
				function (error) {
					return _Utils_Tuple2(2, error);
				})
			]) : _List_Nil;
		var eligibilityDateValidator = isNew ? _List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Employee$Form$validateEligibilityDate(isNew))
			]) : _List_Nil;
		var divisionValidator = requiresDivisions ? _List_fromArray(
			[
				A2(
				$author$project$Components$EmployeeDivisionInput$validate,
				function ($) {
					return $.NT;
				},
				function (error) {
					return _Utils_Tuple2(4, error);
				})
			]) : _List_Nil;
		var validators = A2(
			$elm$core$List$cons,
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Employee$Form$validatePatientFields),
			_Utils_ap(
				typeValidator,
				_Utils_ap(
					planValidator,
					_Utils_ap(divisionValidator, eligibilityDateValidator))));
		return $rtfeldman$elm_validate$Validate$all(validators);
	});
var $author$project$Components$Employee$Form$validate = function (_v0) {
	var settings = _v0.a;
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	var patientForm = function () {
		var _v1 = $author$project$Components$Patient$Form$validate(fields.VM);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var newForm = _v2.a;
			return newForm;
		} else {
			var newForm = _v1.a;
			return newForm;
		}
	}();
	return A2(
		$elm$core$Result$mapError,
		$author$project$Components$Employee$Form$EmployeeForm(settings),
		A2(
			$elm$core$Result$map,
			$elm$core$Tuple$mapFirst(
				$author$project$Components$Employee$Form$EmployeeForm(settings)),
			A2(
				$author$project$Utils$Form$validate,
				A3(
					$author$project$Components$Employee$Form$validator,
					settings.xn.Yl,
					fields.iX,
					$author$project$Components$EmployeeDependentTypeInput$selectedType(fields.ahI)),
				A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{VM: patientForm}),
					form))));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A5(
					$author$project$Components$Employee$Form$update,
					model.D5,
					model.ZD,
					$elm$core$Maybe$Just(model.ab9),
					subMsg,
					model.an);
				var form = _v1.a;
				var formCmd = _v1.b;
				var formOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{an: form}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg, formCmd),
					formOutMsgs);
			case 1:
				var _v2 = $author$project$Components$Employee$Form$validate(model.an);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validForm = _v3.a;
					var validFields = _v3.b;
					var cmd = function () {
						var _v4 = $author$project$Components$Employee$Form$dependentOf(model.an);
						if (!_v4.$) {
							var account = _v4.a;
							return A6(
								$author$project$Api$CompanyRegistration$create,
								model.D5,
								model.ZD,
								model.adR,
								$author$project$Api$CompanyAccount$All$id(account),
								A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm),
								$author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated(
									$author$project$Api$CompanyAccount$All$id(account)));
						} else {
							return A5(
								$author$project$Api$CompanyAccount$create,
								model.D5,
								model.ZD,
								model.adR,
								A2($author$project$Components$Employee$Form$encodeAccount, validFields, validForm),
								$author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyAccountCreated);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kj: true}),
						cmd,
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{an: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				var _v5 = _Utils_Tuple2(
					$author$project$Components$Employee$Form$validate(model.an),
					response);
				_v5$2:
				while (true) {
					switch (_v5.b.$) {
						case 3:
							if (!_v5.a.$) {
								var _v6 = _v5.a.a;
								var validForm = _v6.a;
								var validFields = _v6.b;
								var _v7 = _v5.b;
								var account = _v7.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{H3: response}),
									A6(
										$author$project$Api$CompanyRegistration$create,
										model.D5,
										model.ZD,
										model.adR,
										$author$project$Api$CompanyAccount$One$id(account),
										A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm),
										$author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated(
											$author$project$Api$CompanyAccount$One$id(account))),
									_List_Nil);
							} else {
								break _v5$2;
							}
						case 2:
							var error = _v5.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{H3: response, kj: false}),
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$OutMsg$ShowToast,
										1,
										$author$project$Ui$Toast$serverError(error)),
									$author$project$OutMsg$reportDecodeError(response)));
						default:
							break _v5$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{H3: response, kj: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var accountId = msg.a;
				var response = msg.b;
				var _v8 = _Utils_Tuple2(
					$author$project$Components$Employee$Form$validate(model.an),
					response);
				_v8$2:
				while (true) {
					switch (_v8.b.$) {
						case 3:
							if (!_v8.a.$) {
								var _v9 = _v8.a.a;
								var validForm = _v9.a;
								var validFields = _v9.b;
								var _v10 = _v8.b;
								var registration = _v10.a;
								var _v11 = $author$project$Components$Employee$Form$shouldEnroll(model.an) ? _Utils_Tuple2(
									A5(
										$author$project$Api$CompanyRegistration$enroll,
										model.D5,
										model.ZD,
										{
											eR: accountId,
											ff: model.adR,
											nU: $author$project$Api$CompanyRegistration$One$id(registration)
										},
										A2($author$project$Components$Employee$Form$encodeEnroll, validFields, validForm),
										$author$project$Pages$Companies$CompanyId_String$Employees$Create$RegistrationEnrolled),
									_List_Nil) : _Utils_Tuple2(
									A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
											{ff: model.adR})),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, 'Patient created!')
										]));
								var cmd = _v11.a;
								var outMsg = _v11.b;
								return _Utils_Tuple3(model, cmd, outMsg);
							} else {
								break _v8$2;
							}
						case 2:
							var error = _v8.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{kj: false}),
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$OutMsg$ShowToast,
										1,
										$author$project$Ui$Toast$serverError(error)),
									$author$project$OutMsg$reportDecodeError(response)));
						default:
							break _v8$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kj: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var registration = response.a;
						var createAffiliationCmd = A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg,
							A4($author$project$Components$Employee$Form$createEmployeeAffiliation, model.D5, model.ZD, registration, model.an));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
											{ff: model.adR})),
										createAffiliationCmd
									])),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Patient created!')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormSubmitted = {$: 1};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText = function (form) {
	var _v0 = _Utils_Tuple2(
		$author$project$Components$Employee$Form$dependentOf(form),
		$author$project$Components$Employee$Form$shouldEnroll(form));
	if (_v0.a.$ === 1) {
		if (_v0.b) {
			var _v1 = _v0.a;
			return 'Create and Enroll Employee';
		} else {
			var _v2 = _v0.a;
			return 'Create Employee';
		}
	} else {
		if (_v0.b) {
			return 'Create and Enroll Dependent';
		} else {
			return 'Create Dependent';
		}
	}
};
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Api$Patient$Meta$chosenFirstName = function (_v0) {
	var fields = _v0.a;
	return fields.KX;
};
var $author$project$Api$Patient$Meta$dob = function (_v0) {
	var fields = _v0.a;
	return fields.acQ;
};
var $author$project$Api$Patient$Meta$firstName = function (_v0) {
	var fields = _v0.a;
	return fields.Pu;
};
var $author$project$Api$Patient$Meta$gender = function (_v0) {
	var fields = _v0.a;
	return fields.PO;
};
var $author$project$Api$Patient$Meta$genderIdentity = function (_v0) {
	var fields = _v0.a;
	return fields.PP;
};
var $author$project$Api$Patient$Meta$healthInsuranceCarrier = function (_v0) {
	var fields = _v0.a;
	return fields.Qk;
};
var $author$project$Api$Patient$Meta$joinedPracticeDate = function (_v0) {
	var fields = _v0.a;
	return fields.Sq;
};
var $author$project$Api$Patient$Meta$leadSourceId = function (_v0) {
	var fields = _v0.a;
	return fields.SI;
};
var $author$project$Api$Patient$Meta$locationId = function (_v0) {
	var fields = _v0.a;
	return fields.S3;
};
var $author$project$Api$Patient$Meta$practitionerId = function (_v0) {
	var fields = _v0.a;
	return fields.WO;
};
var $author$project$Api$Patient$Meta$pronouns = function (_v0) {
	var fields = _v0.a;
	return fields.Xi;
};
var $author$project$Api$Patient$Meta$sex = function (_v0) {
	var fields = _v0.a;
	return fields.ZH;
};
var $author$project$Api$Patient$Meta$usesTobacco = function (_v0) {
	var fields = _v0.a;
	return fields.aaI;
};
var $author$project$Ui$Form$Group$Test = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$Form$Group$test = function (dataTest) {
	return $author$project$Ui$Form$Group$Test(dataTest);
};
var $author$project$Components$Patient$Form$viewAddressField = function (address) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Address'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$margin(0),
				$author$project$Ui$Form$Group$test('address')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
				A2($author$project$Components$AddressInput$view, _List_Nil, address))
			]));
};
var $author$project$Components$ResourceFilter$Affiliate$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$AffiliateInput$view = function (_v0) {
	var filter = _v0.Fi;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A2(
					$author$project$Components$ResourceFilter$Affiliate$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$style(0)
						]),
					filter))
			]));
};
var $author$project$Components$Patient$Form$viewAffiliateField = function (affiliate) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Primary Care Clinic'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('affiliate')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
				$author$project$Components$AffiliateInput$view(affiliate))
			]));
};
var $author$project$Components$Patient$Form$viewBillingAddressField = F3(
	function (_v0, usesBillingAddress, billingAddress) {
		var billingAsShipping = _v0.abD;
		var _v1 = _Utils_Tuple2(usesBillingAddress, billingAddress);
		if (_v1.a && (!_v1.b.$)) {
			var address = _v1.b.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(
						(billingAsShipping ? 'Shipping' : 'Billing') + ' Address'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpanMd(8),
						$author$project$Ui$Form$Group$test('billing-address')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
						A2($author$project$Components$AddressInput$view, _List_Nil, address))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Patient$Form$ChosenName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$NameInput$disable = F2(
	function (disable_, _v0) {
		var errors = _v0.a;
		var options = _v0.b;
		var fields = _v0.c;
		return A3(
			$author$project$Components$NameInput$Model,
			errors,
			_Utils_update(
				options,
				{dW: disable_}),
			fields);
	});
var $author$project$Components$NameInput$test = F2(
	function (string, _v0) {
		var errors = _v0.a;
		var options = _v0.b;
		var fields = _v0.c;
		return A3(
			$author$project$Components$NameInput$Model,
			errors,
			_Utils_update(
				options,
				{ti: string}),
			fields);
	});
var $author$project$Components$NameInput$FieldUpdated = $elm$core$Basics$identity;
var $author$project$Components$NameInput$FirstName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$NameInput$LastName = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$NameInput$MiddleName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$NameInput$Suffix = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$NameInput$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$NameInput$errorsForGroup = F2(
	function (validation, errors) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var errValidation = _v0.a;
				var errMessage = _v0.b;
				return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
			},
			errors);
	});
var $author$project$Components$NameInput$groupHasErrors = F2(
	function (validationGroup, errors) {
		return !$elm$core$List$isEmpty(
			A2($author$project$Components$NameInput$errorsForGroup, validationGroup, errors));
	});
var $author$project$Components$NameInput$titleOptions = _List_fromArray(
	['Ms.', 'Mrs.', 'Miss', 'Mr.', 'Dr.', 'Mx.']);
var $author$project$Components$NameInput$view = function (_v0) {
	var errors = _v0.a;
	var disabled = _v0.b.dW;
	var testStr = _v0.b.ti;
	var fields = _v0.c;
	var _v1 = fields;
	var title = _v1.$G;
	var firstName = _v1.Pu;
	var middleName = _v1.TX;
	var lastName = _v1.SA;
	var suffix = _v1._8;
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(title)),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$Title)),
								$author$project$Ui$Form$Select$disabled(disabled)
							]),
						A2(
							$elm$core$List$cons,
							A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$elm$core$Maybe$Just(''),
								''),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just(option),
										option);
								},
								$author$project$Components$NameInput$titleOptions)))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(3),
						$author$project$Ui$FlexGrid$spanSm(6)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(firstName),
								$author$project$Ui$Form$Input$placeholder('First'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$FirstName)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Components$NameInput$errorsForGroup, 0, errors)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Components$NameInput$groupHasErrors, 0, errors)),
								$author$project$Ui$Form$Input$disabled(disabled),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$test(testStr + '-first-name')
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(2),
						$author$project$Ui$FlexGrid$spanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(middleName),
								$author$project$Ui$Form$Input$placeholder('M'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$MiddleName)),
								$author$project$Ui$Form$Input$disabled(disabled),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$test(testStr + '-middle-name')
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(3),
						$author$project$Ui$FlexGrid$spanSm(7)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(lastName),
								$author$project$Ui$Form$Input$placeholder('Last'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$LastName)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Components$NameInput$errorsForGroup, 1, errors)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Components$NameInput$groupHasErrors, 1, errors)),
								$author$project$Ui$Form$Input$disabled(disabled),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$ariaLabel('Last Name'),
								$author$project$Ui$Form$Input$test(testStr + '-last-name')
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(2),
						$author$project$Ui$FlexGrid$spanSm(5)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', suffix)),
								$author$project$Ui$Form$Input$placeholder('Suffix'),
								$author$project$Ui$Form$Input$onInput(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$Suffix),
									$elm$core$Maybe$Just)),
								$author$project$Ui$Form$Input$disabled(disabled),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$ariaLabel('Suffix'),
								$author$project$Ui$Form$Input$test(testStr + '-suffix')
							]))
					]))
			]));
};
var $author$project$Components$Patient$Form$withinTooltipIf = F2(
	function (maybeExplanation, content) {
		if (!maybeExplanation.$) {
			var explanation = maybeExplanation.a;
			return A3(
				$author$project$Ui$Tooltip$view,
				_List_Nil,
				explanation,
				_List_fromArray(
					[content]));
		} else {
			return content;
		}
	});
var $author$project$Components$Patient$Form$viewChosenNameField = F2(
	function (metaField, maybeChosenName) {
		if (!maybeChosenName.$) {
			var chosenName = maybeChosenName.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Chosen Name'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpanMd(8),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$test('chosen-name')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Patient$Form$withinTooltipIf,
						$author$project$Utils$MetaFields$explanation(metaField),
						A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$ChosenName),
							$author$project$Components$NameInput$view(
								A2(
									$author$project$Components$NameInput$test,
									'chosen-name',
									A2(
										$author$project$Components$NameInput$disable,
										$author$project$Utils$MetaFields$isUneditable(metaField),
										chosenName)))))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Patient$Form$DateOfBirthBlur = {$: 4};
var $author$project$Components$Patient$Form$viewDateOfBirthField = F4(
	function (metaField, _v0, errors, dateOfBirth) {
		var requiresDOB = _v0.BT;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Date of Birth'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(requiresDOB),
					$author$project$Ui$Form$Group$test('date-of-birth')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
								A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$Patient$Form$datePattern, dateOfBirth),
								A3(
								$author$project$Ui$Form$Input$onMaskedInput,
								$author$project$Components$Patient$Form$datePattern,
								dateOfBirth,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$DateOfBirth)),
								$author$project$Ui$Form$Input$disabled(
								$author$project$Utils$MetaFields$isUneditable(metaField)),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(errors)),
								$author$project$Ui$Form$Input$onBlur($author$project$Components$Patient$Form$DateOfBirthBlur)
							])))
				]));
	});
var $author$project$Components$Patient$Form$Email = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$Form$viewEmailField = F3(
	function (_v0, errors, email) {
		var requiresEmail = _v0.ago;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Email'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(requiresEmail),
					$author$project$Ui$Form$Group$test('email')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$phi(true),
							$author$project$Ui$Form$Input$placeholder('joe@example.com'),
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', email)),
							$author$project$Ui$Form$Input$onInput(
							A2(
								$elm$core$Basics$composeL,
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Email),
								$author$project$Utils$String$toMaybe)),
							$author$project$Ui$Form$Input$errors(errors),
							$author$project$Ui$Form$Input$invalid(
							!$elm$core$List$isEmpty(errors))
						]))
				]));
	});
var $author$project$Components$EmergencyContactInput$Email = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$EmergencyContactInput$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmergencyContactInput$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmergencyContactInput$Relationship = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$EmergencyContactInput$relationshipToLabel = function (rel) {
	if (rel.$ === 1) {
		return 'None';
	} else {
		switch (rel.a.$) {
			case 0:
				var _v1 = rel.a;
				return 'Spouse';
			case 1:
				var _v2 = rel.a;
				return 'Parent';
			case 2:
				var _v3 = rel.a;
				return 'Child';
			case 3:
				var _v4 = rel.a;
				return 'Sibling';
			case 4:
				var _v5 = rel.a;
				return 'Grandparent';
			case 5:
				var _v6 = rel.a;
				return 'Guardian';
			default:
				return 'Other';
		}
	}
};
var $author$project$Components$EmergencyContactInput$relationshipOptions = function (selected) {
	var relationshipToItem = function (rel) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(selected, rel)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$EmergencyContactInput$FieldChanged(
						$author$project$Components$EmergencyContactInput$Relationship(rel)))
				]),
			$elm$html$Html$text(
				$author$project$Components$EmergencyContactInput$relationshipToLabel(rel)));
	};
	return A2(
		$elm$core$List$map,
		relationshipToItem,
		function (someOptions) {
			return A2($elm$core$List$cons, $elm$core$Maybe$Nothing, someOptions);
		}(
			A2(
				$elm$core$List$map,
				$elm$core$Maybe$Just,
				_List_fromArray(
					[
						$author$project$Components$EmergencyContactInput$Spouse,
						$author$project$Components$EmergencyContactInput$Parent,
						$author$project$Components$EmergencyContactInput$Child,
						$author$project$Components$EmergencyContactInput$Sibling,
						$author$project$Components$EmergencyContactInput$Grandparent,
						$author$project$Components$EmergencyContactInput$Guardian,
						$author$project$Components$EmergencyContactInput$Other('')
					]))));
};
var $author$project$Components$EmergencyContactInput$view = function (_v0) {
	var form = _v0.PB;
	var relationshipDropdown = _v0.nV;
	var emergencyContact = $author$project$Utils$Form$fields(form);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$placeholder('First Name'),
										$author$project$Ui$Form$Input$phi(true),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$FirstName)),
										$author$project$Ui$Form$Input$value(emergencyContact.Pu),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$placeholder('Last Name'),
										$author$project$Ui$Form$Input$phi(true),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$LastName)),
										$author$project$Ui$Form$Input$value(emergencyContact.SA),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(4)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$NewDropdown$viewSelect,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										function () {
											var _v1 = emergencyContact.X6;
											if (!_v1.$) {
												var rel = _v1.a;
												return $author$project$Components$EmergencyContactInput$relationshipToLabel(
													$elm$core$Maybe$Just(rel));
											} else {
												return 'Select a relationship';
											}
										}())
									]),
								$author$project$Components$EmergencyContactInput$relationshipOptions(emergencyContact.X6),
								relationshipDropdown)
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						_List_fromArray(
							[
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]))
					])),
				function () {
				var _v2 = emergencyContact.X6;
				if ((!_v2.$) && (_v2.a.$ === 6)) {
					var other = _v2.a.a;
					return A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(12)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$placeholder('Relationship'),
												$author$project$Ui$Form$Input$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Relationship),
														$elm$core$Maybe$Just),
													$author$project$Components$EmergencyContactInput$Other)),
												$author$project$Ui$Form$Input$value(other),
												$author$project$Ui$Form$Input$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 3, form))
											]))
									]))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone),
								$author$project$Components$PhoneInput$view(emergencyContact.Wg))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$phi(true),
										$author$project$Ui$Form$Input$placeholder('Email'),
										$author$project$Ui$Form$Input$value(emergencyContact.Oo),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Email)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 2, form))
									])),
								$author$project$Utils$FormErrors$view(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]))
					]))
			]));
};
var $author$project$Components$Patient$Form$viewEmergencyContact = function (emergencyContact) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Emergency Contact'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('emergency-contacts')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$EmergencyContact),
				$author$project$Components$EmergencyContactInput$view(emergencyContact))
			]));
};
var $author$project$Components$Patient$Form$Gender = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Patient$Form$GenderOther = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$Form$viewGenderField = F3(
	function (metaField, gender, genderOther) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Sex'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('gender')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					$author$project$Ui$Form$Gender$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Gender$gender(gender),
								$author$project$Ui$Form$Gender$genderOther(genderOther),
								$author$project$Ui$Form$Gender$onGenderChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Gender)),
								$author$project$Ui$Form$Gender$onGenderOtherChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$GenderOther)),
								$author$project$Ui$Form$Gender$disabled(
								$author$project$Utils$MetaFields$isUneditable(metaField))
							])))
				]));
	});
var $author$project$Components$Patient$Form$GenderIdentity = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Patient$Form$GenderIdentityOther = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$GenderIdentity$Man = {$: 0};
var $author$project$Api$GenderIdentity$NonBinary = {$: 2};
var $author$project$Api$GenderIdentity$TransMan = {$: 3};
var $author$project$Api$GenderIdentity$TransWoman = {$: 4};
var $author$project$Api$GenderIdentity$Woman = {$: 1};
var $author$project$Api$GenderIdentity$all = _List_fromArray(
	[
		$author$project$Api$GenderIdentity$Man,
		$author$project$Api$GenderIdentity$Woman,
		$author$project$Api$GenderIdentity$NonBinary,
		$author$project$Api$GenderIdentity$TransMan,
		$author$project$Api$GenderIdentity$TransWoman,
		$author$project$Api$GenderIdentity$NotListed('')
	]);
var $author$project$Api$GenderIdentity$fromString = F2(
	function (notListedString, genderIdentity) {
		var _v0 = $elm$core$String$toLower(genderIdentity);
		switch (_v0) {
			case 'man':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$Man);
			case 'woman':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$Woman);
			case 'non-binary':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$NonBinary);
			case 'trans man':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$TransMan);
			case 'trans woman':
				return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$TransWoman);
			case 'not listed':
				return $elm$core$Maybe$Just(
					$author$project$Api$GenderIdentity$NotListed(notListedString));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Patient$Form$viewGenderIdentityField = F3(
	function (metaField, maybeGenderOther, genderIdentity) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Gender Identity'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('gender-identity')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								A2($elm$core$Maybe$map, $author$project$Api$GenderIdentity$toString, genderIdentity)),
								$author$project$Ui$Form$Select$onChange(
								A2(
									$elm$core$Basics$composeR,
									$author$project$Api$GenderIdentity$fromString(
										A2($elm$core$Maybe$withDefault, '', maybeGenderOther)),
									A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$GenderIdentity, $author$project$Components$Patient$Form$FieldUpdated))),
								$author$project$Ui$Form$Select$disabled(
								$author$project$Utils$MetaFields$isUneditable(metaField))
							]),
						A2(
							$elm$core$List$cons,
							A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$elm$core$Maybe$Just(''),
								''),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just(option),
										$elm_community$string_extra$String$Extra$toTitleCase(option));
								},
								A2($elm$core$List$map, $author$project$Api$GenderIdentity$toString, $author$project$Api$GenderIdentity$all))))),
				function () {
					if ((!genderIdentity.$) && (genderIdentity.a.$ === 5)) {
						var other = genderIdentity.a.a;
						return _List_fromArray(
							[
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								A2(
								$author$project$Components$Patient$Form$withinTooltipIf,
								$author$project$Utils$MetaFields$explanation(metaField),
								$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(other),
											$author$project$Ui$Form$Input$placeholder('Description'),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$GenderIdentityOther)),
											$author$project$Ui$Form$Input$disabled(
											$author$project$Utils$MetaFields$isUneditable(metaField))
										])))
							]);
					} else {
						return _List_fromArray(
							[$author$project$Utils$Html$empty]);
					}
				}()));
	});
var $author$project$Components$HealthInsuranceInput$disable = F2(
	function (disabled, _v0) {
		var filter = _v0.a;
		var options = _v0.b;
		var healthInsurance = _v0.c;
		return A3(
			$author$project$Components$HealthInsuranceInput$Model,
			filter,
			_Utils_update(
				options,
				{dW: disabled}),
			healthInsurance);
	});
var $author$project$Components$HealthInsuranceInput$OtherNameUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$HealthInsuranceInput$GroupIdUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HealthInsuranceInput$viewGroupIdField = F2(
	function (options, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Group Id')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(value),
								$author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$GroupIdUpdated),
								$author$project$Ui$Form$Input$placeholder('3207524'),
								$author$project$Ui$Form$Input$disabled(options.dW),
								$author$project$Ui$Form$Input$phi(true)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$HealthInsuranceInput$DeductibleUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HealthInsuranceInput$viewHighDeductibleField = F2(
	function (options, maybeValue) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('High deductible')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Is this a high-deductible plan?')
						])),
					function () {
					if (!maybeValue.$) {
						var deductible = maybeValue.a;
						return $author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Yes, this is a high-deductible plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$active(deductible),
											$author$project$Ui$Button$onClick(
											$author$project$Components$HealthInsuranceInput$DeductibleUpdated(true)),
											$author$project$Ui$Button$disabled(options.dW)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Yes')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'No, this is not a high-deductible plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$active(!deductible),
											$author$project$Ui$Button$onClick(
											$author$project$Components$HealthInsuranceInput$DeductibleUpdated(false)),
											$author$project$Ui$Button$disabled(options.dW)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No')
										]))
								]));
					} else {
						return $author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Yes, this is a high-deductible plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Components$HealthInsuranceInput$DeductibleUpdated(true)),
											$author$project$Ui$Button$disabled(options.dW)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Yes')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'No, this is not a high-deductible plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick(
											$author$project$Components$HealthInsuranceInput$DeductibleUpdated(false)),
											$author$project$Ui$Button$disabled(options.dW)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No')
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Components$HealthInsuranceInput$MemberIdUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HealthInsuranceInput$viewMemberIdField = F2(
	function (options, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Member Id')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(value),
								$author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$MemberIdUpdated),
								$author$project$Ui$Form$Input$placeholder('A22222222'),
								$author$project$Ui$Form$Input$disabled(options.dW),
								$author$project$Ui$Form$Input$phi(true)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$HealthInsuranceInput$view = function (_v0) {
	var filter = _v0.a;
	var options = _v0.b;
	var maybeCarrierAndInsurance = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$HealthInsuranceInput$FilterMsg,
				A2(
					$author$project$Components$ResourceFilter$InsuranceCarrierAlias$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$disabled(options.dW)
						]),
					filter)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						A2($elm$html$Html$br, _List_Nil, _List_Nil)),
					maybeCarrierAndInsurance)),
				function () {
				if ((!maybeCarrierAndInsurance.$) && (maybeCarrierAndInsurance.a.a.$ === 1)) {
					var _v2 = maybeCarrierAndInsurance.a;
					var name = _v2.a.a.zh;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Carrier\'s Name'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(name),
												$author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$OtherNameUpdated),
												$author$project$Ui$Form$Input$disabled(options.dW)
											]))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				if (!maybeCarrierAndInsurance.$) {
					var _v4 = maybeCarrierAndInsurance.a;
					var groupId = _v4.b.PY;
					var memberId = _v4.b.Tz;
					var highDeductible = _v4.b.Qq;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$HealthInsuranceInput$viewGroupIdField, options, groupId),
								A2($author$project$Components$HealthInsuranceInput$viewMemberIdField, options, memberId),
								A2($author$project$Components$HealthInsuranceInput$viewHighDeductibleField, options, highDeductible)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Patient$Form$viewHealthInsuranceField = F2(
	function (metaField, healthInsurance) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Health Insurance'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('health-insurance')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
						$author$project$Components$HealthInsuranceInput$view(
							A2(
								$author$project$Components$HealthInsuranceInput$disable,
								$author$project$Utils$MetaFields$isUneditable(metaField),
								healthInsurance))))
				]));
	});
var $author$project$Components$Patient$Form$viewJoinedPracticeField = F2(
	function (metaField, _v0) {
		var joinedPractice = _v0.a;
		var dateInput = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Joined Practice'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('joined-practice')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice),
						A2(
							$author$project$Components$DateInput$view,
							_List_fromArray(
								[
									$author$project$Components$DateInput$value(joinedPractice),
									$author$project$Components$DateInput$disabled(
									$author$project$Utils$MetaFields$isUneditable(metaField))
								]),
							dateInput)))
				]));
	});
var $author$project$Components$KnownPracticeInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$KnownPracticeInput$errors = $elm$core$Basics$identity;
var $author$project$Components$KnownPracticeInput$OtherNameUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$KnownPracticeInput$OtherWebsiteUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$KnownPracticeInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{fE: errors_});
	});
var $author$project$Components$ResourceFilter$KnownPractice$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$KnownPracticeInput$view = F2(
	function (options, _v0) {
		var filter = _v0.a;
		var knownPractice = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$KnownPracticeInput$FilterMsg,
					A2($author$project$Components$ResourceFilter$KnownPractice$view, _List_Nil, filter)),
					function () {
					if ((!knownPractice.$) && (knownPractice.a.$ === 1)) {
						var name = knownPractice.a.a.zh;
						var website = knownPractice.a.a.DO;
						var optionsRecord = A3(
							$elm$core$List$foldl,
							$author$project$Components$KnownPracticeInput$optionToRecord,
							{fE: _List_Nil},
							options);
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Your DPC Name'),
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(name),
													$author$project$Ui$Form$Input$onInput($author$project$Components$KnownPracticeInput$OtherNameUpdated),
													$author$project$Ui$Form$Input$errors(optionsRecord.fE),
													$author$project$Ui$Form$Input$invalid(
													!$elm$core$List$isEmpty(optionsRecord.fE))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('DPC Website'),
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(website),
													$author$project$Ui$Form$Input$onInput($author$project$Components$KnownPracticeInput$OtherWebsiteUpdated)
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Patient$Form$viewKnownPracticeField = F2(
	function (errors, knownPractice) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('DPC Practice'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('known-practice')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
					A2(
						$author$project$Components$KnownPracticeInput$view,
						_List_fromArray(
							[
								$author$project$Components$KnownPracticeInput$errors(errors)
							]),
						knownPractice))
				]));
	});
var $author$project$Components$LeadSourceInput$disable = F2(
	function (disabled, model) {
		return _Utils_update(
			model,
			{dW: disabled});
	});
var $author$project$Components$LeadSourceInput$OtherChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$LeadSource$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$LeadSourceInput$view = function (_v0) {
	var other = _v0.c2;
	var disabled = _v0.dW;
	var leadSourceResourceFilter = _v0.mQ;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$LeadSource$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$disabled(disabled)
						]),
					leadSourceResourceFilter)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						A2($elm$html$Html$br, _List_Nil, _List_Nil)),
					other)),
				function () {
				if (!other.$) {
					var otherText = other.a;
					return $author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(otherText),
								$author$project$Ui$Form$Input$onInput($author$project$Components$LeadSourceInput$OtherChanged)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Patient$Form$viewLeadSourceField = F2(
	function (metaField, leadSource) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Lead Source'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('lead-source')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
						$author$project$Components$LeadSourceInput$view(
							A2(
								$author$project$Components$LeadSourceInput$disable,
								$author$project$Utils$MetaFields$isUneditable(metaField),
								leadSource))))
				]));
	});
var $author$project$Components$Patient$Form$DifferentChosenNameClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$Form$LegalName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$Form$viewLegalNameField = F3(
	function (metaField, chosenNameIsDifferent, legalName) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Legal Name'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(true),
					$author$project$Ui$Form$Group$test('legal-name')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LegalName),
						$author$project$Components$NameInput$view(
							A2(
								$author$project$Components$NameInput$test,
								'legal-name',
								A2(
									$author$project$Components$NameInput$disable,
									$author$project$Utils$MetaFields$isUneditable(metaField),
									legalName))))),
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(chosenNameIsDifferent),
							$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Patient$Form$DifferentChosenNameClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Chosen name is different')
						]))
				]));
	});
var $author$project$Components$LocationInput$disable = F2(
	function (disabled, input) {
		return _Utils_update(
			input,
			{dW: disabled});
	});
var $author$project$Components$LocationInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$LocationInput$errors = $elm$core$Basics$identity;
var $author$project$Components$LocationInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{fE: errors_});
	});
var $author$project$Components$LocationInput$view = F2(
	function (options, _v0) {
		var filter = _v0.Fi;
		var disabled = _v0.dW;
		var optionsRecord = A3(
			$elm$core$List$foldl,
			$author$project$Components$LocationInput$optionToRecord,
			{fE: _List_Nil},
			options);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$identity,
					A2(
						$author$project$Components$ResourceFilter$Location$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0),
								$author$project$Components$ResourceFilter$invalid(
								!$elm$core$List$isEmpty(optionsRecord.fE)),
								$author$project$Components$ResourceFilter$disabled(disabled)
							]),
						filter)),
					$author$project$Utils$FormErrors$view(optionsRecord.fE)
				]));
	});
var $author$project$Components$Patient$Form$viewLocationField = F4(
	function (metaField, required, errors, location) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Location'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(required),
					$author$project$Ui$Form$Group$test('location')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
						A2(
							$author$project$Components$LocationInput$view,
							_List_fromArray(
								[
									$author$project$Components$LocationInput$errors(errors)
								]),
							A2(
								$author$project$Components$LocationInput$disable,
								$author$project$Utils$MetaFields$isUneditable(metaField),
								location))))
				]));
	});
var $author$project$Components$Patient$Form$viewPhonesField = F2(
	function (_v0, phones) {
		var requiresPhone = _v0.agp;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Phones'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(requiresPhone),
					$author$project$Ui$Form$Group$test('phones')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones),
					$author$project$Components$PhoneInput$view(phones))
				]));
	});
var $author$project$Components$PractitionerInput$disable = F2(
	function (disabled, input) {
		return _Utils_update(
			input,
			{dW: disabled});
	});
var $author$project$Components$PractitionerInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$PractitionerInput$errors = $elm$core$Basics$identity;
var $author$project$Components$PractitionerInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{fE: errors_});
	});
var $author$project$Components$PractitionerInput$view = F2(
	function (options, _v0) {
		var filter = _v0.Fi;
		var disabled = _v0.dW;
		var optionsRecord = A3(
			$elm$core$List$foldl,
			$author$project$Components$PractitionerInput$optionToRecord,
			{fE: _List_Nil},
			options);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$identity,
					A2(
						$author$project$Components$ResourceFilter$Practitioner$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0),
								$author$project$Components$ResourceFilter$invalid(
								!$elm$core$List$isEmpty(optionsRecord.fE)),
								$author$project$Components$ResourceFilter$disabled(disabled)
							]),
						filter)),
					$author$project$Utils$FormErrors$view(optionsRecord.fE)
				]));
	});
var $author$project$Components$Patient$Form$viewPractitionerField = F4(
	function (metaField, required, errors, practitioner) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Provider'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(required),
					$author$project$Ui$Form$Group$test('provider')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
						A2(
							$author$project$Components$PractitionerInput$view,
							_List_fromArray(
								[
									$author$project$Components$PractitionerInput$errors(errors)
								]),
							A2(
								$author$project$Components$PractitionerInput$disable,
								$author$project$Utils$MetaFields$isUneditable(metaField),
								practitioner))))
				]));
	});
var $author$project$Components$Patient$Form$PreferredLanguage = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Patient$Form$viewPreferredLanguageField = function (preferredLanguage) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Preferred Language'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('preferred-language')
			]),
		_List_fromArray(
			[
				$author$project$Components$LanguageInput$view(
				_List_fromArray(
					[
						$author$project$Components$LanguageInput$value(preferredLanguage),
						$author$project$Components$LanguageInput$onChange(
						A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$PreferredLanguage, $author$project$Components$Patient$Form$FieldUpdated))
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text('This language will be used on the patient portal and all patient notifications')
					]))
			]));
};
var $author$project$Components$Patient$Form$ProfilePictureUploaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$Form$viewProfilePictureField = F2(
	function (errors, currentProfilePictureUrl) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Profile Picture'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('profilePicture')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Components$Patient$Form$ProfilePictureUploaded),
							$author$project$Ui$Form$File$empty(false)
						])),
					function () {
					if (!currentProfilePictureUrl.$) {
						if (currentProfilePictureUrl.a === '') {
							return $author$project$Utils$Html$empty;
						} else {
							var url = currentProfilePictureUrl.a;
							return A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt4]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Image$fromSrc,
										{I1: 'Profile picture'},
										url,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(50)
											])),
										$author$project$Utils$FormErrors$view(errors)
									]));
						}
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Profile picture will be shown on patient profile.'),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('Recommended size: 200x200 px or larger.'),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('Supported image files: JPG, PNG.')
						]))
				]));
	});
var $author$project$Components$Patient$Form$Pronoun = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Patient$Form$PronounOther = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Pronoun$HeHimHis = {$: 0};
var $author$project$Api$Pronoun$SheHerHers = {$: 1};
var $author$project$Api$Pronoun$TheyThemTheirs = {$: 2};
var $author$project$Api$Pronoun$all = _List_fromArray(
	[
		$author$project$Api$Pronoun$HeHimHis,
		$author$project$Api$Pronoun$SheHerHers,
		$author$project$Api$Pronoun$TheyThemTheirs,
		$author$project$Api$Pronoun$Other('')
	]);
var $author$project$Api$Pronoun$fromString = function (string) {
	switch (string) {
		case 'He/Him/His':
			return $elm$core$Maybe$Just($author$project$Api$Pronoun$HeHimHis);
		case 'She/Her/Hers':
			return $elm$core$Maybe$Just($author$project$Api$Pronoun$SheHerHers);
		case 'They/Them/Theirs':
			return $elm$core$Maybe$Just($author$project$Api$Pronoun$TheyThemTheirs);
		case 'Not Listed':
			return $elm$core$Maybe$Just(
				$author$project$Api$Pronoun$Other(''));
		default:
			return $elm$core$Maybe$Just(
				$author$project$Api$Pronoun$Other(string));
	}
};
var $author$project$Components$Patient$Form$viewPronounField = F2(
	function (metaField, pronoun) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Pronoun'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(6),
					$author$project$Ui$Form$Group$test('pronoun')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										A2($elm$core$Maybe$map, $author$project$Api$Pronoun$toString, pronoun)),
										$author$project$Ui$Form$Select$onChange(
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Pronoun),
											$author$project$Api$Pronoun$fromString)),
										$author$project$Ui$Form$Select$disabled(
										$author$project$Utils$MetaFields$isUneditable(metaField))
									]),
								A2(
									$elm$core$List$cons,
									A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just(''),
										''),
									A2(
										$elm$core$List$map,
										function (option) {
											return A3(
												$author$project$Ui$Form$Select$option,
												_List_Nil,
												$elm$core$Maybe$Just(option),
												option);
										},
										A2($elm$core$List$map, $author$project$Api$Pronoun$toString, $author$project$Api$Pronoun$all)))),
							function () {
								if ((!pronoun.$) && (pronoun.a.$ === 3)) {
									var other = pronoun.a.a;
									return _List_fromArray(
										[
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(other),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$PronounOther)),
													$author$project$Ui$Form$Input$placeholder('Pronoun'),
													$author$project$Ui$Form$Input$disabled(
													$author$project$Utils$MetaFields$isUneditable(metaField))
												]))
										]);
								} else {
									return _List_fromArray(
										[$author$project$Utils$Html$empty]);
								}
							}())))
				]));
	});
var $author$project$Components$Patient$Form$Sex = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Gender$allWithoutOther = _List_fromArray(
	[0, 1, 2]);
var $author$project$Components$Patient$Form$viewSexField = F2(
	function (metaField, sex) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Sex'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('sex')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$elm$html$Html$span,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (genderOption) {
								return A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(
											A2(
												$elm$core$Maybe$withDefault,
												false,
												A2(
													$elm$core$Maybe$map,
													$elm$core$Basics$eq(genderOption),
													sex))),
											$author$project$Ui$Form$Radio$onCheck(
											A2(
												$elm$core$Basics$composeL,
												A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Sex),
												$elm$core$Basics$always(genderOption))),
											$author$project$Ui$Form$Radio$disabled(
											$author$project$Utils$MetaFields$isUneditable(metaField))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm_community$string_extra$String$Extra$toTitleCase(
												$author$project$Api$Gender$toString(genderOption)))
										]));
							},
							$author$project$Api$Gender$allWithoutOther)))
				]));
	});
var $author$project$Components$SocialSecurityNumberInput$Errors = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$SocialSecurityNumberInput$errors = $author$project$Components$SocialSecurityNumberInput$Errors;
var $author$project$Components$SocialSecurityNumberInput$Invalid = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$SocialSecurityNumberInput$invalid = $author$project$Components$SocialSecurityNumberInput$Invalid;
var $author$project$Components$SocialSecurityNumberInput$OnInput = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$SocialSecurityNumberInput$onInput = $author$project$Components$SocialSecurityNumberInput$OnInput;
var $author$project$Components$SocialSecurityNumberInput$Value = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$SocialSecurityNumberInput$value = $author$project$Components$SocialSecurityNumberInput$Value;
var $author$project$Components$SocialSecurityNumberInput$defaultOptionRecord = {fE: _List_Nil, q$: false, afc: $elm$core$Maybe$Nothing, aaN: ''};
var $author$project$Components$SocialSecurityNumberInput$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 1:
						var handler = option.a;
						return _Utils_update(
							record,
							{
								afc: $elm$core$Maybe$Just(handler)
							});
					case 0:
						var val = option.a;
						return _Utils_update(
							record,
							{aaN: val});
					case 2:
						var errors_ = option.a;
						return _Utils_update(
							record,
							{fE: errors_});
					default:
						var invalid_ = option.a;
						return _Utils_update(
							record,
							{q$: invalid_});
				}
			}),
		$author$project$Components$SocialSecurityNumberInput$defaultOptionRecord,
		options);
};
var $author$project$Components$SocialSecurityNumberInput$view = function (options) {
	var optionsRecord = $author$project$Components$SocialSecurityNumberInput$optionsToRecord(options);
	var onInputAttr = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (handler) {
				return _List_fromArray(
					[
						A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Components$SocialSecurityNumberInput$ssnPattern, optionsRecord.aaN, handler)
					]);
			},
			optionsRecord.afc));
	return $author$project$Ui$Form$Input$view(
		A2(
			$elm$core$List$cons,
			A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$SocialSecurityNumberInput$ssnPattern, optionsRecord.aaN),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Input$placeholder('123-45-6789'),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Form$Input$errors(optionsRecord.fE),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Form$Input$invalid(optionsRecord.q$),
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$phi(true),
							onInputAttr))))));
};
var $author$project$Components$Patient$Form$viewSsnField = F3(
	function (errors, requiresSSN, ssn) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('SSN'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(4),
					$author$project$Ui$Form$Group$required(requiresSSN),
					$author$project$Ui$Form$Group$test('ssn')
				]),
			_List_fromArray(
				[
					$author$project$Components$SocialSecurityNumberInput$view(
					_List_fromArray(
						[
							$author$project$Components$SocialSecurityNumberInput$value(ssn),
							$author$project$Components$SocialSecurityNumberInput$onInput(
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$SSN)),
							$author$project$Components$SocialSecurityNumberInput$errors(errors),
							$author$project$Components$SocialSecurityNumberInput$invalid(
							!$elm$core$List$isEmpty(errors))
						]))
				]));
	});
var $author$project$Components$Patient$Form$SyncToEmr = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Patient$Form$viewSyncToEmrField = function (syncToEmr) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Sync to emr'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8),
				$author$project$Ui$Form$Group$test('sync-to-emr')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(syncToEmr),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$SyncToEmr))
					]))
			]));
};
var $author$project$Components$Patient$Form$TobaccoUse = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Patient$Form$tobaccoUseFromMaybeString = function (string) {
	switch (string) {
		case 'true':
			return $elm$core$Maybe$Just(true);
		case 'false':
			return $elm$core$Maybe$Just(false);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Patient$Form$tobaccoUseToMaybeString = function (maybeBool) {
	return A2(
		$elm$core$Maybe$map,
		function (bool) {
			return bool ? 'true' : 'false';
		},
		maybeBool);
};
var $author$project$Components$Patient$Form$viewTobaccoUseField = F2(
	function (metaField, tobaccoUse) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Tobacco Use'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('tobacco-use')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Form$withinTooltipIf,
					$author$project$Utils$MetaFields$explanation(metaField),
					A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$author$project$Components$Patient$Form$tobaccoUseToMaybeString(tobaccoUse)),
								$author$project$Ui$Form$Select$onChange(
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$TobaccoUse),
									$author$project$Components$Patient$Form$tobaccoUseFromMaybeString)),
								$author$project$Ui$Form$Select$disabled(
								$author$project$Utils$MetaFields$isUneditable(metaField))
							]),
						_List_fromArray(
							[
								A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, ''),
								A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$author$project$Components$Patient$Form$tobaccoUseToMaybeString(
									$elm$core$Maybe$Just(true)),
								'Uses tobacco'),
								A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$author$project$Components$Patient$Form$tobaccoUseToMaybeString(
									$elm$core$Maybe$Just(false)),
								'Does not use tobacco')
							])))
				]));
	});
var $author$project$Components$Patient$Form$UsesBillingAddress = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Patient$Form$viewUsesBillingAddressField = F2(
	function (_v0, usesBillingAddress) {
		var billingAsShipping = _v0.abD;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$test('uses-billing-address')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(usesBillingAddress),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$UsesBillingAddress))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Use a different address for billing')
								])),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'This ' + ((billingAsShipping ? 'shipping' : 'billing') + ' address will be shown on all invoices and used for payment processing.'))
								]))
						]))
				]));
	});
var $author$project$Components$Patient$Form$view = function (_v0) {
	var settings = _v0.a;
	var form = _v0.b;
	var ifSetting = F2(
		function (getter, field) {
			return getter(settings) ? field : $author$project$Utils$Html$empty;
		});
	var fields = $author$project$Utils$Form$fields(form);
	var errorsFor = function (group) {
		return A2($author$project$Utils$Form$validationErrors, group, form);
	};
	var editableField = function (accessor) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$MetaFields$alwaysEditable,
			A2($elm$core$Maybe$map, accessor, settings.TU));
	};
	return _List_fromArray(
		[
			A3(
			$author$project$Components$Patient$Form$viewLegalNameField,
			editableField($author$project$Api$Patient$Meta$firstName),
			$author$project$Utils$Maybe$toBool(fields.bo),
			fields.SK),
			A2(
			$author$project$Components$Patient$Form$viewChosenNameField,
			editableField($author$project$Api$Patient$Meta$chosenFirstName),
			fields.bo),
			A4(
			$author$project$Components$Patient$Form$viewDateOfBirthField,
			editableField($author$project$Api$Patient$Meta$dob),
			settings,
			errorsFor(10),
			fields.MR),
			A2(
			ifSetting,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.$1;
				},
				$elm$core$Basics$not),
			A3(
				$author$project$Components$Patient$Form$viewGenderField,
				editableField($author$project$Api$Patient$Meta$gender),
				fields.PO,
				fields.PQ)),
			A2(
			ifSetting,
			function ($) {
				return $.$1;
			},
			A2(
				$author$project$Components$Patient$Form$viewSexField,
				editableField($author$project$Api$Patient$Meta$sex),
				fields.ZH)),
			A2(
			ifSetting,
			function ($) {
				return $.$1;
			},
			A3(
				$author$project$Components$Patient$Form$viewGenderIdentityField,
				editableField($author$project$Api$Patient$Meta$genderIdentity),
				fields.PQ,
				fields.PP)),
			A2(
			ifSetting,
			function ($) {
				return $.$1;
			},
			A2(
				$author$project$Components$Patient$Form$viewPronounField,
				editableField($author$project$Api$Patient$Meta$pronouns),
				fields.Xh)),
			A3(
			$author$project$Components$Patient$Form$viewEmailField,
			settings,
			errorsFor(2),
			fields.Oo),
			A2(
			ifSetting,
			function ($) {
				return $.rr;
			},
			$author$project$Components$Patient$Form$viewPreferredLanguageField(fields.WV)),
			A2(
			$author$project$Components$Patient$Form$viewProfilePictureField,
			errorsFor(11),
			fields.p7),
			A2($author$project$Components$Patient$Form$viewPhonesField, settings, fields.Wi),
			$author$project$Components$Patient$Form$viewAddressField(fields.It),
			A2($author$project$Components$Patient$Form$viewUsesBillingAddressField, settings, fields.aaC),
			A3($author$project$Components$Patient$Form$viewBillingAddressField, settings, fields.aaC, fields.JZ),
			$author$project$Components$Patient$Form$viewEmergencyContact(fields.Oq),
			A2(
			ifSetting,
			function (_v1) {
				var ssnEnabled = _v1._D;
				var userIsAdmin = _v1.DF;
				var isNew = _v1.iX;
				return ssnEnabled && (userIsAdmin || isNew);
			},
			A3(
				$author$project$Components$Patient$Form$viewSsnField,
				errorsFor(6),
				settings.Ys,
				fields._C)),
			A2(
			ifSetting,
			function ($) {
				return $.aeA;
			},
			A2(
				$author$project$Components$Patient$Form$viewKnownPracticeField,
				errorsFor(7),
				fields.Ss)),
			A2(
			ifSetting,
			function ($) {
				return $.ahB;
			},
			A2(
				$author$project$Components$Patient$Form$viewTobaccoUseField,
				editableField($author$project$Api$Patient$Meta$usesTobacco),
				fields.oL)),
			A2(
			ifSetting,
			function ($) {
				return $.Qe;
			},
			A4(
				$author$project$Components$Patient$Form$viewPractitionerField,
				editableField($author$project$Api$Patient$Meta$practitionerId),
				settings.Yr,
				errorsFor(8),
				fields.afS)),
			A2(
			ifSetting,
			function (_v2) {
				var hasLocations = _v2.P8;
				var trackPatientsByLocation = _v2.$$;
				return hasLocations && trackPatientsByLocation;
			},
			A4(
				$author$project$Components$Patient$Form$viewLocationField,
				editableField($author$project$Api$Patient$Meta$locationId),
				settings.Ym,
				errorsFor(9),
				fields.aet)),
			A2(
			ifSetting,
			function ($) {
				return $.$f;
			},
			$author$project$Components$Patient$Form$viewAffiliateField(fields.DZ)),
			A2(
			$author$project$Components$Patient$Form$viewJoinedPracticeField,
			editableField($author$project$Api$Patient$Meta$joinedPracticeDate),
			fields.i_),
			A2(
			$author$project$Components$Patient$Form$viewHealthInsuranceField,
			editableField($author$project$Api$Patient$Meta$healthInsuranceCarrier),
			fields.Qj),
			A2(
			$author$project$Components$Patient$Form$viewLeadSourceField,
			editableField($author$project$Api$Patient$Meta$leadSourceId),
			fields.SH),
			A2(
			ifSetting,
			function ($) {
				return $.abL;
			},
			$author$project$Components$Patient$Form$viewSyncToEmrField(fields.$j))
		]);
};
var $author$project$Components$Employee$Form$viewEligibilityDate = F2(
	function (errors, _v0) {
		var eligibilityDate = _v0.a;
		var dateInput = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Eligibility Date'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$test('eligibility-date')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate),
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(eligibilityDate),
								$author$project$Components$DateInput$errors(errors)
							]),
						dateInput))
				]));
	});
var $author$project$Components$EmployeeDivisionInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$EmployeeDivisionInput$errors = $elm$core$Basics$identity;
var $author$project$Components$EmployeeDivisionInput$DivisionChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmployeeDivisionInput$divisionOptions = function (divisions) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Unassigned'),
		A2(
			$elm$core$List$map,
			function (division) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$EmployeeDivision$All$id(division)),
					$author$project$Api$EmployeeDivision$All$name(division));
			},
			divisions));
};
var $author$project$Components$EmployeeDivisionInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{fE: errors_});
	});
var $author$project$Components$EmployeeDivisionInput$view = F2(
	function (options, _v0) {
		var employeeDivisions = _v0.xp;
		var division = _v0.NT;
		if (employeeDivisions.$ === 3) {
			var divisions = employeeDivisions.a;
			var optionsRecord = A3(
				$elm$core$List$foldl,
				$author$project$Components$EmployeeDivisionInput$optionToRecord,
				{fE: _List_Nil},
				options);
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(division),
								$author$project$Ui$Form$Select$onChange($author$project$Components$EmployeeDivisionInput$DivisionChanged),
								$author$project$Ui$Form$Select$invalid(
								!$elm$core$List$isEmpty(optionsRecord.fE))
							]),
						$author$project$Components$EmployeeDivisionInput$divisionOptions(divisions)),
						$author$project$Utils$FormErrors$view(optionsRecord.fE)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$EmployeeDivisionInput$visible = function (_v0) {
	var employeeDivisions = _v0.xp;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
			$author$project$Api$Data$toMaybe(employeeDivisions)));
};
var $author$project$Components$Employee$Form$viewEmployeeDivision = F3(
	function (errors, settings, division) {
		return (settings.aaF && $author$project$Components$EmployeeDivisionInput$visible(division)) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Division'),
					$author$project$Ui$Form$Group$labelSpanMd(4),
					$author$project$Ui$Form$Group$inputSpanMd(8),
					$author$project$Ui$Form$Group$required(settings.Yl)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division),
					A2(
						$author$project$Components$EmployeeDivisionInput$view,
						_List_fromArray(
							[
								$author$project$Components$EmployeeDivisionInput$errors(errors)
							]),
						division))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Employee$Form$viewEmployeeId = F2(
	function (type_, id) {
		if (!id.$) {
			var id_ = id.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label(
							($author$project$Components$EmployeeDependentTypeInput$selectedType(type_) === 'employee') ? 'Employee ID' : 'Dependent ID'),
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(false),
							$author$project$Ui$Form$Group$test('registration-id')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(id_)
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Employee$Form$ExternalId = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Employee$Form$viewExternalId = function (externalId) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('External ID'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$test('externalId')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', externalId)),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$ExternalId))
					]))
			]));
};
var $author$project$Components$Employee$Form$Enroll = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Employee$Form$MembershipStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Employee$Form$viewMembershipStartDate = F3(
	function (currentDate, startDate, maybeEnroll) {
		if (!maybeEnroll.$) {
			var enroll = maybeEnroll.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Membership Start Date'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$test('membership-start-date')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										function () {
										if (enroll) {
											var dateOption = function (date) {
												return A3(
													$author$project$Ui$Form$Select$option,
													_List_Nil,
													$elm$core$Maybe$Just(
														$justinmimbs$date$Date$toIsoString(date)),
													A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
											};
											var options = A2(
												$elm$core$List$map,
												dateOption,
												A4(
													$justinmimbs$date$Date$range,
													2,
													1,
													A3($justinmimbs$date$Date$add, 1, -6, currentDate),
													A3($justinmimbs$date$Date$add, 1, 6, currentDate)));
											return A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														$elm$core$Maybe$Just(startDate)),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$MembershipStartDate))
													]),
												options);
										} else {
											return A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Will not be enrolled')
													]));
										}
									}()
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												enroll ? A3(
												$author$project$Ui$Button$view,
												{abp: 'Do not enroll yet'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Employee$Form$FieldUpdated(
															$author$project$Components$Employee$Form$Enroll(
																$elm$core$Maybe$Just(false))))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Do Not Enroll Yet')
													])) : A3(
												$author$project$Ui$Button$view,
												{abp: 'Set membership start date'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Employee$Form$FieldUpdated(
															$author$project$Components$Employee$Form$Enroll(
																$elm$core$Maybe$Just(true))))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Set membership start date')
													]))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$SponsorPlanInput$Errors = $elm$core$Basics$identity;
var $author$project$Components$SponsorPlanInput$errors = $elm$core$Basics$identity;
var $author$project$Components$SponsorPlanInput$optionToRecord = F2(
	function (option, acc) {
		var errors_ = option;
		return _Utils_update(
			acc,
			{fE: errors_});
	});
var $author$project$Components$SponsorPlanInput$view = F2(
	function (options, _v0) {
		var filter = _v0.Fi;
		var disabled = _v0.dW;
		var optionsRecord = A3(
			$elm$core$List$foldl,
			$author$project$Components$SponsorPlanInput$optionToRecord,
			{fE: _List_Nil},
			options);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$identity,
					A2(
						$author$project$Components$ResourceFilter$CompanyPlan$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0),
								$author$project$Components$ResourceFilter$invalid(
								!$elm$core$List$isEmpty(optionsRecord.fE)),
								$author$project$Components$ResourceFilter$disabled(disabled)
							]),
						filter)),
					$author$project$Utils$FormErrors$view(optionsRecord.fE)
				]));
	});
var $author$project$Components$Employee$Form$viewPlanField = F5(
	function (required, errors, type_, sponsorPlan, id) {
		var _v0 = _Utils_Tuple2(
			id,
			$author$project$Components$EmployeeDependentTypeInput$selectedType(type_));
		if ((_v0.a.$ === 1) && (_v0.b === 'employee')) {
			var _v1 = _v0.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Membership Plan'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$required(required),
						$author$project$Ui$Form$Group$test('membership-plan')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
						A2(
							$author$project$Components$SponsorPlanInput$view,
							_List_fromArray(
								[
									$author$project$Components$SponsorPlanInput$errors(errors)
								]),
							sponsorPlan))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$EmployeeDependentTypeInput$Errors = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$errors = $author$project$Components$EmployeeDependentTypeInput$Errors;
var $author$project$Components$EmployeeDependentTypeInput$Readonly = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$readonly = $author$project$Components$EmployeeDependentTypeInput$Readonly;
var $author$project$Components$EmployeeDependentTypeInput$TypeChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$EmployeeDependentTypeInput$defaultOptions = {fE: _List_Nil, sk: false};
var $author$project$Components$EmployeeDependentTypeInput$optionToRecord = F2(
	function (option, acc) {
		if (!option.$) {
			var errors_ = option.a;
			return _Utils_update(
				acc,
				{fE: errors_});
		} else {
			var bool = option.a;
			return _Utils_update(
				acc,
				{sk: bool});
		}
	});
var $author$project$Components$EmployeeDependentTypeInput$typeLabel = function (type_) {
	switch (type_) {
		case 'employee':
			return 'Employee';
		case 'spouse':
			return 'Adult';
		case 'child':
			return 'Child';
		default:
			var somethingElse = type_;
			return somethingElse;
	}
};
var $author$project$Components$EmployeeDependentTypeInput$typeOptions = A2(
	$elm$core$List$map,
	function (type_) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(type_),
			$author$project$Components$EmployeeDependentTypeInput$typeLabel(type_));
	},
	_List_fromArray(
		['employee', 'spouse', 'child']));
var $author$project$Components$ResourceFilter$CompanyAccount$view = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$view,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$EmployeeDependentTypeInput$view = F2(
	function (options, _v0) {
		var type_ = _v0.ahI;
		var dependentOfFilter = _v0.dV;
		var dependentOf = _v0.fs;
		var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$EmployeeDependentTypeInput$optionToRecord, $author$project$Components$EmployeeDependentTypeInput$defaultOptions, options);
		return _Utils_Tuple2(
			optionsRecord.sk ? A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Components$EmployeeDependentTypeInput$typeLabel(type_))
					])) : A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(type_)),
						$author$project$Ui$Form$Select$onChange($author$project$Components$EmployeeDependentTypeInput$TypeChanged)
					]),
				$author$project$Components$EmployeeDependentTypeInput$typeOptions),
			(type_ === 'employee') ? $elm$core$Maybe$Nothing : A2(
				$elm$core$Maybe$map,
				function (filter) {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						optionsRecord.sk ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Maybe$andThen, $author$project$Api$CompanyAccount$All$subscriberName, dependentOf)))
									]))
							]) : _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg,
								A2($author$project$Components$ResourceFilter$CompanyAccount$view, _List_Nil, filter)),
								$author$project$Utils$FormErrors$view(optionsRecord.fE)
							]));
				},
				dependentOfFilter));
	});
var $author$project$Components$Employee$Form$viewTypeField = F3(
	function (isNew, errors, typeInput) {
		var _v0 = A2(
			$author$project$Components$EmployeeDependentTypeInput$view,
			_List_fromArray(
				[
					$author$project$Components$EmployeeDependentTypeInput$readonly(!isNew),
					$author$project$Components$EmployeeDependentTypeInput$errors(errors)
				]),
			typeInput);
		var type_ = _v0.a;
		var maybeDependentOf = _v0.b;
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Type'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$required(!isNew),
						$author$project$Ui$Form$Group$test('registration-type')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
						type_)
					])),
			function () {
				if (!maybeDependentOf.$) {
					var dependentOf_ = maybeDependentOf.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Dependent Of'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(!isNew)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
									dependentOf_)
								]))
						]);
				} else {
					return _List_Nil;
				}
			}());
	});
var $author$project$Components$Employee$Form$view = function (_v0) {
	var settings = _v0.a;
	var form = _v0.b;
	var fields = $author$project$Utils$Form$fields(form);
	var patientFields = A2(
		$elm$core$List$map,
		$elm$html$Html$map($author$project$Components$Employee$Form$PatientFormMsg),
		$author$project$Components$Patient$Form$view(fields.VM));
	var externalIdField = _List_fromArray(
		[
			$author$project$Components$Employee$Form$viewExternalId(fields.ade)
		]);
	var errorsFor = function (group) {
		return A2($author$project$Utils$Form$validationErrors, group, form);
	};
	var otherEmployeeFields = fields.iX ? _List_fromArray(
		[
			A5(
			$author$project$Components$Employee$Form$viewPlanField,
			true,
			errorsFor(2),
			fields.ahI,
			fields.GH,
			fields.adR),
			A3($author$project$Components$Employee$Form$viewMembershipStartDate, settings.VM.cO, fields.TK, fields.OC),
			A2(
			$author$project$Components$Employee$Form$viewEligibilityDate,
			errorsFor(3),
			fields.cS)
		]) : _List_fromArray(
		[
			A3($author$project$Components$Employee$Form$viewMembershipStartDate, settings.VM.cO, fields.TK, fields.OC),
			A2(
			$author$project$Components$Employee$Form$viewEligibilityDate,
			errorsFor(3),
			fields.cS)
		]);
	var divisionField = _List_fromArray(
		[
			A3(
			$author$project$Components$Employee$Form$viewEmployeeDivision,
			errorsFor(4),
			settings.xn,
			fields.NT)
		]);
	var _v1 = A2($elm_community$list_extra$List$Extra$splitAt, 2, patientFields);
	var nameFields = _v1.a;
	var otherPatientFields = _v1.b;
	return _Utils_ap(
		A2($author$project$Components$Employee$Form$viewEmployeeId, fields.ahI, fields.adR),
		_Utils_ap(
			externalIdField,
			_Utils_ap(
				nameFields,
				_Utils_ap(
					A3(
						$author$project$Components$Employee$Form$viewTypeField,
						fields.iX,
						errorsFor(0),
						fields.ahI),
					_Utils_ap(
						divisionField,
						_Utils_ap(otherPatientFields, otherEmployeeFields))))));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Employees$Create$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
													{ff: model.adR}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('All Employees & Dependents')
													])),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('  /  New Employee or Dependent')
													]))
											])),
										$author$project$Ui$HorizontalRule$view(
										_List_fromArray(
											[$author$project$Ui$HorizontalRule$thin])),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('New Employee or Dependent')
											])),
										A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg),
											$author$project$Components$Employee$Form$view(model.an)))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
											{ff: model.adR}),
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{
											abp: $author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText(model.an)
										},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(model.kj)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText(model.an))
											]))
									]))
							]))
					]))
			]),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + (' | ' + model.adR)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Create$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Employees$Create$init, aer: $author$project$Pages$Companies$CompanyId_String$Employees$Create$load, agD: $author$project$Pages$Companies$CompanyId_String$Employees$Create$save, ahd: $author$project$Pages$Companies$CompanyId_String$Employees$Create$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Employees$Create$update, ahP: $author$project$Pages$Companies$CompanyId_String$Employees$Create$view});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyRegistration = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$CompanyAccount$retrieve = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$CompanyAccount$companyAccountPath(id)));
	});
var $author$project$Api$CompanyAccount$retrieve = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$retrieve,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Account$retrieve,
			apiClient,
			companyId,
			id,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$retrieve = F4(
	function (apiClient, accountId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, id)));
	});
var $author$project$Api$Provider$Company$Registration$retrieve = F5(
	function (apiClient, companyId, companyAccountId, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, id)));
	});
var $author$project$Api$CompanyRegistration$retrieve = F6(
	function (apiClient, session, companyId, companyAccoutId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyRegistration$retrieve,
			apiClient,
			companyAccoutId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Registration$retrieve,
			apiClient,
			companyId,
			companyAccoutId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var model = {D5: shared.D5, ab9: company, Lr: $author$project$Api$Data$Loading, Ls: params.acX, ff: params.ff, Ly: $author$project$Api$Data$Loading, ED: params.acF, cO: shared.cO, an: $elm$core$Maybe$Nothing, adN: shared.adN, TU: $author$project$Api$Data$Loading, afu: shared.afu, VM: $author$project$Api$Data$Loading, WF: practice, jY: $author$project$Api$Data$NotAsked, ZD: session, kj: false};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5($author$project$Api$CompanyAccount$retrieve, shared.D5, session, params.ff, params.acX, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyAccount),
						A6($author$project$Api$CompanyRegistration$retrieve, shared.D5, session, params.ff, params.acX, params.acF, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyRegistration)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$subscriptions = function (model) {
	var _v0 = model.an;
	if (!_v0.$) {
		var employeeForm = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg,
			$author$project$Components$Employee$Form$subscriptions(employeeForm));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyAccountUpdated = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyRegistrationUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotMeta = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotPatient = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$CompanyAccount$One$division = function (_v0) {
	var record = _v0.b;
	return record.NT;
};
var $author$project$Api$Provider$CompanyAccount$One$division = function (_v0) {
	var record = _v0.b;
	return record.NT;
};
var $author$project$Api$CompanyAccount$One$division = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$EmployeeDivision$All$Provider,
			$author$project$Api$Provider$CompanyAccount$One$division(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$EmployeeDivision$All$Employer,
			$author$project$Api$Employer$CompanyAccount$One$division(companyAccount_));
	}
};
var $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate = function (_v0) {
	var record = _v0;
	return record.Ol;
};
var $author$project$Api$Employer$CompanyAccount$One$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate = function (_v0) {
	var record = _v0.b;
	return record.Ol;
};
var $author$project$Api$Provider$CompanyAccount$One$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$CompanyAccount$One$eligibilityStartDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$One$eligibilityStartDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$One$eligibilityStartDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ade;
};
var $author$project$Api$Employer$CompanyRegistration$One$externalId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$externalId(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$externalId = function (_v0) {
	var record = _v0;
	return record.ade;
};
var $author$project$Api$Provider$CompanyRegistration$One$externalId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$externalId(shared);
};
var $author$project$Api$CompanyRegistration$One$externalId = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$One$externalId(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$One$externalId(companyRegistration_);
	}
};
var $author$project$Components$EmployeeDependentTypeInput$fill = F3(
	function (session, company, type_) {
		return _Utils_Tuple2(
			{ab9: company, fs: $elm$core$Maybe$Nothing, dV: $elm$core$Maybe$Nothing, ZD: session, ahI: type_},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$EmployeeDivisionInput$fill = F4(
	function (session, companyId, apiClient, division) {
		return _Utils_Tuple2(
			{D5: apiClient, NT: division, xp: $author$project$Api$Data$Loading, agk: false, ZD: session},
			A5(
				$author$project$Api$EmployeeDivision$list,
				apiClient,
				session,
				companyId,
				function (d) {
					return d;
				},
				$author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions));
	});
var $author$project$Api$Employer$Patient$One$address = function (_v0) {
	var record = _v0.b;
	return record.It;
};
var $author$project$Api$Patient$One$address = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$address(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$address(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$assignedAffiliation = function (_v0) {
	var record = _v0.b;
	return record.Jp;
};
var $author$project$Api$Provider$Patient$One$assignedAffiliation = function (_v0) {
	var record = _v0.b;
	return record.Jp;
};
var $author$project$Api$Patient$One$assignedAffiliation = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Provider,
			$author$project$Api$Provider$Patient$One$assignedAffiliation(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Affiliate$AffiliateMin$Employer,
			$author$project$Api$Employer$Patient$One$assignedAffiliation(patient_));
	}
};
var $author$project$Api$Employer$Patient$One$billingAddress = function (_v0) {
	var record = _v0.b;
	return record.JZ;
};
var $author$project$Api$Patient$One$billingAddress = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$billingAddress(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$billingAddress(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$chosenFirstName = function (_v0) {
	var record = _v0.b;
	return record.KX;
};
var $author$project$Api$Provider$Patient$Shared$chosenFirstName = function (_v0) {
	var shared = _v0;
	return shared.KX;
};
var $author$project$Api$Provider$Patient$One$chosenFirstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenFirstName(shared);
};
var $author$project$Api$Patient$One$chosenFirstName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenFirstName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenFirstName(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$chosenLastName = function (_v0) {
	var record = _v0.b;
	return record.KY;
};
var $author$project$Api$Provider$Patient$Shared$chosenLastName = function (_v0) {
	var shared = _v0;
	return shared.KY;
};
var $author$project$Api$Provider$Patient$One$chosenLastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenLastName(shared);
};
var $author$project$Api$Patient$One$chosenLastName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenLastName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenLastName(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$chosenMiddleName = function (_v0) {
	var record = _v0.b;
	return record.KZ;
};
var $author$project$Api$Provider$Patient$Shared$chosenMiddleName = function (_v0) {
	var shared = _v0;
	return shared.KZ;
};
var $author$project$Api$Provider$Patient$One$chosenMiddleName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenMiddleName(shared);
};
var $author$project$Api$Patient$One$chosenMiddleName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenMiddleName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenMiddleName(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$chosenTitle = function (_v0) {
	var record = _v0.b;
	return record.K$;
};
var $author$project$Api$Provider$Patient$Shared$chosenTitle = function (_v0) {
	var shared = _v0;
	return shared.K$;
};
var $author$project$Api$Provider$Patient$One$chosenTitle = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenTitle(shared);
};
var $author$project$Api$Patient$One$chosenTitle = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenTitle(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenTitle(patient_);
	}
};
var $author$project$Components$Patient$Form$chosenNamePresent = function (patient) {
	return $author$project$Utils$Maybe$toBool(
		$author$project$Api$Patient$One$chosenTitle(patient)) || ($author$project$Utils$Maybe$toBool(
		$author$project$Api$Patient$One$chosenFirstName(patient)) || ($author$project$Utils$Maybe$toBool(
		$author$project$Api$Patient$One$chosenMiddleName(patient)) || $author$project$Utils$Maybe$toBool(
		$author$project$Api$Patient$One$chosenLastName(patient))));
};
var $author$project$Api$Employer$Patient$One$chosenSuffix = function (_v0) {
	var record = _v0.b;
	return record.K_;
};
var $author$project$Api$Provider$Patient$Shared$chosenSuffix = function (_v0) {
	var shared = _v0;
	return shared.K_;
};
var $author$project$Api$Provider$Patient$One$chosenSuffix = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$chosenSuffix(shared);
};
var $author$project$Api$Patient$One$chosenSuffix = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$chosenSuffix(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$chosenSuffix(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$dob = function (_v0) {
	var record = _v0;
	return record.acQ;
};
var $author$project$Api$Employer$Patient$One$dob = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$dob(shared);
};
var $author$project$Api$Provider$Patient$Shared$dob = function (_v0) {
	var shared = _v0;
	return shared.acQ;
};
var $author$project$Api$Provider$Patient$One$dob = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$dob(shared);
};
var $author$project$Api$Patient$One$dob = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$dob(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$dob(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Employer$Patient$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$email(shared);
};
var $author$project$Api$Patient$One$email = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$email(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$email(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$emergencyContact = function (_v0) {
	var record = _v0.b;
	return record.Oq;
};
var $author$project$Api$Provider$Patient$One$emergencyContact = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Oq;
	});
var $author$project$Api$Patient$One$emergencyContact = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$emergencyContact(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$emergencyContact(patient_);
	}
};
var $author$project$Components$Patient$Form$GotPlainSSN = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$Patient$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$Patient$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$id(shared);
};
var $author$project$Api$Patient$One$id = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$id(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$id(patient_);
	}
};
var $author$project$Api$Provider$SocialSecurityNumber$One$SocialSecurityNumber = $elm$core$Basics$identity;
var $author$project$Api$Provider$SocialSecurityNumber$One$Record = function (formattedNumber) {
	return {PF: formattedNumber};
};
var $author$project$Api$Provider$SocialSecurityNumber$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'formatted_number',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$SocialSecurityNumber$One$Record));
var $author$project$Api$Provider$SocialSecurityNumber$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SocialSecurityNumber$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$SocialSecurityNumber$ssnPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['social_security_number']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[patientId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['patients']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$SocialSecurityNumber$retrieve = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$SocialSecurityNumber$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$SocialSecurityNumber$ssnPath(patientId)));
	});
var $author$project$Components$Patient$Form$fetchPlainSSN = F3(
	function (apiClient, session, patient) {
		var _v0 = $author$project$Api$Platform$Session$One$role(session);
		if (_v0 === 'practice_admin') {
			return A3(
				$author$project$Api$Provider$SocialSecurityNumber$retrieve,
				apiClient,
				$author$project$Api$Patient$One$id(patient),
				$author$project$Components$Patient$Form$GotPlainSSN);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Employer$Patient$Shared$firstName = function (_v0) {
	var shared = _v0;
	return shared.Pu;
};
var $author$project$Api$Employer$Patient$One$firstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$firstName(shared);
};
var $author$project$Api$Provider$Patient$Shared$firstName = function (_v0) {
	var shared = _v0;
	return shared.Pu;
};
var $author$project$Api$Provider$Patient$One$firstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$firstName(shared);
};
var $author$project$Api$Patient$One$firstName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$firstName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$firstName(patient_);
	}
};
var $author$project$Api$Gender$fromString = function (gender) {
	switch (gender) {
		case 'male':
			return $elm$core$Maybe$Just(0);
		case 'female':
			return $elm$core$Maybe$Just(1);
		case 'intersex':
			return $elm$core$Maybe$Just(2);
		case 'other':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Patient$Shared$gender = function (_v0) {
	var shared = _v0;
	return shared.PO;
};
var $author$project$Api$Employer$Patient$One$gender = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$gender(shared);
};
var $author$project$Api$Provider$Patient$Shared$gender = function (_v0) {
	var shared = _v0;
	return shared.PO;
};
var $author$project$Api$Provider$Patient$One$gender = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$gender(shared);
};
var $author$project$Api$Patient$One$gender = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$gender(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$gender(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$genderIdentity = function (_v0) {
	var shared = _v0;
	return shared.PP;
};
var $author$project$Api$Employer$Patient$One$genderIdentity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$genderIdentity(shared);
};
var $author$project$Api$Provider$Patient$Shared$genderIdentity = function (_v0) {
	var shared = _v0;
	return shared.PP;
};
var $author$project$Api$Provider$Patient$One$genderIdentity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$genderIdentity(shared);
};
var $author$project$Api$Patient$One$genderIdentity = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$genderIdentity(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$genderIdentity(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$genderOther = function (_v0) {
	var shared = _v0;
	return shared.PQ;
};
var $author$project$Api$Employer$Patient$One$genderOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$genderOther(shared);
};
var $author$project$Api$Provider$Patient$Shared$genderOther = function (_v0) {
	var shared = _v0;
	return shared.PQ;
};
var $author$project$Api$Provider$Patient$One$genderOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$genderOther(shared);
};
var $author$project$Api$Patient$One$genderOther = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$genderOther(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$genderOther(patient_);
	}
};
var $author$project$Api$HealthInsurance$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$HealthInsurance$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Patient$One$healthInsurance = function (_v0) {
	var record = _v0.b;
	return record.Qj;
};
var $author$project$Api$Provider$Patient$One$healthInsurance = function (_v0) {
	var record = _v0.b;
	return record.Qj;
};
var $author$project$Api$Patient$One$healthInsurance = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$HealthInsurance$Shared$Provider,
			$author$project$Api$Provider$Patient$One$healthInsurance(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$HealthInsurance$Shared$Employer,
			$author$project$Api$Employer$Patient$One$healthInsurance(patient_));
	}
};
var $author$project$Api$Employer$LeadSource$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$LeadSource$Shared$id = function (leadSource) {
	if (!leadSource.$) {
		var leadSource_ = leadSource.a;
		return $author$project$Api$Provider$LeadSource$Shared$id(leadSource_);
	} else {
		var leadSource_ = leadSource.a;
		return $author$project$Api$Employer$LeadSource$Shared$id(leadSource_);
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$carrier = function (_v0) {
	var record = _v0;
	return record.KJ;
};
var $author$project$Api$Provider$HealthInsurance$Shared$carrier = function (_v0) {
	var shared = _v0;
	return shared.KJ;
};
var $author$project$Api$HealthInsurance$Shared$carrier = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return A2(
			$elm$core$Maybe$map,
			function (carrier_) {
				return $author$project$Api$HealthInsuranceCarrier$Shared$Provider(carrier_);
			},
			$author$project$Api$Provider$HealthInsurance$Shared$carrier(insurance_));
	} else {
		var insurance_ = insurance.a;
		return A2(
			$elm$core$Maybe$map,
			function (carrier_) {
				return $author$project$Api$HealthInsuranceCarrier$Shared$Employer(carrier_);
			},
			$author$project$Api$Employer$HealthInsurance$Shared$carrier(insurance_));
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$groupId = function (_v0) {
	var record = _v0;
	return record.PY;
};
var $author$project$Api$Provider$HealthInsurance$Shared$groupId = function (_v0) {
	var shared = _v0;
	return shared.PY;
};
var $author$project$Api$HealthInsurance$Shared$groupId = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return $author$project$Api$Provider$HealthInsurance$Shared$groupId(insurance_);
	} else {
		var insurance_ = insurance.a;
		return $author$project$Api$Employer$HealthInsurance$Shared$groupId(insurance_);
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$highDeductible = function (_v0) {
	var record = _v0;
	return record.Qq;
};
var $author$project$Api$Provider$HealthInsurance$Shared$highDeductible = function (_v0) {
	var shared = _v0;
	return shared.Qq;
};
var $author$project$Api$HealthInsurance$Shared$highDeductible = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return $author$project$Api$Provider$HealthInsurance$Shared$highDeductible(insurance_);
	} else {
		var insurance_ = insurance.a;
		return $author$project$Api$Employer$HealthInsurance$Shared$highDeductible(insurance_);
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$memberId = function (_v0) {
	var record = _v0;
	return record.Tz;
};
var $author$project$Api$Provider$HealthInsurance$Shared$memberId = function (_v0) {
	var shared = _v0;
	return shared.Tz;
};
var $author$project$Api$HealthInsurance$Shared$memberId = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return $author$project$Api$Provider$HealthInsurance$Shared$memberId(insurance_);
	} else {
		var insurance_ = insurance.a;
		return $author$project$Api$Employer$HealthInsurance$Shared$memberId(insurance_);
	}
};
var $author$project$Api$Employer$HealthInsurance$Shared$payerName = function (_v0) {
	var record = _v0;
	return record.VV;
};
var $author$project$Api$Provider$HealthInsurance$Shared$payerName = function (_v0) {
	var shared = _v0;
	return shared.VV;
};
var $author$project$Api$HealthInsurance$Shared$payerName = function (insurance) {
	if (!insurance.$) {
		var insurance_ = insurance.a;
		return $author$project$Api$Provider$HealthInsurance$Shared$payerName(insurance_);
	} else {
		var insurance_ = insurance.a;
		return $author$project$Api$Employer$HealthInsurance$Shared$payerName(insurance_);
	}
};
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bb);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bb: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				G0: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$HealthInsuranceInput$init = F3(
	function (apiClient, session, healthInsurance) {
		var insuranceCarrier = function () {
			var _v3 = $author$project$Api$HealthInsurance$Shared$carrier(healthInsurance);
			if (!_v3.$) {
				var carrier = _v3.a;
				return $author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias(
					{
						Eu: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrier),
						KK: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier),
						Ev: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrier),
						Ew: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrier),
						zh: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
					});
			} else {
				return $author$project$Components$HealthInsuranceInput$Other(
					{
						zh: A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
					});
			}
		}();
		var healthInsuranceRecord = {
			PY: $author$project$Api$HealthInsurance$Shared$groupId(healthInsurance),
			Qq: $author$project$Api$HealthInsurance$Shared$highDeductible(healthInsurance),
			Tz: $author$project$Api$HealthInsurance$Shared$memberId(healthInsurance),
			VV: $author$project$Api$HealthInsurance$Shared$payerName(healthInsurance)
		};
		var _v0 = function (_v1) {
			var filter = _v1.a;
			var filterCmd = _v1.b;
			var _v2 = $author$project$Api$HealthInsurance$Shared$carrier(healthInsurance);
			if (!_v2.$) {
				var carrier = _v2.a;
				var insuranceAlias = {
					Eu: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrier),
					KK: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier),
					Ev: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrier),
					Ew: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrier),
					zh: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
				};
				return _Utils_Tuple2(
					A2(
						$author$project$Components$ResourceFilter$InsuranceCarrierAlias$setValue,
						$elm$core$Maybe$Just(insuranceAlias),
						filter),
					filterCmd);
			} else {
				return A2(
					$elm$core$Tuple$mapSecond,
					function (preSelectedIdCmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[filterCmd, preSelectedIdCmd]));
					},
					A2(
						$author$project$Components$ResourceFilter$InsuranceCarrierAlias$preSelectedId,
						$elm$core$Maybe$Just(''),
						filter));
			}
		}(
			A3(
				$author$project$Components$ResourceFilter$InsuranceCarrierAlias$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'None', UL: 'Other (Enter insurance carrier name manually)', aeZ: true});
				}));
		var insuranceCarrierAliasFilter = _v0.a;
		var insuranceCarrierAliasCmd = _v0.b;
		return _Utils_Tuple2(
			A3(
				$author$project$Components$HealthInsuranceInput$Model,
				insuranceCarrierAliasFilter,
				{dW: false},
				$elm$core$Maybe$Just(
					_Utils_Tuple2(insuranceCarrier, healthInsuranceRecord))),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, insuranceCarrierAliasCmd));
	});
var $author$project$Api$KnownPractice$Shared$id = function (knownPractice) {
	if (!knownPractice.$) {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Provider$KnownPractice$Shared$id(knownPractice_);
	} else {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Employer$KnownPractice$Shared$id(knownPractice_);
	}
};
var $author$project$Api$KnownPractice$Shared$name = function (knownPractice) {
	if (!knownPractice.$) {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Provider$KnownPractice$Shared$name(knownPractice_);
	} else {
		var knownPractice_ = knownPractice.a;
		return $author$project$Api$Employer$KnownPractice$Shared$name(knownPractice_);
	}
};
var $author$project$Components$ResourceFilter$KnownPractice$setValue = F2(
	function (resource, model) {
		return _Utils_update(
			model,
			{
				G0: function () {
					if (!resource.$) {
						var resource_ = resource.a;
						return $author$project$Components$ResourceFilter$One(resource_);
					} else {
						return $author$project$Components$ResourceFilter$All;
					}
				}()
			});
	});
var $author$project$Components$KnownPracticeInput$init = F3(
	function (apiClient, session, knownPractice) {
		var knownPractice_ = {
			adR: $author$project$Api$KnownPractice$Shared$id(knownPractice),
			zh: $author$project$Api$KnownPractice$Shared$name(knownPractice)
		};
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			function (filter) {
				return A2(
					$author$project$Components$ResourceFilter$KnownPractice$setValue,
					$elm$core$Maybe$Just(knownPractice_),
					filter);
			},
			A3(
				$author$project$Components$ResourceFilter$KnownPractice$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'Select a DPC practice', UL: 'Other (Enter your DPC manually)', aeZ: true});
				}));
		var knownPracticeFilter = _v0.a;
		var knownPracticeCmd = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$KnownPracticeInput$Model,
				knownPracticeFilter,
				$elm$core$Maybe$Just(
					$author$project$Components$KnownPracticeInput$KnownPractice(knownPractice_))),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, knownPracticeCmd));
	});
var $author$project$Components$LeadSourceInput$init = F3(
	function (apiClient, selected, other) {
		var _v0 = A2($author$project$Components$LeadSourceInput$initLeadSourceResourceFilter, apiClient, selected);
		var leadSourceResourceFilter = _v0.a;
		var leadSourceResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{dW: false, mQ: leadSourceResourceFilter, c2: other, ag: selected},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd));
	});
var $author$project$Components$NameInput$init = function (fields) {
	return A3(
		$author$project$Components$NameInput$Model,
		_List_Nil,
		{dW: false, ti: ''},
		fields);
};
var $author$project$Api$Employer$Patient$Shared$joinedPracticeDate = function (_v0) {
	var shared = _v0;
	return shared.Sq;
};
var $author$project$Api$Employer$Patient$One$joinedPracticeDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$joinedPracticeDate(shared);
};
var $author$project$Api$Provider$Patient$Shared$joinedPracticeDate = function (_v0) {
	var shared = _v0;
	return shared.Sq;
};
var $author$project$Api$Provider$Patient$One$joinedPracticeDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$joinedPracticeDate(shared);
};
var $author$project$Api$Patient$One$joinedPracticeDate = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$joinedPracticeDate(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$joinedPracticeDate(patient_);
	}
};
var $author$project$Api$KnownPractice$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$KnownPractice$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Patient$One$knownPractice = function (_v0) {
	var record = _v0.b;
	return record.Ss;
};
var $author$project$Api$Provider$Patient$One$knownPractice = function (_v0) {
	var record = _v0.b;
	return record.Ss;
};
var $author$project$Api$Patient$One$knownPractice = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$KnownPractice$Shared$Provider,
			$author$project$Api$Provider$Patient$One$knownPractice(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$KnownPractice$Shared$Employer,
			$author$project$Api$Employer$Patient$One$knownPractice(patient_));
	}
};
var $author$project$Api$Employer$Patient$Shared$lastName = function (_v0) {
	var shared = _v0;
	return shared.SA;
};
var $author$project$Api$Employer$Patient$One$lastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$lastName(shared);
};
var $author$project$Api$Provider$Patient$Shared$lastName = function (_v0) {
	var shared = _v0;
	return shared.SA;
};
var $author$project$Api$Provider$Patient$One$lastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$lastName(shared);
};
var $author$project$Api$Patient$One$lastName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$lastName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$lastName(patient_);
	}
};
var $author$project$Api$LeadSource$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$LeadSource$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Patient$One$leadSource = function (_v0) {
	var record = _v0.b;
	return record.SH;
};
var $author$project$Api$Provider$Patient$One$leadSource = function (_v0) {
	var record = _v0.b;
	return record.SH;
};
var $author$project$Api$Patient$One$leadSource = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$LeadSource$Shared$Provider,
			$author$project$Api$Provider$Patient$One$leadSource(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$LeadSource$Shared$Employer,
			$author$project$Api$Employer$Patient$One$leadSource(patient_));
	}
};
var $author$project$Api$Employer$Patient$Shared$leadSourceOther = function (_v0) {
	var shared = _v0;
	return shared.SJ;
};
var $author$project$Api$Employer$Patient$One$leadSourceOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$leadSourceOther(shared);
};
var $author$project$Api$Provider$Patient$Shared$leadSourceOther = function (_v0) {
	var shared = _v0;
	return shared.SJ;
};
var $author$project$Api$Provider$Patient$One$leadSourceOther = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$leadSourceOther(shared);
};
var $author$project$Api$Patient$One$leadSourceOther = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$leadSourceOther(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$leadSourceOther(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$location = function (_v0) {
	var record = _v0.b;
	return record.aet;
};
var $author$project$Api$Patient$One$location = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Location$Shared$Provider,
			$author$project$Api$Provider$Patient$One$location(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Location$Shared$Employer,
			$author$project$Api$Employer$Patient$One$location(patient_));
	}
};
var $author$project$Api$Employer$Patient$Shared$middleName = function (_v0) {
	var shared = _v0;
	return shared.TX;
};
var $author$project$Api$Employer$Patient$One$middleName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$middleName(shared);
};
var $author$project$Api$Provider$Patient$Shared$middleName = function (_v0) {
	var shared = _v0;
	return shared.TX;
};
var $author$project$Api$Provider$Patient$One$middleName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$middleName(shared);
};
var $author$project$Api$Patient$One$middleName = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$middleName(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$middleName(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$phones = function (_v0) {
	var record = _v0.b;
	return record.Wi;
};
var $author$project$Api$Provider$Patient$One$phones = function (_v0) {
	var record = _v0.b;
	return record.Wi;
};
var $author$project$Api$Patient$One$phones = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$phones(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$phones(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$practitioner = function (_v0) {
	var record = _v0.b;
	return record.afS;
};
var $author$project$Api$Patient$One$practitioner = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practitioner$Shared$Provider,
			$author$project$Api$Provider$Patient$One$practitioner(patient_));
	} else {
		var patient_ = patient.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practitioner$Shared$Employer,
			$author$project$Api$Employer$Patient$One$practitioner(patient_));
	}
};
var $author$project$Api$Employer$Patient$One$preferredLanguage = function (_v0) {
	var record = _v0.b;
	return record.WV;
};
var $author$project$Api$Provider$Patient$One$preferredLanguage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.WV;
	});
var $author$project$Api$Patient$One$preferredLanguage = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$preferredLanguage(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$preferredLanguage(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$profilePictureUrl = function (_v0) {
	var record = _v0.b;
	return record.Xg;
};
var $author$project$Api$Provider$Patient$One$profilePictureUrl = function (_v0) {
	var record = _v0.b;
	return record.Xg;
};
var $author$project$Api$Patient$One$profilePictureUrl = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$profilePictureUrl(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$profilePictureUrl(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$pronoun = function (_v0) {
	var shared = _v0;
	return shared.Xh;
};
var $author$project$Api$Employer$Patient$One$pronoun = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$pronoun(shared);
};
var $author$project$Api$Provider$Patient$Shared$pronoun = function (_v0) {
	var shared = _v0;
	return shared.Xh;
};
var $author$project$Api$Provider$Patient$One$pronoun = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$pronoun(shared);
};
var $author$project$Api$Patient$One$pronoun = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$pronoun(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$pronoun(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$sex = function (_v0) {
	var shared = _v0;
	return shared.ZH;
};
var $author$project$Api$Employer$Patient$One$sex = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$sex(shared);
};
var $author$project$Api$Provider$Patient$Shared$sex = function (_v0) {
	var shared = _v0;
	return shared.ZH;
};
var $author$project$Api$Provider$Patient$One$sex = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$sex(shared);
};
var $author$project$Api$Patient$One$sex = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$sex(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$sex(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$suffix = function (_v0) {
	var record = _v0.b;
	return record._8;
};
var $author$project$Api$Provider$Patient$One$suffix = function (_v0) {
	var record = _v0.b;
	return record._8;
};
var $author$project$Api$Patient$One$suffix = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$suffix(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$suffix(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$syncToEmr = function (_v0) {
	var shared = _v0;
	return shared.$j;
};
var $author$project$Api$Employer$Patient$One$syncToEmr = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$syncToEmr(shared);
};
var $author$project$Api$Provider$Patient$Shared$syncToEmr = function (_v0) {
	var shared = _v0;
	return shared.$j;
};
var $author$project$Api$Provider$Patient$One$syncToEmr = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$syncToEmr(shared);
};
var $author$project$Api$Patient$One$syncToEmr = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$syncToEmr(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$syncToEmr(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$title = function (_v0) {
	var record = _v0.b;
	return record.$G;
};
var $author$project$Api$Provider$Patient$One$title = function (_v0) {
	var record = _v0.b;
	return record.$G;
};
var $author$project$Api$Patient$One$title = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$title(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$title(patient_);
	}
};
var $author$project$Api$Employer$Patient$One$usesBillingAddress = function (_v0) {
	var record = _v0.b;
	return record.aaC;
};
var $author$project$Api$Provider$Patient$One$usesBillingAddress = function (_v0) {
	var record = _v0.b;
	return record.aaC;
};
var $author$project$Api$Patient$One$usesBillingAddress = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$usesBillingAddress(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$usesBillingAddress(patient_);
	}
};
var $author$project$Api$Employer$Patient$Shared$usesTobacco = function (_v0) {
	var shared = _v0;
	return shared.aaI;
};
var $author$project$Api$Employer$Patient$One$usesTobacco = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Patient$Shared$usesTobacco(shared);
};
var $author$project$Api$Provider$Patient$Shared$usesTobacco = function (_v0) {
	var shared = _v0;
	return shared.aaI;
};
var $author$project$Api$Provider$Patient$One$usesTobacco = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
};
var $author$project$Api$Patient$One$usesTobacco = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$One$usesTobacco(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$One$usesTobacco(patient_);
	}
};
var $author$project$Components$Patient$Form$fill = F8(
	function (apiClient, session, currentDate, company, isEmployeeForm, patient, meta, settingsMapper) {
		var settings = function () {
			var defaultSettings_ = A3($author$project$Components$Patient$Form$defaultSettings, currentDate, false, isEmployeeForm);
			return settingsMapper(
				_Utils_update(
					defaultSettings_,
					{
						TU: $elm$core$Maybe$Just(meta)
					}));
		}();
		var practitionerOptionals = function () {
			var locationId = (settings.P8 && settings.$$) ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Location$Shared$id,
				$author$project$Api$Patient$One$location(patient)) : $elm$core$Maybe$Nothing;
			var affiliateId = settings.$f ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Affiliate$AffiliateMin$id,
				$author$project$Api$Patient$One$assignedAffiliation(patient)) : $elm$core$Maybe$Nothing;
			return A5(
				$author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras,
				isEmployeeForm,
				company,
				locationId,
				affiliateId,
				_List_fromArray(
					[1]));
		}();
		var phones = A2(
			$elm$core$List$map,
			$author$project$Utils$Phone$fromApi,
			$author$project$Api$Patient$One$phones(patient));
		var phonesInput = A3(
			$author$project$Components$PhoneInput$init,
			'patient-phones',
			phones,
			function (d) {
				return _Utils_update(
					d,
					{Ik: true});
			});
		var optionals = function () {
			var practitionerId = settings.Qe ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Practitioner$Shared$id,
				$author$project$Api$Patient$One$practitioner(patient)) : $elm$core$Maybe$Nothing;
			var affiliateId = settings.$f ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Affiliate$AffiliateMin$id,
				$author$project$Api$Patient$One$assignedAffiliation(patient)) : $elm$core$Maybe$Nothing;
			return A4($author$project$Components$Patient$Form$locationOptionals, isEmployeeForm, company, practitionerId, affiliateId);
		}();
		var legalNameFields = {
			Pu: $author$project$Api$Patient$One$firstName(patient),
			SA: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Patient$One$lastName(patient)),
			TX: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Patient$One$middleName(patient)),
			_8: $author$project$Api$Patient$One$suffix(patient),
			$G: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Patient$One$title(patient))
		};
		var currentProfilePictureUrl = $author$project$Api$Patient$One$profilePictureUrl(patient);
		var chosenNameFields = $author$project$Components$Patient$Form$chosenNamePresent(patient) ? $elm$core$Maybe$Just(
			$author$project$Components$NameInput$init(
				{
					Pu: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Patient$One$chosenFirstName(patient)),
					SA: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Patient$One$chosenLastName(patient)),
					TX: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Patient$One$chosenMiddleName(patient)),
					_8: $author$project$Api$Patient$One$chosenSuffix(patient),
					$G: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Patient$One$chosenTitle(patient))
				})) : $elm$core$Maybe$Nothing;
		var _v0 = A3(
			$author$project$Components$PractitionerInput$init,
			apiClient,
			practitionerOptionals,
			$author$project$Api$Patient$One$practitioner(patient));
		var practitioner = _v0.a;
		var practitionerCmd = _v0.b;
		var _v1 = A3(
			$author$project$Components$LocationInput$init,
			apiClient,
			optionals,
			$author$project$Api$Patient$One$location(patient));
		var location = _v1.a;
		var locationCmd = _v1.b;
		var _v2 = function () {
			var maybeLeadSourceId = A2(
				$elm$core$Maybe$map,
				$author$project$Api$LeadSource$Shared$id,
				$author$project$Api$Patient$One$leadSource(patient));
			return A3(
				$author$project$Components$LeadSourceInput$init,
				apiClient,
				maybeLeadSourceId,
				$author$project$Api$Patient$One$leadSourceOther(patient));
		}();
		var leadSource = _v2.a;
		var leadSourceCmd = _v2.b;
		var _v3 = function () {
			var _v4 = $author$project$Api$Patient$One$knownPractice(patient);
			if (!_v4.$) {
				var knownPractice_ = _v4.a;
				return A3($author$project$Components$KnownPracticeInput$init, apiClient, session, knownPractice_);
			} else {
				return A2($author$project$Components$KnownPracticeInput$empty, apiClient, session);
			}
		}();
		var knownPractice = _v3.a;
		var knownPracticeCmd = _v3.b;
		var _v5 = function () {
			var _v6 = $author$project$Api$Patient$One$healthInsurance(patient);
			if (!_v6.$) {
				var insurance_ = _v6.a;
				return A3($author$project$Components$HealthInsuranceInput$init, apiClient, session, insurance_);
			} else {
				return A2($author$project$Components$HealthInsuranceInput$empty, apiClient, session);
			}
		}();
		var healthInsurance = _v5.a;
		var healthInsuranceCmd = _v5.b;
		var _v7 = $author$project$Components$DateInput$init;
		var dateInput = _v7.a;
		var dateInputCmd = _v7.b;
		var _v8 = A2(
			$author$project$Components$AddressInput$initFromApi,
			'patient-billing-address',
			$author$project$Api$Patient$One$billingAddress(patient));
		var billingAddress = _v8.a;
		var billingAddressCmd = _v8.b;
		var _v9 = function () {
			var resource = A2(
				$elm$core$Maybe$map,
				$author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin,
				$author$project$Api$Patient$One$assignedAffiliation(patient));
			var practitionerId = settings.Qe ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Practitioner$Shared$id,
				$author$project$Api$Patient$One$practitioner(patient)) : $elm$core$Maybe$Nothing;
			var locationId = (settings.P8 && settings.$$) ? A2(
				$elm$core$Maybe$map,
				$author$project$Api$Location$Shared$id,
				$author$project$Api$Patient$One$location(patient)) : $elm$core$Maybe$Nothing;
			var filteredAffiliateOptionals = A2($author$project$Components$Patient$Form$affiliateOptionals, practitionerId, locationId);
			return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, resource);
		}();
		var affiliate = _v9.a;
		var affiliateCmd = _v9.b;
		var _v10 = A2(
			$author$project$Components$AddressInput$initFromApi,
			'patient-address',
			$author$project$Api$Patient$One$address(patient));
		var address = _v10.a;
		var addressCmd = _v10.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				$author$project$Utils$Form$init(
					{
						It: address,
						DZ: affiliate,
						JZ: $elm$core$Maybe$Just(billingAddress),
						bo: chosenNameFields,
						p7: currentProfilePictureUrl,
						MR: A2(
							$agustinrhcp$elm_mask$Mask$unMask,
							$author$project$Components$Patient$Form$datePattern,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									$author$project$Api$Patient$One$dob(patient)))),
						Oo: $author$project$Api$Patient$One$email(patient),
						Oq: $author$project$Components$EmergencyContactInput$init(
							$author$project$Api$Patient$One$emergencyContact(patient)),
						PO: A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Gender$fromString,
							$author$project$Api$Patient$One$gender(patient)),
						PP: A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$GenderIdentity$fromString(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Patient$One$genderOther(patient))),
							$author$project$Api$Patient$One$genderIdentity(patient)),
						PQ: $author$project$Api$Patient$One$genderOther(patient),
						Qj: healthInsurance,
						i_: _Utils_Tuple2(
							$author$project$Api$Patient$One$joinedPracticeDate(patient),
							dateInput),
						Ss: knownPractice,
						SH: leadSource,
						SK: $author$project$Components$NameInput$init(legalNameFields),
						aet: A2($author$project$Components$LocationInput$require, settings.Ym, location),
						Wi: A2($author$project$Components$PhoneInput$require, settings.agp, phonesInput),
						afS: A2($author$project$Components$PractitionerInput$require, settings.Yr, practitioner),
						WV: $author$project$Api$Patient$One$preferredLanguage(patient),
						sg: 0,
						Xg: $elm$core$Maybe$Nothing,
						Xh: A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Pronoun$fromString,
							$author$project$Api$Patient$One$pronoun(patient)),
						ZH: A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Gender$fromString,
							$author$project$Api$Patient$One$sex(patient)),
						_C: '',
						$j: $author$project$Api$Patient$One$syncToEmr(patient),
						oL: $author$project$Api$Patient$One$usesTobacco(patient),
						aaC: $author$project$Api$Patient$One$usesBillingAddress(patient)
					})),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
						addressCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress),
						billingAddressCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice),
						knownPracticeCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
						practitionerCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location),
						locationCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
						leadSourceCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance),
						healthInsuranceCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice),
						dateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate),
						affiliateCmd),
						A3($author$project$Components$Patient$Form$fetchPlainSSN, apiClient, session, patient)
					])));
	});
var $author$project$Api$Employer$Plan$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Plan$Min$id = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$id(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$id(plan_);
	}
};
var $author$project$Api$Plan$Min$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Plan$Min$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$One$membershipPlan = function (_v0) {
	var record = _v0.b;
	return record.TI;
};
var $author$project$Api$Provider$CompanyAccount$One$membershipPlan = function (_v0) {
	var record = _v0.b;
	return record.TI;
};
var $author$project$Api$CompanyAccount$One$membershipPlan = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$Provider,
			$author$project$Api$Provider$CompanyAccount$One$membershipPlan(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$Employer,
			$author$project$Api$Employer$CompanyAccount$One$membershipPlan(companyAccount_));
	}
};
var $author$project$Components$SponsorPlanInput$fill = F4(
	function (session, company, apiClient, companyAccount) {
		var planId = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$id,
			$author$project$Api$CompanyAccount$One$membershipPlan(companyAccount));
		var _v0 = A4($author$project$Components$SponsorPlanInput$filterInit, session, company, apiClient, planId);
		var filter = _v0.a;
		var filterCmd = _v0.b;
		return _Utils_Tuple2(
			{dW: false, Fi: filter, agk: false, aaN: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
	});
var $author$project$Api$Employer$CompanyRegistration$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Employer$CompanyRegistration$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$CompanyRegistration$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Api$CompanyRegistration$One$type_ = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$One$type_(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$One$type_(companyRegistration_);
	}
};
var $author$project$Components$Employee$Form$fill = function (session) {
	return function (company) {
		return function (apiClient) {
			return function (currentDate) {
				return function (companyAccount) {
					return function (companyRegistration) {
						return function (patient) {
							return function (meta) {
								return function (employeeMapper) {
									return function (patientMapper) {
										var isNew = false;
										var employeeSettings = employeeMapper($author$project$Components$Employee$Form$defaultEmployeeSettings);
										var division = $author$project$Api$CompanyAccount$One$division(companyAccount);
										var divisionId = A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$All$id, division);
										var _v0 = A3(
											$author$project$Components$EmployeeDependentTypeInput$fill,
											session,
											company,
											$author$project$Api$CompanyRegistration$One$type_(companyRegistration));
										var typeInput = _v0.a;
										var typeInputCmd = _v0.b;
										var _v1 = $author$project$Components$DateInput$init;
										var startDateInput = _v1.a;
										var startDateInputCmd = _v1.b;
										var _v2 = A2(
											$elm$core$Tuple$mapFirst,
											$author$project$Components$SponsorPlanInput$require(true),
											A4($author$project$Components$SponsorPlanInput$fill, session, company, apiClient, companyAccount));
										var sponsorPlan = _v2.a;
										var sponsorPlanCmd = _v2.b;
										var _v3 = A8(
											$author$project$Components$Patient$Form$fill,
											apiClient,
											session,
											currentDate,
											$elm$core$Maybe$Just(company),
											true,
											patient,
											meta,
											patientMapper);
										var patientForm = _v3.a;
										var patientFormCmd = _v3.b;
										var _v4 = A4(
											$author$project$Components$EmployeeDivisionInput$fill,
											session,
											$author$project$Api$Company$id(company),
											apiClient,
											divisionId);
										var divisionInput = _v4.a;
										var divisionInputCmd = _v4.b;
										var form = $author$project$Utils$Form$init(
											{
												NT: A2($author$project$Components$EmployeeDivisionInput$require, employeeSettings.Yl, divisionInput),
												cS: _Utils_Tuple2(
													$author$project$Api$CompanyAccount$One$eligibilityStartDate(companyAccount),
													startDateInput),
												OC: $elm$core$Maybe$Nothing,
												ade: $author$project$Api$CompanyRegistration$One$externalId(companyRegistration),
												adR: $elm$core$Maybe$Just(
													$author$project$Api$CompanyRegistration$One$id(companyRegistration)),
												iX: isNew,
												TK: $author$project$Components$Employee$Form$nextFirstOfMonth(currentDate),
												VM: patientForm,
												GH: A2($author$project$Components$SponsorPlanInput$require, employeeSettings.BU, sponsorPlan),
												ahI: typeInput
											});
										return _Utils_Tuple2(
											A2(
												$author$project$Components$Employee$Form$EmployeeForm,
												A3($author$project$Components$Employee$Form$defaultSettings, currentDate, isNew, employeeSettings),
												form),
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, patientFormCmd),
														A2(
														$elm$core$Platform$Cmd$map,
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type),
														typeInputCmd),
														A2(
														$elm$core$Platform$Cmd$map,
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan),
														sponsorPlanCmd),
														A2(
														$elm$core$Platform$Cmd$map,
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate),
														startDateInputCmd),
														A2(
														$elm$core$Platform$Cmd$map,
														A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division),
														divisionInputCmd)
													])));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm = function (model) {
	var _v0 = model.TU;
	if (_v0.$ === 3) {
		var meta = _v0.a;
		var _v1 = _Utils_Tuple3(model.Lr, model.Ly, model.VM);
		if (((_v1.a.$ === 3) && (_v1.b.$ === 3)) && (_v1.c.$ === 3)) {
			var _v2 = _v1.a;
			var companyAccount = _v2.a;
			var _v3 = _v1.b;
			var companyRegistration = _v3.a;
			var _v4 = _v1.c;
			var patient = _v4.a;
			var _v5 = $author$project$Components$Employee$Form$fill(model.ZD)(model.ab9)(model.D5)(model.cO)(companyAccount)(companyRegistration)(patient)(meta)(
				function (es) {
					return _Utils_update(
						es,
						{
							Yl: $author$project$Api$Company$requiresEmployeeDivisions(model.ab9),
							aaF: $author$project$Api$Company$usesEmployeeDivisions(model.ab9)
						});
				})(
				function (ps) {
					return _Utils_update(
						ps,
						{
							abD: $author$project$Api$Practice$labelBillingAsShipping(model.WF),
							abL: A2($author$project$Api$Practice$featureEnabled, 3, model.WF),
							P8: $author$project$Api$Practice$hasPractitioners(model.WF),
							Qe: $author$project$Api$Practice$hasPractitioners(model.WF),
							BT: true,
							ago: $author$project$Api$Practice$requiresPatientEmail(model.WF),
							Ym: $author$project$Api$Practice$requiresLocation(model.WF),
							agp: $author$project$Api$Practice$requiresPatientMobile(model.WF),
							Yr: $author$project$Api$Practice$requiresPractitioner(model.WF),
							Ys: $author$project$Api$Practice$requiresSSN(model.WF),
							_D: $author$project$Api$Practice$ssnEnabled(model.WF),
							$f: A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Network$Shared$syncByAffiliation,
									$author$project$Api$Practice$network(model.WF))),
							ahB: A2($author$project$Api$Practice$featureEnabled, 2, model.WF),
							$$: $author$project$Api$Practice$trackPatientsByLocation(model.WF),
							$1: $author$project$Api$Practice$transInclusivity(model.WF),
							DF: A3($author$project$Permission$canGoTo, model.ZD, model.adN, 0)
						});
				});
			var form = _v5.a;
			var formCmd = _v5.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						an: $elm$core$Maybe$Just(form)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg, formCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Api$Employer$Patient$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Patient$Min$name = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$name(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$name(patient_);
	}
};
var $author$project$Api$Patient$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Patient$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Patient$One$Patient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Patient$One$Record = function (chosenTitle) {
	return function (chosenFirstName) {
		return function (chosenMiddleName) {
			return function (chosenLastName) {
				return function (chosenSuffix) {
					return function (title) {
						return function (suffix) {
							return function (usesBillingAddress) {
								return function (address) {
									return function (billingAddress) {
										return function (phones) {
											return function (location) {
												return function (practitioner) {
													return function (preferredLanguage) {
														return function (leadSource) {
															return function (healthInsurance) {
																return function (knownPractice) {
																	return function (assignedAffiliation) {
																		return function (profilePictureUrl) {
																			return function (emergencyContact) {
																				return {It: address, Jp: assignedAffiliation, JZ: billingAddress, KX: chosenFirstName, KY: chosenLastName, KZ: chosenMiddleName, K_: chosenSuffix, K$: chosenTitle, Oq: emergencyContact, Qj: healthInsurance, Ss: knownPractice, SH: leadSource, aet: location, Wi: phones, afS: practitioner, WV: preferredLanguage, Xg: profilePictureUrl, _8: suffix, $G: title, aaC: usesBillingAddress};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Affiliate$AffiliateMin$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Employer$Affiliate$AffiliateMin$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Employer$Affiliate$AffiliateMin$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Affiliate$AffiliateMin$Record)));
var $author$project$Api$Employer$Affiliate$AffiliateMin$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Affiliate$AffiliateMin$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$HealthInsurance$Shared$HealthInsurance = $elm$core$Basics$identity;
var $author$project$Api$Employer$HealthInsurance$Shared$Record = F5(
	function (memberId, groupId, payerName, highDeductible, carrier) {
		return {KJ: carrier, PY: groupId, Qq: highDeductible, Tz: memberId, VV: payerName};
	});
var $author$project$Api$Employer$HealthInsurance$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'carrier',
	$elm$json$Json$Decode$nullable($author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'high_deductible',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payer_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'group_id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'member_id',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$HealthInsurance$Shared$Record))))));
var $author$project$Api$Employer$HealthInsurance$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$HealthInsurance$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$LeadSource$Shared$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Employer$LeadSource$Shared$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Employer$LeadSource$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$LeadSource$Shared$Record));
var $author$project$Api$Employer$LeadSource$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$LeadSource$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Location$Shared$Location = $elm$core$Basics$identity;
var $author$project$Api$Employer$Location$Shared$Record = F3(
	function (id, name, affiliation) {
		return {IJ: affiliation, adR: id, zh: name};
	});
var $author$project$Api$Employer$Location$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'affiliation',
	$elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Employer$Location$Shared$Record))));
var $author$project$Api$Employer$Location$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Location$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Practitioner$Shared$Practitioner = $elm$core$Basics$identity;
var $author$project$Api$Employer$Practitioner$Shared$Record = F6(
	function (id, name, isMaster, isSynced, openingsSize, affiliation) {
		return {IJ: affiliation, adR: id, RQ: isMaster, Sa: isSynced, zh: name, Vb: openingsSize};
	});
var $author$project$Api$Employer$Practitioner$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'affiliation',
	$elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'openings_size',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_synced',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_master',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Employer$Practitioner$Shared$Record)))))));
var $author$project$Api$Employer$Practitioner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Practitioner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Patient$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'emergency_contact',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$EmergencyContact$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'profile_picture_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'assigned_affiliation',
			$elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'known_practice',
				$elm$json$Json$Decode$nullable($author$project$Api$Employer$KnownPractice$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'health_insurance',
					$elm$json$Json$Decode$nullable($author$project$Api$Employer$HealthInsurance$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'lead_source',
						$elm$json$Json$Decode$nullable($author$project$Api$Employer$LeadSource$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'preferred_language',
							$author$project$Language$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'practitioner',
								$elm$json$Json$Decode$nullable($author$project$Api$Employer$Practitioner$Shared$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'location',
									$elm$json$Json$Decode$nullable($author$project$Api$Employer$Location$Shared$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'phones',
										$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'billing_address',
											$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'address',
												$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'uses_billing_address',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'suffix',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'title',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'chosen_suffix',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'chosen_last_name',
																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'chosen_middle_name',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'chosen_first_name',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'chosen_title',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				$elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$One$Record)))))))))))))))))))));
var $author$project$Api$Employer$Patient$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Patient$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Patient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$One$Patient)));
var $author$project$Api$Employer$Patient$patientsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patients']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Patient$patientPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Employer$Patient$patientsPath);
};
var $author$project$Api$Employer$Patient$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Patient$patientPath(id_)));
	});
var $author$project$Api$Patient$retrieve = F4(
	function (apiClient, session, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Patient$retrieve,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Patient$One$Employer))) : A3(
			$author$project$Api$Provider$Patient$retrieve,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Patient$One$Provider)));
	});
var $author$project$Api$Patient$Meta$Meta = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Patient$Meta$MetaActions = function (archive) {
	return {Jm: archive};
};
var $author$project$Utils$MetaFields$decodeActionable = $elm$json$Json$Decode$bool;
var $author$project$Api$Patient$Meta$decodeMetaActions = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['actions', 'archive']),
	$author$project$Utils$MetaFields$decodeActionable,
	$elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$MetaActions));
var $author$project$Api$Patient$Meta$MetaFields = function (firstName) {
	return function (chosenFirstName) {
		return function (dob) {
			return function (gender) {
				return function (sex) {
					return function (genderIdentity) {
						return function (pronouns) {
							return function (usesTobacco) {
								return function (practitionerId) {
									return function (locationId) {
										return function (joinedPracticeDate) {
											return function (healthInsuranceCarrier) {
												return function (leadSourceId) {
													return {KX: chosenFirstName, acQ: dob, Pu: firstName, PO: gender, PP: genderIdentity, Qk: healthInsuranceCarrier, Sq: joinedPracticeDate, SI: leadSourceId, S3: locationId, WO: practitionerId, Xi: pronouns, ZH: sex, aaI: usesTobacco};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Patient$Meta$decodeMetaFields = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'lead_source_id',
	$author$project$Utils$MetaFields$decodeEditable,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'health_insurance_carrier',
		$author$project$Utils$MetaFields$decodeEditable,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'joined_practice_date',
			$author$project$Utils$MetaFields$decodeEditable,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'location_id',
				$author$project$Utils$MetaFields$decodeEditable,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'practitioner_id',
					$author$project$Utils$MetaFields$decodeEditable,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'uses_tobacco',
						$author$project$Utils$MetaFields$decodeEditable,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'pronouns',
							$author$project$Utils$MetaFields$decodeEditable,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'gender_identity',
								$author$project$Utils$MetaFields$decodeEditable,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'sex',
									$author$project$Utils$MetaFields$decodeEditable,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'gender',
										$author$project$Utils$MetaFields$decodeEditable,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'dob',
											$author$project$Utils$MetaFields$decodeEditable,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'chosen_first_name',
												$author$project$Utils$MetaFields$decodeEditable,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'first_name',
													$author$project$Utils$MetaFields$decodeEditable,
													$elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$MetaFields))))))))))))));
var $author$project$Api$Patient$Meta$decode = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Patient$Meta$decodeMetaActions,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Patient$Meta$decodeMetaFields,
		$elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$Meta)));
var $author$project$Api$Employer$Patient$Meta$metaPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['meta']),
		$author$project$Api$Employer$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$Meta$metaPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['meta']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Patient$Meta$retrieve = F4(
	function (apiClient, session, id, toMsg) {
		var metaPath = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Patient$Meta$metaPath : $author$project$Api$Provider$Patient$Meta$metaPath;
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Patient$Meta$decode,
			toMsg,
			$author$project$Api$Data$requestTo(
				metaPath(id)));
	});
var $author$project$Api$Employer$CompanyAccount$update = F4(
	function (apiClient, id, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$CompanyAccount$companyAccountPath(id))));
	});
var $author$project$Api$Provider$Company$Account$update = F5(
	function (apiClient, basePath, id, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Company$Account$companyAccountPath, basePath, id))));
	});
var $author$project$Api$CompanyAccount$update = F6(
	function (apiClient, session, companyId, id, jsonBody, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyAccount$update,
			apiClient,
			id,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Account$update,
			apiClient,
			$author$project$Api$Provider$Company$companyPath(companyId),
			id,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$update = F5(
	function (apiClient, accountId, id, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, id))));
	});
var $author$project$Api$Provider$Company$Registration$update = F6(
	function (apiClient, companyId, companyAccountId, id, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, id))));
	});
var $author$project$Api$CompanyRegistration$update = F7(
	function (apiClient, session, companyId, accountId, id, jsonBody, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$CompanyRegistration$update,
			apiClient,
			accountId,
			id,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6(
			$author$project$Api$Provider$Company$Registration$update,
			apiClient,
			companyId,
			accountId,
			id,
			jsonBody,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					$author$project$OutMsg$handleErrorResponse(response),
					$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(
						_Utils_update(
							model,
							{Lr: response})));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var companyRegistration = response.a;
					var patientId = $author$project$Api$Patient$Min$id(
						$author$project$Api$CompanyRegistration$One$patient(companyRegistration));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ly: response}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A4($author$project$Api$Patient$retrieve, model.D5, model.ZD, patientId, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotPatient),
									A4($author$project$Api$Patient$Meta$retrieve, model.D5, model.ZD, patientId, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotMeta)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ly: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					$author$project$OutMsg$handleErrorResponse(response),
					$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(
						_Utils_update(
							model,
							{VM: response})));
			case 3:
				var response = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					$author$project$OutMsg$handleErrorResponse(response),
					$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(
						_Utils_update(
							model,
							{TU: response})));
			case 4:
				var subMsg = msg.a;
				var _v2 = model.an;
				if (!_v2.$) {
					var employeeForm = _v2.a;
					var _v3 = A5(
						$author$project$Components$Employee$Form$update,
						model.D5,
						model.ZD,
						$elm$core$Maybe$Just(model.ab9),
						subMsg,
						employeeForm);
					var form = _v3.a;
					var formCmd = _v3.b;
					var formOutMsgs = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								an: $elm$core$Maybe$Just(form)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg, formCmd),
						formOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var _v4 = model.an;
				if (!_v4.$) {
					var employeeForm = _v4.a;
					var _v5 = $author$project$Components$Employee$Form$validate(employeeForm);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var validForm = _v6.a;
						var validFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: true}),
							A7(
								$author$project$Api$CompanyRegistration$update,
								model.D5,
								model.ZD,
								model.ff,
								model.Ls,
								model.ED,
								A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm),
								$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyRegistrationUpdated),
							_List_Nil);
					} else {
						var erroredForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									an: $elm$core$Maybe$Just(erroredForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				var _v7 = model.an;
				if (!_v7.$) {
					var employeeForm = _v7.a;
					var _v8 = _Utils_Tuple2(
						$author$project$Components$Employee$Form$validate(employeeForm),
						response);
					if ((!_v8.a.$) && (_v8.b.$ === 3)) {
						var _v9 = _v8.a.a;
						var validForm = _v9.a;
						var validFields = _v9.b;
						var _v10 = _v8.b;
						var registration = _v10.a;
						var createAffiliationCmd = A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg,
							A4($author$project$Components$Employee$Form$createEmployeeAffiliation, model.D5, model.ZD, registration, employeeForm));
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A6(
										$author$project$Api$CompanyAccount$update,
										model.D5,
										model.ZD,
										model.ff,
										model.Ls,
										A2($author$project$Components$Employee$Form$encodeAccount, validFields, validForm),
										$author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyAccountUpdated(registration)),
										createAffiliationCmd
									])),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var registration = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$One$patient(registration));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Lr: $author$project$Api$Data$Loading, Ly: $author$project$Api$Data$Loading, VM: $author$project$Api$Data$Loading, kj: false}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
								{ff: model.ff})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated ' + patientName)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kj: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormSubmitted = {$: 5};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
													{ff: model.ff}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('All Employees & Dependents')
													])),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('  /  Edit Employee')
													]))
											])),
										$author$project$Ui$HorizontalRule$view(
										_List_fromArray(
											[$author$project$Ui$HorizontalRule$thin])),
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Edit Employee')
											])),
										function () {
										var _v0 = model.an;
										if (!_v0.$) {
											var employeeForm = _v0.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg),
													$author$project$Components$Employee$Form$view(employeeForm)));
										} else {
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$itemsCenter]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]));
										}
									}()
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
											{ff: model.ff}),
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Update employee'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(model.kj)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Update')
											]))
									]))
							]))
					]))
			]),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + (' | ' + model.ff)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$init, aer: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$load, agD: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$save, ahd: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$update, ahP: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$view});
var $author$project$Api$Provider$Report$CompanyRegistrations = 23;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCancellationReasons = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$CancellationReason$Employer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$CancellationReason$Provider = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$CancellationReason$cancellationReasonsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['cancellation_reasons']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$CancellationReason$All$CancellationReason = $elm$core$Basics$identity;
var $author$project$Api$Employer$CancellationReason$Shared$CancellationReason = $elm$core$Basics$identity;
var $author$project$Api$Employer$CancellationReason$Shared$SharedRecord = F2(
	function (id, description) {
		return {Nx: description, adR: id};
	});
var $author$project$Api$Employer$CancellationReason$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$CancellationReason$Shared$SharedRecord)));
var $author$project$Api$Employer$CancellationReason$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CancellationReason$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CancellationReason$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$CancellationReason$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$CancellationReason$listDefaults = {afy: $author$project$Api$Pagination$init};
var $author$project$Api$Employer$CancellationReason$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$CancellationReason$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.afy);
};
var $author$project$Api$Employer$CancellationReason$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$CancellationReason$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$CancellationReason$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$CancellationReason$cancellationReasonsPath)));
	});
var $author$project$Api$CancellationReason$listDefaults = {afy: $author$project$Api$Pagination$init};
var $author$project$Api$CancellationReason$optionalsToEmployer = function (optionals) {
	var options = optionals($author$project$Api$CancellationReason$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{afy: options.afy});
	};
};
var $author$project$Api$CancellationReason$optionalsToProvider = function (optionals) {
	var options = optionals($author$project$Api$CancellationReason$listDefaults);
	return function (d) {
		return _Utils_update(
			d,
			{afy: options.afy});
	};
};
var $author$project$Api$CancellationReason$list = F4(
	function (apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CancellationReason$list,
			apiClient,
			$author$project$Api$CancellationReason$optionalsToEmployer(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CancellationReason$Employer)))) : A3(
			$author$project$Api$Provider$CancellationReason$list,
			apiClient,
			$author$project$Api$CancellationReason$optionalsToProvider(optionals),
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$CancellationReason$Provider))));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCancellationReasons = function (model) {
	return A4(
		$author$project$Api$CancellationReason$list,
		model.D5,
		model.ZD,
		function (d) {
			return _Utils_update(
				d,
				{
					afy: A2($author$project$Api$Pagination$withItemsPerPage, 100, model.afy)
				});
		},
		$author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCancellationReasons);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCompanyAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$CompanyAccount$MembershipPatients = 0;
var $author$project$Api$CompanyAccount$Plan = 2;
var $author$project$Api$CompanyAccount$Registrations = 1;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue = function (filter) {
	switch (filter) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('needs_approval');
		case 2:
			return $elm$core$Maybe$Just('denied');
		case 3:
			return $elm$core$Maybe$Just('active_members');
		case 4:
			return $elm$core$Maybe$Just('not_active_members');
		case 5:
			return $elm$core$Maybe$Just('eligible');
		default:
			return $elm$core$Maybe$Just('not_eligible');
	}
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Fc: _List_fromArray(
					[2, 1, 0]),
				Fi: $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(model.Fi),
				afy: model.afy,
				af_: model.af_,
				ag1: model.ag1
			});
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts = function (model) {
	return A5(
		$author$project$Api$CompanyAccount$list,
		model.D5,
		model.ZD,
		model.adR,
		$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams(model),
		$author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCompanyAccounts);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$All = 0;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$DeniedApproval = 2;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Eligible = 5;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Enrolled = 3;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$NeedsApproval = 1;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$NotEligible = 6;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Unenrolled = 4;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterFromQuery = function (queryString) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm_community$list_extra$List$Extra$find,
			function (filter) {
				return _Utils_eq(
					$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(filter),
					queryString);
			},
			_List_fromArray(
				[1, 2, 3, 4, 5, 6])));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: shared.D5,
			abO: $author$project$Api$Data$Loading,
			ab9: company,
			Lt: $author$project$Api$Data$Loading,
			cO: shared.cO,
			Nr: $elm$core$Maybe$Nothing,
			xo: $elm$core$Maybe$Nothing,
			l9: $author$project$Components$ExportCsv$init(
				{adw: shared.afu, G0: 23}),
			Fi: $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterFromQuery(
				A2($elm$core$Dict$get, 'filter', query)),
			mg: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'employee-filter-dropdown', ahx: $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterDropdownMsg})),
			adv: $elm$core$Maybe$Nothing,
			adR: params.ff,
			afu: shared.afu,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			ag1: $author$project$Api$Sort$initFromQuery(query),
			eJ: _List_Nil,
			Hy: shared.Hy
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(model),
						$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCancellationReasons(model)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{afu: shared.afu}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$Close = {$: 1};
var $author$project$Components$Employee$EnrollmentModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Employee$EnrollmentModal$Close);
};
var $author$project$Components$Company$EmployeeRow$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(model.fy),
				function () {
				var _v0 = model.fD;
				if (!_v0.$) {
					var enrollmentModal = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Company$EmployeeRow$EnrollmentModalMsg,
						$author$project$Components$Employee$EnrollmentModal$subscriptions(enrollmentModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed),
					model.h8)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed),
					model.ih))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$tableRowSubscriptions = function (tableRows) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var id = _v0.a;
			var row = _v0.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(id),
				$author$project$Components$Company$EmployeeRow$subscriptions(row));
		},
		tableRows);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$core$Platform$Sub$batch(
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$tableRowSubscriptions(model.eJ)),
				$author$project$Ui$NewDropdown$subscriptions(model.mg),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$findTableRow = F2(
	function (tableRows, companyRegistrationId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var id = _v0.a;
					return _Utils_eq(id, companyRegistrationId);
				},
				tableRows));
	});
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$id(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$DropdownMenuMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$NewDropdown$DownLeft = 2;
var $author$project$Ui$NewDropdown$toDownLeft = function (config) {
	return _Utils_update(
		config,
		{xb: 2});
};
var $author$project$Components$Company$EmployeeRow$init = F8(
	function (practice, session, company, currentDate, timeFormatter, cancellationReasons, companyAccount, registration) {
		return {
			abO: cancellationReasons,
			ab9: company,
			Lr: companyAccount,
			Ly: registration,
			cO: currentDate,
			h8: $elm$core$Maybe$Nothing,
			ih: $elm$core$Maybe$Nothing,
			fy: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$toDownLeft(
					$author$project$Ui$NewDropdown$defaultConfig(
						{
							adR: 'employee-actions-dropdown-' + $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(registration),
							ahx: $author$project$Components$Company$EmployeeRow$DropdownMenuMsg
						}))),
			fD: $elm$core$Maybe$Nothing,
			WF: practice,
			jY: $author$project$Api$Data$NotAsked,
			ZD: session,
			Hy: timeFormatter,
			g6: $elm$core$Maybe$Nothing,
			aah: $elm$core$Maybe$Nothing
		};
	});
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$All$registrations = function (_v0) {
	var record = _v0.b;
	return record.age;
};
var $author$project$Api$CompanyAccount$All$registrations = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$CompanyRegistration$ForCompanyAccountAll$Provider,
			$author$project$Api$Provider$CompanyAccount$All$registrations(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$CompanyRegistration$ForCompanyAccountAll$Employer,
			$author$project$Api$Employer$CompanyAccount$All$registrations(companyAccount_));
	}
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_ = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$type_(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$type_(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$AccountOrRegistrationUpdated = 1;
var $author$project$Components$Employee$EnrollmentModal$Approve = 1;
var $author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$EmployeeRow$DependentEnrolled = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Company$EmployeeRow$EmployeeDenied = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$Enroll = 0;
var $author$project$Components$Company$EmployeeRow$GotCompanyAccount = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$GotCompanyRegistration = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeRow$None = 0;
var $author$project$Components$Company$EmployeeRow$UnenrollModalMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$CompanyAccount$companyAccountPath = F3(
	function (session, companyId, accountId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[accountId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['accounts']),
				A2($author$project$Api$Company$companyPath, session, companyId)));
	});
var $author$project$Api$Employer$CompanyAccount$delete = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(basePath));
	});
var $author$project$Api$Provider$Company$Account$delete = F4(
	function (apiClient, companyId, accountId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Provider$Company$Account$companyAccountPath,
					$author$project$Api$Provider$Company$companyPath(companyId),
					accountId)));
	});
var $author$project$Api$CompanyAccount$delete = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		if ($author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
			var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
			return A3($author$project$Api$Employer$CompanyAccount$delete, apiClient, basePath, toMsg);
		} else {
			return A4($author$project$Api$Provider$Company$Account$delete, apiClient, companyId, accountId, toMsg);
		}
	});
var $author$project$Api$Employer$CompanyRegistration$delete = F4(
	function (apiClient, accountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)));
	});
var $author$project$Api$Provider$Company$Registration$delete = F5(
	function (apiClient, companyId, companyAccountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)));
	});
var $author$project$Api$CompanyRegistration$delete = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var registrationId = _v0.nU;
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyRegistration$delete, apiClient, accountId, registrationId, toMsg) : A5($author$project$Api$Provider$Company$Registration$delete, apiClient, companyId, accountId, registrationId, toMsg);
	});
var $author$project$Api$Employer$CompanyAccount$deny = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deny']),
					basePath)));
	});
var $author$project$Api$Provider$Company$Account$deny = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deny']),
					basePath)));
	});
var $author$project$Api$CompanyAccount$deny = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$deny,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3(
			$author$project$Api$Provider$Company$Account$deny,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Components$Company$UnenrollModal$EndDateInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Employer$CompanyAccount$Meta$defaultValue = function (_v0) {
	var meta = _v0;
	return meta.ja.qs.Nm;
};
var $author$project$Api$Provider$CompanyAccount$Meta$defaultValue = function (_v0) {
	var meta = _v0;
	return meta.ja.qs.Nm;
};
var $author$project$Api$CompanyAccount$Meta$defaultValue = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$defaultValue(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$defaultValue(meta_);
	}
};
var $author$project$Components$Company$UnenrollModal$initFormFields = function (companyAccount) {
	return {
		abM: $elm$core$Maybe$Nothing,
		abN: $elm$core$Maybe$Nothing,
		agi: $author$project$Api$CompanyAccount$Meta$defaultValue(companyAccount)
	};
};
var $author$project$Api$CompanyAccount$Meta$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyAccount$Meta$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$All$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Provider$CompanyAccount$All$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$CompanyAccount$All$meta = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$CompanyAccount$Meta$Provider(
			$author$project$Api$Provider$CompanyAccount$All$meta(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$CompanyAccount$Meta$Employer(
			$author$project$Api$Employer$CompanyAccount$All$meta(companyAccount_));
	}
};
var $author$project$Components$Company$UnenrollModal$init = F6(
	function (session, _v0, companyAccount, registration, currentDate, minDate) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var registrationId = _v0.nU;
		var accountMeta = $author$project$Api$CompanyAccount$All$meta(companyAccount);
		var fields = $author$project$Components$Company$UnenrollModal$initFormFields(accountMeta);
		var _v1 = $author$project$Components$DateInput$init;
		var endDateInput = _v1.a;
		var endDateInputCmd = _v1.b;
		return _Utils_Tuple2(
			{
				eR: accountId,
				Lr: companyAccount,
				ff: companyId,
				Ly: registration,
				cO: currentDate,
				qu: endDateInput,
				PB: $author$project$Utils$Form$init(fields),
				y6: minDate,
				nU: registrationId,
				ZD: session
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$UnenrollModal$EndDateInputMsg, endDateInputCmd));
	});
var $author$project$Components$Employee$EnrollmentModal$GotCompanyAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$GotCompanyPlans = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$Model = $elm$core$Basics$identity;
var $author$project$Utils$Date$alignTo = F2(
	function (date, cutoffDay) {
		var alignedDate = A2($justinmimbs$date$Date$floor, 2, date);
		return (_Utils_cmp(
			$justinmimbs$date$Date$day(date),
			cutoffDay) > 0) ? A3($justinmimbs$date$Date$add, 1, 1, alignedDate) : alignedDate;
	});
var $author$project$Api$Employer$Company$Shared$enrollmentCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.OF;
};
var $author$project$Api$Employer$Company$One$enrollmentCutOffDayOfMonth = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$enrollmentCutOffDayOfMonth(shared);
};
var $author$project$Api$Provider$Company$One$enrollmentCutOffDayOfMonth = function (_v0) {
	var record = _v0.b;
	return record.OF;
};
var $author$project$Api$Company$enrollmentCutOffDayOfMonth = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$enrollmentCutOffDayOfMonth(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$enrollmentCutOffDayOfMonth(company_);
	}
};
var $author$project$Api$Employer$Company$One$nextInvoiceDate = function (_v0) {
	var record = _v0.b;
	return record.UF;
};
var $author$project$Api$Provider$Company$Shared$nextInvoiceDate = function (_v0) {
	var record = _v0;
	return record.UF;
};
var $author$project$Api$Provider$Company$One$nextInvoiceDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$nextInvoiceDate(shared);
};
var $author$project$Api$Company$nextInvoiceDate = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$nextInvoiceDate(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$nextInvoiceDate(company_);
	}
};
var $author$project$Components$Employee$EnrollmentModal$init = F6(
	function (apiClient, currentDate, session, action, company, companyAccountId) {
		var enrollmentCutOffDayOfMonth = $author$project$Api$Company$enrollmentCutOffDayOfMonth(company);
		var alignToCutoff = function (date) {
			return A2($author$project$Utils$Date$alignTo, date, enrollmentCutOffDayOfMonth);
		};
		var defaultStart = alignToCutoff(currentDate);
		return _Utils_Tuple2(
			{
				DV: action,
				IQ: alignToCutoff,
				ab9: company,
				Lr: $author$project$Api$Data$Loading,
				Ls: companyAccountId,
				ak: $author$project$Api$Data$Loading,
				cO: currentDate,
				w7: defaultStart,
				PB: $elm$core$Maybe$Nothing,
				UF: $author$project$Api$Company$nextInvoiceDate(company),
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				kk: ''
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Api$CompanyPlan$list,
						apiClient,
						session,
						$author$project$Api$Company$id(company),
						$elm$core$Basics$identity,
						$author$project$Components$Employee$EnrollmentModal$GotCompanyPlans),
						A5(
						$author$project$Api$CompanyAccount$retrieve,
						apiClient,
						session,
						$author$project$Api$Company$id(company),
						companyAccountId,
						$author$project$Components$Employee$EnrollmentModal$GotCompanyAccount)
					])));
	});
var $author$project$Api$Employer$CompanyAccount$makeEligible = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_eligible']),
					basePath)));
	});
var $author$project$Api$Provider$Company$Account$makeEligible = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_eligible']),
					basePath)));
	});
var $author$project$Api$CompanyAccount$makeEligible = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$makeEligible,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3(
			$author$project$Api$Provider$Company$Account$makeEligible,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$makeEligible = F4(
	function (apiClient, accountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_eligible']),
					A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId))));
	});
var $author$project$Api$Provider$Company$Registration$makeEligible = F5(
	function (apiClient, companyId, companyAccountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_eligible']),
					A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId))));
	});
var $author$project$Api$CompanyRegistration$makeEligible = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var registrationId = _v0.nU;
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyRegistration$makeEligible,
			apiClient,
			accountId,
			registrationId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Registration$makeEligible,
			apiClient,
			companyId,
			accountId,
			registrationId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Api$Employer$CompanyAccount$makeIneligible = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_ineligible']),
					basePath)));
	});
var $author$project$Api$Provider$Company$Account$makeIneligible = F3(
	function (apiClient, basePath, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_ineligible']),
					basePath)));
	});
var $author$project$Api$CompanyAccount$makeIneligible = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$CompanyAccount$makeIneligible,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3(
			$author$project$Api$Provider$Company$Account$makeIneligible,
			apiClient,
			basePath,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$makeIneligible = F4(
	function (apiClient, accountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_ineligible']),
					A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId))));
	});
var $author$project$Api$Provider$Company$Registration$makeIneligible = F5(
	function (apiClient, companyId, companyAccountId, registrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['make_ineligible']),
					A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId))));
	});
var $author$project$Api$CompanyRegistration$makeIneligible = F4(
	function (apiClient, session, _v0, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var registrationId = _v0.nU;
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyRegistration$makeIneligible,
			apiClient,
			accountId,
			registrationId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5(
			$author$project$Api$Provider$Company$Registration$makeIneligible,
			apiClient,
			companyId,
			accountId,
			registrationId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function (_v0) {
	var record = _v0.b;
	return record.TK;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function (_v0) {
	var record = _v0.b;
	return record.TK;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(companyRegistration_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Meta$min = function (_v0) {
	var meta = _v0;
	return meta.ja.qs.TZ;
};
var $author$project$Api$Provider$CompanyAccount$Meta$min = function (_v0) {
	var meta = _v0;
	return meta.ja.qs.TZ;
};
var $author$project$Api$CompanyAccount$Meta$min = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$min(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$min(meta_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Provider(
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration_));
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Employer(
			$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration_));
	}
};
var $author$project$Api$Employer$Patient$Min$age = function (_v0) {
	var record = _v0;
	return record.IK;
};
var $author$project$Api$Provider$Patient$Min$age = function (_v0) {
	var min = _v0;
	return min.IK;
};
var $author$project$Api$Patient$Min$age = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$age(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$age(patient_);
	}
};
var $author$project$Api$Employer$Plan$Min$maximumAge = function (_v0) {
	var record = _v0;
	return record.Tu;
};
var $author$project$Api$Provider$Plan$Min$maximumAge = function (_v0) {
	var record = _v0;
	return record.Tu;
};
var $author$project$Api$Plan$Min$maximumAge = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$maximumAge(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$maximumAge(plan_);
	}
};
var $author$project$Components$Company$EmployeeRow$patientIsAboveAge = F2(
	function (plan, patient) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Plan$Min$maximumAge(plan),
			$author$project$Api$Patient$Min$age(patient));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var maximumAge = _v0.a.a;
			var age = _v0.b.a;
			return _Utils_cmp(age, maximumAge) > 0;
		} else {
			return false;
		}
	});
var $author$project$Api$Employer$Plan$Min$minimumAge = function (_v0) {
	var record = _v0;
	return record.T1;
};
var $author$project$Api$Provider$Plan$Min$minimumAge = function (_v0) {
	var record = _v0;
	return record.T1;
};
var $author$project$Api$Plan$Min$minimumAge = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$minimumAge(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$minimumAge(plan_);
	}
};
var $author$project$Components$Company$EmployeeRow$patientIsBelowAge = F2(
	function (plan, patient) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Plan$Min$minimumAge(plan),
			$author$project$Api$Patient$Min$age(patient));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var minimumAge = _v0.a.a;
			var age = _v0.b.a;
			return _Utils_cmp(age, minimumAge) < 0;
		} else {
			return false;
		}
	});
var $author$project$Components$Company$EmployeeRow$patientOutsideAgeRange = F2(
	function (plan, companyRegistration) {
		if ((!plan.$) && (!plan.a.$)) {
			var plan_ = plan.a.a;
			var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration);
			return A2($author$project$Components$Company$EmployeeRow$patientIsBelowAge, plan_, patient) || A2($author$project$Components$Company$EmployeeRow$patientIsAboveAge, plan_, patient);
		} else {
			return false;
		}
	});
var $author$project$Api$Employer$CompanyAccount$All$plan = function (_v0) {
	var record = _v0.b;
	return record.GH;
};
var $author$project$Api$Provider$CompanyAccount$All$plan = function (_v0) {
	var record = _v0.b;
	return record.GH;
};
var $author$project$Api$CompanyAccount$All$plan = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			A2($elm$core$Basics$composeR, $elm$core$Maybe$map, $author$project$Api$Expandable$map),
			$author$project$Api$Plan$Min$Provider,
			$author$project$Api$Provider$CompanyAccount$All$plan(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			A2($elm$core$Basics$composeR, $elm$core$Maybe$map, $author$project$Api$Expandable$map),
			$author$project$Api$Plan$Min$Employer,
			$author$project$Api$Employer$CompanyAccount$All$plan(companyAccount_));
	}
};
var $author$project$Components$Company$UnenrollModal$CancellationReasonOtherValidation = 1;
var $author$project$Components$Company$UnenrollModal$CancellationReasonValidation = 0;
var $author$project$Components$Company$UnenrollModal$Closed = 1;
var $author$project$Components$Company$UnenrollModal$EndDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$UnenrollModal$GotCompanyAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$UnenrollModal$GotCompanyRegistration = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$UnenrollModal$None = 0;
var $author$project$Components$Company$UnenrollModal$Unenrolled = 2;
var $author$project$Components$Company$UnenrollModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var date = field.a;
			return _Utils_update(
				fields,
				{agi: date});
		} else {
			var _v1 = field.a;
			var cancellationReason = _v1.a;
			var cancellationReasonOther = _v1.b;
			return _Utils_update(
				fields,
				{abM: cancellationReason, abN: cancellationReasonOther});
		}
	});
var $author$project$Components$CancellationReason$Input$validate = F3(
	function (cancellationReasonValidationGroup, cancellationReasonOtherValidationGroup, fields) {
		var _v0 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Nx;
				},
				fields.abM),
			fields.abN);
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(cancellationReasonValidationGroup, 'Please select a reason.')
				]);
		} else {
			if ((_v0.a.a === 'Other') && (_v0.b.$ === 1)) {
				var _v2 = _v0.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(cancellationReasonOtherValidationGroup, 'Please enter a reason')
					]);
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Components$Company$UnenrollModal$EndDateValidation = 2;
var $author$project$Components$Company$UnenrollModal$validateEndDate = F2(
	function (model, fields) {
		var _v0 = fields.agi;
		if (!_v0.$) {
			var endDate = _v0.a;
			var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, model.cO);
			var minDate = A2($elm$core$Maybe$withDefault, yesterdayDate, model.y6);
			return (A2($justinmimbs$date$Date$compare, minDate, endDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(2, 'End date is invalid')
				]);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$Company$UnenrollModal$formFieldsValidator = function (model) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Company$UnenrollModal$validateEndDate(model)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				A2($author$project$Components$CancellationReason$Input$validate, 0, 1))
			]));
};
var $author$project$Api$Employer$CompanyAccount$unenroll = F4(
	function (apiClient, basePath, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unenroll']),
						basePath))));
	});
var $author$project$Api$Provider$Company$Account$unenroll = F4(
	function (apiClient, basePath, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unenroll']),
						basePath))));
	});
var $author$project$Api$CompanyAccount$unenroll = F5(
	function (apiClient, session, _v0, fields, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requested_end_date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.agi)),
					_Utils_Tuple2(
					'cancellation_reason',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.abM)),
					_Utils_Tuple2(
					'cancellation_reason_other',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abN))
				]));
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyAccount$unenroll,
			apiClient,
			basePath,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Account$unenroll,
			apiClient,
			basePath,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyRegistration$unenroll = F5(
	function (apiClient, accountId, registrationId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unenroll']),
						A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)))));
	});
var $author$project$Api$Provider$Company$Registration$unenroll = F6(
	function (apiClient, companyId, companyAccountId, registrationId, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyRegistration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['unenroll']),
						A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)))));
	});
var $author$project$Api$CompanyRegistration$unenroll = F5(
	function (apiClient, session, _v0, fields, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var registrationId = _v0.nU;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'requested_end_date',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.agi)),
					_Utils_Tuple2(
					'cancellation_reason',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.abM)),
					_Utils_Tuple2(
					'cancellation_reason_other',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abN))
				]));
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$CompanyRegistration$unenroll,
			apiClient,
			accountId,
			registrationId,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6(
			$author$project$Api$Provider$Company$Registration$unenroll,
			apiClient,
			companyId,
			accountId,
			registrationId,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
	});
var $author$project$Components$Company$UnenrollModal$updateDateInputFormField = F6(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, field) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$rtfeldman$elm_validate$Validate$fromErrors(
							$author$project$Components$Company$UnenrollModal$validateEndDate(model)),
						A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Company$UnenrollModal$formFieldsUpdate,
							field(date),
							model.PB)));
			} else {
				return model.PB;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			ac5: 0,
			y8: A2(
				dateInputSetter,
				newDateInput,
				_Utils_update(
					model,
					{PB: newForm})),
			as: _List_Nil
		};
	});
var $author$project$Components$Company$UnenrollModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Company$UnenrollModal$formFieldsValidator(model),
					model.PB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var apiFields = {
						abM: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							validFields.abM),
						abN: validFields.abN,
						agi: validFields.agi
					};
					var unenrollCmd = function () {
						var _v3 = model.nU;
						if (!_v3.$) {
							var registrationId = _v3.a;
							return A5(
								$author$project$Api$CompanyRegistration$unenroll,
								apiClient,
								model.ZD,
								{eR: model.eR, ff: model.ff, nU: registrationId},
								apiFields,
								$author$project$Components$Company$UnenrollModal$GotCompanyRegistration);
						} else {
							return A5(
								$author$project$Api$CompanyAccount$unenroll,
								apiClient,
								model.ZD,
								{eR: model.eR, ff: model.ff},
								apiFields,
								$author$project$Components$Company$UnenrollModal$GotCompanyAccount);
						}
					}();
					return {
						EC: unenrollCmd,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					var newForm = _v1.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Ly));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' is now unenrolled.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Ly));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' is now unenrolled.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Company$UnenrollModal$updateDateInputFormField,
					model,
					function ($) {
						return $.qu;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{qu: newDateInput});
						}),
					subMsg,
					$author$project$Components$Company$UnenrollModal$EndDateInputMsg,
					$author$project$Components$Company$UnenrollModal$EndDate);
			default:
				var field = msg.a;
				var newForm = $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$rtfeldman$elm_validate$Validate$fromErrors(
							A2($author$project$Components$CancellationReason$Input$validate, 0, 1)),
						A3($author$project$Utils$Form$update, $author$project$Components$Company$UnenrollModal$formFieldsUpdate, field, model.PB)));
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Employee$EnrollmentModal$Approved = 3;
var $author$project$Components$Employee$EnrollmentModal$Closed = 1;
var $author$project$Components$Employee$EnrollmentModal$CompanyAccountApproved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$CompanyAccountEnrolled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$Enrolled = 2;
var $author$project$Components$Employee$EnrollmentModal$None = 0;
var $author$project$Api$Employer$CompanyAccount$approve = F4(
	function (apiClient, basePath, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership_start_date',
					$author$project$Utils$Date$encode(fields.TK))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['approve']),
						basePath))));
	});
var $author$project$Api$Provider$Company$Account$approve = F4(
	function (apiClient, basePath, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership_start_date',
					$author$project$Utils$Date$encode(fields.TK)),
					_Utils_Tuple2(
					'plan',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GH))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['approve']),
						basePath))));
	});
var $author$project$Api$CompanyAccount$approve = F5(
	function (apiClient, session, _v0, fields, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyAccount$approve,
			apiClient,
			basePath,
			{TK: fields.TK},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Account$approve,
			apiClient,
			basePath,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$CompanyAccount$enroll = F4(
	function (apiClient, basePath, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership_start_date',
					$author$project$Utils$Date$encode(fields.TK)),
					_Utils_Tuple2(
					'plan',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GH))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enroll']),
						basePath))));
	});
var $author$project$Api$Provider$Company$Account$enroll = F4(
	function (apiClient, basePath, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership_start_date',
					$author$project$Utils$Date$encode(fields.TK)),
					_Utils_Tuple2(
					'plan',
					A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GH))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enroll']),
						basePath))));
	});
var $author$project$Api$CompanyAccount$enroll = F5(
	function (apiClient, session, _v0, fields, toMsg) {
		var companyId = _v0.ff;
		var accountId = _v0.eR;
		var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$CompanyAccount$enroll,
			apiClient,
			basePath,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4(
			$author$project$Api$Provider$Company$Account$enroll,
			apiClient,
			basePath,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
	});
var $author$project$Api$Employer$Plan$Shared$maximumAge = function (_v0) {
	var record = _v0;
	return record.Tu;
};
var $author$project$Api$Employer$Plan$All$maximumAge = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Employer$Plan$One$maximumAge = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Provider$Plan$All$maximumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
};
var $author$project$Api$Plan$maximumAge = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$maximumAge(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$maximumAge(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$maximumAge(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$maximumAge(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$maximumAge(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$maximumAge(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$minimumAge = function (_v0) {
	var record = _v0;
	return record.T1;
};
var $author$project$Api$Employer$Plan$All$minimumAge = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Employer$Plan$One$minimumAge = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Provider$Plan$All$minimumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
};
var $author$project$Api$Plan$minimumAge = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$minimumAge(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$minimumAge(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$minimumAge(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$minimumAge(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$minimumAge(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$minimumAge(plan_);
	}
};
var $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType = function (_v0) {
	var record = _v0;
	return record.$O;
};
var $author$project$Api$Employer$Plan$All$tobaccoSurchargeType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Api$Employer$Plan$One$tobaccoSurchargeType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Api$Provider$Plan$All$tobaccoSurchargeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
};
var $author$project$Api$Plan$tobaccoSurchargeType = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$tobaccoSurchargeType(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$tobaccoSurchargeType(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$tobaccoSurchargeType(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$tobaccoSurchargeType(plan_);
	}
};
var $author$project$Components$Employee$EnrollmentModal$planFieldFromApi = function (plan) {
	return {
		adR: $author$project$Api$Plan$id(plan),
		Tu: $author$project$Api$Plan$maximumAge(plan),
		T1: $author$project$Api$Plan$minimumAge(plan),
		zh: $author$project$Api$Plan$name(plan),
		$O: $author$project$Api$Plan$tobaccoSurchargeType(plan)
	};
};
var $author$project$Components$Employee$EnrollmentModal$formFieldsUpdate = F3(
	function (_v0, field, fields) {
		var model = _v0;
		if (!field.$) {
			var planId = field.a;
			var plans = A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, fields.ak);
			var plan = A2(
				$elm_community$list_extra$List$Extra$find,
				function (plan_) {
					return _Utils_eq(
						$author$project$Api$Plan$id(plan_),
						planId);
				},
				plans);
			return _Utils_update(
				fields,
				{
					GH: A2($elm$core$Maybe$map, $author$project$Components$Employee$EnrollmentModal$planFieldFromApi, plan)
				});
		} else {
			var date = field.a;
			return _Utils_update(
				fields,
				{
					TK: A2($elm$core$Maybe$withDefault, model.w7, date)
				});
		}
	});
var $author$project$Components$Employee$EnrollmentModal$PlanValidation = 0;
var $author$project$Components$Employee$EnrollmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.GH;
			},
			_Utils_Tuple2(0, 'Please pick a plan'))
		]));
var $author$project$Api$Employer$CompanyPlan$Shared$isDefault = function (_v0) {
	var record = _v0;
	return record.RI;
};
var $author$project$Api$Employer$CompanyPlan$All$isDefault = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyPlan$Shared$isDefault(shared);
};
var $author$project$Api$Provider$CompanyPlan$Shared$isDefault = function (_v0) {
	var record = _v0;
	return record.RI;
};
var $author$project$Api$Provider$CompanyPlan$One$isDefault = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyPlan$Shared$isDefault(shared);
};
var $author$project$Api$Provider$CompanyPlan$All$isDefault = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyPlan$One$isDefault(one);
};
var $author$project$Api$CompanyPlan$isDefault = function (companyPlan) {
	switch (companyPlan.$) {
		case 0:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$One$isDefault(companyPlan_);
		case 1:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$All$isDefault(companyPlan_);
		default:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Employer$CompanyPlan$All$isDefault(companyPlan_);
	}
};
var $author$project$Api$Employer$Plan$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Plan$Min$name = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$name(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$name(plan_);
	}
};
var $author$project$Api$Employer$Plan$Min$tobaccoSurchargeType = function (_v0) {
	var record = _v0;
	return record.$O;
};
var $author$project$Api$Provider$Plan$Min$tobaccoSurchargeType = function (_v0) {
	var record = _v0;
	return record.$O;
};
var $author$project$Api$Plan$Min$tobaccoSurchargeType = function (plan) {
	if (!plan.$) {
		var plan_ = plan.a;
		return $author$project$Api$Provider$Plan$Min$tobaccoSurchargeType(plan_);
	} else {
		var plan_ = plan.a;
		return $author$project$Api$Employer$Plan$Min$tobaccoSurchargeType(plan_);
	}
};
var $author$project$Components$Employee$EnrollmentModal$planFieldFromApiMin = function (plan) {
	return {
		adR: $author$project$Api$Plan$Min$id(plan),
		Tu: $author$project$Api$Plan$Min$maximumAge(plan),
		T1: $author$project$Api$Plan$Min$minimumAge(plan),
		zh: $author$project$Api$Plan$Min$name(plan),
		$O: $author$project$Api$Plan$Min$tobaccoSurchargeType(plan)
	};
};
var $author$project$Api$Employer$CompanyAccount$One$selectedPlan = function (_v0) {
	var record = _v0.b;
	return record.Zh;
};
var $author$project$Api$Provider$CompanyAccount$One$selectedPlan = function (_v0) {
	var record = _v0.b;
	return record.Zh;
};
var $author$project$Api$CompanyAccount$One$selectedPlan = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$Provider,
			$author$project$Api$Provider$CompanyAccount$One$selectedPlan(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$Employer,
			$author$project$Api$Employer$CompanyAccount$One$selectedPlan(companyAccount_));
	}
};
var $author$project$Components$Employee$EnrollmentModal$initFormFields = F3(
	function (defaultStart, companyAccount, companyPlans) {
		var plans = A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, companyPlans);
		var plan = function () {
			if ($elm$core$List$length(plans) === 1) {
				return A2(
					$elm$core$Maybe$map,
					$author$project$Components$Employee$EnrollmentModal$planFieldFromApi,
					$elm$core$List$head(plans));
			} else {
				var defaultCompanyPlan = A2(
					$elm_community$list_extra$List$Extra$find,
					function (companyPlan) {
						return $author$project$Api$CompanyPlan$isDefault(companyPlan);
					},
					companyPlans);
				var _v0 = _Utils_Tuple2(
					$author$project$Api$CompanyAccount$One$selectedPlan(companyAccount),
					A2($elm$core$Maybe$map, $author$project$Api$CompanyPlan$plan, defaultCompanyPlan));
				if (!_v0.a.$) {
					var selectedPlan = _v0.a.a;
					return $elm$core$Maybe$Just(
						$author$project$Components$Employee$EnrollmentModal$planFieldFromApiMin(selectedPlan));
				} else {
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var defaultPlan = _v0.b.a;
						return $elm$core$Maybe$Just(
							$author$project$Components$Employee$EnrollmentModal$planFieldFromApi(defaultPlan));
					} else {
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Components$Employee$EnrollmentModal$planFieldFromApi,
							$elm$core$List$head(plans));
					}
				}
			}
		}();
		return {Lr: companyAccount, ak: companyPlans, TK: defaultStart, GH: plan};
	});
var $author$project$Components$Employee$EnrollmentModal$initForm = F3(
	function (companyAccount, companyPlans, defaultStart) {
		var fields = function () {
			var _v0 = _Utils_Tuple2(companyAccount, companyPlans);
			if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
				var _v1 = _v0.a;
				var companyAccount_ = _v1.a;
				var _v2 = _v0.b;
				var companyPlans_ = _v2.a;
				return $elm$core$Maybe$Just(
					A3($author$project$Components$Employee$EnrollmentModal$initFormFields, defaultStart, companyAccount_, companyPlans_));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A2($elm$core$Maybe$map, $author$project$Utils$Form$init, fields);
	});
var $author$project$Api$Employer$CompanyAccount$One$subscriber = function (_v0) {
	var record = _v0.b;
	return record._3;
};
var $author$project$Api$Provider$CompanyAccount$One$subscriber = function (_v0) {
	var record = _v0.b;
	return record._3;
};
var $author$project$Api$CompanyAccount$One$subscriberName = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$Shared$name,
			$author$project$Api$Provider$CompanyAccount$One$subscriber(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$Employer$Patient$Shared$name,
			$author$project$Api$Employer$CompanyAccount$One$subscriber(companyAccount_));
	}
};
var $author$project$Components$Employee$EnrollmentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 0:
				var _v2 = model.PB;
				if (!_v2.$) {
					var form = _v2.a;
					var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Employee$EnrollmentModal$formFieldsValidator, form);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var newForm = _v4.a;
						var validFormFields = _v4.b;
						var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var employeeParams = {
							eR: model.Ls,
							ff: $author$project$Api$Company$id(model.ab9)
						};
						var apiFields = {
							TK: validFields.TK,
							GH: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.adR;
								},
								validFields.GH)
						};
						return {
							EC: function () {
								var _v5 = model.DV;
								if (!_v5) {
									return A5($author$project$Api$CompanyAccount$enroll, apiClient, model.ZD, employeeParams, apiFields, $author$project$Components$Employee$EnrollmentModal$CompanyAccountEnrolled);
								} else {
									return A5($author$project$Api$CompanyAccount$approve, apiClient, model.ZD, employeeParams, apiFields, $author$project$Components$Employee$EnrollmentModal$CompanyAccountApproved);
								}
							}(),
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							as: _List_Nil
						};
					} else {
						var newForm = _v3.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var companyAccount = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								Lr: response,
								PB: A3($author$project$Components$Employee$EnrollmentModal$initForm, response, model.ak, model.w7),
								kk: A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$CompanyAccount$One$subscriberName(companyAccount))
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								ak: response,
								PB: A3($author$project$Components$Employee$EnrollmentModal$initForm, model.Lr, response, model.w7)
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, model.kk + ' was enrolled')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 3,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, model.kk + ' was enrolled')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var field = msg.a;
				var _v10 = model.PB;
				if (!_v10.$) {
					var form = _v10.a;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Employee$EnrollmentModal$formFieldsUpdate(model),
						field,
						form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Company$EmployeeRow$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$NewDropdown$update, subMsg, model.fy);
				var dropdown = _v1.a;
				var cmd = _v1.b;
				return {
					EC: cmd,
					ac5: 0,
					y8: _Utils_update(
						model,
						{fy: dropdown}),
					as: _List_Nil
				};
			case 1:
				var employeeOrDependent_ = msg.a;
				var madeEligibleCmd = function () {
					if (!employeeOrDependent_.$) {
						var employee = employeeOrDependent_.a;
						return A4(
							$author$project$Api$CompanyAccount$makeEligible,
							apiClient,
							model.ZD,
							{
								eR: $author$project$Api$CompanyAccount$All$id(employee),
								ff: $author$project$Api$Company$id(model.ab9)
							},
							$author$project$Components$Company$EmployeeRow$GotCompanyAccount('eligible'));
					} else {
						var dependent = employeeOrDependent_.a;
						return A4(
							$author$project$Api$CompanyRegistration$makeEligible,
							apiClient,
							model.ZD,
							{
								eR: $author$project$Api$CompanyAccount$All$id(model.Lr),
								ff: $author$project$Api$Company$id(model.ab9),
								nU: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
							},
							$author$project$Components$Company$EmployeeRow$GotCompanyRegistration('eligible'));
					}
				}();
				return {EC: madeEligibleCmd, ac5: 0, y8: model, as: _List_Nil};
			case 2:
				var employeeOrDependent_ = msg.a;
				var madeIneligibleCmd = function () {
					if (!employeeOrDependent_.$) {
						var employee = employeeOrDependent_.a;
						return A4(
							$author$project$Api$CompanyAccount$makeIneligible,
							apiClient,
							model.ZD,
							{
								eR: $author$project$Api$CompanyAccount$All$id(employee),
								ff: $author$project$Api$Company$id(model.ab9)
							},
							$author$project$Components$Company$EmployeeRow$GotCompanyAccount('ineligible'));
					} else {
						var dependent = employeeOrDependent_.a;
						return A4(
							$author$project$Api$CompanyRegistration$makeIneligible,
							apiClient,
							model.ZD,
							{
								eR: $author$project$Api$CompanyAccount$All$id(model.Lr),
								ff: $author$project$Api$Company$id(model.ab9),
								nU: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
							},
							$author$project$Components$Company$EmployeeRow$GotCompanyRegistration('ineligible'));
					}
				}();
				return {EC: madeIneligibleCmd, ac5: 0, y8: model, as: _List_Nil};
			case 3:
				var actionString = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Ly));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + (' was made ' + actionString))
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				var actionString = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Ly));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + (' was made ' + actionString))
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Ly));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' was deleted.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 6:
				var employeeOrDependent_ = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{h8: employeeOrDependent_}),
					as: _List_Nil
				};
			case 7:
				var employeeOrDependent_ = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var deleteCmd = function () {
						if (!employeeOrDependent_.$) {
							var employee = employeeOrDependent_.a;
							return A4(
								$author$project$Api$CompanyAccount$delete,
								apiClient,
								model.ZD,
								{
									eR: $author$project$Api$CompanyAccount$All$id(employee),
									ff: $author$project$Api$Company$id(model.ab9)
								},
								$author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved);
						} else {
							var dependent = employeeOrDependent_.a;
							return A4(
								$author$project$Api$CompanyRegistration$delete,
								apiClient,
								model.ZD,
								{
									eR: $author$project$Api$CompanyAccount$All$id(model.Lr),
									ff: $author$project$Api$Company$id(model.ab9),
									nU: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
								},
								$author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved);
						}
					}();
					return {
						EC: deleteCmd,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								h8: $elm$core$Maybe$Just(employeeOrDependent_)
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{h8: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				}
			case 15:
				var employeeOrDependent_ = msg.a;
				var _v8 = function () {
					if (!employeeOrDependent_.$) {
						var employee = employeeOrDependent_.a;
						var accountMeta = $author$project$Api$CompanyAccount$All$meta(model.Lr);
						return _Utils_Tuple3(
							$author$project$Api$CompanyAccount$All$id(employee),
							$elm$core$Maybe$Nothing,
							$author$project$Api$CompanyAccount$Meta$min(accountMeta));
					} else {
						var dependent = employeeOrDependent_.a;
						return _Utils_Tuple3(
							$author$project$Api$CompanyAccount$All$id(model.Lr),
							$elm$core$Maybe$Just(
								$author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)),
							$author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(dependent));
					}
				}();
				var accountId = _v8.a;
				var registrationId = _v8.b;
				var minDate = _v8.c;
				var _v10 = A6(
					$author$project$Components$Company$UnenrollModal$init,
					model.ZD,
					{
						eR: accountId,
						ff: $author$project$Api$Company$id(model.ab9),
						nU: registrationId
					},
					model.Lr,
					model.Ly,
					model.cO,
					minDate);
				var unenrollModal = _v10.a;
				var unenrollModalCmd = _v10.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$UnenrollModalMsg, unenrollModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							g6: $elm$core$Maybe$Just(unenrollModal)
						}),
					as: _List_Nil
				};
			case 8:
				var employeeOrDependent_ = msg.a;
				if (!employeeOrDependent_.$) {
					var companyAccount = employeeOrDependent_.a;
					var _v12 = A6(
						$author$project$Components$Employee$EnrollmentModal$init,
						apiClient,
						model.cO,
						model.ZD,
						0,
						model.ab9,
						$author$project$Api$CompanyAccount$All$id(companyAccount));
					var enrollmentModal = _v12.a;
					var enrollmentModalCmd = _v12.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalCmd),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								fD: $elm$core$Maybe$Just(enrollmentModal)
							}),
						as: _List_Nil
					};
				} else {
					var dependent = employeeOrDependent_.a;
					var showPlanAgeWarning = A2(
						$author$project$Components$Company$EmployeeRow$patientOutsideAgeRange,
						$author$project$Api$CompanyAccount$All$plan(model.Lr),
						dependent);
					return {
						EC: showPlanAgeWarning ? $elm$core$Platform$Cmd$none : A5(
							$author$project$Api$CompanyRegistration$enroll,
							apiClient,
							model.ZD,
							{
								eR: $author$project$Api$CompanyAccount$All$id(model.Lr),
								ff: $author$project$Api$Company$id(model.ab9),
								nU: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
							},
							$elm$json$Json$Encode$object(_List_Nil),
							$author$project$Components$Company$EmployeeRow$DependentEnrolled),
						ac5: 0,
						y8: showPlanAgeWarning ? _Utils_update(
							model,
							{
								ih: $elm$core$Maybe$Just(dependent)
							}) : _Utils_update(
							model,
							{jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				}
			case 10:
				var dependent = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					EC: A5(
						$author$project$Api$CompanyRegistration$enroll,
						apiClient,
						model.ZD,
						{
							eR: $author$project$Api$CompanyAccount$All$id(model.Lr),
							ff: $author$project$Api$Company$id(model.ab9),
							nU: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
						},
						$elm$json$Json$Encode$object(_List_Nil),
						$author$project$Components$Company$EmployeeRow$DependentEnrolled),
					ac5: 0,
					y8: _Utils_update(
						model,
						{ih: $elm$core$Maybe$Nothing, jY: $author$project$Api$Data$Loading}),
					as: _List_Nil
				} : {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{ih: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = $author$project$Api$Patient$Min$name(
						$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Ly));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' was successfully enrolled.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 16:
				var subMsg = msg.a;
				var _v14 = model.g6;
				if (!_v14.$) {
					var unenrollModal = _v14.a;
					var unenrollModalResult = A3($author$project$Components$Company$UnenrollModal$update, apiClient, subMsg, unenrollModal);
					var event = function () {
						var _v17 = unenrollModalResult.ac5;
						if (_v17 === 2) {
							return 1;
						} else {
							return 0;
						}
					}();
					var _v15 = function () {
						var _v16 = unenrollModalResult.ac5;
						switch (_v16) {
							case 0:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											g6: $elm$core$Maybe$Just(unenrollModalResult.y8)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 1:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{g6: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							default:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{g6: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
						}
					}();
					var newModel = _v15.a;
					var cmd = _v15.b;
					var outMsgs = _v15.c;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$UnenrollModalMsg, unenrollModalResult.EC),
									cmd
								])),
						ac5: event,
						y8: newModel,
						as: _Utils_ap(unenrollModalResult.as, outMsgs)
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 11:
				var _v18 = A6(
					$author$project$Components$Employee$EnrollmentModal$init,
					apiClient,
					model.cO,
					model.ZD,
					1,
					model.ab9,
					$author$project$Api$CompanyAccount$All$id(model.Lr));
				var enrollmentModal = _v18.a;
				var enrollmentModalCmd = _v18.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fD: $elm$core$Maybe$Just(enrollmentModal)
						}),
					as: _List_Nil
				};
			case 12:
				var subMsg = msg.a;
				var _v19 = model.fD;
				if (!_v19.$) {
					var enrollmentModal = _v19.a;
					var enrollmentModalResult = A3($author$project$Components$Employee$EnrollmentModal$update, apiClient, subMsg, enrollmentModal);
					var _v20 = function () {
						var _v21 = enrollmentModalResult.ac5;
						switch (_v21) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(enrollmentModalResult.y8),
									0);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
							case 2:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
						}
					}();
					var newEnrollmentModal = _v20.a;
					var event = _v20.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{fD: newEnrollmentModal}),
						as: enrollmentModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 13:
				return {
					EC: A4(
						$author$project$Api$CompanyAccount$deny,
						apiClient,
						model.ZD,
						{
							eR: $author$project$Api$CompanyAccount$All$id(model.Lr),
							ff: $author$project$Api$Company$id(model.ab9)
						},
						$author$project$Components$Company$EmployeeRow$EmployeeDenied),
					ac5: 0,
					y8: _Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			case 14:
				var response = msg.a;
				if (response.$ === 3) {
					var patientName = A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$CompanyAccount$All$subscriberName(model.Lr));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, patientName + ' is denied and they will no longer be eligible.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var registrationId = msg.a;
				return {
					EC: A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top(
							{
								ff: $author$project$Api$Company$id(model.ab9),
								acF: registrationId,
								acX: $author$project$Api$CompanyAccount$All$id(model.Lr)
							})),
					ac5: 0,
					y8: model,
					as: _List_Nil
				};
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateTableRows = F2(
	function (tableRows, _v0) {
		var registrationId = _v0.a;
		var rowToUpdate = _v0.b;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var id = _v1.a;
				var row = _v1.b;
				return _Utils_eq(id, registrationId) ? _Utils_Tuple2(registrationId, rowToUpdate) : _Utils_Tuple2(id, row);
			},
			tableRows);
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('filter'),
			$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(model.Fi))
		]);
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
						{ff: model.adR}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var companyAccounts = response.a;
					var headers = response.b;
					var intFromHeader = F2(
						function (key, headers_) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$String$toInt,
									A2($elm$core$Dict$get, key, headers_)));
						});
					var totalAmount = A2(intFromHeader, 'x-total-amount', headers);
					var totalDueAmount = A2(intFromHeader, 'x-total-due-amount', headers);
					var employeePrioritized = function (registration) {
						return ($author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(registration) === 'employee') ? 0 : 1;
					};
					var orderedRegistrations = function (account) {
						return A2(
							$elm$core$List$sortBy,
							employeePrioritized,
							$author$project$Api$CompanyAccount$All$registrations(account));
					};
					var tableRows = A3(
						$elm$core$List$foldr,
						$elm$core$Basics$append,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (account) {
								return A2(
									$elm$core$List$map,
									function (reg) {
										return _Utils_Tuple2(
											$author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(reg),
											A8($author$project$Components$Company$EmployeeRow$init, model.WF, model.ZD, model.ab9, model.cO, model.Hy, model.abO, account, reg));
									},
									orderedRegistrations(account));
							},
							companyAccounts));
					var employeeCount = A2(intFromHeader, 'x-employee-count', headers);
					var dependentCount = A2(intFromHeader, 'x-dependent-count', headers);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Lt: response,
								Nr: $elm$core$Maybe$Just(dependentCount),
								xo: $elm$core$Maybe$Just(employeeCount),
								adv: $elm$core$Maybe$Just(
									_Utils_Tuple2(totalAmount, totalDueAmount)),
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								eJ: tableRows
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Lt: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{Lt: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(newModel),
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var registrationId = msg.a;
				var subMsg = msg.b;
				var _v2 = A2($author$project$Pages$Companies$CompanyId_String$Employees$Top$findTableRow, model.eJ, registrationId);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var employeeRow = _v3.b;
					var employeeRowResult = A3($author$project$Components$Company$EmployeeRow$update, model.D5, subMsg, employeeRow);
					var refreshCmd = function () {
						var _v5 = employeeRowResult.ac5;
						if (!_v5) {
							return $elm$core$Platform$Cmd$none;
						} else {
							return $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(model);
						}
					}();
					var _v4 = _Utils_Tuple3(employeeRowResult.y8, employeeRowResult.EC, employeeRowResult.as);
					var newEmployeeRow = _v4.a;
					var employeeRowCmd = _v4.b;
					var employeeRowOutMsgs = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eJ: A2(
									$author$project$Pages$Companies$CompanyId_String$Employees$Top$updateTableRows,
									model.eJ,
									_Utils_Tuple2(id, newEmployeeRow))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									refreshCmd,
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId),
									employeeRowCmd)
								])),
						employeeRowOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v6.a;
				var searchInputCmd = _v6.b;
				var searchInputEvent = _v6.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v7 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								Lt: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(qModel),
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v9 = A2($author$project$Ui$NewDropdown$update, subMsg, model.mg);
				var dropdown = _v9.a;
				var dropdownCmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mg: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 5:
				var option = msg.a;
				var newModel = _Utils_update(
					model,
					{Lt: $author$project$Api$Data$Loading, Fi: option});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(newModel),
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{abO: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var subMsg = msg.a;
				var _v10 = A3($author$project$Components$ExportCsv$update, model.D5, subMsg, model.l9);
				var exportCsv = _v10.a;
				var subCmd = _v10.b;
				var subOutMsg = _v10.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployerOrProviderCompany = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$companyType = function (company) {
	return A2(
		$elm$core$Maybe$map,
		function (company_) {
			var company__ = company_;
			return $author$project$Api$Company$companyType(company__);
		},
		company);
};
var $author$project$Api$CompanyRegistration$exportPath = F2(
	function (session, companyId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['export']),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['accounts']),
				A2($author$project$Api$Company$companyPath, session, companyId)));
	});
var $author$project$Components$ExportCsv$link = A3(
	$author$project$Ui$Button$view,
	{abp: 'Export to csv'},
	_List_fromArray(
		[
			$author$project$Ui$Button$link,
			$author$project$Ui$Button$onClick($author$project$Components$ExportCsv$OpenModal),
			$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$export)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Export to CSV')
		]));
var $author$project$Api$CompanyAccount$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$CompanyAccount$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Fi;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', filter)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.af_;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v2 = options.adR;
				if (!_v2.$) {
					var string = _v2.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Components$Company$EmployeeRow$deleteModal = function (model) {
	var _v0 = model.h8;
	if (!_v0.$) {
		var employee = _v0.a;
		var patientName = $author$project$Api$Patient$Min$name(
			$author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Ly));
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed(employee),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('remove'),
					$author$project$Components$HiConfirm$noun(patientName),
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text('Removing this relationship will delete the patient history with this company. Are you sure you want to remove?')
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$EmployeeRow$viewEnrollDependentModal = function (model) {
	var _v0 = model.ih;
	if (!_v0.$) {
		var dependent = _v0.a;
		var customMessage = function () {
			var _v1 = $author$project$Api$CompanyAccount$All$plan(model.Lr);
			if ((!_v1.$) && (!_v1.a.$)) {
				var plan = _v1.a.a;
				var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(dependent);
				var _v2 = A2($author$project$Components$Company$EmployeeRow$patientIsBelowAge, plan, patient) ? _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Api$Plan$Min$minimumAge(plan)),
					'minimum') : (A2($author$project$Components$Company$EmployeeRow$patientIsAboveAge, plan, patient) ? _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$author$project$Api$Plan$Min$maximumAge(plan)),
					'maximum') : _Utils_Tuple2(0, ''));
				var ageLimit = _v2.a;
				var ageLimitType = _v2.b;
				return _List_fromArray(
					[
						$elm$html$Html$text(
						'The ' + (ageLimitType + (' age defined for this plan is ' + ($elm$core$String$fromInt(ageLimit) + ('. ' + ($author$project$Api$Patient$Min$name(patient) + (' is ' + (A2(
							$elm$core$Maybe$withDefault,
							'N/A',
							A2(
								$elm$core$Maybe$map,
								$elm$core$String$fromInt,
								$author$project$Api$Patient$Min$age(patient))) + ' years old. Do you want to proceed anyway?'))))))))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed(dependent),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('enroll'),
					$author$project$Components$HiConfirm$noun(
					($author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(dependent) === 'spouse') ? 'adult' : $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(dependent)),
					$author$project$Components$HiConfirm$customMessage(customMessage)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Employee$EnrollmentModal$Save = {$: 0};
var $author$project$Ui$Modal$htmlTitle = function (contents) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-title')
			]),
		A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$never),
			contents));
};
var $author$project$Components$Employee$EnrollmentModal$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$MembershipStartDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Employee$EnrollmentModal$MembershipStartDateValidation = 1;
var $author$project$Components$Employee$EnrollmentModal$Plan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Date$isBeforeOrEqual = F2(
	function (date, otherDate) {
		return A2($author$project$Utils$Date$isBefore, date, otherDate) || _Utils_eq(date, otherDate);
	});
var $author$project$Ui$Form$Select$dateOptions = function (dates) {
	return A2(
		$elm$core$List$map,
		function (date) {
			var dateString = $justinmimbs$date$Date$toIsoString(date);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(dateString),
				A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
		},
		dates);
};
var $author$project$Utils$Date$nextTwelveMonths = function (referenceDate) {
	return A2(
		$elm$core$List$map,
		function (offset) {
			return A3($justinmimbs$date$Date$add, 1, offset, referenceDate);
		},
		A2($elm$core$List$range, 0, 11));
};
var $author$project$Components$Employee$EnrollmentModal$membershipStartDateOptions = F2(
	function (currentDate, alignToCutoff) {
		var startDate = A3(
			$justinmimbs$date$Date$add,
			1,
			-6,
			alignToCutoff(currentDate));
		return $author$project$Ui$Form$Select$dateOptions(
			$author$project$Utils$Date$nextTwelveMonths(startDate));
	});
var $author$project$Api$Employer$CompanyPlan$Shared$availableForEnrollment = function (_v0) {
	var record = _v0;
	return record.JJ;
};
var $author$project$Api$Employer$CompanyPlan$All$availableForEnrollment = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyPlan$Shared$availableForEnrollment(shared);
};
var $author$project$Api$Provider$CompanyPlan$Shared$availableForEnrollment = function (_v0) {
	var record = _v0;
	return record.JJ;
};
var $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyPlan$Shared$availableForEnrollment(shared);
};
var $author$project$Api$Provider$CompanyPlan$All$availableForEnrollment = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment(one);
};
var $author$project$Api$CompanyPlan$availableForEnrollment = function (companyPlan) {
	switch (companyPlan.$) {
		case 0:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment(companyPlan_);
		case 1:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$All$availableForEnrollment(companyPlan_);
		default:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Employer$CompanyPlan$All$availableForEnrollment(companyPlan_);
	}
};
var $author$project$Components$Employee$EnrollmentModal$planOptions = function (companyPlans) {
	return A2(
		$elm$core$List$map,
		function (companyPlan) {
			var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
			var label = (!$author$project$Api$CompanyPlan$availableForEnrollment(companyPlan)) ? ($author$project$Api$Plan$name(plan) + ' (Hidden for new enrollments)') : $author$project$Api$Plan$name(plan);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$author$project$Api$Plan$id(plan)),
				label);
		},
		companyPlans);
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$patient = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Provider(
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient(companyRegistration_));
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Patient$Min$Employer(
			$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$patient(companyRegistration_));
	}
};
var $author$project$Components$Employee$EnrollmentModal$patientsOutsideAgeRange = F2(
	function (plan, companyRegistrations) {
		var patients = A2($elm$core$List$map, $author$project$Api$CompanyRegistration$ForCompanyAccountOne$patient, companyRegistrations);
		var belowAgePatients = A2(
			$elm$core$List$filter,
			function (patient) {
				var _v1 = _Utils_Tuple2(
					plan.T1,
					$author$project$Api$Patient$Min$age(patient));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var minimumAge = _v1.a.a;
					var age = _v1.b.a;
					return _Utils_cmp(age, minimumAge) < 0;
				} else {
					return false;
				}
			},
			patients);
		var aboveAgePatients = A2(
			$elm$core$List$filter,
			function (patient) {
				var _v0 = _Utils_Tuple2(
					plan.Tu,
					$author$project$Api$Patient$Min$age(patient));
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var maximumAge = _v0.a.a;
					var age = _v0.b.a;
					return _Utils_cmp(age, maximumAge) > 0;
				} else {
					return false;
				}
			},
			patients);
		return _Utils_Tuple2(belowAgePatients, aboveAgePatients);
	});
var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$One$registrations = function (_v0) {
	var record = _v0.b;
	return record.age;
};
var $author$project$Api$CompanyAccount$One$registrations = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$CompanyRegistration$ForCompanyAccountOne$Provider,
			$author$project$Api$Provider$CompanyAccount$One$registrations(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$CompanyRegistration$ForCompanyAccountOne$Employer,
			$author$project$Api$Employer$CompanyAccount$One$registrations(companyAccount_));
	}
};
var $author$project$Components$Employee$EnrollmentModal$viewPatient = function (patient) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Patient$Min$name(patient))
					])),
				$elm$html$Html$text(' is '),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'N/A',
							A2(
								$elm$core$Maybe$map,
								$elm$core$String$fromInt,
								$author$project$Api$Patient$Min$age(patient))))
					])),
				$elm$html$Html$text(' years old.')
			]));
};
var $author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange = F3(
	function (range, limit, patients) {
		return A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('The '),
					$elm$html$Html$text(range),
					$elm$html$Html$text(' age defined for this plan is '),
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, limit))),
					$elm$html$Html$text('.'),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Components$Employee$EnrollmentModal$viewPatient, patients))
				]));
	});
var $author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRangeWarning = F2(
	function (plan, companyAccount) {
		var _v0 = A2(
			$author$project$Components$Employee$EnrollmentModal$patientsOutsideAgeRange,
			plan,
			$author$project$Api$CompanyAccount$One$registrations(companyAccount));
		var belowAgePatients = _v0.a;
		var aboveAgePatients = _v0.b;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					($elm$core$List$length(belowAgePatients) >= 1) ? A3($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange, 'minimum', plan.T1, belowAgePatients) : $author$project$Utils$Html$empty,
					($elm$core$List$length(aboveAgePatients) >= 1) ? A3($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange, 'maximum', plan.Tu, aboveAgePatients) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Employee$EnrollmentModal$viewForm = F2(
	function (form, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(form);
		var membershipStartsAfterEligibility = function () {
			var _v2 = $author$project$Api$CompanyAccount$One$eligibilityStartDate(fields.Lr);
			if (!_v2.$) {
				var eligibilityStartDate = _v2.a;
				return A2($author$project$Utils$Date$isBeforeOrEqual, eligibilityStartDate, fields.TK);
			} else {
				return true;
			}
		}();
		var chargesOnNextInvoice = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (nextInvoiceDate) {
					var monthsUntilBill = A3($justinmimbs$date$Date$diff, 1, fields.TK, nextInvoiceDate) + 1;
					return A2($elm$core$Basics$max, monthsUntilBill, 0);
				},
				model.UF));
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Employee$EnrollmentModal$Save),
					$author$project$Ui$Form$horizontal
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Plan'),
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							($elm$core$List$length(fields.ak) > 1) ? A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.adR;
										},
										fields.GH)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Employee$EnrollmentModal$FormUpdated, $author$project$Components$Employee$EnrollmentModal$Plan)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]),
							$author$project$Components$Employee$EnrollmentModal$planOptions(fields.ak)) : A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											function ($) {
												return $.zh;
											},
											fields.GH)))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Start Membership'),
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$justinmimbs$date$Date$toIsoString(fields.TK))),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Components$Employee$EnrollmentModal$FormUpdated, $author$project$Components$Employee$EnrollmentModal$MembershipStartDate),
											$elm$core$Result$toMaybe),
										$justinmimbs$date$Date$fromIsoString)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]),
							A2($author$project$Components$Employee$EnrollmentModal$membershipStartDateOptions, model.cO, model.IQ))
						])),
					(chargesOnNextInvoice <= 1) ? A2(
					$author$project$Ui$Alert$info,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('We will charge for this employee starting on the draft '),
							$elm$html$Html$text(
							A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, fields.TK)),
							$elm$html$Html$text(' invoice.')
						])) : $author$project$Utils$Html$empty,
					(!_Utils_eq(
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.$O;
						},
						fields.GH),
					$elm$core$Maybe$Nothing)) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This plan includes a tobacco surcharge. Please review each member’s tobacco use to ensure pricing is accurate.')
						])) : $author$project$Utils$Html$empty,
					((chargesOnNextInvoice > 1) || (!membershipStartsAfterEligibility)) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							(chargesOnNextInvoice > 1) ? A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('We will back bill this enrollee starting from '),
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, fields.TK)),
									$elm$html$Html$text('. '),
									$elm$html$Html$text('All charges will be added to the draft '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											model.UF))),
									$elm$html$Html$text(' invoice.')
								])) : $author$project$Utils$Html$empty,
							(!membershipStartsAfterEligibility) ? A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('You are enrolling this person before their eligibility start date.')
								])) : $author$project$Utils$Html$empty
						])) : $author$project$Utils$Html$empty,
					function () {
					var _v1 = fields.GH;
					if (!_v1.$) {
						var plan = _v1.a;
						return A2($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRangeWarning, plan, fields.Lr);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Employee$EnrollmentModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Employee$EnrollmentModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$htmlTitle(
						_List_fromArray(
							[
								function () {
								var _v1 = model.DV;
								if (_v1 === 1) {
									return $elm$html$Html$text('Approve');
								} else {
									return $elm$html$Html$text('Enroll');
								}
							}(),
								$author$project$Utils$Html$noBreakSpace,
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(model.kk)
									]))
							]))
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						function () {
						var _v2 = model.PB;
						if (!_v2.$) {
							var form = _v2.a;
							return A2($author$project$Components$Employee$EnrollmentModal$viewForm, form, model);
						} else {
							return A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Spinner$view(_List_Nil)
									]));
						}
					}(),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Employee$EnrollmentModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						function () {
						var verb = function () {
							var _v3 = model.DV;
							if (!_v3) {
								return 'Enroll';
							} else {
								return 'Approve and Enroll';
							}
						}();
						return A3(
							$author$project$Ui$Button$view,
							{abp: verb + (' ' + model.kk)},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Employee$EnrollmentModal$Save),
									$author$project$Ui$Button$disabled(
									_Utils_eq(model.PB, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(verb),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.kk)
										]))
								]));
					}()
					]))
			]));
};
var $author$project$Components$Company$EmployeeRow$viewEnrollModal = function (model) {
	var _v0 = model.fD;
	if (!_v0.$) {
		var enrollmentModal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Company$EmployeeRow$EnrollmentModalMsg,
			$author$project$Components$Employee$EnrollmentModal$view(enrollmentModal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$UnenrollModal$CancellationReason = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$UnenrollModal$Close = {$: 0};
var $author$project$Components$Company$UnenrollModal$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$UnenrollModal$Unenroll = {$: 1};
var $author$project$Api$Employer$CancellationReason$Shared$description = function (_v0) {
	var shared = _v0;
	return shared.Nx;
};
var $author$project$Api$Employer$CancellationReason$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$CancellationReason$Shared$description(shared);
};
var $author$project$Api$CancellationReason$description = function (cancellationReason) {
	if (cancellationReason.$ === 1) {
		var cancellationReason_ = cancellationReason.a;
		return $author$project$Api$Provider$CancellationReason$All$description(cancellationReason_);
	} else {
		var cancellationReason_ = cancellationReason.a;
		return $author$project$Api$Employer$CancellationReason$All$description(cancellationReason_);
	}
};
var $author$project$Api$Employer$CancellationReason$Shared$id = function (_v0) {
	var shared = _v0;
	return shared.adR;
};
var $author$project$Api$Employer$CancellationReason$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$CancellationReason$Shared$id(shared);
};
var $author$project$Api$CancellationReason$id = function (cancellationReason) {
	if (cancellationReason.$ === 1) {
		var cancellationReason_ = cancellationReason.a;
		return $author$project$Api$Provider$CancellationReason$All$id(cancellationReason_);
	} else {
		var cancellationReason_ = cancellationReason.a;
		return $author$project$Api$Employer$CancellationReason$All$id(cancellationReason_);
	}
};
var $author$project$Components$CancellationReason$Input$cancellationReasonOptions = function (cancellationReasons) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a reason'),
		A2(
			$elm$core$List$map,
			function (cancellationReason) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$CancellationReason$id(cancellationReason)),
					$author$project$Api$CancellationReason$description(cancellationReason));
			},
			A2(
				$elm$core$List$filter,
				function (cancellationReason) {
					return $author$project$Api$CancellationReason$description(cancellationReason) !== 'Termination by Patient';
				},
				cancellationReasons)));
};
var $author$project$Components$CancellationReason$CancellationReasonRecord$fromAll = function (cancellationReason) {
	return {
		Nx: $author$project$Api$CancellationReason$description(cancellationReason),
		adR: $author$project$Api$CancellationReason$id(cancellationReason)
	};
};
var $author$project$Components$CancellationReason$Input$findCancellationReason = F2(
	function (cancellationReasons, id) {
		return A2(
			$elm$core$Maybe$map,
			$author$project$Components$CancellationReason$CancellationReasonRecord$fromAll,
			A2(
				$elm_community$list_extra$List$Extra$find,
				function (cancellationReason) {
					return _Utils_eq(
						$author$project$Api$CancellationReason$id(cancellationReason),
						id);
				},
				cancellationReasons));
	});
var $author$project$Components$CancellationReason$Input$view = function (options) {
	var labelWidth = A2($elm$core$Maybe$withDefault, 4, options.aek);
	var _v0 = function () {
		var _v1 = options.abO;
		if (_v1.$ === 3) {
			var cancellationReasons_ = _v1.a;
			return _Utils_Tuple2(cancellationReasons_, false);
		} else {
			return _Utils_Tuple2(_List_Nil, true);
		}
	}();
	var cancellationReasons = _v0.a;
	var cancellationReasonsLoading = _v0.b;
	var _v2 = options.aaN;
	var cancellationReason = _v2.a;
	var cancellationReasonOther = _v2.b;
	var isOther = _Utils_eq(
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.Nx;
			},
			cancellationReason),
		$elm$core$Maybe$Just('Other'));
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(labelWidth),
						$author$project$Ui$Form$Group$inputSpan(12 - labelWidth),
						$author$project$Ui$Form$Group$label('Cancellation Reason'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.adR;
									},
									cancellationReason)),
								$author$project$Ui$Form$Select$onChange(
								function (id) {
									return options.ae4(
										_Utils_Tuple2(
											A2($author$project$Components$CancellationReason$Input$findCancellationReason, cancellationReasons, id),
											$elm$core$Maybe$Nothing));
								}),
								$author$project$Ui$Form$Select$invalid(
								!$elm$core$List$isEmpty(options.fE)),
								$author$project$Ui$Form$Select$errors(options.fE),
								$author$project$Ui$Form$Select$loading(cancellationReasonsLoading)
							]),
						$author$project$Components$CancellationReason$Input$cancellationReasonOptions(cancellationReasons))
					])),
				isOther ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(labelWidth),
						$author$project$Ui$Form$Group$inputSpan(12 - labelWidth),
						$author$project$Ui$Form$Group$label('Cancellation Reason Description'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$placeholder('Cancellation Reason Description Required'),
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', cancellationReasonOther)),
								$author$project$Ui$Form$Input$onInput(
								function (string) {
									return options.ae4(
										_Utils_Tuple2(
											cancellationReason,
											$author$project$Utils$String$toMaybe(string)));
								}),
								$author$project$Ui$Form$Input$invalid(
								!$elm$core$List$isEmpty(options.OP)),
								$author$project$Ui$Form$Input$errors(options.OP)
							]))
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Api$Employer$CompanyAccount$Meta$billFromDate = function (_v0) {
	var meta = _v0;
	return meta.ja.JX;
};
var $author$project$Api$Provider$CompanyAccount$Meta$billFromDate = function (_v0) {
	var meta = _v0;
	return meta.ja.JX;
};
var $author$project$Api$CompanyAccount$Meta$billFromDate = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$billFromDate(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$billFromDate(meta_);
	}
};
var $justinmimbs$date$Date$isBetween = F3(
	function (_v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var x = _v2;
		return A3($justinmimbs$date$Date$isBetweenInt, a, b, x);
	});
var $author$project$Api$Employer$CompanyAccount$Meta$minWithoutProration = function (_v0) {
	var meta = _v0;
	return meta.ja.qs.T0;
};
var $author$project$Api$Provider$CompanyAccount$Meta$minWithoutProration = function (_v0) {
	var meta = _v0;
	return meta.ja.qs.T0;
};
var $author$project$Api$CompanyAccount$Meta$minWithoutProration = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$minWithoutProration(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$minWithoutProration(meta_);
	}
};
var $author$project$Components$Company$UnenrollModal$mayHaveCancellableInvoice = F2(
	function (companyAccountMeta, endDate) {
		var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
		var billFromDate = $author$project$Api$CompanyAccount$Meta$billFromDate(companyAccountMeta);
		var _v0 = _Utils_Tuple3(endDate, minWithoutProration, billFromDate);
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var endDate_ = _v0.a.a;
			var minWithoutProration_ = _v0.b.a;
			var billFromDate_ = _v0.c.a;
			return A3($justinmimbs$date$Date$isBetween, minWithoutProration_, billFromDate_, endDate_) && (!_Utils_eq(endDate_, billFromDate_));
		} else {
			return false;
		}
	});
var $author$project$Components$Company$UnenrollModal$viewCancellableInvoiceMessage = F2(
	function (companyAccountMeta, endDate) {
		return A2($author$project$Components$Company$UnenrollModal$mayHaveCancellableInvoice, companyAccountMeta, endDate) ? A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Patient will not appear on invoices after this date.')
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Employer$CompanyAccount$Meta$billingStartDate = function (_v0) {
	var meta = _v0;
	return meta.ja.J$;
};
var $author$project$Api$Provider$CompanyAccount$Meta$billingStartDate = function (_v0) {
	var meta = _v0;
	return meta.ja.J$;
};
var $author$project$Api$CompanyAccount$Meta$billingStartDate = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$billingStartDate(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$billingStartDate(meta_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Meta$maxWithoutBilling = function (_v0) {
	var meta = _v0;
	return meta.ja.qs.Tt;
};
var $author$project$Api$Provider$CompanyAccount$Meta$maxWithoutBilling = function (_v0) {
	var meta = _v0;
	return meta.ja.qs.Tt;
};
var $author$project$Api$CompanyAccount$Meta$maxWithoutBilling = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$maxWithoutBilling(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$maxWithoutBilling(meta_);
	}
};
var $author$project$Components$Company$UnenrollModal$mayNeedProration = F2(
	function (companyAccountMeta, endDate) {
		var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
		var maxWithoutBilling = $author$project$Api$CompanyAccount$Meta$maxWithoutBilling(companyAccountMeta);
		var _v0 = _Utils_Tuple3(minWithoutProration, maxWithoutBilling, endDate);
		if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
			var minWithoutProration_ = _v0.a.a;
			var maxWithoutBilling_ = _v0.b.a;
			var endDate_ = _v0.c.a;
			return A3($justinmimbs$date$Date$isBetween, maxWithoutBilling_, minWithoutProration_, endDate_) && (!_Utils_eq(endDate_, minWithoutProration_));
		} else {
			return false;
		}
	});
var $author$project$Components$Company$UnenrollModal$prorationWarning = F3(
	function (supportUrl, minWithoutProration, billedFromDate) {
		var format = function (maybeDate) {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
					maybeDate));
		};
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'We have billed this membership through ' + (format(minWithoutProration) + ('. If you’d like to credit the period of ' + (format(billedFromDate) + (' through ' + (format(minWithoutProration) + ', you can learn how to do that ')))))),
							A3(
							$author$project$Ui$Link$externalHref,
							supportUrl,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							$elm$html$Html$text('.')
						]))
				]));
	});
var $author$project$Components$Company$UnenrollModal$viewProrationWarning = F2(
	function (companyAccountMeta, endDate) {
		if (A2($author$project$Components$Company$UnenrollModal$mayNeedProration, companyAccountMeta, endDate)) {
			var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
			var billingStartDate = $author$project$Api$CompanyAccount$Meta$billingStartDate(companyAccountMeta);
			var billedFromDate = A2(
				$elm_community$list_extra$List$Extra$maximumBy,
				$justinmimbs$date$Date$toRataDie,
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					_List_fromArray(
						[endDate, billingStartDate])));
			return A3($author$project$Components$Company$UnenrollModal$prorationWarning, 'https://support.hint.com/en/articles/4622730-adding-an-employer-credit-or-one-off-charge', minWithoutProration, billedFromDate);
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Company$UnenrollModal$view = F2(
	function (cancellationReasons, model) {
		var minDate = A2($elm$core$Maybe$withDefault, model.cO, model.y6);
		var isDisabled = function (date) {
			return !(!A2($justinmimbs$date$Date$compare, minDate, date));
		};
		var fields = $author$project$Utils$Form$fields(model.PB);
		var accountMeta = $author$project$Api$CompanyAccount$All$meta(model.Lr);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Company$UnenrollModal$Close,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Unenroll Employee')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$onSubmit($author$project$Components$Company$UnenrollModal$Unenroll),
									$author$project$Ui$Form$horizontal
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('End Date'),
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(4),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Company$UnenrollModal$EndDateInputMsg,
											A2(
												$author$project$Components$DateInput$view,
												_List_fromArray(
													[
														$author$project$Components$DateInput$value(fields.agi),
														$author$project$Components$DateInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB)),
														$author$project$Components$DateInput$errors(
														A2($author$project$Utils$Form$validationErrors, 2, model.PB)),
														$author$project$Components$DateInput$disabledPickerDates(isDisabled)
													]),
												model.qu)),
											A2($author$project$Components$Company$UnenrollModal$viewCancellableInvoiceMessage, accountMeta, fields.agi),
											A2($author$project$Components$Company$UnenrollModal$viewProrationWarning, accountMeta, fields.agi)
										])),
									$author$project$Components$CancellationReason$Input$view(
									{
										abO: cancellationReasons,
										fE: A2($author$project$Utils$Form$validationErrors, 0, model.PB),
										OP: A2($author$project$Utils$Form$validationErrors, 1, model.PB),
										aek: $elm$core$Maybe$Nothing,
										ae4: A2($elm$core$Basics$composeL, $author$project$Components$Company$UnenrollModal$FormUpdated, $author$project$Components$Company$UnenrollModal$CancellationReason),
										aaN: _Utils_Tuple2(fields.abM, fields.abN)
									})
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick($author$project$Components$Company$UnenrollModal$Close)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'End employee enrollment'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick($author$project$Components$Company$UnenrollModal$Unenroll),
									$author$project$Ui$Button$disabled(
									$author$project$Utils$Form$hasAnyValidationError(model.PB))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('End')
								]))
						]))
				]));
	});
var $author$project$Components$Company$EmployeeRow$viewUnenrollModal = function (model) {
	var _v0 = model.g6;
	if (!_v0.$) {
		var unenrollModal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Company$EmployeeRow$UnenrollModalMsg,
			A2($author$project$Components$Company$UnenrollModal$view, model.abO, unenrollModal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$EmployeeRow$modal = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Company$EmployeeRow$deleteModal(model),
				$author$project$Components$Company$EmployeeRow$viewUnenrollModal(model),
				$author$project$Components$Company$EmployeeRow$viewEnrollModal(model),
				$author$project$Components$Company$EmployeeRow$viewEnrollDependentModal(model)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewEmployeesStats = F3(
	function (companyType_, employeeCount, dependentCount) {
		var totalCount = A2($elm$core$Maybe$withDefault, 0, employeeCount) + A2($elm$core$Maybe$withDefault, 0, dependentCount);
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Formatters$String$affiliateMember, 'Employees', companyType_) + ': ')
										])),
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, employeeCount)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Dependents: ')
										])),
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, dependentCount)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Total: ')
										])),
									A2(
									$author$project$Ui$Typography$title,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(totalCount))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewNewEmployeeDependentButton = function (company) {
	return (!(!$author$project$Api$Company$companyType(company))) ? A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create(
			{
				ff: $author$project$Api$Company$id(company)
			}),
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonDefault,
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('New Employee or Dependent')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel = function (filter) {
	switch (filter) {
		case 0:
			return 'All Status';
		case 1:
			return 'Needs Approval';
		case 2:
			return 'Denied Approval';
		case 3:
			return 'Enrolled';
		case 4:
			return 'Unenrolled';
		case 5:
			return 'Eligible';
		default:
			return 'Not Eligible';
	}
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterItems = function (currentFilter) {
	var filterToItem = function (filter) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentFilter, filter)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterSelected(filter))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel(filter)));
	};
	return A2(
		$elm$core$List$cons,
		filterToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				filterToItem,
				_List_fromArray(
					[1, 2, 3, 4, 5, 6]))));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewSearchAndFilters = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(8),
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg,
								A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(4),
								$author$project$Ui$FlexGrid$spanMd(2)
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Ui$NewDropdown$viewSelect,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel(model.Fi))
									]),
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$filterItems(model.Fi),
								model.mg)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$usesEmployeeDivisions = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				var company__ = company_;
				return $author$project$Api$Company$usesEmployeeDivisions(company__);
			},
			company));
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$columns = function (model) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'name', true, 'Name'),
					A3($author$project$Api$Column$init, 'type', true, 'Type'),
					A3($author$project$Api$Column$init, 'email', false, 'Email'),
					A3($author$project$Api$Column$init, 'date_of_birth', true, 'Date of Birth'),
					A3($author$project$Api$Column$init, 'plan', true, 'Plan'),
					A3($author$project$Api$Column$init, 'status', true, 'Status')
				]),
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$usesEmployeeDivisions(
				$elm$core$Maybe$Just(model.ab9)) ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'divisions', true, 'Divisions')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'actions', false, 'Actions')
				])
			]));
};
var $author$project$Ui$Table$Attribute = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Table$CellActive = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Table$Display = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Table$Hidden = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Table$Nested = {$: 8};
var $author$project$Ui$Table$NoWrap = {$: 9};
var $author$project$Ui$Table$Rowspan = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Table$VerticalAlignedBottom = {$: 14};
var $author$project$Ui$Table$VerticalCenteredCell = {$: 15};
var $author$project$Ui$Table$mapCellOption = F2(
	function (f, cellOption) {
		switch (cellOption.$) {
			case 0:
				var attributes = cellOption.a;
				return $author$project$Ui$Table$Attribute(attributes);
			case 1:
				var value = cellOption.a;
				return $author$project$Ui$Table$CellActive(value);
			case 2:
				var alignment = cellOption.a;
				return $author$project$Ui$Table$CellAlignment(alignment);
			case 3:
				var _int = cellOption.a;
				return $author$project$Ui$Table$Colspan(_int);
			case 4:
				var display = cellOption.a;
				return $author$project$Ui$Table$Display(display);
			case 5:
				var screenSize = cellOption.a;
				var _int = cellOption.b;
				return A2($author$project$Ui$Table$Grid, screenSize, _int);
			case 6:
				var screenSize = cellOption.a;
				return $author$project$Ui$Table$Hidden(screenSize);
			case 7:
				var string = cellOption.a;
				return $author$project$Ui$Table$MinWidth(string);
			case 8:
				return $author$project$Ui$Table$Nested;
			case 9:
				return $author$project$Ui$Table$NoWrap;
			case 11:
				var _int = cellOption.a;
				return $author$project$Ui$Table$Rowspan(_int);
			case 10:
				var msg = cellOption.a;
				return $author$project$Ui$Table$OnClick(
					f(msg));
			case 12:
				var bool = cellOption.a;
				return $author$project$Ui$Table$Sortable(bool);
			case 13:
				var direction = cellOption.a;
				return $author$project$Ui$Table$SortDirection(direction);
			case 14:
				return $author$project$Ui$Table$VerticalAlignedBottom;
			default:
				return $author$project$Ui$Table$VerticalCenteredCell;
		}
	});
var $author$project$Ui$Table$mapCell = F2(
	function (f, _v0) {
		var _v1 = _v0;
		var options = _v1.a;
		var contents = _v1.b;
		return _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				$author$project$Ui$Table$mapCellOption(f),
				options),
			A2(
				$elm$core$List$map,
				$elm$html$Html$map(f),
				contents));
	});
var $author$project$Ui$Table$mapRowOption = F2(
	function (_v0, rowOption) {
		if (!rowOption.$) {
			var style = rowOption.a;
			return $author$project$Ui$Table$Styled(style);
		} else {
			return $author$project$Ui$Table$NoBorder;
		}
	});
var $author$project$Ui$Table$mapRow = F2(
	function (f, row_) {
		if (row_.$ === 1) {
			var _v1 = row_.a;
			var options = _v1.a;
			var cells = _v1.b;
			return $author$project$Ui$Table$Row(
				_Utils_Tuple2(
					A2(
						$elm$core$List$map,
						$author$project$Ui$Table$mapRowOption(f),
						options),
					A2(
						$elm$core$List$map,
						$author$project$Ui$Table$mapCell(f),
						cells)));
		} else {
			return $author$project$Ui$Table$None;
		}
	});
var $author$project$Components$Company$EmployeeRow$EmployerOrProviderCompany = $elm$core$Basics$identity;
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$status = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$status(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$status(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus = function (employee) {
	if (!employee.$) {
		var employee_ = employee.a;
		return $author$project$Api$CompanyAccount$All$status(employee_);
	} else {
		var employee_ = employee.a;
		return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$status(employee_);
	}
};
var $author$project$Components$Company$EmployeeRow$endingStatus = F3(
	function (endDate, currentDate, endDateString) {
		if (!endDate.$) {
			var date = endDate.a;
			return ((A2($justinmimbs$date$Date$compare, currentDate, date) === 2) || (A2($justinmimbs$date$Date$compare, currentDate, date) === 1)) ? ('Ended on ' + endDateString) : ('Member through ' + endDateString);
		} else {
			return 'Eligible';
		}
	});
var $author$project$Api$Employer$CompanyAccount$All$membershipEndDate = function (_v0) {
	var record = _v0.b;
	return record.TE;
};
var $author$project$Api$Provider$CompanyAccount$All$membershipEndDate = function (_v0) {
	var record = _v0.b;
	return record.TE;
};
var $author$project$Api$CompanyAccount$All$membershipEndDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$membershipEndDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$membershipEndDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$membershipEndDate = function (_v0) {
	var record = _v0;
	return record.TE;
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$membershipEndDate(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$membershipEndDate = function (_v0) {
	var record = _v0;
	return record.TE;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$membershipEndDate(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$accountStatus = F2(
	function (currentDate, employee) {
		var status = $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus(employee);
		var membershipEndDate = function () {
			if (!employee.$) {
				var employee_ = employee.a;
				return $author$project$Api$CompanyAccount$All$membershipEndDate(employee_);
			} else {
				var employee_ = employee.a;
				return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(employee_);
			}
		}();
		var membershipEndDateString = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
				membershipEndDate));
		switch (status) {
			case 'ending':
				return A3($author$project$Components$Company$EmployeeRow$endingStatus, membershipEndDate, currentDate, membershipEndDateString);
			case 'needs_approval':
				return 'Needs Approval';
			case 'eligible':
				return A3($author$project$Components$Company$EmployeeRow$endingStatus, membershipEndDate, currentDate, membershipEndDateString);
			case 'enrolled':
				var membershipStartDateString = function () {
					if (!employee.$) {
						var employee_ = employee.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
								$author$project$Api$CompanyAccount$All$membershipStartDate(employee_)));
					} else {
						var employee_ = employee.a;
						return A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
								$author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(employee_)));
					}
				}();
				return 'Enrolled' + (' as of ' + membershipStartDateString);
			default:
				return $author$project$Formatters$String$humanize(status);
		}
	});
var $author$project$Api$EmployeeDivision$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$EmployeeDivision$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyAccount$All$division = function (_v0) {
	var record = _v0.b;
	return record.NT;
};
var $author$project$Api$Provider$CompanyAccount$All$division = function (_v0) {
	var record = _v0.b;
	return record.NT;
};
var $author$project$Api$CompanyAccount$All$division = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$EmployeeDivision$Shared$Provider,
			$author$project$Api$Provider$CompanyAccount$All$division(companyAccount_));
	} else {
		var companyAccount_ = companyAccount.a;
		return A2(
			$elm$core$Maybe$map,
			$author$project$Api$EmployeeDivision$Shared$Employer,
			$author$project$Api$Employer$CompanyAccount$All$division(companyAccount_));
	}
};
var $author$project$Api$Employer$Patient$Min$dob = function (_v0) {
	var record = _v0;
	return record.acQ;
};
var $author$project$Api$Provider$Patient$Min$dob = function (_v0) {
	var min = _v0;
	return min.acQ;
};
var $author$project$Api$Patient$Min$dob = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$dob(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$dob(patient_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Shared$eligibilityEndDate = function (_v0) {
	var record = _v0;
	return record.Ok;
};
var $author$project$Api$Employer$CompanyAccount$All$eligibilityEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityEndDate(shared);
};
var $author$project$Api$Provider$CompanyAccount$Shared$eligibilityEndDate = function (_v0) {
	var record = _v0.b;
	return record.Ok;
};
var $author$project$Api$Provider$CompanyAccount$All$eligibilityEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityEndDate(shared);
};
var $author$project$Api$CompanyAccount$All$eligibilityEndDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$eligibilityEndDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$eligibilityEndDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityEndDate = function (_v0) {
	var record = _v0;
	return record.Ok;
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityEndDate(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityEndDate = function (_v0) {
	var record = _v0;
	return record.Ok;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityEndDate(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(companyRegistration_);
	}
};
var $author$project$Api$Employer$CompanyAccount$All$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$Provider$CompanyAccount$All$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$CompanyAccount$All$eligibilityStartDate = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$eligibilityStartDate(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$eligibilityStartDate(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityStartDate = function (_v0) {
	var record = _v0;
	return record.Ol;
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityStartDate = function (_v0) {
	var record = _v0;
	return record.Ol;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityStartDate(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo = function (employee) {
	var eligibilityStartDate = function () {
		if (!employee.$) {
			var employee_ = employee.a;
			return $author$project$Api$CompanyAccount$All$eligibilityStartDate(employee_);
		} else {
			var employee_ = employee.a;
			return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(employee_);
		}
	}();
	var eligibilityEndDate = function () {
		if (!employee.$) {
			var employee_ = employee.a;
			return $author$project$Api$CompanyAccount$All$eligibilityEndDate(employee_);
		} else {
			var employee_ = employee.a;
			return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(employee_);
		}
	}();
	var _v0 = _Utils_Tuple2(eligibilityStartDate, eligibilityEndDate);
	if (!_v0.a.$) {
		if (_v0.b.$ === 1) {
			var eligibilityDate = _v0.a.a;
			var _v1 = _v0.b;
			return 'Eligible from ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityDate);
		} else {
			var eligibilityDate = _v0.a.a;
			var eligibilityEndDate_ = _v0.b.a;
			return 'Eligible from ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityDate) + (' to ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityEndDate_)));
		}
	} else {
		return '';
	}
};
var $author$project$Components$Company$EmployeeRow$eligibilityStatus = F2(
	function (model, employee) {
		var eligibilityEndDate = function () {
			if (!employee.$) {
				var employee_ = employee.a;
				return $author$project$Api$CompanyAccount$All$eligibilityEndDate(employee_);
			} else {
				var employee_ = employee.a;
				return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(employee_);
			}
		}();
		if (!eligibilityEndDate.$) {
			var eligibilityEndDate_ = eligibilityEndDate.a;
			return A2($author$project$Utils$Date$isBefore, eligibilityEndDate_, model.cO) ? ('Ineligible since ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityEndDate_)) : $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo(employee);
		} else {
			return $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo(employee);
		}
	});
var $author$project$Api$Employer$Patient$Min$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$Patient$Min$email = function (_v0) {
	var min = _v0;
	return min.Oo;
};
var $author$project$Api$Patient$Min$email = function (patient) {
	if (!patient.$) {
		var patient_ = patient.a;
		return $author$project$Api$Provider$Patient$Min$email(patient_);
	} else {
		var patient_ = patient.a;
		return $author$project$Api$Employer$Patient$Min$email(patient_);
	}
};
var $author$project$Components$Company$EmployeeRow$Dependent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$EmployeeRow$Employee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$EmployeeRow$employeeOrDependent = function (model) {
	var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Ly);
	if (_v0 === 'employee') {
		return $author$project$Components$Company$EmployeeRow$Employee(model.Lr);
	} else {
		return $author$project$Components$Company$EmployeeRow$Dependent(model.Ly);
	}
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$externalId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$externalId(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$externalId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$externalId(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$externalId = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$externalId(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$externalId(companyRegistration_);
	}
};
var $author$project$Components$Company$EmployeeRow$isNetwork = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return !$author$project$Api$Company$companyType(company_);
	} else {
		return false;
	}
};
var $author$project$Api$Employer$CompanyRegistration$Shared$isSubscriber = function (_v0) {
	var record = _v0;
	return record.R8;
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyRegistration$Shared$isSubscriber(shared);
};
var $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber = function (_v0) {
	var record = _v0;
	return record.R8;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber(shared);
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$isSubscriber(companyRegistration_);
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$isSubscriber(companyRegistration_);
	}
};
var $author$project$Api$EmployeeDivision$Shared$name = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$Shared$name(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$Shared$name(employeeDivision_);
	}
};
var $author$project$Ui$Table$nested = $author$project$Ui$Table$Nested;
var $author$project$Components$Company$EmployeeRow$usesEmployeeDivisions = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (company_) {
				var company__ = company_;
				return $author$project$Api$Company$usesEmployeeDivisions(company__);
			},
			company));
};
var $author$project$Components$Company$EmployeeRow$Approve = 0;
var $author$project$Components$Company$EmployeeRow$ApproveEmployee = {$: 11};
var $author$project$Components$Company$EmployeeRow$DeleteEmployeeOrDependent = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Company$EmployeeRow$Deny = 1;
var $author$project$Components$Company$EmployeeRow$DenyEmployee = {$: 13};
var $author$project$Components$Company$EmployeeRow$DependentMeta = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$EmployeeRow$EditEmployeeOrDependent = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Company$EmployeeRow$EmployeeMeta = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$EmployeeRow$Enroll = 2;
var $author$project$Components$Company$EmployeeRow$EnrollEmployeeOrDependent = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentEligible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentIneligible = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$EmployeeRow$MakeEligible = 5;
var $author$project$Components$Company$EmployeeRow$MakeIneligible = 4;
var $author$project$Components$Company$EmployeeRow$Remove = 6;
var $author$project$Components$Company$EmployeeRow$Unenroll = 3;
var $author$project$Components$Company$EmployeeRow$UnenrollEmployeeOrDependent = function (a) {
	return {$: 15, a: a};
};
var $author$project$Ui$NewDropdown$ButtonSize = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$NewDropdown$Sm = 0;
var $author$project$Ui$NewDropdown$buttonSm = $author$project$Ui$NewDropdown$ButtonSize(0);
var $author$project$Api$Employer$CompanyAccount$Meta$canEnrollAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Ks;
};
var $author$project$Api$Provider$CompanyAccount$Meta$canEnrollAction = function (_v0) {
	var record = _v0;
	return record.tF.Ks;
};
var $author$project$Api$CompanyAccount$Meta$canEnrollAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$canEnrollAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$canEnrollAction(meta_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Meta$canEnrollAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Ks;
};
var $author$project$Api$Provider$Meta$CompanyRegistration$enrollAction = function (_v0) {
	var record = _v0;
	return record.tF.OC;
};
var $author$project$Api$CompanyRegistration$Meta$canEnrollAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Meta$CompanyRegistration$enrollAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyRegistration$Meta$canEnrollAction(meta_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Shared$isEligible = function (_v0) {
	var record = _v0;
	return record.RK;
};
var $author$project$Api$Employer$CompanyAccount$All$isEligible = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyAccount$Shared$isEligible(shared);
};
var $author$project$Api$Provider$CompanyAccount$Shared$isEligible = function (_v0) {
	var record = _v0.b;
	return record.RK;
};
var $author$project$Api$Provider$CompanyAccount$All$isEligible = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$isEligible(shared);
};
var $author$project$Api$CompanyAccount$All$isEligible = function (companyAccount) {
	if (!companyAccount.$) {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Provider$CompanyAccount$All$isEligible(companyAccount_);
	} else {
		var companyAccount_ = companyAccount.a;
		return $author$project$Api$Employer$CompanyAccount$All$isEligible(companyAccount_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Meta$isEligibleAction = function (_v0) {
	var meta = _v0;
	return meta.tF.RK;
};
var $author$project$Api$Provider$CompanyAccount$Meta$isEligibleAction = function (_v0) {
	var meta = _v0;
	return meta.tF.RK;
};
var $author$project$Api$CompanyAccount$Meta$isEligibleAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$isEligibleAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$isEligibleAction(meta_);
	}
};
var $author$project$Api$Employer$CompanyRegistration$Meta$isEligibleAction = function (_v0) {
	var meta = _v0;
	return meta.tF.RK;
};
var $author$project$Api$Provider$Meta$CompanyRegistration$isEligibleAction = function (_v0) {
	var meta = _v0;
	return meta.tF.RK;
};
var $author$project$Api$CompanyRegistration$Meta$isEligibleAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$Meta$CompanyRegistration$isEligibleAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyRegistration$Meta$isEligibleAction(meta_);
	}
};
var $author$project$Api$Employer$CompanyAccount$Meta$needsApprovalAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Um;
};
var $author$project$Api$Provider$CompanyAccount$Meta$needsApprovalAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Um;
};
var $author$project$Api$CompanyAccount$Meta$needsApprovalAction = function (meta) {
	if (!meta.$) {
		var meta_ = meta.a;
		return $author$project$Api$Provider$CompanyAccount$Meta$needsApprovalAction(meta_);
	} else {
		var meta_ = meta.a;
		return $author$project$Api$Employer$CompanyAccount$Meta$needsApprovalAction(meta_);
	}
};
var $author$project$Components$Company$EmployeeRow$canTakeAction = F4(
	function (actions, employee, meta, model) {
		var status = $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus(employee);
		switch (actions) {
			case 0:
				if (!meta.$) {
					var meta_ = meta.a;
					return $author$project$Api$CompanyAccount$Meta$needsApprovalAction(meta_) || ((status === 'needs_approval') || (status === 'denied'));
				} else {
					return false;
				}
			case 1:
				if (!employee.$) {
					return status === 'needs_approval';
				} else {
					return false;
				}
			case 2:
				var enrollMeta = function () {
					if (!meta.$) {
						var meta_ = meta.a;
						return $author$project$Api$CompanyAccount$Meta$canEnrollAction(meta_);
					} else {
						var meta_ = meta.a;
						return $author$project$Api$CompanyRegistration$Meta$canEnrollAction(meta_);
					}
				}();
				return enrollMeta || (enrollMeta && ((status === 'eligible') && (!$author$project$Components$Company$EmployeeRow$isNetwork(
					$elm$core$Maybe$Just(model.ab9)))));
			case 3:
				return (status === 'enrolled') && (!$author$project$Components$Company$EmployeeRow$isNetwork(
					$elm$core$Maybe$Just(model.ab9)));
			case 4:
				return status === 'eligible';
			case 5:
				if (!meta.$) {
					var meta_ = meta.a;
					return $author$project$Api$CompanyAccount$Meta$isEligibleAction(meta_);
				} else {
					var meta_ = meta.a;
					return $author$project$Api$CompanyRegistration$Meta$isEligibleAction(meta_);
				}
			default:
				if (!employee.$) {
					var employee_ = employee.a;
					return !$author$project$Api$CompanyAccount$All$isEligible(employee_);
				} else {
					return status === 'ineligible';
				}
		}
	});
var $author$project$Api$CompanyRegistration$Meta$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CompanyRegistration$Meta$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$meta = function (companyRegistration) {
	if (!companyRegistration.$) {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$CompanyRegistration$Meta$Provider(
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$meta(companyRegistration_));
	} else {
		var companyRegistration_ = companyRegistration.a;
		return $author$project$Api$CompanyRegistration$Meta$Employer(
			$author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$meta(companyRegistration_));
	}
};
var $author$project$Components$Company$EmployeeRow$viewActionsDropdown = function (model) {
	var canManageAccount = !$author$project$Components$Company$EmployeeRow$isNetwork(
		$elm$core$Maybe$Just(model.ab9));
	return _List_fromArray(
		[
			function () {
			if (canManageAccount) {
				var registrationId = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(model.Ly);
				var employeeOrDependentMeta = function () {
					var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Ly);
					if (_v0 === 'employee') {
						return $author$project$Components$Company$EmployeeRow$EmployeeMeta(
							$author$project$Api$CompanyAccount$All$meta(model.Lr));
					} else {
						return $author$project$Components$Company$EmployeeRow$DependentMeta(
							$author$project$Api$CompanyRegistration$ForCompanyAccountAll$meta(model.Ly));
					}
				}();
				var items = A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Company$EmployeeRow$EditEmployeeOrDependent(registrationId))
							]),
						$elm$html$Html$text('Edit')),
					_Utils_ap(
						A4(
							$author$project$Components$Company$EmployeeRow$canTakeAction,
							0,
							$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
							employeeOrDependentMeta,
							model) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect($author$project$Components$Company$EmployeeRow$ApproveEmployee)
									]),
								$elm$html$Html$text('Approve'))
							]) : _List_Nil,
						_Utils_ap(
							A4(
								$author$project$Components$Company$EmployeeRow$canTakeAction,
								1,
								$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
								employeeOrDependentMeta,
								model) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$NewDropdown$item,
									_List_fromArray(
										[
											$author$project$Ui$NewDropdown$onSelect($author$project$Components$Company$EmployeeRow$DenyEmployee)
										]),
									$elm$html$Html$text('Deny'))
								]) : _List_Nil,
							_Utils_ap(
								A4(
									$author$project$Components$Company$EmployeeRow$canTakeAction,
									2,
									$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
									employeeOrDependentMeta,
									model) ? _List_fromArray(
									[
										A2(
										$author$project$Ui$NewDropdown$item,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$onSelect(
												$author$project$Components$Company$EmployeeRow$EnrollEmployeeOrDependent(
													$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
											]),
										$elm$html$Html$text('Enroll'))
									]) : _List_Nil,
								_Utils_ap(
									A4(
										$author$project$Components$Company$EmployeeRow$canTakeAction,
										3,
										$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
										employeeOrDependentMeta,
										model) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$NewDropdown$item,
											_List_fromArray(
												[
													$author$project$Ui$NewDropdown$onSelect(
													$author$project$Components$Company$EmployeeRow$UnenrollEmployeeOrDependent(
														$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
												]),
											$elm$html$Html$text('Unenroll'))
										]) : _List_Nil,
									_Utils_ap(
										A4(
											$author$project$Components$Company$EmployeeRow$canTakeAction,
											5,
											$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
											employeeOrDependentMeta,
											model) ? _List_fromArray(
											[
												A2(
												$author$project$Ui$NewDropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$NewDropdown$onSelect(
														$author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentEligible(
															$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
													]),
												$elm$html$Html$text('Make Eligible'))
											]) : _List_Nil,
										_Utils_ap(
											A4(
												$author$project$Components$Company$EmployeeRow$canTakeAction,
												4,
												$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
												employeeOrDependentMeta,
												model) ? _List_fromArray(
												[
													A2(
													$author$project$Ui$NewDropdown$item,
													_List_fromArray(
														[
															$author$project$Ui$NewDropdown$onSelect(
															$author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentIneligible(
																$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
														]),
													$elm$html$Html$text('Make Ineligible'))
												]) : _List_Nil,
											A4(
												$author$project$Components$Company$EmployeeRow$canTakeAction,
												6,
												$author$project$Components$Company$EmployeeRow$employeeOrDependent(model),
												employeeOrDependentMeta,
												model) ? _List_fromArray(
												[
													A2(
													$author$project$Ui$NewDropdown$item,
													_List_fromArray(
														[
															$author$project$Ui$NewDropdown$onSelect(
															$author$project$Components$Company$EmployeeRow$DeleteEmployeeOrDependent(
																$elm$core$Maybe$Just(
																	$author$project$Components$Company$EmployeeRow$employeeOrDependent(model))))
														]),
													$elm$html$Html$text('Remove'))
												]) : _List_Nil)))))));
				return A4(
					$author$project$Ui$NewDropdown$view,
					_List_fromArray(
						[$author$project$Ui$NewDropdown$buttonSm]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage')
						]),
					items,
					model.fy);
			} else {
				return A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('You can\'t take any actions on this account')
						]));
			}
		}()
		]);
};
var $author$project$Components$Company$EmployeeRow$viewRow = function (model) {
	var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.Ly);
	var membershipPlanName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Plan$Min$name,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				$author$project$Api$Expandable$toMaybe(
					$author$project$Api$CompanyAccount$All$plan(model.Lr)))));
	var memberType = function () {
		if ($author$project$Components$Company$EmployeeRow$isNetwork(
			$elm$core$Maybe$Just(model.ab9)) && ($author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Ly) !== 'employee')) {
			return 'Dependent';
		} else {
			var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Ly);
			if (_v0 === 'spouse') {
				return 'Adult';
			} else {
				return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Ly);
			}
		}
	}();
	var isSubscriber = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$isSubscriber(model.Ly);
	var isEmployee = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.Ly) === 'employee';
	var nestedCellClass = (isSubscriber && isEmployee) ? _List_Nil : _List_fromArray(
		[$author$project$Ui$Table$nested]);
	var tableClass = (isSubscriber && isEmployee) ? $author$project$Ui$Table$row(_List_Nil) : $author$project$Ui$Table$row(
		_List_fromArray(
			[$author$project$Ui$Table$noBorder]));
	var externalId = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$CompanyRegistration$ForCompanyAccountAll$externalId(model.Ly));
	var patientName = A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Patient$Min$name(patient))
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text(' ' + externalId)
					]))
			]));
	var patientNameCellContent = $author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? patientName : A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
			{
				VN: $author$project$Api$Patient$Min$id(patient)
			}),
		_List_Nil,
		_List_fromArray(
			[patientName]));
	var email = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Patient$Min$email(patient));
	var dob = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
			$author$project$Api$Patient$Min$dob(patient)));
	return tableClass(
		A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Table$cell,
				nestedCellClass,
				_List_fromArray(
					[patientNameCellContent])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(memberType))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(email)
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(dob)
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(membershipPlanName)
									])),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Components$Company$EmployeeRow$accountStatus,
																model.cO,
																$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
														])),
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Components$Company$EmployeeRow$eligibilityStatus,
																model,
																$author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
														]))
												]))
										])),
								_Utils_ap(
									function () {
										if ($author$project$Components$Company$EmployeeRow$usesEmployeeDivisions(
											$elm$core$Maybe$Just(model.ab9))) {
											var division = A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$EmployeeDivision$Shared$name,
													$author$project$Api$CompanyAccount$All$division(model.Lr)));
											return _List_fromArray(
												[
													A2(
													$author$project$Ui$Table$cell,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(division)
														]))
												]);
										} else {
											return _List_Nil;
										}
									}(),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$cell,
											_List_Nil,
											$author$project$Components$Company$EmployeeRow$viewActionsDropdown(model))
										])))))))));
};
var $author$project$Components$Company$EmployeeRow$view = function (model) {
	return $author$project$Components$Company$EmployeeRow$viewRow(model);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewTable = function (model) {
	var tableRows = A2(
		$elm$core$List$map,
		function (_v2) {
			var registrationId = _v2.a;
			var row = _v2.b;
			return A2(
				$author$project$Ui$Table$mapRow,
				$author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId),
				$author$project$Components$Company$EmployeeRow$view(row));
		},
		model.eJ);
	var _v0 = function () {
		var _v1 = model.Lt;
		if (_v1.$ === 3) {
			var companyAccounts_ = _v1.a;
			return _Utils_Tuple2(false, companyAccounts_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any employees')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
			$author$project$Pages$Companies$CompanyId_String$Employees$Top$columns(model)),
		tableRows,
		_List_Nil);
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$view = function (model) {
	return {
		e5: function () {
			var tableRowModals = A2(
				$elm$core$List$map,
				function (_v1) {
					var registrationId = _v1.a;
					var row = _v1.b;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId),
						$author$project$Components$Company$EmployeeRow$modal(row));
				},
				model.eJ);
			var loading = function () {
				var _v0 = model.Lt;
				if (_v0.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			var companyType_ = $author$project$Pages$Companies$CompanyId_String$Employees$Top$companyType(
				$elm$core$Maybe$Just(model.ab9));
			return _Utils_ap(
				tableRowModals,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text(
														'All ' + A2($author$project$Formatters$String$affiliateMember, 'Employees & Dependents', companyType_))
													])),
												$author$project$Pages$Companies$CompanyId_String$Employees$Top$viewNewEmployeeDependentButton(model.ab9)
											])),
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$viewSearchAndFilters(model),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
										_List_fromArray(
											[
												A3($author$project$Pages$Companies$CompanyId_String$Employees$Top$viewEmployeesStats, companyType_, model.xo, model.Nr),
												A2(
												$author$project$Ui$Element$view,
												_List_Nil,
												_List_fromArray(
													[
														A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg, $author$project$Components$ExportCsv$link),
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg,
														A3(
															$author$project$Components$ExportCsv$modal,
															model.D5,
															_List_fromArray(
																[
																	$author$project$Components$ExportCsv$path(
																	A2($author$project$Api$CompanyRegistration$exportPath, model.ZD, model.adR)),
																	$author$project$Components$ExportCsv$params(
																	A2($elm$core$Basics$composeL, $author$project$Api$CompanyAccount$listOptionsToParams, $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams)(model))
																]),
															model.l9))
													]))
											]))
									])),
								$author$project$Pages$Companies$CompanyId_String$Employees$Top$viewTable(model),
								A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Companies$CompanyId_String$Employees$Top$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(loading)
												]),
											model.afy))
									]))
							]))
					]));
		}(),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + (' | ' + model.adR)
	};
};
var $author$project$Pages$Companies$CompanyId_String$Employees$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Employees$Top$init, aer: $author$project$Pages$Companies$CompanyId_String$Employees$Top$load, agD: $author$project$Pages$Companies$CompanyId_String$Employees$Top$save, ahd: $author$project$Pages$Companies$CompanyId_String$Employees$Top$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Employees$Top$update, ahP: $author$project$Pages$Companies$CompanyId_String$Employees$Top$view});
var $author$project$Spa$Page$applicationCompany = function (page) {
	return {
		ad0: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple3(shared.ZD, shared.WF, shared.ab9);
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						_v0$6:
						while (true) {
							switch (_v0.a.$) {
								case 3:
									switch (_v0.b.$) {
										case 3:
											if (!_v0.b.a.$) {
												switch (_v0.c.$) {
													case 3:
														if (!_v0.c.a.$) {
															var _v1 = _v0.a;
															var session = _v1.a;
															var _v2 = _v0.b;
															var practice = _v2.a.a;
															var _v3 = _v0.c;
															var company = _v3.a.a;
															return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) ? _Utils_Tuple3(
																$author$project$Spa$Page$SessionLoading(url),
																A2(
																	$author$project$Utils$Route$navigate,
																	$elm$core$Dict$empty,
																	A2($author$project$Permission$homeStateFor, session, shared.adN)),
																_List_Nil) : ((!_Utils_eq(
																url.Vx.ff,
																$author$project$Api$Provider$Company$One$id(company))) ? _Utils_Tuple3(
																$author$project$Spa$Page$SessionLoading(url),
																$elm$core$Platform$Cmd$none,
																_List_fromArray(
																	[
																		$author$project$OutMsg$RetrieveCompany(url.Vx.ff)
																	])) : A2(
																$author$project$Utils$Tuple3$mapFirst,
																$author$project$Spa$Page$SessionLoaded,
																A2(
																	$author$project$Utils$Tuple3$fromTuple2,
																	_List_Nil,
																	A5(page.ad0, session, practice, company, shared, url))));
														} else {
															break _v0$6;
														}
													case 2:
														break _v0$5;
													default:
														break _v0$6;
												}
											} else {
												var _v4 = _v0.a;
												var session = _v4.a;
												var _v5 = _v0.b;
												return _Utils_Tuple3(
													$author$project$Spa$Page$SessionLoading(url),
													A2(
														$author$project$Utils$Route$navigate,
														$elm$core$Dict$empty,
														A2($author$project$Permission$homeStateFor, session, shared.adN)),
													_List_Nil);
											}
										case 2:
											break _v0$4;
										default:
											if (_v0.c.$ === 2) {
												break _v0$5;
											} else {
												break _v0$6;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								case 0:
									var _v6 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{af6: true}),
										_List_Nil);
								default:
									if (_v0.b.$ === 2) {
										break _v0$4;
									} else {
										if (_v0.c.$ === 2) {
											break _v0$5;
										} else {
											break _v0$6;
										}
									}
							}
						}
						var _v7 = url;
						var params = _v7.Vx;
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrieveCompany(params.ff)
								]));
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aer: F2(
			function (shared, model) {
				var _v8 = _Utils_Tuple3(shared.ZD, shared.WF, shared.ab9);
				_v8$2:
				while (true) {
					_v8$4:
					while (true) {
						_v8$5:
						while (true) {
							switch (_v8.a.$) {
								case 3:
									switch (_v8.b.$) {
										case 3:
											if (!_v8.b.a.$) {
												switch (_v8.c.$) {
													case 3:
														if (!_v8.c.a.$) {
															var _v9 = _v8.a;
															var session = _v9.a;
															var _v10 = _v8.b;
															var practice = _v10.a.a;
															var _v11 = _v8.c;
															var company = _v11.a.a;
															switch (model.$) {
																case 0:
																	var url = model.a;
																	if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) {
																		return _Utils_Tuple3(
																			$author$project$Spa$Page$SessionLoading(url),
																			A2(
																				$author$project$Utils$Route$navigate,
																				$elm$core$Dict$empty,
																				A2($author$project$Permission$homeStateFor, session, shared.adN)),
																			_List_Nil);
																	} else {
																		var _v13 = A5(page.ad0, session, practice, company, shared, url);
																		var pageModel = _v13.a;
																		var cmd = _v13.b;
																		return _Utils_Tuple3(
																			$author$project$Spa$Page$SessionLoaded(pageModel),
																			cmd,
																			_List_Nil);
																	}
																case 1:
																	var modelWithSession = model.a;
																	return A2(
																		$author$project$Utils$Tuple3$fromTuple2,
																		_List_Nil,
																		A2(
																			$elm$core$Tuple$mapFirst,
																			$author$project$Spa$Page$SessionLoaded,
																			A2(
																				page.aer,
																				shared,
																				_Utils_update(
																					modelWithSession,
																					{D5: shared.D5}))));
																default:
																	return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
															}
														} else {
															break _v8$5;
														}
													case 0:
														break _v8$2;
													default:
														break _v8$5;
												}
											} else {
												var _v14 = _v8.a;
												var session = _v14.a;
												var _v15 = _v8.b;
												return _Utils_Tuple3(
													model,
													A2(
														$author$project$Utils$Route$navigate,
														$elm$core$Dict$empty,
														A2($author$project$Permission$homeStateFor, session, shared.adN)),
													_List_Nil);
											}
										case 2:
											if (!_v8.c.$) {
												break _v8$2;
											} else {
												break _v8$4;
											}
										default:
											if (!_v8.c.$) {
												break _v8$2;
											} else {
												break _v8$5;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								default:
									if (_v8.b.$ === 2) {
										break _v8$4;
									} else {
										break _v8$5;
									}
							}
						}
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				var _v16 = _v8.a;
				var _v17 = _v8.c;
				if (!model.$) {
					var url = model.a;
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrieveCompany(url.Vx.ff)
							]));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		agD: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.agD, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		ahd: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahd(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		aaq: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.aaq, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		ahP: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahP(modelWithSession);
			} else {
				return {e5: $author$project$Components$BlankPage$view, $G: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$GotBrokerDeals = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals = function (model) {
	return A3(
		$author$project$Api$Provider$BrokerDeal$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					ab9: $elm$core$Maybe$Just(model.ff),
					QR: $elm$core$Maybe$Just(true)
				});
		},
		$author$project$Pages$Companies$CompanyId_String$EndedCommissions$GotBrokerDeals);
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var params = _v1.Vx;
		var model = {
			D5: shared.D5,
			J9: $author$project$Api$Data$Loading,
			dt: A3(
				$author$project$Components$BrokerDeal$Table$init,
				session,
				shared.cO,
				{l3: true, qI: false, qJ: true}),
			ff: params.ff,
			WF: practice
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
	});
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					dt: A2($author$project$Components$BrokerDeal$Table$load, shared.cO, model.dt)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$subscriptions = function (_v0) {
	var brokerDealsTable = _v0.dt;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg,
		$author$project$Components$BrokerDeal$Table$subscriptions(brokerDealsTable));
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var brokerDeals = response.a;
				var brokerDealsTable = A2(
					$author$project$Components$BrokerDeal$Table$withBrokerDeals,
					A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals),
					model.dt);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{J9: response, dt: brokerDealsTable}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{J9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.D5, subMsg, model.dt);
			var _v2 = function () {
				var _v3 = brokerDealsTableResult.ac5;
				switch (_v3) {
					case 0:
						return _Utils_Tuple2(model.J9, $elm$core$Platform$Cmd$none);
					case 1:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					case 2:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					case 3:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					case 4:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					case 5:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
					default:
						return _Utils_Tuple2(
							$author$project$Api$Data$Loading,
							$author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
				}
			}();
			var brokerDeals = _v2.a;
			var cmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{J9: brokerDeals, dt: brokerDealsTableResult.y8}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg, brokerDealsTableResult.EC),
							cmd
						])),
				brokerDealsTableResult.as);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$modal(model.dt)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
														{ff: model.ff}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Account & Pricing')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ended Deals')
												]))
										]))),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Ended Deals')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg,
								A2(
									$author$project$Components$BrokerDeal$Table$view,
									_List_fromArray(
										[
											$author$project$Components$BrokerDeal$Table$loading(
											!$author$project$Api$Data$isSuccess(model.J9))
										]),
									model.dt))
							]))
					]))
			]),
		$G: A2($author$project$Formatters$String$sponsorize, model.WF, 'Companies') + ' | Commissions'
	};
};
var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$page = $author$project$Spa$Page$applicationCompany(
	{ad0: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$init, aer: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$load, agD: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$save, ahd: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$update, ahP: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$view});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotCompanyInvoiceSetting = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPaymentSourceSetting = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticeCompanyInvoiceSetting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticePaymentSourceSetting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$Company$One$companyInvoiceSettingId = function (_v0) {
	var record = _v0.b;
	return record.Lv;
};
var $author$project$Api$Provider$Company$One$companyPaymentSourceSettingId = function (_v0) {
	var record = _v0.b;
	return record.Lx;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$ForCompany = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$Record = function (invoiceUpcomingAutoSend) {
	return function (invoiceAutoSend) {
		return function (invoiceAutoSendDay) {
			return function (invoiceAutoSendMonth) {
				return function (invoiceAutoIssue) {
					return function (invoiceAutoIssueDay) {
						return function (invoiceAutoIssueMonth) {
							return function (invoiceDueDay) {
								return function (invoiceDueMonth) {
									return function (invoiceAutoPay) {
										return function (invoiceAutoPayDay) {
											return function (invoiceAutoPayMonth) {
												return function (invoiceGracePeriodDays) {
													return function (chargePhiDetailsEnabled) {
														return function (chargePhiDetailsUpdatedAt) {
															return function (chargePhiDetailsUpdatedBy) {
																return function (chargeRouteToRecurringInvoice) {
																	return function (billingEnabled) {
																		return function (billingStartDate) {
																			return function (hideSponsorInvoices) {
																				return {Eg: billingEnabled, J$: billingStartDate, KR: chargePhiDetailsEnabled, KS: chargePhiDetailsUpdatedAt, KT: chargePhiDetailsUpdatedBy, Ey: chargeRouteToRecurringInvoice, Qp: hideSponsorInvoices, Ri: invoiceAutoIssue, Rj: invoiceAutoIssueDay, FK: invoiceAutoIssueMonth, Rk: invoiceAutoPay, FL: invoiceAutoPayDay, FM: invoiceAutoPayMonth, Rl: invoiceAutoSend, Rm: invoiceAutoSendDay, FN: invoiceAutoSendMonth, Ro: invoiceDueDay, FO: invoiceDueMonth, FP: invoiceGracePeriodDays, FQ: invoiceUpcomingAutoSend};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hide_sponsor_invoices',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'billing_start_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'billing_enabled',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'charge_route_to_recurring_invoice',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge_phi_details_updated_by',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'charge_phi_details_updated_at',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'charge_phi_details_enabled',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_grace_period_days',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'invoice_auto_pay_month',
									$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'invoice_auto_pay_day',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'invoice_auto_pay',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'invoice_due_month',
												$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'invoice_due_day',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'invoice_auto_issue_month',
														$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'invoice_auto_issue_day',
															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'invoice_auto_issue',
																$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'invoice_auto_send_month',
																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'invoice_auto_send_day',
																		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'invoice_auto_send',
																			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'invoice_upcoming_auto_send',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$Record)))))))))))))))))))));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id_)));
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$ForCompany = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$Record = F3(
	function (acceptsAch, acceptsCards, acceptsAmex) {
		return {H_: acceptsAch, H$: acceptsAmex, H0: acceptsCards};
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accepts_amex',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accepts_cards',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'accepts_ach',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$ForCompany$Record))));
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PaymentSourceSetting$ForCompany$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id_)));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$init = F5(
	function (_v0, practice, company, shared, _v1) {
		var practiceId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
		var paymentSettingId = $author$project$Api$Provider$PaymentSourceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$paymentSourceSetting(practice));
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				ab9: company,
				cO: shared.cO,
				PB: $elm$core$Maybe$Nothing,
				adR: $author$project$Api$Provider$Company$One$companyInvoiceSettingId(company),
				FR: $author$project$Shared$isHintAdmin(shared),
				aL: $elm$core$Maybe$Nothing,
				rY: $author$project$Api$Provider$Company$One$companyPaymentSourceSettingId(company),
				V4: $author$project$Api$Data$Loading,
				WF: practice,
				nB: $author$project$Api$Data$Loading,
				sa: $author$project$Api$Data$Loading,
				cq: $author$project$Api$Data$Loading,
				dk: $elm$core$Maybe$Nothing,
				eQ: $elm$core$Maybe$Nothing,
				DL: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, shared.D5, practiceId, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticeCompanyInvoiceSetting),
						A3($author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve, shared.D5, paymentSettingId, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticePaymentSourceSetting),
						A3(
						$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$retrieve,
						shared.D5,
						$author$project$Api$Provider$Company$One$companyInvoiceSettingId(company),
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotCompanyInvoiceSetting),
						A3(
						$author$project$Api$Provider$PaymentSourceSetting$ForCompany$retrieve,
						shared.D5,
						$author$project$Api$Provider$Company$One$companyPaymentSourceSettingId(company),
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPaymentSourceSetting),
						A2($author$project$Api$Provider$Practice$One$featureEnabled, 11, practice) ? A3(
						$author$project$Api$Provider$VirtualBankAccount$list,
						shared.D5,
						$author$project$Api$Provider$Company$One$id(company),
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cO: shared.cO}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Close = 3;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(3);
};
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Close = 1;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(1);
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (virtualBankAccountEnableModal) {
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg,
							$author$project$Components$Company$VirtualBankAccounts$EnableModal$subscriptions(virtualBankAccountEnableModal));
					},
					model.eQ)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (virtualBankAccountAuthorizeModal) {
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg,
							$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$subscriptions(virtualBankAccountAuthorizeModal));
					},
					model.dk))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizedAndConfirmed = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountCreated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$VirtualBankAccount$authorizeAndCreate = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['authorize_and_create']),
					$author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId))));
	});
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{yk: false});
};
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{yk: false});
};
var $author$project$Api$Provider$VirtualBankAccount$create = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId)));
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingEnabled = function (_v0) {
	var forCompany = _v0;
	return forCompany.Eg;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate = function (_v0) {
	var forCompany = _v0;
	return forCompany.J$;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsEnabled = function (_v0) {
	var forCompany = _v0;
	return forCompany.KR;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargeRouteToRecurringInvoice = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ey;
};
var $author$project$Utils$Overridable$Defaulted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Utils$Overridable$Overriden = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Utils$Overridable$fromMaybe = F2(
	function (maybe, default_) {
		if (!maybe.$) {
			var override_ = maybe.a;
			return A2($author$project$Utils$Overridable$Overriden, override_, default_);
		} else {
			return $author$project$Utils$Overridable$Defaulted(default_);
		}
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$hideSponsorInvoices = function (_v0) {
	var forCompany = _v0;
	return forCompany.Qp;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssue = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ri;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueDay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Rj;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueMonth = function (_v0) {
	var forCompany = _v0;
	return forCompany.FK;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Rk;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayDay = function (_v0) {
	var forCompany = _v0;
	return forCompany.FL;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayMonth = function (_v0) {
	var forCompany = _v0;
	return forCompany.FM;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSend = function (_v0) {
	var forCompany = _v0;
	return forCompany.Rl;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendDay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Rm;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendMonth = function (_v0) {
	var forCompany = _v0;
	return forCompany.FN;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueDay = function (_v0) {
	var forCompany = _v0;
	return forCompany.Ro;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueMonth = function (_v0) {
	var forCompany = _v0;
	return forCompany.FO;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceGracePeriodDays = function (_v0) {
	var forCompany = _v0;
	return forCompany.FP;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceUpcomingAutoSend = function (_v0) {
	var forCompany = _v0;
	return forCompany.FQ;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm = F3(
	function (companySettings, practiceSettings, currentDate) {
		var billingStartDate = function () {
			var _v1 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate(companySettings);
			if (!_v1.$) {
				var date = _v1.a;
				return ((A2($justinmimbs$date$Date$compare, currentDate, date) === 2) || (A2($justinmimbs$date$Date$compare, currentDate, date) === 1)) ? $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, 1, currentDate)) : $elm$core$Maybe$Just(date);
			} else {
				return $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, 1, currentDate));
			}
		}();
		var billingEnabledDateToggle = function () {
			var _v0 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate(companySettings);
			if (!_v0.$) {
				var date = _v0.a;
				return $elm$core$Maybe$Just(
					!((A2($justinmimbs$date$Date$compare, currentDate, date) === 2) || (A2($justinmimbs$date$Date$compare, currentDate, date) === 1)));
			} else {
				return $elm$core$Maybe$Just(false);
			}
		}();
		return _Utils_Tuple2(
			{
				Eg: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingEnabled(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings)),
				e4: A2(
					$author$project$Utils$Overridable$fromMaybe,
					billingEnabledDateToggle,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings)),
				J$: billingStartDate,
				KR: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsEnabled(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled(practiceSettings)),
				Ey: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargeRouteToRecurringInvoice(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice(practiceSettings)),
				Qp: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$hideSponsorInvoices(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices(practiceSettings)),
				Ri: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssue(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue(practiceSettings)),
				Rj: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueDay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay(practiceSettings)),
				FK: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueMonth(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth(practiceSettings)),
				Rk: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay(practiceSettings)),
				FL: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayDay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay(practiceSettings)),
				FM: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayMonth(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth(practiceSettings)),
				Rl: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSend(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend(practiceSettings)),
				Rm: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendDay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay(practiceSettings)),
				FN: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendMonth(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth(practiceSettings)),
				Ro: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueDay(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay(practiceSettings)),
				FO: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueMonth(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth(practiceSettings)),
				FP: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceGracePeriodDays(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays(practiceSettings)),
				FQ: A2(
					$author$project$Utils$Overridable$fromMaybe,
					$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceUpcomingAutoSend(companySettings),
					$author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend(practiceSettings))
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPayIssueDateValidation = 4;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter = F2(
	function (_v0, _v1) {
		var firstDay = _v0.a;
		var firstMonth = _v0.b;
		var secondDay = _v1.a;
		var secondMonth = _v1.b;
		var secondMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(secondMonth);
		var firstMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(firstMonth);
		return _Utils_eq(firstMonthInt, secondMonthInt) ? (_Utils_cmp(firstDay, secondDay) < 1) : (_Utils_cmp(firstMonthInt, secondMonthInt) < 0);
	});
var $author$project$Utils$Overridable$value = function (overridable) {
	if (!overridable.$) {
		var override_ = overridable.a;
		return override_;
	} else {
		var default_ = overridable.a;
		return default_;
	}
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate = function (form) {
	return ($author$project$Utils$Overridable$value(form.Rk) && $author$project$Utils$Overridable$value(form.Ri)) ? A2(
		$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Rj),
			$author$project$Utils$Overridable$value(form.FK)),
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.FL),
			$author$project$Utils$Overridable$value(form.FM))) : true;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoIssueDateIsBeforeOrOnAutoPayDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate,
	_Utils_Tuple2(4, 'The autopay date must be on or after the scheduled issue date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$IssueDateValidation = 5;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate,
	_Utils_Tuple2(5, 'The scheduled issue date must be before or on the autopay date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPayDateValidation = 3;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate = function (form) {
	return ($author$project$Utils$Overridable$value(form.Rl) && $author$project$Utils$Overridable$value(form.Rk)) ? A2(
		$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Rm),
			$author$project$Utils$Overridable$value(form.FN)),
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.FL),
			$author$project$Utils$Overridable$value(form.FM))) : true;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(3, 'The autopay date must be on or after the Invoice Created notification date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate = function (form) {
	return $author$project$Utils$Overridable$value(form.Rk) ? A2(
		$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.FL),
			$author$project$Utils$Overridable$value(form.FM)),
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Ro),
			$author$project$Utils$Overridable$value(form.FO))) : true;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayIsOnOrBeforeDueDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate,
	_Utils_Tuple2(3, 'The autopay date must be before the invoice is due'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoSendDateValidation = 1;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsBeforeOrOnPayDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(1, 'The Invoice Created notification date must be before or on the autopay date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate = function (form) {
	return ($author$project$Utils$Overridable$value(form.Rk) || (!$author$project$Utils$Overridable$value(form.Rl))) ? true : A2(
		$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter,
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Rm),
			$author$project$Utils$Overridable$value(form.FN)),
		_Utils_Tuple2(
			$author$project$Utils$Overridable$value(form.Ro),
			$author$project$Utils$Overridable$value(form.FO)));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsOnOrBeforeDueDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(1, 'The Invoice Created notification date must be before the invoice is due'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$DueDateValidation = 6;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate,
	_Utils_Tuple2(6, 'The invoice must be due on or after the autopay date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate,
	_Utils_Tuple2(6, 'The invoice must be due on or after the Invoice Created notification date'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$EnableBillingDateValidation = 2;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$enableBillingIsInFutureValidator = function (currentDate) {
	return A2(
		$rtfeldman$elm_validate$Validate$ifFalse,
		function (_v0) {
			var billingStartDate = _v0.J$;
			var billingEnabledDateToggle = _v0.e4;
			if (!$author$project$Utils$Overridable$value(billingEnabledDateToggle)) {
				return true;
			} else {
				var billingDate = function () {
					if (!billingStartDate.$) {
						var date = billingStartDate.a;
						return date;
					} else {
						return currentDate;
					}
				}();
				return !((A2($justinmimbs$date$Date$compare, currentDate, billingDate) === 2) || (A2($justinmimbs$date$Date$compare, currentDate, billingDate) === 1));
			}
		},
		_Utils_Tuple2(2, 'The date must be in the future'));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function (_v0) {
		var invoiceUpcomingAutoSend = _v0.FQ;
		var invoiceAutoSend = _v0.Rl;
		return $author$project$Utils$Overridable$value(invoiceUpcomingAutoSend) ? $author$project$Utils$Overridable$value(invoiceAutoSend) : true;
	},
	_Utils_Tuple2(0, 'This notification can only be enabled if the Invoice Created notification is also enabled'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceUpcomingIsEnabledIfInvoiceCreatedIsEnabledValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	function (_v0) {
		var invoiceUpcomingAutoSend = _v0.FQ;
		var invoiceAutoSend = _v0.Rl;
		return $author$project$Utils$Overridable$value(invoiceUpcomingAutoSend) ? $author$project$Utils$Overridable$value(invoiceAutoSend) : true;
	},
	_Utils_Tuple2(1, 'This notification cannot be disabled if the Invoice Upcoming notification is enabled'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceUpcomingIsEnabledIfInvoiceCreatedIsEnabledValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoIssueDateIsBeforeOrOnAutoPayDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsBeforeOrOnPayDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayIsOnOrBeforeDueDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsOnOrBeforeDueDateValidator,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$enableBillingIsInFutureValidator(currentDate)
			]));
};
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$init = function (companyName) {
	return {Lw: companyName, q4: false, yk: true, jY: $author$project$Api$Data$NotAsked};
};
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$init = function (companyName) {
	return {Lw: companyName, yk: true, jY: $author$project$Api$Data$NotAsked};
};
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAch = function (_v0) {
	var forCompany = _v0;
	return forCompany.H_;
};
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAmex = function (_v0) {
	var forCompany = _v0;
	return forCompany.H$;
};
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsCards = function (_v0) {
	var forCompany = _v0;
	return forCompany.H0;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields = F2(
	function (practicePaymentSourceSetting, paymentSourceSetting) {
		return {
			H_: A2(
				$author$project$Utils$Overridable$fromMaybe,
				$author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAch(paymentSourceSetting),
				$author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch(practicePaymentSourceSetting)),
			H$: A2(
				$author$project$Utils$Overridable$fromMaybe,
				$author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAmex(paymentSourceSetting),
				$author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex(practicePaymentSourceSetting)),
			H0: A2(
				$author$project$Utils$Overridable$fromMaybe,
				$author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsCards(paymentSourceSetting),
				$author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards(practicePaymentSourceSetting))
		};
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var overridableBool = field.a;
				return _Utils_update(
					fields,
					{H_: overridableBool});
			case 1:
				var overridableBool = field.a;
				return _Utils_update(
					fields,
					{H$: overridableBool, H0: overridableBool});
			default:
				var overridableBool = field.a;
				return _Utils_update(
					fields,
					{H$: overridableBool});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmexValidation = 0;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$sponsorAcceptsAllCards = function (form) {
	return !((!$author$project$Utils$Overridable$value(form.H0)) && $author$project$Utils$Overridable$value(form.H$));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$acceptsAmexValidator = A2(
	$rtfeldman$elm_validate$Validate$ifFalse,
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$sponsorAcceptsAllCards,
	_Utils_Tuple2(0, 'If the sponsor does not accept cards they cannot accept Amex'));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$acceptsAmexValidator]));
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingStartDate = function (_v0) {
	var forPractice = _v0;
	return forPractice.J$;
};
var $author$project$Utils$Overridable$toMaybe = function (overridable) {
	if (!overridable.$) {
		var override_ = overridable.a;
		return $elm$core$Maybe$Just(override_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable = F2(
	function (encoder, maybeA) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, encoder, maybeA));
	});
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company_invoice_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'invoice_upcoming_auto_send',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.FQ)),
								_Utils_Tuple2(
								'invoice_auto_send',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Rl)),
								_Utils_Tuple2(
								'invoice_auto_send_day',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.Rm)),
								_Utils_Tuple2(
								'invoice_auto_send_month',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.FN)),
								_Utils_Tuple2(
								'invoice_auto_issue',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Ri)),
								_Utils_Tuple2(
								'invoice_auto_issue_day',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.Rj)),
								_Utils_Tuple2(
								'invoice_auto_issue_month',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.FK)),
								_Utils_Tuple2(
								'invoice_due_day',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.Ro)),
								_Utils_Tuple2(
								'invoice_due_month',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.FO)),
								_Utils_Tuple2(
								'invoice_auto_pay',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Rk)),
								_Utils_Tuple2(
								'invoice_auto_pay_day',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.FL)),
								_Utils_Tuple2(
								'invoice_auto_pay_month',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.FM)),
								_Utils_Tuple2(
								'invoice_grace_period_days',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.FP)),
								_Utils_Tuple2(
								'charge_phi_details_enabled',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.KR)),
								_Utils_Tuple2(
								'charge_route_to_recurring_invoice',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Ey)),
								_Utils_Tuple2(
								'billing_enabled',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Eg)),
								_Utils_Tuple2(
								'billing_start_date',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Utils$Date$encode, fields.J$)),
								_Utils_Tuple2(
								'hide_sponsor_invoices',
								A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Qp))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id))));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings = F5(
	function (apiClient, id, formFields, practiceSettings, currentDate) {
		var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var billingStartDate = function () {
			var _v0 = $author$project$Utils$Overridable$toMaybe(validated.Eg);
			if (!_v0.$) {
				var billingEnabled = _v0.a;
				return (!billingEnabled) ? $elm$core$Maybe$Nothing : ((!$author$project$Utils$Overridable$value(validated.e4)) ? $elm$core$Maybe$Just(currentDate) : validated.J$);
			} else {
				if (practiceSettings.$ === 3) {
					var settings = practiceSettings.a;
					return $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingStartDate(settings);
				} else {
					return validated.J$;
				}
			}
		}();
		var flattenedForm = {
			Eg: $author$project$Utils$Overridable$toMaybe(validated.Eg),
			J$: billingStartDate,
			KR: $author$project$Utils$Overridable$toMaybe(validated.KR),
			Ey: $author$project$Utils$Overridable$toMaybe(validated.Ey),
			Qp: $author$project$Utils$Overridable$toMaybe(validated.Qp),
			Ri: $author$project$Utils$Overridable$toMaybe(validated.Ri),
			Rj: $author$project$Utils$Overridable$toMaybe(validated.Rj),
			FK: $author$project$Utils$Overridable$toMaybe(validated.FK),
			Rk: $author$project$Utils$Overridable$toMaybe(validated.Rk),
			FL: $author$project$Utils$Overridable$toMaybe(validated.FL),
			FM: $author$project$Utils$Overridable$toMaybe(validated.FM),
			Rl: $author$project$Utils$Overridable$toMaybe(validated.Rl),
			Rm: $author$project$Utils$Overridable$toMaybe(validated.Rm),
			FN: $author$project$Utils$Overridable$toMaybe(validated.FN),
			Ro: $author$project$Utils$Overridable$toMaybe(validated.Ro),
			FO: $author$project$Utils$Overridable$toMaybe(validated.FO),
			FP: $author$project$Utils$Overridable$toMaybe(validated.FP),
			FQ: $author$project$Utils$Overridable$toMaybe(validated.FQ)
		};
		return A4($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$update, apiClient, id, flattenedForm, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsUpdated);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentSourceSettingUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable = F2(
	function (encoder, maybeA) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Encode$null,
			A2($elm$core$Maybe$map, encoder, maybeA));
	});
var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$update = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'payment_source_setting',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'accepts_ach',
								A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.H_)),
								_Utils_Tuple2(
								'accepts_cards',
								A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.H0)),
								_Utils_Tuple2(
								'accepts_amex',
								A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.H$))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id))));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting = F3(
	function (apiClient, id, formFields) {
		var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var flattenedForm = {
			H_: $author$project$Utils$Overridable$toMaybe(validated.H_),
			H$: $author$project$Utils$Overridable$toMaybe(validated.H$),
			H0: $author$project$Utils$Overridable$toMaybe(validated.H0)
		};
		return A4($author$project$Api$Provider$PaymentSourceSetting$ForCompany$update, apiClient, id, flattenedForm, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentSourceSettingUpdated);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting = function (model) {
	var _v0 = _Utils_Tuple2(model.PB, model.aL);
	if (!_v0.a.$) {
		if (_v0.b.$ === 1) {
			var form = _v0.a.a;
			var _v1 = _v0.b;
			var _v2 = A2(
				$author$project$Utils$Form$validate,
				$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.cO),
				form);
			if (!_v2.$) {
				var _v3 = _v2.a;
				var newForm = _v3.a;
				var validFormFields = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: $elm$core$Maybe$Just(newForm),
							cq: $author$project$Api$Data$Loading
						}),
					A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.D5, model.adR, validFormFields, model.sa, model.cO),
					_List_Nil);
			} else {
				var newForm = _v2.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: $elm$core$Maybe$Just(newForm)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		} else {
			var form = _v0.a.a;
			var paymentForm = _v0.b.a;
			var _v4 = _Utils_Tuple2(
				A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.cO),
					form),
				A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator, paymentForm));
			if (!_v4.a.$) {
				if (!_v4.b.$) {
					var _v5 = _v4.a.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					var _v6 = _v4.b.a;
					var newPaymentForm = _v6.a;
					var validPaymentFormFields = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								aL: $elm$core$Maybe$Just(newPaymentForm),
								V4: $author$project$Api$Data$Loading,
								cq: $author$project$Api$Data$Loading
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.D5, model.adR, validFormFields, model.sa, model.cO),
									A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.D5, model.rY, validPaymentFormFields)
								])),
						_List_Nil);
				} else {
					var _v7 = _v4.a.a;
					var newForm = _v7.a;
					var validFormFields = _v7.b;
					var newPaymentForm = _v4.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								aL: $elm$core$Maybe$Just(newPaymentForm),
								cq: $author$project$Api$Data$Loading
							}),
						A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.D5, model.adR, validFormFields, model.sa, model.cO),
						_List_Nil);
				}
			} else {
				if (!_v4.b.$) {
					var newForm = _v4.a.a;
					var _v8 = _v4.b.a;
					var newPaymentForm = _v8.a;
					var validPaymentFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								aL: $elm$core$Maybe$Just(newPaymentForm),
								V4: $author$project$Api$Data$Loading
							}),
						A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.D5, model.rY, validPaymentFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a.a;
					var newPaymentForm = _v4.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								aL: $elm$core$Maybe$Just(newPaymentForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			}
		}
	} else {
		if (!_v0.b.$) {
			var _v9 = _v0.a;
			var paymentForm = _v0.b.a;
			var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator, paymentForm);
			if (!_v10.$) {
				var _v11 = _v10.a;
				var newForm = _v11.a;
				var validFormFields = _v11.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(newForm),
							V4: $author$project$Api$Data$Loading
						}),
					A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.D5, model.rY, validFormFields),
					_List_Nil);
			} else {
				var newForm = _v10.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aL: $elm$core$Maybe$Just(newForm)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		} else {
			var _v12 = _v0.a;
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	}
};
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Closed = 2;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Confirm = 1;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$None = 0;
var $author$project$Ports$NewTab$open = _Platform_outgoingPort('open', $elm$json$Json$Encode$string);
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$StripeTimerDone = 1;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$stripeButtonClicked = A2(
	$elm$core$Task$perform,
	function (_v0) {
		return 1;
	},
	$elm$core$Process$sleep(3000));
var $author$project$Utils$HintUrls$stripePaymentMethodsUrl = 'https://dashboard.stripe.com/settings/payment_methods';
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg) {
			case 0:
				var cmd = model.q4 ? $author$project$Ports$NewTab$open($author$project$Utils$HintUrls$stripePaymentMethodsUrl) : $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							$author$project$Ports$NewTab$open($author$project$Utils$HintUrls$stripePaymentMethodsUrl),
							$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$stripeButtonClicked
						]));
				return {EC: cmd, ac5: 0, y8: model, as: _List_Nil};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{q4: true}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(model),
					as: _List_Nil
				};
			default:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 2,
					y8: $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(model),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Closed = 1;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Confirmed = 0;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg) {
			return {
				EC: $elm$core$Platform$Cmd$none,
				ac5: 0,
				y8: $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(model),
				as: _List_Nil
			};
		} else {
			return {
				EC: $elm$core$Platform$Cmd$none,
				ac5: 1,
				y8: $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(model),
				as: _List_Nil
			};
		}
	});
var $author$project$Utils$Overridable$default = function (overridable) {
	if (!overridable.$) {
		var default_ = overridable.b;
		return default_;
	} else {
		var default_ = overridable.a;
		return default_;
	}
};
var $author$project$Utils$Overridable$makeDefault = function (overridable) {
	if (!overridable.$) {
		var default_ = overridable.b;
		return $author$project$Utils$Overridable$Defaulted(default_);
	} else {
		return overridable;
	}
};
var $author$project$Utils$Overridable$overriden = F2(
	function (override_, default_) {
		return A2($author$project$Utils$Overridable$Overriden, override_, default_);
	});
var $author$project$Utils$Overridable$switch = function (overridable) {
	if (!overridable.$) {
		var default_ = overridable.b;
		return $author$project$Utils$Overridable$Defaulted(default_);
	} else {
		var default_ = overridable.a;
		return A2($author$project$Utils$Overridable$Overriden, default_, default_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updateFormField = F2(
	function (formField, form) {
		switch (formField.$) {
			case 0:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{FQ: overridableBool});
			case 15:
				var settingGroup = formField.a;
				var isDefault = formField.b;
				switch (settingGroup) {
					case 0:
						return isDefault ? _Utils_update(
							form,
							{
								Rl: $author$project$Utils$Overridable$makeDefault(form.Rl),
								Rm: $author$project$Utils$Overridable$makeDefault(form.Rm),
								FN: $author$project$Utils$Overridable$makeDefault(form.FN)
							}) : _Utils_update(
							form,
							{
								Rl: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Rl),
									$author$project$Utils$Overridable$default(form.Rl)),
								Rm: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Rm),
									$author$project$Utils$Overridable$default(form.Rm)),
								FN: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.FN),
									$author$project$Utils$Overridable$default(form.FN))
							});
					case 1:
						return isDefault ? _Utils_update(
							form,
							{
								Ri: $author$project$Utils$Overridable$makeDefault(form.Ri),
								Rj: $author$project$Utils$Overridable$makeDefault(form.Rj),
								FK: $author$project$Utils$Overridable$makeDefault(form.FK)
							}) : _Utils_update(
							form,
							{
								Ri: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Ri),
									$author$project$Utils$Overridable$default(form.Ri)),
								Rj: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Rj),
									$author$project$Utils$Overridable$default(form.Rj)),
								FK: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.FK),
									$author$project$Utils$Overridable$default(form.FK))
							});
					case 5:
						return isDefault ? _Utils_update(
							form,
							{
								Eg: $author$project$Utils$Overridable$makeDefault(form.Eg)
							}) : _Utils_update(
							form,
							{
								Eg: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Eg),
									$author$project$Utils$Overridable$default(form.Eg))
							});
					case 2:
						return isDefault ? _Utils_update(
							form,
							{
								Rk: $author$project$Utils$Overridable$makeDefault(form.Rk),
								FL: $author$project$Utils$Overridable$makeDefault(form.FL),
								FM: $author$project$Utils$Overridable$makeDefault(form.FM)
							}) : _Utils_update(
							form,
							{
								Rk: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Rk),
									$author$project$Utils$Overridable$default(form.Rk)),
								FL: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.FL),
									$author$project$Utils$Overridable$default(form.FL)),
								FM: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.FM),
									$author$project$Utils$Overridable$default(form.FM))
							});
					case 3:
						return isDefault ? _Utils_update(
							form,
							{
								Ro: $author$project$Utils$Overridable$makeDefault(form.Ro),
								FO: $author$project$Utils$Overridable$makeDefault(form.FO)
							}) : _Utils_update(
							form,
							{
								Ro: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.Ro),
									$author$project$Utils$Overridable$default(form.Ro)),
								FO: A2(
									$author$project$Utils$Overridable$overriden,
									$author$project$Utils$Overridable$default(form.FO),
									$author$project$Utils$Overridable$default(form.FO))
							});
					default:
						return _Utils_update(
							form,
							{
								FP: $author$project$Utils$Overridable$switch(form.FP)
							});
				}
			case 1:
				var overridableBool = formField.a;
				return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(
					form,
					{
						Rl: overridableBool,
						Rm: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.Rm),
							$author$project$Utils$Overridable$default(form.Rm)),
						FN: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.FN),
							$author$project$Utils$Overridable$default(form.FN))
					}) : _Utils_update(
					form,
					{
						Rl: overridableBool,
						Rm: $author$project$Utils$Overridable$makeDefault(form.Rm),
						FN: $author$project$Utils$Overridable$makeDefault(form.FN)
					});
			case 2:
				var string = formField.a;
				var autosendDay = $elm$core$String$toInt(string);
				if (!autosendDay.$) {
					var day = autosendDay.a;
					return _Utils_update(
						form,
						{
							Rm: A2(
								$author$project$Utils$Overridable$overriden,
								day,
								$author$project$Utils$Overridable$default(form.Rm))
						});
				} else {
					return form;
				}
			case 3:
				var string = formField.a;
				var maybeAutoSendMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
				if (!maybeAutoSendMonth.$) {
					var autosendMonth = maybeAutoSendMonth.a;
					return _Utils_update(
						form,
						{
							FN: A2(
								$author$project$Utils$Overridable$overriden,
								autosendMonth,
								$author$project$Utils$Overridable$default(form.FN))
						});
				} else {
					return form;
				}
			case 4:
				var overridableBool = formField.a;
				return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(
					form,
					{
						Ri: overridableBool,
						Rj: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.Rj),
							$author$project$Utils$Overridable$default(form.Rj)),
						FK: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.FK),
							$author$project$Utils$Overridable$default(form.FK))
					}) : _Utils_update(
					form,
					{
						Ri: overridableBool,
						Rj: $author$project$Utils$Overridable$makeDefault(form.Rj),
						FK: $author$project$Utils$Overridable$makeDefault(form.FK)
					});
			case 5:
				var string = formField.a;
				var autoIssueDay = $elm$core$String$toInt(string);
				if (!autoIssueDay.$) {
					var day = autoIssueDay.a;
					return _Utils_update(
						form,
						{
							Rj: A2(
								$author$project$Utils$Overridable$overriden,
								day,
								$author$project$Utils$Overridable$default(form.Rj))
						});
				} else {
					return form;
				}
			case 6:
				var string = formField.a;
				var maybeAutoIssueMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
				if (!maybeAutoIssueMonth.$) {
					var autoIssueMonth = maybeAutoIssueMonth.a;
					return _Utils_update(
						form,
						{
							FK: A2(
								$author$project$Utils$Overridable$overriden,
								autoIssueMonth,
								$author$project$Utils$Overridable$default(form.FK))
						});
				} else {
					return form;
				}
			case 7:
				var overridableBool = formField.a;
				return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(
					form,
					{
						Rk: overridableBool,
						FL: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.FL),
							$author$project$Utils$Overridable$default(form.FL)),
						FM: A2(
							$author$project$Utils$Overridable$overriden,
							$author$project$Utils$Overridable$value(form.FM),
							$author$project$Utils$Overridable$default(form.FM))
					}) : _Utils_update(
					form,
					{
						Rk: overridableBool,
						FL: $author$project$Utils$Overridable$makeDefault(form.FL),
						FM: $author$project$Utils$Overridable$makeDefault(form.FM)
					});
			case 8:
				var string = formField.a;
				var autoPayDay = $elm$core$String$toInt(string);
				if (!autoPayDay.$) {
					var day = autoPayDay.a;
					return _Utils_update(
						form,
						{
							FL: A2(
								$author$project$Utils$Overridable$overriden,
								day,
								$author$project$Utils$Overridable$default(form.FL))
						});
				} else {
					return form;
				}
			case 9:
				var string = formField.a;
				var maybeAutoPayMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
				if (!maybeAutoPayMonth.$) {
					var autoPayMonth = maybeAutoPayMonth.a;
					return _Utils_update(
						form,
						{
							FM: A2(
								$author$project$Utils$Overridable$overriden,
								autoPayMonth,
								$author$project$Utils$Overridable$default(form.FM))
						});
				} else {
					return form;
				}
			case 10:
				var string = formField.a;
				var dueDay = $elm$core$String$toInt(string);
				if (!dueDay.$) {
					var day = dueDay.a;
					return _Utils_update(
						form,
						{
							Ro: A2(
								$author$project$Utils$Overridable$overriden,
								day,
								$author$project$Utils$Overridable$default(form.Ro))
						});
				} else {
					return form;
				}
			case 11:
				var string = formField.a;
				var maybeDueMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
				if (!maybeDueMonth.$) {
					var month = maybeDueMonth.a;
					return _Utils_update(
						form,
						{
							FO: A2(
								$author$project$Utils$Overridable$overriden,
								month,
								$author$project$Utils$Overridable$default(form.FO))
						});
				} else {
					return form;
				}
			case 16:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{e4: overridableBool});
			case 17:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{Eg: overridableBool});
			case 18:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{Qp: overridableBool});
			case 19:
				var selectedDateOption = formField.a;
				return _Utils_update(
					form,
					{
						J$: $elm$core$Result$toMaybe(
							$justinmimbs$date$Date$fromIsoString(selectedDateOption))
					});
			case 12:
				var string = formField.a;
				var days = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(string));
				return _Utils_update(
					form,
					{
						FP: A2(
							$author$project$Utils$Overridable$overriden,
							days,
							$author$project$Utils$Overridable$default(form.FP))
					});
			case 13:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{KR: overridableBool});
			default:
				var overridableBool = formField.a;
				return _Utils_update(
					form,
					{Ey: overridableBool});
		}
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				var _v1 = _Utils_Tuple2(response, model.sa);
				if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
					var _v2 = _v1.a;
					var companySettings = _v2.a;
					var _v3 = _v1.b;
					var practiceSettings = _v3.a;
					var _v4 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companySettings, practiceSettings, model.cO);
					var fields = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$fromValidateResult(
										A2(
											$author$project$Utils$Form$validate,
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.cO),
											$author$project$Utils$Form$init(fields)))),
								cq: response
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cq: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				var _v5 = _Utils_Tuple2(response, model.nB);
				if ((_v5.a.$ === 3) && (_v5.b.$ === 3)) {
					var _v6 = _v5.a;
					var paymentSourceSetting = _v6.a;
					var _v7 = _v5.b;
					var practicePaymentSourceSetting = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aL: $elm$core$Maybe$Just(
									$author$project$Utils$Form$fromValidateResult(
										A2(
											$author$project$Utils$Form$validate,
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator,
											$author$project$Utils$Form$init(
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))))),
								V4: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var response = msg.a;
				var _v8 = _Utils_Tuple2(response, model.V4);
				if ((_v8.a.$ === 3) && (_v8.b.$ === 3)) {
					var _v9 = _v8.a;
					var practicePaymentSourceSetting = _v9.a;
					var _v10 = _v8.b;
					var paymentSourceSetting = _v10.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aL: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))),
								nB: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				var _v11 = _Utils_Tuple2(response, model.cq);
				if ((_v11.a.$ === 3) && (_v11.b.$ === 3)) {
					var _v12 = _v11.a;
					var practiceSettings = _v12.a;
					var _v13 = _v11.b;
					var companySettings = _v13.a;
					var _v14 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companySettings, practiceSettings, model.cO);
					var fields = _v14.a;
					var cmd = _v14.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(fields)),
								sa: response
							}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sa: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var formField = msg.a;
				var _v15 = model.PB;
				if (!_v15.$) {
					var form = _v15.a;
					return function (newForm) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}(
						$author$project$Utils$Form$fromValidateResult(
							A2(
								$author$project$Utils$Form$validate,
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.cO),
								A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updateFormField, formField, form))));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var field = msg.a;
				var _v16 = model.aL;
				if (!_v16.$) {
					var form = _v16.a;
					return function (newForm) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aL: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}(
						A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsUpdate, field, form));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting(model);
			case 7:
				var response = msg.a;
				var _v17 = _Utils_Tuple2(response, model.sa);
				if ((_v17.a.$ === 3) && (_v17.b.$ === 3)) {
					var _v18 = _v17.a;
					var companyInvoiceSettings = _v18.a;
					var _v19 = _v17.b;
					var practiceSettings = _v19.a;
					var _v20 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companyInvoiceSettings, practiceSettings, model.cO);
					var fields = _v20.a;
					var cmd = _v20.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(fields)),
								cq: response
							}),
						cmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice settings updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cq: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var response = msg.a;
				var _v21 = _Utils_Tuple2(response, model.nB);
				if ((_v21.a.$ === 3) && (_v21.b.$ === 3)) {
					var _v22 = _v21.a;
					var paymentSourceSetting = _v22.a;
					var _v23 = _v21.b;
					var practicePaymentSourceSetting = _v23.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aL: $elm$core$Maybe$Just(
									$author$project$Utils$Form$init(
										A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))),
								V4: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Payment options settings updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{V4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var acceptsSourceBankTransfers = msg.a;
				return acceptsSourceBankTransfers ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eQ: $elm$core$Maybe$Just(
								$author$project$Components$Company$VirtualBankAccounts$EnableModal$init(
									$author$project$Api$Provider$Company$One$name(model.ab9)))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dk: $elm$core$Maybe$Just(
								$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$init(
									$author$project$Api$Provider$Company$One$name(model.ab9)))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var subMsg = msg.a;
				var _v24 = model.eQ;
				if (!_v24.$) {
					var virtualBankAccountEnableModal = _v24.a;
					var modalResult = A2($author$project$Components$Company$VirtualBankAccounts$EnableModal$update, subMsg, virtualBankAccountEnableModal);
					var _v25 = modalResult.ac5;
					if (_v25 === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eQ: $elm$core$Maybe$Just(
										$author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(virtualBankAccountEnableModal))
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg, modalResult.EC),
							modalResult.as);
					} else {
						var createCmd = A3(
							$author$project$Api$Provider$VirtualBankAccount$create,
							model.D5,
							$author$project$Api$Provider$Company$One$id(model.ab9),
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountCreated);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eQ: $elm$core$Maybe$Just(modalResult.y8)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										createCmd,
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg, modalResult.EC)
									])),
							modalResult.as);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eQ: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3(
							$author$project$Api$Provider$VirtualBankAccount$list,
							model.D5,
							$author$project$Api$Provider$Company$One$id(model.ab9),
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Bank Transfer account enabled')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					var virtualBankAccounts = response.a;
					return $elm$core$List$isEmpty(virtualBankAccounts) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{DL: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								DL: $elm$core$Maybe$Just(virtualBankAccounts)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{DL: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var subMsg = msg.a;
				var _v28 = model.dk;
				if (!_v28.$) {
					var virtualBankAccountAuthorizeModal = _v28.a;
					var modalResult = A2($author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$update, subMsg, virtualBankAccountAuthorizeModal);
					var _v29 = modalResult.ac5;
					switch (_v29) {
						case 0:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										dk: $elm$core$Maybe$Just(modalResult.y8)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.EC),
								modalResult.as);
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										dk: $elm$core$Maybe$Just(
											$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(virtualBankAccountAuthorizeModal))
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.EC),
								modalResult.as);
						default:
							var createCmd = A3(
								$author$project$Api$Provider$VirtualBankAccount$authorizeAndCreate,
								model.D5,
								$author$project$Api$Provider$Company$One$id(model.ab9),
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizedAndConfirmed);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										dk: $elm$core$Maybe$Just(
											$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(virtualBankAccountAuthorizeModal))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.EC),
											createCmd
										])),
								modalResult.as);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dk: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3(
							$author$project$Api$Provider$VirtualBankAccount$list,
							model.D5,
							$author$project$Api$Provider$Company$One$id(model.ab9),
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'Authorization confirmed and transfer details created for ' + $author$project$Api$Provider$Company$One$name(model.ab9))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsSubmitted = {$: 6};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedAt = function (_v0) {
	var forCompany = _v0;
	return forCompany.KS;
};
var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedBy = function (_v0) {
	var forCompany = _v0;
	return forCompany.KT;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting = F2(
	function (func, maybeForm) {
		if (!maybeForm.$) {
			var form = maybeForm.a;
			return func(form);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$ConfirmAndEnable = 2;
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$GoToStripeClicked = 0;
var $author$project$Utils$HintUrls$stripeBankTransfersUrl = 'https://docs.stripe.com/payments/bank-transfers';
var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$modal = function (_v0) {
	var model = _v0;
	return model.yk ? A3(
		$author$project$Ui$Modal$view,
		3,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Stripe Authorization Needed')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit(2),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$fontWeight(1)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('To activate bank transfers for employers, you will first need to turn on bank transfer payments in Stripe. Click “Go to Stripe” to complete the setup.'),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A3(
										$author$project$Ui$Link$externalHref,
										$author$project$Utils$HintUrls$stripeBankTransfersUrl,
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('Learn More')
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$justifyCenter)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								model.q4 ? A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter),
										$author$project$Ui$Typography$margin(12)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Go to stripe'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(0)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Go to Stripe')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Confirm and enable bank transfers'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick(2),
												$author$project$Ui$Button$submit
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Confirm and Enable')
											]))
									])) : A3(
								$author$project$Ui$Button$view,
								{abp: 'Go to stripe'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick(0)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Go to Stripe')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Confirm = 0;
var $author$project$Components$Company$VirtualBankAccounts$EnableModal$modal = function (_v0) {
	var model = _v0;
	return model.yk ? A3(
		$author$project$Ui$Modal$view,
		1,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Enable Bank Transfers for ' + model.Lw)
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit(0),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$helpBlock,
										$author$project$Ui$Typography$fontWeight(1)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Clicking Confirm will allow the employer to transfer funds directly to that account to pay invoices. This setting will apply to all future invoices for this employer.')
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(1)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Confirm'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$onClick(0),
										$author$project$Ui$Button$submit
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Confirm')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Utils$Overridable$isOverriden = function (overridable) {
	if (!overridable.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Utils$Overridable$override = F2(
	function (override_, overridable) {
		return A2(
			$author$project$Utils$Overridable$Overriden,
			override_,
			$author$project$Utils$Overridable$default(overridable));
	});
var $author$project$Formatters$Bool$toOnOff = function (bool) {
	return bool ? 'On' : 'Off';
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargePhiDetailsEnabled = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.KR) ? 'Remove override' : 'Override';
	var value = $author$project$Utils$Overridable$value(fields.KR);
	return _Utils_ap(
		$author$project$Utils$Overridable$isOverriden(fields.KR) ? _List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(value),
						$author$project$Ui$ToggleSwitch$onChange(
						function (bool) {
							return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled(
									A2($author$project$Utils$Overridable$override, bool, fields.KR)));
						})
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toOnOff(value))
							]))
					]))
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: overrideText},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled(
								$author$project$Utils$Overridable$switch(fields.KR))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(overrideText)
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargeRouteToRecurringInvoice = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Ey) ? 'Remove override' : 'Override';
	var value = $author$project$Utils$Overridable$value(fields.Ey);
	return _Utils_ap(
		$author$project$Utils$Overridable$isOverriden(fields.Ey) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(value),
								$author$project$Ui$ToggleSwitch$onChange(
								function (bool) {
									return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice(
											A2($author$project$Utils$Overridable$override, bool, fields.Ey)));
								})
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toOnOff(value))
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice(
										$author$project$Utils$Overridable$switch(fields.Ey))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$StartDateToggleBilling = 5;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingToggle = F2(
	function (isHintAdmin, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _Utils_ap(
			$author$project$Utils$Overridable$isOverriden(fields.Eg) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(
									$author$project$Utils$Overridable$value(fields.Eg)),
									$author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
									$author$project$Ui$ToggleSwitch$onChange(
									function (bool) {
										return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabled(
												A2($author$project$Utils$Overridable$override, bool, fields.Eg)));
									})
								]))
						]))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Bool$toOnOff(
										$author$project$Utils$Overridable$value(fields.Eg)))
								]))
						]))
				]),
			_List_fromArray(
				[
					function () {
					if (isHintAdmin) {
						var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Eg) ? 'Remove override' : 'Override';
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{abp: overrideText},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
												A2(
													$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
													5,
													$author$project$Utils$Overridable$isOverriden(fields.Eg))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(overrideText)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBilling = F2(
	function (isHintAdmin, form) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Billing (Hinter only)')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We will bill sponsors when this setting is enabled. When this setting is disabled, we will not bill sponsors, but are still tracking employee eligibility.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingToggle, isHintAdmin, form))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabledDateToggle = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingStartDateSelected = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingSelectedDropdownDate = F2(
	function (billingStartDate, currentDate) {
		if (!billingStartDate.$) {
			var date = billingStartDate.a;
			return date;
		} else {
			return currentDate;
		}
	});
var $author$project$Utils$Date$changeDay = F2(
	function (day, date) {
		var year = $justinmimbs$date$Date$year(date);
		var month = $justinmimbs$date$Date$month(date);
		return A3($justinmimbs$date$Date$fromCalendarDate, year, month, day);
	});
var $author$project$Utils$Date$toBeginningOfMonth = function (date) {
	return A2($author$project$Utils$Date$changeDay, 1, date);
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingStartDateOptions = function (startDate) {
	return $author$project$Ui$Form$Select$dateOptions(
		$author$project$Utils$Date$nextTwelveMonths(
			$author$project$Utils$Date$toBeginningOfMonth(startDate)));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingDate = F2(
	function (form, currentDate) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('mr-2')
							]),
						_List_fromArray(
							[
								$author$project$Utils$Overridable$value(fields.e4) ? A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Utils$Date$toIsoString(
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingSelectedDropdownDate, fields.J$, currentDate)))),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingStartDateSelected))
									]),
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingStartDateOptions(currentDate)) : $author$project$Utils$Html$empty
							])),
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(
								$author$project$Utils$Overridable$value(fields.e4)),
								$author$project$Ui$ToggleSwitch$onChange(
								function (bool) {
									return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabledDateToggle(
											A2($author$project$Utils$Overridable$override, bool, fields.e4)));
								})
							]))
					]))
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate = F2(
	function (form, currentDate) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					($author$project$Utils$Overridable$value(fields.Eg) && $author$project$Utils$Overridable$isOverriden(fields.Eg)) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Start billing in the future')
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mb4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Select a date when sponsor billing will start. Changing this date will cause all draft and outstanding invoices to be CANCELLED.')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingDate, form, currentDate))
								])),
							$author$project$Ui$HorizontalRule$view(_List_Nil)
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoicesToggle = F2(
	function (isHintAdmin, form) {
		var fields = $author$project$Utils$Form$fields(form);
		return _Utils_ap(
			$author$project$Utils$Overridable$isOverriden(fields.Qp) ? _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(
									$author$project$Utils$Overridable$value(fields.Qp)),
									$author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
									$author$project$Ui$ToggleSwitch$onChange(
									function (bool) {
										return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices(
												A2($author$project$Utils$Overridable$override, bool, fields.Qp)));
									})
								]))
						]))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Bool$toOnOff(
										$author$project$Utils$Overridable$value(fields.Qp)))
								]))
						]))
				]),
			_List_fromArray(
				[
					function () {
					if (isHintAdmin) {
						var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Qp) ? 'Remove override' : 'Override';
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$HinterOnly$button,
									{abp: overrideText},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
												$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices(
													$author$project$Utils$Overridable$switch(fields.Qp))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(overrideText)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoices = F2(
	function (isHintAdmin, form) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Hide Sponsor Invoice Tab (Hinter only)')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('When billing is disabled for sponsors, the Invoices tab will be hidden in the employer portal.')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoicesToggle, isHintAdmin, form))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoIssue = 1;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssue = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueDay = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueMonth = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$daysOfMonth = A2($elm$core$List$range, 1, 31);
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions = A2(
	$elm$core$List$map,
	function (day) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(day)),
			$author$project$Formatters$Int$ordinal(day));
	},
	$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$daysOfMonth);
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions = A2(
	$elm$core$List$map,
	function (option) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)),
			$author$project$Formatters$String$humanize(
				$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)));
	},
	$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate);
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[
										$author$project$Ui$Typography$danger,
										$author$project$Ui$Typography$small,
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(message)
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoIssue = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceAutoIssue = $author$project$Utils$Overridable$value(fields.Ri);
	var invoiceAutoIssueDay = $author$project$Utils$Overridable$value(fields.Rj);
	var invoiceAutoIssueMonth = $author$project$Utils$Overridable$value(fields.FK);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Ri) ? 'Remove override' : 'Override';
	return _Utils_ap(
		function () {
			if ($author$project$Utils$Overridable$isOverriden(fields.Ri)) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$offset(1),
										$author$project$Ui$FlexGrid$spanMd(5)
									]),
								_List_fromArray(
									[
										invoiceAutoIssue ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoIssueMonth))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 5, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										invoiceAutoIssue ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(invoiceAutoIssueDay))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueDay)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 5, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(invoiceAutoIssue),
												$author$project$Ui$ToggleSwitch$onChange(
												function (bool) {
													return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
														$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssue(
															A2($author$project$Utils$Overridable$override, bool, fields.Ri)));
												})
											]))
									]))
							])),
						A2($author$project$Utils$Form$hasValidationErrors, 5, form) ? A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
							A2($author$project$Utils$Form$validationErrors, 5, form))) : $author$project$Utils$Html$empty
					]);
			} else {
				var settingsText = invoiceAutoIssue ? ($author$project$Formatters$String$humanize(
					$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoIssueMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoIssueDay))) : $author$project$Formatters$Bool$toOnOff(invoiceAutoIssue);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(settingsText)
									]))
							]))
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										1,
										$author$project$Utils$Overridable$isOverriden(fields.Ri))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPay = 2;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPay = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayDay = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayMonth = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoPay = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceAutoPay = $author$project$Utils$Overridable$value(fields.Rk);
	var invoiceAutoPayDay = $author$project$Utils$Overridable$value(fields.FL);
	var invoiceAutoPayMonth = $author$project$Utils$Overridable$value(fields.FM);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Rk) ? 'Remove override' : 'Override';
	return _Utils_ap(
		function () {
			if ($author$project$Utils$Overridable$isOverriden(fields.Rk)) {
				var hasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 3, form) || A2($author$project$Utils$Form$hasValidationErrors, 4, form);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$offsetMd(1),
										$author$project$Ui$FlexGrid$spanMd(5)
									]),
								_List_fromArray(
									[
										invoiceAutoPay ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoPayMonth))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayMonth)),
												$author$project$Ui$Form$Select$invalid(hasValidationErrors)
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										invoiceAutoPay ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(invoiceAutoPayDay))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayDay)),
												$author$project$Ui$Form$Select$invalid(hasValidationErrors)
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(invoiceAutoPay),
												$author$project$Ui$ToggleSwitch$onChange(
												function (bool) {
													return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
														$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPay(
															A2($author$project$Utils$Overridable$override, bool, fields.Rk)));
												})
											]))
									]))
							])),
						hasValidationErrors ? A2(
						$elm$html$Html$div,
						_List_Nil,
						_Utils_ap(
							A2(
								$elm$core$List$map,
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
								A2($author$project$Utils$Form$validationErrors, 3, form)),
							A2(
								$elm$core$List$map,
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
								A2($author$project$Utils$Form$validationErrors, 4, form)))) : $author$project$Utils$Html$empty
					]);
			} else {
				var settingsText = invoiceAutoPay ? ($author$project$Formatters$String$humanize(
					$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoPayMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoPayDay))) : $author$project$Formatters$Bool$toOnOff(invoiceAutoPay);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(settingsText)
									]))
							]))
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										2,
										$author$project$Utils$Overridable$isOverriden(fields.Rk))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoSend = 0;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSend = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendDay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendMonth = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoSend = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceAutoSend = $author$project$Utils$Overridable$value(fields.Rl);
	var invoiceAutoSendDay = $author$project$Utils$Overridable$value(fields.Rm);
	var invoiceAutoSendMonth = $author$project$Utils$Overridable$value(fields.FN);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Rl) ? 'Remove override' : 'Override';
	return _Utils_ap(
		function () {
			if ($author$project$Utils$Overridable$isOverriden(fields.Rl)) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$offset(1),
										$author$project$Ui$FlexGrid$spanMd(5)
									]),
								_List_fromArray(
									[
										invoiceAutoSend ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoSendMonth))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										invoiceAutoSend ? A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(invoiceAutoSendDay))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendDay)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(invoiceAutoSend),
												$author$project$Ui$ToggleSwitch$onChange(
												function (bool) {
													return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
														$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSend(
															A2($author$project$Utils$Overridable$override, bool, fields.Rl)));
												})
											]))
									]))
							])),
						A2($author$project$Utils$Form$hasValidationErrors, 1, form) ? A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
							A2($author$project$Utils$Form$validationErrors, 1, form))) : $author$project$Utils$Html$empty
					]);
			} else {
				var settingsText = invoiceAutoSend ? ($author$project$Formatters$String$humanize(
					$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoSendMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoSendDay))) : $author$project$Formatters$Bool$toOnOff(invoiceAutoSend);
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(settingsText)
									]))
							]))
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										0,
										$author$project$Utils$Overridable$isOverriden(fields.Rl))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$DueDate = 3;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueDay = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueMonth = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceDueDay = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceDueDay = $author$project$Utils$Overridable$value(fields.Ro);
	var invoiceDueMonth = $author$project$Utils$Overridable$value(fields.FO);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Ro) ? 'Remove override' : 'Override';
	return _Utils_ap(
		function () {
			if ($author$project$Utils$Overridable$isOverriden(fields.Ro)) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$offsetMd(4),
										$author$project$Ui$FlexGrid$spanMd(5)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceDueMonth))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 6, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions)
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(3)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(invoiceDueDay))),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueDay)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 6, form))
											]),
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions)
									]))
							])),
						A2($author$project$Utils$Form$hasValidationErrors, 6, form) ? A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
							A2($author$project$Utils$Form$validationErrors, 6, form))) : $author$project$Utils$Html$empty
					]);
			} else {
				var settingsText = $author$project$Formatters$String$humanize(
					$author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceDueMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceDueDay));
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(settingsText)
									]))
							]))
					]);
			}
		}(),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										3,
										$author$project$Utils$Overridable$isOverriden(fields.Ro))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GracePeriod = 4;
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceGracePeriodDays = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceGracePeriodDays = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceGracePeriodDays = $author$project$Utils$Overridable$value(fields.FP);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.FP) ? 'Remove override' : 'Override';
	return _Utils_ap(
		$author$project$Utils$Overridable$isOverriden(fields.FP) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$offset(6),
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$group(
								A2(
									$author$project$Ui$Form$Input$withPreAddon,
									'# of days',
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											$elm$core$String$fromInt(invoiceGracePeriodDays)),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceGracePeriodDays))
										])))
							]))
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Formatters$String$pluralize, 'day', invoiceGracePeriodDays))
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: overrideText},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
									A2(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle,
										4,
										$author$project$Utils$Overridable$isOverriden(fields.FP))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(overrideText)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceUpcomingAutoSend = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	var invoiceUpcomingAutoSend = $author$project$Utils$Overridable$value(fields.FQ);
	var overrideText = $author$project$Utils$Overridable$isOverriden(fields.FQ) ? 'Remove override' : 'Override';
	return _Utils_ap(
		$author$project$Utils$Overridable$isOverriden(fields.FQ) ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$flexCol]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(invoiceUpcomingAutoSend),
								$author$project$Ui$ToggleSwitch$onChange(
								function (bool) {
									return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
										$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend(
											A2($author$project$Utils$Overridable$override, bool, fields.FQ)));
								})
							]))
					])),
				A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow,
					A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Formatters$Bool$toOnOff(invoiceUpcomingAutoSend))
							]))
					]))
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: overrideText},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(
							$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend(
								$author$project$Utils$Overridable$switch(fields.FQ))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(overrideText)
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource = F3(
	function (acceptsSource, acceptsSourceField, label) {
		var acceptsSourceBool = $author$project$Utils$Overridable$value(acceptsSource);
		var acceptsFieldType = function () {
			switch (acceptsSourceField.$) {
				case 0:
					return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch;
				case 1:
					return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards;
				default:
					return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex;
			}
		}();
		var overrideBtn = A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					function () {
					var buttonLabel = $author$project$Utils$Overridable$isOverriden(acceptsSource) ? 'Remove override' : 'Override';
					return A3(
						$author$project$Ui$Button$view,
						{abp: label},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated(
									acceptsFieldType(
										$author$project$Utils$Overridable$switch(acceptsSource))))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(buttonLabel)
							]));
				}()
				]));
		return $author$project$Utils$Overridable$isOverriden(acceptsSource) ? A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$titleSm,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$on(acceptsSourceBool),
											$author$project$Ui$ToggleSwitch$onChange(
											function (bool) {
												return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated(
													acceptsFieldType(
														A2($author$project$Utils$Overridable$override, bool, acceptsSource)));
											})
										]))
								])),
							overrideBtn
						]))
				])) : A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$titleSm,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Bool$toOnOff(acceptsSourceBool))
								])),
							overrideBtn
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalClicked = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Practice$Shared$hasBankTransfersCapability = function (_v0) {
	var record = _v0;
	return record.P1;
};
var $author$project$Api$Provider$Practice$One$hasBankTransfersCapability = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$hasBankTransfersCapability(shared);
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewVirtualBankAccountsActions = F2(
	function (model, label) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h5,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('m-0')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]))
						])),
					function () {
					var _v0 = model.DL;
					if (!_v0.$) {
						var companyId = $author$project$Api$Provider$Company$One$id(model.ab9);
						var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
							{ff: companyId});
						return A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Formatters$Bool$toOnOff(true))
										])),
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('View Transfer Details')
										]))
								]));
					} else {
						return A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											function () {
											var acceptsSourceBankTransfers = $author$project$Api$Provider$Practice$One$hasBankTransfersCapability(model.WF);
											var verb = acceptsSourceBankTransfers ? 'Enable' : 'Authorize';
											return A3(
												$author$project$Ui$Button$view,
												{abp: verb + ' transfer details'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalClicked(acceptsSourceBankTransfers))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(verb)
													]));
										}()
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentOptions = F3(
	function (model, fields, sponsorized) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Payment Options')
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Choose payment options available to  ' + (sponsorized + 's.'))
										]))
								]))
						])),
					A2($author$project$Api$Provider$Practice$One$featureEnabled, 11, model.WF) ? A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewVirtualBankAccountsActions, model, 'Accept Bank Transfers') : $author$project$Utils$Html$empty,
					A3(
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource,
					fields.H_,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch(fields.H_),
					'Accept Bank Accounts'),
					A3(
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource,
					fields.H0,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards(fields.H0),
					'Accept Credit Cards'),
					A3(
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource,
					fields.H$,
					$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex(fields.H$),
					'Accept American Express')
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentSettingsForm = F2(
	function (model, form) {
		var sponsorized = A2($author$project$Formatters$String$sponsorize, model.WF, 'employer');
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentOptions, model, fields, sponsorized)
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createTimelineEventAttributes = F2(
	function (fields, today) {
		var createTimelineDate = $author$project$Components$InvoiceSetting$Timeline$createTimelineDate(today);
		var dueDate = A2(
			createTimelineDate,
			$author$project$Utils$Overridable$value(fields.FO),
			$author$project$Utils$Overridable$value(fields.Ro));
		var unpaidDate = A3(
			$justinmimbs$date$Date$add,
			3,
			$author$project$Utils$Overridable$value(fields.FP),
			A2(
				createTimelineDate,
				$author$project$Utils$Overridable$value(fields.FO),
				$author$project$Utils$Overridable$value(fields.Ro)));
		var upcomingDate = A3(
			$justinmimbs$date$Date$add,
			2,
			-1,
			A2(
				createTimelineDate,
				$author$project$Utils$Overridable$value(fields.FN),
				$author$project$Utils$Overridable$value(fields.Rm)));
		var autopayDate = A2(
			createTimelineDate,
			$author$project$Utils$Overridable$value(fields.FM),
			$author$project$Utils$Overridable$value(fields.FL));
		var autoSendDate = A2(
			createTimelineDate,
			$author$project$Utils$Overridable$value(fields.FN),
			$author$project$Utils$Overridable$value(fields.Rm));
		var autoIssueDate = A2(
			createTimelineDate,
			$author$project$Utils$Overridable$value(fields.FK),
			$author$project$Utils$Overridable$value(fields.Rj));
		return _List_fromArray(
			[
				_Utils_Tuple3(
				$author$project$Utils$Overridable$value(fields.FQ) && $author$project$Utils$Overridable$value(fields.Rl),
				upcomingDate,
				'Send \"Upcoming\" email'),
				_Utils_Tuple3(
				$author$project$Utils$Overridable$value(fields.Rl),
				autoSendDate,
				'Send \"Created\" email'),
				_Utils_Tuple3(
				$author$project$Utils$Overridable$value(fields.Ri),
				autoIssueDate,
				'Issue Invoice'),
				_Utils_Tuple3(
				$author$project$Utils$Overridable$value(fields.Rk),
				autopayDate,
				'Autopay Invoice'),
				_Utils_Tuple3(true, dueDate, 'Due Date'),
				_Utils_Tuple3(true, unpaidDate, 'Employees show as unpaid')
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewTimeline = F2(
	function (currentDate, form) {
		if (!form.$) {
			var settingsForm = form.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(12)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Timeline$view,
										0,
										$author$project$Components$InvoiceSetting$Timeline$createTimelineEvents(
											A2(
												$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createTimelineEventAttributes,
												$author$project$Utils$Form$fields(settingsForm),
												currentDate)))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(12)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__InvoiceSettings,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Update global sponsor invoice settings')
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$view = function (model) {
	var sponsorizedPl = A2($author$project$Formatters$String$sponsorize, model.WF, 'employers');
	var sponsorized = A2($author$project$Formatters$String$sponsorize, model.WF, 'employer');
	var hideSponsorInvoicesSection = function () {
		var _v7 = model.PB;
		if (!_v7.$) {
			var form = _v7.a;
			return (model.FR && (!$author$project$Utils$Overridable$value(
				$author$project$Utils$Form$fields(form).Eg))) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoices, model.FR, form)
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	}();
	var enableBillingSection = function () {
		var _v6 = model.PB;
		if (!_v6.$) {
			var form = _v6.a;
			return A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.WF) ? (((!model.FR) && $author$project$Utils$Overridable$value(
				$author$project$Utils$Form$fields(form).Eg)) ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate,
						form,
						A3($justinmimbs$date$Date$add, 1, 1, model.cO))
					])) : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBilling, model.FR, form),
						A2(
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate,
						form,
						A3($justinmimbs$date$Date$add, 1, 1, model.cO))
					]))) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	}();
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.eQ;
				if (!_v0.$) {
					var virtualBankAccountEnableModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg,
						$author$project$Components$Company$VirtualBankAccounts$EnableModal$modal(virtualBankAccountEnableModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.dk;
				if (!_v1.$) {
					var virtualBankAccountAuthorizeModal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg,
						$author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$modal(virtualBankAccountAuthorizeModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[$author$project$Ui$Form$horizontal]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Example of Upcoming Month')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewTimeline, model.cO, model.PB),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										enableBillingSection,
										hideSponsorInvoicesSection,
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Notification: Invoice Upcoming')
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Sent to '),
																$elm$html$Html$text(sponsorizedPl),
																$elm$html$Html$text(' to let them know when to expect an invoice. '),
																$elm$html$Html$text('This notification is sent 1 week prior to the “Invoice Created” notification')
															])),
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Admin__Notifications__Company,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('View and customize the notification')
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6),
														$author$project$Ui$FlexGrid$justifyRight
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceUpcomingAutoSend, model.PB))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Notification: Invoice Created')
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Sent to '),
																$elm$html$Html$text(sponsorizedPl),
																$elm$html$Html$text(' on the specified day. Invoices can be sent regardless'),
																$elm$html$Html$text(' of whether they are still in draft or have been issued.')
															])),
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Admin__Notifications__Company,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('View and customize the notification')
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoSend, model.PB))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Scheduled Issue Date')
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																'Invoices will be automatically issued on the specified date, locking charges in place and preventing ' + ($author$project$Formatters$String$pluralOf(sponsorized) + (' from making any changes. Once issued, ' + (sponsorized + ' can pay invoices manually, or invoices will be automatically processed based on the Scheduled Autopay Date settings.'))))
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoIssue, model.PB))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Scheduled Autopay Date')
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Payment for the full amount of all issued invoices will be automatically attempted on the specified date. ' + ('Payments will not be processed for non-issued invoices. This date is visible to the  ' + (sponsorized + '.')))
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoPay, model.PB))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Due Date')
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('The day when the invoice is considered ”due”. This date is visible to the ' + (sponsorized + ' and printed on the invoice.'))
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceDueDay, model.PB))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Grace Period')
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('If the invoice is not yet paid after the grace period passes, each employee\'s membership status will be set to “unpaid” and the invoice will be considered “overdue”. The grace period starts after the due date.')
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceGracePeriodDays, model.PB))
											])),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Include Full Charge Details')
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Allow the ' + (sponsorized + ' to see full charge details and patient names when viewing or downloading the invoice. Since these details may contain protected health information, this setting is off by default.'))
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(6),
														$author$project$Ui$FlexGrid$justifyRight
													]),
												_List_fromArray(
													[
														function () {
														var _v2 = $author$project$Api$Data$toMaybe(model.cq);
														if (!_v2.$) {
															var companyInvoiceSetting = _v2.a;
															var _v3 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedAt(companyInvoiceSetting);
															if (!_v3.$) {
																var chargePhiDetailsUpdatedAt = _v3.a;
																return A2(
																	$author$project$Ui$FlexGrid$row,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$FlexGrid$column,
																			_List_fromArray(
																				[
																					$author$project$Ui$FlexGrid$spanMd(12)
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$author$project$Ui$Typography$p,
																					_List_fromArray(
																						[
																							$author$project$Ui$Typography$muted,
																							$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text('Updated by '),
																							$elm$html$Html$text(
																							A2(
																								$elm$core$Maybe$withDefault,
																								'N/A',
																								A2(
																									$elm$core$Maybe$map,
																									$author$project$Api$Provider$User$Min$name,
																									$author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedBy(companyInvoiceSetting)))),
																							$elm$html$Html$text(' on '),
																							$elm$html$Html$text(
																							A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargePhiDetailsUpdatedAt))
																						]))
																				]))
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														} else {
															return $author$project$Utils$Html$empty;
														}
													}(),
														A2(
														$author$project$Ui$Element$view,
														_List_fromArray(
															[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$flexCol]),
														A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargePhiDetailsEnabled, model.PB))
													]))
											])),
										A3(
										$author$project$Utils$FeatureGate$gate,
										3,
										$author$project$Api$Practice$Provider(model.WF),
										A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$HorizontalRule$view(_List_Nil),
													$author$project$Ui$Typography$headingSm(
													_List_fromArray(
														[
															$elm$html$Html$text('Add Service Charges to Membership Invoices')
														])),
													A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanMd(6)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('When point-of-care service charges are paid for by the employer, '),
																			$elm$html$Html$text('automatically add these charges to the employer\'s next draft membership invoice. If this setting is disabled, '),
																			$elm$html$Html$text('service charges will be added to a separate service invoice.')
																		]))
																])),
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanMd(6)
																]),
															A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargeRouteToRecurringInvoice, model.PB))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													function () {
														var _v4 = model.aL;
														if (!_v4.$) {
															var form = _v4.a;
															return A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentSettingsForm, model, form);
														} else {
															return _List_fromArray(
																[$author$project$Utils$Html$empty]);
														}
													}())
												])))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Admin__Practice,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										function () {
										if ($author$project$Utils$Maybe$toBool(model.PB)) {
											var nonSubmittable = function () {
												var _v5 = model.PB;
												if (!_v5.$) {
													var form = _v5.a;
													return $author$project$Utils$Form$hasAnyValidationError(form);
												} else {
													return true;
												}
											}();
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'Update company invoice settings'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$loading(
														_Utils_eq(model.cq, $author$project$Api$Data$Loading)),
														$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsSubmitted),
														$author$project$Ui$Button$disabled(nonSubmittable)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					]))
			]),
		$G: A2($author$project$Formatters$String$sponsorize, model.WF, 'Companies') + ' | Invoice Settings'
	};
};
var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$page = $author$project$Spa$Page$applicationCompany(
	{ad0: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$init, aer: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$load, agD: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$save, ahd: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$update, ahP: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$view});
var $author$project$Components$Invoice$Company = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$EmployerOrProviderCompany = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$InvoiceComponentMsg = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var _v1 = $author$project$Components$Invoice$init(
			{
				D5: shared.D5,
				k0: false,
				ab9: $elm$core$Maybe$Just(
					$author$project$Components$Invoice$EmployerOrProviderCompany(company)),
				Rr: A2($author$project$Components$Invoice$Company, params.ff, params.adR),
				F_: $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
					{ff: params.ff}),
				r$: $elm$core$Maybe$Just(
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
						{ff: params.ff})),
				WF: practice,
				ZD: session,
				Cd: shared
			});
		var invoiceComponent = _v1.a;
		var invoiceComponentCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, Rh: invoiceComponent, WF: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, invoiceComponentCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Invoice$subscriptions(model.Rh));
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Invoice$update, model.D5, subMsg, model.Rh);
		var invoiceComponent = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{Rh: invoiceComponent}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Invoice$view, model.D5, model.Rh)),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Invoices'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$init, aer: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$load, agD: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$save, ahd: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$update, ahP: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$view});
var $author$project$Api$Provider$Report$Invoice = 3;
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$GotInvoices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{afy: model.afy, ag1: model.ag1});
	};
};
var $author$project$Api$Invoice$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Invoice$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Invoice$All$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Employer$Invoice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Invoice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Invoice$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Employer$Invoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Employer$Invoice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Employer$Invoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Invoice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Employer$Invoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Invoice$invoicesPath)));
	});
var $author$project$Api$Invoice$list = F5(
	function (apiClient, session, companyId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Invoice$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Invoice$All$Employer)))) : A4(
			$author$project$Api$Provider$Company$Invoice$list,
			apiClient,
			companyId,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Invoice$All$Provider))));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices = function (model) {
	return A5(
		$author$project$Api$Invoice$list,
		model.D5,
		model.ZD,
		model.adR,
		$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams(model),
		$author$project$Pages$Companies$CompanyId_String$Invoices$Top$GotInvoices);
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var query = _v0.Bi;
		var model = {
			D5: shared.D5,
			ab9: company,
			l9: $author$project$Components$ExportCsv$init(
				{adw: shared.afu, G0: 3}),
			adv: $elm$core$Maybe$Nothing,
			adR: params.ff,
			q2: $author$project$Api$Data$Loading,
			na: $author$project$Api$Data$NotAsked,
			afu: shared.afu,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			ZD: session,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'invoice_date',
				1,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(model));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{afu: shared.afu}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg,
		$author$project$Components$ExportCsv$subscriptions(model.l9));
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$InvoiceCreated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Company$Invoice$create = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Invoice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$Invoice$invoicesPath(companyId)));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
						{ff: model.adR}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				$author$project$Api$Sort$toQuery(model.ag1))));
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					var intFromHeader = F2(
						function (key, headers_) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$andThen,
									$elm$core$String$toInt,
									A2($elm$core$Dict$get, key, headers_)));
						});
					var totalAmount = A2(intFromHeader, 'x-total-amount', headers);
					var totalDueAmount = A2(intFromHeader, 'x-total-due-amount', headers);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								adv: $elm$core$Maybe$Just(
									_Utils_Tuple2(totalAmount, totalDueAmount)),
								q2: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{q2: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
								$author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{q2: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
								$author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{na: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$Company$Invoice$create, model.D5, model.adR, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$InvoiceCreated),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					var newModel = _Utils_update(
						model,
						{q2: $author$project$Api$Data$Loading, na: response});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
									A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
										{
											ff: model.adR,
											adR: $author$project$Api$Provider$Invoice$One$id(invoice)
										}))
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'New invoice created!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{na: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$ExportCsv$update, model.D5, subMsg, model.l9);
				var exportCsv = _v3.a;
				var subCmd = _v3.b;
				var subOutMsg = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Invoice$invoicesPath = F2(
	function (session, id_) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Invoice$invoicesPath : $author$project$Api$Provider$Company$Invoice$invoicesPath(id_);
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$CreateInvoice = {$: 3};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$newInvoiceButton = F2(
	function (practiceOrganization, newInvoice) {
		if (!practiceOrganization.$) {
			return A2($author$project$Utils$FeatureGate$gateAvailable, 3, practiceOrganization) ? A3(
				$author$project$Ui$Button$view,
				{abp: 'Create new invoice'},
				_List_fromArray(
					[
						$author$project$Ui$Button$styled(0),
						$author$project$Ui$Button$loading(
						_Utils_eq(newInvoice, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Invoices$Top$CreateInvoice),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('New Invoice')
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$SortTable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'invoice_date', true, 'Date'),
		A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
		A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Total'),
		A3($author$project$Api$Column$init, 'description', false, 'Description')
	]);
var $author$project$Api$Employer$Invoice$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Invoice$All$amountInCents = function (_v0) {
	var record = _v0.b;
	return record.I2;
};
var $author$project$Api$Invoice$All$amountInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$amountInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$amountInCents(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Employer$Invoice$All$description = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$description(shared);
};
var $author$project$Api$Provider$Invoice$All$description = function (_v0) {
	var record = _v0.b;
	return record.Nx;
};
var $author$project$Api$Invoice$All$description = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$description(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$description(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$dueInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$dueInCents(shared);
};
var $author$project$Api$Provider$Invoice$All$dueInCents = function (_v0) {
	var record = _v0.b;
	return record.N2;
};
var $author$project$Api$Invoice$All$dueInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$dueInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$dueInCents(invoice_);
	}
};
var $author$project$Ui$Typography$Ellipsis = {$: 16};
var $author$project$Ui$Typography$ellipsis = $author$project$Ui$Typography$Ellipsis;
var $author$project$Api$Employer$Invoice$All$humanStatus = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$humanStatus(shared);
};
var $author$project$Api$Invoice$All$humanStatus = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$humanStatus(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$humanStatus(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$id(shared);
};
var $author$project$Api$Invoice$All$id = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$id(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$id(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$invoiceDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$invoiceDate(shared);
};
var $author$project$Api$Invoice$All$invoiceDate = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$invoiceDate(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$invoiceDate(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$invoiceNumber = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Invoice$All$invoiceNumber = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$invoiceNumber(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$invoiceNumber(invoice_);
	}
};
var $author$project$Api$Employer$Invoice$All$paidInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Invoice$Shared$paidInCents(shared);
};
var $author$project$Api$Provider$Invoice$All$paidInCents = function (_v0) {
	var record = _v0.b;
	return record.Vu;
};
var $author$project$Api$Invoice$All$paidInCents = function (invoice) {
	if (!invoice.$) {
		var invoice_ = invoice.a;
		return $author$project$Api$Provider$Invoice$All$paidInCents(invoice_);
	} else {
		var invoice_ = invoice.a;
		return $author$project$Api$Employer$Invoice$All$paidInCents(invoice_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewRow = F2(
	function (companyId, invoice) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
								{
									ff: companyId,
									adR: $author$project$Api$Invoice$All$id(invoice)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Invoice$All$invoiceDate(invoice)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
								{
									ff: companyId,
									adR: $author$project$Api$Invoice$All$id(invoice)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Invoice$All$invoiceNumber(invoice)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Api$Invoice$Status$toBadge(
							$author$project$Api$Invoice$All$humanStatus(invoice))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Invoice$All$amountInCents(invoice))),
							$author$project$Utils$Html$noBreakSpace,
							(($author$project$Api$Invoice$All$dueInCents(invoice) > 0) && ($author$project$Api$Invoice$All$paidInCents(invoice) > 0)) ? A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('('),
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Invoice$All$dueInCents(invoice))),
									$elm$html$Html$text(' due)')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$ellipsis]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Invoice$All$description(invoice))
								]))
						])),
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.q2;
		if (_v1.$ === 3) {
			var invoices_ = _v1.a;
			return _Utils_Tuple2(false, invoices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var invoices = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any charges for '),
						$elm$html$Html$text(
						$author$project$Api$Company$name(model.ab9)),
						$elm$html$Html$text(' yet. An invoice will be created on the 1st of the month for any '),
						$elm$html$Html$text(
						A2($author$project$Api$Practice$sponsorize, model.WF, 'employees')),
						$elm$html$Html$text(' who have signed up.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$SortTable)),
					$author$project$Pages$Companies$CompanyId_String$Invoices$Top$columns),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewRow(model.adR),
			invoices),
		_List_Nil);
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$view = function (model) {
	return {
		e5: function () {
			var loading = function () {
				var _v0 = model.q2;
				if (_v0.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Panel$title(
											_List_fromArray(
												[
													$elm$html$Html$text('Invoices')
												])),
											A2($author$project$Pages$Companies$CompanyId_String$Invoices$Top$newInvoiceButton, model.WF, model.na)
										]))
								])),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewTable(model)
								])),
							A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Invoices$Top$PaginationMsg,
									A2(
										$author$project$Api$Pagination$view,
										_List_fromArray(
											[
												$author$project$Ui$Pagination$List$loading(loading)
											]),
										model.afy))
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg,
					A3(
						$author$project$Components$ExportCsv$modal,
						model.D5,
						_List_fromArray(
							[
								$author$project$Components$ExportCsv$path(
								A2($author$project$Api$Invoice$invoicesPath, model.ZD, model.adR)),
								$author$project$Components$ExportCsv$params(
								$author$project$Api$Provider$Invoice$listOptionsToParams(
									$author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams(model)))
							]),
						model.l9))
				]);
		}(),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Invoices'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$init, aer: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$load, agD: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$save, ahd: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$update, ahP: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$view});
var $author$project$Api$Provider$Note$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Notes$NotesMsg = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$Notes$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var query = _v1.Bi;
		var params = _v1.Vx;
		var _v2 = A6(
			$author$project$Components$Notes$init,
			shared.D5,
			shared.Hy,
			$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes(
				{ff: params.ff}),
			query,
			$author$project$Api$Provider$Note$Company(params.ff),
			$author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
		var notes = _v2.a;
		var notesCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: notes, WF: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$Notes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Notes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Notes$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Notes$subscriptions(model.rh));
};
var $author$project$Pages$Companies$CompanyId_String$Notes$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Notes$update, model.D5, subMsg, model.rh);
		var notes = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: notes}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Companies$CompanyId_String$Notes$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Notes$view(model.rh)),
		$G: A2($author$project$Formatters$String$sponsorize, model.WF, 'Companies') + ' | Notes'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Notes$page = $author$project$Spa$Page$applicationCompany(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Notes$init, aer: $author$project$Pages$Companies$CompanyId_String$Notes$load, agD: $author$project$Pages$Companies$CompanyId_String$Notes$save, ahd: $author$project$Pages$Companies$CompanyId_String$Notes$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Notes$update, ahP: $author$project$Pages$Companies$CompanyId_String$Notes$view});
var $author$project$Pages$Companies$CompanyId_String$Notifications$AdminTableMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Notification$CompanyContext = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Notifications$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var params = _v1.Vx;
		var multilanguageEnabled = A2(
			$author$project$Api$Practice$featureEnabled,
			10,
			$author$project$Api$Practice$Provider(practice));
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled),
			A4(
				$author$project$Components$Admin$NotificationSetting$AdminTable$init,
				shared.D5,
				session,
				$author$project$Api$Provider$Notification$CompanyContext(params.ff),
				0));
		var adminTable = _v2.a;
		var adminTableCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: adminTable, WF: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$Notifications$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Notifications$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Notifications$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rh));
};
var $author$project$Pages$Companies$CompanyId_String$Notifications$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.D5, subMsg, model.rh);
		var adminTable = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: adminTable}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Companies$CompanyId_String$Notifications$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Employee Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('These are emails that will be sent to any patients who are being sponsored by their employers. '),
										$elm$html$Html$text('They will also receive any patient emails that don\'t relate to payment of their memberships.')
									])),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$identity),
								$author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rh))))
					]))
			]),
		$G: A2($author$project$Formatters$String$sponsorize, model.WF, 'Companies') + ' | Notifications'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Notifications$page = $author$project$Spa$Page$applicationCompany(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Notifications$init, aer: $author$project$Pages$Companies$CompanyId_String$Notifications$load, agD: $author$project$Pages$Companies$CompanyId_String$Notifications$save, ahd: $author$project$Pages$Companies$CompanyId_String$Notifications$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Notifications$update, ahP: $author$project$Pages$Companies$CompanyId_String$Notifications$view});
var $author$project$Components$PaymentSources$Company = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$PaymentSourcesMsg = $elm$core$Basics$identity;
var $author$project$Components$PaymentSources$DropdownMenuMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$PaymentSources$Model = $elm$core$Basics$identity;
var $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Provider$Patient$One$createdAt = function (_v0) {
	var record = _v0.b;
	return record.Mf;
};
var $author$project$Components$MovePaymentMethodsModal$Closed = {$: 0};
var $author$project$Components$MovePaymentMethodsModal$init = $author$project$Components$MovePaymentMethodsModal$Closed;
var $author$project$Components$VirtualBankAccounts$Model = $elm$core$Basics$identity;
var $author$project$Components$VirtualBankAccounts$GotVirtualBankAccounts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$VirtualBankAccounts$loadData = F2(
	function (apiClient, companyId) {
		return _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A3($author$project$Api$Provider$VirtualBankAccount$list, apiClient, companyId, $author$project$Components$VirtualBankAccounts$GotVirtualBankAccounts));
	});
var $author$project$Components$VirtualBankAccounts$init = F3(
	function (companyId, practice, _v0) {
		var timeFormatter = _v0.Hy;
		var apiClient = _v0.D5;
		var _v1 = A2($author$project$Components$VirtualBankAccounts$loadData, apiClient, companyId);
		var virtualBankAccounts = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{JS: false, WF: practice, Hy: timeFormatter, DL: virtualBankAccounts},
			cmd);
	});
var $author$project$Components$PaymentSources$GotBankAccounts = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PaymentSources$GotCards = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PaymentSources$GotPaymentSourcesMigratable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Patient$PaymentMethod$canMigrateDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['can_migrate']),
	$elm$json$Json$Decode$bool);
var $author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['payment_methods']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$PaymentMethod$canMigratePath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['can_migrate']),
		$author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId));
};
var $author$project$Api$Provider$Patient$PaymentMethod$canMigrate = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$PaymentMethod$canMigrateDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$PaymentMethod$canMigratePath(patientId)));
	});
var $author$project$Components$PaymentSources$loadData = F4(
	function (basePath, apiClient, session, resource) {
		return _Utils_Tuple3(
			$author$project$Api$Data$Loading,
			$author$project$Api$Data$Loading,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$Card$list, basePath, apiClient, session, $author$project$Components$PaymentSources$GotCards),
						A4($author$project$Api$BankAccount$list, basePath, apiClient, session, $author$project$Components$PaymentSources$GotBankAccounts),
						function () {
						if (resource.$ === 1) {
							var patient = resource.a;
							return A3(
								$author$project$Api$Provider$Patient$PaymentMethod$canMigrate,
								apiClient,
								$author$project$Api$Provider$Patient$One$id(patient),
								$author$project$Components$PaymentSources$GotPaymentSourcesMigratable);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}()
					])));
	});
var $author$project$Components$PaymentSources$init = F4(
	function (resource, session, practice, shared) {
		var patientId = function () {
			if (resource.$ === 1) {
				var patient = resource.a;
				return $author$project$Api$Provider$Patient$One$id(patient);
			} else {
				return '';
			}
		}();
		var patientCreatedAt = function () {
			if (resource.$ === 1) {
				var patient = resource.a;
				return $elm$core$Maybe$Just(
					$author$project$Api$Provider$Patient$One$createdAt(patient));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var basePath = function () {
			if (!resource.$) {
				var company = resource.a;
				if (!company.$) {
					var company_ = company.a;
					return $author$project$Api$Provider$Company$companyPath(
						$author$project$Api$Provider$Company$One$id(company_));
				} else {
					return $author$project$Api$Data$employerPath;
				}
			} else {
				var patient = resource.a;
				return A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[
							$author$project$Api$Provider$Patient$One$id(patient)
						]),
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['patients']),
						$author$project$Api$Data$providerPath));
			}
		}();
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				resource,
				A2($author$project$Api$Practice$featureEnabled, 11, practice));
			if ((!_v1.a.$) && _v1.b) {
				var company = _v1.a.a;
				var _v2 = A3(
					$author$project$Components$VirtualBankAccounts$init,
					$author$project$Api$Company$id(company),
					practice,
					{D5: shared.D5, Hy: shared.Hy});
				var model_ = _v2.a;
				var cmd_ = _v2.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(model_),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg, cmd_));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var virtualBankAccountModel = _v0.a;
		var virtualBankAccountCmd = _v0.b;
		var _v3 = A4($author$project$Components$PaymentSources$loadData, basePath, shared.D5, session, resource);
		var cards = _v3.a;
		var bankAccounts = _v3.b;
		var cmd = _v3.c;
		return _Utils_Tuple2(
			{
				hy: A7(
					$author$project$Components$AuditTrailLog$init,
					session,
					shared.aav,
					shared.Hy,
					$elm$core$Maybe$Just('patient'),
					$elm$core$Maybe$Just(patientId),
					patientCreatedAt,
					$elm$core$Maybe$Just('payment_methods')),
				pD: bankAccounts,
				vD: basePath,
				pN: cards,
				lB: $author$project$Components$CreatePaymentMethodModal$init,
				cO: shared.cO,
				fr: $elm$core$Maybe$Nothing,
				qT: shared.qT,
				FR: $author$project$Shared$isHintAdmin(shared),
				rp: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'payment-methods-other-actions-dropdown-menu', ahx: $author$project$Components$PaymentSources$DropdownMenuMsg})),
				f6: $author$project$Components$MovePaymentMethodsModal$init,
				AL: $author$project$Api$Data$Loading,
				WF: practice,
				sj: shared.sj,
				G0: resource,
				ZD: session,
				Hg: $elm$core$Maybe$Nothing,
				Hy: shared.Hy,
				aw: $elm$core$Set$empty,
				tx: virtualBankAccountModel
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, virtualBankAccountCmd])));
	});
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$init = F5(
	function (session, practice, company, shared, _v0) {
		var _v1 = A4(
			$author$project$Components$PaymentSources$init,
			$author$project$Components$PaymentSources$Company(company),
			session,
			practice,
			shared);
		var paymentSources = _v1.a;
		var paymentSourcesCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: paymentSources, WF: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSourcesCmd));
	});
var $author$project$Components$PaymentSources$setPractice = F2(
	function (practice, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{WF: practice});
	});
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$load = F2(
	function (shared, model) {
		var _v0 = shared.WF;
		if (_v0.$ === 3) {
			var practice = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						rh: A2($author$project$Components$PaymentSources$setPractice, practice, model.rh),
						WF: practice
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$PaymentSources$AuditTrailLogMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentSources$CloseMovePaymentMethodsModal = {$: 22};
var $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentSources$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$MovePaymentMethodsModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
var $author$project$Components$PaymentSources$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentSources$CreatePaymentMethodModalMsg,
				$author$project$Components$CreatePaymentMethodModal$subscriptions(model.lB)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$PaymentSources$HiConfirmClosed),
					model.fr)),
				$author$project$Components$AuditTrailLog$isOpen(model.hy) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PaymentSources$AuditTrailLogMsg,
				$author$project$Components$AuditTrailLog$subscriptions(model.hy)) : $elm$core$Platform$Sub$none,
				$author$project$Components$MovePaymentMethodsModal$subscriptions($author$project$Components$PaymentSources$CloseMovePaymentMethodsModal)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PaymentSources$subscriptions(model.rh));
};
var $author$project$Components$PaymentSources$Deleted = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$PaymentSources$MadeDefault = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$PaymentSources$Patient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentSources$PatientUpdated = function (a) {
	return {$: 15, a: a};
};
var $author$project$OutMsg$RetrievePatient = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$close = function (_v0) {
	return $author$project$Components$MovePaymentMethodsModal$Closed;
};
var $author$project$Components$PaymentSources$formFieldsFromSource = function (source) {
	var cardFields = function () {
		if (!source.$) {
			return $elm$core$Maybe$Just(
				{
					ac9: $author$project$Api$Source$expMonth(source),
					ada: $author$project$Api$Source$expYear(source),
					tC: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Source$zip(source))
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	return {
		Et: cardFields,
		aej: $author$project$Api$Source$label(source)
	};
};
var $author$project$Components$PaymentSources$cardFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var month = field.a;
				return _Utils_update(
					fields,
					{
						ac9: $elm$core$String$toInt(month)
					});
			case 2:
				var year = field.a;
				return _Utils_update(
					fields,
					{
						ada: $elm$core$String$toInt(year)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{tC: string});
			default:
				return fields;
		}
	});
var $author$project$Components$PaymentSources$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					aej: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var _v1 = fields.Et;
			if (_v1.$ === 1) {
				return fields;
			} else {
				var cardFields = _v1.a;
				return _Utils_update(
					fields,
					{
						Et: $elm$core$Maybe$Just(
							A2($author$project$Components$PaymentSources$cardFormFieldsUpdate, field, cardFields))
					});
			}
		}
	});
var $author$project$Components$PaymentSources$ExpirationDateValidation = 1;
var $author$project$Components$PaymentSources$expDateValidator = F2(
	function (currentDate, fields) {
		var _v0 = fields.Et;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var cardFields = _v0.a;
			var invalid = _Utils_Tuple2(1, 'Please enter a future expiration date.');
			var _v1 = _Utils_Tuple2(cardFields.ada, cardFields.ac9);
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var expYear = _v1.a.a;
				var expMonth = _v1.b.a;
				var currentYear = $justinmimbs$date$Date$year(currentDate);
				var currentMonth = $justinmimbs$date$Date$monthNumber(currentDate);
				return (_Utils_eq(currentYear, expYear) && (_Utils_cmp(expMonth, currentMonth) < 0)) ? _List_fromArray(
					[invalid]) : _List_Nil;
			} else {
				return _List_fromArray(
					[invalid]);
			}
		}
	});
var $author$project$Components$PaymentSources$ZipValidation = 0;
var $author$project$Components$PaymentSources$zipValidator = function (fields) {
	var _v0 = fields.Et;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var cardFields = _v0.a;
		var zipLenght = $elm$core$String$length(cardFields.tC);
		return ((zipLenght === 5) || (zipLenght === 9)) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please enter a valid zip code.')
			]);
	}
};
var $author$project$Components$PaymentSources$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$PaymentSources$zipValidator),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$PaymentSources$expDateValidator(currentDate))
			]));
};
var $author$project$Components$MovePaymentMethodsModal$None = 1;
var $author$project$Components$MovePaymentMethodsModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$GotPaymentSources = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PaymentMethod$Min$PaymentMethod = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentMethod$Min$Record = F5(
	function (id, sourceBrand, lastFour, label, isDefault) {
		return {adR: id, RI: isDefault, aej: label, Sz: lastFour, _f: sourceBrand};
	});
var $author$project$Api$Provider$PaymentMethod$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_default',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'label',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_four',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'payment_method_brand',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethod$Min$Record))))));
var $author$project$Api$Provider$PaymentMethod$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PaymentMethod$Min$recordDecoder);
var $author$project$Api$Provider$Patient$PaymentMethod$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$maybe(
				$elm$json$Json$Decode$list($author$project$Api$Provider$PaymentMethod$Min$decoder)),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId)));
	});
var $author$project$Components$MovePaymentMethodsModal$getPaymentSources = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$PaymentMethod$list, apiClient, patientId, $author$project$Components$MovePaymentMethodsModal$GotPaymentSources);
	});
var $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$Patient$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bb);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bb: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$LimitedPatientSelector$initPatientResourceFilter = F3(
	function (apiClient, optionals, patient) {
		return function (_v0) {
			var patientResourceFilter = _v0.a;
			var patientResourceFilterCmd = _v0.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(patientResourceFilter, patientResourceFilterCmd),
				A2(
					$elm$core$Maybe$map,
					function (patient_) {
						var _v1 = A2(
							$author$project$Components$ResourceFilter$Patient$preSelectedId,
							$elm$core$Maybe$Just(patient_.adR),
							patientResourceFilter);
						var withPreSelectedModel = _v1.a;
						var withPreSelectedCmd = _v1.b;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$ResourceFilter$Patient$extraItems,
								_List_fromArray(
									[
										{IK: patient_.IK, adR: patient_.adR, TL: patient_.TL, zh: patient_.zh}
									]),
								withPreSelectedModel),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[withPreSelectedCmd, patientResourceFilterCmd])));
					},
					patient));
		}(
			A2($author$project$Components$ResourceFilter$Patient$init, apiClient, optionals));
	});
var $author$project$Components$LimitedPatientSelector$init = F4(
	function (apiClient, patientResourceFilterOptionals, patients, patient) {
		var _v0 = A2(
			$elm$core$List$any,
			function (patient_) {
				return _Utils_eq(
					$elm$core$Maybe$Just(patient_.adR),
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.adR;
						},
						patient));
			},
			patients) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A3($author$project$Components$LimitedPatientSelector$initPatientResourceFilter, apiClient, patientResourceFilterOptionals, patient));
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				VM: patient,
				rU: patientResourceFilter,
				GC: patientResourceFilterOptionals,
				Ap: patients,
				aaN: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adR;
					},
					patient)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceFilterCmd));
	});
var $author$project$Components$MovePaymentMethodsModal$mapPatientAttributes = function (patient) {
	return A2(
		$elm$core$Maybe$map,
		function (patient_) {
			return {
				IK: $author$project$Api$Provider$Patient$One$age(patient_),
				adR: $author$project$Api$Provider$Patient$One$id(patient_),
				aet: $elm$core$Maybe$Nothing,
				TL: $author$project$Api$Provider$Patient$One$membershipStatus(patient_),
				zh: $author$project$Api$Provider$Patient$One$name(patient_),
				afS: $elm$core$Maybe$Nothing,
				aaI: $author$project$Api$Provider$Patient$One$usesTobacco(patient_)
			};
		},
		patient);
};
var $author$project$Components$MovePaymentMethodsModal$initLimitedPatientSelector = F3(
	function (apiClient, patients, patient) {
		return A4(
			$author$project$Components$LimitedPatientSelector$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Patient', IS: true});
			},
			patients,
			$author$project$Components$MovePaymentMethodsModal$mapPatientAttributes(patient));
	});
var $author$project$Api$Provider$Patient$One$payees = function (_v0) {
	var record = _v0.b;
	return record.VU;
};
var $author$project$Components$MovePaymentMethodsModal$initFormFields = F2(
	function (apiClient, patient) {
		var patients = A2(
			$elm$core$List$map,
			function (patient_) {
				return {
					IK: $author$project$Api$Provider$Patient$Shared$age(patient_),
					adR: $author$project$Api$Provider$Patient$Shared$id(patient_),
					aet: $elm$core$Maybe$Nothing,
					TL: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient_),
					zh: $author$project$Api$Provider$Patient$Shared$name(patient_),
					afS: $elm$core$Maybe$Nothing,
					aaI: $author$project$Api$Provider$Patient$Shared$usesTobacco(patient_)
				};
			},
			$author$project$Api$Provider$Patient$One$payees(patient));
		var _v0 = A3(
			$author$project$Components$MovePaymentMethodsModal$initLimitedPatientSelector,
			apiClient,
			patients,
			$elm$core$Maybe$Just(patient));
		var limitedPatientSelector = _v0.a;
		var limitedPatientSelectorCmd = _v0.b;
		return _Utils_Tuple2(
			{
				lq: true,
				rd: limitedPatientSelector,
				VM: $author$project$Components$MovePaymentMethodsModal$mapPatientAttributes(
					$elm$core$Maybe$Just(patient))
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd));
	});
var $author$project$Components$MovePaymentMethodsModal$openAndInit = F4(
	function (apiClient, basePath, session, patient) {
		var _v0 = A2($author$project$Components$MovePaymentMethodsModal$initFormFields, apiClient, patient);
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		var open = {
			vD: basePath,
			PB: $author$project$Utils$Form$init(formFields),
			yh: true,
			rq: $author$project$Api$Data$NotAsked,
			VM: patient,
			eh: $elm$core$Maybe$Nothing,
			jp: $elm$core$Maybe$Nothing,
			B4: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$One$id(patient)),
			B5: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$One$name(patient)),
			ZD: session
		};
		return {
			EC: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						A2(
						$author$project$Components$MovePaymentMethodsModal$getPaymentSources,
						apiClient,
						$author$project$Api$Provider$Patient$One$id(patient))
					])),
			ac5: 1,
			y8: $author$project$Components$MovePaymentMethodsModal$Open(open),
			as: _List_Nil
		};
	});
var $author$project$Components$MovePaymentMethodsModal$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$PaymentMethodsMigrated = 0;
var $author$project$Components$MovePaymentMethodsModal$moveDefaultToOtherSource = function (paymentSources) {
	return A2(
		$elm$core$List$map,
		function (paymentSource) {
			return _Utils_update(
				paymentSource,
				{RI: false});
		},
		paymentSources);
};
var $author$project$Components$MovePaymentMethodsModal$appendPaymentsources = F2(
	function (sourcePaymentSources, destinationpaymentSources) {
		return A2(
			$elm$core$Maybe$map,
			function (sourcePaymentSources_) {
				return A2(
					$elm$core$Maybe$withDefault,
					sourcePaymentSources_,
					A2(
						$elm$core$Maybe$map,
						function (destinationpaymentSources_) {
							return A2(
								$elm$core$List$append,
								sourcePaymentSources_,
								$author$project$Components$MovePaymentMethodsModal$moveDefaultToOtherSource(destinationpaymentSources_));
						},
						destinationpaymentSources));
			},
			sourcePaymentSources);
	});
var $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var patient = field.a;
			return _Utils_update(
				fields,
				{VM: patient});
		} else {
			var bool = field.a;
			return _Utils_update(
				fields,
				{lq: bool});
		}
	});
var $author$project$Components$MovePaymentMethodsModal$PatientValidation = 0;
var $author$project$Components$MovePaymentMethodsModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.VM;
			},
			_Utils_Tuple2(0, 'Please pick a patient.'))
		]));
var $author$project$Api$Provider$PaymentMethod$Min$isDefault = function (_v0) {
	var record = _v0;
	return record.RI;
};
var $author$project$Api$Provider$PaymentMethod$Min$lastFour = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand = function (_v0) {
	var record = _v0;
	return record._f;
};
var $author$project$Components$MovePaymentMethodsModal$mapPaymentSourceAttributes = function (sources) {
	return A2(
		$elm$core$Maybe$map,
		function (sources_) {
			return A2(
				$elm$core$List$map,
				function (source_) {
					return {
						RI: $author$project$Api$Provider$PaymentMethod$Min$isDefault(source_),
						Sz: A2(
							$elm$core$Maybe$withDefault,
							'N/A',
							$author$project$Api$Provider$PaymentMethod$Min$lastFour(source_)),
						AJ: $author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(source_)
					};
				},
				sources_);
		},
		sources);
};
var $author$project$Components$MovePaymentMethodsModal$PaymentMethodsMoved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Patient$PaymentMethod$movePath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['migrate']),
		$author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId));
};
var $author$project$Api$Provider$Patient$PaymentMethod$migrate = F4(
	function (apiClient, patientId, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'to_patient_id',
					$elm$json$Json$Encode$string(params.ahy)),
					_Utils_Tuple2(
					'remove_sources_from_patient',
					$elm$json$Json$Encode$bool(params.agg))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$PaymentMethod$movePath(patientId))));
	});
var $author$project$Components$MovePaymentMethodsModal$movePaymentMethods = F3(
	function (apiClient, fromPatient, fields) {
		return A4(
			$author$project$Api$Provider$Patient$PaymentMethod$migrate,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(fromPatient),
			{
				agg: fields.lq,
				ahy: A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.adR;
						},
						fields.VM))
			},
			$author$project$Components$MovePaymentMethodsModal$PaymentMethodsMoved);
	});
var $author$project$Components$LimitedPatientSelector$Closed = {$: 2};
var $author$project$Components$LimitedPatientSelector$ItemSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LimitedPatientSelector$None = {$: 0};
var $author$project$Api$Provider$Patient$All$location = function (_v0) {
	var record = _v0.b;
	return record.aet;
};
var $author$project$Api$Provider$Patient$All$practitioner = function (_v0) {
	var record = _v0.b;
	return record.afS;
};
var $author$project$Api$Provider$Patient$All$usesTobacco = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
};
var $author$project$Components$LimitedPatientSelector$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A3($author$project$Components$LimitedPatientSelector$initPatientResourceFilter, apiClient, model.GC, model.VM);
				var patientResourceFilter = _v1.a;
				var patientResourceFilterCmd = _v1.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceFilterCmd),
					ac5: $author$project$Components$LimitedPatientSelector$None,
					y8: _Utils_update(
						model,
						{
							rU: $elm$core$Maybe$Just(patientResourceFilter)
						}),
					as: _List_Nil
				};
			case 1:
				var patientId = msg.a;
				var patient = A2(
					$elm_community$list_extra$List$Extra$find,
					function (patient_) {
						return _Utils_eq(patient_.adR, patientId);
					},
					model.Ap);
				var event = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None),
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeL, $author$project$Components$LimitedPatientSelector$ItemSelected, $author$project$Components$ResourceFilter$One),
						patient));
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: event,
					y8: _Utils_update(
						model,
						{
							VM: patient,
							aaN: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.adR;
								},
								patient)
						}),
					as: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v2 = model.rU;
				if (!_v2.$) {
					var patientResourceFilter = _v2.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, patientResourceFilter);
					var event = function () {
						var _v3 = patientResourceResult.ac5;
						if (_v3.$ === 1) {
							return $author$project$Components$LimitedPatientSelector$None;
						} else {
							if (_v3.a.$ === 1) {
								var _v4 = _v3.a;
								return $author$project$Components$LimitedPatientSelector$Closed;
							} else {
								switch (_v3.a.a.$) {
									case 0:
										var patient = _v3.a.a.a;
										var practitioner = A2(
											$elm$core$Maybe$map,
											function (practitioner_) {
												return {
													adR: $author$project$Api$Provider$Practitioner$Min$id(practitioner_),
													zh: $author$project$Api$Provider$Practitioner$Min$name(practitioner_)
												};
											},
											$author$project$Api$Provider$Patient$All$practitioner(patient));
										var location = A2(
											$elm$core$Maybe$map,
											function (location_) {
												return {
													adR: $author$project$Api$Provider$Location$Min$id(location_),
													zh: $author$project$Api$Provider$Location$Min$name(location_)
												};
											},
											$author$project$Api$Provider$Patient$All$location(patient));
										var resource = {
											IK: $author$project$Api$Provider$Patient$All$age(patient),
											adR: $author$project$Api$Provider$Patient$All$id(patient),
											aet: location,
											TL: $author$project$Api$Provider$Patient$All$membershipStatus(patient),
											zh: $author$project$Api$Provider$Patient$All$name(patient),
											afS: practitioner,
											aaI: $author$project$Api$Provider$Patient$All$usesTobacco(patient)
										};
										return $author$project$Components$LimitedPatientSelector$ItemSelected(
											$author$project$Components$ResourceFilter$One(resource));
									case 2:
										var _v5 = _v3.a.a;
										return $author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None);
									case 3:
										var _v6 = _v3.a.a;
										return $author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None);
									default:
										return $author$project$Components$LimitedPatientSelector$None;
								}
							}
						}
					}();
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{
								rU: $elm$core$Maybe$Just(patientResourceResult.y8)
							}),
						as: patientResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$LimitedPatientSelector$None, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$MovePaymentMethodsModal$updateForm = F4(
	function (model, apiClient, field, form) {
		var selectedPatientName = function () {
			if ((!field.$) && (!field.a.$)) {
				var patient = field.a.a;
				return $elm$core$Maybe$Just(patient.zh);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var selectedPatientId = function () {
			if ((!field.$) && (!field.a.$)) {
				var patient = field.a.a;
				return $elm$core$Maybe$Just(patient.adR);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate, field, form);
		var cmd = function () {
			if (!selectedPatientId.$) {
				var patientId = selectedPatientId.a;
				return A2($author$project$Components$MovePaymentMethodsModal$getPaymentSources, apiClient, patientId);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{PB: newForm, B4: selectedPatientId, B5: selectedPatientName}),
			cmd);
	});
var $author$project$Components$MovePaymentMethodsModal$update = F3(
	function (apiClient, msg, model) {
		if (model.$ === 1) {
			var open = model.a;
			switch (msg.$) {
				case 0:
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: $author$project$Components$MovePaymentMethodsModal$Closed, as: _List_Nil};
				case 2:
					var field = msg.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate, field, open.PB);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: $author$project$Components$MovePaymentMethodsModal$Open(
							_Utils_update(
								open,
								{PB: newForm})),
						as: _List_Nil
					};
				case 1:
					var subMsg = msg.a;
					var fields = $author$project$Utils$Form$fields(open.PB);
					var limitedPatientSelectorResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, fields.rd);
					var newForm = A2(
						$author$project$Utils$Form$set,
						_Utils_update(
							fields,
							{rd: limitedPatientSelectorResult.y8}),
						open.PB);
					var _v2 = function () {
						var _v3 = limitedPatientSelectorResult.ac5;
						_v3$2:
						while (true) {
							if (_v3.$ === 1) {
								switch (_v3.a.$) {
									case 0:
										var patient = _v3.a.a;
										return A4(
											$author$project$Components$MovePaymentMethodsModal$updateForm,
											open,
											apiClient,
											$author$project$Components$MovePaymentMethodsModal$Patient(
												$elm$core$Maybe$Just(patient)),
											newForm);
									case 3:
										var _v4 = _v3.a;
										return A4(
											$author$project$Components$MovePaymentMethodsModal$updateForm,
											open,
											apiClient,
											$author$project$Components$MovePaymentMethodsModal$Patient($elm$core$Maybe$Nothing),
											newForm);
									default:
										break _v3$2;
								}
							} else {
								break _v3$2;
							}
						}
						return _Utils_Tuple2(
							_Utils_update(
								open,
								{PB: newForm}),
							$elm$core$Platform$Cmd$none);
					}();
					var newModel = _v2.a;
					var formCmd = _v2.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg, limitedPatientSelectorResult.EC),
									formCmd
								])),
						ac5: 1,
						y8: $author$project$Components$MovePaymentMethodsModal$Open(newModel),
						as: limitedPatientSelectorResult.as
					};
				case 3:
					var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$MovePaymentMethodsModal$formFieldsValidator, open.PB);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						return {
							EC: A3($author$project$Components$MovePaymentMethodsModal$movePaymentMethods, apiClient, open.VM, fields),
							ac5: 1,
							y8: $author$project$Components$MovePaymentMethodsModal$Open(
								_Utils_update(
									open,
									{PB: newForm, rq: $author$project$Api$Data$Loading})),
							as: _List_Nil
						};
					} else {
						var newForm = _v5.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: $author$project$Components$MovePaymentMethodsModal$Open(
								_Utils_update(
									open,
									{PB: newForm})),
							as: _List_Nil
						};
					}
				case 4:
					var response = msg.a;
					switch (response.$) {
						case 3:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$MovePaymentMethodsModal$Closed,
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Payment sources migrated to new patient.')
									])
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 1,
								y8: $author$project$Components$MovePaymentMethodsModal$Open(
									_Utils_update(
										open,
										{rq: response})),
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: $author$project$Components$MovePaymentMethodsModal$Closed, as: _List_Nil};
					}
				default:
					var response = msg.a;
					switch (response.$) {
						case 3:
							var paymentSources = response.a;
							var maybePaymentMethods = $author$project$Components$MovePaymentMethodsModal$mapPaymentSourceAttributes(paymentSources);
							var paymentMethodsList = A2($author$project$Components$MovePaymentMethodsModal$appendPaymentsources, open.eh, maybePaymentMethods);
							var currentOwnerPaymentMethods = open.yh ? maybePaymentMethods : open.eh;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 1,
								y8: $author$project$Components$MovePaymentMethodsModal$Open(
									_Utils_update(
										open,
										{yh: false, eh: currentOwnerPaymentMethods, jp: paymentMethodsList})),
								as: _List_Nil
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 1,
								y8: $author$project$Components$MovePaymentMethodsModal$Open(open),
								as: _List_Nil
							};
						default:
							return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: $author$project$Components$MovePaymentMethodsModal$Closed, as: _List_Nil};
					}
			}
		} else {
			return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
		}
	});
var $author$project$Api$Provider$VirtualBankAccount$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$VirtualBankAccounts$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{DL: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var field = msg.a;
				var copiedText = msg.b;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(copiedText),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, field + ' copied to clipboard')
						]));
			default:
				var virtualBankAccount = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2(
							$author$project$OutMsg$ShowToast,
							1,
							'Unimplemented action ' + $author$project$Api$Provider$VirtualBankAccount$Shared$id(virtualBankAccount))
						]));
		}
	});
var $author$project$Api$Provider$Patient$updateAutopay = F4(
	function (apiClient, id_, autopay_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'autopay',
								$elm$json$Json$Encode$bool(autopay_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$updateExemptFromCreditCardFees = F4(
	function (apiClient, id_, autopay_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'exempt_from_credit_card_fees',
								$elm$json$Json$Encode$bool(autopay_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Components$PaymentSources$Updated = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Employer$BankAccount$update = F5(
	function (basePath, apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'bank_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$BankAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_))));
	});
var $author$project$Api$Provider$BankAccount$update = F5(
	function (basePath, apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'bank_account',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$BankAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_))));
	});
var $author$project$Api$BankAccount$update = F6(
	function (basePath, apiClient, session, bankAccount, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$BankAccount$update,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$BankAccount$EmployerOne))) : A5(
			$author$project$Api$Provider$BankAccount$update,
			basePath,
			apiClient,
			$author$project$Api$BankAccount$id(bankAccount),
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$BankAccount$ProviderOne)));
	});
var $author$project$Api$Employer$Card$update = F5(
	function (basePath, apiClient, id_, fields, toMsg) {
		var zipCode = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$pair('zip'),
						$elm$core$List$singleton)),
				fields.tC));
		var label = _List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aej))
			]);
		var expYear = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$pair('exp_year'),
							$elm$core$List$singleton))),
				fields.ada));
		var expMonth = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$pair('exp_month'),
							$elm$core$List$singleton))),
				fields.ac9));
		var cardObject = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[label, expMonth, expYear, zipCode])));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('card', cardObject)
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Employer$Card$cardPath, basePath, id_))));
	});
var $author$project$Api$Provider$Card$update = F5(
	function (basePath, apiClient, id_, fields, toMsg) {
		var zipCode = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$pair('zip'),
						$elm$core$List$singleton)),
				fields.tC));
		var label = _List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aej))
			]);
		var expYear = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$pair('exp_year'),
							$elm$core$List$singleton))),
				fields.ada));
		var expMonth = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$fromInt,
					A2(
						$elm$core$Basics$composeR,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$pair('exp_month'),
							$elm$core$List$singleton))),
				fields.ac9));
		var cardObject = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[label, expMonth, expYear, zipCode])));
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('card', cardObject)
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Card$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Card$cardPath, basePath, id_))));
	});
var $author$project$Api$Card$update = F6(
	function (basePath, apiClient, session, card, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$Card$update,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A5(
			$author$project$Api$Provider$Card$update,
			basePath,
			apiClient,
			$author$project$Api$Card$id(card),
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
	});
var $author$project$Api$Source$update = F6(
	function (basePath, apiClient, session, source, fields, toMsg) {
		switch (source.$) {
			case 0:
				var card = source.a;
				var cardFields = {
					ac9: A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.ac9;
						},
						fields.Et),
					ada: A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.ada;
						},
						fields.Et),
					aej: fields.aej,
					tC: A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.tC;
						},
						fields.Et)
				};
				return A6(
					$author$project$Api$Card$update,
					basePath,
					apiClient,
					session,
					card,
					cardFields,
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$author$project$Api$Data$map($author$project$Api$Source$Card)));
			case 1:
				var bankAccount = source.a;
				var onlyLabel = function (f) {
					return {aej: f.aej};
				}(fields);
				return A6(
					$author$project$Api$BankAccount$update,
					basePath,
					apiClient,
					session,
					bankAccount,
					onlyLabel,
					A2(
						$elm$core$Basics$composeL,
						toMsg,
						$author$project$Api$Data$map($author$project$Api$Source$BankAccount)));
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$PaymentSources$updateSource = F5(
	function (basePath, apiClient, session, source, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A6($author$project$Api$Source$update, basePath, apiClient, session, source, fields, $author$project$Components$PaymentSources$Updated);
	});
var $author$project$Components$PaymentSources$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 9:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pN: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pD: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 10:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{AL: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 17:
				var patientId = msg.a;
				var toggle = msg.b;
				var cmd = A4($author$project$Api$Provider$Patient$updateExemptFromCreditCardFees, apiClient, patientId, toggle, $author$project$Components$PaymentSources$PatientUpdated);
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 16:
				var patientId = msg.a;
				var toggle = msg.b;
				var cmd = A4($author$project$Api$Provider$Patient$updateAutopay, apiClient, patientId, toggle, $author$project$Components$PaymentSources$PatientUpdated);
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 15:
				var response = msg.a;
				switch (response.$) {
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					case 3:
						var patient = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									G0: $author$project$Components$PaymentSources$Patient(patient)
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(patient))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var source = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Hg: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									source,
									$author$project$Utils$Form$init(
										$author$project$Components$PaymentSources$formFieldsFromSource(source)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var field = msg.a;
				var _v3 = model.Hg;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var source = _v4.a;
					var form = _v4.b;
					var saveRequest = _v4.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$PaymentSources$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Hg: $elm$core$Maybe$Just(
									_Utils_Tuple3(source, newForm, saveRequest))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Hg: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var _v5 = model.Hg;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var source = _v6.a;
					var form = _v6.b;
					var formValidator = $author$project$Components$PaymentSources$formFieldsValidator(model.cO);
					var _v7 = A2($author$project$Utils$Form$validate, formValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var newForm = _v8.a;
						var validFormFields = _v8.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Hg: $elm$core$Maybe$Just(
										_Utils_Tuple3(source, newForm, $author$project$Api$Data$Loading))
								}),
							A5($author$project$Components$PaymentSources$updateSource, model.vD, apiClient, model.ZD, source, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Hg: $elm$core$Maybe$Just(
										_Utils_Tuple3(source, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var response = msg.a;
				var _v9 = model.Hg;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var source = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var _v12 = A4($author$project$Components$PaymentSources$loadData, model.vD, apiClient, model.ZD, model.G0);
						var cards = _v12.a;
						var bankAccounts = _v12.b;
						var cmd = _v12.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{pD: bankAccounts, pN: cards, Hg: $elm$core$Maybe$Nothing}),
							cmd,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Source successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Hg: $elm$core$Maybe$Just(
										_Utils_Tuple3(source, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var source = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fr: $elm$core$Maybe$Nothing,
							aw: A2(
								$elm$core$Set$insert,
								$author$project$Api$Source$id(source),
								model.aw)
						}),
					A6(
						$author$project$Api$Source$updateDefault,
						model.vD,
						apiClient,
						model.ZD,
						source,
						$elm$core$Maybe$Nothing,
						$author$project$Components$PaymentSources$MadeDefault(
							$author$project$Api$Source$id(source))),
					_List_Nil);
			case 12:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						var _v14 = A4($author$project$Components$PaymentSources$loadData, model.vD, apiClient, model.ZD, model.G0);
						var cards = _v14.a;
						var bankAccounts = _v14.b;
						var cmd = _v14.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									pD: bankAccounts,
									pN: cards,
									aw: A2($elm$core$Set$remove, id, model.aw)
								}),
							cmd,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Default source successfully updated.')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aw: A2($elm$core$Set$remove, id, model.aw)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var source = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fr: $elm$core$Maybe$Just(source)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var source = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fr: $elm$core$Maybe$Nothing,
							aw: A2(
								$elm$core$Set$insert,
								$author$project$Api$Source$id(source),
								model.aw)
						}),
					A5(
						$author$project$Api$Source$delete,
						model.vD,
						apiClient,
						model.ZD,
						source,
						$author$project$Components$PaymentSources$Deleted(source)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{fr: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var source = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						var retrieveOutMsg = function () {
							var _v17 = model.G0;
							if (_v17.$ === 1) {
								var patient = _v17.a;
								return _List_fromArray(
									[
										$author$project$OutMsg$RetrievePatient(
										$author$project$Api$Provider$Patient$One$id(patient))
									]);
							} else {
								return _List_Nil;
							}
						}();
						var _v16 = A4($author$project$Components$PaymentSources$loadData, model.vD, apiClient, model.ZD, model.G0);
						var cards = _v16.a;
						var bankAccounts = _v16.b;
						var cmd = _v16.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									pD: bankAccounts,
									pN: cards,
									aw: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.aw)
								}),
							cmd,
							A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 3, 'Source successfully deleted'),
								retrieveOutMsg));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aw: A2(
										$elm$core$Set$remove,
										$author$project$Api$Source$id(source),
										model.aw)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var createPaymentMethodModalResult = A3($author$project$Components$CreatePaymentMethodModal$update, apiClient, subMsg, model.lB);
				var _v18 = function () {
					var _v19 = createPaymentMethodModalResult.ac5;
					if (!_v19) {
						return A4($author$project$Components$PaymentSources$loadData, model.vD, apiClient, model.ZD, model.G0);
					} else {
						return _Utils_Tuple3(model.pN, model.pD, $elm$core$Platform$Cmd$none);
					}
				}();
				var cards = _v18.a;
				var bankAccounts = _v18.b;
				var cmd = _v18.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pD: bankAccounts, pN: cards, lB: createPaymentMethodModalResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg, createPaymentMethodModalResult.EC),
								cmd
							])),
					createPaymentMethodModalResult.as);
			case 5:
				var subMsg = msg.a;
				var _v20 = A2($author$project$Ui$NewDropdown$update, subMsg, model.rp);
				var dropdownMenu = _v20.a;
				var cmd = _v20.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rp: dropdownMenu}),
					cmd,
					_List_Nil);
			case 14:
				var subMsg = msg.a;
				var movePaymentMethodsModalResult = A3($author$project$Components$MovePaymentMethodsModal$update, apiClient, subMsg, model.f6);
				var _v21 = function () {
					var _v22 = movePaymentMethodsModalResult.ac5;
					if (!_v22) {
						return A4($author$project$Components$PaymentSources$loadData, model.vD, apiClient, model.ZD, model.G0);
					} else {
						return _Utils_Tuple3(model.pN, model.pD, $elm$core$Platform$Cmd$none);
					}
				}();
				var cards = _v21.a;
				var bankAccounts = _v21.b;
				var cmd = _v21.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pD: bankAccounts, pN: cards, f6: movePaymentMethodsModalResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg, movePaymentMethodsModalResult.EC),
								cmd
							])),
					movePaymentMethodsModalResult.as);
			case 0:
				var subMsg = msg.a;
				var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, model.hy);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hy: auditTrailLogResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$AuditTrailLogMsg, auditTrailLogResult.EC),
					auditTrailLogResult.as);
			case 20:
				var subMsg = msg.a;
				var _v23 = function () {
					var _v24 = model.tx;
					if (!_v24.$) {
						var virtualBankAccountsComponent_ = _v24.a;
						var _v25 = A2($author$project$Components$VirtualBankAccounts$update, subMsg, virtualBankAccountsComponent_);
						var virtualModel_ = _v25.a;
						var virtualCmd_ = _v25.b;
						var virtualOutMsgs_ = _v25.c;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(virtualModel_),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg, virtualCmd_),
							virtualOutMsgs_);
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}();
				var model_ = _v23.a;
				var cmd_ = _v23.b;
				var outMsgs_ = _v23.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tx: model_}),
					cmd_,
					outMsgs_);
			case 21:
				var patient = msg.a;
				var result = A4($author$project$Components$MovePaymentMethodsModal$openAndInit, apiClient, model.vD, model.ZD, patient);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f6: result.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg, result.EC),
					result.as);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f6: $author$project$Components$MovePaymentMethodsModal$close(model.f6)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PaymentSources$update, model.D5, subMsg, model.rh);
		var paymentSources = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: paymentSources}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$MovePaymentMethodsModal$Checkbox = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$Close = {$: 0};
var $author$project$Components$MovePaymentMethodsModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$MovePaymentMethodsModal$MovePaymentMethods = {$: 3};
var $author$project$Components$MovePaymentMethodsModal$countPaymentSources = F2(
	function (model, patientId) {
		var paymentSources = _Utils_eq(
			patientId,
			$author$project$Api$Provider$Patient$One$id(model.VM)) ? model.eh : model.jp;
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$List$length, paymentSources));
	});
var $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource = function (paymentSources) {
	return A2(
		$elm$core$List$filter,
		function (paymentSource_) {
			return paymentSource_.RI;
		},
		paymentSources);
};
var $author$project$Components$MovePaymentMethodsModal$displayDefaultSource = F2(
	function (model, patientId) {
		var defaultSource = function () {
			if (_Utils_eq(
				patientId,
				$author$project$Api$Provider$Patient$One$id(model.VM))) {
				var _v0 = model.eh;
				if (!_v0.$) {
					var paymentSource_ = _v0.a;
					return $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource(paymentSource_);
				} else {
					return _List_Nil;
				}
			} else {
				var _v1 = model.jp;
				if (!_v1.$) {
					var paymentSource_ = _v1.a;
					return $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource(paymentSource_);
				} else {
					return _List_Nil;
				}
			}
		}();
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-align-left')
				]),
			A2(
				$elm$core$List$map,
				function (source_) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(source_.AJ + ' ')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(source_.Sz)
									]))
							]));
				},
				defaultSource));
	});
var $author$project$Components$MovePaymentMethodsModal$displayNoBulletSources = F2(
	function (model, patientId) {
		var paymentSources = _Utils_eq(
			patientId,
			$author$project$Api$Provider$Patient$One$id(model.VM)) ? model.eh : model.jp;
		var paymentSource = A2(
			$elm$core$Maybe$andThen,
			function (sources) {
				return $elm$core$List$head(sources);
			},
			paymentSources);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if (!paymentSource.$) {
						var paymentSource_ = paymentSource.a;
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(paymentSource_.AJ + ' ')
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(paymentSource_.Sz)
										]))
								]));
					} else {
						return $elm$html$Html$text('');
					}
				}()
				]));
	});
var $author$project$Components$MovePaymentMethodsModal$otherPaymentSources = function (paymentSources) {
	return A2(
		$elm$core$List$filter,
		function (paymentSource_) {
			return !paymentSource_.RI;
		},
		paymentSources);
};
var $author$project$Components$MovePaymentMethodsModal$displayOtherSources = F2(
	function (model, patientId) {
		var otherSources = function () {
			if (_Utils_eq(
				patientId,
				$author$project$Api$Provider$Patient$One$id(model.VM))) {
				var _v0 = model.eh;
				if (!_v0.$) {
					var paymentSource_ = _v0.a;
					return $author$project$Components$MovePaymentMethodsModal$otherPaymentSources(paymentSource_);
				} else {
					return _List_Nil;
				}
			} else {
				var _v1 = model.jp;
				if (!_v1.$) {
					var paymentSource_ = _v1.a;
					return $author$project$Components$MovePaymentMethodsModal$otherPaymentSources(paymentSource_);
				} else {
					return _List_Nil;
				}
			}
		}();
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('list-align-left')
				]),
			A2(
				$elm$core$List$map,
				function (source_) {
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(source_.AJ + ' ')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(source_.Sz)
									]))
							]));
				},
				otherSources));
	});
var $author$project$Components$MovePaymentMethodsModal$showTextIf = F2(
	function (isTrue, htmlMsg) {
		return isTrue ? htmlMsg : $elm$html$Html$text('');
	});
var $author$project$Components$MovePaymentMethodsModal$displayPaymentSources = F2(
	function (model, patientId) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1,
					$elm$html$Html$text('Default Source:')),
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1,
					A2($author$project$Components$MovePaymentMethodsModal$displayDefaultSource, model, patientId)),
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) === 1,
					A2($author$project$Components$MovePaymentMethodsModal$displayNoBulletSources, model, patientId)),
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1,
					$elm$html$Html$text('Payment Sources:')),
					A2(
					$author$project$Components$MovePaymentMethodsModal$showTextIf,
					A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1,
					A2($author$project$Components$MovePaymentMethodsModal$displayOtherSources, model, patientId))
				]));
	});
var $author$project$Components$LimitedPatientSelector$Errors = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LimitedPatientSelector$errors = $author$project$Components$LimitedPatientSelector$Errors;
var $author$project$Components$LimitedPatientSelector$Invalid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$LimitedPatientSelector$invalid = $author$project$Components$LimitedPatientSelector$Invalid;
var $author$project$Components$LimitedPatientSelector$FindAnotherPatient = {$: 0};
var $author$project$Components$LimitedPatientSelector$PatientSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$LimitedPatientSelector$defaultOptions = {fE: _List_Nil, q$: false};
var $author$project$Components$LimitedPatientSelector$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var bool = option.a;
					return _Utils_update(
						record,
						{q$: bool});
				} else {
					var list = option.a;
					return _Utils_update(
						record,
						{fE: list});
				}
			}),
		$author$project$Components$LimitedPatientSelector$defaultOptions,
		options);
};
var $author$project$Components$LimitedPatientSelector$patientOptions = function (patients) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose a patient'),
		A2(
			$elm$core$List$map,
			function (patient) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(patient.adR),
					patient.zh);
			},
			patients));
};
var $author$project$Components$LimitedPatientSelector$view = F2(
	function (options, model) {
		var optionsRecord = $author$project$Components$LimitedPatientSelector$optionsToRecord(options);
		var _v0 = model.rU;
		if (!_v0.$) {
			var patientResourceFilter = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Patient$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$invalid(optionsRecord.q$),
							$author$project$Components$ResourceFilter$errors(optionsRecord.fE)
						]),
					patientResourceFilter));
		} else {
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(model.aaN),
								$author$project$Ui$Form$Select$onChange($author$project$Components$LimitedPatientSelector$PatientSelected),
								$author$project$Ui$Form$Select$invalid(optionsRecord.q$),
								$author$project$Ui$Form$Select$errors(optionsRecord.fE)
							]),
						$author$project$Components$LimitedPatientSelector$patientOptions(model.Ap)),
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[$author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text(' or '),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Find another patient'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$onClick($author$project$Components$LimitedPatientSelector$FindAnotherPatient)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Find another patient')
									]))
							]))
					]));
		}
	});
var $author$project$Components$MovePaymentMethodsModal$viewMovePaymentMethodsModal = function (open) {
	var selectedPatientId = A2($elm$core$Maybe$withDefault, '', open.B4);
	var fields = $author$project$Utils$Form$fields(open.PB);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(true),
				$author$project$Ui$Form$onSubmit($author$project$Components$MovePaymentMethodsModal$MovePaymentMethods)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$MovePaymentMethodsModal$Close,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Move Payment Methods to Another Patient')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9),
												$author$project$Ui$Form$Group$label('New Owner'),
												$author$project$Ui$Form$Group$required(true)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg,
												A2(
													$author$project$Components$LimitedPatientSelector$view,
													_List_fromArray(
														[
															$author$project$Components$LimitedPatientSelector$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, open.PB)),
															$author$project$Components$LimitedPatientSelector$errors(
															A2($author$project$Utils$Form$validationErrors, 0, open.PB))
														]),
													fields.rd)),
												A2(
												$author$project$Ui$Form$Checkbox$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Checkbox$value(fields.lq),
														$author$project$Ui$Form$Checkbox$onCheck(
														A2($elm$core$Basics$composeL, $author$project$Components$MovePaymentMethodsModal$FormUpdated, $author$project$Components$MovePaymentMethodsModal$Checkbox))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Remove payment methods from current patient')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-50')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$FlexGrid$column,
														_List_fromArray(
															[
																$author$project$Ui$FlexGrid$spanSm(6)
															]),
														_List_fromArray(
															[
																(A2(
																$author$project$Components$MovePaymentMethodsModal$countPaymentSources,
																open,
																$author$project$Api$Provider$Patient$One$id(open.VM)) > 0) ? A2(
																$author$project$Ui$Typography$div,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$span,
																		_List_fromArray(
																			[$author$project$Ui$Typography$gray]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('From ')
																			])),
																		A2(
																		$author$project$Ui$Typography$span,
																		_List_fromArray(
																			[$author$project$Ui$Typography$gray, $author$project$Ui$Typography$bold]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Api$Provider$Patient$One$name(open.VM))
																			]))
																	])) : $elm$html$Html$text(''),
																fields.lq ? A2(
																$author$project$Ui$Typography$div,
																_List_fromArray(
																	[$author$project$Ui$Typography$danger, $author$project$Ui$Typography$strike]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Components$MovePaymentMethodsModal$displayPaymentSources,
																		open,
																		$author$project$Api$Provider$Patient$One$id(open.VM))
																	])) : A2(
																$author$project$Ui$Typography$div,
																_List_fromArray(
																	[$author$project$Ui$Typography$danger]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Components$MovePaymentMethodsModal$displayPaymentSources,
																		open,
																		$author$project$Api$Provider$Patient$One$id(open.VM))
																	]))
															])),
														A2(
														$author$project$Ui$FlexGrid$column,
														_List_fromArray(
															[
																$author$project$Ui$FlexGrid$spanSm(6)
															]),
														_List_fromArray(
															[
																((!$elm$core$String$isEmpty(selectedPatientId)) && ((A2(
																$author$project$Components$MovePaymentMethodsModal$countPaymentSources,
																open,
																$author$project$Api$Provider$Patient$One$id(open.VM)) > 0) && (A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, open, selectedPatientId) > 0))) ? A2(
																$author$project$Ui$Typography$div,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$span,
																		_List_fromArray(
																			[$author$project$Ui$Typography$gray]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('To ')
																			])),
																		function () {
																		var selectedPatientName = A2($elm$core$Maybe$withDefault, '', open.B5);
																		return A2(
																			$author$project$Ui$Typography$span,
																			_List_fromArray(
																				[$author$project$Ui$Typography$gray, $author$project$Ui$Typography$bold]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(selectedPatientName)
																				]));
																	}()
																	])) : $author$project$Utils$Html$empty,
																$elm$core$String$isEmpty(selectedPatientId) ? $author$project$Utils$Html$empty : A2(
																$author$project$Ui$Typography$div,
																_List_fromArray(
																	[$author$project$Ui$Typography$success]),
																_List_fromArray(
																	[
																		A2($author$project$Components$MovePaymentMethodsModal$displayPaymentSources, open, selectedPatientId)
																	]))
															]))
													]))
											]))
									]))
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$MovePaymentMethodsModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Confirm'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$loading(
										_Utils_eq(open.rq, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Confirm')
									]))
							]))
					]))
			]));
};
var $author$project$Components$MovePaymentMethodsModal$modal = function (model) {
	if (model.$ === 1) {
		var open = model.a;
		return $author$project$Components$MovePaymentMethodsModal$viewMovePaymentMethodsModal(open);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Element$mt1 = $author$project$Ui$Element$Margin('mt-1');
var $author$project$Components$PaymentSourceDisplayer$skeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('VISA *4242')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Added mm/dd/YYYY, expires mm/dd/YYYY')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Maually added by someone')
						]))
				]))
		]));
var $author$project$Components$VirtualBankAccounts$loadFromData = function (model) {
	var _v0 = model.DL;
	if (_v0.$ === 3) {
		var virtualBankAccounts_ = _v0.a;
		return virtualBankAccounts_;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$VirtualBankAccounts$TransactionHistory = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$balanceInCents = function (_v0) {
	var record = _v0;
	return record.abw;
};
var $author$project$Api$Provider$VirtualBankAccount$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Components$VirtualBankAccounts$CopyToClipboard = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$VirtualBankAccounts$viewVirtualBankAccountBox = function (virtualBankAccount) {
	return A3(
		$author$project$Ui$Alert$view,
		1,
		_List_fromArray(
			[
				$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
				$author$project$Ui$Alert$margin(25)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Bank Name')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(10)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$black,
												$author$project$Ui$Typography$margin(25)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(virtualBankAccount)),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Copy Bank Name'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
														$author$project$Ui$Button$onClick(
														A2(
															$author$project$Components$VirtualBankAccounts$CopyToClipboard,
															'Bank Name',
															$author$project$Api$Provider$VirtualBankAccount$Shared$swiftBankName(virtualBankAccount)))
													]),
												_List_Nil)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Routing Number')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(10)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$black,
												$author$project$Ui$Typography$margin(25)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(virtualBankAccount)),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Copy Routing Number'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
														$author$project$Ui$Button$onClick(
														A2(
															$author$project$Components$VirtualBankAccounts$CopyToClipboard,
															'Routing Number',
															$author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(virtualBankAccount)))
													]),
												_List_Nil)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Account Number')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(10)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$black,
												$author$project$Ui$Typography$margin(25)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber(virtualBankAccount)),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Copy Account Number'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
														$author$project$Ui$Button$onClick(
														A2(
															$author$project$Components$VirtualBankAccounts$CopyToClipboard,
															'Account Number',
															$author$project$Api$Provider$VirtualBankAccount$Shared$swiftAccountNumber(virtualBankAccount)))
													]),
												_List_Nil)
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('SWIFT code')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(10)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$black,
												$author$project$Ui$Typography$margin(25)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(virtualBankAccount)),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Copy SWIFT Code'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
														$author$project$Ui$Button$onClick(
														A2(
															$author$project$Components$VirtualBankAccounts$CopyToClipboard,
															'Swift Code',
															$author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(virtualBankAccount)))
													]),
												_List_Nil)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$VirtualBankAccounts$viewVirtualBankAccount = F2(
	function (timeFormatter, virtualBankAccount) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inline')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Formatters$String$titleize(
																$author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(virtualBankAccount)))
														]))
												])),
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													' (Account Balance: ' + ($author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$VirtualBankAccount$Shared$balanceInCents(virtualBankAccount)) + ')'))
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'View transaction history'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$VirtualBankAccounts$TransactionHistory(virtualBankAccount))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Transaction History')
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Added ' + A2(
														timeFormatter,
														5,
														$author$project$Api$Provider$VirtualBankAccount$Shared$createdAt(virtualBankAccount)))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('TRANSFER INSTRUCTIONS')
												]))
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$black]),
											_List_fromArray(
												[
													$elm$html$Html$text('To pay via Bank Transfer, transer funds using the following bank information. Bank Transfers can take up to five business days.')
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(12)
								]),
							_List_fromArray(
								[
									$author$project$Components$VirtualBankAccounts$viewVirtualBankAccountBox(virtualBankAccount)
								]))
						]))
				]));
	});
var $author$project$Components$VirtualBankAccounts$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$ListGroup$view,
		_List_Nil,
		A2(
			$elm$core$List$map,
			$author$project$Components$VirtualBankAccounts$viewVirtualBankAccount(model.Hy),
			$author$project$Components$VirtualBankAccounts$loadFromData(model)));
};
var $author$project$Components$PaymentSources$viewAuditTrailLog = function (model) {
	var _v0 = model.G0;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$ml2]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$PaymentSources$AuditTrailLogMsg,
						$author$project$Components$AuditTrailLog$view(model.hy))
					]))
			]);
	} else {
		return _List_fromArray(
			[$author$project$Utils$Html$empty]);
	}
};
var $author$project$Api$Employer$Company$One$invoiceAutoPay = function (_v0) {
	var record = _v0.b;
	return record.Rk;
};
var $author$project$Api$Provider$Company$One$invoiceAutoPay = function (_v0) {
	var record = _v0.b;
	return record.Rk;
};
var $author$project$Api$Company$invoiceAutoPay = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoPay(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoPay(company_);
	}
};
var $author$project$Components$PaymentSources$viewCompanyAutopay = F3(
	function (model, company, organizationIsCompany) {
		var _v0 = $author$project$Api$Company$invoiceAutoPay(company) ? _Utils_Tuple2('On', ' Disable Autopay to stop automated payment collection on upcoming invoices.') : _Utils_Tuple2('Off', '');
		var disableAutoPayToggleText = _v0.a;
		var disableAutoPayText = _v0.b;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(10)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Autopay')
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? $elm$html$Html$text(
									$elm$core$String$concat(
										_List_fromArray(
											['Automatically process payment for issued invoices on their due date.', disableAutoPayText]))) : $elm$html$Html$text('If set, we will automatically try to process a payment for the invoice on its due date.')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(2),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(disableAutoPayToggleText)
										]))
								])),
							organizationIsCompany ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings(
								{
									ff: $author$project$Api$Company$id(company)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Manage invoice settings')
								]))
						]))
				]));
	});
var $author$project$Components$PaymentSources$TogglePatientAutopay = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$Shared$autopay = function (_v0) {
	var shared = _v0;
	return shared.JI;
};
var $author$project$Api$Provider$Patient$One$autopay = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$autopay(shared);
};
var $author$project$Components$PaymentSources$viewPatientAutopay = F2(
	function (practice, patient) {
		var _v0 = function () {
			if ($author$project$Api$Provider$Patient$One$autopay(patient)) {
				var multipleMembershipsText = $author$project$Api$Practice$allowMultipleRetailMemberships(practice) ? ' To set a different payment method for a specific membership, update it from the Memberships tab under Pricing.' : '';
				return _Utils_Tuple2('Automated payments collection will be attempted.', 'Disable Autopay to stop automated payment collection on upcoming invoices.' + multipleMembershipsText);
			} else {
				return _Utils_Tuple2('No automated payments collection will be attempted.', 'Enable Autopay to start automated payment collection on upcoming invoices.');
			}
		}();
		var autoPayText = _v0.a;
		var toggleAutoPayText = _v0.b;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(10)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Autopay')
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$concat(
										_List_fromArray(
											[autoPayText, ' ', toggleAutoPayText])))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(2),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(
									$author$project$Api$Provider$Patient$One$autopay(patient)),
									$author$project$Ui$ToggleSwitch$onChange(
									$author$project$Components$PaymentSources$TogglePatientAutopay(
										$author$project$Api$Provider$Patient$One$id(patient)))
								]))
						]))
				]));
	});
var $author$project$Components$PaymentSources$viewAutopay = function (model) {
	var _v0 = model.G0;
	if (!_v0.$) {
		var company = _v0.a;
		return _List_fromArray(
			[
				A3(
				$author$project$Components$PaymentSources$viewCompanyAutopay,
				model,
				company,
				$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD))
			]);
	} else {
		var patient = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Components$PaymentSources$viewPatientAutopay, model.WF, patient)
			]);
	}
};
var $author$project$Components$PaymentSources$TogglePatientExemptFromCreditCardFees = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$One$exemptFromCreditCardFees = function (_v0) {
	var record = _v0.b;
	return record.OS;
};
var $author$project$Components$PaymentSources$viewExemptFromCreditCardFees = function (model) {
	var showToggle = function () {
		var _v1 = model.WF;
		if (!_v1.$) {
			var practice = _v1.a;
			return $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice);
		} else {
			return false;
		}
	}();
	var _v0 = _Utils_Tuple2(model.G0, showToggle);
	if ((_v0.a.$ === 1) && _v0.b) {
		var patient = _v0.a.a;
		var exemptText = 'When enabled, this patient will not be charged credit card fees, even if they pay with a credit card.';
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Exclude this patient from credit card surcharge')
									])),
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$concat(
											_List_fromArray(
												[exemptText, ' '])))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(2),
								$author$project$Ui$FlexGrid$justifyRight
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(
										$author$project$Api$Provider$Patient$One$exemptFromCreditCardFees(patient)),
										$author$project$Ui$ToggleSwitch$onChange(
										$author$project$Components$PaymentSources$TogglePatientExemptFromCreditCardFees(
											$author$project$Api$Provider$Patient$One$id(patient)))
									]))
							]))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Icon$Copy = 57;
var $author$project$Components$PaymentSources$OpenMovePaymentMethodsModal = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$PaymentSources$viewMoreActionsDowndown = F2(
	function (model, sources) {
		var _v0 = model.G0;
		if (!_v0.$) {
			return _List_Nil;
		} else {
			var patient = _v0.a;
			var canMigrate = function () {
				var _v1 = model.AL;
				if (_v1.$ === 3) {
					var paymentSourcesMigratable = _v1.a;
					return paymentSourcesMigratable;
				} else {
					return false;
				}
			}();
			return ((!$elm$core$List$isEmpty(sources)) && canMigrate) ? $elm$core$List$singleton(
				A4(
					$author$project$Ui$NewDropdown$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Other Actions')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$PaymentSources$OpenMovePaymentMethodsModal(patient))
								]),
							A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 57),
										$author$project$Utils$Html$noBreakSpace,
										$elm$html$Html$text('Move All Payment Methods to Another Patient')
									])))
						]),
					model.rp)) : _List_Nil;
		}
	});
var $author$project$Api$Employer$BankAccount$One$default = function (_v0) {
	var record = _v0.b;
	return record.M5;
};
var $author$project$Api$Employer$BankAccount$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$BankAccount$One$default(one);
};
var $author$project$Api$Provider$BankAccount$One$default = function (_v0) {
	var record = _v0.b;
	return record.M5;
};
var $author$project$Api$Provider$BankAccount$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$BankAccount$One$default(one);
};
var $author$project$Api$BankAccount$default = function (bankAccount) {
	switch (bankAccount.$) {
		case 0:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$One$default(bankAccount_);
		case 1:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Provider$BankAccount$All$default(bankAccount_);
		case 2:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$One$default(bankAccount_);
		default:
			var bankAccount_ = bankAccount.a;
			return $author$project$Api$Employer$BankAccount$All$default(bankAccount_);
	}
};
var $author$project$Api$Employer$Card$One$default = function (_v0) {
	var record = _v0.b;
	return record.M5;
};
var $author$project$Api$Employer$Card$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Employer$Card$One$default(one);
};
var $author$project$Api$Provider$Card$One$default = function (_v0) {
	var record = _v0.b;
	return record.M5;
};
var $author$project$Api$Provider$Card$All$default = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Card$One$default(one);
};
var $author$project$Api$Card$default = function (card) {
	switch (card.$) {
		case 0:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$One$default(card_);
		case 1:
			var card_ = card.a;
			return $author$project$Api$Provider$Card$All$default(card_);
		case 2:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$One$default(card_);
		default:
			var card_ = card.a;
			return $author$project$Api$Employer$Card$All$default(card_);
	}
};
var $author$project$Api$Source$default = function (source) {
	switch (source.$) {
		case 0:
			var card = source.a;
			return $author$project$Api$Card$default(card);
		case 1:
			var bankAccount = source.a;
			return $author$project$Api$BankAccount$default(bankAccount);
		default:
			return false;
	}
};
var $author$project$Components$PaymentSources$viewNoDefaultSourceWarning = F2(
	function (resource, sources) {
		if (resource.$ === 1) {
			var patient = resource.a;
			var hasNoDefaultSource = (!$elm$core$List$isEmpty(sources)) && $elm$core$List$isEmpty(
				A2(
					$elm$core$List$filter,
					function (source) {
						return $author$project$Api$Source$default(source);
					},
					sources));
			return ($author$project$Api$Provider$Patient$One$autopay(patient) && hasNoDefaultSource) ? A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Alert$warning,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('There is no default payment source on file. '),
												$elm$html$Html$text('Please select a default payment method or turn off auto pay.')
											]))
									]))
							]))
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$PaymentSources$Delete = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentSources$Edit = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PaymentSources$MakeDefault = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$PatientId = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$patientId = $author$project$Components$PaymentSourceDisplayer$PatientId;
var $author$project$Components$PaymentSourceDisplayer$ShowAssignedMemberships = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$PaymentSourceDisplayer$showAssignedMemberships = $author$project$Components$PaymentSourceDisplayer$ShowAssignedMemberships;
var $author$project$Components$PaymentSources$viewSource = F6(
	function (timeFormatter, isHintAdmin, updatingSources, practice, maybePatientId, source) {
		var loading = A2(
			$elm$core$Set$member,
			$author$project$Api$Source$id(source),
			updatingSources);
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$PaymentSourceDisplayer$view,
									timeFormatter,
									_List_fromArray(
										[
											$author$project$Components$PaymentSourceDisplayer$source(
											$elm$core$Maybe$Just(source)),
											$author$project$Components$PaymentSourceDisplayer$showProcessor(isHintAdmin),
											$author$project$Components$PaymentSourceDisplayer$showAssignedMemberships(
											$author$project$Api$Practice$allowMultipleRetailMemberships(practice)),
											$author$project$Components$PaymentSourceDisplayer$patientId(maybePatientId)
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											$author$project$Api$Source$default(source) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : A3(
											$author$project$Ui$Button$view,
											{abp: 'Make this payment source the default for the payer'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$PaymentSources$MakeDefault(source))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Make Default')
												])),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Edit payment source'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$PaymentSources$Edit(source)),
													$author$project$Ui$Button$disabled(loading)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Delete payment source'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$loading(loading),
													$author$project$Ui$Button$onClick(
													$author$project$Components$PaymentSources$Delete(source))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$PaymentSources$viewPaymentSourcesList = F2(
	function (model, sources) {
		if ($elm$core$List$isEmpty(sources)) {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$ListGroup$item,
					_List_Nil,
					$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? _List_fromArray(
						[
							$elm$html$Html$text('You have not added any credit cards or bank accounts.')
						]) : _List_fromArray(
						[
							(!$author$project$Api$Practice$hasPaymentProcessorAccount(model.WF)) ? A2(
							$author$project$Utils$PaymentProcessor$toSetupAlert,
							model.WF,
							$elm$core$Maybe$Just('In order to add payment options')) : A2(
							$author$project$Ui$Alert$warning,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = model.G0;
									if (!_v0.$) {
										return $elm$html$Html$text('This employer has no payment sources set up.');
									} else {
										return $elm$html$Html$text('This patient has no payment sources set up.');
									}
								}()
								]))
						]))
				]);
		} else {
			var maybePatientId = function () {
				var _v1 = model.G0;
				if (_v1.$ === 1) {
					var patient = _v1.a;
					return $elm$core$Maybe$Just(
						$author$project$Api$Provider$Patient$One$id(patient));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			return A2(
				$elm$core$List$map,
				A5($author$project$Components$PaymentSources$viewSource, model.Hy, model.FR, model.aw, model.WF, maybePatientId),
				sources);
		}
	});
var $author$project$Api$Employer$Company$One$invoiceAutoIssue = function (_v0) {
	var record = _v0.b;
	return record.Ri;
};
var $author$project$Api$Provider$Company$One$invoiceAutoIssue = function (_v0) {
	var record = _v0.b;
	return record.Ri;
};
var $author$project$Api$Company$invoiceAutoIssue = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoIssue(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoIssue(company_);
	}
};
var $author$project$Api$Employer$Company$One$invoiceAutoIssueDay = function (_v0) {
	var record = _v0.b;
	return record.Rj;
};
var $author$project$Api$Provider$Company$One$invoiceAutoIssueDay = function (_v0) {
	var record = _v0.b;
	return record.Rj;
};
var $author$project$Api$Company$invoiceAutoIssueDay = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoIssueDay(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoIssueDay(company_);
	}
};
var $author$project$Api$Employer$Company$One$invoiceAutoSend = function (_v0) {
	var record = _v0.b;
	return record.Rl;
};
var $author$project$Api$Provider$Company$One$invoiceAutoSend = function (_v0) {
	var record = _v0.b;
	return record.Rl;
};
var $author$project$Api$Company$invoiceAutoSend = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoSend(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoSend(company_);
	}
};
var $author$project$Api$Employer$Company$One$invoiceAutoSendDay = function (_v0) {
	var record = _v0.b;
	return record.Rm;
};
var $author$project$Api$Provider$Company$One$invoiceAutoSendDay = function (_v0) {
	var record = _v0.b;
	return record.Rm;
};
var $author$project$Api$Company$invoiceAutoSendDay = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceAutoSendDay(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceAutoSendDay(company_);
	}
};
var $author$project$Api$Employer$Company$One$invoiceDueDay = function (_v0) {
	var record = _v0.b;
	return record.Ro;
};
var $author$project$Api$Provider$Company$One$invoiceDueDay = function (_v0) {
	var record = _v0.b;
	return record.Ro;
};
var $author$project$Api$Company$invoiceDueDay = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invoiceDueDay(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$invoiceDueDay(company_);
	}
};
var $author$project$Components$PaymentSources$viewPaymentTerms = function (model) {
	return (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD)) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Terms')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(12)
							]),
						_List_fromArray(
							[
								function () {
								var _v0 = model.G0;
								if (!_v0.$) {
									var company = _v0.a;
									return A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												function () {
												var _v1 = _Utils_Tuple2(
													$author$project$Api$Company$invoiceAutoSend(company),
													$author$project$Api$Company$invoiceAutoSendDay(company));
												if (_v1.a && (!_v1.b.$)) {
													var invoiceAutoSendDay = _v1.b.a;
													return A2(
														$author$project$Ui$Typography$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('You will receive the invoice on the '),
																A2(
																$author$project$Ui$Typography$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Formatters$Int$ordinal(invoiceAutoSendDay))
																	])),
																$elm$html$Html$text(' and can make changes until '),
																function () {
																var _v2 = _Utils_Tuple2(
																	$author$project$Api$Company$invoiceAutoIssue(company),
																	$author$project$Api$Company$invoiceAutoIssueDay(company));
																if (_v2.a && (!_v2.b.$)) {
																	var invoiceAutoIssueDay = _v2.b.a;
																	return (_Utils_cmp(invoiceAutoIssueDay, invoiceAutoSendDay) > 0) ? A2(
																		$author$project$Ui$Typography$span,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('the '),
																				A2(
																				$author$project$Ui$Typography$strong,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						$author$project$Formatters$Int$ordinal(invoiceAutoIssueDay))
																					])),
																				$elm$html$Html$text('.')
																			])) : $elm$html$Html$text('it gets issued by the Practice.');
																} else {
																	return $elm$html$Html$text('it gets issued by the Practice.');
																}
															}()
															]));
												} else {
													return A2(
														$author$project$Ui$Typography$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('You will receive the invoice once it gets issued.')
															]));
												}
											}(),
												A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Payment will be due on the '),
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Formatters$Int$ordinal(
																	$author$project$Api$Company$invoiceDueDay(company)))
															])),
														$elm$html$Html$text(' if autopay is '),
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('on')
															])),
														$elm$html$Html$text(' then it will process.')
													]))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]));
};
var $author$project$Components$PaymentSources$CancelEdit = {$: 1};
var $author$project$Components$PaymentSources$FormUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$PaymentSources$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PaymentSources$Update = {$: 18};
var $author$project$Components$PaymentSources$ExpMonth = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PaymentSources$ExpYear = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentSources$Zip = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PaymentSources$monthOptions = A2(
	$elm$core$List$map,
	function (month) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(month)),
			$elm$core$String$fromInt(month));
	},
	A2($elm$core$List$range, 1, 12));
var $author$project$Components$PaymentSources$yearOptions = function (currentDate) {
	var fromYear = $justinmimbs$date$Date$year(currentDate);
	var toYear = fromYear + 10;
	return A2(
		$elm$core$List$map,
		function (year) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(year)),
				$elm$core$String$fromInt(year));
		},
		A2($elm$core$List$range, fromYear, toYear));
};
var $author$project$Components$PaymentSources$viewCardFields = F3(
	function (currentDate, form, cardFields) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Expiration Date'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, cardFields.ac9)),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$ExpMonth)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Components$PaymentSources$monthOptions)
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Select$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Select$value(
												A2($elm$core$Maybe$map, $elm$core$String$fromInt, cardFields.ada)),
												$author$project$Ui$Form$Select$onChange(
												A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$ExpYear)),
												$author$project$Ui$Form$Select$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, form))
											]),
										$author$project$Components$PaymentSources$yearOptions(currentDate))
									]))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Zip Code'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(cardFields.tC),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$Zip)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form))
							])),
						$author$project$Utils$FormErrors$view(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]);
	});
var $author$project$Components$PaymentSources$viewSourceModal = F3(
	function (currentDate, form, updateRequest) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Payment Source',
			S_: _Utils_eq(updateRequest, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(''),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$PaymentSources$CancelEdit,
			U0: $elm$core$Basics$always($author$project$Components$PaymentSources$Update)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$placeholder('HSA card for incidental charges'),
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.aej)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$Label))
								]))
						])),
				function () {
					var _v0 = fields.Et;
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var cardFields = _v0.a;
						return A3($author$project$Components$PaymentSources$viewCardFields, currentDate, form, cardFields);
					}
				}()));
	});
var $author$project$Components$CreatePaymentMethodModal$Company = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CreatePaymentMethodModal$Patient = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$PaymentSources$viewSourcesActions = function (model) {
	var paymentMethodOwner = function () {
		var _v0 = model.G0;
		if (!_v0.$) {
			var company = _v0.a;
			return $author$project$Components$CreatePaymentMethodModal$Company(company);
		} else {
			var patient = _v0.a;
			return $author$project$Components$CreatePaymentMethodModal$Patient(patient);
		}
	}();
	var openOptions = {vD: model.vD, qT: model.qT, FR: model.FR, Vp: paymentMethodOwner, WF: model.WF, sj: model.sj, ZD: model.ZD, Hy: model.Hy, tv: true};
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Components$PaymentSources$CreatePaymentMethodModalMsg,
			$author$project$Components$CreatePaymentMethodModal$button(openOptions))
		]);
};
var $author$project$Api$Employer$Company$One$stripeLink = function (_v0) {
	var record = _v0.b;
	return record._X;
};
var $author$project$Api$Provider$Company$Shared$stripeLink = function (_v0) {
	var record = _v0;
	return record._X;
};
var $author$project$Api$Provider$Company$One$stripeLink = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$stripeLink(shared);
};
var $author$project$Api$Company$stripeLink = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$stripeLink(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$stripeLink(company_);
	}
};
var $author$project$Api$Provider$Patient$One$stripeLink = function (_v0) {
	var record = _v0.b;
	return record._X;
};
var $author$project$Components$PaymentSources$viewStripeLink = function (model) {
	var maybeStripeLink = function () {
		var _v2 = model.G0;
		if (!_v2.$) {
			var company = _v2.a;
			return $author$project$Api$Company$stripeLink(company);
		} else {
			var patient = _v2.a;
			return $author$project$Api$Provider$Patient$One$stripeLink(patient);
		}
	}();
	if (!maybeStripeLink.$) {
		var stripeLink_ = maybeStripeLink.a;
		var viewOnStripeLink = A3(
			$author$project$Ui$HinterOnly$linkHref,
			stripeLink_,
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text(' View on Stripe')
				]));
		var _v1 = model.G0;
		if (!_v1.$) {
			return model.FR ? _List_fromArray(
				[viewOnStripeLink]) : _List_Nil;
		} else {
			return model.FR ? _List_fromArray(
				[viewOnStripeLink]) : _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Element$FlexWrap = {$: 8};
var $author$project$Ui$Element$wrap = $author$project$Ui$Element$FlexWrap;
var $author$project$Components$PaymentSources$view = function (_v0) {
	var model = _v0;
	var _v1 = function () {
		var _v2 = _Utils_Tuple2(model.pN, model.pD);
		_v2$2:
		while (true) {
			switch (_v2.a.$) {
				case 3:
					if (_v2.b.$ === 3) {
						var _v3 = _v2.a;
						var cards = _v3.a;
						var _v4 = _v2.b;
						var bankAccounts = _v4.a;
						return _Utils_Tuple2(
							false,
							$elm$core$List$reverse(
								A2(
									$elm$core$List$sortBy,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Api$Source$createdAt,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$Maybe$map($elm$time$Time$posixToMillis),
											$elm$core$Maybe$withDefault(0))),
									_Utils_ap(
										A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
										A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts)))));
					} else {
						break _v2$2;
					}
				case 2:
					if (_v2.b.$ === 2) {
						return _Utils_Tuple2(false, _List_Nil);
					} else {
						break _v2$2;
					}
				default:
					break _v2$2;
			}
		}
		return _Utils_Tuple2(true, _List_Nil);
	}();
	var loading = _v1.a;
	var sources = _v1.b;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Components$PaymentSources$CreatePaymentMethodModalMsg,
			$author$project$Components$CreatePaymentMethodModal$modal(model.lB)),
			A2(
			$elm$html$Html$map,
			$author$project$Components$PaymentSources$MovePaymentMethodsModalMsg,
			$author$project$Components$MovePaymentMethodsModal$modal(model.f6)),
			function () {
			var _v5 = model.Hg;
			if (!_v5.$) {
				var _v6 = _v5.a;
				var form = _v6.b;
				var updateRequest = _v6.c;
				return A3($author$project$Components$PaymentSources$viewSourceModal, model.cO, form, updateRequest);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v7 = model.fr;
			if (!_v7.$) {
				var source = _v7.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$PaymentSources$HiConfirmClosed(source),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun(
							$author$project$Api$Source$noun(source)),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Source$detail(source))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$rowItemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(5)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$wrap, $author$project$Ui$Element$mb2, $author$project$Ui$Element$itemsStart]),
											_List_fromArray(
												[
													$author$project$Ui$Panel$title(
													_List_fromArray(
														[
															$elm$html$Html$text('Payment Methods')
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$wrap, $author$project$Ui$Element$mt1]),
													$author$project$Components$PaymentSources$viewAuditTrailLog(model))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(7)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2, $author$project$Ui$Element$justifyRight]),
											_Utils_ap(
												$author$project$Components$PaymentSources$viewStripeLink(model),
												_Utils_ap(
													A2($author$project$Components$PaymentSources$viewMoreActionsDowndown, model, sources),
													$author$project$Components$PaymentSources$viewSourcesActions(model))))
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb4]),
							$author$project$Components$PaymentSources$viewExemptFromCreditCardFees(model)),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mb4]),
											$author$project$Components$PaymentSources$viewAutopay(model))
										]))
								])),
							A2($author$project$Components$PaymentSources$viewNoDefaultSourceWarning, model.G0, sources),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(12)
										]),
									_List_fromArray(
										[
											$author$project$Components$PaymentSources$viewPaymentTerms(model)
										]))
								])),
							loading ? A2(
							$author$project$Ui$ListGroup$view,
							_List_Nil,
							A2(
								$elm$core$List$repeat,
								2,
								A2(
									$author$project$Ui$ListGroup$item,
									_List_Nil,
									_List_fromArray(
										[$author$project$Components$PaymentSourceDisplayer$skeleton])))) : A2(
							$author$project$Ui$ListGroup$view,
							_List_Nil,
							A2($author$project$Components$PaymentSources$viewPaymentSourcesList, model, sources)),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Utils$Html$empty,
							A2(
								$elm$core$Maybe$map,
								function (virtualBankAccountsComponent_) {
									return A2(
										$elm$html$Html$map,
										$author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg,
										$author$project$Components$VirtualBankAccounts$view(virtualBankAccountsComponent_));
								},
								model.tx))
						]))
				]))
		]);
};
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$PaymentSources$view(model.rh)),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Payment Options'
	};
};
var $author$project$Pages$Companies$CompanyId_String$PaymentSources$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$PaymentSources$init, aer: $author$project$Pages$Companies$CompanyId_String$PaymentSources$load, agD: $author$project$Pages$Companies$CompanyId_String$PaymentSources$save, ahd: $author$project$Pages$Companies$CompanyId_String$PaymentSources$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$PaymentSources$update, ahP: $author$project$Pages$Companies$CompanyId_String$PaymentSources$view});
var $author$project$Pages$Companies$CompanyId_String$Signup$GotSignupPages = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages = F2(
	function (apiClient, company) {
		return A3(
			$author$project$Api$Provider$SignupPage$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ff: $elm$core$Maybe$Just(
							$author$project$Api$Company$id(company)),
						afy: $elm$core$Maybe$Nothing
					});
			},
			$author$project$Pages$Companies$CompanyId_String$Signup$GotSignupPages);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Company$One$collectPaymentSourceOnSignup = function (_v0) {
	var record = _v0.b;
	return record.Lf;
};
var $author$project$Api$Company$collectPaymentSourceOnSignup = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$One$collectPaymentSourceOnSignup(company_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$One$collectPractitionerOnSignup = function (_v0) {
	var record = _v0.b;
	return record.Lg;
};
var $author$project$Api$Company$collectPractitionerOnSignup = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$collectPractitionerOnSignup(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Company$One$collectSSNOnSignup = function (_v0) {
	var record = _v0.b;
	return record.Lh;
};
var $author$project$Api$Provider$Company$One$collectSSNOnSignup = function (_v0) {
	var record = _v0.b;
	return record.Lh;
};
var $author$project$Api$Company$collectSSNOnSignup = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$collectSSNOnSignup(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$collectSSNOnSignup(company_);
	}
};
var $author$project$Api$Provider$Company$Shared$customPostSignupPage = function (_v0) {
	var record = _v0;
	return record.MH;
};
var $author$project$Api$Provider$Company$One$customPostSignupPage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$customPostSignupPage(shared);
};
var $author$project$Api$Company$customPostSignupPage = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$One$customPostSignupPage(company_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields = function (params) {
	return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
		{
			Lf: params.Lf,
			Lg: params.Lg,
			Lh: params.Lh,
			MH: A2($elm$core$Maybe$withDefault, false, params.MH),
			WB: A2($elm$core$Maybe$withDefault, '', params.WB),
			WC: A2($elm$core$Maybe$withDefault, '', params.WC),
			WD: A2($elm$core$Maybe$withDefault, '', params.WD),
			X1: A2($elm$core$Maybe$withDefault, false, params.X1),
			ZX: A2($elm$core$Maybe$withDefault, false, params.ZX)
		});
};
var $author$project$Api$Provider$Company$Shared$postSignupButtonLabel = function (_v0) {
	var record = _v0;
	return record.WB;
};
var $author$project$Api$Provider$Company$One$postSignupButtonLabel = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$postSignupButtonLabel(shared);
};
var $author$project$Api$Company$postSignupButtonLabel = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$postSignupButtonLabel(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$Shared$postSignupMessage = function (_v0) {
	var record = _v0;
	return record.WC;
};
var $author$project$Api$Provider$Company$One$postSignupMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$postSignupMessage(shared);
};
var $author$project$Api$Company$postSignupMessage = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$postSignupMessage(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$Shared$postSignupRedirectUrl = function (_v0) {
	var record = _v0;
	return record.WD;
};
var $author$project$Api$Provider$Company$One$postSignupRedirectUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$postSignupRedirectUrl(shared);
};
var $author$project$Api$Company$postSignupRedirectUrl = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$postSignupRedirectUrl(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$Shared$redirectsPostSignup = function (_v0) {
	var record = _v0;
	return record.X1;
};
var $author$project$Api$Provider$Company$One$redirectsPostSignup = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$redirectsPostSignup(shared);
};
var $author$project$Api$Company$redirectsPostSignup = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$One$redirectsPostSignup(company_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$Shared$showPostSignupFooterButton = function (_v0) {
	var record = _v0;
	return record.ZX;
};
var $author$project$Api$Provider$Company$One$showPostSignupFooterButton = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$showPostSignupFooterButton(shared);
};
var $author$project$Api$Company$showPostSignupFooterButton = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$One$showPostSignupFooterButton(company_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromCompany = F2(
	function (organizationIsCompany, company) {
		return organizationIsCompany ? $author$project$Pages$Companies$CompanyId_String$Signup$Employer(
			{
				Lh: $author$project$Api$Company$collectSSNOnSignup(company)
			}) : $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields(
			{
				Lf: $author$project$Api$Company$collectPaymentSourceOnSignup(company),
				Lg: $author$project$Api$Company$collectPractitionerOnSignup(company),
				Lh: $author$project$Api$Company$collectSSNOnSignup(company),
				MH: $author$project$Api$Company$customPostSignupPage(company),
				WB: $author$project$Api$Company$postSignupButtonLabel(company),
				WC: $author$project$Api$Company$postSignupMessage(company),
				WD: $author$project$Api$Company$postSignupRedirectUrl(company),
				X1: $author$project$Api$Company$redirectsPostSignup(company),
				ZX: $author$project$Api$Company$showPostSignupFooterButton(company)
			});
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$init = F5(
	function (session, practice, company, shared, _v0) {
		var model = {
			D5: shared.D5,
			ab9: company,
			acv: shared.adu.acv,
			Nk: $elm$core$Maybe$Nothing,
			mD: false,
			FR: $author$project$Shared$isHintAdmin(shared),
			c0: $author$project$Utils$Form$init(
				A2($author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromCompany, shared.afu, company)),
			WF: practice,
			n6: $jinjor$elm_debounce$Debounce$init,
			ZD: session,
			oi: false,
			sT: _List_Nil
		};
		var fetchSignupPagesCmd = ($author$project$Api$Platform$Session$One$role(session) === 'practice_admin') ? A2($author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages, shared.D5, company) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(model, fetchSignupPagesCmd);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$subscriptions = function (model) {
	return model.oi ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings = {$: 5};
var $author$project$Pages$Companies$CompanyId_String$Signup$debounceSave = function (field) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings;
		},
		$elm$core$Task$succeed(field));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$employerFormFieldsUpdate = F2(
	function (field, fields) {
		if (fields.$ === 1) {
			var fields_ = fields.a;
			if (field.$ === 6) {
				var collectSSN = field.a;
				return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(
					_Utils_update(
						fields_,
						{Lh: collectSSN}));
			} else {
				return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(fields_);
			}
		} else {
			var fields_ = fields.a;
			return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(fields_);
		}
	});
var $author$project$Api$Provider$Company$SignupSetting$collectPaymentSourceOnSignup = function (_v0) {
	var record = _v0;
	return record.Lf;
};
var $author$project$Api$Company$SignupSetting$collectPaymentSourceOnSignup = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$SignupSetting$collectPaymentSourceOnSignup(signupSetting_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$collectPractitionerOnSignup = function (_v0) {
	var record = _v0;
	return record.Lg;
};
var $author$project$Api$Company$SignupSetting$collectPractitionerOnSignup = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$collectPractitionerOnSignup(signupSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Company$SignupSetting$collectSSNOnSignup = function (_v0) {
	var record = _v0;
	return record.Lh;
};
var $author$project$Api$Provider$Company$SignupSetting$collectSSNOnSignup = function (_v0) {
	var record = _v0;
	return record.Lh;
};
var $author$project$Api$Company$SignupSetting$collectSSNOnSignup = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$collectSSNOnSignup(signupSetting_);
	} else {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$SignupSetting$collectSSNOnSignup(signupSetting_);
	}
};
var $author$project$Api$Provider$Company$SignupSetting$customPostSignupPage = function (_v0) {
	var record = _v0;
	return record.MH;
};
var $author$project$Api$Company$SignupSetting$customPostSignupPage = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$SignupSetting$customPostSignupPage(signupSetting_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$postSignupButtonLabel = function (_v0) {
	var record = _v0;
	return record.WB;
};
var $author$project$Api$Company$SignupSetting$postSignupButtonLabel = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$postSignupButtonLabel(signupSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$postSignupMessage = function (_v0) {
	var record = _v0;
	return record.WC;
};
var $author$project$Api$Company$SignupSetting$postSignupMessage = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$postSignupMessage(signupSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$postSignupRedirectUrl = function (_v0) {
	var record = _v0;
	return record.WD;
};
var $author$project$Api$Company$SignupSetting$postSignupRedirectUrl = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$SignupSetting$postSignupRedirectUrl(signupSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$redirectsPostSignup = function (_v0) {
	var record = _v0;
	return record.X1;
};
var $author$project$Api$Company$SignupSetting$redirectsPostSignup = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$SignupSetting$redirectsPostSignup(signupSetting_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Company$SignupSetting$showPostSignupFooterButton = function (_v0) {
	var record = _v0;
	return record.ZX;
};
var $author$project$Api$Company$SignupSetting$showPostSignupFooterButton = function (signupSetting) {
	if (!signupSetting.$) {
		var signupSetting_ = signupSetting.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Company$SignupSetting$showPostSignupFooterButton(signupSetting_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromSignupSetting = F2(
	function (organizationIsCompany, signupSetting) {
		return organizationIsCompany ? $author$project$Pages$Companies$CompanyId_String$Signup$Employer(
			{
				Lh: $author$project$Api$Company$SignupSetting$collectSSNOnSignup(signupSetting)
			}) : $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields(
			{
				Lf: $author$project$Api$Company$SignupSetting$collectPaymentSourceOnSignup(signupSetting),
				Lg: $author$project$Api$Company$SignupSetting$collectPractitionerOnSignup(signupSetting),
				Lh: $author$project$Api$Company$SignupSetting$collectSSNOnSignup(signupSetting),
				MH: $author$project$Api$Company$SignupSetting$customPostSignupPage(signupSetting),
				WB: $author$project$Api$Company$SignupSetting$postSignupButtonLabel(signupSetting),
				WC: $author$project$Api$Company$SignupSetting$postSignupMessage(signupSetting),
				WD: $author$project$Api$Company$SignupSetting$postSignupRedirectUrl(signupSetting),
				X1: $author$project$Api$Company$SignupSetting$redirectsPostSignup(signupSetting),
				ZX: $author$project$Api$Company$SignupSetting$showPostSignupFooterButton(signupSetting)
			});
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate = F2(
	function (field, fields) {
		if (!fields.$) {
			var fields_ = fields.a;
			switch (field.$) {
				case 0:
					var bool = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{MH: bool}));
				case 1:
					var bool = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{X1: bool}));
				case 2:
					var bool = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{ZX: bool}));
				case 3:
					var string = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{WC: string}));
				case 4:
					var string = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{WB: string}));
				case 5:
					var string = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{WD: string}));
				case 6:
					var collectSSN = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{Lh: collectSSN}));
				default:
					var collectPractitioner = field.a;
					return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(
						_Utils_update(
							fields_,
							{Lg: collectPractitioner}));
			}
		} else {
			var fields_ = fields.a;
			return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(fields_);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$debounceSaveForField = function (field) {
	switch (field.$) {
		case 0:
			return false;
		case 1:
			return false;
		case 2:
			return false;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return true;
		case 6:
			return false;
		default:
			return false;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$SaveDebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Pages$Companies$CompanyId_String$Signup$SaveDebounceMsg
};
var $author$project$Pages$Companies$CompanyId_String$Signup$SignupSettingUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Utils$String$encode = function (str) {
	return $author$project$Utils$String$isBlank(str) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(
		$elm$core$String$trim(str));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$encodeForm = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	if (!fields.$) {
		var fields_ = fields.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'custom_post_signup_page',
				$elm$json$Json$Encode$bool(fields_.MH)),
				_Utils_Tuple2(
				'redirects_post_signup',
				$elm$json$Json$Encode$bool(fields_.X1)),
				_Utils_Tuple2(
				'show_post_signup_footer_button',
				$elm$json$Json$Encode$bool(fields_.ZX)),
				_Utils_Tuple2(
				'post_signup_message',
				$author$project$Utils$String$encode(fields_.WC)),
				_Utils_Tuple2(
				'post_signup_button_label',
				$author$project$Utils$String$encode(fields_.WB)),
				_Utils_Tuple2(
				'post_signup_redirect_url',
				$author$project$Utils$String$encode(fields_.WD)),
				_Utils_Tuple2(
				'collect_practitioner_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields_.Lg)),
				_Utils_Tuple2(
				'collect_ssn_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields_.Lh)),
				_Utils_Tuple2(
				'collect_payment_source_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields_.Lf))
			]);
	} else {
		var fields_ = fields.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'collect_ssn_on_signup',
				$author$project$Api$CollectOnSignup$encoderMaybe(fields_.Lh))
			]);
	}
};
var $author$project$Api$Company$SignupSetting$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$SignupSetting$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Company$SignupSetting$SignupSetting = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$SignupSetting$Record = function (collectSSNOnSignup) {
	return {Lh: collectSSNOnSignup};
};
var $author$project$Api$Employer$Company$SignupSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_ssn_on_signup',
	$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$SignupSetting$Record));
var $author$project$Api$Employer$Company$SignupSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$SignupSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Company$SignupSetting$path = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['signup_settings']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Company$SignupSetting$update = F3(
	function (apiClient, params, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$SignupSetting$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$SignupSetting$path)));
	});
var $author$project$Api$Provider$Company$SignupSetting$SignupSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$SignupSetting$Record = F9(
	function (collectSSNOnSignup, collectPractitionerOnSignup, postSignupButtonLabel, postSignupMessage, postSignupRedirectUrl, redirectsPostSignup, showPostSignupFooterButton, customPostSignupPage, collectPaymentSourceOnSignup) {
		return {Lf: collectPaymentSourceOnSignup, Lg: collectPractitionerOnSignup, Lh: collectSSNOnSignup, MH: customPostSignupPage, WB: postSignupButtonLabel, WC: postSignupMessage, WD: postSignupRedirectUrl, X1: redirectsPostSignup, ZX: showPostSignupFooterButton};
	});
var $author$project$Api$Provider$Company$SignupSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'collect_payment_source_on_signup',
	$author$project$Api$CollectOnSignup$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'custom_post_signup_page',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'show_post_signup_footer_button',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'redirects_post_signup',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'post_signup_redirect_url',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'post_signup_message',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'post_signup_button_label',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'collect_practitioner_on_signup',
								$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'collect_ssn_on_signup',
									$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$SignupSetting$Record))))))))));
var $author$project$Api$Provider$Company$SignupSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$SignupSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$SignupSetting$path = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['signup_settings']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$SignupSetting$update = F4(
	function (apiClient, companyId, params, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$SignupSetting$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$SignupSetting$path(companyId))));
	});
var $author$project$Api$Company$SignupSetting$update = F5(
	function (apiClient, session, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signup_settings',
					$elm$json$Json$Encode$object(params))
				]));
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$SignupSetting$update,
			apiClient,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$SignupSetting$Employer))) : A4(
			$author$project$Api$Provider$Company$SignupSetting$update,
			apiClient,
			id,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$SignupSetting$Provider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty = function (model) {
	return model.mD ? A5(
		$author$project$Api$Company$SignupSetting$update,
		model.D5,
		model.ZD,
		$author$project$Api$Company$id(model.ab9),
		$author$project$Pages$Companies$CompanyId_String$Signup$encodeForm(model.c0),
		$author$project$Pages$Companies$CompanyId_String$Signup$SignupSettingUpdated) : $elm$core$Platform$Cmd$none;
};
var $author$project$Pages$Companies$CompanyId_String$Signup$saveChanges = F3(
	function (field, model, updater) {
		var newModel = _Utils_update(
			model,
			{
				mD: true,
				c0: A3($author$project$Utils$Form$update, updater, field, model.c0)
			});
		if ($author$project$Pages$Companies$CompanyId_String$Signup$debounceSaveForField(field)) {
			var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig, field, newModel.n6);
			var debounceModel = _v0.a;
			var debounceCmd = _v0.b;
			return _Utils_Tuple2(
				_Utils_update(
					newModel,
					{n6: debounceModel}),
				debounceCmd);
		} else {
			return _Utils_Tuple2(
				newModel,
				$author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty(newModel));
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 8:
				var dataSignupPages = msg.a;
				if (dataSignupPages.$ === 3) {
					var signupPages = dataSignupPages.a;
					var defaultSignupPage = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (page_) {
								return $author$project$Api$Provider$SignupPage$All$default(page_);
							},
							signupPages));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Nk: defaultSignupPage, sT: signupPages}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sT: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataSignupPages));
				}
			case 0:
				var field = msg.a;
				if ((!field.$) && (!field.a)) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oi: true}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					var _v3 = A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, field, model, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate);
					var newModel = _v3.a;
					var debounceCmd = _v3.b;
					return _Utils_Tuple3(newModel, debounceCmd, _List_Nil);
				}
			case 1:
				var field = msg.a;
				var _v4 = A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, field, model, $author$project$Pages$Companies$CompanyId_String$Signup$employerFormFieldsUpdate);
				var newModel = _v4.a;
				var debounceCmd = _v4.b;
				return _Utils_Tuple3(newModel, debounceCmd, _List_Nil);
			case 2:
				var value = msg.a;
				var newField = $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage(!value);
				var _v5 = value ? A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, newField, model, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							mD: false,
							c0: A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate, newField, model.c0)
						}),
					$elm$core$Platform$Cmd$none);
				var newModel = _v5.a;
				var debounceCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{oi: false}),
					debounceCmd,
					_List_Nil);
			case 3:
				var signupSettingData = msg.a;
				if (signupSettingData.$ === 3) {
					var signupSetting = signupSettingData.a;
					var fields = $author$project$Utils$Form$fields(model.c0);
					var isEmployer = function () {
						if (fields.$ === 1) {
							return true;
						} else {
							return false;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								mD: false,
								c0: $author$project$Utils$Form$init(
									A2($author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromSignupSetting, isEmployer, signupSetting))
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(signupSettingData));
				}
			case 4:
				var debounceMsg = msg.a;
				var _v8 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Pages$Companies$CompanyId_String$Signup$debounceSave),
					debounceMsg,
					model.n6);
				var newDebouncer = _v8.a;
				var debounceCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n6: newDebouncer}),
					debounceCmd,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					model,
					$author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty(model),
					_List_Nil);
			case 6:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(url),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
						]));
			case 7:
				var id = msg.a;
				var selectedPage = A2(
					$elm_community$list_extra$List$Extra$find,
					function (signupPage_) {
						return _Utils_eq(
							id,
							$author$project$Api$Provider$SignupPage$All$id(signupPage_));
					},
					model.sT);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Nk: selectedPage}),
					A3($author$project$Api$Provider$SignupPage$makeDefault, model.D5, id, $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageUpdated),
					_List_Nil);
			default:
				var signupPageData = msg.a;
				if (signupPageData.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages, model.D5, model.ab9),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Company\'s default signup page was updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(signupPageData));
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$EmployerFormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$CollectSSNOnSignup = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Employer$Practice$One$collectSSNOnSignup = function (_v0) {
	var record = _v0;
	return record.Lh;
};
var $author$project$Api$Practice$collectSSNOnSignup = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$collectSSNOnSignup(practice_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton = F5(
	function (currentCollectOnSignup, selectedCollectOnSignup, toMsg, toFieldMsg, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
					$author$project$Ui$Button$onClick(
					toMsg(
						toFieldMsg(selectedCollectOnSignup)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup = F7(
	function (collectOnSignup, label, labelHelp, viewPracticeDefault, childrenContent, toMsg, toFieldMsg) {
		var extraCollectOption = viewPracticeDefault ? _List_fromArray(
			[
				A5($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton, collectOnSignup, $elm$core$Maybe$Nothing, toMsg, toFieldMsg, 'Practice Default')
			]) : _List_Nil;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											$author$project$Ui$Button$group(
											A2(
												$elm$core$List$cons,
												A5(
													$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton,
													collectOnSignup,
													$elm$core$Maybe$Just(0),
													toMsg,
													toFieldMsg,
													'No'),
												A2(
													$elm$core$List$cons,
													A5(
														$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton,
														collectOnSignup,
														$elm$core$Maybe$Just(1),
														toMsg,
														toFieldMsg,
														'Optional'),
													A2(
														$elm$core$List$cons,
														A5(
															$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton,
															collectOnSignup,
															$elm$core$Maybe$Just(2),
															toMsg,
															toFieldMsg,
															'Require'),
														extraCollectOption))))
										]))
								])),
						childrenContent))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN = F3(
	function (collectSSNOnSignup, practice, toMsg) {
		var labelHelpText = function () {
			if (!collectSSNOnSignup.$) {
				switch (collectSSNOnSignup.a) {
					case 0:
						var _v1 = collectSSNOnSignup.a;
						return 'SSN will not be collected.';
					case 1:
						var _v2 = collectSSNOnSignup.a;
						return 'SSN are optional and can be left blank.';
					case 2:
						var _v3 = collectSSNOnSignup.a;
						return 'A SSN is required for each member. This will prevent people without SSNs from signing up.';
					case 3:
						var _v4 = collectSSNOnSignup.a;
						return '';
					default:
						var _v5 = collectSSNOnSignup.a;
						return '';
				}
			} else {
				return 'Will use the practice setting. Currently set to \'' + ($author$project$Api$CollectOnSignup$label(
					$author$project$Api$Practice$collectSSNOnSignup(practice)) + '\'');
			}
		}();
		return A7(
			$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup,
			collectSSNOnSignup,
			'Collect SSN',
			$elm$html$Html$text(labelHelpText),
			true,
			_List_Nil,
			toMsg,
			$author$project$Pages$Companies$CompanyId_String$Signup$CollectSSNOnSignup);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$Copy = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Employer$Company$One$employeeSignupUrl = function (_v0) {
	var record = _v0.b;
	return record.Os;
};
var $author$project$Api$Provider$Company$One$employeeSignupUrl = function (_v0) {
	var record = _v0.b;
	return record.Os;
};
var $author$project$Api$Company$employeeSignupUrl = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$employeeSignupUrl(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$employeeSignupUrl(company_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl = function (company) {
	var url = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Company$employeeSignupUrl(company));
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(11),
						$author$project$Ui$FlexGrid$offsetSm(1)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Global Employee Sign-Up Link'),
								$author$project$Ui$Form$Group$labelHelp(
								$elm$html$Html$text('Leads to the default sign-up page.')),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$clearfix,
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$group(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(url),
												$author$project$Ui$Form$Input$disabled(true)
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Copy link to clipboard'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Companies$CompanyId_String$Signup$Copy(url))
											]),
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 25),
												$elm$html$Html$text(' Copy Link')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Ui$Tooltip$Right = 3;
var $author$project$Pages$Companies$CompanyId_String$Signup$viewTitle = A2(
	$author$project$Ui$FlexGrid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(6)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Employee Sign-Up Settings')
								])),
							A3(
							$author$project$Ui$Tooltip$view,
							_List_fromArray(
								[
									$author$project$Ui$Tooltip$placement(3)
								]),
							'Click to Learn More',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$externalHref,
									'https://support.hint.com/employers/employer-account-setup',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Icon$view,
											_List_fromArray(
												[$author$project$Ui$Icon$clickable]),
											5)
										]))
								]))
						]))
				]))
		]));
var $author$project$Pages$Companies$CompanyId_String$Signup$viewEmployerForm = F3(
	function (employerFormFields, company, practice) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[$author$project$Pages$Companies$CompanyId_String$Signup$viewTitle])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl(company),
						A3($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN, employerFormFields.Lh, practice, $author$project$Pages$Companies$CompanyId_String$Signup$EmployerFormUpdated)
					]))
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$CollectPractitionerOnSignup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Practice$collectPractitionerOnSignup = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectPractitioner = F2(
	function (collectPractitionerOnSignup, practice) {
		var labelHelpText = function () {
			if (!collectPractitionerOnSignup.$) {
				switch (collectPractitionerOnSignup.a) {
					case 0:
						var _v1 = collectPractitionerOnSignup.a;
						return 'Providers will not be collected.';
					case 1:
						var _v2 = collectPractitionerOnSignup.a;
						return 'Providers are optional and can be left blank.';
					case 2:
						var _v3 = collectPractitionerOnSignup.a;
						return 'A provider is required for each member.';
					case 3:
						var _v4 = collectPractitionerOnSignup.a;
						return '';
					default:
						var _v5 = collectPractitionerOnSignup.a;
						return '';
				}
			} else {
				var _v6 = $author$project$Api$Practice$collectPractitionerOnSignup(practice);
				if (!_v6.$) {
					var collectPractitioner = _v6.a;
					return 'Will use the practice setting. Currently set to \'' + ($author$project$Api$CollectOnSignup$label(collectPractitioner) + '\'');
				} else {
					return 'Will use the practice setting.';
				}
			}
		}();
		return A7(
			$author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup,
			collectPractitionerOnSignup,
			'Collect Provider',
			$elm$html$Html$text(labelHelpText),
			true,
			_List_Nil,
			$author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated,
			$author$project$Pages$Companies$CompanyId_String$Signup$CollectPractitionerOnSignup);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewConfirmModal = function (showConfirmModal) {
	return showConfirmModal ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('clear'),
				$author$project$Components$HiConfirm$noun('company settings'),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						$elm$html$Html$text('Confirmation page settings specific to this company will be reverted to the practice defaults. This action cannot be undone.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Companies$CompanyId_String$Signup$RedirectsPostSignup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle = F3(
	function (label, labelHelp, toggleSwitch) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(label),
									$author$project$Ui$Form$Group$labelHelp(labelHelp),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix,
									$author$project$Ui$Form$Group$labelSpan(8),
									$author$project$Ui$Form$Group$inputSpan(4)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[toggleSwitch]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewAutoRedirectToggle = function (redirectsPostSignup) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$RedirectsPostSignup))
			]));
	return A3(
		$author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle,
		'Auto Redirect to External Site',
		$elm$html$Html$text(''),
		toggleSwitch);
};
var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupButtonLabel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonText = F4(
	function (postSignupButtonLabel, redirectsPostSignup, showPostSignupFooterButton, practice) {
		if ((!redirectsPostSignup) && showPostSignupFooterButton) {
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'If left blank, button will read Go to ' + ($author$project$Api$Practice$name(practice) + ' Website (under '))
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Signup,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Online Signup')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(').')
							]))
					]));
			return A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(11),
								$author$project$Ui$FlexGrid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Custom Button Text'),
										$author$project$Ui$Form$Group$labelHelp(labelHelp),
										$author$project$Ui$Form$Group$labelClass(''),
										$author$project$Ui$Form$Group$clearfix,
										$author$project$Ui$Form$Group$labelSpanSm(5),
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(postSignupButtonLabel),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupButtonLabel)),
												$author$project$Ui$Form$Input$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupRedirectUrl = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Practice$url = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$url(practice_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonUrl = F4(
	function (postSignupRedirectUrl, redirectsPostSignup, showPostSignupFooterButton, practice) {
		if ((!redirectsPostSignup) && (!showPostSignupFooterButton)) {
			return $author$project$Utils$Html$empty;
		} else {
			var title = redirectsPostSignup ? 'Redirect URL' : 'Custom Button URL';
			var labelHelp = redirectsPostSignup ? $elm$html$Html$text('') : A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__Practice,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Account')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(').')
							]))
					]));
			return A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(11),
								$author$project$Ui$FlexGrid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label(title),
										$author$project$Ui$Form$Group$labelHelp(labelHelp),
										$author$project$Ui$Form$Group$labelClass(''),
										$author$project$Ui$Form$Group$clearfix,
										$author$project$Ui$Form$Group$labelSpanSm(5),
										$author$project$Ui$Form$Group$inputSpanSm(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(postSignupRedirectUrl),
												$author$project$Ui$Form$Input$placeholder(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													$author$project$Api$Practice$url(practice))),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupRedirectUrl)),
												$author$project$Ui$Form$Input$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
											]))
									]))
							]))
					]));
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupMessage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomMessage = F2(
	function (customMessage, redirectsPostSignup) {
		return redirectsPostSignup ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Custom Message'),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix,
									$author$project$Ui$Form$Group$labelSpanSm(5),
									$author$project$Ui$Form$Group$inputSpanSm(7)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Textarea$placeholder('Add your custom message here.'),
											$author$project$Ui$Form$Textarea$value(customMessage),
											$author$project$Ui$Form$Textarea$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupMessage)),
											$author$project$Ui$Form$Textarea$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$ShowPostSignupFooterButton = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewPostSignupButtonToggle = F2(
	function (showPostSignupFooterButton, redirectsPostSignup) {
		if (redirectsPostSignup) {
			return $author$project$Utils$Html$empty;
		} else {
			var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$ShowPostSignupFooterButton))
					]));
			var labelHelpText = showPostSignupFooterButton ? 'A button is displayed that can be configured below with a custom text and URL.' : 'No button will be shown, and employee should be instructed to close their current signup tab.';
			var labelHelp = A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(labelHelpText)
					]));
			return A3(
				$author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle,
				'Show Redirect Button on Confirmation',
				A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
				toggleSwitch);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupFields = F2(
	function (providerFormFields, practice) {
		return providerFormFields.MH ? _List_fromArray(
			[
				$author$project$Pages$Companies$CompanyId_String$Signup$viewAutoRedirectToggle(providerFormFields.X1),
				A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomMessage, providerFormFields.WC, providerFormFields.X1),
				A2($author$project$Pages$Companies$CompanyId_String$Signup$viewPostSignupButtonToggle, providerFormFields.ZX, providerFormFields.X1),
				A4($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonText, providerFormFields.WB, providerFormFields.X1, providerFormFields.ZX, practice),
				A4($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonUrl, providerFormFields.WD, providerFormFields.X1, providerFormFields.ZX, practice)
			]) : _List_Nil;
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupToggle = function (customPostSignupPage) {
	var toggleSwitch = $author$project$Ui$ToggleSwitch$view(
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$on(customPostSignupPage),
				$author$project$Ui$ToggleSwitch$onChange(
				A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage))
			]));
	var labelHelp = customPostSignupPage ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Employee will be redirected or see a confirmation page specific to this company')
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Employee will be redirected or see the default confirmation page based on the '),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__Signup,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('global practice settings')
					]))
			]));
	return A3(
		$author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle,
		'Custom Confirmation Page after Signup',
		A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp),
		toggleSwitch);
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewProviderForm = F3(
	function (showConfirmModal, providerFormFields, practice) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[$author$project$Pages$Companies$CompanyId_String$Signup$viewTitle])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					$author$project$Pages$Companies$CompanyId_String$Signup$viewConfirmModal(showConfirmModal),
					A2(
						$elm$core$List$cons,
						A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectPractitioner, providerFormFields.Lg, practice),
						A2(
							$elm$core$List$cons,
							A3($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN, providerFormFields.Lh, practice, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated),
							A2(
								$elm$core$List$cons,
								$author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupToggle(providerFormFields.MH),
								A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupFields, providerFormFields, practice))))))
			]);
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageSelectMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewDefaultSignupPage = function (model) {
	var _v0 = model.Nk;
	if (!_v0.$) {
		var signupPage = _v0.a;
		var signupPageItems = A2(
			$elm$core$List$map,
			function (signupPage_) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$SignupPage$All$id(signupPage_)),
					$author$project$Api$Provider$SignupPage$All$displayName(signupPage_));
			},
			model.sT);
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Default Sign-Up Page'),
									$author$project$Ui$Form$Group$labelHelp(
									$elm$html$Html$text('This is the page that will open when the global link is clicked by an employee.')),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$labelClass(''),
									$author$project$Ui$Form$Group$clearfix
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$author$project$Api$Provider$SignupPage$All$id(signupPage))),
											$author$project$Ui$Form$Select$onChange($author$project$Pages$Companies$CompanyId_String$Signup$SignupPageSelectMsg)
										]),
									signupPageItems)
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewNewSignupPageButton = function (company) {
	return A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New(
			{
				ff: $author$project$Api$Company$id(company)
			}),
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonDefault,
				$author$project$Ui$Link$pull(0),
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('New Page')
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPage = F2(
	function (model, item) {
		var status = ($author$project$Api$Practice$hasPaymentProcessorAccount(model.WF) && $author$project$Api$Provider$SignupPage$All$active(item)) ? 'live' : 'inactive';
		var signupPageId = $author$project$Api$Provider$SignupPage$All$id(item);
		var companyId = $author$project$Api$Company$id(model.ab9);
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_Nil,
											_List_fromArray(
												[
													($author$project$Api$Provider$SignupPage$All$type_(item) === 'checkout') ? A2($author$project$Ui$Icon$view, _List_Nil, 22) : A2($author$project$Ui$Icon$view, _List_Nil, 21)
												])),
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$SignupPage$All$displayName(item))
												])),
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Ui$Badge$fromString, _List_Nil, status)
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Copy link to clipboard'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$size(0),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Companies$CompanyId_String$Signup$Copy(
														$author$project$Api$Provider$SignupPage$All$url(item)))
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$Icon$view, _List_Nil, 25),
													$author$project$Utils$Html$noBreakSpace,
													$elm$html$Html$text('Copy Link')
												])),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String(
												{ff: companyId, adR: signupPageId}),
											_List_fromArray(
												[
													$author$project$Ui$Link$sm,
													$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit')
												])),
											$author$project$Api$Provider$SignupPage$All$isDestroyable(item) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Delete signup page'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$size(0),
													$author$project$Ui$Button$pull(1),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Delete')
												])) : $author$project$Utils$Html$empty,
											$author$project$Api$Provider$SignupPage$All$default(item) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : $author$project$Utils$Html$empty
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPages = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(11),
						$author$project$Ui$FlexGrid$offsetSm(1)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Sign-Up Pages'),
								$author$project$Ui$Form$Group$labelHelp(
								$elm$html$Html$text('Custom sign-up pages for plans and checkout items.')),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8),
								$author$project$Ui$Form$Group$labelClass(''),
								$author$project$Ui$Form$Group$clearfix
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$ListGroup$view,
								_List_Nil,
								A2(
									$elm$core$List$map,
									$author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPage(model),
									model.sT)),
								$author$project$Pages$Companies$CompanyId_String$Signup$viewNewSignupPageButton(model.ab9)
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesTitle = $author$project$Ui$Typography$headingSm(
	_List_fromArray(
		[
			$elm$html$Html$text('Employee Sign-Up Pages')
		]));
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesSection = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[$author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesTitle])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl(model.ab9),
					$author$project$Pages$Companies$CompanyId_String$Signup$viewDefaultSignupPage(model),
					$author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPages(model)
				]))
		]);
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewSections = function (model) {
	var fields = $author$project$Utils$Form$fields(model.c0);
	if (!fields.$) {
		var providerFormFields = fields.a;
		return _Utils_ap(
			$author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesSection(model),
			A3($author$project$Pages$Companies$CompanyId_String$Signup$viewProviderForm, model.oi, providerFormFields, model.WF));
	} else {
		var employerFormFields = fields.a;
		return A3($author$project$Pages$Companies$CompanyId_String$Signup$viewEmployerForm, employerFormFields, model.ab9, model.WF);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Signup$viewBody = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		$author$project$Pages$Companies$CompanyId_String$Signup$viewSections(model));
};
var $author$project$Pages$Companies$CompanyId_String$Signup$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$Companies$CompanyId_String$Signup$viewBody(model)
			]),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Online Signup'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Signup$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Signup$init, aer: $author$project$Pages$Companies$CompanyId_String$Signup$load, agD: $author$project$Pages$Companies$CompanyId_String$Signup$save, ahd: $author$project$Pages$Companies$CompanyId_String$Signup$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Signup$update, ahP: $author$project$Pages$Companies$CompanyId_String$Signup$view});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$FormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var params = _v1.Vx;
		var id = params.adR;
		var companyId = params.ff;
		var _v2 = A6(
			$author$project$Components$Admin$SignupPages$Form$init,
			shared.D5,
			session,
			practice,
			$elm$core$Maybe$Just(id),
			$elm$core$Maybe$Just(companyId),
			$elm$core$Maybe$Nothing);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				ff: companyId,
				acv: shared.adu.acv,
				PB: form,
				FR: $author$project$Shared$isHintAdmin(shared),
				WF: practice,
				ZD: session
			},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var formCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd),
			outMsgs);
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$SignupPages$Form$view(model.PB))
			]),
		$G: A2($author$project$Formatters$String$sponsorize, model.WF, 'Companies') + ' | Online Signup'
	};
};
var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$page = $author$project$Spa$Page$applicationCompany(
	{ad0: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$init, aer: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$load, agD: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$save, ahd: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$update, ahP: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$view});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$FormMsg = $elm$core$Basics$identity;
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$init = F5(
	function (session, practice, _v0, shared, _v1) {
		var params = _v1.Vx;
		var companyId = params.ff;
		var _v2 = A6(
			$author$project$Components$Admin$SignupPages$Form$init,
			shared.D5,
			session,
			practice,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(companyId),
			$elm$core$Maybe$Nothing);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				ff: companyId,
				acv: shared.adu.acv,
				PB: form,
				FR: $author$project$Shared$isHintAdmin(shared),
				WF: practice,
				ZD: session
			},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var formCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd),
			outMsgs);
	});
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$SignupPages$Form$view(model.PB))
			]),
		$G: A2($author$project$Formatters$String$sponsorize, model.WF, 'Companies') + ' | Online Signup'
	};
};
var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$page = $author$project$Spa$Page$applicationCompany(
	{ad0: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$init, aer: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$load, agD: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$save, ahd: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$update, ahP: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$view});
var $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$GotCompany = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Company$Admins$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$Admins$formFieldsInit = {Oo: ''};
var $author$project$Components$Company$Admins$GotCompanyAdmins = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CompanyAdmin$companyAdminsPath = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['admins']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[companyId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['companies']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CompanyAdmin$All$CompanyAdmin = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyAdmin$One$CompanyAdmin = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyAdmin$Shared$CompanyAdmin = $elm$core$Basics$identity;
var $author$project$Api$Provider$CompanyAdmin$Shared$Record = F5(
	function (id, email, invitationPending, isDestroyable, user) {
		return {Oo: email, adR: id, Rf: invitationPending, RJ: isDestroyable, aaz: user};
	});
var $author$project$Api$Provider$CompanyAdmin$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_destroyable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invitation_pending',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'email',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$Shared$Record))))));
var $author$project$Api$Provider$CompanyAdmin$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAdmin$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAdmin$One$Record = function (invitationUrl) {
	return {Rg: invitationUrl};
};
var $author$project$Api$Provider$CompanyAdmin$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invitation_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$One$Record));
var $author$project$Api$Provider$CompanyAdmin$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAdmin$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$CompanyAdmin$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$One$CompanyAdmin)));
var $author$project$Api$Provider$CompanyAdmin$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CompanyAdmin$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CompanyAdmin$list = F3(
	function (apiClient, companyId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAdmin$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId)));
	});
var $author$project$Components$Company$Admins$listCompanyAdmins = F2(
	function (apiClient, company) {
		return A3(
			$author$project$Api$Provider$CompanyAdmin$list,
			apiClient,
			$author$project$Api$Provider$Company$One$id(company),
			$author$project$Components$Company$Admins$GotCompanyAdmins);
	});
var $author$project$Components$Company$Admins$init = F3(
	function (apiClient, company, practice) {
		return _Utils_Tuple2(
			{
				dq: false,
				bk: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit),
				po: $author$project$Api$Data$Loading,
				ab9: company,
				WF: practice,
				W7: false
			},
			A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, company));
	});
var $author$project$Components$Company$CommissionDeals$GotBrokerDeals = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$CommissionDeals$fetchBrokerDeals = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$BrokerDeal$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ab9: $elm$core$Maybe$Just(
							$author$project$Api$Provider$Company$One$id(model.ab9)),
						afy: model.afy
					});
			},
			$author$project$Components$Company$CommissionDeals$GotBrokerDeals);
	});
var $author$project$Components$Company$CommissionDeals$init = F6(
	function (session, company, practice, apiClient, currentDate, timeZone) {
		var model = {
			J9: $author$project$Api$Data$Loading,
			dt: A3(
				$author$project$Components$BrokerDeal$Table$init,
				session,
				currentDate,
				{l3: false, qI: false, qJ: true}),
			ab9: company,
			hY: $elm$core$Maybe$Nothing,
			cO: currentDate,
			afy: $author$project$Api$Pagination$init,
			WF: practice,
			ZD: session,
			Hz: timeZone
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
	});
var $author$project$Components$Company$ContactForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$ContactForm$AddressInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$ContactForm$initPhoneInput = function (phones) {
	return A3(
		$author$project$Components$PhoneInput$init,
		'company-phone-input',
		A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones),
		function (d) {
			return _Utils_update(
				d,
				{acB: $author$project$Api$Common$Phone$Shared$Office});
		});
};
var $author$project$Components$Company$ContactForm$initFormFields = function (company) {
	var _v0 = A2(
		$author$project$Components$AddressInput$initFromApi,
		'company',
		$author$project$Api$Company$address(company));
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	var fields = {
		It: addressInput,
		zh: $author$project$Api$Company$name(company),
		Wg: $author$project$Components$Company$ContactForm$initPhoneInput(
			$author$project$Api$Company$phones(company))
	};
	return _Utils_Tuple2(
		fields,
		A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$AddressInputMsg, addressInputCmd));
};
var $author$project$Components$Company$ContactForm$init = F3(
	function (company, practice, session) {
		var _v0 = $author$project$Components$Company$ContactForm$initFormFields(company);
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				ab9: company,
				PB: $author$project$Utils$Form$init(formFields),
				WF: practice,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session
			},
			formFieldsCmd);
	});
var $author$project$Api$Provider$Company$Shared$inactive = function (_v0) {
	var record = _v0;
	return record.QR;
};
var $author$project$Api$Provider$Company$One$isInactive = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$inactive(shared);
};
var $author$project$Api$Provider$Company$One$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Components$Company$DeactivateSponsor$init = F2(
	function (company, practice) {
		var status = $author$project$Api$Provider$Company$One$status(company);
		var inactive = $author$project$Api$Provider$Company$One$isInactive(company);
		var archived = status === 'archived';
		return _Utils_Tuple2(
			{Jn: archived, ab9: company, iL: false, QR: inactive, WF: practice, W7: false, jY: $author$project$Api$Data$NotAsked},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Company$EmployeeDivisions$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$EmployeeDivisions$initFormFields = function () {
	var fields = {zh: ''};
	return _Utils_Tuple2(fields, $elm$core$Platform$Cmd$none);
}();
var $author$project$Api$EmployeeDivision$Count = 0;
var $author$project$Components$Company$EmployeeDivisions$GotEmployeeDivisions = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions = F3(
	function (apiClient, session, company) {
		return A5(
			$author$project$Api$EmployeeDivision$list,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			function (d) {
				return _Utils_update(
					d,
					{
						Fc: _List_fromArray(
							[0])
					});
			},
			$author$project$Components$Company$EmployeeDivisions$GotEmployeeDivisions);
	});
var $author$project$Components$Company$EmployeeDivisions$init = F4(
	function (apiClient, company, practice, session) {
		var usesDivisions = $author$project$Api$Company$usesEmployeeDivisions(company);
		var requireDivisions = $author$project$Api$Company$requiresEmployeeDivisions(company);
		var _v0 = $author$project$Components$Company$EmployeeDivisions$initFormFields;
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				ab9: company,
				xp: $author$project$Api$Data$Loading,
				PB: $author$project$Utils$Form$init(formFields),
				WF: practice,
				Yj: requireDivisions,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				aaE: usesDivisions
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						usesDivisions ? A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, session, company) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Components$Company$Enrollment$GotNotificationSetting = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$Enrollment$Model = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$One$backBillPeriods = function (_v0) {
	var record = _v0.b;
	return record.JP;
};
var $author$project$Api$Provider$Company$Shared$backBillPeriods = function (_v0) {
	var record = _v0;
	return record.JP;
};
var $author$project$Api$Provider$Company$One$backBillPeriods = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$backBillPeriods(shared);
};
var $author$project$Api$Company$backBillPeriods = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$backBillPeriods(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$backBillPeriods(company_);
	}
};
var $author$project$Api$Provider$Company$One$employeeInviteNotification = function (_v0) {
	var record = _v0.b;
	return record.Or;
};
var $author$project$Api$Company$employeeInviteNotification = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$employeeInviteNotification(company_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Company$One$limitBackBill = function (_v0) {
	var record = _v0.b;
	return record.SS;
};
var $author$project$Api$Provider$Company$Shared$limitBackBill = function (_v0) {
	var record = _v0;
	return record.SS;
};
var $author$project$Api$Provider$Company$One$limitBackBill = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$limitBackBill(shared);
};
var $author$project$Api$Company$limitBackBill = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$limitBackBill(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$limitBackBill(company_);
	}
};
var $author$project$Api$Employer$Company$One$numberDependentsAllowed = function (_v0) {
	var record = _v0.b;
	return record.UQ;
};
var $author$project$Api$Provider$Company$One$numberDependentsAllowed = function (_v0) {
	var record = _v0.b;
	return record.UQ;
};
var $author$project$Api$Company$numberDependentsAllowed = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$numberDependentsAllowed(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$numberDependentsAllowed(company_);
	}
};
var $author$project$Api$Employer$Company$One$terminationCutOffDayOfMonth = function (_v0) {
	var record = _v0.b;
	return record.$x;
};
var $author$project$Api$Provider$Company$One$terminationCutOffDayOfMonth = function (_v0) {
	var record = _v0.b;
	return record.$x;
};
var $author$project$Api$Company$terminationCutOffDayOfMonth = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$terminationCutOffDayOfMonth(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$terminationCutOffDayOfMonth(company_);
	}
};
var $author$project$Api$Employer$Company$One$useTerminationCutOffDate = function (_v0) {
	var record = _v0.b;
	return record.aax;
};
var $author$project$Api$Provider$Company$One$useTerminationCutOffDate = function (_v0) {
	var record = _v0.b;
	return record.aax;
};
var $author$project$Api$Company$useTerminationCutOffDate = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$useTerminationCutOffDate(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$useTerminationCutOffDate(company_);
	}
};
var $author$project$Components$Company$Enrollment$formFieldsInit = function (company) {
	return {
		JP: $elm$core$String$fromInt(
			$author$project$Api$Company$backBillPeriods(company)),
		Or: A2(
			$elm$core$Maybe$withDefault,
			'practice_default',
			$author$project$Api$Company$employeeInviteNotification(company)),
		OF: $author$project$Api$Company$enrollmentCutOffDayOfMonth(company),
		SS: $author$project$Api$Company$limitBackBill(company),
		UQ: $author$project$Api$Company$numberDependentsAllowed(company),
		$x: $author$project$Api$Company$terminationCutOffDayOfMonth(company),
		o6: $author$project$Api$Company$useTerminationCutOffDate(company)
	};
};
var $author$project$Components$Company$Enrollment$init = F5(
	function (apiClient, company, practice, session, hinterViewOff) {
		var _v0 = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked) : _Utils_Tuple2(
			A4($author$project$Api$Provider$NotificationSetting$retrieve, apiClient, 'employee_invite', $elm$core$Maybe$Nothing, $author$project$Components$Company$Enrollment$GotNotificationSetting),
			$author$project$Api$Data$Loading);
		var cmd = _v0.a;
		var notificationSetting = _v0.b;
		return _Utils_Tuple2(
			{
				po: $author$project$Api$Data$Loading,
				Es: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0),
				ab9: company,
				h4: $jinjor$elm_debounce$Debounce$init,
				b6: $author$project$Utils$Form$init(
					$author$project$Components$Company$Enrollment$formFieldsInit(company)),
				UN: notificationSetting,
				WF: practice,
				W7: false,
				ZD: session
			},
			cmd);
	});
var $author$project$Components$Company$Plans$GotDefaultPlan = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Company$Plans$PlanResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Company$Plans$GotCompanyPlans = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$Plans$listCompanyPlans = F3(
	function (apiClient, session, company) {
		return A5(
			$author$project$Api$CompanyPlan$list,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			function (d) {
				return d;
			},
			$author$project$Components$Company$Plans$GotCompanyPlans);
	});
var $author$project$Api$Plan$EmployerOne = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Employer$Plan$One$Plan = $elm$core$Basics$identity;
var $author$project$Api$Employer$Plan$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Plan$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Plan$planPath = function (planId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[planId]),
		$author$project$Api$Employer$Plan$plansPath);
};
var $author$project$Api$Employer$Plan$retrieve = F3(
	function (apiClient, planId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Plan$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Plan$planPath(planId)));
	});
var $author$project$Api$Plan$retrieve = F5(
	function (apiClient, session, planId, expand, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Plan$retrieve,
			apiClient,
			planId,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Plan$EmployerOne))) : A4(
			$author$project$Api$Provider$Plan$retrieve,
			apiClient,
			planId,
			expand,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Plan$ProviderOne)));
	});
var $author$project$Components$Company$Plans$retrievePlan = F4(
	function (apiClient, session, planId, toMsg) {
		return A5(
			$author$project$Api$Plan$retrieve,
			apiClient,
			session,
			planId,
			_List_fromArray(
				[1]),
			toMsg);
	});
var $author$project$Components$Company$Plans$init = F4(
	function (apiClient, company, practice, session) {
		var retrieveDefaultPlan = function () {
			var _v1 = $author$project$Api$Company$defaultPlan(company);
			if (!_v1.$) {
				var defaultPlan = _v1.a;
				return A4(
					$author$project$Components$Company$Plans$retrievePlan,
					apiClient,
					session,
					$author$project$Api$Plan$id(defaultPlan),
					$author$project$Components$Company$Plans$GotDefaultPlan);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						AS: _List_fromArray(
							[0, 1, 3])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Plan'});
			});
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				dp: false,
				ab9: company,
				ak: _List_Nil,
				L5: $elm$core$Maybe$Nothing,
				Nh: $elm$core$Maybe$Nothing,
				ql: false,
				f7: $author$project$Api$Company$allowCustomMembershipPlan(company),
				bu: $elm$core$Maybe$Nothing,
				ee: $elm$core$Maybe$Nothing,
				jw: planResourceFilter,
				WF: practice,
				j0: $elm$core$Maybe$Nothing,
				ZD: session,
				og: false,
				he: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, session, company),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$PlanResourceFilterMsg, planResourceFilterCmd),
						retrieveDefaultPlan
					])));
	});
var $author$project$Api$Company$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Company$companyPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['company']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Company$One$Company = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Company$Shared$Company = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$Shared$Record = function (id) {
	return function (name) {
		return function (companyType) {
			return function (periodInMonths) {
				return function (allowCustomMembershipPlan) {
					return function (usesEmployeeDivisions) {
						return function (requiresEmployeeDivisions) {
							return function (enrollmentCutOffDayOfMonth) {
								return function (inactive) {
									return function (status) {
										return {IV: allowCustomMembershipPlan, LA: companyType, OF: enrollmentCutOffDayOfMonth, adR: id, QR: inactive, zh: name, Wc: periodInMonths, Yl: requiresEmployeeDivisions, ag7: status, aaF: usesEmployeeDivisions};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Company$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'inactive',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enrollment_cutoff_day_of_month',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'requires_employee_divisions',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'uses_employee_divisions',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'allow_custom_membership_plan',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'period_in_months',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'company_type',
								$author$project$Api$Company$CompanyType$decoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$Shared$Record)))))))))));
var $author$project$Api$Employer$Company$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Company$One$Record = function (invoiceAutoIssue) {
	return function (invoiceAutoIssueDay) {
		return function (invoiceAutoSend) {
			return function (invoiceAutoSendDay) {
				return function (invoiceDueDay) {
					return function (invoiceAutoPay) {
						return function (nextInvoiceDate) {
							return function (parent) {
								return function (acceptsAch) {
									return function (acceptsAmex) {
										return function (acceptsCards) {
											return function (chargePhiDetailsEnabled) {
												return function (address) {
													return function (phones) {
														return function (defaultSource) {
															return function (activeMembershipsCount) {
																return function (defaultPlan) {
																	return function (collectSSNOnSignup) {
																		return function (employeeSignupUrl) {
																			return function (limitBackBill) {
																				return function (backBillPeriods) {
																					return function (numberDependentsAllowed) {
																						return function (useTerminationCutOffDate) {
																							return function (terminationCutOffDayOfMonth) {
																								return function (stripeLink) {
																									return function (defaultLocation) {
																										return function (defaultPractitioner) {
																											return function (defaultAffiliation) {
																												return function (defaultSignupPage) {
																													return function (billAffiliateRate) {
																														return function (hideSponsorInvoices) {
																															return {H_: acceptsAch, H$: acceptsAmex, H0: acceptsCards, Ih: activeMembershipsCount, It: address, JP: backBillPeriods, JW: billAffiliateRate, KR: chargePhiDetailsEnabled, Lh: collectSSNOnSignup, M6: defaultAffiliation, M9: defaultLocation, Nh: defaultPlan, Nj: defaultPractitioner, Nk: defaultSignupPage, Nl: defaultSource, Os: employeeSignupUrl, Qp: hideSponsorInvoices, Ri: invoiceAutoIssue, Rj: invoiceAutoIssueDay, Rk: invoiceAutoPay, Rl: invoiceAutoSend, Rm: invoiceAutoSendDay, Ro: invoiceDueDay, SS: limitBackBill, UF: nextInvoiceDate, UQ: numberDependentsAllowed, Vy: parent, Wi: phones, _X: stripeLink, $x: terminationCutOffDayOfMonth, aax: useTerminationCutOffDate};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Company$Min$Company = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$Min$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Employer$Company$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$Min$Record)));
var $author$project$Api$Employer$Company$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$SignupPage$Min$SignupPage = $elm$core$Basics$identity;
var $author$project$Api$Employer$SignupPage$Min$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Employer$SignupPage$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$SignupPage$Min$Record));
var $author$project$Api$Employer$SignupPage$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$SignupPage$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Company$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hide_sponsor_invoices',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'bill_affiliate_rate',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'default_signup_page',
			$elm$json$Json$Decode$nullable($author$project$Api$Employer$SignupPage$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_affiliation',
				$elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'default_practitioner',
					$elm$json$Json$Decode$nullable($author$project$Api$Employer$Practitioner$Shared$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'default_location',
						$elm$json$Json$Decode$nullable($author$project$Api$Employer$Location$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'stripe_link',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'termination_cutoff_day_of_month',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'use_termination_cutoff_date',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'number_dependents_allowed',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'back_bill_periods',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'limit_back_bill',
												$elm$json$Json$Decode$bool,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'employee_signup_url',
													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'collect_ssn_on_signup',
														$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'default_plan',
															$elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Shared$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'memberships_count',
																$elm$json$Json$Decode$int,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'default_source',
																	$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'phones',
																		$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'address',
																			$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'charge_phi_details_enabled',
																				$elm$json$Json$Decode$bool,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'accepts_cards',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'accepts_amex',
																						$elm$json$Json$Decode$bool,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'accepts_ach',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'parent',
																								$elm$json$Json$Decode$nullable($author$project$Api$Employer$Company$Min$decoder),
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'next_invoice_date',
																									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'invoice_auto_pay',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'invoice_due_day',
																											$elm$json$Json$Decode$int,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'invoice_auto_send_day',
																												$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'invoice_auto_send',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'invoice_auto_issue_day',
																														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'invoice_auto_issue',
																															$elm$json$Json$Decode$bool,
																															$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$One$Record))))))))))))))))))))))))))))))));
var $author$project$Api$Employer$Company$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$Company$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$One$Company)));
var $author$project$Api$Employer$Company$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath));
	});
var $author$project$Api$Provider$Company$One$Company = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Company$One$Record = function (companyInvoiceSettingId) {
	return function (companyPaymentSourceSettingId) {
		return function (invoiceAutoIssue) {
			return function (invoiceAutoIssueDay) {
				return function (invoiceAutoSend) {
					return function (invoiceAutoSendDay) {
						return function (invoiceDueDay) {
							return function (invoiceAutoPay) {
								return function (parent) {
									return function (acceptsAch) {
										return function (acceptsAmex) {
											return function (acceptsCards) {
												return function (usesEmployeeDivisions) {
													return function (chargePhiDetailsEnabled) {
														return function (address) {
															return function (phones) {
																return function (defaultSource) {
																	return function (activeMembershipsCount) {
																		return function (defaultPlan) {
																			return function (defaultPractitioner) {
																				return function (defaultLocation) {
																					return function (defaultAffiliation) {
																						return function (collectSSNOnSignup) {
																							return function (collectPractitionerOnSignup) {
																								return function (collectPaymentSourceOnSignup) {
																									return function (employeeSignupUrl) {
																										return function (status) {
																											return function (numberDependentsAllowed) {
																												return function (enrollmentCutOffDayOfMonth) {
																													return function (useTerminationCutOffDate) {
																														return function (terminationCutOffDayOfMonth) {
																															return function (employeeInviteNotification) {
																																return function (flaggedNotesCount) {
																																	return function (invitationPending) {
																																		return function (defaultSignupPage) {
																																			return function (billAffiliateRate) {
																																				return {H_: acceptsAch, H$: acceptsAmex, H0: acceptsCards, Ih: activeMembershipsCount, It: address, JW: billAffiliateRate, KR: chargePhiDetailsEnabled, Lf: collectPaymentSourceOnSignup, Lg: collectPractitionerOnSignup, Lh: collectSSNOnSignup, Lv: companyInvoiceSettingId, Lx: companyPaymentSourceSettingId, M6: defaultAffiliation, M9: defaultLocation, Nh: defaultPlan, Nj: defaultPractitioner, Nk: defaultSignupPage, Nl: defaultSource, Or: employeeInviteNotification, Os: employeeSignupUrl, OF: enrollmentCutOffDayOfMonth, Py: flaggedNotesCount, Rf: invitationPending, Ri: invoiceAutoIssue, Rj: invoiceAutoIssueDay, Rk: invoiceAutoPay, Rl: invoiceAutoSend, Rm: invoiceAutoSendDay, Ro: invoiceDueDay, UQ: numberDependentsAllowed, Vy: parent, Wi: phones, ag7: status, $x: terminationCutOffDayOfMonth, aax: useTerminationCutOffDate, aaF: usesEmployeeDivisions};
																																			};
																																		};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$SignupPage$Min$SignupPage = $elm$core$Basics$identity;
var $author$project$Api$Provider$SignupPage$Min$Record = F2(
	function (id, slug) {
		return {adR: id, _c: slug};
	});
var $author$project$Api$Provider$SignupPage$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'slug',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$Min$Record)));
var $author$project$Api$Provider$SignupPage$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$SignupPage$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bill_affiliate_rate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'default_signup_page',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$SignupPage$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invitation_pending',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'flagged_notes_count',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'employee_invite_notification',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'termination_cutoff_day_of_month',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'use_termination_cutoff_date',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'enrollment_cutoff_day_of_month',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'number_dependents_allowed',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'status',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'employee_signup_url',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'collect_payment_source_on_signup',
												$author$project$Api$CollectOnSignup$decoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'collect_practitioner_on_signup',
													$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'collect_ssn_on_signup',
														$elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'default_affiliation',
															$elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'default_location',
																$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Shared$decoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'default_practitioner',
																	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder),
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'default_plan',
																		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'memberships_count',
																			$elm$json$Json$Decode$int,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'default_source',
																				$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'phones',
																					$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'address',
																						$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'charge_phi_details_enabled',
																							$elm$json$Json$Decode$bool,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'uses_employee_divisions',
																								$elm$json$Json$Decode$bool,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'accepts_cards',
																									$elm$json$Json$Decode$bool,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'accepts_amex',
																										$elm$json$Json$Decode$bool,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'accepts_ach',
																											$elm$json$Json$Decode$bool,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'parent',
																												$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'invoice_auto_pay',
																													$elm$json$Json$Decode$bool,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'invoice_due_day',
																														$elm$json$Json$Decode$int,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'invoice_auto_send_day',
																															$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'invoice_auto_send',
																																$elm$json$Json$Decode$bool,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'invoice_auto_issue_day',
																																	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'invoice_auto_issue',
																																		$elm$json$Json$Decode$bool,
																																		A3(
																																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																																			_List_fromArray(
																																				['payment_source_setting', 'id']),
																																			$elm$json$Json$Decode$string,
																																			A3(
																																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																																				_List_fromArray(
																																					['company_invoice_setting', 'id']),
																																				$elm$json$Json$Decode$string,
																																				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$One$Record)))))))))))))))))))))))))))))))))))));
var $author$project$Api$Provider$Company$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Company$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$One$Company)));
var $author$project$Api$Provider$Company$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Company$companyPath(id_)));
	});
var $author$project$Api$Company$retrieve = F4(
	function (apiClient, session, id_, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2(
			$author$project$Api$Employer$Company$retrieve,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Employer))) : A3(
			$author$project$Api$Provider$Company$retrieve,
			apiClient,
			id_,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var _v1 = A5($author$project$Components$Company$Enrollment$init, shared.D5, company, practice, session, shared.adN);
		var enrollment = _v1.a;
		var enrollmentCmd = _v1.b;
		var _v2 = A4($author$project$Components$Company$EmployeeDivisions$init, shared.D5, company, practice, session);
		var employeeDivisions = _v2.a;
		var employeeDivisionsCmd = _v2.b;
		var _v3 = function () {
			var _v4 = _Utils_Tuple2(company, practice);
			if ((!_v4.a.$) && (!_v4.b.$)) {
				var company_ = _v4.a.a;
				var practice_ = _v4.b.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A2($author$project$Components$Company$DeactivateSponsor$init, company_, practice_));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var deactivateSponsor = _v3.a;
		var deactivateSponsorCmd = _v3.b;
		var _v5 = A3($author$project$Components$Company$ContactForm$init, company, practice, session);
		var contactForm = _v5.a;
		var contactFormCmd = _v5.b;
		var _v6 = A4($author$project$Components$Company$Plans$init, shared.D5, company, practice, session);
		var companyPlans = _v6.a;
		var companyPlansCmd = _v6.b;
		var _v7 = function () {
			var _v8 = _Utils_Tuple2(company, practice);
			if ((!_v8.a.$) && (!_v8.b.$)) {
				var company_ = _v8.a.a;
				var practice_ = _v8.b.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A3($author$project$Components$Company$Admins$init, shared.D5, company_, practice_));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var companyAdmins = _v7.a;
		var companyAdminsCmd = _v7.b;
		var _v9 = function () {
			var _v10 = _Utils_Tuple2(company, practice);
			if ((!_v10.a.$) && (!_v10.b.$)) {
				var company_ = _v10.a.a;
				var practice_ = _v10.b.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A6($author$project$Components$Company$CommissionDeals$init, session, company_, practice_, shared.D5, shared.cO, shared.Hz));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var commissionDeals = _v9.a;
		var commissionDealsCmd = _v9.b;
		return _Utils_Tuple2(
			{D5: shared.D5, lx: commissionDeals, ly: companyAdmins, ak: companyPlans, hU: contactForm, cO: shared.cO, lN: deactivateSponsor, M6: $elm$core$Maybe$Nothing, M9: $elm$core$Maybe$Nothing, h5: $elm$core$Maybe$Nothing, xp: employeeDivisions, l5: enrollment, adR: params.ff, WF: practice, ZD: session, Hz: shared.Hz},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$Company$retrieve, shared.D5, session, params.ff, $author$project$Pages$Companies$CompanyId_String$Top$GotCompany),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg, commissionDealsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg, companyAdminsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg, deactivateSponsorCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg, enrollmentCmd)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$Admins$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$CommissionDeals$CreateModalMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$CommissionDeals$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$CommissionDeals$CreateModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$CreateModal$subscriptions, model.hY))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$subscriptions(model.dt))
			]));
};
var $author$project$Components$Company$ContactForm$GotPhoneInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$ContactForm$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = $author$project$Utils$Form$fields(model.PB);
	var phone = _v1.Wg;
	var address = _v1.It;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$ContactForm$AddressInputMsg,
				$author$project$Components$AddressInput$subscriptions(address)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$ContactForm$GotPhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(phone))
			]));
};
var $author$project$Components$Company$DeactivateSponsor$HiConfirmClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$DeactivateSponsor$subscriptions = function (model) {
	return model.iL ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$DeactivateSponsor$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$DefaultAffiliation$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$DefaultLocation$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$DefaultProvider$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$Enrollment$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Company$Plans$ClosePricingDetailsModal = {$: 19};
var $author$project$Components$Company$Plans$CoveragePlanMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$Plans$HiConfirmPlanAddClosed = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Company$Plans$HiConfirmPlanChangedClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Company$Plans$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$ClosePricingDetailsModal)),
					model.j0)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Company$Plans$CoveragePlanMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.L5))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed)),
					model.bu)),
				function () {
				var _v0 = _Utils_Tuple2(model.Nh, model.he);
				if ((!_v0.a.$) && _v0.b) {
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmPlanChangedClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmPlanAddClosed)),
					model.ee))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg,
				$author$project$Components$Company$ContactForm$subscriptions(model.hU)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg,
				$author$project$Components$Company$Plans$subscriptions(model.ak)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg,
				$author$project$Components$Company$Enrollment$subscriptions(model.l5)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$Admins$subscriptions, model.ly))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultProvider$subscriptions, model.h5))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultLocation$subscriptions, model.M9))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultAffiliation$subscriptions, model.M6))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$CommissionDeals$subscriptions, model.lx))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$DeactivateSponsor$subscriptions, model.lN)))
			]));
};
var $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$DefaultAffiliation$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultAffiliation$GotAffiliations = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$DefaultAffiliation$fetchAffiliations = function (apiClient) {
	return A3(
		$author$project$Api$Provider$Affiliate$list,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					afy: $author$project$Api$Pagination$init,
					af_: $elm$core$Maybe$Nothing,
					ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
					ag7: $elm$core$Maybe$Nothing
				});
		},
		$author$project$Components$Company$DefaultAffiliation$GotAffiliations);
};
var $author$project$Components$Company$DefaultAffiliation$initAffiliateResourceFilter = F3(
	function (apiClient, session, company) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Affiliate$init,
			apiClient,
			session,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Clinic', IS: false, aeZ: false});
			});
		var newResourceFilterModel = _v0.a;
		var cmd = _v0.b;
		var filterModelWithDefaults = function () {
			var _v1 = $author$project$Api$Provider$Company$One$defaultAffiliation(company);
			if (!_v1.$) {
				var affiliation = _v1.a;
				return A2(
					$author$project$Components$ResourceFilter$Affiliate$setValue,
					$elm$core$Maybe$Just(
						{
							adR: $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliation),
							zh: $author$project$Api$Provider$Affiliate$AffiliateMin$name(affiliation)
						}),
					newResourceFilterModel);
			} else {
				return newResourceFilterModel;
			}
		}();
		return _Utils_Tuple2(filterModelWithDefaults, cmd);
	});
var $author$project$Components$Company$DefaultAffiliation$initFormFields = function (company) {
	var defaultAffiliation = A2(
		$elm$core$Maybe$map,
		function (affiliation) {
			return $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliation);
		},
		$author$project$Api$Provider$Company$One$defaultAffiliation(company));
	return {IJ: defaultAffiliation};
};
var $author$project$Components$Company$DefaultAffiliation$init = F4(
	function (session, company, practice, apiClient) {
		var affiliationForm = $author$project$Components$Company$DefaultAffiliation$initFormFields(company);
		var _v0 = A3($author$project$Components$Company$DefaultAffiliation$initAffiliateResourceFilter, apiClient, session, company);
		var affiliateResourceFilter = _v0.a;
		var affiliateResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				ps: affiliateResourceFilter,
				eY: $author$project$Utils$Form$init(affiliationForm),
				pt: _List_Nil,
				ab9: company,
				WF: practice,
				jY: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg, affiliateResourceFilterCmd),
						$author$project$Components$Company$DefaultAffiliation$fetchAffiliations(apiClient)
					])));
	});
var $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$DefaultLocation$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultLocation$initFormFields = function (company) {
	var defaultLocation = A2(
		$elm$core$Maybe$map,
		function (location) {
			return $author$project$Api$Provider$Location$Shared$id(location);
		},
		$author$project$Api$Provider$Company$One$defaultLocation(company));
	return {aet: defaultLocation};
};
var $author$project$Components$Company$DefaultLocation$initLocationResourceFilter = F2(
	function (apiClient, company) {
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Location', aeZ: false});
			});
		var newResourceFilterModel = _v0.a;
		var cmd = _v0.b;
		var filterModelWithDefaults = function () {
			var _v1 = $author$project$Api$Provider$Company$One$defaultLocation(company);
			if (!_v1.$) {
				var location = _v1.a;
				return function (value) {
					return A2($author$project$Components$ResourceFilter$Location$setValue, value, newResourceFilterModel);
				}(
					$author$project$Components$ResourceFilter$Location$resourceFromShared(
						$elm$core$Maybe$Just(
							$author$project$Api$Location$Shared$Provider(location))));
			} else {
				return newResourceFilterModel;
			}
		}();
		return _Utils_Tuple2(filterModelWithDefaults, cmd);
	});
var $author$project$Components$Company$DefaultLocation$init = F3(
	function (company, practice, apiClient) {
		var locationForm = $author$project$Components$Company$DefaultLocation$initFormFields(company);
		var _v0 = A2($author$project$Components$Company$DefaultLocation$initLocationResourceFilter, apiClient, company);
		var locationResourceFilter = _v0.a;
		var locationResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				ab9: company,
				fV: $author$project$Utils$Form$init(locationForm),
				rl: locationResourceFilter,
				WF: practice,
				jY: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg, locationResourceFilterCmd));
	});
var $author$project$Components$Company$DefaultProvider$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$DefaultProvider$initFormFields = function (company) {
	var defaultPractitioner = A2(
		$elm$core$Maybe$map,
		function (practitioner) {
			return $author$project$Api$Provider$Practitioner$Shared$id(practitioner);
		},
		$author$project$Api$Provider$Company$One$defaultPractitioner(company));
	return {afS: defaultPractitioner};
};
var $author$project$Components$Company$DefaultProvider$initPractitionerResourceFilter = F2(
	function (apiClient, company) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$Practitioner$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Provider', aeZ: false});
			});
		var newResourceFilterModel = _v0.a;
		var cmd = _v0.b;
		var filterModelWithDefaults = function () {
			var _v1 = $author$project$Api$Provider$Company$One$defaultPractitioner(company);
			if (!_v1.$) {
				var practitioner = _v1.a;
				return function (value) {
					return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, newResourceFilterModel);
				}(
					$author$project$Components$ResourceFilter$Practitioner$resourceFromShared(
						$elm$core$Maybe$Just(
							$author$project$Api$Practitioner$Shared$Provider(practitioner))));
			} else {
				return newResourceFilterModel;
			}
		}();
		return _Utils_Tuple2(filterModelWithDefaults, cmd);
	});
var $author$project$Components$Company$DefaultProvider$init = F3(
	function (company, practice, apiClient) {
		var providerForm = $author$project$Components$Company$DefaultProvider$initFormFields(company);
		var _v0 = A2($author$project$Components$Company$DefaultProvider$initPractitionerResourceFilter, apiClient, company);
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				ab9: company,
				WF: practice,
				jC: practitionerResourceFilter,
				gq: $author$project$Utils$Form$init(providerForm),
				jY: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg, practitionerResourceFilterCmd));
	});
var $author$project$Components$Company$Admins$CompanyAdminDeleted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Company$Admins$GotInvitation = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Components$Company$Admins$InviteLinkMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$CompanyAdmin$companyAdminPath = F2(
	function (companyId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId));
	});
var $author$project$Api$Provider$CompanyAdmin$delete = F4(
	function (apiClient, companyId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$CompanyAdmin$companyAdminPath, companyId, id_)));
	});
var $author$project$Api$Provider$CompanyAdmin$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$CompanyAdmin$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$email(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$email = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$email(shared);
};
var $author$project$Components$Company$Admins$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{Oo: string});
	});
var $author$project$Components$Company$Admins$EmailValidation = 0;
var $author$project$Components$Company$Admins$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Oo;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email.'))
		]));
var $author$project$Api$Provider$CompanyAdmin$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CompanyAdmin$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$id(shared);
};
var $author$project$Api$Provider$CompanyAdmin$invite = F4(
	function (apiClient, companyId, email_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'admin',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(email_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId))));
	});
var $author$project$Api$Provider$CompanyAdmin$reinvite = F4(
	function (apiClient, companyId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reinvite']),
					A2($author$project$Api$Provider$CompanyAdmin$companyAdminPath, companyId, id_))));
	});
var $author$project$Components$Company$Admins$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var admins = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dq: $elm$core$List$isEmpty(admins),
								po: response,
								W7: false
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{W7: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var admin = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{W7: true}),
					A4(
						$author$project$Api$Provider$CompanyAdmin$delete,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.ab9),
						$author$project$Api$Provider$CompanyAdmin$All$id(admin),
						$author$project$Components$Company$Admins$CompanyAdminDeleted(admin)),
					_List_Nil);
			case 2:
				var admin = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, model.ab9),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$CompanyAdmin$All$email(admin) + ' was successfully removed from this company')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{W7: false}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{W7: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 3:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$Admins$formFieldsValidator, model.bk);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var validatedForm = _v5.a;
					var validFormFields = _v5.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dq: false, bk: validatedForm}),
						A4(
							$author$project$Api$Provider$CompanyAdmin$invite,
							apiClient,
							$author$project$Api$Provider$Company$One$id(model.ab9),
							fields.Oo,
							A2($author$project$Components$Company$Admins$GotInvitation, fields.Oo, false)),
						_List_Nil);
				} else {
					var erroredForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bk: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var admin = msg.a;
				var adminId = $author$project$Api$Provider$CompanyAdmin$All$id(admin);
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CompanyAdmin$reinvite,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.ab9),
						adminId,
						A2(
							$author$project$Components$Company$Admins$GotInvitation,
							$author$project$Api$Provider$CompanyAdmin$All$email(admin),
							true)),
					_List_Nil);
			case 5:
				var email = msg.a;
				var isReinvite = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var sentText = isReinvite ? 'resent' : 'sent';
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bk: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit),
								po: $author$project$Api$Data$Loading
							}),
						A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, model.ab9),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invitation was successfully ' + (sentText + (' to ' + email)))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dq: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dq: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dq: false,
							bk: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$Admins$formFieldsUpdate, field, model.bk);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bk: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v7 = $author$project$Components$InviteLink$update(subMsg);
				var inviteLinkCmd = _v7.a;
				var inviteLinkOutMsg = _v7.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Admins$InviteLinkMsg, inviteLinkCmd),
					inviteLinkOutMsg);
		}
	});
var $author$project$Components$Company$CommissionDeals$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.hY;
				if (!_v1.$) {
					var createModal = _v1.a;
					var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, apiClient, subMsg, createModal);
					var _v2 = function () {
						var _v3 = createModalResult.ac5;
						switch (_v3) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createModalResult.y8),
									model.J9,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.J9, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						}
					}();
					var createModal_ = _v2.a;
					var brokerDeals = _v2.b;
					var cmd = _v2.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{J9: brokerDeals, hY: createModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$CreateModalMsg, createModalResult.EC),
									cmd
								])),
						createModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v4 = A5(
					$author$project$Components$BrokerDeal$CreateModal$init,
					apiClient,
					model.ZD,
					model.cO,
					model.Hz,
					{
						vJ: $elm$core$Maybe$Nothing,
						vK: $elm$core$Maybe$Nothing,
						Lp: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.WF),
						ab9: $elm$core$Maybe$Just(model.ab9),
						M2: 0,
						ja: $elm$core$Maybe$Nothing,
						agv: false
					});
				var createModal = _v4.a;
				var createModalCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hY: $elm$core$Maybe$Just(createModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$CreateModalMsg, createModalCmd),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerDeals = response.a;
					var headers = response.b;
					var brokerDealsTable = A2(
						$author$project$Components$BrokerDeal$Table$withBrokerDeals,
						A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals),
						model.dt);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								J9: response,
								dt: brokerDealsTable,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{J9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, apiClient, subMsg, model.dt);
				var _v6 = function () {
					var _v7 = brokerDealsTableResult.ac5;
					switch (_v7) {
						case 0:
							return _Utils_Tuple2(model.J9, $elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						case 2:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						case 3:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						case 4:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						case 5:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
						default:
							return _Utils_Tuple2(
								$author$project$Api$Data$Loading,
								A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
					}
				}();
				var brokerDeals = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{J9: brokerDeals, dt: brokerDealsTableResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg, brokerDealsTableResult.EC),
								cmd
							])),
					brokerDealsTableResult.as);
		}
	});
var $author$project$Components$Company$ContactForm$Address = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$ContactForm$Phone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$ContactForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var address = field.a;
				return _Utils_update(
					fields,
					{It: address});
			default:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Wg: phone});
		}
	});
var $author$project$Components$Company$ContactForm$NameValidation = 0;
var $author$project$Components$Company$ContactForm$AddressValidation = 1;
var $author$project$Components$Company$ContactForm$validateAddress = function (fields) {
	return $author$project$Components$AddressInput$isValid(fields.It) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please enter an address')
		]);
};
var $author$project$Components$Company$ContactForm$PhoneValidation = 2;
var $author$project$Components$Company$ContactForm$validatePhone = function (fields) {
	var _v0 = $author$project$Components$PhoneInput$getPhones(fields.Wg);
	if (!_v0.$) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter a valid phone')
			]);
	}
};
var $author$project$Components$Company$ContactForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$ContactForm$validateAddress),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$ContactForm$validatePhone)
		]));
var $author$project$Components$Company$ContactForm$CompanyUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$ContactForm$apiFormFields = function (fields) {
	var phones = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$author$project$Components$PhoneInput$getPhones(fields.Wg));
	var address = $author$project$Components$AddressInput$getAddress(fields.It);
	return {
		It: address,
		zh: fields.zh,
		Wi: A2($elm$core$List$map, $author$project$Utils$Phone$toRecord, phones)
	};
};
var $author$project$Api$Company$Shared$encodeUpdate = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(fields.zh)),
							_Utils_Tuple2(
							'address',
							$author$project$Api$Common$Address$Shared$encode(fields.It)),
							_Utils_Tuple2(
							'phones',
							A2($elm$json$Json$Encode$list, $author$project$Api$Common$Phone$Shared$encode, fields.Wi))
						])))
			]));
};
var $author$project$Api$Employer$Company$update = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdate(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
	});
var $author$project$Api$Provider$Company$update = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdate(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Api$Company$update = F5(
	function (apiClient, session, id_, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$update,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4(
			$author$project$Api$Provider$Company$update,
			apiClient,
			id_,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Components$Company$ContactForm$updateContactInformation = F4(
	function (apiClient, session, id_, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5(
			$author$project$Api$Company$update,
			apiClient,
			session,
			id_,
			$author$project$Components$Company$ContactForm$apiFormFields(fields),
			$author$project$Components$Company$ContactForm$CompanyUpdated);
	});
var $author$project$Components$Company$ContactForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$ContactForm$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var fields = $author$project$Utils$Form$fields(model.PB);
				var address = $author$project$Components$AddressInput$validate(fields.It);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Company$ContactForm$formFieldsUpdate,
					$author$project$Components$Company$ContactForm$Address(address),
					model.PB);
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$ContactForm$formFieldsValidator, newForm);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var validFormFields = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$Loading}),
						A4(
							$author$project$Components$Company$ContactForm$updateContactInformation,
							apiClient,
							model.ZD,
							$author$project$Api$Company$id(model.ab9),
							validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = $author$project$Utils$Form$fields(model.PB);
				var address = _v4.It;
				var _v5 = A2($author$project$Components$AddressInput$update, subMsg, address);
				var addressInputModel = _v5.a;
				var addressInputCmd = _v5.b;
				var outMsgs = _v5.c;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Company$ContactForm$formFieldsUpdate,
					$author$project$Components$Company$ContactForm$Address(addressInputModel),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$AddressInputMsg, addressInputCmd),
					outMsgs);
			case 4:
				var subMsg = msg.a;
				var _v6 = $author$project$Utils$Form$fields(model.PB);
				var phone = _v6.Wg;
				var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v7.a;
				var phoneCmd = _v7.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Company$ContactForm$formFieldsUpdate,
					$author$project$Components$Company$ContactForm$Phone(phoneInput),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$GotPhoneInputMsg, phoneCmd),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					var _v9 = $author$project$Components$Company$ContactForm$initFormFields(company);
					var formFields = _v9.a;
					var formFieldsCmd = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $author$project$Utils$Form$init(formFields),
								jY: response
							}),
						formFieldsCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Company$DeactivateSponsor$SponsorArchived = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Company$archive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['archive']),
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DeactivateSponsor$archiveSponsor = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Company$archive, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorArchived);
	});
var $author$project$Components$Company$DeactivateSponsor$SponsorDeactivated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Company$deactivate = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['deactivate']),
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DeactivateSponsor$deactivateSponsor = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Company$deactivate, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorDeactivated);
	});
var $author$project$Components$Company$DeactivateSponsor$SponsorReactivated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Company$reactivate = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reactivate']),
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DeactivateSponsor$reactivateSponsor = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Company$reactivate, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorReactivated);
	});
var $author$project$Components$Company$DeactivateSponsor$SponsorUnArchived = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Company$unArchive = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unarchive']),
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DeactivateSponsor$unArchiveSponsor = F2(
	function (apiClient, id) {
		return A3($author$project$Api$Provider$Company$unArchive, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorUnArchived);
	});
var $author$project$Components$Company$DeactivateSponsor$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iL: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{iL: false, W7: true}),
					A2(
						$author$project$Components$Company$DeactivateSponsor$deactivateSponsor,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.ab9)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{iL: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{W7: true}),
					A2(
						$author$project$Components$Company$DeactivateSponsor$reactivateSponsor,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.ab9)),
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{W7: true}),
					A2(
						$author$project$Components$Company$DeactivateSponsor$archiveSponsor,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.ab9)),
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{W7: true}),
					A2(
						$author$project$Components$Company$DeactivateSponsor$unArchiveSponsor,
						apiClient,
						$author$project$Api$Provider$Company$One$id(model.ab9)),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{QR: true, W7: false, jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been deactivated. The employees will be unenrolled soon')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{QR: false, W7: false, jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been reactivated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Jn: true, W7: false, jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been archived. They will not show up in your employer list.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Jn: false, W7: false, jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been unarchived.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Company$DefaultAffiliation$Affiliation = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultAffiliation$formFieldsUpdate = F2(
	function (field, fields) {
		var affiliation = field;
		return _Utils_update(
			fields,
			{
				IJ: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adR;
					},
					affiliation)
			});
	});
var $author$project$Components$Company$DefaultAffiliation$AffiliationValidation = 0;
var $author$project$Components$Company$DefaultAffiliation$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.IJ;
			},
			_Utils_Tuple2(0, ''))
		]));
var $author$project$Components$Company$DefaultAffiliation$CompanyUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Shared$encodeUpdateAffiliation = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'default_affiliation',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.IJ))
						])))
			]));
};
var $author$project$Api$Provider$Company$updateAffiliation = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateAffiliation(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DefaultAffiliation$updateDefaultAffiliation = F3(
	function (apiClient, id_, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Company$updateAffiliation, apiClient, id_, fields, $author$project$Components$Company$DefaultAffiliation$CompanyUpdated);
	});
var $author$project$Components$Company$DefaultAffiliation$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var affiliateResourceResult = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, subMsg, model.ps);
				var _v2 = function () {
					var _v3 = affiliateResourceResult.ac5;
					_v3$2:
					while (true) {
						if ((!_v3.$) && (!_v3.a.$)) {
							switch (_v3.a.a.$) {
								case 0:
									var affiliate = _v3.a.a.a;
									var newForm = A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Company$DefaultAffiliation$formFieldsUpdate,
										$elm$core$Maybe$Just(affiliate),
										model.eY);
									var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultAffiliation$formFieldsValidator, newForm);
									if (!_v4.$) {
										var _v5 = _v4.a;
										var validatedForm = _v5.a;
										var validFormFields = _v5.b;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{eY: validatedForm, jY: $author$project$Api$Data$Loading}),
											A3(
												$author$project$Components$Company$DefaultAffiliation$updateDefaultAffiliation,
												apiClient,
												$author$project$Api$Provider$Company$One$id(model.ab9),
												validFormFields));
									} else {
										var validatedForm = _v4.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{eY: validatedForm, jY: $author$project$Api$Data$NotAsked}),
											$elm$core$Platform$Cmd$none);
									}
								case 2:
									var _v6 = _v3.a.a;
									var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultAffiliation$formFieldsUpdate, $elm$core$Maybe$Nothing, model.eY);
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{eY: form}),
										$elm$core$Platform$Cmd$none);
								default:
									break _v3$2;
							}
						} else {
							break _v3$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{ps: affiliateResourceResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg, affiliateResourceResult.EC),
								cmd
							])),
					affiliateResourceResult.as);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					var formFields = $author$project$Components$Company$DefaultAffiliation$initFormFields(company);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eY: $author$project$Utils$Form$init(formFields),
								ab9: company,
								jY: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrieveCompany(
								$author$project$Api$Provider$Company$One$id(model.ab9)),
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var affiliations = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pt: affiliations}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pt: _List_Nil}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Company$DefaultLocation$Location = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultLocation$formFieldsUpdate = F2(
	function (field, fields) {
		var location = field;
		return _Utils_update(
			fields,
			{
				aet: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adR;
					},
					location)
			});
	});
var $author$project$Components$Company$DefaultLocation$LocationValidation = 0;
var $author$project$Components$Company$DefaultLocation$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.aet;
			},
			_Utils_Tuple2(0, ''))
		]));
var $author$project$Components$Company$DefaultLocation$CompanyUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Shared$encodeUpdateLocation = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'default_location',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aet))
						])))
			]));
};
var $author$project$Api$Provider$Company$updateLocation = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateLocation(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DefaultLocation$updateDefaultLocation = F3(
	function (apiClient, id_, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Company$updateLocation, apiClient, id_, fields, $author$project$Components$Company$DefaultLocation$CompanyUpdated);
	});
var $author$project$Components$Company$DefaultLocation$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var subMsg = msg.a;
			var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.rl);
			var _v2 = function () {
				var _v3 = locationResourceResult.ac5;
				_v3$2:
				while (true) {
					if ((!_v3.$) && (!_v3.a.$)) {
						switch (_v3.a.a.$) {
							case 0:
								var location = _v3.a.a.a;
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Company$DefaultLocation$formFieldsUpdate,
									$elm$core$Maybe$Just(location),
									model.fV);
								var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultLocation$formFieldsValidator, newForm);
								if (!_v4.$) {
									var _v5 = _v4.a;
									var validatedForm = _v5.a;
									var validFormFields = _v5.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{fV: validatedForm, jY: $author$project$Api$Data$Loading}),
										A3(
											$author$project$Components$Company$DefaultLocation$updateDefaultLocation,
											apiClient,
											$author$project$Api$Provider$Company$One$id(model.ab9),
											validFormFields));
								} else {
									var validatedForm = _v4.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{fV: validatedForm, jY: $author$project$Api$Data$NotAsked}),
										$elm$core$Platform$Cmd$none);
								}
							case 2:
								var _v6 = _v3.a.a;
								var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultLocation$formFieldsUpdate, $elm$core$Maybe$Nothing, model.fV);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{fV: form}),
									$elm$core$Platform$Cmd$none);
							default:
								break _v3$2;
						}
					} else {
						break _v3$2;
					}
				}
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}();
			var newModel = _v2.a;
			var cmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					newModel,
					{rl: locationResourceResult.y8}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg, locationResourceResult.EC),
							cmd
						])),
				locationResourceResult.as);
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var company = response.a;
				var formFields = $author$project$Components$Company$DefaultLocation$initFormFields(company);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ab9: company,
							fV: $author$project$Utils$Form$init(formFields),
							jY: response
						}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$OutMsg$RetrieveCompany(
							$author$project$Api$Provider$Company$One$id(model.ab9)),
							A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
						]));
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Components$Company$DefaultProvider$Practitioner = $elm$core$Basics$identity;
var $author$project$Components$Company$DefaultProvider$formFieldsUpdate = F2(
	function (field, fields) {
		var practitioner = field;
		return _Utils_update(
			fields,
			{
				afS: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adR;
					},
					practitioner)
			});
	});
var $author$project$Components$Company$DefaultProvider$PractitionerValidation = 0;
var $author$project$Components$Company$DefaultProvider$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.afS;
			},
			_Utils_Tuple2(0, ''))
		]));
var $author$project$Components$Company$DefaultProvider$CompanyUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$Shared$encodeUpdatePractitioner = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'default_practitioner',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afS))
						])))
			]));
};
var $author$project$Api$Provider$Company$updateProvider = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdatePractitioner(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$DefaultProvider$updateDefaultProvider = F3(
	function (apiClient, id_, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Provider$Company$updateProvider, apiClient, id_, fields, $author$project$Components$Company$DefaultProvider$CompanyUpdated);
	});
var $author$project$Components$Company$DefaultProvider$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var subMsg = msg.a;
			var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.jC);
			var _v2 = function () {
				var _v3 = practitionerResourceResult.ac5;
				_v3$2:
				while (true) {
					if ((!_v3.$) && (!_v3.a.$)) {
						switch (_v3.a.a.$) {
							case 0:
								var practitioner = _v3.a.a.a;
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Company$DefaultProvider$formFieldsUpdate,
									$elm$core$Maybe$Just(practitioner),
									model.gq);
								var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultProvider$formFieldsValidator, newForm);
								if (!_v4.$) {
									var _v5 = _v4.a;
									var validatedForm = _v5.a;
									var validFormFields = _v5.b;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{gq: validatedForm, jY: $author$project$Api$Data$Loading}),
										A3(
											$author$project$Components$Company$DefaultProvider$updateDefaultProvider,
											apiClient,
											$author$project$Api$Provider$Company$One$id(model.ab9),
											validFormFields));
								} else {
									var validatedForm = _v4.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{gq: validatedForm, jY: $author$project$Api$Data$NotAsked}),
										$elm$core$Platform$Cmd$none);
								}
							case 2:
								var _v6 = _v3.a.a;
								var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultProvider$formFieldsUpdate, $elm$core$Maybe$Nothing, model.gq);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{gq: form}),
									$elm$core$Platform$Cmd$none);
							default:
								break _v3$2;
						}
					} else {
						break _v3$2;
					}
				}
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}();
			var newModel = _v2.a;
			var cmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					newModel,
					{jC: practitionerResourceResult.y8}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
							cmd
						])),
				practitionerResourceResult.as);
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var company = response.a;
				var formFields = $author$project$Components$Company$DefaultProvider$initFormFields(company);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ab9: company,
							gq: $author$project$Utils$Form$init(formFields),
							jY: response
						}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$OutMsg$RetrieveCompany(
							$author$project$Api$Provider$Company$One$id(model.ab9)),
							A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
						]));
			} else {
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Components$Company$EmployeeDivisions$EmployeeDivisionDeleted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Company$EmployeeDivisions$EmployeeDivisionAdded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$EmployeeDivision$Shared$encodeAddDivision = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'employee_division',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'name',
							$elm$json$Json$Encode$string(fields.zh))
						])))
			]));
};
var $author$project$Api$Employer$EmployeeDivision$create = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$EmployeeDivision$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$EmployeeDivision$Shared$encodeAddDivision(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
	});
var $author$project$Api$Provider$Company$EmployeeDivision$create = F4(
	function (apiClient, companyId, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$EmployeeDivision$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$EmployeeDivision$Shared$encodeAddDivision(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
	});
var $author$project$Api$EmployeeDivision$create = F5(
	function (apiClient, session, companyId, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$EmployeeDivision$create,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$EmployeeDivision$All$Employer))) : A4(
			$author$project$Api$Provider$Company$EmployeeDivision$create,
			apiClient,
			companyId,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$EmployeeDivision$All$Provider)));
	});
var $author$project$Components$Company$EmployeeDivisions$addEmployeeDivision = F4(
	function (apiClient, session, company, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A5(
			$author$project$Api$EmployeeDivision$create,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			fields,
			$author$project$Components$Company$EmployeeDivisions$EmployeeDivisionAdded);
	});
var $author$project$Api$Employer$EmployeeDivision$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id_]),
					$author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
	});
var $author$project$Api$Provider$Company$EmployeeDivision$delete = F4(
	function (apiClient, companyId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id_]),
					$author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
	});
var $author$project$Api$EmployeeDivision$delete = F5(
	function (apiClient, session, companyId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$EmployeeDivision$delete, apiClient, id, toMsg) : A4($author$project$Api$Provider$Company$EmployeeDivision$delete, apiClient, companyId, id, toMsg);
	});
var $author$project$Components$Company$EmployeeDivisions$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{zh: string});
	});
var $author$project$Components$Company$EmployeeDivisions$NameValidation = 0;
var $author$project$Components$Company$EmployeeDivisions$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a division name.'))
		]));
var $author$project$Components$Company$EmployeeDivisions$CompanyUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Company$Shared$encodeUpdateRequireDivisions = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'requires_employee_divisions',
							$elm$json$Json$Encode$bool(fields.Yj))
						])))
			]));
};
var $author$project$Api$Employer$Company$updateRequireDivisions = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateRequireDivisions(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
	});
var $author$project$Api$Provider$Company$updateRequireDivisions = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateRequireDivisions(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Api$Company$updateRequireDivisions = F5(
	function (apiClient, session, id_, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$updateRequireDivisions,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4(
			$author$project$Api$Provider$Company$updateRequireDivisions,
			apiClient,
			id_,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Components$Company$EmployeeDivisions$updateCompanyRequireDivisions = F4(
	function (apiClient, session, id_, requireDivisions) {
		var fields = {Yj: requireDivisions};
		return A5($author$project$Api$Company$updateRequireDivisions, apiClient, session, id_, fields, $author$project$Components$Company$EmployeeDivisions$CompanyUpdated);
	});
var $author$project$Api$Company$Shared$encodeUpdateUsesDivisions = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'uses_employee_divisions',
							$elm$json$Json$Encode$bool(fields.aaE))
						])))
			]));
};
var $author$project$Api$Employer$Company$updateUsesDivisions = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateUsesDivisions(fields),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
	});
var $author$project$Api$Provider$Company$updateUsesDivisions = F4(
	function (apiClient, id_, fields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Company$Shared$encodeUpdateUsesDivisions(fields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Api$Company$updateUsesDivisions = F5(
	function (apiClient, session, id_, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$updateUsesDivisions,
			apiClient,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4(
			$author$project$Api$Provider$Company$updateUsesDivisions,
			apiClient,
			id_,
			fields,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Components$Company$EmployeeDivisions$updateCompanyUsesDivisions = F4(
	function (apiClient, session, id_, usesDivisions) {
		var fields = {aaE: usesDivisions};
		return A5($author$project$Api$Company$updateUsesDivisions, apiClient, session, id_, fields, $author$project$Components$Company$EmployeeDivisions$CompanyUpdated);
	});
var $author$project$Components$Company$EmployeeDivisions$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$EmployeeDivisions$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Yj: bool}),
					A4(
						$author$project$Components$Company$EmployeeDivisions$updateCompanyRequireDivisions,
						apiClient,
						model.ZD,
						$author$project$Api$Company$id(model.ab9),
						bool),
					_List_Nil);
			case 2:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Yj: model.Yj && bool, aaE: bool}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A4(
								$author$project$Components$Company$EmployeeDivisions$updateCompanyUsesDivisions,
								apiClient,
								model.ZD,
								$author$project$Api$Company$id(model.ab9),
								bool),
								A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.ZD, model.ab9)
							])),
					_List_Nil);
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{xp: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v2 = function () {
					var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$EmployeeDivisions$formFieldsValidator, model.PB);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var validatedForm = _v4.a;
						var validFormFields = _v4.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{PB: validatedForm, jY: $author$project$Api$Data$Loading}),
							A4($author$project$Components$Company$EmployeeDivisions$addEmployeeDivision, apiClient, model.ZD, model.ab9, validFormFields));
					} else {
						var validatedForm = _v3.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{PB: validatedForm, jY: $author$project$Api$Data$NotAsked}),
							$elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(newModel, cmd, _List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrieveCompany(
								$author$project$Api$Company$id(model.ab9)),
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var division = msg.a;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$EmployeeDivision$delete,
						apiClient,
						model.ZD,
						$author$project$Api$Company$id(model.ab9),
						$author$project$Api$EmployeeDivision$All$id(division),
						$author$project$Components$Company$EmployeeDivisions$EmployeeDivisionDeleted(division)),
					_List_Nil);
			case 7:
				var division = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.ZD, model.ab9),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$EmployeeDivision$All$name(division) + ' was successfully removed from this company')
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v7 = $author$project$Components$Company$EmployeeDivisions$initFormFields;
				var formFields = _v7.a;
				var formFieldsCmd = _v7.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $author$project$Utils$Form$init(formFields)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.ZD, model.ab9),
										formFieldsCmd
									])),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, ' A new division was successfully added to this company')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $author$project$Utils$Form$init(formFields)
								}),
							formFieldsCmd,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Company$Enrollment$AttemptedSave = {$: 1};
var $author$project$Components$Company$Enrollment$BackBillPeriods = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$Enrollment$debounceBackBillingPeriod = function (_v0) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed($author$project$Components$Company$Enrollment$AttemptedSave));
};
var $author$project$Components$Company$Enrollment$DebounceMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Company$Enrollment$debounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Company$Enrollment$DebounceMsg
};
var $author$project$Api$Employer$Company$EnrollmentSetting$backBillPeriods = function (_v0) {
	var record = _v0;
	return record.JP;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$backBillPeriods = function (_v0) {
	var record = _v0;
	return record.JP;
};
var $author$project$Api$Company$EnrollmentSetting$backBillPeriods = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting_);
	}
};
var $author$project$Api$Provider$Company$EnrollmentSetting$employeeInviteNotification = function (_v0) {
	var record = _v0;
	return record.Or;
};
var $author$project$Api$Company$EnrollmentSetting$employeeInviteNotification = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$employeeInviteNotification(enrollmentSetting_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.OF;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.OF;
};
var $author$project$Api$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting_);
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$limitBackBill = function (_v0) {
	var record = _v0;
	return record.SS;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$limitBackBill = function (_v0) {
	var record = _v0;
	return record.SS;
};
var $author$project$Api$Company$EnrollmentSetting$limitBackBill = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$limitBackBill(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$limitBackBill(enrollmentSetting_);
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$numberDependentsAllowed = function (_v0) {
	var record = _v0;
	return record.UQ;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$numberDependentsAllowed = function (_v0) {
	var record = _v0;
	return record.UQ;
};
var $author$project$Api$Company$EnrollmentSetting$numberDependentsAllowed = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting_);
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.$x;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function (_v0) {
	var record = _v0;
	return record.$x;
};
var $author$project$Api$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting_);
	}
};
var $author$project$Api$Employer$Company$EnrollmentSetting$useTerminationCutOffDate = function (_v0) {
	var record = _v0;
	return record.aax;
};
var $author$project$Api$Provider$Company$EnrollmentSetting$useTerminationCutOffDate = function (_v0) {
	var record = _v0;
	return record.aax;
};
var $author$project$Api$Company$EnrollmentSetting$useTerminationCutOffDate = function (signupSetting) {
	if (!signupSetting.$) {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Provider$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting_);
	} else {
		var enrollmentSetting_ = signupSetting.a;
		return $author$project$Api$Employer$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting_);
	}
};
var $author$project$Components$Company$Enrollment$formFieldsInitFromEnrollmentSetting = function (enrollmentSetting) {
	return {
		JP: $elm$core$String$fromInt(
			$author$project$Api$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting)),
		Or: A2(
			$elm$core$Maybe$withDefault,
			'practice_default',
			$author$project$Api$Company$EnrollmentSetting$employeeInviteNotification(enrollmentSetting)),
		OF: $author$project$Api$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting),
		SS: $author$project$Api$Company$EnrollmentSetting$limitBackBill(enrollmentSetting),
		UQ: $author$project$Api$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting),
		$x: $author$project$Api$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting),
		o6: $author$project$Api$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting)
	};
};
var $author$project$Components$Company$Enrollment$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{SS: bool});
			case 1:
				var value = field.a;
				return _Utils_update(
					fields,
					{JP: value});
			case 2:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						UQ: A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(value))
					});
			case 3:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						OF: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(value))
					});
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{o6: bool});
			case 5:
				var value = field.a;
				return _Utils_update(
					fields,
					{
						$x: A2(
							$elm$core$Maybe$withDefault,
							1,
							$elm$core$String$toInt(value))
					});
			default:
				var value = field.a;
				return _Utils_update(
					fields,
					{Or: value});
		}
	});
var $author$project$Components$Company$Enrollment$EnrollmentSettingUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$Enrollment$encodeBackBillPeriods = function (backBillPeriods) {
	var _v0 = $elm$core$String$toInt(backBillPeriods);
	if (!_v0.$) {
		var value = _v0.a;
		return _Utils_Tuple2(
			'back_bill_periods',
			$elm$json$Json$Encode$int(value));
	} else {
		return _Utils_Tuple2('back_bill_periods', $elm$json$Json$Encode$null);
	}
};
var $author$project$Components$Company$Enrollment$encodeForm = F2(
	function (form, session) {
		var fields = $author$project$Utils$Form$fields(form);
		var encodedFields = _List_fromArray(
			[
				_Utils_Tuple2(
				'limit_back_bill',
				$elm$json$Json$Encode$bool(fields.SS)),
				$author$project$Components$Company$Enrollment$encodeBackBillPeriods(fields.JP),
				_Utils_Tuple2(
				'number_dependents_allowed',
				$elm$json$Json$Encode$int(fields.UQ)),
				_Utils_Tuple2(
				'enrollment_cutoff_day_of_month',
				$elm$json$Json$Encode$int(fields.OF)),
				_Utils_Tuple2(
				'use_termination_cutoff_date',
				$elm$json$Json$Encode$bool(fields.o6)),
				_Utils_Tuple2(
				'termination_cutoff_day_of_month',
				$elm$json$Json$Encode$int(fields.$x))
			]);
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? encodedFields : A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'employee_invite_notification',
				$author$project$Utils$String$encode(fields.Or)),
			encodedFields);
	});
var $author$project$Api$Company$EnrollmentSetting$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Company$EnrollmentSetting$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Employer$Company$EnrollmentSetting$EnrollmentSetting = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$EnrollmentSetting$Record = F6(
	function (limitBackBill, backBillPeriods, numberDependentsAllowed, enrollmentCutOffDayOfMonth, useTerminationCutOffDate, terminationCutOffDayOfMonth) {
		return {JP: backBillPeriods, OF: enrollmentCutOffDayOfMonth, SS: limitBackBill, UQ: numberDependentsAllowed, $x: terminationCutOffDayOfMonth, aax: useTerminationCutOffDate};
	});
var $author$project$Api$Employer$Company$EnrollmentSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'termination_cutoff_day_of_month',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'use_termination_cutoff_date',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'enrollment_cutoff_day_of_month',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'number_dependents_allowed',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'back_bill_periods',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'limit_back_bill',
						$elm$json$Json$Decode$bool,
						$elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$EnrollmentSetting$Record)))))));
var $author$project$Api$Employer$Company$EnrollmentSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Company$EnrollmentSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Company$EnrollmentSetting$path = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['enrollment_settings']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Company$EnrollmentSetting$update = F3(
	function (apiClient, params, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Employer$Company$EnrollmentSetting$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Company$EnrollmentSetting$path)));
	});
var $author$project$Api$Provider$Company$EnrollmentSetting$EnrollmentSetting = $elm$core$Basics$identity;
var $author$project$Api$Provider$Company$EnrollmentSetting$Record = F7(
	function (limitBackBill, backBillPeriods, numberDependentsAllowed, enrollmentCutOffDayOfMonth, useTerminationCutOffDate, terminationCutOffDayOfMonth, employeeInviteNotification) {
		return {JP: backBillPeriods, Or: employeeInviteNotification, OF: enrollmentCutOffDayOfMonth, SS: limitBackBill, UQ: numberDependentsAllowed, $x: terminationCutOffDayOfMonth, aax: useTerminationCutOffDate};
	});
var $author$project$Api$Provider$Company$EnrollmentSetting$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'employee_invite_notification',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'termination_cutoff_day_of_month',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'use_termination_cutoff_date',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enrollment_cutoff_day_of_month',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'number_dependents_allowed',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'back_bill_periods',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'limit_back_bill',
							$elm$json$Json$Decode$bool,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$EnrollmentSetting$Record))))))));
var $author$project$Api$Provider$Company$EnrollmentSetting$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Company$EnrollmentSetting$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Company$EnrollmentSetting$path = function (companyId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['enrollment_settings']),
		$author$project$Api$Provider$Company$companyPath(companyId));
};
var $author$project$Api$Provider$Company$EnrollmentSetting$update = F4(
	function (apiClient, companyId, params, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$EnrollmentSetting$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				params,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$EnrollmentSetting$path(companyId))));
	});
var $author$project$Api$Company$EnrollmentSetting$update = F5(
	function (apiClient, session, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'enrollment_settings',
					$elm$json$Json$Encode$object(params))
				]));
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Company$EnrollmentSetting$update,
			apiClient,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$EnrollmentSetting$Employer))) : A4(
			$author$project$Api$Provider$Company$EnrollmentSetting$update,
			apiClient,
			id,
			body,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Company$EnrollmentSetting$Provider)));
	});
var $author$project$Components$Company$Enrollment$updateEnrollmentSetting = F4(
	function (form, apiClient, session, company) {
		return A5(
			$author$project$Api$Company$EnrollmentSetting$update,
			apiClient,
			session,
			$author$project$Api$Company$id(company),
			A2($author$project$Components$Company$Enrollment$encodeForm, form, session),
			$author$project$Components$Company$Enrollment$EnrollmentSettingUpdated);
	});
var $author$project$Components$Company$Enrollment$BackBillPeriodsValidation = 0;
var $author$project$Components$Company$Enrollment$validateBackBillPeriods = function (_v0) {
	var backBillPeriods = _v0.JP;
	var _v1 = $elm$core$String$toInt(backBillPeriods);
	if (!_v1.$) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(0, 'Please enter a backbilling period.')
			]);
	}
};
var $author$project$Components$Company$Enrollment$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$Enrollment$validateBackBillPeriods)
		]));
var $author$project$Components$Company$Enrollment$validateForm = function (enrollmentForm) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$Enrollment$formFieldsValidator, enrollmentForm);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.a;
		return _Utils_Tuple2(form, true);
	} else {
		var form = _v0.a;
		return _Utils_Tuple2(form, false);
	}
};
var $author$project$Components$Company$Enrollment$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$Enrollment$formFieldsUpdate, field, model.b6);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b6: newForm}),
					A2(
						$elm$core$Task$perform,
						$elm$core$Basics$identity,
						$elm$core$Task$succeed($author$project$Components$Company$Enrollment$AttemptedSave)),
					_List_Nil);
			case 1:
				var _v2 = $author$project$Components$Company$Enrollment$validateForm(model.b6);
				var newForm = _v2.a;
				var isValid = _v2.b;
				return isValid ? _Utils_Tuple3(
					_Utils_update(
						model,
						{b6: newForm, W7: true}),
					A4($author$project$Components$Company$Enrollment$updateEnrollmentSetting, newForm, apiClient, model.ZD, model.ab9),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{b6: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var value = msg.a;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Company$Enrollment$formFieldsUpdate,
					$author$project$Components$Company$Enrollment$BackBillPeriods(value),
					model.b6);
				var _v3 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Company$Enrollment$debounceConfig, value, model.h4);
				var debounce = _v3.a;
				var debounceCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h4: debounce, b6: newForm}),
					debounceCmd,
					_List_Nil);
			case 3:
				var dMsg = msg.a;
				var _v4 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Company$Enrollment$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Company$Enrollment$debounceBackBillingPeriod),
					dMsg,
					model.h4);
				var debounce = _v4.a;
				var debounceCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h4: debounce}),
					debounceCmd,
					_List_Nil);
			case 4:
				var enrollmentSettingData = msg.a;
				var newModel = _Utils_update(
					model,
					{W7: false});
				if (enrollmentSettingData.$ === 3) {
					var enrollmentSetting = enrollmentSettingData.a;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{
								b6: $author$project$Utils$Form$init(
									$author$project$Components$Company$Enrollment$formFieldsInitFromEnrollmentSetting(enrollmentSetting))
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
							]));
				} else {
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(enrollmentSettingData));
				}
			default:
				var notificationSettingData = msg.a;
				var newModel = _Utils_update(
					model,
					{UN: notificationSettingData});
				if (notificationSettingData.$ === 2) {
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(notificationSettingData));
				} else {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Components$Company$Plans$CompanyPlanUpdated = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Company$Plans$GotPricingDetailsPlan = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Company$Plans$NewPlanSelected = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$CompanyPlan$ProviderOne = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Plans$PlanAdded = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$CompanyPlan$create = F4(
	function (apiClient, companyId, planId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company_plan',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'plan',
								$author$project$Utils$Encode$association(planId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CompanyPlan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId))));
	});
var $author$project$Components$Company$Plans$createCompanyPlan = F3(
	function (apiClient, company, plan) {
		return A4(
			$author$project$Api$Provider$CompanyPlan$create,
			apiClient,
			$author$project$Api$Company$id(company),
			$author$project$Api$Plan$id(plan),
			$author$project$Components$Company$Plans$PlanAdded);
	});
var $author$project$Components$Company$Plans$defaultBillingFields = {IV: $elm$core$Maybe$Nothing, Nh: $elm$core$Maybe$Nothing, Wc: $elm$core$Maybe$Nothing};
var $author$project$Components$Company$Plans$doesSupportPeriod = F2(
	function (plan, period) {
		return A2(
			$elm$core$List$member,
			period,
			$author$project$Api$Plan$periods(plan));
	});
var $author$project$Api$Employer$CompanyPlan$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$CompanyPlan$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$CompanyPlan$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyPlan$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CompanyPlan$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyPlan$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyPlan$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyPlan$One$id(one);
};
var $author$project$Api$CompanyPlan$id = function (companyPlan) {
	switch (companyPlan.$) {
		case 0:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$One$id(companyPlan_);
		case 1:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Provider$CompanyPlan$All$id(companyPlan_);
		default:
			var companyPlan_ = companyPlan.a;
			return $author$project$Api$Employer$CompanyPlan$All$id(companyPlan_);
	}
};
var $author$project$Api$Plan$coveragePlan = function (plan) {
	switch (plan.$) {
		case 0:
			return $author$project$Api$Expandable$NotExpanded;
		case 1:
			return $author$project$Api$Expandable$NotExpanded;
		case 4:
			return $author$project$Api$Expandable$NotExpanded;
		case 2:
			return $author$project$Api$Expandable$NotExpanded;
		case 6:
			return $author$project$Api$Expandable$NotExpanded;
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$coveragePlan(plan_);
		default:
			return $author$project$Api$Expandable$NotExpanded;
	}
};
var $author$project$Components$Company$Plans$initCoveragePlanRules = F3(
	function (apiClient, model, plan) {
		var _v0 = A2(
			$author$project$Api$Expandable$withDefault,
			$elm$core$Maybe$Nothing,
			$author$project$Api$Plan$coveragePlan(plan));
		if (!_v0.$) {
			var coveragePlan = _v0.a;
			return A3(
				$elm$core$Tuple$mapBoth,
				$elm$core$Maybe$Just,
				$elm$core$Platform$Cmd$map($author$project$Components$Company$Plans$CoveragePlanMsg),
				A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					apiClient,
					model.ZD,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)),
					$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan),
					$elm$core$Maybe$Nothing,
					{XO: true}));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$Employer$Company$One$activeMembershipsCount = function (_v0) {
	var record = _v0.b;
	return record.Ih;
};
var $author$project$Api$Provider$Company$One$activeMembershipsCount = function (_v0) {
	var record = _v0.b;
	return record.Ih;
};
var $author$project$Api$Company$activeMembershipsCount = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$activeMembershipsCount(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$activeMembershipsCount(company_);
	}
};
var $author$project$Components$Company$Plans$hasActiveMemberships = function (company) {
	return $author$project$Api$Company$activeMembershipsCount(company) > 0;
};
var $author$project$Api$Period$retrieveByNumberOfMonths = function (number) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (_v0) {
			var period = _v0;
			return _Utils_eq(period.ji, number);
		},
		$author$project$Api$Period$list);
};
var $author$project$Components$Company$Plans$plansWithoutPeriod = F2(
	function (newBillingPeriod, companyPlans) {
		var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths(newBillingPeriod);
		if (!maybePeriod.$) {
			var period = maybePeriod.a;
			return A2(
				$elm$core$List$filter,
				function (plan) {
					return !A2(
						$elm$core$List$member,
						period,
						$author$project$Api$Plan$periods(plan));
				},
				A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, companyPlans));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Company$Plans$needsBillingChangeConfirmation = F3(
	function (company, newBillingPeriod, companyPlans) {
		return $author$project$Components$Company$Plans$hasActiveMemberships(company) || ($elm$core$List$length(
			A2($author$project$Components$Company$Plans$plansWithoutPeriod, newBillingPeriod, companyPlans)) > 0);
	});
var $author$project$Api$Employer$Company$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Wc;
};
var $author$project$Api$Employer$Company$One$periodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$periodInMonths(shared);
};
var $author$project$Api$Provider$Company$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Wc;
};
var $author$project$Api$Provider$Company$One$periodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$periodInMonths(shared);
};
var $author$project$Api$Company$periodInMonths = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$periodInMonths(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$periodInMonths(company_);
	}
};
var $author$project$Components$Company$Plans$PlanDeleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Provider$CompanyPlan$companyPlanPath = F2(
	function (companyId, companyPlanId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[companyPlanId]),
			$author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId));
	});
var $author$project$Api$Provider$CompanyPlan$delete = F4(
	function (apiClient, companyId, companyPlanId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$CompanyPlan$companyPlanPath, companyId, companyPlanId)));
	});
var $author$project$Components$Company$Plans$removeCompanyPlan = F3(
	function (apiClient, company, companyPlan) {
		var companyPlanId = $author$project$Api$CompanyPlan$id(companyPlan);
		return A4(
			$author$project$Api$Provider$CompanyPlan$delete,
			apiClient,
			$author$project$Api$Company$id(company),
			companyPlanId,
			$author$project$Components$Company$Plans$PlanDeleted(companyPlanId));
	});
var $author$project$Components$Company$Plans$resetCompanyPlansOnToggleChange = function (model) {
	var _v0 = _Utils_Tuple2(model.Nh, model.f7);
	if ((!_v0.a.$) && (!_v0.b)) {
		var defaultPlan = _v0.a.a;
		return A2(
			$elm$core$List$filter,
			function (c) {
				return _Utils_eq(
					$author$project$Api$Plan$id(
						$author$project$Api$CompanyPlan$plan(c)),
					$author$project$Api$Plan$id(defaultPlan));
			},
			model.ak);
	} else {
		return model.ak;
	}
};
var $author$project$Components$Company$Plans$showResponseMessage = F2(
	function (response, successMessage) {
		if (response.$ === 3) {
			return _List_fromArray(
				[
					A2($author$project$OutMsg$ShowToast, 3, successMessage)
				]);
		} else {
			return $author$project$OutMsg$handleErrorResponse(response);
		}
	});
var $author$project$Api$Provider$CompanyPlan$update = F5(
	function (apiClient, companyId, companyPlanId, availableForEnrollment_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company_plan',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'available_for_enrollment',
								$elm$json$Json$Encode$bool(availableForEnrollment_))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$CompanyPlan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$CompanyPlan$companyPlanPath, companyId, companyPlanId))));
	});
var $author$project$Components$Company$Plans$CompanyUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Company$updateAffiliateBilling = F4(
	function (apiClient, id_, billAffiliateRate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bill_affiliate_rate',
								$elm$json$Json$Encode$bool(billAffiliateRate))
							])))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$Plans$updateCompanyAffiliateBilling = F3(
	function (apiClient, company, billAffiliateRate) {
		var companyId = $author$project$Api$Company$id(company);
		return A4(
			$author$project$Api$Provider$Company$updateAffiliateBilling,
			apiClient,
			companyId,
			billAffiliateRate,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Components$Company$Plans$CompanyUpdated,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Api$Provider$Company$updateBilling = F6(
	function (apiClient, id_, periodInMonths, allowCustomMembershipPlan, defaultPlanId, toMsg) {
		var defaultPlanAssociation = function (defaultPlanId_) {
			return $elm$core$Maybe$Just(
				{
					adR: $elm$core$Maybe$Just(defaultPlanId_),
					ahI: $elm$core$Maybe$Nothing
				});
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company',
					$elm$json$Json$Encode$object(
						_Utils_ap(
							A3($author$project$Utils$Encode$optional, 'period_in_months', $elm$json$Json$Encode$int, periodInMonths),
							_Utils_ap(
								A3($author$project$Utils$Encode$optional, 'allow_custom_membership_plan', $elm$json$Json$Encode$bool, allowCustomMembershipPlan),
								A3(
									$author$project$Utils$Encode$optional,
									'default_plan',
									$author$project$Utils$Encode$typedAssociation,
									A2($elm$core$Maybe$andThen, defaultPlanAssociation, defaultPlanId))))))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Company$companyPath(id_))));
	});
var $author$project$Components$Company$Plans$updateCompanyBilling = F3(
	function (apiClient, company, fields) {
		var defaultPlanId = A2($elm$core$Maybe$map, $author$project$Api$Plan$id, fields.Nh);
		var companyId = $author$project$Api$Company$id(company);
		return A6(
			$author$project$Api$Provider$Company$updateBilling,
			apiClient,
			companyId,
			fields.Wc,
			fields.IV,
			defaultPlanId,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Components$Company$Plans$CompanyUpdated,
				$author$project$Api$Data$map($author$project$Api$Company$Provider)));
	});
var $author$project$Components$Company$Plans$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var text = msg.a;
				var newBillingPeriod = $elm$core$String$toInt(text);
				if (!newBillingPeriod.$) {
					var newBillingPeriod_ = newBillingPeriod.a;
					return A3($author$project$Components$Company$Plans$needsBillingChangeConfirmation, model.ab9, newBillingPeriod_, model.ak) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{bu: newBillingPeriod, og: false}),
						$elm$core$Platform$Cmd$none,
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{bu: newBillingPeriod, og: false}),
						A3(
							$author$project$Components$Company$Plans$updateCompanyBilling,
							apiClient,
							model.ab9,
							_Utils_update(
								$author$project$Components$Company$Plans$defaultBillingFields,
								{Wc: newBillingPeriod})),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{og: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var enabled = msg.a;
				if (enabled) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{f7: true}),
						A3(
							$author$project$Components$Company$Plans$updateCompanyBilling,
							apiClient,
							model.ab9,
							_Utils_update(
								$author$project$Components$Company$Plans$defaultBillingFields,
								{
									IV: $elm$core$Maybe$Just(true)
								})),
						_List_Nil);
				} else {
					if ($elm$core$List$length(model.ak) > 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{he: true}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var cmds = $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$author$project$Components$Company$Plans$updateCompanyBilling,
									apiClient,
									model.ab9,
									_Utils_update(
										$author$project$Components$Company$Plans$defaultBillingFields,
										{
											IV: $elm$core$Maybe$Just(false)
										})),
									A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, model.ZD, model.ab9)
								]));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{f7: false}),
							cmds,
							_List_Nil);
					}
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var companyPlans = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ak: companyPlans}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ab9: company,
								ak: $author$project$Components$Company$Plans$resetCompanyPlansOnToggleChange(model)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Components$Company$Plans$showResponseMessage, response, 'Company successfully updated'));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var confirmed = msg.a;
				if (confirmed) {
					var _v4 = model.bu;
					if (!_v4.$) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bu: $elm$core$Maybe$Nothing}),
							A3(
								$author$project$Components$Company$Plans$updateCompanyBilling,
								apiClient,
								model.ab9,
								_Utils_update(
									$author$project$Components$Company$Plans$defaultBillingFields,
									{Wc: model.bu})),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bu: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bu: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var confirmed = msg.a;
				if (confirmed) {
					var defaultPlanChanged = function (plan) {
						var _v5 = $author$project$Api$Company$defaultPlan(model.ab9);
						if (!_v5.$) {
							var defaultPlan = _v5.a;
							return !_Utils_eq(
								$author$project$Api$Plan$id(plan),
								$author$project$Api$Plan$id(defaultPlan));
						} else {
							return false;
						}
					};
					var newDefaultPlan = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2($elm$core$Maybe$map, defaultPlanChanged, model.Nh)) ? model.Nh : $elm$core$Maybe$Nothing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ql: false, f7: false, he: false}),
						A3(
							$author$project$Components$Company$Plans$updateCompanyBilling,
							apiClient,
							model.ab9,
							{
								IV: $elm$core$Maybe$Just(false),
								Nh: newDefaultPlan,
								Wc: model.bu
							}),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{he: false}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 6:
				var enabled = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ql: enabled}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jw);
				var _v6 = function () {
					var _v7 = planResourceResult.ac5;
					if (!_v7.$) {
						if (!_v7.a.$) {
							var _v8 = $author$project$Components$ResourceFilter$Plan$value(planResourceResult.y8);
							if (!_v8.$) {
								var selectedPlanId = _v8.a;
								return model.dp ? _Utils_Tuple2(
									model,
									A4($author$project$Components$Company$Plans$retrievePlan, apiClient, model.ZD, selectedPlanId, $author$project$Components$Company$Plans$NewPlanSelected)) : _Utils_Tuple2(
									_Utils_update(
										model,
										{he: true}),
									A4($author$project$Components$Company$Plans$retrievePlan, apiClient, model.ZD, selectedPlanId, $author$project$Components$Company$Plans$GotDefaultPlan));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						} else {
							var _v9 = _v7.a;
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var modelAfterEvent = _v6.a;
				var resourceEvent = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						modelAfterEvent,
						{jw: planResourceResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$PlanResourceFilterMsg, planResourceResult.EC),
								resourceEvent
							])),
					planResourceResult.as);
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var plan = response.a;
					var _v11 = A3($author$project$Components$Company$Plans$initCoveragePlanRules, apiClient, model, plan);
					var coveragePlanRules = _v11.a;
					var coveragePlanRulesCmd = _v11.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L5: coveragePlanRules,
								Nh: $elm$core$Maybe$Just(plan)
							}),
						coveragePlanRulesCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dp: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var maybePlan = msg.a;
				if (!maybePlan.$) {
					var plan = maybePlan.a;
					return _Utils_Tuple3(
						model,
						A3($author$project$Components$Company$Plans$removeCompanyPlan, apiClient, model.ab9, plan),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dp: false, ee: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 12:
				var response = msg.a;
				var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths(
					$author$project$Api$Company$periodInMonths(model.ab9));
				var _v13 = _Utils_Tuple2(response, maybePeriod);
				if ((_v13.a.$ === 3) && (!_v13.b.$)) {
					var _v14 = _v13.a;
					var plan = _v14.a;
					var period = _v13.b.a;
					return A2($author$project$Components$Company$Plans$doesSupportPeriod, plan, period) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{dp: false}),
						A3($author$project$Components$Company$Plans$createCompanyPlan, apiClient, model.ab9, plan),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ee: $elm$core$Maybe$Just(plan)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var companyPlanId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ak: A2(
									$elm$core$List$filter,
									function (c) {
										return !_Utils_eq(
											$author$project$Api$CompanyPlan$id(c),
											companyPlanId);
									},
									model.ak)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully removed from this company'));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var response = msg.a;
				var _v16 = A2($author$project$Api$Data$map, $author$project$Api$CompanyPlan$ProviderOne, response);
				if (_v16.$ === 3) {
					var plan = _v16.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ak: A2($elm$core$List$cons, plan, model.ak)
							}),
						$elm$core$Platform$Cmd$none,
						A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully added to this company'));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 15:
				var plan = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Components$Company$Plans$updateCompanyBilling,
								apiClient,
								model.ab9,
								_Utils_update(
									$author$project$Components$Company$Plans$defaultBillingFields,
									{
										Nh: $elm$core$Maybe$Just(plan)
									})),
								A4(
								$author$project$Components$Company$Plans$retrievePlan,
								apiClient,
								model.ZD,
								$author$project$Api$Plan$id(plan),
								$author$project$Components$Company$Plans$GotDefaultPlan)
							])),
					_List_Nil);
			case 16:
				var plan = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L5: $elm$core$Maybe$Nothing, j0: $elm$core$Maybe$Nothing}),
					A4(
						$author$project$Components$Company$Plans$retrievePlan,
						apiClient,
						model.ZD,
						$author$project$Api$Plan$id(plan),
						$author$project$Components$Company$Plans$GotPricingDetailsPlan),
					_List_Nil);
			case 17:
				var companyPlan = msg.a;
				var availableForEnrollment = msg.b;
				return _Utils_Tuple3(
					model,
					A5(
						$author$project$Api$Provider$CompanyPlan$update,
						apiClient,
						$author$project$Api$Company$id(model.ab9),
						$author$project$Api$CompanyPlan$id(companyPlan),
						availableForEnrollment,
						$author$project$Components$Company$Plans$CompanyPlanUpdated),
					_List_Nil);
			case 20:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, model.ZD, model.ab9),
					A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully update'));
			case 18:
				var confirmed = msg.a;
				var _v17 = _Utils_Tuple2(confirmed, model.ee);
				if (_v17.a && (!_v17.b.$)) {
					var newPlanRow = _v17.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dp: false, ee: $elm$core$Maybe$Nothing}),
						A3($author$project$Components$Company$Plans$createCompanyPlan, apiClient, model.ab9, newPlanRow),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dp: false, ee: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 19:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j0: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 21:
				var response = msg.a;
				if (response.$ === 3) {
					var plan = response.a;
					var _v19 = A3($author$project$Components$Company$Plans$initCoveragePlanRules, apiClient, model, plan);
					var coveragePlanRules = _v19.a;
					var coveragePlanRulesCmd = _v19.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L5: coveragePlanRules,
								j0: $elm$core$Maybe$Just(plan)
							}),
						coveragePlanRulesCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 22:
				var subMsg = msg.a;
				var _v20 = model.L5;
				if (!_v20.$) {
					var coveragePlan = _v20.a;
					var _v21 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, coveragePlan);
					var newCoveragePlan = _v21.a;
					var coveragePlanCmd = _v21.b;
					var coveragePlanOutMsgs = _v21.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L5: $elm$core$Maybe$Just(newCoveragePlan)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$CoveragePlanMsg, coveragePlanCmd),
						coveragePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var billAffiliateRate = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Components$Company$Plans$updateCompanyAffiliateBilling, apiClient, model.ab9, billAffiliateRate),
					_List_Nil);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Company$ContactForm$update, model.D5, subMsg, model.hU);
				var newContactForm = _v1.a;
				var contactFormCmd = _v1.b;
				var contactFormOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hU: newContactForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd),
					contactFormOutMsgs);
			case 1:
				var subMsg = msg.a;
				var _v2 = model.lx;
				if (!_v2.$) {
					var companyDeals = _v2.a;
					var _v3 = A3($author$project$Components$Company$CommissionDeals$update, model.D5, subMsg, companyDeals);
					var newCommissionDeals = _v3.a;
					var commissionDealsCmd = _v3.b;
					var commissionDealsOutMsgs = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lx: $elm$core$Maybe$Just(newCommissionDeals)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg, commissionDealsCmd),
						commissionDealsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = A3($author$project$Components$Company$Plans$update, model.D5, subMsg, model.ak);
				var newCompanyPlans = _v4.a;
				var companyPlansCmd = _v4.b;
				var companyPlansOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ak: newCompanyPlans}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd),
					companyPlansOutMsgs);
			case 3:
				var subMsg = msg.a;
				var _v5 = model.ly;
				if (!_v5.$) {
					var companyAdmins = _v5.a;
					var _v6 = A3($author$project$Components$Company$Admins$update, model.D5, subMsg, companyAdmins);
					var newCompanyAdmins = _v6.a;
					var companyAdminsCmd = _v6.b;
					var companyAdminsOutMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ly: $elm$core$Maybe$Just(newCompanyAdmins)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg, companyAdminsCmd),
						companyAdminsOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var subMsg = msg.a;
				var _v7 = model.h5;
				if (!_v7.$) {
					var defaultProvider = _v7.a;
					var _v8 = A3($author$project$Components$Company$DefaultProvider$update, model.D5, subMsg, defaultProvider);
					var newProvider = _v8.a;
					var defaultProviderCmd = _v8.b;
					var defaultProviderOutMsgs = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								h5: $elm$core$Maybe$Just(newProvider)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg, defaultProviderCmd),
						defaultProviderOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var subMsg = msg.a;
				var _v9 = model.M9;
				if (!_v9.$) {
					var defaultLocation = _v9.a;
					var _v10 = A3($author$project$Components$Company$DefaultLocation$update, model.D5, subMsg, defaultLocation);
					var newLocation = _v10.a;
					var defaultLocationCmd = _v10.b;
					var defaultLocationOutMsgs = _v10.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								M9: $elm$core$Maybe$Just(newLocation)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg, defaultLocationCmd),
						defaultLocationOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var subMsg = msg.a;
				var _v11 = model.M6;
				if (!_v11.$) {
					var defaultAffiliation = _v11.a;
					var _v12 = A3($author$project$Components$Company$DefaultAffiliation$update, model.D5, subMsg, defaultAffiliation);
					var newAffiliation = _v12.a;
					var defaultAffiliationCmd = _v12.b;
					var defaultAffiliationOutMsgs = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								M6: $elm$core$Maybe$Just(newAffiliation)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, defaultAffiliationCmd),
						defaultAffiliationOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var subMsg = msg.a;
				var _v13 = A3($author$project$Components$Company$EmployeeDivisions$update, model.D5, subMsg, model.xp);
				var newDivision = _v13.a;
				var employeeDivisionsCmd = _v13.b;
				var employeeDivisionsOutMsgs = _v13.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{xp: newDivision}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd),
					employeeDivisionsOutMsgs);
			case 8:
				var subMsg = msg.a;
				var _v14 = model.lN;
				if (!_v14.$) {
					var deactivateSponsor = _v14.a;
					var _v15 = A3($author$project$Components$Company$DeactivateSponsor$update, model.D5, subMsg, deactivateSponsor);
					var sponsor = _v15.a;
					var deactivateSponsorCmd = _v15.b;
					var deactivateSponsorOutMsgs = _v15.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lN: $elm$core$Maybe$Just(sponsor)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg, deactivateSponsorCmd),
						deactivateSponsorOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var _v16 = A3($author$project$Components$Company$Enrollment$update, model.D5, subMsg, model.l5);
				var enrollmentModel = _v16.a;
				var enrollmentCmd = _v16.b;
				var enrollmentOutMsgs = _v16.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l5: enrollmentModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg, enrollmentCmd),
					enrollmentOutMsgs);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					var _v18 = A4($author$project$Components$Company$EmployeeDivisions$init, model.D5, company, model.WF, model.ZD);
					var employeeDivisions = _v18.a;
					var employeeDivisionsCmd = _v18.b;
					var _v19 = function () {
						var _v20 = _Utils_Tuple2(company, model.WF);
						if ((!_v20.a.$) && (!_v20.b.$)) {
							var company_ = _v20.a.a;
							var practice_ = _v20.b.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A3($author$project$Components$Company$DefaultProvider$init, company_, practice_, model.D5));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var defaultProvider = _v19.a;
					var defaultProviderCmd = _v19.b;
					var _v21 = function () {
						var _v22 = _Utils_Tuple2(company, model.WF);
						if ((!_v22.a.$) && (!_v22.b.$)) {
							var company_ = _v22.a.a;
							var practice_ = _v22.b.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A3($author$project$Components$Company$DefaultLocation$init, company_, practice_, model.D5));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var defaultLocation = _v21.a;
					var defaultLocationCmd = _v21.b;
					var _v23 = function () {
						var _v24 = _Utils_Tuple2(company, model.WF);
						if ((!_v24.a.$) && (!_v24.b.$)) {
							var company_ = _v24.a.a;
							var practice_ = _v24.b.a;
							return A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A4($author$project$Components$Company$DefaultAffiliation$init, model.ZD, company_, practice_, model.D5));
						} else {
							return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var defaultAffiliation = _v23.a;
					var defaultAffiliationCmd = _v23.b;
					var _v25 = A3($author$project$Components$Company$ContactForm$init, company, model.WF, model.ZD);
					var contactForm = _v25.a;
					var contactFormCmd = _v25.b;
					var _v26 = A4($author$project$Components$Company$Plans$init, model.D5, company, model.WF, model.ZD);
					var companyPlans = _v26.a;
					var companyPlansCmd = _v26.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ak: companyPlans, hU: contactForm, M6: defaultAffiliation, M9: defaultLocation, h5: defaultProvider, xp: employeeDivisions}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg, defaultLocationCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg, defaultProviderCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, defaultAffiliationCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Permission$disallowForRoles = F2(
	function (session, roles) {
		return A2(
			$elm$core$List$member,
			$author$project$Api$Platform$Session$One$role(session),
			roles);
	});
var $author$project$Ui$Panel$Hr = {$: 4};
var $author$project$Ui$Panel$hr = $author$project$Ui$Panel$Hr;
var $author$project$Components$Company$CommissionDeals$Create = {$: 3};
var $author$project$Components$Company$CommissionDeals$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg,
				$author$project$Components$BrokerDeal$Table$modal(model.dt)),
				function () {
				var _v0 = model.hY;
				if (!_v0.$) {
					var createModal = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Company$CommissionDeals$CreateModalMsg,
						$author$project$Components$BrokerDeal$CreateModal$view(createModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Allocate a share of revenue from the employer to a broker. You can manage broker accounts ')
									])),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('. ')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('If you need to remove a deal, make sure that it is ended first.')
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions(
									{
										ff: $author$project$Api$Provider$Company$One$id(model.ab9)
									}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('See Ended Deals')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Add broker deal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$Company$CommissionDeals$Create),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Broker Deal')
									]))
							]))
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg,
				A2(
					$author$project$Components$BrokerDeal$Table$view,
					_List_fromArray(
						[
							$author$project$Components$BrokerDeal$Table$loading(
							!$author$project$Api$Data$isSuccess(model.J9))
						]),
					model.dt))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewComissionedDeals = function (model) {
	var _v0 = model.WF;
	if (!_v0.$) {
		var practice_ = _v0.a;
		var _v1 = _Utils_Tuple3(
			model.lx,
			$author$project$Api$Provider$Practice$One$commissionsEnabled(practice_),
			!A2(
				$author$project$Permission$disallowForRoles,
				model.ZD,
				_List_fromArray(
					['practice_staff_limited'])));
		if (((!_v1.a.$) && _v1.b) && _v1.c) {
			var commissionDeals = _v1.a.a;
			return _List_fromArray(
				[
					$author$project$Ui$Panel$hr,
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Commission Deals')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg,
							$author$project$Components$Company$CommissionDeals$view(commissionDeals))
						]))
				]);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Company$Admins$CancelNewAdmin = {$: 7};
var $author$project$Components$Company$Admins$Email = $elm$core$Basics$identity;
var $author$project$Components$Company$Admins$FormUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Company$Admins$Invite = {$: 3};
var $author$project$Components$Company$Admins$addingUserRow = function (model) {
	if (model.dq) {
		var fields = $author$project$Utils$Form$fields(model.bk);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(fields.Oo),
										$author$project$Ui$Form$Input$placeholder('gsumner@example.com'),
										$author$project$Ui$Form$Input$autofocus(true),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Company$Admins$FormUpdated, $elm$core$Basics$identity)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, model.bk)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 0, model.bk))
									]))
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_Nil),
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Create and invite adminisitrator'},
										_List_fromArray(
											[
												$author$project$Ui$Button$size(0),
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Components$Company$Admins$Invite),
												$author$project$Ui$Button$disabled(
												$author$project$Api$Provider$Company$One$isInactive(model.ab9))
											]),
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 16),
												$author$project$Utils$Html$noBreakSpace,
												$elm$html$Html$text('Create and Invite')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$size(0),
												$author$project$Ui$Button$onClick($author$project$Components$Company$Admins$CancelNewAdmin),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									]))
							]))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$CompanyAdmin$Shared$user = function (_v0) {
	var record = _v0;
	return record.aaz;
};
var $author$project$Api$Provider$CompanyAdmin$One$user = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$user(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$user = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$user(one);
};
var $author$project$Components$InviteLink$CompanyAdmin = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Admins$Delete = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CompanyAdmin$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.RJ;
};
var $author$project$Api$Provider$CompanyAdmin$One$isDestroyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAdmin$Shared$isDestroyable(shared);
};
var $author$project$Api$Provider$CompanyAdmin$All$isDestroyable = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$CompanyAdmin$One$isDestroyable(one);
};
var $author$project$Components$Company$Admins$deleteLink = F2(
	function (processing, admin) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Remove administrator'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$size(0),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Company$Admins$Delete(admin)),
					$author$project$Ui$Button$disabled(
					(!$author$project$Api$Provider$CompanyAdmin$All$isDestroyable(admin)) || processing),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Remove')
				]));
	});
var $author$project$Components$Company$Admins$ReInvite = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$Admins$resendInvite = function (admin) {
	return $author$project$Api$Provider$CompanyAdmin$All$invitationPending(admin) ? A3(
		$author$project$Ui$Button$view,
		{abp: 'Resend invite'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$size(0),
				$author$project$Ui$Button$onClick(
				$author$project$Components$Company$Admins$ReInvite(admin)),
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Resend invite')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Company$Admins$userActions = F2(
	function (processing, admin) {
		return _List_fromArray(
			[
				$author$project$Components$Company$Admins$resendInvite(admin),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Company$Admins$InviteLinkMsg,
				$author$project$Components$InviteLink$view(
					$author$project$Components$InviteLink$CompanyAdmin(admin))),
				A2($author$project$Components$Company$Admins$deleteLink, processing, admin)
			]);
	});
var $author$project$Components$Company$Admins$viewAdmin = F2(
	function (processing, admin) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$CompanyAdmin$All$email(admin))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$User$Shared$name,
											$author$project$Api$Provider$CompanyAdmin$All$user(admin))))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
							A2($author$project$Components$Company$Admins$userActions, processing, admin))
						]))
				]));
	});
var $author$project$Components$Company$Admins$viewAdminsList = function (model) {
	var _v0 = function () {
		var _v1 = model.po;
		if (_v1.$ === 3) {
			var admins_ = _v1.a;
			return _Utils_Tuple2(false, admins_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var admins = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Email')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
				A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		_Utils_ap(
			$author$project$Components$Company$Admins$addingUserRow(model),
			A2(
				$elm$core$List$map,
				$author$project$Components$Company$Admins$viewAdmin(model.W7),
				admins)),
		_List_Nil);
};
var $author$project$Components$Company$Admins$AddAdminClicked = {$: 6};
var $author$project$Components$Company$Admins$viewNewAdminButton = function (cannotAddUser) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Add new administrator'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick($author$project$Components$Company$Admins$AddAdminClicked),
				$author$project$Ui$Button$pull(1),
				$author$project$Ui$Button$disabled(cannotAddUser),
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('New Administrator')
			]));
};
var $author$project$Components$Company$Admins$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart, $author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('These individuals will receive all emails.')
							])),
						$author$project$Components$Company$Admins$viewNewAdminButton(
						model.dq || $author$project$Api$Provider$Company$One$isInactive(model.ab9))
					])),
				$author$project$Components$Company$Admins$viewAdminsList(model)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewCompanyAdmins = function (model) {
	var _v0 = model.WF;
	if (!_v0.$) {
		var _v1 = model.ly;
		if (!_v1.$) {
			var companyAdmins = _v1.a;
			return _List_fromArray(
				[
					$author$project$Ui$Panel$hr,
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Api$Practice$sponsorize, model.WF, 'Company') + ' Administrators')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg,
							$author$project$Components$Company$Admins$view(companyAdmins))
						]))
				]);
		} else {
			return _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Ui$Icon$Invalid = 26;
var $author$project$Components$Company$Plans$periodName = function (periodInMonths) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Period$billName,
			$author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)));
};
var $author$project$Components$Company$Plans$planWithoutPeriodMessage = F2(
	function (period, plan) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Ui$Icon$view, _List_Nil, 26),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' The plan ')
						])),
					A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Plan$name(plan))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							' does not have ' + ($author$project$Components$Company$Plans$periodName(period) + ' pricing enabled'))
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							' so rates will be calculated based on ' + ($author$project$Components$Company$Plans$periodName(
								$author$project$Api$Plan$defaultPeriodInMonths(plan)) + ' rates.'))
						]))
				]));
	});
var $author$project$Components$Company$Plans$addPlanConfirmModal = function (model) {
	var _v0 = model.ee;
	if (!_v0.$) {
		var newPlanRow = _v0.a;
		var companyPeriod = $author$project$Api$Company$periodInMonths(model.ab9);
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$Plans$HiConfirmPlanAddClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Alert$warning,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Components$Company$Plans$planWithoutPeriodMessage, companyPeriod, newPlanRow)
								]))
						])),
					$author$project$Components$HiConfirm$noun('Plan'),
					$author$project$Components$HiConfirm$verb('Add')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$allowBillingPeriodChangeModal = function (model) {
	var _v0 = model.bu;
	if (!_v0.$) {
		var newBillingPeriod = _v0.a;
		var plansWithoutPeriod_ = A2($author$project$Components$Company$Plans$plansWithoutPeriod, newBillingPeriod, model.ak);
		var plansMessage = ($elm$core$List$length(plansWithoutPeriod_) > 0) ? A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Components$Company$Plans$planWithoutPeriodMessage(newBillingPeriod),
				plansWithoutPeriod_)) : $author$project$Utils$Html$empty;
		var membershipsMessage = $author$project$Components$Company$Plans$hasActiveMemberships(model.ab9) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'This will change ' + (A2(
								$author$project$Formatters$String$pluralize,
								'membership',
								$author$project$Api$Company$activeMembershipsCount(model.ab9)) + (' from billing ' + ($author$project$Components$Company$Plans$periodName(
								$author$project$Api$Company$periodInMonths(model.ab9)) + (' to billing ' + ($author$project$Components$Company$Plans$periodName(newBillingPeriod) + ' on each monthly invoice.'))))))
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Regenerating the invoice draft may take a few moments.')
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil)
				])) : $author$project$Utils$Html$empty;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
								]),
							_List_fromArray(
								[membershipsMessage, plansMessage]))
						])),
					$author$project$Components$HiConfirm$noun('Billing Period'),
					$author$project$Components$HiConfirm$verb('Change')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$viewPricingDetails = F2(
	function (plan, model) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(10),
							$author$project$Ui$FlexGrid$offset(1)
						]),
					_List_fromArray(
						[
							function () {
							if (!plan.$) {
								var plan_ = plan.a;
								return A3(
									$author$project$Components$Plan$Summary$Pricing$view,
									plan_,
									$elm$core$Maybe$Just(model.WF),
									$elm$core$Maybe$Just(model.ab9));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Company$Plans$allowMultiplePlanChangeModal = function (model) {
	var _v0 = _Utils_Tuple2(model.Nh, model.he);
	if ((!_v0.a.$) && _v0.b) {
		var plan = _v0.a.a;
		var newPricingMessage = A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('New Pricing')
						])),
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					A2(
						$author$project$Components$Company$Plans$viewPricingDetails,
						$elm$core$Maybe$Just(plan),
						model))
				]));
		var membershipMessage = $author$project$Components$Company$Plans$hasActiveMemberships(model.ab9) ? A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'All memberships in this company will be moved to ' + ($author$project$Api$Plan$name(plan) + ' effective on the current draft invoice.'))
				])) : $author$project$Utils$Html$empty;
		var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths(
			$author$project$Api$Company$periodInMonths(model.ab9));
		var planMessage = function () {
			if (!maybePeriod.$) {
				var period = maybePeriod.a;
				return (!A2($author$project$Components$Company$Plans$doesSupportPeriod, plan, period)) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 26),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('The plan ')
								])),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Plan$name(plan))
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									' does not have ' + ($author$project$Api$Period$billName(period) + (' pricing enabled so rates will be calculated based on ' + ($author$project$Components$Company$Plans$periodName(
										$author$project$Api$Plan$defaultPeriodInMonths(plan)) + ' rates.'))))
								]))
						])) : $author$project$Utils$Html$empty;
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Company$Plans$HiConfirmPlanChangedClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
								]),
							_List_fromArray(
								[planMessage, membershipMessage, newPricingMessage]))
						])),
					$author$project$Components$HiConfirm$noun('Pricing'),
					$author$project$Components$HiConfirm$verb('Update')
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$AffiliateBillRateChanged = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Company$Plans$billAffiliateRateToggle = function (model) {
	var network = $author$project$Api$Practice$network(model.WF);
	var ratesFromAffiliate = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$ratesFromAffiliate, network));
	return ratesFromAffiliate ? A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(2),
								$author$project$Ui$Form$Group$inputSpan(10),
								$author$project$Ui$Form$Group$label('Bill Affiliate Rate')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(
										$author$project$Api$Company$billAffiliateRate(model.ab9)),
										$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Company$Plans$AffiliateBillRateChanged)
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Company$Plans$BillingPeriodChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Plans$ShowBillingPeriodSelect = {$: 1};
var $author$project$Components$Company$Plans$billingPeriodOptions = A2(
	$elm$core$List$map,
	function (period) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$elm$core$String$fromInt(
					$author$project$Api$Period$numberOfMonths(period))),
			$elm_community$string_extra$String$Extra$toSentenceCase(
				$author$project$Api$Period$billName(period)));
	},
	$author$project$Api$Period$list);
var $author$project$Components$Company$Plans$billingPeriod = function (model) {
	var periodInMonths = $author$project$Api$Company$periodInMonths(model.ab9);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(2),
				$author$project$Ui$Form$Group$inputSpan(6),
				$author$project$Ui$Form$Group$label('Billed')
			]),
		_List_fromArray(
			[
				model.og ? A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(
							$elm$core$String$fromInt(periodInMonths))),
						$author$project$Ui$Form$Select$onChange($author$project$Components$Company$Plans$BillingPeriodChanged)
					]),
				$author$project$Components$Company$Plans$billingPeriodOptions) : A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm_community$string_extra$String$Extra$toSentenceCase(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Period$billName,
											$author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)))))
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Edit Billing Period'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ShowBillingPeriodSelect),
								$author$project$Ui$Button$pull(1)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit Billing Period')
							]))
					]))
			]));
};
var $author$project$Components$Company$Plans$AttemptMultiplePlanChange = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$Plans$multiplePlansToggle = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(2),
								$author$project$Ui$Form$Group$inputSpan(10),
								$author$project$Ui$Form$Group$label('Multiple Plans')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(model.f7),
										$author$project$Ui$ToggleSwitch$onChange($author$project$Components$Company$Plans$AttemptMultiplePlanChange)
									]))
							]))
					]))
			]));
};
var $author$project$Components$Company$Plans$viewAsPractice = function (practice) {
	if (!practice.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Company$Plans$pricingSettings = function (model) {
	return $author$project$Components$Company$Plans$viewAsPractice(model.WF) ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Company$Plans$billingPeriod(model),
				$author$project$Components$Company$Plans$billAffiliateRateToggle(model),
				$author$project$Components$Company$Plans$multiplePlansToggle(model)
			])) : $elm$html$Html$text('');
};
var $author$project$Components$Company$Plans$ShowDefaultPlanSelect = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Company$Plans$editSuggestionLink = function (id_) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('You can edit the plan configuration ')
					])),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Admin__Plans__Id_String(
					{adR: id_}),
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('here')
					]))
			]));
};
var $author$project$Components$Company$Plans$viewCoveragePlan = function (model) {
	var _v0 = _Utils_Tuple2(
		model.L5,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Expandable$withDefault($elm$core$Maybe$Nothing),
				A2($elm$core$Maybe$map, $author$project$Api$Plan$coveragePlan, model.Nh))));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var coveragePlanRulesModel = _v0.a.a;
		var coveragePlan = _v0.b.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Covered Charge Categories & Items')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(2),
							$author$project$Ui$Form$Group$inputSpan(6),
							$author$project$Ui$Form$Group$label('Coverage Plan')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Permission$disallowForRoles,
									model.ZD,
									_List_fromArray(
										['practice_manager', 'practice_staff', 'practice_staff_limited', 'practice_staff_limited_and_reports'])) ? A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$CoveragePlan$One$name(coveragePlan))
										])) : A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String(
										{
											adR: $author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$CoveragePlan$One$name(coveragePlan))
										]))
								]))
						])),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$elm$html$Html$map,
					$author$project$Components$Company$Plans$CoveragePlanMsg,
					$author$project$Components$Admin$CoveragePlans$Rules$view(coveragePlanRulesModel))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$showDefaultPlan = function (model) {
	var _v0 = model.Nh;
	if (!_v0.$) {
		var defaultPlan = _v0.a;
		return $author$project$Components$Company$Plans$viewAsPractice(model.WF) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(2),
							$author$project$Ui$Form$Group$inputSpan(6),
							$author$project$Ui$Form$Group$label('Default Plan')
						]),
					_List_fromArray(
						[
							model.ql ? A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(10)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Company$Plans$PlanResourceFilterMsg,
											A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.jw))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(2)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Cancel'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Company$Plans$ShowDefaultPlanSelect(false)),
													$author$project$Ui$Button$pull(1)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												]))
										]))
								])) : A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Api$Plan$name(defaultPlan))
														])),
													$author$project$Components$Company$Plans$editSuggestionLink(
													$author$project$Api$Plan$id(defaultPlan))
												])),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Change default plan'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Company$Plans$ShowDefaultPlanSelect(true))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Change Default Plan')
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(10),
									$author$project$Ui$FlexGrid$offset(1)
								]),
							_List_fromArray(
								[
									A2($elm$html$Html$hr, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					A2($author$project$Components$Company$Plans$viewPricingDetails, model.Nh, model)),
					$author$project$Components$Company$Plans$viewCoveragePlan(model)
				])) : A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2($author$project$Components$Company$Plans$viewPricingDetails, model.Nh, model));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Admin$CoverageDocuments$Form$viewAsList = function (coverageDocuments) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (coverageDocument) {
				return A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Admin$CoverageDocuments$Form$viewListItems(coverageDocument)
						]));
			},
			coverageDocuments));
};
var $author$project$Components$Company$Plans$showPricingModal = function (model) {
	var _v0 = model.j0;
	if (!_v0.$) {
		var selectedForPricingExpanding = _v0.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Company$Plans$ClosePricingDetailsModal,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Plan Pricing')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							A2(
								$author$project$Components$Company$Plans$viewPricingDetails,
								$elm$core$Maybe$Just(selectedForPricingExpanding),
								model)),
							function () {
							var _v1 = model.L5;
							if (!_v1.$) {
								var modelCoveragePlanRules = _v1.a;
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9),
											$author$project$Ui$Form$Group$clearfix,
											$author$project$Ui$Form$Group$label('Coverage Plan')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													function () {
													var coverageDocuments_ = A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$CoveragePlan$One$coverageDocuments,
														A2(
															$author$project$Api$Expandable$withDefault,
															$elm$core$Maybe$Nothing,
															$author$project$Api$Plan$coveragePlan(selectedForPricingExpanding)));
													return $author$project$Components$Admin$CoverageDocuments$Form$viewAsList(
														A2($elm$core$Maybe$withDefault, _List_Nil, coverageDocuments_));
												}(),
													A2(
													$elm$html$Html$map,
													$author$project$Components$Company$Plans$CoveragePlanMsg,
													$author$project$Components$Admin$CoveragePlans$Rules$view(modelCoveragePlanRules))
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ClosePricingDetailsModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Company$Plans$AddPlanClicked = {$: 10};
var $author$project$Components$Company$Plans$RemovePlanClicked = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Company$Plans$removeLink = function (plan) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Remove plan'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Company$Plans$RemovePlanClicked(plan)),
				$author$project$Ui$Button$size(0),
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Remove')
			]));
};
var $author$project$Components$Company$Plans$addingPlan = function (model) {
	return model.dp ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Company$Plans$PlanResourceFilterMsg,
							A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.jw))
						])),
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Company$Plans$removeLink($elm$core$Maybe$Nothing)
						]))
				]))
		]) : _List_Nil;
};
var $author$project$Components$Company$Plans$AvailableForEnrollmentToggleChanged = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Components$Company$Plans$ShowPricingClicked = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Company$Plans$hiddenForEmployer = F2(
	function (practice, html) {
		return $author$project$Components$Company$Plans$viewAsPractice(practice) ? html : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Company$Plans$MakeDefaultPlanClicked = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Company$Plans$makeDefaultLink = function (plan) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Make default'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Company$Plans$MakeDefaultPlanClicked(plan)),
				$author$project$Ui$Button$size(0)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Make Default')
			]));
};
var $author$project$Components$Company$Plans$viewPlan = F3(
	function (maybeDefaultPlan, practice, companyPlan) {
		var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
		var availableForEnrollment = $author$project$Api$CompanyPlan$availableForEnrollment(companyPlan);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Plan$name(plan)),
									$author$project$Utils$Html$noBreakSpace,
									A3(
									$author$project$Ui$Button$view,
									{abp: 'see plan details'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Company$Plans$ShowPricingClicked(plan))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('(see plan details)')
										])),
									A2(
									$author$project$Components$Company$Plans$hiddenForEmployer,
									practice,
									$author$project$Components$Company$Plans$editSuggestionLink(
										$author$project$Api$Plan$id(plan)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Company$Plans$viewAsPractice(practice) ? $author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(availableForEnrollment),
									$author$project$Ui$ToggleSwitch$onChange(
									$author$project$Components$Company$Plans$AvailableForEnrollmentToggleChanged(companyPlan))
								])) : (availableForEnrollment ? $elm$html$Html$text('Yes') : $elm$html$Html$text('No'))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v0 = _Utils_Tuple2(
							maybeDefaultPlan,
							$author$project$Components$Company$Plans$viewAsPractice(practice));
						if ((!_v0.a.$) && _v0.b) {
							var defaultPlan = _v0.a.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
									(!_Utils_eq(
										$author$project$Api$Plan$id(plan),
										$author$project$Api$Plan$id(defaultPlan))) ? _List_fromArray(
										[
											$author$project$Components$Company$Plans$makeDefaultLink(plan),
											$author$project$Components$Company$Plans$removeLink(
											$elm$core$Maybe$Just(companyPlan))
										]) : _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$muted,
													$author$project$Ui$Typography$helpBlock,
													$author$project$Ui$Typography$pull(1)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('This will be the default for new memberships')
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}())
				]));
	});
var $author$project$Components$Company$Plans$viewPlanList = function (model) {
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				$elm$core$List$isEmpty(model.ak))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Name')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Available For Enrollment')
					])),
				$author$project$Components$Company$Plans$viewAsPractice(model.WF) ? A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Add plan'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Company$Plans$AddPlanClicked),
								$author$project$Ui$Button$pull(1),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add Plan')
							]))
					])) : A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
			]),
		_Utils_ap(
			$author$project$Components$Company$Plans$addingPlan(model),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$Company$Plans$viewPlan, model.Nh, model.WF),
				model.ak)),
		_List_Nil);
};
var $author$project$Components$Company$Plans$view = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Company$Plans$allowBillingPeriodChangeModal(model),
				$author$project$Components$Company$Plans$allowMultiplePlanChangeModal(model),
				$author$project$Components$Company$Plans$showPricingModal(model),
				$author$project$Components$Company$Plans$addPlanConfirmModal(model),
				$author$project$Components$Company$Plans$pricingSettings(model),
				(!model.f7) ? $author$project$Components$Company$Plans$showDefaultPlan(model) : $author$project$Components$Company$Plans$viewPlanList(model)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewCompanyPlans = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Panel$hr,
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$elm$html$Html$text('Employee Pricing')
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg,
					$author$project$Components$Company$Plans$view(model.ak))
				]))
		]);
};
var $author$project$Components$Company$ContactForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$ContactForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$ContactForm$Save = {$: 1};
var $author$project$Components$Company$ContactForm$view = function (_v0) {
	var model = _v0;
	var sponsorString = A2($author$project$Api$Practice$sponsorize, model.WF, 'Employer');
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$onSubmit($author$project$Components$Company$ContactForm$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$inputSpan(10),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$label(sponsorString + ' Name')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.zh),
								$author$project$Ui$Form$Input$placeholder(sponsorString),
								$author$project$Ui$Form$Input$autofocus(true),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Company$ContactForm$FormUpdated, $author$project$Components$Company$ContactForm$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, model.PB))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$inputSpan(10),
						$author$project$Ui$Form$Group$label('Address')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Company$ContactForm$AddressInputMsg,
						A2($author$project$Components$AddressInput$view, _List_Nil, fields.It))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Phone'),
						$author$project$Ui$Form$Group$labelSpan(2),
						$author$project$Ui$Form$Group$inputSpan(10)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$Company$ContactForm$GotPhoneInputMsg,
						$author$project$Components$PhoneInput$view(fields.Wg))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[
						$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Upate contact information'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(loading)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Update')
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewContactInformation = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$elm$html$Html$text('Contact Information')
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg,
					$author$project$Components$Company$ContactForm$view(model.hU))
				]))
		]);
};
var $author$project$Components$Company$DeactivateSponsor$ArchiveClicked = {$: 3};
var $author$project$Components$Company$DeactivateSponsor$UnArchiveClicked = {$: 4};
var $author$project$Components$Company$DeactivateSponsor$viewArchive = F3(
	function (sponsorString, archived, processing) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			archived ? _List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Unarchive ' + sponsorString)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Unarchiving a sponsor shows them on your main employer list. ')
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Unarchive sponsor'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$disabled(processing),
							$author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$UnArchiveClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Unarchive')
						]))
				]) : _List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Archive ' + sponsorString)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Archiving a sponsor simply hides them from your main employer list. ')
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Archive sponsor'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$disabled(processing),
							$author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$ArchiveClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Archive')
						]))
				]));
	});
var $author$project$Components$Company$DeactivateSponsor$HiConfirmOpened = {$: 0};
var $author$project$Components$Company$DeactivateSponsor$viewDeactivate = F2(
	function (sponsorString, processing) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$margin(2)
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Deactivate ' + sponsorString)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deactivate this sponsor account. This will end all employee memberships and stop billing invoices to this employer. ')
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Deactivate sponsor'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$disabled(processing),
							$author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$HiConfirmOpened)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deactivate')
						]))
				]));
	});
var $author$project$Components$Company$DeactivateSponsor$ReactivateClicked = {$: 2};
var $author$project$Components$Company$DeactivateSponsor$viewReactivate = F3(
	function (sponsorString, archived, processing) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Reactivate ' + sponsorString)
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('This has no immediate effect except to make it possible to enroll and bill for employees again. ')
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Reactivate sponsor'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$disabled(archived || processing),
							$author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$ReactivateClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Reactivate')
						]))
				]));
	});
var $author$project$Components$Company$DeactivateSponsor$view = function (model) {
	var sponsorString = A2($author$project$Formatters$String$sponsorize, model.WF, 'Employer');
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				model.QR ? A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						A3($author$project$Components$Company$DeactivateSponsor$viewReactivate, sponsorString, model.Jn, model.W7),
						A2($elm$html$Html$hr, _List_Nil, _List_Nil),
						A3($author$project$Components$Company$DeactivateSponsor$viewArchive, sponsorString, model.Jn, model.W7)
					])) : A2($author$project$Components$Company$DeactivateSponsor$viewDeactivate, sponsorString, model.W7),
				A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						if (model.iL) {
							var sponsorName = $author$project$Api$Provider$Company$One$name(model.ab9);
							return A2(
								$author$project$Components$HiConfirm$modal,
								$author$project$Components$Company$DeactivateSponsor$HiConfirmClosed,
								_List_fromArray(
									[
										$author$project$Components$HiConfirm$verb('deactivate'),
										$author$project$Components$HiConfirm$noun(sponsorName),
										$author$project$Components$HiConfirm$customMessage(
										_List_fromArray(
											[
												$elm$html$Html$text('You\'re about to deactivate ' + (sponsorName + ' which will cancel their memberships and disable emails and invoicing. This action cannot be undone.'))
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewDeactivateSponsor = function (model) {
	var _v0 = model.WF;
	if (!_v0.$) {
		var _v1 = model.lN;
		if (!_v1.$) {
			var deactivateSponsor = _v1.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg,
				$author$project$Components$Company$DeactivateSponsor$view(deactivateSponsor));
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Company$DefaultAffiliation$viewDefaultAffiliation = function (practitionerResourceFilter) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Default Primary Care Clinic')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Choose a default primary care clinic to be assigned to all covered employees.')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(7),
								$author$project$Ui$FlexGrid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg,
								A2(
									$author$project$Components$ResourceFilter$Affiliate$view,
									_List_fromArray(
										[
											$author$project$Components$ResourceFilter$style(0)
										]),
									practitionerResourceFilter))
							]))
					]))
			]));
};
var $author$project$Components$Company$DefaultAffiliation$view = function (_v0) {
	var model = _v0;
	return $elm$core$List$isEmpty(model.pt) ? $author$project$Utils$Html$empty : $author$project$Components$Company$DefaultAffiliation$viewDefaultAffiliation(model.ps);
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultAffiliation = function (model) {
	var _v0 = model.WF;
	if (!_v0.$) {
		var _v1 = model.M6;
		if (!_v1.$) {
			var defaultAffiliation = _v1.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg,
				$author$project$Components$Company$DefaultAffiliation$view(defaultAffiliation));
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Company$DefaultLocation$viewDefaultLocation = function (practitionerResourceFilter) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Default Location')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Choose a location to be assigned to all covered employees.')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(7),
								$author$project$Ui$FlexGrid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg,
								A2(
									$author$project$Components$ResourceFilter$Location$view,
									_List_fromArray(
										[
											$author$project$Components$ResourceFilter$style(0)
										]),
									practitionerResourceFilter))
							]))
					]))
			]));
};
var $author$project$Components$Company$DefaultLocation$view = function (_v0) {
	var model = _v0;
	return $author$project$Api$Provider$Practice$One$hasLocations(model.WF) ? $author$project$Components$Company$DefaultLocation$viewDefaultLocation(model.rl) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultLocation = function (model) {
	var _v0 = model.WF;
	if (!_v0.$) {
		var _v1 = model.M9;
		if (!_v1.$) {
			var defaultLocation = _v1.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg,
				$author$project$Components$Company$DefaultLocation$view(defaultLocation));
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Company$DefaultProvider$viewDefaultProvider = function (practitionerResourceFilter) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Default Provider')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Choose a provider to be assigned to all covered employees.')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(7),
								$author$project$Ui$FlexGrid$offsetSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg,
								A2(
									$author$project$Components$ResourceFilter$Practitioner$view,
									_List_fromArray(
										[
											$author$project$Components$ResourceFilter$style(0)
										]),
									practitionerResourceFilter))
							]))
					]))
			]));
};
var $author$project$Components$Company$DefaultProvider$view = function (_v0) {
	var model = _v0;
	return $author$project$Api$Provider$Practice$One$hasPractitioners(model.WF) ? $author$project$Components$Company$DefaultProvider$viewDefaultProvider(model.jC) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultProvider = function (model) {
	var _v0 = model.WF;
	if (!_v0.$) {
		var _v1 = model.h5;
		if (!_v1.$) {
			var defaultProvider = _v1.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg,
				$author$project$Components$Company$DefaultProvider$view(defaultProvider));
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Company$EmployeeDivisions$SelectedRequireDivisions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$SelectedUsesDivisions = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$CreateDivisionClicked = {$: 5};
var $author$project$Components$Company$EmployeeDivisions$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$Name = $elm$core$Basics$identity;
var $author$project$Api$Employer$Company$Shared$isInactive = function (_v0) {
	var record = _v0;
	return record.QR;
};
var $author$project$Api$Employer$Company$One$isInactive = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$isInactive(shared);
};
var $author$project$Api$Company$isInactive = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$isInactive(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$isInactive(company_);
	}
};
var $author$project$Components$Company$EmployeeDivisions$addingDivision = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$group(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.zh),
											$author$project$Ui$Form$Input$placeholder('Human Resources'),
											$author$project$Ui$Form$Input$autofocus(true),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$Company$EmployeeDivisions$FormUpdated, $elm$core$Basics$identity)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, 0, model.PB))
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Create division'},
									_List_fromArray(
										[
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick($author$project$Components$Company$EmployeeDivisions$CreateDivisionClicked),
											$author$project$Ui$Button$disabled(
											$author$project$Api$Company$isInactive(model.ab9)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Create Division')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Api$Employer$EmployeeDivision$All$assignedAccounts = function (_v0) {
	var record = _v0.b;
	return record.Jo;
};
var $author$project$Api$Provider$EmployeeDivision$All$assignedAccounts = function (_v0) {
	var record = _v0.b;
	return record.Jo;
};
var $author$project$Api$EmployeeDivision$All$assignedAccounts = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$assignedAccounts(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$assignedAccounts(employeeDivision_);
	}
};
var $author$project$Components$Company$EmployeeDivisions$Delete = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Company$EmployeeDivisions$deleteDivision = function (division) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Remove division'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$size(0),
				$author$project$Ui$Button$onClick(
				$author$project$Components$Company$EmployeeDivisions$Delete(division)),
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Remove')
			]));
};
var $author$project$Api$Employer$EmployeeDivision$All$eligibleAccounts = function (_v0) {
	var record = _v0.b;
	return record.Om;
};
var $author$project$Api$Provider$EmployeeDivision$All$eligibleAccounts = function (_v0) {
	var record = _v0.b;
	return record.Om;
};
var $author$project$Api$EmployeeDivision$All$eligibleAccounts = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$eligibleAccounts(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$eligibleAccounts(employeeDivision_);
	}
};
var $author$project$Api$Employer$EmployeeDivision$All$enrolledAccounts = function (_v0) {
	var record = _v0.b;
	return record.OD;
};
var $author$project$Api$Provider$EmployeeDivision$All$enrolledAccounts = function (_v0) {
	var record = _v0.b;
	return record.OD;
};
var $author$project$Api$EmployeeDivision$All$enrolledAccounts = function (employeeDivision) {
	if (!employeeDivision.$) {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Provider$EmployeeDivision$All$enrolledAccounts(employeeDivision_);
	} else {
		var employeeDivision_ = employeeDivision.a;
		return $author$project$Api$Employer$EmployeeDivision$All$enrolledAccounts(employeeDivision_);
	}
};
var $author$project$Components$Company$EmployeeDivisions$viewDivision = function (division) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$EmployeeDivision$All$name(division))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$author$project$Api$EmployeeDivision$All$assignedAccounts(division))))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$author$project$Api$EmployeeDivision$All$eligibleAccounts(division))))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$author$project$Api$EmployeeDivision$All$enrolledAccounts(division))))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(3)
					]),
				_List_fromArray(
					[
						$author$project$Components$Company$EmployeeDivisions$deleteDivision(division)
					]))
			]));
};
var $author$project$Components$Company$EmployeeDivisions$viewDivisionsList = function (model) {
	var _v0 = function () {
		var _v1 = model.xp;
		if (_v1.$ === 3) {
			var employeeDivisions_ = _v1.a;
			return _Utils_Tuple2(false, employeeDivisions_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var employeeDivisions = _v0.b;
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$author$project$Ui$Table$view,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Name')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Assigned')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Eligible')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Enrolled')
									])),
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							]),
						A2($elm$core$List$map, $author$project$Components$Company$EmployeeDivisions$viewDivision, employeeDivisions),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				$author$project$Components$Company$EmployeeDivisions$addingDivision(model))
			]));
};
var $author$project$Components$Company$EmployeeDivisions$viewEmployeeDivisions = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$margin(2)
			]),
		_List_fromArray(
			[
				A2($elm$html$Html$hr, _List_Nil, _List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Employee Divisions')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[$author$project$Ui$Typography$helpBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text('Allows you to set a division on each employee. Invoices and reporting can then be grouped by each division. ')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(model.aaE),
										$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Company$EmployeeDivisions$SelectedUsesDivisions)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Use Employee Divisions')
									]))
							]))
					])),
				model.aaE ? A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(12)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$value(model.Yj),
										$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Company$EmployeeDivisions$SelectedRequireDivisions)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Require a division on each employee ')
									]))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(12)
							]),
						_List_fromArray(
							[
								model.aaE ? $author$project$Components$Company$EmployeeDivisions$viewDivisionsList(model) : $author$project$Utils$Html$empty
							]))
					]))
			]));
};
var $author$project$Components$Company$EmployeeDivisions$view = function (_v0) {
	var model = _v0;
	return $author$project$Components$Company$EmployeeDivisions$viewEmployeeDivisions(model);
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewEmployeeDivisions = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg,
		$author$project$Components$Company$EmployeeDivisions$view(model.xp));
};
var $author$project$Components$Company$Enrollment$title = $author$project$Ui$Typography$headingSm(
	_List_fromArray(
		[
			$elm$html$Html$text('Enrollment and Termination '),
			A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[$author$project$Ui$Typography$small]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Tooltip$view,
					_List_fromArray(
						[
							$author$project$Ui$Tooltip$placement(3)
						]),
					'Click to Learn More',
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$externalHref,
							'https://support.hint.com/employers/employer-account-setup',
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Icon$view,
									_List_fromArray(
										[$author$project$Ui$Icon$clickable]),
									5)
								]))
						]))
				]))
		]));
var $author$project$Components$Company$Enrollment$BackBillingPeriodChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Feature$NonMonthlySponsorBilling = 1;
var $author$project$Ui$Form$Input$withPostAddon = F2(
	function (addonText, options) {
		var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
		var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Form$Input$viewFeedback(optionsRecord),
						A2(
						$elm$html$Html$input,
						A2(
							$elm$core$List$cons,
							$elm$html$Html$Attributes$class('form-control'),
							A2(
								$elm$core$List$cons,
								$elm$html$Html$Attributes$value(optionsRecord.aaN),
								_Utils_ap(
									$author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.ahI),
									_Utils_ap(optionsRecord.vw, onInputHandler)))),
						_List_Nil),
						$elm$core$String$isEmpty(addonText) ? $elm$html$Html$text('') : $author$project$Ui$Form$Input$addon(
						_List_fromArray(
							[
								$elm$html$Html$text(addonText)
							]))
					]),
					A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
				]));
	});
var $author$project$Components$Company$Enrollment$viewBackBillPeriods = F5(
	function (practice, backBillPeriods, limitBackBill, form, processing) {
		return limitBackBill ? A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Allowed Backbilling Period')
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$group(
											A2(
												$author$project$Ui$Form$Input$withPostAddon,
												A2($author$project$Api$Practice$featureEnabled, 1, practice) ? 'periods' : 'months',
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(backBillPeriods),
														$author$project$Ui$Form$Input$onInput($author$project$Components$Company$Enrollment$BackBillingPeriodChanged),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
														$author$project$Ui$Form$Input$disabled(processing)
													])))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Company$Enrollment$notificationSettingPracticeValue = function (notificationSetting) {
	if (notificationSetting.$ === 3) {
		var notificationSetting_ = notificationSetting.a;
		return $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting_) ? 'On' : 'Off';
	} else {
		return 'Off';
	}
};
var $author$project$Components$Company$Enrollment$EmployeeInviteNotification = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Company$Enrollment$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Enrollment$viewEmployeeInviteButton = F4(
	function (currentValue, buttonValue, label, processing) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentValue, buttonValue)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Company$Enrollment$FormUpdated(
						$author$project$Components$Company$Enrollment$EmployeeInviteNotification(buttonValue))),
					$author$project$Ui$Button$disabled(processing)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Company$Enrollment$viewEmployeeInviteHelpText = F2(
	function (employeeInviteValue, practiceValue) {
		switch (employeeInviteValue) {
			case 'practice_default':
				return 'Will use the practice setting. Curently set to \'' + (practiceValue + '\'.');
			case 'on':
				return 'Employee invite notification will be sent.';
			default:
				return 'Employee invite notification will not be sent.';
		}
	});
var $author$project$Components$Company$Enrollment$viewEmployeeInvite = F4(
	function (employeeInviteValue, processing, canManageInvitations, notificationSetting) {
		return canManageInvitations ? A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Send Employee Invite Notification')
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Button$group(
									_List_fromArray(
										[
											A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'on', 'On', processing),
											A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'off', 'Off', processing),
											A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'practice_default', 'Practice Default', processing)
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Components$Company$Enrollment$viewEmployeeInviteHelpText,
												employeeInviteValue,
												$author$project$Components$Company$Enrollment$notificationSettingPracticeValue(notificationSetting)))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Company$Enrollment$EnrollmentCutOffDay = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Form$Select$Class = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$Select$class = $author$project$Ui$Form$Select$Class;
var $author$project$Components$Company$Enrollment$cutOffDayOptions = A2(
	$elm$core$List$map,
	$elm$core$String$fromInt,
	A2($elm$core$List$range, 1, 31));
var $author$project$Components$Company$Enrollment$viewEnrollmentCutOffDay = F2(
	function (enrollmentCutOffDayOfMonth, processing) {
		var infoText = '\n            If an employee self enrolls before the cutoff day,\n            they will be enrolled and billed from the 1st of the current month.\n            If they enroll after the cutoff day,\n            their membership will be billed and started on the first of next month.\n            ';
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Enrollment Cutoff Day')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									$elm$html$Html$text(infoText)
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Day of Month ')
										])),
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$class('select--between-text'),
											$author$project$Ui$Form$Select$inline,
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(enrollmentCutOffDayOfMonth))),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$EnrollmentCutOffDay)),
											$author$project$Ui$Form$Select$disabled(processing)
										]),
									A2(
										$elm$core$List$map,
										function (option) {
											return A3(
												$author$project$Ui$Form$Select$option,
												_List_Nil,
												$elm$core$Maybe$Just(option),
												option);
										},
										$author$project$Components$Company$Enrollment$cutOffDayOptions))
								]))
						]))
				]));
	});
var $author$project$Components$Company$Enrollment$LimitBackbill = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Company$Enrollment$viewLimitBackbillToggle = F2(
	function (limitBackBill, processing) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1),
							$author$project$Ui$FlexGrid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Limit Backbilling')
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(limitBackBill),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$LimitBackbill)),
													$author$project$Ui$ToggleSwitch$disabled(processing)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Company$Enrollment$NumberDependentsAllowed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Company$Enrollment$numberDependentsOptions = A2(
	$elm$core$List$map,
	$elm$core$String$fromInt,
	A2($elm$core$List$range, 0, 10));
var $author$project$Components$Company$Enrollment$viewNumberDependentsAllowed = F2(
	function (numberDependentsAllowed, processing) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Dependent Information')
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Employer will pay for up to ')
										])),
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$class('select--between-text'),
											$author$project$Ui$Form$Select$inline,
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(numberDependentsAllowed))),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$NumberDependentsAllowed)),
											$author$project$Ui$Form$Select$disabled(processing)
										]),
									A2(
										$elm$core$List$map,
										function (option) {
											return A3(
												$author$project$Ui$Form$Select$option,
												_List_Nil,
												$elm$core$Maybe$Just(option),
												option);
										},
										$author$project$Components$Company$Enrollment$numberDependentsOptions)),
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(' dependents for each of its employees.')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Company$Enrollment$TerminationCutOffDay = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$Enrollment$UseTerminationCutOffDay = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Company$Enrollment$viewTerminationCutOffDay = F3(
	function (useTerminationCutOffDay, terminationCutOffDayOfMonth, processing) {
		var infoText = useTerminationCutOffDay ? '\n              If a patient terminates before the cutoff day, the patient\'s end date\n              will be set to the 1st of the indicated month. If they terminate after\n              the cutoff day, the patient\'s end date will be the 1st of the following month.\n              Memberships with an end date prior to the current month will be ended on the\n              1st of the current month.\n              ' : '\n              Memberships can be ended on any day of the month.\n              Memberships with an end date prior to the current month will be ended \'today\'.\n              ';
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(11),
							$author$project$Ui$FlexGrid$offsetSm(1)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Termination Cutoff Day')
										])),
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$view(
											_List_fromArray(
												[
													$author$project$Ui$ToggleSwitch$on(useTerminationCutOffDay),
													$author$project$Ui$ToggleSwitch$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$UseTerminationCutOffDay)),
													$author$project$Ui$ToggleSwitch$disabled(processing)
												]))
										]))
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(infoText)
								])),
							useTerminationCutOffDay ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Day of Month ')
										])),
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$class('select--between-text'),
											$author$project$Ui$Form$Select$inline,
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(terminationCutOffDayOfMonth))),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$TerminationCutOffDay)),
											$author$project$Ui$Form$Select$disabled(processing)
										]),
									A2(
										$elm$core$List$map,
										function (option) {
											return A3(
												$author$project$Ui$Form$Select$option,
												_List_Nil,
												$elm$core$Maybe$Just(option),
												option);
										},
										$author$project$Components$Company$Enrollment$cutOffDayOptions))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Company$Enrollment$viewForm = F5(
	function (practice, form, processing, canManageInvitations, notificationSetting) {
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$Company$Enrollment$viewLimitBackbillToggle, fields.SS, processing),
					A5($author$project$Components$Company$Enrollment$viewBackBillPeriods, practice, fields.JP, fields.SS, form, processing),
					A2($author$project$Components$Company$Enrollment$viewNumberDependentsAllowed, fields.UQ, processing),
					A2($author$project$Components$Company$Enrollment$viewEnrollmentCutOffDay, fields.OF, processing),
					A3($author$project$Components$Company$Enrollment$viewTerminationCutOffDay, fields.o6, fields.$x, processing),
					A4($author$project$Components$Company$Enrollment$viewEmployeeInvite, fields.Or, processing, canManageInvitations, notificationSetting)
				]));
	});
var $author$project$Components$Company$Enrollment$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A5($author$project$Components$Company$Enrollment$viewForm, model.WF, model.b6, model.W7, model.Es, model.UN)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Top$viewEnrollment = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Panel$hr,
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[$author$project$Components$Company$Enrollment$title])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg,
					$author$project$Components$Company$Enrollment$view(model.l5))
				]))
		]);
};
var $author$project$Pages$Companies$CompanyId_String$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_Utils_ap(
					$author$project$Pages$Companies$CompanyId_String$Top$viewContactInformation(model),
					_Utils_ap(
						$author$project$Pages$Companies$CompanyId_String$Top$viewComissionedDeals(model),
						_Utils_ap(
							$author$project$Pages$Companies$CompanyId_String$Top$viewCompanyPlans(model),
							_Utils_ap(
								$author$project$Pages$Companies$CompanyId_String$Top$viewCompanyAdmins(model),
								_Utils_ap(
									$author$project$Pages$Companies$CompanyId_String$Top$viewEnrollment(model),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Panel$body,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Pages$Companies$CompanyId_String$Top$viewDefaultProvider(model),
													$author$project$Pages$Companies$CompanyId_String$Top$viewDefaultLocation(model),
													$author$project$Pages$Companies$CompanyId_String$Top$viewDefaultAffiliation(model),
													$author$project$Pages$Companies$CompanyId_String$Top$viewEmployeeDivisions(model),
													$author$project$Pages$Companies$CompanyId_String$Top$viewDeactivateSponsor(model)
												]))
										])))))))
			]),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Account & Pricing'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Top$init, aer: $author$project$Pages$Companies$CompanyId_String$Top$load, agD: $author$project$Pages$Companies$CompanyId_String$Top$save, ahd: $author$project$Pages$Companies$CompanyId_String$Top$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Top$update, ahP: $author$project$Pages$Companies$CompanyId_String$Top$view});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotFeedEnroller = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotUploads = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath = function (model) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(model.adR);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{afy: model.afy, af_: model.af_});
	};
};
var $author$project$Api$Upload$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Upload$All$fromEmployer = $author$project$Api$Upload$All$Employer;
var $author$project$Api$Upload$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Upload$All$fromProvider = $author$project$Api$Upload$All$Provider;
var $author$project$Api$Employer$Upload$All$Upload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Upload$All$Record = function (meta) {
	return {TU: meta};
};
var $author$project$Api$Employer$Upload$Meta$Meta = $elm$core$Basics$identity;
var $author$project$Api$Employer$Upload$Meta$Record = function (actions) {
	return {tF: actions};
};
var $author$project$Api$Employer$Upload$Meta$ActionsRecord = F4(
	function (preprocess, process, duplicate, cancel) {
		return {KF: cancel, N3: duplicate, WZ: preprocess, W5: process};
	});
var $author$project$Api$Employer$Upload$Meta$actionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cancel',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'duplicate',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'process',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'preprocess',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$Meta$ActionsRecord)))));
var $author$project$Api$Employer$Upload$Meta$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'actions',
	$author$project$Api$Employer$Upload$Meta$actionsRecordDecoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$Meta$Record));
var $author$project$Api$Employer$Upload$Meta$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Upload$Meta$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Upload$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$author$project$Api$Employer$Upload$Meta$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$All$Record));
var $author$project$Api$Employer$Upload$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Upload$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Upload$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$All$Upload)));
var $author$project$Api$Employer$Upload$uploadsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['uploads']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Upload$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$Upload$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$Upload$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Employer$Upload$uploadsPath)));
	});
var $author$project$Api$Upload$list = F5(
	function (basePath, apiClient, session, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Upload$list,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Upload$All$fromEmployer)))) : A4(
			$author$project$Api$Provider$Upload$list,
			basePath,
			apiClient,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$Upload$All$fromProvider))));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads = function (model) {
	return A5(
		$author$project$Api$Upload$list,
		$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
		model.D5,
		model.ZD,
		$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchParams(model),
		$author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotUploads);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: shared.D5,
			cG: $elm$core$Maybe$Nothing,
			lj: false,
			ab9: company,
			cR: $elm$core$Maybe$Nothing,
			iH: $author$project$Api$Data$Loading,
			adR: params.ff,
			FR: $author$project$Shared$isHintAdmin(shared),
			afu: shared.afu,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			jH: $elm$core$Maybe$Nothing,
			nK: $author$project$Api$Data$NotAsked,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			Hy: shared.Hy,
			kF: $elm$core$Maybe$Nothing,
			o5: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model),
						A4($author$project$Api$FeedEnroller$retrieve, shared.D5, session, params.ff, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotFeedEnroller)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared),
					afu: shared.afu
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed = {$: 9};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Company$UploadModal$Close = {$: 0};
var $author$project$Components$Company$UploadModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Company$UploadModal$Close);
};
var $author$project$Components$Upload$ProcessUploadModal$Close = {$: 0};
var $author$project$Components$Upload$ProcessUploadModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$ProcessUploadModal$Close);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Upload$ProcessUploadModal$subscriptions, model.jH))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Company$UploadModal$subscriptions, model.kF))),
				model.lj ? $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed)),
					model.cG)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed)),
					model.cR))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Canceled = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicated = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotProcessingStatus = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Employer$Upload$uploadPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Employer$Upload$uploadsPath);
};
var $author$project$Api$Employer$Upload$cancel = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Employer$Upload$uploadPath(id))));
	});
var $author$project$Api$Provider$Upload$cancel = F4(
	function (basePath, apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
	});
var $author$project$Api$Upload$cancel = F5(
	function (basePath, apiClient, session, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$cancel, apiClient, id, toMsg) : A4($author$project$Api$Provider$Upload$cancel, basePath, apiClient, id, toMsg);
	});
var $author$project$Api$Employer$Upload$One$Upload = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$Upload$One$Record = function (results) {
	return {YC: results};
};
var $author$project$Api$Employer$Upload$One$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'results',
	$author$project$Api$Common$Upload$Results$decoder,
	_List_Nil,
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$One$Record));
var $author$project$Api$Employer$Upload$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Upload$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Upload$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$One$Upload)));
var $author$project$Api$Employer$Upload$duplicate = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$Upload$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['duplicate']),
					$author$project$Api$Employer$Upload$uploadPath(id))));
	});
var $author$project$Api$Provider$Upload$duplicate = F4(
	function (basePath, apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Upload$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['duplicate']),
					A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
	});
var $author$project$Api$Upload$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Upload$One$fromEmployer = $author$project$Api$Upload$One$Employer;
var $author$project$Api$Upload$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Upload$One$fromProvider = $author$project$Api$Upload$One$Provider;
var $author$project$Api$Upload$duplicate = F5(
	function (basePath, apiClient, session, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Upload$duplicate,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Upload$One$fromEmployer))) : A4(
			$author$project$Api$Provider$Upload$duplicate,
			basePath,
			apiClient,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Upload$One$fromProvider)));
	});
var $author$project$Api$Employer$Upload$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$id(shared);
};
var $author$project$Api$Upload$All$id = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$id(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$id(upload_);
	}
};
var $author$project$Components$Company$UploadModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Company$UploadModal$initFormFields = {adn: $elm$core$Maybe$Nothing};
var $author$project$Components$Company$UploadModal$init = F2(
	function (basePath, session) {
		var fields = $author$project$Components$Company$UploadModal$initFormFields;
		return {
			vD: basePath,
			PB: $author$project$Utils$Form$init(fields),
			jY: $author$project$Api$Data$NotAsked,
			ZD: session
		};
	});
var $author$project$Components$Upload$ProcessUploadModal$init = F3(
	function (basePath, session, id) {
		return {vD: basePath, adR: id, nJ: $author$project$Api$Data$NotAsked, ZD: session};
	});
var $author$project$Api$Common$Upload$ProcessingStatus$isProcessing = function (_v0) {
	var record = _v0;
	return record.R0;
};
var $author$project$Api$Common$Upload$ProcessingStatus$ProcessingStatus = $elm$core$Basics$identity;
var $author$project$Api$Common$Upload$ProcessingStatus$Record = function (isProcessing) {
	return {R0: isProcessing};
};
var $author$project$Api$Common$Upload$ProcessingStatus$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_processing',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$ProcessingStatus$Record));
var $author$project$Api$Common$Upload$ProcessingStatus$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Upload$ProcessingStatus$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Upload$processingStatus = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Upload$ProcessingStatus$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['is_processing']),
					$author$project$Api$Employer$Upload$uploadsPath)));
	});
var $author$project$Api$Provider$Upload$processingStatus = F3(
	function (basePath, apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Common$Upload$ProcessingStatus$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['is_processing']),
					$author$project$Api$Provider$Upload$uploadsPath(basePath))));
	});
var $author$project$Api$Upload$processingStatus = F4(
	function (basePath, apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$Employer$Upload$processingStatus, apiClient, toMsg) : A3($author$project$Api$Provider$Upload$processingStatus, basePath, apiClient, toMsg);
	});
var $author$project$Components$Company$UploadModal$Closed = 0;
var $author$project$Components$Company$UploadModal$File = $elm$core$Basics$identity;
var $author$project$Components$Company$UploadModal$FileValidation = 0;
var $author$project$Components$Company$UploadModal$None = 1;
var $author$project$Components$Company$UploadModal$UploadCreated = 2;
var $author$project$Components$Company$UploadModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Employer$FeedEnroller$createUpload = F3(
	function (apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				function () {
					var _v0 = fields.adn;
					if (!_v0.$) {
						var file = _v0.a;
						return _List_fromArray(
							[
								A2($elm$http$Http$filePart, 'file', file)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['upload']),
						$author$project$Api$Employer$FeedEnroller$feedEnrollersPath))));
	});
var $author$project$Api$Provider$FeedEnroller$createUpload = F4(
	function (basePath, apiClient, fields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				function () {
					var _v0 = fields.adn;
					if (!_v0.$) {
						var file = _v0.a;
						return _List_fromArray(
							[
								A2($elm$http$Http$filePart, 'file', file)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['upload']),
						$author$project$Api$Provider$FeedEnroller$feedEnrollersPath(basePath)))));
	});
var $author$project$Api$FeedEnroller$createUpload = F5(
	function (basePath, apiClient, session, fields, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$FeedEnroller$createUpload, apiClient, fields, toMsg) : A4($author$project$Api$Provider$FeedEnroller$createUpload, basePath, apiClient, fields, toMsg);
	});
var $author$project$Components$Company$UploadModal$createUpload = F4(
	function (basePath, apiClient, session, validFormFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var file = _v0.adn;
		return A5(
			$author$project$Api$FeedEnroller$createUpload,
			basePath,
			apiClient,
			session,
			{adn: file},
			$author$project$Components$Company$UploadModal$Created);
	});
var $author$project$Components$Company$UploadModal$formFieldsUpdate = F2(
	function (field, fields) {
		var file = field;
		return _Utils_update(
			fields,
			{adn: file});
	});
var $author$project$Components$Company$UploadModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.adn;
			},
			_Utils_Tuple2(0, 'Please select a file.'))
		]));
var $author$project$Components$Company$UploadModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 1:
				var files = msg.a;
				var file = $elm$core$List$head(files);
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$UploadModal$formFieldsUpdate, file, model.PB);
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$UploadModal$formFieldsValidator, newForm);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var validFormFields = _v3.b;
					return {
						EC: A4($author$project$Components$Company$UploadModal$createUpload, model.vD, apiClient, model.ZD, validFormFields),
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var validatedForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: validatedForm}),
						as: _List_Nil
					};
				}
			case 2:
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$UploadModal$formFieldsValidator, model.PB);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return {
						EC: A4($author$project$Components$Company$UploadModal$createUpload, model.vD, apiClient, model.ZD, validFormFields),
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm, jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v4.a;
					var errorMsg = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($author$project$Utils$Form$validationErrors, 0, newForm)));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, errorMsg)
							])
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'File successfully uploaded.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Upload$ProcessUploadModal$Closed = 1;
var $author$project$Components$Upload$ProcessUploadModal$None = 0;
var $author$project$Components$Upload$ProcessUploadModal$Processed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Upload$ProcessUploadModal$UploadProcessing = 2;
var $author$project$Api$Employer$Upload$asyncProcess = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['async_process']),
					$author$project$Api$Employer$Upload$uploadPath(id))));
	});
var $author$project$Api$Provider$Upload$asyncProcess = F4(
	function (basePath, apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['async_process']),
					A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
	});
var $author$project$Api$Upload$asyncProcess = F5(
	function (basePath, apiClient, session, id_, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$asyncProcess, apiClient, id_, toMsg) : A4($author$project$Api$Provider$Upload$asyncProcess, basePath, apiClient, id_, toMsg);
	});
var $author$project$Components$Upload$ProcessUploadModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				return {
					EC: A5($author$project$Api$Upload$asyncProcess, model.vD, apiClient, model.ZD, model.adR, $author$project$Components$Upload$ProcessUploadModal$Processed),
					ac5: 0,
					y8: _Utils_update(
						model,
						{nJ: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{nJ: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'The file will be processed soon.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{nJ: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
						{ff: model.adR}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Api$Employer$Upload$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$status(shared);
};
var $author$project$Api$Provider$Upload$All$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$status(shared);
};
var $author$project$Api$Upload$All$status = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$status(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$status(upload_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$uploadFinishedPreprocessing = function (upload) {
	return ($author$project$Api$Upload$All$status(upload) === 5) || ($author$project$Api$Upload$All$status(upload) === 6);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								o5: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o5: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iH: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q,
								o5: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(qModel),
										$author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, o5: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(newModel),
								$author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var uploadModal = A2(
					$author$project$Components$Company$UploadModal$init,
					$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
					model.ZD);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kF: $elm$core$Maybe$Just(uploadModal)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v5 = model.kF;
				if (!_v5.$) {
					var uploadModal = _v5.a;
					var uploadModalResult = A3($author$project$Components$Company$UploadModal$update, model.D5, subMsg, uploadModal);
					var _v6 = function () {
						var _v7 = uploadModalResult.ac5;
						switch (_v7) {
							case 0:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.o5, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(uploadModalResult.y8),
									model.o5,
									$elm$core$Platform$Cmd$none);
						}
					}();
					var uploadModal_ = _v6.a;
					var uploads = _v6.b;
					var cmd = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kF: uploadModal_, o5: uploads}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg, uploadModalResult.EC),
									cmd
								])),
						uploadModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var upload = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nK: $author$project$Api$Data$Loading}),
					A4(
						$author$project$Api$Upload$processingStatus,
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
						model.D5,
						model.ZD,
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotProcessingStatus(upload)),
					_List_Nil);
			case 7:
				var upload = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var processingStatus = response.a;
					var _v9 = ((!$author$project$Api$Common$Upload$ProcessingStatus$isProcessing(processingStatus)) || $author$project$Pages$Companies$CompanyId_String$Uploads$Top$uploadFinishedPreprocessing(upload)) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							A3(
								$author$project$Components$Upload$ProcessUploadModal$init,
								$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
								model.ZD,
								$author$project$Api$Upload$All$id(upload))),
						false) : _Utils_Tuple2($elm$core$Maybe$Nothing, true);
					var processUploadModal = _v9.a;
					var cannotUploadModal = _v9.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lj: cannotUploadModal, jH: processUploadModal, nK: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nK: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var subMsg = msg.a;
				var _v10 = model.jH;
				if (!_v10.$) {
					var processUploadModal = _v10.a;
					var processUploadModalResult = A3($author$project$Components$Upload$ProcessUploadModal$update, model.D5, subMsg, processUploadModal);
					var _v11 = function () {
						var _v12 = processUploadModalResult.ac5;
						switch (_v12) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(processUploadModalResult.y8),
									model.o5,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.o5, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model));
						}
					}();
					var processUploadModal_ = _v11.a;
					var uploads = _v11.b;
					var cmd = _v11.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jH: processUploadModal_, o5: uploads}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg, processUploadModalResult.EC),
									cmd
								])),
						processUploadModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lj: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var upload = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cR: $elm$core$Maybe$Just(
								_Utils_Tuple2(upload, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var confirmed = msg.a;
				var _v13 = _Utils_Tuple2(model.cR, confirmed);
				if ((!_v13.a.$) && _v13.b) {
					var _v14 = _v13.a.a;
					var upload = _v14.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cR: $elm$core$Maybe$Just(
									_Utils_Tuple2(upload, $author$project$Api$Data$Loading))
							}),
						A5(
							$author$project$Api$Upload$duplicate,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
							model.D5,
							model.ZD,
							$author$project$Api$Upload$All$id(upload),
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicated(upload)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cR: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 12:
				var upload = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cR: $elm$core$Maybe$Nothing, o5: $author$project$Api$Data$Loading}),
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Upload successfully duplicated.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cR: $elm$core$Maybe$Just(
									_Utils_Tuple2(upload, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				var upload = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cG: $elm$core$Maybe$Just(
								_Utils_Tuple2(upload, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var confirmed = msg.a;
				var _v16 = _Utils_Tuple2(model.cG, confirmed);
				if ((!_v16.a.$) && _v16.b) {
					var _v17 = _v16.a.a;
					var upload = _v17.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cG: $elm$core$Maybe$Just(
									_Utils_Tuple2(upload, $author$project$Api$Data$Loading))
							}),
						A5(
							$author$project$Api$Upload$cancel,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
							model.D5,
							model.ZD,
							$author$project$Api$Upload$All$id(upload),
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Canceled(upload)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cG: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 15:
				var upload = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cG: $elm$core$Maybe$Nothing, o5: $author$project$Api$Data$Loading}),
						$author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Upload successfully canceled.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cG: $elm$core$Maybe$Just(
									_Utils_Tuple2(upload, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v19 = $author$project$Components$FileLink$update(subMsg);
				var getFileCmdMsg = _v19.a;
				var outMsgs = _v19.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg, getFileCmdMsg),
					outMsgs);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Upload = {$: 4};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild = function (company) {
	return $author$project$Api$Company$companyType(company) === 1;
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$canUploadFile = A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild);
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsParent = function (company) {
	return $author$project$Api$Company$companyType(company) === 2;
};
var $author$project$Api$Employer$Upload$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$name(shared);
};
var $author$project$Api$Upload$All$name = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$name(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$name(upload_);
	}
};
var $author$project$Components$Company$UploadModal$FileUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Company$UploadModal$Save = {$: 2};
var $author$project$Components$Company$UploadModal$view = function (_v0) {
	var model = _v0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Company$UploadModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Upload File')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Company$UploadModal$Save),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('File'),
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(4)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$File$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$File$accept(1),
												$author$project$Ui$Form$File$onInput($author$project$Components$Company$UploadModal$FileUploaded)
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Company$UploadModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Upload'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Company$UploadModal$Save),
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Upload')
							]))
					]))
			]));
};
var $author$project$Components$Upload$ProcessUploadModal$Process = {$: 1};
var $author$project$Components$Upload$ProcessUploadModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Upload$ProcessUploadModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Process Upload')
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Components$Upload$ProcessUploadModal$Close),
												$author$project$Ui$Button$fullWidth(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(6)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Process upload'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Components$Upload$ProcessUploadModal$Process),
												$author$project$Ui$Button$fullWidth(true),
												$author$project$Ui$Button$loading(
												_Utils_eq(model.nJ, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Process Upload')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'File'),
		A3($author$project$Api$Column$init, 'uploader_type', true, 'Type'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'started_at', true, 'Started'),
		A3($author$project$Api$Column$init, 'finished_at', true, 'Finished'),
		A3($author$project$Api$Column$init, 'rows_total', true, 'Total Rows'),
		A3($author$project$Api$Column$init, 'rows_processed_or_ignored', true, 'Processed'),
		A3($author$project$Api$Column$init, 'rows_failed', true, 'Failed'),
		A3($author$project$Api$Column$init, '', false, 'Actions')
	]);
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Cancel = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicate = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Process = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Employer$Upload$Meta$preprocessAction = function (_v0) {
	var meta = _v0;
	return meta.tF.WZ;
};
var $author$project$Api$Provider$Upload$Meta$preprocessAction = function (_v0) {
	var meta = _v0;
	return meta.tF.WZ;
};
var $author$project$Api$Upload$Meta$preprocessAction = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$Meta$preprocessAction(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$Meta$preprocessAction(upload_);
	}
};
var $author$project$Api$Employer$Upload$Meta$processAction = function (_v0) {
	var meta = _v0;
	return meta.tF.W5;
};
var $author$project$Api$Provider$Upload$Meta$processAction = function (_v0) {
	var meta = _v0;
	return meta.tF.W5;
};
var $author$project$Api$Upload$Meta$processAction = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$Meta$processAction(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$Meta$processAction(upload_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$canProcessUpload = function (meta) {
	return $author$project$Api$Upload$Meta$preprocessAction(meta) || $author$project$Api$Upload$Meta$processAction(meta);
};
var $author$project$Api$Employer$Upload$Meta$cancelAction = function (_v0) {
	var meta = _v0;
	return meta.tF.KF;
};
var $author$project$Api$Provider$Upload$Meta$cancelAction = function (_v0) {
	var meta = _v0;
	return meta.tF.KF;
};
var $author$project$Api$Upload$Meta$cancelAction = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$Meta$cancelAction(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$Meta$cancelAction(upload_);
	}
};
var $author$project$Api$Employer$Upload$Meta$duplicateAction = function (_v0) {
	var meta = _v0;
	return meta.tF.N3;
};
var $author$project$Api$Provider$Upload$Meta$duplicateAction = function (_v0) {
	var meta = _v0;
	return meta.tF.N3;
};
var $author$project$Api$Upload$Meta$duplicateAction = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$Meta$duplicateAction(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$Meta$duplicateAction(upload_);
	}
};
var $author$project$Api$Upload$uploadPath = F3(
	function (basePath, session, id_) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Upload$uploadPath(id_) : A2($author$project$Api$Provider$Upload$uploadPath, basePath, id_);
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$exportCsvPath = F2(
	function (model, upload) {
		return A4(
			$author$project$Api$Data$downloadUrl,
			model.D5,
			A3(
				$author$project$Api$Upload$uploadPath,
				$author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model),
				model.ZD,
				$author$project$Api$Upload$All$id(upload)),
			0,
			_List_Nil);
	});
var $author$project$Api$Common$Upload$Shared$rowsFailed = function (_v0) {
	var record = _v0;
	return record.YR;
};
var $author$project$Api$Employer$Upload$All$rowsFailed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsFailed(shared);
};
var $author$project$Api$Provider$Upload$All$rowsFailed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsFailed(shared);
};
var $author$project$Api$Upload$All$rowsFailed = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$rowsFailed(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$rowsFailed(upload_);
	}
};
var $author$project$Api$Common$Upload$Shared$rowsSupressed = function (_v0) {
	var record = _v0;
	return record.YU;
};
var $author$project$Api$Employer$Upload$All$rowsSupressed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsSupressed(shared);
};
var $author$project$Api$Provider$Upload$All$rowsSupressed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsSupressed(shared);
};
var $author$project$Api$Upload$All$rowsSupressed = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$rowsSupressed(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$rowsSupressed(upload_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$failedRowsCountWithoutSupressed = function (upload) {
	return $elm$core$List$maximum(
		_List_fromArray(
			[
				$author$project$Api$Upload$All$rowsFailed(upload) - $author$project$Api$Upload$All$rowsSupressed(upload),
				0
			]));
};
var $author$project$Api$Common$Upload$Shared$finishedAt = function (_v0) {
	var record = _v0;
	return record.Pr;
};
var $author$project$Api$Employer$Upload$All$finishedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$finishedAt(shared);
};
var $author$project$Api$Provider$Upload$All$finishedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$finishedAt(shared);
};
var $author$project$Api$Upload$All$finishedAt = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$finishedAt(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$finishedAt(upload_);
	}
};
var $author$project$Ui$Typography$LongText = {$: 22};
var $author$project$Ui$Typography$longText = $author$project$Ui$Typography$LongText;
var $author$project$Api$Upload$Meta$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Upload$Meta$fromEmployer = $author$project$Api$Upload$Meta$Employer;
var $author$project$Api$Upload$Meta$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Upload$Meta$fromProvider = $author$project$Api$Upload$Meta$Provider;
var $author$project$Api$Employer$Upload$All$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Provider$Upload$All$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Api$Upload$All$meta = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Upload$Meta$fromProvider(
			$author$project$Api$Provider$Upload$All$meta(upload_));
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Upload$Meta$fromEmployer(
			$author$project$Api$Employer$Upload$All$meta(upload_));
	}
};
var $author$project$Ui$Table$noWrap = $author$project$Ui$Table$NoWrap;
var $author$project$Api$Employer$Upload$All$rowsProcessedOrIgnored = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
};
var $author$project$Api$Provider$Upload$All$rowsProcessedOrIgnored = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
};
var $author$project$Api$Upload$All$rowsProcessedOrIgnored = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$rowsProcessedOrIgnored(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$rowsProcessedOrIgnored(upload_);
	}
};
var $author$project$Api$Employer$Upload$All$rowsTotal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
};
var $author$project$Api$Provider$Upload$All$rowsTotal = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
};
var $author$project$Api$Upload$All$rowsTotal = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$rowsTotal(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$rowsTotal(upload_);
	}
};
var $author$project$Api$Common$Upload$Shared$startedAt = function (_v0) {
	var record = _v0;
	return record._H;
};
var $author$project$Api$Employer$Upload$All$startedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$startedAt(shared);
};
var $author$project$Api$Provider$Upload$All$startedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$startedAt(shared);
};
var $author$project$Api$Upload$All$startedAt = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$startedAt(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$startedAt(upload_);
	}
};
var $author$project$Api$Upload$Status$toString = function (status) {
	switch (status) {
		case 0:
			return 'unattempted';
		case 1:
			return 'downloading';
		case 2:
			return 'enqueued_for_preprocessing';
		case 3:
			return 'ready_to_preprocess';
		case 4:
			return 'preprocessing';
		case 5:
			return 'review_data_matches';
		case 6:
			return 'review_file_size';
		case 7:
			return 'enqueued_for_processing';
		case 8:
			return 'ready_to_process';
		case 9:
			return 'processing';
		case 10:
			return 'postprocessing';
		case 11:
			return 'processed';
		case 12:
			return 'failed';
		default:
			return 'cancelled';
	}
};
var $author$project$Api$Employer$Upload$All$uploaderType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
};
var $author$project$Api$Provider$Upload$All$uploaderType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
};
var $author$project$Api$Upload$All$uploaderType = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$All$uploaderType(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$All$uploaderType(upload_);
	}
};
var $author$project$Ui$Link$Xs = 1;
var $author$project$Ui$Link$xs = $author$project$Ui$Link$Size(1);
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewRow = F2(
	function (model, upload) {
		var meta = $author$project$Api$Upload$All$meta(upload);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$longText]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top(
										{
											ff: model.adR,
											HK: $author$project$Api$Upload$All$id(upload)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												$author$project$Api$Upload$All$name(upload)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Upload$All$uploaderType(upload);
							switch (_v0.$) {
								case 0:
									return $elm$html$Html$text('AutoSync');
								case 1:
									return $elm$html$Html$text('Manual');
								case 2:
									return $elm$html$Html$text('Manual');
								default:
									var string = _v0.a;
									return $elm$html$Html$text(string);
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Upload$Status$toString(
								$author$project$Api$Upload$All$status(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									model.Hy(0),
									$author$project$Api$Upload$All$startedAt(upload))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									model.Hy(0),
									$author$project$Api$Upload$All$finishedAt(upload))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Upload$All$rowsTotal(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								$author$project$Api$Upload$All$rowsProcessedOrIgnored(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(
								A2(
									$elm$core$Maybe$withDefault,
									0,
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$failedRowsCountWithoutSupressed(upload))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$noWrap]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							_List_Nil,
							'Download file',
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg,
									A3(
										$author$project$Components$FileLink$view,
										{
											K1: model.D5,
											PE: 0,
											aav: A2($author$project$Pages$Companies$CompanyId_String$Uploads$Top$exportCsvPath, model, upload)
										},
										_List_fromArray(
											[
												$author$project$Ui$Link$ariaLabel('Download file'),
												$author$project$Ui$Link$xs,
												$author$project$Ui$Link$buttonDefault,
												$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$export)
											]),
										_List_Nil))
								])),
							$author$project$Utils$Html$noBreakSpace,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$canProcessUpload(meta) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Process upload'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Process(upload)),
									$author$project$Ui$Button$loading(
									_Utils_eq(model.nK, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Process Upload')
								])) : $author$project$Utils$Html$empty,
							$author$project$Utils$Html$noBreakSpace,
							$author$project$Api$Upload$Meta$duplicateAction(meta) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Duplicate upload'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicate(upload))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Duplicate Upload')
								])) : $author$project$Utils$Html$empty,
							$author$project$Utils$Html$noBreakSpace,
							$author$project$Api$Upload$Meta$cancelAction(meta) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel upload'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Companies$CompanyId_String$Uploads$Top$Cancel(upload))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel Upload')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.o5;
		if (_v1.$ === 3) {
			var uploads_ = _v1.a;
			return _Utils_Tuple2(false, uploads_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploads = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no uploads yet!')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
			$author$project$Pages$Companies$CompanyId_String$Uploads$Top$columns),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewRow(model),
			uploads),
		_List_Nil);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$view = function (model) {
	return {
		e5: function () {
			var loading = function () {
				var _v7 = model.o5;
				if (_v7.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			return _List_fromArray(
				[
					function () {
					var _v0 = model.kF;
					if (!_v0.$) {
						var uploadModal = _v0.a;
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg,
							$author$project$Components$Company$UploadModal$view(uploadModal));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v1 = model.cG;
					if (!_v1.$) {
						var _v2 = _v1.a;
						var upload = _v2.a;
						var saveRequest = _v2.b;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed,
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('cancel'),
									$author$project$Components$HiConfirm$noun('Upload'),
									$author$project$Components$HiConfirm$detail(
									'\"' + (A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Upload$All$name(upload)) + '\"')),
									$author$project$Components$HiConfirm$loading(
									_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v3 = model.cR;
					if (!_v3.$) {
						var _v4 = _v3.a;
						var upload = _v4.a;
						var saveRequest = _v4.b;
						return A2(
							$author$project$Components$HiConfirm$modal,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed,
							_List_fromArray(
								[
									$author$project$Components$HiConfirm$verb('duplicate'),
									$author$project$Components$HiConfirm$noun('Upload'),
									$author$project$Components$HiConfirm$detail(
									'\"' + (A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Upload$All$name(upload)) + '\"')),
									$author$project$Components$HiConfirm$loading(
									_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v5 = model.jH;
					if (!_v5.$) {
						var processUploadModal = _v5.a;
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg,
							$author$project$Components$Upload$ProcessUploadModal$view(processUploadModal));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					model.lj ? $author$project$Components$Upload$CannotUploadModal$view($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed) : $author$project$Utils$Html$empty,
					A6(
					$author$project$Layouts$Company$Uploads$view,
					model.ZD,
					model.WF,
					model.ab9,
					model.iH,
					_List_fromArray(
						[
							function () {
							if (!$author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild(model.ab9)) {
								var fileUrl = 'https://docs.google.com/spreadsheets/d/1pJagUUuUftzqL8n4y_uzZLWuiQUaor7-59RLSAtPfPo/edit?gid=0';
								return A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Employee Uploads following the '),
											A3(
											$author$project$Ui$Link$externalHref,
											fileUrl,
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('default CSV Template')
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg,
													A2(
														$author$project$Ui$SearchInput$view,
														_List_fromArray(
															[
																$author$project$Ui$SearchInput$phi(true),
																$author$project$Ui$SearchInput$placeholder('Search by file name or upload identificator')
															]),
														model.sA))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(4),
											$author$project$Ui$FlexGrid$justifyRight
										]),
									function () {
										var _v6 = model.iH;
										if (_v6.$ === 3) {
											var feedEnroller = _v6.a;
											return _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															function () {
															if ($author$project$Pages$Companies$CompanyId_String$Uploads$Top$canUploadFile(model.ab9)) {
																var buttonLabel = ($author$project$Utils$Maybe$toBool(feedEnroller) || $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsParent(model.ab9)) ? 'Upload AutoSync file' : 'Upload file';
																return A3(
																	$author$project$Ui$Button$view,
																	{abp: buttonLabel},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$Top$Upload),
																			$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(buttonLabel)
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}(),
															(model.FR && ((!$author$project$Utils$Maybe$toBool(feedEnroller)) && ((!$author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild(model.ab9)) && (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD))))) ? A3(
															$author$project$Ui$HinterOnly$linkRoute,
															$author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas(
																{ff: model.adR}),
															_List_fromArray(
																[$author$project$Ui$Link$buttonDefault]),
															_List_fromArray(
																[
																	$elm$html$Html$text(' Configure EAS')
																])) : $author$project$Utils$Html$empty
														]))
												]);
										} else {
											return _List_fromArray(
												[
													$author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small]))
												]);
										}
									}())
								])),
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewTable(model)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Companies$CompanyId_String$Uploads$Top$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.afy))
						]))
				]);
		}(),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Employee Uploads'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$init, aer: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$load, agD: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$save, ahd: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$update, ahP: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$view});
var $author$project$Components$Upload$UploadRowList$Failed = 0;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotFeedEnroller = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None = {$: 0};
var $author$project$Components$Upload$UploadRowList$Processed = 2;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Upload$UploadRowList$Warning = 1;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotUpload = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$basePath = function (model) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(model.ff);
};
var $author$project$Api$Employer$Upload$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Upload$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Employer$Upload$uploadPath(id_)));
	});
var $author$project$Api$Upload$retrieve = F5(
	function (basePath, apiClient, session, id_, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3(
			$author$project$Api$Employer$Upload$retrieve,
			apiClient,
			id_,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Upload$One$fromEmployer))) : A4(
			$author$project$Api$Provider$Upload$retrieve,
			basePath,
			apiClient,
			id_,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Upload$One$fromProvider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$fetchUpload = function (model) {
	return A5(
		$author$project$Api$Upload$retrieve,
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$basePath(model),
		model.D5,
		model.ZD,
		model.adR,
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotUpload);
};
var $author$project$Components$Upload$UploadRowList$GotUploadRows = $elm$core$Basics$identity;
var $author$project$Api$UploadRow$All$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$UploadRow$All$fromEmployer = $author$project$Api$UploadRow$All$Employer;
var $author$project$Api$UploadRow$All$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRow$All$fromProvider = $author$project$Api$UploadRow$All$Provider;
var $author$project$Api$Employer$UploadRow$All$UploadRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$UploadRow$Shared$UploadRow = $elm$core$Basics$identity;
var $author$project$Api$Employer$UploadRow$Shared$Record = F5(
	function (id, rowNumber, reviewed, isSupressed, csvRow) {
		return {Mp: csvRow, adR: id, R9: isSupressed, YK: reviewed, YP: rowNumber};
	});
var $author$project$Api$Employer$UploadRow$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'csv_row',
	$elm$json$Json$Decode$dict(
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_supressed',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reviewed',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'row_number',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$Shared$Record))))));
var $author$project$Api$Employer$UploadRow$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$UploadRow$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$UploadRow$All$Record = F2(
	function (resultData, uploadRowResults) {
		return {YA: resultData, aar: uploadRowResults};
	});
var $author$project$Api$Employer$UploadRowResult$Shared$UploadRowResult = $elm$core$Basics$identity;
var $author$project$Api$Employer$UploadRowResult$Shared$Record = F2(
	function (message, resultType) {
		return {aeD: message, YB: resultType};
	});
var $author$project$Api$Employer$UploadRowResult$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'result_type',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRowResult$Shared$Record)));
var $author$project$Api$Employer$UploadRowResult$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$UploadRowResult$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$UploadRow$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'upload_row_results',
	$elm$json$Json$Decode$list($author$project$Api$Employer$UploadRowResult$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'result_data',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$All$Record)));
var $author$project$Api$Employer$UploadRow$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$UploadRow$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$UploadRow$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$All$UploadRow)));
var $author$project$Api$Employer$UploadRow$uploadRowsPath = function (uploadId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['upload_rows']),
		$author$project$Api$Employer$Upload$uploadPath(uploadId));
};
var $author$project$Api$Employer$UploadRow$list = F4(
	function (apiClient, uploadId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Employer$UploadRow$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Common$UploadRow$ListOptionals$toParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Employer$UploadRow$uploadRowsPath(uploadId))));
	});
var $author$project$Api$UploadRow$list = F5(
	function (apiClient, session, uploadId, optionals, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$UploadRow$list,
			apiClient,
			uploadId,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$UploadRow$All$fromEmployer)))) : A4(
			$author$project$Api$Provider$UploadRow$list,
			apiClient,
			uploadId,
			optionals,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Api$UploadRow$All$fromProvider))));
	});
var $author$project$Api$Common$UploadRow$ListOptionals$Processed = 2;
var $author$project$Api$Common$UploadRow$ListOptionals$Warning = 1;
var $author$project$Components$Upload$UploadRowList$resultTypeFilter = function (resultType) {
	switch (resultType) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Components$Upload$UploadRowList$fetchUploadRows = F2(
	function (apiClient, model) {
		var resultTypeListOptionals = function (listOptionals) {
			var _v0 = model.YB;
			switch (_v0) {
				case 0:
					return _Utils_update(
						listOptionals,
						{
							Hs: $elm$core$Maybe$Just('not_supressed')
						});
				case 1:
					return listOptionals;
				default:
					return listOptionals;
			}
		};
		return A5(
			$author$project$Api$UploadRow$list,
			apiClient,
			model.ZD,
			model.HK,
			A2(
				$elm$core$Basics$composeR,
				function (d) {
					return _Utils_update(
						d,
						{
							Fi: $elm$core$Maybe$Just(
								$author$project$Components$Upload$UploadRowList$resultTypeFilter(model.YB))
						});
				},
				resultTypeListOptionals),
			$elm$core$Basics$identity);
	});
var $author$project$Components$Upload$UploadRowList$init = F5(
	function (apiClient, session, companyId, uploadId, resultType) {
		var model = {ff: companyId, YB: resultType, ZD: session, HK: uploadId, tu: $author$project$Api$Data$Loading};
		return _Utils_Tuple2(
			model,
			A2($author$project$Components$Upload$UploadRowList$fetchUploadRows, apiClient, model));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$init = F5(
	function (session, practice, company, shared, _v0) {
		var params = _v0.Vx;
		var _v1 = A5($author$project$Components$Upload$UploadRowList$init, shared.D5, session, params.ff, params.HK, 1);
		var warningUploadRowList = _v1.a;
		var warningUploadRowListCmd = _v1.b;
		var _v2 = A5($author$project$Components$Upload$UploadRowList$init, shared.D5, session, params.ff, params.HK, 2);
		var processedUploadRowList = _v2.a;
		var processedUploadRowListCmd = _v2.b;
		var _v3 = A5($author$project$Components$Upload$UploadRowList$init, shared.D5, session, params.ff, params.HK, 0);
		var failedUploadRowList = _v3.a;
		var failedUploadRowListCmd = _v3.b;
		var model = {D5: shared.D5, ab9: company, ff: params.ff, qD: failedUploadRowList, iH: $author$project$Api$Data$Loading, adR: params.HK, WF: practice, sf: processedUploadRowList, ZD: session, Hy: shared.Hy, DB: $author$project$Api$Data$Loading, eO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None, tz: warningUploadRowList};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$fetchUpload(model),
						A4($author$project$Api$FeedEnroller$retrieve, shared.D5, session, params.ff, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotFeedEnroller),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg, failedUploadRowListCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg, warningUploadRowListCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg, processedUploadRowListCmd)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed = {$: 7};
var $author$project$Components$Upload$WarningDetailsModal$subscribeToEscapeKeyPress = function (msg) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(msg);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$subscriptions = function (model) {
	var _v0 = model.eO;
	if (_v0.$ === 1) {
		return $author$project$Components$Upload$WarningDetailsModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $BrianHicks$elm_csv$Csv$Encode$encodeItems = F2(
	function (encoder, rows) {
		if (!encoder.$) {
			var convert = encoder.a;
			var _v1 = A3(
				$elm$core$List$foldr,
				F2(
					function (row, _v2) {
						var converted_ = _v2.a;
						var names = _v2.b;
						var convertedRow = convert(row);
						return _Utils_Tuple2(
							A2(
								$elm$core$List$cons,
								$elm$core$Dict$fromList(convertedRow),
								converted_),
							A3(
								$elm$core$List$foldl,
								F2(
									function (_v3, _v4) {
										var name = _v3.a;
										var soFar = _v4.a;
										var column = _v4.b;
										return _Utils_Tuple2(
											A3(
												$elm$core$Dict$update,
												name,
												function (value) {
													if (!value.$) {
														var columns = value.a;
														return $elm$core$Maybe$Just(
															A2($elm$core$List$cons, column, columns));
													} else {
														return $elm$core$Maybe$Just(
															_List_fromArray(
																[column]));
													}
												},
												soFar),
											column + 1);
									}),
								_Utils_Tuple2(names, 0),
								convertedRow).a);
					}),
				_Utils_Tuple2(_List_Nil, $elm$core$Dict$empty),
				rows);
			var converted = _v1.a;
			var namePositions = _v1.b;
			var ordering = A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$sortBy,
					$elm$core$Tuple$second,
					$elm$core$Dict$toList(
						A2(
							$elm$core$Dict$map,
							F2(
								function (_v6, positions) {
									return $elm$core$List$sum(positions) / $elm$core$List$length(positions);
								}),
							namePositions))));
			return A2(
				$elm$core$List$cons,
				ordering,
				A2(
					$elm$core$List$map,
					function (row) {
						return A2(
							$elm$core$List$map,
							function (field) {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, field, row));
							},
							ordering);
					},
					converted));
		} else {
			var convert = encoder.a;
			return A2($elm$core$List$map, convert, rows);
		}
	});
var $BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary = F2(
	function (fieldSeparator, value) {
		return (A2($elm$core$String$contains, '\"', value) || (A2($elm$core$String$contains, fieldSeparator, value) || (A2($elm$core$String$contains, '\u000D\n', value) || A2($elm$core$String$contains, '\n', value)))) ? ('\"' + (A3($elm$core$String$replace, '\"', '\"\"', value) + '\"')) : value;
	});
var $BrianHicks$elm_csv$Csv$Encode$encode = F2(
	function (_v0, items) {
		var encoder = _v0.ac0;
		var fieldSeparator = _v0.adl;
		var fieldSeparatorString = $elm$core$String$fromChar(fieldSeparator);
		return A2(
			$elm$core$String$join,
			'\u000D\n',
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$String$join(fieldSeparatorString),
					$elm$core$List$map(
						$BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary(fieldSeparatorString))),
				A2($BrianHicks$elm_csv$Csv$Encode$encodeItems, encoder, items)));
	});
var $elm$file$File$Download$string = F3(
	function (name, mime, content) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$never,
			A3(_File_download, name, mime, content));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$warningRowEncoder = function (record) {
	return _List_fromArray(
		[
			_Utils_Tuple2('Ident', record.adS),
			_Utils_Tuple2('First Name', record.Pu),
			_Utils_Tuple2('Last Name', record.SA),
			_Utils_Tuple2('DOB', record.acQ),
			_Utils_Tuple2('Company Name', record.Lw),
			_Utils_Tuple2('External ID', record.ade)
		]);
};
var $BrianHicks$elm_csv$Csv$Encode$WithFieldNames = function (a) {
	return {$: 0, a: a};
};
var $BrianHicks$elm_csv$Csv$Encode$withFieldNames = $BrianHicks$elm_csv$Csv$Encode$WithFieldNames;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$downloadWarnings = function (warnings) {
	var warningsList = function () {
		if (warnings.$ === 1) {
			var _v1 = warnings.a;
			var warnings_ = _v1.b;
			return warnings_;
		} else {
			return _List_Nil;
		}
	}();
	return A3(
		$elm$file$File$Download$string,
		'warnings.csv',
		'text/csv',
		A2(
			$BrianHicks$elm_csv$Csv$Encode$encode,
			{
				ac0: $BrianHicks$elm_csv$Csv$Encode$withFieldNames($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$warningRowEncoder),
				adl: ','
			},
			warningsList));
};
var $author$project$Components$Upload$UploadRowList$update = F2(
	function (msg, model) {
		var response = msg;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{tu: response}),
			$elm$core$Platform$Cmd$none,
			$author$project$OutMsg$handleErrorResponse(response));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{DB: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iH: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.qD);
				var failedUploadRowList_ = _v1.a;
				var failedUploadRowListCmd = _v1.b;
				var failedUploadRowListOutMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qD: failedUploadRowList_}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg, failedUploadRowListCmd),
					failedUploadRowListOutMsgs);
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.tz);
				var warningUploadRowList_ = _v2.a;
				var warningUploadRowListCmd = _v2.b;
				var warningUploadRowListOutMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tz: warningUploadRowList_}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg, warningUploadRowListCmd),
					warningUploadRowListOutMsgs);
			case 4:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.sf);
				var processedUploadRowList_ = _v3.a;
				var processedUploadRowListCmd = _v3.b;
				var processedUploadRowListOutMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sf: processedUploadRowList_}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg, processedUploadRowListCmd),
					processedUploadRowListOutMsgs);
			case 5:
				var type_ = msg.a;
				var warnings = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings(
								_Utils_Tuple2(
									$author$project$Formatters$String$titleize(type_),
									warnings))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var registration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings(
								_Utils_Tuple2('Too many unenrollments', registration.adT))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None}),
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$downloadWarnings(model.eO),
					_List_Nil);
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalDownload = {$: 8};
var $author$project$Components$Upload$WarningDetailsModal$button = function (onClick) {
	return A3(
		$author$project$Ui$Button$view,
		{abp: 'Export to csv'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
				$author$project$Ui$Button$onClick(onClick),
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$export)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Tooltip$view,
				_List_fromArray(
					[
						$author$project$Ui$Tooltip$placement(2)
					]),
				'Export to CSV',
				_List_Nil)
			]));
};
var $author$project$Components$Upload$WarningDetailsModal$viewWarning = function (warning) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.adS)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.Pu)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.SA)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.acQ)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.Lw)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(warning.ade)
					]))
			]));
};
var $author$project$Components$Upload$WarningDetailsModal$view = F4(
	function (title, warnings, onClose, onDownload) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(title)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Table$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('ID')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('First Name')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Last Name')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('DOB')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Company Name')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('External ID')
										])),
									A2(
									$author$project$Ui$Table$header,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$Upload$WarningDetailsModal$button(onDownload)
										]))
								]),
							A2($elm$core$List$map, $author$project$Components$Upload$WarningDetailsModal$viewWarning, warnings),
							_List_Nil)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(onClose)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewTooManyUnenrollmentsWarning = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewUploadWarnings = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Employer$Upload$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$createdAt(shared);
};
var $author$project$Api$Provider$Upload$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$createdAt(shared);
};
var $author$project$Api$Upload$One$createdAt = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$One$createdAt(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$One$createdAt(upload_);
	}
};
var $author$project$Api$Employer$Upload$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$errorMessage(shared);
};
var $author$project$Api$Upload$One$errorMessage = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$One$errorMessage(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$One$errorMessage(upload_);
	}
};
var $elm$core$String$lines = _String_lines;
var $author$project$Api$Employer$Upload$One$results = function (_v0) {
	var record = _v0.b;
	return record.YC;
};
var $author$project$Api$Provider$Upload$One$results = function (_v0) {
	var record = _v0.b;
	return record.YC;
};
var $author$project$Api$Upload$One$results = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$One$results(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$One$results(upload_);
	}
};
var $author$project$Api$Employer$Upload$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Upload$Shared$status(shared);
};
var $author$project$Api$Upload$One$status = function (upload) {
	if (!upload.$) {
		var upload_ = upload.a;
		return $author$project$Api$Provider$Upload$One$status(upload_);
	} else {
		var upload_ = upload.a;
		return $author$project$Api$Employer$Upload$One$status(upload_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$uploadStatusLabel = function (upload) {
	var status = $author$project$Api$Upload$One$status(upload);
	return ((status === 2) || (status === 7)) ? 'enqueued' : $author$project$Api$Upload$Status$toString(status);
};
var $author$project$Ui$ListGroup$Danger = 3;
var $author$project$Ui$ListGroup$Success = 0;
var $author$project$Ui$ListGroup$Warning = 2;
var $author$project$Ui$ListGroup$Background = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$ListGroup$background = $author$project$Ui$ListGroup$Background;
var $author$project$Components$Upload$UploadRowList$backgroundStyle = function (resultType) {
	switch (resultType) {
		case 0:
			return $author$project$Ui$ListGroup$background(3);
		case 1:
			return $author$project$Ui$ListGroup$background(2);
		default:
			return $author$project$Ui$ListGroup$background(0);
	}
};
var $author$project$Components$Upload$UploadRowList$resultTypeToString = function (resultType) {
	switch (resultType) {
		case 0:
			return 'failed';
		case 1:
			return 'warning';
		default:
			return 'processed';
	}
};
var $author$project$Components$Upload$UploadRowList$resultTypeToTitle = function (resultType) {
	switch (resultType) {
		case 0:
			return 'Failed';
		case 1:
			return 'Warning';
		default:
			return 'Processed';
	}
};
var $author$project$Components$Upload$UploadRowList$textStyle = function (resultType) {
	switch (resultType) {
		case 0:
			return $author$project$Ui$Typography$danger;
		case 1:
			return $author$project$Ui$Typography$warning;
		default:
			return $author$project$Ui$Typography$success;
	}
};
var $author$project$Components$Upload$UploadRowList$isErrorsOrWarnings = function (resultType) {
	return (!resultType) || (resultType === 1);
};
var $author$project$Api$Employer$UploadRow$Shared$rowNumber = function (_v0) {
	var record = _v0;
	return record.YP;
};
var $author$project$Api$Employer$UploadRow$All$rowNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$rowNumber(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$rowNumber = function (_v0) {
	var record = _v0;
	return record.YP;
};
var $author$project$Api$Provider$UploadRow$All$rowNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$rowNumber(shared);
};
var $author$project$Api$UploadRow$All$rowNumber = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$rowNumber(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$rowNumber(uploadRow_);
	}
};
var $author$project$Api$Employer$UploadRowResult$Shared$message = function (_v0) {
	var record = _v0;
	return record.aeD;
};
var $author$project$Api$UploadRowResult$Shared$message = function (uploadRowResult) {
	if (!uploadRowResult.$) {
		var uploadRowResult_ = uploadRowResult.a;
		return $author$project$Api$Provider$UploadRowResult$Shared$message(uploadRowResult_);
	} else {
		var uploadRowResult_ = uploadRowResult.a;
		return $author$project$Api$Employer$UploadRowResult$Shared$message(uploadRowResult_);
	}
};
var $author$project$Api$Employer$UploadRowResult$Shared$resultType = function (_v0) {
	var record = _v0;
	return record.YB;
};
var $author$project$Api$Provider$UploadRowResult$Shared$resultType = function (_v0) {
	var record = _v0;
	return record.YB;
};
var $author$project$Api$UploadRowResult$Shared$resultType = function (uploadRowResult) {
	if (!uploadRowResult.$) {
		var uploadRowResult_ = uploadRowResult.a;
		return $author$project$Api$Provider$UploadRowResult$Shared$resultType(uploadRowResult_);
	} else {
		var uploadRowResult_ = uploadRowResult.a;
		return $author$project$Api$Employer$UploadRowResult$Shared$resultType(uploadRowResult_);
	}
};
var $author$project$Api$UploadRowResult$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$UploadRowResult$Shared$fromEmployer = $author$project$Api$UploadRowResult$Shared$Employer;
var $author$project$Api$UploadRowResult$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRowResult$Shared$fromProvider = $author$project$Api$UploadRowResult$Shared$Provider;
var $author$project$Api$Employer$UploadRow$All$uploadRowResults = function (_v0) {
	var record = _v0.b;
	return record.aar;
};
var $author$project$Api$UploadRow$All$uploadRowResults = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$UploadRowResult$Shared$fromProvider,
			$author$project$Api$Provider$UploadRow$All$uploadRowResults(uploadRow_));
	} else {
		var uploadRow_ = uploadRow.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$UploadRowResult$Shared$fromEmployer,
			$author$project$Api$Employer$UploadRow$All$uploadRowResults(uploadRow_));
	}
};
var $author$project$Components$Upload$UploadRowList$viewUploadRowMessage = F2(
	function (messageTypes, uploadRow) {
		var messages = A2(
			$elm$core$List$filterMap,
			function (uploadRowResult) {
				return A2(
					$elm$core$Maybe$andThen,
					function (resultType) {
						return A2($elm$core$List$member, resultType, messageTypes) ? $author$project$Api$UploadRowResult$Shared$message(uploadRowResult) : $elm$core$Maybe$Nothing;
					},
					$author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
			},
			$author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
		var messagesString = A2(
			$elm$core$String$join,
			' - ',
			$elm_community$list_extra$List$Extra$unique(messages));
		var _v0 = $author$project$Utils$String$toMaybe(messagesString);
		if (!_v0.$) {
			var messagesString_ = _v0.a;
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Formatters$String$ellipsis, 100, messagesString_))
					]));
		} else {
			return A2(
				$author$project$Ui$Typography$em,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Blank')
					]));
		}
	});
var $author$project$Components$Upload$UploadRowList$viewUploadRowResult = function (uploadRow) {
	var ignoredTypes = _List_fromArray(
		['warning']);
	var resultsWithoutWarnings = A2(
		$elm$core$List$filterMap,
		function (uploadRowResult) {
			return A2(
				$elm$core$Maybe$andThen,
				function (resultType) {
					return (!A2($elm$core$List$member, resultType, ignoredTypes)) ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
				},
				$author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
		},
		$author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
	var uniqSortedResults = $elm_community$list_extra$List$Extra$unique(resultsWithoutWarnings);
	var humanizedResults = A2(
		$elm$core$List$map,
		A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize),
		uniqSortedResults);
	var resultsString = $elm$core$List$isEmpty(humanizedResults) ? 'No Account Change' : A2($elm$core$String$join, ' - ', humanizedResults);
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2($author$project$Formatters$String$ellipsis, 100, resultsString))
			]));
};
var $author$project$Components$Upload$UploadRowList$viewUploadRow = F2(
	function (resultType, uploadRow) {
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(10)
								]),
							_List_fromArray(
								[
									function () {
									if ($author$project$Components$Upload$UploadRowList$isErrorsOrWarnings(resultType)) {
										var messageTypes = function () {
											switch (resultType) {
												case 0:
													return _List_fromArray(
														['error']);
												case 1:
													return _List_fromArray(
														['warning', 'duplicate_ignored']);
												default:
													return _List_Nil;
											}
										}();
										return A2($author$project$Components$Upload$UploadRowList$viewUploadRowMessage, messageTypes, uploadRow);
									} else {
										return $author$project$Components$Upload$UploadRowList$viewUploadRowResult(uploadRow);
									}
								}()
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(2),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Row #'),
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$author$project$Api$UploadRow$All$rowNumber(uploadRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Upload$UploadRowList$zeroState = function (resultType) {
	switch (resultType) {
		case 0:
			return 'No failed rows';
		case 1:
			return 'No rows with warnings';
		default:
			return 'No rows processed';
	}
};
var $author$project$Components$Upload$UploadRowList$view = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h5,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.tu;
								if (_v0.$ === 3) {
									var headers = _v0.b;
									var totalCount = A2(
										$elm$core$Maybe$withDefault,
										0,
										A2(
											$elm$core$Maybe$andThen,
											$elm$core$String$toInt,
											A2($elm$core$Dict$get, 'x-total-count', headers)));
									return A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Components$Upload$UploadRowList$textStyle(model.YB)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Components$Upload$UploadRowList$resultTypeToTitle(model.YB)),
												$elm$html$Html$text(' - '),
												$elm$html$Html$text(
												$elm$core$String$fromInt(totalCount)),
												$elm$html$Html$text(' rows ')
											]));
								} else {
									return A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Spinner$view(
												_List_fromArray(
													[$author$project$Ui$Spinner$small]))
											]));
								}
							}()
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults(
							{ff: model.ff, HK: model.HK}),
						_List_fromArray(
							[
								$author$project$Ui$Link$routeParams(
								_List_fromArray(
									[
										A2(
										$elm$url$Url$Builder$string,
										'resultType',
										$author$project$Components$Upload$UploadRowList$resultTypeToString(model.YB))
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('See all rows >')
							]))
					])),
				function () {
				var _v1 = model.tu;
				if (_v1.$ === 3) {
					var uploadRows = _v1.a;
					var listGroupOptions = A2(
						$elm$core$List$cons,
						$author$project$Ui$ListGroup$zeroState(
							$author$project$Components$Upload$UploadRowList$zeroState(model.YB)),
						$elm$core$List$isEmpty(uploadRows) ? _List_Nil : _List_fromArray(
							[
								$author$project$Components$Upload$UploadRowList$backgroundStyle(model.YB)
							]));
					return A2(
						$author$project$Ui$ListGroup$view,
						listGroupOptions,
						A2(
							$elm$core$List$map,
							$author$project$Components$Upload$UploadRowList$viewUploadRow(model.YB),
							uploadRows));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$viewUpload = F2(
	function (model, upload) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$uploadStatusLabel(upload)))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('File received on '),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										model.Hy,
										0,
										$author$project$Api$Upload$One$createdAt(upload)))
								]))
						])),
					function () {
					var _v0 = $author$project$Api$Upload$One$errorMessage(upload);
					if (!_v0.$) {
						var errorMessage = _v0.a;
						var errorMessages = $elm$core$String$lines(errorMessage);
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (message) {
									return A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Badge$fromString, _List_Nil, 'error'),
												$author$project$Utils$Html$noBreakSpace,
												A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(message)
													]))
											]));
								},
								errorMessages));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (result) {
							return A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										switch (result.$) {
											case 0:
												var value = result.a;
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													A2(
														$elm$core$List$cons,
														A2($author$project$Ui$Badge$fromString, _List_Nil, 'warning'),
														A2(
															$elm$core$List$cons,
															$author$project$Utils$Html$noBreakSpace,
															A2(
																$elm$core$List$cons,
																$elm$html$Html$text(value.aeD),
																A2(
																	$elm$core$List$indexedMap,
																	F2(
																		function (index, registration) {
																			return A2(
																				$author$project$Ui$Typography$span,
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(registration.ab9),
																						$elm$html$Html$text(' ('),
																						$elm$html$Html$text(
																						$elm$core$String$fromInt(registration.LY)),
																						$elm$html$Html$text(') '),
																						A3(
																						$author$project$Ui$Button$view,
																						{abp: 'View unenrollment warnings'},
																						_List_fromArray(
																							[
																								$author$project$Ui$Button$link,
																								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																								$author$project$Ui$Button$onClick(
																								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewTooManyUnenrollmentsWarning(registration))
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('View >')
																							])),
																						_Utils_eq(
																						index,
																						$elm$core$List$length(value.age) - 1) ? $author$project$Utils$Html$empty : $elm$html$Html$text(', ')
																					]));
																		}),
																	value.age)))));
											case 1:
												var key = result.a;
												var value = result.b;
												return $elm$core$List$isEmpty(value) ? $author$project$Utils$Html$empty : A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															A2($author$project$Ui$Badge$fromString, _List_Nil, 'warning'),
															$author$project$Utils$Html$noBreakSpace,
															$elm$html$Html$text(
															$author$project$Formatters$String$humanize(key)),
															$elm$html$Html$text(' ('),
															$elm$html$Html$text(
															$elm$core$String$fromInt(
																$elm$core$List$length(value))),
															$elm$html$Html$text(') '),
															A3(
															$author$project$Ui$Button$view,
															{abp: 'View upload warnings'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																	$author$project$Ui$Button$onClick(
																	A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewUploadWarnings, key, value))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('View >')
																]))
														]));
											default:
												return $author$project$Utils$Html$empty;
										}
									}()
									]));
						},
						$author$project$Api$Upload$One$results(upload))),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg,
									$author$project$Components$Upload$UploadRowList$view(model.qD))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(6)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg,
									$author$project$Components$Upload$UploadRowList$view(model.tz))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(12)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg,
									$author$project$Components$Upload$UploadRowList$view(model.sf))
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.eO;
				if (_v0.$ === 1) {
					var _v1 = _v0.a;
					var title = _v1.a;
					var warnings = _v1.b;
					return A4($author$project$Components$Upload$WarningDetailsModal$view, title, warnings, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalDownload);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A6(
				$author$project$Layouts$Company$Uploads$view,
				model.ZD,
				model.WF,
				model.ab9,
				model.iH,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$never,
										A2(
											$author$project$Ui$Breadcrumb$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
																{ff: model.ff}),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Uploads')
																]))
														])),
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_fromArray(
														[
															$author$project$Ui$Breadcrumb$active(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(model.adR)
														]))
												]))),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										function () {
										var _v2 = model.DB;
										if (_v2.$ === 3) {
											var upload = _v2.a;
											return A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$viewUpload, model, upload);
										} else {
											return A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
													]),
												_List_fromArray(
													[
														$author$project$Ui$Spinner$view(_List_Nil)
													]));
										}
									}()
									]))
							]))
					]),
				_List_Nil)
			]),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Employee Uploads'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$init, aer: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$load, agD: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$save, ahd: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$update, ahP: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$view});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotFeedEnroller = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NotSupressed = 1;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Processed = 2;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressFilterDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Supressed = 0;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UploadRowResultsActionDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Report$UploadRowSponsor = 18;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$DobUpdated = 1;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$EndDateUpdated = 7;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Enrolled = 3;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$MembershipChanged = 6;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NewCompany = 8;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NewPatient = 2;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NoAccountChange = 0;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PlanChanged = 9;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Restarted = 4;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$TerminatedByEndDate = 5;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue = function (action) {
	switch (action) {
		case 0:
			return 'no_account_change';
		case 1:
			return 'dob_updated';
		case 2:
			return 'new_patient';
		case 3:
			return 'enrolled';
		case 4:
			return 'restarted';
		case 5:
			return 'terminated_by_end_date';
		case 7:
			return 'end_date_updated';
		case 6:
			return 'membership_changed';
		case 8:
			return 'new_company';
		default:
			return 'plan_changed';
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionFromQuery = function (queryString) {
	return A2(
		$elm_community$list_extra$List$Extra$find,
		function (status) {
			return _Utils_eq(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue(status),
				queryString);
		},
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 7, 6, 8, 9]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString = function (resultType) {
	switch (resultType) {
		case 0:
			return 'failed';
		case 1:
			return 'warning';
		default:
			return 'processed';
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue = function (supress) {
	if (!supress) {
		return 'supressed';
	} else {
		return 'not_supressed';
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			_Utils_Tuple2(
				'resultType',
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString(model.YB))),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue,
				$elm$core$Tuple$pair('upload_row_results_result_type')),
			model.hb),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue,
				$elm$core$Tuple$pair('supress_filter')),
			model.Hs),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('q'),
			model.af_)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults(
					{ff: model.ff, HK: model.HK}))
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$urlParams(model)))));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotUploadRows = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFilter = function (resultType) {
	switch (resultType) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRowsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Fi: $elm$core$Maybe$Just(
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFilter(model.YB)),
				afy: model.afy,
				af_: model.af_,
				ag1: model.ag1,
				Hs: A2($elm$core$Maybe$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue, model.Hs),
				HL: A2($elm$core$Maybe$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue, model.hb)
			});
	};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows = function (model) {
	return A5(
		$author$project$Api$UploadRow$list,
		model.D5,
		model.ZD,
		model.HK,
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRowsParams(model),
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotUploadRows);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Failed = 0;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Warning = 1;
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFromString = function (string) {
	switch (string) {
		case 'failed':
			return $elm$core$Maybe$Just(0);
		case 'warning':
			return $elm$core$Maybe$Just(1);
		case 'processed':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$init = F5(
	function (session, practice, company, _v0, _v1) {
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var params = _v1.Vx;
		var query = _v1.Bi;
		var resultType = A2(
			$elm$core$Maybe$withDefault,
			2,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFromString,
				A2($elm$core$Dict$get, 'resultType', query)));
		var q = A2($elm$core$Dict$get, 'q', query);
		var exportCsv = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$Components$ExportCsv$init(
				{adw: false, G0: 18}));
		var _v2 = function () {
			switch (resultType) {
				case 0:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							function (supressQuery) {
								if ((!supressQuery.$) && (supressQuery.a === 'supressed')) {
									return 0;
								} else {
									return 1;
								}
							}(
								A2($elm$core$Dict$get, 'supress_filter', query))),
						$elm$core$Maybe$Nothing);
				case 1:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				default:
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionFromQuery,
							A2($elm$core$Dict$get, 'upload_row_results_result_type', query)));
			}
		}();
		var supressFilter = _v2.a;
		var uploadRowResultsResultType = _v2.b;
		var model = {
			D5: apiClient,
			ab9: company,
			ff: params.ff,
			l9: exportCsv,
			iH: $author$project$Api$Data$Loading,
			adN: hinterViewOff,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			af_: q,
			jI: $elm$core$Maybe$Nothing,
			YB: resultType,
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'row_number',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			Hs: supressFilter,
			oE: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'supress-filter-dropdown-filter', ahx: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressFilterDropdownMsg})),
			bi: $elm$core$Set$empty,
			HK: params.HK,
			o3: $elm$core$Maybe$Nothing,
			hb: uploadRowResultsResultType,
			o4: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'upload-row-results-result-type-dropdown-filter', ahx: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UploadRowResultsActionDropdownMsg})),
			tu: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$FeedEnroller$retrieve, apiClient, session, params.ff, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotFeedEnroller),
						A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(model)
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed = {$: 11};
var $author$project$Components$Upload$RowDescriptionDetailsModal$subscribeToEscapeKeyPress = function (onClose) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
};
var $author$project$Components$Upload$RawRowModal$Close = {$: 2};
var $author$project$Components$Upload$RawRowModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$RawRowModal$Close);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$ExportCsv$subscriptions, model.l9))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Upload$RawRowModal$subscriptions, model.jI))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Upload$RowDescriptionDetailsModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed)),
					model.o3)),
				$author$project$Ui$NewDropdown$subscriptions(model.o4),
				$author$project$Ui$NewDropdown$subscriptions(model.oE)
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Api$Employer$UploadRow$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Employer$UploadRow$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$id(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$UploadRow$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$id(shared);
};
var $author$project$Api$UploadRow$All$id = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$id(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$id(uploadRow_);
	}
};
var $author$project$Components$Upload$RawRowModal$GotUploadRow = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRow$One$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$UploadRow$One$fromEmployer = $author$project$Api$UploadRow$One$Employer;
var $author$project$Api$UploadRow$One$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRow$One$fromProvider = $author$project$Api$UploadRow$One$Provider;
var $author$project$Api$Employer$UploadRow$One$UploadRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Employer$UploadRow$One$Record = function (rowsInMyGroup) {
	return {YS: rowsInMyGroup};
};
var $author$project$Api$Employer$UploadRow$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows_in_my_group',
	$elm$json$Json$Decode$list($author$project$Api$Employer$UploadRow$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$One$Record));
var $author$project$Api$Employer$UploadRow$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$UploadRow$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Employer$UploadRow$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$One$UploadRow)));
var $author$project$Api$Employer$UploadRow$uploadRowPath = F2(
	function (uploadId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Employer$UploadRow$uploadRowsPath(uploadId));
	});
var $author$project$Api$Employer$UploadRow$retrieve = F4(
	function (apiClient, uploadId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id_)));
	});
var $author$project$Api$Provider$UploadRow$One$UploadRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$UploadRow$One$Record = function (rowsInMyGroup) {
	return {YS: rowsInMyGroup};
};
var $author$project$Api$Provider$UploadRow$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rows_in_my_group',
	$elm$json$Json$Decode$list($author$project$Api$Provider$UploadRow$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$One$Record));
var $author$project$Api$Provider$UploadRow$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$UploadRow$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$UploadRow$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$One$UploadRow)));
var $author$project$Api$Provider$UploadRow$uploadRowPath = F2(
	function (uploadId, id) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id]),
			$author$project$Api$Provider$UploadRow$uploadRowsPath(uploadId));
	});
var $author$project$Api$Provider$UploadRow$retrieve = F4(
	function (apiClient, uploadId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id_)));
	});
var $author$project$Api$UploadRow$retrieve = F5(
	function (apiClient, session, uploadId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$UploadRow$retrieve,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4(
			$author$project$Api$Provider$UploadRow$retrieve,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
	});
var $author$project$Components$Upload$RawRowModal$init = F4(
	function (apiClient, session, uploadId, uploadRowId) {
		return _Utils_Tuple2(
			{j8: false, tt: $author$project$Api$Data$Loading},
			A5($author$project$Api$UploadRow$retrieve, apiClient, session, uploadId, uploadRowId, $author$project$Components$Upload$RawRowModal$GotUploadRow));
	});
var $author$project$Api$Employer$UploadRow$supress = F4(
	function (apiClient, uploadId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['supress']),
					A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$Provider$UploadRow$supress = F4(
	function (apiClient, uploadId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['supress']),
					A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$UploadRow$supress = F5(
	function (apiClient, session, uploadId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$UploadRow$supress,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4(
			$author$project$Api$Provider$UploadRow$supress,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
	});
var $author$project$Api$Employer$UploadRow$unsupress = F4(
	function (apiClient, uploadId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Employer$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unsupress']),
					A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$Provider$UploadRow$unsupress = F4(
	function (apiClient, uploadId, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$UploadRow$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unsupress']),
					A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$UploadRow$unsupress = F5(
	function (apiClient, session, uploadId, id, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4(
			$author$project$Api$Employer$UploadRow$unsupress,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4(
			$author$project$Api$Provider$UploadRow$unsupress,
			apiClient,
			uploadId,
			id,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
	});
var $author$project$Components$Upload$RawRowModal$Closed = 1;
var $author$project$Components$Upload$RawRowModal$None = 0;
var $author$project$Components$Upload$RawRowModal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tt: response}),
					$author$project$OutMsg$handleErrorResponse(response),
					0);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j8: !model.j8}),
					_List_Nil,
					0);
			default:
				return _Utils_Tuple3(model, _List_Nil, 1);
		}
	});
var $author$project$Api$Employer$UploadRow$updateReviewed = F5(
	function (apiClient, uploadId, id, reviewed, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'reviewed',
					$elm$json$Json$Encode$bool(reviewed))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Employer$UploadRow$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$Provider$UploadRow$updateReviewed = F5(
	function (apiClient, uploadId, id, reviewed, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'reviewed',
					$elm$json$Json$Encode$bool(reviewed))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$UploadRow$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
	});
var $author$project$Api$UploadRow$updateReviewed = F6(
	function (apiClient, session, uploadId, id, reviewed, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5(
			$author$project$Api$Employer$UploadRow$updateReviewed,
			apiClient,
			uploadId,
			id,
			reviewed,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A5(
			$author$project$Api$Provider$UploadRow$updateReviewed,
			apiClient,
			uploadId,
			id,
			reviewed,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iH: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								tu: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{tu: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						hb: selectedOption,
						tu: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$NewDropdown$update, subMsg, model.o4);
				var dropdown = _v2.a;
				var dropdownCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{o4: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 5:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						Hs: selectedOption,
						tu: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oE);
				var dropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oE: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v4.a;
				var searchInputCmd = _v4.b;
				var searchInputEvent = _v4.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v5 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q,
								tu: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 7:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1),
						tu: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, tu: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v7 = model.l9;
				if (!_v7.$) {
					var exportCsv = _v7.a;
					var _v8 = A3($author$project$Components$ExportCsv$update, model.D5, subMsg, exportCsv);
					var exportCsv_ = _v8.a;
					var subCmd = _v8.b;
					var subOutMsg = _v8.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								l9: $elm$core$Maybe$Just(exportCsv_)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg, subCmd),
						subOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var rowNumber = msg.a;
				var messages = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							o3: $elm$core$Maybe$Just(
								_Utils_Tuple2(rowNumber, messages))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{o3: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var uploadRow = msg.a;
				var _v9 = A4(
					$author$project$Components$Upload$RawRowModal$init,
					model.D5,
					model.ZD,
					model.HK,
					$author$project$Api$UploadRow$All$id(uploadRow));
				var rawRowModal = _v9.a;
				var rawRowModalCmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jI: $elm$core$Maybe$Just(rawRowModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg, rawRowModalCmd),
					_List_Nil);
			case 13:
				var subMsg = msg.a;
				var _v10 = model.jI;
				if (!_v10.$) {
					var rawRowModal = _v10.a;
					var _v11 = A2($author$project$Components$Upload$RawRowModal$update, subMsg, rawRowModal);
					var rawRowModal_ = _v11.a;
					var subOutMsg = _v11.b;
					var rawRowModalEvent = _v11.c;
					var newRawRowModal = function () {
						if (!rawRowModalEvent) {
							return $elm$core$Maybe$Just(rawRowModal_);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jI: newRawRowModal}),
						$elm$core$Platform$Cmd$none,
						subOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var uploadRow = msg.a;
				var id = $author$project$Api$UploadRow$All$id(uploadRow);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bi: A2($elm$core$Set$insert, id, model.bi)
						}),
					A5(
						$author$project$Api$UploadRow$unsupress,
						model.D5,
						model.ZD,
						model.HK,
						id,
						A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'unmuted')),
					_List_Nil);
			case 15:
				var uploadRow = msg.a;
				var id = $author$project$Api$UploadRow$All$id(uploadRow);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bi: A2($elm$core$Set$insert, id, model.bi)
						}),
					A5(
						$author$project$Api$UploadRow$supress,
						model.D5,
						model.ZD,
						model.HK,
						id,
						A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'muted')),
					_List_Nil);
			case 16:
				var uploadRow = msg.a;
				var bool = msg.b;
				var id = $author$project$Api$UploadRow$All$id(uploadRow);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bi: A2($elm$core$Set$insert, id, model.bi)
						}),
					A6(
						$author$project$Api$UploadRow$updateReviewed,
						model.D5,
						model.ZD,
						model.HK,
						id,
						bool,
						A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'updated')),
					_List_Nil);
			default:
				var uploadRow = msg.a;
				var action = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bi: A2(
									$elm$core$Set$remove,
									$author$project$Api$UploadRow$All$id(uploadRow),
									model.bi),
								tu: $author$project$Api$Data$Loading
							}),
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(model),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'Row #' + ($elm$core$String$fromInt(
									$author$project$Api$UploadRow$All$rowNumber(uploadRow)) + (' was successfully ' + (action + '.'))))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bi: A2(
									$elm$core$Set$remove,
									$author$project$Api$UploadRow$All$id(uploadRow),
									model.bi)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$exportUploadRowsParams = function (model) {
	var queryParams = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			A2(
				$author$project$Api$Param$string,
				'filter',
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString(model.YB))),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue,
				$author$project$Api$Param$string('upload_row_results_result_type')),
			model.hb),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue,
				$author$project$Api$Param$string('supress_filter')),
			model.Hs),
			A2(
			$elm$core$Maybe$map,
			$author$project$Api$Param$string('q'),
			model.af_)
		]);
	return A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToTitle = function (resultType) {
	switch (resultType) {
		case 0:
			return 'Failed';
		case 1:
			return 'Warning';
		default:
			return 'Processed';
	}
};
var $author$project$Api$Employer$UploadRow$One$rowNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$rowNumber(shared);
};
var $author$project$Api$Provider$UploadRow$One$rowNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$rowNumber(shared);
};
var $author$project$Api$UploadRow$One$rowNumber = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$One$rowNumber(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$One$rowNumber(uploadRow_);
	}
};
var $author$project$Components$Upload$RawRowModal$ToggleRowsInGroup = {$: 1};
var $author$project$Api$Employer$UploadRow$Shared$csvRow = function (_v0) {
	var record = _v0;
	return record.Mp;
};
var $author$project$Api$Employer$UploadRow$One$csvRow = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$csvRow(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$csvRow = function (_v0) {
	var record = _v0;
	return record.Mp;
};
var $author$project$Api$Provider$UploadRow$One$csvRow = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$csvRow(shared);
};
var $author$project$Api$UploadRow$One$csvRow = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$One$csvRow(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$One$csvRow(uploadRow_);
	}
};
var $author$project$Api$UploadRow$Shared$rowNumber = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$Shared$rowNumber(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$Shared$rowNumber(uploadRow_);
	}
};
var $author$project$Api$UploadRow$Shared$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$UploadRow$Shared$fromEmployer = $author$project$Api$UploadRow$Shared$Employer;
var $author$project$Api$UploadRow$Shared$Provider = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$UploadRow$Shared$fromProvider = $author$project$Api$UploadRow$Shared$Provider;
var $author$project$Api$Employer$UploadRow$One$rowsInMyGroup = function (_v0) {
	var record = _v0.b;
	return record.YS;
};
var $author$project$Api$Provider$UploadRow$One$rowsInMyGroup = function (_v0) {
	var record = _v0.b;
	return record.YS;
};
var $author$project$Api$UploadRow$One$rowsInMyGroup = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$UploadRow$Shared$fromProvider,
			$author$project$Api$Provider$UploadRow$One$rowsInMyGroup(uploadRow_));
	} else {
		var uploadRow_ = uploadRow.a;
		return A2(
			$elm$core$List$map,
			$author$project$Api$UploadRow$Shared$fromEmployer,
			$author$project$Api$Employer$UploadRow$One$rowsInMyGroup(uploadRow_));
	}
};
var $author$project$Api$UploadRow$Shared$csvRow = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$Shared$csvRow(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$Shared$csvRow(uploadRow_);
	}
};
var $author$project$Components$Upload$RawRowModal$viewCsvValue = function (value) {
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$Maybe$withDefault, '', value))
					]))
			]));
};
var $author$project$Components$Upload$RawRowModal$viewRowInGroupValue = F2(
	function (key, csv) {
		var value = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2($elm$core$Dict$get, key, csv));
		return $author$project$Components$Upload$RawRowModal$viewCsvValue(value);
	});
var $author$project$Components$Upload$RawRowModal$viewCsvField = F3(
	function (showRowsInGroup, rowsInMyGroup, _v0) {
		var key = _v0.a;
		var value = _v0.b;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(key)
										]))
								])),
							$author$project$Components$Upload$RawRowModal$viewCsvValue(value)
						]),
						showRowsInGroup ? A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$UploadRow$Shared$csvRow,
							$author$project$Components$Upload$RawRowModal$viewRowInGroupValue(key)),
						rowsInMyGroup) : _List_Nil
					])));
	});
var $author$project$Components$Upload$RawRowModal$viewRowNumber = function (rowNumber) {
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(rowNumber))
			]));
};
var $author$project$Components$Upload$RawRowModal$viewModalBody = F2(
	function (uploadRow, model) {
		var rowsInMyGroup = $author$project$Api$UploadRow$One$rowsInMyGroup(uploadRow);
		var rowsInMyGroupLength = $elm$core$List$length(rowsInMyGroup);
		var rowNumber = $author$project$Api$UploadRow$One$rowNumber(uploadRow);
		return _List_fromArray(
			[
				(rowsInMyGroupLength > 0) ? A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_Utils_ap(
					(rowsInMyGroupLength === 1) ? _List_fromArray(
						[
							$elm$html$Html$text('* There is one more row in this group. ')
						]) : _List_fromArray(
						[
							$elm$html$Html$text('* There are '),
							$elm$html$Html$text(
							$elm$core$String$fromInt(rowsInMyGroupLength)),
							$elm$html$Html$text(' more rows in this group. ')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Toggle rows visibility'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$onClick($author$project$Components$Upload$RawRowModal$ToggleRowsInGroup)
								]),
							_List_fromArray(
								[
									model.j8 ? $elm$html$Html$text('Hide') : $elm$html$Html$text('Show'),
									$elm$html$Html$text(' Rows')
								]))
						]))) : $author$project$Utils$Html$empty,
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Table$row,
						_List_Nil,
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$cell,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Row #')
													]))
											])),
										$author$project$Components$Upload$RawRowModal$viewRowNumber(rowNumber)
									]),
									model.j8 ? A2(
									$elm$core$List$map,
									A2($elm$core$Basics$composeR, $author$project$Api$UploadRow$Shared$rowNumber, $author$project$Components$Upload$RawRowModal$viewRowNumber),
									rowsInMyGroup) : _List_Nil
								]))),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Upload$RawRowModal$viewCsvField, model.j8, rowsInMyGroup),
						$elm$core$Dict$toList(
							$author$project$Api$UploadRow$One$csvRow(uploadRow)))),
				_List_Nil)
			]);
	});
var $author$project$Components$Upload$RawRowModal$view = function (model) {
	var rowNumber = A2(
		$elm$core$Maybe$withDefault,
		'N/A',
		A2(
			$elm$core$Maybe$map,
			$elm$core$String$fromInt,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$UploadRow$One$rowNumber,
				$author$project$Api$Data$toMaybe(model.tt))));
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Upload$RawRowModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Raw CSV Row #' + rowNumber)
					])),
				$author$project$Ui$Modal$body(
				function () {
					var _v0 = model.tt;
					if (_v0.$ === 3) {
						var uploadRow = _v0.a;
						return A2($author$project$Components$Upload$RawRowModal$viewModalBody, uploadRow, model);
					} else {
						return _List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]);
					}
				}()),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Upload$RawRowModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							]))
					]))
			]));
};
var $author$project$Components$Upload$RowDescriptionDetailsModal$viewWarning = function (warning) {
	return A2(
		$author$project$Ui$ListGroup$item,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(warning)
			]));
};
var $author$project$Components$Upload$RowDescriptionDetailsModal$view = F3(
	function (title, warnings, onClose) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(title)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$ListGroup$view,
							_List_Nil,
							A2($elm$core$List$map, $author$project$Components$Upload$RowDescriptionDetailsModal$viewWarning, warnings))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(onClose)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel = function (supress) {
	if (supress.$ === 1) {
		return 'All Rows';
	} else {
		if (!supress.a) {
			var _v1 = supress.a;
			return 'Muted rows';
		} else {
			var _v2 = supress.a;
			return 'Umuted rows';
		}
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressFilterDropdownOptions = function (currentSupress) {
	var supressToItem = function (supress) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressSelected(supress)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentSupress, supress))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel(supress)));
	};
	return _List_fromArray(
		[
			supressToItem($elm$core$Maybe$Nothing),
			$author$project$Ui$NewDropdown$separator,
			supressToItem(
			$elm$core$Maybe$Just(0)),
			supressToItem(
			$elm$core$Maybe$Just(1))
		]);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewSupressFilterDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel(model.Hs))
			]),
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressFilterDropdownOptions(model.Hs),
		model.oE);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow = function (resultType) {
	return !resultType;
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$columns = function (resultType) {
	var reviewedColumn = A3($author$project$Api$Column$init, 'reviewed', false, 'Reviewed');
	var messagesColumnId = $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow(resultType) ? 'upload_row_results_error_code' : 'upload_row_results_message';
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'row_number', true, 'Row #'),
					A3($author$project$Api$Column$init, 'patient_ident', false, 'Platform Patient'),
					A3($author$project$Api$Column$init, 'external_id', false, 'External ID'),
					A3($author$project$Api$Column$init, 'first_name', false, 'First Name'),
					A3($author$project$Api$Column$init, 'last_name', false, 'Last Name'),
					A3($author$project$Api$Column$init, 'current_dob', false, 'Dob')
				]),
				function () {
				switch (resultType) {
					case 0:
						return _List_Nil;
					case 1:
						return _List_Nil;
					default:
						return _List_fromArray(
							[
								A3($author$project$Api$Column$init, 'actions', false, 'Processing Result')
							]);
				}
			}(),
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, messagesColumnId, false, 'Processing Desc.')
				]),
				function () {
				switch (resultType) {
					case 0:
						return _List_fromArray(
							[
								A3($author$project$Api$Column$init, 'supress_status', false, 'Status')
							]);
					case 1:
						return _List_Nil;
					default:
						return _List_Nil;
				}
			}(),
				function () {
				switch (resultType) {
					case 0:
						return _List_fromArray(
							[reviewedColumn]);
					case 1:
						return _List_fromArray(
							[reviewedColumn]);
					default:
						return _List_Nil;
				}
			}(),
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'controls', false, 'Actions')
				])
			]));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressRow = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UnsupressRow = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UpdateRowReviewed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRawRow = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRowMessages = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Api$Common$UploadRowResult$Data$currentDob = function (_v0) {
	var record = _v0;
	return record.Mt;
};
var $author$project$Api$Common$UploadRowResult$Data$externalId = function (_v0) {
	var record = _v0;
	return record.ade;
};
var $author$project$Api$Common$UploadRowResult$Data$firstName = function (_v0) {
	var record = _v0;
	return record.Pu;
};
var $author$project$Api$Employer$UploadRow$Shared$isSupressed = function (_v0) {
	var record = _v0;
	return record.R9;
};
var $author$project$Api$Employer$UploadRow$All$isSupressed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$isSupressed(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$isSupressed = function (_v0) {
	var record = _v0;
	return record.R9;
};
var $author$project$Api$Provider$UploadRow$All$isSupressed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$isSupressed(shared);
};
var $author$project$Api$UploadRow$All$isSupressed = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$isSupressed(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$isSupressed(uploadRow_);
	}
};
var $author$project$Api$Common$UploadRowResult$Data$lastName = function (_v0) {
	var record = _v0;
	return record.SA;
};
var $author$project$Api$Common$UploadRowResult$Data$patientIdent = function (_v0) {
	var record = _v0;
	return record.VO;
};
var $author$project$Ui$Element$Phi = {$: 16};
var $author$project$Ui$Element$phi = $author$project$Ui$Element$Phi;
var $author$project$Api$Employer$UploadRow$All$resultData = function (_v0) {
	var record = _v0.b;
	return record.YA;
};
var $author$project$Api$Provider$UploadRow$All$resultData = function (_v0) {
	var record = _v0.b;
	return record.YA;
};
var $author$project$Api$UploadRow$All$resultData = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$resultData(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$resultData(uploadRow_);
	}
};
var $author$project$Api$Employer$UploadRow$Shared$reviewed = function (_v0) {
	var record = _v0;
	return record.YK;
};
var $author$project$Api$Employer$UploadRow$All$reviewed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$UploadRow$Shared$reviewed(shared);
};
var $author$project$Api$Provider$UploadRow$Shared$reviewed = function (_v0) {
	var record = _v0;
	return record.YK;
};
var $author$project$Api$Provider$UploadRow$All$reviewed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$UploadRow$Shared$reviewed(shared);
};
var $author$project$Api$UploadRow$All$reviewed = function (uploadRow) {
	if (!uploadRow.$) {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Provider$UploadRow$All$reviewed(uploadRow_);
	} else {
		var uploadRow_ = uploadRow.a;
		return $author$project$Api$Employer$UploadRow$All$reviewed(uploadRow_);
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowMessages = function (uploadRowResults) {
	return $elm_community$list_extra$List$Extra$unique(
		$elm$core$List$concat(
			A2(
				$elm$core$List$filterMap,
				function (uploadRowResult) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$String$split('|'),
						$author$project$Api$UploadRowResult$Shared$message(uploadRowResult));
				},
				uploadRowResults)));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewRow = F2(
	function (model, uploadRow) {
		var uploadRowResults = A2(
			$elm$core$List$filterMap,
			function (uploadRowResult) {
				return A2(
					$elm$core$Maybe$andThen,
					function (resultType) {
						var _v7 = model.YB;
						switch (_v7) {
							case 1:
								return A2(
									$elm$core$List$member,
									resultType,
									_List_fromArray(
										['warning', 'duplicate_ignored'])) ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
							case 0:
								return (resultType === 'error') ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
							default:
								return (resultType !== 'warning') ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
						}
					},
					$author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
			},
			$author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
		var uploadRowResultData = $author$project$Api$UploadRow$All$resultData(uploadRow);
		var rowNumber = $author$project$Api$UploadRow$All$rowNumber(uploadRow);
		var patientIdent = A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$patientIdent, uploadRowResultData);
		var messages = $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowMessages(uploadRowResults);
		var loading = A2(
			$elm$core$Set$member,
			$author$project$Api$UploadRow$All$id(uploadRow),
			model.bi);
		var reviewedColumn = A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(
							$author$project$Api$UploadRow$All$reviewed(uploadRow)),
							$author$project$Ui$Form$Checkbox$onCheck(
							$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UpdateRowReviewed(uploadRow)),
							$author$project$Ui$Form$Checkbox$loading(loading)
						]),
					_List_Nil)
				]));
		var canGoToPatients = A3($author$project$Permission$canGoTo, model.ZD, model.adN, 44);
		var blank = A2(
			$author$project$Ui$Typography$em,
			_List_fromArray(
				[$author$project$Ui$Typography$muted]),
			_List_fromArray(
				[
					$elm$html$Html$text('Blank')
				]));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(rowNumber))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = _Utils_Tuple2(patientIdent, canGoToPatients);
									if (!_v0.a.$) {
										if (_v0.b) {
											var patientIdent_ = _v0.a.a;
											return A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{VN: patientIdent_}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(patientIdent_)
													]));
										} else {
											var patientIdent_ = _v0.a.a;
											return $elm$html$Html$text(patientIdent_);
										}
									} else {
										var _v1 = _v0.a;
										return blank;
									}
								}()
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											blank,
											A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$externalId, uploadRowResultData)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											blank,
											A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$firstName, uploadRowResultData)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											blank,
											A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$lastName, uploadRowResultData)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$phi]),
									_List_fromArray(
										[
											A2(
											$elm$core$Maybe$withDefault,
											blank,
											A2(
												$elm$core$Maybe$map,
												$elm$html$Html$text,
												A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$currentDob, uploadRowResultData)))
										]))
								]))
						]),
						function () {
						var _v2 = model.YB;
						switch (_v2) {
							case 0:
								return _List_Nil;
							case 1:
								return _List_Nil;
							default:
								var results = A2(
									$elm$core$List$map,
									A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize),
									$elm_community$list_extra$List$Extra$unique(
										A2(
											$elm$core$List$filterMap,
											function (uploadRowResult) {
												return A2(
													$elm$core$Maybe$andThen,
													function (resultType) {
														var _v3 = model.YB;
														switch (_v3) {
															case 1:
																return A2(
																	$elm$core$List$member,
																	resultType,
																	_List_fromArray(
																		['warning', 'duplicate_ignored'])) ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
															case 0:
																return (resultType === 'error') ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
															default:
																return (resultType !== 'warning') ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
														}
													},
													$author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
											},
											uploadRowResults)));
								var resultsString = $elm$core$List$isEmpty(results) ? 'No Account Change' : A2($elm$core$String$join, ' - ', results);
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Table$cell,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(resultsString)
													]))
											]))
									]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									($elm$core$List$length(messages) > 1) ? _List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$String$ellipsis,
												100,
												A2($elm$core$String$join, ', ', messages))),
											$author$project$Utils$Html$noBreakSpace,
											A3(
											$author$project$Ui$Button$view,
											{abp: 'View all row messages'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRowMessages, rowNumber, messages))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('View all >')
												]))
										]) : _List_fromArray(
										[
											$elm$html$Html$text(
											A2($elm$core$String$join, ', ', messages))
										]))
								]))
						]),
						function () {
						var _v4 = model.YB;
						switch (_v4) {
							case 0:
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Table$cell,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Api$UploadRow$All$isSupressed(uploadRow) ? $elm$html$Html$text('Muted') : $elm$html$Html$text('Unmuted')
											]))
									]);
							case 1:
								return _List_Nil;
							default:
								return _List_Nil;
						}
					}(),
						function () {
						var _v5 = model.YB;
						switch (_v5) {
							case 0:
								return _List_fromArray(
									[reviewedColumn]);
							case 1:
								return _List_fromArray(
									[reviewedColumn]);
							default:
								return _List_Nil;
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(2)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'View raw row details'},
									_List_fromArray(
										[
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRawRow(uploadRow))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('CSV Data')
										])),
									$author$project$Utils$Html$noBreakSpace,
									function () {
									var _v6 = _Utils_Tuple2(
										$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow(model.YB),
										$author$project$Api$UploadRow$All$isSupressed(uploadRow));
									if (_v6.a) {
										if (_v6.b) {
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'Unmute'},
												_List_fromArray(
													[
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UnsupressRow(uploadRow)),
														$author$project$Ui$Button$loading(loading)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Unmute')
													]));
										} else {
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'Mute'},
												_List_fromArray(
													[
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick(
														$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressRow(uploadRow)),
														$author$project$Ui$Button$loading(loading)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Mute')
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])
					])));
	});
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.tu;
		if (_v1.$ === 3) {
			var uploadRows_ = _v1.a;
			return _Utils_Tuple2(false, uploadRows_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploadRows = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the filters selected.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SortTable)),
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$columns(model.YB)),
					$author$project$Utils$Maybe$toBool(model.l9) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg, $author$project$Components$ExportCsv$button)
							]))
					]) : _List_Nil
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewRow(model),
			uploadRows),
		_List_Nil);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel = function (maybeAction) {
	if (maybeAction.$ === 1) {
		return 'All Actions';
	} else {
		var action = maybeAction.a;
		switch (action) {
			case 0:
				return 'No Account Change';
			case 1:
				return 'Dob Updated';
			case 2:
				return 'New Patient';
			case 3:
				return 'Enrolled';
			case 4:
				return 'Restarted';
			case 5:
				return 'Terminated by End Date';
			case 7:
				return 'End Date Updated';
			case 6:
				return 'Membership Changed';
			case 8:
				return 'New Company';
			default:
				return 'Plan Changed';
		}
	}
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ResultActionSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowResultsResultTypeDropdownOptions = function (currentType) {
	var actionToItem = function (action) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ResultActionSelected(action)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentType, action))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel(action)));
	};
	return A2(
		$elm$core$List$cons,
		actionToItem($elm$core$Maybe$Nothing),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, actionToItem),
				_List_fromArray(
					[0, 1, 2, 3, 4, 5, 7, 6, 8, 9]))));
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewUploadRowResultsResultTypeDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel(model.hb))
			]),
		$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowResultsResultTypeDropdownOptions(model.hb),
		model.o4);
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.o3;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var rowNumber = _v1.a;
					var messages = _v1.b;
					var title = 'Row #' + ($elm$core$String$fromInt(rowNumber) + ' Processing Description');
					return A3($author$project$Components$Upload$RowDescriptionDetailsModal$view, title, messages, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.jI;
				if (!_v2.$) {
					var rawRowModal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg,
						$author$project$Components$Upload$RawRowModal$view(rawRowModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.l9;
				if (!_v3.$) {
					var exportCsv = _v3.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg,
						A3(
							$author$project$Components$ExportCsv$modal,
							model.D5,
							_List_fromArray(
								[
									$author$project$Components$ExportCsv$params(
									$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$exportUploadRowsParams(model)),
									$author$project$Components$ExportCsv$path(
									$author$project$Api$Provider$UploadRow$uploadRowsPath(model.HK))
								]),
							exportCsv));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A6(
				$author$project$Layouts$Company$Uploads$view,
				model.ZD,
				model.WF,
				model.ab9,
				model.iH,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$elm$core$Basics$never,
										A2(
											$author$project$Ui$Breadcrumb$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
																{ff: model.ff}),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Uploads')
																]))
														])),
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top(
																{ff: model.ff, HK: model.HK}),
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(model.HK)
																]))
														])),
													A2(
													$author$project$Ui$Breadcrumb$item,
													_List_fromArray(
														[
															$author$project$Ui$Breadcrumb$active(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToTitle(model.YB))
														]))
												]))),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$offset(6),
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanSm(3),
														$author$project$Ui$FlexGrid$offsetSm(9)
													]),
												_List_fromArray(
													[
														function () {
														var _v4 = model.YB;
														switch (_v4) {
															case 0:
																return $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewSupressFilterDropdown(model);
															case 1:
																return $author$project$Utils$Html$empty;
															default:
																return $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewUploadRowResultsResultTypeDropdown(model);
														}
													}()
													]))
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_fromArray(
											[$author$project$Ui$FlexGrid$mb2]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(12)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg,
																A2(
																	$author$project$Ui$SearchInput$view,
																	_List_fromArray(
																		[
																			$author$project$Ui$SearchInput$placeholder('Search by first or last name')
																		]),
																	model.sA))
															]))
													]))
											])),
										$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewTable(model)
									]))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(
									!$author$project$Utils$Maybe$toBool(
										$author$project$Api$Data$toMaybe(model.tu)))
								]),
							model.afy))
					]))
			]),
		$G: A2($author$project$Api$Practice$sponsorize, model.WF, 'Companies') + ' | Employee Uploads'
	};
};
var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$page = $author$project$Spa$Page$applicationCompanyOrEmployer(
	{ad0: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$init, aer: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$load, agD: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$save, ahd: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$subscriptions, aaq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$update, ahP: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$view});
var $author$project$Pages$Companies$New$GotPracticeCompanyInvoiceSetting = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$New$LocationResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$New$PlanResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$New$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var currentDate = _v0.cO;
		var practiceCompanyInvoiceSettingId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id(
			$author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
		var _v2 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						AS: _List_fromArray(
							[0, 1, 3])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Plan'});
			});
		var planResourceFilter = _v2.a;
		var planResourceFilterCmd = _v2.b;
		var _v3 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Locations'});
			});
		var locationResourceFilter = _v3.a;
		var locationResourceFilterCmd = _v3.b;
		return _Utils_Tuple2(
			{
				D5: apiClient,
				Eg: false,
				ab9: $author$project$Api$Data$NotAsked,
				aX: $elm$core$Maybe$Nothing,
				cO: currentDate,
				rl: locationResourceFilter,
				jw: planResourceFilter,
				WF: practice,
				BR: $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies(practice)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, apiClient, practiceCompanyInvoiceSettingId, $author$project$Pages$Companies$New$GotPracticeCompanyInvoiceSetting),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Pages$Companies$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Companies$New$DefaultLocation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$New$DefaultPlan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$New$companyFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{Nh: string});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{M9: string});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						J$: $elm$core$Maybe$Just(string)
					});
		}
	});
var $author$project$Pages$Companies$New$DefaultPlanValidation = 1;
var $author$project$Pages$Companies$New$NameValidation = 0;
var $author$project$Pages$Companies$New$DefaultLocationValidation = 2;
var $author$project$Pages$Companies$New$validateDefaultLocation = F2(
	function (requireDefaultLocationForCompanies, form) {
		var _v0 = _Utils_Tuple2(requireDefaultLocationForCompanies, form.M9);
		if (_v0.a && (_v0.b.$ === 1)) {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(2, 'Please select a location.')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Companies$New$companyFormFieldsValidator = function (requireDefaultLocationForCompanies) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.zh;
				},
				_Utils_Tuple2(0, 'Please enter a company name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Nh;
				},
				_Utils_Tuple2(1, 'Please select a plan.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Companies$New$validateDefaultLocation(requireDefaultLocationForCompanies))
			]));
};
var $author$project$Pages$Companies$New$GotCompany = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Company$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'company',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(fields.zh)),
										_Utils_Tuple2(
										'default_plan',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string(fields.Ni))
												]))),
										_Utils_Tuple2(
										'billing_start_date',
										A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.J$))
									]),
									function () {
									var _v0 = fields.Na;
									if (!_v0.$) {
										var string = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'default_location',
												$elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'id',
															$elm$json$Json$Encode$string(string))
														])))
											]);
									} else {
										return _List_Nil;
									}
								}()
								]))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Company$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companiesPath)));
	});
var $author$project$Pages$Companies$New$createCompany = F3(
	function (practice, apiClient, companyFormFields) {
		var validFields = $rtfeldman$elm_validate$Validate$fromValid(companyFormFields);
		var defaultPlanId = validFields.Nh;
		var defaultLocationId = validFields.M9;
		var billingStartDate = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, practice) ? A2(
			$elm$core$Maybe$andThen,
			A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm$core$Result$toMaybe),
			validFields.J$) : $elm$core$Maybe$Nothing;
		return A3(
			$author$project$Api$Provider$Company$create,
			apiClient,
			{J$: billingStartDate, Na: defaultLocationId, Ni: defaultPlanId, zh: validFields.zh},
			$author$project$Pages$Companies$New$GotCompany);
	});
var $author$project$Pages$Companies$New$initCompanyFormFields = function (billingStartDate) {
	return {J$: billingStartDate, M9: $elm$core$Maybe$Nothing, Nh: '', zh: ''};
};
var $author$project$Pages$Companies$New$createCompanyForm = F2(
	function (billingEnabled, billingStartDate) {
		var billingStartDateDefaultSelectedValue = billingEnabled ? $author$project$Utils$Date$toIsoString(billingStartDate) : '';
		return $author$project$Utils$Form$init(
			$author$project$Pages$Companies$New$initCompanyFormFields(
				$author$project$Utils$String$toMaybe(billingStartDateDefaultSelectedValue)));
	});
var $author$project$Pages$Companies$New$viewBillingStartDateOptions = function (currentDate) {
	var billingStartDate = $author$project$Utils$Date$toBeginningOfMonth(currentDate);
	return _Utils_Tuple2(
		billingStartDate,
		$author$project$Ui$Form$Select$dateOptions(
			$author$project$Utils$Date$nextTwelveMonths(billingStartDate)));
};
var $author$project$Pages$Companies$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v1 = model.aX;
				if (!_v1.$) {
					var newCompanyForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aX: $elm$core$Maybe$Just(
									A3($author$project$Utils$Form$update, $author$project$Pages$Companies$New$companyFormFieldsUpdate, field, newCompanyForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = model.aX;
				if (!_v2.$) {
					var newCompanyForm = _v2.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.D5, subMsg, model.jw);
					var modelAfterEvent = function () {
						var _v3 = planResourceResult.ac5;
						if (!_v3.$) {
							if (!_v3.a.$) {
								return _Utils_update(
									model,
									{
										aX: $elm$core$Maybe$Just(
											A3(
												$author$project$Utils$Form$update,
												$author$project$Pages$Companies$New$companyFormFieldsUpdate,
												$author$project$Pages$Companies$New$DefaultPlan(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Components$ResourceFilter$Plan$value(planResourceResult.y8))),
												newCompanyForm))
									});
							} else {
								var _v4 = _v3.a;
								return model;
							}
						} else {
							return model;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							modelAfterEvent,
							{jw: planResourceResult.y8}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$PlanResourceFilterMsg, planResourceResult.EC),
						planResourceResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v5 = model.aX;
				if (!_v5.$) {
					var newCompanyForm = _v5.a;
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, model.D5, subMsg, model.rl);
					var modelAfterEvent = function () {
						var _v6 = locationResourceResult.ac5;
						if (!_v6.$) {
							if (!_v6.a.$) {
								return _Utils_update(
									model,
									{
										aX: $elm$core$Maybe$Just(
											A3(
												$author$project$Utils$Form$update,
												$author$project$Pages$Companies$New$companyFormFieldsUpdate,
												$author$project$Pages$Companies$New$DefaultLocation(
													$author$project$Components$ResourceFilter$Location$value(locationResourceResult.y8)),
												newCompanyForm))
									});
							} else {
								var _v7 = _v6.a;
								return model;
							}
						} else {
							return model;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							modelAfterEvent,
							{rl: locationResourceResult.y8}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$LocationResourceFilterMsg, locationResourceResult.EC),
						locationResourceResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v8 = model.aX;
				if (!_v8.$) {
					var newCompanyForm = _v8.a;
					var _v9 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Pages$Companies$New$companyFormFieldsValidator(model.BR),
						newCompanyForm);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var newForm = _v10.a;
						var validFormFields = _v10.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ab9: $author$project$Api$Data$Loading,
									aX: $elm$core$Maybe$Just(newForm)
								}),
							A3($author$project$Pages$Companies$New$createCompany, model.WF, model.D5, validFormFields),
							_List_Nil);
					} else {
						var newForm = _v9.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aX: $elm$core$Maybe$Just(newForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var company = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ab9: response}),
						$author$project$Ports$Navigation$pushUrl(
							'/companies/' + $author$project$Api$Provider$Company$One$id(company)),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Company$One$name(company) + ' created')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ab9: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practiceSettings = response.a;
					var billingEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.WF) ? $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings) : false;
					var _v13 = $author$project$Pages$Companies$New$viewBillingStartDateOptions(model.cO);
					var billingStartDate = _v13.a;
					var newForm = A2($author$project$Pages$Companies$New$createCompanyForm, billingEnabled, billingStartDate);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Eg: billingEnabled,
								aX: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Companies$New$CreateCompany = {$: 3};
var $author$project$Pages$Companies$New$BillingStartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Companies$New$CompanyFormFieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Companies$New$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$One$notRetailPlansCount = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.UM;
	});
var $author$project$Pages$Companies$New$viewPanelBody = function (model) {
	var _v0 = model.aX;
	if (!_v0.$) {
		var newCompanyForm = _v0.a;
		if ($author$project$Api$Provider$Practice$One$notRetailPlansCount(model.WF) > 0) {
			var _v1 = $author$project$Utils$Form$fields(newCompanyForm);
			var name = _v1.zh;
			var _v2 = $author$project$Pages$Companies$New$viewBillingStartDateOptions(model.cO);
			var billingStartDate = _v2.a;
			var billingStartDateOptions = _v2.b;
			return $elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label(
									'Name the ' + A2($author$project$Formatters$String$sponsorize, model.WF, 'Employer')),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$autofocus(true),
											$author$project$Ui$Form$Input$value(name),
											$author$project$Ui$Form$Input$placeholder(
											'New ' + (A2($author$project$Formatters$String$sponsorize, model.WF, 'Employer') + ' Name')),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$New$CompanyFormFieldUpdated, $author$project$Pages$Companies$New$Name)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, newCompanyForm)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, 0, newCompanyForm))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Default Plan'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$New$PlanResourceFilterMsg,
									A2(
										$author$project$Components$ResourceFilter$Plan$view,
										_List_fromArray(
											[
												$author$project$Components$ResourceFilter$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 1, newCompanyForm)),
												$author$project$Components$ResourceFilter$errors(
												A2($author$project$Utils$Form$validationErrors, 1, newCompanyForm))
											]),
										model.jw))
								])),
							model.Eg ? A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Billing Start Date'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											$elm$core$Maybe$Just(
												$author$project$Utils$Date$toIsoString(billingStartDate))),
											$author$project$Ui$Form$Select$onChange(
											A2($elm$core$Basics$composeL, $author$project$Pages$Companies$New$CompanyFormFieldUpdated, $author$project$Pages$Companies$New$BillingStartDate))
										]),
									billingStartDateOptions)
								])) : $author$project$Utils$Html$empty
						]),
						model.BR ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Default Location'),
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Companies$New$LocationResourceFilterMsg,
									A2(
										$author$project$Components$ResourceFilter$Location$view,
										_List_fromArray(
											[
												$author$project$Components$ResourceFilter$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 2, newCompanyForm)),
												$author$project$Components$ResourceFilter$errors(
												A2($author$project$Utils$Form$validationErrors, 2, newCompanyForm))
											]),
										model.rl))
								]))
						]) : _List_Nil
					]));
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsEnd, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('It looks like you haven\'t added any '),
									$elm$html$Html$text(
									A2($author$project$Formatters$String$sponsorize, model.WF, 'employer')),
									$elm$html$Html$text(' plan yet.')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__CompanyPlans__New,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Create one?')
								]))
						]))
				]);
		}
	} else {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton(
						'Name the ' + A2($author$project$Formatters$String$sponsorize, model.WF, 'Employer')),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$input(_List_Nil)
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton('Default Plan'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$input(_List_Nil)
					])),
				model.Eg ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Billing Start Date'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$input(_List_Nil)
					])) : $author$project$Utils$Html$empty
			]);
	}
};
var $author$project$Pages$Companies$New$viewPanelFooter = function (_v0) {
	var practice = _v0.WF;
	var company = _v0.ab9;
	return ($author$project$Api$Provider$Practice$One$notRetailPlansCount(practice) > 0) ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Companies__Top,
			_List_fromArray(
				[$author$project$Ui$Link$buttonSecondary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Cancel')
				])),
			A3(
			$author$project$Ui$Button$view,
			{
				abp: 'Create New ' + A2($author$project$Formatters$String$sponsorize, practice, 'Employer')
			},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$submit,
					$author$project$Ui$Button$loading(
					_Utils_eq(company, $author$project$Api$Data$Loading))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Create New ' + A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))
				]))
		]) : _List_Nil;
};
var $author$project$Pages$Companies$New$viewBody = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$onSubmit($author$project$Pages$Companies$New$CreateCompany),
				$author$project$Ui$Form$horizontal
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Create New ' + A2($author$project$Formatters$String$sponsorize, model.WF, 'Employer'))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Companies$New$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter]),
						$author$project$Pages$Companies$New$viewPanelFooter(model))
					]))
			]));
};
var $author$project$Pages$Companies$New$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$Companies$New$viewBody(model)
			]),
		$G: A2($author$project$Formatters$String$sponsorize, model.WF, 'Employers')
	};
};
var $author$project$Pages$Companies$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Companies$New$init, aer: $author$project$Pages$Companies$New$load, agD: $author$project$Pages$Companies$New$save, ahd: $author$project$Pages$Companies$New$subscriptions, aaq: $author$project$Pages$Companies$New$update, ahP: $author$project$Pages$Companies$New$view});
var $author$project$Pages$Companies$Top$FilterDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$FeatureGate$ManageEmployers = 9;
var $author$project$Pages$Companies$Top$PlanResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Companies$Top$SponsorTypeDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Company$EligibleCount = 1;
var $author$project$Api$Provider$Company$EnrolledCount = 2;
var $author$project$Pages$Companies$Top$GotCompanies = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Company$NeedsApprovalCount = 3;
var $author$project$Api$Provider$Company$OwedInCents = 4;
var $author$project$Api$Provider$Company$Plans = 0;
var $author$project$Pages$Companies$Top$filterToValue = function (filter) {
	switch (filter) {
		case 0:
			return '';
		case 1:
			return 'with_flagged_notes';
		case 2:
			return 'without_default_location';
		case 3:
			return 'without_broker_deals';
		case 4:
			return 'needs_approval_review';
		default:
			return 'archived';
	}
};
var $author$project$Pages$Companies$Top$sponsorTypeToValue = function (sponsorType) {
	switch (sponsorType) {
		case 0:
			return '';
		case 1:
			return 'network';
		default:
			return 'employer';
	}
};
var $author$project$Pages$Companies$Top$fetchCompanies = function (model) {
	return A3(
		$author$project$Api$Provider$Company$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{
					Fc: _List_fromArray(
						[0, 1, 2, 3, 4]),
					Fi: function () {
						var _v0 = model.Fi;
						if (!_v0) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(
								$author$project$Pages$Companies$Top$filterToValue(model.Fi));
						}
					}(),
					afy: model.afy,
					GH: model.afN,
					af_: model.af_,
					ag1: model.ag1,
					Hj: function () {
						var _v1 = model.Hj;
						if (!_v1) {
							return $elm$core$Maybe$Nothing;
						} else {
							return $elm$core$Maybe$Just(
								$author$project$Pages$Companies$Top$sponsorTypeToValue(model.Hj));
						}
					}()
				});
		},
		$author$project$Pages$Companies$Top$GotCompanies);
};
var $author$project$Pages$Companies$Top$GotUpgradePricing = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Companies$Top$fetchUpgradePricing = function (apiClient) {
	return A2($author$project$Api$Provider$PracticePricing$Upgrade$retrieve, apiClient, $author$project$Pages$Companies$Top$GotUpgradePricing);
};
var $author$project$Pages$Companies$Top$All = 0;
var $author$project$Pages$Companies$Top$Archived = 5;
var $author$project$Pages$Companies$Top$NeedsApprovalReview = 4;
var $author$project$Pages$Companies$Top$WithFlaggedNotes = 1;
var $author$project$Pages$Companies$Top$WithoutBrokerDeals = 3;
var $author$project$Pages$Companies$Top$WithoutDefaultLocation = 2;
var $author$project$Pages$Companies$Top$filterFromQuery = function (queryString) {
	_v0$5:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'with_flagged_notes':
					return 1;
				case 'without_default_location':
					return 2;
				case 'without_broker_deals':
					return 3;
				case 'needs_approval_review':
					return 4;
				case 'archived':
					return 5;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 0;
};
var $author$project$Pages$Companies$Top$AllSponsorTypes = 0;
var $author$project$Pages$Companies$Top$Employer = 2;
var $author$project$Pages$Companies$Top$Network = 1;
var $author$project$Pages$Companies$Top$sponsorTypeFromQuery = function (queryString) {
	_v0$2:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'network':
					return 1;
				case 'employer':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Pages$Companies$Top$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var query = _v1.Bi;
		var selfUpgradeEnabled = !A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			9,
			$author$project$Api$Practice$Provider(practice));
		var q = A2($elm$core$Dict$get, 'q', query);
		var planId = A2($elm$core$Dict$get, 'plan', query);
		var _v2 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						AS: _List_fromArray(
							[0, 1])
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Plans', afT: planId});
			});
		var planResourceFilter = _v2.a;
		var planResourceFilterCmd = _v2.b;
		var model = {
			D5: apiClient,
			bT: $author$project$Api$Data$Loading,
			Fi: $author$project$Pages$Companies$Top$filterFromQuery(
				A2($elm$core$Dict$get, 'filter', query)),
			mg: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'filter-dropdown-filter', ahx: $author$project$Pages$Companies$Top$FilterDropdownMsg})),
			afy: $author$project$Api$Pagination$initFromQuery(query),
			afN: planId,
			jw: planResourceFilter,
			WF: practice,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			G7: selfUpgradeEnabled,
			ZD: session,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			Hj: $author$project$Pages$Companies$Top$sponsorTypeFromQuery(
				A2($elm$core$Dict$get, 'sponsor_type', query)),
			oz: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'sponsor-type-dropdown-filter', ahx: $author$project$Pages$Companies$Top$SponsorTypeDropdownMsg})),
			o2: $elm$core$Maybe$Nothing,
			kC: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$PlanResourceFilterMsg, planResourceFilterCmd),
						$author$project$Pages$Companies$Top$fetchCompanies(model),
						(selfUpgradeEnabled && $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session)) ? $author$project$Pages$Companies$Top$fetchUpgradePricing(apiClient) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Pages$Companies$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Companies$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Companies$Top$UpgradePracticeModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Companies$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(model.mg),
				$author$project$Ui$NewDropdown$subscriptions(model.oz),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$Top$UpgradePracticeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$UpgradePracticeModal$subscriptions, model.kC))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Companies$Top$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.jw))
			]));
};
var $author$project$Pages$Companies$Top$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Companies$Top$updateUrl = F2(
	function (model, customPath) {
		var queryParams = _List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$elm$url$Url$Builder$string('q'),
				model.af_),
				function () {
				var _v0 = model.Fi;
				if (!_v0) {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						A2(
							$elm$url$Url$Builder$string,
							'filter',
							$author$project$Pages$Companies$Top$filterToValue(model.Fi)));
				}
			}(),
				A2(
				$elm$core$Maybe$map,
				$elm$url$Url$Builder$string('plan'),
				model.afN),
				function () {
				var _v1 = model.Hj;
				if (!_v1) {
					return $elm$core$Maybe$Nothing;
				} else {
					return $elm$core$Maybe$Just(
						A2(
							$elm$url$Url$Builder$string,
							'sponsor_type',
							$author$project$Pages$Companies$Top$sponsorTypeToValue(model.Hj)));
				}
			}()
			]);
		var urlParams = A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
		return $author$project$Ports$Navigation$replaceUrl(
			A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Relative,
				_List_fromArray(
					[
						$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Companies__Top)
					]),
				urlParams,
				customPath));
	});
var $author$project$Pages$Companies$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bT: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bT: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v3 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								bT: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Companies$Top$fetchCompanies(qModel),
										A2($author$project$Pages$Companies$Top$updateUrl, qModel, $elm$core$Maybe$Nothing)
									])));
					}
				}();
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{bT: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$NewDropdown$update, subMsg, model.mg);
				var dropdown = _v5.a;
				var dropdownCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mg: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 4:
				var filter = msg.a;
				var newModel = _Utils_update(
					model,
					{bT: $author$project$Api$Data$Loading, Fi: filter});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.D5, subMsg, model.jw);
				var planId = function () {
					var _v7 = planResourceResult.ac5;
					if (!_v7.$) {
						if (!_v7.a.$) {
							return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.y8);
						} else {
							var _v8 = _v7.a;
							return model.afN;
						}
					} else {
						return model.afN;
					}
				}();
				var newModel = _Utils_update(
					model,
					{afN: planId, jw: planResourceResult.y8});
				var _v6 = _Utils_eq(model.afN, newModel.afN) ? _Utils_Tuple2(model.bT, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])));
				var companies = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{bT: companies}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$PlanResourceFilterMsg, planResourceResult.EC),
								cmd
							])),
					planResourceResult.as);
			case 6:
				var subMsg = msg.a;
				var _v9 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oz);
				var dropdown = _v9.a;
				var dropdownCmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oz: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 7:
				var option = msg.a;
				var newModel = _Utils_update(
					model,
					{bT: $author$project$Api$Data$Loading, Hj: option});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Companies$Top$fetchCompanies(newModel),
								A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
							])),
					_List_Nil);
			case 9:
				var response = msg.a;
				_v10$2:
				while (true) {
					switch (response.$) {
						case 3:
							var upgrade = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										o2: $elm$core$Maybe$Just(upgrade)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v11 = response.a;
								return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
							} else {
								break _v10$2;
							}
						default:
							break _v10$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 10:
				var _v12 = A3(
					$author$project$Components$UpgradePracticeModal$init,
					model.o2,
					model.ZD,
					$author$project$Api$Provider$Practice$One$hasClinicalAccount(model.WF));
				var upgradePracticeModal = _v12.a;
				var upgradePracticeModalCmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kC: $elm$core$Maybe$Just(upgradePracticeModal)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$UpgradePracticeModalMsg, upgradePracticeModalCmd),
								A2(
								$author$project$Pages$Companies$Top$updateUrl,
								model,
								$author$project$Components$UpgradePracticeModal$urlParam(upgradePracticeModal))
							])),
					_List_Nil);
			case 11:
				var subMsg = msg.a;
				var _v13 = model.kC;
				if (!_v13.$) {
					var upgradePracticeModal = _v13.a;
					var result = A3($author$project$Components$UpgradePracticeModal$update, model.D5, subMsg, upgradePracticeModal);
					var _v14 = function () {
						var _v15 = result.ac5;
						switch (_v15.$) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Companies$Top$updateUrl, model, $elm$core$Maybe$Nothing),
									_List_Nil);
							case 2:
								var successMsg = _v15.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Companies__Top),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, successMsg)
										]));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(result.y8),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
						}
					}();
					var modal_ = _v14.a;
					var cmd_ = _v14.b;
					var outMsgs_ = _v14.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kC: modal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$UpgradePracticeModalMsg, result.EC),
									cmd_
								])),
						outMsgs_);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var text = msg.a;
				var href = msg.b;
				return _Utils_Tuple3(
					model,
					A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.ZD, text, href),
					_List_Nil);
		}
	});
var $author$project$Pages$Companies$Top$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Companies$Top$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Companies$Top$columns = function (practice) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3(
					$author$project$Api$Column$init,
					'name',
					true,
					A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))
				]),
				$author$project$Api$Provider$Practice$One$usesSponsors(practice) ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'company_type', true, 'Type')
				]) : _List_Nil,
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'plans', false, 'Plan(s)'),
					A3($author$project$Api$Column$init, 'status', false, 'Status'),
					A3($author$project$Api$Column$init, 'enrolled', false, 'Enrolled'),
					A3($author$project$Api$Column$init, 'eligible', false, 'Eligible'),
					A3($author$project$Api$Column$init, 'needs_approval', false, 'Needs Approval'),
					A3($author$project$Api$Column$init, 'account_balance', false, 'Account Balance')
				])
			]));
};
var $author$project$Pages$Companies$Top$Filtered = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Companies$Top$filterToLabel = F2(
	function (practice, filter) {
		switch (filter) {
			case 0:
				return 'All ' + A2($author$project$Formatters$String$sponsorize, practice, 'Companies');
			case 1:
				return 'Has Flagged Notes';
			case 2:
				return 'Has No Default Location';
			case 3:
				return 'Has No Broker Deals';
			case 4:
				return 'Needs Approval Review';
			default:
				return 'Archived';
		}
	});
var $author$project$Pages$Companies$Top$filterItems = F2(
	function (currentFilter, practice) {
		var filterToItem = function (filter) {
			return A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentFilter, filter)),
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Pages$Companies$Top$Filtered(filter))
					]),
				$elm$html$Html$text(
					A2($author$project$Pages$Companies$Top$filterToLabel, practice, filter)));
		};
		return A2(
			$elm$core$List$cons,
			filterToItem(0),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$map,
					filterToItem,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[1, 2]),
								$author$project$Api$Provider$Practice$One$commissionsEnabled(practice) ? _List_fromArray(
								[3]) : _List_Nil,
								_List_fromArray(
								[4, 5])
							])))));
	});
var $author$project$Pages$Companies$Top$SponsorTypeSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Companies$Top$sponsorTypeToLabel = F2(
	function (practice, filter) {
		switch (filter) {
			case 0:
				return 'All ' + (A2($author$project$Formatters$String$sponsorize, practice, 'Companies') + ' Types');
			case 1:
				return 'Network';
			default:
				return 'Employer';
		}
	});
var $author$project$Pages$Companies$Top$sponsorTypeItems = F2(
	function (currentSponsorType, practice) {
		var sponsorTypeToItem = function (sponsorType) {
			return A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentSponsorType, sponsorType)),
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Pages$Companies$Top$SponsorTypeSelected(sponsorType))
					]),
				$elm$html$Html$text(
					A2($author$project$Pages$Companies$Top$sponsorTypeToLabel, practice, sponsorType)));
		};
		return A2(
			$elm$core$List$cons,
			sponsorTypeToItem(0),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$map,
					sponsorTypeToItem,
					_List_fromArray(
						[1, 2]))));
	});
var $author$project$Api$Provider$Company$All$companyType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$companyType(shared);
};
var $author$project$Api$Provider$Company$All$eligibleCount = function (_v0) {
	var record = _v0.b;
	return record.On;
};
var $author$project$Api$Provider$Company$All$enrolledCount = function (_v0) {
	var record = _v0.b;
	return record.OE;
};
var $author$project$Api$Provider$Company$All$flaggedNotesCount = function (_v0) {
	var record = _v0.b;
	return record.Py;
};
var $author$project$Api$Provider$Company$All$needsApprovalCount = function (_v0) {
	var record = _v0.b;
	return record.Un;
};
var $author$project$Api$Provider$Company$All$owedInCents = function (_v0) {
	var record = _v0.b;
	return record.Vo;
};
var $author$project$Api$Provider$Company$All$plans = function (_v0) {
	var record = _v0.b;
	return record.Wq;
};
var $author$project$Api$Provider$Company$All$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Pages$Companies$Top$viewCompany = F2(
	function (practice, company) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
										{
											ff: $author$project$Api$Provider$Company$All$id(company)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Company$All$name(company)),
											$author$project$Utils$Html$noBreakSpace,
											($author$project$Api$Provider$Company$All$flaggedNotesCount(company) > 0) ? $author$project$Ui$SvgIcon$flag(_List_Nil) : $author$project$Utils$Html$empty
										]))
								]))
						]),
						$author$project$Api$Provider$Practice$One$usesSponsors(practice) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									(!$author$project$Api$Provider$Company$All$companyType(company)) ? $elm$html$Html$text('Network') : $elm$html$Html$text('Employer')
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$toSentence(
										A2(
											$elm$core$List$map,
											$author$project$Api$Provider$Plan$Shared$name,
											A2(
												$author$project$Api$Expandable$withDefault,
												_List_Nil,
												$author$project$Api$Provider$Company$All$plans(company)))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$titleize(
										$author$project$Api$Provider$Company$All$status(company)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Company$All$enrolledCount(company))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Company$All$eligibleCount(company))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Company$All$needsApprovalCount(company))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										A2(
											$author$project$Api$Expandable$withDefault,
											0,
											$author$project$Api$Provider$Company$All$owedInCents(company))))
								]))
						])
					])));
	});
var $author$project$Pages$Companies$Top$AnalyticsLinkClicked = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Ui$Panel$ExtraPadding = {$: 2};
var $author$project$Ui$Panel$extraPadding = $author$project$Ui$Panel$ExtraPadding;
var $author$project$Ui$Element$mr4 = $author$project$Ui$Element$Margin('mr-4');
var $author$project$Pages$Companies$Top$userCanSeeCard = F2(
	function (session, upgradeAvailable) {
		var userIsAdmin = $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session);
		return (!userIsAdmin) || (userIsAdmin && $elm_community$maybe_extra$Maybe$Extra$isJust(upgradeAvailable));
	});
var $author$project$Pages$Companies$Top$UpgradePracticeClicked = {$: 10};
var $author$project$Pages$Companies$Top$viewUpgradeButton = F3(
	function (selfUpgradeEnabled, upgradeAvailable, canUserUpgrade) {
		if (selfUpgradeEnabled) {
			var buttonText = function () {
				if (!upgradeAvailable.$) {
					var upgrade = upgradeAvailable.a;
					return 'Upgrade to ' + $author$project$Api$Provider$PracticePricing$Upgrade$tierName(upgrade);
				} else {
					return 'Upgrade';
				}
			}();
			return A3(
				$author$project$Ui$Button$view,
				{abp: buttonText},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Pages$Companies$Top$UpgradePracticeClicked),
						$author$project$Ui$Button$disabled(!canUserUpgrade)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonText)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$Top$viewSelfUpgradeCard = F3(
	function (session, selfUpgradeEnabled, upgradeAvailable) {
		if (selfUpgradeEnabled && A2($author$project$Pages$Companies$Top$userCanSeeCard, session, upgradeAvailable)) {
			var learnMoreLink = 'https://www.hint.com/core#Employer-Direct-Contracting';
			var canUserUpgrade = $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session);
			return A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$extraPadding]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Typography$heading(
										_List_fromArray(
											[
												$elm$html$Html$text('Help Employers Rethink Primary Care, Your Way')
											])),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Employers are ready for a better way to offer healthcare. Partnering with them can grow your revenue by up to 40% while keeping your practice sustainable, patient-focused, and independent. ')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexMd]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mr4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$externalHref,
												learnMoreLink,
												_List_fromArray(
													[
														$author$project$Ui$Link$buttonSecondary,
														$author$project$Ui$Link$targetBlank,
														$author$project$Ui$Link$onClick(
														A2($author$project$Pages$Companies$Top$AnalyticsLinkClicked, 'Learn More', learnMoreLink))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Learn More')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A3($author$project$Pages$Companies$Top$viewUpgradeButton, selfUpgradeEnabled, upgradeAvailable, canUserUpgrade),
												(!canUserUpgrade) ? A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
												_List_fromArray(
													[
														$elm$html$Html$text('Must be an admin to upgrade')
													])) : $author$project$Utils$Html$empty
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Companies$Top$view = function (model) {
	var _v0 = function () {
		var _v1 = model.bT;
		if (_v1.$ === 3) {
			var companies_ = _v1.a;
			return _Utils_Tuple2(false, companies_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var companies = _v0.b;
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v2 = model.kC;
				if (!_v2.$) {
					var modal = _v2.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Companies$Top$UpgradePracticeModalMsg,
						$author$project$Components$UpgradePracticeModal$view(modal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Formatters$String$sponsorize, model.WF, 'Employers'))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Utils$FeatureGate$gateAvailable,
								9,
								$author$project$Api$Practice$Provider(model.WF)) ? A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Companies__New,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add),
										$author$project$Ui$Link$buttonPrimary
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add '),
										$elm$html$Html$text(
										A2($author$project$Formatters$String$sponsorize, model.WF, 'Employer'))
									])) : $elm$html$Html$text('')
							]))
					])),
				A3($author$project$Pages$Companies$Top$viewSelfUpgradeCard, model.ZD, model.G7, model.o2),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Companies$Top$SearchInputMsg,
												A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(2),
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A4(
												$author$project$Ui$NewDropdown$viewSelect,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Pages$Companies$Top$filterToLabel, model.WF, model.Fi))
													]),
												A2($author$project$Pages$Companies$Top$filterItems, model.Fi, model.WF),
												model.mg)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(2),
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Companies$Top$PlanResourceFilterMsg,
												A2($author$project$Components$ResourceFilter$Plan$viewNew, _List_Nil, model.jw))
											])),
										$author$project$Api$Provider$Practice$One$usesSponsors(model.WF) ? A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(2),
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A4(
												$author$project$Ui$NewDropdown$viewSelect,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Pages$Companies$Top$sponsorTypeToLabel, model.WF, model.Hj))
													]),
												A2($author$project$Pages$Companies$Top$sponsorTypeItems, model.Hj, model.WF),
												model.oz)
											])) : $author$project$Ui$FlexGrid$none
									]))
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(loading),
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h4,
										_List_Nil,
										_List_fromArray(
											[
												function () {
												var _v3 = model.af_;
												if (!_v3.$) {
													return A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('No '),
																$elm$html$Html$text(
																A2($author$project$Formatters$String$sponsorize, model.WF, 'employers')),
																$elm$html$Html$text(' found for your search criteria.')
															]));
												} else {
													return A2(
														$author$project$Ui$Element$view,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('It looks like you haven\'t added any '),
																$elm$html$Html$text(
																A2($author$project$Formatters$String$sponsorize, model.WF, 'employers')),
																$elm$html$Html$text(' yet.')
															]));
												}
											}(),
												$author$project$Utils$Html$noBreakSpace,
												A2(
												$author$project$Utils$FeatureGate$gateAvailable,
												9,
												$author$project$Api$Practice$Provider(model.WF)) ? A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Companies__New,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Would you like to create one?')
													])) : $author$project$Utils$Html$empty
											]))
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Api$Column$view(
								A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Companies$Top$SortTable)),
							$author$project$Pages$Companies$Top$columns(model.WF)),
						A2(
							$elm$core$List$map,
							$author$project$Pages$Companies$Top$viewCompany(model.WF),
							companies),
						_List_Nil),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Companies$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.afy))
							]))
					]))
			]),
		$G: A2($author$project$Formatters$String$sponsorize, model.WF, 'Employers')
	};
};
var $author$project$Pages$Companies$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Companies$Top$init, aer: $author$project$Pages$Companies$Top$load, agD: $author$project$Pages$Companies$Top$save, ahd: $author$project$Pages$Companies$Top$subscriptions, aaq: $author$project$Pages$Companies$Top$update, ahP: $author$project$Pages$Companies$Top$view});
var $author$project$Pages$Contacts$ContactId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$ContactId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$ContactId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Contacts$ContactId_String$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Contact'};
};
var $author$project$Pages$Contacts$ContactId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Contacts$ContactId_String$Top$init,
		aer: $author$project$Pages$Contacts$ContactId_String$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Contacts$ContactId_String$Top$update,
		ahP: $author$project$Pages$Contacts$ContactId_String$Top$view
	});
var $author$project$Pages$Contacts$List$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$List$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$List$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Contacts$List$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Contacts'};
};
var $author$project$Pages$Contacts$List$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Contacts$List$init,
		aer: $author$project$Pages$Contacts$List$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Contacts$List$update,
		ahP: $author$project$Pages$Contacts$List$view
	});
var $author$project$Pages$Contacts$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Contacts$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Contacts$New$view = function (_v0) {
	return {e5: _List_Nil, $G: 'New Contact'};
};
var $author$project$Pages$Contacts$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Contacts$New$init,
		aer: $author$project$Pages$Contacts$New$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Contacts$New$update,
		ahP: $author$project$Pages$Contacts$New$view
	});
var $author$project$Spa$Page$application = function (page) {
	return page;
};
var $author$project$Pages$Error$Status_String$init = F2(
	function (_v0, _v1) {
		var params = _v1.Vx;
		var query = _v1.Bi;
		return _Utils_Tuple3(
			{
				aeD: A2($elm$core$Dict$get, 'message', query),
				ag7: params.ag7
			},
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$Error$Status_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Error$Status_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Error$Status_String$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Error$Status_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Error$Status_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Error '),
						$elm$html$Html$text(model.ag7)
					])),
				function () {
				var _v0 = model.aeD;
				if (!_v0.$) {
					var message = _v0.a;
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				function () {
					var _v1 = model.ag7;
					switch (_v1) {
						case '401':
							return _List_fromArray(
								[
									$elm$html$Html$text('You need to login first to see that page.'),
									$elm$html$Html$text(' You can do that '),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Login,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('here')
										])),
									$elm$html$Html$text('.')
								]);
						case '403':
							return _List_fromArray(
								[
									$elm$html$Html$text('You\'re not authorized to do that. Please check your permissions and try agian.')
								]);
						case '404':
							return _List_fromArray(
								[
									$elm$html$Html$text('This page doesn\'t exist anymore. Please let us know (email '),
									A3(
									$author$project$Ui$Link$mailto,
									'support@hint.com',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('support@hint.com')
										])),
									$elm$html$Html$text(') how you got here so we can update any outdated or expired links.')
								]);
						case '418':
							return _List_fromArray(
								[
									$elm$html$Html$text('I\'m a teapot')
								]);
						case '422':
							return _List_fromArray(
								[
									$elm$html$Html$text('Your request was missing some required information or didn\'t validate properly. Please try again.')
								]);
						case '428':
							return _List_fromArray(
								[
									$elm$html$Html$text('You aren\'t able to do that until you further set up your account.')
								]);
						case '500':
							return _List_fromArray(
								[
									$elm$html$Html$text('Our servers didn\'t like that. We\'ve been notified about this error and are looking into it.')
								]);
						case '503':
							return _List_fromArray(
								[
									$elm$html$Html$text('Our servers are currently undergoing maintenance. Please try again soon.')
								]);
						default:
							return _List_fromArray(
								[
									$elm$html$Html$text('Something bad happened. Please let us know (email '),
									A3(
									$author$project$Ui$Link$mailto,
									'support@hint.com',
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('support@hint.com')
										])),
									$elm$html$Html$text(') how you did this and we\'ll take a look.')
								]);
					}
				}()),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Take me '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Top,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('home')
							])),
						$elm$html$Html$text('.')
					]))
			]),
		$G: 'Error'
	};
};
var $author$project$Pages$Error$Status_String$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$Error$Status_String$init, aer: $author$project$Pages$Error$Status_String$load, agD: $author$project$Pages$Error$Status_String$save, ahd: $author$project$Pages$Error$Status_String$subscriptions, aaq: $author$project$Pages$Error$Status_String$update, ahP: $author$project$Pages$Error$Status_String$view});
var $author$project$Pages$Files$Public$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Files$Public$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Files$Public$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Files$Public$view = function (_v0) {
	return {e5: _List_Nil, $G: 'File Drive'};
};
var $author$project$Pages$Files$Public$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Files$Public$init,
		aer: $author$project$Pages$Files$Public$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Files$Public$update,
		ahP: $author$project$Pages$Files$Public$view
	});
var $author$project$Pages$Files$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Files$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Files$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Files$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'File Drive'};
};
var $author$project$Pages$Files$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Files$Top$init,
		aer: $author$project$Pages$Files$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Files$Top$update,
		ahP: $author$project$Pages$Files$Top$view
	});
var $author$project$Pages$Forms$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Forms$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Forms$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Forms$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Forms'};
};
var $author$project$Pages$Forms$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Forms$init,
		aer: $author$project$Pages$Forms$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Forms$update,
		ahP: $author$project$Pages$Forms$view
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['admin_users_groups']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath);
};
var $author$project$Api$Platform$AdminUsersGroup$One$AdminUsersGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$AdminUsersGroup$Shared$AdminUsersGroup = $elm$core$Basics$identity;
var $author$project$Api$Platform$AdminUsersGroup$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Platform$AdminUsersGroup$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$Shared$Record)));
var $author$project$Api$Platform$AdminUsersGroup$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$AdminUsersGroup$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$AdminUsersGroup$One$Record = F2(
	function (usersCount, practicesCount) {
		return {WM: practicesCount, aaB: usersCount};
	});
var $author$project$Api$Platform$AdminUsersGroup$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practices_count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'users_count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$One$Record)));
var $author$project$Api$Platform$AdminUsersGroup$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$AdminUsersGroup$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$AdminUsersGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$One$AdminUsersGroup)));
var $author$project$Api$Platform$AdminUsersGroup$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$AdminUsersGroup$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_)));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroup = function (model) {
	return A3($author$project$Api$Platform$AdminUsersGroup$retrieve, model.D5, model.adR, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroup);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupPractices = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath = function (adminUsersGroupId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practices']),
		$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(adminUsersGroupId));
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$listDefaults = {
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$AdminUsersGroup$Practice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$list = F4(
	function (apiClient, adminUsersGroupId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Practice$Min$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$AdminUsersGroup$Practice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId))));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices = function (model) {
	return A4(
		$author$project$Api$Platform$AdminUsersGroup$Practice$list,
		model.D5,
		model.adR,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.bx, af_: model.nD, ag1: model.nE});
		},
		$author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupPractices);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupUsers = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath = function (adminUsersGroupId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['users']),
		$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(adminUsersGroupId));
};
var $author$project$Api$Platform$AdminUsersGroup$User$listDefaults = {
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'first_name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$AdminUsersGroup$User$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$AdminUsersGroup$User$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Platform$AdminUsersGroup$User$list = F4(
	function (apiClient, adminUsersGroupId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$User$Min$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$AdminUsersGroup$User$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId))));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers = function (model) {
	return A4(
		$author$project$Api$Platform$AdminUsersGroup$User$list,
		model.D5,
		model.adR,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.bG, af_: model.o7, ag1: model.o8});
		},
		$author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupUsers);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var query = _v2.Bi;
		var params = _v2.Vx;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			X: $elm$core$Maybe$Nothing,
			ax: $elm$core$Maybe$Nothing,
			bM: $author$project$Api$Data$Loading,
			ay: $elm$core$Maybe$Nothing,
			cx: $author$project$Api$Data$Loading,
			DY: $author$project$Api$Data$Loading,
			D5: apiClient,
			cQ: $elm$core$Maybe$Nothing,
			dG: $elm$core$Set$empty,
			dH: $elm$core$Set$empty,
			adR: params.adR,
			bx: $author$project$Api$Pagination$init,
			nD: q,
			sc: $author$project$Ui$SearchInput$init(q),
			nE: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
			bG: $author$project$Api$Pagination$init,
			o7: q,
			tw: $author$project$Ui$SearchInput$init(q),
			o8: A3($author$project$Api$Sort$withDefault, 'first_name', 0, $author$project$Api$Sort$init)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroup(model),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model)
					])));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice = {$: 23};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser = {$: 12};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed)),
					model.cQ)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser)),
					model.ay)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice)),
					model.ax))
			]));
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupDeleted = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeAdded = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeDeleted = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserAdded = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserDeleted = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$Practice$add = F4(
	function (apiClient, adminUsersGroupId, practiceId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(practiceId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Practice$Min$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId))));
	});
var $author$project$Api$Platform$AdminUsersGroup$User$add = F4(
	function (apiClient, adminUsersGroupId, userId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(userId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$User$Min$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId))));
	});
var $author$project$Api$Platform$AdminUsersGroup$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_)));
	});
var $author$project$Api$Platform$AdminUsersGroup$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Platform$AdminUsersGroup$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$AdminUsersGroup$Shared$name(shared);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup = function (adminUsersGroup) {
	return $author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsUpdate = F2(
	function (field, _v0) {
		var name = field;
		return name;
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$NameValidation = 0;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Api$Platform$AdminUsersGroup$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Platform$AdminUsersGroup$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$AdminUsersGroup$Shared$id(shared);
};
var $author$project$Api$Platform$User$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Platform$User$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsUpdate = F2(
	function (field, _v0) {
		var practiceId = field;
		return $author$project$Utils$String$toMaybe(practiceId);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeIdValidation = 0;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a practice ID.'))
		]));
var $author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticePath = F2(
	function (adminUsersGroupId, practiceId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[practiceId]),
			$author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId));
	});
var $author$project$Api$Platform$AdminUsersGroup$Practice$remove = F4(
	function (apiClient, adminUsersGroupId, practiceId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticePath, adminUsersGroupId, practiceId)));
	});
var $author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUserPath = F2(
	function (adminUsersGroupId, userId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[userId]),
			$author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId));
	});
var $author$project$Api$Platform$AdminUsersGroup$User$remove = F4(
	function (apiClient, adminUsersGroupId, userId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUserPath, adminUsersGroupId, userId)));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$update = F4(
	function (apiClient, id_, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'admin_users_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Platform$AdminUsersGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_))));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$updateAdminUsersGroup = F3(
	function (apiClient, id, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4($author$project$Api$Platform$AdminUsersGroup$update, apiClient, id, name, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUpdated);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsUpdate = F2(
	function (field, _v0) {
		var userId = field;
		return $author$project$Utils$String$toMaybe(userId);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserIdValidation = 0;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a user ID.'))
		]));
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cQ: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var confirmed = msg.a;
				var _v1 = model.X;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var adminUsersGroup = _v2.a;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cQ: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
							}),
						A3(
							$author$project$Api$Platform$AdminUsersGroup$delete,
							model.D5,
							$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupDeleted(adminUsersGroup)),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{cQ: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var adminUsersGroup = msg.a;
				var dataAdminUsersGroup = msg.b;
				switch (dataAdminUsersGroup.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup) + ' was successfully removed.')
								]));
					case 2:
						var error = dataAdminUsersGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cQ: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(dataAdminUsersGroup)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var _v4 = model.X;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var adminUsersGroup = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var newForm = _v7.a;
						var validFormFields = _v7.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									X: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$Loading))
								}),
							A3(
								$author$project$Pages$Hinter$AdminUsersGroups$Id_String$updateAdminUsersGroup,
								model.D5,
								$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
								validFormFields),
							_List_Nil);
					} else {
						var newForm = _v6.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									X: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var adminUsersGroup = response.a;
					var form = $author$project$Utils$Form$init(
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup(adminUsersGroup));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								X: $elm$core$Maybe$Just(
									_Utils_Tuple3(adminUsersGroup, form, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{X: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var field = msg.a;
				var _v9 = model.X;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					var adminUsersGroup = _v10.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								X: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, adminUsersGroup))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var dataAdminUsersGroup = msg.a;
				var _v11 = model.X;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var adminUsersGroup = _v12.a;
					var form = _v12.b;
					if (dataAdminUsersGroup.$ === 3) {
						var newAdminUsersGroup = dataAdminUsersGroup.a;
						var newForm = $author$project$Utils$Form$init(
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup(newAdminUsersGroup));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									X: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup) + ' was successfully updated.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									X: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroup, form, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataAdminUsersGroup));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cx: response,
								bG: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.bG)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cx: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.bG);
				var newModel = _Utils_update(
					model,
					{DY: $author$project$Api$Data$Loading, bG: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(newModel),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v15 = A2($author$project$Ui$SearchInput$update, subMsg, model.tw);
				var searchInput = _v15.a;
				var searchInputCmd = _v15.b;
				var searchInputEvent = _v15.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.o7;
					}
				}();
				var _v16 = function () {
					if (_Utils_eq(q, model.o7)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								cx: $author$project$Api$Data$Loading,
								bG: $author$project$Api$Pagination$reset(model.bG),
								o7: q
							});
						return _Utils_Tuple2(
							qModel,
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(qModel));
					}
				}();
				var newModel = _v16.a;
				var cmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{tw: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 10:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						cx: $author$project$Api$Data$Loading,
						bG: $author$project$Api$Pagination$reset(model.bG),
						o8: A2($author$project$Api$Sort$update, columnId, model.o8)
					});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(newModel),
					_List_Nil);
			case 11:
				var _v18 = model.X;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var adminUsersGroup = _v19.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ay: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
										$author$project$Utils$Form$init($elm$core$Maybe$Nothing),
										$author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ay: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var field = msg.a;
				var _v20 = model.ay;
				if (!_v20.$) {
					var _v21 = _v20.a;
					var adminUsersGroupId = _v21.a;
					var form = _v21.b;
					var request = _v21.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ay: $elm$core$Maybe$Just(
									_Utils_Tuple3(adminUsersGroupId, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var _v22 = model.ay;
				if (!_v22.$) {
					var _v23 = _v22.a;
					var adminUsersGroupId = _v23.a;
					var form = _v23.b;
					var _v24 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsValidator, form);
					if (!_v24.$) {
						var _v25 = _v24.a;
						var newForm = _v25.a;
						var validFormFields = _v25.b;
						var userId = A2(
							$elm$core$Maybe$withDefault,
							'',
							$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ay: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$Loading))
								}),
							A4($author$project$Api$Platform$AdminUsersGroup$User$add, model.D5, adminUsersGroupId, userId, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserAdded),
							_List_Nil);
					} else {
						var newForm = _v24.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ay: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var response = msg.a;
				var _v26 = model.ay;
				if (!_v26.$) {
					var _v27 = _v26.a;
					var adminUsersGroupId = _v27.a;
					var form = _v27.b;
					if (response.$ === 3) {
						var user = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ay: $elm$core$Maybe$Nothing, cx: $author$project$Api$Data$Loading}),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$User$Min$name(user) + ' was successfully added.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ay: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var adminUsersGroupId = msg.a;
				var user = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cQ: $elm$core$Maybe$Nothing,
							dH: A2(
								$elm$core$Set$insert,
								$author$project$Api$Platform$User$Min$id(user),
								model.dH)
						}),
					A4(
						$author$project$Api$Platform$AdminUsersGroup$User$remove,
						model.D5,
						adminUsersGroupId,
						$author$project$Api$Platform$User$Min$id(user),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserDeleted(user)),
					_List_Nil);
			case 17:
				var user = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cx: $author$project$Api$Data$Loading,
									dH: A2(
										$elm$core$Set$remove,
										$author$project$Api$Platform$User$Min$id(user),
										model.dH)
								}),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$User$Min$name(user) + ' was successfully removed.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dH: A2(
										$elm$core$Set$remove,
										$author$project$Api$Platform$User$Min$id(user),
										model.dH)
								}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bM: response,
								bx: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.bx)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bM: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 19:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.bx);
				var newModel = _Utils_update(
					model,
					{bM: $author$project$Api$Data$Loading, bx: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(newModel),
					_List_Nil);
			case 20:
				var subMsg = msg.a;
				var _v31 = A2($author$project$Ui$SearchInput$update, subMsg, model.sc);
				var searchInput = _v31.a;
				var searchInputCmd = _v31.b;
				var searchInputEvent = _v31.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.nD;
					}
				}();
				var _v32 = function () {
					if (_Utils_eq(q, model.nD)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								bM: $author$project$Api$Data$Loading,
								bx: $author$project$Api$Pagination$reset(model.bx),
								nD: q
							});
						return _Utils_Tuple2(
							qModel,
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(qModel));
					}
				}();
				var newModel = _v32.a;
				var cmd = _v32.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sc: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 21:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bM: $author$project$Api$Data$Loading,
						bx: $author$project$Api$Pagination$reset(model.bx),
						nE: A2($author$project$Api$Sort$update, columnId, model.nE)
					});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(newModel),
					_List_Nil);
			case 22:
				var _v34 = model.X;
				if (!_v34.$) {
					var _v35 = _v34.a;
					var adminUsersGroup = _v35.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ax: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
										$author$project$Utils$Form$init($elm$core$Maybe$Nothing),
										$author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ax: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 24:
				var field = msg.a;
				var _v36 = model.ax;
				if (!_v36.$) {
					var _v37 = _v36.a;
					var adminUsersGroupId = _v37.a;
					var form = _v37.b;
					var request = _v37.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ax: $elm$core$Maybe$Just(
									_Utils_Tuple3(adminUsersGroupId, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 25:
				var _v38 = model.ax;
				if (!_v38.$) {
					var _v39 = _v38.a;
					var adminUsersGroupId = _v39.a;
					var form = _v39.b;
					var _v40 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsValidator, form);
					if (!_v40.$) {
						var _v41 = _v40.a;
						var newForm = _v41.a;
						var validFormFields = _v41.b;
						var practiceId = A2(
							$elm$core$Maybe$withDefault,
							'',
							$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ax: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$Loading))
								}),
							A4($author$project$Api$Platform$AdminUsersGroup$Practice$add, model.D5, adminUsersGroupId, practiceId, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeAdded),
							_List_Nil);
					} else {
						var newForm = _v40.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ax: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 26:
				var response = msg.a;
				var _v42 = model.ax;
				if (!_v42.$) {
					var _v43 = _v42.a;
					var adminUsersGroupId = _v43.a;
					var form = _v43.b;
					if (response.$ === 3) {
						var practice = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ax: $elm$core$Maybe$Nothing, bM: $author$project$Api$Data$Loading}),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$Practice$Min$name(practice) + ' was successfully added.')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ax: $elm$core$Maybe$Just(
										_Utils_Tuple3(adminUsersGroupId, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 27:
				var adminUsersGroupId = msg.a;
				var practice = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cQ: $elm$core$Maybe$Nothing,
							dG: A2(
								$elm$core$Set$insert,
								$author$project$Api$Platform$Practice$Min$id(practice),
								model.dG)
						}),
					A4(
						$author$project$Api$Platform$AdminUsersGroup$Practice$remove,
						model.D5,
						adminUsersGroupId,
						$author$project$Api$Platform$Practice$Min$id(practice),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeDeleted(practice)),
					_List_Nil);
			default:
				var practice = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bM: $author$project$Api$Data$Loading,
									dG: A2(
										$elm$core$Set$remove,
										$author$project$Api$Platform$Practice$Min$id(practice),
										model.dG)
								}),
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Platform$Practice$Min$name(practice) + ' was successfully removed.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dG: A2(
										$elm$core$Set$remove,
										$author$project$Api$Platform$Practice$Min$id(practice),
										model.dG)
								}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeFormUpdated = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeId = $elm$core$Basics$identity;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupPractice = {$: 25};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddPracticeModal = F2(
	function (form, request) {
		var practiceId = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Add Practice',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Nothing,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice,
			U0: $elm$core$Basics$always($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupPractice)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Practice ID'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', practiceId)),
									$author$project$Ui$Form$Input$placeholder('pra-abcdef1234567890'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeFormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupUser = {$: 14};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserFormUpdated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserId = $elm$core$Basics$identity;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddUserModal = F2(
	function (form, request) {
		var userId = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Add User',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Nothing,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser,
			U0: $elm$core$Basics$always($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupUser)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('User ID'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', userId)),
									$author$project$Ui$Form$Input$placeholder('user-abcdef1234567890'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserFormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddPractice = {$: 22};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesPaginationMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSortTable = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practicesTableColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'id', true, 'ID'),
		A3($author$project$Api$Column$init, 'name', true, 'Name')
	]);
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupPractice = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractice = F3(
	function (adminUsersGroupId, model, practice) {
		var id = $author$project$Api$Platform$Practice$Min$id(practice);
		var loading = A2($elm$core$Set$member, id, model.dG);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$Practice$Min$id(practice))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$Practice$Min$name(practice))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Remove practice from admin users group'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$size(0),
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupPractice, adminUsersGroupId, practice)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPracticesTable = F2(
	function (adminUsersGroupId, model) {
		var _v0 = function () {
			var _v1 = model.bM;
			if (_v1.$ === 3) {
				var adminUsersGroupPractices_ = _v1.a;
				return _Utils_Tuple2(false, adminUsersGroupPractices_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var adminUsersGroupPractices = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no practices in this group')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.nE, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSortTable)),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$practicesTableColumns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractice, adminUsersGroupId, model),
				adminUsersGroupPractices),
			_List_Nil);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractices = F2(
	function (adminUsersGroupId, model) {
		var loading = function () {
			var _v0 = model.bM;
			if (_v0.$ === 3) {
				return false;
			} else {
				return true;
			}
		}();
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									$elm$html$Html$text('Practices')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$pull(1)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Add practice'},
											_List_fromArray(
												[
													$author$project$Ui$Button$default,
													$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddPractice)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add Practice')
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mt2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg,
													A2($author$project$Ui$SearchInput$view, _List_Nil, model.sc))
												]))
										]))
								]))
						])),
					A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPracticesTable, adminUsersGroupId, model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesPaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.bx))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddUser = {$: 11};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersPaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSortTable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$usersTableColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'id', true, 'ID'),
		A3($author$project$Api$Column$init, 'first_name', true, 'Name'),
		A3($author$project$Api$Column$init, 'email', true, 'Email')
	]);
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupUser = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Api$Platform$User$Min$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewUser = F3(
	function (adminUsersGroupId, model, user) {
		var id = $author$project$Api$Platform$User$Min$id(user);
		var loading = A2($elm$core$Set$member, id, model.dH);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$User$Min$id(user))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$User$Min$name(user))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Platform$User$Min$email(user))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Remove user from admin users group'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$size(0),
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupUser, adminUsersGroupId, user)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsersTable = F2(
	function (adminUsersGroupId, model) {
		var _v0 = function () {
			var _v1 = model.cx;
			if (_v1.$ === 3) {
				var adminUsersGroupUsers_ = _v1.a;
				return _Utils_Tuple2(false, adminUsersGroupUsers_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var adminUsersGroupUsers = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no users in this group')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.o8, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSortTable)),
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$usersTableColumns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewUser, adminUsersGroupId, model),
				adminUsersGroupUsers),
			_List_Nil);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsers = F2(
	function (adminUsersGroupId, model) {
		var loading = function () {
			var _v0 = model.cx;
			if (_v0.$ === 3) {
				return false;
			} else {
				return true;
			}
		}();
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									$elm$html$Html$text('Users')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$pull(1)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Add user'},
											_List_fromArray(
												[
													$author$project$Ui$Button$default,
													$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddUser)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add User')
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mt2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(12)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg,
													A2($author$project$Ui$SearchInput$view, _List_Nil, model.tw))
												]))
										]))
								]))
						])),
					A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsersTable, adminUsersGroupId, model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersPaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.bG))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroup = {$: 4};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$Name = $elm$core$Basics$identity;
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroup = {$: 1};
var $author$project$Api$Platform$AdminUsersGroup$One$practicesCount = function (_v0) {
	var record = _v0.b;
	return record.WM;
};
var $author$project$Api$Platform$AdminUsersGroup$One$usersCount = function (_v0) {
	var record = _v0.b;
	return record.aaB;
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewForm = F3(
	function (adminUsersGroup, form, saveRequest) {
		var preventDelete = ($author$project$Api$Platform$AdminUsersGroup$One$usersCount(adminUsersGroup) > 0) || ($author$project$Api$Platform$AdminUsersGroup$One$practicesCount(adminUsersGroup) > 0);
		var name = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Group Name'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Update admin users group'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$loading(
									_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Delete admin users group'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$disabled(preventDelete),
									$author$project$Ui$Button$loading(
									_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroup),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroup = F4(
	function (adminUsersGroup, form, saveRequest, model) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Panel$heading,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Panel$titleWithButton,
													_List_fromArray(
														[
															$elm$html$Html$text('Admin Users Group - '),
															$elm$html$Html$text(
															$author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup))
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[
																	$author$project$Ui$Typography$pull(1)
																]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Link$route,
																	$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2($author$project$Ui$Icon$view, _List_Nil, 2)
																		]))
																]))
														]))
												])),
											A2(
											$author$project$Ui$Panel$body,
											_List_Nil,
											_List_fromArray(
												[
													A3($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewForm, adminUsersGroup, form, saveRequest),
													$author$project$Ui$HorizontalRule$view(_List_Nil)
												]))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsers,
									$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
									model)
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractices,
									$author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup),
									model)
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.cQ;
				if (!_v0.$) {
					var deleteRequest = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed,
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('admin users group'),
								$author$project$Components$HiConfirm$loading(
								_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.ay;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var form = _v2.b;
					var user = _v2.c;
					return A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddUserModal, form, user);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.ax;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var form = _v4.b;
					var practice = _v4.c;
					return A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddPracticeModal, form, practice);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.X;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var adminUsersGroup = _v6.a;
					var form = _v6.b;
					var saveRequest = _v6.c;
					return A4($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroup, adminUsersGroup, form, saveRequest, model);
				} else {
					return A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]));
				}
			}()
			]),
		$G: 'Admin | Admin Users Groups'
	};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$init, aer: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$load, agD: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$save, ahd: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$subscriptions, aaq: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$update, ahP: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$view});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$GotAdminUsersGroups = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$All$AdminUsersGroup = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$AdminUsersGroup$All$AllRecord = F2(
	function (usersCount, practicesCount) {
		return {WM: practicesCount, aaB: usersCount};
	});
var $author$project$Api$Platform$AdminUsersGroup$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practices_count',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'users_count',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$All$AllRecord)));
var $author$project$Api$Platform$AdminUsersGroup$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$AdminUsersGroup$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$AdminUsersGroup$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$All$AdminUsersGroup)));
var $author$project$Api$Platform$AdminUsersGroup$listDefaults = {
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$AdminUsersGroup$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$AdminUsersGroup$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Platform$AdminUsersGroup$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$AdminUsersGroup$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$AdminUsersGroup$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath)));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups = function (model) {
	return A3(
		$author$project$Api$Platform$AdminUsersGroup$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, af_: model.af_, ag1: model.ag1});
		},
		$author$project$Pages$Hinter$AdminUsersGroups$Top$GotAdminUsersGroups);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var query = _v2.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			X: $elm$core$Maybe$Nothing,
			DY: $author$project$Api$Data$Loading,
			D5: apiClient,
			afy: $author$project$Api$Pagination$init,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(model));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit = {$: 4};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit)),
			model.X));
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$AdminUsersGroupCreated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Platform$AdminUsersGroup$create = F3(
	function (apiClient, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'admin_users_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$AdminUsersGroup$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath)));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$createAdminUsersGroup = F2(
	function (apiClient, formFields) {
		var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3($author$project$Api$Platform$AdminUsersGroup$create, apiClient, name, $author$project$Pages$Hinter$AdminUsersGroups$Top$AdminUsersGroupCreated);
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsInit = '';
var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsUpdate = F2(
	function (field, _v0) {
		var name = field;
		return name;
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$NameValidation = 0;
var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			$elm$core$Basics$identity,
			_Utils_Tuple2(0, 'Please enter a name.'))
		]));
var $author$project$Pages$Hinter$AdminUsersGroups$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							X: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsInit),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{DY: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(newModel),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v1.a;
				var searchInputCmd = _v1.b;
				var searchInputEvent = _v1.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v2 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								DY: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(qModel));
					}
				}();
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 3:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						DY: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(newModel),
					_List_Nil);
			case 6:
				var form = msg.a;
				var id = msg.b;
				var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsValidator, form);
				if (!_v4.$) {
					var _v5 = _v4.a;
					var newForm = _v5.a;
					var validFormFields = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								X: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
							}),
						A2($author$project$Pages$Hinter$AdminUsersGroups$Top$createAdminUsersGroup, model.D5, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v4.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								X: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{X: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								DY: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{DY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var field = msg.a;
				var _v7 = model.X;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var id = _v8.a;
					var form = _v8.b;
					var adminUsersGroup = _v8.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								X: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, adminUsersGroup))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var dataAdminUsersGroup = msg.a;
				var _v9 = model.X;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (dataAdminUsersGroup.$ === 3) {
						var adminUsersGroup = dataAdminUsersGroup.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{X: $elm$core$Maybe$Nothing, DY: $author$project$Api$Data$Loading}),
							$author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									X: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, dataAdminUsersGroup))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataAdminUsersGroup));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup = {$: 0};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$FormUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$Name = $elm$core$Basics$identity;
var $author$project$Pages$Hinter$AdminUsersGroups$Top$SaveAdminUsersGroup = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroupModal = F3(
	function (id, form, adminUsersGroup) {
		var name = $author$project$Utils$Form$fields(form);
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Admin Users Group',
			S_: _Utils_eq(adminUsersGroup, $author$project$Api$Data$Loading),
			Tv: id,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit,
			U0: $author$project$Pages$Hinter$AdminUsersGroups$Top$SaveAdminUsersGroup(form)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(4),
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(name),
									$author$project$Ui$Form$Input$placeholder('Group Name'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Top$FormUpdated, $elm$core$Basics$identity)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]));
	});
var $author$project$Pages$Hinter$AdminUsersGroups$Top$SortTable = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$tableColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name'),
		A3($author$project$Api$Column$init, 'users_count', false, 'Users Count'),
		A3($author$project$Api$Column$init, 'practices_count', false, 'Practices Count')
	]);
var $author$project$Api$Platform$AdminUsersGroup$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$AdminUsersGroup$Shared$id(shared);
};
var $author$project$Api$Platform$AdminUsersGroup$All$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$AdminUsersGroup$Shared$name(shared);
};
var $author$project$Api$Platform$AdminUsersGroup$All$practicesCount = function (_v0) {
	var record = _v0.b;
	return record.WM;
};
var $author$project$Api$Platform$AdminUsersGroup$All$usersCount = function (_v0) {
	var record = _v0.b;
	return record.aaB;
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroup = function (adminUsersGroup) {
	var id = $author$project$Api$Platform$AdminUsersGroup$All$id(adminUsersGroup);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String(
							{adR: id}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Platform$AdminUsersGroup$All$name(adminUsersGroup))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Platform$AdminUsersGroup$All$usersCount(adminUsersGroup)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Platform$AdminUsersGroup$All$practicesCount(adminUsersGroup)))
					]))
			]));
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.DY;
		if (_v1.$ === 3) {
			var adminUsersGroups_ = _v1.a;
			return _Utils_Tuple2(false, adminUsersGroups_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var adminUsersGroups = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no Admin Users Groups.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						function () {
						var label = 'Add a Admin Users Group here';
						return A3(
							$author$project$Ui$Button$view,
							{abp: label},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					}()
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view(
				A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Hinter$AdminUsersGroups$Top$SortTable)),
			$author$project$Pages$Hinter$AdminUsersGroups$Top$tableColumns),
		A2($elm$core$List$map, $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroup, adminUsersGroups),
		_List_Nil);
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.X;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var id = _v1.a;
					var form = _v1.b;
					var adminUsersGroup = _v1.c;
					return A3($author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroupModal, id, form, adminUsersGroup);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										$elm$html$Html$text('Admin Users Groups')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$pull(1)
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Add new admin users group'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('New Admin Users Group')
													])),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$User__Organizations__Top,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$Ui$Icon$view, _List_Nil, 2)
													]))
											]))
									])),
								A2(
								$elm$html$Html$em,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Lets you assign multiple users to multiple practices')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$mt2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg,
														A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
													]))
											]))
									]))
							])),
						$author$project$Pages$Hinter$AdminUsersGroups$Top$viewPanelBody(model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Hinter$AdminUsersGroups$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.DY))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Admin Users Groups'
	};
};
var $author$project$Pages$Hinter$AdminUsersGroups$Top$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Hinter$AdminUsersGroups$Top$init, aer: $author$project$Pages$Hinter$AdminUsersGroups$Top$load, agD: $author$project$Pages$Hinter$AdminUsersGroups$Top$save, ahd: $author$project$Pages$Hinter$AdminUsersGroups$Top$subscriptions, aaq: $author$project$Pages$Hinter$AdminUsersGroups$Top$update, ahP: $author$project$Pages$Hinter$AdminUsersGroups$Top$view});
var $author$project$Pages$Hinter$ClonePractice$GotPracticeUsers = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$fetchTeamMembers = function (apiClient) {
	return A3(
		$author$project$Api$Provider$TeamMember$list,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{
					afy: A2($author$project$Api$Pagination$withItemsPerPage, 50, $author$project$Api$Pagination$init),
					ag1: A3($author$project$Api$Sort$withDefault, 'role', 0, $author$project$Api$Sort$init)
				});
		},
		$author$project$Pages$Hinter$ClonePractice$GotPracticeUsers);
};
var $author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Hinter$ClonePractice$initFormFields = function (practice) {
	var _v0 = $author$project$Components$DateInput$init;
	var launchDateDateInput = _v0.a;
	var launchDateDateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			ab3: false,
			ab4: false,
			ab5: false,
			ab6: false,
			acu: true,
			Oo: $author$project$Api$Provider$Practice$One$email(practice),
			Fo: practice,
			QA: $elm$core$Maybe$Nothing,
			SG: $elm$core$Maybe$Nothing,
			rb: launchDateDateInput,
			zh: '',
			U5: false,
			afR: _List_Nil
		},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg(launchDateDateInput),
			launchDateDateInputCmd));
};
var $author$project$Pages$Hinter$ClonePractice$init = F4(
	function (_v0, practice, shared, _v1) {
		var _v2 = $author$project$Pages$Hinter$ClonePractice$initFormFields(practice);
		var formFields = _v2.a;
		var formFieldsCmd = _v2.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				cO: shared.cO,
				PB: $author$project$Utils$Form$init(formFields),
				afR: $author$project$Api$Data$Loading,
				jY: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						$author$project$Pages$Hinter$ClonePractice$fetchTeamMembers(shared.D5)
					])));
	});
var $author$project$Pages$Hinter$ClonePractice$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cO: shared.cO}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$ClonePractice$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$ClonePractice$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Hinter$ClonePractice$LaunchDate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Hinter$ClonePractice$PracticeCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Practice$clone = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(fields.zh)),
								_Utils_Tuple2(
								'launch_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.SG)),
								_Utils_Tuple2(
								'onboarded',
								$elm$json$Json$Encode$bool(fields.U5)),
								_Utils_Tuple2(
								'practice_users',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.afR)),
								_Utils_Tuple2(
								'hubspot_deal_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.QA)),
								_Utils_Tuple2(
								'clone_embedded_reports',
								$elm$json$Json$Encode$bool(fields.ab4)),
								_Utils_Tuple2(
								'deal_reporting_only',
								$elm$json$Json$Encode$bool(fields.acu)),
								_Utils_Tuple2(
								'clone_lead_sources',
								$elm$json$Json$Encode$bool(fields.ab6)),
								_Utils_Tuple2(
								'clone_coupons',
								$elm$json$Json$Encode$bool(fields.ab3)),
								_Utils_Tuple2(
								'clone_feature_flags',
								$elm$json$Json$Encode$bool(fields.ab5)),
								_Utils_Tuple2(
								'email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oo))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['clone']),
						$author$project$Api$Provider$Practice$practicePath))));
	});
var $author$project$Pages$Hinter$ClonePractice$practiceFormFields = function (fields) {
	return {
		ab3: fields.ab3,
		ab4: fields.ab4,
		ab5: fields.ab5,
		ab6: fields.ab6,
		acu: fields.acu,
		Oo: fields.Oo,
		QA: fields.QA,
		SG: fields.SG,
		zh: fields.zh,
		U5: fields.U5,
		afR: A2(
			$elm$core$List$map,
			function (pu) {
				return pu.adR;
			},
			A2(
				$elm$core$List$filter,
				function (pu) {
					return pu.hL;
				},
				fields.afR))
	};
};
var $author$project$Pages$Hinter$ClonePractice$clonePractice = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$clone,
			apiClient,
			$author$project$Pages$Hinter$ClonePractice$practiceFormFields(fields),
			$author$project$Pages$Hinter$ClonePractice$PracticeCreated);
	});
var $author$project$Pages$Hinter$ClonePractice$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 1:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{SG: date, rb: dateInput});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{U5: bool});
			case 3:
				var practiceUserId = field.a;
				var checked = field.b;
				return _Utils_update(
					fields,
					{
						afR: A3(
							$elm_community$list_extra$List$Extra$updateIf,
							function (practiceUserField) {
								return _Utils_eq(practiceUserField.adR, practiceUserId);
							},
							function (practiceUserField) {
								return _Utils_update(
									practiceUserField,
									{hL: checked});
							},
							fields.afR)
					});
			case 4:
				return _Utils_update(
					fields,
					{
						afR: A2(
							$elm$core$List$map,
							function (practiceUserField) {
								return _Utils_update(
									practiceUserField,
									{hL: true});
							},
							fields.afR)
					});
			case 5:
				return _Utils_update(
					fields,
					{
						afR: A2(
							$elm$core$List$map,
							function (practiceUserField) {
								return _Utils_update(
									practiceUserField,
									{hL: false});
							},
							fields.afR)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						QA: $author$project$Utils$String$toMaybe(string)
					});
			case 7:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ab4: bool});
			case 8:
				var bool = field.a;
				return _Utils_update(
					fields,
					{acu: bool});
			case 9:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Oo: $author$project$Utils$String$toMaybe(string)
					});
			case 10:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ab6: bool});
			case 11:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ab3: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ab5: bool});
		}
	});
var $author$project$Pages$Hinter$ClonePractice$EmailValidation = 2;
var $author$project$Pages$Hinter$ClonePractice$NameValidation = 0;
var $author$project$Pages$Hinter$ClonePractice$LaunchDateValidation = 1;
var $author$project$Pages$Hinter$ClonePractice$validateLaunchDate = F2(
	function (currentDate, fields) {
		var invalid = _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a date greater or equal than today')
			]);
		var _v0 = fields.SG;
		if (!_v0.$) {
			var launchDate = _v0.a;
			return (A2($justinmimbs$date$Date$compare, currentDate, launchDate) !== 2) ? _List_Nil : invalid;
		} else {
			return invalid;
		}
	});
var $author$project$Pages$Hinter$ClonePractice$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.zh;
				},
				_Utils_Tuple2(0, 'Please enter a name.')),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Hinter$ClonePractice$validateLaunchDate(currentDate)),
				A3(
				$author$project$Utils$Validate$ifInvalidEmail,
				{abh: true},
				function ($) {
					return $.Oo;
				},
				_Utils_Tuple2(2, 'Please enter a valid email.'))
			]));
};
var $author$project$Pages$Hinter$ClonePractice$initPracticeUserField = function (practiceUser) {
	return {
		hL: false,
		Oo: $author$project$Api$Provider$PracticeUser$All$email(practiceUser),
		adR: $author$project$Api$Provider$PracticeUser$All$id(practiceUser),
		agy: $author$project$Api$Provider$PracticeUser$All$role(practiceUser)
	};
};
var $author$project$Pages$Hinter$ClonePractice$formFieldsWithUsers = F2(
	function (users, formFields) {
		return _Utils_update(
			formFields,
			{
				afR: A2($elm$core$List$map, $author$project$Pages$Hinter$ClonePractice$initPracticeUserField, users)
			});
	});
var $author$project$Pages$Hinter$ClonePractice$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$ClonePractice$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$ClonePractice$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			_List_Nil);
	});
var $author$project$Pages$Hinter$ClonePractice$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$ClonePractice$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$Hinter$ClonePractice$formFieldsValidator(model.cO),
					model.PB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var validatedForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Hinter$ClonePractice$clonePractice, model.D5, validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var _v4 = _Utils_Tuple2(
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$OutMsg$SwitchToOrganization,
								$author$project$Api$Provider$Practice$One$organizationId(practice),
								$elm$core$Maybe$Nothing,
								$author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Admin__Billing))
							]));
					var cmd = _v4.a;
					var outMsgs = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						cmd,
						_Utils_ap(
							outMsgs,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Practice cloned'),
									$author$project$OutMsg$PracticeUpdated(response)
								])));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Pages$Hinter$ClonePractice$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg,
					$author$project$Pages$Hinter$ClonePractice$LaunchDate,
					function ($) {
						return $.SG;
					});
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practiceUsers = response.a;
					var fields = $author$project$Utils$Form$fields(model.PB);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $author$project$Utils$Form$init(
									A2($author$project$Pages$Hinter$ClonePractice$formFieldsWithUsers, practiceUsers, fields)),
								afR: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{afR: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Hinter$ClonePractice$Save = {$: 1};
var $author$project$Pages$Hinter$ClonePractice$CloneCoupons = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$CloneEmbeddedReports = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$CloneFeatureFlags = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$CloneLeadSources = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$DealReportingOnly = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$Email = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$HubspotDealId = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$Onboarded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$ClonePractice$PracticeUserChecked = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Hinter$ClonePractice$viewPracticeUser = function (practiceUserField) {
	return A2(
		$author$project$Ui$Form$Checkbox$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Checkbox$value(practiceUserField.hL),
				$author$project$Ui$Form$Checkbox$onCheck(
				A2(
					$elm$core$Basics$composeL,
					$author$project$Pages$Hinter$ClonePractice$FormUpdated,
					$author$project$Pages$Hinter$ClonePractice$PracticeUserChecked(practiceUserField.adR)))
			]),
		_List_fromArray(
			[
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text(practiceUserField.Oo + (' (' + (practiceUserField.agy + ')')))
			]));
};
var $author$project$Pages$Hinter$ClonePractice$PracticeUserAllChecked = {$: 4};
var $author$project$Pages$Hinter$ClonePractice$PracticeUserAllUnChecked = {$: 5};
var $author$project$Pages$Hinter$ClonePractice$viewSelectAllButton = A2(
	$author$project$Ui$Typography$div,
	_List_fromArray(
		[
			$author$project$Ui$Typography$attrs(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('pt-1.5')
				]))
		]),
	_List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Select all'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Hinter$ClonePractice$FormUpdated($author$project$Pages$Hinter$ClonePractice$PracticeUserAllChecked))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Select All')
				])),
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(' | ')
				])),
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Unselect all'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Hinter$ClonePractice$FormUpdated($author$project$Pages$Hinter$ClonePractice$PracticeUserAllUnChecked))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Unselect All')
				]))
		]));
var $author$project$Pages$Hinter$ClonePractice$viewUsers = F2(
	function (practiceUsersData, practiceUserFields) {
		if (practiceUsersData.$ === 3) {
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Practice Users')
					]),
				$elm$core$List$isEmpty(practiceUserFields) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$padding(6)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No users to clone')
							]))
					]) : A2(
					$elm$core$List$cons,
					$author$project$Pages$Hinter$ClonePractice$viewSelectAllButton,
					A2($elm$core$List$map, $author$project$Pages$Hinter$ClonePractice$viewPracticeUser, practiceUserFields)));
		} else {
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton('Practice Users'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpanMd(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$input(_List_Nil)
					]));
		}
	});
var $author$project$Pages$Hinter$ClonePractice$viewForm = F2(
	function (form, practiceUsers) {
		var fields = $author$project$Utils$Form$fields(form);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Cloning from')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Practice$One$name(fields.Fo))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Don\'t Require Payment Method')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.U5),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$Onboarded))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Clone Embedded Reports')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.ab4),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneEmbeddedReports))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Clone Lead Sources')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.ab6),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneLeadSources))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Clone Coupons')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.ab3),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneCoupons))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Clone Feature Flags')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.ab5),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneFeatureFlags))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Business Name'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.zh),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Business Email')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', fields.Oo)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$Email)),
								$author$project$Ui$Form$Input$phi(true),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Hubspot Deal ID')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(
								A2($elm$core$Maybe$withDefault, '', fields.QA)),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$HubspotDealId))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('If Hubspot Deal ID is not provided then pricing will by cloned from the Practice.')
							])),
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(fields.acu),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$DealReportingOnly))
							]),
						_List_fromArray(
							[
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('Deal ID is used for reporting only. Clone the pricing, do not import anything from Hubspot')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Launch Date'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg(fields.rb),
						A2(
							$author$project$Components$DateInput$view,
							_List_fromArray(
								[
									$author$project$Components$DateInput$value(fields.SG),
									$author$project$Components$DateInput$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Components$DateInput$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]),
							fields.rb))
					])),
				A2($author$project$Pages$Hinter$ClonePractice$viewUsers, practiceUsers, fields.afR)
			]);
	});
var $author$project$Pages$Hinter$ClonePractice$view = function (model) {
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$ClonePractice$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Clone Practice')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								A2($author$project$Pages$Hinter$ClonePractice$viewForm, model.PB, model.afR)),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Create practice'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		$G: 'Clone Practice'
	};
};
var $author$project$Pages$Hinter$ClonePractice$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Hinter$ClonePractice$init, aer: $author$project$Pages$Hinter$ClonePractice$load, agD: $author$project$Pages$Hinter$ClonePractice$save, ahd: $author$project$Pages$Hinter$ClonePractice$subscriptions, aaq: $author$project$Pages$Hinter$ClonePractice$update, ahP: $author$project$Pages$Hinter$ClonePractice$view});
var $author$project$Pages$Hinter$Disputes$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Hinter$Disputes$GotDisputes = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$Dispute$All$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Platform$Dispute$All$Record = F8(
	function (id, dueDate, amountInCents, status, reasonCode, reasonDescription, invoice, practice) {
		return {I2: amountInCents, N1: dueDate, adR: id, Rh: invoice, WF: practice, XQ: reasonCode, XR: reasonDescription, ag7: status};
	});
var $author$project$Api$Platform$Dispute$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Platform$Practice$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invoice',
		$author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reason_description',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'reason_code',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'due_date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$All$Record)))))))));
var $author$project$Api$Platform$Dispute$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Dispute$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Dispute$disputesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['disputes']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Dispute$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Platform$Dispute$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$Dispute$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Param$string('status'),
						$elm$core$List$singleton),
					options.ag7))
			]));
};
var $author$project$Api$Platform$Dispute$list = F3(
	function (apiClient, query, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Dispute$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$Dispute$listOptionsToParams(query),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$Dispute$disputesPath)));
	});
var $author$project$Pages$Hinter$Disputes$fetchDisputes = function (model) {
	return A3(
		$author$project$Api$Platform$Dispute$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, ag1: model.ag1, ag7: model.ag7});
		},
		$author$project$Pages$Hinter$Disputes$GotDisputes);
};
var $author$project$Pages$Hinter$Disputes$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var query = _v2.Bi;
		var model = {
			D5: apiClient,
			fw: $elm$core$Maybe$Nothing,
			b2: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$init,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'due_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			ag7: A2($elm$core$Dict$get, 'status', query),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'disputes-status-dropdown', ahx: $author$project$Pages$Hinter$Disputes$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Hinter$Disputes$fetchDisputes(model));
	});
var $author$project$Pages$Hinter$Disputes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$Disputes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$Disputes$CloseDisputeModal = {$: 5};
var $author$project$Pages$Hinter$Disputes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$DisputeModal$subscriptions($author$project$Pages$Hinter$Disputes$CloseDisputeModal)),
					model.fw)),
				$author$project$Ui$NewDropdown$subscriptions(model.oA)
			]));
};
var $author$project$Pages$Hinter$Disputes$DisputeModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Platform$Dispute$All$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Pages$Hinter$Disputes$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.ag7)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__Disputes)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Hinter$Disputes$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b2: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b2: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var statusDropdown = _v2.a;
				var statusDropdownCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 2:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						b2: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						ag7: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var status = selectedOption.a;
								return $elm$core$Maybe$Just(status);
							}
						}()
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
								$author$project$Pages$Hinter$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
								$author$project$Pages$Hinter$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 7:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
								$author$project$Pages$Hinter$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var dispute = msg.a;
				var _v4 = A3(
					$author$project$Components$DisputeModal$init,
					$author$project$Api$Data$platformPath,
					model.D5,
					$author$project$Api$Platform$Dispute$All$id(dispute));
				var disputeModal = _v4.a;
				var disputeModalCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fw: $elm$core$Maybe$Just(disputeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$Disputes$DisputeModalMsg, disputeModalCmd),
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fw: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v5 = model.fw;
				if (!_v5.$) {
					var disputeModal = _v5.a;
					var _v6 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
					var newDisputeModal = _v6.a;
					var disputeModalCmd = _v6.b;
					var disputeModalOutMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fw: $elm$core$Maybe$Just(newDisputeModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$Disputes$DisputeModalMsg, disputeModalCmd),
						disputeModalOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Hinter$Disputes$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$Disputes$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Hinter$Disputes$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'practice', false, 'Practice'),
		A3($author$project$Api$Column$init, 'due_date', true, 'Due Date'),
		A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
		A3($author$project$Api$Column$init, 'reason_code', true, 'Reason Code'),
		A3($author$project$Api$Column$init, 'status', true, 'Status')
	]);
var $author$project$Pages$Hinter$Disputes$OpenDisputeModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Platform$Dispute$All$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Platform$Dispute$All$dueDate = function (_v0) {
	var record = _v0;
	return record.N1;
};
var $author$project$Api$Platform$Dispute$All$invoice = function (_v0) {
	var record = _v0;
	return record.Rh;
};
var $author$project$Api$Platform$Dispute$All$practice = function (_v0) {
	var record = _v0;
	return record.WF;
};
var $author$project$Api$Platform$Dispute$All$reasonCode = function (_v0) {
	var record = _v0;
	return record.XQ;
};
var $author$project$Api$Platform$Dispute$All$reasonDescription = function (_v0) {
	var record = _v0;
	return record.XR;
};
var $author$project$Api$Platform$Dispute$All$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Pages$Hinter$Disputes$viewItem = function (dispute) {
	var invoice = $author$project$Api$Platform$Dispute$All$invoice(dispute);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Platform$Practice$Min$name(
							$author$project$Api$Platform$Dispute$All$practice(dispute)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Formatters$Date$toString,
							$author$project$Formatters$Date$Full,
							$author$project$Api$Platform$Dispute$All$dueDate(dispute)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'#' + $elm$core$String$fromInt(
							$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Platform$Dispute$All$amountInCents(dispute)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = $author$project$Api$Platform$Dispute$All$reasonDescription(dispute);
						if (!_v0.$) {
							var reasonDescription = _v0.a;
							return A3(
								$author$project$Ui$Tooltip$view,
								_List_fromArray(
									[
										$author$project$Ui$Tooltip$placement(0)
									]),
								reasonDescription,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Badge$fromString,
										_List_Nil,
										$author$project$Api$Platform$Dispute$All$reasonCode(dispute))
									]));
						} else {
							return A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Platform$Dispute$All$reasonCode(dispute));
						}
					}()
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						$author$project$Api$Platform$Dispute$All$status(dispute))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[
						$author$project$Ui$Table$textRight,
						$author$project$Ui$Table$colspan(2)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'View dispute'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Hinter$Disputes$OpenDisputeModal(dispute))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('View Dispute')
							]))
					]))
			]));
};
var $author$project$Pages$Hinter$Disputes$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.b2;
		if (_v1.$ === 3) {
			var disputes_ = _v1.a;
			return _Utils_Tuple2(false, disputes_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var disputes = _v0.b;
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no disputes.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Hinter$Disputes$SortTable)),
						$author$project$Pages$Hinter$Disputes$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2($elm$core$List$map, $author$project$Pages$Hinter$Disputes$viewItem, disputes),
			_List_Nil)
		]);
};
var $author$project$Pages$Hinter$Disputes$None = {$: 1};
var $author$project$Pages$Hinter$Disputes$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$Disputes$StatusFiltered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$Disputes$statusDropdownOptions = function (currentStatus) {
	var statusOptions = A2(
		$elm$core$List$map,
		function (status) {
			return A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Pages$Hinter$Disputes$StatusFiltered(
							$author$project$Pages$Hinter$Disputes$Status(status))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(status),
							currentStatus))
					]),
				$elm$html$Html$text(
					$author$project$Formatters$String$humanize(status)));
		},
		_List_fromArray(
			['created', 'action_required', 'processing', 'won', 'lost']));
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Hinter$Disputes$StatusFiltered($author$project$Pages$Hinter$Disputes$None)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$NewDropdown$separator, statusOptions));
};
var $author$project$Pages$Hinter$Disputes$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Status',
					A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, model.ag7)))
			]),
		$author$project$Pages$Hinter$Disputes$statusDropdownOptions(model.ag7),
		model.oA);
};
var $author$project$Pages$Hinter$Disputes$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$DisputeModal$view($author$project$Pages$Hinter$Disputes$CloseDisputeModal),
					model.fw)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Disputes')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(5),
												$author$project$Ui$FlexGrid$spanSm(3),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Hinter$Disputes$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Hinter$Disputes$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Hinter$Disputes$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.b2))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Manage Disputes'
	};
};
var $author$project$Pages$Hinter$Disputes$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Hinter$Disputes$init, aer: $author$project$Pages$Hinter$Disputes$load, agD: $author$project$Pages$Hinter$Disputes$save, ahd: $author$project$Pages$Hinter$Disputes$subscriptions, aaq: $author$project$Pages$Hinter$Disputes$update, ahP: $author$project$Pages$Hinter$Disputes$view});
var $author$project$Pages$Hinter$FeatureFlags$GotFeatureFlags = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Platform$BulkFeature$bulkFeaturesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['bulk_features']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$BulkFeature$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$BulkFeature$bulkFeaturesPath));
	});
var $author$project$Pages$Hinter$FeatureFlags$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var model = {
			eS: $elm$core$Maybe$Nothing,
			D5: apiClient,
			qE: $author$project$Api$Data$Loading,
			sA: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
			sB: ''
		};
		return _Utils_Tuple2(
			model,
			A2($author$project$Api$Platform$BulkFeature$list, apiClient, $author$project$Pages$Hinter$FeatureFlags$GotFeatureFlags));
	});
var $author$project$Pages$Hinter$FeatureFlags$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$FeatureFlags$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$FeatureFlags$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Hinter$FeatureFlags$ActionCompleted = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Pages$Hinter$FeatureFlags$DisableAll = 2;
var $author$project$Pages$Hinter$FeatureFlags$EnableAll = 1;
var $author$project$Pages$Hinter$FeatureFlags$EnableClinical = 0;
var $author$project$Pages$Hinter$FeatureFlags$SearchInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Hinter$FeatureFlags$actionLabel = function (actionType) {
	switch (actionType) {
		case 0:
			return 'Enable Clinical';
		case 1:
			return 'Enable All';
		default:
			return 'Disable All';
	}
};
var $author$project$Api$Platform$BulkFeature$bulkFeaturePath = function (featureName) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[featureName]),
		$author$project$Api$Platform$BulkFeature$bulkFeaturesPath);
};
var $author$project$Api$Platform$BulkFeature$disableAll = F3(
	function (apiClient, featureName, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['disable_all']),
					$author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
	});
var $author$project$Api$Platform$BulkFeature$enableAll = F3(
	function (apiClient, featureName, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['enable_all']),
					$author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
	});
var $author$project$Api$Platform$BulkFeature$enableClinical = F3(
	function (apiClient, featureName, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['enable_clinical']),
					$author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
	});
var $author$project$Pages$Hinter$FeatureFlags$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qE: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qE: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				var searchQuery = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return A2($elm$core$Maybe$withDefault, '', query);
					} else {
						return model.sB;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sA: searchInput, sB: searchQuery}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$FeatureFlags$SearchInputMsg, searchInputCmd),
					_List_Nil);
			case 2:
				var featureName = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eS: $elm$core$Maybe$Just(
								_Utils_Tuple2(featureName, 0))
						}),
					A3(
						$author$project$Api$Platform$BulkFeature$enableClinical,
						model.D5,
						featureName,
						A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 0)),
					_List_Nil);
			case 3:
				var featureName = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eS: $elm$core$Maybe$Just(
								_Utils_Tuple2(featureName, 1))
						}),
					A3(
						$author$project$Api$Platform$BulkFeature$enableAll,
						model.D5,
						featureName,
						A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 1)),
					_List_Nil);
			case 4:
				var featureName = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							eS: $elm$core$Maybe$Just(
								_Utils_Tuple2(featureName, 2))
						}),
					A3(
						$author$project$Api$Platform$BulkFeature$disableAll,
						model.D5,
						featureName,
						A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 2)),
					_List_Nil);
			default:
				var featureName = msg.a;
				var actionType = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eS: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Pages$Hinter$FeatureFlags$actionLabel(actionType) + (' job enqueued for ' + featureName))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eS: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Ui$SearchInput$Immediate = {$: 5};
var $author$project$Ui$SearchInput$immediate = $author$project$Ui$SearchInput$Immediate;
var $author$project$Pages$Hinter$FeatureFlags$ClickDisableAll = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Hinter$FeatureFlags$ClickEnableAll = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$FeatureFlags$ClickEnableClinical = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$FeatureFlags$viewFeatureFlag = F2(
	function (actionInProgress, featureName) {
		var isLoading = function (actionType) {
			if (!actionInProgress.$) {
				var _v1 = actionInProgress.a;
				var name = _v1.a;
				var at = _v1.b;
				return _Utils_eq(name, featureName) && _Utils_eq(at, actionType);
			} else {
				return false;
			}
		};
		var anyLoading = !_Utils_eq(actionInProgress, $elm$core$Maybe$Nothing);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(featureName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Enable ' + (featureName + ' for clinical practices')},
							_List_fromArray(
								[
									$author$project$Ui$Button$success,
									$author$project$Ui$Button$size(0),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Hinter$FeatureFlags$ClickEnableClinical(featureName)),
									$author$project$Ui$Button$loading(
									isLoading(0)),
									$author$project$Ui$Button$disabled(anyLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clinical')
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Enable ' + (featureName + ' for all practices')},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$size(0),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Hinter$FeatureFlags$ClickEnableAll(featureName)),
									$author$project$Ui$Button$loading(
									isLoading(1)),
									$author$project$Ui$Button$disabled(anyLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('All')
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Disable ' + (featureName + ' for all practices')},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$size(0),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Hinter$FeatureFlags$ClickDisableAll(featureName)),
									$author$project$Ui$Button$loading(
									isLoading(2)),
									$author$project$Ui$Button$disabled(anyLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Disable')
								]))
						]))
				]));
	});
var $author$project$Pages$Hinter$FeatureFlags$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.qE;
		if (_v1.$ === 3) {
			var flags_ = _v1.a;
			return _Utils_Tuple2(false, flags_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var flags = _v0.b;
	var filteredFlags = $elm$core$String$isEmpty(model.sB) ? flags : A2(
		$elm$core$List$filter,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$String$contains(
				$elm$core$String$toLower(model.sB)),
			$elm$core$String$toLower),
		flags);
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$verticalCentered,
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No feature flags found.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Flag Name')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Enable Clinical')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Enable All')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Disable All')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Hinter$FeatureFlags$viewFeatureFlag(model.eS),
			filteredFlags),
		_List_Nil);
};
var $author$project$Pages$Hinter$FeatureFlags$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										$elm$html$Html$text('Feature Flags')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$User__Organizations__Top,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 2)
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$mt2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(12)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Hinter$FeatureFlags$SearchInputMsg,
														A2(
															$author$project$Ui$SearchInput$view,
															_List_fromArray(
																[
																	$author$project$Ui$SearchInput$placeholder('Search feature flags...'),
																	$author$project$Ui$SearchInput$immediate
																]),
															model.sA))
													]))
											]))
									]))
							])),
						$author$project$Pages$Hinter$FeatureFlags$viewPanelBody(model)
					]))
			]),
		$G: 'Admin | Feature Flags'
	};
};
var $author$project$Pages$Hinter$FeatureFlags$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Hinter$FeatureFlags$init, aer: $author$project$Pages$Hinter$FeatureFlags$load, agD: $author$project$Pages$Hinter$FeatureFlags$save, ahd: $author$project$Pages$Hinter$FeatureFlags$subscriptions, aaq: $author$project$Pages$Hinter$FeatureFlags$update, ahP: $author$project$Pages$Hinter$FeatureFlags$view});
var $author$project$Pages$Hinter$NewGroup$init = F3(
	function (_v0, shared, _v1) {
		return _Utils_Tuple2(
			{D5: shared.D5, zh: '', m7: $elm$core$Maybe$Nothing, jY: $author$project$Api$Data$NotAsked},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$NewGroup$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$NewGroup$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$NewGroup$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Hinter$NewGroup$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$ManagementGroup$create = F3(
	function (apiClient, name_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'management_group',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ManagementGroup$Shared$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath)));
	});
var $author$project$Pages$Hinter$NewGroup$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var name = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{zh: name, m7: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var trimmedName = $elm$core$String$trim(model.zh);
				return $elm$core$String$isEmpty(trimmedName) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							m7: $elm$core$Maybe$Just('Name is required')
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Provider$ManagementGroup$create, model.D5, trimmedName, $author$project$Pages$Hinter$NewGroup$Created),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var group = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Organizations__Top),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'Group \"' + ($author$project$Api$Provider$ManagementGroup$Shared$name(group) + '\" created'))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Hinter$NewGroup$Save = {$: 1};
var $author$project$Pages$Hinter$NewGroup$UpdateName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$NewGroup$view = function (model) {
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewGroup$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Create New Group')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Name'),
												$author$project$Ui$Form$Group$required(true)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(model.zh),
														$author$project$Ui$Form$Input$onInput($author$project$Pages$Hinter$NewGroup$UpdateName),
														$author$project$Ui$Form$Input$placeholder('Enter group name'),
														$author$project$Ui$Form$Input$disabled(loading),
														$author$project$Ui$Form$Input$invalid(
														!_Utils_eq(model.m7, $elm$core$Maybe$Nothing)),
														$author$project$Ui$Form$Input$errors(
														A2(
															$elm$core$Maybe$withDefault,
															_List_Nil,
															A2($elm$core$Maybe$map, $elm$core$List$singleton, model.m7)))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$User__Organizations__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Create new group'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		$G: 'Group Setup'
	};
};
var $author$project$Pages$Hinter$NewGroup$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Hinter$NewGroup$init, aer: $author$project$Pages$Hinter$NewGroup$load, agD: $author$project$Pages$Hinter$NewGroup$save, ahd: $author$project$Pages$Hinter$NewGroup$subscriptions, aaq: $author$project$Pages$Hinter$NewGroup$update, ahP: $author$project$Pages$Hinter$NewGroup$view});
var $author$project$Pages$Hinter$NewPartner$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$NewPartnerForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Hinter$NewPartnerForm$FormUpdated = $elm$core$Basics$identity;
var $author$project$Components$Hinter$NewPartnerForm$ManagedBy = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeManagementGroup = 2;
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypePractice = 1;
var $author$project$Components$Partner$AdminSettings$ManagedByInput$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$User$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$User$Practice$list = $author$project$Api$Platform$User$Practice$list;
var $author$project$Components$ResourceFilter$User$Practice$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$User$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			$elm$core$Maybe$Nothing,
			toMsg);
	});
var $author$project$Components$ResourceFilter$User$Practice$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$User$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						af_: $elm$core$Maybe$Just(id)
					});
			},
			$elm$core$Maybe$Nothing,
			toMsg);
	});
var $author$project$Components$ResourceFilter$User$Practice$selectId = 'practices';
var $author$project$Components$ResourceFilter$User$Practice$toTitle = $author$project$Api$Platform$Practice$All$name;
var $author$project$Components$ResourceFilter$User$Practice$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$User$Practice$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$User$Practice$toValue = $author$project$Api$Platform$Practice$All$id;
var $author$project$Components$ResourceFilter$User$Practice$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$User$Practice$fetchResources, adR: $author$project$Components$ResourceFilter$User$Practice$selectId, gx: 'Practices', st: $author$project$Components$ResourceFilter$User$Practice$retrieveResource, ahw: $author$project$Components$ResourceFilter$User$Practice$toLabel, ahA: $author$project$Components$ResourceFilter$User$Practice$toTitle, g0: $author$project$Components$ResourceFilter$User$Practice$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$init = F2(
	function (apiClient, maybeInitialValue) {
		var managedByType = function () {
			if (maybeInitialValue.$ === 1) {
				return 0;
			} else {
				if (!maybeInitialValue.a.$) {
					return 1;
				} else {
					return 2;
				}
			}
		}();
		var _v0 = A2(
			$author$project$Components$ResourceFilter$User$Practice$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Practice'});
			});
		var practiceResourceFilter = _v0.a;
		var practiceResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{f1: managedByType, jA: practiceResourceFilter},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg, practiceResourceFilterCmd));
	});
var $author$project$Components$Hinter$NewPartnerForm$initFormFields = function (apiClient) {
	var _v0 = A2($author$project$Components$Partner$AdminSettings$ManagedByInput$init, apiClient, $elm$core$Maybe$Nothing);
	var managedByInput = _v0.a;
	var managedByInputCmd = _v0.b;
	return _Utils_Tuple2(
		{Ic: false, Jy: 'manual', Mu: $elm$core$Maybe$Nothing, Oo: $elm$core$Maybe$Nothing, Q5: $elm$core$Maybe$Nothing, SY: _List_Nil, F0: 0, S8: $elm$core$Maybe$Nothing, i8: managedByInput, Tl: $elm$core$Maybe$Nothing, Ts: $elm$core$Maybe$Nothing, zh: '', WN: false, Xb: $elm$core$Maybe$Nothing, X0: $elm$core$Maybe$Nothing, Y0: false, Z6: $elm$core$Maybe$Nothing, _c: $elm$core$Maybe$Nothing, ag7: 'beta', $a: $elm$core$Maybe$Nothing, $w: $elm$core$Maybe$Nothing, aaG: true, hd: false, aaX: false, aaY: false},
		A2(
			$elm$core$Platform$Cmd$map,
			A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy),
			managedByInputCmd));
};
var $author$project$Components$Hinter$NewPartnerForm$init = function (apiClient) {
	var _v0 = $author$project$Components$Hinter$NewPartnerForm$initFormFields(apiClient);
	var formFields = _v0.a;
	var formFieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			PB: $author$project$Utils$Form$init(formFields)
		},
		formFieldsCmd);
};
var $author$project$Pages$Hinter$NewPartner$init = F3(
	function (_v0, shared, _v1) {
		var _v2 = $author$project$Components$Hinter$NewPartnerForm$init(shared.D5);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form, jY: $author$project$Api$Data$NotAsked},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPartner$FormMsg, formCmd));
	});
var $author$project$Pages$Hinter$NewPartner$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$NewPartner$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$ResourceFilter$User$Practice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg,
		$author$project$Components$ResourceFilter$User$Practice$subscriptions(model.jA));
};
var $author$project$Components$Hinter$NewPartnerForm$subscriptions = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$elm$core$Platform$Sub$map,
		A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy),
		$author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions(fields.i8));
};
var $author$project$Pages$Hinter$NewPartner$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Hinter$NewPartner$FormMsg,
		$author$project$Components$Hinter$NewPartnerForm$subscriptions(model.PB));
};
var $author$project$Pages$Hinter$NewPartner$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$BaaType$toString = function (baaType) {
	if (!baaType) {
		return 'contractor';
	} else {
		return 'independent';
	}
};
var $author$project$Api$Partner$BaaType$encode = A2($elm$core$Basics$composeR, $author$project$Api$Partner$BaaType$toString, $elm$json$Json$Encode$string);
var $author$project$Api$Partner$Partner$encodeProductOverviewField = function (field) {
	return _Utils_Tuple2(
		'product_overview',
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[field])));
};
var $author$project$Api$Partner$Partner$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var name = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name)),
							acc);
					case 1:
						var slug = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'slug',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, slug)),
							acc);
					case 2:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'website_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 3:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'marketing_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 4:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'signup_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 5:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'support_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 6:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'redirect_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 8:
						var maybeDesc = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'product_description',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeDesc)),
							acc);
					case 9:
						var maybeDesc = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'integration_description',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeDesc)),
							acc);
					case 10:
						var addressParts = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'address',
								$elm$json$Json$Encode$object(addressParts)),
							acc);
					case 11:
						var authType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'auth_type',
								$elm$json$Json$Encode$string(authType)),
							acc);
					case 12:
						var maybeEmail = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'email',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeEmail)),
							acc);
					case 13:
						var email = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'technical_email',
								$elm$json$Json$Encode$string(email)),
							acc);
					case 14:
						var uses = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'uses_integration_records',
								$elm$json$Json$Encode$bool(uses)),
							acc);
					case 15:
						var active = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'active',
								$elm$json$Json$Encode$bool(active)),
							acc);
					case 16:
						var disabled = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'webhooks_disabled',
								$elm$json$Json$Encode$bool(disabled)),
							acc);
					case 17:
						var paused = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'webhooks_paused',
								$elm$json$Json$Encode$bool(paused)),
							acc);
					case 18:
						var unmute = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'unmute_self_webhooks',
								$elm$json$Json$Encode$bool(unmute)),
							acc);
					case 19:
						var maybeMax = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'max_requests_per_minute',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, maybeMax)),
							acc);
					case 20:
						var readOnly = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'practices_read_only',
								$elm$json$Json$Encode$bool(readOnly)),
							acc);
					case 21:
						var logo = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'logo',
								$elm$json$Json$Encode$string(logo)),
							acc);
					case 22:
						var events = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'listened_events',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, events)),
							acc);
					case 23:
						var status = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'status',
								$elm$json$Json$Encode$string(status)),
							acc);
					case 24:
						var sandboxEnabled = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'sandbox_enabled',
								$elm$json$Json$Encode$bool(sandboxEnabled)),
							acc);
					case 7:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'post_activation_redirect_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					case 25:
						var maybeDesc = field.a;
						return A2(
							$elm$core$List$cons,
							$author$project$Api$Partner$Partner$encodeProductOverviewField(
								_Utils_Tuple2(
									'description',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeDesc))),
							acc);
					case 26:
						var images = field.a;
						return A2(
							$elm$core$List$cons,
							$author$project$Api$Partner$Partner$encodeProductOverviewField(
								_Utils_Tuple2(
									'images',
									A2(
										$elm$json$Json$Encode$list,
										function (image) {
											if (!image.$) {
												var url = image.a;
												return $elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'url',
															$elm$json$Json$Encode$string(url))
														]));
											} else {
												var id = image.a.adR;
												var alt = image.a.I1;
												return $elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'id',
															$elm$json$Json$Encode$string(id)),
															_Utils_Tuple2(
															'alt',
															$elm$json$Json$Encode$string(alt))
														]));
											}
										},
										images))),
							acc);
					case 27:
						var maybeManagedBy = field.a;
						var managedBy = A2(
							$elm$core$Maybe$map,
							function (managedBy_) {
								if (!managedBy_.$) {
									var id = managedBy_.a;
									return {
										adR: $elm$core$Maybe$Just(id),
										ahI: $elm$core$Maybe$Just('Practice')
									};
								} else {
									var id = managedBy_.a;
									return {
										adR: $elm$core$Maybe$Just(id),
										ahI: $elm$core$Maybe$Just('ManagementGroup')
									};
								}
							},
							maybeManagedBy);
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'managed_by',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, managedBy)),
							acc);
					case 28:
						var partnerAgreementAccepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'partner_agreement_accepted',
								$elm$json$Json$Encode$bool(partnerAgreementAccepted)),
							acc);
					case 29:
						var addendumAgreementAccepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'addendum_agreement_accepted',
								$elm$json$Json$Encode$bool(addendumAgreementAccepted)),
							acc);
					case 30:
						var file = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'custom_partner_agreement',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)),
							acc);
					case 31:
						var file = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'addendum_agreement',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)),
							acc);
					case 32:
						var file = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'custom_api_access_agreement',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)),
							acc);
					case 33:
						var file = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'custom_baa_agreement',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)),
							acc);
					case 34:
						var baaType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'baa_type',
								A2($author$project$Utils$Encode$nullable, $author$project$Api$Partner$BaaType$encode, baaType)),
							acc);
					case 35:
						var baaAgreementAccepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'baa_agreement_accepted',
								$elm$json$Json$Encode$bool(baaAgreementAccepted)),
							acc);
					default:
						var apiAccessAgreementAccepted = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'api_access_agreement_accepted',
								$elm$json$Json$Encode$bool(apiAccessAgreementAccepted)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$Partner$create = F3(
	function (apiClient, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$Partner$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Pages$Hinter$NewPartner$createPartner = F2(
	function (apiClient, permittedFields) {
		return A3($author$project$Api$Partner$Partner$create, apiClient, permittedFields, $author$project$Pages$Hinter$NewPartner$Created);
	});
var $author$project$Api$Partner$Partner$Shared$organizationId = function (_v0) {
	var record = _v0;
	return record.aft;
};
var $author$project$Api$Partner$Partner$One$organizationId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$organizationId(shared);
};
var $author$project$Components$ResourceFilter$User$Practice$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if ((!_v1.$) && (!_v1.a.$)) {
				var selected = _v1.a.a;
				return _Utils_update(
					model,
					{G0: selected});
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var subMsg = msg.a;
			var practiceResourceResult = A3($author$project$Components$ResourceFilter$User$Practice$update, apiClient, subMsg, model.jA);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{jA: practiceResourceResult.y8}),
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg, practiceResourceResult.EC),
				practiceResourceResult.as);
		} else {
			var managedByType = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{f1: managedByType}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Components$Hinter$NewPartnerForm$formFieldsUpdate = F3(
	function (apiClient, field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{zh: string}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{
							_c: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var bool = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Y0: bool}),
					$elm$core$Platform$Cmd$none);
			default:
				var subMsg = field.a;
				var _v1 = A3($author$project$Components$Partner$AdminSettings$ManagedByInput$update, apiClient, subMsg, fields.i8);
				var managedByInput = _v1.a;
				var managedByInputCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{i8: managedByInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy),
						managedByInputCmd));
		}
	});
var $author$project$Components$Hinter$NewPartnerForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		var field = msg;
		var _v2 = A3(
			$author$project$Utils$Form$updateWithCmd,
			$author$project$Components$Hinter$NewPartnerForm$formFieldsUpdate(apiClient),
			field,
			model.PB);
		var newForm = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			cmd,
			_List_Nil);
	});
var $author$project$Components$Hinter$NewPartnerForm$EmailValidation = 6;
var $author$project$Components$Hinter$NewPartnerForm$LogoValidation = 5;
var $author$project$Components$Hinter$NewPartnerForm$MarketingUrlValidation = 1;
var $author$project$Components$Hinter$NewPartnerForm$NameValidation = 0;
var $author$project$Components$Hinter$NewPartnerForm$RedirectUrlValidation = 4;
var $author$project$Components$Hinter$NewPartnerForm$SignupUrlValidation = 2;
var $author$project$Components$Hinter$NewPartnerForm$SupportUrlValidation = 3;
var $author$project$Components$Hinter$NewPartnerForm$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Hinter$NewPartnerForm$validateUrl = F3(
	function (getter, validationGroup, fields) {
		var _v0 = getter(fields);
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var url = _v0.a;
			return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'URL must start with http:// or https://')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Hinter$NewPartnerForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.F0;
			},
			$author$project$Components$Hinter$NewPartnerForm$maxLogoBytesSize,
			_Utils_Tuple2(5, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Components$Hinter$NewPartnerForm$validateUrl,
				function ($) {
					return $.Tl;
				},
				1)),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Components$Hinter$NewPartnerForm$validateUrl,
				function ($) {
					return $.Z6;
				},
				2)),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Components$Hinter$NewPartnerForm$validateUrl,
				function ($) {
					return $.$a;
				},
				3)),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A2(
				$author$project$Components$Hinter$NewPartnerForm$validateUrl,
				function ($) {
					return $.X0;
				},
				4)),
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: true},
			function ($) {
				return $.Oo;
			},
			_Utils_Tuple2(6, 'Please enter a valid email'))
		]));
var $author$project$Api$Partner$Partner$Active = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Partner$Partner$AuthType = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$Partner$Email = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Partner$Partner$IntegrationDescription = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$Partner$ListenedEvents = function (a) {
	return {$: 22, a: a};
};
var $author$project$Api$Partner$Partner$Logo = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Partner$Partner$ManagedBy = function (a) {
	return {$: 27, a: a};
};
var $author$project$Api$Partner$Partner$ManagedByManagementGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$ManagedByPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$MarketingUrl = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$Partner$MaxRequestPerMinute = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Partner$Partner$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$PracticesReadOnly = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$Partner$Partner$ProductDescription = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$Partner$RedirectUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$Partner$SandboxEnabled = function (a) {
	return {$: 24, a: a};
};
var $author$project$Api$Partner$Partner$SignupUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$Partner$Slug = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$Status = function (a) {
	return {$: 23, a: a};
};
var $author$project$Api$Partner$Partner$SupportUrl = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$Partner$TechnicalEmail = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Partner$Partner$UsesIntegrationRecords = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Partner$Partner$WebhooksDisabled = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Partner$Partner$WebhooksPaused = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$User$Practice$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$value = function (_v0) {
	var model = _v0;
	var _v1 = model.f1;
	switch (_v1) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return A2(
				$elm$core$Maybe$map,
				$author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice,
				$author$project$Components$ResourceFilter$User$Practice$value(model.jA));
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Hinter$NewPartnerForm$toPermittedFields = function (fields) {
	var managedByField = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$Just,
				A2($elm$core$Basics$composeR, $author$project$Api$Partner$Partner$ManagedBy, $elm$core$List$singleton)),
			A2(
				$elm$core$Maybe$map,
				function (v) {
					if (!v.$) {
						var practiceId = v.a;
						return $author$project$Api$Partner$Partner$ManagedByPractice(practiceId);
					} else {
						var managementGroupId = v.a;
						return $author$project$Api$Partner$Partner$ManagedByManagementGroup(managementGroupId);
					}
				},
				$author$project$Components$Partner$AdminSettings$ManagedByInput$value(fields.i8))));
	return A2(
		$elm$core$List$cons,
		$author$project$Api$Partner$Partner$Name(fields.zh),
		_Utils_ap(
			function () {
				var _v0 = fields._c;
				if (!_v0.$) {
					var slug = _v0.a;
					return _List_fromArray(
						[
							$author$project$Api$Partner$Partner$Slug(
							$elm$core$Maybe$Just(slug))
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _v1 = fields.S8;
					if (!_v1.$) {
						var logoUrl = _v1.a;
						return _List_fromArray(
							[
								$author$project$Api$Partner$Partner$Logo(logoUrl)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					managedByField,
					_List_fromArray(
						[
							$author$project$Api$Partner$Partner$Status(fields.ag7),
							$author$project$Api$Partner$Partner$MarketingUrl(fields.Tl),
							$author$project$Api$Partner$Partner$SignupUrl(fields.Z6),
							$author$project$Api$Partner$Partner$SupportUrl(fields.$a),
							$author$project$Api$Partner$Partner$RedirectUrl(fields.X0),
							$author$project$Api$Partner$Partner$ProductDescription(fields.Xb),
							$author$project$Api$Partner$Partner$IntegrationDescription(fields.Q5),
							$author$project$Api$Partner$Partner$AuthType(fields.Jy),
							$author$project$Api$Partner$Partner$Email(fields.Oo),
							$author$project$Api$Partner$Partner$TechnicalEmail(
							A2($elm$core$Maybe$withDefault, '', fields.$w)),
							$author$project$Api$Partner$Partner$UsesIntegrationRecords(fields.aaG),
							$author$project$Api$Partner$Partner$Active(fields.Ic),
							$author$project$Api$Partner$Partner$WebhooksDisabled(fields.aaX),
							$author$project$Api$Partner$Partner$WebhooksPaused(fields.aaY),
							$author$project$Api$Partner$Partner$ListenedEvents(fields.SY),
							$author$project$Api$Partner$Partner$PracticesReadOnly(fields.WN),
							$author$project$Api$Partner$Partner$MaxRequestPerMinute(fields.Ts),
							$author$project$Api$Partner$Partner$SandboxEnabled(fields.Y0)
						])))));
};
var $author$project$Components$Hinter$NewPartnerForm$validate = function (_v0) {
	var model = _v0;
	var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$NewPartnerForm$formFieldsValidator, model.PB);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var validFormFields = _v2.b;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return $elm$core$Result$Ok(
			$author$project$Components$Hinter$NewPartnerForm$toPermittedFields(fields));
	} else {
		var validatedForm = _v1.a;
		return $elm$core$Result$Err(
			_Utils_update(
				model,
				{PB: validatedForm}));
	}
};
var $author$project$Pages$Hinter$NewPartner$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Hinter$NewPartnerForm$update, model.D5, subMsg, model.PB);
				var form = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: form}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPartner$FormMsg, cmd),
					outMsgs);
			case 1:
				var _v2 = $author$project$Components$Hinter$NewPartnerForm$validate(model.PB);
				if (!_v2.$) {
					var permittedFields = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Hinter$NewPartner$createPartner, model.D5, permittedFields),
						_List_Nil);
				} else {
					var updatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: updatedForm, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					var _v4 = _Utils_Tuple2(
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$OutMsg$SwitchToOrganization,
								$author$project$Api$Partner$Partner$One$organizationId(partner),
								$elm$core$Maybe$Nothing,
								$author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Partner__Dashboard__Top))
							]));
					var cmd = _v4.a;
					var outMsgs = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						cmd,
						A2(
							$elm$core$List$cons,
							A2($author$project$OutMsg$ShowToast, 3, 'Partner created'),
							outMsgs));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Hinter$NewPartner$Save = {$: 1};
var $author$project$Components$Hinter$NewPartnerForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$NewPartnerForm$SandboxEnabled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Hinter$NewPartnerForm$Slug = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton = F3(
	function (currentManagedByType, managedByType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentManagedByType, managedByType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeSelected(managedByType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$ResourceFilter$User$Practice$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$view = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Managed By Type')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.f1, 0, 'None'),
								A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.f1, 1, 'Practice'),
								A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.f1, 2, 'Management Group')
							]))
					])),
				function () {
				var _v1 = model.f1;
				switch (_v1) {
					case 0:
						return $author$project$Utils$Html$empty;
					case 1:
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Practice')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg,
									A2($author$project$Components$ResourceFilter$User$Practice$viewNew, _List_Nil, model.jA))
								]));
					default:
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$label('Management Group')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Not implemented')
										]))
								]));
				}
			}()
			]));
};
var $author$project$Components$Hinter$NewPartnerForm$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Name'),
								$author$project$Ui$Form$Group$required(true)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(fields.zh),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$Name)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 0, model.PB))
									]))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Slug')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields._c)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$Slug))
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy),
								$author$project$Components$Partner$AdminSettings$ManagedByInput$view(fields.i8))
							])),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Sandbox Enabled')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.Y0),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$SandboxEnabled))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Hinter$NewPartner$view = function (model) {
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewPartner$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Create New Partner')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Hinter$NewPartner$FormMsg,
										$author$project$Components$Hinter$NewPartnerForm$view(model.PB))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Create new partner'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		$G: 'Partner Setup'
	};
};
var $author$project$Pages$Hinter$NewPartner$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Hinter$NewPartner$init, aer: $author$project$Pages$Hinter$NewPartner$load, agD: $author$project$Pages$Hinter$NewPartner$save, ahd: $author$project$Pages$Hinter$NewPartner$subscriptions, aaq: $author$project$Pages$Hinter$NewPartner$update, ahP: $author$project$Pages$Hinter$NewPartner$view});
var $author$project$Pages$Hinter$NewPractice$AddressInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Hinter$NewPractice$initPhoneInput = A3(
	$author$project$Components$PhoneInput$init,
	'new-practice-phone-input',
	_List_Nil,
	function (d) {
		return _Utils_update(
			d,
			{Ik: true, abk: false, acB: $author$project$Api$Common$Phone$Shared$Office, yQ: 1, agk: false});
	});
var $author$project$Pages$Hinter$NewPractice$initFormFields = F2(
	function (origin, defaultHubspotDeal) {
		var _v0 = $author$project$Components$DateInput$init;
		var launchDateDateInput = _v0.a;
		var launchDateDateInputCmd = _v0.b;
		var _v1 = $author$project$Components$AddressInput$init('new-practice');
		var addressInput = _v1.a;
		var addressInputCmd = _v1.b;
		return _Utils_Tuple2(
			{
				H7: 0,
				It: A2(
					$author$project$Components$AddressInput$withHiddenCountry,
					true,
					A2($author$project$Components$AddressInput$withRequired, true, addressInput)),
				abx: origin + '/join/',
				Mu: $elm$core$Maybe$Nothing,
				Of: $elm$core$Maybe$Nothing,
				Oo: $elm$core$Maybe$Nothing,
				ac4: $elm$core$Maybe$Nothing,
				adL: $elm$core$Maybe$Just('rainforest'),
				QA: defaultHubspotDeal,
				ad7: $elm$core$Maybe$Nothing,
				SG: $elm$core$Maybe$Nothing,
				rb: launchDateDateInput,
				F0: 0,
				S8: $elm$core$Maybe$Nothing,
				zh: '',
				U5: false,
				Gq: false,
				V0: $elm$core$Maybe$Just('rainforest'),
				Wg: $author$project$Pages$Hinter$NewPractice$initPhoneInput,
				afZ: true,
				agB: $elm$core$Maybe$Nothing,
				agL: $elm$core$Maybe$Nothing,
				agP: true,
				ahb: $elm$core$Maybe$Nothing,
				aav: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg(launchDateDateInput),
						launchDateDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$AddressInputMsg, addressInputCmd)
					])));
	});
var $author$project$Pages$Hinter$NewPractice$init = F3(
	function (_v0, shared, _v1) {
		var _v2 = A2($author$project$Pages$Hinter$NewPractice$initFormFields, shared.adu.afw, shared.adu.acz);
		var formFields = _v2.a;
		var formFieldsCmd = _v2.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				cO: shared.cO,
				PB: $author$project$Utils$Form$init(formFields),
				jY: $author$project$Api$Data$NotAsked
			},
			formFieldsCmd);
	});
var $author$project$Pages$Hinter$NewPractice$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cO: shared.cO}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Hinter$NewPractice$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Hinter$NewPractice$PhoneInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Hinter$NewPractice$subscriptions = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var phone = _v0.Wg;
	var address = _v0.It;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Hinter$NewPractice$AddressInputMsg,
				$author$project$Components$AddressInput$subscriptions(address)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Hinter$NewPractice$PhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(phone))
			]));
};
var $author$project$Pages$Hinter$NewPractice$Address = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Hinter$NewPractice$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$NewPractice$LaunchDate = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Pages$Hinter$NewPractice$Logo = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Hinter$NewPractice$Phone = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$AccountType$toString = function (accountType) {
	switch (accountType) {
		case 0:
			return 'standard';
		case 1:
			return 'affiliate';
		default:
			return 'mce';
	}
};
var $author$project$Api$AccountType$encode = A2($elm$core$Basics$composeR, $author$project$Api$AccountType$toString, $elm$json$Json$Encode$string);
var $author$project$Api$Provider$Practice$create = F3(
	function (apiClient, fields, toMsg) {
		var phones_ = A2(
			$elm$json$Json$Encode$list,
			function (phone) {
				return $author$project$Api$Common$Phone$Shared$encode(phone);
			},
			fields.Wi);
		var logo_ = function () {
			var _v0 = fields.S7;
			if (!_v0.$) {
				var base64 = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'logo',
						$elm$json$Json$Encode$string(base64))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var address_ = $author$project$Api$Common$Address$Shared$encode(fields.It);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'account_type',
								$author$project$Api$AccountType$encode(fields.H7)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'sales_owner',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agB)),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'primary_care',
										$elm$json$Json$Encode$bool(fields.afZ)),
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(
											'segment',
											A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agL)),
										A2(
											$elm$core$List$cons,
											_Utils_Tuple2(
												'name',
												$elm$json$Json$Encode$string(fields.zh)),
											A2(
												$elm$core$List$cons,
												_Utils_Tuple2(
													'url',
													A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aav)),
												A2(
													$elm$core$List$cons,
													_Utils_Tuple2(
														'email',
														A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oo)),
													A2(
														$elm$core$List$cons,
														_Utils_Tuple2(
															'ein',
															A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Of)),
														A2(
															$elm$core$List$cons,
															_Utils_Tuple2('address', address_),
															A2(
																$elm$core$List$cons,
																_Utils_Tuple2('phones', phones_),
																A2(
																	$elm$core$List$cons,
																	_Utils_Tuple2(
																		'estimated_memberships_count',
																		A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.ac4)),
																	A2(
																		$elm$core$List$cons,
																		_Utils_Tuple2(
																			'launch_date',
																			A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.SG)),
																		A2(
																			$elm$core$List$cons,
																			_Utils_Tuple2(
																				'hubspot_deal_id',
																				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.QA)),
																			A2(
																				$elm$core$List$cons,
																				_Utils_Tuple2(
																					'payment_processor',
																					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.V0)),
																				A2(
																					$elm$core$List$cons,
																					_Utils_Tuple2(
																						'hint_customer_payment_processor',
																						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adL)),
																					A2(
																						$elm$core$List$cons,
																						_Utils_Tuple2(
																							'stripe_platform_id',
																							A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahb)),
																						A2(
																							$elm$core$List$cons,
																							_Utils_Tuple2(
																								'invitation_email',
																								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ad7)),
																							A2(
																								$elm$core$List$cons,
																								_Utils_Tuple2(
																									'send_invitation',
																									$elm$json$Json$Encode$bool(fields.agP)),
																								A2(
																									$elm$core$List$cons,
																									_Utils_Tuple2(
																										'ein',
																										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Of)),
																									A2(
																										$elm$core$List$cons,
																										_Utils_Tuple2(
																											'invitation_base_url',
																											$elm$json$Json$Encode$string(fields.ad6)),
																										A2(
																											$elm$core$List$cons,
																											_Utils_Tuple2(
																												'onboarded',
																												$elm$json$Json$Encode$bool(fields.U5)),
																											logo_)))))))))))))))))))))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Hinter$NewPractice$practiceFormFields = function (fields) {
	var phones = A2(
		$elm$core$List$map,
		$author$project$Utils$Phone$toRecord,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Components$PhoneInput$getPhones(fields.Wg)));
	var address = $author$project$Components$AddressInput$getAddress(fields.It);
	return {H7: fields.H7, It: address, Of: fields.Of, Oo: fields.Oo, ac4: fields.ac4, adL: fields.adL, QA: fields.QA, ad6: fields.abx, ad7: fields.ad7, SG: fields.SG, S7: fields.S8, zh: fields.zh, U5: fields.U5, V0: fields.V0, Wi: phones, afZ: fields.afZ, agB: fields.agB, agL: fields.agL, agP: fields.agP, ahb: fields.ahb, aav: fields.aav};
};
var $author$project$Pages$Hinter$NewPractice$createPractice = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$create,
			apiClient,
			$author$project$Pages$Hinter$NewPractice$practiceFormFields(fields),
			$author$project$Pages$Hinter$NewPractice$Created);
	});
var $author$project$Pages$Hinter$NewPractice$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{afZ: bool});
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						agB: $author$project$Utils$String$toMaybe(string)
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						agL: $author$project$Utils$String$toMaybe(string)
					});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aav: $author$project$Utils$String$toMaybe(string)
					});
			case 5:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						Mu: $elm$core$Maybe$Just(string),
						F0: _int,
						S8: $elm$core$Maybe$Just(string)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Oo: $author$project$Utils$String$toMaybe(string)
					});
			case 7:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Of: $author$project$Utils$String$toMaybe(string)
					});
			case 8:
				var phone = field.a;
				return _Utils_update(
					fields,
					{Wg: phone});
			case 9:
				var address = field.a;
				return _Utils_update(
					fields,
					{It: address});
			case 10:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ac4: $elm$core$String$toInt(string)
					});
			case 11:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{SG: date, rb: dateInput});
			case 12:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						QA: $author$project$Utils$String$toMaybe(string)
					});
			case 13:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						V0: $author$project$Utils$String$toMaybe(string)
					});
			case 14:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						adL: $author$project$Utils$String$toMaybe(string)
					});
			case 15:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ahb: $author$project$Utils$String$toMaybe(string)
					});
			case 16:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ad7: $author$project$Utils$String$toMaybe(string)
					});
			case 17:
				var bool = field.a;
				return _Utils_update(
					fields,
					{agP: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{U5: bool});
		}
	});
var $author$project$Pages$Hinter$NewPractice$EinValidation = 5;
var $author$project$Pages$Hinter$NewPractice$EmailValidation = 3;
var $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessorValidation = 11;
var $author$project$Pages$Hinter$NewPractice$InvitationEmailValidation = 8;
var $author$project$Pages$Hinter$NewPractice$LogoValidation = 2;
var $author$project$Pages$Hinter$NewPractice$NameValidation = 0;
var $author$project$Pages$Hinter$NewPractice$PaymentProcessorValidation = 10;
var $author$project$Pages$Hinter$NewPractice$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Pages$Hinter$NewPractice$AddressValidation = 6;
var $author$project$Pages$Hinter$NewPractice$validateAddress = function (fields) {
	return (!$author$project$Components$AddressInput$isValid(fields.It)) ? _List_fromArray(
		[
			_Utils_Tuple2(6, 'Please enter a valid address.')
		]) : _List_Nil;
};
var $author$project$Pages$Hinter$NewPractice$HubspotDealValidation = 9;
var $author$project$Pages$Hinter$NewPractice$validateHubspotDealId = function (fields) {
	return _Utils_eq(fields.QA, $elm$core$Maybe$Nothing) ? _List_fromArray(
		[
			_Utils_Tuple2(9, 'Please set a Hubspot Deal Id')
		]) : _List_Nil;
};
var $author$project$Pages$Hinter$NewPractice$LaunchDateValidation = 7;
var $author$project$Pages$Hinter$NewPractice$validateLaunchDate = F2(
	function (currentDate, fields) {
		var _v0 = fields.SG;
		if (_v0.$ === 1) {
			return _List_Nil;
		} else {
			var launchDate = _v0.a;
			return (A2($justinmimbs$date$Date$compare, currentDate, launchDate) !== 2) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(7, 'Please enter a date greater or equal than today')
				]);
		}
	});
var $author$project$Pages$Hinter$NewPractice$PhoneValidation = 4;
var $author$project$Pages$Hinter$NewPractice$validatePhone = function (fields) {
	var _v0 = $author$project$Components$PhoneInput$getPhones(fields.Wg);
	if (!_v0.$) {
		return _List_Nil;
	} else {
		return _List_fromArray(
			[
				_Utils_Tuple2(4, 'Please enter a valid phone')
			]);
	}
};
var $author$project$Pages$Hinter$NewPractice$StripePlatformIdValidation = 12;
var $author$project$Pages$Hinter$NewPractice$validateStripePlatformId = function (fields) {
	return (_Utils_eq(
		fields.adL,
		$elm$core$Maybe$Just('stripe')) && _Utils_eq(fields.ahb, $elm$core$Maybe$Nothing)) ? _List_fromArray(
		[
			_Utils_Tuple2(12, 'Please set a Stripe Customer ID or select rainforest as Pay Hint Via')
		]) : _List_Nil;
};
var $author$project$Pages$Hinter$NewPractice$UrlValidation = 1;
var $author$project$Pages$Hinter$NewPractice$validateUrl = function (fields) {
	var _v0 = fields.aav;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var url = _v0.a;
		return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'URL must start with http:// or https://')
			]) : _List_Nil;
	}
};
var $author$project$Pages$Hinter$NewPractice$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.zh;
				},
				_Utils_Tuple2(0, 'Please enter a name.')),
				A3(
				$author$project$Utils$Validate$ifIntGreaterThan,
				function ($) {
					return $.F0;
				},
				$author$project$Pages$Hinter$NewPractice$maxLogoBytesSize,
				_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateUrl),
				A3(
				$author$project$Utils$Validate$ifInvalidEmail,
				{abh: true},
				function ($) {
					return $.Oo;
				},
				_Utils_Tuple2(3, 'Please enter a valid email')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validatePhone),
				A2(
				$author$project$Ui$Form$Ein$ifInvalid,
				function ($) {
					return $.Of;
				},
				_Utils_Tuple2(5, 'Please enter a valid EIN or leave empty')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateAddress),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$Hinter$NewPractice$validateLaunchDate(currentDate)),
				A3(
				$author$project$Utils$Validate$ifInvalidEmail,
				{abh: true},
				function ($) {
					return $.ad7;
				},
				_Utils_Tuple2(8, 'Please enter a valid email')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateHubspotDealId),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.V0;
				},
				_Utils_Tuple2(10, 'Please select a payment processor')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.adL;
				},
				_Utils_Tuple2(11, 'Please select a payment processor to pay hint via')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateStripePlatformId)
			]));
};
var $author$project$Pages$Hinter$NewPractice$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			_List_Nil);
	});
var $author$project$Pages$Hinter$NewPractice$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$NewPractice$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var fields = $author$project$Utils$Form$fields(model.PB);
				var address = $author$project$Components$AddressInput$validate(fields.It);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					$author$project$Pages$Hinter$NewPractice$Address(address),
					model.PB);
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$Hinter$NewPractice$formFieldsValidator(model.cO),
					newForm);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var validatedForm = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Hinter$NewPractice$createPractice, model.D5, validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validatedForm, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var _v4 = _Utils_Tuple2(
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A3(
								$author$project$OutMsg$SwitchToOrganization,
								$author$project$Api$Provider$Practice$One$organizationId(practice),
								$elm$core$Maybe$Nothing,
								$author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Admin__Billing))
							]));
					var cmd = _v4.a;
					var outMsgs = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						cmd,
						_Utils_ap(
							outMsgs,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Practice created'),
									$author$project$OutMsg$PracticeUpdated(response)
								])));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v5) {
							var task = _v5.a;
							var size = _v5.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Pages$Hinter$NewPractice$FormUpdated,
									$author$project$Pages$Hinter$NewPractice$Logo(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v6 = $author$project$Utils$Form$fields(model.PB);
				var address = _v6.It;
				var _v7 = A2($author$project$Components$AddressInput$update, subMsg, address);
				var addressInputModel = _v7.a;
				var addressInputCmd = _v7.b;
				var outMsgs = _v7.c;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					$author$project$Pages$Hinter$NewPractice$Address(addressInputModel),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$AddressInputMsg, addressInputCmd),
					outMsgs);
			case 5:
				var subMsg = msg.a;
				var _v8 = $author$project$Utils$Form$fields(model.PB);
				var phone = _v8.Wg;
				var _v9 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
				var phoneInput = _v9.a;
				var phoneCmd = _v9.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$Hinter$NewPractice$formFieldsUpdate,
					$author$project$Pages$Hinter$NewPractice$Phone(phoneInput),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$PhoneInputMsg, phoneCmd),
					_List_Nil);
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Pages$Hinter$NewPractice$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg,
					$author$project$Pages$Hinter$NewPractice$LaunchDate,
					function ($) {
						return $.SG;
					});
		}
	});
var $author$project$Pages$Hinter$NewPractice$Save = {$: 1};
var $author$project$Pages$Hinter$NewPractice$Ein = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Email = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Hinter$NewPractice$EstimatedMembershipsCount = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessor = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Hinter$NewPractice$HubspotDealId = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Hinter$NewPractice$InvitationEmail = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Hinter$NewPractice$LogoUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Name = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Onboarded = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Hinter$NewPractice$PaymentProcessor = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Hinter$NewPractice$PrimaryCare = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Hinter$NewPractice$SalesOwner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Segment = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Hinter$NewPractice$SendInvitation = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Hinter$NewPractice$StripePlatformId = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Hinter$NewPractice$Url = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Hinter$NewPractice$paymentProcessors = _List_fromArray(
	[
		_Utils_Tuple2('stripe', 'Stripe'),
		_Utils_Tuple2('rainforest', 'Rainforest')
	]);
var $author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Select an option'),
	A2(
		$elm$core$List$map,
		function (_v0) {
			var value = _v0.a;
			var label = _v0.b;
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(value),
				label);
		},
		$author$project$Pages$Hinter$NewPractice$paymentProcessors));
var $author$project$Pages$Hinter$NewPractice$segments = _List_fromArray(
	['Direct care', 'Fee for service', 'Hybrid', 'Concierge']);
var $author$project$Pages$Hinter$NewPractice$segmentOptions = A2(
	$elm$core$List$cons,
	A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Select an option'),
	A2(
		$elm$core$List$map,
		function (segment) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(segment),
				segment);
		},
		$author$project$Pages$Hinter$NewPractice$segments));
var $author$project$Pages$Hinter$NewPractice$viewForm = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Don\'t Require Payment Method')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.U5),
							$author$project$Ui$ToggleSwitch$disabled(fields.Gq),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Onboarded))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Sales owner')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.agB)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$SalesOwner))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Primary care')
				]),
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.afZ),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$PrimaryCare))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Segment')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(fields.agL),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Segment))
						]),
					$author$project$Pages$Hinter$NewPractice$segmentOptions)
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Business Name'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(fields.zh),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Name)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 0, model.PB))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Website')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.aav)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Url)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 1, model.PB))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Practice Logo')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(0),
							$author$project$Ui$Form$File$onInput($author$project$Pages$Hinter$NewPractice$LogoUploaded),
							$author$project$Ui$Form$File$empty(true)
						]))
				])),
			function () {
			var _v0 = fields.Mu;
			if (!_v0.$) {
				var url = _v0.a;
				return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Image$fromSrc,
							{I1: 'Logo'},
							url,
							_List_fromArray(
								[
									$author$project$Ui$Image$height(50)
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 2, model.PB))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Phone')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Hinter$NewPractice$PhoneInputMsg,
					$author$project$Components$PhoneInput$view(fields.Wg)),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 4, model.PB))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Email')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.Oo)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Email)),
							$author$project$Ui$Form$Input$placeholder('contact@mypractice.com'),
							$author$project$Ui$Form$Input$phi(true),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 3, model.PB))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Business Address'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Hinter$NewPractice$AddressInputMsg,
					A2($author$project$Components$AddressInput$view, _List_Nil, fields.It))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Employer Identification Number (EIN)')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Ein$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Ein$value(fields.Of),
							$author$project$Ui$Form$Ein$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Ein)),
							$author$project$Ui$Form$Ein$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 5, model.PB)),
							$author$project$Ui$Form$Ein$errors(
							A2($author$project$Utils$Form$validationErrors, 5, model.PB))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$label('Launch & Billing Start')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg(fields.rb),
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(fields.SG),
								$author$project$Components$DateInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 7, model.PB)),
								$author$project$Components$DateInput$errors(
								A2($author$project$Utils$Form$validationErrors, 7, model.PB))
							]),
						fields.rb))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Current Members')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$number,
							$author$project$Ui$Form$Input$value(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.ac4))),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$EstimatedMembershipsCount))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Hubspot Deal ID'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.QA)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$HubspotDealId)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 9, model.PB)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 9, model.PB))
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Payment Processor'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(fields.V0),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$PaymentProcessor)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 10, model.PB)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 10, model.PB))
						]),
					$author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions)
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Pay Hint Via'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(fields.adL),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessor)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 11, model.PB)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 11, model.PB))
						]),
					$author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Use rainforest unless a stripe customer id is provided.')
						]))
				])),
			_Utils_eq(
			fields.adL,
			$elm$core$Maybe$Just('stripe')) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Stripe Customer ID')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.ahb)),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$StripePlatformId)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 12, model.PB)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 12, model.PB))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('This is for the payment info they gave us, allowing us to charge the customer a minimum/pmpm fee.')
						]))
				])) : $author$project$Utils$Html$empty,
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Owner email')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(
							A2($elm$core$Maybe$withDefault, '', fields.ad7)),
							$author$project$Ui$Form$Input$placeholder('email@example.com'),
							$author$project$Ui$Form$Input$onInput(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$InvitationEmail)),
							$author$project$Ui$Form$Input$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 8, model.PB)),
							$author$project$Ui$Form$Input$errors(
							A2($author$project$Utils$Form$validationErrors, 8, model.PB))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$helpBlock]),
					_List_fromArray(
						[
							$elm$html$Html$text('Leave this blank for clinical accounts.')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpan(8),
					$author$project$Ui$Form$Group$label('Invitation to owners')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Do you want to send an invitation to practice owners?')
						])),
					$author$project$Ui$ToggleSwitch$view(
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$on(fields.agP),
							$author$project$Ui$ToggleSwitch$onChange(
							A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$SendInvitation))
						]))
				]))
		]);
};
var $author$project$Pages$Hinter$NewPractice$view = function (model) {
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewPractice$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Create New Practice')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_Utils_ap(
									$author$project$Pages$Hinter$NewPractice$viewForm(model),
									_List_fromArray(
										[
											function () {
											var _v0 = model.jY;
											if (_v0.$ === 2) {
												var error = _v0.a;
												return A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt4]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Alert$danger,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Api$Data$errorToString(error))
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Create new practice'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$Hinter$NewPractice$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Hinter$NewPractice$init, aer: $author$project$Pages$Hinter$NewPractice$load, agD: $author$project$Pages$Hinter$NewPractice$save, ahd: $author$project$Pages$Hinter$NewPractice$subscriptions, aaq: $author$project$Pages$Hinter$NewPractice$update, ahP: $author$project$Pages$Hinter$NewPractice$view});
var $author$project$Pages$Home$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Home$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Home$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Home$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Home'};
};
var $author$project$Pages$Home$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Home$init,
		aer: $author$project$Pages$Home$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Home$update,
		ahP: $author$project$Pages$Home$view
	});
var $author$project$Pages$Inventory$InventoryId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$InventoryId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$InventoryId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Inventory$InventoryId_String$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Medication'};
};
var $author$project$Pages$Inventory$InventoryId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Inventory$InventoryId_String$Top$init,
		aer: $author$project$Pages$Inventory$InventoryId_String$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Inventory$InventoryId_String$Top$update,
		ahP: $author$project$Pages$Inventory$InventoryId_String$Top$view
	});
var $author$project$Pages$Inventory$List$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$List$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$List$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Inventory$List$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Medications'};
};
var $author$project$Pages$Inventory$List$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Inventory$List$init,
		aer: $author$project$Pages$Inventory$List$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Inventory$List$update,
		ahP: $author$project$Pages$Inventory$List$view
	});
var $author$project$Pages$Inventory$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Inventory$New$view = function (_v0) {
	return {e5: _List_Nil, $G: 'New Medication'};
};
var $author$project$Pages$Inventory$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Inventory$New$init,
		aer: $author$project$Pages$Inventory$New$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Inventory$New$update,
		ahP: $author$project$Pages$Inventory$New$view
	});
var $author$project$Pages$Inventory$Settings$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Inventory$Settings$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Inventory$Settings$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Inventory Settings'};
};
var $author$project$Pages$Inventory$Settings$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Inventory$Settings$init,
		aer: $author$project$Pages$Inventory$Settings$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Inventory$Settings$update,
		ahP: $author$project$Pages$Inventory$Settings$view
	});
var $author$project$Pages$Join$Token_String$GotInvitation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Join$Token_String$GotSession = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Platform$Invitation$One$Invitation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Invitation$Shared$Invitation = $elm$core$Basics$identity;
var $author$project$Api$Platform$Invitation$Shared$Record = F2(
	function (role, email) {
		return {Oo: email, agy: role};
	});
var $author$project$Api$Platform$Invitation$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'role',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$Shared$Record)));
var $author$project$Api$Platform$Invitation$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Invitation$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Invitation$One$Record = F2(
	function (accepted, organization) {
		return {HZ: accepted, Vd: organization};
	});
var $author$project$Api$Platform$Invitation$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization',
	$author$project$Api$Platform$Organization$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accepted',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$One$Record)));
var $author$project$Api$Platform$Invitation$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Invitation$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$Invitation$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$One$Invitation)));
var $author$project$Api$Platform$Invitation$invitationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['invitations']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Invitation$invitationPath = function (token) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[token]),
		$author$project$Api$Platform$Invitation$invitationsPath);
};
var $author$project$Api$Platform$Invitation$retrieve = F3(
	function (apiClient, token, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$Invitation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Platform$Invitation$invitationPath(token)));
	});
var $author$project$Pages$Join$Token_String$init = F2(
	function (shared, _v0) {
		var params = _v0.Vx;
		var _v1 = $author$project$Api$Data$clientHasAuthToken(shared.D5) ? _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A2($author$project$Api$Platform$Session$retrieve, shared.D5, $author$project$Pages$Join$Token_String$GotSession)) : _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
		var session = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple3(
			{D5: shared.D5, PB: $elm$core$Maybe$Nothing, my: $author$project$Api$Data$Loading, aet: shared.aav, jY: $author$project$Api$Data$NotAsked, ZD: session, $Q: params.$Q, aa1: $author$project$Api$Data$Loading},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Platform$Invitation$retrieve, shared.D5, params.$Q, $author$project$Pages$Join$Token_String$GotInvitation),
						cmd
					])),
			_List_Nil);
	});
var $author$project$Pages$Join$Token_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Join$Token_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Join$Token_String$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Join$Token_String$PasswordStrengthCheck = function (a) {
	return {$: 5, a: a};
};
var $author$project$Utils$PasswordStrength$PasswordStrength = $elm$core$Basics$identity;
var $author$project$Utils$PasswordStrength$init = $elm$core$Basics$identity;
var $author$project$Ports$PasswordStrength$passwordStrengthChecked = _Platform_incomingPort(
	'passwordStrengthChecked',
	A2(
		$elm$json$Json$Decode$andThen,
		function (suggestions) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (strength) {
					return $elm$json$Json$Decode$succeed(
						{aha: strength, ahe: suggestions});
				},
				A2($elm$json$Json$Decode$field, 'strength', $elm$json$Json$Decode$int));
		},
		A2(
			$elm$json$Json$Decode$field,
			'suggestions',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
var $author$project$Ports$PasswordStrength$checked = function (toMsg) {
	return $author$project$Ports$PasswordStrength$passwordStrengthChecked(
		A2($elm$core$Basics$composeR, $author$project$Utils$PasswordStrength$init, toMsg));
};
var $author$project$Pages$Join$Token_String$subscriptions = function (_v0) {
	return $author$project$Ports$PasswordStrength$checked(
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$PasswordStrengthCheck),
			$elm$core$Maybe$Just));
};
var $author$project$Pages$Join$Token_String$InvitationAccepted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Join$Token_String$UserCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Platform$Invitation$accept = F3(
	function (apiClient, token, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Invitation$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['accept']),
					$author$project$Api$Platform$Invitation$invitationPath(token))));
	});
var $author$project$Api$Platform$Invitation$One$accepted = function (_v0) {
	var record = _v0.b;
	return record.HZ;
};
var $author$project$Api$Data$clientWithAuthToken = F2(
	function (authToken, _v0) {
		var client = _v0;
		return _Utils_update(
			client,
			{e2: authToken});
	});
var $author$project$Api$Data$clientDisableAuth = function (_v0) {
	var client = _v0;
	return _Utils_update(
		client,
		{B9: false});
};
var $author$project$Api$Platform$User$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'first_name',
								$elm$json$Json$Encode$string(fields.Pu)),
								_Utils_Tuple2(
								'last_name',
								$elm$json$Json$Encode$string(fields.SA)),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(fields.Oo)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(fields.afC)),
								_Utils_Tuple2(
								'terms_accepted',
								$elm$json$Json$Encode$bool(fields.Hw))
							]))),
					_Utils_Tuple2(
					'invitation_id',
					$elm$json$Json$Encode$string(fields.ad8))
				]));
		return A4(
			$author$project$Api$Data$post,
			$author$project$Api$Data$clientDisableAuth(apiClient),
			$author$project$Api$Platform$User$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
	});
var $author$project$Api$Platform$User$One$defaultOrganization = function (_v0) {
	var record = _v0.b;
	return record.Nd;
};
var $author$project$Ports$PasswordStrength$checkPasswordStrength = _Platform_outgoingPort('checkPasswordStrength', $elm$json$Json$Encode$string);
var $author$project$Ports$PasswordStrength$check = $author$project$Ports$PasswordStrength$checkPasswordStrength;
var $author$project$Pages$Join$Token_String$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Pu: string}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{SA: string}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Oo: string}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{afC: string, nh: $elm$core$Maybe$Nothing}),
					$author$project$Ports$PasswordStrength$check(string));
			case 4:
				var bool = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Hw: bool}),
					$elm$core$Platform$Cmd$none);
			default:
				var check = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{nh: check}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Join$Token_String$EmailValidation = 2;
var $author$project$Pages$Join$Token_String$FirstNameValidation = 0;
var $author$project$Pages$Join$Token_String$LastNameValidation = 1;
var $author$project$Pages$Join$Token_String$PasswordValidation = 3;
var $author$project$Pages$Join$Token_String$TermsAcceptedValidation = 4;
var $author$project$Utils$PasswordStrength$isUnguessable = function (_v0) {
	var record = _v0;
	return record.aha >= 3;
};
var $author$project$Pages$Join$Token_String$formFieldsValidator = function (existingUser) {
	return $rtfeldman$elm_validate$Validate$all(
		existingUser ? _List_Nil : _List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Pu;
				},
				_Utils_Tuple2(0, 'Please enter a first name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.SA;
				},
				_Utils_Tuple2(1, 'Please enter a last name.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.Oo;
				},
				_Utils_Tuple2(2, 'Please enter an email.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.afC;
				},
				_Utils_Tuple2(3, 'Please enter a password.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function ($) {
					return $.Hw;
				},
				_Utils_Tuple2(4, 'You must accept our Terms of Service when creating your account.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifFalse,
				function (subject) {
					return A2(
						$elm$core$Maybe$withDefault,
						false,
						A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.nh));
				},
				_Utils_Tuple2(3, 'Please enter a secure password.'))
			]));
};
var $author$project$Api$Platform$Invitation$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Platform$Invitation$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$Invitation$Shared$email(shared);
};
var $author$project$Pages$Join$Token_String$initFormFields = F2(
	function (invitation, user) {
		return {
			Oo: A2(
				$elm$core$Maybe$withDefault,
				$author$project$Api$Platform$Invitation$One$email(invitation),
				A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$email, user)),
			Pu: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$firstName, user)),
			SA: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$lastName, user)),
			afC: '',
			nh: $elm$core$Maybe$Nothing,
			Hw: false,
			aaz: user
		};
	});
var $author$project$Pages$Join$Token_String$initInvitationForm = F2(
	function (session, invitation) {
		var _v0 = _Utils_Tuple2(session, invitation);
		_v0$3:
		while (true) {
			if (_v0.b.$ === 3) {
				switch (_v0.a.$) {
					case 3:
						var _v1 = _v0.a;
						var session_ = _v1.a;
						var _v2 = _v0.b;
						var invitation_ = _v2.a;
						var form = $author$project$Utils$Form$init(
							A2(
								$author$project$Pages$Join$Token_String$initFormFields,
								invitation_,
								$elm$core$Maybe$Just(
									$author$project$Api$Platform$Session$One$user(session_))));
						return $elm$core$Maybe$Just(form);
					case 2:
						var _v3 = _v0.b;
						var invitation_ = _v3.a;
						var form = $author$project$Utils$Form$init(
							A2($author$project$Pages$Join$Token_String$initFormFields, invitation_, $elm$core$Maybe$Nothing));
						return $elm$core$Maybe$Just(form);
					case 0:
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						var invitation_ = _v5.a;
						var form = $author$project$Utils$Form$init(
							A2($author$project$Pages$Join$Token_String$initFormFields, invitation_, $elm$core$Maybe$Nothing));
						return $elm$core$Maybe$Just(form);
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$OutMsg$GoToDefaultStateAction = {$: 1};
var $author$project$Api$Platform$Organization$Shared$requiresMfa = function (_v0) {
	var record = _v0.b;
	return record.Yn;
};
var $author$project$Pages$Join$Token_String$navigateToAcceptedOrganization = function (organization) {
	return $author$project$Api$Platform$Organization$Shared$requiresMfa(organization) ? _Utils_Tuple2(
		A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Mfa),
		_List_Nil) : _Utils_Tuple2(
		$elm$core$Platform$Cmd$none,
		_List_fromArray(
			[
				A3(
				$author$project$OutMsg$SwitchToOrganization,
				$author$project$Api$Platform$Organization$Shared$id(organization),
				$elm$core$Maybe$Nothing,
				$author$project$OutMsg$GoToDefaultStateAction)
			]));
};
var $author$project$Api$Platform$Invitation$One$organization = function (_v0) {
	var record = _v0.b;
	return record.Vd;
};
var $author$project$Ports$Session$sessionPersistRedirectPort = _Platform_outgoingPort('sessionPersistRedirectPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Session$persistRedirect = function (url) {
	return $author$project$Ports$Session$sessionPersistRedirectPort(url);
};
var $author$project$Pages$Join$Token_String$GotWhitelabelSetting = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$WhitelabelSetting$platformWhitelabelSettingsPath = function (practiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['whitelabel_settings']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[practiceId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['practices']),
				$author$project$Api$Data$platformPath)));
};
var $author$project$Api$WhitelabelSetting$platformRetrieve = F3(
	function (apiClient, practiceId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$WhitelabelSetting$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$WhitelabelSetting$platformWhitelabelSettingsPath(practiceId)));
	});
var $author$project$Pages$Join$Token_String$retrieveWhitelabelSettings = F2(
	function (apiClient, practiceId) {
		return A3($author$project$Api$WhitelabelSetting$platformRetrieve, apiClient, practiceId, $author$project$Pages$Join$Token_String$GotWhitelabelSetting);
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.Xj;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.adz,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.Bi,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.Wx,
					_Utils_ap(http, url.adO)),
				url.VL)));
};
var $author$project$Pages$Join$Token_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				var cmd = function () {
					if (response.$ === 3) {
						var invitation = response.a;
						return A2(
							$author$project$Pages$Join$Token_String$retrieveWhitelabelSettings,
							model.D5,
							$author$project$Api$Platform$Organization$Shared$id(
								$author$project$Api$Platform$Invitation$One$organization(invitation)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: A2($author$project$Pages$Join$Token_String$initInvitationForm, model.ZD, response),
							my: response
						}),
					cmd,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							PB: A2($author$project$Pages$Join$Token_String$initInvitationForm, response, model.my),
							ZD: response
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aa1: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var field = msg.a;
				var _v2 = model.PB;
				if (!_v2.$) {
					var form = _v2.a;
					var _v3 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Pages$Join$Token_String$formFieldsUpdate, field, form);
					var newForm = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Join$Token_String$FormUpdated, cmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var _v4 = model.PB;
				if (!_v4.$) {
					var form = _v4.a;
					var session = $author$project$Api$Data$toMaybe(model.ZD);
					var existingUser = $author$project$Utils$Maybe$toBool(session);
					var _v5 = A2(
						$author$project$Utils$Form$validate,
						$author$project$Pages$Join$Token_String$formFieldsValidator(existingUser),
						form);
					if (!_v5.$) {
						var _v6 = _v5.a;
						var newForm = _v6.a;
						var validFormFields = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$Loading
								}),
							function () {
								if (!session.$) {
									var accessToken = $author$project$Api$Data$clientAuthToken(model.D5);
									var apiClient = A2($author$project$Api$Data$clientWithAuthToken, accessToken, model.D5);
									return A3($author$project$Api$Platform$Invitation$accept, apiClient, model.$Q, $author$project$Pages$Join$Token_String$InvitationAccepted);
								} else {
									var _v8 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
									var firstName = _v8.Pu;
									var lastName = _v8.SA;
									var email = _v8.Oo;
									var termsAccepted = _v8.Hw;
									var password = _v8.afC;
									return A3(
										$author$project$Api$Platform$User$create,
										model.D5,
										{Oo: email, Pu: firstName, ad8: model.$Q, SA: lastName, afC: password, Hw: termsAccepted},
										$author$project$Pages$Join$Token_String$UserCreated);
								}
							}(),
							_List_Nil);
					} else {
						var newForm = _v5.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm),
									jY: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var invitation = response.a;
					var organization = $author$project$Api$Platform$Invitation$One$organization(invitation);
					var _v10 = $author$project$Pages$Join$Token_String$navigateToAcceptedOrganization(organization);
					var cmd = _v10.a;
					var outMsgs = _v10.b;
					return _Utils_Tuple3(
						model,
						cmd,
						_Utils_ap(
							outMsgs,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Invitation accepted')
								])));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var user = response.a;
					var _v12 = $author$project$Api$Platform$User$One$defaultOrganization(user);
					if (!_v12.$) {
						return _Utils_Tuple3(
							model,
							$author$project$Ports$Session$logout(
								{af6: true}),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: $author$project$Api$Data$NotAsked}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var cmd = function () {
					var _v13 = model.my;
					if (_v13.$ === 3) {
						var invitation_ = _v13.a;
						return $author$project$Api$Platform$Invitation$One$accepted(invitation_) ? $author$project$Ports$Session$logout(
							{af6: true}) : $author$project$Ports$Session$logout(
							{af6: false});
					} else {
						return $author$project$Ports$Session$logout(
							{af6: false});
					}
				}();
				return _Utils_Tuple3(model, cmd, _List_Nil);
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Session$persistRedirect(
								$elm$url$Url$toString(model.aet)),
								$author$project$Ports$Session$authorize(
								{af6: true})
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Join$Token_String$Logout = {$: 7};
var $author$project$Pages$Join$Token_String$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Join$Token_String$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Join$Token_String$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Join$Token_String$Password = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Join$Token_String$Save = {$: 4};
var $author$project$Pages$Join$Token_String$SignInClicked = {$: 8};
var $author$project$Pages$Join$Token_String$TermsAccepted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$WhitelabelSetting$brandName = function (_v0) {
	var record = _v0;
	return record.Ek;
};
var $author$project$Ui$Button$Lg = 2;
var $author$project$Ui$Button$lg = $author$project$Ui$Button$Size(2);
var $author$project$Api$Platform$Organization$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Platform$Organization$Shared$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Organization$Min$name(min);
};
var $author$project$Api$Platform$User$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Ui$Form$PasswordInput$Placeholder = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$PasswordInput$placeholder = $author$project$Ui$Form$PasswordInput$Placeholder;
var $author$project$Api$Platform$Invitation$Shared$role = function (_v0) {
	var record = _v0;
	return record.agy;
};
var $author$project$Api$Platform$Invitation$One$role = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$Invitation$Shared$role(shared);
};
var $author$project$Ui$Well$Signin = {$: 1};
var $author$project$Ui$Well$signin = $author$project$Ui$Well$Signin;
var $author$project$Ui$Form$Signup = {$: 5};
var $author$project$Ui$Form$signup = $author$project$Ui$Form$Signup;
var $author$project$Ui$Form$PasswordInput$StrengthCheck = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$PasswordInput$strengthCheck = $author$project$Ui$Form$PasswordInput$StrengthCheck;
var $author$project$Utils$HintUrls$termsUrl = 'http://www.hint.com/terms/';
var $author$project$Ui$Form$PasswordInput$WithFeedback = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$PasswordInput$withFeedback = $author$project$Ui$Form$PasswordInput$WithFeedback;
var $author$project$Pages$Join$Token_String$viewAcceptInvitationForm = F3(
	function (model, form, invitation) {
		var organization = $author$project$Api$Platform$Invitation$One$organization(invitation);
		var invitedAs = ($author$project$Api$Platform$Invitation$One$role(invitation) === 'admin') ? 'an administrator' : 'a user';
		var fields = $author$project$Utils$Form$fields(form);
		var existingUser = $author$project$Utils$Maybe$toBool(fields.aaz);
		return A2(
			$author$project$Ui$Well$view,
			_List_fromArray(
				[$author$project$Ui$Well$signin]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$horizontal,
							$author$project$Ui$Form$signup,
							$author$project$Ui$Form$noValidate(true),
							$author$project$Ui$Form$autocomplete(false),
							$author$project$Ui$Form$onSubmit($author$project$Pages$Join$Token_String$Save)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$heading(
							_List_fromArray(
								[
									function () {
									if (existingUser) {
										return $elm$html$Html$text('Accept Invitation');
									} else {
										var brandName = function () {
											var _v0 = model.aa1;
											if (_v0.$ === 3) {
												var whitelabelSetting = _v0.a;
												return $author$project$Api$WhitelabelSetting$brandName(whitelabelSetting) + ' ';
											} else {
												return '';
											}
										}();
										return $elm$html$Html$text(
											$elm$core$String$concat(
												_List_fromArray(
													['Create your ', brandName, 'Account'])));
									}
								}()
								])),
							function () {
							var _v1 = fields.aaz;
							if (!_v1.$) {
								var user = _v1.a;
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock]),
											_Utils_eq(
												$author$project$Api$Platform$User$Shared$email(user),
												$author$project$Api$Platform$Invitation$One$email(invitation)) ? _List_fromArray(
												[
													$elm$html$Html$text('You\'re logged in as '),
													$elm$html$Html$text(
													$author$project$Api$Platform$User$Shared$name(user)),
													$elm$html$Html$text('.')
												]) : _List_fromArray(
												[
													$elm$html$Html$text('You\'re logged in as '),
													A2(
													$author$project$Ui$Typography$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Api$Platform$User$Shared$email(user))
														])),
													$elm$html$Html$text(' but are accepting an invitation sent to '),
													A2(
													$author$project$Ui$Typography$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Api$Platform$Invitation$One$email(invitation))
														]))
												])),
											A2(
											$author$project$Ui$Typography$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Want to create a new account? '),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Sign out'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$Logout)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Sign Out')
														])),
													$elm$html$Html$text('.')
												]))
										]));
							} else {
								return A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Already have an account? '),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Sign In'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$SignInClicked)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sign In')
												]))
										]));
							}
						}(),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form) || A2($author$project$Utils$Form$hasValidationErrors, 1, form))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$placeholder('First'),
															$author$project$Ui$Form$Input$value(fields.Pu),
															$author$project$Ui$Form$Input$onInput(
															A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$FirstName)),
															$author$project$Ui$Form$Input$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
															$author$project$Ui$Form$Input$disabled(existingUser)
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$Input$placeholder('Last'),
															$author$project$Ui$Form$Input$value(fields.SA),
															$author$project$Ui$Form$Input$onInput(
															A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$LastName)),
															$author$project$Ui$Form$Input$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
															$author$project$Ui$Form$Input$disabled(existingUser)
														]))
												]))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 2, form))
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$placeholder('Email address'),
											$author$project$Ui$Form$Input$email,
											$author$project$Ui$Form$Input$value(fields.Oo),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$Email)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
											$author$project$Ui$Form$Input$disabled(existingUser)
										]))
								])),
							(!existingUser) ? A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 3, form))
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$PasswordInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$PasswordInput$placeholder('Password'),
											$author$project$Ui$Form$PasswordInput$value(fields.afC),
											$author$project$Ui$Form$PasswordInput$strengthCheck(fields.nh),
											$author$project$Ui$Form$PasswordInput$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$Password)),
											$author$project$Ui$Form$PasswordInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
											$author$project$Ui$Form$PasswordInput$withFeedback(
											$author$project$Utils$Form$validated(form))
										]))
								])) : $author$project$Utils$Html$empty,
							(!existingUser) ? A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Checkbox$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Checkbox$value(fields.Hw),
											$author$project$Ui$Form$Checkbox$required(true),
											$author$project$Ui$Form$Checkbox$onCheck(
											A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$TermsAccepted)),
											$author$project$Ui$Form$Checkbox$errors(
											A2($author$project$Utils$Form$validationErrors, 4, form))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('I agree to this software platform\'s '),
											A3(
											$author$project$Ui$Link$externalHref,
											$author$project$Utils$HintUrls$termsUrl,
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('Terms of Service')
												])),
											$elm$html$Html$text('.')
										]))
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Accept invitation'},
									_List_fromArray(
										[
											$author$project$Ui$Button$lg,
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$fullWidth(true),
											$author$project$Ui$Button$submit,
											$author$project$Ui$Button$loading(
											_Utils_eq(model.jY, $author$project$Api$Data$Loading))
										]),
									_List_fromArray(
										[
											existingUser ? $elm$html$Html$text('Accept Invitation') : $elm$html$Html$text('Sign Up')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$helpBlock,
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('as '),
											$elm$html$Html$text(invitedAs),
											$elm$html$Html$text(' for '),
											$elm$html$Html$text(
											$author$project$Api$Platform$Organization$Shared$name(organization))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Join$Token_String$viewInvitation = F3(
	function (model, form, invitation) {
		return $author$project$Api$Platform$Invitation$One$accepted(invitation) ? A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('It looks like you have already accepted our invitation. Please use your new credentials to access your account '),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Sign In'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$Logout)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$elm$html$Html$text('.')
				])) : A3($author$project$Pages$Join$Token_String$viewAcceptInvitationForm, model, form, invitation);
	});
var $author$project$Pages$Join$Token_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(model.my, model.PB);
				_v0$2:
				while (true) {
					switch (_v0.a.$) {
						case 3:
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var invitation = _v1.a;
								var form = _v0.b.a;
								return A3($author$project$Pages$Join$Token_String$viewInvitation, model, form, invitation);
							} else {
								break _v0$2;
							}
						case 2:
							return A2(
								$author$project$Ui$Alert$danger,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('The invitation is invalid or has expired')
									]));
						default:
							break _v0$2;
					}
				}
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Spinner$view(_List_Nil)
						]));
			}()
			]),
		$G: 'Login'
	};
};
var $author$project$Pages$Join$Token_String$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$Join$Token_String$init, aer: $author$project$Pages$Join$Token_String$load, agD: $author$project$Pages$Join$Token_String$save, ahd: $author$project$Pages$Join$Token_String$subscriptions, aaq: $author$project$Pages$Join$Token_String$update, ahP: $author$project$Pages$Join$Token_String$view});
var $author$project$Components$Auth$RequestCode$formFieldsInit = {Oo: ''};
var $author$project$Components$Auth$RequestCode$init = {
	b4: $author$project$Utils$Form$init($author$project$Components$Auth$RequestCode$formFieldsInit)
};
var $author$project$Components$Auth$VerifyCode$formFieldsInit = {K3: ''};
var $author$project$Components$Auth$VerifyCode$init = {
	bp: $author$project$Utils$Form$init($author$project$Components$Auth$VerifyCode$formFieldsInit),
	K4: false,
	ls: 0,
	Oo: $elm$core$Maybe$Nothing,
	ON: $elm$core$Maybe$Nothing,
	W7: false,
	sw: $elm$core$Maybe$Nothing,
	sL: false
};
var $author$project$Pages$Login$redirectBasedOnSession = F2(
	function (model, shared) {
		var _v0 = shared.ZD;
		switch (_v0.$) {
			case 3:
				var session = _v0.a;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						A2($author$project$Permission$homeStateFor, session, shared.adN)),
					_List_Nil);
			case 1:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			default:
				var cmd = shared.adu.abt ? $elm$core$Platform$Cmd$none : $author$project$Ports$Session$authorize(
					{af6: true});
				return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Pages$Login$init = F2(
	function (shared, _v0) {
		var query = _v0.Bi;
		var model = {D5: shared.D5, abt: shared.adu.abt, Oo: $elm$core$Maybe$Nothing, qT: shared.qT, W7: false, sp: $author$project$Components$Auth$RequestCode$init, sw: $elm$core$Maybe$Nothing, eP: $author$project$Components$Auth$VerifyCode$init};
		if (shared.adu.abt) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			if (A2($author$project$Api$Data$clientHasTokenExpired, shared.D5, shared.ack)) {
				var returnUrlCmd = function () {
					var _v1 = A2($elm$core$Dict$get, 'returnUrl', query);
					if (!_v1.$) {
						var returnUrl = _v1.a;
						return $author$project$Ports$Session$persistRedirect(returnUrl);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								returnUrlCmd,
								$author$project$Ports$Session$authorize(
								{af6: true})
							])),
					_List_Nil);
			} else {
				return A2($author$project$Pages$Login$redirectBasedOnSession, model, shared);
			}
		}
	});
var $author$project$Pages$Login$load = F2(
	function (shared, model) {
		return A2($author$project$Pages$Login$redirectBasedOnSession, model, shared);
	});
var $author$project$Pages$Login$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Login$GotRecaptchaToken = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$GoogleRecaptcha$gotRecaptchaTokenPort = _Platform_incomingPort(
	'gotRecaptchaTokenPort',
	A2(
		$elm$json$Json$Decode$andThen,
		function (token) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (result) {
					return $elm$json$Json$Decode$succeed(
						{Yz: result, $Q: token});
				},
				A2($elm$json$Json$Decode$field, 'result', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string)));
var $author$project$Ports$GoogleRecaptcha$GoogleRecaptchaNotDefined = 0;
var $author$project$Ports$GoogleRecaptcha$GoogleRequestError = 1;
var $author$project$Ports$GoogleRecaptcha$localStorageResultFromPort = F2(
	function (msg, _v0) {
		var token = _v0.$Q;
		var result = _v0.Yz;
		switch (result) {
			case 'ok':
				return msg(
					$elm$core$Result$Ok(token));
			case 'recaptcha-not-defined':
				return msg(
					$elm$core$Result$Err(0));
			default:
				return msg(
					$elm$core$Result$Err(1));
		}
	});
var $author$project$Ports$GoogleRecaptcha$gotRecaptchaToken = function (msg) {
	return $author$project$Ports$GoogleRecaptcha$gotRecaptchaTokenPort(
		$author$project$Ports$GoogleRecaptcha$localStorageResultFromPort(msg));
};
var $author$project$Pages$Login$subscriptions = function (_v0) {
	return $author$project$Ports$GoogleRecaptcha$gotRecaptchaToken($author$project$Pages$Login$GotRecaptchaToken);
};
var $author$project$OutMsg$BackupAuthCodeValidated = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Login$GotCodeCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$GoogleRecaptcha$Login = 1;
var $author$project$Pages$Login$VerifyCodeMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$GoogleRecaptcha$actionToString = function (action) {
	if (!action) {
		return 'onboard';
	} else {
		return 'login';
	}
};
var $author$project$Ports$GoogleRecaptcha$getRecaptchaTokenPort = _Platform_outgoingPort('getRecaptchaTokenPort', $elm$json$Json$Encode$string);
var $author$project$Ports$GoogleRecaptcha$getRecaptchaToken = function (action) {
	return $author$project$Ports$GoogleRecaptcha$getRecaptchaTokenPort(
		$author$project$Ports$GoogleRecaptcha$actionToString(action));
};
var $author$project$Api$Auth$authSaltDecoder = A2($elm$json$Json$Decode$field, 'salt', $elm$json$Json$Decode$string);
var $author$project$Api$Auth$requestCode = F4(
	function (client, email, recaptchaToken, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'google_recaptcha_token',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, recaptchaToken))
				]));
		return A4(
			$author$project$Api$Data$post,
			$author$project$Api$Data$clientDisableAuth(client),
			$author$project$Api$Auth$authSaltDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['request_code']),
						$author$project$Api$Auth$authPath))));
	});
var $author$project$Components$Auth$RequestCode$EmailSubmitted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Auth$RequestCode$NoEvent = {$: 0};
var $author$project$Components$Auth$RequestCode$formFieldsUpdate = F2(
	function (field, form) {
		var email = field;
		return _Utils_update(
			form,
			{Oo: email});
	});
var $author$project$Components$Auth$RequestCode$EmailValidation = 0;
var $author$project$Utils$String$strip = function (string) {
	return A3($elm$core$String$replace, ' ', '', string);
};
var $author$project$Components$Auth$RequestCode$validateEmail = function (_v0) {
	var email = _v0.Oo;
	var emailText = $author$project$Utils$String$strip(email);
	return ((!$rtfeldman$elm_validate$Validate$isBlank(emailText)) && (!$rtfeldman$elm_validate$Validate$isValidEmail(emailText))) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Please enter a valid email.')
		]) : _List_Nil;
};
var $author$project$Components$Auth$RequestCode$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Auth$RequestCode$validateEmail)
		]));
var $author$project$Components$Auth$RequestCode$validateForm = function (model) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$RequestCode$formFieldsValidator, model.b4);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.a;
		return _Utils_Tuple2(form, true);
	} else {
		var form = _v0.a;
		return _Utils_Tuple2(form, false);
	}
};
var $author$project$Components$Auth$RequestCode$validate = function (model) {
	return _Utils_update(
		model,
		{
			b4: $author$project$Components$Auth$RequestCode$validateForm(model).a
		});
};
var $author$project$Components$Auth$RequestCode$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var field = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							b4: A3($author$project$Utils$Form$update, $author$project$Components$Auth$RequestCode$formFieldsUpdate, field, model.b4)
						}),
					$author$project$Components$Auth$RequestCode$NoEvent);
			case 0:
				var _v1 = $author$project$Components$Auth$RequestCode$validateForm(model);
				var newForm = _v1.a;
				var isFormValid = _v1.b;
				var newModel = _Utils_update(
					model,
					{b4: newForm});
				if (isFormValid) {
					var _v2 = $author$project$Utils$Form$fields(model.b4);
					var email = _v2.Oo;
					return _Utils_Tuple2(
						newModel,
						$author$project$Components$Auth$RequestCode$EmailSubmitted(email));
				} else {
					return _Utils_Tuple2(newModel, $author$project$Components$Auth$RequestCode$NoEvent);
				}
			default:
				return _Utils_Tuple2(
					$author$project$Components$Auth$RequestCode$validate(model),
					$author$project$Components$Auth$RequestCode$NoEvent);
		}
	});
var $author$project$Components$Auth$VerifyCode$JWT = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Auth$VerifyCode$NoEvent = {$: 0};
var $author$project$Components$Auth$VerifyCode$ResendCode = {$: 1};
var $author$project$Components$Auth$VerifyCode$ResponseError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Auth$VerifyCode$formFieldsUpdate = F2(
	function (field, form) {
		var code = field;
		return _Utils_update(
			form,
			{K3: code});
	});
var $author$project$Components$Auth$VerifyCode$CodeValidation = 0;
var $rtfeldman$elm_validate$Validate$isInt = function (str) {
	var _v0 = $elm$core$String$toInt(str);
	if (_v0.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Components$Auth$VerifyCode$validateCode = function (_v0) {
	var code = _v0.K3;
	return ((!$rtfeldman$elm_validate$Validate$isInt(code)) || ($elm$core$String$length(code) !== 6)) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'Code format is not valid.')
		]) : _List_Nil;
};
var $author$project$Components$Auth$VerifyCode$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Auth$VerifyCode$validateCode)
		]));
var $author$project$Components$Auth$VerifyCode$validateForm = function (model) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$VerifyCode$formFieldsValidator, model.bp);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.a;
		return _Utils_Tuple2(form, true);
	} else {
		var form = _v0.a;
		return _Utils_Tuple2(form, false);
	}
};
var $author$project$Components$Auth$VerifyCode$validate = function (model) {
	return _Utils_update(
		model,
		{
			bp: $author$project$Components$Auth$VerifyCode$validateForm(model).a
		});
};
var $author$project$Components$Auth$VerifyCode$GotCodeValidated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Auth$verifyCode = F5(
	function (client, email, salt, code, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(email)),
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(code)),
					_Utils_Tuple2(
					'salt',
					$elm$json$Json$Encode$string(salt))
				]));
		return A4(
			$author$project$Api$Data$post,
			$author$project$Api$Data$clientDisableAuth(client),
			$author$project$Api$Auth$authTokenDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Auth$authPath)));
	});
var $author$project$Components$Auth$VerifyCode$verifyCode = F4(
	function (apiClient, maybeEmail, maybeSalt, code) {
		var _v0 = _Utils_Tuple2(maybeEmail, maybeSalt);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var email = _v0.a.a;
			var salt = _v0.b.a;
			return A5($author$project$Api$Auth$verifyCode, apiClient, email, salt, code, $author$project$Components$Auth$VerifyCode$GotCodeValidated);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Auth$VerifyCode$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: A3($author$project$Utils$Form$update, $author$project$Components$Auth$VerifyCode$formFieldsUpdate, field, model.bp)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Auth$VerifyCode$NoEvent);
			case 0:
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$VerifyCode$formFieldsValidator, model.bp);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var _v3 = $author$project$Utils$Form$fields(model.bp);
					var code = _v3.K3;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bp: newForm, ls: model.ls + 1, ON: $elm$core$Maybe$Nothing, W7: true, sL: false}),
						A4($author$project$Components$Auth$VerifyCode$verifyCode, apiClient, model.Oo, model.sw, code),
						$author$project$Components$Auth$VerifyCode$NoEvent);
				} else {
					var newForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bp: newForm}),
						$elm$core$Platform$Cmd$none,
						$author$project$Components$Auth$VerifyCode$NoEvent);
				}
			case 1:
				return _Utils_Tuple3(
					$author$project$Components$Auth$VerifyCode$validate(model),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Auth$VerifyCode$NoEvent);
			case 3:
				return model.W7 ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$NoEvent) : _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bp: $author$project$Utils$Form$init($author$project$Components$Auth$VerifyCode$formFieldsInit),
							ls: 0,
							ON: $elm$core$Maybe$Nothing,
							sL: true
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Auth$VerifyCode$ResendCode);
			default:
				var response = msg.a;
				_v4$2:
				while (true) {
					switch (response.$) {
						case 3:
							var token = response.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$Components$Auth$VerifyCode$JWT(token));
						case 2:
							if (response.a.$ === 6) {
								var _v5 = response.a;
								var errorMessage = _v5.b;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											ON: $elm$core$Maybe$Just(errorMessage),
											W7: false
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$Components$Auth$VerifyCode$NoEvent);
							} else {
								break _v4$2;
							}
						default:
							break _v4$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{W7: false}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$Auth$VerifyCode$ResponseError(response));
		}
	});
var $author$project$Components$Auth$VerifyCode$withEmail = F2(
	function (email, model) {
		return _Utils_update(
			model,
			{
				Oo: $elm$core$Maybe$Just(email)
			});
	});
var $author$project$Components$Auth$VerifyCode$withSalt = F2(
	function (salt, model) {
		return _Utils_update(
			model,
			{
				sw: $elm$core$Maybe$Just(salt)
			});
	});
var $author$project$Pages$Login$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var requestCodeMsg = msg.a;
				var _v1 = A2($author$project$Components$Auth$RequestCode$update, requestCodeMsg, model.sp);
				var requestCodeModel = _v1.a;
				var event = _v1.b;
				var newModel = _Utils_update(
					model,
					{sp: requestCodeModel});
				if (!event.$) {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var newEmail = event.a;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{
								Oo: $elm$core$Maybe$Just(newEmail),
								W7: true,
								eP: A2($author$project$Components$Auth$VerifyCode$withEmail, newEmail, model.eP)
							}),
						$author$project$Ports$GoogleRecaptcha$getRecaptchaToken(1),
						_List_Nil);
				}
			case 1:
				var verifyCodeMsg = msg.a;
				var _v3 = A3($author$project$Components$Auth$VerifyCode$update, model.D5, verifyCodeMsg, model.eP);
				var verifyCodeModel = _v3.a;
				var verifyCmd = _v3.b;
				var event = _v3.c;
				var newModel = _Utils_update(
					model,
					{eP: verifyCodeModel});
				switch (event.$) {
					case 1:
						return _Utils_Tuple3(
							newModel,
							$author$project$Ports$GoogleRecaptcha$getRecaptchaToken(1),
							_List_Nil);
					case 3:
						var response = event.a;
						return _Utils_Tuple3(
							newModel,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd),
							$author$project$OutMsg$handleErrorResponse(response));
					case 2:
						var token = event.a;
						return _Utils_Tuple3(
							newModel,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd),
							_List_fromArray(
								[
									$author$project$OutMsg$BackupAuthCodeValidated(token)
								]));
					default:
						return _Utils_Tuple3(
							newModel,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd),
							_List_Nil);
				}
			case 2:
				var result = msg.a;
				var recaptchaToken = $elm$core$Result$toMaybe(result);
				var email = A2($elm$core$Maybe$withDefault, '', model.Oo);
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Auth$requestCode, model.D5, email, recaptchaToken, $author$project$Pages$Login$GotCodeCreated),
					_List_Nil);
			default:
				var authData = msg.a;
				var newModel = _Utils_update(
					model,
					{W7: false});
				_v5$2:
				while (true) {
					switch (authData.$) {
						case 3:
							var salt = authData.a;
							return _Utils_Tuple3(
								_Utils_update(
									newModel,
									{
										sw: $elm$core$Maybe$Just(salt),
										eP: A2($author$project$Components$Auth$VerifyCode$withSalt, salt, model.eP)
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (authData.a.$ === 9) {
								return _Utils_Tuple3(newModel, $elm$browser$Browser$Navigation$reload, _List_Nil);
							} else {
								break _v5$2;
							}
						default:
							break _v5$2;
					}
				}
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Ui$Image$HintFullLogo = 12;
var $author$project$Pages$Login$RequestCodeMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Login$canShowVerifyCode = F2(
	function (maybeEmail, maybeSalt) {
		return !($author$project$Utils$Maybe$isNothing(maybeEmail) || $author$project$Utils$Maybe$isNothing(maybeSalt));
	});
var $author$project$Components$Auth$RequestCode$EmailBlurred = {$: 1};
var $author$project$Components$Auth$RequestCode$EmailField = $elm$core$Basics$identity;
var $author$project$Components$Auth$RequestCode$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Auth$RequestCode$SubmitForm = {$: 0};
var $author$project$Components$Auth$RequestCode$isSubmitDisabled = F3(
	function (email, formHasValidationErrors, processingAction) {
		return $author$project$Utils$String$isBlank(email) || (formHasValidationErrors || processingAction);
	});
var $author$project$Ui$Form$Group$LabelAbove = {$: 13};
var $author$project$Ui$Form$Group$labelAbove = $author$project$Ui$Form$Group$LabelAbove;
var $author$project$Utils$HintUrls$statusPageUrl = 'https://status.hint.com/';
var $author$project$Components$BackupAuthAlert$viewAlertText = _List_fromArray(
	[
		$elm$html$Html$text('Our main sign in system is currently down. Please save your work frequently as you will be signed out automatically when the main system comes back online.'),
		A2($elm$html$Html$br, _List_Nil, _List_Nil),
		$elm$html$Html$text('Thank you for your patience.'),
		$author$project$Utils$Html$noBreakSpace,
		A3(
		$author$project$Ui$Link$externalHref,
		$author$project$Utils$HintUrls$statusPageUrl,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('See status page for real-time updates.')
			]))
	]);
var $author$project$Components$Auth$RequestCode$viewBackupAuthAlert = A2(
	$author$project$Ui$Alert$warning,
	_List_fromArray(
		[
			$author$project$Ui$Alert$margin(25),
			$author$project$Ui$Alert$icon(59),
			$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
		]),
	$author$project$Components$BackupAuthAlert$viewAlertText);
var $author$project$Components$Auth$RequestCode$viewForm = F2(
	function (model, processingAction) {
		var formHasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 0, model.b4);
		var _v0 = $author$project$Utils$Form$fields(model.b4);
		var email = _v0.Oo;
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Events$onSubmit($author$project$Components$Auth$RequestCode$SubmitForm)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Auth$RequestCode$viewBackupAuthAlert,
									A2($elm$html$Html$br, _List_Nil, _List_Nil)
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Your email'),
											$author$project$Ui$Form$Group$required(true),
											$author$project$Ui$Form$Group$labelAbove
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$placeholder('e.g. name@example.com'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Auth$RequestCode$FormUpdated, $elm$core$Basics$identity)),
													$author$project$Ui$Form$Input$invalid(formHasValidationErrors),
													$author$project$Ui$Form$Input$value(email),
													$author$project$Ui$Form$Input$email,
													$author$project$Ui$Form$Input$onBlur($author$project$Components$Auth$RequestCode$EmailBlurred)
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 0, model.b4))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Send authentication code'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$fullWidth(true),
											$author$project$Ui$Button$disabled(
											A3($author$project$Components$Auth$RequestCode$isSubmitDisabled, email, formHasValidationErrors, processingAction)),
											$author$project$Ui$Button$submit,
											$author$project$Ui$Button$loading(processingAction)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Send code')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Auth$RequestCode$viewTermsText = A2(
	$author$project$Ui$Typography$span,
	_List_fromArray(
		[
			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('I agree with the ')
				])),
			A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Utils$HintUrls$termsUrl,
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Terms')
				]))
		]));
var $author$project$Components$Auth$RequestCode$view = F2(
	function (model, processingAction) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[$author$project$Ui$Panel$extraPadding]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mt4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text('Sign in with email')
												])),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2($author$project$Components$Auth$RequestCode$viewForm, model, processingAction),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$author$project$Components$Auth$RequestCode$viewTermsText
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Auth$VerifyCode$CodeBlurred = {$: 1};
var $author$project$Components$Auth$VerifyCode$CodeField = $elm$core$Basics$identity;
var $author$project$Components$Auth$VerifyCode$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Auth$VerifyCode$ResendCodeMsg = {$: 3};
var $author$project$Components$Auth$VerifyCode$SubmitForm = {$: 0};
var $author$project$Components$Auth$VerifyCode$codeExhausted = function (codeSubmitAttempts) {
	return codeSubmitAttempts >= 3;
};
var $author$project$Components$Auth$VerifyCode$isSubmitDisabled = F3(
	function (hasValidationErros, processing, codeSubmitAttempts) {
		return hasValidationErros || (processing || $author$project$Components$Auth$VerifyCode$codeExhausted(codeSubmitAttempts));
	});
var $author$project$Components$Auth$VerifyCode$viewCodeError = function (errorMessage) {
	if (!errorMessage.$) {
		var message = errorMessage.a;
		return A2(
			$author$project$Ui$Alert$danger,
			_List_fromArray(
				[
					$author$project$Ui$Alert$icon(60),
					$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(message)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Auth$VerifyCode$viewCodeResendMessage = function () {
	var supportEmail = 'support@hint.com';
	var infoText = '\n            If we have an account matching your email address, you will receive\n            an email with a code. If you do not receive an email, please contact\n            us at\n            ';
	return A2(
		$author$project$Ui$Alert$info,
		_List_fromArray(
			[
				$author$project$Ui$Alert$margin(25),
				$author$project$Ui$Alert$icon(5),
				$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Code has been resent')
							]))
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(infoText)
					])),
				A3(
				$author$project$Ui$Link$mailto,
				supportEmail,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(supportEmail)
					]))
			]));
}();
var $author$project$Components$Auth$VerifyCode$viewEmailSentText = function (email) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_fromArray(
			[
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('An email with a code has been sent to ' + (email + '. Please enter the code within 15 minutes.'))
			]));
};
var $author$project$Components$Auth$VerifyCode$viewForm = F6(
	function (email, processing, showCodeResend, codeForm, errorMessage, codeSubmitAttempts) {
		var hasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 0, codeForm);
		var _v0 = $author$project$Utils$Form$fields(codeForm);
		var code = _v0.K3;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$Auth$VerifyCode$viewEmailSentText(email),
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Resend verification code'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick($author$project$Components$Auth$VerifyCode$ResendCodeMsg),
													$author$project$Ui$Button$disabled(processing)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resend code')
												]))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									showCodeResend ? $author$project$Components$Auth$VerifyCode$viewCodeResendMessage : $author$project$Utils$Html$empty,
									$author$project$Components$Auth$VerifyCode$viewCodeError(errorMessage)
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Your code'),
											$author$project$Ui$Form$Group$required(true),
											$author$project$Ui$Form$Group$labelAbove
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$placeholder('e.g. 123456'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Auth$VerifyCode$FormUpdated, $elm$core$Basics$identity)),
													$author$project$Ui$Form$Input$invalid(hasValidationErrors),
													$author$project$Ui$Form$Input$value(code),
													$author$project$Ui$Form$Input$onBlur($author$project$Components$Auth$VerifyCode$CodeBlurred)
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 0, codeForm))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Sign in'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$fullWidth(true),
											$author$project$Ui$Button$disabled(
											A3($author$project$Components$Auth$VerifyCode$isSubmitDisabled, hasValidationErrors, processing, codeSubmitAttempts)),
											$author$project$Ui$Button$onClick($author$project$Components$Auth$VerifyCode$SubmitForm),
											$author$project$Ui$Button$loading(processing)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sign In')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Auth$VerifyCode$viewTermsText = A2(
	$author$project$Ui$Typography$span,
	_List_fromArray(
		[
			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('I agree with the ')
				])),
			A3(
			$author$project$Ui$Link$externalHref,
			$author$project$Utils$HintUrls$termsUrl,
			_List_fromArray(
				[$author$project$Ui$Link$targetBlank]),
			_List_fromArray(
				[
					$elm$html$Html$text('Terms')
				]))
		]));
var $author$project$Components$Auth$VerifyCode$view = function (model) {
	var _v0 = _Utils_Tuple2(model.Oo, model.sw);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var email = _v0.a.a;
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[$author$project$Ui$Panel$extraPadding]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mt4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text('Enter your code')
												])),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A6($author$project$Components$Auth$VerifyCode$viewForm, email, model.W7, model.sL, model.bp, model.ON, model.ls),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											$author$project$Components$Auth$VerifyCode$viewTermsText
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Login$viewComponents = F5(
	function (maybeEmail, maybeSalt, processingAction, requestCodeModel, verifyCodeModel) {
		return A2($author$project$Pages$Login$canShowVerifyCode, maybeEmail, maybeSalt) ? A2(
			$elm$html$Html$map,
			$author$project$Pages$Login$VerifyCodeMsg,
			$author$project$Components$Auth$VerifyCode$view(verifyCodeModel)) : A2(
			$elm$html$Html$map,
			$author$project$Pages$Login$RequestCodeMsg,
			A2($author$project$Components$Auth$RequestCode$view, requestCodeModel, processingAction));
	});
var $author$project$Ui$Link$CurrentColor = {$: 18};
var $author$project$Ui$Link$currentColor = $author$project$Ui$Link$CurrentColor;
var $author$project$Pages$Login$viewReCaptcha = A2(
	$author$project$Ui$Typography$p,
	_List_fromArray(
		[
			$author$project$Ui$Typography$muted,
			$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('This site is protected by reCAPTCHA and the Google ')
				])),
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$externalHref,
					'https://policies.google.com/privacy',
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank, $author$project$Ui$Link$currentColor]),
					_List_fromArray(
						[
							$elm$html$Html$text('Privacy Policy')
						]))
				])),
			A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(' and ')
				])),
			A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[
					$author$project$Ui$Typography$attrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline-block')
						]))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$externalHref,
					'https://policies.google.com/terms',
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank, $author$project$Ui$Link$currentColor]),
					_List_fromArray(
						[
							$elm$html$Html$text('Terms of Service')
						]))
				]))
		]));
var $author$project$Pages$Login$viewBody = function (model) {
	return model.abt ? A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(6),
								$author$project$Ui$FlexGrid$offset(3)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$mb4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[$author$project$Ui$FlexGrid$textCenter]),
										_List_fromArray(
											[
												A4(
												$author$project$Ui$Image$view,
												model.qT,
												{I1: 'Hint Logo'},
												_List_fromArray(
													[
														$author$project$Ui$Image$height(55)
													]),
												12)
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										_List_fromArray(
											[
												A5($author$project$Pages$Login$viewComponents, model.Oo, model.sw, model.W7, model.sp, model.eP)
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										_List_fromArray(
											[
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$author$project$Pages$Login$viewReCaptcha
											]))
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Login$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$Login$viewBody(model)
			]),
		$G: 'Login'
	};
};
var $author$project$Pages$Login$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$Login$init, aer: $author$project$Pages$Login$load, agD: $author$project$Pages$Login$save, ahd: $author$project$Pages$Login$subscriptions, aaq: $author$project$Pages$Login$update, ahP: $author$project$Pages$Login$view});
var $author$project$Spa$Page$element = function (page) {
	return {
		ad0: F2(
			function (_v0, params) {
				var _v1 = page.ad0(params);
				var model = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(model, cmd, _List_Nil);
			}),
		aer: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: page.ahd,
		aaq: F2(
			function (msg, model) {
				var _v2 = A2(page.aaq, msg, model);
				var newModel = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(newModel, cmd, _List_Nil);
			}),
		ahP: page.ahP
	};
};
var $author$project$Pages$Logout$init = function (_v0) {
	return _Utils_Tuple2(
		{},
		$author$project$Ports$Session$logout(
			{af6: true}));
};
var $author$project$Pages$Logout$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Logout$update = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Logout$view = function (_v0) {
	return {e5: $author$project$Components$LoadingPage$view, $G: 'Logout'};
};
var $author$project$Pages$Logout$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$Logout$init, ahd: $author$project$Pages$Logout$subscriptions, aaq: $author$project$Pages$Logout$update, ahP: $author$project$Pages$Logout$view});
var $author$project$Pages$Marketplace$Layer$Manage$Settings$GotLayerAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Layer$Manage$Settings$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{D5: shared.D5, lA: $elm$core$Maybe$Nothing, lW: $elm$core$Maybe$Nothing, yw: $author$project$Api$Data$Loading, WF: practice, ZD: session},
			A2($author$project$Api$Provider$Practice$LayerAccount$retrieve, shared.D5, $author$project$Pages$Marketplace$Layer$Manage$Settings$GotLayerAccount));
	});
var $author$project$Pages$Marketplace$Layer$Manage$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Layer$Manage$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Layer$Manage$Settings$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Marketplace$Layer$Manage$Settings$CreateFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Marketplace$Layer$Manage$Settings$EditFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Layer$Manage$Settings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var layerAccount = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										lA: $elm$core$Maybe$Nothing,
										lW: $elm$core$Maybe$Just(
											$author$project$Components$Layer$EditForm$init(layerAccount)),
										yw: response
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								var createForm = $author$project$Components$Layer$CreateForm$init(model.WF);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											lA: $elm$core$Maybe$Just(createForm),
											lW: $elm$core$Maybe$Nothing,
											yw: response
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{yw: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var createFormMsg = msg.a;
				var _v3 = model.lA;
				if (!_v3.$) {
					var createForm = _v3.a;
					var result = A3($author$project$Components$Layer$CreateForm$update, model.D5, createFormMsg, createForm);
					var refetchCmd = function () {
						var _v4 = result.l6;
						if (_v4.$ === 1) {
							return A2($author$project$Api$Provider$Practice$LayerAccount$retrieve, model.D5, $author$project$Pages$Marketplace$Layer$Manage$Settings$GotLayerAccount);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lA: $elm$core$Maybe$Just(result.y8)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Layer$Manage$Settings$CreateFormMsg, result.EC),
									refetchCmd
								])),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var editFormMsg = msg.a;
				var _v5 = model.lW;
				if (!_v5.$) {
					var editForm = _v5.a;
					var _v6 = A3($author$project$Components$Layer$EditForm$update, model.D5, editFormMsg, editForm);
					var newEditForm = _v6.a;
					var editFormCmd = _v6.b;
					var outMsgs = _v6.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								lW: $elm$core$Maybe$Just(newEditForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Layer$Manage$Settings$EditFormMsg, editFormCmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$LayerAccount$activate, model.D5, $author$project$Pages$Marketplace$Layer$Manage$Settings$GotLayerAccount),
					_List_Nil);
		}
	});
var $author$project$Pages$Marketplace$Layer$Manage$Settings$ActivateLayerAccount = {$: 3};
var $author$project$Pages$Marketplace$Layer$Manage$Settings$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple3(model.lA, model.lW, model.yw);
				if (!_v0.a.$) {
					var createForm = _v0.a.a;
					return A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Marketplace$Layer$Manage$Settings$CreateFormMsg,
										$author$project$Components$Layer$CreateForm$view(createForm))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Marketplace$Layer$Manage$Settings$CreateFormMsg,
										$author$project$Components$Layer$CreateForm$viewSubmitButton(createForm))
									]))
							]));
				} else {
					if (!_v0.b.$) {
						if (_v0.c.$ === 3) {
							var _v1 = _v0.a;
							var editForm = _v0.b.a;
							var _v2 = _v0.c;
							var layerAccount = _v2.a;
							return ($author$project$Api$Provider$LayerAccount$One$status(layerAccount) === 'onboarding') ? $author$project$Components$Layer$OnboardingForm$view($author$project$Pages$Marketplace$Layer$Manage$Settings$ActivateLayerAccount) : A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Marketplace$Layer$Manage$Settings$EditFormMsg,
												$author$project$Components$Layer$EditForm$view(editForm))
											]))
									]));
						} else {
							var _v3 = _v0.a;
							var editForm = _v0.b.a;
							return A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Marketplace$Layer$Manage$Settings$EditFormMsg,
												$author$project$Components$Layer$EditForm$view(editForm))
											]))
									]));
						}
					} else {
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						return $elm$html$Html$text('');
					}
				}
			}()
			]),
		$G: 'Layer Settings'
	};
};
var $author$project$Pages$Marketplace$Layer$Manage$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Marketplace$Layer$Manage$Settings$init, aer: $author$project$Pages$Marketplace$Layer$Manage$Settings$load, agD: $author$project$Pages$Marketplace$Layer$Manage$Settings$save, ahd: $author$project$Pages$Marketplace$Layer$Manage$Settings$subscriptions, aaq: $author$project$Pages$Marketplace$Layer$Manage$Settings$update, ahP: $author$project$Pages$Marketplace$Layer$Manage$Settings$view});
var $author$project$Pages$Marketplace$Manage$GotProducts = $elm$core$Basics$identity;
var $author$project$Api$Provider$Marketplace$Product$All$Product = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Common$Marketplace$Product$All$Product = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Marketplace$Product$All$Record = function (status) {
	return {ag7: status};
};
var $author$project$Api$Provider$Marketplace$Product$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Marketplace$Product$All$Record));
var $author$project$Api$Provider$Marketplace$Product$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Marketplace$Product$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Marketplace$Product$All$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Marketplace$Product$All$Product)));
var $author$project$Api$Provider$Marketplace$Product$productsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['marketplace', 'products']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Marketplace$Product$listManageable = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Marketplace$Product$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['managed']),
					$author$project$Api$Provider$Marketplace$Product$productsPath)));
	});
var $author$project$Pages$Marketplace$Manage$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{D5: shared.D5, yG: $author$project$Api$Data$Loading, WF: practice, ZD: session},
			A2($author$project$Api$Provider$Marketplace$Product$listManageable, shared.D5, $elm$core$Basics$identity));
	});
var $author$project$Pages$Marketplace$Manage$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Manage$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Manage$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Marketplace$Manage$update = F2(
	function (msg, model) {
		var response = msg;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{yG: response}),
			$elm$core$Platform$Cmd$none,
			$author$project$OutMsg$handleErrorResponse(response));
	});
var $author$project$Ui$Element$mb6 = $author$project$Ui$Element$Margin('mb-6');
var $author$project$Pages$Marketplace$Manage$productsColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', false, 'Product Name'),
		A3($author$project$Api$Column$init, 'type', false, 'Type'),
		A3($author$project$Api$Column$init, 'status', false, 'Status')
	]);
var $author$project$Ui$Table$alignCenter = $author$project$Ui$Table$VerticalCenteredCell;
var $author$project$Api$Common$Marketplace$Product$Shared$iconUrl = function (_v0) {
	var record = _v0;
	return record.QH;
};
var $author$project$Api$Common$Marketplace$Product$All$iconUrl = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(shared);
};
var $author$project$Api$Provider$Marketplace$Product$All$iconUrl = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$All$iconUrl(common);
};
var $author$project$Api$Common$Marketplace$Product$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Common$Marketplace$Product$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$name(shared);
};
var $author$project$Api$Provider$Marketplace$Product$All$name = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$All$name(common);
};
var $author$project$Api$Common$Marketplace$Product$Shared$slug = function (_v0) {
	var record = _v0;
	return record._c;
};
var $author$project$Api$Common$Marketplace$Product$All$slug = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$slug(shared);
};
var $author$project$Api$Provider$Marketplace$Product$All$slug = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$All$slug(common);
};
var $author$project$Api$Provider$Marketplace$Product$All$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Api$Common$Marketplace$Product$ProductType$toLabel = function (type_) {
	switch (type_) {
		case 0:
			return 'App';
		case 1:
			return 'Integration';
		default:
			return 'Solution';
	}
};
var $author$project$Api$Common$Marketplace$Product$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Common$Marketplace$Product$All$type_ = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Common$Marketplace$Product$Shared$type_(shared);
};
var $author$project$Api$Provider$Marketplace$Product$All$type_ = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$All$type_(common);
};
var $author$project$Pages$Marketplace$Manage$viewProductRow = function (product) {
	var productName = $author$project$Api$Provider$Marketplace$Product$All$name(product);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$alignCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								function () {
								var _v0 = $author$project$Api$Provider$Marketplace$Product$All$iconUrl(product);
								if (!_v0.$) {
									var url = _v0.a;
									return A3(
										$author$project$Ui$Image$fromSrc,
										{I1: productName + ' icon'},
										url,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(32)
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Marketplace__Slug_String(
									{
										_c: $author$project$Api$Provider$Marketplace$Product$All$slug(product)
									}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(productName)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$alignCenter]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Common$Marketplace$Product$ProductType$toLabel(
							$author$project$Api$Provider$Marketplace$Product$All$type_(product)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$alignCenter]),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$html$Html$text(''),
						A2(
							$elm$core$Maybe$map,
							$author$project$Ui$Badge$fromString(_List_Nil),
							$author$project$Api$Provider$Marketplace$Product$All$status(product)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				_List_fromArray(
					[
						function () {
						var _v1 = $author$project$Api$Provider$Marketplace$Product$All$type_(product);
						if (!_v1) {
							return A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings(
									{
										_c: $author$project$Api$Provider$Marketplace$Product$All$slug(product)
									}),
								_List_fromArray(
									[$author$project$Ui$Link$buttonDefault, $author$project$Ui$Link$sm]),
								_List_fromArray(
									[
										$elm$html$Html$text('Manage')
									]));
						} else {
							var _v2 = $author$project$Api$Provider$Marketplace$Product$All$slug(product);
							if (_v2 === 'layer') {
								return A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Marketplace__Layer__Manage__Settings,
									_List_fromArray(
										[$author$project$Ui$Link$buttonDefault, $author$project$Ui$Link$sm]),
									_List_fromArray(
										[
											$elm$html$Html$text('Manage')
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}
					}()
					]))
			]));
};
var $author$project$Pages$Marketplace$Manage$viewPartners = function (model) {
	var _v0 = function () {
		var _v1 = model.yG;
		if (_v1.$ === 3) {
			var products_ = _v1.a;
			return _Utils_Tuple2(false, products_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var products = _v0.b;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('There are no installed partners')
							])),
						$author$project$Ui$Table$loading(loading)
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
							$author$project$Pages$Marketplace$Manage$productsColumns),
							_List_fromArray(
							[
								A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
							])
						])),
				A2($elm$core$List$map, $author$project$Pages$Marketplace$Manage$viewProductRow, products),
				_List_Nil)
			]));
};
var $author$project$Pages$Marketplace$Manage$viewBody = function (model) {
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Element$custom,
			'layout-header h-24',
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb6]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$heading(
							_List_fromArray(
								[
									$elm$html$Html$text('Manage Partners')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Marketplace__Top,
							_List_fromArray(
								[$author$project$Ui$Link$buttonDefault]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Marketplace')
								]))
						]))
				])),
			$author$project$Pages$Marketplace$Manage$viewPartners(model)
		]);
};
var $author$project$Pages$Marketplace$Manage$view = function (model) {
	return {
		e5: $author$project$Pages$Marketplace$Manage$viewBody(model),
		$G: 'Marketplace | Manage'
	};
};
var $author$project$Pages$Marketplace$Manage$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Marketplace$Manage$init, aer: $author$project$Pages$Marketplace$Manage$load, agD: $author$project$Pages$Marketplace$Manage$save, ahd: $author$project$Pages$Marketplace$Manage$subscriptions, aaq: $author$project$Pages$Marketplace$Manage$update, ahP: $author$project$Pages$Marketplace$Manage$view});
var $author$project$Pages$Marketplace$Slug_String$ProductMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Platform$Session$One$organizationIsPartner = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq(2),
			A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.Vd)));
};
var $author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_product_documents']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath);
};
var $author$project$Api$Partner$PartnerProductDocument$signedFileUrl = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_file_url']),
					$author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath(id))));
	});
var $author$project$Api$Provider$Marketplace$Product$productPath = function (slug) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[slug]),
		$author$project$Api$Provider$Marketplace$Product$productsPath);
};
var $author$project$Api$Provider$Marketplace$Product$Document$documentsPath = function (slug) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['documents']),
		$author$project$Api$Provider$Marketplace$Product$productPath(slug));
};
var $author$project$Api$Provider$Marketplace$Product$Document$documentPath = F2(
	function (slug, documentId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[documentId]),
			$author$project$Api$Provider$Marketplace$Product$Document$documentsPath(slug));
	});
var $author$project$Api$Provider$Marketplace$Product$Document$signedUrl = F4(
	function (apiClient, slug, documentId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_url']),
					A2($author$project$Api$Provider$Marketplace$Product$Document$documentPath, slug, documentId))));
	});
var $author$project$Pages$Marketplace$Slug_String$fetchDocumentSignedUrl = F5(
	function (session, apiClient, slug, documentId, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? A3($author$project$Api$Partner$PartnerProductDocument$signedFileUrl, apiClient, documentId, toMsg) : A4($author$project$Api$Provider$Marketplace$Product$Document$signedUrl, apiClient, slug, documentId, toMsg);
	});
var $author$project$Pages$Marketplace$Slug_String$GotProviderPractice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$fetchPractice = F2(
	function (apiClient, session) {
		return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$Marketplace$Slug_String$GotProviderPractice);
	});
var $author$project$Pages$Marketplace$Slug_String$GotPartnerMarketplaceProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$GotProviderMarketplaceProduct = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Marketplace$Product$One$Product = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$One$Product = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Common$Marketplace$Product$One$Record = function (partnerId) {
	return function (overview) {
		return function (highlights) {
			return function (quotes) {
				return function (links) {
					return function (dataFlows) {
						return function (categories) {
							return function (composedCtaUrl) {
								return function (partnerProductDocuments) {
									return function (preconditions) {
										return {KL: categories, LF: composedCtaUrl, MN: dataFlows, Qr: highlights, SX: links, Vn: overview, VD: partnerId, VF: partnerProductDocuments, WT: preconditions, XI: quotes};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Common$Marketplace$Product$DataFlow$DataFlow = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$DataFlow$Record = F3(
	function (hintName, partnerName, syncDirection) {
		return {Qx: hintName, VE: partnerName, $h: syncDirection};
	});
var $author$project$Api$Common$Marketplace$Product$DataFlow$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sync_direction',
		$author$project$Api$Common$Marketplace$Product$SyncDirection$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'partner_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'hint_name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$DataFlow$Record)))));
var $author$project$Api$Common$Marketplace$Product$Document$Document = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Document$Record = F4(
	function (id, title, documentType, url) {
		return {NZ: documentType, adR: id, $G: title, aav: url};
	});
var $author$project$Api$Common$Marketplace$Product$Document$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'document_type',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Document$Record)))));
var $author$project$Api$Common$Marketplace$Product$Document$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Document$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Highlight$Highlight = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Highlight$Record = F3(
	function (title, description, imageUrl) {
		return {Nx: description, QN: imageUrl, $G: title};
	});
var $author$project$Api$Common$Marketplace$Product$Highlight$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Highlight$Record))));
var $author$project$Api$Common$Marketplace$Product$Highlight$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Highlight$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Link$Link = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Link$Record = F4(
	function (title, linkType, value, composedUrl) {
		return {LG: composedUrl, SV: linkType, $G: title, aaN: value};
	});
var $author$project$Api$Common$Marketplace$Product$Link$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'composed_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'value',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'link_type',
			$author$project$Api$Common$Marketplace$Product$LinkType$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Link$Record)))));
var $author$project$Api$Common$Marketplace$Product$Link$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Link$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Overview$Overview = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Overview$Record = F2(
	function (description, images) {
		return {Nx: description, QO: images};
	});
var $author$project$Api$Common$Marketplace$Product$ProductImage$ProductImage = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$ProductImage$Record = F2(
	function (fileUrl, alt) {
		return {I1: alt, Po: fileUrl};
	});
var $author$project$Api$Common$Marketplace$Product$ProductImage$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'alt',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'file_url',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$ProductImage$Record)));
var $author$project$Api$Common$Marketplace$Product$ProductImage$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$ProductImage$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Overview$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'images',
	$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$ProductImage$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Overview$Record)));
var $author$project$Api$Common$Marketplace$Product$Overview$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Overview$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$Precondition$Precondition = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Precondition$Record = F3(
	function (id, type_, url) {
		return {adR: id, ahI: type_, aav: url};
	});
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$ExternalAccount = 1;
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$ExternalInstall = 0;
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'external_install':
				return $elm$json$Json$Decode$succeed(0);
			case 'external_account':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknown precondition type: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$Precondition$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Api$Common$Marketplace$Product$Precondition$Type$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Precondition$Record)))));
var $author$project$Api$Common$Marketplace$Product$Quote$Quote = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$Quote$Record = F4(
	function (text, author, authorTitle, authorImageUrl) {
		return {Jz: author, JA: authorImageUrl, JB: authorTitle, $A: text};
	});
var $author$project$Api$Common$Marketplace$Product$Quote$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'author_image_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'author_title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'author',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'text',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Quote$Record)))));
var $author$project$Api$Common$Marketplace$Product$Quote$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Quote$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Common$Marketplace$Product$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'preconditions',
	$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Precondition$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'partner_product_documents',
		$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Document$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'composed_cta_url',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'categories',
				$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'data_flows',
					$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$DataFlow$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'links',
						$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Link$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'quotes',
							$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Quote$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'highlights',
								$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Highlight$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'overview',
									$elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Overview$decoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$One$Record)))))))))));
var $author$project$Api$Common$Marketplace$Product$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Marketplace$Product$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$One$Product)));
var $author$project$Api$Partner$Marketplace$Product$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Marketplace$Product$productsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['marketplace', 'products']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Marketplace$Product$productPath = function (slug) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[slug]),
		$author$project$Api$Partner$Marketplace$Product$productsPath);
};
var $author$project$Api$Partner$Marketplace$Product$retrieve = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$Marketplace$Product$productPath(slug)));
	});
var $author$project$Api$Provider$Marketplace$Product$One$Product = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Marketplace$Product$One$Record = F4(
	function (status, engagementStatus, betaAccess, installMeta) {
		return {JU: betaAccess, OB: engagementStatus, Q1: installMeta, ag7: status};
	});
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Other = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$AttemptInstall = {$: 3};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted = {$: 2};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested = {$: 4};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested = {$: 1};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted = {$: 0};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString = function (string) {
	switch (string) {
		case 'waitlisted':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted);
		case 'interested':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested);
		case 'beta_access_granted':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted);
		case 'attempt_install':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$AttemptInstall);
		case 'install_requested':
			return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder = A2(
	$elm$json$Json$Decode$map,
	function (string) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Common$Marketplace$Product$Engagement$Status$Other(string),
			$author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString(string));
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$InstallMeta$InstallMeta = $elm$core$Basics$identity;
var $author$project$Api$Common$Marketplace$Product$InstallMeta$Record = F3(
	function (enabled, reason, missingRequirements) {
		return {Ot: enabled, T6: missingRequirements, XP: reason};
	});
var $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingFeature = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingTier = {$: 1};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr = {$: 0};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString = function (string) {
	if (string === 'emr') {
		return $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr;
	} else {
		return $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Other(string);
	}
};
var $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirementDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		if (type_ === 'feature') {
			return A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeL, $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingFeature, $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString),
				A2($elm$json$Json$Decode$field, 'feature', $elm$json$Json$Decode$string));
		} else {
			return A2(
				$elm$json$Json$Decode$map,
				$elm$core$Basics$always($author$project$Api$Common$Marketplace$Product$InstallMeta$MissingTier),
				A2($elm$json$Json$Decode$field, 'starting_tier', $elm$json$Json$Decode$string));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Api$Common$Marketplace$Product$InstallMeta$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'missing_requirements',
		$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirementDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reason',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'enabled',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$InstallMeta$Record)))));
var $author$project$Api$Provider$Marketplace$Product$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'meta',
	$elm$json$Json$Decode$nullable(
		A2($elm$json$Json$Decode$field, 'install', $author$project$Api$Common$Marketplace$Product$InstallMeta$decoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'beta_access',
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(false),
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool)),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'engagement_status',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Marketplace$Product$One$Record)))));
var $author$project$Api$Provider$Marketplace$Product$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Marketplace$Product$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Common$Marketplace$Product$One$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Marketplace$Product$One$Product)));
var $author$project$Api$Provider$Marketplace$Product$retrieve = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Marketplace$Product$productPath(slug)));
	});
var $author$project$Pages$Marketplace$Slug_String$fetchProduct = F3(
	function (apiClient, session, slug) {
		return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? A3($author$project$Api$Partner$Marketplace$Product$retrieve, apiClient, slug, $author$project$Pages$Marketplace$Slug_String$GotPartnerMarketplaceProduct) : A3($author$project$Api$Provider$Marketplace$Product$retrieve, apiClient, slug, $author$project$Pages$Marketplace$Slug_String$GotProviderMarketplaceProduct);
	});
var $author$project$Components$Marketplace$Product$CallToActionMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$init = function (_v0) {
	var isAdmin = _v0.Ru;
	var toMsg = _v0.ahx;
	var fetchDocumentSignedUrl = _v0.Pj;
	return {dm: $elm$core$Set$empty, dn: $elm$core$Set$empty, bI: $elm$core$Maybe$Nothing, dD: $elm$core$Maybe$Nothing, Pj: fetchDocumentSignedUrl, Ru: isAdmin, S_: false, WF: $elm$core$Maybe$Nothing, W8: $elm$core$Maybe$Nothing, ahx: toMsg};
};
var $author$project$Components$Marketplace$Product$Overview$CarouselMsg = $elm$core$Basics$identity;
var $author$project$Components$Marketplace$Product$Overview$Model = $elm$core$Basics$identity;
var $author$project$Components$Carousel$Model = F2(
	function (index, toMsg) {
		return {x4: index, ahx: toMsg};
	});
var $author$project$Components$Carousel$init = $author$project$Components$Carousel$Model(0);
var $author$project$Components$Marketplace$Product$Overview$init = function (overview) {
	return {
		pO: $author$project$Components$Carousel$init($elm$core$Basics$identity),
		Vn: overview
	};
};
var $author$project$Components$Marketplace$Product$Quotes$CarouselMsg = $elm$core$Basics$identity;
var $author$project$Components$Marketplace$Product$Quotes$Model = $elm$core$Basics$identity;
var $author$project$Components$Marketplace$Product$Quotes$init = function (quotes) {
	return {
		pO: $author$project$Components$Carousel$init($elm$core$Basics$identity),
		XI: quotes
	};
};
var $author$project$Components$Marketplace$Product$init = function (_v0) {
	var isAdmin = _v0.Ru;
	var imageStore = _v0.qT;
	var fetchDocumentSignedUrl = _v0.Pj;
	return _Utils_Tuple2(
		{
			bR: $author$project$Components$Marketplace$Product$CallToAction$init(
				{Pj: fetchDocumentSignedUrl, Ru: isAdmin, ahx: $author$project$Components$Marketplace$Product$CallToActionMsg}),
			qT: imageStore,
			Vn: $author$project$Components$Marketplace$Product$Overview$init($elm$core$Maybe$Nothing),
			W8: $elm$core$Maybe$Nothing,
			XI: $author$project$Components$Marketplace$Product$Quotes$init(_List_Nil)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Marketplace$Slug_String$init = F3(
	function (session, shared, _v0) {
		var params = _v0.Vx;
		var _v1 = $author$project$Components$Marketplace$Product$init(
			{
				Pj: $author$project$Pages$Marketplace$Slug_String$fetchDocumentSignedUrl(session),
				qT: shared.qT,
				Ru: $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session)
			});
		var product = _v1.a;
		var productCmd = _v1.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				FR: $author$project$Shared$isHintAdmin(shared),
				rA: false,
				VD: $elm$core$Maybe$Nothing,
				W8: product,
				ZD: session,
				_c: params._c
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$ProductMsg, productCmd),
						A3($author$project$Pages$Marketplace$Slug_String$fetchProduct, shared.D5, session, params._c),
						A2($author$project$Pages$Marketplace$Slug_String$fetchPractice, shared.D5, session)
					])));
	});
var $author$project$Pages$Marketplace$Slug_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Slug_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled = {$: 3};
var $author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled = {$: 10};
var $author$project$Components$Marketplace$Product$CallToAction$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled)),
					model.bI)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled)),
					model.dD))
			]));
};
var $author$project$Components$Marketplace$Product$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Marketplace$Product$CallToActionMsg,
		$author$project$Components$Marketplace$Product$CallToAction$subscriptions(model.bR));
};
var $author$project$Pages$Marketplace$Slug_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Marketplace$Slug_String$ProductMsg,
		$author$project$Components$Marketplace$Product$subscriptions(model.W8));
};
var $author$project$Api$Common$Marketplace$Product$One$partnerId = function (_v0) {
	var record = _v0.b;
	return record.VD;
};
var $author$project$Api$Partner$Marketplace$Product$One$partnerId = function (_v0) {
	var common = _v0;
	return $author$project$Api$Common$Marketplace$Product$One$partnerId(common);
};
var $author$project$Api$Provider$Marketplace$Product$One$partnerId = function (_v0) {
	var common = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$One$partnerId(common);
};
var $author$project$Api$Common$Marketplace$Product$ProductImage$alt = function (_v0) {
	var record = _v0;
	return record.I1;
};
var $author$project$Api$Common$Marketplace$Product$Quote$author = function (_v0) {
	var record = _v0;
	return record.Jz;
};
var $author$project$Api$Common$Marketplace$Product$Quote$authorImageUrl = function (_v0) {
	var record = _v0;
	return record.JA;
};
var $author$project$Api$Common$Marketplace$Product$Quote$authorTitle = function (_v0) {
	var record = _v0;
	return record.JB;
};
var $author$project$Api$Common$Marketplace$Product$Shared$builtByName = function (_v0) {
	var record = _v0;
	return record.Kd;
};
var $author$project$Api$Common$Marketplace$Product$One$builtByName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$builtByName(shared);
};
var $author$project$Api$Common$Marketplace$Product$Shared$builtByUrl = function (_v0) {
	var record = _v0;
	return record.Ke;
};
var $author$project$Api$Common$Marketplace$Product$One$builtByUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$builtByUrl(shared);
};
var $author$project$Api$Common$Marketplace$Product$One$categories = function (_v0) {
	var record = _v0.b;
	return record.KL;
};
var $author$project$Api$Common$Marketplace$Product$One$composedCtaUrl = function (_v0) {
	var record = _v0.b;
	return record.LF;
};
var $author$project$Api$Common$Marketplace$Product$Link$composedUrl = function (_v0) {
	var record = _v0;
	return record.LG;
};
var $author$project$Api$Common$Marketplace$Product$One$dataFlows = function (_v0) {
	var record = _v0.b;
	return record.MN;
};
var $author$project$Api$Common$Marketplace$Product$Highlight$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Common$Marketplace$Product$Overview$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Common$Marketplace$Product$Shared$distributionType = function (_v0) {
	var record = _v0;
	return record.NS;
};
var $author$project$Api$Common$Marketplace$Product$One$distributionType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$distributionType(shared);
};
var $author$project$Api$Common$Marketplace$Product$Document$documentType = function (_v0) {
	var record = _v0;
	return record.NZ;
};
var $author$project$Api$Common$Marketplace$Product$Shared$featured = function (_v0) {
	var record = _v0;
	return record.Pc;
};
var $author$project$Api$Common$Marketplace$Product$One$featured = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$featured(shared);
};
var $author$project$Api$Common$Marketplace$Product$ProductImage$fileUrl = function (_v0) {
	var record = _v0;
	return record.Po;
};
var $author$project$Api$Common$Marketplace$Product$One$highlights = function (_v0) {
	var record = _v0.b;
	return record.Qr;
};
var $author$project$Api$Common$Marketplace$Product$DataFlow$hintName = function (_v0) {
	var record = _v0;
	return record.Qx;
};
var $author$project$Api$Common$Marketplace$Product$One$iconUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(shared);
};
var $author$project$Api$Common$Marketplace$Product$Document$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Common$Marketplace$Product$Highlight$imageUrl = function (_v0) {
	var record = _v0;
	return record.QN;
};
var $author$project$Api$Common$Marketplace$Product$Overview$images = function (_v0) {
	var record = _v0;
	return record.QO;
};
var $author$project$Api$Common$Marketplace$Product$Link$linkType = function (_v0) {
	var record = _v0;
	return record.SV;
};
var $author$project$Api$Common$Marketplace$Product$One$links = function (_v0) {
	var record = _v0.b;
	return record.SX;
};
var $author$project$Api$Common$Marketplace$Product$Shared$listingStatus = function (_v0) {
	var record = _v0;
	return record.SZ;
};
var $author$project$Api$Common$Marketplace$Product$One$listingStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$listingStatus(shared);
};
var $author$project$Api$Common$Marketplace$Product$Category$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Common$Marketplace$Product$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$name(shared);
};
var $author$project$Api$Common$Marketplace$Product$One$overview = function (_v0) {
	var record = _v0.b;
	return record.Vn;
};
var $author$project$Api$Common$Marketplace$Product$DataFlow$partnerName = function (_v0) {
	var record = _v0;
	return record.VE;
};
var $author$project$Api$Common$Marketplace$Product$One$partnerProductDocuments = function (_v0) {
	var record = _v0.b;
	return record.VF;
};
var $author$project$Api$Common$Marketplace$Product$One$preconditions = function (_v0) {
	var record = _v0.b;
	return record.WT;
};
var $author$project$Api$Common$Marketplace$Product$One$quotes = function (_v0) {
	var record = _v0.b;
	return record.XI;
};
var $author$project$Api$Common$Marketplace$Product$One$slug = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$slug(shared);
};
var $author$project$Api$Common$Marketplace$Product$Shared$summary = function (_v0) {
	var record = _v0;
	return record._9;
};
var $author$project$Api$Common$Marketplace$Product$One$summary = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$summary(shared);
};
var $author$project$Api$Common$Marketplace$Product$DataFlow$syncDirection = function (_v0) {
	var record = _v0;
	return record.$h;
};
var $author$project$Api$Common$Marketplace$Product$Quote$text = function (_v0) {
	var record = _v0;
	return record.$A;
};
var $author$project$Api$Common$Marketplace$Product$Document$title = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Api$Common$Marketplace$Product$Highlight$title = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Api$Common$Marketplace$Product$Link$title = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Api$Common$Marketplace$Product$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Common$Marketplace$Product$Shared$type_(shared);
};
var $author$project$Api$Common$Marketplace$Product$Document$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Api$Common$Marketplace$Product$Link$value = function (_v0) {
	var record = _v0;
	return record.aaN;
};
var $author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded = function (marketplaceProduct) {
	return {
		JU: false,
		Kd: $author$project$Api$Common$Marketplace$Product$One$builtByName(marketplaceProduct),
		Ke: $author$project$Api$Common$Marketplace$Product$One$builtByUrl(marketplaceProduct),
		KL: A2(
			$elm$core$List$map,
			function (cat) {
				return {
					zh: $author$project$Api$Common$Marketplace$Product$Category$name(cat)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$categories(marketplaceProduct)),
		LF: $author$project$Api$Common$Marketplace$Product$One$composedCtaUrl(marketplaceProduct),
		MN: A2(
			$elm$core$List$map,
			function (df) {
				return {
					Qx: $author$project$Api$Common$Marketplace$Product$DataFlow$hintName(df),
					VE: $author$project$Api$Common$Marketplace$Product$DataFlow$partnerName(df),
					$h: $author$project$Api$Common$Marketplace$Product$DataFlow$syncDirection(df)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$dataFlows(marketplaceProduct)),
		NS: $author$project$Api$Common$Marketplace$Product$One$distributionType(marketplaceProduct),
		OB: $elm$core$Maybe$Nothing,
		Pc: $author$project$Api$Common$Marketplace$Product$One$featured(marketplaceProduct),
		Qr: A2(
			$elm$core$List$map,
			function (hl) {
				return {
					Nx: $author$project$Api$Common$Marketplace$Product$Highlight$description(hl),
					QN: $author$project$Api$Common$Marketplace$Product$Highlight$imageUrl(hl),
					$G: $author$project$Api$Common$Marketplace$Product$Highlight$title(hl)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$highlights(marketplaceProduct)),
		QH: $author$project$Api$Common$Marketplace$Product$One$iconUrl(marketplaceProduct),
		Q1: $elm$core$Maybe$Nothing,
		SX: A2(
			$elm$core$List$map,
			function (l) {
				return {
					LG: $author$project$Api$Common$Marketplace$Product$Link$composedUrl(l),
					SV: $author$project$Api$Common$Marketplace$Product$Link$linkType(l),
					$G: $author$project$Api$Common$Marketplace$Product$Link$title(l),
					aaN: $author$project$Api$Common$Marketplace$Product$Link$value(l)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$links(marketplaceProduct)),
		SZ: $author$project$Api$Common$Marketplace$Product$One$listingStatus(marketplaceProduct),
		zh: $author$project$Api$Common$Marketplace$Product$One$name(marketplaceProduct),
		Vn: A2(
			$elm$core$Maybe$map,
			function (overview) {
				return {
					Nx: $author$project$Api$Common$Marketplace$Product$Overview$description(overview),
					QO: A2(
						$elm$core$List$map,
						function (img) {
							return {
								I1: A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Common$Marketplace$Product$ProductImage$alt(img)),
								aav: $author$project$Api$Common$Marketplace$Product$ProductImage$fileUrl(img)
							};
						},
						$author$project$Api$Common$Marketplace$Product$Overview$images(overview))
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$overview(marketplaceProduct)),
		VF: A2(
			$elm$core$List$map,
			function (doc) {
				return {
					NZ: $author$project$Api$Common$Marketplace$Product$Document$documentType(doc),
					adR: $author$project$Api$Common$Marketplace$Product$Document$id(doc),
					$G: $author$project$Api$Common$Marketplace$Product$Document$title(doc),
					aav: $author$project$Api$Common$Marketplace$Product$Document$url(doc)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$partnerProductDocuments(marketplaceProduct)),
		WT: $author$project$Api$Common$Marketplace$Product$One$preconditions(marketplaceProduct),
		XI: A2(
			$elm$core$List$map,
			function (q) {
				return {
					Jz: $author$project$Api$Common$Marketplace$Product$Quote$author(q),
					JA: $author$project$Api$Common$Marketplace$Product$Quote$authorImageUrl(q),
					JB: $author$project$Api$Common$Marketplace$Product$Quote$authorTitle(q),
					$A: $author$project$Api$Common$Marketplace$Product$Quote$text(q)
				};
			},
			$author$project$Api$Common$Marketplace$Product$One$quotes(marketplaceProduct)),
		_c: $author$project$Api$Common$Marketplace$Product$One$slug(marketplaceProduct),
		ag7: $elm$core$Maybe$Nothing,
		_9: $author$project$Api$Common$Marketplace$Product$One$summary(marketplaceProduct),
		ahI: $author$project$Api$Common$Marketplace$Product$One$type_(marketplaceProduct)
	};
};
var $author$project$Api$Partner$Marketplace$Product$One$toCommon = function (_v0) {
	var common = _v0;
	return common;
};
var $author$project$Pages$Marketplace$Slug_String$partnerMarketplaceProductToProductExpanded = function (marketplaceProduct) {
	return $author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded(
		$author$project$Api$Partner$Marketplace$Product$One$toCommon(marketplaceProduct));
};
var $author$project$Api$Provider$Marketplace$Product$One$betaAccess = function (_v0) {
	var record = _v0.b;
	return record.JU;
};
var $author$project$Api$Provider$Marketplace$Product$One$engagementStatus = function (_v0) {
	var record = _v0.b;
	return record.OB;
};
var $author$project$Api$Provider$Marketplace$Product$One$installMeta = function (_v0) {
	var record = _v0.b;
	return record.Q1;
};
var $author$project$Api$Provider$Marketplace$Product$One$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Api$Provider$Marketplace$Product$One$toCommon = function (_v0) {
	var common = _v0.a;
	return common;
};
var $author$project$Pages$Marketplace$Slug_String$providerMarketplaceProductToProductExpanded = function (marketplaceProduct) {
	return function (expanded) {
		return _Utils_update(
			expanded,
			{
				JU: $author$project$Api$Provider$Marketplace$Product$One$betaAccess(marketplaceProduct),
				OB: $author$project$Api$Provider$Marketplace$Product$One$engagementStatus(marketplaceProduct),
				Q1: $author$project$Api$Provider$Marketplace$Product$One$installMeta(marketplaceProduct),
				ag7: $author$project$Api$Provider$Marketplace$Product$One$status(marketplaceProduct)
			});
	}(
		$author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded(
			$author$project$Api$Provider$Marketplace$Product$One$toCommon(marketplaceProduct)));
};
var $author$project$Components$Marketplace$Product$CallToAction$setPractice = F2(
	function (practice, model) {
		return _Utils_update(
			model,
			{
				WF: $elm$core$Maybe$Just(practice)
			});
	});
var $author$project$Components$Marketplace$Product$setPractice = F2(
	function (practice, model) {
		return _Utils_update(
			model,
			{
				bR: A2($author$project$Components$Marketplace$Product$CallToAction$setPractice, practice, model.bR)
			});
	});
var $author$project$Components$Marketplace$Product$CallToAction$setProduct = F2(
	function (product, model) {
		return _Utils_update(
			model,
			{
				W8: $elm$core$Maybe$Just(product)
			});
	});
var $author$project$Components$Marketplace$Product$toCallToActionProduct = function (product) {
	return {JU: product.JU, LF: product.LF, NS: product.NS, OB: product.OB, Q1: product.Q1, SZ: product.SZ, zh: product.zh, VF: product.VF, WT: product.WT, _c: product._c, ag7: product.ag7, ahI: product.ahI};
};
var $author$project$Components$Marketplace$Product$setProduct = F2(
	function (product, model) {
		var quotes = $author$project$Components$Marketplace$Product$Quotes$init(product.XI);
		var overview = $author$project$Components$Marketplace$Product$Overview$init(product.Vn);
		return _Utils_update(
			model,
			{
				bR: A2(
					$author$project$Components$Marketplace$Product$CallToAction$setProduct,
					$author$project$Components$Marketplace$Product$toCallToActionProduct(product),
					model.bR),
				Vn: overview,
				W8: $elm$core$Maybe$Just(product),
				XI: quotes
			});
	});
var $author$project$Components$Marketplace$Product$None = 0;
var $author$project$Components$Marketplace$Product$OverviewMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Marketplace$Product$ProductActivated = 1;
var $author$project$Components$Marketplace$Product$ProductDeactivated = 3;
var $author$project$Components$Marketplace$Product$ProductEngagementUpdated = 4;
var $author$project$Components$Marketplace$Product$ProductInstallRequested = 5;
var $author$project$Components$Marketplace$Product$ProductPartnerActivated = 2;
var $author$project$Components$Marketplace$Product$QuotesMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$Activated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Marketplace$Product$CallToAction$BetaAccessRequested = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$Deactivated = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Marketplace$Product$CallToAction$GotPdfDocumentSignedUrl = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$InstallAttempted = {$: 1};
var $author$project$Components$Marketplace$Product$CallToAction$InstallRequested = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$InterestExpressed = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$None = 0;
var $author$project$Components$Marketplace$Product$CallToAction$PartnerActivated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$ProductActivated = 1;
var $author$project$Components$Marketplace$Product$CallToAction$ProductDeactivated = 3;
var $author$project$Components$Marketplace$Product$CallToAction$ProductEngagementUpdated = 4;
var $author$project$Components$Marketplace$Product$CallToAction$ProductInstallRequested = 5;
var $author$project$Components$Marketplace$Product$CallToAction$ProductPartnerActivated = 2;
var $author$project$Api$Provider$Marketplace$Product$expressInterest = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['express_interest']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$Product = $elm$core$Basics$identity;
var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'integration',
	$author$project$Api$Provider$Integration$One$decoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Marketplace$Product$One$decoder,
		$elm$json$Json$Decode$succeed(
			F2(
				function (_v0, inte) {
					return inte;
				}))));
var $author$project$Api$Provider$Marketplace$Product$install = F4(
	function (apiClient, slug, partnerProductDocumentIds, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_document_ids',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, partnerProductDocumentIds))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['install']),
						$author$project$Api$Provider$Marketplace$Product$productPath(slug)))));
	});
var $author$project$Api$Provider$Marketplace$Product$installAttempted = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['attempt_install']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$integration = function (_v0) {
	var i = _v0;
	return i;
};
var $author$project$Api$Provider$Marketplace$Product$requestBeta = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['request_beta_access']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Api$Provider$Marketplace$Product$requestInstall = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['request_install']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Api$Provider$Marketplace$Product$uninstall = F3(
	function (apiClient, slug, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['uninstall']),
					$author$project$Api$Provider$Marketplace$Product$productPath(slug))));
	});
var $author$project$Components$Marketplace$Product$CallToAction$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var product = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dm: $elm$core$Set$empty,
							dn: $elm$core$Set$empty,
							bI: $elm$core$Maybe$Just(
								_Utils_Tuple2(product, $author$project$Api$Data$NotAsked))
						}),
					A3(
						$author$project$Api$Provider$Marketplace$Product$installAttempted,
						apiClient,
						product._c,
						$elm$core$Basics$always($author$project$Components$Marketplace$Product$CallToAction$InstallAttempted)),
					0);
			case 1:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 0);
			case 2:
				var product = msg.a;
				var documentIds = A2(
					$elm$core$List$map,
					function ($) {
						return $.adR;
					},
					product.VF);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bI: $elm$core$Maybe$Just(
								_Utils_Tuple2(product, $author$project$Api$Data$Loading))
						}),
					A4(
						$author$project$Api$Provider$Marketplace$Product$install,
						apiClient,
						product._c,
						documentIds,
						$author$project$Components$Marketplace$Product$CallToAction$Activated(product)),
					0);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dm: $elm$core$Set$empty, dn: $elm$core$Set$empty, bI: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					0);
			case 4:
				var documentId = msg.a;
				var checked = msg.b;
				var acceptedDocumentIds = checked ? A2($elm$core$Set$insert, documentId, model.dm) : A2($elm$core$Set$remove, documentId, model.dm);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dm: acceptedDocumentIds}),
					$elm$core$Platform$Cmd$none,
					0);
			case 5:
				var preconditionId = msg.a;
				var checked = msg.b;
				var acceptedPreconditionIds = checked ? A2($elm$core$Set$insert, preconditionId, model.dn) : A2($elm$core$Set$remove, preconditionId, model.dn);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dn: acceptedPreconditionIds}),
					$elm$core$Platform$Cmd$none,
					0);
			case 6:
				var product = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var installedProduct = response.a;
					var integration = $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$integration(installedProduct);
					var cmd = function () {
						var _v2 = _Utils_Tuple3(
							$author$project$Api$Provider$Integration$One$authType(integration),
							$author$project$Api$Provider$Integration$One$connectionUrl(integration),
							$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
						_v2$0:
						while (true) {
							_v2$3:
							while (true) {
								_v2$4:
								while (true) {
									switch (_v2.a) {
										case 'automatic_redirect':
											if (!_v2.c.$) {
												if (!_v2.b.$) {
													break _v2$0;
												} else {
													break _v2$3;
												}
											} else {
												if (!_v2.b.$) {
													break _v2$0;
												} else {
													break _v2$4;
												}
											}
										case 'automatic_headless':
											return A3(
												$author$project$Api$Provider$Integration$connect,
												apiClient,
												$author$project$Api$Provider$Integration$One$id(integration),
												$author$project$Components$Marketplace$Product$CallToAction$PartnerActivated);
										case 'manual':
											return A2(
												$elm$core$List$member,
												$author$project$Api$Provider$Integration$One$status(integration),
												_List_fromArray(
													['pending', 'inactive'])) ? A2(
												$author$project$Utils$Route$navigate,
												$elm$core$Dict$empty,
												$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
													{_c: product._c})) : $elm$core$Platform$Cmd$none;
										default:
											if (!_v2.c.$) {
												break _v2$3;
											} else {
												break _v2$4;
											}
									}
								}
								var _v3 = _v2.c;
								return $elm$core$Platform$Cmd$none;
							}
							var postActivationRedirectUrl = _v2.c.a;
							return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
						}
						var connectionUrl = _v2.b.a;
						return $author$project$Ports$Navigation$openInNewWindow(connectionUrl);
					}();
					var activatingProduct = ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless') ? $elm$core$Maybe$Just(
						_Utils_Tuple2(product, response)) : $elm$core$Maybe$Nothing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bI: activatingProduct}),
						cmd,
						1);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bI: $elm$core$Maybe$Just(
									_Utils_Tuple2(product, response))
							}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var integration = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bI: $elm$core$Maybe$Nothing}),
						function () {
							var _v5 = _Utils_Tuple2(
								$author$project$Api$Provider$Integration$One$authType(integration),
								$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
							if ((_v5.a === 'automatic_headless') && (!_v5.b.$)) {
								var postActivationRedirectUrl = _v5.b.a;
								return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}(),
						2);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bI: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 8:
				var product = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dD: $elm$core$Maybe$Just(
								_Utils_Tuple2(product, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					0);
			case 9:
				var product = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dD: $elm$core$Maybe$Just(
								_Utils_Tuple2(product, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$Marketplace$Product$uninstall,
						apiClient,
						product._c,
						$author$project$Components$Marketplace$Product$CallToAction$Deactivated(product)),
					0);
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dD: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					0);
			case 11:
				var product = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dD: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						3);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dD: $elm$core$Maybe$Just(
									_Utils_Tuple2(product, response))
							}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 12:
				var product = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S_: true}),
					A3($author$project$Api$Provider$Marketplace$Product$requestBeta, apiClient, product._c, $author$project$Components$Marketplace$Product$CallToAction$BetaAccessRequested),
					0);
			case 13:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false}),
						$elm$core$Platform$Cmd$none,
						4);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 14:
				var product = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S_: true}),
					A3($author$project$Api$Provider$Marketplace$Product$expressInterest, apiClient, product._c, $author$project$Components$Marketplace$Product$CallToAction$InterestExpressed),
					0);
			case 15:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false}),
						$elm$core$Platform$Cmd$none,
						4);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 16:
				var product = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S_: true}),
					A3($author$project$Api$Provider$Marketplace$Product$requestInstall, apiClient, product._c, $author$project$Components$Marketplace$Product$CallToAction$InstallRequested),
					0);
			case 17:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false}),
						$elm$core$Platform$Cmd$none,
						5);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false}),
						$elm$core$Platform$Cmd$none,
						0);
				}
			case 18:
				var document = msg.a;
				var _v10 = model.W8;
				if (!_v10.$) {
					var product = _v10.a;
					return _Utils_Tuple3(
						model,
						A4(model.Pj, apiClient, product._c, document.adR, $author$project$Components$Marketplace$Product$CallToAction$GotPdfDocumentSignedUrl),
						0);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 0);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						0);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 0);
				}
		}
	});
var $author$project$Components$Carousel$update = F2(
	function (msg, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(model.ahx),
			function () {
				var index = msg;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{x4: index}),
					$elm$core$Platform$Cmd$none);
			}());
	});
var $author$project$Components$Marketplace$Product$Overview$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var carouselMsg = msg;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (carousel) {
				return _Utils_update(
					model,
					{pO: carousel});
			},
			A2($author$project$Components$Carousel$update, carouselMsg, model.pO));
	});
var $author$project$Components$Marketplace$Product$Quotes$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var carouselMsg = msg;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (carousel) {
				return _Utils_update(
					model,
					{pO: carousel});
			},
			A2($author$project$Components$Carousel$update, carouselMsg, model.pO));
	});
var $author$project$Components$Marketplace$Product$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var overviewMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					0,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Components$Marketplace$Product$OverviewMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (overview) {
								return _Utils_update(
									model,
									{Vn: overview});
							},
							A2($author$project$Components$Marketplace$Product$Overview$update, overviewMsg, model.Vn))));
			case 1:
				var quotesMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					0,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Components$Marketplace$Product$QuotesMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (quotes) {
								return _Utils_update(
									model,
									{XI: quotes});
							},
							A2($author$project$Components$Marketplace$Product$Quotes$update, quotesMsg, model.XI))));
			default:
				var ctaMsg = msg.a;
				var _v1 = A3($author$project$Components$Marketplace$Product$CallToAction$update, apiClient, ctaMsg, model.bR);
				var callToAction = _v1.a;
				var ctaCmd = _v1.b;
				var ctaEvent = _v1.c;
				var event = function () {
					switch (ctaEvent) {
						case 0:
							return 0;
						case 1:
							return 1;
						case 2:
							return 2;
						case 3:
							return 3;
						case 4:
							return 4;
						default:
							return 5;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bR: callToAction}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Marketplace$Product$CallToActionMsg, ctaCmd),
					event);
		}
	});
var $author$project$Pages$Marketplace$Slug_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var prodMsg = msg.a;
				var fetchProductCmd = A3($author$project$Pages$Marketplace$Slug_String$fetchProduct, model.D5, model.ZD, model._c);
				var _v1 = A3($author$project$Components$Marketplace$Product$update, model.D5, prodMsg, model.W8);
				var product = _v1.a;
				var productCmd = _v1.b;
				var event = _v1.c;
				var cmd = function () {
					switch (event) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return fetchProductCmd;
						case 2:
							return fetchProductCmd;
						case 3:
							return fetchProductCmd;
						case 4:
							return fetchProductCmd;
						default:
							return fetchProductCmd;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{W8: product}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$ProductMsg, productCmd),
								cmd
							])),
					_List_Nil);
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var product = A2(
						$author$project$Components$Marketplace$Product$setPractice,
						{
							zh: $author$project$Api$Provider$Practice$One$name(practice)
						},
						model.W8);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{W8: product}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				_v4$2:
				while (true) {
					switch (response.$) {
						case 3:
							var marketplaceProduct = response.a;
							var productExpanded = $author$project$Pages$Marketplace$Slug_String$providerMarketplaceProductToProductExpanded(marketplaceProduct);
							var product = A2($author$project$Components$Marketplace$Product$setProduct, productExpanded, model.W8);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										VD: $elm$core$Maybe$Just(
											$author$project$Api$Provider$Marketplace$Product$One$partnerId(marketplaceProduct)),
										W8: product
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v5 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{rA: true}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v4$2;
							}
						default:
							break _v4$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var response = msg.a;
				_v6$2:
				while (true) {
					switch (response.$) {
						case 3:
							var marketplaceProduct = response.a;
							var productExpanded = $author$project$Pages$Marketplace$Slug_String$partnerMarketplaceProductToProductExpanded(marketplaceProduct);
							var product = A2($author$project$Components$Marketplace$Product$setProduct, productExpanded, model.W8);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										VD: $elm$core$Maybe$Just(
											$author$project$Api$Partner$Marketplace$Product$One$partnerId(marketplaceProduct)),
										W8: product
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v7 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{rA: true}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v6$2;
							}
						default:
							break _v6$2;
					}
				}
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Ui$SvgIcon$ArrowLeft = 57;
var $author$project$Ui$SvgIcon$arrowLeft = $author$project$Ui$SvgIcon$viewIcon(57);
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$Ui$Typography$headingXl = function (content) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-heading-xl text-main')
				]),
			content));
};
var $author$project$Components$Marketplace$Product$CallToAction$ActivateConfirmed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$activateVerb = function (product) {
	var _v0 = product.ahI;
	switch (_v0) {
		case 0:
			return 'Install App';
		case 1:
			return 'Activate Integration';
		default:
			return '';
	}
};
var $author$project$Api$Common$Marketplace$Product$Precondition$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Marketplace$Product$CallToAction$OpenPdfDocument = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$ToggleDocumentAccepted = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Marketplace$Product$CallToAction$viewDocumentCheckbox = F2(
	function (acceptedIds, document) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(
							A2($elm$core$Set$member, document.adR, acceptedIds)),
							$author$project$Ui$Form$Checkbox$onCheck(
							$author$project$Components$Marketplace$Product$CallToAction$ToggleDocumentAccepted(document.adR))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('I have read and agree to')
						])),
					function () {
					var _v0 = _Utils_Tuple2(document.NZ, document.aav);
					_v0$2:
					while (true) {
						switch (_v0.a) {
							case 'url':
								if (!_v0.b.$) {
									var url = _v0.b.a;
									return A3(
										$author$project$Ui$Link$externalHref,
										url,
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text(document.$G)
											]));
								} else {
									break _v0$2;
								}
							case 'pdf':
								return A3(
									$author$project$Ui$Button$view,
									{abp: 'Open ' + document.$G},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Marketplace$Product$CallToAction$OpenPdfDocument(document))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(document.$G)
										]));
							default:
								break _v0$2;
						}
					}
					return $elm$html$Html$text(document.$G);
				}()
				]));
	});
var $author$project$Components$Marketplace$Product$CallToAction$viewDocumentAgreements = F4(
	function (practice, productName, acceptedIds, documents) {
		if ($elm$core$List$isEmpty(documents)) {
			return $elm$html$Html$text('');
		} else {
			var practiceName = A2(
				$elm$core$Maybe$withDefault,
				'<practice name>',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.zh;
					},
					practice));
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('By checking the boxes below, you:'),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('pl-6')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('i. confirm that you have read and agree to the documents listed below;')
													])),
												A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('ii. represent and warrant that you are an authorized representative of '),
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														_List_fromArray(
															[
																$elm$html$Html$text(practiceName)
															])),
														$elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
													])),
												A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('iii. agree that this electronic acceptance constitutes a legally binding agreement between '),
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														_List_fromArray(
															[
																$elm$html$Html$text(productName)
															])),
														$elm$html$Html$text(' and '),
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														_List_fromArray(
															[
																$elm$html$Html$text(practiceName)
															])),
														$elm$html$Html$text(', effective as of the date of acceptance.')
													]))
											]))
									])),
								A2(
								$author$project$Ui$Typography$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$bold]),
										_List_fromArray(
											[
												$elm$html$Html$text(practiceName)
											])),
										$elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
								A2(
									$elm$core$List$map,
									$author$project$Components$Marketplace$Product$CallToAction$viewDocumentCheckbox(acceptedIds),
									documents))
							]))
					]));
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$TogglePreconditionAccepted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$labels = function (t) {
	if (!t) {
		return {D$: ' before connecting.', Ed: 'This app requires ', Ez: 'Package Installed', FZ: 'installing a package'};
	} else {
		return {D$: ' before connecting.', Ed: 'You\'ll need an ', Ez: 'Account Created', FZ: 'account with this partner'};
	}
};
var $author$project$Api$Common$Marketplace$Product$Precondition$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Common$Marketplace$Product$Precondition$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Components$Marketplace$Product$CallToAction$viewPrecondition = F2(
	function (acceptedIds, precondition) {
		var l = $author$project$Api$Common$Marketplace$Product$Precondition$Type$labels(
			$author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition));
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(l.Ed),
							A3(
							$author$project$Ui$Link$externalHref,
							$author$project$Api$Common$Marketplace$Product$Precondition$url(precondition),
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(l.FZ)
								])),
							$elm$html$Html$text(l.D$)
						])),
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(
							A2(
								$elm$core$Set$member,
								$author$project$Api$Common$Marketplace$Product$Precondition$id(precondition),
								acceptedIds)),
							$author$project$Ui$Form$Checkbox$onCheck(
							$author$project$Components$Marketplace$Product$CallToAction$TogglePreconditionAccepted(
								$author$project$Api$Common$Marketplace$Product$Precondition$id(precondition)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(l.Ez)
						]))
				]));
	});
var $author$project$Components$Marketplace$Product$CallToAction$viewPreconditions = F2(
	function (acceptedIds, preconditions_) {
		return $elm$core$List$isEmpty(preconditions_) ? $elm$html$Html$text('') : A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
					A2(
						$elm$core$List$map,
						$author$project$Components$Marketplace$Product$CallToAction$viewPrecondition(acceptedIds),
						preconditions_))
				]));
	});
var $author$project$Components$Marketplace$Product$CallToAction$viewActivateModal = function (model) {
	var _v0 = model.bI;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var product = _v1.a;
		var request = _v1.b;
		var verb = $author$project$Components$Marketplace$Product$CallToAction$activateVerb(product);
		var isLoading = _Utils_eq(request, $author$project$Api$Data$Loading);
		var errorMessage = function () {
			if (request.$ === 2) {
				var error = request.a;
				return $elm$core$Maybe$Just(
					$author$project$Ui$Toast$serverError(error));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var documents = product.VF;
		var allPreconditionsAccepted = A2(
			$elm$core$List$all,
			function (p) {
				return A2(
					$elm$core$Set$member,
					$author$project$Api$Common$Marketplace$Product$Precondition$id(p),
					model.dn);
			},
			product.WT);
		var allDocumentsAccepted = A2(
			$elm$core$List$all,
			function (doc) {
				return A2($elm$core$Set$member, doc.adR, model.dm);
			},
			documents);
		var installDisabled = isLoading || (((!$elm$core$List$isEmpty(documents)) && (!allDocumentsAccepted)) || (!allPreconditionsAccepted));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(verb + (' ' + (product.zh + '?')))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							if (!errorMessage.$) {
								var message = errorMessage.a;
								return A2(
									$author$project$Ui$Alert$danger,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This will activate '),
									$elm$html$Html$text(product.zh),
									$elm$html$Html$text(' and add it to your connected integrations. You\'ll be able to configure settings after activation.')
								])),
							A4($author$project$Components$Marketplace$Product$CallToAction$viewDocumentAgreements, model.WF, product.zh, model.dm, documents),
							A2($author$project$Components$Marketplace$Product$CallToAction$viewPreconditions, model.dn, product.WT)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: verb},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Marketplace$Product$CallToAction$ActivateConfirmed(product)),
									$author$project$Ui$Button$disabled(installDisabled),
									$author$project$Ui$Button$loading(isLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(verb)
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$DeactivateConfirmed = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb = function (product) {
	var _v0 = product.ahI;
	switch (_v0) {
		case 0:
			return 'Uninstall App';
		case 1:
			return 'Deactivate Integration';
		default:
			return '';
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$viewDeactivateModal = function (model) {
	var _v0 = model.dD;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var product = _v1.a;
		var request = _v1.b;
		var verb = $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product);
		var errorMessage = function () {
			if (request.$ === 2) {
				var error = request.a;
				return $elm$core$Maybe$Just(
					$author$project$Ui$Toast$serverError(error));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(verb + (' ' + (product.zh + '?')))
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							function () {
							if (!errorMessage.$) {
								var message = errorMessage.a;
								return A2(
									$author$project$Ui$Alert$danger,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(message)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Are you sure you want to ' + ($elm$core$String$toLower(verb) + ' ')),
									$elm$html$Html$text(product.zh),
									$elm$html$Html$text('? This will remove the integration and all its settings.')
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: verb},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Marketplace$Product$CallToAction$DeactivateConfirmed(product)),
									$author$project$Ui$Button$disabled(
									_Utils_eq(request, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(verb)
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$modal = function (model) {
	return A2(
		$elm$html$Html$map,
		model.ahx,
		A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Marketplace$Product$CallToAction$viewActivateModal(model),
					$author$project$Components$Marketplace$Product$CallToAction$viewDeactivateModal(model)
				])));
};
var $author$project$Components$Marketplace$Product$CallToAction$Activate = {$: 2};
var $author$project$Components$Marketplace$Product$CallToAction$ActivateProduct = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$DeactivateProduct = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$Disabled = 0;
var $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest = {$: 1};
var $author$project$Components$Marketplace$Product$CallToAction$ExpressInterestClicked = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$RequestBeta = {$: 0};
var $author$project$Components$Marketplace$Product$CallToAction$RequestBetaAccess = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$RequestInstallClicked = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$NoAction = {$: 5};
var $author$project$Components$Marketplace$Product$CallToAction$ExternalCta = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Marketplace$Product$CallToAction$Deactivate = {$: 3};
var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantFromEngagement = F2(
	function (product, variant) {
		if (product.JU) {
			return $author$project$Components$Marketplace$Product$CallToAction$Activate;
		} else {
			var _v0 = product.OB;
			_v0$3:
			while (true) {
				if (!_v0.$) {
					switch (_v0.a.$) {
						case 2:
							var _v1 = _v0.a;
							return $author$project$Components$Marketplace$Product$CallToAction$Activate;
						case 3:
							var _v2 = _v0.a;
							return $author$project$Components$Marketplace$Product$CallToAction$Activate;
						case 4:
							var _v3 = _v0.a;
							return $author$project$Components$Marketplace$Product$CallToAction$Activate;
						default:
							break _v0$3;
					}
				} else {
					break _v0$3;
				}
			}
			return variant;
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive = F2(
	function (product, variant) {
		var _v0 = product.ag7;
		if ((!_v0.$) && (_v0.a === 'active')) {
			return $author$project$Components$Marketplace$Product$CallToAction$Deactivate;
		} else {
			return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantFromEngagement, product, variant);
		}
	});
var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantForLive = function (product) {
	var _v0 = product.ahI;
	if (_v0 === 2) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Components$Marketplace$Product$CallToAction$NoAction,
			A2($elm$core$Maybe$map, $author$project$Components$Marketplace$Product$CallToAction$ExternalCta, product.LF));
	} else {
		return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$Activate);
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$ctaVariant = function (product) {
	var _v0 = product.SZ;
	switch (_v0) {
		case 1:
			return $author$project$Components$Marketplace$Product$CallToAction$NoAction;
		case 0:
			return $author$project$Components$Marketplace$Product$CallToAction$NoAction;
		case 5:
			return $author$project$Components$Marketplace$Product$CallToAction$ctaVariantForLive(product);
		case 4:
			return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$RequestBeta);
		case 3:
			return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest);
		case 2:
			return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest);
		default:
			return $author$project$Components$Marketplace$Product$CallToAction$NoAction;
	}
};
var $author$project$Api$Common$Marketplace$Product$InstallMeta$enabled = function (_v0) {
	var record = _v0;
	return record.Ot;
};
var $author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled = F2(
	function (product, variant) {
		var _v0 = _Utils_Tuple2(variant, product.OB);
		_v0$3:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 0:
						if (!_v0.b.a.$) {
							var _v1 = _v0.a;
							var _v2 = _v0.b.a;
							return true;
						} else {
							break _v0$3;
						}
					case 1:
						if (_v0.b.a.$ === 1) {
							var _v3 = _v0.a;
							var _v4 = _v0.b.a;
							return true;
						} else {
							break _v0$3;
						}
					case 2:
						if (_v0.b.a.$ === 4) {
							var _v5 = _v0.a;
							var _v6 = _v0.b.a;
							return true;
						} else {
							break _v0$3;
						}
					default:
						break _v0$3;
				}
			} else {
				break _v0$3;
			}
		}
		return false;
	});
var $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirements = function (_v0) {
	var record = _v0;
	return record.T6;
};
var $author$project$Api$Common$Marketplace$Product$InstallMeta$reason = function (_v0) {
	var record = _v0;
	return record.XP;
};
var $author$project$Components$Marketplace$Product$CallToAction$requestInstallVerb = function (product) {
	var _v0 = product.ahI;
	switch (_v0) {
		case 0:
			return 'Request Install';
		case 1:
			return 'Request Activation';
		default:
			return '';
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$withMarketplaceUtmParams = function (url) {
	return A2(
		$author$project$Utils$Url$addParams,
		url,
		_List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'utm_source', 'hint'),
				A2($elm$url$Url$Builder$string, 'utm_medium', 'marketplace'),
				A2($elm$url$Url$Builder$string, 'utm_campaign', 'hint_marketplace')
			]));
};
var $author$project$Components$Marketplace$Product$CallToAction$viewMissingRequirement = function (requirement) {
	if ((!requirement.$) && (!requirement.a.$)) {
		var _v1 = requirement.a;
		return $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						$author$project$Components$Marketplace$Product$CallToAction$withMarketplaceUtmParams('https://www.hint.com/clinical-upgrade'),
						_List_fromArray(
							[$author$project$Ui$Link$fullWidth, $author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$fullWidth, $author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('Get a Demo')
							]))
					])));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Marketplace$Product$CallToAction$button = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			model.ahx,
			function () {
				var _v0 = model.W8;
				if (!_v0.$) {
					var product = _v0.a;
					var isDisabled = A2($elm$core$List$member, 0, options);
					var commonButtonOptions = _List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$loading(model.S_),
							$author$project$Ui$Button$fullWidth(true)
						]);
					var _v1 = $author$project$Components$Marketplace$Product$CallToAction$ctaVariant(product);
					switch (_v1.$) {
						case 0:
							var isButtonDisabled = isDisabled || (model.S_ || A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$RequestBeta));
							return A3(
								$author$project$Ui$Button$view,
								{abp: 'Request beta access'},
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Button$onClick(
										$author$project$Components$Marketplace$Product$CallToAction$RequestBetaAccess(product)),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Button$disabled(isButtonDisabled),
										commonButtonOptions)),
								_List_fromArray(
									[
										$elm$html$Html$text(
										_Utils_eq(
											product.OB,
											$elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted)) ? 'On Waitlist' : 'Request beta access')
									]));
						case 1:
							var isButtonDisabled = isDisabled || (model.S_ || A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest));
							return A3(
								$author$project$Ui$Button$view,
								{abp: 'Express interest'},
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Button$onClick(
										$author$project$Components$Marketplace$Product$CallToAction$ExpressInterestClicked(product)),
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Button$disabled(isButtonDisabled),
										commonButtonOptions)),
								_List_fromArray(
									[
										$elm$html$Html$text(
										_Utils_eq(
											product.OB,
											$elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested)) ? 'Interest expressed' : 'Express interest')
									]));
						case 2:
							if (model.Ru) {
								var installMeta = product.Q1;
								var missingReqs = A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirements, installMeta));
								var reasonText = A2($elm$core$Maybe$andThen, $author$project$Api$Common$Marketplace$Product$InstallMeta$reason, installMeta);
								var installEnabled = A2(
									$elm$core$Maybe$withDefault,
									true,
									A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$InstallMeta$enabled, installMeta));
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
									A2(
										$elm$core$List$cons,
										A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{
														abp: $author$project$Components$Marketplace$Product$CallToAction$activateVerb(product)
													},
													A2(
														$elm$core$List$cons,
														$author$project$Ui$Button$onClick(
															$author$project$Components$Marketplace$Product$CallToAction$ActivateProduct(product)),
														A2(
															$elm$core$List$cons,
															$author$project$Ui$Button$disabled(isDisabled || (!installEnabled)),
															commonButtonOptions)),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Components$Marketplace$Product$CallToAction$activateVerb(product))
														])),
													function () {
													if (!reasonText.$) {
														var reason = reasonText.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
															_List_fromArray(
																[
																	$elm$html$Html$text(reason)
																]));
													} else {
														return $elm$html$Html$text('');
													}
												}()
												])),
										A2($elm$core$List$filterMap, $author$project$Components$Marketplace$Product$CallToAction$viewMissingRequirement, missingReqs)));
							} else {
								var alreadyRequested = A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$Activate);
								var requestLabel = alreadyRequested ? 'Install Requested' : $author$project$Components$Marketplace$Product$CallToAction$requestInstallVerb(product);
								return A3(
									$author$project$Ui$Button$view,
									{abp: requestLabel},
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Button$onClick(
											$author$project$Components$Marketplace$Product$CallToAction$RequestInstallClicked(product)),
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Button$disabled(isDisabled || (alreadyRequested || model.S_)),
											commonButtonOptions)),
									_List_fromArray(
										[
											$elm$html$Html$text(requestLabel)
										]));
							}
						case 3:
							return model.Ru ? A3(
								$author$project$Ui$Button$view,
								{
									abp: $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product)
								},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$fullWidth(true),
										$author$project$Ui$Button$loading(model.S_),
										$author$project$Ui$Button$disabled(isDisabled),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Marketplace$Product$CallToAction$DeactivateProduct(product))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product))
									])) : A3(
								$author$project$Ui$Button$view,
								{
									abp: $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product)
								},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$fullWidth(true),
										$author$project$Ui$Button$disabled(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product))
									]));
						case 4:
							var url = _v1.a;
							return isDisabled ? A3(
								$author$project$Ui$Button$view,
								{abp: 'Contact Partner'},
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Button$disabled(true),
									commonButtonOptions),
								_List_fromArray(
									[
										$elm$html$Html$text('Contact Partner')
									])) : A3(
								$author$project$Ui$Link$externalHref,
								url,
								_List_fromArray(
									[$author$project$Ui$Link$fullWidth, $author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text('Contact Partner')
									]));
						default:
							return $elm$html$Html$text('');
					}
				} else {
					return $elm$html$Html$text('');
				}
			}());
	});
var $author$project$Components$Marketplace$Product$settingsUrl = function (product) {
	return A2(
		$elm$core$Maybe$andThen,
		function (status) {
			switch (status) {
				case 'inactive':
					return $elm$core$Maybe$Nothing;
				case 'pending':
					return $elm$core$Maybe$Just(
						$author$project$Spa$Generated$Route$toString(
							$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
								{_c: product._c})));
				default:
					var _v1 = _Utils_Tuple2(product.ahI, product._c);
					if (!_v1.a) {
						var _v2 = _v1.a;
						return $elm$core$Maybe$Just(
							$author$project$Spa$Generated$Route$toString(
								$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
									{_c: product._c})));
					} else {
						if (_v1.b === 'layer') {
							return $elm$core$Maybe$Just(
								$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Layer__Manage__Settings));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}
			}
		},
		product.ag7);
};
var $author$project$Components$Marketplace$Product$cardButtons = F2(
	function (model, product) {
		var manageButton = function () {
			var _v0 = $author$project$Components$Marketplace$Product$settingsUrl(product);
			if (!_v0.$) {
				var url = _v0.a;
				return _List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						url,
						_List_fromArray(
							[$author$project$Ui$Link$fullWidth, $author$project$Ui$Link$buttonPrimary]),
						_List_fromArray(
							[
								$elm$html$Html$text('Manage')
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_ap(
			manageButton,
			_List_fromArray(
				[
					A2($author$project$Components$Marketplace$Product$CallToAction$button, _List_Nil, model.bR)
				]));
	});
var $author$project$Components$Carousel$AspectVideo = {$: 2};
var $author$project$Components$Carousel$aspectVideo = $author$project$Components$Carousel$AspectVideo;
var $author$project$Components$Carousel$Image = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Carousel$image = F3(
	function (id, src, alt) {
		return $author$project$Components$Carousel$Image(
			{I1: alt, adR: id, sX: src});
	});
var $author$project$Components$Carousel$Thumbnails = {$: 0};
var $author$project$Components$Carousel$thumbnails = $author$project$Components$Carousel$Thumbnails;
var $author$project$Utils$Html$ulFromString = function (string) {
	return function (_v2) {
		var acc = _v2.a;
		var ils = _v2.b;
		if (!ils.b) {
			return acc;
		} else {
			var items = ils;
			return _Utils_ap(
				acc,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('m-0')
							]),
						items)
					]));
		}
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (line, _v0) {
					var acc = _v0.a;
					var ils = _v0.b;
					if (A2($elm$core$String$startsWith, '- ', line) || A2($elm$core$String$startsWith, '* ', line)) {
						return _Utils_Tuple2(
							acc,
							_Utils_ap(
								ils,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$String$dropLeft, 2, line))
											]))
									])));
					} else {
						if (!ils.b) {
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[
											$elm$html$Html$text(line),
											A2($elm$html$Html$br, _List_Nil, _List_Nil)
										])),
								_List_Nil);
						} else {
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('m-0')
												]),
											ils),
											$elm$html$Html$text(line),
											A2($elm$html$Html$br, _List_Nil, _List_Nil)
										])),
								_List_Nil);
						}
					}
				}),
			_Utils_Tuple2(_List_Nil, _List_Nil),
			$elm$core$String$lines(string)));
};
var $author$project$Components$Carousel$JumpTo = $elm$core$Basics$identity;
var $author$project$Ui$SvgIcon$Chevron = 12;
var $author$project$Ui$SvgIcon$chevron = $author$project$Ui$SvgIcon$viewIcon(12);
var $author$project$Components$Carousel$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				switch (option.$) {
					case 0:
						return _Utils_update(
							acc,
							{Dr: true});
					case 1:
						var action = option.a;
						return _Utils_update(
							acc,
							{
								z3: $elm$core$Maybe$Just(action)
							});
					default:
						return _Utils_update(
							acc,
							{vu: true});
				}
			}),
		{vu: false, z3: $elm$core$Maybe$Nothing, Dr: false},
		options);
};
var $author$project$Ui$SvgIcon$Rotate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$SvgIcon$rotate180 = $author$project$Ui$SvgIcon$Rotate(180);
var $author$project$Components$Carousel$viewImage = function (img) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('carousel__image')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(img.sX),
						$elm$html$Html$Attributes$alt(''),
						$elm$html$Html$Attributes$class('carousel__image__bg')
					]),
				_List_Nil),
				A3(
				$author$project$Ui$Image$fromSrc,
				{I1: img.I1},
				img.sX,
				_List_Nil)
			]));
};
var $author$project$Components$Carousel$viewItem = function (item) {
	if (!item.$) {
		var img = item.a;
		return $author$project$Components$Carousel$viewImage(img);
	} else {
		var content = item.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel__image')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$map, $elm$core$Basics$never, content)
				]));
	}
};
var $author$project$Components$Carousel$viewImageThumb = function (img) {
	return A3(
		$author$project$Ui$Image$fromSrc,
		{I1: img.I1},
		img.sX,
		_List_fromArray(
			[
				$author$project$Ui$Image$class('rounded'),
				$author$project$Ui$Image$width(68),
				$author$project$Ui$Image$height(68)
			]));
};
var $author$project$Components$Carousel$viewThumb = F4(
	function (itemsCount, selectedIndex, index, item) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel__thumbnail-button'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'carousel__thumbnail-button--active',
							_Utils_eq(index, selectedIndex))
						])),
					$elm$html$Html$Events$onClick(
					A2($elm$core$Basics$modBy, itemsCount, index))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					function () {
						if (!item.$) {
							var img = item.a;
							return $author$project$Components$Carousel$viewImageThumb(img);
						} else {
							var content = item.b;
							return content;
						}
					}())
				]));
	});
var $author$project$Components$Carousel$view = F3(
	function (options, _v0, items) {
		var index = _v0.x4;
		var toMsg = _v0.ahx;
		if ($elm$core$List$isEmpty(items)) {
			return $elm$html$Html$text('');
		} else {
			var optionsRecord = $author$project$Components$Carousel$optionsToRecord(options);
			var itemsCount = $elm$core$List$length(items);
			var nextIndex = A2($elm$core$Basics$modBy, itemsCount, index + 1);
			var prevIndex = A2($elm$core$Basics$modBy, itemsCount, index - 1);
			var currentItem = A2(
				$elm$core$Array$get,
				index,
				$elm$core$Array$fromList(items));
			var itemId = A2(
				$elm$core$Maybe$map,
				function (item) {
					if (!item.$) {
						var img = item.a;
						return img.adR;
					} else {
						var id = item.a;
						return id;
					}
				},
				currentItem);
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('carousel'),
								A2(
								$elm$html$Html$Attributes$attribute,
								'style',
								'--carousel-index:' + $elm$core$String$fromInt(index)),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('aspect-video', optionsRecord.vu)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								toMsg,
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(prevIndex),
											$elm$html$Html$Attributes$class('carousel__control carousel__control--left')
										]),
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$chevron(
											_List_fromArray(
												[$author$project$Ui$SvgIcon$rotate180]))
										]))),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('carousel__track')
									]),
								A2($elm$core$List$map, $author$project$Components$Carousel$viewItem, items)),
								A2(
								$elm$html$Html$map,
								toMsg,
								A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(nextIndex),
											$elm$html$Html$Attributes$class('carousel__control carousel__control--right')
										]),
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$chevron(_List_Nil)
										]))),
								function () {
								var _v1 = _Utils_Tuple2(optionsRecord.z3, itemId);
								if ((!_v1.a.$) && (!_v1.b.$)) {
									var action = _v1.a.a;
									var itemId_ = _v1.b.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('carousel__overlay')
											]),
										_List_fromArray(
											[
												action(itemId_)
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}()
							])),
						optionsRecord.Dr ? A2(
						$elm$html$Html$map,
						toMsg,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('carousel__thumbnails')
								]),
							A2(
								$elm$core$List$indexedMap,
								A2($author$project$Components$Carousel$viewThumb, itemsCount, index),
								items))) : $elm$html$Html$text('')
					]));
		}
	});
var $author$project$Ui$Card$optionsToRecord = A2(
	$elm$core$List$foldl,
	F2(
		function (option, acc) {
			switch (option.$) {
				case 0:
					var bool = option.a;
					return _Utils_update(
						acc,
						{xS: bool});
				case 3:
					var bool = option.a;
					return _Utils_update(
						acc,
						{zg: bool});
				case 1:
					var href = option.a;
					return _Utils_update(
						acc,
						{
							SU: $elm$core$Maybe$Just(href)
						});
				default:
					var bool = option.a;
					return _Utils_update(
						acc,
						{dW: bool});
			}
		}),
	{dW: false, xS: false, SU: $elm$core$Maybe$Nothing, zg: false});
var $author$project$Ui$Card$view = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Card$optionsToRecord(options);
		var node = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$div,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always($elm$html$Html$a),
				optionsRecord.SU));
		return A2(
			node,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('card--highlighted', optionsRecord.xS),
							_Utils_Tuple2(
							'card--clickable',
							A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$always(true),
									optionsRecord.SU))),
							_Utils_Tuple2('card--muted', optionsRecord.zg),
							_Utils_Tuple2('disabled', optionsRecord.dW)
						])),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$Attributes$class(''),
					A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, optionsRecord.SU))
				]),
			content);
	});
var $author$project$Components$Marketplace$Product$Overview$view = function (_v0) {
	var model = _v0;
	var _v1 = model.Vn;
	if (!_v1.$) {
		var overview = _v1.a;
		var items = A2(
			$elm$core$List$map,
			function (img) {
				return A3($author$project$Components$Carousel$image, img.aav, img.aav, img.I1);
			},
			overview.QO);
		return A2(
			$author$project$Ui$Card$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Overview')
								])),
							$author$project$Ui$HorizontalRule$view(
							_List_fromArray(
								[$author$project$Ui$HorizontalRule$thin])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt4]),
							_List_fromArray(
								[
									A3(
									$author$project$Components$Carousel$view,
									_List_fromArray(
										[$author$project$Components$Carousel$aspectVideo, $author$project$Components$Carousel$thumbnails]),
									model.pO,
									items)
								])),
							function () {
							var _v2 = overview.Nx;
							if (!_v2.$) {
								var description = _v2.a;
								return A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$preWrap, $author$project$Ui$Typography$muted]),
												$author$project$Utils$Html$ulFromString(description))
											])));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Carousel$Html = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Carousel$html = $author$project$Components$Carousel$Html;
var $author$project$Ui$Image$ProductHighlightImagePlaceholder = 15;
var $author$project$Ui$SvgIcon$Quote = 92;
var $author$project$Ui$Element$DirectionRow = 0;
var $author$project$Ui$Element$flexRowMd = A2($author$project$Ui$Element$Direction, 2, 0);
var $author$project$Ui$Image$FullWidth = {$: 4};
var $author$project$Ui$Image$fullWidth = $author$project$Ui$Image$FullWidth;
var $author$project$Ui$Image$Rounded = {$: 5};
var $author$project$Ui$Image$rounded = $author$project$Ui$Image$Rounded;
var $author$project$Components$Marketplace$Product$Quotes$viewQuote = F2(
	function (imageStore, _v0) {
		var text = _v0.$A;
		var author = _v0.Jz;
		var authorTitle = _v0.JB;
		var authorImageUrl = _v0.JA;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$flexRowMd]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$width('50px'),
									$author$project$Ui$SvgIcon$class('icon--primary')
								]),
							92)
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$fullWidth]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text(text)
										]))
								])),
							$author$project$Ui$HorizontalRule$view(
							_List_fromArray(
								[$author$project$Ui$HorizontalRule$thin])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt4]),
							_List_fromArray(
								[
									function () {
									if (!authorImageUrl.$) {
										var imageUrl = authorImageUrl.a;
										return A3(
											$author$project$Ui$Image$fromSrc,
											{I1: author + ' image'},
											imageUrl,
											_List_fromArray(
												[
													$author$project$Ui$Image$rounded,
													$author$project$Ui$Image$height(100),
													$author$project$Ui$Image$width(100)
												]));
									} else {
										return A4(
											$author$project$Ui$Image$view,
											imageStore,
											{I1: author + ' image'},
											_List_fromArray(
												[$author$project$Ui$Image$fullWidth]),
											15);
									}
								}(),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$ml2]),
									_List_fromArray(
										[
											$elm$html$Html$text(author),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text(authorTitle)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Marketplace$Product$Quotes$view = F2(
	function (imageStore, _v0) {
		var model = _v0;
		if ($elm$core$List$isEmpty(model.XI)) {
			return $elm$html$Html$text('');
		} else {
			var items = A2(
				$elm$core$List$map,
				function (quote) {
					return A2(
						$author$project$Components$Carousel$html,
						quote.$A,
						A2($author$project$Components$Marketplace$Product$Quotes$viewQuote, imageStore, quote));
				},
				model.XI);
			return A2(
				$author$project$Ui$Card$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								A3($author$project$Components$Carousel$view, _List_Nil, model.pO, items)
							]))
					]));
		}
	});
var $author$project$Ui$SvgIcon$Package = 84;
var $author$project$Ui$SvgIcon$package = $author$project$Ui$SvgIcon$viewIcon(84);
var $author$project$Ui$SvgIcon$Transfer = 47;
var $author$project$Ui$SvgIcon$transfer = $author$project$Ui$SvgIcon$viewIcon(47);
var $author$project$Ui$SvgIcon$Xl = 4;
var $author$project$Ui$SvgIcon$xl = $author$project$Ui$SvgIcon$Size(4);
var $author$project$Components$Marketplace$Product$viewProductDataFlow = F2(
	function (product, dataFlow) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									function () {
									var _v0 = product.QH;
									if (!_v0.$) {
										var iconUrl = _v0.a;
										return A3(
											$author$project$Ui$Image$fromSrc,
											{I1: 'icon'},
											iconUrl,
											_List_fromArray(
												[
													$author$project$Ui$Image$height(20)
												]));
									} else {
										return $author$project$Ui$SvgIcon$package(
											_List_fromArray(
												[$author$project$Ui$SvgIcon$xl]));
									}
								}(),
									$elm$html$Html$text(dataFlow.VE)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textCenter]),
					_List_fromArray(
						[
							function () {
							var _v1 = dataFlow.$h;
							switch (_v1) {
								case 0:
									return $author$project$Ui$SvgIcon$arrowLeft(_List_Nil);
								case 1:
									return $author$project$Ui$SvgIcon$arrowRight(_List_Nil);
								default:
									return $author$project$Ui$SvgIcon$transfer(
										_List_fromArray(
											[$author$project$Ui$SvgIcon$xl]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$hintHeart(
									_List_fromArray(
										[$author$project$Ui$SvgIcon$xl])),
									$elm$html$Html$text(dataFlow.Qx)
								]))
						]))
				]));
	});
var $author$project$Components$Marketplace$Product$viewDataFlows = function (product) {
	return $elm$core$List$isEmpty(product.MN) ? $elm$html$Html$text('') : A2(
		$author$project$Ui$Card$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Data Syncing')
									]))
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt4, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('The following data fields are synchronized between Hint and '),
								$elm$html$Html$text(product.zh),
								$elm$html$Html$text(':')
							])),
						A4(
						$author$project$Ui$Table$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('In ' + product.zh)
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[$author$project$Ui$Table$textCenter]),
								_List_fromArray(
									[
										$elm$html$Html$text('Sync Direction')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('In Hint')
									]))
							]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Marketplace$Product$viewProductDataFlow(product),
							product.MN),
						_List_Nil)
					]))
			]));
};
var $author$project$Ui$Card$Highlighted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Card$highlighted = $author$project$Ui$Card$Highlighted;
var $author$project$Components$Marketplace$ProductCard$viewAttribution = F2(
	function (builtByName, builtByUrl) {
		if (!builtByName.$) {
			var name = builtByName.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Built by ')
							])),
						function () {
						if (!builtByUrl.$) {
							var url = builtByUrl.a;
							return A3(
								$author$project$Ui$Link$externalHref,
								url,
								_List_fromArray(
									[
										$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$launch),
										$author$project$Ui$Link$targetBlank
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]));
						} else {
							return $elm$html$Html$text(name);
						}
					}()
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Ui$Badge$Neutral = 5;
var $author$project$Ui$Badge$neutral = $author$project$Ui$Badge$Color(5);
var $author$project$Api$Common$Marketplace$Product$ProductType$toString = function (type_) {
	switch (type_) {
		case 0:
			return 'app';
		case 1:
			return 'integration';
		default:
			return 'solution';
	}
};
var $author$project$Components$Marketplace$ProductCard$viewIntegrationChip = function (product) {
	var _v0 = product.ag7;
	if (!_v0.$) {
		switch (_v0.a) {
			case 'inactive':
				return A2(
					$author$project$Ui$Badge$view,
					_List_fromArray(
						[$author$project$Ui$Badge$neutral]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Common$Marketplace$Product$ProductType$toString(product.ahI))
						]));
			case 'active':
				return A2(
					$author$project$Ui$Badge$view,
					_List_fromArray(
						[$author$project$Ui$Badge$success]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Common$Marketplace$Product$ProductType$toString(product.ahI)),
							$author$project$Ui$SvgIcon$check(_List_Nil)
						]));
			default:
				var status = _v0.a;
				return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
		}
	} else {
		return A2(
			$author$project$Ui$Badge$view,
			_List_fromArray(
				[$author$project$Ui$Badge$neutral]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Common$Marketplace$Product$ProductType$toString(product.ahI))
				]));
	}
};
var $author$project$Ui$Badge$AccentPrimary = 6;
var $author$project$Ui$Badge$accentPrimary = $author$project$Ui$Badge$Color(6);
var $author$project$Ui$Badge$AccentSecondary = 7;
var $author$project$Ui$Badge$accentSecondary = $author$project$Ui$Badge$Color(7);
var $author$project$Components$Marketplace$ProductCard$listingStatusOptions = function (status) {
	switch (status) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[$author$project$Ui$Badge$neutral]);
		case 2:
			return _List_Nil;
		case 3:
			return _List_fromArray(
				[$author$project$Ui$Badge$accentPrimary]);
		case 4:
			return _List_fromArray(
				[$author$project$Ui$Badge$accentSecondary]);
		case 5:
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 6:
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 7:
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		default:
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
	}
};
var $author$project$Api$Common$Marketplace$Product$Status$toLabel = function (status) {
	switch (status) {
		case 0:
			return 'Hidden';
		case 1:
			return 'Unpublished';
		case 2:
			return 'Researching';
		case 3:
			return 'Coming Soon';
		case 4:
			return 'Beta';
		case 5:
			return 'Live';
		case 6:
			return 'Sunsetting';
		case 7:
			return 'Deprecated';
		default:
			return 'Decommissioned';
	}
};
var $author$project$Components$Marketplace$ProductCard$viewListingChip = function (product) {
	return A2(
		$author$project$Ui$Badge$view,
		$author$project$Components$Marketplace$ProductCard$listingStatusOptions(product.SZ),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Common$Marketplace$Product$Status$toLabel(product.SZ))
			]));
};
var $author$project$Components$Marketplace$ProductCard$viewExpanded = F2(
	function (_v0, product) {
		var buttons = _v0.abK;
		return A2(
			$author$project$Ui$Card$view,
			_List_fromArray(
				[
					$author$project$Ui$Card$highlighted(product.Pc)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4]),
					_List_fromArray(
						[
							function () {
							var _v1 = product.QH;
							if (!_v1.$) {
								var url = _v1.a;
								return A3(
									$author$project$Ui$Image$fromSrc,
									{I1: product.zh + '\'s icon'},
									url,
									_List_fromArray(
										[
											$author$project$Ui$Image$width(64)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}(),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Typography$heading(
									_List_fromArray(
										[
											$elm$html$Html$text(product.zh)
										]))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v2 = product._9;
							if (!_v2.$) {
								var summary = _v2.a;
								return A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb2, $author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text(summary)
										]));
							} else {
								return $elm$html$Html$text('');
							}
						}()
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							$author$project$Components$Marketplace$ProductCard$viewIntegrationChip(product),
							function () {
							var _v3 = product.SZ;
							if (_v3 === 5) {
								return $elm$html$Html$text('');
							} else {
								return $author$project$Components$Marketplace$ProductCard$viewListingChip(product);
							}
						}()
						])),
					A2($author$project$Components$Marketplace$ProductCard$viewAttribution, product.Kd, product.Ke),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
					buttons)
				]));
	});
var $author$project$Ui$Image$HeightAuto = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Image$heightAuto = $author$project$Ui$Image$HeightAuto(0);
var $author$project$Components$Marketplace$Product$viewHighlight = function (_v0) {
	var title = _v0.$G;
	var description = _v0.Nx;
	var imageUrl = _v0.QN;
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(3)
					]),
				_List_fromArray(
					[
						function () {
						if (!imageUrl.$) {
							var src = imageUrl.a;
							return A3(
								$author$project$Ui$Image$fromSrc,
								{I1: 'Highlight image'},
								src,
								_List_fromArray(
									[
										$author$project$Ui$Image$rounded,
										$author$project$Ui$Image$fullWidth,
										$author$project$Ui$Image$heightAuto,
										$author$project$Ui$Image$class('object-contain')
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])),
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Utils$Html$ulFromString,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Ui$Typography$div(
													_List_fromArray(
														[$author$project$Ui$Typography$preWrap, $author$project$Ui$Typography$muted])),
												A2(
													$elm$core$Basics$composeR,
													$elm$core$List$singleton,
													$author$project$Ui$Element$view(
														_List_fromArray(
															[$author$project$Ui$Element$mt4]))))),
										description)))
							]))
					]))
			]));
};
var $author$project$Components$Marketplace$Product$viewCategory = function (category) {
	return A2(
		$author$project$Ui$Badge$view,
		_List_fromArray(
			[$author$project$Ui$Badge$neutral]),
		_List_fromArray(
			[
				$elm$html$Html$text(category.zh)
			]));
};
var $author$project$Components$Marketplace$Product$viewCategories = function (product) {
	return $elm$core$List$isEmpty(product.KL) ? $elm$html$Html$text('') : A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Categories')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap2]),
				A2($elm$core$List$map, $author$project$Components$Marketplace$Product$viewCategory, product.KL))
			]));
};
var $author$project$Ui$SvgIcon$Call = 85;
var $author$project$Ui$SvgIcon$call = $author$project$Ui$SvgIcon$viewIcon(85);
var $author$project$Ui$SvgIcon$Mail = 86;
var $author$project$Ui$SvgIcon$mail = $author$project$Ui$SvgIcon$viewIcon(86);
var $author$project$Ui$Link$Tabindex = function (a) {
	return {$: 19, a: a};
};
var $author$project$Ui$Link$preventFocus = $author$project$Ui$Link$Tabindex(-1);
var $author$project$Ui$Link$Tel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Link$tel = F3(
	function (tel_, options, content) {
		return A2(
			$author$project$Ui$Link$view,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Link$Tel(tel_),
				options),
			content);
	});
var $author$project$Components$Marketplace$Product$viewLink = function (_v0) {
	var title = _v0.$G;
	var linkType = _v0.SV;
	var value = _v0.aaN;
	var composedUrl = _v0.LG;
	switch (linkType) {
		case 0:
			return A3(
				$author$project$Ui$Link$externalHref,
				A2($elm$core$Maybe$withDefault, value, composedUrl),
				_List_fromArray(
					[
						$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$launch),
						$author$project$Ui$Link$preventFocus,
						$author$project$Ui$Link$targetBlank
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]));
		case 1:
			return A3(
				$author$project$Ui$Link$mailto,
				value,
				_List_fromArray(
					[
						$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$mail),
						$author$project$Ui$Link$preventFocus
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]));
		default:
			return A3(
				$author$project$Ui$Link$tel,
				value,
				_List_fromArray(
					[
						$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$call),
						$author$project$Ui$Link$preventFocus
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					]));
	}
};
var $author$project$Components$Marketplace$Product$viewLinks = function (product) {
	if ($elm$core$List$isEmpty(product.SX)) {
		return $elm$html$Html$text('');
	} else {
		var elemAttrs = $elm$core$List$isEmpty(product.KL) ? _List_Nil : _List_fromArray(
			[$author$project$Ui$Element$mb4]);
		return A2(
			$author$project$Ui$Element$view,
			elemAttrs,
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Learn More & Support')
						])),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
					A2($elm$core$List$map, $author$project$Components$Marketplace$Product$viewLink, product.SX))
				]));
	}
};
var $author$project$Components$Marketplace$Product$viewLinksAndCategories = function (product) {
	return ($elm$core$List$isEmpty(product.SX) && $elm$core$List$isEmpty(product.KL)) ? $elm$html$Html$text('') : A2(
		$author$project$Ui$Card$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Marketplace$Product$viewLinks(product),
				$author$project$Components$Marketplace$Product$viewCategories(product)
			]));
};
var $author$project$Components$Marketplace$Product$viewContent = function (model) {
	var _v0 = model.W8;
	if (!_v0.$) {
		var product = _v0.a;
		return A3(
			$author$project$Ui$Element$custom,
			'marketplace-landing',
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Element$custom,
					'marketplace-landing__aside',
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$Marketplace$ProductCard$viewExpanded,
							{
								abK: A2($author$project$Components$Marketplace$Product$cardButtons, model, product)
							},
							product),
							$author$project$Components$Marketplace$Product$viewLinksAndCategories(product)
						])),
					A3(
					$author$project$Ui$Element$custom,
					'marketplace-landing__main',
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Marketplace$Product$OverviewMsg,
							$author$project$Components$Marketplace$Product$Overview$view(model.Vn)),
							$elm$core$List$isEmpty(product.Qr) ? $elm$html$Html$text('') : A2(
							$author$project$Ui$Card$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text('Highlights')
												])),
											$author$project$Ui$HorizontalRule$view(
											_List_fromArray(
												[$author$project$Ui$HorizontalRule$thin])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
											A2($elm$core$List$map, $author$project$Components$Marketplace$Product$viewHighlight, product.Qr))
										]))
								])),
							A2(
							$elm$html$Html$map,
							$author$project$Components$Marketplace$Product$QuotesMsg,
							A2($author$project$Components$Marketplace$Product$Quotes$view, model.qT, model.XI)),
							$author$project$Components$Marketplace$Product$viewDataFlows(product)
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Marketplace$Product$view = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Marketplace$Product$CallToAction$modal(model.bR),
				$author$project$Components$Marketplace$Product$viewContent(model)
			]));
};
var $author$project$Pages$Marketplace$Slug_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4, $author$project$Ui$Element$spaceBetween]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Marketplace__Top,
						_List_fromArray(
							[
								$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$arrowLeft)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Back to Marketplace')
							])),
						function () {
						var _v0 = _Utils_Tuple2(model.FR, model.VD);
						if (_v0.a && (!_v0.b.$)) {
							var partnerId = _v0.b.a;
							return A3(
								$author$project$Ui$HinterOnly$linkRoute,
								$author$project$Spa$Generated$Route$Partner__Product,
								_List_fromArray(
									[
										$author$project$Ui$Link$buttonDefault,
										$author$project$Ui$Link$routeParams(
										_List_fromArray(
											[
												A2($elm$url$Url$Builder$string, 'switch-to-partner', partnerId)
											])),
										$author$project$Ui$Link$targetBlank
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])),
				model.rA ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt2, $author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						$author$project$Ui$Typography$headingXl(
							_List_fromArray(
								[
									$elm$html$Html$text('Product not found.')
								])))
					])) : A2(
				$elm$html$Html$map,
				$author$project$Pages$Marketplace$Slug_String$ProductMsg,
				$author$project$Components$Marketplace$Product$view(model.W8))
			]),
		$G: 'Marketplace | ' + model._c
	};
};
var $author$project$Pages$Marketplace$Slug_String$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Marketplace$Slug_String$init, aer: $author$project$Pages$Marketplace$Slug_String$load, agD: $author$project$Pages$Marketplace$Slug_String$save, ahd: $author$project$Pages$Marketplace$Slug_String$subscriptions, aaq: $author$project$Pages$Marketplace$Slug_String$update, ahP: $author$project$Pages$Marketplace$Slug_String$view});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$GotIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple2(
			{kQ: $author$project$Api$Data$NotAsked, D5: shared.D5, Q4: $author$project$Api$Data$Loading, WF: practice, ZD: session, _c: params._c},
			A3($author$project$Api$Provider$Integration$retrieve, shared.D5, params._c, $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$GotIntegration));
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$PartnerActivated = function (a) {
	return {$: 2, a: a};
};
var $author$project$OutMsg$RefreshLayout = {$: 20};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Q4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var integration = msg.a;
				var cmd = function () {
					var _v1 = _Utils_Tuple3(
						$author$project$Api$Provider$Integration$One$authType(integration),
						$author$project$Api$Provider$Integration$One$connectionUrl(integration),
						$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
					_v1$0:
					while (true) {
						_v1$3:
						while (true) {
							_v1$4:
							while (true) {
								switch (_v1.a) {
									case 'automatic_redirect':
										if (!_v1.c.$) {
											if (!_v1.b.$) {
												break _v1$0;
											} else {
												break _v1$3;
											}
										} else {
											if (!_v1.b.$) {
												break _v1$0;
											} else {
												break _v1$4;
											}
										}
									case 'automatic_headless':
										return A3(
											$author$project$Api$Provider$Integration$connect,
											model.D5,
											$author$project$Api$Provider$Integration$One$id(integration),
											$author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$PartnerActivated);
									case 'manual':
										return $elm$core$Platform$Cmd$none;
									default:
										if (!_v1.c.$) {
											break _v1$3;
										} else {
											break _v1$4;
										}
								}
							}
							var _v2 = _v1.c;
							return $elm$core$Platform$Cmd$none;
						}
						var postActivationRedirectUrl = _v1.c.a;
						return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
					}
					var connectionUrl = _v1.b.a;
					return $author$project$Ports$Navigation$openInNewWindow(connectionUrl);
				}();
				var activationRequest = ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless') ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kQ: activationRequest}),
					cmd,
					($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless') ? _List_Nil : _List_fromArray(
						[
							A2(
							$author$project$OutMsg$ShowToast,
							3,
							$author$project$Api$Provider$Integration$One$name(integration) + ' activated')
						]));
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var integration = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kQ: response, Q4: response}),
						function () {
							var _v4 = _Utils_Tuple2(
								$author$project$Api$Provider$Integration$One$authType(integration),
								$author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
							if ((_v4.a === 'automatic_headless') && (!_v4.b.$)) {
								var postActivationRedirectUrl = _v4.b.a;
								return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
							} else {
								return A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
										{_c: model._c}));
							}
						}(),
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								$author$project$Api$Provider$Integration$One$name(integration) + ' activated'),
								$author$project$OutMsg$RefreshLayout
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kQ: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$Activate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate = function (integration) {
	return ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_redirect') || ($author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless');
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.Q4;
				if (_v0.$ === 3) {
					var integration = _v0.a;
					var status = $author$project$Api$Provider$Integration$One$status(integration);
					var name = $author$project$Api$Provider$Integration$One$name(integration);
					return A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										((status === 'pending') && $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate(integration)) ? A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpan(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$em,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('If you haven\'t been contacted by '),
																				$elm$html$Html$text(name),
																				$elm$html$Html$text(' about next steps for this integration, then something probably went wrong.')
																			]))
																	])),
																A3(
																$author$project$Ui$Button$view,
																{abp: 'Try again'},
																_List_fromArray(
																	[
																		$author$project$Ui$Button$onClick(
																		$author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$Activate(integration)),
																		$author$project$Ui$Button$primary,
																		$author$project$Ui$Button$loading(
																		_Utils_eq(model.kQ, $author$project$Api$Data$Loading))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Try again')
																	]))
															]))
													]))
											])) : $author$project$Utils$Html$empty,
										function () {
										if ((status === 'pending') && ($author$project$Api$Provider$Integration$One$active(integration) && (!$author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate(integration)))) {
											var email = $author$project$Api$Provider$Integration$One$email(integration);
											return A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Authorization Code'),
														$author$project$Ui$Form$Group$labelSpanSm(4),
														$author$project$Ui$Form$Group$inputSpanSm(8)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$pre,
																_List_fromArray(
																	[$author$project$Ui$Typography$authorizationCode]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2(
																			$elm$core$Maybe$withDefault,
																			'N/A',
																			$author$project$Api$Provider$Integration$One$authorizationCode(integration)))
																	])),
																A2(
																$author$project$Ui$Alert$warning,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$em,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(name),
																				$elm$html$Html$text(' does not support automatic integrations yet. Please email them at'),
																				A3(
																				$author$project$Ui$Link$mailto,
																				A2($elm$core$Maybe$withDefault, '', email),
																				_List_Nil,
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						A2($elm$core$Maybe$withDefault, '', email))
																					])),
																				$elm$html$Html$text(' and they can provide you with next steps.')
																			]))
																	]))
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]),
		$G: 'Onboarding'
	};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$init, aer: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$load, agD: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$save, ahd: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$subscriptions, aaq: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$update, ahP: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$view});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$GotIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple2(
			{D5: shared.D5, Q4: $author$project$Api$Data$Loading, WF: practice, ZD: session, cq: $elm$core$Maybe$Nothing, _c: params._c},
			A3($author$project$Api$Provider$Integration$retrieve, shared.D5, params._c, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$GotIntegration));
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var integration = response.a;
				var _v2 = $author$project$Api$Provider$Integration$One$partnerApp(integration);
				if (!_v2.$) {
					var partnerApp = _v2.a;
					var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp);
					if (!settingsAnchor.$) {
						var _v4 = $author$project$Components$Admin$PartnerApp$Settings$init(partnerApp);
						var settings = _v4.a;
						var settingsCmd = _v4.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Q4: response,
									cq: $elm$core$Maybe$Just(settings)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg, settingsCmd),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{Q4: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Q4: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Q4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var settingsMsg = msg.a;
			var _v5 = model.cq;
			if (!_v5.$) {
				var settings = _v5.a;
				var _v6 = A2($author$project$Components$Admin$PartnerApp$Settings$update, settingsMsg, settings);
				var newSettings = _v6.a;
				var settingsCmd = _v6.b;
				var outMsgs = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cq: $elm$core$Maybe$Just(newSettings)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg, settingsCmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.cq;
				if (!_v0.$) {
					var settings = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg,
						$author$project$Components$Admin$PartnerApp$Settings$view(settings));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]),
		$G: 'Settings'
	};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$init, aer: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$load, agD: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$save, ahd: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$subscriptions, aaq: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$update, ahP: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$view});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$GotIntegration = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple2(
			{D5: shared.D5, Q4: $author$project$Api$Data$Loading, jl: $elm$core$Maybe$Nothing, WF: practice, ZD: session, _c: params._c},
			A3($author$project$Api$Provider$Integration$retrieve, shared.D5, params._c, $author$project$Pages$Marketplace$Slug_String$Manage$Users$GotIntegration));
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$subscriptions = function (model) {
	var _v0 = model.jl;
	if (!_v0.$) {
		var partnerAppTeam = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg,
			$author$project$Components$Admin$PartnerApp$Team$subscriptions(partnerAppTeam));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			if (response.$ === 3) {
				var integration = response.a;
				var _v2 = $author$project$Api$Provider$Integration$One$partnerApp(integration);
				if (!_v2.$) {
					var partnerApp = _v2.a;
					var _v3 = A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A4(
								$author$project$Components$Admin$PartnerApp$Team$init,
								model.D5,
								integration,
								partnerApp,
								$author$project$Api$Platform$Session$One$user(model.ZD))));
					var partnerAppTeam = _v3.a;
					var partnerAppTeamCmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Q4: response, jl: partnerAppTeam}),
						partnerAppTeamCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Q4: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Q4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			var subMsg = msg.a;
			var _v4 = model.jl;
			if (!_v4.$) {
				var partnerAppTeam = _v4.a;
				var result = A3($author$project$Components$Admin$PartnerApp$Team$update, model.D5, subMsg, partnerAppTeam);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jl: $elm$core$Maybe$Just(result.y8)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg, result.EC),
					result.as);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$viewBody = function (model) {
	var _v0 = model.jl;
	if (!_v0.$) {
		var partnerAppTeam = _v0.a;
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg),
				$author$project$Components$Admin$PartnerApp$Team$modal(partnerAppTeam)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg,
					$author$project$Components$Admin$PartnerApp$Team$view(partnerAppTeam))
				]));
	} else {
		var _v1 = model.Q4;
		if (_v1.$ === 1) {
			return _List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil)
				]);
		} else {
			return _List_Nil;
		}
	}
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$view = function (model) {
	return {
		e5: $author$project$Pages$Marketplace$Slug_String$Manage$Users$viewBody(model),
		$G: 'Manage Users'
	};
};
var $author$project$Pages$Marketplace$Slug_String$Manage$Users$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Marketplace$Slug_String$Manage$Users$init, aer: $author$project$Pages$Marketplace$Slug_String$Manage$Users$load, agD: $author$project$Pages$Marketplace$Slug_String$Manage$Users$save, ahd: $author$project$Pages$Marketplace$Slug_String$Manage$Users$subscriptions, aaq: $author$project$Pages$Marketplace$Slug_String$Manage$Users$update, ahP: $author$project$Pages$Marketplace$Slug_String$Manage$Users$view});
var $author$project$Pages$Marketplace$Top$CategoryDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Marketplace$Top$GotCategories = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Feature$MarketplaceViewTiles = 25;
var $author$project$Pages$Marketplace$Top$determineCanViewTiles = function (shared) {
	return $author$project$Shared$isHintAdmin(shared) || A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Practice$featureEnabled(25),
			$author$project$Api$Data$toMaybe(shared.WF)));
};
var $author$project$Api$Platform$Marketplace$ProductCategory$productCategoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['marketplace', 'product_categories']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Marketplace$ProductCategory$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Marketplace$ProductCategory$productCategoriesPath));
	});
var $author$project$Pages$Marketplace$Top$productTypeFromQuery = function (queryString) {
	_v0$3:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'app':
					return $elm$core$Maybe$Just(0);
				case 'integration':
					return $elm$core$Maybe$Just(1);
				case 'solution':
					return $elm$core$Maybe$Just(2);
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Pages$Marketplace$Top$init = F3(
	function (session, shared, _v0) {
		var query = _v0.Bi;
		var selectedCategories = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$split(','),
				A2($elm$core$Dict$get, 'category', query)));
		var q = A2($elm$core$Dict$get, 'q', query);
		var productTypeQuery = A2($elm$core$Dict$get, 'type', query);
		var productType = $author$project$Pages$Marketplace$Top$productTypeFromQuery(productTypeQuery);
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				li: $author$project$Pages$Marketplace$Top$determineCanViewTiles(shared),
				KL: $author$project$Api$Data$Loading,
				lm: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'category-dropdown', ahx: $author$project$Pages$Marketplace$Top$CategoryDropdownMsg})),
				Fy: false,
				FR: $author$project$Shared$isHintAdmin(shared),
				GT: productType,
				af_: q,
				sA: $author$project$Ui$SearchInput$init(q),
				co: selectedCategories,
				ZD: session
			},
			A2($author$project$Api$Platform$Marketplace$ProductCategory$list, shared.D5, $author$project$Pages$Marketplace$Top$GotCategories));
	});
var $author$project$Pages$Marketplace$Top$load = F2(
	function (shared, model) {
		return model.li ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
			_Utils_update(
				model,
				{
					li: $author$project$Pages$Marketplace$Top$determineCanViewTiles(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Marketplace$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Marketplace$Top$subscriptions = function (model) {
	return $author$project$Ui$NewDropdown$subscriptions(model.lm);
};
var $author$project$Pages$Marketplace$Top$SearchInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Marketplace$Top$productTypeToValue = function (productType) {
	switch (productType) {
		case 0:
			return 'app';
		case 1:
			return 'integration';
		default:
			return 'solution';
	}
};
var $author$project$Pages$Marketplace$Top$updateUrl = function (model) {
	var categoryParam = $elm$core$List$isEmpty(model.co) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$url$Url$Builder$string,
			'category',
			A2($elm$core$String$join, ',', model.co)));
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Pages$Marketplace$Top$productTypeToValue,
				$elm$url$Url$Builder$string('type')),
			model.GT),
			categoryParam
		]);
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Top)
				]),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Marketplace$Top$andUpdateUrl = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var outMsgs = _v0.c;
	return _Utils_Tuple3(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					$author$project$Pages$Marketplace$Top$updateUrl(model)
				])),
		outMsgs);
};
var $author$project$Pages$Marketplace$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v1.a;
				var searchInputCmd = _v1.b;
				var searchInputEvent = _v1.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				return $author$project$Pages$Marketplace$Top$andUpdateUrl(
					_Utils_Tuple3(
						_Utils_update(
							model,
							{af_: q, sA: searchInput}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Top$SearchInputMsg, searchInputCmd),
						_List_Nil));
			case 1:
				var productType = msg.a;
				return $author$project$Pages$Marketplace$Top$andUpdateUrl(
					_Utils_Tuple3(
						_Utils_update(
							model,
							{GT: productType}),
						$elm$core$Platform$Cmd$none,
						_List_Nil));
			case 2:
				var dropdownMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.lm);
				var categoryDropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lm: categoryDropdown}),
					dropdownCmd,
					_List_Nil);
			case 3:
				var category = msg.a;
				var checked = msg.b;
				var selectedCategories = checked ? A2($elm$core$List$cons, category, model.co) : A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(category),
					model.co);
				return $author$project$Pages$Marketplace$Top$andUpdateUrl(
					_Utils_Tuple3(
						_Utils_update(
							model,
							{co: selectedCategories}),
						$elm$core$Platform$Cmd$none,
						_List_Nil));
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{KL: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var hinterMode = msg.a;
				var newModel = _Utils_update(
					model,
					{Fy: hinterMode});
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$Marketplace$Top$HinterModeToggled = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Marketplace$Top$categoriesToLabel = function (selectedCategories) {
	if (!selectedCategories.b) {
		return 'Categories';
	} else {
		if (!selectedCategories.b.b) {
			var single = selectedCategories.a;
			return single;
		} else {
			var multiple = selectedCategories;
			return 'Categories (' + ($elm$core$String$fromInt(
				$elm$core$List$length(multiple)) + ')');
		}
	}
};
var $author$project$Pages$Marketplace$Top$CategoryToggled = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Marketplace$Top$categoryItems = F2(
	function (selectedCategories, categories) {
		return A2(
			$elm$core$List$map,
			function (cat) {
				var categoryName = $author$project$Api$Common$Marketplace$Product$Category$name(cat);
				var isChecked = A2($elm$core$List$member, categoryName, selectedCategories);
				return A2(
					$author$project$Ui$NewDropdown$checkbox,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$onCheck(
							$author$project$Pages$Marketplace$Top$CategoryToggled(categoryName)),
							$author$project$Ui$NewDropdown$checked(isChecked)
						]),
					$elm$html$Html$text(categoryName));
			},
			categories);
	});
var $author$project$Pages$Marketplace$Top$viewBody = function (model) {
	var isPartner = $author$project$Api$Platform$Session$One$organizationIsPartner(model.ZD);
	var categoryAttribute = $elm$core$List$isEmpty(model.co) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		A2(
			$elm$html$Html$Attributes$attribute,
			'category',
			A2($elm$core$String$join, ',', model.co)));
	var attributes = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$elm$html$Html$Attributes$attribute('q'),
				model.af_),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Pages$Marketplace$Top$productTypeToValue,
					$elm$html$Html$Attributes$attribute('type')),
				model.GT),
				categoryAttribute,
				$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$Attributes$attribute,
					'is-partner',
					$author$project$Utils$Bool$toString(isPartner))),
				$elm$core$Maybe$Just(
				$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('hidden', !model.li)
						]))),
				$elm$core$Maybe$Just(
				A2(
					$elm$html$Html$Attributes$attribute,
					'hinter-mode',
					$author$project$Utils$Bool$toString(model.Fy)))
			]));
	return A3($elm$html$Html$node, 'hint-marketplace', attributes, _List_Nil);
};
var $author$project$Pages$Marketplace$Top$ProductTypeSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Element$Hidden = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Element$hidden = $author$project$Ui$Element$Hidden(0);
var $author$project$Ui$Element$inlineBlockMd = A2($author$project$Ui$Element$Display, 2, 1);
var $author$project$Pages$Marketplace$Top$viewProductTypeButtons = function (currentProductType) {
	return $author$project$Ui$Button$group(
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'All Partners'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(
						_Utils_eq(currentProductType, $elm$core$Maybe$Nothing)),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Marketplace$Top$ProductTypeSelected($elm$core$Maybe$Nothing))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('All'),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$hidden, $author$project$Ui$Element$inlineBlockMd, $author$project$Ui$Element$ml1]),
						_List_fromArray(
							[
								$elm$html$Html$text('Partners')
							]))
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Apps'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(
						_Utils_eq(
							currentProductType,
							$elm$core$Maybe$Just(0))),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Marketplace$Top$ProductTypeSelected(
							$elm$core$Maybe$Just(0)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Apps')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Integrations'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(
						_Utils_eq(
							currentProductType,
							$elm$core$Maybe$Just(1))),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Marketplace$Top$ProductTypeSelected(
							$elm$core$Maybe$Just(1)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Integrations')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Solutions'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(
						_Utils_eq(
							currentProductType,
							$elm$core$Maybe$Just(2))),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Marketplace$Top$ProductTypeSelected(
							$elm$core$Maybe$Just(2)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Solutions')
					]))
			]));
};
var $author$project$Pages$Marketplace$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A3(
				$author$project$Ui$Element$custom,
				'layout-header',
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Marketplace')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										model.FR ? A3(
										$author$project$Ui$HinterOnly$button,
										{abp: 'Admin Mode'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Marketplace$Top$HinterModeToggled(!model.Fy)),
												$author$project$Ui$Button$active(model.Fy),
												$author$project$Ui$Button$secondary
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Admin Mode')
											])) : $author$project$Utils$Html$empty,
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Marketplace__Manage,
										_List_fromArray(
											[$author$project$Ui$Link$buttonDefault]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage partners')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('Discover apps, integrations and solutions to extend your Hint experience')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$mb4]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(4),
												$author$project$Ui$FlexGrid$spanLg(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Marketplace$Top$SearchInputMsg,
												A2(
													$author$project$Ui$SearchInput$view,
													_List_fromArray(
														[
															$author$project$Ui$SearchInput$placeholder('Search Partners...'),
															$author$project$Ui$SearchInput$immediate
														]),
													model.sA))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(8),
												$author$project$Ui$FlexGrid$spanLg(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flex]),
												_List_fromArray(
													[
														$author$project$Pages$Marketplace$Top$viewProductTypeButtons(model.GT),
														function () {
														var _v0 = model.KL;
														if (_v0.$ === 3) {
															var categories = _v0.a;
															return A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$flexAuto]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$Ui$NewDropdown$viewSelect,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Pages$Marketplace$Top$categoriesToLabel(model.co))
																			]),
																		A2($author$project$Pages$Marketplace$Top$categoryItems, model.co, categories),
																		model.lm)
																	]));
														} else {
															return $author$project$Utils$Html$empty;
														}
													}()
													]))
											]))
									]))
							]))
					])),
				$author$project$Pages$Marketplace$Top$viewBody(model),
				(!model.li) ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt2, $author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						$author$project$Ui$Typography$headingXl(
							_List_fromArray(
								[
									$elm$html$Html$text('Launching at '),
									A3(
									$author$project$Ui$Link$externalHref,
									'https://summit.hint.com',
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text('Hint Summit.')
										]))
								])))
					])) : $author$project$Utils$Html$empty
			]),
		$G: 'Marketplace'
	};
};
var $author$project$Pages$Marketplace$Top$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Marketplace$Top$init, aer: $author$project$Pages$Marketplace$Top$load, agD: $author$project$Pages$Marketplace$Top$save, ahd: $author$project$Pages$Marketplace$Top$subscriptions, aaq: $author$project$Pages$Marketplace$Top$update, ahP: $author$project$Pages$Marketplace$Top$view});
var $author$project$Pages$Messages$Calls$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Calls$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Calls$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Calls$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Phone Calls'};
};
var $author$project$Pages$Messages$Calls$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Calls$init,
		aer: $author$project$Pages$Messages$Calls$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Calls$update,
		ahP: $author$project$Pages$Messages$Calls$view
	});
var $author$project$Pages$Messages$Drafts$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Drafts$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Drafts$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Drafts$view = function (_v0) {
	return {e5: _List_Nil, $G: 'My Drafts'};
};
var $author$project$Pages$Messages$Drafts$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Drafts$init,
		aer: $author$project$Pages$Messages$Drafts$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Drafts$update,
		ahP: $author$project$Pages$Messages$Drafts$view
	});
var $author$project$Pages$Messages$Faxes$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Faxes$New$view = function (_v0) {
	return {e5: _List_Nil, $G: 'New Fax'};
};
var $author$project$Pages$Messages$Faxes$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Faxes$New$init,
		aer: $author$project$Pages$Messages$Faxes$New$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Faxes$New$update,
		ahP: $author$project$Pages$Messages$Faxes$New$view
	});
var $author$project$Pages$Messages$Faxes$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Faxes$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Faxes$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Faxes'};
};
var $author$project$Pages$Messages$Faxes$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Faxes$Top$init,
		aer: $author$project$Pages$Messages$Faxes$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Faxes$Top$update,
		ahP: $author$project$Pages$Messages$Faxes$Top$view
	});
var $author$project$Pages$Messages$Forms$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Forms$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Forms$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Forms$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Forms'};
};
var $author$project$Pages$Messages$Forms$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Forms$init,
		aer: $author$project$Pages$Messages$Forms$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Forms$update,
		ahP: $author$project$Pages$Messages$Forms$view
	});
var $author$project$Pages$Messages$Labs$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Labs$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Labs$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Labs$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Lab Results'};
};
var $author$project$Pages$Messages$Labs$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Labs$init,
		aer: $author$project$Pages$Messages$Labs$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Labs$update,
		ahP: $author$project$Pages$Messages$Labs$view
	});
var $author$project$Pages$Messages$Messages$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Messages$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Messages$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Messages$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Messages'};
};
var $author$project$Pages$Messages$Messages$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Messages$init,
		aer: $author$project$Pages$Messages$Messages$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Messages$update,
		ahP: $author$project$Pages$Messages$Messages$view
	});
var $author$project$Pages$Messages$Scheduled$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Scheduled$New$view = function (_v0) {
	return {e5: _List_Nil, $G: 'New Scheduled Event'};
};
var $author$project$Pages$Messages$Scheduled$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Scheduled$New$init,
		aer: $author$project$Pages$Messages$Scheduled$New$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Scheduled$New$update,
		ahP: $author$project$Pages$Messages$Scheduled$New$view
	});
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Edut Scheduled Event'};
};
var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$init,
		aer: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$update,
		ahP: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$view
	});
var $author$project$Pages$Messages$Scheduled$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Scheduled$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Scheduled$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Scheduled'};
};
var $author$project$Pages$Messages$Scheduled$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Scheduled$Top$init,
		aer: $author$project$Pages$Messages$Scheduled$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Scheduled$Top$update,
		ahP: $author$project$Pages$Messages$Scheduled$Top$view
	});
var $author$project$Pages$Messages$Sms$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Sms$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Messages$Sms$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Messages$Sms$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Inbox'};
};
var $author$project$Pages$Messages$Sms$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Messages$Sms$init,
		aer: $author$project$Pages$Messages$Sms$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Messages$Sms$update,
		ahP: $author$project$Pages$Messages$Sms$view
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Edit Appointment Type'};
};
var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$init,
		aer: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$update,
		ahP: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$view
	});
var $author$project$Pages$NewSettings$AppointmentTypes$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$New$view = function (_v0) {
	return {e5: _List_Nil, $G: 'New Appointment Type'};
};
var $author$project$Pages$NewSettings$AppointmentTypes$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$AppointmentTypes$New$init,
		aer: $author$project$Pages$NewSettings$AppointmentTypes$New$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$AppointmentTypes$New$update,
		ahP: $author$project$Pages$NewSettings$AppointmentTypes$New$view
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$AppointmentTypes$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Appointment Types'};
};
var $author$project$Pages$NewSettings$AppointmentTypes$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$AppointmentTypes$Top$init,
		aer: $author$project$Pages$NewSettings$AppointmentTypes$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$AppointmentTypes$Top$update,
		ahP: $author$project$Pages$NewSettings$AppointmentTypes$Top$view
	});
var $author$project$Pages$NewSettings$Erx$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Erx$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Erx$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Erx$view = function (_v0) {
	return {e5: _List_Nil, $G: 'eRx'};
};
var $author$project$Pages$NewSettings$Erx$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Erx$init,
		aer: $author$project$Pages$NewSettings$Erx$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Erx$update,
		ahP: $author$project$Pages$NewSettings$Erx$view
	});
var $author$project$Pages$NewSettings$HinterSettings$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$HinterSettings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$HinterSettings$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$HinterSettings$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Hinter Settings'};
};
var $author$project$Pages$NewSettings$HinterSettings$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$HinterSettings$init,
		aer: $author$project$Pages$NewSettings$HinterSettings$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$HinterSettings$update,
		ahP: $author$project$Pages$NewSettings$HinterSettings$view
	});
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Edit Location'};
};
var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$init,
		aer: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$update,
		ahP: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$view
	});
var $author$project$Pages$NewSettings$Locations$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Locations$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Locations$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Calendar Locations'};
};
var $author$project$Pages$NewSettings$Locations$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Locations$Top$init,
		aer: $author$project$Pages$NewSettings$Locations$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Locations$Top$update,
		ahP: $author$project$Pages$NewSettings$Locations$Top$view
	});
var $author$project$Pages$NewSettings$PracticeInfo$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$PracticeInfo$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$PracticeInfo$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$PracticeInfo$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Practice Info'};
};
var $author$project$Pages$NewSettings$PracticeInfo$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$PracticeInfo$init,
		aer: $author$project$Pages$NewSettings$PracticeInfo$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$PracticeInfo$update,
		ahP: $author$project$Pages$NewSettings$PracticeInfo$view
	});
var $author$project$Pages$NewSettings$Team$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Team$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Team'};
};
var $author$project$Pages$NewSettings$Team$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Team$init,
		aer: $author$project$Pages$NewSettings$Team$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Team$update,
		ahP: $author$project$Pages$NewSettings$Team$view
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Team Member'};
};
var $author$project$Pages$NewSettings$Team$TeamId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Team$TeamId_String$init,
		aer: $author$project$Pages$NewSettings$Team$TeamId_String$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Team$TeamId_String$update,
		ahP: $author$project$Pages$NewSettings$Team$TeamId_String$view
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Team Member - Basic Info'};
};
var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$init,
		aer: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$update,
		ahP: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$view
	});
var $author$project$Pages$NewSettings$Templates$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Templates$New$view = function (_v0) {
	return {e5: _List_Nil, $G: 'New Template'};
};
var $author$project$Pages$NewSettings$Templates$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Templates$New$init,
		aer: $author$project$Pages$NewSettings$Templates$New$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Templates$New$update,
		ahP: $author$project$Pages$NewSettings$Templates$New$view
	});
var $author$project$Pages$NewSettings$Templates$TemplateId_String$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$TemplateId_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$TemplateId_String$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Templates$TemplateId_String$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Edit Template'};
};
var $author$project$Pages$NewSettings$Templates$TemplateId_String$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Templates$TemplateId_String$init,
		aer: $author$project$Pages$NewSettings$Templates$TemplateId_String$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Templates$TemplateId_String$update,
		ahP: $author$project$Pages$NewSettings$Templates$TemplateId_String$view
	});
var $author$project$Pages$NewSettings$Templates$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$NewSettings$Templates$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$NewSettings$Templates$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Templates'};
};
var $author$project$Pages$NewSettings$Templates$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$NewSettings$Templates$Top$init,
		aer: $author$project$Pages$NewSettings$Templates$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$NewSettings$Templates$Top$update,
		ahP: $author$project$Pages$NewSettings$Templates$Top$view
	});
var $author$project$Pages$NotFound$init = F2(
	function (shared, _v0) {
		var route = function () {
			var _v1 = shared.ZD;
			if (_v1.$ === 3) {
				var session = _v1.a;
				return A2($author$project$Permission$homeStateFor, session, shared.adN);
			} else {
				return $author$project$Spa$Generated$Route$Login;
			}
		}();
		return _Utils_Tuple3(
			{d: route, aa1: shared.aa1},
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$NotFound$load = F2(
	function (shared, model) {
		var _v0 = _Utils_Tuple2(shared.ZD, shared.aa1);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var session = _v1.a;
			var _v2 = _v0.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						d: A2($author$project$Permission$homeStateFor, session, shared.adN),
						aa1: shared.aa1
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$NotFound$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$NotFound$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$NotFound$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Api$WhitelabelSetting$branded = function (_v0) {
	var record = _v0;
	return record.El;
};
var $author$project$Ui$SvgIcon$Hint404 = 30;
var $author$project$Ui$SvgIcon$hint404 = $author$project$Ui$SvgIcon$viewIcon(30);
var $author$project$Ui$SvgIcon$SpacedBottom = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$SvgIcon$mb4 = $author$project$Ui$SvgIcon$SpacedBottom(4);
var $author$project$Api$WhitelabelSetting$practiceFacingLogoUrl = function (_v0) {
	var record = _v0;
	return record.GN;
};
var $author$project$Pages$NotFound$viewBody = F2(
	function (route, dataWhitelabelSetting) {
		var loading = function () {
			if (dataWhitelabelSetting.$ === 3) {
				return false;
			} else {
				return true;
			}
		}();
		var _v0 = function () {
			if (dataWhitelabelSetting.$ === 3) {
				var whitelabelSetting = dataWhitelabelSetting.a;
				return _Utils_Tuple2(
					$author$project$Api$WhitelabelSetting$branded(whitelabelSetting),
					$author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
			} else {
				return _Utils_Tuple2(false, $elm$core$Maybe$Nothing);
			}
		}();
		var showCustomLogo = _v0.a;
		var imgUrl = _v0.b;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$mt8]),
				_List_fromArray(
					[
						loading ? $author$project$Ui$Skeleton$card(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(2)
							])) : (showCustomLogo ? A3(
						$author$project$Ui$Image$fromSrc,
						{I1: 'App Logo'},
						A2($elm$core$Maybe$withDefault, '', imgUrl),
						_List_Nil) : $author$project$Ui$SvgIcon$hint404(
						_List_fromArray(
							[$author$project$Ui$SvgIcon$mb4]))),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('We couldn’t find this page...')
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$elm$html$Html$text('Sorry, the page you’re looking for doesn’t exist or has been moved')
							])),
						A3(
						$author$project$Ui$Link$route,
						route,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Take me Home')
							]))
					]))
			]);
	});
var $author$project$Pages$NotFound$view = function (_v0) {
	var route = _v0.d;
	var whitelabelSetting = _v0.aa1;
	return {
		e5: A2($author$project$Pages$NotFound$viewBody, route, whitelabelSetting),
		$G: 'Page Not Found'
	};
};
var $author$project$Pages$NotFound$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$NotFound$init, aer: $author$project$Pages$NotFound$load, agD: $author$project$Pages$NotFound$save, ahd: $author$project$Pages$NotFound$subscriptions, aaq: $author$project$Pages$NotFound$update, ahP: $author$project$Pages$NotFound$view});
var $author$project$Pages$Oauth$Callback$init = F2(
	function (shared, _v0) {
		var query = _v0.Bi;
		if ($elm$core$Dict$isEmpty(query)) {
			return _Utils_Tuple3(
				{},
				A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Login),
				_List_Nil);
		} else {
			var _v1 = shared.ZD;
			switch (_v1.$) {
				case 3:
					var session = _v1.a;
					return _Utils_Tuple3(
						{},
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							A2($author$project$Permission$homeStateFor, session, shared.adN)),
						_List_Nil);
				case 1:
					return _Utils_Tuple3(
						{},
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				default:
					return _Utils_Tuple3(
						{},
						$author$project$Ports$Session$authorize(
							{af6: true}),
						_List_Nil);
			}
		}
	});
var $author$project$Pages$Oauth$Callback$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Oauth$Callback$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Oauth$Callback$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Oauth$Callback$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Oauth$Callback$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Login'};
};
var $author$project$Pages$Oauth$Callback$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$Oauth$Callback$init, aer: $author$project$Pages$Oauth$Callback$load, agD: $author$project$Pages$Oauth$Callback$save, ahd: $author$project$Pages$Oauth$Callback$subscriptions, aaq: $author$project$Pages$Oauth$Callback$update, ahP: $author$project$Pages$Oauth$Callback$view});
var $author$project$Spa$Page$applicationOnlyPublic = function (page) {
	return {
		ad0: F2(
			function (shared, url) {
				var _v0 = shared.ZD;
				switch (_v0.$) {
					case 3:
						return A2(page.ad0, shared, url);
					case 0:
						var _v1 = A2(page.ad0, shared, url);
						var model = _v1.a;
						var cmd = _v1.b;
						var outMsgs = _v1.c;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmd,
										$author$project$Ports$Session$authorize(
										{af6: false})
									])),
							outMsgs);
					default:
						return A2(page.ad0, shared, url);
				}
			}),
		aer: F2(
			function (shared, model) {
				return A2(page.aer, shared, model);
			}),
		agD: page.agD,
		ahd: page.ahd,
		aaq: page.aaq,
		ahP: page.ahP
	};
};
var $author$project$Pages$Onboard$DealId_String$Top$GotPracticeOnboarding = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$OnboardingStepper$PracticeInfo = 0;
var $author$project$Components$OnboardingStepper$defaultStepId = 0;
var $author$project$Components$OnboardingStepper$InternalStep = F3(
	function (id, index, label) {
		return {adR: id, x4: index, aej: label};
	});
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Components$OnboardingStepper$Completed = 3;
var $author$project$Components$OnboardingStepper$PaymentSetup = 2;
var $author$project$Components$OnboardingStepper$UserCreation = 1;
var $author$project$Components$OnboardingStepper$stepIds = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Components$OnboardingStepper$stepIndex = function (stepId) {
	return A2(
		$elm$core$Maybe$withDefault,
		-1,
		A2($elm_community$list_extra$List$Extra$elemIndex, stepId, $author$project$Components$OnboardingStepper$stepIds));
};
var $author$project$Components$OnboardingStepper$stepLabel = function (stepId) {
	switch (stepId) {
		case 0:
			return 'Account Information';
		case 1:
			return 'Account Owner Setup';
		case 2:
			return 'Billing Setup';
		default:
			return '';
	}
};
var $author$project$Components$OnboardingStepper$buildInternalStep = function (stepId) {
	return A3(
		$author$project$Components$OnboardingStepper$InternalStep,
		stepId,
		$author$project$Components$OnboardingStepper$stepIndex(stepId),
		$author$project$Components$OnboardingStepper$stepLabel(stepId));
};
var $author$project$Components$OnboardingStepper$internalSteps = A2($elm$core$List$map, $author$project$Components$OnboardingStepper$buildInternalStep, $author$project$Components$OnboardingStepper$stepIds);
var $author$project$Components$OnboardingStepper$init = function (stepId) {
	return {
		EP: $author$project$Components$OnboardingStepper$buildInternalStep(stepId),
		_O: $author$project$Components$OnboardingStepper$internalSteps
	};
};
var $author$project$Api$Provider$PracticeOnboarding$One$PracticeOnboarding = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$One$Record = F5(
	function (ident, practiceName, step, emr, dealId) {
		return {act: dealId, acY: emr, adS: ident, afQ: practiceName, _M: step};
	});
var $author$project$Api$Provider$PracticeOnboarding$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deal_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'emr',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practice$Emr$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'step',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practice_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ident',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeOnboarding$One$Record))))));
var $author$project$Api$Provider$PracticeOnboarding$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PracticeOnboarding$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PracticeOnboarding$retrieve = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticeOnboarding$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id_)));
	});
var $author$project$Pages$Onboard$DealId_String$Top$init = F2(
	function (shared, _v0) {
		var params = _v0.Vx;
		var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
		var currentStep = stepperModel.EP;
		return _Utils_Tuple3(
			{EP: currentStep, act: params.act, jx: $elm$core$Maybe$Nothing, WJ: $author$project$Api$Data$NotAsked, Cd: shared, _N: stepperModel},
			A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.D5, params.act, $author$project$Pages$Onboard$DealId_String$Top$GotPracticeOnboarding),
			_List_Nil);
	});
var $author$project$Pages$Onboard$DealId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Onboard$DealId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Onboard$PracticeInfo$GotRecaptchaToken = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$subscriptions = function (_v0) {
	var model = _v0;
	return $author$project$Ui$NewDropdown$subscriptions(model.l1);
};
var $author$project$Pages$Onboard$DealId_String$Top$subscriptions = function (_v0) {
	var practiceForm = _v0.jx;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$GoogleRecaptcha$gotRecaptchaToken(
				A2($elm$core$Basics$composeL, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, $author$project$Components$Onboard$PracticeInfo$GotRecaptchaToken)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Onboard$PracticeInfo$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg)),
					practiceForm))
			]));
};
var $author$project$Pages$Onboard$DealId_String$Top$GotNewPracticeOnboarding = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$One$dealId = function (_v0) {
	var record = _v0;
	return record.act;
};
var $author$project$Api$Provider$PracticeOnboarding$One$ident = function (_v0) {
	var record = _v0;
	return record.adS;
};
var $author$project$Components$Onboard$PracticeInfo$DateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Onboard$PracticeInfo$EmrDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$One$emr = function (_v0) {
	var record = _v0;
	return record.acY;
};
var $author$project$Api$Provider$PracticeOnboarding$One$practiceName = function (_v0) {
	var record = _v0;
	return record.afQ;
};
var $author$project$Components$Onboard$PracticeInfo$init = F3(
	function (dealId, shared, practiceOnboarding) {
		var emr = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
		var _v0 = $author$project$Components$DateInput$init;
		var dateInput = _v0.a;
		var dateInputCmd = _v0.b;
		var inittedForm = $author$project$Utils$Form$init(
			{
				kR: $elm$core$Maybe$Nothing,
				qd: dateInput,
				act: dealId,
				acY: emr,
				ac_: $elm$core$Maybe$Nothing,
				SG: $elm$core$Maybe$Nothing,
				zh: $author$project$Api$Provider$PracticeOnboarding$One$practiceName(practiceOnboarding)
			});
		return _Utils_Tuple2(
			{
				l1: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'emr', ahx: $author$project$Components$Onboard$PracticeInfo$EmrDropdownMsg})),
				PB: inittedForm,
				Cd: shared,
				kj: false
			},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Onboard$PracticeInfo$DateInputMsg(dateInput),
				dateInputCmd));
	});
var $author$project$Api$Provider$PracticeOnboarding$new = F3(
	function (apiClient, dealId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PracticeOnboarding$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'deal_id', dealId)
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['new']),
						$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath))));
	});
var $author$project$Components$OnboardingStepper$redirectToLastStep = F2(
	function (step, onboardId) {
		switch (step) {
			case 0:
				return A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$empty,
					$author$project$Spa$Generated$Route$Onboard__OnboardId_String__User(
						{afq: onboardId}));
			case 1:
				return A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$empty,
					$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment(
						{afq: onboardId}));
			case 2:
				return A2(
					$author$project$Utils$Route$navigate,
					$elm$core$Dict$empty,
					$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing(
						{afq: onboardId}));
			default:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Practice);
		}
	});
var $author$project$Api$Provider$PracticeOnboarding$One$step = function (_v0) {
	var record = _v0;
	return record._M;
};
var $author$project$Components$OnboardingStepper$stepToType = function (string) {
	switch (string) {
		case 'practice_info':
			return 0;
		case 'user_creation':
			return 1;
		case 'payment_setup':
			return 2;
		case 'completed':
			return 3;
		default:
			return 0;
	}
};
var $author$project$Components$Onboard$PracticeInfo$Emr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$EmrOther = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$LaunchDate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Ports$GoogleRecaptcha$Onboard = 0;
var $author$project$Components$Onboard$PracticeInfo$PracticeOnboardingCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_onboarding',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'deal_id',
								$elm$json$Json$Encode$string(fields.act)),
								_Utils_Tuple2(
								'emr',
								A2(
									$author$project$Utils$Encode$nullable,
									A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$Emr$toValue, $elm$json$Json$Encode$string),
									fields.acY)),
								_Utils_Tuple2(
								'estimated_memberships_count',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.ac4)),
								_Utils_Tuple2(
								'launch_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.SG)),
								_Utils_Tuple2(
								'practice_name',
								$elm$json$Json$Encode$string(fields.afQ))
							]))),
					_Utils_Tuple2(
					'google_recaptcha_token',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.af4))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeOnboarding$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath)));
	});
var $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var name = field.a;
				return _Utils_update(
					fields,
					{zh: name});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						kR: $elm$core$String$toInt(string)
					});
			case 1:
				var maybeEmr = field.a;
				return _Utils_update(
					fields,
					{acY: maybeEmr});
			case 2:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{ac_: maybeString});
			default:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{qd: dateInput, SG: date});
		}
	});
var $author$project$Components$Onboard$PracticeInfo$ActiveMembersCountValidation = 1;
var $author$project$Components$Onboard$PracticeInfo$NameValidation = 0;
var $author$project$Components$Onboard$PracticeInfo$LaunchDateValidation = 2;
var $author$project$Components$Onboard$PracticeInfo$validateLaunchDate = function (fields) {
	var _v0 = fields.SG;
	if (_v0.$ === 1) {
		return _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please enter an estimated launch date.')
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Onboard$PracticeInfo$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a practice name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function (fields) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.kR));
			},
			_Utils_Tuple2(1, 'Please enter an active members count.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Onboard$PracticeInfo$validateLaunchDate)
		]));
var $author$project$Components$Onboard$PracticeInfo$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Onboard$PracticeInfo$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: validForm, kj: true}),
						$author$project$Ports$GoogleRecaptcha$getRecaptchaToken(0),
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 6:
				var result = msg.a;
				var recaptchaToken = $elm$core$Result$toMaybe(result);
				var fields = $author$project$Utils$Form$fields(model.PB);
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$PracticeOnboarding$create,
						model.Cd.D5,
						{act: fields.act, acY: fields.acY, ac4: fields.kR, SG: fields.SG, afQ: fields.zh, af4: recaptchaToken},
						$author$project$Components$Onboard$PracticeInfo$PracticeOnboardingCreated),
					_List_Nil);
			case 5:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var practiceOnboarding = response.a;
						var onboardId = $author$project$Api$Provider$PracticeOnboarding$One$ident(practiceOnboarding);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Onboard__OnboardId_String__User(
									{afq: onboardId})),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$NewDropdown$update, subMsg, model.l1);
				var newDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l1: newDropdown}),
					cmd,
					_List_Nil);
			case 2:
				var emrOption = msg.a;
				var newForm = function () {
					if (!emrOption.$) {
						var emr = emrOption.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
							$author$project$Components$Onboard$PracticeInfo$EmrOther($elm$core$Maybe$Nothing),
							A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
								$author$project$Components$Onboard$PracticeInfo$Emr(
									$elm$core$Maybe$Just(emr)),
								model.PB));
					} else {
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
							$author$project$Components$Onboard$PracticeInfo$Emr($elm$core$Maybe$Nothing),
							model.PB);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v7 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
				var newDateInput = _v7.a;
				var subCmd = _v7.b;
				var event = _v7.c;
				var newForm = function () {
					if (event.$ === 1) {
						var date = event.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
							A2($author$project$Components$Onboard$PracticeInfo$LaunchDate, newDateInput, date),
							model.PB);
					} else {
						var fields = $author$project$Utils$Form$fields(model.PB);
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Onboard$PracticeInfo$formFieldsUpdate,
							A2($author$project$Components$Onboard$PracticeInfo$LaunchDate, newDateInput, fields.SG),
							model.PB);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Onboard$PracticeInfo$DateInputMsg(newDateInput),
						subCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$Onboard$DealId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.jx;
				if (_v1.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var practiceForm = _v1.a;
					var _v2 = A2($author$project$Components$Onboard$PracticeInfo$update, subMsg, practiceForm);
					var practiceInfoFormModel = _v2.a;
					var practiceInfoFormCmd = _v2.b;
					var practiceInfoMsg = _v2.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								jx: $elm$core$Maybe$Just(practiceInfoFormModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, practiceInfoFormCmd),
						practiceInfoMsg);
				}
			case 1:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var practiceOnboarding = response.a;
						var onboardId = $author$project$Api$Provider$PracticeOnboarding$One$ident(practiceOnboarding);
						var currentOnboardingStep = $author$project$Api$Provider$PracticeOnboarding$One$step(practiceOnboarding);
						var currentStepType = $author$project$Components$OnboardingStepper$stepToType(currentOnboardingStep);
						var stepperModel = $author$project$Components$OnboardingStepper$init(currentStepType);
						var currentStep = stepperModel.EP;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{EP: currentStep, WJ: response}),
							A2($author$project$Components$OnboardingStepper$redirectToLastStep, currentStepType, onboardId),
							$author$project$OutMsg$handleErrorResponse(response));
					case 2:
						return _Utils_Tuple3(
							model,
							A3($author$project$Api$Provider$PracticeOnboarding$new, model.Cd.D5, model.act, $author$project$Pages$Onboard$DealId_String$Top$GotNewPracticeOnboarding),
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practiceOnboarding = response.a;
					var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
					var currentStep = stepperModel.EP;
					var _v5 = A3(
						$author$project$Components$Onboard$PracticeInfo$init,
						$author$project$Api$Provider$PracticeOnboarding$One$dealId(practiceOnboarding),
						model.Cd,
						practiceOnboarding);
					var practiceInfoFormModel = _v5.a;
					var practiceInfoFormCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								EP: currentStep,
								jx: $elm$core$Maybe$Just(practiceInfoFormModel)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, practiceInfoFormCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Onboard$PracticeInfo$FormSubmitted = {$: 4};
var $author$project$Components$Onboard$PracticeInfo$ActiveMembersCount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Form$field = function (getter) {
	return A2($elm$core$Basics$composeR, $author$project$Utils$Form$fields, getter);
};
var $author$project$Components$Onboard$PracticeInfo$viewActiveMembersCount = function (form) {
	var activeMembersCount = A2(
		$author$project$Utils$Form$field,
		function ($) {
			return $.kR;
		},
		form);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(12),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$label('How many active members do you currently have?'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$test('active-members-count')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$number,
						$author$project$Ui$Form$Input$value(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $elm$core$String$fromInt, activeMembersCount))),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$ActiveMembersCount)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 1, form))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeInfo$EmrSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Practice$Emr$isHintClinical = function (_v0) {
	var option = _v0.ae;
	return !option;
};
var $author$project$Components$Onboard$PracticeInfo$emrIsHintClinical = function (emr) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$isHintClinical, emr));
};
var $author$project$Components$Onboard$PracticeInfo$viewEmr = F2(
	function (form, emrDropdown) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(5),
					$author$project$Ui$Form$Group$labelAbove,
					$author$project$Ui$Form$Group$label('EMR')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var emr = A2(
										$author$project$Utils$Form$field,
										function ($) {
											return $.acY;
										},
										form);
									var currentLabel = function () {
										if (!emr.$) {
											var emrValue = emr.a;
											return $author$project$Api$Provider$Practice$Emr$toLabel(emrValue);
										} else {
											return 'Select an EMR';
										}
									}();
									var availableOptions = $author$project$Components$Onboard$PracticeInfo$emrIsHintClinical(emr) ? $author$project$Api$Provider$Practice$Emr$options : A2(
										$elm$core$List$filter,
										function (emrOption) {
											return !$author$project$Api$Provider$Practice$Emr$isHintClinical(emrOption);
										},
										$author$project$Api$Provider$Practice$Emr$options);
									var items = A2(
										$elm$core$List$map,
										function (emrOption) {
											return A2(
												$author$project$Ui$NewDropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$NewDropdown$onSelect(
														$author$project$Components$Onboard$PracticeInfo$EmrSelected(
															$elm$core$Maybe$Just(emrOption))),
														$author$project$Ui$NewDropdown$selected(
														_Utils_eq(
															emr,
															$elm$core$Maybe$Just(emrOption)))
													]),
												$elm$html$Html$text(
													$author$project$Api$Provider$Practice$Emr$toLabel(emrOption)));
										},
										availableOptions);
									return A4(
										$author$project$Ui$NewDropdown$viewSelect,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$disabled(
												$author$project$Components$Onboard$PracticeInfo$emrIsHintClinical(emr))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(currentLabel)
											]),
										items,
										emrDropdown);
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Onboard$PracticeInfo$viewEmrOther = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return _Utils_eq(
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$toOption, fields.acY),
		$elm$core$Maybe$Just(13)) ? A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', fields.ac_)),
						$author$project$Ui$Form$Input$onInput(
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$EmrOther),
							$author$project$Utils$String$toMaybe))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Onboard$PracticeInfo$viewInfoHeader = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Welcome to Hint!')
				])),
			A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(' We\'re excited to walk you through setting up your account. This form should be completed by the business owner or an authorized delegate and should take you about 5 minutes.')
				]))
		]));
var $author$project$Components$Onboard$PracticeInfo$viewPracticeLaunchDate = function (form) {
	var fields = $author$project$Utils$Form$fields(form);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(12),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$label('What is your estimated launch / go-live date?'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Onboard$PracticeInfo$DateInputMsg(fields.qd),
				A2(
					$author$project$Components$DateInput$view,
					_List_fromArray(
						[
							$author$project$Components$DateInput$value(fields.SG),
							$author$project$Components$DateInput$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
							$author$project$Components$DateInput$errors(
							A2($author$project$Utils$Form$validationErrors, 2, form))
						]),
					fields.qd)),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text('This is when you can start billing patients through Hint.')
					]))
			]));
};
var $author$project$Components$Onboard$PracticeInfo$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PracticeInfo$viewPracticeName = function (form) {
	var name = A2(
		$author$project$Utils$Form$field,
		function ($) {
			return $.zh;
		},
		form);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Practice Name'),
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(name),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$Name)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, form))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeInfo$viewForm = F3(
	function (form, emrDropdown, submitting) {
		return _List_fromArray(
			[
				$author$project$Components$Onboard$PracticeInfo$viewInfoHeader,
				$author$project$Components$Onboard$PracticeInfo$viewPracticeName(form),
				A2($author$project$Components$Onboard$PracticeInfo$viewEmr, form, emrDropdown),
				$author$project$Components$Onboard$PracticeInfo$viewEmrOther(form),
				$author$project$Components$Onboard$PracticeInfo$viewPracticeLaunchDate(form),
				$author$project$Components$Onboard$PracticeInfo$viewActiveMembersCount(form),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textRight, $author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Submit pratice information'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(submitting)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Next')
							]))
					]))
			]);
	});
var $author$project$Components$Onboard$PracticeInfo$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$onSubmit($author$project$Components$Onboard$PracticeInfo$FormSubmitted)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$extraPadding]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A3($author$project$Components$Onboard$PracticeInfo$viewForm, model.PB, model.l1, model.kj))
					]))
			]));
};
var $author$project$Pages$Onboard$DealId_String$Top$view = function (model) {
	return {
		e5: function () {
			var _v0 = model.jx;
			if (_v0.$ === 1) {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Spinner$view(_List_Nil)
							]))
					]);
			} else {
				var practiceForm = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg,
						$author$project$Components$Onboard$PracticeInfo$view(practiceForm))
					]);
			}
		}(),
		$G: 'Onboard'
	};
};
var $author$project$Pages$Onboard$DealId_String$Top$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ad0: $author$project$Pages$Onboard$DealId_String$Top$init, aer: $author$project$Pages$Onboard$DealId_String$Top$load, agD: $author$project$Pages$Onboard$DealId_String$Top$save, ahd: $author$project$Pages$Onboard$DealId_String$Top$subscriptions, aaq: $author$project$Pages$Onboard$DealId_String$Top$update, ahP: $author$project$Pages$Onboard$DealId_String$Top$view});
var $author$project$Pages$Onboard$OnboardId_String$Completed$init = F2(
	function (_v0, _v1) {
		var params = _v1.Vx;
		return _Utils_Tuple3(
			{afq: params.afq},
			A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Account),
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completed$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completed$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Onboard$OnboardId_String$Completed$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Onboard$OnboardId_String$Completed$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completed$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[
						$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(_List_Nil)
					]))
			]),
		$G: 'Onboard'
	};
};
var $author$project$Pages$Onboard$OnboardId_String$Completed$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ad0: $author$project$Pages$Onboard$OnboardId_String$Completed$init, aer: $author$project$Pages$Onboard$OnboardId_String$Completed$load, agD: $author$project$Pages$Onboard$OnboardId_String$Completed$save, ahd: $author$project$Pages$Onboard$OnboardId_String$Completed$subscriptions, aaq: $author$project$Pages$Onboard$OnboardId_String$Completed$update, ahP: $author$project$Pages$Onboard$OnboardId_String$Completed$view});
var $author$project$Pages$Onboard$OnboardId_String$Completing$PracticeOnboardingCompleted = $elm$core$Basics$identity;
var $author$project$Api$Provider$PracticeOnboarding$setupPractice = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['setup_practice']),
					$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$init = F2(
	function (shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple3(
			{afq: params.afq},
			A3($author$project$Api$Provider$PracticeOnboarding$setupPractice, shared.D5, params.afq, $elm$core$Basics$identity),
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Api$Data$errorToStatus = function (errorResponse) {
	switch (errorResponse.$) {
		case 0:
			return '401';
		case 1:
			return '404';
		case 2:
			return '503';
		case 4:
			return '502';
		case 3:
			return '503';
		case 5:
			return '404';
		case 8:
			return '500';
		case 6:
			var code = errorResponse.a;
			return $elm$core$String$fromInt(code);
		case 7:
			return '417';
		case 9:
			return '403';
		default:
			return '409';
	}
};
var $author$project$Pages$Onboard$OnboardId_String$Completing$update = F2(
	function (msg, model) {
		var response = msg;
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed(
							{afq: model.afq})),
					_List_Nil);
			case 2:
				if ((response.a.$ === 6) && (response.a.a === 422)) {
					var _v2 = response.a;
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed(
								{afq: model.afq})),
						_List_Nil);
				} else {
					var error = response.a;
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Error__Status_String(
								{
									ag7: $author$project$Api$Data$errorToStatus(error)
								})),
						_List_Nil);
				}
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$Onboard$OnboardId_String$Completing$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(_List_Nil),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Please wait while we create your account.')
							])),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('You will be able to sign in shortly to continue onboarding.')
							]))
					]))
			]),
		$G: 'Onboard'
	};
};
var $author$project$Pages$Onboard$OnboardId_String$Completing$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ad0: $author$project$Pages$Onboard$OnboardId_String$Completing$init, aer: $author$project$Pages$Onboard$OnboardId_String$Completing$load, agD: $author$project$Pages$Onboard$OnboardId_String$Completing$save, ahd: $author$project$Pages$Onboard$OnboardId_String$Completing$subscriptions, aaq: $author$project$Pages$Onboard$OnboardId_String$Completing$update, ahP: $author$project$Pages$Onboard$OnboardId_String$Completing$view});
var $author$project$Pages$Onboard$OnboardId_String$Payment$PaymentSetupMsg = $elm$core$Basics$identity;
var $author$project$Components$Onboard$PaymentSetup$GotPracticeOnboarding = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$GotSetupConfig = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rainforest$Live = 0;
var $author$project$Components$Onboard$PaymentSetup$Loading = {$: 0};
var $author$project$Components$Onboard$PaymentSetup$Model = $elm$core$Basics$identity;
var $author$project$Rainforest$Sandbox = 1;
var $author$project$Ports$Rainforest$rainforestPortLoad = _Platform_outgoingPort('rainforestPortLoad', $elm$json$Json$Encode$string);
var $author$project$Rainforest$toString = function (env) {
	if (!env) {
		return 'production';
	} else {
		return 'sandbox';
	}
};
var $author$project$Ports$Rainforest$load = A2($elm$core$Basics$composeR, $author$project$Rainforest$toString, $author$project$Ports$Rainforest$rainforestPortLoad);
var $author$project$Components$Onboard$PaymentSetup$init = F2(
	function (onboardId, shared) {
		var rainforestEnv = _Utils_eq(
			shared.adu.adM,
			$elm$core$Maybe$Just('production')) ? 0 : 1;
		return _Utils_Tuple2(
			{cD: false, qT: shared.qT, cW: true, afq: onboardId, WJ: $author$project$Api$Data$Loading, at: $author$project$Components$Onboard$PaymentSetup$Loading},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.D5, onboardId, $author$project$Components$Onboard$PaymentSetup$GotPracticeOnboarding),
						A3(
						$author$project$Api$PaymentMethod$getClientSecret,
						A2(
							$author$project$Api$Data$pathAppend,
							_List_fromArray(
								['practice_onboardings', onboardId]),
							$author$project$Api$Data$providerPath),
						shared.D5,
						$author$project$Components$Onboard$PaymentSetup$GotSetupConfig),
						$author$project$Ports$Rainforest$load(rainforestEnv)
					])));
	});
var $author$project$Pages$Onboard$OnboardId_String$Payment$init = F2(
	function (shared, _v0) {
		var params = _v0.Vx;
		var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
		var currentStep = stepperModel.EP;
		var _v1 = A2($author$project$Components$Onboard$PaymentSetup$init, params.afq, shared);
		var paymentSetupFormModel = _v1.a;
		var paymentSetupFormCmd = _v1.b;
		return _Utils_Tuple3(
			{D5: shared.D5, EP: currentStep, nr: paymentSetupFormModel, _N: stepperModel},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSetupFormCmd),
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Payment$load = F2(
	function (shared, model) {
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{D5: shared.D5}),
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$Payment$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Onboard$PaymentSetup$GotStripePaymentMethod = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$subscriptions = function (_v0) {
	return $author$project$Ports$Stripe$onSetupIntentConfirmed($author$project$Components$Onboard$PaymentSetup$GotStripePaymentMethod);
};
var $author$project$Pages$Onboard$OnboardId_String$Payment$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Onboard$PaymentSetup$subscriptions(model.nr));
};
var $author$project$Components$Onboard$PaymentSetup$Failed = {$: 3};
var $author$project$Components$Onboard$PaymentSetup$Rainforest = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$Stripe = {$: 1};
var $author$project$Components$Onboard$PaymentSetup$andNoop = function (model) {
	return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
};
var $author$project$Components$Onboard$PaymentSetup$stripeElementId = 'card-element';
var $author$project$Components$Onboard$PaymentSetup$buildStripeElement = function (clientSecret) {
	return A6($author$project$Ports$Stripe$buildAndMountElementWithSetupIntent, $elm$core$Maybe$Nothing, clientSecret, '#' + $author$project$Components$Onboard$PaymentSetup$stripeElementId, false, '', '');
};
var $author$project$Components$Onboard$PaymentSetup$PracticeOnboardingUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$updateProcessorConfig = F4(
	function (apiClient, paymentProcessorParams, id, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_onboarding',
					$elm$json$Json$Encode$object(
						$author$project$Api$PaymentProcessorParams$encode(paymentProcessorParams)))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
	});
var $author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding = F3(
	function (apiClient, paymentProcessorParams, onboardId) {
		return A4($author$project$Api$Provider$PracticeOnboarding$updateProcessorConfig, apiClient, paymentProcessorParams, onboardId, $author$project$Components$Onboard$PaymentSetup$PracticeOnboardingUpdated);
	});
var $author$project$Components$Onboard$PaymentSetup$updateRainforest = F4(
	function (apiClient, msg, config, model) {
		switch (msg.$) {
			case 0:
				var rainforestId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							at: $author$project$Components$Onboard$PaymentSetup$Rainforest(config)
						}),
					A3(
						$author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding,
						apiClient,
						$author$project$Api$PaymentProcessorParams$rainforestParams(rainforestId),
						model.afq),
					_List_Nil);
			case 1:
				var isValid = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							at: $author$project$Components$Onboard$PaymentSetup$Rainforest(
								_Utils_update(
									config,
									{yl: isValid}))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							at: $author$project$Components$Onboard$PaymentSetup$Rainforest(
								_Utils_update(
									config,
									{cW: false}))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Onboard$PaymentSetup$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var setup = response.a;
					var _v3 = function () {
						if (!setup.$) {
							var secret = setup.a;
							return _Utils_Tuple2(
								$author$project$Components$Onboard$PaymentSetup$Stripe,
								$author$project$Components$Onboard$PaymentSetup$buildStripeElement(secret));
						} else {
							var sessionKey = setup.a.agS;
							var paymentMethodConfigId = setup.a.afH;
							var allowedMethods = setup.a.abl;
							return _Utils_Tuple2(
								$author$project$Components$Onboard$PaymentSetup$Rainforest(
									{abl: allowedMethods, cW: true, yl: false, afH: paymentMethodConfigId, agS: sessionKey}),
								$elm$core$Platform$Cmd$none);
						}
					}();
					var config = _v3.a;
					var processorElement = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cW: false, at: config}),
						processorElement,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cW: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var portCall = function () {
					var _v5 = model.at;
					switch (_v5.$) {
						case 1:
							return A2(
								$author$project$Ports$Stripe$confirmSetupIntent,
								'#' + $author$project$Components$Onboard$PaymentSetup$stripeElementId,
								{abE: $elm$core$Maybe$Nothing});
						case 2:
							return $author$project$Ports$Rainforest$submitPaymentMethod;
						default:
							return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cD: true}),
					portCall,
					_List_Nil);
			case 2:
				var cardPaymentMethodResult = msg.a;
				if (!cardPaymentMethodResult.$) {
					var stripeCardPaymentMethod = cardPaymentMethodResult.a;
					var params = $author$project$Api$PaymentProcessorParams$stripeParams(stripeCardPaymentMethod.adR);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cD: true}),
						A3($author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding, apiClient, params, model.afq),
						_List_Nil);
				} else {
					var _v7 = model.at;
					if (!_v7.$) {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cD: false, at: $author$project$Components$Onboard$PaymentSetup$Failed}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				}
			case 3:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cD: false}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing(
									{afq: model.afq})),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cD: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cD: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 4:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{WJ: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									WJ: $author$project$Api$Data$Failure(error)
								}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Error__Status_String(
									{
										ag7: $author$project$Api$Data$errorToStatus(error)
									})),
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{WJ: $author$project$Api$Data$NotAsked}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var rainforestMsg = msg.a;
				var _v10 = model.at;
				if (_v10.$ === 2) {
					var config = _v10.a;
					return A4($author$project$Components$Onboard$PaymentSetup$updateRainforest, apiClient, rainforestMsg, config, model);
				} else {
					return $author$project$Components$Onboard$PaymentSetup$andNoop(model);
				}
		}
	});
var $author$project$Pages$Onboard$OnboardId_String$Payment$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Onboard$PaymentSetup$update, model.D5, subMsg, model.nr);
		var paymentSetupModel = _v1.a;
		var paymentSetupFormCmd = _v1.b;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{nr: paymentSetupModel}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSetupFormCmd),
			_List_Nil);
	});
var $author$project$Components$Onboard$PaymentSetup$viewInfoHeader = A2(
	$author$project$Ui$Typography$span,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Add your payment method')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[
							$author$project$Ui$Typography$margin(18)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('You will not be billed immediately for your application software fees. You can view your billing start date after you complete onboarding.')
						]))
				]))
		]));
var $author$project$Components$Onboard$PaymentSetup$Approved = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$Loaded = {$: 2};
var $author$project$Components$Onboard$PaymentSetup$Noop = {$: 3};
var $author$project$Components$Onboard$PaymentSetup$RainforestMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Onboard$PaymentSetup$Save = {$: 1};
var $author$project$Components$Onboard$PaymentSetup$ValidityChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Button$Test = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ui$Button$test = $author$project$Ui$Button$Test;
var $author$project$Components$Onboard$PaymentSetup$viewPaymentElementsForm = function (_v0) {
	var model = _v0;
	var valid = function () {
		var _v4 = model.at;
		if (_v4.$ === 2) {
			var conf = _v4.a;
			return conf.yl;
		} else {
			return true;
		}
	}();
	var disabled = !valid;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4, $author$project$Ui$Element$mb4]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stripe-card')
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = _Utils_Tuple2(model.cW, model.at);
						_v1$2:
						while (true) {
							if (!_v1.a) {
								switch (_v1.b.$) {
									case 1:
										var _v2 = _v1.b;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id($author$project$Components$Onboard$PaymentSetup$stripeElementId)
												]),
											_List_Nil);
									case 2:
										var config = _v1.b.a;
										var _v3 = config;
										var sessionKey = _v3.agS;
										var paymentMethodConfigId = _v3.afH;
										var allowedMethods = _v3.abl;
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$WebComponents$Rainforest$Payment$view,
													{
														ae1: A2($elm$core$Basics$composeR, $author$project$Components$Onboard$PaymentSetup$Approved, $author$project$Components$Onboard$PaymentSetup$RainforestMsg),
														ae3: A2(
															$elm$core$Basics$composeR,
															$elm$core$Basics$always($author$project$Components$Onboard$PaymentSetup$Noop),
															$author$project$Components$Onboard$PaymentSetup$RainforestMsg),
														afd: $author$project$Components$Onboard$PaymentSetup$RainforestMsg(
															$author$project$Components$Onboard$PaymentSetup$ValidityChanged(false)),
														aff: $author$project$Components$Onboard$PaymentSetup$RainforestMsg($author$project$Components$Onboard$PaymentSetup$Loaded),
														afg: A2(
															$elm$core$Basics$composeR,
															$elm$core$Basics$always($author$project$Components$Onboard$PaymentSetup$Noop),
															$author$project$Components$Onboard$PaymentSetup$RainforestMsg),
														afp: $author$project$Components$Onboard$PaymentSetup$RainforestMsg(
															$author$project$Components$Onboard$PaymentSetup$ValidityChanged(true))
													},
													{abl: allowedMethods, afH: paymentMethodConfigId, agS: sessionKey}),
													config.cW ? A2(
													$author$project$Ui$FlexGrid$row,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$FlexGrid$column,
															_List_fromArray(
																[
																	$author$project$Ui$FlexGrid$spanSm(8),
																	$author$project$Ui$FlexGrid$justifyCenter
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Spinner$view(
																	_List_fromArray(
																		[$author$project$Ui$Spinner$large]))
																]))
														])) : $author$project$Utils$Html$empty
												]));
									default:
										break _v1$2;
								}
							} else {
								break _v1$2;
							}
						}
						return A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(8),
											$author$project$Ui$FlexGrid$justifyCenter
										]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$large]))
										]))
								]));
					}()
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_fromArray(
					[$author$project$Ui$FlexGrid$mt4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(12),
								$author$project$Ui$FlexGrid$justifyRight
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Submit payment method'},
								_List_fromArray(
									[
										$author$project$Ui$Button$styled(1),
										$author$project$Ui$Button$loading(model.cD),
										$author$project$Ui$Button$disabled(model.cD || disabled),
										$author$project$Ui$Button$onClick($author$project$Components$Onboard$PaymentSetup$Save),
										$author$project$Ui$Button$test('submit-payment-method')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Next')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Onboard$PaymentSetup$viewForm = function (_v0) {
	var model = _v0;
	return _Utils_eq(model.WJ, $author$project$Api$Data$Loading) ? _List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Spinner$view(_List_Nil)
				]))
		]) : _List_fromArray(
		[
			$author$project$Components$Onboard$PaymentSetup$viewInfoHeader,
			$author$project$Components$Onboard$PaymentSetup$viewPaymentElementsForm(model)
		]);
};
var $author$project$Components$Onboard$PaymentSetup$view = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$noValidate(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$extraPadding]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Components$Onboard$PaymentSetup$viewForm(model))
					]))
			]));
};
var $author$project$Pages$Onboard$OnboardId_String$Payment$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Onboard$PaymentSetup$view(model.nr))
			]),
		$G: 'Onboard'
	};
};
var $author$project$Pages$Onboard$OnboardId_String$Payment$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ad0: $author$project$Pages$Onboard$OnboardId_String$Payment$init, aer: $author$project$Pages$Onboard$OnboardId_String$Payment$load, agD: $author$project$Pages$Onboard$OnboardId_String$Payment$save, ahd: $author$project$Pages$Onboard$OnboardId_String$Payment$subscriptions, aaq: $author$project$Pages$Onboard$OnboardId_String$Payment$update, ahP: $author$project$Pages$Onboard$OnboardId_String$Payment$view});
var $author$project$Pages$Onboard$OnboardId_String$User$GotPracticeOnboarding = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Onboard$OnboardId_String$User$ShowingCreateForm = 0;
var $author$project$Pages$Onboard$OnboardId_String$User$ShowingExistingUser = 1;
var $author$project$Components$Onboard$PracticeUser$Model = $elm$core$Basics$identity;
var $author$project$Components$Onboard$PracticeUser$init = F2(
	function (onboardId, shared) {
		var inittedForm = $author$project$Utils$Form$init(
			{Oo: '', Pu: '', SA: '', afC: '', rR: '', nh: $elm$core$Maybe$Nothing, Hw: false});
		return _Utils_Tuple2(
			{PB: inittedForm, afq: onboardId, Cd: shared},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Onboard$OnboardId_String$User$init = F2(
	function (shared, _v0) {
		var params = _v0.Vx;
		var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
		var maybeSession = function () {
			var _v3 = shared.ZD;
			if (_v3.$ === 3) {
				var session = _v3.a;
				return $elm$core$Maybe$Just(session);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var initialViewMode = function () {
			if (!maybeSession.$) {
				return 1;
			} else {
				return 0;
			}
		}();
		var currentStep = stepperModel.EP;
		var _v1 = A2($author$project$Components$Onboard$PracticeUser$init, params.afq, shared);
		var practiceUserFormModel = _v1.a;
		var practiceUserFormCmd = _v1.b;
		return _Utils_Tuple3(
			{EP: currentStep, fR: false, m0: maybeSession, afq: params.afq, WJ: $author$project$Api$Data$Loading, Cd: shared, _N: stepperModel, kI: practiceUserFormModel, kJ: initialViewMode},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, practiceUserFormCmd),
						A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.D5, params.afq, $author$project$Pages$Onboard$OnboardId_String$User$GotPracticeOnboarding)
					])),
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$User$determineViewMode = F3(
	function (maybeSession, practiceOnboardingData, currentViewMode) {
		var _v0 = _Utils_Tuple2(practiceOnboardingData, maybeSession);
		if (!_v0.b.$) {
			if (_v0.a.$ === 3) {
				var _v1 = _v0.a;
				var practiceOnboarding = _v1.a;
				var _v2 = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
				if (!_v2.$) {
					var emr = _v2.a;
					return $author$project$Api$Provider$Practice$Emr$isHintClinical(emr) ? 0 : 1;
				} else {
					return 1;
				}
			} else {
				return 1;
			}
		} else {
			return currentViewMode;
		}
	});
var $author$project$Pages$Onboard$OnboardId_String$User$load = F2(
	function (shared, model) {
		var updatedMaybeSession = function () {
			var _v0 = shared.ZD;
			if (_v0.$ === 3) {
				var session = _v0.a;
				return $elm$core$Maybe$Just(session);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var updatedViewMode = A3($author$project$Pages$Onboard$OnboardId_String$User$determineViewMode, updatedMaybeSession, model.WJ, model.kJ);
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{m0: updatedMaybeSession, Cd: shared, kJ: updatedViewMode}),
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$Onboard$OnboardId_String$User$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Onboard$PracticeUser$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PracticeUser$PasswordStrengthCheck = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Onboard$PracticeUser$subscriptions = function (_v0) {
	return $author$project$Ports$PasswordStrength$checked(
		A2(
			$elm$core$Basics$composeL,
			A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$PasswordStrengthCheck),
			$elm$core$Maybe$Just));
};
var $author$project$Pages$Onboard$OnboardId_String$User$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg,
		$author$project$Components$Onboard$PracticeUser$subscriptions(model.kI));
};
var $author$project$Ui$Toast$Info = 0;
var $author$project$Pages$Onboard$OnboardId_String$User$UserLinked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath = F2(
	function (basePath, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			basePath);
	});
var $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice_onboardings']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PracticeOnboarding$User$userPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['user']),
		basePath);
};
var $author$project$Api$Provider$PracticeOnboarding$User$linkExistingPath = function (onboardId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['link']),
		$author$project$Api$Provider$PracticeOnboarding$User$userPath(
			A2($author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath, $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath, onboardId)));
};
var $author$project$Api$Provider$PracticeOnboarding$User$linkExisting = F3(
	function (apiClient, onboardId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PracticeOnboarding$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PracticeOnboarding$User$linkExistingPath(onboardId)));
	});
var $author$project$Components$Onboard$PracticeUser$OnboardingUserCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeOnboarding$User$onboardingUserPath = function (onboardId) {
	return $author$project$Api$Provider$PracticeOnboarding$User$userPath(
		A2($author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath, $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath, onboardId));
};
var $author$project$Api$Provider$PracticeOnboarding$User$create = F3(
	function (apiClient, fields, toMsg) {
		var createOnboardingUserPath = $author$project$Api$Provider$PracticeOnboarding$User$onboardingUserPath(fields.afq);
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_onboarding_user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'first_name',
								$elm$json$Json$Encode$string(fields.Pu)),
								_Utils_Tuple2(
								'last_name',
								$elm$json$Json$Encode$string(fields.SA)),
								_Utils_Tuple2(
								'terms_accepted',
								$elm$json$Json$Encode$bool(fields.Hw)),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(fields.Oo)),
								_Utils_Tuple2(
								'password',
								$elm$json$Json$Encode$string(fields.afC))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(createOnboardingUserPath)));
	});
var $author$project$Components$Onboard$PracticeUser$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Pu: string}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{SA: string}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Oo: string}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{afC: string, nh: $elm$core$Maybe$Nothing}),
					$author$project$Ports$PasswordStrength$check(string));
			case 4:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{rR: string}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var bool = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Hw: bool}),
					$elm$core$Platform$Cmd$none);
			default:
				var check = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{nh: check}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Onboard$PracticeUser$EmailValidation = 2;
var $author$project$Components$Onboard$PracticeUser$FirstNameValidation = 0;
var $author$project$Components$Onboard$PracticeUser$LastNameValidation = 1;
var $author$project$Components$Onboard$PracticeUser$PasswordValidation = 3;
var $author$project$Components$Onboard$PracticeUser$TermsAcceptedValidation = 5;
var $author$project$Components$Onboard$PracticeUser$PasswordConfirmationValidation = 4;
var $author$project$Components$Onboard$PracticeUser$validatePasswordConfirmation = function (fields) {
	return $author$project$Utils$String$isBlank(fields.afC) ? _List_Nil : (_Utils_eq(fields.afC, fields.rR) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(4, 'The password and its confirmation don\'t match.')
		]));
};
var $author$project$Components$Onboard$PracticeUser$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Pu;
			},
			_Utils_Tuple2(0, 'Please enter a first name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.SA;
			},
			_Utils_Tuple2(1, 'Please enter a last name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.afC;
			},
			_Utils_Tuple2(3, 'Please enter a password.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Onboard$PracticeUser$validatePasswordConfirmation),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function ($) {
				return $.Hw;
			},
			_Utils_Tuple2(5, 'You must accept our Terms of Service when creating your account.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.nh));
			},
			_Utils_Tuple2(3, 'Please enter a secure password.')),
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Oo;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(2, 'Please enter a valid email.'))
		]));
var $author$project$Components$Onboard$PracticeUser$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v2 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Onboard$PracticeUser$formFieldsUpdate, field, model.PB);
				var newForm = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Onboard$PracticeUser$FormUpdated, cmd),
					_List_Nil);
			case 1:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Onboard$PracticeUser$formFieldsValidator, model.PB);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var fields = $author$project$Utils$Form$fields(newForm);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3(
									$author$project$Api$Provider$PracticeOnboarding$User$create,
									model.Cd.D5,
									{Oo: fields.Oo, Pu: fields.Pu, SA: fields.SA, afq: model.afq, afC: fields.afC, Hw: fields.Hw},
									$author$project$Components$Onboard$PracticeUser$OnboardingUserCreated),
									A2($author$project$Ports$LocalStorage$setItem, 'login-email', fields.Oo)
								])),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment(
									{afq: model.afq})),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Session$persistRedirect(
								$elm$url$Url$toString(model.Cd.aav)),
								$author$project$Ports$Session$authorize(
								{af6: true})
							])),
					_List_Nil);
		}
	});
var $author$project$Pages$Onboard$OnboardId_String$User$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Onboard$PracticeUser$update, subMsg, model.kI);
				var practiceUserFormModel = _v1.a;
				var practiceUserFormCmd = _v1.b;
				var practiceUserMsg = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kI: practiceUserFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, practiceUserFormCmd),
					practiceUserMsg);
			case 1:
				var response = msg.a;
				var updatedViewMode = A3($author$project$Pages$Onboard$OnboardId_String$User$determineViewMode, model.m0, response, 0);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WJ: response, kJ: updatedViewMode}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var _v2 = model.WJ;
				switch (_v2.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fR: true}),
							A3($author$project$Api$Provider$PracticeOnboarding$User$linkExisting, model.Cd.D5, model.afq, $author$project$Pages$Onboard$OnboardId_String$User$UserLinked),
							_List_Nil);
					case 1:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 0, 'Please wait while we load your practice information...')
								]));
					case 2:
						var error = _v2.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'Unable to continue. Please refresh the page and try again.')
								]));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kJ: 0}),
					$author$project$Ports$Session$logout(
						{af6: false}),
					_List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fR: false}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment(
									{afq: model.afq})),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fR: false}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fR: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
		}
	});
var $author$project$Components$Onboard$PracticeUser$Save = {$: 1};
var $author$project$Components$Onboard$PracticeUser$SignInClicked = {$: 3};
var $author$project$Components$Onboard$PracticeUser$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewEmail = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$margin(7),
				$author$project$Ui$Form$Group$label('Email'),
				$author$project$Ui$Form$Group$test('email')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(fields.Oo),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$Email)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 2, model.PB))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewFirstName = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('First Name'),
				$author$project$Ui$Form$Group$test('first-name')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(fields.Pu),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$FirstName)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 0, model.PB))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewLastName = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Last Name'),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$margin(2),
				$author$project$Ui$Form$Group$test('last-name')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(fields.SA),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$LastName)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 1, model.PB))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$Password = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewPassword = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Password'),
				$author$project$Ui$Form$Group$invalid(
				A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB))
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$PasswordInput$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$PasswordInput$placeholder('Password'),
						$author$project$Ui$Form$PasswordInput$value(fields.afC),
						$author$project$Ui$Form$PasswordInput$strengthCheck(fields.nh),
						$author$project$Ui$Form$PasswordInput$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$Password)),
						$author$project$Ui$Form$PasswordInput$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
						$author$project$Ui$Form$PasswordInput$withFeedback(
						$author$project$Utils$Form$validated(model.PB))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$PasswordConfirmation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewPasswordConfirm = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$labelAbove,
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Password Confirmation'),
				$author$project$Ui$Form$Group$invalid(
				A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB))
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Password Confirmation'),
						$author$project$Ui$Form$Input$password,
						$author$project$Ui$Form$Input$value(fields.rR),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$PasswordConfirmation)),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 4, model.PB)),
						$author$project$Ui$Form$Input$errors(
						A2($author$project$Utils$Form$validationErrors, 4, model.PB))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$TermsAccepted = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Onboard$PracticeUser$viewTermsAccepted = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(12),
						$author$project$Ui$Form$Group$inputSpanSm(12)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(fields.Hw),
								$author$project$Ui$Form$Checkbox$required(true),
								$author$project$Ui$Form$Checkbox$onCheck(
								A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$TermsAccepted)),
								$author$project$Ui$Form$Checkbox$errors(
								A2($author$project$Utils$Form$validationErrors, 5, model.PB))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('I have read and agree to the '),
								A3(
								$author$project$Ui$Link$externalHref,
								$author$project$Utils$HintUrls$termsUrl,
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text('Terms of Service')
									])),
								$elm$html$Html$text('.')
							]))
					]))
			]));
};
var $author$project$Components$Onboard$PracticeUser$viewForm = function (model) {
	return _List_fromArray(
		[
			$author$project$Components$Onboard$PracticeUser$viewFirstName(model),
			$author$project$Components$Onboard$PracticeUser$viewLastName(model),
			$author$project$Components$Onboard$PracticeUser$viewEmail(model),
			$author$project$Components$Onboard$PracticeUser$viewPassword(model),
			$author$project$Components$Onboard$PracticeUser$viewPasswordConfirm(model),
			$author$project$Components$Onboard$PracticeUser$viewTermsAccepted(model),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textRight]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Submit user'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$submit,
							$author$project$Ui$Button$loading(false)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Next')
						]))
				]))
		]);
};
var $author$project$Components$Onboard$PracticeUser$view = F2(
	function (_v0, showSignInPrompt) {
		var model = _v0;
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$horizontal,
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$onSubmit($author$project$Components$Onboard$PracticeUser$Save)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_fromArray(
						[$author$project$Ui$Panel$extraPadding]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													$elm$html$Html$text('Create your account')
												])),
											showSignInPrompt ? A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[
													$author$project$Ui$Typography$margin(21),
													$author$project$Ui$Typography$margin(5)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Already have an account? '),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Sign in to continue'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick($author$project$Components$Onboard$PracticeUser$SignInClicked)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Sign in to continue')
														]))
												])) : $elm$html$Html$text('')
										])),
								$author$project$Components$Onboard$PracticeUser$viewForm(model)))
						]))
				]));
	});
var $author$project$Pages$Onboard$OnboardId_String$User$ContinueWithExistingUser = {$: 2};
var $author$project$Pages$Onboard$OnboardId_String$User$CreateNewUserInstead = {$: 3};
var $author$project$Pages$Onboard$OnboardId_String$User$viewExistingUserCard = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[$author$project$Ui$Panel$extraPadding]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = model.m0;
						if (!_v0.$) {
							var session = _v0.a;
							var user = $author$project$Api$Platform$Session$One$user(session);
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Typography$heading(
												_List_fromArray(
													[
														$elm$html$Html$text('Confirm the account owner')
													])),
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[
														$author$project$Ui$Typography$margin(8)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Account Owner: '),
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[
																$author$project$Ui$Typography$fontWeight(0)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Platform$User$Shared$email(user))
															]))
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textRight, $author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Create new owner'},
												_List_fromArray(
													[
														$author$project$Ui$Button$secondary,
														$author$project$Ui$Button$onClick($author$project$Pages$Onboard$OnboardId_String$User$CreateNewUserInstead),
														$author$project$Ui$Button$disabled(model.fR)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Create new owner')
													])),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Next'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$onClick($author$project$Pages$Onboard$OnboardId_String$User$ContinueWithExistingUser),
														$author$project$Ui$Button$loading(model.fR),
														$author$project$Ui$Button$margin(12)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Next')
													]))
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}()
					]))
			]));
};
var $author$project$Pages$Onboard$OnboardId_String$User$view = function (model) {
	return {
		e5: function () {
			var _v0 = _Utils_Tuple2(model.kJ, model.WJ);
			_v0$3:
			while (true) {
				if (!_v0.a) {
					if (_v0.b.$ === 3) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						var practiceOnboarding = _v4.a;
						var emr = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
						var isClinical = A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$isHintClinical, emr));
						var showSignInPrompt = (!isClinical) && _Utils_eq(model.m0, $elm$core$Maybe$Nothing);
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg,
								A2($author$project$Components$Onboard$PracticeUser$view, model.kI, showSignInPrompt))
							]);
					} else {
						break _v0$3;
					}
				} else {
					switch (_v0.b.$) {
						case 3:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return _List_fromArray(
								[
									$author$project$Pages$Onboard$OnboardId_String$User$viewExistingUserCard(model)
								]);
						case 1:
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]))
								]);
						default:
							break _v0$3;
					}
				}
			}
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg,
					A2($author$project$Components$Onboard$PracticeUser$view, model.kI, false))
				]);
		}(),
		$G: 'Onboard'
	};
};
var $author$project$Pages$Onboard$OnboardId_String$User$page = $author$project$Spa$Page$applicationOnlyPublic(
	{ad0: $author$project$Pages$Onboard$OnboardId_String$User$init, aer: $author$project$Pages$Onboard$OnboardId_String$User$load, agD: $author$project$Pages$Onboard$OnboardId_String$User$save, ahd: $author$project$Pages$Onboard$OnboardId_String$User$subscriptions, aaq: $author$project$Pages$Onboard$OnboardId_String$User$update, ahP: $author$project$Pages$Onboard$OnboardId_String$User$view});
var $author$project$Pages$Onboarding$PracticePaymentSourcesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Onboarding$GotApplicationFeePlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Onboarding$fetchApplicationFeePlan = function (apiClient) {
	return A2($author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve, apiClient, $author$project$Pages$Onboarding$GotApplicationFeePlan);
};
var $author$project$Pages$Onboarding$GotPracticePricing = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Onboarding$fetchPracticePricing = function (apiClient) {
	return A2($author$project$Api$Provider$PracticePricing$retrieve, apiClient, $author$project$Pages$Onboarding$GotPracticePricing);
};
var $author$project$Pages$Onboarding$GotBankAccounts = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Onboarding$GotCards = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Onboarding$fetchSources = function (apiClient) {
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Onboarding$GotCards),
				A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Onboarding$GotBankAccounts)
			]));
};
var $author$project$Pages$Onboarding$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A6(
			$author$project$Components$Practice$PaymentSources$init,
			session,
			practice,
			shared.qT,
			shared.Hy,
			$author$project$Shared$isHintAdmin(shared),
			shared.sj);
		var practicePaymentSources = _v1.a;
		var practicePaymentSourcesCmd = _v1.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				cO: shared.cO,
				me: $author$project$Api$Data$Loading,
				FR: $author$project$Shared$isHintAdmin(shared),
				WF: practice,
				cj: practicePaymentSources,
				ck: $author$project$Api$Data$Loading,
				ZD: session
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Onboarding$fetchSources(shared.D5),
						$author$project$Pages$Onboarding$fetchApplicationFeePlan(shared.D5),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, practicePaymentSourcesCmd),
						$author$project$Pages$Onboarding$fetchPracticePricing(shared.D5)
					])));
	});
var $author$project$Pages$Onboarding$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Onboarding$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Onboarding$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Onboarding$PracticePaymentSourcesMsg,
		$author$project$Components$Practice$PaymentSources$subscriptions(model.cj));
};
var $author$project$Pages$Onboarding$OnboardingCompleted = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Onboarding$GotPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Onboarding$fetchPractice = function (apiClient) {
	return A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$Onboarding$GotPractice);
};
var $author$project$Api$Provider$Practice$onboard = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['onboard']),
					$author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Api$Provider$Practice$skipPaymentRequirement = F2(
	function (apiClient, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'onboarded',
								$elm$json$Json$Encode$bool(true))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
	});
var $author$project$Pages$Onboarding$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{me: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var dataResponse = msg.a;
				if (dataResponse.$ === 3) {
					var practice = dataResponse.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WF: practice}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataResponse));
				}
			case 2:
				var subMsg = msg.a;
				var practicePaymentSourcesResult = A3($author$project$Components$Practice$PaymentSources$update, model.D5, subMsg, model.cj);
				var cmds = function () {
					var _v2 = practicePaymentSourcesResult.ac5;
					switch (_v2) {
						case 0:
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Onboarding$fetchSources(model.D5),
										$author$project$Pages$Onboarding$fetchPractice(model.D5)
									]));
						case 2:
							return $elm$core$Platform$Cmd$none;
						default:
							return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cj: practicePaymentSourcesResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, practicePaymentSourcesResult.EC),
								cmds
							])),
					practicePaymentSourcesResult.as);
			case 3:
				return _Utils_Tuple3(
					model,
					function (fn) {
						return fn($author$project$Pages$Onboarding$OnboardingCompleted);
					}(
						$author$project$Api$Provider$Practice$onboard(model.D5)),
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Provider$Practice$skipPaymentRequirement, model.D5, $author$project$Pages$Onboarding$OnboardingCompleted),
					_List_Nil);
			case 5:
				var dataResponse = msg.a;
				if (dataResponse.$ === 3) {
					var practice = dataResponse.a;
					var paymentProcessingRoute = (($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') && (!A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice))) ? $author$project$Spa$Generated$Route$Admin__Stripe : $author$project$Spa$Generated$Route$Admin__PaymentProcessing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WF: practice}),
						A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, paymentProcessingRoute),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataResponse));
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ck: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cj: A2($author$project$Components$Practice$PaymentSources$initCards, response, model.cj)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cj: A2($author$project$Components$Practice$PaymentSources$initBankAccounts, response, model.cj)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			default:
				var label = msg.a;
				var url = msg.b;
				return _Utils_Tuple3(
					model,
					A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.ZD, label, url),
					_List_Nil);
		}
	});
var $author$project$Pages$Onboarding$AnalyticsLinkClicked = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$Onboarding$CompleteOnboardingClicked = {$: 3};
var $author$project$Pages$Onboarding$SkipPaymentRequirementClicked = {$: 4};
var $author$project$Pages$Onboarding$hasAnyPaymentSource = function (model) {
	var _v0 = _Utils_Tuple2(model.pD, model.pN);
	if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
		var _v1 = _v0.a;
		var bankAccounts = _v1.a;
		var _v2 = _v0.b;
		var cards = _v2.a;
		return ($elm$core$List$length(bankAccounts) + $elm$core$List$length(cards)) > 0;
	} else {
		return false;
	}
};
var $author$project$Pages$Onboarding$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Onboarding$PracticePaymentSourcesMsg,
				$author$project$Components$Practice$PaymentSources$modal(model.cj)),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Welcome to Hint!')
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Sources')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add payment source that will be used for Hint fees')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = _Utils_Tuple2(model.me, model.ck);
								_v0$1:
								while (true) {
									_v0$3:
									while (true) {
										switch (_v0.a.$) {
											case 1:
												var _v1 = _v0.a;
												return $author$project$Components$HintBilling$NextBill$skeleton;
											case 3:
												switch (_v0.b.$) {
													case 1:
														break _v0$1;
													case 3:
														var _v3 = _v0.a;
														var feePlan_ = _v3.a;
														var _v4 = _v0.b;
														var practicePricing_ = _v4.a;
														return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing_) ? A4(
															$author$project$Components$HintBilling$LegacyPricing$view,
															model.cO,
															feePlan_,
															$author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(practicePricing_),
															$author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing_)) : A2(
															$author$project$Ui$Element$view,
															_List_Nil,
															_List_fromArray(
																[
																	A2($author$project$Components$HintBilling$NextBill$view, practicePricing_, $author$project$Utils$Html$empty),
																	A2($elm$html$Html$br, _List_Nil, _List_Nil),
																	A5(
																	$author$project$Components$HintBilling$Pricing$view,
																	model.me,
																	model.cO,
																	$author$project$Api$Provider$Practice$One$hasClinicalAccount(model.WF),
																	$author$project$Pages$Onboarding$AnalyticsLinkClicked,
																	practicePricing_)
																]));
													default:
														break _v0$3;
												}
											default:
												if (_v0.b.$ === 1) {
													break _v0$1;
												} else {
													break _v0$3;
												}
										}
									}
									return $author$project$Components$HintBilling$NextBill$skeleton;
								}
								var _v2 = _v0.b;
								return $author$project$Components$HintBilling$NextBill$skeleton;
							}(),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Onboarding$PracticePaymentSourcesMsg,
								A2($author$project$Components$Practice$PaymentSources$view, model.cj, false))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Continue to next step'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$disabled(
										!$author$project$Pages$Onboarding$hasAnyPaymentSource(model.cj)),
										$author$project$Ui$Button$onClick($author$project$Pages$Onboarding$CompleteOnboardingClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Continue')
									])),
								model.FR ? A3(
								$author$project$Ui$HinterOnly$button,
								{abp: 'Skip payment requirement'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Pages$Onboarding$SkipPaymentRequirementClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Skip payment requirement')
									])) : $author$project$Utils$Html$empty
							]))
					]))
			]),
		$G: 'Onboarding'
	};
};
var $author$project$Pages$Onboarding$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Onboarding$init, aer: $author$project$Pages$Onboarding$load, agD: $author$project$Pages$Onboarding$save, ahd: $author$project$Pages$Onboarding$subscriptions, aaq: $author$project$Pages$Onboarding$update, ahP: $author$project$Pages$Onboarding$view});
var $author$project$Spa$Page$applicationPartner = function (page) {
	return {
		ad0: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple2(shared.ZD, shared.Vz);
				_v0$2:
				while (true) {
					_v0$4:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var _v1 = _v0.a;
										var session = _v1.a;
										var _v2 = _v0.b;
										var partner = _v2.a;
										return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) ? _Utils_Tuple3(
											$author$project$Spa$Page$SessionLoading(url),
											A2(
												$author$project$Utils$Route$navigate,
												$elm$core$Dict$empty,
												A2($author$project$Permission$homeStateFor, session, shared.adN)),
											_List_Nil) : A2(
											$author$project$Utils$Tuple3$mapFirst,
											$author$project$Spa$Page$SessionLoaded,
											A2(
												$author$project$Utils$Tuple3$fromTuple2,
												_List_Nil,
												A4(page.ad0, session, partner, shared, url)));
									case 2:
										break _v0$2;
									default:
										break _v0$4;
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							case 0:
								if (_v0.b.$ === 2) {
									break _v0$2;
								} else {
									var _v3 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{af6: true}),
										_List_Nil);
								}
							default:
								if (_v0.b.$ === 2) {
									break _v0$2;
								} else {
									break _v0$4;
								}
						}
					}
					return _Utils_Tuple3(
						$author$project$Spa$Page$SessionLoading(url),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aer: F2(
			function (shared, model) {
				var _v4 = _Utils_Tuple3(shared.ZD, shared.Vz, model);
				_v4$2:
				while (true) {
					_v4$3:
					while (true) {
						if (!_v4.c.$) {
							switch (_v4.a.$) {
								case 3:
									switch (_v4.b.$) {
										case 3:
											var _v5 = _v4.a;
											var session = _v5.a;
											var _v6 = _v4.b;
											var partner = _v6.a;
											var url = _v4.c.a;
											if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) {
												return _Utils_Tuple3(
													$author$project$Spa$Page$SessionLoading(url),
													A2(
														$author$project$Utils$Route$navigate,
														$elm$core$Dict$empty,
														A2($author$project$Permission$homeStateFor, session, shared.adN)),
													_List_Nil);
											} else {
												var _v7 = A4(page.ad0, session, partner, shared, url);
												var pageModel = _v7.a;
												var cmd = _v7.b;
												return _Utils_Tuple3(
													$author$project$Spa$Page$SessionLoaded(pageModel),
													cmd,
													_List_Nil);
											}
										case 2:
											break _v4$2;
										default:
											break _v4$3;
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								default:
									if (_v4.b.$ === 2) {
										break _v4$2;
									} else {
										break _v4$3;
									}
							}
						} else {
							break _v4$3;
						}
					}
					if (model.$ === 1) {
						var modelWithSession = model.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Spa$Page$SessionLoaded,
								A2(
									page.aer,
									shared,
									_Utils_update(
										modelWithSession,
										{D5: shared.D5}))));
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		agD: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.agD, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		ahd: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahd(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		aaq: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.aaq, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		ahP: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahP(modelWithSession);
			} else {
				return {e5: $author$project$Components$BlankPage$view, $G: 'Loading...'};
			}
		}
	};
};
var $author$project$Components$Partner$ManageApiKeys$Integrations = {$: 1};
var $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$Partner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManageApiKeys$GotApiKeys = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{afy: model.afy, ag1: model.ag1});
	};
};
var $author$project$Api$Partner$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['api_keys']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$ApiKey$All$ApiKey = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$ApiKey$All$Record = function (integration) {
	return {Q4: integration};
};
var $author$project$Api$Partner$Integration$Shared$Integration = $elm$core$Basics$identity;
var $author$project$Api$Partner$Integration$Shared$Record = F5(
	function (id, status, practiceActive, partnerActive, practice) {
		return {adR: id, VA: partnerActive, WF: practice, WG: practiceActive, ag7: status};
	});
var $author$project$Api$Partner$Practice$Shared$Practice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$Practice$Shared$Record = F2(
	function (organizationId, hasClinicalAccount) {
		return {P2: hasClinicalAccount, aft: organizationId};
	});
var $author$project$Api$Partner$Practice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'has_clinical_account',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'organization_id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Shared$Record)));
var $author$project$Api$Partner$Practice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Practice$Shared$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$Practice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Shared$Practice)));
var $author$project$Api$Partner$Integration$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice',
	$author$project$Api$Partner$Practice$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'partner_active',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'practice_active',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$Integration$Shared$Record))))));
var $author$project$Api$Partner$Integration$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Integration$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$ApiKey$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'integration',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$Integration$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$All$Record));
var $author$project$Api$Partner$ApiKey$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$ApiKey$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$ApiKey$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$All$ApiKey)));
var $author$project$Api$Partner$Common$ApiKey$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Common$ApiKey$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Common$ApiKey$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Partner$ApiKey$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$ApiKey$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Common$ApiKey$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Partner$Integration$integrationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['integrations']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Integration$ApiKey$apiKeysPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['api_keys']),
	$author$project$Api$Partner$Integration$integrationsPath);
var $author$project$Api$Partner$Integration$ApiKey$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$ApiKey$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Common$ApiKey$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$ApiKey$apiKeysPath)));
	});
var $author$project$Components$Partner$ManageApiKeys$fetchApiKeys = F2(
	function (apiClient, model) {
		var _v0 = model.Vp;
		if (!_v0.$) {
			return A3(
				$author$project$Api$Partner$ApiKey$list,
				apiClient,
				$author$project$Components$Partner$ManageApiKeys$fetchParams(model),
				$author$project$Components$Partner$ManageApiKeys$GotApiKeys);
		} else {
			return A3(
				$author$project$Api$Partner$Integration$ApiKey$list,
				apiClient,
				$author$project$Components$Partner$ManageApiKeys$fetchParams(model),
				$author$project$Components$Partner$ManageApiKeys$GotApiKeys);
		}
	});
var $author$project$Components$ResourceFilter$Partner$Integration$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Partner$Integration$All$Integration = $elm$core$Basics$identity;
var $author$project$Api$Partner$Integration$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Integration$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Integration$listDefaults = {adR: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Integration$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Integration$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				function () {
				var _v0 = options.adR;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'id', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.af_;
				if (!_v1.$) {
					var string = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Partner$Integration$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Integration$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Integration$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$integrationsPath)));
	});
var $author$project$Components$ResourceFilter$Partner$Integration$list = F3(
	function (apiClient, optionals, toMsg) {
		return A3($author$project$Api$Partner$Integration$list, apiClient, optionals, toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Integration$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$Integration$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Integration$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$Integration$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						af_: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Integration$selectId = 'partner-integrations';
var $author$project$Api$Partner$Practice$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Partner$Practice$Shared$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Partner$Practice$Min$name(min);
};
var $author$project$Api$Partner$Integration$Shared$practice = function (_v0) {
	var record = _v0;
	return record.WF;
};
var $author$project$Api$Partner$Integration$All$practice = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Integration$Shared$practice(shared);
};
var $author$project$Components$ResourceFilter$Partner$Integration$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$Partner$Integration$All$practice, $author$project$Api$Partner$Practice$Shared$name);
var $author$project$Components$ResourceFilter$Partner$Integration$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Partner$Integration$toTitle(resource))
		]);
};
var $author$project$Api$Partner$Integration$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Partner$Integration$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Integration$Shared$id(shared);
};
var $author$project$Components$ResourceFilter$Partner$Integration$toValue = $author$project$Api$Partner$Integration$All$id;
var $author$project$Components$ResourceFilter$Partner$Integration$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$Partner$Integration$fetchResources, adR: $author$project$Components$ResourceFilter$Partner$Integration$selectId, gx: 'Integrations', st: $author$project$Components$ResourceFilter$Partner$Integration$retrieveResource, ahw: $author$project$Components$ResourceFilter$Partner$Integration$toLabel, ahA: $author$project$Components$ResourceFilter$Partner$Integration$toTitle, g0: $author$project$Components$ResourceFilter$Partner$Integration$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Sort$withPrefix = F2(
	function (prefix, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{A7: prefix});
	});
var $author$project$Components$Partner$ManageApiKeys$init = F4(
	function (apiClient, timeFormatter, owner, query) {
		var prefix = function () {
			if (!owner.$) {
				return 'partner_';
			} else {
				return 'integrations_';
			}
		}();
		var _v0 = A2(
			$author$project$Components$ResourceFilter$Partner$Integration$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Practice'});
			});
		var integrationResourceFilter = _v0.a;
		var integrationResourceFilterCmd = _v0.b;
		var model = {
			bN: $author$project$Api$Data$Loading,
			ic: $elm$core$Maybe$Nothing,
			mw: integrationResourceFilter,
			FU: $elm$core$Maybe$Nothing,
			Vp: owner,
			afy: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, prefix, $author$project$Api$Pagination$init)),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'created_at',
				1,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, prefix, $author$project$Api$Sort$init))),
			Hy: timeFormatter,
			bE: $elm$core$Set$empty,
			dl: $elm$core$Set$empty
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg, integrationResourceFilterCmd)
					])));
	});
var $author$project$Pages$Partner$ApiKeys$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.Bi;
		var _v2 = A4($author$project$Components$Partner$ManageApiKeys$init, shared.D5, shared.Hy, $author$project$Components$Partner$ManageApiKeys$Integrations, query);
		var manageIntegrationsApiKeys = _v2.a;
		var manageIntegrationsApiKeysCmd = _v2.b;
		var _v3 = A4(
			$author$project$Components$Partner$ManageApiKeys$init,
			shared.D5,
			shared.Hy,
			$author$project$Components$Partner$ManageApiKeys$Partner(partner),
			query);
		var manageGlobalApiKeys = _v3.a;
		var manageGlobalApiKeysCmd = _v3.b;
		var model = {D5: shared.D5, mW: manageGlobalApiKeys, mY: manageIntegrationsApiKeys};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg, manageGlobalApiKeysCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg, manageIntegrationsApiKeysCmd)
					])));
	});
var $author$project$Pages$Partner$ApiKeys$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$ApiKeys$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$ManageApiKeys$CancelEdit = {$: 6};
var $author$project$Components$ResourceFilter$Partner$Integration$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Partner$ManageApiKeys$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManageApiKeys$CancelEdit)),
					model.FU)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Partner$Integration$subscriptions(model.mw))
			]));
};
var $author$project$Pages$Partner$ApiKeys$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg,
				$author$project$Components$Partner$ManageApiKeys$subscriptions(model.mW)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg,
				$author$project$Components$Partner$ManageApiKeys$subscriptions(model.mY))
			]));
};
var $author$project$Components$Partner$ManageApiKeys$IntegrationField = function (a) {
	return {$: 1, a: a};
};
var $author$project$OutMsg$RefreshPartner = {$: 3};
var $author$project$Components$Partner$ManageApiKeys$WebhooksSignatureApiKeyUpdated = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Partner$ManageApiKeys$Deleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Api$Partner$ApiKey$apiKeyPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$ApiKey$apiKeysPath);
};
var $author$project$Api$Partner$ApiKey$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$ApiKey$apiKeyPath(id)));
	});
var $author$project$Api$Partner$Integration$ApiKey$apiKeyPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Partner$Integration$ApiKey$apiKeysPath);
};
var $author$project$Api$Partner$Integration$ApiKey$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$Integration$ApiKey$apiKeyPath(id)));
	});
var $author$project$Api$Partner$ApiKey$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Partner$ApiKey$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$id(shared);
};
var $author$project$Components$Partner$ManageApiKeys$deleteItem = F3(
	function (apiClient, owner, item) {
		if (!owner.$) {
			return A3(
				$author$project$Api$Partner$ApiKey$delete,
				apiClient,
				$author$project$Api$Partner$ApiKey$All$id(item),
				$author$project$Components$Partner$ManageApiKeys$Deleted(item));
		} else {
			return A3(
				$author$project$Api$Partner$Integration$ApiKey$delete,
				apiClient,
				$author$project$Api$Partner$ApiKey$All$id(item),
				$author$project$Components$Partner$ManageApiKeys$Deleted(item));
		}
	});
var $author$project$Api$Partner$ApiKey$All$integration = function (_v0) {
	var record = _v0.b;
	return record.Q4;
};
var $author$project$Api$Partner$ApiKey$Shared$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Partner$ApiKey$All$label = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$label(shared);
};
var $author$project$Components$Partner$ManageApiKeys$formFieldsFromItem = function (apiKey) {
	return _Utils_Tuple2(
		{
			Q4: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$Integration$Shared$id,
				$author$project$Api$Partner$ApiKey$All$integration(apiKey)),
			aej: $author$project$Api$Partner$ApiKey$All$label(apiKey)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Partner$ManageApiKeys$formFieldsInit = _Utils_Tuple2(
	{Q4: $elm$core$Maybe$Nothing, aej: $elm$core$Maybe$Nothing},
	$elm$core$Platform$Cmd$none);
var $author$project$Components$Partner$ManageApiKeys$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{
					aej: $author$project$Utils$String$toMaybe(string)
				});
		} else {
			var integration = field.a;
			return _Utils_update(
				fields,
				{Q4: integration});
		}
	});
var $author$project$Components$Partner$ManageApiKeys$IntegrationValidation = 0;
var $author$project$Components$Partner$ManageApiKeys$validateIntegration = F2(
	function (owner, fields) {
		if (!owner.$) {
			return _List_Nil;
		} else {
			return _Utils_eq(fields.Q4, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Practice is required')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Partner$ManageApiKeys$formFieldsValidator = function (owner) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Partner$ManageApiKeys$validateIntegration(owner))
			]));
};
var $author$project$Components$Partner$ManageApiKeys$Created = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$ApiKey$One$ApiKey = 0;
var $author$project$Api$Partner$ApiKey$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$ApiKey$apiKeysPath)));
	});
var $author$project$Api$Partner$Integration$ApiKey$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aej)),
								_Utils_Tuple2(
								'integration',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.Q4))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$ApiKey$apiKeysPath)));
	});
var $author$project$Components$Partner$ManageApiKeys$integrationApiKeyApiFields = function (fields) {
	return {Q4: fields.Q4, aej: fields.aej};
};
var $author$project$Components$Partner$ManageApiKeys$partnerApiKeyApiFields = function (fields) {
	return {aej: fields.aej};
};
var $author$project$Components$Partner$ManageApiKeys$createItem = F3(
	function (apiClient, owner, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		if (!owner.$) {
			return A3(
				$author$project$Api$Partner$ApiKey$create,
				apiClient,
				$author$project$Components$Partner$ManageApiKeys$partnerApiKeyApiFields(fields),
				$author$project$Components$Partner$ManageApiKeys$Created);
		} else {
			return A3(
				$author$project$Api$Partner$Integration$ApiKey$create,
				apiClient,
				$author$project$Components$Partner$ManageApiKeys$integrationApiKeyApiFields(fields),
				$author$project$Components$Partner$ManageApiKeys$Created);
		}
	});
var $author$project$Components$Partner$ManageApiKeys$Updated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$ApiKey$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$ApiKey$apiKeyPath(id))));
	});
var $author$project$Api$Partner$Integration$ApiKey$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'api_key',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aej))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$ApiKey$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$Integration$ApiKey$apiKeyPath(id))));
	});
var $author$project$Components$Partner$ManageApiKeys$updateItem = F4(
	function (apiClient, owner, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		if (!owner.$) {
			return A4(
				$author$project$Api$Partner$ApiKey$update,
				apiClient,
				id,
				{aej: fields.aej},
				$author$project$Components$Partner$ManageApiKeys$Updated);
		} else {
			return A4(
				$author$project$Api$Partner$Integration$ApiKey$update,
				apiClient,
				id,
				{aej: fields.aej},
				$author$project$Components$Partner$ManageApiKeys$Updated);
		}
	});
var $author$project$Components$Partner$ManageApiKeys$saveItem = F4(
	function (apiClient, owner, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Components$Partner$ManageApiKeys$updateItem, apiClient, owner, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManageApiKeys$createItem, apiClient, owner, formFields);
		}
	});
var $author$project$Components$ResourceFilter$Partner$Integration$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if ((!_v1.$) && (!_v1.a.$)) {
				var selected = _v1.a.a;
				return _Utils_update(
					model,
					{G0: selected});
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Partner$ManageApiKeys$updateUrl = function (model) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__ApiKeys)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				$author$project$Api$Sort$toQuery(model.ag1))));
};
var $author$project$Api$Partner$Partner$updateWebhooksSignatureApiKey = F3(
	function (apiClient, id, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhooks_signature_api_key',
					$author$project$Utils$Encode$association(id))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['webhooks_signature_api_key']),
						$author$project$Api$Partner$Partner$partnerPath))));
	});
var $author$project$Components$ResourceFilter$Partner$Integration$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Partner$ManageApiKeys$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bN: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bN: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{bN: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, newModel),
								$author$project$Components$Partner$ManageApiKeys$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bN: $author$project$Api$Data$Loading,
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, newModel),
								$author$project$Components$Partner$ManageApiKeys$updateUrl(newModel)
							])),
					_List_Nil);
			case 14:
				var tokenStr = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(tokenStr),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard.')
						]));
			case 3:
				var id = msg.a;
				var visibleApiKeyTokens = A2($elm$core$Set$member, id, model.dl) ? A2($elm$core$Set$remove, id, model.dl) : A2($elm$core$Set$insert, id, model.dl);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dl: visibleApiKeyTokens}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var _v3 = $author$project$Components$Partner$ManageApiKeys$formFieldsInit;
				var formFields = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 5:
				var item = msg.a;
				var _v4 = $author$project$Components$Partner$ManageApiKeys$formFieldsFromItem(item);
				var formFields = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(item),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var field = msg.a;
				var _v5 = model.FU;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var id = _v6.a;
					var form = _v6.b;
					var request = _v6.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManageApiKeys$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var item = msg.a;
				var form = msg.b;
				var _v7 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Partner$ManageApiKeys$formFieldsValidator(model.Vp),
					form);
				if (!_v7.$) {
					var _v8 = _v7.a;
					var validatedForm = _v8.a;
					var validFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Components$Partner$ManageApiKeys$saveItem,
							apiClient,
							model.Vp,
							A2($elm$core$Maybe$map, $author$project$Api$Partner$ApiKey$All$id, item),
							validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v9 = model.FU;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bN: $author$project$Api$Data$Loading, FU: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully created api key'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				var _v12 = model.FU;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bN: $author$project$Api$Data$Loading, FU: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated api key')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Partner$ApiKey$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ic: $elm$core$Maybe$Nothing,
								bE: A2($elm$core$Set$insert, id, model.bE)
							}),
						A3($author$project$Components$Partner$ManageApiKeys$deleteItem, apiClient, model.Vp, item),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bN: $author$project$Api$Data$Loading,
									bE: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$ApiKey$All$id(item),
										model.bE)
								}),
							A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Api key was successfully removed.'),
									$author$project$OutMsg$RefreshPartner
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bE: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$ApiKey$All$id(item),
										model.bE)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var item = msg.a;
				var _v16 = model.Vp;
				if (!_v16.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bE: A2(
									$elm$core$Set$insert,
									$author$project$Api$Partner$ApiKey$All$id(item),
									model.bE)
							}),
						A3(
							$author$project$Api$Partner$Partner$updateWebhooksSignatureApiKey,
							apiClient,
							$author$project$Api$Partner$ApiKey$All$id(item),
							$author$project$Components$Partner$ManageApiKeys$WebhooksSignatureApiKeyUpdated(item)),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bN: $author$project$Api$Data$Loading,
									Vp: $author$project$Components$Partner$ManageApiKeys$Partner(partner),
									bE: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$ApiKey$All$id(item),
										model.bE)
								}),
							A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated webhooks signature api key')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bE: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$ApiKey$All$id(item),
										model.bE)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var integrationResourceResult = A3($author$project$Components$ResourceFilter$Partner$Integration$update, apiClient, subMsg, model.mw);
				var item = function () {
					var _v18 = _Utils_Tuple2(model.FU, integrationResourceResult.ac5);
					if (!_v18.a.$) {
						if ((!_v18.b.$) && (!_v18.b.a.$)) {
							var _v19 = _v18.a.a;
							var id = _v19.a;
							var form = _v19.b;
							var request = _v19.c;
							var updatedForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Partner$ManageApiKeys$formFieldsUpdate,
								$author$project$Components$Partner$ManageApiKeys$IntegrationField(
									$author$project$Components$ResourceFilter$Partner$Integration$value(integrationResourceResult.y8)),
								form);
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(id, updatedForm, request));
						} else {
							var item_ = _v18.a.a;
							return $elm$core$Maybe$Just(item_);
						}
					} else {
						var _v20 = _v18.a;
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mw: integrationResourceResult.y8, FU: item}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg, integrationResourceResult.EC),
					integrationResourceResult.as);
		}
	});
var $author$project$Pages$Partner$ApiKeys$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A3($author$project$Components$Partner$ManageApiKeys$update, model.D5, subMsg, model.mW);
			var manageGlobalApiKeys = _v1.a;
			var manageGlobalApiKeysCmd = _v1.b;
			var manageGlobalApiKeysOutMsgs = _v1.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{mW: manageGlobalApiKeys}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg, manageGlobalApiKeysCmd),
				manageGlobalApiKeysOutMsgs);
		} else {
			var subMsg = msg.a;
			var _v2 = A3($author$project$Components$Partner$ManageApiKeys$update, model.D5, subMsg, model.mY);
			var manageIntegrationsApiKeys = _v2.a;
			var manageIntegrationsApiKeysCmd = _v2.b;
			var manageIntegrationsApiKeysOutMsgs = _v2.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{mY: manageIntegrationsApiKeys}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg, manageIntegrationsApiKeysCmd),
				manageIntegrationsApiKeysOutMsgs);
		}
	});
var $author$project$Components$Partner$ManageApiKeys$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Partner$ManageApiKeys$New = {$: 4};
var $author$project$Components$Partner$ManageApiKeys$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$FormUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$Label = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$Save = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Components$ResourceFilter$Partner$Integration$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Partner$ManageApiKeys$viewCreateEditModal = F5(
	function (owner, integrationResourceFilter, item, form, request) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Api Key',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Partner$ApiKey$All$id, item),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$ManageApiKeys$CancelEdit,
			U0: $elm$core$Basics$always(
				A2($author$project$Components$Partner$ManageApiKeys$Save, item, form))
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					function () {
					if (!owner.$) {
						return $author$project$Utils$Html$empty;
					} else {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('Practice')
								]),
							_List_fromArray(
								[
									function () {
									if (!item.$) {
										var item_ = item.a;
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Partner$Practice$Shared$name,
															A2(
																$elm$core$Maybe$map,
																$author$project$Api$Partner$Integration$Shared$practice,
																$author$project$Api$Partner$ApiKey$All$integration(item_)))))
												]));
									} else {
										return A2(
											$elm$html$Html$map,
											$author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Partner$Integration$viewNew,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
														$author$project$Components$ResourceFilter$errors(
														A2($author$project$Utils$Form$validationErrors, 0, form))
													]),
												integrationResourceFilter));
									}
								}()
								]));
					}
				}(),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Label')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.aej)),
									$author$project$Ui$Form$Input$placeholder('Optional label'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManageApiKeys$FormUpdated, $author$project$Components$Partner$ManageApiKeys$Label))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManageApiKeys$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$columns = function (owner) {
	return _Utils_ap(
		function () {
			if (!owner.$) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						A3($author$project$Api$Column$init, 'name', true, 'Practice')
					]);
			}
		}(),
		_List_fromArray(
			[
				A3($author$project$Api$Column$init, 'label', true, 'Label'),
				A3($author$project$Api$Column$init, 'token', true, 'Token'),
				A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
				A3($author$project$Api$Column$init, 'last_used_at', true, 'Last Used At'),
				A3($author$project$Api$Column$init, 'deactivated_at', true, 'Deactivated At')
			]));
};
var $author$project$Components$Partner$ManageApiKeys$CopyToken = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$ToggleApiKey = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$UseForWebhooksSignature = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Partner$ApiKey$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Partner$ApiKey$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$createdAt(shared);
};
var $author$project$Api$Partner$ApiKey$Shared$deactivatedAt = function (_v0) {
	var record = _v0;
	return record.M0;
};
var $author$project$Api$Partner$ApiKey$All$deactivatedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$deactivatedAt(shared);
};
var $author$project$Api$Partner$ApiKey$Shared$lastUsedAt = function (_v0) {
	var record = _v0;
	return record.SF;
};
var $author$project$Api$Partner$ApiKey$All$lastUsedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$lastUsedAt(shared);
};
var $author$project$Api$Partner$ApiKey$Shared$token = function (_v0) {
	var record = _v0;
	return record.$Q;
};
var $author$project$Api$Partner$ApiKey$All$token = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$ApiKey$Shared$token(shared);
};
var $author$project$Components$Partner$ManageApiKeys$Delete = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$viewDeleteButton = F3(
	function (disabled, loading, apiKey) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$active(disabled),
					$author$project$Ui$Tooltip$padding(2)
				]),
			'Can’t remove the api key being used for the webhooks signature.',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Delete api key'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$loading(loading),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Partner$ManageApiKeys$Delete(apiKey)),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
							$author$project$Ui$Button$disabled(disabled)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						]))
				]));
	});
var $author$project$Components$Partner$ManageApiKeys$Edit = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$ManageApiKeys$viewEditButton = F2(
	function (loading, apiKey) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Edit api key'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$ManageApiKeys$Edit(apiKey)),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
					$author$project$Ui$Button$loading(loading)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Edit')
				]));
	});
var $author$project$Api$Partner$Partner$One$webhooksSignatureApiKey = function (_v0) {
	var record = _v0.b;
	return record.aaZ;
};
var $author$project$Components$Partner$ManageApiKeys$viewApiKey = F5(
	function (timeFormatter, owner, updatingItems, visibleApiKeyTokens, apiKey) {
		var id = $author$project$Api$Partner$ApiKey$All$id(apiKey);
		var loading = A2($elm$core$Set$member, id, updatingItems);
		var visible = A2($elm$core$Set$member, id, visibleApiKeyTokens);
		var _v0 = visible ? _Utils_Tuple2(55, 'Hide api key') : _Utils_Tuple2(56, 'Show api key');
		var visibleIcon = _v0.a;
		var ariaLabel = _v0.b;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!owner.$) {
							return _List_Nil;
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Partner$Practice$Shared$name,
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Partner$Integration$Shared$practice,
														$author$project$Api$Partner$ApiKey$All$integration(apiKey)))))
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										$author$project$Api$Partner$ApiKey$All$label(apiKey)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									visible ? _List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$ApiKey$All$token(apiKey))
										]) : _List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$String$repeat,
												$elm$core$String$length(
													$author$project$Api$Partner$ApiKey$All$token(apiKey)) - 4,
												'*')),
											$elm$html$Html$text(
											A2(
												$elm$core$String$right,
												4,
												$author$project$Api$Partner$ApiKey$All$token(apiKey)))
										])),
									$author$project$Utils$Html$noBreakSpace,
									A3(
									$author$project$Ui$Button$view,
									{abp: ariaLabel},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Partner$ManageApiKeys$ToggleApiKey(id))
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Icon$view,
											_List_fromArray(
												[$author$project$Ui$Icon$clickable]),
											visibleIcon)
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Copy api key'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Partner$ManageApiKeys$CopyToken(
												$author$project$Api$Partner$ApiKey$All$token(apiKey))),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
										]),
									_List_Nil)
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										0,
										$author$project$Api$Partner$ApiKey$All$createdAt(apiKey)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(0),
											$author$project$Api$Partner$ApiKey$All$lastUsedAt(apiKey))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(0),
											$author$project$Api$Partner$ApiKey$All$deactivatedAt(apiKey))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[$author$project$Ui$Table$textRight]),
							function () {
								if (!owner.$) {
									var partner = owner.a;
									var isWebhooksSignatureApiKey = _Utils_eq(
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Partner$ApiKey$Shared$id,
											$author$project$Api$Partner$Partner$One$webhooksSignatureApiKey(partner)),
										$elm$core$Maybe$Just(id));
									return isWebhooksSignatureApiKey ? _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$padding(2)
												]),
											_List_fromArray(
												[
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Badge$view,
													_List_fromArray(
														[$author$project$Ui$Badge$info]),
													_List_fromArray(
														[
															$elm$html$Html$text('Webhooks Signature')
														]))
												])),
											A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
											A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, true, loading, apiKey)
										]) : _List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Use api key for webhooks signature'},
											_List_fromArray(
												[
													$author$project$Ui$Button$secondary,
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Partner$ManageApiKeys$UseForWebhooksSignature(apiKey)),
													$author$project$Ui$Button$loading(loading)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Use for webhooks signature')
												])),
											A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
											A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, false, loading, apiKey)
										]);
								} else {
									return _List_fromArray(
										[
											A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
											A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, false, loading, apiKey)
										]);
								}
							}())
						])
					])));
	});
var $author$project$Components$Partner$ManageApiKeys$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bN;
		if (_v1.$ === 3) {
			var apiKeys_ = _v1.a;
			return _Utils_Tuple2(false, apiKeys_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var apiKeys = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any api keys')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Partner$ManageApiKeys$SortTable)),
				$author$project$Components$Partner$ManageApiKeys$columns(model.Vp)),
			_List_fromArray(
				[
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				])),
		A2(
			$elm$core$List$map,
			A4($author$project$Components$Partner$ManageApiKeys$viewApiKey, model.Hy, model.Vp, model.bE, model.dl),
			apiKeys),
		_List_Nil);
};
var $author$project$Components$Partner$ManageApiKeys$view = function (_v0) {
	var model = _v0;
	var loading = function () {
		var _v5 = model.bN;
		if (_v5.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return _List_fromArray(
		[
			function () {
			var _v1 = model.FU;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var item = _v2.a;
				var form = _v2.b;
				var request = _v2.c;
				return A5($author$project$Components$Partner$ManageApiKeys$viewCreateEditModal, model.Vp, model.mw, item, form, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.ic;
			if (!_v3.$) {
				var item = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Partner$ManageApiKeys$HiConfirmClosed(item),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('api key')
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									function () {
									var _v4 = model.Vp;
									if (!_v4.$) {
										return $elm$html$Html$text('Partner Api Keys');
									} else {
										return $elm$html$Html$text('Practices Api Keys');
									}
								}()
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add new api key'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick($author$project$Components$Partner$ManageApiKeys$New),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New Api Key')
										]))
								]))
						])),
					$author$project$Components$Partner$ManageApiKeys$viewTable(model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Partner$ManageApiKeys$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.afy))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$ApiKeys$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg),
							$author$project$Components$Partner$ManageApiKeys$view(model.mW))),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg),
							$author$project$Components$Partner$ManageApiKeys$view(model.mY)))
					]))
			]),
		$G: 'Partner | Api Keys'
	};
};
var $author$project$Pages$Partner$ApiKeys$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$ApiKeys$init, aer: $author$project$Pages$Partner$ApiKeys$load, agD: $author$project$Pages$Partner$ApiKeys$save, ahd: $author$project$Pages$Partner$ApiKeys$subscriptions, aaq: $author$project$Pages$Partner$ApiKeys$update, ahP: $author$project$Pages$Partner$ApiKeys$view});
var $author$project$Pages$Partner$Billing$GotAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$RainforestAccount$One$RainforestAccount = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$RainforestAccount$Shared$RainforestAccount = $elm$core$Basics$identity;
var $author$project$Api$Partner$RainforestAccount$Shared$Record = function (status) {
	return {ag7: status};
};
var $author$project$Api$Partner$RainforestAccount$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$Shared$Record));
var $author$project$Api$Partner$RainforestAccount$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$RainforestAccount$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$RainforestAccount$One$Record = F8(
	function (merchantId, merchantApplicationId, merchantApplicationStatus, statementDescriptor, depositAccountLast4, depositAccountRoutingNumber, depositAccountBankName, depositAccountAccountType) {
		return {Nt: depositAccountAccountType, Nu: depositAccountBankName, Nv: depositAccountLast4, Nw: depositAccountRoutingNumber, TP: merchantApplicationId, TQ: merchantApplicationStatus, TR: merchantId, _J: statementDescriptor};
	});
var $author$project$Api$Partner$RainforestAccount$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'deposit_account_account_type',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'deposit_account_bank_name',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'deposit_account_routing_number',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'deposit_account_last_4',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'statement_descriptor',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'merchant_application_status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'merchant_application_id',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'merchant_id',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$One$Record)))))))));
var $author$project$Api$Partner$RainforestAccount$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$RainforestAccount$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$RainforestAccount$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$One$RainforestAccount)));
var $author$project$Api$Partner$RainforestAccount$rainforestAccountPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['rainforest_account']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$RainforestAccount$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Pages$Partner$Billing$init = F4(
	function (_v0, partner, shared, _v1) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				fm: $author$project$Api$Data$NotAsked,
				FR: $author$project$Shared$isHintAdmin(shared),
				yW: false,
				Vz: partner,
				cm: $author$project$Api$Data$Loading,
				Bl: $author$project$Rainforest$isSandbox(shared.sj),
				jR: $elm$core$Maybe$Nothing,
				Cc: $elm$core$Maybe$Nothing,
				ka: $elm$core$Maybe$Nothing,
				oG: $author$project$Api$Data$NotAsked
			},
			A2($author$project$Api$Partner$RainforestAccount$retrieve, shared.D5, $author$project$Pages$Partner$Billing$GotAccount));
	});
var $author$project$Pages$Partner$Billing$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Billing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Billing$ResetAccountModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Billing$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg)),
					model.ka)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Rainforest$ResetAccountModal$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Partner$Billing$ResetAccountModalMsg)),
					model.jR))
			]));
};
var $author$project$Pages$Partner$Billing$GotCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Billing$GotDeleteRainforestAccount = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Partner$Billing$GotSetupSessionKey = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Billing$PrefilledWithFakeData = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Partner$Billing$Synced = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$RainforestAccount$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Api$Partner$RainforestAccount$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
	});
var $author$project$Api$Partner$RainforestAccount$fakePrefill = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['fake_prefill']),
					$author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Api$Partner$RainforestAccount$reset = F3(
	function (apiClient, merchantName, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'merchant_name',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, merchantName))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reset']),
						$author$project$Api$Partner$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Api$Partner$RainforestAccount$One$record = function (_v0) {
	var record_ = _v0.b;
	return record_;
};
var $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.TQ;
	});
var $author$project$Api$Partner$RainforestAccount$setup = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			A2($elm$json$Json$Decode$field, 'session_key', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['setup']),
					$author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Pages$Partner$Billing$retrieveSetupSessionKey = F2(
	function (apiClient, rainforestAccount) {
		return ($author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount) !== 'completed') ? A2($author$project$Api$Partner$RainforestAccount$setup, apiClient, $author$project$Pages$Partner$Billing$GotSetupSessionKey) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Api$Partner$RainforestAccount$simulateStatusChange = F4(
	function (apiClient, status, reviewTypes, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'status',
					$elm$json$Json$Encode$string(status)),
					_Utils_Tuple2(
					'review_types',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, reviewTypes))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['simulate_status_change']),
						$author$project$Api$Partner$RainforestAccount$rainforestAccountPath))));
	});
var $author$project$Api$Partner$RainforestAccount$sync = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$RainforestAccount$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync']),
					$author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
	});
var $author$project$Pages$Partner$Billing$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var rainforestAccount = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{cm: response}),
								A2($author$project$Pages$Partner$Billing$retrieveSetupSessionKey, model.D5, rainforestAccount),
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v2 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{cm: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cm: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$RainforestAccount$create, model.D5, $author$project$Pages$Partner$Billing$GotCreated),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cm: response}),
						A2($author$project$Api$Partner$RainforestAccount$setup, model.D5, $author$project$Pages$Partner$Billing$GotSetupSessionKey),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var sessionKey = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Cc: $elm$core$Maybe$Just(sessionKey)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{yW: true}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Payment Processing Application submitted')
						]));
			case 7:
				var _v5 = $author$project$Components$Rainforest$SimulateApplicationEventModal$init($author$project$Api$Partner$RainforestAccount$simulateStatusChange);
				var simulateApplicationEventModal = _v5.a;
				var simulateApplicationEventModalCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ka: $elm$core$Maybe$Just(simulateApplicationEventModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg, simulateApplicationEventModalCmd),
					_List_Nil);
			case 8:
				var simulateApplicationEventModalMsg = msg.a;
				var _v6 = model.ka;
				if (!_v6.$) {
					var simulateApplicationEventModal = _v6.a;
					var simulateApplicationEventModalResult = A3($author$project$Components$Rainforest$SimulateApplicationEventModal$update, model.D5, simulateApplicationEventModalMsg, simulateApplicationEventModal);
					var simulateApplicationEventModal_ = function () {
						var _v7 = simulateApplicationEventModalResult.ac5;
						switch (_v7) {
							case 1:
								return $elm$core$Maybe$Nothing;
							case 2:
								return $elm$core$Maybe$Just(simulateApplicationEventModalResult.y8);
							default:
								return $elm$core$Maybe$Just(simulateApplicationEventModalResult.y8);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ka: simulateApplicationEventModal_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg, simulateApplicationEventModalResult.EC),
						simulateApplicationEventModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var _v8 = $author$project$Components$Rainforest$ResetAccountModal$init($author$project$Api$Partner$RainforestAccount$reset);
				var resetAccountModal = _v8.a;
				var resetAccountModalCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jR: $elm$core$Maybe$Just(resetAccountModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$ResetAccountModalMsg, resetAccountModalCmd),
					_List_Nil);
			case 6:
				var resetAccountModalMsg = msg.a;
				var _v9 = model.jR;
				if (!_v9.$) {
					var resetAccountModal = _v9.a;
					var resetAccountModalResult = A3($author$project$Components$Rainforest$ResetAccountModal$update, model.D5, resetAccountModalMsg, resetAccountModal);
					var _v10 = function () {
						var _v11 = resetAccountModalResult.ac5;
						switch (_v11.$) {
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, model.cm);
							case 2:
								var rainforestAccountResponse = _v11.b;
								return _Utils_Tuple2($elm$core$Maybe$Nothing, rainforestAccountResponse);
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(resetAccountModalResult.y8),
									model.cm);
						}
					}();
					var resetAccountModal_ = _v10.a;
					var rainforestAccount = _v10.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cm: rainforestAccount, jR: resetAccountModal_}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$ResetAccountModalMsg, resetAccountModalResult.EC),
						resetAccountModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oG: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Partner$RainforestAccount$sync, model.D5, $author$project$Pages$Partner$Billing$Synced),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cm: response, oG: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sync with Rainforest was successful.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oG: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fm: $author$project$Api$Data$Loading}),
					A2($author$project$Api$Partner$RainforestAccount$delete, model.D5, $author$project$Pages$Partner$Billing$GotDeleteRainforestAccount),
					_List_Nil);
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fm: $author$project$Api$Data$NotAsked,
								cm: $author$project$Api$Data$Failure($author$project$Api$Data$NotFound)
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account was successfully deleted.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fm: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 13:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$RainforestAccount$fakePrefill, model.D5, $author$project$Pages$Partner$Billing$PrefilledWithFakeData),
					_List_Nil);
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Pages$Partner$Billing$DeleteRainforestAccount = {$: 11};
var $author$project$Pages$Partner$Billing$OpenResetAccountModal = {$: 5};
var $author$project$Pages$Partner$Billing$OpenSimulateModal = {$: 7};
var $author$project$Pages$Partner$Billing$PrefillWithFakeDataClicked = {$: 13};
var $author$project$Pages$Partner$Billing$Sync = {$: 9};
var $author$project$Pages$Partner$Billing$applicationIsProcessing = F2(
	function (rainforestAccount, _v0) {
		var merchantOnboardingSubmitted = _v0.yW;
		return merchantOnboardingSubmitted || ('processing' === $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount));
	});
var $author$project$Api$Partner$RainforestAccount$Shared$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Partner$RainforestAccount$Shared$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$Shared$record,
	function ($) {
		return $.ag7;
	});
var $author$project$Api$Partner$RainforestAccount$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$RainforestAccount$Shared$status(shared);
};
var $author$project$Pages$Partner$Billing$MerchantOnboardingSubmitted = {$: 4};
var $author$project$Api$Partner$RainforestAccount$One$merchantApplicationId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.TP;
	});
var $author$project$Api$Partner$RainforestAccount$One$merchantId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.TR;
	});
var $author$project$Api$Partner$RainforestAccount$One$depositAccountAccountType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.Nt;
	});
var $author$project$Api$Partner$RainforestAccount$One$depositAccountBankName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.Nu;
	});
var $author$project$Api$Partner$RainforestAccount$One$depositAccountLast4 = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.Nv;
	});
var $author$project$Api$Partner$RainforestAccount$One$depositAccountRoutingNumber = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $.Nw;
	});
var $author$project$Api$Partner$RainforestAccount$One$statementDescriptor = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Partner$RainforestAccount$One$record,
	function ($) {
		return $._J;
	});
var $author$project$Pages$Partner$Billing$viewActive = function (rainforestAccount) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Statement Descriptor'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$statementDescriptor(rainforestAccount)))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Deposit Account'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text('Bank Name: ')
									])),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$depositAccountBankName(rainforestAccount)))
							])),
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text('Last 4: ')
									])),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$depositAccountLast4(rainforestAccount)))
							])),
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text('Routing Number: ')
									])),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$depositAccountRoutingNumber(rainforestAccount)))
							])),
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text('Account Type: ')
									])),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									$author$project$Api$Partner$RainforestAccount$One$depositAccountAccountType(rainforestAccount)))
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Billing$viewInProgressAlert = A2(
	$author$project$Ui$Alert$info,
	_List_fromArray(
		[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Setup Hint Payments')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('To start processing payments in Hint, please complete the form below. It takes about 5–10 minutes and requires key details like your account’s contact info, tax ID, bank details, and ownership info (including SSN).')
				]))
		]));
var $author$project$Pages$Partner$Billing$viewInReviewAlert = A2(
	$author$project$Ui$Alert$info,
	_List_fromArray(
		[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$strong,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Application Submitted — Under Review')
				])),
			A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Thank you for submitting your payment setup form! We’re currently reviewing your details — this usually takes a few business days. No action is needed right now.')
				]))
		]));
var $author$project$Pages$Partner$Billing$viewAccount = F2(
	function (rainforestAccount, model) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
					switch (_v0) {
						case 'created':
							return $author$project$Pages$Partner$Billing$viewInProgressAlert;
						case 'in_progress':
							return $author$project$Pages$Partner$Billing$viewInProgressAlert;
						case 'processing':
							return $author$project$Pages$Partner$Billing$viewInReviewAlert;
						case 'in_review':
							return $author$project$Pages$Partner$Billing$viewInReviewAlert;
						case 'needs_information':
							return A2(
								$author$project$Ui$Alert$info,
								_List_fromArray(
									[$author$project$Ui$Alert$mb2, $author$project$Ui$Alert$textLeft]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Action Needed — More Info Required')
											])),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('To finish setting up Hint Payments, we need a bit more information. Please use the form below to provide the missing details. Once submitted, we’ll review and confirm your setup — usually within a few business days. We’ll notify you by email when it\'s complete.')
											]))
									]));
						case 'completed':
							return A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Status'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$fromString,
												_List_Nil,
												$author$project$Api$Partner$RainforestAccount$One$status(rainforestAccount))
											]))
									]));
						default:
							return $elm$html$Html$text('');
					}
				}(),
					function () {
					var _v1 = _Utils_Tuple3(
						A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model),
						$author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount),
						model.Cc);
					_v1$1:
					while (true) {
						if (_v1.a) {
							return A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label(''),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanMd(12),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpBlock]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Your payment processing account is under review, we will notify you when it\'s approved or if more information is needed.')
													]))
											]))
									]));
						} else {
							if (!_v1.c.$) {
								if (_v1.b === 'completed') {
									break _v1$1;
								} else {
									var setupSessionKey = _v1.c.a;
									return A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label(''),
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpanMd(8)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$WebComponents$Rainforest$MerchantOnboarding$view,
												$author$project$Pages$Partner$Billing$MerchantOnboardingSubmitted,
												{
													TP: A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Api$Partner$RainforestAccount$One$merchantApplicationId(rainforestAccount)),
													TR: A2(
														$elm$core$Maybe$withDefault,
														'',
														$author$project$Api$Partner$RainforestAccount$One$merchantId(rainforestAccount)),
													agS: setupSessionKey
												})
											]));
								}
							} else {
								if (_v1.b === 'completed') {
									break _v1$1;
								} else {
									var _v2 = _v1.c;
									return $author$project$Utils$Html$empty;
								}
							}
						}
					}
					return $author$project$Pages$Partner$Billing$viewActive(rainforestAccount);
				}()
				]));
	});
var $author$project$Pages$Partner$Billing$CreateClicked = {$: 1};
var $author$project$Pages$Partner$Billing$viewSetup = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$textCenter]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Set up your Payment Processing account to start accepting payments.')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Get Started'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$CreateClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Get Started')
						]))
				]))
		]));
var $author$project$Pages$Partner$Billing$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Rainforest$SimulateApplicationEventModal$view,
					$elm$html$Html$map($author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg)),
				model.ka)),
			A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$Html$empty,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$Rainforest$ResetAccountModal$view,
					$elm$html$Html$map($author$project$Pages$Partner$Billing$ResetAccountModalMsg)),
				model.jR)),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Payment Processing')
										])),
									function () {
									if (model.FR) {
										var _v0 = model.cm;
										if (_v0.$ === 3) {
											var rainforestAccount = _v0.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap2, $author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$HinterOnly$button,
														{abp: 'Sync with Rainforest'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Sync),
																$author$project$Ui$Button$loading(
																_Utils_eq(model.oG, $author$project$Api$Data$Loading))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Sync with Rainforest')
															])),
														(model.Bl && A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model)) ? A3(
														$author$project$Ui$HinterOnly$button,
														{abp: 'Simulate status change'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$sm,
																$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$OpenSimulateModal)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Simulate Status Change')
															])) : $author$project$Utils$Html$empty,
														A3(
														$author$project$Ui$HinterOnly$button,
														{abp: 'Reset Rainforest account'},
														_List_fromArray(
															[
																$author$project$Ui$Button$secondary,
																$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$OpenResetAccountModal)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Reset Rainforest account')
															])),
														($author$project$Api$Partner$RainforestAccount$One$status(rainforestAccount) === 'canceled') ? A3(
														$author$project$Ui$HinterOnly$button,
														{abp: 'Delete Rainforest account'},
														_List_fromArray(
															[
																$author$project$Ui$Button$danger,
																$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$DeleteRainforestAccount),
																$author$project$Ui$Button$loading(
																_Utils_eq(model.fm, $author$project$Api$Data$Loading))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Delete Rainforest account')
															])) : $author$project$Utils$Html$empty
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = model.cm;
							_v1$3:
							while (true) {
								switch (_v1.$) {
									case 3:
										var rainforestAccount = _v1.a;
										return A2($author$project$Pages$Partner$Billing$viewAccount, rainforestAccount, model);
									case 2:
										if (_v1.a.$ === 5) {
											var _v2 = _v1.a;
											return $author$project$Pages$Partner$Billing$viewSetup;
										} else {
											break _v1$3;
										}
									case 1:
										return $elm$html$Html$text('');
									default:
										break _v1$3;
								}
							}
							return $elm$html$Html$text('');
						}()
						])),
					function () {
					var _v3 = model.cm;
					if (_v3.$ === 3) {
						var rainforestAccount = _v3.a;
						return A2(
							$author$project$Ui$Panel$footer,
							_List_fromArray(
								[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap4]),
							_List_fromArray(
								[
									(model.FR && (model.Bl && A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model))) ? A3(
									$author$project$Ui$HinterOnly$button,
									{abp: 'Prefill with fake data'},
									_List_fromArray(
										[
											$author$project$Ui$Button$secondary,
											$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$PrefillWithFakeDataClicked)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Prefill')
										])) : $author$project$Utils$Html$empty
								]));
					} else {
						return $author$project$Ui$Panel$none;
					}
				}()
				]))
		]);
};
var $author$project$Pages$Partner$Billing$view = function (model) {
	return {
		e5: $author$project$Pages$Partner$Billing$viewBody(model),
		$G: 'Partner | Payment Processing'
	};
};
var $author$project$Pages$Partner$Billing$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Billing$init, aer: $author$project$Pages$Partner$Billing$load, agD: $author$project$Pages$Partner$Billing$save, ahd: $author$project$Pages$Partner$Billing$subscriptions, aaq: $author$project$Pages$Partner$Billing$update, ahP: $author$project$Pages$Partner$Billing$view});
var $author$project$Pages$Partner$Billing$Hinter$GotBilling = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$PartnerCharges$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$PartnerCharges$GotPartnerCharges = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$PartnerCharges$fetchPartnerChargesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				afy: model.afy,
				WF: model.jy,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Api$Partner$Reports$PartnerCharge$PartnerCharge = $elm$core$Basics$identity;
var $author$project$Api$Partner$Reports$PartnerCharge$Record = F7(
	function (id, practice, description, amountInCents, feeInCents, invoice, practiceInvoice) {
		return {I2: amountInCents, Nx: description, Pf: feeInCents, adR: id, Rh: invoice, WF: practice, WH: practiceInvoice};
	});
var $author$project$Api$Partner$Reports$PartnerCharge$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practice_invoice',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invoice',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fee_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'practice',
						$author$project$Api$Partner$Practice$Min$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Partner$Reports$PartnerCharge$Record))))))));
var $author$project$Api$Partner$Reports$PartnerCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Reports$PartnerCharge$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Reports$PartnerCharge$listDefaults = {
	E9: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	WF: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
	Hl: $elm$core$Maybe$Nothing
};
var $author$project$Api$Partner$Reports$PartnerCharge$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Reports$PartnerCharge$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.WF;
						if (!_v2.$) {
							var practice_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practice', practice_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Partner$Reports$PartnerCharge$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'partner_charges']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Reports$PartnerCharge$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Reports$PartnerCharge$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Reports$PartnerCharge$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Reports$PartnerCharge$listPath)));
	});
var $author$project$Components$Reports$PartnerCharges$fetchPartnerCharges = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Partner$Reports$PartnerCharge$list,
			apiClient,
			$author$project$Components$Reports$PartnerCharges$fetchPartnerChargesParams(model),
			$author$project$Components$Reports$PartnerCharges$GotPartnerCharges);
	});
var $author$project$Components$ResourceFilter$Partner$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Api$Partner$Practice$listDefaults = {afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Practice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Practice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var query = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', query)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Partner$Practice$practicesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practices']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Practice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Practice$Min$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Practice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Practice$practicesPath)));
	});
var $author$project$Components$ResourceFilter$Partner$Practice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A3($author$project$Api$Partner$Practice$list, apiClient, optionals, toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Practice$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Practice$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Partner$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						af_: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Partner$Practice$selectId = 'partner-practices';
var $author$project$Components$ResourceFilter$Partner$Practice$toTitle = $author$project$Api$Partner$Practice$Min$name;
var $author$project$Components$ResourceFilter$Partner$Practice$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Partner$Practice$toTitle(resource))
		]);
};
var $author$project$Api$Partner$Practice$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$ResourceFilter$Partner$Practice$toValue = $author$project$Api$Partner$Practice$Min$id;
var $author$project$Components$ResourceFilter$Partner$Practice$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$Partner$Practice$fetchResources, adR: $author$project$Components$ResourceFilter$Partner$Practice$selectId, gx: 'Practices', st: $author$project$Components$ResourceFilter$Partner$Practice$retrieveResource, ahw: $author$project$Components$ResourceFilter$Partner$Practice$toLabel, ahA: $author$project$Components$ResourceFilter$Partner$Practice$toTitle, g0: $author$project$Components$ResourceFilter$Partner$Practice$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Reports$PartnerCharges$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'practice_name', false, 'Practice'),
		A3($author$project$Api$Column$init, 'description', false, 'Description'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
		A3($author$project$Api$Column$init, 'fee_in_cents', true, 'Fee'),
		A3($author$project$Api$Column$init, 'invoice_number', false, 'Invoice'),
		A3($author$project$Api$Column$init, 'practice_invoice_number', false, 'Practice Invoice')
	]);
var $author$project$Components$Reports$PartnerCharges$init = function (_v0) {
	var currentDate = _v0.cO;
	var apiClient = _v0.D5;
	var _v1 = A2(
		$author$project$Components$ResourceFilter$Partner$Practice$init,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{D0: 'All Practices'});
		});
	var practiceResourceFilter = _v1.a;
	var practiceResourceFilterCmd = _v1.b;
	var _v2 = A2(
		$author$project$Components$DateRangeInput$init,
		'partner-charges-date-range',
		A2($author$project$Components$Reports$PartnerCharges$dateRangeInputSettings, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
	var dateRangeInput = _v2.a;
	var dateRangeInputCmd = _v2.b;
	var model = {
		Ll: $author$project$Components$Reports$PartnerCharges$initColumns,
		cO: currentDate,
		h3: dateRangeInput,
		E9: $elm$core$Maybe$Nothing,
		afy: $author$project$Api$Pagination$init,
		cg: $author$project$Api$Data$Loading,
		jy: $elm$core$Maybe$Nothing,
		jA: practiceResourceFilter,
		ag1: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
		Hl: $elm$core$Maybe$Nothing
	};
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg, dateRangeInputCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg, practiceResourceFilterCmd),
					A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, model)
				])));
};
var $author$project$Api$Partner$Billing$billingPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['billing']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Billing$Billing = $elm$core$Basics$identity;
var $author$project$Api$Partner$Billing$Record = function (rules) {
	return {YY: rules};
};
var $author$project$Api$Partner$Billing$Rule = F2(
	function (id, billsBy) {
		return {abF: billsBy, adR: id};
	});
var $author$project$Api$Partner$Billing$Gross = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Billing$Margin = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Billing$Transaction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$Billing$billsByDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (ruleType) {
		switch (ruleType) {
			case 'gross':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Partner$Billing$Gross,
					A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
			case 'margin':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Partner$Billing$Margin,
					A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
			case 'transaction':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Api$Partner$Billing$Transaction,
					A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
			default:
				return $elm$json$Json$Decode$fail('Unknown rule type: ' + ruleType);
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Api$Partner$Billing$ruleDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Api$Partner$Billing$Rule,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string),
	$author$project$Api$Partner$Billing$billsByDecoder);
var $author$project$Api$Partner$Billing$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rules',
		$elm$json$Json$Decode$list($author$project$Api$Partner$Billing$ruleDecoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$Billing$Record)));
var $author$project$Api$Partner$Billing$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$Billing$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$Billing$billingPath));
	});
var $author$project$Pages$Partner$Billing$Hinter$init = F4(
	function (_v0, partner, shared, _v1) {
		var _v2 = $author$project$Components$Reports$PartnerCharges$init(shared);
		var partnerCharges = _v2.a;
		var partnerChargesCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, pE: $author$project$Api$Data$Loading, Vz: partner, cg: partnerCharges, bz: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Partner$Billing$retrieve, shared.D5, $author$project$Pages$Partner$Billing$Hinter$GotBilling),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg, partnerChargesCmd)
					])));
	});
var $author$project$Pages$Partner$Billing$Hinter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Billing$Hinter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Billing$Hinter$RuleModalClosed = {$: 7};
var $author$project$Components$ResourceFilter$Partner$Practice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Reports$PartnerCharges$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PartnerCharges$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg,
				$author$project$Components$ResourceFilter$Partner$Practice$subscriptions(model.jA))
			]));
};
var $author$project$Pages$Partner$Billing$Hinter$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Billing$Hinter$RuleModalClosed),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg,
				$author$project$Components$Reports$PartnerCharges$subscriptions(model.cg))
			]));
};
var $author$project$Pages$Partner$Billing$Hinter$GotCreatedBilling = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$GotCreatedRule = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$GotDeletedRule = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$GotUpdatedRule = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$Billing$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Billing$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$Billing$billingPath));
	});
var $author$project$Api$Partner$Billing$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				if (!field.$) {
					var ruleType = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(ruleType)),
						acc);
				} else {
					var percent = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'fee_percent',
							$elm$json$Json$Encode$float(percent)),
						acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'rule',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$Billing$createRule = F3(
	function (apiClient, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Billing$ruleDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$Billing$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['rules']),
						$author$project$Api$Partner$Billing$billingPath))));
	});
var $author$project$Api$Partner$Billing$deleteRule = F3(
	function (apiClient, ruleId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['rules', ruleId]),
					$author$project$Api$Partner$Billing$billingPath)));
	});
var $author$project$Api$Partner$Billing$RuleFeePercent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Billing$RuleType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$formFieldsToPermittedFields = function (fields) {
	return _List_fromArray(
		[
			$author$project$Api$Partner$Billing$RuleType(fields.agA),
			$author$project$Api$Partner$Billing$RuleFeePercent(
			A2(
				$elm$core$Maybe$withDefault,
				0.0,
				A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.iG)))
		]);
};
var $author$project$Pages$Partner$Billing$Hinter$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var ruleType = field.a;
			return _Utils_update(
				fields,
				{agA: ruleType});
		} else {
			var percentage = field.a;
			return _Utils_update(
				fields,
				{iG: percentage});
		}
	});
var $author$project$Pages$Partner$Billing$Hinter$ruleToFormFields = function (rule) {
	var _v0 = function () {
		var _v1 = rule.abF;
		switch (_v1.$) {
			case 0:
				var percent = _v1.a;
				return _Utils_Tuple2(
					'gross',
					$elm$core$Maybe$Just(
						$author$project$Percentage$fromFloat(percent)));
			case 1:
				var percent = _v1.a;
				return _Utils_Tuple2(
					'margin',
					$elm$core$Maybe$Just(
						$author$project$Percentage$fromFloat(percent)));
			default:
				var percent = _v1.a;
				return _Utils_Tuple2(
					'transaction',
					$elm$core$Maybe$Just(
						$author$project$Percentage$fromFloat(percent)));
		}
	}();
	var ruleType = _v0.a;
	var feePercentage = _v0.b;
	return {iG: feePercentage, agA: ruleType};
};
var $author$project$Components$ResourceFilter$Partner$Practice$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if ((!_v1.$) && (!_v1.a.$)) {
				var selected = _v1.a.a;
				return _Utils_update(
					model,
					{G0: selected});
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$Reports$PartnerCharges$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Billing__Hinter)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Components$ResourceFilter$Partner$Practice$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Reports$PartnerCharges$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								cg: $author$project$Api$Data$Loading,
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
						$author$project$Components$Reports$PartnerCharges$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								cg: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cg: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var subMsg = msg.a;
				var practiceResourceResult = A3($author$project$Components$ResourceFilter$Partner$Practice$update, apiClient, subMsg, model.jA);
				var practiceId = function () {
					var _v5 = practiceResourceResult.ac5;
					if ((!_v5.$) && (!_v5.a.$)) {
						return $author$project$Components$ResourceFilter$Partner$Practice$value(practiceResourceResult.y8);
					} else {
						return model.jy;
					}
				}();
				var newModel = _Utils_update(
					model,
					{jy: practiceId, jA: practiceResourceResult.y8});
				var _v4 = function () {
					if (_Utils_eq(model.jy, newModel.jy)) {
						return _Utils_Tuple3(model.cg, $elm$core$Platform$Cmd$none, model.afy);
					} else {
						var paginationReset = $author$project$Api$Pagination$reset(model.afy);
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
							paginationReset);
					}
				}();
				var partnerCharges = _v4.a;
				var cmd = _v4.b;
				var pagination = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{afy: pagination, cg: partnerCharges}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg, practiceResourceResult.EC),
								cmd
							])),
					practiceResourceResult.as);
			case 3:
				var subMsg = msg.a;
				var newPagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: newPagination, cg: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
					_List_Nil);
			default:
				var columnKey = msg.a;
				var newSort = A2($author$project$Api$Sort$update, columnKey, model.ag1);
				var newModel = _Utils_update(
					model,
					{cg: $author$project$Api$Data$Loading, ag1: newSort});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
					_List_Nil);
		}
	});
var $author$project$Api$Partner$Billing$updateRule = F4(
	function (apiClient, ruleId, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Partner$Billing$ruleDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$Billing$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['rules', ruleId]),
						$author$project$Api$Partner$Billing$billingPath))));
	});
var $author$project$Pages$Partner$Billing$Hinter$FeePercentageValidation = 1;
var $author$project$Pages$Partner$Billing$Hinter$RuleTypeValidation = 0;
var $author$project$Pages$Partner$Billing$Hinter$validate = function (form) {
	var validator = $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.agA;
				},
				_Utils_Tuple2(0, 'Rule type is required')),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.iG;
				},
				_Utils_Tuple2(1, 'Fee percentage is required'))
			]));
	return A2($author$project$Utils$Form$validate, validator, form);
};
var $author$project$Pages$Partner$Billing$Hinter$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pE: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Billing$create, model.D5, $author$project$Pages$Partner$Billing$Hinter$GotCreatedBilling),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{pE: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var form = $author$project$Utils$Form$init(
					{iG: $elm$core$Maybe$Nothing, agA: 'gross'});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bz: $elm$core$Maybe$Just(
								_Utils_Tuple2($elm$core$Maybe$Nothing, form))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var ruleId = msg.a;
				var rule = msg.b;
				var form = $author$project$Utils$Form$init(
					$author$project$Pages$Partner$Billing$Hinter$ruleToFormFields(rule));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bz: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just(ruleId),
									form))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var ruleId = msg.a;
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Partner$Billing$deleteRule, model.D5, ruleId, $author$project$Pages$Partner$Billing$Hinter$GotDeletedRule),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Partner$Billing$retrieve, model.D5, $author$project$Pages$Partner$Billing$Hinter$GotBilling),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bz: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var field = msg.a;
				var _v3 = model.bz;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var ruleId = _v4.a;
					var form = _v4.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Billing$Hinter$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bz: $elm$core$Maybe$Just(
									_Utils_Tuple2(ruleId, newForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var _v5 = model.bz;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var ruleId = _v6.a;
					var form = _v6.b;
					var _v7 = $author$project$Pages$Partner$Billing$Hinter$validate(form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var validFields = _v8.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
						var permittedFields = $author$project$Pages$Partner$Billing$Hinter$formFieldsToPermittedFields(fields);
						var cmd = function () {
							if (!ruleId.$) {
								var id = ruleId.a;
								return A4($author$project$Api$Partner$Billing$updateRule, model.D5, id, permittedFields, $author$project$Pages$Partner$Billing$Hinter$GotUpdatedRule);
							} else {
								return A3($author$project$Api$Partner$Billing$createRule, model.D5, permittedFields, $author$project$Pages$Partner$Billing$Hinter$GotCreatedRule);
							}
						}();
						return _Utils_Tuple3(model, cmd, _List_Nil);
					} else {
						var formWithErrors = _v7.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bz: $elm$core$Maybe$Just(
										_Utils_Tuple2(ruleId, formWithErrors))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bz: $elm$core$Maybe$Nothing}),
						A2($author$project$Api$Partner$Billing$retrieve, model.D5, $author$project$Pages$Partner$Billing$Hinter$GotBilling),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bz: $elm$core$Maybe$Nothing}),
						A2($author$project$Api$Partner$Billing$retrieve, model.D5, $author$project$Pages$Partner$Billing$Hinter$GotBilling),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v12 = A3($author$project$Components$Reports$PartnerCharges$update, model.D5, subMsg, model.cg);
				var partnerCharges = _v12.a;
				var cmd = _v12.b;
				var outMsgs = _v12.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cg: partnerCharges}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg, cmd),
					outMsgs);
		}
	});
var $author$project$Components$Reports$PartnerCharges$PaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ResourceFilter$Partner$Practice$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$ResourceFilter$Partner$Practice$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Reports$PartnerCharges$viewPracticeResourceFilter = function (practiceResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Partner$Practice$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			practiceResourceFilter));
};
var $author$project$Components$Reports$PartnerCharges$SortTable = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$Reports$PartnerCharge$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Partner$Reports$PartnerCharge$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Partner$Reports$PartnerCharge$feeInCents = function (_v0) {
	var record = _v0;
	return record.Pf;
};
var $author$project$Api$Common$Payable$Invoice$Min$humanStatus = function (_v0) {
	var record = _v0;
	return record.QE;
};
var $author$project$Api$Partner$Reports$PartnerCharge$invoice = function (_v0) {
	var record = _v0;
	return record.Rh;
};
var $author$project$Api$Partner$Reports$PartnerCharge$practiceInvoice = function (_v0) {
	var record = _v0;
	return record.WH;
};
var $author$project$Api$Partner$Reports$PartnerCharge$practiceName = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$Practice$Min$name(record.WF);
};
var $author$project$Components$Reports$PartnerCharges$viewTableRow = function (partnerCharge) {
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Partner$Reports$PartnerCharge$practiceName(partnerCharge))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Partner$Reports$PartnerCharge$description(partnerCharge))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Partner$Reports$PartnerCharge$amountInCents(partnerCharge)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Partner$Reports$PartnerCharge$feeInCents(partnerCharge)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				function () {
					var _v0 = $author$project$Api$Partner$Reports$PartnerCharge$invoice(partnerCharge);
					if (!_v0.$) {
						var invoice = _v0.a;
						return _List_fromArray(
							[
								$elm$html$Html$text(
								function (n) {
									return '#' + n;
								}(
									$elm$core$String$fromInt(
										$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice)))),
								$author$project$Utils$Html$noBreakSpace,
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text('N/A')
									]))
							]);
					}
				}()),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				function () {
					var _v1 = $author$project$Api$Partner$Reports$PartnerCharge$practiceInvoice(partnerCharge);
					if (!_v1.$) {
						var invoice = _v1.a;
						return _List_fromArray(
							[
								$elm$html$Html$text(
								function (n) {
									return '#' + n;
								}(
									$elm$core$String$fromInt(
										$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice)))),
								$author$project$Utils$Html$noBreakSpace,
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice))
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text('N/A')
									]))
							]);
					}
				}())
			]));
};
var $author$project$Components$Reports$PartnerCharges$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.cg;
		if (_v1.$ === 3) {
			var partnerCharges_ = _v1.a;
			return _Utils_Tuple2(false, partnerCharges_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var partnerCharges = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view(
				A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$PartnerCharges$SortTable)),
			model.Ll),
		A2($elm$core$List$map, $author$project$Components$Reports$PartnerCharges$viewTableRow, partnerCharges),
		_List_Nil);
};
var $author$project$Components$Reports$PartnerCharges$view = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Partner Charges')
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mt4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(12)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Reports$PartnerCharges$DateRangeInputMsg,
											$author$project$Components$DateRangeInput$view(model.h3))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4)
										]),
									_List_fromArray(
										[
											$author$project$Components$Reports$PartnerCharges$viewPracticeResourceFilter(model.jA)
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_Nil,
									function () {
										var activeFilters = A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg),
											$author$project$Components$ResourceFilter$Partner$Practice$viewMultiSelected(model.jA));
										return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Active filters')
															]))
													])),
												A2($elm$html$Html$span, _List_Nil, activeFilters)
											]);
									}())
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Components$Reports$PartnerCharges$viewTable(model)
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Reports$PartnerCharges$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(
										!$author$project$Utils$Maybe$toBool(
											$author$project$Api$Data$toMaybe(model.cg)))
									]),
								model.afy))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$Billing$Hinter$AddRuleClicked = {$: 3};
var $author$project$Api$Partner$Billing$rules = function (_v0) {
	var record = _v0;
	return record.YY;
};
var $author$project$Pages$Partner$Billing$Hinter$DeleteRuleClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$EditRuleClicked = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Partner$Billing$Hinter$viewRule = function (rule) {
	return A2(
		$author$project$Ui$FlexGrid$column,
		_List_fromArray(
			[
				$author$project$Ui$FlexGrid$span(6),
				$author$project$Ui$FlexGrid$spanMd(3)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = rule.abF;
				switch (_v0.$) {
					case 0:
						var percentage = _v0.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Gross')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Fee: ')
												])),
											$elm$html$Html$text(
											$author$project$Formatters$Float$toPercentage(percentage))
										]))
								]));
					case 1:
						var percentage = _v0.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Margin')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Fee: ')
												])),
											$elm$html$Html$text(
											$author$project$Formatters$Float$toPercentage(percentage))
										]))
								]));
					default:
						var percentage = _v0.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Transaction')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Fee: ')
												])),
											$elm$html$Html$text(
											$author$project$Formatters$Float$toPercentage(percentage))
										]))
								]));
				}
			}(),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Edit rule'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
								$author$project$Ui$Button$onClick(
								A2($author$project$Pages$Partner$Billing$Hinter$EditRuleClicked, rule.adR, rule)),
								$author$project$Ui$Button$sm
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Delete rule'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Partner$Billing$Hinter$DeleteRuleClicked(rule.adR)),
								$author$project$Ui$Button$sm
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Delete')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Billing$Hinter$viewBilling = function (billing) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb4]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Billing Details')
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Add rule'},
					_List_fromArray(
						[
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
							$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$AddRuleClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Rule')
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Pages$Partner$Billing$Hinter$viewRule,
				$author$project$Api$Partner$Billing$rules(billing)))
		]);
};
var $author$project$Pages$Partner$Billing$Hinter$CreateClicked = {$: 1};
var $author$project$Pages$Partner$Billing$Hinter$viewBuildBilling = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$flexCol]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$elm$html$Html$text('There\'s no billing yet')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Set up billing'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$CreateClicked)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Set up billing')
					]))
			]))
	]);
var $author$project$Pages$Partner$Billing$Hinter$FeePercentage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$FormUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$SaveRuleClicked = {$: 9};
var $author$project$Pages$Partner$Billing$Hinter$RuleType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton = F3(
	function (fields, ruleType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$styled(
					_Utils_eq(fields.agA, ruleType) ? 1 : 0),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Partner$Billing$Hinter$FormUpdated(
						$author$project$Pages$Partner$Billing$Hinter$RuleType(ruleType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Pages$Partner$Billing$Hinter$viewRuleModal = F2(
	function (ruleId, form) {
		var modalTitle = function () {
			if (!ruleId.$) {
				return 'Edit Rule';
			} else {
				return 'Add Rule';
			}
		}();
		var fields = $author$project$Utils$Form$fields(form);
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Billing$Hinter$RuleModalClosed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Billing$Hinter$SaveRuleClicked)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(modalTitle)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Rule Type'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Button$group(
									_List_fromArray(
										[
											A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'gross', 'Gross'),
											A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'margin', 'Margin'),
											A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'transaction', 'Transaction')
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Fee Percentage'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$PercentageInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$PercentageInput$value(fields.iG),
											$author$project$Ui$Form$PercentageInput$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Billing$Hinter$FormUpdated, $author$project$Pages$Partner$Billing$Hinter$FeePercentage)),
											$author$project$Ui$Form$PercentageInput$errors(
											errorsFor(1)),
											$author$project$Ui$Form$PercentageInput$placeholder('10')
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$RuleModalClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Save rule'},
							_List_fromArray(
								[$author$project$Ui$Button$primary, $author$project$Ui$Button$submit]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Billing$Hinter$viewBody = function (model) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					function () {
					var _v0 = model.bz;
					if (!_v0.$) {
						var _v1 = _v0.a;
						var ruleId = _v1.a;
						var form = _v1.b;
						return A2($author$project$Pages$Partner$Billing$Hinter$viewRuleModal, ruleId, form);
					} else {
						return $elm$html$Html$text('');
					}
				}(),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					$elm$core$List$singleton(
						A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							function () {
								var _v2 = model.pE;
								_v2$2:
								while (true) {
									switch (_v2.$) {
										case 3:
											var billing = _v2.a;
											return $author$project$Pages$Partner$Billing$Hinter$viewBilling(billing);
										case 2:
											if (_v2.a.$ === 5) {
												var _v3 = _v2.a;
												return $author$project$Pages$Partner$Billing$Hinter$viewBuildBilling;
											} else {
												break _v2$2;
											}
										default:
											break _v2$2;
									}
								}
								return _List_Nil;
							}())))
				]),
				A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg),
				$author$project$Components$Reports$PartnerCharges$view(model.cg))
			]));
};
var $author$project$Pages$Partner$Billing$Hinter$view = function (model) {
	return {
		e5: $author$project$Pages$Partner$Billing$Hinter$viewBody(model),
		$G: 'Partner | Billing'
	};
};
var $author$project$Pages$Partner$Billing$Hinter$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Billing$Hinter$init, aer: $author$project$Pages$Partner$Billing$Hinter$load, agD: $author$project$Pages$Partner$Billing$Hinter$save, ahd: $author$project$Pages$Partner$Billing$Hinter$subscriptions, aaq: $author$project$Pages$Partner$Billing$Hinter$update, ahP: $author$project$Pages$Partner$Billing$Hinter$view});
var $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$Agreements = 1;
var $author$project$Pages$Partner$Dashboard$Top$CompanyDetails = 0;
var $author$project$Pages$Partner$Dashboard$Top$ProductListing = 2;
var $author$project$Pages$Partner$Dashboard$Top$SandboxSetup = 3;
var $author$project$Api$Partner$Partner$Shared$sandboxEnabled = function (_v0) {
	var record = _v0;
	return record.Y0;
};
var $author$project$Api$Partner$Partner$One$sandboxEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$sandboxEnabled(shared);
};
var $author$project$Pages$Partner$Dashboard$Top$allSteps = function (partner) {
	return _Utils_ap(
		$author$project$Api$Partner$Partner$One$sandboxEnabled(partner) ? _List_fromArray(
			[3]) : _List_Nil,
		_List_fromArray(
			[0, 1, 2]));
};
var $author$project$Api$Partner$Partner$One$addendumAgreementFileName = function (_v0) {
	var record = _v0.b;
	return record.Im;
};
var $author$project$Api$Partner$Partner$One$addendumDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.In;
};
var $author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.Jh;
};
var $author$project$Api$Partner$Partner$One$baaDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.JN;
};
var $author$project$Api$Partner$Partner$One$baaType = function (_v0) {
	var record = _v0.b;
	return record.JO;
};
var $author$project$Api$Partner$Partner$One$managedBy = function (_v0) {
	var record = _v0.b;
	return record.Td;
};
var $author$project$Api$Partner$Partner$One$partnerDocumentAgreement = function (_v0) {
	var record = _v0.b;
	return record.VC;
};
var $author$project$Pages$Partner$Dashboard$Top$isAgreementsComplete = function (partner) {
	var isManaged = !_Utils_eq(
		$author$project$Api$Partner$Partner$One$managedBy(partner),
		$elm$core$Maybe$Nothing);
	var partnerAgreementDone = isManaged || (!_Utils_eq(
		$author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner),
		$elm$core$Maybe$Nothing));
	var baaDone = function () {
		var _v0 = $author$project$Api$Partner$Partner$One$baaType(partner);
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return !_Utils_eq(
					$author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner),
					$elm$core$Maybe$Nothing);
			} else {
				var _v2 = _v0.a;
				return true;
			}
		} else {
			return false;
		}
	}();
	var apiAccessDone = (!isManaged) || (!_Utils_eq(
		$author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner),
		$elm$core$Maybe$Nothing));
	var addendumDone = isManaged || (_Utils_eq(
		$author$project$Api$Partner$Partner$One$addendumAgreementFileName(partner),
		$elm$core$Maybe$Nothing) || (!_Utils_eq(
		$author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner),
		$elm$core$Maybe$Nothing)));
	return partnerAgreementDone && (addendumDone && (apiAccessDone && baaDone));
};
var $author$project$Api$Partner$Partner$One$address = function (_v0) {
	var record = _v0.b;
	return record.It;
};
var $author$project$Api$Partner$Partner$Shared$technicalEmail = function (_v0) {
	var record = _v0;
	return record.$w;
};
var $author$project$Api$Partner$Partner$One$technicalEmail = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$technicalEmail(shared);
};
var $author$project$Api$Partner$Partner$Shared$websiteUrl = function (_v0) {
	var record = _v0;
	return record.aa_;
};
var $author$project$Api$Partner$Partner$One$websiteUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$websiteUrl(shared);
};
var $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete = function (partner) {
	var _v0 = _Utils_Tuple3(
		$author$project$Api$Partner$Partner$One$websiteUrl(partner),
		$author$project$Api$Partner$Partner$One$technicalEmail(partner),
		$author$project$Api$Partner$Partner$One$address(partner));
	if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
		var technicalEmail = _v0.b.a;
		var address = _v0.c.a;
		return (!$author$project$Api$Common$Address$Shared$isAddressIncomplete(address)) && (!$elm$core$String$isEmpty(technicalEmail));
	} else {
		return false;
	}
};
var $author$project$Api$Partner$PartnerProduct$Shared$distributionType = function (_v0) {
	var record = _v0;
	return record.NS;
};
var $author$project$Api$Partner$Partner$Shared$marketplaceIconUrl = function (_v0) {
	var record = _v0;
	return record.Tm;
};
var $author$project$Api$Partner$Partner$One$marketplaceIconUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$marketplaceIconUrl(shared);
};
var $author$project$Api$Partner$PartnerProduct$Shared$summary = function (_v0) {
	var record = _v0;
	return record._9;
};
var $author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete = F2(
	function (partner, product) {
		return (!_Utils_eq(
			$author$project$Api$Partner$PartnerProduct$Shared$summary(product),
			$elm$core$Maybe$Nothing)) && (!_Utils_eq(
			$author$project$Api$Partner$Partner$One$marketplaceIconUrl(partner),
			$elm$core$Maybe$Nothing));
	});
var $author$project$Api$Partner$Partner$One$product = function (_v0) {
	var record = _v0.b;
	return record.W8;
};
var $author$project$Api$Partner$PartnerProduct$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished = function (partner) {
	var _v0 = $author$project$Api$Partner$Partner$One$product(partner);
	if (!_v0.$) {
		var product = _v0.a;
		return (!$author$project$Api$Partner$PartnerProduct$Shared$distributionType(product)) && ((!A2(
			$elm$core$List$member,
			$author$project$Api$Partner$PartnerProduct$Shared$status(product),
			_List_fromArray(
				[1, 8]))) && A2($author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete, partner, product));
	} else {
		return false;
	}
};
var $author$project$Api$Partner$Partner$One$hasSandboxPartners = function (_v0) {
	var record = _v0.b;
	return record.Qf;
};
var $author$project$Api$Partner$Partner$One$hasSandboxPractices = function (_v0) {
	var record = _v0.b;
	return record.Qg;
};
var $author$project$Pages$Partner$Dashboard$Top$isSandboxSetupComplete = function (partner) {
	return $author$project$Api$Partner$Partner$One$hasSandboxPartners(partner) && $author$project$Api$Partner$Partner$One$hasSandboxPractices(partner);
};
var $author$project$Pages$Partner$Dashboard$Top$isStepComplete = F2(
	function (partner, step) {
		switch (step) {
			case 0:
				return $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete(partner);
			case 1:
				return $author$project$Pages$Partner$Dashboard$Top$isAgreementsComplete(partner);
			case 2:
				return $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished(partner);
			default:
				return $author$project$Pages$Partner$Dashboard$Top$isSandboxSetupComplete(partner);
		}
	});
var $author$project$Pages$Partner$Dashboard$Top$firstIncompleteStep = function (partner) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (step) {
				return !A2($author$project$Pages$Partner$Dashboard$Top$isStepComplete, partner, step);
			},
			$author$project$Pages$Partner$Dashboard$Top$allSteps(partner)));
};
var $author$project$Components$Partner$BaaForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$BaaForm$initFormFields = function (partner) {
	return {
		pB: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner),
			$elm$core$Maybe$Nothing),
		JO: $author$project$Api$Partner$Partner$One$baaType(partner)
	};
};
var $author$project$Components$Partner$BaaForm$init = F2(
	function (timeFormatter, partner) {
		return _Utils_Tuple2(
			{
				PB: $author$project$Utils$Form$init(
					$author$project$Components$Partner$BaaForm$initFormFields(partner)),
				Vz: partner,
				Hy: timeFormatter,
				o$: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$DocumentsAgreementsForm$initFormFields = function (partner) {
	return {
		tI: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner),
			$elm$core$Maybe$Nothing),
		vq: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner),
			$elm$core$Maybe$Nothing),
		z5: !_Utils_eq(
			$author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner),
			$elm$core$Maybe$Nothing)
	};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$init = F2(
	function (timeFormatter, partner) {
		return _Utils_Tuple2(
			{
				PB: $author$project$Utils$Form$init(
					$author$project$Components$Partner$DocumentsAgreementsForm$initFormFields(partner)),
				Vz: partner,
				Hy: timeFormatter,
				o$: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$Form$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$Form$Address = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Partner$Form$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Partner$Partner$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$email(shared);
};
var $author$project$Api$Partner$Partner$Shared$integrationDescription = function (_v0) {
	var record = _v0;
	return record.Q5;
};
var $author$project$Api$Partner$Partner$One$integrationDescription = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$integrationDescription(shared);
};
var $author$project$Api$Partner$Partner$Shared$logoUrl = function (_v0) {
	var record = _v0;
	return record.S8;
};
var $author$project$Api$Partner$Partner$One$logoUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$logoUrl(shared);
};
var $author$project$Api$Partner$Partner$Shared$marketingUrl = function (_v0) {
	var record = _v0;
	return record.Tl;
};
var $author$project$Api$Partner$Partner$One$marketingUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$marketingUrl(shared);
};
var $author$project$Api$Partner$Partner$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Partner$Partner$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$name(shared);
};
var $author$project$Api$Partner$Partner$Shared$productDescription = function (_v0) {
	var record = _v0;
	return record.Xb;
};
var $author$project$Api$Partner$Partner$One$productDescription = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$productDescription(shared);
};
var $author$project$Api$Partner$Partner$Shared$signupUrl = function (_v0) {
	var record = _v0;
	return record.Z6;
};
var $author$project$Api$Partner$Partner$One$signupUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$signupUrl(shared);
};
var $author$project$Api$Partner$Partner$Shared$supportUrl = function (_v0) {
	var record = _v0;
	return record.$a;
};
var $author$project$Api$Partner$Partner$One$supportUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$supportUrl(shared);
};
var $author$project$Api$Partner$Partner$Shared$usesIntegrationRecords = function (_v0) {
	var record = _v0;
	return record.aaG;
};
var $author$project$Api$Partner$Partner$One$usesIntegrationRecords = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$usesIntegrationRecords(shared);
};
var $author$project$Components$Partner$Form$initFormFields = function (partner) {
	var _v0 = A2(
		$author$project$Components$AddressInput$initFromApi,
		'partner-address',
		$author$project$Api$Partner$Partner$One$address(partner));
	var address = _v0.a;
	var addressCmd = _v0.b;
	return _Utils_Tuple2(
		{
			It: address,
			Mu: $author$project$Api$Partner$Partner$One$logoUrl(partner),
			Oo: $author$project$Api$Partner$Partner$One$email(partner),
			Q5: $author$project$Api$Partner$Partner$One$integrationDescription(partner),
			F0: 0,
			S8: $elm$core$Maybe$Nothing,
			Tl: $author$project$Api$Partner$Partner$One$marketingUrl(partner),
			zh: $author$project$Api$Partner$Partner$One$name(partner),
			Xb: $author$project$Api$Partner$Partner$One$productDescription(partner),
			Z6: $author$project$Api$Partner$Partner$One$signupUrl(partner),
			$a: $author$project$Api$Partner$Partner$One$supportUrl(partner),
			$w: $author$project$Api$Partner$Partner$One$technicalEmail(partner),
			aaG: $author$project$Api$Partner$Partner$One$usesIntegrationRecords(partner),
			aa_: $author$project$Api$Partner$Partner$One$websiteUrl(partner)
		},
		A2(
			$elm$core$Platform$Cmd$map,
			A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address),
			addressCmd));
};
var $author$project$Components$Partner$Form$init = function (partner) {
	var _v0 = $author$project$Components$Partner$Form$initFormFields(partner);
	var formFields = _v0.a;
	var formFieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			PB: $author$project$Utils$Form$init(formFields),
			Vz: partner
		},
		formFieldsCmd);
};
var $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded = function (partner) {
	return $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete(partner);
};
var $author$project$Api$Platform$Session$One$sandbox = function (_v0) {
	var record = _v0;
	return record.Y$;
};
var $author$project$Pages$Partner$Dashboard$Top$init = F4(
	function (session, partner, shared, _v0) {
		var onboarded = $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded(partner);
		var initialExpanded = function () {
			var _v4 = $author$project$Pages$Partner$Dashboard$Top$firstIncompleteStep(partner);
			if (!_v4.$) {
				var step = _v4.a;
				return _List_fromArray(
					[step]);
			} else {
				return _List_Nil;
			}
		}();
		var _v1 = onboarded ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				$author$project$Components$Partner$Form$init(partner)));
		var partnerForm = _v1.a;
		var partnerFormCmd = _v1.b;
		var _v2 = A2($author$project$Components$Partner$DocumentsAgreementsForm$init, shared.Hy, partner);
		var documentsAgreementsForm = _v2.a;
		var documentsAgreementsFormCmd = _v2.b;
		var _v3 = A2($author$project$Components$Partner$BaaForm$init, shared.Hy, partner);
		var baaForm = _v3.a;
		var baaFormCmd = _v3.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				bO: baaForm,
				b3: documentsAgreementsForm,
				l7: initialExpanded,
				FT: $author$project$Api$Platform$Session$One$sandbox(session),
				U5: onboarded,
				Vz: partner,
				ba: partnerForm,
				jU: $author$project$Api$Data$NotAsked,
				Hy: shared.Hy,
				o$: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						partnerFormCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
					])));
	});
var $author$project$Pages$Partner$Dashboard$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Dashboard$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$BaaForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Partner$DocumentsAgreementsForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Partner$Form$subscriptions = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$elm$core$Platform$Sub$map,
		A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address),
		$author$project$Components$AddressInput$subscriptions(fields.It));
};
var $author$project$Pages$Partner$Dashboard$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Partner$Form$subscriptions, model.ba))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Dashboard$Top$BaaFormMsg,
				$author$project$Components$Partner$BaaForm$subscriptions(model.bO)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg,
				$author$project$Components$Partner$DocumentsAgreementsForm$subscriptions(model.b3))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$GotReviewResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$GotUpdatedPartner = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections = function (partner) {
	var _v0 = $author$project$Pages$Partner$Dashboard$Top$firstIncompleteStep(partner);
	if (!_v0.$) {
		var step = _v0.a;
		return _List_fromArray(
			[step]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Partner$PartnerProduct$One$PartnerProduct = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$PartnerProduct$One$Record = F4(
	function (ctaUrl, utmCampaign, utmContent, requirement) {
		return {Mq: ctaUrl, Yk: requirement, aaJ: utmCampaign, aaK: utmContent};
	});
var $author$project$Api$Common$Marketplace$Product$Requirement$FeatureRequirement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Requirement$TierRequirement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$decoder = A2($elm$json$Json$Decode$map, $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString, $elm$json$Json$Decode$string);
var $author$project$Api$Common$Marketplace$Product$Requirement$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (type_) {
		if (type_ === 'feature') {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Api$Common$Marketplace$Product$Requirement$FeatureRequirement,
				A2($elm$json$Json$Decode$field, 'feature', $author$project$Api$Common$Marketplace$Product$Requirement$Feature$decoder));
		} else {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Api$Common$Marketplace$Product$Requirement$TierRequirement,
				A2($elm$json$Json$Decode$field, 'starting_tier', $elm$json$Json$Decode$string));
		}
	},
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
var $author$project$Api$Partner$PartnerProduct$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requirement',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Requirement$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'utm_content',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'utm_campaign',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'cta_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$One$Record)))));
var $author$project$Api$Partner$PartnerProduct$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProduct$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$PartnerProduct$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$One$PartnerProduct)));
var $author$project$Api$Partner$PartnerProduct$productPathWithId = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId]),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProduct$requestReview = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['request_review']),
					$author$project$Api$Partner$PartnerProduct$productPathWithId(productId))));
	});
var $author$project$Components$Partner$BaaForm$Save = {$: 1};
var $author$project$Components$Partner$BaaForm$saveMsg = $author$project$Components$Partner$BaaForm$Save;
var $author$project$Components$Partner$DocumentsAgreementsForm$Save = {$: 1};
var $author$project$Components$Partner$DocumentsAgreementsForm$saveMsg = $author$project$Components$Partner$DocumentsAgreementsForm$Save;
var $author$project$Api$Partner$Partner$update = F3(
	function (apiClient, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$Partner$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Components$Partner$BaaForm$BaaAccepted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$BaaAgreementAccepted = function (a) {
	return {$: 35, a: a};
};
var $author$project$Api$Partner$Partner$BaaType = function (a) {
	return {$: 34, a: a};
};
var $author$project$Components$Partner$BaaForm$GotCustomBaaAgreementUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$BaaForm$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$BaaForm$None = {$: 0};
var $author$project$Components$Partner$BaaForm$PartnerUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$BaaForm$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var baaType = field.a;
			return _Utils_update(
				fields,
				{
					JO: $elm$core$Maybe$Just(baaType)
				});
		} else {
			var bool = field.a;
			return _Utils_update(
				fields,
				{pB: bool});
		}
	});
var $author$project$Components$Partner$BaaForm$BaaTypeValidation = 0;
var $author$project$Components$Partner$BaaForm$BaaAcceptedValidation = 1;
var $author$project$Components$Partner$BaaForm$validateBaaAccepted = function (fields) {
	return (_Utils_eq(
		fields.JO,
		$elm$core$Maybe$Just(0)) && (!fields.pB)) ? _List_fromArray(
		[
			_Utils_Tuple2(1, 'Please agree to the BAA.')
		]) : _List_Nil;
};
var $author$project$Components$Partner$BaaForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.JO;
			},
			_Utils_Tuple2(0, 'Please select a BAA type.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$BaaForm$validateBaaAccepted)
		]));
var $author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_custom_baa_agreement_url']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Components$Partner$BaaForm$toPermittedFields = F2(
	function (partner, fields) {
		return A2(
			$elm$core$List$cons,
			$author$project$Api$Partner$Partner$BaaType(fields.JO),
			(_Utils_eq(
				$author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner),
				$elm$core$Maybe$Nothing) && _Utils_eq(
				fields.JO,
				$elm$core$Maybe$Just(0))) ? _List_fromArray(
				[
					$author$project$Api$Partner$Partner$BaaAgreementAccepted(fields.pB)
				]) : _List_Nil);
	});
var $author$project$Components$Partner$BaaForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				if ((field.$ === 1) && field.a) {
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Partner$BaaForm$formFieldsUpdate,
						$author$project$Components$Partner$BaaForm$BaaAccepted(true),
						model.PB);
					var fields = $author$project$Utils$Form$fields(model.PB);
					return {
						EC: A3(
							$author$project$Api$Partner$Partner$update,
							apiClient,
							_List_fromArray(
								[
									$author$project$Api$Partner$Partner$BaaType(fields.JO),
									$author$project$Api$Partner$Partner$BaaAgreementAccepted(true)
								]),
							$author$project$Components$Partner$BaaForm$GotUpdatedPartner),
						ac5: $author$project$Components$Partner$BaaForm$None,
						y8: _Utils_update(
							model,
							{PB: newForm, o$: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$BaaForm$formFieldsUpdate, field, model.PB);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$BaaForm$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 1:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$BaaForm$formFieldsValidator, model.PB);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var updatedForm = _v4.a;
					var validFormFields = _v4.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var permittedFields = A2($author$project$Components$Partner$BaaForm$toPermittedFields, model.Vz, fields);
					return {
						EC: A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$BaaForm$GotUpdatedPartner),
						ac5: $author$project$Components$Partner$BaaForm$None,
						y8: _Utils_update(
							model,
							{PB: updatedForm, o$: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var updatedForm = _v3.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$BaaForm$None,
						y8: _Utils_update(
							model,
							{PB: updatedForm, o$: $author$project$Api$Data$NotAsked}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$BaaForm$PartnerUpdated(partner),
						y8: _Utils_update(
							model,
							{
								PB: $author$project$Utils$Form$init(
									$author$project$Components$Partner$BaaForm$initFormFields(partner)),
								Vz: partner,
								o$: response
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$BaaForm$None,
						y8: _Utils_update(
							model,
							{o$: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				return {
					EC: A2($author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl, apiClient, $author$project$Components$Partner$BaaForm$GotCustomBaaAgreementUrl),
					ac5: $author$project$Components$Partner$BaaForm$None,
					y8: model,
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						EC: $author$project$Ports$Navigation$openInNewWindow(url),
						ac5: $author$project$Components$Partner$BaaForm$None,
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$BaaForm$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Api$Partner$Partner$AddendumAgreementAccepted = function (a) {
	return {$: 29, a: a};
};
var $author$project$Api$Partner$Partner$ApiAccessAgreementAccepted = function (a) {
	return {$: 36, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$GotAddendumAgreementUrl = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$GotApiAccessAgreementUrl = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$GotCustomPartnerAgreementUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$None = {$: 0};
var $author$project$Api$Partner$Partner$PartnerAgreementAccepted = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$PartnerUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{z5: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{tI: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{vq: bool});
		}
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Api$Partner$Partner$signedAddendumAgreementUrl = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_addendum_agreement_url']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_custom_api_access_agreement_url']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_custom_partner_agreement_url']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$toPermittedFields = F2(
	function (partner, fields) {
		return _Utils_ap(
			(_Utils_eq(
				$author$project$Api$Partner$Partner$One$managedBy(partner),
				$elm$core$Maybe$Nothing) && _Utils_eq(
				$author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner),
				$elm$core$Maybe$Nothing)) ? _List_fromArray(
				[
					$author$project$Api$Partner$Partner$PartnerAgreementAccepted(fields.z5)
				]) : _List_Nil,
			_Utils_ap(
				(_Utils_eq(
					$author$project$Api$Partner$Partner$One$managedBy(partner),
					$elm$core$Maybe$Nothing) && _Utils_eq(
					$author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner),
					$elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						$author$project$Api$Partner$Partner$AddendumAgreementAccepted(fields.tI)
					]) : _List_Nil,
				((!_Utils_eq(
					$author$project$Api$Partner$Partner$One$managedBy(partner),
					$elm$core$Maybe$Nothing)) && _Utils_eq(
					$author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner),
					$elm$core$Maybe$Nothing)) ? _List_fromArray(
					[
						$author$project$Api$Partner$Partner$ApiAccessAgreementAccepted(fields.vq)
					]) : _List_Nil));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				_v2$3:
				while (true) {
					switch (field.$) {
						case 0:
							if (field.a) {
								return {
									EC: A3(
										$author$project$Api$Partner$Partner$update,
										apiClient,
										_List_fromArray(
											[
												$author$project$Api$Partner$Partner$PartnerAgreementAccepted(true)
											]),
										$author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
									ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
									y8: _Utils_update(
										model,
										{
											PB: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.PB),
											o$: $author$project$Api$Data$Loading
										}),
									as: _List_Nil
								};
							} else {
								break _v2$3;
							}
						case 1:
							if (field.a) {
								return {
									EC: A3(
										$author$project$Api$Partner$Partner$update,
										apiClient,
										_List_fromArray(
											[
												$author$project$Api$Partner$Partner$AddendumAgreementAccepted(true)
											]),
										$author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
									ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
									y8: _Utils_update(
										model,
										{
											PB: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.PB),
											o$: $author$project$Api$Data$Loading
										}),
									as: _List_Nil
								};
							} else {
								break _v2$3;
							}
						default:
							if (field.a) {
								return {
									EC: A3(
										$author$project$Api$Partner$Partner$update,
										apiClient,
										_List_fromArray(
											[
												$author$project$Api$Partner$Partner$ApiAccessAgreementAccepted(true)
											]),
										$author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
									ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
									y8: _Utils_update(
										model,
										{
											PB: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.PB),
											o$: $author$project$Api$Data$Loading
										}),
									as: _List_Nil
								};
							} else {
								break _v2$3;
							}
					}
				}
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					y8: _Utils_update(
						model,
						{
							PB: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.PB)
						}),
					as: _List_Nil
				};
			case 1:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsValidator, model.PB);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var updatedForm = _v4.a;
					var validFormFields = _v4.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var permittedFields = A2($author$project$Components$Partner$DocumentsAgreementsForm$toPermittedFields, model.Vz, fields);
					return {
						EC: A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: _Utils_update(
							model,
							{PB: updatedForm, o$: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var updatedForm = _v3.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: _Utils_update(
							model,
							{PB: updatedForm, o$: $author$project$Api$Data$NotAsked}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$PartnerUpdated(partner),
						y8: _Utils_update(
							model,
							{
								PB: $author$project$Utils$Form$init(
									$author$project$Components$Partner$DocumentsAgreementsForm$initFormFields(partner)),
								Vz: partner,
								o$: response
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: _Utils_update(
							model,
							{o$: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				return {
					EC: A2($author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotCustomPartnerAgreementUrl),
					ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					y8: model,
					as: _List_Nil
				};
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						EC: $author$project$Ports$Navigation$openInNewWindow(url),
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 5:
				return {
					EC: A2($author$project$Api$Partner$Partner$signedAddendumAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotAddendumAgreementUrl),
					ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					y8: model,
					as: _List_Nil
				};
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						EC: $author$project$Ports$Navigation$openInNewWindow(url),
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 4:
				return {
					EC: A2($author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotApiAccessAgreementUrl),
					ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
					y8: model,
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						EC: $author$project$Ports$Navigation$openInNewWindow(url),
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Partner$DocumentsAgreementsForm$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Partner$Form$Logo = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Partner$Form$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{zh: string}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							aa_: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Tl: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Z6: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							$a: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Xb: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Q5: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var _int = field.a;
				var string = field.b;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Mu: $elm$core$Maybe$Just(string),
							F0: _int,
							S8: $elm$core$Maybe$Just(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							Oo: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var string = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{
							$w: $author$project$Utils$String$toMaybe(string)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{aaG: bool}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var addressMsg = field.a;
				var _v1 = A2($author$project$Components$AddressInput$update, addressMsg, fields.It);
				var addressInput = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						fields,
						{It: addressInput}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address),
						cmd),
					outMsgs);
		}
	});
var $author$project$Components$Partner$Form$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var field = msg.a;
			var _v2 = A3($author$project$Utils$Form$updateWithCmdAndOutMsgs, $author$project$Components$Partner$Form$formFieldsUpdate, field, model.PB);
			var newForm = _v2.a;
			var cmd = _v2.b;
			var outMsgs = _v2.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{PB: newForm}),
				cmd,
				outMsgs);
		} else {
			var logos = msg.a;
			var cmd = A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var task = _v3.a;
						var size = _v3.b;
						return A2(
							$elm$core$Task$perform,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Partner$Form$FormUpdated,
								$author$project$Components$Partner$Form$Logo(size)),
							task);
					},
					A2(
						$elm$core$Maybe$map,
						function (logo) {
							return _Utils_Tuple2(
								$elm$file$File$toUrl(logo),
								$elm$file$File$size(logo));
						},
						$elm$core$List$head(logos))));
			return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Components$Partner$Form$LogoValidation = 5;
var $author$project$Components$Partner$Form$NameValidation = 0;
var $author$project$Components$Partner$Form$TechnicalEmailValidation = 7;
var $author$project$Components$Partner$Form$WebsiteUrlValidation = 1;
var $author$project$Components$Partner$Form$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$Form$AddressValidation = 8;
var $author$project$Components$Partner$Form$validateAddress = function (fields) {
	return $author$project$Components$AddressInput$isValid(fields.It) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(8, 'Please enter an address')
		]);
};
var $author$project$Components$Partner$Form$validateRequiredMaybeString = F4(
	function (getter, validationGroup, errorMsg, fields) {
		var _v0 = getter(fields);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, errorMsg)
				]);
		} else {
			var value = _v0.a;
			return $elm$core$String$isEmpty(value) ? _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, errorMsg)
				]) : _List_Nil;
		}
	});
var $author$project$Components$Partner$Form$validateUrlRequired = F4(
	function (getter, validationGroup, errorMsg, fields) {
		var _v0 = getter(fields);
		if (_v0.$ === 1) {
			return _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, errorMsg)
				]);
		} else {
			var url = _v0.a;
			return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
				[
					_Utils_Tuple2(validationGroup, 'URL must start with http:// or https://')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Partner$Form$formFieldsValidatorAll = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a name.')),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.F0;
			},
			$author$project$Components$Partner$Form$maxLogoBytesSize,
			_Utils_Tuple2(5, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A3(
				$author$project$Components$Partner$Form$validateUrlRequired,
				function ($) {
					return $.aa_;
				},
				1,
				'Please enter a website URL.')),
			$rtfeldman$elm_validate$Validate$fromErrors(
			A3(
				$author$project$Components$Partner$Form$validateRequiredMaybeString,
				function ($) {
					return $.$w;
				},
				7,
				'Please enter a technical email.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$Form$validateAddress)
		]));
var $author$project$Api$Partner$Partner$Address = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$Partner$WebsiteUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$Form$toPermittedFields = function (fields) {
	return A2(
		$elm$core$List$cons,
		$author$project$Api$Partner$Partner$Name(fields.zh),
		A2(
			$elm$core$List$cons,
			$author$project$Api$Partner$Partner$WebsiteUrl(fields.aa_),
			A2(
				$elm$core$List$cons,
				$author$project$Api$Partner$Partner$MarketingUrl(fields.Tl),
				A2(
					$elm$core$List$cons,
					$author$project$Api$Partner$Partner$SignupUrl(fields.Z6),
					A2(
						$elm$core$List$cons,
						$author$project$Api$Partner$Partner$SupportUrl(fields.$a),
						A2(
							$elm$core$List$cons,
							$author$project$Api$Partner$Partner$ProductDescription(fields.Xb),
							A2(
								$elm$core$List$cons,
								$author$project$Api$Partner$Partner$IntegrationDescription(fields.Q5),
								A2(
									$elm$core$List$cons,
									$author$project$Api$Partner$Partner$Email(fields.Oo),
									A2(
										$elm$core$List$cons,
										$author$project$Api$Partner$Partner$TechnicalEmail(
											A2($elm$core$Maybe$withDefault, '', fields.$w)),
										A2(
											$elm$core$List$cons,
											$author$project$Api$Partner$Partner$UsesIntegrationRecords(fields.aaG),
											A2(
												$elm$core$List$cons,
												$author$project$Api$Partner$Partner$Address(
													A2($author$project$Components$AddressInput$encodeWithPrefix, '', fields.It)),
												function () {
													var _v0 = fields.S8;
													if (!_v0.$) {
														var logoUrl = _v0.a;
														return _List_fromArray(
															[
																$author$project$Api$Partner$Partner$Logo(logoUrl)
															]);
													} else {
														return _List_Nil;
													}
												}())))))))))));
};
var $author$project$Components$Partner$Form$validate = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	var validatedAddress = $author$project$Components$AddressInput$validate(fields.It);
	var updatedFields = _Utils_update(
		fields,
		{It: validatedAddress});
	var updatedForm = A2($author$project$Utils$Form$set, updatedFields, model.PB);
	var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$Form$formFieldsValidatorAll, updatedForm);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var validFormFields = _v2.b;
		var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return $elm$core$Result$Ok(
			$author$project$Components$Partner$Form$toPermittedFields(validFields));
	} else {
		var validatedForm = _v1.a;
		return $elm$core$Result$Err(
			_Utils_update(
				model,
				{PB: validatedForm}));
	}
};
var $author$project$Pages$Partner$Dashboard$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.ba;
				if (!_v1.$) {
					var partnerForm = _v1.a;
					var _v2 = A2($author$project$Components$Partner$Form$update, subMsg, partnerForm);
					var updatedForm = _v2.a;
					var cmd = _v2.b;
					var outMsgs = _v2.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ba: $elm$core$Maybe$Just(updatedForm)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var baaFormResult = A3($author$project$Components$Partner$BaaForm$update, model.D5, subMsg, model.bO);
				var _v3 = baaFormResult.ac5;
				if (!_v3.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bO: baaFormResult.y8}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormResult.EC),
						baaFormResult.as);
				} else {
					var partner = _v3.a;
					var _v4 = A2($author$project$Components$Partner$DocumentsAgreementsForm$init, model.Hy, partner);
					var documentsAgreementsForm = _v4.a;
					var documentsAgreementsFormCmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bO: baaFormResult.y8,
								b3: documentsAgreementsForm,
								l7: $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(partner),
								Vz: partner
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormResult.EC),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
								])),
						baaFormResult.as);
				}
			case 2:
				var subMsg = msg.a;
				var documentsAgreementsFormResult = A3($author$project$Components$Partner$DocumentsAgreementsForm$update, model.D5, subMsg, model.b3);
				var _v5 = documentsAgreementsFormResult.ac5;
				if (!_v5.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b3: documentsAgreementsFormResult.y8}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormResult.EC),
						documentsAgreementsFormResult.as);
				} else {
					var partner = _v5.a;
					var _v6 = A2($author$project$Components$Partner$BaaForm$init, model.Hy, partner);
					var baaForm = _v6.a;
					var baaFormCmd = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bO: baaForm,
								b3: documentsAgreementsFormResult.y8,
								l7: $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(partner),
								Vz: partner
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormResult.EC),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd)
								])),
						documentsAgreementsFormResult.as);
				}
			case 3:
				var _v7 = model.ba;
				if (!_v7.$) {
					var partnerForm = _v7.a;
					var _v8 = $author$project$Components$Partner$Form$validate(partnerForm);
					if (!_v8.$) {
						var permittedFields = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{o$: $author$project$Api$Data$Loading}),
							A3($author$project$Api$Partner$Partner$update, model.D5, permittedFields, $author$project$Pages$Partner$Dashboard$Top$GotUpdatedPartner),
							_List_Nil);
					} else {
						var updatedForm = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ba: $elm$core$Maybe$Just(updatedForm),
									o$: $author$project$Api$Data$NotAsked
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					var onboarded = $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded(partner);
					var partnerForm = onboarded ? $elm$core$Maybe$Nothing : model.ba;
					var expandedSections = $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(partner);
					var _v10 = A2($author$project$Components$Partner$DocumentsAgreementsForm$init, model.Hy, partner);
					var documentsAgreementsForm = _v10.a;
					var documentsAgreementsFormCmd = _v10.b;
					var _v11 = A2($author$project$Components$Partner$BaaForm$init, model.Hy, partner);
					var baaForm = _v11.a;
					var baaFormCmd = _v11.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bO: baaForm, b3: documentsAgreementsForm, l7: expandedSections, U5: onboarded, Vz: partner, ba: partnerForm, o$: response}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
								])),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var _v12 = $author$project$Components$Partner$Form$init(model.Vz);
				var partnerForm = _v12.a;
				var partnerFormCmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ba: $elm$core$Maybe$Just(partnerForm)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg, partnerFormCmd),
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ba: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var docResult = A3($author$project$Components$Partner$DocumentsAgreementsForm$update, model.D5, $author$project$Components$Partner$DocumentsAgreementsForm$saveMsg, model.b3);
				var baaResult = A3($author$project$Components$Partner$BaaForm$update, model.D5, $author$project$Components$Partner$BaaForm$saveMsg, model.bO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bO: baaResult.y8, b3: docResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, docResult.EC),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaResult.EC)
							])),
					_Utils_ap(docResult.as, baaResult.as));
			case 8:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jU: $author$project$Api$Data$Loading}),
					A3($author$project$Api$Partner$PartnerProduct$requestReview, model.D5, id, $author$project$Pages$Partner$Dashboard$Top$GotReviewResponse),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jU: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Review requested! The Hint team will review your listing shortly.')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jU: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Dashboard$Top$SaveAgreements = {$: 7};
var $author$project$Components$Partner$BaaForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$BaaForm$OpenCustomBaaAgreement = {$: 3};
var $author$project$Api$Partner$Partner$One$customBaaAgreementFileName = function (_v0) {
	var record = _v0.b;
	return record.MA;
};
var $author$project$Api$Partner$User$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Utils$HintUrls$partnerBaaUrl = 'https://www.hint.com/partnerbaa';
var $author$project$Ui$OrderedList$Roman = {$: 1};
var $author$project$Ui$OrderedList$roman = $author$project$Ui$OrderedList$Roman;
var $author$project$Api$Partner$DocumentAgreement$Shared$signedAt = function (_v0) {
	var record = _v0;
	return record.Z$;
};
var $author$project$Ui$SvgIcon$Success = 3;
var $author$project$Ui$SvgIcon$success = $author$project$Ui$SvgIcon$IconColor(3);
var $author$project$Api$Partner$DocumentAgreement$Shared$user = function (_v0) {
	var record = _v0;
	return record.aaz;
};
var $author$project$Components$Partner$BaaForm$BaaType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Panel$Active = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Panel$active = $author$project$Ui$Panel$Active;
var $author$project$Ui$Typography$FullWidth = {$: 37};
var $author$project$Ui$Typography$fullWidth = $author$project$Ui$Typography$FullWidth;
var $author$project$Ui$Form$Radio$HideCircle = {$: 4};
var $author$project$Ui$Form$Radio$hideCircle = $author$project$Ui$Form$Radio$HideCircle;
var $author$project$Ui$Form$Radio$NoPadding = {$: 5};
var $author$project$Ui$Form$Radio$noPadding = $author$project$Ui$Form$Radio$NoPadding;
var $author$project$Components$Partner$BaaForm$viewBaaTypeButton = F2(
	function (currentBaaType, baaType) {
		var _v0 = function () {
			if (!baaType) {
				return _Utils_Tuple2(
					'Subcontractor Business Associate (Under Hint’s BAA)',
					_List_fromArray(
						['You will enter into a Business Associate Agreement with Hint as a subcontractor business associate. This BAA will govern your access to and use of Protected Health Information (PHI) in connection with joint customers.', 'Under this model, Hint maintains BAAs with Covered Entities, and you operate as Hint’s subcontractor.']));
			} else {
				return _Utils_Tuple2(
					'Independent Business Associate (Direct BAAs with Covered Entities)',
					_List_fromArray(
						['You will not enter into a BAA with Hint. If you create, receive, maintain, or transmit Protected Health Information on behalf of your customers, you are responsible for determining whether you are a Business Associate and for entering into any required Business Associate Agreements directly with those Covered Entities.', 'Hint will not be a party to, or responsible for, any such agreements.', 'If your product is made available through the Hint Marketplace, Hint can facilitate the presentation and execution of your BAA (or other required terms) directly between you and participating practices during the onboarding and installation process.']));
			}
		}();
		var label = _v0.a;
		var notes = _v0.b;
		return A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$span(6)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Radio$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Radio$value(
							_Utils_eq(
								currentBaaType,
								$elm$core$Maybe$Just(baaType))),
							$author$project$Ui$Form$Radio$inline,
							$author$project$Ui$Form$Radio$onCheck(
							function (_v2) {
								return $author$project$Components$Partner$BaaForm$FormUpdated(
									$author$project$Components$Partner$BaaForm$BaaType(baaType));
							}),
							$author$project$Ui$Form$Radio$hideCircle,
							$author$project$Ui$Form$Radio$noPadding
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$view,
							_List_fromArray(
								[
									$author$project$Ui$Panel$active(
									_Utils_eq(
										currentBaaType,
										$elm$core$Maybe$Just(baaType)))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$body,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$titleSm,
											_List_fromArray(
												[
													$author$project$Ui$Typography$fullWidth,
													$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter),
													$author$project$Ui$Typography$margin(5)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(label)
												])),
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$ul,
													_List_Nil,
													A2(
														$elm$core$List$map,
														function (note) {
															return A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(note)
																	]));
														},
														notes))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$BaaForm$panelBody = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var baaAgreementLink = function () {
		var _v4 = $author$project$Api$Partner$Partner$One$customBaaAgreementFileName(model.Vz);
		if (!_v4.$) {
			return A3(
				$author$project$Ui$Button$view,
				{abp: 'View Business Associate Agreement'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick($author$project$Components$Partner$BaaForm$OpenCustomBaaAgreement)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Business Associate Agreement')
					]));
		} else {
			return A3(
				$author$project$Ui$Link$externalHref,
				$author$project$Utils$HintUrls$partnerBaaUrl,
				_List_fromArray(
					[$author$project$Ui$Link$targetBlank]),
				_List_fromArray(
					[
						$elm$html$Html$text('Business Associate Agreement')
					]));
		}
	}();
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Business Associate Agreement')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Components$Partner$BaaForm$viewBaaTypeButton, fields.JO, 0),
										A2($author$project$Components$Partner$BaaForm$viewBaaTypeButton, fields.JO, 1)
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(12)
											]),
										_List_fromArray(
											[
												function () {
												var _v0 = _Utils_Tuple2(
													fields.JO,
													$author$project$Api$Partner$Partner$One$baaDocumentAgreement(model.Vz));
												if ((!_v0.a.$) && (!_v0.a.a)) {
													if (!_v0.b.$) {
														var _v1 = _v0.a.a;
														var baaDocumentAgreement = _v0.b.a;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2, $author$project$Ui$Element$mt2]),
															_List_fromArray(
																[
																	$author$project$Ui$SvgIcon$check(
																	_List_fromArray(
																		[$author$project$Ui$SvgIcon$success])),
																	A2(
																	$elm$html$Html$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Api$Partner$User$Shared$name(
																				$author$project$Api$Partner$DocumentAgreement$Shared$user(baaDocumentAgreement))),
																			$elm$html$Html$text(' agreed to the '),
																			baaAgreementLink,
																			$elm$html$Html$text(' on '),
																			$elm$html$Html$text(
																			A2(
																				model.Hy,
																				6,
																				$author$project$Api$Partner$DocumentAgreement$Shared$signedAt(baaDocumentAgreement)))
																		]))
																]));
													} else {
														var _v2 = _v0.a.a;
														var _v3 = _v0.b;
														return A2(
															$author$project$Ui$Element$view,
															_List_fromArray(
																[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mt2]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$div,
																	_List_fromArray(
																		[$author$project$Ui$Typography$small]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('By selecting \"I Agree,\" you:'),
																			A2(
																			$author$project$Ui$OrderedList$view,
																			_List_fromArray(
																				[$author$project$Ui$OrderedList$roman]),
																			_List_fromArray(
																				[
																					A2(
																					$author$project$Ui$OrderedList$item,
																					_List_Nil,
																					_List_fromArray(
																						[
																							$elm$html$Html$text('confirm that you have read and agree to Hint\'s '),
																							baaAgreementLink
																						])),
																					A2(
																					$author$project$Ui$OrderedList$item,
																					_List_Nil,
																					_List_fromArray(
																						[
																							$elm$html$Html$text('represent and warrant that you are an authorized representative of '),
																							A2(
																							$author$project$Ui$Typography$strong,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text(
																									$author$project$Api$Partner$Partner$One$name(model.Vz))
																								])),
																							$elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
																						])),
																					A2(
																					$author$project$Ui$OrderedList$item,
																					_List_Nil,
																					_List_fromArray(
																						[
																							$elm$html$Html$text('agree that this electronic acceptance constitutes a legally binding agreement between Hint Health, Inc. and '),
																							A2(
																							$author$project$Ui$Typography$strong,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text(
																									$author$project$Api$Partner$Partner$One$name(model.Vz))
																								])),
																							$elm$html$Html$text(', effective as of the date of acceptance.')
																						]))
																				])),
																			$elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
																			A2(
																			$author$project$Ui$Typography$strong,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Api$Partner$Partner$One$name(model.Vz))
																				])),
																			$elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
																		])),
																	A3(
																	$author$project$Ui$Button$view,
																	{abp: 'I Agree to Business Associate Agreement'},
																	_List_fromArray(
																		[
																			$author$project$Ui$Button$primary,
																			$author$project$Ui$Button$onClick(
																			$author$project$Components$Partner$BaaForm$FormUpdated(
																				$author$project$Components$Partner$BaaForm$BaaAccepted(true)))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('I Agree')
																		]))
																]));
													}
												} else {
													return $author$project$Utils$Html$empty;
												}
											}(),
												$author$project$Utils$FormErrors$view(
												A2($author$project$Utils$Form$validationErrors, 0, model.PB)),
												$author$project$Utils$FormErrors$view(
												A2($author$project$Utils$Form$validationErrors, 1, model.PB))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Partner$BaaForm$viewBody = function (_v0) {
	var model = _v0;
	return $author$project$Components$Partner$BaaForm$panelBody(model);
};
var $author$project$Components$Partner$DocumentsAgreementsForm$AddendumAgreementAccepted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$OpenAddendumAgreement = {$: 5};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewAgreedLine = F3(
	function (timeFormatter, agreementLink, documentAgreement) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
			_List_fromArray(
				[
					$author$project$Ui$SvgIcon$check(
					_List_fromArray(
						[$author$project$Ui$SvgIcon$success])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$User$Shared$name(
								$author$project$Api$Partner$DocumentAgreement$Shared$user(documentAgreement))),
							$elm$html$Html$text(' agreed to the '),
							agreementLink,
							$elm$html$Html$text(' on '),
							$elm$html$Html$text(
							A2(
								timeFormatter,
								6,
								$author$project$Api$Partner$DocumentAgreement$Shared$signedAt(documentAgreement)))
						]))
				]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$viewAgreementTerms = F2(
	function (partner, agreementLink) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[$author$project$Ui$Typography$small]),
			_List_fromArray(
				[
					$elm$html$Html$text('By selecting \"I Agree,\" you:'),
					A2(
					$author$project$Ui$OrderedList$view,
					_List_fromArray(
						[$author$project$Ui$OrderedList$roman]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$OrderedList$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('confirm that you have read and agree to Hint\'s '),
									agreementLink
								])),
							A2(
							$author$project$Ui$OrderedList$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('represent and warrant that you are an authorized representative of '),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$Partner$One$name(partner))
										])),
									$elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
								])),
							A2(
							$author$project$Ui$OrderedList$item,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('agree that this electronic acceptance constitutes a legally binding agreement between Hint Health, Inc. and '),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$Partner$One$name(partner))
										])),
									$elm$html$Html$text(', effective as of the date of acceptance.')
								]))
						])),
					$elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$Partner$One$name(partner))
						])),
					$elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
				]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement = F3(
	function (partner, agreementLink, agreeMsg) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
			_List_fromArray(
				[
					A2($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreementTerms, partner, agreementLink),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'I Agree'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$onClick(agreeMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('I Agree')
						]))
				]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$viewAddendumAgreement = F2(
	function (timeFormatter, partner) {
		var _v0 = $author$project$Api$Partner$Partner$One$addendumAgreementFileName(partner);
		if (!_v0.$) {
			var agreementLink = A3(
				$author$project$Ui$Button$view,
				{abp: 'View addendum agreement'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenAddendumAgreement)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Addendum Agreement')
					]));
			return A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Addendum Agreement')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v1 = $author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner);
								if (!_v1.$) {
									var documentAgreement = _v1.a;
									return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreedLine, timeFormatter, agreementLink, documentAgreement);
								} else {
									return A3(
										$author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement,
										partner,
										agreementLink,
										$author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated(
											$author$project$Components$Partner$DocumentsAgreementsForm$AddendumAgreementAccepted(true)));
								}
							}()
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$ApiAccessAgreementAccepted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomApiAccessAgreement = {$: 4};
var $author$project$Utils$HintUrls$apiAccessAgreementUrl = 'https://www.hint.com/api-access-agreement';
var $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName = function (_v0) {
	var record = _v0.b;
	return record.Mz;
};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewApiAccessAgreement = F2(
	function (timeFormatter, partner) {
		var agreementLink = function () {
			var _v1 = $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName(partner);
			if (!_v1.$) {
				return A3(
					$author$project$Ui$Button$view,
					{abp: 'View API access agreement'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomApiAccessAgreement)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('API Access Agreement')
						]));
			} else {
				return A3(
					$author$project$Ui$Link$externalHref,
					$author$project$Utils$HintUrls$apiAccessAgreementUrl,
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank]),
					_List_fromArray(
						[
							$elm$html$Html$text('API Access Agreement')
						]));
			}
		}();
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('API Access Agreement')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner);
							if (!_v0.$) {
								var documentAgreement = _v0.a;
								return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreedLine, timeFormatter, agreementLink, documentAgreement);
							} else {
								return A3(
									$author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement,
									partner,
									agreementLink,
									$author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated(
										$author$project$Components$Partner$DocumentsAgreementsForm$ApiAccessAgreementAccepted(true)));
							}
						}()
						]))
				]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomPartnerAgreement = {$: 3};
var $author$project$Components$Partner$DocumentsAgreementsForm$PartnerAgreementAccepted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName = function (_v0) {
	var record = _v0.b;
	return record.MG;
};
var $author$project$Utils$HintUrls$partnerAgreementUrl = 'http://www.hint.com/partner-agreement';
var $author$project$Components$Partner$DocumentsAgreementsForm$viewPartnerAgreement = F2(
	function (timeFormatter, partner) {
		var agreementLink = function () {
			var _v1 = $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName(partner);
			if (!_v1.$) {
				return A3(
					$author$project$Ui$Button$view,
					{abp: 'View partner agreement'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomPartnerAgreement)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Partner Agreement')
						]));
			} else {
				return A3(
					$author$project$Ui$Link$externalHref,
					$author$project$Utils$HintUrls$partnerAgreementUrl,
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank]),
					_List_fromArray(
						[
							$elm$html$Html$text('Partner Agreement')
						]));
			}
		}();
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Partner Agreement')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner);
							if (!_v0.$) {
								var documentAgreement = _v0.a;
								return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreedLine, timeFormatter, agreementLink, documentAgreement);
							} else {
								return A3(
									$author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement,
									partner,
									agreementLink,
									$author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated(
										$author$project$Components$Partner$DocumentsAgreementsForm$PartnerAgreementAccepted(true)));
							}
						}()
						]))
				]));
	});
var $author$project$Components$Partner$DocumentsAgreementsForm$panelList = function (model) {
	return _List_fromArray(
		[
			_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(model.Vz),
			$elm$core$Maybe$Nothing) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewPartnerAgreement, model.Hy, model.Vz) : $author$project$Utils$Html$empty,
			_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(model.Vz),
			$elm$core$Maybe$Nothing) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewAddendumAgreement, model.Hy, model.Vz) : $author$project$Utils$Html$empty,
			(!_Utils_eq(
			$author$project$Api$Partner$Partner$One$managedBy(model.Vz),
			$elm$core$Maybe$Nothing)) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewApiAccessAgreement, model.Hy, model.Vz) : $author$project$Utils$Html$empty
		]);
};
var $author$project$Components$Partner$DocumentsAgreementsForm$viewPanels = function (_v0) {
	var model = _v0;
	return $author$project$Components$Partner$DocumentsAgreementsForm$panelList(model);
};
var $author$project$Pages$Partner$Dashboard$Top$viewAgreementsContent = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$elm$html$Html$map($author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg),
				$author$project$Components$Partner$DocumentsAgreementsForm$viewPanels(model.b3)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Partner$Dashboard$Top$BaaFormMsg,
					$author$project$Components$Partner$BaaForm$viewBody(model.bO)),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Save agreements'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$SaveAgreements)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				])));
};
var $author$project$Pages$Partner$Dashboard$Top$CancelEdit = {$: 6};
var $author$project$Pages$Partner$Dashboard$Top$EditClicked = {$: 5};
var $author$project$Pages$Partner$Dashboard$Top$Save = {$: 3};
var $author$project$Components$Partner$Form$Minimal = 0;
var $author$project$Components$Partner$Form$minimal = 0;
var $author$project$Components$Partner$Form$Email = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$Form$EmailValidation = 6;
var $author$project$Components$Partner$Form$IntegrationDescription = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$Form$LogoUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$Form$MarketingUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$Form$MarketingUrlValidation = 2;
var $author$project$Components$Partner$Form$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$Form$ProductDescription = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$Form$SignupUrl = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$Form$SignupUrlValidation = 3;
var $author$project$Components$Partner$Form$SupportUrl = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$Form$SupportUrlValidation = 4;
var $author$project$Components$Partner$Form$TechnicalEmail = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$Form$UsesIntegrationRecords = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$Form$WebsiteUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$Form$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				return _Utils_update(
					acc,
					{f4: true});
			}),
		{f4: false},
		options);
};
var $author$project$Components$Partner$Form$view = F2(
	function (options, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Components$Partner$Form$optionsToRecord(options);
		var unlessMinimal = function (field) {
			return optionsRecord.f4 ? $elm$html$Html$text('') : field;
		};
		var fields = $author$project$Utils$Form$fields(model.PB);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Legal Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.zh),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Name)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, model.PB))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Legal Address'),
							$author$project$Ui$Form$Group$required(!optionsRecord.f4)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address),
							A2($author$project$Components$AddressInput$view, _List_Nil, fields.It)),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 8, model.PB))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Website URL'),
							$author$project$Ui$Form$Group$required(!optionsRecord.f4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.aa_)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$WebsiteUrl)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, model.PB))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Logo (Horizontal)')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$File$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$File$accept(0),
									$author$project$Ui$Form$File$onInput($author$project$Components$Partner$Form$LogoUploaded),
									$author$project$Ui$Form$File$empty(true)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Preferred format: SVG or PNG')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Aspect ratio: Horizontal (aproximately 3:1)')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Minimum width: 300px')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Content: May include your company name or wordmark')
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											$elm$html$Html$text('This asset may be used in larger layouts or future branding surfaces.')
										]))
								]))
						])),
					function () {
					var _v1 = fields.Mu;
					if (!_v1.$) {
						var url = _v1.a;
						return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8),
									$author$project$Ui$Form$Group$label('')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Image$fromSrc,
									{I1: 'Logo'},
									url,
									_List_fromArray(
										[
											$author$project$Ui$Image$height(50)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Utils$Form$validationErrors, 5, model.PB))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Technical Notifications'),
							$author$project$Ui$Form$Group$required(!optionsRecord.f4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(
									A2($elm$core$Maybe$withDefault, '', fields.$w)),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$TechnicalEmail)),
									$author$project$Ui$Form$Input$placeholder('contact@mypartner.com'),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 7, model.PB)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 7, model.PB))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt2, $author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text('Email for technical alerts (e.g., webhook failures, outages, planned downtime); use a shared mailing list to avoid a single point of failure.')
								]))
						])),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Email'),
								$author$project$Ui$Form$Group$required(!optionsRecord.f4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.Oo)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Email)),
										$author$project$Ui$Form$Input$placeholder('contact@mypartner.com'),
										$author$project$Ui$Form$Input$phi(true),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 6, model.PB)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 6, model.PB))
									]))
							]))),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Product Description')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Textarea$value(
										A2($elm$core$Maybe$withDefault, '', fields.Xb)),
										$author$project$Ui$Form$Textarea$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$ProductDescription))
									]))
							]))),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Integration Description')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Textarea$value(
										A2($elm$core$Maybe$withDefault, '', fields.Q5)),
										$author$project$Ui$Form$Textarea$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$IntegrationDescription))
									]))
							]))),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Marketing URL')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.Tl)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$MarketingUrl)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 2, model.PB))
									]))
							]))),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Signup URL')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.Z6)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$SignupUrl)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 3, model.PB))
									]))
							]))),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Support URL')
							]),
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', fields.$a)),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$SupportUrl)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 4, model.PB)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 4, model.PB))
									]))
							]))),
					unlessMinimal(
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Uses Integration Records')
							]),
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$view(
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$on(fields.aaG),
										$author$project$Ui$ToggleSwitch$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$UsesIntegrationRecords))
									]))
							])))
				]));
	});
var $author$project$Ui$SvgIcon$Location = 14;
var $author$project$Ui$SvgIcon$location = $author$project$Ui$SvgIcon$viewIcon(14);
var $author$project$Pages$Partner$Dashboard$Top$viewAccount = function (partner) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol]),
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (logoUrl) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Image$fromSrc,
									{
										I1: $author$project$Api$Partner$Partner$One$name(partner) + ' logo'
									},
									logoUrl,
									_List_fromArray(
										[
											$author$project$Ui$Image$height(100)
										]))
								]));
					},
					$author$project$Api$Partner$Partner$One$logoUrl(partner))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (address) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$location(_List_Nil),
									$author$project$Components$AddressDisplay$view(address)
								]));
					},
					$author$project$Api$Partner$Partner$One$address(partner))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (url) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$translate(_List_Nil),
									A3(
									$author$project$Ui$Link$externalHref,
									url,
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(url)
										]))
								]));
					},
					$author$project$Api$Partner$Partner$One$websiteUrl(partner))),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$html$Html$text(''),
				A2(
					$elm$core$Maybe$map,
					function (email) {
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$mail(_List_Nil),
									A3(
									$author$project$Ui$Link$mailto,
									email,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(email)
										]))
								]));
					},
					$author$project$Api$Partner$Partner$One$technicalEmail(partner)))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent = function (model) {
	var editing = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(true),
			model.ba));
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Dashboard$Top$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						editing ? _List_Nil : _List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Partner$Partner$One$name(model.Vz))
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Edit account'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$EditClicked),
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.ba;
								if (!_v0.$) {
									var partnerForm = _v0.a;
									return A2(
										$elm$html$Html$map,
										$author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg,
										A2(
											$author$project$Components$Partner$Form$view,
											_List_fromArray(
												[$author$project$Components$Partner$Form$minimal]),
											partnerForm));
								} else {
									return $author$project$Pages$Partner$Dashboard$Top$viewAccount(model.Vz);
								}
							}()
							])),
						function () {
						if (editing) {
							var loading = _Utils_eq(model.o$, $author$project$Api$Data$Loading);
							return A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$mt2]),
								_List_fromArray(
									[
										model.U5 ? A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel editing'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$CancelEdit)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])) : $elm$html$Html$text(''),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Save partner changes'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Save')
											]))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]));
};
var $author$project$Api$Partner$PartnerProduct$Shared$builtByName = function (_v0) {
	var record = _v0;
	return record.Kd;
};
var $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl = function (_v0) {
	var record = _v0;
	return record.Ke;
};
var $author$project$Api$Partner$PartnerProduct$Shared$featured = function (_v0) {
	var record = _v0;
	return record.Pc;
};
var $author$project$Api$Partner$PartnerProduct$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Partner$PartnerProduct$Shared$slug = function (_v0) {
	var record = _v0;
	return record._c;
};
var $author$project$Api$Partner$PartnerProduct$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Ui$FlexGrid$itemsCenter = $author$project$Ui$FlexGrid$Element($author$project$Ui$Element$itemsCenter);
var $author$project$Ui$Card$Link = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Card$linkTo = $author$project$Ui$Card$Link;
var $author$project$Ui$Card$Muted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Card$muted = $author$project$Ui$Card$Muted;
var $author$project$Components$Marketplace$ProductCard$view = F3(
	function (hinterMode, productRoute, product) {
		var listed = (!product.NS) && (!A2(
			$elm$core$List$member,
			product.SZ,
			_List_fromArray(
				[1, 8])));
		return A2(
			$author$project$Ui$Card$view,
			_List_fromArray(
				[
					$author$project$Ui$Card$highlighted(product.Pc),
					$author$project$Ui$Card$muted(hinterMode && (!listed)),
					$author$project$Ui$Card$linkTo(
					$author$project$Spa$Generated$Route$toString(productRoute))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4),
									$author$project$Ui$FlexGrid$itemsCenter,
									$author$project$Ui$FlexGrid$justifyCenter
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = product.QH;
									if (!_v0.$) {
										var url = _v0.a;
										return A3(
											$author$project$Ui$Image$fromSrc,
											{I1: product.zh + '\'s icon'},
											url,
											_List_fromArray(
												[
													$author$project$Ui$Image$width(64)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}()
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb4]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$itemsStart, $author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													$author$project$Ui$Typography$headingSm(
													_List_fromArray(
														[
															$elm$html$Html$text(product.zh)
														])),
													$author$project$Components$Marketplace$ProductCard$viewIntegrationChip(product)
												]))
										])),
									A3(
									$author$project$Ui$Element$custom,
									'max-h-24',
									_List_fromArray(
										[$author$project$Ui$Element$mb4]),
									_List_fromArray(
										[
											function () {
											var clampClass = function () {
												var _v1 = product.SZ;
												if (_v1 === 5) {
													return 'line-clamp-3';
												} else {
													return 'line-clamp-2';
												}
											}();
											return A3(
												$author$project$Ui$Element$custom,
												clampClass,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mb2]),
												$elm$core$List$singleton(
													$elm$html$Html$text(
														A2($elm$core$Maybe$withDefault, '', product._9))));
										}(),
											function () {
											var _v2 = _Utils_Tuple2(hinterMode, product.SZ);
											if ((!_v2.a) && (_v2.b === 5)) {
												var _v3 = _v2.b;
												return $elm$html$Html$text('');
											} else {
												return $author$project$Components$Marketplace$ProductCard$viewListingChip(product);
											}
										}()
										]))
								]))
						]))
				]));
	});
var $author$project$Ui$Margin$Top_0_50 = 6;
var $author$project$Ui$Card$Disabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Card$disabled = $author$project$Ui$Card$Disabled;
var $author$project$Ui$SvgIcon$mb3 = $author$project$Ui$SvgIcon$SpacedBottom(3);
var $author$project$Pages$Partner$Dashboard$Top$viewNewProduct = function (model) {
	return A2(
		$author$project$Ui$Card$view,
		_List_fromArray(
			[
				$author$project$Ui$Card$linkTo(
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Product__New)),
				$author$project$Ui$Card$disabled(
				!_Utils_eq(
					$author$project$Api$Partner$Partner$One$product(model.Vz),
					$elm$core$Maybe$Nothing))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(12),
								$author$project$Ui$FlexGrid$itemsCenter,
								$author$project$Ui$FlexGrid$justifyCenter
							]),
						_List_fromArray(
							[
								$author$project$Ui$SvgIcon$add(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$mb3, $author$project$Ui$SvgIcon$xl])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Add Product')
									])),
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$muted,
										$author$project$Ui$Typography$margin(6)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Create a new product listing for the marketplace')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard = function (model) {
	var _v0 = $author$project$Api$Partner$Partner$One$product(model.Vz);
	if (!_v0.$) {
		var product = _v0.a;
		var marketplaceProduct = {
			Kd: $author$project$Api$Partner$PartnerProduct$Shared$builtByName(product),
			Ke: $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(product),
			NS: $author$project$Api$Partner$PartnerProduct$Shared$distributionType(product),
			Pc: $author$project$Api$Partner$PartnerProduct$Shared$featured(product),
			QH: $author$project$Api$Partner$Partner$One$marketplaceIconUrl(model.Vz),
			SZ: $author$project$Api$Partner$PartnerProduct$Shared$status(product),
			zh: $author$project$Api$Partner$PartnerProduct$Shared$name(product),
			_c: $author$project$Api$Partner$PartnerProduct$Shared$slug(product),
			ag7: $elm$core$Maybe$Nothing,
			_9: $author$project$Api$Partner$PartnerProduct$Shared$summary(product),
			ahI: $author$project$Api$Partner$PartnerProduct$Shared$type_(product)
		};
		return A3(
			$author$project$Ui$Element$custom,
			'marketplace-cards',
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Components$Marketplace$ProductCard$view, false, $author$project$Spa$Generated$Route$Partner__Product, marketplaceProduct)
				]));
	} else {
		return $author$project$Pages$Partner$Dashboard$Top$viewNewProduct(model);
	}
};
var $author$project$Pages$Partner$Dashboard$Top$completedStepCount = function (partner) {
	return $elm$core$List$length(
		A2(
			$elm$core$List$filter,
			$author$project$Pages$Partner$Dashboard$Top$isStepComplete(partner),
			$author$project$Pages$Partner$Dashboard$Top$allSteps(partner)));
};
var $author$project$Pages$Partner$Dashboard$Top$totalSteps = function (partner) {
	return $elm$core$List$length(
		$author$project$Pages$Partner$Dashboard$Top$allSteps(partner));
};
var $author$project$Pages$Partner$Dashboard$Top$viewProgressHeader = function (partner) {
	var total = $author$project$Pages$Partner$Dashboard$Top$totalSteps(partner);
	var completed = $author$project$Pages$Partner$Dashboard$Top$completedStepCount(partner);
	var percentage = (!total) ? 0 : (((completed * 100) / total) | 0);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$title,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Go Live in Marketplace')
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(completed) + (' of ' + ($elm$core$String$fromInt(total) + ' complete')))
									]))
							])),
						$author$project$Ui$ProgressBar$view(
						_List_fromArray(
							[
								$author$project$Ui$ProgressBar$width(percentage)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								$elm$html$Html$text('Complete the steps below, then submit your listing for review.')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb4, $author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				$author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard(model),
				$author$project$Pages$Partner$Dashboard$Top$viewProgressHeader(model.Vz)
			]));
};
var $author$project$Pages$Partner$Dashboard$Top$RequestReview = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Ui$SvgIcon$Circled = {$: 7};
var $author$project$Ui$SvgIcon$circled = $author$project$Ui$SvgIcon$Circled;
var $author$project$Ui$SvgIcon$Circle = 45;
var $author$project$Ui$SvgIcon$circle = $author$project$Ui$SvgIcon$viewIcon(45);
var $author$project$Pages$Partner$Dashboard$Top$statusIcon = function (complete) {
	return complete ? $author$project$Ui$SvgIcon$check(
		_List_fromArray(
			[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$success])) : $author$project$Ui$SvgIcon$circle(
		_List_fromArray(
			[$author$project$Ui$SvgIcon$info, $author$project$Ui$SvgIcon$xl]));
};
var $author$project$Pages$Partner$Dashboard$Top$viewProductChecklist = F2(
	function (partner, product) {
		var tileComplete = A2($author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete, partner, product);
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									$author$project$Pages$Partner$Dashboard$Top$statusIcon(tileComplete),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Marketplace card')
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
											_List_fromArray(
												[
													$elm$html$Html$text('Name, summary, and icon')
												]))
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mt4]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$edit(
											_List_fromArray(
												[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$info])),
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Detail page')
														])),
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
													_List_fromArray(
														[
															$elm$html$Html$text('Overview, highlights, and details')
														]))
												]))
										])),
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Partner__Product,
									_List_fromArray(
										[
											$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit),
											$author$project$Ui$Link$sm
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Dashboard$Top$viewProductListingContent = function (model) {
	var _v0 = $author$project$Api$Partner$Partner$One$product(model.Vz);
	if (!_v0.$) {
		var product = _v0.a;
		var published = $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished(model.Vz);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Element$custom,
							'marketplace-cards',
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var marketplaceProduct = {
										Kd: $author$project$Api$Partner$PartnerProduct$Shared$builtByName(product),
										Ke: $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(product),
										NS: $author$project$Api$Partner$PartnerProduct$Shared$distributionType(product),
										Pc: $author$project$Api$Partner$PartnerProduct$Shared$featured(product),
										QH: $author$project$Api$Partner$Partner$One$marketplaceIconUrl(model.Vz),
										SZ: $author$project$Api$Partner$PartnerProduct$Shared$status(product),
										zh: $author$project$Api$Partner$PartnerProduct$Shared$name(product),
										_c: $author$project$Api$Partner$PartnerProduct$Shared$slug(product),
										ag7: $elm$core$Maybe$Nothing,
										_9: $author$project$Api$Partner$PartnerProduct$Shared$summary(product),
										ahI: $author$project$Api$Partner$PartnerProduct$Shared$type_(product)
									};
									return A3($author$project$Components$Marketplace$ProductCard$view, false, $author$project$Spa$Generated$Route$Partner__Product, marketplaceProduct);
								}()
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$mt2]),
							_List_fromArray(
								[
									$elm$html$Html$text('This is how your listing will appear in the marketplace. Click to edit.')
								]))
						])),
					A2($author$project$Pages$Partner$Dashboard$Top$viewProductChecklist, model.Vz, product),
					function () {
					if (published) {
						return $author$project$Utils$Html$empty;
					} else {
						var reviewReady = A2(
							$elm$core$List$all,
							$author$project$Pages$Partner$Dashboard$Top$isStepComplete(model.Vz),
							A2(
								$elm$core$List$filter,
								function (s) {
									return s !== 2;
								},
								$author$project$Pages$Partner$Dashboard$Top$allSteps(model.Vz)));
						var loading = _Utils_eq(model.jU, $author$project$Api$Data$Loading);
						var alreadyRequested = function () {
							var _v1 = model.jU;
							if (_v1.$ === 3) {
								return true;
							} else {
								return false;
							}
						}();
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Request listing review'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$disabled((!reviewReady) || alreadyRequested),
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Partner$Dashboard$Top$RequestReview(
												$author$project$Api$Partner$PartnerProduct$Shared$id(product)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Request Listing Review')
										]))
								]));
					}
				}()
				]));
	} else {
		return $author$project$Pages$Partner$Dashboard$Top$viewNewProduct(model);
	}
};
var $author$project$Pages$Partner$Dashboard$Top$viewSandboxSetupContent = function (_v0) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Partner__Sandboxes__Top,
				_List_fromArray(
					[$author$project$Ui$Link$buttonPrimary]),
				_List_fromArray(
					[
						$elm$html$Html$text('Go to Sandboxes')
					]))
			]));
};
var $author$project$Ui$Panel$Collapsed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Panel$collapsed = $author$project$Ui$Panel$Collapsed;
var $author$project$Pages$Partner$Dashboard$Top$stepDescription = function (step) {
	switch (step) {
		case 0:
			return 'Legal business name, address, logo, and technical contact';
		case 1:
			return 'Review and accept required partner and business associate agreements';
		case 2:
			return 'Create and configure your marketplace product listing';
		default:
			return 'Create and configure a sandbox partner and sandbox practice for testing';
	}
};
var $author$project$Pages$Partner$Dashboard$Top$stepTitle = function (step) {
	switch (step) {
		case 0:
			return 'Company Details';
		case 1:
			return 'Agreements';
		case 2:
			return 'Product Listing';
		default:
			return 'Sandbox Setup';
	}
};
var $author$project$Pages$Partner$Dashboard$Top$viewSetupSection = F3(
	function (model, step, content) {
		var expanded = A2($elm$core$List$member, step, model.l7);
		var complete = A2($author$project$Pages$Partner$Dashboard$Top$isStepComplete, model.Vz, step);
		return A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[
					$author$project$Ui$Panel$collapsed(!expanded)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							$author$project$Pages$Partner$Dashboard$Top$statusIcon(complete),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Pages$Partner$Dashboard$Top$stepTitle(step))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Pages$Partner$Dashboard$Top$stepDescription(step))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboard = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_Utils_ap(
					$author$project$Api$Partner$Partner$One$sandboxEnabled(model.Vz) ? _List_fromArray(
						[
							$author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader(model),
							A3(
							$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
							model,
							3,
							$author$project$Pages$Partner$Dashboard$Top$viewSandboxSetupContent(model))
						]) : _List_fromArray(
						[
							$author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader(model)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
							model,
							0,
							$author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent(model)),
							A3(
							$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
							model,
							1,
							$author$project$Pages$Partner$Dashboard$Top$viewAgreementsContent(model)),
							A3(
							$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
							model,
							2,
							$author$project$Pages$Partner$Dashboard$Top$viewProductListingContent(model))
						])))
			]),
		$G: 'Partner | Dashboard'
	};
};
var $author$project$Pages$Partner$Dashboard$Top$viewGuideStep = F3(
	function (number, title, description) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text(number)
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Dashboard$Top$viewIntegrationGuidePanel = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Panel$title(
					_List_fromArray(
						[
							$elm$html$Html$text('Building Your Integration')
						]))
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted]),
							_List_fromArray(
								[
									$elm$html$Html$text('Follow the steps in the developer documentation to build and test your integration with Hint.')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap2]),
							_List_fromArray(
								[
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '1', 'Define data sync', 'Determine sync direction and source of truth'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '2', 'Implement activation', 'Set up the practice activation flow'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '3', 'Initial data sync', 'Backfill existing data safely'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '4', 'Keep data current', 'Use webhooks to stay in sync'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '5', 'Integration records', 'Make sync status observable'),
									A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '6', 'Surface key fields', 'Show high-value data in your UI')
								])),
							A3(
							$author$project$Ui$Link$externalHref,
							'https://developers.hint.com/docs/building-an-integration',
							_List_fromArray(
								[$author$project$Ui$Link$buttonPrimary, $author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Developer Docs')
								]))
						]))
				]))
		]));
var $author$project$Pages$Partner$Dashboard$Top$viewSandboxDashboard = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard(model)
							])),
						$author$project$Pages$Partner$Dashboard$Top$viewIntegrationGuidePanel,
						A3(
						$author$project$Pages$Partner$Dashboard$Top$viewSetupSection,
						model,
						0,
						$author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent(model))
					]))
			]),
		$G: 'Partner | Dashboard'
	};
};
var $author$project$Pages$Partner$Dashboard$Top$view = function (model) {
	return model.FT ? $author$project$Pages$Partner$Dashboard$Top$viewSandboxDashboard(model) : $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboard(model);
};
var $author$project$Pages$Partner$Dashboard$Top$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Dashboard$Top$init, aer: $author$project$Pages$Partner$Dashboard$Top$load, agD: $author$project$Pages$Partner$Dashboard$Top$save, ahd: $author$project$Pages$Partner$Dashboard$Top$subscriptions, aaq: $author$project$Pages$Partner$Dashboard$Top$update, ahP: $author$project$Pages$Partner$Dashboard$Top$view});
var $author$project$Pages$Partner$Engagements$StatusDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Engagements$GotInstalledCount = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$EngagementEvent$Installed = 2;
var $author$project$Api$Partner$EngagementEvent$All$EngagementEvent = 0;
var $author$project$Api$Partner$EngagementEvent$All$Record = F4(
	function (id, practice, action, createdAt) {
		return {DV: action, Mf: createdAt, adR: id, WF: practice};
	});
var $author$project$Api$Partner$EngagementEvent$All$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$always(0),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'action',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'practice',
				$author$project$Api$Partner$Practice$Min$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$EngagementEvent$All$Record))))));
var $author$project$Api$Partner$EngagementEvent$engagementEventsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['engagement_events']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$EngagementEvent$actionToString = function (action) {
	switch (action) {
		case 0:
			return 'expressed_interest';
		case 1:
			return 'joined_waitlist';
		default:
			return 'installed';
	}
};
var $author$project$Api$Partner$EngagementEvent$listOptionsToParams = function (optionals) {
	var options = optionals(
		{DV: $elm$core$Maybe$Nothing, Gy: $elm$core$Maybe$Nothing});
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Partner$EngagementEvent$actionToString,
					$author$project$Api$Param$string('action')),
				options.DV),
				A2(
				$elm$core$Maybe$map,
				function (p) {
					return A2(
						$author$project$Api$Param$string,
						'page',
						$elm$core$String$fromInt(p));
				},
				options.Gy)
			]));
};
var $author$project$Api$Partner$EngagementEvent$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$EngagementEvent$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$EngagementEvent$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$EngagementEvent$engagementEventsPath)));
	});
var $author$project$Pages$Partner$Engagements$fetchInstalledCount = function (apiClient) {
	return A3(
		$author$project$Api$Partner$EngagementEvent$list,
		apiClient,
		function (o) {
			return _Utils_update(
				o,
				{
					DV: $elm$core$Maybe$Just(2),
					Gy: $elm$core$Maybe$Just(0)
				});
		},
		$author$project$Pages$Partner$Engagements$GotInstalledCount);
};
var $author$project$Api$Partner$EngagementEvent$ExpressedInterest = 0;
var $author$project$Pages$Partner$Engagements$GotInterestedCount = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Partner$Engagements$fetchInterestedCount = function (apiClient) {
	return A3(
		$author$project$Api$Partner$EngagementEvent$list,
		apiClient,
		function (o) {
			return _Utils_update(
				o,
				{
					DV: $elm$core$Maybe$Just(0),
					Gy: $elm$core$Maybe$Just(0)
				});
		},
		$author$project$Pages$Partner$Engagements$GotInterestedCount);
};
var $author$project$Pages$Partner$Engagements$GotWaitlistedCount = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$EngagementEvent$JoinedWaitlist = 1;
var $author$project$Pages$Partner$Engagements$fetchWaitlistedCount = function (apiClient) {
	return A3(
		$author$project$Api$Partner$EngagementEvent$list,
		apiClient,
		function (o) {
			return _Utils_update(
				o,
				{
					DV: $elm$core$Maybe$Just(1),
					Gy: $elm$core$Maybe$Just(0)
				});
		},
		$author$project$Pages$Partner$Engagements$GotWaitlistedCount);
};
var $author$project$Pages$Partner$Engagements$fetchCountCmds = F2(
	function (apiClient, maybeListingStatus) {
		_v0$4:
		while (true) {
			if (!maybeListingStatus.$) {
				switch (maybeListingStatus.a) {
					case 3:
						var _v1 = maybeListingStatus.a;
						return _List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchInterestedCount(apiClient)
							]);
					case 2:
						var _v2 = maybeListingStatus.a;
						return _List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchInterestedCount(apiClient)
							]);
					case 4:
						var _v3 = maybeListingStatus.a;
						return _List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchWaitlistedCount(apiClient),
								$author$project$Pages$Partner$Engagements$fetchInstalledCount(apiClient)
							]);
					case 5:
						var _v4 = maybeListingStatus.a;
						return _List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchInstalledCount(apiClient)
							]);
					default:
						break _v0$4;
				}
			} else {
				break _v0$4;
			}
		}
		return _List_Nil;
	});
var $author$project$Pages$Partner$Engagements$GotEngagements = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Engagement$All$Engagement = $elm$core$Basics$identity;
var $author$project$Api$Partner$Engagement$All$Record = F5(
	function (id, practice, status, createdAt, betaAccessGranted) {
		return {JV: betaAccessGranted, Mf: createdAt, adR: id, WF: practice, ag7: status};
	});
var $author$project$Api$Partner$Engagement$All$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'beta_access_granted',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'practice',
					$author$project$Api$Partner$Practice$Min$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Partner$Engagement$All$Record)))))));
var $author$project$Api$Partner$Engagement$engagementsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['engagements']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString = function (status) {
	switch (status.$) {
		case 0:
			return 'waitlisted';
		case 1:
			return 'interested';
		case 2:
			return 'beta_access_granted';
		case 3:
			return 'attempt_install';
		case 4:
			return 'install_requested';
		default:
			var string = status.a;
			return string;
	}
};
var $author$project$Api$Partner$Engagement$listOptionsToParams = function (optionals) {
	var options = optionals(
		{afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, Hn: _List_Nil});
	var statusParams = function () {
		var _v0 = options.Hn;
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var statuses = _v0;
			return _List_fromArray(
				[
					A2(
					$author$project$Api$Param$list,
					'status',
					A2($elm$core$List$map, $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString, statuses))
				]);
		}
	}();
	return _Utils_ap(
		statusParams,
		_Utils_ap(
			$author$project$Api$Pagination$toApiParams(options.afy),
			$author$project$Api$Sort$toParams(options.ag1)));
};
var $author$project$Api$Partner$Engagement$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Engagement$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Engagement$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Engagement$engagementsPath)));
	});
var $author$project$Pages$Partner$Engagements$fetchEngagements = function (model) {
	return A3(
		$author$project$Api$Partner$Engagement$list,
		model.D5,
		function (o) {
			return _Utils_update(
				o,
				{afy: model.afy, ag1: model.ag1, Hn: model.cs});
		},
		$author$project$Pages$Partner$Engagements$GotEngagements);
};
var $author$project$Pages$Partner$Engagements$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.Bi;
		var statusFilter = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$String$split(','),
					$elm$core$List$filterMap($author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString)),
				A2($elm$core$Dict$get, 'status', query)));
		var sort = A3(
			$author$project$Api$Sort$withDefault,
			'created_at',
			1,
			$author$project$Api$Sort$initFromQuery(query));
		var pagination = $author$project$Api$Pagination$initFromQuery(query);
		var listingStatus = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Partner$PartnerProduct$Shared$status,
			$author$project$Api$Partner$Partner$One$product(partner));
		var initModel = {
			D5: shared.D5,
			b5: $author$project$Api$Data$Loading,
			qX: $author$project$Api$Data$NotAsked,
			q_: $author$project$Api$Data$NotAsked,
			SZ: listingStatus,
			afy: pagination,
			ag1: sort,
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'status-filter', ahx: $author$project$Pages$Partner$Engagements$StatusDropdownMsg})),
			cs: statusFilter,
			Hy: shared.Hy,
			DN: $author$project$Api$Data$NotAsked
		};
		var countCmds = A2($author$project$Pages$Partner$Engagements$fetchCountCmds, shared.D5, listingStatus);
		return _Utils_Tuple2(
			initModel,
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					$author$project$Pages$Partner$Engagements$fetchEngagements(initModel),
					countCmds)));
	});
var $author$project$Pages$Partner$Engagements$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Engagements$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Engagements$subscriptions = function (model) {
	return $author$project$Ui$NewDropdown$subscriptions(model.oA);
};
var $author$project$Pages$Partner$Engagements$AccessGranted = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Partner$Engagements$buildUrl = function (model) {
	var params = _Utils_ap(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$List$isEmpty(model.cs) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2(
						$elm$url$Url$Builder$string,
						'status',
						A2(
							$elm$core$String$join,
							',',
							A2($elm$core$List$map, $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString, model.cs))))
				])),
		_Utils_ap(
			$author$project$Api$Pagination$toPageQuery(model.afy),
			$author$project$Api$Sort$toQuery(model.ag1)));
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Engagements)
			]),
		params);
};
var $author$project$Api$Partner$Engagement$grantAccess = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Engagement$All$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						[id, 'grant_access']),
					$author$project$Api$Partner$Engagement$engagementsPath)));
	});
var $author$project$Api$Partner$Engagement$All$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Pages$Partner$Engagements$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				var pagination = function () {
					if (response.$ === 3) {
						var headers = response.b;
						return A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy);
					} else {
						return model.afy;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b5: response, afy: pagination}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				var engagement = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Partner$Engagement$grantAccess,
						model.D5,
						$author$project$Api$Partner$Engagement$All$id(engagement),
						$author$project$Pages$Partner$Engagements$AccessGranted(engagement)),
					_List_Nil);
			case 2:
				var engagement = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var updated = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b5: A2(
									$author$project$Api$Data$map,
									$elm$core$List$map(
										function (e) {
											return _Utils_eq(
												$author$project$Api$Partner$Engagement$All$id(e),
												$author$project$Api$Partner$Engagement$All$id(engagement)) ? updated : e;
										}),
									model.b5)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var status = msg.a;
				var newFilter = A2($elm$core$List$member, status, model.cs) ? A2(
					$elm$core$List$filter,
					$elm$core$Basics$neq(status),
					model.cs) : _Utils_ap(
					model.cs,
					_List_fromArray(
						[status]));
				var newModel = _Utils_update(
					model,
					{
						b5: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						cs: newFilter
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
								$author$project$Ports$Navigation$replaceUrl(
								$author$project$Pages$Partner$Engagements$buildUrl(newModel))
							])),
					_List_Nil);
			case 4:
				var dropdownMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.oA);
				var dropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 5:
				var paginationMsg = msg.a;
				var newModel = _Utils_update(
					model,
					{
						b5: $author$project$Api$Data$Loading,
						afy: A2($author$project$Api$Pagination$update, paginationMsg, model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
								$author$project$Ports$Navigation$replaceUrl(
								$author$project$Pages$Partner$Engagements$buildUrl(newModel))
							])),
					_List_Nil);
			case 7:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{q_: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{DN: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						b5: $author$project$Api$Data$Loading,
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
								$author$project$Ports$Navigation$replaceUrl(
								$author$project$Pages$Partner$Engagements$buildUrl(newModel))
							])),
					_List_Nil);
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qX: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Partner$Engagements$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Engagements$viewStatItem = F2(
	function (label, data) {
		var count = A2(
			$elm$core$Maybe$withDefault,
			'—',
			A2(
				$elm$core$Maybe$map,
				$elm$core$String$fromInt,
				$author$project$Api$Data$totalCount(data)));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Typography$heading(
					_List_fromArray(
						[
							$elm$html$Html$text(count)
						])),
					A2(
					$author$project$Ui$Typography$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Pages$Partner$Engagements$viewStatItems = function (items) {
	return $elm$core$List$isEmpty(items) ? $elm$html$Html$text('') : A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4]),
		items);
};
var $author$project$Pages$Partner$Engagements$viewStats = function (model) {
	var _v0 = model.SZ;
	_v0$4:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 3:
					var _v1 = _v0.a;
					return $author$project$Pages$Partner$Engagements$viewStatItems(
						_List_fromArray(
							[
								A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Interested', model.q_)
							]));
				case 2:
					var _v2 = _v0.a;
					return $author$project$Pages$Partner$Engagements$viewStatItems(
						_List_fromArray(
							[
								A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Interested', model.q_)
							]));
				case 4:
					var _v3 = _v0.a;
					return $author$project$Pages$Partner$Engagements$viewStatItems(
						_List_fromArray(
							[
								A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Waitlisted', model.DN),
								A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Installed', model.qX)
							]));
				case 5:
					var _v4 = _v0.a;
					return $author$project$Pages$Partner$Engagements$viewStatItems(
						_List_fromArray(
							[
								A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Installed', model.qX)
							]));
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return $elm$html$Html$text('');
};
var $author$project$Pages$Partner$Engagements$isLiveOrAbove = function (maybeStatus) {
	_v0$4:
	while (true) {
		if (!maybeStatus.$) {
			switch (maybeStatus.a) {
				case 5:
					var _v1 = maybeStatus.a;
					return true;
				case 6:
					var _v2 = maybeStatus.a;
					return true;
				case 7:
					var _v3 = maybeStatus.a;
					return true;
				case 8:
					var _v4 = maybeStatus.a;
					return true;
				default:
					break _v0$4;
			}
		} else {
			break _v0$4;
		}
	}
	return false;
};
var $author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel = function (status) {
	switch (status.$) {
		case 0:
			return 'Waitlisted';
		case 1:
			return 'Interest Expressed';
		case 2:
			return 'Beta Access Granted';
		case 3:
			return 'Install Attempted';
		case 4:
			return 'Install Requested';
		default:
			var string = status.a;
			return string;
	}
};
var $author$project$Pages$Partner$Engagements$ToggleStatusFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Engagements$viewStatusFilterItem = F2(
	function (activeStatuses, status) {
		return A2(
			$author$project$Ui$NewDropdown$checkbox,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$checked(
					A2($elm$core$List$member, status, activeStatuses)),
					$author$project$Ui$NewDropdown$onCheck(
					function (_v0) {
						return $author$project$Pages$Partner$Engagements$ToggleStatusFilter(status);
					}),
					$author$project$Ui$NewDropdown$onSelectKeepOpen
				]),
			$elm$html$Html$text(
				$author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel(status)));
	});
var $author$project$Pages$Partner$Engagements$viewStatusFilter = function (model) {
	var triggerLabel = function () {
		var _v0 = model.cs;
		if (!_v0.b) {
			return 'Status';
		} else {
			var statuses = _v0;
			return A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel, statuses));
		}
	}();
	var availableStatuses = $author$project$Pages$Partner$Engagements$isLiveOrAbove(model.SZ) ? _List_fromArray(
		[$author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted, $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested]) : _List_fromArray(
		[$author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted, $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested, $author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted]);
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(triggerLabel)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Partner$Engagements$viewStatusFilterItem(model.cs),
			availableStatuses),
		model.oA);
};
var $author$project$Pages$Partner$Engagements$SortTable = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Engagements$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'practice', true, 'Practice'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'created_at', true, 'First Engaged'),
		A3($author$project$Api$Column$init, '', false, 'Beta Access'),
		A3($author$project$Api$Column$init, '', false, '')
	]);
var $author$project$Pages$Partner$Engagements$GrantAccess = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Engagement$All$betaAccessGranted = function (_v0) {
	var record = _v0;
	return record.JV;
};
var $author$project$Api$Partner$Engagement$All$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Partner$Engagement$All$practice = function (_v0) {
	var record = _v0;
	return record.WF;
};
var $author$project$Api$Partner$Engagement$All$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Pages$Partner$Engagements$viewRow = F3(
	function (showBetaColumns, timeFormatter, engagement) {
		var baseCells = _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Partner$Practice$Min$name(
							$author$project$Api$Partner$Engagement$All$practice(engagement)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Badge$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel(
									$author$project$Api$Partner$Engagement$All$status(engagement)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							timeFormatter,
							5,
							$author$project$Api$Partner$Engagement$All$createdAt(engagement)))
					]))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_Utils_ap(
				baseCells,
				showBetaColumns ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Api$Partner$Engagement$All$betaAccessGranted(engagement) ? A2(
								$author$project$Ui$Badge$view,
								_List_fromArray(
									[$author$project$Ui$Badge$success]),
								_List_fromArray(
									[
										$elm$html$Html$text('Granted')
									])) : $elm$html$Html$text('')
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								(!$author$project$Api$Partner$Engagement$All$betaAccessGranted(engagement)) ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$justifyRight]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Grant access'},
										_List_fromArray(
											[
												$author$project$Ui$Button$default,
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Partner$Engagements$GrantAccess(engagement))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Grant access')
											]))
									])) : $elm$html$Html$text('')
							]))
					]) : _List_Nil));
	});
var $author$project$Pages$Partner$Engagements$viewTable = function (model) {
	var showBetaColumns = !$author$project$Pages$Partner$Engagements$isLiveOrAbove(model.SZ);
	var visibleColumns = showBetaColumns ? $author$project$Pages$Partner$Engagements$columns : A2($elm$core$List$take, 3, $author$project$Pages$Partner$Engagements$columns);
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				_Utils_eq(model.b5, $author$project$Api$Data$Loading))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view(
				A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Partner$Engagements$SortTable)),
			visibleColumns),
		A2(
			$elm$core$List$map,
			A2($author$project$Pages$Partner$Engagements$viewRow, showBetaColumns, model.Hy),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Api$Data$toMaybe(model.b5))),
		_List_Nil);
};
var $author$project$Pages$Partner$Engagements$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mb4]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Engagements')
										]))
								])),
							$author$project$Pages$Partner$Engagements$viewStats(model),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4)
										]),
									_List_fromArray(
										[
											$author$project$Pages$Partner$Engagements$viewStatusFilter(model)
										]))
								]))
						])),
					$author$project$Pages$Partner$Engagements$viewTable(model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$Partner$Engagements$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(
										_Utils_eq(model.b5, $author$project$Api$Data$Loading))
									]),
								model.afy))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$Engagements$view = function (model) {
	return {
		e5: $author$project$Pages$Partner$Engagements$viewBody(model),
		$G: 'Partner | Engagements'
	};
};
var $author$project$Pages$Partner$Engagements$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Engagements$init, aer: $author$project$Pages$Partner$Engagements$load, agD: $author$project$Pages$Partner$Engagements$save, ahd: $author$project$Pages$Partner$Engagements$subscriptions, aaq: $author$project$Pages$Partner$Engagements$update, ahP: $author$project$Pages$Partner$Engagements$view});
var $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Hinter$PartnerFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$Model = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$Shared$active = function (_v0) {
	var record = _v0;
	return record.Ic;
};
var $author$project$Api$Partner$Partner$One$active = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$active(shared);
};
var $author$project$Api$Partner$Partner$Shared$practicesReadOnly = function (_v0) {
	var record = _v0;
	return record.WN;
};
var $author$project$Api$Partner$Partner$One$practicesReadOnly = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$practicesReadOnly(shared);
};
var $author$project$Components$Hinter$EditPartnerForm$initFormFields = function (partner) {
	return _Utils_Tuple2(
		{
			Ic: $author$project$Api$Partner$Partner$One$active(partner),
			WN: $author$project$Api$Partner$Partner$One$practicesReadOnly(partner),
			Y0: $author$project$Api$Partner$Partner$One$sandboxEnabled(partner)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Hinter$EditPartnerForm$init = function (partner) {
	var _v0 = $author$project$Components$Hinter$EditPartnerForm$initFormFields(partner);
	var formFields = _v0.a;
	var formFieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			PB: $author$project$Utils$Form$init(formFields),
			o$: $author$project$Api$Data$NotAsked
		},
		formFieldsCmd);
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$AdminSettings$ManagedByForm$init = F2(
	function (_v0, partner) {
		return {aG: $elm$core$Maybe$Nothing, Vz: partner};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$init = function (partner) {
	return _Utils_Tuple2(
		{a_: $elm$core$Maybe$Nothing, a$: $elm$core$Maybe$Nothing, a0: $elm$core$Maybe$Nothing, a1: $elm$core$Maybe$Nothing, Vz: partner},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Partner$Hinter$init = F4(
	function (_v0, partner, shared, _v1) {
		var managedByForm = A2($author$project$Components$Partner$AdminSettings$ManagedByForm$init, shared.D5, partner);
		var _v2 = $author$project$Components$Hinter$EditPartnerForm$init(partner);
		var partnerForm = _v2.a;
		var partnerFormCmd = _v2.b;
		var _v3 = $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$init(partner);
		var partnerDocumentsForm = _v3.a;
		var partnerDocumentsFormCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, i7: managedByForm, Vz: partner, jm: partnerDocumentsForm, ba: partnerForm, j5: false},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerFormMsg, partnerFormCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, partnerDocumentsFormCmd)
					])));
	});
var $author$project$Pages$Partner$Hinter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Hinter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Hinter$ArchiveConfirmClosed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Hinter$ManagedByFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy = {$: 2};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.aG;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var managedByInput = _v2.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg,
						$author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions(managedByInput));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy)),
					model.aG))
			]));
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit = {$: 4};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)),
					model.a1)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)),
					model.a_)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)),
					model.a$)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)),
					model.a0))
			]));
};
var $author$project$Pages$Partner$Hinter$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Hinter$PartnerFormMsg,
				$author$project$Components$Hinter$EditPartnerForm$subscriptions(model.ba)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Hinter$ManagedByFormMsg,
				$author$project$Components$Partner$AdminSettings$ManagedByForm$subscriptions(model.i7)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg,
				$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$subscriptions(model.jm)),
				model.j5 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Partner$Hinter$ArchiveConfirmClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$Partner$Hinter$PartnerArchived = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$Partner$archive = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['archive']),
					$author$project$Api$Partner$Partner$partnerPath)));
	});
var $author$project$Components$Hinter$EditPartnerForm$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{WN: bool});
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ic: bool});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Y0: bool});
		}
	});
var $author$project$Components$Hinter$EditPartnerForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$Hinter$EditPartnerForm$toPermittedFields = function (fields) {
	return _List_fromArray(
		[
			$author$project$Api$Partner$Partner$Active(fields.Ic),
			$author$project$Api$Partner$Partner$PracticesReadOnly(fields.WN),
			$author$project$Api$Partner$Partner$SandboxEnabled(fields.Y0)
		]);
};
var $author$project$Components$Hinter$EditPartnerForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Hinter$EditPartnerForm$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$EditPartnerForm$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validFormFields = _v3.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: $author$project$Api$Data$Loading}),
						A3(
							$author$project$Api$Partner$Partner$update,
							apiClient,
							$author$project$Components$Hinter$EditPartnerForm$toPermittedFields(fields),
							$author$project$Components$Hinter$EditPartnerForm$GotUpdatedPartner),
						_List_Nil);
				} else {
					var updatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: updatedForm, o$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByManagementGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedBySaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$ManagementGroup$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v2 = model.aG;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var managedByInput = _v3.a;
					var request = _v3.b;
					var _v4 = A3($author$project$Components$Partner$AdminSettings$ManagedByInput$update, apiClient, subMsg, managedByInput);
					var newManagedByInput = _v4.a;
					var managedByInputCmd = _v4.b;
					var outMsgs = _v4.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aG: $elm$core$Maybe$Just(
									_Utils_Tuple2(newManagedByInput, request))
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg, managedByInputCmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var initialValue = A2(
					$elm$core$Maybe$map,
					function (managedBy) {
						if (!managedBy.$) {
							var practice = managedBy.a;
							return $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice(
								$author$project$Api$Partner$Practice$Min$id(practice));
						} else {
							var managementGroup = managedBy.a;
							return $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByManagementGroup(
								$author$project$Api$Partner$ManagementGroup$Min$id(managementGroup));
						}
					},
					$author$project$Api$Partner$Partner$One$managedBy(model.Vz));
				var _v5 = A2($author$project$Components$Partner$AdminSettings$ManagedByInput$init, apiClient, initialValue);
				var managedByInput = _v5.a;
				var managedByInputCmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aG: $elm$core$Maybe$Just(
								_Utils_Tuple2(managedByInput, $author$project$Api$Data$NotAsked))
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg, managedByInputCmd),
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aG: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var _v7 = model.aG;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var managedByInput = _v8.a;
					var managedByValue = A2(
						$elm$core$Maybe$map,
						function (v) {
							if (!v.$) {
								var practiceId = v.a;
								return $author$project$Api$Partner$Partner$ManagedByPractice(practiceId);
							} else {
								var managementGroupId = v.a;
								return $author$project$Api$Partner$Partner$ManagedByManagementGroup(managementGroupId);
							}
						},
						$author$project$Components$Partner$AdminSettings$ManagedByInput$value(managedByInput));
					var permittedFields = _List_fromArray(
						[
							$author$project$Api$Partner$Partner$ManagedBy(managedByValue)
						]);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aG: $elm$core$Maybe$Just(
									_Utils_Tuple2(managedByInput, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedBySaved),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				var _v10 = model.aG;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var managedByInput = _v11.a;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aG: $elm$core$Maybe$Nothing, Vz: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aG: $elm$core$Maybe$Just(
										_Utils_Tuple2(managedByInput, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Api$Partner$Partner$AddendumAgreement = function (a) {
	return {$: 31, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementProcessed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementSaved = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$Partner$CustomApiAccessAgreement = function (a) {
	return {$: 32, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementProcessed = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementSaved = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$Partner$CustomBaaAgreement = function (a) {
	return {$: 33, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementProcessed = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementSaved = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Partner$Partner$CustomPartnerAgreement = function (a) {
	return {$: 30, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementProcessed = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementSaved = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotAddendumAgreementUrl = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomApiAccessAgreementUrl = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomBaaAgreementUrl = function (a) {
	return {$: 28, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomPartnerAgreementUrl = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation = F2(
	function (addendumAgreementType, fileSizeAndUrl) {
		if (addendumAgreementType === 1) {
			if (!fileSizeAndUrl.$) {
				var _v2 = fileSizeAndUrl.a;
				var fileSize = _v2.a;
				return (_Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0) ? _List_fromArray(
					['That file is too large! Our maximum file size is 5 mb.']) : _List_Nil;
			} else {
				return _List_fromArray(
					['Please upload a file']);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidAddendumAgreement = F2(
	function (addendumAgreementType, fileSizeAndUrl) {
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation, addendumAgreementType, fileSizeAndUrl));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation = F2(
	function (customApiAccessAgreementType, fileSizeAndUrl) {
		if (customApiAccessAgreementType === 1) {
			if (!fileSizeAndUrl.$) {
				var _v2 = fileSizeAndUrl.a;
				var fileSize = _v2.a;
				return (_Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0) ? _List_fromArray(
					['That file is too large! Our maximum file size is 5 mb.']) : _List_Nil;
			} else {
				return _List_fromArray(
					['Please upload a file']);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomApiAccessAgreement = F2(
	function (customApiAccessAgreementType, fileSizeAndUrl) {
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation, customApiAccessAgreementType, fileSizeAndUrl));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation = F2(
	function (customBaaAgreementType, fileSizeAndUrl) {
		if (customBaaAgreementType === 1) {
			if (!fileSizeAndUrl.$) {
				var _v2 = fileSizeAndUrl.a;
				var fileSize = _v2.a;
				return (_Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0) ? _List_fromArray(
					['That file is too large! Our maximum file size is 5 mb.']) : _List_Nil;
			} else {
				return _List_fromArray(
					['Please upload a file']);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomBaaAgreement = F2(
	function (customBaaAgreementType, fileSizeAndUrl) {
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation, customBaaAgreementType, fileSizeAndUrl));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation = F2(
	function (customPartnerAgreementType, fileSizeAndUrl) {
		if (customPartnerAgreementType === 1) {
			if (!fileSizeAndUrl.$) {
				var _v2 = fileSizeAndUrl.a;
				var fileSize = _v2.a;
				return (_Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0) ? _List_fromArray(
					['That file is too large! Our maximum file size is 5 mb.']) : _List_Nil;
			} else {
				return _List_fromArray(
					['Please upload a file']);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomPartnerAgreement = F2(
	function (customPartnerAgreementType, fileSizeAndUrl) {
		return $elm$core$List$isEmpty(
			A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation, customPartnerAgreementType, fileSizeAndUrl));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var customPartnerAgreementType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a1: $elm$core$Maybe$Just(
								_Utils_Tuple3(customPartnerAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var addendumAgreementType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a_: $elm$core$Maybe$Just(
								_Utils_Tuple3(addendumAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var customApiAccessAgreementType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a$: $elm$core$Maybe$Just(
								_Utils_Tuple3(customApiAccessAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var customBaaAgreementType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a0: $elm$core$Maybe$Just(
								_Utils_Tuple3(customBaaAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a_: $elm$core$Maybe$Nothing, a$: $elm$core$Maybe$Nothing, a0: $elm$core$Maybe$Nothing, a1: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v2 = model.a1;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var customPartnerAgreementType = _v3.a;
					var fileSizeAndUrl = _v3.b;
					if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomPartnerAgreement, customPartnerAgreementType, fileSizeAndUrl)) {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$Partner$CustomPartnerAgreement(
								function () {
									if (customPartnerAgreementType === 1) {
										return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}())
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a1: $elm$core$Maybe$Just(
										_Utils_Tuple3(customPartnerAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var _v5 = model.a_;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var addendumAgreementType = _v6.a;
					var fileSizeAndUrl = _v6.b;
					if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidAddendumAgreement, addendumAgreementType, fileSizeAndUrl)) {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$Partner$AddendumAgreement(
								function () {
									if (addendumAgreementType === 1) {
										return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}())
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a_: $elm$core$Maybe$Just(
										_Utils_Tuple3(addendumAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var _v8 = model.a$;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var customApiAccessAgreementType = _v9.a;
					var fileSizeAndUrl = _v9.b;
					if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomApiAccessAgreement, customApiAccessAgreementType, fileSizeAndUrl)) {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$Partner$CustomApiAccessAgreement(
								function () {
									if (customApiAccessAgreementType === 1) {
										return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}())
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a$: $elm$core$Maybe$Just(
										_Utils_Tuple3(customApiAccessAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var _v11 = model.a0;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var customBaaAgreementType = _v12.a;
					var fileSizeAndUrl = _v12.b;
					if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomBaaAgreement, customBaaAgreementType, fileSizeAndUrl)) {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$Partner$CustomBaaAgreement(
								function () {
									if (customBaaAgreementType === 1) {
										return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}())
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a0: $elm$core$Maybe$Just(
										_Utils_Tuple3(customBaaAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
								}),
							A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementSaved),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v14 = model.a1;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var customPartnerAgreementType = _v15.a;
					var customPartnerAgreementFile = _v15.b;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a1: $elm$core$Maybe$Nothing, Vz: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a1: $elm$core$Maybe$Just(
										_Utils_Tuple3(customPartnerAgreementType, customPartnerAgreementFile, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				var _v17 = model.a_;
				if (!_v17.$) {
					var _v18 = _v17.a;
					var addendumAgreementType = _v18.a;
					var addendumAgreementFile = _v18.b;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a_: $elm$core$Maybe$Nothing, Vz: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a_: $elm$core$Maybe$Just(
										_Utils_Tuple3(addendumAgreementType, addendumAgreementFile, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var response = msg.a;
				var _v20 = model.a$;
				if (!_v20.$) {
					var _v21 = _v20.a;
					var customApiAccessAgreementType = _v21.a;
					var customApiAccessAgreementFile = _v21.b;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a$: $elm$core$Maybe$Nothing, Vz: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a$: $elm$core$Maybe$Just(
										_Utils_Tuple3(customApiAccessAgreementType, customApiAccessAgreementFile, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var response = msg.a;
				var _v23 = model.a0;
				if (!_v23.$) {
					var _v24 = _v23.a;
					var customBaaAgreementType = _v24.a;
					var customBaaAgreementFile = _v24.b;
					if (response.$ === 3) {
						var partner = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{a0: $elm$core$Maybe$Nothing, Vz: partner}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
									$author$project$OutMsg$RefreshPartner
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a0: $elm$core$Maybe$Just(
										_Utils_Tuple3(customBaaAgreementType, customBaaAgreementFile, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v26) {
							var task = _v26.a;
							var size = _v26.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementProcessed(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 14:
				var size = msg.a;
				var url = msg.b;
				var _v27 = model.a1;
				if (!_v27.$) {
					var _v28 = _v27.a;
					var customPartnerAgreementType = _v28.a;
					var request = _v28.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a1: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										customPartnerAgreementType,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(size, url)),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v29) {
							var task = _v29.a;
							var size = _v29.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementProcessed(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 16:
				var size = msg.a;
				var url = msg.b;
				var _v30 = model.a_;
				if (!_v30.$) {
					var _v31 = _v30.a;
					var addendumAgreementType = _v31.a;
					var request = _v31.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a_: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										addendumAgreementType,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(size, url)),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 17:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v32) {
							var task = _v32.a;
							var size = _v32.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementProcessed(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 18:
				var size = msg.a;
				var url = msg.b;
				var _v33 = model.a$;
				if (!_v33.$) {
					var _v34 = _v33.a;
					var customApiAccessAgreementType = _v34.a;
					var request = _v34.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a$: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										customApiAccessAgreementType,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(size, url)),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v35) {
							var task = _v35.a;
							var size = _v35.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementProcessed(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 20:
				var size = msg.a;
				var url = msg.b;
				var _v36 = model.a0;
				if (!_v36.$) {
					var _v37 = _v36.a;
					var customBaaAgreementType = _v37.a;
					var request = _v37.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a0: $elm$core$Maybe$Just(
									_Utils_Tuple3(
										customBaaAgreementType,
										$elm$core$Maybe$Just(
											_Utils_Tuple2(size, url)),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 21:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomPartnerAgreementUrl),
					_List_Nil);
			case 22:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 23:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Partner$signedAddendumAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotAddendumAgreementUrl),
					_List_Nil);
			case 24:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 25:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomApiAccessAgreementUrl),
					_List_Nil);
			case 26:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 27:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomBaaAgreementUrl),
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navigation$openInNewWindow(url),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Hinter$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Hinter$EditPartnerForm$update, model.D5, subMsg, model.ba);
				var partnerForm = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ba: partnerForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerFormMsg, cmd),
					outMsgs);
			case 1:
				var subMsg = msg.a;
				var _v2 = A3($author$project$Components$Partner$AdminSettings$ManagedByForm$update, model.D5, subMsg, model.i7);
				var managedByForm = _v2.a;
				var managedByFormCmd = _v2.b;
				var managedByForOutMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i7: managedByForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$ManagedByFormMsg, managedByFormCmd),
					managedByForOutMsgs);
			case 2:
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$update, model.D5, subMsg, model.jm);
				var partnerDocumentsForm = _v3.a;
				var partnerDocumentsFormCmd = _v3.b;
				var partnerDocumentsFormOutMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jm: partnerDocumentsForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, partnerDocumentsFormCmd),
					partnerDocumentsFormOutMsgs);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j5: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{j5: false}),
					A2($author$project$Api$Partner$Partner$archive, model.D5, $author$project$Pages$Partner$Hinter$PartnerArchived),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{j5: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Vz: partner}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[$author$project$OutMsg$RefreshPartner]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Components$Partner$AdminSettings$ManagedByForm$SaveManagedBy = {$: 3};
var $author$project$Api$Partner$Partner$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Partner$Partner$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$id(shared);
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$viewEditManagedByModal = F3(
	function (managedByInput, request, model) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Managed By',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.Vz)),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy,
			U0: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$ManagedByForm$SaveManagedBy)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg,
					$author$project$Components$Partner$AdminSettings$ManagedByInput$view(managedByInput))
				]));
	});
var $author$project$Components$Partner$AdminSettings$ManagedByForm$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.aG;
	if (!_v1.$) {
		var _v2 = _v1.a;
		var managedByInput = _v2.a;
		var request = _v2.b;
		return A3($author$project$Components$Partner$AdminSettings$ManagedByForm$viewEditManagedByModal, managedByInput, request, model);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementTypePdf = 1;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementUploaded = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveAddendumAgreement = {$: 6};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton = F3(
	function (currentAddendumAgreementType, addendumAgreementType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentAddendumAgreementType, addendumAgreementType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement(addendumAgreementType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditAddendumAgreementModal = F4(
	function (addendumAgreementType, fileSizeAndUrl, request, model) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Addendum Agreement',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.Vz)),
			Tw: $elm$core$Maybe$Just('Updating the addendum agreement will remove the acceptance of the addendum agreement.'),
			U_: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
			U0: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveAddendumAgreement)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Addendum Agreement')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton, addendumAgreementType, 0, 'None'),
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton, addendumAgreementType, 1, 'PDF')
								]))
						])),
					function () {
					if (addendumAgreementType === 1) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('PDF')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(2),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementUploaded)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation, addendumAgreementType, fileSizeAndUrl))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementTypePdf = 1;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementUploaded = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomApiAccessAgreement = {$: 7};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton = F3(
	function (currentCustomApiAccessAgreementType, customApiAccessAgreementType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCustomApiAccessAgreementType, customApiAccessAgreementType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement(customApiAccessAgreementType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomApiAccessAgreementModal = F4(
	function (customApiAccessAgreementType, fileSizeAndUrl, request, model) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Custom Api Access Agreement',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.Vz)),
			Tw: $elm$core$Maybe$Just('Updating the custom api access agreement will remove the acceptance of the api access agreement.'),
			U_: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
			U0: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomApiAccessAgreement)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Custom Api Access Agreement')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton, customApiAccessAgreementType, 0, 'None'),
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton, customApiAccessAgreementType, 1, 'PDF')
								]))
						])),
					function () {
					if (customApiAccessAgreementType === 1) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('PDF')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(2),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementUploaded)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation, customApiAccessAgreementType, fileSizeAndUrl))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementTypePdf = 1;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementUploaded = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomBaaAgreement = {$: 8};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton = F3(
	function (currentCustomBaaAgreementType, customBaaAgreementType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCustomBaaAgreementType, customBaaAgreementType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement(customBaaAgreementType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomBaaAgreementModal = F4(
	function (customBaaAgreementType, fileSizeAndUrl, request, model) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Custom BAA Agreement',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.Vz)),
			Tw: $elm$core$Maybe$Just('Updating the custom BAA agreement will remove the acceptance of the BAA agreement.'),
			U_: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
			U0: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomBaaAgreement)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Custom BAA Agreement')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton, customBaaAgreementType, 0, 'None'),
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton, customBaaAgreementType, 1, 'PDF')
								]))
						])),
					function () {
					if (customBaaAgreementType === 1) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('PDF')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(2),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementUploaded)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation, customBaaAgreementType, fileSizeAndUrl))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementTypeNone = 0;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementTypePdf = 1;
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementUploaded = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomPartnerAgreement = {$: 5};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton = F3(
	function (currentCustomPartnerAgreementType, customPartnerAgreementType, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentCustomPartnerAgreementType, customPartnerAgreementType)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement(customPartnerAgreementType))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomPartnerAgreementModal = F4(
	function (customPartnerAgreementType, fileSizeAndUrl, request, model) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Custom Partner Agreement',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Just(
				$author$project$Api$Partner$Partner$One$id(model.Vz)),
			Tw: $elm$core$Maybe$Just('Updating the custom partner agreement will remove the acceptance of the partner agreement.'),
			U_: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
			U0: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomPartnerAgreement)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Custom Partner Agreement')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton, customPartnerAgreementType, 0, 'None'),
									A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton, customPartnerAgreementType, 1, 'PDF')
								]))
						])),
					function () {
					if (customPartnerAgreementType === 1) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('PDF')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$File$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$File$accept(2),
											$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementUploaded)
										])),
									$author$project$Utils$FormErrors$view(
									A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation, customPartnerAgreementType, fileSizeAndUrl))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$modal = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.a1;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var customPartnerAgreementType = _v2.a;
					var fileSizeAndUrl = _v2.b;
					var request = _v2.c;
					return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomPartnerAgreementModal, customPartnerAgreementType, fileSizeAndUrl, request, model);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.a_;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var addendumAgreementType = _v4.a;
					var fileSizeAndUrl = _v4.b;
					var request = _v4.c;
					return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditAddendumAgreementModal, addendumAgreementType, fileSizeAndUrl, request, model);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v5 = model.a$;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var customApiAccessAgreementType = _v6.a;
					var fileSizeAndUrl = _v6.b;
					var request = _v6.c;
					return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomApiAccessAgreementModal, customApiAccessAgreementType, fileSizeAndUrl, request, model);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v7 = model.a0;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var customBaaAgreementType = _v8.a;
					var fileSizeAndUrl = _v8.b;
					var request = _v8.c;
					return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomBaaAgreementModal, customBaaAgreementType, fileSizeAndUrl, request, model);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Hinter$EditPartnerForm$Active = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$PracticesReadOnly = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$SandboxEnabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$EditPartnerForm$Save = {$: 1};
var $author$project$Components$Hinter$EditPartnerForm$view = function (_v0) {
	var model = _v0;
	var loading = _Utils_eq(model.o$, $author$project$Api$Data$Loading);
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Live API Enabled')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.Ic),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$Active))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Sandbox Enabled')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.Y0),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$SandboxEnabled))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Practices Read Only')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.WN),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$PracticesReadOnly))
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Save partner changes'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(loading),
								$author$project$Ui$Button$onClick($author$project$Components$Hinter$EditPartnerForm$Save)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$EditManagedBy = {$: 1};
var $author$project$Api$Partner$ManagementGroup$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$Partner$AdminSettings$ManagedByForm$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('Managed By')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								function () {
								var _v1 = $author$project$Api$Partner$Partner$One$managedBy(model.Vz);
								if (!_v1.$) {
									if (!_v1.a.$) {
										var practice = _v1.a.a;
										return $elm$html$Html$text(
											$author$project$Api$Partner$Practice$Min$name(practice) + (' (' + ($author$project$Api$Partner$Practice$Min$id(practice) + ')')));
									} else {
										var managementGroup = _v1.a.a;
										return $elm$html$Html$text(
											$author$project$Api$Partner$ManagementGroup$Min$name(managementGroup) + (' (' + ($author$project$Api$Partner$ManagementGroup$Min$id(managementGroup) + ')')));
									}
								} else {
									return $elm$html$Html$text('None');
								}
							}(),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Change managed by'},
								_List_fromArray(
									[
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$ManagedByForm$EditManagedBy)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Change')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenAddendumAgreement = {$: 23};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomApiAccessAgreement = {$: 25};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomBaaAgreement = {$: 27};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomPartnerAgreement = {$: 21};
var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$view = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Custom Partner Agreement')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v1 = $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName(model.Vz);
										if (!_v1.$) {
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'View custom partner agreement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomPartnerAgreement)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View custom partner agreement')
													]));
										} else {
											return $elm$html$Html$text('None');
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Manage custom partner agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Addendum Agreement')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v2 = $author$project$Api$Partner$Partner$One$addendumAgreementFileName(model.Vz);
										if (!_v2.$) {
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'View addendum agreement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenAddendumAgreement)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View addendum agreement')
													]));
										} else {
											return $elm$html$Html$text('None');
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Manage addendum agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Custom Api Access Agreement')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v3 = $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName(model.Vz);
										if (!_v3.$) {
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'View custom api access agreement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomApiAccessAgreement)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View custom api access agreement')
													]));
										} else {
											return $elm$html$Html$text('None');
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Manage custom api access agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Custom BAA Agreement')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v4 = $author$project$Api$Partner$Partner$One$customBaaAgreementFileName(model.Vz);
										if (!_v4.$) {
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'View custom BAA agreement'},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomBaaAgreement)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('View custom BAA agreement')
													]));
										} else {
											return $elm$html$Html$text('None');
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Manage custom BAA agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manage')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Hinter$ArchiveClicked = {$: 3};
var $author$project$Api$Partner$Partner$Shared$archived = function (_v0) {
	var record = _v0;
	return record.Jn;
};
var $author$project$Api$Partner$Partner$One$archived = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$archived(shared);
};
var $author$project$Pages$Partner$Hinter$viewArchive = function (partner) {
	return $author$project$Api$Partner$Partner$One$archived(partner) ? $elm$html$Html$text('') : A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Archive')
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						$elm$html$Html$text('Archive this partner account. This will decommission all products, revoke api keys, deactivate integrations and remove access entirely.')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Archive Partner'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick($author$project$Pages$Partner$Hinter$ArchiveClicked)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Archive')
					]))
			]));
};
var $author$project$Pages$Partner$Hinter$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				model.j5 ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Partner$Hinter$ArchiveConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('archive'),
						$author$project$Components$HiConfirm$noun('partner')
					])) : $elm$html$Html$text(''),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Hinter$ManagedByFormMsg,
				$author$project$Components$Partner$AdminSettings$ManagedByForm$modal(model.i7)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg,
				$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$modal(model.jm)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Admin Actions')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Hinter$PartnerFormMsg,
								$author$project$Components$Hinter$EditPartnerForm$view(model.ba)),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Hinter$ManagedByFormMsg,
								$author$project$Components$Partner$AdminSettings$ManagedByForm$view(model.i7)),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg,
								$author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$view(model.jm)),
								$author$project$Pages$Partner$Hinter$viewArchive(model.Vz)
							]))
					]))
			]),
		$G: 'Partner | Admin Settings'
	};
};
var $author$project$Pages$Partner$Hinter$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Hinter$init, aer: $author$project$Pages$Partner$Hinter$load, agD: $author$project$Pages$Partner$Hinter$save, ahd: $author$project$Pages$Partner$Hinter$subscriptions, aaq: $author$project$Pages$Partner$Hinter$update, ahP: $author$project$Pages$Partner$Hinter$view});
var $author$project$Pages$Partner$Practices$Top$GotIntegrations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Practices$Top$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{afy: model.afy, af_: model.af_, ag1: model.ag1});
	};
};
var $author$project$Pages$Partner$Practices$Top$fetchIntegrations = function (model) {
	return A3(
		$author$project$Api$Partner$Integration$list,
		model.D5,
		$author$project$Pages$Partner$Practices$Top$fetchParams(model),
		$author$project$Pages$Partner$Practices$Top$GotIntegrations);
};
var $author$project$Pages$Partner$Practices$Top$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.Bi;
		var model = {
			bH: $elm$core$Maybe$Nothing,
			bJ: $elm$core$Maybe$Nothing,
			D5: shared.D5,
			Ra: $author$project$Api$Data$Loading,
			FR: $author$project$Shared$isHintAdmin(shared),
			afy: $author$project$Api$Pagination$initFromQuery(query),
			Vz: partner,
			af_: A2($elm$core$Dict$get, 'q', query),
			sA: $author$project$Ui$SearchInput$init(
				A2($elm$core$Dict$get, 'q', query)),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'status',
				1,
				$author$project$Api$Sort$initFromQuery(query))
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Partner$Practices$Top$fetchIntegrations(model));
	});
var $author$project$Pages$Partner$Practices$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Practices$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Practices$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Practices$Top$IntegrationActivated = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Pages$Partner$Practices$Top$IntegrationCreated = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Pages$Partner$Practices$Top$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$Integration$One$Integration = 0;
var $author$project$Api$Partner$Integration$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$Integration$integrationPath = function (integrationId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[integrationId]),
		$author$project$Api$Partner$Integration$integrationsPath);
};
var $author$project$Api$Partner$Integration$activate = F4(
	function (apiClient, integrationId, code, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'code',
					$elm$json$Json$Encode$string(code))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Integration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['activate']),
						$author$project$Api$Partner$Integration$integrationPath(integrationId)))));
	});
var $author$project$Api$Partner$Integration$create = F3(
	function (apiClient, practiceId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'integration',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'practice',
								$author$project$Utils$Encode$association(practiceId))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Integration$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$integrationsPath)));
	});
var $author$project$Pages$Partner$Practices$Top$updateUrl = function (model) {
	var params = _Utils_ap(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$elm$url$Url$Builder$string('q'),
					model.af_)
				])),
		_Utils_ap(
			$author$project$Api$Sort$toQuery(model.ag1),
			$author$project$Api$Pagination$toPageQuery(model.afy)));
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Practices__Top)
				]),
			params));
};
var $author$project$Pages$Partner$Practices$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Ra: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ra: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{Ra: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
								$author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Ra: $author$project$Api$Data$Loading,
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
								$author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v2.a;
				var searchInputCmd = _v2.b;
				var searchInputEvent = _v2.c;
				if (searchInputEvent.$ === 1) {
					var q = searchInputEvent.a;
					var newModel = _Utils_update(
						model,
						{
							Ra: $author$project$Api$Data$Loading,
							afy: $author$project$Api$Pagination$reset(model.afy),
							af_: q,
							sA: searchInput
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Practices$Top$SearchInputMsg, searchInputCmd),
									$author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
									$author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sA: searchInput}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Practices$Top$SearchInputMsg, searchInputCmd),
						_List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bJ: $elm$core$Maybe$Just(
								_Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bJ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var _v4 = model.bJ;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var practiceId = _v5.a;
					if (!practiceId.$) {
						var practiceId_ = practiceId.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bJ: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$elm$core$Maybe$Just(practiceId_),
											$author$project$Api$Data$Loading))
								}),
							A3(
								$author$project$Api$Partner$Integration$create,
								model.D5,
								practiceId_,
								$author$project$Pages$Partner$Practices$Top$IntegrationCreated(practiceId_)),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var practiceId = msg.a;
				var _v7 = model.bJ;
				if (!_v7.$) {
					var _v8 = _v7.a;
					var request = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bJ: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(practiceId),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var practiceId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bJ: $elm$core$Maybe$Nothing, Ra: $author$project$Api$Data$Loading}),
						$author$project$Pages$Partner$Practices$Top$fetchIntegrations(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Practice added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bJ: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(practiceId),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var integration = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bH: $elm$core$Maybe$Just(
								{vv: false, K3: '', Q4: integration, so: $author$project$Api$Data$NotAsked})
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var code = msg.a;
				var _v10 = model.bH;
				if (!_v10.$) {
					var activation = _v10.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bH: $elm$core$Maybe$Just(
									_Utils_update(
										activation,
										{K3: code, so: $author$project$Api$Data$NotAsked}))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var _v11 = model.bH;
				if (!_v11.$) {
					var activation = _v11.a;
					var trimmedCode = $elm$core$String$trim(activation.K3);
					var updatedActivation = _Utils_update(
						activation,
						{vv: true, K3: trimmedCode, so: $author$project$Api$Data$NotAsked});
					if ($elm$core$String$isEmpty(trimmedCode)) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bH: $elm$core$Maybe$Just(updatedActivation)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						var integrationId = $author$project$Api$Partner$Integration$All$id(activation.Q4);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bH: $elm$core$Maybe$Just(
										_Utils_update(
											updatedActivation,
											{so: $author$project$Api$Data$Loading}))
								}),
							A4(
								$author$project$Api$Partner$Integration$activate,
								model.D5,
								integrationId,
								trimmedCode,
								$author$project$Pages$Partner$Practices$Top$IntegrationActivated(integrationId)),
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var integrationId = msg.a;
				var response = msg.b;
				var _v12 = model.bH;
				if (!_v12.$) {
					var activation = _v12.a;
					if (_Utils_eq(
						$author$project$Api$Partner$Integration$All$id(activation.Q4),
						integrationId)) {
						if (response.$ === 3) {
							var newModel = _Utils_update(
								model,
								{bH: $elm$core$Maybe$Nothing, Ra: $author$project$Api$Data$Loading});
							return _Utils_Tuple3(
								newModel,
								$author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Practice activated')
									]));
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bH: $elm$core$Maybe$Just(
											_Utils_update(
												activation,
												{so: response}))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Practices$Top$New = {$: 4};
var $author$project$Pages$Partner$Practices$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed = {$: 10};
var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationCodeChanged = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted = {$: 12};
var $author$project$Pages$Partner$Practices$Top$viewActivateIntegrationModal = function (activation) {
	var showCodeError = activation.vv && $elm$core$String$isEmpty(
		$elm$core$String$trim(activation.K3));
	var practiceName = $author$project$Api$Partner$Practice$Shared$name(
		$author$project$Api$Partner$Integration$All$practice(activation.Q4));
	var isLoading = _Utils_eq(activation.so, $author$project$Api$Data$Loading);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed,
		_List_fromArray(
			[
				$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Activate Practice Integration')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceY4]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Enter the authorization code ' + (practiceName + ' shared with you to complete the connection.'))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Authorization Code'),
										$author$project$Ui$Form$Group$required(true),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(activation.K3),
												$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Practices$Top$ActivateIntegrationCodeChanged),
												$author$project$Ui$Form$Input$invalid(showCodeError),
												$author$project$Ui$Form$Input$errors(
												showCodeError ? _List_fromArray(
													['Authorization code is required']) : _List_Nil),
												$author$project$Ui$Form$Input$disabled(isLoading)
											]))
									]))
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed),
								$author$project$Ui$Button$disabled(isLoading)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Activate practice integration'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted),
								$author$project$Ui$Button$loading(isLoading),
								$author$project$Ui$Button$disabled(isLoading)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Activate')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Practices$Top$NewIntegrationClosed = {$: 5};
var $author$project$Pages$Partner$Practices$Top$NewIntegrationPracticeIdUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Partner$Practices$Top$SaveIntegration = {$: 6};
var $author$project$Pages$Partner$Practices$Top$viewAddIntegrationModal = F2(
	function (practiceId, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Practices$Top$NewIntegrationClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Practice')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Practice ID'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', practiceId)),
											$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Practices$Top$NewIntegrationPracticeIdUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(practiceId, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(practiceId, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Practice is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$NewIntegrationClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add Practice'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$SaveIntegration),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Practice')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Practices$Top$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Practices$Top$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'practice', true, 'Name'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'practice_active', true, 'Practice Active'),
		A3($author$project$Api$Column$init, 'partner_active', true, 'Partner Active')
	]);
var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationClicked = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$Integration$Shared$partnerActive = function (_v0) {
	var record = _v0;
	return record.VA;
};
var $author$project$Api$Partner$Integration$All$partnerActive = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Integration$Shared$partnerActive(shared);
};
var $author$project$Api$Partner$Partner$Shared$authType = function (_v0) {
	var record = _v0;
	return record.Jy;
};
var $author$project$Api$Partner$Partner$One$authType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$authType(shared);
};
var $author$project$Pages$Partner$Practices$Top$partnerUsesManualAuth = function (partner) {
	return $author$project$Api$Partner$Partner$One$authType(partner) === 'manual';
};
var $author$project$Api$Partner$Integration$Shared$practiceActive = function (_v0) {
	var record = _v0;
	return record.WG;
};
var $author$project$Api$Partner$Integration$All$practiceActive = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Integration$Shared$practiceActive(shared);
};
var $author$project$Pages$Partner$Practices$Top$canActivateIntegration = F2(
	function (partner, integration) {
		return $author$project$Pages$Partner$Practices$Top$partnerUsesManualAuth(partner) && ($author$project$Api$Partner$Integration$All$practiceActive(integration) && (!$author$project$Api$Partner$Integration$All$partnerActive(integration)));
	});
var $author$project$Api$Partner$Practice$Shared$hasClinicalAccount = function (_v0) {
	var record = _v0.b;
	return record.P2;
};
var $author$project$Api$Partner$Integration$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Partner$Integration$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Integration$Shared$status(shared);
};
var $author$project$Pages$Partner$Practices$Top$viewIntegration = F2(
	function (model, integration) {
		var practice = $author$project$Api$Partner$Integration$All$practice(integration);
		var practiceName = $author$project$Api$Partner$Practice$Shared$name(practice);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(practiceName),
							$author$project$Api$Partner$Practice$Shared$hasClinicalAccount(practice) ? A2(
							$author$project$Ui$Badge$view,
							_List_fromArray(
								[$author$project$Ui$Badge$info]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clinical')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Partner$Integration$All$status(integration))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$Bool$toString(
								$author$project$Api$Partner$Integration$All$practiceActive(integration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$Bool$toString(
								$author$project$Api$Partner$Integration$All$partnerActive(integration)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							($author$project$Pages$Partner$Practices$Top$partnerUsesManualAuth(model.Vz) && A2($author$project$Pages$Partner$Practices$Top$canActivateIntegration, model.Vz, integration)) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Activate ' + (practiceName + ' integration')},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Practices$Top$ActivateIntegrationClicked(integration))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Activate')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Partner$Practices$Top$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.Ra;
		if (_v1.$ === 3) {
			var integrations_ = _v1.a;
			return _Utils_Tuple2(false, integrations_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var integrations = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any practices')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Partner$Practices$Top$SortTable)),
					$author$project$Pages$Partner$Practices$Top$columns),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Partner$Practices$Top$viewIntegration(model),
			integrations),
		_List_Nil);
};
var $author$project$Pages$Partner$Practices$Top$view = function (model) {
	return {
		e5: function () {
			var loading = function () {
				var _v3 = model.Ra;
				if (_v3.$ === 3) {
					return false;
				} else {
					return true;
				}
			}();
			return _List_fromArray(
				[
					function () {
					var _v0 = model.bJ;
					if (!_v0.$) {
						var _v1 = _v0.a;
						var item = _v1.a;
						var request = _v1.b;
						return A2($author$project$Pages$Partner$Practices$Top$viewAddIntegrationModal, item, request);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v2 = model.bH;
					if (!_v2.$) {
						var activation = _v2.a;
						return $author$project$Pages$Partner$Practices$Top$viewActivateIntegrationModal(activation);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$mb2]),
									_List_fromArray(
										[
											$author$project$Ui$Panel$title(
											_List_fromArray(
												[
													$elm$html$Html$text('Practices')
												])),
											model.FR ? A3(
											$author$project$Ui$HinterOnly$button,
											{abp: 'Add practice'},
											_List_fromArray(
												[
													$author$project$Ui$Button$default,
													$author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$New)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add Practice')
												])) : $author$project$Utils$Html$empty
										])),
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Partner$Practices$Top$SearchInputMsg,
									A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
								])),
							$author$project$Pages$Partner$Practices$Top$viewTable(model),
							A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Partner$Practices$Top$PaginationMsg,
									A2(
										$author$project$Api$Pagination$view,
										_List_fromArray(
											[
												$author$project$Ui$Pagination$List$loading(loading)
											]),
										model.afy))
								]))
						]))
				]);
		}(),
		$G: 'Partner | Practices'
	};
};
var $author$project$Pages$Partner$Practices$Top$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Practices$Top$init, aer: $author$project$Pages$Partner$Practices$Top$load, agD: $author$project$Pages$Partner$Practices$Top$save, ahd: $author$project$Pages$Partner$Practices$Top$subscriptions, aaq: $author$project$Pages$Partner$Practices$Top$update, ahP: $author$project$Pages$Partner$Practices$Top$view});
var $author$project$Pages$Partner$Product$CallToActionMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$Partner$Product$CarouselMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$GotCategories = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductCategories$init = F2(
	function (apiClient, partner) {
		return _Utils_Tuple2(
			{
				KL: $author$project$Api$Data$Loading,
				lm: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'category-dropdown', ahx: $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDropdownMsg})),
				bW: $elm$core$Maybe$Nothing,
				Vz: partner,
				C: $elm$core$Maybe$Nothing
			},
			A2($author$project$Api$Platform$Marketplace$ProductCategory$list, apiClient, $author$project$Components$Partner$ManagePartnerProductCategories$GotCategories));
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$init = F2(
	function (partner, imageStore) {
		return _Utils_Tuple2(
			{b$: $elm$core$Maybe$Nothing, qT: imageStore, Vz: partner, D: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductHighlights$init = F2(
	function (partner, imageStore) {
		return _Utils_Tuple2(
			{bY: $elm$core$Maybe$Nothing, qT: imageStore, Vz: partner, F: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductLinks$init = F2(
	function (partner, imageStore) {
		return _Utils_Tuple2(
			{bZ: $elm$core$Maybe$Nothing, qT: imageStore, Vz: partner, G: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductQuotes$init = F2(
	function (partner, imageStore) {
		return _Utils_Tuple2(
			{b0: $elm$core$Maybe$Nothing, qT: imageStore, Vz: partner, H: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Product$GotPartnerProduct = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProduct$retrieve = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProduct$productPathWithId(productId)));
	});
var $author$project$Pages$Partner$Product$retrieveProduct = F2(
	function (apiClient, product) {
		if (!product.$) {
			var sharedProduct = product.a;
			return A3(
				$author$project$Api$Partner$PartnerProduct$retrieve,
				apiClient,
				$author$project$Api$Partner$PartnerProduct$Shared$id(sharedProduct),
				$author$project$Pages$Partner$Product$GotPartnerProduct);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pages$Partner$Product$init = F4(
	function (_v0, partner, shared, _v1) {
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var _v2 = A2($author$project$Components$Partner$ManagePartnerProductQuotes$init, partner, shared.qT);
		var managePartnerProductQuotes = _v2.a;
		var managePartnerProductQuotesCmd = _v2.b;
		var _v3 = A2($author$project$Components$Partner$ManagePartnerProductLinks$init, partner, shared.qT);
		var managePartnerProductLinks = _v3.a;
		var managePartnerProductLinksCmd = _v3.b;
		var _v4 = A2($author$project$Components$Partner$ManagePartnerProductHighlights$init, partner, shared.qT);
		var managePartnerProductHighlights = _v4.a;
		var managePartnerProductHighlightsCmd = _v4.b;
		var _v5 = A2($author$project$Components$Partner$ManagePartnerProductDataFlows$init, partner, shared.qT);
		var managePartnerProductDataFlows = _v5.a;
		var managePartnerProductDataFlowsCmd = _v5.b;
		var _v6 = A2($author$project$Components$Partner$ManagePartnerProductCategories$init, shared.D5, partner);
		var manageCategories = _v6.a;
		var manageCategoriesCmd = _v6.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				bR: $author$project$Components$Marketplace$Product$CallToAction$init(
					{
						Pj: F4(
							function (apiClient, _v7, documentId, toMsg) {
								return A3($author$project$Api$Partner$PartnerProductDocument$signedFileUrl, apiClient, documentId, toMsg);
							}),
						Ru: true,
						ahx: $author$project$Pages$Partner$Product$CallToActionMsg
					}),
				pO: $author$project$Components$Carousel$init($author$project$Pages$Partner$Product$CarouselMsg),
				fp: $elm$core$Maybe$Nothing,
				w: $elm$core$Maybe$Nothing,
				qF: 0,
				qT: shared.qT,
				FR: isHintAdmin,
				S_: false,
				fY: manageCategories,
				fZ: managePartnerProductDataFlows,
				f_: managePartnerProductHighlights,
				f$: managePartnerProductLinks,
				f0: managePartnerProductQuotes,
				Vz: partner,
				W8: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Pages$Partner$Product$retrieveProduct,
						shared.D5,
						$author$project$Api$Partner$Partner$One$product(partner)),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg, managePartnerProductLinksCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, managePartnerProductHighlightsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, managePartnerProductDataFlowsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg, manageCategoriesCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, managePartnerProductQuotesCmd)
					])));
	});
var $author$project$Pages$Partner$Product$load = F2(
	function (shared, model) {
		var hasProduct = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(true),
				$author$project$Api$Partner$Partner$One$product(model.Vz)));
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				hasProduct,
				$author$project$Api$Data$toMaybe(shared.Vz));
			if ((!_v1.a) && (!_v1.b.$)) {
				var part = _v1.b.a;
				var _v2 = $author$project$Api$Partner$Partner$One$product(part);
				if (!_v2.$) {
					var product = _v2.a;
					return _Utils_Tuple2(
						part,
						A2(
							$author$project$Pages$Partner$Product$retrieveProduct,
							shared.D5,
							$elm$core$Maybe$Just(product)));
				} else {
					return _Utils_Tuple2(model.Vz, $elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(model.Vz, $elm$core$Platform$Cmd$none);
			}
		}();
		var partner = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared),
					Vz: partner
				}),
			cmd);
	});
var $author$project$Pages$Partner$Product$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Product$CancelEdit = {$: 2};
var $author$project$Pages$Partner$Product$DeleteConfirmClosed = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.C;
				if (!_v1.$) {
					return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.bW;
				if (!_v2.$) {
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Ui$NewDropdown$subscriptions(model.lm)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd)),
					model.D)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed)),
					model.b$))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit)),
					model.F)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed)),
					model.bY))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd)),
					model.G)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed)),
					model.bZ))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit)),
					model.H)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed)),
					model.b0))
			]));
};
var $author$project$Pages$Partner$Product$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Product$CancelEdit),
				function () {
				var _v0 = model.fp;
				if (!_v0.$) {
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Partner$Product$DeleteConfirmClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg,
				$author$project$Components$Partner$ManagePartnerProductLinks$subscriptions(model.f$)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg,
				$author$project$Components$Partner$ManagePartnerProductHighlights$subscriptions(model.f_)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg,
				$author$project$Components$Partner$ManagePartnerProductDataFlows$subscriptions(model.fZ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg,
				$author$project$Components$Partner$ManagePartnerProductCategories$subscriptions(model.fY)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg,
				$author$project$Components$Partner$ManagePartnerProductQuotes$subscriptions(model.f0))
			]));
};
var $author$project$Pages$Partner$Product$Edited = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Product$GotPartnerUpdated = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Partner$Product$Icon = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Product$ProductOverviewImages = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Partner$Product$Saved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$ProductImage$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Partner$PartnerProductOverview$Shared$images = function (_v0) {
	var record = _v0;
	return record.QO;
};
var $author$project$Api$Partner$Partner$One$productOverview = function (_v0) {
	var record = _v0.b;
	return record.Xe;
};
var $author$project$Components$Carousel$reset = function (model) {
	return _Utils_update(
		model,
		{x4: 0});
};
var $author$project$Api$Partner$Partner$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath));
	});
var $author$project$Api$Partner$PartnerProduct$BuiltByName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProduct$BuiltByUrl = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProduct$CtaUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Partner$Product$GotPartnerProductUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Icon = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Name = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$Partner$ProductOverviewDescription = function (a) {
	return {$: 25, a: a};
};
var $author$project$Api$Partner$Partner$ProductOverviewImage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$Partner$ProductOverviewImageUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$Partner$ProductOverviewImages = function (a) {
	return {$: 26, a: a};
};
var $author$project$Api$Partner$PartnerProduct$ProductType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Summary = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$PartnerProduct$UtmCampaign = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$PartnerProduct$UtmContent = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Partner$ProductImage$Shared$alt = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, '', record.I1);
};
var $author$project$Utils$Maybe$fromString = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Api$Partner$PartnerProduct$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$id(shared);
};
var $author$project$Api$Common$Marketplace$Product$DistributionType$toString = function (distributionType) {
	if (!distributionType) {
		return 'public';
	} else {
		return 'unlisted';
	}
};
var $author$project$Api$Common$Marketplace$Product$DistributionType$encode = function (distributionType) {
	return $elm$json$Json$Encode$string(
		$author$project$Api$Common$Marketplace$Product$DistributionType$toString(distributionType));
};
var $author$project$Api$Common$Marketplace$Product$ProductType$encode = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$Common$Marketplace$Product$ProductType$toString);
var $author$project$Api$Common$Marketplace$Product$Status$toString = function (status) {
	switch (status) {
		case 0:
			return 'hidden';
		case 1:
			return 'unpublished';
		case 2:
			return 'researching';
		case 3:
			return 'coming_soon';
		case 4:
			return 'beta';
		case 5:
			return 'live';
		case 6:
			return 'sunsetting';
		case 7:
			return 'deprecated';
		default:
			return 'decommissioned';
	}
};
var $author$project$Api$Common$Marketplace$Product$Status$encode = function (status) {
	return $elm$json$Json$Encode$string(
		$author$project$Api$Common$Marketplace$Product$Status$toString(status));
};
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString = function (feature) {
	if (!feature.$) {
		return 'emr';
	} else {
		var string = feature.a;
		return string;
	}
};
var $author$project$Api$Partner$PartnerProduct$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var slug = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'slug',
								$elm$json$Json$Encode$string(slug)),
							acc);
					case 1:
						var productType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'product_type',
								$author$project$Api$Common$Marketplace$Product$ProductType$encode(productType)),
							acc);
					case 2:
						var name = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name)),
							acc);
					case 3:
						var icon = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'marketplace_icon',
								$elm$json$Json$Encode$string(icon)),
							acc);
					case 4:
						var summary = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'summary',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, summary)),
							acc);
					case 5:
						var builtByName = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'built_by_name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, builtByName)),
							acc);
					case 6:
						var builtByUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'built_by_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, builtByUrl)),
							acc);
					case 7:
						var distributionType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'distribution_type',
								$author$project$Api$Common$Marketplace$Product$DistributionType$encode(distributionType)),
							acc);
					case 8:
						var featured = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'featured',
								$elm$json$Json$Encode$bool(featured)),
							acc);
					case 9:
						var status = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'status',
								$author$project$Api$Common$Marketplace$Product$Status$encode(status)),
							acc);
					case 10:
						var ctaUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'cta_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, ctaUrl)),
							acc);
					case 11:
						var utmCampaign = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'utm_campaign',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, utmCampaign)),
							acc);
					case 12:
						var utmContent = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'utm_content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, utmContent)),
							acc);
					default:
						var req = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'requirement',
								function () {
									if (!req.$) {
										if (!req.a.$) {
											var feature = req.a.a;
											return $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'type',
														$elm$json$Json$Encode$string('feature')),
														_Utils_Tuple2(
														'feature',
														$elm$json$Json$Encode$string(
															$author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(feature)))
													]));
										} else {
											var value = req.a.a;
											return $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'type',
														$elm$json$Json$Encode$string('tier')),
														_Utils_Tuple2(
														'starting_tier',
														$elm$json$Json$Encode$string(value))
													]));
										}
									} else {
										return $elm$json$Json$Encode$null;
									}
								}()),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$PartnerProduct$update = F4(
	function (apiClient, productId, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$PartnerProduct$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProduct$productPathWithId(productId))));
	});
var $author$project$Pages$Partner$Product$CtaUrlValidation = 2;
var $author$project$Pages$Partner$Product$IconValidation = 1;
var $author$project$Pages$Partner$Product$NameValidation = 0;
var $author$project$Pages$Partner$Product$maxIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Pages$Partner$Product$validator = function (field) {
	switch (field.$) {
		case 0:
			var name = field.a;
			return A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				$elm$core$Basics$always(name),
				_Utils_Tuple2(0, 'Please enter a name.'));
		case 2:
			var maybeIcon = field.a;
			return $rtfeldman$elm_validate$Validate$all(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifNothing,
						$elm$core$Basics$always(maybeIcon),
						_Utils_Tuple2(1, 'Please select an icon to upload.')),
						function () {
						if (!maybeIcon.$) {
							var _v2 = maybeIcon.a;
							var iconSize = _v2.a;
							return A3(
								$author$project$Utils$Validate$ifIntGreaterThan,
								$elm$core$Basics$always(iconSize),
								$author$project$Pages$Partner$Product$maxIconBytesSize,
								_Utils_Tuple2(1, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'));
						} else {
							return $rtfeldman$elm_validate$Validate$all(_List_Nil);
						}
					}()
					]));
		case 5:
			return $rtfeldman$elm_validate$Validate$all(_List_Nil);
		case 6:
			return $rtfeldman$elm_validate$Validate$all(_List_Nil);
		case 7:
			var cta = field.a;
			return A2(
				$rtfeldman$elm_validate$Validate$ifTrue,
				$elm$core$Basics$always(
					$author$project$Utils$Validate$isInvalidUrlStricter(cta.aav)),
				_Utils_Tuple2(2, 'Please enter a valid URL (e.g. https://partner.example.com).'));
		default:
			return $rtfeldman$elm_validate$Validate$all(_List_Nil);
	}
};
var $author$project$Pages$Partner$Product$validate = function (form) {
	return A2(
		$author$project$Utils$Form$validate,
		$author$project$Pages$Partner$Product$validator(
			$author$project$Utils$Form$fields(form)),
		form);
};
var $author$project$Pages$Partner$Product$submit = F2(
	function (model, form) {
		var _v0 = $author$project$Pages$Partner$Product$validate(form);
		if (_v0.$ === 1) {
			var invalidForm = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						w: $elm$core$Maybe$Just(invalidForm)
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			var _v1 = _v0.a;
			var validField = _v1.b;
			var _v2 = model.W8;
			if (_v2.$ === 3) {
				var product = _v2.a;
				var field = $rtfeldman$elm_validate$Validate$fromValid(validField);
				var productFields = function () {
					switch (field.$) {
						case 5:
							var maybeName = field.a;
							var maybeUrl = field.b;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$BuiltByName(maybeName),
									$author$project$Api$Partner$PartnerProduct$BuiltByUrl(maybeUrl)
								]);
						case 0:
							var name = field.a;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$Name(name)
								]);
						case 1:
							var description = field.a;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$Summary(
									$author$project$Utils$Maybe$fromString(description))
								]);
						case 2:
							if (!field.a.$) {
								var _v5 = field.a.a;
								var url = _v5.b;
								return _List_fromArray(
									[
										$author$project$Api$Partner$PartnerProduct$Icon(url)
									]);
							} else {
								var _v6 = field.a;
								return _List_Nil;
							}
						case 6:
							var productType = field.a;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$ProductType(productType)
								]);
						case 7:
							var cta = field.a;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProduct$CtaUrl(
									$author$project$Utils$Maybe$fromString(cta.aav)),
									$author$project$Api$Partner$PartnerProduct$UtmCampaign(
									$author$project$Utils$Maybe$fromString(cta.aaJ)),
									$author$project$Api$Partner$PartnerProduct$UtmContent(
									$author$project$Utils$Maybe$fromString(cta.aaK))
								]);
						default:
							return _List_Nil;
					}
				}();
				if ($elm$core$List$isEmpty(productFields)) {
					switch (field.$) {
						case 3:
							var description = field.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{w: $elm$core$Maybe$Nothing, S_: true}),
								A3(
									$author$project$Api$Partner$Partner$update,
									model.D5,
									_List_fromArray(
										[
											$author$project$Api$Partner$Partner$ProductOverviewDescription(
											$author$project$Utils$Maybe$fromString(description))
										]),
									$author$project$Pages$Partner$Product$GotPartnerUpdated(true)),
								_List_Nil);
						case 4:
							var existingImages = field.a;
							var newUrls = field.b;
							var newImageParams = A2($elm$core$List$map, $author$project$Api$Partner$Partner$ProductOverviewImageUrl, newUrls);
							var existingImageParams = A2(
								$elm$core$List$map,
								function (img) {
									return $author$project$Api$Partner$Partner$ProductOverviewImage(
										{
											I1: $author$project$Api$Partner$ProductImage$Shared$alt(img),
											adR: $author$project$Api$Partner$ProductImage$Shared$id(img)
										});
								},
								existingImages);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{w: $elm$core$Maybe$Nothing, S_: true}),
								A3(
									$author$project$Api$Partner$Partner$update,
									model.D5,
									_List_fromArray(
										[
											$author$project$Api$Partner$Partner$ProductOverviewImages(
											_Utils_ap(existingImageParams, newImageParams))
										]),
									$author$project$Pages$Partner$Product$GotPartnerUpdated(true)),
								_List_Nil);
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{w: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
					}
				} else {
					var productId = $author$project$Api$Partner$PartnerProduct$One$id(product);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{w: $elm$core$Maybe$Nothing, S_: true}),
						A4($author$project$Api$Partner$PartnerProduct$update, model.D5, productId, productFields, $author$project$Pages$Partner$Product$GotPartnerProductUpdated),
						_List_Nil);
				}
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{w: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}
		}
	});
var $author$project$Api$Partner$PartnerProduct$One$ctaUrl = function (_v0) {
	var record = _v0.b;
	return record.Mq;
};
var $author$project$Api$Partner$PartnerProduct$One$distributionType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$distributionType(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$name(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$slug = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$slug(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$status(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$type_(shared);
};
var $author$project$Pages$Partner$Product$toCallToActionProduct = function (product) {
	return {
		JU: false,
		LF: $author$project$Api$Partner$PartnerProduct$One$ctaUrl(product),
		NS: $author$project$Api$Partner$PartnerProduct$One$distributionType(product),
		OB: $elm$core$Maybe$Nothing,
		Q1: $elm$core$Maybe$Nothing,
		SZ: $author$project$Api$Partner$PartnerProduct$One$status(product),
		zh: $author$project$Api$Partner$PartnerProduct$One$name(product),
		VF: _List_Nil,
		WT: _List_Nil,
		_c: $author$project$Api$Partner$PartnerProduct$One$slug(product),
		ag7: $elm$core$Maybe$Nothing,
		ahI: $author$project$Api$Partner$PartnerProduct$One$type_(product)
	};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryUpdated = 2;
var $author$project$Components$Partner$ManagePartnerProductCategories$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$None = 0;
var $author$project$Components$Partner$ManagePartnerProductCategories$Updated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Category$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Partner$ManagePartnerProductCategories$categoryFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var name = field.a;
			return _Utils_update(
				fields,
				{zh: name, oa: $elm$core$Maybe$Nothing});
		} else {
			var category = field.a;
			return _Utils_update(
				fields,
				{
					zh: $author$project$Api$Common$Marketplace$Product$Category$name(category),
					oa: $elm$core$Maybe$Just(
						$author$project$Api$Common$Marketplace$Product$Category$id(category))
				});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$NameValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductCategories$categoryValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(0, 'Please enter a category name.'))
		]));
var $author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_product_categories']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerProductCategory$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_category',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(params.zh))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductCategory$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath)));
	});
var $author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath);
};
var $author$project$Api$Partner$PartnerProductCategory$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath(id)));
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$initCategoryFields = {zh: '', oa: $elm$core$Maybe$Nothing};
var $author$project$Api$Partner$PartnerProductCategory$update = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Partner$PartnerProductCategory$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath(id)));
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		var noOp = {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							C: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductCategories$initCategoryFields),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{C: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 2:
				var field = msg.a;
				var _v2 = model.C;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductCategories$categoryFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								C: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						as: _List_Nil
					};
				} else {
					return noOp;
				}
			case 3:
				var _v4 = model.C;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var maybeCategory = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductCategories$categoryValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var validatedForm = _v7.a;
						var validFormFields = _v7.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
						var _v8 = fields.oa;
						if (!_v8.$) {
							var categoryId = _v8.a;
							return {
								EC: A3($author$project$Api$Partner$PartnerProductCategory$update, apiClient, categoryId, $author$project$Components$Partner$ManagePartnerProductCategories$Updated),
								ac5: 0,
								y8: _Utils_update(
									model,
									{
										C: $elm$core$Maybe$Just(
											_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$Loading))
									}),
								as: _List_Nil
							};
						} else {
							return {
								EC: A3(
									$author$project$Api$Partner$PartnerProductCategory$create,
									apiClient,
									{zh: fields.zh},
									$author$project$Components$Partner$ManagePartnerProductCategories$Created),
								ac5: 0,
								y8: _Utils_update(
									model,
									{
										C: $elm$core$Maybe$Just(
											_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$Loading))
									}),
								as: _List_Nil
							};
						}
					} else {
						var validatedForm = _v6.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							as: _List_Nil
						};
					}
				} else {
					return noOp;
				}
			case 4:
				var response = msg.a;
				var _v9 = model.C;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var maybeCategory = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: _Utils_update(
								model,
								{C: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Category added successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeCategory, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return noOp;
				}
			case 5:
				var response = msg.a;
				var _v12 = model.C;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var maybeCategory = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: _Utils_update(
								model,
								{C: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Category added successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybeCategory, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return noOp;
				}
			case 7:
				var id = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							bW: $elm$core$Maybe$Just(
								_Utils_Tuple2(id, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 8:
				var confirmed = msg.a;
				var _v15 = model.bW;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var id = _v16.a;
					return confirmed ? {
						EC: A3($author$project$Api$Partner$PartnerProductCategory$delete, apiClient, id, $author$project$Components$Partner$ManagePartnerProductCategories$Deleted),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								bW: $elm$core$Maybe$Just(
									_Utils_Tuple2(id, $author$project$Api$Data$Loading))
							}),
						as: _List_Nil
					} : {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{bW: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return noOp;
				}
			case 9:
				var response = msg.a;
				var _v17 = model.bW;
				if (!_v17.$) {
					var _v18 = _v17.a;
					var id = _v18.a;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 3,
							y8: _Utils_update(
								model,
								{bW: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Category removed successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									bW: $elm$core$Maybe$Just(
										_Utils_Tuple2(id, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return noOp;
				}
			case 6:
				var subMsg = msg.a;
				var _v20 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lm);
				var updatedDropdown = _v20.a;
				var dropdownCmd = _v20.b;
				return {
					EC: dropdownCmd,
					ac5: 0,
					y8: _Utils_update(
						model,
						{lm: updatedDropdown}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{KL: response}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowUpdated = 2;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$None = 0;
var $author$project$Api$Common$Marketplace$Product$SyncDirection$default = 0;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var hintName = field.a;
				return _Utils_update(
					fields,
					{Qx: hintName});
			case 1:
				var partnerName = field.a;
				return _Utils_update(
					fields,
					{VE: partnerName});
			default:
				var syncDirection = field.a;
				return _Utils_update(
					fields,
					{
						$h: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Common$Marketplace$Product$SyncDirection$default,
							$author$project$Api$Common$Marketplace$Product$SyncDirection$fromString(syncDirection))
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$HintNameValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerNameValidation = 1;
var $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Qx;
			},
			_Utils_Tuple2(0, 'Please enter a hint name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.VE;
			},
			_Utils_Tuple2(1, 'Please enter a partner name.'))
		]));
var $author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_product_data_flows']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath);
};
var $author$project$Api$Partner$PartnerProductDataFlow$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath(id)));
	});
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFields = {Qx: '', VE: '', $h: 1};
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName = function (_v0) {
	var record = _v0;
	return record.Qx;
};
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName = function (_v0) {
	var record = _v0;
	return record.VE;
};
var $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection = function (_v0) {
	var record = _v0;
	return record.$h;
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFieldsForEdit = function (productDataFlow) {
	return {
		Qx: $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName(productDataFlow),
		VE: $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName(productDataFlow),
		$h: $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection(productDataFlow)
	};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Created = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProductDataFlow$One$PartnerProductDataFlow = 0;
var $author$project$Api$Partner$PartnerProductDataFlow$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Common$Marketplace$Product$SyncDirection$toString = function (syncDirection) {
	switch (syncDirection) {
		case 0:
			return 'from_hint';
		case 1:
			return 'to_hint';
		default:
			return 'bidirectional';
	}
};
var $author$project$Api$Common$Marketplace$Product$SyncDirection$encode = function (syncDirection) {
	return $elm$json$Json$Encode$string(
		$author$project$Api$Common$Marketplace$Product$SyncDirection$toString(syncDirection));
};
var $author$project$Api$Partner$PartnerProductDataFlow$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_data_flow',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'hint_name',
								$elm$json$Json$Encode$string(params.Qx)),
								_Utils_Tuple2(
								'partner_name',
								$elm$json$Json$Encode$string(params.VE)),
								_Utils_Tuple2(
								'sync_direction',
								$author$project$Api$Common$Marketplace$Product$SyncDirection$encode(params.$h))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductDataFlow$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath)));
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$createLink = F2(
	function (apiClient, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var hintName = _v0.Qx;
		var partnerName = _v0.VE;
		var syncDirection = _v0.$h;
		return A3(
			$author$project$Api$Partner$PartnerProductDataFlow$create,
			apiClient,
			{Qx: hintName, VE: partnerName, $h: syncDirection},
			$author$project$Components$Partner$ManagePartnerProductDataFlows$Created);
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Updated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductDataFlow$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_data_flow',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'hint_name',
								$elm$json$Json$Encode$string(params.Qx)),
								_Utils_Tuple2(
								'partner_name',
								$elm$json$Json$Encode$string(params.VE)),
								_Utils_Tuple2(
								'sync_direction',
								$author$project$Api$Common$Marketplace$Product$SyncDirection$encode(params.$h))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductDataFlow$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath(id))));
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$updateLink = F3(
	function (apiClient, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var hintName = _v0.Qx;
		var partnerName = _v0.VE;
		var syncDirection = _v0.$h;
		return A4(
			$author$project$Api$Partner$PartnerProductDataFlow$update,
			apiClient,
			id,
			{Qx: hintName, VE: partnerName, $h: syncDirection},
			$author$project$Components$Partner$ManagePartnerProductDataFlows$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$save = F3(
	function (apiClient, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A3($author$project$Components$Partner$ManagePartnerProductDataFlows$updateLink, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Partner$ManagePartnerProductDataFlows$createLink, apiClient, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							D: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFields),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 2:
				var productDataFlow = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							D: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productDataFlow),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFieldsForEdit(productDataFlow)),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{D: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 3:
				var field = msg.a;
				var _v2 = model.D;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								D: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 4:
				var _v4 = model.D;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var productDataFlow = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var validatedForm = _v7.a;
						var validFormFields = _v7.b;
						var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDataFlow$Shared$id, productDataFlow);
						return {
							EC: A3($author$project$Components$Partner$ManagePartnerProductDataFlows$save, apiClient, id, validFormFields),
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									D: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDataFlow, validatedForm, $author$project$Api$Data$Loading))
								}),
							as: _List_Nil
						};
					} else {
						var validatedForm = _v6.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									D: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDataFlow, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 5:
				var response = msg.a;
				var _v8 = model.D;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var productDataFlow = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: _Utils_update(
								model,
								{D: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Synced field created successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									D: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDataFlow, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				var response = msg.a;
				var _v11 = model.D;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var productDataFlow = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: _Utils_update(
								model,
								{D: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Synced field updated successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									D: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDataFlow, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 7:
				var productDataFlow = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							b$: $elm$core$Maybe$Just(
								_Utils_Tuple2(productDataFlow, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 8:
				var confirmed = msg.a;
				var _v14 = model.b$;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var productDataFlow = _v15.a;
					return confirmed ? {
						EC: A3(
							$author$project$Api$Partner$PartnerProductDataFlow$delete,
							apiClient,
							$author$project$Api$Partner$PartnerProductDataFlow$Shared$id(productDataFlow),
							$author$project$Components$Partner$ManagePartnerProductDataFlows$Deleted),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								b$: $elm$core$Maybe$Just(
									_Utils_Tuple2(productDataFlow, $author$project$Api$Data$Loading))
							}),
						as: _List_Nil
					} : {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{b$: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			default:
				var response = msg.a;
				var _v16 = model.b$;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var productDataFlow = _v17.a;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 3,
							y8: _Utils_update(
								model,
								{b$: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Synced field deleted successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									b$: $elm$core$Maybe$Just(
										_Utils_Tuple2(productDataFlow, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$Deleted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightUpdated = 2;
var $author$project$Components$Partner$ManagePartnerProductHighlights$Image = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$None = 0;
var $author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_product_highlights']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath);
};
var $author$project$Api$Partner$PartnerProductHighlight$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath(id)));
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$highlightFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var title = field.a;
				return _Utils_update(
					fields,
					{$G: title});
			case 1:
				var description = field.a;
				return _Utils_update(
					fields,
					{Nx: description});
			default:
				var imageSize = field.a;
				var imageUrl = field.b;
				return _Utils_update(
					fields,
					{
						p4: $elm$core$Maybe$Just(imageUrl),
						adV: $elm$core$Maybe$Just(imageUrl),
						ms: imageSize
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$DescriptionValidation = 1;
var $author$project$Components$Partner$ManagePartnerProductHighlights$ImageValidation = 2;
var $author$project$Components$Partner$ManagePartnerProductHighlights$TitleValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductHighlights$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$ManagePartnerProductHighlights$highlightValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.$G;
			},
			_Utils_Tuple2(0, 'Please enter a title.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Nx;
			},
			_Utils_Tuple2(1, 'Please enter a description.')),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.ms;
			},
			$author$project$Components$Partner$ManagePartnerProductHighlights$maxLogoBytesSize,
			_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
		]));
var $author$project$Api$Partner$PartnerProductHighlight$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFields = {p4: $elm$core$Maybe$Nothing, Nx: '', adV: $elm$core$Maybe$Nothing, ms: 0, $G: ''};
var $author$project$Api$Partner$PartnerProductHighlight$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl = function (_v0) {
	var record = _v0;
	return record.QN;
};
var $author$project$Api$Partner$PartnerProductHighlight$Shared$title = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFieldsForEdit = function (productHighlight) {
	return {
		p4: $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl(productHighlight),
		Nx: $author$project$Api$Partner$PartnerProductHighlight$Shared$description(productHighlight),
		adV: $elm$core$Maybe$Nothing,
		ms: 0,
		$G: $author$project$Api$Partner$PartnerProductHighlight$Shared$title(productHighlight)
	};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$One$PartnerProductHighlight = 0;
var $author$project$Api$Partner$PartnerProductHighlight$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$PartnerProductHighlight$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_highlight',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.$G)),
								_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(params.Nx)),
								_Utils_Tuple2(
								'image',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.adV))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductHighlight$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath)));
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$createProductHighlight = F2(
	function (apiClient, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.$G;
		var description = _v0.Nx;
		var image = _v0.adV;
		return A3(
			$author$project$Api$Partner$PartnerProductHighlight$create,
			apiClient,
			{Nx: description, adV: image, $G: title},
			$author$project$Components$Partner$ManagePartnerProductHighlights$Created);
	});
var $author$project$Api$Partner$PartnerProductHighlight$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$Image = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Updated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProductHighlight$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var title = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(title)),
							acc);
					case 1:
						var description = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'description',
								$elm$json$Json$Encode$string(description)),
							acc);
					default:
						var image = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'image',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, image)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product_highlight',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$PartnerProductHighlight$update = F4(
	function (apiClient, id, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$PartnerProductHighlight$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductHighlight$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath(id))));
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$updateProductHighlight = F3(
	function (apiClient, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.$G;
		var description = _v0.Nx;
		var image = _v0.adV;
		return A4(
			$author$project$Api$Partner$PartnerProductHighlight$update,
			apiClient,
			id,
			A2(
				$elm$core$List$cons,
				$author$project$Api$Partner$PartnerProductHighlight$Title(title),
				A2(
					$elm$core$List$cons,
					$author$project$Api$Partner$PartnerProductHighlight$Description(description),
					function () {
						if (!image.$) {
							var imageUrl = image.a;
							return _List_fromArray(
								[
									$author$project$Api$Partner$PartnerProductHighlight$Image(
									$elm$core$Maybe$Just(imageUrl))
								]);
						} else {
							return _List_Nil;
						}
					}())),
			$author$project$Components$Partner$ManagePartnerProductHighlights$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$saveProductHighlight = F3(
	function (apiClient, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A3($author$project$Components$Partner$ManagePartnerProductHighlights$updateProductHighlight, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Partner$ManagePartnerProductHighlights$createProductHighlight, apiClient, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							F: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFields),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{F: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 3:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var task = _v2.a;
							var size = _v2.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated,
									$author$project$Components$Partner$ManagePartnerProductHighlights$Image(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return {EC: cmd, ac5: 0, y8: model, as: _List_Nil};
			case 2:
				var field = msg.a;
				var _v3 = model.F;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var id = _v4.a;
					var form = _v4.b;
					var request = _v4.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductHighlights$highlightFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								F: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 4:
				var productHighlight = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							F: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productHighlight),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFieldsForEdit(productHighlight)),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 5:
				var _v5 = model.F;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var item = _v6.a;
					var form = _v6.b;
					var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductHighlights$highlightValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var validatedForm = _v8.a;
						var validFormFields = _v8.b;
						var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductHighlight$Shared$id, item);
						return {
							EC: A3($author$project$Components$Partner$ManagePartnerProductHighlights$saveProductHighlight, apiClient, id, validFormFields),
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									F: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
								}),
							as: _List_Nil
						};
					} else {
						var validatedForm = _v7.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									F: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				var response = msg.a;
				var _v9 = model.F;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var productHighlight = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: _Utils_update(
								model,
								{F: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product highlight created successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									F: $elm$core$Maybe$Just(
										_Utils_Tuple3(productHighlight, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 7:
				var response = msg.a;
				var _v12 = model.F;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var item = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: _Utils_update(
								model,
								{F: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product highlight updated successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									F: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 8:
				var productHighlight = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							bY: $elm$core$Maybe$Just(
								_Utils_Tuple2(productHighlight, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 9:
				var confirmed = msg.a;
				var _v15 = model.bY;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var productHighlight = _v16.a;
					return confirmed ? {
						EC: A3(
							$author$project$Api$Partner$PartnerProductHighlight$delete,
							apiClient,
							$author$project$Api$Partner$PartnerProductHighlight$Shared$id(productHighlight),
							$author$project$Components$Partner$ManagePartnerProductHighlights$Deleted),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								bY: $elm$core$Maybe$Just(
									_Utils_Tuple2(productHighlight, $author$project$Api$Data$Loading))
							}),
						as: _List_Nil
					} : {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{bY: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			default:
				var response = msg.a;
				var _v17 = model.bY;
				if (!_v17.$) {
					var _v18 = _v17.a;
					var productHighlight = _v18.a;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 3,
							y8: _Utils_update(
								model,
								{bY: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product highlight deleted successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									bY: $elm$core$Maybe$Just(
										_Utils_Tuple2(productHighlight, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$Deleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$LinkCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductLinks$LinkDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductLinks$LinkUpdated = 2;
var $author$project$Components$Partner$ManagePartnerProductLinks$None = 0;
var $author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_product_links']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath);
};
var $author$project$Api$Partner$PartnerProductLink$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath(id)));
	});
var $author$project$Api$Partner$PartnerProductLink$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Partner$ManagePartnerProductLinks$initLinkFields = {SV: 0, $G: '', aaJ: '', aaK: '', aaN: ''};
var $author$project$Api$Partner$PartnerProductLink$Shared$linkType = function (_v0) {
	var record = _v0;
	return record.SV;
};
var $author$project$Api$Partner$PartnerProductLink$Shared$title = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Api$Partner$PartnerProductLink$Shared$utmCampaign = function (_v0) {
	var record = _v0;
	return record.aaJ;
};
var $author$project$Api$Partner$PartnerProductLink$Shared$utmContent = function (_v0) {
	var record = _v0;
	return record.aaK;
};
var $author$project$Api$Partner$PartnerProductLink$Shared$value = function (_v0) {
	var record = _v0;
	return record.aaN;
};
var $author$project$Components$Partner$ManagePartnerProductLinks$initLinkFieldsForEdit = function (productLink) {
	return {
		SV: $author$project$Api$Partner$PartnerProductLink$Shared$linkType(productLink),
		$G: $author$project$Api$Partner$PartnerProductLink$Shared$title(productLink),
		aaJ: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Partner$PartnerProductLink$Shared$utmCampaign(productLink)),
		aaK: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Partner$PartnerProductLink$Shared$utmContent(productLink)),
		aaN: $author$project$Api$Partner$PartnerProductLink$Shared$value(productLink)
	};
};
var $author$project$Api$Common$Marketplace$Product$LinkType$default = 0;
var $author$project$Components$Partner$ManagePartnerProductLinks$linkFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var title = field.a;
				return _Utils_update(
					fields,
					{$G: title});
			case 1:
				var value = field.a;
				return _Utils_update(
					fields,
					{aaN: value});
			case 2:
				var linkType = field.a;
				return _Utils_update(
					fields,
					{
						SV: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Common$Marketplace$Product$LinkType$default,
							$author$project$Api$Common$Marketplace$Product$LinkType$fromString(linkType))
					});
			case 3:
				var campaign = field.a;
				return _Utils_update(
					fields,
					{aaJ: campaign});
			default:
				var content = field.a;
				return _Utils_update(
					fields,
					{aaK: content});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$TitleValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductLinks$ValueValidation = 1;
var $author$project$Components$Partner$ManagePartnerProductLinks$valueLabel = function (linkType) {
	switch (linkType) {
		case 0:
			return 'URL';
		case 1:
			return 'Email address';
		default:
			return 'Phone number';
	}
};
var $author$project$Components$Partner$ManagePartnerProductLinks$validateValue = function (fields) {
	if ($elm$core$String$isEmpty(fields.aaN)) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				1,
				'Please enter a ' + ($author$project$Components$Partner$ManagePartnerProductLinks$valueLabel(fields.SV) + '.'))
			]);
	} else {
		var _v0 = fields.SV;
		switch (_v0) {
			case 0:
				return $author$project$Utils$Validate$isInvalidUrl(fields.aaN) ? _List_fromArray(
					[
						_Utils_Tuple2(1, 'Please enter a valid URL.')
					]) : _List_Nil;
			case 1:
				return A2(
					$author$project$Utils$Validate$isInvalidEmail,
					{abh: true},
					$elm$core$Maybe$Just(fields.aaN)) ? _List_fromArray(
					[
						_Utils_Tuple2(1, 'Please enter a valid email address.')
					]) : _List_Nil;
			default:
				return A2($author$project$Utils$Validate$doesNotMatchRegex, fields.aaN, '^\\d+$') ? _List_fromArray(
					[
						_Utils_Tuple2(1, 'Please enter a valid phone number.')
					]) : _List_Nil;
		}
	}
};
var $author$project$Components$Partner$ManagePartnerProductLinks$linkValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.$G;
			},
			_Utils_Tuple2(0, 'Please enter a title.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManagePartnerProductLinks$validateValue)
		]));
var $author$project$Components$Partner$ManagePartnerProductLinks$Created = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$One$PartnerProductLink = 0;
var $author$project$Api$Partner$PartnerProductLink$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Common$Marketplace$Product$LinkType$toString = function (linkType) {
	switch (linkType) {
		case 0:
			return 'url';
		case 1:
			return 'email';
		default:
			return 'phone';
	}
};
var $author$project$Api$Partner$PartnerProductLink$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_link',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.$G)),
								_Utils_Tuple2(
								'value',
								$elm$json$Json$Encode$string(params.aaN)),
								_Utils_Tuple2(
								'link_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Common$Marketplace$Product$LinkType$toString(params.SV))),
								_Utils_Tuple2(
								'utm_campaign',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aaJ)),
								_Utils_Tuple2(
								'utm_content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aaK))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductLink$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath)));
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$createLink = F2(
	function (apiClient, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.$G;
		var linkType = _v0.SV;
		var value = _v0.aaN;
		var utmCampaign = _v0.aaJ;
		var utmContent = _v0.aaK;
		return A3(
			$author$project$Api$Partner$PartnerProductLink$create,
			apiClient,
			{
				SV: linkType,
				$G: title,
				aaJ: $author$project$Utils$Maybe$fromString(utmCampaign),
				aaK: $author$project$Utils$Maybe$fromString(utmContent),
				aaN: value
			},
			$author$project$Components$Partner$ManagePartnerProductLinks$Created);
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$Updated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_link',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.$G)),
								_Utils_Tuple2(
								'value',
								$elm$json$Json$Encode$string(params.aaN)),
								_Utils_Tuple2(
								'link_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Common$Marketplace$Product$LinkType$toString(params.SV))),
								_Utils_Tuple2(
								'utm_campaign',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aaJ)),
								_Utils_Tuple2(
								'utm_content',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aaK))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductLink$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath(id))));
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$updateLink = F3(
	function (apiClient, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.$G;
		var linkType = _v0.SV;
		var value = _v0.aaN;
		var utmCampaign = _v0.aaJ;
		var utmContent = _v0.aaK;
		return A4(
			$author$project$Api$Partner$PartnerProductLink$update,
			apiClient,
			id,
			{
				SV: linkType,
				$G: title,
				aaJ: $author$project$Utils$Maybe$fromString(utmCampaign),
				aaK: $author$project$Utils$Maybe$fromString(utmContent),
				aaN: value
			},
			$author$project$Components$Partner$ManagePartnerProductLinks$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$save = F3(
	function (apiClient, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A3($author$project$Components$Partner$ManagePartnerProductLinks$updateLink, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Partner$ManagePartnerProductLinks$createLink, apiClient, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							G: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductLinks$initLinkFields),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 2:
				var productLink = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							G: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productLink),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductLinks$initLinkFieldsForEdit(productLink)),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{G: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 3:
				var field = msg.a;
				var _v2 = model.G;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var request = _v3.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductLinks$linkFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								G: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 4:
				var _v4 = model.G;
				if (!_v4.$) {
					var _v5 = _v4.a;
					var productLink = _v5.a;
					var form = _v5.b;
					var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductLinks$linkValidator, form);
					if (!_v6.$) {
						var _v7 = _v6.a;
						var validatedForm = _v7.a;
						var validFormFields = _v7.b;
						var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductLink$Shared$id, productLink);
						return {
							EC: A3($author$project$Components$Partner$ManagePartnerProductLinks$save, apiClient, id, validFormFields),
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									G: $elm$core$Maybe$Just(
										_Utils_Tuple3(productLink, validatedForm, $author$project$Api$Data$Loading))
								}),
							as: _List_Nil
						};
					} else {
						var validatedForm = _v6.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									G: $elm$core$Maybe$Just(
										_Utils_Tuple3(productLink, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 5:
				var response = msg.a;
				var _v8 = model.G;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var productLink = _v9.a;
					var form = _v9.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: _Utils_update(
								model,
								{G: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product link created successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									G: $elm$core$Maybe$Just(
										_Utils_Tuple3(productLink, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				var response = msg.a;
				var _v11 = model.G;
				if (!_v11.$) {
					var _v12 = _v11.a;
					var productLink = _v12.a;
					var form = _v12.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: _Utils_update(
								model,
								{G: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product link updated successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									G: $elm$core$Maybe$Just(
										_Utils_Tuple3(productLink, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 7:
				var productLink = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							bZ: $elm$core$Maybe$Just(
								_Utils_Tuple2(productLink, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 8:
				var confirmed = msg.a;
				var _v14 = model.bZ;
				if (!_v14.$) {
					var _v15 = _v14.a;
					var productLink = _v15.a;
					return confirmed ? {
						EC: A3(
							$author$project$Api$Partner$PartnerProductLink$delete,
							apiClient,
							$author$project$Api$Partner$PartnerProductLink$Shared$id(productLink),
							$author$project$Components$Partner$ManagePartnerProductLinks$Deleted),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								bZ: $elm$core$Maybe$Just(
									_Utils_Tuple2(productLink, $author$project$Api$Data$Loading))
							}),
						as: _List_Nil
					} : {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{bZ: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 10:
				var url = msg.a;
				return {
					EC: $author$project$Ports$Clipboard$copy(url),
					ac5: 0,
					y8: model,
					as: _List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						])
				};
			default:
				var response = msg.a;
				var _v16 = model.bZ;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var productLink = _v17.a;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 3,
							y8: _Utils_update(
								model,
								{bZ: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product link deleted successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									bZ: $elm$core$Maybe$Just(
										_Utils_Tuple2(productLink, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImage = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$Deleted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$None = 0;
var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteUpdated = 2;
var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_product_quotes']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath);
};
var $author$project$Api$Partner$PartnerProductQuote$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath(id)));
	});
var $author$project$Api$Partner$PartnerProductQuote$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFields = {Jz: '', k6: $elm$core$Maybe$Nothing, pA: 0, JB: '', p2: $elm$core$Maybe$Nothing, $A: ''};
var $author$project$Api$Partner$PartnerProductQuote$Shared$author = function (_v0) {
	var record = _v0;
	return record.Jz;
};
var $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl = function (_v0) {
	var record = _v0;
	return record.JA;
};
var $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle = function (_v0) {
	var record = _v0;
	return record.JB;
};
var $author$project$Api$Partner$PartnerProductQuote$Shared$text = function (_v0) {
	var record = _v0;
	return record.$A;
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFieldsForEdit = function (productQuote) {
	return {
		Jz: $author$project$Api$Partner$PartnerProductQuote$Shared$author(productQuote),
		k6: $elm$core$Maybe$Nothing,
		pA: 0,
		JB: $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle(productQuote),
		p2: $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl(productQuote),
		$A: $author$project$Api$Partner$PartnerProductQuote$Shared$text(productQuote)
	};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$quoteFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var text = field.a;
				return _Utils_update(
					fields,
					{$A: text});
			case 1:
				var author = field.a;
				return _Utils_update(
					fields,
					{Jz: author});
			case 2:
				var authorTitle = field.a;
				return _Utils_update(
					fields,
					{JB: authorTitle});
			default:
				var imageSize = field.a;
				var imageUrl = field.b;
				return _Utils_update(
					fields,
					{
						k6: $elm$core$Maybe$Just(imageUrl),
						pA: imageSize,
						p2: $elm$core$Maybe$Just(imageUrl)
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageValidation = 3;
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitleValidation = 2;
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorValidation = 1;
var $author$project$Components$Partner$ManagePartnerProductQuotes$TextValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductQuotes$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$ManagePartnerProductQuotes$quoteValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.$A;
			},
			_Utils_Tuple2(0, 'Please enter a text.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Jz;
			},
			_Utils_Tuple2(1, 'Please enter an author.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.JB;
			},
			_Utils_Tuple2(2, 'Please enter an author title.')),
			A3(
			$author$project$Utils$Validate$ifIntGreaterThan,
			function ($) {
				return $.pA;
			},
			$author$project$Components$Partner$ManagePartnerProductQuotes$maxLogoBytesSize,
			_Utils_Tuple2(3, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
		]));
var $author$project$Components$Partner$ManagePartnerProductQuotes$Created = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProductQuote$One$PartnerProductQuote = 0;
var $author$project$Api$Partner$PartnerProductQuote$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams = function (params) {
	var authorImageUrl = function () {
		var _v0 = params.JA;
		if (!_v0.$) {
			var base64 = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(
					'author_image',
					$elm$json$Json$Encode$string(base64))
				]);
		} else {
			return _List_Nil;
		}
	}();
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'partner_product_quote',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'text',
							$elm$json$Json$Encode$string(params.$A)),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'author',
								$elm$json$Json$Encode$string(params.Jz)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'author_title',
									$elm$json$Json$Encode$string(params.JB)),
								authorImageUrl)))))
			]));
};
var $author$project$Api$Partner$PartnerProductQuote$create = F3(
	function (apiClient, params, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductQuote$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams(params),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath)));
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$createProductQuote = F2(
	function (apiClient, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var text = _v0.$A;
		var author = _v0.Jz;
		var authorTitle = _v0.JB;
		var authorImage = _v0.k6;
		return A3(
			$author$project$Api$Partner$PartnerProductQuote$create,
			apiClient,
			{Jz: author, JA: authorImage, JB: authorTitle, $A: text},
			$author$project$Components$Partner$ManagePartnerProductQuotes$Created);
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$Updated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProductQuote$update = F4(
	function (apiClient, id, params, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductQuote$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams(params),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath(id))));
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$updateProductQuote = F3(
	function (apiClient, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var text = _v0.$A;
		var author = _v0.Jz;
		var authorTitle = _v0.JB;
		var authorImage = _v0.k6;
		return A4(
			$author$project$Api$Partner$PartnerProductQuote$update,
			apiClient,
			id,
			{Jz: author, JA: authorImage, JB: authorTitle, $A: text},
			$author$project$Components$Partner$ManagePartnerProductQuotes$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$save = F3(
	function (apiClient, id, formFields) {
		if (!id.$) {
			var id_ = id.a;
			return A3($author$project$Components$Partner$ManagePartnerProductQuotes$updateProductQuote, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Partner$ManagePartnerProductQuotes$createProductQuote, apiClient, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							H: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFields),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{H: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 3:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var task = _v2.a;
							var size = _v2.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated,
									$author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImage(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return {EC: cmd, ac5: 0, y8: model, as: _List_Nil};
			case 2:
				var field = msg.a;
				var _v3 = model.H;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var id = _v4.a;
					var form = _v4.b;
					var request = _v4.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductQuotes$quoteFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								H: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 4:
				var productQuote = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							H: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productQuote),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFieldsForEdit(productQuote)),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 5:
				var _v5 = model.H;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var item = _v6.a;
					var form = _v6.b;
					var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductQuotes$quoteValidator, form);
					if (!_v7.$) {
						var _v8 = _v7.a;
						var validatedForm = _v8.a;
						var validFormFields = _v8.b;
						var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductQuote$Shared$id, item);
						return {
							EC: A3($author$project$Components$Partner$ManagePartnerProductQuotes$save, apiClient, id, validFormFields),
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
								}),
							as: _List_Nil
						};
					} else {
						var validatedForm = _v7.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				var response = msg.a;
				var _v9 = model.H;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var productQuote = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: _Utils_update(
								model,
								{H: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product quote created successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										_Utils_Tuple3(productQuote, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 7:
				var response = msg.a;
				var _v12 = model.H;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var item = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 2,
							y8: _Utils_update(
								model,
								{H: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product quote updated successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									H: $elm$core$Maybe$Just(
										_Utils_Tuple3(item, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 8:
				var productQuote = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							b0: $elm$core$Maybe$Just(
								_Utils_Tuple2(productQuote, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 9:
				var confirmed = msg.a;
				var _v15 = model.b0;
				if (!_v15.$) {
					var _v16 = _v15.a;
					var productQuote = _v16.a;
					return confirmed ? {
						EC: A3(
							$author$project$Api$Partner$PartnerProductQuote$delete,
							apiClient,
							$author$project$Api$Partner$PartnerProductQuote$Shared$id(productQuote),
							$author$project$Components$Partner$ManagePartnerProductQuotes$Deleted),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								b0: $elm$core$Maybe$Just(
									_Utils_Tuple2(productQuote, $author$project$Api$Data$Loading))
							}),
						as: _List_Nil
					} : {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{b0: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			default:
				var response = msg.a;
				var _v17 = model.b0;
				if (!_v17.$) {
					var _v18 = _v17.a;
					var productQuote = _v18.a;
					if (response.$ === 3) {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 3,
							y8: _Utils_update(
								model,
								{b0: $elm$core$Maybe$Nothing}),
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Product quote deleted successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									b0: $elm$core$Maybe$Just(
										_Utils_Tuple2(productQuote, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Pages$Partner$Product$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							w: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init(
									$author$project$Pages$Partner$Product$Icon($elm$core$Maybe$Nothing)))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var icons = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var task = _v1.a;
							var size = _v1.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$Edited, $author$project$Pages$Partner$Product$Icon),
										$elm$core$Maybe$Just),
									$elm$core$Tuple$pair(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (icon) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(icon),
									$elm$file$File$size(icon));
							},
							$elm$core$List$head(icons))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 0:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							w: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init(field))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{w: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var form = msg.a;
				return A2($author$project$Pages$Partner$Product$submit, model, form);
			case 3:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							w: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init(field))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 19:
				var ctaMsg = msg.a;
				var _v2 = A3($author$project$Components$Marketplace$Product$CallToAction$update, model.D5, ctaMsg, model.bR);
				var callToAction = _v2.a;
				var ctaCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bR: callToAction}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$CallToActionMsg, ctaCmd),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var product = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bR: A2(
									$author$project$Components$Marketplace$Product$CallToAction$setProduct,
									$author$project$Pages$Partner$Product$toCallToActionProduct(product),
									model.bR),
								W8: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{W8: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{w: $elm$core$Maybe$Nothing, S_: false, W8: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Product updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var showAlert = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var partner = response.a;
					var _v6 = A2($author$project$Components$Partner$ManagePartnerProductQuotes$init, partner, model.qT);
					var managePartnerProductQuotes = _v6.a;
					var managePartnerProductQuotesCmd = _v6.b;
					var _v7 = A2($author$project$Components$Partner$ManagePartnerProductLinks$init, partner, model.qT);
					var managePartnerProductLinks = _v7.a;
					var managePartnerProductLinksCmd = _v7.b;
					var _v8 = A2($author$project$Components$Partner$ManagePartnerProductHighlights$init, partner, model.qT);
					var managePartnerProductHighlights = _v8.a;
					var managePartnerProductHighlightsCmd = _v8.b;
					var _v9 = A2($author$project$Components$Partner$ManagePartnerProductDataFlows$init, partner, model.qT);
					var managePartnerProductDataFlows = _v9.a;
					var managePartnerProductDataFlowsCmd = _v9.b;
					var _v10 = A2($author$project$Components$Partner$ManagePartnerProductCategories$init, model.D5, partner);
					var manageCategories = _v10.a;
					var manageCategoriesCmd = _v10.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								pO: $author$project$Components$Carousel$reset(model.pO),
								S_: false,
								fY: manageCategories,
								fZ: managePartnerProductDataFlows,
								f_: managePartnerProductHighlights,
								f$: managePartnerProductLinks,
								f0: managePartnerProductQuotes,
								Vz: partner
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, managePartnerProductHighlightsCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg, managePartnerProductLinksCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, managePartnerProductDataFlowsCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg, manageCategoriesCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, managePartnerProductQuotesCmd)
								])),
						A2(
							$elm$core$List$cons,
							$author$project$OutMsg$RefreshPartner,
							showAlert ? _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!')
								]) : _List_Nil));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{S_: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 9:
				var subMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2(
						$elm$core$Tuple$mapFirst,
						function (carousel) {
							return _Utils_update(
								model,
								{pO: carousel});
						},
						A2($author$project$Components$Carousel$update, subMsg, model.pO)));
			case 10:
				var images = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qF: model.qF + 1, S_: true}),
					A2(
						$elm$core$Task$perform,
						function (urls) {
							var existingImages = A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Partner$PartnerProductOverview$Shared$images,
									$author$project$Api$Partner$Partner$One$productOverview(model.Vz)));
							return $author$project$Pages$Partner$Product$Saved(
								$author$project$Utils$Form$init(
									A2($author$project$Pages$Partner$Product$ProductOverviewImages, existingImages, urls)));
						},
						$elm$core$Task$sequence(
							A2($elm$core$List$map, $elm$file$File$toUrl, images))),
					_List_Nil);
			case 11:
				var imageId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fp: $elm$core$Maybe$Just(imageId)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var confirmed = msg.a;
				var _v11 = _Utils_Tuple2(confirmed, model.fp);
				if (_v11.a && (!_v11.b.$)) {
					var imageId = _v11.b.a;
					var remainingImages = A2(
						$elm$core$List$filter,
						function (img) {
							return !_Utils_eq(
								$author$project$Api$Partner$ProductImage$Shared$id(img),
								imageId);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Partner$PartnerProductOverview$Shared$images,
								$author$project$Api$Partner$Partner$One$productOverview(model.Vz))));
					return A2(
						$author$project$Pages$Partner$Product$submit,
						_Utils_update(
							model,
							{fp: $elm$core$Maybe$Nothing}),
						$author$project$Utils$Form$init(
							A2($author$project$Pages$Partner$Product$ProductOverviewImages, remainingImages, _List_Nil)));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fp: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 13:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductLinks$update, model.D5, subMsg, model.f$);
				var extraCmd = function () {
					var _v12 = result.ac5;
					switch (_v12) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						case 2:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						default:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f$: result.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg, result.EC),
								extraCmd
							])),
					result.as);
			case 14:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductHighlights$update, model.D5, subMsg, model.f_);
				var extraCmd = function () {
					var _v13 = result.ac5;
					switch (_v13) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						case 2:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						default:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f_: result.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, result.EC),
								extraCmd
							])),
					result.as);
			case 15:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductDataFlows$update, model.D5, subMsg, model.fZ);
				var extraCmd = function () {
					var _v14 = result.ac5;
					switch (_v14) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						case 2:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						default:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fZ: result.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, result.EC),
								extraCmd
							])),
					result.as);
			case 16:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductCategories$update, model.D5, subMsg, model.fY);
				var extraCmd = function () {
					var _v15 = result.ac5;
					switch (_v15) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						case 2:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						default:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fY: result.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg, result.EC),
								extraCmd
							])),
					result.as);
			case 17:
				var subMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductQuotes$update, model.D5, subMsg, model.f0);
				var extraCmd = function () {
					var _v16 = result.ac5;
					switch (_v16) {
						case 0:
							return $elm$core$Platform$Cmd$none;
						case 1:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						case 2:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
						default:
							return A2(
								$author$project$Api$Partner$Partner$retrieve,
								model.D5,
								$author$project$Pages$Partner$Product$GotPartnerUpdated(false));
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f0: result.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, result.EC),
								extraCmd
							])),
					result.as);
			default:
				var value = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(value),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						]));
		}
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$viewDeleteConfirmModal = function (model) {
	var _v0 = model.bW;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('remove'),
					$author$project$Components$HiConfirm$noun('category'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$Save = {$: 3};
var $author$project$Components$Partner$ManagePartnerProductCategories$SelectedCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductCategories$viewEditModal = function (model) {
	var _v0 = model.C;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var form = _v1.b;
		var request = _v1.c;
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Category',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Nothing,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd,
			U0: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductCategories$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var categories = function () {
			var _v2 = model.KL;
			if (_v2.$ === 3) {
				var cats = _v2.a;
				return cats;
			} else {
				return _List_Nil;
			}
		}();
		var options = A2(
			$elm$core$List$map,
			function (cat) {
				return A2(
					$author$project$Ui$NewDropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$onSelect(
							$author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated(
								$author$project$Components$Partner$ManagePartnerProductCategories$SelectedCategory(cat))),
							$author$project$Ui$NewDropdown$selected(
							_Utils_eq(
								fields.oa,
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$Category$id(cat))))
						]),
					$elm$html$Html$text(
						$author$project$Api$Common$Marketplace$Product$Category$name(cat)));
			},
			categories);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A4(
							$author$project$Ui$NewDropdown$viewCombobox,
							_List_Nil,
							{
								ae8: $elm$core$Maybe$Nothing,
								afc: A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductCategories$Name, $author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated),
								aaN: fields.zh
							},
							options,
							model.lm)
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Partner$ManagePartnerProductCategories$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductCategories$viewDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductCategories$viewEditModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowDeleteConfirmModal = function (model) {
	var _v0 = model.b$;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('synced field'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$HintName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Save = {$: 4};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$SyncDirection = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$linkTypeOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var syncDirection = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Common$Marketplace$Product$SyncDirection$toString(syncDirection)),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2(1, 'To Hint'),
			_Utils_Tuple2(0, 'From Hint'),
			_Utils_Tuple2(2, 'Two-way')
		]));
var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowEditModal = function (_v0) {
	var productDataFlow = _v0.D;
	if (!productDataFlow.$) {
		var _v2 = productDataFlow.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Synced field',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDataFlow$Shared$id, item),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd,
			U0: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductDataFlows$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Hint name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Qx),
									$author$project$Ui$Form$Input$placeholder('Invoice'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDataFlows$HintName, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Partner name'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.VE),
									$author$project$Ui$Form$Input$placeholder('Expense'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerName, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8),
							$author$project$Ui$Form$Group$label('Sync Direction')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$SyncDirection$toString(fields.$h))),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated, $author$project$Components$Partner$ManagePartnerProductDataFlows$SyncDirection))
								]),
							$author$project$Components$Partner$ManagePartnerProductDataFlows$linkTypeOptions)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowEditModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightDeleteConfirmModal = function (model) {
	var _v0 = model.bY;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('highlight'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$ImageUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$SaveHighlight = {$: 5};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightModal = function (_v0) {
	var productHighlight = _v0.F;
	if (!productHighlight.$) {
		var _v2 = productHighlight.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Highlight',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductHighlight$Shared$id, item),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit,
			U0: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductHighlights$SaveHighlight)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Title')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.$G),
									$author$project$Ui$Form$Input$placeholder('Highlight title'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductHighlights$Title, $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Description')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(fields.Nx),
									$author$project$Ui$Form$Textarea$placeholder('Highlight description'),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductHighlights$Description, $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated)),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Textarea$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Image')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$File$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$File$accept(0),
									$author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductHighlights$ImageUploaded),
									$author$project$Ui$Form$File$empty(true)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Recommended size: 256x160 px or larger.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('Supported image file: JPG, PNG')
								])),
							function () {
							var _v3 = fields.p4;
							if (!_v3.$) {
								if (_v3.a === '') {
									return $author$project$Utils$Html$empty;
								} else {
									var url = _v3.a;
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Image$fromSrc,
												{I1: 'Uploaded image'},
												url,
												_List_fromArray(
													[
														$author$project$Ui$Image$height(50)
													])),
												$author$project$Utils$FormErrors$view(
												A2($author$project$Utils$Form$validationErrors, 2, form))
											]));
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductLinks$viewLinkDeleteConfirmModal = function (model) {
	var _v0 = model.bZ;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('link'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductLinks$CopyUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$LinkType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Save = {$: 4};
var $author$project$Components$Partner$ManagePartnerProductLinks$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$UtmCampaign = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$UtmContent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Value = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$linkTypeOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var linkType = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Common$Marketplace$Product$LinkType$toString(linkType)),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2(0, 'URL'),
			_Utils_Tuple2(1, 'Email'),
			_Utils_Tuple2(2, 'Phone')
		]));
var $author$project$Components$Partner$UtmLinkPreview$buildPreviewUrl = function (params) {
	if ($elm$core$String$isEmpty(params.aav)) {
		return $elm$core$Maybe$Nothing;
	} else {
		var separator = A2($elm$core$String$contains, '?', params.aav) ? '&' : '?';
		var campaign = $elm$core$String$isEmpty(params.aaJ) ? 'hint_marketplace' : params.aaJ;
		var utmParams = A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'utm_source', 'hint')),
					$elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'utm_medium', 'marketplace')),
					$elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'utm_campaign', campaign)),
					$elm$core$String$isEmpty(params.aaK) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2($elm$url$Url$Builder$string, 'utm_content', params.aaK))
				]));
		return $elm$core$Maybe$Just(
			function (query) {
				return _Utils_ap(
					params.aav,
					_Utils_ap(separator, query));
			}(
				A2(
					$elm$core$String$dropLeft,
					1,
					$elm$url$Url$Builder$toQuery(utmParams))));
	}
};
var $elm$html$Html$code = _VirtualDom_node('code');
var $author$project$Components$Partner$UtmLinkPreview$view = F2(
	function (params, onCopy) {
		var _v0 = $author$project$Components$Partner$UtmLinkPreview$buildPreviewUrl(params);
		if (_v0.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var previewUrl = _v0.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$pre,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-xs text-muted bg-gray-50 rounded p-2 whitespace-pre-wrap break-all flex-1 m-0')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$code,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(previewUrl)
									]))
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Copy URL'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
								$author$project$Ui$Button$size(0),
								$author$project$Ui$Button$onClick(
								onCopy(previewUrl))
							]),
						_List_Nil)
					]));
		}
	});
var $author$project$Components$Partner$ManagePartnerProductLinks$viewLinkEditModal = function (_v0) {
	var productLink = _v0.G;
	if (!productLink.$) {
		var _v2 = productLink.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Qn: $elm$core$Maybe$Just('Add a link to your product that will be displayed on the product page.'),
			aej: 'Link',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductLink$Shared$id, item),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd,
			U0: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductLinks$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		var valuePlaceholder = function () {
			var _v3 = fields.SV;
			switch (_v3) {
				case 0:
					return 'https://example.com';
				case 1:
					return 'example@example.com';
				default:
					return '(123) 456-7890';
			}
		}();
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Title'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.$G),
									$author$project$Ui$Form$Input$placeholder('Link title'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$Title, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Type')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Api$Common$Marketplace$Product$LinkType$toString(fields.SV))),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated, $author$project$Components$Partner$ManagePartnerProductLinks$LinkType))
									]),
								$author$project$Components$Partner$ManagePartnerProductLinks$linkTypeOptions)
							])),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label(
									$author$project$Components$Partner$ManagePartnerProductLinks$valueLabel(fields.SV)),
									$author$project$Ui$Form$Group$required(true)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.aaN),
											$author$project$Ui$Form$Input$placeholder(valuePlaceholder),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$Value, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated)),
											$author$project$Ui$Form$Input$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
											$author$project$Ui$Form$Input$errors(
											A2($author$project$Utils$Form$validationErrors, 1, form))
										]))
								])),
						(!fields.SV) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('UTM Campaign')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.aaJ),
												$author$project$Ui$Form$Input$placeholder('hint_marketplace'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$UtmCampaign, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpan(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('UTM Content')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields.aaK),
												$author$project$Ui$Form$Input$placeholder('Optional'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$UtmContent, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated))
											]))
									])),
								A2(
								$author$project$Components$Partner$UtmLinkPreview$view,
								{aav: fields.aaN, aaJ: fields.aaJ, aaK: fields.aaK},
								$author$project$Components$Partner$ManagePartnerProductLinks$CopyUrl)
							]) : _List_Nil))));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductLinks$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductLinks$viewLinkDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductLinks$viewLinkEditModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteDeleteConfirmModal = function (model) {
	var _v0 = model.b0;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('quote'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Author = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageUploaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Save = {$: 5};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Text = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteModal = function (_v0) {
	var productQuote = _v0.H;
	if (!productQuote.$) {
		var _v2 = productQuote.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Quote',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductQuote$Shared$id, item),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit,
			U0: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductQuotes$Save)
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Quote'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(fields.$A),
									$author$project$Ui$Form$Textarea$placeholder('Quote'),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$Text, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Textarea$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Author'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Jz),
									$author$project$Ui$Form$Input$placeholder('Author'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$Author, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Author Title'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.JB),
									$author$project$Ui$Form$Input$placeholder('Author Title'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitle, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 2, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Author Image')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$File$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$File$accept(0),
									$author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageUploaded),
									$author$project$Ui$Form$File$empty(true)
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Recommended size: 256x160 px or larger.'),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									$elm$html$Html$text('Supported image file: JPG, PNG')
								])),
							function () {
							var _v3 = fields.p2;
							if (!_v3.$) {
								if (_v3.a === '') {
									return $author$project$Utils$Html$empty;
								} else {
									var url = _v3.a;
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt4]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Image$fromSrc,
												{I1: 'Uploaded image'},
												url,
												_List_fromArray(
													[
														$author$project$Ui$Image$height(50)
													])),
												$author$project$Utils$FormErrors$view(
												A2($author$project$Utils$Form$validationErrors, 3, form))
											]));
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteModal(model)
			]));
};
var $author$project$Pages$Partner$Product$Attribution = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Partner$Product$Edit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Product$EditIconClicked = {$: 7};
var $author$project$Ui$Image$MarketplaceIconPlaceholder = 16;
var $author$project$Pages$Partner$Product$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Product$ProductDescription = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Product$ProductType = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProduct$One$builtByName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$builtByName(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$builtByUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$featured = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$featured(shared);
};
var $author$project$Api$Partner$PartnerProduct$One$summary = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerProduct$Shared$summary(shared);
};
var $author$project$Components$Marketplace$Product$CallToAction$disabled = 0;
var $author$project$Pages$Partner$Product$ExternalCta = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProduct$One$utmCampaign = function (_v0) {
	var record = _v0.b;
	return record.aaJ;
};
var $author$project$Api$Partner$PartnerProduct$One$utmContent = function (_v0) {
	var record = _v0.b;
	return record.aaK;
};
var $author$project$Pages$Partner$Product$externalCtaEditField = function (product) {
	return $author$project$Pages$Partner$Product$ExternalCta(
		{
			aav: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Partner$PartnerProduct$One$ctaUrl(product)),
			aaJ: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Partner$PartnerProduct$One$utmCampaign(product)),
			aaK: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Partner$PartnerProduct$One$utmContent(product))
		});
};
var $author$project$Pages$Partner$Product$viewCtaButton = F2(
	function (callToAction, product) {
		var _v0 = $author$project$Api$Partner$PartnerProduct$One$type_(product);
		if (_v0 === 2) {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('inline-edit w-full'),
								$elm$html$Html$Events$onClick(
								$author$project$Pages$Partner$Product$Edit(
									$author$project$Pages$Partner$Product$externalCtaEditField(product)))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$Marketplace$Product$CallToAction$button,
								_List_fromArray(
									[$author$project$Components$Marketplace$Product$CallToAction$disabled]),
								callToAction),
								$author$project$Ui$SvgIcon$edit(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$xs]))
							]))
					]));
		} else {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$Marketplace$Product$CallToAction$button,
						_List_fromArray(
							[$author$project$Components$Marketplace$Product$CallToAction$disabled]),
						callToAction)
					]));
		}
	});
var $author$project$Pages$Partner$Product$viewInlineEdit = F2(
	function (msg, viewView) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline-edit'),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$map, $elm$core$Basics$never, viewView),
					$author$project$Ui$SvgIcon$edit(
					_List_fromArray(
						[$author$project$Ui$SvgIcon$xs]))
				]));
	});
var $author$project$Pages$Partner$Product$productCard = F4(
	function (imageStore, partner, product, callToAction) {
		var productSummary = $author$project$Api$Partner$PartnerProduct$One$summary(product);
		var productName = $author$project$Api$Partner$PartnerProduct$One$name(product);
		var builtByUrl = $author$project$Api$Partner$PartnerProduct$One$builtByUrl(product);
		var builtByName = $author$project$Api$Partner$PartnerProduct$One$builtByName(product);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('card'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'card--highlighted',
							$author$project$Api$Partner$PartnerProduct$One$featured(product))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Partner$Product$viewInlineEdit,
							$author$project$Pages$Partner$Product$EditIconClicked,
							function () {
								var _v0 = $author$project$Api$Partner$Partner$One$marketplaceIconUrl(partner);
								if (!_v0.$) {
									var icon = _v0.a;
									return A3(
										$author$project$Ui$Image$fromSrc,
										{I1: productName + ' icon'},
										icon,
										_List_fromArray(
											[
												$author$project$Ui$Image$height(64)
											]));
								} else {
									return A4(
										$author$project$Ui$Image$view,
										imageStore,
										{I1: 'Product icon placeholder'},
										_List_fromArray(
											[
												$author$project$Ui$Image$height(64)
											]),
										16);
								}
							}()),
							A2(
							$author$project$Pages$Partner$Product$viewInlineEdit,
							$author$project$Pages$Partner$Product$Edit(
								$author$project$Pages$Partner$Product$Name(productName)),
							$author$project$Ui$Typography$headingSm(
								$elm$core$List$singleton(
									$elm$html$Html$text(productName))))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Partner$Product$viewInlineEdit,
							$author$project$Pages$Partner$Product$Edit(
								$author$project$Pages$Partner$Product$ProductType(
									$author$project$Api$Partner$PartnerProduct$One$type_(product))),
							A2(
								$author$project$Ui$Badge$view,
								_List_fromArray(
									[$author$project$Ui$Badge$neutral]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Common$Marketplace$Product$ProductType$toString(
											$author$project$Api$Partner$PartnerProduct$One$type_(product)))
									])))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A2(
							$author$project$Pages$Partner$Product$viewInlineEdit,
							$author$project$Pages$Partner$Product$Edit(
								$author$project$Pages$Partner$Product$ProductDescription(
									A2($elm$core$Maybe$withDefault, '', productSummary))),
							function () {
								if (!productSummary.$) {
									var description = productSummary.a;
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted]),
										_List_fromArray(
											[
												$elm$html$Html$text(description)
											]));
								} else {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-muted')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('N/A')
											]));
								}
							}())
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt4, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Built by ')
								])),
							A2(
							$author$project$Pages$Partner$Product$viewInlineEdit,
							$author$project$Pages$Partner$Product$Edit(
								A2($author$project$Pages$Partner$Product$Attribution, builtByName, builtByUrl)),
							function () {
								var _v2 = _Utils_Tuple2(builtByName, builtByUrl);
								if (!_v2.a.$) {
									if (!_v2.b.$) {
										var name = _v2.a.a;
										var url = _v2.b.a;
										return A3(
											$author$project$Ui$Link$externalHref,
											url,
											_List_fromArray(
												[
													$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$launch),
													$author$project$Ui$Link$targetBlank
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(name)
												]));
									} else {
										var name = _v2.a.a;
										var _v3 = _v2.b;
										return $elm$html$Html$text(name);
									}
								} else {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-muted')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('N/A')
											]));
								}
							}())
						])),
					A2($author$project$Pages$Partner$Product$viewCtaButton, callToAction, product)
				]));
	});
var $author$project$Components$Partner$ManagePartnerProductCategories$Add = {$: 0};
var $author$project$Components$Partner$ManagePartnerProductCategories$Remove = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProductCategory$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Partner$PartnerProductCategory$One$id = $author$project$Api$Partner$PartnerProductCategory$Shared$id;
var $author$project$Api$Partner$PartnerProductCategory$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Partner$PartnerProductCategory$One$name = $author$project$Api$Partner$PartnerProductCategory$Shared$name;
var $author$project$Api$Partner$Partner$One$productCategories = function (_v0) {
	var record = _v0.b;
	return record.W9;
};
var $author$project$Components$Partner$ManagePartnerProductCategories$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Categories')
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Add category'},
					_List_fromArray(
						[
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
							$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductCategories$Add)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Category')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$gap2, $author$project$Ui$Element$wrap]),
			A2(
				$elm$core$List$map,
				function (cat) {
					return A3(
						$author$project$Ui$Button$view,
						{abp: 'Remove category'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductCategories$Remove(
									$author$project$Api$Partner$PartnerProductCategory$One$id(cat)))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr2]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Partner$PartnerProductCategory$One$name(cat))
									])),
								$author$project$Ui$SvgIcon$cross(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$xs]))
							]));
				},
				$author$project$Api$Partner$Partner$One$productCategories(model.Vz)))
		]);
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Add = {$: 0};
var $author$project$Api$Partner$Partner$One$productDataFlows = function (_v0) {
	var record = _v0.b;
	return record.Xa;
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Delete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$Edit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlow = F2(
	function (maybeIcon, productDataFlow) {
		var syncDirection = $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection(productDataFlow);
		var partnerName = $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName(productDataFlow);
		var hintName = $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName(productDataFlow);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									function () {
									if (!maybeIcon.$) {
										var iconUrl = maybeIcon.a;
										return A3(
											$author$project$Ui$Image$fromSrc,
											{I1: 'icon'},
											iconUrl,
											_List_fromArray(
												[
													$author$project$Ui$Image$height(20)
												]));
									} else {
										return $author$project$Ui$SvgIcon$package(
											_List_fromArray(
												[$author$project$Ui$SvgIcon$xl]));
									}
								}(),
									$elm$html$Html$text(partnerName)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textCenter]),
					_List_fromArray(
						[
							function () {
							switch (syncDirection) {
								case 0:
									return $author$project$Ui$SvgIcon$arrowLeft(_List_Nil);
								case 1:
									return $author$project$Ui$SvgIcon$arrowRight(_List_Nil);
								default:
									return $author$project$Ui$SvgIcon$transfer(
										_List_fromArray(
											[$author$project$Ui$SvgIcon$xl]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$hintHeart(
							_List_fromArray(
								[$author$project$Ui$SvgIcon$xl])),
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text(hintName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Edit synced field'},
							_List_fromArray(
								[
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
									$author$project$Ui$Button$onClick(
									$author$project$Components$Partner$ManagePartnerProductDataFlows$Edit(productDataFlow))
								]),
							_List_Nil),
							$author$project$Utils$Html$noBreakSpace,
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Delete synced field'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
									$author$project$Ui$Button$onClick(
									$author$project$Components$Partner$ManagePartnerProductDataFlows$Delete(productDataFlow))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Components$Partner$ManagePartnerProductDataFlows$view = function (_v0) {
	var model = _v0;
	var productDataFlows = $author$project$Api$Partner$Partner$One$productDataFlows(model.Vz);
	var iconUrl = $author$project$Api$Partner$Partner$One$marketplaceIconUrl(model.Vz);
	return A3(
		$author$project$Ui$Element$custom,
		'card',
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Data Syncing')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Add field'},
						_List_fromArray(
							[
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
								$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDataFlows$Add)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add Field')
							]))
					])),
				$author$project$Ui$HorizontalRule$view(
				_List_fromArray(
					[$author$project$Ui$HorizontalRule$thin])),
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'In ' + $author$project$Api$Partner$Partner$One$name(model.Vz))
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textCenter]),
						_List_fromArray(
							[
								$elm$html$Html$text('Sync Direction')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('In Hint')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[$author$project$Ui$Table$textRight]),
						_List_fromArray(
							[
								$elm$html$Html$text('Actions')
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlow(iconUrl),
					productDataFlows),
				_List_Nil)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Add = {$: 0};
var $author$project$Api$Partner$Partner$One$productHighlights = function (_v0) {
	var record = _v0.b;
	return record.Xc;
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Delete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductHighlights$viewProductHighlight = F2(
	function (model, productHighlight) {
		var title = $author$project$Api$Partner$PartnerProductHighlight$Shared$title(productHighlight);
		var description = $author$project$Api$Partner$PartnerProductHighlight$Shared$description(productHighlight);
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(3)
						]),
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl(productHighlight);
							if (!_v0.$) {
								var imageUrl = _v0.a;
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Image$fromSrc,
											{I1: 'Highlight image'},
											imageUrl,
											_List_fromArray(
												[
													$author$project$Ui$Image$rounded,
													$author$project$Ui$Image$fullWidth,
													$author$project$Ui$Image$heightAuto,
													$author$project$Ui$Image$class('object-contain')
												]))
										]));
							} else {
								return A4(
									$author$project$Ui$Image$view,
									model.qT,
									{I1: title + ' image'},
									_List_fromArray(
										[
											$author$project$Ui$Image$rounded,
											$author$project$Ui$Image$height(160),
											$author$project$Ui$Image$width(256)
										]),
									15);
							}
						}()
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$fullWidth]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text(title)
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Edit highlight'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManagePartnerProductHighlights$Edit(productHighlight))
														]),
													_List_Nil),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Delete highlight'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManagePartnerProductHighlights$Delete(productHighlight))
														]),
													_List_Nil)
												]))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$elm$core$Basics$never,
											A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$preWrap, $author$project$Ui$Typography$muted]),
												$author$project$Utils$Html$ulFromString(description)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManagePartnerProductHighlights$view = function (_v0) {
	var model = _v0;
	var productHighlights = $author$project$Api$Partner$Partner$One$productHighlights(model.Vz);
	return A3(
		$author$project$Ui$Element$custom,
		'card',
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Highlights')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Add highlight'},
								_List_fromArray(
									[
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
										$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductHighlights$Add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Highlight')
									]))
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap4]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Partner$ManagePartnerProductHighlights$viewProductHighlight(model),
							productHighlights))
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Add = {$: 0};
var $author$project$Api$Partner$Partner$One$productLinks = function (_v0) {
	var record = _v0.b;
	return record.Xd;
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Delete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductLinks$Edit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$PartnerProductLink$Shared$composedUrl = function (_v0) {
	var record = _v0;
	return record.LG;
};
var $author$project$Components$Partner$ManagePartnerProductLinks$viewProductLink = function (productLink) {
	var value = $author$project$Api$Partner$PartnerProductLink$Shared$value(productLink);
	var title = $author$project$Api$Partner$PartnerProductLink$Shared$title(productLink);
	var linkType = $author$project$Api$Partner$PartnerProductLink$Shared$linkType(productLink);
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				function () {
				switch (linkType) {
					case 0:
						var href = A2(
							$elm$core$Maybe$withDefault,
							value,
							$author$project$Api$Partner$PartnerProductLink$Shared$composedUrl(productLink));
						return A3(
							$author$project$Ui$Link$externalHref,
							href,
							_List_fromArray(
								[
									$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$launch),
									$author$project$Ui$Link$preventFocus,
									$author$project$Ui$Link$targetBlank
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]));
					case 1:
						return A3(
							$author$project$Ui$Link$mailto,
							value,
							_List_fromArray(
								[
									$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$mail),
									$author$project$Ui$Link$preventFocus
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]));
					default:
						return A3(
							$author$project$Ui$Link$tel,
							value,
							_List_fromArray(
								[
									$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$call),
									$author$project$Ui$Link$preventFocus
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]));
				}
			}(),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Edit link'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductLinks$Edit(productLink))
							]),
						_List_Nil),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Delete link'},
						_List_fromArray(
							[
								$author$project$Ui$Button$danger,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductLinks$Delete(productLink))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductLinks$view = function (_v0) {
	var model = _v0;
	var productLinks = $author$project$Api$Partner$Partner$One$productLinks(model.Vz);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Learn More & Support')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add link'},
							_List_fromArray(
								[
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
									$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductLinks$Add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Link')
								]))
						])),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
					A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductLinks$viewProductLink, productLinks))))
		]);
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Add = {$: 0};
var $author$project$Api$Partner$Partner$One$productQuotes = function (_v0) {
	var record = _v0.b;
	return record.Xf;
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Delete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductQuotes$viewProductQuote = F2(
	function (model, productQuote) {
		var text_ = $author$project$Api$Partner$PartnerProductQuote$Shared$text(productQuote);
		var authorTitle = $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle(productQuote);
		var author = $author$project$Api$Partner$PartnerProductQuote$Shared$author(productQuote);
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap4]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$width('50px'),
											$author$project$Ui$SvgIcon$class('icon--primary')
										]),
									92)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$fullWidth]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text(text_)
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Edit quote'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManagePartnerProductQuotes$Edit(productQuote))
														]),
													_List_Nil),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Delete quote'},
													_List_fromArray(
														[
															$author$project$Ui$Button$danger,
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Partner$ManagePartnerProductQuotes$Delete(productQuote))
														]),
													_List_Nil)
												]))
										])),
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$thin])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											function () {
											var _v0 = $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl(productQuote);
											if (!_v0.$) {
												var imageUrl = _v0.a;
												return A3(
													$author$project$Ui$Image$fromSrc,
													{I1: author + ' image'},
													imageUrl,
													_List_fromArray(
														[
															$author$project$Ui$Image$rounded,
															$author$project$Ui$Image$height(100),
															$author$project$Ui$Image$width(100)
														]));
											} else {
												return A4(
													$author$project$Ui$Image$view,
													model.qT,
													{I1: author + ' image'},
													_List_fromArray(
														[$author$project$Ui$Image$fullWidth]),
													15);
											}
										}(),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$ml2]),
											_List_fromArray(
												[
													$elm$html$Html$text(author),
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text(authorTitle)
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManagePartnerProductQuotes$view = function (_v0) {
	var model = _v0;
	var productQuotes = $author$project$Api$Partner$Partner$One$productQuotes(model.Vz);
	return A3(
		$author$project$Ui$Element$custom,
		'card',
		_List_fromArray(
			[$author$project$Ui$Element$mt4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Quotes')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Add quote'},
								_List_fromArray(
									[
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
										$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductQuotes$Add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Quote')
									]))
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						A2(
							$elm$core$List$map,
							$author$project$Components$Partner$ManagePartnerProductQuotes$viewProductQuote(model),
							productQuotes))
					]))
			]));
};
var $author$project$Pages$Partner$Product$viewDeleteConfirmModal = function (model) {
	var _v0 = model.fp;
	if (!_v0.$) {
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Pages$Partner$Product$DeleteConfirmClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('image'),
					$author$project$Components$HiConfirm$loading(model.S_)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Partner$Product$IconUploaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Partner$Product$ProductOverviewDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Common$Marketplace$Product$ProductType$all = _List_fromArray(
	[0, 1, 2]);
var $author$project$Api$Common$Marketplace$Product$ProductType$default = 0;
var $author$project$Api$Common$Marketplace$Product$ProductType$fromString = function (str) {
	switch (str) {
		case 'app':
			return $elm$core$Maybe$Just(0);
		case 'integration':
			return $elm$core$Maybe$Just(1);
		case 'solution':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Ui$Form$Group$static = $author$project$Ui$Form$Static$view(_List_Nil);
var $author$project$Components$Partner$ProductIconInstructions$view = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Preferred format: SVG (vector)')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Aspect ratio: 1:1 (square)')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('PNG fallback: 800×800 px recommended, transparent background')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Content: Icon or symbol only — no text or wordmarks')
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textMuted]),
			_List_fromArray(
				[
					$elm$html$Html$text('This icon is designed for dense UI areas where clarity at small sizes is important.')
				]))
		]));
var $author$project$Pages$Partner$Product$CopyToClipboard = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Partner$Product$viewExternalCtaForm = F2(
	function (form, cta) {
		var fieldOpts = function (label) {
			return _List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(label)
				]);
		};
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					fieldOpts('CTA URL'),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(cta.aav),
									$author$project$Ui$Form$Input$onInput(
									function (url) {
										return $author$project$Pages$Partner$Product$Edited(
											$author$project$Pages$Partner$Product$ExternalCta(
												_Utils_update(
													cta,
													{aav: url})));
									}),
									$author$project$Ui$Form$Input$placeholder('https://partner.example.com/signup'),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 2, form))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					fieldOpts('Campaign'),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(cta.aaJ),
									$author$project$Ui$Form$Input$onInput(
									function (campaign) {
										return $author$project$Pages$Partner$Product$Edited(
											$author$project$Pages$Partner$Product$ExternalCta(
												_Utils_update(
													cta,
													{aaJ: campaign})));
									}),
									$author$project$Ui$Form$Input$placeholder('hint_marketplace')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt1, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text('Defaults to \"hint_marketplace\" if left blank. Used as utm_campaign.')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					fieldOpts('Content'),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(cta.aaK),
									$author$project$Ui$Form$Input$onInput(
									function (content) {
										return $author$project$Pages$Partner$Product$Edited(
											$author$project$Pages$Partner$Product$ExternalCta(
												_Utils_update(
													cta,
													{aaK: content})));
									}),
									$author$project$Ui$Form$Input$placeholder('Optional')
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt1, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text('Optional. Used as utm_content to differentiate placements.')
								]))
						])),
					A2($author$project$Components$Partner$UtmLinkPreview$view, cta, $author$project$Pages$Partner$Product$CopyToClipboard)
				]));
	});
var $author$project$Pages$Partner$Product$viewEditModalInput = function (form) {
	var field = $author$project$Utils$Form$fields(form);
	if (field.$ === 7) {
		var cta = field.a;
		return A2($author$project$Pages$Partner$Product$viewExternalCtaForm, form, cta);
	} else {
		var formGroupOptions = A2(
			$elm$core$List$cons,
			$author$project$Ui$Form$Group$labelSpanSm(4),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Form$Group$inputSpanSm(8),
				function () {
					switch (field.$) {
						case 0:
							return _List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true)
								]);
						case 1:
							return _List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Summary')
								]);
						case 3:
							return _List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Product overview')
								]);
						case 5:
							return _List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Built by')
								]);
						case 2:
							return _List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Icon')
								]);
						case 6:
							return _List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Product type')
								]);
						default:
							return _List_Nil;
					}
				}()));
		return A2(
			$author$project$Ui$Form$Group$view,
			formGroupOptions,
			function () {
				switch (field.$) {
					case 0:
						var name = field.a;
						return _List_fromArray(
							[
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(name),
										$author$project$Ui$Form$Input$onInput(
										A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Product$Name, $author$project$Pages$Partner$Product$Edited)),
										$author$project$Ui$Form$Input$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Ui$Form$Input$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]))
							]);
					case 1:
						var description = field.a;
						return _List_fromArray(
							[
								$author$project$Ui$Form$Textarea$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Textarea$value(description),
										$author$project$Ui$Form$Textarea$onInput(
										A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Product$ProductDescription, $author$project$Pages$Partner$Product$Edited))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt2, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
								_List_fromArray(
									[
										$elm$html$Html$text('One sentence that describes your product without repeating the product name shown above.')
									]))
							]);
					case 3:
						var description = field.a;
						return _List_fromArray(
							[
								$author$project$Ui$Form$Textarea$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Textarea$value(description),
										$author$project$Ui$Form$Textarea$onInput(
										A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Product$ProductOverviewDescription, $author$project$Pages$Partner$Product$Edited))
									]))
							]);
					case 5:
						var maybeName = field.a;
						var maybeUrl = field.b;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Name')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														A2($elm$core$Maybe$withDefault, '', maybeName)),
														$author$project$Ui$Form$Input$onInput(
														function (name) {
															return $author$project$Pages$Partner$Product$Edited(
																A2(
																	$author$project$Pages$Partner$Product$Attribution,
																	$author$project$Utils$Maybe$fromString(name),
																	maybeUrl));
														}),
														$author$project$Ui$Form$Input$placeholder('Example')
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('URL')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														A2($elm$core$Maybe$withDefault, '', maybeUrl)),
														$author$project$Ui$Form$Input$onInput(
														function (url) {
															return $author$project$Pages$Partner$Product$Edited(
																A2(
																	$author$project$Pages$Partner$Product$Attribution,
																	maybeName,
																	$author$project$Utils$Maybe$fromString(url)));
														}),
														$author$project$Ui$Form$Input$placeholder('https://example.com')
													]))
											]))
									]))
							]);
					case 2:
						return _List_fromArray(
							[
								$author$project$Ui$Form$Group$static(
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol]),
										_List_fromArray(
											[
												$author$project$Components$Partner$ProductIconInstructions$view,
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$flexCol]),
												_List_fromArray(
													[
														$author$project$Ui$Form$File$view(
														_List_fromArray(
															[
																$author$project$Ui$Form$File$onInput($author$project$Pages$Partner$Product$IconUploaded)
															])),
														$author$project$Utils$FormErrors$view(
														A2($author$project$Utils$Form$validationErrors, 1, form))
													]))
											]))
									]))
							]);
					case 6:
						var productType = field.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Api$Common$Marketplace$Product$ProductType$toString(productType))),
										$author$project$Ui$Form$Select$onChange(
										function (value) {
											return $author$project$Pages$Partner$Product$Edited(
												$author$project$Pages$Partner$Product$ProductType(
													A2(
														$elm$core$Maybe$withDefault,
														$author$project$Api$Common$Marketplace$Product$ProductType$default,
														$author$project$Api$Common$Marketplace$Product$ProductType$fromString(value))));
										})
									]),
								A2(
									$elm$core$List$map,
									function (type_) {
										return A3(
											$author$project$Ui$Form$Select$option,
											_List_Nil,
											$elm$core$Maybe$Just(
												$author$project$Api$Common$Marketplace$Product$ProductType$toString(type_)),
											$author$project$Api$Common$Marketplace$Product$ProductType$toLabel(type_));
									},
									$author$project$Api$Common$Marketplace$Product$ProductType$all))
							]);
					default:
						return _List_Nil;
				}
			}());
	}
};
var $author$project$Pages$Partner$Product$viewEditModal = function (model) {
	var _v0 = model.w;
	if (!_v0.$) {
		var form = _v0.a;
		var field = $author$project$Utils$Form$fields(form);
		var saveDisabled = function () {
			if (field.$ === 2) {
				var maybeIcon = field.a;
				return A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(false),
						maybeIcon));
			} else {
				return false;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Product$CancelEdit,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit(
					$author$project$Pages$Partner$Product$Saved(form))
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Editing Product')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$author$project$Pages$Partner$Product$viewEditModalInput(form)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$CancelEdit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Save product changes'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$disabled(saveDisabled)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Partner$Product$ProductOverviewImageDeleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Partner$Product$ProductOverviewImagesUploaded = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Link$ButtonWarning = 4;
var $author$project$Ui$Link$buttonWarning = $author$project$Ui$Link$Style(4);
var $author$project$Api$Partner$PartnerProductOverview$Shared$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Ui$Form$File$Key = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$Form$File$key = $author$project$Ui$Form$File$Key;
var $author$project$Components$Carousel$OverlayAction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Carousel$overlay = $author$project$Components$Carousel$OverlayAction;
var $author$project$Api$Partner$ProductImage$Shared$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Pages$Partner$Product$productImageToCarouselImage = function (productImage) {
	return A3(
		$author$project$Components$Carousel$image,
		$author$project$Api$Partner$ProductImage$Shared$id(productImage),
		$author$project$Api$Partner$ProductImage$Shared$url(productImage),
		$author$project$Api$Partner$ProductImage$Shared$alt(productImage));
};
var $author$project$Ui$Form$File$SrOnly = {$: 6};
var $author$project$Ui$Form$File$viewWithContent = F2(
	function (options, content) {
		var optionsRecord = $author$project$Ui$Form$File$optionsToRecord(options);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('cursor-pointer m-0'),
					$elm$html$Html$Attributes$tabindex(0),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('inline-edit inline-edit--overlay', optionsRecord.qW)
						])),
					A2($elm$html$Html$Attributes$style, 'overflow', 'auto')
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$map, $elm$core$Basics$never, content),
					$author$project$Ui$Form$File$view(
					A2($elm$core$List$cons, $author$project$Ui$Form$File$SrOnly, options)),
					optionsRecord.qW ? $author$project$Ui$SvgIcon$edit(
					_List_fromArray(
						[$author$project$Ui$SvgIcon$xs])) : $elm$html$Html$text('')
				]));
	});
var $author$project$Pages$Partner$Product$viewProductOverview = function (model) {
	var carousel = model.pO;
	var fileKey = model.qF;
	var loading = model.S_;
	var partner = model.Vz;
	var productOverviewDescription = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Partner$PartnerProductOverview$Shared$description,
		$author$project$Api$Partner$Partner$One$productOverview(partner));
	var deleteButton = function (imageId) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Delete image'},
			_List_fromArray(
				[
					$author$project$Ui$Button$danger,
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Partner$Product$ProductOverviewImageDeleted(imageId))
				]),
			_List_Nil);
	};
	var customElementClasses = 'button button--default [&>*:first-child]:mt-0' + (loading ? 'button--disabled' : '');
	var carouselItems = A2(
		$elm$core$List$map,
		$author$project$Pages$Partner$Product$productImageToCarouselImage,
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$PartnerProductOverview$Shared$images,
				$author$project$Api$Partner$Partner$One$productOverview(partner))));
	return A2(
		$author$project$Ui$Card$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Overview')
									])),
								function () {
								var _v0 = model.W8;
								if (_v0.$ === 3) {
									var product = _v0.a;
									return A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Marketplace__Slug_String(
											{
												_c: $author$project$Api$Partner$PartnerProduct$One$slug(product)
											}),
										_List_fromArray(
											[$author$project$Ui$Link$buttonWarning, $author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('View in Marketplace')
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}()
							])),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A3(
						$author$project$Components$Carousel$view,
						_List_fromArray(
							[
								$author$project$Components$Carousel$thumbnails,
								$author$project$Components$Carousel$overlay(deleteButton),
								$author$project$Components$Carousel$aspectVideo
							]),
						carousel,
						carouselItems),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$File$viewWithContent,
								_List_fromArray(
									[
										$author$project$Ui$Form$File$disabled(loading),
										$author$project$Ui$Form$File$key(
										$elm$core$String$fromInt(fileKey)),
										$author$project$Ui$Form$File$onInput($author$project$Pages$Partner$Product$ProductOverviewImagesUploaded)
									]),
								A3(
									$author$project$Ui$Element$custom,
									customElementClasses,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$upload(_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Upload content')
												]))
										])))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4]),
						_List_fromArray(
							[
								A2(
								$author$project$Pages$Partner$Product$viewInlineEdit,
								$author$project$Pages$Partner$Product$Edit(
									$author$project$Pages$Partner$Product$ProductOverviewDescription(
										A2($elm$core$Maybe$withDefault, '', productOverviewDescription))),
								function () {
									if (!productOverviewDescription.$) {
										var description = productOverviewDescription.a;
										return A2(
											$elm$html$Html$map,
											$elm$core$Basics$never,
											A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$preWrap, $author$project$Ui$Typography$muted]),
												$author$project$Utils$Html$ulFromString(description)));
									} else {
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-muted')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('N/A')
												]));
									}
								}())
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Product$viewBody = function (model) {
	var _v0 = model.W8;
	if (_v0.$ === 3) {
		var product = _v0.a;
		return _List_fromArray(
			[
				$author$project$Pages$Partner$Product$viewEditModal(model),
				$author$project$Pages$Partner$Product$viewDeleteConfirmModal(model),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg,
				$author$project$Components$Partner$ManagePartnerProductLinks$modal(model.f$)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg,
				$author$project$Components$Partner$ManagePartnerProductHighlights$modal(model.f_)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg,
				$author$project$Components$Partner$ManagePartnerProductDataFlows$modal(model.fZ)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg,
				$author$project$Components$Partner$ManagePartnerProductCategories$modal(model.fY)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg,
				$author$project$Components$Partner$ManagePartnerProductQuotes$modal(model.f0)),
				A3(
				$author$project$Ui$Element$custom,
				'marketplace-landing',
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Element$custom,
						'marketplace-landing__aside',
						_List_Nil,
						_List_fromArray(
							[
								A4($author$project$Pages$Partner$Product$productCard, model.qT, model.Vz, product, model.bR),
								A2(
								$author$project$Ui$Card$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mb2]),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg),
											$author$project$Components$Partner$ManagePartnerProductLinks$view(model.f$))),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$mt2]),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg),
											$author$project$Components$Partner$ManagePartnerProductCategories$view(model.fY)))
									]))
							])),
						A3(
						$author$project$Ui$Element$custom,
						'marketplace-landing__main',
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Partner$Product$viewProductOverview(model),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg,
								$author$project$Components$Partner$ManagePartnerProductHighlights$view(model.f_)),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg,
								$author$project$Components$Partner$ManagePartnerProductDataFlows$view(model.fZ)),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg,
								$author$project$Components$Partner$ManagePartnerProductQuotes$view(model.f0))
							]))
					]))
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Partner$Product$view = function (model) {
	return {
		e5: $author$project$Pages$Partner$Product$viewBody(model),
		$G: 'Partner | Product'
	};
};
var $author$project$Pages$Partner$Product$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Product$init, aer: $author$project$Pages$Partner$Product$load, agD: $author$project$Pages$Partner$Product$save, ahd: $author$project$Pages$Partner$Product$subscriptions, aaq: $author$project$Pages$Partner$Product$update, ahP: $author$project$Pages$Partner$Product$view});
var $author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManagePartnerProductDocuments$GotDocuments = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProductDocument$All$PartnerProductDocument = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductDocument$Shared$PartnerProductDocument = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProductDocument$Shared$Record = F5(
	function (id, title, documentType, url, pdfName) {
		return {NZ: documentType, adR: id, V8: pdfName, $G: title, aav: url};
	});
var $author$project$Api$Partner$PartnerProductDocument$Shared$PdfDocument = 0;
var $author$project$Api$Partner$PartnerProductDocument$Shared$UrlDocument = 1;
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString = function (string) {
	switch (string) {
		case 'pdf':
			return $elm$core$Maybe$Just(0);
		case 'url':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail('Unsupported document type')))),
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$PartnerProductDocument$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'pdf_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'document_type',
			$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'title',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductDocument$Shared$Record))))));
var $author$project$Api$Partner$PartnerProductDocument$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductDocument$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductDocument$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerProductDocument$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerProductDocument$listDefaults = {afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Partner$PartnerProductDocument$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$PartnerProductDocument$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy),
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var q = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', q)
						]);
				} else {
					return _List_Nil;
				}
			}()
			]));
};
var $author$project$Api$Partner$PartnerProductDocument$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductDocument$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$PartnerProductDocument$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath)));
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Partner$PartnerProductDocument$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: model.afy, af_: model.af_, ag1: model.ag1});
			},
			$author$project$Components$Partner$ManagePartnerProductDocuments$GotDocuments);
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$init = F2(
	function (apiClient, query) {
		var q = A2($elm$core$Dict$get, 'q', query);
		var initialModel = {
			bX: $elm$core$Maybe$Nothing,
			bq: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			E: $elm$core$Maybe$Nothing,
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q),
			ag1: $author$project$Api$Sort$initFromQuery(query)
		};
		return _Utils_Tuple2(
			initialModel,
			A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, initialModel));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Model = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath = function (productId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['partner_products', productId, 'preconditions']),
		$author$project$Api$Data$partnerPath);
};
var $author$project$Api$Partner$PartnerProduct$Precondition$list = F3(
	function (apiClient, productId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Precondition$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId)));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$init = F2(
	function (apiClient, productId) {
		return _Utils_Tuple2(
			{ah: $elm$core$Maybe$Nothing, b_: $elm$core$Maybe$Nothing, WT: $author$project$Api$Data$Loading, GS: productId},
			A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, productId, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions));
	});
var $author$project$Api$Partner$Partner$Shared$postActivationRedirectUrl = function (_v0) {
	var record = _v0;
	return record.WA;
};
var $author$project$Api$Partner$Partner$One$postActivationRedirectUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$postActivationRedirectUrl(shared);
};
var $author$project$Api$Partner$Partner$Shared$redirectUrl = function (_v0) {
	var record = _v0;
	return record.X0;
};
var $author$project$Api$Partner$Partner$One$redirectUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$redirectUrl(shared);
};
var $author$project$Pages$Partner$Product$ActivationSettings$initFormFields = function (partner) {
	var _v0 = function () {
		var _v1 = $author$project$Api$Partner$Partner$One$authType(partner);
		switch (_v1) {
			case 'automatic_redirect':
				return _Utils_Tuple2(true, false);
			case 'automatic_headless':
				return _Utils_Tuple2(true, true);
			default:
				return _Utils_Tuple2(false, false);
		}
	}();
	var automaticallyIntegrates = _v0.a;
	var headless = _v0.b;
	return _Utils_Tuple2(
		{
			bl: automaticallyIntegrates,
			fL: headless,
			WA: $author$project$Api$Partner$Partner$One$postActivationRedirectUrl(partner),
			X0: $author$project$Api$Partner$Partner$One$redirectUrl(partner)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$Partner$Product$ActivationSettings$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.Bi;
		var productId = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$PartnerProduct$Shared$id,
				$author$project$Api$Partner$Partner$One$product(partner)));
		var _v2 = A2($author$project$Components$Partner$ManagePartnerProductPreconditions$init, shared.D5, productId);
		var preconditionsModel = _v2.a;
		var preconditionsCmd = _v2.b;
		var _v3 = $author$project$Pages$Partner$Product$ActivationSettings$initFormFields(partner);
		var formFields = _v3.a;
		var formFieldsCmd = _v3.b;
		var _v4 = A2($author$project$Components$Partner$ManagePartnerProductDocuments$init, shared.D5, query);
		var documentsModel = _v4.a;
		var documentsCmd = _v4.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				PB: $author$project$Utils$Form$init(formFields),
				i4: documentsModel,
				i6: preconditionsModel,
				Vz: partner,
				o$: $author$project$Api$Data$NotAsked
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg, documentsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg, preconditionsCmd)
					])));
	});
var $author$project$Pages$Partner$Product$ActivationSettings$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Product$ActivationSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd = {$: 5};
var $author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd)),
					model.E)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed)),
					model.bX))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm = {$: 3};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.ah;
				if (!_v1.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.b_;
				if (!_v2.$) {
					return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Partner$Product$ActivationSettings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg,
				$author$project$Components$Partner$ManagePartnerProductDocuments$subscriptions(model.i4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg,
				$author$project$Components$Partner$ManagePartnerProductPreconditions$subscriptions(model.i6))
			]));
};
var $author$project$Pages$Partner$Product$ActivationSettings$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Product$ActivationSettings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						X0: $author$project$Utils$String$toMaybe(string)
					});
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{bl: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{fL: bool});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						WA: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$Deleted = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentCreated = 1;
var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentDeleted = 3;
var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentUpdated = 2;
var $author$project$Components$Partner$ManagePartnerProductDocuments$File = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$GotSignedPdfUrl = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$None = 0;
var $author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$PartnerProductDocument$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath(id)));
	});
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDefault = 1;
var $author$project$Components$Partner$ManagePartnerProductDocuments$documentFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var title = field.a;
				return _Utils_update(
					fields,
					{$G: title});
			case 1:
				var docType = field.a;
				return _Utils_update(
					fields,
					{
						NZ: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDefault,
							$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString(docType)),
						qG: 0,
						V7: $elm$core$Maybe$Nothing,
						aav: ''
					});
			case 2:
				var url = field.a;
				return _Utils_update(
					fields,
					{aav: url});
			default:
				var size = field.a;
				var dataUrl = field.b;
				return _Utils_update(
					fields,
					{
						qG: size,
						V7: $elm$core$Maybe$Just(
							_Utils_Tuple2(size, dataUrl))
					});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$TitleValidation = 0;
var $author$project$Components$Partner$ManagePartnerProductDocuments$FileValidation = 2;
var $author$project$Components$Partner$ManagePartnerProductDocuments$UrlValidation = 1;
var $author$project$Utils$FileSize$twentyFiveMegabytes = (25 * 1024) * 1024;
var $author$project$Components$Partner$ManagePartnerProductDocuments$maxFileBytesSize = $author$project$Utils$FileSize$twentyFiveMegabytes;
var $author$project$Components$Partner$ManagePartnerProductDocuments$validateUrlOrFile = function (fields) {
	var _v0 = fields.NZ;
	if (_v0 === 1) {
		return $elm$core$String$isEmpty(fields.aav) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a URL.')
			]) : ($author$project$Utils$Validate$isInvalidUrl(fields.aav) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'Please enter a valid URL.')
			]) : _List_Nil);
	} else {
		return (_Utils_eq(fields.V7, $elm$core$Maybe$Nothing) && _Utils_eq(fields.xv, $elm$core$Maybe$Nothing)) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Please attach a PDF file.')
			]) : ((_Utils_cmp(fields.qG, $author$project$Components$Partner$ManagePartnerProductDocuments$maxFileBytesSize) > 0) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'That file is too large! Maximum file size is 25 MB.')
			]) : _List_Nil);
	}
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$documentValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.$G;
			},
			_Utils_Tuple2(0, 'Please enter a title.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManagePartnerProductDocuments$validateUrlOrFile)
		]));
var $author$project$Api$Partner$PartnerProductDocument$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Partner$PartnerProductDocument$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$id(shared);
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFields = {NZ: 1, xv: $elm$core$Maybe$Nothing, qG: 0, V7: $elm$core$Maybe$Nothing, $G: '', aav: ''};
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentType = function (_v0) {
	var record = _v0;
	return record.NZ;
};
var $author$project$Api$Partner$PartnerProductDocument$All$documentType = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$documentType(shared);
};
var $author$project$Api$Partner$PartnerProductDocument$Shared$pdfName = function (_v0) {
	var record = _v0;
	return record.V8;
};
var $author$project$Api$Partner$PartnerProductDocument$All$pdfName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$pdfName(shared);
};
var $author$project$Api$Partner$PartnerProductDocument$Shared$title = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Api$Partner$PartnerProductDocument$All$title = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$title(shared);
};
var $author$project$Api$Partner$PartnerProductDocument$Shared$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Api$Partner$PartnerProductDocument$All$url = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$PartnerProductDocument$Shared$url(shared);
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFieldsForEdit = function (doc) {
	return {
		NZ: $author$project$Api$Partner$PartnerProductDocument$All$documentType(doc),
		xv: $author$project$Api$Partner$PartnerProductDocument$All$pdfName(doc),
		qG: 0,
		V7: $elm$core$Maybe$Nothing,
		$G: $author$project$Api$Partner$PartnerProductDocument$All$title(doc),
		aav: A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Partner$PartnerProductDocument$All$url(doc))
	};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Created = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$PartnerProductDocument$One$PartnerProductDocument = 0;
var $author$project$Api$Partner$PartnerProductDocument$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString = function (docType) {
	if (!docType) {
		return 'pdf';
	} else {
		return 'url';
	}
};
var $author$project$Api$Partner$PartnerProductDocument$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_document',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'document_type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(params.NZ))),
								_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.$G)),
								_Utils_Tuple2(
								'url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aav)),
								_Utils_Tuple2(
								'pdf',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.V7))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProductDocument$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath)));
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$createDocument = F2(
	function (apiClient, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.$G;
		var documentType = _v0.NZ;
		var url = _v0.aav;
		var pdf = _v0.V7;
		return A3(
			$author$project$Api$Partner$PartnerProductDocument$create,
			apiClient,
			{
				NZ: documentType,
				V7: A2($elm$core$Maybe$map, $elm$core$Tuple$second, pdf),
				$G: title,
				aav: $author$project$Utils$Maybe$fromString(url)
			},
			$author$project$Components$Partner$ManagePartnerProductDocuments$Created);
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$Updated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$PartnerProductDocument$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner_product_document',
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'title',
								$elm$json$Json$Encode$string(params.$G)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'url',
									A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aav)),
								function () {
									var _v0 = params.V7;
									if (!_v0.$) {
										var pdf = _v0.a;
										return _List_fromArray(
											[
												_Utils_Tuple2(
												'pdf',
												$elm$json$Json$Encode$string(pdf))
											]);
									} else {
										return _List_Nil;
									}
								}()))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProductDocument$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath(id))));
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$updateDocument = F3(
	function (apiClient, id, formFields) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var title = _v0.$G;
		var url = _v0.aav;
		var pdf = _v0.V7;
		return A4(
			$author$project$Api$Partner$PartnerProductDocument$update,
			apiClient,
			id,
			{
				V7: A2($elm$core$Maybe$map, $elm$core$Tuple$second, pdf),
				$G: title,
				aav: $author$project$Utils$Maybe$fromString(url)
			},
			$author$project$Components$Partner$ManagePartnerProductDocuments$Updated);
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$save = F3(
	function (apiClient, docId, formFields) {
		if (!docId.$) {
			var id_ = docId.a;
			return A3($author$project$Components$Partner$ManagePartnerProductDocuments$updateDocument, apiClient, id_, formFields);
		} else {
			return A2($author$project$Components$Partner$ManagePartnerProductDocuments$createDocument, apiClient, formFields);
		}
	});
var $author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl = function (model) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Product__ActivationSettings)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$map,
								$elm$url$Url$Builder$string('q'),
								model.af_)
							]))))));
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								bq: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{bq: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bq: $author$project$Api$Data$Loading,
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
								$author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(newModel)
							])),
					ac5: 0,
					y8: newModel,
					as: _List_Nil
				};
			case 2:
				var subMsg = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bq: $author$project$Api$Data$Loading,
						afy: A2($author$project$Api$Pagination$update, subMsg, model.afy)
					});
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
								$author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(newModel)
							])),
					ac5: 0,
					y8: newModel,
					as: _List_Nil
				};
			case 3:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v3.a;
				var searchInputCmd = _v3.b;
				var searchInputEvent = _v3.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v4 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								bq: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, qModel),
										$author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v4.a;
				var fetchCmd = _v4.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg, searchInputCmd),
								fetchCmd
							])),
					ac5: 0,
					y8: _Utils_update(
						newModel,
						{sA: searchInput}),
					as: _List_Nil
				};
			case 4:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							E: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFields),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 5:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{E: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 6:
				var productDocument = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							E: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(productDocument),
									$author$project$Utils$Form$init(
										$author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFieldsForEdit(productDocument)),
									$author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 7:
				var field = msg.a;
				var _v6 = model.E;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var id = _v7.a;
					var form = _v7.b;
					var request = _v7.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductDocuments$documentFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								E: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, request))
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 8:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v8) {
							var task = _v8.a;
							var size = _v8.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated,
									$author$project$Components$Partner$ManagePartnerProductDocuments$File(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (f) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(f),
									$elm$file$File$size(f));
							},
							$elm$core$List$head(files))));
				return {EC: cmd, ac5: 0, y8: model, as: _List_Nil};
			case 9:
				var _v9 = model.E;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var productDocument = _v10.a;
					var form = _v10.b;
					var _v11 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductDocuments$documentValidator, form);
					if (!_v11.$) {
						var _v12 = _v11.a;
						var validatedForm = _v12.a;
						var validFormFields = _v12.b;
						var docId = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDocument$All$id, productDocument);
						return {
							EC: A3($author$project$Components$Partner$ManagePartnerProductDocuments$save, apiClient, docId, validFormFields),
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									E: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDocument, validatedForm, $author$project$Api$Data$Loading))
								}),
							as: _List_Nil
						};
					} else {
						var validatedForm = _v11.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									E: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDocument, validatedForm, $author$project$Api$Data$NotAsked))
								}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 10:
				var response = msg.a;
				var _v13 = model.E;
				if (!_v13.$) {
					var _v14 = _v13.a;
					var productDocument = _v14.a;
					var form = _v14.b;
					if (response.$ === 3) {
						var newModel = _Utils_update(
							model,
							{bq: $author$project$Api$Data$Loading, E: $elm$core$Maybe$Nothing});
						return {
							EC: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
							ac5: 1,
							y8: newModel,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Document created successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									E: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDocument, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 11:
				var response = msg.a;
				var _v16 = model.E;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var productDocument = _v17.a;
					var form = _v17.b;
					if (response.$ === 3) {
						var newModel = _Utils_update(
							model,
							{bq: $author$project$Api$Data$Loading, E: $elm$core$Maybe$Nothing});
						return {
							EC: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
							ac5: 2,
							y8: newModel,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Document updated successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									E: $elm$core$Maybe$Just(
										_Utils_Tuple3(productDocument, form, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 12:
				var doc = msg.a;
				return {
					EC: A3(
						$author$project$Api$Partner$PartnerProductDocument$signedFileUrl,
						apiClient,
						$author$project$Api$Partner$PartnerProductDocument$All$id(doc),
						$author$project$Components$Partner$ManagePartnerProductDocuments$GotSignedPdfUrl),
					ac5: 0,
					y8: model,
					as: _List_Nil
				};
			case 13:
				var response = msg.a;
				if (response.$ === 3) {
					var url = response.a;
					return {
						EC: $author$project$Ports$Navigation$openInNewWindow(url),
						ac5: 0,
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 14:
				var productDocument = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							bX: $elm$core$Maybe$Just(
								_Utils_Tuple2(productDocument, $author$project$Api$Data$NotAsked))
						}),
					as: _List_Nil
				};
			case 15:
				var confirmed = msg.a;
				var _v20 = model.bX;
				if (!_v20.$) {
					var _v21 = _v20.a;
					var productDocument = _v21.a;
					return confirmed ? {
						EC: A3(
							$author$project$Api$Partner$PartnerProductDocument$delete,
							apiClient,
							$author$project$Api$Partner$PartnerProductDocument$All$id(productDocument),
							$author$project$Components$Partner$ManagePartnerProductDocuments$Deleted),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								bX: $elm$core$Maybe$Just(
									_Utils_Tuple2(productDocument, $author$project$Api$Data$Loading))
							}),
						as: _List_Nil
					} : {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{bX: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			default:
				var response = msg.a;
				var _v22 = model.bX;
				if (!_v22.$) {
					var _v23 = _v22.a;
					var productDocument = _v23.a;
					if (response.$ === 3) {
						var newModel = _Utils_update(
							model,
							{bX: $elm$core$Maybe$Nothing, bq: $author$project$Api$Data$Loading});
						return {
							EC: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
							ac5: 3,
							y8: newModel,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Document deleted successfully!')
								])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: _Utils_update(
								model,
								{
									bX: $elm$core$Maybe$Just(
										_Utils_Tuple2(productDocument, response))
								}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotDeleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Precondition$Type_ = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Precondition$Url = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Precondition$One$Precondition = 0;
var $author$project$Api$Partner$PartnerProduct$Precondition$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$Marketplace$Product$Precondition$decoder,
	$elm$json$Json$Decode$succeed(
		$elm$core$Basics$always(0)));
var $author$project$Api$Common$Marketplace$Product$Precondition$Type$toString = function (t) {
	if (!t) {
		return 'external_install';
	} else {
		return 'external_account';
	}
};
var $author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				if (!field.$) {
					var t = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(
								$author$project$Api$Common$Marketplace$Product$Precondition$Type$toString(t))),
						acc);
				} else {
					var u = field.a;
					return A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'url',
							$elm$json$Json$Encode$string(u)),
						acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'precondition',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$PartnerProduct$Precondition$create = F4(
	function (apiClient, productId, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$Precondition$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId))));
	});
var $author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath = F2(
	function (productId, preconditionId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[preconditionId]),
			$author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId));
	});
var $author$project$Api$Partner$PartnerProduct$Precondition$destroy = F4(
	function (apiClient, productId, preconditionId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath, productId, preconditionId)));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$emptyForm = {ahI: 0, aav: ''};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$formFromPrecondition = function (precondition) {
	return {
		ahI: $author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition),
		aav: $author$project$Api$Common$Marketplace$Product$Precondition$url(precondition)
	};
};
var $author$project$Api$Partner$PartnerProduct$Precondition$update = F5(
	function (apiClient, productId, preconditionId, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$Precondition$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath, productId, preconditionId))));
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$updateForm = F2(
	function (field, form) {
		if (!field.$) {
			var t = field.a;
			return _Utils_update(
				form,
				{ahI: t});
		} else {
			var string = field.a;
			return _Utils_update(
				form,
				{aav: string});
		}
	});
var $author$project$Components$Partner$ManagePartnerProductPreconditions$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{WT: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ah: $elm$core$Maybe$Just(
								_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Components$Partner$ManagePartnerProductPreconditions$emptyForm, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var precondition = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ah: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(precondition),
									$author$project$Components$Partner$ManagePartnerProductPreconditions$formFromPrecondition(precondition),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ah: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var field = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ah: A2(
								$elm$core$Maybe$map,
								function (_v2) {
									var p = _v2.a;
									var f = _v2.b;
									var r = _v2.c;
									return _Utils_Tuple3(
										p,
										A2($author$project$Components$Partner$ManagePartnerProductPreconditions$updateForm, field, f),
										r);
								},
								model.ah)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var maybeId = msg.a;
				var _v3 = model.ah;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var maybePrecondition = _v4.a;
					var form = _v4.b;
					if ($elm$core$String$isEmpty(
						$elm$core$String$trim(form.aav))) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ah: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybePrecondition, form, $author$project$Api$Data$NotAsked))
								}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'URL is required.')
								]));
					} else {
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$PartnerProduct$Precondition$Type_(form.ahI),
								$author$project$Api$Partner$PartnerProduct$Precondition$Url(form.aav)
							]);
						var cmd = function () {
							if (!maybeId.$) {
								var id = maybeId.a;
								return A5($author$project$Api$Partner$PartnerProduct$Precondition$update, apiClient, model.GS, id, permittedFields, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved);
							} else {
								return A4($author$project$Api$Partner$PartnerProduct$Precondition$create, apiClient, model.GS, permittedFields, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved);
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ah: $elm$core$Maybe$Just(
										_Utils_Tuple3(maybePrecondition, form, $author$project$Api$Data$Loading))
								}),
							cmd,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ah: $elm$core$Maybe$Nothing, WT: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, model.GS, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Precondition saved successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ah: A2(
									$elm$core$Maybe$map,
									function (_v7) {
										var p = _v7.a;
										var f = _v7.b;
										return _Utils_Tuple3(p, f, response);
									},
									model.ah)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var precondition = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							b_: $elm$core$Maybe$Just(
								_Utils_Tuple2(precondition, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var confirmed = msg.a;
				var _v8 = model.b_;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var precondition = _v9.a;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b_: $elm$core$Maybe$Just(
									_Utils_Tuple2(precondition, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Api$Partner$PartnerProduct$Precondition$destroy,
							apiClient,
							model.GS,
							$author$project$Api$Common$Marketplace$Product$Precondition$id(precondition),
							$author$project$Components$Partner$ManagePartnerProductPreconditions$GotDeleted),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{b_: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b_: $elm$core$Maybe$Nothing, WT: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, model.GS, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Precondition deleted successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b_: A2(
									$elm$core$Maybe$map,
									function (_v11) {
										var p = _v11.a;
										return _Utils_Tuple2(p, response);
									},
									model.b_)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Product$ActivationSettings$PostActivationRedirectUrlValidation = 1;
var $author$project$Pages$Partner$Product$ActivationSettings$validatePostActivationRedirectUrl = function (fields) {
	var _v0 = fields.WA;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var url = _v0.a;
		return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
			[
				_Utils_Tuple2(1, 'URL must start with http:// or https://')
			]) : _List_Nil;
	}
};
var $author$project$Pages$Partner$Product$ActivationSettings$RedirectUrlValidation = 0;
var $author$project$Pages$Partner$Product$ActivationSettings$validateRedirectUrl = function (fields) {
	var _v0 = _Utils_Tuple2(fields.bl, fields.X0);
	if (_v0.a) {
		if (_v0.b.$ === 1) {
			var _v1 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Redirect URL is required')
				]);
		} else {
			var url = _v0.b.a;
			return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'URL must start with http:// or https://')
				]) : _List_Nil;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$Partner$Product$ActivationSettings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Partner$Product$ActivationSettings$validateRedirectUrl),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Partner$Product$ActivationSettings$validatePostActivationRedirectUrl)
		]));
var $author$project$Api$Partner$Partner$PostActivationRedirectUrl = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Partner$Product$ActivationSettings$toPermittedFields = function (fields) {
	var authType = function () {
		var _v0 = _Utils_Tuple2(fields.bl, fields.fL);
		if (_v0.a) {
			if (!_v0.b) {
				return 'automatic_redirect';
			} else {
				return 'automatic_headless';
			}
		} else {
			return 'manual';
		}
	}();
	return A2(
		$elm$core$List$cons,
		$author$project$Api$Partner$Partner$AuthType(authType),
		A2(
			$elm$core$List$cons,
			$author$project$Api$Partner$Partner$RedirectUrl(fields.X0),
			(fields.bl && fields.fL) ? _List_fromArray(
				[
					$author$project$Api$Partner$Partner$PostActivationRedirectUrl(fields.WA)
				]) : _List_Nil));
};
var $author$project$Pages$Partner$Product$ActivationSettings$validate = function (model) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Product$ActivationSettings$formFieldsValidator, model.PB);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var validFormFields = _v1.b;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return $elm$core$Result$Ok(
			$author$project$Pages$Partner$Product$ActivationSettings$toPermittedFields(fields));
	} else {
		var validatedForm = _v0.a;
		return $elm$core$Result$Err(validatedForm);
	}
};
var $author$project$Pages$Partner$Product$ActivationSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Product$ActivationSettings$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v1 = $author$project$Pages$Partner$Product$ActivationSettings$validate(model);
				if (!_v1.$) {
					var permittedFields = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$Partner$update, model.D5, permittedFields, $author$project$Pages$Partner$Product$ActivationSettings$GotUpdatedPartner),
						_List_Nil);
				} else {
					var updatedForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: updatedForm, o$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var partner = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Vz: partner, o$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var documentsMsg = msg.a;
				var result = A3($author$project$Components$Partner$ManagePartnerProductDocuments$update, model.D5, documentsMsg, model.i4);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i4: result.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg, result.EC),
					result.as);
			default:
				var preconditionsMsg = msg.a;
				var _v3 = A3($author$project$Components$Partner$ManagePartnerProductPreconditions$update, model.D5, preconditionsMsg, model.i6);
				var preconditionsModel = _v3.a;
				var preconditionsCmd = _v3.b;
				var outMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{i6: preconditionsModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg, preconditionsCmd),
					outMsgs);
		}
	});
var $author$project$Pages$Partner$Product$ActivationSettings$AutomaticallyIntegrates = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Product$ActivationSettings$Headless = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Product$ActivationSettings$PostActivationRedirectUrl = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Product$ActivationSettings$RedirectUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Product$ActivationSettings$Save = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentDeleteConfirmModal = function (model) {
	var _v0 = model.bX;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('document'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$FileUploaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Save = {$: 9};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Url = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$documentTypeOptions = A2(
	$elm$core$List$map,
	function (_v0) {
		var docType = _v0.a;
		var label = _v0.b;
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(docType)),
			label);
	},
	_List_fromArray(
		[
			_Utils_Tuple2(1, 'Link to URL'),
			_Utils_Tuple2(0, 'Upload PDF')
		]));
var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentEditModal = function (_v0) {
	var productDocument = _v0.E;
	if (!productDocument.$) {
		var _v2 = productDocument.a;
		var item = _v2.a;
		var form = _v2.b;
		var request = _v2.c;
		var fields = $author$project$Utils$Form$fields(form);
		var updateWarning = function () {
			var _v7 = fields.NZ;
			if (!_v7) {
				return 'Uploading a new PDF';
			} else {
				return 'Updating the URL';
			}
		}() + ' will invalidate any existing document agreements.';
		var modalConfig = {
			Qn: $elm$core$Maybe$Just('Attach a document or link to your product listing.'),
			aej: 'Document',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDocument$All$id, item),
			Tw: $elm$core$Maybe$Just(updateWarning),
			U_: $author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd,
			U0: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductDocuments$Save)
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Title'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.$G),
									$author$project$Ui$Form$Input$placeholder('Document title'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDocuments$Title, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						])),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8),
								$author$project$Ui$Form$Group$label('Type')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(fields.NZ))),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated, $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentType)),
										$author$project$Ui$Form$Select$disabled(
										!_Utils_eq(item, $elm$core$Maybe$Nothing))
									]),
								$author$project$Components$Partner$ManagePartnerProductDocuments$documentTypeOptions)
							])),
					function () {
						var _v3 = fields.NZ;
						if (_v3 === 1) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8),
											$author$project$Ui$Form$Group$label('URL'),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(fields.aav),
													$author$project$Ui$Form$Input$placeholder('https://example.com/docs'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDocuments$Url, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
													$author$project$Ui$Form$Input$errors(
													A2($author$project$Utils$Form$validationErrors, 1, form))
												]))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpan(4),
											$author$project$Ui$Form$Group$inputSpan(8),
											$author$project$Ui$Form$Group$label('PDF File'),
											$author$project$Ui$Form$Group$required(
											_Utils_eq(item, $elm$core$Maybe$Nothing))
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$File$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$File$accept(2),
													$author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductDocuments$FileUploaded)
												])),
											function () {
											var _v4 = fields.V7;
											if (!_v4.$) {
												return A2(
													$author$project$Ui$Typography$p,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text('File selected.')
														]));
											} else {
												if (!item.$) {
													var doc = item.a;
													var _v6 = $author$project$Api$Partner$PartnerProductDocument$All$pdfName(doc);
													if (!_v6.$) {
														return A2(
															$author$project$Ui$Typography$p,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text('A file is already uploaded. Select a new file to replace it.')
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												} else {
													return $author$project$Utils$Html$empty;
												}
											}
										}(),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]))
								]);
						}
					}())));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentEditModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewDeleteConfirmModal = function (model) {
	var _v0 = model.b_;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var request = _v1.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('delete'),
					$author$project$Components$HiConfirm$noun('precondition'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(request, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Save = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Type_ = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Url = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewFormModal = function (model) {
	var _v0 = model.ah;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var maybePrecondition = _v1.a;
		var form = _v1.b;
		var request = _v1.c;
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Precondition',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$Precondition$id, maybePrecondition),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm,
			U0: $author$project$Components$Partner$ManagePartnerProductPreconditions$Save
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Type'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$Precondition$Type$toString(form.ahI))),
									$author$project$Ui$Form$Select$onChange(
									function (val) {
										if (val === 'external_account') {
											return $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm(
												$author$project$Components$Partner$ManagePartnerProductPreconditions$Type_(1));
										} else {
											return $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm(
												$author$project$Components$Partner$ManagePartnerProductPreconditions$Type_(0));
										}
									})
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('external_install'),
									'External Install'),
									A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just('external_account'),
									'External Account')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('URL'),
							$author$project$Ui$Form$Group$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(form.aav),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm, $author$project$Components$Partner$ManagePartnerProductPreconditions$Url))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$modal = function (_v0) {
	var model = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Components$Partner$ManagePartnerProductPreconditions$viewDeleteConfirmModal(model),
				$author$project$Components$Partner$ManagePartnerProductPreconditions$viewFormModal(model)
			]));
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Add = {$: 4};
var $author$project$Components$Partner$ManagePartnerProductDocuments$PaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$SortTable = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'title', true, 'Name'),
		A3($author$project$Api$Column$init, 'document_type', true, 'Type'),
		A3($author$project$Api$Column$init, 'content', false, 'Content'),
		A3($author$project$Api$Column$init, 'actions', false, '')
	]);
var $author$project$Components$Partner$ManagePartnerProductDocuments$Delete = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$Edit = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$OpenPdf = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentRow = function (doc) {
	var docType = $author$project$Api$Partner$PartnerProductDocument$All$documentType(doc);
	var typeLabel = function () {
		if (!docType) {
			return 'PDF';
		} else {
			return 'URL';
		}
	}();
	var contentCell = function () {
		if (docType === 1) {
			var _v1 = $author$project$Api$Partner$PartnerProductDocument$All$url(doc);
			if (!_v1.$) {
				var url = _v1.a;
				return A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(url)
								]))
						]));
			} else {
				return A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil);
			}
		} else {
			return A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Open PDF'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductDocuments$OpenPdf(doc))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Open PDF')
							]))
					]));
		}
	}();
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Partner$PartnerProductDocument$All$title(doc))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(typeLabel)
					])),
				contentCell,
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Edit document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductDocuments$Edit(doc))
							]),
						_List_Nil),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Delete document'},
						_List_fromArray(
							[
								$author$project$Ui$Button$danger,
								$author$project$Ui$Button$sm,
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Partner$ManagePartnerProductDocuments$Delete(doc))
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bq;
		if (_v1.$ === 3) {
			var docs = _v1.a;
			return _Utils_Tuple2(false, docs);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var documents = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('No documents added yet.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view(
				A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Partner$ManagePartnerProductDocuments$SortTable)),
			$author$project$Components$Partner$ManagePartnerProductDocuments$columns),
		A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentRow, documents),
		_List_Nil);
};
var $author$project$Components$Partner$ManagePartnerProductDocuments$view = function (_v0) {
	var model = _v0;
	var loading = _Utils_eq(model.bq, $author$project$Api$Data$Loading);
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									$elm$html$Html$text('Documents')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add document'},
									_List_fromArray(
										[
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
											$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDocuments$Add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Document')
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg,
							A2(
								$author$project$Ui$SearchInput$view,
								_List_fromArray(
									[
										$author$project$Ui$SearchInput$placeholder('Filter by title')
									]),
								model.sA))
						])),
					$author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentTable(model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Partner$ManagePartnerProductDocuments$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.afy))
						]))
				]))
		]);
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$OpenAdd = {$: 1};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$Delete = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$OpenEdit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Element$gap = $author$project$Ui$Element$Gap(1);
var $author$project$Ui$Alignment$Self = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Alignment$selfCenter = $author$project$Ui$Alignment$Self(1);
var $author$project$Ui$Element$selfCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$selfCenter);
var $author$project$Ui$Well$FullWidth = {$: 4};
var $author$project$Ui$Well$wFull = $author$project$Ui$Well$FullWidth;
var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewPreview = function (precondition) {
	var l = $author$project$Api$Common$Marketplace$Product$Precondition$Type$labels(
		$author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition));
	return A2(
		$author$project$Ui$FlexGrid$column,
		_List_fromArray(
			[
				$author$project$Ui$FlexGrid$span(5)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Well$view,
						_List_fromArray(
							[$author$project$Ui$Well$wFull]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$gap]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(l.Ed),
												A3(
												$author$project$Ui$Link$externalHref,
												$author$project$Api$Common$Marketplace$Product$Precondition$url(precondition),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(l.FZ)
													])),
												$elm$html$Html$text(l.D$)
											])),
										A2(
										$author$project$Ui$Form$Checkbox$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Checkbox$disabled(true)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text(l.Ez)
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap2, $author$project$Ui$Element$selfCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Edit precondition'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$Partner$ManagePartnerProductPreconditions$OpenEdit(precondition)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Edit')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Delete precondition'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Partner$ManagePartnerProductPreconditions$Delete(precondition))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Remove')
									]))
							]))
					]))
			]));
};
var $author$project$Components$Partner$ManagePartnerProductPreconditions$view = function (_v0) {
	var model = _v0;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Preconditions')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = model.WT;
							if (_v1.$ === 3) {
								if (!_v1.a.b) {
									return A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted]),
										_List_fromArray(
											[
												$elm$html$Html$text('No preconditions added yet.')
											]));
								} else {
									var preconditions = _v1.a;
									return A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductPreconditions$viewPreview, preconditions));
								}
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt4]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add precondition'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
											$author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductPreconditions$OpenAdd)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Add Precondition')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$Product$ActivationSettings$view = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg,
				$author$project$Components$Partner$ManagePartnerProductDocuments$modal(model.i4)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg,
				$author$project$Components$Partner$ManagePartnerProductPreconditions$modal(model.i6)),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Product$ActivationSettings$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Activation Settings')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Enabled')
											]),
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$view(
												_List_fromArray(
													[
														$author$project$Ui$ToggleSwitch$on(fields.bl),
														$author$project$Ui$ToggleSwitch$onChange(
														A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated, $author$project$Pages$Partner$Product$ActivationSettings$AutomaticallyIntegrates))
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Headless')
											]),
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$view(
												_List_fromArray(
													[
														$author$project$Ui$ToggleSwitch$on(fields.fL),
														$author$project$Ui$ToggleSwitch$onChange(
														A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated, $author$project$Pages$Partner$Product$ActivationSettings$Headless)),
														$author$project$Ui$ToggleSwitch$disabled(!fields.bl)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label(
												(fields.bl && fields.fL) ? 'Connect URL' : 'Redirect URL'),
												$author$project$Ui$Form$Group$required(fields.bl)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														A2($elm$core$Maybe$withDefault, '', fields.X0)),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated, $author$project$Pages$Partner$Product$ActivationSettings$RedirectUrl)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 0, model.PB)),
														$author$project$Ui$Form$Input$disabled(!fields.bl)
													])),
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$helpBlock]),
												_List_fromArray(
													[
														$elm$html$Html$text('We\'ll append an authorization code to this url. '),
														$elm$html$Html$text('For example, if your url is '),
														A2(
														$author$project$Ui$Typography$pre,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('https://some.example.com/signup?code=')
															])),
														$elm$html$Html$text(' then, '),
														$elm$html$Html$text('we would append a code so it would become '),
														A2(
														$author$project$Ui$Typography$pre,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('https://some.example.com/signup?code=2jK3jlOOOpejk7xnKEl')
															]))
													])),
												A2(
												$author$project$Ui$Alert$warning,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$title,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Hey. Check That Redirect!')
															])),
														$elm$html$Html$text('We just put the authorization code immediately after your url, no questions asked. This lets you retain control over how that auth code gets used in your routes, whether it\'s a query param or just part of the route, like an ID.')
													]))
											])),
										(fields.bl && fields.fL) ? A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(4),
												$author$project$Ui$Form$Group$inputSpan(8),
												$author$project$Ui$Form$Group$label('Post Activation Redirect URL')
											]),
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$view(
												_List_fromArray(
													[
														$author$project$Ui$Form$Input$value(
														A2($elm$core$Maybe$withDefault, '', fields.WA)),
														$author$project$Ui$Form$Input$onInput(
														A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated, $author$project$Pages$Partner$Product$ActivationSettings$PostActivationRedirectUrl)),
														$author$project$Ui$Form$Input$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
														$author$project$Ui$Form$Input$errors(
														A2($author$project$Utils$Form$validationErrors, 1, model.PB))
													]))
											])) : $author$project$Utils$Html$empty
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Save partner changes'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(
												_Utils_eq(model.o$, $author$project$Api$Data$Loading))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Save')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg),
					$author$project$Components$Partner$ManagePartnerProductDocuments$view(model.i4))),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt4]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg),
					$author$project$Components$Partner$ManagePartnerProductPreconditions$view(model.i6)))
			]),
		$G: 'Partner | Product | ActivationSettings'
	};
};
var $author$project$Pages$Partner$Product$ActivationSettings$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Product$ActivationSettings$init, aer: $author$project$Pages$Partner$Product$ActivationSettings$load, agD: $author$project$Pages$Partner$Product$ActivationSettings$save, ahd: $author$project$Pages$Partner$Product$ActivationSettings$subscriptions, aaq: $author$project$Pages$Partner$Product$ActivationSettings$update, ahP: $author$project$Pages$Partner$Product$ActivationSettings$view});
var $author$project$Pages$Partner$Product$AppSettings$GotApp = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AppAnchors$NavMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Partner$AppAnchors$TypeDropdownMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Partner$AppAnchor$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Partner$AppAnchors$init = F2(
	function (isHintAdmin, anchors) {
		var _v0 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
		var navModel = _v0.a;
		var navCmd = _v0.b;
		return _Utils_Tuple2(
			{
				Z: $elm$core$Maybe$Nothing,
				hu: $author$project$Api$Data$NotAsked,
				D2: anchors,
				qf: $author$project$Api$Data$NotAsked,
				lO: false,
				FR: isHintAdmin,
				m8: navModel,
				bc: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Partner$AppAnchor$id,
					$elm$core$List$head(anchors)),
				oU: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'anchor-type-dropdown', ahx: $author$project$Components$Partner$AppAnchors$TypeDropdownMsg}))
			},
			navCmd);
	});
var $author$project$Api$Partner$App$appPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['app']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$App$App = $elm$core$Basics$identity;
var $author$project$Api$Partner$App$Record = F5(
	function (name, status, handshakeUrl, partnerRoles, anchors) {
		return {D2: anchors, P$: handshakeUrl, zh: name, VG: partnerRoles, ag7: status};
	});
var $author$project$Api$Partner$AppAnchor$AppAnchor = $elm$core$Basics$identity;
var $author$project$Api$Partner$AppAnchor$Record = function (id) {
	return function (type_) {
		return function (sourceUrl) {
			return function (interactionTitle) {
				return function (interactionDescription) {
					return function (interactionType) {
						return function (corePageIconUrl) {
							return function (corePageIconLabel) {
								return function (corePageAutoAdjustHeight) {
									return function (settingsLabel) {
										return {LV: corePageAutoAdjustHeight, LW: corePageIconLabel, LX: corePageIconUrl, adR: id, Rb: interactionDescription, Rc: interactionTitle, Rd: interactionType, ZE: settingsLabel, _j: sourceUrl, ahI: type_};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Partner$AppAnchor$ClinicalInteraction = 1;
var $author$project$Api$Partner$AppAnchor$CorePage = 0;
var $author$project$Api$Partner$AppAnchor$Settings = 2;
var $author$project$Api$Partner$AppAnchor$decodeAnchorType = A2(
	$elm$json$Json$Decode$andThen,
	function (typeString) {
		switch (typeString) {
			case 'core_page':
				return $elm$json$Json$Decode$succeed(0);
			case 'clinical_interaction':
				return $elm$json$Json$Decode$succeed(1);
			case 'settings':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Invalid anchor type ' + typeString);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Partner$AppAnchor$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'settings_label',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'core_page_auto_adjust_height',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'core_page_icon_label',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'core_page_icon_url',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					$elm$core$Maybe$Nothing,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'interaction_type',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'interaction_description',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'interaction_title',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								$elm$core$Maybe$Nothing,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'source_url',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'type',
										$author$project$Api$Partner$AppAnchor$decodeAnchorType,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Partner$AppAnchor$Record))))))))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$App$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'anchors',
		$elm$json$Json$Decode$list($author$project$Api$Partner$AppAnchor$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'partner_roles',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'handshake_url',
				$elm$json$Json$Decode$string,
				'',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Partner$App$Record)))))),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$App$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Partner$App$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath));
	});
var $author$project$Pages$Partner$Product$AppSettings$init = F4(
	function (_v0, partner, shared, _v1) {
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				cz: $author$project$Api$Data$Loading,
				hv: A2($author$project$Components$Partner$AppAnchors$init, isHintAdmin, _List_Nil).a,
				a2: $elm$core$Maybe$Nothing,
				FR: isHintAdmin,
				Vz: partner,
				tc: $author$project$Ui$TagsInput$init('partner-roles'),
				tg: false,
				oJ: $author$project$Api$Data$NotAsked,
				o$: $author$project$Api$Data$NotAsked
			},
			A2($author$project$Api$Partner$App$retrieve, shared.D5, $author$project$Pages$Partner$Product$AppSettings$GotApp));
	});
var $author$project$Pages$Partner$Product$AppSettings$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Product$AppSettings$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Partner$Product$AppSettings$EditModalClosed = {$: 4};
var $author$project$Pages$Partner$Product$AppSettings$TestHandshakeModalClosed = {$: 9};
var $author$project$Components$Partner$AppAnchors$AnchorModalClosed = {$: 7};
var $author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed = {$: 4};
var $author$project$Components$Partner$AppAnchors$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$AppAnchors$AnchorModalClosed),
				$author$project$Ui$Nav$subscriptions(model.m8),
				$author$project$Ui$NewDropdown$subscriptions(model.oU),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed)
			]));
};
var $author$project$Pages$Partner$Product$AppSettings$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg,
				$author$project$Components$Partner$AppAnchors$subscriptions(model.hv)),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Product$AppSettings$TestHandshakeModalClosed),
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Product$AppSettings$EditModalClosed)
			]));
};
var $author$project$Pages$Partner$Product$AppSettings$GotCreatedApp = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Product$AppSettings$GotTestHandshakeResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Partner$Product$AppSettings$GotUpdatedApp = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$App$HandshakeUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$App$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$App$PartnerRoles = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Product$AppSettings$PartnerRoles = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Product$AppSettings$TagsInputMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Partner$App$anchors = function (_v0) {
	var record = _v0;
	return record.D2;
};
var $author$project$Api$Partner$App$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$App$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath));
	});
var $author$project$Pages$Partner$Product$AppSettings$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var name = field.a;
				return _Utils_update(
					fields,
					{zh: name});
			case 1:
				var url = field.a;
				return _Utils_update(
					fields,
					{P$: url});
			default:
				var roles = field.a;
				return _Utils_update(
					fields,
					{VG: roles});
		}
	});
var $author$project$Api$Partner$App$handshakeTest = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['handshake_test']),
					$author$project$Api$Partner$App$appPath)));
	});
var $author$project$Api$Partner$App$handshakeUrl = function (_v0) {
	var record = _v0;
	return record.P$;
};
var $author$project$Api$Partner$App$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Partner$App$partnerRoles = function (_v0) {
	var record = _v0;
	return record.VG;
};
var $author$project$Api$Partner$App$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var name_ = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(name_)),
							acc);
					case 1:
						var maybeUrl = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'handshake_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)),
							acc);
					default:
						var roles = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'partner_roles',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, roles)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'app',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$App$update = F3(
	function (apiClient, permittedFields, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Partner$App$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Partner$App$encodePermittedFields(permittedFields),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath)));
	});
var $author$project$Components$Partner$AppAnchors$AnchorFormUpdated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$AppAnchors$AnchorType = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$AppAnchor$CorePageAutoAdjustHeight = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$AppAnchor$CorePageIcon = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageIcon = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Partner$AppAnchor$CorePageIconLabel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$AppAnchors$GotAnchorResult = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$AppAnchors$GotDeletedAnchor = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Partner$AppAnchor$InteractionDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Partner$AppAnchor$InteractionTitle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$AppAnchor$InteractionType = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$AppAnchor$SettingsLabel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$AppAnchor$SourceUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Partner$AppAnchor$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageCustomization = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$AppAnchors$General = 0;
var $author$project$Components$Partner$AppAnchors$SettingsCustomization = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$AppAnchors$initCustomizationFromType = function (type_) {
	switch (type_) {
		case 0:
			return $author$project$Components$Partner$AppAnchors$CorePageCustomization(
				{LV: true, LW: $elm$core$Maybe$Nothing, wP: 0, LX: $elm$core$Maybe$Nothing, wW: $elm$core$Maybe$Nothing});
		case 1:
			return $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
				{Rb: '', Rc: '', Rd: 0});
		default:
			return $author$project$Components$Partner$AppAnchors$SettingsCustomization(
				{ZE: $elm$core$Maybe$Nothing});
	}
};
var $author$project$Components$Partner$AppAnchors$Lab = 1;
var $author$project$Components$Partner$AppAnchors$interactionTypeFromString = function (s) {
	switch (s) {
		case 'general':
			return $elm$core$Maybe$Just(0);
		case 'lab':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var type_ = field.a;
				return _Utils_update(
					fields,
					{
						s: $author$project$Components$Partner$AppAnchors$initCustomizationFromType(type_),
						ahI: type_
					});
			case 1:
				var url = field.a;
				return _Utils_update(
					fields,
					{_j: url});
			case 5:
				var _int = field.a;
				var string = field.b;
				var _v1 = fields.s;
				switch (_v1.$) {
					case 0:
						var config = _v1.a;
						return _Utils_update(
							fields,
							{
								s: $author$project$Components$Partner$AppAnchors$CorePageCustomization(
									_Utils_update(
										config,
										{
											wP: _int,
											LX: $elm$core$Maybe$Just(string),
											wW: $elm$core$Maybe$Just(string)
										}))
							});
					case 1:
						return fields;
					default:
						return fields;
				}
			case 6:
				var label = field.a;
				var _v2 = fields.s;
				switch (_v2.$) {
					case 0:
						var config = _v2.a;
						return _Utils_update(
							fields,
							{
								s: $author$project$Components$Partner$AppAnchors$CorePageCustomization(
									_Utils_update(
										config,
										{
											LW: $author$project$Utils$String$toMaybe(label)
										}))
							});
					case 1:
						return fields;
					default:
						return fields;
				}
			case 7:
				var autoAdjust = field.a;
				var _v3 = fields.s;
				switch (_v3.$) {
					case 0:
						var config = _v3.a;
						return _Utils_update(
							fields,
							{
								s: $author$project$Components$Partner$AppAnchors$CorePageCustomization(
									_Utils_update(
										config,
										{LV: autoAdjust}))
							});
					case 1:
						return fields;
					default:
						return fields;
				}
			case 2:
				var title = field.a;
				var _v4 = fields.s;
				switch (_v4.$) {
					case 1:
						var config = _v4.a;
						return _Utils_update(
							fields,
							{
								s: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
									_Utils_update(
										config,
										{Rc: title}))
							});
					case 0:
						return fields;
					default:
						return fields;
				}
			case 3:
				var description = field.a;
				var _v5 = fields.s;
				switch (_v5.$) {
					case 1:
						var config = _v5.a;
						return _Utils_update(
							fields,
							{
								s: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
									_Utils_update(
										config,
										{Rb: description}))
							});
					case 0:
						return fields;
					default:
						return fields;
				}
			case 4:
				var string = field.a;
				var _v6 = fields.s;
				switch (_v6.$) {
					case 1:
						var config = _v6.a;
						return _Utils_update(
							fields,
							{
								s: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
									_Utils_update(
										config,
										{
											Rd: A2(
												$elm$core$Maybe$withDefault,
												0,
												$author$project$Components$Partner$AppAnchors$interactionTypeFromString(string))
										}))
							});
					case 0:
						return fields;
					default:
						return fields;
				}
			default:
				var label = field.a;
				var _v7 = fields.s;
				switch (_v7.$) {
					case 2:
						var config = _v7.a;
						return _Utils_update(
							fields,
							{
								s: $author$project$Components$Partner$AppAnchors$SettingsCustomization(
									_Utils_update(
										config,
										{
											ZE: $author$project$Utils$String$toMaybe(label)
										}))
							});
					case 0:
						return fields;
					default:
						return fields;
				}
		}
	});
var $author$project$Api$Partner$AppAnchor$appAnchorsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['app', 'anchors']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$AppAnchor$typeToValue = function (anchorType) {
	switch (anchorType) {
		case 0:
			return 'core_page';
		case 1:
			return 'clinical_interaction';
		default:
			return 'settings';
	}
};
var $author$project$Api$Partner$AppAnchor$encodePermittedFields = function (permittedFields) {
	var encodedFields = A3(
		$elm$core$List$foldl,
		F2(
			function (field, acc) {
				switch (field.$) {
					case 0:
						var anchorType = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string(
									$author$project$Api$Partner$AppAnchor$typeToValue(anchorType))),
							acc);
					case 1:
						var url = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'source_url',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, url)),
							acc);
					case 3:
						var description = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'interaction_description',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, description)),
							acc);
					case 2:
						var title = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'interaction_title',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, title)),
							acc);
					case 4:
						var interactionType_ = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'interaction_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, interactionType_)),
							acc);
					case 5:
						var icon = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'core_page_icon',
								$elm$json$Json$Encode$string(icon)),
							acc);
					case 6:
						var label = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'core_page_icon_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, label)),
							acc);
					case 7:
						var autoAdjustHeight = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'core_page_auto_adjust_height',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, autoAdjustHeight)),
							acc);
					default:
						var label = field.a;
						return A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'settings_label',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, label)),
							acc);
				}
			}),
		_List_Nil,
		permittedFields);
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'anchor',
				$elm$json$Json$Encode$object(encodedFields))
			]));
};
var $author$project$Api$Partner$AppAnchor$create = F3(
	function (apiClient, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$AppAnchor$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$AppAnchor$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$AppAnchor$appAnchorsPath)));
	});
var $author$project$Api$Partner$AppAnchor$appAnchorPath = function (anchorId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[anchorId]),
		$author$project$Api$Partner$AppAnchor$appAnchorsPath);
};
var $author$project$Api$Partner$AppAnchor$delete = F3(
	function (apiClient, anchorId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$AppAnchor$appAnchorPath(anchorId)));
	});
var $author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight = function (_v0) {
	var record = _v0;
	return record.LV;
};
var $author$project$Api$Partner$AppAnchor$corePageIconLabel = function (_v0) {
	var record = _v0;
	return record.LW;
};
var $author$project$Api$Partner$AppAnchor$corePageIconUrl = function (_v0) {
	var record = _v0;
	return record.LX;
};
var $author$project$Api$Partner$AppAnchor$interactionDescription = function (_v0) {
	var record = _v0;
	return record.Rb;
};
var $author$project$Api$Partner$AppAnchor$interactionTitle = function (_v0) {
	var record = _v0;
	return record.Rc;
};
var $author$project$Api$Partner$AppAnchor$interactionType = function (_v0) {
	var record = _v0;
	return record.Rd;
};
var $author$project$Api$Partner$AppAnchor$settingsLabel = function (_v0) {
	var record = _v0;
	return record.ZE;
};
var $author$project$Api$Partner$AppAnchor$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Components$Partner$AppAnchors$initCustomizationFromAnchor = function (anchor) {
	var _v0 = $author$project$Api$Partner$AppAnchor$type_(anchor);
	switch (_v0) {
		case 0:
			return $author$project$Components$Partner$AppAnchors$CorePageCustomization(
				{
					LV: A2(
						$elm$core$Maybe$withDefault,
						true,
						$author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight(anchor)),
					LW: $author$project$Api$Partner$AppAnchor$corePageIconLabel(anchor),
					wP: 0,
					LX: $elm$core$Maybe$Nothing,
					wW: $author$project$Api$Partner$AppAnchor$corePageIconUrl(anchor)
				});
		case 1:
			return $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(
				{
					Rb: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Partner$AppAnchor$interactionDescription(anchor)),
					Rc: A2(
						$elm$core$Maybe$withDefault,
						'',
						$author$project$Api$Partner$AppAnchor$interactionTitle(anchor)),
					Rd: A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							$author$project$Components$Partner$AppAnchors$interactionTypeFromString,
							$author$project$Api$Partner$AppAnchor$interactionType(anchor)))
				});
		default:
			return $author$project$Components$Partner$AppAnchors$SettingsCustomization(
				{
					ZE: $author$project$Api$Partner$AppAnchor$settingsLabel(anchor)
				});
	}
};
var $author$project$Components$Partner$AppAnchors$interactionTypeToString = function (type_) {
	if (!type_) {
		return 'general';
	} else {
		return 'lab';
	}
};
var $author$project$Api$Partner$AppAnchor$sourceUrl = function (_v0) {
	var record = _v0;
	return record._j;
};
var $author$project$Api$Partner$AppAnchor$update = F4(
	function (apiClient, anchorId, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$AppAnchor$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$AppAnchor$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$AppAnchor$appAnchorPath(anchorId))));
	});
var $author$project$Components$Partner$AppAnchors$SourceUrlValidation = 0;
var $author$project$Components$Partner$AppAnchors$CorePageIconValidation = 1;
var $author$project$Components$Partner$AppAnchors$maxCorePageIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$AppAnchors$validaCorePageIconSize = function (fields) {
	var _v0 = fields.s;
	switch (_v0.$) {
		case 0:
			var config = _v0.a;
			return (_Utils_cmp(config.wP, $author$project$Components$Partner$AppAnchors$maxCorePageIconBytesSize) > 0) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')
				]) : _List_Nil;
		case 1:
			return _List_Nil;
		default:
			return _List_Nil;
	}
};
var $author$project$Components$Partner$AppAnchors$validateAnchor = function (form) {
	var validator = $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $._j;
				},
				_Utils_Tuple2(0, 'Source URL is required')),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$AppAnchors$validaCorePageIconSize)
			]));
	return A2($author$project$Utils$Form$validate, validator, form);
};
var $author$project$Components$Partner$AppAnchors$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var form = $author$project$Utils$Form$init(
					{
						s: $author$project$Components$Partner$AppAnchors$initCustomizationFromType(0),
						_j: '',
						ahI: 0
					});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							Z: $elm$core$Maybe$Just(
								_Utils_Tuple2($elm$core$Maybe$Nothing, form))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var id = msg.a;
				var _v1 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
				var navModel = _v1.a;
				var navCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							m8: navModel,
							bc: $elm$core$Maybe$Just(id)
						}),
					navCmd,
					_List_Nil);
			case 2:
				var _v2 = _Utils_Tuple2(
					model.bc,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (anchor) {
								return _Utils_eq(
									$elm$core$Maybe$Just(
										$author$project$Api$Partner$AppAnchor$id(anchor)),
									model.bc);
							},
							model.D2)));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var anchorId = _v2.a.a;
					var selectedAnchor = _v2.b.a;
					var form = $author$project$Utils$Form$init(
						{
							s: $author$project$Components$Partner$AppAnchors$initCustomizationFromAnchor(selectedAnchor),
							_j: $author$project$Api$Partner$AppAnchor$sourceUrl(selectedAnchor),
							ahI: $author$project$Api$Partner$AppAnchor$type_(selectedAnchor)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Z: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(anchorId),
										form))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lO: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lO: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var _v3 = model.bc;
				if (!_v3.$) {
					var anchorId = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qf: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$AppAnchor$delete, apiClient, anchorId, $author$project$Components$Partner$AppAnchors$GotDeletedAnchor),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var updatedAnchors = A2(
						$elm$core$List$filter,
						function (anchor) {
							return !_Utils_eq(
								$elm$core$Maybe$Just(
									$author$project$Api$Partner$AppAnchor$id(anchor)),
								model.bc);
						},
						model.D2);
					var newSelectedId = A2(
						$elm$core$Maybe$map,
						$author$project$Api$Partner$AppAnchor$id,
						$elm$core$List$head(updatedAnchors));
					var _v5 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
					var navModel = _v5.a;
					var navCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{D2: updatedAnchors, qf: $author$project$Api$Data$NotAsked, lO: false, m8: navModel, bc: newSelectedId}),
						navCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Surface deleted successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{qf: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Z: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var field = msg.a;
				var _v6 = model.Z;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var maybeId = _v7.a;
					var form = _v7.b;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Z: $elm$core$Maybe$Just(
									_Utils_Tuple2(maybeId, newForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var _v8 = model.Z;
				if (!_v8.$) {
					var _v9 = _v8.a;
					var maybeId = _v9.a;
					var form = _v9.b;
					var _v10 = $author$project$Components$Partner$AppAnchors$validateAnchor(form);
					if (!_v10.$) {
						var _v11 = _v10.a;
						var anchorForm = _v11.a;
						var validFields = _v11.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
						var permittedFields = A2(
							$elm$core$List$cons,
							$author$project$Api$Partner$AppAnchor$Type(fields.ahI),
							A2(
								$elm$core$List$cons,
								$author$project$Api$Partner$AppAnchor$SourceUrl(
									$elm$core$Maybe$Just(fields._j)),
								function () {
									var _v14 = fields.s;
									switch (_v14.$) {
										case 1:
											var config = _v14.a;
											return _List_fromArray(
												[
													$author$project$Api$Partner$AppAnchor$InteractionTitle(
													$author$project$Utils$Maybe$fromString(config.Rc)),
													$author$project$Api$Partner$AppAnchor$InteractionDescription(
													$author$project$Utils$Maybe$fromString(config.Rb)),
													$author$project$Api$Partner$AppAnchor$InteractionType(
													$elm$core$Maybe$Just(
														$author$project$Components$Partner$AppAnchors$interactionTypeToString(config.Rd)))
												]);
										case 0:
											var config = _v14.a;
											return A2(
												$elm$core$List$cons,
												$author$project$Api$Partner$AppAnchor$CorePageIconLabel(config.LW),
												A2(
													$elm$core$List$cons,
													$author$project$Api$Partner$AppAnchor$CorePageAutoAdjustHeight(
														$elm$core$Maybe$Just(config.LV)),
													function () {
														var _v15 = config.LX;
														if (!_v15.$) {
															var iconUrl = _v15.a;
															return _List_fromArray(
																[
																	$author$project$Api$Partner$AppAnchor$CorePageIcon(iconUrl)
																]);
														} else {
															return _List_Nil;
														}
													}()));
										default:
											var config = _v14.a;
											return _List_fromArray(
												[
													$author$project$Api$Partner$AppAnchor$SettingsLabel(config.ZE)
												]);
									}
								}()));
						var _v12 = function () {
							if (maybeId.$ === 1) {
								return _Utils_Tuple2(
									A3($author$project$Api$Partner$AppAnchor$create, apiClient, permittedFields, $author$project$Components$Partner$AppAnchors$GotAnchorResult),
									_Utils_update(
										model,
										{
											Z: $elm$core$Maybe$Just(
												_Utils_Tuple2(maybeId, anchorForm)),
											hu: $author$project$Api$Data$Loading
										}));
							} else {
								var anchorId = maybeId.a;
								return _Utils_Tuple2(
									A4($author$project$Api$Partner$AppAnchor$update, apiClient, anchorId, permittedFields, $author$project$Components$Partner$AppAnchors$GotAnchorResult),
									_Utils_update(
										model,
										{
											Z: $elm$core$Maybe$Just(
												_Utils_Tuple2(maybeId, anchorForm)),
											hu: $author$project$Api$Data$Loading
										}));
							}
						}();
						var cmd = _v12.a;
						var updatedModel = _v12.b;
						return _Utils_Tuple3(updatedModel, cmd, _List_Nil);
					} else {
						var formWithErrors = _v10.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Z: $elm$core$Maybe$Just(
										_Utils_Tuple2(maybeId, formWithErrors))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					var anchor = response.a;
					var _v17 = function () {
						var _v18 = model.Z;
						if (!_v18.$) {
							if (_v18.a.a.$ === 1) {
								var _v19 = _v18.a;
								var _v20 = _v19.a;
								return _Utils_Tuple3(
									_Utils_ap(
										model.D2,
										_List_fromArray(
											[anchor])),
									'Surface created successfully!',
									$elm$core$Maybe$Just(
										$author$project$Api$Partner$AppAnchor$id(anchor)));
							} else {
								var _v21 = _v18.a;
								var anchorId = _v21.a.a;
								return _Utils_Tuple3(
									A2(
										$elm$core$List$map,
										function (a) {
											return _Utils_eq(
												$author$project$Api$Partner$AppAnchor$id(a),
												anchorId) ? anchor : a;
										},
										model.D2),
									'Surface updated successfully!',
									model.bc);
							}
						} else {
							return _Utils_Tuple3(model.D2, 'Surface saved successfully!', model.bc);
						}
					}();
					var updatedAnchors = _v17.a;
					var toastMessage = _v17.b;
					var newSelectedId = _v17.c;
					var _v22 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
					var navModel = _v22.a;
					var navCmd = _v22.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Z: $elm$core$Maybe$Nothing, hu: $author$project$Api$Data$NotAsked, D2: updatedAnchors, m8: navModel, bc: newSelectedId}),
						navCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, toastMessage)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hu: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var subMsg = msg.a;
				var _v23 = A2($author$project$Ui$Nav$update, subMsg, model.m8);
				var navModel = _v23.a;
				var navCmd = _v23.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m8: navModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AppAnchors$NavMsg, navCmd),
					_List_Nil);
			case 12:
				var subMsg = msg.a;
				var _v24 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oU);
				var typeDropdown = _v24.a;
				var cmd = _v24.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oU: typeDropdown}),
					cmd,
					_List_Nil);
			case 13:
				var selectedType = msg.a;
				var _v25 = model.Z;
				if (!_v25.$) {
					var _v26 = _v25.a;
					var maybeId = _v26.a;
					var form = _v26.b;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate,
						$author$project$Components$Partner$AppAnchors$AnchorType(selectedType),
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Z: $elm$core$Maybe$Just(
									_Utils_Tuple2(maybeId, newForm))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var logos = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v27) {
							var task = _v27.a;
							var size = _v27.b;
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Components$Partner$AppAnchors$AnchorFormUpdated,
									$author$project$Components$Partner$AppAnchors$CorePageIcon(size)),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (logo) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(logo),
									$elm$file$File$size(logo));
							},
							$elm$core$List$head(logos))));
				return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Pages$Partner$Product$AppSettings$NameValidation = 0;
var $author$project$Pages$Partner$Product$AppSettings$validate = function (form) {
	var validator = $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.zh;
				},
				_Utils_Tuple2(0, 'Name is required'))
			]));
	return A2($author$project$Utils$Form$validate, validator, form);
};
var $author$project$Pages$Partner$Product$AppSettings$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				_v1$2:
				while (true) {
					switch (response.$) {
						case 3:
							var app = response.a;
							var _v2 = A2(
								$author$project$Components$Partner$AppAnchors$init,
								model.FR,
								$author$project$Api$Partner$App$anchors(app));
							var appAnchors = _v2.a;
							var appAnchorsCmd = _v2.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{cz: response, hv: appAnchors}),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg, appAnchorsCmd),
								_List_Nil);
						case 2:
							if (response.a.$ === 5) {
								var _v3 = response.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{cz: response}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cz: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Partner$App$create, model.D5, $author$project$Pages$Partner$Product$AppSettings$GotCreatedApp),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cz: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var _v5 = model.cz;
				if (_v5.$ === 3) {
					var app = _v5.a;
					var form = $author$project$Utils$Form$init(
						{
							P$: $author$project$Api$Partner$App$handshakeUrl(app),
							zh: $author$project$Api$Partner$App$name(app),
							VG: $author$project$Api$Partner$App$partnerRoles(app)
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a2: $elm$core$Maybe$Just(form)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a2: $elm$core$Maybe$Nothing, o$: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var subMsg = msg.a;
				var _v6 = model.a2;
				if (!_v6.$) {
					var form = _v6.a;
					var _v7 = A2($author$project$Ui$TagsInput$update, subMsg, model.tc);
					var newTagsInput = _v7.a;
					var tagsInputMsg = _v7.b;
					var maybeEvent = _v7.c;
					var newForm = A2(
						$elm$core$Maybe$withDefault,
						form,
						A2(
							$elm$core$Maybe$map,
							function (event) {
								var _v8 = $author$project$Utils$Form$fields(form);
								var partnerRoles = _v8.VG;
								var newPartnerRoles = function () {
									if (!event.$) {
										var tag = event.a;
										return _Utils_ap(
											partnerRoles,
											_List_fromArray(
												[tag]));
									} else {
										var tag = event.a;
										return A2($elm_community$list_extra$List$Extra$remove, tag, partnerRoles);
									}
								}();
								return A3(
									$author$project$Utils$Form$update,
									$author$project$Pages$Partner$Product$AppSettings$formFieldsUpdate,
									$author$project$Pages$Partner$Product$AppSettings$PartnerRoles(newPartnerRoles),
									form);
							},
							maybeEvent));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a2: $elm$core$Maybe$Just(newForm),
								tc: newTagsInput
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$AppSettings$TagsInputMsg, tagsInputMsg),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var field = msg.a;
				var _v10 = model.a2;
				if (!_v10.$) {
					var form = _v10.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Product$AppSettings$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a2: $elm$core$Maybe$Just(newForm)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var _v11 = model.a2;
				if (!_v11.$) {
					var form = _v11.a;
					var _v12 = $author$project$Pages$Partner$Product$AppSettings$validate(form);
					if (!_v12.$) {
						var _v13 = _v12.a;
						var appForm = _v13.a;
						var validFields = _v13.b;
						var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
						var permittedFields = _List_fromArray(
							[
								$author$project$Api$Partner$App$Name(fields.zh),
								$author$project$Api$Partner$App$HandshakeUrl(
								$elm$core$String$isEmpty(fields.P$) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.P$)),
								$author$project$Api$Partner$App$PartnerRoles(
								A2($elm_community$list_extra$List$Extra$filterNot, $elm$core$String$isEmpty, fields.VG))
							]);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a2: $elm$core$Maybe$Just(appForm),
									o$: $author$project$Api$Data$Loading
								}),
							A3($author$project$Api$Partner$App$update, model.D5, permittedFields, $author$project$Pages$Partner$Product$AppSettings$GotUpdatedApp),
							_List_Nil);
					} else {
						var formWithErrors = _v12.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a2: $elm$core$Maybe$Just(formWithErrors)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cz: response, a2: $elm$core$Maybe$Nothing, o$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'App updated successfully!')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var _v15 = model.cz;
				if (_v15.$ === 3) {
					var app = _v15.a;
					return $elm$core$String$isEmpty(
						$author$project$Api$Partner$App$handshakeUrl(app)) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{tg: true, oJ: $author$project$Api$Data$Loading}),
						A2($author$project$Api$Partner$App$handshakeTest, model.D5, $author$project$Pages$Partner$Product$AppSettings$GotTestHandshakeResult),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{tg: false, oJ: $author$project$Api$Data$NotAsked}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oJ: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v16 = A3($author$project$Components$Partner$AppAnchors$update, model.D5, subMsg, model.hv);
				var appAnchors = _v16.a;
				var cmd = _v16.b;
				var outMsgs = _v16.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hv: appAnchors}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg, cmd),
					outMsgs);
		}
	});
var $author$project$Pages$Partner$Product$AppSettings$EditClicked = {$: 3};
var $author$project$Pages$Partner$Product$AppSettings$TestHandshakeClicked = {$: 8};
var $author$project$Api$Partner$App$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Components$Partner$AppAnchors$CorePageAutoAdjustHeight = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageIconLabel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$AppAnchors$CorePageIconUploaded = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Partner$AppAnchors$InteractionDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Partner$AppAnchors$InteractionTitle = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$AppAnchors$InteractionType = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$AppAnchors$SaveAnchorClicked = {$: 9};
var $author$project$Components$Partner$AppAnchors$SettingsLabel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Partner$AppAnchors$SourceUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$AppAnchors$TypeSelected = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Partner$AppAnchor$typeToLabel = function (anchorType) {
	switch (anchorType) {
		case 0:
			return 'Full Page in Core';
		case 1:
			return 'Interaction on Clinical';
		default:
			return 'Settings';
	}
};
var $author$project$Components$Partner$AppAnchors$viewAnchorModal = F5(
	function (isHintAdmin, maybeId, form, anchorRequest, typeDropdown) {
		var isLoading = function () {
			if (anchorRequest.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var isEditing = !_Utils_eq(maybeId, $elm$core$Maybe$Nothing);
		var modalTitle = isEditing ? 'Edit Surface' : 'Add Surface';
		var fields = $author$project$Utils$Form$fields(form);
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Partner$AppAnchors$AnchorModalClosed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit($author$project$Components$Partner$AppAnchors$SaveAnchorClicked)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(modalTitle)
						])),
					$author$project$Ui$Modal$body(
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Type'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									isEditing ? $author$project$Ui$Form$Group$static(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$AppAnchor$typeToLabel(fields.ahI))
										])) : A4(
									$author$project$Ui$NewDropdown$viewSelect,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$AppAnchor$typeToLabel(fields.ahI))
										]),
									A2(
										$elm$core$List$map,
										function (type_) {
											return A2(
												$author$project$Ui$NewDropdown$item,
												_List_fromArray(
													[
														$author$project$Ui$NewDropdown$onSelect(
														$author$project$Components$Partner$AppAnchors$TypeSelected(type_)),
														$author$project$Ui$NewDropdown$selected(
														_Utils_eq(fields.ahI, type_))
													]),
												$elm$html$Html$text(
													$author$project$Api$Partner$AppAnchor$typeToLabel(type_)));
										},
										_List_fromArray(
											[0, 1, 2])),
									typeDropdown)
								])),
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('Source URL'),
										$author$project$Ui$Form$Group$required(true),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(fields._j),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$SourceUrl)),
												$author$project$Ui$Form$Input$errors(
												errorsFor(0)),
												$author$project$Ui$Form$Input$placeholder('https://your-app.com/widget')
											]))
									])),
							function () {
								var _v0 = _Utils_Tuple2(fields.ahI, fields.s);
								_v0$3:
								while (true) {
									switch (_v0.a) {
										case 0:
											if (!_v0.b.$) {
												var _v1 = _v0.a;
												var config = _v0.b.a;
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpan(8),
																$author$project$Ui$Form$Group$label('Icon')
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$File$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$File$accept(0),
																		$author$project$Ui$Form$File$onInput($author$project$Components$Partner$AppAnchors$CorePageIconUploaded),
																		$author$project$Ui$Form$File$empty(true)
																	]))
															])),
														function () {
														var _v2 = config.wW;
														if (!_v2.$) {
															var url = _v2.a;
															return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$labelSpanSm(4),
																		$author$project$Ui$Form$Group$inputSpan(8),
																		$author$project$Ui$Form$Group$label('')
																	]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Ui$Image$fromSrc,
																		{I1: 'Logo'},
																		url,
																		_List_fromArray(
																			[
																				$author$project$Ui$Image$height(50)
																			])),
																		$author$project$Utils$FormErrors$view(
																		A2($author$project$Utils$Form$validationErrors, 1, form))
																	]));
														} else {
															return $author$project$Utils$Html$empty;
														}
													}(),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Icon Label'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(
																		A2($elm$core$Maybe$withDefault, '', config.LW)),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$CorePageIconLabel)),
																		$author$project$Ui$Form$Input$placeholder('Enter icon label'),
																		$author$project$Ui$Form$Input$disabled(!isHintAdmin)
																	]))
															])),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8),
																$author$project$Ui$Form$Group$label('Auto adjust height')
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$static(
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Element$view,
																		_List_fromArray(
																			[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$mb2]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('When enabled, the iframe height adapts to the embedded app\'s content for a seamless layout without inner scrollbars.'),
																				A2($elm$html$Html$br, _List_Nil, _List_Nil),
																				$elm$html$Html$text('When disabled, the app stays boxed with its own scroll area, allowing sticky elements.')
																			])),
																		$author$project$Ui$ToggleSwitch$view(
																		_List_fromArray(
																			[
																				$author$project$Ui$ToggleSwitch$on(config.LV),
																				$author$project$Ui$ToggleSwitch$onChange(
																				A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$CorePageAutoAdjustHeight))
																			]))
																	]))
															]))
													]);
											} else {
												break _v0$3;
											}
										case 1:
											if (_v0.b.$ === 1) {
												var _v3 = _v0.a;
												var config = _v0.b.a;
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Interaction Title'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(config.Rc),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionTitle)),
																		$author$project$Ui$Form$Input$placeholder('Enter interaction title')
																	]))
															])),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Interaction Description'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(config.Rb),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionDescription)),
																		$author$project$Ui$Form$Input$placeholder('Enter interaction description')
																	]))
															])),
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Interaction Type'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Form$Select$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Select$value(
																		$elm$core$Maybe$Just(
																			$author$project$Components$Partner$AppAnchors$interactionTypeToString(config.Rd))),
																		$author$project$Ui$Form$Select$onChange(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionType))
																	]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Ui$Form$Select$option,
																		_List_Nil,
																		$elm$core$Maybe$Just(
																			$author$project$Components$Partner$AppAnchors$interactionTypeToString(0)),
																		'General'),
																		A3(
																		$author$project$Ui$Form$Select$option,
																		_List_Nil,
																		$elm$core$Maybe$Just(
																			$author$project$Components$Partner$AppAnchors$interactionTypeToString(1)),
																		'Lab')
																	]))
															]))
													]);
											} else {
												break _v0$3;
											}
										default:
											if (_v0.b.$ === 2) {
												var _v4 = _v0.a;
												var config = _v0.b.a;
												return _List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Group$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Group$label('Settings Label'),
																$author$project$Ui$Form$Group$labelSpanSm(4),
																$author$project$Ui$Form$Group$inputSpanSm(8)
															]),
														_List_fromArray(
															[
																$author$project$Ui$Form$Input$view(
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Input$value(
																		A2($elm$core$Maybe$withDefault, '', config.ZE)),
																		$author$project$Ui$Form$Input$onInput(
																		A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$SettingsLabel)),
																		$author$project$Ui$Form$Input$placeholder('Enter settings label')
																	]))
															]))
													]);
											} else {
												break _v0$3;
											}
									}
								}
								return _List_Nil;
							}()))),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$AnchorModalClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Save surface'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(isLoading),
									$author$project$Ui$Button$submit
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	});
var $author$project$Components$Partner$AppAnchors$AddAnchorClicked = {$: 0};
var $author$project$Components$Partner$AppAnchors$AnchorClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Nav$CustomItem = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$Nav$customItem = $author$project$Ui$Nav$CustomItem;
var $author$project$Ui$Nav$Id = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Nav$itemId = $author$project$Ui$Nav$Id;
var $author$project$Ui$Nav$Slim = 0;
var $author$project$Ui$Nav$slim = 0;
var $author$project$Api$Partner$AppAnchor$typeLabel = function (_v0) {
	var record = _v0;
	return $author$project$Api$Partner$AppAnchor$typeToLabel(record.ahI);
};
var $author$project$Components$Partner$AppAnchors$viewAnchorsAsNavs = function (model) {
	var anchorItems = A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, anchor) {
				return A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$itemId(
							$author$project$Api$Partner$AppAnchor$id(anchor)),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$Maybe$withDefault,
								!index,
								A2(
									$elm$core$Maybe$map,
									$elm$core$Basics$eq(
										$author$project$Api$Partner$AppAnchor$id(anchor)),
									model.bc))),
							$author$project$Ui$Nav$onItemClick(
							$author$project$Components$Partner$AppAnchors$AnchorClicked(
								$author$project$Api$Partner$AppAnchor$id(anchor)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$AppAnchor$typeLabel(anchor))
						]));
			}),
		model.D2);
	var addItem = A2(
		$author$project$Ui$Nav$customItem,
		_List_fromArray(
			[
				$author$project$Ui$Nav$onItemClick($author$project$Components$Partner$AppAnchors$AddAnchorClicked)
			]),
		A3(
			$author$project$Ui$Button$view,
			{abp: 'Add surface'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add surface')
				])));
	return A3(
		$author$project$Ui$Nav$view,
		_List_fromArray(
			[$author$project$Ui$Nav$slim]),
		_Utils_ap(
			anchorItems,
			_List_fromArray(
				[addItem])),
		model.m8);
};
var $author$project$Components$Partner$AppAnchors$ConfirmDeleteAnchor = {$: 5};
var $author$project$Components$Partner$AppAnchors$viewDeleteConfirmModal = A3(
	$author$project$Ui$Modal$view,
	$author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed,
	_List_Nil,
	_List_fromArray(
		[
			$author$project$Ui$Modal$header(
			_List_fromArray(
				[
					$author$project$Ui$Modal$title('Delete Surface')
				])),
			$author$project$Ui$Modal$body(
			_List_fromArray(
				[
					$elm$html$Html$text('Are you sure you want to delete this surface? This action cannot be undone.')
				])),
			$author$project$Ui$Modal$footer(
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Cancel delete'},
					_List_fromArray(
						[
							$author$project$Ui$Button$secondary,
							$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Cancel')
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Confirm delete'},
					_List_fromArray(
						[
							$author$project$Ui$Button$danger,
							$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$ConfirmDeleteAnchor)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Delete')
						]))
				]))
		]));
var $author$project$Components$Partner$AppAnchors$DeleteAnchorClicked = {$: 3};
var $author$project$Components$Partner$AppAnchors$EditAnchorClicked = {$: 2};
var $author$project$Components$Partner$AppAnchors$interactionTypeLabel = function (type_) {
	if (!type_) {
		return 'General';
	} else {
		return 'Lab';
	}
};
var $author$project$Components$Partner$AppAnchors$viewSelectedAnchorInfo = function (model) {
	var selectedAnchor = A2(
		$elm$core$Maybe$andThen,
		$elm$core$List$head,
		A2(
			$elm$core$Maybe$map,
			function (anchorId) {
				return A2(
					$elm$core$List$filter,
					function (anchor) {
						return _Utils_eq(
							$author$project$Api$Partner$AppAnchor$id(anchor),
							anchorId);
					},
					model.D2);
			},
			model.bc));
	if (!selectedAnchor.$) {
		var anchor = selectedAnchor.a;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2, $author$project$Ui$Element$mt2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Source URL')
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$static(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$AppAnchor$sourceUrl(anchor))
										]))
								])),
						function () {
							var _v1 = $author$project$Api$Partner$AppAnchor$type_(anchor);
							switch (_v1) {
								case 0:
									return _List_fromArray(
										[
											function () {
											var _v2 = $author$project$Api$Partner$AppAnchor$corePageIconUrl(anchor);
											if (!_v2.$) {
												var url = _v2.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Icon')
														]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Image$fromSrc,
															{I1: 'App icon'},
															url,
															_List_fromArray(
																[
																	$author$project$Ui$Image$height(50)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v3 = $author$project$Api$Partner$AppAnchor$corePageIconLabel(anchor);
											if (!_v3.$) {
												var corePageIconLabel = _v3.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Icon Label')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(corePageIconLabel)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Auto Adjust Height')
												]),
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$static(
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																true,
																$author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight(anchor)) ? 'Enabled' : 'Disabled')
														]))
												]))
										]);
								case 1:
									return _List_fromArray(
										[
											function () {
											var _v4 = $author$project$Api$Partner$AppAnchor$interactionTitle(anchor);
											if (!_v4.$) {
												var title = _v4.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Interaction Title')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(title)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v5 = $author$project$Api$Partner$AppAnchor$interactionDescription(anchor);
											if (!_v5.$) {
												var description = _v5.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Interaction Description')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(description)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											function () {
											var _v6 = $author$project$Api$Partner$AppAnchor$interactionType(anchor);
											if (!_v6.$) {
												var interactionType_ = _v6.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Interaction Type')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$elm$core$Maybe$withDefault,
																		interactionType_,
																		A2(
																			$elm$core$Maybe$map,
																			$author$project$Components$Partner$AppAnchors$interactionTypeLabel,
																			$author$project$Components$Partner$AppAnchors$interactionTypeFromString(interactionType_))))
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]);
								default:
									return _List_fromArray(
										[
											function () {
											var _v7 = $author$project$Api$Partner$AppAnchor$settingsLabel(anchor);
											if (!_v7.$) {
												var settingsLabel = _v7.a;
												return A2(
													$author$project$Ui$Form$Group$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$label('Settings Label')
														]),
													_List_fromArray(
														[
															$author$project$Ui$Form$Group$static(
															_List_fromArray(
																[
																	$elm$html$Html$text(settingsLabel)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]);
							}
						}())),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mt2]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Edit surface'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$EditAnchorClicked),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
									$author$project$Ui$Button$sm
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Edit')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Delete surface'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$DeleteAnchorClicked),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete),
									$author$project$Ui$Button$sm
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Partner$AppAnchors$view = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.Z;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var maybeId = _v1.a;
					var form = _v1.b;
					return A5($author$project$Components$Partner$AppAnchors$viewAnchorModal, model.FR, maybeId, form, model.hu, model.oU);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.lO ? $author$project$Components$Partner$AppAnchors$viewDeleteConfirmModal : $author$project$Utils$Html$empty,
				$author$project$Components$Partner$AppAnchors$viewAnchorsAsNavs(model),
				$author$project$Components$Partner$AppAnchors$viewSelectedAnchorInfo(model)
			]));
};
var $author$project$Pages$Partner$Product$AppSettings$viewApp = F2(
	function (model, app) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb4]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('App Settings')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Edit app'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$EditClicked),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Name'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Partner$App$name(app)),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text('The display name users will see when searching for or browsing the app.')
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Status'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Badge$fromString,
								_List_Nil,
								$author$project$Api$Partner$App$status(app))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Partner Roles'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								$elm$core$List$isEmpty(
								$author$project$Api$Partner$App$partnerRoles(app)) ? $elm$html$Html$text('No partner roles defined') : A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									function (role) {
										return A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(role)
												]));
									},
									$author$project$Api$Partner$App$partnerRoles(app)))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Handshake url'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												function (handshakeUrl) {
													return $elm$core$String$isEmpty(handshakeUrl) ? 'None' : handshakeUrl;
												}(
													$author$project$Api$Partner$App$handshakeUrl(app))),
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textMuted]),
												_List_fromArray(
													[
														$elm$html$Html$text('The endpoint where we send a signed request to establish trust. The request includes:'),
														A2(
														$elm$html$Html$ul,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('user: { id, email, name, first_name, last_name, partner_roles }')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('practice: { id }')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('patient: { id } | null')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('integration: { id } | null')
																	])),
																A2(
																$elm$html$Html$li,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('access_token: string')
																	]))
															])),
														$elm$html$Html$text('Your endpoint must return a session_key, which we will pass into the iframe for authentication.')
													]))
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Test handshake endpoint'},
										_List_fromArray(
											[
												$author$project$Ui$Button$secondary,
												$author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$TestHandshakeClicked),
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$disabled(
												$elm$core$String$isEmpty(
													$author$project$Api$Partner$App$handshakeUrl(app)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Test')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Surfaces'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$static(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg,
								$author$project$Components$Partner$AppAnchors$view(model.hv))
							]))
					]))
			]);
	});
var $author$project$Pages$Partner$Product$AppSettings$CreateClicked = {$: 1};
var $author$project$Pages$Partner$Product$AppSettings$viewBuildApp = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$flexCol]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$elm$html$Html$text('There\'s no APP yet')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Build your app'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$CreateClicked)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Start building')
					]))
			]))
	]);
var $author$project$Pages$Partner$Product$AppSettings$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Product$AppSettings$HandshakeUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Product$AppSettings$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Product$AppSettings$SaveClicked = {$: 6};
var $author$project$Pages$Partner$Product$AppSettings$viewEditModal = F3(
	function (tagsInput, form, updateRequest) {
		var isLoading = function () {
			if (updateRequest.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var fields = $author$project$Utils$Form$fields(form);
		var errorsFor = function (group) {
			return A2($author$project$Utils$Form$validationErrors, group, form);
		};
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Product$AppSettings$EditModalClosed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Product$AppSettings$SaveClicked)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Edit App')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.zh),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$AppSettings$FormUpdated, $author$project$Pages$Partner$Product$AppSettings$Name)),
											$author$project$Ui$Form$Input$disabled(isLoading),
											$author$project$Ui$Form$Input$errors(
											errorsFor(0))
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Handshake URL'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(fields.P$),
											$author$project$Ui$Form$Input$onInput(
											A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$AppSettings$FormUpdated, $author$project$Pages$Partner$Product$AppSettings$HandshakeUrl)),
											$author$project$Ui$Form$Input$placeholder('https://your-app.com/handshake'),
											$author$project$Ui$Form$Input$disabled(isLoading)
										]))
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Partner Roles'),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Partner$Product$AppSettings$TagsInputMsg,
									A2(
										$author$project$Ui$TagsInput$view,
										_List_fromArray(
											[
												$author$project$Ui$TagsInput$tags(fields.VG)
											]),
										tagsInput)),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Roles can be copy/pasted into this field as long as they are separated by commas.')
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel edit'},
							_List_fromArray(
								[
									$author$project$Ui$Button$secondary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$EditModalClosed),
									$author$project$Ui$Button$disabled(isLoading)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Save changes'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$disabled(isLoading),
									$author$project$Ui$Button$loading(isLoading),
									$author$project$Ui$Button$submit
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Product$AppSettings$viewTestHandshakeModal = function (testRequest) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Partner$Product$AppSettings$TestHandshakeModalClosed,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Test Handshake Endpoint')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						function () {
						switch (testRequest.$) {
							case 1:
								return $elm$html$Html$text('Testing handshake endpoint...');
							case 3:
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Handshake successful!'),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													$elm$html$Html$text('Your endpoint responded correctly to the test request.')
												]))
										]));
							case 2:
								return A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Handshake failed'),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
											_List_fromArray(
												[
													$elm$html$Html$text('Please check your endpoint URL and try again.')
												]))
										]));
							default:
								return $elm$html$Html$text('Ready to test handshake endpoint');
						}
					}()
					])),
				$author$project$Ui$Modal$footer(
				A2(
					$elm$core$List$cons,
					A3(
						$author$project$Ui$Button$view,
						{abp: 'Close test modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$secondary,
								$author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$TestHandshakeModalClosed)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Close')
							])),
					function () {
						if (testRequest.$ === 2) {
							return _List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Retry handshake test'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$TestHandshakeClicked)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Retry')
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()))
			]));
};
var $author$project$Pages$Partner$Product$AppSettings$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.a2;
			if (!_v0.$) {
				var form = _v0.a;
				return A3($author$project$Pages$Partner$Product$AppSettings$viewEditModal, model.tc, form, model.o$);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			model.tg ? $author$project$Pages$Partner$Product$AppSettings$viewTestHandshakeModal(model.oJ) : $elm$html$Html$text(''),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			$elm$core$List$singleton(
				A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					function () {
						var _v1 = model.cz;
						_v1$2:
						while (true) {
							switch (_v1.$) {
								case 3:
									var app = _v1.a;
									return A2($author$project$Pages$Partner$Product$AppSettings$viewApp, model, app);
								case 2:
									if (_v1.a.$ === 5) {
										var _v2 = _v1.a;
										return $author$project$Pages$Partner$Product$AppSettings$viewBuildApp;
									} else {
										break _v1$2;
									}
								default:
									break _v1$2;
							}
						}
						return _List_Nil;
					}())))
		]);
};
var $author$project$Pages$Partner$Product$AppSettings$view = function (model) {
	return {
		e5: $author$project$Pages$Partner$Product$AppSettings$viewBody(model),
		$G: 'Partner | Product | AppSettings'
	};
};
var $author$project$Pages$Partner$Product$AppSettings$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Product$AppSettings$init, aer: $author$project$Pages$Partner$Product$AppSettings$load, agD: $author$project$Pages$Partner$Product$AppSettings$save, ahd: $author$project$Pages$Partner$Product$AppSettings$subscriptions, aaq: $author$project$Pages$Partner$Product$AppSettings$update, ahP: $author$project$Pages$Partner$Product$AppSettings$view});
var $author$project$Pages$Partner$Product$Hinter$GotPartnerProduct = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Product$Hinter$init = F4(
	function (_v0, partner, shared, _v1) {
		var _v2 = $author$project$Api$Partner$Partner$One$product(partner);
		if (!_v2.$) {
			var product = _v2.a;
			var productId = $author$project$Api$Partner$PartnerProduct$Shared$id(product);
			return _Utils_Tuple2(
				{D5: shared.D5, Vz: partner, gd: $elm$core$Maybe$Nothing, W8: $author$project$Api$Data$Loading},
				A3($author$project$Api$Partner$PartnerProduct$retrieve, shared.D5, productId, $author$project$Pages$Partner$Product$Hinter$GotPartnerProduct));
		} else {
			return _Utils_Tuple2(
				{D5: shared.D5, Vz: partner, gd: $elm$core$Maybe$Nothing, W8: $author$project$Api$Data$NotAsked},
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Partner$Product$Hinter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Product$Hinter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Product$Hinter$subscriptions = function (model) {
	var _v0 = model.gd;
	if (!_v0.$) {
		var partnerProductForm = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg,
			$author$project$Components$Hinter$EditPartnerProductForm$subscriptions(partnerProductForm));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Hinter$EditPartnerProductForm$Model = $elm$core$Basics$identity;
var $author$project$Components$Hinter$EditPartnerProductForm$FeatureType = 0;
var $author$project$Components$Hinter$EditPartnerProductForm$TierType = 1;
var $author$project$Api$Partner$PartnerProduct$One$requirement = function (_v0) {
	var record = _v0.b;
	return record.Yk;
};
var $author$project$Components$Hinter$EditPartnerProductForm$initFormFields = function (product) {
	var _v0 = function () {
		var _v1 = $author$project$Api$Partner$PartnerProduct$One$requirement(product);
		if (!_v1.$) {
			if (!_v1.a.$) {
				var f = _v1.a.a;
				return _Utils_Tuple3(
					true,
					0,
					$elm$core$Maybe$Just(
						$author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(f)));
			} else {
				var tier = _v1.a.a;
				return _Utils_Tuple3(
					true,
					1,
					$elm$core$Maybe$Just(tier));
			}
		} else {
			return _Utils_Tuple3(false, 0, $elm$core$Maybe$Nothing);
		}
	}();
	var requirementEnabled = _v0.a;
	var requirementType = _v0.b;
	var requirementValue = _v0.c;
	return _Utils_Tuple2(
		{
			NS: $author$project$Api$Partner$PartnerProduct$One$distributionType(product),
			Pc: $author$project$Api$Partner$PartnerProduct$One$featured(product),
			jQ: requirementEnabled,
			n$: requirementType,
			gw: requirementValue,
			_c: $author$project$Api$Partner$PartnerProduct$One$slug(product),
			ag7: $author$project$Api$Partner$PartnerProduct$One$status(product)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Hinter$EditPartnerProductForm$init = function (product) {
	var _v0 = $author$project$Components$Hinter$EditPartnerProductForm$initFormFields(product);
	var formFields = _v0.a;
	var formFieldsCmd = _v0.b;
	return _Utils_Tuple2(
		{
			PB: $author$project$Utils$Form$init(formFields),
			GS: $author$project$Api$Partner$PartnerProduct$One$id(product),
			o$: $author$project$Api$Data$NotAsked
		},
		formFieldsCmd);
};
var $author$project$Components$Hinter$EditPartnerProductForm$GotUpdatedPartnerProduct = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{_c: string});
			case 1:
				var distributionType = field.a;
				return _Utils_update(
					fields,
					{NS: distributionType});
			case 2:
				var status = field.a;
				return _Utils_update(
					fields,
					{ag7: status});
			case 3:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Pc: bool});
			case 4:
				var bool = field.a;
				return _Utils_update(
					fields,
					{jQ: bool, gw: $elm$core$Maybe$Nothing});
			case 5:
				var requirementType = field.a;
				return _Utils_update(
					fields,
					{n$: requirementType, gw: $elm$core$Maybe$Nothing});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						gw: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Hinter$EditPartnerProductForm$RequirementValueValidation = 0;
var $author$project$Components$Hinter$EditPartnerProductForm$validateRequirementValue = function (fields) {
	return (fields.jQ && _Utils_eq(fields.gw, $elm$core$Maybe$Nothing)) ? _List_fromArray(
		[
			_Utils_Tuple2(0, 'A value is required')
		]) : _List_Nil;
};
var $author$project$Components$Hinter$EditPartnerProductForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Hinter$EditPartnerProductForm$validateRequirementValue)
		]));
var $author$project$Api$Partner$PartnerProduct$DistributionType = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Partner$PartnerProduct$FeatureRequirement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Featured = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$PartnerProduct$InstallationRequirement = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Slug = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Partner$PartnerProduct$Status = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$PartnerProduct$TierRequirement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$toPermittedFields = function (fields) {
	var installationRequirement = fields.jQ ? A2(
		$elm$core$Maybe$map,
		function (value) {
			var _v0 = fields.n$;
			if (!_v0) {
				return $author$project$Api$Partner$PartnerProduct$FeatureRequirement(
					$author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString(value));
			} else {
				return $author$project$Api$Partner$PartnerProduct$TierRequirement(value);
			}
		},
		fields.gw) : $elm$core$Maybe$Nothing;
	return _List_fromArray(
		[
			$author$project$Api$Partner$PartnerProduct$Slug(fields._c),
			$author$project$Api$Partner$PartnerProduct$DistributionType(fields.NS),
			$author$project$Api$Partner$PartnerProduct$Status(fields.ag7),
			$author$project$Api$Partner$PartnerProduct$Featured(fields.Pc),
			$author$project$Api$Partner$PartnerProduct$InstallationRequirement(installationRequirement)
		]);
};
var $author$project$Components$Hinter$EditPartnerProductForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Hinter$EditPartnerProductForm$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$EditPartnerProductForm$formFieldsValidator, model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validFormFields = _v3.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: $author$project$Api$Data$Loading}),
						A4(
							$author$project$Api$Partner$PartnerProduct$update,
							apiClient,
							model.GS,
							$author$project$Components$Hinter$EditPartnerProductForm$toPermittedFields(fields),
							$author$project$Components$Hinter$EditPartnerProductForm$GotUpdatedPartnerProduct),
						_List_Nil);
				} else {
					var updatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: updatedForm, o$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var updatedProduct = response.a;
					var _v5 = $author$project$Components$Hinter$EditPartnerProductForm$initFormFields(updatedProduct);
					var updatedFormFields = _v5.a;
					var formFieldsCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $author$project$Utils$Form$init(updatedFormFields),
								o$: $author$project$Api$Data$NotAsked
							}),
						formFieldsCmd,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Settings saved!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Product$Hinter$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = model.gd;
			if (!_v1.$) {
				var partnerProductForm = _v1.a;
				var _v2 = A3($author$project$Components$Hinter$EditPartnerProductForm$update, model.D5, subMsg, partnerProductForm);
				var newPartnerProductForm = _v2.a;
				var cmd = _v2.b;
				var outMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gd: $elm$core$Maybe$Just(newPartnerProductForm)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg, cmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var product = response.a;
				var _v4 = $author$project$Components$Hinter$EditPartnerProductForm$init(product);
				var partnerProductForm = _v4.a;
				var partnerProductFormCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gd: $elm$core$Maybe$Just(partnerProductForm),
							W8: response
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg, partnerProductFormCmd),
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{W8: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		}
	});
var $author$project$Components$Hinter$EditPartnerProductForm$DistributionType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$Featured = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$RequirementEnabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$RequirementType = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$RequirementValue = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$Save = {$: 1};
var $author$project$Components$Hinter$EditPartnerProductForm$Slug = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Hinter$EditPartnerProductForm$Status = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Common$Marketplace$Product$Status$all = _List_fromArray(
	[1, 2, 3, 4, 5, 6, 7, 8]);
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$all = _List_fromArray(
	[$author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr]);
var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$toLabel = function (feature) {
	if (!feature.$) {
		return 'EMR - Clinical';
	} else {
		var string = feature.a;
		return string;
	}
};
var $author$project$Components$Hinter$EditPartnerProductForm$requirementValueOptions = function (requirementType) {
	if (!requirementType) {
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a feature...'),
			A2(
				$elm$core$List$map,
				function (f) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(f)),
						$author$project$Api$Common$Marketplace$Product$Requirement$Feature$toLabel(f));
				},
				$author$project$Api$Common$Marketplace$Product$Requirement$Feature$all));
	} else {
		return _List_fromArray(
			[
				A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a tier...')
			]);
	}
};
var $author$project$Components$Hinter$EditPartnerProductForm$view = function (_v0) {
	var model = _v0;
	var loading = _Utils_eq(model.o$, $author$project$Api$Data$Loading);
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Slug')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields._c),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Slug))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Distribution Type')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$DistributionType$toString(fields.NS))),
								$author$project$Ui$Form$Select$onChange(
								function (str) {
									return A2(
										$elm$core$Maybe$withDefault,
										$author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
											$author$project$Components$Hinter$EditPartnerProductForm$DistributionType(fields.NS)),
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$DistributionType),
											$author$project$Api$Common$Marketplace$Product$DistributionType$fromString(str)));
								})
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$elm$core$Maybe$Just('public'),
								'Public'),
								A3(
								$author$project$Ui$Form$Select$option,
								_List_Nil,
								$elm$core$Maybe$Just('unlisted'),
								'Unlisted')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Featured')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.Pc),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Featured))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Status')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$Status$toString(fields.ag7))),
								$author$project$Ui$Form$Select$onChange(
								function (str) {
									return A2(
										$elm$core$Maybe$withDefault,
										$author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
											$author$project$Components$Hinter$EditPartnerProductForm$Status(fields.ag7)),
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Status),
											$author$project$Api$Common$Marketplace$Product$Status$fromString(str)));
								})
							]),
						A2(
							$elm$core$List$map,
							function (status) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$Status$toString(status)),
									$author$project$Api$Common$Marketplace$Product$Status$toLabel(status));
							},
							$author$project$Api$Common$Marketplace$Product$Status$all))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpan(8),
						$author$project$Ui$Form$Group$label('Has a requirement?')
					]),
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(fields.jQ),
								$author$project$Ui$ToggleSwitch$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$RequirementEnabled))
							]))
					])),
				fields.jQ ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											function () {
												var _v1 = fields.n$;
												if (!_v1) {
													return 'feature';
												} else {
													return 'tier';
												}
											}())),
										$author$project$Ui$Form$Select$onChange(
										function (str) {
											if (str === 'feature') {
												return $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
													$author$project$Components$Hinter$EditPartnerProductForm$RequirementType(0));
											} else {
												return $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated(
													$author$project$Components$Hinter$EditPartnerProductForm$RequirementType(1));
											}
										})
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just('feature'),
										'Feature'),
										A3(
										$author$project$Ui$Form$Select$option,
										_List_Nil,
										$elm$core$Maybe$Just('tier'),
										'Tier')
									])),
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$value(fields.gw),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$RequirementValue)),
										$author$project$Ui$Form$Select$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
										$author$project$Ui$Form$Select$errors(
										A2($author$project$Utils$Form$validationErrors, 0, model.PB))
									]),
								$author$project$Components$Hinter$EditPartnerProductForm$requirementValueOptions(fields.n$))
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt4]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Save product changes'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$submit,
								$author$project$Ui$Button$loading(loading),
								$author$project$Ui$Button$onClick($author$project$Components$Hinter$EditPartnerProductForm$Save)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Save')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Product$Hinter$view = function (model) {
	return {
		e5: function () {
			var _v0 = model.gd;
			if (!_v0.$) {
				var partnerProductForm = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Admin Settings')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg,
										$author$project$Components$Hinter$EditPartnerProductForm$view(partnerProductForm))
									]))
							]))
					]);
			} else {
				return _List_Nil;
			}
		}(),
		$G: 'Partner | Product | Admin Settings'
	};
};
var $author$project$Pages$Partner$Product$Hinter$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Product$Hinter$init, aer: $author$project$Pages$Partner$Product$Hinter$load, agD: $author$project$Pages$Partner$Product$Hinter$save, ahd: $author$project$Pages$Partner$Product$Hinter$subscriptions, aaq: $author$project$Pages$Partner$Product$Hinter$update, ahP: $author$project$Pages$Partner$Product$Hinter$view});
var $author$project$Pages$Partner$Product$New$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$NewProduct$Model = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$Shared$productType = function (_v0) {
	var record = _v0;
	return record.GT;
};
var $author$project$Api$Partner$Partner$One$productType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$productType(shared);
};
var $author$project$Api$Partner$Partner$Shared$slug = function (_v0) {
	var record = _v0;
	return record._c;
};
var $author$project$Api$Partner$Partner$One$slug = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$slug(shared);
};
var $author$project$Components$Partner$NewProduct$initFormFields = function (partner) {
	return _Utils_Tuple2(
		{
			Nx: $elm$core$Maybe$Nothing,
			QG: $elm$core$Maybe$Nothing,
			zh: $author$project$Api$Partner$Partner$One$name(partner),
			GT: $author$project$Api$Partner$Partner$One$productType(partner),
			_c: $author$project$Api$Partner$Partner$One$slug(partner)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Partner$NewProduct$init = F2(
	function (partner, imageStore) {
		var _v0 = $author$project$Components$Partner$NewProduct$initFormFields(partner);
		var formFields = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				PB: $author$project$Utils$Form$init(formFields),
				qT: imageStore
			},
			formFieldsCmd);
	});
var $author$project$Pages$Partner$Product$New$init = F4(
	function (_v0, partner, shared, _v1) {
		var _v2 = A2($author$project$Components$Partner$NewProduct$init, partner, shared.qT);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form, jY: $author$project$Api$Data$NotAsked},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$New$FormMsg, formCmd));
	});
var $author$project$Pages$Partner$Product$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Product$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$NewProduct$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Product$New$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Partner$Product$New$FormMsg,
		$author$project$Components$Partner$NewProduct$subscriptions(model.PB));
};
var $author$project$Pages$Partner$Product$New$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Partner$PartnerProduct$partnerProductPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partner_products']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$PartnerProduct$create = F3(
	function (apiClient, permittedFields, toMsg) {
		var body = $author$project$Api$Partner$PartnerProduct$encodePermittedFields(permittedFields);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerProduct$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProduct$partnerProductPath)));
	});
var $author$project$Pages$Partner$Product$New$createProduct = F2(
	function (apiClient, permittedFields) {
		return A3($author$project$Api$Partner$PartnerProduct$create, apiClient, permittedFields, $author$project$Pages$Partner$Product$New$Created);
	});
var $author$project$Components$Partner$NewProduct$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$NewProduct$Icon = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Partner$NewProduct$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{_c: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						GT: A2(
							$elm$core$Maybe$withDefault,
							$author$project$Api$Common$Marketplace$Product$ProductType$default,
							$author$project$Api$Common$Marketplace$Product$ProductType$fromString(string))
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{zh: string});
			case 3:
				var _int = field.a;
				var string = field.b;
				return _Utils_update(
					fields,
					{
						QG: $elm$core$Maybe$Just(
							_Utils_Tuple2(_int, string))
					});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Nx: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Partner$NewProduct$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var field = msg.a;
			var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$NewProduct$formFieldsUpdate, field, model.PB);
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{PB: newForm}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			var icons = msg.a;
			var cmd = A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var task = _v2.a;
						var size = _v2.b;
						return A2(
							$elm$core$Task$perform,
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Partner$NewProduct$FormUpdated,
								$author$project$Components$Partner$NewProduct$Icon(size)),
							task);
					},
					A2(
						$elm$core$Maybe$map,
						function (icon) {
							return _Utils_Tuple2(
								$elm$file$File$toUrl(icon),
								$elm$file$File$size(icon));
						},
						$elm$core$List$head(icons))));
			return _Utils_Tuple3(model, cmd, _List_Nil);
		}
	});
var $author$project$Components$Partner$NewProduct$IconValidation = 2;
var $author$project$Components$Partner$NewProduct$NameValidation = 1;
var $author$project$Components$Partner$NewProduct$SlugValidation = 0;
var $author$project$Components$Partner$NewProduct$maxIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
var $author$project$Components$Partner$NewProduct$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $._c;
			},
			_Utils_Tuple2(0, 'Please enter a slug.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(1, 'Please enter a name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.QG;
			},
			_Utils_Tuple2(2, 'Please select an icon to upload.')),
			$rtfeldman$elm_validate$Validate$fromErrors(
			function (fields) {
				var _v0 = fields.QG;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var iconSize = _v1.a;
					return (_Utils_cmp(iconSize, $author$project$Components$Partner$NewProduct$maxIconBytesSize) > 0) ? _List_fromArray(
						[
							_Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')
						]) : _List_Nil;
				} else {
					return _List_Nil;
				}
			})
		]));
var $author$project$Components$Partner$NewProduct$validate = function (_v0) {
	var model = _v0;
	var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$NewProduct$formFieldsValidator, model.PB);
	if (!_v1.$) {
		var _v2 = _v1.a;
		var validFormFields = _v2.b;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		var iconUrl = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$Tuple$second, fields.QG));
		return $elm$core$Result$Ok(
			_List_fromArray(
				[
					$author$project$Api$Partner$PartnerProduct$Slug(fields._c),
					$author$project$Api$Partner$PartnerProduct$ProductType(fields.GT),
					$author$project$Api$Partner$PartnerProduct$Name(fields.zh),
					$author$project$Api$Partner$PartnerProduct$Icon(iconUrl),
					$author$project$Api$Partner$PartnerProduct$Summary(fields.Nx)
				]));
	} else {
		var validatedForm = _v1.a;
		return $elm$core$Result$Err(
			_Utils_update(
				model,
				{PB: validatedForm}));
	}
};
var $author$project$Pages$Partner$Product$New$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Partner$NewProduct$update, subMsg, model.PB);
				var form = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: form}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$New$FormMsg, cmd),
					outMsgs);
			case 1:
				var _v2 = $author$project$Components$Partner$NewProduct$validate(model.PB);
				if (!_v2.$) {
					var permittedFields = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$Partner$Product$New$createProduct, model.D5, permittedFields),
						_List_Nil);
				} else {
					var updatedForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: updatedForm, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Partner__Product),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Product created'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Partner$Product$New$Save = {$: 1};
var $author$project$Components$Partner$NewProduct$Description = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$NewProduct$IconUploaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$NewProduct$Name = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$NewProduct$ProductType = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$NewProduct$Slug = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$NewProduct$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Icon'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol]),
						_List_fromArray(
							[
								$author$project$Components$Partner$ProductIconInstructions$view,
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
								_List_fromArray(
									[
										function () {
										var _v1 = fields.QG;
										if (!_v1.$) {
											var _v2 = _v1.a;
											var url = _v2.b;
											return A3(
												$author$project$Ui$Image$fromSrc,
												{I1: 'Product icon'},
												url,
												_List_fromArray(
													[
														$author$project$Ui$Image$height(64),
														$author$project$Ui$Image$width(64)
													]));
										} else {
											return $elm$html$Html$text('');
										}
									}(),
										$author$project$Ui$Form$File$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$File$accept(0),
												$author$project$Ui$Form$File$onInput($author$project$Components$Partner$NewProduct$IconUploaded),
												$author$project$Ui$Form$File$empty(
												!_Utils_eq(fields.QG, $elm$core$Maybe$Nothing))
											])),
										$author$project$Utils$FormErrors$view(
										A2($author$project$Utils$Form$validationErrors, 2, model.PB))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Name'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields.zh),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Name)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 1, model.PB))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Slug'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(fields._c),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Slug)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, model.PB))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Product Type'),
						$author$project$Ui$Form$Group$required(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(
								$elm$core$Maybe$Just(
									$author$project$Api$Common$Marketplace$Product$ProductType$toString(fields.GT))),
								$author$project$Ui$Form$Select$onChange(
								A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$ProductType))
							]),
						A2(
							$elm$core$List$map,
							function (type_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Common$Marketplace$Product$ProductType$toString(type_)),
									$author$project$Api$Common$Marketplace$Product$ProductType$toLabel(type_));
							},
							$author$project$Api$Common$Marketplace$Product$ProductType$all)),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
						_List_fromArray(
							[
								$elm$html$Html$text('Integration partners sync data between systems, application partners embed partner-powered workflows directly inside Hint, and solutions partners offer strategic or commercial benefits without any technical integration. Learn more '),
								A3(
								$author$project$Ui$Link$externalHref,
								'https://developers.hint.com/docs/marketplace',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('here')
									])),
								$elm$html$Html$text('.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8),
						$author$project$Ui$Form$Group$label('Summary')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$value(
								A2($elm$core$Maybe$withDefault, '', fields.Nx)),
								$author$project$Ui$Form$Textarea$onInput(
								A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Description))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt2, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm]),
						_List_fromArray(
							[
								$elm$html$Html$text('One sentence that describes your product without repeating the product name shown above.')
							]))
					]))
			]));
};
var $author$project$Pages$Partner$Product$New$view = function (model) {
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Product$New$Save)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('New Product')
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Partner$Product$New$FormMsg,
										$author$project$Components$Partner$NewProduct$view(model.PB))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Partner__Dashboard__Top,
										_List_fromArray(
											[$author$project$Ui$Link$buttonSecondary]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Create new product'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Create')
											]))
									]))
							]))
					]))
			]),
		$G: 'New Product'
	};
};
var $author$project$Pages$Partner$Product$New$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Product$New$init, aer: $author$project$Pages$Partner$Product$New$load, agD: $author$project$Pages$Partner$Product$New$save, ahd: $author$project$Pages$Partner$Product$New$subscriptions, aaq: $author$project$Pages$Partner$Product$New$update, ahP: $author$project$Pages$Partner$Product$New$view});
var $author$project$Pages$Partner$Sandboxes$Top$GotSandboxPartners = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartnersParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{afy: model.eA, ag1: model.jV});
	};
};
var $author$project$Api$Partner$Partner$All$Partner = $elm$core$Basics$identity;
var $author$project$Api$Partner$Partner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Partner$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Sandbox$Partner$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Sandbox$Partner$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Sandbox$Partner$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Partner$Sandbox$Partner$sandboxesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['sandboxes', 'partners']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Sandbox$Partner$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Partner$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Sandbox$Partner$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Partner$sandboxesPath)));
	});
var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners = function (model) {
	return A3(
		$author$project$Api$Partner$Sandbox$Partner$list,
		model.D5,
		$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartnersParams(model),
		$author$project$Pages$Partner$Sandboxes$Top$GotSandboxPartners);
};
var $author$project$Pages$Partner$Sandboxes$Top$GotSandboxPractices = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPracticesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{afy: model.eB, ag1: model.jW});
	};
};
var $author$project$Api$Partner$Practice$All$Practice = $elm$core$Basics$identity;
var $author$project$Api$Partner$Practice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$Practice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$Sandbox$Practice$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Sandbox$Practice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Sandbox$Practice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Partner$Sandbox$Practice$sandboxesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['sandboxes', 'practices']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Sandbox$Practice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$Practice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Sandbox$Practice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Practice$sandboxesPath)));
	});
var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices = function (model) {
	return A3(
		$author$project$Api$Partner$Sandbox$Practice$list,
		model.D5,
		$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPracticesParams(model),
		$author$project$Pages$Partner$Sandboxes$Top$GotSandboxPractices);
};
var $author$project$Pages$Partner$Sandboxes$Top$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.Bi;
		var model = {
			bK: $elm$core$Maybe$Nothing,
			bL: $elm$core$Maybe$Nothing,
			D5: shared.D5,
			Md: $author$project$Api$Data$NotAsked,
			dB: $elm$core$Set$empty,
			FR: $author$project$Shared$isHintAdmin(shared),
			Vz: partner,
			sx: $author$project$Api$Data$Loading,
			eA: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, 'sandbox_partners', $author$project$Api$Pagination$init)),
			jV: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				1,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, 'sandbox_partners', $author$project$Api$Sort$init))),
			sy: $author$project$Api$Data$Loading,
			eB: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, 'sandbox_practices', $author$project$Api$Pagination$init)),
			jW: A3(
				$author$project$Api$Sort$withDefault,
				'name',
				1,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, 'sandbox_practices', $author$project$Api$Sort$init)))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(model),
						$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model)
					])));
	});
var $author$project$Pages$Partner$Sandboxes$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Sandboxes$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Sandboxes$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Partner$Sandboxes$Top$ClinicalAccountCreated = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$OutMsg$GoToDefaultStateAndReloadAction = {$: 4};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnerCreated = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticeCreated = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Api$Partner$Sandbox$Partner$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'partner',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.zh))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Partner$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Partner$sandboxesPath)));
	});
var $author$project$Api$Partner$Practice$One$Practice = 0;
var $author$project$Api$Partner$Practice$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$Sandbox$Practice$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'name',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.zh))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$Practice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Practice$sandboxesPath)));
	});
var $author$project$Api$Partner$Sandbox$Practice$sandboxePath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Partner$Sandbox$Practice$sandboxesPath);
};
var $author$project$Api$Partner$Sandbox$Practice$createClinicalAccount = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['create_clinical_account']),
					$author$project$Api$Partner$Sandbox$Practice$sandboxePath(id))));
	});
var $author$project$Api$Partner$Partner$One$sandboxOf = function (_v0) {
	var record = _v0.b;
	return record.Y1;
};
var $author$project$Pages$Partner$Sandboxes$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Sandboxes__Top)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.eB),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.jW),
					A2(
						$elm$core$List$append,
						$author$project$Api$Pagination$toPageQuery(model.eA),
						$author$project$Api$Sort$toQuery(model.jV))))));
};
var $author$project$Pages$Partner$Sandboxes$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								sx: response,
								eA: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.eA)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sx: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								sy: response,
								eB: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.eB)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{sy: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 2:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.eA);
				var newModel = _Utils_update(
					model,
					{sx: $author$project$Api$Data$Loading, eA: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(newModel),
								$author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.eB);
				var newModel = _Utils_update(
					model,
					{sy: $author$project$Api$Data$Loading, eB: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(newModel),
								$author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						sx: $author$project$Api$Data$Loading,
						jV: A2($author$project$Api$Sort$update, columnId, model.jV)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(newModel),
								$author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						sy: $author$project$Api$Data$Loading,
						jW: A2($author$project$Api$Sort$update, columnId, model.jW)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(newModel),
								$author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var name = $author$project$Api$Partner$Partner$One$name(model.Vz) + ' Sandbox';
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bK: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just(name),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bK: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var _v3 = model.bK;
				if (!_v3.$) {
					var _v4 = _v3.a;
					var name = _v4.a;
					if (!name.$) {
						var name_ = name.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bK: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$elm$core$Maybe$Just(name_),
											$author$project$Api$Data$Loading))
								}),
							A3(
								$author$project$Api$Partner$Sandbox$Partner$create,
								model.D5,
								{
									zh: $elm$core$Maybe$Just(name_)
								},
								$author$project$Pages$Partner$Sandboxes$Top$SandboxPartnerCreated(name_)),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var name = msg.a;
				var _v6 = model.bK;
				if (!_v6.$) {
					var _v7 = _v6.a;
					var request = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bK: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(name),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var name = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bK: $elm$core$Maybe$Nothing, sx: $author$project$Api$Data$Loading}),
						$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sandbox added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bK: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var name = $author$project$Api$Partner$Partner$One$name(model.Vz) + ' Sandbox Practice';
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bL: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$elm$core$Maybe$Just(name),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bL: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var _v9 = model.bL;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var name = _v10.a;
					if (!name.$) {
						var name_ = name.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bL: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											$elm$core$Maybe$Just(name_),
											$author$project$Api$Data$Loading))
								}),
							A3(
								$author$project$Api$Partner$Sandbox$Practice$create,
								model.D5,
								{
									zh: $elm$core$Maybe$Just(name_)
								},
								$author$project$Pages$Partner$Sandboxes$Top$SandboxPracticeCreated(name_)),
							_List_Nil);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 14:
				var name = msg.a;
				var _v12 = model.bL;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var request = _v13.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bL: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$author$project$Utils$String$toMaybe(name),
										request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 15:
				var name = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bL: $elm$core$Maybe$Nothing, sy: $author$project$Api$Data$Loading}),
						$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Sandbox practice added')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bL: $elm$core$Maybe$Just(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(name),
										response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 16:
				var organizationId = msg.a;
				var postOrganizationSwitchedAction = _Utils_eq(
					$author$project$Api$Partner$Partner$One$sandboxOf(model.Vz),
					$elm$core$Maybe$Nothing) ? $author$project$OutMsg$GoToDefaultStateAndReloadAction : $author$project$OutMsg$GoToDefaultStateAction;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, postOrganizationSwitchedAction)
						]));
			case 17:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dB: A2($elm$core$Set$insert, id, model.dB)
						}),
					A3(
						$author$project$Api$Partner$Sandbox$Practice$createClinicalAccount,
						model.D5,
						id,
						$author$project$Pages$Partner$Sandboxes$Top$ClinicalAccountCreated(id)),
					_List_Nil);
			default:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dB: A2($elm$core$Set$remove, id, model.dB),
									sy: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Clinical account successfully created')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dB: A2($elm$core$Set$remove, id, model.dB)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed = {$: 7};
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerNameUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPartner = {$: 8};
var $author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPartnerModal = F2(
	function (name, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Sandbox')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', name)),
											$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerNameUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(name, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Name is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add Sandbox'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPartner),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Sandbox')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed = {$: 12};
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeNameUpdated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPractice = {$: 13};
var $author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPracticeModal = F2(
	function (name, request) {
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Sandbox')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$label('Name'),
									$author$project$Ui$Form$Group$required(true),
									$author$project$Ui$Form$Group$labelSpanSm(4),
									$author$project$Ui$Form$Group$inputSpanSm(8)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(
											A2($elm$core$Maybe$withDefault, '', name)),
											$author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeNameUpdated),
											$author$project$Ui$Form$Input$invalid(
											_Utils_eq(name, $elm$core$Maybe$Nothing)),
											$author$project$Ui$Form$Input$errors(
											_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray(
												['Name is required']) : _List_Nil)
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add Sandbox'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPractice),
									$author$project$Ui$Button$loading(
									_Utils_eq(request, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Sandbox')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartner = {$: 6};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersPaginationMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersSortTable = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$sandboxPartnersColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name')
	]);
var $author$project$Ui$Table$Success = 1;
var $author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Partner$Partner$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Partner$Shared$id(shared);
};
var $author$project$Api$Partner$Partner$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Partner$Shared$name(shared);
};
var $author$project$Api$Partner$Partner$All$organizationId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Partner$Shared$organizationId(shared);
};
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartner = F2(
	function (model, sandboxPartner) {
		var sandboxName = $author$project$Api$Partner$Partner$All$name(sandboxPartner);
		var isCurrentSandbox = _Utils_eq(
			$author$project$Api$Partner$Partner$All$id(sandboxPartner),
			$author$project$Api$Partner$Partner$One$id(model.Vz));
		var rowOptions = isCurrentSandbox ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(1)
			]) : _List_Nil;
		return A2(
			$author$project$Ui$Table$row,
			rowOptions,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sandboxName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							isCurrentSandbox ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Button$view,
							{abp: 'Switch' + sandboxName},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox(
										$author$project$Api$Partner$Partner$All$organizationId(sandboxPartner)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Switch')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartnersTable = function (model) {
	var _v0 = function () {
		var _v1 = model.sx;
		if (_v1.$ === 3) {
			var sandboxPartners_ = _v1.a;
			return _Utils_Tuple2(false, sandboxPartners_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var sandboxPartners = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any sandbox partners')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.jV, $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersSortTable)),
					$author$project$Pages$Partner$Sandboxes$Top$sandboxPartnersColumns),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartner(model),
			sandboxPartners),
		_List_Nil);
};
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartners = function (model) {
	var loading = function () {
		var _v2 = model.sx;
		if (_v2.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$titleWithButton,
						_List_fromArray(
							[
								$elm$html$Html$text('Sandbox Partners')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$pull(1)
									]),
								_List_fromArray(
									[
										function () {
										var _v0 = _Utils_Tuple2(
											$author$project$Api$Partner$Partner$One$sandboxOf(model.Vz),
											$author$project$Api$Partner$Partner$One$sandboxEnabled(model.Vz));
										if ((_v0.a.$ === 1) && _v0.b) {
											var _v1 = _v0.a;
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'Add sandbox partner'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartner)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add Sandbox Partner')
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					])),
				$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartnersTable(model),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersPaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(loading)
								]),
							model.eA))
					]))
			]));
};
var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPractice = {$: 11};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesPaginationMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesSortTable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Sandboxes$Top$sandboxPracticesColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'name', true, 'Name')
	]);
var $author$project$Pages$Partner$Sandboxes$Top$CreateClinicalAccount = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Partner$Practice$All$hasClinicalAccount = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Practice$Shared$hasClinicalAccount(shared);
};
var $author$project$Api$Partner$Practice$Shared$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Partner$Practice$Min$id(min);
};
var $author$project$Api$Partner$Practice$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Practice$Shared$id(shared);
};
var $author$project$Api$Partner$Practice$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Practice$Shared$name(shared);
};
var $author$project$Api$Partner$Practice$Shared$organizationId = function (_v0) {
	var record = _v0.b;
	return record.aft;
};
var $author$project$Api$Partner$Practice$All$organizationId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Partner$Practice$Shared$organizationId(shared);
};
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractice = F2(
	function (model, sandboxPractice) {
		var sandboxName = $author$project$Api$Partner$Practice$All$name(sandboxPractice);
		var sandboxId = $author$project$Api$Partner$Practice$All$id(sandboxPractice);
		var loading = A2($elm$core$Set$member, sandboxId, model.dB);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(sandboxName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							($author$project$Api$Partner$Practice$All$hasClinicalAccount(sandboxPractice) || (!$author$project$Api$Partner$Partner$One$sandboxEnabled(model.Vz))) ? $author$project$Utils$Html$empty : A3(
							$author$project$Ui$Button$view,
							{abp: 'Create Clinical Account'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Sandboxes$Top$CreateClinicalAccount(sandboxId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Create Clinical Account')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Switch ' + sandboxName},
							_List_fromArray(
								[
									$author$project$Ui$Button$default,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox(
										$author$project$Api$Partner$Practice$All$organizationId(sandboxPractice)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Switch')
								]))
						]))
				]));
	});
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPracticesTable = function (model) {
	var _v0 = function () {
		var _v1 = model.sy;
		if (_v1.$ === 3) {
			var sandboxPractices_ = _v1.a;
			return _Utils_Tuple2(false, sandboxPractices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var sandboxPractices = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any sandbox practices')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.jW, $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesSortTable)),
					$author$project$Pages$Partner$Sandboxes$Top$sandboxPracticesColumns),
					_List_fromArray(
					[
						A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractice(model),
			sandboxPractices),
		_List_Nil);
};
var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractices = function (model) {
	var loading = function () {
		var _v2 = model.sy;
		if (_v2.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$titleWithButton,
						_List_fromArray(
							[
								$elm$html$Html$text('Sandbox Practices')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$pull(1)
									]),
								_List_fromArray(
									[
										function () {
										var _v0 = _Utils_Tuple2(
											$author$project$Api$Partner$Partner$One$sandboxOf(model.Vz),
											$author$project$Api$Partner$Partner$One$sandboxEnabled(model.Vz));
										if ((_v0.a.$ === 1) && _v0.b) {
											var _v1 = _v0.a;
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'Add sandbox practice'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPractice)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add Sandbox Practice')
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					])),
				$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPracticesTable(model),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesPaginationMsg,
						A2(
							$author$project$Api$Pagination$view,
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(loading)
								]),
							model.eB))
					]))
			]));
};
var $author$project$Pages$Partner$Sandboxes$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.bK;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var name = _v1.a;
					var request = _v1.b;
					return A2($author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPartnerModal, name, request);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.bL;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var name = _v3.a;
					var request = _v3.b;
					return A2($author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPracticeModal, name, request);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartners(model)
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractices(model)
							]))
					]))
			]),
		$G: 'Partner | Sandboxes'
	};
};
var $author$project$Pages$Partner$Sandboxes$Top$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Sandboxes$Top$init, aer: $author$project$Pages$Partner$Sandboxes$Top$load, agD: $author$project$Pages$Partner$Sandboxes$Top$save, ahd: $author$project$Pages$Partner$Sandboxes$Top$subscriptions, aaq: $author$project$Pages$Partner$Sandboxes$Top$update, ahP: $author$project$Pages$Partner$Sandboxes$Top$view});
var $author$project$Pages$Partner$Team$GotRoles = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Team$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('q'),
			model.af_)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Team)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Pages$Partner$Team$GotTeamMembers = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$PartnerUser$All$PartnerUser = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$PartnerUser$Shared$PartnerUser = $elm$core$Basics$identity;
var $author$project$Api$Partner$PartnerUser$Shared$Record = F8(
	function (id, email, role, notificationsEnabled, invitationPending, isOwner, isDestroyable, user) {
		return {Oo: email, adR: id, Rf: invitationPending, RJ: isDestroyable, RX: isOwner, UO: notificationsEnabled, agy: role, aaz: user};
	});
var $author$project$Api$Partner$User$One$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$User$One$Record = function (mfaStatus) {
	return {TW: mfaStatus};
};
var $author$project$Api$Partner$User$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mfa_status',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$User$One$Record));
var $author$project$Api$Partner$User$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$User$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$User$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$User$One$User)));
var $author$project$Api$Partner$PartnerUser$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$User$One$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_destroyable',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_owner',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'invitation_pending',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'notifications_enabled',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'role',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'email',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$Shared$Record)))))))));
var $author$project$Api$Partner$PartnerUser$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerUser$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$PartnerUser$All$Record = function (invitationUrl) {
	return {Rg: invitationUrl};
};
var $author$project$Api$Partner$PartnerUser$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invitation_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$All$Record));
var $author$project$Api$Partner$PartnerUser$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$PartnerUser$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$PartnerUser$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$All$PartnerUser)));
var $author$project$Api$Partner$TeamMember$listOptionalsDefaults = {afy: $author$project$Api$Pagination$init, af_: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Partner$TeamMember$listOptionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$TeamMember$listOptionalsDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Partner$TeamMember$teamMembersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['team_members']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$TeamMember$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$PartnerUser$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$TeamMember$listOptionalsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$TeamMember$teamMembersPath)));
	});
var $author$project$Pages$Partner$Team$fetchTeamMembers = function (model) {
	return A3(
		$author$project$Api$Partner$TeamMember$list,
		model.D5,
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, af_: model.af_, ag1: model.ag1});
		},
		$author$project$Pages$Partner$Team$GotTeamMembers);
};
var $author$project$Api$Partner$Role$rolesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['roles']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$Role$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$Role$rolesPath));
	});
var $author$project$Pages$Partner$Team$init = F4(
	function (session, partner, shared, _v0) {
		var query = _v0.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			D5: shared.D5,
			EQ: $author$project$Api$Platform$Session$One$user(session),
			lQ: $elm$core$Maybe$Nothing,
			dU: $elm$core$Set$empty,
			$9: $elm$core$Maybe$Nothing,
			FR: $author$project$Shared$isHintAdmin(shared),
			ea: $elm$core$Set$empty,
			afw: shared.adu.afw,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			Vz: partner,
			af_: q,
			BX: $author$project$Api$Data$Loading,
			sA: $author$project$Ui$SearchInput$init(q),
			ZD: session,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'user_first_name',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			A: $elm$core$Maybe$Nothing,
			eK: $author$project$Api$Data$Loading,
			tl: A2(
				$author$project$Components$Admin$ToogleOrganizationMfa$init,
				session,
				$author$project$Components$Admin$ToogleOrganizationMfa$Partner(partner))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Partner$Team$fetchTeamMembers(model),
						A2($author$project$Api$Partner$Role$list, shared.D5, $author$project$Pages$Partner$Team$GotRoles),
						A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Partner$Team$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$Team$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Partner$Team$CancelTeamMemberEdit = {$: 3};
var $author$project$Pages$Partner$Team$DeleteConfirmClosed = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$Partner$Team$DisableMfaConfirmClosed = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Api$Partner$PartnerUser$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Partner$PartnerUser$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$id(shared);
};
var $author$project$Pages$Partner$Team$subscriptions = function (_v0) {
	var teamMember = _v0.A;
	var deletingTeamMember = _v0.lQ;
	var disablingMfaTeamMember = _v0.$9;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Team$CancelTeamMemberEdit)),
					teamMember)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Partner$Team$DeleteConfirmClosed),
						$author$project$Api$Partner$PartnerUser$All$id),
					deletingTeamMember)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Partner$Team$DisableMfaConfirmClosed),
					disablingMfaTeamMember))
			]));
};
var $author$project$Pages$Partner$Team$GotInvitation = F3(
	function (a, b, c) {
		return {$: 21, a: a, b: b, c: c};
	});
var $author$project$Pages$Partner$Team$InviteLinkMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$Partner$Team$MfaStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$Team$SearchInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Partner$Team$TeamMemberDeleted = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Pages$Partner$Team$TeamMemberMfaDisabled = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Partner$Team$ToogleOrganizationMfa = function (a) {
	return {$: 22, a: a};
};
var $author$project$Api$Partner$TeamMember$teamMemberPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Partner$TeamMember$teamMembersPath);
};
var $author$project$Api$Partner$TeamMember$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$TeamMember$teamMemberPath(id_)));
	});
var $author$project$Api$Partner$TeamMember$disableMfa = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['mfa']),
					$author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Api$Partner$PartnerUser$Shared$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Partner$PartnerUser$All$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$email(shared);
};
var $author$project$Api$Partner$User$One$mfaStatus = function (_v0) {
	var record = _v0.b;
	return record.TW;
};
var $author$project$Api$Partner$PartnerUser$Shared$user = function (_v0) {
	var record = _v0;
	return record.aaz;
};
var $author$project$Api$Partner$PartnerUser$All$user = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$user(shared);
};
var $author$project$Pages$Partner$Team$mfaStatus = function (teamMember) {
	var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Partner$PartnerUser$All$user, teamMember);
	if (!_v0.$) {
		var user = _v0.a;
		return $author$project$Api$Partner$User$One$mfaStatus(user);
	} else {
		return 'invite pending';
	}
};
var $author$project$Api$Partner$PartnerUser$Shared$notificationsEnabled = function (_v0) {
	var record = _v0;
	return record.UO;
};
var $author$project$Api$Partner$PartnerUser$All$notificationsEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$notificationsEnabled(shared);
};
var $author$project$Api$Partner$PartnerUser$Shared$role = function (_v0) {
	var record = _v0;
	return record.agy;
};
var $author$project$Api$Partner$PartnerUser$All$role = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$role(shared);
};
var $author$project$Pages$Partner$Team$formFieldsFromTeamMember = function (teamMember) {
	return {
		abx: '',
		Oo: $author$project$Api$Partner$PartnerUser$All$email(teamMember),
		ad9: false,
		TW: $author$project$Pages$Partner$Team$mfaStatus(
			$elm$core$Maybe$Just(teamMember)),
		UO: $author$project$Api$Partner$PartnerUser$All$notificationsEnabled(teamMember),
		agy: $author$project$Api$Partner$PartnerUser$All$role(teamMember)
	};
};
var $author$project$Pages$Partner$Team$formFieldsInit = function (origin) {
	return {
		abx: origin + '/join/',
		Oo: '',
		ad9: true,
		TW: $author$project$Pages$Partner$Team$mfaStatus($elm$core$Maybe$Nothing),
		UO: true,
		agy: ''
	};
};
var $author$project$Pages$Partner$Team$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{Oo: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{agy: string});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{UO: bool});
			case 3:
				var string = field.a;
				return _Utils_update(
					fields,
					{TW: string});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{ad9: bool});
		}
	});
var $author$project$Pages$Partner$Team$EmailValidation = 0;
var $author$project$Pages$Partner$Team$RoleValidation = 1;
var $author$project$Pages$Partner$Team$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Oo;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.agy;
			},
			_Utils_Tuple2(1, 'Please pick a role.'))
		]));
var $author$project$Api$Partner$PartnerUser$One$PartnerUser = 0;
var $author$project$Api$Partner$PartnerUser$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$TeamMember$invite = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerUser$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['invite']),
					$author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Pages$Partner$Team$TeamMemberCreated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Partner$TeamMember$create = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'base_url',
								$elm$json$Json$Encode$string(fields.abx)),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(fields.Oo)),
								_Utils_Tuple2(
								'role',
								$elm$json$Json$Encode$string(fields.agy)),
								_Utils_Tuple2(
								'notifications_enabled',
								$elm$json$Json$Encode$bool(fields.UO))
							]))),
					_Utils_Tuple2(
					'invite',
					$elm$json$Json$Encode$bool(fields.ad9))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$PartnerUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$TeamMember$teamMembersPath)));
	});
var $author$project$Pages$Partner$Team$createTeamMember = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Partner$TeamMember$create,
			apiClient,
			{abx: fields.abx, Oo: fields.Oo, ad9: fields.ad9, UO: fields.UO, agy: fields.agy},
			$author$project$Pages$Partner$Team$TeamMemberCreated);
	});
var $author$project$Pages$Partner$Team$TeamMemberUpdated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Partner$TeamMember$update = F4(
	function (apiClient, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'team_member',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									A3($author$project$Utils$Encode$optional, 'role', $elm$json$Json$Encode$string, fields.agy),
									A3($author$project$Utils$Encode$optional, 'notifications_enabled', $elm$json$Json$Encode$bool, fields.UO)
								]))))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$PartnerUser$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
	});
var $author$project$Pages$Partner$Team$updateTeamMember = F3(
	function (apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Partner$TeamMember$update,
			apiClient,
			id,
			{
				UO: $elm$core$Maybe$Just(fields.UO),
				agy: $elm$core$Maybe$Just(fields.agy)
			},
			$author$project$Pages$Partner$Team$TeamMemberUpdated);
	});
var $author$project$Pages$Partner$Team$saveTeamMember = F3(
	function (apiClient, maybeId, formFields) {
		if (!maybeId.$) {
			var id = maybeId.a;
			return A3($author$project$Pages$Partner$Team$updateTeamMember, apiClient, id, formFields);
		} else {
			return A2($author$project$Pages$Partner$Team$createTeamMember, apiClient, formFields);
		}
	});
var $author$project$Pages$Partner$Team$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{BX: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							A: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(
										$author$project$Pages$Partner$Team$formFieldsInit(model.afw)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var field = msg.a;
				var _v1 = model.A;
				if (!_v1.$) {
					var _v2 = _v1.a;
					var teamMember = _v2.a;
					var form = _v2.b;
					var request = _v2.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Team$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, request))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var form = msg.a;
				var teamMember = msg.b;
				var id = msg.c;
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Team$formFieldsValidator, form);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Pages$Partner$Team$saveTeamMember, model.D5, id, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							A: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(teamMember),
									$author$project$Utils$Form$init(
										$author$project$Pages$Partner$Team$formFieldsFromTeamMember(teamMember)),
									$author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{A: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								eK: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eK: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v6.a;
				var searchInputCmd = _v6.b;
				var searchInputEvent = _v6.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v7 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								afy: $author$project$Api$Pagination$reset(model.afy),
								af_: q,
								eK: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Partner$Team$fetchTeamMembers(qModel),
										A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
									])));
					}
				}();
				var newModel = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, eK: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Team$fetchTeamMembers(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 7:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1),
						eK: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Partner$Team$fetchTeamMembers(newModel),
								A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 10:
				var response = msg.a;
				var _v9 = model.A;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var teamMember = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{A: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Partner$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									A: $elm$core$Maybe$Just(
										_Utils_Tuple3(teamMember, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var response = msg.a;
				var _v12 = model.A;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{A: $elm$core$Maybe$Nothing}),
							$author$project$Pages$Partner$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									A: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dU: A2($elm$core$Set$remove, id, model.dU),
									eK: $author$project$Api$Data$Loading
								}),
							$author$project$Pages$Partner$Team$fetchTeamMembers(model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dU: A2($elm$core$Set$remove, id, model.dU)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lQ: $elm$core$Maybe$Just(teamMember)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var id = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lQ: $elm$core$Maybe$Nothing,
							dU: A2($elm$core$Set$insert, id, model.dU)
						}),
					A3(
						$author$project$Api$Partner$TeamMember$delete,
						model.D5,
						id,
						$author$project$Pages$Partner$Team$TeamMemberDeleted(id)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{lQ: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							$9: $elm$core$Maybe$Just(id)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				var id = msg.a;
				var confirmed = msg.b;
				var _v16 = model.A;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var teamMember = _v17.a;
					var form = _v17.b;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$9: $elm$core$Maybe$Nothing,
								A: $elm$core$Maybe$Just(
									_Utils_Tuple3(teamMember, form, $author$project$Api$Data$Loading))
							}),
						A3($author$project$Api$Partner$TeamMember$disableMfa, model.D5, id, $author$project$Pages$Partner$Team$TeamMemberMfaDisabled),
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{$9: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 17:
				var response = msg.a;
				var _v18 = model.A;
				if (!_v18.$) {
					var _v19 = _v18.a;
					var teamMember = _v19.a;
					var form = _v19.b;
					switch (response.$) {
						case 3:
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Partner$Team$formFieldsUpdate,
								$author$project$Pages$Partner$Team$MfaStatus('inactive'),
								form);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										A: $elm$core$Maybe$Just(
											_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked)),
										eK: $author$project$Api$Data$Loading
									}),
								$author$project$Pages$Partner$Team$fetchTeamMembers(model),
								_List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Team member mfa successfully disabled')
									]));
						case 2:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										A: $elm$core$Maybe$Just(
											_Utils_Tuple3(teamMember, form, $author$project$Api$Data$NotAsked))
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Partner$TeamMember$invite,
						model.D5,
						$author$project$Api$Partner$PartnerUser$All$id(teamMember),
						A2(
							$author$project$Pages$Partner$Team$GotInvitation,
							$author$project$Api$Partner$PartnerUser$All$email(teamMember),
							false)),
					_List_Nil);
			case 19:
				var teamMember = msg.a;
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Partner$TeamMember$invite,
						model.D5,
						$author$project$Api$Partner$PartnerUser$All$id(teamMember),
						A2(
							$author$project$Pages$Partner$Team$GotInvitation,
							$author$project$Api$Partner$PartnerUser$All$email(teamMember),
							true)),
					_List_Nil);
			case 21:
				var email = msg.a;
				var isReinvite = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var prefix = isReinvite ? 'A new' : 'An';
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eK: $author$project$Api$Data$Loading}),
						$author$project$Pages$Partner$Team$fetchTeamMembers(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, prefix + (' invitation is being sent to ' + email))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 20:
				var subMsg = msg.a;
				var _v22 = $author$project$Components$InviteLink$update(subMsg);
				var inviteLinkCmd = _v22.a;
				var inviteLinkOutMsg = _v22.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$InviteLinkMsg, inviteLinkCmd),
					inviteLinkOutMsg);
			default:
				var subMsg = msg.a;
				var toogleOrganizationMfaResult = A3($author$project$Components$Admin$ToogleOrganizationMfa$update, model.D5, subMsg, model.tl);
				var newModel = function () {
					var _v23 = toogleOrganizationMfaResult.ac5;
					switch (_v23.$) {
						case 0:
							return model;
						case 1:
							return model;
						default:
							var partner = _v23.a;
							return _Utils_update(
								model,
								{Vz: partner});
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{tl: toogleOrganizationMfaResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$ToogleOrganizationMfa, toogleOrganizationMfaResult.EC),
					toogleOrganizationMfaResult.as);
		}
	});
var $author$project$Pages$Partner$Team$NewTeamMember = {$: 1};
var $author$project$Pages$Partner$Team$PaginationMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$Team$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Partner$Team$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'),
		A3($author$project$Api$Column$init, 'email', false, 'Email'),
		A3($author$project$Api$Column$init, 'role', true, 'Role'),
		A3($author$project$Api$Column$init, 'notifications', false, 'Notifications'),
		A3($author$project$Api$Column$init, 'mfa', false, 'MFA')
	]);
var $author$project$Pages$Partner$Team$EditTeamMember = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Team$InviteTeamMember = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Partner$Team$OpenDeleteConfirm = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$InviteLink$PartnerUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Team$ReInviteTeamMember = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Partner$PartnerUser$Shared$isDestroyable = function (_v0) {
	var record = _v0;
	return record.RJ;
};
var $author$project$Api$Partner$PartnerUser$All$isDestroyable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$isDestroyable(shared);
};
var $author$project$Api$Partner$PartnerUser$Shared$isOwner = function (_v0) {
	var record = _v0;
	return record.RX;
};
var $author$project$Api$Partner$PartnerUser$All$isOwner = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$PartnerUser$Shared$isOwner(shared);
};
var $author$project$Api$Partner$User$Shared$isAdmin = function (_v0) {
	var record = _v0;
	return record.Ru;
};
var $author$project$Api$Partner$User$One$isAdmin = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$User$Shared$isAdmin(shared);
};
var $author$project$Api$Partner$PartnerUser$All$isHinter = function (_v0) {
	var shared = _v0.a;
	return A2(
		$elm$core$String$contains,
		'@hint.com',
		$author$project$Api$Partner$PartnerUser$Shared$email(shared));
};
var $author$project$Api$Partner$PartnerUser$All$isSuperAdmin = function (partnerUser) {
	var _v0 = $author$project$Api$Partner$PartnerUser$All$user(partnerUser);
	if (_v0.$ === 1) {
		return false;
	} else {
		var user_ = _v0.a;
		return $author$project$Api$Partner$PartnerUser$All$isHinter(partnerUser) && $author$project$Api$Partner$User$One$isAdmin(user_);
	}
};
var $author$project$Api$Partner$User$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$User$Shared$name(shared);
};
var $author$project$Pages$Partner$Team$viewTeamMember = F5(
	function (currentUser, deletingTeamMembers, makingAdminTeamMembers, currentUserIsHintAdmin, teamMember) {
		var notificationsStatus = $author$project$Api$Partner$PartnerUser$All$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
		var memberIsOwner = $author$project$Api$Partner$PartnerUser$All$isOwner(teamMember);
		var isCurrentUser = _Utils_eq(
			$author$project$Api$Partner$PartnerUser$All$email(teamMember),
			$author$project$Api$Platform$User$Shared$email(currentUser));
		var rowOptions = isCurrentUser ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(2)
			]) : _List_Nil;
		var id = $author$project$Api$Partner$PartnerUser$All$id(teamMember);
		var loading = A2($elm$core$Set$member, id, deletingTeamMembers) || A2($elm$core$Set$member, id, makingAdminTeamMembers);
		return A2(
			$author$project$Ui$Table$row,
			rowOptions,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('11em')
						]),
					function () {
						var _v0 = $author$project$Api$Partner$PartnerUser$All$user(teamMember);
						if (!_v0.$) {
							var user = _v0.a;
							var memberIsHintAdmin = $author$project$Api$Partner$PartnerUser$All$isSuperAdmin(teamMember);
							var isOwnerOrAdminLabel = function () {
								var _v1 = _Utils_Tuple3(memberIsOwner, memberIsHintAdmin, currentUserIsHintAdmin);
								if (_v1.a) {
									if (_v1.b) {
										if (_v1.c) {
											return $elm$html$Html$text(' (owner | admin)');
										} else {
											return $elm$html$Html$text(' (owner)');
										}
									} else {
										return $elm$html$Html$text(' (owner)');
									}
								} else {
									if (_v1.b && _v1.c) {
										return $elm$html$Html$text(' (admin)');
									} else {
										return $author$project$Utils$Html$empty;
									}
								}
							}();
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Partner$User$One$name(user))
										])),
									isOwnerOrAdminLabel
								]);
						} else {
							var isOwnerLabel = memberIsOwner ? $elm$html$Html$text(' (owner)') : $author$project$Utils$Html$empty;
							return $author$project$Api$Partner$PartnerUser$All$invitationPending(teamMember) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Invitation Pending'),
											isOwnerLabel
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Resend invite email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Partner$Team$ReInviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resend')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Partner$Team$InviteLinkMsg,
											$author$project$Components$InviteLink$view(
												$author$project$Components$InviteLink$PartnerUser(teamMember)))
										]))
								]) : _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Not Invited'),
											isOwnerLabel
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Send invite email'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Partner$Team$InviteTeamMember(teamMember)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send),
													$author$project$Ui$Button$sm
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Send Invite')
												])),
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Partner$Team$InviteLinkMsg,
											$author$project$Components$InviteLink$view(
												$author$project$Components$InviteLink$PartnerUser(teamMember)))
										]))
								]);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Partner$PartnerUser$All$email(teamMember))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Formatters$String$humanize(
									$author$project$Api$Partner$PartnerUser$All$role(teamMember))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Pages$Partner$Team$mfaStatus(
								$elm$core$Maybe$Just(teamMember)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Edit team member'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$disabled(
									loading || (memberIsOwner && (!$author$project$Api$Platform$User$Shared$isAdmin(currentUser)))),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Team$EditTeamMember(teamMember)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Edit')
								])),
							($author$project$Api$Partner$PartnerUser$All$isDestroyable(teamMember) && (!isCurrentUser)) ? A3(
							$author$project$Ui$Button$view,
							{abp: 'Delete team member'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$sm,
									$author$project$Ui$Button$loading(loading),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Partner$Team$OpenDeleteConfirm(teamMember)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Delete')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Partner$Team$viewPanelBody = function (model) {
	var _v0 = function () {
		var _v1 = model.eK;
		if (_v1.$ === 3) {
			var teamMembers_ = _v1.a;
			return _Utils_Tuple2(false, teamMembers_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var teamMembers = _v0.b;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingSm(
			_List_fromArray(
				[
					$elm$html$Html$text('Security')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Partner$Team$ToogleOrganizationMfa,
			$author$project$Components$Admin$ToogleOrganizationMfa$view(model.tl)),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Members')
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_fromArray(
				[$author$project$Ui$FlexGrid$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Partner$Team$SearchInputMsg,
									A2($author$project$Ui$SearchInput$view, _List_Nil, model.sA))
								]))
						]))
				])),
			A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('There are no team members.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						A2(
						$elm$core$List$map,
						$author$project$Api$Column$view(
							A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Partner$Team$SortTable)),
						$author$project$Pages$Partner$Team$columns),
						_List_fromArray(
						[
							A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
						])
					])),
			A2(
				$elm$core$List$map,
				A4($author$project$Pages$Partner$Team$viewTeamMember, model.EQ, model.dU, model.ea, model.FR),
				teamMembers),
			_List_Nil)
		]);
};
var $author$project$Pages$Partner$Team$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$Team$FormUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Partner$Team$Invite = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$Team$NotificationsEnabled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$Team$OpenDisableMfaConfirm = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Partner$Team$Role = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$Team$SaveTeamMember = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Pages$Partner$Team$roleOptions = function (roles) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Pick a role'),
		A2(
			$elm$core$List$map,
			function (role) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Common$Role$All$name(role)),
					$author$project$Formatters$String$titleize(
						$author$project$Formatters$String$humanize(
							$author$project$Api$Common$Role$All$name(role))));
			},
			roles));
};
var $author$project$Pages$Partner$Team$viewPermissionSet = F2(
	function (index, permissionSet) {
		var hasEvenIndex = !A2($elm$core$Basics$modBy, 2, index);
		var offset = hasEvenIndex ? $author$project$Ui$FlexGrid$offsetSm(2) : $author$project$Ui$FlexGrid$offset(1);
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						offset,
						$author$project$Ui$FlexGrid$span(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Formatters$String$humanize(
													$author$project$Api$Common$PermissionSet$Shared$name(permissionSet)))
											])),
										$author$project$Api$Common$PermissionSet$Shared$enabled(permissionSet) ? A2($author$project$Ui$Icon$view, _List_Nil, 18) : A2($author$project$Ui$Icon$view, _List_Nil, 20)
									]))
							]))
					]))
			]);
	});
var $author$project$Pages$Partner$Team$viewTeamMemberModal = F4(
	function (model, teamMember, request, form) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Team Member',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$id, teamMember),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Partner$Team$CancelTeamMemberEdit,
			U0: A2($author$project$Pages$Partner$Team$SaveTeamMember, form, teamMember)
		};
		var isNewTeamMember = !$author$project$Utils$Maybe$toBool(teamMember);
		var isCurrentUser = _Utils_eq(
			A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$email, teamMember),
			$elm$core$Maybe$Just(
				$author$project$Api$Platform$User$Shared$email(model.EQ)));
		var roleDisabled = isCurrentUser || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$isOwner, teamMember));
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = function () {
			var _v1 = model.BX;
			if (_v1.$ === 3) {
				var list = _v1.a;
				return _Utils_Tuple2(list, false);
			} else {
				return _Utils_Tuple2(_List_Nil, true);
			}
		}();
		var roles_ = _v0.a;
		var rolesLoading = _v0.b;
		var permissionSets = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$Role$All$permissionSets,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (role) {
						return _Utils_eq(
							$author$project$Api$Common$Role$All$name(role),
							fields.agy);
					},
					roles_)));
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(isNewTeamMember),
							$author$project$Ui$Form$Group$label('Email')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.Oo),
									$author$project$Ui$Form$Input$placeholder('email@example.com'),
									$author$project$Ui$Form$Input$autofocus(true),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Email)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form)),
									$author$project$Ui$Form$Input$disabled(!isNewTeamMember)
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$label('Role')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(fields.agy)),
									$author$project$Ui$Form$Select$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Role)),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 1, form)),
									$author$project$Ui$Form$Select$loading(rolesLoading),
									$author$project$Ui$Form$Select$disabled(roleDisabled)
								]),
							$author$project$Pages$Partner$Team$roleOptions(roles_)),
							roleDisabled ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$info]),
							_List_fromArray(
								[
									$elm$html$Html$text('You cannot change your own role.')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Notifications')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.UO),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$NotificationsEnabled))
								]))
						])),
					isNewTeamMember ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Send invitation')
						]),
					_List_fromArray(
						[
							$author$project$Ui$ToggleSwitch$view(
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$on(fields.ad9),
									$author$project$Ui$ToggleSwitch$onChange(
									A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Invite))
								]))
						])) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('MFA')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, fields.TW),
									$author$project$Utils$Html$noBreakSpace,
									function () {
									if (!teamMember.$) {
										var teamMember_ = teamMember.a;
										return ((fields.TW === 'active') && (!isCurrentUser)) ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Reset MFA device'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Partner$Team$OpenDisableMfaConfirm(
														$author$project$Api$Partner$PartnerUser$All$id(teamMember_)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset MFA device')
												])) : $author$project$Utils$Html$empty;
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$mb2]),
					$elm$core$List$concat(
						A2($elm$core$List$indexedMap, $author$project$Pages$Partner$Team$viewPermissionSet, permissionSets)))
				]));
	});
var $author$project$Pages$Partner$Team$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.A;
				if (!_v0.$) {
					var _v1 = _v0.a;
					var teamMember = _v1.a;
					var form = _v1.b;
					var request = _v1.c;
					return A4($author$project$Pages$Partner$Team$viewTeamMemberModal, model, teamMember, request, form);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.lQ;
				if (!_v2.$) {
					var teamMember = _v2.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Partner$Team$DeleteConfirmClosed(
							$author$project$Api$Partner$PartnerUser$All$id(teamMember)),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('delete'),
								$author$project$Components$HiConfirm$noun('team member'),
								$author$project$Components$HiConfirm$detail(
								$author$project$Api$Partner$PartnerUser$All$email(teamMember))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v3 = model.$9;
				if (!_v3.$) {
					var id = _v3.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Partner$Team$DisableMfaConfirmClosed(id),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('reset'),
								$author$project$Components$HiConfirm$noun('MFA device'),
								$author$project$Components$HiConfirm$titleizeNoun(false),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text('Resetting the MFA device for this user will log them out of all sessions and require them to setup a new MFA device the next time they login.')
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Team')
													])),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														$elm$html$Html$text('Changing settings within the Admin section requires \"Admin\" privileges. Non admin users can\n        view the settings but cannot change them.')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Add new member'},
												_List_fromArray(
													[
														$author$project$Ui$Button$default,
														$author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$NewTeamMember),
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Add')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						$author$project$Pages$Partner$Team$viewPanelBody(model)),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Partner$Team$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.eK))
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Admin | Team'
	};
};
var $author$project$Pages$Partner$Team$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$Team$init, aer: $author$project$Pages$Partner$Team$load, agD: $author$project$Pages$Partner$Team$save, ahd: $author$project$Pages$Partner$Team$subscriptions, aaq: $author$project$Pages$Partner$Team$update, ahP: $author$project$Pages$Partner$Team$view});
var $author$project$Pages$Partner$WebhookEndpoints$GotIntegrationEvents = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Integrations = 1;
var $author$project$Pages$Partner$WebhookEndpoints$ListenedEventsDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$ManageGlobalWebhookEndpointsMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$ManageIntegrationWebhookEndpointsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Partner = 0;
var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Model = $elm$core$Basics$identity;
var $author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{afy: model.afy, ag1: model.ag1});
	};
};
var $author$project$Api$Partner$WebhookEndpoint$All$WebhookEndpoint = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Partner$WebhookEndpoint$Shared$WebhookEndpoint = $elm$core$Basics$identity;
var $author$project$Api$Partner$WebhookEndpoint$Shared$Record = F4(
	function (id, webhookUrl, createdAt, lastDeliveredAt) {
		return {Mf: createdAt, adR: id, Sx: lastDeliveredAt, aaW: webhookUrl};
	});
var $author$project$Api$Partner$WebhookEndpoint$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'last_delivered_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'webhook_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$Shared$Record)))));
var $author$project$Api$Partner$WebhookEndpoint$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$WebhookEndpoint$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Partner$WebhookEndpoint$All$Record = function (integration) {
	return {Q4: integration};
};
var $author$project$Api$Partner$WebhookEndpoint$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'integration',
	$elm$json$Json$Decode$nullable($author$project$Api$Partner$Integration$Shared$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$All$Record));
var $author$project$Api$Partner$WebhookEndpoint$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Partner$WebhookEndpoint$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Partner$WebhookEndpoint$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$All$WebhookEndpoint)));
var $author$project$Api$Partner$Common$WebhookEndpoint$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Partner$Common$WebhookEndpoint$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['webhook_endpoints']),
	$author$project$Api$Partner$Integration$integrationsPath);
var $author$project$Api$Partner$Integration$WebhookEndpoint$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$WebhookEndpoint$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['webhook_endpoints']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$WebhookEndpoint$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Partner$WebhookEndpoint$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints = F2(
	function (apiClient, model) {
		var _v0 = model.Vp;
		if (!_v0) {
			return A3(
				$author$project$Api$Partner$WebhookEndpoint$list,
				apiClient,
				$author$project$Components$Partner$ManageWebhookEndpoints$fetchParams(model),
				$author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints);
		} else {
			return A3(
				$author$project$Api$Partner$Integration$WebhookEndpoint$list,
				apiClient,
				$author$project$Components$Partner$ManageWebhookEndpoints$fetchParams(model),
				$author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$init = F4(
	function (apiClient, timeFormatter, owner, query) {
		var prefix = function () {
			if (!owner) {
				return 'partner_';
			} else {
				return 'integrations_';
			}
		}();
		var _v0 = A2(
			$author$project$Components$ResourceFilter$Partner$Integration$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Practice'});
			});
		var integrationResourceFilter = _v0.a;
		var integrationResourceFilterCmd = _v0.b;
		var model = {
			ic: $elm$core$Maybe$Nothing,
			dN: $elm$core$Set$empty,
			mw: integrationResourceFilter,
			FU: $elm$core$Maybe$Nothing,
			Vp: owner,
			afy: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, prefix, $author$project$Api$Pagination$init)),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'created_at',
				1,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, prefix, $author$project$Api$Sort$init))),
			Hy: timeFormatter,
			hf: $author$project$Api$Data$Loading
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg, integrationResourceFilterCmd)
					])));
	});
var $author$project$Api$Partner$Partner$Shared$listenedEvents = function (_v0) {
	var record = _v0;
	return record.SY;
};
var $author$project$Api$Partner$Partner$One$listenedEvents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$listenedEvents(shared);
};
var $author$project$Api$Partner$Partner$Shared$maxRequestsPperMinute = function (_v0) {
	var record = _v0;
	return record.Ts;
};
var $author$project$Api$Partner$Partner$One$maxRequestsPperMinute = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$maxRequestsPperMinute(shared);
};
var $author$project$Api$Partner$Partner$Shared$unmuteSelfWebhooks = function (_v0) {
	var record = _v0;
	return record.aak;
};
var $author$project$Api$Partner$Partner$One$unmuteSelfWebhooks = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$unmuteSelfWebhooks(shared);
};
var $author$project$Api$Partner$Partner$Shared$webhooksDisabled = function (_v0) {
	var record = _v0;
	return record.aaX;
};
var $author$project$Api$Partner$Partner$One$webhooksDisabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$webhooksDisabled(shared);
};
var $author$project$Api$Partner$Partner$Shared$webhooksPaused = function (_v0) {
	var record = _v0;
	return record.aaY;
};
var $author$project$Api$Partner$Partner$One$webhooksPaused = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$webhooksPaused(shared);
};
var $author$project$Pages$Partner$WebhookEndpoints$initFormFields = function (partner) {
	return _Utils_Tuple2(
		{
			SY: $author$project$Api$Partner$Partner$One$listenedEvents(partner),
			Ts: $author$project$Api$Partner$Partner$One$maxRequestsPperMinute(partner),
			aak: $author$project$Api$Partner$Partner$One$unmuteSelfWebhooks(partner),
			aaX: $author$project$Api$Partner$Partner$One$webhooksDisabled(partner),
			aaY: $author$project$Api$Partner$Partner$One$webhooksPaused(partner)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Api$Partner$IntegrationEvent$integrationEventsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['integration_events']),
	$author$project$Api$Data$partnerPath);
var $author$project$Api$Partner$IntegrationEvent$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Partner$IntegrationEvent$integrationEventsPath));
	});
var $author$project$Pages$Partner$WebhookEndpoints$init = F4(
	function (_v0, partner, shared, _v1) {
		var query = _v1.Bi;
		var _v2 = A4($author$project$Components$Partner$ManageWebhookEndpoints$init, shared.D5, shared.Hy, 1, query);
		var manageIntegrationsWebhookEndpoints = _v2.a;
		var manageIntegrationsWebhookEndpointsCmd = _v2.b;
		var _v3 = A4($author$project$Components$Partner$ManageWebhookEndpoints$init, shared.D5, shared.Hy, 0, query);
		var manageGlobalWebhookEndpoints = _v3.a;
		var manageGlobalWebhookEndpointsCmd = _v3.b;
		var _v4 = $author$project$Pages$Partner$WebhookEndpoints$initFormFields(partner);
		var formFields = _v4.a;
		var formFieldsCmd = _v4.b;
		var model = {
			D5: shared.D5,
			PB: $author$project$Utils$Form$init(formFields),
			x8: $author$project$Api$Data$Loading,
			FR: $author$project$Shared$isHintAdmin(shared),
			mU: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'listened-events-dropdown', ahx: $author$project$Pages$Partner$WebhookEndpoints$ListenedEventsDropdownMsg})),
			yC: '',
			mX: manageGlobalWebhookEndpoints,
			mZ: manageIntegrationsWebhookEndpoints,
			o$: $author$project$Api$Data$NotAsked
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formFieldsCmd,
						A2($author$project$Api$Partner$IntegrationEvent$list, shared.D5, $author$project$Pages$Partner$WebhookEndpoints$GotIntegrationEvents),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$WebhookEndpoints$ManageGlobalWebhookEndpointsMsg, manageGlobalWebhookEndpointsCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$WebhookEndpoints$ManageIntegrationWebhookEndpointsMsg, manageIntegrationsWebhookEndpointsCmd)
					])));
	});
var $author$project$Pages$Partner$WebhookEndpoints$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Partner$WebhookEndpoints$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit = {$: 5};
var $author$project$Components$Partner$ManageWebhookEndpoints$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit)),
					model.FU)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg,
				$author$project$Components$ResourceFilter$Partner$Integration$subscriptions(model.mw))
			]));
};
var $author$project$Pages$Partner$WebhookEndpoints$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$WebhookEndpoints$ManageGlobalWebhookEndpointsMsg,
				$author$project$Components$Partner$ManageWebhookEndpoints$subscriptions(model.mX)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Partner$WebhookEndpoints$ManageIntegrationWebhookEndpointsMsg,
				$author$project$Components$Partner$ManageWebhookEndpoints$subscriptions(model.mZ)),
				$author$project$Ui$NewDropdown$subscriptions(model.mU)
			]));
};
var $author$project$Pages$Partner$WebhookEndpoints$GotUpdatedPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aaX: bool});
			case 1:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aaY: bool});
			case 2:
				var bool = field.a;
				return _Utils_update(
					fields,
					{aak: bool});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Ts: $elm$core$String$toInt(string)
					});
			default:
				var listenedEventField = field.a;
				var checked = field.b;
				return _Utils_update(
					fields,
					{
						SY: function () {
							var _v1 = _Utils_Tuple2(listenedEventField, checked);
							if (_v1.b) {
								switch (_v1.a.$) {
									case 0:
										var avaialbleListenedEvents = _v1.a.a;
										return avaialbleListenedEvents;
									case 1:
										return _List_Nil;
									default:
										var listenedEvents = _v1.a.a;
										return $elm$core$List$isEmpty(listenedEvents) ? _List_Nil : $elm_community$list_extra$List$Extra$unique(
											_Utils_ap(listenedEvents, fields.SY));
								}
							} else {
								switch (_v1.a.$) {
									case 0:
										return _List_Nil;
									case 1:
										var avaialbleListenedEvents = _v1.a.a;
										return avaialbleListenedEvents;
									default:
										var listenedEvents = _v1.a.a;
										return $elm_community$list_extra$List$Extra$unique(
											A2(
												$elm$core$List$filter,
												function (selectedEvent) {
													return !A2($elm$core$List$member, selectedEvent, listenedEvents);
												},
												fields.SY));
								}
							}
						}()
					});
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationField = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Deleted = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Partner$Integration$WebhookEndpoint$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath(id)));
	});
var $author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath = function (id) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id]),
		$author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath);
};
var $author$project$Api$Partner$WebhookEndpoint$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath(id)));
	});
var $author$project$Api$Partner$WebhookEndpoint$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Partner$WebhookEndpoint$All$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookEndpoint$Shared$id(shared);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$deleteItem = F3(
	function (apiClient, owner, item) {
		if (!owner) {
			return A3(
				$author$project$Api$Partner$WebhookEndpoint$delete,
				apiClient,
				$author$project$Api$Partner$WebhookEndpoint$All$id(item),
				$author$project$Components$Partner$ManageWebhookEndpoints$Deleted(item));
		} else {
			return A3(
				$author$project$Api$Partner$Integration$WebhookEndpoint$delete,
				apiClient,
				$author$project$Api$Partner$WebhookEndpoint$All$id(item),
				$author$project$Components$Partner$ManageWebhookEndpoints$Deleted(item));
		}
	});
var $author$project$Api$Partner$WebhookEndpoint$All$integration = function (_v0) {
	var record = _v0.b;
	return record.Q4;
};
var $author$project$Api$Partner$WebhookEndpoint$Shared$webhookUrl = function (_v0) {
	var record = _v0;
	return record.aaW;
};
var $author$project$Api$Partner$WebhookEndpoint$All$webhookUrl = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookEndpoint$Shared$webhookUrl(shared);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsFromItem = function (webhookEndpoint) {
	return _Utils_Tuple2(
		{
			Q4: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$Integration$Shared$id,
				$author$project$Api$Partner$WebhookEndpoint$All$integration(webhookEndpoint)),
			aaW: $author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(webhookEndpoint)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsInit = _Utils_Tuple2(
	{Q4: $elm$core$Maybe$Nothing, aaW: ''},
	$elm$core$Platform$Cmd$none);
var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var string = field.a;
			return _Utils_update(
				fields,
				{aaW: string});
		} else {
			var integration = field.a;
			return _Utils_update(
				fields,
				{Q4: integration});
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationValidation = 1;
var $author$project$Components$Partner$ManageWebhookEndpoints$validateIntegration = F2(
	function (owner, fields) {
		if (!owner) {
			return _List_Nil;
		} else {
			return _Utils_eq(fields.Q4, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Practice is required')
				]) : _List_Nil;
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrlValidation = 0;
var $author$project$Components$Partner$ManageWebhookEndpoints$validateWebhookUrl = function (fields) {
	return A2($elm$core$String$startsWith, 'https://', fields.aaW) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(0, 'URL must start with https://')
		]);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsValidator = function (owner) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManageWebhookEndpoints$validateWebhookUrl),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Partner$ManageWebhookEndpoints$validateIntegration(owner))
			]));
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Created = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Partner$WebhookEndpoint$One$WebhookEndpoint = 0;
var $author$project$Api$Partner$WebhookEndpoint$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Partner$Integration$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aaW)),
								_Utils_Tuple2(
								'integration',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.Q4))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Api$Partner$WebhookEndpoint$create = F3(
	function (apiClient, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aaW))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Partner$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath)));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$integrationWebhookEndpointApiFields = function (fields) {
	return {Q4: fields.Q4, aaW: fields.aaW};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$partnerWebhookEndpointApiFields = function (fields) {
	return {aaW: fields.aaW};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$createItem = F3(
	function (apiClient, owner, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		if (!owner) {
			return A3(
				$author$project$Api$Partner$WebhookEndpoint$create,
				apiClient,
				$author$project$Components$Partner$ManageWebhookEndpoints$partnerWebhookEndpointApiFields(fields),
				$author$project$Components$Partner$ManageWebhookEndpoints$Created);
		} else {
			return A3(
				$author$project$Api$Partner$Integration$WebhookEndpoint$create,
				apiClient,
				$author$project$Components$Partner$ManageWebhookEndpoints$integrationWebhookEndpointApiFields(fields),
				$author$project$Components$Partner$ManageWebhookEndpoints$Created);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$Updated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Partner$Integration$WebhookEndpoint$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aaW))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath(id))));
	});
var $author$project$Api$Partner$WebhookEndpoint$update = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'webhook_endpoint',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'webhook_url',
								$elm$json$Json$Encode$string(params.aaW))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Partner$WebhookEndpoint$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath(id))));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$updateItem = F4(
	function (apiClient, owner, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		if (!owner) {
			return A4(
				$author$project$Api$Partner$WebhookEndpoint$update,
				apiClient,
				id,
				{aaW: fields.aaW},
				$author$project$Components$Partner$ManageWebhookEndpoints$Updated);
		} else {
			return A4(
				$author$project$Api$Partner$Integration$WebhookEndpoint$update,
				apiClient,
				id,
				{aaW: fields.aaW},
				$author$project$Components$Partner$ManageWebhookEndpoints$Updated);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$saveItem = F4(
	function (apiClient, owner, maybeId, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Components$Partner$ManageWebhookEndpoints$updateItem, apiClient, owner, id_, formFields);
		} else {
			return A3($author$project$Components$Partner$ManageWebhookEndpoints$createItem, apiClient, owner, formFields);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$updateUrl = function (model) {
	return $author$project$Ports$Navigation$replaceUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__WebhookEndpoints)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				$author$project$Api$Sort$toQuery(model.ag1))));
};
var $author$project$Components$Partner$ManageWebhookEndpoints$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								hf: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, hf: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, newModel),
								$author$project$Components$Partner$ManageWebhookEndpoints$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1),
						hf: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, newModel),
								$author$project$Components$Partner$ManageWebhookEndpoints$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var _v3 = $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsInit;
				var formFields = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 4:
				var item = msg.a;
				var _v4 = $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsFromItem(item);
				var formFields = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							FU: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(item),
									$author$project$Utils$Form$init(formFields),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{FU: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var field = msg.a;
				var _v5 = model.FU;
				if (!_v5.$) {
					var _v6 = _v5.a;
					var id = _v6.a;
					var form = _v6.b;
					var item = _v6.c;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate, field, form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, item))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var item = msg.a;
				var form = msg.b;
				var _v7 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Partner$ManageWebhookEndpoints$formFieldsValidator(model.Vp),
					form);
				if (!_v7.$) {
					var _v8 = _v7.a;
					var validatedForm = _v8.a;
					var validFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
							}),
						A4(
							$author$project$Components$Partner$ManageWebhookEndpoints$saveItem,
							apiClient,
							model.Vp,
							A2($elm$core$Maybe$map, $author$project$Api$Partner$WebhookEndpoint$All$id, item),
							validFormFields),
						_List_Nil);
				} else {
					var validatedForm = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								FU: $elm$core$Maybe$Just(
									_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v9 = model.FU;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, hf: $author$project$Api$Data$Loading}),
							A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully created webhook endpoint'),
									$author$project$OutMsg$RefreshPractice
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var response = msg.a;
				var _v12 = model.FU;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{FU: $elm$core$Maybe$Nothing, hf: $author$project$Api$Data$Loading}),
							A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated webhook endpoint')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									FU: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ic: $elm$core$Maybe$Just(item)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var item = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var id = $author$project$Api$Partner$WebhookEndpoint$All$id(item);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ic: $elm$core$Maybe$Nothing,
								dN: A2($elm$core$Set$insert, id, model.dN)
							}),
						A3($author$project$Components$Partner$ManageWebhookEndpoints$deleteItem, apiClient, model.Vp, item),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ic: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 12:
				var item = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$WebhookEndpoint$All$id(item),
										model.dN),
									hf: $author$project$Api$Data$Loading
								}),
							A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint was successfully removed.'),
									$author$project$OutMsg$RefreshPractice
								]));
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									dN: A2(
										$elm$core$Set$remove,
										$author$project$Api$Partner$WebhookEndpoint$All$id(item),
										model.dN)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				var subMsg = msg.a;
				var integrationResourceResult = A3($author$project$Components$ResourceFilter$Partner$Integration$update, apiClient, subMsg, model.mw);
				var item = function () {
					var _v16 = _Utils_Tuple2(model.FU, integrationResourceResult.ac5);
					if (!_v16.a.$) {
						if ((!_v16.b.$) && (!_v16.b.a.$)) {
							var _v17 = _v16.a.a;
							var id = _v17.a;
							var form = _v17.b;
							var request = _v17.c;
							var updatedForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate,
								$author$project$Components$Partner$ManageWebhookEndpoints$IntegrationField(
									$author$project$Components$ResourceFilter$Partner$Integration$value(integrationResourceResult.y8)),
								form);
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(id, updatedForm, request));
						} else {
							var item_ = _v16.a.a;
							return $elm$core$Maybe$Just(item_);
						}
					} else {
						var _v18 = _v16.a;
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mw: integrationResourceResult.y8, FU: item}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg, integrationResourceResult.EC),
					integrationResourceResult.as);
		}
	});
var $author$project$Pages$Partner$WebhookEndpoints$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Api$Partner$Partner$UnmuteSelfWebhooks = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$toPermittedFields = F2(
	function (isHintAdmin, fields) {
		return A2(
			$elm$core$List$cons,
			$author$project$Api$Partner$Partner$ListenedEvents(fields.SY),
			A2(
				$elm$core$List$cons,
				$author$project$Api$Partner$Partner$WebhooksPaused(fields.aaY),
				A2(
					$elm$core$List$cons,
					$author$project$Api$Partner$Partner$UnmuteSelfWebhooks(fields.aak),
					A2(
						$elm$core$List$cons,
						$author$project$Api$Partner$Partner$MaxRequestPerMinute(fields.Ts),
						isHintAdmin ? _List_fromArray(
							[
								$author$project$Api$Partner$Partner$WebhooksDisabled(fields.aaX)
							]) : _List_Nil))));
	});
var $author$project$Pages$Partner$WebhookEndpoints$validate = function (model) {
	var _v0 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$WebhookEndpoints$formFieldsValidator, model.PB);
	if (!_v0.$) {
		var _v1 = _v0.a;
		var validFormFields = _v1.b;
		var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return $elm$core$Result$Ok(
			A2($author$project$Pages$Partner$WebhookEndpoints$toPermittedFields, model.FR, fields));
	} else {
		var validatedForm = _v0.a;
		return $elm$core$Result$Err(validatedForm);
	}
};
var $author$project$Pages$Partner$WebhookEndpoints$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$WebhookEndpoints$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v1 = $author$project$Pages$Partner$WebhookEndpoints$validate(model);
				if (!_v1.$) {
					var permittedFields = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Partner$Partner$update, model.D5, permittedFields, $author$project$Pages$Partner$WebhookEndpoints$GotUpdatedPartner),
						_List_Nil);
				} else {
					var updatedForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: updatedForm, o$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
								$author$project$OutMsg$RefreshPartner
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o$: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, subMsg, model.mU);
				var listenedEventsDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mU: listenedEventsDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{x8: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 5:
				var text = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{yC: text}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v4 = A3($author$project$Components$Partner$ManageWebhookEndpoints$update, model.D5, subMsg, model.mX);
				var manageGlobalWebhookEndpoints = _v4.a;
				var manageGlobalWebhookEndpointsCmd = _v4.b;
				var manageGlobalWebhookEndpointsOutMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mX: manageGlobalWebhookEndpoints}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$WebhookEndpoints$ManageGlobalWebhookEndpointsMsg, manageGlobalWebhookEndpointsCmd),
					manageGlobalWebhookEndpointsOutMsgs);
			default:
				var subMsg = msg.a;
				var _v5 = A3($author$project$Components$Partner$ManageWebhookEndpoints$update, model.D5, subMsg, model.mZ);
				var manageIntegrationsWebhookEndpoints = _v5.a;
				var manageIntegrationsWebhookEndpointsCmd = _v5.b;
				var manageIntegrationsWebhookEndpointsOutMsgs = _v5.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mZ: manageIntegrationsWebhookEndpoints}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$WebhookEndpoints$ManageIntegrationWebhookEndpointsMsg, manageIntegrationsWebhookEndpointsCmd),
					manageIntegrationsWebhookEndpointsOutMsgs);
		}
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$HiConfirmClosed = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$New = {$: 3};
var $author$project$Components$Partner$ManageWebhookEndpoints$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$FormUpdated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Save = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$viewCreateEditModal = F5(
	function (owner, integrationResourceFilter, item, form, request) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Webhook Endpoint',
			S_: _Utils_eq(request, $author$project$Api$Data$Loading),
			Tv: A2($elm$core$Maybe$map, $author$project$Api$Partner$WebhookEndpoint$All$id, item),
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit,
			U0: $elm$core$Basics$always(
				A2($author$project$Components$Partner$ManageWebhookEndpoints$Save, item, form))
		};
		var fields = $author$project$Utils$Form$fields(form);
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					function () {
					if (!owner) {
						return $author$project$Utils$Html$empty;
					} else {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpan(4),
									$author$project$Ui$Form$Group$inputSpan(8),
									$author$project$Ui$Form$Group$label('Practice')
								]),
							_List_fromArray(
								[
									function () {
									if (!item.$) {
										var item_ = item.a;
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Partner$Practice$Shared$name,
															A2(
																$elm$core$Maybe$map,
																$author$project$Api$Partner$Integration$Shared$practice,
																$author$project$Api$Partner$WebhookEndpoint$All$integration(item_)))))
												]));
									} else {
										return A2(
											$elm$html$Html$map,
											$author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Partner$Integration$viewNew,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
														$author$project$Components$ResourceFilter$errors(
														A2($author$project$Utils$Form$validationErrors, 1, form))
													]),
												integrationResourceFilter));
									}
								}()
								]));
					}
				}(),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8),
							$author$project$Ui$Form$Group$label('Webhook URL')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(fields.aaW),
									$author$project$Ui$Form$Input$placeholder('https://your-webhook-url.com'),
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManageWebhookEndpoints$FormUpdated, $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrl)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, form))
								]))
						]))
				]));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$SortTable = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$columns = function (owner) {
	return _Utils_ap(
		function () {
			if (!owner) {
				return _List_Nil;
			} else {
				return _List_fromArray(
					[
						A3($author$project$Api$Column$init, 'name', true, 'Practice')
					]);
			}
		}(),
		_List_fromArray(
			[
				A3($author$project$Api$Column$init, 'webhook_url', true, 'Webhook URL'),
				A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
				A3($author$project$Api$Column$init, 'last_delivered_at', true, 'Last Delivered At')
			]));
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Delete = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Partner$ManageWebhookEndpoints$Edit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Partner$WebhookEndpoint$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Partner$WebhookEndpoint$All$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookEndpoint$Shared$createdAt(shared);
};
var $author$project$Api$Partner$WebhookEndpoint$Shared$lastDeliveredAt = function (_v0) {
	var record = _v0;
	return record.Sx;
};
var $author$project$Api$Partner$WebhookEndpoint$All$lastDeliveredAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$WebhookEndpoint$Shared$lastDeliveredAt(shared);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$viewWebhookEndpoint = F4(
	function (timeFormatter, owner, deletingItems, webhookEndpoint) {
		var id = $author$project$Api$Partner$WebhookEndpoint$All$id(webhookEndpoint);
		var loading = A2($elm$core$Set$member, id, deletingItems);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						if (!owner) {
							return _List_Nil;
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Partner$Practice$Shared$name,
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Partner$Integration$Shared$practice,
														$author$project$Api$Partner$WebhookEndpoint$All$integration(webhookEndpoint)))))
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(webhookEndpoint))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										0,
										$author$project$Api$Partner$WebhookEndpoint$All$createdAt(webhookEndpoint)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(0),
											$author$project$Api$Partner$WebhookEndpoint$All$lastDeliveredAt(webhookEndpoint))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[$author$project$Ui$Table$textRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit webhook endpoint'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Partner$ManageWebhookEndpoints$Edit(webhookEndpoint)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Delete location'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$loading(loading),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Partner$ManageWebhookEndpoints$Delete(webhookEndpoint)),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete')
										]))
								]))
						])
					])));
	});
var $author$project$Components$Partner$ManageWebhookEndpoints$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.hf;
		if (_v1.$ === 3) {
			var webhookEndpoints_ = _v1.a;
			return _Utils_Tuple2(false, webhookEndpoints_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var webhookEndpoints = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any webhook endpoints')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_Utils_ap(
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Partner$ManageWebhookEndpoints$SortTable)),
				$author$project$Components$Partner$ManageWebhookEndpoints$columns(model.Vp)),
			_List_fromArray(
				[
					A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
				])),
		A2(
			$elm$core$List$map,
			A3($author$project$Components$Partner$ManageWebhookEndpoints$viewWebhookEndpoint, model.Hy, model.Vp, model.dN),
			webhookEndpoints),
		_List_Nil);
};
var $author$project$Components$Partner$ManageWebhookEndpoints$view = function (_v0) {
	var model = _v0;
	var loading = function () {
		var _v5 = model.hf;
		if (_v5.$ === 3) {
			return false;
		} else {
			return true;
		}
	}();
	return _List_fromArray(
		[
			function () {
			var _v1 = model.FU;
			if (!_v1.$) {
				var _v2 = _v1.a;
				var item = _v2.a;
				var form = _v2.b;
				var request = _v2.c;
				return A5($author$project$Components$Partner$ManageWebhookEndpoints$viewCreateEditModal, model.Vp, model.mw, item, form, request);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v3 = model.ic;
			if (!_v3.$) {
				var item = _v3.a;
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Components$Partner$ManageWebhookEndpoints$HiConfirmClosed(item),
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('delete'),
							$author$project$Components$HiConfirm$noun('webhook endpoint'),
							$author$project$Components$HiConfirm$detail(
							$author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(item))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$titleWithButton,
							_List_fromArray(
								[
									function () {
									var _v4 = model.Vp;
									if (!_v4) {
										return $elm$html$Html$text('Partner Webhook Endpoints');
									} else {
										return $elm$html$Html$text('Practices Webhook Endpoints');
									}
								}()
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Add new webhook endpoint'},
									_List_fromArray(
										[
											$author$project$Ui$Button$default,
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick($author$project$Components$Partner$ManageWebhookEndpoints$New),
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New Webhook Endpoint')
										]))
								]))
						])),
					$author$project$Components$Partner$ManageWebhookEndpoints$viewTable(model),
					A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Partner$ManageWebhookEndpoints$PaginationMsg,
							A2(
								$author$project$Api$Pagination$view,
								_List_fromArray(
									[
										$author$project$Ui$Pagination$List$loading(loading)
									]),
								model.afy))
						]))
				]))
		]);
};
var $author$project$Pages$Partner$WebhookEndpoints$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$MaxRequestsPperMinute = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$Save = {$: 1};
var $author$project$Pages$Partner$WebhookEndpoints$UnmuteSelfWebhooks = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$WebhooksDisabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$WebhooksPaused = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$NewDropdown$Secondary = 0;
var $author$project$Ui$NewDropdown$buttonSecondary = $author$project$Ui$NewDropdown$Button(0);
var $elm_community$list_extra$List$Extra$isSubsequenceOf = F2(
	function (subseq, list) {
		isSubsequenceOf:
		while (true) {
			var _v0 = _Utils_Tuple2(subseq, list);
			if (!_v0.a.b) {
				return true;
			} else {
				if (!_v0.b.b) {
					return false;
				} else {
					var _v1 = _v0.a;
					var x = _v1.a;
					var xs = _v1.b;
					var _v2 = _v0.b;
					var y = _v2.a;
					var ys = _v2.b;
					if (_Utils_eq(x, y)) {
						var $temp$subseq = xs,
							$temp$list = ys;
						subseq = $temp$subseq;
						list = $temp$list;
						continue isSubsequenceOf;
					} else {
						var $temp$subseq = subseq,
							$temp$list = ys;
						subseq = $temp$subseq;
						list = $temp$list;
						continue isSubsequenceOf;
					}
				}
			}
		}
	});
var $author$project$Pages$Partner$WebhookEndpoints$ListenedEventFieldAll = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$ListenedEventFieldNone = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$ListenedEventFieldOne = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Partner$WebhookEndpoints$ListenedEvents = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Partner$WebhookEndpoints$ListenedEventsSearched = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$NewDropdown$Item$Indented = {$: 13};
var $author$project$Ui$NewDropdown$indented = $author$project$Ui$NewDropdown$Item$Indented;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Pages$Partner$WebhookEndpoints$listenedEventsOptions = F3(
	function (availableListenedEvents, listenedEventsSearch, checkedListenedEvents) {
		var contains = function (availableListenedEvent) {
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(listenedEventsSearch),
				$elm$core$String$toLower(availableListenedEvent));
		};
		var filteredAvailableListenedEvents = A2($elm$core$List$filter, contains, availableListenedEvents);
		var resources = $elm$core$List$sort(
			$elm_community$list_extra$List$Extra$unique(
				A2(
					$elm$core$List$filterMap,
					$elm$core$List$head,
					A2(
						$elm$core$List$map,
						$elm$core$String$split('.'),
						filteredAvailableListenedEvents))));
		return A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$input(
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onInput($author$project$Pages$Partner$WebhookEndpoints$ListenedEventsSearched),
						$author$project$Ui$NewDropdown$value(listenedEventsSearch),
						$author$project$Ui$NewDropdown$placeholder('Search...')
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$NewDropdown$checkbox,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$onCheck(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Pages$Partner$WebhookEndpoints$FormUpdated,
								$author$project$Pages$Partner$WebhookEndpoints$ListenedEvents(
									$author$project$Pages$Partner$WebhookEndpoints$ListenedEventFieldAll(availableListenedEvents)))),
							$author$project$Ui$NewDropdown$checked(
							_Utils_eq(
								$elm$core$List$length(checkedListenedEvents),
								$elm$core$List$length(availableListenedEvents)))
						]),
					$elm$html$Html$text('All')),
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$NewDropdown$checkbox,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onCheck(
								A2(
									$elm$core$Basics$composeL,
									$author$project$Pages$Partner$WebhookEndpoints$FormUpdated,
									$author$project$Pages$Partner$WebhookEndpoints$ListenedEvents(
										$author$project$Pages$Partner$WebhookEndpoints$ListenedEventFieldNone(availableListenedEvents)))),
								$author$project$Ui$NewDropdown$checked(
								$elm$core$List$isEmpty(checkedListenedEvents))
							]),
						$elm$html$Html$text('None')),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$NewDropdown$separator,
						A2(
							$elm$core$List$concatMap,
							function (resource) {
								var resourceEvents = A2(
									$elm$core$List$filter,
									$elm$core$String$startsWith(resource),
									filteredAvailableListenedEvents);
								return A2(
									$elm$core$List$map,
									function (listenedEvent) {
										var formFieldValue = A2($elm$core$String$endsWith, '*', listenedEvent) ? $author$project$Pages$Partner$WebhookEndpoints$ListenedEventFieldOne(resourceEvents) : $author$project$Pages$Partner$WebhookEndpoints$ListenedEventFieldOne(
											_List_fromArray(
												[listenedEvent]));
										var checked = A2($elm$core$String$endsWith, '*', listenedEvent) ? A2($elm_community$list_extra$List$Extra$isSubsequenceOf, resourceEvents, checkedListenedEvents) : A2($elm$core$List$member, listenedEvent, checkedListenedEvents);
										var checkboxOptions = A2(
											$elm$core$List$cons,
											$author$project$Ui$NewDropdown$onCheck(
												A2(
													$elm$core$Basics$composeL,
													$author$project$Pages$Partner$WebhookEndpoints$FormUpdated,
													$author$project$Pages$Partner$WebhookEndpoints$ListenedEvents(formFieldValue))),
											A2(
												$elm$core$List$cons,
												$author$project$Ui$NewDropdown$checked(checked),
												A2($elm$core$String$endsWith, '*', listenedEvent) ? _List_Nil : _List_fromArray(
													[$author$project$Ui$NewDropdown$indented])));
										return A2(
											$author$project$Ui$NewDropdown$checkbox,
											checkboxOptions,
											$elm$html$Html$text(listenedEvent));
									},
									A2($elm$core$List$cons, resource + '.*', resourceEvents));
							},
							resources)))));
	});
var $author$project$Ui$NewDropdown$Loading = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$NewDropdown$loading = $author$project$Ui$NewDropdown$Loading;
var $author$project$Pages$Partner$WebhookEndpoints$viewSettings = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var _v0 = function () {
		var _v1 = model.x8;
		if (_v1.$ === 3) {
			var avaialbleListenedEvents_ = _v1.a;
			return _Utils_Tuple2(false, avaialbleListenedEvents_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var avaialbleListenedEventsLoading = _v0.a;
	var avaialbleListenedEvents = _v0.b;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$onSubmit($author$project$Pages$Partner$WebhookEndpoints$Save)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Settings')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								model.FR ? A2(
								$author$project$Ui$HinterOnly$formGroup,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Webhooks Disabled')
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(fields.aaX),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Partner$WebhookEndpoints$FormUpdated, $author$project$Pages$Partner$WebhookEndpoints$WebhooksDisabled))
											]))
									])) : $author$project$Utils$Html$empty,
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Webhooks Paused')
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(fields.aaY),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Partner$WebhookEndpoints$FormUpdated, $author$project$Pages$Partner$WebhookEndpoints$WebhooksPaused))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Unmute Self Webhooks')
									]),
								_List_fromArray(
									[
										$author$project$Ui$ToggleSwitch$view(
										_List_fromArray(
											[
												$author$project$Ui$ToggleSwitch$on(fields.aak),
												$author$project$Ui$ToggleSwitch$onChange(
												A2($elm$core$Basics$composeL, $author$project$Pages$Partner$WebhookEndpoints$FormUpdated, $author$project$Pages$Partner$WebhookEndpoints$UnmuteSelfWebhooks))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Max Requests per Minute')
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Ts))),
												$author$project$Ui$Form$Input$number,
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$Partner$WebhookEndpoints$FormUpdated, $author$project$Pages$Partner$WebhookEndpoints$MaxRequestsPperMinute))
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpan(8),
										$author$project$Ui$Form$Group$label('Listened Events')
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Ui$NewDropdown$view,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$buttonSecondary,
												$author$project$Ui$NewDropdown$loading(avaialbleListenedEventsLoading)
											]),
										_List_fromArray(
											[
												function () {
												if ($elm$core$List$isEmpty(fields.SY)) {
													return $elm$html$Html$text('None');
												} else {
													if (_Utils_eq(
														$elm$core$List$length(avaialbleListenedEvents),
														$elm$core$List$length(fields.SY))) {
														return $elm$html$Html$text('All');
													} else {
														var selectedResources = $elm$core$List$sort(
															A2(
																$elm$core$List$filter,
																function (resource) {
																	var selectedResourceEvents = $elm$core$List$sort(
																		A2(
																			$elm$core$List$filter,
																			$elm$core$String$startsWith(resource),
																			fields.SY));
																	var avaialbleResourceEvents = $elm$core$List$sort(
																		A2(
																			$elm$core$List$filter,
																			$elm$core$String$startsWith(resource),
																			avaialbleListenedEvents));
																	return A2($elm_community$list_extra$List$Extra$isSubsequenceOf, avaialbleResourceEvents, selectedResourceEvents);
																},
																$elm_community$list_extra$List$Extra$unique(
																	A2(
																		$elm$core$List$filterMap,
																		$elm$core$List$head,
																		A2(
																			$elm$core$List$map,
																			$elm$core$String$split('.'),
																			avaialbleListenedEvents)))));
														var selectedListenedEvents = $elm$core$List$sort(
															$elm$core$List$concat(
																_List_fromArray(
																	[
																		A2(
																		$elm$core$List$map,
																		function (resource) {
																			return resource + '.*';
																		},
																		selectedResources),
																		A2(
																		$elm_community$list_extra$List$Extra$filterNot,
																		function (listenedEvent) {
																			return A2(
																				$elm$core$List$any,
																				function (resource) {
																					return A2($elm$core$String$startsWith, resource, listenedEvent);
																				},
																				selectedResources);
																		},
																		fields.SY)
																	])));
														return $elm$html$Html$text(
															A2($elm$core$String$join, ', ', selectedListenedEvents));
													}
												}
											}()
											]),
										A3($author$project$Pages$Partner$WebhookEndpoints$listenedEventsOptions, avaialbleListenedEvents, model.yC, fields.SY),
										model.mU)
									]))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Save partner changes'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$loading(
										_Utils_eq(model.o$, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Partner$WebhookEndpoints$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						_List_fromArray(
							[
								$author$project$Pages$Partner$WebhookEndpoints$viewSettings(model)
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Pages$Partner$WebhookEndpoints$ManageGlobalWebhookEndpointsMsg),
							$author$project$Components$Partner$ManageWebhookEndpoints$view(model.mX))),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Pages$Partner$WebhookEndpoints$ManageIntegrationWebhookEndpointsMsg),
							$author$project$Components$Partner$ManageWebhookEndpoints$view(model.mZ)))
					]))
			]),
		$G: 'Partner | Webhook Endpoints'
	};
};
var $author$project$Pages$Partner$WebhookEndpoints$page = $author$project$Spa$Page$applicationPartner(
	{ad0: $author$project$Pages$Partner$WebhookEndpoints$init, aer: $author$project$Pages$Partner$WebhookEndpoints$load, agD: $author$project$Pages$Partner$WebhookEndpoints$save, ahd: $author$project$Pages$Partner$WebhookEndpoints$subscriptions, aaq: $author$project$Pages$Partner$WebhookEndpoints$update, ahP: $author$project$Pages$Partner$WebhookEndpoints$view});
var $author$project$Pages$Patients$Create$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Practice$One$accountType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.H7;
	});
var $author$project$Api$Provider$Practice$One$isMce = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$accountType,
	$elm$core$Basics$eq(2));
var $author$project$Pages$Patients$Create$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A6(
			$author$project$Components$Patient$Form$empty,
			shared.D5,
			session,
			shared.cO,
			$elm$core$Maybe$Nothing,
			false,
			function (settings) {
				return _Utils_update(
					settings,
					{
						abD: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
						abL: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
						P8: $author$project$Api$Provider$Practice$One$hasLocations(practice),
						Qe: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
						aeA: $author$project$Api$Provider$Practice$One$isMce(practice),
						rr: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
						ago: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
						Ym: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
						agp: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
						Yr: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
						Ys: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
						_D: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
						$f: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Network$Shared$syncByAffiliation,
								$author$project$Api$Provider$Practice$One$network(practice))),
						ahB: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
						$$: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
						$1: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
						DF: A3($author$project$Permission$canGoTo, session, shared.adN, 0)
					});
			});
		var form = _v1.a;
		var formCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form, WF: practice, ZD: session, kj: false},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Create$FormMsg, formCmd));
	});
var $author$project$Pages$Patients$Create$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$Create$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$Create$subscriptions = function (_v0) {
	var form = _v0.PB;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Patients$Create$FormMsg,
		$author$project$Components$Patient$Form$subscriptions(form));
};
var $author$project$Pages$Patients$Create$PatientCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Patient$create = F3(
	function (apiClient, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath)));
	});
var $author$project$Components$Patient$Form$encode = F2(
	function (validFields, form) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					A2($author$project$Components$Patient$Form$encodePatient, validFields, form)
				]));
	});
var $author$project$Pages$Patients$Create$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var _v1 = $author$project$Components$Patient$Form$validate(model.PB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var validForm = _v2.a;
					var validFields = _v2.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{kj: true}),
						A3(
							$author$project$Api$Provider$Patient$create,
							model.D5,
							A2($author$project$Components$Patient$Form$encode, validFields, validForm),
							$author$project$Pages$Patients$Create$PatientCreated),
						_List_Nil);
				} else {
					var erroredForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 0:
				var formMsg = msg.a;
				var _v3 = A5($author$project$Components$Patient$Form$update, model.D5, model.ZD, $elm$core$Maybe$Nothing, formMsg, model.PB);
				var form = _v3.a;
				var formCmd = _v3.b;
				var formOutMsgs = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: form}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Create$FormMsg, formCmd),
					formOutMsgs);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var patient = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
											{
												VN: $author$project$Api$Provider$Patient$One$id(patient)
											})),
										A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Pages$Patients$Create$FormMsg,
										A5(
											$author$project$Components$Patient$Form$createAffiliation,
											model.D5,
											model.ZD,
											$author$project$Api$Provider$Patient$One$id(patient),
											$elm$core$Maybe$Nothing,
											model.PB).EC)
									])),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
		}
	});
var $author$project$Pages$Patients$Create$FormSubmitted = {$: 1};
var $author$project$Pages$Patients$Create$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('md:ml-8')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$noValidate(true),
								$author$project$Ui$Form$autocomplete(false),
								$author$project$Ui$Form$horizontal,
								$author$project$Ui$Form$onSubmit($author$project$Pages$Patients$Create$FormSubmitted)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$heading,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Panel$title(
												_List_fromArray(
													[
														$elm$html$Html$text('Create New Patient')
													]))
											])),
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Pages$Patients$Create$FormMsg),
											$author$project$Components$Patient$Form$view(model.PB))),
										A2(
										$author$project$Ui$Panel$footer,
										_List_fromArray(
											[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__Top,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													])),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Create new patient'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$submit,
														$author$project$Ui$Button$loading(model.kj)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Create')
													]))
											]))
									]))
							]))
					]))
			]),
		$G: 'Patients'
	};
};
var $author$project$Pages$Patients$Create$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Patients$Create$init, aer: $author$project$Pages$Patients$Create$load, agD: $author$project$Pages$Patients$Create$save, ahd: $author$project$Pages$Patients$Create$subscriptions, aaq: $author$project$Pages$Patients$Create$update, ahP: $author$project$Pages$Patients$Create$view});
var $author$project$OutMsg$InitializePatientsList = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Page$applicationPatient = function (page) {
	return {
		ad0: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple3(shared.ZD, shared.WF, shared.Mw);
				_v0$5:
				while (true) {
					_v0$6:
					while (true) {
						_v0$7:
						while (true) {
							switch (_v0.a.$) {
								case 3:
									switch (_v0.b.$) {
										case 3:
											if (!_v0.b.a.$) {
												switch (_v0.c.$) {
													case 0:
														var _v1 = _v0.a;
														var _v2 = _v0.b;
														var _v3 = _v0.c;
														return _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoading(url),
															$elm$core$Platform$Cmd$none,
															_List_fromArray(
																[
																	$author$project$OutMsg$RetrievePatient(url.Vx.VN),
																	$author$project$OutMsg$InitializePatientsList(url.Bi)
																]));
													case 3:
														var _v4 = _v0.a;
														var session = _v4.a;
														var _v5 = _v0.b;
														var practice = _v5.a.a;
														var _v6 = _v0.c;
														var patient = _v6.a;
														return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) ? _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoading(url),
															A2(
																$author$project$Utils$Route$navigate,
																$elm$core$Dict$empty,
																A2($author$project$Permission$homeStateFor, session, shared.adN)),
															_List_Nil) : ((!_Utils_eq(
															url.Vx.VN,
															$author$project$Api$Provider$Patient$One$id(patient))) ? _Utils_Tuple3(
															$author$project$Spa$Page$SessionLoading(url),
															$elm$core$Platform$Cmd$none,
															_List_fromArray(
																[
																	$author$project$OutMsg$RetrievePatient(url.Vx.VN),
																	$author$project$OutMsg$InitializePatientsList(url.Bi)
																])) : A2(
															$author$project$Utils$Tuple3$mapFirst,
															$author$project$Spa$Page$SessionLoaded,
															A2(
																$author$project$Utils$Tuple3$fromTuple2,
																_List_Nil,
																A5(page.ad0, session, practice, patient, shared, url))));
													case 2:
														break _v0$6;
													default:
														break _v0$7;
												}
											} else {
												var _v7 = _v0.a;
												var session = _v7.a;
												var _v8 = _v0.b;
												return _Utils_Tuple3(
													$author$project$Spa$Page$SessionLoading(url),
													A2(
														$author$project$Utils$Route$navigate,
														$elm$core$Dict$empty,
														A2($author$project$Permission$homeStateFor, session, shared.adN)),
													_List_Nil);
											}
										case 2:
											break _v0$5;
										default:
											if (_v0.c.$ === 2) {
												break _v0$6;
											} else {
												break _v0$7;
											}
									}
								case 2:
									return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
								case 0:
									var _v9 = _v0.a;
									return _Utils_Tuple3(
										$author$project$Spa$Page$SessionLoading(url),
										$author$project$Ports$Session$authorize(
											{af6: true}),
										_List_Nil);
								default:
									if (_v0.b.$ === 2) {
										break _v0$5;
									} else {
										if (_v0.c.$ === 2) {
											break _v0$6;
										} else {
											break _v0$7;
										}
									}
							}
						}
						return _Utils_Tuple3(
							$author$project$Spa$Page$SessionLoading(url),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
					return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aer: F2(
			function (shared, model) {
				var _v10 = _Utils_Tuple3(shared.ZD, shared.WF, shared.Mw);
				_v10$4:
				while (true) {
					_v10$5:
					while (true) {
						switch (_v10.a.$) {
							case 3:
								switch (_v10.b.$) {
									case 3:
										if (!_v10.b.a.$) {
											switch (_v10.c.$) {
												case 0:
													var _v11 = _v10.a;
													var _v12 = _v10.b;
													var _v13 = _v10.c;
													if (!model.$) {
														var url = model.a;
														var _v15 = url;
														var params = _v15.Vx;
														var query = _v15.Bi;
														return _Utils_Tuple3(
															model,
															$elm$core$Platform$Cmd$none,
															_List_fromArray(
																[
																	$author$project$OutMsg$RetrievePatient(params.VN),
																	$author$project$OutMsg$InitializePatientsList(query)
																]));
													} else {
														return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
													}
												case 3:
													var _v16 = _v10.a;
													var session = _v16.a;
													var _v17 = _v10.b;
													var practice = _v17.a.a;
													var _v18 = _v10.c;
													var patient = _v18.a;
													switch (model.$) {
														case 0:
															var url = model.a;
															if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) {
																return _Utils_Tuple3(
																	$author$project$Spa$Page$SessionLoading(url),
																	A2(
																		$author$project$Utils$Route$navigate,
																		$elm$core$Dict$empty,
																		A2($author$project$Permission$homeStateFor, session, shared.adN)),
																	_List_Nil);
															} else {
																var _v20 = A5(page.ad0, session, practice, patient, shared, url);
																var pageModel = _v20.a;
																var cmd = _v20.b;
																return _Utils_Tuple3(
																	$author$project$Spa$Page$SessionLoaded(pageModel),
																	cmd,
																	_List_Nil);
															}
														case 1:
															var modelWithSession = model.a;
															return A2(
																$author$project$Utils$Tuple3$fromTuple2,
																_List_Nil,
																A2(
																	$elm$core$Tuple$mapFirst,
																	$author$project$Spa$Page$SessionLoaded,
																	A2(
																		page.aer,
																		shared,
																		_Utils_update(
																			modelWithSession,
																			{D5: shared.D5}))));
														default:
															return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
													}
												default:
													break _v10$5;
											}
										} else {
											var _v21 = _v10.a;
											var session = _v21.a;
											var _v22 = _v10.b;
											return _Utils_Tuple3(
												model,
												A2(
													$author$project$Utils$Route$navigate,
													$elm$core$Dict$empty,
													A2($author$project$Permission$homeStateFor, session, shared.adN)),
												_List_Nil);
										}
									case 2:
										break _v10$4;
									default:
										break _v10$5;
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								if (_v10.b.$ === 2) {
									break _v10$4;
								} else {
									break _v10$5;
								}
						}
					}
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		agD: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.agD, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		ahd: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahd(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		aaq: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.aaq, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		ahP: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahP(modelWithSession);
			} else {
				return {e5: $author$project$Components$BlankPage$view, $G: 'Loading...'};
			}
		}
	};
};
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$PaymentSourcesMsg = $elm$core$Basics$identity;
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$init = F5(
	function (session, practice, patient, shared, _v0) {
		var _v1 = A4(
			$author$project$Components$PaymentSources$init,
			$author$project$Components$PaymentSources$Patient(patient),
			session,
			$author$project$Api$Practice$Provider(practice),
			shared);
		var paymentSources = _v1.a;
		var paymentSourcesCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, VM: patient, gi: paymentSources, WF: practice, ZD: session},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSourcesCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$load = F2(
	function (shared, model) {
		var _v0 = shared.WF;
		if ((_v0.$ === 3) && (!_v0.a.$)) {
			var practice = _v0.a.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						gi: A2(
							$author$project$Components$PaymentSources$setPractice,
							$author$project$Api$Practice$Provider(practice),
							model.gi),
						WF: practice
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$PaymentSources$subscriptions(model.gi));
};
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$PaymentSources$update, model.D5, subMsg, model.gi);
		var paymentSources = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{gi: paymentSources}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$PaymentSources$view(model.gi)),
		$G: 'Patient | Payment Methods'
	};
};
var $author$project$Pages$Patients$PatientId_String$Accounts$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Accounts$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Accounts$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Accounts$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Accounts$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Accounts$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Accounts$Top$view});
var $author$project$Api$Provider$SyncDetail$AdditionalDetails = 0;
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$GotAffiliateSyncDetail = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$SyncDetail$Affiliate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$SyncDetail$Record = function (enrollmentStatus) {
	return function (syncStatus) {
		return function (completedAt) {
			return function (startedAt) {
				return function (errorMessage) {
					return function (coveragePlan) {
						return function (coverageType) {
							return function (enrollmentDate) {
								return function (memberType) {
									return function (terminationDate) {
										return function (companyName) {
											return function (membership) {
												return function (plan) {
													return {Lw: companyName, LB: completedAt, L5: coveragePlan, L8: coverageType, OG: enrollmentDate, OI: enrollmentStatus, ON: errorMessage, TB: memberType, ja: membership, GH: plan, _H: startedAt, $i: syncStatus, $y: terminationDate};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Patient$SyncDetail$recordDecoder = A3(
	$author$project$Api$Expandable$expandable,
	'plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder),
	A3(
		$author$project$Api$Expandable$expandable,
		'membership',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Membership$Min$decoder),
		A3(
			$author$project$Api$Expandable$expandable,
			'company_name',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$author$project$Api$Expandable$expandable,
				'termination_date',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$author$project$Api$Expandable$expandable,
					'member_type',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$author$project$Api$Expandable$expandable,
						'enrollment_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$author$project$Api$Expandable$expandable,
							'coverage_type',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$author$project$Api$Expandable$expandable,
								'coverage_plan',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'error_message',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'started_at',
										$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'completed_at',
											$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'sync_status',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'enrollment_status',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Record))))))))))))));
var $author$project$Api$Provider$Patient$SyncDetail$affiliateDecoder = $elm$json$Json$Decode$nullable(
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$SyncDetail$recordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['network', 'name']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Affiliate))));
var $author$project$Api$Provider$SyncDetail$expandToString = function (expand) {
	if (!expand) {
		return 'additional_details';
	} else {
		return 'coverage_plan';
	}
};
var $author$project$Api$Provider$SyncDetail$listDefaults = {Fc: _List_Nil};
var $author$project$Api$Provider$SyncDetail$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$SyncDetail$listDefaults);
	return A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$SyncDetail$expandToString, options.Fc);
};
var $author$project$Api$Provider$SyncDetail$retrieveAffiliate = F4(
	function (apiClient, patientId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$SyncDetail$affiliateDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$SyncDetail$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['sync_details', 'affiliate']),
						$author$project$Api$Provider$Patient$patientPath(patientId)))));
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$init = F5(
	function (_v0, practice, patient, shared, _v1) {
		return _Utils_Tuple2(
			{u7: $author$project$Api$Data$Loading, D5: shared.D5, VM: patient, WF: practice, Hy: shared.Hy},
			A4(
				$author$project$Api$Provider$SyncDetail$retrieveAffiliate,
				shared.D5,
				$author$project$Api$Provider$Patient$One$id(patient),
				function (d) {
					return _Utils_update(
						d,
						{
							Fc: _List_fromArray(
								[0])
						});
				},
				$elm$core$Basics$identity));
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$update = F2(
	function (msg, model) {
		var data = msg;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{u7: data}),
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Api$Provider$Patient$SyncDetail$record_ = function (detail) {
	if (!detail.$) {
		var r = detail.b;
		return r;
	} else {
		var r = detail.b;
		return r;
	}
};
var $author$project$Api$Provider$Patient$SyncDetail$companyName = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.Lw;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageSponsor = function (syncDetails) {
	var companyName = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return A2(
				$author$project$Api$Expandable$withDefault,
				$elm$core$Maybe$Nothing,
				$author$project$Api$Provider$Patient$SyncDetail$companyName(details));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	if (!companyName.$) {
		var name = companyName.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Coverage Sponsor'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$Patient$SyncDetail$coverageType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.L8;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageType = function (syncDetails) {
	var coverageType = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2(
						$author$project$Api$Expandable$withDefault,
						$elm$core$Maybe$Nothing,
						$author$project$Api$Provider$Patient$SyncDetail$coverageType(details))));
		} else {
			return $elm$html$Html$text('N/A');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Coverage Type'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[coverageType]))
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$terminationDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.$y;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewEndDate = function (syncDetails) {
	var endDate = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'-',
					A2(
						$elm$core$Maybe$map,
						$justinmimbs$date$Date$format('MM/dd/yyyy'),
						A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Patient$SyncDetail$terminationDate(details)))));
		} else {
			return $elm$html$Html$text('-');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('End Date'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[endDate]))
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$completedAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.LB;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewLastSyncDate = F2(
	function (syncDetails, timeFormatter) {
		var lastSyncDate = function () {
			if (!syncDetails.$) {
				var details = syncDetails.a;
				return $elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'-',
						A2(
							$elm$core$Maybe$map,
							timeFormatter(5),
							$author$project$Api$Provider$Patient$SyncDetail$completedAt(details))));
			} else {
				return $elm$html$Html$text('-');
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Last Sync Date'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[lastSyncDate]))
				]));
	});
var $author$project$Api$Provider$Patient$SyncDetail$memberType = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.TB;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewMemberType = function (syncDetails) {
	var memberType = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2(
						$author$project$Api$Expandable$withDefault,
						$elm$core$Maybe$Nothing,
						$author$project$Api$Provider$Patient$SyncDetail$memberType(details))));
		} else {
			return $elm$html$Html$text('N/A');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Member Type'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[memberType]))
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$membership = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.ja;
	});
var $author$project$Api$Provider$Membership$Min$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewNetworkPaymentStatus = function (syncDetails) {
	var paymentStatus = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Membership$Min$status,
				A2(
					$author$project$Api$Expandable$withDefault,
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Patient$SyncDetail$membership(details)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var coverageType = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return A2(
				$author$project$Api$Expandable$withDefault,
				$elm$core$Maybe$Nothing,
				$author$project$Api$Provider$Patient$SyncDetail$coverageType(details));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var _v0 = _Utils_Tuple2(
		paymentStatus,
		!_Utils_eq(
			coverageType,
			$elm$core$Maybe$Just('Employer')));
	if ((!_v0.a.$) && _v0.b) {
		var status = _v0.a.a;
		var statuses = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('active', 'paid'),
					_Utils_Tuple2('unpaid', 'unpaid')
				]));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Network Payment Status'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Dict$get, status, statuses)))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSkeleton = A2(
	$elm$html$Html$div,
	_List_Nil,
	A2(
		$elm$core$List$map,
		function (label) {
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSkeleton(label),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(4),
										$author$project$Ui$Skeleton$spanMd(3)
									]))
							]))
					]));
		},
		_List_fromArray(
			['Coverage Type', 'Member Type', 'Sponsor Membership Plan', 'Start date', 'End Date', 'Last sync date'])));
var $author$project$Api$Provider$Patient$SyncDetail$plan = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.GH;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSponsorMembershipPlan = function (syncDetails) {
	var plan = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Plan$Min$name,
						A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Patient$SyncDetail$plan(details)))));
		} else {
			return $elm$html$Html$text('N/A');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Sponsor Membership Plan'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[plan]))
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$enrollmentDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.OG;
	});
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewStartDate = function (syncDetails) {
	var startDate = function () {
		if (!syncDetails.$) {
			var details = syncDetails.a;
			return $elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'-',
					A2(
						$elm$core$Maybe$map,
						$justinmimbs$date$Date$format('MM/dd/yyyy'),
						A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Patient$SyncDetail$enrollmentDate(details)))));
		} else {
			return $elm$html$Html$text('-');
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Start Date'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[startDate]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$view = function (_v0) {
	var affiliateSyncDetails = _v0.u7;
	var timeFormatter = _v0.Hy;
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Affiliation')
									])),
								function () {
								switch (affiliateSyncDetails.$) {
									case 3:
										var syncDetails = affiliateSyncDetails.a;
										return A2(
											$author$project$Ui$Form$view,
											_List_fromArray(
												[$author$project$Ui$Form$horizontal]),
											_List_fromArray(
												[
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageType(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageSponsor(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewMemberType(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSponsorMembershipPlan(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewStartDate(syncDetails),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewEndDate(syncDetails),
													A2($author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewLastSyncDate, syncDetails, timeFormatter),
													$author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewNetworkPaymentStatus(syncDetails)
												]));
									case 1:
										return $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSkeleton;
									default:
										return $author$project$Utils$Html$empty;
								}
							}()
							]))
					]))
			]),
		$G: 'Patient | Affiliations'
	};
};
var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$view});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$PatientDocument$One$PatientDocument = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$PatientDocument$Shared$PatientDocument = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientDocument$Shared$Record = F8(
	function (id, agreementId, name, status, signedAt, signedFrom, signature, hasSignedDocument) {
		return {IM: agreementId, Qh: hasSignedDocument, adR: id, zh: name, Z_: signature, Z$: signedAt, Z2: signedFrom, ag7: status};
	});
var $author$project$Api$Provider$PatientDocument$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'has_signed_document',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'signature',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'signed_from',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'signed_at',
				$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'agreement_id',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'document_id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$Shared$Record)))))))));
var $author$project$Api$Provider$PatientDocument$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientDocument$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientDocument$One$Record = F4(
	function (currentDocumentVersion, signedDocumentVersion, requestDetail, signedByName) {
		return {aci: currentDocumentVersion, Yg: requestDetail, Z0: signedByName, Z1: signedDocumentVersion};
	});
var $author$project$Api$Provider$PatientDocument$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'signed_by_name',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'request_detail',
		$elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'signed_document_version',
			$elm$json$Json$Decode$maybe($author$project$Api$Provider$DocumentVersion$Shared$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'current_document_version',
				$author$project$Api$Provider$DocumentVersion$Shared$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$One$Record)))));
var $author$project$Api$Provider$PatientDocument$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientDocument$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$PatientDocument$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$One$PatientDocument)));
var $author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['patient_documents']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath = F2(
	function (patientId, documentId) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[documentId]),
			$author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId));
	});
var $author$project$Api$Provider$Patient$PatientDocument$retrieve = F4(
	function (apiClient, id_, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PatientDocument$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$init = F5(
	function (_v0, practice, patient, shared, _v1) {
		var params = _v1.Vx;
		return _Utils_Tuple2(
			{eZ: $author$project$Api$Data$Loading, dr: $elm$core$Maybe$Nothing, D5: shared.D5, p1: true, rM: true, z$: $author$project$Api$Data$NotAsked, VM: patient, WF: practice, Cl: $author$project$Api$Data$NotAsked, Hy: shared.Hy},
			A4($author$project$Api$Provider$Patient$PatientDocument$retrieve, shared.D5, params.IM, params.VN, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed = {$: 0};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$subscriptions = function (model) {
	return model.U9 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2($elm$core$Maybe$map, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$subscriptions, model.dr)));
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotUploadedSignedDocument = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$PatientDocument$One$currentDocumentVersion = function (_v0) {
	var record = _v0.b;
	return record.aci;
};
var $author$project$Api$Provider$PatientDocument$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PatientDocument$One$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$id(shared);
};
var $author$project$Api$Provider$PatientDocument$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$PatientDocument$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$status(shared);
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementAccepted = function (agreement) {
	var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
	switch (_v0) {
		case 'accepted':
			return true;
		case 'accepted_and_outdated':
			return true;
		case 'not_accepted':
			return false;
		default:
			return false;
	}
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel = F4(
	function (practice, patient, agreement, open_) {
		return _Utils_Tuple2(
			{
				HZ: $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementAccepted(agreement),
				eZ: agreement,
				qG: 0,
				Po: $elm$core$Maybe$Nothing,
				cW: false,
				U9: open_,
				VM: patient,
				WF: practice
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$init = F4(
	function (practice, patient, agreement, open_) {
		return A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, practice, patient, agreement, open_);
	});
var $author$project$Api$Provider$PatientDocument$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$PatientDocument$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$name(shared);
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$open = function (model) {
	return _Utils_update(
		model,
		{U9: true});
};
var $author$project$Api$Provider$Patient$PatientDocument$signedDocument = F4(
	function (apiClient, id_, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['uri']),
				$elm$json$Json$Decode$string),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['signed_document']),
					A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_))));
	});
var $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion = function (_v0) {
	var record = _v0.b;
	return record.Z1;
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$File = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateFailed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateSucceeded = {$: 1};
var $author$project$Api$Provider$Patient$PatientDocument$acceptDocument = F5(
	function (apiClient, id_, patientId, fileUrl, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'signed_document',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fileUrl))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PatientDocument$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['accept']),
						A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)))));
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$acceptAgreement = F5(
	function (token, documentId, patientId, fileUrl, agreement) {
		return A5($author$project$Api$Provider$Patient$PatientDocument$acceptDocument, token, documentId, patientId, fileUrl, agreement);
	});
var $author$project$Api$Provider$PatientDocument$Shared$agreementId = function (_v0) {
	var record = _v0;
	return record.IM;
};
var $author$project$Api$Provider$PatientDocument$One$agreementId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$agreementId(shared);
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate = function (agreement) {
	var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
	if (_v0 === 'accepted_and_outdated') {
		return true;
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Patient$PatientDocument$removeDocumentAcceptance = F5(
	function (apiClient, id_, patientId, agreementId_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'document_agreement_id',
					$elm$json$Json$Encode$string(agreementId_))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PatientDocument$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['remove_acceptance']),
						A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)))));
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$removeAcceptance = F5(
	function (token, documentId, patientId, agreementId, agreement) {
		return A5($author$project$Api$Provider$Patient$PatientDocument$removeDocumentAcceptance, token, documentId, patientId, agreementId, agreement);
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				var response = msg.a;
				switch (response.$) {
					case 2:
						var error = response.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $elm$core$Maybe$Just(
								$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateFailed(error)),
							y8: _Utils_update(
								model,
								{cW: false})
						};
					case 3:
						var agreement = response.a;
						var _v2 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, model.WF, model.VM, agreement, false);
						var newModel = _v2.a;
						var cmd = _v2.b;
						return {
							EC: cmd,
							ac5: $elm$core$Maybe$Just($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateSucceeded),
							y8: _Utils_update(
								newModel,
								{cW: false})
						};
					default:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $elm$core$Maybe$Nothing,
							y8: _Utils_update(
								model,
								{cW: false})
						};
				}
			case 0:
				var _v3 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, model.WF, model.VM, model.eZ, false);
				var newModel = _v3.a;
				var cmd = _v3.b;
				return {
					EC: cmd,
					ac5: $elm$core$Maybe$Nothing,
					y8: _Utils_update(
						newModel,
						{cW: false})
				};
			case 3:
				var _int = msg.a;
				var string = msg.b;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $elm$core$Maybe$Nothing,
					y8: _Utils_update(
						model,
						{
							qG: _int,
							Po: $elm$core$Maybe$Just(string)
						})
				};
			case 4:
				var files = msg.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (_v4) {
							var task = _v4.a;
							var size = _v4.b;
							return A2(
								$elm$core$Task$perform,
								$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$File(size),
								task);
						},
						A2(
							$elm$core$Maybe$map,
							function (file) {
								return _Utils_Tuple2(
									$elm$file$File$toUrl(file),
									$elm$file$File$size(file));
							},
							$elm$core$List$head(files))));
				return {EC: cmd, ac5: $elm$core$Maybe$Nothing, y8: model};
			default:
				var patientId = $author$project$Api$Provider$Patient$One$id(model.VM);
				var outOfDate = $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate(model.eZ);
				var documentId = $author$project$Api$Provider$PatientDocument$One$id(model.eZ);
				var cmd = function () {
					if (model.HZ && (!outOfDate)) {
						var agreementId = function () {
							var _v5 = $author$project$Api$Provider$PatientDocument$One$agreementId(model.eZ);
							if (!_v5.$) {
								var id = _v5.a;
								return id;
							} else {
								return '';
							}
						}();
						return A5($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$removeAcceptance, apiClient, documentId, patientId, agreementId, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement);
					} else {
						return A5($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$acceptAgreement, apiClient, documentId, patientId, model.Po, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement);
					}
				}();
				return {
					EC: cmd,
					ac5: $elm$core$Maybe$Nothing,
					y8: _Utils_update(
						model,
						{cW: true})
				};
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				switch (response.$) {
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eZ: response}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					case 3:
						var agreement = response.a;
						var outdatedFileCmd = function () {
							var _v2 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
							if (_v2 === 'accepted_and_outdated') {
								var _v3 = $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion(agreement);
								if (_v3.$ === 1) {
									return $elm$core$Platform$Cmd$none;
								} else {
									var outdatedDoc = _v3.a;
									return A4(
										$author$project$Api$Provider$DocumentVersion$signedFileUrl,
										model.D5,
										$author$project$Api$Provider$PatientDocument$One$id(agreement),
										$author$project$Api$Provider$DocumentVersion$Shared$id(outdatedDoc),
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl(false));
								}
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}();
						var currentFileCmd = A4(
							$author$project$Api$Provider$DocumentVersion$signedFileUrl,
							model.D5,
							$author$project$Api$Provider$PatientDocument$One$id(agreement),
							$author$project$Api$Provider$DocumentVersion$Shared$id(
								$author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement)),
							$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl(true));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eZ: response}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[currentFileCmd, outdatedFileCmd])),
							_List_Nil);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{eZ: response}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{p1: !model.p1}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rM: !model.rM}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var isCurrent = msg.a;
				var response = msg.b;
				var newModel = isCurrent ? _Utils_update(
					model,
					{Cl: response}) : _Utils_update(
					model,
					{z$: response});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$none,
					function () {
						if (response.$ === 2) {
							var error = response.a;
							return _List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]);
						} else {
							return _List_Nil;
						}
					}());
			case 2:
				var agreement = msg.a;
				var _v5 = model.dr;
				if (_v5.$ === 1) {
					var _v6 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$init, model.WF, model.VM, agreement, true);
					var modal = _v6.a;
					var cmd = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dr: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg, cmd),
						_List_Nil);
				} else {
					var modal = _v5.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dr: $elm$core$Maybe$Just(
									$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$open(modal))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var modalMsg = msg.a;
				var _v7 = model.dr;
				if (!_v7.$) {
					var modal = _v7.a;
					var result = A3($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$update, model.D5, modalMsg, modal);
					var _v8 = function () {
						var _v9 = result.ac5;
						if (!_v9.$) {
							if (!_v9.a.$) {
								var error = _v9.a.a;
								return _Utils_Tuple2(
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A2(
											$author$project$OutMsg$ShowToast,
											1,
											$author$project$Ui$Toast$serverError(error))
										]));
							} else {
								var _v10 = _v9.a;
								var successText = $author$project$Api$Provider$PatientDocument$One$name(modal.eZ) + ' marked as accepted';
								return _Utils_Tuple2(
									A4(
										$author$project$Api$Provider$Patient$PatientDocument$retrieve,
										model.D5,
										$author$project$Api$Provider$PatientDocument$One$id(modal.eZ),
										$author$project$Api$Provider$Patient$One$id(modal.VM),
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement),
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, successText)
										]));
							}
						} else {
							return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
						}
					}();
					var command = _v8.a;
					var outMsg = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								dr: $elm$core$Maybe$Just(result.y8)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg, result.EC),
									command
								])),
						outMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var id = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$Patient$PatientDocument$signedDocument,
						model.D5,
						id,
						$author$project$Api$Provider$Patient$One$id(model.VM),
						$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotUploadedSignedDocument),
					_List_Nil);
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Navigation$openInNewWindow(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Data$toMaybe(response))),
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted = {$: 2};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$FileUploaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$viewFileUploader = function (model) {
	var maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
	var fileSizeError = (_Utils_cmp(model.qG, maxFileBytesSize) > 0) ? 'That file is too large! Our maximum file size is 5 mb.' : '';
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('border-light')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$File$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$File$accept(2),
						$author$project$Ui$Form$File$onInput($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$FileUploaded)
					])),
				$author$project$Utils$FormErrors$viewError(fileSizeError)
			]));
};
var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$view = function (model) {
	if (model.U9) {
		var patientName = $author$project$Api$Provider$Patient$One$name(model.VM);
		var outOfDate = $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate(model.eZ);
		var buttonText = function () {
			if (model.HZ && (!outOfDate)) {
				return 'Confirm';
			} else {
				var _v0 = model.qG;
				if (!_v0) {
					return 'Confirm without Uploading';
				} else {
					return 'Confirm';
				}
			}
		}();
		var footer = _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Confirm'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(model.cW),
						$author$project$Ui$Button$onClick($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonText)
					]))
			]);
		var agreementName = $author$project$Api$Provider$PatientDocument$One$name(model.eZ);
		var bodyText = (model.HZ && (!outOfDate)) ? ('Are you sure you want to remove the acceptance of the ' + (agreementName + (' for ' + (patientName + '?')))) : ('Do you have a signed copy from ' + (patientName + (' of the ' + (agreementName + '?'))));
		var body = (model.HZ && (!outOfDate)) ? A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted),
					$author$project$Ui$Form$horizontal
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-075')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(bodyText)
						]))
				])) : A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted),
					$author$project$Ui$Form$horizontal
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mb-075')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(bodyText)
						])),
					$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$viewFileUploader(model)
				]));
		var titleText = (model.HZ && (!outOfDate)) ? ('Remove ' + agreementName) : ('Accept ' + agreementName);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title(titleText)
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[body])),
					$author$project$Ui$Modal$footer(footer)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreementAcceptanceModal = function (model) {
	var _v0 = model.dr;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg,
			$author$project$Components$Patient$Agreements$AgreementAcceptanceModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Button$GreyLink = 8;
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible = {$: 1};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleOutdatedAgreementVisible = {$: 4};
var $author$project$Api$Provider$DocumentVersion$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewFromUrl = F2(
	function (patientDocumentName, signedFileUrl) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Api$Data$toMaybe(signedFileUrl);
					if (!_v0.$) {
						var url_ = _v0.a;
						var pdfUrl = 'https://docs.google.com/gview?url=' + ($elm$url$Url$percentEncode(url_) + '&embedded=true');
						return A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('embed-responsive embed-responsive-full')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$iframe,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(pdfUrl),
													$elm$html$Html$Attributes$title(patientDocumentName),
													A2(
													$elm$html$Html$Attributes$property,
													'frameborder',
													$elm$json$Json$Encode$string('0')),
													A2(
													$elm$html$Html$Attributes$property,
													'allowfullscreen',
													$elm$json$Json$Encode$string('false')),
													$elm$html$Html$Attributes$class('embed-responsive-item ng-scope')
												]),
											_List_Nil)
										]))
								]));
					} else {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$card(_List_Nil)
								]));
					}
				}()
				]));
	});
var $author$project$Ui$Well$Clearfix = {$: 2};
var $author$project$Ui$Well$clearfix = $author$project$Ui$Well$Clearfix;
var $author$project$Api$Provider$PatientDocument$Shared$hasSignedDocument = function (_v0) {
	var record = _v0;
	return record.Qh;
};
var $author$project$Api$Provider$PatientDocument$One$hasSignedDocument = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$hasSignedDocument(shared);
};
var $author$project$Api$Provider$PatientDocument$One$requestDetail = function (_v0) {
	var record = _v0.b;
	return record.Yg;
};
var $author$project$Api$Provider$PatientDocument$Shared$signature = function (_v0) {
	var record = _v0;
	return record.Z_;
};
var $author$project$Api$Provider$PatientDocument$One$signature = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$signature(shared);
};
var $author$project$Api$Provider$PatientDocument$Shared$signedAt = function (_v0) {
	var record = _v0;
	return record.Z$;
};
var $author$project$Api$Provider$PatientDocument$One$signedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$signedAt(shared);
};
var $author$project$Api$Provider$PatientDocument$One$signedByName = function (_v0) {
	var record = _v0.b;
	return record.Z0;
};
var $author$project$Api$Provider$PatientDocument$Shared$signedFrom = function (_v0) {
	var record = _v0;
	return record.Z2;
};
var $author$project$Api$Provider$PatientDocument$One$signedFrom = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$PatientDocument$Shared$signedFrom(shared);
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel = F2(
	function (atOrBy, signedFrom) {
		return ((signedFrom === 'provider_portal') ? 'Marked as accepted' : 'Accepted') + (' ' + atOrBy);
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAcceptedBySection = F2(
	function (maybeSignedFrom, maybeSignedByName) {
		var label = A2(
			$elm$core$Maybe$map,
			$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel('by'),
			maybeSignedFrom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					A2($elm$core$Maybe$withDefault, '', label)),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', maybeSignedByName))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAceeptedAtSection = F3(
	function (timeFormatter, maybeSignedFrom, maybeSignedAt) {
		var signedAt = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				timeFormatter(2),
				maybeSignedAt));
		var label = A2(
			$elm$core$Maybe$map,
			$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel('at'),
			maybeSignedFrom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					A2($elm$core$Maybe$withDefault, '', label)),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(signedAt)
								]))
						]))
				]));
	});
var $author$project$Api$Common$RequestDetail$Shared$clientName = function (_v0) {
	var record = _v0;
	return record.K2;
};
var $author$project$Api$Common$RequestDetail$Shared$deviceBrand = function (_v0) {
	var record = _v0;
	return record.ND;
};
var $author$project$Api$Common$RequestDetail$Shared$deviceName = function (_v0) {
	var record = _v0;
	return record.NE;
};
var $author$project$Api$Common$RequestDetail$Shared$deviceType = function (_v0) {
	var record = _v0;
	return record.NF;
};
var $author$project$Api$Common$RequestDetail$Shared$osName = function (_v0) {
	var record = _v0;
	return record.Vj;
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewDetailsSection = F2(
	function (maybeSignedFrom, maybeRequestDetails) {
		if (maybeRequestDetails.$ === 1) {
			return $author$project$Utils$Html$empty;
		} else {
			var requestDetails = maybeRequestDetails.a;
			var _v1 = _Utils_Tuple2(
				$author$project$Api$Common$RequestDetail$Shared$clientName(requestDetails),
				maybeSignedFrom);
			if (_v1.a.$ === 1) {
				var _v2 = _v1.a;
				return $author$project$Utils$Html$empty;
			} else {
				if (_v1.b.$ === 1) {
					var _v3 = _v1.b;
					return $author$project$Utils$Html$empty;
				} else {
					var clientName = _v1.a.a;
					var signedFrom = _v1.b.a;
					return (signedFrom === 'provider_portal') ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Details'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										function () {
											var _v4 = $author$project$Api$Common$RequestDetail$Shared$deviceType(requestDetails);
											if (_v4.$ === 1) {
												return _List_Nil;
											} else {
												var deviceType = _v4.a;
												return (deviceType === 'desktop') ? _List_fromArray(
													[
														$elm$html$Html$text(
														'Using ' + (clientName + (' on ' + (A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$RequestDetail$Shared$osName(requestDetails)) + ' Desktop'))))
													]) : _List_fromArray(
													[
														$elm$html$Html$text(
														'Using ' + (clientName + (' on ' + (A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$RequestDetail$Shared$deviceBrand(requestDetails)) + (' ' + A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$RequestDetail$Shared$deviceName(requestDetails)))))))
													]);
											}
										}())
									]))
							]));
				}
			}
		}
	});
var $author$project$Api$Common$RequestDetail$Shared$ip = function (_v0) {
	var record = _v0;
	return record.Rt;
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewIpSection = F2(
	function (maybeSignedFrom, maybeRequestDetails) {
		if (maybeRequestDetails.$ === 1) {
			return $author$project$Utils$Html$empty;
		} else {
			var requestDetails = maybeRequestDetails.a;
			var _v1 = _Utils_Tuple2(
				$author$project$Api$Common$RequestDetail$Shared$ip(requestDetails),
				maybeSignedFrom);
			if (_v1.a.$ === 1) {
				var _v2 = _v1.a;
				return $author$project$Utils$Html$empty;
			} else {
				if (_v1.b.$ === 1) {
					var _v3 = _v1.b;
					return $author$project$Utils$Html$empty;
				} else {
					var ip = _v1.a.a;
					var signedFrom = _v1.b.a;
					return (signedFrom === 'provider_portal') ? $author$project$Utils$Html$empty : A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('IP Address'),
								$author$project$Ui$Form$Group$labelSpanSm(4),
								$author$project$Ui$Form$Group$inputSpanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(ip)
											]))
									]))
							]));
				}
			}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedHeaderSection = F2(
	function (viaSectionText, notSignedElectronically) {
		return notSignedElectronically ? A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Signed electronically '),
					A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(viaSectionText)
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenFileDocument = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewUploadedDocumentSection = F3(
	function (id, maybeSignedFrom, hasSignedDocument) {
		if (!maybeSignedFrom.$) {
			var signedFrom = maybeSignedFrom.a;
			return ((signedFrom === 'provider_portal') && hasSignedDocument) ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'View uploaded document'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenFileDocument(id))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('View uploaded document')
									]))
							]))
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedAgreementDetails = F3(
	function (timeFormatter, showSignatureDetails, agreement) {
		if (($author$project$Api$Provider$PatientDocument$One$status(agreement) === 'not_accepted') || (!showSignatureDetails)) {
			return $author$project$Utils$Html$empty;
		} else {
			var maybeSignedFrom = $author$project$Api$Provider$PatientDocument$One$signedFrom(agreement);
			var notSignedElectronically = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (signedFrom) {
						return (signedFrom !== 'provider_portal') && (signedFrom !== 'public_api');
					},
					maybeSignedFrom));
			var viaSectionText = function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Api$Provider$PatientDocument$One$signature(agreement),
					maybeSignedFrom);
				if (_v0.a.$ === 1) {
					var _v1 = _v0.a;
					return 'by typing their name';
				} else {
					if (!_v0.b.$) {
						var signedFrom = _v0.b.a;
						return (signedFrom === 'online_signup') ? 'via checkbox on online signup.' : 'via checkbox';
					} else {
						var _v2 = _v0.b;
						return 'via checkbox';
					}
				}
			}();
			var maybeSignedByName = $author$project$Api$Provider$PatientDocument$One$signedByName(agreement);
			var maybeSignedAt = $author$project$Api$Provider$PatientDocument$One$signedAt(agreement);
			var maybeRequestDetails = $author$project$Api$Provider$PatientDocument$One$requestDetail(agreement);
			var hasSignedDocument = $author$project$Api$Provider$PatientDocument$One$hasSignedDocument(agreement);
			return A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(8),
								$author$project$Ui$FlexGrid$offset(2)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Well$view,
								_List_fromArray(
									[$author$project$Ui$Well$small, $author$project$Ui$Well$clearfix]),
								_List_fromArray(
									[
										A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedHeaderSection, viaSectionText, notSignedElectronically),
										A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAcceptedBySection, maybeSignedFrom, maybeSignedByName),
										A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAceeptedAtSection, timeFormatter, maybeSignedFrom, maybeSignedAt),
										A3(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewUploadedDocumentSection,
										$author$project$Api$Provider$PatientDocument$One$id(agreement),
										maybeSignedFrom,
										hasSignedDocument),
										A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewDetailsSection, maybeSignedFrom, maybeRequestDetails),
										A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewIpSection, maybeSignedFrom, maybeRequestDetails)
									]))
							]))
					]));
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement = F5(
	function (timeFormatter, showSignatureDetails, agreementVisibilityRecord, agreement, document) {
		if (agreementVisibilityRecord.mI) {
			var documentBody = function () {
				var _v0 = $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType(document);
				switch (_v0) {
					case 1:
						return _List_fromArray(
							[
								A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewFromUrl, 'name', agreementVisibilityRecord.Po)
							]);
					case 0:
						return _List_fromArray(
							[
								A3(
								$author$project$Ui$Link$externalHref,
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$DocumentVersion$Shared$linkUrl(document)),
								_List_fromArray(
									[$author$project$Ui$Link$targetBlank]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Api$Provider$DocumentVersion$Shared$linkUrl(document)))
									]))
							]);
					default:
						return A2(
							$elm$core$List$map,
							$elm$html$Html$map($elm$core$Basics$never),
							$author$project$Utils$Dom$textToHtml(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$DocumentVersion$Shared$content(document))));
				}
			}();
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedAgreementDetails, timeFormatter, showSignatureDetails, agreement),
					documentBody));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreements = F4(
	function (timeFormatter, agreement, current, outdated) {
		var isOutdated = function () {
			var _v3 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
			if (_v3 === 'accepted_and_outdated') {
				return true;
			} else {
				return false;
			}
		}();
		var agreementVisibleName = function () {
			var _v2 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
			if (_v2 === 'accepted') {
				return 'Signed Agreement';
			} else {
				return 'Current Agreement';
			}
		}();
		var _v0 = _Utils_Tuple2(current.mI, outdated.mI);
		var currentAgreementVisible = _v0.a;
		var outdatedAgreementVisible = _v0.b;
		var agreementIcon = currentAgreementVisible ? 28 : 27;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			function () {
				if (isOutdated) {
					var _v1 = $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion(agreement);
					if (_v1.$ === 1) {
						return _List_Nil;
					} else {
						var signedDocumentVersion = _v1.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'View ' + agreementVisibleName},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible),
												$author$project$Ui$Button$styled(8)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(agreementVisibleName),
												$author$project$Utils$Html$noBreakSpace,
												A2($author$project$Ui$Icon$view, _List_Nil, agreementIcon)
											])),
										A5(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement,
										timeFormatter,
										false,
										current,
										agreement,
										$author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Signed Out Of Date Agreement'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleOutdatedAgreementVisible),
												$author$project$Ui$Button$styled(8)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Signed Out Of Date Agreement'),
												$author$project$Utils$Html$noBreakSpace,
												A2(
												$author$project$Ui$Icon$view,
												_List_Nil,
												outdatedAgreementVisible ? 28 : 27)
											])),
										function () {
										if (outdatedAgreementVisible) {
											var currentDocumentVersionDate = A2(
												timeFormatter,
												2,
												$author$project$Api$Provider$DocumentVersion$Shared$createdAt(
													$author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement)));
											return A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														$elm$html$Html$text('Agreement was later updated, the most recent version was added on ' + currentDocumentVersionDate)
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A5($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement, timeFormatter, true, outdated, agreement, signedDocumentVersion)
									]))
							]);
					}
				} else {
					return _List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'View ' + agreementVisibleName},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible),
									$author$project$Ui$Button$styled(8),
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(agreementVisibleName),
									$author$project$Utils$Html$noBreakSpace,
									A2($author$project$Ui$Icon$view, _List_Nil, agreementIcon)
								])),
							A5(
							$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement,
							timeFormatter,
							true,
							current,
							agreement,
							$author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement))
						]);
				}
			}());
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewBreadcrumbs = F2(
	function (patientId, agreementName) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{VN: patientId}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Patient')
						])),
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$gray]),
					_List_fromArray(
						[
							$elm$html$Html$text('  /  ' + agreementName)
						])),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenAgreementAcceptanceModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Badge$Inline = {$: 0};
var $author$project$Ui$Badge$inline = $author$project$Ui$Badge$Inline;
var $author$project$Ui$Typography$p0 = $author$project$Ui$Typography$Padding(0);
var $author$project$Ui$Typography$textLeft = $author$project$Ui$Typography$Aligned($author$project$Ui$Alignment$textLeft);
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewHeader = F3(
	function (agreement, patient, practice) {
		var practiceAddress = function () {
			var _v2 = $author$project$Api$Provider$Practice$One$address(practice);
			if (!_v2.$) {
				var practiceAddress_ = _v2.a;
				return $author$project$Components$AddressDisplay$view(practiceAddress_);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var patientAddress = function () {
			var _v1 = $author$project$Api$Provider$Patient$One$address(patient);
			if (!_v1.$) {
				var address = _v1.a;
				return $author$project$Components$AddressDisplay$view(address);
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var buttonText = function () {
			var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
			switch (_v0) {
				case 'accepted':
					return 'Mark as Not Accepted';
				case 'not_accepted':
					return 'Mark as Accepted';
				default:
					return 'Mark Current Agreement as Accepted';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$PatientDocument$One$name(agreement))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mr2]),
									_List_Nil),
									A2(
									$author$project$Ui$Badge$fromString,
									_List_fromArray(
										[$author$project$Ui$Badge$inline]),
									$author$project$Api$Provider$PatientDocument$One$status(agreement))
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: buttonText},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenAgreementAcceptanceModal(agreement))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonText)
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$textLeft, $author$project$Ui$Typography$p0]),
									_List_fromArray(
										[
											$elm$html$Html$text('Member')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(10)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Patient$One$name(patient))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[patientAddress]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$textLeft, $author$project$Ui$Typography$p0]),
									_List_fromArray(
										[
											$elm$html$Html$text('Business')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(10)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Practice$One$name(practice))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[practiceAddress]))
								]))
						])),
					$author$project$Ui$HorizontalRule$view(_List_Nil)
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSkeleton = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsStart]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$spanFromText('Patient')
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('  /  ')
					])),
				$author$project$Ui$Skeleton$text(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(2)
					]))
			])),
		$author$project$Ui$HorizontalRule$view(
		_List_fromArray(
			[$author$project$Ui$HorizontalRule$thin])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$block,
										$author$project$Ui$Skeleton$spanFromText('Some Agreement')
									]))
							])),
						$author$project$Ui$Skeleton$input(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(2)
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(_List_Nil)
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(10)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(3)
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(_List_Nil)
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(10)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(4)
									]))
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$itemsStart, $author$project$Ui$Element$spaceX2]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('Signed Agreement')
							])),
						$author$project$Ui$Skeleton$card(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(8)
							]))
					]))
			]))
	]);
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$view = function (model) {
	var _v0 = model;
	var timeFormatter = _v0.Hy;
	var practice = _v0.WF;
	var patient = _v0.VM;
	var agreement = _v0.eZ;
	var signedFileUrl = _v0.Cl;
	var currentAgreementVisible = _v0.p1;
	var outdatedSignedFileUrl = _v0.z$;
	var outdatedAgreementVisible = _v0.rM;
	return {
		e5: function () {
			if (agreement.$ === 3) {
				var agreement_ = agreement.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewBreadcrumbs,
										$author$project$Api$Provider$Patient$One$id(model.VM),
										$author$project$Api$Provider$PatientDocument$One$name(agreement_)),
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreementAcceptanceModal(model),
										A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewHeader, agreement_, patient, practice),
										A4(
										$author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreements,
										timeFormatter,
										agreement_,
										{Po: signedFileUrl, mI: currentAgreementVisible},
										{Po: outdatedSignedFileUrl, mI: outdatedAgreementVisible})
									]))
							]))
					]);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSkeleton)
							]))
					]);
			}
		}(),
		$G: 'Patient | Agreements'
	};
};
var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$view});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotIntegrationRecords = function (a) {
	return {$: 55, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotTaxProfiles = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$OtherActionsDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileDropdownMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$integrationRecords = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['integration_records']),
					$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$MembershipPaymentSource = 4;
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands = _List_fromArray(
	[0, 1, 2, 3, 4]);
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice = F2(
	function (apiClient, invoiceId) {
		return A4($author$project$Api$Provider$CustomerInvoice$retrieve, apiClient, invoiceId, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice);
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$init = F5(
	function (session, practice, patient, shared, _v0) {
		var params = _v0.Vx;
		return _Utils_Tuple2(
			{
				hp: $elm$core$Maybe$Nothing,
				D5: shared.D5,
				hy: $elm$core$Maybe$Nothing,
				hA: false,
				pD: $author$project$Api$Data$Loading,
				pN: $author$project$Api$Data$Loading,
				hJ: _List_Nil,
				fd: $elm$core$Maybe$Nothing,
				wS: $elm$core$Dict$empty,
				h_: $elm$core$Maybe$Nothing,
				lC: $elm$core$Maybe$Nothing,
				h0: $elm$core$Maybe$Nothing,
				cO: shared.cO,
				lH: $author$project$Components$CustomerEmailModal$init,
				h6: false,
				iq: $author$project$Components$Invoice$DownloadFile$init(shared.aav),
				it: $elm$core$Maybe$Nothing,
				adN: shared.adN,
				Q8: $author$project$Api$Data$Loading,
				Rh: $author$project$Api$Data$NotAsked,
				aea: params.aea,
				FR: $author$project$Shared$isHintAdmin(shared),
				mK: false,
				F_: $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
					{VN: params.VN}),
				nd: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'other-actions-dropdown-menu', ahx: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$OtherActionsDropdownMsg})),
				VJ: $author$project$Api$Data$NotAsked,
				VM: patient,
				VN: params.VN,
				jr: A4(
					$author$project$Components$PaymentsList$init,
					shared.Hy,
					$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(params.aea),
					session,
					false),
				WF: practice,
				jG: $elm$core$Maybe$Nothing,
				sj: shared.sj,
				gA: $author$project$Components$CustomerSchedulePaymentModal$init,
				jZ: _List_Nil,
				ZD: session,
				Cd: shared,
				kr: $author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'tax-profiles-dropdown', ahx: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileDropdownMsg})),
				g_: $author$project$Api$Data$NotAsked,
				Hy: shared.Hy,
				aav: shared.aav
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, shared.D5, params.aea),
						A2($author$project$Api$Provider$TaxProfile$list, shared.D5, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotTaxProfiles),
						$author$project$Shared$isHintAdmin(shared) ? A3($author$project$Api$Provider$CustomerInvoice$integrationRecords, shared.D5, params.aea, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotIntegrationRecords) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg = function (a) {
	return {$: 48, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg = function (a) {
	return {$: 40, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg = function (a) {
	return {$: 46, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg = function (a) {
	return {$: 45, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg = function (a) {
	return {$: 35, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Close = {$: 1};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerInvoice$AdjustVoidModal$Close);
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Close = {$: 0};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotLocalStorageItem = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = _Utils_Tuple2(model.hF, model.bS);
				if (!_v1.a.$) {
					var _v2 = _v1.a.a;
					var cardReaderConnectingModal = _v2.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg,
						$author$project$Components$CardReader$ConnectingModal$subscriptions(cardReaderConnectingModal));
				} else {
					if (!_v1.b.$) {
						var _v3 = _v1.b.a;
						var cardReaderPaymentModal = _v3.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg,
							$author$project$Components$CardReader$PaymentModal$subscriptions(cardReaderPaymentModal));
					} else {
						var _v4 = _v1.a;
						var _v5 = _v1.b;
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Close);
					}
				}
			}(),
				$author$project$Ports$LocalStorage$gotItem($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotLocalStorageItem)
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Close = {$: 1};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerInvoice$ProcessRefundModal$Close);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$Close = {$: 0};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$CreateScheduledPaymentModal$Close);
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit = {$: 2};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$subscriptions = function (model) {
	var _v0 = model._;
	if (!_v0.$) {
		return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Patient$Charges$ChargeModal$CloseClicked = {$: 0};
var $author$project$Components$Patient$Charges$ChargeModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$Charges$ChargeModal$CloseClicked);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg,
				$author$project$Components$CustomerSchedulePaymentModal$subscriptions(model.gA)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.lC))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreateScheduledPaymentModal$subscriptions, model.h0))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$subscriptions, model.h_))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$subscriptions, model.fd))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$subscriptions, model.it))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$subscriptions, model.hp))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$subscriptions, model.jG))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.iq)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$subscriptions(model.lH)),
				model.h6 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed) : $elm$core$Platform$Sub$none,
				model.hA ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed) : $elm$core$Platform$Sub$none,
				function () {
				var _v0 = model.hy;
				if (!_v0.$) {
					var auditTrailLog = _v0.a;
					return $author$project$Components$AuditTrailLog$isOpen(auditTrailLog) ? A2(
						$elm$core$Platform$Sub$map,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg,
						$author$project$Components$AuditTrailLog$subscriptions(auditTrailLog)) : $elm$core$Platform$Sub$none;
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Ui$NewDropdown$subscriptions(model.kr),
				$author$project$Ui$NewDropdown$subscriptions(model.nd),
				$elm$core$Platform$Sub$batch(
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Ui$NewDropdown$subscriptions),
					model.hJ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg,
				$author$project$Components$PaymentsList$subscriptions(model.jr))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDeleted = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotBankAccounts = function (a) {
	return {$: 51, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards = function (a) {
	return {$: 52, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCoverageDiscounts = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotScheduledPayments = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceIssued = function (a) {
	return {$: 20, a: a};
};
var $author$project$Api$FeatureGate$ScheduledPartialPayments = 12;
var $author$project$Api$Provider$CustomerInvoice$applyCredits = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['apply_credits']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$cancelPayment = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['cancel_payment']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$One$createdAt = function (_v0) {
	var record = _v0.b;
	return record.Mf;
};
var $author$project$Api$Provider$CustomerInvoice$Charge$chargesPath = function (customerInvoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['charges']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[customerInvoiceId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['customer_invoices']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CustomerInvoice$Charge$chargePath = F2(
	function (customerInvoiceId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$CustomerInvoice$Charge$chargesPath(customerInvoiceId));
	});
var $author$project$Api$Provider$CustomerInvoice$Charge$delete = F4(
	function (apiClient, customerInvoiceId, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$CustomerInvoice$Charge$chargePath, customerInvoiceId, id_)));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceDeleted = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$deleteInvoice = function (model) {
	var _v0 = model.Rh;
	if (_v0.$ === 3) {
		var invoice = _v0.a;
		return _Utils_Tuple3(
			model,
			A3(
				$author$project$Api$Provider$CustomerInvoice$delete,
				model.D5,
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceDeleted),
			_List_Nil);
	} else {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	}
};
var $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource = function (_v0) {
	var record = _v0;
	return record.V3;
};
var $author$project$Api$Provider$ScheduledPayment$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard = function (scheduledPayments) {
	var scheduled = A2(
		$elm$core$List$filter,
		function (sp) {
			return $author$project$Api$Provider$ScheduledPayment$Shared$status(sp) === 'scheduled';
		},
		scheduledPayments);
	return (!$elm$core$List$isEmpty(scheduled)) && A2(
		$elm$core$List$all,
		function (sp) {
			var _v0 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(sp);
			if (!_v0.$) {
				var source = _v0.a;
				return !_Utils_eq(
					$author$project$Api$Common$Source$Shared$type_(source),
					$elm$core$Maybe$Just('Card'));
			} else {
				return false;
			}
		},
		scheduled);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard = function (cards) {
	if (cards.$ === 3) {
		var cards_ = cards.a;
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				$author$project$Api$Source$default,
				A2($elm$core$List$map, $author$project$Api$Source$Card, cards_)));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource = F4(
	function (practice, invoice, cards, scheduledPayments) {
		if ($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard(scheduledPayments)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
			if (!_v0.$) {
				var source = _v0.a;
				return _Utils_eq(
					$author$project$Api$Common$Source$Shared$type_(source),
					$elm$core$Maybe$Just('Card')) ? $elm$core$Maybe$Just(
					$author$project$Api$Source$Source(source)) : $elm$core$Maybe$Nothing;
			} else {
				return $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard(cards);
			}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotPassthroughFees = function (a) {
	return {$: 54, a: a};
};
var $author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFeesPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['calculate']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['passthroughs']),
			$author$project$Api$Provider$Patient$patientPath(patientId)));
};
var $author$project$Api$Provider$PassthroughFee$One$PassthroughFee = $elm$core$Basics$identity;
var $author$project$Api$Provider$PassthroughFee$Shared$PassthroughFee = $elm$core$Basics$identity;
var $author$project$Api$Provider$PassthroughFee$Shared$InternalRecord = F2(
	function (passthroughFeeInCents, totalInCents) {
		return {VI: passthroughFeeInCents, $X: totalInCents};
	});
var $author$project$Api$Provider$PassthroughFee$Shared$internalRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'total_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'passthrough_fees_in_cents',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PassthroughFee$Shared$InternalRecord)));
var $author$project$Api$Provider$PassthroughFee$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PassthroughFee$Shared$internalRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PassthroughFee$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PassthroughFee$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees = F6(
	function (apiClient, patientId, paymentMethodId, type_, amountInCents, toMsg) {
		var _v0 = function () {
			_v1$3:
			while (true) {
				if (!type_.$) {
					switch (type_.a) {
						case 'credit':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('card'),
								$elm$core$Maybe$Just('credit'));
						case 'amex':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('amex'),
								$elm$core$Maybe$Just('credit'));
						case 'debit':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('card'),
								$elm$core$Maybe$Just('debit'));
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		}();
		var cardType = _v0.a;
		var cardFunding = _v0.b;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'passthrough',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'amount_in_cents',
								$elm$json$Json$Encode$int(amountInCents)),
								_Utils_Tuple2(
								'payment_method_id',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, paymentMethodId)),
								_Utils_Tuple2(
								'card_type',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, cardType)),
								_Utils_Tuple2(
								'card_funding',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, cardFunding))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PassthroughFee$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFeesPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd = F4(
	function (apiClient, amount, sourceChoice, patientId) {
		var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Source$id, sourceChoice);
		if (!_v0.$) {
			var sourceId = _v0.a;
			return A6(
				$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees,
				apiClient,
				patientId,
				$elm$core$Maybe$Just(sourceId),
				$elm$core$Maybe$Nothing,
				amount,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotPassthroughFees);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$date = function (_v0) {
	var record = _v0;
	return record.MO;
};
var $author$project$Api$Provider$CustomerInvoice$One$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$date(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$location = function (_v0) {
	var record = _v0.b;
	return record.aet;
};
var $author$project$Api$Provider$CustomerInvoice$One$owner = function (_v0) {
	var record = _v0.b;
	return record.Vp;
};
var $author$project$Components$Membership$Form$Records$patientFromShared = function (patient) {
	return {
		IK: $author$project$Api$Provider$Patient$Shared$age(patient),
		adR: $author$project$Api$Provider$Patient$Shared$id(patient),
		aet: $elm$core$Maybe$Nothing,
		TL: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient),
		zh: $author$project$Api$Provider$Patient$Shared$name(patient),
		afS: $elm$core$Maybe$Nothing,
		aaI: $author$project$Api$Provider$Patient$Shared$usesTobacco(patient)
	};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsFromInvoice = function (invoice) {
	var payer = function () {
		var _v2 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
		if (!_v2.$) {
			var patient = _v2.a;
			return $author$project$Components$Membership$Form$Records$patientFromShared(patient);
		} else {
			return {IK: $elm$core$Maybe$Nothing, adR: '', aet: $elm$core$Maybe$Nothing, TL: '', zh: '', afS: $elm$core$Maybe$Nothing, aaI: $elm$core$Maybe$Nothing};
		}
	}();
	var locationId = function () {
		var _v1 = $author$project$Api$Provider$CustomerInvoice$One$location(invoice);
		if (!_v1.$) {
			var location = _v1.a;
			return $author$project$Api$Provider$Location$Min$id(location);
		} else {
			return '';
		}
	}();
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			qd: dateInput,
			Rn: $elm$core$Maybe$Just(
				$author$project$Api$Provider$CustomerInvoice$One$date(invoice)),
			S3: $elm$core$Maybe$Just(locationId),
			GD: $elm$core$Maybe$Just(payer)
		},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg(dateInput),
			dateInputCmd));
};
var $author$project$Components$ResourceFilter$Location$resourceFromMin = $elm$core$Maybe$map(
	function (location) {
		return {
			IJ: $elm$core$Maybe$Nothing,
			adR: $author$project$Api$Provider$Location$Min$id(location),
			RQ: false,
			Sa: false,
			zh: $author$project$Api$Provider$Location$Min$name(location)
		};
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter = F2(
	function (apiClient, invoice) {
		var invoiceLocation = $author$project$Api$Provider$CustomerInvoice$One$location(invoice);
		var _v0 = A4(
			$author$project$Components$ResourceFilter$Location$init,
			apiClient,
			$elm$core$Maybe$Nothing,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a location', IS: false});
			});
		var locationResourceFilterModel = _v0.a;
		var locationResourceFilterCmd = _v0.b;
		var locationResourceFilter = function () {
			if (!invoiceLocation.$) {
				var location = invoiceLocation.a;
				return function (value) {
					return A2($author$project$Components$ResourceFilter$Location$setValue, value, locationResourceFilterModel);
				}(
					$author$project$Components$ResourceFilter$Location$resourceFromMin(
						$elm$core$Maybe$Just(location)));
			} else {
				return locationResourceFilterModel;
			}
		}();
		return _Utils_Tuple2(locationResourceFilter, locationResourceFilterCmd);
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initPatientResourceFilter = F2(
	function (apiClient, preselectedPatient) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Patient$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (patient_) {
							return _List_fromArray(
								[
									{
									IK: $author$project$Api$Provider$Patient$Shared$age(patient_),
									adR: $author$project$Api$Provider$Patient$Shared$id(patient_),
									TL: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient_),
									zh: $author$project$Api$Provider$Patient$Shared$name(patient_)
								}
								]);
						},
						preselectedPatient))),
			A2(
				$author$project$Components$ResourceFilter$Patient$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Select a Payer',
							IS: false,
							afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$id, preselectedPatient)
						});
				}));
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$init = F2(
	function (apiClient, invoice) {
		var invoicePayer = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
		var _v0 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initPatientResourceFilter, apiClient, invoicePayer);
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		var _v1 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter, apiClient, invoice);
		var locationResourceFilter = _v1.a;
		var locationResourceFilterCmd = _v1.b;
		var _v2 = $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsFromInvoice(invoice);
		var form = _v2.a;
		var formCmd = _v2.b;
		return _Utils_Tuple2(
			{
				x6: true,
				_: $elm$core$Maybe$Just(
					_Utils_Tuple3(
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Utils$Form$init(form),
						invoice)),
				S_: false,
				rl: $elm$core$Maybe$Just(locationResourceFilter),
				rU: $elm$core$Maybe$Just(patientResourceFilter)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceFilterCmd),
						formCmd
					])));
	});
var $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$age(shared);
};
var $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig = function (d) {
	return _Utils_update(
		d,
		{D0: 'None', IS: false, adB: true, adC: '', adJ: true, adK: true, aeZ: false});
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location = function (_v0) {
	var record = _v0.b;
	return record.aet;
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner = function (_v0) {
	var record = _v0.b;
	return record.afS;
};
var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
};
var $author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector = F3(
	function (apiClient, probablePatients, patient) {
		return A4(
			$author$project$Components$LimitedPatientSelector$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Patient', IS: false});
			},
			A2(
				$elm$core$List$map,
				function (patient_) {
					return {
						IK: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient_),
						adR: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
						aet: A2(
							$elm$core$Maybe$map,
							function (location) {
								return {
									adR: $author$project$Api$Provider$Location$Min$id(location),
									zh: $author$project$Api$Provider$Location$Min$name(location)
								};
							},
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient_)),
						TL: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient_),
						zh: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_),
						afS: A2(
							$elm$core$Maybe$map,
							function (practitioner) {
								return {
									adR: $author$project$Api$Provider$Practitioner$Min$id(practitioner),
									zh: $author$project$Api$Provider$Practitioner$Min$name(practitioner)
								};
							},
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient_)),
						aaI: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient_)
					};
				},
				probablePatients),
			patient);
	});
var $author$project$Components$Patient$Charges$ChargeModal$formFieldsFromItem = F5(
	function (apiClient, showItemTypeInTitle, session, probablePatients, charge) {
		var practitioner = $author$project$Api$Provider$Charge$One$practitioner(charge);
		var patient = $author$project$Api$Provider$Charge$One$patient(charge);
		var location = $author$project$Api$Provider$Charge$One$location(charge);
		var formPatient = A2(
			$elm$core$Maybe$map,
			function (patient_) {
				return {
					adR: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
					zh: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
				};
			},
			patient);
		var chargeItem = A2(
			$elm$core$Maybe$map,
			function (chargeItem_) {
				return {
					IN: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem_),
					Ex: $author$project$Api$Provider$Charge$One$category(charge),
					K3: $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem_),
					K5: $author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem_),
					Nx: $author$project$Api$Provider$ChargeItem$ForCharge$description(chargeItem_),
					adR: $author$project$Api$Provider$ChargeItem$ForCharge$id(chargeItem_),
					aef: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_),
					q9: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_) ? 1 : 0,
					Tg: $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem_),
					zh: $author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem_),
					Ba: $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents(chargeItem_),
					Xv: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem_),
					$u: $author$project$Api$Provider$ChargeItem$ForCharge$taxable(chargeItem_),
					$_: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem_),
					aam: $author$project$Api$Provider$ChargeItem$ForCharge$uom(chargeItem_)
				};
			},
			$author$project$Api$Provider$Charge$One$chargeItem(charge));
		var category = $author$project$Api$Provider$Charge$One$category(charge);
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Practitioner$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (practitioner_) {
							return _List_fromArray(
								[
									{
									adR: $author$project$Api$Provider$Practitioner$Shared$id(practitioner_),
									zh: $author$project$Api$Provider$Practitioner$Shared$name(practitioner_)
								}
								]);
						},
						practitioner))),
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Unassigned',
							aeZ: false,
							afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner)
						});
				}));
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Location$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (location_) {
							return _List_fromArray(
								[
									{
									adR: $author$project$Api$Provider$Location$Min$id(location_),
									zh: $author$project$Api$Provider$Location$Min$name(location_)
								}
								]);
						},
						location))),
			A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				$elm$core$Maybe$Nothing,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Unassigned',
							aeZ: false,
							afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location)
						});
				}));
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = A3(
			$author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector,
			apiClient,
			probablePatients,
			A2(
				$elm$core$Maybe$map,
				function (patient_) {
					return {
						IK: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient_),
						adR: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
						aet: A2(
							$elm$core$Maybe$map,
							function (location_) {
								return {
									adR: $author$project$Api$Provider$Location$Min$id(location_),
									zh: $author$project$Api$Provider$Location$Min$name(location_)
								};
							},
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient_)),
						TL: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient_),
						zh: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_),
						afS: A2(
							$elm$core$Maybe$map,
							function (practitioner_) {
								return {
									adR: $author$project$Api$Provider$Practitioner$Min$id(practitioner_),
									zh: $author$project$Api$Provider$Practitioner$Min$name(practitioner_)
								};
							},
							$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient_)),
						aaI: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient_)
					};
				},
				patient));
		var limitedPatientSelector = _v3.a;
		var limitedPatientSelectorCmd = _v3.b;
		var _v4 = $author$project$Components$DateInput$init;
		var endDateInput = _v4.a;
		var endDateInputCmd = _v4.b;
		var _v5 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$ChargeItem$setValue(
				A2(
					$elm$core$Maybe$withDefault,
					$author$project$Components$ResourceFilter$FreeText(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$Charge$One$name(charge))),
					A2(
						$elm$core$Maybe$map,
						function (chargeItem_) {
							return $author$project$Components$ResourceFilter$One(
								{IN: chargeItem_.IN, Ex: chargeItem_.Ex, K3: chargeItem_.K3, K5: chargeItem_.K5, Nx: chargeItem_.Nx, adR: chargeItem_.adR, aef: chargeItem_.aef, q9: chargeItem_.q9, Tg: chargeItem_.Tg, zh: chargeItem_.zh, Ba: chargeItem_.Ba, Xv: chargeItem_.Xv, $u: chargeItem_.$u, $_: chargeItem_.$_, aam: chargeItem_.aam});
						},
						chargeItem))),
			A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig));
		var chargeItemResourceFilter = _v5.a;
		var chargeItemResourceFilterCmd = _v5.b;
		var _v6 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$ResourceFilter$Category$extraItems(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (category_) {
							return _List_fromArray(
								[
									{
									adR: $author$project$Api$Provider$Category$Shared$id(category_),
									zh: $author$project$Api$Provider$Category$Shared$name(category_)
								}
								]);
						},
						category))),
			A3(
				$author$project$Components$ResourceFilter$Category$init,
				apiClient,
				session,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Unassigned',
							aeZ: false,
							afT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category)
						});
				}));
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		return _Utils_Tuple2(
			{
				Ex: A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Category$Shared$id,
					$author$project$Api$Provider$Charge$One$category(charge)),
				cJ: categoryResourceFilter,
				lp: chargeItem,
				cK: chargeItemResourceFilter,
				Nx: $author$project$Api$Provider$Charge$One$description(charge),
				NI: $author$project$Api$Provider$Charge$One$discountInCents(charge),
				NJ: $author$project$Api$Provider$Charge$One$discountOverridden(charge),
				qs: $author$project$Api$Provider$Charge$One$endDate(charge),
				qu: endDateInput,
				adR: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$id(charge)),
				rd: limitedPatientSelector,
				aet: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location),
				rl: locationResourceFilter,
				zh: $author$project$Api$Provider$Charge$One$name(charge),
				VM: formPatient,
				afS: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner),
				jC: practitionerResourceFilter,
				Ba: $author$project$Currency$fromMaybeInt(
					$author$project$Api$Provider$Charge$One$priceInCents(charge)),
				W$: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$priceUom(charge)),
				Bd: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$quantity(charge)),
				Be: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$quantityUom(charge)),
				_E: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Charge$One$date(charge)),
				kg: startDateInput,
				$u: A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$ChargeItem$ForCharge$taxable,
						$author$project$Api$Provider$Charge$One$chargeItem(charge)))
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Components$Patient$Charges$ChargeModal$initFormFields = F6(
	function (apiClient, showItemTypeInTitle, session, date, probablePatients, patient) {
		var maybePractitioner = A2(
			$elm$core$Maybe$map,
			function (prac) {
				return {
					IJ: $elm$core$Maybe$Nothing,
					adR: $author$project$Api$Provider$Practitioner$Shared$id(prac),
					RQ: $author$project$Api$Provider$Practitioner$Shared$isMaster(prac),
					Sa: $author$project$Api$Provider$Practitioner$Shared$isSynced(prac),
					zh: $author$project$Api$Provider$Practitioner$Shared$name(prac),
					Vb: $author$project$Api$Provider$Practitioner$Shared$openingsSize(prac),
					afQ: '',
					WP: ''
				};
			},
			$author$project$Api$Provider$Patient$One$practitioner(patient));
		var maybeLocation = A2(
			$elm$core$Maybe$map,
			function (loc) {
				return {
					IJ: $elm$core$Maybe$Nothing,
					adR: $author$project$Api$Provider$Location$Shared$id(loc),
					RQ: false,
					Sa: false,
					zh: $author$project$Api$Provider$Location$Shared$name(loc)
				};
			},
			$author$project$Api$Provider$Patient$One$location(patient));
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = A2(
			$elm$core$Tuple$mapFirst,
			function (filter) {
				return A2($author$project$Components$ResourceFilter$Practitioner$setValue, maybePractitioner, filter);
			},
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'Unassigned', aeZ: false});
				}));
		var practitionerResourceFilter = _v1.a;
		var practitionerResourceFilterCmd = _v1.b;
		var _v2 = A2(
			$elm$core$Tuple$mapFirst,
			function (filter) {
				return A2($author$project$Components$ResourceFilter$Location$setValue, maybeLocation, filter);
			},
			A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				$elm$core$Maybe$Nothing,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'Unassigned', aeZ: false});
				}));
		var locationResourceFilter = _v2.a;
		var locationResourceFilterCmd = _v2.b;
		var _v3 = A3(
			$author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector,
			apiClient,
			probablePatients,
			$elm$core$Maybe$Just(
				{
					IK: $author$project$Api$Provider$Patient$One$age(patient),
					adR: $author$project$Api$Provider$Patient$One$id(patient),
					aet: A2(
						$elm$core$Maybe$map,
						function (location) {
							return {
								adR: $author$project$Api$Provider$Location$Shared$id(location),
								zh: $author$project$Api$Provider$Location$Shared$name(location)
							};
						},
						$author$project$Api$Provider$Patient$One$location(patient)),
					TL: $author$project$Api$Provider$Patient$One$membershipStatus(patient),
					zh: $author$project$Api$Provider$Patient$One$name(patient),
					afS: A2(
						$elm$core$Maybe$map,
						function (practitioner) {
							return {
								adR: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
								zh: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
							};
						},
						$author$project$Api$Provider$Patient$One$practitioner(patient)),
					aaI: $author$project$Api$Provider$Patient$One$usesTobacco(patient)
				}));
		var limitedPatientSelector = _v3.a;
		var limitedPatientSelectorCmd = _v3.b;
		var _v4 = $author$project$Components$DateInput$init;
		var endDateInput = _v4.a;
		var endDateInputCmd = _v4.b;
		var _v5 = A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig);
		var chargeItemResourceFilter = _v5.a;
		var chargeItemResourceFilterCmd = _v5.b;
		var _v6 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false});
			});
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		return _Utils_Tuple2(
			{
				Ex: $elm$core$Maybe$Nothing,
				cJ: categoryResourceFilter,
				lp: $elm$core$Maybe$Nothing,
				cK: chargeItemResourceFilter,
				Nx: '',
				NI: 0,
				NJ: false,
				qs: $elm$core$Maybe$Nothing,
				qu: endDateInput,
				adR: $elm$core$Maybe$Nothing,
				rd: limitedPatientSelector,
				aet: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adR;
					},
					maybeLocation),
				rl: locationResourceFilter,
				zh: $elm$core$Maybe$Nothing,
				VM: $elm$core$Maybe$Just(
					{
						adR: $author$project$Api$Provider$Patient$One$id(patient),
						zh: $author$project$Api$Provider$Patient$One$name(patient)
					}),
				afS: A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adR;
					},
					maybePractitioner),
				jC: practitionerResourceFilter,
				Ba: $elm$core$Maybe$Nothing,
				W$: $elm$core$Maybe$Nothing,
				Bd: $elm$core$Maybe$Just(1),
				Be: $elm$core$Maybe$Nothing,
				_E: $elm$core$Maybe$Just(date),
				kg: startDateInput,
				$u: false
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Api$Provider$CustomerInvoice$One$probablePatients = function (_v0) {
	var record = _v0.b;
	return record.W3;
};
var $author$project$Components$Patient$Charges$ChargeModal$init = F6(
	function (apiClient, session, practice, patient, invoice, charge) {
		var showItemTypeInTitle = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice);
		var _v0 = function () {
			if (!charge.$) {
				var charge_ = charge.a;
				return A5(
					$author$project$Components$Patient$Charges$ChargeModal$formFieldsFromItem,
					apiClient,
					showItemTypeInTitle,
					session,
					$author$project$Api$Provider$CustomerInvoice$One$probablePatients(invoice),
					charge_);
			} else {
				var date = $author$project$Api$Provider$CustomerInvoice$One$date(invoice);
				return A6(
					$author$project$Components$Patient$Charges$ChargeModal$initFormFields,
					apiClient,
					showItemTypeInTitle,
					session,
					date,
					$author$project$Api$Provider$CustomerInvoice$One$probablePatients(invoice),
					patient);
			}
		}();
		var formFields = _v0.a;
		var formCmd = _v0.b;
		return _Utils_Tuple2(
			{
				vQ: A2(
					$elm$core$Maybe$withDefault,
					true,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Charge$Meta$priceInCentsEditable,
						A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$meta, charge))),
				abU: charge,
				PB: $author$project$Utils$Form$init(formFields),
				Rh: invoice,
				VM: patient,
				WF: practice,
				afU: $author$project$Api$Data$NotAsked,
				em: $jinjor$elm_debounce$Debounce$init,
				n7: false,
				ZD: session,
				gJ: false
			},
			formCmd);
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$Model = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$One$charges = function (_v0) {
	var record = _v0.b;
	return record.KU;
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Model = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields = F2(
	function (charge, voidOnly) {
		return {
			abU: charge,
			lp: $author$project$Api$Provider$Charge$One$chargeItem(charge),
			MO: $author$project$Api$Provider$Charge$One$date(charge),
			xf: false,
			qs: $author$project$Api$Provider$Charge$One$endDate(charge),
			qu: A2(
				$elm$core$Maybe$map,
				$author$project$Components$DateInput$initFromDate,
				$author$project$Api$Provider$Charge$One$endDate(charge)),
			Ba: A2(
				$elm$core$Maybe$map,
				$author$project$Currency$fromInt,
				$author$project$Api$Provider$Charge$One$priceInCents(charge)),
			Bd: $elm$core$Maybe$Just(
				$author$project$Api$Provider$Charge$One$quantity(charge)),
			Be: $author$project$Api$Provider$Charge$One$quantityUom(charge),
			ex: false,
			M: (!$author$project$Api$Provider$Charge$One$quantity(charge)) || voidOnly,
			HP: false
		};
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$init = F2(
	function (charge, voidOnly) {
		var form = $author$project$Utils$Form$init(
			A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields, charge, voidOnly));
		return _Utils_Tuple2(
			{tL: $elm$core$Maybe$Nothing, PB: form, DM: voidOnly},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$init = F2(
	function (invoice, _v0) {
		var voidOnly = _v0.DM;
		var refunding = _v0.agb;
		var voidCmd = voidOnly ? A2(
			$elm$core$Task$perform,
			$author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll,
			$elm$core$Task$succeed(true)) : $elm$core$Platform$Cmd$none;
		var adjustments = A2(
			$elm$core$List$map,
			function (charge) {
				return _Utils_Tuple2(
					$author$project$Api$Provider$Charge$One$id(charge),
					A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$init, charge, voidOnly));
			},
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$One$charges(invoice)));
		var adjustmentsCmds = A2(
			$elm$core$List$map,
			function (_v2) {
				var chargeId = _v2.a;
				var adjustment = _v2.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId),
					adjustment.b);
			},
			adjustments);
		var forms = A2(
			$elm$core$List$map,
			function (_v1) {
				var chargeId = _v1.a;
				var adjustment = _v1.b;
				return _Utils_Tuple2(chargeId, adjustment.a);
			},
			adjustments);
		return _Utils_Tuple2(
			{W: forms, fE: _List_Nil, Rh: invoice, aeC: $elm$core$Maybe$Nothing, afU: $author$project$Api$Data$NotAsked, agb: refunding, oP: 0, DM: voidOnly},
			$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$cons, voidCmd, adjustmentsCmds)));
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$init = F2(
	function (invoice, voidOnly) {
		var _v0 = A2(
			$author$project$Components$CustomerInvoice$AdjustmentsForm$init,
			invoice,
			{agb: false, DM: voidOnly});
		var adjustmentsFormModel = _v0.a;
		var adjustmentsFormCmd = _v0.b;
		return _Utils_Tuple2(
			{bj: adjustmentsFormModel, Rh: invoice, kj: false, DM: voidOnly},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg, adjustmentsFormCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal = F3(
	function (model, invoice, voidOnly) {
		var _v0 = A2($author$project$Components$CustomerInvoice$AdjustVoidModal$init, invoice, voidOnly);
		var adjustVoidModal = _v0.a;
		var adjustVoidModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					hp: $elm$core$Maybe$Just(adjustVoidModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg, adjustVoidModalCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDropdownsMsg = F2(
	function (a, b) {
		return {$: 49, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$Shared$isPersisted = function (_v0) {
	var record = _v0;
	return record.R$;
};
var $author$project$Api$Provider$Charge$One$isPersisted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$isPersisted(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initChargeDropdowns = function (invoice) {
	return A2(
		$elm$core$List$map,
		function (charge) {
			return _Utils_Tuple2(
				$author$project$Api$Provider$Charge$One$id(charge),
				$author$project$Ui$NewDropdown$init(
					$author$project$Ui$NewDropdown$toDownLeft(
						$author$project$Ui$NewDropdown$defaultConfig(
							{
								adR: 'charge-dropdown-' + $author$project$Api$Provider$Charge$One$id(charge),
								ahx: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDropdownsMsg(charge)
							}))));
		},
		A2(
			$elm$core$List$filter,
			$author$project$Api$Provider$Charge$One$isPersisted,
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$One$charges(invoice))));
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotBankAccounts = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotCards = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderLabel = F2(
	function (showProcessor, cardReader) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A3(
						$author$project$Utils$PaymentProcessor$toLabel,
						showProcessor,
						cardReader,
						A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just)),
						$elm$core$Maybe$Just(
						$author$project$Api$Provider$CardReader$All$label(cardReader))
					])));
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderToValue = function (cardReader) {
	return $elm$core$Maybe$Just(
		$author$project$Api$Provider$CardReader$All$id(cardReader));
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$defaultOptions = {oo: false};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotPassthroughFees = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard = F2(
	function (useExistingSources, _v0) {
		var source = _v0.Hg;
		var cardType = _v0.KI;
		var _v1 = _Utils_Tuple3(
			useExistingSources,
			A2($elm$core$Maybe$andThen, $author$project$Api$Source$type_, source),
			cardType);
		_v1$3:
		while (true) {
			if (_v1.a) {
				if ((!_v1.b.$) && (_v1.b.a === 'Card')) {
					return true;
				} else {
					break _v1$3;
				}
			} else {
				if (!_v1.c.$) {
					switch (_v1.c.a) {
						case 'credit':
							return true;
						case 'amex':
							return true;
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
		}
		return false;
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd = F5(
	function (apiClient, useExistingSources, amount, fields, patientId) {
		return A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, useExistingSources, fields) ? A6(
			$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees,
			apiClient,
			patientId,
			A2($elm$core$Maybe$map, $author$project$Api$Source$id, fields.Hg),
			fields.KI,
			amount,
			$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotPassthroughFees) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Manual = 0;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAtDateInputMsg = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsFromPayable = F3(
	function (today, allowMultipleMemberships, payable) {
		var dueInCents = $author$project$Api$Provider$CustomerInvoice$One$dueInCents(payable);
		var defaultSource = allowMultipleMemberships ? A2(
			$elm_community$maybe_extra$Maybe$Extra$orElse,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Source$Source,
				$author$project$Api$Provider$CustomerInvoice$One$source(payable)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Source$Source,
				$author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(payable))) : A2(
			$elm$core$Maybe$map,
			$author$project$Api$Source$Source,
			$author$project$Api$Provider$CustomerInvoice$One$source(payable));
		var _v0 = $author$project$Components$DateInput$init;
		var dateInput = _v0.a;
		var dateInputCmd = _v0.b;
		return _Utils_Tuple2(
			{
				I2: $elm$core$Maybe$Just(
					$author$project$Currency$fromInt(dueInCents)),
				cH: 0,
				abR: $elm$core$Maybe$Nothing,
				KI: $elm$core$Maybe$Nothing,
				mB: dueInCents,
				aeC: $elm$core$Maybe$Nothing,
				Vt: $elm$core$Maybe$Just(today),
				Gz: dateInput,
				Hg: defaultSource,
				Ct: false
			},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAtDateInputMsg(dateInput),
				dateInputCmd));
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$paymentSourceToValue = function (source) {
	return $elm$core$Maybe$Just(
		$author$project$Api$Source$id(source));
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceName = function (source_) {
	var _v0 = $author$project$Api$Source$name(source_);
	if (!_v0.$) {
		var name = _v0.a;
		return $elm$core$Maybe$Just(name);
	} else {
		return $author$project$Api$Source$type_(source_);
	}
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceLabel = F2(
	function (showProcessor, source) {
		var paymentProcessorLabel = function (source_) {
			var _v0 = _Utils_Tuple2(
				showProcessor,
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Utils$String$toMaybe,
					$author$project$Api$Source$paymentProcessor(source_)));
			if (_v0.a && (!_v0.b.$)) {
				var paymentProcessor_ = _v0.b.a;
				return $elm$core$Maybe$Just('[' + (paymentProcessor_ + ']'));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						paymentProcessorLabel(source),
						A2(
						$elm$core$Maybe$map,
						$author$project$Formatters$String$titleize,
						$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceName(source)),
						A2(
						$elm$core$Maybe$map,
						function (lastFour) {
							return ' * ' + lastFour;
						},
						$author$project$Api$Source$lastFour(source)),
						A2(
						$elm$core$Maybe$map,
						function (funding) {
							return ' (' + (funding + ')');
						},
						$author$project$Api$Source$funding(source))
					])));
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCardReader = F2(
	function (showProcessor, cardReader) {
		return _List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A4(
					$author$project$Utils$PaymentProcessor$toBadge,
					showProcessor,
					showProcessor,
					cardReader,
					A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just))),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderLabel, showProcessor, cardReader))
					]))
			]);
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$paymentProcessor = F2(
	function (showProcessor, source_) {
		var badge = F2(
			function (style, processor) {
				return $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Badge$fromString,
						_List_fromArray(
							[$author$project$Ui$Badge$spacedRight, style]),
						processor));
			});
		var _v0 = _Utils_Tuple2(
			showProcessor,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Utils$String$toMaybe,
				$author$project$Api$Source$paymentProcessor(source_)));
		_v0$2:
		while (true) {
			if (_v0.a && (!_v0.b.$)) {
				switch (_v0.b.a) {
					case 'stripe':
						return A2(badge, $author$project$Ui$Badge$primary, 'stripe');
					case 'rainforest':
						return A2(badge, $author$project$Ui$Badge$success, 'rainforest');
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentSource = F2(
	function (showProcessor, source) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$paymentProcessor, showProcessor, source)),
						function () {
						var _v0 = $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceName(source);
						if (!_v0.$) {
							var name = _v0.a;
							return A2(
								$elm$html$Html$strong,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('inline')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Formatters$String$titleize(name))
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						$author$project$Utils$Html$noBreakSpace,
						function () {
						var _v1 = $author$project$Api$Source$lastFour(source);
						if (!_v1.$) {
							var lastFour = _v1.a;
							return A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('*' + lastFour)
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						$author$project$Utils$Html$noBreakSpace,
						function () {
						var _v2 = $author$project$Api$Source$funding(source);
						if (!_v2.$) {
							var funding = _v2.a;
							return A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('(' + (funding + ')'))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						A2(
							$elm$core$Maybe$withDefault,
							'N/A',
							$author$project$Api$Source$status(source))),
						$author$project$Utils$Html$noBreakSpace,
						function () {
						var _v3 = $author$project$Api$Source$label(source);
						if (!_v3.$) {
							var label = _v3.a;
							return A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$em,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-muted')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true),
														$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label)
													]))
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]);
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$init = function (today) {
	return function (timeFormatter) {
		return function (paymentPath) {
			return function (sourcePath) {
				return function (apiClient) {
					return function (session) {
						return function (practice) {
							return function (isHintAdmin) {
								return function (rainforestEnv) {
									return function (optionsBuilder) {
										return function (payable) {
											return function (patientId) {
												var useExistingSources = true;
												var options = optionsBuilder($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$defaultOptions);
												var _v0 = function () {
													if (!sourcePath.$) {
														var sourcePath_ = sourcePath.a;
														return _Utils_Tuple2(
															$elm$core$Platform$Cmd$batch(
																_List_fromArray(
																	[
																		A4($author$project$Api$Card$list, sourcePath_, apiClient, session, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotCards),
																		A4($author$project$Api$BankAccount$list, sourcePath_, apiClient, session, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotBankAccounts)
																	])),
															$author$project$Api$Data$Loading);
													} else {
														return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
													}
												}();
												var sourceCmd = _v0.a;
												var sourceStatus = _v0.b;
												var _v2 = A3(
													$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsFromPayable,
													today,
													$author$project$Api$Practice$allowMultipleRetailMemberships(practice),
													payable);
												var fields = _v2.a;
												var fieldsCmd = _v2.b;
												var amountInCents = A2(
													$elm$core$Maybe$withDefault,
													0,
													$author$project$Currency$toInt(
														A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.I2)));
												var passthroughFeesCmd = A5($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd, apiClient, useExistingSources, amountInCents, fields, patientId);
												return _Utils_Tuple2(
													{
														pD: sourceStatus,
														hF: $elm$core$Maybe$Nothing,
														bS: $elm$core$Maybe$Nothing,
														pM: $author$project$Ui$Form$SearchableSelect$init(
															{
																adR: 'card-reader-select',
																ahw: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCardReader(options.oo),
																ahA: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderLabel(options.oo),
																g0: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderToValue
															}),
														hG: $author$project$Api$Data$NotAsked,
														pN: sourceStatus,
														PB: $author$project$Utils$Form$init(fields),
														FR: isHintAdmin,
														VJ: $author$project$Api$Data$NotAsked,
														VN: patientId,
														afF: payable,
														af: $author$project$Api$Data$NotAsked,
														rX: paymentPath,
														r_: $author$project$Ui$Form$SearchableSelect$init(
															{
																adR: 'source-select',
																ahw: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentSource(options.oo),
																ahA: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceLabel(options.oo),
																g0: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$paymentSourceToValue
															}),
														WF: practice,
														sj: rainforestEnv,
														ZD: session,
														Hh: sourcePath,
														s7: $author$project$Api$Provider$CustomerInvoice$One$dueInCents(payable),
														Hy: timeFormatter,
														$P: today,
														V: useExistingSources
													},
													$elm$core$Platform$Cmd$batch(
														_List_fromArray(
															[fieldsCmd, sourceCmd, passthroughFeesCmd])));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath = function (invoice) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Provider$Patient$patientPath,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$Shared$id,
			$author$project$Api$Provider$CustomerInvoice$One$owner(invoice)));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePassthroughFeesPaymentModal = F2(
	function (model, invoice) {
		var _v0 = $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$init(model.cO)(model.Hy)(
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))(
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice))(model.D5)(model.ZD)(
			$author$project$Api$Practice$Provider(model.WF))(model.FR)(model.sj)(
			function (d) {
				return _Utils_update(
					d,
					{oo: model.FR});
			})(invoice)(model.VN);
		var createPassthroughFeesPaymentModal = _v0.a;
		var createPassthroughFeesPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					h_: $elm$core$Maybe$Just(createPassthroughFeesPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg, createPassthroughFeesPaymentModalCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal = F4(
	function (model, invoice, external, displayModal) {
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.cO)(model.Hy)(
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))(
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice))(model.D5)(model.ZD)(
			$author$project$Api$Practice$Provider(model.WF))(model.FR)(model.sj)(
			function (d) {
				return _Utils_update(
					d,
					{qk: displayModal, O4: external, oo: model.FR});
			})(
			A2($author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice, model.VN, invoice));
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					lC: $elm$core$Maybe$Just(createPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotBankAccounts = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotCards = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPaymentSources = F3(
	function (apiClient, session, sourcePath) {
		if (!sourcePath.$) {
			var sourcePath_ = sourcePath.a;
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$Card$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreateScheduledPaymentModal$GotCards),
						A4($author$project$Api$BankAccount$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreateScheduledPaymentModal$GotBankAccounts)
					]));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsFromPayable = function (customerInvoice) {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			mB: $author$project$Api$Provider$CustomerInvoice$One$dueInCents(customerInvoice),
			j: _List_Nil
		},
		A2(
			$elm$core$Platform$Cmd$map,
			A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, 0, dateInput),
			dateInputCmd));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$init = F9(
	function (today, timeFormatter, sourcePath, apiClient, session, practice, customerInvoice, patientId, shouldChargeCreditCardFees) {
		var _v0 = $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsFromPayable(customerInvoice);
		var fields = _v0.a;
		var fieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				pD: $author$project$Api$Data$Loading,
				pN: $author$project$Api$Data$Loading,
				lI: customerInvoice,
				PB: $author$project$Utils$Form$init(fields),
				cW: true,
				VN: patientId,
				WF: practice,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				ZQ: shouldChargeCreditCardFees,
				Hh: sourcePath,
				Hy: timeFormatter,
				$P: today
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						fieldsCmd,
						A3($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPaymentSources, apiClient, session, sourcePath)
					])));
	});
var $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees = function (_v0) {
	var record = _v0.b;
	return record.ZQ;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreateScheduledPaymentModal = F2(
	function (model, invoice) {
		var _v0 = A9(
			$author$project$Components$Invoice$CreateScheduledPaymentModal$init,
			model.cO,
			model.Hy,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice),
			model.D5,
			model.ZD,
			model.WF,
			invoice,
			model.VN,
			$author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.VM));
		var createScheduledPaymentModal = _v0.a;
		var createScheduledPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					h0: $elm$core$Maybe$Just(createScheduledPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg, createScheduledPaymentModalCmd));
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Check = 1;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$CustomerInvoice$RefundsForm$Model = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$RefundsForm$init = F3(
	function (refunds, timeFormatter, invoice) {
		var forms = A2(
			$elm$core$List$map,
			function (payment) {
				return _Utils_Tuple2(
					$author$project$Api$Payment$id(payment),
					$author$project$Utils$Form$init(
						{I2: $elm$core$Maybe$Nothing, VY: payment}));
			},
			refunds);
		return _Utils_Tuple2(
			{pn: 0, fE: _List_Nil, ao: forms, Rh: invoice, X3: refunds, Hy: timeFormatter},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$CustomerInvoice$RefundsForm$AmountInCentsValidation = 0;
var $author$project$Components$CustomerInvoice$RefundsForm$validateAmountInCents = function (fields) {
	var paymentAmount = $author$project$Api$Payment$amountInCents(fields.VY);
	var isInvalidCurrency = function (amount) {
		return A2(
			$author$project$Utils$Validate$isInvalidCurrency,
			{
				abi: false,
				yQ: $elm$core$Maybe$Just(paymentAmount),
				TZ: $elm$core$Maybe$Just(0)
			},
			amount);
	};
	return ((!_Utils_eq(fields.I2, $elm$core$Maybe$Nothing)) && isInvalidCurrency(fields.I2)) ? _List_fromArray(
		[
			_Utils_Tuple2(
			0,
			'Enter a positive amount below or equal to ' + ($author$project$Utils$Currency$fromInt(paymentAmount) + '.'))
		]) : _List_Nil;
};
var $author$project$Components$CustomerInvoice$RefundsForm$refundValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$RefundsForm$validateAmountInCents)
		]));
var $author$project$Components$CustomerInvoice$RefundsForm$TotalRefundValidation = 1;
var $author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount = function (forms) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$elm$core$Maybe$withDefault(0),
			A2(
				$elm$core$List$map,
				$elm$core$Maybe$andThen($author$project$Currency$toInt),
				A2(
					$elm$core$List$map,
					function ($) {
						return $.I2;
					},
					A2(
						$elm$core$List$map,
						$author$project$Utils$Form$fields,
						A2($elm$core$List$map, $elm$core$Tuple$second, forms))))));
};
var $author$project$Components$CustomerInvoice$RefundsForm$RefundsValidation = 0;
var $author$project$Components$CustomerInvoice$RefundsForm$validateRefunds = function (model) {
	var anyRefundError = A2(
		$elm$core$List$any,
		A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Utils$Form$hasAnyValidationError),
		model.ao);
	return anyRefundError ? _List_fromArray(
		[0]) : _List_Nil;
};
var $author$project$Components$CustomerInvoice$RefundsForm$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$RefundsForm$validateRefunds),
			A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ao;
				},
				A2(
					$elm$core$Basics$composeR,
					$author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount,
					function (_int) {
						return _int <= 0;
					})),
			1)
		]));
var $author$project$Components$CustomerInvoice$RefundsForm$validate = function (_v0) {
	var model = _v0;
	var newForms = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$mapSecond(
				$author$project$Utils$Form$validate($author$project$Components$CustomerInvoice$RefundsForm$refundValidator)),
			$elm$core$Tuple$mapSecond($author$project$Utils$Form$fromValidateResult)),
		model.ao);
	var newModel = _Utils_update(
		model,
		{fE: _List_Nil, ao: newForms});
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					newModel,
					{fE: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$CustomerInvoice$RefundsForm$validator, newModel))));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$init = function (basePath) {
	return function (payments) {
		return function (invoice) {
			return function (patient) {
				return function (shared) {
					return function (session) {
						return function (practice) {
							return function (voidOnly) {
								return function (timeFormatter) {
									return function (isHintAdmin) {
										return function (rainforestEnv) {
											var paymentProcessorRefundablePayments = A2($elm$core$List$filter, $author$project$Api$Payment$isRefundableOnPaymentProcessor, payments);
											var refundType = $elm$core$List$isEmpty(paymentProcessorRefundablePayments) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing;
											var _v0 = A2(
												$elm$core$Tuple$mapFirst,
												$author$project$Components$CustomerInvoice$RefundsForm$validate,
												A3($author$project$Components$CustomerInvoice$RefundsForm$init, payments, timeFormatter, invoice));
											var refundsFormModel = _v0.a;
											var refundsFormCmd = _v0.b;
											var _v1 = A2(
												$author$project$Components$CustomerInvoice$AdjustmentsForm$init,
												invoice,
												{agb: true, DM: voidOnly});
											var adjustmentsFormModel = _v1.a;
											var adjustmentsFormCmd = _v1.b;
											return _Utils_Tuple2(
												{
													bj: adjustmentsFormModel,
													vD: basePath,
													lC: $elm$core$Maybe$Nothing,
													PB: $author$project$Utils$Form$init(
														{aeC: $elm$core$Maybe$Nothing}),
													Rh: invoice,
													fQ: true,
													FR: isHintAdmin,
													rI: false,
													VM: patient,
													V5: payments,
													WF: practice,
													sj: rainforestEnv,
													er: $author$project$Api$Data$NotAsked,
													gv: refundType,
													es: refundsFormModel,
													ZD: session,
													Cd: shared,
													Hy: timeFormatter,
													ty: false
												},
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg, adjustmentsFormCmd),
															A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg, refundsFormCmd)
														])));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$CustomerInvoice$One$payments = function (_v0) {
	var record = _v0.b;
	return record.V5;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments = function (invoice) {
	return A2(
		$elm$core$List$map,
		$author$project$Api$Payment$Provider_One,
		A2(
			$author$project$Api$Expandable$withDefault,
			_List_Nil,
			$author$project$Api$Provider$CustomerInvoice$One$payments(invoice)));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initProcessRefundModal = F2(
	function (model, invoice) {
		var _v0 = $author$project$Components$CustomerInvoice$ProcessRefundModal$init($author$project$Api$Data$providerPath)(
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments(invoice))(invoice)(model.VM)(model.Cd)(model.ZD)(model.WF)(false)(model.Hy)(model.FR)(model.sj);
		var processRefundModal = _v0.a;
		var processRefundModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					jG: $elm$core$Maybe$Just(processRefundModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg, processRefundModalCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceRedirect = F2(
	function (patientId, invoiceId) {
		return A2(
			$author$project$Utils$Route$navigate,
			$elm$core$Dict$empty,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
				{aea: invoiceId, VN: patientId}));
	});
var $author$project$Api$Provider$ScheduledPayment$Shared$ScheduledPayment = $elm$core$Basics$identity;
var $author$project$Api$Provider$ScheduledPayment$Shared$Record = F9(
	function (id, amountInCents, passthroughFeesInCents, payable, payment, paymentSource, scheduledOn, status, memo) {
		return {I2: amountInCents, adR: id, aeC: memo, VK: passthroughFeesInCents, afF: payable, VY: payment, V3: paymentSource, agH: scheduledOn, ag7: status};
	});
var $author$project$Api$Provider$ScheduledPayment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'memo',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'scheduled_on',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'payment_source',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'payment',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Payment$One$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'payable',
						$author$project$Api$Common$Payable$Invoice$Min$decoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'passthrough_fees_in_cents',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'amount_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$ScheduledPayment$Shared$Record))))))))));
var $author$project$Api$Provider$ScheduledPayment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ScheduledPayment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath = function (payableId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['scheduled_payments']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['customer_invoices', payableId]),
			$author$project$Api$Data$providerPath));
};
var $author$project$Api$Provider$ScheduledPayment$list = F3(
	function (apiClient, payableId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ScheduledPayment$Shared$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath(payableId)));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkedAsBadDebt = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$markAsBadDebt = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['mark_as_bad_debt']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$markAsBadDebt = function (model) {
	var _v0 = model.Rh;
	if (_v0.$ === 3) {
		var invoice = _v0.a;
		return _Utils_Tuple3(
			model,
			A4(
				$author$project$Api$Provider$CustomerInvoice$markAsBadDebt,
				model.D5,
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkedAsBadDebt),
			_List_Nil);
	} else {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	}
};
var $author$project$Api$Provider$CustomerInvoice$markAsSent = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['mark_as_sent']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$markAsUnsent = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['mark_as_unsent']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$removeCredits = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['remove_credits']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$returnToDraft = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['return_to_draft']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$reverseBadDebt = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reverse_bad_debt']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$reverseCreditTransfer = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['reverse_credit_transfer']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$stopRetrying = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['stop_retrying']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$transferToCredit = F4(
	function (apiClient, id, expand, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['transfer_to_credit']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Api$Provider$CustomerInvoice$update = F5(
	function (apiClient, invoiceId, fields, expand, toMsg) {
		var taxProfile = function () {
			var _v3 = fields.$t;
			if (!_v3.$) {
				var profile = _v3.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'tax_profile',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(profile))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var owner = function () {
			var _v2 = fields.Vp;
			if (!_v2.$) {
				var owner_ = _v2.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'owner',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(owner_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var location = function () {
			var _v1 = fields.aet;
			if (!_v1.$) {
				var location_ = _v1.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'location',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(location_))
								])))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var date = function () {
			var _v0 = fields.MO;
			if (!_v0.$) {
				var date_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'date',
						$author$project$Utils$Date$encode(date_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_Utils_ap(
				owner,
				_Utils_ap(
					location,
					_Utils_ap(date, taxProfile))));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2(
						$author$project$Api$Param$list,
						'expand',
						A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
					]),
				A2(
					$author$project$Api$Data$requestWithJson,
					body,
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(invoiceId)))));
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Closed = 1;
var $author$project$Components$CustomerInvoice$AdjustVoidModal$None = 0;
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Revised = 2;
var $author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse = F3(
	function (model, data, successMsg) {
		if (data.$ === 3) {
			return {
				EC: $elm$core$Platform$Cmd$none,
				ac5: 2,
				y8: _Utils_update(
					model,
					{kj: false}),
				as: _List_fromArray(
					[
						A2($author$project$OutMsg$ShowToast, 3, successMsg)
					])
			};
		} else {
			return {
				EC: $elm$core$Platform$Cmd$none,
				ac5: 1,
				y8: _Utils_update(
					model,
					{kj: false}),
				as: $author$project$OutMsg$handleErrorResponse(data)
			};
		}
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Created = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Voided = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voided = function (_v0) {
	var form = _v0.PB;
	return $author$project$Utils$Form$fields(form).M;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided = function (_v0) {
	var model = _v0;
	return model.DM || A2(
		$elm$core$List$all,
		$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voided,
		A2($elm$core$List$map, $elm$core$Tuple$second, model.W));
};
var $author$project$Api$Provider$InvoiceAdjustment$One$InvoiceAdjustment = 0;
var $author$project$Api$Provider$InvoiceAdjustment$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath = function (customerInvoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['invoice_adjustments']),
		$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(customerInvoiceId));
};
var $author$project$Api$Provider$InvoiceAdjustment$create = F4(
	function (apiClient, customerInvoiceId, body, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$InvoiceAdjustment$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath(customerInvoiceId))));
	});
var $author$project$Api$Provider$Uom$Shared$encode = function (uom) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Uom$Shared$code(uom))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Uom$Shared$name(uom))),
				_Utils_Tuple2(
				'period_quantity',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$int,
					$author$project$Api$Provider$Uom$Shared$periodQuantity(uom))),
				_Utils_Tuple2(
				'period_unit',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Uom$PeriodUnit$toString,
						$author$project$Api$Provider$Uom$Shared$periodUnit(uom)))),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Uom$Shared$type_(uom))),
				_Utils_Tuple2(
				'unit_class',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Uom$Shared$unitClass(uom)))
			]));
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory = function (charge) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$ChargeItem$ForCharge$trackInventory,
			$author$project$Api$Provider$Charge$One$chargeItem(charge)));
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$encodedForm = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	var quantity = fields.M ? $elm$core$Maybe$Just(0) : fields.Bd;
	var returnToInventory = ($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory(fields.abU) && fields.M) ? $elm$core$Maybe$Just(fields.ex) : $elm$core$Maybe$Nothing;
	var encodedCharge = $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Api$Provider$Charge$One$id(fields.abU)))
			]));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'date',
				$author$project$Utils$Date$encode(
					$author$project$Api$Provider$Charge$One$date(fields.abU))),
				_Utils_Tuple2(
				'end_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qs)),
				_Utils_Tuple2('charge', encodedCharge),
				_Utils_Tuple2(
				'price_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Ba)),
				_Utils_Tuple2(
				'return_to_inventory',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, returnToInventory)),
				_Utils_Tuple2(
				'void',
				$elm$json$Json$Encode$bool(fields.M)),
				_Utils_Tuple2(
				'quantity_uom',
				$author$project$Api$Provider$Uom$Shared$encode(fields.Be)),
				_Utils_Tuple2(
				'quantity',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, quantity))
			]));
};
var $author$project$Api$Provider$CustomerInvoice$One$revisionNumber = function (_v0) {
	var record = _v0.b;
	return record.YM;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm = function (_v0) {
	var model = _v0;
	var encodedAdjustments = A2(
		$elm$json$Json$Encode$list,
		$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$encodedForm,
		A2($elm$core$List$map, $elm$core$Tuple$second, model.W));
	return _List_fromArray(
		[
			_Utils_Tuple2('charge_adjustments', encodedAdjustments),
			_Utils_Tuple2(
			'reason',
			A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, model.aeC)),
			_Utils_Tuple2(
			'revision_number',
			$elm$json$Json$Encode$int(
				$author$project$Api$Provider$CustomerInvoice$One$revisionNumber(model.Rh)))
		]);
};
var $author$project$Api$Provider$CustomerInvoice$void = F4(
	function (apiClient, id, _v0, toMsg) {
		var voidReason = _v0.ahR;
		var refundPayments = _v0.aga;
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'refund_payments',
					$elm$json$Json$Encode$bool(refundPayments)),
					_Utils_Tuple2(
					'void_reason',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, voidReason))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['void']),
						$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$voidParams = function (_v0) {
	var model = _v0;
	return {aga: false, ahR: model.aeC};
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$submitCmd = F2(
	function (model, apiClient) {
		return $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model.bj) ? A4(
			$author$project$Api$Provider$CustomerInvoice$void,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(model.Rh),
			$author$project$Components$CustomerInvoice$AdjustmentsForm$voidParams(model.bj),
			$author$project$Components$CustomerInvoice$AdjustVoidModal$Voided) : A4(
			$author$project$Api$Provider$InvoiceAdjustment$create,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(model.Rh),
			$elm$json$Json$Encode$object(
				$author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model.bj)),
			$author$project$Components$CustomerInvoice$AdjustVoidModal$Created);
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentCreated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$None = {$: 0};
var $author$project$Api$Provider$ChargeAdjustment$Preview$endDate = function (_v0) {
	var record = _v0.b;
	return record.qs;
};
var $author$project$Api$Provider$ChargeAdjustment$Shared$quantityAdjustment = function (_v0) {
	var record = _v0;
	return record.Xu;
};
var $author$project$Api$Provider$ChargeAdjustment$Preview$quantityAdjustment = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeAdjustment$Shared$quantityAdjustment(shared);
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$adjustmentPreviewed = F2(
	function (preview, _v0) {
		var model = _v0;
		var fields = $author$project$Utils$Form$fields(model.PB);
		var quantity = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(
				$author$project$Api$Provider$Charge$One$quantity(fields.abU) + $author$project$Api$Provider$ChargeAdjustment$Preview$quantityAdjustment(preview)),
			fields.Bd);
		var newForm = A2(
			$author$project$Utils$Form$set,
			_Utils_update(
				fields,
				{
					qs: $author$project$Api$Provider$ChargeAdjustment$Preview$endDate(preview),
					Bd: quantity
				}),
			model.PB);
		return _Utils_update(
			model,
			{
				tL: $elm$core$Maybe$Just(preview),
				PB: newForm
			});
	});
var $author$project$Api$Provider$ChargeAdjustment$Shared$charge = function (_v0) {
	var record = _v0;
	return record.abU;
};
var $author$project$Api$Provider$ChargeAdjustment$Preview$charge = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeAdjustment$Shared$charge(shared);
};
var $author$project$Api$Provider$InvoiceAdjustment$Preview$chargeAdjustments = function (_v0) {
	var record = _v0.b;
	return record.KP;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$chargeForm = F2(
	function (chargeId, adjustmentsForms) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(chargeId)),
					adjustmentsForms)));
	});
var $author$project$Utils$Tuple3$first = function (_v0) {
	var first_ = _v0.a;
	return first_;
};
var $author$project$Api$Provider$Charge$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CustomerInvoice$Shared$paidInCents = function (_v0) {
	var record = _v0;
	return record.Vu;
};
var $author$project$Api$Provider$CustomerInvoice$One$paidInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$paidInCents(shared);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$GotPreview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError = function (_v0) {
	var errors = _v0.fE;
	return !$elm$core$List$isEmpty(errors);
};
var $author$project$Api$Provider$InvoiceAdjustment$Preview$InvoiceAdjustment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$InvoiceAdjustment$Preview$Record = function (chargeAdjustments) {
	return {KP: chargeAdjustments};
};
var $author$project$Api$Provider$ChargeAdjustment$Preview$ChargeAdjustment = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$ChargeAdjustment$Shared$ChargeAdjustment = $elm$core$Basics$identity;
var $author$project$Api$Provider$ChargeAdjustment$Shared$Record = F6(
	function (priceAdjustmentInCents, quantityAdjustment, subtotalAdjustmentInCents, taxAdjustmentInCents, totalAdjustmentInCents, charge) {
		return {abU: charge, afV: priceAdjustmentInCents, Xu: quantityAdjustment, _6: subtotalAdjustmentInCents, ahj: taxAdjustmentInCents, ahC: totalAdjustmentInCents};
	});
var $author$project$Api$Provider$Charge$Min$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Charge$Min$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$Charge$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Min$Record));
var $author$project$Api$Provider$Charge$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ChargeAdjustment$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'charge',
	$author$project$Api$Provider$Charge$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'total_adjustment_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tax_adjustment_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'subtotal_adjustment_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'quantity_adjustment',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'price_adjustment_in_cents',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Shared$Record)))))));
var $author$project$Api$Provider$ChargeAdjustment$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeAdjustment$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ChargeAdjustment$Preview$Record = F2(
	function (date, endDate) {
		return {MO: date, qs: endDate};
	});
var $author$project$Api$Provider$ChargeAdjustment$Preview$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'date',
		$author$project$Utils$Date$decode,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Preview$Record)));
var $author$project$Api$Provider$ChargeAdjustment$Preview$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ChargeAdjustment$Preview$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$ChargeAdjustment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Preview$ChargeAdjustment)));
var $author$project$Api$Provider$InvoiceAdjustment$Preview$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'charge_adjustments',
	$elm$json$Json$Decode$list($author$project$Api$Provider$ChargeAdjustment$Preview$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Preview$Record));
var $author$project$Api$Provider$InvoiceAdjustment$Preview$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$InvoiceAdjustment$Preview$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$InvoiceAdjustment$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Preview$InvoiceAdjustment)));
var $author$project$Api$Provider$InvoiceAdjustment$previewPath = function (customerInvoiceId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['preview']),
		$author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath(customerInvoiceId));
};
var $author$project$Api$Provider$InvoiceAdjustment$preview = F4(
	function (apiClient, customerInvoiceId, body, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$InvoiceAdjustment$Preview$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$InvoiceAdjustment$previewPath(customerInvoiceId))));
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd = F2(
	function (apiClient, model) {
		var modelRecord = model;
		return $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError(model) ? $elm$core$Platform$Cmd$none : A4(
			$author$project$Api$Provider$InvoiceAdjustment$preview,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(modelRecord.Rh),
			$elm$json$Json$Encode$object(
				$author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model)),
			$author$project$Components$CustomerInvoice$AdjustmentsForm$GotPreview);
	});
var $author$project$Utils$Tuple3$second = function (_v0) {
	var second_ = _v0.b;
	return second_;
};
var $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents = function (_v0) {
	var record = _v0;
	return record.ahC;
};
var $author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents(shared);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount = function (dataPreview) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents,
			$author$project$Api$Data$toMaybe(dataPreview)));
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$FieldUpdated = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$InputChanged = 1;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$None = 0;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateField = F2(
	function (field, formFields) {
		switch (field.$) {
			case 0:
				var dateInputMsg = field.a;
				var _v1 = formFields.qu;
				if (!_v1.$) {
					var endDateInput = _v1.a;
					var _v2 = A2($author$project$Components$DateInput$update, dateInputMsg, endDateInput);
					var dateInput = _v2.a;
					var dateInputCmd = _v2.b;
					var inputEvent = _v2.c;
					var _v3 = function () {
						if (inputEvent.$ === 1) {
							var date = inputEvent.a;
							return _Utils_Tuple2(date, 1);
						} else {
							return _Utils_Tuple2(formFields.qs, 0);
						}
					}();
					var newValue = _v3.a;
					var event = _v3.b;
					var quantityUom = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Api$Provider$Uom$Shared$day,
						A2(
							$elm$core$Maybe$map,
							$author$project$Utils$Uom$matchRange(formFields.MO),
							newValue));
					var quantity = $elm$core$Maybe$Just(
						A3($author$project$Utils$Uom$quantityBetween, quantityUom, formFields.MO, newValue));
					return _Utils_Tuple3(
						_Utils_update(
							formFields,
							{
								qs: newValue,
								qu: $elm$core$Maybe$Just(dateInput),
								Bd: quantity,
								Be: quantityUom
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate),
							dateInputCmd),
						event);
				} else {
					return _Utils_Tuple3(formFields, $elm$core$Platform$Cmd$none, 0);
				}
			case 1:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{
							Bd: $elm$core$Maybe$Just(
								$author$project$Api$Provider$Charge$One$quantity(formFields.abU)),
							ex: bool,
							M: bool
						}),
					$elm$core$Platform$Cmd$none,
					1);
			case 2:
				var bool = field.a;
				var returnToInventory = bool ? false : formFields.ex;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{
							Bd: $elm$core$Maybe$Just(
								$author$project$Api$Provider$Charge$One$quantity(formFields.abU)),
							ex: returnToInventory,
							M: bool,
							HP: bool
						}),
					$elm$core$Platform$Cmd$none,
					1);
			case 3:
				var str = field.a;
				var quantity = $elm$core$String$toInt(str);
				var returnToInventory = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						function (quantity_) {
							return _Utils_cmp(
								$author$project$Api$Provider$Charge$One$quantity(formFields.abU),
								quantity_) > 0;
						},
						quantity));
				var endDate = A3(
					$author$project$Utils$Uom$addTo,
					$elm$core$Maybe$Just(formFields.MO),
					formFields.Be,
					A2($elm$core$Maybe$withDefault, 0, quantity));
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{qs: endDate, Bd: quantity, ex: returnToInventory}),
					$elm$core$Platform$Cmd$none,
					1);
			case 4:
				var str = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{
							Be: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Api$Provider$Uom$Shared$day,
								$author$project$Utils$Uom$fromCode(str))
						}),
					$elm$core$Platform$Cmd$none,
					1);
			case 5:
				var currency = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{Ba: currency}),
					$elm$core$Platform$Cmd$none,
					1);
			case 6:
				var bool = field.a;
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{ex: bool}),
					$elm$core$Platform$Cmd$none,
					1);
			default:
				var itemPriceInCents = A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents, $author$project$Currency$fromFloat),
					formFields.lp);
				return _Utils_Tuple3(
					_Utils_update(
						formFields,
						{xf: true, Ba: itemPriceInCents}),
					$elm$core$Platform$Cmd$none,
					1);
		}
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update = F2(
	function (msg, _v0) {
		var model = _v0;
		var form = model.PB;
		var field = msg;
		var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateField, field, form);
		var newForm = _v2.a;
		var newFormCmd = _v2.b;
		var event = _v2.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: newForm}),
			newFormCmd,
			event);
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$updateChargeForm = F3(
	function (chargeId, newForm, adjustmentsForms) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var form = _v0.b;
				return _Utils_eq(id, chargeId) ? _Utils_Tuple2(id, newForm) : _Utils_Tuple2(id, form);
			},
			adjustmentsForms);
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$formFromResult = function (result) {
	if (!result.$) {
		var _v1 = result.a;
		var form = _v1.a;
		return form;
	} else {
		var form = result.a;
		return form;
	}
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm = F2(
	function (model, form) {
		return _Utils_update(
			model,
			{PB: form});
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCentsValidation = 0;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityValidation = 1;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validator = function () {
	var negativeQuantity = function (fields) {
		return (!fields.M) && (A2($elm$core$Maybe$withDefault, 0, fields.Bd) < 0);
	};
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.Ba;
				},
				_Utils_Tuple2(0, 'Please enter a price.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifTrue,
				negativeQuantity,
				_Utils_Tuple2(1, 'Please enter a valid quantity.'))
			]));
}();
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validate = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Result$mapError,
		$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm(model),
		A2(
			$elm$core$Result$map,
			$elm$core$Tuple$mapFirst(
				$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm(model)),
			A2($author$project$Utils$Form$validate, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validator, model.PB)));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentsValidation = 0;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyValidationError = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$hasAnyValidationError(model.PB);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$validateAdjustments = function (model) {
	var anyAdjustmentError = A2(
		$elm$core$List$any,
		A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyValidationError),
		model.W);
	return anyAdjustmentError ? _List_fromArray(
		[0]) : _List_Nil;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$NewDueValidation = 1;
var $author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount = F3(
	function (totalInCents, totalPayments, totalAdjustment) {
		return (totalInCents + totalAdjustment) - totalPayments;
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$totalInCents = function (_v0) {
	var record = _v0;
	return record.$X;
};
var $author$project$Api$Provider$CustomerInvoice$One$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$totalInCents(shared);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount = function (invoice) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			$author$project$Api$Provider$Payment$One$amountInCents,
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$One$payments(invoice))));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$validateNewDue = function (model) {
	var _v0 = model.afU;
	if (_v0.$ === 3) {
		var preview = _v0.a;
		var totalPayments = $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount(model.Rh);
		var totalInCents = $author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.Rh);
		var totalAdjustment = $author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents(preview);
		var newDue = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount, totalInCents, totalPayments, totalAdjustment);
		return (newDue < 0) ? _List_fromArray(
			[1]) : _List_Nil;
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$validator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$AdjustmentsForm$validateAdjustments),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$AdjustmentsForm$validateNewDue)
		]));
var $author$project$Components$CustomerInvoice$AdjustmentsForm$validate = function (_v0) {
	var model = _v0;
	var newForms = A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$mapSecond($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validate),
			$elm$core$Tuple$mapSecond($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$formFromResult)),
		model.W);
	var newModel = _Utils_update(
		model,
		{W: newForms, fE: _List_Nil});
	return $author$project$Utils$Result$merge(
		A2(
			$elm$core$Result$mapError,
			function (errors) {
				return _Utils_update(
					newModel,
					{fE: errors});
			},
			A2(
				$elm$core$Result$map,
				$rtfeldman$elm_validate$Validate$fromValid,
				A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$CustomerInvoice$AdjustmentsForm$validator, newModel))));
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$VoidAll = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voidAll = F2(
	function (bool, model) {
		return A2(
			$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update,
			$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$VoidAll(bool),
			model);
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var chargeId = msg.a;
				var subMsg = msg.b;
				var _v2 = A2($author$project$Components$CustomerInvoice$AdjustmentsForm$chargeForm, chargeId, model.W);
				if (!_v2.$) {
					var form = _v2.a;
					var _v3 = A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update, subMsg, form);
					var newForm = _v3.a;
					var newFormCmd = _v3.b;
					var event = _v3.c;
					var newPreview = function () {
						if (event === 1) {
							return $author$project$Api$Data$NotAsked;
						} else {
							return model.afU;
						}
					}();
					var newModel = $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(
						_Utils_update(
							model,
							{
								W: A3($author$project$Components$CustomerInvoice$AdjustmentsForm$updateChargeForm, chargeId, newForm, model.W),
								afU: newPreview
							}));
					var previewCmd = function () {
						if (event === 1) {
							return A2($author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd, apiClient, newModel);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId),
									newFormCmd),
									previewCmd
								])),
						ac5: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
						y8: newModel,
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$CustomerInvoice$AdjustmentsForm$None, y8: model, as: _List_Nil};
				}
			case 1:
				var bool = msg.a;
				var voidedForms = A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(
						$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voidAll(bool)),
					model.W);
				var newForms = A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond($author$project$Utils$Tuple3$first),
					voidedForms);
				var newModel = $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(
					_Utils_update(
						model,
						{W: newForms, afU: $author$project$Api$Data$NotAsked}));
				var cmds = A2(
					$elm$core$List$map,
					function (_v6) {
						var chargeId = _v6.a;
						var cmd = _v6.b;
						return A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId),
							cmd);
					},
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$mapSecond($author$project$Utils$Tuple3$second),
						voidedForms));
				return {
					EC: $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd, apiClient, newModel),
							cmds)),
					ac5: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
					y8: newModel,
					as: _List_Nil
				};
			case 2:
				var dataPreview = msg.a;
				if (dataPreview.$ === 3) {
					var preview = dataPreview.a;
					var totalRefundedAmount = model.agb ? A2(
						$elm$core$Basics$min,
						$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Rh),
						A2(
							$elm$core$Basics$max,
							-$author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount(dataPreview),
							0)) : 0;
					var adjustmentPreview = function (chargeId) {
						return $elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Api$Provider$ChargeAdjustment$Preview$charge,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Api$Provider$Charge$Min$id,
										$elm$core$Basics$eq(chargeId))),
								$author$project$Api$Provider$InvoiceAdjustment$Preview$chargeAdjustments(preview)));
					};
					var newForms = A2(
						$elm$core$List$map,
						function (_v8) {
							var chargeId = _v8.a;
							var form = _v8.b;
							return _Utils_Tuple2(
								chargeId,
								function () {
									var _v9 = adjustmentPreview(chargeId);
									if (!_v9.$) {
										var adjustmentPreview_ = _v9.a;
										return A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$adjustmentPreviewed, adjustmentPreview_, form);
									} else {
										return form;
									}
								}());
						},
						model.W);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentCreated(
							A2(
								$elm$core$Basics$max,
								-$author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount(dataPreview),
								0)),
						y8: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(
							_Utils_update(
								model,
								{W: newForms, afU: dataPreview, oP: totalRefundedAmount})),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
						y8: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(
							_Utils_update(
								model,
								{afU: dataPreview})),
						as: _List_Nil
					};
				}
			default:
				var string = msg.a;
				var memo = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
					y8: _Utils_update(
						model,
						{aeC: memo}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$CustomerInvoice$AdjustVoidModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var newModel = _Utils_update(
					model,
					{
						bj: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(model.bj),
						kj: true
					});
				return {
					EC: A2($author$project$Components$CustomerInvoice$AdjustVoidModal$submitCmd, newModel, apiClient),
					ac5: 0,
					y8: newModel,
					as: _List_Nil
				};
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 2:
				var subMsg = msg.a;
				var adjustmentsFormResult = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$update, apiClient, subMsg, model.bj);
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg, adjustmentsFormResult.EC),
					ac5: 0,
					y8: _Utils_update(
						model,
						{bj: adjustmentsFormResult.y8}),
					as: adjustmentsFormResult.as
				};
			case 3:
				var dataAdjustments = msg.a;
				return A3($author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse, model, dataAdjustments, 'Revision created!');
			default:
				var dataVoid = msg.a;
				return A3($author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse, model, dataVoid, 'Invoice voided!');
		}
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReader = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderSelectMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Closed = 0;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$None = 1;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAt = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaymentCreated = 2;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaymentSourceSelectMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Source = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardCreated = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createCard = F5(
	function (basePath, apiClient, session, formFields, readCard) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (basePath_) {
					return A5(
						$author$project$Api$Card$create,
						basePath_,
						apiClient,
						session,
						{
							KI: $elm$core$Maybe$Nothing,
							Mi: $elm$core$Maybe$Just(readCard.Mi),
							Sz: $elm$core$Maybe$Nothing,
							U7: $elm$core$Maybe$Just(readCard.U7),
							V1: readCard.V1
						},
						$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardCreated(formFields));
				},
				basePath));
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Created = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$payableIdAndKey = function (payable) {
	return _Utils_Tuple2(
		'customer_invoice_id',
		$author$project$Api$Provider$CustomerInvoice$One$id(payable));
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createPayment = F7(
	function (basePath, apiClient, session, payable, formFields, cardReaderCard, cardReader) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var selectedSource = function () {
			var _v3 = _Utils_Tuple2(cardReaderCard, cardReader);
			if (_v3.a.$ === 1) {
				if (_v3.b.$ === 1) {
					var _v4 = _v3.a;
					var _v5 = _v3.b;
					return A2(
						$elm$core$Maybe$map,
						function (source) {
							return {
								adR: $elm$core$Maybe$Just(
									$author$project$Api$Source$id(source)),
								ahI: $author$project$Api$Source$type_(source)
							};
						},
						fields.Hg);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				var cardReaderCard_ = _v3.a.a;
				return $elm$core$Maybe$Just(
					{
						adR: $elm$core$Maybe$Just(
							$author$project$Api$Card$id(cardReaderCard_)),
						ahI: $author$project$Api$Card$type_(cardReaderCard_)
					});
			}
		}();
		var _v0 = function () {
			var _v1 = fields.KI;
			_v1$3:
			while (true) {
				if (!_v1.$) {
					switch (_v1.a) {
						case 'credit':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('card'),
								$elm$core$Maybe$Just('credit'));
						case 'amex':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('amex'),
								$elm$core$Maybe$Just('credit'));
						case 'debit':
							return _Utils_Tuple2(
								$elm$core$Maybe$Just('card'),
								$elm$core$Maybe$Just('debit'));
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
		}();
		var selectedCardType = _v0.a;
		var selectedCardFunding = _v0.b;
		var _v2 = $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$payableIdAndKey(payable);
		var payableKey = _v2.a;
		var payableId = _v2.b;
		return A7(
			$author$project$Api$Payment$create,
			basePath,
			apiClient,
			session,
			payableKey,
			payableId,
			{
				I2: A2(
					$elm$core$Maybe$withDefault,
					$author$project$Currency$fromInt(fields.mB),
					fields.I2),
				abR: A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, cardReader),
				O4: false,
				aeC: fields.aeC,
				Vt: fields.Vt,
				agN: selectedCardFunding,
				agO: selectedCardType,
				Hg: selectedSource,
				ag2: $elm$core$Maybe$Just(!fields.Ct)
			},
			$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Created(formFields));
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotCardReaders = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchCardReaders = function (apiClient) {
	return A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotCardReaders);
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var _int = field.a;
				return _Utils_update(
					fields,
					{I2: _int});
			case 1:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{Vt: date, Gz: dateInput});
			case 3:
				var source = field.a;
				return _Utils_update(
					fields,
					{Hg: source});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						aeC: $author$project$Utils$String$toMaybe(string)
					});
			case 4:
				var cardReader = field.a;
				return _Utils_update(
					fields,
					{abR: cardReader});
			case 5:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Ct: bool});
			default:
				var cardType = field.a;
				return _Utils_update(
					fields,
					{
						KI: $elm$core$Maybe$Just(cardType)
					});
		}
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderValidation = 1;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardTypeValidation = 3;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$SourceValidation = 2;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCentsValidation = 0;
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$validateAmountInCents = function (fields) {
	var min = 50;
	var max = fields.mB;
	return A2(
		$author$project$Utils$Validate$isInvalidCurrency,
		{
			abi: false,
			yQ: $elm$core$Maybe$Just(max),
			TZ: $elm$core$Maybe$Just(min)
		},
		fields.I2) ? _List_fromArray(
		[
			_Utils_Tuple2(
			0,
			'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
		]) : _List_Nil;
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsValidator = function (useExistingSources) {
	return $rtfeldman$elm_validate$Validate$all(
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$validateAmountInCents)
					]),
					useExistingSources ? _List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifNothing,
						function ($) {
							return $.Hg;
						},
						_Utils_Tuple2(2, 'Please pick a source.'))
					]) : _List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifNothing,
						function ($) {
							return $.abR;
						},
						_Utils_Tuple2(1, 'Please pick a card reader.')),
						A2(
						$rtfeldman$elm_validate$Validate$ifNothing,
						function ($) {
							return $.KI;
						},
						_Utils_Tuple2(3, 'Please pick a card type.'))
					])
				])));
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$shouldDefaultCardReaderSwitch = F3(
	function (apiClient, response, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.pN, model.pD);
			if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
				var _v2 = _v1.a;
				var cards = _v2.a;
				var _v3 = _v1.b;
				var bankAccounts = _v3.a;
				var useCardReader = $elm$core$List$isEmpty(cards) && ($elm$core$List$isEmpty(bankAccounts) && ($author$project$Api$Practice$usesCardReaders(model.WF) && (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD))));
				return _Utils_Tuple3(
					!useCardReader,
					useCardReader ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
					useCardReader ? $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchCardReaders(apiClient) : $elm$core$Platform$Cmd$none);
			} else {
				return _Utils_Tuple3(model.V, model.hG, $elm$core$Platform$Cmd$none);
			}
		}();
		var useExistingSources = _v0.a;
		var cardReaders = _v0.b;
		var cmd = _v0.c;
		return {
			EC: cmd,
			ac5: 1,
			y8: _Utils_update(
				model,
				{hG: cardReaders, V: useExistingSources}),
			as: $author$project$OutMsg$handleErrorResponse(response)
		};
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate,
					A2(field, newDateInput, date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate,
					A2(
						field,
						newDateInput,
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return {
			EC: A2(
				$elm$core$Platform$Cmd$map,
				toMsg(newDateInput),
				subCmd),
			ac5: 1,
			y8: _Utils_update(
				model,
				{PB: newForm}),
			as: _List_Nil
		};
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 8:
				var response = msg.a;
				return A3(
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$shouldDefaultCardReaderSwitch,
					apiClient,
					response,
					_Utils_update(
						model,
						{pN: response}));
			case 9:
				var response = msg.a;
				return A3(
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$shouldDefaultCardReaderSwitch,
					apiClient,
					response,
					_Utils_update(
						model,
						{pD: response}));
			case 10:
				var response = msg.a;
				return {
					EC: $author$project$Ports$LocalStorage$getItem('last-used-card-reader'),
					ac5: 1,
					y8: _Utils_update(
						model,
						{hG: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 11:
				var _v2 = msg.a;
				var key = _v2.a;
				var value = _v2.b;
				var _v3 = _Utils_Tuple2(key, value);
				if ((_v3.a === 'last-used-card-reader') && (!_v3.b.$)) {
					var lastUsedCardReaderId = _v3.b.a;
					var cardReader = A2(
						$elm_community$list_extra$List$Extra$find,
						function (cardReader_) {
							return _Utils_eq(
								$author$project$Api$Provider$CardReader$All$id(cardReader_),
								lastUsedCardReaderId);
						},
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							$author$project$Api$Data$toMaybe(model.hG)));
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate,
						$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReader(cardReader),
						model.PB);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 12:
				var useExistingSources = msg.a;
				var _v4 = ((!useExistingSources) && _Utils_eq(model.hG, $author$project$Api$Data$NotAsked)) ? _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchCardReaders(apiClient)) : _Utils_Tuple2(model.hG, $elm$core$Platform$Cmd$none);
				var cardReaders = _v4.a;
				var fetchCardReadersCmd = _v4.b;
				return {
					EC: fetchCardReadersCmd,
					ac5: 1,
					y8: _Utils_update(
						model,
						{hG: cardReaders, V: useExistingSources}),
					as: _List_Nil
				};
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate, field, model.PB);
				var passthroughFeesCmd = function () {
					if (field.$ === 6) {
						var amountInCents = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Currency$toInt(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Currency$zero,
									$author$project$Utils$Form$fields(model.PB).I2)));
						return A5(
							$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd,
							apiClient,
							model.V,
							amountInCents,
							$author$project$Utils$Form$fields(newForm),
							model.VN);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {
					EC: passthroughFeesCmd,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 2:
				var amountInCents = A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Currency$toInt(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Currency$zero,
							$author$project$Utils$Form$fields(model.PB).I2)));
				var passthroughFeesCmd = A5(
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd,
					apiClient,
					model.V,
					amountInCents,
					$author$project$Utils$Form$fields(model.PB),
					model.VN);
				return {
					EC: passthroughFeesCmd,
					ac5: 1,
					y8: _Utils_update(
						model,
						{s7: amountInCents}),
					as: _List_Nil
				};
			case 3:
				var paymentSourceSelectMsg = msg.a;
				var amountInCents = A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Currency$toInt(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Currency$zero,
							$author$project$Utils$Form$fields(model.PB).I2)));
				var _v6 = A2($author$project$Ui$Form$SearchableSelect$update, paymentSourceSelectMsg, model.r_);
				var selectModel = _v6.a;
				var selectCmd = _v6.b;
				var event = _v6.c;
				var newForm = function () {
					if ((!event.$) && (!event.a.$)) {
						var maybeSource = event.a.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate,
							$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Source(maybeSource),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				var passthroughFeesCmd = function () {
					if ((!event.$) && (!event.a.$)) {
						return A5(
							$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd,
							apiClient,
							model.V,
							amountInCents,
							$author$project$Utils$Form$fields(newForm),
							model.VN);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaymentSourceSelectMsg, selectCmd),
								passthroughFeesCmd
							])),
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm, r_: selectModel, s7: amountInCents}),
					as: _List_Nil
				};
			case 4:
				var cardReaderSelectMsg = msg.a;
				var _v9 = A2($author$project$Ui$Form$SearchableSelect$update, cardReaderSelectMsg, model.pM);
				var selectModel = _v9.a;
				var selectCmd = _v9.b;
				var event = _v9.c;
				var newForm = function () {
					if ((!event.$) && (!event.a.$)) {
						var maybeCardReader = event.a.a;
						return A3(
							$author$project$Utils$Form$update,
							$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate,
							$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReader(maybeCardReader),
							model.PB);
					} else {
						return model.PB;
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderSelectMsg, selectCmd),
					ac5: 1,
					y8: _Utils_update(
						model,
						{pM: selectModel, PB: newForm}),
					as: _List_Nil
				};
			case 5:
				var _v11 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsValidator(model.V),
					model.PB);
				if (!_v11.$) {
					var _v12 = _v11.a;
					var newForm = _v12.a;
					var validFormFields = _v12.b;
					var _v13 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var cardReader = _v13.abR;
					var storeCard = _v13.Ct;
					var _v14 = function () {
						var _v15 = _Utils_Tuple3(
							model.V,
							cardReader,
							$author$project$Api$Practice$paymentProcessor(model.WF));
						if (_v15.a) {
							return _Utils_Tuple3(
								$elm$core$Maybe$Nothing,
								A7($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createPayment, model.rX, apiClient, model.ZD, model.afF, validFormFields, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
								$author$project$Api$Data$Loading);
						} else {
							if (!_v15.b.$) {
								if (_v15.c === 'rainforest') {
									var cardReader_ = _v15.b.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										A7(
											$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createPayment,
											model.rX,
											apiClient,
											model.ZD,
											model.afF,
											validFormFields,
											$elm$core$Maybe$Nothing,
											$elm$core$Maybe$Just(cardReader_)),
										$author$project$Api$Data$Loading);
								} else {
									var cardReader_ = _v15.b.a;
									return A2(
										$author$project$Utils$Tuple3$fromTuple2,
										model.af,
										A3(
											$elm$core$Tuple$mapBoth,
											function (m) {
												return $elm$core$Maybe$Just(
													_Utils_Tuple2(m, validFormFields));
											},
											$elm$core$Platform$Cmd$map($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg),
											A7(
												$author$project$Components$CardReader$ConnectingModal$init,
												apiClient,
												model.ZD,
												model.FR,
												model.sj,
												cardReader_,
												$author$project$Components$CardReader$ConnectingModal$Patient(model.VN),
												storeCard)));
								}
							} else {
								var _v16 = _v15.b;
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, model.af);
							}
						}
					}();
					var cardReaderConnectingModal = _v14.a;
					var cmd = _v14.b;
					var paymentCreatedSaveRequest = _v14.c;
					return {
						EC: cmd,
						ac5: 1,
						y8: _Utils_update(
							model,
							{hF: cardReaderConnectingModal, PB: newForm, af: paymentCreatedSaveRequest}),
						as: _List_Nil
					};
				} else {
					var newForm = _v11.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 6:
				var validFormFields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var payment = response.a;
					var _v18 = function () {
						var _v19 = _Utils_Tuple2(
							$author$project$Api$Payment$cardReader(payment),
							$author$project$Api$Payment$status(payment));
						if (!_v19.a.$) {
							var cardReader = _v19.a.a;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								$elm$core$Maybe$Nothing,
								A3(
									$elm$core$Tuple$mapBoth,
									function (m) {
										return $elm$core$Maybe$Just(
											_Utils_Tuple2(m, validFormFields));
									},
									$elm$core$Platform$Cmd$map($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg),
									A6(
										$author$project$Components$CardReader$PaymentModal$init,
										apiClient,
										model.ZD,
										model.FR,
										model.sj,
										$author$project$Api$Provider$CardReader$Shared$id(cardReader),
										payment)));
						} else {
							if (_v19.b === 'failed') {
								var _v20 = _v19.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Platform$Cmd$none,
									$elm$core$Maybe$Just(
										_Utils_Tuple2('Payment failed', 1)));
							} else {
								var _v21 = _v19.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Platform$Cmd$none,
									$elm$core$Maybe$Just(
										_Utils_Tuple2('Payment processed successfully', 3)));
							}
						}
					}();
					var cardReaderPaymentModal = _v18.a;
					var cardReaderPaymentModalCmd = _v18.b;
					var message = _v18.c;
					return {
						EC: cardReaderPaymentModalCmd,
						ac5: _Utils_eq(cardReaderPaymentModal, $elm$core$Maybe$Nothing) ? 2 : 1,
						y8: _Utils_update(
							model,
							{bS: cardReaderPaymentModal, af: $author$project$Api$Data$NotAsked}),
						as: A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								function (_v22) {
									var toastMessage_ = _v22.a;
									var toastLevel_ = _v22.b;
									return _List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, toastLevel_, toastMessage_)
										]);
								},
								message))
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{af: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 7:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAtDateInputMsg,
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAt,
					function ($) {
						return $.Vt;
					});
			case 13:
				var subMsg = msg.a;
				var _v23 = model.hF;
				if (!_v23.$) {
					var _v24 = _v23.a;
					var cardReaderConnectingModal = _v24.a;
					var validFormFields = _v24.b;
					var cardReaderConnectingModalResult = A3($author$project$Components$CardReader$ConnectingModal$update, apiClient, subMsg, cardReaderConnectingModal);
					var _v25 = function () {
						var _v26 = cardReaderConnectingModalResult.ac5;
						switch (_v26.$) {
							case 1:
								var card = _v26.a;
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A5($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createCard, model.Hh, apiClient, model.ZD, validFormFields, card));
							case 0:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.af, $elm$core$Platform$Cmd$none);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(cardReaderConnectingModalResult.y8, validFormFields)),
									model.af,
									$elm$core$Platform$Cmd$none);
						}
					}();
					var cardReaderConnectingModal_ = _v25.a;
					var paymentCreatedSaveRequest = _v25.b;
					var cmd = _v25.c;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg, cardReaderConnectingModalResult.EC),
									cmd
								])),
						ac5: 1,
						y8: _Utils_update(
							model,
							{hF: cardReaderConnectingModal_, af: paymentCreatedSaveRequest}),
						as: cardReaderConnectingModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 14:
				var subMsg = msg.a;
				var _v27 = model.bS;
				if (!_v27.$) {
					var _v28 = _v27.a;
					var cardReaderPaymentModal = _v28.a;
					var validFormFields = _v28.b;
					var cardReaderPaymentModalResult = A3($author$project$Components$CardReader$PaymentModal$update, apiClient, subMsg, cardReaderPaymentModal);
					var _v29 = cardReaderPaymentModalResult.ac5;
					switch (_v29) {
						case 1:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 2,
								y8: _Utils_update(
									model,
									{bS: $elm$core$Maybe$Nothing, af: $author$project$Api$Data$NotAsked}),
								as: _Utils_ap(
									cardReaderPaymentModalResult.as,
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, 'Payment processed successfully')
										]))
							};
						case 3:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 2,
								y8: _Utils_update(
									model,
									{bS: $elm$core$Maybe$Nothing, af: $author$project$Api$Data$NotAsked}),
								as: cardReaderPaymentModalResult.as
							};
						case 2:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 2,
								y8: _Utils_update(
									model,
									{bS: $elm$core$Maybe$Nothing, af: $author$project$Api$Data$NotAsked}),
								as: _Utils_ap(
									cardReaderPaymentModalResult.as,
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 1, 'Payment failed')
										]))
							};
						case 0:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 1,
								y8: _Utils_update(
									model,
									{bS: $elm$core$Maybe$Nothing, af: $author$project$Api$Data$NotAsked}),
								as: cardReaderPaymentModalResult.as
							};
						default:
							return {
								EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EC),
								ac5: 1,
								y8: _Utils_update(
									model,
									{
										bS: $elm$core$Maybe$Just(
											_Utils_Tuple2(cardReaderPaymentModalResult.y8, validFormFields))
									}),
								as: cardReaderPaymentModalResult.as
							};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 15:
				var validFormFields = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var card = response.a;
					return {
						EC: A7(
							$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createPayment,
							model.rX,
							apiClient,
							model.ZD,
							model.afF,
							validFormFields,
							$elm$core$Maybe$Just(card),
							$elm$core$Maybe$Nothing),
						ac5: 1,
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{af: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var fees = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{VJ: fees}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Closed = 1;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$None = 0;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForPartialRefund = 3;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForPaymentOrVoid = 4;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForRefund = 2;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$FullRefundCreated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund = function (refundType) {
	_v0$2:
	while (true) {
		if (!refundType.$) {
			switch (refundType.a) {
				case 1:
					var _v1 = refundType.a;
					return true;
				case 2:
					var _v2 = refundType.a;
					return true;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return false;
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund = F6(
	function (apiClient, model, fields, payment, amountInCents, toMsg) {
		if ($author$project$Api$Payment$amountInCents(payment) > 0) {
			var paymentPath = A2(
				$author$project$Api$Payment$paymentPath,
				model.vD,
				$author$project$Api$Payment$id(payment));
			return A4(
				$author$project$Api$Provider$Refund$create,
				paymentPath,
				apiClient,
				{
					I2: amountInCents,
					O4: $author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund(model.gv) || (!$author$project$Api$Payment$isRefundableOnPaymentProcessor(payment)),
					aeC: fields.aeC
				},
				toMsg);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$createFullRefund = F3(
	function (model, apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A2(
			$elm$core$List$map,
			function (payment) {
				return A6(
					$author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund,
					apiClient,
					model,
					fields,
					payment,
					$author$project$Currency$fromInt(
						$author$project$Api$Payment$amountInCents(payment)),
					$author$project$Components$CustomerInvoice$ProcessRefundModal$FullRefundCreated);
			},
			model.V5);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceAdjustmentCreated = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$PartialRefundCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$CustomerInvoice$RefundsForm$encodedForm = F2(
	function (external, form) {
		var fields = $author$project$Utils$Form$fields(form);
		var encodedRefund = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(
						$author$project$Api$Payment$id(fields.VY)))
				]));
		var encodedExternal = $elm$json$Json$Encode$bool(
			external || (!$author$project$Api$Payment$isRefundableOnPaymentProcessor(fields.VY)));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2('payment', encodedRefund),
					_Utils_Tuple2(
					'amount_in_cents',
					A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.I2)),
					_Utils_Tuple2('external', encodedExternal)
				]));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$positiveAmountInCents = function (form) {
	var amountInCents = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Currency$toInt,
			$author$project$Utils$Form$fields(form).I2));
	return amountInCents > 0;
};
var $author$project$Components$CustomerInvoice$RefundsForm$validRefundForms = function (forms) {
	return A2(
		$elm$core$List$filter,
		$author$project$Components$CustomerInvoice$RefundsForm$positiveAmountInCents,
		A2($elm$core$List$map, $elm$core$Tuple$second, forms));
};
var $author$project$Components$CustomerInvoice$RefundsForm$encodedForms = F2(
	function (_v0, external) {
		var model = _v0;
		var encodedRefunds = A2(
			$elm$json$Json$Encode$list,
			$author$project$Components$CustomerInvoice$RefundsForm$encodedForm(external),
			$author$project$Components$CustomerInvoice$RefundsForm$validRefundForms(model.ao));
		return _List_fromArray(
			[
				_Utils_Tuple2('refunds', encodedRefunds)
			]);
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyChange = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	return !_Utils_eq(
		fields,
		A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields, fields.abU, false));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyChange = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$List$any,
		A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyChange),
		model.W);
};
var $author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError = function (_v0) {
	var errors = _v0.fE;
	return !$elm$core$List$isEmpty(errors);
};
var $author$project$Components$CustomerInvoice$RefundsForm$paymentsRefundAmounts = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Utils$Form$fields,
				function (fields) {
					return _Utils_Tuple2(fields.VY, fields.I2);
				})),
		model.ao);
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$createPartialRefund = F2(
	function (apiClient, model) {
		if ($author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError(model.es)) {
			return $elm$core$Platform$Cmd$none;
		} else {
			if ($author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyChange(model.bj)) {
				var encodedBody = $elm$json$Json$Encode$object(
					_Utils_ap(
						$author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model.bj),
						A2(
							$author$project$Components$CustomerInvoice$RefundsForm$encodedForms,
							model.es,
							$author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund(model.gv))));
				return A4(
					$author$project$Api$Provider$InvoiceAdjustment$create,
					apiClient,
					$author$project$Api$Provider$CustomerInvoice$One$id(model.Rh),
					encodedBody,
					$author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceAdjustmentCreated);
			} else {
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (_v0) {
							var payment = _v0.a;
							var amountInCents = _v0.b;
							if (!amountInCents.$) {
								var amountInCents_ = amountInCents.a;
								return A6(
									$author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund,
									apiClient,
									model,
									$author$project$Utils$Form$fields(model.PB),
									payment,
									amountInCents_,
									$author$project$Components$CustomerInvoice$ProcessRefundModal$PartialRefundCreated);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						},
						$author$project$Components$CustomerInvoice$RefundsForm$paymentsRefundAmounts(model.es)));
			}
		}
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$formFieldsUpdate = F2(
	function (field, fields) {
		var string = field;
		return _Utils_update(
			fields,
			{
				aeC: $author$project$Utils$String$toMaybe(string)
			});
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$GotInvoice = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$invoiceExpands = _List_fromArray(
	[0, 1, 2, 3]);
var $author$project$Components$CustomerInvoice$ProcessRefundModal$retrieveInvoice = F2(
	function (apiClient, invoiceId) {
		return A4($author$project$Api$Provider$CustomerInvoice$retrieve, apiClient, invoiceId, $author$project$Components$CustomerInvoice$ProcessRefundModal$invoiceExpands, $author$project$Components$CustomerInvoice$ProcessRefundModal$GotInvoice);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$initCreatePaymentModal = F4(
	function (apiClient, model, external, invoice) {
		var patientPath = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$patientPath,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$Shared$id,
				$author$project$Api$Provider$CustomerInvoice$One$owner(model.Rh)));
		var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.Cd.cO)(model.Cd.Hy)(
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(invoice)))(patientPath)(apiClient)(model.ZD)(
			$author$project$Api$Practice$Provider(model.WF))(model.FR)(model.sj)(
			function (d) {
				return _Utils_update(
					d,
					{O4: external, oo: model.FR});
			})(
			A2(
				$author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice,
				$author$project$Api$Provider$Patient$One$id(model.VM),
				invoice));
		var createPaymentModal = _v0.a;
		var createPaymentModalCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					lC: $elm$core$Maybe$Just(createPaymentModal)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg, createPaymentModalCmd));
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$showPaymentModal = F3(
	function (apiClient, model, external) {
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A4($author$project$Components$CustomerInvoice$ProcessRefundModal$initCreatePaymentModal, apiClient, model, external, model.Rh));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$None = {$: 0};
var $author$project$Components$CustomerInvoice$RefundsForm$TotalRefundAmountChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerInvoice$RefundsForm$PartialRefundAmountInCents = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate = F2(
	function (field, fields) {
		var currency = field;
		return _Utils_update(
			fields,
			{I2: currency});
	});
var $author$project$Components$CustomerInvoice$RefundsForm$assignMaxiumumRefund = F2(
	function (remainingAmount, _v0) {
		var paymentId = _v0.a;
		var form = _v0.b;
		var refundAmount = A2(
			$elm$core$Basics$min,
			remainingAmount,
			$author$project$Api$Payment$amountInCents(
				$author$project$Utils$Form$fields(form).VY));
		var newRemainingAmount = remainingAmount - refundAmount;
		var newForm = $author$project$Utils$Form$fromValidateResult(
			A2(
				$author$project$Utils$Form$validate,
				$author$project$Components$CustomerInvoice$RefundsForm$refundValidator,
				A3(
					$author$project$Utils$Form$update,
					$author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate,
					$elm$core$Maybe$Just(
						$author$project$Currency$fromInt(refundAmount)),
					form)));
		return _Utils_Tuple2(
			newRemainingAmount,
			_Utils_Tuple2(paymentId, newForm));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$findRefundForm = F2(
	function (paymentId, forms) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq(paymentId)),
					forms)));
	});
var $elm_community$list_extra$List$Extra$mapAccuml = F3(
	function (f, acc0, list) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (x, _v1) {
					var acc1 = _v1.a;
					var ys = _v1.b;
					var _v2 = A2(f, acc1, x);
					var acc2 = _v2.a;
					var y = _v2.b;
					return _Utils_Tuple2(
						acc2,
						A2($elm$core$List$cons, y, ys));
				}),
			_Utils_Tuple2(acc0, _List_Nil),
			list);
		var accFinal = _v0.a;
		var generatedList = _v0.b;
		return _Utils_Tuple2(
			accFinal,
			$elm$core$List$reverse(generatedList));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$updateRefundForm = F3(
	function (paymentId, newForm, forms) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var form = _v0.b;
				return _Utils_eq(id, paymentId) ? _Utils_Tuple2(id, newForm) : _Utils_Tuple2(id, form);
			},
			forms);
	});
var $author$project$Components$CustomerInvoice$RefundsForm$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var adjustmentAmount = msg.a;
			var _v2 = A3($elm_community$list_extra$List$Extra$mapAccuml, $author$project$Components$CustomerInvoice$RefundsForm$assignMaxiumumRefund, adjustmentAmount, model.ao);
			var newForms = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{pn: adjustmentAmount, ao: newForms}),
				$elm$core$Platform$Cmd$none,
				$author$project$Components$CustomerInvoice$RefundsForm$None);
		} else {
			var paymentId = msg.a;
			var field = msg.b;
			var _v3 = A2($author$project$Components$CustomerInvoice$RefundsForm$findRefundForm, paymentId, model.ao);
			if (!_v3.$) {
				var form = _v3.a;
				var newForm = $author$project$Utils$Form$fromValidateResult(
					A2(
						$author$project$Utils$Form$validate,
						$author$project$Components$CustomerInvoice$RefundsForm$refundValidator,
						A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate, field, form)));
				var newForms = A3($author$project$Components$CustomerInvoice$RefundsForm$updateRefundForm, paymentId, newForm, model.ao);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ao: newForms}),
					$elm$core$Platform$Cmd$none,
					$author$project$Components$CustomerInvoice$RefundsForm$TotalRefundAmountChanged(
						$author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount(newForms)));
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$CustomerInvoice$RefundsForm$None);
			}
		}
	});
var $author$project$Components$CustomerInvoice$RefundsForm$GotAdjustmentAmount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerInvoice$RefundsForm$updateAdjustmentAmount = function (adjustmentAmount) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(
			$author$project$Components$CustomerInvoice$RefundsForm$GotAdjustmentAmount(adjustmentAmount)));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$updateRefundAmount = F2(
	function (amount, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{oP: amount});
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceVoided = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$voidInvoice = F2(
	function (model, apiClient) {
		return A4(
			$author$project$Api$Provider$CustomerInvoice$void,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(model.Rh),
			{
				aga: false,
				ahR: $elm$core$Maybe$Just('')
			},
			$author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceVoided);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$rtfeldman$elm_validate$Validate$all(_List_Nil),
					model.PB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					var cmd = model.fQ ? $elm$core$Platform$Cmd$batch(
						A3($author$project$Components$CustomerInvoice$ProcessRefundModal$createFullRefund, model, apiClient, validFormFields)) : A2($author$project$Components$CustomerInvoice$ProcessRefundModal$createPartialRefund, apiClient, model);
					return {
						EC: cmd,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm, er: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v1.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 2:
				var toggle = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{fQ: toggle}),
					as: _List_Nil
				};
			case 14:
				var toggle = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							gv: $elm$core$Maybe$Just(toggle)
						}),
					as: _List_Nil
				};
			case 3:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$ProcessRefundModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var invoiceId = $author$project$Api$Provider$CustomerInvoice$One$id(model.Rh);
					return {
						EC: A2($author$project$Components$CustomerInvoice$ProcessRefundModal$retrieveInvoice, apiClient, invoiceId),
						ac5: 2,
						y8: _Utils_update(
							model,
							{er: response}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{er: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 5:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 3,
					y8: model,
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 8:
				var _v4 = A3($author$project$Components$CustomerInvoice$ProcessRefundModal$showPaymentModal, apiClient, model, false);
				var newModel = _v4.a;
				var cmd = _v4.b;
				var outMsgs = _v4.c;
				return {
					EC: cmd,
					ac5: 0,
					y8: _Utils_update(
						newModel,
						{rI: true}),
					as: outMsgs
				};
			case 11:
				var subMsg = msg.a;
				var _v5 = model.lC;
				if (!_v5.$) {
					var createPaymentModal = _v5.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, apiClient, subMsg, createPaymentModal);
					var _v6 = function () {
						var _v7 = createPaymentModalResult.ac5;
						switch (_v7) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.y8),
									model.Rh,
									0);
							case 2:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, 4);
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, 0);
						}
					}();
					var createPaymentModal_ = _v6.a;
					var invoice = _v6.b;
					var event = _v6.c;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg, createPaymentModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{lC: createPaymentModal_, Rh: invoice, rI: false}),
						as: createPaymentModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				var subMsg = msg.a;
				var adjustmentsFormResult = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$update, apiClient, subMsg, model.bj);
				var _v8 = function () {
					var _v9 = adjustmentsFormResult.ac5;
					if (!_v9.$) {
						return _Utils_Tuple3(adjustmentsFormResult.y8, 0, $elm$core$Platform$Cmd$none);
					} else {
						var adjustmentAmount = _v9.a;
						var refundsFormCmd = A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg,
							$author$project$Components$CustomerInvoice$RefundsForm$updateAdjustmentAmount(adjustmentAmount));
						return _Utils_Tuple3(adjustmentsFormResult.y8, 0, refundsFormCmd);
					}
				}();
				var adjustmentsForm_ = _v8.a;
				var event = _v8.b;
				var cmd = _v8.c;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg, adjustmentsFormResult.EC)
							])),
					ac5: event,
					y8: _Utils_update(
						model,
						{bj: adjustmentsForm_}),
					as: adjustmentsFormResult.as
				};
			case 12:
				var response = msg.a;
				var newModel = function () {
					if (response.$ === 3) {
						var invoice_ = response.a;
						return _Utils_update(
							model,
							{Rh: invoice_});
					} else {
						return model;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: newModel,
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 9:
				return {
					EC: A2($author$project$Components$CustomerInvoice$ProcessRefundModal$voidInvoice, model, apiClient),
					ac5: 0,
					y8: _Utils_update(
						model,
						{ty: true}),
					as: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var _v11 = A2(
					$author$project$Utils$Tuple3$mapFirst,
					$author$project$Components$CustomerInvoice$RefundsForm$validate,
					A2($author$project$Components$CustomerInvoice$RefundsForm$update, subMsg, model.es));
				var newRefundsFormModel = _v11.a;
				var newRefundsFormCmd = _v11.b;
				var refundEvent = _v11.c;
				var newAdjustmentForms = function () {
					if (refundEvent.$ === 1) {
						var amount = refundEvent.a;
						return A2($author$project$Components$CustomerInvoice$AdjustmentsForm$updateRefundAmount, amount, model.bj);
					} else {
						return model.bj;
					}
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg, newRefundsFormCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{bj: newAdjustmentForms, es: newRefundsFormModel}),
					as: _List_Nil
				};
			case 10:
				var response = msg.a;
				var newModel = function () {
					if (response.$ === 3) {
						var invoice_ = response.a;
						return _Utils_update(
							model,
							{Rh: invoice_});
					} else {
						return model;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 4,
					y8: _Utils_update(
						newModel,
						{ty: false}),
					as: _List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
						])
				};
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 4,
							y8: model,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Invoice adjustment created')
								])
						};
					case 2:
						var error = response.a;
						var errorString = $author$project$Api$Data$errorToString(error);
						var errorMessage = $elm$core$String$isEmpty(errorString) ? 'Unexpected error processing your invoice adjustment' : errorString;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 4,
							y8: model,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, errorMessage)
								])
						};
					default:
						return {EC: $elm$core$Platform$Cmd$none, ac5: 4, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$Closed = 0;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$None = 1;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentCreated = 2;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceFieldUpdated = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelectFieldUpdated = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelected = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents = F3(
	function (invoiceDueInCents, index, scheduledPayment) {
		return A2(
			$author$project$Utils$Validate$isInvalidCurrency,
			{
				abi: false,
				yQ: $elm$core$Maybe$Nothing,
				TZ: $elm$core$Maybe$Just(50)
			},
			scheduledPayment.I2) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(index),
				'Must be more than $0.50')
			]) : (A2(
			$author$project$Utils$Validate$isInvalidCurrency,
			{
				abi: false,
				yQ: $elm$core$Maybe$Just(invoiceDueInCents),
				TZ: $elm$core$Maybe$Just(50)
			},
			scheduledPayment.I2) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(index),
				'Invalid number.')
			]) : _List_Nil);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$amountInCentsFormValidation = F2(
	function (invoiceDueInCents, scheduledPayment) {
		return $rtfeldman$elm_validate$Validate$fromErrors(
			function (_v0) {
				return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents, invoiceDueInCents, scheduledPayment.x4, scheduledPayment);
			});
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledPaymentsCreated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$ScheduledPayment$create = F4(
	function (apiClient, payableId, scheduledPaymentsList, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'scheduled_payments',
					A2(
						$elm$json$Json$Encode$list,
						function (fieldMap) {
							return $elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMap.adR)),
										_Utils_Tuple2(
										'scheduled_on',
										A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fieldMap.agH)),
										_Utils_Tuple2(
										'payment_source_id',
										$elm$json$Json$Encode$string(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2($elm$core$Maybe$map, $author$project$Api$Source$id, fieldMap.V3)))),
										_Utils_Tuple2(
										'amount_in_cents',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fieldMap.I2)),
										_Utils_Tuple2(
										'memo',
										A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMap.aeC))
									]));
						},
						scheduledPaymentsList))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ScheduledPayment$Shared$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath(payableId))));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields = function (formFields) {
	return A2(
		$elm$core$List$filter,
		function (scheduledPaymentField) {
			return !scheduledPaymentField.Yb;
		},
		formFields);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$createScheduledPayment = F3(
	function (apiClient, customerInvoice, formFields) {
		var scheduledPaymentsList = A2(
			$elm$core$List$map,
			function (scheduledPaymentField) {
				return {
					I2: A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Just(0),
						A2($elm$core$Maybe$map, $author$project$Currency$toInt, scheduledPaymentField.I2)),
					adR: scheduledPaymentField.adR,
					aeC: scheduledPaymentField.aeC,
					V3: scheduledPaymentField.V3,
					agH: scheduledPaymentField.agH
				};
			},
			$author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(formFields));
		return A4(
			$author$project$Api$Provider$ScheduledPayment$create,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(customerInvoice),
			scheduledPaymentsList,
			$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledPaymentsCreated);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotPassthroughFees = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard = function (source) {
	return _Utils_eq(
		A2($elm$core$Maybe$andThen, $author$project$Api$Source$type_, source),
		$elm$core$Maybe$Just('Card'));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd = F6(
	function (shouldChargeCreditCardFees, apiClient, amount, sourceChoice, patientId, index) {
		if (shouldChargeCreditCardFees && $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard(sourceChoice)) {
			var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Source$id, sourceChoice);
			if (!_v0.$) {
				var sourceId = _v0.a;
				return A6(
					$author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees,
					apiClient,
					patientId,
					$elm$core$Maybe$Just(sourceId),
					$elm$core$Maybe$Nothing,
					amount,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$GotPassthroughFees(index));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotScheduledPayments = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments = F2(
	function (apiClient, customerInvoice) {
		return A3(
			$author$project$Api$Provider$ScheduledPayment$list,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$id(customerInvoice),
			$author$project$Components$Invoice$CreateScheduledPaymentModal$GotScheduledPayments);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var index = field.a;
				var amountInCents = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{I2: amountInCents, ft: true});
					},
					fields.j);
				return _Utils_update(
					fields,
					{j: updatedScheduledPayment});
			case 4:
				var index = field.a;
				var source = field.b;
				var updatedPassthroughFees = $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard(source) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						function (scheduledPaymentForm) {
							return scheduledPaymentForm.VK;
						},
						A2($elm_community$list_extra$List$Extra$getAt, index, fields.j))) : $elm$core$Maybe$Nothing;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{VK: updatedPassthroughFees, V3: source});
					},
					fields.j);
				return _Utils_update(
					fields,
					{j: updatedScheduledPayment});
			case 5:
				var index = field.a;
				var sourceSelect = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{ft: true, r_: sourceSelect});
					},
					fields.j);
				return _Utils_update(
					fields,
					{j: updatedScheduledPayment});
			case 3:
				var index = field.a;
				var memo = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{
								ft: true,
								aeC: $elm$core$Maybe$Just(memo)
							});
					},
					fields.j);
				return _Utils_update(
					fields,
					{j: updatedScheduledPayment});
			case 6:
				var index = field.a;
				var date = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{ft: true, agH: date});
					},
					fields.j);
				return _Utils_update(
					fields,
					{j: updatedScheduledPayment});
			case 7:
				var index = field.a;
				var dateInput = field.b;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{n8: dateInput});
					},
					fields.j);
				return _Utils_update(
					fields,
					{j: updatedScheduledPayment});
			case 2:
				var index = field.a;
				var updatedScheduledPayment = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (scheduledPaymentForm) {
						return _Utils_update(
							scheduledPaymentForm,
							{Yb: true});
					},
					fields.j);
				return _Utils_update(
					fields,
					{j: updatedScheduledPayment});
			default:
				var updatedScheduledPaymentsList = field.a;
				return _Utils_update(
					fields,
					{j: updatedScheduledPaymentsList});
		}
	});
var $author$project$Api$Provider$ScheduledPayment$Shared$payment = function (_v0) {
	var record = _v0;
	return record.VY;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment = function (scheduledPayment) {
	return A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ScheduledPayment$Shared$payment, scheduledPayment.nc);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled = function (scheduledPayment) {
	var _v0 = _Utils_Tuple2(
		scheduledPayment.nc,
		$author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment));
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var originalScheduledPayment = _v0.a.a;
		return $author$project$Api$Provider$ScheduledPayment$Shared$status(originalScheduledPayment) === 'processed';
	} else {
		return (_Utils_eq(scheduledPayment.adR, $elm$core$Maybe$Nothing) || scheduledPayment.ft) ? false : (scheduledPayment.ag7 === 'processed');
	}
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields = function (formFields) {
	return A2(
		$elm$core$List$filter,
		function (scheduledPaymentField) {
			return !$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPaymentField);
		},
		$author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(formFields));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validatePaymentSource = F2(
	function (index, scheduledPayment) {
		return _Utils_eq(scheduledPayment.V3, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(index),
				'Please pick a source.')
			]) : _List_Nil;
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOn = F3(
	function (index, today, scheduledPayment) {
		var _v0 = scheduledPayment.agH;
		if (!_v0.$) {
			var scheduledOn = _v0.a;
			return A2($author$project$Utils$Date$isBeforeOrEqual, scheduledOn, today) ? _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(index),
					'Select a future date.')
				]) : _List_Nil;
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(index),
					'Select a future date.')
				]);
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateForm = F3(
	function (invoiceDueInCents, today, formFields) {
		var scheduledPaymentsToValidate = $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields(formFields.j);
		var sourceValidations = A2(
			$elm$core$List$concatMap,
			function (scheduledPayment) {
				return A2($author$project$Components$Invoice$CreateScheduledPaymentModal$validatePaymentSource, scheduledPayment.x4, scheduledPayment);
			},
			scheduledPaymentsToValidate);
		var scheduleOnValidations = A2(
			$elm$core$List$concatMap,
			function (scheduledPayment) {
				return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOn, scheduledPayment.x4, today, scheduledPayment);
			},
			scheduledPaymentsToValidate);
		var amountInCentsValidations = A2(
			$elm$core$List$concatMap,
			function (scheduledPayment) {
				return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents, invoiceDueInCents, scheduledPayment.x4, scheduledPayment);
			},
			scheduledPaymentsToValidate);
		return $elm$core$List$concat(
			_List_fromArray(
				[amountInCentsValidations, sourceValidations, scheduleOnValidations]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnPaymentSourceCombinationValidation = {$: 3};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors = function (fields) {
	var scheduledPaymentsToValidate = $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields(fields.j);
	var allPairs = A2(
		$elm$core$List$map,
		function (scheduledPayment) {
			var _v0 = _Utils_Tuple2(scheduledPayment.V3, scheduledPayment.agH);
			if (_v0.a.$ === 1) {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var scheduledOn = _v0.b.a;
					return '-1|' + $justinmimbs$date$Date$toIsoString(scheduledOn);
				} else {
					return '0|0';
				}
			} else {
				if (!_v0.b.$) {
					var paymentSource = _v0.a.a;
					var scheduledOn = _v0.b.a;
					return $author$project$Api$Source$id(paymentSource) + ('|' + $justinmimbs$date$Date$toIsoString(scheduledOn));
				} else {
					var paymentSource = _v0.a.a;
					return $author$project$Api$Source$id(paymentSource) + '|1';
				}
			}
		},
		scheduledPaymentsToValidate);
	var uniquePairs = $elm_community$list_extra$List$Extra$unique(allPairs);
	return !_Utils_eq(uniquePairs, allPairs);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOnPaymentSourceCombined = function (fields) {
	return $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields) ? _List_fromArray(
		[
			_Utils_Tuple2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnPaymentSourceCombinationValidation, 'The same source can not be used for more than single scheduled payment per day')
		]) : _List_Nil;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$formValidation = F2(
	function (invoiceDueInCents, today) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Invoice$CreateScheduledPaymentModal$validateForm, invoiceDueInCents, today)),
					$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOnPaymentSourceCombined)
				]));
	});
var $author$project$Api$Provider$ScheduledPayment$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$calculateExistingSourceValue = F2(
	function (scheduledPaymentSource, sources) {
		if (!scheduledPaymentSource.$) {
			var source = scheduledPaymentSource.a;
			return A2(
				$elm$core$List$any,
				function (s) {
					return _Utils_eq(
						$author$project$Api$Source$id(s),
						$author$project$Api$Source$id(source));
				},
				sources) ? ((!_Utils_eq(
				$author$project$Api$Source$status(source),
				$elm$core$Maybe$Just('failed'))) ? scheduledPaymentSource : $elm$core$Maybe$Nothing) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$calculateScheduledPaymentSourceDefault = F2(
	function (model, scheduledPayments) {
		var defaultSource = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Source$Source,
			$author$project$Api$Provider$CustomerInvoice$One$source(model.lI));
		var _v0 = $elm$core$List$head(
			$elm$core$List$reverse(scheduledPayments));
		if (!_v0.$) {
			var scheduledPaymentForm = _v0.a;
			var _v1 = A2($elm$core$Maybe$andThen, $author$project$Api$Source$status, scheduledPaymentForm.V3);
			if ((!_v1.$) && (_v1.a === 'failed')) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = A2($elm$core$Maybe$andThen, $author$project$Api$Source$status, defaultSource);
				if ((!_v2.$) && (_v2.a === 'failed')) {
					return $elm$core$Maybe$Nothing;
				} else {
					return A2(
						$elm$core$Maybe$withDefault,
						defaultSource,
						A2($elm$core$Maybe$map, $elm$core$Maybe$Just, scheduledPaymentForm.V3));
				}
			}
		} else {
			return defaultSource;
		}
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$deriveScheduledPaymentSource = function (scheduledPayment) {
	return A2(
		$elm$core$Maybe$map,
		$author$project$Api$Source$Source,
		$author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment));
};
var $author$project$Api$Provider$ScheduledPayment$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$ScheduledPayment$Shared$memo = function (_v0) {
	var record = _v0;
	return record.aeC;
};
var $author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents = function (_v0) {
	var record = _v0;
	return record.VK;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources = function (model) {
	var _v0 = _Utils_Tuple2(model.pN, model.pD);
	if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
		var _v1 = _v0.a;
		var cards = _v1.a;
		var _v2 = _v0.b;
		var bankAccounts = _v2.a;
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Source$createdAt,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($elm$time$Time$posixToMillis),
						$elm$core$Maybe$withDefault(0))),
				_Utils_ap(
					A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
					A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName = function (source_) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Utils$String$toMaybe,
		$author$project$Api$Source$name(source_));
	if (!_v0.$) {
		var label = _v0.a;
		return $elm$core$Maybe$Just(label);
	} else {
		return $author$project$Api$Source$type_(source_);
	}
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectLabel = function (source) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					$author$project$Formatters$String$titleize,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName(source)),
					A2(
					$elm$core$Maybe$map,
					function (lastFour) {
						return ' * ' + lastFour;
					},
					$author$project$Api$Source$lastFour(source)),
					A2(
					$elm$core$Maybe$map,
					function (funding) {
						return ' (' + (funding + ')');
					},
					$author$project$Api$Source$funding(source))
				])));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectToValue = function (source) {
	return $elm$core$Maybe$Just(
		$author$project$Api$Source$id(source));
};
var $author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn = function (_v0) {
	var record = _v0;
	return record.agH;
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSourceSelect = function (source) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName(source);
					if (!_v0.$) {
						var name = _v0.a;
						return A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('inline')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Formatters$String$titleize(name))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v1 = $author$project$Api$Source$lastFour(source);
					if (!_v1.$) {
						var lastFour = _v1.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('*' + lastFour)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v2 = $author$project$Api$Source$funding(source);
					if (!_v2.$) {
						var funding = _v2.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('(' + (funding + ')'))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$author$project$Ui$Badge$fromString,
					_List_Nil,
					A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						$author$project$Api$Source$status(source))),
					$author$project$Utils$Html$noBreakSpace,
					function () {
					var _v3 = $author$project$Api$Source$label(source);
					if (!_v3.$) {
						var label = _v3.a;
						return A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$em,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true),
													$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(label)
												]))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]))
		]);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList = F2(
	function (model, _v0) {
		var index = _v0.a;
		var scheduledPayment_ = _v0.b;
		var sourceSelect = $author$project$Ui$Form$SearchableSelect$init(
			{
				adR: 'schpmt-source-select-' + $elm$core$String$fromInt(index),
				ahw: $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSourceSelect,
				ahA: $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectLabel,
				g0: $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectToValue
			});
		var amountInCents = function () {
			if (!scheduledPayment_.$) {
				var scheduledPayment = scheduledPayment_.a;
				return $author$project$Currency$fromMaybeInt(
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$ScheduledPayment$Shared$amountInCents(scheduledPayment)));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v1 = $author$project$Components$DateInput$init;
		var dateInput = _v1.a;
		var dateInputCmd = _v1.b;
		var updatedScheduledPayment = function () {
			if (!scheduledPayment_.$) {
				var scheduledPayment = scheduledPayment_.a;
				var paymentSource = A2(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$calculateExistingSourceValue,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$deriveScheduledPaymentSource(scheduledPayment),
					$author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources(model));
				return {
					I2: amountInCents,
					ft: false,
					adR: $elm$core$Maybe$Just(
						$author$project$Api$Provider$ScheduledPayment$Shared$id(scheduledPayment)),
					x4: index,
					aeC: $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment),
					nc: $elm$core$Maybe$Just(scheduledPayment),
					VK: $author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents(scheduledPayment),
					V3: paymentSource,
					r_: sourceSelect,
					Yb: false,
					agH: $elm$core$Maybe$Just(
						$author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)),
					n8: dateInput,
					ag7: $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment)
				};
			} else {
				var tomorrow = A3($justinmimbs$date$Date$add, 3, 1, model.$P);
				var fields = $author$project$Utils$Form$fields(model.PB);
				var lastDate = A2(
					$elm$core$Maybe$withDefault,
					model.$P,
					$elm$core$List$head(
						$elm$core$List$reverse(
							A2(
								$elm$core$List$sortBy,
								$justinmimbs$date$Date$toRataDie,
								A2(
									$elm$core$List$map,
									function (scheduledPayment) {
										return A2($elm$core$Maybe$withDefault, tomorrow, scheduledPayment.agH);
									},
									A2(
										$elm$core$List$filter,
										function (scheduledPayment) {
											return !A2(
												$author$project$Utils$Date$isBefore,
												A2($elm$core$Maybe$withDefault, model.$P, scheduledPayment.agH),
												model.$P);
										},
										$author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(fields.j)))))));
				return {
					I2: amountInCents,
					ft: true,
					adR: $elm$core$Maybe$Nothing,
					x4: index,
					aeC: $elm$core$Maybe$Nothing,
					nc: $elm$core$Maybe$Nothing,
					VK: $elm$core$Maybe$Just(0),
					V3: A2($author$project$Components$Invoice$CreateScheduledPaymentModal$calculateScheduledPaymentSourceDefault, model, fields.j),
					r_: sourceSelect,
					Yb: false,
					agH: $elm$core$Maybe$Just(
						A3($justinmimbs$date$Date$add, 3, 1, lastDate)),
					n8: dateInput,
					ag7: 'scheduled'
				};
			}
		}();
		return _Utils_Tuple2(
			updatedScheduledPayment,
			A2(
				$elm$core$Platform$Cmd$map,
				A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, index, dateInput),
				dateInputCmd));
	});
var $author$project$Api$Provider$PassthroughFee$Shared$passthroughFeeInCents = function (_v0) {
	var internalRecord = _v0;
	return internalRecord.VI;
};
var $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PassthroughFee$Shared$passthroughFeeInCents(shared);
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnFieldUpdated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnInputFieldUpdated = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$updateScheduledOnFormField = F5(
	function (model, index, dateInput, subMsg, toMsg) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var changedForm = A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
			A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnInputFieldUpdated, index, newDateInput),
			model.PB);
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
					A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnFieldUpdated, index, date),
					changedForm);
			} else {
				return changedForm;
			}
		}();
		return {
			EC: A2(
				$elm$core$Platform$Cmd$map,
				A2(toMsg, index, newDateInput),
				subCmd),
			ac5: 1,
			y8: _Utils_update(
				model,
				{PB: newForm}),
			as: _List_Nil
		};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var scheduledPayments = response.a;
					if ($elm$core$List$length(scheduledPayments) > 0) {
						var scheduledPaymentsIndexedTuples = A2(
							$elm$core$List$indexedMap,
							F2(
								function (index, scheduledPayment) {
									return _Utils_Tuple2(
										index,
										$elm$core$Maybe$Just(scheduledPayment));
								}),
							scheduledPayments);
						var updatedScheduledPaymentsAndCmds = A2(
							$elm$core$List$map,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList(model),
							scheduledPaymentsIndexedTuples);
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(
								A2($elm$core$List$map, $elm$core$Tuple$first, updatedScheduledPaymentsAndCmds)),
							model.PB);
						return {
							EC: $elm$core$Platform$Cmd$batch(
								A2($elm$core$List$map, $elm$core$Tuple$second, updatedScheduledPaymentsAndCmds)),
							ac5: 1,
							y8: _Utils_update(
								model,
								{PB: newForm, cW: false}),
							as: _List_Nil
						};
					} else {
						var fields = $author$project$Utils$Form$fields(model.PB);
						var _v3 = A2(
							$author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList,
							model,
							_Utils_Tuple2(0, $elm$core$Maybe$Nothing));
						var defaultScheduledPayment = _v3.a;
						var dateInputCmd = _v3.b;
						var updatedScheduledPayment = _Utils_ap(
							fields.j,
							_List_fromArray(
								[defaultScheduledPayment]));
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment),
							model.PB);
						return {
							EC: dateInputCmd,
							ac5: 1,
							y8: _Utils_update(
								model,
								{PB: newForm, cW: false}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 4:
				var response = msg.a;
				var cmd = _Utils_eq(model.pD, $author$project$Api$Data$Loading) ? $elm$core$Platform$Cmd$none : A2($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments, apiClient, model.lI);
				return {
					EC: cmd,
					ac5: 1,
					y8: _Utils_update(
						model,
						{pN: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 3:
				var response = msg.a;
				var cmd = _Utils_eq(model.pN, $author$project$Api$Data$Loading) ? $elm$core$Platform$Cmd$none : A2($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments, apiClient, model.lI);
				return {
					EC: cmd,
					ac5: 1,
					y8: _Utils_update(
						model,
						{pD: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 1:
				var fields = $author$project$Utils$Form$fields(model.PB);
				var newIndex = $elm$core$List$length(fields.j);
				var _v4 = A2(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList,
					model,
					_Utils_Tuple2(newIndex, $elm$core$Maybe$Nothing));
				var newScheduledPayment = _v4.a;
				var dateInputCmd = _v4.b;
				var updatedScheduledPayment = _Utils_ap(
					fields.j,
					_List_fromArray(
						[newScheduledPayment]));
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment),
					model.PB);
				return {
					EC: dateInputCmd,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 6:
				var index = msg.a;
				var paymentSourceSelectMsg = msg.b;
				var _v5 = $author$project$Utils$Form$fields(model.PB);
				var scheduledPaymentsForm = _v5.j;
				var scheduledPaymentFormItem = A2($elm_community$list_extra$List$Extra$getAt, index, scheduledPaymentsForm);
				if (!scheduledPaymentFormItem.$) {
					var scheduledPaymentFormItem_ = scheduledPaymentFormItem.a;
					var _v7 = A2($author$project$Ui$Form$SearchableSelect$update, paymentSourceSelectMsg, scheduledPaymentFormItem_.r_);
					var selectModel = _v7.a;
					var selectCmd = _v7.b;
					var event = _v7.c;
					var updatesSourceSelectForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
						A2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelectFieldUpdated, index, selectModel),
						model.PB);
					var _v8 = function () {
						if ((!event.$) && (!event.a.$)) {
							var maybeSource = event.a.a;
							var amountInCents = A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Currency$toInt(
									A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, scheduledPaymentFormItem_.I2)));
							return _Utils_Tuple2(
								A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
									A2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceFieldUpdated, index, maybeSource),
									updatesSourceSelectForm),
								A6($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd, model.ZQ, apiClient, amountInCents, maybeSource, model.VN, index));
						} else {
							return _Utils_Tuple2(updatesSourceSelectForm, $elm$core$Platform$Cmd$none);
						}
					}();
					var newForm = _v8.a;
					var reFetchPassthroughFeesCmd = _v8.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelected(index),
									selectCmd),
									reFetchPassthroughFeesCmd
								])),
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 10:
				var index = msg.a;
				var _v10 = $author$project$Utils$Form$fields(model.PB);
				var invoiceDueInCents = _v10.mB;
				var scheduledPaymentsForm = _v10.j;
				var scheduledPaymentForm = A2($elm_community$list_extra$List$Extra$getAt, index, scheduledPaymentsForm);
				if (!scheduledPaymentForm.$) {
					var scheduledPaymentFormItem_ = scheduledPaymentForm.a;
					var _v12 = A2(
						$author$project$Utils$Form$validate,
						A2($author$project$Components$Invoice$CreateScheduledPaymentModal$amountInCentsFormValidation, invoiceDueInCents, scheduledPaymentFormItem_),
						model.PB);
					if (!_v12.$) {
						var _v13 = _v12.a;
						var newForm = _v13.a;
						var passthroughFeesCmd = function () {
							var amountInCents = A2(
								$elm$core$Maybe$withDefault,
								0,
								$author$project$Currency$toInt(
									A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, scheduledPaymentFormItem_.I2)));
							return A6($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd, model.ZQ, apiClient, amountInCents, scheduledPaymentFormItem_.V3, model.VN, index);
						}();
						return {
							EC: passthroughFeesCmd,
							ac5: 1,
							y8: _Utils_update(
								model,
								{PB: newForm}),
							as: _List_Nil
						};
					} else {
						var newForm = _v12.a;
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 1,
							y8: _Utils_update(
								model,
								{PB: newForm}),
							as: _List_Nil
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 11:
				var index = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var passthroughFees = response.a;
					var passthroughFeesInCents = $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents(passthroughFees);
					var updatedScheduledPayment = A3(
						$elm_community$list_extra$List$Extra$updateAt,
						index,
						function (scheduledPaymentForm) {
							return _Utils_update(
								scheduledPaymentForm,
								{
									VK: $elm$core$Maybe$Just(passthroughFeesInCents)
								});
						},
						$author$project$Utils$Form$fields(model.PB).j);
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment),
						model.PB);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
				}
			case 7:
				var _v15 = $author$project$Utils$Form$fields(model.PB);
				var invoiceDueInCents = _v15.mB;
				var scheduledPaymentsForm = _v15.j;
				var _v16 = A2(
					$author$project$Utils$Form$validate,
					A2($author$project$Components$Invoice$CreateScheduledPaymentModal$formValidation, invoiceDueInCents, model.$P),
					model.PB);
				if (!_v16.$) {
					var _v17 = _v16.a;
					var newForm = _v17.a;
					var createScheduledPaymentCmd = A3($author$project$Components$Invoice$CreateScheduledPaymentModal$createScheduledPayment, apiClient, model.lI, scheduledPaymentsForm);
					return {
						EC: createScheduledPaymentCmd,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm, jY: $author$project$Api$Data$Loading}),
						as: _List_Nil
					};
				} else {
					var newForm = _v16.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Successfully created scheduled payments')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var index = msg.a;
				var dateInput = msg.b;
				var subMsg = msg.c;
				return A5($author$project$Components$Invoice$CreateScheduledPaymentModal$updateScheduledOnFormField, model, index, dateInput, subMsg, $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected);
		}
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$GotPatient = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Location = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Payer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateFailed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateSucceeded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var maybePatient = field.a;
				return _Utils_update(
					fields,
					{GD: maybePatient});
			case 1:
				var maybeLocation = field.a;
				return _Utils_update(
					fields,
					{S3: maybeLocation});
			default:
				var dateInput = field.a;
				var maybeDate = field.b;
				return _Utils_update(
					fields,
					{qd: dateInput, Rn: maybeDate});
		}
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$Membership$Form$Records$locationFromMin = function (location) {
	return {
		adR: $author$project$Api$Provider$Location$Min$id(location),
		zh: $author$project$Api$Provider$Location$Min$name(location)
	};
};
var $author$project$Components$Membership$Form$Records$practitionerFromMin = function (practitioner) {
	return {
		adR: $author$project$Api$Provider$Practitioner$Min$id(practitioner),
		zh: $author$project$Api$Provider$Practitioner$Min$name(practitioner)
	};
};
var $author$project$Components$Membership$Form$Records$patientFromAll = function (patient) {
	return {
		IK: $author$project$Api$Provider$Patient$All$age(patient),
		adR: $author$project$Api$Provider$Patient$All$id(patient),
		aet: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$locationFromMin,
			$author$project$Api$Provider$Patient$All$location(patient)),
		TL: $author$project$Api$Provider$Patient$All$membershipStatus(patient),
		zh: $author$project$Api$Provider$Patient$All$name(patient),
		afS: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$practitionerFromMin,
			$author$project$Api$Provider$Patient$All$practitioner(patient)),
		aaI: $author$project$Api$Provider$Patient$All$usesTobacco(patient)
	};
};
var $author$project$Components$ResourceFilter$Location$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bb);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bb: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$InvoiceUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$updateInvoice = F3(
	function (apiClient, invoiceId, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = function () {
			var _v0 = _Utils_Tuple2(fields.GD, fields.S3);
			if (!_v0.a.$) {
				var payer = _v0.a.a;
				var maybeLocationId = _v0.b;
				return {
					MO: fields.Rn,
					aet: maybeLocationId,
					Vp: $elm$core$Maybe$Just(payer.adR),
					$t: $elm$core$Maybe$Nothing
				};
			} else {
				return {MO: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, Vp: $elm$core$Maybe$Nothing, $t: $elm$core$Maybe$Nothing};
			}
		}();
		return A5(
			$author$project$Api$Provider$CustomerInvoice$update,
			apiClient,
			invoiceId,
			apiFields,
			_List_fromArray(
				[0]),
			$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$InvoiceUpdated);
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var patient = response.a;
					var _v2 = model.rl;
					if (!_v2.$) {
						var locationResourceFilter_ = _v2.a;
						var _v3 = model._;
						if (!_v3.$) {
							var _v4 = _v3.a;
							var invoice = _v4.c;
							var locationFieldEnabled = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'draft';
							var _v5 = function () {
								var _v6 = _Utils_Tuple3(
									$author$project$Api$Provider$Patient$One$location(patient),
									locationFieldEnabled,
									model.x6);
								if (((!_v6.a.$) && _v6.b) && (!_v6.c)) {
									var location = _v6.a.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(
											function (value) {
												return A2($author$project$Components$ResourceFilter$Location$setValue, value, locationResourceFilter_);
											}(
												$author$project$Components$ResourceFilter$Location$resourceFromShared(
													$elm$core$Maybe$Just(
														$author$project$Api$Location$Shared$Provider(location))))),
										$elm$core$Maybe$Just(
											$author$project$Api$Provider$Location$Shared$id(location)));
								} else {
									return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
								}
							}();
							var maybeLocationResourceFilter = _v5.a;
							var preSelectedId = _v5.b;
							var _v7 = function () {
								if (!maybeLocationResourceFilter.$) {
									var locationResourceFilter = maybeLocationResourceFilter.a;
									return A2(
										$elm$core$Tuple$mapFirst,
										$elm$core$Maybe$Just,
										A2($author$project$Components$ResourceFilter$Location$preSelectedId, preSelectedId, locationResourceFilter));
								} else {
									return A2(
										$elm$core$Tuple$mapFirst,
										$elm$core$Maybe$Just,
										A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter, apiClient, invoice));
								}
							}();
							var newLocationResourceFilter = _v7.a;
							var newLocationResourceFilterCmd = _v7.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{x6: false, rl: newLocationResourceFilter}),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, newLocationResourceFilterCmd),
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 4:
				var subMsg = msg.a;
				var _v9 = model.rU;
				if (!_v9.$) {
					var patientResourceFilter = _v9.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, patientResourceFilter);
					var _v10 = function () {
						var _v11 = patientResourceResult.ac5;
						if (((!_v11.$) && (!_v11.a.$)) && (!_v11.a.a.$)) {
							var patient = _v11.a.a.a;
							var _v12 = model._;
							if (!_v12.$) {
								var _v13 = _v12.a;
								var id = _v13.a;
								var form = _v13.b;
								var invoice = _v13.c;
								var patientRequestCmd = A3(
									$author$project$Api$Provider$Patient$retrieve,
									apiClient,
									$author$project$Api$Provider$Patient$All$id(patient),
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$GotPatient);
								var patientRecord = $author$project$Components$Membership$Form$Records$patientFromAll(patient);
								var newForm = A3(
									$author$project$Utils$Form$update,
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate,
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Payer(
										$elm$core$Maybe$Just(patientRecord)),
									form);
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											_: $elm$core$Maybe$Just(
												_Utils_Tuple3(id, newForm, invoice)),
											rU: $elm$core$Maybe$Just(patientResourceResult.y8)
										}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceResult.EC),
												patientRequestCmd
											])));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										rU: $elm$core$Maybe$Just(patientResourceResult.y8)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceResult.EC));
						}
					}();
					var newModel = _v10.a;
					var cmd = _v10.b;
					return _Utils_Tuple3(newModel, cmd, $elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 5:
				var subMsg = msg.a;
				var _v14 = model.rl;
				if (!_v14.$) {
					var locationResourceFilter = _v14.a;
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, locationResourceFilter);
					var _v15 = function () {
						var _v16 = model._;
						if (!_v16.$) {
							var _v17 = _v16.a;
							var id = _v17.a;
							var form = _v17.b;
							var invoice = _v17.c;
							var newForm = A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Location(
									$author$project$Components$ResourceFilter$Location$value(locationResourceResult.y8)),
								form);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										_: $elm$core$Maybe$Just(
											_Utils_Tuple3(id, newForm, invoice)),
										rl: $elm$core$Maybe$Just(locationResourceResult.y8)
									}),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceResult.EC));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v15.a;
					var formCmd = _v15.b;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									formCmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceResult.EC)
								])),
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 0:
				var form = msg.a;
				var maybeInvoiceId = msg.b;
				if (!maybeInvoiceId.$) {
					var invoiceId = maybeInvoiceId.a;
					var _v19 = model._;
					if (!_v19.$) {
						var _v20 = _v19.a;
						var invoice = _v20.c;
						var _v21 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsValidator, form);
						if (!_v21.$) {
							var _v22 = _v21.a;
							var newForm = _v22.a;
							var validFormFields = _v22.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										_: $elm$core$Maybe$Just(
											_Utils_Tuple3(invoiceId, newForm, invoice)),
										S_: true
									}),
								A3($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$updateInvoice, apiClient, invoiceId, validFormFields),
								$elm$core$Maybe$Nothing);
						} else {
							var newForm = _v21.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										_: $elm$core$Maybe$Just(
											_Utils_Tuple3(invoiceId, newForm, invoice))
									}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Nothing);
						}
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 1:
				var response = msg.a;
				var _v23 = model._;
				if (!_v23.$) {
					switch (response.$) {
						case 3:
							var invoice = response.a;
							var ownerId = function () {
								var _v25 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
								if (!_v25.$) {
									var patient = _v25.a;
									return $author$project$Api$Provider$Patient$Shared$id(patient);
								} else {
									return '';
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{S_: false}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateSucceeded(ownerId)));
						case 2:
							var error = response.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{S_: false}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Just(
									$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateFailed(error)));
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{S_: false}),
								$elm$core$Platform$Cmd$none,
								$elm$core$Maybe$Nothing);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			default:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v26 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
				var newDateInput = _v26.a;
				var subCmd = _v26.b;
				var event = _v26.c;
				var _v27 = model._;
				if (!_v27.$) {
					var _v28 = _v27.a;
					var id = _v28.a;
					var form = _v28.b;
					var invoice = _v28.c;
					var newForm = function () {
						if (event.$ === 1) {
							var date = event.a;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate,
								A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date, newDateInput, date),
								form);
						} else {
							var _v30 = $author$project$Utils$Form$fields(form);
							var invoiceDate = _v30.Rn;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate,
								A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date, newDateInput, invoiceDate),
								form);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								_: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, invoice))
							}),
						subCmd,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Components$Patient$Charges$ChargeModal$Category = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeItem = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated = {$: 3};
var $author$project$Components$Patient$Charges$ChargeModal$Closed = {$: 1};
var $author$project$Components$Patient$Charges$ChargeModal$EndDate = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$Location = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$None = {$: 0};
var $author$project$Components$Patient$Charges$ChargeModal$Patient = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$Practitioner = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$StartDate = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$clearFormFields = F3(
	function (apiClient, showItemTypeInTitle, existingFormFields) {
		var newCategoryResourceFilter = A2($author$project$Components$ResourceFilter$Category$setValue, $elm$core$Maybe$Nothing, existingFormFields.cJ);
		var _v0 = $author$project$Components$DateInput$init;
		var startDateInput = _v0.a;
		var startDateInputCmd = _v0.b;
		var _v1 = $author$project$Components$DateInput$init;
		var endDateInput = _v1.a;
		var endDateInputCmd = _v1.b;
		var _v2 = A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig);
		var chargeItemResourceFilter = _v2.a;
		var chargeItemResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				existingFormFields,
				{
					Ex: $elm$core$Maybe$Nothing,
					cJ: newCategoryResourceFilter,
					lp: $elm$core$Maybe$Nothing,
					cK: chargeItemResourceFilter,
					Nx: '',
					NI: 0,
					NJ: false,
					qs: $elm$core$Maybe$Nothing,
					qu: endDateInput,
					adR: $elm$core$Maybe$Nothing,
					zh: $elm$core$Maybe$Nothing,
					Ba: $elm$core$Maybe$Nothing,
					W$: $elm$core$Maybe$Nothing,
					Bd: $elm$core$Maybe$Just(1),
					Be: $elm$core$Maybe$Nothing,
					kg: startDateInput,
					$u: false
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput),
						startDateInputCmd),
						A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput),
						endDateInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd)
					])));
	});
var $author$project$Components$Patient$Charges$ChargeModal$PreviewDebounced = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$debouncePreview = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Patient$Charges$ChargeModal$PreviewDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Components$Patient$Charges$ChargeModal$ChargeItemValidation = 1;
var $author$project$Components$Patient$Charges$ChargeModal$PatientValidation = 0;
var $author$project$Components$Patient$Charges$ChargeModal$PriceInCentsValidation = 3;
var $author$project$Components$Patient$Charges$ChargeModal$QuantityValidation = 2;
var $author$project$Components$Patient$Charges$ChargeModal$StartDateValidation = 4;
var $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.zh;
			},
			_Utils_Tuple2(1, 'Please pick a charge.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.VM;
			},
			_Utils_Tuple2(0, 'Please pick a patient.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Bd;
			},
			_Utils_Tuple2(2, 'Can\'t be blank.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Ba;
			},
			_Utils_Tuple2(3, 'Please enter an amount.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $._E;
			},
			_Utils_Tuple2(4, 'Please pick a date.'))
		]));
var $author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount = F5(
	function (model, apiClient, charge, form, shouldClose) {
		var fields = $author$project$Utils$Form$fields(form);
		if (fields.NJ && (!$author$project$Api$Provider$Charge$One$discountOverridden(charge))) {
			return _Utils_Tuple3(
				A3(
					$author$project$Api$Provider$Charge$CoverageDiscount$override,
					apiClient,
					$author$project$Api$Provider$Charge$One$id(charge),
					$author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden(shouldClose)),
				$author$project$Components$Patient$Charges$ChargeModal$None,
				_List_Nil);
		} else {
			if ((!fields.NJ) && $author$project$Api$Provider$Charge$One$discountOverridden(charge)) {
				return _Utils_Tuple3(
					A3(
						$author$project$Api$Provider$Charge$CoverageDiscount$reset,
						apiClient,
						$author$project$Api$Provider$Charge$One$id(charge),
						$author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden(shouldClose)),
					$author$project$Components$Patient$Charges$ChargeModal$None,
					_List_Nil);
			} else {
				var message = _Utils_eq(model.abU, $elm$core$Maybe$Nothing) ? 'Charge created.' : 'Charge updated.';
				return _Utils_Tuple3(
					$elm$core$Platform$Cmd$none,
					_Utils_eq(model.abU, $elm$core$Maybe$Nothing) ? $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated(shouldClose) : $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, message)
						]));
			}
		}
	});
var $author$project$Components$Patient$Charges$ChargeModal$PreviewDebouncedMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Patient$Charges$ChargeModal$PreviewDebouncedMsg
};
var $author$project$Components$Patient$Charges$ChargeModal$GotChargeCreated = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice = F2(
	function (model, fields) {
		var priceInCents = function () {
			if (!(!fields.NI)) {
				var _v0 = _Utils_Tuple2(fields.lp, model.afU);
				if (!_v0.a.$) {
					var chargeItem = _v0.a.a;
					return $elm$core$Maybe$Just(chargeItem.Ba | 0);
				} else {
					if (_v0.b.$ === 3) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var preview = _v2.a;
						return $elm$core$Maybe$Just(
							$author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
					} else {
						var _v3 = _v0.a;
						return $elm$core$Maybe$Just(
							fields.NI + A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Ba)));
					}
				}
			} else {
				return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Ba);
			}
		}();
		return {
			Ex: fields.Ex,
			lp: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				fields.lp),
			MO: fields._E,
			Nx: fields.Nx,
			NJ: fields.NJ,
			qs: fields.qs,
			Rh: $author$project$Api$Provider$Charge$Invoice(
				$elm$core$Maybe$Just(
					{
						adR: $elm$core$Maybe$Just(
							$author$project$Api$Provider$CustomerInvoice$One$id(model.Rh)),
						ahI: $elm$core$Maybe$Just('customer_invoice')
					})),
			aet: fields.aet,
			zh: fields.zh,
			VM: A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.adR;
				},
				fields.VM),
			GD: $elm$core$Maybe$Nothing,
			afS: fields.afS,
			Ba: priceInCents,
			Bd: A2($elm$core$Maybe$withDefault, 1, fields.Bd),
			Be: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Be)
		};
	});
var $author$project$Components$Patient$Charges$ChargeModal$createCharge = F4(
	function (model, apiClient, formFields, shouldClose) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A4(
			$author$project$Api$Provider$Charge$create,
			$author$project$Api$Data$providerPath,
			apiClient,
			A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields),
			$author$project$Components$Patient$Charges$ChargeModal$GotChargeCreated(shouldClose));
	});
var $author$project$Components$Patient$Charges$ChargeModal$GotChargeUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$updateCharge = F4(
	function (model, apiClient, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields);
		return A5(
			$author$project$Api$Provider$Charge$update,
			$author$project$Api$Provider$CustomerInvoice$customerInvoicePath(
				$author$project$Api$Provider$CustomerInvoice$One$id(model.Rh)),
			apiClient,
			id,
			apiFields,
			$author$project$Components$Patient$Charges$ChargeModal$GotChargeUpdated);
	});
var $author$project$Components$Patient$Charges$ChargeModal$save = F4(
	function (model, apiClient, formFields, shouldClose) {
		var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var id = _v0.adR;
		if (!id.$) {
			var id_ = id.a;
			return A4($author$project$Components$Patient$Charges$ChargeModal$updateCharge, model, apiClient, id_, formFields);
		} else {
			return A4($author$project$Components$Patient$Charges$ChargeModal$createCharge, model, apiClient, formFields, shouldClose);
		}
	});
var $author$project$Components$Patient$Charges$ChargeModal$GotPreview = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview = function (field) {
	switch (field.$) {
		case 1:
			return true;
		case 0:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return false;
		case 5:
			return false;
		case 6:
			return false;
		case 7:
			return true;
		case 8:
			return true;
		case 9:
			return true;
		case 10:
			return true;
		case 11:
			return true;
		case 12:
			return true;
		default:
			return true;
	}
};
var $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields = function (fields) {
	return $author$project$Utils$Maybe$toBool(fields.zh) && (A2($elm$core$Maybe$withDefault, 0, fields.Bd) > 0);
};
var $author$project$Components$Patient$Charges$ChargeModal$calculatePreview = F4(
	function (field, form, apiClient, model) {
		var fields = $author$project$Utils$Form$fields(form);
		var _v0 = (model.vQ && ($author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview(field) && $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields))) ? _Utils_Tuple2(
			A3(
				$jinjor$elm_debounce$Debounce$push,
				$author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig,
				A4(
					$author$project$Api$Provider$Charge$calculate,
					$author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath),
					apiClient,
					A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields),
					$author$project$Components$Patient$Charges$ChargeModal$GotPreview),
				model.em),
			$author$project$Api$Data$Loading) : _Utils_Tuple2(
			_Utils_Tuple2(model.em, $elm$core$Platform$Cmd$none),
			$author$project$Api$Data$NotAsked);
		var _v1 = _v0.a;
		var newDebouncer = _v1.a;
		var cmd = _v1.b;
		var preview = _v0.b;
		return _Utils_Tuple2(
			($author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview(field) && $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields)) ? _Utils_update(
				model,
				{afU: preview, em: newDebouncer}) : ((!$author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields)) ? _Utils_update(
				model,
				{afU: $author$project$Api$Data$NotAsked, em: newDebouncer}) : _Utils_update(
				model,
				{em: newDebouncer})),
			cmd);
	});
var $author$project$Components$Patient$Charges$ChargeModal$resetEndDate = function (fields) {
	var _v0 = _Utils_Tuple2(fields.Bd, fields.Be);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var quantity = _v0.a.a;
		var quantityUom = _v0.b.a;
		return _Utils_update(
			fields,
			{
				qs: A3($author$project$Utils$Uom$addTo, fields._E, quantityUom, quantity)
			});
	} else {
		return fields;
	}
};
var $author$project$Components$Patient$Charges$ChargeModal$translateLocation = function (location) {
	return {IJ: $elm$core$Maybe$Nothing, adR: location.adR, RQ: false, Sa: false, zh: location.zh};
};
var $author$project$Components$Patient$Charges$ChargeModal$translatePractitioner = function (practitioner) {
	return {IJ: $elm$core$Maybe$Nothing, adR: practitioner.adR, RQ: false, Sa: false, zh: practitioner.zh, Vb: $elm$core$Maybe$Nothing, afQ: '', WP: ''};
};
var $author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 1:
				var patient = field.a;
				var _v1 = function () {
					if (!patient.$) {
						var pat = patient.a;
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(
								{adR: pat.adR, zh: pat.zh}),
							A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$translateLocation, pat.aet),
							A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$translatePractitioner, pat.afS));
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
					}
				}();
				var formPatient = _v1.a;
				var locationResource = _v1.b;
				var practitionerResource = _v1.c;
				return _Utils_update(
					fields,
					{
						aet: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							locationResource),
						rl: A2($author$project$Components$ResourceFilter$Location$setValue, locationResource, fields.rl),
						VM: formPatient,
						afS: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							practitionerResource),
						jC: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitionerResource, fields.jC)
					});
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						lp: $elm$core$Maybe$Nothing,
						zh: $author$project$Utils$String$toMaybe(string),
						W$: $elm$core$Maybe$Nothing,
						Be: $elm$core$Maybe$Nothing
					});
			case 2:
				var chargeItem = field.a;
				var category = A2(
					$elm$core$Maybe$andThen,
					function ($) {
						return $.Ex;
					},
					chargeItem);
				return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(
					_Utils_update(
						fields,
						{
							Ex: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
							cJ: A2(
								$author$project$Components$ResourceFilter$Category$setValue,
								A2(
									$elm$core$Maybe$map,
									function (category_) {
										return {
											adR: $author$project$Api$Provider$Category$Shared$id(category_),
											zh: $author$project$Api$Provider$Category$Shared$name(category_)
										};
									},
									category),
								fields.cJ),
							lp: chargeItem,
							Nx: A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$andThen,
									function ($) {
										return $.Nx;
									},
									chargeItem)),
							zh: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.zh;
								},
								chargeItem),
							Ba: A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.Ba;
									},
									$author$project$Currency$fromFloat),
								chargeItem),
							W$: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.aam;
								},
								chargeItem),
							Bd: $elm$core$Maybe$Just(1),
							Be: A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.aam;
								},
								chargeItem)
						}));
			case 3:
				var maybeString = field.a;
				return _Utils_update(
					fields,
					{Ex: maybeString});
			case 4:
				var practitioner = field.a;
				return _Utils_update(
					fields,
					{
						afS: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							practitioner),
						jC: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitioner, fields.jC)
					});
			case 5:
				var location = field.a;
				return _Utils_update(
					fields,
					{
						aet: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							location),
						rl: A2($author$project$Components$ResourceFilter$Location$setValue, location, fields.rl)
					});
			case 6:
				var string = field.a;
				return _Utils_update(
					fields,
					{Nx: string});
			case 7:
				var string = field.a;
				return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(
					_Utils_update(
						fields,
						{
							Bd: $elm$core$String$toInt(string)
						}));
			case 8:
				var string = field.a;
				var _v3 = $author$project$Utils$Uom$fromCode(string);
				if (!_v3.$) {
					var quantityUom = _v3.a;
					var quantity = function () {
						var _v4 = _Utils_Tuple2(fields._E, fields.qs);
						if ((!_v4.a.$) && (!_v4.b.$)) {
							var startDate = _v4.a.a;
							var endDate = _v4.b.a;
							return $elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom,
									startDate,
									$elm$core$Maybe$Just(endDate)));
						} else {
							return fields.Bd;
						}
					}();
					return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(
						_Utils_update(
							fields,
							{
								Bd: quantity,
								Be: $elm$core$Maybe$Just(quantityUom)
							}));
				} else {
					return _Utils_update(
						fields,
						{Be: $elm$core$Maybe$Nothing});
				}
			case 9:
				var dateInput = field.a;
				var date = field.b;
				return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(
					_Utils_update(
						fields,
						{_E: date, kg: dateInput}));
			case 10:
				var dateInput = field.a;
				var date = field.b;
				var _v5 = function () {
					var _v6 = _Utils_Tuple2(fields._E, date);
					if ((!_v6.a.$) && (!_v6.b.$)) {
						var startDate_ = _v6.a.a;
						var endDate = _v6.b.a;
						var startDate__ = (A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2) ? endDate : startDate_;
						var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(startDate__),
							$elm$core$Maybe$Just(quantityUom_),
							$elm$core$Maybe$Just(
								A3(
									$author$project$Utils$Uom$quantityBetween,
									quantityUom_,
									startDate__,
									$elm$core$Maybe$Just(endDate))));
					} else {
						return _Utils_Tuple3(fields._E, fields.Be, fields.Bd);
					}
				}();
				var startDate = _v5.a;
				var quantityUom = _v5.b;
				var quantity = _v5.c;
				return _Utils_update(
					fields,
					{qs: date, qu: dateInput, Bd: quantity, Be: quantityUom, _E: startDate});
			case 11:
				var _int = field.a;
				return _Utils_update(
					fields,
					{Ba: _int});
			case 12:
				var bool = field.a;
				var priceInCents = bool ? fields.Ba : A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.Ba;
						},
						$author$project$Currency$fromFloat),
					fields.lp);
				return _Utils_update(
					fields,
					{NJ: bool, Ba: priceInCents});
			default:
				var _int = field.a;
				return _Utils_update(
					fields,
					{NI: _int});
		}
	});
var $author$project$Components$Patient$Charges$ChargeModal$updateForm = F4(
	function (model, apiClient, field, form) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate, field, form);
		return A4(
			$author$project$Components$Patient$Charges$ChargeModal$calculatePreview,
			field,
			newForm,
			apiClient,
			_Utils_update(
				model,
				{PB: newForm}));
	});
var $author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField = F7(
	function (model, apiClient, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var dateField = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A2(field, newDateInput, date);
			} else {
				return A2(
					field,
					newDateInput,
					fieldGetter(
						$author$project$Utils$Form$fields(model.PB)));
			}
		}();
		var _v1 = A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, dateField, model.PB);
		var newModel = _v1.a;
		var formCmd = _v1.b;
		return {
			EC: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						formCmd,
						A2(
						$elm$core$Platform$Cmd$map,
						toMsg(newDateInput),
						subCmd)
					])),
			ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
			y8: newModel,
			as: _List_Nil
		};
	});
var $author$project$Components$Patient$Charges$ChargeModal$DiscountInCents = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$PriceInCents = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$updateFormFromPreview = F2(
	function (preview, form) {
		return A3(
			$author$project$Utils$Form$update,
			$author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate,
			$author$project$Components$Patient$Charges$ChargeModal$DiscountInCents(
				$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)),
			A3(
				$author$project$Utils$Form$update,
				$author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate,
				$author$project$Components$Patient$Charges$ChargeModal$PriceInCents(
					$elm$core$Maybe$Just(
						$author$project$Currency$fromInt(
							$author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))),
				form));
	});
var $author$project$Components$Patient$Charges$ChargeModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Patient$Charges$ChargeModal$Closed, y8: model, as: _List_Nil};
			case 1:
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator, model.PB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					return {
						EC: A4($author$project$Components$Patient$Charges$ChargeModal$save, model, apiClient, validFormFields, true),
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm, n7: true}),
						as: _List_Nil
					};
				} else {
					var newForm = _v1.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator, model.PB);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return {
						EC: A4($author$project$Components$Patient$Charges$ChargeModal$save, model, apiClient, validFormFields, false),
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm, n7: true}),
						as: _List_Nil
					};
				} else {
					var newForm = _v3.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 3:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField,
					model,
					apiClient,
					dateInput,
					subMsg,
					$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg,
					$author$project$Components$Patient$Charges$ChargeModal$StartDate,
					function ($) {
						return $._E;
					});
			case 4:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A7(
					$author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField,
					model,
					apiClient,
					dateInput,
					subMsg,
					$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg,
					$author$project$Components$Patient$Charges$ChargeModal$EndDate,
					function ($) {
						return $.qs;
					});
			case 5:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var limitedPatientSelectorResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, fields.rd);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{rd: limitedPatientSelectorResult.y8}),
					model.PB);
				var _v5 = function () {
					var _v6 = limitedPatientSelectorResult.ac5;
					_v6$2:
					while (true) {
						if (_v6.$ === 1) {
							switch (_v6.a.$) {
								case 0:
									var patient = _v6.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Patient(
											$elm$core$Maybe$Just(patient)),
										newForm);
								case 3:
									var _v7 = _v6.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Patient($elm$core$Maybe$Nothing),
										newForm);
								default:
									break _v6$2;
							}
						} else {
							break _v6$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v5.a;
				var formCmd = _v5.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorResult.EC),
								formCmd
							])),
					ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
					y8: newModel,
					as: limitedPatientSelectorResult.as
				};
			case 6:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, fields.cK);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{cK: chargeItemResourceResult.y8}),
					model.PB);
				var _v8 = function () {
					var _v9 = chargeItemResourceResult.ac5;
					_v9$2:
					while (true) {
						if ((!_v9.$) && (!_v9.a.$)) {
							switch (_v9.a.a.$) {
								case 0:
									var item = _v9.a.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$ChargeItem(
											$elm$core$Maybe$Just(item)),
										newForm);
								case 5:
									var string = _v9.a.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Name(string),
										newForm);
								default:
									break _v9$2;
							}
						} else {
							break _v9$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v8.a;
				var formCmd = _v8.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.EC),
								formCmd
							])),
					ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
					y8: newModel,
					as: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.cJ);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{cJ: categoryResourceResult.y8}),
					model.PB);
				var _v10 = function () {
					var _v11 = categoryResourceResult.ac5;
					if (!_v11.$) {
						if (!_v11.a.$) {
							return A4(
								$author$project$Components$Patient$Charges$ChargeModal$updateForm,
								model,
								apiClient,
								$author$project$Components$Patient$Charges$ChargeModal$Category(
									$author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8)),
								newForm);
						} else {
							var _v12 = _v11.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{PB: newForm}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{PB: newForm}),
							$elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v10.a;
				var formCmd = _v10.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceResult.EC),
								formCmd
							])),
					ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
					y8: newModel,
					as: categoryResourceResult.as
				};
			case 8:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, fields.jC);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{jC: practitionerResourceResult.y8}),
					model.PB);
				var _v13 = function () {
					var _v14 = practitionerResourceResult.ac5;
					_v14$2:
					while (true) {
						if ((!_v14.$) && (!_v14.a.$)) {
							switch (_v14.a.a.$) {
								case 0:
									var practitioner = _v14.a.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Practitioner(
											$elm$core$Maybe$Just(practitioner)),
										newForm);
								case 2:
									var _v15 = _v14.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Practitioner($elm$core$Maybe$Nothing),
										newForm);
								default:
									break _v14$2;
							}
						} else {
							break _v14$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v13.a;
				var formCmd = _v13.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
								formCmd
							])),
					ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
					y8: newModel,
					as: practitionerResourceResult.as
				};
			case 9:
				var subMsg = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, fields.rl);
				var newForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{rl: locationResourceResult.y8}),
					model.PB);
				var _v16 = function () {
					var _v17 = locationResourceResult.ac5;
					_v17$2:
					while (true) {
						if ((!_v17.$) && (!_v17.a.$)) {
							switch (_v17.a.a.$) {
								case 0:
									var location = _v17.a.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Location(
											$elm$core$Maybe$Just(location)),
										newForm);
								case 2:
									var _v18 = _v17.a.a;
									return A4(
										$author$project$Components$Patient$Charges$ChargeModal$updateForm,
										model,
										apiClient,
										$author$project$Components$Patient$Charges$ChargeModal$Location($elm$core$Maybe$Nothing),
										newForm);
								default:
									break _v17$2;
							}
						} else {
							break _v17$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none);
				}();
				var newModel = _v16.a;
				var formCmd = _v16.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceResult.EC),
								formCmd
							])),
					ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
					y8: newModel,
					as: locationResourceResult.as
				};
			case 10:
				var field = msg.a;
				var _v19 = A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, field, model.PB);
				var newModel = _v19.a;
				var formCmd = _v19.b;
				return {EC: formCmd, ac5: $author$project$Components$Patient$Charges$ChargeModal$None, y8: newModel, as: _List_Nil};
			case 11:
				var shouldClose = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var charge = response.a;
					var _v21 = A2(
						$elm$core$Tuple$mapFirst,
						function (clearedFormFields) {
							return A2($author$project$Utils$Form$set, clearedFormFields, model.PB);
						},
						A3(
							$author$project$Components$Patient$Charges$ChargeModal$clearFormFields,
							apiClient,
							A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.WF),
							$author$project$Utils$Form$fields(model.PB)));
					var resetForm = _v21.a;
					var resetCmds = _v21.b;
					var newModel = _Utils_update(
						model,
						{PB: resetForm, n7: false});
					var _v22 = A5($author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount, model, apiClient, charge, model.PB, shouldClose);
					var cmd = _v22.a;
					var event = _v22.b;
					var outMsg = _v22.c;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[resetCmds, cmd])),
						ac5: event,
						y8: newModel,
						as: outMsg
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: _Utils_update(
							model,
							{n7: false}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 12:
				var response = msg.a;
				var newModel = _Utils_update(
					model,
					{n7: false});
				if (response.$ === 3) {
					var charge = response.a;
					var _v24 = A5($author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount, model, apiClient, charge, model.PB, true);
					var cmd = _v24.a;
					var event = _v24.b;
					var outMsg = _v24.c;
					return {EC: cmd, ac5: event, y8: newModel, as: outMsg};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: newModel,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 13:
				var shouldClose = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var message = _Utils_eq(model.abU, $elm$core$Maybe$Nothing) ? 'Charge created.' : 'Charge updated.';
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: _Utils_eq(model.abU, $elm$core$Maybe$Nothing) ? $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated(shouldClose) : $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, message)
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 14:
				var debounceMsg = msg.a;
				var _v26 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Patient$Charges$ChargeModal$debouncePreview),
					debounceMsg,
					model.em);
				var newDebouncer = _v26.a;
				var cmd = _v26.b;
				return {
					EC: cmd,
					ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
					y8: _Utils_update(
						model,
						{em: newDebouncer}),
					as: _List_Nil
				};
			case 15:
				var cmd = msg.a;
				return {EC: cmd, ac5: $author$project$Components$Patient$Charges$ChargeModal$None, y8: model, as: _List_Nil};
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					var preview = response.a;
					var newForm = A2($author$project$Components$Patient$Charges$ChargeModal$updateFormFromPreview, preview, model.PB);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm, afU: response}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
						y8: _Utils_update(
							model,
							{afU: response}),
						as: _List_Nil
					};
				}
			default:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Patient$Charges$ChargeModal$None,
					y8: _Utils_update(
						model,
						{gJ: !model.gJ}),
					as: _List_Nil
				};
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$updateChargeDropdown = F3(
	function (msg, charge, dropdowns) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v2, _v3) {
					var id = _v2.a;
					var dropdown = _v2.b;
					var cmd = _v2.c;
					var dropdownsAcc = _v3.a;
					var cmdAcc = _v3.b;
					return _Utils_Tuple2(
						_Utils_ap(
							dropdownsAcc,
							_List_fromArray(
								[
									_Utils_Tuple2(id, dropdown)
								])),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, cmdAcc])));
				}),
			_Utils_Tuple2(_List_Nil, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var chargeId = _v0.a;
					var dropdown = _v0.b;
					if (_Utils_eq(
						chargeId,
						$author$project$Api$Provider$Charge$One$id(charge))) {
						var _v1 = A2($author$project$Ui$NewDropdown$update, msg, dropdown);
						var newDropdown = _v1.a;
						var dropdownCmd = _v1.b;
						return _Utils_Tuple3(chargeId, newDropdown, dropdownCmd);
					} else {
						return _Utils_Tuple3(chargeId, dropdown, $elm$core$Platform$Cmd$none);
					}
				},
				dropdowns));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					var cmd = function () {
						var _v2 = $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice);
						if (!_v2.$) {
							var patientPath_ = _v2.a;
							return A2(
								$author$project$Utils$FeatureGate$gateAvailable,
								12,
								$author$project$Api$Practice$Provider(model.WF)) ? $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3(
										$author$project$Api$Provider$ScheduledPayment$list,
										model.D5,
										$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
										$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotScheduledPayments),
										A4($author$project$Api$Card$list, patientPath_, model.D5, model.ZD, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards),
										A4($author$project$Api$BankAccount$list, patientPath_, model.D5, model.ZD, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotBankAccounts)
									])) : ($author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.VM) ? A4($author$project$Api$Card$list, patientPath_, model.D5, model.ZD, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards) : $elm$core$Platform$Cmd$none);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var auditTrailLog = A7(
						$author$project$Components$AuditTrailLog$init,
						model.ZD,
						model.Cd.aav,
						model.Cd.Hy,
						$elm$core$Maybe$Just('customer_invoice'),
						$elm$core$Maybe$Just(model.aea),
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$CustomerInvoice$One$createdAt(invoice)),
						$elm$core$Maybe$Nothing);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hy: $elm$core$Maybe$Just(auditTrailLog),
								hJ: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initChargeDropdowns(invoice),
								Rh: response
							}),
						cmd,
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.VM))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g_: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, subMsg, model.nd);
				var dropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nd: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 24:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$markAsSent,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 25:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$markAsUnsent,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 29:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$applyCredits,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 30:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$removeCredits,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 31:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$transferToCredit,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 32:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$reverseCreditTransfer,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 26:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$stopRetrying,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 27:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$returnToDraft,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 28:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$reverseBadDebt,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 34:
				var invoice = msg.a;
				var _v4 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$init, model.D5, invoice);
				var editInvoiceModal = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							it: $elm$core$Maybe$Just(editInvoiceModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg, cmd),
					_List_Nil);
			case 35:
				var modalMsg = msg.a;
				var _v5 = model.it;
				if (!_v5.$) {
					var modal = _v5.a;
					var _v6 = A3($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$update, model.D5, modalMsg, modal);
					var editInvoiceModel = _v6.a;
					var editInvoiceCmd = _v6.b;
					var event = _v6.c;
					var _v7 = function () {
						if (!event.$) {
							if (!event.a.$) {
								var error = event.a.a;
								return _Utils_Tuple3(
									$elm$core$Platform$Cmd$none,
									_List_fromArray(
										[
											A2(
											$author$project$OutMsg$ShowToast,
											1,
											$author$project$Ui$Toast$serverError(error))
										]),
									$elm$core$Maybe$Just(editInvoiceModel));
							} else {
								var patientId = event.a.a;
								var successText = model.aea + ' was successfully updated.';
								var currentPayer = function () {
									var _v10 = model.Rh;
									if (_v10.$ === 3) {
										var invoice = _v10.a;
										return $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								var redirectCommand = function () {
									if (!currentPayer.$) {
										var currentPayer_ = currentPayer.a;
										return _Utils_eq(
											$author$project$Api$Provider$Patient$Shared$id(currentPayer_),
											patientId) ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea) : A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceRedirect, patientId, model.aea);
									} else {
										return $elm$core$Platform$Cmd$none;
									}
								}();
								return _Utils_Tuple3(
									redirectCommand,
									_List_fromArray(
										[
											A2($author$project$OutMsg$ShowToast, 3, successText)
										]),
									$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple3(
								$elm$core$Platform$Cmd$none,
								_List_Nil,
								$elm$core$Maybe$Just(editInvoiceModel));
						}
					}();
					var cmd = _v7.a;
					var outMsg = _v7.b;
					var newEditInvoiceModal = _v7.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{it: newEditInvoiceModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg, editInvoiceCmd),
									cmd
								])),
						outMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var _v11 = model.lC;
				if (!_v11.$) {
					var createPaymentModal = _v11.a;
					var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.D5, subMsg, createPaymentModal);
					var _v12 = function () {
						var _v13 = createPaymentModalResult.ac5;
						switch (_v13) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPaymentModalResult.y8),
									model.Rh,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPaymentModal_ = _v12.a;
					var invoice = _v12.b;
					var cmd = _v12.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{lC: createPaymentModal_, Rh: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg, createPaymentModalResult.EC),
									cmd
								])),
						createPaymentModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var subMsg = msg.a;
				var _v14 = model.h0;
				if (!_v14.$) {
					var createScheduledPaymentModal = _v14.a;
					var createScheduledPaymentModalResult = A3($author$project$Components$Invoice$CreateScheduledPaymentModal$update, model.D5, subMsg, createScheduledPaymentModal);
					var _v15 = function () {
						var _v16 = createScheduledPaymentModalResult.ac5;
						switch (_v16) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createScheduledPaymentModalResult.y8),
									model.Rh,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, $elm$core$Platform$Cmd$none);
						}
					}();
					var createScheduledPaymentModal_ = _v15.a;
					var invoice = _v15.b;
					var cmd = _v15.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h0: createScheduledPaymentModal_, Rh: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg, createScheduledPaymentModalResult.EC),
									cmd
								])),
						createScheduledPaymentModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var subMsg = msg.a;
				var _v17 = model.h_;
				if (!_v17.$) {
					var createPassthroughFeesPaymentModal = _v17.a;
					var createPassthroughFeesPaymentModalResult = A3($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$update, model.D5, subMsg, createPassthroughFeesPaymentModal);
					var _v18 = function () {
						var _v19 = createPassthroughFeesPaymentModalResult.ac5;
						switch (_v19) {
							case 1:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPassthroughFeesPaymentModalResult.y8),
									model.Rh,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, $elm$core$Platform$Cmd$none);
						}
					}();
					var createPassthroughFeesPaymentModal_ = _v18.a;
					var invoice = _v18.b;
					var cmd = _v18.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{h_: createPassthroughFeesPaymentModal_, Rh: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg, createPassthroughFeesPaymentModalResult.EC),
									cmd
								])),
						createPassthroughFeesPaymentModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var subMsg = msg.a;
				var _v20 = model.hp;
				if (!_v20.$) {
					var adjustVoidModal = _v20.a;
					var adjustVoidModalResult = A3($author$project$Components$CustomerInvoice$AdjustVoidModal$update, model.D5, subMsg, adjustVoidModal);
					var _v21 = function () {
						var _v22 = adjustVoidModalResult.ac5;
						switch (_v22) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(adjustVoidModalResult.y8),
									model.Rh,
									$elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Api$Data$Loading,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
							default:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, $elm$core$Platform$Cmd$none);
						}
					}();
					var newAdjustVoidModal = _v21.a;
					var invoice = _v21.b;
					var cmd = _v21.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hp: newAdjustVoidModal, Rh: invoice}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg, adjustVoidModalResult.EC),
									cmd
								])),
						adjustVoidModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal, model, invoice, false));
			case 7:
				var subMsg = msg.a;
				var _v23 = model.jG;
				if (!_v23.$) {
					var processRefundModal = _v23.a;
					var processRefundModalResult = A3($author$project$Components$CustomerInvoice$ProcessRefundModal$update, model.D5, subMsg, processRefundModal);
					var _v24 = function () {
						var _v25 = processRefundModalResult.ac5;
						switch (_v25) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(processRefundModalResult.y8),
									model.Rh,
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Rh, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(processRefundModalResult.y8),
									model.Rh,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
							case 3:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									model.Rh,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									model.Rh,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
						}
					}();
					var newProcessRefundModal = _v24.a;
					var invoice = _v24.b;
					var cmd = _v24.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: invoice, jG: newProcessRefundModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg, processRefundModalResult.EC),
									cmd
								])),
						processRefundModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initProcessRefundModal, model, invoice));
			case 5:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal, model, invoice, true));
			case 8:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal, model, invoice, true, 1));
			case 12:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal, model, invoice, false, 0));
			case 13:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePassthroughFeesPaymentModal, model, invoice));
			case 22:
				var charge = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$Charge$delete,
						model.D5,
						model.aea,
						$author$project$Api$Provider$Charge$One$id(charge),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDeleted),
					_List_Nil);
			case 23:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h6: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				var confirmed = msg.a;
				return confirmed ? $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$deleteInvoice(
					_Utils_update(
						model,
						{h6: false})) : _Utils_Tuple3(
					_Utils_update(
						model,
						{h6: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 16:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hA: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 17:
				var confirmed = msg.a;
				return confirmed ? $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$markAsBadDebt(
					_Utils_update(
						model,
						{hA: false})) : _Utils_Tuple3(
					_Utils_update(
						model,
						{hA: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 18:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
								{
									VN: $author$project$Api$Provider$Patient$One$id(model.VM)
								})),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Invoice removed')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 19:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response}),
						A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 21:
				var invoice = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mK: true}),
					A4(
						$author$project$Api$Provider$CustomerInvoice$issue,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceIssued),
					_List_Nil);
			case 20:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Rh: response, mK: false}),
						A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea),
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.VM))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mK: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 36:
				var id = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							wS: A3($elm$core$Dict$insert, id, $author$project$Api$Data$Loading, model.wS)
						}),
					A3(
						$author$project$Api$Provider$Charge$CoverageDiscount$list,
						model.D5,
						id,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCoverageDiscounts(id)),
					_List_Nil);
			case 37:
				var chargeId = msg.a;
				var response = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							wS: A3($elm$core$Dict$insert, chargeId, response, model.wS)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 38:
				var _v30 = model.Rh;
				if (_v30.$ === 3) {
					var invoice = _v30.a;
					var _v31 = A6($author$project$Components$Patient$Charges$ChargeModal$init, model.D5, model.ZD, model.WF, model.VM, invoice, $elm$core$Maybe$Nothing);
					var modal = _v31.a;
					var modalCmd = _v31.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fd: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, modalCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 39:
				var charge = msg.a;
				var _v32 = model.Rh;
				if (_v32.$ === 3) {
					var invoice = _v32.a;
					var _v33 = A6(
						$author$project$Components$Patient$Charges$ChargeModal$init,
						model.D5,
						model.ZD,
						model.WF,
						model.VM,
						invoice,
						$elm$core$Maybe$Just(charge));
					var modal = _v33.a;
					var modalCmd = _v33.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fd: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, modalCmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 40:
				var subMsg = msg.a;
				var _v34 = model.fd;
				if (!_v34.$) {
					var chargeModal = _v34.a;
					var chargeModalResult = A3($author$project$Components$Patient$Charges$ChargeModal$update, model.D5, subMsg, chargeModal);
					var _v35 = function () {
						var _v36 = chargeModalResult.ac5;
						switch (_v36.$) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(chargeModalResult.y8),
									$elm$core$Platform$Cmd$none);
							case 2:
								var shouldClose = _v36.a;
								return shouldClose ? _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea)) : _Utils_Tuple2(
									$elm$core$Maybe$Just(chargeModalResult.y8),
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
							case 3:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
							default:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
						}
					}();
					var newModalModel = _v35.a;
					var cmd = _v35.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fd: newModalModel}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, chargeModalResult.EC)
								])),
						chargeModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 41:
				var invoice = msg.a;
				var _v37 = A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg),
					A2(
						$author$project$Components$CustomerSchedulePaymentModal$open,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						model.cO));
				var schedulePaymentModal = _v37.a;
				var schedulePaymentModalCmd = _v37.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gA: schedulePaymentModal}),
					schedulePaymentModalCmd,
					_List_Nil);
			case 42:
				var subMsg = msg.a;
				var schedulePaymentResult = A3($author$project$Components$CustomerSchedulePaymentModal$update, model.D5, subMsg, model.gA);
				var invoice = function () {
					var _v38 = schedulePaymentResult.ac5;
					if (!_v38.$) {
						return model.Rh;
					} else {
						var invoice_ = _v38.b;
						return invoice_;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Rh: invoice, gA: schedulePaymentResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg, schedulePaymentResult.EC),
					schedulePaymentResult.as);
			case 33:
				var invoice = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$CustomerInvoice$cancelPayment,
						model.D5,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						_List_fromArray(
							[0, 1]),
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 43:
				var subMsg = msg.a;
				var _v39 = A2($author$project$Ui$NewDropdown$update, subMsg, model.kr);
				var taxDropdown = _v39.a;
				var taxDropdownCmd = _v39.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kr: taxDropdown}),
					taxDropdownCmd,
					_List_Nil);
			case 44:
				var profile = msg.a;
				var fields = {
					MO: $elm$core$Maybe$Nothing,
					aet: $elm$core$Maybe$Nothing,
					Vp: $elm$core$Maybe$Nothing,
					$t: $elm$core$Maybe$Just(
						$author$project$Api$Provider$TaxProfile$All$id(profile))
				};
				return _Utils_Tuple3(
					model,
					A5($author$project$Api$Provider$CustomerInvoice$update, model.D5, model.aea, fields, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice),
					_List_Nil);
			case 45:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.D5, subMsg, model.iq);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iq: downloadInvoiceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg, downloadInvoiceResult.EC),
					downloadInvoiceResult.as);
			case 46:
				var subMsg = msg.a;
				var _v40 = A3($author$project$Components$CustomerEmailModal$update, model.D5, subMsg, model.lH);
				var customerEmailModal = _v40.a;
				var subCmd = _v40.b;
				var subOutMsg = _v40.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lH: customerEmailModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg, subCmd),
					subOutMsg);
			case 47:
				var subMsg = msg.a;
				var refreshInvoice = _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.D5, model.aea));
				var paymentsListResult = A3($author$project$Components$PaymentsList$update, model.D5, subMsg, model.jr);
				var _v41 = function () {
					var _v42 = paymentsListResult.ac5;
					switch (_v42) {
						case 1:
							return refreshInvoice;
						case 3:
							return refreshInvoice;
						case 2:
							return refreshInvoice;
						case 4:
							return refreshInvoice;
						default:
							return _Utils_Tuple2(model.Rh, $elm$core$Platform$Cmd$none);
					}
				}();
				var invoice = _v41.a;
				var cmd = _v41.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Rh: invoice, jr: paymentsListResult.y8}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg, paymentsListResult.EC),
								cmd
							])),
					paymentsListResult.as);
			case 48:
				var subMsg = msg.a;
				var _v43 = function () {
					var _v44 = model.hy;
					if (!_v44.$) {
						var auditTrailLog = _v44.a;
						var result = A3($author$project$Components$AuditTrailLog$update, model.D5, subMsg, auditTrailLog);
						return _Utils_Tuple3(
							$elm$core$Maybe$Just(result.y8),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg, result.EC),
							result.as);
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}();
				var auditTrailLogResultModel = _v43.a;
				var auditTrailLogResultCmd = _v43.b;
				var auditTrailLogResultOutMsgs = _v43.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hy: auditTrailLogResultModel}),
					auditTrailLogResultCmd,
					auditTrailLogResultOutMsgs);
			case 49:
				var charge = msg.a;
				var subMsg = msg.b;
				var _v45 = A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$updateChargeDropdown, subMsg, charge, model.hJ);
				var chargesDropdowns = _v45.a;
				var dropdownCmd = _v45.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hJ: chargesDropdowns}),
					dropdownCmd,
					_List_Nil);
			case 50:
				var response = msg.a;
				if (response.$ === 3) {
					var scheduledPayments = response.a;
					var passthroughFeesCmd = function () {
						var _v47 = _Utils_Tuple2(
							$author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.VM),
							model.Rh);
						if (_v47.a && (_v47.b.$ === 3)) {
							var _v48 = _v47.b;
							var invoice = _v48.a;
							return A4(
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd,
								model.D5,
								$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice),
								A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource, model.WF, invoice, model.pN, scheduledPayments),
								model.VN);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jZ: scheduledPayments}),
						passthroughFeesCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 52:
				var response = msg.a;
				var passthroughFeesCmd = function () {
					var _v49 = _Utils_Tuple2(
						$author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.VM),
						model.Rh);
					if (_v49.a && (_v49.b.$ === 3)) {
						var _v50 = _v49.b;
						var invoice = _v50.a;
						return A4(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd,
							model.D5,
							$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice),
							A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource, model.WF, invoice, response, model.jZ),
							model.VN);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pN: response}),
					passthroughFeesCmd,
					$author$project$OutMsg$handleErrorResponse(response));
			case 51:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pD: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 53:
				var invoice = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreateScheduledPaymentModal, model, invoice));
			case 54:
				var fees = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{VJ: fees}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Q8: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Api$Provider$CustomerInvoice$One$invoiceNumber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$invoiceNumber(shared);
};
var $author$project$Api$Provider$CustomerInvoice$Meta$issueAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Sh;
};
var $author$project$Api$Provider$CustomerInvoice$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$Submit = {$: 0};
var $author$project$Ui$Padding$Top_0 = 5;
var $author$project$Ui$Form$Checkbox$ContainerAttr = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Form$Checkbox$containerAttr = function (attributes) {
	return $author$project$Ui$Form$Checkbox$ContainerAttr(attributes);
};
var $author$project$Api$Provider$Charge$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$Charge$One$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$type_(shared);
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$chargeSentence = F2(
	function (charge, canEdit) {
		var practitioner = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (name) {
					return ' with ' + name;
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Practitioner$Shared$name,
					$author$project$Api$Provider$Charge$One$practitioner(charge))));
		var patient = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name,
				$author$project$Api$Provider$Charge$One$patient(charge)));
		var date = A2(
			$justinmimbs$date$Date$format,
			'MM/dd/yyyy',
			$author$project$Api$Provider$Charge$One$date(charge));
		var period = function () {
			if ($author$project$Api$Provider$Charge$One$type_(charge) === 'service') {
				return ' on ' + date;
			} else {
				if (canEdit) {
					return ' from ' + (date + ' to ');
				} else {
					var endDate = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$justinmimbs$date$Date$format('MM/dd/yyyy'),
							$author$project$Api$Provider$Charge$One$endDate(charge)));
					return ' from ' + (date + (' to ' + endDate));
				}
			}
		}();
		return _Utils_ap(
			patient,
			_Utils_ap(practitioner, period));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewChargeNameCell = function (fields) {
	var strikeOption = fields.M ? _List_fromArray(
		[$author$project$Ui$Typography$strike]) : _List_Nil;
	return A2(
		$author$project$Ui$Table$cell,
		_List_fromArray(
			[$author$project$Ui$Table$alignCenter]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				strikeOption,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$Charge$One$name(fields.abU)))
					]))
			]));
};
var $author$project$Components$DateInput$Attr = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$DateInput$attr = function (attributes) {
	return $author$project$Components$DateInput$Attr(attributes);
};
var $author$project$Components$DateInput$Inline = {$: 8};
var $author$project$Components$DateInput$inline = $author$project$Components$DateInput$Inline;
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewEndDateInput = F2(
	function (canEdit, fields) {
		if (canEdit && ($author$project$Api$Provider$Charge$One$type_(fields.abU) === 'coverage')) {
			var _v0 = fields.qu;
			if (!_v0.$) {
				var endDateInput = _v0.a;
				return A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate),
							A2(
								$author$project$Components$DateInput$view,
								_List_fromArray(
									[
										$author$project$Components$DateInput$value(fields.qs),
										$author$project$Components$DateInput$attr(
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'width', '150px')
											])),
										$author$project$Components$DateInput$inline,
										$author$project$Components$DateInput$disabled(fields.M)
									]),
								endDateInput))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$DiscountOverridden = {$: 7};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCents = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Charge$Meta$revisableAction = function (_v0) {
	var meta = _v0;
	return meta.tF.YL;
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewPriceCell = F2(
	function (form, fields) {
		var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction(
			$author$project$Api$Provider$Charge$One$meta(fields.abU));
		var hasDiscount = (!(!$author$project$Api$Provider$Charge$One$discountInCents(fields.abU))) && (!fields.xf);
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(fields.Ba),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCents)),
							$author$project$Ui$Form$CurrencyInput$disabled(fields.M || (hasDiscount || (!isRevisable))),
							$author$project$Ui$Form$CurrencyInput$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						])),
					function () {
					if ($author$project$Api$Provider$Uom$Shared$isTimeBased(fields.Be)) {
						var strikeOption = fields.M ? _List_fromArray(
							[$author$project$Ui$Typography$strike]) : _List_Nil;
						var priceUom = $author$project$Api$Provider$Charge$One$priceUom(fields.abU);
						return A2(
							$author$project$Ui$Typography$span,
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Typography$muted,
								A2(
									$elm$core$List$cons,
									$author$project$Ui$Typography$pull(1),
									A2($elm$core$List$cons, $author$project$Ui$Typography$small, strikeOption))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'per ' + $author$project$Api$Provider$Uom$Shared$name(priceUom))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					hasDiscount ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Remove membership rule'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$DiscountOverridden),
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$sm
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove membership rule')
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Quantity = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityUom = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewQuantityCell = F2(
	function (form, fields) {
		var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction(
			$author$project$Api$Provider$Charge$One$meta(fields.abU));
		var quantityInput = $author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$number,
					$author$project$Ui$Form$Input$value(
					A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Bd))),
					$author$project$Ui$Form$Input$onInput(
					A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Quantity)),
					$author$project$Ui$Form$Input$errors(
					A2($author$project$Utils$Form$validationErrors, 1, form)),
					$author$project$Ui$Form$Input$disabled(fields.M || (!isRevisable))
				]));
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					if ($author$project$Api$Provider$Uom$Shared$isTimeBased(fields.Be)) {
						var uomOptions = A2(
							$elm$core$List$map,
							function (uom_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Uom$Shared$code(uom_)),
									$author$project$Api$Provider$Uom$Shared$name(uom_));
							},
							$author$project$Api$Provider$Uom$list(
								function (d) {
									return _Utils_update(
										d,
										{
											HH: $elm$core$Maybe$Just('time')
										});
								}));
						return A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(5)
										]),
									_List_fromArray(
										[quantityInput])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(7)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$Uom$Shared$code(fields.Be))),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityUom)),
													$author$project$Ui$Form$Select$disabled(fields.M || (!isRevisable))
												]),
											uomOptions)
										]))
								]));
					} else {
						return quantityInput;
					}
				}()
				]));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$ReturnToInventory = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewReturnToInventory = F2(
	function (fields, voidOnly) {
		var quantityReduced = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (quantity_) {
					return _Utils_cmp(
						$author$project$Api$Provider$Charge$One$quantity(fields.abU),
						quantity_) > 0;
				},
				fields.Bd));
		return ($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory(fields.abU) && (fields.M || quantityReduced)) ? A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$pull(1),
					$author$project$Ui$Typography$padding(0),
					$author$project$Ui$Typography$attrs(
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'inline-flex')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(fields.ex),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$ReturnToInventory)),
							$author$project$Ui$Form$Checkbox$inline,
							$author$project$Ui$Form$Checkbox$attr(
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$style, 'padding', '0')
								])),
							$author$project$Ui$Form$Checkbox$disabled(voidOnly)
						]),
					_List_Nil),
					A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Return to Inventory')
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$ChargeAdjustment$Shared$subtotalAdjustmentInCents = function (_v0) {
	var record = _v0;
	return record._6;
};
var $author$project$Api$Provider$ChargeAdjustment$Preview$subtotalAdjustmentInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$ChargeAdjustment$Shared$subtotalAdjustmentInCents(shared);
};
var $author$project$Api$Provider$Charge$Shared$subtotalInCents = function (_v0) {
	var record = _v0;
	return record._7;
};
var $author$project$Api$Provider$Charge$One$subtotalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$subtotalInCents(shared);
};
var $author$project$Api$Provider$Charge$Shared$taxable = function (_v0) {
	var record = _v0;
	return record.$u;
};
var $author$project$Api$Provider$Charge$One$taxable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$taxable(shared);
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewSubtotalCell = F3(
	function (adjustmentPreview, fields, voidOnly) {
		var taxLabel = $author$project$Api$Provider$Charge$One$taxable(fields.abU) ? $elm$html$Html$text(' + tax') : $author$project$Utils$Html$empty;
		var subtotalAdjustmentInCents = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeAdjustment$Preview$subtotalAdjustmentInCents, adjustmentPreview));
		var strikeOption = fields.M ? _List_fromArray(
			[$author$project$Ui$Typography$strike]) : _List_Nil;
		var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction(
			$author$project$Api$Provider$Charge$One$meta(fields.abU));
		var tooltipIcon = function () {
			if ((!isRevisable) && (!voidOnly)) {
				var isChargeItemPackage = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$ForCharge$isPackage, fields.lp));
				var tooltipMessage = isChargeItemPackage ? 'Packages cannot be revised on invoices.' : 'Items included in a package cannot be revised on invoices.';
				return _List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[$author$project$Ui$Tooltip$wide]),
						tooltipMessage,
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 5)
							])),
						$author$project$Utils$Html$noBreakSpace
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$author$project$Ui$Table$cell,
			_List_fromArray(
				[$author$project$Ui$Table$alignCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight),
						strikeOption),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$margin(0)
								]),
							(!subtotalAdjustmentInCents) ? _Utils_ap(
								tooltipIcon,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$bold]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$Charge$One$subtotalInCents(fields.abU)))
											])),
										A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										_List_fromArray(
											[taxLabel]))
									])) : _Utils_ap(
								tooltipIcon,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$Charge$One$subtotalInCents(fields.abU)))
											])),
										$author$project$Utils$Html$noBreakSpace,
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$bold]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$Charge$One$subtotalInCents(fields.abU) + subtotalAdjustmentInCents))
											])),
										A2(
										$author$project$Ui$Typography$div,
										_List_Nil,
										_List_fromArray(
											[taxLabel]))
									])))
						]))
				]));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Void = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewVoidCell = F2(
	function (fields, voidOnly) {
		var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction(
			$author$project$Api$Provider$Charge$One$meta(fields.abU));
		return A2(
			$author$project$Ui$Table$cell,
			_List_fromArray(
				[$author$project$Ui$Table$alignCenter]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(fields.M),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Void)),
							$author$project$Ui$Form$Checkbox$disabled(voidOnly || (!isRevisable))
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$view = function (_v0) {
	var form = _v0.PB;
	var adjustmentPreview = _v0.tL;
	var voidOnly = _v0.DM;
	var fields = $author$project$Utils$Form$fields(form);
	var canEdit = $author$project$Api$Provider$Charge$Meta$editAction(
		$author$project$Api$Provider$Charge$One$meta(fields.abU));
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Table$row,
			_List_fromArray(
				[
					$author$project$Ui$Table$styled(2)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(5),
							$author$project$Ui$Table$alignCenter
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$chargeSentence, fields.abU, canEdit))
								])),
							A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewEndDateInput, canEdit, fields),
							A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewReturnToInventory, fields, voidOnly)
						]))
				])),
			A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewVoidCell, fields, voidOnly),
					$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewChargeNameCell(fields),
					A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewQuantityCell, form, fields),
					A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewPriceCell, form, fields),
					A3($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewSubtotalCell, adjustmentPreview, fields, voidOnly)
				]))
		]);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewChargesTable = function (model) {
	var adjustmentRows = A2(
		$elm$core$List$concatMap,
		function (_v0) {
			var chargeId = _v0.a;
			var form = _v0.b;
			return A2(
				$elm$core$List$map,
				$author$project$Ui$Table$mapRow(
					$author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId)),
				$author$project$Components$CustomerInvoice$ChargeAdjustmentForm$view(form));
		},
		model.W);
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$Ui$Panel$table,
				_List_fromArray(
					[
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('There are no charges.')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Checkbox$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Checkbox$containerAttr(
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'margin-top', '3px')
											])),
										$author$project$Ui$Form$Checkbox$attr(
										_List_fromArray(
											[
												$author$project$Ui$Padding$toClass(5)
											])),
										$author$project$Ui$Form$Checkbox$value(
										$author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model)),
										$author$project$Ui$Form$Checkbox$onCheck($author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll),
										$author$project$Ui$Form$Checkbox$disabled(model.DM)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Void')
									]))
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Charge')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Qty')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(3)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Price')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_fromArray(
							[
								$author$project$Ui$Table$cellSpan(2),
								$author$project$Ui$Table$textRight
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Amount')
							]))
					]),
				adjustmentRows,
				_List_Nil)
			]));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Charges')
							]))
					])),
				$author$project$Components$CustomerInvoice$AdjustmentsForm$viewChargesTable(model)
			]));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$MemoUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewNewDue = F4(
	function (totalInCents, totalPayments, totalAdjustment, totalRefundedAmount) {
		if (!(!totalAdjustment)) {
			var newDue = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount, totalInCents, totalPayments, totalAdjustment) + totalRefundedAmount;
			return A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(4)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$attrs(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-label-md')
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('New due:')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$display4]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(newDue))
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Utils$Currency$fromIntWithPlus = function (cents) {
	return (cents >= 0) ? ('+' + $author$project$Utils$Currency$fromInt(cents)) : $author$project$Utils$Currency$fromInt(cents);
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewPayments = F2(
	function (totalPayments, totalAdjustment) {
		return (!(!totalAdjustment)) ? A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$attrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-label-md')
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Payments:')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$bold]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromIntWithPlus(-totalPayments))
										]))
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewRefunds = function (totalRefundedAmount) {
	return (!(!totalRefundedAmount)) ? A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-label-md')
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('New refunds:')
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromIntWithPlus(totalRefundedAmount))
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewRevision = function (totalAdjustment) {
	if (!(!totalAdjustment)) {
		var color = (totalAdjustment > 0) ? $author$project$Ui$Typography$success : $author$project$Ui$Typography$danger;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$attrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-label-md')
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New revision:')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(8)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$bold, color]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromIntWithPlus(totalAdjustment))
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummaryContent = function (model) {
	var totalPayments = $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount(model.Rh);
	var totalAdjustment = A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents,
			$author$project$Api$Data$toMaybe(model.afU)));
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$attrs(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-label-md')
													]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Original total:')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$p,
												_List_fromArray(
													[$author$project$Ui$Typography$bold]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.Rh)))
													]))
											]))
									]))
							])),
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewRevision(totalAdjustment),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						A2($author$project$Components$CustomerInvoice$AdjustmentsForm$viewPayments, totalPayments, totalAdjustment),
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$thin])),
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewRefunds(model.oP),
						A4(
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewNewDue,
						$author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.Rh),
						totalPayments,
						totalAdjustment,
						model.oP),
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$phi(true),
								$author$project$Ui$Form$Textarea$placeholder('Reason / memo for revision'),
								$author$project$Ui$Form$Textarea$onInput($author$project$Components$CustomerInvoice$AdjustmentsForm$MemoUpdated),
								$author$project$Ui$Form$Textarea$value(
								A2($elm$core$Maybe$withDefault, '', model.aeC))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpBlock]),
						_List_fromArray(
							[
								$elm$html$Html$text('This is an internal note and does not appear on the printed invoice.')
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Summary')
							]))
					])),
				$author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummaryContent(model)
			]));
};
var $author$project$Components$CustomerInvoice$AdjustmentsForm$view = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges(model)
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary(model)
					]))
			]));
};
var $author$project$Components$CustomerInvoice$AdjustVoidModal$view = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(false),
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$onSubmit($author$project$Components$CustomerInvoice$AdjustVoidModal$Submit)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$CustomerInvoice$AdjustVoidModal$Close,
				_List_fromArray(
					[
						$author$project$Ui$Modal$size(3)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Create Revision')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg,
								$author$project$Components$CustomerInvoice$AdjustmentsForm$view(model.bj))
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$AdjustVoidModal$Close)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								function () {
								var verb = (model.DM || $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model.bj)) ? 'Void' : 'Revise';
								return A3(
									$author$project$Ui$Button$view,
									{abp: verb + ' invoice'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$loading(model.kj),
											$author$project$Ui$Button$disabled(
											$author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError(model.bj)),
											$author$project$Ui$Button$submit
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(verb)
										]));
							}()
							]))
					]))
			]));
};
var $author$project$Api$Provider$PassthroughFee$Shared$totalInCents = function (_v0) {
	var internalRecord = _v0;
	return internalRecord.$X;
};
var $author$project$Api$Provider$PassthroughFee$One$totalInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PassthroughFee$Shared$totalInCents(shared);
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesTotalAmount = function (passthroughFees) {
	if (passthroughFees.$ === 3) {
		var passthrough = passthroughFees.a;
		return $author$project$Api$Provider$PassthroughFee$One$totalInCents(passthrough);
	} else {
		return 0;
	}
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardType = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CreatePayment = {$: 5};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$StoreCard = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$UpdateUseExistingSources = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardTypeOptions = _List_fromArray(
	[
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Choose a card type...'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('debit'),
		'Debit'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('credit'),
		'Credit'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just('amex'),
		'American Express')
	]);
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCardReaders = function (model) {
	var _v0 = function () {
		var _v1 = model.hG;
		if (_v1.$ === 3) {
			var cardReaders_ = _v1.a;
			return _Utils_Tuple2(cardReaders_, false);
		} else {
			return _Utils_Tuple2(_List_Nil, true);
		}
	}();
	var cardReaders = _v0.a;
	var cardReadersLoading = _v0.b;
	var _v2 = $author$project$Utils$Form$fields(model.PB);
	var cardReader = _v2.abR;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				((!cardReadersLoading) && $elm$core$List$isEmpty(cardReaders)) ? A2(
				$author$project$Ui$Alert$danger,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('There are no card readers available. Please '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Admin__CardReaders,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('add a card reader')
							])),
						$elm$html$Html$text(' now.')
					])) : $author$project$Utils$Html$empty,
				A2(
				$elm$html$Html$map,
				$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderSelectMsg,
				A3(
					$author$project$Ui$Form$SearchableSelect$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$SearchableSelect$value(cardReader),
							$author$project$Ui$Form$SearchableSelect$placeholder('Choose Card Reader'),
							$author$project$Ui$Form$SearchableSelect$loading(cardReadersLoading),
							$author$project$Ui$Form$SearchableSelect$disabled(
							$elm$core$List$isEmpty(cardReaders)),
							$author$project$Ui$Form$SearchableSelect$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
							$author$project$Ui$Form$SearchableSelect$errors(
							A2($author$project$Utils$Form$validationErrors, 1, model.PB))
						]),
					A2(
						$elm$core$List$map,
						$author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil),
						cardReaders),
					model.pM)),
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[
						$author$project$Ui$Typography$margin(20),
						$author$project$Ui$Typography$muted
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Defaulted to the last reader used on this computer. '),
						$elm$html$Html$text('Tap payments such as Apple Pay & Google Pay are not supported at this time.')
					]))
			]));
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Memo = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewMemoField = function (fields) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Memo'),
				$author$project$Ui$Form$Group$labelSpan(2),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', fields.aeC)),
						$author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
						$author$project$Ui$Form$Input$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Memo))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCentsBlur = {$: 2};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPayNowPanel = F2(
	function (fields, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Payment'),
					$author$project$Ui$Form$Group$labelSpan(2),
					$author$project$Ui$Form$Group$inputSpan(10)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(fields.I2),
											$author$project$Ui$Form$CurrencyInput$onInput(
											A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCents)),
											$author$project$Ui$Form$CurrencyInput$onBlur($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCentsBlur),
											$author$project$Ui$Form$CurrencyInput$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6),
									$author$project$Ui$FlexGrid$itemsCenter
								]),
							_List_fromArray(
								[
									A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, model.V, fields) ? A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' of '),
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(fields.mB)),
													$elm$html$Html$text(' due')
												])),
											$author$project$Utils$Html$noBreakSpace,
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
											_List_fromArray(
												[
													$elm$html$Html$text('(+ credit card fees)')
												]))
										])) : A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
											$author$project$Ui$Typography$margin(10)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(' of '),
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(fields.mB)),
													$elm$html$Html$text(' due')
												]))
										]))
								]))
						])),
					$author$project$Utils$FormErrors$view(
					A2($author$project$Utils$Form$validationErrors, 0, model.PB))
				]));
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentSources = F2(
	function (model, selected) {
		var selectedSourceId = A2($elm$core$Maybe$map, $author$project$Api$Source$id, selected);
		var patientSources = function () {
			var _v1 = _Utils_Tuple2(model.pN, model.pD);
			if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
				var _v2 = _v1.a;
				var cards = _v2.a;
				var _v3 = _v1.b;
				var bankAccounts = _v3.a;
				return $elm$core$List$reverse(
					A2(
						$elm$core$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Api$Source$createdAt,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Maybe$map($elm$time$Time$posixToMillis),
								$elm$core$Maybe$withDefault(0))),
						_Utils_ap(
							A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
							A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
			} else {
				return _List_Nil;
			}
		}();
		var isSelectedInList = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (id) {
					return A2(
						$elm$core$List$any,
						function (s) {
							return _Utils_eq(
								$author$project$Api$Source$id(s),
								id);
						},
						patientSources);
				},
				selectedSourceId));
		var sources = function () {
			var _v0 = _Utils_Tuple2(selected, isSelectedInList);
			if ((!_v0.a.$) && (!_v0.b)) {
				var selectedSource = _v0.a.a;
				return A2($elm$core$List$cons, selectedSource, patientSources);
			} else {
				return patientSources;
			}
		}();
		return A2(
			$elm$html$Html$map,
			$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaymentSourceSelectMsg,
			A3(
				$author$project$Ui$Form$SearchableSelect$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$SearchableSelect$value(selected),
						$author$project$Ui$Form$SearchableSelect$placeholder('Select a Source'),
						$author$project$Ui$Form$SearchableSelect$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB)),
						$author$project$Ui$Form$SearchableSelect$errors(
						A2($author$project$Utils$Form$validationErrors, 2, model.PB))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil),
					sources),
				model.r_));
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesInCents = function (passthroughFees) {
	if (passthroughFees.$ === 3) {
		var passthrough = passthroughFees.a;
		return $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents(passthrough);
	} else {
		return 0;
	}
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentTotalModal = F2(
	function (subtotal, passthroughFees) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Payment Total')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetSm(1),
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
									_List_fromArray(
										[
											$elm$html$Html$text('Subtotal')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Currency$format(
												$author$project$Currency$fromInt(subtotal)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetSm(1),
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
									_List_fromArray(
										[
											$elm$html$Html$text('Credit Card Fees')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Currency$format(
												$author$project$Currency$fromInt(
													$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesInCents(passthroughFees))))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPayNowModal = F3(
	function (model, fields, amountInCentsString) {
		return _List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Process Payment')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CreatePayment),
								$author$project$Ui$Form$horizontal
							]),
						$elm$core$List$concat(
							_List_fromArray(
								[
									_List_fromArray(
									[
										A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPayNowPanel, fields, model),
										$author$project$Utils$Html$empty,
										$author$project$Utils$Html$empty,
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Source'),
												$author$project$Ui$Form$Group$labelSpan(2),
												$author$project$Ui$Form$Group$inputSpan(9)
											]),
										_List_fromArray(
											[
												($author$project$Api$Practice$usesCardReaders(model.WF) && (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.ZD))) ? $author$project$Ui$Form$ButtonSelect$view(
												{
													ae4: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$UpdateUseExistingSources,
													zY: _List_fromArray(
														[
															A2($author$project$Ui$Form$ButtonSelect$option, true, 'Existing payment source'),
															A2($author$project$Ui$Form$ButtonSelect$option, false, 'Card Reader')
														]),
													aaN: model.V
												}) : $author$project$Utils$Html$empty,
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$margin(2)
													]),
												_List_Nil),
												model.V ? A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentSources, model, fields.Hg) : $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCardReaders(model)
											]))
									]),
									function () {
									if (!model.V) {
										var _v0 = function () {
											var _v1 = model.hG;
											if (_v1.$ === 3) {
												var cardReaders_ = _v1.a;
												return _Utils_Tuple2(cardReaders_, false);
											} else {
												return _Utils_Tuple2(_List_Nil, true);
											}
										}();
										var cardReaders = _v0.a;
										var cardReadersLoading = _v0.b;
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Card Type'),
														$author$project$Ui$Form$Group$labelSpan(2),
														$author$project$Ui$Form$Group$inputSpan(9),
														$author$project$Ui$Form$Group$clearfix
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Select$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$Select$value(fields.KI),
																$author$project$Ui$Form$Select$onChange(
																A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardType)),
																$author$project$Ui$Form$Select$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
																$author$project$Ui$Form$Select$errors(
																A2($author$project$Utils$Form$validationErrors, 3, model.PB))
															]),
														$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardTypeOptions),
														function () {
														var _v2 = fields.KI;
														_v2$3:
														while (true) {
															if (!_v2.$) {
																switch (_v2.a) {
																	case 'debit':
																		return A3(
																			$author$project$Ui$Alert$view,
																			1,
																			_List_fromArray(
																				[
																					$author$project$Ui$Alert$margin(20)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('No extra fees will be charged to the customer\'s card')
																				]));
																	case 'credit':
																		return A3(
																			$author$project$Ui$Alert$view,
																			2,
																			_List_fromArray(
																				[
																					$author$project$Ui$Alert$margin(20)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Credit card fees will be charged to the customer\'s card')
																				]));
																	case 'amex':
																		return A3(
																			$author$project$Ui$Alert$view,
																			2,
																			_List_fromArray(
																				[
																					$author$project$Ui$Alert$margin(20)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Credit card fees will be charged to the customer\'s card')
																				]));
																	default:
																		break _v2$3;
																}
															} else {
																break _v2$3;
															}
														}
														return $author$project$Utils$Html$empty;
													}()
													])),
												A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Remember this card'),
														$author$project$Ui$Form$Group$labelSpan(2),
														$author$project$Ui$Form$Group$inputSpan(9)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Store card for future use')
															])),
														((!cardReadersLoading) && (!$elm$core$List$isEmpty(cardReaders))) ? A2(
														$author$project$Ui$Typography$p,
														_List_fromArray(
															[$author$project$Ui$Typography$gray]),
														_List_fromArray(
															[
																$elm$html$Html$text('Save and set this card as the default payment method for future invoices.')
															])) : $author$project$Utils$Html$empty,
														$author$project$Ui$ToggleSwitch$view(
														_List_fromArray(
															[
																$author$project$Ui$ToggleSwitch$on(fields.Ct),
																$author$project$Ui$ToggleSwitch$onChange(
																A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$StoreCard))
															]))
													]))
											]);
									} else {
										return _List_Nil;
									}
								}(),
									_List_fromArray(
									[
										$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewMemoField(fields)
									])
								]))),
						A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, model.V, fields) ? A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentTotalModal, model.s7, model.VJ) : $author$project$Utils$Html$empty
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, model.V, fields) ? A2(
						$author$project$Ui$FlexGrid$row,
						_List_fromArray(
							[$author$project$Ui$FlexGrid$mb4]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$offsetSm(1),
										$author$project$Ui$FlexGrid$span(5)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
										_List_fromArray(
											[
												$elm$html$Html$text('Total')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(5)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Currency$format(
													$author$project$Currency$fromInt(
														$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesTotalAmount(model.VJ))))
											]))
									]))
							])) : $author$project$Utils$Html$empty,
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Process now'},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(3),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.af, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CreatePayment)
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 46),
								$elm$html$Html$text(' Process '),
								$elm$html$Html$text(amountInCentsString),
								$elm$html$Html$text(' Now')
							]))
					]))
			]);
	});
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCreatePaymentModal = function (model) {
	var fields = $author$project$Utils$Form$fields(model.PB);
	var amountInCentsString = A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, model.V, fields) ? $author$project$Currency$format(
		$author$project$Currency$fromInt(
			$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesTotalAmount(model.VJ))) : $author$project$Currency$format(
		A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.I2));
	var modalToDisplay = A3($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPayNowModal, model, fields, amountInCentsString);
	return A3($author$project$Ui$Modal$view, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Close, _List_Nil, modalToDisplay);
};
var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$view = function (_v0) {
	var model = _v0;
	var _v1 = _Utils_Tuple2(model.hF, model.bS);
	if (!_v1.a.$) {
		var _v2 = _v1.a.a;
		var cardReaderConnectingModal = _v2.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg,
			$author$project$Components$CardReader$ConnectingModal$view(cardReaderConnectingModal));
	} else {
		if (!_v1.b.$) {
			var _v3 = _v1.b.a;
			var cardReaderPaymentModal = _v3.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg,
				$author$project$Components$CardReader$PaymentModal$view(cardReaderPaymentModal));
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCreatePaymentModal(model);
		}
	}
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Submit = {$: 0};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Pay = {$: 8};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Void = {$: 9};
var $author$project$Api$Provider$Patient$One$hasPaymentMethod = function (_v0) {
	var record = _v0.b;
	return record.Qc;
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewAfterRefundActions = function (model) {
	var patientHasPaymentMethod = $author$project$Api$Provider$Patient$One$hasPaymentMethod(model.VM);
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Void'},
			_List_fromArray(
				[
					$author$project$Ui$Button$danger,
					$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Void),
					$author$project$Ui$Button$loading(model.ty)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Void')
				])),
			patientHasPaymentMethod ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Process new payment'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Pay),
					$author$project$Ui$Button$loading(model.rI)
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$Icon$view, _List_Nil, 46),
					$elm$html$Html$text(' Process New Payment')
				])) : A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
				{
					VN: $author$project$Api$Provider$Patient$One$id(model.VM)
				}),
			_List_fromArray(
				[$author$project$Ui$Link$buttonSuccess]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Payment Source')
				]))
		]);
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewFooter = F2(
	function (model, notRefunded) {
		return notRefunded ? _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Close)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Process refund'},
				_List_fromArray(
					[
						$author$project$Ui$Button$styled(4),
						$author$project$Ui$Button$loading(
						_Utils_eq(model.er, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$disabled(
						(!model.fQ) && $author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError(model.es)),
						$author$project$Ui$Button$submit,
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Process Refund')
					]))
			]) : $author$project$Components$CustomerInvoice$ProcessRefundModal$viewAfterRefundActions(model);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Memo = $elm$core$Basics$identity;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$MemoValidation = 0;
var $author$project$Ui$Form$Textarea$CustomHeight = function (a) {
	return {$: 11, a: a};
};
var $author$project$Ui$Form$Textarea$customHeight = function (height) {
	return $author$project$Ui$Form$Textarea$CustomHeight(height);
};
var $author$project$Api$Provider$CustomerInvoice$Shared$passthroughFeesInCents = function (_v0) {
	var record = _v0;
	return record.VK;
};
var $author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$passthroughFeesInCents(shared);
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewFullRefundSection = F2(
	function (model, fields) {
		var feesCharged = $author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(model.Rh);
		var feesChargedText = (feesCharged > 0) ? ' (includes fees)' : '';
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(
									A2($elm$core$Maybe$withDefault, '', fields.aeC)),
									$author$project$Ui$Form$Textarea$phi(true),
									$author$project$Ui$Form$Textarea$customHeight('63px'),
									$author$project$Ui$Form$Textarea$placeholder('Memo for revision'),
									$author$project$Ui$Form$Textarea$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$ProcessRefundModal$FormUpdated, $elm$core$Basics$identity))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('This is an internal note and does not appear on the printed invoice.')
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Panel$body,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(6)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Total refund' + (feesChargedText + ' :'))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$div,
															_List_fromArray(
																[
																	$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_fromArray(
																		[$author$project$Ui$Typography$bold]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Utils$Currency$fromInt(
																				$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Rh) + feesCharged))
																		]))
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$FormUpdated = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$CustomerInvoice$RefundsForm$formHasErrors = F2(
	function (model, paymentId) {
		var _v0 = A2($author$project$Components$CustomerInvoice$RefundsForm$findRefundForm, paymentId, model.ao);
		if (!_v0.$) {
			var form = _v0.a;
			return A2($author$project$Utils$Form$validationErrors, 0, form);
		} else {
			return _List_fromArray(
				['']);
		}
	});
var $author$project$Components$CustomerInvoice$RefundsForm$viewRefundablePaymentRow = F2(
	function (model, _v0) {
		var paymentId = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var source = $author$project$Api$Payment$source(fields.VY);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v1 = $author$project$Api$Payment$paidAt(fields.VY);
									if (!_v1.$) {
										var paidAt_ = _v1.a;
										return $elm$html$Html$text(
											A2(model.Hy, 5, paidAt_));
									} else {
										return $elm$html$Html$text(
											A2(
												model.Hy,
												5,
												$author$project$Api$Payment$createdAt(fields.VY)));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Payment$status(fields.VY)),
							$author$project$Api$Payment$external(fields.VY) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
							A2(
							$author$project$Components$PaymentSourceDisplayer$view,
							model.Hy,
							_List_fromArray(
								[
									$author$project$Components$PaymentSourceDisplayer$source(
									A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source)),
									$author$project$Components$PaymentSourceDisplayer$limitedView(true),
									$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
									$author$project$Components$PaymentSourceDisplayer$paymentProcessor(
									$author$project$Api$Payment$paymentProcessor(fields.VY))
								])),
							($author$project$Api$Payment$status(fields.VY) === 'failed') ? $elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$String$humanize,
									$author$project$Api$Payment$errorMessage(fields.VY)))) : $author$project$Utils$Html$empty,
							function () {
							var _v2 = $author$project$Api$Payment$memo(fields.VY);
							if (!_v2.$) {
								var memo = _v2.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(' - ' + memo)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$value(fields.I2),
									$author$project$Ui$Form$CurrencyInput$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$CustomerInvoice$RefundsForm$FormUpdated(paymentId),
										$elm$core$Basics$identity)),
									$author$project$Ui$Form$CurrencyInput$errors(
									A2($author$project$Components$CustomerInvoice$RefundsForm$formHasErrors, model, paymentId))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
								]),
							_List_fromArray(
								[
									_Utils_eq(
									$author$project$Api$Payment$attemptedInCents(fields.VY),
									$author$project$Api$Payment$amountInCents(fields.VY)) ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$strike]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Payment$attemptedInCents(fields.VY)))
										])),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											'from ' + $author$project$Utils$Currency$fromInt(
												$author$project$Api$Payment$amountInCents(fields.VY)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$CustomerInvoice$RefundsForm$view = function (_v0) {
	var model = _v0;
	var refundRows = A2(
		$elm$core$List$map,
		$author$project$Components$CustomerInvoice$RefundsForm$viewRefundablePaymentRow(model),
		model.ao);
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Refunds')
					])),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								if (model.pn > 0) {
									var overPaidAmount = A2(
										$elm$core$Basics$min,
										$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Rh),
										model.pn);
									return A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Overpaid amount (with current adjustment): ')
													])),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$bold]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(overPaidAmount))
													]))
											]));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							])),
						A4(
						$author$project$Ui$Panel$table,
						_List_fromArray(
							[
								$author$project$Ui$Table$zeroState(
								_List_fromArray(
									[
										$elm$html$Html$text('There are no refunds.')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[
										$author$project$Ui$Table$cellSpan(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Date')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[
										$author$project$Ui$Table$cellSpan(4)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Payment Details')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[
										$author$project$Ui$Table$cellSpan(3)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_fromArray(
									[
										$author$project$Ui$Table$cellSpan(2),
										$author$project$Ui$Table$textRight
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Amount')
									]))
							]),
						refundRows,
						_List_Nil),
						A2($author$project$Ui$Panel$footer, _List_Nil, _List_Nil)
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewPartialRefundSection = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg,
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges(model.bj)),
						A2(
						$elm$html$Html$map,
						$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg,
						$author$project$Components$CustomerInvoice$RefundsForm$view(model.es))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(4)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg,
						$author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary(model.bj))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$Other = 2;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundAlertMessage = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				(_Utils_eq(
					model.gv,
					$elm$core$Maybe$Just(1)) || _Utils_eq(
					model.gv,
					$elm$core$Maybe$Just(2))) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('By selecting an external refund method, you acknowledge that you are responsible for refunding the patient outside of this platform.')
									]))
							]))
					]) : _List_fromArray(
					[$author$project$Utils$Html$empty]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundConfirmation = function (model) {
	var refundAmount = function () {
		var _v0 = model.er;
		if (_v0.$ === 3) {
			var refund = _v0.a;
			return $author$project$Api$Provider$Refund$One$amountInCents(refund);
		} else {
			return 0;
		}
	}();
	var name = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Patient$Shared$name,
			$author$project$Api$Provider$CustomerInvoice$One$owner(model.Rh)));
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You have successfully recorded a refund of ')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromInt(refundAmount))
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' to ')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Panel$body,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$FlexGrid$column,
														_List_fromArray(
															[
																$author$project$Ui$FlexGrid$spanMd(6)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Previous due:')
															])),
														A2(
														$author$project$Ui$FlexGrid$column,
														_List_fromArray(
															[
																$author$project$Ui$FlexGrid$spanMd(6)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$div,
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$margin(2),
																		$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Typography$p,
																		_List_fromArray(
																			[$author$project$Ui$Typography$bold]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Utils$Currency$fromInt(
																					$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Rh)))
																			]))
																	]))
															]))
													])),
												$author$project$Ui$HorizontalRule$view(
												_List_fromArray(
													[$author$project$Ui$HorizontalRule$thin])),
												A2(
												$author$project$Ui$FlexGrid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$FlexGrid$column,
														_List_fromArray(
															[
																$author$project$Ui$FlexGrid$spanMd(6)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Current due:')
															])),
														A2(
														$author$project$Ui$FlexGrid$column,
														_List_fromArray(
															[
																$author$project$Ui$FlexGrid$spanMd(6)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$justifyRight]),
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$headingSm(
																		_List_fromArray(
																			[
																				$elm$html$Html$text(
																				$author$project$Utils$Currency$fromInt(refundAmount))
																			]))
																	]))
															]))
													]))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundFailedMessage = function (model) {
	var maybePatient = $author$project$Api$Provider$CustomerInvoice$One$owner(model.Rh);
	var name = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$name, maybePatient));
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('A refund of ')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromInt(
											$author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.Rh)))
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' to ')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' failed to process ')
									]))
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$OriginalSource = 0;
var $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundMethod = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(7)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Refund method')
							])),
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('How do you want to issue a refund?')
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(5),
						$author$project$Ui$FlexGrid$justifyRight
					]),
				function () {
					var _v0 = model.gv;
					if (!_v0.$) {
						var refundType = _v0.a;
						var refundablePayments = A2(
							$elm$core$List$filter,
							function (payment) {
								return !$author$project$Api$Payment$external(payment);
							},
							A2($elm$core$List$filter, $author$project$Api$Payment$isRefundableOnPaymentProcessor, model.V5));
						return _List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										function () {
										if (!$elm$core$List$isEmpty(refundablePayments)) {
											var originalSourceName = function () {
												if ($elm$core$List$length(refundablePayments) > 1) {
													return 'Original Souce';
												} else {
													var firstSource = A2(
														$elm$core$Maybe$withDefault,
														$elm$core$Maybe$Nothing,
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Payment$source,
															$elm$core$List$head(refundablePayments)));
													if (!firstSource.$) {
														var source = firstSource.a;
														var nameSource = A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$Source$Shared$name(source));
														var lastFour = A2(
															$elm$core$Maybe$withDefault,
															'',
															$author$project$Api$Common$Source$Shared$lastFour(source));
														return nameSource + (' *' + lastFour);
													} else {
														return '';
													}
												}
											}();
											return A3(
												$author$project$Ui$Button$view,
												{abp: 'Select original source ' + originalSourceName},
												_List_fromArray(
													[
														$author$project$Ui$Button$active(!refundType),
														$author$project$Ui$Button$onClick(
														$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(0))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(originalSourceName)
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Select check'},
										_List_fromArray(
											[
												$author$project$Ui$Button$active(refundType === 1),
												$author$project$Ui$Button$onClick(
												$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(1))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Check')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Select other'},
										_List_fromArray(
											[
												$author$project$Ui$Button$active(refundType === 2),
												$author$project$Ui$Button$onClick(
												$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(2))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Other')
											]))
									]))
							]);
					} else {
						return _List_fromArray(
							[
								$author$project$Ui$Button$group(
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Change refund method'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$onClick(
												$author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(0))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Change refund method')
											]))
									]))
							]);
					}
				}())
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Payment$Shared$passthroughFees = function (_v0) {
	var record = _v0;
	return record.VJ;
};
var $author$project$Api$Provider$Payment$One$passthroughFees = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$passthroughFees(shared);
};
var $author$project$Api$Provider$Payment$SharedWithRefunds$passthroughFees = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Payment$Shared$passthroughFees(shared);
};
var $author$project$Api$Payment$passthroughFees = function (payment) {
	switch (payment.$) {
		case 1:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$One$passthroughFees(payment_);
		case 0:
			var payment_ = payment.a;
			return $author$project$Api$Provider$Payment$SharedWithRefunds$passthroughFees(payment_);
		default:
			return false;
	}
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$thereIsAtLeastOnePaymentWithPassthroughFees = function (payments) {
	return function (paymentWithPassthroughFees) {
		return !_Utils_eq(paymentWithPassthroughFees, $elm$core$Maybe$Nothing);
	}(
		A2(
			$elm_community$list_extra$List$Extra$find,
			function (payment) {
				return $author$project$Api$Payment$passthroughFees(payment);
			},
			payments));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundType = function (model) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(7)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Refund type')
							])),
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Do you want to issue a full or partial refund?')
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanSm(5),
						$author$project$Ui$FlexGrid$justifyRight
					]),
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Select partial refund'},
								_List_fromArray(
									[
										$author$project$Ui$Button$active(!model.fQ),
										$author$project$Ui$Button$onClick(
										$author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType(false)),
										$author$project$Ui$Button$disabled(
										$author$project$Components$CustomerInvoice$ProcessRefundModal$thereIsAtLeastOnePaymentWithPassthroughFees(model.V5))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Partial refund')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Select full refund'},
								_List_fromArray(
									[
										$author$project$Ui$Button$active(model.fQ),
										$author$project$Ui$Button$onClick(
										$author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType(true))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Full refund')
									]))
							]))
					]))
			]));
};
var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundBody = F3(
	function (model, refundStatus, notRefunded) {
		return notRefunded ? _List_fromArray(
			[
				(refundStatus === 'failed') ? $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundFailedMessage(model) : $author$project$Utils$Html$empty,
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundType(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundMethod(model),
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundAlertMessage(model),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				model.fQ ? A2(
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewFullRefundSection,
				model,
				$author$project$Utils$Form$fields(model.PB)) : $author$project$Components$CustomerInvoice$ProcessRefundModal$viewPartialRefundSection(model)
			]) : _List_fromArray(
			[
				$author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundConfirmation(model)
			]);
	});
var $author$project$Components$CustomerInvoice$ProcessRefundModal$view = function (model) {
	var _v0 = model.lC;
	if (!_v0.$) {
		var createPaymentModal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg,
			$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
	} else {
		var refundStatus = function () {
			var _v1 = model.er;
			switch (_v1.$) {
				case 3:
					var refund_ = _v1.a;
					return $author$project$Api$Provider$Refund$One$status(refund_);
				case 2:
					return 'failed';
				default:
					return '';
			}
		}();
		var notRefunded = ((refundStatus !== 'successful') && (refundStatus !== 'waiting_for_processor')) || _Utils_eq(model.er, $author$project$Api$Data$NotAsked);
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$horizontal,
					$author$project$Ui$Form$onSubmit($author$project$Components$CustomerInvoice$ProcessRefundModal$Submit)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Modal$view,
					$author$project$Components$CustomerInvoice$ProcessRefundModal$Close,
					_List_fromArray(
						[
							$author$project$Ui$Modal$size(3)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Modal$header(
							_List_fromArray(
								[
									$author$project$Ui$Modal$title('Process Refund')
								])),
							$author$project$Ui$Modal$body(
							A3($author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundBody, model, refundStatus, notRefunded)),
							$author$project$Ui$Modal$footer(
							A2($author$project$Components$CustomerInvoice$ProcessRefundModal$viewFooter, model, notRefunded))
						]))
				]));
	}
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewClicked = {$: 1};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked = {$: 7};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsAmountInCents = function (scheduledPaymentsForm) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (scheduledPayment) {
				return scheduledPayment.Yb ? 0 : ((!_Utils_eq(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment),
					$elm$core$Maybe$Nothing)) ? 0 : A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, scheduledPayment.I2)));
			},
			scheduledPaymentsForm));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsPassthroughFeesInCents = function (scheduledPaymentsForm) {
	return $elm$core$List$sum(
		A2(
			$elm$core$List$map,
			function (scheduledPayment) {
				return scheduledPayment.Yb ? 0 : ((!_Utils_eq(
					$author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment),
					$elm$core$Maybe$Nothing)) ? 0 : A2($elm$core$Maybe$withDefault, 0, scheduledPayment.VK));
			},
			scheduledPaymentsForm));
};
var $author$project$Ui$SvgIcon$Stop = 54;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewErrorBox = F3(
	function (fields, scheduledAmountInCents, amountInCentsString) {
		var hasCombinationErrors = $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields);
		var errorHtml = function () {
			var _v0 = _Utils_Tuple2(
				_Utils_cmp(scheduledAmountInCents, fields.mB) > 0,
				hasCombinationErrors);
			if (_v0.a) {
				return _List_fromArray(
					[
						$elm$html$Html$text('The total scheduled payments amount '),
						$elm$html$Html$text(amountInCentsString),
						$elm$html$Html$text(' exceeds the total amount due '),
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(fields.mB)),
						$elm$html$Html$text('. Please adjust one of the payments to a lower amount.')
					]);
			} else {
				if (_v0.b) {
					return _List_fromArray(
						[
							$elm$html$Html$text(' '),
							$elm$html$Html$text('The same source can not be used for more than single scheduled payment per day.'),
							$elm$html$Html$text(' ')
						]);
				} else {
					return _List_Nil;
				}
			}
		}();
		return $elm$core$List$isEmpty(errorHtml) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Alert$view,
					3,
					_List_fromArray(
						[
							$author$project$Ui$Alert$margin(25),
							$author$project$Ui$Alert$icon(54),
							$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$black,
									$author$project$Ui$Typography$fontWeight(1),
									$author$project$Ui$Typography$margin(25)
								]),
							errorHtml)
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$margin(2)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewProcessedPayment = F2(
	function (timeFormatter, scheduledPayment) {
		var humanStatus = function () {
			var _v5 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
			if (!_v5.$) {
				var payment_ = _v5.a;
				return $author$project$Api$Provider$Payment$One$status(payment_);
			} else {
				return $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment);
			}
		}();
		var _v0 = function () {
			var _v1 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment);
			if (!_v1.$) {
				var source = _v1.a;
				return _Utils_Tuple2(
					$elm$html$Html$text('on '),
					A2(
						$author$project$Components$PaymentSourceDisplayer$view,
						timeFormatter,
						_List_fromArray(
							[
								$author$project$Components$PaymentSourceDisplayer$source(
								$elm$core$Maybe$Just(
									$author$project$Api$Source$Source(source))),
								$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
								$author$project$Components$PaymentSourceDisplayer$limitedView(true)
							])));
			} else {
				return _Utils_Tuple2(
					$elm$html$Html$text('No payment info'),
					$author$project$Utils$Html$empty);
			}
		}();
		var paymentInfoText = _v0.a;
		var paymentInfoHtml = _v0.b;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(4),
							$author$project$Ui$FlexGrid$justifyLeft
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(4),
							$author$project$Ui$FlexGrid$justifyCenter
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, humanStatus),
									$elm$html$Html$text(' '),
									paymentInfoText,
									paymentInfoHtml,
									function () {
									var _v2 = $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment);
									if (!_v2.$) {
										var memo = _v2.a;
										return A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' - ' + memo)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							function () {
							var _v3 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
							if (!_v3.$) {
								var payment = _v3.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$createdBy]),
									_List_fromArray(
										[
											$elm$html$Html$text('Created by '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'this platform',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$Payment$Creator$displayName,
													$author$project$Api$Provider$Payment$One$createdBy(payment)))),
											$elm$html$Html$text(' on '),
											$elm$html$Html$text(
											A2(
												timeFormatter,
												0,
												$author$project$Api$Provider$Payment$One$createdAt(payment)))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(4),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					function () {
						var _v4 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
						if (!_v4.$) {
							var payment = _v4.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
										]),
									_List_fromArray(
										[
											_Utils_eq(
											$author$project$Api$Provider$Payment$One$attemptedInCents(payment),
											$author$project$Api$Provider$Payment$One$amountInCents(payment)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$strike]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$Payment$One$attemptedInCents(payment)))
												])),
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$Payment$One$amountInCents(payment)))
												]))
										]))
								]);
						} else {
							return _List_fromArray(
								[$author$project$Utils$Html$empty]);
						}
					}())
				]));
	});
var $author$project$Ui$Table$rowspan = $author$project$Ui$Table$Rowspan;
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsBlur = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsFieldUpdated = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewAmount = F2(
	function (scheduledPayment, form) {
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$CurrencyInput$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$CurrencyInput$value(scheduledPayment.I2),
							$author$project$Ui$Form$CurrencyInput$disabled(
							$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
							$author$project$Ui$Form$CurrencyInput$onInput(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated,
								$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsFieldUpdated(scheduledPayment.x4))),
							$author$project$Ui$Form$CurrencyInput$onBlur(
							$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsBlur(scheduledPayment.x4)),
							$author$project$Ui$Form$CurrencyInput$invalid(
							A2(
								$author$project$Utils$Form$hasValidationErrors,
								$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(scheduledPayment.x4),
								form)),
							$author$project$Ui$Form$CurrencyInput$errors(
							A2(
								$author$project$Utils$Form$validationErrors,
								$author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(scheduledPayment.x4),
								form))
						]))
				]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$DeleteFieldUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewDestroy = function (scheduledPayment) {
	return $author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment) ? $author$project$Utils$Html$empty : A2(
		$author$project$Ui$Typography$div,
		_List_fromArray(
			[
				$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Remove scheduled payment'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$size(0),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated(
							$author$project$Components$Invoice$CreateScheduledPaymentModal$DeleteFieldUpdated(scheduledPayment.x4))),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_Nil)
			]));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$MemoFieldUpdated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewMemo = function (scheduledPayment) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', scheduledPayment.aeC)),
						$author$project$Ui$Form$Input$disabled(
						$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
						$author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
						$author$project$Ui$Form$Input$onInput(
						A2(
							$elm$core$Basics$composeL,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$MemoFieldUpdated(scheduledPayment.x4)))
					]))
			]));
};
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSource = F2(
	function (model, scheduledPayment) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelected(scheduledPayment.x4),
			A3(
				$author$project$Ui$Form$SearchableSelect$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$SearchableSelect$value(scheduledPayment.V3),
						$author$project$Ui$Form$SearchableSelect$placeholder('Select a Source'),
						$author$project$Ui$Form$SearchableSelect$disabled(
						$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
						$author$project$Ui$Form$SearchableSelect$invalid(
						A2(
							$author$project$Utils$Form$hasValidationErrors,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(scheduledPayment.x4),
							model.PB)),
						$author$project$Ui$Form$SearchableSelect$errors(
						A2(
							$author$project$Utils$Form$validationErrors,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(scheduledPayment.x4),
							model.PB))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil),
					$author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources(model)),
				scheduledPayment.r_));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduleOn = F2(
	function (model, scheduledPayment) {
		return A2(
			$elm$html$Html$map,
			A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, scheduledPayment.x4, scheduledPayment.n8),
			A2(
				$author$project$Components$DateInput$view,
				_List_fromArray(
					[
						$author$project$Components$DateInput$value(scheduledPayment.agH),
						$author$project$Components$DateInput$disabled(
						$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
						$author$project$Components$DateInput$invalid(
						A2(
							$author$project$Utils$Form$hasValidationErrors,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(scheduledPayment.x4),
							model.PB)),
						$author$project$Components$DateInput$errors(
						A2(
							$author$project$Utils$Form$validationErrors,
							$author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(scheduledPayment.x4),
							model.PB)),
						$author$project$Components$DateInput$disabledPickerDates(
						function (date) {
							return A2($author$project$Utils$Date$isBefore, date, model.$P);
						})
					]),
				scheduledPayment.n8));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPayment = F2(
	function (scheduledPayment, model) {
		return scheduledPayment.Yb ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduleOn, model, scheduledPayment)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSource, model, scheduledPayment)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewAmount, scheduledPayment, model.PB)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$colspan(5),
								$author$project$Ui$Table$alignCenter,
								$author$project$Ui$Table$rowspan(2)
							]),
						_List_fromArray(
							[
								$author$project$Components$Invoice$CreateScheduledPaymentModal$viewDestroy(scheduledPayment)
							]))
					])),
				A2(
				$author$project$Ui$Table$row,
				_List_fromArray(
					[$author$project$Ui$Table$noBorder]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_fromArray(
							[
								$author$project$Ui$Table$colspan(3)
							]),
						_List_fromArray(
							[
								$author$project$Components$Invoice$CreateScheduledPaymentModal$viewMemo(scheduledPayment)
							]))
					]))
			]);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPaymentsTable = F2(
	function (model, fields) {
		return A4(
			$author$project$Ui$Table$view,
			_List_fromArray(
				[
					$author$project$Ui$Table$loading(model.cW),
					$author$project$Ui$Table$containerClasses(
					_List_fromArray(
						['table-wrapper-overflow-visible']))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Date')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Source')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(4),
							$author$project$Ui$Table$textRight
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Amount')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_fromArray(
						[
							$author$project$Ui$Table$cellSpan(1)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]))
				]),
			A2(
				$elm$core$List$concatMap,
				function (scheduledPayment) {
					var _v0 = _Utils_Tuple2(
						scheduledPayment.nc,
						$author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment));
					if ((!_v0.a.$) && (!_v0.b.$)) {
						var originalscheduledPayment_ = _v0.a.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Table$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$cell,
										_List_fromArray(
											[
												$author$project$Ui$Table$colspan(3)
											]),
										_List_fromArray(
											[
												A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewProcessedPayment, model.Hy, originalscheduledPayment_)
											]))
									]))
							]);
					} else {
						return A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPayment, scheduledPayment, model);
					}
				},
				fields.j),
			_List_Nil);
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewWarningBox = F2(
	function (fields, amountInCentsString) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Alert$view,
					2,
					_List_fromArray(
						[
							$author$project$Ui$Alert$margin(25),
							$author$project$Ui$Alert$icon(59),
							$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$black,
									$author$project$Ui$Typography$fontWeight(1),
									$author$project$Ui$Typography$margin(25)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('The total scheduled payments amount '),
									$elm$html$Html$text(amountInCentsString),
									$elm$html$Html$text(' is less than the total amount due '),
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(fields.mB)),
									$elm$html$Html$text('.')
								]))
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$margin(2)
						]),
					_List_Nil)
				]));
	});
var $author$project$Components$Invoice$CreateScheduledPaymentModal$view = function (_v0) {
	var model = _v0;
	var fields = $author$project$Utils$Form$fields(model.PB);
	var _v1 = $author$project$Utils$Form$fields(model.PB);
	var scheduledPaymentsForm = _v1.j;
	var scheduledAmountInCents = $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsAmountInCents(scheduledPaymentsForm);
	var amountInCentsString = $author$project$Currency$format(
		$author$project$Currency$fromInt(scheduledAmountInCents));
	var disableSaveButton = (!$author$project$Utils$Form$dirty(model.PB)) || ((_Utils_cmp(scheduledAmountInCents, fields.mB) > 0) || $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields));
	var totalPassthroughFees = model.ZQ ? $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsPassthroughFeesInCents(scheduledPaymentsForm) : 0;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Invoice$CreateScheduledPaymentModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Scheduled Payment(s)')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked),
								$author$project$Ui$Form$horizontal
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPaymentsTable, model, fields),
										((!(!scheduledAmountInCents)) && (_Utils_cmp(scheduledAmountInCents, fields.mB) < 0)) ? A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewWarningBox, fields, amountInCentsString) : $author$project$Utils$Html$empty,
										A3($author$project$Components$Invoice$CreateScheduledPaymentModal$viewErrorBox, fields, scheduledAmountInCents, amountInCentsString),
										A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$margin(2)
											]),
										_List_Nil),
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_fromArray(
											[$author$project$Ui$FlexGrid$rowItemsCenter]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(4)
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{abp: 'Add another payment'},
														_List_fromArray(
															[
																$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewClicked)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$span,
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$wrapWord),
																		$author$project$Ui$Typography$preWrap
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Add Another Payment')
																	]))
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(1)
													]),
												_List_fromArray(
													[$author$project$Utils$Html$empty])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(7)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$FlexGrid$row,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$FlexGrid$column,
																_List_fromArray(
																	[
																		$author$project$Ui$FlexGrid$span(12)
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Group$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Group$label('Total'),
																				$author$project$Ui$Form$Group$labelSpan(6),
																				$author$project$Ui$Form$Group$inputSpan(6)
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Form$Static$view,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Typography$span,
																						_List_fromArray(
																							[$author$project$Ui$Typography$bold]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(amountInCentsString)
																							])),
																						$elm$html$Html$text(' of '),
																						A2(
																						$author$project$Ui$Typography$span,
																						_List_fromArray(
																							[$author$project$Ui$Typography$bold]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Utils$Currency$fromInt(fields.mB))
																							])),
																						$elm$html$Html$text(' due')
																					]))
																			]))
																	]))
															])),
														A2(
														$author$project$Ui$FlexGrid$row,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$FlexGrid$column,
																_List_fromArray(
																	[
																		$author$project$Ui$FlexGrid$span(12)
																	]),
																_List_fromArray(
																	[
																		(totalPassthroughFees > 0) ? A2(
																		$author$project$Ui$Form$Group$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$Form$Group$label('Total Credit Card Fees'),
																				$author$project$Ui$Form$Group$labelSpan(6),
																				$author$project$Ui$Form$Group$inputSpan(6)
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Form$Static$view,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Typography$span,
																						_List_fromArray(
																							[$author$project$Ui$Typography$bold]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Utils$Currency$fromInt(totalPassthroughFees))
																							]))
																					]))
																			])) : $author$project$Utils$Html$empty
																	]))
															]))
													]))
											]))
									]))
							])),
						$author$project$Utils$Html$empty,
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Schedule paymnets'},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(3),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked),
								$author$project$Ui$Button$disabled(disableSaveButton)
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 46),
								$elm$html$Html$text(' Schedule Payments ')
							]))
					]))
			]));
};
var $author$project$Components$Patient$Charges$ChargeModal$SaveAndAddAnotherClicked = {$: 2};
var $author$project$Components$Patient$Charges$ChargeModal$SaveClicked = {$: 1};
var $author$project$Api$Provider$Charge$Meta$categoryEditable = function (_v0) {
	var meta = _v0;
	return meta.Ex.Oa;
};
var $author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip = F2(
	function (disabled, contents) {
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_fromArray(
				[
					$author$project$Ui$Tooltip$active(disabled)
				]),
			'To change the item, price, or quantity you must revise the invoice.',
			contents);
	});
var $author$project$Components$Patient$Charges$ChargeModal$viewCategoryFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$categoryEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var categoryResourceFilter = _v0.cJ;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Category'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Category$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$disabled(!canEdit)
									]),
								categoryResourceFilter))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$nameEditable = function (_v0) {
	var meta = _v0;
	return meta.zh.Oa;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewChargeFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$nameEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var chargeItemResourceFilter = _v0.cK;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Item'),
					$author$project$Ui$Form$Group$required(canEdit),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$ChargeItem$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
										$author$project$Components$ResourceFilter$errors(
										A2($author$project$Utils$Form$validationErrors, 1, form)),
										$author$project$Components$ResourceFilter$disabled(!canEdit)
									]),
								chargeItemResourceFilter))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$dateEditable = function (_v0) {
	var meta = _v0;
	return meta.MO.Oa;
};
var $author$project$Api$Provider$Charge$Meta$endDateEditable = function (_v0) {
	var meta = _v0;
	return meta.qs.Oa;
};
var $author$project$Components$Patient$Charges$ChargeModal$isTimeBased = function (uom) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq('time'),
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$unitClass, uom)));
};
var $author$project$Components$Patient$Charges$ChargeModal$viewDatesFormGroup = F2(
	function (form, meta) {
		var canEditDate = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$dateEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var startDate = _v0._E;
		var startDateInput = _v0.kg;
		var endDate = _v0.qs;
		var endDateInput = _v0.qu;
		var quantityUom = _v0.Be;
		var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					timeBased ? 'Dates' : 'Date'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
									!canEditDate,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput),
											A2(
												$author$project$Components$DateInput$view,
												_List_fromArray(
													[
														$author$project$Components$DateInput$value(startDate),
														$author$project$Components$DateInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
														$author$project$Components$DateInput$errors(
														A2($author$project$Utils$Form$validationErrors, 4, form)),
														$author$project$Components$DateInput$disabled(!canEditDate)
													]),
												startDateInput))
										]))
								])),
							function () {
							if (timeBased) {
								var canEditEndDate = A2(
									$elm$core$Maybe$withDefault,
									true,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$endDateEditable, meta));
								return A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
											!canEditEndDate,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput),
													A2(
														$author$project$Components$DateInput$view,
														_List_fromArray(
															[
																$author$project$Components$DateInput$value(endDate),
																$author$project$Components$DateInput$disabled(!canEditEndDate)
															]),
														endDateInput))
												]))
										]));
							} else {
								return $author$project$Ui$FlexGrid$none;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$Description = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$FormUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Charge$Meta$descriptionEditable = function (_v0) {
	var meta = _v0;
	return meta.Nx.Oa;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewDescriptionFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$descriptionEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var description = _v0.Nx;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Description'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							$author$project$Ui$Form$Textarea$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Textarea$value(description),
									$author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
									$author$project$Ui$Form$Textarea$onInput(
									A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$Description)),
									$author$project$Ui$Form$Textarea$disabled(!canEdit)
								]))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$locationEditable = function (_v0) {
	var meta = _v0;
	return meta.aet.Oa;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewLocationFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$locationEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var locationResourceFilter = _v0.rl;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Location'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Location$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$disabled(!canEdit)
									]),
								locationResourceFilter))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$patientEditable = function (_v0) {
	var meta = _v0;
	return meta.VM.Oa;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewPatientFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$patientEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var limitedPatientSelector = _v0.rd;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Patient'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg,
							A2(
								$author$project$Components$LimitedPatientSelector$view,
								_List_fromArray(
									[
										$author$project$Components$LimitedPatientSelector$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Components$LimitedPatientSelector$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]),
								limitedPatientSelector))
						]))
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$viewPriceFormGroup = F2(
	function (model, meta) {
		var _v0 = $author$project$Utils$Form$fields(model.PB);
		var priceInCents = _v0.Ba;
		var quantityUom = _v0.Be;
		var priceUom = _v0.W$;
		var discountOverridden = _v0.NJ;
		var chargeItem = _v0.lp;
		var chargeItemPriceEditable = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.aef;
					}),
				chargeItem));
		var priceEditableByChargeItem = A2(
			$elm$core$Maybe$withDefault,
			chargeItemPriceEditable,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
		var canEdit = priceEditableByChargeItem;
		var discountNotRemoved = function () {
			var _v2 = $author$project$Api$Data$toMaybe(model.afU);
			if (!_v2.$) {
				var preview = _v2.a;
				return (!discountOverridden) && (!(!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview)));
			} else {
				return false;
			}
		}();
		var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Price'),
					$author$project$Ui$Form$Group$required(canEdit),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
									!canEdit,
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$view(
											_Utils_ap(
												function () {
													var _v1 = _Utils_Tuple2(
														timeBased,
														A2(
															$elm$core$Maybe$map,
															$elm$core$String$toLower,
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, priceUom)));
													if (_v1.a && (!_v1.b.$)) {
														var name = _v1.b.a;
														return _List_fromArray(
															[
																$author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
															]);
													} else {
														return _List_Nil;
													}
												}(),
												_List_fromArray(
													[
														$author$project$Ui$Form$CurrencyInput$value(priceInCents),
														$author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
														$author$project$Ui$Form$CurrencyInput$onInput(
														A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$PriceInCents)),
														$author$project$Ui$Form$CurrencyInput$invalid(
														A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
														$author$project$Ui$Form$CurrencyInput$disabled((!canEdit) || discountNotRemoved)
													]))),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 3, model.PB)),
											discountNotRemoved ? A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Remove membership rule'},
													_List_fromArray(
														[
															$author$project$Ui$Button$onClick(
															$author$project$Components$Patient$Charges$ChargeModal$FormUpdated(
																$author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden(true)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Remove membership rule')
														]))
												])) : $author$project$Utils$Html$empty
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[
											$author$project$Ui$Typography$muted,
											$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Amounts can be negative')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Api$Provider$Charge$Meta$practitionerEditable = function (_v0) {
	var meta = _v0;
	return meta.afS.Oa;
};
var $author$project$Components$Patient$Charges$ChargeModal$viewProviderFormGroup = F2(
	function (form, meta) {
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$practitionerEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var practitionerResourceFilter = _v0.jC;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Provider'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
					!canEdit,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Practitioner$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$style(0),
										$author$project$Components$ResourceFilter$disabled(!canEdit)
									]),
								practitionerResourceFilter))
						]))
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$Quantity = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Patient$Charges$ChargeModal$QuantityUom = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Charge$Meta$quantityEditable = function (_v0) {
	var meta = _v0;
	return meta.Bd.Oa;
};
var $author$project$Api$Provider$Charge$Meta$quantityUomEditable = function (_v0) {
	var meta = _v0;
	return meta.Be.Oa;
};
var $author$project$Components$Patient$Charges$ChargeModal$uomOptions = A2(
	$elm$core$List$map,
	function (uom_) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$Uom$Shared$code(uom_)),
			$author$project$Api$Provider$Uom$Shared$name(uom_));
	},
	$author$project$Api$Provider$Uom$list(
		function (d) {
			return _Utils_update(
				d,
				{
					HH: $elm$core$Maybe$Just('time')
				});
		}));
var $author$project$Components$Patient$Charges$ChargeModal$viewQuantityFormGroup = F2(
	function (form, meta) {
		var canEditQuantity = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$quantityEditable, meta));
		var _v0 = $author$project$Utils$Form$fields(form);
		var quantity = _v0.Bd;
		var quantityUom = _v0.Be;
		var chargeItem = _v0.lp;
		var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('QTY'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9),
					$author$project$Ui$Form$Group$required(canEditQuantity)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
									!canEditQuantity,
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$number,
													$author$project$Ui$Form$Input$value(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2($elm$core$Maybe$map, $elm$core$String$fromInt, quantity))),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$Quantity)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
													$author$project$Ui$Form$Input$errors(
													A2($author$project$Utils$Form$validationErrors, 2, form)),
													$author$project$Ui$Form$Input$disabled(!canEditQuantity)
												]))
										]))
								])),
							function () {
							if (timeBased) {
								var canEditQuantityUom = A2(
									$elm$core$Maybe$withDefault,
									true,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$quantityUomEditable, meta));
								return A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip,
											!canEditQuantityUom,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, quantityUom)),
															$author$project$Ui$Form$Select$onChange(
															A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$QuantityUom)),
															$author$project$Ui$Form$Select$disabled(!canEditQuantityUom)
														]),
													$author$project$Components$Patient$Charges$ChargeModal$uomOptions)
												]))
										]));
							} else {
								return $author$project$Ui$FlexGrid$none;
							}
						}()
						])),
					A2(
					$author$project$Components$InventoryWarning$view,
					A2(
						$elm$core$Maybe$map,
						function (item) {
							return {IN: item.IN, Xv: item.Xv, $_: item.$_};
						},
						chargeItem),
					quantity)
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$ToggleAdditionalDetails = {$: 17};
var $author$project$Components$Patient$Charges$ChargeModal$viewShowAdditionalDetails = function (showAdditionalDetails) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(''),
				$author$project$Ui$Form$Group$labelSpan(3),
				$author$project$Ui$Form$Group$inputSpan(9)
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = showAdditionalDetails ? _Utils_Tuple2(
					'Hide additional charge details',
					A2($author$project$Ui$Icon$view, _List_Nil, 28)) : _Utils_Tuple2(
					'See additional charge details',
					A2($author$project$Ui$Icon$view, _List_Nil, 27));
				var label = _v0.a;
				var icon = _v0.b;
				return A3(
					$author$project$Ui$Button$view,
					{abp: label},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$size(0),
							$author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$ToggleAdditionalDetails)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label),
							$author$project$Utils$Html$noBreakSpace,
							icon
						]));
			}()
			]));
};
var $author$project$Components$Patient$Charges$ChargeModal$viewDiscount = F3(
	function (_v0, meta, preview) {
		var form = _v0.PB;
		var canEdit = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
		var _v1 = $author$project$Utils$Form$fields(form);
		var discountOverridden = _v1.NJ;
		var chargeItem = _v1.lp;
		var discountRemoved = discountOverridden && (!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					(!$elm$core$List$isEmpty(
					$author$project$Api$Provider$Charge$Calculate$coveredCharges(preview))) ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Total without membership: '),
							$author$project$Components$Invoice$ChargeDiscount$view(preview)
						])) : $author$project$Utils$Html$empty,
					discountRemoved ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Membership rule was removed')
						])) : $author$project$Utils$Html$empty,
					(canEdit && (discountRemoved && $author$project$Utils$Maybe$toBool(chargeItem))) ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Revert to original'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Patient$Charges$ChargeModal$FormUpdated(
								$author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden(false)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Revert to original')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$viewTotalFormGroup = F2(
	function (model, meta) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Total'),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					function () {
						var _v0 = _Utils_Tuple2(model.vQ, model.afU);
						if (!_v0.a) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_fromArray(
										[$author$project$Ui$Typography$display4]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												A2(
													$elm$core$Maybe$withDefault,
													0,
													A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$subtotalInCents, model.abU))))
										]))
								]);
						} else {
							switch (_v0.b.$) {
								case 3:
									var _v1 = _v0.b;
									var preview = _v1.a;
									var total = $author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview));
									var routingWarning = A2(
										$elm$core$Maybe$withDefault,
										$elm$html$Html$text(''),
										A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, 0, preview));
									var discountInfo = A3($author$project$Components$Patient$Charges$ChargeModal$viewDiscount, model, meta, preview);
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[$author$project$Ui$Typography$display4]),
											_List_fromArray(
												[
													$elm$html$Html$text(total)
												])),
											discountInfo,
											routingWarning
										]);
								case 1:
									var _v2 = _v0.b;
									return _List_fromArray(
										[
											$author$project$Ui$Spinner$view(
											_List_fromArray(
												[$author$project$Ui$Spinner$small]))
										]);
								default:
									return _List_fromArray(
										[
											$elm$html$Html$text('N/A')
										]);
							}
						}
					}())
				]));
	});
var $author$project$Components$Patient$Charges$ChargeModal$viewFormGroups = function (model) {
	var meta = A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$meta, model.abU);
	var form = model.PB;
	var basicFormGroups = _List_fromArray(
		[
			A2($author$project$Components$Patient$Charges$ChargeModal$viewPatientFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewChargeFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewQuantityFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewPriceFormGroup, model, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewTotalFormGroup, model, meta),
			$author$project$Components$Patient$Charges$ChargeModal$viewShowAdditionalDetails(model.gJ)
		]);
	var additionalFormGroups = model.gJ ? _List_fromArray(
		[
			A2($author$project$Components$Patient$Charges$ChargeModal$viewCategoryFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewDescriptionFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewDatesFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewProviderFormGroup, form, meta),
			A2($author$project$Components$Patient$Charges$ChargeModal$viewLocationFormGroup, form, meta)
		]) : _List_Nil;
	return $elm$core$List$concat(
		_List_fromArray(
			[basicFormGroups, additionalFormGroups]));
};
var $author$project$Components$Patient$Charges$ChargeModal$viewBody = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$Patient$Charges$ChargeModal$SaveClicked),
				$author$project$Ui$Form$horizontal
			]),
		$author$project$Components$Patient$Charges$ChargeModal$viewFormGroups(model));
};
var $author$project$Components$Patient$Charges$ChargeModal$view = function (model) {
	var previewLoading = _Utils_eq(model.afU, $author$project$Api$Data$Loading);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Patient$Charges$ChargeModal$CloseClicked,
		_List_fromArray(
			[
				$author$project$Ui$Modal$size(1)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						_Utils_eq(model.abU, $elm$core$Maybe$Nothing) ? 'Add Charge' : 'Edit Charge')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Patient$Charges$ChargeModal$viewBody(model)
					])),
				$author$project$Ui$Modal$footer(
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Cancel and close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$CloseClicked),
										$author$project$Ui$Button$link
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									]))
							]),
							function () {
							var _v0 = model.abU;
							if (!_v0.$) {
								return _List_fromArray(
									[$author$project$Utils$Html$empty]);
							} else {
								return _List_fromArray(
									[
										$author$project$Utils$Html$noBreakSpace,
										A3(
										$author$project$Ui$Button$view,
										{abp: 'save & Add another'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(0),
												$author$project$Ui$Button$loading(model.n7),
												$author$project$Ui$Button$disabled(previewLoading),
												$author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$SaveAndAddAnotherClicked)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Save & Add Another')
											]))
									]);
							}
						}(),
							_List_fromArray(
							[
								$author$project$Utils$Html$noBreakSpace,
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Save'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$SaveClicked),
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$disabled(previewLoading),
										$author$project$Ui$Button$loading(model.n7)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							])
						])))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalOpened = {$: 38};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewAddChargeButton = A3(
	$author$project$Ui$Button$view,
	{abp: 'Add charge'},
	_List_fromArray(
		[
			$author$project$Ui$Button$secondary,
			$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalOpened),
			$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Add Charge')
		]));
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$findChargeDropdown = F2(
	function (charge, dropdowns) {
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$mapFirst(
							$elm$core$Basics$eq(
								$author$project$Api$Provider$Charge$One$id(charge))),
						$elm$core$Tuple$first),
					dropdowns)));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteCharge = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditCharge = function (a) {
	return {$: 39, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$destroyAction = function (_v0) {
	var meta = _v0;
	return meta.tF.NA;
};
var $author$project$Ui$SvgIcon$Dots = 55;
var $author$project$Ui$SvgIcon$dots = $author$project$Ui$SvgIcon$viewIcon(55);
var $author$project$Api$Provider$Charge$One$isLocked = function (_v0) {
	var record = _v0.b;
	return record.RP;
};
var $author$project$Ui$Element$Danger = 4;
var $author$project$Ui$Element$textDanger = $author$project$Ui$Element$Text(4);
var $author$project$Ui$Element$textLeft = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textLeft);
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeActions = F3(
	function (charge, customerInvoiceMeta, maybeDropdown) {
		if ($author$project$Api$Provider$Charge$One$isLocked(charge)) {
			var tooltipText = 'An admin must unlock the charge\'s reporting period before editing this charge';
			return A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(2)
							]),
						tooltipText,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Icon$view,
								_List_fromArray(
									[$author$project$Ui$Icon$textMuted]),
								38)
							]))
					]));
		} else {
			return A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				function () {
					if (maybeDropdown.$ === 1) {
						return _List_Nil;
					} else {
						var dropdown = maybeDropdown.a;
						return $elm$core$List$singleton(
							A4(
								$author$project$Ui$NewDropdown$view,
								_List_fromArray(
									[$author$project$Ui$NewDropdown$buttonSecondary, $author$project$Ui$NewDropdown$buttonSm]),
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$dots(_List_Nil)
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Ui$NewDropdown$item,
										_List_fromArray(
											[
												$author$project$Ui$NewDropdown$onSelect(
												$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditCharge(charge))
											]),
										A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textLeft, $author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$edit(_List_Nil),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												]))),
									$author$project$Api$Provider$CustomerInvoice$Meta$destroyAction(customerInvoiceMeta) ? _List_fromArray(
										[
											A2(
											$author$project$Ui$NewDropdown$item,
											_List_fromArray(
												[
													$author$project$Ui$NewDropdown$onSelect(
													$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteCharge(charge))
												]),
											A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$textDanger, $author$project$Ui$Element$textLeft, $author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
												_List_fromArray(
													[
														$author$project$Ui$SvgIcon$delete(_List_Nil),
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Delete')
															]))
													])))
										]) : _List_Nil),
								dropdown));
					}
				}());
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AmountDetailHovered = function (a) {
	return {$: 36, a: a};
};
var $author$project$Api$Provider$Charge$One$consumedPrepaidCharges = function (_v0) {
	var record = _v0.b;
	return record.LJ;
};
var $author$project$Api$Provider$Charge$Shared$issuedSubtotalInCents = function (_v0) {
	var record = _v0;
	return record.Sm;
};
var $author$project$Api$Provider$Charge$One$issuedSubtotalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$issuedSubtotalInCents(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCoverageDiscount = function (coverageDiscount) {
	var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coverageDiscount);
	return A2(
		$author$project$Components$CoverageRuleDescription$view,
		$author$project$Components$CoverageRuleDescription$Shared(coverageRule),
		false);
};
var $author$project$Api$Provider$PrepaidCharge$packageName = function (_v0) {
	var record = _v0;
	return A2(
		$elm$core$Maybe$map,
		function ($) {
			return $.zh;
		},
		record.abU);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPrepaidCharges = F2(
	function (hasCoverageRules, prepaidCharges) {
		var packageNames = A2($elm$core$List$filterMap, $author$project$Api$Provider$PrepaidCharge$packageName, prepaidCharges);
		if ($elm$core$List$isEmpty(packageNames)) {
			return _List_Nil;
		} else {
			var joinedNames = function () {
				if (!packageNames.b) {
					return '';
				} else {
					if (!packageNames.b.b) {
						var single = packageNames.a;
						return single;
					} else {
						var last = A2(
							$elm$core$Maybe$withDefault,
							'',
							$elm$core$List$head(
								A2(
									$elm$core$List$drop,
									$elm$core$List$length(packageNames) - 1,
									packageNames)));
						var allButLast = A2(
							$elm$core$List$take,
							$elm$core$List$length(packageNames) - 1,
							packageNames);
						return A2($elm$core$String$join, ', ', allButLast) + (' and ' + last);
					}
				}
			}();
			var packageText = hasCoverageRules ? ('and included in ' + joinedNames) : ('Included in ' + (joinedNames + '.'));
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(packageText)
						]))
				]);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeAmount = F2(
	function (charge, maybeCoverageDiscounts) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					function () {
					if (!(!$author$project$Api$Provider$Charge$One$discountInCents(charge))) {
						var coverageDiscountContent = function () {
							if ((!maybeCoverageDiscounts.$) && (maybeCoverageDiscounts.a.$ === 3)) {
								var _v2 = maybeCoverageDiscounts.a;
								var coverageDiscounts = _v2.a;
								return A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCoverageDiscount, coverageDiscounts);
							} else {
								return _List_Nil;
							}
						}();
						var hasCoverageRules = !$elm$core$List$isEmpty(coverageDiscountContent);
						var costBeforeDiscount = $author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge) + $author$project$Api$Provider$Charge$One$discountInCents(charge);
						var consumedPrepaidCharges = $author$project$Api$Provider$Charge$One$consumedPrepaidCharges(charge);
						var prepaidContent = A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPrepaidCharges, hasCoverageRules, consumedPrepaidCharges);
						var popoverContent = _Utils_ap(coverageDiscountContent, prepaidContent);
						return A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if ((!$elm$core$List$isEmpty(popoverContent)) || _Utils_eq(maybeCoverageDiscounts, $elm$core$Maybe$Nothing)) {
										var popoverOptions = function () {
											if (!maybeCoverageDiscounts.$) {
												return _List_Nil;
											} else {
												return $elm$core$List$isEmpty(consumedPrepaidCharges) ? _List_fromArray(
													[
														$author$project$Ui$Popover$onHover(
														$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AmountDetailHovered(
															$author$project$Api$Provider$Charge$One$id(charge)))
													]) : _List_Nil;
											}
										}();
										return A3(
											$author$project$Ui$Popover$view,
											popoverOptions,
											_List_fromArray(
												[
													A2($author$project$Ui$Icon$view, _List_Nil, 5)
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$Popover$body, _List_Nil, popoverContent)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(costBeforeDiscount))
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					(!_Utils_eq(
					$author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge),
					$author$project$Api$Provider$Charge$One$subtotalInCents(charge))) ? A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge)))
						])) : $author$project$Utils$Html$empty,
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text(
					$author$project$Utils$Currency$fromInt(
						$author$project$Api$Provider$Charge$One$subtotalInCents(charge))),
					$author$project$Api$Provider$Charge$One$taxable(charge) ? A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' + tax')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail = F2(
	function (label, value) {
		return $elm$core$String$isEmpty(value) ? $elm$html$Html$text('') : A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textMuted]),
			_List_fromArray(
				[
					$elm$html$Html$text(label + ':  '),
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Api$Provider$PrepaidCharge$chargeItem = function (_v0) {
	var record = _v0;
	return record.lp;
};
var $author$project$Api$Provider$PrepaidCharge$originalQuantity = function (_v0) {
	var record = _v0;
	return record.Vi;
};
var $author$project$Api$Provider$Charge$One$prepaidCharges = function (_v0) {
	var record = _v0.b;
	return record.WW;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePackageItems = function (charge) {
	var toItemText = function (prepaidCharge) {
		var quantity = $author$project$Api$Provider$PrepaidCharge$originalQuantity(prepaidCharge);
		var chargeItem = $author$project$Api$Provider$PrepaidCharge$chargeItem(prepaidCharge);
		var name = $author$project$Api$Provider$ChargeItem$Min$name(chargeItem);
		return $elm$core$String$fromInt(quantity) + (' ' + name);
	};
	var itemsText = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$map,
			toItemText,
			$author$project$Api$Provider$Charge$One$prepaidCharges(charge)));
	return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Includes', itemsText);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetails = function (charge) {
	var date = A2(
		$author$project$Formatters$Date$toString,
		$author$project$Formatters$Date$Full,
		$author$project$Api$Provider$Charge$One$date(charge));
	var detailsRow = A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$wrap, $author$project$Ui$Element$spaceX2]),
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Api$Provider$Charge$One$endDate(charge);
				if (!_v0.$) {
					var endDate = _v0.a;
					return A2(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
						'Dates',
						date + (' - ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate)));
				} else {
					return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Date', date);
				}
			}(),
				A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
				'Description',
				$author$project$Api$Provider$Charge$One$description(charge)),
				A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
				'Practitioner',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Practitioner$Shared$name,
						$author$project$Api$Provider$Charge$One$practitioner(charge)))),
				A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
				'Patient',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name,
						$author$project$Api$Provider$Charge$One$patient(charge)))),
				A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail,
				'Location',
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Location$Min$name,
						$author$project$Api$Provider$Charge$One$location(charge)))),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textSm]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$InventoryWarning$view,
						A2(
							$elm$core$Maybe$map,
							function (chargeItem) {
								return {
									IN: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem),
									Xv: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem),
									$_: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem)
								};
							},
							$author$project$Api$Provider$Charge$One$chargeItem(charge)),
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$Charge$One$quantity(charge)))
					]))
			]));
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$spaceY2]),
		_List_fromArray(
			[
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePackageItems(charge),
				detailsRow
			]));
};
var $author$project$Formatters$ChargeItem$ifPresent = function (string) {
	return $elm$core$String$isEmpty(string) ? '' : A2($elm$core$String$append, ' - ', string);
};
var $author$project$Formatters$ChargeItem$toTitle = function (chargeItem) {
	var codeTypeAndCode = $author$project$Formatters$ChargeItemCode$toString(
		$author$project$Formatters$ChargeItemCode$CodeTypeAndCode(
			_Utils_Tuple2(
				$author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem),
				$author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem))));
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem),
				$author$project$Formatters$ChargeItem$ifPresent(codeTypeAndCode),
				$author$project$Formatters$ChargeItem$ifPresent(
				$author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeName = function (charge) {
	var name = function () {
		var _v1 = $author$project$Api$Provider$Charge$One$chargeItem(charge);
		if (!_v1.$) {
			var chargeItem = _v1.a;
			return $author$project$Formatters$ChargeItem$toTitle(chargeItem);
		} else {
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Charge$One$name(charge));
		}
	}();
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$bold]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				function () {
				var _v0 = A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Provider$Charge$One$category,
					$elm$core$Maybe$map($author$project$Api$Provider$Category$Shared$name))(charge);
				if (!_v0.$) {
					var categoryName = _v0.a;
					return A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(' - ' + categoryName)
							]));
				} else {
					return $elm$html$Html$text('');
				}
			}()
			]));
};
var $author$project$Api$Provider$Charge$Shared$issuedPriceInCents = function (_v0) {
	var record = _v0;
	return record.Sj;
};
var $author$project$Api$Provider$Charge$One$issuedPriceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$issuedPriceInCents(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePrice = function (charge) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(
					$author$project$Api$Provider$Charge$One$issuedPriceInCents(charge),
					$author$project$Api$Provider$Charge$One$priceInCents(charge));
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var issuedPrice = _v0.a.a;
					var price = _v0.b.a;
					return (!_Utils_eq(issuedPrice, price)) ? A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(issuedPrice))
							])) : $author$project$Utils$Html$empty;
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Utils$Html$noBreakSpace,
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v1 = $author$project$Api$Provider$Charge$One$priceInCents(charge);
						if (!_v1.$) {
							var price = _v1.a;
							return $elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(price));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])),
				($author$project$Api$Provider$Charge$One$type_(charge) === 'coverage') ? A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$concat(
							_List_fromArray(
								[
									' per ',
									$elm$core$String$toLower(
									$author$project$Api$Provider$Uom$Shared$name(
										$author$project$Api$Provider$Charge$One$priceUom(charge)))
								])))
					])) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Api$Provider$Charge$Shared$issuedQuantity = function (_v0) {
	var record = _v0;
	return record.Sk;
};
var $author$project$Api$Provider$Charge$One$issuedQuantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$issuedQuantity(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeQuantity = function (charge) {
	var showQuantityWithUnit = F2(
		function (quantity, uom) {
			return $author$project$Api$Provider$Uom$Shared$isTimeBased(uom) ? A2(
				$author$project$Formatters$String$pluralize,
				$author$project$Api$Provider$Uom$Shared$name(uom),
				quantity) : $elm$core$String$fromInt(quantity);
		});
	var diffInQuantityUom = !_Utils_eq(
		$author$project$Api$Provider$Uom$Shared$code(
			$author$project$Api$Provider$Charge$One$issuedQuantityUom(charge)),
		$author$project$Api$Provider$Uom$Shared$code(
			$author$project$Api$Provider$Charge$One$quantityUom(charge)));
	var diffInQuantity = !_Utils_eq(
		$author$project$Api$Provider$Charge$One$issuedQuantity(charge),
		$author$project$Api$Provider$Charge$One$quantity(charge));
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				(diffInQuantity || diffInQuantityUom) ? A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$strike]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							showQuantityWithUnit,
							$author$project$Api$Provider$Charge$One$issuedQuantity(charge),
							$author$project$Api$Provider$Charge$One$issuedQuantityUom(charge)))
					])) : $author$project$Utils$Html$empty,
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text(
				A2(
					showQuantityWithUnit,
					$author$project$Api$Provider$Charge$One$quantity(charge),
					$author$project$Api$Provider$Charge$One$quantityUom(charge)))
			]));
};
var $author$project$Components$ChargeRoutingWarning$One = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ChargeRoutingWarning$viewWithChargeOne = F2(
	function (selectedPayer, charge) {
		return A2(
			$author$project$Components$ChargeRoutingWarning$view,
			selectedPayer,
			$author$project$Components$ChargeRoutingWarning$One(charge));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCharge = F4(
	function (charge, customerInvoiceMeta, coverageDiscounts, dropdown) {
		var warning = A2($author$project$Components$ChargeRoutingWarning$viewWithChargeOne, 0, charge);
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$Table$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeName(charge)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePrice(charge)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeQuantity(charge)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeAmount, charge, coverageDiscounts)
							])),
						A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeActions, charge, customerInvoiceMeta, dropdown)
					])),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Table$row,
					_List_fromArray(
						[$author$project$Ui$Table$noBorder]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(3)
								]),
							_List_fromArray(
								[
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetails(charge)
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(3)
								]),
							_List_fromArray(
								[
									$author$project$Api$Provider$Charge$One$discountOverridden(charge) ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$small,
											$author$project$Ui$Typography$muted,
											$author$project$Ui$Typography$pull(1)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Membership rule was removed')
										])) : $author$project$Utils$Html$empty
								])),
							A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
						])),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (warning_) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$row,
									_List_fromArray(
										[$author$project$Ui$Table$noBorder]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$cell,
											_List_fromArray(
												[
													$author$project$Ui$Table$colspan(12)
												]),
											_List_fromArray(
												[warning_]))
										]))
								]);
						},
						warning))));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargesTable = function (model) {
	var _v0 = function () {
		var _v1 = model.Rh;
		if (_v1.$ === 3) {
			var invoice = _v1.a;
			var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
			return _Utils_Tuple2(
				false,
				A2(
					$elm$core$List$concatMap,
					function (charge) {
						return A4(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCharge,
							charge,
							meta,
							A2(
								$elm$core$Dict$get,
								$author$project$Api$Provider$Charge$One$id(charge),
								model.wS),
							A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$findChargeDropdown, charge, model.hJ));
					},
					A2(
						$elm$core$List$filter,
						$author$project$Api$Provider$Charge$One$isPersisted,
						A2(
							$author$project$Api$Expandable$withDefault,
							_List_Nil,
							$author$project$Api$Provider$CustomerInvoice$One$charges(invoice)))));
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var charges = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('There are no charges.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(6)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Item')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Price')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(1)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Qty')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(2),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(1)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('')
					]))
			]),
		charges,
		_List_Nil);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmOpened = {$: 14};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDeleteButton = F2(
	function (model, invoice) {
		return $author$project$Api$Provider$CustomerInvoice$Meta$destroyAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Delete invoice'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Rh, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmOpened)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Delete')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceClicked = function (a) {
	return {$: 34, a: a};
};
var $author$project$Api$Provider$Patient$Shared$phones = function (_v0) {
	var shared = _v0;
	return shared.Wi;
};
var $author$project$Ui$Element$Test = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Element$test = $author$project$Ui$Element$Test;
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled = function (invoice) {
	var invoiceStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
	var hasLockedCharges = A2(
		$elm$core$List$any,
		function (charge) {
			return $author$project$Api$Provider$Charge$One$isLocked(charge);
		},
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Api$Expandable$toMaybe(
				$author$project$Api$Provider$CustomerInvoice$One$charges(invoice))));
	return (hasLockedCharges && (invoiceStatus !== 'draft')) || A2(
		$elm$core$List$member,
		invoiceStatus,
		_List_fromArray(
			['bad_debt', 'cancelled']));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecord = F2(
	function (timeFormatter, record) {
		var unsyncedReason = function () {
			var _v2 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
			if (!_v2.$) {
				var reason = _v2.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(reason)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var lastSyncedAt = function () {
			var _v1 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
			if (!_v1.$) {
				var time = _v1.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'on ' + A2(timeFormatter, 0, time))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$name(
			$author$project$Api$Provider$IntegrationRecord$All$integration(record));
		var errorMessage = function () {
			var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
			if (!_v0.$) {
				var message = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var additionalInfo = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-control-static'),
					$elm$html$Html$Attributes$class('text-muted'),
					$elm$html$Html$Attributes$class('text-body-sm')
				]),
			_List_fromArray(
				[unsyncedReason, errorMessage, lastSyncedAt]));
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(7)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$flexAuto, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$HinterOnly$icon(_List_Nil)
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
									_List_fromArray(
										[
											$elm$html$Html$text(integrationName)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(5)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsStart]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$IntegrationRecord$Status$toString(
										$author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record)))
								])),
							additionalInfo
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecords = F2(
	function (formatter, response) {
		if (response.$ === 3) {
			var integrationRecords = response.a;
			return A2(
				$elm$core$List$map,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecord(formatter),
				integrationRecords);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Formatters$Phone$phoneParts = function (phone) {
	var countryAt = $elm$core$String$length(phone) - 10;
	var rest = A2($elm$core$String$dropLeft, countryAt, phone);
	var country = A3($elm$core$String$slice, 0, countryAt, phone);
	return _Utils_Tuple2(country, rest);
};
var $author$project$Formatters$Phone$formatWithCountry = function (phoneNumber) {
	var parsedNumber = A2(
		$elm$core$String$filter,
		function (_char) {
			return _char !== '+';
		},
		$elm$core$String$trim(phoneNumber));
	var length = $elm$core$String$length(parsedNumber);
	if (A2($elm$core$String$contains, '-', parsedNumber) || ((length < 10) || (length > 13))) {
		return phoneNumber;
	} else {
		var phoneWithCountry = (length === 10) ? ('1' + parsedNumber) : parsedNumber;
		var _v0 = $author$project$Formatters$Phone$phoneParts(phoneWithCountry);
		var country = _v0.a;
		var rest = _v0.b;
		return country + (' ' + $author$project$Formatters$Phone$format(rest));
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPhone = function (phone) {
	var formattedPhone = function (number) {
		return $author$project$Formatters$Phone$formatWithCountry(number) + (' (' + ($author$project$Formatters$PhoneType$toString(
			$author$project$Api$Common$Phone$Shared$type_(phone)) + ')'));
	};
	var _v0 = $author$project$Api$Common$Phone$Shared$number(phone);
	if (!_v0.$) {
		var number = _v0.a;
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[
					$author$project$Ui$Typography$phi(true),
					$author$project$Ui$Typography$margin(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					formattedPhone(number))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetails = F5(
	function (timeFormatter, isHintAdmin, integrationRecords, practice, invoice) {
		var editButtonDisabled = $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled(invoice);
		var editButton = A3(
			$author$project$Ui$Button$view,
			{abp: 'Edit details'},
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceClicked(invoice)),
					$author$project$Ui$Button$disabled(editButtonDisabled),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Edit Details')
				]));
		var _v0 = function () {
			var _v1 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
			if (!_v1.$) {
				var patient = _v1.a;
				return _Utils_Tuple2(
					$author$project$Api$Provider$Patient$Shared$name(patient),
					A2(
						$author$project$Api$Expandable$withDefault,
						_List_Nil,
						$author$project$Api$Provider$Patient$Shared$phones(patient)));
			} else {
				return _Utils_Tuple2('', _List_Nil);
			}
		}();
		var ownerName = _v0.a;
		var ownerPhones = _v0.b;
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[
					$author$project$Ui$Element$test('invoice-details'),
					$author$project$Ui$Element$mb4
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(2),
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
									_List_fromArray(
										[
											$elm$html$Html$text('Payer')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(4),
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[
											$author$project$Ui$Typography$bold,
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(ownerName)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPhone, ownerPhones))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(4)
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$spanMd(7),
													$author$project$Ui$FlexGrid$span(6)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
													_List_fromArray(
														[
															$elm$html$Html$text('Invoice Date')
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(5)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																$author$project$Formatters$Date$Full,
																$author$project$Api$Provider$CustomerInvoice$One$date(invoice)))
														]))
												]))
										])),
								A2(
									$elm$core$List$cons,
									A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanMd(7),
														$author$project$Ui$FlexGrid$span(6)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
														_List_fromArray(
															[
																$elm$html$Html$text('Location')
															]))
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(5)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2(
																	$elm$core$Maybe$withDefault,
																	'',
																	A2(
																		$elm$core$Maybe$map,
																		$author$project$Api$Provider$Location$Min$name,
																		$author$project$Api$Provider$CustomerInvoice$One$location(invoice))))
															]))
													]))
											])),
									A2(
										$elm$core$List$cons,
										((!$elm$core$List$isEmpty(
											$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments(invoice))) || $author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice)) ? $author$project$Utils$Html$empty : A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(7),
															$author$project$Ui$FlexGrid$span(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$p0, $author$project$Ui$Typography$textLeft]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Default Payment Source')
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(5)
														]),
													_List_fromArray(
														[
															function () {
															var _v2 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
															if (!_v2.$) {
																var source = _v2.a;
																return A2(
																	$author$project$Components$PaymentSourceDisplayer$view,
																	timeFormatter,
																	_List_fromArray(
																		[
																			$author$project$Components$PaymentSourceDisplayer$source(
																			$elm$core$Maybe$Just(
																				$author$project$Api$Source$Source(source))),
																			$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
																			$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																		]));
															} else {
																var _v3 = $author$project$Api$Provider$CustomerInvoice$One$source(invoice);
																if (!_v3.$) {
																	var source = _v3.a;
																	return A2(
																		$author$project$Components$PaymentSourceDisplayer$view,
																		timeFormatter,
																		_List_fromArray(
																			[
																				$author$project$Components$PaymentSourceDisplayer$source(
																				$elm$core$Maybe$Just(
																					$author$project$Api$Source$Source(source))),
																				$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
																				$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																			]));
																} else {
																	return A2(
																		$author$project$Ui$Element$view,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2($author$project$Ui$Badge$fromString, _List_Nil, 'none')
																			]));
																}
															}
														}()
														]))
												])),
										isHintAdmin ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecords, timeFormatter, integrationRecords) : _List_Nil)))),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(2),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[editButton]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetailsSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_fromArray(
		[$author$project$Ui$Element$mb4]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2),
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Payer')
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(4),
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(4)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(4)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(7),
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$text(
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$spanFromText('Invoice Date')
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(4)
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(7),
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$text(
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$spanFromText('Location')
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$span(5)
												]))
										]))
								]))
						]))
				]))
		]));
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$SaveInvoice = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewLocationInput = F2(
	function (locationResourceFilter, disable) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$inputSpanSm(8),
					$author$project$Ui$Form$Group$label('Location')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Location$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(disable)
							]),
						locationResourceFilter))
				]));
	});
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewPatientInput = function (patientResourceFilter) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(4),
				$author$project$Ui$Form$Group$inputSpanSm(8),
				$author$project$Ui$Form$Group$label('Payer')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg,
				A2($author$project$Components$ResourceFilter$Patient$view, _List_Nil, patientResourceFilter))
			]));
};
var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$view = function (model) {
	var _v0 = model._;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var invoiceId = _v1.a;
		var form = _v1.b;
		var invoice = _v1.c;
		var _v2 = $author$project$Utils$Form$fields(form);
		var invoiceDate = _v2.Rn;
		var dateInput = _v2.qd;
		var _v3 = _Utils_Tuple2(model.rU, model.rl);
		if ((!_v3.a.$) && (!_v3.b.$)) {
			var patientResourceFilter = _v3.a.a;
			var locationResourceFilter = _v3.b.a;
			var modalConfig = {
				Qn: $elm$core$Maybe$Nothing,
				aej: 'Customer Invoice',
				S_: model.S_,
				Tv: $elm$core$Maybe$Just(invoiceId),
				Tw: $elm$core$Maybe$Nothing,
				U_: $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit,
				U0: $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$SaveInvoice(form)
			};
			var disabled = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) !== 'draft';
			return A2(
				$author$project$Components$Admin$CreateEditModal$modal,
				modalConfig,
				_List_fromArray(
					[
						$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewPatientInput(patientResourceFilter),
						A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewLocationInput, locationResourceFilter, disabled),
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Invoice Date'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg(dateInput),
								A2(
									$author$project$Components$DateInput$view,
									_List_fromArray(
										[
											$author$project$Components$DateInput$value(invoiceDate),
											$author$project$Components$DateInput$disabled(disabled)
										]),
									dateInput))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditInvoiceModal = function (maybeModal) {
	if (!maybeModal.$) {
		var modal = maybeModal.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg,
			$author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsSentClicked = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsUnsentClicked = function (a) {
	return {$: 25, a: a};
};
var $author$project$Components$CustomerEmailModal$PatientShared = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$StopRetryingClicked = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$CustomerEmailModal$OpenModal = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Components$CustomerEmailModal$defaultOptions = {dW: false, ag_: 0};
var $author$project$Components$CustomerEmailModal$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var bool = option.a;
					return _Utils_update(
						record,
						{dW: bool});
				} else {
					var size_ = option.a;
					return _Utils_update(
						record,
						{ag_: size_});
				}
			}),
		$author$project$Components$CustomerEmailModal$defaultOptions,
		options);
};
var $author$project$Components$CustomerEmailModal$button = F5(
	function (session, options, type_, contextId, recipient) {
		var optionsRecord = $author$project$Components$CustomerEmailModal$optionsToRecord(options);
		return A3(
			$author$project$Ui$Tooltip$view,
			_List_Nil,
			'Send Invoice via Email',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Send invoice via email'},
					_List_fromArray(
						[
							$author$project$Ui$Button$size(optionsRecord.ag_),
							$author$project$Ui$Button$onClick(
							A4($author$project$Components$CustomerEmailModal$OpenModal, session, type_, contextId, recipient)),
							$author$project$Ui$Button$disabled(optionsRecord.dW),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Email')
						]))
				]));
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$issuedTotalInCents = function (_v0) {
	var record = _v0;
	return record.Sn;
};
var $author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$issuedTotalInCents(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$lastSentAt = function (_v0) {
	var record = _v0.b;
	return record.SD;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$markAsSentAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Tj;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$markAsUnsentAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Tk;
};
var $author$project$Api$Provider$CustomerInvoice$Shared$securePdfInlineToken = function (_v0) {
	var record = _v0;
	return record.Ze;
};
var $author$project$Api$Provider$CustomerInvoice$One$securePdfInlineToken = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$securePdfInlineToken(shared);
};
var $author$project$Components$CustomerEmailModal$Size = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CustomerEmailModal$size = $author$project$Components$CustomerEmailModal$Size;
var $author$project$Api$Provider$CustomerInvoice$Meta$stopRetryingAction = function (_v0) {
	var meta = _v0;
	return meta.tF._P;
};
var $author$project$Ui$Badge$Test = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Badge$test = $author$project$Ui$Badge$Test;
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ConvertToCreditClicked = function (a) {
	return {$: 31, a: a};
};
var $author$project$Api$FeatureGate$PatientCredits = 4;
var $author$project$Ui$Margin$X_0_5 = 24;
var $author$project$Api$Provider$CustomerInvoice$Meta$transferToCreditAction = function (_v0) {
	var meta = _v0;
	return meta.tF.$4;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewConvertToCreditButton = F2(
	function (model, invoice) {
		return (A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			4,
			$author$project$Api$Practice$Provider(model.WF)) && $author$project$Api$Provider$CustomerInvoice$Meta$transferToCreditAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice))) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Convert amount to credit'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$margin(24),
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Rh, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ConvertToCreditClicked(invoice))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Convert to Credit')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmOpened = {$: 16};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReturnToDraftClicked = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseBadDebtClicked = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked = function (a) {
	return {$: 53, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentClicked = function (a) {
	return {$: 41, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Void = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$cancel = function (_v0) {
	var meta = _v0;
	return meta.tF.KF;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment = function (_v0) {
	var meta = _v0;
	return meta.tF.Mb;
};
var $author$project$Ui$NewDropdown$Item$HiddenLg = {$: 11};
var $author$project$Ui$NewDropdown$hiddenLg = $author$project$Ui$NewDropdown$Item$HiddenLg;
var $author$project$Api$Provider$CustomerInvoice$Meta$markAsBadDebtAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Th;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction = function (_v0) {
	var meta = _v0;
	return meta.tF.XW;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$returnToDraftAction = function (_v0) {
	var meta = _v0;
	return meta.tF.YE;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$reverseBadDebtAction = function (_v0) {
	var meta = _v0;
	return meta.tF.YI;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Y5;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$schedulePaymentAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Y6;
};
var $author$project$Ui$SvgIcon$stop = $author$project$Ui$SvgIcon$viewIcon(54);
var $author$project$Api$Provider$CustomerInvoice$Meta$updateAction = function (_v0) {
	var meta = _v0;
	return meta.tF.aaq;
};
var $author$project$Ui$SvgIcon$Void = 52;
var $author$project$Ui$SvgIcon$void = $author$project$Ui$SvgIcon$viewIcon(52);
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewOtherDropdown = F2(
	function (model, invoice) {
		var ifAllowed = F2(
			function (condition, dropdownItem) {
				return condition(
					$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? $elm$core$Maybe$Just(dropdownItem) : $elm$core$Maybe$Nothing;
			});
		var schedulePaymentsOption = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			12,
			$author$project$Api$Practice$Provider(model.WF)) ? A2(
			ifAllowed,
			$author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked(invoice))
					]),
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$calendar(_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Schedule Payments')
								]))
						])))) : A2(
			ifAllowed,
			$author$project$Api$Provider$CustomerInvoice$Meta$schedulePaymentAction,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentClicked(invoice))
					]),
				A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$calendar(_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Schedule Payment')
								]))
						]))));
		var canRevise = function (meta) {
			return $author$project$Api$Provider$CustomerInvoice$Meta$updateAction(meta) && ($author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment(meta) && A3($author$project$Permission$canGoTo, model.ZD, model.Cd.adN, 48));
		};
		return function (options) {
			return $elm$core$List$isEmpty(options) ? $author$project$Utils$Html$empty : A4(
				$author$project$Ui$NewDropdown$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Other ')
							]))
					]),
				options,
				model.nd);
		}(
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment(invoice)),
									$author$project$Ui$NewDropdown$hiddenLg
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$check(_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Record Payment')
											]))
									])))),
						A2(
						ifAllowed,
						canRevise,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise(invoice)),
									$author$project$Ui$NewDropdown$hiddenLg
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$edit(_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Revise')
											]))
									])))),
						schedulePaymentsOption,
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$markAsBadDebtAction,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmOpened)
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$stop(_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Bad Debt')
											]))
									])))),
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$returnToDraftAction,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReturnToDraftClicked(invoice))
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$arrowLeft(
										_List_fromArray(
											[$author$project$Ui$SvgIcon$xs])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Return To Draft')
											]))
									])))),
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$reverseBadDebtAction,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseBadDebtClicked(invoice))
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$arrowLeft(_List_Nil),
										$elm$html$Html$text('Return To Issued')
									])))),
						A2(
						ifAllowed,
						$author$project$Api$Provider$CustomerInvoice$Meta$cancel,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Void(invoice))
								]),
							A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$flex, $author$project$Ui$Element$gap2, $author$project$Ui$Element$textDanger, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$void(_List_Nil),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Void')
											]))
									]))))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Pay = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PayWithPassthroughFees = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$createPaymentAction = function (_v0) {
	var meta = _v0;
	return meta.tF.V$;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessPayment = F2(
	function (model, invoice) {
		var usesCardReaders = $author$project$Api$Provider$Practice$One$usesCardReaders(model.WF);
		var hasPaymentMethod = $author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$CustomerInvoice$One$source(invoice));
		var canCreatePaymentAction = $author$project$Api$Provider$CustomerInvoice$Meta$createPaymentAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice));
		return (canCreatePaymentAction && ((hasPaymentMethod || usesCardReaders) && $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.VM))) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Process payment'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Rh, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PayWithPassthroughFees(invoice)),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$dollarSign)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Process Payment')
				])) : ((canCreatePaymentAction && (hasPaymentMethod || usesCardReaders)) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Process payment'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Rh, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Pay(invoice)),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$dollarSign)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Process Payment')
				])) : ((canCreatePaymentAction && ((!hasPaymentMethod) && (!usesCardReaders))) ? A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
				{VN: model.VN}),
			_List_fromArray(
				[$author$project$Ui$Link$buttonSuccess]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Payment Source')
				])) : $author$project$Utils$Html$empty));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefund = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton = F2(
	function (permitted, button) {
		return permitted ? button : A3(
			$author$project$Ui$Popover$view,
			_List_Nil,
			_List_fromArray(
				[button]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Popover$body,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Please contact your practice administrator to be granted permission.')
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessRefund = F2(
	function (model, invoice) {
		if ($author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice) > 0) {
			var canIssueRefunds = A3($author$project$Permission$canGoTo, model.ZD, model.Cd.adN, 49);
			var buttonStyle = ($author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'paid') ? 4 : 5;
			return A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton,
				canIssueRefunds,
				A3(
					$author$project$Ui$Button$view,
					{abp: 'Process refund'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(buttonStyle),
							$author$project$Ui$Button$loading(
							_Utils_eq(model.Rh, $author$project$Api$Data$Loading)),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefund(invoice)),
							$author$project$Ui$Button$disabled(!canIssueRefunds),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Process Refund')
						])));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Ui$Button$Display = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Ui$Button$displayLg = A2($author$project$Ui$Button$Display, true, 3);
var $author$project$Ui$Button$hidden = A2($author$project$Ui$Button$Display, false, 0);
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRecordPayment = F2(
	function (model, invoice) {
		return $author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Record payment'},
			_List_fromArray(
				[
					$author$project$Ui$Button$secondary,
					$author$project$Ui$Button$loading(
					_Utils_eq(model.Rh, $author$project$Api$Data$Loading)),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment(invoice)),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check),
					$author$project$Ui$Button$hidden,
					$author$project$Ui$Button$displayLg
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Record Payment')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRevise = F2(
	function (model, invoice) {
		var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
		if ($author$project$Api$Provider$CustomerInvoice$Meta$updateAction(meta) && $author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment(meta)) {
			var canRevise = A3($author$project$Permission$canGoTo, model.ZD, model.Cd.adN, 48);
			return A2(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton,
				canRevise,
				A3(
					$author$project$Ui$Button$view,
					{abp: 'Revise invoice'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(4),
							$author$project$Ui$Button$loading(
							_Utils_eq(model.Rh, $author$project$Api$Data$Loading)),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise(invoice)),
							$author$project$Ui$Button$disabled(!canRevise),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
							$author$project$Ui$Button$hidden,
							$author$project$Ui$Button$displayLg
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Revise')
						])));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeader = F3(
	function (model, meta, invoice) {
		var statusLabel = function () {
			var _v1 = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
			if (_v1 === 'sent') {
				return A3(
					$author$project$Ui$Tooltip$view,
					_List_Nil,
					'on ' + A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							model.Hy(0),
							$author$project$Api$Provider$CustomerInvoice$One$lastSentAt(invoice))),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_fromArray(
								[
									$author$project$Ui$Badge$test('invoice-status')
								]),
							$author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice))
						]));
			} else {
				return A2(
					$author$project$Ui$Badge$fromString,
					_List_fromArray(
						[
							$author$project$Ui$Badge$test('invoice-status')
						]),
					$author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice));
			}
		}();
		var markAsSentButton = $author$project$Api$Provider$CustomerInvoice$Meta$markAsSentAction(meta) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Mark as sent'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsSentClicked(invoice))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Mark as Sent')
				])) : ($author$project$Api$Provider$CustomerInvoice$Meta$markAsUnsentAction(meta) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Mark as not sent'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsUnsentClicked(invoice))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Mark as Not Sent')
				])) : ($author$project$Api$Provider$CustomerInvoice$Meta$stopRetryingAction(meta) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Stop retrying'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$StopRetryingClicked(invoice))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Stop Retrying')
				])) : $author$project$Utils$Html$empty));
		var emailButton = A2(
			$elm$core$Maybe$map,
			function (owner) {
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg,
					A5(
						$author$project$Components$CustomerEmailModal$button,
						model.ZD,
						_List_fromArray(
							[
								$author$project$Components$CustomerEmailModal$size(0)
							]),
						0,
						$author$project$Api$Provider$CustomerInvoice$One$id(invoice),
						$author$project$Components$CustomerEmailModal$PatientShared(owner)));
			},
			$author$project$Api$Provider$CustomerInvoice$One$owner(invoice));
		var downloadPdfButton = A2(
			$elm$core$Maybe$map,
			function (securePdfInlineToken) {
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg,
					A4(
						$author$project$Components$Invoice$DownloadFile$view,
						model.iq,
						securePdfInlineToken,
						_List_fromArray(
							[
								$author$project$Components$Invoice$DownloadFile$label('Export to PDF'),
								$author$project$Components$Invoice$DownloadFile$tooltip(true)
							]),
						_List_fromArray(
							[$author$project$Ui$Button$sm])));
			},
			$author$project$Api$Provider$CustomerInvoice$One$securePdfInlineToken(invoice));
		var buttons = _List_fromArray(
			[
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewOtherDropdown, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessRefund, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRevise, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRecordPayment, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessPayment, model, invoice),
				A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewConvertToCreditButton, model, invoice)
			]);
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(4),
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
									_List_fromArray(
										[
											$author$project$Ui$Panel$title(
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Invoice #' + $elm$core$String$fromInt(
														$author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice))),
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$small]),
													_List_fromArray(
														[
															$elm$html$Html$text(' for ')
														])),
													(!_Utils_eq(
													$author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents(invoice),
													$author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice))) ? A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents(invoice))),
															$author$project$Utils$Html$noBreakSpace
														])) : $author$project$Utils$Html$empty,
													A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(' '),
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice)))
														])),
													(!(!$author$project$Api$Provider$CustomerInvoice$One$revisionNumber(invoice))) ? A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															' (rev. ' + ($elm$core$String$fromInt(
																$author$project$Api$Provider$CustomerInvoice$One$revisionNumber(invoice)) + ')'))
														])) : $author$project$Utils$Html$empty,
													$author$project$Utils$Html$noBreakSpace,
													statusLabel
												]))
										])),
									function () {
									var _v0 = model.hy;
									if (!_v0.$) {
										var auditTrailLog = _v0.a;
										return A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											$elm$core$List$singleton(
												A2(
													$elm$html$Html$map,
													$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg,
													$author$project$Components$AuditTrailLog$view(auditTrailLog))));
									} else {
										return A2($author$project$Ui$Element$view, _List_Nil, _List_Nil);
									}
								}(),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt2, $author$project$Ui$Element$gap2]),
									A2(
										$elm$core$List$filterMap,
										$elm$core$Basics$identity,
										_List_fromArray(
											[
												emailButton,
												downloadPdfButton,
												$elm$core$Maybe$Just(markAsSentButton)
											])))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanLg(8),
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$wrap, $author$project$Ui$Element$gap2]),
									buttons)
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeaderSkeleton = A2(
	$author$project$Ui$Element$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(4),
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$spanFromText('Invoice #100 for $50.00')
										]))
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$span(3)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$mt2, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										])),
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(8),
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$wrap, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$input(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										])),
									$author$project$Ui$Skeleton$input(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										]))
								]))
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHiConfirmModals = F2(
	function (model, invoice_) {
		if (model.h6) {
			var due = $author$project$Utils$Currency$fromInt(
				$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice_));
			var deleteInvoiceModalText = 'You\'re about to delete Invoice #' + ($elm$core$String$fromInt(
				$author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice_)) + (' for ' + (due + '. This action cannot be undone.')));
			return A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('delete'),
						$author$project$Components$HiConfirm$noun('invoice'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								$elm$html$Html$text(deleteInvoiceModalText)
							]))
					]));
		} else {
			if (model.hA) {
				var modalHeaderText = 'invoice #' + ($elm$core$String$fromInt(
					$author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice_)) + ' as bad debt');
				var modalBodyText = '\n                Marking an invoice as bad debt will remove it from your outstanding invoices report,\n                but your revenue is unaffected, and it remains on the patient\'s balance\n                ';
				return A2(
					$author$project$Components$HiConfirm$modal,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed,
					_List_fromArray(
						[
							$author$project$Components$HiConfirm$verb('mark'),
							$author$project$Components$HiConfirm$noun(modalHeaderText),
							$author$project$Components$HiConfirm$customMessage(
							_List_fromArray(
								[
									$elm$html$Html$text(modalBodyText)
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Api$Provider$CustomerInvoice$One$adjustments = function (_v0) {
	var record = _v0.b;
	return record.IC;
};
var $author$project$Formatters$Time$Time__Only = 3;
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt = function (_v0) {
	var record = _v0.b;
	return record.Mf;
};
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$position = function (_v0) {
	var record = _v0.b;
	return record.Wz;
};
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$reason = function (_v0) {
	var record = _v0.b;
	return record.XP;
};
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents(shared);
};
var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$user = function (_v0) {
	var record = _v0.b;
	return record.aaz;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevision = F2(
	function (timeFormatter, adjustment) {
		var totalAdjustment = $author$project$Utils$Currency$fromInt(
			$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents(adjustment));
		var revisionDescription = $elm$html$Html$text(
			$elm$core$String$concat(
				_List_fromArray(
					[
						'Revision #',
						$elm$core$String$fromInt(
						$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$position(adjustment)),
						' by ',
						A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$User$Shared$name,
							$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$user(adjustment))),
						' at ',
						A2(
						timeFormatter,
						3,
						$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt(adjustment))
					])));
		var revisionAmount = ($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents(adjustment) < 0) ? A2(
			$author$project$Ui$Typography$strong,
			_List_fromArray(
				[
					$author$project$Ui$Typography$danger,
					$author$project$Ui$Typography$pull(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(totalAdjustment)
				])) : A2(
			$author$project$Ui$Typography$strong,
			_List_fromArray(
				[
					$author$project$Ui$Typography$pull(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(totalAdjustment)
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('revision__item')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										timeFormatter,
										5,
										$author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt(adjustment)))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(7)
								]),
							_List_fromArray(
								[
									revisionDescription,
									function () {
									var _v0 = $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$reason(adjustment);
									if (!_v0.$) {
										var reason = _v0.a;
										return A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock, $author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$elm$html$Html$text(reason)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[revisionAmount])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Api$Provider$CustomerInvoice$One$voidReason = function (_v0) {
	var record = _v0.b;
	return record.ahR;
};
var $author$project$Api$Provider$CustomerInvoice$One$voidedAt = function (_v0) {
	var record = _v0.b;
	return record.aaT;
};
var $author$project$Api$Provider$CustomerInvoice$One$voidedByName = function (_v0) {
	var record = _v0.b;
	return record.aaU;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewVoidRevision = F2(
	function (timeFormatter, invoice) {
		var voidDescription = function () {
			var _v1 = _Utils_Tuple2(
				$author$project$Api$Provider$CustomerInvoice$One$voidedByName(invoice),
				$author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var name = _v1.a.a;
				var time = _v1.b.a;
				return A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$concat(
								_List_fromArray(
									[
										name,
										' at ',
										A2(timeFormatter, 3, time)
									])))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('revision__item--voided')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											timeFormatter(5),
											$author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice))))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(7)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Voided by '),
									voidDescription,
									function () {
									var _v0 = $author$project$Api$Provider$CustomerInvoice$One$voidReason(invoice);
									if (!_v0.$) {
										var reason = _v0.a;
										return A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$helpBlock, $author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$elm$html$Html$text(reason)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevisions = function (model) {
	var _v0 = model.Rh;
	if (_v0.$ === 3) {
		var invoice = _v0.a;
		var isVoided = ($author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'cancelled') && $author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice));
		var adjustments = A2(
			$author$project$Api$Expandable$withDefault,
			_List_Nil,
			$author$project$Api$Provider$CustomerInvoice$One$adjustments(invoice));
		var adjustmentsCount = isVoided ? ($elm$core$List$length(adjustments) + 1) : $elm$core$List$length(adjustments);
		return (adjustmentsCount > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('invoice-revisions mt-4')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$title,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice Revisions')
								])),
							A2(
							$author$project$Ui$Badge$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(adjustmentsCount))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevision(model.Hy),
						adjustments)),
					isVoided ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewVoidRevision, model.Hy, invoice) : $author$project$Utils$Html$empty
				])) : $author$project$Utils$Html$empty;
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Issue = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIssueButton = F2(
	function (model, invoice) {
		if ($author$project$Api$Provider$CustomerInvoice$Meta$issueAction(
			$author$project$Api$Provider$CustomerInvoice$One$meta(invoice))) {
			var due = $author$project$Utils$Currency$fromInt(
				$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice));
			var buttonText = 'Issue ' + (due + ' Invoice');
			return A3(
				$author$project$Ui$Button$view,
				{abp: buttonText},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(model.mK),
						$author$project$Ui$Button$onClick(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Issue(invoice))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(buttonText)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultSourceFromList = function (model) {
	var allSources = function () {
		var _v0 = _Utils_Tuple2(model.pN, model.pD);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var _v1 = _v0.a;
			var cards = _v1.a;
			var _v2 = _v0.b;
			var bankAccounts = _v2.a;
			return $elm$core$List$reverse(
				A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Api$Source$createdAt,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map($elm$time$Time$posixToMillis),
							$elm$core$Maybe$withDefault(0))),
					_Utils_ap(
						A2($elm$core$List$map, $author$project$Api$Source$Card, cards),
						A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
		} else {
			return _List_Nil;
		}
	}();
	var defaultSource = $elm$core$List$head(
		A2($elm$core$List$filter, $author$project$Api$Source$default, allSources));
	return (!_Utils_eq(defaultSource, $elm$core$Maybe$Nothing)) ? defaultSource : $elm$core$List$head(allSources);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$UnschedulePaymentClicked = function (a) {
	return {$: 33, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Shared$paymentScheduledOn = function (_v0) {
	var record = _v0;
	return record.V2;
};
var $author$project$Api$Provider$CustomerInvoice$One$paymentScheduledOn = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$paymentScheduledOn(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPayment = F2(
	function (timeFormatter, invoice) {
		if ($author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice)) {
			var paymentScheduledOn = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
					$author$project$Api$Provider$CustomerInvoice$One$paymentScheduledOn(invoice)));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('payment__scheduled')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(paymentScheduledOn)
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(7)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource(invoice) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'scheduled') : A2($author$project$Ui$Badge$fromString, _List_Nil, 'scheduled_without_source')
											])),
										$elm$html$Html$text(' '),
										function () {
										var _v0 = $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice);
										if (!_v0.$) {
											var source = _v0.a;
											return A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('on '),
														A2(
														$author$project$Components$PaymentSourceDisplayer$view,
														timeFormatter,
														_List_fromArray(
															[
																$author$project$Components$PaymentSourceDisplayer$source(
																$elm$core$Maybe$Just(
																	$author$project$Api$Source$Source(source))),
																$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
																$author$project$Components$PaymentSourceDisplayer$limitedView(true)
															]))
													]));
										} else {
											var _v1 = $author$project$Api$Provider$CustomerInvoice$One$source(invoice);
											if (!_v1.$) {
												var source = _v1.a;
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('on '),
															A2(
															$author$project$Components$PaymentSourceDisplayer$view,
															timeFormatter,
															_List_fromArray(
																[
																	$author$project$Components$PaymentSourceDisplayer$source(
																	$elm$core$Maybe$Just(
																		$author$project$Api$Source$Source(source))),
																	$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
																	$author$project$Components$PaymentSourceDisplayer$limitedView(true)
																]))
														]));
											} else {
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('No payment info')
														]));
											}
										}
									}()
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2),
										$author$project$Ui$FlexGrid$justifyRight
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(
													$author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice)))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(1)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Unschedule payment'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$UnschedulePaymentClicked(invoice))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Unschedule')
											]))
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow = F4(
	function (patient, timeFormatter, scheduledPayment, defaultSource) {
		var totalInCents = $author$project$Utils$Currency$fromInt(
			$author$project$Api$Provider$ScheduledPayment$Shared$amountInCents(scheduledPayment) + ($author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(patient) ? A2(
				$elm$core$Maybe$withDefault,
				0,
				$author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents(scheduledPayment)) : 0));
		var humanStatus = function () {
			var _v4 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
			if (!_v4.$) {
				var payment_ = _v4.a;
				return $author$project$Api$Provider$Payment$One$status(payment_);
			} else {
				return $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment);
			}
		}();
		var _v0 = function () {
			var _v1 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment);
			if (!_v1.$) {
				var source = _v1.a;
				return _Utils_Tuple2(
					$elm$html$Html$text('on '),
					A2(
						$author$project$Components$PaymentSourceDisplayer$view,
						timeFormatter,
						_List_fromArray(
							[
								$author$project$Components$PaymentSourceDisplayer$source(
								$elm$core$Maybe$Just(
									$author$project$Api$Source$Source(source))),
								$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
								$author$project$Components$PaymentSourceDisplayer$limitedView(true)
							])));
			} else {
				return (!_Utils_eq(defaultSource, $elm$core$Maybe$Nothing)) ? _Utils_Tuple2(
					$elm$html$Html$text('on '),
					A2(
						$author$project$Components$PaymentSourceDisplayer$view,
						timeFormatter,
						_List_fromArray(
							[
								$author$project$Components$PaymentSourceDisplayer$source(defaultSource),
								$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
								$author$project$Components$PaymentSourceDisplayer$limitedView(true)
							]))) : _Utils_Tuple2(
					$elm$html$Html$text('No payment info'),
					$author$project$Utils$Html$empty);
			}
		}();
		var paymentInfoText = _v0.a;
		var paymentInfoHtml = _v0.b;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(7)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, humanStatus),
									$elm$html$Html$text(' '),
									paymentInfoText,
									paymentInfoHtml,
									function () {
									var _v2 = $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment);
									if (!_v2.$) {
										var memo = _v2.a;
										return A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' - ' + memo)
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							function () {
							var _v3 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
							if (!_v3.$) {
								var payment = _v3.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$createdBy]),
									_List_fromArray(
										[
											$elm$html$Html$text('Created by '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'this platform',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$Payment$Creator$displayName,
													$author$project$Api$Provider$Payment$One$createdBy(payment)))),
											$elm$html$Html$text(' on '),
											$elm$html$Html$text(
											A2(
												timeFormatter,
												0,
												$author$project$Api$Provider$Payment$One$createdAt(payment)))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(2),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(totalInCents)
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentList = F5(
	function (patient, timeFormatter, scheduledPayments, payments, defaultSource) {
		var existingPaymentIds = A2(
			$elm$core$List$map,
			function (p) {
				return $author$project$Api$Payment$id(p);
			},
			payments);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payment__scheduled')
				]),
			A2(
				$elm$core$List$map,
				function (scheduledPayment) {
					var _v0 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
					if (!_v0.$) {
						var scheduledPaymentPayment_ = _v0.a;
						return A2(
							$elm$core$List$member,
							$author$project$Api$Provider$Payment$One$id(scheduledPaymentPayment_),
							existingPaymentIds) ? $author$project$Utils$Html$empty : A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow, patient, timeFormatter, scheduledPayment, defaultSource);
					} else {
						return A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow, patient, timeFormatter, scheduledPayment, defaultSource);
					}
				},
				scheduledPayments));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPaymentsList = F2(
	function (model, invoice) {
		var showScheduledPayments = A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			12,
			$author$project$Api$Practice$Provider(model.WF)) && (!$elm$core$List$isEmpty(model.jZ));
		var payments = A2(
			$elm$core$List$map,
			$author$project$Api$Payment$Provider_One,
			A2(
				$author$project$Api$Expandable$withDefault,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$One$payments(invoice)));
		return ((!$elm$core$List$isEmpty(payments)) || ($author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice) || showScheduledPayments)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('payments-history mb-4'),
					$author$project$Utils$Html$Attributes$test('payments-history')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(8)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$title,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Payments')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(4),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									(showScheduledPayments && ($author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction(
									$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) && (!$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled(invoice)))) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Edit scheduled payments'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked(invoice))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit Scheduled Payments')
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(1)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('')
								]))
						])),
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg,
					A3(
						$author$project$Components$PaymentsList$view,
						_List_fromArray(
							[
								$author$project$Components$PaymentsList$showCreatedBy(true),
								$author$project$Components$PaymentsList$showRefundMemo(true),
								$author$project$Components$PaymentsList$allowDisputes(true),
								$author$project$Components$PaymentsList$isHintAdmin(model.FR)
							]),
						payments,
						model.jr)),
					showScheduledPayments ? A5(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentList,
					model.VM,
					model.Hy,
					model.jZ,
					payments,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultSourceFromList(model)) : A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPayment, model.Hy, invoice)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$CustomerInvoice$Shared$estimatedDueInCents = function (_v0) {
	var record = _v0;
	return record.OQ;
};
var $author$project$Api$Provider$CustomerInvoice$One$estimatedDueInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$estimatedDueInCents(shared);
};
var $author$project$Ui$Typography$m0 = $author$project$Ui$Typography$Margin(25);
var $author$project$Api$Provider$CustomerInvoice$Shared$subtotalInCents = function (_v0) {
	var record = _v0;
	return record._7;
};
var $author$project$Api$Provider$CustomerInvoice$One$subtotalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$subtotalInCents(shared);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ApplyCreditsClicked = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RemoveCreditsClicked = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseCreditTransferClicked = function (a) {
	return {$: 32, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Meta$applyCreditsAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Jk;
};
var $author$project$Api$Provider$CustomerInvoice$Shared$creditInCents = function (_v0) {
	var record = _v0;
	return record.Ml;
};
var $author$project$Api$Provider$CustomerInvoice$One$creditInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$creditInCents(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents = function (_v0) {
	var record = _v0.b;
	return record.Mm;
};
var $author$project$Ui$Typography$Display5 = {$: 27};
var $author$project$Ui$Typography$display5 = $author$project$Ui$Typography$Display5;
var $author$project$Api$Provider$CustomerInvoice$Meta$removeCreditsAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Ya;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$reverseCreditTransferAction = function (_v0) {
	var meta = _v0;
	return meta.tF.YJ;
};
var $author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents = function (_v0) {
	var record = _v0.b;
	return record.$6;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail = F3(
	function (invoice, customerInvoiceMeta, hasPassthoughFees) {
		if ((!(!$author$project$Api$Provider$CustomerInvoice$One$creditInCents(invoice))) || (!(!$author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents(invoice)))) {
			var creditTotal = $author$project$Api$Provider$CustomerInvoice$One$creditInCents(invoice) + $author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents(invoice);
			return A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$offsetMd(7),
								$author$project$Ui$FlexGrid$spanMd(4),
								$author$project$Ui$FlexGrid$span(11)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$label,
										_List_fromArray(
											[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
										_List_fromArray(
											[
												$elm$html$Html$text('Credit')
											])),
										hasPassthoughFees ? A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(-creditTotal))
											])) : A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$display5]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(-creditTotal))
											]))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(1)
							]),
						_List_fromArray(
							[
								$author$project$Api$Provider$CustomerInvoice$Meta$removeCreditsAction(customerInvoiceMeta) ? A3(
								$author$project$Ui$Button$view,
								{abp: 'Remove credit'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RemoveCreditsClicked(invoice))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Remove')
									])) : $author$project$Utils$Html$empty
							]))
					]));
		} else {
			if ($author$project$Api$Provider$CustomerInvoice$Meta$applyCreditsAction(customerInvoiceMeta)) {
				return A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetMd(7),
									$author$project$Ui$FlexGrid$spanMd(4),
									$author$project$Ui$FlexGrid$span(11)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_fromArray(
												[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Credit')
												])),
											hasPassthoughFees ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(0))
												])) : A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$display5]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(0))
												]))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(1)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Apply credits'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$sm,
											$author$project$Ui$Button$onClick(
											$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ApplyCreditsClicked(invoice))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Apply')
										]))
								]))
						]));
			} else {
				if ($author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents(invoice) > 0) {
					return A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$offsetMd(7),
										$author$project$Ui$FlexGrid$spanMd(4),
										$author$project$Ui$FlexGrid$span(11)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$label,
												_List_fromArray(
													[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
												_List_fromArray(
													[
														$elm$html$Html$text('Transferred to Credit')
													])),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$display5]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Utils$Currency$fromInt(
															$author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents(invoice)))
													]))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(1)
									]),
								_List_fromArray(
									[
										$author$project$Api$Provider$CustomerInvoice$Meta$reverseCreditTransferAction(customerInvoiceMeta) ? A3(
										$author$project$Ui$Button$view,
										{abp: 'Undo credit transfer'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$sm,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseCreditTransferClicked(invoice))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Undo')
											])) : $author$project$Utils$Html$empty
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSourceIsACreditCard = F4(
	function (practice, invoice, cards, scheduledPayments) {
		if ($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard(scheduledPayments)) {
			return false;
		} else {
			var _v0 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
			if (!_v0.$) {
				var source = _v0.a;
				return _Utils_eq(
					$author$project$Api$Common$Source$Shared$type_(source),
					$elm$core$Maybe$Just('Card'));
			} else {
				return !_Utils_eq(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard(cards),
					$elm$core$Maybe$Nothing);
			}
		}
	});
var $author$project$Ui$HorizontalRule$Minimal = 2;
var $author$project$Ui$HorizontalRule$minimal = $author$project$Ui$HorizontalRule$Style(2);
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesInCents = function (passthroughFees) {
	if (passthroughFees.$ === 3) {
		var passthrough = passthroughFees.a;
		return $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents(passthrough);
	} else {
		return 0;
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesTotalAmount = function (passthroughFees) {
	if (passthroughFees.$ === 3) {
		var passthrough = passthroughFees.a;
		return $author$project$Api$Provider$PassthroughFee$One$totalInCents(passthrough);
	} else {
		return 0;
	}
};
var $author$project$Api$Provider$TaxProfile$Shared$forDisplay = function (taxProfile) {
	return $elm$core$String$concat(
		_List_fromArray(
			[
				$author$project$Api$Provider$TaxProfile$Shared$name(taxProfile),
				$author$project$Utils$String$noBreakSpace,
				'Tax',
				$author$project$Utils$String$noBreakSpace,
				$elm$core$String$fromFloat(
				$author$project$Api$Provider$TaxProfile$Shared$rate(taxProfile)),
				'%'
			]));
};
var $author$project$Api$Provider$CustomerInvoice$Shared$taxInCents = function (_v0) {
	var record = _v0;
	return record.$r;
};
var $author$project$Api$Provider$CustomerInvoice$One$taxInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CustomerInvoice$Shared$taxInCents(shared);
};
var $author$project$Api$Provider$CustomerInvoice$One$taxProfile = function (_v0) {
	var record = _v0.b;
	return record.$t;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileEditable = function (_v0) {
	var meta = _v0;
	return meta.$t.Oa;
};
var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileViewable = function (_v0) {
	var meta = _v0;
	return meta.$t.aaQ;
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel = F3(
	function (invoice, hasPassthoughFees, label) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$offsetMd(7),
							$author$project$Ui$FlexGrid$spanMd(4),
							$author$project$Ui$FlexGrid$span(11)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									label,
									hasPassthoughFees ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice)))
										])) : A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$display5]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice)))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileChanged = function (a) {
	return {$: 44, a: a};
};
var $author$project$Api$Provider$TaxProfile$One$forDisplay = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$TaxProfile$Shared$forDisplay(shared);
};
var $author$project$Api$Provider$TaxProfile$All$forDisplay = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$TaxProfile$One$forDisplay(one);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxProfileOption = function (taxProfile) {
	return A2(
		$author$project$Ui$NewDropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$onSelect(
				$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileChanged(taxProfile))
			]),
		A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[$author$project$Ui$Typography$hintLabel]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$TaxProfile$All$forDisplay(taxProfile))
				])));
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail = F5(
	function (invoice, customerInvoiceMeta, taxProfiles, taxProfileDropdown, hasPassthoughFees) {
		var taxProfileIsViewable = $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileViewable(customerInvoiceMeta) || (!(!$author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice)));
		var taxProfileIsEditable = $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileEditable(customerInvoiceMeta);
		var maybeTaxProfile = $author$project$Api$Provider$CustomerInvoice$One$taxProfile(invoice);
		var _v0 = _Utils_Tuple3(taxProfileIsViewable, taxProfileIsEditable, maybeTaxProfile);
		_v0$2:
		while (true) {
			if (_v0.a) {
				if (_v0.b) {
					var currentTaxProfileLabel = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$TaxProfile$Shared$forDisplay,
							$author$project$Api$Provider$CustomerInvoice$One$taxProfile(invoice)));
					return A3(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel,
						invoice,
						hasPassthoughFees,
						A4(
							$author$project$Ui$NewDropdown$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel]),
									_List_fromArray(
										[
											$elm$html$Html$text(currentTaxProfileLabel)
										]))
								]),
							A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxProfileOption, taxProfiles),
							taxProfileDropdown));
				} else {
					if (!_v0.c.$) {
						var taxProfile = _v0.c.a;
						return A3(
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel,
							invoice,
							hasPassthoughFees,
							A2(
								$author$project$Ui$Typography$label,
								_List_fromArray(
									[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$TaxProfile$Shared$forDisplay(taxProfile))
									])));
					} else {
						break _v0$2;
					}
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail = F2(
	function (label, content) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$offsetMd(7),
							$author$project$Ui$FlexGrid$spanMd(4),
							$author$project$Ui$FlexGrid$span(11)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[content]))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold = F2(
	function (label, content) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$offsetMd(7),
							$author$project$Ui$FlexGrid$spanMd(4),
							$author$project$Ui$FlexGrid$span(11)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
									_List_fromArray(
										[
											$elm$html$Html$text(label)
										])),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$display5]),
									_List_fromArray(
										[content]))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewNewInvoiceTotalsSummary = F5(
	function (model, invoice, meta, taxProfiles, dueTotal) {
		var totalToHtml = function (value) {
			return $elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(value));
		};
		var invoiceHumanStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
		var showCreditCardFeesForDueAmount = $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.VM) && (A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSourceIsACreditCard, model.WF, invoice, model.pN, model.jZ) && A2(
			$elm$core$List$member,
			invoiceHumanStatus,
			_List_fromArray(
				['issued', 'sent', 'retrying'])));
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail,
					'Subtotal',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$subtotalInCents(invoice))),
					A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail, invoice, meta, taxProfiles, model.kr, true),
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Invoice Total',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice))),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetMd(7),
									$author$project$Ui$FlexGrid$spanMd(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$minimal]))
								]))
						])),
					A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail, invoice, meta, true),
					(invoiceHumanStatus !== 'draft') ? A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail,
					'Paid',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice) * (-1))) : $author$project$Utils$Html$empty,
					(!(!$author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(invoice))) ? A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail,
					'Credit Card Fees Paid',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(invoice) * (-1))) : $author$project$Utils$Html$empty,
					(invoiceHumanStatus !== 'draft') ? A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetMd(7),
									$author$project$Ui$FlexGrid$spanMd(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$minimal]))
								]))
						])) : $author$project$Utils$Html$empty,
					showCreditCardFeesForDueAmount ? A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail,
					'Total Credit Card Fees',
					totalToHtml(
						$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesInCents(model.VJ))) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetMd(7),
									$author$project$Ui$FlexGrid$spanMd(4),
									$author$project$Ui$FlexGrid$span(11)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_fromArray(
												[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Due')
												])),
											showCreditCardFeesForDueAmount ? A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('display-3')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesTotalAmount(model.VJ)))
												])) : A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('display-3')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(dueTotal))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotals = function (model) {
	var _v0 = _Utils_Tuple2(model.Rh, model.g_);
	if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
		var _v1 = _v0.a;
		var invoice = _v1.a;
		var _v2 = _v0.b;
		var taxProfiles = _v2.a;
		var totalToHtml = function (value) {
			return $elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(value));
		};
		var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
		var invoiceHumanStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
		var dueTotal = (invoiceHumanStatus === 'draft') ? $author$project$Api$Provider$CustomerInvoice$One$estimatedDueInCents(invoice) : $author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice);
		return $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.VM) ? A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewNewInvoiceTotalsSummary, model, invoice, meta, taxProfiles, dueTotal) : A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Subtotal',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$subtotalInCents(invoice))),
					A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail, invoice, meta, taxProfiles, model.kr, false),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetMd(7),
									$author$project$Ui$FlexGrid$spanMd(4),
									$author$project$Ui$FlexGrid$span(11)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_fromArray(
												[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Total')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('display-3')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice)))
												]))
										]))
								]))
						])),
					A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail, invoice, meta, false),
					(invoiceHumanStatus !== 'draft') ? A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Paid',
					totalToHtml(
						$author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice))) : $author$project$Utils$Html$empty,
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetMd(7),
									$author$project$Ui$FlexGrid$spanMd(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$thin]))
								]))
						])),
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Due',
					totalToHtml(dueTotal))
				]));
	} else {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mt4]),
			_List_fromArray(
				[
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Subtotal',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('$100.00')
							]))),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetMd(7),
									$author$project$Ui$FlexGrid$spanMd(4),
									$author$project$Ui$FlexGrid$span(11)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$label,
											_List_fromArray(
												[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$m0, $author$project$Ui$Typography$p0]),
											_List_fromArray(
												[
													$elm$html$Html$text('Total')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('display-3')
												]),
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$text(
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$spanFromText('$100.00')
														]))
												]))
										]))
								]))
						])),
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Paid',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('$100.00')
							]))),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offsetMd(7),
									$author$project$Ui$FlexGrid$spanMd(4)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$thin]))
								]))
						])),
					A2(
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold,
					'Due',
					$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('$100.00')
							])))
				]));
	}
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg,
			$author$project$Components$CustomerSchedulePaymentModal$view(model.gA)),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg,
			$author$project$Components$CustomerEmailModal$modal(model.lH)),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg,
			$author$project$Components$PaymentsList$modal(model.jr)),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Utils$Html$empty,
							A2(
								$elm$core$Maybe$map,
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHiConfirmModals(model),
								$author$project$Api$Data$toMaybe(model.Rh))),
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditInvoiceModal(model.it),
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							A2(
								$author$project$Ui$Breadcrumb$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Breadcrumb$item,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												model.F_,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Invoices')
													]))
											])),
										A2(
										$author$project$Ui$Breadcrumb$item,
										_List_fromArray(
											[
												$author$project$Ui$Breadcrumb$active(true)
											]),
										_List_fromArray(
											[
												function () {
												var _v0 = model.Rh;
												if (_v0.$ === 3) {
													var invoice = _v0.a;
													return $elm$html$Html$text(
														'#' + $elm$core$String$fromInt(
															$author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice)));
												} else {
													return $author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$spanFromText('#1234')
															]));
												}
											}()
											]))
									]))),
							function () {
							var _v1 = model.Rh;
							if (_v1.$ === 3) {
								var invoice = _v1.a;
								return A3(
									$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeader,
									model,
									$author$project$Api$Provider$CustomerInvoice$One$meta(invoice),
									invoice);
							} else {
								return $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeaderSkeleton;
							}
						}(),
							$author$project$Ui$HorizontalRule$view(_List_Nil),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetailsSkeleton,
							A2(
								$elm$core$Maybe$map,
								A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetails, model.Hy, model.FR, model.Q8, model.WF),
								$author$project$Api$Data$toMaybe(model.Rh))),
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Utils$Html$empty,
							A2(
								$elm$core$Maybe$map,
								$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPaymentsList(model),
								$author$project$Api$Data$toMaybe(model.Rh))),
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Charges')
								])),
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargesTable(model),
							function () {
							var _v2 = model.Rh;
							if (_v2.$ === 3) {
								var invoice = _v2.a;
								return ($author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'draft') ? A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt4]),
									_List_fromArray(
										[$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewAddChargeButton])) : $author$project$Utils$Html$empty;
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotals(model),
							$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevisions(model)
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					function () {
						var _v3 = model.Rh;
						if (_v3.$ === 3) {
							var invoice = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDeleteButton, model, invoice),
									$author$project$Api$Provider$CustomerInvoice$Meta$issueAction(
									$author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIssueButton, model, invoice) : $author$project$Utils$Html$empty
								]);
						} else {
							return _List_Nil;
						}
					}())
				])),
			function () {
			var _v4 = model.lC;
			if (!_v4.$) {
				var createPaymentModal = _v4.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg,
					$author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v5 = model.h0;
			if (!_v5.$) {
				var createScheduledPaymentModal = _v5.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg,
					$author$project$Components$Invoice$CreateScheduledPaymentModal$view(createScheduledPaymentModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v6 = model.h_;
			if (!_v6.$) {
				var createPassthroughFeesPaymentModal = _v6.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg,
					$author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$view(createPassthroughFeesPaymentModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v7 = model.fd;
			if (!_v7.$) {
				var chargeModal = _v7.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg,
					$author$project$Components$Patient$Charges$ChargeModal$view(chargeModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v8 = model.hp;
			if (!_v8.$) {
				var adjustVoidModal = _v8.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg,
					$author$project$Components$CustomerInvoice$AdjustVoidModal$view(adjustVoidModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			function () {
			var _v9 = model.jG;
			if (!_v9.$) {
				var processRefundModal = _v9.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg,
					$author$project$Components$CustomerInvoice$ProcessRefundModal$view(processRefundModal));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}()
		]);
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$view = function (model) {
	return {
		e5: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewBody(model),
		$G: 'Patient | Invoices'
	};
};
var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$view});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$DateRangeInput$additionalItem = F4(
	function (id, label, start, end) {
		return {E9: end, adR: id, aej: label, Hl: start};
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$additionalMonthOptions = function (currentDate) {
	var currentYear = $justinmimbs$date$Date$year(currentDate);
	var firstDayCurrentYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear, 0, 1);
	var firstDayLastYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear - 1, 0, 1);
	var lastDayCurrentYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear, 11, 31);
	var lastDayLastYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear - 1, 11, 31);
	return _List_fromArray(
		[
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'current_year',
			'Current Year',
			$elm$core$Maybe$Just(firstDayCurrentYear),
			$elm$core$Maybe$Just(lastDayCurrentYear)),
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'last_year',
			'Last Year',
			$elm$core$Maybe$Just(firstDayLastYear),
			$elm$core$Maybe$Just(lastDayLastYear))
		]);
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{
				kT: $author$project$Pages$Patients$PatientId_String$Charges$Top$additionalMonthOptions,
				wZ: _List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(6)
					]),
				adD: start,
				Fp: true,
				ahu: end
			});
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$GotInvoices = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices = function (model) {
	var options = function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				Vp: $elm$core$Maybe$Just(
					$author$project$Api$Provider$Patient$One$id(model.VM)),
				afy: model.afy,
				ag1: A3($author$project$Api$Sort$withDefault, 'date', 1, $author$project$Api$Sort$init),
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				ag7: $elm$core$Maybe$Nothing
			});
	};
	return A3($author$project$Api$Provider$CustomerInvoice$list, model.D5, options, $author$project$Pages$Patients$PatientId_String$Charges$Top$GotInvoices);
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
						{
							VN: $author$project$Api$Provider$Patient$One$id(model.VM)
						}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$init = F5(
	function (_v0, practice, patient, _v1, _v2) {
		var apiClient = _v1.D5;
		var timeFormatter = _v1.Hy;
		var url = _v1.aav;
		var currentDate = _v1.cO;
		var query = _v2.Bi;
		var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v3.a;
		var end = _v3.b;
		var _v4 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range',
			A2(
				$author$project$Pages$Patients$PatientId_String$Charges$Top$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v4.a;
		var dateRangeInputCmd = _v4.b;
		var model = {
			D5: apiClient,
			cO: currentDate,
			h3: dateRangeInput,
			EW: '',
			iq: $author$project$Components$Invoice$DownloadFile$init(url),
			E9: end,
			q2: $author$project$Api$Data$NotAsked,
			afy: $author$project$Api$Pagination$init,
			VM: patient,
			WF: practice,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			Hy: timeFormatter,
			aav: url
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg, dateRangeInputCmd),
						$author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(model),
						$author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(model)
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.iq))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceCreated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$create = F3(
	function (apiClient, patientId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'customer_invoice',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'patient',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(patientId))
										])))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$CustomerInvoice$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicesPath)));
	});
var $author$project$Api$Provider$CustomerInvoice$One$ownerId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$CustomerInvoice$One$owner,
	$elm$core$Maybe$map($author$project$Api$Provider$Patient$Shared$id));
var $author$project$Pages$Patients$PatientId_String$Charges$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								q2: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{q2: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{q2: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(newModel),
								$author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.D5, subMsg, model.iq);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iq: downloadInvoiceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg, downloadInvoiceResult.EC),
					downloadInvoiceResult.as);
			case 3:
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$CustomerInvoice$create,
						model.D5,
						$author$project$Api$Provider$Patient$One$id(model.VM),
						$author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceCreated),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var invoice = response.a;
					var _v3 = $author$project$Api$Provider$CustomerInvoice$One$ownerId(invoice);
					if (!_v3.$) {
						var ownerId = _v3.a;
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
									{
										aea: $author$project$Api$Provider$CustomerInvoice$One$id(invoice),
										VN: ownerId
									})),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Invoice created.')
								]));
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 1, 'We were unable to create an invoice.')
								]));
					}
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v4.a;
				var subCmd = _v4.b;
				var event = _v4.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						var label = event.c;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								EW: label,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						$author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(newModel),
						$author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Patient$One$overdueAmountInCents = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Vm;
	});
var $author$project$Api$Provider$Patient$One$owedInCents = function (_v0) {
	var record = _v0.b;
	return record.Vo;
};
var $author$project$Components$Invoice$DownloadFile$FetchToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Invoice$DownloadFile$viewAndGenerateToken = F3(
	function (model, path, options) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('inline text-left')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Download ' + options.aej},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick(
							A2($author$project$Components$Invoice$DownloadFile$FetchToken, path, options.MQ)),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$export)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(options.aej)
						])),
					model.R0 ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Api$Provider$CustomerInvoice$All$dueInCents = function (_v0) {
	var record = _v0;
	return record.N2;
};
var $author$project$Api$Provider$CustomerInvoice$All$isPaymentScheduled = function (_v0) {
	var record = _v0;
	return record.R_;
};
var $author$project$Api$Provider$CustomerInvoice$All$issuedTotalInCents = function (_v0) {
	var record = _v0;
	return record.Sn;
};
var $author$project$Api$Provider$CustomerInvoice$All$lastSentAt = function (_v0) {
	var record = _v0;
	return record.SD;
};
var $author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate = function (_v0) {
	var record = _v0;
	return record.UH;
};
var $author$project$Api$Provider$CustomerInvoice$All$paidAt = function (_v0) {
	var record = _v0;
	return record.Vt;
};
var $author$project$Api$Provider$CustomerInvoice$All$paymentScheduledOn = function (_v0) {
	var record = _v0;
	return record.V2;
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted = function (scheduledDate) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
			scheduledDate));
};
var $author$project$Api$Provider$CustomerInvoice$All$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$CustomerInvoice$All$totalInCents = function (_v0) {
	var record = _v0;
	return record.$X;
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$viewInvoiceRow = F4(
	function (timeFormatter, patientId, practice, invoice) {
		var issuedTotalInCents = $author$project$Api$Provider$CustomerInvoice$All$issuedTotalInCents(invoice);
		var issueDate = A2(
			$author$project$Formatters$Date$toString,
			$author$project$Formatters$Date$Full,
			$author$project$Api$Provider$CustomerInvoice$All$date(invoice));
		var invoiceId = $author$project$Api$Provider$CustomerInvoice$All$id(invoice);
		var invoiceRoute = $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
			{aea: invoiceId, VN: patientId});
		var humanStatus = _List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$fromString,
				_List_Nil,
				$author$project$Api$Provider$CustomerInvoice$All$humanStatus(invoice)),
				function () {
				if ($author$project$Api$Provider$CustomerInvoice$All$isPaymentScheduled(invoice)) {
					var paymentScheduledOnTextValue = (A2(
						$author$project$Utils$FeatureGate$gateAvailable,
						12,
						$author$project$Api$Practice$Provider(practice)) && (!_Utils_eq(
						$author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate(invoice),
						$elm$core$Maybe$Nothing))) ? $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted(
						$author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate(invoice)) : $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted(
						$author$project$Api$Provider$CustomerInvoice$All$paymentScheduledOn(invoice));
					var paymentScheduledOnFullText = $elm$core$String$isEmpty(paymentScheduledOnTextValue) ? '' : A2($elm$core$String$append, ' payment scheduled for ', paymentScheduledOnTextValue);
					return A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text(paymentScheduledOnFullText)
							]));
				} else {
					if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'sent') {
						var lastSentAtText = A2(
							$elm$core$String$append,
							' last sent at ',
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(5),
									$author$project$Api$Provider$CustomerInvoice$All$lastSentAt(invoice))));
						return A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text(lastSentAtText)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}
			}(),
				function () {
				if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'paid') {
					var paidAtText = A2(
						$elm$core$String$append,
						' on ',
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								timeFormatter(5),
								$author$project$Api$Provider$CustomerInvoice$All$paidAt(invoice))));
					return A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
						_List_fromArray(
							[
								$elm$html$Html$text(paidAtText)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
		var dueInCents = $author$project$Api$Provider$CustomerInvoice$All$dueInCents(invoice);
		var amount = _List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				function () {
					if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'draft') {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromInt(issuedTotalInCents))
									]))
							]);
					} else {
						var totalInCents = $author$project$Api$Provider$CustomerInvoice$All$totalInCents(invoice);
						return (!_Utils_eq(totalInCents, issuedTotalInCents)) ? _List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$strike, $author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromInt(issuedTotalInCents))
									])),
								$elm$html$Html$text(
								' ' + $author$project$Utils$Currency$fromInt(totalInCents))
							]) : _List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Utils$Currency$fromInt(totalInCents))
							]);
					}
				}()),
				(!_Utils_eq(
				dueInCents,
				$author$project$Api$Provider$CustomerInvoice$All$totalInCents(invoice))) ? ((dueInCents > 0) ? A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						' (' + ($author$project$Utils$Currency$fromInt(dueInCents) + ' owed)'))
					])) : ((dueInCents < 0) ? A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						' (-' + ($author$project$Utils$Currency$fromInt(dueInCents) + ' overpaid)'))
					])) : $elm$html$Html$text(''))) : $elm$html$Html$text('')
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							invoiceRoute,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(issueDate)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							invoiceRoute,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'#' + $elm$core$String$fromInt(
										$author$project$Api$Provider$CustomerInvoice$All$invoiceNumber(invoice)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('12em')
						]),
					amount),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$minWidth('12em')
						]),
					humanStatus)
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceButtonClicked = {$: 3};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$viewNewInvoiceButton = A3(
	$author$project$Ui$Button$view,
	{abp: 'Add invoice'},
	_List_fromArray(
		[
			$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceButtonClicked),
			$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add),
			$author$project$Ui$Button$default
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Add Invoice')
		]));
var $author$project$Pages$Patients$PatientId_String$Charges$Top$view = function (_v0) {
	var invoices = _v0.q2;
	var pagination = _v0.afy;
	var timeFormatter = _v0.Hy;
	var patient = _v0.VM;
	var currentDate = _v0.cO;
	var downloadInvoice = _v0.iq;
	var dateRangeInput = _v0.h3;
	var start = _v0.Hl;
	var end = _v0.E9;
	var practice = _v0.WF;
	var patientId = $author$project$Api$Provider$Patient$One$id(patient);
	var path = A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[patientId]),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['patients']),
			$author$project$Api$Data$providerPath));
	var _v1 = function () {
		if (invoices.$ === 3) {
			var inv = invoices.a;
			return _Utils_Tuple2(false, inv);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v1.a;
	var invoices_ = _v1.b;
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Invoices')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanLg(3),
												$author$project$Ui$FlexGrid$spanSm(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(dateRangeInput))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanLg(1),
												$author$project$Ui$FlexGrid$spanSm(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$ml2]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$primary]),
														_List_fromArray(
															[
																$elm$html$Html$text('Balance:')
															])),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														A2(
														$author$project$Ui$Typography$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$Currency$fromInt(
																	$author$project$Api$Provider$Patient$One$owedInCents(patient)))
															]))
													]))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanLg(2),
												$author$project$Ui$FlexGrid$spanSm(6)
											]),
										_List_fromArray(
											[
												(!(!$author$project$Api$Provider$Patient$One$overdueAmountInCents(patient))) ? A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$ml2]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$primary]),
														_List_fromArray(
															[
																$elm$html$Html$text(' Past Due:')
															])),
														A2($elm$html$Html$br, _List_Nil, _List_Nil),
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$danger]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Utils$Currency$fromInt(
																	$author$project$Api$Provider$Patient$One$overdueAmountInCents(patient)))
															]))
													])) : $author$project$Utils$Html$empty
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanLg(6),
												$author$project$Ui$FlexGrid$spanSm(12),
												$author$project$Ui$FlexGrid$justifyRight
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$gap2]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg,
														A3(
															$author$project$Components$Invoice$DownloadFile$viewAndGenerateToken,
															downloadInvoice,
															path,
															{
																abs: true,
																MQ: {
																	Fu: A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A2(
																			$elm$core$Maybe$map,
																			$justinmimbs$date$Date$toIsoString,
																			A2(
																				$elm$core$Maybe$map,
																				A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
																				start))),
																	F2: A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A2(
																			$elm$core$Maybe$map,
																			$justinmimbs$date$Date$toIsoString,
																			A2(
																				$elm$core$Maybe$map,
																				A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
																				end)))
																},
																aej: 'Export Account Statement'
															})),
														$author$project$Pages$Patients$PatientId_String$Charges$Top$viewNewInvoiceButton
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$verticalCentered,
										$author$project$Ui$Table$loading(loading),
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('This patient has no invoices')
											]))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Date')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Number')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Amount')
											])),
										A2(
										$author$project$Ui$Table$header,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Status')
											]))
									]),
								A2(
									$elm$core$List$map,
									A3($author$project$Pages$Patients$PatientId_String$Charges$Top$viewInvoiceRow, timeFormatter, patientId, practice),
									invoices_),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Patients$PatientId_String$Charges$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									pagination))
							]))
					]))
			]),
		$G: 'Patient | Invoices'
	};
};
var $author$project$Pages$Patients$PatientId_String$Charges$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Charges$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Charges$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Charges$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Charges$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Charges$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Charges$Top$view});
var $author$project$Pages$Patients$PatientId_String$Chart$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Chart$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Chart$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Patients$PatientId_String$Chart$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Patient Chart'};
};
var $author$project$Pages$Patients$PatientId_String$Chart$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Patients$PatientId_String$Chart$init,
		aer: $author$project$Pages$Patients$PatientId_String$Chart$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Patients$PatientId_String$Chart$update,
		ahP: $author$project$Pages$Patients$PatientId_String$Chart$view
	});
var $author$project$Pages$Patients$PatientId_String$Edit$GotCompany = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$GotMeta = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$init = F5(
	function (session, practice, patient, shared, _v0) {
		var params = _v0.Vx;
		var _v1 = function () {
			var _v2 = $author$project$Api$Provider$Patient$One$company(patient);
			if (!_v2.$) {
				var company_ = _v2.a;
				return _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					A3(
						$author$project$Api$Provider$Company$retrieve,
						shared.D5,
						$author$project$Api$Provider$Company$Min$id(company_),
						$author$project$Pages$Patients$PatientId_String$Edit$GotCompany));
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
			}
		}();
		var company = _v1.a;
		var retrieveCompanyCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, ab9: company, cO: shared.cO, PB: $elm$core$Maybe$Nothing, adN: shared.adN, adR: params.VN, TU: $author$project$Api$Data$Loading, f9: $elm$core$Maybe$Nothing, VM: patient, WF: practice, ZD: session, kj: false},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						retrieveCompanyCmd,
						A4(
						$author$project$Api$Patient$Meta$retrieve,
						shared.D5,
						session,
						$author$project$Api$Provider$Patient$One$id(patient),
						$author$project$Pages$Patients$PatientId_String$Edit$GotMeta)
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Edit$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Edit$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked = {$: 6};
var $author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$FormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$subscriptions = function (_v0) {
	var form = _v0.PB;
	var openModal = _v0.f9;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Patient$Form$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg)),
					form)),
				function () {
				if (!openModal.$) {
					if (!openModal.a) {
						var _v2 = openModal.a;
						return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked);
					} else {
						var _v3 = openModal.a;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked);
					}
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Patients$PatientId_String$Edit$PatientArchived = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$PatientUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Patient$delete = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$patientPath(id_)));
	});
var $author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm = F8(
	function (session, practice, hinterViewOff, patient, apiClient, currentDate, company, meta) {
		return A8(
			$author$project$Components$Patient$Form$fill,
			apiClient,
			session,
			currentDate,
			A2($elm$core$Maybe$map, $author$project$Api$Company$Provider, company),
			false,
			$author$project$Api$Patient$One$Provider(patient),
			meta,
			function (settings) {
				return _Utils_update(
					settings,
					{
						abD: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
						abL: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
						P8: $author$project$Api$Provider$Practice$One$hasLocations(practice),
						Qe: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
						aeA: $author$project$Api$Provider$Practice$One$isMce(practice),
						rr: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
						ago: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
						Ym: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
						agp: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
						Yr: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
						Ys: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
						_D: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
						$f: A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Network$Shared$syncByAffiliation,
								$author$project$Api$Provider$Practice$One$network(practice))),
						ahB: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
						$$: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
						$1: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
						DF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0)
					});
			});
	});
var $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm = function (model) {
	var _v0 = _Utils_Tuple2(model.ab9, model.TU);
	_v0$2:
	while (true) {
		if (_v0.b.$ === 3) {
			switch (_v0.a.$) {
				case 3:
					var _v1 = _v0.a;
					var company_ = _v1.a;
					var _v2 = _v0.b;
					var meta = _v2.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A8(
								$author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm,
								model.ZD,
								model.WF,
								model.adN,
								model.VM,
								model.D5,
								model.cO,
								$elm$core$Maybe$Just(company_),
								meta)));
				case 0:
					var _v3 = _v0.a;
					var _v4 = _v0.b;
					var meta = _v4.a;
					return A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A8($author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm, model.ZD, model.WF, model.adN, model.VM, model.D5, model.cO, $elm$core$Maybe$Nothing, meta)));
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
};
var $author$project$Api$Provider$Patient$update = F4(
	function (apiClient, id_, jsonBody, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				jsonBody,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Edit$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				var modelWithCompany = _Utils_update(
					model,
					{ab9: response});
				var _v1 = $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm(modelWithCompany);
				var form = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						modelWithCompany,
						{PB: form}),
					cmd,
					_List_Nil);
			case 1:
				var response = msg.a;
				var modelWithMeta = _Utils_update(
					model,
					{TU: response});
				var _v2 = $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm(modelWithMeta);
				var form = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						modelWithMeta,
						{PB: form}),
					cmd,
					_List_Nil);
			case 2:
				var formMsg = msg.a;
				if (formMsg.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
								{
									VN: $author$project$Api$Provider$Patient$One$id(model.VM)
								})),
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.VM)),
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								'Successfully updated ' + $author$project$Api$Provider$Patient$One$id(model.VM))
							]));
				} else {
					var _v4 = model.PB;
					if (!_v4.$) {
						var form = _v4.a;
						var _v5 = function () {
							var _v6 = model.ab9;
							if (_v6.$ === 3) {
								var company_ = _v6.a;
								return A5(
									$author$project$Components$Patient$Form$update,
									model.D5,
									model.ZD,
									$elm$core$Maybe$Just(
										$author$project$Api$Company$Provider(company_)),
									formMsg,
									form);
							} else {
								return A5($author$project$Components$Patient$Form$update, model.D5, model.ZD, $elm$core$Maybe$Nothing, formMsg, form);
							}
						}();
						var newForm = _v5.a;
						var formCmd = _v5.b;
						var formOutMsgs = _v5.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(newForm)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Edit$FormMsg, formCmd),
							formOutMsgs);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				}
			case 3:
				var _v7 = model.PB;
				if (!_v7.$) {
					var form = _v7.a;
					var _v8 = $author$project$Components$Patient$Form$validate(form);
					if (!_v8.$) {
						var _v9 = _v8.a;
						var validForm = _v9.a;
						var validFields = _v9.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: true}),
							A4(
								$author$project$Api$Provider$Patient$update,
								model.D5,
								model.adR,
								A2($author$project$Components$Patient$Form$encode, validFields, validForm),
								$author$project$Pages$Patients$PatientId_String$Edit$PatientUpdated),
							_List_Nil);
					} else {
						var erroredForm = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									PB: $elm$core$Maybe$Just(erroredForm)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var patient = response.a;
						var createAffiliationResult = function () {
							var _v12 = model.PB;
							if (!_v12.$) {
								var form = _v12.a;
								var affiliationId = A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Affiliate$AffiliateMin$id,
									$author$project$Api$Provider$Patient$One$assignedAffiliation(model.VM));
								return A5(
									$author$project$Components$Patient$Form$createAffiliation,
									model.D5,
									model.ZD,
									$author$project$Api$Provider$Patient$One$id(patient),
									affiliationId,
									form);
							} else {
								return {v$: false, EC: $elm$core$Platform$Cmd$none};
							}
						}();
						var _v11 = createAffiliationResult.v$ ? _Utils_Tuple2(
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Edit$FormMsg, createAffiliationResult.EC),
							_List_Nil) : _Utils_Tuple2(
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
									{
										VN: $author$project$Api$Provider$Patient$One$id(patient)
									})),
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(patient)),
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully updated ' + $author$project$Api$Provider$Patient$One$id(patient))
								]));
						var cmd = _v11.a;
						var outMsgs = _v11.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							cmd,
							outMsgs);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kj: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 5:
				var openModal = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							f9: $elm$core$Maybe$Just(openModal)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f9: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{f9: $elm$core$Maybe$Nothing}),
					A3($author$project$Api$Provider$Patient$delete, model.D5, model.adR, $author$project$Pages$Patients$PatientId_String$Edit$PatientArchived),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{f9: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
									{VN: model.adR})),
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(model.adR),
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully archived ' + model.adR)
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Ports$Navigation$back, _List_Nil);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Edit$CancelButtonClicked = {$: 9};
var $author$project$Pages$Patients$PatientId_String$Edit$FormSubmitted = {$: 3};
var $author$project$Api$Provider$Patient$Shared$archived = function (_v0) {
	var shared = _v0;
	return shared.Jn;
};
var $author$project$Api$Provider$Patient$One$archived = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$archived(shared);
};
var $author$project$Api$Provider$Patient$One$isSynced = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Sa;
	});
var $author$project$Components$AddressInput$skeleton = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(7)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(5)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$input(_List_Nil)
						]))
				]))
		]));
var $author$project$Components$NameInput$skeleton = A2(
	$author$project$Ui$FlexGrid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanSm(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanSm(6),
					$author$project$Ui$FlexGrid$spanMd(3)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanSm(4),
					$author$project$Ui$FlexGrid$spanMd(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanSm(7),
					$author$project$Ui$FlexGrid$spanMd(3)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanSm(5),
					$author$project$Ui$FlexGrid$spanMd(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$input(_List_Nil)
				]))
		]));
var $author$project$Components$PhoneInput$skeleton = function (repeat) {
	return _Utils_ap(
		A2(
			$elm$core$List$repeat,
			repeat,
			A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(4)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$input(_List_Nil)
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(8)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$input(_List_Nil)
							]))
					]))),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$spanFromText('Add Another Phone')
							]))
					]))
			]));
};
var $author$project$Components$Patient$Form$skeleton = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Legal Name'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Components$NameInput$skeleton,
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(4)
							]))
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Date of Birth'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Sex'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(3)
							]))
					]))
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Gender Identity'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Pronoun'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Email'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Phones'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		$author$project$Components$PhoneInput$skeleton(1)),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Address'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[$author$project$Components$AddressInput$skeleton])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Provider'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Location'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Health Insurance'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSkeleton('Lead Source'),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpanMd(8)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			]))
	]);
var $author$project$Pages$Patients$PatientId_String$Edit$unlessRestricted = F2(
	function (hideSection, body) {
		return hideSection ? $author$project$Utils$Html$empty : body;
	});
var $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Edit$CannotArchive = 0;
var $author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchive = 1;
var $author$project$Api$Patient$Meta$archive = function (_v0) {
	var actions = _v0.b;
	return actions.Jm;
};
var $author$project$Utils$MetaFields$isActionable = $elm$core$Basics$identity;
var $author$project$Pages$Patients$PatientId_String$Edit$viewArchiveButton = F2(
	function (patient, meta) {
		var openArchiveModalMsg = $author$project$Utils$MetaFields$isActionable(
			$author$project$Api$Patient$Meta$archive(meta)) ? $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked(1) : $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked(0);
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Archive patient'},
			_List_fromArray(
				[
					$author$project$Ui$Button$danger,
					$author$project$Ui$Button$disabled(
					$author$project$Api$Provider$Patient$One$archived(patient)),
					$author$project$Ui$Button$onClick(openArchiveModalMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Archive')
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Edit$viewCannotArchiveModal = A3(
	$author$project$Ui$Modal$view,
	$author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked,
	_List_fromArray(
		[
			$author$project$Ui$Modal$size(1)
		]),
	_List_fromArray(
		[
			$author$project$Ui$Modal$header(
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Cannot Archive Patient')
						]))
				])),
			$author$project$Ui$Modal$body(
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You cannot archive a patient in the following situations:')
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If they have an uncollected balance')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If they have an active membership')
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('If they are actively linked to a company')
								]))
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('To archive the patient, cancel any charges or mark them as bad debt, end any memberships, and unlink any companies.')
						]))
				])),
			$author$project$Ui$Modal$footer(
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Close'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(0),
							$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('OK')
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Edit$confirmArchiveMessage = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Are you sure you want to archive this patient? This will disable all payments and emails to this patient.')
					]))
			]))
	]);
var $author$project$Pages$Patients$PatientId_String$Edit$viewConfirmArchiveModal = A2(
	$author$project$Components$HiConfirm$modal,
	$author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked,
	_List_fromArray(
		[
			$author$project$Components$HiConfirm$verb('archive'),
			$author$project$Components$HiConfirm$noun('patient'),
			$author$project$Components$HiConfirm$customMessage($author$project$Pages$Patients$PatientId_String$Edit$confirmArchiveMessage)
		]));
var $author$project$Pages$Patients$PatientId_String$Edit$viewMergeButton = function (patient) {
	var button = A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Merge(
			{
				VN: $author$project$Api$Provider$Patient$One$id(patient)
			}),
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonWarning,
				$author$project$Ui$Link$disabled(
				$author$project$Api$Provider$Patient$One$membershipStatus(patient) !== 'inactive')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Merge')
			]));
	return ($author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive') ? button : A3(
		$author$project$Ui$Popover$view,
		_List_Nil,
		_List_fromArray(
			[button]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Popover$body,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Patient must be inactive in order to be merged into another record.')
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Edit$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.f9;
				if (!_v0.$) {
					if (!_v0.a) {
						var _v1 = _v0.a;
						return $author$project$Pages$Patients$PatientId_String$Edit$viewCannotArchiveModal;
					} else {
						var _v2 = _v0.a;
						return $author$project$Pages$Patients$PatientId_String$Edit$viewConfirmArchiveModal;
					}
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$onSubmit($author$project$Pages$Patients$PatientId_String$Edit$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{VN: model.adR}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Patient')
													])),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('  /  Edit Patient')
													]))
											])),
										$author$project$Ui$HorizontalRule$view(
										_List_fromArray(
											[$author$project$Ui$HorizontalRule$thin])),
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Edit Patient')
											])),
										function () {
										var _v3 = model.PB;
										if (!_v3.$) {
											var form = _v3.a;
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg),
													$author$project$Components$Patient$Form$view(form)));
										} else {
											return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Patient$Form$skeleton);
										}
									}()
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
								function () {
									var _v4 = model.TU;
									if (_v4.$ === 3) {
										var meta = _v4.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Cancel and go back'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Edit$CancelButtonClicked)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Cancel')
													])),
												A2(
												$author$project$Pages$Patients$PatientId_String$Edit$unlessRestricted,
												$author$project$Api$Provider$Patient$One$isSynced(model.VM),
												A2($author$project$Pages$Patients$PatientId_String$Edit$viewArchiveButton, model.VM, meta)),
												$author$project$Pages$Patients$PatientId_String$Edit$viewMergeButton(model.VM),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Update patient'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$disabled(
														$author$project$Api$Provider$Patient$One$archived(model.VM)),
														$author$project$Ui$Button$submit,
														$author$project$Ui$Button$loading(model.kj)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Update')
													]))
											]);
									} else {
										return _List_Nil;
									}
								}())
							]))
					]))
			]),
		$G: 'Patient | ' + model.adR
	};
};
var $author$project$Pages$Patients$PatientId_String$Edit$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Edit$init, aer: $author$project$Pages$Patients$PatientId_String$Edit$load, agD: $author$project$Pages$Patients$PatientId_String$Edit$save, ahd: $author$project$Pages$Patients$PatientId_String$Edit$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Edit$update, ahP: $author$project$Pages$Patients$PatientId_String$Edit$view});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$GotCredits = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Patient$Credit$creditsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['credits']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Credit$All$Credit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Credit$Shared$Credit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Credit$Shared$Record = function (id) {
	return function (name) {
		return function (amountInCents) {
			return function (balanceInCents) {
				return function (createdAt) {
					return function (expiresOn) {
						return function (expiresSoon) {
							return function (isEditable) {
								return function (isExpired) {
									return function (issuedOn) {
										return function (reason) {
											return function (transferredInCents) {
												return function (creditCategory) {
													return {I2: amountInCents, abw: balanceInCents, Mf: createdAt, Mj: creditCategory, O$: expiresOn, O0: expiresSoon, adR: id, aee: isEditable, RM: isExpired, Si: issuedOn, zh: name, XP: reason, $5: transferredInCents};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Credit$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'credit_category',
	$author$project$Api$Provider$CreditCategory$Shared$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'transferred_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'reason',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'issued_on',
				$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_expired',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_editable',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'expires_soon',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'expires_on',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'created_at',
									$elm_community$json_extra$Json$Decode$Extra$datetime,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'balance_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'amount_in_cents',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Credit$Shared$Record))))))))))))));
var $author$project$Api$Provider$Credit$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Credit$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Credit$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Credit$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$Credit$listDefaults = {
	afy: $author$project$Api$Pagination$init,
	ag1: A3($author$project$Api$Sort$withDefault, 'issued_on', 0, $author$project$Api$Sort$init),
	ag7: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Patient$Credit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Patient$Credit$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.ag7;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'status', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Patient$Credit$list = F4(
	function (apiClient, patientId, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Credit$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Patient$Credit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$Credit$creditsPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue = function (option) {
	switch (option) {
		case 1:
			return 'zero_balance';
		case 2:
			return 'outstanding';
		default:
			return 'all';
	}
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits = function (model) {
	var options = function (d) {
		return _Utils_update(
			d,
			{
				afy: model.afy,
				ag1: A3($author$project$Api$Sort$withDefault, 'issued_on', 1, $author$project$Api$Sort$init),
				ag7: $elm$core$Maybe$Just(
					$author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue(model.ag7))
			});
	};
	return A4(
		$author$project$Api$Provider$Patient$Credit$list,
		model.D5,
		$author$project$Api$Provider$Patient$One$id(model.VM),
		options,
		$author$project$Pages$Patients$PatientId_String$ManageCredits$GotCredits);
};
var $author$project$Components$ResourceFilter$CreditCategory$list = $author$project$Api$Provider$CreditCategory$list;
var $author$project$Components$ResourceFilter$CreditCategory$resourceFromAll = function (category) {
	return {
		I2: $author$project$Api$Provider$CreditCategory$All$amountInCents(category),
		O_: $author$project$Api$Provider$CreditCategory$All$expiresInDays(category),
		adR: $author$project$Api$Provider$CreditCategory$All$id(category),
		zh: $author$project$Api$Provider$CreditCategory$All$name(category)
	};
};
var $author$project$Components$ResourceFilter$CreditCategory$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$CreditCategory$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination, af_: query});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$CreditCategory$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$CreditCategory$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$CreditCategory$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map(
					$elm$core$List$map($author$project$Components$ResourceFilter$CreditCategory$resourceFromAll))));
	});
var $author$project$Components$ResourceFilter$CreditCategory$selectId = 'credit_category';
var $author$project$Components$ResourceFilter$CreditCategory$toTitle = function ($) {
	return $.zh;
};
var $author$project$Components$ResourceFilter$CreditCategory$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$CreditCategory$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$CreditCategory$toValue = function ($) {
	return $.adR;
};
var $author$project$Components$ResourceFilter$CreditCategory$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$CreditCategory$fetchResources, adR: $author$project$Components$ResourceFilter$CreditCategory$selectId, gx: 'Category', st: $author$project$Components$ResourceFilter$CreditCategory$retrieveResource, ahw: $author$project$Components$ResourceFilter$CreditCategory$toLabel, ahA: $author$project$Components$ResourceFilter$CreditCategory$toTitle, g0: $author$project$Components$ResourceFilter$CreditCategory$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'issued_on', false, 'Issued On'),
		A3($author$project$Api$Column$init, '', false, 'Category'),
		A3($author$project$Api$Column$init, '', false, 'Reason'),
		A3($author$project$Api$Column$init, 'expires_on', false, 'Expires'),
		A3($author$project$Api$Column$init, 'amount_in_cents', false, 'Total Amount'),
		A3($author$project$Api$Column$init, 'used_in_cents', false, 'Amount Left')
	]);
var $author$project$Pages$Patients$PatientId_String$ManageCredits$All = 0;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$Outstanding = 2;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$ZeroBalance = 1;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionFromQuery = function (queryString) {
	_v0$2:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'zero_balance':
					return 1;
				case 'outstanding':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$url$Url$Builder$string,
			'status',
			$author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue(model.ag7))
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(
					$author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits(
						{
							VN: $author$project$Api$Provider$Patient$One$id(model.VM)
						}))
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					queryParams))));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$init = F5(
	function (_v0, practice, patient, _v1, _v2) {
		var apiClient = _v1.D5;
		var currentDate = _v1.cO;
		var query = _v2.Bi;
		var _v3 = A2(
			$author$project$Components$ResourceFilter$CreditCategory$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Credit Category', IS: false, aeZ: false});
			});
		var creditCategoriesResourceFilter = _v3.a;
		var creditCategoriesResourceFilterCmd = _v3.b;
		var model = {
			D5: apiClient,
			Ll: $author$project$Pages$Patients$PatientId_String$ManageCredits$initColumns,
			r: $elm$core$Maybe$Nothing,
			fh: creditCategoriesResourceFilter,
			aY: $author$project$Api$Data$Loading,
			cO: currentDate,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			VM: patient,
			WF: practice,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'issued_on',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			ag7: $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionFromQuery(
				A2($elm$core$Dict$get, 'status', query)),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'credits-status-dropdown-filter', ahx: $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model),
						$author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, creditCategoriesResourceFilterCmd)
					])));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit = {$: 2};
var $author$project$Components$ResourceFilter$CreditCategory$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$subscriptions = function (_v0) {
	var credit = _v0.r;
	var statusDropdown = _v0.oA;
	var creditCategoriesResourceFilter = _v0.fh;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(statusDropdown),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$CreditCategory$subscriptions(creditCategoriesResourceFilter)),
				function () {
				if (!credit.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}()
			]));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategory = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryOnly = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$Date = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$Provider$Credit$Shared$category = function (_v0) {
	var record = _v0;
	return record.Mj;
};
var $author$project$Api$Provider$Credit$All$category = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$category(shared);
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Provider$Credit$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Credit$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Credit$Shared$expiresOn = function (_v0) {
	var record = _v0;
	return record.O$;
};
var $author$project$Api$Provider$Credit$All$expiresOn = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$expiresOn(shared);
};
var $author$project$Api$Provider$Credit$Shared$reason = function (_v0) {
	var record = _v0;
	return record.XP;
};
var $author$project$Api$Provider$Credit$All$reason = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$reason(shared);
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsFromCredit = function (credit) {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{
			I2: $elm$core$Maybe$Just(
				$author$project$Currency$fromInt(
					$author$project$Api$Provider$Credit$All$amountInCents(credit))),
			Mj: $elm$core$Maybe$Nothing,
			qd: dateInput,
			O$: $author$project$Api$Provider$Credit$All$expiresOn(credit),
			XP: A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Credit$All$reason(credit))
		},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput),
			dateInputCmd));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsInit = function () {
	var _v0 = $author$project$Components$DateInput$init;
	var dateInput = _v0.a;
	var dateInputCmd = _v0.b;
	return _Utils_Tuple2(
		{I2: $elm$core$Maybe$Nothing, Mj: $elm$core$Maybe$Nothing, qd: dateInput, O$: $elm$core$Maybe$Nothing, XP: ''},
		A2(
			$elm$core$Platform$Cmd$map,
			$author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput),
			dateInputCmd));
}();
var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate = F3(
	function (currentDate, field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{XP: string});
			case 1:
				var maybeCurrency = field.a;
				return _Utils_update(
					fields,
					{I2: maybeCurrency});
			case 2:
				var dateInput = field.a;
				var maybeDate = field.b;
				return _Utils_update(
					fields,
					{qd: dateInput, O$: maybeDate});
			case 3:
				var creditCategory = field.a;
				return _Utils_update(
					fields,
					{
						I2: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, creditCategory.I2),
						Mj: $elm$core$Maybe$Just(creditCategory),
						O$: function () {
							var _v1 = creditCategory.O_;
							if (!_v1.$) {
								var days = _v1.a;
								return $elm$core$Maybe$Just(
									A3($justinmimbs$date$Date$add, 3, days, currentDate));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}()
					});
			default:
				var creditCategory = field.a;
				return _Utils_update(
					fields,
					{
						Mj: $elm$core$Maybe$Just(creditCategory)
					});
		}
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$NameValidation = 0;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.Mj;
			},
			_Utils_Tuple2(0, 'Please enter a category.'))
		]));
var $author$project$Api$Provider$Credit$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Credit$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$id(shared);
};
var $author$project$Api$Provider$Credit$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Credit$One$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$name(shared);
};
var $author$project$Components$ResourceFilter$CreditCategory$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bb);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bb: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCreated = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Credit$One$Credit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Credit$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Credit$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$Credit$create = F4(
	function (apiClient, patientId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'credit',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'credit_category',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(fields.EL))
										]))),
								_Utils_Tuple2(
								'amount_in_cents',
								$elm$json$Json$Encode$int(fields.I2)),
								_Utils_Tuple2(
								'expires_on',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.O$)),
								_Utils_Tuple2(
								'reason',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.XP))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Credit$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$Credit$creditsPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$createCredit = F3(
	function (apiClient, patientId, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {
			I2: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.I2)),
			EL: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adR;
					},
					fields.Mj)),
			O$: fields.O$,
			XP: (fields.XP === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.XP)
		};
		return A4($author$project$Api$Provider$Patient$Credit$create, apiClient, patientId, apiFields, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCreated);
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditUpdated = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Patient$Credit$creditPath = F2(
	function (patientId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Patient$Credit$creditsPath(patientId));
	});
var $author$project$Api$Provider$Patient$Credit$update = F5(
	function (apiClient, patientId, id_, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'credit',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'credit_category',
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'id',
											$elm$json$Json$Encode$string(fields.EL))
										]))),
								_Utils_Tuple2(
								'amount_in_cents',
								$elm$json$Json$Encode$int(fields.I2)),
								_Utils_Tuple2(
								'expires_on',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.O$)),
								_Utils_Tuple2(
								'reason',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.XP))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Credit$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Patient$Credit$creditPath, patientId, id_))));
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$updateCredit = F4(
	function (apiClient, patientId, id, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		var apiFields = {
			I2: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.I2)),
			EL: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.adR;
					},
					fields.Mj)),
			O$: fields.O$,
			XP: $elm$core$Maybe$Just(fields.XP)
		};
		return A5($author$project$Api$Provider$Patient$Credit$update, apiClient, patientId, id, apiFields, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditUpdated);
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$saveCredit = F4(
	function (patientId, maybeId, apiClient, formFields) {
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Pages$Patients$PatientId_String$ManageCredits$updateCredit, apiClient, patientId, id_, formFields);
		} else {
			return A3($author$project$Pages$Patients$PatientId_String$ManageCredits$createCredit, apiClient, patientId, formFields);
		}
	});
var $author$project$Components$ResourceFilter$CreditCategory$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var field = msg.a;
				var _v2 = model.r;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var id = _v3.a;
					var form = _v3.b;
					var credit = _v3.c;
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.cO),
						field,
						form);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, credit))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{r: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var _v4 = $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsInit;
				var form = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							r: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$author$project$Utils$Form$init(form),
									$author$project$Api$Data$NotAsked))
						}),
					cmd,
					_List_Nil);
			case 5:
				var form = msg.a;
				var maybeId = msg.b;
				var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsValidator, form);
				if (!_v5.$) {
					var _v6 = _v5.a;
					var newForm = _v6.a;
					var validFormFields = _v6.b;
					var patientId = $author$project$Api$Provider$Patient$One$id(model.VM);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeId, newForm, $author$project$Api$Data$Loading))
							}),
						A4($author$project$Pages$Patients$PatientId_String$ManageCredits$saveCredit, patientId, maybeId, model.D5, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v5.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: $elm$core$Maybe$Just(
									_Utils_Tuple3(maybeId, newForm, $author$project$Api$Data$NotAsked))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 4:
				var credit = msg.a;
				var _v7 = function (categoryId) {
					return A2($author$project$Components$ResourceFilter$CreditCategory$preSelectedId, categoryId, model.fh);
				}(
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CreditCategory$Shared$id(
							$author$project$Api$Provider$Credit$All$category(credit))));
				var newFilter = _v7.a;
				var filterCmd = _v7.b;
				var _v8 = $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsFromCredit(credit);
				var newForm = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							r: $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$Credit$All$id(credit)),
									$author$project$Utils$Form$init(newForm),
									$author$project$Api$Data$NotAsked)),
							fh: newFilter
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, filterCmd)
							])),
					_List_Nil);
			case 6:
				var response = msg.a;
				var _v9 = model.r;
				if (!_v9.$) {
					var _v10 = _v9.a;
					var id = _v10.a;
					var form = _v10.b;
					if (response.$ === 3) {
						var credit = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{r: $elm$core$Maybe$Nothing, aY: $author$project$Api$Data$Loading}),
							$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									'Successfully created ' + $author$project$Api$Provider$Credit$One$name(credit)),
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.VM))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									r: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v12 = model.r;
				if (!_v12.$) {
					var _v13 = _v12.a;
					var id = _v13.a;
					var form = _v13.b;
					if (response.$ === 3) {
						var credit = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{r: $elm$core$Maybe$Nothing, aY: $author$project$Api$Data$Loading}),
							$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									3,
									$author$project$Api$Provider$Credit$One$name(credit) + ' was successfully updated.'),
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.VM))
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									r: $elm$core$Maybe$Just(
										_Utils_Tuple3(id, form, response))
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var dateInput = msg.a;
				var subMsg = msg.b;
				var _v15 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
				var newDateInput = _v15.a;
				var subCmd = _v15.b;
				var event = _v15.c;
				var _v16 = model.r;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var id = _v17.a;
					var form = _v17.b;
					var credit = _v17.c;
					var newForm = function () {
						if (event.$ === 1) {
							var date = event.a;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.cO),
								A2($author$project$Pages$Patients$PatientId_String$ManageCredits$Date, newDateInput, date),
								form);
						} else {
							var _v19 = $author$project$Utils$Form$fields(form);
							var expiresOn = _v19.O$;
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.cO),
								A2($author$project$Pages$Patients$PatientId_String$ManageCredits$Date, newDateInput, expiresOn),
								form);
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								r: $elm$core$Maybe$Just(
									_Utils_Tuple3(id, newForm, credit))
							}),
						subCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var subMsg = msg.a;
				var _v20 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var dropdown = _v20.a;
				var dropdownCmd = _v20.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 10:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{aY: $author$project$Api$Data$Loading, ag7: status});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
								$author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
							])),
					_List_Nil);
			case 11:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{aY: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
								$author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
							])),
					_List_Nil);
			case 12:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						aY: $author$project$Api$Data$Loading,
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
								$author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var resourceResult = A3($author$project$Components$ResourceFilter$CreditCategory$update, model.D5, subMsg, model.fh);
				var newCredit = A2(
					$elm$core$Maybe$map,
					function (_v21) {
						var id = _v21.a;
						var form = _v21.b;
						var credit = _v21.c;
						var newForm = function () {
							var _v22 = resourceResult.ac5;
							if (((!_v22.$) && (!_v22.a.$)) && (!_v22.a.a.$)) {
								var creditCategory = _v22.a.a.a;
								var formField = function () {
									if (!id.$) {
										return $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryOnly(creditCategory);
									} else {
										return $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategory(creditCategory);
									}
								}();
								return A3(
									$author$project$Utils$Form$update,
									$author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.cO),
									formField,
									form);
							} else {
								return form;
							}
						}();
						return _Utils_Tuple3(id, newForm, credit);
					},
					model.r);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{r: newCredit, fh: resourceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, resourceResult.EC),
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$PatientId_String$ManageCredits$NewCredit = {$: 3};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$PaginationMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$SortTable = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$AmountInCents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$Reason = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$SaveCredit = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Ui$Form$Accessible$CreditCategoryFilter = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Ui$Form$Accessible$creditCategoryFilter = $author$project$Ui$Form$Accessible$CreditCategoryFilter;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditModal = F4(
	function (creditCategoryResourceFilter, maybeId, form, credit) {
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Credit',
			S_: _Utils_eq(credit, $author$project$Api$Data$Loading),
			Tv: maybeId,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit,
			U0: $author$project$Pages$Patients$PatientId_String$ManageCredits$SaveCredit(form)
		};
		var _v0 = $author$project$Utils$Form$fields(form);
		var amountInCents = _v0.I2;
		var expiresOn = _v0.O$;
		var reason = _v0.XP;
		var dateInput = _v0.qd;
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A4(
					$author$project$Ui$Form$Accessible$single,
					'Category',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$labelSpan(4),
							$author$project$Ui$Form$Accessible$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]),
					A3(
						$author$project$Ui$Form$Accessible$creditCategoryFilter,
						$author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$disabled(
								$author$project$Utils$Maybe$toBool(maybeId))
							]),
						creditCategoryResourceFilter)),
					A4(
					$author$project$Ui$Form$Accessible$single,
					'Reason',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$labelSpan(4)
						]),
					_List_Nil,
					$author$project$Ui$Form$Accessible$textInput(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(reason),
								$author$project$Ui$Form$Input$placeholder('Extra info about credit'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated, $author$project$Pages$Patients$PatientId_String$ManageCredits$Reason))
							]))),
					A4(
					$author$project$Ui$Form$Accessible$single,
					'Expires',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$labelSpan(4)
						]),
					_List_Nil,
					A3(
						$author$project$Ui$Form$Accessible$dateInput,
						$author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput),
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(expiresOn)
							]),
						dateInput)),
					A4(
					$author$project$Ui$Form$Accessible$single,
					'Amount',
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$labelSpan(4),
							$author$project$Ui$Form$Accessible$required(true)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Accessible$inputSpan(8)
						]),
					$author$project$Ui$Form$Accessible$currencyInput(
						_List_fromArray(
							[
								$author$project$Ui$Form$CurrencyInput$value(amountInCents),
								$author$project$Ui$Form$CurrencyInput$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated, $author$project$Pages$Patients$PatientId_String$ManageCredits$AmountInCents)),
								$author$project$Ui$Form$CurrencyInput$placeholder('100.00')
							])))
				]));
	});
var $author$project$Ui$Table$Danger = 4;
var $author$project$Pages$Patients$PatientId_String$ManageCredits$EditCredit = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Credit$Shared$balanceInCents = function (_v0) {
	var record = _v0;
	return record.abw;
};
var $author$project$Api$Provider$Credit$All$balanceInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$balanceInCents(shared);
};
var $author$project$Api$Provider$Credit$Shared$expiresSoon = function (_v0) {
	var record = _v0;
	return record.O0;
};
var $author$project$Api$Provider$Credit$All$expiresSoon = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$expiresSoon(shared);
};
var $author$project$Api$Provider$Credit$Shared$isExpired = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Provider$Credit$All$isExpired = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$isExpired(shared);
};
var $author$project$Api$Provider$Credit$Shared$issuedOn = function (_v0) {
	var record = _v0;
	return record.Si;
};
var $author$project$Api$Provider$Credit$All$issuedOn = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$issuedOn(shared);
};
var $author$project$Api$Provider$Credit$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$name(shared);
};
var $author$project$Api$Provider$Credit$Shared$transferredInCents = function (_v0) {
	var record = _v0;
	return record.$5;
};
var $author$project$Api$Provider$Credit$All$transferredInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Credit$Shared$transferredInCents(shared);
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditRow = function (credit) {
	var zeroBalance = !$author$project$Api$Provider$Credit$All$balanceInCents(credit);
	var rowOptions = zeroBalance ? _List_fromArray(
		[
			$author$project$Ui$Table$styled(4)
		]) : _List_Nil;
	var reason = A2(
		$elm$core$Maybe$withDefault,
		'-',
		$author$project$Api$Provider$Credit$All$reason(credit));
	var name = $author$project$Formatters$String$humanize(
		$author$project$Api$Provider$Credit$All$name(credit));
	var issuedOn = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
			$author$project$Api$Provider$Credit$All$issuedOn(credit)));
	var expiresOn = function () {
		var _v0 = $author$project$Api$Provider$Credit$All$expiresOn(credit);
		if (!_v0.$) {
			var expiration = _v0.a;
			return $author$project$Api$Provider$Credit$All$isExpired(credit) ? $elm$html$Html$text('Expired') : ($author$project$Api$Provider$Credit$All$expiresSoon(credit) ? A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$danger]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiration))
					])) : $elm$html$Html$text(
				A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiration)));
		} else {
			return $elm$html$Html$text('Never');
		}
	}();
	var amountLeft = (!$author$project$Api$Provider$Credit$All$amountInCents(credit)) ? $author$project$Api$Provider$Credit$All$transferredInCents(credit) : $author$project$Api$Provider$Credit$All$amountInCents(credit);
	return A2(
		$author$project$Ui$Table$row,
		rowOptions,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(issuedOn)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(0)
							]),
						reason,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Formatters$String$ellipsis, 35, reason))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[expiresOn])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(amountLeft))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Provider$Credit$All$balanceInCents(credit)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_fromArray(
					[$author$project$Ui$Table$textRight]),
				_List_fromArray(
					[
						zeroBalance ? $author$project$Utils$Html$empty : A3(
						$author$project$Ui$Button$view,
						{abp: 'Edit credit'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Patients$PatientId_String$ManageCredits$EditCredit(credit)),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit),
								$author$project$Ui$Button$link
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusFiltered = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel = function (option) {
	switch (option) {
		case 1:
			return 'Applied';
		case 2:
			return 'Outstanding';
		default:
			return 'All Credits';
	}
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusDropdownOptions = function (currentStatusOption) {
	var statusOptionToItem = function (option) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentStatusOption, option)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$Patients$PatientId_String$ManageCredits$StatusFiltered(option))
				]),
			$elm$html$Html$text(
				$author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel(option)));
	};
	return A2(
		$elm$core$List$cons,
		statusOptionToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				statusOptionToItem,
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel(model.ag7))
			]),
		$author$project$Pages$Patients$PatientId_String$ManageCredits$statusDropdownOptions(model.ag7),
		model.oA);
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$view = function (model) {
	var patient = model.VM;
	var credits = model.aY;
	var credit = model.r;
	var patientId = $author$project$Api$Provider$Patient$One$id(patient);
	var _v0 = function () {
		if (credits.$ === 3) {
			var data = credits.a;
			return _Utils_Tuple2(false, data);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var creds = _v0.b;
	return {
		e5: _List_fromArray(
			[
				function () {
				if (!credit.$) {
					var _v3 = credit.a;
					var id = _v3.a;
					var form = _v3.b;
					var credit_ = _v3.c;
					return A4($author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditModal, model.fh, id, form, credit_);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{VN: patientId}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Patient')
													])),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$gray]),
												_List_fromArray(
													[
														$elm$html$Html$text('  /  Manage Credits')
													]))
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Add credit'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$ManageCredits$NewCredit),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add Credit')
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(4)
											]),
										_List_fromArray(
											[
												$author$project$Pages$Patients$PatientId_String$ManageCredits$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(
								_List_fromArray(
									[$author$project$Ui$HorizontalRule$thin])),
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$verticalCentered,
										$author$project$Ui$Table$loading(loading),
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('This patient has no credits. You can add credits by clicking \'Add Credit\' above.')
											]))
									]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											A2(
											$elm$core$List$map,
											$author$project$Api$Column$view(
												A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Pages$Patients$PatientId_String$ManageCredits$SortTable)),
											model.Ll),
											_List_fromArray(
											[
												A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
											])
										])),
								A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditRow, creds),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Patients$PatientId_String$ManageCredits$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.afy))
							]))
					]))
			]),
		$G: 'Patient | Credits'
	};
};
var $author$project$Pages$Patients$PatientId_String$ManageCredits$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$ManageCredits$init, aer: $author$project$Pages$Patients$PatientId_String$ManageCredits$load, agD: $author$project$Pages$Patients$PatientId_String$ManageCredits$save, ahd: $author$project$Pages$Patients$PatientId_String$ManageCredits$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$ManageCredits$update, ahP: $author$project$Pages$Patients$PatientId_String$ManageCredits$view});
var $author$project$Api$Provider$Membership$CoveragePlan = 0;
var $author$project$Components$Membership$Form$GotCancellationReasons = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$GotItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Membership$new = F5(
	function (apiClient, ownerId, companyAccountId, expand, toMsg) {
		var query = A2(
			$elm$core$List$cons,
			A2($author$project$Api$Param$string, 'owner', ownerId),
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Api$Param$list,
					'expand',
					A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand)),
				function () {
					if (!companyAccountId.$) {
						var string = companyAccountId.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'company_account', string)
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				query,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['new']),
						$author$project$Api$Provider$Membership$membershipsPath))));
	});
var $author$project$Components$Membership$Form$retrieveItem = F2(
	function (apiClient, id) {
		return A4(
			$author$project$Api$Provider$Membership$retrieve,
			apiClient,
			id,
			_List_fromArray(
				[0]),
			$author$project$Components$Membership$Form$GotItem);
	});
var $author$project$Components$Membership$Form$init = function (apiClient) {
	return function (timeZone) {
		return function (currentDate) {
			return function (session) {
				return function (practice) {
					return function (hinterViewOff) {
						return function (query) {
							return function (patient) {
								return function (id) {
									return function (currentTime) {
										return function (url) {
											var cmd = function () {
												if (!id.$) {
													var id_ = id.a;
													return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id_);
												} else {
													return A5(
														$author$project$Api$Provider$Membership$new,
														apiClient,
														$author$project$Api$Provider$Patient$One$id(patient),
														A2($elm$core$Dict$get, 'company_account', query),
														_List_fromArray(
															[0]),
														$author$project$Components$Membership$Form$GotItem);
												}
											}();
											return _Utils_Tuple2(
												{
													dv: $elm$core$Maybe$Nothing,
													abO: $author$project$Api$Data$Loading,
													cO: currentDate,
													fm: $elm$core$Maybe$Nothing,
													adN: hinterViewOff,
													adR: id,
													iX: !$author$project$Utils$Maybe$toBool(id),
													ja: $elm$core$Maybe$Nothing,
													gc: $elm$core$Maybe$Nothing,
													VM: patient,
													c6: $elm$core$Maybe$Nothing,
													WF: practice,
													jE: $author$project$Api$Data$NotAsked,
													en: $jinjor$elm_debounce$Debounce$init,
													jN: $elm$core$Maybe$Nothing,
													jS: $elm$core$Maybe$Nothing,
													gz: true,
													jY: $author$project$Api$Data$NotAsked,
													l: $elm$core$Maybe$Nothing,
													ZD: session,
													Hy: A2($author$project$Formatters$Time$init, timeZone, currentTime),
													Hz: timeZone,
													aav: url
												},
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															cmd,
															A4(
															$author$project$Api$CancellationReason$list,
															apiClient,
															session,
															function (d) {
																return _Utils_update(
																	d,
																	{
																		afy: A2($author$project$Api$Pagination$withItemsPerPage, 100, $author$project$Api$Pagination$init)
																	});
															},
															$author$project$Components$Membership$Form$GotCancellationReasons)
														])));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$init = F5(
	function (session, practice, patient, _v0, _v1) {
		var apiClient = _v0.D5;
		var timeZone = _v0.Hz;
		var currentDate = _v0.cO;
		var hinterViewOff = _v0.adN;
		var currentTime = _v0.ack;
		var url = _v0.aav;
		var params = _v1.Vx;
		var query = _v1.Bi;
		var _v2 = $author$project$Components$Membership$Form$init(apiClient)(timeZone)(currentDate)(session)(practice)(hinterViewOff)(query)(patient)(
			$elm$core$Maybe$Just(params.yS))(currentTime)(url);
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			cmd);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Membership$Form$save = F2(
	function (model, shared) {
		var pendingChangesExists = (!model.iX) && (!model.gz);
		return _Utils_update(
			shared,
			{
				afI: pendingChangesExists ? $elm$core$Maybe$Just('You have draft changes to your membership. Are you sure you want to leave?') : $elm$core$Maybe$Nothing
			});
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$save = F2(
	function (_v0, shared) {
		var form = _v0.PB;
		return A2($author$project$Components$Membership$Form$save, form, shared);
	});
var $author$project$Components$Membership$Form$CancelModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Membership$Form$ContractsMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Components$Membership$Form$DeleteHiConfirmClosed = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Components$Membership$Form$MembersMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$PlanChangeMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Components$Membership$Form$RecurringChargesMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Components$Membership$Form$RenewContractModalMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Components$Membership$Form$RestartModalMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Membership$Form$SummaryMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$Close = {$: 1};
var $author$project$Components$Membership$Form$CancelModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$CancelModal$Close);
};
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$subscriptions = F2(
	function (onClose, _v0) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress(
			onClose(false));
	});
var $author$project$Components$Membership$Form$RenewContractModal$Close = {$: 0};
var $author$project$Components$Membership$Form$RenewContractModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RenewContractModal$Close);
};
var $author$project$Components$Membership$Form$RestartModal$Close = {$: 1};
var $author$project$Components$Membership$Form$RestartModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RestartModal$Close);
};
var $author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$Contracts$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Sub$none,
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed),
			A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.e7)));
};
var $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$CreatePatientModal$Close = {$: 0};
var $author$project$Components$CreatePatientModal$PatientFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CreatePatientModal$subscriptions = function (_v0) {
	var form = _v0.PB;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CreatePatientModal$Close),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$CreatePatientModal$PatientFormMsg,
				$author$project$Components$Patient$Form$subscriptions(form))
			]));
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$subscriptions = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2($elm$core$Maybe$map, $author$project$Components$CreatePatientModal$subscriptions, model.h$)));
};
var $author$project$Components$Membership$Form$Sections$Members$subscriptions = function (_v0) {
	var membershipPatients = _v0.TF;
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$map,
			function (_v1) {
				var id = _v1.a;
				var _v2 = _v1.b;
				var membershipPatient = _v2.b;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id),
					$author$project$Components$Membership$Form$Members$MembershipPatient$subscriptions(membershipPatient));
			},
			$elm$core$Dict$toList(membershipPatients)));
};
var $author$project$Components$Membership$Form$Sections$PlanChange$CloseModal = {$: 1};
var $author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v1 = model.PB;
				if (!_v1.$) {
					return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$Sections$PlanChange$CloseModal);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					function (_v2) {
						var membershipId = _v2.a;
						var scheduledChange = _v2.c;
						return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
							A2($author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed, membershipId, scheduledChange));
					},
					model.fm))
			]));
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit = {$: 0};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit);
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$subscriptions = function (_v0) {
	var model = _v0;
	var _v1 = model.fg;
	if (!_v1.$) {
		var createEditModal = _v1.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg,
			$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$subscriptions(createEditModal));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2(
						$elm$core$Maybe$map,
						A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$BrokerDeal$CreateModal$subscriptions),
						model.hY))),
				$author$project$Components$AuditTrailLog$isOpen(model.hy) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg,
				$author$project$Components$AuditTrailLog$subscriptions(model.hy)) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Components$Membership$Form$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				function () {
				var _v0 = model.dv;
				if (!_v0.$) {
					var cancelModal = _v0.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Membership$Form$CancelModalMsg,
						$author$project$Components$Membership$Form$CancelModal$subscriptions(cancelModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v1 = model.jS;
				if (!_v1.$) {
					var restartModal = _v1.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Membership$Form$RestartModalMsg,
						$author$project$Components$Membership$Form$RestartModal$subscriptions(restartModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v2 = model.gc;
				if (!_v2.$) {
					var _v3 = _v2.a;
					var outsideAgeRangeModal = _v3.a;
					return A2($author$project$Components$Membership$Form$OutsideAgeRangeModal$subscriptions, $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed, outsideAgeRangeModal);
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v4 = model.l;
				if (!_v4.$) {
					var sections = _v4.a;
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$SummaryMsg,
								$author$project$Components$Membership$Form$Sections$Summary$subscriptions(sections._9)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$MembersMsg,
								$author$project$Components$Membership$Form$Sections$Members$subscriptions(sections.B)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$RecurringChargesMsg,
								$author$project$Components$Membership$Form$Sections$RecurringCharges$subscriptions(sections.XZ)),
								A2(
								$elm$core$Platform$Sub$map,
								$author$project$Components$Membership$Form$ContractsMsg,
								$author$project$Components$Membership$Form$Sections$Contracts$subscriptions(sections.aC)),
								function () {
								var _v5 = sections.ju;
								if (!_v5.$) {
									var planChange = _v5.a;
									return A2(
										$elm$core$Platform$Sub$map,
										$author$project$Components$Membership$Form$PlanChangeMsg,
										$author$project$Components$Membership$Form$Sections$PlanChange$subscriptions(planChange));
								} else {
									return $elm$core$Platform$Sub$none;
								}
							}()
							]));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				function () {
				var _v6 = model.jN;
				if (!_v6.$) {
					var renewContractModal = _v6.a;
					return A2(
						$elm$core$Platform$Sub$map,
						$author$project$Components$Membership$Form$RenewContractModalMsg,
						$author$project$Components$Membership$Form$RenewContractModal$subscriptions(renewContractModal));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Membership$Form$DeleteHiConfirmClosed),
					A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fm)))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$subscriptions = function (model) {
	return $author$project$Components$Membership$Form$subscriptions(model.PB);
};
var $author$project$Components$Membership$Form$BillsOverviewMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Components$Membership$Form$Confirmed = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Membership$Form$Contract = {$: 3};
var $author$project$Components$Membership$Form$Deleted = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Members = {$: 1};
var $author$project$Components$Membership$Form$Pricing = {$: 2};
var $author$project$Components$Membership$Form$PricingMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges = {$: 4};
var $author$project$Components$Membership$Form$Summary = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Membership$confirm = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['confirm']),
					$author$project$Api$Provider$Membership$membershipPath(id))));
	});
var $author$project$Components$Membership$Form$PriceCheckDebounced = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$debouncePriceCheck = function (cmd) {
	return A2(
		$elm$core$Task$perform,
		$author$project$Components$Membership$Form$PriceCheckDebounced,
		$elm$core$Task$succeed(cmd));
};
var $author$project$Api$Provider$Membership$delete = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Membership$membershipPath(id)));
	});
var $author$project$Api$Provider$MembershipContract$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Components$Membership$Form$CancelModal$EndDateInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Meta$endDateDefaultValue = function (_v0) {
	var meta = _v0;
	return meta.qs.Nm;
};
var $author$project$Api$Provider$Membership$One$meta = function (_v0) {
	var record = _v0.b;
	return record.TU;
};
var $author$project$Components$Membership$Form$CancelModal$initFormFields = function (membership) {
	return {
		abM: $elm$core$Maybe$Nothing,
		abN: $elm$core$Maybe$Nothing,
		qs: $author$project$Api$Provider$Membership$Meta$endDateDefaultValue(
			$author$project$Api$Provider$Membership$One$meta(membership))
	};
};
var $author$project$Components$Membership$Form$CancelModal$init = F2(
	function (currentDate, membership) {
		var fields = $author$project$Components$Membership$Form$CancelModal$initFormFields(membership);
		var _v0 = $author$project$Components$DateInput$init;
		var endDateInput = _v0.a;
		var endDateInputCmd = _v0.b;
		return _Utils_Tuple2(
			{
				e7: $author$project$Api$Data$NotAsked,
				cO: currentDate,
				qu: endDateInput,
				PB: $author$project$Utils$Form$init(fields),
				ja: membership
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModal$EndDateInputMsg, endDateInputCmd));
	});
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$init = F4(
	function (minimumAge, maximumAge, belowAgePatients, aboveAgePatients) {
		return {tD: aboveAgePatients, vF: belowAgePatients, Tu: maximumAge, T1: minimumAge};
	});
var $author$project$Components$Membership$Form$RenewContractModal$init = F2(
	function (membershipId, lastContractEndDate) {
		return {FX: lastContractEndDate, yS: membershipId, aeC: $elm$core$Maybe$Nothing, nY: $author$project$Api$Data$NotAsked};
	});
var $author$project$Components$Membership$Form$RestartModal$GotPriceCheck = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Membership$restart = F5(
	function (apiClient, id, priceCheck, nextBillDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						priceCheck ? _List_fromArray(
						[
							_Utils_Tuple2(
							'check_price',
							$elm$json$Json$Encode$bool(true))
						]) : _List_Nil,
						_List_fromArray(
						[
							_Utils_Tuple2(
							'next_bill_date',
							A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, nextBillDate))
						])
					])));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['restart']),
						$author$project$Api$Provider$Membership$membershipPath(id)))));
	});
var $author$project$Components$Membership$Form$RestartModal$init = F4(
	function (apiClient, currentDate, nextBillDate, membership) {
		var dateInput = $author$project$Components$DateInput$initFromDate(
			A2($elm$core$Maybe$withDefault, currentDate, nextBillDate));
		return _Utils_Tuple2(
			{cO: currentDate, qd: dateInput, ja: membership, UC: $elm$core$Maybe$Nothing, c6: $elm$core$Maybe$Nothing, ss: $author$project$Api$Data$NotAsked},
			A5(
				$author$project$Api$Provider$Membership$restart,
				apiClient,
				$author$project$Api$Provider$Membership$One$id(membership),
				true,
				nextBillDate,
				$author$project$Components$Membership$Form$RestartModal$GotPriceCheck));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$fixedPeriodRateInCentsEdited = function (_v0) {
	var form = _v0.PB;
	var _v1 = $author$project$Utils$Form$fields(form);
	var manuallySet = _v1.cb;
	return manuallySet.XJ;
};
var $elm_community$list_extra$List$Extra$count = function (predicate) {
	return A2(
		$elm$core$List$foldl,
		F2(
			function (x, acc) {
				return predicate(x) ? (acc + 1) : acc;
			}),
		0);
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$fixedPeriodRateInCentsEdited = function (_v0) {
	var editFixedPeriodRateInCents = _v0.dZ;
	return editFixedPeriodRateInCents;
};
var $author$project$Components$Membership$Form$Sections$Members$fixedPeriodRateInCentsEditedCount = function (_v0) {
	var membershipPatients = _v0.TF;
	return A2(
		$elm_community$list_extra$List$Extra$count,
		$author$project$Components$Membership$Form$Members$MembershipPatient$fixedPeriodRateInCentsEdited,
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			$elm$core$Dict$values(membershipPatients)));
};
var $author$project$Components$Membership$Form$Sections$Members$membersFields = function (_v0) {
	var membershipPatients = _v0.TF;
	return membershipPatients;
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields = function (_v0) {
	var form = _v0.PB;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Membership$Form$initSectionsShared = F5(
	function (patient, membership, pendingMembership, sections, model) {
		var _v0 = sections;
		var pricing = _v0.cl;
		var members = _v0.B;
		var patients = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.VM;
			},
			A2(
				$elm$core$List$map,
				$author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields,
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					A2(
						$elm$core$List$sortBy,
						$elm$core$Tuple$first,
						$elm$core$Dict$values(
							$author$project$Components$Membership$Form$Sections$Members$membersFields(members))))));
		var fixedPeriodRateInCentsEditedCount = $author$project$Components$Membership$Form$Sections$Members$fixedPeriodRateInCentsEditedCount(members) + ($author$project$Components$Membership$Form$Sections$Pricing$fixedPeriodRateInCentsEdited(pricing) ? 1 : 0);
		var onlyOneFixedPeriodRateInCentsEditable = _Utils_eq(
			fixedPeriodRateInCentsEditedCount,
			$elm$core$List$length(patients));
		return {
			iX: model.iX,
			ja: membership,
			afr: onlyOneFixedPeriodRateInCentsEditable,
			Vp: patient,
			Ap: patients,
			c6: pendingMembership,
			afW: _Utils_eq(model.jE, $author$project$Api$Data$Loading),
			gz: model.gz
		};
	});
var $author$project$Components$Membership$Form$patientsOutsideAgeRange = F2(
	function (plan, sections) {
		var patients = A2(
			$elm$core$List$filterMap,
			function ($) {
				return $.VM;
			},
			A2(
				$elm$core$List$map,
				$author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields,
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$second,
					$elm$core$Dict$values(
						$author$project$Components$Membership$Form$Sections$Members$membersFields(sections.B)))));
		var belowAgePatients = A2(
			$elm$core$List$filter,
			function (patient) {
				var _v1 = _Utils_Tuple2(
					$author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan),
					patient.IK);
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var minimumAge = _v1.a.a;
					var age = _v1.b.a;
					return _Utils_cmp(age, minimumAge) < 0;
				} else {
					return false;
				}
			},
			patients);
		var aboveAgePatients = A2(
			$elm$core$List$filter,
			function (patient) {
				var _v0 = _Utils_Tuple2(
					$author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan),
					patient.IK);
				if ((!_v0.a.$) && (!_v0.b.$)) {
					var maximumAge = _v0.a.a;
					var age = _v0.b.a;
					return _Utils_cmp(age, maximumAge) > 0;
				} else {
					return false;
				}
			},
			patients);
		return _Utils_Tuple2(belowAgePatients, aboveAgePatients);
	});
var $author$project$Components$Membership$Form$PriceCheckDebouncedMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$priceCheckDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(1000),
	ahG: $author$project$Components$Membership$Form$PriceCheckDebouncedMsg
};
var $author$project$Api$Provider$Membership$CompanyAccount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Membership$AutoRenew = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Membership$BillDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Membership$ContractEndDate = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Provider$Membership$ContractExpires = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Provider$Membership$ContractPeriodInMonths = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Provider$Membership$ContractType = function (a) {
	return {$: 15, a: a};
};
var $author$project$Api$Provider$Membership$Coupon = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Membership$FixedPeriodRateInCents = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Membership$FixedRegistrationFeeInCents = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Provider$Membership$MinimumEnrollmentPeriodInMonths = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Membership$NextBillDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Membership$Owner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Membership$PaymentSource = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$Membership$PeriodInMonths = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Membership$Plan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Membership$RecurringCharges = function (a) {
	return {$: 16, a: a};
};
var $author$project$Api$Provider$Membership$StartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$Meta$autoRenewEditable = function (_v0) {
	var meta = _v0;
	return meta.JH.Oa;
};
var $author$project$Api$Provider$Membership$Meta$billDateEditable = function (_v0) {
	var meta = _v0;
	return meta.vG.Oa;
};
var $author$project$Api$Provider$Membership$Meta$contractEndDateEditable = function (_v0) {
	var meta = _v0;
	return meta.wO.Oa;
};
var $author$project$Api$Provider$Membership$Meta$contractExpiresEditable = function (_v0) {
	var meta = _v0;
	return meta.LP.Oa;
};
var $author$project$Components$Membership$Form$Sections$Contracts$contractFields = function (_v0) {
	var form = _v0.PB;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable = function (_v0) {
	var meta = _v0;
	return meta.LQ.Oa;
};
var $author$project$Api$Provider$Membership$Meta$contractTypeEditable = function (_v0) {
	var meta = _v0;
	return meta.EI.Oa;
};
var $author$project$Api$Provider$Membership$Meta$couponEditable = function (_v0) {
	var meta = _v0;
	return meta.L1.Oa;
};
var $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable = function (_v0) {
	var meta = _v0;
	return meta.Pw.Oa;
};
var $author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable = function (_v0) {
	var meta = _v0;
	return meta.Px.Oa;
};
var $author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable = function (_v0) {
	var meta = _v0;
	return meta.T3.Oa;
};
var $author$project$Api$Provider$Membership$Meta$nextBillDateEditable = function (_v0) {
	var meta = _v0;
	return meta.UC.Oa;
};
var $author$project$Api$Provider$Membership$Meta$ownerEditable = function (_v0) {
	var meta = _v0;
	return meta.Vp.Oa;
};
var $author$project$Api$Provider$Membership$Meta$paymentSourceEditable = function (_v0) {
	var meta = _v0;
	return meta.V3.Oa;
};
var $author$project$Api$Provider$Membership$Meta$periodInMonthsEditable = function (_v0) {
	var meta = _v0;
	return meta.Wc.Oa;
};
var $author$project$Api$Provider$Membership$Meta$planEditable = function (_v0) {
	var meta = _v0;
	return meta.GH.Oa;
};
var $author$project$Components$Membership$Form$Sections$Pricing$pricingFields = function (_v0) {
	var form = _v0.PB;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Api$Provider$Membership$Meta$recurringChargesEditable = function (_v0) {
	var meta = _v0;
	return meta.XZ.Oa;
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$recurringChargesFields = function (_v0) {
	var form = _v0.PB;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Api$Provider$Membership$Meta$startDateEditable = function (_v0) {
	var meta = _v0;
	return meta._E.Oa;
};
var $author$project$Components$Membership$Form$Sections$Summary$summaryFields = function (_v0) {
	var form = _v0.PB;
	return $author$project$Utils$Form$fields(form);
};
var $author$project$Components$Membership$Form$apiFields = F2(
	function (membership, sections) {
		var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections._9);
		var recurringCharges = $author$project$Components$Membership$Form$Sections$RecurringCharges$recurringChargesFields(sections.XZ);
		var pricing = $author$project$Components$Membership$Form$Sections$Pricing$pricingFields(sections.cl);
		var meta = $author$project$Api$Provider$Membership$One$meta(membership);
		var membershipPatients = $author$project$Components$Membership$Form$Sections$Members$membersFields(sections.B);
		var contract = $author$project$Components$Membership$Form$Sections$Contracts$contractFields(sections.aC);
		return _Utils_Tuple2(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$filter,
					$elm$core$Tuple$second,
					_List_fromArray(
						[
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$Owner(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.adR;
									},
									summary.Vp)),
							$author$project$Api$Provider$Membership$Meta$ownerEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$Plan(
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.adR;
									},
									summary.GH)),
							$author$project$Api$Provider$Membership$Meta$planEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$StartDate(summary._E),
							$author$project$Api$Provider$Membership$Meta$startDateEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$BillDate(summary.vG),
							$author$project$Api$Provider$Membership$Meta$billDateEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$NextBillDate(summary.UC),
							$author$project$Api$Provider$Membership$Meta$nextBillDateEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$AutoRenew(summary.JH),
							$author$project$Api$Provider$Membership$Meta$autoRenewEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$PeriodInMonths(summary.Wc),
							$author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$MinimumEnrollmentPeriodInMonths(summary.T3),
							$author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$FixedPeriodRateInCents(pricing.Pw),
							$author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$Coupon(pricing.L1),
							$author$project$Api$Provider$Membership$Meta$couponEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$FixedRegistrationFeeInCents(pricing.Px),
							$author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$PaymentSource(pricing.V3),
							$author$project$Utils$Maybe$toBool(pricing.V3) && $author$project$Api$Provider$Membership$Meta$paymentSourceEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$ContractEndDate(contract.qs),
							$author$project$Api$Provider$Membership$Meta$contractEndDateEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$ContractExpires(contract.OY),
							$author$project$Api$Provider$Membership$Meta$contractExpiresEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$ContractPeriodInMonths(contract.Wc),
							$author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$ContractType(contract.ahI),
							$author$project$Api$Provider$Membership$Meta$contractTypeEditable(meta)),
							_Utils_Tuple2(
							$author$project$Api$Provider$Membership$RecurringCharges(
								A2(
									$elm$core$List$map,
									function (recurringCharge) {
										return {
											lp: recurringCharge.lp.adR,
											ads: recurringCharge.ads,
											adt: recurringCharge.adt,
											adR: recurringCharge.adR,
											VM: A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.adR;
												},
												recurringCharge.VM),
											Wc: recurringCharge.Wc,
											afL: recurringCharge.afL,
											afS: A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.adR;
												},
												recurringCharge.afS),
											Bd: recurringCharge.Bd
										};
									},
									recurringCharges.XZ)),
							$author$project$Api$Provider$Membership$Meta$recurringChargesEditable(meta))
						]))),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var membershipPatient = _v0.b;
					var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
					return {
						DV: membershipPatientRecord.DV,
						abM: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							membershipPatientRecord.abM),
						abN: membershipPatientRecord.abN,
						qs: membershipPatientRecord.qs,
						OH: membershipPatientRecord.OH,
						Pw: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, membershipPatientRecord.Pw),
						adR: membershipPatientRecord.adR,
						TB: membershipPatientRecord.TB,
						VM: A2(
							$elm$core$Maybe$map,
							function (patient) {
								return {adR: patient.adR, aaI: patient.aaI};
							},
							membershipPatientRecord.VM),
						_n: membershipPatientRecord._n,
						_E: membershipPatientRecord._E
					};
				},
				$elm$core$Dict$values(membershipPatients)));
	});
var $author$project$Components$Membership$Form$Created = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Membership$encodePaymentSource = function (maybePaymentSource) {
	if (!maybePaymentSource.$) {
		var paymentSource = maybePaymentSource.a;
		var _v1 = paymentSource.adR;
		if (!_v1.$) {
			var id_ = _v1.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$string(id_))
					]));
		} else {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2('id', $elm$json$Json$Encode$null)
					]));
		}
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Api$Provider$Membership$encodeRecurringCharge = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adR)),
				_Utils_Tuple2(
				'fixed_price_in_cents',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.adt)),
				_Utils_Tuple2(
				'fixed_description',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ads)),
				_Utils_Tuple2(
				'quantity',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Bd)),
				_Utils_Tuple2(
				'periods_remaining',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.afL)),
				_Utils_Tuple2(
				'period_in_months',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Wc)),
				_Utils_Tuple2(
				'charge_item',
				$author$project$Utils$Encode$association(fields.lp)),
				_Utils_Tuple2(
				'patient',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.VM)),
				_Utils_Tuple2(
				'practitioner',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.afS))
			]));
};
var $author$project$Api$Provider$Membership$encodeMembershipField = function (field) {
	switch (field.$) {
		case 0:
			var owner = field.a;
			return _Utils_Tuple2(
				'owner',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, owner));
		case 1:
			var plan = field.a;
			return _Utils_Tuple2(
				'plan',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, plan));
		case 2:
			var companyAccount = field.a;
			return _Utils_Tuple2(
				'company_account',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, companyAccount));
		case 3:
			var startDate = field.a;
			return _Utils_Tuple2(
				'start_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, startDate));
		case 4:
			var billDate = field.a;
			return _Utils_Tuple2(
				'bill_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, billDate));
		case 5:
			var nextBillDate = field.a;
			return _Utils_Tuple2(
				'next_bill_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, nextBillDate));
		case 6:
			var autoRenew = field.a;
			return _Utils_Tuple2(
				'auto_renew',
				$elm$json$Json$Encode$bool(autoRenew));
		case 7:
			var periodInMonths = field.a;
			return _Utils_Tuple2(
				'period_in_months',
				$elm$json$Json$Encode$int(periodInMonths));
		case 8:
			var minimumEnrollmentPeriodInMonths = field.a;
			return _Utils_Tuple2(
				'minimum_enrollment_period_in_months',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, minimumEnrollmentPeriodInMonths));
		case 9:
			var fixedPeriodRateInCents = field.a;
			return _Utils_Tuple2(
				'fixed_period_rate_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fixedPeriodRateInCents));
		case 10:
			var coupon = field.a;
			return _Utils_Tuple2(
				'coupon',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, coupon));
		case 11:
			var fixedRegistrationFeeInCents = field.a;
			return _Utils_Tuple2(
				'fixed_registration_fee_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fixedRegistrationFeeInCents));
		case 12:
			var contractEndDate = field.a;
			return _Utils_Tuple2(
				'contract_end_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, contractEndDate));
		case 13:
			var contractExpires = field.a;
			return _Utils_Tuple2(
				'contract_expires',
				$elm$json$Json$Encode$bool(contractExpires));
		case 14:
			var contractPeriodInMonths = field.a;
			return _Utils_Tuple2(
				'contract_period_in_months',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, contractPeriodInMonths));
		case 15:
			var contractType = field.a;
			return _Utils_Tuple2(
				'contract_type',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$ContractType$encode, contractType));
		case 16:
			var recurringCharges = field.a;
			return _Utils_Tuple2(
				'recurring_charges',
				A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Membership$encodeRecurringCharge, recurringCharges));
		default:
			var maybePaymentSource = field.a;
			return _Utils_Tuple2(
				'payment_source',
				$author$project$Api$Provider$Membership$encodePaymentSource(maybePaymentSource));
	}
};
var $author$project$Api$MemberRelationship$encode = function (memberRelationship) {
	switch (memberRelationship) {
		case 0:
			return $elm$json$Json$Encode$string('employee');
		case 1:
			return $elm$json$Json$Encode$string('spouse');
		case 2:
			return $elm$json$Json$Encode$string('child');
		default:
			return $elm$json$Json$Encode$string('other');
	}
};
var $author$project$Api$Provider$Membership$encodePatient = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(fields.adR)),
				_Utils_Tuple2(
				'uses_tobacco',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.aaI))
			]));
};
var $author$project$Api$Provider$Membership$encodeMembershipPatient = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(fields.adR)),
				_Utils_Tuple2(
				'member_type',
				$author$project$Api$MemberRelationship$encode(fields.TB)),
				_Utils_Tuple2(
				'patient',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Membership$encodePatient, fields.VM)),
				_Utils_Tuple2(
				'enrollment_requested_on',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.OH)),
				_Utils_Tuple2(
				'start_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields._E)),
				_Utils_Tuple2(
				'end_date',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qs)),
				_Utils_Tuple2(
				'fixed_period_rate_in_cents',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Pw)),
				_Utils_Tuple2(
				'special_rate',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields._n)),
				_Utils_Tuple2(
				'cancellation_reason',
				A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.abM)),
				_Utils_Tuple2(
				'cancellation_reason_other',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abN)),
				_Utils_Tuple2(
				'_action',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.DV))
			]));
};
var $author$project$Api$Provider$Membership$encodeMembership = F2(
	function (fields, membershipPatients) {
		return $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'membership_patients',
					A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Membership$encodeMembershipPatient, membershipPatients)),
				A2($elm$core$List$map, $author$project$Api$Provider$Membership$encodeMembershipField, fields)));
	});
var $author$project$Api$Provider$Membership$create = F7(
	function (apiClient, fields, membershipPatients, priceCheck, expand, billNow, toMsg) {
		var body = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'membership',
							A2($author$project$Api$Provider$Membership$encodeMembership, fields, membershipPatients))
						]),
						priceCheck ? _List_fromArray(
						[
							_Utils_Tuple2(
							'check_price',
							$elm$json$Json$Encode$bool(true))
						]) : _List_Nil,
						billNow ? _List_fromArray(
						[
							_Utils_Tuple2(
							'create_and_bill_now',
							$elm$json$Json$Encode$bool(true))
						]) : _List_Nil
					])));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2(
							$author$project$Api$Param$list,
							'expand',
							A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
						]),
					$author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipsPath))));
	});
var $author$project$Components$Membership$Form$createItem = F4(
	function (apiClient, membershipApiFields, membershipPatientsApiFields, billNow) {
		return A7(
			$author$project$Api$Provider$Membership$create,
			apiClient,
			membershipApiFields,
			membershipPatientsApiFields,
			false,
			_List_fromArray(
				[0]),
			billNow,
			$author$project$Components$Membership$Form$Created);
	});
var $author$project$Components$Membership$Form$Updated = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Membership$update = F7(
	function (apiClient, id, fields, membershipPatients, priceCheck, expand, toMsg) {
		var body = $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'membership',
							A2($author$project$Api$Provider$Membership$encodeMembership, fields, membershipPatients))
						]),
						priceCheck ? _List_fromArray(
						[
							_Utils_Tuple2(
							'check_price',
							$elm$json$Json$Encode$bool(true))
						]) : _List_Nil
					])));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				A2(
					$author$project$Api$Data$requestWithQuery,
					_List_fromArray(
						[
							A2(
							$author$project$Api$Param$list,
							'expand',
							A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
						]),
					$author$project$Api$Data$requestTo(
						$author$project$Api$Provider$Membership$membershipPath(id)))));
	});
var $author$project$Components$Membership$Form$updateItem = F4(
	function (apiClient, id, membershipApiFields, membershipPatientsApiFields) {
		return A7(
			$author$project$Api$Provider$Membership$update,
			apiClient,
			id,
			membershipApiFields,
			membershipPatientsApiFields,
			false,
			_List_fromArray(
				[0]),
			$author$project$Components$Membership$Form$Updated);
	});
var $author$project$Components$Membership$Form$saveItem = F5(
	function (apiClient, maybeId, membership, sections, billNow) {
		var _v0 = A2($author$project$Components$Membership$Form$apiFields, membership, sections);
		var membershipApiFields = _v0.a;
		var membershipPatientsApiFields = _v0.b;
		if (!maybeId.$) {
			var id_ = maybeId.a;
			return A4($author$project$Components$Membership$Form$updateItem, apiClient, id_, membershipApiFields, membershipPatientsApiFields);
		} else {
			var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections._9);
			return A4(
				$author$project$Components$Membership$Form$createItem,
				apiClient,
				A2(
					$elm$core$List$cons,
					$author$project$Api$Provider$Membership$CompanyAccount(summary.Lr),
					membershipApiFields),
				membershipPatientsApiFields,
				billNow);
		}
	});
var $author$project$Api$Provider$Membership$Shared$isUpdatable = function (_v0) {
	var record = _v0;
	return record.Sf;
};
var $author$project$Api$Provider$Membership$One$isUpdatable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$isUpdatable(shared);
};
var $author$project$Components$Membership$Form$GotPriceCheck = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$priceCheck = F4(
	function (apiClient, membership, sections, model) {
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			function (membershipPatients) {
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.VM;
						},
						$author$project$Utils$Maybe$toBool),
					membershipPatients);
			},
			A2($author$project$Components$Membership$Form$apiFields, membership, sections));
		var membershipApiFields = _v0.a;
		var membershipPatientsApiFields = _v0.b;
		var _v1 = model.adR;
		if (!_v1.$) {
			var id = _v1.a;
			return A7(
				$author$project$Api$Provider$Membership$update,
				apiClient,
				id,
				membershipApiFields,
				membershipPatientsApiFields,
				true,
				_List_fromArray(
					[0]),
				$author$project$Components$Membership$Form$GotPriceCheck);
		} else {
			var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections._9);
			return A7(
				$author$project$Api$Provider$Membership$create,
				apiClient,
				A2(
					$elm$core$List$cons,
					$author$project$Api$Provider$Membership$CompanyAccount(summary.Lr),
					membershipApiFields),
				membershipPatientsApiFields,
				true,
				_List_fromArray(
					[0]),
				false,
				$author$project$Components$Membership$Form$GotPriceCheck);
		}
	});
var $author$project$Components$Membership$Form$validPriceCheckFields = function (sections) {
	var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections._9);
	var membershipPatients = $author$project$Components$Membership$Form$Sections$Members$membersFields(sections.B);
	var contract = $author$project$Components$Membership$Form$Sections$Contracts$contractFields(sections.aC);
	return (!$elm$core$Dict$isEmpty(membershipPatients)) && ($author$project$Utils$Maybe$toBool(summary.GH) && ((!contract.OY) || ($author$project$Utils$Maybe$toBool(contract.Wc) && $author$project$Utils$Maybe$toBool(contract.ahI))));
};
var $author$project$Components$Membership$Form$checkPrice = F4(
	function (apiClient, membership, newSections, model) {
		var shouldCheckPrice = $author$project$Api$Provider$Membership$One$isUpdatable(membership) && $author$project$Components$Membership$Form$validPriceCheckFields(newSections);
		var _v0 = shouldCheckPrice ? A3(
			$jinjor$elm_debounce$Debounce$push,
			$author$project$Components$Membership$Form$priceCheckDebounceConfig,
			A4($author$project$Components$Membership$Form$priceCheck, apiClient, membership, newSections, model),
			model.en) : _Utils_Tuple2(model.en, $elm$core$Platform$Cmd$none);
		var newDebouncer = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			shouldCheckPrice ? _Utils_update(
				model,
				{jE: $author$project$Api$Data$Loading, en: newDebouncer}) : ((!$author$project$Components$Membership$Form$validPriceCheckFields(newSections)) ? _Utils_update(
				model,
				{jE: $author$project$Api$Data$NotAsked, en: newDebouncer}) : _Utils_update(
				model,
				{en: newDebouncer})),
			cmd);
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$init = F2(
	function (currentDate, membershipId) {
		return {lb: $author$project$Api$Data$NotAsked, cO: currentDate, yS: membershipId};
	});
var $author$project$Components$Membership$Form$initBillsOverview = F2(
	function (membership, model) {
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Membership$Form$Sections$BillsOverview$init,
				model.cO,
				$author$project$Api$Provider$Membership$One$id(membership)),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Membership$Form$Sections$Contracts$GotMembershipContracts = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$Shared$contractEndDate = function (_v0) {
	var record = _v0;
	return record.wO;
};
var $author$project$Api$Provider$Membership$One$contractEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$contractEndDate(shared);
};
var $author$project$Api$Provider$Membership$Shared$contractExpires = function (_v0) {
	var record = _v0;
	return record.LP;
};
var $author$project$Api$Provider$Membership$One$contractExpires = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$contractExpires(shared);
};
var $author$project$Api$Provider$Membership$One$contractPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.LQ;
};
var $author$project$Api$Provider$Membership$Shared$contractType = function (_v0) {
	var record = _v0;
	return record.EI;
};
var $author$project$Api$Provider$Membership$One$contractType = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$contractType(shared);
};
var $author$project$Components$Membership$Form$Sections$Contracts$initFormFields = function (membership) {
	return {
		qs: $author$project$Api$Provider$Membership$One$contractEndDate(membership),
		OY: $author$project$Api$Provider$Membership$One$contractExpires(membership),
		Wc: $author$project$Api$Provider$Membership$One$contractPeriodInMonths(membership),
		ahI: $author$project$Api$Provider$Membership$One$contractType(membership)
	};
};
var $author$project$Api$Provider$MembershipContract$All$MembershipContract = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipContract$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipContract$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath = function (membershipId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['contracts']),
		$author$project$Api$Provider$Membership$membershipPath(membershipId));
};
var $author$project$Api$Provider$Membership$MembershipContract$list = F3(
	function (apiClient, membershipId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipContract$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId)));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$init = F3(
	function (apiClient, isNew, membership) {
		var formFields = $author$project$Components$Membership$Form$Sections$Contracts$initFormFields(membership);
		var _v0 = (!isNew) ? _Utils_Tuple2(
			$author$project$Api$Data$Loading,
			A3(
				$author$project$Api$Provider$Membership$MembershipContract$list,
				apiClient,
				$author$project$Api$Provider$Membership$One$id(membership),
				$author$project$Components$Membership$Form$Sections$Contracts$GotMembershipContracts)) : _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
		var membershipContracts = _v0.a;
		var membershipContractsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				e7: $elm$core$Maybe$Nothing,
				is: false,
				PB: $author$project$Utils$Form$init(formFields),
				ja: membership,
				yR: membershipContracts,
				sI: false
			},
			membershipContractsCmd);
	});
var $author$project$Components$Membership$Form$initContracts = F3(
	function (apiClient, membership, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$ContractsMsg),
			A3($author$project$Components$Membership$Form$Sections$Contracts$init, apiClient, model.iX, membership));
	});
var $author$project$Components$Membership$Form$Sections$Members$GotNewMembershipPatient = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $author$project$Api$Provider$MembershipPatient$New$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$MembershipPatient$New$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$MembershipPatient$New$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$New$Record));
var $author$project$Api$Provider$MembershipPatient$New$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$New$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$MembershipPatient$membershipPatientsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['membership_patients']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$MembershipPatient$build = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$MembershipPatient$New$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['build']),
					$author$project$Api$Provider$MembershipPatient$membershipPatientsPath)));
	});
var $author$project$Components$Membership$Form$Sections$Members$addMember = F4(
	function (apiClient, memberType, patient, startDate) {
		return A2(
			$author$project$Api$Provider$MembershipPatient$build,
			apiClient,
			A3($author$project$Components$Membership$Form$Sections$Members$GotNewMembershipPatient, memberType, patient, startDate));
	});
var $author$project$Api$Provider$Membership$One$billedThroughDate = function (_v0) {
	var record = _v0.b;
	return record.JY;
};
var $author$project$Api$Provider$Membership$One$companyAccount = function (_v0) {
	var record = _v0.b;
	return record.Lr;
};
var $author$project$Api$Provider$MembershipPatient$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$id(shared);
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$initPatientResourceFilter = F2(
	function (apiClient, patient) {
		return function (_v0) {
			var patientResourceFilter = _v0.a;
			var patientResourceFilterCmd = _v0.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(patientResourceFilter, patientResourceFilterCmd),
				A2(
					$elm$core$Maybe$map,
					function (patient_) {
						var _v1 = A2(
							$author$project$Components$ResourceFilter$Patient$preSelectedId,
							$elm$core$Maybe$Just(patient_.adR),
							patientResourceFilter);
						var withPreSelectedModel = _v1.a;
						var withPreSelectedCmd = _v1.b;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$ResourceFilter$Patient$extraItems,
								_List_fromArray(
									[
										{IK: patient_.IK, adR: patient_.adR, TL: patient_.TL, zh: patient_.zh}
									]),
								withPreSelectedModel),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[withPreSelectedCmd, patientResourceFilterCmd])));
					},
					patient));
		}(
			A2(
				$author$project$Components$ResourceFilter$Patient$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'Select a Patient', IS: true});
				}));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$init = F9(
	function (apiClient, currentDate, session, practice, hinterViewOff, isNew, originalPatient, originalMembershipPatient, formFields) {
		var _v0 = A2($author$project$Components$Membership$Form$Members$MembershipPatient$initPatientResourceFilter, apiClient, formFields.VM);
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				h$: $elm$core$Maybe$Nothing,
				cO: currentDate,
				qm: false,
				dZ: $author$project$Utils$Maybe$toBool(formFields.Pw),
				qn: false,
				d_: function () {
					if (!originalPatient.$) {
						var originalPatient_ = originalPatient.a;
						return _Utils_eq(originalPatient_.aaI, $elm$core$Maybe$Nothing);
					} else {
						return false;
					}
				}(),
				qu: $author$project$Components$DateInput$initFromDate(currentDate),
				qy: $author$project$Components$DateInput$initFromDate(currentDate),
				PB: $author$project$Utils$Form$init(formFields),
				adN: hinterViewOff,
				iX: isNew,
				eb: $author$project$Utils$Maybe$toBool(formFields._n),
				Gu: originalMembershipPatient,
				Gw: formFields,
				Vh: originalPatient,
				rU: patientResourceFilter,
				WF: practice,
				aN: false,
				ZD: session,
				kg: $author$project$Components$DateInput$initFromDate(currentDate)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg, patientResourceFilterCmd));
	});
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason = function (_v0) {
	var record = _v0.b;
	return record.abM;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReasonOther = function (_v0) {
	var record = _v0.b;
	return record.abN;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$companyRegistration = function (_v0) {
	var record = _v0.b;
	return record.Ly;
};
var $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate = function (_v0) {
	var record = _v0;
	return record.Oe;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$effectiveEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate(shared);
};
var $author$project$Api$Provider$MembershipPatient$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$endDate(shared);
};
var $author$project$Api$Provider$MembershipPatient$Shared$enrollmentRequestedOn = function (_v0) {
	var record = _v0;
	return record.OH;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$enrollmentRequestedOn(shared);
};
var $author$project$Api$Provider$MembershipPatient$Shared$firstBillStartDate = function (_v0) {
	var record = _v0;
	return record.Ps;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$firstBillStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$firstBillStartDate(shared);
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents = function (_v0) {
	var record = _v0.b;
	return record.Pw;
};
var $author$project$Components$CancellationReason$CancellationReasonRecord$fromShared = function (cancellationReason) {
	return {
		Nx: $author$project$Api$Provider$CancellationReason$Shared$description(cancellationReason),
		adR: $author$project$Api$Provider$CancellationReason$Shared$id(cancellationReason)
	};
};
var $author$project$Api$Provider$SpecialRate$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType = function (_v0) {
	var record = _v0.b;
	return record.TB;
};
var $author$project$Api$Provider$CompanyRegistration$Meta$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation = function (patient) {
	return {
		IK: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient),
		adR: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient),
		aet: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$locationFromMin,
			$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient)),
		TL: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient),
		zh: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient),
		afS: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$practitionerFromMin,
			$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient)),
		aaI: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient)
	};
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate = function (_v0) {
	var record = _v0.b;
	return record._n;
};
var $author$project$Api$Provider$MembershipPatient$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$startDate(shared);
};
var $author$project$Components$Membership$Form$Records$membershipPatientFromOne = function (membershipPatient) {
	var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
	var companyRegistration = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$companyRegistration(membershipPatient);
	var companyRegistrationRecord = A2(
		$elm$core$Maybe$map,
		function (companyRegistration_) {
			return {
				TU: $author$project$Api$Provider$CompanyRegistration$Meta$meta(companyRegistration_)
			};
		},
		companyRegistration);
	return {
		DV: $elm$core$Maybe$Nothing,
		abM: A2(
			$elm$core$Maybe$map,
			$author$project$Components$CancellationReason$CancellationReasonRecord$fromShared,
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason(membershipPatient)),
		abN: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReasonOther(membershipPatient),
		Ly: companyRegistrationRecord,
		Oe: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$effectiveEndDate(membershipPatient),
		qs: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(membershipPatient),
		OH: $elm$core$Maybe$Just(
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn(membershipPatient)),
		Ps: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$firstBillStartDate(membershipPatient),
		Pw: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents(membershipPatient)),
		adR: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient),
		TB: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient),
		VM: $elm$core$Maybe$Just(
			$author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation(patient)),
		_n: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$SpecialRate$Min$id,
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate(membershipPatient)),
		_E: $elm$core$Maybe$Just(
			$author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate(membershipPatient))
	};
};
var $author$project$Components$Membership$Form$Sections$Members$initMembersFields = F8(
	function (apiClient, currentDate, session, practice, hinterViewOff, isNew, patient, membership) {
		var startDate = isNew ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Api$Provider$Membership$One$startDate(membership),
				$author$project$Api$Provider$Membership$One$billedThroughDate(membership))) : $author$project$Api$Provider$Membership$One$billedThroughDate(membership);
		var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(membership);
		var membershipPatientsWithCmds = A2(
			$elm$core$List$map,
			function (membershipPatient) {
				var originalMembershipPatient = A2(
					$elm_community$list_extra$List$Extra$find,
					function (membershipPatient_) {
						return _Utils_eq(
							$author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_),
							$author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient));
					},
					$author$project$Api$Provider$Membership$One$membershipPatients(membership));
				var originalPatient = A2(
					$elm$core$Maybe$map,
					$author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation,
					A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, originalMembershipPatient));
				var membershipPatientRecord = $author$project$Components$Membership$Form$Records$membershipPatientFromOne(membershipPatient);
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					membershipPatientRecord,
					A9($author$project$Components$Membership$Form$Members$MembershipPatient$init, apiClient, currentDate, session, practice, hinterViewOff, isNew, originalPatient, originalMembershipPatient, membershipPatientRecord));
			},
			membershipPatients);
		var membershipPatientsCmds = A2(
			$elm$core$List$map,
			function (_v2) {
				var cmd = _v2.b;
				var membershipPatientRecord = _v2.c;
				return A2(
					$elm$core$Platform$Cmd$map,
					$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.adR),
					cmd);
			},
			membershipPatientsWithCmds);
		var companyAccount = $author$project$Api$Provider$Membership$One$companyAccount(membership);
		var addMembershipPatientCmd = function () {
			var _v1 = _Utils_Tuple3(
				isNew,
				companyAccount,
				$author$project$Api$Provider$Patient$One$company(patient));
			if (_v1.a) {
				if ((!_v1.b.$) && (!_v1.c.$)) {
					return A4(
						$author$project$Components$Membership$Form$Sections$Members$addMember,
						apiClient,
						0,
						$elm$core$Maybe$Just(patient),
						startDate);
				} else {
					return A4(
						$author$project$Components$Membership$Form$Sections$Members$addMember,
						apiClient,
						1,
						$elm$core$Maybe$Just(patient),
						startDate);
				}
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, _v0) {
							var membershipPatientModel = _v0.a;
							var membershipPatientRecord = _v0.c;
							return _Utils_Tuple2(
								membershipPatientRecord.adR,
								_Utils_Tuple2(index, membershipPatientModel));
						}),
					membershipPatientsWithCmds)),
			$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$cons, addMembershipPatientCmd, membershipPatientsCmds)));
	});
var $author$project$Api$Provider$Membership$Meta$membershipPatientsMaxCount = function (_v0) {
	var meta = _v0;
	return meta.TG;
};
var $author$project$Components$Membership$Form$Sections$Members$init = F8(
	function (apiClient, currentDate, session, practice, patient, hinterViewOff, isNew, membership) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var _v0 = A8($author$project$Components$Membership$Form$Sections$Members$initMembersFields, apiClient, currentDate, session, practice, hinterViewOff, isNew, patient, membership);
		var membershipPatients = _v0.a;
		var formFieldsCmd = _v0.b;
		return _Utils_Tuple2(
			{
				cO: currentDate,
				N7: false,
				adN: hinterViewOff,
				iX: isNew,
				F4: $author$project$Api$Provider$Membership$Meta$membershipPatientsMaxCount(membershipMeta),
				TF: membershipPatients,
				Gv: $elm$core$Set$fromList(
					$elm$core$Dict$keys(membershipPatients)),
				WF: practice,
				ZD: session
			},
			formFieldsCmd);
	});
var $author$project$Components$Membership$Form$initMembers = F3(
	function (apiClient, membership, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$MembersMsg),
			A8($author$project$Components$Membership$Form$Sections$Members$init, apiClient, model.cO, model.ZD, model.WF, model.VM, model.adN, model.iX, membership));
	});
var $author$project$Api$Provider$Membership$Shared$billsAtEndOfPeriod = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.J0);
};
var $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Provider$Membership$One$company = function (_v0) {
	var record = _v0.b;
	return record.ab9;
};
var $author$project$Components$Membership$Form$Sections$PlanChange$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$initPlanResourceFilter = F5(
	function (apiClient, session, planType, billsAtEndOfPeriod, companyId) {
		var listOptionals = function () {
			if (!companyId.$) {
				var companyId_ = companyId.a;
				return function (d) {
					return _Utils_update(
						d,
						{
							D9: $elm$core$Maybe$Just(companyId_)
						});
				};
			} else {
				return function (d) {
					return _Utils_update(
						d,
						{
							J0: billsAtEndOfPeriod ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing,
							AS: _List_fromArray(
								[planType])
						});
				};
			}
		}();
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Plan', IS: true});
			});
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$init = F7(
	function (apiClient, session, currentDate, membershipId, planType, billsAtEndOfPeriod, companyId) {
		var _v0 = A5($author$project$Components$Membership$Form$Sections$PlanChange$initPlanResourceFilter, apiClient, session, planType, billsAtEndOfPeriod, companyId);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				cO: currentDate,
				fm: $elm$core$Maybe$Nothing,
				PB: $elm$core$Maybe$Nothing,
				q5: !$author$project$Utils$Maybe$toBool(membershipId),
				yS: membershipId,
				jw: planResourceFilter,
				jY: $author$project$Api$Data$NotAsked
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg, planResourceFilterCmd));
	});
var $author$project$Components$Membership$Form$initPlanChange = F3(
	function (apiClient, membership, model) {
		if (A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			6,
			$author$project$Api$Practice$Provider(model.WF))) {
			var plan = $author$project$Api$Provider$Membership$One$plan(membership);
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$PlanChangeMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A7(
						$author$project$Components$Membership$Form$Sections$PlanChange$init,
						apiClient,
						model.ZD,
						model.cO,
						model.adR,
						$author$project$Api$Provider$Plan$SharedWithContractInfo$planType(plan),
						$author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership),
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Company$Shared$id,
							$author$project$Api$Provider$Membership$One$company(membership)))));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$Membership$Form$Sections$Pricing$GotCoupons = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$GotPaymentMethods = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$PaymentMethod$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Membership$One$coupon = function (_v0) {
	var record = _v0.b;
	return record.L1;
};
var $author$project$Api$Provider$Membership$Shared$fixedPeriodRateInCents = function (_v0) {
	var record = _v0;
	return record.Pw;
};
var $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$fixedPeriodRateInCents(shared);
};
var $author$project$Api$Provider$Membership$Shared$fixedRegistrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.Px;
};
var $author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$fixedRegistrationFeeInCents(shared);
};
var $author$project$Components$Membership$Form$Sections$Pricing$initFormFields = function (membership) {
	var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
	return {
		L1: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Common$Coupon$Shared$id,
			$author$project$Api$Provider$Membership$One$coupon(membership)),
		Pw: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership)),
		Px: A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			$author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership)),
		cb: {
			XJ: $author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership)) && $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(membershipMeta),
			et: $author$project$Utils$Maybe$toBool(
				$author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership)) && $author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(membershipMeta)
		},
		V3: $elm$core$Maybe$Nothing
	};
};
var $author$project$Api$Provider$PaymentMethod$Min$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Components$Membership$Form$Sections$Pricing$paymentMethodTitle = function (paymentMethod) {
	var _v0 = $author$project$Api$Provider$PaymentMethod$Min$label(paymentMethod);
	if (!_v0.$) {
		var lbl = _v0.a;
		return lbl;
	} else {
		var lastFour = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (lf) {
					return ' *' + lf;
				},
				$author$project$Api$Provider$PaymentMethod$Min$lastFour(paymentMethod)));
		var brand = $author$project$Formatters$String$titleize(
			$author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(paymentMethod));
		return _Utils_ap(brand, lastFour);
	}
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodOption = function (paymentMethod) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$strong,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('inline')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$String$titleize(
								$author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(paymentMethod)))
						])),
					$elm$html$Html$text(' '),
					function () {
					var _v0 = $author$project$Api$Provider$PaymentMethod$Min$lastFour(paymentMethod);
					if (!_v0.$) {
						var lastFour = _v0.a;
						return A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('*' + lastFour)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]))
		]);
};
var $author$project$Components$Membership$Form$Sections$Pricing$init = F3(
	function (apiClient, patientId, membership) {
		var formFields = $author$project$Components$Membership$Form$Sections$Pricing$initFormFields(membership);
		return _Utils_Tuple2(
			{
				wR: $author$project$Api$Data$Loading,
				N7: $author$project$Utils$Maybe$toBool(formFields.L1),
				lX: false,
				PB: $author$project$Utils$Form$init(formFields),
				rW: $author$project$Ui$Form$SearchableSelect$init(
					{
						adR: 'payment-method-select',
						ahw: $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodOption,
						ahA: $author$project$Components$Membership$Form$Sections$Pricing$paymentMethodTitle,
						g0: function (pm) {
							return $elm$core$Maybe$Just(
								$author$project$Api$Provider$PaymentMethod$Min$id(pm));
						}
					}),
				AK: $author$project$Api$Data$Loading,
				j1: $elm$core$Maybe$Nothing
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3(
						$author$project$Api$Provider$Coupon$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									GY: $elm$core$Maybe$Just(true)
								});
						},
						$author$project$Components$Membership$Form$Sections$Pricing$GotCoupons),
						A3($author$project$Api$Provider$Patient$PaymentMethod$list, apiClient, patientId, $author$project$Components$Membership$Form$Sections$Pricing$GotPaymentMethods)
					])));
	});
var $author$project$Components$Membership$Form$initPricing = F3(
	function (apiClient, patientId, membership) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$PricingMsg),
			A3($author$project$Components$Membership$Form$Sections$Pricing$init, apiClient, patientId, membership));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$GotTaxableChargeItemsCount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem = function (_v0) {
	var record = _v0.b;
	return record.lp;
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$description = function (_v0) {
	var record = _v0.b;
	return record.Nx;
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Min$id(min);
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Provider$ChargeItem$Min$name(min);
};
var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$priceInCents = function (_v0) {
	var record = _v0.b;
	return record.Ba;
};
var $author$project$Components$Membership$Form$Records$chargeItemFromForRecurringCharge = function (chargeItem) {
	return {
		Nx: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$description(chargeItem),
		adR: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id(chargeItem),
		zh: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$name(chargeItem),
		Ba: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$priceInCents(chargeItem)
	};
};
var $author$project$Api$Provider$RecurringCharge$Shared$fixedDescription = function (_v0) {
	var record = _v0;
	return record.ads;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$fixedDescription(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$fixedPriceInCents = function (_v0) {
	var record = _v0;
	return record.adt;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$fixedPriceInCents(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$id(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$name(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$nextBillDate = function (_v0) {
	var record = _v0;
	return record.UC;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$nextBillDate(shared);
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Components$Membership$Form$Records$patientFromMin = function (patient) {
	return {
		IK: $elm$core$Maybe$Nothing,
		adR: $author$project$Api$Provider$Patient$Min$id(patient),
		aet: $elm$core$Maybe$Nothing,
		TL: '',
		zh: $author$project$Api$Provider$Patient$Min$name(patient),
		afS: $elm$core$Maybe$Nothing,
		aaI: $elm$core$Maybe$Nothing
	};
};
var $author$project$Api$Provider$RecurringCharge$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Wc;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$periodInMonths(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$periodsMax = function (_v0) {
	var record = _v0;
	return record.We;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsMax = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$periodsMax(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$periodsRemaining = function (_v0) {
	var record = _v0;
	return record.afL;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$periodsRemaining(shared);
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner = function (_v0) {
	var record = _v0.b;
	return record.afS;
};
var $author$project$Api$Provider$RecurringCharge$Shared$quantity = function (_v0) {
	var record = _v0;
	return record.Bd;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$quantity(shared);
};
var $author$project$Api$Provider$RecurringCharge$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$RecurringCharge$Shared$startDate(shared);
};
var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$uom = function (_v0) {
	var record = _v0.b;
	return record.aam;
};
var $author$project$Components$Membership$Form$Records$recurringChargeFromForMembershipOne = function (recurringCharge) {
	var practitioner = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner(recurringCharge);
	var patient = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient(recurringCharge);
	var chargeItem = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem(recurringCharge);
	return {
		lp: $author$project$Components$Membership$Form$Records$chargeItemFromForRecurringCharge(chargeItem),
		ads: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription(recurringCharge),
		adt: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents(recurringCharge),
		adR: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$id(recurringCharge),
		zh: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$name(recurringCharge),
		UC: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate(recurringCharge),
		VM: $elm$core$Maybe$Just(
			$author$project$Components$Membership$Form$Records$patientFromMin(patient)),
		Wc: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths(recurringCharge),
		We: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsMax(recurringCharge),
		afL: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining(recurringCharge),
		afS: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromMin, practitioner),
		Bd: $elm$core$Maybe$Just(
			$author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity(recurringCharge)),
		_E: $elm$core$Maybe$Just(
			$author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate(recurringCharge)),
		aam: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$uom(recurringCharge)
	};
};
var $author$project$Api$Provider$Membership$One$recurringCharges = function (_v0) {
	var record = _v0.b;
	return record.XZ;
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsInit = function (membership) {
	var recurringCharges = $author$project$Api$Provider$Membership$One$recurringCharges(membership);
	return {
		XZ: A2($elm$core$List$map, $author$project$Components$Membership$Form$Records$recurringChargeFromForMembershipOne, recurringCharges)
	};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$init = F3(
	function (apiClient, practice, membership) {
		var showItemTypeInTitle = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice);
		var formFields = $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsInit(membership);
		return _Utils_Tuple2(
			{
				fg: $elm$core$Maybe$Nothing,
				PB: $author$project$Utils$Form$init(formFields),
				qL: false,
				Ci: showItemTypeInTitle
			},
			A3(
				$author$project$Api$Provider$ChargeItem$list,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							afy: A2($author$project$Api$Pagination$withItemsPerPage, 0, $author$project$Api$Pagination$init),
							$u: $elm$core$Maybe$Just(false)
						});
				},
				$author$project$Components$Membership$Form$Sections$RecurringCharges$GotTaxableChargeItemsCount));
	});
var $author$project$Components$Membership$Form$initRecurringCharges = F3(
	function (apiClient, practice, membership) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$RecurringChargesMsg),
			A3($author$project$Components$Membership$Form$Sections$RecurringCharges$init, apiClient, practice, membership));
	});
var $author$project$Components$Membership$Form$Sections$Summary$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Membership$One$createdAt = function (_v0) {
	var record = _v0.b;
	return record.Mf;
};
var $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderOne = function (brokerDeal) {
	return {
		vJ: $author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal),
		ab9: $author$project$Api$Provider$BrokerDeal$One$company(brokerDeal),
		M1: $author$project$Api$Provider$BrokerDeal$One$dealName(brokerDeal),
		M2: $author$project$Api$Provider$BrokerDeal$One$dealType(brokerDeal),
		qs: $author$project$Api$Provider$BrokerDeal$One$endDate(brokerDeal),
		adR: $author$project$Api$Provider$BrokerDeal$One$id(brokerDeal),
		TU: $author$project$Api$Provider$BrokerDeal$One$meta(brokerDeal),
		XM: $author$project$Api$Provider$BrokerDeal$One$rates(brokerDeal)
	};
};
var $author$project$Components$Membership$Form$Sections$Summary$initPatientResourceFilter = function (apiClient) {
	return A2(
		$author$project$Components$ResourceFilter$Patient$init,
		apiClient,
		function (d) {
			return _Utils_update(
				d,
				{IS: false});
		});
};
var $author$project$Api$Provider$Membership$One$neverBeenBilled = function (_v0) {
	var record = _v0.b;
	return record.Uu;
};
var $author$project$Components$Membership$Form$Sections$Summary$initPlanResourceFilter = F3(
	function (apiClient, session, membership) {
		var listOptionals = function () {
			var _v0 = $author$project$Api$Provider$Membership$One$company(membership);
			if (!_v0.$) {
				var company = _v0.a;
				return function (d) {
					return _Utils_update(
						d,
						{
							D9: $elm$core$Maybe$Just(
								$author$project$Api$Provider$Company$Shared$id(company))
						});
				};
			} else {
				var planType = _List_fromArray(
					[2, 3]);
				var billsAtEndOfPeriod = $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership) && (!$author$project$Api$Provider$Membership$One$neverBeenBilled(membership));
				return function (d) {
					return _Utils_update(
						d,
						{
							J0: billsAtEndOfPeriod ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing,
							AS: planType
						});
				};
			}
		}();
		return A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			listOptionals,
			function (d) {
				return _Utils_update(
					d,
					{IS: false});
			});
	});
var $author$project$Api$Provider$Membership$One$autoRenew = function (_v0) {
	var record = _v0.b;
	return record.JH;
};
var $author$project$Api$Provider$Membership$Shared$billDate = function (_v0) {
	var record = _v0;
	return record.vG;
};
var $author$project$Api$Provider$Membership$One$billDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$billDate(shared);
};
var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.T3;
};
var $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Provider$Membership$Shared$nextBillDate = function (_v0) {
	var record = _v0;
	return record.UC;
};
var $author$project$Api$Provider$Membership$One$nextBillDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$nextBillDate(shared);
};
var $author$project$Api$Provider$Membership$One$periodInMonths = function (_v0) {
	var record = _v0.b;
	return record.Wc;
};
var $author$project$Components$Membership$Form$Records$planFromSharedWithContractInfo = function (plan) {
	return {
		adR: $author$project$Api$Provider$Plan$SharedWithContractInfo$id(plan),
		zh: $author$project$Api$Provider$Plan$SharedWithContractInfo$name(plan)
	};
};
var $author$project$Api$Provider$Membership$One$status = function (_v0) {
	var record = _v0.b;
	return record.ag7;
};
var $author$project$Components$Membership$Form$Sections$Summary$initSummaryFields = F4(
	function (currentDate, isNew, practice, membership) {
		var minimumEnrollmentPeriodInMonths = $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths(membership);
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var setBillDate = ($author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) && $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta)) ? _Utils_eq(
			$author$project$Api$Provider$Membership$One$billDate(membership),
			$author$project$Api$Provider$Membership$One$nextBillDate(membership)) : ($author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) ? false : $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta));
		var companyAccount = $author$project$Api$Provider$Membership$One$companyAccount(membership);
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(isNew, companyAccount);
			if (_v1.a && (!_v1.b.$)) {
				var companyAccount_ = _v1.b.a;
				var eligibilityStartDate = A2(
					$elm$core$Maybe$withDefault,
					currentDate,
					$author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(companyAccount_));
				return _Utils_Tuple2(
					(A2($justinmimbs$date$Date$compare, eligibilityStartDate, currentDate) === 2) ? $elm$core$Maybe$Just(eligibilityStartDate) : $elm$core$Maybe$Nothing,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Membership$One$startDate(membership)));
			} else {
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Membership$One$nextBillDate(membership));
			}
		}();
		var futureEligibilityDate = _v0.a;
		var nextBillDate = _v0.b;
		return {
			JH: $author$project$Api$Provider$Membership$One$autoRenew(membership),
			vG: $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta) ? (setBillDate ? $author$project$Api$Provider$Membership$One$billDate(membership) : $elm$core$Maybe$Nothing) : $elm$core$Maybe$Nothing,
			Lr: A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$Shared$id, companyAccount),
			Fq: futureEligibilityDate,
			cb: {_E: false},
			T3: minimumEnrollmentPeriodInMonths,
			UC: $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) ? nextBillDate : $elm$core$Maybe$Nothing,
			Vp: A2(
				$elm$core$Maybe$map,
				$author$project$Components$Membership$Form$Records$patientFromShared,
				$author$project$Api$Provider$Membership$One$owner(membership)),
			Wc: $author$project$Api$Provider$Membership$One$periodInMonths(membership),
			GH: (isNew && A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, practice)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				$author$project$Components$Membership$Form$Records$planFromSharedWithContractInfo(
					$author$project$Api$Provider$Membership$One$plan(membership))),
			eF: setBillDate,
			_E: function () {
				if ($author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta)) {
					var startDateMembership = $author$project$Api$Provider$Membership$One$startDate(membership);
					var startDate = (($author$project$Api$Provider$Membership$One$status(membership) === 'unconfirmed') && A2($author$project$Utils$Date$isBefore, startDateMembership, currentDate)) ? currentDate : startDateMembership;
					return $elm$core$Maybe$Just(startDate);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}()
		};
	});
var $author$project$Components$Membership$Form$Sections$Summary$init = function (apiClient) {
	return function (timeZone) {
		return function (currentDate) {
			return function (session) {
				return function (practice) {
					return function (isNew) {
						return function (timeFormatter) {
							return function (hinterViewOff) {
								return function (url) {
									return function (membership) {
										var membershipCreatedAt = $author$project$Api$Provider$Membership$One$createdAt(membership);
										var formFields = A4($author$project$Components$Membership$Form$Sections$Summary$initSummaryFields, currentDate, isNew, practice, membership);
										var brokerDeals = A2(
											$elm$core$List$map,
											$author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderOne,
											$author$project$Api$Provider$Membership$One$brokerDeals(membership));
										var _v0 = $author$project$Components$DateInput$init;
										var startDateInput = _v0.a;
										var startDateInputCmd = _v0.b;
										var _v1 = A3($author$project$Components$Membership$Form$Sections$Summary$initPlanResourceFilter, apiClient, session, membership);
										var planResourceFilter = _v1.a;
										var planResourceFilterCmd = _v1.b;
										var _v2 = $author$project$Components$Membership$Form$Sections$Summary$initPatientResourceFilter(apiClient);
										var patientResourceFilter = _v2.a;
										var patientResourceFilterCmd = _v2.b;
										var _v3 = $author$project$Components$DateInput$init;
										var nextBillDateInput = _v3.a;
										var nextBillDateInputCmd = _v3.b;
										return _Utils_Tuple2(
											{
												hy: A7(
													$author$project$Components$AuditTrailLog$init,
													session,
													url,
													timeFormatter,
													$elm$core$Maybe$Just('membership'),
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$Membership$One$id(membership)),
													membershipCreatedAt,
													$elm$core$Maybe$Nothing),
												J9: brokerDeals,
												e7: $elm$core$Maybe$Nothing,
												hY: $elm$core$Maybe$Nothing,
												cO: currentDate,
												is: false,
												PB: $author$project$Utils$Form$init(formFields),
												adN: hinterViewOff,
												iX: isNew,
												zy: false,
												ry: nextBillDateInput,
												rU: patientResourceFilter,
												jw: planResourceFilter,
												WF: practice,
												ZD: session,
												of: {
													eT: (!$author$project$Utils$Maybe$toBool(formFields.T3)) && $author$project$Api$Provider$Membership$One$neverBeenBilled(membership),
													UC: false,
													Vp: false,
													GH: isNew && A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, practice)
												},
												kg: startDateInput,
												Hz: timeZone
											},
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceFilterCmd),
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceFilterCmd),
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg, startDateInputCmd),
														A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg, nextBillDateInputCmd)
													])));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Components$Membership$Form$initSummary = F3(
	function (apiClient, membership, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$SummaryMsg),
			$author$project$Components$Membership$Form$Sections$Summary$init(apiClient)(model.Hz)(model.cO)(model.ZD)(model.WF)(model.iX)(model.Hy)(model.adN)(model.aav)(membership));
	});
var $author$project$Components$Membership$Form$setupMembershipOnScope = F3(
	function (apiClient, membership, model) {
		var _v0 = A3($author$project$Components$Membership$Form$initSummary, apiClient, membership, model);
		var summary = _v0.a;
		var summaryCmd = _v0.b;
		var _v1 = A3($author$project$Components$Membership$Form$initRecurringCharges, apiClient, model.WF, membership);
		var recurringCharges = _v1.a;
		var recurringChargesCmd = _v1.b;
		var _v2 = A3(
			$author$project$Components$Membership$Form$initPricing,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(model.VM),
			membership);
		var pricing = _v2.a;
		var pricingCmd = _v2.b;
		var _v3 = A3($author$project$Components$Membership$Form$initPlanChange, apiClient, membership, model);
		var planChange = _v3.a;
		var planChangeCmd = _v3.b;
		var _v4 = A3($author$project$Components$Membership$Form$initMembers, apiClient, membership, model);
		var members = _v4.a;
		var membersCmd = _v4.b;
		var _v5 = A3($author$project$Components$Membership$Form$initContracts, apiClient, membership, model);
		var contracts = _v5.a;
		var contractsCmd = _v5.b;
		var _v6 = A2($author$project$Components$Membership$Form$initBillsOverview, membership, model);
		var billsOverview = _v6.a;
		var billsOverviewCmd = _v6.b;
		var sections = {pG: billsOverview, aC: contracts, B: members, ju: planChange, cl: pricing, XZ: recurringCharges, _9: summary};
		var newModel = _Utils_update(
			model,
			{
				ja: $elm$core$Maybe$Just(membership),
				c6: $elm$core$Maybe$Just(membership),
				gz: true,
				l: $elm$core$Maybe$Just(sections)
			});
		return A2(
			$elm$core$Tuple$mapSecond,
			function (checkPriceCmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[summaryCmd, membersCmd, pricingCmd, contractsCmd, recurringChargesCmd, billsOverviewCmd, planChangeCmd, checkPriceCmd]));
			},
			A4($author$project$Components$Membership$Form$checkPrice, apiClient, membership, sections, newModel));
	});
var $author$project$Components$Membership$Form$CancelModal$Cancelled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$Closed = {$: 1};
var $author$project$Components$Membership$Form$CancelModal$EndDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$MembershipCancelled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$None = {$: 0};
var $author$project$Api$Provider$Membership$cancel = F4(
	function (apiClient, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'end_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qs)),
								_Utils_Tuple2(
								'cancellation_reason',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.abM)),
								_Utils_Tuple2(
								'cancellation_reason_other',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abN))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['cancel']),
						$author$project$Api$Provider$Membership$membershipPath(id)))));
	});
var $author$project$Components$Membership$Form$CancelModal$formFieldsUpdate = F2(
	function (field, fields) {
		if (!field.$) {
			var date = field.a;
			return _Utils_update(
				fields,
				{qs: date});
		} else {
			var _v1 = field.a;
			var cancellationReason = _v1.a;
			var cancellationReasonOther = _v1.b;
			return _Utils_update(
				fields,
				{abM: cancellationReason, abN: cancellationReasonOther});
		}
	});
var $author$project$Components$Membership$Form$CancelModal$CancellationReasonOtherValidation = 2;
var $author$project$Components$Membership$Form$CancelModal$CancellationReasonValidation = 1;
var $author$project$Components$Membership$Form$CancelModal$EndDateValidation = 0;
var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMin = function (_v0) {
	var meta = _v0;
	return meta.qs._A;
};
var $author$project$Components$Membership$Form$CancelModal$validateEndDate = F2(
	function (membership, fields) {
		var minEndDate = $author$project$Api$Provider$Membership$One$isSponsored(membership) ? $author$project$Api$Provider$Membership$Meta$endDateSponsoredMin(
			$author$project$Api$Provider$Membership$One$meta(membership)) : $elm$core$Maybe$Nothing;
		var _v0 = _Utils_Tuple2(fields.qs, minEndDate);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var endDate = _v0.a.a;
				var minEndDate_ = _v0.b.a;
				return (!A2($justinmimbs$date$Date$compare, endDate, minEndDate_)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						0,
						'Please enter a date greater or equal than ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, minEndDate_))
					]) : _List_Nil;
			} else {
				var _v1 = _v0.b;
				return _List_Nil;
			}
		} else {
			var _v2 = _v0.a;
			return _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a date.')
				]);
		}
	});
var $author$project$Components$Membership$Form$CancelModal$formFieldsValidator = function (membership) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Membership$Form$CancelModal$validateEndDate(membership)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				A2($author$project$Components$CancellationReason$Input$validate, 1, 2))
			]));
};
var $author$project$Components$Membership$Form$CancelModal$updateDateInputFormField = F7(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, field, fieldGetter) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var event = _v0.c;
		var newForm = function () {
			if (event.$ === 1) {
				var date = event.a;
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Membership$Form$CancelModal$formFieldsUpdate,
					field(date),
					model.PB);
			} else {
				var fields = $author$project$Utils$Form$fields(model.PB);
				return A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Membership$Form$CancelModal$formFieldsUpdate,
					field(
						fieldGetter(fields)),
					model.PB);
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			ac5: $author$project$Components$Membership$Form$CancelModal$None,
			y8: A2(
				dateInputSetter,
				newDateInput,
				_Utils_update(
					model,
					{PB: newForm})),
			as: _List_Nil
		};
	});
var $author$project$Components$Membership$Form$CancelModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Membership$Form$CancelModal$Closed, y8: model, as: _List_Nil};
			case 0:
				var _v2 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Components$Membership$Form$CancelModal$formFieldsValidator(model.ja),
					model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var newForm = _v3.a;
					var validFormFields = _v3.b;
					var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var apiFields = {
						abM: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.adR;
							},
							validFields.abM),
						abN: validFields.abN,
						qs: validFields.qs
					};
					return {
						EC: A4(
							$author$project$Api$Provider$Membership$cancel,
							apiClient,
							$author$project$Api$Provider$Membership$One$id(model.ja),
							apiFields,
							$author$project$Components$Membership$Form$CancelModal$MembershipCancelled),
						ac5: $author$project$Components$Membership$Form$CancelModal$None,
						y8: _Utils_update(
							model,
							{e7: $author$project$Api$Data$Loading, PB: newForm}),
						as: _List_Nil
					};
				} else {
					var newForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$CancelModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var membership = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$CancelModal$Cancelled(membership),
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$CancelModal$None,
						y8: _Utils_update(
							model,
							{e7: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var subMsg = msg.a;
				return A7(
					$author$project$Components$Membership$Form$CancelModal$updateDateInputFormField,
					model,
					function ($) {
						return $.qu;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{qu: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$CancelModal$EndDateInputMsg,
					$author$project$Components$Membership$Form$CancelModal$EndDate,
					function ($) {
						return $.qs;
					});
			default:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$CancelModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Membership$Form$CancelModal$None,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Membership$Form$RenewContractModal$Closed = 1;
var $author$project$Components$Membership$Form$RenewContractModal$GotRenewResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$RenewContractModal$None = 0;
var $author$project$Components$Membership$Form$RenewContractModal$Renwed = 2;
var $author$project$Api$Provider$MembershipContract$One$MembershipContract = 0;
var $author$project$Api$Provider$MembershipContract$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Membership$MembershipContract$renew = F4(
	function (apiClient, membershipId, memo, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'memo',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, memo))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$MembershipContract$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['renew']),
						$author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId)))));
	});
var $author$project$Components$Membership$Form$RenewContractModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				var memo = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							aeC: $author$project$Utils$String$toMaybe(memo)
						}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: A4($author$project$Api$Provider$Membership$MembershipContract$renew, apiClient, model.yS, model.aeC, $author$project$Components$Membership$Form$RenewContractModal$GotRenewResponse),
					ac5: 0,
					y8: _Utils_update(
						model,
						{nY: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{nY: response}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{nY: response}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Membership$Form$RestartModal$Closed = {$: 1};
var $author$project$Components$Membership$Form$RestartModal$MembershipRestarted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$RestartModal$None = {$: 0};
var $author$project$Components$Membership$Form$RestartModal$Restarted = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$RestartModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 1:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Membership$Form$RestartModal$Closed, y8: model, as: _List_Nil};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var pendingMembership = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$RestartModal$None,
						y8: _Utils_update(
							model,
							{
								c6: $elm$core$Maybe$Just(pendingMembership)
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$RestartModal$Closed,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 0:
				return {
					EC: A5(
						$author$project$Api$Provider$Membership$restart,
						apiClient,
						$author$project$Api$Provider$Membership$One$id(model.ja),
						false,
						model.UC,
						$author$project$Components$Membership$Form$RestartModal$MembershipRestarted),
					ac5: $author$project$Components$Membership$Form$RestartModal$None,
					y8: _Utils_update(
						model,
						{ss: $author$project$Api$Data$Loading}),
					as: _List_Nil
				};
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var membership = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$RestartModal$Restarted(membership),
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$RestartModal$None,
						y8: _Utils_update(
							model,
							{ss: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var dateInputModel = msg.a;
				var dateInputMsg = msg.b;
				var _v3 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
				var newDateInput = _v3.a;
				var subCmd = _v3.b;
				var event = _v3.c;
				if (event.$ === 1) {
					var maybeDate = event.a;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									subCmd,
									A5(
									$author$project$Api$Provider$Membership$restart,
									apiClient,
									$author$project$Api$Provider$Membership$One$id(model.ja),
									true,
									maybeDate,
									$author$project$Components$Membership$Form$RestartModal$GotPriceCheck)
								])),
						ac5: $author$project$Components$Membership$Form$RestartModal$None,
						y8: _Utils_update(
							model,
							{qd: newDateInput, UC: maybeDate}),
						as: _List_Nil
					};
				} else {
					return {
						EC: subCmd,
						ac5: $author$project$Components$Membership$Form$RestartModal$None,
						y8: _Utils_update(
							model,
							{qd: newDateInput}),
						as: _List_Nil
					};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$Billed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$BillsOverview$MembershipBilled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$BillsOverview$None = {$: 0};
var $author$project$Api$Provider$Membership$bill = F4(
	function (apiClient, id, startDate, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'membership',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'start_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, startDate))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Membership$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['bill']),
						$author$project$Api$Provider$Membership$membershipPath(id)))));
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$update = F3(
	function (apiClient, msg, model) {
		if (!msg.$) {
			var startDate = msg.a;
			return {
				EC: A4($author$project$Api$Provider$Membership$bill, apiClient, model.yS, startDate, $author$project$Components$Membership$Form$Sections$BillsOverview$Billed),
				ac5: $author$project$Components$Membership$Form$Sections$BillsOverview$None,
				y8: _Utils_update(
					model,
					{lb: $author$project$Api$Data$Loading}),
				as: _List_Nil
			};
		} else {
			var response = msg.a;
			if (response.$ === 3) {
				var membership = response.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Membership$Form$Sections$BillsOverview$MembershipBilled(membership),
					y8: _Utils_update(
						model,
						{lb: $author$project$Api$Data$NotAsked}),
					as: _List_Nil
				};
			} else {
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Membership$Form$Sections$BillsOverview$None,
					y8: _Utils_update(
						model,
						{lb: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			}
		}
	});
var $author$project$Components$Membership$Form$Sections$Contracts$Canceled = 1;
var $author$project$Components$Membership$Form$Sections$Contracts$GotCanceledResponse = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$Contracts$None = 0;
var $author$project$Components$Membership$Form$Sections$Contracts$Updated = 2;
var $author$project$Api$Provider$Membership$MembershipContract$cancel = F3(
	function (apiClient, membershipId, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['cancel']),
					$author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId))));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var bool = field.a;
				return _Utils_update(
					fields,
					{OY: bool});
			case 1:
				var date = field.a;
				return _Utils_update(
					fields,
					{
						qs: $elm$core$Result$toMaybe(
							$justinmimbs$date$Date$fromIsoString(date))
					});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Wc: $elm$core$String$toInt(string)
					});
			default:
				var type_ = field.a;
				return _Utils_update(
					fields,
					{
						ahI: $author$project$Api$ContractType$fromString(type_)
					});
		}
	});
var $author$project$Components$Membership$Form$Sections$Contracts$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{yR: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 1:
				var endDate = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var newFields = _Utils_update(
					fields,
					{qs: endDate});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 2,
					y8: _Utils_update(
						model,
						{
							is: !model.is,
							PB: A2($author$project$Utils$Form$set, newFields, model.PB)
						}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{sI: !model.sI}),
					as: _List_Nil
				};
			case 4:
				var membershipId = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							e7: $elm$core$Maybe$Just(
								_Utils_Tuple2($author$project$Api$Data$NotAsked, membershipId))
						}),
					as: _List_Nil
				};
			case 5:
				var membershipId = msg.a;
				var confirmed = msg.b;
				return confirmed ? {
					EC: A3(
						$author$project$Api$Provider$Membership$MembershipContract$cancel,
						apiClient,
						membershipId,
						$author$project$Components$Membership$Form$Sections$Contracts$GotCanceledResponse(membershipId)),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							e7: $elm$core$Maybe$Just(
								_Utils_Tuple2($author$project$Api$Data$Loading, membershipId))
						}),
					as: _List_Nil
				} : {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{e7: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 3:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$Contracts$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 2,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			default:
				var membershipId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{e7: $elm$core$Maybe$Nothing}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Contract canceled.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								e7: $elm$core$Maybe$Just(
									_Utils_Tuple2($author$project$Api$Data$NotAsked, membershipId))
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$None = 0;
var $author$project$Components$Membership$Form$Sections$Members$Updated = 1;
var $author$project$Api$Provider$MembershipPatient$New$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Membership$Form$Records$locationFromShared = function (location) {
	return {
		adR: $author$project$Api$Provider$Location$Shared$id(location),
		zh: $author$project$Api$Provider$Location$Shared$name(location)
	};
};
var $author$project$Components$Membership$Form$Records$practitionerFromShared = function (practitioner) {
	return {
		adR: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
		zh: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
	};
};
var $author$project$Components$Membership$Form$Records$patientFromOne = function (patient) {
	return {
		IK: $author$project$Api$Provider$Patient$One$age(patient),
		adR: $author$project$Api$Provider$Patient$One$id(patient),
		aet: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$locationFromShared,
			$author$project$Api$Provider$Patient$One$location(patient)),
		TL: $author$project$Api$Provider$Patient$One$membershipStatus(patient),
		zh: $author$project$Api$Provider$Patient$One$name(patient),
		afS: A2(
			$elm$core$Maybe$map,
			$author$project$Components$Membership$Form$Records$practitionerFromShared,
			$author$project$Api$Provider$Patient$One$practitioner(patient)),
		aaI: $author$project$Api$Provider$Patient$One$usesTobacco(patient)
	};
};
var $author$project$Components$Membership$Form$Records$membershipPatientFromNew = F5(
	function (currentDate, membershipPatient, memberType, patient, startDate) {
		return {
			DV: $elm$core$Maybe$Just('create'),
			abM: $elm$core$Maybe$Nothing,
			abN: $elm$core$Maybe$Nothing,
			Ly: $elm$core$Maybe$Nothing,
			Oe: $elm$core$Maybe$Nothing,
			qs: $elm$core$Maybe$Nothing,
			OH: $elm$core$Maybe$Just(currentDate),
			Ps: $elm$core$Maybe$Nothing,
			Pw: $elm$core$Maybe$Nothing,
			adR: $author$project$Api$Provider$MembershipPatient$New$id(membershipPatient),
			TB: memberType,
			VM: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromOne, patient),
			_n: $elm$core$Maybe$Nothing,
			_E: startDate
		};
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$None = 0;
var $author$project$Components$Membership$Form$Members$MembershipPatient$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Removed = 2;
var $author$project$Components$Membership$Form$Members$MembershipPatient$Restarted = 3;
var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Updated = 1;
var $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var patient = field.a;
				return _Utils_update(
					fields,
					{VM: patient});
			case 1:
				var string = field.a;
				var patient = A2(
					$elm$core$Maybe$map,
					function (patient_) {
						return _Utils_update(
							patient_,
							{
								aaI: $author$project$Utils$Bool$fromString(string)
							});
					},
					fields.VM);
				return _Utils_update(
					fields,
					{VM: patient});
			case 2:
				var date = field.a;
				return _Utils_update(
					fields,
					{OH: date});
			case 3:
				var date = field.a;
				return _Utils_update(
					fields,
					{_E: date});
			case 4:
				var string = field.a;
				return _Utils_update(
					fields,
					{_n: string});
			case 5:
				var currency = field.a;
				return _Utils_update(
					fields,
					{Pw: currency});
			case 6:
				var date = field.a;
				return _Utils_update(
					fields,
					{qs: date});
			default:
				var _v1 = field.a;
				var cancellationReason = _v1.a;
				var cancellationReasonOther = _v1.b;
				return _Utils_update(
					fields,
					{abM: cancellationReason, abN: cancellationReasonOther});
		}
	});
var $author$project$Components$Patient$Form$withAddress = F2(
	function (address, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var _v1 = A2($author$project$Components$AddressInput$initFromApi, 'patient-address', address);
		var addressInput = _v1.a;
		var addressInputCmd = _v1.b;
		var newFields = _Utils_update(
			fields,
			{It: addressInput});
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				A2($author$project$Utils$Form$set, newFields, form)),
			A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address),
				addressInputCmd));
	});
var $author$project$Components$Patient$Form$withLeadSource = F4(
	function (apiClient, leadSource, leadSourceOther, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var _v1 = A3(
			$author$project$Components$LeadSourceInput$init,
			apiClient,
			A2($elm$core$Maybe$map, $author$project$Api$LeadSource$Shared$id, leadSource),
			leadSourceOther);
		var leadSourceInput = _v1.a;
		var leadSourceInputCmd = _v1.b;
		var newFields = _Utils_update(
			fields,
			{SH: leadSourceInput});
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				A2($author$project$Utils$Form$set, newFields, form)),
			A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource),
				leadSourceInputCmd));
	});
var $author$project$Components$Patient$Form$withPractitioner = F3(
	function (apiClient, practitioner, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var _v1 = A3($author$project$Components$PractitionerInput$init, apiClient, $elm$core$Basics$identity, practitioner);
		var practitionerInput = _v1.a;
		var practitionerInputCmd = _v1.b;
		var newFields = _Utils_update(
			fields,
			{afS: practitionerInput});
		return _Utils_Tuple2(
			A2(
				$author$project$Components$Patient$Form$PatientForm,
				settings,
				A2($author$project$Utils$Form$set, newFields, form)),
			A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner),
				practitionerInputCmd));
	});
var $author$project$Components$Patient$Form$withSyncToEmr = F2(
	function (syncToEmr, _v0) {
		var settings = _v0.a;
		var form = _v0.b;
		var fields = $author$project$Utils$Form$fields(form);
		var newFields = _Utils_update(
			fields,
			{$j: syncToEmr});
		return A2(
			$author$project$Components$Patient$Form$PatientForm,
			settings,
			A2($author$project$Utils$Form$set, newFields, form));
	});
var $author$project$Components$CreatePatientModal$init = F6(
	function (apiClient, currentDate, session, practice, hinterViewOff, patient) {
		var _v0 = A2(
			$elm$core$Tuple$mapFirst,
			$author$project$Components$Patient$Form$withSyncToEmr(true),
			function (_v3) {
				var f = _v3.a;
				var cmd = _v3.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$Platform$Cmd$batch,
							$elm$core$List$append(
								_List_fromArray(
									[cmd]))),
						$elm$core$List$singleton),
					A3(
						$author$project$Components$Patient$Form$withPractitioner,
						apiClient,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Practitioner$Shared$Provider,
							$author$project$Api$Provider$Patient$One$practitioner(patient)),
						f));
			}(
				function (_v2) {
					var f = _v2.a;
					var cmd = _v2.b;
					return A2(
						$elm$core$Tuple$mapSecond,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Platform$Cmd$batch,
								$elm$core$List$append(
									_List_fromArray(
										[cmd]))),
							$elm$core$List$singleton),
						A4(
							$author$project$Components$Patient$Form$withLeadSource,
							apiClient,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$LeadSource$Shared$Provider,
								$author$project$Api$Provider$Patient$One$leadSource(patient)),
							$author$project$Api$Provider$Patient$One$leadSourceOther(patient),
							f));
				}(
					function (_v1) {
						var f = _v1.a;
						var cmd = _v1.b;
						return A2(
							$elm$core$Tuple$mapSecond,
							A2(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									$elm$core$Platform$Cmd$batch,
									$elm$core$List$append(
										_List_fromArray(
											[cmd]))),
								$elm$core$List$singleton),
							A2(
								$author$project$Components$Patient$Form$withAddress,
								$author$project$Api$Provider$Patient$One$address(patient),
								f));
					}(
						A6(
							$author$project$Components$Patient$Form$empty,
							apiClient,
							session,
							currentDate,
							$elm$core$Maybe$Nothing,
							false,
							function (settings) {
								return _Utils_update(
									settings,
									{
										abD: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
										abL: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
										P8: $author$project$Api$Provider$Practice$One$hasLocations(practice),
										Qe: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
										aeA: $author$project$Api$Provider$Practice$One$isMce(practice),
										rr: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
										ago: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
										Ym: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
										agp: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
										Yr: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
										Ys: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
										_D: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
										$f: A2(
											$elm$core$Maybe$withDefault,
											false,
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Network$Shared$syncByAffiliation,
												$author$project$Api$Provider$Practice$One$network(practice))),
										ahB: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
										$$: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
										$1: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
										DF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0)
									});
							})))));
		var form = _v0.a;
		var formCmd = _v0.b;
		return _Utils_Tuple2(
			{PB: form, ZD: session, kj: false},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePatientModal$PatientFormMsg, formCmd));
	});
var $author$project$Components$CreatePatientModal$Closed = {$: 1};
var $author$project$Components$CreatePatientModal$Created = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CreatePatientModal$None = {$: 0};
var $author$project$Components$CreatePatientModal$PatientCreated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$CreatePatientModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$CreatePatientModal$Closed, y8: model, as: _List_Nil};
			case 1:
				var formMsg = msg.a;
				var _v1 = A5($author$project$Components$Patient$Form$update, apiClient, model.ZD, $elm$core$Maybe$Nothing, formMsg, model.PB);
				var form = _v1.a;
				var formCmd = _v1.b;
				var formOutMsgs = _v1.c;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePatientModal$PatientFormMsg, formCmd),
					ac5: $author$project$Components$CreatePatientModal$None,
					y8: _Utils_update(
						model,
						{PB: form}),
					as: formOutMsgs
				};
			case 2:
				var _v2 = $author$project$Components$Patient$Form$validate(model.PB);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validForm = _v3.a;
					var validFields = _v3.b;
					return {
						EC: A3(
							$author$project$Api$Provider$Patient$create,
							apiClient,
							A2($author$project$Components$Patient$Form$encode, validFields, validForm),
							$author$project$Components$CreatePatientModal$PatientCreated),
						ac5: $author$project$Components$CreatePatientModal$None,
						y8: _Utils_update(
							model,
							{kj: true}),
						as: _List_Nil
					};
				} else {
					var erroredForm = _v2.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$CreatePatientModal$None,
						y8: _Utils_update(
							model,
							{PB: erroredForm}),
						as: _List_Nil
					};
				}
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var patient = response.a;
						return {
							EC: A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Components$CreatePatientModal$PatientFormMsg,
								A5(
									$author$project$Components$Patient$Form$createAffiliation,
									apiClient,
									model.ZD,
									$author$project$Api$Provider$Patient$One$id(patient),
									$elm$core$Maybe$Nothing,
									model.PB).EC),
							ac5: $author$project$Components$CreatePatientModal$Created(patient),
							y8: _Utils_update(
								model,
								{kj: false}),
							as: _List_Nil
						};
					case 2:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$CreatePatientModal$None,
							y8: _Utils_update(
								model,
								{kj: false}),
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$CreatePatientModal$None,
							y8: _Utils_update(
								model,
								{kj: false}),
							as: _List_Nil
						};
				}
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField = F6(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var dateInputEvent = _v0.c;
		var _v1 = function () {
			if (dateInputEvent.$ === 1) {
				var date = dateInputEvent.a;
				var field_ = toField(date);
				return _Utils_Tuple2(
					A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate,
						toField(date),
						model.PB),
					$elm$core$Maybe$Just(field_));
			} else {
				return _Utils_Tuple2(model.PB, $elm$core$Maybe$Nothing);
			}
		}();
		var newForm = _v1.a;
		var field = _v1.b;
		return {
			EC: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			ac5: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(1),
					field)),
			y8: A2(
				dateInputSetter,
				newDateInput,
				_Utils_update(
					model,
					{PB: newForm})),
			as: _List_Nil
		};
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var membershipPatient = $author$project$Utils$Form$fields(model.PB);
				var newMembershipPatient = _Utils_update(
					membershipPatient,
					{
						DV: $elm$core$Maybe$Just('restart'),
						abM: $elm$core$Maybe$Nothing,
						abN: $elm$core$Maybe$Nothing,
						qs: $elm$core$Maybe$Nothing
					});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 3,
					y8: _Utils_update(
						model,
						{
							PB: A2($author$project$Utils$Form$set, newMembershipPatient, model.PB),
							aN: false
						}),
					as: _List_Nil
				};
			case 1:
				var endDate = msg.a;
				var membershipPatient = $author$project$Utils$Form$fields(model.PB);
				var _v2 = function () {
					if (_Utils_eq(
						membershipPatient.DV,
						$elm$core$Maybe$Just('create'))) {
						return _Utils_Tuple2(2, membershipPatient);
					} else {
						var newMembershipPatient_ = _Utils_update(
							membershipPatient,
							{
								DV: $elm$core$Maybe$Just('terminate'),
								qs: endDate
							});
						return _Utils_Tuple2(1, newMembershipPatient_);
					}
				}();
				var event = _v2.a;
				var newMembershipPatient = _v2.b;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: event,
					y8: _Utils_update(
						model,
						{
							PB: A2($author$project$Utils$Form$set, newMembershipPatient, model.PB),
							aN: true
						}),
					as: _List_Nil
				};
			case 2:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 3:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rU);
				var _v3 = function () {
					var _v4 = patientResourceResult.ac5;
					_v4$2:
					while (true) {
						if ((!_v4.$) && (!_v4.a.$)) {
							switch (_v4.a.a.$) {
								case 0:
									var patient = _v4.a.a.a;
									var patientRecord = $author$project$Components$Membership$Form$Records$patientFromAll(patient);
									var field = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient(
										$elm$core$Maybe$Just(patientRecord));
									var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.PB);
									return _Utils_Tuple3(
										newForm_,
										_Utils_eq(patientRecord.aaI, $elm$core$Maybe$Nothing),
										1);
								case 2:
									var _v5 = _v4.a.a;
									var field = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient($elm$core$Maybe$Nothing);
									var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.PB);
									return _Utils_Tuple3(newForm_, false, 1);
								default:
									break _v4$2;
							}
						} else {
							break _v4$2;
						}
					}
					return _Utils_Tuple3(model.PB, model.d_, 0);
				}();
				var newForm = _v3.a;
				var editTobaccoUsage = _v3.b;
				var event = _v3.c;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg, patientResourceResult.EC),
					ac5: event,
					y8: _Utils_update(
						model,
						{d_: editTobaccoUsage, PB: newForm, rU: patientResourceResult.y8}),
					as: patientResourceResult.as
				};
			case 4:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{qm: true}),
					as: _List_Nil
				};
			case 5:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField,
					model,
					function ($) {
						return $.qy;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{qy: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOn);
			case 6:
				var date = msg.a;
				var field = $author$project$Components$Membership$Form$Members$MembershipPatient$StartDate(date);
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{qn: true, PB: newForm}),
					as: _List_Nil
				};
			case 7:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField,
					model,
					function ($) {
						return $.kg;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{kg: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$StartDate);
			case 8:
				var fields = $author$project$Utils$Form$fields(model.PB);
				var specialRate = model.eb ? $elm$core$Maybe$Nothing : fields._n;
				var newFields = _Utils_update(
					fields,
					{_n: specialRate});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{
							PB: A2($author$project$Utils$Form$set, newFields, model.PB),
							eb: !model.eb
						}),
					as: _List_Nil
				};
			case 9:
				var defaultValue = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var fixedPeriodRateInCents = function () {
					var _v6 = _Utils_Tuple2(model.dZ, fields.Pw);
					if (_v6.a) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (!_v6.b.$) {
							var fixedPeriodRateInCents_ = _v6.b.a;
							return $elm$core$Maybe$Just(fixedPeriodRateInCents_);
						} else {
							var _v7 = _v6.b;
							return defaultValue;
						}
					}
				}();
				var newFields = _Utils_update(
					fields,
					{Pw: fixedPeriodRateInCents});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{
							dZ: !model.dZ,
							PB: A2($author$project$Utils$Form$set, newFields, model.PB)
						}),
					as: _List_Nil
				};
			case 10:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField,
					model,
					function ($) {
						return $.qu;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{qu: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EndDate);
			case 11:
				var patient = msg.a;
				var _v8 = A6($author$project$Components$CreatePatientModal$init, apiClient, model.cO, model.ZD, model.WF, model.adN, patient);
				var createPatientModal = _v8.a;
				var createPatientModalCmd = _v8.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg, createPatientModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							h$: $elm$core$Maybe$Just(createPatientModal)
						}),
					as: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v9 = model.h$;
				if (!_v9.$) {
					var createPatientModal = _v9.a;
					var createPatientModalResult = A3($author$project$Components$CreatePatientModal$update, apiClient, subMsg, createPatientModal);
					var _v10 = function () {
						var _v11 = createPatientModalResult.ac5;
						switch (_v11.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createPatientModalResult.y8),
									$elm$core$Maybe$Nothing,
									_List_Nil);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _List_Nil);
							default:
								var patient = _v11.a;
								var outMsgs_ = model.iX ? _List_Nil : _List_fromArray(
									[
										A2(
										$author$project$OutMsg$ShowToast,
										3,
										$author$project$Api$Provider$Patient$One$name(patient) + ' was added as a new patient to this membership. Click \" Update \" to confirm adding them to this membership.')
									]);
								var field_ = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient(
									$elm$core$Maybe$Just(
										$author$project$Components$Membership$Form$Records$patientFromOne(patient)));
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just(field_),
									outMsgs_);
						}
					}();
					var createPatientModal_ = _v10.a;
					var field = _v10.b;
					var outMsgs = _v10.c;
					var editTobaccoUsage = function () {
						if (((!field.$) && (!field.a.$)) && (!field.a.a.$)) {
							var patientRecord = field.a.a.a;
							return _Utils_eq(patientRecord.aaI, $elm$core$Maybe$Nothing);
						} else {
							return model.d_;
						}
					}();
					var _v12 = A2(
						$elm$core$Maybe$withDefault,
						_Utils_Tuple2(model.PB, 0),
						A2(
							$elm$core$Maybe$map,
							function (field_) {
								var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field_, model.PB);
								return _Utils_Tuple2(newForm_, 1);
							},
							field));
					var newForm = _v12.a;
					var event = _v12.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg, createPatientModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{h$: createPatientModal_, d_: editTobaccoUsage, PB: newForm}),
						as: _Utils_ap(createPatientModalResult.as, outMsgs)
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var memberType = msg.a;
				var patient = msg.b;
				var startDate = msg.c;
				var response = msg.d;
				if (response.$ === 3) {
					var membershipPatient = response.a;
					var membershipPatientRecord = A5($author$project$Components$Membership$Form$Records$membershipPatientFromNew, model.cO, membershipPatient, memberType, patient, startDate);
					var _v2 = A9($author$project$Components$Membership$Form$Members$MembershipPatient$init, apiClient, model.cO, model.ZD, model.WF, model.adN, model.iX, membershipPatientRecord.VM, $elm$core$Maybe$Nothing, membershipPatientRecord);
					var membershipPatientModel = _v2.a;
					var membershipPatientCmd = _v2.b;
					var membershipPatients = A3(
						$elm$core$Dict$insert,
						membershipPatientRecord.adR,
						_Utils_Tuple2(
							$elm$core$Dict$size(model.TF),
							membershipPatientModel),
						model.TF);
					return {
						EC: A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.adR),
							membershipPatientCmd),
						ac5: 1,
						y8: _Utils_update(
							model,
							{TF: membershipPatients}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$reportDecodeError(response)
					};
				}
			case 1:
				var memberType = msg.a;
				var startDate = msg.b;
				return {
					EC: A4($author$project$Components$Membership$Form$Sections$Members$addMember, apiClient, memberType, $elm$core$Maybe$Nothing, startDate),
					ac5: 0,
					y8: model,
					as: _List_Nil
				};
			default:
				var id = msg.a;
				var subMsg = msg.b;
				var _v3 = A2($elm$core$Dict$get, id, model.TF);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var originalIndex = _v4.a;
					var membershipPatient = _v4.b;
					var membershipPatientResult = A3($author$project$Components$Membership$Form$Members$MembershipPatient$update, apiClient, subMsg, membershipPatient);
					var _v5 = function () {
						var _v6 = membershipPatientResult.ac5;
						switch (_v6) {
							case 0:
								return _Utils_Tuple2(
									A3(
										$elm$core$Dict$insert,
										id,
										_Utils_Tuple2(originalIndex, membershipPatientResult.y8),
										model.TF),
									0);
							case 1:
								var newMembershipPatients_ = A3(
									$elm$core$Dict$insert,
									id,
									_Utils_Tuple2(originalIndex, membershipPatientResult.y8),
									model.TF);
								return _Utils_Tuple2(newMembershipPatients_, 1);
							case 2:
								var newMembershipPatients_ = A2($elm$core$Dict$remove, id, model.TF);
								return _Utils_Tuple2(newMembershipPatients_, 1);
							default:
								var newMembershipPatients_ = A3(
									$elm$core$Dict$insert,
									id,
									_Utils_Tuple2(originalIndex, membershipPatientResult.y8),
									model.TF);
								return _Utils_Tuple2(newMembershipPatients_, 1);
						}
					}();
					var newMembershipPatients = _v5.a;
					var event = _v5.b;
					return {
						EC: A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id),
							membershipPatientResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{TF: newMembershipPatients}),
						as: membershipPatientResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDate = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$Created = 2;
var $author$project$Components$Membership$Form$Sections$PlanChange$Deleted = 1;
var $author$project$Components$Membership$Form$Sections$PlanChange$GotDeletedResponse = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$None = 0;
var $author$project$Components$Membership$Form$Sections$PlanChange$ToPlan = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$Updated = 3;
var $author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath = function (membershipId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['scheduled_changes']),
		$author$project$Api$Provider$Membership$membershipPath(membershipId));
};
var $author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath = F2(
	function (membershipId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath(membershipId));
	});
var $author$project$Api$Provider$Membership$ScheduledChange$delete = F4(
	function (apiClient, membershipId, id, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2($author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath, membershipId, id)));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var type_ = field.a;
				return _Utils_update(
					fields,
					{ahI: type_});
			case 1:
				var dateInput = field.a;
				var date = field.b;
				return _Utils_update(
					fields,
					{KO: date, v_: dateInput});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						KN: $elm$core$String$toInt(string)
					});
			default:
				var planId = field.a;
				return _Utils_update(
					fields,
					{$J: planId});
		}
	});
var $author$project$Api$Provider$MembershipScheduledChange$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Membership$Form$Sections$PlanChange$initFormFields = F2(
	function (contract, membershipMeta) {
		var type_ = contract.OY ? 2 : 1;
		var _v0 = $author$project$Components$DateInput$init;
		var changeOnDateDateInput = _v0.a;
		var changeOnDateDateInputCmd = _v0.b;
		return _Utils_Tuple2(
			{KN: $elm$core$Maybe$Nothing, KO: $elm$core$Maybe$Nothing, v_: changeOnDateDateInput, EH: contract, F5: membershipMeta, $J: $elm$core$Maybe$Nothing, ahI: type_},
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg(changeOnDateDateInput),
				changeOnDateDateInputCmd));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$GotCreatedResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$GotUpdatedResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$apiFields = function (validFormFields) {
	var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
	var changeOnDate = _v0.KO;
	var changeAfterMonths = _v0.KN;
	var toPlan = _v0.$J;
	return {KN: changeAfterMonths, KO: changeOnDate, $J: toPlan};
};
var $author$project$Api$Provider$MembershipScheduledChange$One$MembershipScheduledChange = 0;
var $author$project$Api$Provider$MembershipScheduledChange$One$decoder = $elm$json$Json$Decode$succeed(0);
var $author$project$Api$Provider$Membership$ScheduledChange$create = F4(
	function (apiClient, membershipId, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'scheduled_change',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'change_after_months',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.KN)),
								_Utils_Tuple2(
								'change_on_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.KO)),
								_Utils_Tuple2(
								'to_plan',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.$J))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$MembershipScheduledChange$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath(membershipId))));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$ToPlanValidation = 2;
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonthsValidation = 1;
var $author$project$Components$Membership$Form$Sections$PlanChange$validateChangeAfterMonths = function (fields) {
	var _v0 = _Utils_Tuple2(fields.ahI, fields.KN);
	if (_v0.a === 1) {
		if (!_v0.b.$) {
			var _v1 = _v0.a;
			var changeAfterMonths = _v0.b.a;
			return ((changeAfterMonths >= 1) && (changeAfterMonths <= 48)) ? _List_Nil : _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a number between 1 and 48')
				]);
		} else {
			var _v2 = _v0.a;
			var _v3 = _v0.b;
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a number.')
				]);
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateValidation = 0;
var $author$project$Components$Membership$Form$Sections$PlanChange$validateChangeOnDate = F2(
	function (currentDate, fields) {
		var _v0 = _Utils_Tuple2(fields.ahI, fields.KO);
		if (!_v0.a) {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var changeOnDate = _v0.b.a;
				var tomorrowDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
				return (A2($justinmimbs$date$Date$compare, tomorrowDate, changeOnDate) !== 2) ? _List_Nil : _List_fromArray(
					[
						_Utils_Tuple2(0, 'Please enter a date greater or equal than tomorrow')
					]);
			} else {
				var _v2 = _v0.a;
				var _v3 = _v0.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(0, 'Please enter a date.')
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsValidator = function (currentDate) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Components$Membership$Form$Sections$PlanChange$validateChangeOnDate(currentDate)),
				$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$PlanChange$validateChangeAfterMonths),
				A2(
				$rtfeldman$elm_validate$Validate$ifNothing,
				function ($) {
					return $.$J;
				},
				_Utils_Tuple2(2, 'Please pick a plan'))
			]));
};
var $author$project$Api$Provider$Membership$ScheduledChange$update = F5(
	function (apiClient, membershipId, id, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'scheduled_change',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'change_after_months',
								A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.KN)),
								_Utils_Tuple2(
								'change_on_date',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.KO)),
								_Utils_Tuple2(
								'to_plan',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.$J))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$MembershipScheduledChange$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath, membershipId, id))));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$save = F3(
	function (apiClient, id, model) {
		var _v0 = _Utils_Tuple3(
			model.yS,
			A2(
				$elm$core$Maybe$map,
				$author$project$Utils$Form$validate(
					$author$project$Components$Membership$Form$Sections$PlanChange$formFieldsValidator(model.cO)),
				model.PB),
			id);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			if (_v0.b.a.$ === 1) {
				var newForm = _v0.b.a.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							PB: $elm$core$Maybe$Just(newForm)
						}),
					as: _List_Nil
				};
			} else {
				if (!_v0.c.$) {
					var membershipId = _v0.a.a;
					var _v1 = _v0.b.a.a;
					var newForm = _v1.a;
					var validFormFields = _v1.b;
					var id_ = _v0.c.a;
					return {
						EC: A5(
							$author$project$Api$Provider$Membership$ScheduledChange$update,
							apiClient,
							membershipId,
							id_,
							$author$project$Components$Membership$Form$Sections$PlanChange$apiFields(validFormFields),
							$author$project$Components$Membership$Form$Sections$PlanChange$GotUpdatedResponse),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								jY: $author$project$Api$Data$Loading
							}),
						as: _List_Nil
					};
				} else {
					var membershipId = _v0.a.a;
					var _v2 = _v0.b.a.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					var _v3 = _v0.c;
					return {
						EC: A4(
							$author$project$Api$Provider$Membership$ScheduledChange$create,
							apiClient,
							membershipId,
							$author$project$Components$Membership$Form$Sections$PlanChange$apiFields(validFormFields),
							$author$project$Components$Membership$Form$Sections$PlanChange$GotCreatedResponse),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm),
								jY: $author$project$Api$Data$Loading
							}),
						as: _List_Nil
					};
				}
			}
		} else {
			return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
		}
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$updateDateInputFormField = F6(
	function (model, dateInput, subMsg, toMsg, field, fieldGetter) {
		var _v0 = model.PB;
		if (!_v0.$) {
			var form = _v0.a;
			var _v1 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
			var newDateInput = _v1.a;
			var subCmd = _v1.b;
			var event = _v1.c;
			var newForm = function () {
				if (event.$ === 1) {
					var date = event.a;
					return A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate,
						A2(field, newDateInput, date),
						form);
				} else {
					var fields = $author$project$Utils$Form$fields(form);
					return A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate,
						A2(
							field,
							newDateInput,
							fieldGetter(fields)),
						form);
				}
			}();
			return {
				EC: A2(
					$elm$core$Platform$Cmd$map,
					toMsg(newDateInput),
					subCmd),
				ac5: 0,
				y8: _Utils_update(
					model,
					{
						PB: $elm$core$Maybe$Just(newForm)
					}),
				as: _List_Nil
			};
		} else {
			return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
		}
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var contract = msg.a;
				var membershipMeta = msg.b;
				var _v2 = A2($author$project$Components$Membership$Form$Sections$PlanChange$initFormFields, contract, membershipMeta);
				var formFields = _v2.a;
				var formFieldsCmd = _v2.b;
				return {
					EC: formFieldsCmd,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							PB: $elm$core$Maybe$Just(
								$author$project$Utils$Form$init(formFields))
						}),
					as: _List_Nil
				};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 2:
				var membershipId = msg.a;
				var scheduledChange = msg.b;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple3(membershipId, $author$project$Api$Data$NotAsked, scheduledChange))
						}),
					as: _List_Nil
				};
			case 7:
				var membershipId = msg.a;
				var scheduledChange = msg.b;
				var confirmed = msg.c;
				return confirmed ? {
					EC: A4(
						$author$project$Api$Provider$Membership$ScheduledChange$delete,
						apiClient,
						membershipId,
						$author$project$Api$Provider$MembershipScheduledChange$Shared$id(scheduledChange),
						A2($author$project$Components$Membership$Form$Sections$PlanChange$GotDeletedResponse, membershipId, scheduledChange)),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple3(membershipId, $author$project$Api$Data$Loading, scheduledChange))
						}),
					as: _List_Nil
				} : {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{fm: $elm$core$Maybe$Nothing}),
					as: _List_Nil
				};
			case 3:
				var field = msg.a;
				var _v3 = model.PB;
				if (!_v3.$) {
					var form = _v3.a;
					var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate, field, form);
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								PB: $elm$core$Maybe$Just(newForm)
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 4:
				var dateInput = msg.a;
				var subMsg = msg.b;
				return A6(
					$author$project$Components$Membership$Form$Sections$PlanChange$updateDateInputFormField,
					model,
					dateInput,
					subMsg,
					$author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg,
					$author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDate,
					function ($) {
						return $.KO;
					});
			case 5:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jw);
				var newForm = A2(
					$elm$core$Maybe$map,
					function (form) {
						var _v4 = planResourceResult.ac5;
						if ((!_v4.$) && (!_v4.a.$)) {
							var planId = $author$project$Components$ResourceFilter$Plan$value(planResourceResult.y8);
							return A3(
								$author$project$Utils$Form$update,
								$author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate,
								$author$project$Components$Membership$Form$Sections$PlanChange$ToPlan(planId),
								form);
						} else {
							return form;
						}
					},
					model.PB);
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg, planResourceResult.EC),
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm, jw: planResourceResult.y8}),
					as: planResourceResult.as
				};
			case 8:
				var membershipId = msg.a;
				var scheduledChange = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{fm: $elm$core$Maybe$Nothing}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change removed.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								fm: $elm$core$Maybe$Just(
									_Utils_Tuple3(membershipId, $author$project$Api$Data$NotAsked, scheduledChange))
							}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 6:
				var id = msg.a;
				return A3($author$project$Components$Membership$Form$Sections$PlanChange$save, apiClient, id, model);
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change applied.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 3,
						y8: _Utils_update(
							model,
							{jY: response}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change applied.')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$Pricing$None = 0;
var $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSelectMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$Updated = 1;
var $author$project$Components$Membership$Form$Sections$Pricing$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var currency = field.a;
				return _Utils_update(
					fields,
					{Pw: currency});
			case 1:
				var coupon = field.a;
				return _Utils_update(
					fields,
					{
						L1: $author$project$Utils$String$toMaybe(coupon)
					});
			default:
				var currency = field.a;
				return _Utils_update(
					fields,
					{Px: currency});
		}
	});
var $author$project$Api$Provider$MembershipBill$Shared$registrationFeeInCents = function (_v0) {
	var record = _v0;
	return record.X5;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$registrationFeeInCents(shared);
};
var $author$project$Api$Provider$Membership$One$revenueInCents = function (_v0) {
	var record = _v0.b;
	return record.YF;
};
var $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills = function (_v0) {
	var record = _v0.b;
	return record.aan;
};
var $author$project$Components$Membership$Form$Sections$Pricing$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{wR: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 1:
				var pendingMembership = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var manuallySet = fields.cb;
				var fixedPeriodRateInCents = function () {
					var _v2 = _Utils_Tuple2(manuallySet.XJ, fields.Pw);
					if (_v2.a) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (!_v2.b.$) {
							var fixedPeriodRateInCents_ = _v2.b.a;
							return $elm$core$Maybe$Just(fixedPeriodRateInCents_);
						} else {
							var _v3 = _v2.b;
							return $elm$core$Maybe$Just(
								$author$project$Currency$fromInt(
									$author$project$Api$Provider$Membership$One$revenueInCents(pendingMembership)));
						}
					}
				}();
				var newFields = _Utils_update(
					fields,
					{
						Pw: fixedPeriodRateInCents,
						cb: _Utils_update(
							manuallySet,
							{XJ: !manuallySet.XJ})
					});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{
							PB: A2($author$project$Utils$Form$set, newFields, model.PB)
						}),
					as: _List_Nil
				};
			case 2:
				var pendingMembership = msg.a;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var manuallySet = fields.cb;
				var fixedRegistrationFeeInCents = function () {
					var _v4 = _Utils_Tuple2(manuallySet.et, fields.Px);
					if (_v4.a) {
						return $elm$core$Maybe$Nothing;
					} else {
						if (!_v4.b.$) {
							var fixedRegistrationFeeInCents_ = _v4.b.a;
							return $elm$core$Maybe$Just(fixedRegistrationFeeInCents_);
						} else {
							var _v5 = _v4.b;
							return A2(
								$elm$core$Maybe$map,
								$author$project$Currency$fromInt,
								A2(
									$elm$core$Maybe$andThen,
									$author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents,
									$elm$core$List$head(
										$author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership))));
						}
					}
				}();
				var newFields = _Utils_update(
					fields,
					{
						Px: fixedRegistrationFeeInCents,
						cb: _Utils_update(
							manuallySet,
							{et: !manuallySet.et})
					});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{
							PB: A2($author$project$Utils$Form$set, newFields, model.PB)
						}),
					as: _List_Nil
				};
			case 3:
				var fields = $author$project$Utils$Form$fields(model.PB);
				var newFields = model.N7 ? _Utils_update(
					fields,
					{L1: $elm$core$Maybe$Nothing}) : fields;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{
							N7: !model.N7,
							PB: A2($author$project$Utils$Form$set, newFields, model.PB)
						}),
					as: _List_Nil
				};
			case 4:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$Pricing$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 5:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{AK: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 6:
				var _v6 = function () {
					if (model.lX) {
						var fields = $author$project$Utils$Form$fields(model.PB);
						return _Utils_Tuple2(
							$elm$core$Maybe$Nothing,
							A2(
								$author$project$Utils$Form$set,
								_Utils_update(
									fields,
									{V3: $elm$core$Maybe$Nothing}),
								model.PB));
					} else {
						return _Utils_Tuple2(model.j1, model.PB);
					}
				}();
				var newSelectedPaymentMethod = _v6.a;
				var newForm = _v6.b;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{lX: !model.lX, PB: newForm, j1: newSelectedPaymentMethod}),
					as: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Ui$Form$SearchableSelect$update, subMsg, model.rW);
				var newSelect = _v7.a;
				var selectCmd = _v7.b;
				var maybeEvent = _v7.c;
				var _v8 = function () {
					if ((!maybeEvent.$) && (!maybeEvent.a.$)) {
						var maybePaymentMethod = maybeEvent.a.a;
						var newPaymentSource = function () {
							if (!maybePaymentMethod.$) {
								var pm = maybePaymentMethod.a;
								return $elm$core$Maybe$Just(
									{
										adR: $elm$core$Maybe$Just(
											$author$project$Api$Provider$PaymentMethod$Min$id(pm))
									});
							} else {
								return $elm$core$Maybe$Just(
									{adR: $elm$core$Maybe$Nothing});
							}
						}();
						var fields = $author$project$Utils$Form$fields(model.PB);
						return _Utils_Tuple3(
							A2(
								$author$project$Utils$Form$set,
								_Utils_update(
									fields,
									{V3: newPaymentSource}),
								model.PB),
							maybePaymentMethod,
							1);
					} else {
						return _Utils_Tuple3(model.PB, model.j1, 0);
					}
				}();
				var newForm = _v8.a;
				var newSelectedPaymentMethod = _v8.b;
				var event = _v8.c;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSelectMsg, selectCmd),
					ac5: event,
					y8: _Utils_update(
						model,
						{PB: newForm, rW: newSelect, j1: newSelectedPaymentMethod}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$None = 0;
var $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Updated = 1;
var $author$project$Api$Provider$Uom$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Wc;
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate = F3(
	function (index, field, fields) {
		var recurringCharges = A3(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			function (recurringCharge) {
				switch (field.$) {
					case 0:
						var _int = field.a;
						var quantity = function () {
							var _v1 = _Utils_Tuple2(
								$author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.aam),
								_int);
							if ((!_v1.a.$) && (!_v1.b.$)) {
								var chargeItemPeriod = _v1.a.a;
								var periodInMonths = _v1.b.a;
								return $elm$core$Maybe$Just((periodInMonths / chargeItemPeriod) | 0);
							} else {
								return recurringCharge.Bd;
							}
						}();
						return _Utils_update(
							recurringCharge,
							{Wc: _int, Bd: quantity});
					case 1:
						var _int = field.a;
						return _Utils_update(
							recurringCharge,
							{afL: _int});
					default:
						var _int = field.a;
						return _Utils_update(
							recurringCharge,
							{Bd: _int});
				}
			},
			fields.XZ);
		return _Utils_update(
			fields,
			{XZ: recurringCharges});
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initChargeItemResourceFilter = F2(
	function (apiClient, showItemTypeInTitle) {
		return A4(
			$author$project$Components$ResourceFilter$ChargeItem$initWithItemType,
			showItemTypeInTitle,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						$u: $elm$core$Maybe$Just(false)
					});
			},
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select an item', IS: true});
			});
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFields = function (patient) {
	return {lp: $elm$core$Maybe$Nothing, ads: $elm$core$Maybe$Nothing, adt: $elm$core$Maybe$Nothing, VM: patient, afL: $elm$core$Maybe$Nothing, afS: $elm$core$Maybe$Nothing, aam: $elm$core$Maybe$Nothing};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFieldsFromItem = function (recurringCharge) {
	return {
		lp: $elm$core$Maybe$Just(recurringCharge.lp),
		ads: recurringCharge.ads,
		adt: A2($elm$core$Maybe$map, $author$project$Currency$fromFloat, recurringCharge.adt),
		VM: recurringCharge.VM,
		afL: recurringCharge.afL,
		afS: recurringCharge.afS,
		aam: $elm$core$Maybe$Just(recurringCharge.aam)
	};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initLimitedPatientSelector = F3(
	function (apiClient, patients, patient) {
		return A4(
			$author$project$Components$LimitedPatientSelector$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Select a Patient', IS: true});
			},
			patients,
			patient);
	});
var $author$project$Components$ResourceFilter$Practitioner$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bb);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bb: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initPractitionerResourceFilter = F2(
	function (apiClient, practitioner) {
		return function (_v0) {
			var practitionerResourceFilter = _v0.a;
			var practitionerResourceFilterCmd = _v0.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(practitionerResourceFilter, practitionerResourceFilterCmd),
				A2(
					$elm$core$Maybe$map,
					function (practitioner_) {
						var _v1 = A2(
							$author$project$Components$ResourceFilter$Practitioner$preSelectedId,
							$elm$core$Maybe$Just(practitioner_.adR),
							practitionerResourceFilter);
						var withPreSelectedModel = _v1.a;
						var withPreSelectedCmd = _v1.b;
						return _Utils_Tuple2(
							A2(
								$author$project$Components$ResourceFilter$Practitioner$extraItems,
								_List_fromArray(
									[
										{adR: practitioner_.adR, zh: practitioner_.adR}
									]),
								withPreSelectedModel),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[withPreSelectedCmd, practitionerResourceFilterCmd])));
					},
					practitioner));
		}(
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'Unassigned'});
				}));
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init = F6(
	function (apiClient, showItemTypeInTitle, patients, patient, index, recurringCharge) {
		var formFields = function () {
			if (!recurringCharge.$) {
				var recurringCharge_ = recurringCharge.a;
				return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFieldsFromItem(recurringCharge_);
			} else {
				return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFields(patient);
			}
		}();
		var _v0 = A2(
			$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initPractitionerResourceFilter,
			apiClient,
			A2(
				$elm$core$Maybe$andThen,
				function ($) {
					return $.afS;
				},
				recurringCharge));
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		var _v1 = A3($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initLimitedPatientSelector, apiClient, patients, formFields.VM);
		var limitedPatientSelector = _v1.a;
		var limitedPatientSelectorCmd = _v1.b;
		var _v2 = A2($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initChargeItemResourceFilter, apiClient, showItemTypeInTitle);
		var chargeItemResourceFilter = _v2.a;
		var chargeItemResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			{
				cK: chargeItemResourceFilter,
				PB: $author$project$Utils$Form$init(formFields),
				x4: index,
				rd: limitedPatientSelector,
				jC: practitionerResourceFilter
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
					])));
	});
var $author$project$Components$Membership$Form$Records$recurringChargeFromNew = function (newRecurringCharge) {
	var _v0 = _Utils_Tuple2(newRecurringCharge.lp, newRecurringCharge.aam);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var chargeItem = _v0.a.a;
		var uom = _v0.b.a;
		return $elm$core$Maybe$Just(
			{
				lp: chargeItem,
				ads: $elm$core$Maybe$Nothing,
				adt: $elm$core$Maybe$Nothing,
				adR: $elm$core$Maybe$Nothing,
				zh: $elm$core$Maybe$Nothing,
				UC: $elm$core$Maybe$Nothing,
				VM: newRecurringCharge.VM,
				Wc: $elm$core$Maybe$Just(
					A2(
						$elm$core$Maybe$withDefault,
						1,
						$author$project$Api$Provider$Uom$Shared$periodInMonths(uom))),
				We: newRecurringCharge.afL,
				afL: newRecurringCharge.afL,
				afS: newRecurringCharge.afS,
				Bd: $elm$core$Maybe$Just(1),
				_E: $elm$core$Maybe$Nothing,
				aam: uom
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Added = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Closed = {$: 1};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None = {$: 0};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Updated = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Records$chargeItemFromResourceFilter = function (chargeItem) {
	return {Nx: chargeItem.Nx, adR: chargeItem.adR, zh: chargeItem.zh, Ba: chargeItem.Ba};
};
var $author$project$Components$Membership$Form$Records$patientFromLimitedPatientSelector = $elm$core$Basics$identity;
var $author$project$Components$Membership$Form$Records$practitionerFromResourceFilter = function (practitioner) {
	return {adR: practitioner.adR, zh: practitioner.zh};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var patient = field.a;
				return _Utils_update(
					fields,
					{
						VM: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromLimitedPatientSelector, patient),
						afS: A2(
							$elm$core$Maybe$andThen,
							function ($) {
								return $.afS;
							},
							patient)
					});
			case 1:
				var chargeItem = field.a;
				return _Utils_update(
					fields,
					{
						lp: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$chargeItemFromResourceFilter, chargeItem),
						aam: A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.aam;
							},
							chargeItem)
					});
			case 2:
				var practitioner = field.a;
				return _Utils_update(
					fields,
					{
						afS: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromResourceFilter, practitioner)
					});
			case 3:
				var currency = field.a;
				return _Utils_update(
					fields,
					{adt: currency});
			default:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						ads: $author$project$Utils$String$toMaybe(string)
					});
		}
	});
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemValidation = 1;
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PatientValidation = 0;
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.VM;
			},
			_Utils_Tuple2(0, 'Please pick a patient')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.lp;
			},
			_Utils_Tuple2(1, 'Please pick a charge item'))
		]));
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Closed, y8: model, as: _List_Nil};
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, field, model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 2:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, model.rd);
				var newForm = function () {
					var _v2 = patientResourceResult.ac5;
					_v2$2:
					while (true) {
						if (_v2.$ === 1) {
							switch (_v2.a.$) {
								case 0:
									var patient = _v2.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient(
											$elm$core$Maybe$Just(patient)),
										model.PB);
								case 3:
									var _v3 = _v2.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient($elm$core$Maybe$Nothing),
										model.PB);
								default:
									break _v2$2;
							}
						} else {
							break _v2$2;
						}
					}
					return model.PB;
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg, patientResourceResult.EC),
					ac5: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					y8: _Utils_update(
						model,
						{PB: newForm, rd: patientResourceResult.y8}),
					as: patientResourceResult.as
				};
			case 3:
				var subMsg = msg.a;
				var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cK);
				var newForm = function () {
					var _v4 = chargeItemResourceResult.ac5;
					_v4$2:
					while (true) {
						if ((!_v4.$) && (!_v4.a.$)) {
							switch (_v4.a.a.$) {
								case 0:
									var chargeItem = _v4.a.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem(
											$elm$core$Maybe$Just(chargeItem)),
										model.PB);
								case 2:
									var _v5 = _v4.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem($elm$core$Maybe$Nothing),
										model.PB);
								default:
									break _v4$2;
							}
						} else {
							break _v4$2;
						}
					}
					return model.PB;
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.EC),
					ac5: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					y8: _Utils_update(
						model,
						{cK: chargeItemResourceResult.y8, PB: newForm}),
					as: chargeItemResourceResult.as
				};
			case 4:
				var subMsg = msg.a;
				var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.jC);
				var newForm = function () {
					var _v6 = practitionerResourceResult.ac5;
					_v6$2:
					while (true) {
						if ((!_v6.$) && (!_v6.a.$)) {
							switch (_v6.a.a.$) {
								case 0:
									var practitioner = _v6.a.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner(
											$elm$core$Maybe$Just(practitioner)),
										model.PB);
								case 2:
									var _v7 = _v6.a.a;
									return A3(
										$author$project$Utils$Form$update,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate,
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner($elm$core$Maybe$Nothing),
										model.PB);
								default:
									break _v6$2;
							}
						} else {
							break _v6$2;
						}
					}
					return model.PB;
				}();
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
					ac5: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
					y8: _Utils_update(
						model,
						{PB: newForm, jC: practitionerResourceResult.y8}),
					as: practitionerResourceResult.as
				};
			default:
				var periodsRemaining = msg.a;
				var _v8 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsValidator, model.PB);
				if (!_v8.$) {
					var _v9 = _v8.a;
					var newForm = _v9.a;
					var validFormFields = _v9.b;
					var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var event = function () {
						var _v10 = model.x4;
						if (!_v10.$) {
							var index = _v10.a;
							return A2(
								$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Updated,
								index,
								_Utils_update(
									formFields,
									{afL: periodsRemaining}));
						} else {
							return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Added(
								_Utils_update(
									formFields,
									{afL: periodsRemaining}));
						}
					}();
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: event,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				} else {
					var newForm = _v8.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
						y8: _Utils_update(
							model,
							{PB: newForm}),
						as: _List_Nil
					};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					var taxableChargeItemsCount = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$String$toInt,
							A2($elm$core$Dict$get, 'x-total-count', headers)));
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{qL: taxableChargeItemsCount > 0}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 1:
				var index = msg.a;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate(index),
					$author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining(
						$elm$core$Maybe$Just(1)),
					model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 2:
				var index = msg.a;
				var formFields = $author$project$Utils$Form$fields(model.PB);
				var newFormFields = _Utils_update(
					formFields,
					{
						XZ: A2($elm_community$list_extra$List$Extra$removeAt, index, formFields.XZ)
					});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{
							PB: A2($author$project$Utils$Form$set, newFormFields, model.PB)
						}),
					as: _List_Nil
				};
			case 3:
				var patients = msg.a;
				var index = msg.b;
				var _v3 = $author$project$Utils$Form$fields(model.PB);
				var recurringCharges = _v3.XZ;
				var _v4 = A2($elm_community$list_extra$List$Extra$getAt, index, recurringCharges);
				if (!_v4.$) {
					var recurringCharge = _v4.a;
					var _v5 = A6(
						$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init,
						apiClient,
						model.Ci,
						patients,
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(index),
						$elm$core$Maybe$Just(recurringCharge));
					var createEditModal = _v5.a;
					var createEditModalCmd = _v5.b;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalCmd),
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								fg: $elm$core$Maybe$Just(createEditModal)
							}),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 4:
				var index = msg.a;
				var field = msg.b;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate(index),
					field,
					model.PB);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{PB: newForm}),
					as: _List_Nil
				};
			case 5:
				var patients = msg.a;
				var patient = $elm$core$List$head(patients);
				var _v6 = A6($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init, apiClient, model.Ci, patients, patient, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
				var createEditModal = _v6.a;
				var createEditModalCmd = _v6.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalCmd),
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							fg: $elm$core$Maybe$Just(createEditModal)
						}),
					as: _List_Nil
				};
			default:
				var subMsg = msg.a;
				var _v7 = model.fg;
				if (!_v7.$) {
					var createEditModal = _v7.a;
					var createEditModalResult = A3($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$update, apiClient, subMsg, createEditModal);
					var _v8 = function () {
						var _v9 = createEditModalResult.ac5;
						switch (_v9.$) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(createEditModalResult.y8),
									model.PB,
									0);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, model.PB, 0);
							case 2:
								var newRecurringCharge = _v9.a;
								var _v10 = $author$project$Components$Membership$Form$Records$recurringChargeFromNew(newRecurringCharge);
								if (!_v10.$) {
									var recurringCharge = _v10.a;
									var formFields = $author$project$Utils$Form$fields(model.PB);
									var newFormFields = _Utils_update(
										formFields,
										{
											XZ: _Utils_ap(
												formFields.XZ,
												_List_fromArray(
													[recurringCharge]))
										});
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										A2($author$project$Utils$Form$set, newFormFields, model.PB),
										1);
								} else {
									return _Utils_Tuple3($elm$core$Maybe$Nothing, model.PB, 0);
								}
							default:
								var index = _v9.a;
								var updatedRecurringCharge = _v9.b;
								var formFields = $author$project$Utils$Form$fields(model.PB);
								var newRecurringCharges = A3(
									$elm_community$list_extra$List$Extra$updateAt,
									index,
									function (recurringCharge) {
										return _Utils_update(
											recurringCharge,
											{
												ads: updatedRecurringCharge.ads,
												adt: A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, updatedRecurringCharge.adt),
												VM: updatedRecurringCharge.VM,
												afS: updatedRecurringCharge.afS
											});
									},
									formFields.XZ);
								var newFormFields = _Utils_update(
									formFields,
									{XZ: newRecurringCharges});
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2($author$project$Utils$Form$set, newFormFields, model.PB),
									1);
						}
					}();
					var newCreateEditModal = _v8.a;
					var newForm = _v8.b;
					var event = _v8.c;
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{fg: newCreateEditModal, PB: newForm}),
						as: createEditModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Membership$Form$Sections$Summary$NextBillDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$None = {$: 0};
var $author$project$Components$Membership$Form$Sections$Summary$Owner = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$Plan = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$StartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$Updated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$FormUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm = function (field) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Components$Membership$Form$Sections$Summary$FormUpdated(field);
		},
		$elm$core$Process$sleep(0));
};
var $author$project$Components$ResourceFilter$Plan$extraItems = F2(
	function (list_, model) {
		var extraItems_ = A2(
			$elm$core$List$map,
			function (item) {
				return {aej: item.zh, aaN: item.adR};
			},
			list_);
		return _Utils_update(
			model,
			{
				bb: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bb)
			});
	});
var $author$project$Components$Membership$Form$Sections$Summary$GotBrokerDeals = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals = F3(
	function (apiClient, isNew, membershipId) {
		return isNew ? $elm$core$Platform$Cmd$none : A3(
			$author$project$Api$Provider$BrokerDeal$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						ja: $elm$core$Maybe$Just(membershipId)
					});
			},
			$author$project$Components$Membership$Form$Sections$Summary$GotBrokerDeals);
	});
var $author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$Records$planFromApiPlan = function (plan) {
	return {
		adR: $author$project$Api$Plan$id(plan),
		zh: $author$project$Api$Plan$name(plan)
	};
};
var $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var patient = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{
							Vp: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromAll, patient)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var plan = field.a;
				var cmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (plan_) {
							var allowedPeriodInMonths = A2(
								$elm$core$List$map,
								$author$project$Api$Period$numberOfMonths,
								$author$project$Api$Plan$periods(plan_));
							return (!A2($elm$core$List$member, fields.Wc, allowedPeriodInMonths)) ? $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(
								$author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths(
									A2(
										$elm$core$Maybe$withDefault,
										1,
										$elm$core$List$head(allowedPeriodInMonths)))) : $elm$core$Platform$Cmd$none;
						},
						plan));
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{
							GH: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$planFromApiPlan, plan)
						}),
					cmd);
			case 2:
				var date = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{_E: date}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var date = field.a;
				var billDate = fields.eF ? date : $elm$core$Maybe$Nothing;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{vG: billDate, UC: date}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var bool = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{JH: bool}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var _int = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{Wc: _int}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var string = field.a;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{
							T3: $elm$core$String$toInt(string)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var bool = field.a;
				var billDate = bool ? fields.UC : $elm$core$Maybe$Nothing;
				return _Utils_Tuple2(
					_Utils_update(
						fields,
						{vG: billDate, eF: bool}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Components$ResourceFilter$Plan$preSelectedId = F2(
	function (id, model) {
		var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bb);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bb: resourceFilter}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod = function (_v0) {
	var record = _v0;
	return record.J0;
};
var $author$project$Api$Employer$Plan$All$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Employer$Plan$One$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Provider$Plan$All$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
};
var $author$project$Api$Plan$billsAtEndOfPeriod = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$billsAtEndOfPeriod(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$billsAtEndOfPeriod(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$billsAtEndOfPeriod(plan_);
	}
};
var $author$project$Components$Membership$Form$Sections$Summary$planBillsAtEndOfPeriodChanged = F2(
	function (pendingMembership, plan) {
		var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
		return !_Utils_eq(
			$author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod(pendingMembershipPlan),
			$author$project$Api$Plan$billsAtEndOfPeriod(plan));
	});
var $author$project$Components$Membership$Form$Sections$Summary$resetBillDate = F3(
	function (pendingMembership, newPlan, model) {
		if (A2($author$project$Components$Membership$Form$Sections$Summary$planBillsAtEndOfPeriodChanged, pendingMembership, newPlan)) {
			var fields = $author$project$Utils$Form$fields(model.PB);
			var newFields = _Utils_update(
				fields,
				{vG: $elm$core$Maybe$Nothing});
			return _Utils_update(
				model,
				{
					PB: A2($author$project$Utils$Form$set, newFields, model.PB)
				});
		} else {
			return model;
		}
	});
var $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths = function (_v0) {
	var record = _v0;
	return record.T3;
};
var $author$project$Api$Employer$Plan$All$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Employer$Plan$One$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$All$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
};
var $author$project$Api$Plan$minimumEnrollmentPeriodInMonths = function (plan) {
	switch (plan.$) {
		case 0:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(plan_);
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths(plan_);
		case 4:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(plan_);
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$minimumEnrollmentPeriodInMonths(plan_);
		case 6:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$All$minimumEnrollmentPeriodInMonths(plan_);
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths(plan_);
		default:
			var plan_ = plan.a;
			return $author$project$Api$Employer$Plan$One$minimumEnrollmentPeriodInMonths(plan_);
	}
};
var $author$project$Components$Membership$Form$Sections$Summary$planMinimumEnrollmentPeriodInMonthsChanged = F2(
	function (pendingMembership, plan) {
		var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
		return !_Utils_eq(
			$author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths(pendingMembershipPlan),
			$author$project$Api$Plan$minimumEnrollmentPeriodInMonths(plan));
	});
var $author$project$Components$Membership$Form$Sections$Summary$resetMinimumEnrollmentPeriod = F3(
	function (pendingMembership, newPlan, model) {
		if (A2($author$project$Components$Membership$Form$Sections$Summary$planMinimumEnrollmentPeriodInMonthsChanged, pendingMembership, newPlan)) {
			var show = model.of;
			var fields = $author$project$Utils$Form$fields(model.PB);
			var newFields = _Utils_update(
				fields,
				{
					T3: $author$project$Api$Plan$minimumEnrollmentPeriodInMonths(newPlan)
				});
			return _Utils_update(
				model,
				{
					PB: A2($author$project$Utils$Form$set, newFields, model.PB),
					of: _Utils_update(
						show,
						{eT: !show.eT})
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField = F6(
	function (model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
		var dateInput = dateInputGetter(model);
		var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
		var newDateInput = _v0.a;
		var subCmd = _v0.b;
		var dateInputEvent = _v0.c;
		var newFormCmd = function () {
			if (dateInputEvent.$ === 1) {
				var date = dateInputEvent.a;
				var field_ = toField(date);
				return $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(field_);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return {
			EC: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						newFormCmd,
						A2($elm$core$Platform$Cmd$map, toMsg, subCmd)
					])),
			ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
			y8: A2(dateInputSetter, newDateInput, model),
			as: _List_Nil
		};
	});
var $author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate = F3(
	function (membership, startDate, model) {
		var fields = $author$project$Utils$Form$fields(model.PB);
		var calculatedStartDate = $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership) ? A3(
			$justinmimbs$date$Date$add,
			1,
			$author$project$Api$Provider$Membership$One$periodInMonths(membership),
			startDate) : startDate;
		var nextBillDate = model.zy ? A2(
			$elm_community$list_extra$List$Extra$maximumBy,
			$justinmimbs$date$Date$toRataDie,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple2(
							fields.UC,
							$author$project$Api$Provider$Membership$One$nextBillDate(membership));
						if (!_v0.a.$) {
							var nextBillDate_ = _v0.a.a;
							return $elm$core$Maybe$Just(nextBillDate_);
						} else {
							if (!_v0.b.$) {
								var _v1 = _v0.a;
								var nextBillDate_ = _v0.b.a;
								return $elm$core$Maybe$Just(nextBillDate_);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}(),
						$elm$core$Maybe$Just(calculatedStartDate)
					]))) : $elm$core$Maybe$Just(calculatedStartDate);
		return _Utils_eq(nextBillDate, fields.UC) ? $elm$core$Platform$Cmd$none : $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(
			$author$project$Components$Membership$Form$Sections$Summary$NextBillDate(nextBillDate));
	});
var $author$project$Components$Membership$Form$Sections$Summary$update = F4(
	function (apiClient, sectionsShared, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var show = model.of;
				var _v2 = $author$project$Utils$Form$fields(model.PB);
				var owner = _v2.Vp;
				var _v3 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.rU, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (owner_) {
							var _v4 = A2(
								$author$project$Components$ResourceFilter$Patient$preSelectedId,
								$elm$core$Maybe$Just(owner_.adR),
								model.rU);
							var withPreSelectedModel = _v4.a;
							var withPreSelectedCmd = _v4.b;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$ResourceFilter$Patient$extraItems,
									_List_fromArray(
										[
											{IK: owner_.IK, adR: owner_.adR, TL: owner_.TL, zh: owner_.zh}
										]),
									withPreSelectedModel),
								withPreSelectedCmd);
						},
						owner));
				var patientResourceFilter = _v3.a;
				var patientResourceFilterCmd = _v3.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceFilterCmd),
					ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
					y8: _Utils_update(
						model,
						{
							rU: patientResourceFilter,
							of: _Utils_update(
								show,
								{Vp: !show.Vp})
						}),
					as: _List_Nil
				};
			case 1:
				var show = model.of;
				var _v5 = $author$project$Utils$Form$fields(model.PB);
				var plan = _v5.GH;
				var _v6 = A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model.jw, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (plan_) {
							var _v7 = A2(
								$author$project$Components$ResourceFilter$Plan$preSelectedId,
								$elm$core$Maybe$Just(plan_.adR),
								model.jw);
							var withPreSelectedModel = _v7.a;
							var withPreSelectedCmd = _v7.b;
							return _Utils_Tuple2(
								A2(
									$author$project$Components$ResourceFilter$Plan$extraItems,
									_List_fromArray(
										[
											{adR: plan_.adR, zh: plan_.zh}
										]),
									withPreSelectedModel),
								withPreSelectedCmd);
						},
						plan));
				var planResourceFilter = _v6.a;
				var planResourceFilterCmd = _v6.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceFilterCmd),
					ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
					y8: _Utils_update(
						model,
						{
							jw: planResourceFilter,
							of: _Utils_update(
								show,
								{GH: !show.GH})
						}),
					as: _List_Nil
				};
			case 2:
				var fields = $author$project$Utils$Form$fields(model.PB);
				var manuallySet = fields.cb;
				var newFields = _Utils_update(
					fields,
					{
						cb: _Utils_update(
							manuallySet,
							{_E: true})
					});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
					y8: _Utils_update(
						model,
						{
							PB: A2($author$project$Utils$Form$set, newFields, model.PB)
						}),
					as: _List_Nil
				};
			case 3:
				var show = model.of;
				var newModel = _Utils_update(
					model,
					{
						zy: true,
						of: _Utils_update(
							show,
							{UC: true})
					});
				var fields = $author$project$Utils$Form$fields(model.PB);
				var cmd = (!$author$project$Utils$Maybe$toBool(fields.UC)) ? A3(
					$author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate,
					sectionsShared.ja,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Api$Provider$Membership$One$startDate(sectionsShared.c6),
						fields._E),
					newModel) : $elm$core$Platform$Cmd$none;
				return {EC: cmd, ac5: $author$project$Components$Membership$Form$Sections$Summary$None, y8: newModel, as: _List_Nil};
			case 4:
				var show = model.of;
				var fields = $author$project$Utils$Form$fields(model.PB);
				var minimumEnrollmentPeriodInMonths = show.eT ? fields.T3 : $elm$core$Maybe$Nothing;
				var newFields = _Utils_update(
					fields,
					{T3: minimumEnrollmentPeriodInMonths});
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
					y8: _Utils_update(
						model,
						{
							PB: A2($author$project$Utils$Form$set, newFields, model.PB),
							of: _Utils_update(
								show,
								{eT: !show.eT})
						}),
					as: _List_Nil
				};
			case 5:
				var field = msg.a;
				var _v8 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate, field, model.PB);
				var newForm = _v8.a;
				var newFormCmd = _v8.b;
				var newModel = function () {
					if ((field.$ === 1) && (!field.a.$)) {
						var plan = field.a.a;
						return A2(
							$elm$core$Basics$composeL,
							A2($author$project$Components$Membership$Form$Sections$Summary$resetBillDate, sectionsShared.c6, plan),
							A2($author$project$Components$Membership$Form$Sections$Summary$resetMinimumEnrollmentPeriod, sectionsShared.c6, plan));
					} else {
						return $elm$core$Basics$identity;
					}
				}()(
					_Utils_update(
						model,
						{PB: newForm}));
				var updateNextBillCmd = function () {
					var _v9 = _Utils_Tuple2(
						A2(
							$author$project$Utils$Form$field,
							function ($) {
								return $._E;
							},
							newForm),
						_Utils_eq(
							A2(
								$author$project$Utils$Form$field,
								function ($) {
									return $._E;
								},
								newForm),
							A2(
								$author$project$Utils$Form$field,
								function ($) {
									return $._E;
								},
								model.PB)));
					if ((!_v9.a.$) && (!_v9.b)) {
						var newStartDate = _v9.a.a;
						return A3($author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate, sectionsShared.ja, newStartDate, newModel);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[updateNextBillCmd, newFormCmd])),
					ac5: $author$project$Components$Membership$Form$Sections$Summary$Updated(field),
					y8: newModel,
					as: _List_Nil
				};
			case 6:
				var subMsg = msg.a;
				var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rU);
				var _v11 = function () {
					var _v13 = patientResourceResult.ac5;
					if (((!_v13.$) && (!_v13.a.$)) && (!_v13.a.a.$)) {
						var patient = _v13.a.a.a;
						var field_ = $author$project$Components$Membership$Form$Sections$Summary$Owner(
							$elm$core$Maybe$Just(patient));
						var newForm_ = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate, field_, model.PB);
						return _Utils_Tuple2(
							newForm_,
							$elm$core$Maybe$Just(field_));
					} else {
						return _Utils_Tuple2(
							_Utils_Tuple2(model.PB, $elm$core$Platform$Cmd$none),
							$elm$core$Maybe$Nothing);
					}
				}();
				var _v12 = _v11.a;
				var newForm = _v12.a;
				var newFormCmd = _v12.b;
				var field = _v11.b;
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								newFormCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceResult.EC)
							])),
					ac5: A2(
						$elm$core$Maybe$withDefault,
						$author$project$Components$Membership$Form$Sections$Summary$None,
						A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Sections$Summary$Updated, field)),
					y8: _Utils_update(
						model,
						{PB: newForm, rU: patientResourceResult.y8}),
					as: patientResourceResult.as
				};
			case 7:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jw);
				var updateFormCmd = function () {
					var _v14 = planResourceResult.ac5;
					if (((!_v14.$) && (!_v14.a.$)) && (!_v14.a.a.$)) {
						var plan = _v14.a.a.a;
						return $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(
							$author$project$Components$Membership$Form$Sections$Summary$Plan(
								$elm$core$Maybe$Just(plan)));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								updateFormCmd,
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceResult.EC)
							])),
					ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
					y8: _Utils_update(
						model,
						{jw: planResourceResult.y8}),
					as: planResourceResult.as
				};
			case 8:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField,
					model,
					function ($) {
						return $.kg;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{kg: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg,
					$author$project$Components$Membership$Form$Sections$Summary$StartDate);
			case 9:
				var subMsg = msg.a;
				return A6(
					$author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField,
					model,
					function ($) {
						return $.ry;
					},
					F2(
						function (newDateInput, model_) {
							return _Utils_update(
								model_,
								{ry: newDateInput});
						}),
					subMsg,
					$author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg,
					$author$project$Components$Membership$Form$Sections$Summary$NextBillDate);
			case 10:
				var membership = msg.a;
				var _v15 = A5(
					$author$project$Components$BrokerDeal$CreateModal$init,
					apiClient,
					model.ZD,
					model.cO,
					model.Hz,
					{
						vJ: $elm$core$Maybe$Nothing,
						vK: $elm$core$Maybe$Nothing,
						Lp: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.WF),
						ab9: $elm$core$Maybe$Nothing,
						M2: 1,
						ja: $elm$core$Maybe$Just(membership),
						agv: false
					});
				var createModal = _v15.a;
				var createModalCmd = _v15.b;
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg, createModalCmd),
					ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
					y8: _Utils_update(
						model,
						{
							hY: $elm$core$Maybe$Just(
								_Utils_Tuple2(
									$author$project$Api$Provider$Membership$One$id(membership),
									createModal))
						}),
					as: _List_Nil
				};
			case 11:
				var subMsg = msg.a;
				var _v16 = model.hY;
				if (!_v16.$) {
					var _v17 = _v16.a;
					var membershipId = _v17.a;
					var createModal = _v17.b;
					var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, apiClient, subMsg, createModal);
					var _v18 = function () {
						var _v19 = createModalResult.ac5;
						switch (_v19) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(
										_Utils_Tuple2(membershipId, createModalResult.y8)),
									$elm$core$Platform$Cmd$none);
							case 1:
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							case 2:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A3($author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals, apiClient, model.iX, membershipId));
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A3($author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals, apiClient, model.iX, membershipId));
						}
					}();
					var createModal_ = _v18.a;
					var cmd = _v18.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg, createModalResult.EC),
									cmd
								])),
						ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
						y8: _Utils_update(
							model,
							{hY: createModal_}),
						as: createModalResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Membership$Form$Sections$Summary$None, y8: model, as: _List_Nil};
				}
			case 12:
				var response = msg.a;
				if (response.$ === 3) {
					var brokerDeals = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
						y8: _Utils_update(
							model,
							{
								J9: A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals)
							}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var subMsg = msg.a;
				var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, model.hy);
				return {
					EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg, auditTrailLogResult.EC),
					ac5: $author$project$Components$Membership$Form$Sections$Summary$None,
					y8: _Utils_update(
						model,
						{hy: auditTrailLogResult.y8}),
					as: auditTrailLogResult.as
				};
		}
	});
var $author$project$Api$Provider$Plan$All$contractExpires = function (_v0) {
	var record = _v0.b;
	return record.LP;
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires = function (_v0) {
	var record = _v0.b;
	return record.LP;
};
var $author$project$Api$Plan$contractExpires = function (plan) {
	switch (plan.$) {
		case 0:
			return false;
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires(plan_);
		case 4:
			return false;
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$contractExpires(plan_);
		case 6:
			return false;
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$contractExpires(plan_);
		default:
			return false;
	}
};
var $author$project$Api$Provider$Plan$All$contractPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.LQ;
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractPeriodInMonths = function (_v0) {
	var record = _v0.b;
	return record.LQ;
};
var $author$project$Api$Plan$contractPeriodInMonths = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractPeriodInMonths(plan_);
		case 4:
			return $elm$core$Maybe$Nothing;
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$contractPeriodInMonths(plan_);
		case 6:
			return $elm$core$Maybe$Nothing;
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$contractPeriodInMonths(plan_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Plan$All$contractType = function (_v0) {
	var record = _v0.b;
	return record.EI;
};
var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractType = function (_v0) {
	var record = _v0.b;
	return record.EI;
};
var $author$project$Api$Plan$contractType = function (plan) {
	switch (plan.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractType(plan_);
		case 4:
			return $elm$core$Maybe$Nothing;
		case 2:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$All$contractType(plan_);
		case 6:
			return $elm$core$Maybe$Nothing;
		case 3:
			var plan_ = plan.a;
			return $author$project$Api$Provider$Plan$One$contractType(plan_);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Membership$Form$Sections$Contracts$resetContractFields = F3(
	function (isNew, newPlan, _v0) {
		var model = _v0;
		if (isNew) {
			var fields = $author$project$Utils$Form$fields(model.PB);
			var newFields = ($author$project$Api$Plan$contractExpires(newPlan) ? function (f) {
				return _Utils_update(
					f,
					{
						qs: $elm$core$Maybe$Nothing,
						Wc: $author$project$Api$Plan$contractPeriodInMonths(newPlan),
						ahI: $author$project$Api$Plan$contractType(newPlan)
					});
			} : $elm$core$Basics$identity)(
				_Utils_update(
					fields,
					{
						OY: $author$project$Api$Plan$contractExpires(newPlan)
					}));
			var editEndDate = $author$project$Api$Plan$contractExpires(newPlan) ? false : model.is;
			return _Utils_update(
				model,
				{
					is: editEndDate,
					PB: A2($author$project$Utils$Form$set, newFields, model.PB)
				});
		} else {
			return model;
		}
	});
var $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$updateFixedPeriodRateInCents = F3(
	function (newPeriodInMonths, oldPeriodInMonths, _v0) {
		var model = _v0;
		var _v1 = $author$project$Utils$Form$fields(model.PB);
		var fixedPeriodRateInCents = _v1.Pw;
		var _v2 = A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, fixedPeriodRateInCents);
		if (!_v2.$) {
			var fixedPeriodRateInCents_ = _v2.a;
			var ratio = newPeriodInMonths / oldPeriodInMonths;
			var newFixedPeriodRateInCents = fixedPeriodRateInCents_ * ratio;
			return _Utils_eq(newFixedPeriodRateInCents, fixedPeriodRateInCents_) ? $elm$core$Platform$Cmd$none : A2(
				$elm$core$Task$perform,
				function (_v3) {
					return $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated(
						$author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents(
							$elm$core$Maybe$Just(
								$author$project$Currency$fromFloat(newFixedPeriodRateInCents))));
				},
				$elm$core$Process$sleep(0));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$updateStartDates = F3(
	function (startDate, previousStartDate, _v0) {
		var model = _v0;
		var membershipPatientRecord = $author$project$Utils$Form$fields(model.PB);
		var newMembershipPatientRecord = (_Utils_eq(previousStartDate, $elm$core$Maybe$Nothing) || _Utils_eq(membershipPatientRecord._E, previousStartDate)) ? _Utils_update(
			membershipPatientRecord,
			{_E: startDate}) : membershipPatientRecord;
		return _Utils_update(
			model,
			{
				PB: A2($author$project$Utils$Form$set, newMembershipPatientRecord, model.PB)
			});
	});
var $author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates = F3(
	function (startDate, previousStartDate, model) {
		var membershipPatients = A2(
			$elm$core$Dict$map,
			F2(
				function (_v0, _v1) {
					var originalIndex = _v1.a;
					var membershipPatientModel = _v1.b;
					var newMembershipPatientModel = A3($author$project$Components$Membership$Form$Members$MembershipPatient$updateStartDates, startDate, previousStartDate, membershipPatientModel);
					return _Utils_Tuple2(originalIndex, newMembershipPatientModel);
				}),
			model.TF);
		return _Utils_update(
			model,
			{TF: membershipPatients});
	});
var $author$project$Components$Membership$Form$updateForm = F6(
	function (apiClient, membership, model, oldSections, section, currentSections) {
		var _v0 = function () {
			_v1$3:
			while (true) {
				if (!section.$) {
					switch (section.a.$) {
						case 1:
							if (!section.a.a.$) {
								var plan = section.a.a.a;
								var newContracts = A3($author$project$Components$Membership$Form$Sections$Contracts$resetContractFields, model.iX, plan, currentSections.aC);
								return _Utils_Tuple2(
									_Utils_update(
										currentSections,
										{aC: newContracts}),
									$elm$core$Platform$Cmd$none);
							} else {
								break _v1$3;
							}
						case 2:
							var startDate = section.a.a;
							var newMembers = A3($author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates, startDate, $elm$core$Maybe$Nothing, currentSections.B);
							return _Utils_Tuple2(
								_Utils_update(
									currentSections,
									{B: newMembers}),
								$elm$core$Platform$Cmd$none);
						case 6:
							var newPeriodInMonths = section.a.a;
							var _v2 = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(oldSections._9);
							var periodInMonths = _v2.Wc;
							return _Utils_Tuple2(
								currentSections,
								A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Components$Membership$Form$PricingMsg,
									A3($author$project$Components$Membership$Form$Sections$Pricing$updateFixedPeriodRateInCents, newPeriodInMonths, periodInMonths, currentSections.cl)));
						default:
							break _v1$3;
					}
				} else {
					break _v1$3;
				}
			}
			return _Utils_Tuple2(currentSections, $elm$core$Platform$Cmd$none);
		}();
		var newSections = _v0.a;
		var newSectionsCmd = _v0.b;
		return A2(
			$elm$core$Tuple$mapSecond,
			function (checkPriceCmd) {
				return $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[newSectionsCmd, checkPriceCmd]));
			},
			A4(
				$author$project$Components$Membership$Form$checkPrice,
				apiClient,
				membership,
				newSections,
				_Utils_update(
					model,
					{
						l: $elm$core$Maybe$Just(newSections)
					})));
	});
var $author$project$Components$Membership$Form$brokerDealForMatching = function (brokerDeal) {
	return {
		vJ: {
			adR: $author$project$Api$Provider$Broker$Shared$id(
				$author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal))
		}
	};
};
var $author$project$Api$Provider$Membership$Shared$isConfirmed = function (_v0) {
	var record = _v0;
	return record.RD;
};
var $author$project$Api$Provider$Membership$One$isConfirmed = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$isConfirmed(shared);
};
var $author$project$Components$Membership$Form$membershipPatientForMatching = function (membershipPatient) {
	return {
		abM: {
			adR: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$CancellationReason$Shared$id,
				$author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason(membershipPatient))
		},
		qs: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(membershipPatient),
		OH: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn(membershipPatient),
		Pw: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents(membershipPatient),
		adR: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient),
		TB: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient),
		VM: {
			adR: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(
				$author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient)),
			ahO: false
		},
		_n: {
			adR: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$SpecialRate$Min$id,
				$author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate(membershipPatient))
		},
		_E: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate(membershipPatient)
	};
};
var $author$project$Components$Membership$Form$recurringChargeForMatching = function (recurringCharge) {
	return {
		lp: {
			adR: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id(
				$author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem(recurringCharge))
		},
		ads: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription(recurringCharge),
		adt: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents(recurringCharge),
		VM: {
			adR: $author$project$Api$Provider$Patient$Min$id(
				$author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient(recurringCharge))
		},
		Wc: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths(recurringCharge),
		afL: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining(recurringCharge),
		afS: {
			adR: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Practitioner$Min$id,
				$author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner(recurringCharge))
		},
		Bd: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity(recurringCharge),
		_E: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate(recurringCharge)
	};
};
var $author$project$Components$Membership$Form$membershipForMatching = function (membership) {
	return {
		JH: $author$project$Api$Provider$Membership$One$autoRenew(membership),
		vG: $author$project$Api$Provider$Membership$One$billDate(membership),
		J0: $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership),
		J9: A2(
			$elm$core$List$map,
			$author$project$Components$Membership$Form$brokerDealForMatching,
			$author$project$Api$Provider$Membership$One$brokerDeals(membership)),
		Lr: {
			adR: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$CompanyAccount$Shared$id,
				$author$project$Api$Provider$Membership$One$companyAccount(membership))
		},
		wO: $author$project$Api$Provider$Membership$One$contractEndDate(membership),
		LP: $author$project$Api$Provider$Membership$One$contractExpires(membership),
		LQ: $author$project$Api$Provider$Membership$One$contractPeriodInMonths(membership),
		EI: $author$project$Api$Provider$Membership$One$contractType(membership),
		L1: {
			adR: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Common$Coupon$Shared$id,
				$author$project$Api$Provider$Membership$One$coupon(membership))
		},
		Pw: $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership),
		Px: $author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership),
		RD: $author$project$Api$Provider$Membership$One$isConfirmed(membership),
		TF: A2(
			$elm$core$List$map,
			$author$project$Components$Membership$Form$membershipPatientForMatching,
			$author$project$Api$Provider$Membership$One$membershipPatients(membership)),
		T3: $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths(membership),
		UC: $author$project$Api$Provider$Membership$One$nextBillDate(membership),
		Vp: {
			adR: A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$Shared$id,
				$author$project$Api$Provider$Membership$One$owner(membership))
		},
		Wc: $author$project$Api$Provider$Membership$One$periodInMonths(membership),
		GH: {
			adR: $author$project$Api$Provider$Plan$SharedWithContractInfo$id(
				$author$project$Api$Provider$Membership$One$plan(membership))
		},
		XZ: A2(
			$elm$core$List$map,
			$author$project$Components$Membership$Form$recurringChargeForMatching,
			$author$project$Api$Provider$Membership$One$recurringCharges(membership)),
		_E: $author$project$Api$Provider$Membership$One$startDate(membership)
	};
};
var $author$project$Components$Membership$Form$membershipsMatch = F2(
	function (membership, otherMembership) {
		return _Utils_eq(
			$author$project$Components$Membership$Form$membershipForMatching(membership),
			$author$project$Components$Membership$Form$membershipForMatching(otherMembership));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$updateNextBillDates = F2(
	function (pendingMembership, _v0) {
		var model = _v0;
		var formFields = $author$project$Utils$Form$fields(model.PB);
		var newRecurringCharges = A2(
			$elm$core$List$map,
			function (recurringCharge) {
				var _v1 = recurringCharge.adR;
				if (!_v1.$) {
					var id = _v1.a;
					var pendingRecurringCharge = A2(
						$elm_community$list_extra$List$Extra$find,
						function (pendingRecurringCharge_) {
							return _Utils_eq(
								$author$project$Api$Provider$RecurringCharge$ForMembershipOne$id(pendingRecurringCharge_),
								$elm$core$Maybe$Just(id));
						},
						$author$project$Api$Provider$Membership$One$recurringCharges(pendingMembership));
					return A2(
						$elm$core$Maybe$withDefault,
						recurringCharge,
						A2(
							$elm$core$Maybe$map,
							function (pendingRecurringCharge_) {
								return _Utils_update(
									recurringCharge,
									{
										UC: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate(pendingRecurringCharge_)
									});
							},
							pendingRecurringCharge));
				} else {
					return recurringCharge;
				}
			},
			formFields.XZ);
		var newFormFields = _Utils_update(
			formFields,
			{XZ: newRecurringCharges});
		return _Utils_update(
			model,
			{
				PB: A2($author$project$Utils$Form$set, newFormFields, model.PB)
			});
	});
var $author$project$Components$Membership$Form$Sections$Summary$updateStartDate = F3(
	function (pendingMembership, newStartDate, _v0) {
		var model = _v0;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var _v1 = $author$project$Utils$Form$fields(model.PB);
		var startDate = _v1._E;
		return (_Utils_eq(
			$elm$core$Maybe$Just(newStartDate),
			startDate) || (!$author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta))) ? $elm$core$Platform$Cmd$none : $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(
			$author$project$Components$Membership$Form$Sections$Summary$StartDate(
				$elm$core$Maybe$Just(newStartDate)));
	});
var $author$project$Components$Membership$Form$updateFromPriceCheck = F3(
	function (pendingMembership, sections, model) {
		var startDate = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
		var summaryCmd = A3($author$project$Components$Membership$Form$Sections$Summary$updateStartDate, pendingMembership, startDate, sections._9);
		var sameAsOriginal = model.iX ? model.gz : A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Components$Membership$Form$membershipsMatch(pendingMembership),
				model.ja));
		var recurringCharges = A2($author$project$Components$Membership$Form$Sections$RecurringCharges$updateNextBillDates, pendingMembership, sections.XZ);
		var previousStartDate = A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$startDate, model.c6);
		var members = A3(
			$author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates,
			$elm$core$Maybe$Just(startDate),
			previousStartDate,
			sections.B);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					c6: $elm$core$Maybe$Just(pendingMembership),
					gz: sameAsOriginal,
					l: $elm$core$Maybe$Just(
						_Utils_update(
							sections,
							{B: members, XZ: recurringCharges}))
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$SummaryMsg, summaryCmd));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonthsValidation = 1;
var $author$project$Components$Membership$Form$Sections$Contracts$TypeValidation = 0;
var $author$project$Components$Membership$Form$Sections$Contracts$validateContracts = function (contract) {
	return contract.OY ? $elm$core$List$concat(
		_List_fromArray(
			[
				_Utils_eq(contract.Wc, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a number.')
				]) : _List_Nil,
				_Utils_eq(contract.ahI, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please pick an action.')
				]) : _List_Nil
			])) : _List_Nil;
};
var $author$project$Components$Membership$Form$Sections$Contracts$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$Contracts$validateContracts)
		]));
var $author$project$Components$Membership$Form$Sections$Contracts$validate = F2(
	function (_v0, _v1) {
		var model = _v1;
		var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$Contracts$formFieldsValidator, model.PB);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var newForm = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				true);
		} else {
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReasonOtherValidation = 8;
var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReasonValidation = 7;
var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientValidation = 0;
var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDateValidation = 6;
var $author$project$Api$Provider$Membership$Shared$billFromDate = function (_v0) {
	var record = _v0;
	return record.JX;
};
var $author$project$Api$Provider$Membership$One$billFromDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$billFromDate(shared);
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateEndDate = F2(
	function (_v0, fields) {
		var pendingMembership = _v0.c6;
		var min = fields._E;
		var max = $author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A3(
				$justinmimbs$date$Date$add,
				3,
				1,
				$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)));
		return A2(
			$author$project$Utils$Validate$isOutsideDateRange,
			{abi: false, yQ: max, TZ: min},
			fields.qs) ? _List_fromArray(
			[
				_Utils_Tuple2(6, 'Please pick an option.')
			]) : _List_Nil;
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnValidation = 2;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateEnrollmentRequestedOn = F2(
	function (_v0, fields) {
		var editEnrollmentRequestedOn = _v0.qm;
		var _v1 = _Utils_Tuple2(editEnrollmentRequestedOn, fields.OH);
		if (_v1.a) {
			if (!_v1.b.$) {
				return _List_Nil;
			} else {
				var _v2 = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(2, 'Please pick a date.')
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCentsValidation = 5;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateFixedPeriodRateInCents = F2(
	function (model, fields) {
		if (model.dZ) {
			var min = 0;
			var max = 999999999;
			return A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					abi: false,
					yQ: $elm$core$Maybe$Just(max),
					TZ: $elm$core$Maybe$Just(min)
				},
				fields.Pw) ? _List_fromArray(
				[
					_Utils_Tuple2(
					5,
					'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + $author$project$Utils$Currency$fromInt(max))))
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobaccoValidation = 1;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validatePatientUsesTobacco = F3(
	function (_v0, model, fields) {
		var pendingMembership = _v0.c6;
		var showTobaccoUsage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, model.WF) && $author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType(
				$author$project$Api$Provider$Membership$One$plan(pendingMembership)));
		var _v1 = _Utils_Tuple2(showTobaccoUsage && model.d_, fields.VM);
		if (_v1.a && (!_v1.b.$)) {
			var patient = _v1.b.a;
			return _Utils_eq(patient.aaI, $elm$core$Maybe$Nothing) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please pick an option.')
				]) : _List_Nil;
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRateValidation = 4;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateSetSpecialRate = F2(
	function (model, fields) {
		return model.eb ? (_Utils_eq(fields._n, $elm$core$Maybe$Nothing) ? _List_fromArray(
			[
				_Utils_Tuple2(4, 'Please pick a rate.')
			]) : _List_Nil) : _List_Nil;
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDateValidation = 3;
var $author$project$Components$Membership$Form$Members$MembershipPatient$validateStartDate = F3(
	function (_v0, _v1, fields) {
		var pendingMembership = _v0.c6;
		var editStartDate = _v1.qn;
		var _v2 = _Utils_Tuple2(editStartDate, fields._E);
		if (_v2.a) {
			if (!_v2.b.$) {
				var startDate = _v2.b.a;
				var min = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
				var max = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership),
					fields.Ps);
				return (A2($author$project$Utils$Date$isBefore, startDate, min) || A2($author$project$Utils$Date$isAfter, startDate, max)) ? _List_fromArray(
					[
						_Utils_Tuple2(
						3,
						'Please pick a date between ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, min) + (' and ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, max) + '.'))))
					]) : _List_Nil;
			} else {
				var _v3 = _v2.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(3, 'Please pick a date.')
					]);
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsValidator = F2(
	function (sectionsShared, model) {
		return $rtfeldman$elm_validate$Validate$all(
			A2(
				$elm$core$List$cons,
				A2(
					$rtfeldman$elm_validate$Validate$ifNothing,
					function ($) {
						return $.VM;
					},
					_Utils_Tuple2(0, 'Please pick a patient.')),
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_validate$Validate$fromErrors(
						$author$project$Components$Membership$Form$Members$MembershipPatient$validateEnrollmentRequestedOn(model)),
					A2(
						$elm$core$List$cons,
						$rtfeldman$elm_validate$Validate$fromErrors(
							A2($author$project$Components$Membership$Form$Members$MembershipPatient$validateStartDate, sectionsShared, model)),
						A2(
							$elm$core$List$cons,
							$rtfeldman$elm_validate$Validate$fromErrors(
								A2($author$project$Components$Membership$Form$Members$MembershipPatient$validatePatientUsesTobacco, sectionsShared, model)),
							A2(
								$elm$core$List$cons,
								$rtfeldman$elm_validate$Validate$fromErrors(
									$author$project$Components$Membership$Form$Members$MembershipPatient$validateFixedPeriodRateInCents(model)),
								A2(
									$elm$core$List$cons,
									$rtfeldman$elm_validate$Validate$fromErrors(
										$author$project$Components$Membership$Form$Members$MembershipPatient$validateSetSpecialRate(model)),
									model.aN ? _List_fromArray(
										[
											$rtfeldman$elm_validate$Validate$fromErrors(
											$author$project$Components$Membership$Form$Members$MembershipPatient$validateEndDate(sectionsShared)),
											$rtfeldman$elm_validate$Validate$fromErrors(
											A2($author$project$Components$CancellationReason$Input$validate, 7, 8))
										]) : _List_Nil)))))));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$validate = F2(
	function (sectionsShared, _v0) {
		var model = _v0;
		var _v1 = A2(
			$author$project$Utils$Form$validate,
			A2($author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsValidator, sectionsShared, model),
			model.PB);
		if (!_v1.$) {
			var _v2 = _v1.a;
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				true);
		} else {
			var newForm = _v1.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$validate = F2(
	function (sectionsShared, model) {
		var membershipPatientsWithValid = A2(
			$elm$core$Dict$map,
			F2(
				function (_v3, _v4) {
					var membershipPatientModel = _v4.b;
					return A2($author$project$Components$Membership$Form$Members$MembershipPatient$validate, sectionsShared, membershipPatientModel);
				}),
			model.TF);
		var valid = A2(
			$elm$core$List$all,
			$elm$core$Tuple$second,
			$elm$core$Dict$values(membershipPatientsWithValid));
		var membershipPatients = A2(
			$elm$core$Dict$map,
			F2(
				function (id, _v0) {
					var originalIndex = _v0.a;
					var membershipPatientModel = _v0.b;
					var _v1 = A2($elm$core$Dict$get, id, membershipPatientsWithValid);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var newMembershipPatientModel = _v2.a;
						return _Utils_Tuple2(originalIndex, newMembershipPatientModel);
					} else {
						return _Utils_Tuple2(originalIndex, membershipPatientModel);
					}
				}),
			model.TF);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{TF: membershipPatients}),
			valid);
	});
var $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCentsValidation = 0;
var $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCentsValidation = 1;
var $author$project$Components$Membership$Form$Sections$Pricing$validatePricing = function (pricing) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					abi: !pricing.cb.XJ,
					yQ: $elm$core$Maybe$Nothing,
					TZ: $elm$core$Maybe$Just(0)
				},
				pricing.Pw) ? _List_fromArray(
				[
					_Utils_Tuple2(0, 'Please enter a valid amount.')
				]) : _List_Nil,
				A2(
				$author$project$Utils$Validate$isInvalidCurrency,
				{
					abi: !pricing.cb.et,
					yQ: $elm$core$Maybe$Nothing,
					TZ: $elm$core$Maybe$Just(0)
				},
				pricing.Px) ? _List_fromArray(
				[
					_Utils_Tuple2(1, 'Please enter a valid amount.')
				]) : _List_Nil
			]));
};
var $author$project$Components$Membership$Form$Sections$Pricing$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$Pricing$validatePricing)
		]));
var $author$project$Components$Membership$Form$Sections$Pricing$validate = F2(
	function (_v0, _v1) {
		var model = _v1;
		var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$Pricing$formFieldsValidator, model.PB);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var newForm = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				true);
		} else {
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
var $author$project$Components$Membership$Form$Sections$RecurringCharges$validate = F2(
	function (_v0, _v1) {
		var model = _v1;
		var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsValidator, model.PB);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var newForm = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				true);
		} else {
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$Sections$Summary$NextBillDateValidation = 3;
var $author$project$Components$Membership$Form$Sections$Summary$OwnerValidation = 0;
var $author$project$Components$Membership$Form$Sections$Summary$PlanValidation = 1;
var $author$project$Components$Membership$Form$Sections$Summary$StartDateValidation = 2;
var $author$project$Api$Provider$Membership$Meta$billDateMin = function (_v0) {
	var meta = _v0;
	return meta.vG.TZ;
};
var $author$project$Api$Provider$Membership$Meta$nextBillDateMax = function (_v0) {
	var meta = _v0;
	return meta.UC.yQ;
};
var $author$project$Api$Provider$Membership$Meta$nextBillDateMin = function (_v0) {
	var meta = _v0;
	return meta.UC.TZ;
};
var $author$project$Api$Provider$Membership$Meta$startDateMax = function (_v0) {
	var meta = _v0;
	return meta._E.yQ;
};
var $author$project$Api$Provider$Membership$Meta$startDateMin = function (_v0) {
	var meta = _v0;
	return meta._E.TZ;
};
var $author$project$Components$Membership$Form$Sections$Summary$validateSummary = F3(
	function (pendingMembership, show, summary) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_Utils_eq(summary.Vp, $elm$core$Maybe$Nothing) ? _List_fromArray(
					[
						_Utils_Tuple2(0, 'Please pick an owner.')
					]) : _List_Nil,
					_Utils_eq(summary.GH, $elm$core$Maybe$Nothing) ? _List_fromArray(
					[
						_Utils_Tuple2(1, 'Please select a plan.')
					]) : _List_Nil,
					function () {
					var _v0 = _Utils_Tuple2(
						$author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta),
						summary._E);
					if (!_v0.a) {
						return _List_Nil;
					} else {
						if (_v0.b.$ === 1) {
							var _v1 = _v0.b;
							return _List_fromArray(
								[
									_Utils_Tuple2(2, 'Please enter a valid date.')
								]);
						} else {
							var startDate = _v0.b.a;
							var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
							var min = $author$project$Api$Provider$Membership$Meta$startDateMin(pendingMembershipMeta);
							if (!A2($justinmimbs$date$Date$compare, startDate, min)) {
								return _List_fromArray(
									[
										_Utils_Tuple2(
										2,
										'A membership cannot be started before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, min) + '.'))
									]);
							} else {
								var max = A2(
									$elm$core$Maybe$withDefault,
									startDate,
									$author$project$Api$Provider$Membership$Meta$startDateMax(pendingMembershipMeta));
								return (A2($justinmimbs$date$Date$compare, startDate, max) === 2) ? _List_fromArray(
									[
										_Utils_Tuple2(2, 'A membership cannot be started after the first bill.')
									]) : _List_Nil;
							}
						}
					}
				}(),
					function () {
					var _v2 = _Utils_Tuple2(show.UC, summary.UC);
					if (!_v2.a) {
						return _List_Nil;
					} else {
						if (_v2.b.$ === 1) {
							var _v3 = _v2.b;
							return _List_fromArray(
								[
									_Utils_Tuple2(3, 'Please enter a valid date.')
								]);
						} else {
							var nextBillDate = _v2.b.a;
							var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
							var nextBillDateMin = A2(
								$elm$core$Maybe$withDefault,
								nextBillDate,
								$author$project$Api$Provider$Membership$Meta$nextBillDateMin(pendingMembershipMeta));
							var nextBillDateMax = A2(
								$elm$core$Maybe$withDefault,
								nextBillDate,
								$author$project$Api$Provider$Membership$Meta$nextBillDateMax(pendingMembershipMeta));
							var billDateMin = $author$project$Api$Provider$Membership$Meta$billDateMin(pendingMembershipMeta);
							return $elm$core$List$concat(
								_List_fromArray(
									[
										(summary.eF && (!A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMin))) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Must change all bills for dates before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMin) + '.'))
										]) : _List_Nil,
										(summary.eF && (A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMax) === 2)) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Must change all bills for dates after ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMax) + '.'))
										]) : _List_Nil,
										(summary.eF && (!A2($justinmimbs$date$Date$compare, nextBillDate, billDateMin))) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Bill date cannot be set before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, billDateMin) + '.'))
										]) : _List_Nil,
										((!summary.eF) && (!A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMin))) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Next bill date cannot be set before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMin) + '.'))
										]) : _List_Nil,
										(A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMax) === 2) ? _List_fromArray(
										[
											_Utils_Tuple2(
											3,
											'Next bill date cannot be set after ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMax) + '.'))
										]) : _List_Nil
									]));
						}
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$formFieldsValidator = F2(
	function (pendingMembership, show) {
		return $rtfeldman$elm_validate$Validate$all(
			_List_fromArray(
				[
					$rtfeldman$elm_validate$Validate$fromErrors(
					A2($author$project$Components$Membership$Form$Sections$Summary$validateSummary, pendingMembership, show))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$validate = F2(
	function (_v0, _v1) {
		var pendingMembership = _v0.c6;
		var model = _v1;
		var _v2 = A2(
			$author$project$Utils$Form$validate,
			A2($author$project$Components$Membership$Form$Sections$Summary$formFieldsValidator, pendingMembership, model.of),
			model.PB);
		if (!_v2.$) {
			var _v3 = _v2.a;
			var newForm = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				true);
		} else {
			var newForm = _v2.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{PB: newForm}),
				false);
		}
	});
var $author$project$Components$Membership$Form$validateSections = F2(
	function (sectionsShared, sections) {
		var _v0 = A2($author$project$Components$Membership$Form$Sections$Summary$validate, sectionsShared, sections._9);
		var summary = _v0.a;
		var summaryIsValid = _v0.b;
		var _v1 = A2($author$project$Components$Membership$Form$Sections$RecurringCharges$validate, sectionsShared, sections.XZ);
		var recurringCharges = _v1.a;
		var recurringChargesIsValid = _v1.b;
		var _v2 = A2($author$project$Components$Membership$Form$Sections$Pricing$validate, sectionsShared, sections.cl);
		var pricing = _v2.a;
		var pricingIsValid = _v2.b;
		var _v3 = A2($author$project$Components$Membership$Form$Sections$Members$validate, sectionsShared, sections.B);
		var members = _v3.a;
		var membersIsValid = _v3.b;
		var _v4 = A2($author$project$Components$Membership$Form$Sections$Contracts$validate, sectionsShared, sections.aC);
		var contracts = _v4.a;
		var contractsIsValid = _v4.b;
		return _Utils_Tuple2(
			summaryIsValid && (membersIsValid && (pricingIsValid && (recurringChargesIsValid && contractsIsValid))),
			_Utils_update(
				sections,
				{aC: contracts, B: members, cl: pricing, XZ: recurringCharges, _9: summary}));
	});
var $author$project$Components$Membership$Form$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var membership = response.a;
					return A2(
						$author$project$Utils$Tuple3$fromTuple2,
						_List_Nil,
						A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, model));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var response = msg.a;
				var _v2 = model.l;
				if (!_v2.$) {
					var sections = _v2.a;
					var _v3 = function () {
						if (response.$ === 3) {
							var membership = response.a;
							return A3(
								$author$project$Components$Membership$Form$updateFromPriceCheck,
								membership,
								sections,
								_Utils_update(
									model,
									{jE: response}));
						} else {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{jE: response}),
								$elm$core$Platform$Cmd$none);
						}
					}();
					var newModel = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						newModel,
						cmd,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var debounceMsg = msg.a;
				var _v5 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Membership$Form$priceCheckDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Membership$Form$debouncePriceCheck),
					debounceMsg,
					model.en);
				var newDebouncer = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{en: newDebouncer}),
					cmd,
					_List_Nil);
			case 3:
				var cmd = msg.a;
				return _Utils_Tuple3(model, cmd, _List_Nil);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{abO: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 5:
				var billNow = msg.a;
				var _v6 = _Utils_Tuple3(model.l, model.ja, model.c6);
				if (((!_v6.a.$) && (!_v6.b.$)) && (!_v6.c.$)) {
					var sections = _v6.a.a;
					var membership = _v6.b.a;
					var pendingMembership = _v6.c.a;
					var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.VM, membership, pendingMembership, sections, model);
					var _v7 = A2($author$project$Components$Membership$Form$validateSections, shared, sections);
					if (_v7.a) {
						var newSections = _v7.b;
						var saveCmd = A5($author$project$Components$Membership$Form$saveItem, apiClient, model.adR, membership, newSections, billNow);
						var plan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
						var _v8 = A2($author$project$Components$Membership$Form$patientsOutsideAgeRange, plan, newSections);
						var belowAgePatients = _v8.a;
						var aboveAgePatients = _v8.b;
						var _v9 = (($elm$core$List$length(belowAgePatients) > 0) || ($elm$core$List$length(aboveAgePatients) > 0)) ? _Utils_Tuple3(
							$elm$core$Platform$Cmd$none,
							$author$project$Api$Data$NotAsked,
							$elm$core$Maybe$Just(
								_Utils_Tuple2(
									A4(
										$author$project$Components$Membership$Form$OutsideAgeRangeModal$init,
										$author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan),
										$author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan),
										belowAgePatients,
										aboveAgePatients),
									saveCmd))) : _Utils_Tuple3(saveCmd, $author$project$Api$Data$Loading, $elm$core$Maybe$Nothing);
						var cmd = _v9.a;
						var saveRequest = _v9.b;
						var outsideAgeRangeModal = _v9.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									gc: outsideAgeRangeModal,
									jY: saveRequest,
									l: $elm$core$Maybe$Just(newSections)
								}),
							cmd,
							_List_Nil);
					} else {
						var newSections = _v7.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									jY: $author$project$Api$Data$NotAsked,
									l: $elm$core$Maybe$Just(newSections)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				var confirmed = msg.a;
				var _v10 = model.gc;
				if (!_v10.$) {
					var _v11 = _v10.a;
					var saveCmd = _v11.b;
					return confirmed ? _Utils_Tuple3(
						_Utils_update(
							model,
							{gc: $elm$core$Maybe$Nothing, jY: $author$project$Api$Data$Loading}),
						saveCmd,
						_List_Nil) : _Utils_Tuple3(
						_Utils_update(
							model,
							{gc: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 7:
				var response = msg.a;
				var _v12 = model.l;
				if (!_v12.$) {
					if (response.$ === 3) {
						var membership = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
									{
										yS: $author$project$Api$Provider$Membership$One$id(membership),
										VN: $author$project$Api$Provider$Patient$One$id(model.VM)
									})),
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.VM)),
									A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully started')
								]));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 8:
				var response = msg.a;
				var _v14 = model.l;
				if (!_v14.$) {
					if (response.$ === 3) {
						var membership = response.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.VM)),
									A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully updated')
								]),
							A3(
								$author$project$Components$Membership$Form$setupMembershipOnScope,
								apiClient,
								membership,
								_Utils_update(
									model,
									{jY: response})));
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jY: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 9:
				var membership = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jY: $author$project$Api$Data$Loading}),
					A3(
						$author$project$Api$Provider$Membership$confirm,
						apiClient,
						$author$project$Api$Provider$Membership$One$id(membership),
						$author$project$Components$Membership$Form$Confirmed),
					_List_Nil);
			case 10:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: response}),
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
								{
									VN: $author$project$Api$Provider$Patient$One$id(model.VM)
								})),
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.VM)),
								A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully confirmed')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 11:
				var membership = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple2(membership, $author$project$Api$Data$NotAsked))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				var membership = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fm: $elm$core$Maybe$Just(
								_Utils_Tuple2(membership, $author$project$Api$Data$Loading))
						}),
					A3(
						$author$project$Api$Provider$Membership$delete,
						apiClient,
						$author$project$Api$Provider$Membership$One$id(membership),
						$author$project$Components$Membership$Form$Deleted(membership)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{fm: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var membership = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Utils$Route$navigate,
							$elm$core$Dict$empty,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
								{
									VN: $author$project$Api$Provider$Patient$One$id(model.VM)
								})),
						_List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.VM)),
								A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully deleted')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fm: $elm$core$Maybe$Just(
									_Utils_Tuple2(membership, response))
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 14:
				var membership = msg.a;
				var _v18 = A2($author$project$Components$Membership$Form$CancelModal$init, model.cO, membership);
				var cancelModal = _v18.a;
				var cancelModalCmd = _v18.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dv: $elm$core$Maybe$Just(cancelModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModalMsg, cancelModalCmd),
					_List_Nil);
			case 15:
				var subMsg = msg.a;
				var _v19 = model.dv;
				if (!_v19.$) {
					var cancelModal = _v19.a;
					var cancelModalResult = A3($author$project$Components$Membership$Form$CancelModal$update, apiClient, subMsg, cancelModal);
					var _v20 = function () {
						var _v21 = cancelModalResult.ac5;
						switch (_v21.$) {
							case 0:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											dv: $elm$core$Maybe$Just(cancelModalResult.y8)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 1:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{dv: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							default:
								var membership = _v21.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A3(
										$author$project$Components$Membership$Form$setupMembershipOnScope,
										apiClient,
										membership,
										_Utils_update(
											model,
											{dv: $elm$core$Maybe$Nothing})));
						}
					}();
					var newModel = _v20.a;
					var cmd = _v20.b;
					var outMsgs = _v20.c;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModalMsg, cancelModalResult.EC),
									cmd
								])),
						_Utils_ap(cancelModalResult.as, outMsgs));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 16:
				var membership = msg.a;
				var _v22 = A4($author$project$Components$Membership$Form$RestartModal$init, apiClient, model.cO, $elm$core$Maybe$Nothing, membership);
				var restartModal = _v22.a;
				var restartModalCmd = _v22.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jS: $elm$core$Maybe$Just(restartModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RestartModalMsg, restartModalCmd),
					_List_Nil);
			case 17:
				var subMsg = msg.a;
				var _v23 = model.jS;
				if (!_v23.$) {
					var restartModal = _v23.a;
					var restartModalResult = A3($author$project$Components$Membership$Form$RestartModal$update, apiClient, subMsg, restartModal);
					var _v24 = function () {
						var _v25 = restartModalResult.ac5;
						switch (_v25.$) {
							case 0:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											jS: $elm$core$Maybe$Just(restartModalResult.y8)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							case 1:
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{jS: $elm$core$Maybe$Nothing}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							default:
								var membership = _v25.a;
								return A2(
									$author$project$Utils$Tuple3$fromTuple2,
									_List_Nil,
									A3(
										$author$project$Components$Membership$Form$setupMembershipOnScope,
										apiClient,
										membership,
										_Utils_update(
											model,
											{jS: $elm$core$Maybe$Nothing})));
						}
					}();
					var newModel = _v24.a;
					var cmd = _v24.b;
					var outMsgs = _v24.c;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RestartModalMsg, restartModalResult.EC),
									cmd
								])),
						_Utils_ap(restartModalResult.as, outMsgs));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 18:
				var subMsg = msg.a;
				var _v26 = _Utils_Tuple3(model.ja, model.c6, model.l);
				if (((!_v26.a.$) && (!_v26.b.$)) && (!_v26.c.$)) {
					var membership = _v26.a.a;
					var pendingMembership = _v26.b.a;
					var sections = _v26.c.a;
					var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.VM, membership, pendingMembership, sections, model);
					var summaryResult = A4($author$project$Components$Membership$Form$Sections$Summary$update, apiClient, shared, subMsg, sections._9);
					var newSections = _Utils_update(
						sections,
						{_9: summaryResult.y8});
					var _v27 = function () {
						var _v28 = summaryResult.ac5;
						if (!_v28.$) {
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										l: $elm$core$Maybe$Just(newSections)
									}));
						} else {
							var summaryField = _v28.a;
							var _v29 = A6(
								$author$project$Components$Membership$Form$updateForm,
								apiClient,
								membership,
								model,
								sections,
								$author$project$Components$Membership$Form$Summary(summaryField),
								newSections);
							var newModel = _v29.a;
							var formCmd = _v29.b;
							return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v27.a;
					var newModel_ = _v27.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$SummaryMsg, summaryResult.EC),
									cmd
								])),
						summaryResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				var subMsg = msg.a;
				var _v30 = _Utils_Tuple2(model.ja, model.l);
				if ((!_v30.a.$) && (!_v30.b.$)) {
					var membership = _v30.a.a;
					var sections = _v30.b.a;
					var membersResult = A3($author$project$Components$Membership$Form$Sections$Members$update, apiClient, subMsg, sections.B);
					var newSections = _Utils_update(
						sections,
						{B: membersResult.y8});
					var _v31 = function () {
						var _v32 = membersResult.ac5;
						if (!_v32) {
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										l: $elm$core$Maybe$Just(newSections)
									}));
						} else {
							var _v33 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Members, newSections);
							var newModel = _v33.a;
							var formCmd = _v33.b;
							return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v31.a;
					var newModel_ = _v31.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$MembersMsg, membersResult.EC),
									cmd
								])),
						membersResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 20:
				var subMsg = msg.a;
				var _v34 = _Utils_Tuple2(model.ja, model.l);
				if ((!_v34.a.$) && (!_v34.b.$)) {
					var membership = _v34.a.a;
					var sections = _v34.b.a;
					var pricingResult = A2($author$project$Components$Membership$Form$Sections$Pricing$update, subMsg, sections.cl);
					var newSections = _Utils_update(
						sections,
						{cl: pricingResult.y8});
					var _v35 = function () {
						var _v36 = pricingResult.ac5;
						if (!_v36) {
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										l: $elm$core$Maybe$Just(newSections)
									}));
						} else {
							var _v37 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Pricing, newSections);
							var newModel = _v37.a;
							var formCmd = _v37.b;
							return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v35.a;
					var newModel_ = _v35.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$PricingMsg, pricingResult.EC),
									cmd
								])),
						pricingResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 21:
				var subMsg = msg.a;
				var _v38 = _Utils_Tuple2(model.ja, model.l);
				if ((!_v38.a.$) && (!_v38.b.$)) {
					var membership = _v38.a.a;
					var sections = _v38.b.a;
					var contractsResult = A3($author$project$Components$Membership$Form$Sections$Contracts$update, apiClient, subMsg, sections.aC);
					var newSections = _Utils_update(
						sections,
						{aC: contractsResult.y8});
					var _v39 = function () {
						var _v40 = contractsResult.ac5;
						switch (_v40) {
							case 0:
								return _Utils_Tuple2(
									$elm$core$Platform$Cmd$none,
									_Utils_update(
										model,
										{
											l: $elm$core$Maybe$Just(newSections)
										}));
							case 1:
								return _Utils_Tuple2(
									A2(
										$author$project$Components$Membership$Form$retrieveItem,
										apiClient,
										A2($elm$core$Maybe$withDefault, '', model.adR)),
									model);
							default:
								var _v41 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Contract, newSections);
								var newModel = _v41.a;
								var formCmd = _v41.b;
								return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v39.a;
					var newModel_ = _v39.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$ContractsMsg, contractsResult.EC),
									cmd
								])),
						contractsResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 22:
				var subMsg = msg.a;
				var _v42 = _Utils_Tuple2(model.ja, model.l);
				if ((!_v42.a.$) && (!_v42.b.$)) {
					var membership = _v42.a.a;
					var sections = _v42.b.a;
					var recurringChargesResult = A3($author$project$Components$Membership$Form$Sections$RecurringCharges$update, apiClient, subMsg, sections.XZ);
					var newSections = _Utils_update(
						sections,
						{XZ: recurringChargesResult.y8});
					var _v43 = function () {
						var _v44 = recurringChargesResult.ac5;
						if (!_v44) {
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_Utils_update(
									model,
									{
										l: $elm$core$Maybe$Just(newSections)
									}));
						} else {
							var _v45 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$RecurringCharges, newSections);
							var newModel = _v45.a;
							var formCmd = _v45.b;
							return _Utils_Tuple2(formCmd, newModel);
						}
					}();
					var cmd = _v43.a;
					var newModel_ = _v43.b;
					return _Utils_Tuple3(
						newModel_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringChargesMsg, recurringChargesResult.EC),
									cmd
								])),
						recurringChargesResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var subMsg = msg.a;
				var _v46 = model.l;
				if (!_v46.$) {
					var sections = _v46.a;
					var _v47 = sections.ju;
					if (!_v47.$) {
						var planChange = _v47.a;
						var planChangeResult = A3($author$project$Components$Membership$Form$Sections$PlanChange$update, apiClient, subMsg, planChange);
						var id = A2($elm$core$Maybe$withDefault, '', model.adR);
						var cmd = function () {
							var _v48 = planChangeResult.ac5;
							switch (_v48) {
								case 0:
									return $elm$core$Platform$Cmd$none;
								case 1:
									return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
								case 2:
									return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
								default:
									return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									l: $elm$core$Maybe$Just(
										_Utils_update(
											sections,
											{
												ju: $elm$core$Maybe$Just(planChangeResult.y8)
											}))
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$PlanChangeMsg, planChangeResult.EC),
										cmd
									])),
							planChangeResult.as);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 24:
				var subMsg = msg.a;
				var _v49 = model.l;
				if (!_v49.$) {
					var sections = _v49.a;
					var billsOverviewResult = A3($author$project$Components$Membership$Form$Sections$BillsOverview$update, apiClient, subMsg, sections.pG);
					var _v50 = function () {
						var _v51 = billsOverviewResult.ac5;
						if (!_v51.$) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										l: $elm$core$Maybe$Just(
											_Utils_update(
												sections,
												{pG: billsOverviewResult.y8}))
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							var membership = _v51.a;
							return A2(
								$author$project$Utils$Tuple3$fromTuple2,
								_List_Nil,
								A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, model));
						}
					}();
					var newModel = _v50.a;
					var cmd = _v50.b;
					var outMsgs = _v50.c;
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$BillsOverviewMsg, billsOverviewResult.EC),
									cmd
								])),
						_Utils_ap(billsOverviewResult.as, outMsgs));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 25:
				var membershipId = msg.a;
				var lastContract = msg.b;
				var endDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$endDate, lastContract);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							jN: $elm$core$Maybe$Just(
								A2($author$project$Components$Membership$Form$RenewContractModal$init, membershipId, endDate))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v52 = model.jN;
				if (!_v52.$) {
					var renewContractModal = _v52.a;
					var renewContractModalResult = A3($author$project$Components$Membership$Form$RenewContractModal$update, apiClient, subMsg, renewContractModal);
					var _v53 = function () {
						var _v54 = renewContractModalResult.ac5;
						switch (_v54) {
							case 0:
								return _Utils_Tuple3(
									$elm$core$Maybe$Just(renewContractModalResult.y8),
									$elm$core$Platform$Cmd$none,
									model);
							case 1:
								return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, model);
							default:
								return _Utils_Tuple3(
									$elm$core$Maybe$Nothing,
									A2(
										$author$project$Components$Membership$Form$retrieveItem,
										apiClient,
										A2($elm$core$Maybe$withDefault, '', model.adR)),
									model);
						}
					}();
					var renewContractModal_ = _v53.a;
					var cmd = _v53.b;
					var newModel_ = _v53.c;
					return _Utils_Tuple3(
						_Utils_update(
							newModel_,
							{jN: renewContractModal_}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RenewContractModalMsg, renewContractModalResult.EC),
									cmd
								])),
						renewContractModalResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$update = F2(
	function (msg, model) {
		var _v0 = A3($author$project$Components$Membership$Form$update, model.D5, msg, model.PB);
		var form = _v0.a;
		var cmd = _v0.b;
		var outMsgs = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			cmd,
			outMsgs);
	});
var $author$project$Components$Membership$Form$Sections$Contracts$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.PB);
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.PB);
};
var $author$project$Components$Membership$Form$Sections$Members$dirty = function (model) {
	return (!_Utils_eq(
		model.Gv,
		$elm$core$Set$fromList(
			$elm$core$Dict$keys(model.TF)))) || A2(
		$elm$core$List$any,
		function (_v0) {
			var _v1 = _v0.b;
			var membershipPatientModel = _v1.b;
			return $author$project$Components$Membership$Form$Members$MembershipPatient$dirty(membershipPatientModel);
		},
		$elm$core$Dict$toList(model.TF));
};
var $author$project$Components$Membership$Form$Sections$Pricing$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.PB);
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.PB);
};
var $author$project$Components$Membership$Form$Sections$Summary$dirty = function (_v0) {
	var model = _v0;
	return $author$project$Utils$Form$dirty(model.PB);
};
var $author$project$Components$Membership$Form$Sections$Contracts$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.e7;
	if (!_v1.$) {
		var _v2 = _v1.a;
		var cancelRequest = _v2.a;
		var membershipId = _v2.b;
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed(membershipId),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$noun('Contract'),
					$author$project$Components$HiConfirm$verb('Cancel'),
					$author$project$Components$HiConfirm$loading(
					_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$CreatePatientModal$Create = {$: 2};
var $author$project$Components$CreatePatientModal$view = F2(
	function (title, model) {
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false),
					$author$project$Ui$Form$horizontal,
					$author$project$Ui$Form$onSubmit($author$project$Components$CreatePatientModal$Create)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Modal$view,
					$author$project$Components$CreatePatientModal$Close,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Modal$header(
							_List_fromArray(
								[
									$author$project$Ui$Modal$title(title)
								])),
							$author$project$Ui$Modal$body(
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$div,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Components$CreatePatientModal$PatientFormMsg),
										$author$project$Components$Patient$Form$view(model.PB)))
								])),
							$author$project$Ui$Modal$footer(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Cancel and close modal'},
									_List_fromArray(
										[
											$author$project$Ui$Button$onClick($author$project$Components$CreatePatientModal$Close)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Create patient'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$loading(model.kj),
											$author$project$Ui$Button$submit
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Create')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.h$;
	if (!_v1.$) {
		var createPatientModal = _v1.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg,
			A2($author$project$Components$CreatePatientModal$view, 'Add New Patient to Membership', createPatientModal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Membership$Form$Sections$Members$modal = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var _v1 = _v0.b;
				var membershipPatient = _v1.b;
				return A2(
					$elm$html$Html$map,
					$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id),
					$author$project$Components$Membership$Form$Members$MembershipPatient$modal(membershipPatient));
			},
			$elm$core$Dict$toList(model.TF)));
};
var $author$project$Components$Membership$Form$Sections$PlanChange$Save = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonths = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$Meta$contractEndDateDefault = function (_v0) {
	var meta = _v0;
	return meta.wO.M5;
};
var $author$project$Components$Membership$Form$Sections$PlanChange$Type = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton = F3(
	function (currentType_, type_, label) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(currentType_, type_)),
					$author$project$Ui$Button$onClick(
					$author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated(
						$author$project$Components$Membership$Form$Sections$PlanChange$Type(type_)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$viewEffectiveDate = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var type_ = _v0.ahI;
	var changeOnDate = _v0.KO;
	var changeAfterMonths = _v0.KN;
	var changeOnDateDateInput = _v0.v_;
	var contract = _v0.EH;
	var membershipMeta = _v0.F5;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Effective date'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				function () {
				if (type_ === 2) {
					return A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v2 = contract.Wc;
								if (!_v2.$) {
									var contractPeriodInMonths_ = _v2.a;
									var effectiveDate = function () {
										var _v3 = _Utils_Tuple2(
											contract.qs,
											$author$project$Api$Provider$Membership$Meta$contractEndDateDefault(membershipMeta));
										if (!_v3.a.$) {
											var contractEndDate_ = _v3.a.a;
											return $elm$core$Maybe$Just(contractEndDate_);
										} else {
											var _v4 = _v3.a;
											var defaultContractEndDate = _v3.b;
											return defaultContractEndDate;
										}
									}();
									return A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths_)),
												$elm$html$Html$text(' ('),
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
														effectiveDate))),
												$elm$html$Html$text(')')
											]));
								} else {
									return $elm$html$Html$text('Contract end date');
								}
							}(),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('When contract periods are enabled, the plan can only be changed after the contract is ended.')
									]))
							]));
				} else {
					return A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(7)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Button$group(
										_List_fromArray(
											[
												A3($author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton, type_, 1, 'Periods of months'),
												A3($author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton, type_, 0, 'Date')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(5)
									]),
								_List_fromArray(
									[
										function () {
										switch (type_) {
											case 2:
												return $author$project$Utils$Html$empty;
											case 1:
												return $author$project$Ui$Form$PeriodInMonthsInput$view(
													{
														fE: A2($author$project$Utils$Form$validationErrors, 1, form),
														q$: A2($author$project$Utils$Form$hasValidationErrors, 1, form),
														afc: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated, $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonths),
														aaN: changeAfterMonths
													});
											default:
												return A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg(changeOnDateDateInput),
													A2(
														$author$project$Components$DateInput$view,
														_List_fromArray(
															[
																$author$project$Components$DateInput$value(changeOnDate),
																$author$project$Components$DateInput$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
																$author$project$Components$DateInput$errors(
																A2($author$project$Utils$Form$validationErrors, 0, form))
															]),
														changeOnDateDateInput));
										}
									}()
									]))
							]));
				}
			}()
			]));
};
var $author$project$Components$Membership$Form$Sections$PlanChange$viewToPlan = F2(
	function (model, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('New plan'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Plan$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
								$author$project$Components$ResourceFilter$errors(
								A2($author$project$Utils$Form$validationErrors, 2, form))
							]),
						model.jw))
				]));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$viewForm = F2(
	function (model, form) {
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Membership$Form$Sections$PlanChange$viewEffectiveDate(form),
					A2($author$project$Components$Membership$Form$Sections$PlanChange$viewToPlan, model, form)
				]));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$modal = function (_v0) {
	var model = _v0;
	var _v1 = _Utils_Tuple2(model.PB, model.fm);
	if (!_v1.a.$) {
		var form = _v1.a.a;
		var modalConfig = {
			Qn: $elm$core$Maybe$Nothing,
			aej: 'Plan Change',
			S_: _Utils_eq(model.jY, $author$project$Api$Data$Loading),
			Tv: $elm$core$Maybe$Nothing,
			Tw: $elm$core$Maybe$Nothing,
			U_: $author$project$Components$Membership$Form$Sections$PlanChange$CloseModal,
			U0: $author$project$Components$Membership$Form$Sections$PlanChange$Save
		};
		return A2(
			$author$project$Components$Admin$CreateEditModal$modal,
			modalConfig,
			_List_fromArray(
				[
					A2($author$project$Components$Membership$Form$Sections$PlanChange$viewForm, model, form)
				]));
	} else {
		if (!_v1.b.$) {
			var _v2 = _v1.a;
			var _v3 = _v1.b.a;
			var membershipId = _v3.a;
			var deleteRequest = _v3.b;
			var scheduledChange = _v3.c;
			return A2(
				$author$project$Components$HiConfirm$modal,
				A2($author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed, membershipId, scheduledChange),
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$noun('Plan change'),
						$author$project$Components$HiConfirm$verb('Remove'),
						$author$project$Components$HiConfirm$loading(
						_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
					]));
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return $author$project$Utils$Html$empty;
		}
	}
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewChargeItemInput = function (model) {
	var editing = $author$project$Utils$Maybe$toBool(model.x4);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Charge Item'),
				$author$project$Ui$Form$Group$required(!editing)
			]),
		_List_fromArray(
			[
				function () {
				if (editing) {
					var recurringCharge = $author$project$Utils$Form$fields(model.PB);
					return A2(
						$author$project$Ui$Form$Static$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Static$phi(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'N/A',
											A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.zh;
												},
												recurringCharge.lp)))
									]))
							]));
				} else {
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg,
						A2(
							$author$project$Components$ResourceFilter$ChargeItem$view,
							_List_fromArray(
								[
									$author$project$Components$ResourceFilter$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
									$author$project$Components$ResourceFilter$errors(
									A2($author$project$Utils$Form$validationErrors, 1, model.PB))
								]),
							model.cK));
				}
			}()
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedDescription = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewDescriptionInput = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var fixedDescription = _v0.ads;
	var chargeItem = _v0.lp;
	var placeholder = A2(
		$elm$core$Maybe$withDefault,
		'Additional details for receipt (e.g. ICD-10 Codes)',
		A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.Nx;
			},
			chargeItem));
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Description')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Textarea$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Textarea$rows(2),
						$author$project$Ui$Form$Textarea$phi(true),
						$author$project$Ui$Form$Textarea$value(
						A2($elm$core$Maybe$withDefault, '', fixedDescription)),
						$author$project$Ui$Form$Textarea$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedDescription)),
						$author$project$Ui$Form$Textarea$placeholder(placeholder)
					]))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedPriceInCents = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewFixedPriceInCentsInput = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var fixedPriceInCents = _v0.adt;
	var chargeItem = _v0.lp;
	var placeholder = $author$project$Utils$Currency$fromFloat(
		A2(
			$elm$core$Maybe$withDefault,
			0.0,
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.Ba;
				},
				chargeItem)));
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Price')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$CurrencyInput$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$CurrencyInput$value(fixedPriceInCents),
						$author$project$Ui$Form$CurrencyInput$placeholder(placeholder),
						$author$project$Ui$Form$CurrencyInput$onInput(
						A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedPriceInCents))
					]))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPatientInput = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Patient'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg,
				A2(
					$author$project$Components$LimitedPatientSelector$view,
					_List_fromArray(
						[
							$author$project$Components$LimitedPatientSelector$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
							$author$project$Components$LimitedPatientSelector$errors(
							A2($author$project$Utils$Form$validationErrors, 0, model.PB))
						]),
					model.rd))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPractitionerInput = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Provider')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg,
				A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, model.jC))
			]));
};
var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$view = function (_v0) {
	var model = _v0;
	var editing = $author$project$Utils$Maybe$toBool(model.x4);
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title(
						editing ? 'Edit Charge' : 'New Charge')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$view,
						_List_fromArray(
							[$author$project$Ui$Form$horizontal]),
						A2(
							$elm$core$List$cons,
							$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewChargeItemInput(model),
							A2(
								$elm$core$List$cons,
								$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPatientInput(model),
								editing ? _List_fromArray(
									[
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPractitionerInput(model),
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewFixedPriceInCentsInput(model),
										$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewDescriptionInput(model)
									]) : _List_Nil))),
						$author$project$Ui$Clearfix$view
					])),
				$author$project$Ui$Modal$footer(
				A2(
					$elm$core$List$cons,
					A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
					editing ? _List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Save recurring charge'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save($elm$core$Maybe$Nothing)),
									$author$project$Ui$Button$primary
								]),
							_List_fromArray(
								[
									A2($author$project$Ui$Icon$view, _List_Nil, 16),
									$elm$html$Html$text(' Save')
								]))
						]) : _List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add charge once'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save(
										$elm$core$Maybe$Just(1))),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Once')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Add charge recurring'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save($elm$core$Maybe$Nothing)),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Recurring')
								]))
						])))
			]));
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$modal = function (_v0) {
	var model = _v0;
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v1 = model.fg;
				if (!_v1.$) {
					var createEditModal = _v1.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg,
						$author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$view(createEditModal));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Components$Membership$Form$Sections$Summary$modal = function (_v0) {
	var model = _v0;
	var _v1 = model.hY;
	if (!_v1.$) {
		var _v2 = _v1.a;
		var createModal = _v2.b;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg,
			$author$project$Components$BrokerDeal$CreateModal$view(createModal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$MemberRelationship$toString = function (memberRelationship) {
	switch (memberRelationship) {
		case 0:
			return 'employee';
		case 1:
			return 'spouse';
		case 2:
			return 'child';
		default:
			return 'other';
	}
};
var $author$project$Components$Membership$Form$CancelModal$Cancel = {$: 0};
var $author$project$Components$Membership$Form$CancelModal$CancellationReason = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$CancelModal$FormUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Formatters$Date$Timeago = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Provider$Membership$Meta$endDateRetailValues = function (_v0) {
	var meta = _v0;
	return meta.qs.YD;
};
var $author$project$Components$Membership$Form$CancelModal$endDateOptions = function (membership) {
	return $author$project$Ui$Form$Select$dateOptions(
		$author$project$Api$Provider$Membership$Meta$endDateRetailValues(
			$author$project$Api$Provider$Membership$One$meta(membership)));
};
var $author$project$Api$Provider$Membership$One$lastContract = function (_v0) {
	var record = _v0.b;
	return record.Sw;
};
var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration = function (_v0) {
	var meta = _v0;
	return meta.qs._B;
};
var $author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice = F2(
	function (membership, endDate) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var minWithoutProration = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta);
		var billFromDate = $author$project$Api$Provider$Membership$One$billFromDate(membership);
		var _v0 = _Utils_Tuple2(endDate, minWithoutProration);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var endDate_ = _v0.a.a;
				var minWithoutProration_ = _v0.b.a;
				return A3($justinmimbs$date$Date$isBetween, minWithoutProration_, billFromDate, endDate_) && (!_Utils_eq(endDate_, billFromDate));
			} else {
				var endDate_ = _v0.a.a;
				var _v1 = _v0.b;
				return !A2($justinmimbs$date$Date$compare, endDate_, billFromDate);
			}
		} else {
			var _v2 = _v0.a;
			return false;
		}
	});
var $author$project$Api$Provider$Membership$Shared$billingStartDate = function (_v0) {
	var record = _v0;
	return record.J$;
};
var $author$project$Api$Provider$Membership$One$billingStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$billingStartDate(shared);
};
var $author$project$Components$Membership$Form$Utils$billedFromDate = F2(
	function (membership, endDate) {
		return A2(
			$elm_community$list_extra$List$Extra$maximumBy,
			$justinmimbs$date$Date$toRataDie,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						endDate,
						$elm$core$Maybe$Just(
						$author$project$Api$Provider$Membership$One$billingStartDate(membership))
					])));
	});
var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMaxWithoutBilling = function (_v0) {
	var meta = _v0;
	return meta.qs._z;
};
var $author$project$Components$Membership$Form$Utils$mayNeedProration = F2(
	function (membership, endDate) {
		if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) {
			var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
			var minWithoutProration = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta);
			var maxWithoutBilling = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMaxWithoutBilling(membershipMeta);
			var _v0 = _Utils_Tuple3(minWithoutProration, maxWithoutBilling, endDate);
			if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
				var minWithoutProration_ = _v0.a.a;
				var maxWithoutBilling_ = _v0.b.a;
				var endDate_ = _v0.c.a;
				return A3($justinmimbs$date$Date$isBetween, maxWithoutBilling_, minWithoutProration_, endDate_) && (!_Utils_eq(endDate_, minWithoutProration_));
			} else {
				return false;
			}
		} else {
			if (!endDate.$) {
				var endDate_ = endDate.a;
				return !A2(
					$justinmimbs$date$Date$compare,
					endDate_,
					$author$project$Api$Provider$Membership$One$billFromDate(membership));
			} else {
				return false;
			}
		}
	});
var $author$project$Components$Membership$Form$Utils$prorationWarning = F4(
	function (noun, supportUrl, startDate, endDate) {
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('We have billed this '),
							$elm$html$Html$text(noun),
							$elm$html$Html$text(' through '),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									endDate))),
							$elm$html$Html$text('. If you’d like to credit the period of '),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									startDate))),
							$elm$html$Html$text(' through '),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									endDate))),
							$elm$html$Html$text(', you can learn how to do that '),
							A3(
							$author$project$Ui$Link$externalHref,
							supportUrl,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text('here')
								])),
							$elm$html$Html$text('.')
						]))
				]));
	});
var $author$project$Components$Membership$Form$Utils$mayNeedProrationWarning = F3(
	function (noun, membership, endDate) {
		if (A2($author$project$Components$Membership$Form$Utils$mayNeedProration, membership, endDate)) {
			if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) {
				var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
				return A4(
					$author$project$Components$Membership$Form$Utils$prorationWarning,
					noun,
					'https://support.hint.com/en/articles/4622730-adding-an-employer-credit-or-one-off-charge',
					A2($author$project$Components$Membership$Form$Utils$billedFromDate, membership, endDate),
					$author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta));
			} else {
				return A4(
					$author$project$Components$Membership$Form$Utils$prorationWarning,
					noun,
					'https://support.hint.com/invoices/creating-a-prorated-membership-invoice',
					endDate,
					$author$project$Api$Provider$Membership$One$billedThroughDate(membership));
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentEndDate = function (_v0) {
	var record = _v0;
	return record.T2;
};
var $author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentEndDate(shared);
};
var $author$project$Api$Provider$Membership$One$periodRateInCents = function (_v0) {
	var record = _v0.b;
	return record.Wd;
};
var $author$project$Components$Membership$Form$CancelModal$viewMembershipPatient = function (membershipPatient) {
	var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
	var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(
				(memberType === 1) ? 'Adult' : $author$project$Formatters$String$titleize(
					$author$project$Api$MemberRelationship$toString(memberType))),
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{
								VN: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
							}),
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Membership$Form$CancelModal$view = F2(
	function (cancellationReasons, _v0) {
		var model = _v0;
		var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(model.ja);
		var fields = $author$project$Utils$Form$fields(model.PB);
		var earlyTermination = function () {
			var _v1 = _Utils_Tuple2(
				fields.qs,
				$author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.ja));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var endDate = _v1.a.a;
				var minimumEnrollmentEndDate = _v1.b.a;
				return !A2($justinmimbs$date$Date$compare, endDate, minimumEnrollmentEndDate);
			} else {
				return false;
			}
		}();
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Membership$Form$CancelModal$Close,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('End Membership')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							earlyTermination ? A2(
							$author$project$Ui$Alert$warning,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This patient\'s minimum enrollment is scheduled to end '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString(
												A2(
													$author$project$Formatters$Date$Timeago,
													model.cO,
													$elm$core$Maybe$Just('days'))),
											$author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.ja)))),
									$elm$html$Html$text(' on '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											$author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.ja)))),
									$elm$html$Html$text('. If you end their membership early they will not pay for the remaining time.')
								])) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$onSubmit($author$project$Components$Membership$Form$CancelModal$Cancel),
									$author$project$Ui$Form$horizontal
								]),
							$elm$core$List$concat(
								_List_fromArray(
									[
										_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Membership Started'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																$author$project$Formatters$Date$Full,
																$author$project$Api$Provider$Membership$One$startDate(model.ja)))
														]))
												])),
											$author$project$Api$Provider$Membership$One$contractExpires(model.ja) ? A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Contract end date'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
															A2(
																$elm$core$Maybe$andThen,
																$author$project$Api$Provider$MembershipContract$Shared$endDate,
																$author$project$Api$Provider$Membership$One$lastContract(model.ja)))))
												])) : $author$project$Utils$Html$empty,
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('End Date'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8),
													$author$project$Ui$Form$Group$required(true)
												]),
											_List_fromArray(
												[
													$author$project$Api$Provider$Membership$One$isSponsored(model.ja) ? A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$CancelModal$EndDateInputMsg,
													A2(
														$author$project$Components$DateInput$view,
														_List_fromArray(
															[
																$author$project$Components$DateInput$value(fields.qs),
																$author$project$Components$DateInput$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
																$author$project$Components$DateInput$errors(
																A2($author$project$Utils$Form$validationErrors, 0, model.PB))
															]),
														model.qu)) : A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$value(
															A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, fields.qs)),
															$author$project$Ui$Form$Select$onChange(
															A2(
																$elm$core$Basics$composeL,
																A2(
																	$elm$core$Basics$composeL,
																	A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$CancelModal$FormUpdated, $author$project$Components$Membership$Form$CancelModal$EndDate),
																	$elm$core$Result$toMaybe),
																$justinmimbs$date$Date$fromIsoString)),
															$author$project$Ui$Form$Select$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
															$author$project$Ui$Form$Select$errors(
															A2($author$project$Utils$Form$validationErrors, 0, model.PB))
														]),
													$author$project$Components$Membership$Form$CancelModal$endDateOptions(model.ja)),
													A2($author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice, model.ja, fields.qs) ? A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Alert$warning,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Invoices after this date will be automatically cancelled unless paid.')
																]))
														])) : $author$project$Utils$Html$empty,
													A3($author$project$Components$Membership$Form$Utils$mayNeedProrationWarning, 'membership', model.ja, fields.qs)
												])),
											A2($author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice, model.ja, fields.qs) ? A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Amount'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Membership$One$periodRateInCents(model.ja))),
															$author$project$Utils$Html$noBreakSpace,
															$elm$html$Html$text(
															$author$project$Formatters$Int$asPeriod(
																$author$project$Api$Provider$Membership$One$periodInMonths(model.ja)))
														]))
												])) : $author$project$Utils$Html$empty,
											$author$project$Components$CancellationReason$Input$view(
											{
												abO: cancellationReasons,
												fE: A2($author$project$Utils$Form$validationErrors, 1, model.PB),
												OP: A2($author$project$Utils$Form$validationErrors, 2, model.PB),
												aek: $elm$core$Maybe$Nothing,
												ae4: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$CancelModal$FormUpdated, $author$project$Components$Membership$Form$CancelModal$CancellationReason),
												aaN: _Utils_Tuple2(fields.abM, fields.abN)
											})
										]),
										A2($elm$core$List$map, $author$project$Components$Membership$Form$CancelModal$viewMembershipPatient, membershipPatients)
									]))),
							$author$project$Ui$Clearfix$view
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$CancelModal$Close)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'End membership'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.e7, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$CancelModal$Cancel)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('End Membership')
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatient = function (patient) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(patient.zh)
					])),
				$elm$html$Html$text(' is '),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$phi(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'N/A',
							A2($elm$core$Maybe$map, $elm$core$String$fromInt, patient.IK)))
					])),
				$elm$html$Html$text(' years old.')
			]));
};
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange = F3(
	function (range, limit, patients) {
		return A2(
			$author$project$Ui$Typography$p,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('The '),
					$elm$html$Html$text(range),
					$elm$html$Html$text(' age defined for this plan is '),
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						'N/A',
						A2($elm$core$Maybe$map, $elm$core$String$fromInt, limit))),
					$elm$html$Html$text('.'),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2($elm$core$List$map, $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatient, patients))
				]));
	});
var $author$project$Components$Membership$Form$OutsideAgeRangeModal$view = F2(
	function (onClose, model) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose(false),
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Warning - patient outside of plan age range')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							($elm$core$List$length(model.vF) >= 1) ? A3($author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange, 'minimum', model.T1, model.vF) : $author$project$Utils$Html$empty,
							($elm$core$List$length(model.tD) >= 1) ? A3($author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange, 'maximum', model.Tu, model.tD) : $author$project$Utils$Html$empty,
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Do you want to proceed anyway?')
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(
									onClose(false))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Proceed anyway'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									onClose(true))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Confirm')
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$RenewContractModal$MemoUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$RenewContractModal$Renew = {$: 2};
var $author$project$Components$Membership$Form$RenewContractModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Membership$Form$RenewContractModal$Close,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Set contract to renew?')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Current contract expires: '),
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'N/A',
									A2(
										$elm$core$Maybe$map,
										$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
										model.FX)))
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Memo:')
							])),
						$author$project$Ui$Form$Textarea$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Textarea$rows(4),
								$author$project$Ui$Form$Textarea$value(
								A2($elm$core$Maybe$withDefault, '', model.aeC)),
								$author$project$Ui$Form$Textarea$onInput($author$project$Components$Membership$Form$RenewContractModal$MemoUpdated)
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Cancel and close modal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RenewContractModal$Close)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Confirm contract renewal'},
						_List_fromArray(
							[
								$author$project$Ui$Button$primary,
								$author$project$Ui$Button$loading(
								_Utils_eq(model.nY, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RenewContractModal$Renew)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Confirm')
							]))
					]))
			]));
};
var $author$project$Components$Membership$Form$RestartModal$DateInputMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Membership$Form$RestartModal$Restart = {$: 0};
var $author$project$Formatters$Date$Relative = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipBill$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$MembershipBill$Shared$date = function (_v0) {
	var record = _v0;
	return record.MO;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$date(shared);
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice = function (_v0) {
	var record = _v0.b;
	return record.Rh;
};
var $author$project$Api$Provider$MembershipBill$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$startDate(shared);
};
var $author$project$Components$Membership$Form$RestartModal$viewMembershipBill = F3(
	function (currentDate, membership, membershipBill) {
		var invoice = $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill);
		var date = $author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill);
		var startDate = A2(
			$elm$core$Maybe$withDefault,
			date,
			$author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate(membershipBill));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, startDate)),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[$author$project$Ui$Typography$primary]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill))),
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										return A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice_))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										var invoiceRoute = function () {
											if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) {
												return A2(
													$elm$core$Maybe$map,
													function (company_) {
														return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
															{
																ff: $author$project$Api$Provider$Company$Shared$id(company_),
																adR: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_)
															});
													},
													$author$project$Api$Provider$Membership$One$company(membership));
											} else {
												var owner = $author$project$Api$Provider$Membership$One$owner(membership);
												return A2(
													$elm$core$Maybe$map,
													function (owner_) {
														return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
															{
																aea: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_),
																VN: $author$project$Api$Provider$Patient$Shared$id(owner_)
															});
													},
													owner);
											}
										}();
										if (!invoiceRoute.$) {
											var route = invoiceRoute.a;
											return A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Utils$Html$noBreakSpace,
														A3(
														$author$project$Ui$Link$route,
														route,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('#'),
																$elm$html$Html$text(
																$elm$core$String$fromInt(
																	$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
															]))
													]));
										} else {
											return A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(' #'),
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								])),
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text('due '),
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										A2(
											$author$project$Formatters$Date$Relative,
											currentDate,
											$elm$core$Maybe$Just('bill')),
										date))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$RestartModal$viewMembershipPatient = function (membershipPatient) {
	var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
	var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
					{
						VN: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
					}),
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
							]))
					])),
				$author$project$Utils$Html$noBreakSpace,
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						(memberType === 1) ? $elm$html$Html$text('Adult') : $elm$html$Html$text(
						$author$project$Formatters$String$titleize(
							$author$project$Api$MemberRelationship$toString(memberType)))
					]))
			]));
};
var $author$project$Components$Membership$Form$RestartModal$viewModal = F4(
	function (pendingMembership, model, maybeDate, dateInput) {
		var upcomingAndOutstandingBills = $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership);
		var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(model.ja);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Membership$Form$RestartModal$Close,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Restart Membership')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Alert$info,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This membership will no longer end and it\'s next billing date will be '),
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											$author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership)))),
									$elm$html$Html$text('.')
								])),
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$onSubmit($author$project$Components$Membership$Form$RestartModal$Restart),
									$author$project$Ui$Form$horizontal
								]),
							$elm$core$List$concat(
								_List_fromArray(
									[
										_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Start Date'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																$author$project$Formatters$Date$Full,
																$author$project$Api$Provider$Membership$One$startDate(pendingMembership)))
														]))
												])),
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Next Bill Date'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8),
													$author$project$Ui$Form$Group$inputSpan(6),
													$author$project$Ui$Form$Group$inputSpanSm(4),
													$author$project$Ui$Form$Group$clearfix
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$RestartModal$DateInputMsg(dateInput),
													A2(
														$author$project$Components$DateInput$view,
														_List_fromArray(
															[
																$author$project$Components$DateInput$value(maybeDate)
															]),
														dateInput))
												])),
											(!$elm$core$List$isEmpty(membershipPatients)) ? A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Members'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													A2($elm$core$List$map, $author$project$Components$Membership$Form$RestartModal$viewMembershipPatient, membershipPatients))
												])) : $author$project$Utils$Html$empty,
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Upcoming Bills'),
													$author$project$Ui$Form$Group$labelSpan(4),
													$author$project$Ui$Form$Group$inputSpan(8)
												]),
											_List_Nil)
										]),
										A2(
										$elm$core$List$map,
										A2($author$project$Components$Membership$Form$RestartModal$viewMembershipBill, model.cO, model.ja),
										upcomingAndOutstandingBills)
									]))),
							$author$project$Ui$Clearfix$view
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Cancel and close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RestartModal$Close)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Restart membership'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$loading(
									_Utils_eq(model.ss, $author$project$Api$Data$Loading)),
									$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RestartModal$Restart)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Restart Membership')
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$RestartModal$view = function (model) {
	var _v0 = model.c6;
	if (_v0.$ === 1) {
		return $author$project$Utils$Html$empty;
	} else {
		var pendingMembership = _v0.a;
		return A4(
			$author$project$Components$Membership$Form$RestartModal$viewModal,
			pendingMembership,
			model,
			$author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership),
			model.qd);
	}
};
var $author$project$Components$Membership$Form$modal = function (model) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		$elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						function () {
						var _v0 = model.fm;
						if (!_v0.$) {
							var _v1 = _v0.a;
							var membership = _v1.a;
							var deleteRequest = _v1.b;
							var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(membership);
							return A2(
								$author$project$Components$HiConfirm$modal,
								$author$project$Components$Membership$Form$DeleteHiConfirmClosed(membership),
								_List_fromArray(
									[
										$author$project$Components$HiConfirm$noun('membership'),
										$author$project$Components$HiConfirm$verb('delete'),
										$author$project$Components$HiConfirm$customMessage(
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Alert$danger,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Are you sure you want to delete this membership? This cannot be undone.')
													])),
												(!$elm$core$List$isEmpty(membershipPatients)) ? A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												A2(
													$elm$core$List$cons,
													A2(
														$author$project$Ui$Typography$em,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('These related patients will also have their membership deleted.')
															])),
													A2(
														$elm$core$List$map,
														function (membershipPatient) {
															var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
															var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
															return A2(
																$author$project$Ui$Form$Group$view,
																_List_fromArray(
																	[
																		$author$project$Ui$Form$Group$labelSpan(4),
																		$author$project$Ui$Form$Group$inputSpan(4),
																		$author$project$Ui$Form$Group$clearfix,
																		$author$project$Ui$Form$Group$label(
																		(memberType === 1) ? 'Adult' : $author$project$Formatters$String$titleize(
																			$author$project$Api$MemberRelationship$toString(memberType)))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Form$Static$view,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A3(
																				$author$project$Ui$Link$route,
																				$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
																					{
																						VN: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
																					}),
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$author$project$Ui$Typography$span,
																						_List_fromArray(
																							[
																								$author$project$Ui$Typography$phi(true)
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(
																								$author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
																							]))
																					]))
																			]))
																	]));
														},
														membershipPatients))) : $author$project$Utils$Html$empty
											])),
										$author$project$Components$HiConfirm$loading(
										_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						function () {
						var _v2 = model.dv;
						if (!_v2.$) {
							var cancelModal = _v2.a;
							return A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$CancelModalMsg,
								A2($author$project$Components$Membership$Form$CancelModal$view, model.abO, cancelModal));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						function () {
						var _v3 = model.jS;
						if (!_v3.$) {
							var restartModal = _v3.a;
							return A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$RestartModalMsg,
								$author$project$Components$Membership$Form$RestartModal$view(restartModal));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						function () {
						var _v4 = model.gc;
						if (!_v4.$) {
							var _v5 = _v4.a;
							var outsideAgeRangeModal = _v5.a;
							return A2($author$project$Components$Membership$Form$OutsideAgeRangeModal$view, $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed, outsideAgeRangeModal);
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]),
					function () {
					var _v6 = model.l;
					if (!_v6.$) {
						var sections = _v6.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$SummaryMsg,
								$author$project$Components$Membership$Form$Sections$Summary$modal(sections._9)),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$MembersMsg,
								$author$project$Components$Membership$Form$Sections$Members$modal(sections.B)),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$ContractsMsg,
								$author$project$Components$Membership$Form$Sections$Contracts$modal(sections.aC)),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$RecurringChargesMsg,
								$author$project$Components$Membership$Form$Sections$RecurringCharges$modal(sections.XZ)),
								function () {
								var _v7 = sections.ju;
								if (!_v7.$) {
									var planChange = _v7.a;
									return A2(
										$elm$html$Html$map,
										$author$project$Components$Membership$Form$PlanChangeMsg,
										$author$project$Components$Membership$Form$Sections$PlanChange$modal(planChange));
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()
							]);
					} else {
						return _List_Nil;
					}
				}(),
					_List_fromArray(
					[
						function () {
						var _v8 = model.jN;
						if (!_v8.$) {
							var renewContractModal = _v8.a;
							return A2(
								$elm$html$Html$map,
								$author$project$Components$Membership$Form$RenewContractModalMsg,
								$author$project$Components$Membership$Form$RenewContractModal$view(renewContractModal));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					])
				])));
};
var $author$project$Components$Membership$Form$CancelMembership = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Membership$Form$ConfirmMembership = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$DeleteMembership = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Membership$Form$RestartMembership = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ui$Icon$Retweet = 58;
var $author$project$Components$Membership$Form$Save = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Membership$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Api$Provider$Membership$One$endDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$endDate(shared);
};
var $author$project$Api$Provider$Membership$Shared$endDateFarInThePast = function (_v0) {
	var record = _v0;
	return record.Oy;
};
var $author$project$Api$Provider$Membership$One$endDateFarInThePast = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$endDateFarInThePast(shared);
};
var $author$project$Ui$Typography$HiddenXs = {$: 29};
var $author$project$Ui$Typography$hiddenXs = $author$project$Ui$Typography$HiddenXs;
var $author$project$Api$Provider$Membership$One$isCancellable = function (_v0) {
	var record = _v0.b;
	return record.RB;
};
var $author$project$Api$Provider$Membership$One$isConfirmable = function (_v0) {
	var record = _v0.b;
	return record.RC;
};
var $author$project$Api$Provider$Membership$One$isDestroyable = function (_v0) {
	var record = _v0.b;
	return record.RJ;
};
var $author$project$Api$Provider$Membership$Shared$isRestartable = function (_v0) {
	var record = _v0;
	return record.R6;
};
var $author$project$Api$Provider$Membership$One$isRestartable = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$isRestartable(shared);
};
var $author$project$Components$Membership$Form$RenewContract = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Components$Membership$Form$viewRenewContractButton = F2(
	function (dirty, membership) {
		return ($author$project$Api$Provider$Membership$One$contractExpires(membership) && ((!(dirty && $author$project$Api$Provider$Membership$One$isUpdatable(membership))) && (!$author$project$Api$Provider$Membership$One$isRestartable(membership)))) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Renew contract'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$onClick(
					A2(
						$author$project$Components$Membership$Form$RenewContract,
						$author$project$Api$Provider$Membership$One$id(membership),
						$author$project$Api$Provider$Membership$One$lastContract(membership)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Renew Contract')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Membership$Form$viewEditButtons = F3(
	function (dirty, membership, model) {
		return _List_fromArray(
			[
				A2($author$project$Components$Membership$Form$viewRenewContractButton, dirty, membership),
				(dirty && $author$project$Api$Provider$Membership$One$isUpdatable(membership)) ? A3(
				$author$project$Ui$Button$view,
				{abp: 'Update membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$Save(false))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Update')
					])) : $author$project$Utils$Html$empty,
				((!dirty) && $author$project$Api$Provider$Membership$One$isCancellable(membership)) ? A3(
				$author$project$Ui$Button$view,
				{abp: 'End membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$CancelMembership(membership))
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 12),
						$elm$html$Html$text(' End'),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$hiddenXs]),
						_List_fromArray(
							[
								$elm$html$Html$text(' Membership')
							]))
					])) : $author$project$Utils$Html$empty,
				$author$project$Api$Provider$Membership$One$isDestroyable(membership) ? A3(
				$author$project$Ui$Button$view,
				{abp: 'Delete membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$DeleteMembership(membership)),
						$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Delete'),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$hiddenXs]),
						_List_fromArray(
							[
								$elm$html$Html$text(' Membership')
							]))
					])) : $author$project$Utils$Html$empty,
				function () {
				var _v0 = $author$project$Api$Provider$Membership$One$endDate(membership);
				if (!_v0.$) {
					var isRestartable = $author$project$Api$Provider$Membership$One$isRestartable(membership);
					var endDateFarInThePast = $author$project$Api$Provider$Membership$One$endDateFarInThePast(membership);
					var button = A3(
						$author$project$Ui$Button$view,
						{abp: 'Restart memberhsip'},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(1),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Membership$Form$RestartMembership(membership)),
								$author$project$Ui$Button$disabled(
								!$author$project$Api$Provider$Membership$One$isRestartable(membership))
							]),
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 58),
								$elm$html$Html$text(' Restart'),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$hiddenXs]),
								_List_fromArray(
									[
										$elm$html$Html$text(' Membership')
									]))
							]));
					var _v1 = _Utils_Tuple2(isRestartable, endDateFarInThePast);
					if (_v1.a) {
						return button;
					} else {
						if (_v1.b) {
							return A3(
								$author$project$Ui$Tooltip$view,
								_List_Nil,
								'Memberships which ended more than 3 months in the past cannot be restarted. Please create a new membership for the patient.',
								_List_fromArray(
									[button]));
						} else {
							return A3(
								$author$project$Ui$Tooltip$view,
								_List_Nil,
								'This membership is not restartable',
								_List_fromArray(
									[button]));
						}
					}
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				((!dirty) && $author$project$Api$Provider$Membership$One$isConfirmable(membership)) ? A3(
				$author$project$Ui$Button$view,
				{abp: 'Confirm membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$ConfirmMembership(membership))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Confirm'),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$hiddenXs]),
						_List_fromArray(
							[
								$elm$html$Html$text(' Membership')
							]))
					])) : $author$project$Utils$Html$empty
			]);
	});
var $author$project$Ui$Typography$ContentDisabled = function (a) {
	return {$: 33, a: a};
};
var $author$project$Ui$Typography$contentDisabled = $author$project$Ui$Typography$ContentDisabled;
var $author$project$Ui$Spinner$Pull = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Spinner$pull = $author$project$Ui$Spinner$Pull;
var $author$project$Components$Membership$Form$Sections$BillsOverview$IssueInvoice = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$charges = function (_v0) {
	var record = _v0.b;
	return record.KU;
};
var $author$project$Api$Provider$MembershipBill$Shared$couponDiscountInCents = function (_v0) {
	var record = _v0;
	return record.L2;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$couponDiscountInCents(shared);
};
var $author$project$Api$Provider$MembershipBill$Shared$couponDiscountMonths = function (_v0) {
	var record = _v0;
	return record.L3;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$couponDiscountMonths(shared);
};
var $author$project$Api$Provider$Membership$Meta$invoiceNowAction = function (_v0) {
	var meta = _v0;
	return meta.tF.Rp;
};
var $author$project$Utils$Date$isAfterOrEqual = F2(
	function (date, otherDate) {
		return A2($author$project$Utils$Date$isAfter, date, otherDate) || _Utils_eq(date, otherDate);
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$isFirstUninvoicedBill = F3(
	function (isNew, membershipBills, index) {
		return isNew ? false : _Utils_eq(
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (membershipBill) {
					return !$author$project$Utils$Maybe$toBool(
						$author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill));
				},
				membershipBills),
			$elm$core$Maybe$Just(index));
	});
var $author$project$Api$Provider$MembershipBill$Shared$membershipAmountInCents = function (_v0) {
	var record = _v0;
	return record.TD;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$membershipAmountInCents(shared);
};
var $author$project$Api$Common$Payable$Invoice$Min$paymentScheduledOn = function (_v0) {
	var record = _v0;
	return record.V2;
};
var $author$project$Api$Provider$MembershipBill$Shared$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Wc;
};
var $author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipBill$Shared$periodInMonths(shared);
};
var $author$project$Api$Provider$Membership$One$shouldBeBilledUpToDate = function (_v0) {
	var record = _v0.b;
	return record.ZO;
};
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$quantity = function (_v0) {
	var record = _v0;
	return record.Bd;
};
var $author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBillCharge = function (membershipBillCharge) {
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$author$project$Formatters$String$ellipsis,
									27,
									$author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$name(membershipBillCharge))),
								$elm$html$Html$text(' x ')
							])),
						$elm$html$Html$text(
						$elm$core$String$fromInt(
							$author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$quantity(membershipBillCharge)))
					])),
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text(
				$author$project$Utils$Currency$fromInt(
					$author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$amountInCents(membershipBillCharge)))
			]));
};
var $author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBill = F8(
	function (membership, pendingMembership, isNew, sameAsOriginal, model, membershipBills, index, membershipBill) {
		var startDate = $author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate(membershipBill);
		var owner = $author$project$Api$Provider$Membership$One$owner(membership);
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var invoice = $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill);
		var date = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill),
			startDate);
		var couponDiscountInCents = $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents(membershipBill);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, date))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$primary]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill))),
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										return A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Utils$Html$noBreakSpace,
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice_))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									($author$project$Api$Provider$Membership$Meta$invoiceNowAction(membershipMeta) && ($author$project$Api$Provider$Membership$One$isConfirmed(membership) && A3($author$project$Components$Membership$Form$Sections$BillsOverview$isFirstUninvoicedBill, isNew, membershipBills, index))) ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Utils$Html$noBreakSpace,
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Invoice now'},
											_List_fromArray(
												[
													$author$project$Ui$Button$size(0),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Membership$Form$Sections$BillsOverview$IssueInvoice(startDate)),
													$author$project$Ui$Button$disabled(!sameAsOriginal),
													$author$project$Ui$Button$loading(
													_Utils_eq(model.lb, $author$project$Api$Data$Loading)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Invoice Now')
												]))
										])) : $author$project$Utils$Html$empty,
									function () {
									if (!invoice.$) {
										var invoice_ = invoice.a;
										var invoiceRoute = $author$project$Api$Provider$Membership$One$isSponsored(membership) ? A2(
											$elm$core$Maybe$map,
											function (company_) {
												return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
													{
														ff: $author$project$Api$Provider$Company$Shared$id(company_),
														adR: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_)
													});
											},
											$author$project$Api$Provider$Membership$One$company(pendingMembership)) : A2(
											$elm$core$Maybe$map,
											function (owner_) {
												return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
													{
														aea: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_),
														VN: $author$project$Api$Provider$Patient$Shared$id(owner_)
													});
											},
											owner);
										if (!invoiceRoute.$) {
											var route = invoiceRoute.a;
											return A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Utils$Html$noBreakSpace,
														A3(
														$author$project$Ui$Link$route,
														route,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('#'),
																$elm$html$Html$text(
																$elm$core$String$fromInt(
																	$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
															]))
													]));
										} else {
											return A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(' #'),
														$elm$html$Html$text(
														$elm$core$String$fromInt(
															$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
													]));
										}
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])),
					function () {
					var _v3 = $author$project$Api$Provider$Membership$One$shouldBeBilledUpToDate(pendingMembership);
					if (!_v3.$) {
						var shouldBeBilledUpToDate_ = _v3.a;
						var autopay = A2(
							$elm$core$Maybe$withDefault,
							false,
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$autopay, owner));
						return (autopay && ((!(!A2(
							$justinmimbs$date$Date$compare,
							shouldBeBilledUpToDate_,
							$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)))) && ((!$author$project$Utils$Maybe$toBool(invoice)) && (!$author$project$Api$Provider$Membership$One$isSponsored(membership))))) ? A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text('Will automatically invoice '),
									A2(
									$author$project$Utils$Date$isAfterOrEqual,
									model.cO,
									$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)) ? $elm$html$Html$text('and bill ') : $elm$html$Html$text(' '),
									$elm$html$Html$text('tonight.')
								])) : $author$project$Utils$Html$empty;
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v4 = _Utils_Tuple2(
						$author$project$Api$Provider$Membership$One$isSponsored(membership),
						A2($elm$core$Maybe$andThen, $author$project$Api$Common$Payable$Invoice$Min$paymentScheduledOn, invoice));
					if (!_v4.a) {
						if (!_v4.b.$) {
							var paymenScheduledOn = _v4.b.a;
							var contents = (!A2($justinmimbs$date$Date$compare, model.cO, paymenScheduledOn)) ? _List_fromArray(
								[
									$elm$html$Html$text('Payment scheduled for '),
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, paymenScheduledOn)),
									$elm$html$Html$text('.')
								]) : _List_fromArray(
								[
									$elm$html$Html$text('Payment scheduled for tonight.')
								]);
							return A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$small]),
								contents);
						} else {
							var _v5 = _v4.b;
							return $author$project$Utils$Html$empty;
						}
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$author$project$Api$Provider$Membership$One$isSponsored(membership) ? $author$project$Utils$Html$empty : $elm$html$Html$text('Due '),
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)))
						])),
					function () {
					var _v6 = $author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents(membershipBill);
					if (!_v6.$) {
						var registrationFeeInCents = _v6.a;
						return (registrationFeeInCents > 0) ? A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Registration Fee')
										])),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(registrationFeeInCents))
								])) : $author$project$Utils$Html$empty;
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					A2(
						$elm$core$List$map,
						$author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBillCharge,
						$author$project$Api$Provider$MembershipBill$ForMembershipOne$charges(membershipBill))),
					function () {
					if (($author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents(membershipBill) > 0) || ($author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents(membershipBill) > 0)) {
						var periodInMonths = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths(membershipBill));
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Membership')
										])),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents(membershipBill))),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Int$asPeriod(periodInMonths))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					if (couponDiscountInCents > 0) {
						var periodInMonths = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths(membershipBill));
						var couponDiscountMonths = A2(
							$elm$core$Maybe$withDefault,
							0,
							$author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountMonths(membershipBill));
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Includes '),
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(couponDiscountInCents)),
											$elm$html$Html$text(' coupon discount')
										])),
									(_Utils_cmp(couponDiscountMonths, periodInMonths) < 0) ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('('),
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt((couponDiscountInCents / couponDiscountMonths) | 0)),
											$elm$html$Html$text(') off for '),
											$elm$html$Html$text(
											A2($author$project$Formatters$String$pluralize, 'month', couponDiscountMonths))
										])) : $author$project$Utils$Html$empty
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$viewBillsOverview = F2(
	function (_v0, model) {
		var membership = _v0.ja;
		var pendingMembership = _v0.c6;
		var isNew = _v0.iX;
		var priceCheckLoading = _v0.afW;
		var sameAsOriginal = _v0.gz;
		var upcomingAndOutstandingBills = $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership);
		var owner = $author$project$Api$Provider$Membership$One$owner(pendingMembership);
		var autopay = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$autopay, owner));
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$contentDisabled(priceCheckLoading)
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$author$project$Ui$HorizontalRule$view(_List_Nil),
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Bills overview')
								])),
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(3),
									$author$project$Ui$Form$Group$inputSpanSm(9),
									$author$project$Ui$Form$Group$label('Autopay')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													autopay ? $elm$html$Html$text('Enabled') : $elm$html$Html$text('Disabled')
												]))
										])),
									priceCheckLoading ? $author$project$Ui$Spinner$view(
									_List_fromArray(
										[
											$author$project$Ui$Spinner$pull(1)
										])) : $author$project$Utils$Html$empty
								]))
						]),
						A2(
						$elm$core$List$indexedMap,
						A6($author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBill, membership, pendingMembership, isNew, sameAsOriginal, model, upcomingAndOutstandingBills),
						upcomingAndOutstandingBills)
					])));
	});
var $author$project$Components$Membership$Form$Sections$BillsOverview$view = F2(
	function (shared, model) {
		return $elm$core$List$isEmpty(
			$author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(shared.c6)) ? $author$project$Utils$Html$empty : A2($author$project$Components$Membership$Form$Sections$BillsOverview$viewBillsOverview, shared, model);
	});
var $author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts = {$: 2};
var $author$project$Api$Provider$Membership$One$firstContract = function (_v0) {
	var record = _v0.b;
	return record.Pt;
};
var $author$project$Api$Provider$MembershipContract$Shared$isUpcoming = function (_v0) {
	var record = _v0;
	return record.Se;
};
var $author$project$Api$Provider$MembershipContract$All$endDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$MembershipContract$Shared$endDate(shared);
};
var $author$project$Api$Provider$MembershipContract$Shared$memo = function (_v0) {
	var record = _v0;
	return record.aeC;
};
var $author$project$Api$Provider$MembershipContract$All$memo = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$MembershipContract$Shared$memo(shared);
};
var $author$project$Api$Provider$MembershipContract$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$MembershipContract$All$startDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$MembershipContract$Shared$startDate(shared);
};
var $author$project$Components$Membership$Form$Sections$Contracts$CancelContract = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract = F7(
	function (canCancel, isNew, membership, period, startDate, endDate, memo) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					'Contract period ' + $elm$core$String$fromInt(period))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									startDate))),
							$elm$html$Html$text(' - '),
							A3(
							$author$project$Ui$Tooltip$view,
							_List_fromArray(
								[
									$author$project$Ui$Tooltip$placement(0)
								]),
							memo,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$gray, $author$project$Ui$Typography$ellipsis]),
									_List_fromArray(
										[
											$elm$html$Html$text(memo)
										]))
								])),
							function () {
							var _v0 = _Utils_Tuple2(canCancel, isNew);
							if (_v0.a && _v0.b) {
								return A3(
									$author$project$Ui$Button$view,
									{abp: 'Cancel contract'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Membership$Form$Sections$Contracts$CancelContract(
												$author$project$Api$Provider$Membership$One$id(membership)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel contract')
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									endDate)))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractAll = F6(
	function (membershipContracts, canCancel, isNew, membership, index, membershipContract) {
		if ((!index) || _Utils_eq(
			index,
			$elm$core$List$length(membershipContracts) - 1)) {
			return $author$project$Utils$Html$empty;
		} else {
			var startDate = $author$project$Api$Provider$MembershipContract$All$startDate(membershipContract);
			var memo = A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$MembershipContract$All$memo(membershipContract));
			var endDate = $author$project$Api$Provider$MembershipContract$All$endDate(membershipContract);
			return A7(
				$author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract,
				canCancel,
				isNew,
				membership,
				index + 1,
				$elm$core$Maybe$Just(startDate),
				endDate,
				memo);
		}
	});
var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared = F5(
	function (canCancel, isNew, membership, period, membershipContract) {
		var startDate = A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipContract$Shared$startDate, membershipContract);
		var memo = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$memo, membershipContract));
		var endDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$endDate, membershipContract);
		return A7($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract, canCancel, isNew, membership, period, startDate, endDate, memo);
	});
var $author$project$Components$Membership$Form$Sections$Contracts$viewContracts = F4(
	function (showAllContracts, isNew, membership, membershipContracts) {
		var firstContract = $author$project$Api$Provider$Membership$One$firstContract(membership);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A5($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared, false, isNew, membership, 1, firstContract)
						]),
						(($elm$core$List$length(membershipContracts) > 2) && (!showAllContracts)) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(3),
									$author$project$Ui$Form$Group$inputSpanSm(9),
									$author$project$Ui$Form$Group$label('')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Show more contracts'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Show more')
										]))
								]))
						]) : _List_Nil,
						showAllContracts ? A2(
						$elm$core$List$indexedMap,
						A4($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractAll, membershipContracts, false, isNew, membership),
						membershipContracts) : _List_Nil,
						function () {
						if ($elm$core$List$length(membershipContracts) > 1) {
							var lastContract = $author$project$Api$Provider$Membership$One$lastContract(membership);
							return _List_fromArray(
								[
									A5(
									$author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared,
									A2(
										$elm$core$Maybe$withDefault,
										false,
										A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipContract$Shared$isUpcoming, lastContract)),
									isNew,
									membership,
									$elm$core$List$length(membershipContracts),
									lastContract)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						showAllContracts ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(3),
									$author$project$Ui$Form$Group$inputSpanSm(9),
									$author$project$Ui$Form$Group$label('')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Show less contracts'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Show less')
										]))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonths = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewContractPeriodInMonthsField = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var periodInMonths = _v0.Wc;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(4),
				$author$project$Ui$Form$Group$label('Contract period'),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$PeriodInMonthsInput$view(
				{
					fE: A2($author$project$Utils$Form$validationErrors, 1, form),
					q$: A2($author$project$Utils$Form$hasValidationErrors, 1, form),
					afc: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonths),
					aaN: periodInMonths
				})
			]));
};
var $author$project$Components$Membership$Form$Sections$Contracts$Type = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$Meta$contractTypeValues = function (_v0) {
	var meta = _v0;
	return meta.EI.o9;
};
var $author$project$Components$Membership$Form$Sections$Contracts$typeOptions = function (membershipMeta) {
	var types = $author$project$Api$Provider$Membership$Meta$contractTypeValues(membershipMeta);
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'Choose an action'),
		A2(
			$elm$core$List$map,
			function (type_) {
				var typeString = $author$project$Api$ContractType$toString(type_);
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(typeString),
					$author$project$Formatters$String$titleize(
						$author$project$Formatters$String$humanize(typeString)));
			},
			types));
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewContractTypeField = F2(
	function (membershipMeta, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var type_ = _v0.ahI;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(4),
					$author$project$Ui$Form$Group$label('At End Of Period'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(
							A2($elm$core$Maybe$map, $author$project$Api$ContractType$toString, type_)),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$Type)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]),
					$author$project$Components$Membership$Form$Sections$Contracts$typeOptions(membershipMeta))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$EndDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Membership$Meta$contractEndDateValues = function (_v0) {
	var meta = _v0;
	return meta.wO.o9;
};
var $author$project$Components$Membership$Form$Sections$Contracts$validContractEndDates = function (pendingMembership) {
	var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
	var contractEndDates = $author$project$Api$Provider$Membership$Meta$contractEndDateValues(membershipMeta);
	var contractEndDate = function () {
		var _v1 = $author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership);
		if (!_v1.$) {
			var date = _v1.a;
			return $elm$core$Maybe$Just(date);
		} else {
			return $author$project$Api$Provider$Membership$Meta$contractEndDateDefault(membershipMeta);
		}
	}();
	return A2(
		$elm$core$List$sortBy,
		$justinmimbs$date$Date$toRataDie,
		function () {
			if (!contractEndDate.$) {
				var date = contractEndDate.a;
				return A2($elm$core$List$member, date, contractEndDates) ? contractEndDates : A2($elm$core$List$cons, date, contractEndDates);
			} else {
				return contractEndDates;
			}
		}());
};
var $author$project$Components$Membership$Form$Sections$Contracts$endDatesOptions = function (pendingMembership) {
	return A2(
		$elm$core$List$map,
		function (date) {
			var dateString = $justinmimbs$date$Date$toIsoString(date);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(dateString),
				A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
		},
		$author$project$Components$Membership$Form$Sections$Contracts$validContractEndDates(pendingMembership));
};
var $author$project$Api$Provider$Membership$One$finalBillingEndDate = function (_v0) {
	var record = _v0.b;
	return record.Pp;
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewEndDateField = F3(
	function (pendingMembership, editEndDate, form) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Contract End Date')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					function () {
						if ((!editEndDate) && $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership)) {
							var meta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
							var contractEndDate = function () {
								var _v0 = _Utils_Tuple2(
									$author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership),
									$author$project$Api$Provider$Membership$Meta$contractEndDateDefault(meta));
								if (!_v0.a.$) {
									var date = _v0.a.a;
									return $elm$core$Maybe$Just(date);
								} else {
									var _v1 = _v0.a;
									var contractEndDateDefault = _v0.b;
									return contractEndDateDefault;
								}
							}();
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
															contractEndDate))),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Change contract end date'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$pull(1),
															$author$project$Ui$Button$onClick(
															$author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate(
																$author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Change Contract End Date')
														]))
												]))
										]))
								]);
						} else {
							var _v2 = $author$project$Utils$Form$fields(form);
							var endDate = _v2.qs;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(5)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, endDate)),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$EndDate))
												]),
											$author$project$Components$Membership$Form$Sections$Contracts$endDatesOptions(pendingMembership))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(7)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: ' Cancel end date edition'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$pull(1),
													$author$project$Ui$Button$onClick(
													$author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate(
														$author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												]))
										]))
								]);
						}
					}()),
					(!_Utils_eq(
					$author$project$Api$Provider$Membership$One$finalBillingEndDate(pendingMembership),
					$author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership))) ? A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$label,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('Contract end date does not align with the billing periods')
										]))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$Expires = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewExpiresField = function (form) {
	var _v0 = $author$project$Utils$Form$fields(form);
	var expires = _v0.OY;
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Contract Expires')
			]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$on(expires),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$Expires))
					]))
			]));
};
var $author$project$Components$Membership$Form$Sections$Contracts$viewForm = F3(
	function (model, pendingMembership, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var expires = _v0.OY;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Components$Membership$Form$Sections$Contracts$viewExpiresField(form),
					function () {
					if (expires) {
						var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Api$Provider$Membership$Meta$contractEndDateEditable(membershipMeta) ? A3($author$project$Components$Membership$Form$Sections$Contracts$viewEndDateField, pendingMembership, model.is, form) : $author$project$Utils$Html$empty,
									$author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable(membershipMeta) ? $author$project$Components$Membership$Form$Sections$Contracts$viewContractPeriodInMonthsField(form) : $author$project$Utils$Html$empty,
									$author$project$Api$Provider$Membership$Meta$contractTypeEditable(membershipMeta) ? A2($author$project$Components$Membership$Form$Sections$Contracts$viewContractTypeField, membershipMeta, form) : $author$project$Utils$Html$empty
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Contracts$view = F2(
	function (_v0, _v1) {
		var isNew = _v0.iX;
		var membership = _v0.ja;
		var pendingMembership = _v0.c6;
		var model = _v1;
		var plan = $author$project$Api$Provider$Membership$One$plan(membership);
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		if (($author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires(plan) || $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership)) && $author$project$Api$Provider$Membership$Meta$contractExpiresEditable(pendingMembershipMeta)) {
			var membershipContracts = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Api$Data$toMaybe(model.yR));
			var fields = $author$project$Utils$Form$fields(model.PB);
			return A2(
				$author$project$Ui$Typography$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Contract Periods')
							])),
						A3($author$project$Components$Membership$Form$Sections$Contracts$viewForm, model, pendingMembership, model.PB),
						(fields.OY && ((!$elm$core$List$isEmpty(membershipContracts)) && $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership))) ? A4($author$project$Components$Membership$Form$Sections$Contracts$viewContracts, model.sI, isNew, membership, membershipContracts) : $author$project$Utils$Html$empty
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Membership$Form$Sections$Members$AddMember = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$Members$membershipPatientSortValue = F2(
	function (membership, _v0) {
		var originalIndex = _v0.a;
		var membershipPatient = _v0.b;
		var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
		var original = A2(
			$elm_community$list_extra$List$Extra$find,
			function (membershipPatient_) {
				return _Utils_eq(
					$author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_),
					membershipPatientRecord.adR);
			},
			$author$project$Api$Provider$Membership$One$membershipPatients(membership));
		var _v1 = function () {
			if (!original.$) {
				var original_ = original.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(original_));
			} else {
				return _Utils_Tuple2(membershipPatientRecord.DV, membershipPatientRecord.qs);
			}
		}();
		var action = _v1.a;
		var endDate = _v1.b;
		return _Utils_eq(
			action,
			$elm$core$Maybe$Just('create')) ? _Utils_Tuple2(4, originalIndex) : (_Utils_eq(
			action,
			$elm$core$Maybe$Just('restart')) ? _Utils_Tuple2(1, originalIndex) : ((_Utils_eq(
			action,
			$elm$core$Maybe$Just('terminate')) || _Utils_eq(
			action,
			$elm$core$Maybe$Just('destroy'))) ? _Utils_Tuple2(2, originalIndex) : ((!$author$project$Utils$Maybe$toBool(endDate)) ? _Utils_Tuple2(0, originalIndex) : _Utils_Tuple2(3, originalIndex))));
	});
var $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient = function (_v0) {
	var meta = _v0;
	return meta.TF.VM;
};
var $author$project$Components$Membership$Form$Sections$Members$overMaxMembershipPatientsWarning = F2(
	function (maxMembershipPatients, membershipPatients) {
		return (_Utils_cmp(
			$elm$core$Dict$size(membershipPatients),
			maxMembershipPatients) > 0) ? A2(
			$author$project$Ui$Alert$warning,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('This sponsored membership '),
					function () {
					if (maxMembershipPatients === 1) {
						return $elm$html$Html$text('does not allow dependents');
					} else {
						return $elm$html$Html$text(
							'only allows ' + A2($author$project$Formatters$String$pluralize, 'dependent', maxMembershipPatients - 1));
					}
				}(),
					$elm$html$Html$text(', by saving this membership you are choosing to exceed that limit.')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Ui$Typography$Inactive = function (a) {
	return {$: 34, a: a};
};
var $author$project$Ui$Typography$inactive = $author$project$Ui$Typography$Inactive;
var $author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$isMcePlan(shared);
};
var $author$project$Api$Provider$Membership$One$isSynced = function (_v0) {
	var record = _v0.b;
	return record.Sa;
};
var $author$project$Components$CancellationReason$Display$view = F2(
	function (cancellationReason, cancellationReasonOther) {
		var isTerminatedByPatient = cancellationReason.Nx === 'Termination by Patient';
		var patientNoteView = isTerminatedByPatient ? A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					'\"' + (A2($elm$core$Maybe$withDefault, '', cancellationReasonOther) + '\"'))
				])) : $author$project$Utils$Html$empty;
		var descriptionText = function () {
			if (isTerminatedByPatient) {
				return 'Termination by Patient';
			} else {
				var _v0 = _Utils_Tuple2(cancellationReason.Nx, cancellationReasonOther);
				if ((_v0.a === 'Other') && (!_v0.b.$)) {
					var customReason = _v0.b.a;
					return customReason;
				} else {
					return cancellationReason.Nx;
				}
			}
		}();
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(descriptionText),
							patientNoteView
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReason = F2(
	function (membershipPatient, cancellationReason) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Cancellation Reason')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Components$CancellationReason$Display$view, cancellationReason, membershipPatient.abN)
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReason = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReasonInput = F3(
	function (cancellationReasons, membershipPatient, model) {
		return $author$project$Components$CancellationReason$Input$view(
			{
				abO: cancellationReasons,
				fE: A2($author$project$Utils$Form$validationErrors, 7, model.PB),
				OP: A2($author$project$Utils$Form$validationErrors, 8, model.PB),
				aek: $elm$core$Maybe$Just(3),
				ae4: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReason),
				aaN: _Utils_Tuple2(membershipPatient.abM, membershipPatient.abN)
			});
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewEndDateInput = F3(
	function (pendingMembership, membershipPatient, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('End date'),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg,
					A2(
						$author$project$Components$DateInput$view,
						_List_fromArray(
							[
								$author$project$Components$DateInput$value(membershipPatient.qs),
								$author$project$Components$DateInput$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 6, model.PB)),
								$author$project$Components$DateInput$errors(
								A2($author$project$Utils$Form$validationErrors, 6, model.PB))
							]),
						model.qu)),
					($author$project$Utils$Maybe$toBool(membershipPatient.Ps) && (!_Utils_eq(membershipPatient.qs, model.Gw.qs))) ? A3($author$project$Components$Membership$Form$Utils$mayNeedProrationWarning, 'patient', pendingMembership, membershipPatient.qs) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$EditEnrollmentRequestedOn = {$: 4};
var $author$project$Api$Provider$Membership$Meta$membershipPatientsEnrollmentRequestedOn = function (_v0) {
	var meta = _v0;
	return meta.TF.OH;
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewEnrollmentRequestedOnInput = F4(
	function (membership, isPatientActive, membershipPatient, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Enrollment Requested')
				]),
			_List_fromArray(
				[
					function () {
					if (model.qm) {
						return A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg,
							A2(
								$author$project$Components$DateInput$view,
								_List_fromArray(
									[
										$author$project$Components$DateInput$value(membershipPatient.OH),
										$author$project$Components$DateInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 2, model.PB)),
										$author$project$Components$DateInput$errors(
										A2($author$project$Utils$Form$validationErrors, 2, model.PB))
									]),
								model.qy));
					} else {
						var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
						var enrollmentRequestedOnIsEditable = (!model.aN) && $author$project$Api$Provider$Membership$Meta$membershipPatientsEnrollmentRequestedOn(membershipMeta);
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											membershipPatient.OH))),
									(isPatientActive && enrollmentRequestedOnIsEditable) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Change enrollment requested on date'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$EditEnrollmentRequestedOn)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Date')
										])) : $author$project$Utils$Html$empty
								]));
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCents = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$ToggleFixedPeriodRateInCentsOverride = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$billAffiliateRateEnabled = F2(
	function (practice, company) {
		var ratesFromAffiliate = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Network$Shared$ratesFromAffiliate,
				$author$project$Api$Provider$Practice$One$network(practice)));
		var billAffiliateRateCompanySetting = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$billAffiliateRate, company));
		return ratesFromAffiliate && billAffiliateRateCompanySetting;
	});
var $author$project$Api$Provider$Membership$Meta$membershipPatientsFixedPeriodRateInCents = function (_v0) {
	var meta = _v0;
	return meta.TF.Pw;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$revenueInCents = function (_v0) {
	var record = _v0.b;
	return record.YF;
};
var $author$project$Formatters$Int$asPeriodHuman = function (periodInMonths) {
	switch (periodInMonths) {
		case 1:
			return 'Monthly';
		case 3:
			return 'Quarterly';
		case 6:
			return 'Semi-annually';
		case 12:
			return 'Annually';
		default:
			return 'Every ' + ($elm$core$String$fromInt(periodInMonths) + ' Months');
	}
};
var $author$project$Components$FixedRate$view = F3(
	function (_v0, onInput, toggleEdit) {
		var editable = _v0.Oa;
		var disabled = _v0.dW;
		var editing = _v0.w;
		var current = _v0.Mr;
		var period = _v0.afK;
		var value = _v0.aaN;
		var billAffiliateRate = _v0.JW;
		var defaultValue = _v0.Nm;
		var errors = _v0.fE;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							editing ? A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Form$CurrencyInput$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$CurrencyInput$value(value),
											$author$project$Ui$Form$CurrencyInput$onInput(onInput),
											$author$project$Ui$Form$CurrencyInput$invalid(
											!$elm$core$List$isEmpty(errors)),
											$author$project$Ui$Form$CurrencyInput$placeholder('10.00')
										])),
									$author$project$Utils$FormErrors$view(errors)
								])) : A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Currency$format(
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Currency$fromInt(0),
											defaultValue))),
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(
									$author$project$Formatters$Int$asPeriodHuman(period))
								]))
						])),
					editable ? A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(6),
							$author$project$Ui$FlexGrid$justifyRight
						]),
					_List_fromArray(
						[
							function () {
							var verb = editing ? 'Remove Override' : 'Override Rate';
							return A3(
								$author$project$Ui$Button$view,
								{abp: verb},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$onClick(toggleEdit),
										$author$project$Ui$Button$disabled((!editing) && disabled)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(verb)
									]));
						}()
						])) : $author$project$Ui$FlexGrid$none,
					function () {
					if (!current.$) {
						return A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Fixed price ('),
											$elm$html$Html$text(
											$author$project$Formatters$Int$asPeriodHuman(period)),
											$elm$html$Html$text(')')
										]))
								]));
					} else {
						return $author$project$Ui$FlexGrid$none;
					}
				}(),
					((!editable) || $author$project$Utils$Maybe$toBool(current)) ? $author$project$Ui$FlexGrid$none : (billAffiliateRate ? A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Automatically calculated using Affiliate Rate')
								]))
						])) : A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('Automatically calculated')
								]))
						])))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewFixedPeriodRateInput = F5(
	function (_v0, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
		var membership = _v0.ja;
		var pendingMembership = _v0.c6;
		var onlyOneFixedPeriodRateInCentsEditable = _v0.afr;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var fixedPeriodRateInCentsIsEditable = (!model.aN) && $author$project$Api$Provider$Membership$Meta$membershipPatientsFixedPeriodRateInCents(membershipMeta);
		var defaultValue = A2(
			$elm$core$Maybe$map,
			$author$project$Currency$fromInt,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$revenueInCents, pendingMembershipPatient));
		var billAffiliateRate = A2(
			$author$project$Components$Membership$Form$Members$MembershipPatient$billAffiliateRateEnabled,
			model.WF,
			$author$project$Api$Provider$Membership$One$company(membership));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Rate'),
					$author$project$Ui$Form$Group$required(model.dZ)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$FixedRate$view,
					{
						JW: billAffiliateRate,
						Mr: A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents, pendingMembershipPatient),
						Nm: defaultValue,
						dW: onlyOneFixedPeriodRateInCentsEditable,
						Oa: isPatientActive && fixedPeriodRateInCentsIsEditable,
						w: model.dZ,
						fE: A2($author$project$Utils$Form$validationErrors, 5, model.PB),
						afK: $author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership),
						aaN: membershipPatient.Pw
					},
					A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCents),
					$author$project$Components$Membership$Form$Members$MembershipPatient$ToggleFixedPeriodRateInCentsOverride(defaultValue))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$AddNewPatient = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Remove = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$Restart = {$: 0};
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientInput = F8(
	function (practice, owner, membership, pendingMembership, activePatientsCount, isPatientActive, membershipPatient, model) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var patientIsEditable = (!model.aN) && $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta);
		var memberType = membershipPatient.TB;
		var isActive = !$author$project$Utils$Maybe$toBool(membershipPatient.Oe);
		var humanMemberType = ($author$project$Api$Provider$Practice$One$usesSponsors(practice) && (!memberType)) ? 'primary member' : ((memberType === 1) ? 'adult' : $author$project$Api$MemberRelationship$toString(memberType));
		var canRestartPatient = (isPatientActive || ((!$author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta)) || (!memberType))) ? false : ($author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Meta$CompanyRegistration$enrollAction,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.TU;
					},
					membershipPatient.Ly))) : true);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					$author$project$Formatters$String$titleize(humanMemberType))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(9)
								]),
							_List_fromArray(
								[
									function () {
									var _v0 = membershipPatient.VM;
									if (!_v0.$) {
										var patient = _v0.a;
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
														{VN: patient.adR}),
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[
																	$author$project$Ui$Typography$phi(true)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(patient.zh)
																]))
														]))
												]));
									} else {
										return A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg,
													A2(
														$author$project$Components$ResourceFilter$Patient$view,
														_List_fromArray(
															[
																$author$project$Components$ResourceFilter$invalid(
																A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
																$author$project$Components$ResourceFilter$errors(
																A2($author$project$Utils$Form$validationErrors, 0, model.PB))
															]),
														model.rU)),
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$small]),
													_List_fromArray(
														[
															$elm$html$Html$text(' or '),
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Add a new patient'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																	$author$project$Ui$Button$size(0),
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Membership$Form$Members$MembershipPatient$AddNewPatient(owner))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add a new patient')
																]))
														]))
												]));
									}
								}(),
									(isActive || model.aN) ? $author$project$Utils$Html$empty : A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Member from '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													membershipPatient._E))),
											$elm$html$Html$text(' to '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													membershipPatient.Oe)))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(3)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											canRestartPatient ? A3(
											$author$project$Ui$Button$view,
											{abp: 'Restart patient'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$pull(1),
													$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$Restart)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Restart Patient')
												])) : $author$project$Utils$Html$empty,
											function () {
											if ((isPatientActive || model.aN) && (patientIsEditable && (!(!memberType)))) {
												var removeError = (!membershipPatient.TB) ? $elm$core$Maybe$Just('You cannot remove the employee from a sponsored membership.') : ((activePatientsCount === 1) ? $elm$core$Maybe$Just('You can\'t remove the only patient on a membership. Please add another patient first, or if you\'d like to just end the membership, you can click that button below.') : $elm$core$Maybe$Nothing);
												var endDate = A2(
													$elm_community$list_extra$List$Extra$maximumBy,
													$justinmimbs$date$Date$toRataDie,
													A2(
														$elm$core$List$filterMap,
														$elm$core$Basics$identity,
														_List_fromArray(
															[
																membershipPatient._E,
																$author$project$Api$Provider$Membership$Meta$endDateDefaultValue(membershipMeta)
															])));
												return A3(
													$author$project$Ui$Tooltip$view,
													_List_fromArray(
														[
															$author$project$Ui$Tooltip$placement(0),
															$author$project$Ui$Tooltip$active(
															$author$project$Utils$Maybe$toBool(removeError))
														]),
													A2($elm$core$Maybe$withDefault, '', removeError),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Remove patient'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Membership$Form$Members$MembershipPatient$Remove(endDate)),
																	$author$project$Ui$Button$disabled(
																	$author$project$Utils$Maybe$toBool(removeError))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Remove Patient')
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobacco = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$patientUsesTobaccoOptions = _List_fromArray(
	[
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(''),
		'Choose an option'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Utils$Bool$toString(true)),
		'Uses tobacco'),
		A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Utils$Bool$toString(false)),
		'Does not use tobacco')
	]);
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientUsesTobaccoInput = F3(
	function (pendingMembershipPatient, patient, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Tobacco use'),
					$author$project$Ui$Form$Group$required(model.d_)
				]),
			_List_fromArray(
				[
					model.d_ ? A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(
							A2($elm$core$Maybe$map, $author$project$Utils$Bool$toString, patient.aaI)),
							$author$project$Ui$Form$Select$onChange(
							A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobacco)),
							$author$project$Ui$Form$Select$invalid(
							A2($author$project$Utils$Form$hasValidationErrors, 1, model.PB)),
							$author$project$Ui$Form$Select$errors(
							A2($author$project$Utils$Form$validationErrors, 1, model.PB))
						]),
					$author$project$Components$Membership$Form$Members$MembershipPatient$patientUsesTobaccoOptions) : A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							false,
							A2(
								$elm$core$Maybe$andThen,
								A2($elm$core$Basics$composeR, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco),
								pendingMembershipPatient)) ? $elm$html$Html$text('Uses tobacco') : $elm$html$Html$text('Does not use tobacco')
						]))
				]));
	});
var $author$project$Api$Plan$ProviderSharedWithContractInfo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$ToggleSpecialRateOverride = {$: 8};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$discountRule = function (_v0) {
	var record = _v0.b;
	return record.NK;
};
var $author$project$Api$Provider$Membership$Meta$membershipPatientsSpecialRate = function (_v0) {
	var meta = _v0;
	return meta.TF._n;
};
var $author$project$Api$Provider$DiscountRule$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$rateRule = function (_v0) {
	var record = _v0.b;
	return record.XL;
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$specialRateOptions = F2(
	function (periodInMonths, specialRates) {
		return A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				'Choose an option'),
			A2(
				$elm$core$List$map,
				function (specialRate) {
					var amountInCents = A2(
						$elm$core$Maybe$withDefault,
						0,
						function () {
							switch (periodInMonths) {
								case 1:
									return $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(specialRate);
								case 3:
									return $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(specialRate);
								case 6:
									return $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(specialRate);
								case 12:
									return $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(specialRate);
								default:
									return $elm$core$Maybe$Nothing;
							}
						}());
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$SpecialRate$Shared$id(specialRate)),
						$author$project$Api$Provider$SpecialRate$Shared$name(specialRate) + (' - ' + ($author$project$Utils$Currency$fromInt(amountInCents) + (' ' + $author$project$Formatters$Int$asPeriod(periodInMonths)))));
				},
				A2($elm$core$List$sortBy, $author$project$Api$Provider$SpecialRate$Shared$name, specialRates)));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewSpecialRateInput = F6(
	function (membership, pendingMembership, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
		var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
		var planHasSpecialRates = !$elm$core$List$isEmpty(
			$author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(pendingMembershipPlan));
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var specialRateIsEditable = (!model.aN) && $author$project$Api$Provider$Membership$Meta$membershipPatientsSpecialRate(membershipMeta);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Rule'),
					$author$project$Ui$Form$Group$required(model.eb)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) === 4) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									$author$project$Components$Plan$Summary$Percentage$view(
										$author$project$Api$Plan$ProviderSharedWithContractInfo(pendingMembershipPlan)))
								]) : _List_fromArray(
								[
									function () {
									if (model.eb) {
										var specialRates = $author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(pendingMembershipPlan);
										return A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(membershipPatient._n),
													$author$project$Ui$Form$Select$onChange(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRate),
														$author$project$Utils$String$toMaybe)),
													$author$project$Ui$Form$Select$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 4, model.PB)),
													$author$project$Ui$Form$Select$errors(
													A2($author$project$Utils$Form$validationErrors, 4, model.PB)),
													$author$project$Ui$Form$Select$loading(
													$elm$core$List$isEmpty(specialRates))
												]),
											A2(
												$author$project$Components$Membership$Form$Members$MembershipPatient$specialRateOptions,
												$author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership),
												specialRates));
									} else {
										var ruleDescription = function () {
											if ($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) === 1) {
												return 'Fixed Fee';
											} else {
												var rateRuleName = A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$RateRule$Min$name,
														A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$rateRule, pendingMembershipPatient)));
												var discountRuleDescription = function () {
													var _v0 = A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$DiscountRule$Min$name,
														A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$discountRule, pendingMembershipPatient));
													if (!_v0.$) {
														var discountRuleName = _v0.a;
														return ' (' + (discountRuleName + ' discount)');
													} else {
														return '';
													}
												}();
												return _Utils_ap(rateRuleName, discountRuleDescription);
											}
										}();
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(ruleDescription)
												]));
									}
								}()
								])),
							(($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) !== 4) && (isPatientActive && (planHasSpecialRates && specialRateIsEditable))) ? A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var label = model.eb ? 'Remove Override' : 'Override Rule';
											return A3(
												$author$project$Ui$Button$view,
												{abp: label},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
														$author$project$Ui$Button$pull(1),
														$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$ToggleSpecialRateOverride)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label)
													]));
										}()
										]))
								])) : $author$project$Ui$FlexGrid$none
						]))
				]));
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$EditStartDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Membership$Meta$membershipPatientsStartDate = function (_v0) {
	var meta = _v0;
	return meta.TF._E;
};
var $author$project$Components$Membership$Form$Members$MembershipPatient$viewStartDateInput = F6(
	function (membership, pendingMembership, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Membership Start Date')
				]),
			function () {
				if (model.qn) {
					var min = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
					var max = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership),
						membershipPatient.Ps);
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg,
							A2(
								$author$project$Components$DateInput$view,
								_List_fromArray(
									[
										$author$project$Components$DateInput$value(membershipPatient._E),
										$author$project$Components$DateInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, model.PB)),
										$author$project$Components$DateInput$errors(
										A2($author$project$Utils$Form$validationErrors, 3, model.PB)),
										$author$project$Components$DateInput$disabledPickerDates(
										function (date) {
											return A2($author$project$Utils$Date$isBefore, date, min) || A2($author$project$Utils$Date$isAfter, date, max);
										})
									]),
								model.kg)),
							function () {
							var _v0 = membershipPatient._E;
							if (!_v0.$) {
								var membershipPatientStartDate = _v0.a;
								return A2(
									$author$project$Utils$Date$isBefore,
									membershipPatientStartDate,
									$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)) ? ($author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('We will charge for this patient starting on the '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Api$Provider$Company$Shared$nextInvoiceDate,
														$author$project$Api$Provider$Membership$One$company(pendingMembership))))),
											$elm$html$Html$text(' invoice.')
										])) : (($author$project$Utils$Maybe$toBool(membershipPatient.Ps) && (!_Utils_eq(
									membershipPatient._E,
									A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate, model.Gu)))) ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('We will continue billing this patient on '),
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)))
										])) : ((!$author$project$Utils$Maybe$toBool(membershipPatient.Ps)) ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('We will bill this patient starting on '),
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership))),
											$elm$html$Html$text('. If you\'d like to prorate for the period of '),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													membershipPatient._E))),
											$elm$html$Html$text(' - '),
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership))),
											$elm$html$Html$text(', you can learn how to do that '),
											A3(
											$author$project$Ui$Link$externalHref,
											'https://support.hint.com/invoices/creating-a-prorated-membership-invoice',
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text('here')
												])),
											$elm$html$Html$text('.')
										])) : $author$project$Utils$Html$empty))) : $author$project$Utils$Html$empty;
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]);
				} else {
					var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
					var startDateIsEditable = (!model.aN) && $author$project$Api$Provider$Membership$Meta$membershipPatientsStartDate(membershipMeta);
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											membershipPatient._E))),
									(isPatientActive && startDateIsEditable) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Change start date'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Membership$Form$Members$MembershipPatient$EditStartDate(
												A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate, pendingMembershipPatient)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Date')
										])) : $author$project$Utils$Html$empty
								]))
						]);
				}
			}());
	});
var $author$project$Components$Membership$Form$Members$MembershipPatient$view = F5(
	function (practice, sectionsShared, cancellationReasons, activePatientsCount, _v0) {
		var model = _v0;
		var membershipPatient = $author$project$Utils$Form$fields(model.PB);
		var isPatientActive = !$author$project$Utils$Maybe$toBool(membershipPatient.qs);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A8($author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientInput, practice, sectionsShared.Vp, sectionsShared.ja, sectionsShared.c6, activePatientsCount, isPatientActive, membershipPatient, model),
					function () {
					var _v1 = membershipPatient.VM;
					if (!_v1.$) {
						var patient = _v1.a;
						var showTobaccoUsage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice) && $author$project$Utils$Maybe$toBool(
							$author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType(
								$author$project$Api$Provider$Membership$One$plan(sectionsShared.c6)));
						var pendingMembershipPatient = A2(
							$elm_community$list_extra$List$Extra$find,
							function (membershipPatient_) {
								return _Utils_eq(
									$author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_),
									membershipPatient.adR);
							},
							$author$project$Api$Provider$Membership$One$membershipPatients(sectionsShared.c6));
						var isTerminated = $author$project$Utils$Maybe$toBool(membershipPatient.qs) && ((!_Utils_eq(
							membershipPatient.DV,
							$elm$core$Maybe$Just('terminate'))) && (!_Utils_eq(
							membershipPatient.DV,
							$elm$core$Maybe$Just('destroy'))));
						return A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$inactive(!isPatientActive)
								]),
							_List_fromArray(
								[
									showTobaccoUsage ? A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientUsesTobaccoInput, pendingMembershipPatient, patient, model) : $author$project$Utils$Html$empty,
									function () {
									var _v2 = _Utils_Tuple2((!isPatientActive) && (!model.aN), membershipPatient.abM);
									if (_v2.a && (!_v2.b.$)) {
										var cancellationReason = _v2.b.a;
										return A2($author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReason, membershipPatient, cancellationReason);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									function () {
									if ((!isTerminated) && ($author$project$Api$Provider$Membership$One$isUpdatable(sectionsShared.c6) || $author$project$Api$Provider$Membership$One$isSynced(sectionsShared.c6))) {
										var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(sectionsShared.c6);
										return A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											_List_fromArray(
												[
													A4($author$project$Components$Membership$Form$Members$MembershipPatient$viewEnrollmentRequestedOnInput, sectionsShared.ja, isPatientActive, membershipPatient, model),
													A6($author$project$Components$Membership$Form$Members$MembershipPatient$viewStartDateInput, sectionsShared.ja, sectionsShared.c6, pendingMembershipPatient, isPatientActive, membershipPatient, model),
													(!$author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan(pendingMembershipPlan)) ? A6($author$project$Components$Membership$Form$Members$MembershipPatient$viewSpecialRateInput, sectionsShared.ja, sectionsShared.c6, pendingMembershipPatient, isPatientActive, membershipPatient, model) : $author$project$Utils$Html$empty,
													((!$author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan(pendingMembershipPlan)) && ($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) !== 1)) ? A5($author$project$Components$Membership$Form$Members$MembershipPatient$viewFixedPeriodRateInput, sectionsShared, pendingMembershipPatient, isPatientActive, membershipPatient, model) : $author$project$Utils$Html$empty
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					model.aN ? A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewEndDateInput, sectionsShared.c6, membershipPatient, model),
							A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReasonInput, cancellationReasons, membershipPatient, model)
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Members$viewMembershipPatient = F8(
	function (practice, sectionsShared, cancellationReasons, lastIndex, canEditMembershipPatients, activePatientsCount, index, _v0) {
		var membershipPatient = _v0.b;
		var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.adR),
					A5($author$project$Components$Membership$Form$Members$MembershipPatient$view, practice, sectionsShared, cancellationReasons, activePatientsCount, membershipPatient)),
					((!_Utils_eq(index, lastIndex)) || canEditMembershipPatients) ? A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(11),
									$author$project$Ui$FlexGrid$offset(1)
								]),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(_List_Nil)
								]))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Members$viewMembershipPatients = F5(
	function (sectionsShared, cancellationReasons, canEditMembershipPatients, membershipPatients, model) {
		var lastIndex = $elm$core$List$length(membershipPatients) - 1;
		var activePatientsCount = A2(
			$elm_community$list_extra$List$Extra$count,
			function (_v0) {
				var membershipPatient = _v0.b;
				var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
				return !$author$project$Utils$Maybe$toBool(membershipPatientRecord.qs);
			},
			membershipPatients);
		return A2(
			$elm$core$List$indexedMap,
			A6($author$project$Components$Membership$Form$Sections$Members$viewMembershipPatient, model.WF, sectionsShared, cancellationReasons, lastIndex, canEditMembershipPatients, activePatientsCount),
			membershipPatients);
	});
var $author$project$Components$Membership$Form$Sections$Members$view = F3(
	function (sectionsShared, cancellationReasons, model) {
		var membershipPatients = A2(
			$elm$core$List$sortBy,
			$author$project$Components$Membership$Form$Sections$Members$membershipPatientSortValue(sectionsShared.ja),
			$elm$core$Dict$values(model.TF));
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(sectionsShared.ja);
		var canEditMembershipPatients = $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$author$project$Ui$HorizontalRule$view(_List_Nil),
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Members')
								]))
						]),
						A5($author$project$Components$Membership$Form$Sections$Members$viewMembershipPatients, sectionsShared, cancellationReasons, canEditMembershipPatients, membershipPatients, model),
						function () {
						if (canEditMembershipPatients) {
							var startDate = $author$project$Api$Provider$Membership$One$billedThroughDate(sectionsShared.c6);
							return _List_fromArray(
								[
									function () {
									var _v0 = model.F4;
									if (!_v0.$) {
										var maxMembershipPatients = _v0.a;
										return A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$span(11),
															$author$project$Ui$FlexGrid$offset(1)
														]),
													_List_fromArray(
														[
															A2($author$project$Components$Membership$Form$Sections$Members$overMaxMembershipPatientsWarning, maxMembershipPatients, model.TF)
														]))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(9),
													$author$project$Ui$FlexGrid$offset(3)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$gap2]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Add adult'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick(
																	A2($author$project$Components$Membership$Form$Sections$Members$AddMember, 1, startDate)),
																	$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Adult')
																])),
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Add child'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$onClick(
																	A2($author$project$Components$Membership$Form$Sections$Members$AddMember, 2, startDate)),
																	$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Child')
																]))
														]))
												]))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()
					])));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$Add = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$Remove = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Api$Provider$Membership$Meta$membershipScheduledChangeEditable = function (_v0) {
	var meta = _v0;
	return meta.TJ.Oa;
};
var $author$project$Ui$Tooltip$Pull = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Tooltip$pull = $author$project$Ui$Tooltip$Pull;
var $author$project$Api$Provider$Membership$One$scheduledChange = function (_v0) {
	var record = _v0.b;
	return record.Y7;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$changeAfterMonths = function (_v0) {
	var record = _v0;
	return record.KN;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$changeOnDate = function (_v0) {
	var record = _v0;
	return record.KO;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$effectiveDate = function (_v0) {
	var record = _v0;
	return record.Od;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$toPlan = function (_v0) {
	var record = _v0;
	return record.$J;
};
var $author$project$Api$Provider$MembershipScheduledChange$Shared$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Components$Membership$Form$Sections$PlanChange$viewScheduledChange = F2(
	function (contractPeriodInMonths, scheduledChange) {
		var type_ = $author$project$Api$Provider$MembershipScheduledChange$Shared$type_(scheduledChange);
		var effectiveDate = $author$project$Api$Provider$MembershipScheduledChange$Shared$effectiveDate(scheduledChange);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('Status')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Scheduled')
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('Effective date')
						]),
					_List_fromArray(
						[
							function () {
							switch (type_) {
								case 2:
									return A2(
										$author$project$Ui$Typography$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$author$project$Formatters$String$pluralize,
													'month',
													A2($elm$core$Maybe$withDefault, 0, contractPeriodInMonths))),
												$elm$html$Html$text(' ('),
												$elm$html$Html$text(
												A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, effectiveDate)),
												$elm$html$Html$text(')')
											]));
								case 1:
									var changeAfterMonths = $author$project$Api$Provider$MembershipScheduledChange$Shared$changeAfterMonths(scheduledChange);
									return A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$String$pluralize,
															'month',
															A2($elm$core$Maybe$withDefault, 0, changeAfterMonths))),
														$elm$html$Html$text(' ('),
														$elm$html$Html$text(
														A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, effectiveDate)),
														$elm$html$Html$text(')')
													]))
											]));
								default:
									var changeOnDate = $author$project$Api$Provider$MembershipScheduledChange$Shared$changeOnDate(scheduledChange);
									return A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
														changeOnDate)))
											]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('New plan')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'N/A',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Plan$Shared$name,
											$author$project$Api$Provider$MembershipScheduledChange$Shared$toPlan(scheduledChange))))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$PlanChange$view = F3(
	function (_v0, contract, _v1) {
		var membership = _v0.ja;
		var pendingMembership = _v0.c6;
		var model = _v1;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text('Plan Change')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(7)
								]),
							function () {
								var _v2 = $author$project$Api$Provider$Membership$One$scheduledChange(pendingMembership);
								if (!_v2.$) {
									var scheduledChange = _v2.a;
									var buttonOption = function () {
										var _v3 = model.yS;
										if (!_v3.$) {
											var membershipId = _v3.a;
											return $author$project$Ui$Button$onClick(
												A2($author$project$Components$Membership$Form$Sections$PlanChange$Remove, membershipId, scheduledChange));
										} else {
											return $author$project$Ui$Button$disabled(true);
										}
									}();
									return _List_fromArray(
										[
											A3(
											$author$project$Ui$Tooltip$view,
											_List_fromArray(
												[
													$author$project$Ui$Tooltip$placement(0),
													$author$project$Ui$Tooltip$active(model.q5),
													$author$project$Ui$Tooltip$pull(1)
												]),
											'This plan change is set automatically and can be removed after saving the membership.',
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Remove schedule change'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$pull(1),
															buttonOption
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Remove')
														]))
												]))
										]);
								} else {
									var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$spaceBetween]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															$elm$html$Html$text('None')
														])),
													$author$project$Api$Provider$Membership$Meta$membershipScheduledChangeEditable(membershipMeta) ? A3(
													$author$project$Ui$Tooltip$view,
													_List_fromArray(
														[
															$author$project$Ui$Tooltip$placement(0),
															$author$project$Ui$Tooltip$active(model.q5),
															$author$project$Ui$Tooltip$pull(1)
														]),
													'You will be able to add a plan change after the membership is created.',
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Add plan change'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																	$author$project$Ui$Button$disabled(model.q5),
																	$author$project$Ui$Button$onClick(
																	A2($author$project$Components$Membership$Form$Sections$PlanChange$Add, contract, membershipMeta))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add plan change')
																]))
														])) : $author$project$Utils$Html$empty
												]))
										]);
								}
							}()),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v4 = $author$project$Api$Provider$Membership$One$scheduledChange(pendingMembership);
									if (!_v4.$) {
										var scheduledChange = _v4.a;
										return A2($author$project$Components$Membership$Form$Sections$PlanChange$viewScheduledChange, contract.Wc, scheduledChange);
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee = function (pendingMembership) {
	return $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(
		$author$project$Api$Provider$Membership$One$plan(pendingMembership)) === 1;
};
var $author$project$Components$Membership$Form$Sections$Pricing$Coupon = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon = {$: 3};
var $author$project$Components$Membership$Form$Sections$Pricing$formatCoupon = F5(
	function (percentOff, amountOffInCents, applyToEachPatient, durationInMonths, code) {
		return function (string) {
			return A2($elm$core$String$append, string, ' (' + (code + ')'));
		}(
			function (string) {
				return A2(
					$elm$core$String$append,
					string,
					function () {
						if (!durationInMonths.$) {
							var durationInMonths_ = durationInMonths.a;
							return ' for ' + ($elm$core$String$fromInt(durationInMonths_) + ' months');
						} else {
							return '';
						}
					}());
			}(
				function () {
					var _v0 = _Utils_Tuple2(percentOff, amountOffInCents);
					if (!_v0.a.$) {
						var percentOff_ = _v0.a.a;
						return $elm$core$String$fromFloat(percentOff_) + '% off';
					} else {
						if (!_v0.b.$) {
							var _v1 = _v0.a;
							var amountOffInCents_ = _v0.b.a;
							return $author$project$Utils$Currency$fromInt(amountOffInCents_) + (' / ' + (applyToEachPatient ? 'patient' : 'membership'));
						} else {
							var _v2 = _v0.a;
							var _v3 = _v0.b;
							return '';
						}
					}
				}()));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$formatCouponAll = function (coupon) {
	return A5(
		$author$project$Components$Membership$Form$Sections$Pricing$formatCoupon,
		$author$project$Api$Provider$Coupon$All$percentOff(coupon),
		$author$project$Api$Provider$Coupon$All$amountOffInCents(coupon),
		$author$project$Api$Provider$Coupon$All$applyToEachPatient(coupon),
		$author$project$Api$Provider$Coupon$All$durationInMonths(coupon),
		$author$project$Api$Provider$Coupon$All$code(coupon));
};
var $author$project$Components$Membership$Form$Sections$Pricing$couponOptions = function (coupons) {
	return A2(
		$elm$core$List$cons,
		A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(''),
			'None'),
		A2(
			$elm$core$List$map,
			function (coupon) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Coupon$All$id(coupon)),
					$author$project$Components$Membership$Form$Sections$Pricing$formatCouponAll(coupon));
			},
			coupons));
};
var $author$project$Components$Membership$Form$Sections$Pricing$formatCouponShared = function (coupon) {
	if (!coupon.$) {
		var coupon_ = coupon.a;
		return A5(
			$author$project$Components$Membership$Form$Sections$Pricing$formatCoupon,
			$author$project$Api$Common$Coupon$Shared$percentOff(coupon_),
			$author$project$Api$Common$Coupon$Shared$amountOffInCents(coupon_),
			$author$project$Api$Common$Coupon$Shared$applyToEachPatient(coupon_),
			$author$project$Api$Common$Coupon$Shared$durationInMonths(coupon_),
			$author$project$Api$Common$Coupon$Shared$code(coupon_));
	} else {
		return '';
	}
};
var $author$project$Ui$Form$Static$Muted = {$: 2};
var $author$project$Ui$Form$Static$muted = $author$project$Ui$Form$Static$Muted;
var $author$project$Components$Membership$Form$Sections$Pricing$viewCouponField = F5(
	function (membership, pendingMembership, coupons, editCoupon, form) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var _v0 = function () {
			if (coupons.$ === 3) {
				var list = coupons.a;
				return _Utils_Tuple2(false, list);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var couponsLoading = _v0.a;
		var coupons_ = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Coupon')
				]),
			_List_fromArray(
				[
					function () {
					if ($author$project$Api$Provider$Membership$Meta$couponEditable(membershipMeta)) {
						if (editCoupon) {
							var _v2 = $author$project$Utils$Form$fields(form);
							var coupon = _v2.L1;
							return A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(coupon),
														$author$project$Ui$Form$Select$onChange(
														A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$Coupon)),
														$author$project$Ui$Form$Select$loading(couponsLoading)
													]),
												$author$project$Components$Membership$Form$Sections$Pricing$couponOptions(coupons_))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Button$view,
														{abp: 'Remoce coupon'},
														_List_fromArray(
															[
																$author$project$Ui$Button$link,
																$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																$author$project$Ui$Button$pull(1),
																$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Remove Coupon')
															]))
													]))
											])),
										function () {
										var _v3 = $author$project$Api$Provider$Membership$One$coupon(pendingMembership);
										if (!_v3.$) {
											var coupon_ = _v3.a;
											return A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(12)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$p,
														_List_fromArray(
															[$author$project$Ui$Typography$helpBlock]),
														function () {
															var _v4 = $author$project$Api$Common$Coupon$Shared$durationInMonths(coupon_);
															if (!_v4.$) {
																var durationInMonths = _v4.a;
																return _List_fromArray(
																	[
																		$elm$html$Html$text(
																		A2($author$project$Formatters$String$pluralize, 'month', durationInMonths)),
																		$elm$html$Html$text('  coupon')
																	]);
															} else {
																return _List_fromArray(
																	[
																		$elm$html$Html$text('Unlimited duration coupon')
																	]);
															}
														}())
													]));
										} else {
											return $author$project$Ui$FlexGrid$none;
										}
									}()
									]));
						} else {
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('None'),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Add coupon'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$pull(1),
												$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Add Coupon')
											]))
									]));
						}
					} else {
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Components$Membership$Form$Sections$Pricing$formatCouponShared(
										$author$project$Api$Provider$Membership$One$coupon(membership)))
								]));
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$ToggleFixedPeriodRateInCentsOverride = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewFixedRateField = F3(
	function (pendingMembership, onlyOneFixedPeriodRateInCentsEditable, form) {
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var _v0 = $author$project$Utils$Form$fields(form);
		var fixedPeriodRateInCents = _v0.Pw;
		var manuallySet = _v0.cb;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Total Rate'),
					$author$project$Ui$Form$Group$required(manuallySet.XJ)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Components$FixedRate$view,
					{
						JW: false,
						Mr: $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(pendingMembership),
						Nm: $elm$core$Maybe$Just(
							$author$project$Currency$fromInt(
								$author$project$Api$Provider$Membership$One$revenueInCents(pendingMembership))),
						dW: onlyOneFixedPeriodRateInCentsEditable,
						Oa: $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(membershipMeta),
						w: manuallySet.XJ,
						fE: A2($author$project$Utils$Form$validationErrors, 0, form),
						afK: $author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership),
						aaN: fixedPeriodRateInCents
					},
					A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents),
					$author$project$Components$Membership$Form$Sections$Pricing$ToggleFixedPeriodRateInCentsOverride(pendingMembership))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod = {$: 6};
var $author$project$Api$Provider$Membership$One$source = function (_v0) {
	var record = _v0.b;
	return record.Hg;
};
var $author$project$Api$Provider$Membership$Source$expMonth = function (_v0) {
	var record = _v0;
	return record.ac9;
};
var $author$project$Api$Provider$Membership$Source$expYear = function (_v0) {
	var record = _v0;
	return record.ada;
};
var $author$project$Api$Provider$Membership$Source$funding = function (_v0) {
	var record = _v0;
	return record.PK;
};
var $author$project$Api$Provider$Membership$Source$lastFour = function (_v0) {
	var record = _v0;
	return record.Sz;
};
var $author$project$Api$Provider$Membership$Source$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Membership$Source$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Membership$Source$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$Membership$Source$zip = function (_v0) {
	var record = _v0;
	return record.tC;
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodDisplay = F2(
	function (source, isEditable) {
		var sourceType = $author$project$Api$Provider$Membership$Source$type_(source);
		var isCard = sourceType === 'Card';
		var zipText = isCard ? A2(
			$elm$core$Maybe$map,
			function (zip) {
				return 'ZIP code ' + zip;
			},
			$author$project$Api$Provider$Membership$Source$zip(source)) : $elm$core$Maybe$Nothing;
		var expiresText = function () {
			if (isCard) {
				var _v1 = _Utils_Tuple2(
					$author$project$Api$Provider$Membership$Source$expMonth(source),
					$author$project$Api$Provider$Membership$Source$expYear(source));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var expMonth = _v1.a.a;
					var expYear = _v1.b.a;
					return $elm$core$Maybe$Just(
						'Expires ' + ($elm$core$String$fromInt(expMonth) + ('/' + $elm$core$String$fromInt(expYear))));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var secondLineText = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[expiresText, zipText])));
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[
									$author$project$Ui$Typography$attrs(
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('pt-2')
										]))
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$Ui$Typography$p,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$strong,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('inline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Formatters$String$titleize(
														$author$project$Api$Provider$Membership$Source$name(source)))
												])),
											$elm$html$Html$text(' '),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'*' + $author$project$Api$Provider$Membership$Source$lastFour(source))
												])),
											$elm$html$Html$text(' '),
											function () {
											var _v0 = $author$project$Api$Provider$Membership$Source$funding(source);
											if (!_v0.$) {
												var funding = _v0.a;
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('(' + (funding + ')'))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											$elm$html$Html$text(' '),
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$Membership$Source$status(source))
										])),
								$elm$core$String$isEmpty(secondLineText) ? _List_Nil : _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
										_List_fromArray(
											[
												$elm$html$Html$text(secondLineText)
											]))
									])))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$span(6)
						]),
					_List_fromArray(
						[
							isEditable ? A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Change Payment Method'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Payment Method')
										]))
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodField = F2(
	function (membership, model) {
		var _v0 = function () {
			var _v1 = model.AK;
			if (_v1.$ === 3) {
				if (!_v1.a.$) {
					var list = _v1.a.a;
					return _Utils_Tuple2(false, list);
				} else {
					var _v2 = _v1.a;
					return _Utils_Tuple2(false, _List_Nil);
				}
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var paymentMethodsLoading = _v0.a;
		var paymentMethodsList = _v0.b;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Payment Method')
				]),
			_List_fromArray(
				[
					function () {
					if (model.lX) {
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$map,
													$author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSelectMsg,
													A3(
														$author$project$Ui$Form$SearchableSelect$view,
														_List_fromArray(
															[
																$author$project$Ui$Form$SearchableSelect$value(model.j1),
																$author$project$Ui$Form$SearchableSelect$placeholder('Select a payment method'),
																$author$project$Ui$Form$SearchableSelect$loading(paymentMethodsLoading)
															]),
														A2(
															$elm$core$List$map,
															$author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil),
															paymentMethodsList),
														model.rW))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Button$view,
															{abp: 'Cancel'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																	$author$project$Ui$Button$pull(1),
																	$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Cancel')
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('Any upcoming payments for this membership will be charged to the new payment method.')
										]))
								]));
					} else {
						var source = $author$project$Api$Provider$Membership$One$source(membership);
						var isEditable = $author$project$Api$Provider$Membership$Meta$paymentSourceEditable(
							$author$project$Api$Provider$Membership$One$meta(membership));
						if (!source.$) {
							var src = source.a;
							return A2($author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodDisplay, src, isEditable);
						} else {
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('No payment method'),
										(isEditable && (!$elm$core$List$isEmpty(paymentMethodsList))) ? A3(
										$author$project$Ui$Button$view,
										{abp: 'Change Payment Method'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$pull(1),
												$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Change Payment Method')
											])) : $author$project$Utils$Html$empty
									]));
						}
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCents = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$ToggleRegistrationFeeOverride = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$Pricing$viewRegistrationFeeField = F2(
	function (pendingMembership, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var fixedRegistrationFeeInCents = _v0.Px;
		var manuallySet = _v0.cb;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Registration Fee'),
					$author$project$Ui$Form$Group$required(manuallySet.et)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									function () {
									if (manuallySet.et) {
										return A2(
											$author$project$Ui$Typography$div,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Form$CurrencyInput$view(
													_List_fromArray(
														[
															$author$project$Ui$Form$CurrencyInput$value(fixedRegistrationFeeInCents),
															$author$project$Ui$Form$CurrencyInput$onInput(
															A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCents)),
															$author$project$Ui$Form$CurrencyInput$invalid(
															A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
															$author$project$Ui$Form$CurrencyInput$placeholder('10.00')
														])),
													$author$project$Utils$FormErrors$view(
													A2($author$project$Utils$Form$validationErrors, 1, form))
												]));
									} else {
										var registrationFeeInCents = A2(
											$elm$core$Maybe$withDefault,
											0,
											A2(
												$elm$core$Maybe$andThen,
												$author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents,
												$elm$core$List$head(
													$author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership))));
										return A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(registrationFeeInCents))
												]));
									}
								}()
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6),
									$author$project$Ui$FlexGrid$justifyRight
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var label = manuallySet.et ? 'Remove Override' : 'Override Registration Fee';
											return A3(
												$author$project$Ui$Button$view,
												{abp: label},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
														$author$project$Ui$Button$onClick(
														$author$project$Components$Membership$Form$Sections$Pricing$ToggleRegistrationFeeOverride(pendingMembership))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label)
													]));
										}()
										]))
								]))
						])),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(12)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											manuallySet.et ? $elm$html$Html$text('Fixed registration fee') : $elm$html$Html$text('Standard registration fee')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$viewForm = F2(
	function (_v0, model) {
		var membership = _v0.ja;
		var pendingMembership = _v0.c6;
		var onlyOneFixedPeriodRateInCentsEditable = _v0.afr;
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					(!$author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee(pendingMembership)) ? A3($author$project$Components$Membership$Form$Sections$Pricing$viewFixedRateField, pendingMembership, onlyOneFixedPeriodRateInCentsEditable, model.PB) : $author$project$Utils$Html$empty,
					($author$project$Utils$Maybe$toBool(
					$author$project$Api$Provider$Membership$One$coupon(membership)) || $author$project$Api$Provider$Membership$Meta$couponEditable(membershipMeta)) ? A5($author$project$Components$Membership$Form$Sections$Pricing$viewCouponField, membership, pendingMembership, model.wR, model.N7, model.PB) : $author$project$Utils$Html$empty,
					((!$author$project$Api$Provider$Membership$One$isSponsored(membership)) && $author$project$Api$Provider$Membership$Meta$paymentSourceEditable(
					$author$project$Api$Provider$Membership$One$meta(membership))) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodField, membership, model) : $author$project$Utils$Html$empty,
					($author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(pendingMembershipMeta) && (!$author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee(pendingMembership))) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewRegistrationFeeField, pendingMembership, model.PB) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Pricing$view = F2(
	function (sectionsShared, _v0) {
		var model = _v0;
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Pricing')
						])),
					$author$project$Utils$Maybe$toBool(
					$author$project$Api$Provider$Membership$One$nextBillDate(sectionsShared.c6)) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewForm, sectionsShared, model) : A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$offset(5),
									$author$project$Ui$FlexGrid$span(7)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$em,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('This membership has no upcoming bills.')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$AddEndDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Edit = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodInMonths = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Quantity = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$Remove = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$Static$Numeric = {$: 1};
var $author$project$Ui$Form$Static$numeric = $author$project$Ui$Form$Static$Numeric;
var $author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities = function (recurringCharge) {
	var _v0 = $author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.aam);
	if (_v0.$ === 1) {
		return A2($elm$core$List$range, 1, 100);
	} else {
		var periodInMonths = _v0.a;
		return (periodInMonths === 1) ? (_Utils_eq(
			recurringCharge.We,
			$elm$core$Maybe$Just(1)) ? A2($elm$core$List$range, 1, 12) : _List_fromArray(
			[1, 3, 6, 12])) : A2($elm$core$List$range, 1, 4);
	}
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$validRecurringChargePeriods = function (recurringCharge) {
	var _v0 = $author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.aam);
	if (_v0.$ === 1) {
		return _List_fromArray(
			[1, 3, 6, 12]);
	} else {
		var periodInMonths = _v0.a;
		return A2(
			$elm$core$List$map,
			function (quantity) {
				return quantity * periodInMonths;
			},
			$author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities(recurringCharge));
	}
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$periodInMonthsOptions = function (recurringCharge) {
	return A2(
		$elm$core$List$map,
		function (period) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$elm$core$String$fromInt(period)),
				$author$project$Formatters$Int$asPeriodHuman(period));
		},
		$author$project$Components$Membership$Form$Sections$RecurringCharges$validRecurringChargePeriods(recurringCharge));
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$validEndPeriods = function (recurringCharge) {
	var periodInMonths = A2($elm$core$Maybe$withDefault, 0, recurringCharge.Wc);
	return A2($elm$core$List$range, 1, (((23 / periodInMonths) | 0) + ((periodInMonths / 4) | 0)) + 1);
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$periodsRemainingOptions = function (recurringCharge) {
	var periodInMonths = A2($elm$core$Maybe$withDefault, 0, recurringCharge.Wc);
	return A2(
		$elm$core$List$cons,
		A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Unlimited'),
		A2(
			$elm$core$List$map,
			function (remaining) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$elm$core$String$fromInt(remaining)),
					A2($author$project$Formatters$String$pluralize, 'month', remaining * periodInMonths));
			},
			$author$project$Components$Membership$Form$Sections$RecurringCharges$validEndPeriods(recurringCharge)));
};
var $author$project$Components$Membership$Form$Sections$RecurringCharges$quantityOptions = function (recurringCharge) {
	var uom = recurringCharge.aam;
	if ($author$project$Api$Provider$Uom$Shared$isTimeBased(uom)) {
		var periodInMonths = A2(
			$elm$core$Maybe$withDefault,
			0,
			$author$project$Api$Provider$Uom$Shared$periodInMonths(uom));
		return A2(
			$elm$core$List$map,
			function (quantity) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$elm$core$String$fromInt(quantity)),
					A2($author$project$Formatters$String$pluralize, 'month', quantity * periodInMonths));
			},
			$author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities(recurringCharge));
	} else {
		return A2(
			$elm$core$List$map,
			function (quantity) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$elm$core$String$fromInt(quantity)),
					$elm$core$String$fromInt(quantity));
			},
			A2($elm$core$List$range, 1, 99));
	}
};
var $author$project$Ui$Typography$SrOnly = {$: 35};
var $author$project$Ui$Typography$srOnly = $author$project$Ui$Typography$SrOnly;
var $author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharge = F4(
	function (pendingMembership, patients, index, recurringCharge) {
		var uom = recurringCharge.aam;
		var quantity = A2($elm$core$Maybe$withDefault, 0, recurringCharge.Bd);
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var chargeItem = recurringCharge.lp;
		var priceInCents = A2($elm$core$Maybe$withDefault, chargeItem.Ba, recurringCharge.adt);
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$spaceBetween]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[$author$project$Ui$Typography$muted]),
													_List_fromArray(
														[
															_Utils_eq(
															recurringCharge.We,
															$elm$core$Maybe$Just(1)) ? $elm$html$Html$text('On next invoice') : A2(
															$author$project$Ui$Typography$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Invoiced'),
																	$author$project$Utils$Html$noBreakSpace,
																	A2(
																	$author$project$Ui$Form$Select$view,
																	_List_fromArray(
																		[
																			$author$project$Ui$Form$Select$size(1),
																			$author$project$Ui$Form$Select$inline,
																			$author$project$Ui$Form$Select$value(
																			A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.Wc)),
																			$author$project$Ui$Form$Select$onChange(
																			A2(
																				$elm$core$Basics$composeL,
																				A2(
																					$elm$core$Basics$composeL,
																					$author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index),
																					$author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodInMonths),
																				$elm$core$String$toInt))
																		]),
																	$author$project$Components$Membership$Form$Sections$RecurringCharges$periodInMonthsOptions(recurringCharge)),
																	$author$project$Utils$Html$noBreakSpace,
																	(A2($elm$core$Maybe$withDefault, 0, recurringCharge.afL) > 0) ? A2(
																	$author$project$Ui$Typography$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('for'),
																			$author$project$Utils$Html$noBreakSpace,
																			A2(
																			$author$project$Ui$Form$Select$view,
																			_List_fromArray(
																				[
																					$author$project$Ui$Form$Select$size(1),
																					$author$project$Ui$Form$Select$inline,
																					$author$project$Ui$Form$Select$value(
																					A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.afL)),
																					$author$project$Ui$Form$Select$onChange(
																					A2(
																						$elm$core$Basics$composeL,
																						A2(
																							$elm$core$Basics$composeL,
																							$author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index),
																							$author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining),
																						$elm$core$String$toInt))
																				]),
																			$author$project$Components$Membership$Form$Sections$RecurringCharges$periodsRemainingOptions(recurringCharge))
																		])) : A2(
																	$author$project$Ui$Typography$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(' until membership ends '),
																			A3(
																			$author$project$Ui$Button$view,
																			{abp: 'Add end date'},
																			_List_fromArray(
																				[
																					$author$project$Ui$Button$sm,
																					$author$project$Ui$Button$onClick(
																					$author$project$Components$Membership$Form$Sections$RecurringCharges$AddEndDate(index))
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Add End Date')
																				]))
																		]))
																]))
														]))
												])),
											$author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta) ? A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Remove recurring charge'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															$author$project$Components$Membership$Form$Sections$RecurringCharges$Remove(index)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Remove')
														])),
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Edit recurring charge'},
													_List_fromArray(
														[
															$author$project$Ui$Button$sm,
															$author$project$Ui$Button$onClick(
															A2($author$project$Components$Membership$Form$Sections$RecurringCharges$Edit, patients, index)),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$edit)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Edit')
														]))
												])) : $author$project$Utils$Html$empty
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'No Patient',
														A2(
															$elm$core$Maybe$map,
															function ($) {
																return $.zh;
															},
															recurringCharge.VM)))
												])),
											function () {
											var _v0 = recurringCharge.afS;
											if (!_v0.$) {
												var practitioner = _v0.a;
												return A2(
													$author$project$Ui$Typography$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(' with '),
															$elm$html$Html$text(practitioner.zh)
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											(!_Utils_eq(
											recurringCharge.We,
											$elm$core$Maybe$Just(1))) ? A2(
											$author$project$Ui$Typography$span,
											_List_Nil,
											_List_fromArray(
												[
													function () {
													var _v1 = recurringCharge.Wc;
													if (!_v1.$) {
														var periodInMonths = _v1.a;
														return A2(
															$author$project$Ui$Typography$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(' repeating every '),
																	$elm$html$Html$text(
																	A2($author$project$Formatters$String$pluralize, 'month', periodInMonths))
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}(),
													function () {
													var _v2 = _Utils_Tuple2(recurringCharge.afL, recurringCharge.Wc);
													if ((!_v2.a.$) && (!_v2.b.$)) {
														var periodsRemaining = _v2.a.a;
														var periodInMonths = _v2.b.a;
														return A2(
															$author$project$Ui$Typography$span,
															_List_Nil,
															_List_fromArray(
																[
																	_Utils_eq(
																	$elm$core$Maybe$Just(periodsRemaining),
																	recurringCharge.We) ? $elm$html$Html$text(' for ') : $elm$html$Html$text(' for the next '),
																	$elm$html$Html$text(
																	A2($author$project$Formatters$String$pluralize, 'month', periodsRemaining * periodInMonths))
																]));
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												])) : $author$project$Utils$Html$empty
										])),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(5)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$controlLabel, $author$project$Ui$Typography$srOnly]),
													_List_fromArray(
														[
															$elm$html$Html$text('Item')
														])),
													A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Static$phi(true)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($elm$core$Maybe$withDefault, chargeItem.zh, recurringCharge.zh))
																]))
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$controlLabel, $author$project$Ui$Typography$srOnly]),
													_List_fromArray(
														[
															$elm$html$Html$text('Quantity')
														])),
													A2(
													$author$project$Ui$Form$Select$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Select$size(1),
															$author$project$Ui$Form$Select$inline,
															$author$project$Ui$Form$Select$value(
															A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.Bd)),
															$author$project$Ui$Form$Select$onChange(
															A2(
																$elm$core$Basics$composeL,
																A2(
																	$elm$core$Basics$composeL,
																	$author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index),
																	$author$project$Components$Membership$Form$Sections$RecurringCharges$Quantity),
																$elm$core$String$toInt)),
															$author$project$Ui$Form$Select$disabled(
															$author$project$Api$Provider$Uom$Shared$isTimeBased(uom) && (!_Utils_eq(
																recurringCharge.We,
																$elm$core$Maybe$Just(1))))
														]),
													$author$project$Components$Membership$Form$Sections$RecurringCharges$quantityOptions(recurringCharge))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(3)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$controlLabel, $author$project$Ui$Typography$srOnly]),
													_List_fromArray(
														[
															$elm$html$Html$text('Price')
														])),
													A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[$author$project$Ui$Form$Static$numeric]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Currency$format(
																$author$project$Currency$fromFloat(priceInCents))),
															A2($elm$html$Html$br, _List_Nil, _List_Nil),
															$author$project$Api$Provider$Uom$Shared$isTimeBased(uom) ? A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text('per '),
																	$elm$html$Html$text(
																	$author$project$Api$Provider$Uom$Shared$name(uom))
																])) : $author$project$Utils$Html$empty
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$label,
													_List_fromArray(
														[$author$project$Ui$Typography$controlLabel, $author$project$Ui$Typography$srOnly]),
													_List_fromArray(
														[
															$elm$html$Html$text('Price')
														])),
													A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[$author$project$Ui$Form$Static$numeric]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Currency$format(
																		$author$project$Currency$fromFloat(priceInCents * quantity)))
																]))
														]))
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(8)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_fromArray(
														[
															$author$project$Ui$Form$Static$phi(true),
															$author$project$Ui$Form$Static$muted
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																A2($elm$core$Maybe$withDefault, 'No Description', chargeItem.Nx),
																recurringCharge.ads))
														]))
												])),
											((!_Utils_eq(
											recurringCharge.We,
											$elm$core$Maybe$Just(1))) && (!_Utils_eq(
											recurringCharge.afL,
											$elm$core$Maybe$Just(0)))) ? A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(4)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$textMuted]),
													_List_fromArray(
														[
															function () {
															if ((!$author$project$Utils$Maybe$toBool(recurringCharge._E)) || _Utils_eq(recurringCharge._E, recurringCharge.UC)) {
																var startDate = A2(
																	$elm$core$Maybe$withDefault,
																	$author$project$Api$Provider$Membership$One$billFromDate(pendingMembership),
																	recurringCharge._E);
																return A2(
																	$author$project$Ui$Typography$span,
																	_List_fromArray(
																		[
																			$author$project$Ui$Typography$phi(true)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Starting on '),
																			$elm$html$Html$text(
																			A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}(),
															function () {
															var _v3 = _Utils_Tuple2(
																recurringCharge.UC,
																!_Utils_eq(recurringCharge.UC, recurringCharge._E));
															if ((!_v3.a.$) && _v3.b) {
																var nextBillDate = _v3.a.a;
																return A2(
																	$author$project$Ui$Typography$span,
																	_List_fromArray(
																		[
																			$author$project$Ui$Typography$phi(true)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Recurring on '),
																			$elm$html$Html$text(
																			A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDate))
																		]));
															} else {
																return $author$project$Utils$Html$empty;
															}
														}()
														]))
												])) : $author$project$Ui$FlexGrid$none
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharges = F4(
	function (pendingMembership, patients, hasChargeItems, recurringCharges) {
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				A2(
					$elm$core$List$indexedMap,
					A2($author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharge, pendingMembership, patients),
					recurringCharges),
				(hasChargeItems && $author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta)) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$div,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Add charge'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(
										$author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge(patients)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Add Charge')
									]))
							]))
					]) : _List_Nil));
	});
var $author$project$Components$Membership$Form$Sections$RecurringCharges$view = F2(
	function (_v0, _v1) {
		var pendingMembership = _v0.c6;
		var patients = _v0.Ap;
		var model = _v1;
		var _v2 = $author$project$Utils$Form$fields(model.PB);
		var recurringCharges = _v2.XZ;
		return ((!model.qL) && $elm$core$List$isEmpty(recurringCharges)) ? $author$project$Utils$Html$empty : A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_fromArray(
						[$author$project$Ui$FlexGrid$rowItemsCenter]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(5)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$headingSm(
											_List_fromArray(
												[
													$elm$html$Html$text('Additional Charges')
												]))
										]))
								]),
								function () {
								if ($elm$core$List$isEmpty(recurringCharges)) {
									var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(7)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$spaceBetween]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[$author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text('None')
																])),
															$author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta) ? A3(
															$author$project$Ui$Button$view,
															{abp: 'Add charge'},
															_List_fromArray(
																[
																	$author$project$Ui$Button$link,
																	$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
																	$author$project$Ui$Button$onClick(
																	$author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge(patients))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Charge')
																])) : $author$project$Utils$Html$empty
														]))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$numeric]),
													_List_fromArray(
														[
															$elm$html$Html$text('Qty')
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(3)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$numeric]),
													_List_fromArray(
														[
															$elm$html$Html$text('Price')
														]))
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(2)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$hintLabel, $author$project$Ui$Typography$numeric]),
													_List_fromArray(
														[
															$elm$html$Html$text('Amount')
														]))
												]))
										]);
								}
							}()
							]))),
					(!$elm$core$List$isEmpty(recurringCharges)) ? A4($author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharges, pendingMembership, patients, model.qL, recurringCharges) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Api$Feature$MembershipAutoRenewEditable = 5;
var $author$project$Api$Provider$Practice$One$anyRetailBrokers = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Jg;
	});
var $author$project$Api$Provider$Membership$One$cancellationReason = function (_v0) {
	var record = _v0.b;
	return record.abM;
};
var $author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus = F2(
	function (statuses, membership) {
		return A2(
			$elm$core$List$member,
			$author$project$Api$Provider$Membership$One$status(membership),
			statuses);
	});
var $author$project$Components$Membership$Form$Sections$Summary$AutoRenew = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$viewAutoRenewInput = F2(
	function (membership, _v0) {
		var autoRenew = _v0.JH;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Auto Invoice')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(autoRenew),
							$author$project$Ui$Form$Checkbox$onCheck(
							A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, $author$project$Components$Membership$Form$Sections$Summary$AutoRenew)),
							$author$project$Ui$Form$Checkbox$disabled(
							!$author$project$Api$Provider$Membership$Meta$autoRenewEditable(membershipMeta))
						]),
					_List_fromArray(
						[
							autoRenew ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invoices are currently being automatically generated for this membership')
								])) : $author$project$Utils$Html$empty,
							($author$project$Api$Provider$Membership$Meta$autoRenewEditable(membershipMeta) && (!autoRenew)) ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$gray]),
							_List_fromArray(
								[
									$elm$html$Html$text('We are currently '),
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('not')
										])),
									$elm$html$Html$text(' automatically creating invoices for this membership. Check the box to the left to start generating automated invoices.')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$AddBroker = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$BrokerDeal$Timeline$viewWithoutControls = F2(
	function (options, brokerDeal) {
		return A5(
			$author$project$Components$BrokerDeal$Timeline$view,
			options.agX,
			brokerDeal,
			$author$project$Utils$Html$empty,
			$author$project$Utils$Html$empty,
			$elm$core$Basics$always($author$project$Utils$Html$empty));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewBrokerDeal = F3(
	function (brokerDeals, index, brokerDeal) {
		var isLast = _Utils_eq(
			index,
			$elm$core$List$length(brokerDeals) - 1);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Broker$Shared$name(brokerDeal.vJ)),
							$elm$html$Html$text(' ('),
							$elm$html$Html$text(
							$author$project$Api$Provider$BrokerAccount$Shared$name(
								$author$project$Api$Provider$Broker$Shared$brokerAccount(brokerDeal.vJ))),
							$elm$html$Html$text(')')
						])),
					A2(
					$author$project$Components$BrokerDeal$Timeline$viewWithoutControls,
					{agX: false},
					brokerDeal),
					(!isLast) ? $author$project$Ui$HorizontalRule$view(_List_Nil) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewBrokerInput = F3(
	function (isNew, membership, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Broker')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						$author$project$Components$Membership$Form$Sections$Summary$viewBrokerDeal(model.J9),
						model.J9)),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Add broker'},
					_List_fromArray(
						[
							$author$project$Ui$Button$disabled(isNew),
							$author$project$Ui$Button$onClick(
							$author$project$Components$Membership$Form$Sections$Summary$AddBroker(membership)),
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add broker')
						])),
					isNew ? A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('You will be able to assign a broker after the membership is created.')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Api$Provider$Membership$One$cancellationReasonOther = function (_v0) {
	var record = _v0.b;
	return record.abN;
};
var $author$project$Components$CancellationReason$Display$viewShared = F2(
	function (cancellationReason, cancellationReasonOther) {
		return A2(
			$author$project$Components$CancellationReason$Display$view,
			$author$project$Components$CancellationReason$CancellationReasonRecord$fromShared(cancellationReason),
			cancellationReasonOther);
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewCancellationReason = F2(
	function (membership, cancellationReason) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Cancellation Reason')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$CancellationReason$Display$viewShared,
							cancellationReason,
							$author$project$Api$Provider$Membership$One$cancellationReasonOther(membership))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewCompanyName = F2(
	function (company, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					A2($author$project$Formatters$String$sponsorize, model.WF, 'Employer') + ' Name')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
								{
									ff: $author$project$Api$Provider$Company$Shared$id(company)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Company$Shared$name(company))
								]))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewEndDate = F2(
	function (membership, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('End Date')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString(
										A2($author$project$Formatters$Date$Relative, model.cO, $elm$core$Maybe$Nothing)),
									$author$project$Api$Provider$Membership$One$endDate(membership))))
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewMembershipType = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Membership Type')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Formatters$String$sponsorize, model.WF, 'Employer'))
					]))
			]));
};
var $author$project$Components$Membership$Form$Sections$Summary$MinimumEnrollmentPeriodInMonths = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths = {$: 4};
var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentStartDate = function (_v0) {
	var record = _v0;
	return record.T4;
};
var $author$project$Api$Provider$Membership$One$minimumEnrollmentStartDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentStartDate(shared);
};
var $author$project$Components$Membership$Form$Sections$Summary$viewMinimumEnrollmentPeriodInMonthsInput = F3(
	function (pendingMembership, _v0, model) {
		var minimumEnrollmentPeriodInMonths = _v0.T3;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Minimum Enrollment')
				]),
			_List_fromArray(
				[
					model.of.eT ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Add minimum enrollment'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$pull(1),
							$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Minimum Enrollment')
						])) : A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(9)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$PeriodInMonthsSelect$view(
											{
												UL: 'Choose an option',
												ae4: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, $author$project$Components$Membership$Form$Sections$Summary$MinimumEnrollmentPeriodInMonths),
												zY: A2($elm$core$List$range, 1, 12),
												aaN: minimumEnrollmentPeriodInMonths
											})
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(3),
											$author$project$Ui$FlexGrid$justifyRight,
											$author$project$Ui$FlexGrid$itemsCenter
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Remove minimum enrollment'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove')
												]))
										]))
								])),
							function () {
							var _v1 = $author$project$Api$Provider$Membership$One$minimumEnrollmentStartDate(pendingMembership);
							if (!_v1.$) {
								var minimumEnrollmentStartDate = _v1.a;
								return A2(
									$author$project$Ui$FlexGrid$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(12)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$p,
													_List_fromArray(
														[$author$project$Ui$Typography$helpBlock]),
													_List_fromArray(
														[
															$elm$html$Html$text('Cannot cancel between '),
															$elm$html$Html$text(
															A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, minimumEnrollmentStartDate)),
															$elm$html$Html$text(' and '),
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'',
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
																	$author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(pendingMembership))))
														]))
												]))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$EditNextBillDate = {$: 3};
var $author$project$Components$Membership$Form$Sections$Summary$SetBillDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Membership$Meta$billDateValues = function (_v0) {
	var meta = _v0;
	return meta.vG.o9;
};
var $author$project$Components$Membership$Form$Sections$Summary$nextBillDateOptions = function (membership) {
	var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
	var minBillDate = $author$project$Api$Provider$Membership$Meta$billDateMin(membershipMeta);
	return $author$project$Ui$Form$Select$dateOptions(
		A2(
			$elm$core$List$filter,
			function (date) {
				return !(!A2($justinmimbs$date$Date$compare, date, minBillDate));
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Api$Provider$Membership$Meta$billDateValues(
					$author$project$Api$Provider$Membership$One$meta(membership)))));
};
var $author$project$Components$Membership$Form$Sections$Summary$viewNextBillDateInput = F5(
	function (currentDate, membership, pendingMembership, form, model) {
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		var _v0 = $author$project$Utils$Form$fields(form);
		var nextBillDate = _v0.UC;
		var setBillDate = _v0.eF;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Next Bill Due'),
					$author$project$Ui$Form$Group$required(model.of.UC)
				]),
			_List_fromArray(
				[
					model.of.UC ? A2(
					$author$project$Ui$Typography$div,
					_List_Nil,
					_List_fromArray(
						[
							(setBillDate && $author$project$Api$Provider$Membership$One$isSponsored(membership)) ? A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, nextBillDate)),
									$author$project$Ui$Form$Select$onChange(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$NextBillDate, $elm$core$Result$toMaybe),
											$justinmimbs$date$Date$fromIsoString))),
									$author$project$Ui$Form$Select$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
									$author$project$Ui$Form$Select$errors(
									A2($author$project$Utils$Form$validationErrors, 3, form))
								]),
							$author$project$Components$Membership$Form$Sections$Summary$nextBillDateOptions(membership)) : A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg,
							A2(
								$author$project$Components$DateInput$view,
								_List_fromArray(
									[
										$author$project$Components$DateInput$value(nextBillDate),
										$author$project$Components$DateInput$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
										$author$project$Components$DateInput$errors(
										A2($author$project$Utils$Form$validationErrors, 3, form))
									]),
								model.ry)),
							($author$project$Api$Provider$Membership$Meta$billDateEditable(pendingMembershipMeta) && $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(pendingMembershipMeta)) ? A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(setBillDate),
											$author$project$Ui$Form$Radio$onCheck(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
												$elm$core$Basics$always(
													$author$project$Components$Membership$Form$Sections$Summary$SetBillDate(true)))),
											$author$project$Ui$Form$Radio$disabled(
											!A2($author$project$Utils$Form$hasValidationErrors, 3, form))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('All future bills')
										])),
									A2(
									$author$project$Ui$Form$Radio$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Radio$value(!setBillDate),
											$author$project$Ui$Form$Radio$onCheck(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
												$elm$core$Basics$always(
													$author$project$Components$Membership$Form$Sections$Summary$SetBillDate(false)))),
											$author$project$Ui$Form$Radio$disabled(
											!A2($author$project$Utils$Form$hasValidationErrors, 3, form))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Only next bill')
										]))
								])) : $author$project$Utils$Html$empty
						])) : A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v1 = _Utils_Tuple3(
												$author$project$Api$Provider$Membership$One$billDate(pendingMembership),
												$author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership),
												nextBillDate);
											_v1$3:
											while (true) {
												if (_v1.a.$ === 1) {
													if (_v1.b.$ === 1) {
														var _v2 = _v1.a;
														var _v3 = _v1.b;
														return $elm$html$Html$text('Never');
													} else {
														break _v1$3;
													}
												} else {
													if (!_v1.c.$) {
														var nextBillDate_ = _v1.c.a;
														return $elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing),
																nextBillDate_));
													} else {
														if (!_v1.b.$) {
															var nextBillDate_ = _v1.b.a;
															var _v4 = _v1.c;
															return $elm$html$Html$text(
																A2(
																	$author$project$Formatters$Date$toString,
																	A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing),
																	nextBillDate_));
														} else {
															break _v1$3;
														}
													}
												}
											}
											return $author$project$Utils$Html$empty;
										}()
										]))
								])),
							($author$project$Api$Provider$Membership$Meta$billDateEditable(pendingMembershipMeta) || $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(pendingMembershipMeta)) ? A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Change billing date'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$pull(1),
													$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditNextBillDate)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Change Billing Date')
												]))
										]))
								])) : $author$project$Ui$FlexGrid$none
						]))
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$EditOwner = {$: 0};
var $author$project$Components$Membership$Form$Sections$Summary$viewOwnerInput = F4(
	function (membership, pendingMembership, form, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(model.of.Vp),
					$author$project$Ui$Form$Group$label('Payer')
				]),
			function () {
				if (model.of.Vp) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Patient$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
										$author$project$Components$ResourceFilter$errors(
										A2($author$project$Utils$Form$validationErrors, 0, form))
									]),
								model.rU))
						]);
				} else {
					var meta = $author$project$Api$Provider$Membership$One$meta(membership);
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$Patient$Shared$name,
													$author$project$Api$Provider$Membership$One$owner(pendingMembership))))
										])),
									$author$project$Api$Provider$Membership$Meta$ownerEditable(meta) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Change payer'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditOwner)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Payer')
										])) : $author$project$Utils$Html$empty
								]))
						]);
				}
			}());
	});
var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$periodInMonths = function (_v0) {
	var record = _v0;
	return record.Wc;
};
var $author$project$Api$Provider$Membership$One$prepayOptions = function (_v0) {
	var record = _v0.b;
	return record.WY;
};
var $author$project$Components$Membership$Form$Sections$Summary$periodInMonthsOptions = function (pendingMembership) {
	return A2(
		$elm$core$List$map,
		function (membershipBill) {
			var periodInMonths = $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$periodInMonths(membershipBill);
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, periodInMonths),
				A2(
					$elm$core$Maybe$withDefault,
					'N/A',
					A2($elm$core$Maybe$map, $author$project$Formatters$Int$asPeriod, periodInMonths)));
		},
		$author$project$Api$Provider$Membership$One$prepayOptions(pendingMembership));
};
var $author$project$Components$Membership$Form$Sections$Summary$viewPeriodInMonthsInput = F3(
	function (membership, pendingMembership, _v0) {
		var periodInMonths = _v0.Wc;
		var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label('Billed')
				]),
			_List_fromArray(
				[
					$author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(pendingMembership) ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('At end of monthly billing period')
						])) : ($author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(pendingMembershipMeta) ? A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(
							$elm$core$Maybe$Just(
								$elm$core$String$fromInt(periodInMonths))),
							$author$project$Ui$Form$Select$onChange(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
								function (string) {
									return $author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths(
										A2(
											$elm$core$Maybe$withDefault,
											1,
											$elm$core$String$toInt(string)));
								}))
						]),
					$author$project$Components$Membership$Form$Sections$Summary$periodInMonthsOptions(pendingMembership)) : $author$project$Utils$Html$empty),
					((!$author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership)) && (!$author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(pendingMembershipMeta))) ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$Int$asPeriodHuman(
								$author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership)))
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$EditPlan = {$: 1};
var $author$project$Components$Membership$Form$Sections$Summary$viewPlanInput = F4(
	function (membership, pendingMembership, form, model) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$required(model.of.GH),
					$author$project$Ui$Form$Group$label('Plan')
				]),
			function () {
				if (model.of.GH) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Plan$view,
								_List_fromArray(
									[
										$author$project$Components$ResourceFilter$invalid(
										A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
										$author$project$Components$ResourceFilter$errors(
										A2($author$project$Utils$Form$validationErrors, 1, form))
									]),
								model.jw))
						]);
				} else {
					var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Plan$SharedWithContractInfo$name(
												$author$project$Api$Provider$Membership$One$plan(pendingMembership)))
										])),
									$author$project$Api$Provider$Membership$Meta$planEditable(membershipMeta) ? A3(
									$author$project$Ui$Button$view,
									{abp: 'Change plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditPlan)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Change Plan')
										])) : $author$project$Utils$Html$empty
								]))
						]);
				}
			}());
	});
var $author$project$Components$Membership$Form$Sections$Summary$EditStartDate = {$: 2};
var $author$project$Components$Membership$Form$Sections$Summary$startDateOptions = function (membership) {
	return $author$project$Ui$Form$Select$dateOptions(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Api$Provider$Membership$Meta$billDateValues(
				$author$project$Api$Provider$Membership$One$meta(membership))));
};
var $author$project$Components$Membership$Form$Sections$Summary$viewStartDateInput = F5(
	function (currentDate, membership, pendingMembership, form, model) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var startDate = _v0._E;
		var futureEligibilityDate = _v0.Fq;
		var manuallySet = _v0.cb;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$label(
					A2(
						$author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus,
						_List_fromArray(
							['pending', 'unconfirmed']),
						membership) ? 'Starting' : 'Start Date'),
					$author$project$Ui$Form$Group$required(manuallySet._E)
				]),
			_List_fromArray(
				[
					function () {
					if (manuallySet._E) {
						return A2(
							$author$project$Ui$Typography$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Api$Provider$Membership$One$isSponsored(membership) ? A2(
									$author$project$Ui$Form$Select$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Select$value(
											A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, startDate)),
											$author$project$Ui$Form$Select$onChange(
											A2(
												$elm$core$Basics$composeL,
												$author$project$Components$Membership$Form$Sections$Summary$FormUpdated,
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$StartDate, $elm$core$Result$toMaybe),
													$justinmimbs$date$Date$fromIsoString))),
											$author$project$Ui$Form$Select$invalid(
											A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
											$author$project$Ui$Form$Select$errors(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]),
									$author$project$Components$Membership$Form$Sections$Summary$startDateOptions(membership)) : A2(
									$elm$html$Html$map,
									$author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg,
									A2(
										$author$project$Components$DateInput$view,
										_List_fromArray(
											[
												$author$project$Components$DateInput$value(startDate),
												$author$project$Components$DateInput$invalid(
												A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
												$author$project$Components$DateInput$errors(
												A2($author$project$Utils$Form$validationErrors, 2, form))
											]),
										model.kg)),
									function () {
									if (!futureEligibilityDate.$) {
										var futureEligibilityDate_ = futureEligibilityDate.a;
										return A2(
											$author$project$Ui$Alert$warning,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$elm$core$Maybe$withDefault,
																'',
																A2(
																	$elm$core$Maybe$map,
																	$author$project$Api$Provider$Patient$Shared$name,
																	$author$project$Api$Provider$Membership$One$owner(membership))))
														])),
													$elm$html$Html$text(' is not eligible for coverage under '),
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Provider$Company$Shared$name,
															$author$project$Api$Provider$Membership$One$company(membership)))),
													$elm$html$Html$text('\'s plan until '),
													$elm$html$Html$text(
													A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, futureEligibilityDate_))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]));
					} else {
						var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
						return A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$author$project$Formatters$Date$toString,
														A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing),
														$author$project$Api$Provider$Membership$One$startDate(pendingMembership)))
												]))
										])),
									$author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta) ? A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Change start date'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$pull(1),
															$author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditStartDate)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Change Start Date')
														]))
												]))
										])) : $author$project$Ui$FlexGrid$none
								]));
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$Sections$Summary$viewStatus = function (membership) {
	var status = $author$project$Api$Provider$Membership$One$status(membership);
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Status')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Ui$Badge$fromString, _List_Nil, status),
						function () {
						var _v0 = _Utils_Tuple2(
							status === 'active',
							$author$project$Api$Provider$Membership$One$endDate(membership));
						if (_v0.a && (!_v0.b.$)) {
							var endDate = _v0.b.a;
							return A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text(' until '),
										$elm$html$Html$text(
										A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]));
};
var $author$project$Components$Membership$Form$Sections$Summary$view = F2(
	function (_v0, _v1) {
		var membership = _v0.ja;
		var pendingMembership = _v0.c6;
		var isNew = _v0.iX;
		var model = _v1;
		var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
		var fields = $author$project$Utils$Form$fields(model.PB);
		var autoRenewEditable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 5, model.WF);
		return A2(
			$author$project$Ui$Typography$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							$author$project$Ui$Typography$headingSm(
							_List_fromArray(
								[
									$elm$html$Html$text('Summary')
								])),
							isNew ? $author$project$Utils$Html$empty : A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$ml2]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg,
									$author$project$Components$AuditTrailLog$view(model.hy))
								]))
						])),
					A4($author$project$Components$Membership$Form$Sections$Summary$viewOwnerInput, membership, pendingMembership, model.PB, model),
					A4($author$project$Components$Membership$Form$Sections$Summary$viewPlanInput, membership, pendingMembership, model.PB, model),
					(!isNew) ? $author$project$Components$Membership$Form$Sections$Summary$viewStatus(membership) : $author$project$Utils$Html$empty,
					A5($author$project$Components$Membership$Form$Sections$Summary$viewStartDateInput, model.cO, membership, pendingMembership, model.PB, model),
					(A2(
					$author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus,
					_List_fromArray(
						['active', 'unpaid']),
					membership) || ($author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta) || $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta))) ? A5($author$project$Components$Membership$Form$Sections$Summary$viewNextBillDateInput, model.cO, membership, pendingMembership, model.PB, model) : $author$project$Utils$Html$empty,
					($author$project$Api$Provider$Membership$One$isRestartable(membership) || $author$project$Utils$Maybe$toBool(
					$author$project$Api$Provider$Membership$One$endDate(pendingMembership))) ? A2($author$project$Components$Membership$Form$Sections$Summary$viewEndDate, membership, model) : $author$project$Utils$Html$empty,
					$author$project$Utils$Maybe$toBool(
					$author$project$Api$Provider$Membership$One$company(pendingMembership)) ? $author$project$Components$Membership$Form$Sections$Summary$viewMembershipType(model) : $author$project$Utils$Html$empty,
					function () {
					var _v2 = $author$project$Api$Provider$Membership$One$company(pendingMembership);
					if (!_v2.$) {
						var company = _v2.a;
						return A2($author$project$Components$Membership$Form$Sections$Summary$viewCompanyName, company, model);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A3($author$project$Components$Membership$Form$Sections$Summary$viewPeriodInMonthsInput, membership, pendingMembership, fields),
					$author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable(membershipMeta) ? A3($author$project$Components$Membership$Form$Sections$Summary$viewMinimumEnrollmentPeriodInMonthsInput, pendingMembership, fields, model) : $author$project$Utils$Html$empty,
					autoRenewEditable ? A2($author$project$Components$Membership$Form$Sections$Summary$viewAutoRenewInput, membership, fields) : $author$project$Utils$Html$empty,
					($author$project$Api$Provider$Practice$One$anyRetailBrokers(model.WF) && ((!$author$project$Api$Provider$Membership$One$isSponsored(membership)) && (!A2(
					$author$project$Permission$disallowForRoles,
					model.ZD,
					_List_fromArray(
						['practice_staff_limited']))))) ? A3($author$project$Components$Membership$Form$Sections$Summary$viewBrokerInput, model.iX, membership, model) : $author$project$Utils$Html$empty,
					function () {
					var _v3 = $author$project$Api$Provider$Membership$One$cancellationReason(membership);
					if (!_v3.$) {
						var cancellationReason = _v3.a;
						return A2($author$project$Components$Membership$Form$Sections$Summary$viewCancellationReason, membership, cancellationReason);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Membership$Form$viewForm = F4(
	function (membership, pendingMembership, sections, model) {
		var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.VM, membership, pendingMembership, sections, model);
		var _v0 = sections;
		var summary = _v0._9;
		var members = _v0.B;
		var pricing = _v0.cl;
		var contracts = _v0.aC;
		var recurringCharges = _v0.XZ;
		var planChange = _v0.ju;
		var billsOverview = _v0.pG;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$SummaryMsg,
				A2($author$project$Components$Membership$Form$Sections$Summary$view, shared, summary)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$MembersMsg,
				A3($author$project$Components$Membership$Form$Sections$Members$view, shared, model.abO, members)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$PricingMsg,
				A2($author$project$Components$Membership$Form$Sections$Pricing$view, shared, pricing)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$ContractsMsg,
				A2($author$project$Components$Membership$Form$Sections$Contracts$view, shared, contracts)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$RecurringChargesMsg,
				A2($author$project$Components$Membership$Form$Sections$RecurringCharges$view, shared, recurringCharges)),
				function () {
				if (!planChange.$) {
					var planChange_ = planChange.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$Membership$Form$PlanChangeMsg,
						A3(
							$author$project$Components$Membership$Form$Sections$PlanChange$view,
							shared,
							$author$project$Components$Membership$Form$Sections$Contracts$contractFields(contracts),
							planChange_));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Membership$Form$BillsOverviewMsg,
				A2($author$project$Components$Membership$Form$Sections$BillsOverview$view, shared, billsOverview))
			]);
	});
var $author$project$Components$Membership$Form$viewNewButtons = F3(
	function (membership, pendingMembership, model) {
		var startDate = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
		return _List_fromArray(
			[
				function () {
				if (A2($author$project$Utils$Date$isAfter, startDate, model.cO) || $author$project$Api$Provider$Membership$One$isSponsored(pendingMembership)) {
					return $author$project$Utils$Html$empty;
				} else {
					var dueAmountInCents = A3(
						$elm$core$List$foldl,
						F2(
							function (membershipBill, acc) {
								return $author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill) + acc;
							}),
						0,
						A2(
							$elm$core$List$filter,
							function (membershipBill) {
								return A2(
									$justinmimbs$date$Date$compare,
									$author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill),
									model.cO) !== 2;
							},
							$author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership)));
					var label = A2(
						$elm$core$String$join,
						' ',
						_List_fromArray(
							[
								'Create membership and',
								A2(
								$elm$core$Maybe$withDefault,
								false,
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$Patient$Shared$autopay,
									$author$project$Api$Provider$Membership$One$owner(membership))) ? 'Bill' : 'Invoice',
								$author$project$Utils$Currency$fromInt(dueAmountInCents),
								'Now'
							]));
					return A3(
						$author$project$Ui$Button$view,
						{abp: label},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(0),
								$author$project$Ui$Button$loading(
								_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Membership$Form$Save(true))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				}
			}(),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Create membership'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$loading(
						_Utils_eq(model.jY, $author$project$Api$Data$Loading)),
						$author$project$Ui$Button$onClick(
						$author$project$Components$Membership$Form$Save(false))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create')
					]))
			]);
	});
var $author$project$Components$Membership$Form$view = function (model) {
	return _List_fromArray(
		[
			$author$project$Components$Membership$Form$modal(model),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$horizontal,
									$author$project$Ui$Form$noValidate(true),
									$author$project$Ui$Form$autocomplete(false)
								]),
							function () {
								var _v0 = _Utils_Tuple3(model.ja, model.c6, model.l);
								if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
									var membership = _v0.a.a;
									var pendingMembership = _v0.b.a;
									var sections = _v0.c.a;
									return A4($author$project$Components$Membership$Form$viewForm, membership, pendingMembership, sections, model);
								} else {
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$div,
											_List_fromArray(
												[
													$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
												]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(_List_Nil)
												]))
										]);
								}
							}())
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
					A2(
						$elm$core$List$cons,
						A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
								{
									VN: $author$project$Api$Provider$Patient$One$id(model.VM)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
						function () {
							var _v1 = _Utils_Tuple3(model.ja, model.c6, model.l);
							if (((!_v1.a.$) && (!_v1.b.$)) && (!_v1.c.$)) {
								var membership = _v1.a.a;
								var pendingMembership = _v1.b.a;
								var sections = _v1.c.a;
								if (model.iX) {
									return A3($author$project$Components$Membership$Form$viewNewButtons, membership, pendingMembership, model);
								} else {
									var summaryDirty = $author$project$Components$Membership$Form$Sections$Summary$dirty(sections._9);
									var recurringChargesDirty = $author$project$Components$Membership$Form$Sections$RecurringCharges$dirty(sections.XZ);
									var pricingDirty = $author$project$Components$Membership$Form$Sections$Pricing$dirty(sections.cl);
									var membersDirty = $author$project$Components$Membership$Form$Sections$Members$dirty(sections.B);
									var contractsDirty = $author$project$Components$Membership$Form$Sections$Contracts$dirty(sections.aC);
									var dirty = summaryDirty || (membersDirty || (pricingDirty || (recurringChargesDirty || contractsDirty)));
									return A3($author$project$Components$Membership$Form$viewEditButtons, dirty, membership, model);
								}
							} else {
								return _List_fromArray(
									[$author$project$Utils$Html$empty]);
							}
						}()))
				]))
		]);
};
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$view = function (model) {
	return {
		e5: $author$project$Components$Membership$Form$view(model.PB),
		$G: 'Patient | Memberships'
	};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$view});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$init = F5(
	function (session, practice, patient, _v0, _v1) {
		var apiClient = _v0.D5;
		var timeZone = _v0.Hz;
		var currentDate = _v0.cO;
		var hinterViewOff = _v0.adN;
		var currentTime = _v0.ack;
		var url = _v0.aav;
		var query = _v1.Bi;
		var _v2 = $author$project$Components$Membership$Form$init(apiClient)(timeZone)(currentDate)(session)(practice)(hinterViewOff)(query)(patient)($elm$core$Maybe$Nothing)(currentTime)(url);
		var form = _v2.a;
		var cmd = _v2.b;
		return _Utils_Tuple2(
			{D5: apiClient, PB: form},
			cmd);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$save = F2(
	function (_v0, shared) {
		var form = _v0.PB;
		return A2($author$project$Components$Membership$Form$save, form, shared);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$subscriptions = function (model) {
	return $author$project$Components$Membership$Form$subscriptions(model.PB);
};
var $author$project$Pages$Patients$PatientId_String$Memberships$New$update = F2(
	function (msg, model) {
		var _v0 = A3($author$project$Components$Membership$Form$update, model.D5, msg, model.PB);
		var form = _v0.a;
		var cmd = _v0.b;
		var outMsgs = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			cmd,
			outMsgs);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$New$view = function (model) {
	return {
		e5: $author$project$Components$Membership$Form$view(model.PB),
		$G: 'Patient | Memberships'
	};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$New$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Memberships$New$init, aer: $author$project$Pages$Patients$PatientId_String$Memberships$New$load, agD: $author$project$Pages$Patients$PatientId_String$Memberships$New$save, ahd: $author$project$Pages$Patients$PatientId_String$Memberships$New$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Memberships$New$update, ahP: $author$project$Pages$Patients$PatientId_String$Memberships$New$view});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$GotMemberships = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Membership$All$Membership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Membership$All$Record = F9(
	function (id, startDate, nextBillDate, status, plan, periodRateInCents, periodInMonths, state, isPrimary) {
		return {adR: id, aeg: isPrimary, UC: nextBillDate, Wc: periodInMonths, Wd: periodRateInCents, GH: plan, _E: startDate, sZ: state, ag7: status};
	});
var $author$project$Api$Provider$Membership$All$EndingOrEnded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Membership$All$Renewing = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Membership$All$Started = {$: 1};
var $author$project$Api$Provider$Membership$All$Starting = {$: 0};
var $author$project$Api$Provider$Membership$All$Terminating = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Membership$All$decodeMembershipState = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var isCurrent = _v0.a;
		var endDate = _v0.b;
		var contractExpires = _v0.c;
		var _v1 = _Utils_Tuple3(isCurrent, endDate, contractExpires);
		_v1$3:
		while (true) {
			if (!_v1.a) {
				if (_v1.b.$ === 1) {
					var _v2 = _v1.b;
					return $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Starting);
				} else {
					break _v1$3;
				}
			} else {
				if (_v1.b.$ === 1) {
					var _v3 = _v1.b;
					return $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Started);
				} else {
					if (_v1.c) {
						return A3(
							$elm$json$Json$Decode$map2,
							F2(
								function (type_, contractEndDate) {
									return (type_ === 'terminating') ? $author$project$Api$Provider$Membership$All$Terminating(contractEndDate) : $author$project$Api$Provider$Membership$All$Renewing(contractEndDate);
								}),
							A2($elm$json$Json$Decode$field, 'contract_type', $elm$json$Json$Decode$string),
							A2(
								$elm$json$Json$Decode$field,
								'contract_end_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode)));
					} else {
						break _v1$3;
					}
				}
			}
		}
		return A2(
			$elm$json$Json$Decode$map,
			$author$project$Api$Provider$Membership$All$EndingOrEnded,
			A2($elm$json$Json$Decode$field, 'end_date', $author$project$Utils$Date$decode));
	},
	A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (isCurrent, endDate, contractExpires) {
				return _Utils_Tuple3(isCurrent, endDate, contractExpires);
			}),
		A2($elm$json$Json$Decode$field, 'is_current', $elm$json$Json$Decode$bool),
		A2(
			$elm$json$Json$Decode$field,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode)),
		A2($elm$json$Json$Decode$field, 'contract_expires', $elm$json$Json$Decode$bool)));
var $author$project$Api$Provider$Membership$All$Other = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Membership$All$Unconfirmed = {$: 0};
var $author$project$Api$Provider$Membership$All$membershipStatusFromString = function (stringStatus) {
	if (stringStatus === 'unconfirmed') {
		return $author$project$Api$Provider$Membership$All$Unconfirmed;
	} else {
		return $author$project$Api$Provider$Membership$All$Other(stringStatus);
	}
};
var $author$project$Api$Provider$Membership$All$decoder = $elm$json$Json$Decode$list(
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'is_primary',
			$elm$json$Json$Decode$bool,
			false,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
				$author$project$Api$Provider$Membership$All$decodeMembershipState,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'period_in_months',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'period_rate_in_cents',
						$author$project$Currency$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'plan',
							$author$project$Api$Provider$Plan$Min$decoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'status',
								A2($elm$json$Json$Decode$map, $author$project$Api$Provider$Membership$All$membershipStatusFromString, $elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'next_bill_date',
									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'start_date',
										$author$project$Utils$Date$decode,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Record))))))))))));
var $author$project$Api$Provider$Membership$listDefaults = {afy: $author$project$Api$Pagination$init};
var $author$project$Api$Provider$Membership$list = F4(
	function (apiClient, ownerId, optionals, toMsg) {
		var options = optionals($author$project$Api$Provider$Membership$listDefaults);
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Membership$All$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				A2(
					$elm$core$List$cons,
					A2($author$project$Api$Param$string, 'owner', ownerId),
					$author$project$Api$Pagination$toApiParams(options.afy)),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipsPath)));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships = function (model) {
	return A4(
		$author$project$Api$Provider$Membership$list,
		model.D5,
		$author$project$Api$Provider$Patient$One$id(model.VM),
		function (opts) {
			return _Utils_update(
				opts,
				{afy: model.afy});
		},
		$author$project$Pages$Patients$PatientId_String$Memberships$Top$GotMemberships);
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$GotPackages = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$PatientPackage$All$PatientPackage = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientPackage$All$PatientPackageRecord = F8(
	function (id, packageName, priceInCents, purchasedOn, endedAt, expiresAt, status, prepaidCharges) {
		return {ac2: endedAt, OZ: expiresAt, adR: id, Vs: packageName, WW: prepaidCharges, Ba: priceInCents, Xr: purchasedOn, ag7: status};
	});
var $author$project$Api$Provider$PatientPackage$All$PrepaidCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientPackage$All$PrepaidChargeRecord = F5(
	function (id, originalQuantity, remainingQuantity, priceInCents, chargeItem) {
		return {lp: chargeItem, adR: id, Vi: originalQuantity, Ba: priceInCents, X9: remainingQuantity};
	});
var $author$project$Api$Provider$PatientPackage$All$prepaidChargeDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'charge_item',
		$author$project$Api$Provider$ChargeItem$Min$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'price_in_cents',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'remaining_quantity',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'original_quantity',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientPackage$All$PrepaidChargeRecord)))))));
var $author$project$Api$Provider$PatientPackage$All$Active = 0;
var $author$project$Api$Provider$PatientPackage$All$Ended = 1;
var $author$project$Api$Provider$PatientPackage$All$Inactive = 2;
var $author$project$Api$Provider$PatientPackage$All$statusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'active':
				return $elm$json$Json$Decode$succeed(0);
			case 'ended':
				return $elm$json$Json$Decode$succeed(1);
			case 'inactive':
				return $elm$json$Json$Decode$succeed(2);
			default:
				var other = str;
				return $elm$json$Json$Decode$fail('Unknown status: ' + other);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$PatientPackage$All$patientPackageDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'prepaid_charges',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PatientPackage$All$prepaidChargeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$author$project$Api$Provider$PatientPackage$All$statusDecoder,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'expires_at',
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Utils$Date$decode),
				$elm$core$Maybe$Nothing,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'ended_at',
					A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Utils$Date$decode),
					$elm$core$Maybe$Nothing,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'purchased_on',
						$author$project$Utils$Date$decode,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'price_in_cents',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'package_name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientPackage$All$PatientPackageRecord))))))))));
var $author$project$Api$Provider$PatientPackage$All$listDecoder = $elm$json$Json$Decode$list($author$project$Api$Provider$PatientPackage$All$patientPackageDecoder);
var $author$project$Api$Provider$PatientPackage$All$packagesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patient_packages']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PatientPackage$All$list = F3(
	function (client, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			client,
			$author$project$Api$Provider$PatientPackage$All$listDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'patient_id', patientId)
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PatientPackage$All$packagesPath)));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchPackages = function (model) {
	return A3(
		$author$project$Api$Provider$PatientPackage$All$list,
		model.D5,
		$author$project$Api$Provider$Patient$One$id(model.VM),
		$author$project$Pages$Patients$PatientId_String$Memberships$Top$GotPackages);
};
var $author$project$Components$Patient$PackageDetailsModal$init = {yk: false, Vq: $elm$core$Maybe$Nothing, ne: $elm$core$Maybe$Nothing};
var $author$project$Components$PatientsList$urlParams = function (model) {
	var filters = model.g;
	var queryParams = _List_fromArray(
		[
			$elm$core$List$isEmpty(filters.g) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			A2(
				$elm$url$Url$Builder$string,
				'filter',
				A2(
					$elm$core$String$join,
					',',
					A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters.g)))),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_q'),
			filters.af_),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_company'),
			filters.ff),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_plan'),
			filters.afN),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_location_group'),
			filters.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_location'),
			filters.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_practitioner'),
			filters.WO),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('patients_affiliate'),
			filters.pp)
		]);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toPageQuery(model.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toQuery(model.ag1),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$init = F5(
	function (session, practice, patient, shared, _v0) {
		var query = _v0.Bi;
		var model = {
			D5: shared.D5,
			jb: $author$project$Api$Data$NotAsked,
			a8: $elm$core$Maybe$Nothing,
			c4: $author$project$Components$Patient$PackageDetailsModal$init,
			z4: A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			VM: patient,
			WF: practice,
			ZD: session,
			DE: A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $author$project$Components$PatientsList$urlParams, shared.afE))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships(model),
						A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchPackages(model) : $elm$core$Platform$Cmd$none
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked = {$: 1};
var $author$project$Components$Patient$CreateMembershipModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked);
};
var $author$project$Components$Patient$PackageDetailsModal$Close = 0;
var $author$project$Components$Patient$PackageDetailsModal$subscriptions = function (model) {
	return model.yk ? $author$project$Ui$Modal$subscribeToEscapeKeyPress(0) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$subscriptions = function (_v0) {
	var modal = _v0.a8;
	var packageDetailsModal = _v0.c4;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$CreateMembershipModal$subscriptions, modal))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg,
				$author$project$Components$Patient$PackageDetailsModal$subscriptions(packageDetailsModal))
			]));
};
var $author$project$Components$Patient$CreateMembershipModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Patient$CreateMembershipModal$Retail = {$: 0};
var $author$project$Components$Patient$CreateMembershipModal$init = F3(
	function (urlParams, companyAccounts, patient) {
		return {Lt: companyAccounts, VM: patient, sE: $author$project$Components$Patient$CreateMembershipModal$Retail, DE: urlParams};
	});
var $author$project$Utils$NonEmpty$NonEmpty = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Utils$NonEmpty$init = $author$project$Utils$NonEmpty$NonEmpty;
var $author$project$Api$Provider$CompanyAccount$ForPatient$isEligible = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$isEligible(shared);
};
var $author$project$Components$Patient$PackageDetailsModal$open = F2(
	function (_package, model) {
		return _Utils_update(
			model,
			{
				yk: true,
				Vq: $elm$core$Maybe$Just(_package),
				ne: $elm$core$Maybe$Nothing
			});
	});
var $author$project$Components$Patient$PackageDetailsModal$openWithPrice = F3(
	function (_package, price, model) {
		return _Utils_update(
			model,
			{
				yk: true,
				Vq: $elm$core$Maybe$Just(_package),
				ne: $elm$core$Maybe$Just(price)
			});
	});
var $author$project$Api$Provider$PatientPackage$All$priceInCents = function (_v0) {
	var record = _v0;
	return record.Ba;
};
var $author$project$Components$Patient$CreateMembershipModal$CloseModal = {$: 0};
var $author$project$Components$Patient$CreateMembershipModal$CreationFailed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$CreateMembershipModal$CreationSucceeded = {$: 2};
var $author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations = function (_v0) {
	var record = _v0.b;
	return record.Lz;
};
var $author$project$Components$Patient$CreateMembershipModal$Enrolled = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$CompanyAccount$ForPatient$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Components$Patient$CreateMembershipModal$enrollDependent = F3(
	function (apiClient, companyAccount, patient) {
		var maybeCompanyRegistrationId = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (registration) {
						return _Utils_eq(
							$author$project$Api$Provider$Patient$Min$id(
								$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)),
							$author$project$Api$Provider$Patient$One$id(patient));
					},
					$author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(companyAccount))));
		if (!maybeCompanyRegistrationId.$) {
			var companyRegistrationId = maybeCompanyRegistrationId.a;
			var companyId = $author$project$Api$Provider$Company$Min$id(
				$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount));
			return A6(
				$author$project$Api$Provider$Company$Registration$enroll,
				apiClient,
				companyId,
				$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount),
				companyRegistrationId,
				$elm$json$Json$Encode$object(_List_Nil),
				$author$project$Components$Patient$CreateMembershipModal$Enrolled);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember = function (_v0) {
	var record = _v0.b;
	return record.RE;
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber(shared);
};
var $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber = function (_v0) {
	var record = _v0.b;
	return record._3;
};
var $author$project$Components$Patient$CreateMembershipModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var patientId = $author$project$Api$Provider$Patient$One$id(model.VM);
				var _v2 = model.sE;
				if (!_v2.$) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Ports$Navigation$pushRoute,
							model.DE,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
								{VN: patientId})),
						$elm$core$Maybe$Nothing);
				} else {
					var sponsor = _v2.a;
					var subscriber = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(sponsor);
					var isSubscriberEnrolled = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber,
									$author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(sponsor)))));
					var isSubscriber = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$eq(patientId),
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, subscriber)));
					var _v3 = _Utils_Tuple2(isSubscriber, isSubscriberEnrolled);
					if (!_v3.a) {
						if (!_v3.b) {
							var companyId = $author$project$Api$Provider$Company$Min$id(
								$author$project$Api$Provider$CompanyAccount$ForPatient$company(sponsor));
							return _Utils_Tuple3(
								model,
								A2(
									$author$project$Ports$Navigation$pushRoute,
									$author$project$Utils$QueryParameter$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2('filter', 'all'),
												_Utils_Tuple2(
												'q',
												A2(
													$elm$core$Maybe$withDefault,
													'',
													A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, subscriber)))
											])),
									$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
										{ff: companyId})),
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(
								model,
								A3($author$project$Components$Patient$CreateMembershipModal$enrollDependent, apiClient, sponsor, model.VM),
								$elm$core$Maybe$Nothing);
						}
					} else {
						var companyAccountId = $author$project$Api$Provider$CompanyAccount$ForPatient$id(sponsor);
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Ports$Navigation$pushRoute,
								A2(
									$elm$core$List$append,
									$author$project$Utils$QueryParameter$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2('company_account', companyAccountId)
											])),
									model.DE),
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
									{VN: patientId})),
							$elm$core$Maybe$Nothing);
					}
				}
			case 1:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just($author$project$Components$Patient$CreateMembershipModal$CloseModal));
			case 2:
				var membershipType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sE: membershipType}),
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Nothing);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Just($author$project$Components$Patient$CreateMembershipModal$CreationSucceeded));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$elm$core$Maybe$Just(
								$author$project$Components$Patient$CreateMembershipModal$CreationFailed(error)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Components$Patient$PackageDetailsModal$close = function (model) {
	return _Utils_update(
		model,
		{yk: false, Vq: $elm$core$Maybe$Nothing, ne: $elm$core$Maybe$Nothing});
};
var $author$project$Components$Patient$PackageDetailsModal$update = F2(
	function (msg, model) {
		return _Utils_Tuple2(
			$author$project$Components$Patient$PackageDetailsModal$close(model),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString(
				$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
					{
						VN: $author$project$Api$Provider$Patient$One$id(model.VM)
					}))
			]),
		$author$project$Api$Pagination$toPageQuery(model.afy));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		$author$project$Pages$Patients$PatientId_String$Memberships$Top$buildUrl(model));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$update = F2(
	function (msg, model) {
		var patient = model.VM;
		switch (msg.$) {
			case 0:
				var membershipId = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
							{
								yS: membershipId,
								VN: $author$project$Api$Provider$Patient$One$id(patient)
							})),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								jb: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jb: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var eligibleCompanyAccounts = A2(
					$elm$core$List$filter,
					$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible,
					$author$project$Api$Provider$Patient$One$companyAccounts(patient));
				if (!eligibleCompanyAccounts.b) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Ports$Navigation$pushRoute,
							model.DE,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
								{
									VN: $author$project$Api$Provider$Patient$One$id(patient)
								})),
						_List_Nil);
				} else {
					var x = eligibleCompanyAccounts.a;
					var xs = eligibleCompanyAccounts.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								a8: $elm$core$Maybe$Just(
									A3(
										$author$project$Components$Patient$CreateMembershipModal$init,
										model.DE,
										A2($author$project$Utils$NonEmpty$init, x, xs),
										model.VM))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					model,
					A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'patient',
									$author$project$Api$Provider$Patient$One$id(patient))
								])),
						$author$project$Spa$Generated$Route$Charges__New),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v3 = model.a8;
				if (!_v3.$) {
					var modal = _v3.a;
					var _v4 = A3($author$project$Components$Patient$CreateMembershipModal$update, model.D5, subMsg, modal);
					var createModal_ = _v4.a;
					var cmd = _v4.b;
					var maybeEvent = _v4.c;
					var _v5 = function () {
						if (!maybeEvent.$) {
							switch (maybeEvent.a.$) {
								case 0:
									var _v7 = maybeEvent.a;
									return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
								case 2:
									var _v8 = maybeEvent.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Nothing,
										A2(
											$author$project$Ports$Navigation$pushRoute,
											model.DE,
											$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
												{
													VN: $author$project$Api$Provider$Patient$One$id(patient)
												})),
										_List_fromArray(
											[
												$author$project$OutMsg$RetrievePatient(
												$author$project$Api$Provider$Patient$One$id(model.VM))
											]));
								default:
									var error = maybeEvent.a.a;
									return _Utils_Tuple3(
										$elm$core$Maybe$Just(createModal_),
										$elm$core$Platform$Cmd$none,
										_List_fromArray(
											[
												A2(
												$author$project$OutMsg$ShowToast,
												1,
												$author$project$Ui$Toast$serverError(error))
											]));
							}
						} else {
							return _Utils_Tuple3(
								$elm$core$Maybe$Just(createModal_),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						}
					}();
					var newModal = _v5.a;
					var cmdFromEvent = _v5.b;
					var outMsgs = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{a8: newModal}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmdFromEvent,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg, cmd)
								])),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{jb: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships(newModel),
								$author$project$Pages$Patients$PatientId_String$Memberships$Top$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{z4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var _package = msg.a;
				var modalWithPackage = function () {
					var _v9 = $author$project$Api$Provider$PatientPackage$All$priceInCents(_package);
					if (!_v9.$) {
						var price = _v9.a;
						return A3($author$project$Components$Patient$PackageDetailsModal$openWithPrice, _package, price, model.c4);
					} else {
						return A2($author$project$Components$Patient$PackageDetailsModal$open, _package, model.c4);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c4: modalWithPackage}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v10 = A2($author$project$Components$Patient$PackageDetailsModal$update, subMsg, model.c4);
				var newModal = _v10.a;
				var cmd = _v10.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c4: newModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg, cmd),
					_List_Nil);
		}
	});
var $author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$CreateMembershipModal$Sponsored = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$CreateMembershipModal$companyAccountDescription = F2(
	function (companyAccount, patient) {
		var name = $author$project$Api$Provider$Company$Min$name(
			$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount));
		var maybeSubscriber = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount);
		var isSubscriber = function () {
			var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, maybeSubscriber);
			if (!_v0.$) {
				var id = _v0.a;
				return _Utils_eq(
					id,
					$author$project$Api$Provider$Patient$One$id(patient));
			} else {
				return false;
			}
		}();
		return _Utils_ap(
			name,
			function () {
				if (isSubscriber) {
					return ' (employee)';
				} else {
					var subscriberName = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, maybeSubscriber));
					return ' (dependent of ' + (subscriberName + ')');
				}
			}());
	});
var $author$project$Utils$NonEmpty$head = function (_v0) {
	var head_ = _v0.a;
	return head_;
};
var $author$project$Utils$NonEmpty$toList = function (_v0) {
	var head_ = _v0.a;
	var rest = _v0.b;
	return A2($elm$core$List$cons, head_, rest);
};
var $author$project$Components$Patient$CreateMembershipModal$viewAlerts = F2(
	function (selectedCompanyAccount, patient) {
		var maybeSelectedSponsorshipIsSubscriber = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$eq(
				$author$project$Api$Provider$Patient$One$id(patient)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$Min$id,
				$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(selectedCompanyAccount)));
		var maybeIsSubscriberEnrolled = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber,
					$author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(selectedCompanyAccount))));
		var _v0 = _Utils_Tuple2(maybeSelectedSponsorshipIsSubscriber, maybeIsSubscriberEnrolled);
		if (((!_v0.a.$) && (!_v0.a.a)) && (!_v0.b.$)) {
			var bool = _v0.b.a;
			var selectedSponsorshipName = A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Patient$Min$name,
					$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(selectedCompanyAccount)));
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanMd(4),
						$author$project$Ui$Form$Group$inputSpanMd(8)
					]),
				_List_fromArray(
					[
						bool ? A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'This will enroll ' + ($author$project$Api$Provider$Patient$One$name(patient) + (' in membership of ' + selectedSponsorshipName)))
							])) : A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You will be redirected to ' + (selectedSponsorshipName + '\'s Employment Page'))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Patient$CreateMembershipModal$viewBody = F3(
	function (selectedType, companyAccounts, patient) {
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[$author$project$Ui$Form$horizontal]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Membership Type'),
							$author$project$Ui$Form$Group$labelSpanMd(4),
							$author$project$Ui$Form$Group$inputSpanMd(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Button$group(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Select retail membership'},
									_List_fromArray(
										[
											$author$project$Ui$Button$active(
											_Utils_eq($author$project$Components$Patient$CreateMembershipModal$Retail, selectedType)),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged($author$project$Components$Patient$CreateMembershipModal$Retail))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Retail')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Select sponsored membership'},
									_List_fromArray(
										[
											$author$project$Ui$Button$active(
											!_Utils_eq($author$project$Components$Patient$CreateMembershipModal$Retail, selectedType)),
											$author$project$Ui$Button$onClick(
											$author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged(
												$author$project$Components$Patient$CreateMembershipModal$Sponsored(
													$author$project$Utils$NonEmpty$head(companyAccounts))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sponsored')
										]))
								]))
						])),
					function () {
					if (selectedType.$ === 1) {
						var companyAccount = selectedType.a;
						var onSponsorSelected = function (companyAccountId) {
							return $author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged(
								$author$project$Components$Patient$CreateMembershipModal$Sponsored(
									A2(
										$elm$core$Maybe$withDefault,
										companyAccount,
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (elem) {
													return _Utils_eq(
														$author$project$Api$Provider$CompanyAccount$ForPatient$id(elem),
														companyAccountId);
												},
												$author$project$Utils$NonEmpty$toList(companyAccounts))))));
						};
						var companyAccountOptions = A2(
							$elm$core$List$map,
							function (companyAccount_) {
								return A3(
									$author$project$Ui$Form$Select$option,
									_List_Nil,
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount_)),
									A2($author$project$Components$Patient$CreateMembershipModal$companyAccountDescription, companyAccount_, patient));
							},
							$author$project$Utils$NonEmpty$toList(companyAccounts));
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Sponsor'),
											$author$project$Ui$Form$Group$labelSpanMd(4),
											$author$project$Ui$Form$Group$inputSpanMd(8)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$elm$core$Maybe$Just(
														$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount))),
													$author$project$Ui$Form$Select$onChange(onSponsorSelected)
												]),
											companyAccountOptions)
										])),
									A2($author$project$Components$Patient$CreateMembershipModal$viewAlerts, companyAccount, patient)
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]));
	});
var $author$project$Components$Patient$CreateMembershipModal$ConfirmButtonClicked = {$: 0};
var $author$project$Components$Patient$CreateMembershipModal$viewFooter = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Cancel and close modal'},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
				$author$project$Ui$Button$onClick($author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Cancel')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Confirm membership'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$Patient$CreateMembershipModal$ConfirmButtonClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Confirm')
			]))
	]);
var $author$project$Components$Patient$CreateMembershipModal$view = function (_v0) {
	var selectedMembershipType = _v0.sE;
	var companyAccounts = _v0.Lt;
	var patient = _v0.VM;
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Create a membership')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A3($author$project$Components$Patient$CreateMembershipModal$viewBody, selectedMembershipType, companyAccounts, patient)
					])),
				$author$project$Ui$Modal$footer($author$project$Components$Patient$CreateMembershipModal$viewFooter)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal = function (maybeModal) {
	if (!maybeModal.$) {
		var modal = maybeModal.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg,
			$author$project$Components$Patient$CreateMembershipModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$PatientPackage$All$expiresAt = function (_v0) {
	var record = _v0;
	return record.OZ;
};
var $author$project$Api$Provider$PatientPackage$All$packageName = function (_v0) {
	var record = _v0;
	return record.Vs;
};
var $author$project$Api$Provider$PatientPackage$All$prepaidCharges = function (_v0) {
	var record = _v0;
	return record.WW;
};
var $author$project$Api$Provider$PatientPackage$All$chargeItemName = function (_v0) {
	var record = _v0;
	return $author$project$Api$Provider$ChargeItem$Min$name(record.lp);
};
var $author$project$Api$Provider$PatientPackage$All$originalQuantity = function (_v0) {
	var record = _v0;
	return record.Vi;
};
var $author$project$Api$Provider$PatientPackage$All$remainingQuantity = function (_v0) {
	var record = _v0;
	return record.X9;
};
var $author$project$Components$Patient$PackageDetailsModal$viewPrepaidCharge = function (prepaidCharge) {
	var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
	var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
	var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(originalQty) + (' ' + name))
					])),
				$elm$html$Html$text(' '),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)'))
					]))
			]));
};
var $author$project$Components$Patient$PackageDetailsModal$viewModal = F2(
	function (_package, maybePrice) {
		var prepaidCharges_ = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(_package);
		var packageTotal = A2(
			$elm$core$Maybe$withDefault,
			'Price not available',
			A2(
				$elm$core$Maybe$map,
				function (currency) {
					return '$' + $author$project$Currency$toString(currency);
				},
				A2(
					$elm$core$Maybe$map,
					function (price) {
						return $author$project$Currency$fromFloat(price);
					},
					maybePrice)));
		var packageName_ = $author$project$Api$Provider$PatientPackage$All$packageName(_package);
		var expiresAt_ = A2(
			$elm$core$Maybe$map,
			$justinmimbs$date$Date$format('MM/dd/yyyy'),
			$author$project$Api$Provider$PatientPackage$All$expiresAt(_package));
		return A3(
			$author$project$Ui$Modal$view,
			0,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Package Details')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[$author$project$Ui$Form$horizontal]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Package'),
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(packageName_)
														]))
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Price'),
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$strong,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(packageTotal)
														]))
												]))
										])),
									function () {
									if (!expiresAt_.$) {
										var expiryDate = expiresAt_.a;
										return A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$label('Expires'),
													$author$project$Ui$Form$Group$labelSpanSm(3),
													$author$project$Ui$Form$Group$inputSpanSm(9)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(expiryDate)
																]))
														]))
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Includes'),
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													A2($elm$core$List$map, $author$project$Components$Patient$PackageDetailsModal$viewPrepaidCharge, prepaidCharges_))
												]))
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textCenter]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Close modal'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
											$author$project$Ui$Button$onClick(0)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Close')
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Patient$PackageDetailsModal$view = function (model) {
	if (model.yk) {
		var _v0 = model.Vq;
		if (!_v0.$) {
			var _package = _v0.a;
			return A2($author$project$Components$Patient$PackageDetailsModal$viewModal, _package, model.ne);
		} else {
			return $elm$html$Html$text('');
		}
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal = function (modal) {
	return A2(
		$elm$html$Html$map,
		$author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg,
		$author$project$Components$Patient$PackageDetailsModal$view(modal));
};
var $author$project$Api$Provider$PatientPackage$All$activePackages = $elm$core$List$filter(
	function (_v0) {
		var record = _v0;
		return !record.ag7;
	});
var $author$project$Ui$Element$Padding = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Element$p0 = $author$project$Ui$Element$Padding('p-0');
var $author$project$Ui$Panel$viewKeyed = F2(
	function (options, keyedSections) {
		var optionsRecord = $author$project$Ui$Panel$optionsToRecord(options);
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('panel'),
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(optionsRecord.s_),
					optionsRecord.vx)),
			A2(
				$elm$core$List$filterMap,
				function (_v0) {
					var key = _v0.a;
					var maybeSection = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						function (section) {
							return _Utils_Tuple2(key, section);
						},
						maybeSection);
				},
				A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(
						$author$project$Ui$Panel$sectionToContents(optionsRecord)),
					keyedSections)));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$NewPackageClicked = {$: 2};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewNewPackageButton = A3(
	$author$project$Ui$Button$view,
	{abp: 'New package'},
	_List_fromArray(
		[
			$author$project$Ui$Button$styled(0),
			$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Memberships$Top$NewPackageClicked),
			$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('New Package')
		]));
var $author$project$Ui$Margin$Bottom_2_00 = 3;
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$OpenPackageDetailsModal = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$PatientPackage$All$purchasedOn = function (_v0) {
	var record = _v0;
	return record.Xr;
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPrepaidCharge = function (prepaidCharge) {
	var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
	var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
	var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-muted'),
				A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$core$String$fromInt(originalQty) + (' ' + (name + ' '))),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)'))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageItem = function (packageItem) {
	var purchasedOn = $author$project$Api$Provider$PatientPackage$All$purchasedOn(packageItem);
	var prepaidCharges = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(packageItem);
	var packageName = $author$project$Api$Provider$PatientPackage$All$packageName(packageItem);
	var packageDetailsButton = A3(
		$author$project$Ui$Button$view,
		{abp: 'See package details'},
		_List_fromArray(
			[
				$author$project$Ui$Button$margin(20),
				$author$project$Ui$Button$margin(3),
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$styled(0),
				$author$project$Ui$Button$onClick(
				$author$project$Pages$Patients$PatientId_String$Memberships$Top$OpenPackageDetailsModal(packageItem))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('See Package Details')
			]));
	var expiresAt = $author$project$Api$Provider$PatientPackage$All$expiresAt(packageItem);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list__item')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text(packageName)
							]))
					])),
				(!$elm$core$List$isEmpty(prepaidCharges)) ? A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb2]),
				A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPrepaidCharge, prepaidCharges)) : $author$project$Utils$Html$empty,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-body-sm text-muted mb-1')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Purchased on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, purchasedOn))
					])),
				function () {
				if (!expiresAt.$) {
					var expiryDate = expiresAt.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('text-sm text-muted mb-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Expires on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiryDate))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				packageDetailsButton
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel = function (model) {
	var _v0 = model.z4;
	switch (_v0.$) {
		case 3:
			var patientPackages = _v0.a;
			var activePackages = $author$project$Api$Provider$PatientPackage$All$activePackages(patientPackages);
			return A2(
				$author$project$Ui$Panel$viewKeyed,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'title',
						A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Packages')
										]))
								]))),
						(!$elm$core$List$isEmpty(activePackages)) ? _Utils_Tuple2(
						'packages-body',
						A2(
							$author$project$Ui$Panel$body,
							_List_fromArray(
								[$author$project$Ui$Element$p0]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('list')
										]),
									A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageItem, activePackages))
								]))) : _Utils_Tuple2(
						'no-packages',
						A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('This patient has no packages')
								]))),
						_Utils_Tuple2(
						'footer',
						A2(
							$author$project$Ui$Panel$footer,
							_List_Nil,
							_List_fromArray(
								[$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewNewPackageButton])))
					]));
		case 1:
			return A2(
				$author$project$Ui$Panel$viewKeyed,
				_List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple2(
						'title',
						A2(
							$author$project$Ui$Panel$heading,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text('Packages')
										]))
								]))),
						_Utils_Tuple2(
						'loading',
						A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textCenter]),
									_List_fromArray(
										[
											$author$project$Ui$Spinner$view(_List_Nil)
										]))
								])))
					]));
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$NewMembershipClicked = {$: 1};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Phi$Phi = $elm$core$Basics$identity;
var $author$project$Api$Phi$from = function (thing) {
	return thing;
};
var $author$project$Api$Pagination$headerTotalCount = function (_v0) {
	var model = _v0;
	return model.oN;
};
var $author$project$Api$Provider$Patient$One$membershipThrough = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.TM;
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$MembershipClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Membership$All$record_ = function (_v0) {
	var record = _v0;
	return record;
};
var $author$project$Api$Provider$Membership$All$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.adR;
	});
var $author$project$Api$Provider$Membership$All$nextBillDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.UC;
	});
var $author$project$Api$Provider$Membership$All$periodInMonths = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.Wc;
	});
var $author$project$Api$Provider$Membership$All$periodRateInCents = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.Wd;
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$periodToString = function (periodInMonths) {
	switch (periodInMonths) {
		case 1:
			return 'Monthly';
		case 3:
			return 'Quarterly';
		case 6:
			return 'Semi-annually';
		case 12:
			return 'Annually';
		default:
			return '/ ' + $elm$core$String$fromInt(periodInMonths);
	}
};
var $author$project$Api$Provider$Membership$All$plan = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.GH;
	});
var $author$project$Api$Provider$Membership$All$startDate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $._E;
	});
var $author$project$Api$Provider$Membership$All$state = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.sZ;
	});
var $author$project$Api$Provider$Membership$All$status = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Membership$All$record_,
	function ($) {
		return $.ag7;
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$statusToBadge = function (status) {
	var statusText = function () {
		if (!status.$) {
			return 'unconfirmed';
		} else {
			var status_ = status.a;
			return status_;
		}
	}();
	return A2($author$project$Ui$Badge$fromString, _List_Nil, statusText);
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewMembership = function (membership) {
	var status = $author$project$Api$Provider$Membership$All$status(membership);
	var startDate = $author$project$Api$Provider$Membership$All$startDate(membership);
	var planName = $author$project$Api$Provider$Plan$Min$name(
		$author$project$Api$Provider$Membership$All$plan(membership));
	return A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list__item'),
				$elm$html$Html$Attributes$class('list__item--clickable'),
				$elm$html$Html$Events$onClick(
				$author$project$Pages$Patients$PatientId_String$Memberships$Top$MembershipClicked(
					$author$project$Api$Provider$Membership$All$id(membership)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex items-center mb-025')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								function () {
								var _v0 = $author$project$Api$Provider$Membership$All$nextBillDate(membership);
								if (!_v0.$) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('mr-025')
											]),
										$elm$core$List$singleton(
											$elm$html$Html$text(
												$author$project$Currency$format(
													$author$project$Api$Provider$Membership$All$periodRateInCents(membership)))));
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-025')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(planName)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-025')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Pages$Patients$PatientId_String$Memberships$Top$periodToString(
											$author$project$Api$Provider$Membership$All$periodInMonths(membership)))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flex items-center')
							]),
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Memberships$Top$statusToBadge(status)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-body-sm text-muted')
					]),
				function () {
					var _v1 = _Utils_Tuple2(
						status,
						$author$project$Api$Provider$Membership$All$state(membership));
					_v1$0:
					while (true) {
						switch (_v1.b.$) {
							case 0:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var _v3 = _v1.b;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'Starting on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
										]);
								}
							case 1:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var _v4 = _v1.b;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'Memberships started on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
										]);
								}
							case 3:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var on = _v1.b.a;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'Contract terminating on ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													on)))
										]);
								}
							case 4:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var on = _v1.b.a;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'Contract renewing on ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													on)))
										]);
								}
							default:
								if (!_v1.a.$) {
									break _v1$0;
								} else {
									var on = _v1.b.a;
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'From ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate) + (' to ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, on))))
										]);
								}
						}
					}
					var _v2 = _v1.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(
							'Signed up on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
						]);
				}())
			]));
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel = F2(
	function (model, memberships) {
		var _v0 = model;
		var patient = _v0.VM;
		var urlParams = _v0.DE;
		var pagination = _v0.afy;
		var membershipsData = _v0.jb;
		var loading = function () {
			if (membershipsData.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		var hasPagination = $author$project$Api$Pagination$headerTotalCount(pagination) > 10;
		return A2(
			$author$project$Ui$Panel$viewKeyed,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'title',
							A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Memberships')
											]))
									])))),
						function () {
						var _v1 = _Utils_Tuple2(
							$author$project$Api$Provider$Patient$One$membershipThrough(patient),
							$elm$core$List$length(memberships));
						if (!_v1.a.$) {
							var through = _v1.a.a;
							return $elm$core$Maybe$Just(
								A2(
									$elm$core$Tuple$pair,
									'heading',
									A2(
										$author$project$Ui$Panel$heading,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Membership through '),
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														VN: $author$project$Api$Provider$Patient$Min$id(through)
													}),
												_List_fromArray(
													[
														$author$project$Ui$Link$routeParams(urlParams)
													]),
												_List_fromArray(
													[
														$author$project$Api$Phi$text(
														$author$project$Api$Phi$from(
															$author$project$Api$Provider$Patient$Min$name(through)))
													]))
											]))));
						} else {
							if (!_v1.b) {
								return loading ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									A2(
										$elm$core$Tuple$pair,
										'body',
										A2(
											$author$project$Ui$Panel$body,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('This patient has no memberships')
												]))));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}
					}(),
						$elm$core$Maybe$Just(
						_Utils_Tuple2(
							'widget',
							A2(
								$author$project$Ui$Panel$body,
								_List_fromArray(
									[$author$project$Ui$Element$p0]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list')
											]),
										A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewMembership, memberships))
									])))),
						hasPagination ? $elm$core$Maybe$Just(
						A2(
							$elm$core$Tuple$pair,
							'pagination',
							A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Patients$PatientId_String$Memberships$Top$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(loading)
												]),
											pagination))
									])))) : $elm$core$Maybe$Nothing,
						$author$project$Api$Provider$Patient$One$isSynced(patient) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						A2(
							$elm$core$Tuple$pair,
							'footer',
							A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'New membership'},
										_List_fromArray(
											[
												$author$project$Ui$Button$styled(0),
												$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Memberships$Top$NewMembershipClicked),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('New Membership')
											]))
									]))))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$view = function (model) {
	var pageTitle = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.WF) ? 'Patient | Memberships & Packages' : 'Patient | Memberships';
	return {
		e5: function () {
			var _v0 = model.jb;
			switch (_v0.$) {
				case 3:
					var memberships = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel, model, memberships),
							A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.WF) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel(model) : $author$project$Utils$Html$empty,
							$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal(model.a8),
							$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal(model.c4)
						]);
				case 1:
					return _List_fromArray(
						[
							A2($author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel, model, _List_Nil),
							A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.WF) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel(model) : $author$project$Utils$Html$empty,
							$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal(model.a8),
							$author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal(model.c4)
						]);
				default:
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Spinner$view(_List_Nil)
								]))
						]);
			}
		}(),
		$G: pageTitle
	};
};
var $author$project$Pages$Patients$PatientId_String$Memberships$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Memberships$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Memberships$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Memberships$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Memberships$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Memberships$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Memberships$Top$view});
var $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Merge$init = F5(
	function (_v0, practice, patient, _v1, _v2) {
		var apiClient = _v1.D5;
		var _v3 = A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A2(
				$author$project$Components$ResourceFilter$Patient$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'Search for a patient... ',
							abe: $elm$core$Maybe$Nothing,
							ac6: $elm$core$Maybe$Just(
								$author$project$Api$Provider$Patient$One$id(patient))
						});
				}));
		var patientResourceFilter = _v3.a;
		var patientResourceFilterCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: apiClient, hS: false, aa: false, m3: _List_Nil, cc: _List_Nil, cY: _List_Nil, cZ: _List_Nil, ed: $elm$core$Maybe$Nothing, ce: $elm$core$Maybe$Nothing, VM: patient, rU: patientResourceFilter, WF: practice, by: $elm$core$Maybe$Nothing},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg, patientResourceFilterCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Merge$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Merge$subscriptions = function (model) {
	return model.hS ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Api$Provider$PatientMerge$associations = function (_v0) {
	var record = _v0;
	return record.Jr;
};
var $author$project$Api$Provider$PatientMerge$attributes = function (_v0) {
	var record = _v0;
	return record.vw;
};
var $author$project$Api$Provider$PatientMerge$externalRecords = function (_v0) {
	var record = _v0;
	return record.xx;
};
var $author$project$Pages$Patients$PatientId_String$Merge$GotPreview = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PatientMerge$patientMergesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patient_merges']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PatientMerge$Merge = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$MergeRecords = F5(
	function (attributes, paymentOptions, externalRecords, integrationRecords, associations) {
		return {Jr: associations, vw: attributes, xx: externalRecords, Q8: integrationRecords, V_: paymentOptions};
	});
var $author$project$Api$Provider$PatientMerge$Association = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$AssociationRecord = F3(
	function (key, message, count) {
		return {LY: count, yq: key, aeD: message};
	});
var $author$project$Api$Provider$PatientMerge$associationRecordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'count',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'message',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'key',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$AssociationRecord))));
var $author$project$Api$Provider$PatientMerge$associationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$associationRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$Attribute = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$AttributeRecord = F4(
	function (key, field, fromValue, toValue) {
		return {Pk: field, fH: fromValue, yq: key, g0: toValue};
	});
var $author$project$Api$Provider$PatientMerge$attributeRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_value',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_value',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'field',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'key',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$AttributeRecord)))));
var $author$project$Api$Provider$PatientMerge$attributeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$attributeRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$ExternalRecord = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$ExternalRecordRecord = F3(
	function (source, fromValue, toValue) {
		return {fH: fromValue, Hg: source, g0: toValue};
	});
var $author$project$Api$Provider$PatientMerge$externalRecordRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_value',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_value',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'source',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$ExternalRecordRecord))));
var $author$project$Api$Provider$PatientMerge$externalRecordDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$externalRecordRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$Integration = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$IntegrationRecord = F3(
	function (partner, fromValue, toValue) {
		return {fH: fromValue, Vz: partner, g0: toValue};
	});
var $author$project$Api$Provider$PatientMerge$integrationRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_value',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_value',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'partner',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$IntegrationRecord))));
var $author$project$Api$Provider$PatientMerge$integrationDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$integrationRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$PaymentOptions = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$PaymentOptionsRecord = F2(
	function (fromValue, toValue) {
		return {fH: fromValue, g0: toValue};
	});
var $author$project$Api$Provider$PatientMerge$PaymentSources = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMerge$PaymentSourcesRecord = F4(
	function (defaultSource, sources, stripeConnectId, cantKeep) {
		return {KH: cantKeep, Nl: defaultSource, _k: sources, _S: stripeConnectId};
	});
var $author$project$Api$Provider$PatientMerge$paymentSourcesRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'cant_keep',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'stripe_connect_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'sources',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'default_source',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$PaymentSourcesRecord)))));
var $author$project$Api$Provider$PatientMerge$paymentSourcesDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$paymentSourcesRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$paymentOptionsRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'to_value',
	$author$project$Api$Provider$PatientMerge$paymentSourcesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'from_value',
		$author$project$Api$Provider$PatientMerge$paymentSourcesDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$PaymentOptionsRecord)));
var $author$project$Api$Provider$PatientMerge$paymentOptionsDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$paymentOptionsRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$mergeRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'associations',
	$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$associationDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'integration_records',
		$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$integrationDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'external_records',
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$externalRecordDecoder),
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'payment_options',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$PatientMerge$paymentOptionsDecoder),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'attributes',
					$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$attributeDecoder),
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$MergeRecords))))));
var $author$project$Api$Provider$PatientMerge$mergeDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMerge$mergeRecordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMerge$resultDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['result']),
	$author$project$Api$Provider$PatientMerge$mergeDecoder);
var $author$project$Api$Provider$PatientMerge$postToPatientMerges = F6(
	function (apiClient, fromId, toId, isPreview, maybeOptions, toMsg) {
		var values = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						_Utils_Tuple2(
						'from_id',
						$elm$json$Json$Encode$string(fromId)),
						_Utils_Tuple2(
						'to_id',
						$elm$json$Json$Encode$string(toId)),
						_Utils_Tuple2(
						'preview',
						$elm$json$Json$Encode$bool(isPreview))
					]),
					function () {
					if (!maybeOptions.$) {
						var options = maybeOptions.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								'attributes',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.vw)),
								_Utils_Tuple2(
								'transfer_payment_options',
								$elm$json$Json$Encode$bool(options.$3)),
								_Utils_Tuple2(
								'integration_records',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.Q8)),
								_Utils_Tuple2(
								'external_records',
								A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.xx))
							]);
					} else {
						return _List_Nil;
					}
				}()
				]));
		var body = $elm$json$Json$Encode$object(values);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$PatientMerge$resultDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PatientMerge$patientMergesPath)));
	});
var $author$project$Api$Provider$PatientMerge$preview = F4(
	function (apiClient, fromId, toId, toMsg) {
		return A6($author$project$Api$Provider$PatientMerge$postToPatientMerges, apiClient, fromId, toId, true, $elm$core$Maybe$Nothing, toMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Merge$fetchPreview = F3(
	function (apiClient, fromId, toId) {
		return A4($author$project$Api$Provider$PatientMerge$preview, apiClient, fromId, toId, $author$project$Pages$Patients$PatientId_String$Merge$GotPreview);
	});
var $author$project$Api$Provider$PatientMerge$attributeField = function (_v0) {
	var record = _v0;
	return record.Pk;
};
var $author$project$Api$Provider$PatientMerge$attributeFromValue = function (_v0) {
	var record = _v0;
	return record.fH;
};
var $author$project$Api$Provider$PatientMerge$attributeKey = function (_v0) {
	var record = _v0;
	return record.yq;
};
var $author$project$Api$Provider$PatientMerge$attributeToValue = function (_v0) {
	var record = _v0;
	return record.g0;
};
var $author$project$Pages$Patients$PatientId_String$Merge$initAttributeRowModel = function (attribute) {
	var keep = function () {
		var _v0 = $author$project$Api$Provider$PatientMerge$attributeToValue(attribute);
		if (!_v0.$) {
			return 'toValue';
		} else {
			return 'fromValue';
		}
	}();
	return {
		aS: $author$project$Api$Provider$PatientMerge$attributeFromValue(attribute),
		az: $author$project$Api$Provider$PatientMerge$attributeToValue(attribute),
		Pk: $author$project$Api$Provider$PatientMerge$attributeField(attribute),
		t: keep,
		yq: $author$project$Api$Provider$PatientMerge$attributeKey(attribute)
	};
};
var $author$project$Api$Provider$PatientMerge$externalRecordFromValue = function (_v0) {
	var record = _v0;
	return record.fH;
};
var $author$project$Api$Provider$PatientMerge$externalRecordSource = function (_v0) {
	var record = _v0;
	return record.Hg;
};
var $author$project$Api$Provider$PatientMerge$externalRecordToValue = function (_v0) {
	var record = _v0;
	return record.g0;
};
var $author$project$Pages$Patients$PatientId_String$Merge$initExternalRecordRow = function (externalRecord) {
	var keep = function () {
		var _v0 = $author$project$Api$Provider$PatientMerge$externalRecordToValue(externalRecord);
		if (!_v0.$) {
			return 'toValue';
		} else {
			return 'fromValue';
		}
	}();
	return {
		aS: $author$project$Api$Provider$PatientMerge$externalRecordFromValue(externalRecord),
		az: $author$project$Api$Provider$PatientMerge$externalRecordToValue(externalRecord),
		t: keep,
		Hg: $author$project$Api$Provider$PatientMerge$externalRecordSource(externalRecord)
	};
};
var $author$project$Api$Provider$PatientMerge$integrationFromValue = function (_v0) {
	var record = _v0;
	return record.fH;
};
var $author$project$Api$Provider$PatientMerge$integrationPartner = function (_v0) {
	var record = _v0;
	return record.Vz;
};
var $author$project$Api$Provider$PatientMerge$integrationToValue = function (_v0) {
	var record = _v0;
	return record.g0;
};
var $author$project$Pages$Patients$PatientId_String$Merge$initIntegrationRow = function (integration) {
	var keep = function () {
		var _v0 = $author$project$Api$Provider$PatientMerge$integrationToValue(integration);
		if (!_v0.$) {
			return 'toValue';
		} else {
			return 'fromValue';
		}
	}();
	return {
		aS: $author$project$Api$Provider$PatientMerge$integrationFromValue(integration),
		az: $author$project$Api$Provider$PatientMerge$integrationToValue(integration),
		t: keep,
		Vz: $author$project$Api$Provider$PatientMerge$integrationPartner(integration)
	};
};
var $author$project$Api$Provider$PatientMerge$paymentOptionsFromValue = function (_v0) {
	var record = _v0;
	return record.fH;
};
var $author$project$Api$Provider$PatientMerge$paymentOptionsToValue = function (_v0) {
	var record = _v0;
	return record.g0;
};
var $author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId = function (_v0) {
	var record = _v0;
	return record._S;
};
var $author$project$Pages$Patients$PatientId_String$Merge$initPaymentMethodRowModel = function (mergePaymentOptions) {
	var toValueHasNoStripeId = $author$project$Utils$Maybe$isNothing(
		$author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId(
			$author$project$Api$Provider$PatientMerge$paymentOptionsToValue(mergePaymentOptions)));
	var toValue = $author$project$Api$Provider$PatientMerge$paymentOptionsToValue(mergePaymentOptions);
	var fromValue = $author$project$Api$Provider$PatientMerge$paymentOptionsFromValue(mergePaymentOptions);
	return {aS: fromValue, az: toValue, g1: toValueHasNoStripeId};
};
var $author$project$Api$Provider$PatientMerge$integrations = function (_v0) {
	var record = _v0;
	return record.Q8;
};
var $author$project$Pages$Patients$PatientId_String$Merge$PatientsMerged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$PatientMerge$merge = F5(
	function (apiClient, fromId, toId, options, toMsg) {
		return A6(
			$author$project$Api$Provider$PatientMerge$postToPatientMerges,
			apiClient,
			fromId,
			toId,
			false,
			$elm$core$Maybe$Just(options),
			toMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Merge$merge = function (model) {
	var toId = A2($elm$core$Maybe$withDefault, '', model.ce);
	var mergeOptions = {
		vw: A2(
			$elm$core$List$map,
			function (att) {
				return att.yq;
			},
			A2(
				$elm$core$List$filter,
				function (att) {
					return att.t === 'fromValue';
				},
				model.cc)),
		xx: A2(
			$elm$core$List$map,
			function (att) {
				return att.Hg;
			},
			A2(
				$elm$core$List$filter,
				function (att) {
					return att.t === 'fromValue';
				},
				model.cY)),
		Q8: A2(
			$elm$core$List$map,
			function (att) {
				return att.Vz;
			},
			A2(
				$elm$core$List$filter,
				function (att) {
					return att.t === 'fromValue';
				},
				model.cZ)),
		$3: A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (opt) {
					return opt.g1;
				},
				model.ed))
	};
	var fromId = $author$project$Api$Provider$Patient$One$id(model.VM);
	return A5($author$project$Api$Provider$PatientMerge$merge, model.D5, fromId, toId, mergeOptions, $author$project$Pages$Patients$PatientId_String$Merge$PatientsMerged);
};
var $author$project$Api$Provider$PatientMerge$paymentOptions = function (_v0) {
	var record = _v0;
	return record.V_;
};
var $author$project$Components$ResourceFilter$Patient$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Pages$Patients$PatientId_String$Merge$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.rU;
				if (!_v1.$) {
					var patientResourceFilter = _v1.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, model.D5, subMsg, patientResourceFilter);
					var _v2 = function () {
						var _v3 = patientResourceResult.ac5;
						if (!_v3.$) {
							if (!_v3.a.$) {
								return {
									xD: A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											A2(
												$author$project$Pages$Patients$PatientId_String$Merge$fetchPreview,
												model.D5,
												$author$project$Api$Provider$Patient$One$id(model.VM)),
											$author$project$Components$ResourceFilter$Patient$value(patientResourceResult.y8))),
									S_: true,
									by: $elm$core$Maybe$Nothing,
									B4: $author$project$Components$ResourceFilter$Patient$value(patientResourceResult.y8)
								};
							} else {
								var _v4 = _v3.a;
								return {xD: $elm$core$Platform$Cmd$none, S_: model.aa, by: model.by, B4: model.ce};
							}
						} else {
							return {xD: $elm$core$Platform$Cmd$none, S_: model.aa, by: model.by, B4: model.ce};
						}
					}();
					var selectedPatientId = _v2.B4;
					var loading = _v2.S_;
					var previewError = _v2.by;
					var fetchMergeCmd = _v2.xD;
					var commands = _List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg, patientResourceResult.EC),
							fetchMergeCmd
						]);
					var newModel = _Utils_update(
						model,
						{
							aa: loading,
							ce: selectedPatientId,
							rU: $elm$core$Maybe$Just(patientResourceResult.y8),
							by: previewError
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(commands),
						patientResourceResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var response = msg.a;
				_v5$2:
				while (true) {
					switch (response.$) {
						case 3:
							var data = response.a;
							var paymentMethodRowModel = A2(
								$elm$core$Maybe$map,
								$author$project$Pages$Patients$PatientId_String$Merge$initPaymentMethodRowModel,
								$author$project$Api$Provider$PatientMerge$paymentOptions(data));
							var integrationModels = A2(
								$elm$core$List$map,
								$author$project$Pages$Patients$PatientId_String$Merge$initIntegrationRow,
								$author$project$Api$Provider$PatientMerge$integrations(data));
							var externalRecordModels = A2(
								$elm$core$List$map,
								$author$project$Pages$Patients$PatientId_String$Merge$initExternalRecordRow,
								$author$project$Api$Provider$PatientMerge$externalRecords(data));
							var attributeRowModels = A2(
								$elm$core$List$map,
								$author$project$Pages$Patients$PatientId_String$Merge$initAttributeRowModel,
								$author$project$Api$Provider$PatientMerge$attributes(data));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aa: false,
										m3: $author$project$Api$Provider$PatientMerge$associations(data),
										cc: attributeRowModels,
										cY: externalRecordModels,
										cZ: integrationModels,
										ed: paymentMethodRowModel
									}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 2:
							if (response.a.$ === 6) {
								var _v6 = response.a;
								var status = _v6.a;
								var errorMsg = _v6.b;
								var baseError = 'We are not able to automatically merge into the selected patient, ';
								var previewError = (status === 406) ? _Utils_ap(baseError, errorMsg) : (baseError + 'please contact Customer Support to get further assistance.');
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											aa: false,
											m3: _List_Nil,
											cc: _List_Nil,
											cY: _List_Nil,
											cZ: _List_Nil,
											ed: $elm$core$Maybe$Nothing,
											by: $elm$core$Maybe$Just(previewError)
										}),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								break _v5$2;
							}
						default:
							break _v5$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aa: false, m3: _List_Nil, cc: _List_Nil, cY: _List_Nil, cZ: _List_Nil, ed: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 2:
				var idx = msg.a;
				var option = msg.b;
				var _v7 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.cc);
				if (!_v7.$) {
					var attributesRow = _v7.a;
					var newList = A3(
						$elm_community$list_extra$List$Extra$setAt,
						idx,
						_Utils_update(
							attributesRow,
							{t: option}),
						model.cc);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cc: newList}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var option = msg.a;
				var newModel = function () {
					var _v8 = model.ed;
					if (!_v8.$) {
						var paymentOptions = _v8.a;
						return _Utils_update(
							model,
							{
								ed: $elm$core$Maybe$Just(
									_Utils_update(
										paymentOptions,
										{g1: option === 'fromValue'}))
							});
					} else {
						return model;
					}
				}();
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
			case 4:
				var idx = msg.a;
				var option = msg.b;
				var _v9 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.cY);
				if (!_v9.$) {
					var recordRow = _v9.a;
					var newList = A3(
						$elm_community$list_extra$List$Extra$setAt,
						idx,
						_Utils_update(
							recordRow,
							{t: option}),
						model.cY);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cY: newList}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				var idx = msg.a;
				var option = msg.b;
				var _v10 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.cZ);
				if (!_v10.$) {
					var integrationRow = _v10.a;
					var newList = A3(
						$elm_community$list_extra$List$Extra$setAt,
						idx,
						_Utils_update(
							integrationRow,
							{t: option}),
						model.cZ);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cZ: newList}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hS: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 7:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{hS: false}),
					$author$project$Pages$Patients$PatientId_String$Merge$merge(model),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{hS: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2(
								$author$project$Utils$Route$navigate,
								$elm$core$Dict$empty,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
									{
										VN: A2($elm$core$Maybe$withDefault, '', model.ce)
									})),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Patients merged.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalOpened = {$: 6};
var $author$project$Pages$Patients$PatientId_String$Merge$mergeDisabled = function (model) {
	return $author$project$Utils$Maybe$isNothing(model.ce) || model.aa;
};
var $author$project$Api$Provider$PatientMerge$associationKey = function (_v0) {
	var record = _v0;
	return record.yq;
};
var $author$project$Pages$Patients$PatientId_String$Merge$showAssociation = function (association) {
	var visibleAssociations = _List_fromArray(
		['note', 'membership', 'credit', 'company_account', 'invoices', 'phone']);
	return A2(
		$elm$core$List$member,
		$author$project$Api$Provider$PatientMerge$associationKey(association),
		visibleAssociations);
};
var $author$project$Api$Provider$PatientMerge$associationCount = function (_v0) {
	var record = _v0;
	return record.LY;
};
var $author$project$Api$Provider$PatientMerge$associationMessage = function (_v0) {
	var record = _v0;
	return record.aeD;
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewAssociation = function (association) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = $author$project$Api$Provider$PatientMerge$associationCount(association);
				if (!_v0.$) {
					var count = _v0.a;
					return A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(count))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Utils$Html$noBreakSpace,
				A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Provider$PatientMerge$associationMessage(association))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewAssociations = function (_v0) {
	var loadingPreview = _v0.aa;
	var mergeAssociations = _v0.m3;
	var shownAssociations = A2($elm$core$List$filter, $author$project$Pages$Patients$PatientId_String$Merge$showAssociation, mergeAssociations);
	return (loadingPreview || $elm$core$List$isEmpty(shownAssociations)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Associated Changes')
					])),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Merge$viewAssociation, shownAssociations))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForAttribute = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Merge$keepOptions = function (_v0) {
	var disableA = _v0.a;
	var disableB = _v0.b;
	return _List_fromArray(
		[
			A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(disableA)
				]),
			$elm$core$Maybe$Just('fromValue'),
			'Keep Option A'),
			A3(
			$author$project$Ui$Form$Select$option,
			_List_fromArray(
				[
					$author$project$Ui$Form$Select$itemDisabled(disableB)
				]),
			$elm$core$Maybe$Just('toValue'),
			'Keep Option B')
		]);
};
var $author$project$Pages$Patients$PatientId_String$Merge$cellStyle = function (selected) {
	return selected ? _List_fromArray(
		[
			$elm$html$Html$Attributes$class('text-success')
		]) : _List_fromArray(
		[
			$elm$html$Html$Attributes$class('text-danger'),
			$elm$html$Html$Attributes$class('text-strike')
		]);
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewHtml = function (string) {
	var _v0 = $hecrj$html_parser$Html$Parser$run(string);
	if (!_v0.$) {
		var html = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			$hecrj$html_parser$Html$Parser$Util$toVirtualDom(html));
	} else {
		return $elm$html$Html$text(string);
	}
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell = F3(
	function (selectedOption, key, value) {
		var actualValue = function () {
			if (!value.$) {
				var str = value.a;
				return (key === 'address') ? $author$project$Pages$Patients$PatientId_String$Merge$viewHtml(str) : $elm$html$Html$text(str);
			} else {
				return $elm$html$Html$text('[Blank]');
			}
		}();
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(selectedOption),
					_List_fromArray(
						[actualValue]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeRow = F2(
	function (idx, rowModel) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(rowModel.Pk)
								]))
						])),
					A3($author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell, rowModel.t === 'fromValue', rowModel.yq, rowModel.aS),
					A3($author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell, rowModel.t === 'toValue', rowModel.yq, rowModel.az),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(rowModel.t)),
									$author$project$Ui$Form$Select$onChange(
									$author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForAttribute(idx))
								]),
							$author$project$Pages$Patients$PatientId_String$Merge$keepOptions(
								_Utils_Tuple2(false, false)))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributesTable = function (_v0) {
	var mergeAttributes = _v0.cc;
	var loadingPreview = _v0.aa;
	return (loadingPreview || $elm$core$List$isEmpty(mergeAttributes)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Field')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option A')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option B')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]),
				A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeRow, mergeAttributes),
				_List_Nil)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForExternalRecord = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordRow = F2(
	function (idx, model) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(model.Hg)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.t === 'fromValue'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '[Blank]', model.aS))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.t === 'toValue'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '[Blank]', model.az))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(model.t)),
									$author$project$Ui$Form$Select$onChange(
									$author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForExternalRecord(idx))
								]),
							$author$project$Pages$Patients$PatientId_String$Merge$keepOptions(
								_Utils_Tuple2(false, false)))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordsTable = function (_v0) {
	var loadingPreview = _v0.aa;
	var mergeExternalRecords = _v0.cY;
	return (loadingPreview || $elm$core$List$isEmpty(mergeExternalRecords)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('External Records')
					])),
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Service')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option A')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option B')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]),
				A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordRow, mergeExternalRecords),
				_List_Nil)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForIntegration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationRow = F2(
	function (idx, model) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(model.Vz)
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.t === 'fromValue'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '[Blank]', model.aS))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.t === 'toValue'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '[Blank]', model.az))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(model.t)),
									$author$project$Ui$Form$Select$onChange(
									$author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForIntegration(idx))
								]),
							$author$project$Pages$Patients$PatientId_String$Merge$keepOptions(
								_Utils_Tuple2(false, false)))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationsTable = function (_v0) {
	var loadingPreview = _v0.aa;
	var mergeIntegrations = _v0.cZ;
	return (loadingPreview || $elm$core$List$isEmpty(mergeIntegrations)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Integrations')
					])),
				A4(
				$author$project$Ui$Table$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Service')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option A')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Option B')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]),
				A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationRow, mergeIntegrations),
				_List_Nil)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewMergeConfirmModal = function (model) {
	return model.hS ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('merge'),
				$author$project$Components$HiConfirm$noun('patient record'),
				$author$project$Components$HiConfirm$detail(
				$author$project$Api$Provider$Patient$One$id(model.VM) + (' into patient record ' + A2($elm$core$Maybe$withDefault, '', model.ce)))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForPaymentMethod = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep = function (_v0) {
	var record = _v0;
	return record.KH;
};
var $author$project$Api$Provider$PatientMerge$paymentSourcesDefaultSource = function (_v0) {
	var record = _v0;
	return record.Nl;
};
var $author$project$Api$Provider$PatientMerge$paymentSourcesSources = function (_v0) {
	var record = _v0;
	return record._k;
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption = F2(
	function (paymentSource, selectedOption) {
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					$author$project$Pages$Patients$PatientId_String$Merge$cellStyle(selectedOption),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Stripe ID:')
										])),
									$elm$html$Html$text(
									' ' + A2(
										$elm$core$Maybe$withDefault,
										'[Blank]',
										$author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId(paymentSource)))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Default Source:')
										])),
									$elm$html$Html$text(
									' ' + A2(
										$elm$core$Maybe$withDefault,
										' [Blank]',
										$author$project$Api$Provider$PatientMerge$paymentSourcesDefaultSource(paymentSource)))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Payment Sources:')
										])),
									$elm$core$List$isEmpty(
									$author$project$Api$Provider$PatientMerge$paymentSourcesSources(paymentSource)) ? $elm$html$Html$text(' None') : A2(
									$elm$html$Html$ul,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (source) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(source)
													]));
										},
										$author$project$Api$Provider$PatientMerge$paymentSourcesSources(paymentSource)))
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOptionsTable = function (_v0) {
	var loadingPreview = _v0.aa;
	var mergePaymentOptions = _v0.ed;
	if (loadingPreview) {
		return $author$project$Utils$Html$empty;
	} else {
		if (mergePaymentOptions.$ === 1) {
			return $author$project$Utils$Html$empty;
		} else {
			var paymentOptions = mergePaymentOptions.a;
			var keepOption = paymentOptions.g1 ? 'fromValue' : 'toValue';
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Payment options')
							])),
						A4(
						$author$project$Ui$Table$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Option A')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Option B')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('')
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$row,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption, paymentOptions.aS, paymentOptions.g1),
										A2($author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption, paymentOptions.az, !paymentOptions.g1),
										A2(
										$author$project$Ui$Table$cell,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Select$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Select$value(
														$elm$core$Maybe$Just(keepOption)),
														$author$project$Ui$Form$Select$onChange($author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForPaymentMethod)
													]),
												$author$project$Pages$Patients$PatientId_String$Merge$keepOptions(
													_Utils_Tuple2(
														$author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep(paymentOptions.aS),
														$author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep(paymentOptions.az))))
											]))
									]))
							]),
						_List_Nil),
						(paymentOptions.g1 && $author$project$Utils$Maybe$toBool(
						$author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId(paymentOptions.az))) ? A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Migrating payment options will override the current payment options on the destination patient. This will prevent refunds of old payments that used the discarded options.')
							])) : $author$project$Utils$Html$empty
					]));
		}
	}
};
var $author$project$Pages$Patients$PatientId_String$Merge$conflictsPresent = function (_v0) {
	var mergeAttributes = _v0.cc;
	return !$elm$core$List$isEmpty(mergeAttributes);
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewPatientOptions = function (patientResourceFilter) {
	if (!patientResourceFilter.$) {
		var dependentResourceFilter = patientResourceFilter.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-group')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Patient$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						dependentResourceFilter))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Merge$viewTopSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{
								VN: $author$project$Api$Provider$Patient$One$id(model.VM)
							}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Patient')
							])),
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[$author$project$Ui$Typography$gray]),
						_List_fromArray(
							[
								$elm$html$Html$text('  /  Merge ')
							]))
					])),
				$author$project$Ui$HorizontalRule$view(
				_List_fromArray(
					[$author$project$Ui$HorizontalRule$thin])),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Merge Duplicate Patients')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-body-sm text-muted')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('We will attempt to merge all the information we can, including Demographics, Notes, Payment Options, Invoices, Memberships, and Employment Info. After merging, this patient record will automatically be archived.')
					])),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Merge this patient record ')
					])),
				$elm$html$Html$text(
				$author$project$Api$Provider$Patient$One$id(model.VM)),
				A2(
				$elm$html$Html$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' with ')
					])),
				function () {
				var _v0 = model.ce;
				if (!_v0.$) {
					var id = _v0.a;
					return $elm$html$Html$text(id);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Pages$Patients$PatientId_String$Merge$viewPatientOptions(model.rU),
				function () {
				var _v1 = model.by;
				if (!_v1.$) {
					var error = _v1.a;
					return A2(
						$author$project$Ui$Alert$danger,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(error)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				model.aa ? A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('Resolve differences')
									]))
							])),
						A4(
						$author$project$Ui$Table$view,
						_List_fromArray(
							[
								$author$project$Ui$Table$loading(true)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Field')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Option A')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Option B')
									])),
								A2(
								$author$project$Ui$Table$header,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('')
									]))
							]),
						_List_Nil,
						_List_Nil)
					])) : ($author$project$Pages$Patients$PatientId_String$Merge$conflictsPresent(model) ? $author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Resolve differences')
					])) : $author$project$Utils$Html$empty)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Merge$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$Patients$PatientId_String$Merge$viewMergeConfirmModal(model),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Merge$viewTopSection(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewAttributesTable(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOptionsTable(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordsTable(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationsTable(model),
								$author$project$Pages$Patients$PatientId_String$Merge$viewAssociations(model),
								($author$project$Utils$Maybe$toBool(model.ce) && ((!model.aa) && $author$project$Utils$Maybe$isNothing(model.by))) ? A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('All other fields will be unchanged on the destination patient.')
									])) : $author$project$Utils$Html$empty
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit(
									{
										VN: $author$project$Api$Provider$Patient$One$id(model.VM)
									}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Cancel')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Merge patients'},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$disabled(
										$author$project$Pages$Patients$PatientId_String$Merge$mergeDisabled(model)),
										$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalOpened)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Merge')
									]))
							]))
					]))
			]),
		$G: 'Patient | Merge'
	};
};
var $author$project$Pages$Patients$PatientId_String$Merge$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Merge$init, aer: $author$project$Pages$Patients$PatientId_String$Merge$load, agD: $author$project$Pages$Patients$PatientId_String$Merge$save, ahd: $author$project$Pages$Patients$PatientId_String$Merge$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Merge$update, ahP: $author$project$Pages$Patients$PatientId_String$Merge$view});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$NotesMsg = $elm$core$Basics$identity;
var $author$project$Api$Provider$Note$Patient = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Notes$Top$init = F5(
	function (session, _v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var params = _v2.Vx;
		var _v3 = A6(
			$author$project$Components$Notes$init,
			shared.D5,
			shared.Hy,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
				{VN: params.VN}),
			query,
			$author$project$Api$Provider$Note$Patient(params.VN),
			$author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
		var notes = _v3.a;
		var notesCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: notes},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Notes$subscriptions(model.rh));
};
var $author$project$Pages$Patients$PatientId_String$Notes$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Notes$update, model.D5, subMsg, model.rh);
		var notes = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: notes}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Notes$Top$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Notes$view(model.rh)),
		$G: 'Patient | Notes'
	};
};
var $author$project$Pages$Patients$PatientId_String$Notes$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Notes$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Notes$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Notes$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Notes$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Notes$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Notes$Top$view});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotEmailAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$EmailAddress$One$EmailAddress = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmailAddress$One$Record = F6(
	function (id, email, portalEnabled, isBounced, isRejected, isUnsubscribed) {
		return {Oo: email, adR: id, Rz: isBounced, R5: isRejected, Sd: isUnsubscribed, Wy: portalEnabled};
	});
var $author$project$Api$Provider$EmailAddress$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_unsubscribed',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_rejected',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_bounced',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'portal_enabled',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'email',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmailAddress$One$Record)))))));
var $author$project$Api$Provider$EmailAddress$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmailAddress$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$EmailAddress$emailAddressPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['email_address']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[patientId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['patients']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$EmailAddress$retrieve = F3(
	function (apiClient, emailAddressId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$EmailAddress$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$EmailAddress$emailAddressPath(emailAddressId)));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchEmailAddress = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$EmailAddress$retrieve, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotEmailAddress);
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotPatientNotifications = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Notification$All$Notification = $elm$core$Basics$identity;
var $author$project$Api$Provider$Notification$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Notification$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Notification$listDefaults = {afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init};
var $author$project$Api$Provider$Notification$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Notification$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Notification$recipientNotificationsPath = function (recipient) {
	if (!recipient.$) {
		var patientId = recipient.a;
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['notifications']),
			$author$project$Api$Provider$Patient$patientPath(patientId));
	} else {
		var companyId = recipient.a;
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['notifications']),
			$author$project$Api$Provider$Company$companyPath(companyId));
	}
};
var $author$project$Api$Provider$Notification$list = F4(
	function (apiClient, recipient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Notification$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Notification$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Notification$recipientNotificationsPath(recipient))));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList = function (model) {
	return A4(
		$author$project$Api$Provider$Notification$list,
		model.D5,
		$author$project$Api$Provider$Notification$Patient(
			$author$project$Api$Provider$Patient$One$id(model.VM)),
		function (d) {
			return _Utils_update(
				d,
				{afy: model.afy, ag1: model.ag1});
		},
		$author$project$Pages$Patients$PatientId_String$Notifications$Top$GotPatientNotifications);
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$init = F5(
	function (_v0, practice, patient, _v1, _v2) {
		var timeFormatter = _v1.Hy;
		var apiClient = _v1.D5;
		var query = _v2.Bi;
		var model = {
			D5: apiClient,
			Ej: false,
			qp: $elm$core$Maybe$Nothing,
			rB: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			VM: patient,
			WF: practice,
			ag1: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
			Hy: timeFormatter
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList(model),
						A2(
						$author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchEmailAddress,
						apiClient,
						$author$project$Api$Provider$Patient$One$id(patient))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$updateUrl = function (model) {
	var baseRoute = $author$project$Spa$Generated$Route$toString(
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top(
			{
				VN: $author$project$Api$Provider$Patient$One$id(model.VM)
			}));
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[baseRoute]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				$author$project$Api$Sort$toQuery(model.ag1))));
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								rB: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList(newModel),
								$author$project$Pages$Patients$PatientId_String$Notifications$Top$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var emailAddress = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									qp: $elm$core$Maybe$Just(emailAddress)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						if (error.$ === 5) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{qp: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						} else {
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(response));
						}
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$PaginationMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Icon$Warning = 35;
var $author$project$Api$Provider$EmailAddress$One$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$EmailAddress$One$isBounced = function (_v0) {
	var record = _v0;
	return record.Rz;
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewBouncedEmailAlert = F2(
	function (emailAddress, bouncedEmailReset) {
		var _v0 = _Utils_Tuple2(
			bouncedEmailReset,
			$author$project$Api$Provider$EmailAddress$One$isBounced(emailAddress));
		if ((!_v0.a) && _v0.b) {
			return A2(
				$author$project$Ui$Alert$warning,
				_List_fromArray(
					[
						$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$itemsCenter),
						$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$spaceBetween)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 35),
								$elm$html$Html$text(
								' Emails to ' + ($author$project$Api$Provider$EmailAddress$One$email(emailAddress) + ' have bounced.'))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotificationSkeleton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('mm/dd/yyyy at l:%MM %pp')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Sent notification to email')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Patient clicked notification at: Uknown')
						]))
				])),
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$textSm]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Patient opened notification at: Uknown')
						]))
				]))
		]));
var $author$project$Api$Provider$Notification$Shared$attemptedAt = function (_v0) {
	var record = _v0;
	return record.Jv;
};
var $author$project$Api$Provider$Notification$One$attemptedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$attemptedAt(shared);
};
var $author$project$Api$Provider$Notification$All$attemptedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$attemptedAt(one);
};
var $author$project$Api$Provider$Notification$Shared$clickedAt = function (_v0) {
	var record = _v0;
	return record.K0;
};
var $author$project$Api$Provider$Notification$One$clickedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$clickedAt(shared);
};
var $author$project$Api$Provider$Notification$All$clickedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$clickedAt(one);
};
var $author$project$Api$Provider$Notification$Shared$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$Notification$One$errorMessage = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$errorMessage(shared);
};
var $author$project$Api$Provider$Notification$All$errorMessage = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$errorMessage(one);
};
var $author$project$Api$Provider$Notification$Shared$failedAt = function (_v0) {
	var record = _v0;
	return record.O5;
};
var $author$project$Api$Provider$Notification$One$failedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$failedAt(shared);
};
var $author$project$Api$Provider$Notification$All$failedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$failedAt(one);
};
var $author$project$Api$Provider$Notification$Shared$openedAt = function (_v0) {
	var record = _v0;
	return record.Va;
};
var $author$project$Api$Provider$Notification$One$openedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$openedAt(shared);
};
var $author$project$Api$Provider$Notification$All$openedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$openedAt(one);
};
var $author$project$Utils$Maybe$orElse = F2(
	function (elseMaybe, maybe) {
		if (!maybe.$) {
			return maybe;
		} else {
			return elseMaybe;
		}
	});
var $author$project$Api$Provider$Notification$Shared$recipientEmail = function (_v0) {
	var record = _v0;
	return record.XV;
};
var $author$project$Api$Provider$Notification$One$recipientEmail = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$recipientEmail(shared);
};
var $author$project$Api$Provider$Notification$All$recipientEmail = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$recipientEmail(one);
};
var $author$project$Api$Provider$Notification$Shared$shortDescription = function (_v0) {
	var record = _v0;
	return record.ZL;
};
var $author$project$Api$Provider$Notification$One$shortDescription = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Notification$Shared$shortDescription(shared);
};
var $author$project$Api$Provider$Notification$All$shortDescription = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$shortDescription(one);
};
var $author$project$Api$Provider$Notification$One$shortDescriptionHtml = function (_v0) {
	var record = _v0.b;
	return record.ZM;
};
var $author$project$Api$Provider$Notification$All$shortDescriptionHtml = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$shortDescriptionHtml(one);
};
var $author$project$Api$Provider$Notification$All$subjectHtml = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$Notification$One$subjectHtml(one);
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotification = F2(
	function (timeFormatter, notification) {
		var description = (A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$Notification$All$shortDescription(notification)) === 'Custom Message') ? $author$project$Api$Provider$Notification$All$subjectHtml(notification) : $author$project$Api$Provider$Notification$All$shortDescriptionHtml(notification);
		var attemptedOrFailedAt = A2(
			$author$project$Utils$Maybe$orElse,
			$author$project$Api$Provider$Notification$All$failedAt(notification),
			$author$project$Api$Provider$Notification$All$attemptedAt(notification));
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[$author$project$Ui$ListGroup$clearfix, $author$project$Ui$ListGroup$note]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							if (!attemptedOrFailedAt.$) {
								var dateTime = attemptedOrFailedAt.a;
								return $elm$html$Html$text(
									A2(timeFormatter, 0, dateTime));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v1 = $author$project$Api$Provider$Notification$All$failedAt(notification);
							if (!_v1.$) {
								return A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Attempted to send')
										]));
							} else {
								return A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Sent')
										]));
							}
						}(),
							$author$project$Utils$Html$noBreakSpace,
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', description))
								])),
							$author$project$Utils$Html$noBreakSpace,
							function () {
							var _v2 = $author$project$Api$Provider$Notification$All$recipientEmail(notification);
							if (!_v2.$) {
								var email = _v2.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Api$Phi$text(
											$author$project$Api$Phi$from('to ' + email))
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						])),
					function () {
					var _v3 = $author$project$Api$Provider$Notification$All$failedAt(notification);
					if (!_v3.$) {
						return A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, 'failed'),
									$author$project$Utils$Html$noBreakSpace,
									$author$project$Utils$FormErrors$viewError(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Notification$All$errorMessage(notification)))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$noBreakSpace, $author$project$Utils$Html$noBreakSpace])),
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Patient clicked notification at:')
								])),
							$author$project$Utils$Html$noBreakSpace,
							function () {
							var _v4 = $author$project$Api$Provider$Notification$All$clickedAt(notification);
							if (!_v4.$) {
								var dateTime = _v4.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(timeFormatter, 4, dateTime))
										]));
							} else {
								return A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Never')
										]));
							}
						}()
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[$author$project$Utils$Html$noBreakSpace, $author$project$Utils$Html$noBreakSpace])),
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Patient opened notification at:')
								])),
							$author$project$Utils$Html$noBreakSpace,
							function () {
							var _v5 = $author$project$Api$Provider$Notification$All$openedAt(notification);
							if (!_v5.$) {
								var dateTime = _v5.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(timeFormatter, 4, dateTime))
										]));
							} else {
								return A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Unknown')
										]));
							}
						}()
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotifications = F2(
	function (notifications, timeFormatter) {
		return A2(
			$author$project$Ui$ListGroup$view,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotification(timeFormatter),
				notifications));
	});
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$view = function (_v0) {
	var notifications = _v0.rB;
	var timeFormatter = _v0.Hy;
	var pagination = _v0.afy;
	var bouncedEmailReset = _v0.Ej;
	var emailAddress = _v0.qp;
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Notifications')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								if (!emailAddress.$) {
									var emailAddress_ = emailAddress.a;
									return A2($author$project$Pages$Patients$PatientId_String$Notifications$Top$viewBouncedEmailAlert, emailAddress_, bouncedEmailReset);
								} else {
									return $elm$html$Html$text('');
								}
							}(),
								function () {
								if (notifications.$ === 3) {
									var notifications_ = notifications.a;
									return $elm$core$List$isEmpty(notifications_) ? A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('This patient has no notifications.')
											])) : A2($author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotifications, notifications_, timeFormatter);
								} else {
									return A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2($elm$core$List$repeat, 10, $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotificationSkeleton));
								}
							}(),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Patients$PatientId_String$Notifications$Top$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(notifications))
										]),
									pagination))
							]))
					]))
			]),
		$G: 'Patient | Notifications'
	};
};
var $author$project$Pages$Patients$PatientId_String$Notifications$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Notifications$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Notifications$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Notifications$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Notifications$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Notifications$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Notifications$Top$view});
var $author$project$Pages$Patients$PatientId_String$Top$PopoverMsg = function (a) {
	return {$: 61, a: a};
};
var $author$project$Api$Provider$Patient$One$accountAccessSentAt = function (_v0) {
	var record = _v0.b;
	return record.H4;
};
var $author$project$Pages$Patients$PatientId_String$Top$GotEmailAddress = function (a) {
	return {$: 64, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$EmailAddress$retrieve, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotEmailAddress);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotIntegrationRecords = function (a) {
	return {$: 23, a: a};
};
var $author$project$Api$Provider$Patient$integrationRecords = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['integration_records']),
					$author$project$Api$Provider$Patient$patientPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$integrationRecords, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotIntegrationRecords);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotMembershipPatients = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$MembershipPatient = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$Record = F7(
	function (billedThroughDate, nextBillDate, nextInvoiceDueDate, isSponsored, owner, company, plan) {
		return {JY: billedThroughDate, ab9: company, R7: isSponsored, UC: nextBillDate, UG: nextInvoiceDueDate, Vp: owner, GH: plan};
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Plan$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'company',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'owner',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_sponsored',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'next_invoice_due_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'next_bill_date',
						$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'billed_through_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientOne$Record))))))));
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$MembershipPatient$ForPatientOne$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$MembershipPatient$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientOne$MembershipPatient)));
var $author$project$Api$Provider$Patient$MembershipPatient$membershipPatientsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['membership_patients']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$MembershipPatient$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForPatientOne$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$MembershipPatient$membershipPatientsPath(patientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchMembershipPatients = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$MembershipPatient$list, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotMembershipPatients);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotOutdatedDocuments = function (a) {
	return {$: 32, a: a};
};
var $author$project$Api$Provider$PatientDocument$All$PatientDocument = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientDocument$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientDocument$One$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$PatientDocument$outdatedDocumentsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['outdated_signed_documents']),
		$author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId));
};
var $author$project$Api$Provider$Patient$PatientDocument$listOutdated = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientDocument$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$PatientDocument$outdatedDocumentsPath(patientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchOutdatedPatientDocuments = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$PatientDocument$listOutdated, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotOutdatedDocuments);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotPackages = function (a) {
	return {$: 69, a: a};
};
var $author$project$Api$Provider$PatientPackage$patientPackagesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['patient_packages']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$PatientPackage$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$PatientPackage$All$listDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				_List_fromArray(
					[
						A2($author$project$Api$Param$string, 'patient_id', patientId)
					]),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$PatientPackage$patientPackagesPath)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchPackages = F2(
	function (apiClient, patientIdent) {
		return A3($author$project$Api$Provider$PatientPackage$list, apiClient, patientIdent, $author$project$Pages$Patients$PatientId_String$Top$GotPackages);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotDocuments = function (a) {
	return {$: 34, a: a};
};
var $author$project$Api$Provider$Patient$PatientDocument$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientDocument$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchPatientDocuments = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$PatientDocument$list, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotDocuments);
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotPatientMceEligibilities = function (a) {
	return {$: 53, a: a};
};
var $author$project$Api$Provider$PatientMceEligibility$All$PatientMceEligibility = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMceEligibility$Shared$PatientMceEligibility = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientMceEligibility$Shared$Record = F4(
	function (id, name, status, message) {
		return {adR: id, aeD: message, zh: name, ag7: status};
	});
var $author$project$Api$Provider$PatientMceEligibility$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMceEligibility$Shared$Record)))));
var $author$project$Api$Provider$PatientMceEligibility$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMceEligibility$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientMceEligibility$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientMceEligibility$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$MceEligibility$mceEligibilitiesPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['patient_mce_eligibilities']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$MceEligibility$list = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientMceEligibility$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$Patient$MceEligibility$mceEligibilitiesPath(patientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$fetchPatientMceEligibility = F3(
	function (client, practice, patientId) {
		return $elm$core$List$isEmpty(
			$author$project$Api$Provider$Practice$One$addons(practice)) ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Provider$Patient$MceEligibility$list, client, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotPatientMceEligibilities);
	});
var $author$project$Api$Provider$Patient$One$integrations = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Ra;
	});
var $author$project$Api$Provider$Patient$One$lastPortalAccessedAt = function (_v0) {
	var record = _v0.b;
	return record.SC;
};
var $author$project$Api$Provider$Patient$One$requestPendingDocumentsAcceptanceSentAt = function (_v0) {
	var record = _v0.b;
	return record.Yi;
};
var $author$project$Api$Provider$SyncDetail$CoveragePlan = 1;
var $author$project$Pages$Patients$PatientId_String$Top$GotAffiliateSyncDetail = function (a) {
	return {$: 65, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$retrieveSyncDetails = F2(
	function (apiClient, patientId) {
		return A4(
			$author$project$Api$Provider$SyncDetail$retrieveAffiliate,
			apiClient,
			patientId,
			function (d) {
				return _Utils_update(
					d,
					{
						Fc: _List_fromArray(
							[0, 1])
					});
			},
			$author$project$Pages$Patients$PatientId_String$Top$GotAffiliateSyncDetail);
	});
var $author$project$Pages$Patients$PatientId_String$Top$init = F5(
	function (session, practice, patient, shared, _v0) {
		return _Utils_Tuple2(
			{
				kN: false,
				H4: $author$project$Api$Provider$Patient$One$accountAccessSentAt(patient),
				hk: $elm$core$Maybe$Nothing,
				$7: $elm$core$Maybe$Nothing,
				hn: $elm$core$Set$empty,
				u7: $author$project$Api$Data$Loading,
				D5: shared.D5,
				hy: A7(
					$author$project$Components$AuditTrailLog$init,
					session,
					shared.aav,
					shared.Hy,
					$elm$core$Maybe$Just('patient'),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Patient$One$id(patient)),
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$Patient$One$createdAt(patient)),
					$elm$core$Maybe$Nothing),
				Ej: false,
				L5: $elm$core$Maybe$Nothing,
				L7: $author$project$Api$Data$NotAsked,
				hX: $elm$core$Maybe$Nothing,
				cO: shared.cO,
				p5: $elm$core$Maybe$Nothing,
				ii: false,
				ir: $elm$core$Maybe$Nothing,
				fz: $elm$core$Maybe$Nothing,
				qp: $author$project$Api$Data$NotAsked,
				Fa: $author$project$Api$Data$NotAsked,
				mk: false,
				adM: shared.adM,
				adN: shared.adN,
				qY: A2(
					$elm$core$List$map,
					function (_v1) {
						return false;
					},
					$author$project$Api$Provider$Patient$One$integrations(patient)),
				fM: _List_Nil,
				Q8: $author$project$Api$Data$NotAsked,
				FR: $author$project$Shared$isHintAdmin(shared),
				SC: $author$project$Api$Provider$Patient$One$lastPortalAccessedAt(patient),
				i5: $elm$core$Maybe$Nothing,
				i9: $elm$core$Set$empty,
				m1: $elm$core$List$isEmpty(
					$author$project$Api$Provider$Practice$One$addons(practice)) ? $author$project$Api$Data$NotAsked : $author$project$Api$Data$Loading,
				ja: $author$project$Api$Data$NotAsked,
				m2: false,
				TF: $author$project$Api$Data$Loading,
				Up: $elm$core$Maybe$Nothing,
				rN: false,
				rO: $author$project$Api$Data$Loading,
				c4: $author$project$Components$Patient$PackageDetailsModal$init,
				z4: $author$project$Api$Data$Loading,
				VM: patient,
				nk: $author$project$Api$Data$Loading,
				Ao: $author$project$Api$Provider$Patient$One$requestPayInfoSentAt(patient),
				rT: $author$project$Api$Provider$Patient$One$requestPendingDocumentsAcceptanceSentAt(patient),
				AR: $author$project$Api$Data$NotAsked,
				aM: A3($author$project$Ui$Popover$init, 'engagement', false, $author$project$Pages$Patients$PatientId_String$Top$PopoverMsg),
				WF: practice,
				nX: false,
				da: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
				jT: false,
				ob: false,
				j2: false,
				j3: false,
				ZD: session,
				sR: false,
				or: false,
				gR: $author$project$Api$Provider$Patient$One$companyAccounts(patient),
				Hy: A2($author$project$Formatters$Time$init, shared.Hz, shared.ack),
				DE: A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, $author$project$Components$PatientsList$urlParams, shared.afE))
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchMembershipPatients,
						shared.D5,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords,
						shared.D5,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchPatientDocuments,
						shared.D5,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchOutdatedPatientDocuments,
						shared.D5,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A3(
						$author$project$Pages$Patients$PatientId_String$Top$fetchPatientMceEligibility,
						shared.D5,
						practice,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress,
						shared.D5,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$retrieveSyncDetails,
						shared.D5,
						$author$project$Api$Provider$Patient$One$id(patient)),
						A2(
						$author$project$Pages$Patients$PatientId_String$Top$fetchPackages,
						shared.D5,
						$author$project$Api$Provider$Patient$One$id(patient))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Top$load = F2(
	function (shared, model) {
		var _v0 = shared.Mw;
		if (_v0.$ === 3) {
			var patient = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						FR: $author$project$Shared$isHintAdmin(shared),
						VM: patient,
						gR: $author$project$Api$Provider$Patient$One$companyAccounts(patient)
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						FR: $author$project$Shared$isHintAdmin(shared)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed = function (a) {
	return {$: 48, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg = function (a) {
	return {$: 58, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg = function (a) {
	return {$: 66, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg = function (a) {
	return {$: 63, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed = {$: 41};
var $author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg = function (a) {
	return {$: 43, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg = function (a) {
	return {$: 72, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed = function (a) {
	return {$: 49, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$integrationRecordDropdownsSubscriptions = function (models) {
	return A2(
		$elm$core$List$map,
		function (model) {
			return $author$project$Ui$NewDropdown$subscriptions(model);
		},
		models);
};
var $author$project$Components$Patient$AddDependentModal$Closed = {$: 0};
var $author$project$Components$Patient$AddDependentModal$subscriptions = function (_v0) {
	var model = _v0;
	return model.U9 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$AddDependentModal$Closed) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Patient$AddSponsorshipModal$Closed = {$: 0};
var $author$project$Components$Patient$AddSponsorshipModal$subscriptions = function (_v0) {
	var model = _v0;
	return model.U9 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$AddSponsorshipModal$Closed) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Patient$EditAthenaIdModal$Close = {$: 0};
var $author$project$Components$Patient$EditAthenaIdModal$subscriptions = function (_v0) {
	var model = _v0;
	return model.U9 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$EditAthenaIdModal$Close) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$Close = {$: 0};
var $author$project$Components$Patient$EditCustomFormAnswerModal$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$EditCustomFormAnswerModal$Close);
};
var $author$project$Components$Patient$ManagePortalAccessModal$Closed = {$: 0};
var $author$project$Components$Patient$ManagePortalAccessModal$subscriptions = function (_v0) {
	var model = _v0;
	return model.U9 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$ManagePortalAccessModal$Closed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$PatientId_String$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$elm$core$Platform$Sub$batch(
				$author$project$Pages$Patients$PatientId_String$Top$integrationRecordDropdownsSubscriptions(model.fM)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$AddDependentModal$subscriptions, model.hk))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$AddSponsorshipModal$subscriptions, model.$7))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$CreateMembershipModal$subscriptions, model.hX))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$EditCustomFormAnswerModal$subscriptions, model.fz))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg,
				$author$project$Components$Patient$PackageDetailsModal$subscriptions(model.c4)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.L5))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.Up))),
				model.m2 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed) : $elm$core$Platform$Sub$none,
				model.ii ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
				$author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked(
					$author$project$Api$Provider$Patient$One$id(model.VM))) : $elm$core$Platform$Sub$none,
				model.jT ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(
				$author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked(
					$author$project$Api$Provider$Patient$One$id(model.VM))) : $elm$core$Platform$Sub$none,
				model.mk ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed),
					model.da.b)),
				model.kN ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed) : $elm$core$Platform$Sub$none,
				model.nX ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed) : $elm$core$Platform$Sub$none,
				$author$project$Components$AuditTrailLog$isOpen(model.hy) ? A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg,
				$author$project$Components$AuditTrailLog$subscriptions(model.hy)) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$ManagePortalAccessModal$subscriptions, model.i5))),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Sub$none,
					A2($elm$core$Maybe$map, $author$project$Components$Patient$EditAthenaIdModal$subscriptions, model.ir)))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$AddonRequestEmailSent = F2(
	function (a, b) {
		return {$: 55, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$BouncedEmailReset = function (a) {
	return {$: 68, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$DropdownMenuMsg = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotEngagement = function (a) {
	return {$: 60, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$GotMembership = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$GotPayInfoUpdate = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$GotPendingDocsAcceptanceUpdate = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$MceActivationEmailSent = F2(
	function (a, b) {
		return {$: 57, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$PatientDetached = F2(
	function (a, b) {
		return {$: 37, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$PatientRestored = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverAccepted = function (a) {
	return {$: 50, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$acceptEphiWaiver = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$acceptHipaaAuthorization, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverAccepted);
	});
var $author$project$Api$Provider$Patient$AccountAccess$accountAccessSentAt = function (_v0) {
	var record = _v0;
	return record.H4;
};
var $author$project$Api$Provider$IntegrationRecord$One$metadata = function (_v0) {
	var record = _v0.b;
	return record.TV;
};
var $author$project$Api$Provider$IntegrationRecord$One$athenaMetadata = function (record) {
	var _v0 = $author$project$Api$Provider$IntegrationRecord$One$metadata(record);
	if (!_v0.$) {
		var metadata_ = _v0.a;
		return $elm$core$Maybe$Just(metadata_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$athenaMetadata(one);
};
var $author$project$Api$Provider$Patient$SyncDetail$coveragePlan = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.L5;
	});
var $author$project$Api$Provider$Patient$MceActivation$mceActivationsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['mce_activation']),
		$author$project$Api$Provider$Patient$patientPath(patientId));
};
var $author$project$Api$Provider$Patient$MceActivation$create = F4(
	function (apiClient, patientId, mcePracticeId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'mce_practice_id',
					$elm$json$Json$Encode$string(mcePracticeId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$Patient$MceActivation$mceActivationsPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotAccountAccessToken = function (a) {
	return {$: 74, a: a};
};
var $author$project$Api$Provider$Patient$AccountAccessToken$AccountAccessToken = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$AccountAccessToken$Record = F2(
	function (token, url) {
		return {$Q: token, aav: url};
	});
var $author$project$Api$Provider$Patient$AccountAccessToken$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'token',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$AccountAccessToken$Record))));
var $author$project$Api$Provider$Patient$AccountAccessToken$impersonate = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$AccountAccessToken$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['account_access_tokens', 'impersonate']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$createAccountAccessToken = F2(
	function (apiClient, patient) {
		return A3(
			$author$project$Api$Provider$Patient$AccountAccessToken$impersonate,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(patient),
			$author$project$Pages$Patients$PatientId_String$Top$GotAccountAccessToken);
	});
var $author$project$Api$Provider$Patient$disableSyncing = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['disable_syncing']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$Shared$engagementStatus = function (_v0) {
	var shared = _v0;
	return shared.OB;
};
var $author$project$Api$Provider$Patient$One$engagementStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$engagementStatus(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$GotPlainSSN = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$fetchPlainSSN = F2(
	function (apiClient, patient) {
		return A3(
			$author$project$Api$Provider$SocialSecurityNumber$retrieve,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(patient),
			$author$project$Pages$Patients$PatientId_String$Top$GotPlainSSN);
	});
var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushed = function (a) {
	return {$: 29, a: a};
};
var $author$project$Api$Provider$Patient$forcePushElation = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['force_push_elation']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$forcePushElation = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$forcePushElation, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushed);
	});
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
};
var $author$project$Api$Provider$Integration$SharedWithInlinePartner$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Integration$Shared$id(shared);
};
var $author$project$Api$Provider$PatientMceEligibility$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PatientMceEligibility$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PatientMceEligibility$Shared$id(shared);
};
var $author$project$Components$Patient$AddSponsorshipModal$Employee = 0;
var $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$Invalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Practice$One$companiesCount = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lq;
	});
var $author$project$Components$Patient$AddSponsorshipModal$resetModel = F7(
	function (type_, apiClient, practice, patient, open_, usesEmployeeDivisions, requiresEmployeeDivisions) {
		if (!type_) {
			var _v1 = ($author$project$Api$Provider$Practice$One$companiesCount(practice) > 0) ? A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A2(
					$author$project$Components$ResourceFilter$Company$init,
					apiClient,
					function (d) {
						return _Utils_update(
							d,
							{D0: 'Search for a company... ', abe: $elm$core$Maybe$Nothing});
					})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			var companyResourceFilter = _v1.a;
			var companyResourceFilterCmd = _v1.b;
			return _Utils_Tuple2(
				{
					pV: companyResourceFilter,
					xp: $author$project$Api$Data$NotAsked,
					U9: open_,
					VM: patient,
					WF: practice,
					Yl: requiresEmployeeDivisions,
					gC: $elm$core$Maybe$Nothing,
					cp: $elm$core$Maybe$Nothing,
					eD: $elm$core$Maybe$Nothing,
					gF: $elm$core$Maybe$Nothing,
					sF: 0,
					ag7: $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing),
					kl: $elm$core$Maybe$Nothing,
					oD: $elm$core$Maybe$Nothing,
					aaF: usesEmployeeDivisions
				},
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg, companyResourceFilterCmd));
		} else {
			var _v2 = A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A2(
					$author$project$Components$ResourceFilter$Patient$init,
					apiClient,
					function (d) {
						return _Utils_update(
							d,
							{D0: 'Search for a patient... ', abe: $elm$core$Maybe$Nothing});
					}));
			var patientResourceFilter = _v2.a;
			var patientResourceFilterCmd = _v2.b;
			return _Utils_Tuple2(
				{
					pV: $elm$core$Maybe$Nothing,
					xp: $author$project$Api$Data$NotAsked,
					U9: open_,
					VM: patient,
					WF: practice,
					Yl: requiresEmployeeDivisions,
					gC: $elm$core$Maybe$Nothing,
					cp: $elm$core$Maybe$Nothing,
					eD: $elm$core$Maybe$Nothing,
					gF: $elm$core$Maybe$Nothing,
					sF: type_,
					ag7: $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing),
					kl: $elm$core$Maybe$Nothing,
					oD: patientResourceFilter,
					aaF: usesEmployeeDivisions
				},
				A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg, patientResourceFilterCmd));
		}
	});
var $author$project$Components$Patient$AddSponsorshipModal$init = F3(
	function (apiClient, practice, patient) {
		return A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, practice, patient, true, false, false);
	});
var $author$project$Api$Provider$CustomForm$answers = function (_v0) {
	var record = _v0;
	return record.px;
};
var $author$project$Api$Provider$CustomForm$initEmptyAnswers = _List_fromArray(
	[
		{NA: $elm$core$Maybe$Nothing, adR: '', $A: ''}
	]);
var $author$project$Api$Provider$CustomForm$questionId = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CustomForm$questionType = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$CustomForm$title = function (_v0) {
	var record = _v0;
	return record.$G;
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$init = F4(
	function (patientId, question, formId, formResponseId) {
		var answers = $elm$core$List$isEmpty(
			$author$project$Api$Provider$CustomForm$answers(question)) ? $author$project$Api$Provider$CustomForm$initEmptyAnswers : $author$project$Api$Provider$CustomForm$answers(question);
		return _Utils_Tuple2(
			{
				px: answers,
				Fl: formId,
				Fm: $author$project$Api$Provider$CustomForm$questionId(question),
				xI: formResponseId,
				VN: patientId,
				$G: $author$project$Api$Provider$CustomForm$title(question),
				ahI: $author$project$Api$Provider$CustomForm$questionType(question)
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Plan$Shared$coveragePlan(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$initCoveragePlanRules = F3(
	function (model, plan, coverageRuleUsages) {
		var _v0 = A2(
			$author$project$Api$Expandable$withDefault,
			$elm$core$Maybe$Nothing,
			$author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan(plan));
		if (!_v0.$) {
			var coveragePlan = _v0.a;
			return A3(
				$elm$core$Tuple$mapBoth,
				$elm$core$Maybe$Just,
				$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg),
				A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					model.D5,
					model.ZD,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)),
					$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan),
					$elm$core$Maybe$Just(coverageRuleUsages),
					{XO: true}));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$initNetworkCoveragePlanRules = F3(
	function (model, coveragePlan, coverageRuleUsages) {
		if (!coveragePlan.$) {
			var coveragePlan_ = coveragePlan.a;
			return A3(
				$elm$core$Tuple$mapBoth,
				$elm$core$Maybe$Just,
				$elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg),
				A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					model.D5,
					model.ZD,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_)),
					$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_),
					$elm$core$Maybe$Just(coverageRuleUsages),
					{XO: true}));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$Provider$IntegrationRecord$Shared$integrationRecordId = function (_v0) {
	var record = _v0;
	return record.Q7;
};
var $author$project$Api$Provider$IntegrationRecord$One$integrationRecordId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$integrationRecordId(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$integrationRecordId = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$integrationRecordId(one);
};
var $author$project$Components$Patient$AddDependentModal$Adult = 0;
var $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Patient$AddDependentModal$Invalid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$AddDependentModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Patient$AddDependentModal$open = F4(
	function (apiClient, practice, patient, companyAccount) {
		var _v0 = ($author$project$Api$Provider$Practice$One$companiesCount(practice) > 0) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A2(
				$author$project$Components$ResourceFilter$Patient$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'Search for a dependent... ', abe: $elm$core$Maybe$Nothing});
				})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var patientResourceFilter = _v0.a;
		var patientResourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{
				Lr: companyAccount,
				qh: patientResourceFilter,
				U9: true,
				VM: patient,
				WF: practice,
				gD: $elm$core$Maybe$Nothing,
				sF: 0,
				ag7: $author$project$Components$Patient$AddDependentModal$Invalid($elm$core$Maybe$Nothing)
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg, patientResourceFilterCmd));
	});
var $author$project$Components$Patient$AddSponsorshipModal$open = function (_v0) {
	var model = _v0;
	return _Utils_update(
		model,
		{U9: true});
};
var $author$project$Components$Patient$EditAthenaIdModal$Model = $elm$core$Basics$identity;
var $author$project$Components$Patient$EditAthenaIdModal$open = F5(
	function (_v0, practice, integrationRecord, maybeMetadataRecord, patient) {
		var newLocalPatientId = function () {
			if (!maybeMetadataRecord.$) {
				var metadataRecord = maybeMetadataRecord.a;
				return A2($elm$core$Maybe$withDefault, '', metadataRecord.aes);
			} else {
				return '';
			}
		}();
		return _Utils_Tuple2(
			{qZ: integrationRecord, rw: newLocalPatientId, U9: true, VM: patient, WF: practice, W7: false},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Patient$ManagePortalAccessModal$Model = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmailAddress$One$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Patient$ManagePortalAccessModal$GotPatientEmails = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$PatientEmail$All$PatientEmail = $elm$core$Basics$identity;
var $author$project$Api$Provider$PatientEmail$All$Record = F3(
	function (id, portalEnabled, patient) {
		return {adR: id, VM: patient, Wy: portalEnabled};
	});
var $author$project$Api$Provider$PatientEmail$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'portal_enabled',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientEmail$All$Record))));
var $author$project$Api$Provider$PatientEmail$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$PatientEmail$All$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PatientEmail$patientEmailsPath = function (emailAddressId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['patient_emails']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[emailAddressId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['email_addresses']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$PatientEmail$retrieve = F3(
	function (apiClient, emailAddressId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$PatientEmail$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)));
	});
var $author$project$Components$Patient$ManagePortalAccessModal$retrievePatientEmails = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$PatientEmail$retrieve, apiClient, patientId, $author$project$Components$Patient$ManagePortalAccessModal$GotPatientEmails);
	});
var $author$project$Components$Patient$ManagePortalAccessModal$open = F4(
	function (apiClient, practice, emailAddress, patient) {
		var emailAddressId = A2($elm$core$Maybe$map, $author$project$Api$Provider$EmailAddress$One$id, emailAddress);
		var cmd = function () {
			if (!emailAddressId.$) {
				var id = emailAddressId.a;
				return A2($author$project$Components$Patient$ManagePortalAccessModal$retrievePatientEmails, apiClient, id);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			{E6: emailAddressId, U9: true, VM: patient, Am: $author$project$Api$Data$NotAsked, nl: _List_Nil, WF: practice, W7: false},
			cmd);
	});
var $author$project$Pages$Patients$PatientId_String$Top$IntegrationPushed = function (a) {
	return {$: 26, a: a};
};
var $author$project$Api$Provider$Patient$Integration$integrationsPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['integrations']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[patientId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['patients']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$Patient$Integration$integrationPath = F2(
	function (patientId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$Patient$Integration$integrationsPath(patientId));
	});
var $author$project$Api$Provider$Patient$Integration$forcePush = F4(
	function (apiClient, patientId, integrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['force_push']),
					A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$pushIntegration = F3(
	function (apiClient, patientId, integrationId) {
		return A4($author$project$Api$Provider$Patient$Integration$forcePush, apiClient, patientId, integrationId, $author$project$Pages$Patients$PatientId_String$Top$IntegrationPushed);
	});
var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$removeDependent = F3(
	function (apiClient, companyAccount, companyRegistrationId) {
		return A5(
			$author$project$Api$Provider$Company$Registration$delete,
			apiClient,
			$author$project$Api$Provider$Company$Min$id(
				$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)),
			$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount),
			companyRegistrationId,
			$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted(
				$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$removeEmployee = F2(
	function (apiClient, companyAccount) {
		return A4(
			$author$project$Api$Provider$Company$Account$delete,
			apiClient,
			$author$project$Api$Provider$Company$Min$id(
				$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)),
			$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount),
			$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted(
				$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverRemoved = function (a) {
	return {$: 51, a: a};
};
var $author$project$Api$Provider$Patient$removeHipaaAuthorization = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['remove_hipaa_authorization']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$removeEphiWaiver = F2(
	function (apiClient, patientId) {
		return A3($author$project$Api$Provider$Patient$removeHipaaAuthorization, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverRemoved);
	});
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$RequestPendingDocumentsAcceptance = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$Record = function (requestPendingDocumentsAcceptanceSentAt) {
	return {Yi: requestPendingDocumentsAcceptanceSentAt};
};
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'request_pending_documents_acceptance_sent_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$Record));
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$PatientDocument$requestPendingDocumentsAcceptance = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['request_acceptance']),
					$author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId))));
	});
var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$requestPendingDocumentsAcceptanceSentAt = function (_v0) {
	var record = _v0;
	return record.Yi;
};
var $author$project$Api$Provider$Patient$resetBouncedEmail = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['reset_bounced_email']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$restore = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['restore']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Api$Provider$Patient$Engagement$Engagement = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$Engagement$Record = F2(
	function (lastEngagementDate, invoice) {
		return {Rh: invoice, Sy: lastEngagementDate};
	});
var $author$project$Api$Provider$Patient$Engagement$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'invoice',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'last_engagement_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Engagement$Record)));
var $author$project$Api$Provider$Patient$Engagement$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$Engagement$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$Engagement$retrieve = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$Engagement$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['engagement']),
					$author$project$Api$Provider$Patient$patientPath(patientId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$GotCoverageRuleUsages = function (a) {
	return {$: 45, a: a};
};
var $author$project$Api$Provider$CoverageRuleUsage$coverageRuleUsagePath = function (membershipPatientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['coverage_rule_usage']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['membership_patients', membershipPatientId]),
			$author$project$Api$Data$providerPath));
};
var $author$project$Api$Provider$CoverageRuleUsage$All$CoverageRuleUsage = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageRuleUsage$Shared$CoverageRuleUsage = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoverageRuleUsage$Shared$Record = F4(
	function (coverageRule, coveredCharges, remainingItems, remainingItemsUntil) {
		return {L6: coverageRule, L9: coveredCharges, X7: remainingItems, X8: remainingItemsUntil};
	});
var $author$project$Api$Provider$CoveredCharge$Min$CoveredCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$CoveredCharge$Min$Record = F3(
	function (id, quantity, coveredDate) {
		return {Ma: coveredDate, adR: id, Bd: quantity};
	});
var $author$project$Api$Provider$CoveredCharge$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'covered_date',
	$author$project$Utils$Date$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'quantity',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveredCharge$Min$Record))));
var $author$project$Api$Provider$CoveredCharge$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoveredCharge$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRuleUsage$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'remaining_items_until',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'remaining_items',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'covered_charges',
			$elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'coverage_rule',
				$author$project$Api$Provider$CoverageRule$One$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRuleUsage$Shared$Record)))));
var $author$project$Api$Provider$CoverageRuleUsage$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageRuleUsage$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRuleUsage$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CoverageRuleUsage$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$CoverageRuleUsage$list = F3(
	function (apiClient, membershipPatientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$CoverageRuleUsage$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo(
				$author$project$Api$Provider$CoverageRuleUsage$coverageRuleUsagePath(membershipPatientId)));
	});
var $author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages = F2(
	function (apiClient, membershipPatientId) {
		return A3($author$project$Api$Provider$CoverageRuleUsage$list, apiClient, membershipPatientId, $author$project$Pages$Patients$PatientId_String$Top$GotCoverageRuleUsages);
	});
var $author$project$Pages$Patients$PatientId_String$Top$retrieveMembership = F3(
	function (apiClient, membershipId, toMsg) {
		return A4(
			$author$project$Api$Provider$Membership$retrieve,
			apiClient,
			membershipId,
			_List_fromArray(
				[0]),
			toMsg);
	});
var $author$project$Pages$Patients$PatientId_String$Top$AccessLinkSent = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Patient$AccountAccess$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Patient$AccountAccess$Record = function (accountAccessSentAt) {
	return {H4: accountAccessSentAt};
};
var $author$project$Api$Provider$Patient$AccountAccess$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'account_access_sent_at',
	$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$AccountAccess$Record));
var $author$project$Api$Provider$Patient$AccountAccess$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Patient$AccountAccess$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Patient$requestAccountAccess = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Patient$AccountAccess$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['account_access']),
					$author$project$Api$Provider$Patient$patientPath(id_))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$sendAccountAccess = F2(
	function (apiClient, patient) {
		return A3(
			$author$project$Api$Provider$Patient$requestAccountAccess,
			apiClient,
			$author$project$Api$Provider$Patient$One$id(patient),
			$author$project$Pages$Patients$PatientId_String$Top$AccessLinkSent);
	});
var $author$project$Api$Provider$AddonRequest$addonRequestsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['addon_requests']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$AddonRequest$addonRequestPath = function (addonId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[addonId]),
		$author$project$Api$Provider$AddonRequest$addonRequestsPath);
};
var $author$project$Api$Provider$AddonRequest$sendEmail = F4(
	function (apiClient, addonId, patientId, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient_id',
					$elm$json$Json$Encode$string(patientId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['send_email']),
						$author$project$Api$Provider$AddonRequest$addonRequestPath(addonId)))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$IntegrationUnlinked = function (a) {
	return {$: 25, a: a};
};
var $author$project$Api$Provider$Patient$Integration$unlink = F4(
	function (apiClient, patientId, integrationId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$IntegrationRecord$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['unlink']),
					A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$unlinkIntegration = F3(
	function (apiClient, patientId, integrationId) {
		return A4($author$project$Api$Provider$Patient$Integration$unlink, apiClient, patientId, integrationId, $author$project$Pages$Patients$PatientId_String$Top$IntegrationUnlinked);
	});
var $author$project$Components$Patient$AddDependentModal$CreatedCompanyRegistration = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Company$Registration$encodeCreateParams = function (_v0) {
	var type_ = _v0.ahI;
	var patientId = _v0.VN;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'registration',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(type_)),
							_Utils_Tuple2(
							'patient',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'id',
										$elm$json$Json$Encode$string(patientId))
									])))
						])))
			]));
};
var $author$project$Components$Patient$AddDependentModal$typeToCode = function (t) {
	if (!t) {
		return 'spouse';
	} else {
		return 'child';
	}
};
var $author$project$Components$Patient$AddDependentModal$createCompanyRegistration = F5(
	function (apiClient, companyId, companyAccountId, patientId, type_) {
		var params = {
			VN: patientId,
			ahI: $author$project$Components$Patient$AddDependentModal$typeToCode(type_)
		};
		var encodedParams = $author$project$Api$Provider$Company$Registration$encodeCreateParams(params);
		return A5($author$project$Api$Provider$Company$Registration$create, apiClient, companyId, companyAccountId, encodedParams, $author$project$Components$Patient$AddDependentModal$CreatedCompanyRegistration);
	});
var $author$project$Components$Patient$AddDependentModal$GotDependent = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$AddDependentModal$fetchPatient = F2(
	function (token, patientId) {
		return A3($author$project$Api$Provider$Patient$retrieve, token, patientId, $author$project$Components$Patient$AddDependentModal$GotDependent);
	});
var $author$project$Components$Patient$AddDependentModal$Child = 1;
var $author$project$Components$Patient$AddDependentModal$typeFromLabel = function (str) {
	if (str === 'Adult') {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Components$Patient$AddDependentModal$Valid = {$: 0};
var $author$project$Components$Patient$AddDependentModal$findCompanyAccountForSameCompanyAndSubscriber = F3(
	function (accounts, companyId, patientId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (account) {
					return _Utils_eq(
						$author$project$Api$Provider$Company$Min$id(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)),
						companyId) && _Utils_eq(
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Patient$Min$id,
							$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account)),
						$elm$core$Maybe$Just(patientId));
				},
				accounts));
	});
var $author$project$Components$Patient$AddDependentModal$validateModel = function (model) {
	var status = function () {
		var _v0 = model.gD;
		if (_v0.$ === 1) {
			return $author$project$Components$Patient$AddDependentModal$Invalid($elm$core$Maybe$Nothing);
		} else {
			var dependent = _v0.a;
			var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(dependent);
			var existingCompanyAccount = A3(
				$author$project$Components$Patient$AddDependentModal$findCompanyAccountForSameCompanyAndSubscriber,
				accounts,
				$author$project$Api$Provider$Company$Min$id(
					$author$project$Api$Provider$CompanyAccount$ForPatient$company(model.Lr)),
				$author$project$Api$Provider$Patient$One$id(model.VM));
			if (!existingCompanyAccount.$) {
				var subscriberName = $author$project$Api$Provider$Patient$One$name(model.VM);
				var dependentName = $author$project$Api$Provider$Patient$One$name(dependent);
				var companyName = $author$project$Api$Provider$Company$Min$name(
					$author$project$Api$Provider$CompanyAccount$ForPatient$company(model.Lr));
				return $author$project$Components$Patient$AddDependentModal$Invalid(
					$elm$core$Maybe$Just(
						A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('alert'),
									$elm$html$Html$Attributes$class('alert-warning')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('It looks like ' + (dependentName + (' is already linked with ' + (companyName + (', through ' + (subscriberName + '.'))))))
								]))));
			} else {
				return $author$project$Components$Patient$AddDependentModal$Valid;
			}
		}
	}();
	return _Utils_update(
		model,
		{ag7: status});
};
var $author$project$Components$Patient$AddDependentModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					y8: _Utils_update(
						model,
						{U9: false}),
					as: _List_Nil
				};
			case 1:
				var command = function () {
					var _v2 = model.gD;
					if (!_v2.$) {
						var dependent = _v2.a;
						return A5(
							$author$project$Components$Patient$AddDependentModal$createCompanyRegistration,
							apiClient,
							$author$project$Api$Provider$Company$Min$id(
								$author$project$Api$Provider$CompanyAccount$ForPatient$company(model.Lr)),
							$author$project$Api$Provider$CompanyAccount$ForPatient$id(model.Lr),
							$author$project$Api$Provider$Patient$One$id(dependent),
							model.sF);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return {EC: command, y8: model, as: _List_Nil};
			case 2:
				var type_ = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					y8: _Utils_update(
						model,
						{
							sF: $author$project$Components$Patient$AddDependentModal$typeFromLabel(type_)
						}),
					as: _List_Nil
				};
			case 3:
				var subMsg = msg.a;
				var _v3 = model.qh;
				if (!_v3.$) {
					var subscriberResourceFilter = _v3.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, subscriberResourceFilter);
					var _v4 = function () {
						var _v5 = patientResourceResult.ac5;
						if (!_v5.$) {
							if (!_v5.a.$) {
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Patient$AddDependentModal$fetchPatient(apiClient),
											$author$project$Components$ResourceFilter$Patient$value(patientResourceResult.y8))));
							} else {
								var _v6 = _v5.a;
								return _Utils_Tuple2(model.gD, $elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(model.gD, $elm$core$Platform$Cmd$none);
						}
					}();
					var selectedDependent = _v4.a;
					var fetchPatientCmd = _v4.b;
					var commands = _List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg, patientResourceResult.EC),
							fetchPatientCmd
						]);
					var newModel = $author$project$Components$Patient$AddDependentModal$validateModel(
						_Utils_update(
							model,
							{
								qh: $elm$core$Maybe$Just(patientResourceResult.y8),
								gD: selectedDependent
							}));
					return {
						EC: $elm$core$Platform$Cmd$batch(commands),
						y8: newModel,
						as: patientResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, y8: model, as: _List_Nil};
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						y8: _Utils_update(
							model,
							{U9: false}),
						as: _List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.VM))
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var pat = response.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						y8: $author$project$Components$Patient$AddDependentModal$validateModel(
							_Utils_update(
								model,
								{
									gD: $elm$core$Maybe$Just(pat)
								})),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyAccount = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Provider$Company$Account$encodeCreateParams = function (_v0) {
	var divisionId = _v0.NU;
	var type_ = _v0.ahI;
	var patientId = _v0.VN;
	var encodePatient = function (patId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'patient',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(patId))
							])))
				]));
	};
	var encodeRegistrations = function (patId) {
		return A2(
			$elm$json$Json$Encode$list,
			encodePatient,
			_List_fromArray(
				[patId]));
	};
	var encodeDivision = function (divId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(divId))
				]));
	};
	var add = F2(
		function (item, list_) {
			return _Utils_ap(
				list_,
				_List_fromArray(
					[item]));
		});
	var maybeAdd = F2(
		function (_v2, list_) {
			var key = _v2.a;
			var item = _v2.b;
			if (!item.$) {
				var item_ = item.a;
				return A2(
					add,
					_Utils_Tuple2(key, item_),
					list_);
			} else {
				return list_;
			}
		});
	return function (fields) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'account',
					$elm$json$Json$Encode$object(fields))
				]));
	}(
		A2(
			maybeAdd,
			_Utils_Tuple2(
				'division',
				A2($elm$core$Maybe$map, encodeDivision, divisionId)),
			A2(
				maybeAdd,
				_Utils_Tuple2(
					'registrations',
					A2($elm$core$Maybe$map, encodeRegistrations, patientId)),
				A2(
					maybeAdd,
					_Utils_Tuple2(
						'type',
						A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, type_)),
					_List_Nil))));
};
var $author$project$Components$Patient$AddSponsorshipModal$createCompanyAccount = F4(
	function (token, companyId, divisionId, patientId) {
		var params = {
			NU: divisionId,
			VN: $elm$core$Maybe$Just(patientId),
			ahI: $elm$core$Maybe$Just('employee')
		};
		var encodedParams = $author$project$Api$Provider$Company$Account$encodeCreateParams(params);
		return A4(
			$author$project$Api$Provider$Company$Account$create,
			token,
			$author$project$Api$Provider$Company$companyPath(companyId),
			encodedParams,
			$author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyAccount(companyId));
	});
var $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyRegistration = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$typeToCode = function (t) {
	switch (t) {
		case 0:
			return 'employee';
		case 1:
			return 'spouse';
		default:
			return 'child';
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration = F5(
	function (token, companyId, companyAccountId, patientId, type_) {
		var params = {
			VN: patientId,
			ahI: $author$project$Components$Patient$AddSponsorshipModal$typeToCode(type_)
		};
		var encodedParams = $author$project$Api$Provider$Company$Registration$encodeCreateParams(params);
		return A5($author$project$Api$Provider$Company$Registration$create, token, companyId, companyAccountId, encodedParams, $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyRegistration);
	});
var $author$project$Components$Patient$AddSponsorshipModal$GotAccountDivisions = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$fetchAccountDivisions = F2(
	function (token, companyId) {
		return A4(
			$author$project$Api$Provider$Company$EmployeeDivision$list,
			token,
			companyId,
			function (d) {
				return d;
			},
			$author$project$Components$Patient$AddSponsorshipModal$GotAccountDivisions);
	});
var $author$project$Components$Patient$AddSponsorshipModal$GotSubscriber = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$fetchPatient = F2(
	function (token, patientId) {
		return A3($author$project$Api$Provider$Patient$retrieve, token, patientId, $author$project$Components$Patient$AddSponsorshipModal$GotSubscriber);
	});
var $author$project$Api$Provider$Company$All$requiresEmployeeDivisions = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions(shared);
};
var $author$project$Components$ResourceFilter$Company$requiresEmployeeDivisions = $author$project$Api$Provider$Company$All$requiresEmployeeDivisions;
var $author$project$Components$Patient$AddSponsorshipModal$Adult = 1;
var $author$project$Components$Patient$AddSponsorshipModal$Child = 2;
var $author$project$Components$Patient$AddSponsorshipModal$typeFromLabel = function (str) {
	switch (str) {
		case 'Adult':
			return 1;
		case 'Child':
			return 2;
		default:
			return 0;
	}
};
var $author$project$Api$Provider$Company$All$usesEmployeeDivisions = function (_v0) {
	var record = _v0.b;
	return record.aaF;
};
var $author$project$Components$ResourceFilter$Company$usesEmployeeDivisions = $author$project$Api$Provider$Company$All$usesEmployeeDivisions;
var $author$project$Components$Patient$AddSponsorshipModal$Valid = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$findCompanyAccount = F2(
	function (accounts, companyAccountId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (account) {
					return _Utils_eq(
						$author$project$Api$Provider$CompanyAccount$ForPatient$id(account),
						companyAccountId);
				},
				accounts));
	});
var $author$project$Components$Patient$AddSponsorshipModal$validateDependentModel = function (model) {
	var hasNoAccountsWarning = function (subscriber) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert'),
					$elm$html$Html$Attributes$class('alert-warning')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Patient$One$name(subscriber) + ' is not an employee at a company. Visit their page '),
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{
							VN: $author$project$Api$Provider$Patient$One$id(subscriber)
						}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('here')
						])),
					$elm$html$Html$text(' to add employment.')
				]));
	};
	var _v0 = _Utils_Tuple2(model.gF, model.gC);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing);
	} else {
		if (_v0.b.$ === 1) {
			var subscriber = _v0.a.a;
			var _v2 = _v0.b;
			return $author$project$Components$Patient$AddSponsorshipModal$Invalid(
				$elm$core$Maybe$Just(
					hasNoAccountsWarning(subscriber)));
		} else {
			var subscriber = _v0.a.a;
			var companyAccountId = _v0.b.a;
			var _v3 = function () {
				var _v4 = model.kl;
				if (!_v4.$) {
					var ownedAccounts = _v4.a;
					if ($elm$core$List$isEmpty(ownedAccounts)) {
						return _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
					} else {
						var found = A2(
							$author$project$Components$Patient$AddSponsorshipModal$findCompanyAccount,
							$author$project$Api$Provider$Patient$One$companyAccounts(model.VM),
							companyAccountId);
						return _Utils_Tuple2(false, found);
					}
				} else {
					return _Utils_Tuple2(false, $elm$core$Maybe$Nothing);
				}
			}();
			var hasNoAccounts = _v3.a;
			var maybeAlreadyRegisteredOn = _v3.b;
			if (hasNoAccounts) {
				return $author$project$Components$Patient$AddSponsorshipModal$Invalid(
					$elm$core$Maybe$Just(
						hasNoAccountsWarning(subscriber)));
			} else {
				var subscriberName = $author$project$Api$Provider$Patient$One$name(subscriber);
				var patientName = $author$project$Api$Provider$Patient$One$name(model.VM);
				if (!maybeAlreadyRegisteredOn.$) {
					var companyAccount = maybeAlreadyRegisteredOn.a;
					return $author$project$Components$Patient$AddSponsorshipModal$Invalid(
						$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('alert'),
										$elm$html$Html$Attributes$class('alert-warning')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'It looks like ' + (patientName + (' is already linked with ' + ($author$project$Api$Provider$Company$Min$name(
											$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)) + (', through ' + (subscriberName + '.'))))))
									]))));
				} else {
					var companyName = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Company$Min$name,
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$CompanyAccount$ForPatient$company,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (account) {
											return _Utils_eq(
												$author$project$Api$Provider$CompanyAccount$ForPatient$id(account),
												companyAccountId);
										},
										$author$project$Api$Provider$Patient$One$companyAccounts(subscriber))))));
					return $author$project$Components$Patient$AddSponsorshipModal$Valid(
						$elm$core$Maybe$Just(
							A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('alert'),
										$elm$html$Html$Attributes$class('alert-info')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(patientName + (' will be added to ' + (companyName + (', through ' + (subscriberName + '\'s account.')))))
									]))));
				}
			}
		}
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$findCompanyAccountForSameCompanyAndSubscriber = F3(
	function (accounts, companyId, patientId) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (account) {
					return _Utils_eq(
						$author$project$Api$Provider$Company$Min$id(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)),
						companyId) && _Utils_eq(
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Patient$Min$id,
							$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account)),
						$elm$core$Maybe$Just(patientId));
				},
				accounts));
	});
var $author$project$Components$Patient$AddSponsorshipModal$validateEmployeeModel = function (model) {
	var _v0 = model.cp;
	if (!_v0.$) {
		var selectedCompanyId = _v0.a;
		var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(model.VM);
		var alreadyRegistered = A3(
			$author$project$Components$Patient$AddSponsorshipModal$findCompanyAccountForSameCompanyAndSubscriber,
			accounts,
			selectedCompanyId,
			$author$project$Api$Provider$Patient$One$id(model.VM));
		if (!alreadyRegistered.$) {
			var companyAccount = alreadyRegistered.a;
			var patientName = $author$project$Api$Provider$Patient$One$name(model.VM);
			return $author$project$Components$Patient$AddSponsorshipModal$Invalid(
				$elm$core$Maybe$Just(
					A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('alert'),
								$elm$html$Html$Attributes$class('alert-warning')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'It looks like ' + (patientName + (' is already linked with ' + $author$project$Api$Provider$Company$Min$name(
									$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)))))
							]))));
		} else {
			return $author$project$Components$Patient$AddSponsorshipModal$Valid($elm$core$Maybe$Nothing);
		}
	} else {
		return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing);
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$validateModel = function (model) {
	var status = function () {
		var _v0 = model.sF;
		if (!_v0) {
			return $author$project$Components$Patient$AddSponsorshipModal$validateEmployeeModel(model);
		} else {
			return $author$project$Components$Patient$AddSponsorshipModal$validateDependentModel(model);
		}
	}();
	return _Utils_update(
		model,
		{ag7: status});
};
var $author$project$Components$Patient$AddSponsorshipModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var _v2 = A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, model.WF, model.VM, false, model.aaF, model.Yl);
				var newModel = _v2.a;
				var cmd = _v2.b;
				return {EC: cmd, y8: newModel, as: _List_Nil};
			case 1:
				var _v3 = model.sF;
				if (!_v3) {
					var command = function () {
						var _v4 = model.cp;
						if (!_v4.$) {
							var companyId = _v4.a;
							return A4(
								$author$project$Components$Patient$AddSponsorshipModal$createCompanyAccount,
								apiClient,
								companyId,
								model.eD,
								$author$project$Api$Provider$Patient$One$id(model.VM));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return {EC: command, y8: model, as: _List_Nil};
				} else {
					var type_ = _v3;
					var command = function () {
						var _v5 = _Utils_Tuple2(model.cp, model.gC);
						if ((!_v5.a.$) && (!_v5.b.$)) {
							var companyId = _v5.a.a;
							var companyAccountId = _v5.b.a;
							return A5(
								$author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration,
								apiClient,
								companyId,
								companyAccountId,
								$author$project$Api$Provider$Patient$One$id(model.VM),
								type_);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return {EC: command, y8: model, as: _List_Nil};
				}
			case 2:
				var type_ = msg.a;
				var _v6 = A7(
					$author$project$Components$Patient$AddSponsorshipModal$resetModel,
					$author$project$Components$Patient$AddSponsorshipModal$typeFromLabel(type_),
					apiClient,
					model.WF,
					model.VM,
					true,
					model.aaF,
					model.Yl);
				var newModel = _v6.a;
				var cmd = _v6.b;
				return {EC: cmd, y8: newModel, as: _List_Nil};
			case 3:
				var subMsg = msg.a;
				var _v7 = model.pV;
				if (!_v7.$) {
					var companyResourceFilter = _v7.a;
					var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, companyResourceFilter);
					var _v8 = function () {
						var _v9 = companyResourceResult.ac5;
						if (((!_v9.$) && (!_v9.a.$)) && (!_v9.a.a.$)) {
							var company = _v9.a.a.a;
							return _Utils_Tuple2(
								$author$project$Components$ResourceFilter$Company$usesEmployeeDivisions(company),
								$author$project$Components$ResourceFilter$Company$requiresEmployeeDivisions(company));
						} else {
							return _Utils_Tuple2(model.aaF, model.Yl);
						}
					}();
					var usesEmployeeDivisions = _v8.a;
					var requiresEmployeeDivision = _v8.b;
					var _v10 = function () {
						var _v11 = companyResourceResult.ac5;
						if (!_v11.$) {
							if (!_v11.a.$) {
								return _Utils_Tuple2(
									$author$project$Components$ResourceFilter$Company$value(companyResourceResult.y8),
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Patient$AddSponsorshipModal$fetchAccountDivisions(apiClient),
											$author$project$Components$ResourceFilter$Company$value(companyResourceResult.y8))));
							} else {
								var _v12 = _v11.a;
								return _Utils_Tuple2(model.cp, $elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(model.cp, $elm$core$Platform$Cmd$none);
						}
					}();
					var companyId = _v10.a;
					var fetchDivisionsCmd = _v10.b;
					var newModel = $author$project$Components$Patient$AddSponsorshipModal$validateModel(
						_Utils_update(
							model,
							{
								pV: $elm$core$Maybe$Just(companyResourceResult.y8),
								Yl: requiresEmployeeDivision,
								cp: companyId,
								eD: $elm$core$Maybe$Nothing,
								aaF: usesEmployeeDivisions
							}));
					var commands = _List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg, companyResourceResult.EC),
							fetchDivisionsCmd
						]);
					return {
						EC: $elm$core$Platform$Cmd$batch(commands),
						y8: newModel,
						as: companyResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, y8: model, as: _List_Nil};
				}
			case 4:
				var subMsg = msg.a;
				var _v13 = model.oD;
				if (!_v13.$) {
					var subscriberResourceFilter = _v13.a;
					var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, subscriberResourceFilter);
					var _v14 = function () {
						var _v15 = patientResourceResult.ac5;
						if (!_v15.$) {
							if (!_v15.a.$) {
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											$author$project$Components$Patient$AddSponsorshipModal$fetchPatient(apiClient),
											$author$project$Components$ResourceFilter$Patient$value(patientResourceResult.y8))));
							} else {
								var _v16 = _v15.a;
								return _Utils_Tuple2(model.gF, $elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(model.gF, $elm$core$Platform$Cmd$none);
						}
					}();
					var newSelectedSubscriber = _v14.a;
					var fetchPatientCmd = _v14.b;
					var commands = _List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg, patientResourceResult.EC),
							fetchPatientCmd
						]);
					var newModel = $author$project$Components$Patient$AddSponsorshipModal$validateModel(
						_Utils_update(
							model,
							{
								gF: newSelectedSubscriber,
								oD: $elm$core$Maybe$Just(patientResourceResult.y8)
							}));
					return {
						EC: $elm$core$Platform$Cmd$batch(commands),
						y8: newModel,
						as: patientResourceResult.as
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, y8: model, as: _List_Nil};
				}
			case 5:
				var response = msg.a;
				var newModel = function () {
					if (model.Yl) {
						var selectedDivisionId = function () {
							if (response.$ === 3) {
								var data = response.a;
								return A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$EmployeeDivision$All$id,
									$elm$core$List$head(data));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return $author$project$Components$Patient$AddSponsorshipModal$validateModel(
							_Utils_update(
								model,
								{xp: response, eD: selectedDivisionId}));
					} else {
						return $author$project$Components$Patient$AddSponsorshipModal$validateModel(
							_Utils_update(
								model,
								{xp: response}));
					}
				}();
				return {EC: $elm$core$Platform$Cmd$none, y8: newModel, as: _List_Nil};
			case 6:
				var divisionId = msg.a;
				if (divisionId === '') {
					return {
						EC: $elm$core$Platform$Cmd$none,
						y8: _Utils_update(
							model,
							{eD: $elm$core$Maybe$Nothing}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						y8: $author$project$Components$Patient$AddSponsorshipModal$validateModel(
							_Utils_update(
								model,
								{
									eD: $elm$core$Maybe$Just(divisionId)
								})),
						as: _List_Nil
					};
				}
			case 7:
				var companyId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var data = response.a;
					return {
						EC: A5(
							$author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration,
							apiClient,
							companyId,
							$author$project$Api$Provider$CompanyAccount$One$id(data),
							$author$project$Api$Provider$Patient$One$id(model.VM),
							model.sF),
						y8: model,
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 8:
				var response = msg.a;
				if (response.$ === 3) {
					var _v21 = A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, model.WF, model.VM, false, model.aaF, model.Yl);
					var newModel = _v21.a;
					var cmd = _v21.b;
					return {
						EC: cmd,
						y8: newModel,
						as: _List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(
								$author$project$Api$Provider$Patient$One$id(model.VM))
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 9:
				var response = msg.a;
				if (response.$ === 3) {
					var pat = response.a;
					var subscriberOwnedCompanyAccounts = A2(
						$elm$core$List$filter,
						function (acc) {
							return _Utils_eq(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Patient$Min$id,
										$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(acc))),
								$author$project$Api$Provider$Patient$One$id(pat));
						},
						$author$project$Api$Provider$Patient$One$companyAccounts(pat));
					var selectedCompanyAccount = $elm$core$List$head(subscriberOwnedCompanyAccounts);
					var selectedCompanyId = A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Company$Min$id,
						A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$ForPatient$company, selectedCompanyAccount));
					return {
						EC: $elm$core$Platform$Cmd$none,
						y8: $author$project$Components$Patient$AddSponsorshipModal$validateModel(
							_Utils_update(
								model,
								{
									gC: A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$ForPatient$id, selectedCompanyAccount),
									cp: selectedCompanyId,
									gF: $elm$core$Maybe$Just(pat),
									kl: $elm$core$Maybe$Just(subscriberOwnedCompanyAccounts)
								})),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, y8: model, as: _List_Nil};
				}
			default:
				var id = msg.a;
				var companyId = A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$Company$Min$id,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$CompanyAccount$ForPatient$company,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (acc) {
									return _Utils_eq(
										$author$project$Api$Provider$CompanyAccount$ForPatient$id(acc),
										id);
								},
								A2($elm$core$Maybe$withDefault, _List_Nil, model.kl)))));
				return {
					EC: $elm$core$Platform$Cmd$none,
					y8: $author$project$Components$Patient$AddSponsorshipModal$validateModel(
						_Utils_update(
							model,
							{
								gC: $elm$core$Maybe$Just(id),
								cp: companyId
							})),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Patient$EditAthenaIdModal$Closed = {$: 0};
var $author$project$Components$Patient$EditAthenaIdModal$None = {$: 2};
var $author$project$Components$Patient$EditAthenaIdModal$Success = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$EditAthenaIdModal$MetadataUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Patient$Integration$metadataRecordEncoder = function (metadata) {
	var innerObject = $elm$json$Json$Encode$object(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (idVal) {
					return ($elm$core$String$trim(idVal) === '') ? _List_Nil : _List_fromArray(
						[
							_Utils_Tuple2(
							'athena_local_patient_id',
							$elm$json$Json$Encode$string(idVal))
						]);
				},
				metadata.aes)));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2('metadata', innerObject)
			]));
};
var $author$project$Api$Provider$Patient$Integration$updateMetadata = F5(
	function (apiClient, patientId, integrationId, metadata, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Provider$IntegrationRecord$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$Provider$Patient$Integration$metadataRecordEncoder(metadata),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['metadata']),
						A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId)))));
	});
var $author$project$Components$Patient$EditAthenaIdModal$updateLocalPatientId = F4(
	function (apiClient, patientId, integrationId, localPatientId) {
		var metadata = {
			aes: $elm$core$Maybe$Just(localPatientId)
		};
		return A5($author$project$Api$Provider$Patient$Integration$updateMetadata, apiClient, patientId, integrationId, metadata, $author$project$Components$Patient$EditAthenaIdModal$MetadataUpdated);
	});
var $author$project$Components$Patient$EditAthenaIdModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var newLocalPatientId = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Patient$EditAthenaIdModal$None,
					y8: _Utils_update(
						model,
						{rw: newLocalPatientId}),
					as: _List_Nil
				};
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$Patient$EditAthenaIdModal$Closed,
					y8: _Utils_update(
						model,
						{U9: false}),
					as: _List_Nil
				};
			case 2:
				var cmd = A4(
					$author$project$Components$Patient$EditAthenaIdModal$updateLocalPatientId,
					apiClient,
					$author$project$Api$Provider$Patient$One$id(model.VM),
					$author$project$Api$Provider$Integration$SharedWithInlinePartner$id(
						$author$project$Api$Provider$IntegrationRecord$All$integration(model.qZ)),
					model.rw);
				return {
					EC: cmd,
					ac5: $author$project$Components$Patient$EditAthenaIdModal$None,
					y8: _Utils_update(
						model,
						{W7: true}),
					as: _List_Nil
				};
			default:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var newModel = _Utils_update(
							model,
							{U9: false, W7: false});
						var integrationId = $author$project$Api$Provider$Integration$SharedWithInlinePartner$id(
							$author$project$Api$Provider$IntegrationRecord$All$integration(model.qZ));
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$Patient$EditAthenaIdModal$Success(integrationId),
							y8: newModel,
							as: _List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Local ID saved')
								])
						};
					case 2:
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: $author$project$Components$Patient$EditAthenaIdModal$None,
							y8: model,
							as: $author$project$OutMsg$handleErrorResponse(response)
						};
					default:
						return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$Patient$EditAthenaIdModal$None, y8: model, as: _List_Nil};
				}
		}
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$Closed = 1;
var $author$project$Components$Patient$EditCustomFormAnswerModal$FormResponseUpdated = 2;
var $author$project$Components$Patient$EditCustomFormAnswerModal$None = 0;
var $author$project$Api$Provider$CustomForm$answerId = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$CustomForm$answerText = function (_v0) {
	var record = _v0;
	return record.$A;
};
var $author$project$Api$Provider$CustomForm$formResponsesPath = function (patientId) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['form_responses']),
		A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[patientId]),
			A2(
				$author$project$Api$Data$pathAppend,
				_List_fromArray(
					['patients']),
				$author$project$Api$Data$providerPath)));
};
var $author$project$Api$Provider$CustomForm$create = F5(
	function (apiClient, patientId, formId, fields, toMsg) {
		var encodeFormResponseItems = function (item) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'answer',
						$elm$json$Json$Encode$string(item.$A)),
						_Utils_Tuple2(
						'form_item',
						$author$project$Utils$Encode$association(item.Fm))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'form_response_items',
					A2($elm$json$Json$Encode$list, encodeFormResponseItems, fields)),
					_Utils_Tuple2(
					'form',
					$author$project$Utils$Encode$association(formId))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$CustomForm$formResponsesPath(patientId))));
	});
var $author$project$Api$Provider$CustomForm$destroy = function (_v0) {
	var record = _v0;
	return record.NA;
};
var $author$project$Api$Provider$CustomForm$formResponsePath = F2(
	function (patientId, id_) {
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				[id_]),
			$author$project$Api$Provider$CustomForm$formResponsesPath(patientId));
	});
var $author$project$Api$Provider$CustomForm$update = F5(
	function (apiClient, patientId, id_, fields, toMsg) {
		var encodeFormResponseItems = function (item) {
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, item.adR)),
						_Utils_Tuple2(
						'answer',
						$elm$json$Json$Encode$string(item.$A)),
						_Utils_Tuple2(
						'form_item',
						$author$project$Utils$Encode$association(item.Fm)),
						_Utils_Tuple2(
						'_destroy',
						A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, item.NA))
					]));
		};
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'form_response_items',
					A2($elm$json$Json$Encode$list, encodeFormResponseItems, fields))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$Provider$CustomForm$formResponsePath, patientId, id_))));
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$createOrUpdateFormResponse = F2(
	function (apiClient, model) {
		var payload = A2(
			$elm$core$List$map,
			function (answer) {
				return {
					NA: $author$project$Api$Provider$CustomForm$destroy(answer),
					Fm: model.Fm,
					adR: $elm$core$String$isEmpty(
						$author$project$Api$Provider$CustomForm$answerId(answer)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$author$project$Api$Provider$CustomForm$answerId(answer)),
					$A: $author$project$Api$Provider$CustomForm$answerText(answer)
				};
			},
			model.px);
		return $elm$core$String$isEmpty(model.xI) ? A5($author$project$Api$Provider$CustomForm$create, apiClient, model.VN, model.Fl, payload, $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated) : A5($author$project$Api$Provider$CustomForm$update, apiClient, model.VN, model.xI, payload, $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated);
	});
var $author$project$Api$Provider$CustomForm$updateDestroy = F2(
	function (_v0, bool) {
		var formAnswer = _v0;
		return _Utils_update(
			formAnswer,
			{
				NA: $elm$core$Maybe$Just(bool)
			});
	});
var $author$project$Api$Provider$CustomForm$updateText = F2(
	function (newValue, _v0) {
		var formAnswer = _v0;
		return _Utils_update(
			formAnswer,
			{$A: newValue});
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: model, as: _List_Nil};
			case 1:
				return {
					EC: A2($author$project$Components$Patient$EditCustomFormAnswerModal$createOrUpdateFormResponse, apiClient, model),
					ac5: 0,
					y8: model,
					as: _List_Nil
				};
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 2,
						y8: model,
						as: _List_fromArray(
							[
								$author$project$OutMsg$RetrievePatient(model.VN),
								A2($author$project$OutMsg$ShowToast, 3, 'Answer updated succesfully')
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: model,
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
			case 3:
				var formAnswer = msg.a;
				var string = msg.b;
				var newAnswer = A2($author$project$Api$Provider$CustomForm$updateText, string, formAnswer);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{
							px: _List_fromArray(
								[newAnswer])
						}),
					as: _List_Nil
				};
			case 4:
				var newAnswers = A2($elm$core$List$append, model.px, $author$project$Api$Provider$CustomForm$initEmptyAnswers);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{px: newAnswers}),
					as: _List_Nil
				};
			case 5:
				var index = msg.a;
				var newValue = msg.b;
				var newAnswers = A3(
					$elm_community$list_extra$List$Extra$updateAt,
					index,
					function (answer) {
						return A2($author$project$Api$Provider$CustomForm$updateText, newValue, answer);
					},
					model.px);
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{px: newAnswers}),
					as: _List_Nil
				};
			default:
				var index = msg.a;
				var maybeAnswer = A2($elm_community$list_extra$List$Extra$getAt, index, model.px);
				var newAnswers = function () {
					if (maybeAnswer.$ === 1) {
						return model.px;
					} else {
						var answer_ = maybeAnswer.a;
						return ($author$project$Api$Provider$CustomForm$answerId(answer_) === '') ? A2($elm_community$list_extra$List$Extra$removeAt, index, model.px) : A3(
							$elm_community$list_extra$List$Extra$updateAt,
							index,
							function (answer) {
								return A2($author$project$Api$Provider$CustomForm$updateDestroy, answer, true);
							},
							model.px);
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: _Utils_update(
						model,
						{px: newAnswers}),
					as: _List_Nil
				};
		}
	});
var $author$project$Components$Patient$ManagePortalAccessModal$None = 1;
var $author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Components$Patient$ManagePortalAccessModal$ToggledPortalStatus = 0;
var $author$project$Api$Provider$PatientEmail$authorize = F4(
	function (apiClient, emailAddressId, patientEmailId, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['authorize']),
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[patientEmailId]),
						$author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)))));
	});
var $author$project$Api$Provider$PatientEmail$All$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$PatientEmail$All$isPortalEnabled = function (_v0) {
	var record = _v0;
	return record.Wy;
};
var $author$project$Api$Provider$PatientEmail$revoke = F4(
	function (apiClient, emailAddressId, patientEmailId, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['revoke']),
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[patientEmailId]),
						$author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)))));
	});
var $author$project$Components$Patient$ManagePortalAccessModal$toggleisPortalEnabled = F3(
	function (isPortalEnabled, patientEmailId, _v0) {
		var id = _v0.a;
		var enabled = _v0.b;
		return _Utils_eq(id, patientEmailId) ? _Utils_Tuple2(id, isPortalEnabled) : _Utils_Tuple2(id, enabled);
	});
var $author$project$Components$Patient$ManagePortalAccessModal$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var response = msg.a;
				var patientEmailsEnabled = function () {
					if (response.$ === 3) {
						var patientEmails = response.a;
						return A2(
							$elm$core$List$map,
							function (p) {
								return _Utils_Tuple2(
									$author$project$Api$Provider$PatientEmail$All$id(p),
									$author$project$Api$Provider$PatientEmail$All$isPortalEnabled(p));
							},
							patientEmails);
					} else {
						return _List_Nil;
					}
				}();
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{Am: response, nl: patientEmailsEnabled}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 0:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 1,
					y8: _Utils_update(
						model,
						{U9: false}),
					as: _List_Nil
				};
			case 2:
				var patientEmail = msg.a;
				var isPortalEnabled = msg.b;
				var _v3 = model.E6;
				if (!_v3.$) {
					var emailAddressId = _v3.a;
					var patientEmailId = $author$project$Api$Provider$PatientEmail$All$id(patientEmail);
					var requestPortalChange = isPortalEnabled ? A4(
						$author$project$Api$Provider$PatientEmail$authorize,
						apiClient,
						emailAddressId,
						patientEmailId,
						A2($author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged, patientEmailId, isPortalEnabled)) : A4(
						$author$project$Api$Provider$PatientEmail$revoke,
						apiClient,
						emailAddressId,
						patientEmailId,
						A2($author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged, patientEmailId, isPortalEnabled));
					return {
						EC: requestPortalChange,
						ac5: 1,
						y8: _Utils_update(
							model,
							{W7: true}),
						as: _List_Nil
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 1, 'No email address found for this patient.')
							])
					};
				}
			default:
				var patientEmailId = msg.a;
				var isPortalEnabled = msg.b;
				var response = msg.c;
				if (response.$ === 3) {
					var statusText = isPortalEnabled ? 'authorized' : 'revoked';
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: _Utils_update(
							model,
							{
								nl: A2(
									$elm$core$List$map,
									A2($author$project$Components$Patient$ManagePortalAccessModal$toggleisPortalEnabled, isPortalEnabled, patientEmailId),
									model.nl),
								W7: false
							}),
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Patient has been ' + (statusText + ' to use the portal.'))
							])
					};
				} else {
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 1,
						y8: _Utils_update(
							model,
							{W7: false}),
						as: $author$project$OutMsg$handleErrorResponse(response)
					};
				}
		}
	});
var $author$project$Api$Provider$Patient$AccountAccessToken$url = function (_v0) {
	var record = _v0;
	return record.aav;
};
var $author$project$Pages$Patients$PatientId_String$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 65:
				var data = msg.a;
				if (data.$ === 3) {
					var syncDetail = data.a;
					if (!syncDetail.$) {
						var syncDetail_ = syncDetail.a;
						var coveragePlanAll = A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Patient$SyncDetail$coveragePlan(syncDetail_));
						var _v3 = A3($author$project$Pages$Patients$PatientId_String$Top$initNetworkCoveragePlanRules, model, coveragePlanAll, _List_Nil);
						var coveragePlan = _v3.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{u7: data, Up: coveragePlan}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{u7: data}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{u7: data}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(data));
				}
			case 0:
				return _Utils_Tuple3(
					model,
					A2($author$project$Pages$Patients$PatientId_String$Top$fetchPlainSSN, model.D5, model.VM),
					_List_Nil);
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{AR: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{TF: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ob: true}),
					A2($author$project$Pages$Patients$PatientId_String$Top$sendAccountAccess, model.D5, model.VM),
					_List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var data = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								H4: $author$project$Api$Provider$Patient$AccountAccess$accountAccessSentAt(data),
								ob: false
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ob: false}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var employeeOrDependent = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							da: _Utils_Tuple2(
								true,
								$elm$core$Maybe$Just(employeeOrDependent))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				var employeeOrDependant = msg.a;
				var confirmed = msg.b;
				if (confirmed) {
					var newModel = _Utils_update(
						model,
						{
							da: _Utils_Tuple2(
								false,
								$elm$core$Maybe$Just(employeeOrDependant))
						});
					switch (employeeOrDependant.$) {
						case 0:
							var companyAccount = employeeOrDependant.a;
							return _Utils_Tuple3(
								newModel,
								A2($author$project$Pages$Patients$PatientId_String$Top$removeEmployee, model.D5, companyAccount),
								_List_Nil);
						case 1:
							var companyAccount = employeeOrDependant.a;
							var companyRegistration = employeeOrDependant.b;
							return _Utils_Tuple3(
								newModel,
								A3(
									$author$project$Pages$Patients$PatientId_String$Top$removeDependent,
									model.D5,
									companyAccount,
									$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(companyRegistration)),
								_List_Nil);
						default:
							var companyAccount = employeeOrDependant.a;
							var companyRegistration = employeeOrDependant.b;
							return _Utils_Tuple3(
								newModel,
								A3(
									$author$project$Pages$Patients$PatientId_String$Top$removeDependent,
									model.D5,
									companyAccount,
									$author$project$Api$Provider$CompanyRegistration$ForPatientOne$id(companyRegistration)),
								_List_Nil);
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								da: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 7:
				var cacId = msg.a;
				var response = msg.b;
				if (response.$ === 3) {
					var newList = A2(
						$elm$core$List$filter,
						function (cac) {
							return !_Utils_eq(
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(cac),
								cacId);
						},
						model.gR);
					var newModel = _Utils_update(
						model,
						{
							da: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
							gR: newList
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Successfully removed')
							]));
				} else {
					var newModel = _Utils_update(
						model,
						{
							da: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{or: !model.or}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 8:
				var _v7 = model.$7;
				if (_v7.$ === 1) {
					var _v8 = A3($author$project$Components$Patient$AddSponsorshipModal$init, model.D5, model.WF, model.VM);
					var modal = _v8.a;
					var cmd = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$7: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg, cmd),
						_List_Nil);
				} else {
					var modal = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$7: $elm$core$Maybe$Just(
									$author$project$Components$Patient$AddSponsorshipModal$open(modal))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 9:
				var account = msg.a;
				var _v9 = A4($author$project$Components$Patient$AddDependentModal$open, model.D5, model.WF, model.VM, account);
				var modal = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hk: $elm$core$Maybe$Just(modal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg, cmd),
					_List_Nil);
			case 10:
				var modalMsg = msg.a;
				var _v10 = model.$7;
				if (!_v10.$) {
					var modal = _v10.a;
					var result = A3($author$project$Components$Patient$AddSponsorshipModal$update, model.D5, modalMsg, modal);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								$7: $elm$core$Maybe$Just(result.y8)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg, result.EC),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 11:
				var modalMsg = msg.a;
				var _v11 = model.hk;
				if (!_v11.$) {
					var modal = _v11.a;
					var result = A3($author$project$Components$Patient$AddDependentModal$update, model.D5, modalMsg, modal);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hk: $elm$core$Maybe$Just(result.y8)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg, result.EC),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j3: true}),
					A4(
						$author$project$Api$Provider$Patient$requestPaymentInfo,
						model.D5,
						$author$project$Api$Provider$Patient$One$id(model.VM),
						$elm$core$Maybe$Nothing,
						$author$project$Pages$Patients$PatientId_String$Top$GotPayInfoUpdate),
					_List_Nil);
			case 14:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var payInfo = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									Ao: $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt(payInfo),
									j3: false
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{j3: false}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{j3: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 15:
				var cmd = A3(
					$author$project$Api$Provider$Patient$PatientDocument$requestPendingDocumentsAcceptance,
					model.D5,
					$author$project$Api$Provider$Patient$One$id(model.VM),
					$author$project$Pages$Patients$PatientId_String$Top$GotPendingDocsAcceptanceUpdate);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j2: true}),
					cmd,
					_List_Nil);
			case 16:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var pendingDocs = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									rT: $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$requestPendingDocumentsAcceptanceSentAt(pendingDocs),
									j2: false
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{j2: false}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{j2: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 17:
				var eligibleCompanyAccounts = A2(
					$elm$core$List$filter,
					$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible,
					$author$project$Api$Provider$Patient$One$companyAccounts(model.VM));
				if (!eligibleCompanyAccounts.b) {
					return _Utils_Tuple3(
						model,
						A2(
							$author$project$Ports$Navigation$pushRoute,
							model.DE,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
								{
									VN: $author$project$Api$Provider$Patient$One$id(model.VM)
								})),
						_List_Nil);
				} else {
					var x = eligibleCompanyAccounts.a;
					var xs = eligibleCompanyAccounts.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								hX: $elm$core$Maybe$Just(
									A3(
										$author$project$Components$Patient$CreateMembershipModal$init,
										model.DE,
										A2($author$project$Utils$NonEmpty$init, x, xs),
										model.VM))
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 18:
				var subMsg = msg.a;
				var _v15 = model.hX;
				if (!_v15.$) {
					var modal = _v15.a;
					var _v16 = A3($author$project$Components$Patient$CreateMembershipModal$update, model.D5, subMsg, modal);
					var createModal_ = _v16.a;
					var cmd = _v16.b;
					var maybeEvent = _v16.c;
					var _v17 = function () {
						if (!maybeEvent.$) {
							switch (maybeEvent.a.$) {
								case 0:
									var _v19 = maybeEvent.a;
									return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
								case 2:
									var _v20 = maybeEvent.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Nothing,
										_List_fromArray(
											[
												$author$project$OutMsg$RetrievePatient(
												$author$project$Api$Provider$Patient$One$id(model.VM))
											]));
								default:
									var error = maybeEvent.a.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(createModal_),
										_List_fromArray(
											[
												A2(
												$author$project$OutMsg$ShowToast,
												1,
												$author$project$Ui$Toast$serverError(error))
											]));
							}
						} else {
							return _Utils_Tuple2(
								$elm$core$Maybe$Just(createModal_),
								_List_Nil);
						}
					}();
					var newModal = _v17.a;
					var outMsgs = _v17.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hX: newModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg, cmd),
						outMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 19:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jT: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 20:
				var patientId = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{jT: false}),
					A3(
						$author$project$Api$Provider$Patient$restore,
						model.D5,
						patientId,
						$author$project$Pages$Patients$PatientId_String$Top$PatientRestored(patientId)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{jT: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 21:
				var id = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(id),
									A2($author$project$OutMsg$ShowToast, 3, 'This patient is successfully restored.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 23:
				var response = msg.a;
				var _v22 = function () {
					if (response.$ === 3) {
						var data = response.a;
						return _Utils_Tuple3(
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, record) {
										return $author$project$Ui$NewDropdown$init(
											$author$project$Ui$NewDropdown$toDownLeft(
												$author$project$Ui$NewDropdown$defaultConfig(
													{
														adR: $author$project$Api$Provider$Integration$SharedWithInlinePartner$id(
															$author$project$Api$Provider$IntegrationRecord$All$integration(record)) + '-integration-record-dropdown',
														ahx: $author$project$Pages$Patients$PatientId_String$Top$DropdownMenuMsg(index)
													})));
									}),
								data),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_List_Nil,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}();
				var integrationRecordDropdowns = _v22.a;
				var errorReport = _v22.b;
				var outMsgs = _v22.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fM: integrationRecordDropdowns, Q8: response}),
					errorReport,
					outMsgs);
			case 22:
				var index = msg.a;
				var subMsg = msg.b;
				var _v24 = A2($elm_community$list_extra$List$Extra$getAt, index, model.fM);
				if (_v24.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					var dropdownModel = _v24.a;
					var _v25 = A2($author$project$Ui$NewDropdown$update, subMsg, dropdownModel);
					var dropdownMenu = _v25.a;
					var cmd = _v25.b;
					var newList = A3($elm_community$list_extra$List$Extra$setAt, index, dropdownMenu, model.fM);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fM: newList}),
						cmd,
						_List_Nil);
				}
			case 24:
				var action = msg.a;
				var record = msg.b;
				var patientId = $author$project$Api$Provider$Patient$One$id(model.VM);
				var integrationId = $author$project$Api$Provider$Integration$SharedWithInlinePartner$id(
					$author$project$Api$Provider$IntegrationRecord$All$integration(record));
				switch (action) {
					case 0:
						return _Utils_Tuple3(
							model,
							A3($author$project$Pages$Patients$PatientId_String$Top$unlinkIntegration, model.D5, patientId, integrationId),
							_List_Nil);
					case 1:
						var metadataRecord = $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata(record);
						var externalPatientId = function () {
							if (!metadataRecord.$) {
								var metadataRecord_ = metadataRecord.a;
								return A2($elm$core$Maybe$withDefault, '', metadataRecord_.aes);
							} else {
								return A2(
									$elm$core$Maybe$withDefault,
									'',
									$author$project$Api$Provider$IntegrationRecord$All$integrationRecordId(record));
							}
						}();
						return _Utils_Tuple3(
							model,
							$author$project$Ports$Clipboard$copy(externalPatientId),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
								]));
					case 2:
						return _Utils_Tuple3(
							model,
							A3($author$project$Pages$Patients$PatientId_String$Top$pushIntegration, model.D5, patientId, integrationId),
							_List_Nil);
					default:
						var metadataRecord = $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata(record);
						var _v28 = A2(
							$elm$core$Tuple$mapFirst,
							$elm$core$Maybe$Just,
							A5($author$project$Components$Patient$EditAthenaIdModal$open, model.D5, model.WF, record, metadataRecord, model.VM));
						var modal = _v28.a;
						var cmd = _v28.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ir: modal}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, cmd),
							_List_Nil);
				}
			case 26:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Record pushed, this might take a while')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 25:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Record unlinked')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 27:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mk: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 28:
				var confirmed = msg.a;
				var cmd = confirmed ? A2(
					$author$project$Pages$Patients$PatientId_String$Top$forcePushElation,
					model.D5,
					$author$project$Api$Provider$Patient$One$id(model.VM)) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mk: false}),
					cmd,
					_List_Nil);
			case 29:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var patient = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{VM: patient}),
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Successfully synced with Elation')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 30:
				var idx = msg.a;
				var bool = msg.b;
				var newList = A3($elm_community$list_extra$List$Extra$setAt, idx, bool, model.qY);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qY: newList}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 31:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Navigation$openInNewWindow(url),
					_List_Nil);
			case 34:
				var response = msg.a;
				if (response.$ === 2) {
					var error = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nk: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{nk: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 32:
				var response = msg.a;
				if (response.$ === 2) {
					var error = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rO: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								1,
								$author$project$Ui$Toast$serverError(error))
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{rO: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 33:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rN: !model.rN}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 38:
				var formQuestion = msg.a;
				var formId = msg.b;
				var formResponseId = msg.c;
				var _v34 = model.fz;
				if (_v34.$ === 1) {
					var _v35 = A4(
						$author$project$Components$Patient$EditCustomFormAnswerModal$init,
						$author$project$Api$Provider$Patient$One$id(model.VM),
						formQuestion,
						formId,
						formResponseId);
					var modal = _v35.a;
					var cmd = _v35.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fz: $elm$core$Maybe$Just(modal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg, cmd),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 35:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ii: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 36:
				var patientId = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{ii: false}),
					A3(
						$author$project$Api$Provider$Patient$disableSyncing,
						model.D5,
						patientId,
						$author$project$Pages$Patients$PatientId_String$Top$PatientDetached(patientId)),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{ii: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 37:
				var patientId = msg.a;
				var response = msg.b;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(patientId),
									A2($author$project$OutMsg$ShowToast, 3, 'Record detached')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 39:
				var subMsg = msg.a;
				var _v37 = model.fz;
				if (!_v37.$) {
					var modal = _v37.a;
					var result = A3($author$project$Components$Patient$EditCustomFormAnswerModal$update, model.D5, subMsg, modal);
					var newModal = function () {
						var _v38 = result.ac5;
						if (!_v38) {
							return $elm$core$Maybe$Just(result.y8);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fz: newModal}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg, result.EC),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 44:
				var response = msg.a;
				if (response.$ === 3) {
					var membership = response.a;
					var cmd = ($author$project$Api$Provider$Membership$One$status(membership) === 'ended') ? $elm$core$Platform$Cmd$none : A2(
						$author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages,
						model.D5,
						A2($elm$core$Maybe$withDefault, '', model.p5));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ja: response}),
						cmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ja: response}),
						A2(
							$author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages,
							model.D5,
							A2($elm$core$Maybe$withDefault, '', model.p5)),
						_List_Nil);
				}
			case 45:
				var response = msg.a;
				var _v40 = _Utils_Tuple2(response, model.ja);
				if ((_v40.a.$ === 3) && (_v40.b.$ === 3)) {
					var _v41 = _v40.a;
					var coverageRuleUsages = _v41.a;
					var _v42 = _v40.b;
					var membership = _v42.a;
					var plan = $author$project$Api$Provider$Membership$One$plan(membership);
					var _v43 = A3($author$project$Pages$Patients$PatientId_String$Top$initCoveragePlanRules, model, plan, coverageRuleUsages);
					var coveragePlan = _v43.a;
					var coveragePlanRulesCmd = _v43.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{L5: coveragePlan, L7: response}),
						coveragePlanRulesCmd,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{L7: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 40:
				var membershipId = msg.a;
				var membershipPatientId = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							p5: $elm$core$Maybe$Just(membershipPatientId),
							ja: $author$project$Api$Data$Loading,
							m2: true
						}),
					A3($author$project$Pages$Patients$PatientId_String$Top$retrieveMembership, model.D5, membershipId, $author$project$Pages$Patients$PatientId_String$Top$GotMembership),
					_List_Nil);
			case 41:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{L5: $elm$core$Maybe$Nothing, ja: $author$project$Api$Data$NotAsked, m2: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 42:
				var subMsg = msg.a;
				var _v44 = model.L5;
				if (!_v44.$) {
					var coveragePlan = _v44.a;
					var _v45 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, model.D5, subMsg, coveragePlan);
					var newCoveragePlan = _v45.a;
					var coveragePlanCmd = _v45.b;
					var coveragePlanOutMsgs = _v45.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								L5: $elm$core$Maybe$Just(newCoveragePlan)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg, coveragePlanCmd),
						coveragePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 43:
				var subMsg = msg.a;
				var _v46 = model.Up;
				if (!_v46.$) {
					var networkCoveragePlan = _v46.a;
					var _v47 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, model.D5, subMsg, networkCoveragePlan);
					var newNetworkCoveragePlan = _v47.a;
					var networkCoveragePlanCmd = _v47.b;
					var networkCoveragePlanOutMsgs = _v47.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Up: $elm$core$Maybe$Just(newNetworkCoveragePlan)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg, networkCoveragePlanCmd),
						networkCoveragePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 46:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kN: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 48:
				var confirmed = msg.a;
				var cmd = confirmed ? A2(
					$author$project$Pages$Patients$PatientId_String$Top$acceptEphiWaiver,
					model.D5,
					$author$project$Api$Provider$Patient$One$id(model.VM)) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kN: false}),
					cmd,
					_List_Nil);
			case 47:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nX: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 49:
				var confirmed = msg.a;
				var cmd = confirmed ? A2(
					$author$project$Pages$Patients$PatientId_String$Top$removeEphiWaiver,
					model.D5,
					$author$project$Api$Provider$Patient$One$id(model.VM)) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nX: false}),
					cmd,
					_List_Nil);
			case 50:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.VM)),
									A2($author$project$OutMsg$ShowToast, 3, 'Ephi Waiver Accepted')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 51:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							_List_fromArray(
								[
									$author$project$OutMsg$RetrievePatient(
									$author$project$Api$Provider$Patient$One$id(model.VM)),
									A2($author$project$OutMsg$ShowToast, 3, 'Ephi Waiver Removed')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$List$cons,
								A2(
									$author$project$OutMsg$ShowToast,
									1,
									$author$project$Ui$Toast$serverError(error)),
								$author$project$OutMsg$reportDecodeError(response)));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 52:
				var patientValue = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(patientValue),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						]));
			case 73:
				return _Utils_Tuple3(
					model,
					A2($author$project$Pages$Patients$PatientId_String$Top$createAccountAccessToken, model.D5, model.VM),
					_List_Nil);
			case 74:
				var response = msg.a;
				if (response.$ === 3) {
					var accountAccessToken = response.a;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Clipboard$copy(
							$author$project$Api$Provider$Patient$AccountAccessToken$url(accountAccessToken)),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Portal URL copied to clipboard')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 53:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m1: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 54:
				var addon = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hn: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$Addon$Min$id(addon),
								model.hn)
						}),
					A4(
						$author$project$Api$Provider$AddonRequest$sendEmail,
						model.D5,
						$author$project$Api$Provider$Addon$Min$id(addon),
						$author$project$Api$Provider$Patient$One$id(model.VM),
						$author$project$Pages$Patients$PatientId_String$Top$AddonRequestEmailSent(addon)),
					_List_Nil);
			case 55:
				var addon = msg.a;
				var response = msg.b;
				var ourMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Email has been sent')
							]);
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							hn: A2(
								$elm$core$Set$remove,
								$author$project$Api$Provider$Addon$Min$id(addon),
								model.hn)
						}),
					$elm$core$Platform$Cmd$none,
					_Utils_ap(
						ourMsgs,
						$author$project$OutMsg$handleErrorResponse(response)));
			case 56:
				var patientMceEligibility = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i9: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility),
								model.i9)
						}),
					A4(
						$author$project$Api$Provider$Patient$MceActivation$create,
						model.D5,
						$author$project$Api$Provider$Patient$One$id(model.VM),
						$author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility),
						$author$project$Pages$Patients$PatientId_String$Top$MceActivationEmailSent(patientMceEligibility)),
					_List_Nil);
			case 57:
				var patientMceEligibility = msg.a;
				var response = msg.b;
				var ourMsgs = function () {
					if (response.$ === 3) {
						return _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Email has been sent')
							]);
					} else {
						return _List_Nil;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i9: A2(
								$elm$core$Set$remove,
								$author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility),
								model.i9)
						}),
					$elm$core$Platform$Cmd$none,
					_Utils_ap(
						ourMsgs,
						$author$project$OutMsg$handleErrorResponse(response)));
			case 58:
				var subMsg = msg.a;
				var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, model.D5, subMsg, model.hy);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hy: auditTrailLogResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg, auditTrailLogResult.EC),
					auditTrailLogResult.as);
			case 59:
				var popover = A3(
					$author$project$Ui$Popover$init,
					'engagement',
					!$author$project$Ui$Popover$isOpen(model.aM),
					$author$project$Pages$Patients$PatientId_String$Top$PopoverMsg);
				var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.VM);
				var _v53 = _Utils_Tuple2(model.Fa, engagementStatus !== 'never_engaged');
				if ((!_v53.a.$) && _v53.b) {
					var _v54 = _v53.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Fa: $author$project$Api$Data$Loading, aM: popover}),
						A3(
							$author$project$Api$Provider$Patient$Engagement$retrieve,
							model.D5,
							$author$project$Api$Provider$Patient$One$id(model.VM),
							$author$project$Pages$Patients$PatientId_String$Top$GotEngagement),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aM: popover}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 60:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Fa: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 61:
				var subMsg = msg.a;
				var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aM);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aM: popoverModel}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 62:
				var _v55 = A4(
					$author$project$Components$Patient$ManagePortalAccessModal$open,
					model.D5,
					model.WF,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						$author$project$Api$Data$toMaybe(model.qp)),
					model.VM);
				var modal = _v55.a;
				var cmd = _v55.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i5: $elm$core$Maybe$Just(modal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg, cmd),
					_List_Nil);
			case 63:
				var modalMsg = msg.a;
				var _v56 = model.i5;
				if (!_v56.$) {
					var modal = _v56.a;
					var result = A3($author$project$Components$Patient$ManagePortalAccessModal$update, model.D5, modalMsg, modal);
					var cmd = function () {
						var _v57 = result.ac5;
						if (!_v57) {
							return A2(
								$author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress,
								model.D5,
								$author$project$Api$Provider$Patient$One$id(model.VM));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								i5: $elm$core$Maybe$Just(result.y8)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg, result.EC),
									cmd
								])),
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 64:
				var response = msg.a;
				if (response.$ === 2) {
					var error = response.a;
					if (error.$ === 5) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									qp: A2($author$project$Api$Data$Success, $elm$core$Maybe$Nothing, $elm$core$Dict$empty)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								qp: A2($author$project$Api$Data$map, $elm$core$Maybe$Just, response)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 66:
				var modalMsg = msg.a;
				var _v60 = model.ir;
				if (!_v60.$) {
					var modal = _v60.a;
					var result = A3($author$project$Components$Patient$EditAthenaIdModal$update, model.D5, modalMsg, modal);
					var _v61 = function () {
						var _v62 = result.ac5;
						switch (_v62.$) {
							case 1:
								var integrationId = _v62.a;
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.EC),
												A2(
												$author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords,
												model.D5,
												$author$project$Api$Provider$Patient$One$id(model.VM)),
												A3(
												$author$project$Pages$Patients$PatientId_String$Top$pushIntegration,
												model.D5,
												$author$project$Api$Provider$Patient$One$id(model.VM),
												integrationId)
											])));
							case 2:
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(result.y8),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.EC));
							default:
								return _Utils_Tuple2(
									$elm$core$Maybe$Nothing,
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.EC));
						}
					}();
					var newModal = _v61.a;
					var cmds = _v61.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ir: newModal}),
						cmds,
						result.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 67:
				return _Utils_Tuple3(
					model,
					A3(
						$author$project$Api$Provider$Patient$resetBouncedEmail,
						model.D5,
						$author$project$Api$Provider$Patient$One$id(model.VM),
						$author$project$Pages$Patients$PatientId_String$Top$BouncedEmailReset),
					_List_Nil);
			case 68:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ej: true}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2(
								$author$project$OutMsg$ShowToast,
								3,
								A2(
									$elm$core$String$append,
									'You should now be able to send emails to ',
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Patient$One$email(model.VM))))
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 69:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{z4: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 70:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sR: !model.sR}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 71:
				var _package = msg.a;
				var modalWithPackage = function () {
					var _v64 = $author$project$Api$Provider$PatientPackage$All$priceInCents(_package);
					if (!_v64.$) {
						var price = _v64.a;
						return A3($author$project$Components$Patient$PackageDetailsModal$openWithPrice, _package, price, model.c4);
					} else {
						return A2($author$project$Components$Patient$PackageDetailsModal$open, _package, model.c4);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c4: modalWithPackage}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v65 = A2($author$project$Components$Patient$PackageDetailsModal$update, subMsg, model.c4);
				var newModal = _v65.a;
				var cmd = _v65.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c4: newModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg, cmd),
					_List_Nil);
		}
	});
var $author$project$Api$FeatureGate$PatientPortal = 5;
var $author$project$Api$Platform$Session$One$practiceReadOnlyRole = function (_v0) {
	var record = _v0;
	return (record.agy === 'practice_read_only') || (record.agy === 'practice_read_only_and_reports');
};
var $author$project$Permission$hideIfReadOnly = F2(
	function (session, html) {
		return $author$project$Api$Platform$Session$One$practiceReadOnlyRole(session) ? $author$project$Utils$Html$empty : html;
	});
var $author$project$Ui$Panel$titleSm = function (contents) {
	return $author$project$Ui$Typography$headingSm(contents);
};
var $author$project$Components$HiConfirm$CenterText = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HiConfirm$centerText = $author$project$Components$HiConfirm$CenterText;
var $author$project$Pages$Patients$PatientId_String$Top$viewAcceptEphiWaiverModal = function (model) {
	return model.kN ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('Accept'),
				$author$project$Components$HiConfirm$noun('ePHI Waiver'),
				$author$project$Components$HiConfirm$titleizeNoun(false),
				$author$project$Components$HiConfirm$centerText(false),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('We need authorization from this customer that allows us to send them unencrypted communications which may contain Protected Health Information.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Without this authorization we cannot communicate electronically on your behalf with this customer.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Do you have signed authorization that allows us to send unencrypted communication, which may include Protected Health Information, to this customer?')
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Patient$AddDependentModal$Submitted = {$: 1};
var $author$project$Utils$Maybe$appendMaybe = F2(
	function (maybe, list) {
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2($elm$core$Maybe$map, $elm$core$List$singleton, maybe)),
			list);
	});
var $author$project$Components$Patient$AddDependentModal$viewDependentOptions = function (model) {
	var _v0 = model.qh;
	if (!_v0.$) {
		var dependentResourceFilter = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Dependent'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Patient$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						dependentResourceFilter))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddDependentModal$TypeSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$AddDependentModal$typeToLabel = function (t) {
	if (!t) {
		return 'Adult';
	} else {
		return 'Child';
	}
};
var $author$project$Components$Patient$AddDependentModal$types = _List_fromArray(
	[
		$author$project$Components$Patient$AddDependentModal$typeToLabel(0),
		$author$project$Components$Patient$AddDependentModal$typeToLabel(1)
	]);
var $author$project$Components$Patient$AddDependentModal$typeOptions = A2(
	$elm$core$List$map,
	function (typeStr) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(typeStr),
			typeStr);
	},
	$author$project$Components$Patient$AddDependentModal$types);
var $author$project$Components$Patient$AddDependentModal$viewTypeOptions = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Type'),
				$author$project$Ui$Form$Group$labelSpanMd(3),
				$author$project$Ui$Form$Group$inputSpanMd(9),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(
							$author$project$Components$Patient$AddDependentModal$typeToLabel(model.sF))),
						$author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddDependentModal$TypeSelected)
					]),
				$author$project$Components$Patient$AddDependentModal$typeOptions)
			]));
};
var $author$project$Components$Patient$AddDependentModal$view = function (_v0) {
	var model = _v0;
	if (model.U9) {
		var _v1 = function () {
			var _v2 = model.ag7;
			if (!_v2.$) {
				return _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
			} else {
				var msg = _v2.a;
				return _Utils_Tuple2(false, msg);
			}
		}();
		var canSubmit = _v1.a;
		var statusBadge = _v1.b;
		var footerContent = _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Patient$AddDependentModal$Closed)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Add dependent to company'},
				_List_fromArray(
					[
						$author$project$Ui$Button$success,
						$author$project$Ui$Button$disabled(!canSubmit),
						$author$project$Ui$Button$onClick($author$project$Components$Patient$AddDependentModal$Submitted)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add to company')
					]))
			]);
		var body = A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Patient$AddDependentModal$Submitted),
					$author$project$Ui$Form$horizontal
				]),
			A2(
				$author$project$Utils$Maybe$appendMaybe,
				statusBadge,
				_List_fromArray(
					[
						$author$project$Components$Patient$AddDependentModal$viewDependentOptions(model),
						$author$project$Components$Patient$AddDependentModal$viewTypeOptions(model)
					])));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$AddDependentModal$Closed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Add Dependent')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[body])),
					$author$project$Ui$Modal$footer(footerContent)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAddDependentModal = function (model) {
	var _v0 = model.hk;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg,
			$author$project$Components$Patient$AddDependentModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$Submitted = {$: 1};
var $author$project$Components$Patient$AddSponsorshipModal$viewCompanyOptions = function (model) {
	var _v0 = model.pV;
	if (!_v0.$) {
		var companyResourceFilter = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Company'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Company$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						companyResourceFilter))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$DivisionSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$divisionOptions = F2(
	function (requiresEmployeeDivisions, divisions) {
		var optionsList = A2(
			$elm$core$List$map,
			function (division) {
				return A3(
					$author$project$Ui$Form$Select$option,
					_List_Nil,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$EmployeeDivision$All$id(division)),
					$author$project$Api$Provider$EmployeeDivision$All$name(division));
			},
			divisions);
		return requiresEmployeeDivisions ? optionsList : A2(
			$elm$core$List$cons,
			A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(''),
				''),
			optionsList);
	});
var $author$project$Components$Patient$AddSponsorshipModal$viewDivisionsOptions = function (model) {
	if (model.aaF) {
		var _v0 = model.xp;
		if (_v0.$ === 3) {
			var divisions = _v0.a;
			return ($elm$core$List$length(divisions) > 0) ? A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Division'),
						$author$project$Ui$Form$Group$labelSpanMd(3),
						$author$project$Ui$Form$Group$inputSpanMd(9),
						$author$project$Ui$Form$Group$required(model.Yl)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Select$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Select$value(model.eD),
								$author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$DivisionSelected)
							]),
						A2($author$project$Components$Patient$AddSponsorshipModal$divisionOptions, model.Yl, divisions))
					])) : $author$project$Utils$Html$empty;
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$SubscriberCompanyAccountSelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$companyAccountOptions = function (companyAccounts) {
	return A2(
		$elm$core$List$map,
		function (companyAccount) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(
					$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)),
				$author$project$Api$Provider$Company$Min$name(
					$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)));
		},
		companyAccounts);
};
var $author$project$Components$Patient$AddSponsorshipModal$viewPatientCompanyAccountOptions = function (model) {
	var _v0 = model.kl;
	if (!_v0.$) {
		var accounts = _v0.a;
		return ($elm$core$List$length(accounts) > 1) ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Company'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Select$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Select$value(model.gC),
							$author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$SubscriberCompanyAccountSelected)
						]),
					$author$project$Components$Patient$AddSponsorshipModal$companyAccountOptions(accounts))
				])) : $author$project$Utils$Html$empty;
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$viewSubscriberOptions = function (model) {
	var _v0 = model.oD;
	if (!_v0.$) {
		var subscriberResourceFilter = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Dependent of'),
					$author$project$Ui$Form$Group$labelSpanMd(3),
					$author$project$Ui$Form$Group$inputSpanMd(9),
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg,
					A2(
						$author$project$Components$ResourceFilter$Patient$view,
						_List_fromArray(
							[
								$author$project$Components$ResourceFilter$style(0)
							]),
						subscriberResourceFilter))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$TypeSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Patient$AddSponsorshipModal$typeToLabel = function (t) {
	switch (t) {
		case 0:
			return 'Employee';
		case 1:
			return 'Adult';
		default:
			return 'Child';
	}
};
var $author$project$Components$Patient$AddSponsorshipModal$typeLabels = _List_fromArray(
	[
		$author$project$Components$Patient$AddSponsorshipModal$typeToLabel(0),
		$author$project$Components$Patient$AddSponsorshipModal$typeToLabel(1),
		$author$project$Components$Patient$AddSponsorshipModal$typeToLabel(2)
	]);
var $author$project$Components$Patient$AddSponsorshipModal$typeOptions = A2(
	$elm$core$List$map,
	function (typeStr) {
		return A3(
			$author$project$Ui$Form$Select$option,
			_List_Nil,
			$elm$core$Maybe$Just(typeStr),
			typeStr);
	},
	$author$project$Components$Patient$AddSponsorshipModal$typeLabels);
var $author$project$Components$Patient$AddSponsorshipModal$viewTypeOptions = function (model) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Type'),
				$author$project$Ui$Form$Group$labelSpanMd(3),
				$author$project$Ui$Form$Group$inputSpanMd(9),
				$author$project$Ui$Form$Group$required(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Select$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Select$value(
						$elm$core$Maybe$Just(
							$author$project$Components$Patient$AddSponsorshipModal$typeToLabel(model.sF))),
						$author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$TypeSelected)
					]),
				$author$project$Components$Patient$AddSponsorshipModal$typeOptions)
			]));
};
var $author$project$Components$Patient$AddSponsorshipModal$view = function (_v0) {
	var model = _v0;
	if (model.U9) {
		var _v1 = function () {
			var _v2 = model.ag7;
			if (!_v2.$) {
				var msg = _v2.a;
				return _Utils_Tuple2(true, msg);
			} else {
				var msg = _v2.a;
				return _Utils_Tuple2(false, msg);
			}
		}();
		var canSubmit = _v1.a;
		var statusBadge = _v1.b;
		var footerContent = _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Patient$AddSponsorshipModal$Closed)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Link employer to company'},
				_List_fromArray(
					[
						$author$project$Ui$Button$success,
						$author$project$Ui$Button$disabled(!canSubmit),
						$author$project$Ui$Button$onClick($author$project$Components$Patient$AddSponsorshipModal$Submitted)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add to company')
					]))
			]);
		var body = A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$onSubmit($author$project$Components$Patient$AddSponsorshipModal$Submitted),
					$author$project$Ui$Form$horizontal
				]),
			A2(
				$author$project$Utils$Maybe$appendMaybe,
				statusBadge,
				_List_fromArray(
					[
						$author$project$Components$Patient$AddSponsorshipModal$viewTypeOptions(model),
						$author$project$Components$Patient$AddSponsorshipModal$viewCompanyOptions(model),
						$author$project$Components$Patient$AddSponsorshipModal$viewSubscriberOptions(model),
						$author$project$Components$Patient$AddSponsorshipModal$viewDivisionsOptions(model),
						$author$project$Components$Patient$AddSponsorshipModal$viewPatientCompanyAccountOptions(model)
					])));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$AddSponsorshipModal$Closed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Link Employer')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[body])),
					$author$project$Ui$Modal$footer(footerContent)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAddSponsorshipModal = function (model) {
	var _v0 = model.$7;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg,
			$author$project$Components$Patient$AddSponsorshipModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$PatientValueCopiedToClipboard = function (a) {
	return {$: 52, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCopyButton = F2(
	function (description, value) {
		return ($elm$core$String$length(
			$elm$core$String$trim(value)) > 0) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Copy ' + description},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Top$PatientValueCopiedToClipboard(value)),
					$author$project$Ui$Button$margin(10)
				]),
			_List_Nil) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$AddressDisplay$formatSegment = function (maybeSegment) {
	return function (segment) {
		return $elm$core$String$isEmpty(segment) ? '' : segment;
	}(
		A2($elm$core$Maybe$withDefault, '', maybeSegment));
};
var $author$project$Components$AddressDisplay$addCommaIfNotEmpty = function (segment) {
	var formatted = $author$project$Components$AddressDisplay$formatSegment(segment);
	return $elm$core$String$isEmpty(formatted) ? '' : (formatted + ', ');
};
var $author$project$Components$AddressDisplay$viewOneLineAddress = function (address) {
	return $author$project$Components$AddressDisplay$addCommaIfNotEmpty(
		$author$project$Api$Common$Address$Shared$line1(address)) + ($author$project$Components$AddressDisplay$addCommaIfNotEmpty(
		$author$project$Api$Common$Address$Shared$line2(address)) + ($author$project$Components$AddressDisplay$addCommaIfNotEmpty(
		$author$project$Api$Common$Address$Shared$city(address)) + ($author$project$Components$AddressDisplay$formatSegment(
		$author$project$Api$Common$Address$Shared$state(address)) + (' ' + $author$project$Components$AddressDisplay$formatSegment(
		$author$project$Api$Common$Address$Shared$zip(address))))));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAddressesSection = F2(
	function (practice, patient) {
		var primaryAddressTitle = $author$project$Api$Provider$Patient$One$usesBillingAddress(patient) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-label-md'),
					$elm$html$Html$Attributes$class('mb-025')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Primary Address')
				])) : $author$project$Utils$Html$empty;
		var billingAddress = function () {
			var _v2 = _Utils_Tuple2(
				$author$project$Api$Provider$Patient$One$usesBillingAddress(patient),
				$author$project$Api$Provider$Patient$One$billingAddress(patient));
			if (_v2.a && (!_v2.b.$)) {
				var billingAddress_ = _v2.b.a;
				var billingAddressTitle = $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice) ? 'Shipping Address' : 'Billing Address';
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-label-md'),
									$elm$html$Html$Attributes$class('mb-025')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(billingAddressTitle)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsEnd]),
							_List_fromArray(
								[
									$author$project$Components$AddressDisplay$view(billingAddress_),
									A2(
									$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
									'patient billing address',
									$author$project$Components$AddressDisplay$viewOneLineAddress(billingAddress_))
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var _v0 = function () {
			var _v1 = $author$project$Api$Provider$Patient$One$address(patient);
			if (!_v1.$) {
				var address = _v1.a;
				return _Utils_Tuple2(
					$author$project$Components$AddressDisplay$view(address),
					A2(
						$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
						'patient primary address',
						$author$project$Components$AddressDisplay$viewOneLineAddress(address)));
			} else {
				return _Utils_Tuple2($author$project$Utils$Html$empty, $author$project$Utils$Html$empty);
			}
		}();
		var primaryAddress = _v0.a;
		var primaryAddressCopyButton = _v0.b;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[
							primaryAddressTitle,
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsEnd]),
							_List_fromArray(
								[primaryAddress, primaryAddressCopyButton]))
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(6)
						]),
					_List_fromArray(
						[billingAddress]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$RequestPendingDocsAcceptanceButtonClicked = {$: 15};
var $author$project$Ui$Skeleton$ifLoading = F3(
	function (data, skeleton, content) {
		switch (data.$) {
			case 1:
				return skeleton;
			case 3:
				return content;
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Api$Provider$PatientDocument$All$name = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PatientDocument$One$name(one);
};
var $author$project$Api$Provider$PatientDocument$All$signedAt = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PatientDocument$One$signedAt(one);
};
var $author$project$Api$Provider$PatientDocument$All$status = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PatientDocument$One$status(one);
};
var $author$project$Api$Provider$PatientDocument$All$id = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$PatientDocument$One$id(one);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementLink = F2(
	function (patient, document) {
		return $author$project$Api$Provider$Patient$One$archived(patient) ? $author$project$Utils$Html$empty : A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top(
				{
					IM: $author$project$Api$Provider$PatientDocument$All$id(document),
					VN: $author$project$Api$Provider$Patient$One$id(patient)
				}),
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('View Details')
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewAgreement = F3(
	function (timeFormatter, patient, document) {
		var signedAt = A2(
			$elm$core$Maybe$map,
			timeFormatter(0),
			$author$project$Api$Provider$PatientDocument$All$signedAt(document));
		var signedAtText = function () {
			if (!signedAt.$) {
				var text = signedAt.a;
				return ' on ' + text;
			} else {
				return '';
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					$author$project$Api$Provider$PatientDocument$All$name(document)),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9),
					$author$project$Ui$Form$Group$labelClass('control-label')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$PatientDocument$All$status(document)),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													$elm$html$Html$text(signedAtText)
												]))
										])),
									A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreementLink, patient, document)
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementsLastRequestSent = function (model) {
	var _v0 = model.rT;
	if (!_v0.$) {
		var sentAt = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				model.Hy(1),
				model.rT));
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$justifyRight]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text('Last request sent ' + (sentAt + '.'))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAccepted = function (_v0) {
	var shared = _v0;
	return shared.Qy;
};
var $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAccepted(shared);
};
var $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAcceptedAt = function (_v0) {
	var shared = _v0;
	return shared.Qz;
};
var $author$project$Api$Provider$Patient$One$hipaaAuthorizationAcceptedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAcceptedAt(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverClicked = {$: 46};
var $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverClicked = {$: 47};
var $author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiverLink = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted(patient) ? _Utils_Tuple2('Remove ePHI waiver', $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverClicked) : _Utils_Tuple2('Accept ePHI waiver', $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverClicked);
	var linkText = _v0.a;
	var linkMsg = _v0.b;
	return A3(
		$author$project$Ui$Button$view,
		{abp: linkText},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick(linkMsg),
				$author$project$Ui$Button$sm
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(linkText)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiver = function (model) {
	var accepted = $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted(model.VM);
	var signedAt = accepted ? A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (date) {
				return ' on ' + A2(model.Hy, 0, date);
			},
			$author$project$Api$Provider$Patient$One$hipaaAuthorizationAcceptedAt(model.VM))) : '';
	var status = accepted ? 'accepted' : 'not_accepted';
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('ePHI Waiver'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$Badge$fromString, _List_Nil, status),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$small]),
										_List_fromArray(
											[
												$elm$html$Html$text(signedAt)
											]))
									])),
								A2(
								$author$project$Permission$hideIfReadOnly,
								model.ZD,
								$author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiverLink(model.VM))
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$ToggleViewOutdatedDocuments = {$: 33};
var $author$project$Pages$Patients$PatientId_String$Top$viewOutdatedAgreements = function (_v0) {
	var outdatedPatientDocuments = _v0.rO;
	var outdatedDocumentsVisible = _v0.rN;
	var patient = _v0.VM;
	var timeFormatter = _v0.Hy;
	if (outdatedPatientDocuments.$ === 3) {
		var documents = outdatedPatientDocuments.a;
		return ($elm$core$List$length(documents) > 0) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					function () {
					var _v2 = outdatedDocumentsVisible ? _Utils_Tuple2(
						'Hide additional signed agreements ',
						A2($author$project$Ui$Icon$view, _List_Nil, 28)) : _Utils_Tuple2(
						'Show additional signed agreements ',
						A2($author$project$Ui$Icon$view, _List_Nil, 27));
					var label = _v2.a;
					var icon = _v2.b;
					return A3(
						$author$project$Ui$Button$view,
						{abp: label},
						_List_fromArray(
							[
								$author$project$Ui$Button$styled(8),
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleViewOutdatedDocuments)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label),
								icon
							]));
				}(),
					outdatedDocumentsVisible ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[
									$author$project$Ui$Typography$small,
									$author$project$Ui$Typography$muted,
									$author$project$Ui$Typography$margin(21)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('These are previously signed agreements that are no longer required for the patient. These agreements may be related to an old plan or location assignment, or from agreements that have since become unpublished.')
								])),
							A2(
							$author$project$Ui$Form$view,
							_List_fromArray(
								[$author$project$Ui$Form$horizontal]),
							A2(
								$elm$core$List$map,
								A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreement, timeFormatter, patient),
								documents))
						])) : $author$project$Utils$Html$empty
				])) : $author$project$Utils$Html$empty;
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementsSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			$author$project$Ui$HorizontalRule$view(_List_Nil),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Panel$titleSm(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Skeleton$ifLoading,
							model.nk,
							$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('Agreements')
									])),
							$elm$html$Html$text('Agreements'))
						])),
				function () {
					var _v0 = model.nk;
					switch (_v0.$) {
						case 3:
							var documents = _v0.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$view,
									_List_fromArray(
										[$author$project$Ui$Form$horizontal]),
									$elm$core$List$concat(
										_List_fromArray(
											[
												A2(
												$elm$core$List$map,
												A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreement, model.Hy, model.VM),
												documents),
												_List_fromArray(
												[
													$author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiver(model)
												])
											]))),
									A2(
									$author$project$Permission$hideIfReadOnly,
									model.ZD,
									$author$project$Pages$Patients$PatientId_String$Top$viewOutdatedAgreements(model)),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Permission$hideIfReadOnly,
											model.ZD,
											A3(
												$author$project$Ui$Button$view,
												{abp: 'Request acceptance by email'},
												_List_fromArray(
													[
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$disabled(
														$author$project$Api$Provider$Patient$One$archived(model.VM)),
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RequestPendingDocsAcceptanceButtonClicked),
														$author$project$Ui$Button$loading(model.j2),
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Request acceptance by email')
													])))
										])),
									$author$project$Pages$Patients$PatientId_String$Top$viewAgreementsLastRequestSent(model)
								]);
						case 1:
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$view,
									_List_fromArray(
										[$author$project$Ui$Form$horizontal]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$labelSkeleton('Agreement'),
													$author$project$Ui$Form$Group$labelSpanSm(3),
													$author$project$Ui$Form$Group$inputSpanSm(9)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$text(
															_List_fromArray(
																[
																	$author$project$Ui$Skeleton$span(3)
																]))
														]))
												])),
											A2(
											$author$project$Ui$Form$Group$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Group$labelSkeleton('Other Agreement'),
													$author$project$Ui$Form$Group$labelSpanSm(3),
													$author$project$Ui$Form$Group$inputSpanSm(9)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Form$Static$view,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$text(
															_List_fromArray(
																[
																	$author$project$Ui$Skeleton$span(4)
																]))
														]))
												]))
										]))
								]);
						default:
							return _List_Nil;
					}
				}())));
};
var $author$project$Ui$Button$Outline = 6;
var $author$project$Pages$Patients$PatientId_String$Top$RestorePatientButtonClicked = {$: 19};
var $author$project$Ui$Icon$large = $author$project$Ui$Icon$Size(3);
var $author$project$Pages$Patients$PatientId_String$Top$viewArchivedPatientAlert = function (patient) {
	return $author$project$Api$Provider$Patient$One$archived(patient) ? A2(
		$author$project$Ui$Alert$danger,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_fromArray(
					[$author$project$Ui$FlexGrid$rowItemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1),
								$author$project$Ui$FlexGrid$span(2),
								$author$project$Ui$FlexGrid$textCenter
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Icon$view,
								_List_fromArray(
									[$author$project$Ui$Icon$large]),
								35)
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(8),
								$author$project$Ui$FlexGrid$span(10)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('This patient has been archived and is currently read-only.')
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(3)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{
									abp: 'Restore ' + $author$project$Api$Provider$Patient$One$name(patient)
								},
								_List_fromArray(
									[
										$author$project$Ui$Button$styled(6),
										$author$project$Ui$Button$pull(1),
										$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RestorePatientButtonClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Restore ' + $author$project$Api$Provider$Patient$One$name(patient))
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCreateMembershipModal = function (model) {
	var _v0 = model.hX;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg,
			$author$project$Components$Patient$CreateMembershipModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Api$Provider$Patient$One$customForms = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.MC;
	});
var $author$project$Api$Provider$Practice$One$customForms = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.MC;
	});
var $author$project$Api$Provider$CustomForm$mergeForms = F2(
	function (practiceForms, patientForms) {
		var mergedForms = _Utils_ap(patientForms, practiceForms);
		return A2(
			$elm_community$list_extra$List$Extra$uniqueBy,
			function (_v0) {
				var record = _v0;
				return record.adR;
			},
			mergedForms);
	});
var $author$project$Api$Provider$CustomForm$formResponseId = function (_v0) {
	var record = _v0;
	return record.xI;
};
var $author$project$Api$Provider$CustomForm$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$CustomForm$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$CustomForm$questions = function (_v0) {
	var record = _v0;
	return record.Bj;
};
var $author$project$Pages$Patients$PatientId_String$Top$OpenEditCustomFormAnswerModal = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Utils$String$boolStringToYesNo = function (boolString) {
	return (boolString === 'true') ? 'Yes' : 'No';
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormAnswer = F2(
	function (answer, type_) {
		var text_ = function () {
			if (!type_) {
				return $author$project$Utils$String$boolStringToYesNo(answer);
			} else {
				return answer;
			}
		}();
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[
					$author$project$Ui$Typography$phi(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text_)
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormQuestion = F3(
	function (formId, formResponseId, question) {
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$CustomForm$title(question))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanMd(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$justifyRight]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Edit answer'},
											_List_fromArray(
												[
													$author$project$Ui$Button$sm,
													$author$project$Ui$Button$onClick(
													A3($author$project$Pages$Patients$PatientId_String$Top$OpenEditCustomFormAnswerModal, question, formId, formResponseId))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Edit Answer')
												]))
										]))
								]))
						])),
				$elm$core$List$isEmpty(
					$author$project$Api$Provider$CustomForm$answers(question)) ? _List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('None')
							]))
					]) : A2(
					$elm$core$List$map,
					function (answer) {
						return A2(
							$author$project$Pages$Patients$PatientId_String$Top$viewCustomFormAnswer,
							$author$project$Api$Provider$CustomForm$answerText(answer),
							$author$project$Api$Provider$CustomForm$questionType(question));
					},
					$author$project$Api$Provider$CustomForm$answers(question))));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCustomForm = function (customForm) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label(
				$author$project$Api$Provider$CustomForm$name(customForm)),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2(
					$elm$core$List$map,
					A2(
						$author$project$Pages$Patients$PatientId_String$Top$viewCustomFormQuestion,
						$author$project$Api$Provider$CustomForm$id(customForm),
						$author$project$Api$Provider$CustomForm$formResponseId(customForm)),
					$author$project$Api$Provider$CustomForm$questions(customForm)))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormsSection = function (_v0) {
	var patient = _v0.VM;
	var practice = _v0.WF;
	var customForms = A2(
		$author$project$Api$Provider$CustomForm$mergeForms,
		$author$project$Api$Provider$Practice$One$customForms(practice),
		$author$project$Api$Provider$Patient$One$customForms(patient));
	return $elm$core$List$isEmpty(customForms) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$titleSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Additional Info')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewCustomForm, customForms))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewDetachPatientModal = function (model) {
	return model.ii ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked(
			$author$project$Api$Provider$Patient$One$id(model.VM)),
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('detach'),
				$author$project$Components$HiConfirm$noun('patient'),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This patient will become independent of the network and be attached to your practice only.')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Provider$Patient$One$dpcPatient = function (_v0) {
	var record = _v0.b;
	return record.N$;
};
var $author$project$Ui$Form$Static$NoValue = {$: 3};
var $author$project$Ui$Form$Static$noValue = $author$project$Ui$Form$Static$NoValue;
var $author$project$Api$Provider$Patient$DpcPatient$status = function (_v0) {
	var dpc = _v0;
	return dpc.ag7;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewDpcPractice = F2(
	function (practice, patient) {
		var _v0 = $author$project$Api$Provider$Practice$One$accountType(practice);
		if (_v0 === 2) {
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('DPC Practice'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						function () {
						var _v1 = $author$project$Api$Provider$Patient$One$knownPractice(patient);
						if (!_v1.$) {
							var knownPractice = _v1.a;
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$KnownPractice$Shared$name(knownPractice) + ' '),
										function () {
										var _v2 = $author$project$Api$Provider$Patient$One$dpcPatient(patient);
										if (!_v2.$) {
											var dpcPatient = _v2.a;
											var _v3 = $author$project$Api$Provider$Patient$DpcPatient$status(dpcPatient);
											if (!_v3.$) {
												var status = _v3.a;
												return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
											} else {
												return $author$project$Utils$Html$empty;
											}
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									]));
						} else {
							return A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$noValue]),
								_List_Nil);
						}
					}()
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Patient$EditAthenaIdModal$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Patient$EditAthenaIdModal$Submit = {$: 2};
var $author$project$Components$Patient$EditAthenaIdModal$view = function (_v0) {
	var model = _v0;
	if (model.U9) {
		var footerContent = _List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Cancel and close modal'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Patient$EditAthenaIdModal$Close)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Save'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick($author$project$Components$Patient$EditAthenaIdModal$Submit)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Save')
					]))
			]);
		var enterpriseID = $author$project$Api$Provider$IntegrationRecord$All$integrationRecordId(model.qZ);
		var body = _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Partner IDs'),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You can find patient ID on athena’s patient chart next to their age and date of birth.')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$m0]),
						_List_fromArray(
							[
								$elm$html$Html$text('Changing the linked patient id will immediately push data to athena for this patient. If any conflicts arise, athena’s data will be automatically overwritten.')
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('#')
									])),
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(model.rw),
										$author$project$Ui$Form$Input$onInput($author$project$Components$Patient$EditAthenaIdModal$FormUpdated)
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$group(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$addon(
								_List_fromArray(
									[
										$elm$html$Html$text('E#')
									])),
								$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$value(
										A2($elm$core$Maybe$withDefault, '', enterpriseID)),
										$author$project$Ui$Form$Input$disabled(true)
									]))
							]))
					]))
			]);
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$EditAthenaIdModal$Close,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Edit Partner ID')
						])),
					$author$project$Ui$Modal$body(body),
					$author$project$Ui$Modal$footer(footerContent)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEditAthenaIdModal = function (model) {
	var _v0 = model.ir;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg,
			$author$project$Components$Patient$EditAthenaIdModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerCreated = {$: 4};
var $author$project$Components$Patient$EditCustomFormAnswerModal$Update = {$: 1};
var $author$project$Components$Patient$EditCustomFormAnswerModal$BooleanAnswerChanged = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer = F3(
	function (answer, newAnswer, displayAnswer) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: displayAnswer},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						$author$project$Api$Provider$CustomForm$answerText(answer),
						newAnswer)),
					$author$project$Ui$Button$onClick(
					A2($author$project$Components$Patient$EditCustomFormAnswerModal$BooleanAnswerChanged, answer, newAnswer))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(displayAnswer)
						]))
				]));
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewBooleanAnswers = function (formAnswer) {
	return $author$project$Ui$Button$group(
		_List_fromArray(
			[
				A3($author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer, formAnswer, 'true', 'Yes'),
				A3($author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer, formAnswer, 'false', 'No')
			]));
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerDeleted = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerUpdated = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput = F2(
	function (index, value) {
		return $author$project$Ui$Form$Input$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$value(value),
					$author$project$Ui$Form$Input$onInput(
					$author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerUpdated(index)),
					$author$project$Ui$Form$Input$phi(true)
				]));
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewMultipleStringAnswer = F3(
	function (index, value, isDestroyed) {
		if ((!isDestroyed.$) && isDestroyed.a) {
			return $author$project$Utils$Html$empty;
		} else {
			return A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(11)
							]),
						_List_fromArray(
							[
								A2($author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput, index, value)
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Delete multiple string answer'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$margin(7),
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$onClick(
										$author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerDeleted(index)),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
									]),
								_List_Nil)
							]))
					]));
		}
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewStringAnswer = F2(
	function (index, value) {
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanSm(12)
						]),
					_List_fromArray(
						[
							A2($author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput, index, value)
						]))
				]));
	});
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewBody = function (model) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$onSubmit($author$project$Components$Patient$EditCustomFormAnswerModal$Update),
				$author$project$Ui$Form$horizontal
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Answers to the Question'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(model.$G)
									])),
							function () {
								var _v0 = model.ahI;
								switch (_v0) {
									case 0:
										return A2($elm$core$List$map, $author$project$Components$Patient$EditCustomFormAnswerModal$viewBooleanAnswers, model.px);
									case 2:
										return A2(
											$elm$core$List$indexedMap,
											F2(
												function (index, answer) {
													return A2(
														$author$project$Components$Patient$EditCustomFormAnswerModal$viewStringAnswer,
														index,
														$author$project$Api$Provider$CustomForm$answerText(answer));
												}),
											model.px);
									default:
										return _Utils_ap(
											A2(
												$elm$core$List$indexedMap,
												F2(
													function (index, answer) {
														return A3(
															$author$project$Components$Patient$EditCustomFormAnswerModal$viewMultipleStringAnswer,
															index,
															$author$project$Api$Provider$CustomForm$answerText(answer),
															$author$project$Api$Provider$CustomForm$destroy(answer));
													}),
												model.px),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Add answer'},
													_List_fromArray(
														[
															$author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerCreated),
															$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Add Answer')
														]))
												]));
								}
							}()))
					]))
			]));
};
var $author$project$Components$Patient$EditCustomFormAnswerModal$viewFooter = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Cancel and close modal'},
		_List_fromArray(
			[
				$author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$Close)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Cancel')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Update'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$Update)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Update')
			]))
	]);
var $author$project$Components$Patient$EditCustomFormAnswerModal$view = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$Patient$EditCustomFormAnswerModal$Close,
		_List_fromArray(
			[
				$author$project$Ui$Modal$size(1)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Edit Answer')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$author$project$Components$Patient$EditCustomFormAnswerModal$viewBody(model)
					])),
				$author$project$Ui$Modal$footer($author$project$Components$Patient$EditCustomFormAnswerModal$viewFooter)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEditCustomFormAnswerModal = function (model) {
	var _v0 = model.fz;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg,
			$author$project$Components$Patient$EditCustomFormAnswerModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewElationForcePushConfirmModal = function (model) {
	return model.mk ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('sync To'),
				$author$project$Components$HiConfirm$noun('elation'),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						$elm$html$Html$text('You\'re about to sync to elation and override the conflicting values with their values here. This action cannot be undone.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$ResetBouncedEmail = {$: 67};
var $author$project$Api$Provider$EmailAddress$One$isRejected = function (_v0) {
	var record = _v0;
	return record.R5;
};
var $author$project$Api$Provider$EmailAddress$One$isUnsubscribed = function (_v0) {
	var record = _v0;
	return record.Sd;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEmailSection = F2(
	function (patient, emailAddressData) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_Nil,
			function () {
				if (emailAddressData.$ === 3) {
					if (!emailAddressData.a.$) {
						var emailAddress = emailAddressData.a.a;
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$EmailAddress$One$email(emailAddress))
													])),
												$author$project$Api$Provider$EmailAddress$One$isRejected(emailAddress) ? A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$Popover$view,
														_List_fromArray(
															[$author$project$Ui$Popover$dark]),
														_List_fromArray(
															[
																A2($author$project$Ui$Icon$view, _List_Nil, 19),
																$elm$html$Html$text('Invalid')
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Popover$heading,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('Email is invalid and will not be used')
																	]))
															]))
													])) : $author$project$Utils$Html$empty
											])),
										A2(
										$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
										'patient email',
										A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Api$Provider$Patient$One$email(patient)))
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$author$project$Api$Provider$EmailAddress$One$isBounced(emailAddress) ? A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Badge$view,
														_List_fromArray(
															[$author$project$Ui$Badge$danger]),
														_List_fromArray(
															[
																$elm$html$Html$text('Bounced')
															]))
													])),
												A3(
												$author$project$Ui$Button$view,
												{abp: 'Reset bounced status'},
												_List_fromArray(
													[
														$author$project$Ui$Button$styled(6),
														$author$project$Ui$Button$primary,
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ResetBouncedEmail),
														$author$project$Ui$Button$margin(7),
														$author$project$Ui$Button$pull(1),
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$repeat)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Reset Bounced Status')
													]))
											])) : ($author$project$Api$Provider$EmailAddress$One$isUnsubscribed(emailAddress) ? A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$view,
												_List_fromArray(
													[$author$project$Ui$Badge$warning]),
												_List_fromArray(
													[
														$elm$html$Html$text('Unsubscribed')
													]))
											])) : $author$project$Utils$Html$empty)
									]))
							]);
					} else {
						var _v1 = emailAddressData.a;
						return _List_fromArray(
							[$author$project$Utils$Html$empty]);
					}
				} else {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$text(
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$span(2)
										]))
								]))
						]);
				}
			}());
	});
var $author$project$Api$Common$EmergencyContact$Shared$name = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$EmergencyContact$Shared$record,
	function ($) {
		return $.zh;
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewPhone = function (phone) {
	var formattedPhone = function (number) {
		return $author$project$Formatters$Phone$formatWithCountry(number) + (' (' + ($author$project$Formatters$PhoneType$toString(
			$author$project$Api$Common$Phone$Shared$type_(phone)) + ')'));
	};
	var _v0 = $author$project$Api$Common$Phone$Shared$number(phone);
	if (!_v0.$) {
		var number = _v0.a;
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[
					$author$project$Ui$Typography$phi(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					formattedPhone(number)),
					A2(
					$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
					'patient phone',
					$author$project$Formatters$Phone$formatWithCountry(number))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEmergencyContact = function (emergencyContact) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$andThen,
					function (name) {
						return $elm$core$String$isEmpty(name) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
							A2(
								$elm$html$Html$div,
								_List_Nil,
								$elm$core$List$singleton(
									$elm$html$Html$text(name))));
					},
					$author$project$Api$Common$EmergencyContact$Shared$name(emergencyContact)),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Formatters$String$titleize,
						A2(
							$elm$core$Basics$composeR,
							$elm$html$Html$text,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$singleton,
								$elm$html$Html$div(_List_Nil)))),
					$author$project$Api$Common$EmergencyContact$Shared$relationship(emergencyContact)),
					A2(
					$elm$core$Maybe$map,
					function (email) {
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(email),
									A2($author$project$Pages$Patients$PatientId_String$Top$viewCopyButton, 'emergency contact email', email)
								]));
					},
					$author$project$Api$Common$EmergencyContact$Shared$email(emergencyContact)),
					A2(
					$elm$core$Maybe$map,
					function (phone) {
						return $author$project$Pages$Patients$PatientId_String$Top$viewPhone(phone);
					},
					$author$project$Api$Common$EmergencyContact$Shared$phone(emergencyContact))
				])));
};
var $author$project$Api$Provider$Patient$One$isMaster = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.RQ;
	});
var $author$project$Pages$Patients$PatientId_String$Top$EngagementClicked = {$: 59};
var $author$project$Pages$Patients$PatientId_String$Top$viewEngagementBadge = function (status) {
	var _v0 = function () {
		switch (status) {
			case 'currently_engaged':
				return _Utils_Tuple2($author$project$Ui$Badge$success, 'Currently Engaged');
			case 'previously_engaged':
				return _Utils_Tuple2($author$project$Ui$Badge$primary, 'Previously Engaged');
			default:
				return _Utils_Tuple2($author$project$Ui$Badge$danger, 'Never Engaged');
		}
	}();
	var color = _v0.a;
	var engagementStatus = _v0.b;
	return A3(
		$author$project$Ui$Button$view,
		{abp: engagementStatus},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$EngagementClicked)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[color]),
				_List_fromArray(
					[
						$elm$html$Html$text(engagementStatus)
					]))
			]));
};
var $author$project$Api$Provider$Patient$Engagement$invoice = function (_v0) {
	var engagement = _v0;
	return engagement.Rh;
};
var $author$project$Api$Provider$Patient$Engagement$lastEngagementDate = function (_v0) {
	var engagement = _v0;
	return engagement.Sy;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEngagementPopover = function (model) {
	var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.VM);
	var _v0 = _Utils_Tuple2(model.Fa, engagementStatus === 'never_engaged');
	if (!_v0.b) {
		if (_v0.a.$ === 3) {
			var _v1 = _v0.a;
			var engagement = _v1.a;
			var maybeLastEngagementDate = $author$project$Api$Provider$Patient$Engagement$lastEngagementDate(engagement);
			var maybeInvoice = $author$project$Api$Provider$Patient$Engagement$invoice(engagement);
			var _v2 = _Utils_Tuple2(maybeLastEngagementDate, maybeInvoice);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var lastEngagementDate = _v2.a.a;
				var invoice = _v2.b.a;
				var invoiceType = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
				var invoiceNumber = $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice);
				var invoiceId = $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice);
				var invoiceLink = function () {
					switch (invoiceType) {
						case 1:
							var patientId = $author$project$Api$Provider$Patient$One$id(model.VM);
							return A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
									{aea: invoiceId, VN: patientId}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'#' + $elm$core$String$fromInt(invoiceNumber))
									]));
						case 0:
							var companyId = function () {
								var _v5 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
								if (!_v5.$) {
									var company = _v5.a;
									return $author$project$Api$Common$Payable$Owner$Min$id(company);
								} else {
									return '';
								}
							}();
							return A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
									{ff: companyId, adR: invoiceId}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'#' + $elm$core$String$fromInt(invoiceNumber))
									]));
						default:
							return $author$project$Utils$Html$empty;
					}
				}();
				var engagementThreshold = $elm$core$String$fromInt(
					$author$project$Api$Provider$Practice$One$engagementThreshold(model.WF));
				var topText = function () {
					switch (engagementStatus) {
						case 'currently_engaged':
							return 'Received services within ' + (engagementThreshold + ' months');
						case 'previously_engaged':
							return 'Previously utilized services, none received in the past ' + (engagementThreshold + ' months');
						default:
							return '';
					}
				}();
				return A2(
					$author$project$Ui$Popover$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(topText)
								])),
							$author$project$Ui$HorizontalRule$view(
							_List_fromArray(
								[$author$project$Ui$HorizontalRule$thin])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Most recent service date: ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, lastEngagementDate))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice: '),
									invoiceLink
								]))
						]));
			} else {
				return A2($author$project$Ui$Popover$body, _List_Nil, _List_Nil);
			}
		} else {
			return A2($author$project$Ui$Popover$body, _List_Nil, _List_Nil);
		}
	} else {
		return A2(
			$author$project$Ui$Popover$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Individuals who have never received services')
						]))
				]));
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEngagement = function (model) {
	var hasSyncedRecord = $author$project$Api$Provider$Patient$One$isSynced(model.VM) || $author$project$Api$Provider$Patient$One$isMaster(model.VM);
	var gateIsAvailable = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		11,
		$author$project$Api$Practice$Provider(model.WF));
	if (gateIsAvailable || hasSyncedRecord) {
		var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.VM);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Engagement'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Ui$Popover$viewAsClickable,
							_List_fromArray(
								[
									$author$project$Ui$Popover$dark,
									$author$project$Ui$Popover$visible(
									$author$project$Ui$Popover$isOpen(model.aM))
								]),
							_List_fromArray(
								[
									$author$project$Pages$Patients$PatientId_String$Top$viewEngagementBadge(engagementStatus)
								]),
							_List_fromArray(
								[
									$author$project$Pages$Patients$PatientId_String$Top$viewEngagementPopover(model)
								]),
							model.aM)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewAutopaySection = function (patient) {
	var autopayStatus = $author$project$Api$Provider$Patient$One$autopay(patient) ? 'Enabled' : 'Disabled';
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[$author$project$Ui$Form$horizontal]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Autopay'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(autopayStatus)
									]))
							]))
					]))
			]));
};
var $author$project$Api$Provider$Patient$One$creditExpiresSoon = function (_v0) {
	var record = _v0.b;
	return record.Mk;
};
var $author$project$Api$Provider$Patient$One$creditInCents = function (_v0) {
	var record = _v0.b;
	return record.Ml;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCreditsSection = F3(
	function (practice, session, patient) {
		var manageCreditsLink = function () {
			var patientId = $author$project$Api$Provider$Patient$One$id(patient);
			return A2(
				$author$project$Permission$hideIfReadOnly,
				session,
				A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[
							$author$project$Ui$Typography$pull(1)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits(
								{VN: patientId}),
							_List_fromArray(
								[
									$author$project$Ui$Link$buttonDefault,
									$author$project$Ui$Link$disabled(
									$author$project$Api$Provider$Patient$One$archived(patient)),
									$author$project$Ui$Link$xs
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Manage Credits')
								]))
						])));
		}();
		var expirationText = $author$project$Api$Provider$Patient$One$creditExpiresSoon(patient) ? A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[$author$project$Ui$Typography$small, $author$project$Ui$Typography$danger]),
			_List_fromArray(
				[
					$elm$html$Html$text(' Expires soon')
				])) : $author$project$Utils$Html$empty;
		var creditInCents = $author$project$Utils$Currency$fromInt(
			$author$project$Api$Provider$Patient$One$creditInCents(patient));
		return A3(
			$author$project$Utils$FeatureGate$gate,
			4,
			$author$project$Api$Practice$Provider(practice),
			A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[$author$project$Ui$Form$horizontal]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Credits'),
								$author$project$Ui$Form$Group$labelSpanSm(3),
								$author$project$Ui$Form$Group$inputSpanSm(9)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(creditInCents),
												expirationText,
												manageCreditsLink
											]))
									]))
							]))
					])));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewInvoicesLink = function (patient) {
	var patientId = $author$project$Api$Provider$Patient$One$id(patient);
	return A2(
		$author$project$Ui$Typography$span,
		_List_fromArray(
			[
				$author$project$Ui$Typography$pull(1)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
					{VN: patientId}),
				_List_fromArray(
					[
						$author$project$Ui$Link$disabled(
						$author$project$Api$Provider$Patient$One$archived(patient))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('See Invoices')
					]))
			]));
};
var $author$project$Api$Provider$Patient$One$defaultSource = function (_v0) {
	var record = _v0.b;
	return record.Nl;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewNoPaymentMessage = function (patient) {
	return (($author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0) && $author$project$Utils$Maybe$isNothing(
		$author$project$Api$Provider$Patient$One$defaultSource(patient))) ? $elm$html$Html$text('There is no payment method for this account') : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$RequestPaymentInfoUpdateButtonClicked = {$: 13};
var $author$project$Api$Provider$Patient$One$sourcesCount = function (_v0) {
	var record = _v0.b;
	return record._l;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPaymentSourcesSection = F7(
	function (sendingRequestForPaymentInfo, patient, practice, patientRequestInfoSentAt, session, timeFormatter, isHintAdmin) {
		var lastRequestSent = function () {
			if (!patientRequestInfoSentAt.$) {
				var patientRequestInfoSentAt_ = patientRequestInfoSentAt.a;
				var sentAt = A2(timeFormatter, 1, patientRequestInfoSentAt_);
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$justifyRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text('Last request sent ' + (sentAt + '.'))
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[$author$project$Ui$Form$horizontal]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Default Payment Method'),
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v0 = $author$project$Api$Provider$Patient$One$defaultSource(patient);
									if (!_v0.$) {
										var defaultSource = _v0.a;
										var sourcesCount = $author$project$Api$Provider$Patient$One$sourcesCount(patient);
										var sourcesCountText = function () {
											if (sourcesCount > 1) {
												var additionalCount = sourcesCount - 1;
												return A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[
															$author$project$Ui$Typography$attrs(
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('pt-2')
																]))
														]),
													_List_fromArray(
														[
															A3(
															$author$project$Ui$Link$route,
															$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
																{
																	VN: $author$project$Api$Provider$Patient$One$id(patient)
																}),
															_List_fromArray(
																[
																	$author$project$Ui$Link$disabled(
																	$author$project$Api$Provider$Patient$One$archived(patient))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	'View ' + A2($author$project$Formatters$String$pluralize, 'additional payment option', additionalCount))
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}();
										var source = function () {
											if (!defaultSource.$) {
												var cardOne = defaultSource.a;
												return $author$project$Api$Source$Card(
													$author$project$Api$Card$ProviderOne(cardOne));
											} else {
												var bankAccountOne = defaultSource.a;
												return $author$project$Api$Source$BankAccount(
													$author$project$Api$BankAccount$ProviderOne(bankAccountOne));
											}
										}();
										return A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Components$PaymentSourceDisplayer$view,
															timeFormatter,
															_List_fromArray(
																[
																	$author$project$Components$PaymentSourceDisplayer$source(
																	$elm$core$Maybe$Just(source)),
																	$author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
																	$author$project$Components$PaymentSourceDisplayer$limitedView(false),
																	$author$project$Components$PaymentSourceDisplayer$showProcessor(isHintAdmin)
																])),
															sourcesCountText
														]))
												]));
									} else {
										var patientId = $author$project$Api$Provider$Patient$One$id(patient);
										var goToOrManagePaymentOptionsText = ($author$project$Api$Provider$Patient$One$sourcesCount(patient) > 0) ? 'Manage Payment Options' : 'Go to Payment Options';
										return A2(
											$author$project$Ui$FlexGrid$row,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Element$view,
															_List_Nil,
															_List_fromArray(
																[
																	A2($author$project$Ui$Badge$fromString, _List_Nil, 'none')
																]))
														])),
													A2(
													$author$project$Ui$FlexGrid$column,
													_List_fromArray(
														[
															$author$project$Ui$FlexGrid$spanMd(6)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Permission$hideIfReadOnly,
															session,
															A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$justifyRight]),
																_List_fromArray(
																	[
																		A3(
																		$author$project$Ui$Link$route,
																		$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
																			{VN: patientId}),
																		_List_fromArray(
																			[
																				$author$project$Ui$Link$disabled(
																				$author$project$Api$Provider$Patient$One$archived(patient))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(goToOrManagePaymentOptionsText)
																			]))
																	])))
														]))
												]));
									}
								}(),
									function () {
									if ((!$author$project$Api$Provider$Practice$One$acceptsAch(practice)) && (!$author$project$Api$Provider$Practice$One$acceptsCards(practice))) {
										return $author$project$Utils$Html$empty;
									} else {
										if (!$author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup(practice)) {
											return $author$project$Utils$Html$empty;
										} else {
											var sendOrResendRequestTest = function () {
												if (!patientRequestInfoSentAt.$) {
													return ' Resend Request For Payment Info';
												} else {
													return ' Send Request For Payment Info';
												}
											}();
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$justifyRight]),
												_List_fromArray(
													[
														A2(
														$author$project$Permission$hideIfReadOnly,
														session,
														A3(
															$author$project$Ui$Button$view,
															{abp: sendOrResendRequestTest},
															_List_fromArray(
																[
																	$author$project$Ui$Button$primary,
																	$author$project$Ui$Button$disabled(
																	$author$project$Api$Provider$Patient$One$archived(patient)),
																	$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RequestPaymentInfoUpdateButtonClicked),
																	$author$project$Ui$Button$loading(sendingRequestForPaymentInfo),
																	$author$project$Ui$Button$sm,
																	$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(sendOrResendRequestTest)
																])))
													]));
										}
									}
								}(),
									lastRequestSent
								]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewSurchargeEligibilitySection = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(patient) ? _Utils_Tuple2('Enabled', 'Fees will be passed through to the patient if they pay by credit card') : _Utils_Tuple2('Disabled', 'This patient is excluded from credit card passthrough fees');
	var surchargeStatus = _v0.a;
	var surchargeTooltip = _v0.b;
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[$author$project$Ui$Form$horizontal]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Surcharging'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Tooltip$view,
								_List_fromArray(
									[$author$project$Ui$Tooltip$wide]),
								surchargeTooltip,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(surchargeStatus)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewUnpaidWarning = function (patient) {
	return ($author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0) ? A2(
		$author$project$Ui$Typography$span,
		_List_fromArray(
			[
				$author$project$Ui$Typography$margin(10),
				$author$project$Ui$Typography$small,
				$author$project$Ui$Typography$danger
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$Icon$view, _List_Nil, 35),
				$elm$html$Html$text(' Unpaid Charges')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewFinancialInformation = function (_v0) {
	var patient = _v0.VM;
	var session = _v0.ZD;
	var practice = _v0.WF;
	var timeFormatter = _v0.Hy;
	var patientRequestInfoSentAt = _v0.Ao;
	var sendingRequestForPaymentInfo = _v0.j3;
	var isHintAdmin = _v0.FR;
	var owedInCents = $author$project$Utils$Currency$fromInt(
		$author$project$Api$Provider$Patient$One$owedInCents(patient));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$titleSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Financial Info')
					])),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[$author$project$Ui$Form$horizontal]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Balance'),
								$author$project$Ui$Form$Group$labelSpanSm(3),
								$author$project$Ui$Form$Group$inputSpanSm(9)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(owedInCents),
												$author$project$Pages$Patients$PatientId_String$Top$viewUnpaidWarning(patient),
												A2(
												$author$project$Permission$hideIfReadOnly,
												session,
												$author$project$Pages$Patients$PatientId_String$Top$viewInvoicesLink(patient))
											])),
										$author$project$Pages$Patients$PatientId_String$Top$viewNoPaymentMessage(patient)
									]))
							]))
					])),
				A3($author$project$Pages$Patients$PatientId_String$Top$viewCreditsSection, practice, session, patient),
				$author$project$Pages$Patients$PatientId_String$Top$viewAutopaySection(patient),
				A2(
				$author$project$Utils$Html$htmlIf,
				$author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice),
				$author$project$Pages$Patients$PatientId_String$Top$viewSurchargeEligibilitySection(patient)),
				A7($author$project$Pages$Patients$PatientId_String$Top$viewPaymentSourcesSection, sendingRequestForPaymentInfo, patient, practice, patientRequestInfoSentAt, session, timeFormatter, isHintAdmin)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$fullGenderIdentity = function (pat) {
	var fields = A2(
		$elm$core$List$map,
		$elm_community$string_extra$String$Extra$toSentenceCase,
		A2(
			$elm$core$List$filter,
			function (val) {
				return val !== 'not listed';
			},
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$author$project$Api$Provider$Patient$One$sex(pat),
						$author$project$Api$Provider$Patient$One$genderIdentity(pat),
						$author$project$Api$Provider$Patient$One$genderOther(pat),
						$author$project$Api$Provider$Patient$One$pronoun(pat)
					]))));
	return $elm$html$Html$text(
		A2($elm$core$String$join, ', ', fields));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewGenderSection = F2(
	function (practice, patient) {
		var gender = function () {
			if ($author$project$Api$Provider$Practice$One$transInclusivity(practice)) {
				return $author$project$Pages$Patients$PatientId_String$Top$fullGenderIdentity(patient);
			} else {
				var _v0 = $author$project$Api$Provider$Patient$One$gender(patient);
				if (!_v0.$) {
					var gender_ = _v0.a;
					return (gender_ === 'other') ? $elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							$author$project$Api$Provider$Patient$One$genderOther(patient))) : $elm$html$Html$text(gender_);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					_List_fromArray(
						[gender]))
				]));
	});
var $author$project$Ui$Icon$Current = 33;
var $author$project$Pages$Patients$PatientId_String$Top$viewHealthInsurance = function (patient) {
	var content = function () {
		var _v0 = $author$project$Api$Provider$Patient$One$healthInsurance(patient);
		if (!_v0.$) {
			var insurance = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'',
												$author$project$Api$Provider$HealthInsurance$Shared$payerName(insurance)))
										]))
								]))
						])),
					function () {
					var _v1 = $author$project$Api$Provider$HealthInsurance$Shared$groupId(insurance);
					if (!_v1.$) {
						var groupId = _v1.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Group ID: '),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(groupId)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v2 = $author$project$Api$Provider$HealthInsurance$Shared$memberId(insurance);
					if (!_v2.$) {
						var memberId = _v2.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Member ID: '),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(memberId)
										]))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}(),
					function () {
					var _v3 = $author$project$Api$Provider$HealthInsurance$Shared$highDeductible(insurance);
					if (!_v3.$) {
						var highDeductible = _v3.a;
						var icon = highDeductible ? A2($author$project$Ui$Icon$view, _List_Nil, 33) : A2($author$project$Ui$Icon$view, _List_Nil, 26);
						return A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[icon])),
									$elm$html$Html$text('  High Deductible Plan')
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}()
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$noValue]),
					_List_Nil)
				]);
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Insurance Carrier'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		content);
};
var $author$project$Utils$Route$integrationsRoute = function (practice) {
	return ((($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') || $author$project$Api$Provider$Practice$One$hasStripeAccount(practice)) && (!A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice))) ? $author$project$Spa$Generated$Route$Admin__Stripe : $author$project$Spa$Generated$Route$Admin__CardReaders;
};
var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalOpened = {$: 27};
var $author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Api$Provider$ExternalRecord$conflicts = function (_v0) {
	var record = _v0;
	return record.LH;
};
var $author$project$Api$Provider$ExternalRecord$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$ExternalRecord$source = function (_v0) {
	var record = _v0;
	return record.Hg;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewConflict = function (_v0) {
	var name = _v0.zh;
	var ours = _v0.afx;
	var theirs = _v0.ahq;
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(3)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(ours)
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$span,
						_List_fromArray(
							[
								$author$project$Ui$Typography$phi(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(theirs)
							]))
					]))
			]));
};
var $author$project$Api$Provider$ExternalRecord$statusCode = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecordStatusBadge = function (record) {
	var _v0 = $author$project$Api$Provider$ExternalRecord$statusCode(record);
	switch (_v0) {
		case 2:
			return A2($author$project$Ui$Badge$fromString, _List_Nil, 'errored');
		case 0:
			return A2($author$project$Ui$Badge$fromString, _List_Nil, 'synced');
		default:
			return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecord = F3(
	function (idx, conflictsVisible, record) {
		var source = $author$project$Api$Provider$ExternalRecord$source(record);
		var showConflicts = A2($elm$core$Maybe$withDefault, false, conflictsVisible);
		var maybeErrorMsg = $author$project$Api$Provider$ExternalRecord$errorMessage(record);
		var conflictsList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$Api$Provider$ExternalRecord$conflicts(record));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(
					$author$project$Formatters$String$titleize(source)),
					$author$project$Ui$Form$Group$labelSpan(3),
					$author$project$Ui$Form$Group$inputSpan(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(2)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-control-static')
										]),
									_List_fromArray(
										[
											(source === 'elation') ? $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecordStatusBadge(record) : $author$project$Utils$Html$empty
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(10)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('form-control-static')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-muted'),
													$elm$html$Html$Attributes$class('text-body-small'),
													$elm$html$Html$Attributes$class('ml-1')
												]),
											_List_fromArray(
												[
													function () {
													if (!maybeErrorMsg.$) {
														var error = maybeErrorMsg.a;
														return $elm$html$Html$text(error);
													} else {
														return $author$project$Utils$Html$empty;
													}
												}()
												])),
											$elm$core$List$isEmpty(conflictsList) ? $author$project$Utils$Html$empty : (showConflicts ? A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pull-right')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Hide conflicts'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$onClick(
															A2($author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts, idx, false))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Hide conflicts')
														]))
												])) : A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('pull-right')
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Button$view,
													{abp: 'Show conflicts'},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$onClick(
															A2($author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts, idx, true))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Show conflicts')
														]))
												])))
										]))
								]))
						])),
					showConflicts ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('well'),
							$elm$html$Html$Attributes$class('well-sm')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(3)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-label-md')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Field')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(4)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-label-md')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Our Value')
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(4)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('text-label-md')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Elation\'s Value')
												]))
										]))
								])),
						A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewConflict, conflictsList))) : $author$project$Utils$Html$empty,
					showConflicts ? A3(
					$author$project$Ui$Button$view,
					{abp: 'Sync to elation anyways'},
					_List_fromArray(
						[
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$styled(4),
							$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalOpened)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Sync to Elation Anyway')
						])) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Ui$Icon$NewWindow = 31;
var $author$project$Pages$Patients$PatientId_String$Top$WebLinkClicked = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$ExecuteActionForIntegrationRecord = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Api$Provider$IntegrationRecord$Meta$actions = function (_v0) {
	var record = _v0;
	return record.tF;
};
var $author$project$Api$Provider$IntegrationRecord$Shared$meta = function (_v0) {
	var record = _v0;
	return record.TU;
};
var $author$project$Api$Provider$IntegrationRecord$One$meta = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$meta(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$meta = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$meta(one);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecordActions = F2(
	function (maybeMenu, record) {
		if (maybeMenu.$ === 1) {
			return $author$project$Utils$Html$empty;
		} else {
			var menuModel = maybeMenu.a;
			var actions = A2(
				$elm$core$List$filterMap,
				function (action) {
					return action.abs ? $elm$core$Maybe$Just(
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									A2($author$project$Pages$Patients$PatientId_String$Top$ExecuteActionForIntegrationRecord, action.zh, record))
								]),
							$elm$html$Html$text(action.Nx))) : $elm$core$Maybe$Nothing;
				},
				$author$project$Api$Provider$IntegrationRecord$Meta$actions(
					$author$project$Api$Provider$IntegrationRecord$All$meta(record)));
			return A4(
				$author$project$Ui$NewDropdown$view,
				_List_fromArray(
					[$author$project$Ui$NewDropdown$buttonSm]),
				_List_fromArray(
					[
						$elm$html$Html$text('Actions')
					]),
				actions,
				menuModel);
		}
	});
var $author$project$Api$Provider$IntegrationRecord$Shared$webLink = function (_v0) {
	var record = _v0;
	return record.aaV;
};
var $author$project$Api$Provider$IntegrationRecord$One$webLink = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$IntegrationRecord$Shared$webLink(shared);
};
var $author$project$Api$Provider$IntegrationRecord$All$webLink = function (_v0) {
	var one = _v0;
	return $author$project$Api$Provider$IntegrationRecord$One$webLink(one);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecord = F4(
	function (pat, timeFormatter, maybeMenu, record) {
		var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$name(
			$author$project$Api$Provider$IntegrationRecord$All$integration(record));
		if ((!$author$project$Api$Provider$Patient$One$syncToEmr(pat)) && (integrationName === 'Elation')) {
			return $author$project$Utils$Html$empty;
		} else {
			var webLink = function () {
				var _v3 = $author$project$Api$Provider$IntegrationRecord$All$webLink(record);
				if (!_v3.$) {
					var link = _v3.a;
					return A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-control-static')
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'View in ' + integrationName},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$onClick(
										$author$project$Pages$Patients$PatientId_String$Top$WebLinkClicked(link))
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 31),
										$elm$html$Html$text(' View in ' + integrationName)
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}();
			var unsyncedReason = function () {
				var _v2 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
				if (!_v2.$) {
					var reason = _v2.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(reason)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}();
			var lastSyncedAt = function () {
				var _v1 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
				if (!_v1.$) {
					var time = _v1.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'on ' + A2(timeFormatter, 0, time))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}();
			var errorMessage = function () {
				var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
				if (!_v0.$) {
					var message = _v0.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-1')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(message)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}();
			var additionalInfo = A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('form-control-static'),
						$elm$html$Html$Attributes$class('text-muted'),
						$elm$html$Html$Attributes$class('text-body-sm')
					]),
				_List_fromArray(
					[unsyncedReason, errorMessage, lastSyncedAt]));
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(integrationName),
						$author$project$Ui$Form$Group$labelSpan(3),
						$author$project$Ui$Form$Group$inputSpan(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Badge$fromString,
												_List_Nil,
												$author$project$Api$IntegrationRecord$Status$toString(
													$author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record))),
												additionalInfo,
												webLink
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecordActions, maybeMenu, record)
											]))
									]))
							]))
					]));
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationsSection = function (_v0) {
	var practice = _v0.WF;
	var patient = _v0.VM;
	var timeFormatter = _v0.Hy;
	var integrationRecordDropdowns = _v0.fM;
	var integrationRecords = _v0.Q8;
	var integrationConflictsVisible = _v0.qY;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$titleSm(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Skeleton$ifLoading,
						integrationRecords,
						$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Integrations')
								])),
						$elm$html$Html$text('Integrations'))
					])),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[$author$project$Ui$Form$horizontal]),
				_List_fromArray(
					[
						function () {
						if (integrationRecords.$ === 3) {
							var integrationRecords_ = integrationRecords.a;
							var externalRecords_ = $author$project$Api$Provider$Patient$One$integrations(patient);
							return ($elm$core$List$isEmpty(externalRecords_) && $elm$core$List$isEmpty(integrationRecords_)) ? A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('No integrations are active. View integrations '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Utils$Route$integrationsRoute(practice),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('here.')
											]))
									])) : A2(
								$elm$html$Html$div,
								_List_Nil,
								A2(
									$elm$core$List$append,
									A2(
										$elm$core$List$indexedMap,
										function (idx) {
											return A2(
												$author$project$Pages$Patients$PatientId_String$Top$viewExternalRecord,
												idx,
												A2($elm_community$list_extra$List$Extra$getAt, idx, integrationConflictsVisible));
										},
										externalRecords_),
									A2(
										$elm$core$List$indexedMap,
										function (idx) {
											return A3(
												$author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecord,
												patient,
												timeFormatter,
												A2($elm_community$list_extra$List$Extra$getAt, idx, integrationRecordDropdowns));
										},
										integrationRecords_)));
						} else {
							return A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSkeleton('Integration name'),
										$author$project$Ui$Form$Group$labelSpan(3),
										$author$project$Ui$Form$Group$inputSpan(9)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(3)
													]))
											]))
									]));
						}
					}()
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewJoinDate = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$joinedPracticeDate(patient);
	if (!_v0.$) {
		var date = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Joined Practice'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewLeadSource = function (patient) {
	var content = function () {
		var _v0 = $author$project$Api$Provider$Patient$One$leadSource(patient);
		if (!_v0.$) {
			var leadSource = _v0.a;
			var leadSourceName = $author$project$Api$Provider$LeadSource$Shared$name(leadSource);
			var leadSourceStr = (leadSourceName === 'Other') ? A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Patient$One$leadSourceOther(patient)) : leadSourceName;
			return A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(leadSourceStr)
					]));
		} else {
			return A2(
				$author$project$Ui$Form$Static$view,
				_List_fromArray(
					[$author$project$Ui$Form$Static$noValue]),
				_List_Nil);
		}
	}();
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Lead Source'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[content]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewLocation = F2(
	function (practice, patient) {
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var maybeLocation = $author$project$Api$Provider$Patient$One$location(patient);
		var _v0 = _Utils_Tuple2(trackPatientsByLocation, maybeLocation);
		if (_v0.a && (!_v0.b.$)) {
			var location = _v0.b.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Location'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Location$Shared$name(location))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$PatientEmail$All$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Components$Patient$ManagePortalAccessModal$PortalStatusToggled = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Patient$ManagePortalAccessModal$patientInfo = F2(
	function (isCurrentPatient, patientEmail) {
		var thisPatientText = isCurrentPatient ? A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(' (this patient)')
				])) : $author$project$Utils$Html$empty;
		var patient = $author$project$Api$Provider$PatientEmail$All$patient(patientEmail);
		return A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{
							VN: $author$project$Api$Provider$Patient$Min$id(patient)
						}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Patient$Min$name(patient))
						])),
					thisPatientText
				]));
	});
var $author$project$Ui$ToggleSwitch$Sm = {$: 3};
var $author$project$Ui$ToggleSwitch$sm = $author$project$Ui$ToggleSwitch$Sm;
var $author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail = F3(
	function (patientEmailsEnabled, isCurrentPatient, patientEmail) {
		var isPortalEnabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				A2(
					$elm_community$list_extra$List$Extra$find,
					function (pe) {
						return _Utils_eq(
							pe.a,
							$author$project$Api$Provider$PatientEmail$All$id(patientEmail));
					},
					patientEmailsEnabled)));
		return A2(
			$author$project$Ui$Element$view,
			_List_Nil,
			_List_fromArray(
				[
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(5)
								]),
							_List_fromArray(
								[
									A2($author$project$Components$Patient$ManagePortalAccessModal$patientInfo, isCurrentPatient, patientEmail)
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(1),
									$author$project$Ui$FlexGrid$offset(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$sm,
											$author$project$Ui$ToggleSwitch$on(isPortalEnabled),
											$author$project$Ui$ToggleSwitch$onChange(
											$author$project$Components$Patient$ManagePortalAccessModal$PortalStatusToggled(patientEmail))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmails = F3(
	function (patientEmailsEnabled, data, currentPatientId) {
		switch (data.$) {
			case 3:
				var patientEmails = data.a;
				var _v1 = A2(
					$elm$core$List$partition,
					function (patientEmail) {
						return _Utils_eq(
							$author$project$Api$Provider$Patient$Min$id(
								$author$project$Api$Provider$PatientEmail$All$patient(patientEmail)),
							currentPatientId);
					},
					patientEmails);
				var thesePatients = _v1.a;
				var otherPatientEmails = _v1.b;
				return _Utils_ap(
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail, patientEmailsEnabled, true),
						thesePatients),
					A2(
						$elm$core$List$map,
						A2($author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail, patientEmailsEnabled, false),
						otherPatientEmails));
			case 1:
				return _List_fromArray(
					[
						$elm$html$Html$text('Loading...')
					]);
			default:
				return _List_fromArray(
					[$author$project$Utils$Html$empty]);
		}
	});
var $author$project$Components$Patient$ManagePortalAccessModal$view = function (_v0) {
	var model = _v0;
	if (model.U9) {
		var body = A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[$author$project$Ui$Form$horizontal]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Portal access for members using this patient\'s email address:')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					A3(
						$author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmails,
						model.nl,
						model.Am,
						$author$project$Api$Provider$Patient$One$id(model.VM)))
				]));
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Patient$ManagePortalAccessModal$Closed,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Manage Portal Access')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[body]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewManagePortalAccessModal = function (model) {
	var _v0 = model.i5;
	if (!_v0.$) {
		var modal = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg,
			$author$project$Components$Patient$ManagePortalAccessModal$view(modal));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCoveragePlanName = function (membership) {
	return $elm$html$Html$text(
		A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$CoveragePlan$One$name,
				A2(
					$author$project$Api$Expandable$withDefault,
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan(
						$author$project$Api$Provider$Membership$One$plan(membership))))));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageRules = F2(
	function (model, membership) {
		var _v0 = model.L5;
		if (!_v0.$) {
			var modelCoveragePlanRules = _v0.a;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$clearfix,
							$author$project$Ui$Form$Group$label('Coverage Plan')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$bold]),
											_List_fromArray(
												[
													$author$project$Pages$Patients$PatientId_String$Top$viewCoveragePlanName(membership)
												]))
										]))
								])),
							function () {
							var coverageDocuments = A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$CoveragePlan$One$coverageDocuments,
								A2(
									$author$project$Api$Expandable$withDefault,
									$elm$core$Maybe$Nothing,
									$author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan(
										$author$project$Api$Provider$Membership$One$plan(membership))));
							return A2(
								$elm$core$Maybe$withDefault,
								$author$project$Utils$Html$empty,
								A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$viewAsList, coverageDocuments));
						}()
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9),
							$author$project$Ui$Form$Group$label('')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									$author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg,
									$author$project$Components$Admin$CoveragePlans$Rules$view(modelCoveragePlanRules))
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor = function (syncDetails) {
	if (!syncDetails.$) {
		var details = syncDetails.a;
		var companyName = A2(
			$author$project$Api$Expandable$withDefault,
			$elm$core$Maybe$Nothing,
			$author$project$Api$Provider$Patient$SyncDetail$companyName(details));
		if (!companyName.$) {
			var name = companyName.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Coverage Sponsor'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(name)
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageType = function (syncDetails) {
	if (!syncDetails.$) {
		var details = syncDetails.a;
		var coverageType = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$author$project$Api$Expandable$withDefault,
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Patient$SyncDetail$coverageType(details))));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Coverage Type'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[coverageType]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$SvgIcon$alert = $author$project$Ui$SvgIcon$viewIcon(5);
var $author$project$Ui$Alert$HardNotification = {$: 3};
var $author$project$Ui$Alert$hardNotification = $author$project$Ui$Alert$HardNotification;
var $author$project$Ui$Alert$m0 = $author$project$Ui$Alert$Margin(25);
var $author$project$Pages$Patients$PatientId_String$Top$viewInformationalAlert = F3(
	function (networkCoveragePlan, coveragePlan, coverageRuleUsages) {
		var _v0 = _Utils_Tuple3(networkCoveragePlan, coveragePlan, coverageRuleUsages);
		if (((!_v0.a.$) && (_v0.b.$ === 1)) && (_v0.c.$ === 3)) {
			var _v1 = _v0.b;
			var _v2 = _v0.c;
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$HorizontalRule$view(
						_List_fromArray(
							[$author$project$Ui$HorizontalRule$double])),
						A2(
						$author$project$Ui$Alert$warning,
						_List_fromArray(
							[$author$project$Ui$Alert$hardNotification, $author$project$Ui$Alert$m0]),
						_List_fromArray(
							[
								$author$project$Ui$SvgIcon$alert(_List_Nil),
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('These rules are for informational purposes and will not be applied to charges. Please contact your affiliated network with any questions.')
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewMemberType = function (syncDetails) {
	if (!syncDetails.$) {
		var details = syncDetails.a;
		var memberType = $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$author$project$Api$Expandable$withDefault,
					$elm$core$Maybe$Nothing,
					$author$project$Api$Provider$Patient$SyncDetail$memberType(details))));
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Member Type'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$bold]),
							_List_fromArray(
								[memberType]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Ui$Element$Bold = 3;
var $author$project$Ui$Element$fontBold = $author$project$Ui$Element$Text(3);
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipName = function (membership) {
	return $elm$html$Html$text(
		$author$project$Api$Provider$Plan$SharedWithContractInfo$name(
			$author$project$Api$Provider$Membership$One$plan(membership)));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan = function (membership) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Membership Plan')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$fontBold]),
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Top$viewMembershipName(membership)
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$periodName = function (periodInMonths) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Period$rateName,
			$author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate = function (membership) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9),
				$author$project$Ui$Form$Group$label('Rate')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Utils$Currency$fromInt(
											$author$project$Api$Provider$Membership$One$periodRateInCents(membership)) + (' ' + $author$project$Pages$Patients$PatientId_String$Top$periodName(
											$author$project$Api$Provider$Membership$One$periodInMonths(membership))))
									]))
							]))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageDocuments = function (coverageDouments) {
	if (!coverageDouments.$) {
		var coverageDocuments_ = coverageDouments.a;
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$margin(2)
				]),
			_List_fromArray(
				[
					$author$project$Components$Admin$CoverageDocuments$Form$viewAsList(coverageDocuments_)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageRules = F2(
	function (model, syncDetails) {
		var _v0 = _Utils_Tuple3(model.Up, model.L5, model.L7);
		if (((!_v0.a.$) && (_v0.b.$ === 1)) && (_v0.c.$ === 3)) {
			var networkRules = _v0.a.a;
			var _v1 = _v0.b;
			var _v2 = _v0.c;
			var coveragePlan = A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Provider$Patient$SyncDetail$coveragePlan,
					$author$project$Api$Expandable$withDefault($elm$core$Maybe$Nothing)),
				syncDetails);
			var coverageDocuments = A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$coverageDocuments, coveragePlan);
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9),
						$author$project$Ui$Form$Group$label('Network Coverage Plan')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageDocuments(coverageDocuments),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg,
								$author$project$Components$Admin$CoveragePlans$Rules$view(networkRules))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipDetailsModal = function (model) {
	return model.m2 ? A3(
		$author$project$Ui$Modal$view,
		$author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed,
		_List_fromArray(
			[
				$author$project$Ui$Modal$size(2)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Memberships Details')
					])),
				$author$project$Ui$Modal$body(
				function () {
					var _v0 = _Utils_Tuple2(model.ja, model.L7);
					_v0$3:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var _v1 = _v0.a;
										var membership = _v1.a;
										var _v2 = _v0.b;
										var affiliateSyncDetails = function () {
											var _v3 = model.u7;
											if (_v3.$ === 3) {
												var details = _v3.a;
												return details;
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return A2(
											$elm$core$List$cons,
											$author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan(membership),
											A2(
												$elm$core$List$cons,
												$author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate(membership),
												A2(
													$elm$core$List$cons,
													A3($author$project$Pages$Patients$PatientId_String$Top$viewInformationalAlert, model.Up, model.L5, model.L7),
													A2(
														$elm$core$List$cons,
														$author$project$Pages$Patients$PatientId_String$Top$viewCoverageType(affiliateSyncDetails),
														A2(
															$elm$core$List$cons,
															$author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor(affiliateSyncDetails),
															A2(
																$elm$core$List$cons,
																$author$project$Pages$Patients$PatientId_String$Top$viewMemberType(affiliateSyncDetails),
																A2(
																	$elm$core$List$cons,
																	A2($author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageRules, model, affiliateSyncDetails),
																	A2($author$project$Pages$Patients$PatientId_String$Top$viewCoverageRules, model, membership))))))));
									case 0:
										var _v4 = _v0.a;
										var membership = _v4.a;
										var _v5 = _v0.b;
										var affiliateSyncDetails = function () {
											var _v6 = model.u7;
											if (_v6.$ === 3) {
												var details = _v6.a;
												return details;
											} else {
												return $elm$core$Maybe$Nothing;
											}
										}();
										return _List_fromArray(
											[
												$author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan(membership),
												$author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate(membership),
												$author$project$Pages$Patients$PatientId_String$Top$viewCoverageType(affiliateSyncDetails),
												$author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor(affiliateSyncDetails),
												$author$project$Pages$Patients$PatientId_String$Top$viewMemberType(affiliateSyncDetails)
											]);
									default:
										break _v0$3;
								}
							case 1:
								var _v7 = _v0.a;
								return A2(
									$elm$core$List$repeat,
									3,
									A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9),
												$author$project$Ui$Form$Group$labelSkeleton('Detail')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$span(4)
															]))
													]))
											])));
							default:
								break _v0$3;
						}
					}
					return _List_Nil;
				}()),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Close modal'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
										$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Close')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Provider$MembershipPatient$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$status(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$NewMembershipButtonClicked = {$: 17};
var $author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalShown = F2(
	function (a, b) {
		return {$: 40, a: a, b: b};
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate(shared);
};
var $justinmimbs$date$Date$min = F2(
	function (dateA, dateB) {
		var a = dateA;
		var b = dateB;
		return (_Utils_cmp(a, b) < 0) ? dateA : dateB;
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextBillDate = function (_v0) {
	var record = _v0.b;
	return record.UC;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextInvoiceDueDate = function (_v0) {
	var record = _v0.b;
	return record.UG;
};
var $author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships = F2(
	function (currentDate, membershipPatient) {
		var nextInvoiceDueDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextInvoiceDueDate(membershipPatient);
		var nextBillDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextBillDate(membershipPatient);
		var effectiveEndDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate(membershipPatient);
		return _Utils_ap(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (date) {
						return ' until ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
					},
					effectiveEndDate)),
			_Utils_ap(
				function () {
					if (!nextInvoiceDueDate.$) {
						var date = nextInvoiceDueDate.a;
						return _Utils_ap(
							_Utils_eq(
								A2($justinmimbs$date$Date$min, date, currentDate),
								date) ? ' past due invoices starting ' : ' next invoice due ',
							A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date));
					} else {
						return '';
					}
				}(),
				function () {
					var _v1 = _Utils_Tuple2(nextBillDate, nextInvoiceDueDate);
					if ((!_v1.a.$) && (_v1.b.$ === 1)) {
						var date = _v1.a.a;
						var _v2 = _v1.b;
						return ' next due ' + A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date);
					} else {
						return '';
					}
				}()));
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$id = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$id(shared);
};
var $author$project$Api$Provider$MembershipPatient$Shared$membership = function (_v0) {
	var record = _v0;
	return record.ja;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$membership = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$membership(shared);
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner = function (_v0) {
	var record = _v0.b;
	return record.Vp;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$plan = function (_v0) {
	var record = _v0.b;
	return record.GH;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$startDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$MembershipPatient$Shared$startDate(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipActions = F3(
	function (session, patient, membershipPatient) {
		var patientId = $author$project$Api$Provider$Patient$One$id(patient);
		var membershipId = $author$project$Api$Provider$Membership$Min$id(
			$author$project$Api$Provider$MembershipPatient$ForPatientOne$membership(membershipPatient));
		var disabled = $author$project$Api$Provider$Patient$One$archived(patient);
		var actionText = (($author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient) === 'ended') || $author$project$Api$Provider$Patient$One$isSynced(patient)) ? 'See Membership' : (($author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient) !== 'ended') ? 'Edit Membership' : '');
		var body = A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
				{yS: membershipId, VN: patientId}),
			_List_fromArray(
				[
					$author$project$Ui$Link$disabled(disabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(actionText)
				]));
		return A2($author$project$Permission$hideIfReadOnly, session, body);
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored = function (_v0) {
	var record = _v0.b;
	return record.R7;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPayerInfo = F2(
	function (patient, membershipPatient) {
		var _v0 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner(membershipPatient);
		if (!_v0.$) {
			var owner = _v0.a;
			var patientId = $author$project$Api$Provider$Patient$One$id(patient);
			var ownerId = $author$project$Api$Provider$Patient$Min$id(owner);
			if (!_Utils_eq(patientId, ownerId)) {
				var _v1 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored(membershipPatient);
				if (!_v1.$) {
					var isSponsored = _v1.a;
					var ownerName = $author$project$Api$Provider$Patient$Min$name(owner);
					var link = A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{VN: ownerId}),
						_List_fromArray(
							[
								$author$project$Ui$Link$disabled(
								$author$project$Api$Provider$Patient$One$archived(patient))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(ownerName)
									]))
							]));
					return isSponsored ? A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Dependent of '),
								link
							])) : A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Paid by '),
								link
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			} else {
				return $author$project$Utils$Html$empty;
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Provider$MembershipPatient$ForPatientOne$company = function (_v0) {
	var record = _v0.b;
	return record.ab9;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewSponsorInfo = F2(
	function (patient, membershipPatient) {
		var maybeCompany = $author$project$Api$Provider$MembershipPatient$ForPatientOne$company(membershipPatient);
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored(membershipPatient),
			maybeCompany);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var company = _v0.b.a;
			return A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Api$Provider$Patient$One$isSynced(patient) ? $elm$html$Html$text('Network: ') : $elm$html$Html$text('Employer: '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
							{
								ff: $author$project$Api$Provider$Company$Min$id(company)
							}),
						_List_fromArray(
							[
								$author$project$Ui$Link$disabled(
								$author$project$Api$Provider$Patient$One$archived(patient))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Company$Min$name(company))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient = F5(
	function (session, patient, currentDate, affiliateSyncDetails, membershipPatient) {
		var status = $author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient);
		var showSponsorInfo = $author$project$Api$Provider$Patient$One$isSynced(patient) && ((status === 'active') || (status === 'unpaid'));
		var description = function () {
			switch (status) {
				case 'pending':
					return ' begins ' + A2(
						$justinmimbs$date$Date$format,
						'MM/dd/yyyy',
						$author$project$Api$Provider$MembershipPatient$ForPatientOne$startDate(membershipPatient));
				case 'unconfirmed':
					return ' awaiting confirmation';
				case 'active':
					return A2($author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships, currentDate, membershipPatient);
				case 'unpaid':
					return A2($author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships, currentDate, membershipPatient);
				case 'ended':
					var _v5 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate(membershipPatient);
					if (!_v5.$) {
						var date = _v5.a;
						return ' ended on ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
					} else {
						return '';
					}
				default:
					return '';
			}
		}();
		var button = A3(
			$author$project$Ui$Button$view,
			{abp: 'See membership details'},
			_List_fromArray(
				[
					$author$project$Ui$Button$margin(20),
					$author$project$Ui$Button$margin(3),
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$styled(0),
					$author$project$Ui$Button$onClick(
					A2(
						$author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalShown,
						$author$project$Api$Provider$Membership$Min$id(
							$author$project$Api$Provider$MembershipPatient$ForPatientOne$membership(membershipPatient)),
						$author$project$Api$Provider$MembershipPatient$ForPatientOne$id(membershipPatient)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('See Membership Details')
				]));
		var badge = function () {
			var _v3 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner(membershipPatient);
			if (!_v3.$) {
				var owner = _v3.a;
				return A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
						{
							VN: $author$project$Api$Provider$Patient$Min$id(owner)
						}),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_fromArray(
								[
									$author$project$Ui$Badge$test('membership-status')
								]),
							status)
						]));
			} else {
				return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
									_List_fromArray(
										[
											badge,
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Plan$Min$name(
														$author$project$Api$Provider$MembershipPatient$ForPatientOne$plan(membershipPatient)))
												])),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text(description)
												]))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A3($author$project$Pages$Patients$PatientId_String$Top$viewMembershipActions, session, patient, membershipPatient)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Pages$Patients$PatientId_String$Top$viewPayerInfo, patient, membershipPatient)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Pages$Patients$PatientId_String$Top$viewSponsorInfo, patient, membershipPatient)
								])),
							function () {
							if (showSponsorInfo) {
								var syncDetails = function () {
									if (affiliateSyncDetails.$ === 3) {
										var details = affiliateSyncDetails.a;
										return details;
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								var companyName = function () {
									if (!syncDetails.$) {
										var details_ = syncDetails.a;
										return A2(
											$author$project$Api$Expandable$withDefault,
											$elm$core$Maybe$Nothing,
											$author$project$Api$Provider$Patient$SyncDetail$companyName(details_));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}();
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											if (!companyName.$) {
												var name = companyName.a;
												return A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Employer: ' + name)
														]));
											} else {
												return A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Retail ')
														]));
											}
										}()
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							button
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCurrentMemberships = F5(
	function (session, currentDate, patient, syncDetails, membershipPatients) {
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Current and Pending'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			function () {
				if ($author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive') {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_fromArray(
										[
											$author$project$Ui$Badge$test('membership-status')
										]),
									'inactive'),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$pull(1)
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'New membership'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$NewMembershipButtonClicked)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('New Membership')
												]))
										]))
								]))
						]);
				} else {
					if ($elm$core$List$isEmpty(membershipPatients)) {
						return _List_fromArray(
							[$author$project$Utils$Html$empty]);
					} else {
						var firstFiveMembershipPatients = A2($elm$core$List$take, 5, membershipPatients);
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A4($author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient, session, patient, currentDate, syncDetails),
											firstFiveMembershipPatients)),
										($elm$core$List$length(membershipPatients) > 5) ? A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
											{
												VN: $author$project$Api$Provider$Patient$One$id(patient)
											}),
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('See all memberships')
											])) : $author$project$Utils$Html$empty
									]))
							]);
					}
				}
			}());
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewPastMemberships = F5(
	function (session, currentDate, patient, syncDetails, membershipPatients) {
		var firstFiveMembershipPatients = A2($elm$core$List$take, 5, membershipPatients);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Past'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A4($author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient, session, patient, currentDate, syncDetails),
								firstFiveMembershipPatients)),
							($elm$core$List$length(membershipPatients) > 5) ? A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
								{
									VN: $author$project$Api$Provider$Patient$One$id(patient)
								}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('See all memberships')
								])) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipSection = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$titleSm(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Skeleton$ifLoading,
						model.TF,
						$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Memberships')
								])),
						$elm$html$Html$text('Memberships'))
					])),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[$author$project$Ui$Form$horizontal]),
				function () {
					var _v0 = model.TF;
					if (_v0.$ === 3) {
						var membershipPatients = _v0.a;
						var _v1 = A2(
							$elm$core$List$partition,
							function (item) {
								return $author$project$Api$Provider$MembershipPatient$ForPatientOne$status(item) === 'ended';
							},
							membershipPatients);
						var endedMembershipPatients = _v1.a;
						var currentMembershipPatients = _v1.b;
						return _List_fromArray(
							[
								(($author$project$Api$Provider$Patient$One$membershipStatus(model.VM) === 'inactive') || (!$elm$core$List$isEmpty(currentMembershipPatients))) ? A5($author$project$Pages$Patients$PatientId_String$Top$viewCurrentMemberships, model.ZD, model.cO, model.VM, model.u7, currentMembershipPatients) : $author$project$Utils$Html$empty,
								$elm$core$List$isEmpty(endedMembershipPatients) ? $author$project$Utils$Html$empty : A5($author$project$Pages$Patients$PatientId_String$Top$viewPastMemberships, model.ZD, model.cO, model.VM, model.u7, endedMembershipPatients)
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSkeleton('Membership'),
										$author$project$Ui$Form$Group$labelSpanSm(3),
										$author$project$Ui$Form$Group$inputSpanSm(9)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(10),
														$author$project$Ui$Skeleton$block
													])),
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(2),
														$author$project$Ui$Skeleton$block
													]))
											]))
									]))
							]);
					}
				}())
			]));
};
var $author$project$Api$Provider$Patient$One$mergedInto = function (_v0) {
	var record = _v0.b;
	return record.TT;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMergedInto = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$mergedInto(patient);
	if (!_v0.$) {
		var merged = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Merged Into'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
										{
											VN: $author$project$Api$Provider$Patient$Min$id(merged)
										}),
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$Patient$Min$name(merged))
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$DetachPatientButtonClicked = {$: 35};
var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkLinkageAlert = function (patient) {
	return ($author$project$Api$Provider$Patient$One$isSynced(patient) && ($author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive')) ? A2(
		$author$project$Ui$Alert$info,
		_List_fromArray(
			[$author$project$Ui$Alert$mb2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_fromArray(
					[$author$project$Ui$FlexGrid$rowItemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1),
								$author$project$Ui$FlexGrid$span(2),
								$author$project$Ui$FlexGrid$textCenter
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Icon$view,
								_List_fromArray(
									[$author$project$Ui$Icon$large]),
								38)
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(8),
								$author$project$Ui$FlexGrid$span(10)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('This patient\'s record is still linked to the network.')
											]))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Detach this patient from the network to manage their complete profile and memberships.')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(3),
								$author$project$Ui$FlexGrid$justifyRight
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Detach the patient'},
								_List_fromArray(
									[
										$author$project$Ui$Button$styled(6),
										$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$DetachPatientButtonClicked)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Detach the patient')
									]))
							]))
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Provider$PatientPackage$All$endedPackages = $elm$core$List$filter(
	function (_v0) {
		var record = _v0;
		return record.ag7 === 1;
	});
var $author$project$Pages$Patients$PatientId_String$Top$OpenPackageDetailsModal = function (a) {
	return {$: 71, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPrepaidCharge = function (prepaidCharge) {
	var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
	var remainingText = '(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)');
	var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
	var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(originalQty) + (' ' + name))
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
				_List_fromArray(
					[
						$elm$html$Html$text(' ' + remainingText)
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPackage = function (_package) {
	var purchasedOn_ = A2(
		$justinmimbs$date$Date$format,
		'MM/dd/yyyy',
		$author$project$Api$Provider$PatientPackage$All$purchasedOn(_package));
	var prepaidCharges_ = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(_package);
	var prepaidChargesView = A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPrepaidCharge, prepaidCharges_);
	var packageName_ = $author$project$Api$Provider$PatientPackage$All$packageName(_package);
	var packageDetailsButton = A3(
		$author$project$Ui$Button$view,
		{abp: 'See package details'},
		_List_fromArray(
			[
				$author$project$Ui$Button$margin(20),
				$author$project$Ui$Button$margin(3),
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$styled(0),
				$author$project$Ui$Button$onClick(
				$author$project$Pages$Patients$PatientId_String$Top$OpenPackageDetailsModal(_package))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('See Package Details')
			]));
	var expiresAt_ = A2(
		$elm$core$Maybe$map,
		$justinmimbs$date$Date$format('MM/dd/yyyy'),
		$author$project$Api$Provider$PatientPackage$All$expiresAt(_package));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(packageName_),
								A2($elm$html$Html$div, _List_Nil, prepaidChargesView),
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$small,
										$author$project$Ui$Typography$muted,
										$author$project$Ui$Typography$margin(20)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Purchased on ' + purchasedOn_)
									])),
								function () {
								if (!expiresAt_.$) {
									var expiryDate = expiresAt_.a;
									return A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$small,
												$author$project$Ui$Typography$muted,
												$author$project$Ui$Typography$margin(20)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Expires on ' + expiryDate)
											]));
								} else {
									return $elm$html$Html$text('');
								}
							}()
							]))
					])),
				packageDetailsButton
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewActivePackages = function (packages) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Active'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPackage, packages))
					]))
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$ToggleEndedPackages = {$: 70};
var $author$project$Pages$Patients$PatientId_String$Top$viewEndedPackages = F2(
	function (showingEnded, packages) {
		var icon = showingEnded ? A2($author$project$Ui$Icon$view, _List_Nil, 28) : A2($author$project$Ui$Icon$view, _List_Nil, 27);
		var endedCount = $elm$core$List$length(packages);
		var buttonText = 'View Ended (' + ($elm$core$String$fromInt(endedCount) + ')');
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Ended'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: buttonText},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleEndedPackages)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonText),
									$author$project$Utils$Html$noBreakSpace,
									icon
								])),
							showingEnded ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-2')
								]),
							A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPackage, packages)) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewNoActivePackages = A2(
	$author$project$Ui$Form$Group$view,
	_List_fromArray(
		[
			$author$project$Ui$Form$Group$label('Active'),
			$author$project$Ui$Form$Group$labelSpanSm(3),
			$author$project$Ui$Form$Group$inputSpanSm(9)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('None')
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Top$viewNoEndedPackages = A2(
	$author$project$Ui$Form$Group$view,
	_List_fromArray(
		[
			$author$project$Ui$Form$Group$label('Ended'),
			$author$project$Ui$Form$Group$labelSpanSm(3),
			$author$project$Ui$Form$Group$inputSpanSm(9)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('None')
						]))
				]))
		]));
var $author$project$Pages$Patients$PatientId_String$Top$viewPackagesSection = function (model) {
	var packagesEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.WF);
	return packagesEnabled ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Panel$titleSm(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Skeleton$ifLoading,
						model.z4,
						$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$spanFromText('Packages')
								])),
						$elm$html$Html$text('Packages'))
					])),
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[$author$project$Ui$Form$horizontal]),
				function () {
					var _v0 = model.z4;
					if (_v0.$ === 3) {
						var patientPackages = _v0.a;
						var endedPackages_ = $author$project$Api$Provider$PatientPackage$All$endedPackages(patientPackages);
						var activePackages_ = $author$project$Api$Provider$PatientPackage$All$activePackages(patientPackages);
						return _List_fromArray(
							[
								(!$elm$core$List$isEmpty(activePackages_)) ? $author$project$Pages$Patients$PatientId_String$Top$viewActivePackages(activePackages_) : $author$project$Pages$Patients$PatientId_String$Top$viewNoActivePackages,
								(!$elm$core$List$isEmpty(endedPackages_)) ? A2($author$project$Pages$Patients$PatientId_String$Top$viewEndedPackages, model.sR, endedPackages_) : $author$project$Pages$Patients$PatientId_String$Top$viewNoEndedPackages
							]);
					} else {
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$labelSkeleton('Package'),
										$author$project$Ui$Form$Group$labelSpanSm(3),
										$author$project$Ui$Form$Group$inputSpanSm(9)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(10),
														$author$project$Ui$Skeleton$block
													])),
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(2),
														$author$project$Ui$Skeleton$block
													]))
											]))
									]))
							]);
					}
				}())
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPhonesSection = function (patient) {
	var phones = $author$project$Api$Provider$Patient$One$phones(patient);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPhone, phones));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPractitioner = function (patient) {
	var _v0 = $author$project$Api$Provider$Patient$One$practitioner(patient);
	if (!_v0.$) {
		var practitioner = _v0.a;
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Practitioner'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$Practitioner$Shared$name(practitioner))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPreferredLanguage = F2(
	function (practice, patient) {
		var multiLanguage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice);
		return multiLanguage ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Preferred Language'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Language$toLabel(
								$author$project$Api$Provider$Patient$One$preferredLanguage(patient)))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewPrimaryCareClinic = F2(
	function (practice, patient) {
		var syncByAffiliation = A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Network$Shared$syncByAffiliation,
			$author$project$Api$Provider$Practice$One$network(practice));
		var affiliationName = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Affiliate$AffiliateMin$name,
				$author$project$Api$Provider$Patient$One$assignedAffiliation(patient)));
		var _v0 = _Utils_Tuple2(affiliationName, syncByAffiliation);
		if (((!_v0.a.$) && (!_v0.b.$)) && _v0.b.a) {
			var name = _v0.a.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Primary Care Clinic'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Ui$ProfilePicture$Alt = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$ProfilePicture$alt = $author$project$Ui$ProfilePicture$Alt;
var $author$project$Ui$ProfilePicture$Size = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$ProfilePicture$size = $author$project$Ui$ProfilePicture$Size;
var $author$project$Ui$ProfilePicture$defaultOptions = {vw: _List_Nil, qS: _List_Nil};
var $author$project$Ui$ProfilePicture$pxSize = function (px) {
	return $elm$core$String$fromInt(px) + 'px';
};
var $author$project$Ui$ProfilePicture$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var px = option.a;
						return _Utils_update(
							record,
							{
								vw: $elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A2(
												$elm$html$Html$Attributes$style,
												'width',
												$author$project$Ui$ProfilePicture$pxSize(px)),
												A2(
												$elm$html$Html$Attributes$style,
												'height',
												$author$project$Ui$ProfilePicture$pxSize(px))
											]),
											record.vw
										]))
							});
					case 1:
						var string = option.a;
						return _Utils_update(
							record,
							{
								qS: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$alt(string),
									record.qS)
							});
					default:
						var string = option.a;
						return _Utils_update(
							record,
							{
								vw: A2(
									$elm$core$List$cons,
									$elm$html$Html$Attributes$class(string),
									record.vw)
							});
				}
			}),
		$author$project$Ui$ProfilePicture$defaultOptions,
		options);
};
var $author$project$Ui$ProfilePicture$view = F2(
	function (options, profilePictureUrl) {
		var optionsRecord = $author$project$Ui$ProfilePicture$optionsToRecord(options);
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('profile-picture'),
				optionsRecord.vw),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$src(profilePictureUrl),
						optionsRecord.qS),
					_List_Nil)
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewProfilePicture = function (_v0) {
	var patient = _v0.VM;
	var profilePictureUrl = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Provider$Patient$One$profilePictureUrl(patient));
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$label('Profile Picture'),
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(9)
			]),
		_List_fromArray(
			[
				($elm$core$String$length(profilePictureUrl) > 0) ? A2(
				$author$project$Ui$ProfilePicture$view,
				_List_fromArray(
					[
						$author$project$Ui$ProfilePicture$alt(
						$author$project$Api$Provider$Patient$One$name(patient)),
						$author$project$Ui$ProfilePicture$size(80)
					]),
				profilePictureUrl) : A2(
				$author$project$Ui$Form$Static$view,
				_List_fromArray(
					[$author$project$Ui$Form$Static$noValue]),
				_List_Nil)
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewRemoveEphiWaiverModal = function (model) {
	return model.nX ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed,
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('Remove'),
				$author$project$Components$HiConfirm$noun('ePHI Waiver'),
				$author$project$Components$HiConfirm$titleizeNoun(false),
				$author$project$Components$HiConfirm$centerText(false),
				$author$project$Components$HiConfirm$customMessage(
				_List_fromArray(
					[
						$elm$html$Html$text('You\'re about to remove ePHI waiver for this patient. You will no longer be able to send emails to this patient. You can re-authorize at any time.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewRemoveSponsorshipModal = function (model) {
	var _v0 = model.da;
	if (_v0.a && (!_v0.b.$)) {
		var employeeOrDependant = _v0.b.a;
		var _v1 = function () {
			switch (employeeOrDependant.$) {
				case 0:
					var account = employeeOrDependant.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Provider$Patient$Min$name,
								$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account))),
						$author$project$Api$Provider$Company$Min$name(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
				case 1:
					var account = employeeOrDependant.a;
					var registration = employeeOrDependant.b;
					return _Utils_Tuple2(
						$author$project$Api$Provider$Patient$Min$name(
							$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)),
						$author$project$Api$Provider$Company$Min$name(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
				default:
					var account = employeeOrDependant.a;
					var patient = employeeOrDependant.c;
					return _Utils_Tuple2(
						$author$project$Api$Provider$Patient$One$name(patient),
						$author$project$Api$Provider$Company$Min$name(
							$author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
			}
		}();
		var patientName = _v1.a;
		var companyName = _v1.b;
		var details = 'This will permanently remove ' + (patientName + (' from ' + (companyName + '. Are you sure?')));
		return A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed(employeeOrDependant),
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text(details)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$confirmRestorePatientMessage = function (patientName) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Are you sure you want to restore ' + (patientName + '? This will allow you to restart their membership, payments, and emails.'))
						]))
				]))
		]);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewRestorePatientModal = function (model) {
	return model.jT ? A2(
		$author$project$Components$HiConfirm$modal,
		$author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked(
			$author$project$Api$Provider$Patient$One$id(model.VM)),
		_List_fromArray(
			[
				$author$project$Components$HiConfirm$verb('restore'),
				$author$project$Components$HiConfirm$noun('patient'),
				$author$project$Components$HiConfirm$customMessage(
				$author$project$Pages$Patients$PatientId_String$Top$confirmRestorePatientMessage(
					$author$project$Api$Provider$Patient$One$name(model.VM)))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Pages$Patients$PatientId_String$Top$FetchPlainSSN = {$: 0};
var $author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber = function (_v0) {
	var record = _v0;
	return record.Tn;
};
var $author$project$Api$Provider$Patient$One$ssn = function (_v0) {
	var record = _v0.b;
	return record._C;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewSSNSection = function (_v0) {
	var session = _v0.ZD;
	var practice = _v0.WF;
	var patient = _v0.VM;
	var plainSSN = _v0.AR;
	var hinterViewOff = _v0.adN;
	if ($author$project$Api$Provider$Practice$One$ssnEnabled(practice)) {
		var maybeSSN = function () {
			if (plainSSN.$ === 3) {
				var data = plainSSN.a;
				return $author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber(data);
			} else {
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber,
					$author$project$Api$Provider$Patient$One$ssn(patient));
			}
		}();
		if (!maybeSSN.$) {
			var ssn = maybeSSN.a;
			return A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('SSN'),
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(ssn)
											])),
										function () {
										if (plainSSN.$ === 3) {
											return $author$project$Utils$Html$empty;
										} else {
											return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0) ? A3(
												$author$project$Ui$Button$view,
												{abp: 'Show full number'},
												_List_fromArray(
													[
														$author$project$Ui$Button$sm,
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$FetchPlainSSN)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Show Full Number')
													])) : $author$project$Utils$Html$empty;
										}
									}()
									]))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$GenerateDebugPortalUrl = {$: 73};
var $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalOpened = {$: 62};
var $author$project$Pages$Patients$PatientId_String$Top$SendAccessLink = {$: 3};
var $author$project$Api$Provider$EmailAddress$One$isPortalEnabled = function (_v0) {
	var record = _v0;
	return record.Wy;
};
var $author$project$Pages$Patients$PatientId_String$Top$viewSelfService = F8(
	function (sendingAccessLink, timeFormatter, accountAccessSentAt, lastPortalAccessedAt, dataEmailAddress, patient, isHintAdmin, hintEnv) {
		var patientArchived = $author$project$Api$Provider$Patient$One$archived(patient);
		var noEmail = _Utils_eq(
			$author$project$Api$Provider$Patient$One$email(patient),
			$elm$core$Maybe$Nothing);
		var hasDisabledPortal = function () {
			if ((dataEmailAddress.$ === 3) && (!dataEmailAddress.a.$)) {
				var emailAddress = dataEmailAddress.a.a;
				return !$author$project$Api$Provider$EmailAddress$One$isPortalEnabled(emailAddress);
			} else {
				return false;
			}
		}();
		var cannotRequestAccountAccess = patientArchived || noEmail;
		var accessLinkButton = A3(
			$author$project$Ui$Button$view,
			{abp: 'Send access link to patient'},
			_List_fromArray(
				[
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$SendAccessLink),
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$margin(7),
					$author$project$Ui$Button$disabled(cannotRequestAccountAccess || hasDisabledPortal),
					$author$project$Ui$Button$loading(sendingAccessLink),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Send an Access Link')
				]));
		var links = function () {
			if (cannotRequestAccountAccess) {
				var tooltipMsg = patientArchived ? 'The patient is archived.' : (noEmail ? 'The patient must have a valid email address to send the access link.' : '');
				return A3(
					$author$project$Ui$Tooltip$view,
					_List_Nil,
					tooltipMsg,
					_List_fromArray(
						[accessLinkButton]));
			} else {
				var managePortalAccessButton = A3(
					$author$project$Ui$Button$view,
					{abp: 'Manage portal access'},
					_List_fromArray(
						[
							$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalOpened),
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$disabled(cannotRequestAccountAccess)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage Portal Access')
						]));
				var lastSent = function () {
					if (!accountAccessSentAt.$) {
						var time = accountAccessSentAt.a;
						return A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$mt2]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Last sent ' + (A2(timeFormatter, 1, time) + '.'))
								]));
					} else {
						return $author$project$Utils$Html$empty;
					}
				}();
				var debugPortalUrlButton = (isHintAdmin && (!_Utils_eq(
					hintEnv,
					$elm$core$Maybe$Just(0)))) ? A3(
					$author$project$Ui$HinterOnly$button,
					{abp: 'View as member'},
					_List_fromArray(
						[
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$margin(7),
							$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$GenerateDebugPortalUrl)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('View as Member')
						])) : $author$project$Utils$Html$empty;
				var accessLink = hasDisabledPortal ? A3(
					$author$project$Ui$Tooltip$view,
					_List_Nil,
					'This patient\'s portal access is disabled. You can manage this access using the Manage Portal Access button above.',
					_List_fromArray(
						[accessLinkButton])) : accessLinkButton;
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol, $author$project$Ui$Element$itemsEnd]),
					_List_fromArray(
						[managePortalAccessButton, accessLink, debugPortalUrlButton, lastSent]));
			}
		}();
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Patient Portal'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									if (!lastPortalAccessedAt.$) {
										var time = lastPortalAccessedAt.a;
										return $elm$html$Html$text(
											'Last accessed ' + A2(timeFormatter, 1, time));
									} else {
										return $elm$html$Html$text('Never accessed');
									}
								}()
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[links]))
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalOpened = {$: 8};
var $author$project$Pages$Patients$PatientId_String$Top$ToggleViewPastSponsorships = {$: 12};
var $author$project$Api$Provider$Practice$One$hasActiveCompanies = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.P0;
	});
var $author$project$Api$Provider$CompanyAccount$Shared$needsApproval = function (_v0) {
	var record = _v0.b;
	return record.Um;
};
var $author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$needsApproval(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$Dependent = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Pages$Patients$PatientId_String$Top$Employee = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$account = function (_v0) {
	var record = _v0.b;
	return record.H3;
};
var $author$project$Api$Provider$Patient$One$companyRegistrations = function (_v0) {
	var record = _v0.b;
	return record.Lz;
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalOpened = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$CompanyAccount$Shared$terminationRequestedAt = function (_v0) {
	var record = _v0.b;
	return record.ahp;
};
var $author$project$Api$Provider$CompanyAccount$ForPatient$terminationRequestedAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyAccount$Shared$terminationRequestedAt(shared);
};
var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$type_ = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$DependentThrough = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewDependent = F5(
	function (session, account, removingSponsorship, index, registration) {
		var isBeingRemoved = function () {
			if (((!removingSponsorship.a) && (!removingSponsorship.b.$)) && (removingSponsorship.b.a.$ === 1)) {
				var _v2 = removingSponsorship.b.a;
				var reg = _v2.b;
				return _Utils_eq(
					$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(reg),
					$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(registration)) ? A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 8),
							$elm$html$Html$text('Removing')
						])) : $author$project$Ui$FlexGrid$none;
			} else {
				return $author$project$Ui$FlexGrid$none;
			}
		}();
		var canRemove = !$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(account);
		var removeLink = canRemove ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Delete dependent'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened(
						A2($author$project$Pages$Patients$PatientId_String$Top$DependentThrough, account, registration))),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
				]),
			_List_Nil) : $author$project$Utils$Html$empty;
		var _v0 = (index > 0) ? _Utils_Tuple2(
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$offset(2),
					$author$project$Ui$FlexGrid$span(4)
				]),
			$author$project$Ui$FlexGrid$none) : _Utils_Tuple2(
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$span(4)
				]),
			A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(2)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Dependents: ')
					])));
		var style = _v0.a;
		var dependentsTitle = _v0.b;
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					dependentsTitle,
					A2(
					$author$project$Ui$FlexGrid$column,
					style,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
										{
											VN: $author$project$Api$Provider$Patient$Min$id(
												$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration))
										}),
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Patient$Min$name(
														$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)))
												]))
										])),
									A2($author$project$Permission$hideIfReadOnly, session, removeLink)
								]))
						])),
					isBeingRemoved
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewDependents = F4(
	function (session, patient, companyAccount, removingSponsorship) {
		var dependents = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$type_,
				$elm$core$Basics$neq('employee')),
			$author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(companyAccount));
		var canAddDependent = (!$author$project$Utils$Maybe$toBool(
			$author$project$Api$Provider$CompanyAccount$ForPatient$terminationRequestedAt(companyAccount))) && (!$author$project$Api$Provider$Patient$One$isSynced(patient));
		var addDependentButton = canAddDependent ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Add dependent'},
			_List_fromArray(
				[
					$author$project$Ui$Button$sm,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Top$AddDependentModalOpened(companyAccount)),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$add)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Dependent')
				])) : $author$project$Utils$Html$empty;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					($elm$core$List$length(dependents) > 0) ? A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A3($author$project$Pages$Patients$PatientId_String$Top$viewDependent, session, companyAccount, removingSponsorship),
						dependents)) : $author$project$Utils$Html$empty,
					addDependentButton
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount = F2(
	function (_v0, companyAccount) {
		var session = _v0.ZD;
		var patient = _v0.VM;
		var removingSponsorship = _v0.da;
		var patientIsEmployee = _Utils_eq(
			$elm$core$Maybe$Just(
				$author$project$Api$Provider$Patient$One$id(patient)),
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Patient$Min$id,
				$author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount)));
		var isBeingRemoved = function () {
			_v3$2:
			while (true) {
				if ((!removingSponsorship.a) && (!removingSponsorship.b.$)) {
					switch (removingSponsorship.b.a.$) {
						case 0:
							var account = removingSponsorship.b.a.a;
							return _Utils_eq(
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(account),
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)) ? A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 8),
										$elm$html$Html$text('Removing')
									])) : $author$project$Utils$Html$empty;
						case 2:
							var _v4 = removingSponsorship.b.a;
							var account = _v4.a;
							return _Utils_eq(
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(account),
								$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)) ? A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 8),
										$elm$html$Html$text('Removing')
									])) : $author$project$Utils$Html$empty;
						default:
							break _v3$2;
					}
				} else {
					break _v3$2;
				}
			}
			return $author$project$Utils$Html$empty;
		}();
		var employeeOrDependentText = patientIsEmployee ? _List_fromArray(
			[
				$elm$html$Html$text(' Employee ')
			]) : _List_fromArray(
			[
				$elm$html$Html$text(' Dependent through '),
				function () {
				var _v2 = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount);
				if (!_v2.$) {
					var pat = _v2.a;
					return A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{
								VN: $author$project$Api$Provider$Patient$Min$id(pat)
							}),
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Api$Provider$Patient$Min$name(pat))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]);
		var employeeOrDependant = A2($author$project$Ui$Typography$span, _List_Nil, employeeOrDependentText);
		var canRemove = patientIsEmployee ? (!($author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(companyAccount) || $author$project$Api$Provider$Patient$One$isSynced(patient))) : (!$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(companyAccount));
		var removeLink = function () {
			if (canRemove) {
				if (patientIsEmployee) {
					return A3(
						$author$project$Ui$Button$view,
						{abp: 'Remove sponsorship'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
								$author$project$Ui$Button$onClick(
								$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened(
									$author$project$Pages$Patients$PatientId_String$Top$Employee(companyAccount))),
								$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
							]),
						_List_Nil);
				} else {
					var registrationForAccount = $elm$core$List$head(
						A2(
							$elm$core$List$filter,
							function (reg) {
								return _Utils_eq(
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$CompanyAccount$Min$id,
										$author$project$Api$Provider$CompanyRegistration$ForPatientOne$account(reg)),
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
							},
							$author$project$Api$Provider$Patient$One$companyRegistrations(patient)));
					if (!registrationForAccount.$) {
						var registration = registrationForAccount.a;
						return A3(
							$author$project$Ui$Button$view,
							{abp: 'Remove sponsorship'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened(
										A3($author$project$Pages$Patients$PatientId_String$Top$Dependent, companyAccount, registration, patient))),
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$delete)
								]),
							_List_Nil);
					} else {
						return $author$project$Utils$Html$empty;
					}
				}
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Element$custom,
							'inline-flex',
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[
										$author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval(companyAccount) ? $elm$core$Maybe$Just(
										A2(
											$author$project$Ui$Badge$view,
											_List_fromArray(
												[
													$author$project$Ui$Badge$warning,
													$author$project$Ui$Badge$test('sponsorship-needs-approval')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Needs Approval')
												]))) : $elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(
										A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
												{
													ff: $author$project$Api$Provider$Company$Min$id(
														$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount))
												}),
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(
													_List_fromArray(
														[
															A2(
															$elm$url$Url$Builder$string,
															'q',
															$author$project$Api$Provider$Patient$One$name(patient))
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Company$Min$name(
														$author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)))
												])))
									]))),
							A2(
							$elm$html$Html$small,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-muted')
								]),
							_List_fromArray(
								[
									employeeOrDependant,
									A2($author$project$Permission$hideIfReadOnly, session, removeLink)
								]))
						])),
					isBeingRemoved,
					patientIsEmployee ? A4($author$project$Pages$Patients$PatientId_String$Top$viewDependents, session, patient, companyAccount, removingSponsorship) : $author$project$Utils$Html$empty
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewSponsorshipsSection = function (model) {
	if ($author$project$Api$Provider$Practice$One$hasActiveCompanies(model.WF)) {
		var pendingSponsorships = A2($elm$core$List$filter, $author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval, model.gR);
		var pastSponsorships = A2(
			$elm$core$List$filter,
			function (account) {
				return (!$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(account)) && (!$author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval(account));
			},
			model.gR);
		var eligibleSponsorships = A2($elm$core$List$filter, $author$project$Api$Provider$CompanyAccount$ForPatient$isEligible, model.gR);
		var anyPendingSponsorship = $elm$core$List$length(pendingSponsorships) > 0;
		var anyPastSponsorship = $elm$core$List$length(pastSponsorships) > 0;
		var anyEligibleSponsorship = $elm$core$List$length(eligibleSponsorships) > 0;
		var addSponsorshipLink = $author$project$Api$Provider$Patient$One$isSynced(model.VM) ? $author$project$Utils$Html$empty : A2(
			$author$project$Permission$hideIfReadOnly,
			model.ZD,
			A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$pull(1)
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Add sponsorship'},
						_List_fromArray(
							[
								$author$project$Ui$Button$disabled(
								$author$project$Api$Provider$Patient$One$archived(model.VM)),
								$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalOpened),
								$author$project$Ui$Button$sm
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Add Sponsorship')
							]))
					])));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$HorizontalRule$view(_List_Nil),
					$author$project$Ui$Panel$titleSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Sponsorships')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Eligible Sponsorship'),
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9)
						]),
					A2(
						$elm$core$List$cons,
						addSponsorshipLink,
						anyEligibleSponsorship ? A2(
							$elm$core$List$map,
							$author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model),
							eligibleSponsorships) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$noValue]),
								_List_Nil)
							]))),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Pending Sponsorship'),
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9)
						]),
					A2(
						$elm$core$List$cons,
						addSponsorshipLink,
						anyPendingSponsorship ? A2(
							$elm$core$List$map,
							$author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model),
							pendingSponsorships) : _List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_fromArray(
									[$author$project$Ui$Form$Static$noValue]),
								_List_Nil)
							]))),
					model.or ? A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Past Sponsorship'),
							$author$project$Ui$Form$Group$labelSpanSm(3),
							$author$project$Ui$Form$Group$inputSpanSm(9)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model),
						pastSponsorships)) : $author$project$Utils$Html$empty,
					anyPastSponsorship ? A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$offsetSm(3),
											$author$project$Ui$FlexGrid$spanSm(9)
										]),
									_List_fromArray(
										[
											function () {
											var _v0 = model.or ? _Utils_Tuple2(
												'Hide past sponsorships ',
												A2($author$project$Ui$Icon$view, _List_Nil, 28)) : _Utils_Tuple2(
												'See past sponsorships ',
												A2($author$project$Ui$Icon$view, _List_Nil, 27));
											var label = _v0.a;
											var icon = _v0.b;
											return A3(
												$author$project$Ui$Button$view,
												{abp: label},
												_List_fromArray(
													[
														$author$project$Ui$Button$link,
														$author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleViewPastSponsorships)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(label),
														icon
													]));
										}()
										]))
								]))
						])) : $author$project$Utils$Html$empty
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$PatientId_String$Top$viewTobaccoSection = F2(
	function (practice, patient) {
		var tobaccoEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice);
		return tobaccoEnabled ? A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Tobacco Use'),
					$author$project$Ui$Form$Group$labelSpanSm(3),
					$author$project$Ui$Form$Group$inputSpanSm(9)
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = $author$project$Api$Provider$Patient$One$usesTobacco(patient);
					if (!_v0.$) {
						var usesTobaccoBool = _v0.a;
						var usesTobaccoStr = usesTobaccoBool ? 'Uses tobacco' : 'Does not use tobacco';
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(usesTobaccoStr)
								]));
					} else {
						return A2(
							$author$project$Ui$Form$Static$view,
							_List_fromArray(
								[$author$project$Ui$Form$Static$noValue]),
							_List_Nil);
					}
				}()
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Api$Provider$Addon$Min$sendsExternalEmail = function (_v0) {
	var record = _v0;
	return record.Zw;
};
var $author$project$Api$Provider$PatientMceEligibility$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$PatientMceEligibility$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PatientMceEligibility$Shared$status(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$SendAddonEmail = function (a) {
	return {$: 54, a: a};
};
var $author$project$Pages$Patients$PatientId_String$Top$viewEmailableAddon = F2(
	function (addonRequestsLoading, addon) {
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Addon$Min$name(addon)),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Send enrollment email'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$pull(1),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$Patients$PatientId_String$Top$SendAddonEmail(addon)),
							$author$project$Ui$Button$loading(
							A2(
								$elm$core$Set$member,
								$author$project$Api$Provider$Addon$Min$id(addon),
								addonRequestsLoading))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Send Enrollment Email')
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$SendMceActivationEmail = function (a) {
	return {$: 56, a: a};
};
var $author$project$Api$Provider$PatientMceEligibility$Shared$message = function (_v0) {
	var record = _v0;
	return record.aeD;
};
var $author$project$Api$Provider$PatientMceEligibility$All$message = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PatientMceEligibility$Shared$message(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewMceSendActivationButton = F2(
	function (mceActivationsLoading, patientMceEligibility) {
		var message = A2(
			$elm$core$Maybe$withDefault,
			'',
			$author$project$Api$Provider$PatientMceEligibility$All$message(patientMceEligibility));
		return $elm$core$String$isEmpty(message) ? A3(
			$author$project$Ui$Button$view,
			{abp: ' Send enrollment email'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$primary,
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$PatientId_String$Top$SendMceActivationEmail(patientMceEligibility)),
					$author$project$Ui$Button$loading(
					A2(
						$elm$core$Set$member,
						$author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility),
						mceActivationsLoading)),
					$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send),
					$author$project$Ui$Button$sm
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Send Enrollment Email')
				])) : A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(message)
				]));
	});
var $author$project$Api$Provider$PatientMceEligibility$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$PatientMceEligibility$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$PatientMceEligibility$Shared$name(shared);
};
var $author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility = function (patientMceEligibility) {
	var message = A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Provider$PatientMceEligibility$All$message(patientMceEligibility));
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$PatientMceEligibility$All$name(patientMceEligibility)),
				$author$project$Utils$Html$noBreakSpace,
				(($author$project$Api$Provider$PatientMceEligibility$All$status(patientMceEligibility) === 'active') || (!$elm$core$String$isEmpty(message))) ? A2(
				$author$project$Ui$Badge$fromString,
				_List_Nil,
				$author$project$Api$Provider$PatientMceEligibility$All$status(patientMceEligibility)) : $author$project$Utils$Html$empty
			]));
};
var $author$project$Pages$Patients$PatientId_String$Top$viewInactivePatientMceEligibility = F2(
	function (mceActivationsLoading, patientMceEligibility) {
		return A2(
			$author$project$Ui$Form$Static$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility(patientMceEligibility),
							A2($author$project$Pages$Patients$PatientId_String$Top$viewMceSendActivationButton, mceActivationsLoading, patientMceEligibility)
						]))
				]));
	});
var $author$project$Pages$Patients$PatientId_String$Top$viewWrapArounds = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		A2(
			$elm$core$List$cons,
			function () {
				var _v0 = model.m1;
				if (!_v0.$) {
					return $author$project$Utils$Html$empty;
				} else {
					return $author$project$Ui$HorizontalRule$view(_List_Nil);
				}
			}(),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Panel$titleSm(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Skeleton$ifLoading,
							model.m1,
							$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('Wrap-Arounds')
									])),
							$elm$html$Html$text('Wrap-Arounds'))
						])),
				function () {
					var _v1 = model.m1;
					switch (_v1.$) {
						case 3:
							var mcePractices = _v1.a;
							var emailableAddons = A2(
								$elm$core$List$filter,
								function (addon) {
									return $author$project$Api$Provider$Addon$Min$sendsExternalEmail(addon);
								},
								$author$project$Api$Provider$Practice$One$addons(model.WF));
							if ($elm$core$List$isEmpty(mcePractices) && $elm$core$List$isEmpty(emailableAddons)) {
								return _List_Nil;
							} else {
								var mceInactivePractices = A2(
									$elm$core$List$filter,
									function (mcePractice) {
										return $author$project$Api$Provider$PatientMceEligibility$All$status(mcePractice) === 'inactive';
									},
									mcePractices);
								var mceActivePractices = A2(
									$elm$core$List$filter,
									function (mcePractice) {
										return $author$project$Api$Provider$PatientMceEligibility$All$status(mcePractice) === 'active';
									},
									mcePractices);
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Form$view,
										_List_fromArray(
											[$author$project$Ui$Form$horizontal]),
										_List_fromArray(
											[
												(!$elm$core$List$isEmpty(mceActivePractices)) ? A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Current and Pending'),
														$author$project$Ui$Form$Group$labelSpanSm(3),
														$author$project$Ui$Form$Group$inputSpanSm(9)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility, mceActivePractices))
													])) : $author$project$Utils$Html$empty,
												($elm$core$List$isEmpty(mceInactivePractices) && $elm$core$List$isEmpty(emailableAddons)) ? $author$project$Utils$Html$empty : A2(
												$author$project$Ui$Form$Group$view,
												_List_fromArray(
													[
														$author$project$Ui$Form$Group$label('Available'),
														$author$project$Ui$Form$Group$labelSpanSm(3),
														$author$project$Ui$Form$Group$inputSpanSm(9)
													]),
												_Utils_ap(
													A2(
														$elm$core$List$map,
														$author$project$Pages$Patients$PatientId_String$Top$viewInactivePatientMceEligibility(model.i9),
														mceInactivePractices),
													A2(
														$elm$core$List$map,
														$author$project$Pages$Patients$PatientId_String$Top$viewEmailableAddon(model.hn),
														emailableAddons)))
											]))
									]);
							}
						case 1:
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSkeleton('Wrap around'),
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Static$view,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$text(
													_List_fromArray(
														[
															$author$project$Ui$Skeleton$span(3)
														]))
												]))
										]))
								]);
						default:
							return _List_fromArray(
								[$author$project$Utils$Html$empty]);
					}
				}())));
};
var $author$project$Pages$Patients$PatientId_String$Top$view = function (model) {
	var name = _Utils_ap(
		function () {
			var _v1 = $author$project$Api$Provider$Patient$One$chosenTitle(model.VM);
			if (!_v1.$) {
				var chosenTitle = _v1.a;
				return chosenTitle + ' ';
			} else {
				var title = A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Provider$Patient$One$title(model.VM));
				return (title === '') ? '' : (title + ' ');
			}
		}(),
		$author$project$Api$Provider$Patient$One$name(model.VM));
	var dob = function () {
		var _v0 = $author$project$Api$Provider$Patient$One$dob(model.VM);
		if (!_v0.$) {
			var date = _v0.a;
			return A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date);
		} else {
			return '';
		}
	}();
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$Patients$PatientId_String$Top$viewAddSponsorshipModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewAddDependentModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewRemoveSponsorshipModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewCreateMembershipModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewRestorePatientModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewElationForcePushConfirmModal(model),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg,
				$author$project$Components$Patient$PackageDetailsModal$view(model.c4)),
				$author$project$Pages$Patients$PatientId_String$Top$viewDetachPatientModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewEditCustomFormAnswerModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewMembershipDetailsModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewAcceptEphiWaiverModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewRemoveEphiWaiverModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewManagePortalAccessModal(model),
				$author$project$Pages$Patients$PatientId_String$Top$viewEditAthenaIdModal(model),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$Patients$PatientId_String$Top$viewArchivedPatientAlert(model.VM),
								$author$project$Pages$Patients$PatientId_String$Top$viewNetworkLinkageAlert(model.VM),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter]),
								_List_fromArray(
									[
										$author$project$Ui$Panel$titleSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Patient')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$ml2]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg,
												$author$project$Components$AuditTrailLog$view(model.hy))
											]))
									])),
								A2(
								$author$project$Ui$Form$view,
								_List_fromArray(
									[$author$project$Ui$Form$horizontal]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Patient Info'),
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Form$Static$view,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Element$view,
																_List_fromArray(
																	[$author$project$Ui$Element$spaceBetween]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$Element$view,
																		_List_Nil,
																		_List_fromArray(
																			[
																				A2(
																				$author$project$Ui$Typography$span,
																				_List_fromArray(
																					[
																						$author$project$Ui$Typography$phi(true)
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(name)
																					])),
																				A2(
																				$author$project$Ui$Typography$span,
																				_List_fromArray(
																					[
																						$author$project$Ui$Typography$muted,
																						$author$project$Ui$Typography$small,
																						$author$project$Ui$Typography$margin(10),
																						$author$project$Ui$Typography$italic
																					]),
																				_List_fromArray(
																					[
																						$elm$html$Html$text(
																						$author$project$Api$Provider$Patient$One$id(model.VM))
																					])),
																				A2(
																				$author$project$Pages$Patients$PatientId_String$Top$viewCopyButton,
																				'patient identifier ',
																				$author$project$Api$Provider$Patient$One$id(model.VM))
																			])),
																		A2(
																		$author$project$Permission$hideIfReadOnly,
																		model.ZD,
																		A3(
																			$author$project$Ui$Link$route,
																			$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit(
																				{
																					VN: $author$project$Api$Provider$Patient$One$id(model.VM)
																				}),
																			_List_fromArray(
																				[
																					$author$project$Ui$Link$buttonDefault,
																					$author$project$Ui$Link$disabled(
																					$author$project$Api$Provider$Patient$One$archived(model.VM)),
																					$author$project$Ui$Link$xs,
																					$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$edit)
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Edit Patient Details')
																				])))
																	]))
															])),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$span,
																_List_fromArray(
																	[
																		$author$project$Ui$Typography$phi(true)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(dob)
																	]))
															])),
														A2($author$project$Pages$Patients$PatientId_String$Top$viewGenderSection, model.WF, model.VM),
														A2($author$project$Pages$Patients$PatientId_String$Top$viewEmailSection, model.VM, model.qp),
														$author$project$Pages$Patients$PatientId_String$Top$viewPhonesSection(model.VM),
														A2($author$project$Pages$Patients$PatientId_String$Top$viewAddressesSection, model.WF, model.VM)
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$label('Emergency Contact'),
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$core$Maybe$withDefault,
														A2(
															$author$project$Ui$Typography$p,
															_List_fromArray(
																[$author$project$Ui$Typography$italic, $author$project$Ui$Typography$muted]),
															_List_fromArray(
																[
																	$elm$html$Html$text('None')
																])),
														A2(
															$elm$core$Maybe$map,
															$author$project$Pages$Patients$PatientId_String$Top$viewEmergencyContact,
															$author$project$Api$Provider$Patient$One$emergencyContact(model.VM)))
													]))
											])),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewPreferredLanguage, model.WF, model.VM),
										$author$project$Pages$Patients$PatientId_String$Top$viewProfilePicture(model),
										$author$project$Pages$Patients$PatientId_String$Top$viewSSNSection(model),
										$author$project$Pages$Patients$PatientId_String$Top$viewHealthInsurance(model.VM),
										$author$project$Pages$Patients$PatientId_String$Top$viewPractitioner(model.VM),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewLocation, model.WF, model.VM),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewDpcPractice, model.WF, model.VM),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewPrimaryCareClinic, model.WF, model.VM),
										A2($author$project$Pages$Patients$PatientId_String$Top$viewTobaccoSection, model.WF, model.VM),
										$author$project$Pages$Patients$PatientId_String$Top$viewJoinDate(model.VM),
										$author$project$Pages$Patients$PatientId_String$Top$viewLeadSource(model.VM),
										A3(
										$author$project$Utils$FeatureGate$gate,
										5,
										$author$project$Api$Practice$Provider(model.WF),
										A8($author$project$Pages$Patients$PatientId_String$Top$viewSelfService, model.ob, model.Hy, model.H4, model.SC, model.qp, model.VM, model.FR, model.adM)),
										$author$project$Pages$Patients$PatientId_String$Top$viewEngagement(model),
										$author$project$Pages$Patients$PatientId_String$Top$viewMergedInto(model.VM),
										$author$project$Pages$Patients$PatientId_String$Top$viewSponsorshipsSection(model)
									])),
								$author$project$Pages$Patients$PatientId_String$Top$viewMembershipSection(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewPackagesSection(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewWrapArounds(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewFinancialInformation(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewAgreementsSection(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewIntegrationsSection(model),
								$author$project$Pages$Patients$PatientId_String$Top$viewCustomFormsSection(model)
							]))
					]))
			]),
		$G: 'Patient | ' + $author$project$Api$Provider$Patient$One$id(model.VM)
	};
};
var $author$project$Pages$Patients$PatientId_String$Top$page = $author$project$Spa$Page$applicationPatient(
	{ad0: $author$project$Pages$Patients$PatientId_String$Top$init, aer: $author$project$Pages$Patients$PatientId_String$Top$load, agD: $author$project$Pages$Patients$PatientId_String$Top$save, ahd: $author$project$Pages$Patients$PatientId_String$Top$subscriptions, aaq: $author$project$Pages$Patients$PatientId_String$Top$update, ahP: $author$project$Pages$Patients$PatientId_String$Top$view});
var $author$project$Api$Provider$Report$Patient = 0;
var $author$project$Pages$Patients$Top$PatientsListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PatientsList$GotTodaysDate = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$PatientsList$PracticePulseMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$PatientsList$GotPatients = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PatientsList$fetchParams = function (_v0) {
	var filters = _v0.g;
	var pagination = _v0.afy;
	var sort = _v0.ag1;
	return function (d) {
		return _Utils_update(
			d,
			{IJ: filters.pp, ab9: filters.ff, Fi: filters.g, aet: filters.S3, rj: filters.fW, afy: pagination, GH: filters.afN, afS: filters.WO, af_: filters.af_, ag1: sort});
	};
};
var $author$project$Components$PatientsList$fetchPatients = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Patient$list,
			apiClient,
			$author$project$Components$PatientsList$fetchParams(model),
			$author$project$Components$PatientsList$GotPatients);
	});
var $author$project$Components$PracticePulse$GotPulse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Pulse$One$Pulse = $elm$core$Basics$identity;
var $author$project$Api$Provider$Pulse$One$Record = function (activePatients) {
	return function (newPatients) {
		return function (newTerminations) {
			return function (patientInvoicesDueInCents) {
				return function (sponsorInvoicesDueInCents) {
					return function (totalPractitioners) {
						return function (activePatientsPercentage) {
							return function (newPatientsPercentage) {
								return function (newTerminationsPercentage) {
									return function (patientInvoicesDueInCentsPercentage) {
										return function (sponsorInvoicesDueInCentsPercentage) {
											return function (upcomingBirthdayPatients) {
												return {Ii: activePatients, Ij: activePatientsPercentage, Uw: newPatients, Ux: newPatientsPercentage, UA: newTerminations, UB: newTerminationsPercentage, VP: patientInvoicesDueInCents, VQ: patientInvoicesDueInCentsPercentage, _w: sponsorInvoicesDueInCents, _x: sponsorInvoicesDueInCentsPercentage, $Y: totalPractitioners, aao: upcomingBirthdayPatients};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Pulse$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'upcoming_birthday_patients',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sponsor_invoices_due_in_cents_percentage',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient_invoices_due_in_cents_percentage',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'new_terminations_percentage',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'new_patients_percentage',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'active_patients_percentage',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$float),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total_practitioners',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'sponsor_invoices_due_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'patient_invoices_due_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'new_terminations',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'new_patients',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'active_patients',
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$Pulse$One$Record)))))))))))));
var $author$project$Api$Provider$Pulse$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Pulse$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Pulse$pulsePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['pulse']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Pulse$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Pulse$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Pulse$pulsePath));
	});
var $author$project$Components$PracticePulse$init = F2(
	function (apiClient, session) {
		return _Utils_Tuple2(
			{hg: false, U9: true, nN: $author$project$Api$Data$Loading, ZD: session},
			A2($author$project$Api$Provider$Pulse$retrieve, apiClient, $author$project$Components$PracticePulse$GotPulse));
	});
var $author$project$Components$PatientsList$AffiliateResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$PatientsList$CompanyResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$PatientsList$PlanResourceFilterMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter = F4(
	function (apiClient, locationsFilterVisible, locationGroupId, locationId) {
		return locationsFilterVisible ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A4(
				$author$project$Components$ResourceFilter$Location$init,
				apiClient,
				locationGroupId,
				$elm$core$Basics$identity,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'All Locations',
							aeZ: _Utils_eq(locationGroupId, $elm$core$Maybe$Nothing),
							afT: locationId
						});
				})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
	});
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter = F5(
	function (apiClient, hidePractitioner, locationGroupId, locationId, practitionerId) {
		return (!hidePractitioner) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A3(
				$author$project$Components$ResourceFilter$Practitioner$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{aet: locationId, rj: locationGroupId});
				},
				function (d) {
					return _Utils_update(
						d,
						{D0: 'All Providers', aeZ: true, afT: practitionerId});
				})) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
	});
var $author$project$Api$Platform$Session$One$restrictedByGroups = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$withDefault, false, record.Yy);
};
var $author$project$Api$Platform$Session$One$locationGroups = function (_v0) {
	var record = _v0;
	return record.S$;
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$userCanSelectLocationGroup = F2(
	function (session, practice) {
		return $author$project$Api$Platform$Session$One$restrictedByGroups(session) ? A3(
			$elm$core$Basics$composeL,
			$elm$core$Basics$not,
			$elm$core$List$isEmpty,
			$author$project$Api$Platform$Session$One$locationGroups(session)) : ($author$project$Api$Provider$Practice$One$locationGroupsCount(practice) > 0);
	});
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init = F7(
	function (apiClient, session, practice, hidePractitioner, locationGroupId, locationId, practitionerId) {
		var locationsFilterVisible = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var locationGroupsFilterVisible = locationsFilterVisible && A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$userCanSelectLocationGroup, session, practice);
		var _v0 = A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, hidePractitioner, locationGroupId, locationId, practitionerId);
		var practitionerResourceFilter = _v0.a;
		var practitionerResourceFilterCmd = _v0.b;
		var _v1 = A4($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter, apiClient, locationsFilterVisible, locationGroupId, locationId);
		var locationResourceFilter = _v1.a;
		var locationResourceFilterCmd = _v1.b;
		var _v2 = function () {
			if (locationGroupsFilterVisible) {
				var userRestrictedByGroups = $author$project$Api$Platform$Session$One$restrictedByGroups(session);
				return A2(
					$elm$core$Tuple$mapFirst,
					$elm$core$Maybe$Just,
					A2(
						$author$project$Components$ResourceFilter$LocationGroup$init,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{D0: 'All Groups', aeZ: !userRestrictedByGroups, afT: locationGroupId});
						}));
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var locationGroupResourceFilter = _v2.a;
		var locationGroupResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			{xP: hidePractitioner, rk: locationGroupResourceFilter, S1: locationGroupsFilterVisible, rl: locationResourceFilter, F$: locationsFilterVisible, jC: practitionerResourceFilter},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg, locationGroupResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
					])));
	});
var $author$project$Api$Provider$Practice$One$plansCount = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Wr;
	});
var $author$project$Components$PatientsList$initFilters = F4(
	function (apiClient, session, practice, query) {
		var q = A2($elm$core$Dict$get, 'patients_q', query);
		var practitionerId = A2($elm$core$Dict$get, 'patients_practitioner', query);
		var planId = A2($elm$core$Dict$get, 'patients_plan', query);
		var locationId = A2($elm$core$Dict$get, 'patients_location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'patients_location_group', query);
		var initialFilters = function (maybeFilters) {
			var _v5 = _Utils_Tuple2(
				maybeFilters,
				$author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter(practice));
			if (_v5.a.$ === 1) {
				if (_v5.b) {
					var _v6 = _v5.a;
					return _List_fromArray(
						[
							$author$project$Api$Provider$Patient$Status(0)
						]);
				} else {
					var _v7 = _v5.a;
					return _List_Nil;
				}
			} else {
				var justFilters = _v5.a.a;
				return justFilters;
			}
		}(
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$filterMap($author$project$Api$Provider$Patient$filterFromString),
				A2(
					$elm$core$Maybe$map,
					$elm$core$String$split(','),
					A2($elm$core$Dict$get, 'filter', query))));
		var companyId = A2($elm$core$Dict$get, 'patients_company', query);
		var affiliateId = A2($elm$core$Dict$get, 'patients_affiliate', query);
		var _v0 = ($author$project$Api$Provider$Practice$One$plansCount(practice) > 0) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var planResourceFilter = _v0.a;
		var planResourceFilterCmd = _v0.b;
		var _v1 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v1.a;
		var groupLocationAndPractitionerFiltersCmd = _v1.b;
		var _v2 = ($author$project$Api$Provider$Practice$One$companiesCount(practice) > 0) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A4(
				$author$project$Utils$Report$CompanyResourceFilter$init,
				apiClient,
				function (d) {
					return _Utils_update(
						d,
						{aeZ: true});
				},
				$author$project$Api$Practice$Provider(practice),
				companyId)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var companyResourceFilter = _v2.a;
		var companyResourceFilterCmd = _v2.b;
		var _v3 = function () {
			if ($author$project$Api$Provider$Practice$One$isNetwork(practice)) {
				var _v4 = A4(
					$author$project$Components$ResourceFilter$Affiliate$init,
					apiClient,
					session,
					$elm$core$Basics$identity,
					function (d) {
						return _Utils_update(
							d,
							{D0: 'All Affiliates', IS: true, aeZ: true});
					});
				var filter = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(filter),
					cmd);
			} else {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			}
		}();
		var affiliateResourceFilter = _v3.a;
		var affiliateResourceFilterCmd = _v3.b;
		return _Utils_Tuple2(
			{
				pp: affiliateId,
				ps: affiliateResourceFilter,
				ff: companyId,
				pV: companyResourceFilter,
				g: initialFilters,
				b7: groupLocationAndPractitionerFilters,
				fW: locationGroupId,
				S3: locationId,
				jo: $author$project$Components$PatientFilter$init,
				afN: planId,
				jw: planResourceFilter,
				WO: practitionerId,
				af_: q,
				sA: $author$project$Ui$SearchInput$init(q)
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$AffiliateResourceFilterMsg, affiliateResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd)
					])));
	});
var $author$project$Api$Provider$Practice$One$practicePulse = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.WK;
	});
var $author$project$Components$PatientsList$init = F4(
	function (session, practice, patientId, _v0) {
		var apiClient = _v0.D5;
		var query = _v0.Bi;
		var timeFormatter = _v0.Hy;
		var timeZone = _v0.Hz;
		var url = _v0.aav;
		var _v1 = $author$project$Api$Provider$Practice$One$practicePulse(practice) ? A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$Just,
			A2($author$project$Components$PracticePulse$init, apiClient, session)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		var practicePulse = _v1.a;
		var practicePulseCmd = _v1.b;
		var _v2 = A4($author$project$Components$PatientsList$initFilters, apiClient, session, practice, query);
		var filters = _v2.a;
		var filtersCmd = _v2.b;
		var model = {
			g: filters,
			afy: A2(
				$author$project$Api$Pagination$fromQuery,
				query,
				A2($author$project$Api$Pagination$withPrefix, 'patients_', $author$project$Api$Pagination$init)),
			VN: patientId,
			Ap: $author$project$Api$Data$Loading,
			r2: false,
			WF: practice,
			WK: practicePulse,
			ZD: session,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'last_name',
				0,
				A2(
					$author$project$Api$Sort$fromQuery,
					query,
					A2($author$project$Api$Sort$withPrefix, 'patients_', $author$project$Api$Sort$init))),
			Hy: timeFormatter,
			Hz: timeZone,
			oM: $elm$core$Maybe$Nothing,
			aav: url
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$PatientsList$fetchPatients, apiClient, model),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PracticePulseMsg, practicePulseCmd),
						filtersCmd,
						A2($elm$core$Task$perform, $author$project$Components$PatientsList$GotTodaysDate, $justinmimbs$date$Date$today)
					])));
	});
var $author$project$Pages$Patients$Top$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var accountStep = A2(
			$elm$core$Maybe$withDefault,
			8,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$PracticeOnboarding$Shared$accountStep,
				$author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
		var _v1 = function () {
			var _v2 = shared.afE;
			if (_v2.$ === 1) {
				return A4(
					$author$project$Components$PatientsList$init,
					session,
					practice,
					$elm$core$Maybe$Nothing,
					{D5: shared.D5, Bi: query, Hy: shared.Hy, Hz: shared.Hz, aav: shared.aav});
			} else {
				var patientsList_ = _v2.a;
				return _Utils_Tuple2(patientsList_, $elm$core$Platform$Cmd$none);
			}
		}();
		var patientsList = _v1.a;
		var patientListCmd = _v1.b;
		return _Utils_Tuple2(
			{
				H6: accountStep,
				D5: shared.D5,
				l9: $author$project$Components$ExportCsv$init(
					{adw: false, G0: 0}),
				afE: patientsList,
				WF: practice,
				ZD: session
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$PatientsListMsg, patientListCmd));
	});
var $author$project$Pages$Patients$Top$load = F2(
	function (shared, model) {
		var _v0 = shared.afE;
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var patientsList = _v0.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{afE: patientsList}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$Patients$Top$save = F2(
	function (_v0, shared) {
		var patientsList = _v0.afE;
		return _Utils_update(
			shared,
			{
				afE: $elm$core$Maybe$Just(patientsList)
			});
	});
var $author$project$Pages$Patients$Top$ExportCsvMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PatientsList$PatientFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$ResourceFilter$Affiliate$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$ResourceFilter$LocationGroup$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Location$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg)),
					model.rl),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$LocationGroup$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg)),
					model.rk),
					A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Practitioner$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg)),
					model.jC)
				])));
};
var $author$project$Components$PatientsList$subscriptions = function (_v0) {
	var filters = _v0.g;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PatientsList$PatientFilterMsg,
				$author$project$Components$PatientFilter$subscriptions(filters.jo)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Company$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PatientsList$CompanyResourceFilterMsg)),
					filters.pV)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(filters.b7)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Plan$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PatientsList$PlanResourceFilterMsg)),
					filters.jw)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$ResourceFilter$Affiliate$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Components$PatientsList$AffiliateResourceFilterMsg)),
					filters.ps))
			]));
};
var $author$project$Pages$Patients$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Top$PatientsListMsg,
				$author$project$Components$PatientsList$subscriptions(model.afE)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Top$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9))
			]));
};
var $author$project$Utils$PracticeOnboarding$redirectToLastAccountStep = F2(
	function (accountStep, practice) {
		switch (accountStep) {
			case 0:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Account);
			case 1:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans);
			case 2:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents);
			case 3:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team);
			case 4:
				return (!A2(
					$elm$core$Maybe$withDefault,
					13,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Practice$Emr$toOption,
						$author$project$Api$Provider$Practice$One$emr(practice)))) ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Communications) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing);
			case 5:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Legal);
			case 6:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing);
			case 7:
				return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Components$ResourceFilter$Affiliate$reset = function (model) {
	return _Utils_update(
		model,
		{G0: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$Company$reset = function (model) {
	return _Utils_update(
		model,
		{G0: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$Location$reset = function (model) {
	return _Utils_update(
		model,
		{G0: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$LocationGroup$reset = function (model) {
	return _Utils_update(
		model,
		{G0: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$Practitioner$reset = function (model) {
	return _Utils_update(
		model,
		{G0: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$reset = function (model) {
	return _Utils_update(
		model,
		{
			rk: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$LocationGroup$reset, model.rk),
			rl: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Location$reset, model.rl),
			jC: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Practitioner$reset, model.jC)
		});
};
var $author$project$Components$ResourceFilter$Plan$reset = function (model) {
	return _Utils_update(
		model,
		{G0: $author$project$Components$ResourceFilter$All});
};
var $author$project$Components$PracticePulse$FilterSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PracticePulse$None = {$: 0};
var $author$project$Components$PracticePulse$cancellationReasonReportEmbeddedId = 'rpt-OEmUlF2gSktd';
var $author$project$Components$PracticePulse$courseUrl = 'https://accelerator.hint.com/watch';
var $author$project$Components$PracticePulse$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PracticePulse$None,
					y8: _Utils_update(
						model,
						{nN: response}),
					as: $author$project$OutMsg$handleErrorResponse(response)
				};
			case 1:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PracticePulse$None,
					y8: _Utils_update(
						model,
						{U9: !model.U9}),
					as: _List_Nil
				};
			case 2:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$NewActivationsSinceDate),
					y8: model,
					as: _List_Nil
				};
			case 3:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$NewTerminationsSinceDate),
					y8: model,
					as: _List_Nil
				};
			case 4:
				return {
					EC: A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2('status', 'issued,sent,retrying')
								])),
						$author$project$Spa$Generated$Route$Reports__Invoices),
					ac5: $author$project$Components$PracticePulse$None,
					y8: model,
					as: _List_Nil
				};
			case 5:
				return {
					EC: A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2('status', 'issued,failed')
								])),
						$author$project$Spa$Generated$Route$Reports__CompanyInvoices),
					ac5: $author$project$Components$PracticePulse$None,
					y8: model,
					as: _List_Nil
				};
			case 6:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PracticePulse$None,
					y8: _Utils_update(
						model,
						{hg: !model.hg}),
					as: _List_Nil
				};
			case 7:
				return {
					EC: A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Notifications__Patient),
					ac5: $author$project$Components$PracticePulse$None,
					y8: model,
					as: _List_Nil
				};
			case 8:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$WithoutEmail),
					y8: model,
					as: _List_Nil
				};
			case 9:
				return {
					EC: A2(
						$author$project$Utils$Route$navigate,
						$elm$core$Dict$empty,
						$author$project$Spa$Generated$Route$Reports__Custom__Id_String(
							{adR: $author$project$Components$PracticePulse$cancellationReasonReportEmbeddedId})),
					ac5: $author$project$Components$PracticePulse$None,
					y8: model,
					as: _List_Nil
				};
			case 10:
				return {
					EC: $author$project$Ports$Navigation$openInNewWindow($author$project$Components$PracticePulse$courseUrl),
					ac5: $author$project$Components$PracticePulse$None,
					y8: model,
					as: _List_Nil
				};
			default:
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$WithUpcomingBirthday),
					y8: model,
					as: _List_Nil
				};
		}
	});
var $author$project$Components$PatientsList$SearchInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Closed = {$: 1};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None = {$: 2};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop = function (model) {
	return {EC: $elm$core$Platform$Cmd$none, ac5: $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None, y8: model, as: _List_Nil};
};
var $author$project$Components$ResourceFilter$LocationGroup$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = model.rk;
				if (!_v1.$) {
					var locationGroupResourceFilter = _v1.a;
					var locationGroupResourceResult = A3($author$project$Components$ResourceFilter$LocationGroup$update, apiClient, subMsg, locationGroupResourceFilter);
					var event = function () {
						var _v6 = locationGroupResourceResult.ac5;
						if (!_v6.$) {
							if (!_v6.a.$) {
								return A3(
									$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated,
									$author$project$Components$ResourceFilter$LocationGroup$value(locationGroupResourceResult.y8),
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Nothing);
							} else {
								var _v7 = _v6.a;
								return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Closed;
							}
						} else {
							return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
						}
					}();
					var _v2 = function () {
						if (!event.$) {
							var locationGroupId = event.a;
							return A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, model.xP, locationGroupId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple2(model.jC, $elm$core$Platform$Cmd$none);
						}
					}();
					var practitionerResourceFilter = _v2.a;
					var practitionerResourceFilterCmd = _v2.b;
					var _v4 = function () {
						if (!event.$) {
							var locationGroupId = event.a;
							return A4($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter, apiClient, model.F$, locationGroupId, $elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple2(model.rl, $elm$core$Platform$Cmd$none);
						}
					}();
					var locationResourceFilter = _v4.a;
					var locationResourceFilterCmd = _v4.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg, locationGroupResourceResult.EC),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceFilterCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
								])),
						ac5: event,
						y8: _Utils_update(
							model,
							{
								rk: $elm$core$Maybe$Just(locationGroupResourceResult.y8),
								rl: locationResourceFilter,
								jC: practitionerResourceFilter
							}),
						as: locationGroupResourceResult.as
					};
				} else {
					return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
				}
			case 1:
				var subMsg = msg.a;
				var _v8 = model.rl;
				if (!_v8.$) {
					var locationResourceFilter = _v8.a;
					var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, locationResourceFilter);
					var event = function () {
						var _v11 = locationResourceResult.ac5;
						if (!_v11.$) {
							if (!_v11.a.$) {
								return A3(
									$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated,
									A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$LocationGroup$value, model.rk),
									$author$project$Components$ResourceFilter$Location$value(locationResourceResult.y8),
									$elm$core$Maybe$Nothing);
							} else {
								var _v12 = _v11.a;
								return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Closed;
							}
						} else {
							return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
						}
					}();
					var _v9 = function () {
						if (!event.$) {
							var locationGroupId = event.a;
							var locationId = event.b;
							return A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, model.xP, locationGroupId, locationId, $elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple2(model.jC, $elm$core$Platform$Cmd$none);
						}
					}();
					var practitionerResourceFilter = _v9.a;
					var practitionerResourceFilterCmd = _v9.b;
					return {
						EC: $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceResult.EC),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
								])),
						ac5: event,
						y8: _Utils_update(
							model,
							{
								rl: $elm$core$Maybe$Just(locationResourceResult.y8),
								jC: practitionerResourceFilter
							}),
						as: locationResourceResult.as
					};
				} else {
					return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
				}
			default:
				var subMsg = msg.a;
				var _v13 = model.jC;
				if (!_v13.$) {
					var practitionerResourceFilter = _v13.a;
					var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, practitionerResourceFilter);
					var event = function () {
						var _v14 = practitionerResourceResult.ac5;
						if (!_v14.$) {
							if (!_v14.a.$) {
								return A3(
									$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated,
									A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$LocationGroup$value, model.rk),
									A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$Location$value, model.rl),
									$author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.y8));
							} else {
								var _v15 = _v14.a;
								return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Closed;
							}
						} else {
							return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
						}
					}();
					return {
						EC: A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceResult.EC),
						ac5: event,
						y8: _Utils_update(
							model,
							{
								jC: $elm$core$Maybe$Just(practitionerResourceResult.y8)
							}),
						as: practitionerResourceResult.as
					};
				} else {
					return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
				}
		}
	});
var $author$project$Components$PatientsList$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[model.aav.VL]),
			$author$project$Components$PatientsList$urlParams(model)));
};
var $author$project$Components$ResourceFilter$Affiliate$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$PatientsList$updateCurrentFilters = F3(
	function (apiClient, msg, model) {
		var filters = model.g;
		switch (msg.$) {
			case 6:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, filters.b7);
				var _v1 = result.ac5;
				switch (_v1.$) {
					case 0:
						var locationGroupId = _v1.a;
						var locationId = _v1.b;
						var practitionerId = _v1.c;
						var newFilters = _Utils_update(
							filters,
							{b7: result.y8, fW: locationGroupId, S3: locationId, WO: practitionerId});
						var newFiltersAreDifferent = (!_Utils_eq(filters.S3, newFilters.S3)) || ((!_Utils_eq(filters.WO, newFilters.WO)) || (!_Utils_eq(filters.fW, newFilters.fW)));
						var newModel = newFiltersAreDifferent ? _Utils_update(
							model,
							{
								g: newFilters,
								afy: $author$project$Api$Pagination$reset(model.afy),
								Ap: $author$project$Api$Data$Loading
							}) : _Utils_update(
							model,
							{g: newFilters});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, result.EC),
										newFiltersAreDifferent ? $elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
												$author$project$Components$PatientsList$updateUrl(newModel)
											])) : $elm$core$Platform$Cmd$none
									])),
							result.as);
					case 1:
						var newFilters = _Utils_update(
							filters,
							{b7: result.y8});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{g: newFilters}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						var newFilters = _Utils_update(
							filters,
							{b7: result.y8});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{g: newFilters}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 5:
				var subMsg = msg.a;
				var _v2 = filters.jw;
				if (!_v2.$) {
					var planResourceFilter = _v2.a;
					var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planResourceFilter);
					var planId = function () {
						var _v4 = planResourceResult.ac5;
						if (!_v4.$) {
							if (!_v4.a.$) {
								return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.y8);
							} else {
								var _v5 = _v4.a;
								return filters.afN;
							}
						} else {
							return filters.afN;
						}
					}();
					var pagination = _Utils_eq(filters.afN, planId) ? model.afy : $author$project$Api$Pagination$reset(model.afy);
					var newFilters = _Utils_update(
						filters,
						{
							afN: planId,
							jw: $elm$core$Maybe$Just(planResourceResult.y8)
						});
					var newModel = _Utils_update(
						model,
						{g: newFilters, afy: pagination});
					var _v3 = _Utils_eq(filters.afN, newFilters.afN) ? _Utils_Tuple2(model.Ap, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
									$author$project$Components$PatientsList$updateUrl(newModel)
								])));
					var patients = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{afy: pagination, Ap: patients}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PlanResourceFilterMsg, planResourceResult.EC),
									cmd
								])),
						planResourceResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				var subMsg = msg.a;
				var _v6 = filters.pV;
				if (!_v6.$) {
					var companyResourceFilter = _v6.a;
					var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, companyResourceFilter);
					var companyId = function () {
						var _v8 = companyResourceResult.ac5;
						if (!_v8.$) {
							if (!_v8.a.$) {
								return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.y8);
							} else {
								var _v9 = _v8.a;
								return filters.ff;
							}
						} else {
							return filters.ff;
						}
					}();
					var newFilters = _Utils_update(
						filters,
						{
							ff: companyId,
							pV: $elm$core$Maybe$Just(companyResourceResult.y8)
						});
					var pagination = _Utils_eq(filters.ff, companyId) ? model.afy : $author$project$Api$Pagination$reset(model.afy);
					var newModel = _Utils_update(
						model,
						{g: newFilters, afy: pagination});
					var _v7 = _Utils_eq(filters.ff, newFilters.ff) ? _Utils_Tuple2(model.Ap, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
									$author$project$Components$PatientsList$updateUrl(newModel)
								])));
					var patients = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{afy: pagination, Ap: patients}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$CompanyResourceFilterMsg, companyResourceResult.EC),
									cmd
								])),
						companyResourceResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var _v10 = filters.ps;
				if (!_v10.$) {
					var affiliateResourceFilter = _v10.a;
					var affiliateResourceResult = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, subMsg, affiliateResourceFilter);
					var affiliateId = function () {
						var _v12 = affiliateResourceResult.ac5;
						if (!_v12.$) {
							if (!_v12.a.$) {
								return $author$project$Components$ResourceFilter$Affiliate$value(affiliateResourceResult.y8);
							} else {
								var _v13 = _v12.a;
								return filters.pp;
							}
						} else {
							return filters.pp;
						}
					}();
					var newFilters = _Utils_update(
						filters,
						{
							pp: affiliateId,
							ps: $elm$core$Maybe$Just(affiliateResourceResult.y8)
						});
					var pagination = _Utils_eq(filters.pp, affiliateId) ? model.afy : $author$project$Api$Pagination$reset(model.afy);
					var newModel = _Utils_update(
						model,
						{g: newFilters, afy: pagination});
					var _v11 = _Utils_eq(filters.pp, newFilters.pp) ? _Utils_Tuple2(model.Ap, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
						$author$project$Api$Data$Loading,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
									$author$project$Components$PatientsList$updateUrl(newModel)
								])));
					var patients = _v11.a;
					var cmd = _v11.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{afy: pagination, Ap: patients}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$AffiliateResourceFilterMsg, affiliateResourceResult.EC),
									cmd
								])),
						affiliateResourceResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v14 = A2($author$project$Ui$SearchInput$update, subMsg, filters.sA);
				var searchInput = _v14.a;
				var searchInputCmd = _v14.b;
				var searchInputEvent = _v14.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return filters.af_;
					}
				}();
				var newFilters = _Utils_update(
					filters,
					{af_: q, sA: searchInput});
				var _v15 = function () {
					if (_Utils_eq(q, filters.af_)) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{g: newFilters}),
							$elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{
								g: newFilters,
								afy: $author$project$Api$Pagination$reset(model.afy),
								Ap: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Components$PatientsList$fetchPatients, apiClient, qModel),
										$author$project$Components$PatientsList$updateUrl(qModel)
									])));
					}
				}();
				var newModel = _v15.a;
				var cmd = _v15.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v17 = A2($author$project$Components$PatientFilter$update, subMsg, filters.jo);
				var patientFilter = _v17.a;
				var cmd = _v17.b;
				var event = _v17.c;
				if (event.$ === 1) {
					var selectedFilters = event.a;
					var newFilters = _Utils_update(
						filters,
						{g: selectedFilters, jo: patientFilter});
					var newModel = _Utils_update(
						model,
						{
							g: newFilters,
							afy: $author$project$Api$Pagination$reset(model.afy),
							Ap: $author$project$Api$Data$Loading
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
									$author$project$Components$PatientsList$updateUrl(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PatientFilterMsg, cmd)
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								g: _Utils_update(
									filters,
									{jo: patientFilter})
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PatientFilterMsg, cmd),
						_List_Nil);
				}
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$PatientsList$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								Ap: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ap: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 2:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 3:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 4:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 5:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 6:
				return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
			case 7:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Ap: $author$project$Api$Data$Loading,
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
								$author$project$Components$PatientsList$updateUrl(newModel)
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, Ap: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
								$author$project$Components$PatientsList$updateUrl(newModel)
							])),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v2 = model.WK;
				if (!_v2.$) {
					var practicePulse = _v2.a;
					var practicePulseResult = A2($author$project$Components$PracticePulse$update, subMsg, practicePulse);
					var _v3 = function () {
						var _v4 = practicePulseResult.ac5;
						if (!_v4.$) {
							return _Utils_Tuple2(model, false);
						} else {
							var filter = _v4.a;
							var newFilters = function (filters) {
								return _Utils_update(
									filters,
									{
										g: _List_fromArray(
											[filter])
									});
							}(model.g);
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										g: newFilters,
										afy: $author$project$Api$Pagination$reset(model.afy),
										Ap: $author$project$Api$Data$Loading
									}),
								true);
						}
					}();
					var newModel = _v3.a;
					var reloadPatients = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{
								WK: $elm$core$Maybe$Just(practicePulseResult.y8)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									reloadPatients ? A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel) : $elm$core$Platform$Cmd$none,
									A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PracticePulseMsg, practicePulseResult.EC)
								])),
						practicePulseResult.as);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 10:
				var phiMode = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{r2: phiMode}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var patientId = msg.a;
				var url = $elm$url$Url$fromString(
					$author$project$Spa$Generated$Route$toString(
						$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
							{VN: patientId})));
				var newModel = _Utils_update(
					model,
					{
						VN: $elm$core$Maybe$Just(patientId)
					});
				if (!url.$) {
					var value = url.a;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{aav: value}),
						$author$project$Components$PatientsList$updateUrl(newModel),
						_List_Nil);
				} else {
					return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 12:
				var date = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							oM: $elm$core$Maybe$Just(date)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				var filters_ = model.g;
				var newFilters = _Utils_update(
					filters_,
					{
						pp: $elm$core$Maybe$Nothing,
						ps: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Affiliate$reset, filters_.ps),
						ff: $elm$core$Maybe$Nothing,
						pV: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Company$reset, filters_.pV),
						g: _List_Nil,
						b7: $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$reset(filters_.b7),
						fW: $elm$core$Maybe$Nothing,
						S3: $elm$core$Maybe$Nothing,
						afN: $elm$core$Maybe$Nothing,
						jw: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Plan$reset, filters_.jw),
						WO: $elm$core$Maybe$Nothing
					});
				var newModel = _Utils_update(
					model,
					{g: newFilters});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
								$author$project$Components$PatientsList$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Ap: $author$project$Api$Data$Loading}),
					A2($author$project$Components$PatientsList$fetchPatients, apiClient, model),
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$Top$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var patientsListMsg = msg.a;
			var _v1 = A3($author$project$Components$PatientsList$update, model.D5, patientsListMsg, model.afE);
			var patientsListModel = _v1.a;
			var patientsListCmd = _v1.b;
			var outMsgs = _v1.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{afE: patientsListModel}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$PatientsListMsg, patientsListCmd),
							A2($author$project$Utils$PracticeOnboarding$redirectToLastAccountStep, model.H6, model.WF)
						])),
				outMsgs);
		} else {
			var subMsg = msg.a;
			var _v2 = A3($author$project$Components$ExportCsv$update, model.D5, subMsg, model.l9);
			var exportCsv = _v2.a;
			var subCmd = _v2.b;
			var subOutMsg = _v2.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{l9: exportCsv}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$ExportCsvMsg, subCmd),
				subOutMsg);
		}
	});
var $author$project$Components$PracticePulse$Toggle = {$: 1};
var $author$project$Components$PracticePulse$ToggleActionPlan = {$: 6};
var $author$project$Components$PracticePulse$ViewNewPatients = {$: 2};
var $author$project$Components$PracticePulse$ViewRetailInvoices = {$: 4};
var $author$project$Components$PracticePulse$ViewSponsorInvoices = {$: 5};
var $author$project$Components$PracticePulse$ViewTerminatedPatients = {$: 3};
var $author$project$Api$Provider$Pulse$One$activePatients = function (_v0) {
	var record = _v0;
	return record.Ii;
};
var $author$project$Api$Provider$Pulse$One$activePatientsPercentage = function (_v0) {
	var record = _v0;
	return record.Ij;
};
var $author$project$Ui$Panel$Info = 2;
var $author$project$Ui$Panel$info = $author$project$Ui$Panel$Styling(2);
var $author$project$Api$Provider$Pulse$One$newPatients = function (_v0) {
	var record = _v0;
	return record.Uw;
};
var $author$project$Api$Provider$Pulse$One$newPatientsPercentage = function (_v0) {
	var record = _v0;
	return record.Ux;
};
var $author$project$Api$Provider$Pulse$One$newTerminations = function (_v0) {
	var record = _v0;
	return record.UA;
};
var $author$project$Api$Provider$Pulse$One$newTerminationsPercentage = function (_v0) {
	var record = _v0;
	return record.UB;
};
var $author$project$Api$Provider$Pulse$One$patientInvoicesDueInCents = function (_v0) {
	var record = _v0;
	return record.VP;
};
var $author$project$Api$Provider$Pulse$One$patientInvoicesDueInCentsPercentage = function (_v0) {
	var record = _v0;
	return record.VQ;
};
var $author$project$Components$PracticePulse$period = 14;
var $author$project$Components$PracticePulse$periodType = 'day';
var $author$project$Ui$Element$pt0 = $author$project$Ui$Element$Padding('pt-0');
var $author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCents = function (_v0) {
	var record = _v0;
	return record._w;
};
var $author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCentsPercentage = function (_v0) {
	var record = _v0;
	return record._x;
};
var $author$project$Api$Provider$Pulse$One$totalPractitioners = function (_v0) {
	var record = _v0;
	return record.$Y;
};
var $author$project$Components$PracticePulse$EnableEmailSequence = {$: 7};
var $author$project$Ui$Icon$Gift = 53;
var $author$project$Components$PracticePulse$SeeCancellationReasons = {$: 9};
var $author$project$Components$PracticePulse$StartCourse = {$: 10};
var $author$project$Ui$Icon$Tasks = 52;
var $author$project$Components$PracticePulse$ViewPatientsWithoutEmail = {$: 8};
var $author$project$Components$PracticePulse$ViewUpcomingBirthdayPatients = {$: 11};
var $author$project$Ui$Icon$Wrench = 34;
var $author$project$Utils$Html$middleDot = $elm$core$String$fromChar('·');
var $author$project$Api$Provider$Pulse$One$upcomingBirthdayPatients = function (_v0) {
	var record = _v0;
	return record.aao;
};
var $author$project$Components$PracticePulse$viewActionPlanRow = F6(
	function (color, icon, title, description, buttonTitle, msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('action-plan-row'),
					$elm$html$Html$Attributes$class(color)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-icon')
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, icon)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-main')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('action-description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('action-button')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: buttonTitle},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(msg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(buttonTitle)
								]))
						]))
				]));
	});
var $author$project$Components$PracticePulse$viewActionPlan = function (pulse) {
	return _List_fromArray(
		[
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			'green',
			34,
			'Action ' + ($author$project$Utils$Html$middleDot + ' New Patients'),
			'Reach out to schedule first appointments with ' + (A2(
				$author$project$Formatters$String$pluralize,
				'patient',
				$author$project$Api$Provider$Pulse$One$newPatients(pulse)) + (' that joined in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))),
			'See patients',
			$author$project$Components$PracticePulse$ViewNewPatients),
			A6($author$project$Components$PracticePulse$viewActionPlanRow, 'blue', 34, 'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Size'), 'Enable email sequence for people that didn\'t finish enrollment', 'Enable email sequence', $author$project$Components$PracticePulse$EnableEmailSequence),
			A6($author$project$Components$PracticePulse$viewActionPlanRow, 'red', 34, 'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Churn'), 'Add emails to 56 patients missing out on communications', 'See patients', $author$project$Components$PracticePulse$ViewPatientsWithoutEmail),
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			'red',
			34,
			'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Churn'),
			'View cancellation reasons for ' + (A2(
				$author$project$Formatters$String$pluralize,
				'patient',
				$author$project$Api$Provider$Pulse$One$newTerminations(pulse)) + (' patients that terminated in last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))),
			'See cancellation reasons',
			$author$project$Components$PracticePulse$SeeCancellationReasons),
			A6($author$project$Components$PracticePulse$viewActionPlanRow, 'gray', 52, 'Learning', 'If you want to improve your metrics, check out our DPC Accelerator courses on growth, retention and revenue management', 'Start the course', $author$project$Components$PracticePulse$StartCourse),
			A6(
			$author$project$Components$PracticePulse$viewActionPlanRow,
			'gray',
			53,
			'Engagement',
			'Wish a happy birthday to ' + (A2(
				$author$project$Formatters$String$pluralize,
				'patient',
				$author$project$Api$Provider$Pulse$One$upcomingBirthdayPatients(pulse)) + (' who have birthdays in the next ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))),
			'See patients',
			$author$project$Components$PracticePulse$ViewUpcomingBirthdayPatients)
		]);
};
var $author$project$Components$InfoCard$view = F8(
	function (color, title, button, mainNumber, subtitle, description, percentageDisplay, compact) {
		var subtitleElement = function () {
			if (!subtitle.$) {
				var subtitle_ = subtitle.a;
				return A2(
					$author$project$Ui$Typography$p,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$italic]),
					_List_fromArray(
						[
							$elm$html$Html$text(subtitle_)
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}();
		var compactClasses = compact ? _List_fromArray(
			[$author$project$Ui$Element$m0]) : _List_Nil;
		return A3(
			$author$project$Ui$Element$custom,
			'box',
			compactClasses,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel panel--inset m-0'),
							$elm$html$Html$Attributes$class(color + '-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('panel-heading flex items-center justify-between')
								]),
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Typography$headingSm(
									_List_fromArray(
										[
											$elm$html$Html$text(title)
										])),
								button)),
							A3(
							$author$project$Ui$Element$custom,
							'panel-body',
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Typography$heading(
									_List_fromArray(
										[
											$elm$html$Html$text(mainNumber)
										])),
									subtitleElement,
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$textMuted, $author$project$Ui$Element$mt2]),
									_List_fromArray(
										[
											$elm$html$Html$text(description)
										])),
									percentageDisplay
								]))
						]))
				]));
	});
var $author$project$Ui$Icon$Decrease = 51;
var $author$project$Ui$Icon$Increase = 50;
var $author$project$Components$PracticePulse$PercentageDisplay$positiveInteger = function (value) {
	return value > 0;
};
var $author$project$Components$PracticePulse$PercentageDisplay$goodForPractice = F2(
	function (value, increaseIsGood) {
		return _Utils_eq(
			increaseIsGood,
			$author$project$Components$PracticePulse$PercentageDisplay$positiveInteger(value));
	});
var $author$project$Components$PracticePulse$PercentageDisplay$view = function (_v0) {
	var value = _v0.aaN;
	var increaseIsGood = _v0.adZ;
	var period = _v0.afK;
	var type_ = _v0.ahI;
	if (!value.$) {
		var value_ = value.a;
		var icon = $author$project$Components$PracticePulse$PercentageDisplay$positiveInteger(value_) ? 50 : 51;
		var goodOrBadClass = A2($author$project$Components$PracticePulse$PercentageDisplay$goodForPractice, value_, increaseIsGood) ? 'positive' : 'negative';
		return A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('box-percentage'),
							$elm$html$Html$Attributes$class(goodOrBadClass)
						]),
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, icon),
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text(
							$author$project$Formatters$Float$toPercentage(value_))
						])),
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text('Compared to previous '),
							$elm$html$Html$text(
							A2($author$project$Formatters$String$pluralize, type_, period))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$PracticePulse$viewBox = F8(
	function (color, title, button, getMainNumber, getDescription, getPercentage, increaseIsGood, model) {
		var _v0 = model.nN;
		if (_v0.$ === 3) {
			var pulse = _v0.a;
			var percentageDisplay = $author$project$Components$PracticePulse$PercentageDisplay$view(
				{
					adZ: increaseIsGood,
					afK: $author$project$Components$PracticePulse$period,
					ahI: $author$project$Components$PracticePulse$periodType,
					aaN: getPercentage(pulse)
				});
			return A8(
				$author$project$Components$InfoCard$view,
				color,
				title,
				button,
				getMainNumber(pulse),
				$elm$core$Maybe$Nothing,
				getDescription(pulse),
				percentageDisplay,
				false);
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('box')
					]),
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$card(_List_Nil)
					]));
		}
	});
var $author$project$Components$PracticePulse$view = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceBetween]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$titleSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Practice Pulse')
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$textSm, $author$project$Ui$Element$inlineBlock]),
										_List_fromArray(
											[
												$elm$html$Html$text('Last '),
												$elm$html$Html$text(
												A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))
											]))
									])),
								function () {
								var verb = A2(
									$elm$core$String$join,
									' ',
									_List_fromArray(
										[
											model.U9 ? 'Hide' : 'Show',
											'Practice Pulse '
										]));
								return A3(
									$author$project$Ui$Button$view,
									{abp: verb},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$Toggle)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('space-x-1')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(verb)
														])),
													$author$project$Ui$SvgIcon$chevronDown(
													model.U9 ? _List_fromArray(
														[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$rotate180]) : _List_fromArray(
														[$author$project$Ui$SvgIcon$xs]))
												]))
										]));
							}()
							]))
					])),
				model.U9 ? A2(
				$author$project$Ui$Panel$body,
				_List_fromArray(
					[$author$project$Ui$Element$pt0]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('box-container')
							]),
						_List_fromArray(
							[
								A8(
								$author$project$Components$PracticePulse$viewBox,
								'blue',
								'Total Active Patients',
								_List_Nil,
								A2($elm$core$Basics$composeR, $author$project$Api$Provider$Pulse$One$activePatients, $elm$core$String$fromInt),
								function (pulse) {
									return 'Total across ' + A2(
										$author$project$Formatters$String$pluralize,
										'provider',
										$author$project$Api$Provider$Pulse$One$totalPractitioners(pulse));
								},
								$author$project$Api$Provider$Pulse$One$activePatientsPercentage,
								true,
								model),
								A8(
								$author$project$Components$PracticePulse$viewBox,
								'green',
								'New Patients',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'View new patients'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewNewPatients),
												$author$project$Ui$Button$pull(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View')
											]))
									]),
								function (pulse) {
									return '+' + $elm$core$String$fromInt(
										$author$project$Api$Provider$Pulse$One$newPatients(pulse));
								},
								function (_v0) {
									return 'Enrolled in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period);
								},
								$author$project$Api$Provider$Pulse$One$newPatientsPercentage,
								true,
								model),
								A8(
								$author$project$Components$PracticePulse$viewBox,
								'red',
								'Terminations',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'View terminations'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewTerminatedPatients),
												$author$project$Ui$Button$pull(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View')
											]))
									]),
								function (pulse) {
									return '-' + $elm$core$String$fromInt(
										$author$project$Api$Provider$Pulse$One$newTerminations(pulse));
								},
								function (_v1) {
									return 'Terminated in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period);
								},
								$author$project$Api$Provider$Pulse$One$newTerminationsPercentage,
								false,
								model),
								A8(
								$author$project$Components$PracticePulse$viewBox,
								'yellow',
								'Past Due - Retail',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'View retail past due'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewRetailInvoices),
												$author$project$Ui$Button$pull(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View')
											]))
									]),
								function (pulse) {
									return $author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Pulse$One$patientInvoicesDueInCents(pulse));
								},
								$elm$core$Basics$always('Patients\' due invoices'),
								$author$project$Api$Provider$Pulse$One$patientInvoicesDueInCentsPercentage,
								false,
								model),
								A8(
								$author$project$Components$PracticePulse$viewBox,
								'yellow',
								'Past Due - Sponsor',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'View sponsor past due'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
												$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewSponsorInvoices),
												$author$project$Ui$Button$pull(1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View')
											]))
									]),
								function (pulse) {
									return $author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCents(pulse));
								},
								$elm$core$Basics$always('Sponsors\' due invoices'),
								$author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCentsPercentage,
								false,
								model)
							])),
						A2(
						$author$project$Ui$Panel$view,
						_List_fromArray(
							[$author$project$Ui$Panel$info]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
										_List_fromArray(
											[
												$author$project$Ui$Panel$titleSm(
												_List_fromArray(
													[
														$elm$html$Html$text('Action Plan')
													])),
												function () {
												var verb = A2(
													$elm$core$String$join,
													' ',
													_List_fromArray(
														[
															model.hg ? 'Hide' : 'Show',
															'Action Plan '
														]));
												return A3(
													$author$project$Ui$Button$view,
													{abp: verb},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ToggleActionPlan),
															$author$project$Ui$Button$disabled(
															!$author$project$Api$Data$isSuccess(model.nN))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('space-x-1')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(verb)
																		])),
																	$author$project$Ui$SvgIcon$chevronDown(
																	model.hg ? _List_fromArray(
																		[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$rotate180]) : _List_fromArray(
																		[$author$project$Ui$SvgIcon$xs]))
																]))
														]));
											}()
											]))
									])),
								model.hg ? A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								function () {
									var _v2 = model.nN;
									if (_v2.$ === 3) {
										var pulse = _v2.a;
										return $author$project$Components$PracticePulse$viewActionPlan(pulse);
									} else {
										return _List_Nil;
									}
								}()) : $author$project$Ui$Panel$none
							]))
					])) : $author$project$Ui$Panel$none
			]));
};
var $author$project$Components$PatientsList$PaginationMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PatientsList$viewPagination = F2(
	function (paginationOptions, _v0) {
		var patients = _v0.Ap;
		var pagination = _v0.afy;
		return A2(
			$elm$html$Html$map,
			$author$project$Components$PatientsList$PaginationMsg,
			A2(
				$author$project$Api$Pagination$view,
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Pagination$List$loading(
						!$author$project$Utils$Maybe$toBool(
							$author$project$Api$Data$toMaybe(patients))),
					paginationOptions),
				pagination));
	});
var $author$project$Components$PatientsList$SortTable = function (a) {
	return {$: 7, a: a};
};
var $author$project$Ui$Table$Md = 2;
var $author$project$Ui$Table$displayMd = $author$project$Ui$Table$Display(2);
var $author$project$Ui$Table$hidden = $author$project$Ui$Table$Hidden(0);
var $author$project$Components$PatientsList$columns = F2(
	function (mini, practice) {
		var hiddenOnMiniOrSm = function (col) {
			return mini ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$author$project$Api$Column$withOption,
					$author$project$Ui$Table$displayMd,
					A2($author$project$Api$Column$withOption, $author$project$Ui$Table$hidden, col)));
		};
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'last_name', true, 'Patient')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'status', false, 'Status')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'dob', true, 'Date of Birth')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'joined_practice_date', true, 'Joined Practice')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'email', true, 'Email')),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')),
					$author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice) ? hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, 'location', true, 'Location')) : $elm$core$Maybe$Nothing,
					hiddenOnMiniOrSm(
					A3(
						$author$project$Api$Column$init,
						'',
						false,
						A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))),
					hiddenOnMiniOrSm(
					A3($author$project$Api$Column$init, '', false, 'Plan'))
				]));
	});
var $author$project$Ui$Table$active = function (value) {
	return $author$project$Ui$Table$CellActive(value);
};
var $author$project$Api$Provider$Patient$All$affiliateSyncStatus = function (_v0) {
	var record = _v0.b;
	return record.II;
};
var $author$project$Ui$Typography$Age = {$: 28};
var $author$project$Ui$Typography$age = $author$project$Ui$Typography$Age;
var $author$project$Ui$SvgIcon$ArrowRightBottom = 58;
var $author$project$Ui$SvgIcon$arrowRightBottom = $author$project$Ui$SvgIcon$viewIcon(58);
var $author$project$Api$Provider$Patient$All$dob = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$dob(shared);
};
var $author$project$Api$Provider$Patient$All$flaggedNotesCount = function (_v0) {
	var record = _v0.b;
	return record.Py;
};
var $author$project$Formatters$Patient$formatAge = F3(
	function (currentDate, maybeDob, maybeAge) {
		if (!maybeDob.$) {
			var dob = maybeDob.a;
			var ageInMonths = A3($justinmimbs$date$Date$diff, 1, dob, currentDate);
			return (ageInMonths < 24) ? ($elm$core$String$fromInt(ageInMonths) + 'm') : $elm$core$String$fromInt((ageInMonths / 12) | 0);
		} else {
			if (!maybeAge.$) {
				var ageValue = maybeAge.a;
				return (!ageValue) ? '0m' : $elm$core$String$fromInt(ageValue);
			} else {
				return '';
			}
		}
	});
var $author$project$Api$Provider$Patient$All$isAffiliated = function (_v0) {
	var record = _v0.b;
	return record.Rw;
};
var $author$project$Api$Provider$Patient$All$isMaster = function (_v0) {
	var record = _v0.b;
	return record.RQ;
};
var $author$project$Api$Provider$Patient$All$isSynced = function (_v0) {
	var record = _v0.b;
	return record.Sa;
};
var $author$project$Api$Provider$Patient$All$joinedPracticeDate = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Patient$Shared$joinedPracticeDate(shared);
};
var $author$project$Api$Provider$Patient$All$membershipThrough = function (_v0) {
	var record = _v0.b;
	return record.TM;
};
var $author$project$Components$PatientsList$membershipStatus = function (patient) {
	return _Utils_ap(
		$author$project$Formatters$String$humanize(
			$author$project$Api$Provider$Patient$All$membershipStatus(patient)),
		function () {
			var _v0 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
			if (!_v0.$) {
				var membershipThrough = _v0.a;
				return ' through ' + $author$project$Api$Provider$Patient$Min$name(membershipThrough);
			} else {
				return '';
			}
		}());
};
var $author$project$Api$Provider$Patient$All$networkSyncStatus = function (_v0) {
	var record = _v0.b;
	return record.Ut;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$plan = function (_v0) {
	var record = _v0;
	return record.GH;
};
var $author$project$Components$PatientsList$SelectPatient = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$PatientsList$selectPatient = function (patientId) {
	return $author$project$Components$PatientsList$SelectPatient(patientId);
};
var $author$project$Api$Provider$Patient$All$sponsorName = function (_v0) {
	var record = _v0.b;
	return record._y;
};
var $author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Components$PatientsList$viewMembershipPatient = F2(
	function (todaysDate, membershipPatient) {
		var isCurrentMembership = function () {
			if (!todaysDate.$) {
				var today = todaysDate.a;
				return A2(
					$author$project$Utils$Date$isBeforeOrEqual,
					$author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate(membershipPatient),
					today);
			} else {
				return true;
			}
		}();
		return A2(
			$author$project$Ui$Typography$div,
			isCurrentMembership ? _List_Nil : _List_fromArray(
				[$author$project$Ui$Typography$small, $author$project$Ui$Typography$italic]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Provider$Plan$Min$name(
						$author$project$Api$Provider$MembershipPatient$ForPatientAll$plan(membershipPatient))),
					isCurrentMembership ? $author$project$Utils$Html$empty : A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('on '),
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate(membershipPatient)))
						]))
				]));
	});
var $author$project$Components$PatientsList$viewPatient = F3(
	function (mini, model, patient) {
		var responsiveCell = function (cellChildren) {
			return mini ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$hidden, $author$project$Ui$Table$displayMd]),
					cellChildren));
		};
		var practitionerName = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$Practitioner$Min$name,
				$author$project$Api$Provider$Patient$All$practitioner(patient)));
		var id = $author$project$Api$Provider$Patient$All$id(patient);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$active(
									_Utils_eq(
										model.VN,
										$elm$core$Maybe$Just(id)))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap]),
									_List_fromArray(
										[
											function () {
											var isClinical = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.WF) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, model.WF);
											var _v0 = isClinical ? _Utils_Tuple2(
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Chart(
													{VN: id}),
												_List_fromArray(
													[
														$author$project$Ui$Link$onClick(
														$author$project$Components$PatientsList$selectPatient(id))
													])) : _Utils_Tuple2(
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{VN: id}),
												_List_fromArray(
													[
														$author$project$Ui$Link$routeParams(
														$author$project$Components$PatientsList$urlParams(model)),
														$author$project$Ui$Link$onClick(
														$author$project$Components$PatientsList$selectPatient(id))
													]));
											var patientRoute = _v0.a;
											var linkOptions = _v0.b;
											return A3(
												$author$project$Ui$Link$route,
												patientRoute,
												linkOptions,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[
																$author$project$Ui$Typography$phi(true),
																$author$project$Ui$Typography$attrs(
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('mr-2')
																	]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Provider$Patient$All$name(patient)),
																function () {
																var _v1 = model.oM;
																if (!_v1.$) {
																	var currentDate = _v1.a;
																	var ageDisplay = A3(
																		$author$project$Formatters$Patient$formatAge,
																		currentDate,
																		$author$project$Api$Provider$Patient$All$dob(patient),
																		$author$project$Api$Provider$Patient$All$age(patient));
																	return $elm$core$String$isEmpty(ageDisplay) ? $author$project$Utils$Html$empty : A2(
																		$author$project$Ui$Typography$span,
																		_List_fromArray(
																			[$author$project$Ui$Typography$age]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text(', '),
																				$elm$html$Html$text(ageDisplay)
																			]));
																} else {
																	var _v2 = $author$project$Api$Provider$Patient$All$age(patient);
																	if (!_v2.$) {
																		var age = _v2.a;
																		return A2(
																			$author$project$Ui$Typography$span,
																			_List_fromArray(
																				[$author$project$Ui$Typography$age]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(', '),
																					$elm$html$Html$text(
																					$elm$core$String$fromInt(age))
																				]));
																	} else {
																		return $author$project$Utils$Html$empty;
																	}
																}
															}()
															]))
													]));
										}(),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('md:hidden', !mini)
														]))
												]),
											_List_fromArray(
												[
													function () {
													var _v3 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
													if (!_v3.$) {
														return A3(
															$author$project$Ui$Tooltip$view,
															_List_fromArray(
																[
																	$author$project$Ui$Tooltip$placement(0)
																]),
															$author$project$Components$PatientsList$membershipStatus(patient),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Badge$fromStringWithIcon,
																	_List_Nil,
																	$author$project$Api$Provider$Patient$All$membershipStatus(patient),
																	$author$project$Ui$SvgIcon$arrowRightBottom(_List_Nil))
																]));
													} else {
														return A2(
															$author$project$Ui$Badge$fromString,
															_List_Nil,
															$author$project$Api$Provider$Patient$All$membershipStatus(patient));
													}
												}()
												]))
										])),
									function () {
									var _v4 = $author$project$Api$Provider$Patient$All$membershipPatients(patient);
									if (_v4.b) {
										var membershipPatient = _v4.a;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('md:hidden', !mini)
														]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Plan$Min$name(
														$author$project$Api$Provider$MembershipPatient$ForPatientAll$plan(membershipPatient)))
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}(),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('text-muted'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('md:hidden', !mini)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(practitionerName)
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2]),
									$elm$core$List$concat(
										_List_fromArray(
											[
												($author$project$Api$Provider$Patient$All$flaggedNotesCount(patient) > 0) ? _List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
														{
															VN: $author$project$Api$Provider$Patient$All$id(patient)
														}),
													_List_fromArray(
														[
															$author$project$Ui$Link$routeParams(
															_List_fromArray(
																[
																	A2($elm$url$Url$Builder$string, 'flagged', '1')
																])),
															$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
														]),
													_List_Nil)
												]) : _List_Nil,
												($author$project$Api$Provider$Patient$All$isMaster(patient) && $author$project$Api$Provider$Patient$All$isAffiliated(patient)) ? _List_fromArray(
												[
													$author$project$Components$SyncedIcon$view(
													_List_fromArray(
														[
															$author$project$Components$SyncedIcon$master,
															$author$project$Components$SyncedIcon$status(
															$author$project$Api$Provider$Patient$All$networkSyncStatus(patient))
														]))
												]) : _List_Nil,
												($author$project$Api$Provider$Patient$All$isSynced(patient) && $author$project$Api$Provider$Patient$All$isAffiliated(patient)) ? _List_fromArray(
												[
													$author$project$Components$SyncedIcon$view(
													_List_fromArray(
														[
															$author$project$Components$SyncedIcon$synced,
															$author$project$Components$SyncedIcon$status(
															$author$project$Api$Provider$Patient$All$affiliateSyncStatus(patient))
														]))
												]) : _List_Nil
											])))
								]))),
						responsiveCell(
						_List_fromArray(
							[
								function () {
								var _v5 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
								if (!_v5.$) {
									return A3(
										$author$project$Ui$Tooltip$view,
										_List_fromArray(
											[
												$author$project$Ui$Tooltip$placement(0)
											]),
										$author$project$Components$PatientsList$membershipStatus(patient),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Badge$fromStringWithIcon,
												_List_Nil,
												$author$project$Api$Provider$Patient$All$membershipStatus(patient),
												$author$project$Ui$SvgIcon$arrowRightBottom(_List_Nil))
											]));
								} else {
									return A2(
										$author$project$Ui$Badge$fromString,
										_List_Nil,
										$author$project$Api$Provider$Patient$All$membershipStatus(patient));
								}
							}()
							])),
						responsiveCell(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
												$author$project$Api$Provider$Patient$All$dob(patient))))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('md:hidden', !mini)
											]))
									]),
								A2(
									$elm$core$List$map,
									$author$project$Components$PatientsList$viewMembershipPatient(model.oM),
									$author$project$Api$Provider$Patient$All$membershipPatients(patient)))
							])),
						responsiveCell(
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
										$author$project$Api$Provider$Patient$All$joinedPracticeDate(patient)))),
								$author$project$Utils$Html$noBreakSpace,
								($author$project$Api$Provider$Patient$All$membershipStatus(patient) === 'unconfirmed') ? $elm$html$Html$text('(unconfirmed)') : $author$project$Utils$Html$empty
							])),
						responsiveCell(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Api$Provider$Patient$All$email(patient)))
									]))
							])),
						responsiveCell(
						_List_fromArray(
							[
								$elm$html$Html$text(practitionerName)
							])),
						$author$project$Api$Provider$Practice$One$trackPatientsByLocation(model.WF) ? responsiveCell(
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Location$Min$name,
										$author$project$Api$Provider$Patient$All$location(patient))))
							])) : $elm$core$Maybe$Nothing,
						responsiveCell(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$phi(true)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Api$Provider$Patient$All$sponsorName(patient)))
									]))
							])),
						responsiveCell(
						A2(
							$elm$core$List$map,
							$author$project$Components$PatientsList$viewMembershipPatient(model.oM),
							$author$project$Api$Provider$Patient$All$membershipPatients(patient)))
					])));
	});
var $author$project$Components$PatientsList$viewPatientsTable = F2(
	function (mini, model) {
		var _v0 = function () {
			var _v1 = model.Ap;
			if (_v1.$ === 3) {
				var patients_ = _v1.a;
				return _Utils_Tuple2(false, patients_);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var patients = _v0.b;
		return A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[
					$author$project$Ui$Table$verticalCentered,
					$author$project$Ui$Table$zeroState(
					_List_fromArray(
						[
							$elm$html$Html$text('No patients found.')
						])),
					$author$project$Ui$Table$loading(loading)
				]),
			A2(
				$elm$core$List$map,
				$author$project$Api$Column$view(
					A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$PatientsList$SortTable)),
				A2($author$project$Components$PatientsList$columns, mini, model.WF)),
			A2(
				$elm$core$List$map,
				A2($author$project$Components$PatientsList$viewPatient, mini, model),
				patients),
			_List_Nil);
	});
var $author$project$Components$PatientsList$ResetFilters = {$: 13};
var $author$project$Ui$FlexGrid$Conditional = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$FlexGrid$conditional = $author$project$Ui$FlexGrid$Conditional;
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Multi = 0;
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi = 0;
var $author$project$Ui$FilterChips$Reset = $elm$core$Basics$identity;
var $author$project$Ui$FilterChips$reset = $elm$core$Basics$identity;
var $author$project$Ui$FilterChips$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				var msg = option;
				return _Utils_update(
					acc,
					{
						G$: $elm$core$Maybe$Just(msg)
					});
			}),
		{G$: $elm$core$Maybe$Nothing},
		options);
};
var $author$project$Ui$FilterChips$view = F2(
	function (options, activeFilters) {
		if ($elm$core$List$isEmpty(activeFilters)) {
			return $elm$html$Html$text('');
		} else {
			var optionsRecord = $author$project$Ui$FilterChips$optionsToRecord(options);
			return A3(
				$author$project$Ui$Element$custom,
				'filter-chips',
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('filter-chips__title')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Active filters')
									])),
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2(
									$elm$core$Maybe$map,
									function (msg) {
										return A3(
											$author$project$Ui$Button$view,
											{abp: 'Reset filters'},
											_List_fromArray(
												[
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$cross),
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(msg)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset filters')
												]));
									},
									optionsRecord.G$))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('filter-chips__wrapper')
							]),
						activeFilters)
					]));
		}
	});
var $author$project$Components$PatientFilter$viewMultiSelected = function (selected) {
	return A2(
		$elm$core$List$map,
		function (filter) {
			return A3(
				$author$project$Ui$Button$view,
				{abp: 'Remove selection'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick(
						$author$project$Components$PatientFilter$FilterSelected_(
							A2($author$project$Components$PatientFilter$checkedItem, filter, selected))),
						$author$project$Ui$Button$sm,
						$author$project$Ui$Button$mb2
					]),
				A2(
					$elm$core$List$map,
					$elm$html$Html$map($elm$core$Basics$never),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Components$PatientFilter$filterToLabel(filter)),
							$author$project$Ui$SvgIcon$cross(
							_List_fromArray(
								[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$spacedLeft]))
						])));
		},
		selected);
};
var $author$project$Components$ResourceFilter$Company$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$ResourceFilter$Location$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$ResourceFilter$LocationGroup$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$ResourceFilter$Practitioner$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected = function (model) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (locationGroupResourceFilter) {
						return A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg),
							$author$project$Components$ResourceFilter$LocationGroup$viewMultiSelected(locationGroupResourceFilter));
					},
					model.rk)),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (locationResourceFilter) {
						return A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg),
							$author$project$Components$ResourceFilter$Location$viewMultiSelected(locationResourceFilter));
					},
					model.rl)),
				A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (practitionerResourceFilter) {
						return A2(
							$elm$core$List$map,
							$elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg),
							$author$project$Components$ResourceFilter$Practitioner$viewMultiSelected(practitionerResourceFilter));
					},
					model.jC))
			]));
};
var $author$project$Components$ResourceFilter$Plan$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$ResourceFilter$Affiliate$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$ResourceFilter$LocationGroup$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew = F2(
	function (options, model) {
		var optionsRecord = A3(
			$elm$core$List$foldl,
			F2(
				function (opt, acc) {
					return _Utils_update(
						acc,
						{ze: true});
				}),
			{ze: false},
			options);
		var multiOption = optionsRecord.ze ? _List_fromArray(
			[$author$project$Components$ResourceFilter$multi]) : _List_Nil;
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$map,
					function (locationGroupResourceFilter) {
						return A2(
							$elm$html$Html$map,
							$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$LocationGroup$viewNew,
								A2(
									$elm$core$List$cons,
									$author$project$Components$ResourceFilter$style(1),
									multiOption),
								locationGroupResourceFilter));
					},
					model.rk),
					A2(
					$elm$core$Maybe$map,
					function (locationResourceFilter) {
						return A2(
							$elm$html$Html$map,
							$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Location$viewNew,
								A2(
									$elm$core$List$cons,
									$author$project$Components$ResourceFilter$style(1),
									multiOption),
								locationResourceFilter));
					},
					model.rl),
					A2(
					$elm$core$Maybe$map,
					function (practitionerResourceFilter) {
						return A2(
							$elm$html$Html$map,
							$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg,
							A2(
								$author$project$Components$ResourceFilter$Practitioner$viewNew,
								A2(
									$elm$core$List$cons,
									$author$project$Components$ResourceFilter$style(1),
									multiOption),
								practitionerResourceFilter));
					},
					model.jC)
				]));
	});
var $author$project$Components$PatientsList$viewSearchAndFilters = F2(
	function (miniView, model) {
		var filters = model.g;
		var unlessMini = function (option) {
			return $author$project$Ui$FlexGrid$conditional(
				_Utils_Tuple2(!miniView, option));
		};
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_fromArray(
					[$author$project$Ui$FlexGrid$mb2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$PatientsList$SearchInputMsg,
								A2(
									$author$project$Ui$SearchInput$view,
									_List_fromArray(
										[
											$author$project$Ui$SearchInput$phi(true),
											$author$project$Ui$SearchInput$placeholder('Search patients by name, email, ID, date of birth, phone number')
										]),
									filters.sA))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								unlessMini(
								$author$project$Ui$FlexGrid$spanMd(2)),
								$author$project$Ui$FlexGrid$span(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$PatientsList$PatientFilterMsg,
								A3($author$project$Components$PatientFilter$view, model.WF, filters.g, filters.jo))
							])),
					A2(
						$elm$core$List$cons,
						function () {
							var _v0 = filters.pV;
							if (!_v0.$) {
								var companyResourceFilter = _v0.a;
								return A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											unlessMini(
											$author$project$Ui$FlexGrid$spanMd(2)),
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$PatientsList$CompanyResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Company$viewNew,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$style(1),
														$author$project$Components$ResourceFilter$multi
													]),
												companyResourceFilter))
										]));
							} else {
								return $author$project$Ui$FlexGrid$none;
							}
						}(),
						A2(
							$elm$core$List$cons,
							function () {
								var _v1 = filters.jw;
								if (!_v1.$) {
									var planResourceFilter = _v1.a;
									return A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												unlessMini(
												$author$project$Ui$FlexGrid$spanMd(2)),
												$author$project$Ui$FlexGrid$span(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$PatientsList$PlanResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$Plan$viewNew,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$style(1),
															$author$project$Components$ResourceFilter$multi
														]),
													planResourceFilter))
											]));
								} else {
									return $author$project$Ui$FlexGrid$none;
								}
							}(),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										$elm$core$List$singleton,
										$author$project$Ui$FlexGrid$column(
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													unlessMini(
													$author$project$Ui$FlexGrid$spanMd(2))
												]))),
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg),
										A2(
											$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
											_List_fromArray(
												[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
											filters.b7))),
								_List_fromArray(
									[
										function () {
										var _v2 = filters.ps;
										if (!_v2.$) {
											var affiliateResourceFilter = _v2.a;
											return A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														unlessMini(
														$author$project$Ui$FlexGrid$spanMd(2)),
														$author$project$Ui$FlexGrid$span(6)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Components$PatientsList$AffiliateResourceFilterMsg,
														A2(
															$author$project$Components$ResourceFilter$Affiliate$viewNew,
															_List_fromArray(
																[
																	$author$project$Components$ResourceFilter$style(1)
																]),
															affiliateResourceFilter))
													]));
										} else {
											return $author$project$Ui$FlexGrid$none;
										}
									}()
									])))))),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						function () {
							var activeFilters = _Utils_ap(
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Components$ResourceFilter$Plan$viewMultiSelected,
											$elm$core$List$map(
												$elm$html$Html$map($author$project$Components$PatientsList$PlanResourceFilterMsg))),
										model.g.jw)),
								_Utils_ap(
									A2(
										$elm$core$Maybe$withDefault,
										_List_Nil,
										A2(
											$elm$core$Maybe$map,
											A2(
												$elm$core$Basics$composeR,
												$author$project$Components$ResourceFilter$Company$viewMultiSelected,
												$elm$core$List$map(
													$elm$html$Html$map($author$project$Components$PatientsList$CompanyResourceFilterMsg))),
											model.g.pV)),
									_Utils_ap(
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg),
											$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(filters.b7)),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$PatientsList$PatientFilterMsg),
											$author$project$Components$PatientFilter$viewMultiSelected(model.g.g)))));
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$FilterChips$view,
									_List_fromArray(
										[
											$author$project$Ui$FilterChips$reset($author$project$Components$PatientsList$ResetFilters)
										]),
									activeFilters)
								]);
						}())
					]))
			]);
	});
var $author$project$Components$PatientsList$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('patients-list')
			]),
		_List_fromArray(
			[
				function () {
				var _v0 = model.WK;
				if (!_v0.$) {
					var practicePulse = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Components$PatientsList$PracticePulseMsg,
						$author$project$Components$PracticePulse$view(practicePulse));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						A2($author$project$Components$PatientsList$viewSearchAndFilters, false, model)),
						A2($author$project$Components$PatientsList$viewPatientsTable, false, model),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Components$PatientsList$viewPagination, _List_Nil, model)
							]))
					]))
			]));
};
var $author$project$Ui$Link$Test = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Link$test = $author$project$Ui$Link$Test;
var $author$project$Pages$Patients$Top$viewActions = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$hidden, $author$project$Ui$Element$flexMd, $author$project$Ui$Element$gap4]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__Upload,
						_List_fromArray(
							[
								$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$upload)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Upload from CSV')
							])),
						A2($elm$html$Html$map, $author$project$Pages$Patients$Top$ExportCsvMsg, $author$project$Components$ExportCsv$link)
					])),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Charges__New,
				_List_fromArray(
					[
						$author$project$Ui$Link$buttonSecondary,
						$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$dollarSign),
						$author$project$Ui$Link$test('add-charge')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Charge')
					])),
				A3(
				$author$project$Ui$Link$route,
				$author$project$Spa$Generated$Route$Patients__Create,
				_List_fromArray(
					[
						$author$project$Ui$Link$buttonPrimary,
						$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$add)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Patient ')
					]))
			]))
	]);
var $author$project$Pages$Patients$Top$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Top$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					model.D5,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$path($author$project$Api$Provider$Patient$patientsPath),
							$author$project$Components$ExportCsv$params(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Patient$listOptionsToParams, $author$project$Components$PatientsList$fetchParams)(model.afE))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mb4, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$elm$html$Html$text('Patients')
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter]),
						$author$project$Pages$Patients$Top$viewActions)
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Top$PatientsListMsg,
				$author$project$Components$PatientsList$view(model.afE))
			]),
		$G: 'Patients'
	};
};
var $author$project$Pages$Patients$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Patients$Top$init, aer: $author$project$Pages$Patients$Top$load, agD: $author$project$Pages$Patients$Top$save, ahd: $author$project$Pages$Patients$Top$subscriptions, aaq: $author$project$Pages$Patients$Top$update, ahP: $author$project$Pages$Patients$Top$view});
var $author$project$Api$Upload$McePlanResource$McePlan = 0;
var $author$project$Api$Upload$Resource$Patient = 3;
var $author$project$Pages$Patients$Upload$Patient = 0;
var $author$project$Pages$Patients$Upload$UploadFormMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Practice$One$canDeleteAllPatients = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Kq;
	});
var $author$project$Api$Upload$ClinicalResource$AtlasClinical = 0;
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotClinicalUploadResults = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$ClinicalUploadResult$clinicalUploadsPath = F2(
	function (clinicalResource, basePath) {
		var resourcePath = function () {
			if (!clinicalResource) {
				return 'atlas';
			} else {
				return 'ccda';
			}
		}();
		return A2(
			$author$project$Api$Data$pathAppend,
			_List_fromArray(
				['emr', 'file_imports', resourcePath]),
			basePath);
	});
var $author$project$Api$Provider$ClinicalUploadResult$All$ClinicalUploadResult = $elm$core$Basics$identity;
var $author$project$Api$Provider$ClinicalUploadResult$Shared$ClinicalUploadResult = $elm$core$Basics$identity;
var $author$project$Api$Provider$ClinicalUploadResult$Shared$Record = F5(
	function (fileName, status, result, createdAt, id) {
		return {Mf: createdAt, Pm: fileName, adR: id, Yz: result, ag7: status};
	});
var $author$project$Api$Provider$ClinicalUploadResult$Data$Data = $elm$core$Basics$identity;
var $author$project$Api$Provider$ClinicalUploadResult$Data$Record = F2(
	function (code, message) {
		return {K3: code, aeD: message};
	});
var $author$project$Api$Provider$ClinicalUploadResult$Data$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'message',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'code',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$ClinicalUploadResult$Data$Record)));
var $author$project$Api$Provider$ClinicalUploadResult$Data$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ClinicalUploadResult$Data$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ClinicalUploadResult$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'result',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$ClinicalUploadResult$Data$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'file_name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$ClinicalUploadResult$Shared$Record))))));
var $author$project$Api$Provider$ClinicalUploadResult$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ClinicalUploadResult$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ClinicalUploadResult$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ClinicalUploadResult$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$ClinicalUploadResult$listDefaults = {afy: $author$project$Api$Pagination$init};
var $author$project$Api$ClinicalUploadResult$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$ClinicalUploadResult$listDefaults);
	return $author$project$Api$Pagination$toApiParams(options.afy);
};
var $author$project$Api$ClinicalUploadResult$list = F4(
	function (clinicalResource, apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ClinicalUploadResult$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$ClinicalUploadResult$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2($author$project$Api$ClinicalUploadResult$clinicalUploadsPath, clinicalResource, $author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults = F2(
	function (pagination, apiClient) {
		return A4(
			$author$project$Api$ClinicalUploadResult$list,
			0,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination});
			},
			$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotClinicalUploadResults);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init = F2(
	function (timeFormatter, apiClient) {
		var newPagination = $author$project$Api$Pagination$init;
		return _Utils_Tuple2(
			{D5: apiClient, mH: false, afy: newPagination, j9: false, Hy: timeFormatter, ts: $elm$core$Maybe$Nothing, o5: $author$project$Api$Data$Loading},
			A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults, newPagination, apiClient));
	});
var $author$project$Api$Upload$ClinicalResource$CcdaClinical = 1;
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$GotClinicalUploadResults = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults = F2(
	function (pagination, apiClient) {
		return A4(
			$author$project$Api$ClinicalUploadResult$list,
			1,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{afy: pagination});
			},
			$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$GotClinicalUploadResults);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload = {$: 0};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle = {$: 0};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$init = {j7: false, ts: $elm$core$Maybe$Nothing, DD: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload, kH: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init = {a8: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$init, gj: _List_Nil, kD: $elm$core$Maybe$Nothing, DD: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init = F2(
	function (timeFormatter, apiClient) {
		var newPagination = $author$project$Api$Pagination$init;
		return _Utils_Tuple2(
			{afy: newPagination, nL: $elm$core$Maybe$Nothing, Hy: timeFormatter, DD: $elm$core$Maybe$Nothing, hc: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init, o5: $author$project$Api$Data$Loading},
			A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, newPagination, apiClient));
	});
var $author$project$Api$Upload$McePlanResource$McePlanCreate = 0;
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init = F3(
	function (timeFormatter, apiClient, mcePlanResource) {
		return _Utils_Tuple2(
			{Ib: 0, D5: apiClient, Tx: mcePlanResource, j9: false, Hy: timeFormatter, ts: $elm$core$Maybe$Nothing},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$Upload$init = F4(
	function (_v0, practice, shared, _v1) {
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var _v2 = A4($author$project$Components$Upload$Form$init, shared.Hy, shared.D5, 3, $elm$core$Maybe$Nothing);
		var uploadForm = _v2.a;
		var uploadFormCmd = _v2.b;
		var _v3 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init, shared.Hy, shared.D5, 0);
		var mcePlanUploadForm = _v3.a;
		var _v4 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init, shared.Hy, shared.D5);
		var ccdaClinicalUploadForm = _v4.a;
		var _v5 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init, shared.Hy, shared.D5);
		var atlasClinicalUploadForm = _v5.a;
		return _Utils_Tuple2(
			{
				vk: $author$project$Api$Provider$Practice$One$canDeleteAllPatients(practice),
				D5: shared.D5,
				e1: atlasClinicalUploadForm,
				fb: ccdaClinicalUploadForm,
				dw: $elm$core$Maybe$Nothing,
				h8: false,
				FR: isHintAdmin,
				Tx: $elm$core$Maybe$Nothing,
				f2: mcePlanUploadForm,
				WF: practice,
				G0: $elm$core$Maybe$Just(0),
				Hy: shared.Hy,
				g9: uploadForm
			},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, uploadFormCmd));
	});
var $author$project$Pages$Patients$Upload$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Patients$Upload$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Patients$Upload$HiConfirmClosed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Patients$Upload$McePlanUploadFormMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal = {$: 2};
var $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress = function (onClose) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$subscriptions = function (model) {
	return model.j9 ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ReceivedFilePath = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ports$FilePaths$receiveFilePath = _Platform_incomingPort(
	'receiveFilePath',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal = {$: 0};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$subscriptions = function (model) {
	return model.j7 ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$subscriptions(model.a8)),
				$author$project$Ports$FilePaths$receiveFilePath($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ReceivedFilePath)
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$subscriptions(model.hc));
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal = {$: 2};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$subscriptions = function (model) {
	return model.j9 ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Patients$Upload$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Upload$UploadFormMsg,
				$author$project$Components$Upload$Form$subscriptions(model.g9)),
				model.h8 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$Upload$HiConfirmClosed) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$subscriptions(model.e1)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$subscriptions(model.fb)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$Patients$Upload$McePlanUploadFormMsg,
				$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$subscriptions(model.f2))
			]));
};
var $author$project$Api$Upload$Resource$Charge = 4;
var $author$project$Pages$Patients$Upload$GotPatientDestroyAll = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Upload$Resource$PatientNote = 7;
var $author$project$Api$Provider$Patient$destroyAll = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$ClinicalUploadResult$createAtlas = F3(
	function (apiClient, files, toMsg) {
		var filesPart = A2(
			$elm$core$List$map,
			function (file) {
				return A2($elm$http$Http$filePart, 'files[]', file);
			},
			files);
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				filesPart,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['emr', 'file_imports', 'atlas']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var files = msg.a;
				return $elm$core$List$isEmpty(files) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{mH: true}),
					A3($author$project$Api$ClinicalUploadResult$createAtlas, apiClient, files, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotResponse),
					_List_Nil);
			case 1:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{mH: false, j9: true, ts: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									mH: false,
									j9: true,
									ts: $elm$core$Maybe$Just(
										$author$project$Api$Data$errorToString(error))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j9: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								o5: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o5: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, o5: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults, pagination, newModel.D5),
					_List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$AddToExisting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$NewUpload = {$: 0};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUploadResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$initForExistingUpload = function (uploadId) {
	return {
		j7: false,
		ts: $elm$core$Maybe$Nothing,
		DD: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting(uploadId),
		kH: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle
	};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$initForExistingUpload = function (uploadId) {
	return {
		a8: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$initForExistingUpload(uploadId),
		gj: _List_Nil,
		kD: $elm$core$Maybe$Nothing,
		DD: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting(uploadId)
	};
};
var $author$project$Api$ClinicalUploadResult$processUpload = F4(
	function (clinicalResource, apiClient, uploadId, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(_List_Nil),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							[uploadId, 'process_upload']),
						A2($author$project$Api$ClinicalUploadResult$clinicalUploadsPath, clinicalResource, $author$project$Api$Data$providerPath)))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal = F2(
	function (f, model) {
		return f(model);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal = function (model) {
	return _Utils_update(
		model,
		{
			a8: A2(
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal,
				function (m) {
					return _Utils_update(
						m,
						{j7: true});
				},
				model.a8)
		});
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadCreated = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish = F2(
	function (toMsg, proc) {
		var _v0 = proc.sm;
		if (_v0.b) {
			var next = _v0.a;
			return A2(
				$elm$core$Task$perform,
				function (_v1) {
					return A2(toMsg, proc.HK, next);
				},
				$elm$core$Task$succeed(0));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Api$Provider$ClinicalUploadResult$One$ClinicalUploadResult = $elm$core$Basics$identity;
var $author$project$Api$Provider$ClinicalUploadResult$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ClinicalUploadResult$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$ClinicalUploadResult$createCcda = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$ClinicalUploadResult$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(_List_Nil),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['emr', 'file_imports', 'ccda']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates = F2(
	function (uploadId, candidates) {
		return {
			xz: _List_Nil,
			sm: candidates,
			tm: $elm$core$List$length(candidates),
			HK: uploadId,
			aas: 0
		};
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState = F2(
	function (state, model) {
		return _Utils_update(
			model,
			{j7: true, ts: $elm$core$Maybe$Nothing, kH: state});
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onCreateUpload = F3(
	function (apiClient, candidates, model) {
		if ($elm$core$List$isEmpty(candidates)) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var _v0 = model.DD;
			if (_v0.$ === 1) {
				var uploadId = _v0.a;
				var uploadProcess = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates, uploadId, candidates);
				var nextCmd = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, uploadProcess);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a8: A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(uploadProcess),
								model.a8)
						}),
					nextCmd,
					_List_Nil);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a8: A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
								A2(
									$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload,
									0,
									$elm$core$List$length(candidates)),
								model.a8)
						}),
					A2(
						$author$project$Api$ClinicalUploadResult$createCcda,
						apiClient,
						$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadCreated(candidates)),
					_List_Nil);
			}
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$CreateUpload = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilePath = F2(
	function (_v0, model) {
		var filename = _v0.a;
		var relativePath = _v0.b;
		var size = _v0.c;
		var _v1 = model.kD;
		if (!_v1.$) {
			var candidates = _v1.a;
			var updateFirstMatch = function (candidateList) {
				if (!candidateList.b) {
					return _List_Nil;
				} else {
					var first = candidateList.a;
					var rest = candidateList.b;
					return (_Utils_eq(
						$elm$file$File$name(first.adn),
						filename) && (_Utils_eq(
						$elm$file$File$size(first.adn),
						size) && _Utils_eq(first.VL, $elm$core$Maybe$Nothing))) ? A2(
						$elm$core$List$cons,
						_Utils_update(
							first,
							{
								VL: $elm$core$Maybe$Just(relativePath)
							}),
						rest) : A2(
						$elm$core$List$cons,
						first,
						updateFirstMatch(rest));
				}
			};
			var updatedCandidates = updateFirstMatch(candidates);
			var totalCount = $elm$core$List$length(updatedCandidates);
			var processedCount = $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.VL;
						},
						$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
					updatedCandidates));
			var updatedModal = A2(
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
				A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload, processedCount, totalCount),
				model.a8);
			var allPathsResolved = A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.VL;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				updatedCandidates);
			var shouldTriggerCreate = allPathsResolved && (!A2(
				$elm$core$List$all,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.VL;
					},
					$elm$core$Basics$neq($elm$core$Maybe$Nothing)),
				candidates));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						a8: updatedModal,
						kD: $elm$core$Maybe$Just(updatedCandidates)
					}),
				shouldTriggerCreate ? A2(
					$elm$core$Task$perform,
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$CreateUpload,
					$elm$core$Task$succeed(updatedCandidates)) : $elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState = function (process) {
	return $elm$core$List$isEmpty(process.sm) ? _Utils_Tuple2(
		$elm$core$Platform$Cmd$none,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete(
			{
				xy: A2(
					$elm$core$List$map,
					function (file) {
						return _Utils_Tuple3(file.zh, file.VL, file.xs);
					},
					process.xz),
				$W: process.tm
			})) : _Utils_Tuple2(
		A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, process),
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(process));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step = F2(
	function (proc, result) {
		var newRemaining = function () {
			var _v1 = proc.sm;
			if (!_v1.b) {
				return _List_Nil;
			} else {
				var rest = _v1.b;
				return rest;
			}
		}();
		var newFailures = function () {
			if (result.$ === 1) {
				var failedFile = result.a;
				return _Utils_ap(
					proc.xz,
					_List_fromArray(
						[failedFile]));
			} else {
				return proc.xz;
			}
		}();
		return _Utils_update(
			proc,
			{xz: newFailures, sm: newRemaining, aas: proc.aas + 1});
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFileUploadResponse = F4(
	function (_v0, candidate, response, model) {
		var _v1 = _Utils_Tuple2(model.a8.kH, response);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 2) {
				switch (_v1.b.$) {
					case 3:
						var process = _v1.a.a;
						var _v2 = _v1.b;
						var updatedProcess = A2(
							$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step,
							process,
							$elm$core$Result$Ok(0));
						var _v3 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
						var nextCmd = _v3.a;
						var newState = _v3.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									a8: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.a8)
								}),
							nextCmd,
							_List_Nil);
					case 2:
						var process = _v1.a.a;
						var error = _v1.b.a;
						if (error.$ === 10) {
							var updatedProcess = A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step,
								process,
								$elm$core$Result$Ok(0));
							var _v5 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
							var nextCmd = _v5.a;
							var newState = _v5.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										a8: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.a8)
									}),
								nextCmd,
								_List_Nil);
						} else {
							var failedFile = {
								xs: $author$project$Api$Data$errorToString(error),
								zh: $elm$file$File$name(candidate.adn),
								VL: A2($elm$core$Maybe$withDefault, '', candidate.VL)
							};
							var updatedProcess = A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step,
								process,
								$elm$core$Result$Err(failedFile));
							var _v6 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
							var nextCmd = _v6.a;
							var newState = _v6.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										a8: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.a8)
									}),
								nextCmd,
								_List_Nil);
						}
					default:
						break _v1$2;
				}
			} else {
				break _v1$2;
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch = {$: 7};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$isXmlFile = function (file) {
	return A2(
		$elm$core$String$endsWith,
		'.xml',
		$elm$file$File$name(file)) && (!A2(
		$elm$core$String$startsWith,
		'.',
		$elm$file$File$name(file)));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilesSelected = F2(
	function (rawFiles, model) {
		var _v0 = model.a8.kH;
		if (_v0.$ === 3) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var candidates = A2(
				$elm$core$List$map,
				function (f) {
					return {adn: f, VL: $elm$core$Maybe$Nothing};
				},
				A2($elm$core$List$filter, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$isXmlFile, rawFiles));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						a8: A2(
							$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
							A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload,
								0,
								$elm$core$List$length(candidates)),
							model.a8),
						gj: candidates,
						kD: $elm$core$Maybe$Just(candidates)
					}),
				A2(
					$elm$core$Task$perform,
					$elm$core$Basics$identity,
					$elm$core$Task$succeed($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch)),
				_List_Nil);
		}
	});
var $author$project$Api$Provider$ClinicalUploadResult$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$ClinicalUploadResult$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$Shared$id(shared);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadCreated = F4(
	function (_v0, candidates, response, model) {
		switch (response.$) {
			case 3:
				var uploadData = response.a;
				var uploadProcess = A2(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates,
					$author$project$Api$Provider$ClinicalUploadResult$One$id(uploadData),
					candidates);
				var nextCmd = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, uploadProcess);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a8: A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState,
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(uploadProcess),
								model.a8)
						}),
					nextCmd,
					_List_Nil);
			case 2:
				var error = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a8: A2(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal,
								function (m) {
									return _Utils_update(
										m,
										{
											j7: true,
											ts: $elm$core$Maybe$Just(
												$author$project$Api$Data$errorToString(error)),
											kH: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle
										});
								},
								model.a8)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploadResponse = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Api$ClinicalUploadResult$uploadCcdaFile = F5(
	function (apiClient, uploadId, file, maybeRelativePath, toMsg) {
		var filePart = A2($elm$http$Http$filePart, 'file', file);
		var parts = function () {
			if (!maybeRelativePath.$) {
				var relativePath = maybeRelativePath.a;
				return _List_fromArray(
					[
						filePart,
						A2($elm$http$Http$stringPart, 'relative_path', relativePath)
					]);
			} else {
				return _List_fromArray(
					[filePart]);
			}
		}();
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestMultipartBody,
				parts,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['emr', 'file_imports', 'ccda', uploadId, 'upload_file']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadFile = F4(
	function (apiClient, uploadId, candidate, model) {
		return _Utils_Tuple3(
			model,
			A5(
				$author$project$Api$ClinicalUploadResult$uploadCcdaFile,
				apiClient,
				uploadId,
				candidate.adn,
				candidate.VL,
				$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploadResponse(candidate)),
			_List_Nil);
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize = 20;
var $author$project$Ports$FilePaths$getFilePath = _Platform_outgoingPort(
	'getFilePath',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string($.zh)),
					_Utils_Tuple2(
					'size',
					$elm$json$Json$Encode$int($.ag_))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$processNextBatch = function (model) {
	var _v0 = function (batch) {
		return _Utils_Tuple2(
			batch,
			A2($elm$core$List$drop, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize, model.gj));
	}(
		A2($elm$core$List$take, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize, model.gj));
	var currentBatch = _v0.a;
	var remainingCandidates = _v0.b;
	var batchCommands = A2(
		$elm$core$List$map,
		function (candidate) {
			return $author$project$Ports$FilePaths$getFilePath(
				{
					zh: $elm$file$File$name(candidate.adn),
					ag_: $elm$file$File$size(candidate.adn)
				});
		},
		currentBatch);
	var hasMoreBatches = !$elm$core$List$isEmpty(remainingCandidates);
	var nextBatchCmd = hasMoreBatches ? A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch)) : $elm$core$Platform$Cmd$none;
	return _Utils_Tuple3(
		_Utils_update(
			model,
			{gj: remainingCandidates}),
		$elm$core$Platform$Cmd$batch(
			_Utils_ap(
				batchCommands,
				_List_fromArray(
					[nextBatchCmd]))),
		_List_Nil);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$update = F3(
	function (config, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j7: false, ts: $elm$core$Maybe$Nothing, kH: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle}),
					$elm$core$Platform$Cmd$none,
					config.rH(_List_Nil));
			case 1:
				var _v1 = model.kH;
				if (_v1.$ === 2) {
					var process = _v1.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal,
							$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete(
									{
										xy: A2(
											$elm$core$List$cons,
											_Utils_Tuple3(
												'Upload canceled',
												'',
												'The upload was canceled by the user. ' + ($elm$core$String$fromInt(process.aas) + (' of ' + ($elm$core$String$fromInt(process.tm) + (' files were uploaded successfully' + (($elm$core$List$length(process.xz) > 0) ? (', ' + ($elm$core$String$fromInt(
													$elm$core$List$length(process.xz)) + ' failed.')) : '.')))))),
											A2(
												$elm$core$List$map,
												function (f) {
													return _Utils_Tuple3(f.zh, f.VL, f.xs);
												},
												process.xz)),
										$W: process.tm
									})),
							model),
						$elm$core$Platform$Cmd$none,
						config.rH(_List_Nil));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						config.rH(_List_Nil));
				}
			default:
				var files = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					config.rH(files));
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$updateModal = F3(
	function (_v0, modalMsg, model) {
		var config = {rH: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploaded};
		var _v1 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$update, config, modalMsg, model.a8);
		var newModal = _v1.a;
		var cmd = _v1.b;
		var parentMsg = _v1.c;
		switch (modalMsg.$) {
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a8: newModal, gj: _List_Nil, kD: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a8: newModal}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{a8: newModal}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg, cmd),
								A2(
								$elm$core$Task$perform,
								$elm$core$Basics$identity,
								$elm$core$Task$succeed(parentMsg))
							])),
					_List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$update = F3(
	function (api, msg, model) {
		switch (msg.$) {
			case 5:
				var mm = msg.a;
				return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$updateModal, api, mm, model);
			case 0:
				var files = msg.a;
				return A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilesSelected, files, model);
			case 1:
				var candidates = msg.a;
				return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onCreateUpload, api, candidates, model);
			case 2:
				var candidates = msg.a;
				var resp = msg.b;
				return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadCreated, api, candidates, resp, model);
			case 3:
				var id = msg.a;
				var candidate = msg.b;
				return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadFile, api, id, candidate, model);
			case 4:
				var candidate = msg.a;
				var rsp = msg.b;
				return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFileUploadResponse, api, candidate, rsp, model);
			case 6:
				var _v1 = msg.a;
				var filename = _v1.a;
				var relativePath = _v1.b;
				var size = _v1.c;
				return A2(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilePath,
					_Utils_Tuple3(filename, relativePath, size),
					model);
			default:
				return $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$processNextBatch(model);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$uploadState = function (model) {
	return model.a8.kH;
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								o5: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{o5: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 0:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, o5: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, pagination, apiClient),
					_List_Nil);
			case 1:
				var uploadId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nL: $elm$core$Maybe$Just(uploadId)
						}),
					A4($author$project$Api$ClinicalUploadResult$processUpload, 1, apiClient, uploadId, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUploadResponse),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Processing started for the upload.')
						]));
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{nL: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.afy, apiClient),
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Processing completed successfully.')
								]));
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{nL: $elm$core$Maybe$Nothing}),
							A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.afy, apiClient),
							_List_fromArray(
								[
									A2(
									$author$project$OutMsg$ShowToast,
									1,
									'Processing failed: ' + $author$project$Api$Data$errorToString(error))
								]));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var uploadId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							DD: $elm$core$Maybe$Just(
								$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$AddToExisting(uploadId)),
							hc: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal(
								$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$initForExistingUpload(uploadId))
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							DD: $elm$core$Maybe$Just($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$NewUpload),
							hc: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var uploaderMsg = msg.a;
				var _v3 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$update, apiClient, uploaderMsg, model.hc);
				var newUploader = _v3.a;
				var cmd = _v3.b;
				var outMsgs = _v3.c;
				var refreshCmd = function () {
					var _v4 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$uploadState(newUploader);
					if (_v4.$ === 3) {
						return A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.afy, apiClient);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hc: newUploader}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg, cmd),
								refreshCmd
							])),
					outMsgs);
		}
	});
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$McePlanUpload$mcePlanUploadsPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['mce_plan_upload']),
		basePath);
};
var $author$project$Api$McePlanUpload$create = F3(
	function (apiClient, file, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A3(
				$author$project$Api$Data$requestWithFile,
				'file',
				file,
				$author$project$Api$Data$requestTo(
					$author$project$Api$McePlanUpload$mcePlanUploadsPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Api$McePlanUpload$update = F3(
	function (apiClient, file, toMsg) {
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A3(
				$author$project$Api$Data$requestWithFile,
				'file',
				file,
				$author$project$Api$Data$requestTo(
					$author$project$Api$McePlanUpload$mcePlanUploadsPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var files = msg.a;
				return $elm$core$List$isEmpty(files) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(
					model,
					function () {
						var _v1 = $elm$core$List$head(files);
						if (!_v1.$) {
							var file = _v1.a;
							var _v2 = model.Ib;
							if (!_v2) {
								return A3($author$project$Api$McePlanUpload$create, apiClient, file, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse);
							} else {
								return A3($author$project$Api$McePlanUpload$update, apiClient, file, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse);
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					_List_Nil);
			case 1:
				var response = msg.a;
				switch (response.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{j9: true, ts: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									j9: true,
									ts: $elm$core$Maybe$Just(
										$author$project$Api$Data$errorToString(error))
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{j9: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var actionType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{Ib: actionType}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Patients$Upload$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var resource = msg.a;
				var uploadResource = function () {
					switch (resource) {
						case 0:
							return 3;
						case 1:
							return 5;
						case 2:
							return 4;
						default:
							return 7;
					}
				}();
				var _v1 = A4($author$project$Components$Upload$Form$init, model.Hy, model.D5, uploadResource, $elm$core$Maybe$Nothing);
				var uploadForm = _v1.a;
				var uploadFormCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dw: $elm$core$Maybe$Nothing,
							Tx: $elm$core$Maybe$Nothing,
							G0: $elm$core$Maybe$Just(resource),
							g9: uploadForm
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, uploadFormCmd),
					_List_Nil);
			case 1:
				var clinicalResource = msg.a;
				if (!clinicalResource) {
					var _v4 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init, model.Hy, model.D5);
					var atlasClinicalUploadForm = _v4.a;
					var atlasClinicalUploadFormCmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								e1: atlasClinicalUploadForm,
								dw: $elm$core$Maybe$Just(clinicalResource),
								Tx: $elm$core$Maybe$Nothing,
								G0: $elm$core$Maybe$Nothing
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, atlasClinicalUploadFormCmd),
						_List_Nil);
				} else {
					var _v5 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init, model.Hy, model.D5);
					var ccdaClinicalUploadForm = _v5.a;
					var ccdaClinicalUploadFormCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fb: ccdaClinicalUploadForm,
								dw: $elm$core$Maybe$Just(clinicalResource),
								Tx: $elm$core$Maybe$Nothing,
								G0: $elm$core$Maybe$Nothing
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, ccdaClinicalUploadFormCmd),
						_List_Nil);
				}
			case 8:
				var mcePlanResource = msg.a;
				var uploadResource = 0;
				var _v6 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init, model.Hy, model.D5, uploadResource);
				var mcePlanUploadForm = _v6.a;
				var mcePlanUploadCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dw: $elm$core$Maybe$Nothing,
							Tx: $elm$core$Maybe$Just(mcePlanResource),
							f2: mcePlanUploadForm,
							G0: $elm$core$Maybe$Nothing
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, mcePlanUploadCmd),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v7 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$update, model.D5, subMsg, model.f2);
				var mcePlanUploadForm = _v7.a;
				var subCmd = _v7.b;
				var subOutMsgs = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f2: mcePlanUploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, subCmd),
					subOutMsgs);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{h8: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{h8: false}),
					A2($author$project$Api$Provider$Patient$destroyAll, model.D5, $author$project$Pages$Patients$Upload$GotPatientDestroyAll),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{h8: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{vk: false}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Patients were successfully removed.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var subMsg = msg.a;
				var _v9 = A3($author$project$Components$Upload$Form$update, model.D5, subMsg, model.g9);
				var uploadForm = _v9.a;
				var subCmd = _v9.b;
				var subOutMsgs = _v9.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g9: uploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, subCmd),
					subOutMsgs);
			case 6:
				var subMsg = msg.a;
				var _v10 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$update, model.D5, subMsg, model.e1);
				var atlasClinicalUploadForm = _v10.a;
				var subCmd = _v10.b;
				var subOutMsgs = _v10.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e1: atlasClinicalUploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, subCmd),
					subOutMsgs);
			default:
				var subMsg = msg.a;
				var _v11 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$update, model.D5, subMsg, model.fb);
				var ccdaClinicalUploadForm = _v11.a;
				var subCmd = _v11.b;
				var subOutMsgs = _v11.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fb: ccdaClinicalUploadForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, subCmd),
					subOutMsgs);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$uploadingModal = A3(
	$author$project$Ui$Modal$view,
	$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal,
	_List_fromArray(
		[
			$author$project$Ui$Modal$size(2)
		]),
	_List_fromArray(
		[
			$author$project$Ui$Modal$header(_List_Nil),
			$author$project$Ui$Modal$body(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('text-center')
						]),
					_List_fromArray(
						[
							$author$project$Ui$Spinner$view(_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('mt-3')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Uploading files, please wait...')
								]))
						]))
				]))
		]));
var $author$project$Components$Admin$Uploads$UploadModal$viewModalBody = F2(
	function (isError, message) {
		return isError ? _List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$danger,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]) : _List_fromArray(
			[
				A2(
				$author$project$Ui$Alert$success,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(message)
					]))
			]);
	});
var $author$project$Components$Admin$Uploads$UploadModal$view = F3(
	function (onClose, isError, message) {
		return A3(
			$author$project$Ui$Modal$view,
			onClose,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(_List_Nil),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							A2($author$project$Components$Admin$Uploads$UploadModal$viewModalBody, isError, message))
						]))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$modal = function (model) {
	if (model.mH) {
		return $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$uploadingModal;
	} else {
		var _v0 = _Utils_Tuple2(model.j9, model.ts);
		if (_v0.a) {
			if (!_v0.b.$) {
				var errorMessage = _v0.b.a;
				return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal, true, errorMessage);
			} else {
				var _v1 = _v0.b;
				return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal, false, 'Your files were uploaded successfully.');
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	}
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FileSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$File$Xml = 5;
var $author$project$Ui$Form$File$Directory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Form$File$directory = $author$project$Ui$Form$File$Directory;
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FailedFile = F3(
	function (name, path, error) {
		return {xs: error, zh: name, VL: path};
	});
var $author$project$Ui$Element$mb3 = $author$project$Ui$Element$Margin('mb-3');
var $author$project$Ui$Table$Bordered = {$: 1};
var $author$project$Ui$Table$bordered = $author$project$Ui$Table$Bordered;
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFailures = function (failedFiles) {
	var hasFailedFiles = !$elm$core$List$isEmpty(failedFiles);
	return hasFailedFiles ? A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mt4, $author$project$Ui$Element$textLeft]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Failed files:')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('table-wrapper overflow-y-auto max-h-[400px]')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Ui$Table$view,
						_List_fromArray(
							[
								$author$project$Ui$Table$bordered,
								$author$project$Ui$Table$containerClasses(
								_List_fromArray(
									['table-wrapper', 'overflow-y-auto', 'max-h-[400px]']))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Api$Column$view,
								$author$project$Api$Column$NonSortable,
								A3($author$project$Api$Column$init, 'filename', true, 'File Name')),
								A2(
								$author$project$Api$Column$view,
								$author$project$Api$Column$NonSortable,
								A3($author$project$Api$Column$init, 'path', true, 'Path')),
								A2(
								$author$project$Api$Column$view,
								$author$project$Api$Column$NonSortable,
								A3($author$project$Api$Column$init, 'error', true, 'Error Message'))
							]),
						A2(
							$elm$core$List$map,
							function (_v0) {
								var name = _v0.zh;
								var path = _v0.VL;
								var error = _v0.xs;
								return A2(
									$author$project$Ui$Table$row,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Table$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$bold, $author$project$Ui$Typography$danger]),
													_List_fromArray(
														[
															$elm$html$Html$text(name)
														]))
												])),
											A2(
											$author$project$Ui$Table$cell,
											_List_Nil,
											_List_fromArray(
												[
													$elm$core$String$isEmpty(path) ? $elm$html$Html$text('-') : $elm$html$Html$text(path)
												])),
											A2(
											$author$project$Ui$Table$cell,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$div,
													_List_fromArray(
														[$author$project$Ui$Typography$danger]),
													_List_fromArray(
														[
															$elm$html$Html$text(error)
														]))
												]))
										]));
							},
							failedFiles),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mt2]),
				_List_fromArray(
					[
						$elm$html$Html$text('Note: Failed files will be skipped, but the upload process will continue.')
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CancelUpload = {$: 1};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFooter = function (_v0) {
	var allowCancel = _v0.IU;
	var hasFailures = _v0.P6;
	var finished = _v0.Pq;
	return allowCancel ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Cancel upload'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CancelUpload),
					$author$project$Ui$Button$danger
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Cancel Upload')
				]))
		]) : ((hasFailures || finished) ? _List_fromArray(
		[
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Cancel and close modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal),
					$author$project$Ui$Button$primary
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Close')
				]))
		]) : _List_Nil);
};
var $author$project$Ui$ProgressBar$Animated = {$: 1};
var $author$project$Ui$ProgressBar$animated = $author$project$Ui$ProgressBar$Animated;
var $author$project$Ui$ProgressBar$ShowProgress = {$: 6};
var $author$project$Ui$ProgressBar$showProgress = $author$project$Ui$ProgressBar$ShowProgress;
var $author$project$Ui$ProgressBar$Striped = {$: 0};
var $author$project$Ui$ProgressBar$striped = $author$project$Ui$ProgressBar$Striped;
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewProgress = F2(
	function (current, total) {
		if (total > 0) {
			var progress = ((current * 100) / total) | 0;
			var displayCount = (progress >= 100) ? total : current;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb3]),
						_List_fromArray(
							[
								$author$project$Ui$ProgressBar$view(
								_List_fromArray(
									[
										$author$project$Ui$ProgressBar$striped,
										$author$project$Ui$ProgressBar$animated,
										$author$project$Ui$ProgressBar$width(progress),
										$author$project$Ui$ProgressBar$showProgress
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb3]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(displayCount) + (' of ' + ($elm$core$String$fromInt(total) + ' XML files')))
							]))
					]));
		} else {
			return $author$project$Ui$Spinner$view(_List_Nil);
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal = F5(
	function (message, current, total, failedFiles, allowCancel) {
		var progress = (!total) ? 0 : (((current * 100) / total) | 0);
		var failedCount = $elm$core$List$length(failedFiles);
		var config = {
			Mr: current,
			xy: A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var path = _v0.b;
					var error = _v0.c;
					return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FailedFile, name, path, error);
				},
				failedFiles),
			adv: {IU: allowCancel, Pq: progress >= 100, P6: failedCount > 0},
			aeD: message,
			tm: total
		};
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(_List_Nil),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('text-center')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mb3]),
									_List_fromArray(
										[
											$elm$html$Html$text(config.aeD)
										])),
									A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewProgress, config.Mr, config.tm),
									$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFailures(config.xy)
								]))
						])),
					$author$project$Ui$Modal$footer(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFooter(config.adv))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$view = function (model) {
	if (!model.j7) {
		return $author$project$Utils$Html$empty;
	} else {
		var _v0 = model.kH;
		switch (_v0.$) {
			case 1:
				var current = _v0.a;
				var total = _v0.b;
				return A5(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal,
					'Reading ' + ($elm$core$String$fromInt(current) + (' of ' + ($elm$core$String$fromInt(total) + ' files'))),
					current,
					total,
					_List_Nil,
					false);
			case 2:
				var process = _v0.a;
				return A5(
					$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal,
					'Uploading files',
					process.aas,
					process.tm,
					A2(
						$elm$core$List$map,
						function (f) {
							return _Utils_Tuple3(f.zh, f.VL, f.xs);
						},
						process.xz),
					true);
			case 3:
				var failedFiles = _v0.a.xy;
				var totalFiles = _v0.a.$W;
				return $elm$core$List$isEmpty(failedFiles) ? A5($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal, 'Upload complete!', totalFiles, totalFiles, _List_Nil, false) : A5($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal, 'Upload complete with errors', totalFiles, totalFiles, failedFiles, false);
			default:
				var _v1 = model.ts;
				if (!_v1.$) {
					var errorMessage = _v1.a;
					return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal, true, errorMessage);
				} else {
					var _v2 = function () {
						var _v3 = model.DD;
						if (!_v3.$) {
							return _Utils_Tuple2('Select Files to Upload', 'Select a folder containing CCDA (.xml) files. All CCDA files in the folder and its subfolders will be processed.');
						} else {
							return _Utils_Tuple2('Upload More Files', 'Select additional CCDA (.xml) files to add to this upload.');
						}
					}();
					var headerText = _v2.a;
					var helpText = _v2.b;
					return A3(
						$author$project$Ui$Modal$view,
						$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal,
						_List_fromArray(
							[
								$author$project$Ui$Modal$size(2)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Modal$header(
								_List_fromArray(
									[
										$elm$html$Html$text(headerText)
									])),
								$author$project$Ui$Modal$body(
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$helpText]),
										_List_fromArray(
											[
												$elm$html$Html$text(helpText)
											])),
										A2(
										$author$project$Ui$Form$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$noValidate(true),
												$author$project$Ui$Form$autocomplete(false)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Group$view,
												_List_Nil,
												_List_fromArray(
													[
														$author$project$Ui$Form$File$view(
														_List_fromArray(
															[
																$author$project$Ui$Form$File$directory(true),
																$author$project$Ui$Form$File$accept(5),
																$author$project$Ui$Form$File$onInput($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FileSelected)
															]))
													]))
											]))
									]))
							]));
				}
		}
	}
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$view = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$view(model.a8));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$modal = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg,
		$author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$view(model.hc));
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$modal = function (model) {
	var _v0 = _Utils_Tuple2(model.j9, model.ts);
	if (_v0.a) {
		if (!_v0.b.$) {
			var errorMessage = _v0.b.a;
			return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal, true, errorMessage);
		} else {
			var _v1 = _v0.b;
			return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal, false, 'Your files were uploaded successfully.');
		}
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$Patients$Upload$DeleteAllPatients = {$: 2};
var $author$project$Pages$Patients$Upload$Membership = 1;
var $author$project$Pages$Patients$Upload$PatientNote = 3;
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$PaginationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'file_name', true, 'File name'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'result', true, 'Result'),
		A3($author$project$Api$Column$init, 'created_at', true, 'Created At')
	]);
var $author$project$Api$Provider$ClinicalUploadResult$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$ClinicalUploadResult$All$createdAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$Shared$createdAt(shared);
};
var $author$project$Api$Provider$ClinicalUploadResult$Data$message = function (_v0) {
	var record = _v0;
	return record.aeD;
};
var $author$project$Api$Provider$ClinicalUploadResult$Shared$result = function (_v0) {
	var record = _v0;
	return record.Yz;
};
var $author$project$Api$Provider$ClinicalUploadResult$All$errorMessage = function (_v0) {
	var shared = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$ClinicalUploadResult$Data$message,
		$author$project$Api$Provider$ClinicalUploadResult$Shared$result(shared));
};
var $author$project$Api$Provider$ClinicalUploadResult$Shared$fileName = function (_v0) {
	var record = _v0;
	return record.Pm;
};
var $author$project$Api$Provider$ClinicalUploadResult$All$fileName = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$Shared$fileName(shared);
};
var $author$project$Api$Provider$ClinicalUploadResult$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$ClinicalUploadResult$All$Enqueued = {$: 0};
var $author$project$Api$Provider$ClinicalUploadResult$All$Failed = {$: 5};
var $author$project$Api$Provider$ClinicalUploadResult$All$PartiallyProcessed = {$: 6};
var $author$project$Api$Provider$ClinicalUploadResult$All$Processed = {$: 4};
var $author$project$Api$Provider$ClinicalUploadResult$All$Processing = {$: 3};
var $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForProcessing = {$: 2};
var $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForUploading = {$: 1};
var $author$project$Api$Provider$ClinicalUploadResult$All$Unknown = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$ClinicalUploadResult$All$stringToStatus = function (str) {
	switch (str) {
		case 'enqueued':
			return $author$project$Api$Provider$ClinicalUploadResult$All$Enqueued;
		case 'ready_for_uploading':
			return $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForUploading;
		case 'ready_for_processing':
			return $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForProcessing;
		case 'processing':
			return $author$project$Api$Provider$ClinicalUploadResult$All$Processing;
		case 'processed':
			return $author$project$Api$Provider$ClinicalUploadResult$All$Processed;
		case 'failed':
			return $author$project$Api$Provider$ClinicalUploadResult$All$Failed;
		case 'partially_processed':
			return $author$project$Api$Provider$ClinicalUploadResult$All$PartiallyProcessed;
		default:
			return $author$project$Api$Provider$ClinicalUploadResult$All$Unknown(str);
	}
};
var $author$project$Api$Provider$ClinicalUploadResult$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$All$stringToStatus(
		$author$project$Api$Provider$ClinicalUploadResult$Shared$status(shared));
};
var $author$project$Api$Provider$ClinicalUploadResult$All$statusToString = function (uploadStatus) {
	switch (uploadStatus.$) {
		case 0:
			return 'enqueued';
		case 1:
			return 'ready_for_uploading';
		case 2:
			return 'ready_for_processing';
		case 3:
			return 'processing';
		case 4:
			return 'processed';
		case 5:
			return 'failed';
		case 6:
			return 'partially_processed';
		default:
			var str = uploadStatus.a;
			return str;
	}
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewRow = F2(
	function (model, upload) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$ClinicalUploadResult$All$fileName(upload))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$ClinicalUploadResult$All$statusToString(
								$author$project$Api$Provider$ClinicalUploadResult$All$status(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$longText]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$ClinicalUploadResult$All$errorMessage(upload)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								model.Hy,
								0,
								$author$project$Api$Provider$ClinicalUploadResult$All$createdAt(upload)))
						]))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.o5;
		if (_v1.$ === 3) {
			var uploads_ = _v1.a;
			return _Utils_Tuple2(false, uploads_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploads = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no uploads yet!')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
			$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$columns),
		A2(
			$elm$core$List$map,
			$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewRow(model),
			uploads),
		_List_Nil);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewClinicalUploadResults = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Previous Atlas uploads')
					])),
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewTable(model),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$PaginationMsg,
				A2($author$project$Api$Pagination$view, _List_Nil, model.afy))
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$FileUploaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$File$Zip = 4;
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$isZipFile = function (file) {
	var fileName = $elm$file$File$name(file);
	return A2($elm$core$String$endsWith, '.zip', fileName) && (!A2($elm$core$String$startsWith, '.', fileName));
};
var $author$project$Ui$Form$File$Multiple = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Form$File$multiple = $author$project$Ui$Form$File$Multiple;
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewUploadForm = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$helpText]),
			_List_fromArray(
				[
					$elm$html$Html$text('Upload files (.zip only)')
				])),
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$noValidate(true),
					$author$project$Ui$Form$autocomplete(false)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$File$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$File$directory(true),
									$author$project$Ui$Form$File$accept(4),
									$author$project$Ui$Form$File$onInput(
									A2(
										$elm$core$Basics$composeL,
										$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$FileUploaded,
										$elm$core$List$filter($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$isZipFile))),
									$author$project$Ui$Form$File$multiple(true)
								]))
						]))
				]))
		]));
var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 2. Upload Atlas clinical information.')
					])),
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewUploadForm,
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewClinicalUploadResults(model)
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$PaginationMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$columns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'file_name', true, 'File name'),
		A3($author$project$Api$Column$init, 'status', true, 'Status'),
		A3($author$project$Api$Column$init, 'result', true, 'Result'),
		A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
		A3($author$project$Api$Column$init, 'actions', false, 'Actions')
	]);
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUpload = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploadMoreFiles = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$ClinicalUploadResult$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ClinicalUploadResult$Shared$id(shared);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewActionButtons = F3(
	function (model, upload, status) {
		switch (status.$) {
			case 3:
				return $author$project$Utils$Html$empty;
			case 4:
				return $author$project$Utils$Html$empty;
			default:
				var uploadId = $author$project$Api$Provider$ClinicalUploadResult$All$id(upload);
				var uploadMoreButton = A3(
					$author$project$Ui$Button$view,
					{abp: 'Upload more'},
					_List_fromArray(
						[
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploadMoreFiles(uploadId))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Upload more')
						]));
				var isProcessing = _Utils_eq(
					model.nL,
					$elm$core$Maybe$Just(uploadId));
				var buttonText = function () {
					switch (status.$) {
						case 6:
							return 'Re-process failed ones';
						case 5:
							return 'Re-process failed ones';
						default:
							return 'Process';
					}
				}();
				var processButton = A3(
					$author$project$Ui$Button$view,
					{abp: buttonText},
					_List_fromArray(
						[
							$author$project$Ui$Button$sm,
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$onClick(
							$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUpload(uploadId)),
							$author$project$Ui$Button$loading(isProcessing)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(buttonText)
						]));
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[processButton, uploadMoreButton]));
		}
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewRow = F2(
	function (model, upload) {
		var uploadStatus = $author$project$Api$Provider$ClinicalUploadResult$All$status(upload);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$ClinicalUploadResult$All$fileName(upload))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Api$Provider$ClinicalUploadResult$All$statusToString(uploadStatus))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$longText]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$ClinicalUploadResult$All$errorMessage(upload)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								model.Hy,
								0,
								$author$project$Api$Provider$ClinicalUploadResult$All$createdAt(upload)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$noWrap]),
					_List_fromArray(
						[
							A3($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewActionButtons, model, upload, uploadStatus)
						]))
				]));
	});
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.o5;
		if (_v1.$ === 3) {
			var uploads_ = _v1.a;
			return _Utils_Tuple2(false, uploads_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var uploads = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You have no uploads yet!')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		A2(
			$elm$core$List$map,
			$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
			$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$columns),
		A2(
			$elm$core$List$map,
			$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewRow(model),
			uploads),
		_List_Nil);
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewClinicalUploadResults = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Previous CCDA uploads')
					])),
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewTable(model),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$PaginationMsg,
				A2($author$project$Api$Pagination$view, _List_Nil, model.afy))
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$OpenFileSelectionModal = {$: 4};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewUploadForm = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.DD;
				if ((!_v0.$) && (_v0.a.$ === 1)) {
					var uploadId = _v0.a.a;
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpText]),
						_List_fromArray(
							[
								$elm$html$Html$text('Adding files to upload ' + uploadId)
							]));
				} else {
					return A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$helpText]),
						_List_fromArray(
							[
								$elm$html$Html$text('Click the button below to select a folder containing CCDA (.xml) files. All CCDA files in the folder and its subfolders will be processed.')
							]));
				}
			}(),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Create upload'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$OpenFileSelectionModal),
						$author$project$Ui$Button$primary
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Create Upload')
					]))
			]));
};
var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 2. Upload CCDA clinical information.')
					])),
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewUploadForm(model),
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewClinicalUploadResults(model)
			]));
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Upload$McePlanResource$McePlanUpdate = 1;
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns = function (isCreate) {
	var viewColumn = function (_v0) {
		var name = _v0.a;
		var isRequired = _v0.b;
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name),
					isRequired ? A2(
					$author$project$Ui$Typography$em,
					_List_fromArray(
						[$author$project$Ui$Typography$danger, $author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text(' * required')
						])) : $author$project$Utils$Html$empty
				]));
	};
	var baseColumns = _List_fromArray(
		[
			_Utils_Tuple2('Tier', isCreate),
			_Utils_Tuple2('Ages', isCreate),
			_Utils_Tuple2('IUA Level', isCreate)
		]);
	var actionSpecificColumns = isCreate ? _List_fromArray(
		[
			_Utils_Tuple2('Plan Name', true)
		]) : _List_fromArray(
		[
			_Utils_Tuple2('Plan ID', true)
		]);
	var csvColumns = _Utils_ap(baseColumns, actionSpecificColumns);
	return A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2($elm$core$List$map, viewColumn, csvColumns));
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$FileUploaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewUploadForm = A2(
	$author$project$Ui$Form$view,
	_List_fromArray(
		[
			$author$project$Ui$Form$noValidate(true),
			$author$project$Ui$Form$autocomplete(false)
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$File$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$File$accept(1),
							$author$project$Ui$Form$File$onInput($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$FileUploaded),
							$author$project$Ui$Form$File$multiple(true)
						]))
				]))
		]));
var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 2. Select desired change.')
					])),
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Create mce plan'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated(0)),
								$author$project$Ui$Button$active(!model.Ib)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Update mce plan'},
						_List_fromArray(
							[
								$author$project$Ui$Button$onClick(
								$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated(1)),
								$author$project$Ui$Button$active(model.Ib === 1)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Update')
							]))
					])),
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 3. Create a CSV file.')
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('It should include these exact headers:')
					])),
				(!model.Ib) ? $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns(true) : $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns(false),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Get started with our ready-to-go template'),
						$author$project$Utils$Html$noBreakSpace,
						A3(
						$author$project$Ui$Link$externalHref,
						'https://docs.google.com/spreadsheets/d/1QNttlhfBQm-LV-a0WCvsiqNOONyzYTE99WG7BLkVIso/edit?gid=0#gid=0',
						_List_fromArray(
							[$author$project$Ui$Link$targetBlank]),
						_List_fromArray(
							[
								$elm$html$Html$text('here.')
							]))
					])),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$author$project$Ui$Typography$title,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Step 4. Upload the file.')
					])),
				$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewUploadForm
			]));
};
var $author$project$Pages$Patients$Upload$Charge = 2;
var $author$project$Api$FeatureGate$ChargeUploader = 1;
var $author$project$Pages$Patients$Upload$ResourceSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Patients$Upload$buttonStyle = function (bool) {
	return bool ? 1 : 0;
};
var $author$project$Pages$Patients$Upload$viewChargeResourceButton = function (model) {
	var hasFeatureGate = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		1,
		$author$project$Api$Practice$Provider(model.WF));
	return hasFeatureGate ? A3(
		$author$project$Ui$Button$view,
		{abp: 'Charges'},
		_List_fromArray(
			[
				$author$project$Ui$Button$active(
				_Utils_eq(
					model.G0,
					$elm$core$Maybe$Just(2))),
				$author$project$Ui$Button$styled(
				$author$project$Pages$Patients$Upload$buttonStyle(
					_Utils_eq(
						model.G0,
						$elm$core$Maybe$Just(2)))),
				$author$project$Ui$Button$pull(0),
				$author$project$Ui$Button$onClick(
				$author$project$Pages$Patients$Upload$ResourceSelected(2))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Charges')
			])) : (model.FR ? A3(
		$author$project$Ui$HinterOnly$button,
		{abp: 'Charges'},
		_List_fromArray(
			[
				$author$project$Ui$Button$active(
				_Utils_eq(
					model.G0,
					$elm$core$Maybe$Just(2))),
				$author$project$Ui$Button$styled(
				$author$project$Pages$Patients$Upload$buttonStyle(
					_Utils_eq(
						model.G0,
						$elm$core$Maybe$Just(2)))),
				$author$project$Ui$Button$pull(0),
				$author$project$Ui$Button$onClick(
				$author$project$Pages$Patients$Upload$ResourceSelected(2))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Charges')
			])) : $author$project$Utils$Html$empty);
};
var $author$project$Pages$Patients$Upload$ClinicalResourceSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Patients$Upload$viewClinicalResourceButton = F4(
	function (clinicalResource, label, flag, model) {
		return flag ? A3(
			$author$project$Ui$HinterOnly$button,
			{abp: 'Select ' + label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						model.dw,
						$elm$core$Maybe$Just(clinicalResource))),
					$author$project$Ui$Button$styled(
					$author$project$Pages$Patients$Upload$buttonStyle(
						_Utils_eq(
							model.dw,
							$elm$core$Maybe$Just(clinicalResource)))),
					$author$project$Ui$Button$pull(0),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$Upload$ClinicalResourceSelected(clinicalResource))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$Upload$McePlanResourceSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Patients$Upload$viewMcePlanResourceButton = F2(
	function (mcePlanResource, model) {
		return ($author$project$Api$Provider$Practice$One$accountType(model.WF) === 2) ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Select Healthshare Plan'},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						model.Tx,
						$elm$core$Maybe$Just(0))),
					$author$project$Ui$Button$styled(
					$author$project$Pages$Patients$Upload$buttonStyle(
						_Utils_eq(
							model.Tx,
							$elm$core$Maybe$Just(0)))),
					$author$project$Ui$Button$pull(0),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$Upload$McePlanResourceSelected(mcePlanResource))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Healthshare Plan')
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Pages$Patients$Upload$viewResourceButton = F4(
	function (resource, label, isHinter, model) {
		return isHinter ? A3(
			$author$project$Ui$HinterOnly$button,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						model.G0,
						$elm$core$Maybe$Just(resource))),
					$author$project$Ui$Button$styled(
					$author$project$Pages$Patients$Upload$buttonStyle(
						_Utils_eq(
							model.G0,
							$elm$core$Maybe$Just(resource))))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])) : A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$active(
					_Utils_eq(
						model.G0,
						$elm$core$Maybe$Just(resource))),
					$author$project$Ui$Button$styled(
					$author$project$Pages$Patients$Upload$buttonStyle(
						_Utils_eq(
							model.G0,
							$elm$core$Maybe$Just(resource)))),
					$author$project$Ui$Button$pull(0),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Patients$Upload$ResourceSelected(resource))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Pages$Patients$Upload$viewBody = function (model) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$titleWithButton,
						_List_fromArray(
							[
								$elm$html$Html$text('Data Uploader')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						model.vk ? A2(
						$author$project$Ui$Well$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Want to Start Over?')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Click the button below to remove all existing patients before uploading a new list of patients.')
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Delete all patients'},
								_List_fromArray(
									[
										$author$project$Ui$Button$danger,
										$author$project$Ui$Button$onClick($author$project$Pages$Patients$Upload$DeleteAllPatients)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Delete All Patients')
									]))
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanMd(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$title,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Step 1. Choose a data type.')
											])),
										$author$project$Ui$Button$group(
										_List_fromArray(
											[
												A4($author$project$Pages$Patients$Upload$viewResourceButton, 0, 'Patients', false, model),
												A4($author$project$Pages$Patients$Upload$viewResourceButton, 1, 'Memberships', false, model),
												$author$project$Pages$Patients$Upload$viewChargeResourceButton(model),
												A4($author$project$Pages$Patients$Upload$viewResourceButton, 3, 'Patient Notes', false, model),
												A4($author$project$Pages$Patients$Upload$viewClinicalResourceButton, 0, 'Atlas Clinical', model.FR, model),
												A4($author$project$Pages$Patients$Upload$viewClinicalResourceButton, 1, 'CCDA Clinical', model.FR, model),
												A2($author$project$Pages$Patients$Upload$viewMcePlanResourceButton, 0, model)
											]))
									]))
							])),
						function () {
						var _v0 = _Utils_Tuple3(model.G0, model.dw, model.Tx);
						_v0$3:
						while (true) {
							if (_v0.a.$ === 1) {
								if (!_v0.b.$) {
									if (!_v0.b.a) {
										if (_v0.c.$ === 1) {
											var _v1 = _v0.a;
											var _v2 = _v0.b.a;
											var _v3 = _v0.c;
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg,
												$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$view(model.e1));
										} else {
											break _v0$3;
										}
									} else {
										if (_v0.c.$ === 1) {
											var _v4 = _v0.a;
											var _v5 = _v0.b.a;
											var _v6 = _v0.c;
											return A2(
												$elm$html$Html$map,
												$author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg,
												$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$view(model.fb));
										} else {
											break _v0$3;
										}
									}
								} else {
									if (!_v0.c.$) {
										var _v7 = _v0.a;
										var _v8 = _v0.b;
										var _v9 = _v0.c.a;
										return A2(
											$elm$html$Html$map,
											$author$project$Pages$Patients$Upload$McePlanUploadFormMsg,
											$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$view(model.f2));
									} else {
										break _v0$3;
									}
								}
							} else {
								break _v0$3;
							}
						}
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$Patients$Upload$UploadFormMsg,
							A2($author$project$Components$Upload$Form$view, model.D5, model.g9));
					}()
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Patients__Top,
						_List_fromArray(
							[$author$project$Ui$Link$buttonDefault]),
						_List_fromArray(
							[
								A2($author$project$Ui$Icon$view, _List_Nil, 13),
								$author$project$Utils$Html$noBreakSpace,
								$elm$html$Html$text('Go Back')
							]))
					]))
			]));
};
var $author$project$Pages$Patients$Upload$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				model.h8 ? A2(
				$author$project$Components$HiConfirm$modal,
				$author$project$Pages$Patients$Upload$HiConfirmClosed,
				_List_fromArray(
					[
						$author$project$Components$HiConfirm$verb('Delete All Patients'),
						$author$project$Components$HiConfirm$customMessage(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Warning: ')
									])),
								$elm$html$Html$text('this will delete all the patients from the practice.')
							]))
					])) : $author$project$Utils$Html$empty,
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Upload$UploadFormMsg,
				A2($author$project$Components$Upload$Form$modal, model.D5, model.g9)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$modal(model.e1)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg,
				$author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$modal(model.fb)),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$Patients$Upload$McePlanUploadFormMsg,
				$author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$modal(model.f2)),
				$author$project$Pages$Patients$Upload$viewBody(model)
			]),
		$G: 'Patients'
	};
};
var $author$project$Pages$Patients$Upload$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Patients$Upload$init, aer: $author$project$Pages$Patients$Upload$load, agD: $author$project$Pages$Patients$Upload$save, ahd: $author$project$Pages$Patients$Upload$subscriptions, aaq: $author$project$Pages$Patients$Upload$update, ahP: $author$project$Pages$Patients$Upload$view});
var $author$project$Pages$PracticeSetup$Account$AccountFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$Account$GotPractice = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Platform$Organization$Shared$onboardingClinical = function (_v0) {
	var record = _v0.b;
	return record.U6;
};
var $author$project$Pages$PracticeSetup$Account$onboardingClinical = function (session) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$Organization$Shared$onboardingClinical,
			$author$project$Api$Platform$Session$One$organization(session)));
};
var $author$project$Api$Provider$Practice$DefaultPlan = 1;
var $author$project$Pages$PracticeSetup$Account$practiceOptionals = function (optionals) {
	return _Utils_update(
		optionals,
		{
			Fc: _List_fromArray(
				[1])
		});
};
var $author$project$Pages$PracticeSetup$Account$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A4(
			$author$project$Components$Practice$AccountForm$init,
			practice,
			shared.aa1,
			shared,
			{
				aJ: true,
				U6: $author$project$Pages$PracticeSetup$Account$onboardingClinical(session)
			});
		var accountFormModel = _v1.a;
		var accountFormCmd = _v1.b;
		return _Utils_Tuple2(
			{
				cu: accountFormModel,
				D5: shared.D5,
				Ni: '',
				FR: $author$project$Shared$isHintAdmin(shared),
				WF: practice,
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				Cd: shared
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, accountFormCmd),
						A3($author$project$Api$Provider$Practice$retrieve, shared.D5, $author$project$Pages$PracticeSetup$Account$practiceOptionals, $author$project$Pages$PracticeSetup$Account$GotPractice)
					])));
	});
var $author$project$Utils$PracticeSetup$redirectIfOnboardingComplete = F2(
	function (sessionData, hinterViewOff) {
		if (sessionData.$ === 3) {
			var session = sessionData.a;
			var practiceIsOnboarding = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Platform$Organization$Shared$practiceIsOnboarding,
					$author$project$Api$Platform$Session$One$organization(session)));
			return practiceIsOnboarding ? $elm$core$Platform$Cmd$none : A2(
				$author$project$Utils$Route$navigate,
				$elm$core$Dict$empty,
				A2($author$project$Permission$homeStateFor, session, hinterViewOff));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pages$PracticeSetup$Account$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Account$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Account$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$PracticeSetup$Account$AccountFormMsg,
		$author$project$Components$Practice$AccountForm$subscriptions(model.cu));
};
var $author$project$Api$Provider$Practice$One$defaultPlanId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Ni;
	});
var $author$project$Pages$PracticeSetup$Account$Updated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PracticeSetup$Account$updatePractice = F2(
	function (apiClient, formFields) {
		var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
		return A3(
			$author$project$Api$Provider$Practice$update,
			apiClient,
			$author$project$Components$Practice$AccountForm$practiceFromFields(fields),
			$author$project$Pages$PracticeSetup$Account$Updated);
	});
var $author$project$Pages$PracticeSetup$Account$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$Practice$AccountForm$update, subMsg, model.cu);
				var accountFormModel = _v1.a;
				var accountFormCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cu: accountFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, accountFormCmd),
					_List_Nil);
			case 1:
				var _v2 = $author$project$Components$Practice$AccountForm$validate(model.cu);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var validFormFields = _v3.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cu: validatedForm, jY: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$PracticeSetup$Account$updatePractice, model.D5, validFormFields),
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cu: erroredForm, jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var _v5 = A4(
						$author$project$Components$Practice$AccountForm$init,
						practice,
						model.Cd.aa1,
						model.Cd,
						{
							aJ: true,
							U6: $author$project$Pages$PracticeSetup$Account$onboardingClinical(model.ZD)
						});
					var form = _v5.a;
					var cmds = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cu: form, jY: response}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, cmds),
									A2(
									$author$project$Utils$Route$navigate,
									$elm$core$Dict$empty,
									$author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit(
										{adR: model.Ni}))
								])),
						_List_fromArray(
							[
								$author$project$OutMsg$PracticeUpdated(response)
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var practice = response.a;
					var defaultPlanId = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$author$project$Api$Expandable$withDefault,
							$elm$core$Maybe$Nothing,
							$author$project$Api$Provider$Practice$One$defaultPlanId(practice)));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Ni: defaultPlanId}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$PracticeSetup$Account$FormSubmitted = {$: 1};
var $author$project$Pages$PracticeSetup$Account$view = function (model) {
	var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(model.WF) || $author$project$Pages$PracticeSetup$Account$onboardingClinical(model.ZD);
	var practiceIsOnboarding = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$Organization$Shared$practiceIsOnboarding,
			$author$project$Api$Platform$Session$One$organization(model.ZD)));
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$PracticeSetup$Account$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						practiceIsOnboarding ? _List_fromArray(
							[$author$project$Ui$Panel$onlyBorderLeft]) : _List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text('Contact Information')
											])),
										A2(
										$author$project$Ui$Typography$p,
										_List_fromArray(
											[$author$project$Ui$Typography$muted]),
										_List_fromArray(
											[
												$elm$html$Html$text('This information will be displayed to patients on communications and sign-up pages so they know how to reach you.'),
												usingClinicalEmr ? A2(
												$author$project$Ui$Typography$div,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Practice phone and fax will be added later.')
													])) : $author$project$Utils$Html$empty
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$PracticeSetup$Account$AccountFormMsg,
										$author$project$Components$Practice$AccountForm$view(model.cu)),
										function () {
										var _v0 = model.jY;
										if (_v0.$ === 2) {
											var error = _v0.a;
											return A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$mt4]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Alert$danger,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Data$errorToString(error))
															]))
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}()
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2($author$project$Ui$Typography$div, _List_Nil, _List_Nil),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Next'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Next')
											]))
									]))
							]))
					]))
			]),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Account$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Account$init, aer: $author$project$Pages$PracticeSetup$Account$load, agD: $author$project$Pages$PracticeSetup$Account$save, ahd: $author$project$Pages$PracticeSetup$Account$subscriptions, aaq: $author$project$Pages$PracticeSetup$Account$update, ahP: $author$project$Pages$PracticeSetup$Account$view});
var $author$project$Pages$PracticeSetup$Communications$GetNewNumbers = 0;
var $author$project$Pages$PracticeSetup$Communications$initFormFields = {iF: 0, mc: '', gm: 0, nt: ''};
var $author$project$Pages$PracticeSetup$Communications$init = F4(
	function (session, practice, shared, _v0) {
		var phoneInputOptions = function (opts) {
			return _Utils_update(
				opts,
				{Ik: true, abk: false, acB: $author$project$Api$Common$Phone$Shared$Office, acN: true, mo: true, yQ: 1});
		};
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				ON: $elm$core$Maybe$Nothing,
				fF: A3($author$project$Components$PhoneInput$init, 'practice-fax', _List_Nil, phoneInputOptions),
				PB: $author$project$Utils$Form$init($author$project$Pages$PracticeSetup$Communications$initFormFields),
				FR: $author$project$Shared$isHintAdmin(shared),
				fS: false,
				bw: A3($author$project$Components$PhoneInput$init, 'practice-phone', _List_Nil, phoneInputOptions),
				WF: practice,
				ZD: session
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$PracticeSetup$Communications$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Communications$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Communications$FaxInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PracticeSetup$Communications$PhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(model.bw)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PracticeSetup$Communications$FaxInputMsg,
				$author$project$Components$PhoneInput$subscriptions(model.fF))
			]));
};
var $author$project$Pages$PracticeSetup$Communications$GotResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$PortExistingNumbers = 1;
var $author$project$Api$CommunicationsSetup$communicationsSetupPath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['communications_setup']),
		basePath);
};
var $author$project$Api$CommunicationsSetup$listDefaults = {Fh: $elm$core$Maybe$Nothing, Wg: $elm$core$Maybe$Nothing};
var $author$project$Api$CommunicationsSetup$encodeRequest = function (optionals) {
	var options = optionals($author$project$Api$CommunicationsSetup$listDefaults);
	var encodePhoneOrFax = function (data) {
		return $elm$json$Json$Encode$object(
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							_Utils_Tuple2(
							'action',
							$elm$json$Json$Encode$string(data.DV))
						]),
						A3($author$project$Utils$Encode$optional, 'area_code', $elm$json$Json$Encode$string, data.D7),
						A3($author$project$Utils$Encode$optional, 'number', $elm$json$Json$Encode$string, data.Gj)
					])));
	};
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'phone',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, encodePhoneOrFax, options.Wg))),
				_Utils_Tuple2(
				'fax',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, encodePhoneOrFax, options.Fh)))
			]));
};
var $author$project$Api$CommunicationsSetup$create = F3(
	function (apiClient, query, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$author$project$Api$CommunicationsSetup$encodeRequest(query),
				$author$project$Api$Data$requestTo(
					$author$project$Api$CommunicationsSetup$communicationsSetupPath($author$project$Api$Data$providerPath))));
	});
var $author$project$Api$CommunicationsSetup$FaxData = F3(
	function (action, area_code, number) {
		return {DV: action, D7: area_code, Gj: number};
	});
var $author$project$Api$CommunicationsSetup$PhoneData = F3(
	function (action, area_code, number) {
		return {DV: action, D7: area_code, Gj: number};
	});
var $author$project$Pages$PracticeSetup$Communications$createParams = F2(
	function (fields, model) {
		return function (d) {
			var phoneData = function () {
				var _v1 = fields.gm;
				if (!_v1) {
					return A3(
						$author$project$Api$CommunicationsSetup$PhoneData,
						'buy',
						$elm$core$Maybe$Just(fields.nt),
						$elm$core$Maybe$Nothing);
				} else {
					var phoneNumber = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Gj;
							},
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$List$head,
								$author$project$Components$PhoneInput$getPhones(model.bw))));
					return A3(
						$author$project$Api$CommunicationsSetup$PhoneData,
						'port',
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(phoneNumber));
				}
			}();
			var faxData = function () {
				var _v0 = fields.iF;
				if (!_v0) {
					return A3(
						$author$project$Api$CommunicationsSetup$FaxData,
						'buy',
						$elm$core$Maybe$Just(fields.mc),
						$elm$core$Maybe$Nothing);
				} else {
					var faxNumber = A2(
						$elm$core$Maybe$withDefault,
						'',
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Gj;
							},
							A2(
								$elm$core$Maybe$andThen,
								$elm$core$List$head,
								$author$project$Components$PhoneInput$getPhones(model.fF))));
					return A3(
						$author$project$Api$CommunicationsSetup$FaxData,
						'port',
						$elm$core$Maybe$Nothing,
						$elm$core$Maybe$Just(faxNumber));
				}
			}();
			return _Utils_update(
				d,
				{
					Fh: $elm$core$Maybe$Just(faxData),
					Wg: $elm$core$Maybe$Just(phoneData)
				});
		};
	});
var $author$project$Pages$PracticeSetup$Communications$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var option = field.a;
				return _Utils_update(
					fields,
					{gm: option});
			case 1:
				var areaCode = field.a;
				return _Utils_update(
					fields,
					{nt: areaCode});
			case 2:
				var option = field.a;
				return _Utils_update(
					fields,
					{iF: option});
			default:
				var areaCode = field.a;
				return _Utils_update(
					fields,
					{mc: areaCode});
		}
	});
var $author$project$Pages$PracticeSetup$Communications$FaxAreaCodeValidation = 2;
var $author$project$Pages$PracticeSetup$Communications$FaxNumberValidation = 3;
var $author$project$Pages$PracticeSetup$Communications$validateNumber = F6(
	function (action, areaCode, phoneInput, areaCodeValidation, numberValidation, numberType) {
		if (!action) {
			return (!$elm$core$String$length(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, areaCode))) ? _List_fromArray(
				[
					_Utils_Tuple2(areaCodeValidation, 'You must enter a preferred area code for ' + (numberType + '.'))
				]) : (($elm$core$String$length(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, areaCode)) !== 3) ? _List_fromArray(
				[
					_Utils_Tuple2(areaCodeValidation, 'Area code must be exactly 3 digits.')
				]) : _List_Nil);
		} else {
			if ($author$project$Components$PhoneInput$hasErrors(phoneInput)) {
				return _List_fromArray(
					[
						_Utils_Tuple2(numberValidation, 'Please enter a valid ' + (numberType + ' number.'))
					]);
			} else {
				var number = A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.Gj;
						},
						A2(
							$elm$core$Maybe$andThen,
							$elm$core$List$head,
							$author$project$Components$PhoneInput$getPhones(phoneInput))));
				return (!$elm$core$String$length(number)) ? _List_fromArray(
					[
						_Utils_Tuple2(numberValidation, 'You must enter a ' + (numberType + ' number to port.'))
					]) : _List_Nil;
			}
		}
	});
var $author$project$Pages$PracticeSetup$Communications$validateFax = F2(
	function (model, fields) {
		return A6($author$project$Pages$PracticeSetup$Communications$validateNumber, fields.iF, fields.mc, model.fF, 2, 3, 'fax');
	});
var $author$project$Pages$PracticeSetup$Communications$PhoneAreaCodeValidation = 0;
var $author$project$Pages$PracticeSetup$Communications$PhoneNumberValidation = 1;
var $author$project$Pages$PracticeSetup$Communications$validatePhone = F2(
	function (model, fields) {
		return A6($author$project$Pages$PracticeSetup$Communications$validateNumber, fields.gm, fields.nt, model.bw, 0, 1, 'phone');
	});
var $author$project$Pages$PracticeSetup$Communications$formFieldsValidator = function (model) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$PracticeSetup$Communications$validatePhone(model)),
				$rtfeldman$elm_validate$Validate$fromErrors(
				$author$project$Pages$PracticeSetup$Communications$validateFax(model))
			]));
};
var $author$project$Pages$PracticeSetup$Communications$navigateToLegal = A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Legal);
var $author$project$Pages$PracticeSetup$Communications$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = A2(
					$author$project$Utils$Form$validate,
					$author$project$Pages$PracticeSetup$Communications$formFieldsValidator(model),
					model.PB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var newForm = _v2.a;
					var validFormFields = _v2.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var _v3 = fields.gm;
					if (!_v3) {
						var cmd = A3(
							$author$project$Api$CommunicationsSetup$create,
							model.D5,
							A2($author$project$Pages$PracticeSetup$Communications$createParams, fields, model),
							$author$project$Pages$PracticeSetup$Communications$GotResponse);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ON: $elm$core$Maybe$Nothing, PB: newForm, fS: true}),
							cmd,
							_List_Nil);
					} else {
						var cmd = A3(
							$author$project$Api$CommunicationsSetup$create,
							model.D5,
							A2($author$project$Pages$PracticeSetup$Communications$createParams, fields, model),
							$author$project$Pages$PracticeSetup$Communications$GotResponse);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ON: $elm$core$Maybe$Nothing, PB: newForm, fS: true}),
							cmd,
							_List_Nil);
					}
				} else {
					var newForm = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var fields = $author$project$Utils$Form$fields(model.PB);
						var isFaxPorting = fields.iF === 1;
						var isPhonePorting = fields.gm === 1;
						var portingType = function () {
							var _v6 = _Utils_Tuple2(isPhonePorting, isFaxPorting);
							if (_v6.a) {
								if (_v6.b) {
									return $elm$core$Maybe$Just('phone, fax');
								} else {
									return $elm$core$Maybe$Just('phone');
								}
							} else {
								if (_v6.b) {
									return $elm$core$Maybe$Just('fax');
								} else {
									return $elm$core$Maybe$Nothing;
								}
							}
						}();
						var logPortingEventCmd = function () {
							if (!portingType.$) {
								var typeValue = portingType.a;
								return A2(
									$author$project$Utils$Analytics$Shared$logSimpleEvent,
									'self onboarding phone port requested',
									_List_fromArray(
										[
											A2($author$project$Utils$Analytics$Shared$property, 'type', typeValue)
										]));
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ON: $elm$core$Maybe$Nothing, fS: false}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[$author$project$Pages$PracticeSetup$Communications$navigateToLegal, logPortingEventCmd])),
							_List_Nil);
					case 2:
						var error = response.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ON: $elm$core$Maybe$Just(
										$author$project$Api$Data$errorToString(error)),
									fS: false
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fS: false}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
				}
			case 1:
				var field = msg.a;
				var form = A3($author$project$Utils$Form$update, $author$project$Pages$PracticeSetup$Communications$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: form}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, model.bw);
				var phoneInput = _v7.a;
				var phoneCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bw: phoneInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg, phoneCmd),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Components$PhoneInput$update, subMsg, model.fF);
				var faxInput = _v8.a;
				var faxCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fF: faxInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Communications$FaxInputMsg, faxCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$PracticeSetup$Communications$FormSubmitted = {$: 0};
var $author$project$Pages$PracticeSetup$Communications$SetFaxAction = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$SetFaxAreaCode = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$FormUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$areaCodeInput = function (config) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(4),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Area Code')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$value(config.vs),
						$author$project$Ui$Form$Input$onInput(
						function (str) {
							return $author$project$Pages$PracticeSetup$Communications$FormUpdated(
								config.zG(str));
						}),
						$author$project$Ui$Form$Input$maxLength(3),
						$author$project$Ui$Form$Input$placeholder('000'),
						$author$project$Ui$Form$Input$invalid(
						A2($author$project$Utils$Form$hasValidationErrors, config.py, config.PB))
					])),
				A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
				_List_fromArray(
					[
						$elm$html$Html$text('Enter a 3-digit area code to use for any new numbers.')
					])),
				$author$project$Utils$FormErrors$view(
				A2($author$project$Utils$Form$validationErrors, config.py, config.PB))
			]));
};
var $author$project$Pages$PracticeSetup$Communications$existingNumberInput = function (config) {
	return A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpanSm(3),
				$author$project$Ui$Form$Group$inputSpanSm(5),
				$author$project$Ui$Form$Group$required(true),
				$author$project$Ui$Form$Group$label('Existing ' + (config.aej + ' Number'))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				config.AO,
				$author$project$Components$PhoneInput$view(config.bw)),
				$author$project$Utils$FormErrors$view(
				A2($author$project$Utils$Form$validationErrors, config.zE, config.PB))
			]));
};
var $author$project$Pages$PracticeSetup$Communications$viewOptions = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$labelSpanSm(3),
						$author$project$Ui$Form$Group$inputSpanSm(9),
						$author$project$Ui$Form$Group$label(config.aej)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_fromArray(
							[$author$project$Ui$FlexGrid$mt2]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(3)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Radio$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Radio$value(!config.lE),
												$author$project$Ui$Form$Radio$onCheck(
												function (_v0) {
													return $author$project$Pages$PracticeSetup$Communications$FormUpdated(
														config.rE(0));
												})
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Get a New Number')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(6)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Radio$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Radio$value(config.lE === 1),
												$author$project$Ui$Form$Radio$onCheck(
												function (_v1) {
													return $author$project$Pages$PracticeSetup$Communications$FormUpdated(
														config.rE(1));
												})
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Port an Existing Number')
											]))
									]))
							]))
					])),
				(!config.lE) ? $author$project$Pages$PracticeSetup$Communications$areaCodeInput(config) : $author$project$Pages$PracticeSetup$Communications$existingNumberInput(config)
			]));
};
var $author$project$Pages$PracticeSetup$Communications$viewFaxOptions = F2(
	function (model, fields) {
		return $author$project$Pages$PracticeSetup$Communications$viewOptions(
			{vs: fields.mc, py: 2, lE: fields.iF, PB: model.PB, aej: 'Fax', zE: 3, rE: $author$project$Pages$PracticeSetup$Communications$SetFaxAction, zG: $author$project$Pages$PracticeSetup$Communications$SetFaxAreaCode, bw: model.fF, AO: $author$project$Pages$PracticeSetup$Communications$FaxInputMsg});
	});
var $author$project$Pages$PracticeSetup$Communications$SetPhoneAction = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$SetPhoneAreaCode = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Communications$viewPhoneOptions = F2(
	function (model, fields) {
		return $author$project$Pages$PracticeSetup$Communications$viewOptions(
			{vs: fields.nt, py: 0, lE: fields.gm, PB: model.PB, aej: 'Phone', zE: 1, rE: $author$project$Pages$PracticeSetup$Communications$SetPhoneAction, zG: $author$project$Pages$PracticeSetup$Communications$SetPhoneAreaCode, bw: model.bw, AO: $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg});
	});
var $author$project$Pages$PracticeSetup$Communications$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Set up your practice phone & fax')
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$muted]),
								_List_fromArray(
									[
										$elm$html$Html$text('If you\'re getting a new number, we\'ll assign it right away based upon the area code that you enter. If you\'re porting, your onboarding manager will follow up with next steps. If you\'re porting multiple numbers, just enter your main practice number here.')
									]))
							])),
						function () {
						var fields = $author$project$Utils$Form$fields(model.PB);
						return A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Pages$PracticeSetup$Communications$viewPhoneOptions, model, fields),
									$author$project$Utils$Html$noBreakSpace,
									A2($author$project$Pages$PracticeSetup$Communications$viewFaxOptions, model, fields),
									function () {
									var _v0 = model.ON;
									if (!_v0.$) {
										var error = _v0.a;
										return A2(
											$author$project$Ui$Alert$danger,
											_List_fromArray(
												[
													$author$project$Ui$Alert$m0,
													$author$project$Ui$Alert$margin(8)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(error)
												]));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Next'},
									_List_fromArray(
										[
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$margin(8),
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Communications$FormSubmitted),
											$author$project$Ui$Button$loading(model.fS)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Next')
										]))
								]));
					}()
					]))
			]),
		$G: 'Admin Setup'
	};
};
var $author$project$Pages$PracticeSetup$Communications$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Communications$init, aer: $author$project$Pages$PracticeSetup$Communications$load, agD: $author$project$Pages$PracticeSetup$Communications$save, ahd: $author$project$Pages$PracticeSetup$Communications$subscriptions, aaq: $author$project$Pages$PracticeSetup$Communications$update, ahP: $author$project$Pages$PracticeSetup$Communications$view});
var $author$project$Pages$PracticeSetup$Complete$GotDefaultSignupPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Complete$GotPractice = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PracticeSetup$Complete$fetchPractice = function (apiClient) {
	return A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$PracticeSetup$Complete$GotPractice);
};
var $author$project$Pages$PracticeSetup$Complete$init = F4(
	function (_v0, _v1, shared, _v2) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				Nk: $elm$core$Maybe$Nothing,
				qT: shared.qT,
				FR: $author$project$Shared$isHintAdmin(shared),
				WF: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$SignupPage$getDefault, shared.D5, $author$project$Pages$PracticeSetup$Complete$GotDefaultSignupPage),
						$author$project$Pages$PracticeSetup$Complete$fetchPractice(shared.D5)
					])));
	});
var $author$project$Pages$PracticeSetup$Complete$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Complete$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Complete$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$OutMsg$RefreshSession = {$: 4};
var $author$project$Pages$PracticeSetup$Complete$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top),
					_List_fromArray(
						[
							$author$project$OutMsg$PracticeUpdated(model.WF)
						]));
			case 1:
				var response = msg.a;
				if (response.$ === 3) {
					var signupPages = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Nk: $elm$core$List$head(signupPages)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(response));
				}
			case 2:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(url),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied signup url to clipboard')
						]));
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{WF: response}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[$author$project$OutMsg$RefreshSession]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$PracticeSetup$Complete$Completed = {$: 0};
var $author$project$Ui$Image$OnboardingComplete = 14;
var $author$project$Ui$FlexGrid$rowItemsJustifySpaceBetween = $author$project$Ui$FlexGrid$RowElement($author$project$Ui$Element$spaceBetween);
var $author$project$Pages$PracticeSetup$Complete$CopyToClipboard = function (a) {
	return {$: 2, a: a};
};
var $author$project$Utils$Phone$displayPhoneNumber = F2(
	function (region, number_) {
		if (!region) {
			return $author$project$Formatters$Phone$format(number_);
		} else {
			return number_;
		}
	});
var $author$project$Utils$Phone$displayPhone = function (phoneInfo) {
	return A2(
		$author$project$Utils$Phone$displayPhoneNumber,
		phoneInfo.HM ? 0 : 1,
		phoneInfo.Gj);
};
var $author$project$Pages$PracticeSetup$Complete$practicePhone = function (practice) {
	return $elm$core$List$head(
		$author$project$Api$Provider$Practice$One$phones(practice));
};
var $author$project$Pages$PracticeSetup$Complete$viewPracticePhone = function (practice) {
	var _v0 = $author$project$Pages$PracticeSetup$Complete$practicePhone(practice);
	if (!_v0.$) {
		var phone = _v0.a;
		var formattedNumber = $author$project$Utils$Phone$displayPhone(
			{
				Gj: A2(
					$elm$core$Maybe$withDefault,
					'',
					$author$project$Api$Common$Phone$Shared$number(phone)),
				HM: $author$project$Api$Common$Phone$Shared$usFormattable(phone)
			});
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Your practice phone number: '),
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$tel,
									formattedNumber,
									_List_fromArray(
										[$author$project$Ui$Link$targetBlank]),
									_List_fromArray(
										[
											$elm$html$Html$text(formattedNumber)
										]))
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Copy Practice Phone Number'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
									$author$project$Ui$Button$onClick(
									$author$project$Pages$PracticeSetup$Complete$CopyToClipboard(formattedNumber))
								]),
							_List_Nil)
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Pages$PracticeSetup$Complete$viewSkeletonText = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$author$project$Ui$Margin$toClass(11),
			$elm$html$Html$Attributes$class('w-full')
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
					$author$project$Ui$Typography$margin(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$block,
							$author$project$Ui$Skeleton$span(10)
						]))
				]))
		]));
var $author$project$Pages$PracticeSetup$Complete$viewSignupPageUrl = function (maybeSignupPage) {
	if (!maybeSignupPage.$) {
		var signupPage = maybeSignupPage.a;
		var signupUrl = $author$project$Api$Provider$SignupPage$All$baseUrl(signupPage);
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
					$author$project$Ui$Typography$margin(2),
					$author$project$Ui$Typography$margin(11)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$externalHref,
					signupUrl,
					_List_fromArray(
						[$author$project$Ui$Link$targetBlank]),
					_List_fromArray(
						[
							$elm$html$Html$text(signupUrl)
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Copy Signup URL'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy),
							$author$project$Ui$Button$onClick(
							$author$project$Pages$PracticeSetup$Complete$CopyToClipboard(signupUrl))
						]),
					_List_Nil)
				]));
	} else {
		return $author$project$Pages$PracticeSetup$Complete$viewSkeletonText;
	}
};
var $author$project$Pages$PracticeSetup$Complete$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_fromArray(
					[$author$project$Ui$FlexGrid$rowItemsCenter, $author$project$Ui$FlexGrid$rowItemsJustifySpaceBetween]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(12),
								$author$project$Ui$FlexGrid$justifyCenter
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textLeft, $author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$heading(
										_List_fromArray(
											[
												$elm$html$Html$text('Congratulations on setting up your account! What\'s next?')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(6),
												$author$project$Ui$FlexGrid$justifyLeft
											]),
										_List_fromArray(
											[
												A4(
												$author$project$Ui$Image$view,
												model.qT,
												{I1: 'Congratulations illustration showing completed setup'},
												_List_Nil,
												14)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(6),
												$author$project$Ui$FlexGrid$justifyLeft
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
												_List_fromArray(
													[
														$elm$html$Html$text('Patients can now signup with your practice')
													])),
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												function () {
													var signupItems = function () {
														var _v1 = model.Nk;
														if (!_v1.$) {
															return _List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$span,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$author$project$Pages$PracticeSetup$Complete$viewSignupPageUrl(model.Nk)
																		]))
																]);
														} else {
															return _List_fromArray(
																[$author$project$Pages$PracticeSetup$Complete$viewSkeletonText]);
														}
													}();
													var practiceItems = function () {
														var _v0 = model.WF;
														if (_v0.$ === 3) {
															var practice = _v0.a;
															return _List_fromArray(
																[
																	$author$project$Pages$PracticeSetup$Complete$viewPracticePhone(practice)
																]);
														} else {
															return _List_Nil;
														}
													}();
													return A2(
														$elm$core$List$cons,
														A2(
															$elm$html$Html$li,
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$Typography$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('Use the following link to sign-up for your practice. We recommend posting this on your website:')
																		]))
																])),
														_Utils_ap(signupItems, practiceItems));
												}()),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$muted,
														$author$project$Ui$Typography$bold,
														$author$project$Ui$Typography$margin(9)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Expect an email from your onboarding manager within 2 business days')
													])),
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('You will receive emails from your onboarding manager at '),
																		A3(
																		$author$project$Ui$Link$mailto,
																		'onboarding@hint.com',
																		_List_fromArray(
																			[$author$project$Ui$Link$targetBlank]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('onboarding@hint.com')
																			])),
																		$elm$html$Html$text('.')
																	]))
															]))
													])),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$muted,
														$author$project$Ui$Typography$bold,
														$author$project$Ui$Typography$margin(9)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Complete your onboarding checklist')
													])),
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('After clicking \'Next,\' you will see an onboarding checklist with additional next steps.')
																	]))
															]))
													])),
												A2(
												$author$project$Ui$Typography$div,
												_List_fromArray(
													[
														$author$project$Ui$Typography$muted,
														$author$project$Ui$Typography$bold,
														$author$project$Ui$Typography$margin(9)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Learn more on Hint Community')
													])),
												A2(
												$elm$html$Html$ul,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text('You now have access to '),
																		A3(
																		$author$project$Ui$Link$externalHref,
																		'https://community.hint.com/c/account-configuration?automatic_login=true',
																		_List_fromArray(
																			[
																				$author$project$Ui$Link$targetBlank,
																				$author$project$Ui$Link$test('help-community')
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Hint Community')
																			])),
																		$elm$html$Html$text('! View resources on how to jumpstart your Hint Experience!')
																	]))
															]))
													]))
											]))
									])),
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Next'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$loading(false),
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Complete$Completed)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Next')
											]))
									]))
							]))
					]))
			]),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Complete$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Complete$init, aer: $author$project$Pages$PracticeSetup$Complete$load, agD: $author$project$Pages$PracticeSetup$Complete$save, ahd: $author$project$Pages$PracticeSetup$Complete$subscriptions, aaq: $author$project$Pages$PracticeSetup$Complete$update, ahP: $author$project$Pages$PracticeSetup$Complete$view});
var $author$project$Pages$PracticeSetup$Documents$DocumentFormMsg = $elm$core$Basics$identity;
var $author$project$Pages$PracticeSetup$Documents$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = A5(
			$author$project$Components$Admin$Documents$Form$init,
			shared.D5,
			session,
			$elm$core$Maybe$Nothing,
			practice,
			{aJ: true});
		var form = _v1.a;
		var cmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$PracticeSetup$Documents$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Documents$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Documents$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Admin$Documents$Form$subscriptions(model.PB));
};
var $author$project$Pages$PracticeSetup$Documents$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.D5, subMsg, model.PB);
		var form = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{PB: form}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$PracticeSetup$Documents$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Documents$Form$view(model.PB))
			]),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Documents$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Documents$init, aer: $author$project$Pages$PracticeSetup$Documents$load, agD: $author$project$Pages$PracticeSetup$Documents$save, ahd: $author$project$Pages$PracticeSetup$Documents$subscriptions, aaq: $author$project$Pages$PracticeSetup$Documents$update, ahP: $author$project$Pages$PracticeSetup$Documents$view});
var $author$project$Pages$PracticeSetup$Legal$AddressInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Legal$initFormFields = function () {
	var _v0 = $author$project$Components$AddressInput$init('practice-legal-address');
	var addressInput = _v0.a;
	var addressInputCmd = _v0.b;
	return _Utils_Tuple2(
		{Of: $elm$core$Maybe$Nothing, aeo: addressInput, SK: $elm$core$Maybe$Nothing},
		A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Legal$AddressInputMsg, addressInputCmd));
}();
var $author$project$Pages$PracticeSetup$Legal$init = F4(
	function (session, practice, shared, _v0) {
		var _v1 = $author$project$Pages$PracticeSetup$Legal$initFormFields;
		var formFields = _v1.a;
		var formFieldsCmd = _v1.b;
		var form = $author$project$Utils$Form$init(formFields);
		return _Utils_Tuple2(
			{D5: shared.D5, PB: form, WF: practice, ZD: session},
			formFieldsCmd);
	});
var $author$project$Pages$PracticeSetup$Legal$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Legal$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Legal$subscriptions = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var legalAddress = _v0.aeo;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$PracticeSetup$Legal$AddressInputMsg,
		$author$project$Components$AddressInput$subscriptions(legalAddress));
};
var $author$project$Pages$PracticeSetup$Legal$GotResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PracticeSetup$Legal$LegalAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$PracticeBusinessProfile$practiceBusinessProfilePath = function (basePath) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			['practice_business_profile']),
		basePath);
};
var $author$project$Api$Provider$PracticeBusinessProfile$create = F3(
	function (apiClient, fields, toMsg) {
		var addressField = function () {
			var _v0 = fields.aeo;
			if (!_v0.$) {
				var address_ = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'legal_address',
						$author$project$Api$Common$Address$Shared$encode(address_))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'practice_business_profile',
					$elm$json$Json$Encode$object(
						$elm$core$List$concat(
							_List_fromArray(
								[
									A3($author$project$Utils$Encode$optional, 'legal_name', $elm$json$Json$Encode$string, fields.SK),
									A3($author$project$Utils$Encode$optional, 'ein', $elm$json$Json$Encode$string, fields.Of),
									addressField
								]))))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$PracticeBusinessProfile$practiceBusinessProfilePath($author$project$Api$Data$providerPath))));
	});
var $author$project$Pages$PracticeSetup$Legal$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						SK: $elm$core$Maybe$Just(string)
					});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{
						Of: $author$project$Utils$String$toMaybe(string)
					});
			default:
				var address = field.a;
				return _Utils_update(
					fields,
					{aeo: address});
		}
	});
var $author$project$Pages$PracticeSetup$Legal$EinValidation = 0;
var $author$project$Pages$PracticeSetup$Legal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Ein$ifInvalid,
			function ($) {
				return $.Of;
			},
			_Utils_Tuple2(0, 'Please enter a valid EIN or leave empty'))
		]));
var $author$project$Pages$PracticeSetup$Legal$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var form = A3($author$project$Utils$Form$update, $author$project$Pages$PracticeSetup$Legal$formFieldsUpdate, field, model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: form}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v1 = $author$project$Utils$Form$fields(model.PB);
				var legalAddress = _v1.aeo;
				var _v2 = A2($author$project$Components$AddressInput$update, subMsg, legalAddress);
				var addressInputModel = _v2.a;
				var addressInputCmd = _v2.b;
				var outMsgs = _v2.c;
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Pages$PracticeSetup$Legal$formFieldsUpdate,
					$author$project$Pages$PracticeSetup$Legal$LegalAddress(addressInputModel),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Legal$AddressInputMsg, addressInputCmd),
					outMsgs);
			case 2:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$PracticeSetup$Legal$formFieldsValidator, model.PB);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
					var legalAddress = $author$project$Components$AddressInput$getAddress(fields.aeo);
					var hasAnyAddressField = A2(
						$elm$core$List$any,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								!_Utils_eq(legalAddress.pT, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.pZ, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.rf, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.yy, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.sZ, $elm$core$Maybe$Nothing),
								!_Utils_eq(legalAddress.tC, $elm$core$Maybe$Nothing)
							]));
					var legalName = fields.SK;
					var ein = fields.Of;
					var cmd = A3(
						$author$project$Api$Provider$PracticeBusinessProfile$create,
						model.D5,
						{
							Of: ein,
							aeo: hasAnyAddressField ? $elm$core$Maybe$Just(
								{pT: legalAddress.pT, pZ: legalAddress.pZ, rf: legalAddress.rf, yy: legalAddress.yy, sZ: legalAddress.sZ, tC: legalAddress.tC}) : $elm$core$Maybe$Nothing,
							SK: legalName
						},
						$author$project$Pages$PracticeSetup$Legal$GotResponse);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						cmd,
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$PracticeSetup$Legal$Ein = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$Legal$FormSubmitted = {$: 2};
var $author$project$Pages$PracticeSetup$Legal$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$Legal$LegalName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Form$Ein$Placeholder = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$Form$Ein$placeholder = $author$project$Ui$Form$Ein$Placeholder;
var $author$project$Pages$PracticeSetup$Legal$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Verify your business information')
									]))
							])),
						function () {
						var fields = $author$project$Utils$Form$fields(model.PB);
						return A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('This information should be used to verify your business when necessary for services including phone registration for fax and text messages, eRX, payment processing, and more.')
										])),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('All information should match your IRS SS-4 form or there may be delays in activating some features on your account. If you have not yet registered your business with the IRS, leave this information blank.')
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9),
											$author$project$Ui$Form$Group$label('Legal Business Name')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													A2($elm$core$Maybe$withDefault, '', fields.SK)),
													$author$project$Ui$Form$Input$onInput(
													function (name) {
														return $author$project$Pages$PracticeSetup$Legal$FormUpdated(
															$author$project$Pages$PracticeSetup$Legal$LegalName(name));
													}),
													$author$project$Ui$Form$Input$placeholder('Legal name from IRS SS-4 Form')
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9),
											$author$project$Ui$Form$Group$label('EIN')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Ein$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Ein$value(fields.Of),
													$author$project$Ui$Form$Ein$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$PracticeSetup$Legal$FormUpdated, $author$project$Pages$PracticeSetup$Legal$Ein)),
													$author$project$Ui$Form$Ein$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, model.PB)),
													$author$project$Ui$Form$Ein$errors(
													A2($author$project$Utils$Form$validationErrors, 0, model.PB)),
													$author$project$Ui$Form$Ein$placeholder('12-3456789')
												]))
										])),
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$labelSpanSm(3),
											$author$project$Ui$Form$Group$inputSpanSm(9),
											$author$project$Ui$Form$Group$label('Legal Address')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$PracticeSetup$Legal$AddressInputMsg,
											A2($author$project$Components$AddressInput$view, _List_Nil, fields.aeo))
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Next'},
									_List_fromArray(
										[
											$author$project$Ui$Button$pull(1),
											$author$project$Ui$Button$margin(8),
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Legal$FormSubmitted)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Next')
										]))
								]));
					}()
					]))
			]),
		$G: 'Practice Setup - Legal Information'
	};
};
var $author$project$Pages$PracticeSetup$Legal$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Legal$init, aer: $author$project$Pages$PracticeSetup$Legal$load, agD: $author$project$Pages$PracticeSetup$Legal$save, ahd: $author$project$Pages$PracticeSetup$Legal$subscriptions, aaq: $author$project$Pages$PracticeSetup$Legal$update, ahP: $author$project$Pages$PracticeSetup$Legal$view});
var $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$Stripe = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = function () {
			if ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest') {
				var _v2 = A5(
					$author$project$Components$PaymentProcessing$init,
					session,
					practice,
					shared,
					query,
					{aJ: true});
				var paymentProcessing = _v2.a;
				var paymentProcessingCmd = _v2.b;
				return _Utils_Tuple2(
					$author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing(paymentProcessing),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg, paymentProcessingCmd));
			} else {
				var _v3 = A5(
					$author$project$Components$Stripe$init,
					session,
					practice,
					shared,
					query,
					{aJ: true});
				var stripe = _v3.a;
				var stripeCmd = _v3.b;
				return _Utils_Tuple2(
					$author$project$Pages$PracticeSetup$PaymentProcessing$Stripe(stripe),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg, stripeCmd));
			}
		}();
		var paymentProcessor = _v1.a;
		var paymentProcessorCmd = _v1.b;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				FR: $author$project$Shared$isHintAdmin(shared),
				V0: paymentProcessor
			},
			paymentProcessorCmd);
	});
var $author$project$Pages$PracticeSetup$PaymentProcessing$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$PaymentProcessing$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$PaymentProcessing$subscriptions = function (model) {
	var _v0 = model.V0;
	if (_v0.$ === 1) {
		var paymentProcessing = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg,
			$author$project$Components$PaymentProcessing$subscriptions(paymentProcessing));
	} else {
		var stripe = _v0.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg,
			$author$project$Components$Stripe$subscriptions(stripe));
	}
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = model.V0;
			if (!_v1.$) {
				var stripe = _v1.a;
				var _v2 = A3($author$project$Components$Stripe$update, subMsg, stripe, model.D5);
				var newStripe = _v2.a;
				var stripeCmd = _v2.b;
				var outMsgs = _v2.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							V0: $author$project$Pages$PracticeSetup$PaymentProcessing$Stripe(newStripe)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg, stripeCmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		} else {
			var subMsg = msg.a;
			var _v3 = model.V0;
			if (_v3.$ === 1) {
				var paymentProcessing = _v3.a;
				var _v4 = A3($author$project$Components$PaymentProcessing$update, subMsg, paymentProcessing, model.D5);
				var newPaymentProcessing = _v4.a;
				var paymentProcessingCmd = _v4.b;
				var outMsgs = _v4.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							V0: $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing(newPaymentProcessing)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg, paymentProcessingCmd),
					outMsgs);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			}
		}
	});
var $author$project$Pages$PracticeSetup$PaymentProcessing$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.V0;
				if (_v0.$ === 1) {
					var paymentProcessing = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg,
						$author$project$Components$PaymentProcessing$view(paymentProcessing));
				} else {
					var stripe = _v0.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg,
						$author$project$Components$Stripe$view(stripe));
				}
			}()
			]),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$PaymentProcessing$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$PaymentProcessing$init, aer: $author$project$Pages$PracticeSetup$PaymentProcessing$load, agD: $author$project$Pages$PracticeSetup$PaymentProcessing$save, ahd: $author$project$Pages$PracticeSetup$PaymentProcessing$subscriptions, aaq: $author$project$Pages$PracticeSetup$PaymentProcessing$update, ahP: $author$project$Pages$PracticeSetup$PaymentProcessing$view});
var $author$project$Pages$PracticeSetup$Plans$ListMsg = $elm$core$Basics$identity;
var $author$project$Pages$PracticeSetup$Plans$init = F4(
	function (session, practice, shared, params) {
		var _v0 = $author$project$Components$Admin$Plans$List$init(shared.D5)(session)(
			$author$project$Api$Platform$User$Shared$isAdmin(
				$author$project$Api$Platform$Session$One$user(session)))(
			_List_fromArray(
				[2, 3]))($author$project$Spa$Generated$Route$Admin__Plans__Top)($author$project$Spa$Generated$Route$Admin__Plans__New)($author$project$Spa$Generated$Route$Admin__Plans__Id_String)(
			_List_fromArray(
				[
					$elm$html$Html$text('To edit or add more plans later, you can go to Admin → Membership Options page in the product.')
				]))(params.Bi)(
			{aJ: true})(
			$elm$core$Maybe$Just(practice));
		var list = _v0.a;
		var listCmd = _v0.b;
		return _Utils_Tuple2(
			{D5: shared.D5, rh: list},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
	});
var $author$project$Pages$PracticeSetup$Plans$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Plans$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Plans$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$PracticeSetup$Plans$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.D5, subMsg, model.rh);
		var list = _v1.a;
		var listCmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{rh: list}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd),
			outMsgs);
	});
var $author$project$Pages$PracticeSetup$Plans$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Admin$Plans$List$view(model.rh))
			]),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Plans$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Plans$init, aer: $author$project$Pages$PracticeSetup$Plans$load, agD: $author$project$Pages$PracticeSetup$Plans$save, ahd: $author$project$Pages$PracticeSetup$Plans$subscriptions, aaq: $author$project$Pages$PracticeSetup$Plans$update, ahP: $author$project$Pages$PracticeSetup$Plans$view});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var timeZone = _v0.Hz;
		var currentDate = _v0.cO;
		var hinterViewOff = _v0.adN;
		var query = _v1.Bi;
		var params = _v1.Vx;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (planForm) {
				return {D5: apiClient, ny: planForm};
			},
			A9(
				$author$project$Components$Plan$Form$init,
				apiClient,
				timeZone,
				currentDate,
				session,
				practice,
				query,
				$author$project$Spa$Generated$Route$Admin__Plans__Top,
				params.adR,
				{adN: hinterViewOff, WI: true}));
	});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$subscriptions = function (model) {
	return $author$project$Components$Plan$Form$subscriptions(model.ny);
};
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$update = F2(
	function (msg, model) {
		return A2(
			$author$project$Utils$Tuple3$mapFirst,
			function (planForm) {
				return _Utils_update(
					model,
					{ny: planForm});
			},
			A3($author$project$Components$Plan$Form$update, model.D5, msg, model.ny));
	});
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$view = function (model) {
	return {
		e5: $author$project$Components$Plan$Form$view(model.ny),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$init, aer: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$load, agD: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$save, ahd: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$subscriptions, aaq: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$update, ahP: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$view});
var $author$project$Components$Plan$PracticeSetupNewPlan$Model = $elm$core$Basics$identity;
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$initEmptyRules = {
	QW: {Ot: false},
	Tr: {Ot: false}
};
var $author$project$Components$Plan$Form$RegistrationFeePricingFields$empty = $author$project$Utils$Form$init(
	{cJ: $elm$core$Maybe$Nothing, QW: $elm$core$Maybe$Nothing, Tr: $elm$core$Maybe$Nothing, YY: $author$project$Components$Plan$Form$RegistrationFeePricingFields$initEmptyRules});
var $author$project$Components$Plan$BasicForm$initEmptyRules = {
	T3: {Ot: false}
};
var $author$project$Components$Plan$BasicForm$empty = F2(
	function (practice, isViewingAsHinter) {
		var settings = {ym: isViewingAsHinter, WF: practice, WI: true};
		return A2(
			$author$project$Components$Plan$BasicForm$BasicPlanForm,
			settings,
			$author$project$Utils$Form$init(
				{
					Iq: false,
					vn: $elm$core$Maybe$Nothing,
					vo: false,
					J0: false,
					Kh: false,
					p4: $elm$core$Maybe$Nothing,
					w4: $elm$core$Maybe$Nothing,
					w5: 'Membership Fee',
					Nf: 'month',
					Nx: A2($author$project$Components$TranslatedRichText$init, $elm$core$Dict$empty, 'plan-description-language-dropdown'),
					qo: false,
					iy: false,
					lY: false,
					ms: 0,
					QN: $elm$core$Maybe$Nothing,
					T3: $elm$core$Maybe$Nothing,
					y9: $elm$core$Maybe$Nothing,
					za: false,
					zh: '',
					Bf: $elm$core$Maybe$Nothing,
					Bg: false,
					Bo: $elm$core$Maybe$Nothing,
					sl: 'Unassigned',
					Bp: '',
					Bq: 'Registration Fee',
					c9: $author$project$Components$Plan$Form$RegistrationFeePricingFields$empty,
					YY: $author$project$Components$Plan$BasicForm$initEmptyRules,
					B6: $elm$core$Maybe$Nothing,
					B7: false,
					Hi: $elm$core$Maybe$Nothing
				}));
	});
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initEmptyRules = {
	tJ: {Ot: false},
	tK: {Ot: false},
	v3: {Ot: false},
	v4: {Ot: false},
	wQ: {Ot: false},
	xA: {Ot: false},
	xB: {Ot: false},
	zC: {Ot: false},
	Cn: {Ot: false}
};
var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$empty = $author$project$Utils$Form$init(
	{tJ: $elm$core$Maybe$Nothing, tK: $elm$core$Maybe$Nothing, v3: $elm$core$Maybe$Nothing, v4: $elm$core$Maybe$Nothing, wQ: $elm$core$Maybe$Nothing, xA: $elm$core$Maybe$Nothing, xB: $elm$core$Maybe$Nothing, zC: $elm$core$Maybe$Nothing, YY: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initEmptyRules, Cn: $elm$core$Maybe$Nothing});
var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$empty = $author$project$Utils$Form$init(
	{
		IL: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules('month')
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$initFormFields = F2(
	function (practice, isViewingAsHinter) {
		var membershipPricingForm = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$empty;
		var familyPricingForm = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$empty;
		var defaultGroupPricingType = 'family';
		var basicPlanForm = A2($author$project$Components$Plan$BasicForm$empty, practice, isViewingAsHinter);
		return {aA: basicPlanForm, xg: false, cU: familyPricingForm, P_: defaultGroupPricingType, cX: membershipPricingForm};
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$init = F3(
	function (apiClient, practice, isViewingAsHinter) {
		return _Utils_Tuple2(
			{
				D5: apiClient,
				PB: $author$project$Utils$Form$init(
					A2($author$project$Components$Plan$PracticeSetupNewPlan$initFormFields, practice, isViewingAsHinter)),
				WF: practice
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$PracticeSetup$Plans$New$init = F4(
	function (_v0, practice, shared, _v1) {
		var _v2 = A3(
			$author$project$Components$Plan$PracticeSetupNewPlan$init,
			shared.D5,
			practice,
			$author$project$Shared$isHintAdmin(shared));
		var practiceSetupNewPlan = _v2.a;
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				FR: $author$project$Shared$isHintAdmin(shared),
				sb: practiceSetupNewPlan
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$PracticeSetup$Plans$New$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Plans$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Plans$New$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$PracticeSetup$Plans$New$NewPlanMsg = $elm$core$Basics$identity;
var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlan = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFields = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$MembershipPricingFields = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$ToggleFixedMembershipPricing = {$: 3};
var $author$project$Components$Plan$PracticeSetupNewPlan$Created = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Plan$encodeCreateFullFields = function (fields) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(fields.zh)),
				_Utils_Tuple2(
				'buyable',
				$elm$json$Json$Encode$bool(fields.Kh)),
				_Utils_Tuple2(
				'plan_type',
				$elm$json$Json$Encode$string(
					$author$project$Api$PlanType$toString(2))),
				_Utils_Tuple2(
				'default_period',
				$elm$json$Json$Encode$string(fields.Nf)),
				_Utils_Tuple2(
				'discounts_enabled',
				$elm$json$Json$Encode$bool(false)),
				_Utils_Tuple2(
				'bills_at_end_of_period',
				$elm$json$Json$Encode$bool(fields.J0)),
				_Utils_Tuple2(
				'individual_registration_fee_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.QW)),
				_Utils_Tuple2(
				'minimum_enrollment_period_in_months',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.T3)),
				_Utils_Tuple2(
				'default_charge_name',
				$elm$json$Json$Encode$string(fields.w5)),
				_Utils_Tuple2(
				'default_charge_description',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.w4)),
				_Utils_Tuple2(
				'registration_fee_category',
				A2(
					$author$project$Utils$Encode$nullable,
					function (id) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$elm$json$Json$Encode$string(id))
								]));
					},
					fields.Bo)),
				_Utils_Tuple2(
				'max_registration_fee_in_cents',
				A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Tr)),
				_Utils_Tuple2(
				'month_adjustment_percent',
				$author$project$Percentage$encode(fields.y9)),
				_Utils_Tuple2(
				'month_allowed',
				$elm$json$Json$Encode$bool(fields.za)),
				_Utils_Tuple2(
				'quarter_adjustment_percent',
				$author$project$Percentage$encode(fields.Bf)),
				_Utils_Tuple2(
				'quarter_allowed',
				$elm$json$Json$Encode$bool(fields.Bg)),
				_Utils_Tuple2(
				'semi_annual_adjustment_percent',
				$author$project$Percentage$encode(fields.B6)),
				_Utils_Tuple2(
				'semi_annual_allowed',
				$elm$json$Json$Encode$bool(fields.B7)),
				_Utils_Tuple2(
				'annual_adjustment_percent',
				$author$project$Percentage$encode(fields.vn)),
				_Utils_Tuple2(
				'annual_allowed',
				$elm$json$Json$Encode$bool(fields.vo)),
				_Utils_Tuple2(
				'age_rate_rules',
				A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, fields.IL)),
				_Utils_Tuple2(
				'group_pricing_type',
				$elm$json$Json$Encode$string(fields.P_)),
				_Utils_Tuple2(
				'family_num_children_included',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.xB)),
				_Utils_Tuple2(
				'number_additional_children_allowed',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.zC)),
				_Utils_Tuple2(
				'children_age_limit',
				A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.v3)),
				_Utils_Tuple2(
				'couple_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.wQ)),
				_Utils_Tuple2(
				'family_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.xA)),
				_Utils_Tuple2(
				'single_parent_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.Cn)),
				_Utils_Tuple2(
				'additional_adult_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.tJ)),
				_Utils_Tuple2(
				'additional_child_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.tK)),
				_Utils_Tuple2(
				'children_only_discount_rule',
				A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.v4)),
				_Utils_Tuple2(
				'discounts_enabled',
				$elm$json$Json$Encode$bool(fields.xg)),
				_Utils_Tuple2(
				'registration_fee_name',
				$elm$json$Json$Encode$string(fields.Bq)),
				_Utils_Tuple2(
				'registration_fee_description',
				$elm$json$Json$Encode$string(fields.Bp))
			]));
};
var $author$project$Api$Provider$Plan$createFull = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'plan',
					$author$project$Api$Provider$Plan$encodeCreateFullFields(fields))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Plan$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$createPlanFields = F2(
	function (sharedFields, formFields) {
		var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(formFields.cX);
		var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(formFields.cU);
		var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(formFields.aA);
		var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.c9);
		return {
			tJ: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
				},
				familyMembershipPricingFormFields.tJ),
			tK: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
				},
				familyMembershipPricingFormFields.tK),
			IL: A2(
				$elm$core$List$map,
				function (ageRateRule) {
					return {
						I5: ageRateRule.c7.I5,
						e_: ageRateRule.c7.e_,
						L_: A2(
							$elm$core$Maybe$map,
							function (coupleRule) {
								return {I5: coupleRule.c7.I5, e_: coupleRule.c7.e_, T8: coupleRule.c7.T8, f5: coupleRule.c7.f5, Xw: coupleRule.c7.Xw, gr: coupleRule.c7.gr, Zj: coupleRule.c7.Zj, gG: coupleRule.c7.gG};
							},
							ageRateRule.L_),
						PH: $elm$core$Maybe$Just(ageRateRule.PH),
						T8: ageRateRule.c7.T8,
						f5: ageRateRule.c7.f5,
						Xw: ageRateRule.c7.Xw,
						gr: ageRateRule.c7.gr,
						Zj: ageRateRule.c7.Zj,
						gG: ageRateRule.c7.gG,
						$I: ageRateRule.$I,
						aai: ageRateRule.aai
					};
				},
				membershipPricingFormFields.IL),
			vn: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.vn),
			vo: basicPlanFormFields.vo,
			J0: basicPlanFormFields.J0,
			Kh: basicPlanFormFields.Kh,
			v3: familyMembershipPricingFormFields.v3,
			v4: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
				},
				familyMembershipPricingFormFields.v4),
			wQ: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
				},
				familyMembershipPricingFormFields.wQ),
			w4: basicPlanFormFields.w4,
			w5: basicPlanFormFields.w5,
			Nf: basicPlanFormFields.Nf,
			xg: formFields.xg,
			xA: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
				},
				familyMembershipPricingFormFields.xA),
			xB: familyMembershipPricingFormFields.xB,
			P_: sharedFields.P_,
			QW: registrationFeeFields.QW,
			Tr: registrationFeeFields.Tr,
			T3: basicPlanFormFields.T3,
			y9: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.y9),
			za: basicPlanFormFields.za,
			zh: basicPlanFormFields.zh,
			zC: familyMembershipPricingFormFields.zC,
			Bf: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bf),
			Bg: basicPlanFormFields.Bg,
			Bo: basicPlanFormFields.Bo,
			Bp: basicPlanFormFields.Bp,
			Bq: basicPlanFormFields.Bq,
			B6: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.B6),
			B7: basicPlanFormFields.B7,
			Cn: A2(
				$elm$core$Maybe$map,
				function (familyDiscountRule) {
					return {I9: familyDiscountRule.I9, Ja: familyDiscountRule.Ja, Ub: familyDiscountRule.Ub, Uc: familyDiscountRule.Uc, XA: familyDiscountRule.XA, XB: familyDiscountRule.XB, Zn: familyDiscountRule.Zn, Zo: familyDiscountRule.Zo};
				},
				familyMembershipPricingFormFields.Cn),
			Hi: basicPlanFormFields.Hi
		};
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$createPlan = F3(
	function (sharedFields, apiClient, validFormFields) {
		var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
		return A3(
			$author$project$Api$Provider$Plan$createFull,
			apiClient,
			A2($author$project$Components$Plan$PracticeSetupNewPlan$createPlanFields, sharedFields, formFields),
			$author$project$Components$Plan$PracticeSetupNewPlan$Created);
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var basicPlanForm = field.a;
				return _Utils_update(
					fields,
					{aA: basicPlanForm});
			case 1:
				var membershipPricingForm = field.a;
				return _Utils_update(
					fields,
					{cX: membershipPricingForm});
			case 2:
				var familyMembershipPricingForm = field.a;
				return _Utils_update(
					fields,
					{cU: familyMembershipPricingForm});
			case 3:
				var groupPricingType = (fields.P_ === 'fixed_pricing') ? 'family' : 'fixed_pricing';
				return _Utils_update(
					fields,
					{P_: groupPricingType});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{xg: bool});
		}
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFieldValidation = 0;
var $author$project$Components$Plan$PracticeSetupNewPlan$validateBasicPlanFormFields = function (_v0) {
	var basicPlan = _v0.aA;
	return $author$project$Components$Plan$BasicForm$hasErrors(basicPlan) ? _List_fromArray(
		[
			_Utils_Tuple2(0, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsValidation = 2;
var $author$project$Components$Plan$PracticeSetupNewPlan$validateFamilyMembershipPricingFields = function (_v0) {
	var familyMembershipPricingForm = _v0.cU;
	return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(familyMembershipPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2(2, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsValidation = 1;
var $author$project$Components$Plan$PracticeSetupNewPlan$validateIndividualMembershipPricingFields = function (_v0) {
	var membershipPricingForm = _v0.cX;
	return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(membershipPricingForm) ? _List_fromArray(
		[
			_Utils_Tuple2(1, '')
		]) : _List_Nil;
};
var $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateBasicPlanFormFields),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateIndividualMembershipPricingFields),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateFamilyMembershipPricingFields)
		]));
var $author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields = F2(
	function (maybePlan, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var groupPricingType = _v0.P_;
		var basicPlan = _v0.aA;
		var _v1 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
		var defaultPeriod = _v1.Nf;
		return {Nf: defaultPeriod, P_: groupPricingType, GH: maybePlan};
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$updateForm = F3(
	function (model, field, newPlanForm) {
		var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate, field, newPlanForm);
		return _Utils_update(
			model,
			{PB: newForm});
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var planFormMsg = msg.a;
				var _v2 = $author$project$Utils$Form$fields(model.PB);
				var basicPlan = _v2.aA;
				var updateResult = A4($author$project$Components$Plan$BasicForm$update, apiClient, planFormMsg, basicPlan, $elm$core$Maybe$Nothing);
				var newForm = A3(
					$author$project$Utils$Form$update,
					$author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate,
					$author$project$Components$Plan$PracticeSetupNewPlan$BasicPlan(updateResult.y8),
					model.PB);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: newForm}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated, updateResult.EC),
					updateResult.as);
			case 1:
				var membershipPricingFieldsMsg = msg.a;
				var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.PB);
				var _v3 = $author$project$Utils$Form$fields(model.PB);
				var membershipPricingForm = _v3.cX;
				var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, membershipPricingFieldsMsg, membershipPricingForm);
				var newModel = function () {
					var _v4 = newMembershipPricingResult.ac5;
					if (!_v4.$) {
						var newForm = A3(
							$author$project$Utils$Form$update,
							$author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate,
							$author$project$Components$Plan$PracticeSetupNewPlan$MembershipPricingFields(newMembershipPricingResult.y8),
							model.PB);
						return _Utils_update(
							model,
							{PB: newForm});
					} else {
						return A3($author$project$Components$Plan$PracticeSetupNewPlan$updateForm, model, $author$project$Components$Plan$PracticeSetupNewPlan$ToggleFixedMembershipPricing, model.PB);
					}
				}();
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.EC),
					newMembershipPricingResult.as);
			case 2:
				var familyPricingFieldsMsg = msg.a;
				var _v5 = $author$project$Utils$Form$fields(model.PB);
				var familyMembershipPricingForm = _v5.cU;
				var newFamilyMembershipPricingResult = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$update, familyPricingFieldsMsg, familyMembershipPricingForm, $elm$core$Maybe$Nothing);
				var newModel = function () {
					var newForm = A3(
						$author$project$Utils$Form$update,
						$author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate,
						$author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFields(newFamilyMembershipPricingResult.y8),
						model.PB);
					return _Utils_update(
						model,
						{PB: newForm});
				}();
				return _Utils_Tuple3(
					newModel,
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.EC),
					newFamilyMembershipPricingResult.as);
			case 3:
				var field = msg.a;
				var newModel = A3($author$project$Components$Plan$PracticeSetupNewPlan$updateForm, model, field, model.PB);
				return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Plan successfully created.'),
								$author$project$OutMsg$RefreshPractice
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.PB);
				var fields = $author$project$Utils$Form$fields(model.PB);
				var validatedFamilyMembershipPricingForm = function () {
					var _v13 = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate, fields.cU, sharedFields, $elm$core$Maybe$Nothing);
					if (!_v13.$) {
						var _v14 = _v13.a;
						var newForm_ = _v14.a;
						return newForm_;
					} else {
						var newForm_ = _v13.a;
						return newForm_;
					}
				}();
				var validatedMembershipPricingForm = function () {
					var _v11 = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate, sharedFields, fields.cX, $elm$core$Maybe$Nothing);
					if (!_v11.$) {
						var _v12 = _v11.a;
						var newForm = _v12.a;
						return newForm;
					} else {
						var newForm = _v11.a;
						return newForm;
					}
				}();
				var basicPlanForm = function () {
					var _v9 = A2($author$project$Components$Plan$BasicForm$validate, fields.aA, $elm$core$Maybe$Nothing);
					if (!_v9.$) {
						var _v10 = _v9.a;
						var newForm = _v10.a;
						return newForm;
					} else {
						var newForm = _v9.a;
						return newForm;
					}
				}();
				var newValidForm = A2(
					$author$project$Utils$Form$set,
					_Utils_update(
						fields,
						{aA: basicPlanForm, cU: validatedFamilyMembershipPricingForm, cX: validatedMembershipPricingForm}),
					model.PB);
				var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsValidator, newValidForm);
				if (!_v7.$) {
					var _v8 = _v7.a;
					var newForm = _v8.a;
					var validFormFields = _v8.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						A3($author$project$Components$Plan$PracticeSetupNewPlan$createPlan, sharedFields, apiClient, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v7.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
		}
	});
var $author$project$Pages$PracticeSetup$Plans$New$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Plan$PracticeSetupNewPlan$update, model.D5, subMsg, model.sb);
		var practiceSetupNewPlanModel = _v1.a;
		var practiceSetupNewPlanCmd = _v1.b;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{sb: practiceSetupNewPlanModel}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, practiceSetupNewPlanCmd),
			_List_Nil);
	});
var $author$project$Components$Plan$PracticeSetupNewPlan$Save = {$: 5};
var $author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Plan$PracticeSetupNewPlan$viewFamilyDiscountsToggle = function (model) {
	var _v0 = $author$project$Utils$Form$fields(model.PB);
	var discountsEnabled = _v0.xg;
	return A2(
		$author$project$Ui$Typography$span,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Do you offer discounts to family members who enroll together?'),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						$author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(discountsEnabled),
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled(true))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Yes')
											]))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Radio$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Radio$value(!discountsEnabled),
										$author$project$Ui$Form$Radio$inline,
										$author$project$Ui$Form$Radio$onCheck(
										A2(
											$elm$core$Basics$composeL,
											$author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated,
											$elm$core$Basics$always(
												$author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled(false))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('No')
											]))
									]))
							]))
					])),
				$author$project$Utils$Html$noBreakSpace
			]));
};
var $author$project$Components$Plan$PracticeSetupNewPlan$view = function (_v0) {
	var model = _v0;
	var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.PB);
	var _v1 = $author$project$Utils$Form$fields(model.PB);
	var basicPlan = _v1.aA;
	var membershipPricingForm = _v1.cX;
	var familyMembershipPricingForm = _v1.cU;
	var discountsEnabled = _v1.xg;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$view,
			_List_fromArray(
				[$author$project$Ui$Panel$onlyBorderLeft]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_Nil,
									A2(
										$elm$core$List$map,
										$elm$html$Html$map($author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated),
										A2($author$project$Components$Plan$BasicForm$view, basicPlan, $elm$core$Maybe$Nothing)))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated,
											A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$view, sharedFields, model.WF, $elm$core$Maybe$Nothing, membershipPricingForm))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$Plan$PracticeSetupNewPlan$viewFamilyDiscountsToggle(model),
											discountsEnabled ? A2(
											$elm$html$Html$map,
											$author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated,
											A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$view, sharedFields, $elm$core$Maybe$Nothing, familyMembershipPricingForm)) : $author$project$Utils$Html$empty
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$flexCol]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Well$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$info]),
									_List_fromArray(
										[
											$elm$html$Html$text('If you\'re looking for additional options, or have more than one plan, you can access advanced settings after saving your plan.')
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$justifyRight]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Save new plan'},
									_List_fromArray(
										[
											$author$project$Ui$Button$primary,
											$author$project$Ui$Button$onClick($author$project$Components$Plan$PracticeSetupNewPlan$Save)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Save')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$PracticeSetup$Plans$New$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			$author$project$Components$Plan$PracticeSetupNewPlan$view(model.sb)),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Plans$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Plans$New$init, aer: $author$project$Pages$PracticeSetup$Plans$New$load, agD: $author$project$Pages$PracticeSetup$Plans$New$save, ahd: $author$project$Pages$PracticeSetup$Plans$New$subscriptions, aaq: $author$project$Pages$PracticeSetup$Plans$New$update, ahP: $author$project$Pages$PracticeSetup$Plans$New$view});
var $author$project$Pages$PracticeSetup$Team$TeamFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PracticeSetup$Team$init = F4(
	function (session, practice, shared, _v0) {
		var onboardingClinical = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Platform$Organization$Shared$onboardingClinical,
				$author$project$Api$Platform$Session$One$organization(session)));
		var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice) || onboardingClinical;
		var _v1 = A4(
			$author$project$Components$TeamForm$init,
			shared.cO,
			session,
			practice,
			{aJ: true, di: usingClinicalEmr});
		var teamFormModel = _v1.a;
		var teamFormCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, WF: practice, jY: $author$project$Api$Data$NotAsked, ZD: session, g$: teamFormModel, di: usingClinicalEmr},
			A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Team$TeamFormMsg, teamFormCmd));
	});
var $author$project$Pages$PracticeSetup$Team$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			model,
			A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.ZD, shared.adN));
	});
var $author$project$Pages$PracticeSetup$Team$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$PracticeSetup$Team$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$PracticeSetup$Team$Updated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Platform$User$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Pages$PracticeSetup$Team$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$TeamForm$update, subMsg, model.g$, model.D5);
				var teamFormModel = _v1.a;
				var teamFormCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{g$: teamFormModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Team$TeamFormMsg, teamFormCmd),
					_List_Nil);
			case 1:
				var _v2 = $author$project$Components$TeamForm$validate(model.g$);
				if (!_v2.$) {
					var _v3 = _v2.a;
					var validatedForm = _v3.a;
					var validFormFields = _v3.b;
					var fields = $author$project$Components$TeamForm$teamMemberFormFields(
						$rtfeldman$elm_validate$Validate$fromValid(validFormFields));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$Loading, g$: validatedForm}),
						A4(
							$author$project$Api$Provider$TeamMember$update,
							model.D5,
							$author$project$Api$Platform$User$Shared$id(
								$author$project$Api$Platform$Session$One$user(model.ZD)),
							{MR: fields.MR, w3: fields.w3, No: fields.No, S$: $elm$core$Maybe$Nothing, UO: $elm$core$Maybe$Nothing, UP: fields.UP, Wh: fields.Wh, W_: fields.W_, Xm: fields.Xm, Yd: $elm$core$Maybe$Nothing, Yy: $elm$core$Maybe$Nothing, agy: $elm$core$Maybe$Nothing, Cr: fields.Cr},
							$author$project$Pages$PracticeSetup$Team$Updated),
						_List_Nil);
				} else {
					var erroredForm = _v2.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked, g$: erroredForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var nextRoute = model.di ? $author$project$Spa$Generated$Route$PracticeSetup__Communications : $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, nextRoute),
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jY: $author$project$Api$Data$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Pages$PracticeSetup$Team$FormSubmitted = {$: 1};
var $author$project$Pages$PracticeSetup$Team$view = function (model) {
	var loading = _Utils_eq(model.jY, $author$project$Api$Data$Loading);
	var headerText = model.di ? 'Create your Clinical Profile' : 'Create your Profile';
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$horizontal,
						$author$project$Ui$Form$autocomplete(false),
						$author$project$Ui$Form$noValidate(true),
						$author$project$Ui$Form$onSubmit($author$project$Pages$PracticeSetup$Team$FormSubmitted)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$view,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$heading,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Panel$title(
										_List_fromArray(
											[
												$elm$html$Html$text(headerText)
											]))
									])),
								A2(
								$author$project$Ui$Panel$body,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$PracticeSetup$Team$TeamFormMsg,
										$author$project$Components$TeamForm$view(model.g$))
									])),
								A2(
								$author$project$Ui$Panel$footer,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										A2($author$project$Ui$Typography$div, _List_Nil, _List_Nil),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Next'},
										_List_fromArray(
											[
												$author$project$Ui$Button$primary,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$loading(loading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Next')
											]))
									]))
							]))
					]))
			]),
		$G: 'User Profile Setup'
	};
};
var $author$project$Pages$PracticeSetup$Team$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$PracticeSetup$Team$init, aer: $author$project$Pages$PracticeSetup$Team$load, agD: $author$project$Pages$PracticeSetup$Team$save, ahd: $author$project$Pages$PracticeSetup$Team$subscriptions, aaq: $author$project$Pages$PracticeSetup$Team$update, ahP: $author$project$Pages$PracticeSetup$Team$view});
var $author$project$Pages$PracticeSetup$Top$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				$elm$html$Html$text('Practice Setup')
			]),
		$G: 'Practice Setup'
	};
};
var $author$project$Pages$PracticeSetup$Top$page = $author$project$Spa$Page$static($author$project$Pages$PracticeSetup$Top$view);
var $author$project$Pages$Reports$AncillaryCharges$Id_String$ViewDetailsMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$GotAncillaryChargePreview = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Report$AffiliateAncillaryCharge = 22;
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.ff),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('affiliate_practice'),
			model.abb)
		]);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toPageQuery(model.afy),
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl = function (model) {
	var route = function () {
		var _v0 = model.adR;
		if (!_v0.$) {
			var id = _v0.a;
			return $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String(
				{adR: id});
		} else {
			return $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top;
		}
	}();
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString(route)
				]),
			$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams(model)));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$GotAncillaryCharges = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams = F2(
	function (model, pagination) {
		return function (d) {
			return _Utils_update(
				d,
				{
					IF: model.abb,
					ab9: model.ff,
					E9: A2(
						$elm$core$Maybe$map,
						A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
						model.E9),
					afy: pagination,
					Hl: A2(
						$elm$core$Maybe$map,
						A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
						model.Hl)
				});
		};
	});
var $author$project$Api$Provider$Reports$AncillaryCharge$AncillaryCharge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$AncillaryCharge$Record = F7(
	function (id, status, charge, sponsor, affiliate, affiliatePractice, sponsorCharge) {
		return {DZ: affiliate, IF: affiliatePractice, abU: charge, adR: id, _s: sponsor, _t: sponsorCharge, ag7: status};
	});
var $author$project$Api$Provider$Affiliate$Min$Affiliate = $elm$core$Basics$identity;
var $author$project$Api$Provider$Affiliate$Min$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$Affiliate$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$Min$Record));
var $author$project$Api$Provider$Affiliate$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Affiliate$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Charge = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Record = F5(
	function (createdAt, category, patient, priceInCents, invoice) {
		return {Ex: category, Mf: createdAt, Rh: invoice, VM: patient, Ba: priceInCents};
	});
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'invoice',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'price_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient',
			$author$project$Api$Provider$Patient$Min$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'category',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm_community$json_extra$Json$Decode$Extra$datetime,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Record))))));
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Charge$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Charge)));
var $author$project$Api$Provider$Reports$AncillaryCharge$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'sponsor_charge',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'affiliate_practice',
		$author$project$Api$Provider$Practice$Min$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'affiliate',
			$author$project$Api$Provider$Affiliate$Min$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsor',
				$author$project$Api$Provider$Company$Min$decoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge',
					$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'status',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$AncillaryCharge$Record))))))));
var $author$project$Api$Provider$Reports$AncillaryCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$AncillaryCharge$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$AncillaryCharge$listDefaults = {IF: $elm$core$Maybe$Nothing, ab9: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, Hl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$AncillaryCharge$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		$elm$core$List$concat(
			_List_fromArray(
				[
					function () {
					var _v0 = options.Hl;
					if (!_v0.$) {
						var start_ = _v0.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$date, 'start', start_)
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v1 = options.E9;
					if (!_v1.$) {
						var end_ = _v1.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$date, 'end', end_)
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v2 = options.ab9;
					if (!_v2.$) {
						var string = _v2.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'sponsor', string)
							]);
					} else {
						return _List_Nil;
					}
				}(),
					function () {
					var _v3 = options.IF;
					if (!_v3.$) {
						var string = _v3.a;
						return _List_fromArray(
							[
								A2($author$project$Api$Param$string, 'affiliate_practice', string)
							]);
					} else {
						return _List_Nil;
					}
				}()
				])));
};
var $author$project$Api$Provider$Reports$AncillaryCharge$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'affiliate_ancillary_charges']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$AncillaryCharge$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$AncillaryCharge$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$AncillaryCharge$listPath)));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges = F3(
	function (apiClient, model, pagination) {
		return A3(
			$author$project$Api$Provider$Reports$AncillaryCharge$list,
			apiClient,
			A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams, model, pagination),
			$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$GotAncillaryCharges);
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Affiliates$Practice$list = $author$project$Api$Platform$User$Practice$list;
var $author$project$Components$ResourceFilter$Affiliates$Practice$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A4(
			$author$project$Components$ResourceFilter$Affiliates$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						D_: $elm$core$Maybe$Just(true),
						afy: pagination,
						af_: query
					});
			},
			$elm$core$Maybe$Nothing,
			toMsg);
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A4(
			$author$project$Components$ResourceFilter$Affiliates$Practice$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						D_: $elm$core$Maybe$Just(true),
						Fc: _List_fromArray(
							[0]),
						af_: $elm$core$Maybe$Just(id)
					});
			},
			$elm$core$Maybe$Nothing,
			toMsg);
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$selectId = 'practices';
var $author$project$Components$ResourceFilter$Affiliates$Practice$toTitle = $author$project$Api$Platform$Practice$All$name;
var $author$project$Components$ResourceFilter$Affiliates$Practice$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Affiliates$Practice$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Affiliates$Practice$toValue = $author$project$Api$Platform$Practice$All$id;
var $author$project$Components$ResourceFilter$Affiliates$Practice$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$Affiliates$Practice$fetchResources, adR: $author$project$Components$ResourceFilter$Affiliates$Practice$selectId, gx: 'Practices', st: $author$project$Components$ResourceFilter$Affiliates$Practice$retrieveResource, ahw: $author$project$Components$ResourceFilter$Affiliates$Practice$toLabel, ahA: $author$project$Components$ResourceFilter$Affiliates$Practice$toTitle, g0: $author$project$Components$ResourceFilter$Affiliates$Practice$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Utils$Report$PracticeResourceFilter$init = F4(
	function (apiClient, optionals, practice, practiceId) {
		return A2(
			$author$project$Components$ResourceFilter$Affiliates$Practice$init,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{
							D0: 'All ' + A2($author$project$Api$Practice$sponsorize, practice, 'Affiliates'),
							afT: practiceId
						});
				}));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'charge_added', false, 'Charge Added Date'),
		A3($author$project$Api$Column$init, 'sponsor', false, 'Sponsor'),
		A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
		A3($author$project$Api$Column$init, 'affiliate', false, 'Affiliate'),
		A3($author$project$Api$Column$init, 'charge', false, 'Charge'),
		A2(
		$author$project$Api$Column$withOption,
		$author$project$Ui$Table$textCenter,
		A3($author$project$Api$Column$init, 'sponsor_invoice', false, 'Sponsor Invoice'))
	]);
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init = F4(
	function (practice, _v0, query, paramsId) {
		var apiClient = _v0.D5;
		var timeZone = _v0.Hz;
		var currentDate = _v0.cO;
		var pagination = A2($author$project$Api$Pagination$fromQuery, query, $author$project$Api$Pagination$init);
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var affiliatePracticeId = A2($elm$core$Dict$get, 'affiliate_practice', query);
		var _v1 = A4(
			$author$project$Utils$Report$PracticeResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			affiliatePracticeId);
		var practiceResourceFilter = _v1.a;
		var practiceResourceFilterCmd = _v1.b;
		var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v2.a;
		var end = _v2.b;
		var _v3 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v3.a;
		var dateRangeInputCmd = _v3.b;
		var _v4 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v4.a;
		var companyResourceFilterCmd = _v4.b;
		var model = {
			abb: affiliatePracticeId,
			ai: $author$project$Api$Data$Loading,
			Ll: $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initColumns,
			ff: companyId,
			pV: companyResourceFilter,
			cO: currentDate,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 22}),
			adR: paramsId,
			afy: pagination,
			jA: practiceResourceFilter,
			Hl: start,
			Hz: timeZone
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg, practiceResourceFilterCmd),
						A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, model, pagination),
						$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(model)
					])));
	});
var $author$project$Api$Provider$AffiliateAncillaryCharge$AffiliateAncillaryChargePreview = $elm$core$Basics$identity;
var $author$project$Api$Provider$AffiliateAncillaryCharge$Record = F5(
	function (id, status, charge, category, networkCoveragePlan) {
		return {Ex: category, abU: charge, adR: id, Up: networkCoveragePlan, ag7: status};
	});
var $author$project$Api$Provider$AffiliateAncillaryCharge$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'network_coverage_plan',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'category',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'charge',
			$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateAncillaryCharge$Record))))));
var $author$project$Api$Provider$AffiliateAncillaryCharge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$AffiliateAncillaryCharge$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$AffiliateAncillaryCharge$preview = F3(
	function (apiClient, id, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$AffiliateAncillaryCharge$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['affiliate_ancillary_charges', id, 'preview']),
					$author$project$Api$Data$providerPath)));
	});
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$init = F4(
	function (practice, shared, _v0, session) {
		var params = _v0.Vx;
		var query = _v0.Bi;
		var _v1 = A4(
			$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init,
			practice,
			shared,
			query,
			$elm$core$Maybe$Just(params.adR));
		var ancillaryCharges = _v1.a;
		var cmd = _v1.b;
		var _v2 = A3(
			$author$project$Components$ResourceFilter$Category$init,
			shared.D5,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false});
			});
		var categoryResourceFilter = _v2.a;
		var categoryResourceFilterCmd = _v2.b;
		return _Utils_Tuple2(
			{u5: $elm$core$Maybe$Nothing, ai: ancillaryCharges, cJ: categoryResourceFilter, L5: $elm$core$Maybe$Nothing, adR: params.adR, Up: $elm$core$Maybe$Nothing, j$: $elm$core$Maybe$Nothing, ZD: session, aav: shared.aav},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg, cmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A3($author$project$Api$Provider$AffiliateAncillaryCharge$preview, shared.D5, params.adR, $author$project$Components$Reports$AncillaryCharges$ViewDetails$GotAncillaryChargePreview)
					])));
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$init = F4(
	function (session, practice, shared, urlParams) {
		var _v0 = A4($author$project$Components$Reports$AncillaryCharges$ViewDetails$init, practice, shared, urlParams, session);
		var viewDetails = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			{D5: shared.D5, pc: viewDetails},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg,
		A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Sub$none,
			A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.Up)));
};
var $author$project$Pages$Reports$AncillaryCharges$Id_String$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$AncillaryCharges$ViewDetails$subscriptions(model.pc));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargeApproved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$AffiliateAncillaryCharge$approve = F4(
	function (apiClient, id, params, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'charge',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'category',
								A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.Ex))
							])))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['affiliate_ancillary_charges', id, 'approve']),
						$author$project$Api$Data$providerPath))));
	});
var $author$project$Spa$Url$toQuery = function (queryString) {
	var second = A2(
		$elm$core$Basics$composeR,
		$elm$core$List$drop(1),
		$elm$core$List$head);
	var toTuple = function (list) {
		return A2(
			$elm$core$Maybe$map,
			function (first) {
				return _Utils_Tuple2(
					first,
					A2(
						$elm$core$Maybe$withDefault,
						'',
						second(list)));
			},
			$elm$core$List$head(list));
	};
	var decode = A2(
		$elm$core$Basics$composeR,
		$elm$url$Url$percentDecode,
		$elm$core$Maybe$withDefault(''));
	return A2(
		$elm$core$List$map,
		A2($elm$core$Tuple$mapBoth, decode, decode),
		A2(
			$elm$core$List$filterMap,
			toTuple,
			A2(
				$elm$core$List$map,
				$elm$core$String$split('='),
				A2($elm$core$String$split, '&', queryString))));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl = F2(
	function (maybeSelectedPageNumber, model) {
		var queryParamsList = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$map(
					function (_v2) {
						var key = _v2.a;
						var value = _v2.b;
						return A2($elm$url$Url$Builder$string, key, value);
					}),
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$filter(
						function (_v1) {
							var key = _v1.a;
							return A2(
								$elm$core$List$member,
								key,
								_List_fromArray(
									['company', 'start', 'end', 'affiliate_practice']));
						}),
					A2($elm$core$Maybe$map, $author$project$Spa$Url$toQuery, model.aav.Bi))));
		var pageQuery = function () {
			if (!maybeSelectedPageNumber.$) {
				var pageNumber = maybeSelectedPageNumber.a;
				return _List_fromArray(
					[
						A2($elm$url$Url$Builder$int, 'page', pageNumber)
					]);
			} else {
				return $author$project$Api$Pagination$toPageQuery(model.ai.afy);
			}
		}();
		return $author$project$Ports$Navigation$pushUrl(
			A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[
						$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top)
					]),
				A2($elm$core$List$append, pageQuery, queryParamsList)));
	});
var $author$project$Api$Provider$AffiliateAncillaryCharge$category = function (_v0) {
	var record = _v0;
	return record.Ex;
};
var $author$project$Api$Provider$Reports$AncillaryCharge$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$initCategoryResourceFilter = F3(
	function (apiClient, session, id) {
		return A3(
			$author$project$Components$ResourceFilter$Category$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'Unassigned', aeZ: false, afT: id});
			});
	});
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$initNetworkCoveragePlanRules = F4(
	function (apiClient, session, coveragePlan, coverageRuleUsages) {
		if (!coveragePlan.$) {
			var coveragePlan_ = coveragePlan.a;
			return A3(
				$elm$core$Tuple$mapBoth,
				$elm$core$Maybe$Just,
				$elm$core$Platform$Cmd$map($author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg),
				A6(
					$author$project$Components$Admin$CoveragePlans$Rules$init,
					apiClient,
					session,
					$elm$core$Maybe$Just(
						$author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_)),
					$author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_),
					$elm$core$Maybe$Just(coverageRuleUsages),
					{XO: true}));
		} else {
			return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan = function (_v0) {
	var record = _v0;
	return record.Up;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$selectAncillaryCharge = F2(
	function (model, id) {
		var _v0 = model.ai;
		if (_v0.$ === 3) {
			var charges = _v0.a;
			return $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (ancillaryCharge) {
						return _Utils_eq(
							$author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge),
							id);
					},
					charges));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$AncillaryChargeApproved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$ResourceFilter$Affiliates$Practice$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if ((!_v1.$) && (!_v1.a.$)) {
				var selected = _v1.a.a;
				return _Utils_update(
					model,
					{G0: selected});
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update = F3(
	function (msg, model, apiClient) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					var totalCount = A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ai: response, afy: totalCount}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ai: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 1:
				var ancillaryCharge = msg.a;
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$AffiliateAncillaryCharge$approve,
						apiClient,
						$author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge),
						{Ex: $elm$core$Maybe$Nothing},
						$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$AncillaryChargeApproved),
					_List_Nil);
			case 2:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, model, model.afy),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate ancillary charge approved')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 3:
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v3.a;
				var subCmd = _v3.b;
				var subOutMsg = _v3.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg, subCmd),
					subOutMsg);
			case 4:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{ai: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, pagination),
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v4.a;
				var subCmd = _v4.b;
				var event = _v4.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								ai: $author$project$Api$Data$Loading,
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var _v5 = function () {
					if (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) {
						return _Utils_Tuple2(_List_Nil, model.afy);
					} else {
						var paginationReset = $author$project$Api$Pagination$reset(model.afy);
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
								]),
							paginationReset);
					}
				}();
				var cmds = _v5.a;
				var pagination = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{afy: pagination}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pV);
				var companyId = function () {
					var _v8 = companyResourceResult.ac5;
					if ((!_v8.$) && (!_v8.a.$)) {
						return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.y8);
					} else {
						return model.ff;
					}
				}();
				var newModel = _Utils_update(
					model,
					{ff: companyId, pV: companyResourceResult.y8});
				var _v7 = function () {
					if (_Utils_eq(model.ff, newModel.ff)) {
						return _Utils_Tuple3(model.ai, $elm$core$Platform$Cmd$none, model.afy);
					} else {
						var paginationReset = $author$project$Api$Pagination$reset(model.afy);
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
										$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
									])),
							paginationReset);
					}
				}();
				var ancillaryCharges = _v7.a;
				var cmd = _v7.b;
				var pagination = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{ai: ancillaryCharges, afy: pagination}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg, companyResourceResult.EC),
								cmd
							])),
					companyResourceResult.as);
			default:
				var subMsg = msg.a;
				var practiceResourceResult = A3($author$project$Components$ResourceFilter$Affiliates$Practice$update, apiClient, subMsg, model.jA);
				var affiliatePracticeId = function () {
					var _v10 = practiceResourceResult.ac5;
					if ((!_v10.$) && (!_v10.a.$)) {
						return $author$project$Components$ResourceFilter$Affiliates$Practice$value(practiceResourceResult.y8);
					} else {
						return model.abb;
					}
				}();
				var newModel = _Utils_update(
					model,
					{abb: affiliatePracticeId, jA: practiceResourceResult.y8});
				var _v9 = function () {
					if (_Utils_eq(model.abb, newModel.abb)) {
						return _Utils_Tuple3(model.ai, $elm$core$Platform$Cmd$none, model.afy);
					} else {
						var paginationReset = $author$project$Api$Pagination$reset(model.afy);
						return _Utils_Tuple3(
							$author$project$Api$Data$Loading,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
										$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
									])),
							paginationReset);
					}
				}();
				var ancillaryCharges = _v9.a;
				var cmd = _v9.b;
				var pagination = _v9.c;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{ai: ancillaryCharges, afy: pagination}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg, practiceResourceResult.EC),
								cmd
							])),
					practiceResourceResult.as);
		}
	});
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$update = F3(
	function (msg, model, apiClient) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update, subMsg, model.ai, apiClient);
				var ancillaryChargesModel = _v1.a;
				var cmd = _v1.b;
				var outMsgs = _v1.c;
				var selectedAncillaryCharge = A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$selectAncillaryCharge, ancillaryChargesModel, model.adR);
				var newCmd = function () {
					if (subMsg.$ === 4) {
						var paginationMsg = subMsg.a;
						var selectedPageNumber = paginationMsg;
						return A2(
							$author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl,
							$elm$core$Maybe$Just(selectedPageNumber),
							model);
					} else {
						return A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg, cmd);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ai: ancillaryChargesModel, j$: selectedAncillaryCharge}),
					newCmd,
					outMsgs);
			case 1:
				return _Utils_Tuple3(
					model,
					A2($author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl, $elm$core$Maybe$Nothing, model),
					_List_Nil);
			case 2:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var affiliateAncillaryChargePreview = response.a;
						var previewSponsorChargeCategoryId = A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$Category$Min$id,
							$author$project$Api$Provider$AffiliateAncillaryCharge$category(affiliateAncillaryChargePreview));
						var coveragePlan = $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan(affiliateAncillaryChargePreview);
						var _v5 = A4($author$project$Components$Reports$AncillaryCharges$ViewDetails$initNetworkCoveragePlanRules, apiClient, model.ZD, coveragePlan, _List_Nil);
						var networkCoveragePlan = _v5.a;
						var _v6 = A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$initCategoryResourceFilter, apiClient, model.ZD, previewSponsorChargeCategoryId);
						var categoryResourceFilter = _v6.a;
						var categoryResourceFilterCmd = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									u5: $elm$core$Maybe$Just(affiliateAncillaryChargePreview),
									cJ: categoryResourceFilter,
									L5: coveragePlan,
									Up: networkCoveragePlan
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceFilterCmd),
							_List_Nil);
					case 2:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cJ);
				var newCategoryResourceFilter = categoryResourceResult.y8;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cJ: newCategoryResourceFilter}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceResult.EC),
					categoryResourceResult.as);
			case 4:
				var ancillaryCharge = msg.a;
				var category = $author$project$Components$ResourceFilter$Category$value(model.cJ);
				return _Utils_Tuple3(
					model,
					A4(
						$author$project$Api$Provider$AffiliateAncillaryCharge$approve,
						apiClient,
						$author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge),
						{Ex: category},
						$author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargeApproved),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						model,
						A2($author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl, $elm$core$Maybe$Nothing, model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Affiliate ancillary charge approved')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var subMsg = msg.a;
				var _v8 = model.Up;
				if (!_v8.$) {
					var networkCoveragePlan = _v8.a;
					var _v9 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, networkCoveragePlan);
					var newNetworkCoveragePlan = _v9.a;
					var networkCoveragePlanCmd = _v9.b;
					var networkCoveragePlanOutMsgs = _v9.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								Up: $elm$core$Maybe$Just(newNetworkCoveragePlan)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg, networkCoveragePlanCmd),
						networkCoveragePlanOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Reports$AncillaryCharges$Id_String$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$update, subMsg, model.pc, model.D5);
		var viewDetails = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{pc: viewDetails}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initMiniColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'charge_added', false, 'Charge Added Date'),
		A3($author$project$Api$Column$init, 'sponsor', false, 'Sponsor'),
		A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
		A3($author$project$Api$Column$init, 'affiliate', false, 'Affiliate'),
		A3($author$project$Api$Column$init, 'charge', false, 'Charge')
	]);
var $author$project$Api$Provider$Reports$AncillaryCharge$affiliate = function (_v0) {
	var record = _v0;
	return record.DZ;
};
var $author$project$Api$Provider$Reports$AncillaryCharge$affiliatePractice = function (_v0) {
	var record = _v0;
	return record.IF;
};
var $author$project$Api$Provider$Reports$AncillaryCharge$charge = function (_v0) {
	var record = _v0;
	return record.abU;
};
var $author$project$Api$Provider$Affiliate$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice = function (_v0) {
	var record = _v0.b;
	return record.Rh;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell = function (ancillaryCharge) {
	var invoice = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice(
		$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
	var invoiceId = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$id, invoice));
	var affiliationId = $author$project$Api$Provider$Affiliate$Min$id(
		$author$project$Api$Provider$Reports$AncillaryCharge$affiliate(ancillaryCharge));
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Practice$Min$name(
					$author$project$Api$Provider$Reports$AncillaryCharge$affiliatePractice(ancillaryCharge))),
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Invoice: ')
							])),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String(
							{pp: affiliationId, adR: invoiceId}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								'#' + $elm$core$String$fromInt(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber, invoice))))
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2(
							$elm$core$Maybe$map,
							$author$project$Ui$Badge$fromString(_List_Nil),
							A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$humanStatus, invoice)))
					]))
			]));
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$createdAt = function (_v0) {
	var record = _v0.b;
	return record.Mf;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell = F2(
	function (model, ancillaryCharge) {
		var chargeAdded = A2(
			$justinmimbs$date$Date$fromPosix,
			model.Hz,
			$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$createdAt(
				$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge)));
		return A2(
			$author$project$Ui$Table$cell,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargeAdded))
				]));
	});
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category = function (_v0) {
	var record = _v0.b;
	return record.Ex;
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name = function (_v0) {
	var shared = _v0.a;
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		$author$project$Api$Provider$Charge$Shared$name(shared));
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$totalInCents = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell = function (ancillaryCharge) {
	var totalAmountInCents = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$totalInCents(
		$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
	var chargeCategory = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category(
		$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name(
					$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge))),
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$name, chargeCategory)))
					])),
				A2(
				$author$project$Ui$Typography$div,
				_List_fromArray(
					[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(totalAmountInCents))
					]))
			]));
};
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$patient = function (_v0) {
	var record = _v0.b;
	return record.VM;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell = function (ancillaryCharge) {
	var patientName = $author$project$Api$Provider$Patient$Min$name(
		$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$patient(
			$author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge)));
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(patientName)
			]));
};
var $author$project$Api$Provider$Reports$AncillaryCharge$sponsor = function (_v0) {
	var record = _v0;
	return record._s;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell = function (ancillaryCharge) {
	return A2(
		$author$project$Ui$Table$cell,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Api$Provider$Company$Min$name(
					$author$project$Api$Provider$Reports$AncillaryCharge$sponsor(ancillaryCharge)))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniAncillaryCharge = F2(
	function (model, ancillaryCharge) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell, model, ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell(ancillaryCharge)
				]));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter = function (companyResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Company$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			companyResourceFilter));
};
var $author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$ResourceFilter$Affiliates$Practice$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter = function (practiceResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Affiliates$Practice$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			practiceResourceFilter));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniFilters = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$itemsCenter,
							$author$project$Ui$FlexGrid$spanLg(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Charge Added Date')
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(2)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg,
							$author$project$Components$DateRangeInput$view(model.h3))
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(2)
						]),
					_List_fromArray(
						[
							$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter(model.pV)
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanLg(2)
						]),
					_List_fromArray(
						[
							$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter(model.jA)
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					function () {
						var activeFilters = _Utils_ap(
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg),
								$author$project$Components$ResourceFilter$Company$viewMultiSelected(model.pV)),
							A2(
								$elm$core$List$map,
								$elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg),
								$author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected(model.jA)));
						return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Active filters')
											]))
									])),
								A2($elm$html$Html$span, _List_Nil, activeFilters)
							]);
					}())
				]))
		]);
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PaginationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PaginationMsg,
		A2(
			$author$project$Api$Pagination$view,
			_List_fromArray(
				[
					$author$project$Ui$Pagination$List$loading(
					!$author$project$Utils$Maybe$toBool(
						$author$project$Api$Data$toMaybe(model.ai)))
				]),
			model.afy));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMini = function (model) {
	var _v0 = function () {
		var _v1 = model.ai;
		if (_v1.$ === 3) {
			var charges = _v1.a;
			return _Utils_Tuple2(false, charges);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var ancillaryCharges = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniFilters(model)),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('No matching results.')
											])),
										$author$project$Ui$Table$loading(loading)
									]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											A2(
											$elm$core$List$map,
											$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
											$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initMiniColumns),
											_List_fromArray(
											[
												A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
											])
										])),
								A2(
									$elm$core$List$map,
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniAncillaryCharge(model),
									ancillaryCharges),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination(model)
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewAncillaryChargesList = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-1/2')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Affiliate Ancillary Charges')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg,
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMini(model.ai))
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$Close = {$: 1};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$ApproveAncillaryCharge = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Reports$AncillaryCharge$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewApproveButton = function (ancillaryCharge) {
	return ($author$project$Api$Provider$Reports$AncillaryCharge$status(ancillaryCharge) !== 'approved') ? A3(
		$author$project$Ui$Button$view,
		{abp: 'Approve charge'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$onClick(
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$ApproveAncillaryCharge(ancillaryCharge))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Approve')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCategory = function (model) {
	var chargeCategory = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Category$Min$name,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$Basics$identity,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$AncillaryCharge$charge, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category),
					model.j$))));
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4),
						$author$project$Ui$FlexGrid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Category')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(chargeCategory)
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('category-resource-filter')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg,
										A2(
											$author$project$Components$ResourceFilter$Category$view,
											_List_fromArray(
												[
													$author$project$Components$ResourceFilter$style(0)
												]),
											model.cJ))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeName = function (model) {
	var chargeName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$AncillaryCharge$charge, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name),
			model.j$));
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4),
						$author$project$Ui$FlexGrid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Charge')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(chargeName)
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(chargeName)
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoveragePlanName = function (model) {
	var planName = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$CoveragePlan$One$name,
			A2($elm$core$Maybe$andThen, $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan, model.u5)));
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4),
						$author$project$Ui$FlexGrid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Coverage Plan')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(planName)
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewNetworkCoverageDocuments = function (coverageDouments) {
	if (!coverageDouments.$) {
		var coverageDocuments_ = coverageDouments.a;
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$margin(2)
				]),
			_List_fromArray(
				[
					$author$project$Components$Admin$CoverageDocuments$Form$viewAsList(coverageDocuments_)
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoverageRules = function (model) {
	var _v0 = model.Up;
	if (!_v0.$) {
		var networkRules = _v0.a;
		var coverageDocuments = A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$coverageDocuments, model.L5);
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(12)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSpanSm(1),
									$author$project$Ui$Form$Group$inputSpanSm(11),
									$author$project$Ui$Form$Group$label('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewNetworkCoverageDocuments(coverageDocuments),
											A2(
											$elm$html$Html$map,
											$author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg,
											$author$project$Components$Admin$CoveragePlans$Rules$view(networkRules))
										]))
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewHeaders = A2(
	$author$project$Ui$FlexGrid$row,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2($elm$html$Html$div, _List_Nil, _List_Nil)
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Affiliate Invoice')
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_fromArray(
				[
					$author$project$Ui$FlexGrid$spanMd(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$title,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Sponsor Invoice')
						]))
				]))
		]));
var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$date = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Charge$Shared$date(shared);
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewServiceDate = function (model) {
	var chargeDate = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Api$Provider$Reports$AncillaryCharge$charge,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$date,
					$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full))),
			model.j$));
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4),
						$author$project$Ui$FlexGrid$justifyRight
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Service Date')
							]),
						_List_Nil)
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(chargeDate)
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeDetails = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('w-1/2 view-details')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Panel$titleWithButton,
								_List_fromArray(
									[
										$elm$html$Html$text('Charge Details')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Close details'},
										_List_fromArray(
											[
												$author$project$Ui$Button$close,
												$author$project$Ui$Button$onClick($author$project$Components$Reports$AncillaryCharges$ViewDetails$Close)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('×')
													]))
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewHeaders,
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeName(model),
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCategory(model),
										$author$project$Ui$HorizontalRule$view(_List_Nil),
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewServiceDate(model),
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoveragePlanName(model),
										$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoverageRules(model)
									]))
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_fromArray(
							[$author$project$Ui$Element$justifyRight]),
						_List_fromArray(
							[
								A2(
								$elm$core$Maybe$withDefault,
								$elm$html$Html$text(''),
								A2($elm$core$Maybe$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewApproveButton, model.j$))
							]))
					]))
			]));
};
var $author$project$Components$Reports$AncillaryCharges$ViewDetails$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('flex')
			]),
		_List_fromArray(
			[
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewAncillaryChargesList(model),
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeDetails(model)
			]));
};
var $author$project$Pages$Reports$AncillaryCharges$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				$author$project$Components$Reports$AncillaryCharges$ViewDetails$view(model.pc))
			]),
		$G: 'Reports | Affiliate Ancillary Charges'
	};
};
var $author$project$Pages$Reports$AncillaryCharges$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$AncillaryCharges$Id_String$init, aer: $author$project$Pages$Reports$AncillaryCharges$Id_String$load, agD: $author$project$Pages$Reports$AncillaryCharges$Id_String$save, ahd: $author$project$Pages$Reports$AncillaryCharges$Id_String$subscriptions, aaq: $author$project$Pages$Reports$AncillaryCharges$Id_String$update, ahP: $author$project$Pages$Reports$AncillaryCharges$Id_String$view});
var $author$project$Pages$Reports$AncillaryCharges$Top$AncillaryChargesMsg = $elm$core$Basics$identity;
var $author$project$Pages$Reports$AncillaryCharges$Top$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.Bi;
		var _v2 = A4($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init, practice, shared, query, $elm$core$Maybe$Nothing);
		var ancillaryChargesModel = _v2.a;
		var ancillaryChargesCmd = _v2.b;
		return _Utils_Tuple2(
			{ai: ancillaryChargesModel, D5: shared.D5, WF: practice},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, ancillaryChargesCmd));
	});
var $author$project$Pages$Reports$AncillaryCharges$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$AncillaryCharges$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$ResourceFilter$Affiliates$Practice$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg,
				$author$project$Components$ResourceFilter$Affiliates$Practice$subscriptions(model.jA)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.pV))
			]));
};
var $author$project$Pages$Reports$AncillaryCharges$Top$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$subscriptions(model.ai));
};
var $author$project$Pages$Reports$AncillaryCharges$Top$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update, subMsg, model.ai, model.D5);
		var ancillaryChargesModel = _v1.a;
		var cmd = _v1.b;
		var outMsgs = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{ai: ancillaryChargesModel}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd),
			outMsgs);
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ApproveAncillaryCharge = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildViewDetailsRoute = function (model) {
	return $author$project$Ui$Link$routeParams(
		$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams(model));
};
var $author$project$Api$Provider$Reports$AncillaryCharge$sponsorCharge = function (_v0) {
	var record = _v0;
	return record._t;
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewApprovedSponsorInvoice = function (ancillaryCharge) {
	var sponsorInvoice = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice,
		$author$project$Api$Provider$Reports$AncillaryCharge$sponsorCharge(ancillaryCharge));
	if (!sponsorInvoice.$) {
		var sponsorInvoice_ = sponsorInvoice.a;
		var companyId = $author$project$Api$Provider$Company$Min$id(
			$author$project$Api$Provider$Reports$AncillaryCharge$sponsor(ancillaryCharge));
		return A2(
			$author$project$Ui$Typography$div,
			_List_fromArray(
				[
					$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
						{
							ff: companyId,
							adR: $author$project$Api$Common$Payable$Invoice$Min$id(sponsorInvoice_)
						}),
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'#' + $elm$core$String$fromInt(
								$author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(sponsorInvoice_)))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorInvoiceCell = F2(
	function (model, ancillaryCharge) {
		return A2(
			$author$project$Ui$Table$cell,
			_List_fromArray(
				[$author$project$Ui$Table$noWrap]),
			_List_fromArray(
				[
					($author$project$Api$Provider$Reports$AncillaryCharge$status(ancillaryCharge) === 'approved') ? $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewApprovedSponsorInvoice(ancillaryCharge) : A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Approve ancilliary chage'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick(
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ApproveAncillaryCharge(ancillaryCharge))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Approve')
								])),
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String(
								{
									adR: $author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge)
								}),
							_List_fromArray(
								[
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildViewDetailsRoute(model),
									$author$project$Ui$Link$buttonSecondary
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View Details')
								]))
						]))
				]));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAncillaryCharge = F2(
	function (model, ancillaryCharge) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell, model, ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell(ancillaryCharge),
					$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell(ancillaryCharge),
					A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorInvoiceCell, model, ancillaryCharge)
				]));
	});
var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$view = F2(
	function (apiClient, model) {
		var _v0 = function () {
			var _v1 = model.ai;
			if (_v1.$ === 3) {
				var charges = _v1.a;
				return _Utils_Tuple2(false, charges);
			} else {
				return _Utils_Tuple2(true, _List_Nil);
			}
		}();
		var loading = _v0.a;
		var ancillaryCharges = _v0.b;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.ai)),
							$author$project$Components$ExportCsv$reportParams(
							A2(
								$elm$core$Basics$composeL,
								$author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams,
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams(model))(model.afy))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Affiliate Ancillary Charges')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$itemsCenter,
												$author$project$Ui$FlexGrid$spanMd(2)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Charge Added Date')
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.h3))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter(model.pV)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanMd(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter(model.jA)
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg),
													$author$project$Components$ResourceFilter$Company$viewMultiSelected(model.pV)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg),
													$author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected(model.jA)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A4(
								$author$project$Ui$Table$view,
								_List_fromArray(
									[
										$author$project$Ui$Table$zeroState(
										_List_fromArray(
											[
												$elm$html$Html$text('You don\'t have any results for the time period and filters selected. Try broadening your search to see more results.')
											])),
										$author$project$Ui$Table$loading(loading)
									]),
								$elm$core$List$concat(
									_List_fromArray(
										[
											A2(
											$elm$core$List$map,
											$author$project$Api$Column$view($author$project$Api$Column$NonSortable),
											model.Ll),
											_List_fromArray(
											[
												A2(
												$author$project$Ui$Table$header,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pull-right')
															]),
														_List_fromArray(
															[
																A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg, $author$project$Components$ExportCsv$button)
															]))
													]))
											])
										])),
								A2(
									$elm$core$List$map,
									$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAncillaryCharge(model),
									ancillaryCharges),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination(model)
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$AncillaryCharges$Top$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$view, model.D5, model.ai)),
		$G: 'Reports | Affiliate Ancillary Charges'
	};
};
var $author$project$Pages$Reports$AncillaryCharges$Top$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$AncillaryCharges$Top$init, aer: $author$project$Pages$Reports$AncillaryCharges$Top$load, agD: $author$project$Pages$Reports$AncillaryCharges$Top$save, ahd: $author$project$Pages$Reports$AncillaryCharges$Top$subscriptions, aaq: $author$project$Pages$Reports$AncillaryCharges$Top$update, ahP: $author$project$Pages$Reports$AncillaryCharges$Top$view});
var $author$project$Pages$Reports$CompanyInvoices$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$statusToString = function (status) {
	switch (status) {
		case 0:
			return 'issued,failed';
		case 1:
			return 'paid,processing';
		case 2:
			return 'paid';
		default:
			return 'processing';
	}
};
var $author$project$Components$Reports$CompanyInvoices$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			A2($elm$core$Maybe$map, $author$project$Components$Reports$CompanyInvoices$statusToString, model.ag7)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.ff)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CompanyInvoices)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Reports$CompanyInvoices$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$CompanyInvoices$GotInvoices = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				ab9: model.ff,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				afy: model.afy,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				ag7: A2(
					$elm$core$Maybe$map,
					$elm$core$String$split(','),
					A2($elm$core$Maybe$map, $author$project$Components$Reports$CompanyInvoices$statusToString, model.ag7))
			});
	};
};
var $author$project$Api$Provider$Reports$Invoice$Invoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Invoice$Record = F9(
	function (id, invoiceDate, invoiceNumber, amountInCents, dueInCents, paidInCents, description, humanStatus, company) {
		return {I2: amountInCents, ab9: company, Nx: description, N2: dueInCents, QE: humanStatus, adR: id, Rn: invoiceDate, Rq: invoiceNumber, Vu: paidInCents};
	});
var $author$project$Api$Provider$Reports$Invoice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'company',
	$author$project$Api$Provider$Company$Min$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'human_status',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'paid_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'due_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'amount_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'invoice_number',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'invoice_date',
								$author$project$Utils$Date$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Invoice$Record))))))))));
var $author$project$Api$Provider$Reports$Invoice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Invoice$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Invoice$listDefaults = {
	ab9: $elm$core$Maybe$Nothing,
	E9: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	ag1: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init),
	Hl: $elm$core$Maybe$Nothing,
	ag7: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$Invoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Invoice$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.ag7;
						if (!_v2.$) {
							var list_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$list, 'status', list_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.ab9;
						if (!_v3.$) {
							var string = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'company', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Invoice$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'invoices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Invoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Invoice$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Invoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Invoice$listPath)));
	});
var $author$project$Components$Reports$CompanyInvoices$fetchInvoices = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Invoice$list,
			apiClient,
			$author$project$Components$Reports$CompanyInvoices$fetchParams(model),
			$author$project$Components$Reports$CompanyInvoices$GotInvoices);
	});
var $author$project$Components$Reports$CompanyInvoices$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'invoice_date', true, 'Date'),
		A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
		A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Total'),
		A3($author$project$Api$Column$init, 'company', true, 'Company'),
		A3($author$project$Api$Column$init, 'description', false, 'Description')
	]);
var $author$project$Components$Reports$CompanyInvoices$IssuedOrFailed = 0;
var $author$project$Components$Reports$CompanyInvoices$Paid = 2;
var $author$project$Components$Reports$CompanyInvoices$PaidOrProcessing = 1;
var $author$project$Components$Reports$CompanyInvoices$Processing = 3;
var $author$project$Components$Reports$CompanyInvoices$statusFromString = function (status) {
	switch (status) {
		case 'issued,failed':
			return $elm$core$Maybe$Just(0);
		case 'paid,processing':
			return $elm$core$Maybe$Just(1);
		case 'paid':
			return $elm$core$Maybe$Just(2);
		case 'processing':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$CompanyInvoices$init = F3(
	function (practice, _v0, query) {
		var currentDate = _v0.cO;
		var apiClient = _v0.D5;
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var _v1 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v1.a;
		var end = _v1.b;
		var _v2 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$CompanyInvoices$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v2.a;
		var dateRangeInputCmd = _v2.b;
		var _v3 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v3.a;
		var companyResourceFilterCmd = _v3.b;
		var model = {
			Ll: $author$project$Components$Reports$CompanyInvoices$initColumns,
			ff: companyId,
			pV: companyResourceFilter,
			cO: currentDate,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 3}),
			q2: $author$project$Api$Data$Loading,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'invoice_date',
				0,
				A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init)),
			Hl: start,
			ag7: $author$project$Components$Reports$CompanyInvoices$statusFromString(
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2($elm$core$Dict$get, 'status', query))),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'status-dropdown', ahx: $author$project$Components$Reports$CompanyInvoices$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$CompanyInvoices$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.Bi;
		var _v2 = A3($author$project$Components$Reports$CompanyInvoices$init, practice, shared, query);
		var report = _v2.a;
		var reportCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, WF: practice, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$CompanyInvoices$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CompanyInvoices$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CompanyInvoices$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.pV)),
				$author$project$Ui$NewDropdown$subscriptions(model.oA)
			]));
};
var $author$project$Pages$Reports$CompanyInvoices$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CompanyInvoices$subscriptions(model.jO));
};
var $author$project$Components$Reports$CompanyInvoices$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								q2: $author$project$Api$Data$Loading,
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var statusDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: statusDropdown}),
					cmd,
					_List_Nil);
			case 2:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						q2: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						ag7: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pV);
				var companyId = function () {
					var _v5 = companyResourceResult.ac5;
					if (!_v5.$) {
						if (!_v5.a.$) {
							return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.y8);
						} else {
							var _v6 = _v5.a;
							return model.ff;
						}
					} else {
						return model.ff;
					}
				}();
				var newModel = _Utils_update(
					model,
					{ff: companyId, pV: companyResourceResult.y8});
				var _v4 = _Utils_eq(model.ff, newModel.ff) ? _Utils_Tuple2(model.q2, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var invoices = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{q2: invoices}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg, companyResourceResult.EC),
								cmd
							])),
					companyResourceResult.as);
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								q2: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{q2: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{q2: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 6:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v8 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v8.a;
				var subCmd = _v8.b;
				var subOutMsg = _v8.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$CompanyInvoices$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CompanyInvoices$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$CompanyInvoices$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$CompanyInvoices$viewCompanyResourceFilter = function (companyResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Company$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			companyResourceFilter));
};
var $author$project$Components$Reports$CompanyInvoices$StatusSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$CompanyInvoices$statusToDisplayName = function (status) {
	switch (status) {
		case 0:
			return 'Issued (Overdue, Viewed, Sent, Failed)';
		case 1:
			return 'Collected (Paid, Processing)';
		case 2:
			return 'Paid';
		default:
			return 'Processing';
	}
};
var $author$project$Components$Reports$CompanyInvoices$statusDropdownItems = function (currentStatus) {
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CompanyInvoices$StatusSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Statuses')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				function (status) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Reports$CompanyInvoices$StatusSelected(
									$elm$core$Maybe$Just(status))),
								$author$project$Ui$NewDropdown$selected(
								_Utils_eq(
									currentStatus,
									$elm$core$Maybe$Just(status)))
							]),
						$elm$html$Html$text(
							$author$project$Components$Reports$CompanyInvoices$statusToDisplayName(status)));
				},
				_List_fromArray(
					[0, 1, 2, 3]))));
};
var $author$project$Components$Reports$CompanyInvoices$viewStatusDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.ag7;
		if (!_v0.$) {
			var status = _v0.a;
			return $author$project$Components$Reports$CompanyInvoices$statusToDisplayName(status);
		} else {
			return 'Status';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$CompanyInvoices$statusDropdownItems(model.ag7),
		model.oA);
};
var $author$project$Components$Reports$CompanyInvoices$SortTable = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Reports$Invoice$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$Invoice$company = function (_v0) {
	var record = _v0;
	return record.ab9;
};
var $author$project$Api$Provider$Reports$Invoice$description = function (_v0) {
	var record = _v0;
	return record.Nx;
};
var $author$project$Api$Provider$Reports$Invoice$dueInCents = function (_v0) {
	var record = _v0;
	return record.N2;
};
var $author$project$Api$Provider$Reports$Invoice$humanStatus = function (_v0) {
	var record = _v0;
	return record.QE;
};
var $author$project$Api$Provider$Reports$Invoice$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Reports$Invoice$invoiceDate = function (_v0) {
	var record = _v0;
	return record.Rn;
};
var $author$project$Api$Provider$Reports$Invoice$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Api$Provider$Reports$Invoice$paidInCents = function (_v0) {
	var record = _v0;
	return record.Vu;
};
var $author$project$Components$Reports$CompanyInvoices$viewRow = function (invoice) {
	var company = $author$project$Api$Provider$Reports$Invoice$company(invoice);
	return A2(
		$author$project$Ui$Table$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Formatters$Date$toString,
							$author$project$Formatters$Date$Full,
							$author$project$Api$Provider$Reports$Invoice$invoiceDate(invoice)))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
							{
								ff: $author$project$Api$Provider$Company$Min$id(company),
								adR: $author$project$Api$Provider$Reports$Invoice$id(invoice)
							}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(
									$author$project$Api$Provider$Reports$Invoice$invoiceNumber(invoice)))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Badge$fromString,
						_List_Nil,
						$author$project$Api$Provider$Reports$Invoice$humanStatus(invoice))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Provider$Reports$Invoice$amountInCents(invoice))),
						(($author$project$Api$Provider$Reports$Invoice$dueInCents(invoice) > 0) && ($author$project$Api$Provider$Reports$Invoice$paidInCents(invoice) > 0)) ? $elm$html$Html$text(
						$author$project$Utils$Currency$fromInt(
							$author$project$Api$Provider$Reports$Invoice$dueInCents(invoice)) + ' due') : $author$project$Utils$Html$empty
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
							{
								ff: $author$project$Api$Provider$Company$Min$id(company)
							}),
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Provider$Company$Min$name(company))
							]))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$Formatters$String$ellipsis,
							20,
							$author$project$Api$Provider$Reports$Invoice$description(invoice)))
					]))
			]));
};
var $author$project$Components$Reports$CompanyInvoices$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.q2;
		if (_v1.$ === 3) {
			var invoices_ = _v1.a;
			return _Utils_Tuple2(false, invoices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var invoices = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$CompanyInvoices$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2($elm$core$List$map, $author$project$Components$Reports$CompanyInvoices$viewRow, invoices),
		_List_Nil);
};
var $author$project$Components$Reports$CompanyInvoices$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$CompanyInvoices$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.q2)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Invoice$listOptionsToParams, $author$project$Components$Reports$CompanyInvoices$fetchParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Employer Invoices')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.q2;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										var totalDueAmount = A2($author$project$Components$Reports$CompanyInvoices$intFromHeader, headers, 'x-total-due-amount');
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$CompanyInvoices$intFromHeader, headers, 'x-total-amount'))),
												(totalDueAmount > 0) ? $author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text(
														'Total Due: ' + $author$project$Utils$Currency$fromInt(totalDueAmount))
													])) : $author$project$Utils$Html$empty
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.h3)),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanSm(4),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$CompanyInvoices$viewStatusDropdown(model)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(5),
												$author$project$Ui$FlexGrid$spanSm(3),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$CompanyInvoices$viewCompanyResourceFilter(model.pV)
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg),
												$author$project$Components$ResourceFilter$Company$viewMultiSelected(model.pV));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$CompanyInvoices$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$CompanyInvoices$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.q2)))
										]),
									model.afy))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$CompanyInvoices$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CompanyInvoices$view, model.D5, model.jO)),
		$G: 'Reports | ' + (A2($author$project$Formatters$String$sponsorize, model.WF, 'Companies') + ' Invoices')
	};
};
var $author$project$Pages$Reports$CompanyInvoices$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$CompanyInvoices$init, aer: $author$project$Pages$Reports$CompanyInvoices$load, agD: $author$project$Pages$Reports$CompanyInvoices$save, ahd: $author$project$Pages$Reports$CompanyInvoices$subscriptions, aaq: $author$project$Pages$Reports$CompanyInvoices$update, ahP: $author$project$Pages$Reports$CompanyInvoices$view});
var $author$project$Pages$Reports$CreditOutstanding$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CreditOutstanding$Table = 0;
var $author$project$Components$Reports$CreditOutstanding$ByDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Report$Credit = 15;
var $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$CreditOutstanding$GotCredits = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$fetchCreditsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Mj: model.EL,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afy: model.afy,
				afS: model.WO,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Api$Provider$Reports$Credit$Credit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Credit$Record = F8(
	function (issuedOn, expiresOn, balanceInCents, amountInCents, transferredInCents, patient, creditCategory, practitioner) {
		return {I2: amountInCents, abw: balanceInCents, Mj: creditCategory, O$: expiresOn, Si: issuedOn, VM: patient, afS: practitioner, $5: transferredInCents};
	});
var $author$project$Api$Provider$CreditCategory$Min$CreditCategory = $elm$core$Basics$identity;
var $author$project$Api$Provider$CreditCategory$Min$Record = function (name) {
	return {zh: name};
};
var $author$project$Api$Provider$CreditCategory$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$CreditCategory$Min$Record));
var $author$project$Api$Provider$CreditCategory$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$CreditCategory$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Credit$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'practitioner',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'credit_category',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$CreditCategory$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'patient',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'transferred_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'balance_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'expires_on',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'issued_on',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Credit$Record)))))))));
var $author$project$Api$Provider$Reports$Credit$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Credit$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Credit$listDefaults = {Mj: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, rj: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, afS: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$Credit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Credit$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.afS;
						if (!_v2.$) {
							var practitioner_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.Mj;
						if (!_v3.$) {
							var taxJurisdiction_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'credit_category', taxJurisdiction_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.rj;
						if (!_v4.$) {
							var locationGroup_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.aet;
						if (!_v5.$) {
							var location_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Credit$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'credits']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Credit$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Credit$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Credit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Credit$listPath)));
	});
var $author$project$Components$Reports$CreditOutstanding$fetchCredits = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Credit$list,
			apiClient,
			$author$project$Components$Reports$CreditOutstanding$fetchCreditsParams(model),
			$author$project$Components$Reports$CreditOutstanding$GotCredits);
	});
var $author$project$Components$Reports$CreditOutstanding$GotSummary = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Mj: model.EL,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afS: model.WO,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Api$Provider$Reports$Credit$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$Credit$listPath,
			by,
			$author$project$Api$Provider$Reports$Credit$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$CreditOutstanding$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$Credit$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.bQ),
			$author$project$Components$Reports$CreditOutstanding$fetchSummaryParams(model),
			$author$project$Components$Reports$CreditOutstanding$GotSummary);
	});
var $author$project$Components$Reports$CreditOutstanding$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.ahI;
		if (!_v0) {
			return A2($author$project$Components$Reports$CreditOutstanding$fetchCredits, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$CreditOutstanding$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$CreditOutstanding$fetchCredits, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$CreditOutstanding$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'issued_on', true, 'Issued On'),
		A3($author$project$Api$Column$init, 'expires_on', true, 'Expires On'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Outstanding'),
		A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
		A3($author$project$Api$Column$init, 'credit_category', true, 'Category'),
		A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
	]);
var $author$project$Components$Reports$CreditOutstanding$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('credit_category'),
			model.EL),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.WO),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.bQ)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$CreditOutstanding$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					function () {
					var _v0 = model.bQ;
					if (!_v0.$) {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary);
					} else {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditOutstanding);
					}
				}()
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					$author$project$Utils$QueryParameter$fromDict(
						$author$project$Components$Reports$CreditOutstanding$urlParams(model))))));
};
var $author$project$Components$Reports$CreditOutstanding$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.cO;
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var credits = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$CreditOutstanding$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A2(
			$author$project$Components$ResourceFilter$CreditCategory$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						D0: 'All Categories',
						afT: A2($elm$core$Dict$get, 'credit_category', query)
					});
			});
		var creditCategoryResourceFilter = _v6.a;
		var creditCategoryResourceFilterCmd = _v6.b;
		var model = {
			bQ: A2($elm$core$Dict$get, 'by', query),
			lh: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'by-dropdown', ahx: $author$project$Components$Reports$CreditOutstanding$ByDropdownMsg})),
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			Ll: $author$project$Components$Reports$CreditOutstanding$initColumns,
			EL: A2($elm$core$Dict$get, 'credit_category', query),
			fi: creditCategoryResourceFilter,
			aY: credits,
			cO: currentDate,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 15}),
			b7: groupLocationAndPractitionerFilters,
			fW: locationGroupId,
			S3: locationId,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WO: practitionerId,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'issued_on',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			_9: summary,
			ahI: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, creditCategoryResourceFilterCmd),
						A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, model),
						$author$project$Components$Reports$CreditOutstanding$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$CreditOutstanding$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$CreditOutstanding$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$CreditOutstanding$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CreditOutstanding$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditOutstanding$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$CreditCategory$subscriptions(model.fi)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b7)),
				$author$project$Ui$NewDropdown$subscriptions(model.lh)
			]));
};
var $author$project$Pages$Reports$CreditOutstanding$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CreditOutstanding$subscriptions(model.jO));
};
var $author$project$Components$ResourceFilter$CreditCategory$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Reports$CreditOutstanding$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$CreditCategory$update, apiClient, subMsg, model.fi);
				var _v1 = result.ac5;
				if ((!_v1.$) && (!_v1.a.$)) {
					var newCreditCategoryId = $author$project$Components$ResourceFilter$CreditCategory$value(result.y8);
					var newModel = _Utils_update(
						model,
						{
							EL: newCreditCategoryId,
							fi: result.y8,
							aY: $author$project$Api$Data$Loading,
							afy: $author$project$Api$Pagination$reset(model.afy)
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, result.EC),
									A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								])),
						result.as);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fi: result.y8}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, result.EC),
						result.as);
				}
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lh);
				var byDropdown = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lh: byDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bQ: by,
						aY: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				var cmds = function () {
					var _v3 = _Utils_Tuple2(model.ahI, newModel.bQ);
					if (!_v3.a) {
						if (!_v3.b.$) {
							var _v4 = _v3.a;
							return _List_fromArray(
								[
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								]);
						} else {
							var _v5 = _v3.a;
							var _v6 = _v3.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v3.b.$ === 1) {
							var _v7 = _v3.a;
							var _v8 = _v3.b;
							return _List_fromArray(
								[
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								]);
						} else {
							var _v9 = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
									$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v10 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v10.a;
				var subCmd = _v10.b;
				var event = _v10.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								aY: $author$project$Api$Data$Loading,
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
						$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b7);
				var _v12 = result.ac5;
				switch (_v12.$) {
					case 0:
						var locationGroupId = _v12.a;
						var locationId = _v12.b;
						var practitionerId = _v12.c;
						var newModel = _Utils_update(
							model,
							{
								aY: $author$project$Api$Data$Loading,
								b7: result.y8,
								fW: locationGroupId,
								S3: locationId,
								afy: $author$project$Api$Pagination$reset(model.afy),
								WO: practitionerId
							});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, result.EC),
										A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
										$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aY: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{aY: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
								$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
								$author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v14 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v14.a;
				var subCmd = _v14.b;
				var subOutMsg = _v14.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$CreditOutstanding$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CreditOutstanding$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$CreditOutstanding$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$CreditOutstanding$BySelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$CreditOutstanding$byDropdownItems = function (currentBy) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CreditOutstanding$BySelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Summary')),
			$author$project$Ui$NewDropdown$separator,
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CreditOutstanding$BySelected(
						$elm$core$Maybe$Just('credit_category'))),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						currentBy,
						$elm$core$Maybe$Just('credit_category')))
				]),
			$elm$html$Html$text('Category')),
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CreditOutstanding$BySelected(
						$elm$core$Maybe$Just('practitioner'))),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						currentBy,
						$elm$core$Maybe$Just('practitioner')))
				]),
			$elm$html$Html$text('Provider'))
		]);
};
var $author$project$Components$Reports$CreditOutstanding$byToDisplayName = function (by) {
	switch (by) {
		case 'credit_category':
			return 'Category';
		case 'practitioner':
			return 'Provider';
		default:
			return by;
	}
};
var $author$project$Components$Reports$CreditOutstanding$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.bQ;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$CreditOutstanding$byToDisplayName(by);
		} else {
			return 'Summary By';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$CreditOutstanding$byDropdownItems(model.bQ),
		model.lh);
};
var $author$project$Components$Reports$CreditOutstanding$viewCreditCategoryResourceFilter = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$CreditCategory$viewNew,
			_List_fromArray(
				[$author$project$Components$ResourceFilter$multi]),
			model.fi));
};
var $author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$Reports$CreditOutstanding$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$CreditOutstanding$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'None',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'credit',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text('Outstanding')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('numeric')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
													routeParams,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$CreditOutstanding$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model._9)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model._9)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model._9)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Credits')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$CreditOutstanding$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$CreditOutstanding$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$Credit$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$Credit$balanceInCents = function (_v0) {
	var record = _v0;
	return record.abw;
};
var $author$project$Api$Provider$Reports$Credit$creditCategory = function (_v0) {
	var record = _v0;
	return record.Mj;
};
var $author$project$Api$Provider$Reports$Credit$expiresOn = function (_v0) {
	var record = _v0;
	return record.O$;
};
var $author$project$Api$Provider$Reports$Credit$issuedOn = function (_v0) {
	var record = _v0;
	return record.Si;
};
var $author$project$Api$Provider$CreditCategory$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Reports$Credit$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Api$Provider$Reports$Credit$practitioner = function (_v0) {
	var record = _v0;
	return record.afS;
};
var $author$project$Api$Provider$Reports$Credit$transferredInCents = function (_v0) {
	var record = _v0;
	return record.$5;
};
var $author$project$Components$Reports$CreditOutstanding$viewRow = F2(
	function (canGoToPatients, credit) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$Reports$Credit$issuedOn(credit)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
									$author$project$Api$Provider$Reports$Credit$expiresOn(credit))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$Reports$Credit$balanceInCents(credit))),
							($author$project$Api$Provider$Reports$Credit$amountInCents(credit) > 0) ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									(!_Utils_eq(
									$author$project$Api$Provider$Reports$Credit$balanceInCents(credit),
									$author$project$Api$Provider$Reports$Credit$amountInCents(credit))) ? $elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Credit$amountInCents(credit))) : $author$project$Utils$Html$empty,
									$elm$html$Html$text(' Issued')
								])) : $author$project$Utils$Html$empty,
							($author$project$Api$Provider$Reports$Credit$transferredInCents(credit) > 0) ? A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									(!_Utils_eq(
									$author$project$Api$Provider$Reports$Credit$balanceInCents(credit),
									$author$project$Api$Provider$Reports$Credit$transferredInCents(credit))) ? $elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Credit$transferredInCents(credit))) : $author$project$Utils$Html$empty,
									$elm$html$Html$text(' Transferred')
								])) : $author$project$Utils$Html$empty
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							function () {
								var _v0 = _Utils_Tuple2(
									$author$project$Api$Provider$Reports$Credit$patient(credit),
									canGoToPatients);
								if (!_v0.a.$) {
									if (_v0.b) {
										var patient = _v0.a.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
													{
														VN: $author$project$Api$Provider$Patient$Min$id(patient)
													}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$Patient$Min$name(patient))
													]))
											]);
									} else {
										var patient = _v0.a.a;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$Patient$Min$name(patient))
											]);
									}
								} else {
									return _List_Nil;
								}
							}())
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$CreditCategory$Min$name,
									$author$project$Api$Provider$Reports$Credit$creditCategory(credit))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(2)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$String$ellipsis,
								20,
								A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										$author$project$Api$Provider$Practitioner$Min$name,
										$author$project$Api$Provider$Reports$Credit$practitioner(credit)))))
						]))
				]));
	});
var $author$project$Components$Reports$CreditOutstanding$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.aY;
		if (_v1.$ === 3) {
			var credits_ = _v1.a;
			return _Utils_Tuple2(false, credits_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var credits = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$CreditOutstanding$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$CreditOutstanding$viewRow(model.Er),
			credits),
		_List_Nil);
};
var $author$project$Components$Reports$CreditOutstanding$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$CreditOutstanding$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.aY)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Credit$listOptionsToParams, $author$project$Components$Reports$CreditOutstanding$fetchCreditsParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Credit Outstanding')
									])),
								$author$project$Ui$Panel$title(
								function () {
									var _v0 = model.aY;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total Outstanding: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$CreditOutstanding$amountFromHeader, headers, 'x-total-balance')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total Outstanding: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('All outstanding credits for retail customers')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(1)
											]),
										_List_fromArray(
											[
												$author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text('Issued')
													]))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(11)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.h3))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$FlexGrid$column(
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanSm(3),
														$author$project$Ui$FlexGrid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.b7))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanSm(3),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditOutstanding$viewCreditCategoryResourceFilter(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanSm(3),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditOutstanding$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b7)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected(model.fi)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.ahI;
						if (!_v1) {
							return $author$project$Components$Reports$CreditOutstanding$viewTable(model);
						} else {
							return $author$project$Components$Reports$CreditOutstanding$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.ahI;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$CreditOutstanding$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.aY)))
												]),
											model.afy))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$CreditOutstanding$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CreditOutstanding$view, model.D5, model.jO)),
		$G: 'Reports | Credit Outstanding'
	};
};
var $author$project$Pages$Reports$CreditOutstanding$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$CreditOutstanding$init, aer: $author$project$Pages$Reports$CreditOutstanding$load, agD: $author$project$Pages$Reports$CreditOutstanding$save, ahd: $author$project$Pages$Reports$CreditOutstanding$subscriptions, aaq: $author$project$Pages$Reports$CreditOutstanding$update, ahP: $author$project$Pages$Reports$CreditOutstanding$view});
var $author$project$Pages$Reports$CreditOutstanding$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CreditOutstanding$Summary = 1;
var $author$project$Pages$Reports$CreditOutstanding$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$CreditOutstanding$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$CreditOutstanding$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CreditOutstanding$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$CreditOutstanding$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CreditOutstanding$subscriptions(model.jO));
};
var $author$project$Pages$Reports$CreditOutstanding$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CreditOutstanding$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$CreditOutstanding$Summary$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CreditOutstanding$view, model.D5, model.jO)),
		$G: 'Reports | Credit Outstanding'
	};
};
var $author$project$Pages$Reports$CreditOutstanding$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$CreditOutstanding$Summary$init, aer: $author$project$Pages$Reports$CreditOutstanding$Summary$load, agD: $author$project$Pages$Reports$CreditOutstanding$Summary$save, ahd: $author$project$Pages$Reports$CreditOutstanding$Summary$subscriptions, aaq: $author$project$Pages$Reports$CreditOutstanding$Summary$update, ahP: $author$project$Pages$Reports$CreditOutstanding$Summary$view});
var $author$project$Pages$Reports$CreditTransactions$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CreditTransactions$Table = 0;
var $author$project$Components$Reports$CreditTransactions$ByDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Report$CreditLine = 14;
var $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$CreditTransactions$TypeDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$CreditTransactions$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('credit_category'),
			model.EL),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.WO),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('type'),
			model.g5),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.bQ)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$CreditTransactions$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				function () {
				var _v0 = model.bQ;
				if (!_v0.$) {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary);
				} else {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditTransactions);
				}
			}()
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Components$Reports$CreditTransactions$urlParams(model)))));
};
var $author$project$Components$Reports$CreditTransactions$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$CreditTransactions$GotCreditLines = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Mj: model.EL,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afy: model.afy,
				afS: model.WO,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				ahI: model.g5
			});
	};
};
var $author$project$Api$Provider$Reports$CreditLine$CreditLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$CreditLine$Record = F8(
	function (transactionDate, amountInCents, type_, invoice, patient, creditCategory, practitioner, location) {
		return {I2: amountInCents, Mj: creditCategory, Rh: invoice, aet: location, VM: patient, afS: practitioner, $2: transactionDate, ahI: type_};
	});
var $author$project$Api$Provider$Reports$CreditLine$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'credit_category',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$CreditCategory$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'patient',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'invoice',
					$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'type',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transaction_date',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$CreditLine$Record)))))))));
var $author$project$Api$Provider$Reports$CreditLine$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$CreditLine$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$CreditLine$listDefaults = {Mj: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, rj: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, afS: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, ahI: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$CreditLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$CreditLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.afS;
						if (!_v2.$) {
							var practitioner_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.Mj;
						if (!_v3.$) {
							var taxJurisdiction_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'credit_category', taxJurisdiction_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.rj;
						if (!_v4.$) {
							var locationGroup_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.aet;
						if (!_v5.$) {
							var location_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.ahI;
						if (!_v6.$) {
							var string = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'type', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$CreditLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'credit_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$CreditLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$CreditLine$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$CreditLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$CreditLine$listPath)));
	});
var $author$project$Components$Reports$CreditTransactions$fetchCreditLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$CreditLine$list,
			apiClient,
			$author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams(model),
			$author$project$Components$Reports$CreditTransactions$GotCreditLines);
	});
var $author$project$Components$Reports$CreditTransactions$GotSummary = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$CreditTransactions$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Mj: model.EL,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afS: model.WO,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				ahI: model.g5
			});
	};
};
var $author$project$Api$Provider$Reports$CreditLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$CreditLine$listPath,
			by,
			$author$project$Api$Provider$Reports$CreditLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$CreditTransactions$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$CreditLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.bQ),
			$author$project$Components$Reports$CreditTransactions$fetchSummaryParams(model),
			$author$project$Components$Reports$CreditTransactions$GotSummary);
	});
var $author$project$Components$Reports$CreditTransactions$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.ahI;
		if (!_v0) {
			return A2($author$project$Components$Reports$CreditTransactions$fetchCreditLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$CreditTransactions$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$CreditTransactions$fetchCreditLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$CreditTransactions$initColumns = function (trackPatientsByLocation) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
					A3($author$project$Api$Column$init, 'type', true, 'Type'),
					A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
					A3($author$project$Api$Column$init, 'patient', true, 'Patient'),
					A3($author$project$Api$Column$init, 'credit_category', true, 'Category'),
					A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
				]),
				trackPatientsByLocation ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'location', true, 'Location')
				]) : _List_Nil
			]));
};
var $author$project$Components$Reports$CreditTransactions$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.cO;
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var creditLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$CreditTransactions$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A2(
			$author$project$Components$ResourceFilter$CreditCategory$init,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						D0: 'All Categories',
						afT: A2($elm$core$Dict$get, 'credit_category', query)
					});
			});
		var creditCategoryResourceFilter = _v6.a;
		var creditCategoryResourceFilterCmd = _v6.b;
		var model = {
			bQ: A2($elm$core$Dict$get, 'by', query),
			lh: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'by-dropdown', ahx: $author$project$Components$Reports$CreditTransactions$ByDropdownMsg})),
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			Ll: $author$project$Components$Reports$CreditTransactions$initColumns(trackPatientsByLocation),
			EL: A2($elm$core$Dict$get, 'credit_category', query),
			fi: creditCategoryResourceFilter,
			aD: creditLines,
			cO: currentDate,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 14}),
			b7: groupLocationAndPractitionerFilters,
			fW: locationGroupId,
			S3: locationId,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WO: practitionerId,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			_9: summary,
			$$: trackPatientsByLocation,
			oU: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'type-dropdown', ahx: $author$project$Components$Reports$CreditTransactions$TypeDropdownMsg})),
			g5: A2($elm$core$Dict$get, 'type', query),
			ahI: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, creditCategoryResourceFilterCmd),
						A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$CreditTransactions$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$CreditTransactions$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$CreditTransactions$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CreditTransactions$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$CreditTransactions$ExportCsvMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$CreditTransactions$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditTransactions$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditTransactions$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$CreditCategory$subscriptions(model.fi)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b7)),
				$author$project$Ui$NewDropdown$subscriptions(model.lh),
				$author$project$Ui$NewDropdown$subscriptions(model.oU)
			]));
};
var $author$project$Pages$Reports$CreditTransactions$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CreditTransactions$subscriptions(model.jO));
};
var $author$project$Components$Reports$CreditTransactions$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$CreditCategory$update, apiClient, subMsg, model.fi);
				var _v1 = result.ac5;
				if ((!_v1.$) && (!_v1.a.$)) {
					var newCreditCategoryId = $author$project$Components$ResourceFilter$CreditCategory$value(result.y8);
					var newModel = _Utils_update(
						model,
						{
							EL: newCreditCategoryId,
							fi: result.y8,
							aD: $author$project$Api$Data$Loading,
							afy: $author$project$Api$Pagination$reset(model.afy)
						});
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, result.EC),
									A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								])),
						result.as);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fi: result.y8}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, result.EC),
						result.as);
				}
			case 3:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oU);
				var typeDropdown = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oU: typeDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var typeFilter = msg.a;
				var newModel = _Utils_update(
					model,
					{
						aD: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						g5: typeFilter
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lh);
				var byDropdown = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lh: byDropdown}),
					cmd,
					_List_Nil);
			case 6:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bQ: by,
						aD: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				var cmds = function () {
					var _v4 = _Utils_Tuple2(model.ahI, newModel.bQ);
					if (!_v4.a) {
						if (!_v4.b.$) {
							var _v5 = _v4.a;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v6 = _v4.a;
							var _v7 = _v4.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v4.b.$ === 1) {
							var _v8 = _v4.a;
							var _v9 = _v4.b;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v10 = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v11 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v11.a;
				var subCmd = _v11.b;
				var event = _v11.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								aD: $author$project$Api$Data$Loading,
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b7);
				var _v13 = result.ac5;
				switch (_v13.$) {
					case 0:
						var locationGroupId = _v13.a;
						var locationId = _v13.b;
						var practitionerId = _v13.c;
						var newModel = _Utils_update(
							model,
							{
								aD: $author$project$Api$Data$Loading,
								b7: result.y8,
								fW: locationGroupId,
								S3: locationId,
								afy: $author$project$Api$Pagination$reset(model.afy),
								WO: practitionerId
							});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, result.EC),
										A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
										A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aD: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aD: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{aD: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 10:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v15 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v15.a;
				var subCmd = _v15.b;
				var subOutMsg = _v15.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$CreditTransactions$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CreditTransactions$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$CreditTransactions$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$CreditTransactions$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$CreditTransactions$BySelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$CreditTransactions$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$CreditTransactions$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Reports$CreditTransactions$BySelected(
									$elm$core$Maybe$Just('credit_category'))),
								$author$project$Ui$NewDropdown$selected(
								_Utils_eq(
									currentBy,
									$elm$core$Maybe$Just('credit_category')))
							]),
						$elm$html$Html$text('Category')),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$Reports$CreditTransactions$BySelected(
										$elm$core$Maybe$Just('practitioner'))),
									$author$project$Ui$NewDropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just('practitioner')))
								]),
							$elm$html$Html$text('Provider')),
						trackPatientsByLocation ? _List_fromArray(
							[
								A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$Reports$CreditTransactions$BySelected(
											$elm$core$Maybe$Just('location'))),
										$author$project$Ui$NewDropdown$selected(
										_Utils_eq(
											currentBy,
											$elm$core$Maybe$Just('location')))
									]),
								$elm$html$Html$text('Location'))
							]) : _List_Nil))));
	});
var $author$project$Components$Reports$CreditTransactions$byToDisplayName = function (by) {
	switch (by) {
		case 'credit_category':
			return 'Category';
		case 'practitioner':
			return 'Provider';
		case 'location':
			return 'Location';
		default:
			return by;
	}
};
var $author$project$Components$Reports$CreditTransactions$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.bQ;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$CreditTransactions$byToDisplayName(by);
		} else {
			return 'Summary By';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$CreditTransactions$byDropdownItems, model.$$, model.bQ),
		model.lh);
};
var $author$project$Components$Reports$CreditTransactions$viewCreditCategoryResourceFilter = function (model) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$CreditCategory$viewNew,
			_List_fromArray(
				[$author$project$Components$ResourceFilter$multi]),
			model.fi));
};
var $author$project$Components$Reports$CreditTransactions$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$CreditTransactions$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__CreditTransactions,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'None',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__CreditTransactions,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'credit',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('numeric')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__CreditTransactions,
											routeParams,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$CreditTransactions$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model._9)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model._9)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model._9)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Credits')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$CreditTransactions$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$CreditTransactions$SortTable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Reports$CreditLine$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$CreditLine$creditCategory = function (_v0) {
	var record = _v0;
	return record.Mj;
};
var $author$project$Api$Provider$Reports$CreditLine$invoice = function (_v0) {
	var record = _v0;
	return record.Rh;
};
var $author$project$Api$Provider$Reports$CreditLine$location = function (_v0) {
	var record = _v0;
	return record.aet;
};
var $author$project$Api$Provider$Reports$CreditLine$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Api$Provider$Reports$CreditLine$practitioner = function (_v0) {
	var record = _v0;
	return record.afS;
};
var $author$project$Api$Provider$Reports$CreditLine$transactionDate = function (_v0) {
	var record = _v0;
	return record.$2;
};
var $author$project$Api$Provider$Reports$CreditLine$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Components$Reports$CreditTransactions$viewRow = F3(
	function (trackPatientsByLocation, canGoToPatients, creditLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$CreditLine$transactionDate(creditLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$CreditLine$amountInCents(creditLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$String$humanize(
										$author$project$Api$Provider$Reports$CreditLine$type_(creditLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = $author$project$Api$Provider$Reports$CreditLine$invoice(creditLine);
								if (!_v0.$) {
									var invoice = _v0.a;
									var _v1 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
									if (!_v1.$) {
										var owner = _v1.a;
										return _Utils_ap(
											canGoToPatients ? _List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
														{
															aea: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
															VN: $author$project$Api$Common$Payable$Owner$Min$id(owner)
														}),
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															'#' + ($elm$core$String$fromInt(
																$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' ')),
															A2(
															$author$project$Ui$Badge$fromString,
															_List_Nil,
															$author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice))
														]))
												]) : _List_fromArray(
												[
													$elm$html$Html$text(
													'#' + ($elm$core$String$fromInt(
														$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' ')),
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice))
												]),
											_List_fromArray(
												[
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$small,
															$author$project$Ui$Typography$muted,
															$author$project$Ui$Typography$phi(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'for ' + $author$project$Api$Common$Payable$Owner$Min$name(owner))
														]))
												]));
									} else {
										return _List_Nil;
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									function () {
										var _v2 = _Utils_Tuple2(
											$author$project$Api$Provider$Reports$CreditLine$patient(creditLine),
											canGoToPatients);
										if (!_v2.a.$) {
											if (_v2.b) {
												var patient = _v2.a.a;
												return _List_fromArray(
													[
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
															{
																VN: $author$project$Api$Provider$Patient$Min$id(patient)
															}),
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Provider$Patient$Min$name(patient))
															]))
													]);
											} else {
												var patient = _v2.a.a;
												return _List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$Patient$Min$name(patient))
													]);
											}
										} else {
											return _List_Nil;
										}
									}())
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$CreditCategory$Min$name,
											$author$project$Api$Provider$Reports$CreditLine$creditCategory(creditLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Practitioner$Min$name,
											$author$project$Api$Provider$Reports$CreditLine$practitioner(creditLine))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$CreditLine$location(creditLine)))))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Reports$CreditTransactions$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.aD;
		if (_v1.$ === 3) {
			var creditLines_ = _v1.a;
			return _Utils_Tuple2(false, creditLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var creditLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$CreditTransactions$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$CreditTransactions$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$CreditTransactions$viewRow, model.$$, model.Er),
			creditLines),
		_List_Nil);
};
var $author$project$Components$Reports$CreditTransactions$TypeSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$CreditTransactions$typeDropdownItems = function (currentType) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentType, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Types')),
			$author$project$Ui$NewDropdown$separator,
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected(
						$elm$core$Maybe$Just('expired'))),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just('expired')))
				]),
			$elm$html$Html$text('Expired')),
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected(
						$elm$core$Maybe$Just('applied'))),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just('applied')))
				]),
			$elm$html$Html$text('Applied')),
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected(
						$elm$core$Maybe$Just('issued'))),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just('issued')))
				]),
			$elm$html$Html$text('Issued')),
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$CreditTransactions$TypeSelected(
						$elm$core$Maybe$Just('transferred'))),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						currentType,
						$elm$core$Maybe$Just('transferred')))
				]),
			$elm$html$Html$text('Transferred'))
		]);
};
var $author$project$Components$Reports$CreditTransactions$typeToDisplayName = function (typeFilter) {
	switch (typeFilter) {
		case 'expired':
			return 'Expired';
		case 'applied':
			return 'Applied';
		case 'issued':
			return 'Issued';
		case 'transferred':
			return 'Transferred';
		default:
			return typeFilter;
	}
};
var $author$project$Components$Reports$CreditTransactions$viewTypeDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.g5;
		if (!_v0.$) {
			var typeFilter = _v0.a;
			return $author$project$Components$Reports$CreditTransactions$typeToDisplayName(typeFilter);
		} else {
			return 'Type';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$CreditTransactions$typeDropdownItems(model.g5),
		model.oU);
};
var $author$project$Components$Reports$CreditTransactions$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$CreditTransactions$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.aD)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$CreditLine$listOptionsToParams, $author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Credit Transactions')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.aD;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$CreditTransactions$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total credit transactions for retail customers')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$CreditTransactions$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.h3)),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$FlexGrid$column(
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.b7))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditTransactions$viewCreditCategoryResourceFilter(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditTransactions$viewTypeDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$CreditTransactions$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b7)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected(model.fi)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.ahI;
						if (!_v1) {
							return $author$project$Components$Reports$CreditTransactions$viewTable(model);
						} else {
							return $author$project$Components$Reports$CreditTransactions$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.ahI;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$CreditTransactions$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.aD)))
												]),
											model.afy))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$CreditTransactions$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CreditTransactions$view, model.D5, model.jO)),
		$G: 'Reports | Credit Transactions'
	};
};
var $author$project$Pages$Reports$CreditTransactions$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$CreditTransactions$init, aer: $author$project$Pages$Reports$CreditTransactions$load, agD: $author$project$Pages$Reports$CreditTransactions$save, ahd: $author$project$Pages$Reports$CreditTransactions$subscriptions, aaq: $author$project$Pages$Reports$CreditTransactions$update, ahP: $author$project$Pages$Reports$CreditTransactions$view});
var $author$project$Pages$Reports$CreditTransactions$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$CreditTransactions$Summary = 1;
var $author$project$Pages$Reports$CreditTransactions$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$CreditTransactions$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$CreditTransactions$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$CreditTransactions$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$CreditTransactions$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$CreditTransactions$subscriptions(model.jO));
};
var $author$project$Pages$Reports$CreditTransactions$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$CreditTransactions$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$CreditTransactions$Summary$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$CreditTransactions$view, model.D5, model.jO)),
		$G: 'Reports | Credit Transactions'
	};
};
var $author$project$Pages$Reports$CreditTransactions$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$CreditTransactions$Summary$init, aer: $author$project$Pages$Reports$CreditTransactions$Summary$load, agD: $author$project$Pages$Reports$CreditTransactions$Summary$save, ahd: $author$project$Pages$Reports$CreditTransactions$Summary$subscriptions, aaq: $author$project$Pages$Reports$CreditTransactions$Summary$update, ahP: $author$project$Pages$Reports$CreditTransactions$Summary$view});
var $author$project$Pages$Reports$Custom$Id_String$GotEmbeddedReport = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$One$EmbeddedReport = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$EmbeddedReport$Shared$EmbeddedReport = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmbeddedReport$Shared$Record = F2(
	function (id, name) {
		return {adR: id, zh: name};
	});
var $author$project$Api$Provider$EmbeddedReport$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmbeddedReport$Shared$Record)));
var $author$project$Api$Provider$EmbeddedReport$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmbeddedReport$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$EmbeddedReport$One$Record = F2(
	function (service, descriptionLink) {
		return {Ny: descriptionLink, ZA: service};
	});
var $author$project$Api$Provider$EmbeddedReport$One$Periscope = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$One$ThoughtSpot = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$One$reportFromServiceName = function (string) {
	switch (string) {
		case 'periscope':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Api$Provider$EmbeddedReport$One$Periscope,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['signed_url']),
					$elm$json$Json$Decode$string));
		case 'thoughtspot':
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Api$Provider$EmbeddedReport$One$ThoughtSpot,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['report_id']),
					$elm$json$Json$Decode$string));
		default:
			return $elm$json$Json$Decode$fail('Invalid report type: ');
	}
};
var $author$project$Api$Provider$EmbeddedReport$One$recordDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Api$Provider$EmbeddedReport$One$Record,
	A2(
		$elm$json$Json$Decode$andThen,
		$author$project$Api$Provider$EmbeddedReport$One$reportFromServiceName,
		A2($elm$json$Json$Decode$field, 'service_name', $elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'description_link',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
var $author$project$Api$Provider$EmbeddedReport$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmbeddedReport$One$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$EmbeddedReport$Shared$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$EmbeddedReport$One$EmbeddedReport)));
var $author$project$Api$Provider$EmbeddedReport$embeddedReportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['embedded_reports']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$EmbeddedReport$embeddedReportPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$EmbeddedReport$embeddedReportsPath);
};
var $author$project$Api$Provider$EmbeddedReport$retrieveDefaults = {GP: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$EmbeddedReport$retrieveOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$EmbeddedReport$retrieveDefaults);
	var _v0 = options.GP;
	if (!_v0.$) {
		var filter = _v0.a;
		return _List_fromArray(
			[
				A2($author$project$Api$Param$list, 'practices_filter', filter)
			]);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$EmbeddedReport$retrieve = F4(
	function (apiClient, id_, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$EmbeddedReport$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$EmbeddedReport$retrieveOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$EmbeddedReport$embeddedReportPath(id_))));
	});
var $author$project$Pages$Reports$Custom$Id_String$init = F4(
	function (session, practice, shared, _v0) {
		var params = _v0.Vx;
		var model = {
			D5: shared.D5,
			FR: $author$project$Shared$isHintAdmin(shared),
			WF: practice,
			jB: $author$project$Api$Data$NotAsked,
			jO: $author$project$Api$Data$Loading,
			Yc: params.adR,
			sq: false,
			ZD: session
		};
		return _Utils_Tuple2(
			model,
			A4($author$project$Api$Provider$EmbeddedReport$retrieve, shared.D5, params.adR, $elm$core$Basics$identity, $author$project$Pages$Reports$Custom$Id_String$GotEmbeddedReport));
	});
var $author$project$Pages$Reports$Custom$Id_String$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Custom$Id_String$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotTokenRequested = {$: 1};
var $author$project$Ports$ThoughtSpot$onThoughtSpotTokenRequestPort = _Platform_incomingPort(
	'onThoughtSpotTokenRequestPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$ThoughtSpot$onTokenRequested = A2($elm$core$Basics$composeR, $elm$core$Basics$always, $author$project$Ports$ThoughtSpot$onThoughtSpotTokenRequestPort);
var $author$project$Pages$Reports$Custom$Id_String$subscriptions = function (_v0) {
	return $author$project$Ports$ThoughtSpot$onTokenRequested($author$project$Pages$Reports$Custom$Id_String$ThoughtSpotTokenRequested);
};
var $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$tokenDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['token']),
	$elm$json$Json$Decode$string);
var $author$project$Api$Provider$EmbeddedReport$managementGroupToken = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$EmbeddedReport$tokenDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['management_group_token']),
					$author$project$Api$Provider$EmbeddedReport$embeddedReportsPath)));
	});
var $author$project$Api$Provider$EmbeddedReport$token = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$EmbeddedReport$tokenDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['token']),
					$author$project$Api$Provider$EmbeddedReport$embeddedReportsPath)));
	});
var $author$project$Pages$Reports$Custom$Id_String$andRequestToken = function (model) {
	return _Utils_Tuple2(
		model,
		model.sq ? A2($author$project$Api$Provider$EmbeddedReport$managementGroupToken, model.D5, $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken) : A2($author$project$Api$Provider$EmbeddedReport$token, model.D5, $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken));
};
var $author$project$Ports$ThoughtSpot$authenticateThoughtSpotPort = _Platform_outgoingPort('authenticateThoughtSpotPort', $elm$json$Json$Encode$string);
var $author$project$Ports$ThoughtSpot$authenticate = $author$project$Ports$ThoughtSpot$authenticateThoughtSpotPort;
var $author$project$Ports$ThoughtSpot$ReportRecord = F2(
	function (id, email) {
		return {Oo: email, adR: id};
	});
var $author$project$Ports$ThoughtSpot$embedThoughtSpotPort = _Platform_outgoingPort(
	'embedThoughtSpotPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.Oo)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string($.adR))
				]));
	});
var $author$project$Ports$ThoughtSpot$embed = F2(
	function (id, email) {
		return $author$project$Ports$ThoughtSpot$embedThoughtSpotPort(
			A2($author$project$Ports$ThoughtSpot$ReportRecord, id, email));
	});
var $author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction = F3(
	function (action, reportId, model) {
		return function (email) {
			return A2(action, reportId, email);
		}(
			$author$project$Api$Platform$User$Shared$email(
				$author$project$Api$Platform$Session$One$user(model.ZD)));
	});
var $author$project$Api$Provider$EmbeddedReport$One$service = function (_v0) {
	var record = _v0.b;
	return record.ZA;
};
var $author$project$Pages$Reports$Custom$Id_String$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sq: bool}),
					function () {
						var _v1 = model.jO;
						if (_v1.$ === 3) {
							var report = _v1.a;
							var _v2 = $author$project$Api$Provider$EmbeddedReport$One$service(report);
							if (_v2.$ === 1) {
								var reportId = _v2.a;
								return A3($author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction, $author$project$Ports$ThoughtSpot$embed, reportId, model);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					_List_Nil);
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jO: response}),
					function () {
						if (response.$ === 3) {
							var report = response.a;
							var _v4 = $author$project$Api$Provider$EmbeddedReport$One$service(report);
							if (_v4.$ === 1) {
								var reportId = _v4.a;
								return A3($author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction, $author$project$Ports$ThoughtSpot$embed, reportId, model);
							} else {
								return $elm$core$Platform$Cmd$none;
							}
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					$author$project$OutMsg$handleErrorResponse(response));
			case 1:
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					$author$project$Pages$Reports$Custom$Id_String$andRequestToken(model));
			default:
				var dataReport = msg.a;
				return _Utils_Tuple3(
					model,
					function () {
						if (dataReport.$ === 3) {
							var token = dataReport.a;
							return $author$project$Ports$ThoughtSpot$authenticate(token);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}(),
					$author$project$OutMsg$handleErrorResponse(dataReport));
		}
	});
var $author$project$Api$Provider$EmbeddedReport$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$EmbeddedReport$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$EmbeddedReport$Shared$name(shared);
};
var $author$project$Pages$Reports$Custom$Id_String$viewPeriscope = F2(
	function (signedUrl, embeddedReport) {
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$EmbeddedReport$One$name(embeddedReport))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$iframe,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(signedUrl),
									A2($elm$html$Html$Attributes$attribute, 'width', '100%'),
									$elm$html$Html$Attributes$height(480),
									A2($elm$html$Html$Attributes$attribute, 'frameborder', '0')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Pages$Reports$Custom$Id_String$ToughtSpotTokenRequestAsManagementGroup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$EmbeddedReport$One$descriptionLink = function (_v0) {
	var record = _v0.b;
	return record.Ny;
};
var $author$project$Pages$Reports$Custom$Id_String$viewThoughtspot = F2(
	function (embeddedReport, model) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb2]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$Panel$title(
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$EmbeddedReport$One$name(embeddedReport))
										])),
									A2(
									$elm$core$Maybe$withDefault,
									$elm$html$Html$text(''),
									A2(
										$elm$core$Maybe$map,
										A2(
											$elm$core$Basics$composeR,
											function (link) {
												return _List_fromArray(
													[
														$elm$html$Html$text('Report description '),
														A3(
														$author$project$Ui$Link$externalHref,
														link,
														_List_fromArray(
															[$author$project$Ui$Link$targetBlank]),
														_List_fromArray(
															[
																$elm$html$Html$text('here')
															]))
													]);
											},
											$author$project$Ui$Element$view(
												_List_fromArray(
													[$author$project$Ui$Element$textMuted]))),
										$author$project$Api$Provider$EmbeddedReport$One$descriptionLink(embeddedReport)))
								])),
							model.FR ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceX2]),
							_List_fromArray(
								[
									$author$project$Ui$HinterOnly$icon(_List_Nil),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$inlineBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text('view as management group')
										])),
									$author$project$Ui$ToggleSwitch$view(
									_List_fromArray(
										[
											$author$project$Ui$ToggleSwitch$sm,
											$author$project$Ui$ToggleSwitch$on(model.sq),
											$author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Reports$Custom$Id_String$ToughtSpotTokenRequestAsManagementGroup)
										]))
								])) : $elm$html$Html$text('')
						]))
				]));
	});
var $author$project$Pages$Reports$Custom$Id_String$viewBody = function (model) {
	return A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				var _v0 = model.jO;
				if (_v0.$ === 3) {
					var embeddedReport = _v0.a;
					var _v1 = $author$project$Api$Provider$EmbeddedReport$One$service(embeddedReport);
					if (!_v1.$) {
						var signedUrl = _v1.a;
						return A2($author$project$Pages$Reports$Custom$Id_String$viewPeriscope, signedUrl, embeddedReport);
					} else {
						return A2($author$project$Pages$Reports$Custom$Id_String$viewThoughtspot, embeddedReport, model);
					}
				} else {
					return $elm$html$Html$text('');
				}
			}(),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('ts-embed'),
						A2($elm$html$Html$Attributes$style, 'margin-left', '-30px'),
						A2($elm$html$Html$Attributes$style, 'margin-right', '-30px'),
						A2($elm$html$Html$Attributes$style, 'min-height', 'calc(100vh - 55px - 60px - 60px)')
					]),
				_List_Nil)
			]));
};
var $author$project$Pages$Reports$Custom$Id_String$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$Reports$Custom$Id_String$viewBody(model)
			]),
		$G: 'Reports'
	};
};
var $author$project$Pages$Reports$Custom$Id_String$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Custom$Id_String$init, aer: $author$project$Pages$Reports$Custom$Id_String$load, agD: $author$project$Pages$Reports$Custom$Id_String$save, ahd: $author$project$Pages$Reports$Custom$Id_String$subscriptions, aaq: $author$project$Pages$Reports$Custom$Id_String$update, ahP: $author$project$Pages$Reports$Custom$Id_String$view});
var $author$project$Ports$ThoughtSpot$SearchRecord = function (email) {
	return {Oo: email};
};
var $author$project$Ports$ThoughtSpot$embedSearchThoughtSpotPort = _Platform_outgoingPort(
	'embedSearchThoughtSpotPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string($.Oo))
				]));
	});
var $author$project$Ports$ThoughtSpot$embedSearch = A2($elm$core$Basics$composeR, $author$project$Ports$ThoughtSpot$SearchRecord, $author$project$Ports$ThoughtSpot$embedSearchThoughtSpotPort);
var $author$project$Pages$Reports$Custom$New$init = F4(
	function (session, practice, shared, _v0) {
		return _Utils_Tuple2(
			{D5: shared.D5, WF: practice, ZD: session},
			$author$project$Ports$ThoughtSpot$embedSearch(
				$author$project$Api$Platform$User$Shared$email(
					$author$project$Api$Platform$Session$One$user(session))));
	});
var $author$project$Pages$Reports$Custom$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Custom$New$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Custom$New$ThoughtSpotTokenRequested = {$: 0};
var $author$project$Pages$Reports$Custom$New$subscriptions = function (_v0) {
	return $author$project$Ports$ThoughtSpot$onTokenRequested($author$project$Pages$Reports$Custom$New$ThoughtSpotTokenRequested);
};
var $author$project$Pages$Reports$Custom$New$ThoughtSpotGotToken = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Custom$New$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(
				model,
				A2($author$project$Api$Provider$EmbeddedReport$token, model.D5, $author$project$Pages$Reports$Custom$New$ThoughtSpotGotToken),
				_List_Nil);
		} else {
			var dataReport = msg.a;
			return _Utils_Tuple3(
				model,
				function () {
					if (dataReport.$ === 3) {
						var token = dataReport.a;
						return $author$project$Ports$ThoughtSpot$authenticate(token);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}(),
				_List_Nil);
		}
	});
var $author$project$Pages$Reports$Custom$New$viewBody = function (_v0) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id('ts-search-embed'),
					A2($elm$html$Html$Attributes$style, 'height', 'calc(100vh - 55px - 60px - 60px)')
				]),
			_List_Nil)
		]);
};
var $author$project$Pages$Reports$Custom$New$view = function (model) {
	return {
		e5: $author$project$Pages$Reports$Custom$New$viewBody(model),
		$G: 'Reports'
	};
};
var $author$project$Pages$Reports$Custom$New$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Custom$New$init, aer: $author$project$Pages$Reports$Custom$New$load, agD: $author$project$Pages$Reports$Custom$New$save, ahd: $author$project$Pages$Reports$Custom$New$subscriptions, aaq: $author$project$Pages$Reports$Custom$New$update, ahP: $author$project$Pages$Reports$Custom$New$view});
var $author$project$Pages$Reports$Dashboard$ActiveGrowthAttrition = 0;
var $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$Reports$Dashboard$DateRangeInputMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Utils$Date$toEndOfMonth = function (date) {
	var lastDayOfMonth = A2(
		$author$project$Utils$Date$daysInMonth,
		$justinmimbs$date$Date$year(date),
		$justinmimbs$date$Date$month(date));
	return A2($author$project$Utils$Date$changeDay, lastDayOfMonth, date);
};
var $author$project$Utils$Date$monthRange = function (referenceDate) {
	return _Utils_Tuple2(
		$author$project$Utils$Date$toBeginningOfMonth(referenceDate),
		$author$project$Utils$Date$toEndOfMonth(referenceDate));
};
var $author$project$Utils$Date$changeMonth = F2(
	function (month, date) {
		var year = $justinmimbs$date$Date$year(date);
		var day = $justinmimbs$date$Date$day(date);
		return A3($justinmimbs$date$Date$fromCalendarDate, year, month, day);
	});
var $author$project$Utils$Date$quarterRange = function (referenceDate) {
	var quarter = $justinmimbs$date$Date$quarter(referenceDate);
	return _Utils_Tuple2(
		$author$project$Utils$Date$toBeginningOfMonth(
			A2(
				$author$project$Utils$Date$changeMonth,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Utils$Date$monthFromInt((quarter * 3) - 3)),
				referenceDate)),
		$author$project$Utils$Date$toEndOfMonth(
			A2(
				$author$project$Utils$Date$changeMonth,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					$author$project$Utils$Date$monthFromInt(quarter * 3)),
				referenceDate)));
};
var $author$project$Utils$Date$trailingRange = F2(
	function (months_, referenceDate) {
		return _Utils_Tuple2(
			$author$project$Utils$Date$toEndOfMonth(
				A3($justinmimbs$date$Date$add, 1, -(months_ - 1), referenceDate)),
			$author$project$Utils$Date$toEndOfMonth(referenceDate));
	});
var $author$project$Pages$Reports$Dashboard$trailingMonthOption = F2(
	function (currentDate, months) {
		return function (_v0) {
			var start = _v0.a;
			var end = _v0.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'trailing_' + $elm$core$String$fromInt(months),
				'Trailing ' + ($elm$core$String$fromInt(months) + ' months'),
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			A2($author$project$Utils$Date$trailingRange, months, currentDate));
	});
var $author$project$Utils$Date$yearRange = function (referenceDate) {
	return _Utils_Tuple2(
		$author$project$Utils$Date$toBeginningOfMonth(
			A2($author$project$Utils$Date$changeMonth, 0, referenceDate)),
		$author$project$Utils$Date$toEndOfMonth(
			A2($author$project$Utils$Date$changeMonth, 11, referenceDate)));
};
var $author$project$Utils$Date$yearToDateRange = function (referenceDate) {
	return _Utils_Tuple2(
		A2(
			$author$project$Utils$Date$changeDay,
			1,
			A2($author$project$Utils$Date$changeMonth, 0, referenceDate)),
		$author$project$Utils$Date$toEndOfMonth(referenceDate));
};
var $author$project$Pages$Reports$Dashboard$additionalMonthOptions = function (currentDate) {
	return _List_fromArray(
		[
			function (_v0) {
			var start = _v0.a;
			var end = _v0.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'this_month',
				'This Month',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$monthRange(currentDate)),
			A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 3),
			A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 6),
			A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 12),
			function (item) {
			return _Utils_update(
				item,
				{aej: 'Trailing 24 months'});
		}(
			A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 24)),
			function (_v1) {
			var start = _v1.a;
			var end = _v1.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'this_quarter',
				'This Quarter',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$quarterRange(currentDate)),
			function (_v2) {
			var start = _v2.a;
			var end = _v2.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'last_quarter',
				'Last Quarter',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$quarterRange(
				A3($justinmimbs$date$Date$add, 1, -3, currentDate))),
			function (_v3) {
			var start = _v3.a;
			var end = _v3.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'ytd',
				'YTD',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$yearToDateRange(currentDate)),
			function (_v4) {
			var start = _v4.a;
			var end = _v4.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'this_year',
				'This Year',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$yearRange(currentDate)),
			function (_v5) {
			var start = _v5.a;
			var end = _v5.b;
			return A4(
				$author$project$Components$DateRangeInput$additionalItem,
				'last_year',
				'Last Year',
				$elm$core$Maybe$Just(start),
				$elm$core$Maybe$Just(end));
		}(
			$author$project$Utils$Date$yearRange(
				A3($justinmimbs$date$Date$add, 0, -1, currentDate)))
		]);
};
var $author$project$Pages$Reports$Dashboard$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{kT: $author$project$Pages$Reports$Dashboard$additionalMonthOptions, adD: start, Ga: 1, ahu: end});
	});
var $author$project$Pages$Reports$Dashboard$GotIssuedAmount = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Reports$Dashboard$headerFromData = function (stringCurrency) {
	return $author$project$Currency$fromInt(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(stringCurrency)));
};
var $author$project$Pages$Reports$Dashboard$issuedInvoicesParams = function (d) {
	return _Utils_update(
		d,
		{
			afy: $author$project$Api$Pagination$empty,
			ag7: $elm$core$Maybe$Just(
				_List_fromArray(
					['issued']))
		});
};
var $author$project$Api$Provider$Reports$CustomerInvoice$CustomerInvoice = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$CustomerInvoice$Record = function (id) {
	return function (invoiceNumber) {
		return function (dueDate) {
			return function (humanStatus) {
				return function (status) {
					return function (paymentScheduledOn) {
						return function (lastSentAt) {
							return function (paidAt) {
								return function (issuedTotalInCents) {
									return function (totalInCents) {
										return function (creditInCents) {
											return function (paidInCents) {
												return function (dueInCents) {
													return function (isPastDue) {
														return function (isPaymentScheduled) {
															return function (isCustomerViewable) {
																return function (securePdfInlineToken) {
																	return function (owner) {
																		return function (location) {
																			return {Ml: creditInCents, N1: dueDate, N2: dueInCents, QE: humanStatus, adR: id, Rq: invoiceNumber, RG: isCustomerViewable, RY: isPastDue, R_: isPaymentScheduled, Sn: issuedTotalInCents, SD: lastSentAt, aet: location, Vp: owner, Vt: paidAt, Vu: paidInCents, V2: paymentScheduledOn, Ze: securePdfInlineToken, ag7: status, $X: totalInCents};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Reports$Patient$One = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Patient$Patient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Patient$OneRecord = F5(
	function (id, name, email, phoneNumber, hipaaAuthorizationAccepted) {
		return {Oo: email, Qy: hipaaAuthorizationAccepted, adR: id, zh: name, Wh: phoneNumber};
	});
var $author$project$Api$Provider$Reports$Patient$oneRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'hipaa_authorization_accepted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'phone_number',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'email',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Patient$OneRecord))))));
var $author$project$Api$Provider$Reports$Patient$oneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Patient$oneRecordDecoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$CustomerInvoice$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'owner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Patient$oneDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'secure_pdf_inline_token',
			$author$project$Api$File$Token$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_customer_viewable',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_payment_scheduled',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_past_due',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'due_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'paid_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'credit_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'total_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'issued_total_in_cents',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'paid_at',
												$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'last_sent_at',
													$elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'payment_scheduled_on',
														$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'status',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'human_status',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'due_date',
																	$author$project$Utils$Date$decode,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'invoice_number',
																		$elm$json$Json$Decode$int,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$CustomerInvoice$Record))))))))))))))))))));
var $author$project$Api$Provider$Reports$CustomerInvoice$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$CustomerInvoice$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$CustomerInvoice$listDefaults = {
	JI: $elm$core$Maybe$Nothing,
	E9: $elm$core$Maybe$Nothing,
	aet: $elm$core$Maybe$Nothing,
	rj: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	ag1: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init),
	Hl: $elm$core$Maybe$Nothing,
	ag7: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$CustomerInvoice$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple2(options.Hl, options.E9);
						if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return _List_Nil;
						} else {
							var dates = A2(
								$elm$json$Json$Encode$encode,
								0,
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'gte',
											A2(
												$author$project$Utils$Encode$nullable,
												A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery),
												options.Hl)),
											_Utils_Tuple2(
											'lte',
											A2(
												$author$project$Utils$Encode$nullable,
												A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery),
												options.E9))
										])));
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'date', dates)
								]);
						}
					}(),
						function () {
						var _v3 = options.ag7;
						if (!_v3.$) {
							var list_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$list, 'status', list_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.JI;
						if (!_v4.$) {
							var bool = _v4.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Api$Param$string,
									'owner',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'autopay',
													$elm$json$Json$Encode$bool(bool))
												]))))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.rj;
						if (!_v5.$) {
							var string = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.aet;
						if (!_v6.$) {
							var string = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$CustomerInvoice$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'customer_invoices']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$CustomerInvoice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$CustomerInvoice$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$CustomerInvoice$listPath)));
	});
var $author$project$Api$Data$mapHeader = F3(
	function (headerName, func, data) {
		switch (data.$) {
			case 3:
				var headers = data.b;
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Api$Data$Failure(
						$author$project$Api$Data$Decoder('Header with name ' + (headerName + ' missing'))),
					A2(
						$elm$core$Maybe$map,
						function (header) {
							return A2(
								$author$project$Api$Data$Success,
								func(header),
								headers);
						},
						A2($elm$core$Dict$get, headerName, headers)));
			case 0:
				return $author$project$Api$Data$NotAsked;
			case 1:
				return $author$project$Api$Data$Loading;
			default:
				var error = data.a;
				return $author$project$Api$Data$Failure(error);
		}
	});
var $author$project$Pages$Reports$Dashboard$fetchIssued = function (client) {
	return A3(
		$author$project$Api$Provider$Reports$CustomerInvoice$list,
		client,
		$author$project$Pages$Reports$Dashboard$issuedInvoicesParams,
		A2(
			$elm$core$Basics$composeR,
			A2($author$project$Api$Data$mapHeader, 'x-total-billed-amount', $author$project$Pages$Reports$Dashboard$headerFromData),
			$author$project$Pages$Reports$Dashboard$GotIssuedAmount));
};
var $author$project$Pages$Reports$Dashboard$GotActiveMembersMetric = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Reports$Dashboard$GotEndedMembersMetric = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Reports$Dashboard$GotEnrolledMembersMetric = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Provider$Metric$Metric = $elm$core$Basics$identity;
var $author$project$Api$Provider$Metric$compareTick = F2(
	function (_v0, _v1) {
		var date1 = _v0.a;
		var date2 = _v1.a;
		return A2($justinmimbs$date$Date$compare, date1, date2);
	});
var $author$project$Api$Provider$Metric$monthDecoder = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult),
	A2(
		$elm$json$Json$Decode$map,
		function (s) {
			return s + '-01';
		},
		$elm$json$Json$Decode$string));
var $author$project$Api$Provider$Metric$tickDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['x']),
		$author$project$Api$Provider$Metric$monthDecoder),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['y']),
		A2($elm$json$Json$Decode$map, $elm$core$Basics$toFloat, $elm$json$Json$Decode$int)));
var $author$project$Api$Provider$Metric$metricDataDecoder = A3(
	$elm$json$Json$Decode$map2,
	$elm$core$Tuple$pair,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['key']),
		$elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$sortWith($author$project$Api$Provider$Metric$compareTick),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['values']),
			$elm$json$Json$Decode$list($author$project$Api$Provider$Metric$tickDecoder))));
var $author$project$Api$Provider$Metric$metricsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['data']),
		$elm$json$Json$Decode$list($author$project$Api$Provider$Metric$metricDataDecoder)));
var $author$project$Api$Provider$Metric$metricsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['metrics']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Metric$defaults = {Em: $elm$core$Maybe$Nothing, ab9: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, Fa: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, rj: $elm$core$Maybe$Nothing, GH: $elm$core$Maybe$Nothing, afS: $elm$core$Maybe$Nothing, Hl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Metric$optionalsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Metric$defaults);
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$date('start'),
				options.Hl),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$date('end'),
				options.E9),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('practitioner'),
				options.afS),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('location'),
				options.aet),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('location_group'),
				options.rj),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('company'),
				options.ab9),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('plan'),
				options.GH),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('engagement'),
				options.Fa),
				A2(
				$elm$core$Maybe$map,
				$author$project$Api$Param$string('breakout'),
				options.Em)
			]));
};
var $author$project$Api$Provider$Metric$activeMembers = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Metric$metricsDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Metric$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['active_members']),
						$author$project$Api$Provider$Metric$metricsPath))));
	});
var $author$project$Pages$Reports$Dashboard$breakoutToValue = function (breakout) {
	switch (breakout) {
		case 0:
			return 'plan';
		case 1:
			return 'practitioner';
		case 2:
			return 'location_group';
		case 3:
			return 'location';
		case 4:
			return 'employer';
		case 5:
			return 'employer-retail';
		case 6:
			return 'lead_source';
		default:
			return 'cancellation_reason';
	}
};
var $author$project$Pages$Reports$Dashboard$engagementToValue = function (engagement) {
	_v0$3:
	while (true) {
		if (!engagement.$) {
			switch (engagement.a) {
				case 1:
					var _v1 = engagement.a;
					return $elm$core$Maybe$Just('currently_engaged');
				case 2:
					var _v2 = engagement.a;
					return $elm$core$Maybe$Just('previously_engaged');
				case 3:
					var _v3 = engagement.a;
					return $elm$core$Maybe$Just('never_engaged');
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Api$Provider$Metric$totalEnrollments = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Metric$metricsDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Metric$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['enrolled_members']),
						$author$project$Api$Provider$Metric$metricsPath))));
	});
var $author$project$Api$Provider$Metric$totalTerminations = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Metric$metricsDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Metric$optionalsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['ended_members']),
						$author$project$Api$Provider$Metric$metricsPath))));
	});
var $author$project$Pages$Reports$Dashboard$fetchMetrics = function (_v0) {
	var apiClient = _v0.D5;
	var today = _v0.$P;
	var start = _v0.Hl;
	var end = _v0.E9;
	var practitionerId = _v0.WO;
	var locationId = _v0.S3;
	var locationGroupId = _v0.fW;
	var planId = _v0.afN;
	var companyId = _v0.ff;
	var engagement = _v0.Fa;
	var breakout = _v0.Em;
	var _v1 = _Utils_Tuple2(
		A2(
			$elm$core$Maybe$map,
			A2($author$project$Utils$DateWithDefault$toDate, today, 0),
			start),
		A2(
			$elm$core$Maybe$map,
			A2($author$project$Utils$DateWithDefault$toDate, today, 0),
			end));
	var startDate = _v1.a;
	var endDate = _v1.b;
	var optionals = function (d) {
		return _Utils_update(
			d,
			{
				Em: A2($elm$core$Maybe$map, $author$project$Pages$Reports$Dashboard$breakoutToValue, breakout),
				ab9: companyId,
				E9: endDate,
				Fa: $author$project$Pages$Reports$Dashboard$engagementToValue(engagement),
				aet: locationId,
				rj: locationGroupId,
				GH: planId,
				afS: practitionerId,
				Hl: startDate
			});
	};
	return $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				A3($author$project$Api$Provider$Metric$activeMembers, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotActiveMembersMetric),
				A3($author$project$Api$Provider$Metric$totalEnrollments, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotEnrolledMembersMetric),
				A3($author$project$Api$Provider$Metric$totalTerminations, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotEndedMembersMetric)
			]));
};
var $author$project$Pages$Reports$Dashboard$GotOutstanding30To59Amount = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses = _List_fromArray(
	['issued', 'sent', 'retrying']);
var $author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams = function (today) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, -30, today)),
				afy: $author$project$Api$Pagination$empty,
				Hl: $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, -59, today)),
				ag7: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
			});
	};
};
var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom30To59Days = F2(
	function (client, today) {
		return A3(
			$author$project$Api$Provider$Reports$CustomerInvoice$list,
			client,
			$author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams(today),
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData),
				$author$project$Pages$Reports$Dashboard$GotOutstanding30To59Amount));
	});
var $author$project$Pages$Reports$Dashboard$GotOutstanding60PlusAmount = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams = function (today) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, -60, today)),
				afy: $author$project$Api$Pagination$empty,
				ag7: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
			});
	};
};
var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom60PlusDays = F2(
	function (client, today) {
		return A3(
			$author$project$Api$Provider$Reports$CustomerInvoice$list,
			client,
			$author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams(today),
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData),
				$author$project$Pages$Reports$Dashboard$GotOutstanding60PlusAmount));
	});
var $author$project$Pages$Reports$Dashboard$GotOutstandingLt30Amount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams = function (today) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: $elm$core$Maybe$Just(today),
				afy: $author$project$Api$Pagination$empty,
				Hl: $elm$core$Maybe$Just(
					A3($justinmimbs$date$Date$add, 3, -29, today)),
				ag7: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
			});
	};
};
var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFromLessThan30Days = F2(
	function (client, today) {
		return A3(
			$author$project$Api$Provider$Reports$CustomerInvoice$list,
			client,
			$author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams(today),
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData),
				$author$project$Pages$Reports$Dashboard$GotOutstandingLt30Amount));
	});
var $author$project$Pages$Reports$Dashboard$initMetrics = {pk: $author$project$Api$Data$Loading, qw: $author$project$Api$Data$Loading, qx: $author$project$Api$Data$Loading};
var $author$project$Pages$Reports$Dashboard$AllEngagements = 0;
var $author$project$Pages$Reports$Dashboard$CurrentlyEngaged = 1;
var $author$project$Pages$Reports$Dashboard$NeverEngaged = 3;
var $author$project$Pages$Reports$Dashboard$PreviouslyEngaged = 2;
var $author$project$Pages$Reports$Dashboard$valueToEngagement = function (stringEngagement) {
	switch (stringEngagement) {
		case 'all':
			return $elm$core$Maybe$Just(0);
		case 'currently_engaged':
			return $elm$core$Maybe$Just(1);
		case 'previously_engaged':
			return $elm$core$Maybe$Just(2);
		case 'never_engaged':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Just(0);
	}
};
var $author$project$Pages$Reports$Dashboard$init = F4(
	function (session, practice, _v0, _v1) {
		var apiClient = _v0.D5;
		var currentDate = _v0.cO;
		var query = _v1.Bi;
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var planId = A2($elm$core$Dict$get, 'plan', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var engagement = $author$project$Pages$Reports$Dashboard$valueToEngagement(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Dict$get, 'engagement', query)));
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var _v2 = A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId);
		var planResourceFilter = _v2.a;
		var planResourceFilterCmd = _v2.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = _Utils_Tuple2(
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
				start),
			A2(
				$elm$core$Maybe$map,
				A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
				end));
		var startDate = _v5.a;
		var endDate = _v5.b;
		var _v6 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2($author$project$Pages$Reports$Dashboard$dateRangeInputSettings, startDate, endDate));
		var dateRangeInput = _v6.a;
		var dateRangeInputCmd = _v6.b;
		var _v7 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v7.a;
		var companyResourceFilterCmd = _v7.b;
		var model = {D5: apiClient, Em: $elm$core$Maybe$Nothing, ff: companyId, pV: companyResourceFilter, h3: dateRangeInput, E9: end, Fa: engagement, b7: groupLocationAndPractitionerFilters, yn: $author$project$Api$Data$Loading, fW: locationGroupId, S3: locationId, ab: $author$project$Pages$Reports$Dashboard$initMetrics, z0: $author$project$Api$Data$Loading, z1: $author$project$Api$Data$Loading, z2: $author$project$Api$Data$Loading, r0: $elm$core$Maybe$Nothing, afN: planId, jw: planResourceFilter, WF: practice, WO: practitionerId, ZD: session, sQ: 0, Hl: start, $P: currentDate};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFromLessThan30Days, apiClient, currentDate),
						A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom30To59Days, apiClient, currentDate),
						A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom60PlusDays, apiClient, currentDate),
						$author$project$Pages$Reports$Dashboard$fetchIssued(apiClient),
						$author$project$Pages$Reports$Dashboard$fetchMetrics(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg, companyResourceFilterCmd)
					])));
	});
var $author$project$Pages$Reports$Dashboard$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Dashboard$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Dashboard$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Reports$Dashboard$Metrics = F3(
	function (activeMembers, enrolledMembers, endedMembers) {
		return {pk: activeMembers, qw: endedMembers, qx: enrolledMembers};
	});
var $author$project$Api$Provider$Metric$datesRange = function (_v0) {
	var data = _v0;
	return _Utils_Tuple2(
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$elm$core$List$head(data)))),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$List$head,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$reverse,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(data))))));
};
var $author$project$Api$Provider$Metric$filter = F2(
	function (filterFunc, _v0) {
		var metricData = _v0;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var key = _v1.a;
				var data = _v1.b;
				return _Utils_Tuple2(
					key,
					A2($elm$core$List$filter, filterFunc, data));
			},
			metricData);
	});
var $author$project$Api$Provider$Metric$filterByMonth = F2(
	function (month, metric) {
		return A2(
			$author$project$Api$Provider$Metric$filter,
			function (_v0) {
				var date = _v0.a;
				return _Utils_eq(date, month);
			},
			metric);
	});
var $author$project$Api$Provider$Metric$values = function (_v0) {
	var data = _v0;
	return A2(
		$elm$core$List$map,
		function (_v1) {
			var ticks = _v1.b;
			return A2($elm$core$List$map, $elm$core$Tuple$second, ticks);
		},
		data);
};
var $author$project$Api$Provider$Metric$total = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Metric$values,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map($elm$core$List$sum),
		$elm$core$List$sum));
var $author$project$Pages$Reports$Dashboard$buildPeriodSummary = F4(
	function (today, active, ended, enrolled) {
		var _v0 = A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Maybe$withDefault(
				$author$project$Utils$Date$toEndOfMonth(today)),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$withDefault(
					$author$project$Utils$Date$toBeginningOfMonth(today)),
				$author$project$Api$Provider$Metric$datesRange(active)));
		var firstMonth = _v0.a;
		var lastMonth = _v0.b;
		var activeDuringFirstMonth = $elm$core$Basics$round(
			$author$project$Api$Provider$Metric$total(
				A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, active)));
		var endedDuringFirstMonth = $elm$core$Basics$round(
			$author$project$Api$Provider$Metric$total(
				A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, ended)));
		var enrolledDuringFirstMonth = $elm$core$Basics$round(
			$author$project$Api$Provider$Metric$total(
				A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, enrolled)));
		var activeDuringLastMonth = $elm$core$Basics$round(
			$author$project$Api$Provider$Metric$total(
				A2($author$project$Api$Provider$Metric$filterByMonth, lastMonth, active)));
		return {
			tG: activeDuringLastMonth,
			tH: (activeDuringFirstMonth - enrolledDuringFirstMonth) + endedDuringFirstMonth,
			Fb: $elm$core$Basics$round(
				$author$project$Api$Provider$Metric$total(enrolled)),
			Hv: $elm$core$Basics$round(
				$author$project$Api$Provider$Metric$total(ended))
		};
	});
var $author$project$Pages$Reports$Dashboard$andBuildSummary = function (original) {
	var model = original.a;
	var metrics = model.ab;
	var cmds = original.b;
	var outMsgs = original.c;
	var _v0 = _Utils_Tuple3(metrics.pk, metrics.qw, metrics.qx);
	if (((_v0.a.$ === 3) && (_v0.b.$ === 3)) && (_v0.c.$ === 3)) {
		var _v1 = _v0.a;
		var active = _v1.a;
		var _v2 = _v0.b;
		var ended = _v2.a;
		var _v3 = _v0.c;
		var enrolled = _v3.a;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					r0: $elm$core$Maybe$Just(
						A4($author$project$Pages$Reports$Dashboard$buildPeriodSummary, model.$P, active, ended, enrolled))
				}),
			cmds,
			outMsgs);
	} else {
		return original;
	}
};
var $author$project$Pages$Reports$Dashboard$isForbidden = function (data) {
	if (((data.$ === 2) && (data.a.$ === 6)) && (data.a.a === 403)) {
		var _v1 = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Pages$Reports$Dashboard$andHandleAmountResponse = F2(
	function (amount, model) {
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			$author$project$Pages$Reports$Dashboard$isForbidden(amount) ? _List_Nil : $author$project$OutMsg$handleErrorResponse(amount));
	});
var $author$project$Pages$Reports$Dashboard$activeColor = 'rgba(103, 173, 226, 0.45)';
var $author$project$Ports$DashboardChart$YAxis$Left = 1;
var $author$project$Ports$DashboardChart$YAxis$YAxis = $elm$core$Basics$identity;
var $author$project$Ports$DashboardChart$YAxis$axis = function (attributes) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (attribute, record) {
				switch (attribute.$) {
					case 0:
						var id_ = attribute.a;
						return _Utils_update(
							record,
							{adR: id_});
					case 1:
						var position = attribute.a;
						return _Utils_update(
							record,
							{Wz: position});
					case 2:
						var label_ = attribute.a;
						return _Utils_update(
							record,
							{
								aej: $elm$core$Maybe$Just(label_)
							});
					case 3:
						var suffix = attribute.a;
						return _Utils_update(
							record,
							{
								Ds: $elm$core$Maybe$Just(suffix)
							});
					default:
						var stacked_ = attribute.a;
						return _Utils_update(
							record,
							{Cp: stacked_});
				}
			}),
		{Ef: true, adR: '', aej: $elm$core$Maybe$Nothing, Wz: 1, Cp: false, Ds: $elm$core$Maybe$Nothing},
		attributes);
};
var $author$project$Ports$DashboardChart$Chart = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ports$DashboardChart$chartAttributesToRecord = function (attributes) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (attr, record) {
				if (!attr.$) {
					var labels_ = attr.a;
					return _Utils_update(
						record,
						{yt: labels_});
				} else {
					var axis = attr.a;
					return _Utils_update(
						record,
						{
							tB: _Utils_ap(
								record.tB,
								_List_fromArray(
									[axis]))
						});
				}
			}),
		{yt: _List_Nil, tB: _List_Nil},
		attributes);
};
var $author$project$Ports$DashboardChart$chart = F2(
	function (attributes, datasets) {
		return A2(
			$author$project$Ports$DashboardChart$Chart,
			$author$project$Ports$DashboardChart$chartAttributesToRecord(attributes),
			datasets);
	});
var $author$project$Ports$DashboardChart$DataSet$Color = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$ColorConfig = F4(
	function (backgroundColor, borderColor, pointBackgroundColor, pointBorderColor) {
		return {JQ: backgroundColor, J7: borderColor, Wv: pointBackgroundColor, Ww: pointBorderColor};
	});
var $author$project$Ports$DashboardChart$DataSet$color = function (rgbaString) {
	return $author$project$Ports$DashboardChart$DataSet$Color(
		$elm$core$Maybe$Just(
			A4($author$project$Ports$DashboardChart$DataSet$ColorConfig, rgbaString, rgbaString, rgbaString, rgbaString)));
};
var $author$project$Ports$DashboardChart$DataSet$colorAuto = $author$project$Ports$DashboardChart$DataSet$Color($elm$core$Maybe$Nothing);
var $author$project$Api$Provider$Metric$months = function (_v0) {
	var data = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$map($elm$core$Tuple$first),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Tuple$second,
				$elm$core$List$head(data))));
};
var $author$project$Api$Provider$Metric$combine = F2(
	function (key, metric) {
		var months_ = $author$project$Api$Provider$Metric$months(metric);
		return $elm$core$List$singleton(
			A2(
				$elm$core$Tuple$pair,
				key,
				A3(
					$elm$core$List$map2,
					F2(
						function (date, ticks) {
							return _Utils_Tuple2(date, ticks);
						}),
					months_,
					A3(
						$elm$core$List$foldl,
						$elm$core$List$map2(
							F2(
								function (y, accY) {
									return y + accY;
								})),
						A2(
							$elm$core$List$repeat,
							$elm$core$List$length(months_),
							0),
						$author$project$Api$Provider$Metric$values(metric)))));
	});
var $author$project$Ports$DashboardChart$DataSet$Bar = 1;
var $author$project$Ports$DashboardChart$DataSet$DataSet = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ports$DashboardChart$DataSet$dataset = F2(
	function (attributes, data) {
		return A2(
			$author$project$Ports$DashboardChart$DataSet$DataSet,
			data,
			A3(
				$elm$core$List$foldl,
				F2(
					function (attribute, record) {
						switch (attribute.$) {
							case 0:
								var axisId = attribute.a;
								return _Utils_update(
									record,
									{
										vC: $elm$core$Maybe$Just(axisId)
									});
							case 2:
								var type_ = attribute.a;
								return _Utils_update(
									record,
									{ahI: type_});
							case 1:
								var string = attribute.a;
								return _Utils_update(
									record,
									{
										aej: $elm$core$Maybe$Just(string)
									});
							case 3:
								var maybeColorConfig = attribute.a;
								return _Utils_update(
									record,
									{hM: maybeColorConfig});
							default:
								var suffix_ = attribute.a;
								return _Utils_update(
									record,
									{
										_8: $elm$core$Maybe$Just(suffix_)
									});
						}
					}),
				{vC: $elm$core$Maybe$Nothing, hM: $elm$core$Maybe$Nothing, aej: $elm$core$Maybe$Nothing, _8: $elm$core$Maybe$Nothing, ahI: 1},
				attributes));
	});
var $author$project$Pages$Reports$Dashboard$enrollmentsColor = 'rgba(75, 192, 192, 1)';
var $author$project$Api$Provider$Metric$fromList = F2(
	function (key, tick) {
		return $elm$core$List$singleton(
			_Utils_Tuple2(key, tick));
	});
var $author$project$Pages$Reports$Dashboard$growthAndAttritionMetric = F3(
	function (active, ended, enrolled) {
		var months = $author$project$Api$Provider$Metric$months(active);
		return A3(
			$elm$core$Tuple$mapBoth,
			$author$project$Api$Provider$Metric$fromList('growth'),
			$author$project$Api$Provider$Metric$fromList('attrition'),
			A3(
				$elm$core$List$foldl,
				F2(
					function (month, _v0) {
						var growth = _v0.a;
						var attrition = _v0.b;
						var terminations = $author$project$Api$Provider$Metric$total(
							A2($author$project$Api$Provider$Metric$filterByMonth, month, ended));
						var enrollments = $author$project$Api$Provider$Metric$total(
							A2($author$project$Api$Provider$Metric$filterByMonth, month, enrolled));
						var activeAtEnd = $author$project$Api$Provider$Metric$total(
							A2($author$project$Api$Provider$Metric$filterByMonth, month, active));
						var activeAtBeginning = (activeAtEnd - enrollments) + terminations;
						return _Utils_Tuple2(
							_Utils_ap(
								growth,
								_List_fromArray(
									[
										_Utils_Tuple2(
										month,
										(!activeAtBeginning) ? 0 : A2($myrho$elm_round$Round$roundNum, 2, (enrollments * 100) / activeAtBeginning))
									])),
							_Utils_ap(
								attrition,
								_List_fromArray(
									[
										_Utils_Tuple2(
										month,
										(!activeAtBeginning) ? 0 : A2($myrho$elm_round$Round$roundNum, 2, (terminations * 100) / activeAtBeginning))
									])));
					}),
				_Utils_Tuple2(_List_Nil, _List_Nil),
				months));
	});
var $author$project$Ports$DashboardChart$YAxis$Id = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$id = $author$project$Ports$DashboardChart$YAxis$Id;
var $author$project$Ports$DashboardChart$DataSet$Label = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$label = $author$project$Ports$DashboardChart$DataSet$Label;
var $author$project$Ports$DashboardChart$YAxis$Label = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$label = $author$project$Ports$DashboardChart$YAxis$Label;
var $author$project$Ports$DashboardChart$XLabels = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$DashboardChart$labels = $author$project$Ports$DashboardChart$XLabels;
var $author$project$Ports$DashboardChart$YAxis$Position = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$left = $author$project$Ports$DashboardChart$YAxis$Position(1);
var $author$project$Ports$DashboardChart$DataSet$ChartType = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$Line = 0;
var $author$project$Ports$DashboardChart$DataSet$line = $author$project$Ports$DashboardChart$DataSet$ChartType(0);
var $author$project$Api$Provider$Metric$map = F2(
	function (func, _v0) {
		var data = _v0;
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var key = _v1.a;
				var ticks = _v1.b;
				return func(
					_Utils_Tuple2(
						key,
						A2($elm$core$List$map, $elm$core$Tuple$second, ticks)));
			},
			data);
	});
var $author$project$Ports$DashboardChart$DataSet$encode = function (_v0) {
	var data = _v0.a;
	var record = _v0.b;
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'data',
						A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, data))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('label'),
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.aej)),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string(
							function () {
								var _v1 = record.ahI;
								if (_v1 === 1) {
									return 'bar';
								} else {
									return 'line';
								}
							}()))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('yAxisID'),
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.vC)),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'fill',
						$elm$json$Json$Encode$bool(
							function () {
								var _v2 = record.ahI;
								if (_v2 === 1) {
									return true;
								} else {
									return false;
								}
							}()))),
					$elm$core$Maybe$Just(
					_Utils_Tuple2(
						'tension',
						$elm$json$Json$Encode$float(0.4))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('backgroundColor'),
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.JQ;
							},
							record.hM))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('borderColor'),
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.J7;
							},
							record.hM))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('pointBackgroundColor'),
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Wv;
							},
							record.hM))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('pointBorderColor'),
					A2(
						$elm$core$Maybe$map,
						$elm$json$Json$Encode$string,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.Ww;
							},
							record.hM))),
					A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$pair('suffix'),
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record._8))
				])));
};
var $author$project$Ports$DashboardChart$YAxis$encode = function (_v0) {
	var record = _v0;
	return _Utils_Tuple2(
		record.adR,
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(record.adR)),
					_Utils_Tuple2(
					'axis',
					$elm$json$Json$Encode$string('y')),
					_Utils_Tuple2(
					'display',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'stacked',
					$elm$json$Json$Encode$bool(record.Cp)),
					_Utils_Tuple2(
					'position',
					$elm$json$Json$Encode$string(
						function () {
							var _v1 = record.Wz;
							if (!_v1) {
								return 'right';
							} else {
								return 'left';
							}
						}())),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string('linear')),
					_Utils_Tuple2(
					'beginAtZero',
					$elm$json$Json$Encode$bool(record.Ef)),
					_Utils_Tuple2(
					'suggestedMax',
					$elm$json$Json$Encode$int(20)),
					_Utils_Tuple2(
					'ticks',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'suffix',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.Ds)))
							]))),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'display',
								$elm$json$Json$Encode$bool(true)),
								_Utils_Tuple2(
								'text',
								A2(
									$elm$core$Maybe$withDefault,
									$elm$json$Json$Encode$null,
									A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.aej))),
								_Utils_Tuple2(
								'fontSize',
								$elm$json$Json$Encode$int(16))
							])))
				])));
};
var $author$project$Ports$DashboardChart$DataSet$isEmpty = function (_v0) {
	var data = _v0.a;
	return A2(
		$elm$core$List$all,
		function (val) {
			return !val;
		},
		data);
};
var $author$project$Ports$DashboardChart$encode = function (_v0) {
	var record = _v0.a;
	var datasets = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'datasets',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Ports$DashboardChart$DataSet$encode,
					A2($elm$core$List$all, $author$project$Ports$DashboardChart$DataSet$isEmpty, datasets) ? _List_Nil : datasets)),
				_Utils_Tuple2(
				'labels',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, record.yt)),
				_Utils_Tuple2(
				'options',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'plugins',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'tooltip',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'mode',
													$elm$json$Json$Encode$string('index'))
												])))
									]))),
							_Utils_Tuple2(
							'scales',
							$elm$json$Json$Encode$object(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										'x',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'axis',
													$elm$json$Json$Encode$string('x')),
													_Utils_Tuple2(
													'id',
													$elm$json$Json$Encode$string('x')),
													_Utils_Tuple2(
													'stacked',
													$elm$json$Json$Encode$bool(true))
												]))),
									A2($elm$core$List$map, $author$project$Ports$DashboardChart$YAxis$encode, record.tB))))
						])))
			]));
};
var $author$project$Ports$DashboardChart$mountDashboardChart = _Platform_outgoingPort('mountDashboardChart', $elm$core$Basics$identity);
var $author$project$Ports$DashboardChart$mount = A2($elm$core$Basics$composeR, $author$project$Ports$DashboardChart$encode, $author$project$Ports$DashboardChart$mountDashboardChart);
var $author$project$Ports$DashboardChart$YAxis$Right = 0;
var $author$project$Ports$DashboardChart$YAxis$right = $author$project$Ports$DashboardChart$YAxis$Position(0);
var $author$project$Ports$DashboardChart$YAxis$Stacked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$stacked = $author$project$Ports$DashboardChart$YAxis$Stacked(true);
var $author$project$Ports$DashboardChart$DataSet$Suffix = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$suffix = $author$project$Ports$DashboardChart$DataSet$Suffix;
var $author$project$Pages$Reports$Dashboard$terminationsColor = 'rgba(255, 99, 132, 1)';
var $author$project$Ports$DashboardChart$YAxis$TickSuffix = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ports$DashboardChart$YAxis$tickSuffix = $author$project$Ports$DashboardChart$YAxis$TickSuffix;
var $author$project$Ports$DashboardChart$YAxis = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ports$DashboardChart$yAxis = $author$project$Ports$DashboardChart$YAxis;
var $author$project$Ports$DashboardChart$DataSet$YAxisId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ports$DashboardChart$DataSet$yAxis = $author$project$Ports$DashboardChart$DataSet$YAxisId;
var $author$project$Pages$Reports$Dashboard$andRenderChart = function (original) {
	var model = original.a;
	var metrics = model.ab;
	var showing = model.sQ;
	var breakout = model.Em;
	var cmds = original.b;
	var outMsgs = original.c;
	var _v0 = _Utils_Tuple3(metrics.pk, metrics.qw, metrics.qx);
	if (((_v0.a.$ === 3) && (_v0.b.$ === 3)) && (_v0.c.$ === 3)) {
		var _v1 = _v0.a;
		var active = _v1.a;
		var _v2 = _v0.b;
		var ended = _v2.a;
		var _v3 = _v0.c;
		var enrolled = _v3.a;
		var monthsLabels = A2(
			$elm$core$List$map,
			function (date) {
				return A2($justinmimbs$date$Date$format, 'MMM yyyy', date);
			},
			$author$project$Api$Provider$Metric$months(active));
		var ifBrokenOut = F2(
			function (_this, _default) {
				return A2(
					$elm$core$Maybe$withDefault,
					_default,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(_this),
						breakout));
			});
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmds,
						function () {
						switch (showing) {
							case 0:
								return $author$project$Ports$DashboardChart$mount(
									A2(
										$author$project$Ports$DashboardChart$chart,
										_List_fromArray(
											[
												$author$project$Ports$DashboardChart$labels(monthsLabels),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-1'),
															$author$project$Ports$DashboardChart$YAxis$left,
															$author$project$Ports$DashboardChart$YAxis$label('Active Members'),
															$author$project$Ports$DashboardChart$YAxis$stacked
														]))),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-2'),
															$author$project$Ports$DashboardChart$YAxis$right,
															$author$project$Ports$DashboardChart$YAxis$label('Growth / Attrition'),
															$author$project$Ports$DashboardChart$YAxis$tickSuffix('%')
														])))
											]),
										$elm$core$List$concat(
											function (_v5) {
												var growth = _v5.a;
												var attrition = _v5.b;
												return _List_fromArray(
													[
														A2(
														$author$project$Api$Provider$Metric$map,
														function (_v6) {
															var key = _v6.a;
															var values = _v6.b;
															return A2(
																$author$project$Ports$DashboardChart$DataSet$dataset,
																_List_fromArray(
																	[
																		$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor),
																		$author$project$Ports$DashboardChart$DataSet$yAxis('y-1'),
																		$author$project$Ports$DashboardChart$DataSet$label(
																		A2(ifBrokenOut, key, 'Active')),
																		A2(
																		ifBrokenOut,
																		$author$project$Ports$DashboardChart$DataSet$colorAuto,
																		$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor))
																	]),
																values);
														},
														active),
														A2(
														$author$project$Api$Provider$Metric$map,
														function (_v7) {
															var key = _v7.a;
															var values = _v7.b;
															return A2(
																$author$project$Ports$DashboardChart$DataSet$dataset,
																_List_fromArray(
																	[
																		$author$project$Ports$DashboardChart$DataSet$yAxis('y-2'),
																		$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$enrollmentsColor),
																		$author$project$Ports$DashboardChart$DataSet$line,
																		$author$project$Ports$DashboardChart$DataSet$label(key),
																		$author$project$Ports$DashboardChart$DataSet$suffix('%')
																	]),
																values);
														},
														A2($author$project$Api$Provider$Metric$combine, 'Enrollments', growth)),
														A2(
														$author$project$Api$Provider$Metric$map,
														function (_v8) {
															var key = _v8.a;
															var values = _v8.b;
															return A2(
																$author$project$Ports$DashboardChart$DataSet$dataset,
																_List_fromArray(
																	[
																		$author$project$Ports$DashboardChart$DataSet$yAxis('y-2'),
																		$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$terminationsColor),
																		$author$project$Ports$DashboardChart$DataSet$line,
																		$author$project$Ports$DashboardChart$DataSet$label(key),
																		$author$project$Ports$DashboardChart$DataSet$suffix('%')
																	]),
																values);
														},
														A2($author$project$Api$Provider$Metric$combine, 'Terminations', attrition))
													]);
											}(
												A3($author$project$Pages$Reports$Dashboard$growthAndAttritionMetric, active, ended, enrolled)))));
							case 1:
								return $author$project$Ports$DashboardChart$mount(
									A2(
										$author$project$Ports$DashboardChart$chart,
										_List_fromArray(
											[
												$author$project$Ports$DashboardChart$labels(monthsLabels),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-1'),
															$author$project$Ports$DashboardChart$YAxis$left,
															$author$project$Ports$DashboardChart$YAxis$label('Active Members'),
															$author$project$Ports$DashboardChart$YAxis$stacked
														])))
											]),
										A2(
											$author$project$Api$Provider$Metric$map,
											function (_v9) {
												var key = _v9.a;
												var values = _v9.b;
												return A2(
													$author$project$Ports$DashboardChart$DataSet$dataset,
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor),
															$author$project$Ports$DashboardChart$DataSet$label(
															A2(ifBrokenOut, key, 'Active')),
															A2(
															ifBrokenOut,
															$author$project$Ports$DashboardChart$DataSet$colorAuto,
															$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor))
														]),
													values);
											},
											active)));
							case 2:
								return $author$project$Ports$DashboardChart$mount(
									A2(
										$author$project$Ports$DashboardChart$chart,
										_List_fromArray(
											[
												$author$project$Ports$DashboardChart$labels(monthsLabels),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-1'),
															$author$project$Ports$DashboardChart$YAxis$left,
															$author$project$Ports$DashboardChart$YAxis$label('Terminations'),
															$author$project$Ports$DashboardChart$YAxis$stacked
														])))
											]),
										A2(
											$author$project$Api$Provider$Metric$map,
											function (_v10) {
												var key = _v10.a;
												var values = _v10.b;
												return A2(
													$author$project$Ports$DashboardChart$DataSet$dataset,
													_List_fromArray(
														[
															A2(
															ifBrokenOut,
															$author$project$Ports$DashboardChart$DataSet$colorAuto,
															$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$terminationsColor)),
															$author$project$Ports$DashboardChart$DataSet$label(
															A2(ifBrokenOut, key, 'Terminations'))
														]),
													values);
											},
											ended)));
							default:
								return $author$project$Ports$DashboardChart$mount(
									A2(
										$author$project$Ports$DashboardChart$chart,
										_List_fromArray(
											[
												$author$project$Ports$DashboardChart$labels(monthsLabels),
												$author$project$Ports$DashboardChart$yAxis(
												$author$project$Ports$DashboardChart$YAxis$axis(
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$YAxis$id('y-1'),
															$author$project$Ports$DashboardChart$YAxis$left,
															$author$project$Ports$DashboardChart$YAxis$label('Enrollments'),
															$author$project$Ports$DashboardChart$YAxis$stacked
														])))
											]),
										A2(
											$author$project$Api$Provider$Metric$map,
											function (_v11) {
												var key = _v11.a;
												var values = _v11.b;
												return A2(
													$author$project$Ports$DashboardChart$DataSet$dataset,
													_List_fromArray(
														[
															$author$project$Ports$DashboardChart$DataSet$label(
															A2(ifBrokenOut, key, 'Enrollments')),
															A2(
															ifBrokenOut,
															$author$project$Ports$DashboardChart$DataSet$colorAuto,
															$author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$enrollmentsColor))
														]),
													values);
											},
											enrolled)));
						}
					}()
					])),
			outMsgs);
	} else {
		return original;
	}
};
var $author$project$Pages$Reports$Dashboard$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.$P, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.$P, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practitioner'),
			model.WO),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('plan'),
			model.afN),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('engagement'),
			$author$project$Pages$Reports$Dashboard$engagementToValue(model.Fa)),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.ff)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Dashboard)
				]),
			A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
};
var $author$project$Pages$Reports$Dashboard$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var amount = msg.a;
				return A2(
					$author$project$Pages$Reports$Dashboard$andHandleAmountResponse,
					amount,
					_Utils_update(
						model,
						{z2: amount}));
			case 1:
				var amount = msg.a;
				return A2(
					$author$project$Pages$Reports$Dashboard$andHandleAmountResponse,
					amount,
					_Utils_update(
						model,
						{z0: amount}));
			case 2:
				var amount = msg.a;
				return A2(
					$author$project$Pages$Reports$Dashboard$andHandleAmountResponse,
					amount,
					_Utils_update(
						model,
						{z1: amount}));
			case 3:
				var amount = msg.a;
				return A2(
					$author$project$Pages$Reports$Dashboard$andHandleAmountResponse,
					amount,
					_Utils_update(
						model,
						{yn: amount}));
			case 5:
				var metric = msg.a;
				return function (metrics) {
					return $author$project$Pages$Reports$Dashboard$andRenderChart(
						$author$project$Pages$Reports$Dashboard$andBuildSummary(
							_Utils_Tuple3(
								_Utils_update(
									model,
									{ab: metrics}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(metric))));
				}(
					function (metrics) {
						return _Utils_update(
							metrics,
							{pk: metric});
					}(model.ab));
			case 6:
				var metric = msg.a;
				return function (metrics) {
					return $author$project$Pages$Reports$Dashboard$andRenderChart(
						$author$project$Pages$Reports$Dashboard$andBuildSummary(
							_Utils_Tuple3(
								_Utils_update(
									model,
									{ab: metrics}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(metric))));
				}(
					function (metrics) {
						return _Utils_update(
							metrics,
							{qx: metric});
					}(model.ab));
			case 7:
				var metric = msg.a;
				return function (metrics) {
					return $author$project$Pages$Reports$Dashboard$andRenderChart(
						$author$project$Pages$Reports$Dashboard$andBuildSummary(
							_Utils_Tuple3(
								_Utils_update(
									model,
									{ab: metrics}),
								$elm$core$Platform$Cmd$none,
								$author$project$OutMsg$handleErrorResponse(metric))));
				}(
					function (metrics) {
						return _Utils_update(
							metrics,
							{qw: metric});
					}(model.ab));
			case 8:
				var showing = msg.a;
				return $author$project$Pages$Reports$Dashboard$andRenderChart(
					_Utils_Tuple3(
						_Utils_update(
							model,
							{sQ: showing}),
						$elm$core$Platform$Cmd$none,
						_List_Nil));
			case 9:
				var breakout = msg.a;
				return function (newModel) {
					return _Utils_Tuple3(
						newModel,
						$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
						_List_Nil);
				}(
					_Utils_update(
						model,
						{Em: breakout, ab: $author$project$Pages$Reports$Dashboard$initMetrics}));
			case 10:
				var engagement = msg.a;
				return function (newModel) {
					return _Utils_Tuple3(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
									$author$project$Pages$Reports$Dashboard$updateUrl(newModel)
								])),
						_List_Nil);
				}(
					_Utils_update(
						model,
						{Fa: engagement, ab: $author$project$Pages$Reports$Dashboard$initMetrics}));
			case 4:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								ab: A3($author$project$Pages$Reports$Dashboard$Metrics, $author$project$Api$Data$Loading, $author$project$Api$Data$Loading, $author$project$Api$Data$Loading),
								r0: $elm$core$Maybe$Nothing,
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$DateRangeInputMsg, subCmd),
								(_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? $elm$core$Platform$Cmd$none : $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Pages$Reports$Dashboard$updateUrl(newModel),
										$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel)
									]))
							])),
					_List_Nil);
			case 11:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, model.D5, subMsg, model.b7);
				var _v3 = result.ac5;
				switch (_v3.$) {
					case 0:
						var locationGroupId = _v3.a;
						var locationId = _v3.b;
						var practitionerId = _v3.c;
						var newModel = _Utils_update(
							model,
							{b7: result.y8, fW: locationGroupId, S3: locationId, ab: $author$project$Pages$Reports$Dashboard$initMetrics, WO: practitionerId});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, result.EC),
										$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
										$author$project$Pages$Reports$Dashboard$updateUrl(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 13:
				var subMsg = msg.a;
				return function (original) {
					var newModel = original.a;
					var cmd = original.b;
					var outMsgs = original.c;
					return (!_Utils_eq(newModel.ff, model.ff)) ? _Utils_Tuple3(
						_Utils_update(
							newModel,
							{ab: $author$project$Pages$Reports$Dashboard$initMetrics}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
									$author$project$Pages$Reports$Dashboard$updateUrl(newModel)
								])),
						outMsgs) : original;
				}(
					function (result) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ff: function () {
										var _v4 = result.ac5;
										if (!_v4.$) {
											if (!_v4.a.$) {
												return $author$project$Components$ResourceFilter$Company$value(result.y8);
											} else {
												var _v5 = _v4.a;
												return model.ff;
											}
										} else {
											return model.ff;
										}
									}(),
									pV: result.y8
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg, result.EC),
							result.as);
					}(
						A3($author$project$Components$ResourceFilter$Company$update, model.D5, subMsg, model.pV)));
			default:
				var subMsg = msg.a;
				return function (original) {
					var newModel = original.a;
					var cmd = original.b;
					var outMsgs = original.c;
					return (!_Utils_eq(newModel.afN, model.afN)) ? _Utils_Tuple3(
						_Utils_update(
							newModel,
							{ab: $author$project$Pages$Reports$Dashboard$initMetrics}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									$author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
									$author$project$Pages$Reports$Dashboard$updateUrl(newModel)
								])),
						outMsgs) : original;
				}(
					function (result) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									afN: function () {
										var _v6 = result.ac5;
										if (!_v6.$) {
											if (!_v6.a.$) {
												return $author$project$Components$ResourceFilter$Plan$value(result.y8);
											} else {
												var _v7 = _v6.a;
												return model.afN;
											}
										} else {
											return model.afN;
										}
									}(),
									jw: result.y8
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg, result.EC),
							result.as);
					}(
						A3($author$project$Components$ResourceFilter$Plan$update, model.D5, subMsg, model.jw)));
		}
	});
var $author$project$Pages$Reports$Dashboard$Active = 1;
var $author$project$Pages$Reports$Dashboard$BreakoutChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$Reports$Dashboard$CancellationReason = 7;
var $author$project$Pages$Reports$Dashboard$Employer = 4;
var $author$project$Pages$Reports$Dashboard$EmployerVsRetail = 5;
var $author$project$Pages$Reports$Dashboard$EngagementChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Reports$Dashboard$Enrollments = 3;
var $author$project$Pages$Reports$Dashboard$LeadSource = 6;
var $author$project$Pages$Reports$Dashboard$Location = 3;
var $author$project$Pages$Reports$Dashboard$LocationGroup = 2;
var $author$project$Pages$Reports$Dashboard$Plan = 0;
var $author$project$Pages$Reports$Dashboard$Provider = 1;
var $author$project$Pages$Reports$Dashboard$ShowingChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Reports$Dashboard$Terminations = 2;
var $author$project$Pages$Reports$Dashboard$breakoutToLabel = function (breakout) {
	switch (breakout) {
		case 0:
			return 'Plan';
		case 1:
			return 'Provider';
		case 2:
			return 'Location Group';
		case 3:
			return 'Location';
		case 4:
			return 'Employer';
		case 5:
			return 'Employer vs Retail';
		case 6:
			return 'Lead Source';
		default:
			return 'Cancellation Reason';
	}
};
var $author$project$Pages$Reports$Dashboard$buildBreakoutOption = function (breakout) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Pages$Reports$Dashboard$breakoutToValue(breakout)),
		$author$project$Pages$Reports$Dashboard$breakoutToLabel(breakout));
};
var $author$project$Pages$Reports$Dashboard$engagementToLabel = function (engagement) {
	switch (engagement) {
		case 0:
			return 'All Engagement Statuses';
		case 1:
			return 'Currently Engaged';
		case 2:
			return 'Previously Engaged';
		default:
			return 'Never Engaged';
	}
};
var $author$project$Pages$Reports$Dashboard$buildEngagementOption = function (engagement) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$author$project$Pages$Reports$Dashboard$engagementToValue(
			$elm$core$Maybe$Just(engagement)),
		$author$project$Pages$Reports$Dashboard$engagementToLabel(engagement));
};
var $author$project$Pages$Reports$Dashboard$showingToLabel = function (showing) {
	switch (showing) {
		case 0:
			return 'Active, growth, attrition';
		case 1:
			return 'Active';
		case 2:
			return 'Terminations';
		default:
			return 'Enrollments';
	}
};
var $author$project$Pages$Reports$Dashboard$showingToValue = function (showing) {
	switch (showing) {
		case 0:
			return 'all';
		case 1:
			return 'active';
		case 2:
			return 'terminations';
		default:
			return 'enrollments';
	}
};
var $author$project$Pages$Reports$Dashboard$buildShowingOption = function (showing) {
	return A3(
		$author$project$Ui$Form$Select$option,
		_List_Nil,
		$elm$core$Maybe$Just(
			$author$project$Pages$Reports$Dashboard$showingToValue(showing)),
		$author$project$Pages$Reports$Dashboard$showingToLabel(showing));
};
var $author$project$Pages$Reports$Dashboard$valueToBreakout = function (stringBreakout) {
	switch (stringBreakout) {
		case 'plan':
			return $elm$core$Maybe$Just(0);
		case 'practitioner':
			return $elm$core$Maybe$Just(1);
		case 'location_group':
			return $elm$core$Maybe$Just(2);
		case 'location':
			return $elm$core$Maybe$Just(3);
		case 'employer':
			return $elm$core$Maybe$Just(4);
		case 'employer-retail':
			return $elm$core$Maybe$Just(5);
		case 'lead_source':
			return $elm$core$Maybe$Just(6);
		case 'cancellation_reason':
			return $elm$core$Maybe$Just(7);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$Reports$Dashboard$valueToShowing = function (stringShowing) {
	switch (stringShowing) {
		case 'active':
			return 1;
		case 'terminations':
			return 2;
		case 'enrollments':
			return 3;
		default:
			return 0;
	}
};
var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view = function (model) {
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				function (locationGroupResourceFilter) {
					return A2(
						$elm$html$Html$map,
						$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg,
						A2(
							$author$project$Components$ResourceFilter$LocationGroup$view,
							_List_fromArray(
								[
									$author$project$Components$ResourceFilter$style(1)
								]),
							locationGroupResourceFilter));
				},
				model.rk),
				A2(
				$elm$core$Maybe$map,
				function (locationResourceFilter) {
					return A2(
						$elm$html$Html$map,
						$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg,
						A2(
							$author$project$Components$ResourceFilter$Location$view,
							_List_fromArray(
								[
									$author$project$Components$ResourceFilter$style(1)
								]),
							locationResourceFilter));
				},
				model.rl),
				A2(
				$elm$core$Maybe$map,
				function (practitionerResourceFilter) {
					return A2(
						$elm$html$Html$map,
						$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg,
						A2(
							$author$project$Components$ResourceFilter$Practitioner$view,
							_List_fromArray(
								[
									$author$project$Components$ResourceFilter$style(1)
								]),
							practitionerResourceFilter));
				},
				model.jC)
			]));
};
var $author$project$Ui$FlexGrid$Show = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$FlexGrid$showMd = $author$project$Ui$FlexGrid$Show(2);
var $author$project$Pages$Reports$Dashboard$viewPeriodSummary = function (maybePeriodSummary) {
	var showSumaryItem = function (valAccessor) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Ui$Spinner$view(_List_Nil),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					valAccessor,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$String$fromInt,
						function (val) {
							return A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$attrs(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('text-gray tile-item-big-number')
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(val)
									]));
						})),
				maybePeriodSummary));
	};
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_fromArray(
			[$author$project$Ui$FlexGrid$mb4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(4),
						$author$project$Ui$FlexGrid$showMd,
						$author$project$Ui$FlexGrid$textCenter
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile-item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Active at Start')
									])),
								showSumaryItem(
								function ($) {
									return $.tH;
								})
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(4),
						$author$project$Ui$FlexGrid$showMd,
						$author$project$Ui$FlexGrid$textCenter
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile-item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Enrollments')
									])),
								showSumaryItem(
								function ($) {
									return $.Fb;
								})
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(4),
						$author$project$Ui$FlexGrid$showMd,
						$author$project$Ui$FlexGrid$textCenter
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile-item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Terminations')
									])),
								showSumaryItem(
								function ($) {
									return $.Hv;
								})
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(4),
						$author$project$Ui$FlexGrid$showMd,
						$author$project$Ui$FlexGrid$textCenter
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile-item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Active At End')
									])),
								showSumaryItem(
								function ($) {
									return $.tG;
								})
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$span(4),
						$author$project$Ui$FlexGrid$spanMd(2),
						$author$project$Ui$FlexGrid$textCenter
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile-item')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Net Growth')
									])),
								function () {
								if (!maybePeriodSummary.$) {
									var activeAtStart = maybePeriodSummary.a.tH;
									var activeAtEnd = maybePeriodSummary.a.tG;
									var growth = 100 * ((activeAtEnd - activeAtStart) / activeAtStart);
									return A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$attrs(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('tile-item-big-number'),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('text-danger', growth < 0),
																_Utils_Tuple2('text-grey', !growth),
																_Utils_Tuple2('text-success', growth > 0)
															]))
													]))
											]),
										_List_fromArray(
											[
												$elm$core$Basics$isInfinite(growth) ? $elm$html$Html$text('--') : $elm$html$Html$text(
												function (percentage) {
													return percentage + '%';
												}(
													A2($myrho$elm_round$Round$round, 2, growth)))
											]));
								} else {
									return $author$project$Ui$Spinner$view(_List_Nil);
								}
							}()
							]))
					]))
			]));
};
var $author$project$Pages$Reports$Dashboard$viewMemberAnalytics = function (_v0) {
	var dateRangeInput = _v0.h3;
	var periodSummary = _v0.r0;
	var showing = _v0.sQ;
	var groupLocationAndPractitionerFilters = _v0.b7;
	var planResourceFilter = _v0.jw;
	var companyResourceFilter = _v0.pV;
	var breakout = _v0.Em;
	var engagement = _v0.Fa;
	var practice = _v0.WF;
	var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
	var gateIsAvailable = A2(
		$author$project$Utils$FeatureGate$gateAvailable,
		11,
		$author$project$Api$Practice$Provider(practice));
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Member Analytics')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(12)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$headingSm(
										_List_fromArray(
											[
												$elm$html$Html$text('Reporting Period')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(12)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Pages$Reports$Dashboard$DateRangeInputMsg,
										$author$project$Components$DateRangeInput$view(dateRangeInput))
									]))
							])),
						$author$project$Pages$Reports$Dashboard$viewPeriodSummary(periodSummary),
						$author$project$Ui$HorizontalRule$view(_List_Nil),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb3, $author$project$Ui$Element$gap2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text('Show me ')
									])),
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$inline,
										$author$project$Ui$Form$Select$value(
										$elm$core$Maybe$Just(
											$author$project$Pages$Reports$Dashboard$showingToValue(showing))),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToShowing, $author$project$Pages$Reports$Dashboard$ShowingChanged))
									]),
								_List_fromArray(
									[
										$author$project$Pages$Reports$Dashboard$buildShowingOption(0),
										$author$project$Pages$Reports$Dashboard$buildShowingOption(1),
										$author$project$Pages$Reports$Dashboard$buildShowingOption(2),
										$author$project$Pages$Reports$Dashboard$buildShowingOption(3)
									])),
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text(' broken out by ')
									])),
								A2(
								$author$project$Ui$Form$Select$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Select$inline,
										$author$project$Ui$Form$Select$value(
										A2($elm$core$Maybe$map, $author$project$Pages$Reports$Dashboard$breakoutToValue, breakout)),
										$author$project$Ui$Form$Select$onChange(
										A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToBreakout, $author$project$Pages$Reports$Dashboard$BreakoutChanged))
									]),
								A2(
									$elm$core$List$cons,
									A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'No Breakout'),
									A2(
										$elm$core$List$cons,
										$author$project$Pages$Reports$Dashboard$buildBreakoutOption(0),
										A2(
											$elm$core$List$cons,
											$author$project$Pages$Reports$Dashboard$buildBreakoutOption(1),
											A2(
												$elm$core$List$cons,
												$author$project$Pages$Reports$Dashboard$buildBreakoutOption(3),
												A2(
													$elm$core$List$cons,
													$author$project$Pages$Reports$Dashboard$buildBreakoutOption(2),
													A2(
														$elm$core$List$cons,
														$author$project$Pages$Reports$Dashboard$buildBreakoutOption(4),
														A2(
															$elm$core$List$cons,
															$author$project$Pages$Reports$Dashboard$buildBreakoutOption(5),
															A2(
																$elm$core$List$cons,
																$author$project$Pages$Reports$Dashboard$buildBreakoutOption(6),
																function () {
																	if (showing === 2) {
																		return _List_fromArray(
																			[
																				$author$project$Pages$Reports$Dashboard$buildBreakoutOption(7)
																			]);
																	} else {
																		return _List_Nil;
																	}
																}())))))))))
							])),
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_Utils_ap(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$List$singleton,
									$author$project$Ui$FlexGrid$column(
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanSm(4)
											]))),
								A2(
									$elm$core$List$map,
									$elm$html$Html$map($author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg),
									$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view(groupLocationAndPractitionerFilters))),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Company$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$style(1)
													]),
												companyResourceFilter))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg,
											A2(
												$author$project$Components$ResourceFilter$Plan$view,
												_List_fromArray(
													[
														$author$project$Components$ResourceFilter$style(1)
													]),
												planResourceFilter))
										])),
									(gateIsAvailable || practiceIsAffiliateOrNetwork) ? A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(4),
											$author$project$Ui$FlexGrid$span(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$inline,
													$author$project$Ui$Form$Select$value(
													$author$project$Pages$Reports$Dashboard$engagementToValue(engagement)),
													$author$project$Ui$Form$Select$onChange(
													A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToEngagement, $author$project$Pages$Reports$Dashboard$EngagementChanged))
												]),
											_List_fromArray(
												[
													$author$project$Pages$Reports$Dashboard$buildEngagementOption(0),
													$author$project$Pages$Reports$Dashboard$buildEngagementOption(1),
													$author$project$Pages$Reports$Dashboard$buildEngagementOption(2),
													$author$project$Pages$Reports$Dashboard$buildEngagementOption(3)
												]))
										])) : $author$project$Ui$FlexGrid$none
								]))),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$id('dashboard-chart'),
								A2($elm$html$Html$Attributes$style, 'position', 'relative'),
								A2($elm$html$Html$Attributes$style, 'height', '540px')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams = function (optionalsFunc) {
	var options = optionalsFunc($author$project$Api$Provider$Reports$CustomerInvoice$listDefaults);
	return A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('start'),
					$author$project$Utils$Date$toQuery),
				options.Hl),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('end'),
					$author$project$Utils$Date$toQuery),
				options.E9),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('status'),
					$elm$core$String$join(',')),
				options.ag7)
			]));
};
var $author$project$Ui$Panel$Success = 1;
var $author$project$Ui$Panel$success = $author$project$Ui$Panel$Styling(1);
var $author$project$Pages$Reports$Dashboard$viewOutstanding = F3(
	function (title, data, queryParams) {
		if (data.$ === 3) {
			var amount = data.a;
			var intCurrency = A2(
				$elm$core$Maybe$withDefault,
				0,
				$author$project$Currency$toInt(amount));
			var panelStyle = (intCurrency > 0) ? $author$project$Ui$Panel$danger : $author$project$Ui$Panel$success;
			return A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[panelStyle]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_fromArray(
							[$author$project$Ui$Element$textCenter]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingSm(
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Currency$format(amount))
									])),
								A2(
								$author$project$Ui$Typography$p,
								_List_Nil,
								_List_fromArray(
									[
										(intCurrency > 0) ? A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__Invoices,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(queryParams)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View outstanding')
											])) : $elm$html$Html$text('No Outstanding')
									]))
							]))
					]));
		} else {
			return $author$project$Ui$Spinner$view(
				_List_fromArray(
					[$author$project$Ui$Spinner$small]));
		}
	});
var $author$project$Pages$Reports$Dashboard$viewPatientInvoices = function (_v0) {
	var today = _v0.$P;
	var outstandingLt30Amount = _v0.z2;
	var outstanding30To59Amount = _v0.z0;
	var outstanding60PlusAmount = _v0.z1;
	var issuedAmount = _v0.yn;
	var allAmountsSucceeded = A2(
		$elm$core$List$all,
		$author$project$Api$Data$isSuccess,
		_List_fromArray(
			[outstandingLt30Amount, outstanding30To59Amount, outstanding60PlusAmount, issuedAmount]));
	return allAmountsSucceeded ? A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Patient Invoices')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(4)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Pages$Reports$Dashboard$viewOutstanding,
										'< 30 Days Old',
										outstandingLt30Amount,
										$author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams(
											$author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams(today)))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(4)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Pages$Reports$Dashboard$viewOutstanding,
										'30-59 Days Old',
										outstanding30To59Amount,
										$author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams(
											$author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams(today)))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(4)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Pages$Reports$Dashboard$viewOutstanding,
										'60+ Days Old',
										outstanding60PlusAmount,
										$author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams(
											$author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams(today)))
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(12)
									]),
								_List_fromArray(
									[
										function () {
										if (issuedAmount.$ === 3) {
											var amount = issuedAmount.a;
											return A2(
												$author$project$Ui$Panel$view,
												_List_fromArray(
													[$author$project$Ui$Panel$info]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Panel$body,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$author$project$Ui$Typography$strong,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Currency$format(amount))
																	])),
																A2(
																$elm$html$Html$span,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(' in ')
																	])),
																A3(
																$author$project$Ui$Link$route,
																$author$project$Spa$Generated$Route$Reports__Invoices,
																_List_fromArray(
																	[
																		$author$project$Ui$Link$routeParams(
																		$author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams($author$project$Pages$Reports$Dashboard$issuedInvoicesParams))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Issued, but unsent invoices')
																	]))
															]))
													]));
										} else {
											return $author$project$Ui$Spinner$view(
												_List_fromArray(
													[$author$project$Ui$Spinner$small]));
										}
									}()
									]))
							]))
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Pages$Reports$Dashboard$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$Reports$Dashboard$viewPatientInvoices(model),
				$author$project$Pages$Reports$Dashboard$viewMemberAnalytics(model)
			]),
		$G: 'Reports | Dashboard'
	};
};
var $author$project$Pages$Reports$Dashboard$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Dashboard$init, aer: $author$project$Pages$Reports$Dashboard$load, agD: $author$project$Pages$Reports$Dashboard$save, ahd: $author$project$Pages$Reports$Dashboard$subscriptions, aaq: $author$project$Pages$Reports$Dashboard$update, ahP: $author$project$Pages$Reports$Dashboard$view});
var $author$project$Pages$Reports$DeferredRevenue$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$DeferredRevenue$Table = 0;
var $author$project$Components$Reports$DeferredRevenue$ByDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$DeferredRevenueLine = 7;
var $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('category'),
			model.fa),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.WO),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.bQ)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$DeferredRevenue$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				function () {
				var _v0 = model.bQ;
				if (!_v0.$) {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary);
				} else {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__DeferredRevenue);
				}
			}()
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Components$Reports$DeferredRevenue$urlParams(model)))));
};
var $author$project$Components$Reports$DeferredRevenue$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$DeferredRevenue$GotDeferredRevenueLines = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Ex: model.fa,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afy: model.afy,
				afS: model.WO,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$DeferredRevenueLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$DeferredRevenueLine$Record = F8(
	function (transactionDate, amountInCents, category, charge, invoice, client, practitioner, location) {
		return {I2: amountInCents, Ex: category, abU: charge, K1: client, Rh: invoice, aet: location, afS: practitioner, $2: transactionDate};
	});
var $author$project$Api$Provider$Reports$Charge$Charge = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Charge$Record = F2(
	function (name, serviceDate) {
		return {zh: name, ZB: serviceDate};
	});
var $author$project$Api$Provider$Reports$Charge$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'service_date',
	$author$project$Utils$Date$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Charge$Record)));
var $author$project$Api$Provider$Reports$Charge$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Charge$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$RevenueLine$Client$Client = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$RevenueLine$Client$Record = F3(
	function (id, type_, name) {
		return {adR: id, zh: name, ahI: type_};
	});
var $author$project$Api$Provider$Reports$RevenueLine$Client$Company = 1;
var $author$project$Api$Provider$Reports$RevenueLine$Client$Patient = 0;
var $author$project$Api$Provider$Reports$RevenueLine$Client$decodeType = function (string) {
	switch (string) {
		case 'Patient':
			return $elm$json$Json$Decode$succeed(0);
		case 'Company':
			return $elm$json$Json$Decode$succeed(1);
		default:
			return $elm$json$Json$Decode$fail('Unsupported client type: ' + string);
	}
};
var $author$project$Api$Provider$Reports$RevenueLine$Client$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'type',
		A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$RevenueLine$Client$decodeType, $elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$RevenueLine$Client$Record))));
var $author$project$Api$Provider$Reports$RevenueLine$Client$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$RevenueLine$Client$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$DeferredRevenueLine$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'client',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$RevenueLine$Client$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'invoice',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'category',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transaction_date',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$DeferredRevenueLine$Record)))))))));
var $author$project$Api$Provider$Reports$DeferredRevenueLine$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$DeferredRevenueLine$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$DeferredRevenueLine$listDefaults = {Ex: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, rj: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, afS: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$DeferredRevenueLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.Ex;
						if (!_v2.$) {
							var category_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'category', category_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.rj;
						if (!_v3.$) {
							var locationGroup_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.aet;
						if (!_v4.$) {
							var location_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.afS;
						if (!_v5.$) {
							var practitioner_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'deferred_revenue_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$DeferredRevenueLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$DeferredRevenueLine$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$DeferredRevenueLine$listPath)));
	});
var $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$DeferredRevenueLine$list,
			apiClient,
			$author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams(model),
			$author$project$Components$Reports$DeferredRevenue$GotDeferredRevenueLines);
	});
var $author$project$Components$Reports$DeferredRevenue$GotSummary = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Ex: model.fa,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afS: model.WO,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$DeferredRevenueLine$listPath,
			by,
			$author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$DeferredRevenue$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$DeferredRevenueLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.bQ),
			$author$project$Components$Reports$DeferredRevenue$fetchSummaryParams(model),
			$author$project$Components$Reports$DeferredRevenue$GotSummary);
	});
var $author$project$Components$Reports$DeferredRevenue$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.ahI;
		if (!_v0) {
			return A2($author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$DeferredRevenue$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$DeferredRevenue$initColumns = function (trackPatientsByLocation) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'),
			A2(
				$elm$core$List$cons,
				A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
				A2(
					$elm$core$List$cons,
					A3($author$project$Api$Column$init, 'client', true, 'Client'),
					A2(
						$elm$core$List$cons,
						A3($author$project$Api$Column$init, 'category', true, 'Category'),
						A2(
							$elm$core$List$cons,
							A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'),
							trackPatientsByLocation ? _List_fromArray(
								[
									A3($author$project$Api$Column$init, 'location', true, 'Location')
								]) : _List_Nil))))));
};
var $author$project$Components$Reports$DeferredRevenue$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.cO;
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var categoryId = A2($elm$core$Dict$get, 'category', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var deferredRevenueLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$DeferredRevenue$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		var model = {
			bQ: A2($elm$core$Dict$get, 'by', query),
			lh: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'by-dropdown', ahx: $author$project$Components$Reports$DeferredRevenue$ByDropdownMsg})),
			Eq: A3($author$project$Permission$canGoTo, session, hinterViewOff, 17),
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			fa: categoryId,
			cJ: categoryResourceFilter,
			Ll: $author$project$Components$Reports$DeferredRevenue$initColumns(trackPatientsByLocation),
			cO: currentDate,
			h3: dateRangeInput,
			aE: deferredRevenueLines,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 7}),
			b7: groupLocationAndPractitionerFilters,
			fW: locationGroupId,
			S3: locationId,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WO: practitionerId,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			_9: summary,
			$$: trackPatientsByLocation,
			ahI: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$DeferredRevenue$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$DeferredRevenue$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$DeferredRevenue$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$DeferredRevenue$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$DeferredRevenue$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b7)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.cJ)),
				$author$project$Ui$NewDropdown$subscriptions(model.lh)
			]));
};
var $author$project$Pages$Reports$DeferredRevenue$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$DeferredRevenue$subscriptions(model.jO));
};
var $author$project$Components$Reports$DeferredRevenue$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cJ);
				var categoryId = function () {
					var _v2 = categoryResourceResult.ac5;
					if (!_v2.$) {
						if (!_v2.a.$) {
							return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8);
						} else {
							var _v3 = _v2.a;
							return model.fa;
						}
					} else {
						return model.fa;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fa: categoryId, cJ: categoryResourceResult.y8});
				var _v1 = _Utils_eq(model.fa, newModel.fa) ? _Utils_Tuple2(model.aE, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var deferredRevenueLines = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{aE: deferredRevenueLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg, categoryResourceResult.EC),
								cmd
							])),
					categoryResourceResult.as);
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lh);
				var byDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lh: byDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bQ: by,
						aE: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				var cmds = function () {
					var _v5 = _Utils_Tuple2(model.ahI, newModel.bQ);
					if (!_v5.a) {
						if (!_v5.b.$) {
							var _v6 = _v5.a;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v7 = _v5.a;
							var _v8 = _v5.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v5.b.$ === 1) {
							var _v9 = _v5.a;
							var _v10 = _v5.b;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v11 = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v12 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v12.a;
				var subCmd = _v12.b;
				var event = _v12.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								aE: $author$project$Api$Data$Loading,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b7);
				var _v14 = result.ac5;
				switch (_v14.$) {
					case 0:
						var locationGroupId = _v14.a;
						var locationId = _v14.b;
						var practitionerId = _v14.c;
						var newModel = _Utils_update(
							model,
							{
								aE: $author$project$Api$Data$Loading,
								b7: result.y8,
								fW: locationGroupId,
								S3: locationId,
								afy: $author$project$Api$Pagination$reset(model.afy),
								WO: practitionerId
							});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, result.EC),
										A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
										A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								aE: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aE: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{aE: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v16 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v16.a;
				var subCmd = _v16.b;
				var subOutMsg = _v16.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$DeferredRevenue$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$DeferredRevenue$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$DeferredRevenue$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$DeferredRevenue$BySelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$DeferredRevenue$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$DeferredRevenue$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Reports$DeferredRevenue$BySelected(
									$elm$core$Maybe$Just('category'))),
								$author$project$Ui$NewDropdown$selected(
								_Utils_eq(
									currentBy,
									$elm$core$Maybe$Just('category')))
							]),
						$elm$html$Html$text('Category')),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$Reports$DeferredRevenue$BySelected(
										$elm$core$Maybe$Just('practitioner'))),
									$author$project$Ui$NewDropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just('practitioner')))
								]),
							$elm$html$Html$text('Provider')),
						trackPatientsByLocation ? _List_fromArray(
							[
								A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$Reports$DeferredRevenue$BySelected(
											$elm$core$Maybe$Just('location'))),
										$author$project$Ui$NewDropdown$selected(
										_Utils_eq(
											currentBy,
											$elm$core$Maybe$Just('location')))
									]),
								$elm$html$Html$text('Location'))
							]) : _List_Nil))));
	});
var $author$project$Components$Reports$DeferredRevenue$byToDisplayName = function (by) {
	switch (by) {
		case 'category':
			return 'Category';
		case 'practitioner':
			return 'Provider';
		case 'location':
			return 'Location';
		default:
			return by;
	}
};
var $author$project$Components$Reports$DeferredRevenue$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.bQ;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$DeferredRevenue$byToDisplayName(by);
		} else {
			return 'Summarize by';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$DeferredRevenue$byDropdownItems, model.$$, model.bQ),
		model.lh);
};
var $author$project$Components$Reports$DeferredRevenue$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Category$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			categoryResourceFilter));
};
var $author$project$Components$ResourceFilter$Category$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$Reports$DeferredRevenue$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$DeferredRevenue$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Unassigned',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'charge',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$DeferredRevenue$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model._9)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model._9)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model._9)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Charges')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$DeferredRevenue$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$DeferredRevenue$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$category = function (_v0) {
	var record = _v0;
	return record.Ex;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$charge = function (_v0) {
	var record = _v0;
	return record.abU;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$client = function (_v0) {
	var record = _v0;
	return record.K1;
};
var $author$project$Api$Provider$Reports$RevenueLine$Client$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$invoice = function (_v0) {
	var record = _v0;
	return record.Rh;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$location = function (_v0) {
	var record = _v0;
	return record.aet;
};
var $author$project$Api$Provider$Reports$Charge$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Reports$RevenueLine$Client$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$practitioner = function (_v0) {
	var record = _v0;
	return record.afS;
};
var $author$project$Api$Provider$Reports$Charge$serviceDate = function (_v0) {
	var record = _v0;
	return record.ZB;
};
var $author$project$Api$Provider$Reports$DeferredRevenueLine$transactionDate = function (_v0) {
	var record = _v0;
	return record.$2;
};
var $author$project$Api$Provider$Reports$RevenueLine$Client$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Components$Reports$DeferredRevenue$viewRow = F4(
	function (trackPatientsByLocation, canGoToPatients, canGoToCompany, deferredRevenueLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$DeferredRevenueLine$transactionDate(deferredRevenueLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$DeferredRevenueLine$amountInCents(deferredRevenueLine))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('for '),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Provider$Reports$Charge$name,
															$author$project$Api$Provider$Reports$DeferredRevenueLine$charge(deferredRevenueLine))))
												])),
											$elm$html$Html$text(
											' on ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$Reports$Charge$serviceDate,
														$author$project$Api$Provider$Reports$DeferredRevenueLine$charge(deferredRevenueLine)))))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = $author$project$Api$Provider$Reports$DeferredRevenueLine$invoice(deferredRevenueLine);
								if (!_v0.$) {
									var invoice = _v0.a;
									var invoiceStatus = A2(
										$author$project$Ui$Badge$fromString,
										_List_Nil,
										$author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice));
									var invoicePath_ = function () {
										var _v2 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
										switch (_v2) {
											case 1:
												var _v3 = _Utils_Tuple2(
													canGoToPatients,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v3.a && (!_v3.b.$)) {
													var owner = _v3.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
															{
																aea: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
																VN: $author$project$Api$Common$Payable$Owner$Min$id(owner)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											case 0:
												var _v4 = _Utils_Tuple2(
													canGoToCompany,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v4.a && (!_v4.b.$)) {
													var owner = _v4.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
															{
																ff: $author$project$Api$Common$Payable$Owner$Min$id(owner),
																adR: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											default:
												return $elm$core$Maybe$Nothing;
										}
									}();
									var invoiceNumber = $elm$html$Html$text(
										'#' + ($elm$core$String$fromInt(
											$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' '));
									var _for = A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$small,
												$author$project$Ui$Typography$muted
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												'for ' + A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Common$Payable$Owner$Min$name,
														$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))))
											]));
									if (!invoicePath_.$) {
										var path = invoicePath_.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												path,
												_List_Nil,
												_List_fromArray(
													[invoiceNumber, invoiceStatus])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_for
											]);
									} else {
										return _List_fromArray(
											[
												invoiceNumber,
												invoiceStatus,
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_for
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									function () {
										var _v5 = $author$project$Api$Provider$Reports$DeferredRevenueLine$client(deferredRevenueLine);
										if (!_v5.$) {
											var client = _v5.a;
											var path = function () {
												var _v7 = $author$project$Api$Provider$Reports$RevenueLine$Client$type_(client);
												if (!_v7) {
													return canGoToPatients ? $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
															{
																VN: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
															})) : $elm$core$Maybe$Nothing;
												} else {
													return canGoToCompany ? $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
															{
																ff: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
															})) : $elm$core$Maybe$Nothing;
												}
											}();
											var clientName = $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$ellipsis,
													20,
													$author$project$Api$Provider$Reports$RevenueLine$Client$name(client)));
											if (!path.$) {
												var path_ = path.a;
												return _List_fromArray(
													[
														A3(
														$author$project$Ui$Link$route,
														path_,
														_List_Nil,
														_List_fromArray(
															[clientName]))
													]);
											} else {
												return _List_fromArray(
													[clientName]);
											}
										} else {
											return _List_fromArray(
												[
													$elm$html$Html$text('N/A')
												]);
										}
									}())
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Category$Min$name,
											$author$project$Api$Provider$Reports$DeferredRevenueLine$category(deferredRevenueLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Practitioner$Min$name,
												$author$project$Api$Provider$Reports$DeferredRevenueLine$practitioner(deferredRevenueLine)))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$DeferredRevenueLine$location(deferredRevenueLine)))))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Reports$DeferredRevenue$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.aE;
		if (_v1.$ === 3) {
			var deferredRevenueLines_ = _v1.a;
			return _Utils_Tuple2(false, deferredRevenueLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var deferredRevenueLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$DeferredRevenue$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A3($author$project$Components$Reports$DeferredRevenue$viewRow, model.$$, model.Er, model.Eq),
			deferredRevenueLines),
		_List_Nil);
};
var $author$project$Components$Reports$DeferredRevenue$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$DeferredRevenue$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.aE)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams, $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Deferred Revenue')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.aE;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$DeferredRevenue$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total deferred revenue across retail customers and employers')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(12)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.h3))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$FlexGrid$column(
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.b7))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$DeferredRevenue$viewCategoryResourceFilter(model.cJ)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$DeferredRevenue$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$Category$viewMultiSelected(model.cJ)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b7)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.ahI;
						if (!_v1) {
							return $author$project$Components$Reports$DeferredRevenue$viewTable(model);
						} else {
							return $author$project$Components$Reports$DeferredRevenue$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.ahI;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$DeferredRevenue$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.aE)))
												]),
											model.afy))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$DeferredRevenue$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$DeferredRevenue$view, model.D5, model.jO)),
		$G: 'Reports | Deferred Revenue'
	};
};
var $author$project$Pages$Reports$DeferredRevenue$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$DeferredRevenue$init, aer: $author$project$Pages$Reports$DeferredRevenue$load, agD: $author$project$Pages$Reports$DeferredRevenue$save, ahd: $author$project$Pages$Reports$DeferredRevenue$subscriptions, aaq: $author$project$Pages$Reports$DeferredRevenue$update, ahP: $author$project$Pages$Reports$DeferredRevenue$view});
var $author$project$Pages$Reports$DeferredRevenue$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$DeferredRevenue$Summary = 1;
var $author$project$Pages$Reports$DeferredRevenue$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$DeferredRevenue$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$DeferredRevenue$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$DeferredRevenue$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$DeferredRevenue$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$DeferredRevenue$subscriptions(model.jO));
};
var $author$project$Pages$Reports$DeferredRevenue$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$DeferredRevenue$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$DeferredRevenue$Summary$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$DeferredRevenue$view, model.D5, model.jO)),
		$G: 'Reports | Deferred Revenue'
	};
};
var $author$project$Pages$Reports$DeferredRevenue$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$DeferredRevenue$Summary$init, aer: $author$project$Pages$Reports$DeferredRevenue$Summary$load, agD: $author$project$Pages$Reports$DeferredRevenue$Summary$save, ahd: $author$project$Pages$Reports$DeferredRevenue$Summary$subscriptions, aaq: $author$project$Pages$Reports$DeferredRevenue$Summary$update, ahP: $author$project$Pages$Reports$DeferredRevenue$Summary$view});
var $author$project$Pages$Reports$Deposits$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Deposits$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$Deposit = 13;
var $author$project$Components$Reports$Deposits$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$Deposits$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$Deposits$GotDepositSummary = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Reports$DepositSummary$DepositSummary = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$DepositSummary$Record = F3(
	function (nextDepositAvailableOn, nextDepositAmountInCents, availableSoonAmountInCents) {
		return {JM: availableSoonAmountInCents, UD: nextDepositAmountInCents, UE: nextDepositAvailableOn};
	});
var $author$project$Api$Provider$Reports$DepositSummary$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'available_soon_amount_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'next_deposit_amount_in_cents',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'next_deposit_available_on',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$DepositSummary$Record))));
var $author$project$Api$Provider$Reports$DepositSummary$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$DepositSummary$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$DepositSummary$depositSummaryPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['deposits', 'summary']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$DepositSummary$depositSummary = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Reports$DepositSummary$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$DepositSummary$depositSummaryPath));
	});
var $author$project$Components$Reports$Deposits$fetchDepositSummary = F2(
	function (apiClient, _v0) {
		return A2($author$project$Api$Provider$Reports$DepositSummary$depositSummary, apiClient, $author$project$Components$Reports$Deposits$GotDepositSummary);
	});
var $author$project$Components$Reports$Deposits$GotDeposits = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Deposits$fetchDepositsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				afy: model.afy,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				ag7: model.ag7
			});
	};
};
var $author$project$Api$Provider$Reports$Deposit$Deposit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Deposit$Record = function (id) {
	return function (availableOn) {
		return function (amountInCents) {
			return function (stripeFeeInCents) {
				return function (hintFeeInCents) {
					return function (totalFeeInCents) {
						return function (discrepancyInCents) {
							return function (receiptsCount) {
								return function (status) {
									return function (errorMessage) {
										return function (paymentProcessor) {
											return function (canReconcile) {
												return {I2: amountInCents, JL: availableOn, KA: canReconcile, NO: discrepancyInCents, ON: errorMessage, Qv: hintFeeInCents, adR: id, V0: paymentProcessor, XT: receiptsCount, ag7: status, _V: stripeFeeInCents, $V: totalFeeInCents};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Reports$Deposit$Canceled = 3;
var $author$project$Api$Provider$Reports$Deposit$Failed = 4;
var $author$project$Api$Provider$Reports$Deposit$InTransit = 2;
var $author$project$Api$Provider$Reports$Deposit$Paid = 0;
var $author$project$Api$Provider$Reports$Deposit$Pending = 1;
var $author$project$Api$Provider$Reports$Deposit$Upcoming = 5;
var $author$project$Api$Provider$Reports$Deposit$decodeStatus = function (string) {
	switch (string) {
		case 'paid':
			return $elm$json$Json$Decode$succeed(0);
		case 'pending':
			return $elm$json$Json$Decode$succeed(1);
		case 'in_transit':
			return $elm$json$Json$Decode$succeed(2);
		case 'canceled':
			return $elm$json$Json$Decode$succeed(3);
		case 'failed':
			return $elm$json$Json$Decode$succeed(4);
		case 'upcoming':
			return $elm$json$Json$Decode$succeed(5);
		default:
			return $elm$json$Json$Decode$fail('Unsupported deposit status: ' + string);
	}
};
var $author$project$Api$Provider$Reports$Deposit$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'can_reconcile',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'payment_processor',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'error_message',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'status',
				A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$Deposit$decodeStatus, $elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'receipts_count',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'discrepancy_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'total_fee_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'hint_fee_in_cents',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'stripe_fee_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'amount_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'available_on',
											$author$project$Utils$Date$decode,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Deposit$Record)))))))))))));
var $author$project$Api$Provider$Reports$Deposit$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Deposit$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Deposit$listDefaults = {E9: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$Deposit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Deposit$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.ag7;
						if (!_v2.$) {
							var status_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', status_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Deposit$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'deposits']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Deposit$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Deposit$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Deposit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Deposit$listPath)));
	});
var $author$project$Components$Reports$Deposits$fetchDeposits = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Deposit$list,
			apiClient,
			$author$project$Components$Reports$Deposits$fetchDepositsParams(model),
			$author$project$Components$Reports$Deposits$GotDeposits);
	});
var $author$project$Components$Reports$Deposits$initColumns = function (feePlanType) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'available_on', true, 'Est. Available Date'),
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Deposit Amount')
				]),
				function () {
				if (!feePlanType) {
					return _List_fromArray(
						[
							A3($author$project$Api$Column$init, 'stripe_fee_in_cents', true, 'Processing Fee'),
							A3($author$project$Api$Column$init, 'hint_fee_in_cents', true, 'Platform Fee')
						]);
				} else {
					return _List_fromArray(
						[
							A3($author$project$Api$Column$init, 'total_fee_in_cents', true, 'Transaction Fee')
						]);
				}
			}(),
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'discrepancy_in_cents', true, 'Discrepancies'),
					A3($author$project$Api$Column$init, 'receipts_count', false, 'Payment Count'),
					A3($author$project$Api$Column$init, 'payment_processor', false, 'Payment Processor'),
					A3($author$project$Api$Column$init, 'status', false, 'Status')
				])
			]));
};
var $author$project$Components$Reports$Deposits$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.ag7)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Deposits)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Components$Reports$Deposits$init = F3(
	function (practice, shared, query) {
		var feePlanType = $author$project$Api$Provider$Practice$One$feePlanType(practice);
		var _v0 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v0.a;
		var end = _v0.b;
		var _v1 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Deposits$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, shared.cO, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, shared.cO, 0),
					end)));
		var dateRangeInput = _v1.a;
		var dateRangeInputCmd = _v1.b;
		var model = {
			Ll: $author$project$Components$Reports$Deposits$initColumns(feePlanType),
			cO: shared.cO,
			h3: dateRangeInput,
			w9: $author$project$Api$Data$Loading,
			b1: $author$project$Api$Data$Loading,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 13}),
			Pg: feePlanType,
			FR: $author$project$Shared$isHintAdmin(shared),
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WF: practice,
			gt: $elm$core$Maybe$Nothing,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'available_on',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			ag7: A2($elm$core$Dict$get, 'status', query),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'deposits-status-dropdown', ahx: $author$project$Components$Reports$Deposits$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$DateRangeInputMsg, dateRangeInputCmd),
						A2($author$project$Components$Reports$Deposits$fetchDeposits, shared.D5, model),
						A2($author$project$Components$Reports$Deposits$fetchDepositSummary, shared.D5, model),
						$author$project$Components$Reports$Deposits$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$Deposits$init = F4(
	function (_v0, practice, shared, _v1) {
		var query = _v1.Bi;
		var _v2 = A3($author$project$Components$Reports$Deposits$init, practice, shared, query);
		var report = _v2.a;
		var reportCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Deposits$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Deposits$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Deposits$CloseRainforestDepositModal = {$: 10};
var $author$project$Components$Reports$Deposits$ExportCsvMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$Deposits$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Deposits$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Deposits$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				$author$project$Ui$NewDropdown$subscriptions(model.oA),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$Rainforest$SessionModal$subscriptions($author$project$Components$Reports$Deposits$CloseRainforestDepositModal)),
					model.gt))
			]));
};
var $author$project$Pages$Reports$Deposits$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Deposits$subscriptions(model.jO));
};
var $author$project$Api$Platform$RainforestSession$Deposit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Deposits$RainforestDepositModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Reports$Deposit$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Reports$Deposits$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								b1: $author$project$Api$Data$Loading,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
						$author$project$Components$Reports$Deposits$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var statusDropdown = _v3.a;
				var statusDropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 2:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						b1: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						ag7: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var status = selectedOption.a;
								return $elm$core$Maybe$Just(status);
							}
						}()
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
								$author$project$Components$Reports$Deposits$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b1: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b1: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var response = msg.a;
				if (response.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{w9: response}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 5:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{b1: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
								$author$project$Components$Reports$Deposits$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
								$author$project$Components$Reports$Deposits$updateUrl(newModel)
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v7 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v7.a;
				var subCmd = _v7.b;
				var subOutMsg = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$ExportCsvMsg, subCmd),
					subOutMsg);
			case 8:
				var deposit = msg.a;
				var _v8 = A2(
					$author$project$Components$Rainforest$SessionModal$init,
					apiClient,
					$author$project$Api$Platform$RainforestSession$Deposit(
						$author$project$Api$Provider$Reports$Deposit$id(deposit)));
				var rainforestDepositModal = _v8.a;
				var rainforestDepositModalCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							gt: $elm$core$Maybe$Just(rainforestDepositModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$RainforestDepositModalMsg, rainforestDepositModalCmd),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v9 = model.gt;
				if (!_v9.$) {
					var rainforestDepositModal = _v9.a;
					var _v10 = A2($author$project$Components$Rainforest$SessionModal$update, subMsg, rainforestDepositModal);
					var newRainforestDepositModal = _v10.a;
					var rainforestDepositModalCmd = _v10.b;
					var rainforestDepositModalOutMsg = _v10.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gt: $elm$core$Maybe$Just(newRainforestDepositModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$RainforestDepositModalMsg, rainforestDepositModalCmd),
						rainforestDepositModalOutMsg);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gt: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
		}
	});
var $author$project$Pages$Reports$Deposits$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Deposits$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Deposits$PaginationMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Deposits$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Api$Provider$Reports$DepositSummary$availableSoonAmountInCents = function (_v0) {
	var record = _v0;
	return record.JM;
};
var $author$project$Components$Reports$Deposits$viewAvailableSoonCard = function (depositSummary) {
	var title = 'Available Soon';
	var subtitle = 'Estimate expected within a few business days';
	var description = 'Total amount of payments in progress. These have been collected, but not yet deposited.';
	var availableSoon = $author$project$Utils$Currency$fromInt(
		$author$project$Api$Provider$Reports$DepositSummary$availableSoonAmountInCents(depositSummary));
	return A8(
		$author$project$Components$InfoCard$view,
		'blue',
		title,
		_List_Nil,
		availableSoon,
		$elm$core$Maybe$Just(subtitle),
		description,
		$author$project$Utils$Html$empty,
		true);
};
var $author$project$Api$Provider$Reports$DepositSummary$nextDepositAmountInCents = function (_v0) {
	var record = _v0;
	return record.UD;
};
var $author$project$Api$Provider$Reports$DepositSummary$nextDepositAvailableOn = function (_v0) {
	var record = _v0;
	return record.UE;
};
var $author$project$Components$Reports$Deposits$viewNextDepositCard = function (depositSummary) {
	var title = 'Next Deposit';
	var nextDepositAvailableOn = function () {
		var _v1 = $author$project$Api$Provider$Reports$DepositSummary$nextDepositAvailableOn(depositSummary);
		if (!_v1.$) {
			var availableOn = _v1.a;
			return $elm$core$Maybe$Just(
				'Estimate expected ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDayAndYear, availableOn));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}();
	var nextDepositAmount = function () {
		var _v0 = $author$project$Api$Provider$Reports$DepositSummary$nextDepositAmountInCents(depositSummary);
		if (!_v0.$) {
			var amount = _v0.a;
			return $author$project$Utils$Currency$fromInt(amount);
		} else {
			return 'N/A';
		}
	}();
	var description = 'This reflects the portion of the “Available Soon” amount that is scheduled to be paid out next.';
	return A8($author$project$Components$InfoCard$view, 'green', title, _List_Nil, nextDepositAmount, nextDepositAvailableOn, description, $author$project$Utils$Html$empty, true);
};
var $author$project$Components$Reports$Deposits$viewDepositSummary = F2(
	function (depositSummaryData, practice) {
		if ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest') {
			if (depositSummaryData.$ === 3) {
				var depositSummary = depositSummaryData.a;
				return A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$mb6]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_fromArray(
								[$author$project$Ui$FlexGrid$mt4, $author$project$Ui$FlexGrid$mb2]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											$author$project$Components$Reports$Deposits$viewNextDepositCard(depositSummary)
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											$author$project$Components$Reports$Deposits$viewAvailableSoonCard(depositSummary)
										]))
								])),
							A2(
							$author$project$Ui$Typography$p,
							_List_fromArray(
								[$author$project$Ui$Typography$helpBlock]),
							_List_fromArray(
								[
									$elm$html$Html$text('The numbers above are estimates based on pending transactions. Stripe payments are excluded. Final deposit amounts may change as payments and refunds process.')
								]))
						]));
			} else {
				return $author$project$Utils$Html$empty;
			}
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$Reports$Deposits$formatStatus = $elm_community$string_extra$String$Extra$humanize;
var $author$project$Components$Reports$Deposits$None = {$: 1};
var $author$project$Components$Reports$Deposits$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Deposits$StatusFiltered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Deposits$statusDropdownOptions = function (currentStatus) {
	var baseStatusOptions = _List_fromArray(
		['failed', 'paid', 'pending', 'in_transit', 'canceled', 'upcoming']);
	var statusOptions = A2(
		$elm$core$List$map,
		function (status) {
			return A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$Deposits$StatusFiltered(
							$author$project$Components$Reports$Deposits$Status(status))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(status),
							currentStatus))
					]),
				$elm$html$Html$text(
					$author$project$Components$Reports$Deposits$formatStatus(status)));
		},
		baseStatusOptions);
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Deposits$StatusFiltered($author$project$Components$Reports$Deposits$None)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$NewDropdown$separator, statusOptions));
};
var $author$project$Components$Reports$Deposits$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Status',
					A2($elm$core$Maybe$map, $author$project$Components$Reports$Deposits$formatStatus, model.ag7)))
			]),
		$author$project$Components$Reports$Deposits$statusDropdownOptions(model.ag7),
		model.oA);
};
var $author$project$Components$Reports$Deposits$SortTable = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Deposits$OpenRainforestDepositModal = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$Deposit$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$Deposit$availableOn = function (_v0) {
	var record = _v0;
	return record.JL;
};
var $author$project$Api$Provider$Reports$Deposit$canReconcile = function (_v0) {
	var record = _v0;
	return record.KA;
};
var $author$project$Api$Provider$Reports$Deposit$discrepancyInCents = function (_v0) {
	var record = _v0;
	return record.NO;
};
var $author$project$Api$Provider$Reports$Deposit$errorMessage = function (_v0) {
	var record = _v0;
	return record.ON;
};
var $author$project$Api$Provider$Reports$Deposit$hintFeeInCents = function (_v0) {
	var record = _v0;
	return record.Qv;
};
var $author$project$Api$Provider$Reports$Deposit$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Ui$Icon$Pull = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Icon$pull = $author$project$Ui$Icon$Pull;
var $author$project$Api$Provider$Reports$Deposit$receiptsCount = function (_v0) {
	var record = _v0;
	return record.XT;
};
var $author$project$Api$Provider$Reports$Deposit$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Reports$Deposit$statusToString = function (status_) {
	switch (status_) {
		case 0:
			return 'paid';
		case 1:
			return 'pending';
		case 2:
			return 'in transit';
		case 3:
			return 'canceled';
		case 4:
			return 'failed';
		default:
			return 'upcoming';
	}
};
var $author$project$Api$Provider$Reports$Deposit$stripeFeeInCents = function (_v0) {
	var record = _v0;
	return record._V;
};
var $author$project$Api$Provider$Reports$Deposit$totalFeeInCents = function (_v0) {
	var record = _v0;
	return record.$V;
};
var $author$project$Components$Reports$Deposits$viewRow = F3(
	function (isHintAdmin, feePlanType, deposit) {
		var availableDate = ($author$project$Api$Provider$Reports$Deposit$status(deposit) === 5) ? $elm$html$Html$text(
			A2(
				$author$project$Formatters$Date$toString,
				$author$project$Formatters$Date$Full,
				$author$project$Api$Provider$Reports$Deposit$availableOn(deposit))) : A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Reports__PaymentApplications,
			_List_fromArray(
				[
					$author$project$Ui$Link$routeParams(
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'deposit',
							$author$project$Api$Provider$Reports$Deposit$id(deposit))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$author$project$Formatters$Date$toString,
						$author$project$Formatters$Date$Full,
						$author$project$Api$Provider$Reports$Deposit$availableOn(deposit)))
				]));
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[availableDate])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Deposit$amountInCents(deposit)))
								]))
						]),
						function () {
						if (!feePlanType) {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Deposit$stripeFeeInCents(deposit)))
										])),
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Deposit$hintFeeInCents(deposit)))
										]))
								]);
						} else {
							return _List_fromArray(
								[
									A2(
									$author$project$Ui$Table$cell,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Deposit$totalFeeInCents(deposit)))
										]))
								]);
						}
					}(),
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							$author$project$Api$Provider$Reports$Deposit$canReconcile(deposit) ? _List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Deposit$discrepancyInCents(deposit))),
									(!(!$author$project$Api$Provider$Reports$Deposit$discrepancyInCents(deposit))) ? A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$placement(0)
										]),
									'Occasionally there are discrepancies due to failed ACH or disputed payments',
									_List_fromArray(
										[
											$author$project$Utils$Html$noBreakSpace,
											A2(
											$author$project$Ui$Icon$view,
											_List_fromArray(
												[
													$author$project$Ui$Icon$pull(1)
												]),
											5)
										])) : $author$project$Utils$Html$empty
								]) : _List_fromArray(
								[
									$elm$html$Html$text('N/A'),
									A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$placement(0)
										]),
									'Non Automated Deposits cannot be reconciled',
									_List_fromArray(
										[
											$author$project$Utils$Html$noBreakSpace,
											A2(
											$author$project$Ui$Icon$view,
											_List_fromArray(
												[
													$author$project$Ui$Icon$pull(1)
												]),
											5)
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$author$project$Api$Provider$Reports$Deposit$receiptsCount(deposit)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Utils$Html$empty,
									A4(
										$author$project$Utils$PaymentProcessor$toBadge,
										true,
										isHintAdmin,
										deposit,
										A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Deposit$paymentProcessor, $elm$core$Maybe$Just)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v1 = _Utils_Tuple2(
										$author$project$Api$Provider$Reports$Deposit$status(deposit),
										$author$project$Api$Provider$Reports$Deposit$errorMessage(deposit));
									if ((_v1.a === 4) && (!_v1.b.$)) {
										var _v2 = _v1.a;
										var errorMessage = _v1.b.a;
										return A3(
											$author$project$Ui$Tooltip$view,
											_List_fromArray(
												[
													$author$project$Ui$Tooltip$placement(0)
												]),
											errorMessage,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Provider$Reports$Deposit$statusToString(
														$author$project$Api$Provider$Reports$Deposit$status(deposit)))
												]));
									} else {
										return A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$Reports$Deposit$statusToString(
												$author$project$Api$Provider$Reports$Deposit$status(deposit)));
									}
								}()
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v3 = _Utils_Tuple2(
										isHintAdmin,
										$author$project$Api$Provider$Reports$Deposit$paymentProcessor(deposit));
									if (_v3.a && (_v3.b === 'rainforest')) {
										return A3(
											$author$project$Ui$HinterOnly$button,
											{abp: 'View on rainforest'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Components$Reports$Deposits$OpenRainforestDepositModal(deposit))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('View on Rainforest')
												]));
									} else {
										return $author$project$Utils$Html$empty;
									}
								}()
								]))
						])
					])));
	});
var $author$project$Components$Reports$Deposits$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.b1;
		if (_v1.$ === 3) {
			var deposits_ = _v1.a;
			return _Utils_Tuple2(false, deposits_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var deposits = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$Deposits$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$Deposits$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$Deposits$viewRow, model.FR, model.Pg),
			deposits),
		_List_Nil);
};
var $author$project$Components$Reports$Deposits$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Deposits$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.b1)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Deposit$listOptionsToParams, $author$project$Components$Reports$Deposits$fetchDepositsParams)(model))
						]),
					model.l9)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$Rainforest$SessionModal$view($author$project$Components$Reports$Deposits$CloseRainforestDepositModal),
					model.gt)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Deposits')
									])),
								A2($author$project$Components$Reports$Deposits$viewDepositSummary, model.w9, model.WF),
								$author$project$Ui$Typography$heading(
								function () {
									var _v0 = model.b1;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-amount'))),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														function () {
														var _v1 = model.Pg;
														if (!_v1) {
															return $elm$html$Html$text(
																' after ' + ($author$project$Utils$Currency$fromInt(
																	A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-stripe-fee-amount')) + (' in Processing fees and ' + ($author$project$Utils$Currency$fromInt(
																	A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-hint-fee-amount')) + (' in Platform fees across ' + A2(
																	$author$project$Formatters$String$pluralize,
																	'deposit',
																	A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-count')))))));
														} else {
															return $elm$html$Html$text(
																' after ' + ($author$project$Utils$Currency$fromInt(
																	A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-fee-amount')) + (' in transaction fees across ' + A2(
																	$author$project$Formatters$String$pluralize,
																	'deposit',
																	A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-count')))));
														}
													}()
													]))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Deposits$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.h3)),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(5),
												$author$project$Ui$FlexGrid$spanSm(3),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$Deposits$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$Deposits$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Deposits$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.b1)))
										]),
									model.afy))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$Deposits$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Deposits$view, model.D5, model.jO)),
		$G: 'Reports | Deposits'
	};
};
var $author$project$Pages$Reports$Deposits$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Deposits$init, aer: $author$project$Pages$Reports$Deposits$load, agD: $author$project$Pages$Reports$Deposits$save, ahd: $author$project$Pages$Reports$Deposits$subscriptions, aaq: $author$project$Pages$Reports$Deposits$update, ahP: $author$project$Pages$Reports$Deposits$view});
var $author$project$Pages$Reports$Disputes$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Disputes$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$Dispute = 21;
var $author$project$Components$Reports$Disputes$StatusDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$Disputes$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$Disputes$GotDisputes = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Disputes$fetchDisputesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				afy: model.afy,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				ag7: model.ag7
			});
	};
};
var $author$project$Api$Provider$Reports$Dispute$Dispute = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Dispute$Record = F7(
	function (id, paymentProcessor, dueDate, amountInCents, status, reasonCode, reasonDescription) {
		return {I2: amountInCents, N1: dueDate, adR: id, V0: paymentProcessor, XQ: reasonCode, XR: reasonDescription, ag7: status};
	});
var $author$project$Api$Provider$Reports$Dispute$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reason_description',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'reason_code',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'amount_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'due_date',
					$author$project$Utils$Date$decode,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'payment_processor',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Dispute$Record))))))));
var $author$project$Api$Provider$Reports$Dispute$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Dispute$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Dispute$listDefaults = {E9: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$Dispute$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Dispute$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.ag7;
						if (!_v2.$) {
							var status_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', status_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Dispute$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'disputes']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Dispute$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Dispute$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Dispute$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Dispute$listPath)));
	});
var $author$project$Components$Reports$Disputes$fetchDisputes = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Dispute$list,
			apiClient,
			$author$project$Components$Reports$Disputes$fetchDisputesParams(model),
			$author$project$Components$Reports$Disputes$GotDisputes);
	});
var $author$project$Components$Reports$Disputes$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'due_date', true, 'Due Date'),
		A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
		A3($author$project$Api$Column$init, 'reason_code', true, 'Reason Code'),
		A3($author$project$Api$Column$init, 'status', true, 'Status')
	]);
var $author$project$Components$Reports$Disputes$updateUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.ag7)
		]);
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Disputes)
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
};
var $author$project$Components$Reports$Disputes$init = F3(
	function (session, shared, query) {
		var _v0 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v0.a;
		var end = _v0.b;
		var _v1 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Disputes$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, shared.cO, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, shared.cO, 0),
					end)));
		var dateRangeInput = _v1.a;
		var dateRangeInputCmd = _v1.b;
		var model = {
			Ll: $author$project$Components$Reports$Disputes$initColumns,
			cO: shared.cO,
			h3: dateRangeInput,
			fw: $elm$core$Maybe$Nothing,
			b2: $author$project$Api$Data$Loading,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 21}),
			FR: $author$project$Shared$isHintAdmin(shared),
			FS: $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session),
			afy: $author$project$Api$Pagination$initFromQuery(query),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'due_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			ag7: A2($elm$core$Dict$get, 'status', query),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'disputes-status-dropdown', ahx: $author$project$Components$Reports$Disputes$StatusDropdownMsg}))
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DateRangeInputMsg, dateRangeInputCmd),
						A2($author$project$Components$Reports$Disputes$fetchDisputes, shared.D5, model),
						$author$project$Components$Reports$Disputes$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$Disputes$init = F4(
	function (session, _v0, shared, _v1) {
		var query = _v1.Bi;
		var _v2 = A3($author$project$Components$Reports$Disputes$init, session, shared, query);
		var report = _v2.a;
		var reportCmd = _v2.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Disputes$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Disputes$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Disputes$CloseDisputeModal = {$: 8};
var $author$project$Components$Reports$Disputes$ExportCsvMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Disputes$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Disputes$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Disputes$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				$author$project$Ui$NewDropdown$subscriptions(model.oA),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$always(
						$author$project$Components$DisputeModal$subscriptions($author$project$Components$Reports$Disputes$CloseDisputeModal)),
					model.fw))
			]));
};
var $author$project$Pages$Reports$Disputes$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Disputes$subscriptions(model.jO));
};
var $author$project$Components$Reports$Disputes$DisputeModalMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Provider$Reports$Dispute$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Components$Reports$Disputes$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								b2: $author$project$Api$Data$Loading,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
						$author$project$Components$Reports$Disputes$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var statusDropdown = _v3.a;
				var statusDropdownCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: statusDropdown}),
					statusDropdownCmd,
					_List_Nil);
			case 2:
				var selectedOption = msg.a;
				var newModel = _Utils_update(
					model,
					{
						b2: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						ag7: function () {
							if (selectedOption.$ === 1) {
								return $elm$core$Maybe$Nothing;
							} else {
								var status = selectedOption.a;
								return $elm$core$Maybe$Just(status);
							}
						}()
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
								$author$project$Components$Reports$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b2: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b2: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 4:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{b2: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
								$author$project$Components$Reports$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
								$author$project$Components$Reports$Disputes$updateUrl(newModel)
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v6 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v6.a;
				var subCmd = _v6.b;
				var subOutMsg = _v6.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$ExportCsvMsg, subCmd),
					subOutMsg);
			case 7:
				var dispute = msg.a;
				var _v7 = A3(
					$author$project$Components$DisputeModal$init,
					$author$project$Api$Data$providerPath,
					apiClient,
					$author$project$Api$Provider$Reports$Dispute$id(dispute));
				var disputeModal = _v7.a;
				var disputeModalCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							fw: $elm$core$Maybe$Just(disputeModal)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DisputeModalMsg, disputeModalCmd),
					_List_Nil);
			case 8:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fw: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v8 = model.fw;
				if (!_v8.$) {
					var disputeModal = _v8.a;
					var _v9 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
					var newDisputeModal = _v9.a;
					var disputeModalCmd = _v9.b;
					var disputeModalOutMsgs = _v9.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								fw: $elm$core$Maybe$Just(newDisputeModal)
							}),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DisputeModalMsg, disputeModalCmd),
						disputeModalOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
		}
	});
var $author$project$Pages$Reports$Disputes$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Disputes$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Disputes$PaginationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$Disputes$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$Disputes$None = {$: 1};
var $author$project$Components$Reports$Disputes$Status = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Disputes$StatusFiltered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Disputes$statusDropdownOptions = function (currentStatus) {
	var statusOptions = A2(
		$elm$core$List$map,
		function (status) {
			return A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$Disputes$StatusFiltered(
							$author$project$Components$Reports$Disputes$Status(status))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							$elm$core$Maybe$Just(status),
							currentStatus))
					]),
				$elm$html$Html$text(
					$author$project$Formatters$String$humanize(status)));
		},
		_List_fromArray(
			['created', 'action_required', 'processing', 'won', 'lost']));
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Disputes$StatusFiltered($author$project$Components$Reports$Disputes$None)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('No Filter')),
		A2($elm$core$List$cons, $author$project$Ui$NewDropdown$separator, statusOptions));
};
var $author$project$Components$Reports$Disputes$viewStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				A2(
					$elm$core$Maybe$withDefault,
					'All Status',
					A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, model.ag7)))
			]),
		$author$project$Components$Reports$Disputes$statusDropdownOptions(model.ag7),
		model.oA);
};
var $author$project$Components$Reports$Disputes$SortTable = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Disputes$OpenDisputeModal = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Reports$Dispute$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$Dispute$dueDate = function (_v0) {
	var record = _v0;
	return record.N1;
};
var $author$project$Api$Provider$Reports$Dispute$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$Reports$Dispute$reasonCode = function (_v0) {
	var record = _v0;
	return record.XQ;
};
var $author$project$Api$Provider$Reports$Dispute$reasonDescription = function (_v0) {
	var record = _v0;
	return record.XR;
};
var $author$project$Api$Provider$Reports$Dispute$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Components$Reports$Disputes$viewRow = F3(
	function (isHintAdmin, isPracticeAdmin, dispute) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$Date$toString,
								$author$project$Formatters$Date$Full,
								$author$project$Api$Provider$Reports$Dispute$dueDate(dispute)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$Currency$fromInt(
								$author$project$Api$Provider$Reports$Dispute$amountInCents(dispute)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							function () {
							var _v0 = $author$project$Api$Provider$Reports$Dispute$reasonDescription(dispute);
							if (!_v0.$) {
								var reasonDescription = _v0.a;
								return A3(
									$author$project$Ui$Tooltip$view,
									_List_fromArray(
										[
											$author$project$Ui$Tooltip$placement(0)
										]),
									reasonDescription,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$Reports$Dispute$reasonCode(dispute))
										]));
							} else {
								return A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$Reports$Dispute$reasonCode(dispute));
							}
						}()
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$Reports$Dispute$status(dispute))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[
							$author$project$Ui$Table$colspan(2),
							$author$project$Ui$Table$textRight
						]),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$author$project$Utils$Html$empty,
							A4(
								$author$project$Utils$PaymentProcessor$toBadge,
								isHintAdmin,
								isHintAdmin,
								dispute,
								A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Dispute$paymentProcessor, $elm$core$Maybe$Just))),
							function () {
							var _v1 = _Utils_Tuple2(
								$author$project$Api$Provider$Reports$Dispute$paymentProcessor(dispute),
								isPracticeAdmin);
							if ((_v1.a === 'rainforest') && _v1.b) {
								return A3(
									$author$project$Ui$Button$view,
									{abp: 'View dispute'},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick(
											$author$project$Components$Reports$Disputes$OpenDisputeModal(dispute))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('View Dispute')
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]));
	});
var $author$project$Components$Reports$Disputes$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.b2;
		if (_v1.$ === 3) {
			var disputes_ = _v1.a;
			return _Utils_Tuple2(false, disputes_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var disputes = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$Disputes$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$Disputes$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$Disputes$viewRow, model.FR, model.FS),
			disputes),
		_List_Nil);
};
var $author$project$Components$Reports$Disputes$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Disputes$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.b2)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Dispute$listOptionsToParams, $author$project$Components$Reports$Disputes$fetchDisputesParams)(model))
						]),
					model.l9)),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					$author$project$Components$DisputeModal$view($author$project$Components$Reports$Disputes$CloseDisputeModal),
					model.fw)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Disputes')
									])),
								$author$project$Ui$Typography$heading(
								function () {
									var _v0 = model.b2;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-amount'))),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														' after ' + ($author$project$Utils$Currency$fromInt(
															A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-fee-amount')) + (' in transaction fees across ' + A2(
															$author$project$Formatters$String$pluralize,
															'dispute',
															A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-count')))))
													]))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Disputes$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.h3)),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(5),
												$author$project$Ui$FlexGrid$spanSm(3),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$Disputes$viewStatusDropdown(model)
											]))
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$Disputes$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Disputes$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.b2)))
										]),
									model.afy))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$Disputes$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Disputes$view, model.D5, model.jO)),
		$G: 'Reports | Disputes'
	};
};
var $author$project$Pages$Reports$Disputes$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Disputes$init, aer: $author$project$Pages$Reports$Disputes$load, agD: $author$project$Pages$Reports$Disputes$save, ahd: $author$project$Pages$Reports$Disputes$subscriptions, aaq: $author$project$Pages$Reports$Disputes$update, ahP: $author$project$Pages$Reports$Disputes$view});
var $author$project$Pages$Reports$Invoices$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Invoices$AutopayDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Provider$Report$CustomerInvoice = 12;
var $author$project$Components$Reports$Invoices$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$Invoices$StatusDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Invoices$Disabled = 1;
var $author$project$Components$Reports$Invoices$Enabled = 0;
var $author$project$Components$Reports$Invoices$autopayStatusFromString = function (string) {
	switch (string) {
		case 'enabled':
			return $elm$core$Maybe$Just(0);
		case 'disabled':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$Invoices$additionalMonthOptions = function (currentDate) {
	return _List_fromArray(
		[
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'upcoming',
			'Upcoming',
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, 1, currentDate)),
			$elm$core$Maybe$Nothing),
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'date_under_30_days',
			'< 30 Days',
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, -29, currentDate)),
			$elm$core$Maybe$Just(currentDate)),
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'date_30_to_59_days',
			'30 - 59 Days',
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, -59, currentDate)),
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, -30, currentDate))),
			A4(
			$author$project$Components$DateRangeInput$additionalItem,
			'date_60_plus_days',
			'60+ Days',
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(
				A3($justinmimbs$date$Date$add, 3, -60, currentDate)))
		]);
};
var $author$project$Components$Reports$Invoices$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{kT: $author$project$Components$Reports$Invoices$additionalMonthOptions, adD: start, ahu: end});
	});
var $author$project$Components$Reports$Invoices$GotCustomerInvoices = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Invoices$autopayFromString = function (string) {
	switch (string) {
		case 'disabled':
			return $elm$core$Maybe$Just(false);
		case 'enabled':
			return $elm$core$Maybe$Just(true);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$Invoices$autopayStatusToString = function (autopay) {
	if (!autopay) {
		return 'enabled';
	} else {
		return 'disabled';
	}
};
var $author$project$Components$Reports$Invoices$invoiceStatusToString = function (status) {
	switch (status) {
		case 0:
			return 'draft';
		case 1:
			return 'issued';
		case 2:
			return 'issued,sent,retrying';
		case 3:
			return 'paid';
		case 4:
			return 'sent';
		case 5:
			return 'retrying';
		case 6:
			return 'cancelled';
		case 7:
			return 'bad_debt';
		default:
			return 'disputed';
	}
};
var $author$project$Components$Reports$Invoices$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				JI: A2(
					$elm$core$Maybe$andThen,
					A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$autopayStatusToString, $author$project$Components$Reports$Invoices$autopayFromString),
					model.JI),
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afy: model.afy,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				ag7: A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$Reports$Invoices$invoiceStatusToString,
						$elm$core$String$split(',')),
					model.ag7)
			});
	};
};
var $author$project$Components$Reports$Invoices$fetchInvoices = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$CustomerInvoice$list,
			apiClient,
			$author$project$Components$Reports$Invoices$fetchParams(model),
			$author$project$Components$Reports$Invoices$GotCustomerInvoices);
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed = {$: 0};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$init = $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed;
var $author$project$Components$Reports$Invoices$initColumns = function (trackPatientsByLocation) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'date', true, 'Date'),
					A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
					A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
					A3($author$project$Api$Column$init, 'total_in_cents', true, 'Billed'),
					A3($author$project$Api$Column$init, 'paid_in_cents', true, 'Paid'),
					A3($author$project$Api$Column$init, 'due_in_cents', true, 'Due'),
					A3($author$project$Api$Column$init, 'owner', true, 'Payer')
				]),
				trackPatientsByLocation ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'location', true, 'Location')
				]) : _List_Nil
			]));
};
var $author$project$Components$Reports$Invoices$BadDebt = 7;
var $author$project$Components$Reports$Invoices$Cancelled = 6;
var $author$project$Components$Reports$Invoices$Disputed = 8;
var $author$project$Components$Reports$Invoices$Draft = 0;
var $author$project$Components$Reports$Invoices$Issued = 1;
var $author$project$Components$Reports$Invoices$Outstanding = 2;
var $author$project$Components$Reports$Invoices$Paid = 3;
var $author$project$Components$Reports$Invoices$Retrying = 5;
var $author$project$Components$Reports$Invoices$Sent = 4;
var $author$project$Components$Reports$Invoices$invoiceStatusFromString = function (string) {
	switch (string) {
		case 'draft':
			return $elm$core$Maybe$Just(0);
		case 'issued':
			return $elm$core$Maybe$Just(1);
		case 'issued,sent,retrying':
			return $elm$core$Maybe$Just(2);
		case 'paid':
			return $elm$core$Maybe$Just(3);
		case 'sent':
			return $elm$core$Maybe$Just(4);
		case 'retrying':
			return $elm$core$Maybe$Just(5);
		case 'cancelled':
			return $elm$core$Maybe$Just(6);
		case 'bad_debt':
			return $elm$core$Maybe$Just(7);
		case 'disputed':
			return $elm$core$Maybe$Just(8);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$Invoices$urlFromModel = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('status'),
				$author$project$Components$Reports$Invoices$invoiceStatusToString),
			model.ag7),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('autopay'),
				$author$project$Components$Reports$Invoices$autopayStatusToString),
			model.JI)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Invoices)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Reports$Invoices$init = F4(
	function (session, practice, _v0, query) {
		var currentDate = _v0.cO;
		var timeFormatter = _v0.Hy;
		var apiClient = _v0.D5;
		var url = _v0.aav;
		var hinterViewOff = _v0.adN;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var _v1 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, true, locationGroupId, locationId, $elm$core$Maybe$Nothing);
		var groupLocationAndPractitionerFilters = _v1.a;
		var groupLocationAndPractitionerFiltersCmd = _v1.b;
		var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v2.a;
		var end = _v2.b;
		var _v3 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Invoices$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v3.a;
		var dateRangeInputCmd = _v3.b;
		var model = {
			JI: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$Invoices$autopayStatusFromString,
				A2($elm$core$Dict$get, 'autopay', query)),
			k8: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'autopay-dropdown', ahx: $author$project$Components$Reports$Invoices$AutopayDropdownMsg})),
			pH: false,
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			Ll: $author$project$Components$Reports$Invoices$initColumns(trackPatientsByLocation),
			cO: currentDate,
			lH: $author$project$Components$CustomerEmailModal$init,
			lJ: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$init,
			cP: $author$project$Api$Data$Loading,
			h3: dateRangeInput,
			iq: $author$project$Components$Invoice$DownloadFile$init(url),
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 12}),
			b7: groupLocationAndPractitionerFilters,
			fW: locationGroupId,
			S3: locationId,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			GI: $author$project$Api$Provider$Practice$One$deactivated(practice),
			ZD: session,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			ag7: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$Invoices$invoiceStatusFromString,
				A2($elm$core$Dict$get, 'status', query)),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'status-dropdown', ahx: $author$project$Components$Reports$Invoices$StatusDropdownMsg})),
			Hy: timeFormatter,
			$$: trackPatientsByLocation
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, model),
						$author$project$Ports$Navigation$replaceUrl(
						$author$project$Components$Reports$Invoices$urlFromModel(model))
					])));
	});
var $author$project$Pages$Reports$Invoices$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A4($author$project$Components$Reports$Invoices$init, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Invoices$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Invoices$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Invoices$CustomerEmailModalMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Reports$Invoices$DownloadInvoiceMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$Invoices$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close = {$: 2};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Components$Reports$Invoices$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$subscriptions(model.lH)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg,
				$author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$subscriptions(model.lJ)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$DownloadInvoiceMsg,
				$author$project$Components$Invoice$DownloadFile$subscriptions(model.iq)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b7)),
				$author$project$Ui$NewDropdown$subscriptions(model.oA),
				$author$project$Ui$NewDropdown$subscriptions(model.k8)
			]));
};
var $author$project$Pages$Reports$Invoices$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Invoices$subscriptions(model.jO));
};
var $author$project$Components$Reports$Invoices$BulkIssueTriggered = {$: 12};
var $author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['customer_invoices', 'bulk']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$CustomerInvoice$Bulk$issue = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['issue']),
						$author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath))));
	});
var $author$project$Components$Reports$Invoices$issueInvoices = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$CustomerInvoice$Bulk$issue,
			apiClient,
			$author$project$Components$Reports$Invoices$fetchParams(model),
			$elm$core$Basics$always($author$project$Components$Reports$Invoices$BulkIssueTriggered));
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsStarted = 1;
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$None = 0;
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$CustomerInvoice$Bulk$processPayments = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['process_payments']),
						$author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath))));
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$update = F2(
	function (msg, model) {
		if (model.$ === 1) {
			var open = model.a;
			switch (msg.$) {
				case 2:
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed, as: _List_Nil};
				case 0:
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				default:
					return {
						EC: A3(
							$author$project$Api$Provider$CustomerInvoice$Bulk$processPayments,
							open.D5,
							open.Vx,
							$elm$core$Basics$always($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)),
						ac5: 1,
						y8: model,
						as: _List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Bulk process payments started. This may take a while to process.')
							])
					};
			}
		} else {
			if (!msg.$) {
				var apiClient = msg.a;
				var params = msg.b;
				var totalCount = msg.c;
				var status = msg.d;
				var start = msg.e;
				var end = msg.f;
				var currentDate = msg.g;
				var open = {D5: apiClient, cO: currentDate, E9: end, Vx: params, Hl: start, ag7: status, oN: totalCount};
				return {
					EC: $elm$core$Platform$Cmd$none,
					ac5: 0,
					y8: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Open(open),
					as: _List_Nil
				};
			} else {
				return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
			}
		}
	});
var $author$project$Components$Reports$Invoices$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v1.a;
				var subCmd = _v1.b;
				var event = _v1.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								cP: $author$project$Api$Data$Loading,
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b7);
				var _v3 = result.ac5;
				switch (_v3.$) {
					case 0:
						var locationGroupId = _v3.a;
						var locationId = _v3.b;
						var newModel = _Utils_update(
							model,
							{
								cP: $author$project$Api$Data$Loading,
								b7: result.y8,
								fW: locationGroupId,
								S3: locationId,
								afy: $author$project$Api$Pagination$reset(model.afy)
							});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, result.EC),
										A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
										A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 2:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var statusDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: statusDropdown}),
					cmd,
					_List_Nil);
			case 3:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						cP: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy),
						ag7: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$NewDropdown$update, subMsg, model.k8);
				var autopayDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k8: autopayDropdown}),
					cmd,
					_List_Nil);
			case 5:
				var autopay = msg.a;
				var newModel = _Utils_update(
					model,
					{
						JI: autopay,
						cP: $author$project$Api$Data$Loading,
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 6:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								pH: false,
								cP: response,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{cP: $author$project$Api$Data$Loading, afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v7 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v7.a;
				var subCmd = _v7.b;
				var subOutMsg = _v7.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$ExportCsvMsg, subCmd),
					subOutMsg);
			case 10:
				var subMsg = msg.a;
				var _v8 = A3($author$project$Components$CustomerEmailModal$update, apiClient, subMsg, model.lH);
				var customerEmailModal = _v8.a;
				var subCmd = _v8.b;
				var subOutMsg = _v8.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lH: customerEmailModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$CustomerEmailModalMsg, subCmd),
					subOutMsg);
			case 11:
				var subMsg = msg.a;
				var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, apiClient, subMsg, model.iq);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iq: downloadInvoiceResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DownloadInvoiceMsg, downloadInvoiceResult.EC),
					downloadInvoiceResult.as);
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{pH: true}),
					A2($author$project$Components$Reports$Invoices$issueInvoices, apiClient, model),
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Bulk issue invoices started. This may take a while to process.')
						]));
			default:
				var subMsg = msg.a;
				var customerInvoiceBulkPaymentModalResult = A2($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$update, subMsg, model.lJ);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lJ: customerInvoiceBulkPaymentModalResult.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg, customerInvoiceBulkPaymentModalResult.EC),
					customerInvoiceBulkPaymentModalResult.as);
		}
	});
var $author$project$Pages$Reports$Invoices$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Invoices$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Invoices$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$Invoices$intFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$Invoices$IssueButtonClicked = {$: 13};
var $author$project$Components$Reports$Invoices$viewIssueButton = function (bulkIssueTriggered) {
	return bulkIssueTriggered ? $author$project$Utils$Html$empty : A3(
		$author$project$Ui$Button$view,
		{abp: 'Issue invoices'},
		_List_fromArray(
			[
				$author$project$Ui$Button$primary,
				$author$project$Ui$Button$pull(1),
				$author$project$Ui$Button$onClick($author$project$Components$Reports$Invoices$IssueButtonClicked)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Issue Invoices')
			]));
};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$OpenModal = F7(
	function (a, b, c, d, e, f, g) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$button = F7(
	function (apiClient, params, totalCount, status, start, end, currentDate) {
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Process payments'},
			_List_fromArray(
				[
					$author$project$Ui$Button$success,
					$author$project$Ui$Button$pull(1),
					$author$project$Ui$Button$onClick(
					A7($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$OpenModal, apiClient, params, totalCount, status, start, end, currentDate))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('$ Process Payments')
				]));
	});
var $author$project$Components$Reports$Invoices$viewProcessPaymentsButton = F2(
	function (apiClient, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg,
			A7(
				$author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$button,
				apiClient,
				$author$project$Components$Reports$Invoices$fetchParams(model),
				$author$project$Api$Pagination$headerTotalCount(model.afy),
				A2($elm$core$Maybe$map, $author$project$Components$Reports$Invoices$invoiceStatusToString, model.ag7),
				model.Hl,
				model.E9,
				model.cO));
	});
var $author$project$Components$Reports$Invoices$issueOrProcessPaymentButton = F2(
	function (apiClient, model) {
		var anyInvoices = function () {
			var _v6 = model.cP;
			if (_v6.$ === 3) {
				var customerInvoices = _v6.a;
				return !$elm$core$List$isEmpty(customerInvoices);
			} else {
				return false;
			}
		}();
		var _v0 = _Utils_Tuple2(model.ag7, anyInvoices);
		_v0$5:
		while (true) {
			if ((!_v0.a.$) && _v0.b) {
				switch (_v0.a.a) {
					case 0:
						var _v1 = _v0.a.a;
						return $author$project$Components$Reports$Invoices$viewIssueButton(model.pH);
					case 1:
						var _v2 = _v0.a.a;
						return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
					case 4:
						var _v3 = _v0.a.a;
						return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
					case 5:
						var _v4 = _v0.a.a;
						return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
					case 2:
						var _v5 = _v0.a.a;
						return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsClicked = {$: 1};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$formatDateRange = F3(
	function (start, end, currentDate) {
		var startDate = function () {
			if (!start.$) {
				var date = start.a;
				return A2(
					$author$project$Formatters$Date$toString,
					$author$project$Formatters$Date$Full,
					A3($author$project$Utils$DateWithDefault$toDate, currentDate, 0, date));
			} else {
				return '';
			}
		}();
		var endDate = function () {
			if (!end.$) {
				var date = end.a;
				return A2(
					$author$project$Formatters$Date$toString,
					$author$project$Formatters$Date$Full,
					A3($author$project$Utils$DateWithDefault$toDate, currentDate, 0, date));
			} else {
				return '';
			}
		}();
		var _v0 = _Utils_Tuple2(
			$elm$core$String$isEmpty(startDate),
			$elm$core$String$isEmpty(endDate));
		if (_v0.a) {
			if (!_v0.b) {
				return $elm$html$Html$text(' < ' + endDate);
			} else {
				return $elm$html$Html$text('All Dates');
			}
		} else {
			if (!_v0.b) {
				return $elm$html$Html$text(startDate + (' - ' + endDate));
			} else {
				return $elm$html$Html$text(startDate + ' > ');
			}
		}
	});
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$viewMovePaymentMethodsModal = function (open) {
	return A2(
		$author$project$Ui$Form$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$horizontal,
				$author$project$Ui$Form$noValidate(true),
				$author$project$Ui$Form$autocomplete(true),
				$author$project$Ui$Form$onSubmit($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)
			]),
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Process Payments')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9),
												$author$project$Ui$Form$Group$label('Enabled Filters')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$div,
														_List_Nil,
														_List_fromArray(
															[
																A3($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$formatDateRange, open.Hl, open.E9, open.cO)
															])),
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$capitalized]),
														_List_fromArray(
															[
																function () {
																var _v0 = open.ag7;
																if (!_v0.$) {
																	var status = _v0.a;
																	return $elm$html$Html$text(
																		A2(
																			$elm$core$String$join,
																			', ',
																			A2($elm$core$String$split, ',', status)));
																} else {
																	return $elm$html$Html$text('');
																}
															}()
															]))
													]))
											])),
										A2(
										$author$project$Ui$Form$Group$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Group$labelSpanSm(3),
												$author$project$Ui$Form$Group$inputSpanSm(9),
												$author$project$Ui$Form$Group$label('Invoices to Process')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Form$Static$view,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$bold]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$elm$core$String$fromInt(open.oN) + ' patient invoices')
															]))
													]))
											])),
										A2(
										$author$project$Ui$Alert$info,
										_List_fromArray(
											[
												$author$project$Ui$Alert$margin(20),
												$author$project$Ui$Alert$margin(2),
												$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
											]),
										_List_fromArray(
											[
												$author$project$Ui$SvgIcon$alert(
												_List_fromArray(
													[$author$project$Ui$SvgIcon$xl])),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$black,
														$author$project$Ui$Typography$margin(10)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('You will receive an email notification for payments that fail to process.')
													]))
											]))
									]))
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$div,
								_List_fromArray(
									[
										$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Cancel and close modal'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Cancel')
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Process payments'},
										_List_fromArray(
											[
												$author$project$Ui$Button$success,
												$author$project$Ui$Button$submit,
												$author$project$Ui$Button$onClick($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsClicked)
											]),
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 46),
												$elm$html$Html$text(
												' Process ' + ($elm$core$String$fromInt(open.oN) + ' payments'))
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$modal = function (model) {
	if (model.$ === 1) {
		var open = model.a;
		return $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$viewMovePaymentMethodsModal(open);
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Reports$Invoices$AutopaySelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Invoices$autopayToDisplayName = function (autopay) {
	if (!autopay) {
		return 'Autopay Enabled';
	} else {
		return 'Autopay Disabled';
	}
};
var $author$project$Components$Reports$Invoices$autopayDropdownItems = function (current) {
	var toItem = function (autopay) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Invoices$AutopaySelected(
						$elm$core$Maybe$Just(autopay))),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						current,
						$elm$core$Maybe$Just(autopay)))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Invoices$autopayToDisplayName(autopay)));
	};
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Invoices$AutopaySelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(current, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Autopay')),
			$author$project$Ui$NewDropdown$separator,
			toItem(0),
			toItem(1)
		]);
};
var $author$project$Components$Reports$Invoices$viewAutopayDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.JI;
		if (!_v0.$) {
			var autopay = _v0.a;
			return $author$project$Components$Reports$Invoices$autopayToDisplayName(autopay);
		} else {
			return 'Autopay';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$Invoices$autopayDropdownItems(model.JI),
		model.k8);
};
var $author$project$Components$Reports$Invoices$StatusSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Invoices$statusToDisplayName = function (status) {
	switch (status) {
		case 0:
			return 'Draft';
		case 1:
			return 'Issued (Not Sent)';
		case 2:
			return 'Outstanding (Issued, Sent, Retrying)';
		case 3:
			return 'Paid';
		case 4:
			return 'Sent';
		case 5:
			return 'Retrying';
		case 6:
			return 'Cancelled';
		case 7:
			return 'Bad Debt';
		default:
			return 'Disputed';
	}
};
var $author$project$Components$Reports$Invoices$statusDropdownItems = function (current) {
	var toItem = function (status) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Invoices$StatusSelected(
						$elm$core$Maybe$Just(status))),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						current,
						$elm$core$Maybe$Just(status)))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Invoices$statusToDisplayName(status)));
	};
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Invoices$StatusSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(current, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Statuses')),
			$author$project$Ui$NewDropdown$separator,
			toItem(0),
			toItem(1),
			toItem(2),
			$author$project$Ui$NewDropdown$separator,
			toItem(3),
			toItem(4),
			toItem(5),
			toItem(6),
			toItem(7),
			toItem(8)
		]);
};
var $author$project$Components$Reports$Invoices$viewStatusDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.ag7;
		if (!_v0.$) {
			var status = _v0.a;
			return $author$project$Components$Reports$Invoices$statusToDisplayName(status);
		} else {
			return 'Status';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$Invoices$statusDropdownItems(model.ag7),
		model.oA);
};
var $author$project$Components$Reports$Invoices$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CustomerEmailModal$ReportsPatient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Table$Warning = 3;
var $author$project$Api$Provider$Reports$CustomerInvoice$creditInCents = function (_v0) {
	var record = _v0;
	return record.Ml;
};
var $author$project$Components$CustomerEmailModal$Disabled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$CustomerEmailModal$disabled = $author$project$Components$CustomerEmailModal$Disabled;
var $author$project$Api$Provider$Reports$CustomerInvoice$dueDate = function (_v0) {
	var record = _v0;
	return record.N1;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$dueInCents = function (_v0) {
	var record = _v0;
	return record.N2;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$humanStatus = function (_v0) {
	var record = _v0;
	return record.QE;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber = function (_v0) {
	var record = _v0;
	return record.Rq;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$isCustomerViewable = function (_v0) {
	var record = _v0;
	return record.RG;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$isPastDue = function (_v0) {
	var record = _v0;
	return record.RY;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$isPaymentScheduled = function (_v0) {
	var record = _v0;
	return record.R_;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents = function (_v0) {
	var record = _v0;
	return record.Sn;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$lastSentAt = function (_v0) {
	var record = _v0;
	return record.SD;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$location = function (_v0) {
	var record = _v0;
	return record.aet;
};
var $author$project$Api$Provider$Reports$Patient$onePhoneNumber = function (_v0) {
	var record = _v0;
	return record.Wh;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$owner = function (_v0) {
	var record = _v0;
	return record.Vp;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$paidAt = function (_v0) {
	var record = _v0;
	return record.Vt;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$paidInCents = function (_v0) {
	var record = _v0;
	return record.Vu;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$paymentScheduledOn = function (_v0) {
	var record = _v0;
	return record.V2;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$securePdfInlineToken = function (_v0) {
	var record = _v0;
	return record.Ze;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Reports$CustomerInvoice$totalInCents = function (_v0) {
	var record = _v0;
	return record.$X;
};
var $author$project$Components$Reports$Invoices$viewRow = F2(
	function (model, customerInvoice) {
		var isPastDue = $author$project$Api$Provider$Reports$CustomerInvoice$isPastDue(customerInvoice);
		return A2(
			$author$project$Ui$Table$row,
			isPastDue ? _List_fromArray(
				[
					$author$project$Ui$Table$styled(3)
				]) : _List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									isPastDue ? _List_fromArray(
										[$author$project$Ui$Typography$danger]) : _List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$Reports$CustomerInvoice$dueDate(customerInvoice)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = _Utils_Tuple2(
									model.Er,
									$author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice));
								if (_v0.a && (!_v0.b.$)) {
									var owner = _v0.b.a;
									return _List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
												{
													aea: $author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice),
													VN: $author$project$Api$Provider$Reports$Patient$oneId(owner)
												}),
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													'#' + $elm$core$String$fromInt(
														$author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber(customerInvoice)))
												]))
										]);
								} else {
									return _List_fromArray(
										[
											$elm$html$Html$text(
											'#' + $elm$core$String$fromInt(
												$author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber(customerInvoice)))
										]);
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									function () {
									var _v1 = _Utils_Tuple2(
										model.Er,
										$author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice));
									if (_v1.a && (!_v1.b.$)) {
										var owner = _v1.b.a;
										return A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
												{
													aea: $author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice),
													VN: $author$project$Api$Provider$Reports$Patient$oneId(owner)
												}),
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Badge$fromString,
													_List_Nil,
													$author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice))
												]));
									} else {
										return A2(
											$author$project$Ui$Badge$fromString,
											_List_Nil,
											$author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice));
									}
								}(),
									$author$project$Api$Provider$Reports$CustomerInvoice$isPaymentScheduled(customerInvoice) ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											' scheduled for ' + A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													$author$project$Api$Provider$Reports$CustomerInvoice$paymentScheduledOn(customerInvoice))))
										])) : (($author$project$Api$Provider$Reports$CustomerInvoice$status(customerInvoice) === 'sent') ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											' on ' + A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													model.Hy(5),
													$author$project$Api$Provider$Reports$CustomerInvoice$lastSentAt(customerInvoice))))
										])) : (($author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice) === 'paid') ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											' on ' + A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													model.Hy(5),
													$author$project$Api$Provider$Reports$CustomerInvoice$paidAt(customerInvoice))))
										])) : $author$project$Utils$Html$empty))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									($author$project$Api$Provider$Reports$CustomerInvoice$status(customerInvoice) === 'draft') ? A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice)))
										])) : A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											(!_Utils_eq(
											$author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice),
											$author$project$Api$Provider$Reports$CustomerInvoice$totalInCents(customerInvoice))) ? A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Utils$Currency$fromInt(
														$author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice)))
												])) : $author$project$Utils$Html$empty,
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$CustomerInvoice$totalInCents(customerInvoice)))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$CustomerInvoice$paidInCents(customerInvoice) + $author$project$Api$Provider$Reports$CustomerInvoice$creditInCents(customerInvoice)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$CustomerInvoice$dueInCents(customerInvoice)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v2 = $author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice);
								if (!_v2.$) {
									var owner = _v2.a;
									return _List_fromArray(
										[
											model.Er ? A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
												{
													VN: $author$project$Api$Provider$Reports$Patient$oneId(owner)
												}),
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Api$Provider$Reports$Patient$oneName(owner))
														]))
												])) : A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Reports$Patient$oneName(owner))
												])),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											function () {
											var _v3 = $author$project$Api$Provider$Reports$Patient$oneEmail(owner);
											if (!_v3.$) {
												var email = _v3.a;
												return A3(
													$author$project$Ui$Link$mailto,
													email,
													_List_fromArray(
														[$author$project$Ui$Link$targetBlank]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$span,
															_List_fromArray(
																[
																	$author$project$Ui$Typography$phi(true)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(email)
																]))
														]));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'',
														A2(
															$elm$core$Maybe$map,
															$author$project$Formatters$Phone$format,
															$author$project$Api$Provider$Reports$Patient$onePhoneNumber(owner))))
												]))
										]);
								} else {
									return _List_Nil;
								}
							}())
						]),
						model.$$ ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Location$Min$name,
											$author$project$Api$Provider$Reports$CustomerInvoice$location(customerInvoice))))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(2)
								]),
							$author$project$Api$Provider$Reports$CustomerInvoice$isCustomerViewable(customerInvoice) ? _List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$itemsEnd]),
									_List_fromArray(
										[
											function () {
											var _v4 = $author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice);
											if (!_v4.$) {
												var owner = _v4.a;
												return A2(
													$elm$html$Html$map,
													$author$project$Components$Reports$Invoices$CustomerEmailModalMsg,
													A5(
														$author$project$Components$CustomerEmailModal$button,
														model.ZD,
														_List_fromArray(
															[
																$author$project$Components$CustomerEmailModal$disabled(model.GI)
															]),
														0,
														$author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice),
														$author$project$Components$CustomerEmailModal$ReportsPatient(owner)));
											} else {
												return $author$project$Utils$Html$empty;
											}
										}(),
											A2(
											$elm$html$Html$map,
											$author$project$Components$Reports$Invoices$DownloadInvoiceMsg,
											A4(
												$author$project$Components$Invoice$DownloadFile$view,
												model.iq,
												$author$project$Api$Provider$Reports$CustomerInvoice$securePdfInlineToken(customerInvoice),
												_List_Nil,
												_List_fromArray(
													[$author$project$Ui$Button$sm])))
										]))
								]) : _List_Nil)
						])
					])));
	});
var $author$project$Components$Reports$Invoices$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.cP;
		if (_v1.$ === 3) {
			var invoices_ = _v1.a;
			return _Utils_Tuple2(false, invoices_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var customerInvoices = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$Invoices$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$Invoices$viewRow(model),
			customerInvoices),
		_List_Nil);
};
var $author$project$Components$Reports$Invoices$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Invoices$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.cP)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams, $author$project$Components$Reports$Invoices$fetchParams)(model))
						]),
					model.l9)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Invoices$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$modal(model.lH)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Patient Invoices')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg,
								$author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$modal(model.lJ)),
								A2($author$project$Components$Reports$Invoices$issueOrProcessPaymentButton, apiClient, model),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.cP;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										var totalReceivableAmount = A2($author$project$Components$Reports$Invoices$intFromHeader, headers, 'x-total-receivable-amount');
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$Invoices$intFromHeader, headers, 'x-total-billed-amount'))),
												(totalReceivableAmount > 0) ? $author$project$Ui$Typography$headingSm(
												_List_fromArray(
													[
														$elm$html$Html$text(
														'Total Due: ' + $author$project$Utils$Currency$fromInt(totalReceivableAmount))
													])) : $author$project$Utils$Html$empty
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Invoices$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.h3)),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$FlexGrid$column(
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.b7))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanSm(4),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Invoices$viewStatusDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(5),
													$author$project$Ui$FlexGrid$spanSm(3),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Invoices$viewAutopayDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg),
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b7));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$Invoices$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Invoices$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.cP)))
										]),
									model.afy))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$Invoices$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Invoices$view, model.D5, model.jO)),
		$G: 'Reports | Patient Invoices'
	};
};
var $author$project$Pages$Reports$Invoices$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Invoices$init, aer: $author$project$Pages$Reports$Invoices$load, agD: $author$project$Pages$Reports$Invoices$save, ahd: $author$project$Pages$Reports$Invoices$subscriptions, aaq: $author$project$Pages$Reports$Invoices$update, ahP: $author$project$Pages$Reports$Invoices$view});
var $author$project$Pages$Reports$Memberships$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Memberships$AutopayDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$Memberships$BillingPeriodDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Reports$Memberships$CouponResourceFilterMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Reports$Memberships$DateRangeInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Memberships$FilterDropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Memberships$MembershipPatients = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Memberships$Model = $elm$core$Basics$identity;
var $author$project$Components$Reports$Memberships$PlanResourceFilterMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$Memberships$RateCalculationDropdownMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Reports$Memberships$SourceStatusDropdownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$Memberships$AllAutopay = 0;
var $author$project$Components$Reports$Memberships$AutopayDisabled = 2;
var $author$project$Components$Reports$Memberships$AutopayEnabled = 1;
var $author$project$Components$Reports$Memberships$autopayStatusFromQuery = function (queryString) {
	_v0$2:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'enabled':
					return 1;
				case 'disabled':
					return 2;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Components$Reports$Memberships$AllBillingPeriods = 0;
var $author$project$Components$Reports$Memberships$Annually = 5;
var $author$project$Components$Reports$Memberships$Monthly = 1;
var $author$project$Components$Reports$Memberships$NonMonthly = 2;
var $author$project$Components$Reports$Memberships$Quarterly = 3;
var $author$project$Components$Reports$Memberships$SemiAnnually = 4;
var $author$project$Components$Reports$Memberships$billingPeriodFromQuery = function (queryString) {
	_v0$5:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case '1':
					return 1;
				case '3,6,12':
					return 2;
				case '3':
					return 3;
				case '6':
					return 4;
				case '12':
					return 5;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 0;
};
var $author$project$Components$Reports$Memberships$filterTypeToValue = function (filterType) {
	switch (filterType) {
		case 0:
			return 'unconfirmed';
		case 1:
			return 'starting';
		case 2:
			return 'ending';
		case 3:
			return 'current';
		case 4:
			return 'last_or_next_billing';
		case 5:
			return 'contracts_ending';
		default:
			return 'contracts_renewed';
	}
};
var $author$project$Components$Reports$Memberships$sourceStatusToValue = function (sourceStatus) {
	switch (sourceStatus) {
		case 0:
			return '';
		case 1:
			return 'source_valid';
		case 2:
			return 'source_has_warning';
		default:
			return 'source_requires_action';
	}
};
var $author$project$Components$Reports$Memberships$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			A2(
				$elm$url$Url$Builder$string,
				'filter',
				$author$project$Components$Reports$Memberships$filterTypeToValue(model.Fi))),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practitioner'),
			model.WO),
			function () {
			var _v0 = model.pF;
			switch (_v0) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '1'));
				case 2:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '3,6,12'));
				case 3:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '3'));
				case 4:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '6'));
				default:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'period_in_months', '12'));
			}
		}(),
			function () {
			var _v1 = model.sW;
			if (!_v1) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(
					A2(
						$elm$url$Url$Builder$string,
						'source_status',
						$author$project$Components$Reports$Memberships$sourceStatusToValue(model.sW)));
			}
		}(),
			function () {
			var _v2 = model.JI;
			switch (_v2) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'autopay', 'enabled'));
				default:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'autopay', 'disabled'));
			}
		}(),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('plan'),
			model.afN),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('company'),
			model.ff),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('coupon'),
			model.dy),
			function () {
			var _v3 = model.GW;
			switch (_v3) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'rate_calculation', 'auto_calculated'));
				case 2:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'rate_calculation', 'overridden_off_rate'));
				default:
					return $elm$core$Maybe$Just(
						A2($elm$url$Url$Builder$string, 'rate_calculation', 'overridden_on_rate'));
			}
		}()
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Memberships)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Reports$Memberships$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$Memberships$GotData = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Reports$Memberships$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				JI: function () {
					var _v0 = model.JI;
					switch (_v0) {
						case 0:
							return $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Just(true);
						default:
							return $elm$core$Maybe$Just(false);
					}
				}(),
				ab9: model.ff,
				L1: model.dy,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				Fi: $elm$core$Maybe$Just(
					$author$project$Components$Reports$Memberships$filterTypeToValue(model.Fi)),
				aet: model.S3,
				rj: model.fW,
				afy: model.afy,
				Wc: function () {
					var _v1 = model.pF;
					switch (_v1) {
						case 0:
							return $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['1']));
						case 2:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['3', '6', '12']));
						case 3:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['3']));
						case 4:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['6']));
						default:
							return $elm$core$Maybe$Just(
								_List_fromArray(
									['12']));
					}
				}(),
				GH: model.afN,
				afS: model.WO,
				GW: function () {
					var _v2 = model.GW;
					switch (_v2) {
						case 0:
							return $elm$core$Maybe$Nothing;
						case 1:
							return $elm$core$Maybe$Just('auto_calculated');
						case 2:
							return $elm$core$Maybe$Just('overridden_off_rate');
						default:
							return $elm$core$Maybe$Just('overridden_on_rate');
					}
				}(),
				ag1: model.ag1,
				sW: function () {
					var _v3 = model.sW;
					if (!_v3) {
						return $elm$core$Maybe$Nothing;
					} else {
						return $elm$core$Maybe$Just(
							$author$project$Components$Reports$Memberships$sourceStatusToValue(model.sW));
					}
				}(),
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Api$Provider$Reports$MembershipPatient$MembershipPatient = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$MembershipPatient$Record = F5(
	function (status, startDate, endDate, patient, membership) {
		return {qs: endDate, ja: membership, VM: patient, _E: startDate, ag7: status};
	});
var $author$project$Api$Provider$Reports$Membership$Membership = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Reports$Membership$One = 0;
var $author$project$Api$Provider$Reports$Membership$OneRecord = function (lastBillAmountInCents) {
	return function (lastBillDate) {
		return function (startDate) {
			return function (endDate) {
				return function (nextBillDate) {
					return function (periodRateInCents) {
						return function (periodInMonths) {
							return function (sourceStatus) {
								return function (status) {
									return function (owner) {
										return function (plan) {
											return {qs: endDate, Su: lastBillAmountInCents, Sv: lastBillDate, UC: nextBillDate, Vp: owner, Wc: periodInMonths, Wd: periodRateInCents, GH: plan, sW: sourceStatus, _E: startDate, ag7: status};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Reports$Patient$ForMembership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Patient$ForMembershipRecord = F3(
	function (id, name, autopay) {
		return {JI: autopay, adR: id, zh: name};
	});
var $author$project$Api$Provider$Reports$Patient$forMembershipRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'autopay',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Patient$ForMembershipRecord))));
var $author$project$Api$Provider$Reports$Patient$forMembershipDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Patient$forMembershipRecordDecoder),
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Plan$Min$Plan = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Plan$Min$Record = F3(
	function (id, planType, name) {
		return {adR: id, zh: name, Wp: planType};
	});
var $author$project$Api$Provider$Reports$Plan$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'plan_type',
		$elm$json$Json$Decode$nullable($author$project$Api$PlanType$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Plan$Min$Record))));
var $author$project$Api$Provider$Reports$Plan$Min$minDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$Plan$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Membership$oneRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plan',
	$author$project$Api$Provider$Reports$Plan$Min$minDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'owner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Patient$forMembershipDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'status',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'source_status',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'period_in_months',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'period_rate_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'next_bill_date',
							$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'end_date',
								$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'start_date',
									$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'last_bill_date',
										$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_bill_amount_in_cents',
											$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
											$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$OneRecord))))))))))));
var $author$project$Api$Provider$Reports$Membership$oneDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	0,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Reports$Membership$oneRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$Membership)));
var $author$project$Api$Provider$Reports$MembershipPatient$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership',
	$author$project$Api$Provider$Reports$Membership$oneDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'patient',
		$author$project$Api$Provider$Patient$Min$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$author$project$Utils$Date$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$MembershipPatient$Record))))));
var $author$project$Api$Provider$Reports$MembershipPatient$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$MembershipPatient$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$MembershipPatient$listDefaults = {
	JI: $elm$core$Maybe$Nothing,
	ab9: $elm$core$Maybe$Nothing,
	L1: $elm$core$Maybe$Nothing,
	E9: $elm$core$Maybe$Nothing,
	Fi: $elm$core$Maybe$Nothing,
	aet: $elm$core$Maybe$Nothing,
	rj: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	Wc: $elm$core$Maybe$Nothing,
	GH: $elm$core$Maybe$Nothing,
	afS: $elm$core$Maybe$Nothing,
	GW: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'start_date', 0, $author$project$Api$Sort$init),
	sW: $elm$core$Maybe$Nothing,
	Hl: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$MembershipPatient$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Fi;
						if (!_v0.$) {
							var string = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'filter', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.Hl;
						if (!_v1.$) {
							var start_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.E9;
						if (!_v2.$) {
							var end_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.rj;
						if (!_v3.$) {
							var locationGroup_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.aet;
						if (!_v4.$) {
							var location_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.afS;
						if (!_v5.$) {
							var practitioner_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.Wc;
						if (!_v6.$) {
							var list_ = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$list, 'period_in_months', list_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v7 = options.sW;
						if (!_v7.$) {
							var string = _v7.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'source_status', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v8 = options.JI;
						if (!_v8.$) {
							var bool = _v8.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Api$Param$string,
									'owner',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'autopay',
													$elm$json$Json$Encode$bool(bool))
												]))))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v9 = options.GH;
						if (!_v9.$) {
							var string = _v9.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'plan', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v10 = options.ab9;
						if (!_v10.$) {
							var string = _v10.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'company', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v11 = options.GW;
						if (!_v11.$) {
							var string = _v11.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'rate_calculation', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v12 = options.L1;
						if (!_v12.$) {
							var string = _v12.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'coupon', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$MembershipPatient$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'membership_patients']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$MembershipPatient$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$MembershipPatient$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$MembershipPatient$listPath)));
	});
var $author$project$Components$Reports$Memberships$fetchMembershipPatients = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$MembershipPatient$list,
			apiClient,
			$author$project$Components$Reports$Memberships$fetchParams(model),
			A2($elm$core$Basics$composeL, $author$project$Components$Reports$Memberships$GotData, $author$project$Components$Reports$Memberships$MembershipPatients));
	});
var $author$project$Components$Reports$Memberships$Memberships = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Reports$Membership$All = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$Membership$AllRecord = function (membershipPatients) {
	return {TF: membershipPatients};
};
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$ForMembership = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$Record = function (patient) {
	return {VM: patient};
};
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'patient',
	$author$project$Api$Provider$Patient$Min$decoder,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$MembershipPatient$ForMembership$Record));
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$MembershipPatient$ForMembership$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$Membership$allRecordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'membership_patients',
	$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$MembershipPatient$ForMembership$decoder),
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$AllRecord));
var $author$project$Api$Provider$Reports$Membership$allDecoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Membership$allRecordDecoder),
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Reports$Membership$oneRecordDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$Membership)));
var $author$project$Api$Provider$Reports$Membership$listDefaults = {
	JI: $elm$core$Maybe$Nothing,
	ab9: $elm$core$Maybe$Nothing,
	L1: $elm$core$Maybe$Nothing,
	E9: $elm$core$Maybe$Nothing,
	Fi: $elm$core$Maybe$Nothing,
	aet: $elm$core$Maybe$Nothing,
	rj: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	Wc: $elm$core$Maybe$Nothing,
	GH: $elm$core$Maybe$Nothing,
	afS: $elm$core$Maybe$Nothing,
	GW: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'start_date', 0, $author$project$Api$Sort$init),
	sW: $elm$core$Maybe$Nothing,
	Hl: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Reports$Membership$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$Membership$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Fi;
						if (!_v0.$) {
							var string = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'filter', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.Hl;
						if (!_v1.$) {
							var start_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.E9;
						if (!_v2.$) {
							var end_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.rj;
						if (!_v3.$) {
							var locationGroup_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.aet;
						if (!_v4.$) {
							var location_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.afS;
						if (!_v5.$) {
							var practitioner_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.Wc;
						if (!_v6.$) {
							var list_ = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$list, 'period_in_months', list_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v7 = options.sW;
						if (!_v7.$) {
							var string = _v7.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'source_status', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v8 = options.JI;
						if (!_v8.$) {
							var bool = _v8.a;
							return _List_fromArray(
								[
									A2(
									$author$project$Api$Param$string,
									'owner',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'autopay',
													$elm$json$Json$Encode$bool(bool))
												]))))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v9 = options.GH;
						if (!_v9.$) {
							var string = _v9.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'plan', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v10 = options.ab9;
						if (!_v10.$) {
							var string = _v10.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'company', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v11 = options.GW;
						if (!_v11.$) {
							var string = _v11.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'rate_calculation', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v12 = options.L1;
						if (!_v12.$) {
							var string = _v12.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'coupon', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$Membership$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'memberships']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$Membership$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Membership$allDecoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$Membership$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Membership$listPath)));
	});
var $author$project$Components$Reports$Memberships$fetchMemberships = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$Membership$list,
			apiClient,
			$author$project$Components$Reports$Memberships$fetchParams(model),
			A2($elm$core$Basics$composeL, $author$project$Components$Reports$Memberships$GotData, $author$project$Components$Reports$Memberships$Memberships));
	});
var $author$project$Components$Reports$Memberships$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.MJ;
		if (!_v0.$) {
			return A2($author$project$Components$Reports$Memberships$fetchMembershipPatients, apiClient, model);
		} else {
			return A2($author$project$Components$Reports$Memberships$fetchMemberships, apiClient, model);
		}
	});
var $author$project$Components$Reports$Memberships$ContractsEnding = 5;
var $author$project$Components$Reports$Memberships$ContractsRenewed = 6;
var $author$project$Components$Reports$Memberships$Current = 3;
var $author$project$Components$Reports$Memberships$Ending = 2;
var $author$project$Components$Reports$Memberships$LastOrNextBilling = 4;
var $author$project$Components$Reports$Memberships$Starting = 1;
var $author$project$Components$Reports$Memberships$Unconfirmed = 0;
var $author$project$Components$Reports$Memberships$filterTypeFromQuery = function (queryString) {
	_v0$6:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'unconfirmed':
					return 0;
				case 'starting':
					return 1;
				case 'ending':
					return 2;
				case 'current':
					return 3;
				case 'contracts_ending':
					return 5;
				case 'contracts_renewed':
					return 6;
				default:
					break _v0$6;
			}
		} else {
			break _v0$6;
		}
	}
	return 4;
};
var $author$project$Components$ResourceFilter$Coupon$ResourceFilterMsg = $elm$core$Basics$identity;
var $author$project$Components$ResourceFilter$Coupon$list = $author$project$Api$Provider$Coupon$list;
var $author$project$Components$ResourceFilter$Coupon$fetchResources = F4(
	function (toMsg, apiClient, pagination, query) {
		return A3(
			$author$project$Components$ResourceFilter$Coupon$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						afy: pagination,
						af_: query,
						GY: $elm$core$Maybe$Just(true)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Coupon$retrieveResource = F3(
	function (toMsg, apiClient, id) {
		return A3(
			$author$project$Components$ResourceFilter$Coupon$list,
			apiClient,
			function (d) {
				return _Utils_update(
					d,
					{
						adR: $elm$core$Maybe$Just(id)
					});
			},
			toMsg);
	});
var $author$project$Components$ResourceFilter$Coupon$selectId = 'coupons';
var $author$project$Components$ResourceFilter$Coupon$toTitle = $author$project$Api$Provider$Coupon$All$code;
var $author$project$Components$ResourceFilter$Coupon$toLabel = function (resource) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Components$ResourceFilter$Coupon$toTitle(resource))
		]);
};
var $author$project$Components$ResourceFilter$Coupon$toValue = $author$project$Api$Provider$Coupon$All$id;
var $author$project$Components$ResourceFilter$Coupon$init = F2(
	function (apiClient, optionals) {
		var _v0 = A3(
			$author$project$Components$ResourceFilter$init,
			apiClient,
			{Pi: $author$project$Components$ResourceFilter$Coupon$fetchResources, adR: $author$project$Components$ResourceFilter$Coupon$selectId, gx: 'Coupon', st: $author$project$Components$ResourceFilter$Coupon$retrieveResource, ahw: $author$project$Components$ResourceFilter$Coupon$toLabel, ahA: $author$project$Components$ResourceFilter$Coupon$toTitle, g0: $author$project$Components$ResourceFilter$Coupon$toValue},
			optionals);
		var resourceFilter = _v0.a;
		var resourceFilterCmd = _v0.b;
		return _Utils_Tuple2(
			{G0: $author$project$Components$ResourceFilter$All, bb: resourceFilter},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
	});
var $author$project$Utils$Report$CouponResourceFilter$init = F3(
	function (apiClient, optionals, couponId) {
		return A2(
			$author$project$Components$ResourceFilter$Coupon$init,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				optionals,
				function (d) {
					return _Utils_update(
						d,
						{D0: 'All Coupons', afT: couponId});
				}));
	});
var $author$project$Components$Reports$Memberships$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'owner', false, 'Owner'),
		A3($author$project$Api$Column$init, 'patient', false, 'Patients'),
		A3($author$project$Api$Column$init, 'plan', false, 'Plan'),
		A3($author$project$Api$Column$init, 'status', false, 'Status'),
		A3($author$project$Api$Column$init, 'last_bill_date', true, 'Last Bill'),
		A3($author$project$Api$Column$init, 'next_bill_date', true, 'Next Bill'),
		A3($author$project$Api$Column$init, 'period_in_months', true, 'Billed'),
		A3($author$project$Api$Column$init, 'payment_info', false, 'Payment Info')
	]);
var $author$project$Api$Provider$Report$Membership = 11;
var $author$project$Api$Provider$Report$MembershipPatient = 10;
var $author$project$Components$Reports$Memberships$initExportCsv = function (showBy) {
	var resource = function () {
		if (!showBy.$) {
			return 10;
		} else {
			return 11;
		}
	}();
	return $author$project$Components$ExportCsv$init(
		{adw: false, G0: resource});
};
var $author$project$Components$Reports$Memberships$AllRateCalculations = 0;
var $author$project$Components$Reports$Memberships$AutoCalculated = 1;
var $author$project$Components$Reports$Memberships$OverriddenOffRate = 2;
var $author$project$Components$Reports$Memberships$OverriddenOnRate = 3;
var $author$project$Components$Reports$Memberships$rateCalculationFromQuery = function (queryString) {
	_v0$3:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'auto_calculated':
					return 1;
				case 'overridden_off_rate':
					return 2;
				case 'overridden_on_rate':
					return 3;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 0;
};
var $author$project$Components$Reports$Memberships$AllSources = 0;
var $author$project$Components$Reports$Memberships$SourceRequiresAction = 3;
var $author$project$Components$Reports$Memberships$SourceWithWarning = 2;
var $author$project$Components$Reports$Memberships$ValidSource = 1;
var $author$project$Components$Reports$Memberships$sourceStatusFromQuery = function (queryString) {
	_v0$3:
	while (true) {
		if (!queryString.$) {
			switch (queryString.a) {
				case 'source_valid':
					return 1;
				case 'source_has_warning':
					return 2;
				case 'source_requires_action':
					return 3;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 0;
};
var $author$project$Components$Reports$Memberships$init = F4(
	function (session, practice, _v0, query) {
		var currentDate = _v0.cO;
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var planId = A2($elm$core$Dict$get, 'plan', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var data = $author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading);
		var couponId = A2($elm$core$Dict$get, 'coupon', query);
		var companyId = A2($elm$core$Dict$get, 'company', query);
		var _v1 = A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId);
		var planResourceFilter = _v1.a;
		var planResourceFilterCmd = _v1.b;
		var _v2 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v2.a;
		var groupLocationAndPractitionerFiltersCmd = _v2.b;
		var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v3.a;
		var end = _v3.b;
		var _v4 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Memberships$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v4.a;
		var dateRangeInputCmd = _v4.b;
		var _v5 = A3($author$project$Utils$Report$CouponResourceFilter$init, apiClient, $elm$core$Basics$identity, couponId);
		var couponResourceFilter = _v5.a;
		var couponResourceFilterCmd = _v5.b;
		var _v6 = A4(
			$author$project$Utils$Report$CompanyResourceFilter$init,
			apiClient,
			$elm$core$Basics$identity,
			$author$project$Api$Practice$Provider(practice),
			companyId);
		var companyResourceFilter = _v6.a;
		var companyResourceFilterCmd = _v6.b;
		var model = {
			JI: $author$project$Components$Reports$Memberships$autopayStatusFromQuery(
				A2($elm$core$Dict$get, 'autopay', query)),
			k8: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'autopay-dropdown-filter', ahx: $author$project$Components$Reports$Memberships$AutopayDropdownMsg})),
			pF: $author$project$Components$Reports$Memberships$billingPeriodFromQuery(
				A2($elm$core$Dict$get, 'period_in_months', query)),
			ld: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'billing-period-dropdown-filter', ahx: $author$project$Components$Reports$Memberships$BillingPeriodDropdownMsg})),
			Ep: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0),
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			Ll: $author$project$Components$Reports$Memberships$initColumns,
			ff: companyId,
			pV: companyResourceFilter,
			dy: couponId,
			hV: couponResourceFilter,
			cO: currentDate,
			lH: $author$project$Components$CustomerEmailModal$init,
			MJ: data,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$Reports$Memberships$initExportCsv(data),
			Fi: $author$project$Components$Reports$Memberships$filterTypeFromQuery(
				A2($elm$core$Dict$get, 'filter', query)),
			mg: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'filter-dropdown-filter', ahx: $author$project$Components$Reports$Memberships$FilterDropdownMsg})),
			b7: groupLocationAndPractitionerFilters,
			fW: locationGroupId,
			S3: locationId,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			afN: planId,
			jw: planResourceFilter,
			WO: practitionerId,
			GW: $author$project$Components$Reports$Memberships$rateCalculationFromQuery(
				A2($elm$core$Dict$get, 'rate_calculation', query)),
			nP: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'rate-calculation-dropdown-filter', ahx: $author$project$Components$Reports$Memberships$RateCalculationDropdownMsg})),
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'next_bill_date',
				0,
				$author$project$Api$Sort$initFromQuery(query)),
			sW: $author$project$Components$Reports$Memberships$sourceStatusFromQuery(
				A2($elm$core$Dict$get, 'source_status', query)),
			oy: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'source-status-dropdown-filter', ahx: $author$project$Components$Reports$Memberships$SourceStatusDropdownMsg})),
			Hl: start
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg, companyResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CouponResourceFilterMsg, couponResourceFilterCmd),
						A2($author$project$Components$Reports$Memberships$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$Memberships$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A4($author$project$Components$Reports$Memberships$init, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Memberships$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Memberships$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Memberships$CustomerEmailModalMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Components$Reports$Memberships$ExportCsvMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$ResourceFilter$Coupon$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$ResourceFilter$subscriptions(model.bb));
};
var $author$project$Components$Reports$Memberships$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$subscriptions(model.lH)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$PlanResourceFilterMsg,
				$author$project$Components$ResourceFilter$Plan$subscriptions(model.jw)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$CompanyResourceFilterMsg,
				$author$project$Components$ResourceFilter$Company$subscriptions(model.pV)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b7)),
				$author$project$Ui$NewDropdown$subscriptions(model.oy),
				$author$project$Ui$NewDropdown$subscriptions(model.k8),
				$author$project$Ui$NewDropdown$subscriptions(model.ld),
				$author$project$Ui$NewDropdown$subscriptions(model.nP),
				$author$project$Ui$NewDropdown$subscriptions(model.mg),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Memberships$CouponResourceFilterMsg,
				$author$project$Components$ResourceFilter$Coupon$subscriptions(model.hV))
			]));
};
var $author$project$Pages$Reports$Memberships$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Memberships$subscriptions(model.jO));
};
var $author$project$Components$Reports$Memberships$dataLoading = function (showBy) {
	if (!showBy.$) {
		return $author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading);
	} else {
		return $author$project$Components$Reports$Memberships$Memberships($author$project$Api$Data$Loading);
	}
};
var $author$project$Components$ResourceFilter$Coupon$update = F3(
	function (apiClient, msg, model) {
		var subMsg = msg;
		var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bb);
		var modelAfterEvent = function () {
			var _v1 = result.ac5;
			if (!_v1.$) {
				if (!_v1.a.$) {
					var selected = _v1.a.a;
					return _Utils_update(
						model,
						{G0: selected});
				} else {
					var _v2 = _v1.a;
					return model;
				}
			} else {
				return model;
			}
		}();
		return {
			EC: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EC),
			ac5: result.ac5,
			y8: _Utils_update(
				modelAfterEvent,
				{bb: result.y8}),
			as: result.as
		};
	});
var $author$project$Components$ResourceFilter$Coupon$value = function (model) {
	return A2($author$project$Components$ResourceFilter$choiceToValue, model.bb, model.G0);
};
var $author$project$Components$Reports$Memberships$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$NewDropdown$update, subMsg, model.mg);
				var dropdown = _v2.a;
				var dropdownCmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mg: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 1:
				var filterType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						MJ: $author$project$Components$Reports$Memberships$dataLoading(model.MJ),
						Fi: filterType,
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v3.a;
				var subCmd = _v3.b;
				var event = _v3.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								MJ: $author$project$Components$Reports$Memberships$dataLoading(model.MJ),
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 4:
				var data = msg.a;
				var newModel = _Utils_update(
					model,
					{
						MJ: data,
						l9: $author$project$Components$Reports$Memberships$initExportCsv(data),
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b7);
				var _v5 = result.ac5;
				switch (_v5.$) {
					case 0:
						var locationGroupId = _v5.a;
						var locationId = _v5.b;
						var practitionerId = _v5.c;
						var newModel = _Utils_update(
							model,
							{
								MJ: $author$project$Components$Reports$Memberships$dataLoading(model.MJ),
								b7: result.y8,
								fW: locationGroupId,
								S3: locationId,
								afy: $author$project$Api$Pagination$reset(model.afy),
								WO: practitionerId
							});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, result.EC),
										A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
										A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 5:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$NewDropdown$update, subMsg, model.ld);
				var dropdown = _v6.a;
				var dropdownCmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ld: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 6:
				var period = msg.a;
				var newModel = _Utils_update(
					model,
					{
						pF: period,
						MJ: $author$project$Components$Reports$Memberships$dataLoading(model.MJ),
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oy);
				var dropdown = _v7.a;
				var dropdownCmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oy: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 8:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						MJ: $author$project$Components$Reports$Memberships$dataLoading(model.MJ),
						afy: $author$project$Api$Pagination$reset(model.afy),
						sW: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$NewDropdown$update, subMsg, model.k8);
				var dropdown = _v8.a;
				var dropdownCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{k8: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 10:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						JI: status,
						MJ: $author$project$Components$Reports$Memberships$dataLoading(model.MJ),
						afy: $author$project$Api$Pagination$reset(model.afy)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 12:
				var subMsg = msg.a;
				var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pV);
				var companyId = function () {
					var _v10 = companyResourceResult.ac5;
					if (!_v10.$) {
						if (!_v10.a.$) {
							return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.y8);
						} else {
							var _v11 = _v10.a;
							return model.ff;
						}
					} else {
						return model.ff;
					}
				}();
				var newModel = _Utils_update(
					model,
					{ff: companyId, pV: companyResourceResult.y8});
				var _v9 = _Utils_eq(model.ff, newModel.ff) ? _Utils_Tuple2(model.MJ, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Components$Reports$Memberships$dataLoading(model.MJ),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var data = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{MJ: data}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg, companyResourceResult.EC),
								cmd
							])),
					companyResourceResult.as);
			case 11:
				var subMsg = msg.a;
				var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jw);
				var planId = function () {
					var _v13 = planResourceResult.ac5;
					if (!_v13.$) {
						if (!_v13.a.$) {
							return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.y8);
						} else {
							var _v14 = _v13.a;
							return model.afN;
						}
					} else {
						return model.afN;
					}
				}();
				var newModel = _Utils_update(
					model,
					{afN: planId, jw: planResourceResult.y8});
				var _v12 = _Utils_eq(model.afN, newModel.afN) ? _Utils_Tuple2(model.MJ, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Components$Reports$Memberships$dataLoading(model.MJ),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var data = _v12.a;
				var cmd = _v12.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{MJ: data}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$PlanResourceFilterMsg, planResourceResult.EC),
								cmd
							])),
					planResourceResult.as);
			case 13:
				var subMsg = msg.a;
				var _v15 = A2($author$project$Ui$NewDropdown$update, subMsg, model.nP);
				var dropdown = _v15.a;
				var dropdownCmd = _v15.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nP: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 14:
				var calculation = msg.a;
				var newModel = _Utils_update(
					model,
					{
						MJ: $author$project$Components$Reports$Memberships$dataLoading(model.MJ),
						afy: $author$project$Api$Pagination$reset(model.afy),
						GW: calculation
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 15:
				var showBy = msg.a;
				if (!showBy.$) {
					var response = showBy.a;
					if (response.$ === 3) {
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									MJ: $author$project$Components$Reports$Memberships$MembershipPatients(response),
									afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									MJ: $author$project$Components$Reports$Memberships$MembershipPatients(response)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				} else {
					var response = showBy.a;
					if (response.$ === 3) {
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									MJ: $author$project$Components$Reports$Memberships$Memberships(response),
									afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									MJ: $author$project$Components$Reports$Memberships$Memberships(response)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 16:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{
						MJ: $author$project$Components$Reports$Memberships$dataLoading(model.MJ),
						afy: pagination
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 17:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 18:
				var subMsg = msg.a;
				var _v19 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v19.a;
				var subCmd = _v19.b;
				var subOutMsg = _v19.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$ExportCsvMsg, subCmd),
					subOutMsg);
			case 19:
				var subMsg = msg.a;
				var _v20 = A3($author$project$Components$CustomerEmailModal$update, apiClient, subMsg, model.lH);
				var customerEmailModal = _v20.a;
				var subCmd = _v20.b;
				var subOutMsg = _v20.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lH: customerEmailModal}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CustomerEmailModalMsg, subCmd),
					subOutMsg);
			default:
				var subMsg = msg.a;
				var couponResourceResult = A3($author$project$Components$ResourceFilter$Coupon$update, apiClient, subMsg, model.hV);
				var couponId = function () {
					var _v22 = couponResourceResult.ac5;
					if (!_v22.$) {
						if (!_v22.a.$) {
							return $author$project$Components$ResourceFilter$Coupon$value(couponResourceResult.y8);
						} else {
							var _v23 = _v22.a;
							return model.dy;
						}
					} else {
						return model.dy;
					}
				}();
				var newModel = _Utils_update(
					model,
					{dy: couponId, hV: couponResourceResult.y8});
				var _v21 = _Utils_eq(model.dy, newModel.dy) ? _Utils_Tuple2(model.MJ, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Components$Reports$Memberships$dataLoading(model.MJ),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var data = _v21.a;
				var cmd = _v21.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{MJ: data}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CouponResourceFilterMsg, couponResourceResult.EC),
								cmd
							])),
					couponResourceResult.as);
		}
	});
var $author$project$Pages$Reports$Memberships$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Memberships$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Memberships$PaginationMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Reports$Memberships$autopayStatusToLabel = function (status) {
	switch (status) {
		case 0:
			return 'All Autopay';
		case 1:
			return 'Autopay Enabled';
		default:
			return 'Autopay Disabled';
	}
};
var $author$project$Components$Reports$Memberships$AutopaySelected = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Reports$Memberships$autopayStatuses = function (currentStatus) {
	var autopayStatusToItem = function (status) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentStatus, status)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Memberships$AutopaySelected(status))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$autopayStatusToLabel(status)));
	};
	return A2(
		$elm$core$List$cons,
		autopayStatusToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				autopayStatusToItem,
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Components$Reports$Memberships$viewAutopayDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$autopayStatusToLabel(model.JI))
			]),
		$author$project$Components$Reports$Memberships$autopayStatuses(model.JI),
		model.k8);
};
var $author$project$Components$Reports$Memberships$billingPeriodToLabel = function (period) {
	switch (period) {
		case 0:
			return 'All Billing Periods';
		case 1:
			return 'Billed Monthly';
		case 2:
			return 'Billed Non Monthly';
		case 3:
			return 'Billed Quarterly';
		case 4:
			return 'Billed Semi-annually';
		default:
			return 'Billed Annually';
	}
};
var $author$project$Components$Reports$Memberships$BillingPeriodSelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Memberships$billingPeriods = function (currentPeriod) {
	var billingPeriodToItem = function (period) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentPeriod, period)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Memberships$BillingPeriodSelected(period))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$billingPeriodToLabel(period)));
	};
	return A2(
		$elm$core$List$cons,
		billingPeriodToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					billingPeriodToItem,
					_List_fromArray(
						[1, 2])),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$NewDropdown$separator,
					A2(
						$elm$core$List$map,
						billingPeriodToItem,
						_List_fromArray(
							[3, 4, 5]))))));
};
var $author$project$Components$Reports$Memberships$viewBillingPeriodDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$billingPeriodToLabel(model.pF))
			]),
		$author$project$Components$Reports$Memberships$billingPeriods(model.pF),
		model.ld);
};
var $author$project$Components$Reports$Memberships$viewCompanyResourceFilter = function (companyResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$Memberships$CompanyResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Company$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			companyResourceFilter));
};
var $author$project$Components$ResourceFilter$Coupon$viewNew = F2(
	function (options, model) {
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$ResourceFilter$viewNew,
				A2(
					$elm$core$List$cons,
					$author$project$Components$ResourceFilter$value(model.G0),
					options),
				model.bb));
	});
var $author$project$Components$Reports$Memberships$viewCouponResourceFilter = function (couponResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$Memberships$CouponResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Coupon$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			couponResourceFilter));
};
var $author$project$Components$Reports$Memberships$filterTypeToLabel = function (filterType) {
	switch (filterType) {
		case 0:
			return 'Unconfirmed';
		case 1:
			return 'Starting';
		case 2:
			return 'Ending';
		case 3:
			return 'Active';
		case 4:
			return 'Last Billed or Billing';
		case 5:
			return 'Contract Ending';
		default:
			return 'Contracts Renewed';
	}
};
var $author$project$Components$Reports$Memberships$FilterSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$Memberships$filterTypes = function (currentFilter) {
	var filterTypeToItem = function (filterType) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentFilter, filterType)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Memberships$FilterSelected(filterType))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$filterTypeToLabel(filterType)));
	};
	return A2(
		$elm$core$List$map,
		filterTypeToItem,
		_List_fromArray(
			[0, 1, 2, 3, 4, 5, 6]));
};
var $author$project$Components$Reports$Memberships$viewFilterDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$filterTypeToLabel(model.Fi))
			]),
		$author$project$Components$Reports$Memberships$filterTypes(model.Fi),
		model.mg);
};
var $author$project$Components$ResourceFilter$Coupon$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$Reports$Memberships$viewPlanResourceFilter = function (planResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$Memberships$PlanResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Plan$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			planResourceFilter));
};
var $author$project$Components$Reports$Memberships$rateCalculationToLabel = function (calculation) {
	switch (calculation) {
		case 0:
			return 'All Rate Overrides';
		case 1:
			return 'Automatic Rate';
		case 2:
			return 'Overridden (Off Rate)';
		default:
			return 'Overridden (On Rate)';
	}
};
var $author$project$Components$Reports$Memberships$RateCalculationSelected = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Reports$Memberships$rateCalculations = function (currentCalculation) {
	var rateCalculationToItem = function (calculation) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentCalculation, calculation)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Memberships$RateCalculationSelected(calculation))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$rateCalculationToLabel(calculation)));
	};
	return A2(
		$elm$core$List$cons,
		rateCalculationToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				rateCalculationToItem,
				_List_fromArray(
					[1, 2, 3]))));
};
var $author$project$Components$Reports$Memberships$viewRateCalculationDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$rateCalculationToLabel(model.GW))
			]),
		$author$project$Components$Reports$Memberships$rateCalculations(model.GW),
		model.nP);
};
var $author$project$Components$Reports$Memberships$ShowByChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$Memberships$viewShowByButtonGroup = function (model) {
	var _v0 = function () {
		var _v1 = model.MJ;
		if (!_v1.$) {
			return _Utils_Tuple2(true, false);
		} else {
			return _Utils_Tuple2(false, true);
		}
	}();
	var membershipPatientsActive = _v0.a;
	var membershipsActive = _v0.b;
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$justifyRight, $author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$elm$html$Html$text('Show by: '),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$mr2]),
				_List_Nil),
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Shhow by patients'},
						_List_fromArray(
							[
								$author$project$Ui$Button$active(membershipPatientsActive),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Reports$Memberships$ShowByChanged(
									$author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Patients')
							])),
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Shhow by membership owners'},
						_List_fromArray(
							[
								$author$project$Ui$Button$active(membershipsActive),
								$author$project$Ui$Button$onClick(
								$author$project$Components$Reports$Memberships$ShowByChanged(
									$author$project$Components$Reports$Memberships$Memberships($author$project$Api$Data$Loading)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Membership owners')
							]))
					]))
			]));
};
var $author$project$Components$Reports$Memberships$sourceStatusToLabel = function (status) {
	switch (status) {
		case 0:
			return 'All Payment Source';
		case 1:
			return 'Source Valid ';
		case 2:
			return 'Source Has Warning';
		default:
			return 'Source Requires Action';
	}
};
var $author$project$Components$Reports$Memberships$SourceStatusSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$Memberships$sourceStatuses = function (currentStatus) {
	var sourceStatusToItem = function (status) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentStatus, status)),
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$Memberships$SourceStatusSelected(status))
				]),
			$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$sourceStatusToLabel(status)));
	};
	return A2(
		$elm$core$List$cons,
		sourceStatusToItem(0),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				sourceStatusToItem,
				_List_fromArray(
					[1, 2, 3]))));
};
var $author$project$Components$Reports$Memberships$viewSourceStatusDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Components$Reports$Memberships$sourceStatusToLabel(model.sW))
			]),
		$author$project$Components$Reports$Memberships$sourceStatuses(model.sW),
		model.oy);
};
var $author$project$Components$Reports$Memberships$SortTable = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Provider$Reports$Membership$endDate = function (_v0) {
	var one = _v0.a;
	return one.qs;
};
var $author$project$Api$Provider$Reports$MembershipPatient$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Api$Provider$Reports$Patient$forMembershipAutopay = function (_v0) {
	var record = _v0;
	return record.JI;
};
var $author$project$Api$Provider$Reports$Plan$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Reports$Membership$lastBillAmountInCents = function (_v0) {
	var one = _v0.a;
	return one.Su;
};
var $author$project$Api$Provider$Reports$Membership$lastBillDate = function (_v0) {
	var one = _v0.a;
	return one.Sv;
};
var $author$project$Api$Provider$Reports$MembershipPatient$membership = function (_v0) {
	var record = _v0;
	return record.ja;
};
var $author$project$Api$Provider$Reports$Plan$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Reports$Membership$nextBillDate = function (_v0) {
	var one = _v0.a;
	return one.UC;
};
var $author$project$Api$Provider$Reports$Membership$owner = function (_v0) {
	var one = _v0.a;
	return one.Vp;
};
var $author$project$Api$Provider$Reports$MembershipPatient$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Api$Provider$Reports$Membership$periodInMonths = function (_v0) {
	var one = _v0.a;
	return one.Wc;
};
var $author$project$Api$Provider$Reports$Membership$periodRateInCents = function (_v0) {
	var one = _v0.a;
	return one.Wd;
};
var $author$project$Api$Provider$Reports$Membership$plan = function (_v0) {
	var one = _v0.a;
	return one.GH;
};
var $author$project$Api$Provider$Reports$Plan$Min$planType = function (_v0) {
	var record = _v0;
	return record.Wp;
};
var $author$project$Api$Provider$Reports$Membership$sourceStatus = function (_v0) {
	var one = _v0.a;
	return one.sW;
};
var $author$project$Api$Provider$Reports$MembershipPatient$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$Reports$MembershipPatient$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Components$Reports$Memberships$membershipPatientToRow = function (membershipPatient) {
	var membership = $author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient);
	var owner = $author$project$Api$Provider$Reports$Membership$owner(membership);
	var lastBillAmountInCents = A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Api$Provider$Reports$Membership$lastBillAmountInCents(membership));
	var isFixedFee = _Utils_eq(
		$author$project$Api$Provider$Reports$Plan$Min$planType(
			$author$project$Api$Provider$Reports$Membership$plan(membership)),
		$elm$core$Maybe$Just(1));
	var lastBillWasFixedFee = isFixedFee && (!lastBillAmountInCents);
	return {
		JI: A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Patient$forMembershipAutopay, owner)),
		qs: A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Provider$Reports$Membership$endDate(membership),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Maybe$Just,
				$author$project$Api$Provider$Reports$MembershipPatient$endDate(membershipPatient))),
		yg: isFixedFee,
		Su: lastBillAmountInCents,
		Sv: $author$project$Api$Provider$Reports$Membership$lastBillDate(membership),
		yv: lastBillWasFixedFee,
		UC: $author$project$Api$Provider$Reports$Membership$nextBillDate(membership),
		Vp: owner,
		VN: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$Min$id(
				$author$project$Api$Provider$Reports$MembershipPatient$patient(membershipPatient))),
		VR: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Patient$Min$name(
				$author$project$Api$Provider$Reports$MembershipPatient$patient(membershipPatient))),
		An: _List_Nil,
		Wc: $author$project$Api$Provider$Reports$Membership$periodInMonths(membership),
		Wd: $author$project$Api$Provider$Reports$Membership$periodRateInCents(membership),
		afN: $author$project$Api$Provider$Reports$Plan$Min$id(
			$author$project$Api$Provider$Reports$Membership$plan(
				$author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient))),
		Wo: $author$project$Api$Provider$Reports$Plan$Min$name(
			$author$project$Api$Provider$Reports$Membership$plan(
				$author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient))),
		sW: $author$project$Api$Provider$Reports$Membership$sourceStatus(membership),
		_E: $elm$core$Maybe$Just(
			$author$project$Api$Provider$Reports$MembershipPatient$startDate(membershipPatient)),
		ag7: $author$project$Api$Provider$Reports$MembershipPatient$status(membershipPatient)
	};
};
var $author$project$Api$Provider$Reports$Membership$membershipPatients = function (_v0) {
	var all = _v0.b;
	return all.TF;
};
var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Api$Provider$Reports$Membership$startDate = function (_v0) {
	var one = _v0.a;
	return one._E;
};
var $author$project$Api$Provider$Reports$Membership$status = function (_v0) {
	var one = _v0.a;
	return one.ag7;
};
var $author$project$Components$Reports$Memberships$membershipToRow = function (membership) {
	var owner = $author$project$Api$Provider$Reports$Membership$owner(membership);
	var membershipPatients = $author$project$Api$Provider$Reports$Membership$membershipPatients(membership);
	var lastBillAmountInCents = A2(
		$elm$core$Maybe$withDefault,
		0,
		$author$project$Api$Provider$Reports$Membership$lastBillAmountInCents(membership));
	var isFixedFee = _Utils_eq(
		$author$project$Api$Provider$Reports$Plan$Min$planType(
			$author$project$Api$Provider$Reports$Membership$plan(membership)),
		$elm$core$Maybe$Just(1));
	var lastBillWasFixedFee = isFixedFee && (!lastBillAmountInCents);
	return {
		JI: A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Patient$forMembershipAutopay, owner)),
		qs: $author$project$Api$Provider$Reports$Membership$endDate(membership),
		yg: isFixedFee,
		Su: lastBillAmountInCents,
		Sv: $author$project$Api$Provider$Reports$Membership$lastBillDate(membership),
		yv: lastBillWasFixedFee,
		UC: $author$project$Api$Provider$Reports$Membership$nextBillDate(membership),
		Vp: owner,
		VN: $elm$core$Maybe$Nothing,
		VR: $elm$core$Maybe$Nothing,
		An: A2(
			$elm$core$List$map,
			function (membershipPatient) {
				return $author$project$Api$Provider$Patient$Min$name(
					$author$project$Api$Provider$Reports$MembershipPatient$ForMembership$patient(membershipPatient));
			},
			membershipPatients),
		Wc: $author$project$Api$Provider$Reports$Membership$periodInMonths(membership),
		Wd: $author$project$Api$Provider$Reports$Membership$periodRateInCents(membership),
		afN: $author$project$Api$Provider$Reports$Plan$Min$id(
			$author$project$Api$Provider$Reports$Membership$plan(membership)),
		Wo: $author$project$Api$Provider$Reports$Plan$Min$name(
			$author$project$Api$Provider$Reports$Membership$plan(membership)),
		sW: $author$project$Api$Provider$Reports$Membership$sourceStatus(membership),
		_E: $author$project$Api$Provider$Reports$Membership$startDate(membership),
		ag7: $author$project$Api$Provider$Reports$Membership$status(membership)
	};
};
var $author$project$Ui$Icon$RateDecrease = 40;
var $author$project$Ui$Icon$RateIncrease = 41;
var $author$project$Api$Provider$Reports$Patient$forMembershipId = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Reports$Patient$forMembershipName = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$Reports$Memberships$viewRow = F4(
	function (canGoToPatients, canGoToAdmin, showBy, _v0) {
		var owner = _v0.Vp;
		var patientId = _v0.VN;
		var patientName = _v0.VR;
		var patientNames = _v0.An;
		var status = _v0.ag7;
		var startDate = _v0._E;
		var endDate = _v0.qs;
		var lastBillDate = _v0.Sv;
		var lastBillWasFixedFee = _v0.yv;
		var lastBillAmountInCents = _v0.Su;
		var nextBillDate = _v0.UC;
		var isFixedFee = _v0.yg;
		var periodRateInCents = _v0.Wd;
		var periodInMonths = _v0.Wc;
		var autopay = _v0.JI;
		var sourceStatus = _v0.sW;
		var planName = _v0.Wo;
		var planId = _v0.afN;
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						var _v1 = _Utils_Tuple2(owner, canGoToPatients);
						if (!_v1.a.$) {
							if (_v1.b) {
								var owner_ = _v1.a.a;
								return _List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
											{
												VN: $author$project$Api$Provider$Reports$Patient$forMembershipId(owner_)
											}),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$Reports$Patient$forMembershipName(owner_))
													]))
											]))
									]);
							} else {
								var owner_ = _v1.a.a;
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Api$Provider$Reports$Patient$forMembershipName(owner_))
											]))
									]);
							}
						} else {
							var _v2 = _v1.a;
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if (!showBy.$) {
							var _v4 = _Utils_Tuple2(canGoToPatients, patientId);
							if (_v4.a && (!_v4.b.$)) {
								var patientId_ = _v4.b.a;
								return _List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
											{VN: patientId_}),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($elm$core$Maybe$withDefault, '', patientName))
													]))
											]))
									]);
							} else {
								return _List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '', patientName))
											]))
									]);
							}
						} else {
							return A2(
								$elm$core$List$map,
								function (name) {
									return A2(
										$author$project$Ui$Typography$div,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(name)
											]));
								},
								patientNames);
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					canGoToAdmin ? _List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Admin__Plans__Id_String(
								{adR: planId}),
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(planName)
								]))
						]) : _List_fromArray(
						[
							$elm$html$Html$text(planName)
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Badge$fromString, _List_Nil, status),
							A2(
							$author$project$Ui$Typography$div,
							_List_fromArray(
								[$author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									function () {
									if (!endDate.$) {
										var endDate_ = endDate.a;
										return $elm$html$Html$text(
											'ending ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate_));
									} else {
										return $elm$html$Html$text(
											'since ' + A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													startDate)));
									}
								}()
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if (!lastBillDate.$) {
							var lastBillDate_ = lastBillDate.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, lastBillDate_)),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											lastBillWasFixedFee ? $elm$html$Html$text('Fixed Fee') : $elm$html$Html$text(
											'for ' + $author$project$Utils$Currency$fromInt(lastBillAmountInCents))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					function () {
						if (!nextBillDate.$) {
							var nextBillDate_ = nextBillDate.a;
							return _List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDate_)),
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									isFixedFee ? _List_fromArray(
										[
											$elm$html$Html$text('Fixed Fee'),
											((periodRateInCents - lastBillAmountInCents) > 0) ? A2($author$project$Ui$Icon$view, _List_Nil, 41) : A2($author$project$Ui$Icon$view, _List_Nil, 40)
										]) : _List_fromArray(
										[
											$elm$html$Html$text(
											'for ' + $author$project$Utils$Currency$fromInt(periodRateInCents))
										]))
								]);
						} else {
							return _List_Nil;
						}
					}()),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Formatters$Int$asPeriod(periodInMonths))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							'Autopay: ' + $author$project$Formatters$Bool$toString(autopay)),
							A2(
							$author$project$Ui$Typography$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Source: '),
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									A2($elm$core$Maybe$withDefault, 'none', sourceStatus))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$Memberships$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.MJ;
		_v1$2:
		while (true) {
			if (!_v1.$) {
				if (_v1.a.$ === 3) {
					var _v2 = _v1.a;
					var membershipPatients = _v2.a;
					return _Utils_Tuple2(
						false,
						A2($elm$core$List$map, $author$project$Components$Reports$Memberships$membershipPatientToRow, membershipPatients));
				} else {
					break _v1$2;
				}
			} else {
				if (_v1.a.$ === 3) {
					var _v3 = _v1.a;
					var memberships = _v3.a;
					return _Utils_Tuple2(
						false,
						A2($elm$core$List$map, $author$project$Components$Reports$Memberships$membershipToRow, memberships));
				} else {
					break _v1$2;
				}
			}
		}
		return _Utils_Tuple2(true, _List_Nil);
	}();
	var loading = _v0.a;
	var rows = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$Memberships$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A3($author$project$Components$Reports$Memberships$viewRow, model.Er, model.Ep, model.MJ),
			rows),
		_List_Nil);
};
var $author$project$Components$Reports$Memberships$view = F2(
	function (apiClient, _v0) {
		var model = _v0;
		var totalCount = function () {
			var _v5 = model.MJ;
			if (!_v5.$) {
				var lastResponse_ = _v5.a;
				return $author$project$Api$Data$totalCount(lastResponse_);
			} else {
				var lastResponse_ = _v5.a;
				return $author$project$Api$Data$totalCount(lastResponse_);
			}
		}();
		var reportParams = function () {
			var _v4 = model.MJ;
			if (!_v4.$) {
				return A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams, $author$project$Components$Reports$Memberships$fetchParams)(model);
			} else {
				return A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Membership$listOptionsToParams, $author$project$Components$Reports$Memberships$fetchParams)(model);
			}
		}();
		var loading = function () {
			var _v1 = model.MJ;
			_v1$2:
			while (true) {
				if (!_v1.$) {
					if (_v1.a.$ === 3) {
						var _v2 = _v1.a;
						return false;
					} else {
						break _v1$2;
					}
				} else {
					if (_v1.a.$ === 3) {
						var _v3 = _v1.a;
						return false;
					} else {
						break _v1$2;
					}
				}
			}
			return true;
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Memberships$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(totalCount),
							$author$project$Components$ExportCsv$reportParams(reportParams)
						]),
					model.l9)),
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Memberships$CustomerEmailModalMsg,
				$author$project$Components$CustomerEmailModal$modal(model.lH)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Memberships')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm, $author$project$Ui$FlexGrid$mt2]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(2)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$Memberships$viewFilterDropdown(model)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(6)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$Memberships$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.h3))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$Memberships$viewShowByButtonGroup(model)
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$FlexGrid$column(
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.b7))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewBillingPeriodDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewSourceStatusDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewAutopayDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewPlanResourceFilter(model.jw)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewCompanyResourceFilter(model.pV)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewRateCalculationDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Memberships$viewCouponResourceFilter(model.hV)
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$Memberships$PlanResourceFilterMsg),
													$author$project$Components$ResourceFilter$Plan$viewMultiSelected(model.jw)),
												_Utils_ap(
													A2(
														$elm$core$List$map,
														$elm$html$Html$map($author$project$Components$Reports$Memberships$CompanyResourceFilterMsg),
														$author$project$Components$ResourceFilter$Company$viewMultiSelected(model.pV)),
													_Utils_ap(
														A2(
															$elm$core$List$map,
															$elm$html$Html$map($author$project$Components$Reports$Memberships$CouponResourceFilterMsg),
															$author$project$Components$ResourceFilter$Coupon$viewMultiSelected(model.hV)),
														A2(
															$elm$core$List$map,
															$elm$html$Html$map($author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg),
															$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b7)))));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$Memberships$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Memberships$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(loading)
										]),
									model.afy))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$Memberships$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Memberships$view, model.D5, model.jO)),
		$G: 'Reports | Memberships'
	};
};
var $author$project$Pages$Reports$Memberships$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Memberships$init, aer: $author$project$Pages$Reports$Memberships$load, agD: $author$project$Pages$Reports$Memberships$save, ahd: $author$project$Pages$Reports$Memberships$subscriptions, aaq: $author$project$Pages$Reports$Memberships$update, ahP: $author$project$Pages$Reports$Memberships$view});
var $author$project$Pages$Reports$Months$GotReportingPeriods = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Reports$Months$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.qs),
				afy: model.afy,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model._E)
			});
	};
};
var $author$project$Api$Provider$ReportingPeriod$All$ReportingPeriod = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportingPeriod$Shared$ReportingPeriod = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportingPeriod$Shared$Record = function (id) {
	return function (name) {
		return function (locked) {
			return function (isLockable) {
				return function (endDate) {
					return function (startDate) {
						return function (revenueInCents) {
							return function (receiptsInCents) {
								return function (stripeFeesInCents) {
									return function (hintFeesInCents) {
										return function (taxesInCents) {
											return function (creditsInCents) {
												return {Mn: creditsInCents, qs: endDate, Qw: hintFeesInCents, adR: id, RO: isLockable, S6: locked, zh: name, XU: receiptsInCents, YF: revenueInCents, _E: startDate, _W: stripeFeesInCents, $v: taxesInCents};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$ReportingPeriod$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'credits_in_cents',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'taxes_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'hint_fees_in_cents',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'stripe_fees_in_cents',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'receipts_in_cents',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'revenue_in_cents',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'start_date',
							$author$project$Utils$Date$decode,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'end_date',
								$author$project$Utils$Date$decode,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_lockable',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'locked',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$ReportingPeriod$Shared$Record)))))))))))));
var $author$project$Api$Provider$ReportingPeriod$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportingPeriod$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportingPeriod$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportingPeriod$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportingPeriod$listDefaults = {E9: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$ReportingPeriod$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$ReportingPeriod$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Hl;
				if (!_v0.$) {
					var start_ = _v0.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'start',
							$author$project$Utils$Date$toQuery(start_))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				function () {
				var _v1 = options.E9;
				if (!_v1.$) {
					var end_ = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$Api$Param$string,
							'end',
							$author$project$Utils$Date$toQuery(end_))
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reporting_periods']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$ReportingPeriod$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$ReportingPeriod$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$ReportingPeriod$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath)));
	});
var $author$project$Pages$Reports$Months$fetchReportingPeriods = function (model) {
	return A3(
		$author$project$Api$Provider$ReportingPeriod$list,
		model.D5,
		$author$project$Pages$Reports$Months$fetchParams(model),
		$author$project$Pages$Reports$Months$GotReportingPeriods);
};
var $author$project$Pages$Reports$Months$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v3.a;
		var end = _v3.b;
		var model = {
			D5: shared.D5,
			cO: shared.cO,
			qs: end,
			i2: $elm$core$Maybe$Nothing,
			i3: $elm$core$Set$empty,
			afy: A2($author$project$Api$Pagination$withItemsPerPage, 13, $author$project$Api$Pagination$init),
			n_: $author$project$Api$Data$Loading,
			ag1: A3($author$project$Api$Sort$withDefault, 'start_date', 1, $author$project$Api$Sort$init),
			_E: start,
			kz: $elm$core$Maybe$Nothing,
			kA: $elm$core$Set$empty
		};
		return _Utils_Tuple2(
			model,
			$author$project$Pages$Reports$Months$fetchReportingPeriods(model));
	});
var $author$project$Pages$Reports$Months$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{cO: shared.cO}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Months$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Months$LockHiConfirmClosed = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$Reports$Months$UnlockHiConfirmClosed = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Reports$Months$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Reports$Months$UnlockHiConfirmClosed),
					model.kz)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Reports$Months$LockHiConfirmClosed),
					model.i2))
			]));
};
var $author$project$Pages$Reports$Months$ReportingPeriodLocked = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Reports$Months$ReportingPeriodUnlocked = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$ReportingPeriod$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$ReportingPeriod$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$id(shared);
};
var $author$project$Api$Provider$ReportingPeriod$One$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$id(shared);
};
var $author$project$Api$Provider$ReportingPeriod$One$ReportingPeriod = $elm$core$Basics$identity;
var $author$project$Api$Provider$ReportingPeriod$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$ReportingPeriod$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$ReportingPeriod$reportingPeriodPath = function (id_) {
	return A2(
		$author$project$Api$Data$pathAppend,
		_List_fromArray(
			[id_]),
		$author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath);
};
var $author$project$Api$Provider$ReportingPeriod$lock = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ReportingPeriod$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'locked',
							$elm$json$Json$Encode$bool(true))
						])),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ReportingPeriod$reportingPeriodPath(id_))));
	});
var $author$project$Api$Provider$ReportingPeriod$unlock = F3(
	function (apiClient, id_, toMsg) {
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Provider$ReportingPeriod$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'locked',
							$elm$json$Json$Encode$bool(false))
						])),
				$author$project$Api$Data$requestTo(
					$author$project$Api$Provider$ReportingPeriod$reportingPeriodPath(id_))));
	});
var $author$project$Pages$Reports$Months$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{n_: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(response));
			case 1:
				var reportingPeriod = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kz: $elm$core$Maybe$Just(reportingPeriod)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var reportingPeriod = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i2: $elm$core$Maybe$Just(reportingPeriod)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var reportingPeriod = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							kz: $elm$core$Maybe$Nothing,
							kA: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod),
								model.kA)
						}),
					A3(
						$author$project$Api$Provider$ReportingPeriod$unlock,
						model.D5,
						$author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod),
						$author$project$Pages$Reports$Months$ReportingPeriodUnlocked),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{kz: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var reportingPeriod = msg.a;
				var confirmed = msg.b;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{
							i2: $elm$core$Maybe$Nothing,
							i3: A2(
								$elm$core$Set$insert,
								$author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod),
								model.i3)
						}),
					A3(
						$author$project$Api$Provider$ReportingPeriod$lock,
						model.D5,
						$author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod),
						$author$project$Pages$Reports$Months$ReportingPeriodLocked),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{i2: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var reportingPeriod = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								n_: $author$project$Api$Data$Loading,
								kA: A2(
									$elm$core$Set$remove,
									$author$project$Api$Provider$ReportingPeriod$One$id(reportingPeriod),
									model.kA)
							}),
						$author$project$Pages$Reports$Months$fetchReportingPeriods(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Reporting period unlocked')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				var response = msg.a;
				if (response.$ === 3) {
					var reportingPeriod = response.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								i3: A2(
									$elm$core$Set$remove,
									$author$project$Api$Provider$ReportingPeriod$One$id(reportingPeriod),
									model.i3),
								n_: $author$project$Api$Data$Loading
							}),
						$author$project$Pages$Reports$Months$fetchReportingPeriods(model),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Reporting period locked')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
		}
	});
var $author$project$Api$Provider$ReportingPeriod$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$ReportingPeriod$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$name(shared);
};
var $author$project$Pages$Reports$Months$UnlockReportingPeriod = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$ReportingPeriod$Shared$endDate = function (_v0) {
	var record = _v0;
	return record.qs;
};
var $author$project$Api$Provider$ReportingPeriod$All$endDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$endDate(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$isLockable = function (_v0) {
	var record = _v0;
	return record.RO;
};
var $author$project$Api$Provider$ReportingPeriod$All$isLockable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$isLockable(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$locked = function (_v0) {
	var record = _v0;
	return record.S6;
};
var $author$project$Api$Provider$ReportingPeriod$All$locked = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$locked(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$startDate = function (_v0) {
	var record = _v0;
	return record._E;
};
var $author$project$Api$Provider$ReportingPeriod$All$startDate = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$startDate(shared);
};
var $author$project$Pages$Reports$Months$LockReportingPeriod = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Reports$Months$viewLockButton = F3(
	function (unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod) {
		var locked = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod);
		var id = $author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod);
		var locking = A2($elm$core$Set$member, id, lockingReportingPeriods);
		var unlocking = A2($elm$core$Set$member, id, unlockingReportingPeriods);
		var label = locking ? 'Locking...' : (unlocking ? 'Unlocking...' : (locked ? 'Locked' : 'Lock'));
		var buttonStyle = function () {
			var _v0 = _Utils_Tuple2(locked, unlocking);
			if (_v0.a && (!_v0.b)) {
				return 1;
			} else {
				return 0;
			}
		}();
		var buttonEnabled = (!(locked || locking)) && $author$project$Api$Provider$ReportingPeriod$All$isLockable(reportingPeriod);
		return A3(
			$author$project$Ui$Button$view,
			{abp: label},
			_List_fromArray(
				[
					$author$project$Ui$Button$styled(buttonStyle),
					$author$project$Ui$Button$pull(1),
					$author$project$Ui$Button$loading(locking || unlocking),
					$author$project$Ui$Button$disabled(!buttonEnabled),
					$author$project$Ui$Button$onClick(
					$author$project$Pages$Reports$Months$LockReportingPeriod(reportingPeriod))
				]),
			_List_fromArray(
				[
					A2($author$project$Ui$Icon$view, _List_Nil, 38),
					$author$project$Utils$Html$noBreakSpace,
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Api$Provider$ReportingPeriod$Shared$creditsInCents = function (_v0) {
	var record = _v0;
	return record.Mn;
};
var $author$project$Api$Provider$ReportingPeriod$All$creditsInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$creditsInCents(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$hintFeesInCents = function (_v0) {
	var record = _v0;
	return record.Qw;
};
var $author$project$Api$Provider$ReportingPeriod$All$hintFeesInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$hintFeesInCents(shared);
};
var $author$project$Ui$Panel$Primary = 0;
var $author$project$Ui$Panel$primary = $author$project$Ui$Panel$Styling(0);
var $author$project$Api$Provider$ReportingPeriod$Shared$receiptsInCents = function (_v0) {
	var record = _v0;
	return record.XU;
};
var $author$project$Api$Provider$ReportingPeriod$All$receiptsInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$receiptsInCents(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$revenueInCents = function (_v0) {
	var record = _v0;
	return record.YF;
};
var $author$project$Api$Provider$ReportingPeriod$All$revenueInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$revenueInCents(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$stripeFeesInCents = function (_v0) {
	var record = _v0;
	return record._W;
};
var $author$project$Api$Provider$ReportingPeriod$All$stripeFeesInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$stripeFeesInCents(shared);
};
var $author$project$Api$Provider$ReportingPeriod$Shared$taxesInCents = function (_v0) {
	var record = _v0;
	return record.$v;
};
var $author$project$Api$Provider$ReportingPeriod$All$taxesInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$ReportingPeriod$Shared$taxesInCents(shared);
};
var $author$project$Pages$Reports$Months$viewMetric = F5(
	function (label, route, start, end, cents) {
		var reportParams = _List_fromArray(
			[
				A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				$author$project$Utils$Date$toQuery)(start),
				A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				$author$project$Utils$Date$toQuery)(end)
			]);
		return A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(label),
					$author$project$Ui$Form$Group$labelSpan(6),
					$author$project$Ui$Form$Group$inputSpan(6),
					$author$project$Ui$Form$Group$labelClass('')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_fromArray(
						[$author$project$Ui$Form$Static$numeric]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(reportParams)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(cents))
								]))
						]))
				]));
	});
var $author$project$Pages$Reports$Months$viewPanel = function (reportingPeriod) {
	var startDate = $author$project$Api$Provider$ReportingPeriod$All$startDate(reportingPeriod);
	var panelOptions = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod) ? _List_fromArray(
		[$author$project$Ui$Panel$primary]) : _List_Nil;
	var endDate = $author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod);
	return A2(
		$author$project$Ui$Panel$view,
		panelOptions,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Billed Revenue',
						$author$project$Spa$Generated$Route$Reports__Revenue,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$revenueInCents(reportingPeriod)),
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Payments Received',
						$author$project$Spa$Generated$Route$Reports__PaymentApplications,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$receiptsInCents(reportingPeriod)),
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Fees',
						$author$project$Spa$Generated$Route$Reports__PaymentApplications,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$hintFeesInCents(reportingPeriod) + $author$project$Api$Provider$ReportingPeriod$All$stripeFeesInCents(reportingPeriod)),
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Taxes',
						$author$project$Spa$Generated$Route$Reports__SalesTax,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$taxesInCents(reportingPeriod)),
						A5(
						$author$project$Pages$Reports$Months$viewMetric,
						'Credits',
						$author$project$Spa$Generated$Route$Reports__CreditTransactions,
						startDate,
						endDate,
						$author$project$Api$Provider$ReportingPeriod$All$creditsInCents(reportingPeriod))
					]))
			]));
};
var $author$project$Pages$Reports$Months$viewReportingPeriod = F3(
	function (unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod) {
		var locked = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod);
		return A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod))
										])),
									A3($author$project$Pages$Reports$Months$viewLockButton, unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$p,
									_List_fromArray(
										[$author$project$Ui$Typography$helpBlock]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Period from ' + (A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$ReportingPeriod$All$startDate(reportingPeriod)) + (' to ' + A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod)))))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textMuted]),
									locked ? _List_fromArray(
										[
											$elm$html$Html$text('If you need to update charges for this period you can '),
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Unlock this reporting period'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
													$author$project$Ui$Button$onClick(
													$author$project$Pages$Reports$Months$UnlockReportingPeriod(reportingPeriod))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('unlock this reporting period')
												]))
										]) : (((!$author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod)) && (!$author$project$Api$Provider$ReportingPeriod$All$isLockable(reportingPeriod))) ? _List_fromArray(
										[
											$elm$html$Html$text(
											'The current reporting period cannot be locked until it is complete on ' + A2(
												$author$project$Formatters$Date$toString,
												$author$project$Formatters$Date$Full,
												$author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod)))
										]) : _List_Nil))
								])),
							$author$project$Pages$Reports$Months$viewPanel(reportingPeriod)
						]))
				]));
	});
var $author$project$Pages$Reports$Months$viewReportingPeriodSkeleton = function (panel) {
	return A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$text(
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$spanFromText('February')
											]))
									])),
								$author$project$Ui$Skeleton$input(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$spanFromText('  Lock  ')
									]))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$text(
								_List_fromArray(
									[
										$author$project$Ui$Skeleton$span(4)
									]))
							])),
						panel
					]))
			]));
}(
	A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		$elm$core$List$singleton(
			A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (label) {
						return A2(
							$author$project$Ui$Form$Group$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Group$labelSkeleton(label),
									$author$project$Ui$Form$Group$labelSpan(6),
									$author$project$Ui$Form$Group$inputSpan(6),
									$author$project$Ui$Form$Group$labelClass('')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Static$view,
									_List_fromArray(
										[$author$project$Ui$Form$Static$numeric]),
									_List_fromArray(
										[
											$author$project$Ui$Skeleton$text(
											_List_fromArray(
												[
													$author$project$Ui$Skeleton$spanFromText('$100.00')
												]))
										]))
								]));
					},
					_List_fromArray(
						['Billed Revenue', 'Payments Received', 'Fees', 'Taxes']))))));
var $author$project$Pages$Reports$Months$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				function () {
				var _v0 = model.kz;
				if (!_v0.$) {
					var reportingPeriod = _v0.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Reports$Months$UnlockHiConfirmClosed(reportingPeriod),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('unlock'),
								$author$project$Components$HiConfirm$noun(
								$author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod)),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Are you sure you want to unlock your ' + ($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod) + ' reporting period? This will allow updating of charges made during this period which may alter your revenue, payment, tax or credit reports.'))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v1 = model.i2;
				if (!_v1.$) {
					var reportingPeriod = _v1.a;
					return A2(
						$author$project$Components$HiConfirm$modal,
						$author$project$Pages$Reports$Months$LockHiConfirmClosed(reportingPeriod),
						_List_fromArray(
							[
								$author$project$Components$HiConfirm$verb('lock'),
								$author$project$Components$HiConfirm$noun(
								$author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod)),
								$author$project$Components$HiConfirm$customMessage(
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Locking your ' + ($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod) + ' reporting period will completely lock down invoices made in this period and ensure your revenue, payments, tax and credit transaction reports cannot change.'))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				function () {
				var _v2 = model.n_;
				if (_v2.$ === 3) {
					var reportingPeriods = _v2.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							A2($author$project$Pages$Reports$Months$viewReportingPeriod, model.kA, model.i3),
							reportingPeriods));
				} else {
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						A2($elm$core$List$repeat, 12, $author$project$Pages$Reports$Months$viewReportingPeriodSkeleton));
				}
			}()
			]),
		$G: 'Reports | Reporting Periods'
	};
};
var $author$project$Pages$Reports$Months$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Months$init, aer: $author$project$Pages$Reports$Months$load, agD: $author$project$Pages$Reports$Months$save, ahd: $author$project$Pages$Reports$Months$subscriptions, aaq: $author$project$Pages$Reports$Months$update, ahP: $author$project$Pages$Reports$Months$view});
var $author$project$Pages$Reports$PaymentApplications$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$PaymentApplications$Table = 0;
var $author$project$Components$Reports$PaymentApplications$ByDropdownMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$PaymentApplications$DateFilterTypeDropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$PaymentApplications$DepositDropdownMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$PaymentApplications$FeeTypeDropdownMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$PaymentApplications$GotDeposits = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Report$PaymentApplicationLine = 9;
var $author$project$Components$Reports$PaymentApplications$PaymentProcessorDropdownMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Reports$PaymentApplications$Transaction = 0;
var $author$project$Components$Reports$PaymentApplications$TransactionTypeDropdownMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Components$Reports$PaymentApplications$ByCategory = 0;
var $author$project$Components$Reports$PaymentApplications$ByLocation = 2;
var $author$project$Components$Reports$PaymentApplications$ByPractitioner = 1;
var $author$project$Components$Reports$PaymentApplications$ByTransactionType = 3;
var $author$project$Components$Reports$PaymentApplications$byOptionFromString = function (str) {
	switch (str) {
		case 'category':
			return $elm$core$Maybe$Just(0);
		case 'practitioner':
			return $elm$core$Maybe$Just(1);
		case 'location':
			return $elm$core$Maybe$Just(2);
		case 'transaction_type':
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$PaymentApplications$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$PaymentApplications$AmericanExpress = 2;
var $author$project$Components$Reports$PaymentApplications$BankTransfer = 0;
var $author$project$Components$Reports$PaymentApplications$Card = 1;
var $author$project$Components$Reports$PaymentApplications$CashCheck = 4;
var $author$project$Components$Reports$PaymentApplications$NoFee = 3;
var $author$project$Components$Reports$PaymentApplications$feeTypeFromString = function (str) {
	switch (str) {
		case 'Bank Transfer':
			return $elm$core$Maybe$Just(0);
		case 'Card':
			return $elm$core$Maybe$Just(1);
		case 'American Express':
			return $elm$core$Maybe$Just(2);
		case 'No Fee':
			return $elm$core$Maybe$Just(3);
		case 'Cash/Check':
			return $elm$core$Maybe$Just(4);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$PaymentApplications$GotPaymentApplications = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Reports$PaymentApplications$dateFilterTypeToString = function (dateFilterType) {
	if (!dateFilterType) {
		return 'transaction';
	} else {
		return 'deposit';
	}
};
var $author$project$Components$Reports$PaymentApplications$feeTypeToValue = function (feeType) {
	switch (feeType) {
		case 0:
			return 'Bank Transfer';
		case 1:
			return 'Card';
		case 2:
			return 'American Express';
		case 3:
			return 'No Fee';
		default:
			return 'Cash/Check';
	}
};
var $author$project$Components$Reports$PaymentApplications$transactionTypeToValue = function (transactionType) {
	switch (transactionType) {
		case 0:
			return 'all';
		case 1:
			return 'payments';
		default:
			return 'refunds';
	}
};
var $author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Ex: model.fa,
				EU: $elm$core$Maybe$Just(
					$author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.EU)),
				qi: model.acI,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				Ph: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$feeTypeToValue, model.Ph),
				aet: model.S3,
				rj: model.fW,
				afy: model.afy,
				V0: model.V0,
				afS: model.WO,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				HC: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$transactionTypeToValue, model.HC)
			});
	};
};
var $author$project$Api$Provider$Reports$PaymentApplication$PaymentApplication = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$PaymentApplication$Record = function (transactionDate) {
	return function (amountInCents) {
		return function (hintFeeInCents) {
			return function (stripeFeeInCents) {
				return function (totalFeeInCents) {
					return function (charge) {
						return function (deposit) {
							return function (receipt) {
								return function (patient) {
									return function (category) {
										return function (invoice) {
											return function (practitioner) {
												return function (location) {
													return {I2: amountInCents, Ex: category, abU: charge, qi: deposit, Qv: hintFeeInCents, Rh: invoice, aet: location, VM: patient, afS: practitioner, XS: receipt, _V: stripeFeeInCents, $V: totalFeeInCents, $2: transactionDate};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$Deposit$Shared$Deposit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Deposit$Shared$Record = F4(
	function (id, availableOn, amountInCents, status) {
		return {I2: amountInCents, JL: availableOn, adR: id, ag7: status};
	});
var $author$project$Api$Provider$Deposit$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$Deposit$decodeStatus, $elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'amount_in_cents',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'available_on',
			$author$project$Utils$Date$decode,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Deposit$Shared$Record)))));
var $author$project$Api$Provider$Deposit$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Deposit$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Receipt$Shared$Receipt = $elm$core$Basics$identity;
var $author$project$Api$Provider$Receipt$Shared$Record = F4(
	function (objectType, feeType, expectedDepositDate, paymentProcessor) {
		return {OU: expectedDepositDate, Ph: feeType, UW: objectType, V0: paymentProcessor};
	});
var $author$project$Api$Provider$Receipt$Shared$recordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'payment_processor',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'expected_deposit_date',
		$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'fee_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'object_type',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$Api$Provider$Receipt$Shared$Record)))));
var $author$project$Api$Provider$Receipt$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Receipt$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$PaymentApplication$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invoice',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'category',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'patient',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'receipt',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Receipt$Shared$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'deposit',
							$elm$json$Json$Decode$nullable($author$project$Api$Provider$Deposit$Shared$decoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'charge',
								$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'total_fee_in_cents',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'stripe_fee_in_cents',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'hint_fee_in_cents',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'amount_in_cents',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'transaction_date',
													$author$project$Utils$Date$decode,
													$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$PaymentApplication$Record))))))))))))));
var $author$project$Api$Provider$Reports$PaymentApplication$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$PaymentApplication$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$PaymentApplication$listDefaults = {Ex: $elm$core$Maybe$Nothing, EU: $elm$core$Maybe$Nothing, qi: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, Ph: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, rj: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, V0: $elm$core$Maybe$Nothing, afS: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, HC: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$PaymentApplication$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.EU;
						if (!_v0.$) {
							var string = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'date_filter_type', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.Hl;
						if (!_v1.$) {
							var start_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.E9;
						if (!_v2.$) {
							var end_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.Ex;
						if (!_v3.$) {
							var category_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'category', category_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.rj;
						if (!_v4.$) {
							var locationGroup_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.aet;
						if (!_v5.$) {
							var location_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v6 = options.afS;
						if (!_v6.$) {
							var practitioner_ = _v6.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v7 = options.qi;
						if (!_v7.$) {
							var string = _v7.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'deposit', string)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v8 = options.Ph;
						if ((!_v8.$) && (_v8.a === 'Cash/Check')) {
							return _List_fromArray(
								[
									A2(
									$author$project$Api$Param$string,
									'payment',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'external_type',
													A2(
														$elm$json$Json$Encode$list,
														$elm$json$Json$Encode$string,
														_List_fromArray(
															['cash', 'check', 'other'])))
												]))))
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var receiptFields = A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[
									function () {
									var _v9 = options.Ph;
									if (!_v9.$) {
										if (_v9.a === 'Cash/Check') {
											return $elm$core$Maybe$Nothing;
										} else {
											var string = _v9.a;
											return $elm$core$Maybe$Just(
												_Utils_Tuple2(
													'fee_type',
													$elm$json$Json$Encode$string(string)));
										}
									} else {
										return $elm$core$Maybe$Nothing;
									}
								}(),
									A2(
									$elm$core$Maybe$map,
									function (pp) {
										return _Utils_Tuple2(
											'payment_processor',
											$elm$json$Json$Encode$string(pp));
									},
									options.V0)
								]));
						return $elm$core$List$isEmpty(receiptFields) ? _List_Nil : _List_fromArray(
							[
								A2(
								$author$project$Api$Param$string,
								'receipt',
								A2(
									$elm$json$Json$Encode$encode,
									0,
									$elm$json$Json$Encode$object(receiptFields)))
							]);
					}(),
						function () {
						var _v10 = options.HC;
						if (!_v10.$) {
							var string = _v10.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'transaction_type', string)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$PaymentApplication$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'payment_applications']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$PaymentApplication$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$PaymentApplication$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$PaymentApplication$listPath)));
	});
var $author$project$Components$Reports$PaymentApplications$fetchPaymentApplications = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$PaymentApplication$list,
			apiClient,
			$author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams(model),
			$author$project$Components$Reports$PaymentApplications$GotPaymentApplications);
	});
var $author$project$Components$Reports$PaymentApplications$GotSummary = function (a) {
	return {$: 17, a: a};
};
var $author$project$Components$Reports$PaymentApplications$byOptionToValue = function (byOption) {
	switch (byOption) {
		case 0:
			return 'category';
		case 1:
			return 'practitioner';
		case 2:
			return 'location';
		default:
			return 'transaction_type';
	}
};
var $author$project$Components$Reports$PaymentApplications$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Ex: model.fa,
				EU: $elm$core$Maybe$Just(
					$author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.EU)),
				qi: model.acI,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				Ph: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$feeTypeToValue, model.Ph),
				aet: model.S3,
				rj: model.fW,
				V0: model.V0,
				afS: model.WO,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				HC: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$transactionTypeToValue, model.HC)
			});
	};
};
var $author$project$Api$Provider$Reports$PaymentApplication$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$PaymentApplication$listPath,
			by,
			$author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$PaymentApplications$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$PaymentApplication$summary,
			apiClient,
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$byOptionToValue, model.bQ)),
			$author$project$Components$Reports$PaymentApplications$fetchSummaryParams(model),
			$author$project$Components$Reports$PaymentApplications$GotSummary);
	});
var $author$project$Components$Reports$PaymentApplications$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.ahI;
		if (!_v0) {
			return A2($author$project$Components$Reports$PaymentApplications$fetchPaymentApplications, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$PaymentApplications$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$PaymentApplications$fetchPaymentApplications, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$PaymentApplications$fetchDepositsParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				ag1: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$init),
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Components$Reports$PaymentApplications$initColumns = function (trackPatientsByLocation) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, 'payment', false, 'Payment'),
			A2(
				$elm$core$List$cons,
				A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'),
				A2(
					$elm$core$List$cons,
					A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
					A2(
						$elm$core$List$cons,
						A3($author$project$Api$Column$init, 'patient', true, 'Patient'),
						A2(
							$elm$core$List$cons,
							A3($author$project$Api$Column$init, 'category', true, 'Category'),
							A2(
								$elm$core$List$cons,
								A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'),
								_Utils_ap(
									trackPatientsByLocation ? _List_fromArray(
										[
											A3($author$project$Api$Column$init, 'location', true, 'Location')
										]) : _List_Nil,
									_List_fromArray(
										[
											A3($author$project$Api$Column$init, 'payment_processor', false, 'Processor')
										])))))))));
};
var $author$project$Api$Provider$Deposit$All$Deposit = $elm$core$Basics$identity;
var $author$project$Api$Provider$Deposit$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Deposit$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Deposit$depositsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['deposits']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Deposit$listDefaults = {
	E9: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	ag1: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$init),
	Hl: $elm$core$Maybe$Nothing
};
var $author$project$Api$Provider$Deposit$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Deposit$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = _Utils_Tuple2(options.Hl, options.E9);
				if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return _List_Nil;
				} else {
					var dates = A2(
						$elm$json$Json$Encode$encode,
						0,
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'gte',
									A2(
										$author$project$Utils$Encode$nullable,
										A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery),
										options.Hl)),
									_Utils_Tuple2(
									'lte',
									A2(
										$author$project$Utils$Encode$nullable,
										A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery),
										options.E9))
								])));
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'transaction_date', dates)
						]);
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Provider$Deposit$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Deposit$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Deposit$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Deposit$depositsPath)));
	});
var $author$project$Components$Reports$PaymentApplications$Deposit = 1;
var $author$project$Components$Reports$PaymentApplications$stringToDateFilterType = function (str) {
	switch (str) {
		case 'transaction':
			return $elm$core$Maybe$Just(0);
		case 'deposit':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$PaymentApplications$AllTransactions = 0;
var $author$project$Components$Reports$PaymentApplications$Payments = 1;
var $author$project$Components$Reports$PaymentApplications$Refunds = 2;
var $author$project$Components$Reports$PaymentApplications$transactionTypeFromString = function (str) {
	switch (str) {
		case 'all':
			return $elm$core$Maybe$Just(0);
		case 'payments':
			return $elm$core$Maybe$Just(1);
		case 'refunds':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Components$Reports$PaymentApplications$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			$elm$core$Maybe$Just(
			_Utils_Tuple2(
				'date_filter_type',
				$author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.EU))),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('category'),
			model.fa),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('deposit'),
			model.acI),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.WO),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('fee_type'),
				$author$project$Components$Reports$PaymentApplications$feeTypeToValue),
			model.Ph),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('payment_processor'),
			model.V0),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('by'),
				$author$project$Components$Reports$PaymentApplications$byOptionToValue),
			model.bQ),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('transaction_type'),
				$author$project$Components$Reports$PaymentApplications$transactionTypeToValue),
			model.HC)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$PaymentApplications$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					function () {
					var _v0 = model.bQ;
					if (!_v0.$) {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary);
					} else {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__PaymentApplications);
					}
				}()
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					$author$project$Utils$QueryParameter$fromDict(
						$author$project$Components$Reports$PaymentApplications$urlParams(model))))));
};
var $author$project$Components$Reports$PaymentApplications$init = F5(
	function (type_, session, practice, shared, query) {
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var feePlanType = $author$project$Api$Provider$Practice$One$feePlanType(practice);
		var categoryId = A2($elm$core$Dict$get, 'category', query);
		var _v0 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var paymentApplications = _v0.a;
		var summary = _v0.b;
		var _v2 = shared;
		var currentDate = _v2.cO;
		var apiClient = _v2.D5;
		var hinterViewOff = _v2.adN;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$PaymentApplications$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		var model = {
			bQ: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$PaymentApplications$byOptionFromString,
				A2($elm$core$Dict$get, 'by', query)),
			lh: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'by-dropdown', ahx: $author$project$Components$Reports$PaymentApplications$ByDropdownMsg})),
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			fa: categoryId,
			cJ: categoryResourceFilter,
			Ll: $author$project$Components$Reports$PaymentApplications$initColumns(trackPatientsByLocation),
			cO: currentDate,
			EU: A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Components$Reports$PaymentApplications$stringToDateFilterType,
					A2($elm$core$Dict$get, 'date_filter_type', query))),
			lL: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'date-filter-type-dropdown-filter', ahx: $author$project$Components$Reports$PaymentApplications$DateFilterTypeDropdownMsg})),
			h3: dateRangeInput,
			lR: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'deposit-dropdown', ahx: $author$project$Components$Reports$PaymentApplications$DepositDropdownMsg})),
			acI: A2($elm$core$Dict$get, 'deposit', query),
			b1: $author$project$Api$Data$Loading,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 9}),
			Pg: feePlanType,
			Ph: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$PaymentApplications$feeTypeFromString,
				A2($elm$core$Dict$get, 'fee_type', query)),
			mf: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'fee-type-dropdown', ahx: $author$project$Components$Reports$PaymentApplications$FeeTypeDropdownMsg})),
			b7: groupLocationAndPractitionerFilters,
			FR: $author$project$Shared$isHintAdmin(shared),
			fW: locationGroupId,
			S3: locationId,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			z: paymentApplications,
			V0: A2($elm$core$Dict$get, 'payment_processor', query),
			nq: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'payment-processor-dropdown', ahx: $author$project$Components$Reports$PaymentApplications$PaymentProcessorDropdownMsg})),
			WO: practitionerId,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			_9: summary,
			$$: trackPatientsByLocation,
			HC: A2(
				$elm$core$Maybe$andThen,
				$author$project$Components$Reports$PaymentApplications$transactionTypeFromString,
				A2($elm$core$Dict$get, 'transaction_type', query)),
			oQ: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'transaction-type-dropdown', ahx: $author$project$Components$Reports$PaymentApplications$TransactionTypeDropdownMsg})),
			ahI: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A3(
						$author$project$Api$Provider$Deposit$list,
						apiClient,
						$author$project$Components$Reports$PaymentApplications$fetchDepositsParams(model),
						$author$project$Components$Reports$PaymentApplications$GotDeposits),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, model),
						$author$project$Components$Reports$PaymentApplications$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$PaymentApplications$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$PaymentApplications$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$PaymentApplications$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$PaymentApplications$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$PaymentApplications$ExportCsvMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Components$Reports$PaymentApplications$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PaymentApplications$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PaymentApplications$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b7)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.cJ)),
				$author$project$Ui$NewDropdown$subscriptions(model.lh),
				$author$project$Ui$NewDropdown$subscriptions(model.lR),
				$author$project$Ui$NewDropdown$subscriptions(model.mf),
				$author$project$Ui$NewDropdown$subscriptions(model.nq),
				$author$project$Ui$NewDropdown$subscriptions(model.lL),
				$author$project$Ui$NewDropdown$subscriptions(model.oQ)
			]));
};
var $author$project$Pages$Reports$PaymentApplications$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$PaymentApplications$subscriptions(model.jO));
};
var $author$project$Components$Reports$PaymentApplications$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lL);
				var dateFilterTypeDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lL: dateFilterTypeDropdown}),
					cmd,
					_List_Nil);
			case 1:
				var dateFilterType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						EU: dateFilterType,
						afy: $author$project$Api$Pagination$reset(model.afy),
						z: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cJ);
				var categoryId = function () {
					var _v3 = categoryResourceResult.ac5;
					if (!_v3.$) {
						if (!_v3.a.$) {
							return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8);
						} else {
							var _v4 = _v3.a;
							return model.fa;
						}
					} else {
						return model.fa;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fa: categoryId, cJ: categoryResourceResult.y8});
				var _v2 = _Utils_eq(model.fa, newModel.fa) ? _Utils_Tuple2(model.z, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])));
				var paymentApplications = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{z: paymentApplications}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg, categoryResourceResult.EC),
								cmd
							])),
					categoryResourceResult.as);
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b1: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 6:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lR);
				var depositDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lR: depositDropdown}),
					cmd,
					_List_Nil);
			case 7:
				var depositId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						acI: depositId,
						afy: $author$project$Api$Pagination$reset(model.afy),
						z: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Ui$NewDropdown$update, subMsg, model.mf);
				var feeTypeDropdown = _v6.a;
				var cmd = _v6.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mf: feeTypeDropdown}),
					cmd,
					_List_Nil);
			case 9:
				var feeType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						Ph: feeType,
						afy: $author$project$Api$Pagination$reset(model.afy),
						z: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 10:
				var subMsg = msg.a;
				var _v7 = A2($author$project$Ui$NewDropdown$update, subMsg, model.nq);
				var paymentProcessorDropdown = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nq: paymentProcessorDropdown}),
					cmd,
					_List_Nil);
			case 11:
				var paymentProcessor = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						z: $author$project$Api$Data$Loading,
						V0: paymentProcessor
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 12:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lh);
				var byDropdown = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lh: byDropdown}),
					cmd,
					_List_Nil);
			case 13:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bQ: by,
						afy: $author$project$Api$Pagination$reset(model.afy),
						z: $author$project$Api$Data$Loading
					});
				var cmds = function () {
					var _v9 = _Utils_Tuple2(model.ahI, newModel.bQ);
					if (!_v9.a) {
						if (!_v9.b.$) {
							var _v10 = _v9.a;
							return _List_fromArray(
								[
									$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
								]);
						} else {
							var _v11 = _v9.a;
							var _v12 = _v9.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v9.b.$ === 1) {
							var _v13 = _v9.a;
							var _v14 = _v9.b;
							return _List_fromArray(
								[
									$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
								]);
						} else {
							var _v15 = _v9.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
									$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 14:
				var subMsg = msg.a;
				var _v16 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oQ);
				var transactionTypeDropdown = _v16.a;
				var cmd = _v16.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oQ: transactionTypeDropdown}),
					cmd,
					_List_Nil);
			case 15:
				var transactionType = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						z: $author$project$Api$Data$Loading,
						HC: transactionType
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var _v17 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v17.a;
				var subCmd = _v17.b;
				var event = _v17.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								z: $author$project$Api$Data$Loading,
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
						$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b7);
				var _v19 = result.ac5;
				switch (_v19.$) {
					case 0:
						var locationGroupId = _v19.a;
						var locationId = _v19.b;
						var practitionerId = _v19.c;
						var newModel = _Utils_update(
							model,
							{
								b7: result.y8,
								fW: locationGroupId,
								S3: locationId,
								afy: $author$project$Api$Pagination$reset(model.afy),
								z: $author$project$Api$Data$Loading,
								WO: practitionerId
							});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, result.EC),
										A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
										$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 16:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								z: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{z: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 17:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 18:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, z: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			case 19:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
								$author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v21 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v21.a;
				var subCmd = _v21.b;
				var subOutMsg = _v21.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$PaymentApplications$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$PaymentApplications$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$PaymentApplications$PaginationMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Reports$PaymentApplications$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$PaymentApplications$creditTransactionsReportParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('practitioner'),
			model.WO)
		]);
	return A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams);
};
var $author$project$Components$Reports$PaymentApplications$BySelected = function (a) {
	return {$: 13, a: a};
};
var $author$project$Components$Reports$PaymentApplications$byOptionToLabel = function (byOption) {
	switch (byOption) {
		case 0:
			return 'Category';
		case 1:
			return 'Provider';
		case 2:
			return 'Location';
		default:
			return 'Transaction Type';
	}
};
var $author$project$Components$Reports$PaymentApplications$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		var baseOptions = _List_fromArray(
			[0, 1, 3]);
		var allOptions = trackPatientsByLocation ? _Utils_ap(
			baseOptions,
			_List_fromArray(
				[2])) : baseOptions;
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$map,
					function (byOption) {
						return A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$Reports$PaymentApplications$BySelected(
										$elm$core$Maybe$Just(byOption))),
									$author$project$Ui$NewDropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just(byOption)))
								]),
							$elm$html$Html$text(
								$author$project$Components$Reports$PaymentApplications$byOptionToLabel(byOption)));
					},
					allOptions)));
	});
var $author$project$Components$Reports$PaymentApplications$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.bQ;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$PaymentApplications$byOptionToLabel(by);
		} else {
			return 'Summarize By';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$PaymentApplications$byDropdownItems, model.$$, model.bQ),
		model.lh);
};
var $author$project$Components$Reports$PaymentApplications$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Category$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			categoryResourceFilter));
};
var $author$project$Components$Reports$PaymentApplications$DateFilterTypeSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel = function (dateFilterType) {
	if (!dateFilterType) {
		return 'Transacted';
	} else {
		return 'Deposited';
	}
};
var $author$project$Components$Reports$PaymentApplications$viewDateFilterTypeDropdown = function (model) {
	var currentLabel = $author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel(model.EU);
	var allTypes = _List_fromArray(
		[0, 1]);
	var items = A2(
		$elm$core$List$map,
		function (dateFilterType) {
			return A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$DateFilterTypeSelected(dateFilterType)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(model.EU, dateFilterType))
					]),
				$elm$html$Html$text(
					$author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel(dateFilterType)));
		},
		allTypes);
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(currentLabel)
			]),
		items,
		model.lL);
};
var $author$project$Components$Reports$PaymentApplications$DepositSelected = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Provider$Deposit$Shared$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Deposit$All$amountInCents = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Deposit$Shared$amountInCents(shared);
};
var $author$project$Api$Provider$Deposit$Shared$availableOn = function (_v0) {
	var record = _v0;
	return record.JL;
};
var $author$project$Api$Provider$Deposit$All$availableOn = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Deposit$Shared$availableOn(shared);
};
var $author$project$Components$Reports$PaymentApplications$depositLabel = function (deposit) {
	return $author$project$Utils$Currency$fromInt(
		$author$project$Api$Provider$Deposit$All$amountInCents(deposit)) + (' on ' + A2(
		$author$project$Formatters$Date$toString,
		$author$project$Formatters$Date$Full,
		$author$project$Api$Provider$Deposit$All$availableOn(deposit)));
};
var $author$project$Api$Provider$Deposit$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Deposit$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$Deposit$Shared$id(shared);
};
var $author$project$Components$Reports$PaymentApplications$depositDropdownItems = F2(
	function (deposits, currentDepositId) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$DepositSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentDepositId, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All Deposits')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$map,
					function (deposit) {
						var depositId = $author$project$Api$Provider$Deposit$All$id(deposit);
						return A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$Reports$PaymentApplications$DepositSelected(
										$elm$core$Maybe$Just(depositId))),
									$author$project$Ui$NewDropdown$selected(
									_Utils_eq(
										currentDepositId,
										$elm$core$Maybe$Just(depositId)))
								]),
							$elm$html$Html$text(
								$author$project$Components$Reports$PaymentApplications$depositLabel(deposit)));
					},
					deposits)));
	});
var $author$project$Components$Reports$PaymentApplications$viewDepositDropdown = function (model) {
	var placeholder = function () {
		var _v1 = model.acI;
		if (!_v1.$) {
			var depositId = _v1.a;
			var _v2 = model.b1;
			if (_v2.$ === 3) {
				var deposits = _v2.a;
				return A2(
					$elm$core$Maybe$withDefault,
					depositId,
					A2(
						$elm$core$Maybe$map,
						$author$project$Components$Reports$PaymentApplications$depositLabel,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (deposit) {
									return _Utils_eq(
										$author$project$Api$Provider$Deposit$All$id(deposit),
										depositId);
								},
								deposits))));
			} else {
				return depositId;
			}
		} else {
			return 'Deposit';
		}
	}();
	var items = function () {
		var _v0 = model.b1;
		if (_v0.$ === 3) {
			var deposits = _v0.a;
			return A2($author$project$Components$Reports$PaymentApplications$depositDropdownItems, deposits, model.acI);
		} else {
			return _List_Nil;
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		items,
		model.lR);
};
var $author$project$Components$Reports$PaymentApplications$FeeTypeSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$PaymentApplications$feeTypeToLabel = function (feeType) {
	switch (feeType) {
		case 0:
			return 'Bank Transfer';
		case 1:
			return 'Card (Non Amex)';
		case 2:
			return 'American Express';
		case 3:
			return 'All External';
		default:
			return 'Cash/Check/Other';
	}
};
var $author$project$Components$Reports$PaymentApplications$feeTypeDropdownItems = function (currentFeeType) {
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$PaymentApplications$FeeTypeSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentFeeType, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Payment Types')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				function (feeType) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Reports$PaymentApplications$FeeTypeSelected(
									$elm$core$Maybe$Just(feeType))),
								$author$project$Ui$NewDropdown$selected(
								_Utils_eq(
									currentFeeType,
									$elm$core$Maybe$Just(feeType)))
							]),
						$elm$html$Html$text(
							$author$project$Components$Reports$PaymentApplications$feeTypeToLabel(feeType)));
				},
				_List_fromArray(
					[0, 1, 2, 3, 4]))));
};
var $author$project$Components$Reports$PaymentApplications$viewFeeTypeDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.Ph;
		if (!_v0.$) {
			var feeType = _v0.a;
			return $author$project$Components$Reports$PaymentApplications$feeTypeToLabel(feeType);
		} else {
			return 'Payment Type';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$PaymentApplications$feeTypeDropdownItems(model.Ph),
		model.mf);
};
var $author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$PaymentApplications$paymentProcessorDropdownItems = F2(
	function (isHintAdmin, currentProcessor) {
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentProcessor, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All Processors')),
				$author$project$Ui$NewDropdown$separator,
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected(
							$elm$core$Maybe$Just('rainforest'))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							currentProcessor,
							$elm$core$Maybe$Just('rainforest')))
					]),
				$elm$html$Html$text(
					A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'rainforest'))),
				A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected(
							$elm$core$Maybe$Just('stripe'))),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(
							currentProcessor,
							$elm$core$Maybe$Just('stripe')))
					]),
				$elm$html$Html$text(
					A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'stripe')))
			]);
	});
var $author$project$Components$Reports$PaymentApplications$viewPaymentProcessorDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.V0;
		if (!_v0.$) {
			var processor = _v0.a;
			return $elm$html$Html$text(
				A2($author$project$Utils$PaymentProcessor$toLabelText, model.FR, processor));
		} else {
			return $elm$html$Html$text('Payment Processor');
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[placeholder]),
		A2($author$project$Components$Reports$PaymentApplications$paymentProcessorDropdownItems, model.FR, model.V0),
		model.nq);
};
var $author$project$Ui$Table$alignBottom = $author$project$Ui$Table$VerticalAlignedBottom;
var $author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents = function (_v0) {
	var record = _v0;
	return record.o9.Qv;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents = function (_v0) {
	var record = _v0;
	return record.o9._V;
};
var $author$project$Api$Provider$Reports$Summary$summaryRowTotalFeeInCents = function (_v0) {
	var record = _v0;
	return record.o9.$V;
};
var $author$project$Components$Reports$PaymentApplications$feePlanTypeAmounts = F2(
	function (feePlanType, summaryRow) {
		if (!feePlanType) {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text('Platform Fees'),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text('Stripe Fees'),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents(summaryRow)))
								]))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text('Transaction Fees'),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$Summary$summaryRowTotalFeeInCents(summaryRow)))
								]))
						]))
				]);
		}
	});
var $author$project$Components$Reports$PaymentApplications$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$PaymentApplications$urlParams(model),
					summaryRow))
			]);
		var netInCents = ($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow) - $author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents(summaryRow)) - $author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents(summaryRow);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$alignBottom]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[$author$project$Ui$Typography$info]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__PaymentApplications,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'None',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$alignBottom]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__PaymentApplications,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'payment application',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween]),
							_List_fromArray(
								[
									$elm$html$Html$text('Net Amount'),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(netInCents))
										]))
								])),
						_Utils_ap(
							A2($author$project$Components$Reports$PaymentApplications$feePlanTypeAmounts, model.Pg, summaryRow),
							_List_fromArray(
								[
									$author$project$Ui$HorizontalRule$view(
									_List_fromArray(
										[$author$project$Ui$HorizontalRule$thin])),
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$textRight]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Reports__PaymentApplications,
													routeParams,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
														]))
												]))
										]))
								]))))
				]));
	});
var $author$project$Components$Reports$PaymentApplications$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model._9)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model._9)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model._9)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Payment Applications')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$PaymentApplications$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$PaymentApplications$SortTable = function (a) {
	return {$: 19, a: a};
};
var $author$project$Ui$Typography$Amount = {$: 10};
var $author$project$Ui$Typography$amount = $author$project$Ui$Typography$Amount;
var $author$project$Api$Provider$Reports$PaymentApplication$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$PaymentApplication$category = function (_v0) {
	var record = _v0;
	return record.Ex;
};
var $author$project$Api$Provider$Reports$PaymentApplication$charge = function (_v0) {
	var record = _v0;
	return record.abU;
};
var $author$project$Api$Provider$Reports$PaymentApplication$deposit = function (_v0) {
	var record = _v0;
	return record.qi;
};
var $author$project$Components$Reports$PaymentApplications$depositParams = function (deposit) {
	return _List_fromArray(
		[
			A2(
			$elm$url$Url$Builder$string,
			'start',
			$author$project$Utils$Date$toQuery(
				$author$project$Api$Provider$Deposit$Shared$availableOn(deposit))),
			A2(
			$elm$url$Url$Builder$string,
			'end',
			$author$project$Utils$Date$toQuery(
				$author$project$Api$Provider$Deposit$Shared$availableOn(deposit)))
		]);
};
var $author$project$Api$Provider$Receipt$Shared$feeType = function (_v0) {
	var record = _v0;
	return record.Ph;
};
var $author$project$Api$Provider$Reports$PaymentApplication$hintFeeInCents = function (_v0) {
	var record = _v0;
	return record.Qv;
};
var $author$project$Api$Provider$Reports$PaymentApplication$invoice = function (_v0) {
	var record = _v0;
	return record.Rh;
};
var $author$project$Api$Provider$Reports$PaymentApplication$location = function (_v0) {
	var record = _v0;
	return record.aet;
};
var $author$project$Api$Provider$Receipt$Shared$objectType = function (_v0) {
	var record = _v0;
	return record.UW;
};
var $author$project$Api$Provider$Reports$PaymentApplication$patient = function (_v0) {
	var record = _v0;
	return record.VM;
};
var $author$project$Api$Provider$Receipt$Shared$paymentProcessor = function (_v0) {
	var record = _v0;
	return record.V0;
};
var $author$project$Api$Provider$Reports$PaymentApplication$practitioner = function (_v0) {
	var record = _v0;
	return record.afS;
};
var $author$project$Api$Provider$Reports$PaymentApplication$receipt = function (_v0) {
	var record = _v0;
	return record.XS;
};
var $author$project$Api$Provider$Deposit$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Reports$PaymentApplication$stripeFeeInCents = function (_v0) {
	var record = _v0;
	return record._V;
};
var $author$project$Api$Provider$Reports$PaymentApplication$totalFeeInCents = function (_v0) {
	var record = _v0;
	return record.$V;
};
var $author$project$Api$Provider$Reports$PaymentApplication$transactionDate = function (_v0) {
	var record = _v0;
	return record.$2;
};
var $author$project$Api$Provider$Receipt$Shared$expectedDepositDate = function (_v0) {
	var record = _v0;
	return record.OU;
};
var $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit = function (paymentApplication) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		$author$project$Api$Provider$Receipt$Shared$expectedDepositDate,
		$author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication));
	if (!_v0.$) {
		var expectedDepositDate = _v0.a;
		return A2(
			$author$project$Ui$Typography$p,
			_List_fromArray(
				[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
			_List_fromArray(
				[
					$elm$html$Html$text('Expected deposit date: '),
					$elm$html$Html$text(
					A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expectedDepositDate))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Components$Reports$PaymentApplications$viewRow = F5(
	function (feePlanType, trackPatientsByLocation, canGoToPatients, isHintAdmin, paymentApplication) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$PaymentApplication$transactionDate(paymentApplication))),
									function () {
									var _v0 = $author$project$Api$Provider$Reports$PaymentApplication$deposit(paymentApplication);
									if (!_v0.$) {
										var deposit = _v0.a;
										return ($author$project$Api$Provider$Deposit$Shared$status(deposit) === 5) ? $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit(paymentApplication) : A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
											_List_fromArray(
												[
													$elm$html$Html$text('Deposited '),
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Reports__Deposits,
													_List_fromArray(
														[
															$author$project$Ui$Link$routeParams(
															$author$project$Components$Reports$PaymentApplications$depositParams(deposit))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Deposit$Shared$amountInCents(deposit))),
															$elm$html$Html$text(' on '),
															$elm$html$Html$text(
															A2(
																$author$project$Formatters$Date$toString,
																$author$project$Formatters$Date$Full,
																$author$project$Api$Provider$Deposit$Shared$availableOn(deposit)))
														]))
												]));
									} else {
										return $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit(paymentApplication);
									}
								}()
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											A2($elm$core$Basics$composeR, $author$project$Api$Provider$Receipt$Shared$objectType, $author$project$Formatters$String$humanize),
											$author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication)))),
									$elm$html$Html$text(' '),
									A2(
									$author$project$Ui$Typography$span,
									A2(
										$elm$core$List$cons,
										$author$project$Ui$Typography$small,
										A2(
											$elm$core$List$cons,
											$author$project$Ui$Typography$amount,
											($author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication) < 0) ? _List_fromArray(
												[$author$project$Ui$Typography$danger]) : _List_Nil)),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication)))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'Fee Category: ' + A2(
												$elm$core$Maybe$withDefault,
												'',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Provider$Receipt$Shared$feeType,
													$author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication)))),
											A2($elm$html$Html$br, _List_Nil, _List_Nil),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											function () {
												if (!feePlanType) {
													return _List_fromArray(
														[
															$elm$html$Html$text(
															'Platform Fee: ' + $author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$PaymentApplication$hintFeeInCents(paymentApplication))),
															A2($elm$html$Html$br, _List_Nil, _List_Nil),
															$elm$html$Html$text(
															'Stripe Fee: ' + $author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$PaymentApplication$stripeFeeInCents(paymentApplication)))
														]);
												} else {
													return _List_fromArray(
														[
															$elm$html$Html$text(
															'Transaction Fee: ' + $author$project$Utils$Currency$fromInt(
																$author$project$Api$Provider$Reports$PaymentApplication$totalFeeInCents(paymentApplication)))
														]);
												}
											}())
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('for '),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Provider$Reports$Charge$name,
															$author$project$Api$Provider$Reports$PaymentApplication$charge(paymentApplication))))
												])),
											$elm$html$Html$text(
											' on ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$Reports$Charge$serviceDate,
														$author$project$Api$Provider$Reports$PaymentApplication$charge(paymentApplication)))))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v2 = $author$project$Api$Provider$Reports$PaymentApplication$invoice(paymentApplication);
								if (!_v2.$) {
									var invoice = _v2.a;
									var paidBy = A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$small,
												$author$project$Ui$Typography$muted
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												'paid by ' + A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Common$Payable$Owner$Min$name,
														$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))))
											]));
									var invoicePath_ = function () {
										var _v4 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
										switch (_v4) {
											case 1:
												var _v5 = _Utils_Tuple2(
													canGoToPatients,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v5.a && (!_v5.b.$)) {
													var owner = _v5.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
															{
																aea: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
																VN: $author$project$Api$Common$Payable$Owner$Min$id(owner)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											case 0:
												var _v6 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
												if (!_v6.$) {
													var owner = _v6.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
															{
																ff: $author$project$Api$Common$Payable$Owner$Min$id(owner),
																adR: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											default:
												return $elm$core$Maybe$Nothing;
										}
									}();
									var invoiceNumber = $elm$html$Html$text(
										'#' + $elm$core$String$fromInt(
											$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)));
									if (!invoicePath_.$) {
										var path = invoicePath_.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												path,
												_List_Nil,
												_List_fromArray(
													[invoiceNumber])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												paidBy
											]);
									} else {
										return _List_fromArray(
											[
												invoiceNumber,
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												paidBy
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									function () {
										var _v7 = _Utils_Tuple2(
											$author$project$Api$Provider$Reports$PaymentApplication$patient(paymentApplication),
											canGoToPatients);
										if (!_v7.a.$) {
											if (_v7.b) {
												var patient = _v7.a.a;
												return _List_fromArray(
													[
														A3(
														$author$project$Ui$Link$route,
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
															{
																VN: $author$project$Api$Provider$Patient$Min$id(patient)
															}),
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																A2(
																	$author$project$Formatters$String$ellipsis,
																	20,
																	$author$project$Api$Provider$Patient$Min$name(patient)))
															]))
													]);
											} else {
												var patient = _v7.a.a;
												return _List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$author$project$Formatters$String$ellipsis,
															20,
															$author$project$Api$Provider$Patient$Min$name(patient)))
													]);
											}
										} else {
											var _v8 = _v7.a;
											return _List_fromArray(
												[
													$elm$html$Html$text('N/A')
												]);
										}
									}())
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Category$Min$name,
											$author$project$Api$Provider$Reports$PaymentApplication$category(paymentApplication))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Practitioner$Min$name,
												$author$project$Api$Provider$Reports$PaymentApplication$practitioner(paymentApplication)))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$PaymentApplication$location(paymentApplication)))))
								]))
						]) : _List_Nil,
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$core$Maybe$withDefault,
									$author$project$Utils$Html$empty,
									A4(
										$author$project$Utils$PaymentProcessor$toBadge,
										true,
										isHintAdmin,
										paymentApplication,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Api$Provider$Reports$PaymentApplication$receipt,
											$elm$core$Maybe$andThen($author$project$Api$Provider$Receipt$Shared$paymentProcessor))))
								]))
						])
					])));
	});
var $author$project$Components$Reports$PaymentApplications$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.z;
		if (_v1.$ === 3) {
			var paymentApplications_ = _v1.a;
			return _Utils_Tuple2(false, paymentApplications_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var paymentApplications = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$PaymentApplications$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$PaymentApplications$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A4($author$project$Components$Reports$PaymentApplications$viewRow, model.Pg, model.$$, model.Er, model.FR),
			paymentApplications),
		_List_Nil);
};
var $author$project$Components$Reports$PaymentApplications$TransactionTypeSelected = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Reports$PaymentApplications$transactionTypeToLabel = function (transactionType) {
	switch (transactionType) {
		case 0:
			return 'All Transactions';
		case 1:
			return 'Payments';
		default:
			return 'Refunds';
	}
};
var $author$project$Components$Reports$PaymentApplications$transactionTypeDropdownItems = function (currentTransactionType) {
	return A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Components$Reports$PaymentApplications$TransactionTypeSelected($elm$core$Maybe$Nothing)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(currentTransactionType, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('All Transaction Types')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				function (transactionType) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Reports$PaymentApplications$TransactionTypeSelected(
									$elm$core$Maybe$Just(transactionType))),
								$author$project$Ui$NewDropdown$selected(
								_Utils_eq(
									currentTransactionType,
									$elm$core$Maybe$Just(transactionType)))
							]),
						$elm$html$Html$text(
							$author$project$Components$Reports$PaymentApplications$transactionTypeToLabel(transactionType)));
				},
				_List_fromArray(
					[1, 2]))));
};
var $author$project$Components$Reports$PaymentApplications$viewTransactionTypeDropdownFilter = function (model) {
	var placeholder = function () {
		var _v0 = model.HC;
		if (!_v0.$) {
			var transactionType = _v0.a;
			return $author$project$Components$Reports$PaymentApplications$transactionTypeToLabel(transactionType);
		} else {
			return 'Transaction Type';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$PaymentApplications$transactionTypeDropdownItems(model.HC),
		model.oQ);
};
var $author$project$Components$Reports$PaymentApplications$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$PaymentApplications$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.z)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams, $author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Received Payments')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.z;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										var totalPassthroughFeesAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-passthrough-fee-amount');
										var totalFeeAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-fee-amount');
										var totalAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-amount');
										var totalNetAmount = totalAmount - totalFeeAmount;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Utils$Currency$fromInt(totalAmount)),
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														' Net ' + ($author$project$Utils$Currency$fromInt(totalNetAmount) + (' across ' + A2(
															$author$project$Formatters$String$pluralize,
															'payment application',
															A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-count')))))
													])),
												function () {
												var _v1 = model.Pg;
												if (!_v1) {
													return A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																' including ' + ($author$project$Utils$Currency$fromInt(
																	A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-hint-fee-amount')) + (' in Platform fees and ' + ($author$project$Utils$Currency$fromInt(
																	A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-stripe-fee-amount')) + ' in Stripe fees.'))))
															]));
												} else {
													return A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																' including ' + ($author$project$Utils$Currency$fromInt(totalFeeAmount) + ' in transaction fees.'))
															]));
												}
											}(),
												function () {
												if (totalPassthroughFeesAmount > 0) {
													var nonPassthroughFeesAmount = totalFeeAmount - totalPassthroughFeesAmount;
													var passthroughFeesText = ' Of those fees, ' + ($author$project$Utils$Currency$fromInt(totalPassthroughFeesAmount) + (' were paid by patients and ' + ($author$project$Utils$Currency$fromInt(nonPassthroughFeesAmount) + ' by your practice.')));
													return A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
														_List_fromArray(
															[
																$elm$html$Html$text(passthroughFeesText)
															]));
												} else {
													return $author$project$Utils$Html$empty;
												}
											}()
											]);
									} else {
										return _List_fromArray(
											[
												A2(
												$author$project$Ui$Element$view,
												_List_fromArray(
													[$author$project$Ui$Element$spaceX2]),
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$spanFromText('$1000.00')
															])),
														A2(
														$author$project$Ui$Typography$span,
														_List_fromArray(
															[$author$project$Ui$Typography$small]),
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$text(
																_List_fromArray(
																	[
																		$author$project$Ui$Skeleton$span(5)
																	]))
															]))
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total payments (and refunds) applied to charges, excluding '),
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__CreditTransactions,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(
												$author$project$Components$Reports$PaymentApplications$creditTransactionsReportParams(model))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('credit transactions')
											])),
										$elm$html$Html$text('.')
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(3)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$PaymentApplications$viewDateFilterTypeDropdown(model)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(9)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$PaymentApplications$DateRangeInputMsg,
												$author$project$Components$DateRangeInput$view(model.h3))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$FlexGrid$column(
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.b7))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewCategoryResourceFilter(model.cJ)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewDepositDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewFeeTypeDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewPaymentProcessorDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewByDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$PaymentApplications$viewTransactionTypeDropdownFilter(model)
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$Category$viewMultiSelected(model.cJ)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b7)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v2 = model.ahI;
						if (!_v2) {
							return $author$project$Components$Reports$PaymentApplications$viewTable(model);
						} else {
							return $author$project$Components$Reports$PaymentApplications$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v3 = model.ahI;
						if (!_v3) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$PaymentApplications$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.z)))
												]),
											model.afy))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$PaymentApplications$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$PaymentApplications$view, model.D5, model.jO)),
		$G: 'Reports | Received Payments'
	};
};
var $author$project$Pages$Reports$PaymentApplications$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$PaymentApplications$init, aer: $author$project$Pages$Reports$PaymentApplications$load, agD: $author$project$Pages$Reports$PaymentApplications$save, ahd: $author$project$Pages$Reports$PaymentApplications$subscriptions, aaq: $author$project$Pages$Reports$PaymentApplications$update, ahP: $author$project$Pages$Reports$PaymentApplications$view});
var $author$project$Pages$Reports$PaymentApplications$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$PaymentApplications$Summary = 1;
var $author$project$Pages$Reports$PaymentApplications$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$PaymentApplications$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$PaymentApplications$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$PaymentApplications$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$PaymentApplications$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$PaymentApplications$subscriptions(model.jO));
};
var $author$project$Pages$Reports$PaymentApplications$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$PaymentApplications$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$PaymentApplications$Summary$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$PaymentApplications$view, model.D5, model.jO)),
		$G: 'Reports | Received Payments'
	};
};
var $author$project$Pages$Reports$PaymentApplications$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$PaymentApplications$Summary$init, aer: $author$project$Pages$Reports$PaymentApplications$Summary$load, agD: $author$project$Pages$Reports$PaymentApplications$Summary$save, ahd: $author$project$Pages$Reports$PaymentApplications$Summary$subscriptions, aaq: $author$project$Pages$Reports$PaymentApplications$Summary$update, ahP: $author$project$Pages$Reports$PaymentApplications$Summary$view});
var $author$project$Pages$Reports$Revenue$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Revenue$Table = 0;
var $author$project$Components$Reports$Revenue$ByDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$Revenue$DateRangeInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Provider$Report$RevenueLine = 6;
var $author$project$Components$Reports$Revenue$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('category'),
			model.fa),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.WO),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.bQ)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$Revenue$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				function () {
				var _v0 = model.bQ;
				if (!_v0.$) {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Revenue__Summary);
				} else {
					return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Revenue);
				}
			}()
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				$author$project$Utils$QueryParameter$fromDict(
					$author$project$Components$Reports$Revenue$urlParams(model)))));
};
var $author$project$Components$Reports$Revenue$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$Revenue$GotRevenueLines = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$Revenue$fetchRevenueLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Ex: model.fa,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afy: model.afy,
				afS: model.WO,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Api$Provider$Reports$RevenueLine$RevenueLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$RevenueLine$Record = F8(
	function (transactionDate, amountInCents, category, charge, invoice, client, practitioner, location) {
		return {I2: amountInCents, Ex: category, abU: charge, K1: client, Rh: invoice, aet: location, afS: practitioner, $2: transactionDate};
	});
var $author$project$Api$Provider$Reports$RevenueLine$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'client',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$RevenueLine$Client$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'invoice',
				$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'charge',
					$elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'category',
						$elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transaction_date',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$RevenueLine$Record)))))))));
var $author$project$Api$Provider$Reports$RevenueLine$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$RevenueLine$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$RevenueLine$listDefaults = {Ex: $elm$core$Maybe$Nothing, E9: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, rj: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, afS: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$RevenueLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.Ex;
						if (!_v2.$) {
							var taxJurisdiction_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'category', taxJurisdiction_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.rj;
						if (!_v3.$) {
							var locationGroup_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.aet;
						if (!_v4.$) {
							var location_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.afS;
						if (!_v5.$) {
							var practitioner_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$RevenueLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'revenue_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$RevenueLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$RevenueLine$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$RevenueLine$listPath)));
	});
var $author$project$Components$Reports$Revenue$fetchRevenueLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$RevenueLine$list,
			apiClient,
			$author$project$Components$Reports$Revenue$fetchRevenueLinesParams(model),
			$author$project$Components$Reports$Revenue$GotRevenueLines);
	});
var $author$project$Components$Reports$Revenue$GotSummary = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$Revenue$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				Ex: model.fa,
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afS: model.WO,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl)
			});
	};
};
var $author$project$Api$Provider$Reports$RevenueLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$RevenueLine$listPath,
			by,
			$author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$Revenue$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$RevenueLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.bQ),
			$author$project$Components$Reports$Revenue$fetchSummaryParams(model),
			$author$project$Components$Reports$Revenue$GotSummary);
	});
var $author$project$Components$Reports$Revenue$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.ahI;
		if (!_v0) {
			return A2($author$project$Components$Reports$Revenue$fetchRevenueLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$Revenue$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$Revenue$fetchRevenueLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$Revenue$initColumns = function (trackPatientsByLocation) {
	return A2(
		$elm$core$List$cons,
		A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
		A2(
			$elm$core$List$cons,
			A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'),
			A2(
				$elm$core$List$cons,
				A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
				A2(
					$elm$core$List$cons,
					A3($author$project$Api$Column$init, 'client', true, 'Client'),
					A2(
						$elm$core$List$cons,
						A3($author$project$Api$Column$init, 'category', true, 'Category'),
						A2(
							$elm$core$List$cons,
							A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'),
							trackPatientsByLocation ? _List_fromArray(
								[
									A3($author$project$Api$Column$init, 'location', true, 'Location')
								]) : _List_Nil))))));
};
var $author$project$Components$Reports$Revenue$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.cO;
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var categoryId = A2($elm$core$Dict$get, 'category', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var revenueLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$Revenue$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
		var categoryResourceFilter = _v6.a;
		var categoryResourceFilterCmd = _v6.b;
		var model = {
			bQ: A2($elm$core$Dict$get, 'by', query),
			lh: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'by-dropdown', ahx: $author$project$Components$Reports$Revenue$ByDropdownMsg})),
			Eq: A3($author$project$Permission$canGoTo, session, hinterViewOff, 17),
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			fa: categoryId,
			cJ: categoryResourceFilter,
			Ll: $author$project$Components$Reports$Revenue$initColumns(trackPatientsByLocation),
			cO: currentDate,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 6}),
			b7: groupLocationAndPractitionerFilters,
			fW: locationGroupId,
			S3: locationId,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WO: practitionerId,
			aO: revenueLines,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			_9: summary,
			$$: trackPatientsByLocation,
			ahI: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg, categoryResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$Revenue$fetchData, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$Revenue$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$Revenue$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$Revenue$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Revenue$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$Revenue$ExportCsvMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$Revenue$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Revenue$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Revenue$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b7)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$Revenue$CategoryResourceFilterMsg,
				$author$project$Components$ResourceFilter$Category$subscriptions(model.cJ)),
				$author$project$Ui$NewDropdown$subscriptions(model.lh)
			]));
};
var $author$project$Pages$Reports$Revenue$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Revenue$subscriptions(model.jO));
};
var $author$project$Components$Reports$Revenue$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cJ);
				var categoryId = function () {
					var _v2 = categoryResourceResult.ac5;
					if (!_v2.$) {
						if (!_v2.a.$) {
							return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.y8);
						} else {
							var _v3 = _v2.a;
							return model.fa;
						}
					} else {
						return model.fa;
					}
				}();
				var newModel = _Utils_update(
					model,
					{fa: categoryId, cJ: categoryResourceResult.y8});
				var _v1 = _Utils_eq(model.fa, newModel.fa) ? _Utils_Tuple2(model.aO, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var revenueLines = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{aO: revenueLines}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg, categoryResourceResult.EC),
								cmd
							])),
					categoryResourceResult.as);
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lh);
				var byDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lh: byDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bQ: by,
						afy: $author$project$Api$Pagination$reset(model.afy),
						aO: $author$project$Api$Data$Loading
					});
				var cmds = function () {
					var _v5 = _Utils_Tuple2(model.ahI, newModel.bQ);
					if (!_v5.a) {
						if (!_v5.b.$) {
							var _v6 = _v5.a;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v7 = _v5.a;
							var _v8 = _v5.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v5.b.$ === 1) {
							var _v9 = _v5.a;
							var _v10 = _v5.b;
							return _List_fromArray(
								[
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						} else {
							var _v11 = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
									A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 0:
				var subMsg = msg.a;
				var _v12 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v12.a;
				var subCmd = _v12.b;
				var event = _v12.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								aO: $author$project$Api$Data$Loading,
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b7);
				var _v14 = result.ac5;
				switch (_v14.$) {
					case 0:
						var locationGroupId = _v14.a;
						var locationId = _v14.b;
						var practitionerId = _v14.c;
						var newModel = _Utils_update(
							model,
							{
								b7: result.y8,
								fW: locationGroupId,
								S3: locationId,
								afy: $author$project$Api$Pagination$reset(model.afy),
								WO: practitionerId,
								aO: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, result.EC),
										A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
										A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 5:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								aO: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aO: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, aO: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 8:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v16 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v16.a;
				var subCmd = _v16.b;
				var subOutMsg = _v16.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$Revenue$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Revenue$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$Revenue$PaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$Revenue$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$Revenue$BySelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$Revenue$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$Revenue$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Reports$Revenue$BySelected(
									$elm$core$Maybe$Just('category'))),
								$author$project$Ui$NewDropdown$selected(
								_Utils_eq(
									currentBy,
									$elm$core$Maybe$Just('category')))
							]),
						$elm$html$Html$text('Category')),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$Reports$Revenue$BySelected(
										$elm$core$Maybe$Just('practitioner'))),
									$author$project$Ui$NewDropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just('practitioner')))
								]),
							$elm$html$Html$text('Provider')),
						trackPatientsByLocation ? _List_fromArray(
							[
								A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$Reports$Revenue$BySelected(
											$elm$core$Maybe$Just('location'))),
										$author$project$Ui$NewDropdown$selected(
										_Utils_eq(
											currentBy,
											$elm$core$Maybe$Just('location')))
									]),
								$elm$html$Html$text('Location'))
							]) : _List_Nil))));
	});
var $author$project$Components$Reports$Revenue$byToDisplayName = function (by) {
	switch (by) {
		case 'category':
			return 'Category';
		case 'practitioner':
			return 'Provider';
		case 'location':
			return 'Location';
		default:
			return by;
	}
};
var $author$project$Components$Reports$Revenue$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.bQ;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$Revenue$byToDisplayName(by);
		} else {
			return 'Summarize by';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$Revenue$byDropdownItems, model.$$, model.bQ),
		model.lh);
};
var $author$project$Components$Reports$Revenue$viewCategoryResourceFilter = function (categoryResourceFilter) {
	return A2(
		$elm$html$Html$map,
		$author$project$Components$Reports$Revenue$CategoryResourceFilterMsg,
		A2(
			$author$project$Components$ResourceFilter$Category$viewNew,
			_List_fromArray(
				[
					$author$project$Components$ResourceFilter$style(1),
					$author$project$Components$ResourceFilter$multi
				]),
			categoryResourceFilter));
};
var $author$project$Components$Reports$Revenue$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$Revenue$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__Revenue,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'Unassigned',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__Revenue,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'charge',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__Revenue,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$Revenue$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model._9)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model._9)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model._9)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Charges')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$Revenue$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$Revenue$SortTable = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$RevenueLine$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$RevenueLine$category = function (_v0) {
	var record = _v0;
	return record.Ex;
};
var $author$project$Api$Provider$Reports$RevenueLine$charge = function (_v0) {
	var record = _v0;
	return record.abU;
};
var $author$project$Api$Provider$Reports$RevenueLine$client = function (_v0) {
	var record = _v0;
	return record.K1;
};
var $author$project$Api$Provider$Reports$RevenueLine$invoice = function (_v0) {
	var record = _v0;
	return record.Rh;
};
var $author$project$Api$Provider$Reports$RevenueLine$location = function (_v0) {
	var record = _v0;
	return record.aet;
};
var $author$project$Api$Provider$Reports$RevenueLine$practitioner = function (_v0) {
	var record = _v0;
	return record.afS;
};
var $author$project$Api$Provider$Reports$RevenueLine$transactionDate = function (_v0) {
	var record = _v0;
	return record.$2;
};
var $author$project$Components$Reports$Revenue$viewRow = F4(
	function (trackPatientsByLocation, canGoToPatients, canGoToCompany, revenueLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$RevenueLine$transactionDate(revenueLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$RevenueLine$amountInCents(revenueLine))),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
									_List_fromArray(
										[
											$elm$html$Html$text('for '),
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2(
														$elm$core$Maybe$withDefault,
														'N/A',
														A2(
															$elm$core$Maybe$map,
															$author$project$Api$Provider$Reports$Charge$name,
															$author$project$Api$Provider$Reports$RevenueLine$charge(revenueLine))))
												])),
											$elm$html$Html$text(
											' on ' + A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Provider$Reports$Charge$serviceDate,
														$author$project$Api$Provider$Reports$RevenueLine$charge(revenueLine)))))
										]))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = $author$project$Api$Provider$Reports$RevenueLine$invoice(revenueLine);
								if (!_v0.$) {
									var invoice = _v0.a;
									var invoiceStatus = A2(
										$author$project$Ui$Badge$fromString,
										_List_Nil,
										$author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice));
									var invoicePath_ = function () {
										var _v2 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
										switch (_v2) {
											case 1:
												var _v3 = _Utils_Tuple2(
													canGoToPatients,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v3.a && (!_v3.b.$)) {
													var owner = _v3.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
															{
																aea: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
																VN: $author$project$Api$Common$Payable$Owner$Min$id(owner)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											case 0:
												var _v4 = _Utils_Tuple2(
													canGoToCompany,
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
												if (_v4.a && (!_v4.b.$)) {
													var owner = _v4.b.a;
													return $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
															{
																ff: $author$project$Api$Common$Payable$Owner$Min$id(owner),
																adR: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
															}));
												} else {
													return $elm$core$Maybe$Nothing;
												}
											default:
												return $elm$core$Maybe$Nothing;
										}
									}();
									var invoiceNumber = $elm$html$Html$text(
										'#' + ($elm$core$String$fromInt(
											$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' '));
									var _for = A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$phi(true),
												$author$project$Ui$Typography$small,
												$author$project$Ui$Typography$muted
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												'for ' + A2(
													$elm$core$Maybe$withDefault,
													'N/A',
													A2(
														$elm$core$Maybe$map,
														$author$project$Api$Common$Payable$Owner$Min$name,
														$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))))
											]));
									if (!invoicePath_.$) {
										var path = invoicePath_.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												path,
												_List_Nil,
												_List_fromArray(
													[invoiceNumber, invoiceStatus])),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_for
											]);
									} else {
										return _List_fromArray(
											[
												invoiceNumber,
												invoiceStatus,
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												_for
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$phi(true)
										]),
									function () {
										var _v5 = $author$project$Api$Provider$Reports$RevenueLine$client(revenueLine);
										if (!_v5.$) {
											var client = _v5.a;
											var path = function () {
												var _v7 = $author$project$Api$Provider$Reports$RevenueLine$Client$type_(client);
												if (!_v7) {
													return canGoToPatients ? $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
															{
																VN: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
															})) : $elm$core$Maybe$Nothing;
												} else {
													return canGoToCompany ? $elm$core$Maybe$Just(
														$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
															{
																ff: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
															})) : $elm$core$Maybe$Nothing;
												}
											}();
											var clientName = $elm$html$Html$text(
												A2(
													$author$project$Formatters$String$ellipsis,
													20,
													$author$project$Api$Provider$Reports$RevenueLine$Client$name(client)));
											if (!path.$) {
												var path_ = path.a;
												return _List_fromArray(
													[
														A3(
														$author$project$Ui$Link$route,
														path_,
														_List_Nil,
														_List_fromArray(
															[clientName]))
													]);
											} else {
												return _List_fromArray(
													[clientName]);
											}
										} else {
											return _List_fromArray(
												[
													$elm$html$Html$text('N/A')
												]);
										}
									}())
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Category$Min$name,
											$author$project$Api$Provider$Reports$RevenueLine$category(revenueLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Practitioner$Min$name,
												$author$project$Api$Provider$Reports$RevenueLine$practitioner(revenueLine)))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$RevenueLine$location(revenueLine)))))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Reports$Revenue$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.aO;
		if (_v1.$ === 3) {
			var revenueLines_ = _v1.a;
			return _Utils_Tuple2(false, revenueLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var revenueLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$Revenue$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$Revenue$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A3($author$project$Components$Reports$Revenue$viewRow, model.$$, model.Er, model.Eq),
			revenueLines),
		_List_Nil);
};
var $author$project$Components$Reports$Revenue$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$Revenue$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.aO)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams, $author$project$Components$Reports$Revenue$fetchRevenueLinesParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Billed Revenue')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.aO;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$Revenue$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total billed (and reversed out) revenue across retail customers and employers')
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$Revenue$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.h3)),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$FlexGrid$column(
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.b7))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Revenue$viewCategoryResourceFilter(model.cJ)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$Revenue$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = _Utils_ap(
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$Revenue$CategoryResourceFilterMsg),
													$author$project$Components$ResourceFilter$Category$viewMultiSelected(model.cJ)),
												A2(
													$elm$core$List$map,
													$elm$html$Html$map($author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg),
													$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b7)));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.ahI;
						if (!_v1) {
							return $author$project$Components$Reports$Revenue$viewTable(model);
						} else {
							return $author$project$Components$Reports$Revenue$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.ahI;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$Revenue$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.aO)))
												]),
											model.afy))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$Revenue$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Revenue$view, model.D5, model.jO)),
		$G: 'Reports | Billed Revenue'
	};
};
var $author$project$Pages$Reports$Revenue$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Revenue$init, aer: $author$project$Pages$Reports$Revenue$load, agD: $author$project$Pages$Reports$Revenue$save, ahd: $author$project$Pages$Reports$Revenue$subscriptions, aaq: $author$project$Pages$Reports$Revenue$update, ahP: $author$project$Pages$Reports$Revenue$view});
var $author$project$Pages$Reports$Revenue$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$Revenue$Summary = 1;
var $author$project$Pages$Reports$Revenue$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$Revenue$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$Revenue$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$Revenue$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$Revenue$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$Revenue$subscriptions(model.jO));
};
var $author$project$Pages$Reports$Revenue$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$Revenue$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$Revenue$Summary$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$Revenue$view, model.D5, model.jO)),
		$G: 'Reports | Billed Revenue'
	};
};
var $author$project$Pages$Reports$Revenue$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$Revenue$Summary$init, aer: $author$project$Pages$Reports$Revenue$Summary$load, agD: $author$project$Pages$Reports$Revenue$Summary$save, ahd: $author$project$Pages$Reports$Revenue$Summary$subscriptions, aaq: $author$project$Pages$Reports$Revenue$Summary$update, ahP: $author$project$Pages$Reports$Revenue$Summary$view});
var $author$project$Pages$Reports$SalesTax$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$SalesTax$Table = 0;
var $author$project$Components$Reports$SalesTax$ByDropdownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$SalesTax$DateRangeInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$SalesTax$GotTaxJurisdictions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$SalesTax$TaxJurisdictionDropdownMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Provider$Report$TaxLine = 8;
var $author$project$Components$Reports$SalesTax$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$SalesTax$GotSummary = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Reports$SalesTax$fetchSummaryParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afS: model.WO,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				te: model.gZ
			});
	};
};
var $author$project$Api$Provider$Reports$TaxLine$listDefaults = {E9: $elm$core$Maybe$Nothing, aet: $elm$core$Maybe$Nothing, rj: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, afS: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, te: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$TaxLine$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$TaxLine$listDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.afS;
						if (!_v2.$) {
							var practitioner_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'practitioner', practitioner_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.te;
						if (!_v3.$) {
							var taxJurisdiction_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'tax_jurisdiction', taxJurisdiction_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.rj;
						if (!_v4.$) {
							var locationGroup_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location_group', locationGroup_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v5 = options.aet;
						if (!_v5.$) {
							var location_ = _v5.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'location', location_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$TaxLine$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'tax_lines']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$TaxLine$summary = F4(
	function (apiClient, by, optionals, toMsg) {
		return A5(
			$author$project$Api$Provider$Reports$Summary$retrieve,
			apiClient,
			$author$project$Api$Provider$Reports$TaxLine$listPath,
			by,
			$author$project$Api$Provider$Reports$TaxLine$listOptionsToParams(optionals),
			toMsg);
	});
var $author$project$Components$Reports$SalesTax$fetchSummary = F2(
	function (apiClient, model) {
		return A4(
			$author$project$Api$Provider$Reports$TaxLine$summary,
			apiClient,
			A2($elm$core$Maybe$withDefault, '', model.bQ),
			$author$project$Components$Reports$SalesTax$fetchSummaryParams(model),
			$author$project$Components$Reports$SalesTax$GotSummary);
	});
var $author$project$Components$Reports$SalesTax$GotTaxLines = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$SalesTax$fetchTaxLinesParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				aet: model.S3,
				rj: model.fW,
				afy: model.afy,
				afS: model.WO,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				te: model.gZ
			});
	};
};
var $author$project$Api$Provider$Reports$TaxLine$TaxLine = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$TaxLine$Record = F8(
	function (transactionDate, amountInCents, rate, serviceDate, taxJurisdiction, invoice, practitioner, location) {
		return {I2: amountInCents, Rh: invoice, aet: location, afS: practitioner, XJ: rate, ZB: serviceDate, te: taxJurisdiction, $2: transactionDate};
	});
var $author$project$Api$Provider$TaxJurisdiction$Min$TaxJurisdiction = $elm$core$Basics$identity;
var $author$project$Api$Provider$TaxJurisdiction$Min$Record = function (name) {
	return {zh: name};
};
var $author$project$Api$Provider$TaxJurisdiction$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxJurisdiction$Min$Record));
var $author$project$Api$Provider$TaxJurisdiction$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$TaxJurisdiction$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$TaxLine$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'location',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practitioner',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'invoice',
			$elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'tax_jurisdiction',
				$elm$json$Json$Decode$nullable($author$project$Api$Provider$TaxJurisdiction$Min$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'service_date',
					$elm$json$Json$Decode$nullable($author$project$Utils$Date$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rate',
						$elm$json$Json$Decode$float,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'amount_in_cents',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'transaction_date',
								$author$project$Utils$Date$decode,
								$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$TaxLine$Record)))))))));
var $author$project$Api$Provider$Reports$TaxLine$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$TaxLine$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$TaxLine$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$TaxLine$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$TaxLine$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$TaxLine$listPath)));
	});
var $author$project$Components$Reports$SalesTax$fetchTaxLines = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$TaxLine$list,
			apiClient,
			$author$project$Components$Reports$SalesTax$fetchTaxLinesParams(model),
			$author$project$Components$Reports$SalesTax$GotTaxLines);
	});
var $author$project$Components$Reports$SalesTax$fetchData = F2(
	function (apiClient, model) {
		var _v0 = model.ahI;
		if (!_v0) {
			return A2($author$project$Components$Reports$SalesTax$fetchTaxLines, apiClient, model);
		} else {
			return $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Components$Reports$SalesTax$fetchSummary, apiClient, model),
						A2($author$project$Components$Reports$SalesTax$fetchTaxLines, apiClient, model)
					]));
		}
	});
var $author$project$Components$Reports$SalesTax$initColumns = function (trackPatientsByLocation) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
					A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
					A3($author$project$Api$Column$init, 'rate', true, 'Rate'),
					A3($author$project$Api$Column$init, 'charge', true, 'Service Date'),
					A3($author$project$Api$Column$init, 'tax_jurisdiction', true, 'Jurisdiction'),
					A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
					A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
				]),
				trackPatientsByLocation ? _List_fromArray(
				[
					A3($author$project$Api$Column$init, 'location', true, 'Location')
				]) : _List_Nil
			]));
};
var $author$project$Components$Reports$SalesTax$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$pair('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('tax_jurisdiction'),
			model.gZ),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location_group'),
			model.fW),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('location'),
			model.S3),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('practitioner'),
			model.WO),
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('by'),
			model.bQ)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Components$Reports$SalesTax$updateUrl = function (model) {
	return $author$project$Ports$Navigation$pushUrl(
		A2(
			$elm$url$Url$Builder$relative,
			_List_fromArray(
				[
					function () {
					var _v0 = model.bQ;
					if (!_v0.$) {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SalesTax__Summary);
					} else {
						return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SalesTax);
					}
				}()
				]),
			A2(
				$elm$core$List$append,
				$author$project$Api$Pagination$toPageQuery(model.afy),
				A2(
					$elm$core$List$append,
					$author$project$Api$Sort$toQuery(model.ag1),
					$author$project$Utils$QueryParameter$fromDict(
						$author$project$Components$Reports$SalesTax$urlParams(model))))));
};
var $author$project$Components$Reports$SalesTax$init = F5(
	function (type_, session, practice, _v0, query) {
		var currentDate = _v0.cO;
		var apiClient = _v0.D5;
		var hinterViewOff = _v0.adN;
		var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
		var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
		var locationId = A2($elm$core$Dict$get, 'location', query);
		var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
		var _v1 = function () {
			if (!type_) {
				return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
			} else {
				return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
			}
		}();
		var taxLines = _v1.a;
		var summary = _v1.b;
		var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
		var groupLocationAndPractitionerFilters = _v3.a;
		var groupLocationAndPractitionerFiltersCmd = _v3.b;
		var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v4.a;
		var end = _v4.b;
		var _v5 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$SalesTax$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v5.a;
		var dateRangeInputCmd = _v5.b;
		var model = {
			bQ: A2($elm$core$Dict$get, 'by', query),
			lh: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'by-dropdown', ahx: $author$project$Components$Reports$SalesTax$ByDropdownMsg})),
			Er: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
			Ll: $author$project$Components$Reports$SalesTax$initColumns(trackPatientsByLocation),
			cO: currentDate,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 8}),
			b7: groupLocationAndPractitionerFilters,
			fW: locationGroupId,
			S3: locationId,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			WO: practitionerId,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'transaction_date',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			_9: summary,
			oI: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'tax-jurisdiction-dropdown', ahx: $author$project$Components$Reports$SalesTax$TaxJurisdictionDropdownMsg})),
			gZ: A2($elm$core$Dict$get, 'tax_jurisdiction', query),
			$s: $author$project$Api$Data$Loading,
			bh: taxLines,
			$$: trackPatientsByLocation,
			ahI: type_
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Reports$SalesTax$GotTaxJurisdictions),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$DateRangeInputMsg, dateRangeInputCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
						A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, model),
						$author$project$Components$Reports$SalesTax$updateUrl(model)
					])));
	});
var $author$project$Pages$Reports$SalesTax$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$SalesTax$init, 0, session, practice, shared, query);
		var report = _v1.a;
		var reportTaxCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
	});
var $author$project$Pages$Reports$SalesTax$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$SalesTax$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$SalesTax$ExportCsvMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$SalesTax$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SalesTax$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SalesTax$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg,
				$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b7)),
				$author$project$Ui$NewDropdown$subscriptions(model.lh),
				$author$project$Ui$NewDropdown$subscriptions(model.oI)
			]));
};
var $author$project$Pages$Reports$SalesTax$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$SalesTax$subscriptions(model.jO));
};
var $author$project$Components$Reports$SalesTax$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{$s: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 3:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oI);
				var taxJurisdictionDropdown = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oI: taxJurisdictionDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var taxJurisdictionId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						gZ: taxJurisdictionId,
						bh: $author$project$Api$Data$Loading
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
								$author$project$Components$Reports$SalesTax$updateUrl(newModel)
							])),
					_List_Nil);
			case 5:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$NewDropdown$update, subMsg, model.lh);
				var byDropdown = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{lh: byDropdown}),
					cmd,
					_List_Nil);
			case 6:
				var by = msg.a;
				var newModel = _Utils_update(
					model,
					{
						bQ: by,
						afy: $author$project$Api$Pagination$reset(model.afy),
						bh: $author$project$Api$Data$Loading
					});
				var cmds = function () {
					var _v3 = _Utils_Tuple2(model.ahI, newModel.bQ);
					if (!_v3.a) {
						if (!_v3.b.$) {
							var _v4 = _v3.a;
							return _List_fromArray(
								[
									$author$project$Components$Reports$SalesTax$updateUrl(newModel)
								]);
						} else {
							var _v5 = _v3.a;
							var _v6 = _v3.b;
							return _List_fromArray(
								[$elm$core$Platform$Cmd$none]);
						}
					} else {
						if (_v3.b.$ === 1) {
							var _v7 = _v3.a;
							var _v8 = _v3.b;
							return _List_fromArray(
								[
									$author$project$Components$Reports$SalesTax$updateUrl(newModel)
								]);
						} else {
							var _v9 = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
									$author$project$Components$Reports$SalesTax$updateUrl(newModel)
								]);
						}
					}
				}();
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(cmds),
					_List_Nil);
			case 1:
				var subMsg = msg.a;
				var _v10 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v10.a;
				var subCmd = _v10.b;
				var event = _v10.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
								bh: $author$project$Api$Data$Loading
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
						$author$project$Components$Reports$SalesTax$updateUrl(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b7);
				var _v12 = result.ac5;
				switch (_v12.$) {
					case 0:
						var locationGroupId = _v12.a;
						var locationId = _v12.b;
						var practitionerId = _v12.c;
						var newModel = _Utils_update(
							model,
							{
								b7: result.y8,
								fW: locationGroupId,
								S3: locationId,
								afy: $author$project$Api$Pagination$reset(model.afy),
								WO: practitionerId,
								bh: $author$project$Api$Data$Loading
							});
						return _Utils_Tuple3(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, result.EC),
										A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
										$author$project$Components$Reports$SalesTax$updateUrl(newModel)
									])),
							result.as);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
					default:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b7: result.y8}),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, result.EC),
							result.as);
				}
			case 7:
				var response = msg.a;
				if (response.$ === 3) {
					var headers = response.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								bh: response
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bh: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{_9: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, bh: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
								$author$project$Components$Reports$SalesTax$updateUrl(newModel)
							])),
					_List_Nil);
			case 10:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
								$author$project$Components$Reports$SalesTax$updateUrl(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v14 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v14.a;
				var subCmd = _v14.b;
				var subOutMsg = _v14.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$SalesTax$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$SalesTax$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$SalesTax$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$SalesTax$amountFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$andThen,
				$elm$core$String$toInt,
				A2($elm$core$Dict$get, name, headers)));
	});
var $author$project$Components$Reports$SalesTax$BySelected = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$SalesTax$byDropdownItems = F2(
	function (trackPatientsByLocation, currentBy) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$SalesTax$BySelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('No Summary')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$cons,
					A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Reports$SalesTax$BySelected(
									$elm$core$Maybe$Just('tax_jurisdiction'))),
								$author$project$Ui$NewDropdown$selected(
								_Utils_eq(
									currentBy,
									$elm$core$Maybe$Just('tax_jurisdiction')))
							]),
						$elm$html$Html$text('Tax Jurisdiction')),
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$Reports$SalesTax$BySelected(
										$elm$core$Maybe$Just('practitioner'))),
									$author$project$Ui$NewDropdown$selected(
									_Utils_eq(
										currentBy,
										$elm$core$Maybe$Just('practitioner')))
								]),
							$elm$html$Html$text('Provider')),
						trackPatientsByLocation ? _List_fromArray(
							[
								A2(
								$author$project$Ui$NewDropdown$item,
								_List_fromArray(
									[
										$author$project$Ui$NewDropdown$onSelect(
										$author$project$Components$Reports$SalesTax$BySelected(
											$elm$core$Maybe$Just('location'))),
										$author$project$Ui$NewDropdown$selected(
										_Utils_eq(
											currentBy,
											$elm$core$Maybe$Just('location')))
									]),
								$elm$html$Html$text('Location'))
							]) : _List_Nil))));
	});
var $author$project$Components$Reports$SalesTax$byToDisplayName = function (by) {
	switch (by) {
		case 'tax_jurisdiction':
			return 'Tax Jurisdiction';
		case 'practitioner':
			return 'Provider';
		case 'location':
			return 'Location';
		default:
			return by;
	}
};
var $author$project$Components$Reports$SalesTax$viewByDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.bQ;
		if (!_v0.$) {
			var by = _v0.a;
			return $author$project$Components$Reports$SalesTax$byToDisplayName(by);
		} else {
			return 'Summarize by';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		A2($author$project$Components$Reports$SalesTax$byDropdownItems, model.$$, model.bQ),
		model.lh);
};
var $author$project$Components$Reports$SalesTax$viewSummaryRow = F2(
	function (model, summaryRow) {
		var routeParams = _List_fromArray(
			[
				$author$project$Ui$Link$routeParams(
				A2(
					$author$project$Utils$Report$summaryRowTableParams,
					$author$project$Components$Reports$SalesTax$urlParams(model),
					summaryRow))
			]);
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_fromArray(
								[
									$author$project$Ui$Typography$info,
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__SalesTax,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'None',
												$author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Reports__SalesTax,
							routeParams,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$pluralize,
										'tax line',
										$author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_fromArray(
						[$author$project$Ui$Table$textRight]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__SalesTax,
									routeParams,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Utils$Currency$fromInt(
												$author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
										]))
								]))
						]))
				]));
	});
var $author$project$Components$Reports$SalesTax$viewSummaryTable = function (model) {
	var summaryType = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize),
			$author$project$Api$Data$toMaybe(model._9)));
	var summaryRows = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Provider$Reports$Summary$summaryRows,
			$author$project$Api$Data$toMaybe(model._9)));
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(
				!$author$project$Api$Data$isSuccess(model._9)),
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
							]))
					]))
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(summaryType)
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Number of Tax Lines')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_fromArray(
					[
						$author$project$Ui$Table$cellSpan(4),
						$author$project$Ui$Table$textRight
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Amount')
					]))
			]),
		A2(
			$elm$core$List$map,
			$author$project$Components$Reports$SalesTax$viewSummaryRow(model),
			summaryRows),
		_List_Nil);
};
var $author$project$Components$Reports$SalesTax$SortTable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Provider$Reports$TaxLine$amountInCents = function (_v0) {
	var record = _v0;
	return record.I2;
};
var $author$project$Api$Provider$Reports$TaxLine$invoice = function (_v0) {
	var record = _v0;
	return record.Rh;
};
var $author$project$Api$Provider$Reports$TaxLine$location = function (_v0) {
	var record = _v0;
	return record.aet;
};
var $author$project$Api$Provider$TaxJurisdiction$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$Reports$TaxLine$practitioner = function (_v0) {
	var record = _v0;
	return record.afS;
};
var $author$project$Api$Provider$Reports$TaxLine$rate = function (_v0) {
	var record = _v0;
	return record.XJ;
};
var $author$project$Api$Provider$Reports$TaxLine$serviceDate = function (_v0) {
	var record = _v0;
	return record.ZB;
};
var $author$project$Api$Provider$Reports$TaxLine$taxJurisdiction = function (_v0) {
	var record = _v0;
	return record.te;
};
var $author$project$Api$Provider$Reports$TaxLine$transactionDate = function (_v0) {
	var record = _v0;
	return record.$2;
};
var $author$project$Components$Reports$SalesTax$viewRow = F3(
	function (canGoToPatients, trackPatientsByLocation, taxLine) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$Date$toString,
										$author$project$Formatters$Date$Full,
										$author$project$Api$Provider$Reports$TaxLine$transactionDate(taxLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Utils$Currency$fromInt(
										$author$project$Api$Provider$Reports$TaxLine$amountInCents(taxLine)))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromFloat(
										$author$project$Api$Provider$Reports$TaxLine$rate(taxLine)) + '%')
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
											$author$project$Api$Provider$Reports$TaxLine$serviceDate(taxLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$TaxJurisdiction$Min$name,
											$author$project$Api$Provider$Reports$TaxLine$taxJurisdiction(taxLine))))
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							function () {
								var _v0 = $author$project$Api$Provider$Reports$TaxLine$invoice(taxLine);
								if (!_v0.$) {
									var invoice = _v0.a;
									var _v1 = _Utils_Tuple2(
										canGoToPatients,
										$author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
									if (_v1.a && (!_v1.b.$)) {
										var owner = _v1.b.a;
										return _List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
													{
														aea: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
														VN: $author$project$Api$Common$Payable$Owner$Min$id(owner)
													}),
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														'#' + $elm$core$String$fromInt(
															$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
													]))
											]);
									} else {
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'#' + $elm$core$String$fromInt(
													$author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
											]);
									}
								} else {
									return _List_Nil;
								}
							}()),
							A2(
							$author$project$Ui$Table$cell,
							_List_fromArray(
								[
									$author$project$Ui$Table$colspan(
									trackPatientsByLocation ? 1 : 2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$Practitioner$Min$name,
											$author$project$Api$Provider$Reports$TaxLine$practitioner(taxLine))))
								]))
						]),
						trackPatientsByLocation ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$author$project$Formatters$String$ellipsis,
										20,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2(
												$elm$core$Maybe$map,
												$author$project$Api$Provider$Location$Min$name,
												$author$project$Api$Provider$Reports$TaxLine$location(taxLine)))))
								]))
						]) : _List_Nil
					])));
	});
var $author$project$Components$Reports$SalesTax$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.bh;
		if (_v1.$ === 3) {
			var taxLines_ = _v1.a;
			return _Utils_Tuple2(false, taxLines_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var taxLines = _v0.b;
	return A4(
		$author$project$Ui$Panel$table,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$SalesTax$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$SalesTax$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$map,
			A2($author$project$Components$Reports$SalesTax$viewRow, model.Er, model.$$),
			taxLines),
		_List_Nil);
};
var $author$project$Components$Reports$SalesTax$TaxJurisdictionSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$SalesTax$taxJurisdictionDropdownItems = F2(
	function (taxJurisdictions, currentTaxJurisdictionId) {
		return A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect(
						$author$project$Components$Reports$SalesTax$TaxJurisdictionSelected($elm$core$Maybe$Nothing)),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(currentTaxJurisdictionId, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('All Tax Jurisdictions')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2(
					$elm$core$List$map,
					function (taxJurisdiction) {
						var jurisdictionId = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
						return A2(
							$author$project$Ui$NewDropdown$item,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$onSelect(
									$author$project$Components$Reports$SalesTax$TaxJurisdictionSelected(
										$elm$core$Maybe$Just(jurisdictionId))),
									$author$project$Ui$NewDropdown$selected(
									_Utils_eq(
										currentTaxJurisdictionId,
										$elm$core$Maybe$Just(jurisdictionId)))
								]),
							$elm$html$Html$text(
								$author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction)));
					},
					taxJurisdictions)));
	});
var $author$project$Components$Reports$SalesTax$viewTaxJurisrictionDropdown = function (model) {
	var placeholder = function () {
		var _v1 = model.gZ;
		if (!_v1.$) {
			var taxJurisdictionId = _v1.a;
			var _v2 = model.$s;
			if (_v2.$ === 3) {
				var taxJurisdictions = _v2.a;
				return A2(
					$elm$core$Maybe$withDefault,
					taxJurisdictionId,
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$TaxJurisdiction$All$name,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (jurisdiction) {
									return _Utils_eq(
										$author$project$Api$Provider$TaxJurisdiction$All$id(jurisdiction),
										taxJurisdictionId);
								},
								taxJurisdictions))));
			} else {
				return taxJurisdictionId;
			}
		} else {
			return 'Tax Jurisdiction';
		}
	}();
	var items = function () {
		var _v0 = model.$s;
		if (_v0.$ === 3) {
			var taxJurisdictions = _v0.a;
			return A2($author$project$Components$Reports$SalesTax$taxJurisdictionDropdownItems, taxJurisdictions, model.gZ);
		} else {
			return _List_Nil;
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		items,
		model.oI);
};
var $author$project$Components$Reports$SalesTax$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$SalesTax$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.bh)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$TaxLine$listOptionsToParams, $author$project$Components$Reports$SalesTax$fetchTaxLinesParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Sales Tax')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.bh;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total: ' + $author$project$Utils$Currency$fromInt(
													A2($author$project$Components$Reports$SalesTax$amountFromHeader, headers, 'x-total-amount')))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
													]))
											]);
									}
								}()),
								A2(
								$author$project$Ui$Typography$p,
								_List_fromArray(
									[$author$project$Ui$Typography$helpBlock]),
								_List_fromArray(
									[
										$elm$html$Html$text('Total sales tax liabilities for all invoices (excluding \"draft\" or \"cancelled\" invoices). The only way to reverse these liabilities is to '),
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/invoices/creating-and-issuing-invoices',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('void the invoice.')
											])),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(' Learn more about this report ')
											])),
										A3(
										$author$project$Ui$Link$externalHref,
										'https://support.hint.com/reports-and-deposits/sales-tax-reporting',
										_List_fromArray(
											[$author$project$Ui$Link$targetBlank]),
										_List_fromArray(
											[
												$elm$html$Html$text('here')
											]))
									])),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$SalesTax$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.h3)),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_Utils_ap(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											$elm$core$List$singleton,
											$author$project$Ui$FlexGrid$column(
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$span(6),
														$author$project$Ui$FlexGrid$spanMd(4)
													]))),
										A2(
											$elm$core$List$map,
											$elm$html$Html$map($author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg),
											A2(
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew,
												_List_fromArray(
													[$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi]),
												model.b7))),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$SalesTax$viewTaxJurisrictionDropdown(model)
												])),
											A2(
											$author$project$Ui$FlexGrid$column,
											_List_fromArray(
												[
													$author$project$Ui$FlexGrid$span(6),
													$author$project$Ui$FlexGrid$spanMd(4)
												]),
											_List_fromArray(
												[
													$author$project$Components$Reports$SalesTax$viewByDropdown(model)
												]))
										]))),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg),
												$author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b7));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						function () {
						var _v1 = model.ahI;
						if (!_v1) {
							return $author$project$Components$Reports$SalesTax$viewTable(model);
						} else {
							return $author$project$Components$Reports$SalesTax$viewSummaryTable(model);
						}
					}(),
						function () {
						var _v2 = model.ahI;
						if (!_v2) {
							return A2(
								$author$project$Ui$Panel$footer,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										$author$project$Components$Reports$SalesTax$PaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Utils$Maybe$toBool(
														$author$project$Api$Data$toMaybe(model.bh)))
												]),
											model.afy))
									]));
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]);
	});
var $author$project$Pages$Reports$SalesTax$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$SalesTax$view, model.D5, model.jO)),
		$G: 'Reports | Sales Tax'
	};
};
var $author$project$Pages$Reports$SalesTax$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$SalesTax$init, aer: $author$project$Pages$Reports$SalesTax$load, agD: $author$project$Pages$Reports$SalesTax$save, ahd: $author$project$Pages$Reports$SalesTax$subscriptions, aaq: $author$project$Pages$Reports$SalesTax$update, ahP: $author$project$Pages$Reports$SalesTax$view});
var $author$project$Pages$Reports$SalesTax$Summary$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$SalesTax$Summary = 1;
var $author$project$Pages$Reports$SalesTax$Summary$init = F4(
	function (session, practice, shared, _v0) {
		var query = _v0.Bi;
		var _v1 = A5($author$project$Components$Reports$SalesTax$init, 1, session, practice, shared, query);
		var report = _v1.a;
		var reportCmd = _v1.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$SalesTax$Summary$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$SalesTax$Summary$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Reports$SalesTax$Summary$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$SalesTax$subscriptions(model.jO));
};
var $author$project$Pages$Reports$SalesTax$Summary$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$SalesTax$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Pages$Reports$SalesTax$Summary$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$SalesTax$view, model.D5, model.jO)),
		$G: 'Reports | Sales Tax'
	};
};
var $author$project$Pages$Reports$SalesTax$Summary$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$SalesTax$Summary$init, aer: $author$project$Pages$Reports$SalesTax$Summary$load, agD: $author$project$Pages$Reports$SalesTax$Summary$save, ahd: $author$project$Pages$Reports$SalesTax$Summary$subscriptions, aaq: $author$project$Pages$Reports$SalesTax$Summary$update, ahP: $author$project$Pages$Reports$SalesTax$Summary$view});
var $author$project$Pages$Reports$SignupAttempts$ReportMsg = $elm$core$Basics$identity;
var $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Reports$SignupAttempts$GotSignupPages = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Provider$Report$SignupAttempt = 1;
var $author$project$Components$Reports$SignupAttempts$SignupPageDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Reports$SignupAttempts$StatusDropdownMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Reports$SignupAttempts$buildUrl = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.Hl),
			A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				A2($author$project$Utils$DateWithDefault$toQuery, model.cO, 0)),
			model.E9),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('lead_source'),
			model.SI),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('signup_page'),
			model.ot),
			A2(
			$elm$core$Maybe$map,
			$elm$url$Url$Builder$string('status'),
			model.ag7)
		]);
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SignupAttempts)
			]),
		A2(
			$elm$core$List$append,
			$author$project$Api$Pagination$toPageQuery(model.afy),
			A2(
				$elm$core$List$append,
				$author$project$Api$Sort$toQuery(model.ag1),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
};
var $author$project$Components$Reports$SignupAttempts$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Components$Reports$SignupAttempts$GotSignupAttempts = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Reports$SignupAttempts$fetchParams = function (model) {
	return function (d) {
		return _Utils_update(
			d,
			{
				E9: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.E9),
				SH: model.SI,
				afy: model.afy,
				Hc: model.ot,
				ag1: model.ag1,
				Hl: A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, model.cO, 0),
					model.Hl),
				ag7: model.ag7
			});
	};
};
var $author$project$Api$Provider$Reports$SignupAttempt$SignupAttempt = $elm$core$Basics$identity;
var $author$project$Api$Provider$Reports$SignupAttempt$Record = function (createdAt) {
	return function (status) {
		return function (firstName) {
			return function (lastName) {
				return function (email) {
					return function (zip) {
						return function (phoneNumber) {
							return function (followUpInfo) {
								return function (leadSourceOther) {
									return function (signupPage) {
										return function (leadSource) {
											return function (broker) {
												return {vJ: broker, Mf: createdAt, Oo: email, Pu: firstName, PA: followUpInfo, SA: lastName, SH: leadSource, SJ: leadSourceOther, Wh: phoneNumber, Hc: signupPage, ag7: status, tC: zip};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Provider$LeadSource$Min$LeadSource = $elm$core$Basics$identity;
var $author$project$Api$Provider$LeadSource$Min$Record = function (name) {
	return {zh: name};
};
var $author$project$Api$Provider$LeadSource$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Provider$LeadSource$Min$Record));
var $author$project$Api$Provider$LeadSource$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$LeadSource$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$SignupAttempt$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'broker',
	$elm$json$Json$Decode$nullable($author$project$Api$Provider$Broker$Min$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lead_source',
		$elm$json$Json$Decode$nullable($author$project$Api$Provider$LeadSource$Min$decoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'signup_page',
			$elm$json$Json$Decode$nullable($author$project$Api$Provider$SignupPage$Min$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'lead_source_other',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'follow_up_info',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'phone_number',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'zip',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'email',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'last_name',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'first_name',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'status',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'created_at',
												$elm_community$json_extra$Json$Decode$Extra$datetime,
												$elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$SignupAttempt$Record)))))))))))));
var $author$project$Api$Provider$Reports$SignupAttempt$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Reports$SignupAttempt$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Reports$SignupAttempt$reportDefaults = {E9: $elm$core$Maybe$Nothing, SH: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, Hc: $elm$core$Maybe$Nothing, ag1: $author$project$Api$Sort$init, Hl: $elm$core$Maybe$Nothing, ag7: $elm$core$Maybe$Nothing};
var $author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Reports$SignupAttempt$reportDefaults);
	return A2(
		$elm$core$List$append,
		$author$project$Api$Pagination$toApiParams(options.afy),
		A2(
			$elm$core$List$append,
			$author$project$Api$Sort$toParams(options.ag1),
			$elm$core$List$concat(
				_List_fromArray(
					[
						function () {
						var _v0 = options.Hl;
						if (!_v0.$) {
							var start_ = _v0.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'start', start_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v1 = options.E9;
						if (!_v1.$) {
							var end_ = _v1.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$date, 'end', end_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v2 = options.Hc;
						if (!_v2.$) {
							var signupPage_ = _v2.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'signup_page', signupPage_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v3 = options.SH;
						if (!_v3.$) {
							var leadSource_ = _v3.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'lead_source', leadSource_)
								]);
						} else {
							return _List_Nil;
						}
					}(),
						function () {
						var _v4 = options.ag7;
						if (!_v4.$) {
							var status_ = _v4.a;
							return _List_fromArray(
								[
									A2($author$project$Api$Param$string, 'status', status_)
								]);
						} else {
							return _List_Nil;
						}
					}()
					]))));
};
var $author$project$Api$Provider$Reports$SignupAttempt$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports', 'signup_attempts']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Reports$SignupAttempt$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Reports$SignupAttempt$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$SignupAttempt$listPath)));
	});
var $author$project$Components$Reports$SignupAttempts$fetchSignupAttempts = F2(
	function (apiClient, model) {
		return A3(
			$author$project$Api$Provider$Reports$SignupAttempt$list,
			apiClient,
			$author$project$Components$Reports$SignupAttempts$fetchParams(model),
			$author$project$Components$Reports$SignupAttempts$GotSignupAttempts);
	});
var $author$project$Components$Reports$SignupAttempts$initColumns = _List_fromArray(
	[
		A3($author$project$Api$Column$init, 'created_at', true, 'Started on'),
		A3($author$project$Api$Column$init, 'signup_page', true, 'Signup Page'),
		A3($author$project$Api$Column$init, 'lead_source', true, 'Lead Source'),
		A3($author$project$Api$Column$init, 'first_name', true, 'First Name'),
		A3($author$project$Api$Column$init, 'last_name', true, 'Last Name'),
		A3($author$project$Api$Column$init, 'email', true, 'Email'),
		A3($author$project$Api$Column$init, 'zip', true, 'Zip'),
		A3($author$project$Api$Column$init, 'phone_number', true, 'Phone Number'),
		A3($author$project$Api$Column$init, 'status', false, 'Status')
	]);
var $author$project$Components$Reports$SignupAttempts$init = F2(
	function (_v0, query) {
		var currentDate = _v0.cO;
		var timeFormatter = _v0.Hy;
		var apiClient = _v0.D5;
		var leadSourceId = A2($elm$core$Dict$get, 'lead_source', query);
		var _v1 = A3(
			$author$project$Components$ResourceFilter$LeadSource$init,
			apiClient,
			$elm$core$Basics$identity,
			function (d) {
				return _Utils_update(
					d,
					{D0: 'All Lead Sources', UL: 'Unassigned', aeZ: true, afT: leadSourceId});
			});
		var leadSourceResourceFilter = _v1.a;
		var leadSourceResourceFilterCmd = _v1.b;
		var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
		var start = _v2.a;
		var end = _v2.b;
		var _v3 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range-input',
			A2(
				$author$project$Components$Reports$SignupAttempts$dateRangeInputSettings,
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					start),
				A2(
					$elm$core$Maybe$map,
					A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0),
					end)));
		var dateRangeInput = _v3.a;
		var dateRangeInputCmd = _v3.b;
		var model = {
			Ll: $author$project$Components$Reports$SignupAttempts$initColumns,
			EE: $elm$core$Maybe$Nothing,
			cO: currentDate,
			h3: dateRangeInput,
			E9: end,
			l9: $author$project$Components$ExportCsv$init(
				{adw: false, G0: 1}),
			SI: leadSourceId,
			mQ: leadSourceResourceFilter,
			afy: $author$project$Api$Pagination$initFromQuery(query),
			eH: $elm$core$Set$empty,
			aQ: $author$project$Api$Data$Loading,
			os: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'signup-page-dropdown', ahx: $author$project$Components$Reports$SignupAttempts$SignupPageDropdownMsg})),
			ot: A2($elm$core$Dict$get, 'signup_page', query),
			sT: $author$project$Api$Data$Loading,
			ag1: A3(
				$author$project$Api$Sort$withDefault,
				'created_at',
				1,
				$author$project$Api$Sort$initFromQuery(query)),
			Hl: start,
			ag7: A2($elm$core$Dict$get, 'status', query),
			oA: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'status-dropdown', ahx: $author$project$Components$Reports$SignupAttempts$StatusDropdownMsg})),
			Hy: timeFormatter
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd),
						A3(
						$author$project$Api$Provider$SignupPage$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{afy: $elm$core$Maybe$Nothing});
						},
						$author$project$Components$Reports$SignupAttempts$GotSignupPages),
						A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg, dateRangeInputCmd),
						A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, model),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])));
	});
var $author$project$Pages$Reports$SignupAttempts$init = F4(
	function (_v0, _v1, shared, _v2) {
		var query = _v2.Bi;
		var _v3 = A2($author$project$Components$Reports$SignupAttempts$init, shared, query);
		var report = _v3.a;
		var reportCmd = _v3.b;
		return _Utils_Tuple2(
			{D5: shared.D5, jO: report},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
	});
var $author$project$Pages$Reports$SignupAttempts$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Reports$SignupAttempts$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Components$Reports$SignupAttempts$ExportCsvMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$Reports$SignupAttempts$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SignupAttempts$DateRangeInputMsg,
				$author$project$Components$DateRangeInput$subscriptions(model.h3)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SignupAttempts$ExportCsvMsg,
				$author$project$Components$ExportCsv$subscriptions(model.l9)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg,
				$author$project$Components$ResourceFilter$LeadSource$subscriptions(model.mQ)),
				$author$project$Ui$NewDropdown$subscriptions(model.os),
				$author$project$Ui$NewDropdown$subscriptions(model.oA)
			]));
};
var $author$project$Pages$Reports$SignupAttempts$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$Reports$SignupAttempts$subscriptions(model.jO));
};
var $author$project$Components$Reports$SignupAttempts$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, model.mQ);
				var leadSourceId = function () {
					var _v2 = leadSourceResourceResult.ac5;
					if (!_v2.$) {
						if (!_v2.a.$) {
							return $author$project$Components$ResourceFilter$LeadSource$value(leadSourceResourceResult.y8);
						} else {
							var _v3 = _v2.a;
							return model.SI;
						}
					} else {
						return model.SI;
					}
				}();
				var newModel = _Utils_update(
					model,
					{SI: leadSourceId, mQ: leadSourceResourceResult.y8});
				var _v1 = _Utils_eq(model.SI, newModel.SI) ? _Utils_Tuple2(model.aQ, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					$author$project$Api$Data$Loading,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])));
				var signupAttempts = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{aQ: signupAttempts}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg, leadSourceResourceResult.EC),
								cmd
							])),
					leadSourceResourceResult.as);
			case 1:
				var dataSignupPages = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sT: dataSignupPages}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(dataSignupPages));
			case 2:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$NewDropdown$update, subMsg, model.os);
				var signupPageDropdown = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{os: signupPageDropdown}),
					cmd,
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oA);
				var statusDropdown = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oA: statusDropdown}),
					cmd,
					_List_Nil);
			case 3:
				var signupPageId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						aQ: $author$project$Api$Data$Loading,
						ot: signupPageId
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 5:
				var status = msg.a;
				var newModel = _Utils_update(
					model,
					{
						afy: $author$project$Api$Pagination$reset(model.afy),
						aQ: $author$project$Api$Data$Loading,
						ag7: status
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 6:
				var subMsg = msg.a;
				var _v6 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
				var dateRangeInput = _v6.a;
				var subCmd = _v6.b;
				var event = _v6.c;
				var newModel = function () {
					if (event.$ === 1) {
						var fromDate = event.a;
						var toDate = event.b;
						return _Utils_update(
							model,
							{
								h3: dateRangeInput,
								E9: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
								afy: $author$project$Api$Pagination$reset(model.afy),
								aQ: $author$project$Api$Data$Loading,
								Hl: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
							});
					} else {
						return _Utils_update(
							model,
							{h3: dateRangeInput});
					}
				}();
				var cmds = (_Utils_eq(newModel.Hl, model.Hl) && _Utils_eq(newModel.E9, model.E9)) ? _List_Nil : _List_fromArray(
					[
						A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
						A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
					]);
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$cons,
							A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg, subCmd),
							cmds)),
					_List_Nil);
			case 7:
				var dataSignupAttempts = msg.a;
				if (dataSignupAttempts.$ === 3) {
					var headers = dataSignupAttempts.b;
					var completedCount = A2(
						$elm$core$Maybe$andThen,
						$elm$core$String$toInt,
						A2($elm$core$Dict$get, 'x-completed-count', headers));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								EE: completedCount,
								afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy),
								eH: $elm$core$Set$empty,
								aQ: dataSignupAttempts
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eH: $elm$core$Set$empty, aQ: dataSignupAttempts}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataSignupAttempts));
				}
			case 8:
				var index = msg.a;
				var showMoreInfoFor = A2($elm$core$Set$member, index, model.eH) ? A2($elm$core$Set$remove, index, model.eH) : A2($elm$core$Set$insert, index, model.eH);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eH: showMoreInfoFor}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination, aQ: $author$project$Api$Data$Loading});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			case 10:
				var columnId = msg.a;
				var newModel = _Utils_update(
					model,
					{
						ag1: A2($author$project$Api$Sort$update, columnId, model.ag1)
					});
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
								A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
							])),
					_List_Nil);
			default:
				var subMsg = msg.a;
				var _v9 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.l9);
				var exportCsv = _v9.a;
				var subCmd = _v9.b;
				var subOutMsg = _v9.c;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{l9: exportCsv}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$ExportCsvMsg, subCmd),
					subOutMsg);
		}
	});
var $author$project$Pages$Reports$SignupAttempts$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A3($author$project$Components$Reports$SignupAttempts$update, model.D5, subMsg, model.jO);
		var report = _v1.a;
		var subCmd = _v1.b;
		var subOutMsg = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{jO: report}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
			subOutMsg);
	});
var $author$project$Components$Reports$SignupAttempts$PaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Reports$SignupAttempts$countFromHeader = F2(
	function (headers, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'N/A',
			A2($elm$core$Dict$get, name, headers));
	});
var $author$project$Components$ResourceFilter$LeadSource$viewMultiSelected = function (model) {
	return A2(
		$elm$core$List$map,
		$elm$html$Html$map($elm$core$Basics$identity),
		A2($author$project$Components$ResourceFilter$viewMultiSelected, model.G0, model.bb));
};
var $author$project$Components$Reports$SignupAttempts$SignupPageSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Reports$SignupAttempts$signupPageDropdownItems = function (signupPages) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				_List_fromArray(
				[
					A2(
					$author$project$Ui$NewDropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$onSelect(
							$author$project$Components$Reports$SignupAttempts$SignupPageSelected($elm$core$Maybe$Nothing))
						]),
					$elm$html$Html$text('All Signup Pages')),
					$author$project$Ui$NewDropdown$separator
				]),
				A2(
				$elm$core$List$map,
				function (signupPage) {
					return A2(
						$author$project$Ui$NewDropdown$item,
						_List_fromArray(
							[
								$author$project$Ui$NewDropdown$onSelect(
								$author$project$Components$Reports$SignupAttempts$SignupPageSelected(
									$elm$core$Maybe$Just(
										$author$project$Api$Provider$SignupPage$All$id(signupPage))))
							]),
						$elm$html$Html$text(
							$author$project$Api$Provider$SignupPage$All$slug(signupPage)));
				},
				signupPages)
			]));
};
var $author$project$Components$Reports$SignupAttempts$viewSignupPageDropdown = function (model) {
	var placeholder = function () {
		var _v2 = model.ot;
		if (!_v2.$) {
			var id = _v2.a;
			return A2(
				$elm$core$Maybe$withDefault,
				'Signup Page',
				A2(
					$elm$core$Maybe$map,
					$author$project$Api$Provider$SignupPage$All$slug,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$filter(
								function (sp) {
									return _Utils_eq(
										$author$project$Api$Provider$SignupPage$All$id(sp),
										id);
								}),
							$elm$core$List$head),
						$author$project$Api$Data$toMaybe(model.sT))));
		} else {
			return 'Signup Page';
		}
	}();
	var _v0 = function () {
		var _v1 = model.sT;
		if (_v1.$ === 3) {
			var signupPages = _v1.a;
			return _Utils_Tuple2(
				false,
				$author$project$Components$Reports$SignupAttempts$signupPageDropdownItems(signupPages));
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var items = _v0.b;
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$disabled(loading)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		items,
		model.os);
};
var $author$project$Components$Reports$SignupAttempts$StatusSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Reports$SignupAttempts$statusDropdownItems = _List_fromArray(
	[
		A2(
		$author$project$Ui$NewDropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected($elm$core$Maybe$Nothing))
			]),
		$elm$html$Html$text('All Statuses')),
		$author$project$Ui$NewDropdown$separator,
		A2(
		$author$project$Ui$NewDropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected(
					$elm$core$Maybe$Just('abandoned')))
			]),
		$elm$html$Html$text('Abandoned')),
		A2(
		$author$project$Ui$NewDropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected(
					$elm$core$Maybe$Just('completed')))
			]),
		$elm$html$Html$text('Completed')),
		A2(
		$author$project$Ui$NewDropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected(
					$elm$core$Maybe$Just('pending')))
			]),
		$elm$html$Html$text('Pending')),
		A2(
		$author$project$Ui$NewDropdown$item,
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$onSelect(
				$author$project$Components$Reports$SignupAttempts$StatusSelected(
					$elm$core$Maybe$Just('ineligible')))
			]),
		$elm$html$Html$text('Ineligible'))
	]);
var $author$project$Components$Reports$SignupAttempts$statusToDisplayName = function (status) {
	switch (status) {
		case 'abandoned':
			return 'Abandoned';
		case 'completed':
			return 'Completed';
		case 'pending':
			return 'Pending';
		case 'ineligible':
			return 'Ineligible';
		default:
			return status;
	}
};
var $author$project$Components$Reports$SignupAttempts$viewStatusDropdown = function (model) {
	var placeholder = function () {
		var _v0 = model.ag7;
		if (!_v0.$) {
			var status = _v0.a;
			return $author$project$Components$Reports$SignupAttempts$statusToDisplayName(status);
		} else {
			return 'Status';
		}
	}();
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(placeholder)
			]),
		$author$project$Components$Reports$SignupAttempts$statusDropdownItems,
		model.oA);
};
var $author$project$Components$Reports$SignupAttempts$SortTable = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Reports$SignupAttempts$ShowMoreInfo = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Provider$Reports$SignupAttempt$broker = function (_v0) {
	var record = _v0;
	return record.vJ;
};
var $author$project$Api$Provider$Reports$SignupAttempt$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Reports$SignupAttempt$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Provider$Reports$SignupAttempt$firstName = function (_v0) {
	var record = _v0;
	return record.Pu;
};
var $author$project$Api$Provider$Reports$SignupAttempt$followUpInfo = function (_v0) {
	var record = _v0;
	return record.PA;
};
var $author$project$Api$Provider$Reports$SignupAttempt$lastName = function (_v0) {
	var record = _v0;
	return record.SA;
};
var $author$project$Api$Provider$Reports$SignupAttempt$leadSource = function (_v0) {
	var record = _v0;
	return record.SH;
};
var $author$project$Api$Provider$LeadSource$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Components$Reports$SignupAttempts$leadSourceIsOther = function (maybeLeadSource) {
	if (!maybeLeadSource.$) {
		var leadSource = maybeLeadSource.a;
		return $author$project$Api$Provider$LeadSource$Min$name(leadSource) === 'Other';
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Reports$SignupAttempt$leadSourceOther = function (_v0) {
	var record = _v0;
	return record.SJ;
};
var $author$project$Components$Reports$SignupAttempts$moreInfoAvailable = function (signupAttempt) {
	var _v0 = _Utils_Tuple2(
		$author$project$Api$Provider$Reports$SignupAttempt$broker(signupAttempt),
		$author$project$Api$Provider$Reports$SignupAttempt$followUpInfo(signupAttempt));
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			return true;
		} else {
			var _v1 = _v0.b;
			return true;
		}
	} else {
		if (!_v0.b.$) {
			var _v2 = _v0.a;
			return true;
		} else {
			return false;
		}
	}
};
var $author$project$Api$Provider$Reports$SignupAttempt$phoneNumber = function (_v0) {
	var record = _v0;
	return record.Wh;
};
var $author$project$Api$Provider$Reports$SignupAttempt$signupPage = function (_v0) {
	var record = _v0;
	return record.Hc;
};
var $author$project$Api$Provider$SignupPage$Min$slug = function (_v0) {
	var record = _v0;
	return record._c;
};
var $author$project$Api$Provider$Reports$SignupAttempt$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Reports$SignupAttempt$zip = function (_v0) {
	var record = _v0;
	return record.tC;
};
var $author$project$Components$Reports$SignupAttempts$viewRow = F4(
	function (timeFormatter, showMoreInfoFor, index, signupAttempt) {
		return A2(
			$author$project$Ui$Table$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								timeFormatter,
								0,
								$author$project$Api$Provider$Reports$SignupAttempt$createdAt(signupAttempt)))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Provider$SignupPage$Min$slug,
									$author$project$Api$Provider$Reports$SignupAttempt$signupPage(signupAttempt))))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										A2(
											$elm$core$Maybe$map,
											$author$project$Api$Provider$LeadSource$Min$name,
											$author$project$Api$Provider$Reports$SignupAttempt$leadSource(signupAttempt)))),
									$author$project$Utils$Html$noBreakSpace
								]),
								$author$project$Components$Reports$SignupAttempts$leadSourceIsOther(
								$author$project$Api$Provider$Reports$SignupAttempt$leadSource(signupAttempt)) ? _List_fromArray(
								[
									A3(
									$author$project$Ui$Tooltip$view,
									_List_Nil,
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Reports$SignupAttempt$leadSourceOther(signupAttempt)),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[$author$project$Ui$Typography$small]),
											_List_fromArray(
												[
													A2($author$project$Ui$Icon$view, _List_Nil, 5)
												]))
										]))
								]) : _List_Nil
							]))),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Reports$SignupAttempt$firstName(signupAttempt)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Reports$SignupAttempt$lastName(signupAttempt)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Reports$SignupAttempt$email(signupAttempt)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'',
										$author$project$Api$Provider$Reports$SignupAttempt$zip(signupAttempt)))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Formatters$Phone$format(
										A2(
											$elm$core$Maybe$withDefault,
											'',
											$author$project$Api$Provider$Reports$SignupAttempt$phoneNumber(signupAttempt))))
								]))
						])),
					A2(
					$author$project$Ui$Table$cell,
					_List_Nil,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									A2(
									$author$project$Ui$Badge$fromString,
									_List_Nil,
									$author$project$Api$Provider$Reports$SignupAttempt$status(signupAttempt))
								]),
								$author$project$Components$Reports$SignupAttempts$moreInfoAvailable(signupAttempt) ? _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($elm$html$Html$Attributes$style, 'display', 'grid')
										]),
									$elm$core$List$concat(
										_List_fromArray(
											[
												_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('small clickable'),
															A2($elm$html$Html$Attributes$style, 'margin', '4px 0 3px 0;]'),
															$elm$html$Html$Events$onClick(
															$author$project$Components$Reports$SignupAttempts$ShowMoreInfo(index))
														]),
													A2($elm$core$Set$member, index, showMoreInfoFor) ? _List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Less info'),
																	$author$project$Utils$Html$noBreakSpace,
																	A2($author$project$Ui$Icon$view, _List_Nil, 28)
																]))
														]) : _List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('More info'),
																	$author$project$Utils$Html$noBreakSpace,
																	A2($author$project$Ui$Icon$view, _List_Nil, 44)
																]))
														]))
												]),
												A2($elm$core$Set$member, index, showMoreInfoFor) ? $elm$core$List$concat(
												_List_fromArray(
													[
														function () {
														var _v0 = $author$project$Api$Provider$Reports$SignupAttempt$broker(signupAttempt);
														if (!_v0.$) {
															var broker = _v0.a;
															return _List_fromArray(
																[
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('inline small text-muted')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$span,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('bold')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Broker: ')
																				])),
																			A2(
																			$elm$html$Html$span,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Api$Provider$Broker$Min$name(broker))
																				]))
																		]))
																]);
														} else {
															return _List_Nil;
														}
													}(),
														function () {
														var _v1 = $author$project$Api$Provider$Reports$SignupAttempt$followUpInfo(signupAttempt);
														if (!_v1.$) {
															var followUpInfo = _v1.a;
															return _List_fromArray(
																[
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('inline small text-muted')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$span,
																			_List_fromArray(
																				[
																					$elm$html$Html$Attributes$class('bold')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Followup: ')
																				])),
																			A2(
																			$elm$html$Html$span,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(followUpInfo)
																				]))
																		]))
																]);
														} else {
															return _List_Nil;
														}
													}()
													])) : _List_Nil
											])))
								]) : _List_Nil
							]))),
					A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
				]));
	});
var $author$project$Components$Reports$SignupAttempts$viewTable = function (model) {
	var _v0 = function () {
		var _v1 = model.aQ;
		if (_v1.$ === 3) {
			var signupAttempts_ = _v1.a;
			return _Utils_Tuple2(false, signupAttempts_);
		} else {
			return _Utils_Tuple2(true, _List_Nil);
		}
	}();
	var loading = _v0.a;
	var signupAttempts = _v0.b;
	return A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$zeroState(
				_List_fromArray(
					[
						$elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
					])),
				$author$project$Ui$Table$loading(loading)
			]),
		$elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$elm$core$List$map,
					$author$project$Api$Column$view(
						A2($author$project$Api$Column$Sortable, model.ag1, $author$project$Components$Reports$SignupAttempts$SortTable)),
					model.Ll),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('pull-right')
									]),
								_List_fromArray(
									[
										A2($elm$html$Html$map, $author$project$Components$Reports$SignupAttempts$ExportCsvMsg, $author$project$Components$ExportCsv$button)
									]))
							]))
					])
				])),
		A2(
			$elm$core$List$indexedMap,
			A2($author$project$Components$Reports$SignupAttempts$viewRow, model.Hy, model.eH),
			signupAttempts),
		_List_Nil);
};
var $author$project$Components$Reports$SignupAttempts$view = F2(
	function (apiClient, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$Reports$SignupAttempts$ExportCsvMsg,
				A3(
					$author$project$Components$ExportCsv$modal,
					apiClient,
					_List_fromArray(
						[
							$author$project$Components$ExportCsv$report(
							$author$project$Api$Data$totalCount(model.aQ)),
							$author$project$Components$ExportCsv$reportParams(
							A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams, $author$project$Components$Reports$SignupAttempts$fetchParams)(model))
						]),
					model.l9)),
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Signup Attempts')
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								function () {
									var _v0 = model.aQ;
									if (_v0.$ === 3) {
										var headers = _v0.b;
										return _List_fromArray(
											[
												$elm$html$Html$text(
												'Total completed: ' + A2($author$project$Components$Reports$SignupAttempts$countFromHeader, headers, 'x-completed-count')),
												$author$project$Utils$Html$noBreakSpace,
												A2(
												$elm$html$Html$small,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('text-muted')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														'out of ' + (A2($author$project$Components$Reports$SignupAttempts$countFromHeader, headers, 'x-total-count') + ' total'))
													]))
											]);
									} else {
										return _List_fromArray(
											[
												$author$project$Ui$Spinner$view(_List_Nil)
											]);
									}
								}()),
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$SignupAttempts$DateRangeInputMsg,
								$author$project$Components$DateRangeInput$view(model.h3)),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$SignupAttempts$viewSignupPageDropdown(model)
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg,
												A2(
													$author$project$Components$ResourceFilter$LeadSource$viewNew,
													_List_fromArray(
														[
															$author$project$Components$ResourceFilter$style(1),
															$author$project$Components$ResourceFilter$multi
														]),
													model.mQ))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$span(6),
												$author$project$Ui$FlexGrid$spanMd(4)
											]),
										_List_fromArray(
											[
												$author$project$Components$Reports$SignupAttempts$viewStatusDropdown(model)
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_fromArray(
									[$author$project$Ui$FlexGrid$gutterSm]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_Nil,
										function () {
											var activeFilters = A2(
												$elm$core$List$map,
												$elm$html$Html$map($author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg),
												$author$project$Components$ResourceFilter$LeadSource$viewMultiSelected(model.mQ));
											return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray(
												[
													A2(
													$author$project$Ui$Element$view,
													_List_fromArray(
														[$author$project$Ui$Element$mt2, $author$project$Ui$Element$mb2]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Active filters')
																]))
														])),
													A2($elm$html$Html$span, _List_Nil, activeFilters)
												]);
										}())
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Components$Reports$SignupAttempts$viewTable(model)
							])),
						A2(
						$author$project$Ui$Panel$footer,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Components$Reports$SignupAttempts$PaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Utils$Maybe$toBool(
												$author$project$Api$Data$toMaybe(model.aQ)))
										]),
									model.afy))
							]))
					]))
			]);
	});
var $author$project$Pages$Reports$SignupAttempts$view = function (model) {
	return {
		e5: A2(
			$elm$core$List$map,
			$elm$html$Html$map($elm$core$Basics$identity),
			A2($author$project$Components$Reports$SignupAttempts$view, model.D5, model.jO)),
		$G: 'Reports | Signup Attempts'
	};
};
var $author$project$Pages$Reports$SignupAttempts$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$Reports$SignupAttempts$init, aer: $author$project$Pages$Reports$SignupAttempts$load, agD: $author$project$Pages$Reports$SignupAttempts$save, ahd: $author$project$Pages$Reports$SignupAttempts$subscriptions, aaq: $author$project$Pages$Reports$SignupAttempts$update, ahP: $author$project$Pages$Reports$SignupAttempts$view});
var $author$project$Ui$Spinner$Attr = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Spinner$attrs = $author$project$Ui$Spinner$Attr;
var $author$project$Pages$StyleGuide$ActivityIndicators$viewBody = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('extraSmall'),
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[$author$project$Ui$Spinner$extraSmall]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('small'),
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[
								$author$project$Ui$Spinner$small,
								$author$project$Ui$Spinner$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('some-class')
									]))
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('medium'),
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[
								$author$project$Ui$Spinner$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-8')
									]))
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('large'),
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[
								$author$project$Ui$Spinner$large,
								$author$project$Ui$Spinner$attrs(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('mr-8')
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$ActivityIndicators$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$ActivityIndicators$viewBody, $G: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$ActivityIndicators$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ActivityIndicators$view);
var $author$project$Pages$StyleGuide$AddressInput$AddressInputMsg = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$AddressInput$init = function (_v0) {
	var _v1 = $author$project$Components$AddressInput$init('address-input');
	var addressInput = _v1.a;
	var addressInputCmd = _v1.b;
	return _Utils_Tuple2(
		{kU: addressInput},
		A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, addressInputCmd));
};
var $author$project$Pages$StyleGuide$AddressInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$AddressInput$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($author$project$Components$AddressInput$update, subMsg, model.kU);
		var addressInput = _v1.a;
		var addressInputCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{kU: addressInput}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, addressInputCmd));
	});
var $author$project$Generated$StyleGuide$Examples$addressInputExample = '\n    [ AddressInput.view\n        []\n        model.addressInput\n        |> Html.map AddressInputMsg\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$addressInputExampleDisabled = '\n    [ AddressInput.view\n        [ AddressInput.disabled True ]\n        model.addressInput\n        |> Html.map AddressInputMsg\n    ]\n    ';
var $author$project$Pages$StyleGuide$AddressInput$example = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2($author$project$Components$AddressInput$view, _List_Nil, model.kU))
		]);
};
var $author$project$Components$AddressInput$Disabled = $elm$core$Basics$identity;
var $author$project$Components$AddressInput$disabled = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$AddressInput$exampleDisabled = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2(
				$author$project$Components$AddressInput$view,
				_List_fromArray(
					[
						$author$project$Components$AddressInput$disabled(true)
					]),
				model.kU))
		]);
};
var $author$project$Components$StyleGuide$Example$Title = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$StyleGuide$Example$title = $author$project$Components$StyleGuide$Example$Title;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$HCode = $elm$core$Basics$identity;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style1 = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style2 = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style3 = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style4 = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style5 = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style6 = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(3, 'elm-s');
		case 1:
			return _Utils_Tuple2(4, 'elm-bs');
		case 2:
			return _Utils_Tuple2(5, 'elm-gs');
		case 3:
			return _Utils_Tuple2(7, 'elm-c');
		case 4:
			return _Utils_Tuple2(4, 'elm-k');
		case 5:
			return _Utils_Tuple2(6, 'elm-f');
		case 6:
			return _Utils_Tuple2(5, 'elm-ts');
		default:
			return _Utils_Tuple2(2, 'elm-n');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine = function (fragments) {
	return {adA: fragments, mp: $elm$core$Maybe$Nothing};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak = {$: 2};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Comment = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Default = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment = F2(
	function (toStyle, _v0) {
		var syntax = _v0.a;
		var text = _v0.b;
		switch (syntax.$) {
			case 0:
				return {aa9: '', agl: 0, $A: text};
			case 1:
				return {aa9: '', agl: 1, $A: text};
			case 2:
				return {aa9: '', agl: 0, $A: text};
			default:
				var c = syntax.a;
				var _v2 = toStyle(c);
				var requiredStyle = _v2.a;
				var additionalClass = _v2.b;
				return {aa9: additionalClass, agl: requiredStyle, $A: text};
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp = F3(
	function (toStyle, _v0, _v1) {
		var syntax = _v0.a;
		var text = _v0.b;
		var lines = _v1.a;
		var fragments = _v1.b;
		var maybeLastSyntax = _v1.c;
		if (_Utils_eq(syntax, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak)) {
			return _Utils_Tuple3(
				A2(
					$elm$core$List$cons,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(fragments),
					lines),
				_List_fromArray(
					[
						A2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment,
						toStyle,
						_Utils_Tuple2(syntax, text))
					]),
				$elm$core$Maybe$Nothing);
		} else {
			if (_Utils_eq(
				$elm$core$Maybe$Just(syntax),
				maybeLastSyntax)) {
				if (fragments.b) {
					var headFrag = fragments.a;
					var tailFrags = fragments.b;
					return _Utils_Tuple3(
						lines,
						A2(
							$elm$core$List$cons,
							_Utils_update(
								headFrag,
								{
									$A: _Utils_ap(text, headFrag.$A)
								}),
							tailFrags),
						maybeLastSyntax);
				} else {
					return _Utils_Tuple3(
						lines,
						A2(
							$elm$core$List$cons,
							A2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment,
								toStyle,
								_Utils_Tuple2(syntax, text)),
							fragments),
						maybeLastSyntax);
				}
			} else {
				return _Utils_Tuple3(
					lines,
					A2(
						$elm$core$List$cons,
						A2(
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment,
							toStyle,
							_Utils_Tuple2(syntax, text)),
						fragments),
					$elm$core$Maybe$Just(syntax));
			}
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines = F2(
	function (toStyle, revTokens) {
		return function (_v0) {
			var lines = _v0.a;
			var frags = _v0.b;
			return A2(
				$elm$core$List$cons,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(frags),
				lines);
		}(
			A3(
				$elm$core$List$foldl,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp(toStyle),
				_Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing),
				revTokens));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment = {$: 1};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak = function (c) {
	return c === '\n';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile = F2(
	function (isNotRelevant, previousParser) {
		return A2(
			$elm$parser$Parser$ignorer,
			previousParser,
			$elm$parser$Parser$chompWhile(isNotRelevant));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('--'))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen = F3(
	function (f, list, plist) {
		return A2(
			$elm$parser$Parser$andThen,
			function (n) {
				return f(
					_Utils_ap(n, list));
			},
			plist);
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen = F3(
	function (f, list, pn) {
		return A2(
			$elm$parser$Parser$andThen,
			function (n) {
				return f(
					A2($elm$core$List$cons, n, list));
			},
			pn);
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable = F2(
	function (options, revAList) {
		var defaultMap = options.Nb;
		var isNotRelevant = options.RW;
		var end = options.E9;
		var innerParsers = options.Q$;
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							defaultMap(end),
							revAList)),
					$elm$parser$Parser$symbol(end)),
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(revAList),
					$elm$parser$Parser$end),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					$elm$parser$Parser$oneOf(innerParsers)),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$always(true))))))
				]));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable = F3(
	function (nestLevel, options, revAList) {
		var defaultMap = options.Nb;
		var isNotRelevant = options.RW;
		var start = options.Hl;
		var end = options.E9;
		var innerParsers = options.Q$;
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return (nestLevel === 1) ? $elm$parser$Parser$succeed(n) : A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel - 1, options, n);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								defaultMap(end),
								revAList)),
						$elm$parser$Parser$symbol(end))),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen,
					A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel + 1, options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$symbol(start))))),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					$elm$parser$Parser$oneOf(innerParsers)),
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(revAList),
					$elm$parser$Parser$end),
					A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen,
					A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel, options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$always(true))))))
				]));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp = F2(
	function (options, revAList) {
		var start = options.Hl;
		var end = options.E9;
		var isNotRelevant = options.RW;
		var _v0 = _Utils_Tuple2(
			$elm$core$String$uncons(options.Hl),
			$elm$core$String$uncons(options.E9));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the start token cannot be an empty string!');
		} else {
			if (_v0.b.$ === 1) {
				var _v2 = _v0.b;
				return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the end token cannot be an empty string!');
			} else {
				var _v3 = _v0.a.a;
				var startChar = _v3.a;
				var _v4 = _v0.b.a;
				var endChar = _v4.a;
				return options.RU ? A3(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable,
					1,
					_Utils_update(
						options,
						{
							RW: function (c) {
								return isNotRelevant(c) && ((!_Utils_eq(c, startChar)) && (!_Utils_eq(c, endChar)));
							}
						}),
					revAList) : A2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable,
					_Utils_update(
						options,
						{
							RW: function (c) {
								return isNotRelevant(c) && (!_Utils_eq(c, endChar));
							}
						}),
					revAList);
			}
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited = function (options) {
	var start = options.Hl;
	var isNotRelevant = options.RW;
	var defaultMap = options.Nb;
	return A2(
		$elm$parser$Parser$andThen,
		function (n) {
			return A2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp,
				options,
				_List_fromArray(
					[n]));
		},
		A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				defaultMap(start)),
			$elm$parser$Parser$symbol(start)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\n')
			]);
	},
	$elm$parser$Parser$symbol('\n'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	{
		Nb: function (b) {
			return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
		},
		E9: '-}',
		Q$: _List_fromArray(
			[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList]),
		RU: true,
		RW: function (c) {
			return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		Hl: '{-'
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$inlineComment, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$multilineComment]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$BasicSymbol = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C = function (a) {
	return {$: 3, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Capitalized = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$GroupSymbol = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Keyword = 4;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal = {$: 0};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Number = 7;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile = function (isNotRelevant) {
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf(isNotRelevant)),
		$elm$parser$Parser$chompWhile(isNotRelevant));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbols = $elm$core$Set$fromList(
	_List_fromArray(
		['|', '.', '=', '\\', '/', '(', ')', '-', '>', '<', ':', '+', '!', '$', '%', '&', '*']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol = function (c) {
	return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbols);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbol = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbols = $elm$core$Set$fromList(
	_List_fromArray(
		[',', '[', ']', '{', '}']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol = function (c) {
	return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbols);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isStringLiteralChar = function (c) {
	return (c === '\"') || (c === '\'');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace = function (c) {
	return (c === ' ') || (c === '\t');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isStringLiteralChar(c))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$capitalized = $elm$parser$Parser$getChompedString(
	A2(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar,
		$elm$parser$Parser$chompIf($elm$core$Char$isUpper)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbol = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Function = 5;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '/', '*', '=', '.', '$', '<', '>', ':', '&', '|', '^', '?', '%', '#', '@', '~', '!', ',']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isInfixChar = function (c) {
	return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
			b);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$backtrackable(
						$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$backtrackable(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isInfixChar))),
			$elm$parser$Parser$backtrackable(
				$elm$parser$Parser$symbol(')')))));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['as', 'where', 'let', 'in', 'if', 'else', 'then', 'case', 'of', 'type', 'alias']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword = function (str) {
	return A2($elm$core$Set$member, str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$keywordSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber = function (c) {
	return $elm$core$Char$isDigit(c) || (c === '.');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber)),
	$elm$parser$Parser$chompWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('-'))),
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable = $elm$parser$Parser$getChompedString(
	A2(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar,
		$elm$parser$Parser$chompIf($elm$core$Char$isLower)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$weirdText = $elm$parser$Parser$getChompedString(
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7),
					b);
			},
			$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number)),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
					'()')),
			$elm$parser$Parser$symbol('()')),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser,
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbol),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbol),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
					b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$capitalized),
			A2(
			$elm$parser$Parser$map,
			function (n) {
				return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword(n) ? _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n) : _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, n);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$weirdText)
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$String = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet = $elm$core$Set$fromList(
	_List_fromArray(
		['\'', '\"', '\\', 'n', 'r', 't', 'b', 'f', 'v']));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar = function (c) {
	return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet);
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('\\'))),
	$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$elmEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable = function (c) {
	return c === '\\';
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter = {
	Nb: function (b) {
		return _Utils_Tuple2(
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	E9: '\"',
	Q$: _List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$elmEscapable]),
	RU: false,
	RW: function (c) {
		return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	Hl: '\"'
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter,
		{E9: '\'', Hl: '\''}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$tripleDoubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter,
		{E9: '\"\"\"', Hl: '\"\"\"'}));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$tripleDoubleQuote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$doubleQuote, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$quote]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\n');
	},
	$elm$parser$Parser$symbol('\n'));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContext = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContext,
				A2(
					$elm$parser$Parser$map,
					function (n) {
						return A2($elm$core$List$cons, n, revTokens);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$TypeSignature = 6;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === '(') || ((c === ')') || ((c === '-') || (c === ',')))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContentHelp = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
					'()')),
			$elm$parser$Parser$symbol('()')),
			A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
					'->')),
			$elm$parser$Parser$symbol('->')),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
					function (c) {
						return (c === '(') || ((c === ')') || ((c === '-') || (c === ',')));
					}))),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
					b);
			},
			$elm$parser$Parser$getChompedString(
				A2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant,
					$elm$parser$Parser$chompIf($elm$core$Char$isUpper)))),
			A2(
			$elm$parser$Parser$map,
			function (b) {
				return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
			},
			$elm$parser$Parser$getChompedString(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant)))
		]));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContent = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContentHelp),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$andThen,
					function (ns) {
						return A2($elm$parser$Parser$loop, ns, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContent);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1),
									':'),
								revTokens)),
						$elm$parser$Parser$symbol(':')))),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2($elm$parser$Parser$loop, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar = function (c) {
	return (c === '-') || (c === '{');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar = $elm$parser$Parser$getChompedString(
	$elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar));
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.f, s.n3, s.K6, s.sX);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.sX))) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{K6: newCol, aB: s.aB, ad_: s.ad_, f: newOffset, n3: newRow, sX: s.sX});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || (c === '(')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant = function (c) {
	return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || ((c === '(') || ((c === ')') || ((c === ',') || (c === '.'))))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpnIsSpecialChar = function (c) {
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || ((c === '(') || (c === ')')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContextNested = function (_v1) {
	var nestLevel = _v1.a;
	var revTokens = _v1.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested(
				_Utils_Tuple2(nestLevel, revTokens)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested = function (_v0) {
	var nestLevel = _v0.a;
	var revTokens = _v0.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens)));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$andThen,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContextNested,
				A2(
					$elm$parser$Parser$map,
					function (n) {
						return _Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens));
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak)),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							_Utils_ap(n, revTokens)));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParNest = function (_v0) {
	var nestLevel = _v0.a;
	var revTokens = _v0.b;
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested(
				_Utils_Tuple2(nestLevel, revTokens)),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(nestLevel + 1, ns));
				},
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
							revTokens)),
					$elm$parser$Parser$symbol('('))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return (!nestLevel) ? $elm$parser$Parser$Done(ns) : $elm$parser$Parser$Loop(
						_Utils_Tuple2(nestLevel - 1, ns));
				},
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, ')'),
							revTokens)),
					$elm$parser$Parser$symbol(')'))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_Tuple2(
							nestLevel,
							A2($elm$core$List$cons, n, revTokens)));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							function (s) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpnIsSpecialChar))))
						]))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParentheses = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, ')'),
							revTokens)),
					$elm$parser$Parser$symbol(')'))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser,
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
									function (c) {
										return (c === ',') || (c === '.');
									}))),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6),
									b);
							},
							$elm$parser$Parser$getChompedString(
								A2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile,
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant,
									$elm$parser$Parser$chompIf($elm$core$Char$isUpper)))),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
									b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant)))
						]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return A2(
							$elm$parser$Parser$loop,
							_Utils_Tuple2(0, n),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParNest);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens)),
						$elm$parser$Parser$symbol('(')))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return A2($elm$parser$Parser$loop, n, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParentheses);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens)),
						$elm$parser$Parser$symbol('(')))),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
							A2(
							$elm$parser$Parser$map,
							$elm$core$Basics$always(
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
									'exposing')),
							$elm$parser$Parser$keyword('exposing')),
							A2(
							$elm$parser$Parser$map,
							$elm$core$Basics$always(
								_Utils_Tuple2(
									$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
									'as')),
							$elm$parser$Parser$keyword('as')),
							A2(
							$elm$parser$Parser$map,
							function (b) {
								return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
							},
							$elm$parser$Parser$getChompedString(
								$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecIsNotRelevant)))
						]))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp = F2(
	function (revTokens, str) {
		return (str === 'module') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					str),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration) : A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
					str),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature);
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclaration = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp(revTokens),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Done,
				A2($elm$parser$Parser$loop, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable = F2(
	function (revTokens, n) {
		return ((n === 'module') || (n === 'import')) ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration) : ((n === 'port') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclaration) : ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword(n) ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4),
					n),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody) : A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5),
					n),
				revTokens),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature)));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak),
				A2(
				$elm$parser$Parser$map,
				function (n) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(n, revTokens));
				},
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable(revTokens),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (s) {
						return A2(
							$elm$parser$Parser$loop,
							_Utils_ap(s, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral)),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (s) {
						return A2(
							$elm$parser$Parser$loop,
							A2($elm$core$List$cons, s, revTokens),
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody);
					},
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent)),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toRevTokens = A2($elm$parser$Parser$loop, _List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mainLoop);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toRevTokens),
	$elm$core$Result$map(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle)));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$elm = A2(
	$elm$core$Basics$composeR,
	$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme = $elm$core$Basics$identity;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule = function (a) {
	return {$: 1, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$ClassExtends = 8;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css = function (a) {
	return {$: 3, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$DeclarationKeyword = 3;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Elm = function (a) {
	return {$: 0, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex = function (a) {
	return {$: 1, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Identifier = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript = function (a) {
	return {$: 2, a: a};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Property = {$: 3};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$bold = function (style) {
	return _Utils_update(
		style,
		{mC: true});
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic = function (style) {
	return _Utils_update(
		style,
		{mF: true});
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor = {$: 0};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor = function (background) {
	return {pC: background, mC: false, mF: false, q7: false, $A: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis = F2(
	function (text, background) {
		return {pC: background, mC: false, mF: false, q7: false, $A: text};
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor = function (text) {
	return {pC: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor, mC: false, mF: false, q7: false, $A: text};
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$requiredStyles = {
	pm: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#003800')),
	Lm: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#75715e')),
	M5: A2(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis,
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f8f8f2'),
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#23241f')),
	qg: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#380000')),
	mp: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#343434')),
	s$: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#ae81ff')),
	s0: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#e6db74')),
	s1: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f92672')),
	s2: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#66d9ef')),
	s3: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#a6e22e')),
	s4: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#ae81ff')),
	s5: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
		$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#fd971f'))
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$theme = {
	acl: _List_fromArray(
		[
			_Utils_Tuple2(
			_List_fromArray(
				[
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Elm(6),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript(3),
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Property)
				]),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#66d9ef')))),
			_Utils_Tuple2(
			_List_fromArray(
				[
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript(8)
				]),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#a6e22e')))),
			_Utils_Tuple2(
			_List_fromArray(
				[
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0))
				]),
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$bold(
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor(
					$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f92672'))))
		]),
	agm: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$requiredStyles
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment = function (a) {
	switch (a) {
		case 0:
			return _Utils_Tuple2(4, 'css-ar-i');
		case 1:
			return _Utils_Tuple2(6, 'css-ar-p');
		case 2:
			return _Utils_Tuple2(4, 'css-ar-k');
		default:
			return _Utils_Tuple2(5, 'css-ar-v');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style7 = 8;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment = function (att) {
	switch (att) {
		case 0:
			return _Utils_Tuple2(6, 'css-s-a-an');
		case 1:
			return _Utils_Tuple2(3, 'css-s-a-av');
		default:
			return _Utils_Tuple2(4, 'css-s-a-o');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment = function (s) {
	switch (s.$) {
		case 0:
			return _Utils_Tuple2(4, 'css-s-e');
		case 1:
			return _Utils_Tuple2(6, 'css-s-i');
		case 2:
			return _Utils_Tuple2(6, 'css-s-cl');
		case 3:
			return _Utils_Tuple2(8, 'css-s-c');
		case 4:
			return _Utils_Tuple2(4, 'css-s-u');
		case 5:
			var att = s.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment(att);
		case 6:
			return _Utils_Tuple2(0, 'css-s-pe');
		default:
			return _Utils_Tuple2(0, 'css-s-pc');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle = function (syntax) {
	switch (syntax.$) {
		case 0:
			return _Utils_Tuple2(3, 'css-s');
		case 1:
			var a = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment(a);
		case 2:
			var s = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment(s);
		case 3:
			return _Utils_Tuple2(5, 'css-p');
		case 4:
			return _Utils_Tuple2(5, 'css-pv');
		case 5:
			return _Utils_Tuple2(2, 'css-n');
		default:
			return _Utils_Tuple2(4, 'css-u');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'js-n');
		case 1:
			return _Utils_Tuple2(3, 'js-s');
		case 2:
			return _Utils_Tuple2(4, 'js-k');
		case 3:
			return _Utils_Tuple2(5, 'js-dk');
		case 4:
			return _Utils_Tuple2(5, 'js-fe');
		case 5:
			return _Utils_Tuple2(6, 'js-f');
		case 6:
			return _Utils_Tuple2(7, 'js-lk');
		case 7:
			return _Utils_Tuple2(8, 'js-p');
		default:
			return _Utils_Tuple2(6, 'js-ce');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle = function (syntax) {
	return _Utils_Tuple2(0, 'nolang');
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'py-n');
		case 1:
			return _Utils_Tuple2(3, 'py-s');
		case 2:
			return _Utils_Tuple2(4, 'py-k');
		case 3:
			return _Utils_Tuple2(5, 'py-dk');
		case 5:
			return _Utils_Tuple2(6, 'py-f');
		case 6:
			return _Utils_Tuple2(7, 'py-lk');
		case 7:
			return _Utils_Tuple2(8, 'py-p');
		default:
			return _Utils_Tuple2(0, 'py-fe');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'sql-n');
		case 1:
			return _Utils_Tuple2(3, 'sql-s');
		case 2:
			return _Utils_Tuple2(4, 'sql-k');
		case 3:
			return _Utils_Tuple2(5, 'sql-o');
		case 4:
			return _Utils_Tuple2(6, 'sql-f');
		case 5:
			return _Utils_Tuple2(7, 'sql-p');
		default:
			return _Utils_Tuple2(8, 'sql-l');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(4, 'xml-t');
		case 1:
			return _Utils_Tuple2(6, 'xml-a');
		default:
			return _Utils_Tuple2(3, 'xlm-av');
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxToSelector = function (syntax) {
	switch (syntax.$) {
		case 0:
			var elmSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle(elmSyntax).b;
		case 1:
			var xmlSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle(xmlSyntax).b;
		case 2:
			var jsSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle(jsSyntax).b;
		case 3:
			var cssSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle(cssSyntax).b;
		case 4:
			var pythonSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle(pythonSyntax).b;
		case 5:
			var sqlSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle(sqlSyntax).b;
		default:
			var noLangSyntax = syntax.a;
			return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle(noLangSyntax).b;
	}
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxesToSelectors = function (syntaxes) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			', ',
			A2(
				$elm$core$List$map,
				$elm$core$Basics$append('.elmsh-'),
				A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxToSelector, syntaxes))));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss = F2(
	function (property, color) {
		switch (color.$) {
			case 0:
				return '';
			case 1:
				var hex = color.a;
				return property + (hex + ';');
			case 2:
				var r = color.a;
				var g = color.b;
				var b = color.c;
				return $elm$core$String$concat(
					_List_fromArray(
						[
							property,
							'rgb(',
							$elm$core$String$fromInt(r),
							', ',
							$elm$core$String$fromInt(g),
							',',
							$elm$core$String$fromInt(b),
							');'
						]));
			default:
				var r = color.a;
				var g = color.b;
				var b = color.c;
				var a = color.d;
				return $elm$core$String$concat(
					_List_fromArray(
						[
							property,
							'rgba(',
							$elm$core$String$fromInt(r),
							', ',
							$elm$core$String$fromInt(g),
							',',
							$elm$core$String$fromInt(b),
							', ',
							$elm$core$String$fromFloat(a),
							');'
						]));
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse = F2(
	function (bool, str) {
		return bool ? str : '';
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$styleToCss = function (_v0) {
	var isBold = _v0.mC;
	var isItalic = _v0.mF;
	var isUnderline = _v0.q7;
	var text = _v0.$A;
	var background = _v0.pC;
	return $elm$core$String$concat(
		_List_fromArray(
			[
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isBold, 'font-weight: bold;'),
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isItalic, 'font-style: italic;'),
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isUnderline, 'text-decoration: underline;'),
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss, 'color: ', text),
				A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss, 'background: ', background)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCssClass = function (_v0) {
	var selectors = _v0.a;
	var style = _v0.b;
	return $elm$core$String$isEmpty(selectors) ? '' : (selectors + (' {' + ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$styleToCss(style) + '}')));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCss = function (classes) {
	return $elm$core$String$concat(
		A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCssClass, classes));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$toCss = function (_v0) {
	var requiredStyles = _v0.agm;
	var customStyles = _v0.acl;
	return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCss(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2('.elmsh', requiredStyles.M5),
					_Utils_Tuple2('.elmsh-hl', requiredStyles.mp),
					_Utils_Tuple2('.elmsh-add', requiredStyles.pm),
					_Utils_Tuple2('.elmsh-del', requiredStyles.qg),
					_Utils_Tuple2('.elmsh-comm', requiredStyles.Lm),
					_Utils_Tuple2('.elmsh1', requiredStyles.s$),
					_Utils_Tuple2('.elmsh2', requiredStyles.s0),
					_Utils_Tuple2('.elmsh3', requiredStyles.s1),
					_Utils_Tuple2('.elmsh4', requiredStyles.s2),
					_Utils_Tuple2('.elmsh5', requiredStyles.s3),
					_Utils_Tuple2('.elmsh6', requiredStyles.s4),
					_Utils_Tuple2('.elmsh7', requiredStyles.s5)
				]),
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapFirst($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxesToSelectors),
				customStyles)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$css = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$toCss($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$theme);
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$monokai = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$css;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$monokai = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$monokai;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Add = 1;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Del = 2;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Normal = 0;
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString = function (required) {
	return 'elmsh' + function () {
		switch (required) {
			case 0:
				return '0';
			case 1:
				return '-comm';
			case 2:
				return '1';
			case 3:
				return '2';
			case 4:
				return '3';
			case 5:
				return '4';
			case 6:
				return '5';
			case 7:
				return '6';
			default:
				return '7';
		}
	}();
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView = function (_v0) {
	var text = _v0.$A;
	var requiredStyle = _v0.agl;
	var additionalClass = _v0.aa9;
	return ((!requiredStyle) && $elm$core$String$isEmpty(additionalClass)) ? $elm$html$Html$text(text) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString(requiredStyle),
						!(!requiredStyle)),
						_Utils_Tuple2('elmsh-' + additionalClass, additionalClass !== '')
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView = F3(
	function (start, index, _v0) {
		var fragments = _v0.adA;
		var highlight = _v0.mp;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('elmsh-line', true),
							_Utils_Tuple2(
							'elmsh-hl',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(0))),
							_Utils_Tuple2(
							'elmsh-add',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(1))),
							_Utils_Tuple2(
							'elmsh-del',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(2)))
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-elmsh-lc',
					$elm$core$String$fromInt(start + index))
				]),
			A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments));
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml = function (lines) {
	return A2(
		$elm$html$Html$code,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('elmsh')
			]),
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var highlight = _v0.mp;
					var fragments = _v0.adA;
					return _Utils_eq(highlight, $elm$core$Maybe$Nothing) ? A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments) : _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'elmsh-hl',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(0))),
											_Utils_Tuple2(
											'elmsh-add',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(1))),
											_Utils_Tuple2(
											'elmsh-del',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(2)))
										]))
								]),
							A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments))
						]);
				},
				lines)));
};
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml = F2(
	function (maybeStart, lines) {
		if (maybeStart.$ === 1) {
			return A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elmsh')
					]),
				_List_fromArray(
					[
						$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml(lines)
					]));
		} else {
			var start = maybeStart.a;
			return A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elmsh')
					]),
				$elm$core$List$singleton(
					A2(
						$elm$html$Html$code,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView(start),
							lines))));
		}
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml = F2(
	function (maybeStart, _v0) {
		var lines = _v0;
		return A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml, maybeStart, lines);
	});
var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$useTheme = function (_v0) {
	var theme = _v0;
	return A3(
		$elm$html$Html$node,
		'style',
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(theme)
			]));
};
var $author$project$Components$StyleGuide$Example$highlight = function (code) {
	return _List_fromArray(
		[
			$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$useTheme($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$monokai),
			A2(
			$elm$core$Result$withDefault,
			A2(
				$elm$html$Html$pre,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$code,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(code)
							]))
					])),
			A2(
				$elm$core$Result$map,
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml(
					$elm$core$Maybe$Just(1)),
				$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$elm(code)))
		]);
};
var $author$project$Components$StyleGuide$Example$Base = 0;
var $author$project$Components$StyleGuide$Example$optionsToOptionsRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, acc) {
				switch (option.$) {
					case 2:
						var string = option.a;
						return _Utils_update(
							acc,
							{$G: string});
					case 0:
						var content = option.a;
						return _Utils_update(
							acc,
							{Nx: content});
					default:
						var surface = option.a;
						return _Utils_update(
							acc,
							{Dj: surface});
				}
			}),
		{Nx: _List_Nil, Dj: 0, $G: ''},
		options);
};
var $author$project$Components$StyleGuide$Example$view = F2(
	function (options, _v0) {
		var content = _v0.EG;
		var code = _v0.K3;
		var optionsRecord = $author$project$Components$StyleGuide$Example$optionsToOptionsRecord(options);
		var surfaceClass = function () {
			var _v1 = optionsRecord.Dj;
			if (_v1 === 1) {
				return 'surface-subtle';
			} else {
				return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(
					$author$project$Formatters$String$slugify(optionsRecord.$G)),
					$elm$html$Html$Attributes$class('style-guide-example'),
					$elm$html$Html$Attributes$class(surfaceClass)
				]),
			_List_fromArray(
				[
					$elm$core$String$isEmpty(optionsRecord.$G) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$strong,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(
									'#' + $author$project$Formatters$String$slugify(optionsRecord.$G))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(optionsRecord.$G)
								]))
						])),
					$elm$core$List$isEmpty(optionsRecord.Nx) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('style-guide-example__description')
						]),
					optionsRecord.Nx),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('style-guide-example__separator')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('style-guide-example__content')
						]),
					content),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('style-guide-example__code')
						]),
					$author$project$Components$StyleGuide$Example$highlight(code))
				]));
	});
var $author$project$Pages$StyleGuide$AddressInput$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Address Input')
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$addressInputExample,
								EG: $author$project$Pages$StyleGuide$AddressInput$example(model)
							})
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Invalid address input')
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$addressInputExampleDisabled,
								EG: $author$project$Pages$StyleGuide$AddressInput$exampleDisabled(model)
							})
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$AddressInput$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$AddressInput$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$AddressInput$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$AddressInput$init, ahd: $author$project$Pages$StyleGuide$AddressInput$subscriptions, aaq: $author$project$Pages$StyleGuide$AddressInput$update, ahP: $author$project$Pages$StyleGuide$AddressInput$view});
var $author$project$Pages$StyleGuide$Alert$init = function (_v0) {
	return _Utils_Tuple2(
		{kZ: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Alert$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Alert$update = F2(
	function (msg, model) {
		if (msg === 1) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{kZ: false}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{kZ: true}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Generated$StyleGuide$Examples$alertExample = '\n    [ Alert.view Alert.Success [] [ text "This is a Success alert" ]\n    , Alert.view Alert.Danger [] [ text "This is a Danger alert" ]\n    , Alert.view Alert.Warning [] [ text "This is a Warning alert" ]\n    , Alert.view Alert.Info [] [ text "This is a Info alert" ]\n    , Alert.view Alert.Primary [] [ text "This is a Primary alert" ]\n    , Alert.view Alert.Primary [ Alert.icon SvgIcon.Location ] [ text "This is a Primary alert with an Icon" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$alertExampleDismissible = '\n    List.singleton <|\n        if alertDismissed then\n            Button.view { ariaLabel = "Show dismissible alert" } [ Button.onClick AlertShown ] [ text "show dismissible alert " ]\n\n        else\n            Alert.view Alert.Success [ Alert.dismissible AlertDismissed ] [ text "This is a dismissible alert" ]    ';
var $author$project$Ui$Alert$Primary = 4;
var $author$project$Pages$StyleGuide$Alert$example = _List_fromArray(
	[
		A3(
		$author$project$Ui$Alert$view,
		0,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Success alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		3,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Danger alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		2,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Warning alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		1,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Info alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		4,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Primary alert')
			])),
		A3(
		$author$project$Ui$Alert$view,
		4,
		_List_fromArray(
			[
				$author$project$Ui$Alert$icon(14)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('This is a Primary alert with an Icon')
			]))
	]);
var $author$project$Pages$StyleGuide$Alert$AlertDismissed = 0;
var $author$project$Pages$StyleGuide$Alert$AlertShown = 1;
var $author$project$Ui$Alert$Dismissible = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Alert$dismissible = $author$project$Ui$Alert$Dismissible;
var $author$project$Pages$StyleGuide$Alert$exampleDismissible = function (_v0) {
	var alertDismissed = _v0.kZ;
	return $elm$core$List$singleton(
		alertDismissed ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Show dismissible alert'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('show dismissible alert ')
				])) : A3(
			$author$project$Ui$Alert$view,
			0,
			_List_fromArray(
				[
					$author$project$Ui$Alert$dismissible(0)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('This is a dismissible alert')
				])));
};
var $author$project$Pages$StyleGuide$Alert$exampleDismissibleWithIcon = function (_v0) {
	var alertDismissed = _v0.kZ;
	return $elm$core$List$singleton(
		alertDismissed ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Show dismissible alert'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('show dismissible alert ')
				])) : A3(
			$author$project$Ui$Alert$view,
			0,
			_List_fromArray(
				[
					$author$project$Ui$Alert$dismissible(0),
					$author$project$Ui$Alert$icon(59)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('This is a dismissible alert with an icon')
				])));
};
var $author$project$Pages$StyleGuide$Alert$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Alert')
								]),
							{K3: $author$project$Generated$StyleGuide$Examples$alertExample, EG: $author$project$Pages$StyleGuide$Alert$example})
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Dismissible Alert')
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$alertExampleDismissible,
								EG: $author$project$Pages$StyleGuide$Alert$exampleDismissible(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Dismissible Alert with an Icon')
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$alertExampleDismissible,
								EG: $author$project$Pages$StyleGuide$Alert$exampleDismissibleWithIcon(model)
							})
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Alert$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$Alert$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Alert$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Alert$init, ahd: $author$project$Pages$StyleGuide$Alert$subscriptions, aaq: $author$project$Pages$StyleGuide$Alert$update, ahP: $author$project$Pages$StyleGuide$Alert$view});
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Ui$Typography$headingLg = function (content) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$elm$html$Html$h2,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('text-heading-lg text-main')
				]),
			content));
};
var $author$project$Pages$StyleGuide$Badge$marketplaceStatuses = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8]);
var $author$project$Pages$StyleGuide$Badge$supportedLables = _List_fromArray(
	['needs_payment_info', 'pending', 'downloading', 'bank_not_verified', 'successful', 'live', 'failed', 'refunded', 'retrying', 'cancelled', 'default', 'saving', 'refund_pending', 'refund_successful', 'refund_failed', 'active', 'unconfirmed', 'confirmed', 'warning', 'new_payment_source', 'needs_trial_deposits', 'invalid', 'inactive', 'expiring', 'connected', 'requested', 'unpaid', 'paid', 'clearing', 'processing', 'redeemable', 'not_redeemable', 'viewed', 'bad_debt', 'disputed', 'overdue', 'sent', 'issued', 'no_payment', 'missing', 'accepted', 'accepted_and_outdated', 'not_accepted', 'none', 'scheduled', 'scheduled_without_source', 'in transit', 'completed', 'enabled', 'synced', 'unsynced', 'errored', 'opened', 'error', 'processed', 'review_data_matches', 'review_file_size', 'enqueued_for_preprocessing', 'enqueued_for_processing', 'preprocessing', 'ready_to_preprocess', 'ready_to_process', 'payable', 'deal_ending', 'failed_payment']);
var $author$project$Pages$StyleGuide$Badge$viewLabel = function (label) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				A2($author$project$Ui$Badge$fromString, _List_Nil, label)
			]));
};
var $author$project$Pages$StyleGuide$Badge$listingStatusOptions = function (status) {
	switch (status) {
		case 0:
			return _List_Nil;
		case 1:
			return _List_fromArray(
				[$author$project$Ui$Badge$neutral]);
		case 2:
			return _List_Nil;
		case 3:
			return _List_fromArray(
				[$author$project$Ui$Badge$accentPrimary]);
		case 4:
			return _List_fromArray(
				[$author$project$Ui$Badge$accentSecondary]);
		case 5:
			return _List_fromArray(
				[$author$project$Ui$Badge$success]);
		case 6:
			return _List_fromArray(
				[$author$project$Ui$Badge$warning]);
		case 7:
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
		default:
			return _List_fromArray(
				[$author$project$Ui$Badge$danger]);
	}
};
var $author$project$Pages$StyleGuide$Badge$viewListingStatus = function (status) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Badge$view,
				$author$project$Pages$StyleGuide$Badge$listingStatusOptions(status),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Common$Marketplace$Product$Status$toLabel(status))
					]))
			]));
};
var $author$project$Pages$StyleGuide$Badge$viewBody = _List_fromArray(
	[
		$author$project$Ui$Typography$headingLg(
		_List_fromArray(
			[
				$elm$html$Html$text('Badge')
			])),
		A2(
		$author$project$Ui$FlexGrid$row,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Supported labels')
							]),
						{
							K3: 'Badge.fromString [] "active\"',
							EG: A2($elm$core$List$map, $author$project$Pages$StyleGuide$Badge$viewLabel, $author$project$Pages$StyleGuide$Badge$supportedLables)
						}),
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Non supported label')
							]),
						{
							K3: 'Badge.fromString [] "other->unsupported\"',
							EG: _List_fromArray(
								[
									A2($author$project$Ui$Badge$fromString, _List_Nil, 'other->unsupported')
								])
						})
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Marketplace — Product Listing Status')
							]),
						{
							K3: 'Badge.view (listingStatusOptions product.listingStatus)\n    [ text (Status.toLabel product.listingStatus) ]',
							EG: A2($elm$core$List$map, $author$project$Pages$StyleGuide$Badge$viewListingStatus, $author$project$Pages$StyleGuide$Badge$marketplaceStatuses)
						})
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Badge$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$Badge$viewBody, $G: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$Badge$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Badge$view);
var $author$project$Pages$StyleGuide$Button$init = function (_v0) {
	return _Utils_Tuple2(
		{},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Button$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Button$update = F2(
	function (_v0, _v1) {
		return _Utils_Tuple2(
			{},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Generated$StyleGuide$Examples$buttonExampleFullWidthGroup = '\n    [ Button.group\n        [ Button.view\n            { ariaLabel = "Active" }\n            [ Button.active True, Button.fullWidth True ]\n            [ text "Active" ]\n        , Button.view\n            { ariaLabel = "Inactive" }\n            [ Button.fullWidth True ]\n            [ text "Inactive" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleGroup = '\n    [ Button.group\n        [ Button.view\n            { ariaLabel = "Active" }\n            [ Button.active True ]\n            [ text "Active" ]\n        , Button.view\n            { ariaLabel = "Inactive" }\n            []\n            [ text "Inactive" ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleIcon = '\n    [ Button.view { ariaLabel = "Send message" } [ Button.sm, Button.icon SvgIcon.send ] [ text "Send" ]\n    , Button.view { ariaLabel = "Send message" } [ Button.icon SvgIcon.send ] [ text "Send" ]\n    , Button.view { ariaLabel = "Send message" } [ Button.lg, Button.icon SvgIcon.send ] [ text "Send" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleIconOnly = '\n    [ Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.sm\n        , Button.icon SvgIcon.flag\n        ]\n        []\n    , Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.icon SvgIcon.flag\n        ]\n        []\n    , Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.lg\n        , Button.icon SvgIcon.flag\n        ]\n        []\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleLink = '\n    [ Button.view { ariaLabel = "Small link button" } [ Button.link, Button.sm ] [ text "Small link" ]\n    , Button.view { ariaLabel = "Link button" } [ Button.link ] [ text "Link" ]\n    , Button.view { ariaLabel = "Large link button" } [ Button.link, Button.lg ] [ text "Chonk link" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleOther = '\n    [ Button.view { ariaLabel = "Loading button" } [ Button.loading True ] [ text "Loading..." ]\n    , Button.view { ariaLabel = "Disabled button" } [ Button.disabled True ] [ text "disabled" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleSecondaryOverSubtle = '\n    [ Button.view { ariaLabel = "over subtle" } [ Button.secondary ] [ text "I\'m lighter!" ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleSize = '\n    [ Button.view { ariaLabel = "Small button" } [ Button.sm ] [ text "Small" ]\n    , Button.view { ariaLabel = "Medium button" } [] [ text "Medium" ]\n    , Button.view { ariaLabel = "Large button" } [ Button.lg ] [ text "Large" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$buttonExampleStyled = '\n    [ Button.view { ariaLabel = "Default button" } [] [ text "Default" ]\n    , Button.view { ariaLabel = "Primary button" } [ Button.primary ] [ text "Primary" ]\n    , Button.view { ariaLabel = "Secondary button" } [ Button.secondary ] [ text "Secondary" ]\n    , Button.view { ariaLabel = "Success button" } [ Button.success ] [ text "Success" ]\n    , Button.view { ariaLabel = "Warning button" } [ Button.warning ] [ text "Warning" ]\n    , Button.view { ariaLabel = "Danger button" } [ Button.danger ] [ text "Danger" ]\n    , Hr.view []\n    , Button.view { ariaLabel = "Link button" } [ Button.link ] [ text "Link" ]\n    , Button.view { ariaLabel = "Grey link button" } [ Button.styled Button.GreyLink ] [ text "Grey Link" ]\n    ]    ';
var $author$project$Components$StyleGuide$Example$Description = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$StyleGuide$Example$description = $author$project$Components$StyleGuide$Example$Description;
var $author$project$Pages$StyleGuide$Button$exampleFullWidthGroup = _List_fromArray(
	[
		$author$project$Ui$Button$group(
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Active'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(true),
						$author$project$Ui$Button$fullWidth(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Active')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Inactive'},
				_List_fromArray(
					[
						$author$project$Ui$Button$fullWidth(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Inactive')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleGroup = _List_fromArray(
	[
		$author$project$Ui$Button$group(
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Active'},
				_List_fromArray(
					[
						$author$project$Ui$Button$active(true)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Active')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Inactive'},
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Inactive')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleIcon = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Send message'},
		_List_fromArray(
			[
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Send')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Send message'},
		_List_fromArray(
			[
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Send')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Send message'},
		_List_fromArray(
			[
				$author$project$Ui$Button$lg,
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$send)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Send')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleIconOnly = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Flag Button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$secondary,
				$author$project$Ui$Button$sm,
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Flag Button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$secondary,
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Flag Button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$secondary,
				$author$project$Ui$Button$lg,
				$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_Nil)
	]);
var $author$project$Pages$StyleGuide$Button$exampleLink = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Small link button'},
		_List_fromArray(
			[$author$project$Ui$Button$link, $author$project$Ui$Button$sm]),
		_List_fromArray(
			[
				$elm$html$Html$text('Small link')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Link button'},
		_List_fromArray(
			[$author$project$Ui$Button$link]),
		_List_fromArray(
			[
				$elm$html$Html$text('Link')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Large link button'},
		_List_fromArray(
			[$author$project$Ui$Button$link, $author$project$Ui$Button$lg]),
		_List_fromArray(
			[
				$elm$html$Html$text('Chonk link')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleOther = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Loading button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$loading(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Loading...')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Disabled button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$disabled(true)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('disabled')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleSecondaryOverSubtle = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'over subtle'},
		_List_fromArray(
			[$author$project$Ui$Button$secondary]),
		_List_fromArray(
			[
				$elm$html$Html$text('I\'m lighter!')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleSize = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Small button'},
		_List_fromArray(
			[$author$project$Ui$Button$sm]),
		_List_fromArray(
			[
				$elm$html$Html$text('Small')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Medium button'},
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Medium')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Large button'},
		_List_fromArray(
			[$author$project$Ui$Button$lg]),
		_List_fromArray(
			[
				$elm$html$Html$text('Large')
			]))
	]);
var $author$project$Pages$StyleGuide$Button$exampleStyled = _List_fromArray(
	[
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Default button'},
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Default')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Primary button'},
		_List_fromArray(
			[$author$project$Ui$Button$primary]),
		_List_fromArray(
			[
				$elm$html$Html$text('Primary')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Secondary button'},
		_List_fromArray(
			[$author$project$Ui$Button$secondary]),
		_List_fromArray(
			[
				$elm$html$Html$text('Secondary')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Success button'},
		_List_fromArray(
			[$author$project$Ui$Button$success]),
		_List_fromArray(
			[
				$elm$html$Html$text('Success')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Warning button'},
		_List_fromArray(
			[$author$project$Ui$Button$warning]),
		_List_fromArray(
			[
				$elm$html$Html$text('Warning')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Danger button'},
		_List_fromArray(
			[$author$project$Ui$Button$danger]),
		_List_fromArray(
			[
				$elm$html$Html$text('Danger')
			])),
		$author$project$Ui$HorizontalRule$view(_List_Nil),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Link button'},
		_List_fromArray(
			[$author$project$Ui$Button$link]),
		_List_fromArray(
			[
				$elm$html$Html$text('Link')
			])),
		A3(
		$author$project$Ui$Button$view,
		{abp: 'Grey link button'},
		_List_fromArray(
			[
				$author$project$Ui$Button$styled(8)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Grey Link')
			]))
	]);
var $author$project$Components$StyleGuide$Example$Subtle = 1;
var $author$project$Components$StyleGuide$Example$Surface = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$StyleGuide$Example$subtleSurface = $author$project$Components$StyleGuide$Example$Surface(1);
var $author$project$Pages$StyleGuide$Button$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button Styles'),
										$author$project$Components$StyleGuide$Example$description(_List_Nil)
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleStyled, EG: $author$project$Pages$StyleGuide$Button$exampleStyled}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button Sizes')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleSize, EG: $author$project$Pages$StyleGuide$Button$exampleSize}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button Secondary over subtle surface'),
										$author$project$Components$StyleGuide$Example$subtleSurface
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleSecondaryOverSubtle, EG: $author$project$Pages$StyleGuide$Button$exampleSecondaryOverSubtle}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Link options'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('Buttons that look like links but don\'t have a href')
											]))
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleLink, EG: $author$project$Pages$StyleGuide$Button$exampleLink}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Other options')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleOther, EG: $author$project$Pages$StyleGuide$Button$exampleOther})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button Group')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleGroup, EG: $author$project$Pages$StyleGuide$Button$exampleGroup}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Full width button Group')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleFullWidthGroup, EG: $author$project$Pages$StyleGuide$Button$exampleFullWidthGroup}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('with Icon')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleIcon, EG: $author$project$Pages$StyleGuide$Button$exampleIcon}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('with Icon and no content'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('They require Button.ariaLabel option for accessibility')
											]))
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$buttonExampleIconOnly, EG: $author$project$Pages$StyleGuide$Button$exampleIconOnly})
							]))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Button$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Button$init, ahd: $author$project$Pages$StyleGuide$Button$subscriptions, aaq: $author$project$Pages$StyleGuide$Button$update, ahP: $author$project$Pages$StyleGuide$Button$view});
var $author$project$Pages$StyleGuide$Carousel$CarouselMsg = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$Carousel$init = function (_v0) {
	return _Utils_Tuple2(
		{
			pO: $author$project$Components$Carousel$init($elm$core$Basics$identity)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Carousel$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Carousel$update = F2(
	function (msg, model) {
		var subMsg = msg;
		return A2(
			$elm$core$Tuple$mapFirst,
			function (carousel) {
				return _Utils_update(
					model,
					{pO: carousel});
			},
			A2($author$project$Components$Carousel$update, subMsg, model.pO));
	});
var $author$project$Pages$StyleGuide$Carousel$images = _List_fromArray(
	[
		A3($author$project$Components$Carousel$image, '1', 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/full-logo.svg', 'Hint Logo'),
		A3($author$project$Components$Carousel$image, '2', 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/onboarding-complete.png', 'Hint Logo')
	]);
var $author$project$Pages$StyleGuide$Carousel$view = function (model) {
	return {
		e5: $elm$core$List$singleton(
			A3(
				$author$project$Components$Carousel$view,
				_List_fromArray(
					[$author$project$Components$Carousel$aspectVideo]),
				model.pO,
				$author$project$Pages$StyleGuide$Carousel$images)),
		$G: 'StyleGuide.Carousel'
	};
};
var $author$project$Pages$StyleGuide$Carousel$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Carousel$init, ahd: $author$project$Pages$StyleGuide$Carousel$subscriptions, aaq: $author$project$Pages$StyleGuide$Carousel$update, ahP: $author$project$Pages$StyleGuide$Carousel$view});
var $author$project$Pages$StyleGuide$Checkbox$init = function (_v0) {
	return {v1: false, v2: true, pQ: false, pR: false, pS: false};
};
var $author$project$Spa$Page$sandbox = function (page) {
	return {
		ad0: F2(
			function (_v0, url) {
				return _Utils_Tuple3(
					page.ad0(url),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}),
		aer: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v1) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: F2(
			function (msg, model) {
				return _Utils_Tuple3(
					A2(page.aaq, msg, model),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			}),
		ahP: page.ahP
	};
};
var $author$project$Pages$StyleGuide$Checkbox$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_update(
					model,
					{v1: value});
			case 1:
				var value = msg.a;
				return _Utils_update(
					model,
					{v2: value});
			case 2:
				var value = msg.a;
				return _Utils_update(
					model,
					{pQ: value});
			case 3:
				var value = msg.a;
				return _Utils_update(
					model,
					{pR: value});
			case 4:
				var value = msg.a;
				return _Utils_update(
					model,
					{pS: value});
			default:
				var value = msg.a;
				return _Utils_update(
					model,
					{pQ: value, pR: value, pS: value});
		}
	});
var $author$project$Pages$StyleGuide$Checkbox$Checkbox1Changed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$Checkbox2Changed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$Checkbox3Changed = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$Checkbox4Changed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$Checkbox5Changed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$ToggleAllCheckboxes = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$StyleGuide$Checkbox$viewBody = function (_v0) {
	var checkbox1 = _v0.v1;
	var checkbox2 = _v0.v2;
	var checkbox3 = _v0.pQ;
	var checkbox4 = _v0.pR;
	var checkbox5 = _v0.pS;
	var indeterminateChecked = checkbox3 && (checkbox4 && checkbox5);
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Form > Checkbox')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(checkbox1),
								$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox1Changed)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Checkbox')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(checkbox2),
								$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox2Changed)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Checkbox')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('With multiple lines')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(false),
								$author$project$Ui$Form$Checkbox$disabled(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Disabled Checkbox')
							])),
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(true),
								$author$project$Ui$Form$Checkbox$disabled(true)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Disabled Checkbox')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(indeterminateChecked),
								$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$ToggleAllCheckboxes)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Check All')
							])),
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(checkbox3),
								$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox3Changed)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('A')
							])),
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(checkbox4),
								$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox4Changed)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('B')
							])),
						A2(
						$author$project$Ui$Form$Checkbox$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Checkbox$value(checkbox5),
								$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox5Changed)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('C')
							]))
					]))
			]));
};
var $author$project$Pages$StyleGuide$Checkbox$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Pages$StyleGuide$Checkbox$viewBody(model)
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Checkbox$page = $author$project$Spa$Page$sandbox(
	{ad0: $author$project$Pages$StyleGuide$Checkbox$init, aaq: $author$project$Pages$StyleGuide$Checkbox$update, ahP: $author$project$Pages$StyleGuide$Checkbox$view});
var $author$project$Pages$StyleGuide$CurrencyInput$init = function (_v0) {
	return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$CurrencyInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$CurrencyInput$update = F2(
	function (msg, _v0) {
		var _int = msg;
		return _Utils_Tuple2(_int, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$CurrencyInput$CurrencyInputChanged = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$CurrencyInput$amountInCentsErrors = function (currency) {
	return $author$project$Utils$Maybe$toBool(currency) ? _List_Nil : _List_fromArray(
		['Please enter an amount.']);
};
var $author$project$Pages$StyleGuide$CurrencyInput$viewBody = function (amountInCents) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Form -> Currency Input')
				])),
			$author$project$Ui$Form$CurrencyInput$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$CurrencyInput$value(amountInCents),
					$author$project$Ui$Form$CurrencyInput$onInput($elm$core$Basics$identity),
					$author$project$Ui$Form$CurrencyInput$invalid(
					!$author$project$Utils$Maybe$toBool(amountInCents)),
					$author$project$Ui$Form$CurrencyInput$errors(
					$author$project$Pages$StyleGuide$CurrencyInput$amountInCentsErrors(amountInCents))
				])),
			$elm$html$Html$text(
			'Amount in cents: ' + A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				A2($elm$core$Maybe$map, $author$project$Currency$toString, amountInCents)))
		]);
};
var $author$project$Pages$StyleGuide$CurrencyInput$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$CurrencyInput$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$CurrencyInput$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$CurrencyInput$init, ahd: $author$project$Pages$StyleGuide$CurrencyInput$subscriptions, aaq: $author$project$Pages$StyleGuide$CurrencyInput$update, ahP: $author$project$Pages$StyleGuide$CurrencyInput$view});
var $author$project$Pages$StyleGuide$DateInput$DateInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$DateInput$init = function (_v0) {
	var _v1 = $author$project$Components$DateInput$init;
	var invalidDateInput = _v1.a;
	var invalidDateInputCmd = _v1.b;
	var _v2 = $author$project$Components$DateInput$init;
	var disabledDateInput = _v2.a;
	var disabledDateInputCmd = _v2.b;
	var _v3 = $author$project$Components$DateInput$init;
	var dateInput = _v3.a;
	var dateInputCmd = _v3.b;
	return _Utils_Tuple2(
		{MO: $elm$core$Maybe$Nothing, qd: dateInput, xd: disabledDateInput, x9: invalidDateInput},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DateInputMsg, dateInputCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg, invalidDateInputCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg, disabledDateInputCmd)
				])));
};
var $author$project$Pages$StyleGuide$DateInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$DateInput$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$DateInput$update, subMsg, model.qd);
				var disabledDateInput = _v1.a;
				var disabledDateInputCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{xd: disabledDateInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg, disabledDateInputCmd));
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$DateInput$update, subMsg, model.qd);
				var invalidDateInput = _v2.a;
				var invalidDateInputCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{x9: invalidDateInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg, invalidDateInputCmd));
			default:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$DateInput$update, subMsg, model.qd);
				var dateInput = _v3.a;
				var dateInputCmd = _v3.b;
				var dateInputEvent = _v3.c;
				var date = function () {
					if (dateInputEvent.$ === 1) {
						var date_ = dateInputEvent.a;
						return date_;
					} else {
						return model.MO;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{MO: date, qd: dateInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DateInputMsg, dateInputCmd));
		}
	});
var $author$project$Generated$StyleGuide$Examples$dateInputExample1 = '\n    [ DateInput.view\n        [ DateInput.value model.date\n        ]\n        model.dateInput\n        |> Html.map DateInputMsg\n    , text\n        ("Date: "\n            ++ (model.date\n                    |> Maybe.map Date.toIsoString\n                    |> Maybe.withDefault "N/A"\n               )\n        )\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dateInputExampleDisabled = '\n    [ DateInput.view\n        [ DateInput.placeholder "disabled"\n        , DateInput.disabled True\n        ]\n        model.disabledDateInput\n        |> Html.map DisabledDateInputMsg\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$dateInputExampleInvalid = '\n    [ DateInput.view\n        [ DateInput.placeholder "invalid"\n        , DateInput.invalid True\n        , DateInput.errors [ "Some error" ]\n        ]\n        model.invalidDateInput\n        |> Html.map InvalidDateInputMsg\n    ]    ';
var $author$project$Pages$StyleGuide$DateInput$example1 = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$DateInput$DateInputMsg,
			A2(
				$author$project$Components$DateInput$view,
				_List_fromArray(
					[
						$author$project$Components$DateInput$value(model.MO)
					]),
				model.qd)),
			$elm$html$Html$text(
			'Date: ' + A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, model.MO)))
		]);
};
var $author$project$Pages$StyleGuide$DateInput$exampleDisabled = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg,
			A2(
				$author$project$Components$DateInput$view,
				_List_fromArray(
					[
						$author$project$Components$DateInput$placeholder('disabled'),
						$author$project$Components$DateInput$disabled(true)
					]),
				model.xd))
		]);
};
var $author$project$Pages$StyleGuide$DateInput$exampleInvalid = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg,
			A2(
				$author$project$Components$DateInput$view,
				_List_fromArray(
					[
						$author$project$Components$DateInput$placeholder('invalid'),
						$author$project$Components$DateInput$invalid(true),
						$author$project$Components$DateInput$errors(
						_List_fromArray(
							['Some error']))
					]),
				model.x9))
		]);
};
var $author$project$Pages$StyleGuide$DateInput$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Date Input')
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$dateInputExample1,
								EG: $author$project$Pages$StyleGuide$DateInput$example1(model)
							})
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Disabled date input')
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$dateInputExampleDisabled,
								EG: $author$project$Pages$StyleGuide$DateInput$exampleDisabled(model)
							})
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Invalid date input')
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$dateInputExampleInvalid,
								EG: $author$project$Pages$StyleGuide$DateInput$exampleInvalid(model)
							})
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$DateInput$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$DateInput$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$DateInput$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$DateInput$init, ahd: $author$project$Pages$StyleGuide$DateInput$subscriptions, aaq: $author$project$Pages$StyleGuide$DateInput$update, ahP: $author$project$Pages$StyleGuide$DateInput$view});
var $author$project$Pages$StyleGuide$DateRangeInput$DateRangeInputMsg = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$DateRangeInput$dateRangeInputSettings = F2(
	function (start, end) {
		var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
		return _Utils_update(
			defaultSettings,
			{adD: start, ahu: end});
	});
var $author$project$Utils$Date$fromQuery = F2(
	function (key, query) {
		return A2(
			$elm$core$Maybe$andThen,
			$author$project$Utils$Date$fromIsoString,
			A2($elm$core$Dict$get, key, query));
	});
var $author$project$Pages$StyleGuide$DateRangeInput$init = F2(
	function (_v0, _v1) {
		var query = _v1.Bi;
		var rawUrl = _v1.af3;
		var start = A2($author$project$Utils$Date$fromQuery, 'start', query);
		var end = A2($author$project$Utils$Date$fromQuery, 'end', query);
		var _v2 = A2(
			$author$project$Components$DateRangeInput$init,
			'date-range',
			A2($author$project$Pages$StyleGuide$DateRangeInput$dateRangeInputSettings, start, end));
		var dateRangeInput = _v2.a;
		var dateRangeInputCmd = _v2.b;
		return _Utils_Tuple3(
			{h3: dateRangeInput, E9: end, VL: rawUrl.VL, Hl: start},
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dateRangeInputCmd),
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$DateRangeInput$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$DateRangeInput$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$DateRangeInput$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$elm$core$Basics$identity,
		$author$project$Components$DateRangeInput$subscriptions(model.h3));
};
var $author$project$Pages$StyleGuide$DateRangeInput$updateUrl = F3(
	function (model, start, end) {
		var queryParams = _List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('start'),
					$author$project$Utils$Date$toQuery),
				start),
				A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeL,
					$elm$url$Url$Builder$string('end'),
					$author$project$Utils$Date$toQuery),
				end)
			]);
		return $author$project$Ports$Navigation$pushUrl(
			A2(
				$elm$url$Url$Builder$relative,
				_List_fromArray(
					[model.VL]),
				A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
	});
var $author$project$Pages$StyleGuide$DateRangeInput$update = F2(
	function (msg, model) {
		var subMsg = msg;
		var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h3);
		var dateRangeInput = _v1.a;
		var subCmd = _v1.b;
		var event = _v1.c;
		var _v2 = function () {
			if (event.$ === 1) {
				var fromDate = event.a;
				var toDate = event.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{E9: toDate, Hl: fromDate}),
					_List_fromArray(
						[
							A3($author$project$Pages$StyleGuide$DateRangeInput$updateUrl, model, fromDate, toDate)
						]));
			} else {
				return _Utils_Tuple2(model, _List_Nil);
			}
		}();
		var newModel = _v2.a;
		var cmds = _v2.b;
		return _Utils_Tuple3(
			_Utils_update(
				newModel,
				{h3: dateRangeInput}),
			$elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$cons,
					A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd),
					cmds)),
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$DateRangeInput$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Date Range Input')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Default')
				])),
			A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			$author$project$Components$DateRangeInput$view(model.h3)),
			$elm$html$Html$text(
			'Start: ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, model.Hl))),
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			$elm$html$Html$text(
			'End: ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, model.E9)))
		]);
};
var $author$project$Pages$StyleGuide$DateRangeInput$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$DateRangeInput$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$DateRangeInput$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$StyleGuide$DateRangeInput$init, aer: $author$project$Pages$StyleGuide$DateRangeInput$load, agD: $author$project$Pages$StyleGuide$DateRangeInput$save, ahd: $author$project$Pages$StyleGuide$DateRangeInput$subscriptions, aaq: $author$project$Pages$StyleGuide$DateRangeInput$update, ahP: $author$project$Pages$StyleGuide$DateRangeInput$view});
var $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$DisabledDropdownMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$ErrorDropdownMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$InnerDropdownMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$LangDropdownMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$LangWithSearchDropdownMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$LinksDropdownMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$MultiLangDropdownMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$OuterDropdownMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$ReadonlyDropdownMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$SecondInnerDropdownMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$WithInputMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Ui$NewDropdown$toRight = function (config) {
	return _Utils_update(
		config,
		{xb: 1});
};
var $author$project$Pages$StyleGuide$Dropdown$init = function (_v0) {
	return _Utils_Tuple2(
		{
			bn: _List_Nil,
			lv: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'free-text-dropdown', ahx: $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownMsg})),
			lw: '',
			im: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'disabled-dropdown', ahx: $author$project$Pages$StyleGuide$Dropdown$DisabledDropdownMsg})),
			iD: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'error-dropdown', ahx: $author$project$Pages$StyleGuide$Dropdown$ErrorDropdownMsg})),
			iT: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$toRight(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'inner', ahx: $author$project$Pages$StyleGuide$Dropdown$InnerDropdownMsg}))),
			fT: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'lang-dropdown', ahx: $author$project$Pages$StyleGuide$Dropdown$LangDropdownMsg})),
			fU: '',
			i$: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'lang-dropdown-with-search', ahx: $author$project$Pages$StyleGuide$Dropdown$LangWithSearchDropdownMsg})),
			mT: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'links-dropdown', ahx: $author$project$Pages$StyleGuide$Dropdown$LinksDropdownMsg})),
			je: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'multi-lang-dropdown', ahx: $author$project$Pages$StyleGuide$Dropdown$MultiLangDropdownMsg})),
			jj: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'outer', ahx: $author$project$Pages$StyleGuide$Dropdown$OuterDropdownMsg})),
			gu: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'readonly-dropdown', ahx: $author$project$Pages$StyleGuide$Dropdown$ReadonlyDropdownMsg})),
			j_: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$toRight(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'second-inner', ahx: $author$project$Pages$StyleGuide$Dropdown$SecondInnerDropdownMsg}))),
			m: $elm$core$Maybe$Nothing,
			kx: $elm$core$Maybe$Nothing,
			aaN: $elm$core$Maybe$Nothing,
			pe: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'with-input', ahx: $author$project$Pages$StyleGuide$Dropdown$WithInputMsg}))
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Dropdown$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(model.fT),
				$author$project$Ui$NewDropdown$subscriptions(model.i$),
				$author$project$Ui$NewDropdown$subscriptions(model.je),
				(model.iT.U9 || model.j_.U9) ? $elm$core$Platform$Sub$none : $author$project$Ui$NewDropdown$subscriptions(model.jj),
				$author$project$Ui$NewDropdown$subscriptions(model.iT),
				$author$project$Ui$NewDropdown$subscriptions(model.j_),
				$author$project$Ui$NewDropdown$subscriptions(model.pe),
				$author$project$Ui$NewDropdown$subscriptions(model.im),
				$author$project$Ui$NewDropdown$subscriptions(model.gu),
				$author$project$Ui$NewDropdown$subscriptions(model.iD),
				$author$project$Ui$NewDropdown$subscriptions(model.lv),
				$author$project$Ui$NewDropdown$subscriptions(model.mT)
			]));
};
var $author$project$Pages$StyleGuide$Dropdown$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 6:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fU: text}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fU: '', m: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fU: '',
							m: $elm$core$Maybe$Just(lang),
							kx: $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							lw: lang,
							m: $elm$core$Maybe$Just(lang)
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var dropdownMsg = msg.a;
				var _v1 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.fT);
				var newDropdown = _v1.a;
				var dropdownCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fT: newDropdown}),
					dropdownCmd);
			case 1:
				var dropdownMsg = msg.a;
				var _v2 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.i$);
				var newDropdown = _v2.a;
				var dropdownCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{i$: newDropdown}),
					dropdownCmd);
			case 2:
				var dropdownMsg = msg.a;
				var _v3 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.je);
				var newDropdown = _v3.a;
				var dropdownCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{je: newDropdown}),
					dropdownCmd);
			case 9:
				var dropdownMsg = msg.a;
				var _v4 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.jj);
				var newDropdown = _v4.a;
				var dropdownCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{jj: newDropdown}),
					dropdownCmd);
			case 10:
				var dropdownMsg = msg.a;
				var _v5 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.iT);
				var newDropdown = _v5.a;
				var dropdownCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iT: newDropdown}),
					dropdownCmd);
			case 11:
				var dropdownMsg = msg.a;
				var _v6 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.j_);
				var newDropdown = _v6.a;
				var dropdownCmd = _v6.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{j_: newDropdown}),
					dropdownCmd);
			case 12:
				var dropdownMsg = msg.a;
				var _v7 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.pe);
				var newDropdown = _v7.a;
				var dropdownCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pe: newDropdown}),
					dropdownCmd);
			case 7:
				var lang = msg.a;
				var checked = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bn: checked ? A2($elm$core$List$cons, lang, model.bn) : A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(lang),
								model.bn)
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var langs = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bn: langs}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var lang = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							kx: $elm$core$Maybe$Just(lang)
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var dropdownMsg = msg.a;
				var _v8 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.im);
				var newDropdown = _v8.a;
				var dropdownCmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{im: newDropdown}),
					dropdownCmd);
			case 15:
				var dropdownMsg = msg.a;
				var _v9 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.gu);
				var newDropdown = _v9.a;
				var dropdownCmd = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{gu: newDropdown}),
					dropdownCmd);
			case 16:
				var dropdownMsg = msg.a;
				var _v10 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.iD);
				var newDropdown = _v10.a;
				var dropdownCmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iD: newDropdown}),
					dropdownCmd);
			case 17:
				var dropdownMsg = msg.a;
				var _v11 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.lv);
				var newDropdown = _v11.a;
				var dropdownCmd = _v11.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lv: newDropdown}),
					dropdownCmd);
			case 18:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{lw: string}),
					$elm$core$Platform$Cmd$none);
			default:
				var dropdownMsg = msg.a;
				var _v12 = A2($author$project$Ui$NewDropdown$update, dropdownMsg, model.mT);
				var newDropdown = _v12.a;
				var dropdownCmd = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mT: newDropdown}),
					dropdownCmd);
		}
	});
var $author$project$Generated$StyleGuide$Examples$dropdownExample = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.langDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.langDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ]\n            [ SVG.translate []\n            , span [ Html.Attributes.class "ml-1" ] [ text "Select a Language" ]\n            ]\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleDisabled = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.disabledDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.disabledDropdown\n        |> Dropdown.viewSelect [ Dropdown.disabled True ]\n            [ text "Disabled Dropdown" ]\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleInnerDropdown = '\n    -- Make sure to check the subscriptions function!\n    let\n        toOption lang =\n            Dropdown.checkbox\n                [ Dropdown.onCheck <| LangChecked lang\n                , Dropdown.checked (List.member lang model.checkedLangs)\n                ]\n                (text lang)\n    in\n    [ span [ Html.Attributes.id <| model.outerDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            if List.isEmpty model.checkedLangs then\n                "None"\n\n            else\n                model.checkedLangs |> String.join ", "\n        ]\n    , model.outerDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ]\n            [ text "Pick languages" ]\n            [ Dropdown.innerDropdown\n                [ Element.view [ Element.spaceBetween, Element.itemsCenter ]\n                    [ Html.span []\n                        [ text "Functional" ]\n                    , SVG.chevron [ SVG.info ]\n                    ]\n                ]\n                ([ "Elm", "Haskell", "Elixir", "Idris" ] |> List.map toOption)\n                model.innerDropdown\n            , Dropdown.innerDropdown\n                [ Element.view [ Element.spaceBetween, Element.itemsCenter ]\n                    [ Html.span []\n                        [ text "Object Oriented" ]\n                    , SVG.chevron [ SVG.info ]\n                    ]\n                ]\n                ([ "Ruby", "Javascript", "Python" ] |> List.map toOption)\n                model.secondInnerDropdown\n            ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleMultiSelect = '\n    let\n        toOption lang =\n            Dropdown.checkbox\n                [ Dropdown.onCheck <| LangChecked lang\n                , Dropdown.checked (List.member lang model.checkedLangs)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect <| CheckedLangsSet []\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.filter (String.contains model.langSearch)\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.multiLangDropdown.id ++ "-selected" ] [ text "Selected: " ]\n    , text <|\n        if List.isEmpty model.checkedLangs then\n            "None"\n\n        else\n            model.checkedLangs |> String.join ", "\n    , model.multiLangDropdown |> Dropdown.view [ Dropdown.buttonSecondary ] [ text "Langs" ] options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleReadonly = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.readonlyDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.readonlyDropdown\n        |> Dropdown.viewSelect [ Dropdown.readonly True ]\n            [ text "Readonly Dropdown" ]\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleSearch = '\n    let\n        -- Transform language into an option\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            String.toLower lang |> String.contains (String.toLower model.langSearch)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            Dropdown.input\n                (Dropdown.onInput LangSearched\n                    :: Dropdown.value model.langSearch\n                    :: Dropdown.placeholder "Search..."\n                    :: (case langs of\n                            [ singleLang ] ->\n                                -- Optionally, select a single result on Enter.\n                                [ Dropdown.onEnter (LangSelected singleLang) ]\n\n                            _ ->\n                                []\n                       )\n                )\n                :: Dropdown.item\n                    [ Dropdown.onSelect LangCleared\n                    , Dropdown.selected (model.selectedLang == Nothing)\n                    ]\n                    (text "None")\n                :: Dropdown.separator\n                :: (langs\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.langWithSearchDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.langWithSearchDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ] [ text "Lang" ] options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithButton = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ Button.group\n        [ Button.view { ariaLabel = "Open dropdown menu" }\n            []\n            [ text <|\n                case model.selectedLang of\n                    Just lang ->\n                        lang\n\n                    Nothing ->\n                        "None"\n            ]\n        , model.langDropdown\n            |> Dropdown.view []\n                [ SVG.translate []\n                ]\n                options\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithCombobox = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| FreeLangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            String.toLower lang |> String.contains (String.toLower model.comboboxString)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            langs\n                |> List.map toOption\n    in\n    [ span [ Html.Attributes.id <| model.readonlyDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.comboboxDropdown\n        |> Dropdown.viewCombobox []\n            { onInput = ComboboxDropdownInput\n            , value = model.comboboxString\n            , onEnter =\n                langs\n                    |> List.head\n                    |> Maybe.map FreeLangSelected\n            }\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithErrors = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.errorDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.errorDropdown\n        |> Dropdown.viewSelect\n            [ Dropdown.errors [ "This field is required", "Please select a valid option" ]\n            , Dropdown.invalid True\n            ]\n            [ text "Dropdown with Errors" ]\n            options\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithInput = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            case model.typedLang of\n                Nothing ->\n                    True\n\n                Just typedLang ->\n                    String.toLower lang |> String.contains (String.toLower typedLang)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            Dropdown.input\n                [ Dropdown.onInput TypedLang\n                , Dropdown.value <| Maybe.withDefault "" model.typedLang\n                , Dropdown.placeholder "Search or type your own"\n                ]\n                :: Dropdown.item\n                    [ Dropdown.onSelect LangCleared\n                    , Dropdown.selected (model.selectedLang == Nothing)\n                    ]\n                    (text "None")\n                :: Dropdown.separator\n                :: (langs\n                        |> List.map toOption\n                   )\n\n        notIfEmpty lang =\n            if String.isEmpty lang then\n                Nothing\n\n            else\n                Just lang\n    in\n    [ model.withInput\n        |> Dropdown.viewSelect []\n            [ model.typedLang\n                |> Maybe.andThen notIfEmpty\n                |> Maybe.withDefault (model.selectedLang |> Maybe.withDefault "All langs")\n                |> text\n            ]\n            options\n    ]    ';
var $author$project$Pages$StyleGuide$Dropdown$LangCleared = {$: 5};
var $author$project$Pages$StyleGuide$Dropdown$LangSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$example = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						model.m,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(model.m, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.fT.adR + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.m;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$NewDropdown$view,
			_List_fromArray(
				[$author$project$Ui$NewDropdown$buttonSecondary]),
			_List_fromArray(
				[
					$author$project$Ui$SvgIcon$translate(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('ml-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select a Language')
						]))
				]),
			options,
			model.fT)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$exampleDisabled = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						model.m,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(model.m, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.im.adR + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.m;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$NewDropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$disabled(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Disabled Dropdown')
				]),
			options,
			model.im)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$LangChecked = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Ui$NewDropdown$InnerDropdown = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Ui$NewDropdown$innerDropdown = $author$project$Ui$NewDropdown$InnerDropdown;
var $author$project$Pages$StyleGuide$Dropdown$exampleInnerDropdown = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$checkbox,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onCheck(
					$author$project$Pages$StyleGuide$Dropdown$LangChecked(lang)),
					$author$project$Ui$NewDropdown$checked(
					A2($elm$core$List$member, lang, model.bn))
				]),
			$elm$html$Html$text(lang));
	};
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.jj.adR + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					$elm$core$List$isEmpty(model.bn) ? 'None' : A2($elm$core$String$join, ', ', model.bn))
				])),
			A4(
			$author$project$Ui$NewDropdown$view,
			_List_fromArray(
				[$author$project$Ui$NewDropdown$buttonSecondary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Pick languages')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$NewDropdown$innerDropdown,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Functional')
										])),
									$author$project$Ui$SvgIcon$chevron(
									_List_fromArray(
										[$author$project$Ui$SvgIcon$info]))
								]))
						]),
					A2(
						$elm$core$List$map,
						toOption,
						_List_fromArray(
							['Elm', 'Haskell', 'Elixir', 'Idris'])),
					model.iT),
					A3(
					$author$project$Ui$NewDropdown$innerDropdown,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Object Oriented')
										])),
									$author$project$Ui$SvgIcon$chevron(
									_List_fromArray(
										[$author$project$Ui$SvgIcon$info]))
								]))
						]),
					A2(
						$elm$core$List$map,
						toOption,
						_List_fromArray(
							['Ruby', 'Javascript', 'Python'])),
					model.j_)
				]),
			model.jj)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$CheckedLangsSet = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$exampleMultiSelect = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$checkbox,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onCheck(
					$author$project$Pages$StyleGuide$Dropdown$LangChecked(lang)),
					$author$project$Ui$NewDropdown$checked(
					A2($elm$core$List$member, lang, model.bn))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$CheckedLangsSet(_List_Nil))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				A2(
					$elm$core$List$filter,
					$elm$core$String$contains(model.fU),
					_List_fromArray(
						['Elm', 'Ruby', 'Javascript', 'Lua'])))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.je.adR + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: ')
				])),
			$elm$html$Html$text(
			$elm$core$List$isEmpty(model.bn) ? 'None' : A2($elm$core$String$join, ', ', model.bn)),
			A4(
			$author$project$Ui$NewDropdown$view,
			_List_fromArray(
				[$author$project$Ui$NewDropdown$buttonSecondary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Langs')
				]),
			options,
			model.je)
		]);
};
var $author$project$Ui$NewDropdown$Readonly = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$NewDropdown$readonly = $author$project$Ui$NewDropdown$Readonly;
var $author$project$Pages$StyleGuide$Dropdown$exampleReadonly = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						model.m,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(model.m, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.gu.adR + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.m;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$NewDropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$readonly(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Readonly Dropdown')
				]),
			options,
			model.gu)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$LangSearched = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$exampleSearch = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						model.m,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var contains = function (lang) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(model.fU),
			$elm$core$String$toLower(lang));
	};
	var langs = A2(
		$elm$core$List$filter,
		contains,
		_List_fromArray(
			['Elm', 'Ruby', 'Javascript', 'Lua', 'Rust']));
	var options = A2(
		$elm$core$List$cons,
		$author$project$Ui$NewDropdown$input(
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$onInput($author$project$Pages$StyleGuide$Dropdown$LangSearched),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$NewDropdown$value(model.fU),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$NewDropdown$placeholder('Search...'),
						function () {
							if (langs.b && (!langs.b.b)) {
								var singleLang = langs.a;
								return _List_fromArray(
									[
										$author$project$Ui$NewDropdown$onEnter(
										$author$project$Pages$StyleGuide$Dropdown$LangSelected(singleLang))
									]);
							} else {
								return _List_Nil;
							}
						}())))),
		A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(model.m, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('None')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2($elm$core$List$map, toOption, langs))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.i$.adR + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.m;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$NewDropdown$view,
			_List_fromArray(
				[$author$project$Ui$NewDropdown$buttonSecondary]),
			_List_fromArray(
				[
					$elm$html$Html$text('Lang')
				]),
			options,
			model.i$)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$exampleWithButton = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						model.m,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(model.m, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			$author$project$Ui$Button$group(
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Open dropdown menu'},
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								var _v0 = model.m;
								if (!_v0.$) {
									var lang = _v0.a;
									return lang;
								} else {
									return 'None';
								}
							}())
						])),
					A4(
					$author$project$Ui$NewDropdown$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$translate(_List_Nil)
						]),
					options,
					model.fT)
				]))
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownInput = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$FreeLangSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$exampleWithCombobox = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$FreeLangSelected(lang)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						model.m,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var contains = function (lang) {
		return A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(model.lw),
			$elm$core$String$toLower(lang));
	};
	var langs = A2(
		$elm$core$List$filter,
		contains,
		_List_fromArray(
			['Elm', 'Ruby', 'Javascript', 'Lua', 'Rust']));
	var options = A2($elm$core$List$map, toOption, langs);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.gu.adR + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.m;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$NewDropdown$viewCombobox,
			_List_Nil,
			{
				ae8: A2(
					$elm$core$Maybe$map,
					$author$project$Pages$StyleGuide$Dropdown$FreeLangSelected,
					$elm$core$List$head(langs)),
				afc: $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownInput,
				aaN: model.lw
			},
			options,
			model.lv)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$exampleWithErrors = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						model.m,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var options = A2(
		$elm$core$List$cons,
		A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(model.m, $elm$core$Maybe$Nothing))
				]),
			$elm$html$Html$text('None')),
		A2(
			$elm$core$List$cons,
			$author$project$Ui$NewDropdown$separator,
			A2(
				$elm$core$List$map,
				toOption,
				_List_fromArray(
					['Elm', 'Ruby', 'Javascript', 'Lua']))));
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(model.iD.adR + '-selected')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Selected: '),
					$elm$html$Html$text(
					function () {
						var _v0 = model.m;
						if (!_v0.$) {
							var lang = _v0.a;
							return lang;
						} else {
							return 'None';
						}
					}())
				])),
			A4(
			$author$project$Ui$NewDropdown$viewSelect,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$errors(
					_List_fromArray(
						['This field is required', 'Please select a valid option'])),
					$author$project$Ui$NewDropdown$invalid(true)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Dropdown with Errors')
				]),
			options,
			model.iD)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$TypedLang = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$StyleGuide$Dropdown$exampleWithInput = function (model) {
	var toOption = function (lang) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(
						model.m,
						$elm$core$Maybe$Just(lang)))
				]),
			$elm$html$Html$text(lang));
	};
	var notIfEmpty = function (lang) {
		return $elm$core$String$isEmpty(lang) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lang);
	};
	var contains = function (lang) {
		var _v0 = model.kx;
		if (_v0.$ === 1) {
			return true;
		} else {
			var typedLang = _v0.a;
			return A2(
				$elm$core$String$contains,
				$elm$core$String$toLower(typedLang),
				$elm$core$String$toLower(lang));
		}
	};
	var langs = A2(
		$elm$core$List$filter,
		contains,
		_List_fromArray(
			['Elm', 'Ruby', 'Javascript', 'Lua', 'Rust']));
	var options = A2(
		$elm$core$List$cons,
		$author$project$Ui$NewDropdown$input(
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onInput($author$project$Pages$StyleGuide$Dropdown$TypedLang),
					$author$project$Ui$NewDropdown$value(
					A2($elm$core$Maybe$withDefault, '', model.kx)),
					$author$project$Ui$NewDropdown$placeholder('Search or type your own')
				])),
		A2(
			$elm$core$List$cons,
			A2(
				$author$project$Ui$NewDropdown$item,
				_List_fromArray(
					[
						$author$project$Ui$NewDropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
						$author$project$Ui$NewDropdown$selected(
						_Utils_eq(model.m, $elm$core$Maybe$Nothing))
					]),
				$elm$html$Html$text('None')),
			A2(
				$elm$core$List$cons,
				$author$project$Ui$NewDropdown$separator,
				A2($elm$core$List$map, toOption, langs))));
	return _List_fromArray(
		[
			A4(
			$author$project$Ui$NewDropdown$viewSelect,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2(
						$elm$core$Maybe$withDefault,
						A2($elm$core$Maybe$withDefault, 'All langs', model.m),
						A2($elm$core$Maybe$andThen, notIfEmpty, model.kx)))
				]),
			options,
			model.pe)
		]);
};
var $author$project$Ui$NewDropdown$ButtonLink = 1;
var $author$project$Ui$NewDropdown$buttonLink = $author$project$Ui$NewDropdown$Button(1);
var $author$project$Ui$NewDropdown$Link = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Ui$NewDropdown$link = $author$project$Ui$NewDropdown$Link;
var $author$project$Pages$StyleGuide$Dropdown$exampleWithLinks = function (model) {
	return _List_fromArray(
		[
			$elm$html$Html$text('Test arrow navigation on this dropdown with links:'),
			A4(
			$author$project$Ui$NewDropdown$view,
			_List_fromArray(
				[$author$project$Ui$NewDropdown$buttonLink]),
			_List_fromArray(
				[
					$elm$html$Html$text('Switch To')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$NewDropdown$link,
					'https://example.com/clinical',
					_List_Nil,
					$elm$html$Html$text('Clinical')),
					A3(
					$author$project$Ui$NewDropdown$link,
					'https://example.com/admin',
					_List_Nil,
					$elm$html$Html$text('Admin Portal')),
					A2(
					$author$project$Ui$NewDropdown$item,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$onSelect(
							$author$project$Pages$StyleGuide$Dropdown$LangSelected('regular'))
						]),
					$elm$html$Html$text('Regular Item')),
					A3(
					$author$project$Ui$NewDropdown$link,
					'https://example.com/settings',
					_List_Nil,
					$elm$html$Html$text('Settings'))
				]),
			model.mT)
		]);
};
var $author$project$Pages$StyleGuide$Dropdown$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Select Like')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExample,
									EG: $author$project$Pages$StyleGuide$Dropdown$example(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Select Like with search')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleSearch,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleSearch(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Multi select')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleMultiSelect,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleMultiSelect(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Dropdownception')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleInnerDropdown,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleInnerDropdown(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Next to Button')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithButton,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleWithButton(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Free text like?')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithInput,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleWithInput(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Disabled')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleDisabled,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleDisabled(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Readonly')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleReadonly,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleReadonly(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With Errors')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithErrors,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleWithErrors(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Combobox')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithCombobox,
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleWithCombobox(model)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With Links (like navbar)')
									]),
								{
									K3: '-- Links dropdown example',
									EG: $author$project$Pages$StyleGuide$Dropdown$exampleWithLinks(model)
								})
							]))
					]))
			]),
		$G: 'StyleGuide.Dropdown'
	};
};
var $author$project$Pages$StyleGuide$Dropdown$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Dropdown$init, ahd: $author$project$Pages$StyleGuide$Dropdown$subscriptions, aaq: $author$project$Pages$StyleGuide$Dropdown$update, ahP: $author$project$Pages$StyleGuide$Dropdown$view});
var $author$project$Pages$StyleGuide$ExportCsv$WithSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$ExportCsv$WithoutSession = {$: 1};
var $author$project$Pages$StyleGuide$ExportCsv$init = F2(
	function (shared, _v0) {
		var _v1 = shared.ZD;
		if (_v1.$ === 3) {
			return _Utils_Tuple3(
				$author$project$Pages$StyleGuide$ExportCsv$WithSession(
					{
						D5: shared.D5,
						l9: $author$project$Components$ExportCsv$init(
							{adw: false, G0: 0}),
						nZ: $author$project$Components$ExportCsv$init(
							{adw: false, G0: 1})
					}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3($author$project$Pages$StyleGuide$ExportCsv$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$ExportCsv$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$ExportCsv$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$ExportCsv$subscriptions = function (model) {
	if (!model.$) {
		var record = model.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg,
					$author$project$Components$ExportCsv$subscriptions(record.l9)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg,
					$author$project$Components$ExportCsv$subscriptions(record.nZ))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$StyleGuide$ExportCsv$update = F2(
	function (msg, model) {
		if (model.$ === 1) {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		} else {
			var modelRecord = model.a;
			if (!msg.$) {
				var subMsg = msg.a;
				var _v2 = A3($author$project$Components$ExportCsv$update, modelRecord.D5, subMsg, modelRecord.l9);
				var exportCsv = _v2.a;
				var subCmd = _v2.b;
				var subOutMsgs = _v2.c;
				return _Utils_Tuple3(
					$author$project$Pages$StyleGuide$ExportCsv$WithSession(
						_Utils_update(
							modelRecord,
							{l9: exportCsv})),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg, subCmd),
					subOutMsgs);
			} else {
				var subMsg = msg.a;
				var _v3 = A3($author$project$Components$ExportCsv$update, modelRecord.D5, subMsg, modelRecord.nZ);
				var exportCsv = _v3.a;
				var subCmd = _v3.b;
				var subOutMsgs = _v3.c;
				return _Utils_Tuple3(
					$author$project$Pages$StyleGuide$ExportCsv$WithSession(
						_Utils_update(
							modelRecord,
							{nZ: exportCsv})),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg, subCmd),
					subOutMsgs);
			}
		}
	});
var $author$project$Pages$StyleGuide$ExportCsv$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg,
			A3(
				$author$project$Components$ExportCsv$modal,
				model.D5,
				_List_fromArray(
					[
						$author$project$Components$ExportCsv$params(
						_List_fromArray(
							[
								A2($author$project$Api$Param$string, 'practitioner', 'pct-26sCCZ8P7PQC')
							])),
						$author$project$Components$ExportCsv$path($author$project$Api$Provider$Patient$patientsPath),
						$author$project$Components$ExportCsv$filter('current_membership')
					]),
				model.l9)),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg,
			A3(
				$author$project$Components$ExportCsv$modal,
				model.D5,
				_List_fromArray(
					[
						$author$project$Components$ExportCsv$report(
						$elm$core$Maybe$Just(100)),
						$author$project$Components$ExportCsv$reportParams(
						_List_fromArray(
							[
								A2($author$project$Api$Param$string, 'signup_page', 'spg-5M6rwSEww8Y9')
							]))
					]),
				model.nZ)),
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Export Csv')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Non Report Export')
				])),
			A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg, $author$project$Components$ExportCsv$button),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Report Export')
				])),
			A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg, $author$project$Components$ExportCsv$button)
		]);
};
var $author$project$Pages$StyleGuide$ExportCsv$view = function (model) {
	return {
		e5: function () {
			if (!model.$) {
				var modelRecord = model.a;
				return $author$project$Pages$StyleGuide$ExportCsv$viewBody(modelRecord);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You need to be logged in to view this style guide')
							]))
					]);
			}
		}(),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$ExportCsv$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$StyleGuide$ExportCsv$init, aer: $author$project$Pages$StyleGuide$ExportCsv$load, agD: $author$project$Pages$StyleGuide$ExportCsv$save, ahd: $author$project$Pages$StyleGuide$ExportCsv$subscriptions, aaq: $author$project$Pages$StyleGuide$ExportCsv$update, ahP: $author$project$Pages$StyleGuide$ExportCsv$view});
var $author$project$Pages$StyleGuide$FileInput$init = function (_v0) {
	return _Utils_Tuple2(
		{xE: _List_Nil},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$FileInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$FileInput$update = F2(
	function (msg, model) {
		var files = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{xE: files}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$FileInput$FilesUploaded = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$FileInput$viewFile = function (file) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$elm$file$File$name(file))
			]));
};
var $author$project$Pages$StyleGuide$FileInput$viewBody = function (_v0) {
	var files = _v0.xE;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Form -> Input')
				])),
			$author$project$Ui$Form$File$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Disabled')
				])),
			$author$project$Ui$Form$File$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$File$disabled(true)
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Mutiple')
				])),
			$author$project$Ui$Form$File$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$File$multiple(true),
					$author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Allowed types')
				])),
			$author$project$Ui$Form$File$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$File$multiple(true),
					$author$project$Ui$Form$File$accept(1),
					$author$project$Ui$Form$File$accept(0),
					$author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
				])),
			$elm$html$Html$text('Selected: '),
			A2($elm$html$Html$br, _List_Nil, _List_Nil),
			A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2($elm$core$List$map, $author$project$Pages$StyleGuide$FileInput$viewFile, files))
		]);
};
var $author$project$Pages$StyleGuide$FileInput$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$FileInput$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$FileInput$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$FileInput$init, ahd: $author$project$Pages$StyleGuide$FileInput$subscriptions, aaq: $author$project$Pages$StyleGuide$FileInput$update, ahP: $author$project$Pages$StyleGuide$FileInput$view});
var $author$project$Ui$FlexGrid$Hidden = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$FlexGrid$hidden = $author$project$Ui$FlexGrid$Hidden(0);
var $author$project$Pages$StyleGuide$FlexGrid$viewGrid = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Flex Grid')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 6')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(6),
								$author$project$Ui$FlexGrid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(6),
								$author$project$Ui$FlexGrid$spanMd(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(2),
								$author$project$Ui$FlexGrid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 2')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(2),
								$author$project$Ui$FlexGrid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 2')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(2),
								$author$project$Ui$FlexGrid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 2')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 6')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(6)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 6')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$offset(6),
								$author$project$Ui$FlexGrid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(9),
								$author$project$Ui$FlexGrid$hidden,
								$author$project$Ui$FlexGrid$showMd
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 9 Hidden')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(3)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
										A2($elm$html$Html$Attributes$style, 'height', '3em')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Col 3')
									]))
							]))
					])),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('underline mt-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Stretched columns')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_fromArray(
					[$author$project$Ui$FlexGrid$rowItemsStretch, $author$project$Ui$FlexGrid$mt4]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center p-2'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightcoral')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('This column has some content.')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center p-2 h-full'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightgreen')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('This column\'s content div has `h-full`, allowing its background to fill the stretched column.')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$span(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('text-center p-2'),
										A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('This column stretches to match the content, but the content\'s background does not fill the height.'),
										$elm$html$Html$text(' It has the most content of the three columns, and will be the primary column that sets the height for the row.')
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$FlexGrid$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$FlexGrid$viewGrid, $G: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$FlexGrid$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$FlexGrid$view);
var $author$project$Pages$StyleGuide$FlyoutMenu$AbsoluteFlyoutMenuMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$FlyoutMenu$FixedFlyoutMenuMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$FlyoutMenu$Model = $elm$core$Basics$identity;
var $author$project$Ui$FlyoutMenu$init = F2(
	function (id, toMsg) {
		return {adR: id, U9: false, ahx: toMsg};
	});
var $author$project$Pages$StyleGuide$FlyoutMenu$init = function (_v0) {
	return _Utils_Tuple2(
		{
			kM: A2($author$project$Ui$FlyoutMenu$init, 'absolute-menu', $author$project$Pages$StyleGuide$FlyoutMenu$AbsoluteFlyoutMenuMsg),
			mh: A2($author$project$Ui$FlyoutMenu$init, 'fixed-menu', $author$project$Pages$StyleGuide$FlyoutMenu$FixedFlyoutMenuMsg)
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Ui$FlyoutMenu$Close = 1;
var $author$project$Ui$FlyoutMenu$decodePressedKey = function (closeMsg) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (key) {
			return (key === 'Escape') ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
		},
		A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
};
var $author$project$Ui$FlyoutMenu$subscribeToEscapeKeyPress = function (closeMsg) {
	return $elm$browser$Browser$Events$onKeyDown(
		$author$project$Ui$FlyoutMenu$decodePressedKey(closeMsg));
};
var $author$project$Ui$FlyoutMenu$subscriptions = function (_v0) {
	var open = _v0.U9;
	var toMsg = _v0.ahx;
	var id = _v0.adR;
	return open ? $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$FlyoutMenu$subscribeToEscapeKeyPress(
				toMsg(1)),
				A2(
				$author$project$Utils$Dom$onOutsideMouseDown,
				toMsg(1),
				id)
			])) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$FlyoutMenu$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$FlyoutMenu$subscriptions(model.mh),
				$author$project$Ui$FlyoutMenu$subscriptions(model.kM)
			]));
};
var $author$project$Ui$FlyoutMenu$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg) {
			case 0:
				return _Utils_update(
					model,
					{U9: true});
			case 1:
				return _Utils_update(
					model,
					{U9: false});
			default:
				return _Utils_update(
					model,
					{U9: false});
		}
	});
var $author$project$Pages$StyleGuide$FlyoutMenu$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var flyoutMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.kM);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{kM: flyoutMenu}),
				$elm$core$Platform$Cmd$none);
		} else {
			var subMsg = msg.a;
			var flyoutMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.mh);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{mh: flyoutMenu}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Ui$FlyoutMenu$Fixed = 0;
var $author$project$Ui$FlyoutMenu$Body = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$FlyoutMenu$body = function (contents) {
	return $author$project$Ui$FlyoutMenu$Body(contents);
};
var $author$project$Ui$FlyoutMenu$Header = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$FlyoutMenu$header = function (contents) {
	return $author$project$Ui$FlyoutMenu$Header(contents);
};
var $author$project$Ui$FlyoutMenu$Position = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$FlyoutMenu$position = $author$project$Ui$FlyoutMenu$Position;
var $author$project$Ui$FlyoutMenu$title = function (string) {
	return A2(
		$elm$html$Html$h4,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal-title')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(string)
			]));
};
var $author$project$Ui$FlyoutMenu$BlurredOutside = 2;
var $author$project$Ui$FlyoutMenu$Down = 1;
var $author$project$Ui$FlyoutMenu$Open = 0;
var $author$project$Ui$FlyoutMenu$Right = 0;
var $author$project$Ui$FlyoutMenu$Absolute = 1;
var $author$project$Ui$FlyoutMenu$defaultOptions = {xb: 0, Wz: 1};
var $author$project$Ui$FlyoutMenu$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				if (!option.$) {
					var pos = option.a;
					return _Utils_update(
						record,
						{Wz: pos});
				} else {
					var dir = option.a;
					return _Utils_update(
						record,
						{xb: dir});
				}
			}),
		$author$project$Ui$FlyoutMenu$defaultOptions,
		options);
};
var $author$project$Ui$FlyoutMenu$viewSection = function (section) {
	if (!section.$) {
		var contents = section.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flyout-menu__header')
				]),
			contents);
	} else {
		var contents = section.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flyout-menu__content')
				]),
			contents);
	}
};
var $author$project$Ui$FlyoutMenu$view = F4(
	function (options, sections, btnOrLink, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Ui$FlyoutMenu$optionsToRecord(options);
		var displayIfOpen = function (html) {
			return model.U9 ? html : $author$project$Utils$Html$empty;
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('flyout-menu-wrapper'),
					$elm$html$Html$Attributes$id(model.adR),
					A2(
					$author$project$Utils$Dom$onOutsideBlur,
					model.ahx(2),
					model.adR)
				]),
			_List_fromArray(
				[
					displayIfOpen(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('flyout-menu', true),
										_Utils_Tuple2('flyout-menu--right', !optionsRecord.xb),
										_Utils_Tuple2('flyout-menu--down', optionsRecord.xb === 1),
										_Utils_Tuple2('flyout-menu--fixed', !optionsRecord.Wz)
									]))
							]),
						A2($elm$core$List$map, $author$project$Ui$FlyoutMenu$viewSection, sections))),
					displayIfOpen(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('flyout-menu__caret')
							]),
						_List_Nil)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							model.ahx(0)),
							model.U9 ? A2($elm$html$Html$Attributes$style, 'pointer-events', 'none') : $elm$html$Html$Attributes$class('')
						]),
					_List_fromArray(
						[btnOrLink]))
				]));
	});
var $author$project$Pages$StyleGuide$FlyoutMenu$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Flyout Menu')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$header(
							_List_fromArray(
								[
									$author$project$Ui$FlyoutMenu$title('Example Header')
								])),
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Menu item 1'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Lorem Ipsum Hello World')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Menu item 2'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ipsum Hello World Lorem')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Menu item 3'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Hello World Lorem Ipsum')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Menu item 4'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('World Lorem Ipsum Hello')
										]))
								]))
						]),
					A3(
						$author$project$Ui$Button$view,
						{abp: 'Open absolute flyout menu'},
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Absolute Flyout Menu')
							])),
					model.kM))),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$position(0)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$header(
							_List_fromArray(
								[
									$author$project$Ui$FlyoutMenu$title('Example Header')
								])),
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Menu item 1'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Lorem Ipsum Hello World')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Menu item 2'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Ipsum Hello World Lorem')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Menu item 3'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('Hello World Lorem Ipsum')
										])),
									A3(
									$author$project$Ui$Button$view,
									{abp: 'Menu item 4'},
									_List_fromArray(
										[$author$project$Ui$Button$link]),
									_List_fromArray(
										[
											$elm$html$Html$text('World Lorem Ipsum Hello')
										]))
								]))
						]),
					A3(
						$author$project$Ui$Button$view,
						{abp: 'Open fixed flyout menu'},
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Fixed Flyout Menu')
							])),
					model.mh)))
		]);
};
var $author$project$Pages$StyleGuide$FlyoutMenu$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$FlyoutMenu$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$FlyoutMenu$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$FlyoutMenu$init, ahd: $author$project$Pages$StyleGuide$FlyoutMenu$subscriptions, aaq: $author$project$Pages$StyleGuide$FlyoutMenu$update, ahP: $author$project$Pages$StyleGuide$FlyoutMenu$view});
var $author$project$Pages$StyleGuide$FormExample$formFieldsInit = {IK: $elm$core$Maybe$Nothing, Pu: '', SA: ''};
var $author$project$Pages$StyleGuide$FormExample$init = function (_v0) {
	return _Utils_Tuple2(
		{
			PB: $author$project$Utils$Form$init($author$project$Pages$StyleGuide$FormExample$formFieldsInit),
			W7: false
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$FormExample$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$FormExample$formFieldsUpdate = F2(
	function (field, form) {
		switch (field.$) {
			case 1:
				var firstName = field.a;
				return _Utils_update(
					form,
					{Pu: firstName});
			case 2:
				var lastName = field.a;
				return _Utils_update(
					form,
					{SA: lastName});
			default:
				var age = field.a;
				return _Utils_update(
					form,
					{IK: age});
		}
	});
var $author$project$Pages$StyleGuide$FormExample$FirstNameValidation = 0;
var $author$project$Pages$StyleGuide$FormExample$LastNameValidation = 1;
var $author$project$Pages$StyleGuide$FormExample$AgeValidation = 2;
var $author$project$Pages$StyleGuide$FormExample$validateAge = function (form) {
	var _v0 = form.IK;
	if (_v0.$ === 1) {
		return _List_Nil;
	} else {
		var age = _v0.a;
		return (age < 5) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Must be at least 5 years old')
			]) : ((age > 65) ? _List_fromArray(
			[
				_Utils_Tuple2(2, 'Must be younger than 65 years old')
			]) : _List_Nil);
	}
};
var $author$project$Pages$StyleGuide$FormExample$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.Pu;
			},
			_Utils_Tuple2(0, 'Please enter a first name.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.SA;
			},
			_Utils_Tuple2(1, 'Please enter a last name.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$StyleGuide$FormExample$validateAge)
		]));
var $author$project$Pages$StyleGuide$FormExample$CompletedSubmit = {$: 2};
var $author$project$Pages$StyleGuide$FormExample$processForm = function (_v0) {
	return A2(
		$elm$core$Task$perform,
		function (_v1) {
			return $author$project$Pages$StyleGuide$FormExample$CompletedSubmit;
		},
		$elm$core$Process$sleep(3000));
};
var $author$project$Pages$StyleGuide$FormExample$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							PB: A3($author$project$Utils$Form$update, $author$project$Pages$StyleGuide$FormExample$formFieldsUpdate, field, model.PB)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$StyleGuide$FormExample$formFieldsValidator, model.PB);
				if (!_v1.$) {
					var _v2 = _v1.a;
					var form = _v2.a;
					var validFormFields = _v2.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{PB: form, W7: true}),
						$author$project$Pages$StyleGuide$FormExample$processForm(validFormFields));
				} else {
					var form = _v1.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{PB: form}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{W7: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$FormExample$Age = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$FormExample$AttemptedSubmit = {$: 1};
var $author$project$Pages$StyleGuide$FormExample$FirstName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$FormExample$FormUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$FormExample$LastName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$FormExample$ageToString = function (maybeInt) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $elm$core$String$fromInt, maybeInt));
};
var $author$project$Pages$StyleGuide$FormExample$maskAge = F2(
	function (currentAge, nextAgeString) {
		var _v0 = $elm$core$String$toInt(nextAgeString);
		if (_v0.$ === 1) {
			return (nextAgeString === '') ? $elm$core$Maybe$Nothing : currentAge;
		} else {
			var age = _v0.a;
			return $elm$core$Maybe$Just(age);
		}
	});
var $author$project$Pages$StyleGuide$FormExample$viewForm = F2(
	function (processing, form) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var firstName = _v0.Pu;
		var lastName = _v0.SA;
		var age = _v0.IK;
		return A2(
			$author$project$Ui$Form$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('First Name'),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(firstName),
													$author$project$Ui$Form$Input$placeholder('Jane'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$FirstName)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 0, form))
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 0, form))
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$spanSm(6)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Last Name'),
											$author$project$Ui$Form$Group$required(true)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(lastName),
													$author$project$Ui$Form$Input$placeholder('Doe'),
													$author$project$Ui$Form$Input$onInput(
													A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$LastName)),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 1, form))
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 1, form))
										]))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Age')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(12)
										]),
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$view(
											_List_fromArray(
												[
													$author$project$Ui$Form$Input$value(
													$author$project$Pages$StyleGuide$FormExample$ageToString(age)),
													$author$project$Ui$Form$Input$placeholder('e.g 30'),
													$author$project$Ui$Form$Input$onInput(
													A2(
														$elm$core$Basics$composeL,
														A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$Age),
														$author$project$Pages$StyleGuide$FormExample$maskAge(age))),
													$author$project$Ui$Form$Input$invalid(
													A2($author$project$Utils$Form$hasValidationErrors, 2, form))
												])),
											$author$project$Utils$FormErrors$view(
											A2($author$project$Utils$Form$validationErrors, 2, form))
										]))
								]))
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Submit form'},
					_List_fromArray(
						[
							$author$project$Ui$Button$primary,
							$author$project$Ui$Button$disabled(processing),
							$author$project$Ui$Button$loading(processing),
							$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$FormExample$AttemptedSubmit)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Submit')
						]))
				]));
	});
var $author$project$Pages$StyleGuide$FormExample$view = function (_v0) {
	var processing = _v0.W7;
	var form = _v0.PB;
	return {
		e5: _List_fromArray(
			[
				A2($author$project$Pages$StyleGuide$FormExample$viewForm, processing, form)
			]),
		$G: 'Form Example'
	};
};
var $author$project$Pages$StyleGuide$FormExample$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$FormExample$init, ahd: $author$project$Pages$StyleGuide$FormExample$subscriptions, aaq: $author$project$Pages$StyleGuide$FormExample$update, ahP: $author$project$Pages$StyleGuide$FormExample$view});
var $author$project$Pages$StyleGuide$FormGroup$init = function (_v0) {
	return _Utils_Tuple2(
		{Pu: 'Bruce', SA: 'Wayne', Hw: false},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$FormGroup$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$FormGroup$update = F2(
	function (msg, model) {
		var bool = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{Hw: bool}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$FormGroup$example = function (_v0) {
	var firstName = _v0.Pu;
	var lastName = _v0.SA;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Name'),
					$author$project$Ui$Form$Group$labelSpanSm(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(firstName),
											$author$project$Ui$Form$Input$placeholder('First')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(lastName),
											$author$project$Ui$Form$Input$placeholder('Last')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$TermsAcceptedchanged = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$FormGroup$exampleCheckbox = function (_v0) {
	var termsAccepted = _v0.Hw;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpanSm(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Checkbox$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Checkbox$value(termsAccepted),
							$author$project$Ui$Form$Checkbox$required(true),
							$author$project$Ui$Form$Checkbox$onCheck($elm$core$Basics$identity)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('I agree to Hint Health\'s Terms of Service.')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$exampleLabelAbove = function (_v0) {
	var firstName = _v0.Pu;
	var lastName = _v0.SA;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Some label'),
					$author$project$Ui$Form$Group$labelSpanSm(4),
					$author$project$Ui$Form$Group$labelAbove,
					$author$project$Ui$Form$Group$required(true)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(firstName),
											$author$project$Ui$Form$Input$placeholder('First')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(lastName),
											$author$project$Ui$Form$Input$placeholder('Last')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$exampleStatic = function (_v0) {
	var firstName = _v0.Pu;
	var lastName = _v0.SA;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('First Name'),
					$author$project$Ui$Form$Group$labelSpanSm(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(firstName)
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Last Name'),
					$author$project$Ui$Form$Group$labelSpanSm(4)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Static$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(lastName)
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabel = function (_v0) {
	var firstName = _v0.Pu;
	var lastName = _v0.SA;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(firstName),
											$author$project$Ui$Form$Input$placeholder('First')
										]))
								])),
							A2(
							$author$project$Ui$FlexGrid$column,
							_List_fromArray(
								[
									$author$project$Ui$FlexGrid$span(6)
								]),
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$view(
									_List_fromArray(
										[
											$author$project$Ui$Form$Input$value(lastName),
											$author$project$Ui$Form$Input$placeholder('Last')
										]))
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabelButSpaced = function (_v0) {
	var firstName = _v0.Pu;
	var lastName = _v0.SA;
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label(''),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(firstName),
							$author$project$Ui$Form$Input$placeholder('First')
						]))
				])),
			A2(
			$author$project$Ui$Form$Group$view,
			_List_fromArray(
				[
					$author$project$Ui$Form$Group$label('Label'),
					$author$project$Ui$Form$Group$labelSpan(4),
					$author$project$Ui$Form$Group$inputSpan(8)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(lastName),
							$author$project$Ui$Form$Input$placeholder('Last Name')
						]))
				]))
		]);
};
var $author$project$Generated$StyleGuide$Examples$formGroupExample = '\n    [ FormGroup.view\n        [ FormGroup.label "Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleCheckbox = '\n    [ FormGroup.view\n        [ FormGroup.label ""\n        , FormGroup.labelSpanSm 4\n        ]\n        [ Checkbox.view\n            [ Checkbox.value termsAccepted\n            , Checkbox.required True\n            , Checkbox.onCheck TermsAcceptedchanged\n            ]\n            [ strong []\n                [ text "I agree to Hint Health\'s Terms of Service."\n                ]\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleLabelAbove = '\n    [ FormGroup.view\n        [ FormGroup.label "Some label"\n        , FormGroup.labelSpanSm 4\n        , FormGroup.labelAbove\n        , FormGroup.required True\n        ]\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleStatic = '\n    [ FormGroup.view\n        [ FormGroup.label "First Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ FormStatic.view [] [ text firstName ]\n        ]\n    , FormGroup.view\n        [ FormGroup.label "Last Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ FormStatic.view [] [ text lastName ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabel = '\n    [ FormGroup.view\n        []\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabelButSpaced = '\n    [ FormGroup.view\n        [ FormGroup.label ""\n        , FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        ]\n        [ Input.view\n            [ Input.value firstName\n            , Input.placeholder "First"\n            ]\n        ]\n    , FormGroup.view\n        [ FormGroup.label "Label"\n        , FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        ]\n        [ Input.view\n            [ Input.value lastName\n            , Input.placeholder "Last Name"\n            ]\n        ]\n    ]    ';
var $author$project$Pages$StyleGuide$FormGroup$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Form Group')
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$formGroupExample,
								EG: $author$project$Pages$StyleGuide$FormGroup$example(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Form Group with static data'),
									$author$project$Components$StyleGuide$Example$description(
									_List_fromArray(
										[
											$elm$html$Html$text('Inputs and buttons have a certain height that form groups'),
											$elm$html$Html$text(' account for, so they align.'),
											$elm$html$Html$text(' Text, because of having way less height'),
											$elm$html$Html$text(' need to be wrapped inside FormStatic to align.')
										]))
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$formGroupExampleStatic,
								EG: $author$project$Pages$StyleGuide$FormGroup$exampleStatic(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Label above'),
									$author$project$Components$StyleGuide$Example$description(
									_List_fromArray(
										[
											$elm$html$Html$text('Only available in QA')
										]))
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$formGroupExampleLabelAbove,
								EG: $author$project$Pages$StyleGuide$FormGroup$exampleLabelAbove(model)
							})
						])),
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(6)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('without label'),
									$author$project$Components$StyleGuide$Example$description(
									_List_fromArray(
										[
											$elm$html$Html$text('Input will take the full width')
										]))
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabel,
								EG: $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabel(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('without label but with left spacing'),
									$author$project$Components$StyleGuide$Example$description(
									_List_fromArray(
										[
											$elm$html$Html$text('Just set the label as an empty text')
										]))
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabelButSpaced,
								EG: $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabelButSpaced(model)
							}),
							A2(
							$author$project$Components$StyleGuide$Example$view,
							_List_fromArray(
								[
									$author$project$Components$StyleGuide$Example$title('Checkbox'),
									$author$project$Components$StyleGuide$Example$description(_List_Nil)
								]),
							{
								K3: $author$project$Generated$StyleGuide$Examples$formGroupExampleCheckbox,
								EG: $author$project$Pages$StyleGuide$FormGroup$exampleCheckbox(model)
							})
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$FormGroup$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$FormGroup$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$FormGroup$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$FormGroup$init, ahd: $author$project$Pages$StyleGuide$FormGroup$subscriptions, aaq: $author$project$Pages$StyleGuide$FormGroup$update, ahP: $author$project$Pages$StyleGuide$FormGroup$view});
var $author$project$Pages$StyleGuide$FormStatic$viewBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('field label'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('value')
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('phi field label'),
										$author$project$Ui$Form$Group$labelSpanSm(4),
										$author$project$Ui$Form$Group$inputSpanSm(8)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Form$Static$view,
										_List_fromArray(
											[
												$author$project$Ui$Form$Static$phi(true)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('phi value')
											]))
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$FormStatic$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$FormStatic$viewBody, $G: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$FormStatic$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$FormStatic$view);
var $author$project$Pages$StyleGuide$HiConfirm$init = function (_v0) {
	return _Utils_Tuple2(
		{vY: true, pW: false, p9: false, qa: false, w_: $elm$core$Maybe$Nothing, xa: $elm$core$Maybe$Nothing, iL: false, zB: $elm$core$Maybe$Nothing, Ca: $elm$core$Maybe$Nothing, Dt: true, aaO: $elm$core$Maybe$Nothing},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$subscriptions = function (model) {
	return model.iL ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe = function (string) {
	return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
};
var $author$project$Pages$StyleGuide$HiConfirm$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{iL: true}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var confirmed = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pW: confirmed, iL: false}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{qa: true}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var confirmed = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{p9: confirmed, qa: false}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aaO: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							zB: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							w_: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							xa: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Ca: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var bool = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{Dt: bool}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var bool = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{vY: bool}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{pW: false, p9: false}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$HiConfirm$OpenHiConfirm = {$: 0};
var $author$project$Pages$StyleGuide$HiConfirm$Reset = {$: 4};
var $author$project$Pages$StyleGuide$HiConfirm$CenterTextChanged = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$CustomHiConfirmClosed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$CustomMessageChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$DetailChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$NounChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$OpenCustomHiConfirm = {$: 2};
var $author$project$Pages$StyleGuide$HiConfirm$SentenceChanged = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$TitleizeNounChanged = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$VerbChanged = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$StyleGuide$HiConfirm$viewCustom = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				if (model.qa) {
					var customOptions = A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$verb, model.aaO),
								A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$noun, model.zB),
								A2(
								$elm$core$Maybe$map,
								function (customMessage) {
									return $author$project$Components$HiConfirm$customMessage(
										_List_fromArray(
											[
												$elm$html$Html$text(customMessage)
											]));
								},
								model.w_),
								A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$detail, model.xa),
								A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$sentence, model.Ca),
								$elm$core$Maybe$Just(
								$author$project$Components$HiConfirm$titleizeNoun(model.Dt)),
								$elm$core$Maybe$Just(
								$author$project$Components$HiConfirm$centerText(model.vY))
							]));
					return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$StyleGuide$HiConfirm$CustomHiConfirmClosed, customOptions);
				} else {
					return $author$project$Utils$Html$empty;
				}
			}(),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Customize')
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Verb'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.aaO)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$VerbChanged)
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Noun'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.zB)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$NounChanged)
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Custom Message'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.w_)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$CustomMessageChanged)
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Detail'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.xa)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$DetailChanged)
					])),
				$author$project$Ui$Form$Input$view(
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$placeholder('Sentence'),
						$author$project$Ui$Form$Input$value(
						A2($elm$core$Maybe$withDefault, '', model.Ca)),
						$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$SentenceChanged)
					])),
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.Dt),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$HiConfirm$TitleizeNounChanged)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Titleize Noun')
					])),
				A2(
				$author$project$Ui$Form$Checkbox$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Checkbox$value(model.vY),
						$author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$HiConfirm$CenterTextChanged)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Center text')
					])),
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Open custom confirmation dialog'},
				_List_fromArray(
					[
						$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$OpenCustomHiConfirm)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Custom Confirm?')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Confirmed: ' + (model.p9 ? 'Yes' : 'No'))
					]))
			]));
};
var $author$project$Pages$StyleGuide$HiConfirm$viewBody = function (model) {
	return _List_fromArray(
		[
			model.iL ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed, _List_Nil) : $author$project$Utils$Html$empty,
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Hi Confirm')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Default')
				])),
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Open confirmation dialog'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$OpenHiConfirm)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Confirm?')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(
					'Confirmed: ' + (model.pW ? 'Yes' : 'No'))
				])),
			$author$project$Pages$StyleGuide$HiConfirm$viewCustom(model),
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Reset form'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$Reset)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Reset')
				]))
		]);
};
var $author$project$Pages$StyleGuide$HiConfirm$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$HiConfirm$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$HiConfirm$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$HiConfirm$init, ahd: $author$project$Pages$StyleGuide$HiConfirm$subscriptions, aaq: $author$project$Pages$StyleGuide$HiConfirm$update, ahP: $author$project$Pages$StyleGuide$HiConfirm$view});
var $author$project$Pages$StyleGuide$HorizontalRule$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$headingLg(
								_List_fromArray(
									[
										$elm$html$Html$text('Default')
									])),
								$author$project$Ui$HorizontalRule$view(_List_Nil),
								$author$project$Ui$Typography$headingLg(
								_List_fromArray(
									[
										$elm$html$Html$text('Double')
									])),
								$author$project$Ui$HorizontalRule$view(
								_List_fromArray(
									[$author$project$Ui$HorizontalRule$double])),
								$author$project$Ui$Typography$headingLg(
								_List_fromArray(
									[
										$elm$html$Html$text('Thin')
									])),
								$author$project$Ui$HorizontalRule$view(
								_List_fromArray(
									[$author$project$Ui$HorizontalRule$thin]))
							]))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$HorizontalRule$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$HorizontalRule$view);
var $author$project$Ui$Icon$Download = 37;
var $author$project$Ui$Icon$Export = 47;
var $author$project$Ui$Icon$Flag = 15;
var $author$project$Ui$Icon$List = 32;
var $author$project$Ui$Icon$MenuDown = 48;
var $author$project$Ui$Icon$MenuUp = 49;
var $author$project$Ui$Icon$Plus = 3;
var $author$project$Ui$Icon$PlusSign = 14;
var $author$project$Ui$Icon$Print = 29;
var $author$project$Ui$Icon$Upload = 42;
var $author$project$Ui$Icon$User = 0;
var $author$project$Ui$SvgIcon$Account = 3;
var $author$project$Ui$SvgIcon$account = $author$project$Ui$SvgIcon$viewIcon(3);
var $author$project$Ui$SvgIcon$AccountAndPricing = 27;
var $author$project$Ui$SvgIcon$accountAndPricing = $author$project$Ui$SvgIcon$viewIcon(27);
var $author$project$Ui$SvgIcon$Admin = 4;
var $author$project$Ui$SvgIcon$admin = $author$project$Ui$SvgIcon$viewIcon(4);
var $author$project$Ui$SvgIcon$BurgerMenu = 28;
var $author$project$Ui$SvgIcon$burgerMenu = $author$project$Ui$SvgIcon$viewIcon(28);
var $author$project$Ui$SvgIcon$BurgerMenuClose = 29;
var $author$project$Ui$SvgIcon$burgerMenuClose = $author$project$Ui$SvgIcon$viewIcon(29);
var $author$project$Ui$SvgIcon$Commissions = 6;
var $author$project$Ui$SvgIcon$commissions = $author$project$Ui$SvgIcon$viewIcon(6);
var $author$project$Ui$SvgIcon$dollar = $author$project$Ui$SvgIcon$viewIcon(50);
var $author$project$Ui$SvgIcon$EmployeeUploads = 24;
var $author$project$Ui$SvgIcon$employeeUploads = $author$project$Ui$SvgIcon$viewIcon(24);
var $author$project$Ui$SvgIcon$Employees = 23;
var $author$project$Ui$SvgIcon$employees = $author$project$Ui$SvgIcon$viewIcon(23);
var $author$project$Ui$SvgIcon$Enter = 16;
var $author$project$Ui$SvgIcon$enter = $author$project$Ui$SvgIcon$viewIcon(16);
var $author$project$Ui$SvgIcon$Exit = 21;
var $author$project$Ui$SvgIcon$exit = $author$project$Ui$SvgIcon$viewIcon(21);
var $author$project$Ui$SvgIcon$Help = 7;
var $author$project$Ui$SvgIcon$help = $author$project$Ui$SvgIcon$viewIcon(7);
var $author$project$Ui$SvgIcon$Invoices = 25;
var $author$project$Ui$SvgIcon$invoices = $author$project$Ui$SvgIcon$viewIcon(25);
var $author$project$Ui$SvgIcon$KebabMenu = 19;
var $author$project$Ui$SvgIcon$kebabMenu = $author$project$Ui$SvgIcon$viewIcon(19);
var $author$project$Ui$SvgIcon$Open = 18;
var $author$project$Ui$SvgIcon$open = $author$project$Ui$SvgIcon$viewIcon(18);
var $author$project$Ui$SvgIcon$Patients = 8;
var $author$project$Ui$SvgIcon$patients = $author$project$Ui$SvgIcon$viewIcon(8);
var $author$project$Ui$SvgIcon$PaymentMethods = 22;
var $author$project$Ui$SvgIcon$paymentMethods = $author$project$Ui$SvgIcon$viewIcon(22);
var $author$project$Ui$SvgIcon$Report = 9;
var $author$project$Ui$SvgIcon$report = $author$project$Ui$SvgIcon$viewIcon(9);
var $author$project$Ui$SvgIcon$Search = 40;
var $author$project$Ui$SvgIcon$search = $author$project$Ui$SvgIcon$viewIcon(40);
var $author$project$Ui$SvgIcon$SelectArrows = 17;
var $author$project$Ui$SvgIcon$selectArrows = $author$project$Ui$SvgIcon$viewIcon(17);
var $author$project$Ui$SvgIcon$Share = 10;
var $author$project$Ui$SvgIcon$share = $author$project$Ui$SvgIcon$viewIcon(10);
var $author$project$Ui$SvgIcon$sort = $author$project$Ui$SvgIcon$viewIcon(34);
var $author$project$Ui$SvgIcon$sortDown = $author$project$Ui$SvgIcon$viewIcon(35);
var $author$project$Ui$SvgIcon$sortUp = $author$project$Ui$SvgIcon$viewIcon(36);
var $author$project$Ui$SvgIcon$sponsors = $author$project$Ui$SvgIcon$viewIcon(11);
var $author$project$Pages$StyleGuide$Icon$viewIconGrid = A2(
	$elm$core$Basics$composeL,
	A2(
		$elm$core$Basics$composeL,
		$elm$core$List$singleton,
		$author$project$Ui$FlexGrid$row(_List_Nil)),
	$elm$core$List$map(
		A2(
			$elm$core$Basics$composeR,
			$author$project$Ui$Element$view(_List_Nil),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$singleton,
				$author$project$Ui$FlexGrid$column(
					_List_fromArray(
						[
							$author$project$Ui$FlexGrid$spanMd(2)
						]))))));
var $author$project$Pages$StyleGuide$Icon$example = $author$project$Pages$StyleGuide$Icon$viewIconGrid(
	_List_fromArray(
		[
			_List_fromArray(
			[
				$elm$html$Html$text('Synced To'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$syncedTo(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Synced From'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$syncedFrom(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Unpublished Rule'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$unpublishedRuleArrow(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Account'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$account(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Admin'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$admin(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Alert'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$alert(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Commissions'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$commissions(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Help'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$help(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Patients'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$patients(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Report'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$report(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Share'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$share(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Sponsors'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$sponsors(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Chevron'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$chevron(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Location'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$location(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Copy'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$copy(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Enter'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$enter(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Select Arrows'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$selectArrows(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Open'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$open(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Kebab Menu'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$kebabMenu(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Launch'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$launch(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Exit'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$exit(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Payment Methods'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$paymentMethods(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Employees'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$employees(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Employee Uploads'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$employeeUploads(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Invoices'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$invoices(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Config'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$accountAndPricing(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Burger Menu'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$burgerMenu(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Burger Menu Close'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$burgerMenuClose(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Hint 404'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$hint404(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Sort'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$sort(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Sort down'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$sortDown(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Sort up'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$sortUp(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Send'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$send(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Add'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$add(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Edit'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$edit(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Search'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$search(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Delete'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$delete(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Flag'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$flag(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Repeat'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$repeat(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Check'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$check(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Cross'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$cross(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Transfer'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$transfer(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Upload'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$upload(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Export'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$export(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Dollar'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$dollar(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('History'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$history(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Void'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$void(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Calendar'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$calendar(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Stop'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$stop(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Dots'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$dots(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Arrow Right'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$arrowRight(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Arrow Left'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$arrowLeft(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Arrow Right Bottom'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$arrowRightBottom(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Warning'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$warning(_List_Nil)
			]),
			_List_fromArray(
			[
				$elm$html$Html$text('Cross Circle'),
				$author$project$Utils$Html$noBreakSpace,
				$author$project$Ui$SvgIcon$crossCircle(_List_Nil)
			])
		]));
var $author$project$Pages$StyleGuide$Icon$exampleCircled = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$check(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$success])),
				$elm$html$Html$text('Success')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$cross(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$danger])),
				$elm$html$Html$text('Danger')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$alert(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$info])),
				$elm$html$Html$text('Info')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$circle(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$info, $author$project$Ui$SvgIcon$xl])),
				$elm$html$Html$text('Incomplete')
			]))
	]);
var $author$project$Pages$StyleGuide$Icon$exampleCircledSizes = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$check(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$success, $author$project$Ui$SvgIcon$xs])),
				$elm$html$Html$text('Extra Small')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$check(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$success, $author$project$Ui$SvgIcon$sm])),
				$elm$html$Html$text('Small')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$check(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$success])),
				$elm$html$Html$text('Default')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$check(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$success, $author$project$Ui$SvgIcon$lg])),
				$elm$html$Html$text('Large')
			])),
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$gap4, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$check(
				_List_fromArray(
					[$author$project$Ui$SvgIcon$circled, $author$project$Ui$SvgIcon$success, $author$project$Ui$SvgIcon$xl])),
				$elm$html$Html$text('Extra Large')
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$iconExample = '\n    [ [ text "Synced To", Html.noBreakSpace, SvgIcon.syncedTo [] ]\n    , [ text "Synced From", Html.noBreakSpace, SvgIcon.syncedFrom [] ]\n    , [ text "Unpublished Rule", Html.noBreakSpace, SvgIcon.unpublishedRuleArrow [] ]\n    , [ text "Account", Html.noBreakSpace, SvgIcon.account [] ]\n    , [ text "Admin", Html.noBreakSpace, SvgIcon.admin [] ]\n    , [ text "Alert", Html.noBreakSpace, SvgIcon.alert [] ]\n    , [ text "Commissions", Html.noBreakSpace, SvgIcon.commissions [] ]\n    , [ text "Help", Html.noBreakSpace, SvgIcon.help [] ]\n    , [ text "Patients", Html.noBreakSpace, SvgIcon.patients [] ]\n    , [ text "Report", Html.noBreakSpace, SvgIcon.report [] ]\n    , [ text "Share", Html.noBreakSpace, SvgIcon.share [] ]\n    , [ text "Sponsors", Html.noBreakSpace, SvgIcon.sponsors [] ]\n    , [ text "Chevron", Html.noBreakSpace, SvgIcon.chevron [] ]\n    , [ text "Location", Html.noBreakSpace, SvgIcon.location [] ]\n    , [ text "Copy", Html.noBreakSpace, SvgIcon.copy [] ]\n    , [ text "Enter", Html.noBreakSpace, SvgIcon.enter [] ]\n    , [ text "Select Arrows", Html.noBreakSpace, SvgIcon.selectArrows [] ]\n    , [ text "Open", Html.noBreakSpace, SvgIcon.open [] ]\n    , [ text "Kebab Menu", Html.noBreakSpace, SvgIcon.kebabMenu [] ]\n    , [ text "Launch", Html.noBreakSpace, SvgIcon.launch [] ]\n    , [ text "Exit", Html.noBreakSpace, SvgIcon.exit [] ]\n    , [ text "Payment Methods", Html.noBreakSpace, SvgIcon.paymentMethods [] ]\n    , [ text "Employees", Html.noBreakSpace, SvgIcon.employees [] ]\n    , [ text "Employee Uploads", Html.noBreakSpace, SvgIcon.employeeUploads [] ]\n    , [ text "Invoices", Html.noBreakSpace, SvgIcon.invoices [] ]\n    , [ text "Config", Html.noBreakSpace, SvgIcon.accountAndPricing [] ]\n    , [ text "Burger Menu", Html.noBreakSpace, SvgIcon.burgerMenu [] ]\n    , [ text "Burger Menu Close", Html.noBreakSpace, SvgIcon.burgerMenuClose [] ]\n    , [ text "Hint 404", Html.noBreakSpace, SvgIcon.hint404 [] ]\n    , [ text "Sort", Html.noBreakSpace, SvgIcon.sort [] ]\n    , [ text "Sort down", Html.noBreakSpace, SvgIcon.sortDown [] ]\n    , [ text "Sort up", Html.noBreakSpace, SvgIcon.sortUp [] ]\n    , [ text "Send", Html.noBreakSpace, SvgIcon.send [] ]\n    , [ text "Add", Html.noBreakSpace, SvgIcon.add [] ]\n    , [ text "Edit", Html.noBreakSpace, SvgIcon.edit [] ]\n    , [ text "Search", Html.noBreakSpace, SvgIcon.search [] ]\n    , [ text "Delete", Html.noBreakSpace, SvgIcon.delete [] ]\n    , [ text "Flag", Html.noBreakSpace, SvgIcon.flag [] ]\n    , [ text "Repeat", Html.noBreakSpace, SvgIcon.repeat [] ]\n    , [ text "Check", Html.noBreakSpace, SvgIcon.check [] ]\n    , [ text "Cross", Html.noBreakSpace, SvgIcon.cross [] ]\n    , [ text "Transfer", Html.noBreakSpace, SvgIcon.transfer [] ]\n    , [ text "Upload", Html.noBreakSpace, SvgIcon.upload [] ]\n    , [ text "Export", Html.noBreakSpace, SvgIcon.export [] ]\n    , [ text "Dollar", Html.noBreakSpace, SvgIcon.dollar [] ]\n    , [ text "History", Html.noBreakSpace, SvgIcon.history [] ]\n    , [ text "Void", Html.noBreakSpace, SvgIcon.void [] ]\n    , [ text "Calendar", Html.noBreakSpace, SvgIcon.calendar [] ]\n    , [ text "Stop", Html.noBreakSpace, SvgIcon.stop [] ]\n    , [ text "Dots", Html.noBreakSpace, SvgIcon.dots [] ]\n    , [ text "Arrow Right", Html.noBreakSpace, SvgIcon.arrowRight [] ]\n    , [ text "Arrow Left", Html.noBreakSpace, SvgIcon.arrowLeft [] ]\n    , [ text "Arrow Right Bottom", Html.noBreakSpace, SvgIcon.arrowRightBottom [] ]\n    , [ text "Warning", Html.noBreakSpace, SvgIcon.warning [] ]\n    , [ text "Cross Circle", Html.noBreakSpace, SvgIcon.crossCircle [] ]\n    ]\n        |> viewIconGrid    ';
var $author$project$Generated$StyleGuide$Examples$iconExampleCircled = '\n    [ Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.check [ SvgIcon.circled, SvgIcon.success ]\n        , text "Success"\n        ]\n    , Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.cross [ SvgIcon.circled, SvgIcon.danger ]\n        , text "Danger"\n        ]\n    , Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.alert [ SvgIcon.circled, SvgIcon.info ]\n        , text "Info"\n        ]\n    , Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.circle [ SvgIcon.info, SvgIcon.xl ]\n        , text "Incomplete"\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$iconExampleCircledSizes = '\n    [ Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.check [ SvgIcon.circled, SvgIcon.success, SvgIcon.xs ]\n        , text "Extra Small"\n        ]\n    , Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.check [ SvgIcon.circled, SvgIcon.success, SvgIcon.sm ]\n        , text "Small"\n        ]\n    , Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.check [ SvgIcon.circled, SvgIcon.success ]\n        , text "Default"\n        ]\n    , Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.check [ SvgIcon.circled, SvgIcon.success, SvgIcon.lg ]\n        , text "Large"\n        ]\n    , Element.view [ Element.gap4, Element.itemsCenter, Element.mb2 ]\n        [ SvgIcon.check [ SvgIcon.circled, SvgIcon.success, SvgIcon.xl ]\n        , text "Extra Large"\n        ]\n    ]\n    ';
var $author$project$Ui$Icon$TextFriendly = {$: 0};
var $author$project$Ui$Icon$textFriendly = $author$project$Ui$Icon$TextFriendly;
var $author$project$Pages$StyleGuide$Icon$viewIcon = function (_v0) {
	var nameString = _v0.a;
	var name = _v0.b;
	return A2(
		$author$project$Ui$FlexGrid$column,
		_List_fromArray(
			[
				$author$project$Ui$FlexGrid$span(2),
				$author$project$Ui$FlexGrid$justifyRight
			]),
		_List_fromArray(
			[
				A2($author$project$Ui$Icon$view, _List_Nil, name),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(nameString)
					]))
			]));
};
var $author$project$Pages$StyleGuide$Icon$view = function (_v0) {
	var iconNames = _List_fromArray(
		[
			_Utils_Tuple2('Icon.Remove', 2),
			_Utils_Tuple2('Icon.Plus', 3),
			_Utils_Tuple2('Icon.Edit', 4),
			_Utils_Tuple2('Icon.Question', 5),
			_Utils_Tuple2('Icon.Loading', 8),
			_Utils_Tuple2('Icon.Alert', 9),
			_Utils_Tuple2('Icon.Erase', 10),
			_Utils_Tuple2('Icon.Email', 11),
			_Utils_Tuple2('Icon.StopAlt', 12),
			_Utils_Tuple2('Icon.ArrowLeft', 13),
			_Utils_Tuple2('Icon.PlusSign', 14),
			_Utils_Tuple2('Icon.Flag', 15),
			_Utils_Tuple2('Icon.Save', 16),
			_Utils_Tuple2('Icon.ArrowRight', 17),
			_Utils_Tuple2('Icon.Successful', 18),
			_Utils_Tuple2('Icon.Failed', 19),
			_Utils_Tuple2('Icon.Missing', 20),
			_Utils_Tuple2('Icon.Plan', 21),
			_Utils_Tuple2('Icon.Checkout', 22),
			_Utils_Tuple2('Icon.Ok', 23),
			_Utils_Tuple2('Icon.Link', 25),
			_Utils_Tuple2('Icon.Invalid', 26),
			_Utils_Tuple2('Icon.ShowMore', 27),
			_Utils_Tuple2('Icon.ShowLess', 28),
			_Utils_Tuple2('Icon.Print', 29),
			_Utils_Tuple2('Icon.NewWindow', 31),
			_Utils_Tuple2('Icon.List', 32),
			_Utils_Tuple2('Icon.Current', 33),
			_Utils_Tuple2('Icon.Wrench', 34),
			_Utils_Tuple2('Icon.Warning', 35),
			_Utils_Tuple2('Icon.Disabled', 36),
			_Utils_Tuple2('Icon.Download', 37),
			_Utils_Tuple2('Icon.Locked', 38),
			_Utils_Tuple2('Icon.RateDecrease', 40),
			_Utils_Tuple2('Icon.RateIncrease', 41),
			_Utils_Tuple2('Icon.Upload', 42),
			_Utils_Tuple2('Icon.Back', 43),
			_Utils_Tuple2('Icon.Forward', 44),
			_Utils_Tuple2('Icon.Calendar', 45),
			_Utils_Tuple2('Icon.Flash', 46),
			_Utils_Tuple2('Icon.Export', 47),
			_Utils_Tuple2('Icon.MenuDown', 48),
			_Utils_Tuple2('Icon.MenuUp', 49),
			_Utils_Tuple2('Icon.Increase', 50),
			_Utils_Tuple2('Icon.Decrease', 51),
			_Utils_Tuple2('Icon.Tasks', 52),
			_Utils_Tuple2('Icon.Gift', 53),
			_Utils_Tuple2('Icon.Send', 54),
			_Utils_Tuple2('Icon.EyeClose', 55),
			_Utils_Tuple2('Icon.EyeOpen', 56),
			_Utils_Tuple2('Icon.Copy', 57)
		]);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Svg Icon')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$iconExample, EG: $author$project$Pages$StyleGuide$Icon$example}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Circled Icons'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('Icons with circular backgrounds, useful for status indicators')
											]))
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$iconExampleCircled, EG: $author$project$Pages$StyleGuide$Icon$exampleCircled}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Circled Icon Sizes')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$iconExampleCircledSizes, EG: $author$project$Pages$StyleGuide$Icon$exampleCircledSizes})
							]))
					])),
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Icon [DEPRECATING]')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2),
										$author$project$Ui$FlexGrid$justifyRight
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Icon$view,
										_List_fromArray(
											[$author$project$Ui$Icon$textFriendly]),
										11),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter),
												$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Icon.Email + Icon.textFriendly')
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$span(2),
										$author$project$Ui$FlexGrid$justifyRight
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Icon$view,
										_List_fromArray(
											[$author$project$Ui$Icon$clickable]),
										0),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										A2(
										$author$project$Ui$Typography$span,
										_List_fromArray(
											[
												$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter),
												$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Icon.User + Icon.clickable')
											]))
									]))
							]),
							A2(
							$elm$core$List$map,
							$author$project$Pages$StyleGuide$Icon$viewIcon,
							A2(
								$elm$core$List$sortBy,
								function (_v1) {
									var k = _v1.a;
									return k;
								},
								iconNames))
						])))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Icon$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Icon$view);
var $author$project$Pages$StyleGuide$Input$init = function (_v0) {
	return {vE: 'Some initial text', xm: '', AP: '', BS: '', B2: ''};
};
var $author$project$Pages$StyleGuide$Input$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return _Utils_update(
					model,
					{vE: string});
			case 1:
				var string = msg.a;
				return _Utils_update(
					model,
					{B2: string});
			case 2:
				var string = msg.a;
				return _Utils_update(
					model,
					{BS: string});
			case 3:
				var string = msg.a;
				return _Utils_update(
					model,
					{xm: string});
			default:
				var string = msg.a;
				return _Utils_update(
					model,
					{AP: string});
		}
	});
var $author$project$Pages$StyleGuide$Input$BaseInputChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$Input$EmailInputchanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$Input$PhoneInputchanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StyleGuide$Input$RequiredInputchanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$Input$SecretInputChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$Input$emailValid = function (emailText) {
	return $elm$core$String$isEmpty(emailText) || A2($elm$core$String$contains, '@', emailText);
};
var $author$project$Pages$StyleGuide$Input$phoneMask = '(###) ###-####';
var $author$project$Pages$StyleGuide$Input$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Pages$StyleGuide$Input$phoneMask);
var $author$project$Pages$StyleGuide$Input$phoneIncomplete = function (phoneNumber) {
	var maskedPhone = A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Pages$StyleGuide$Input$phonePattern, phoneNumber);
	return ($elm$core$String$length(maskedPhone) > 0) && (!_Utils_eq(
		$elm$core$String$length($author$project$Pages$StyleGuide$Input$phoneMask),
		$elm$core$String$length(maskedPhone)));
};
var $author$project$Pages$StyleGuide$Input$phoneErrors = function (phoneNumber) {
	return $author$project$Pages$StyleGuide$Input$phoneIncomplete(phoneNumber) ? _List_fromArray(
		['Please enter a valid phone number.']) : _List_Nil;
};
var $author$project$Pages$StyleGuide$Input$phonePlaceholder = A3($elm$core$String$replace, '#', '5', $author$project$Pages$StyleGuide$Input$phoneMask);
var $author$project$Pages$StyleGuide$Input$viewBody = function (_v0) {
	var baseText = _v0.vE;
	var secretText = _v0.B2;
	var requiredText = _v0.BS;
	var emailText = _v0.xm;
	var phoneText = _v0.AP;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Form -> Input')
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$value(baseText),
							$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$BaseInputChanged)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('Disabled'),
							$author$project$Ui$Form$Input$disabled(true)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('Secret'),
							$author$project$Ui$Form$Input$password,
							$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$SecretInputChanged),
							$author$project$Ui$Form$Input$value(secretText)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('This is required'),
							$author$project$Ui$Form$Input$value(requiredText),
							$author$project$Ui$Form$Input$invalid(
							$elm$core$String$isEmpty(requiredText)),
							$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$RequiredInputchanged)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('This is required with feedback'),
							$author$project$Ui$Form$Input$withFeedback(true),
							$author$project$Ui$Form$Input$value(requiredText),
							$author$project$Ui$Form$Input$invalid(
							$elm$core$String$isEmpty(requiredText)),
							$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$RequiredInputchanged)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$placeholder('This is an email'),
							$author$project$Ui$Form$Input$email,
							$author$project$Ui$Form$Input$withFeedback(true),
							$author$project$Ui$Form$Input$value(emailText),
							$author$project$Ui$Form$Input$invalid(
							!$author$project$Pages$StyleGuide$Input$emailValid(emailText)),
							$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$EmailInputchanged)
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$view(
					_List_fromArray(
						[
							A2($author$project$Ui$Form$Input$maskedValue, $author$project$Pages$StyleGuide$Input$phonePattern, phoneText),
							$author$project$Ui$Form$Input$placeholder($author$project$Pages$StyleGuide$Input$phonePlaceholder),
							A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Pages$StyleGuide$Input$phonePattern, phoneText, $author$project$Pages$StyleGuide$Input$PhoneInputchanged),
							$author$project$Ui$Form$Input$invalid(
							$author$project$Pages$StyleGuide$Input$phoneIncomplete(phoneText)),
							$author$project$Ui$Form$Input$autoComplete(false),
							$author$project$Ui$Form$Input$phi(true),
							$author$project$Ui$Form$Input$withFeedback(true),
							$author$project$Ui$Form$Input$errors(
							$author$project$Pages$StyleGuide$Input$phoneErrors(phoneText))
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$addon(
							_List_fromArray(
								[
									$elm$html$Html$text('$')
								])),
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value('1.000,00')
								]))
						]))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					A2(
						$author$project$Ui$Form$Input$withPreAddon,
						'$',
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value('1.000,00')
							])))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					A2(
						$author$project$Ui$Form$Input$withPostAddon,
						'%',
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value('20')
							])))
				])),
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Form$Input$group(
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value('a search string')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Search'},
							_List_fromArray(
								[$author$project$Ui$Button$primary]),
							_List_fromArray(
								[
									$elm$html$Html$text('Search')
								]))
						]))
				])),
			A2(
			$author$project$Ui$FlexGrid$row,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$FlexGrid$column,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$placeholder('Span 9 Offset 3')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Input$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$Input$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Input$page = $author$project$Spa$Page$sandbox(
	{ad0: $author$project$Pages$StyleGuide$Input$init, aaq: $author$project$Pages$StyleGuide$Input$update, ahP: $author$project$Pages$StyleGuide$Input$view});
var $author$project$Pages$StyleGuide$Link$example = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('External')
			])),
		A3(
		$author$project$Ui$Link$route,
		$author$project$Spa$Generated$Route$StyleGuide__Link,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Internal (Route)')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$underline]),
		_List_fromArray(
			[
				$elm$html$Html$text('Link with underline')
			]))
	]);
var $author$project$Pages$StyleGuide$Link$exampleButton = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonDefault]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonPrimary]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonSecondary]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonSuccess]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[$author$project$Ui$Link$buttonWarning]),
		_List_fromArray(
			[
				$elm$html$Html$text('Go to Hint')
			]))
	]);
var $author$project$Pages$StyleGuide$Link$exampleWithIcon = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$xs,
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$sm,
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$lg,
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			]))
	]);
var $author$project$Pages$StyleGuide$Link$exampleWithIconOnly = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonSecondary,
				$author$project$Ui$Link$xs,
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonSecondary,
				$author$project$Ui$Link$sm,
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonSecondary,
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_Nil),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$buttonSecondary,
				$author$project$Ui$Link$lg,
				$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
			]),
		_List_Nil)
	]);
var $author$project$Pages$StyleGuide$Link$exampleWithIconRight = _List_fromArray(
	[
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$xs,
				$author$project$Ui$Link$iconRight($author$project$Ui$SvgIcon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$sm,
				$author$project$Ui$Link$iconRight($author$project$Ui$SvgIcon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$iconRight($author$project$Ui$SvgIcon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			])),
		A3(
		$author$project$Ui$Link$externalHref,
		'http://www.hint.com',
		_List_fromArray(
			[
				$author$project$Ui$Link$lg,
				$author$project$Ui$Link$iconRight($author$project$Ui$SvgIcon$flag)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Flag')
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$linkExample = '\n    [ Link.externalHref "http://www.hint.com"\n        []\n        [ text "External" ]\n    , Link.route Route.StyleGuide__Link\n        []\n        [ text "Internal (Route)" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.underline ]\n        [ text "Link with underline" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$linkExampleButton = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.buttonDefault\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonPrimary\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSuccess\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonWarning\n        ]\n        [ text "Go to Hint" ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$linkExampleWithIcon = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.xs\n        , Link.icon SvgIcon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.sm\n        , Link.icon SvgIcon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.icon SvgIcon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.lg\n        , Link.icon SvgIcon.flag\n        ]\n        [ text "Flag" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$linkExampleWithIconOnly = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.xs\n        , Link.icon SvgIcon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.sm\n        , Link.icon SvgIcon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.icon SvgIcon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.lg\n        , Link.icon SvgIcon.flag\n        ]\n        []\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$linkExampleWithIconRight = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.xs\n        , Link.iconRight SvgIcon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.sm\n        , Link.iconRight SvgIcon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.iconRight SvgIcon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.lg\n        , Link.iconRight SvgIcon.flag\n        ]\n        [ text "Flag" ]\n    ]    ';
var $author$project$Pages$StyleGuide$Link$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Link')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$linkExample, EG: $author$project$Pages$StyleGuide$Link$example}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Button options'),
										$author$project$Components$StyleGuide$Example$description(
										_List_fromArray(
											[
												$elm$html$Html$text('Link that look like buttons redirect to a new page. '),
												$elm$html$Html$text('Most common use case should be downloading files')
											]))
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$linkExampleButton, EG: $author$project$Pages$StyleGuide$Link$exampleButton})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With icon')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$linkExampleWithIcon, EG: $author$project$Pages$StyleGuide$Link$exampleWithIcon}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With icon right')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$linkExampleWithIconRight, EG: $author$project$Pages$StyleGuide$Link$exampleWithIconRight}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('With icon and no content')
									]),
								{K3: $author$project$Generated$StyleGuide$Examples$linkExampleWithIconOnly, EG: $author$project$Pages$StyleGuide$Link$exampleWithIconOnly})
							]))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Link$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Link$view);
var $author$project$Ui$ListGroup$Info = 1;
var $author$project$Ui$ListGroup$heading = function (contents) {
	return A2(
		$elm$html$Html$h3,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('list-group-item-heading')
			]),
		contents);
};
var $author$project$Pages$StyleGuide$ListGroup$viewBody = _List_fromArray(
	[
		$author$project$Ui$Typography$heading(
		_List_fromArray(
			[
				$elm$html$Html$text('List Group')
			])),
		A2(
		$author$project$Ui$ListGroup$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$style(0)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Success')
					])),
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$style(1)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Info')
					])),
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$style(2)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Warning')
					])),
				A2(
				$author$project$Ui$ListGroup$item,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$style(3)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Danger')
					])),
				A2(
				$author$project$Ui$ListGroup$item,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$ListGroup$heading(
						_List_fromArray(
							[
								$elm$html$Html$text('List group item heading')
							])),
						$author$project$Ui$ListGroup$body(
						_List_fromArray(
							[
								$elm$html$Html$text('Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.')
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$ListGroup$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$ListGroup$viewBody, $G: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$ListGroup$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ListGroup$view);
var $author$project$Pages$StyleGuide$Modal$init = function (_v0) {
	return _Utils_Tuple2(
		{U9: false, ag_: 1},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Modal$CloseModal = {$: 1};
var $author$project$Pages$StyleGuide$Modal$subscriptions = function (model) {
	return model.U9 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$StyleGuide$Modal$CloseModal) : $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Modal$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var size = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{U9: true, ag_: size}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{U9: false}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$Modal$OpenModal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Modal$Sm = 0;
var $author$project$Pages$StyleGuide$Modal$viewBody = function (model) {
	return _List_fromArray(
		[
			model.U9 ? A3(
			$author$project$Ui$Modal$view,
			$author$project$Pages$StyleGuide$Modal$CloseModal,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(model.ag_)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('header')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$elm$html$Html$text('body')
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$Modal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Save changes'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$Modal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Save changes')
								]))
						]))
				])) : $author$project$Utils$Html$empty,
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Modal')
				])),
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Open small modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(
					$author$project$Pages$StyleGuide$Modal$OpenModal(0))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Open Sm')
				])),
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Open medium modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(
					$author$project$Pages$StyleGuide$Modal$OpenModal(1))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Open Md')
				])),
			A3(
			$author$project$Ui$Button$view,
			{abp: 'Open large modal'},
			_List_fromArray(
				[
					$author$project$Ui$Button$onClick(
					$author$project$Pages$StyleGuide$Modal$OpenModal(2))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Open Lg')
				]))
		]);
};
var $author$project$Pages$StyleGuide$Modal$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$Modal$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Modal$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Modal$init, ahd: $author$project$Pages$StyleGuide$Modal$subscriptions, aaq: $author$project$Pages$StyleGuide$Modal$update, ahP: $author$project$Pages$StyleGuide$Modal$view});
var $author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage = 7;
var $author$project$Pages$StyleGuide$Pagination$defaultTotalCount = 95;
var $author$project$Pages$StyleGuide$Pagination$init = function (_v0) {
	return _Utils_Tuple2(
		{bV: 1, mM: $author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage, oN: $author$project$Pages$StyleGuide$Pagination$defaultTotalCount},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Pagination$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Pagination$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bV: 1,
							oN: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Pages$StyleGuide$Pagination$defaultTotalCount,
								$elm$core$String$toInt(string))
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var string = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bV: 1,
							mM: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage,
								$elm$core$String$toInt(string))
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var currentPage = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bV: currentPage}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Pages$StyleGuide$Pagination$CurrentPageChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$Pagination$ItemsPerPageChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Pagination$List$Lg = 2;
var $author$project$Ui$Pagination$List$Sm = 0;
var $author$project$Pages$StyleGuide$Pagination$TotalCountChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Pagination$List$HideTotalItemsForSinglePage = {$: 2};
var $author$project$Ui$Pagination$List$hideTotalItemsForSinglePage = $author$project$Ui$Pagination$List$HideTotalItemsForSinglePage;
var $author$project$Ui$Pagination$List$Size = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ui$Pagination$List$size = $author$project$Ui$Pagination$List$Size;
var $author$project$Pages$StyleGuide$Pagination$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Pagination')
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$number,
									$author$project$Ui$Form$Input$placeholder(
									'Total Count (Default: ' + ($elm$core$String$fromInt($author$project$Pages$StyleGuide$Pagination$defaultTotalCount) + ')')),
									$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Pagination$TotalCountChanged)
								])),
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$number,
									$author$project$Ui$Form$Input$placeholder(
									'Items Per Page (Default: ' + ($elm$core$String$fromInt($author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage) + ')')),
									$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Pagination$ItemsPerPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Default')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$totalCount(model.oN),
									$author$project$Ui$Pagination$List$itemsPerPage(model.mM),
									$author$project$Ui$Pagination$List$currentPage(model.bV),
									$author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Small')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$totalCount(model.oN),
									$author$project$Ui$Pagination$List$itemsPerPage(model.mM),
									$author$project$Ui$Pagination$List$currentPage(model.bV),
									$author$project$Ui$Pagination$List$size(0),
									$author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Large')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$totalCount(model.oN),
									$author$project$Ui$Pagination$List$itemsPerPage(model.mM),
									$author$project$Ui$Pagination$List$currentPage(model.bV),
									$author$project$Ui$Pagination$List$size(2),
									$author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Hide Total Items For Single Page')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$totalCount(model.oN),
									$author$project$Ui$Pagination$List$itemsPerPage(model.mM),
									$author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
									$author$project$Ui$Pagination$List$currentPage(model.bV),
									$author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged)
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Loading')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Pagination$List$view(
							_List_fromArray(
								[
									$author$project$Ui$Pagination$List$loading(true)
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Pagination$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$Pagination$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Pagination$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Pagination$init, ahd: $author$project$Pages$StyleGuide$Pagination$subscriptions, aaq: $author$project$Pages$StyleGuide$Pagination$update, ahP: $author$project$Pages$StyleGuide$Pagination$view});
var $author$project$Pages$StyleGuide$Panel$exampleCollapsible = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[
				$author$project$Ui$Panel$collapsed(false)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Click to toggle')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('This panel body is collapsible. Click the heading to expand or collapse it.')
					])),
				A2(
				$author$project$Ui$Panel$footer,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('The footer is also hidden when collapsed.')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Panel$exampleCollapsibleStyled = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[
				$author$project$Ui$Panel$info,
				$author$project$Ui$Panel$collapsed(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Styled collapsible (starts collapsed)')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Collapsible panels work with all panel style variants.')
					]))
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$panelExampleCollapsible = '\n    [ Panel.view\n        [ Panel.collapsed False\n        ]\n        [ Panel.heading []\n            [ Panel.title [ text "Click to toggle" ]\n            ]\n        , Panel.body []\n            [ text "This panel body is collapsible. Click the heading to expand or collapse it."\n            ]\n        , Panel.footer []\n            [ text "The footer is also hidden when collapsed."\n            ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$panelExampleCollapsibleStyled = '\n    [ Panel.view\n        [ Panel.info\n        , Panel.collapsed True\n        ]\n        [ Panel.heading []\n            [ Panel.title [ text "Styled collapsible (starts collapsed)" ]\n            ]\n        , Panel.body []\n            [ text "Collapsible panels work with all panel style variants."\n            ]\n        ]\n    ]\n    ';
var $author$project$Ui$Table$Striped = {$: 0};
var $author$project$Ui$Table$striped = $author$project$Ui$Table$Striped;
var $author$project$Pages$StyleGuide$Panel$viewPanel = A2(
	$author$project$Ui$Panel$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Panel$heading,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Panel Title')
				])),
			A2(
			$author$project$Ui$Panel$body,
			_List_fromArray(
				[$author$project$Ui$Element$textCenter]),
			_List_fromArray(
				[
					$elm$html$Html$text('Panel Content')
				])),
			A4(
			$author$project$Ui$Panel$table,
			_List_fromArray(
				[$author$project$Ui$Table$striped]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Panel')
						])),
					A2(
					$author$project$Ui$Table$header,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Table')
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Jhon')
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Doe')
								]))
						])),
					A2(
					$author$project$Ui$Table$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Jane')
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Doe')
								]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Table$row,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Some')
								])),
							A2(
							$author$project$Ui$Table$cell,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Footer')
								]))
						]))
				])),
			A2(
			$author$project$Ui$Panel$footer,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Panel Footer')
				]))
		]));
var $author$project$Pages$StyleGuide$Panel$viewPanelStyle = function (panelStyle) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_fromArray(
			[panelStyle]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Panel Title')
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Panel Content')
					]))
			]));
};
var $author$project$Ui$Panel$Warning = 3;
var $author$project$Ui$Panel$warning = $author$project$Ui$Panel$Styling(3);
var $author$project$Pages$StyleGuide$Panel$view = function (_v0) {
	var panelStyles = _List_fromArray(
		[$author$project$Ui$Panel$primary, $author$project$Ui$Panel$success, $author$project$Ui$Panel$info, $author$project$Ui$Panel$warning, $author$project$Ui$Panel$danger]);
	return {
		e5: $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[$author$project$Pages$StyleGuide$Panel$viewPanel]),
					A2($elm$core$List$map, $author$project$Pages$StyleGuide$Panel$viewPanelStyle, panelStyles),
					_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb4]),
						_List_Nil),
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Collapsible Panel'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('The collapsed option sets the initial state only. After rendering, the panel state is managed by CSS (checkbox hack). Click the heading to toggle.')
									]))
							]),
						{K3: $author$project$Generated$StyleGuide$Examples$panelExampleCollapsible, EG: $author$project$Pages$StyleGuide$Panel$exampleCollapsible}),
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Collapsible Styled Panel'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('The collapsed option sets the initial state only. After rendering, the panel state is managed by CSS (checkbox hack). Click the heading to toggle.')
									]))
							]),
						{K3: $author$project$Generated$StyleGuide$Examples$panelExampleCollapsibleStyled, EG: $author$project$Pages$StyleGuide$Panel$exampleCollapsibleStyled})
					])
				])),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Panel$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Panel$view);
var $author$project$Pages$StyleGuide$PasswordInput$init = function (_v0) {
	return _Utils_Tuple2('', $elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$PasswordInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$PasswordInput$update = F2(
	function (msg, _v0) {
		var string = msg;
		return _Utils_Tuple2(string, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$PasswordInput$PasswordInputChanged = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$PasswordInput$viewBody = function (password) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Form -> Password Input')
				])),
			$author$project$Ui$Form$PasswordInput$view(
			_List_fromArray(
				[
					$author$project$Ui$Form$PasswordInput$value(password),
					$author$project$Ui$Form$PasswordInput$onInput($elm$core$Basics$identity)
				]))
		]);
};
var $author$project$Pages$StyleGuide$PasswordInput$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$PasswordInput$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$PasswordInput$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$PasswordInput$init, ahd: $author$project$Pages$StyleGuide$PasswordInput$subscriptions, aaq: $author$project$Pages$StyleGuide$PasswordInput$update, ahP: $author$project$Pages$StyleGuide$PasswordInput$view});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotBankAccounts = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotCards = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithoutSession = {$: 1};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$init = F2(
	function (shared, _v0) {
		var _v1 = shared.ZD;
		if (_v1.$ === 3) {
			return _Utils_Tuple3(
				$author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession(
					{pD: $author$project$Api$Data$Loading, pN: $author$project$Api$Data$Loading, Hy: shared.Hy}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, shared.D5, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotCards),
							A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, shared.D5, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotBankAccounts)
						])),
				_List_Nil);
		} else {
			return _Utils_Tuple3($author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$update = F2(
	function (msg, model) {
		if (!model.$) {
			var withSession = model.a;
			if (!msg.$) {
				var response = msg.a;
				return _Utils_Tuple3(
					$author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession(
						_Utils_update(
							withSession,
							{pN: response})),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			} else {
				var response = msg.a;
				return _Utils_Tuple3(
					$author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession(
						_Utils_update(
							withSession,
							{pD: response})),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$viewBody = function (model) {
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Payment Source Displayer')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Card')
				])),
			function () {
			var _v0 = model.pN;
			if (_v0.$ === 3) {
				var cards = _v0.a;
				return $elm$core$List$isEmpty(cards) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The current practice does not have any cards, add one  or change to a practice that does')
						])) : A2(
					$author$project$Components$PaymentSourceDisplayer$view,
					model.Hy,
					_List_fromArray(
						[
							$author$project$Components$PaymentSourceDisplayer$source(
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll),
								$elm$core$List$head(cards)))
						]));
			} else {
				return $author$project$Ui$Spinner$view(_List_Nil);
			}
		}(),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('BankAccount')
				])),
			function () {
			var _v1 = model.pD;
			if (_v1.$ === 3) {
				var bankAccounts = _v1.a;
				return $elm$core$List$isEmpty(bankAccounts) ? A2(
					$author$project$Ui$Alert$warning,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The current practice does not have any cards, add one  or change to a practice that does')
						])) : A2(
					$author$project$Components$PaymentSourceDisplayer$view,
					model.Hy,
					_List_fromArray(
						[
							$author$project$Components$PaymentSourceDisplayer$source(
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll),
								$elm$core$List$head(bankAccounts)))
						]));
			} else {
				return $author$project$Ui$Spinner$view(_List_Nil);
			}
		}(),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Practice Source Displayer')
				])),
			function () {
			var _v2 = _Utils_Tuple2(model.pN, model.pD);
			if ((_v2.a.$ === 3) && (_v2.b.$ === 3)) {
				var _v3 = _v2.a;
				var cards = _v3.a;
				var _v4 = _v2.b;
				var bankAccounts = _v4.a;
				return A2(
					$author$project$Components$PracticeSourceDisplayer$view,
					model.Hy,
					A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts));
			} else {
				return $author$project$Ui$Spinner$view(_List_Nil);
			}
		}()
		]);
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$view = function (model) {
	return {
		e5: function () {
			if (!model.$) {
				var modelRecord = model.a;
				return $author$project$Pages$StyleGuide$PaymentSourceDisplayer$viewBody(modelRecord);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You need to be logged in to view this style guide')
							]))
					]);
			}
		}(),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$init, aer: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$load, agD: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$save, ahd: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$subscriptions, aaq: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$update, ahP: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$view});
var $author$project$Pages$StyleGuide$PhoneInput$init = function (_v0) {
	return _Utils_Tuple2(
		{
			bw: A3($author$project$Components$PhoneInput$init, 'phone-input', _List_Nil, $elm$core$Basics$identity),
			nu: A3(
				$author$project$Components$PhoneInput$init,
				'phone-input-one',
				_List_Nil,
				function (d) {
					return _Utils_update(
						d,
						{Ik: true, acB: $author$project$Api$Common$Phone$Shared$Office, yQ: 1});
				}),
			nv: A3(
				$author$project$Components$PhoneInput$init,
				'phone-input-one-required',
				_List_Nil,
				function (d) {
					return _Utils_update(
						d,
						{Ik: true, acB: $author$project$Api$Common$Phone$Shared$Office, yQ: 1, agk: true});
				}),
			nw: A3(
				$author$project$Components$PhoneInput$init,
				'phone-input-preloaded',
				_List_fromArray(
					[
						A3($author$project$Components$PhoneInput$initPhone, $author$project$Api$Common$Phone$Shared$Office, 1, '1234')
					]),
				$elm$core$Basics$identity),
			nx: A3(
				$author$project$Components$PhoneInput$init,
				'phone-input-required',
				_List_Nil,
				function (d) {
					return _Utils_update(
						d,
						{
							Ik: true,
							acB: $author$project$Api$Common$Phone$Shared$Office,
							yQ: 10,
							agk: true,
							ahJ: _List_fromArray(
								[$author$project$Api$Common$Phone$Shared$Office, $author$project$Api$Common$Phone$Shared$Mobile])
						});
				})
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$PhoneInput$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg,
				$author$project$Components$PhoneInput$subscriptions(model.bw)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg,
				$author$project$Components$PhoneInput$subscriptions(model.nx)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg,
				$author$project$Components$PhoneInput$subscriptions(model.nu)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg,
				$author$project$Components$PhoneInput$subscriptions(model.nv)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg,
				$author$project$Components$PhoneInput$subscriptions(model.nw))
			]));
};
var $author$project$Pages$StyleGuide$PhoneInput$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v1 = A2($author$project$Components$PhoneInput$update, subMsg, model.bw);
				var updatedPhoneInput = _v1.a;
				var phoneCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bw: updatedPhoneInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg, phoneCmd));
			case 1:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Components$PhoneInput$update, subMsg, model.nx);
				var updatedPhoneInputRequired = _v2.a;
				var phoneCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nx: updatedPhoneInputRequired}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg, phoneCmd));
			case 2:
				var subMsg = msg.a;
				var _v3 = A2($author$project$Components$PhoneInput$update, subMsg, model.nu);
				var updatedPhoneInputOne = _v3.a;
				var phoneCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nu: updatedPhoneInputOne}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg, phoneCmd));
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Components$PhoneInput$update, subMsg, model.nv);
				var updatedPhoneInputOneRequired = _v4.a;
				var phoneCmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nv: updatedPhoneInputOneRequired}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg, phoneCmd));
			default:
				var subMsg = msg.a;
				var _v5 = A2($author$project$Components$PhoneInput$update, subMsg, model.nw);
				var updatedPhoneInputPreloaded = _v5.a;
				var phoneCmd = _v5.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nw: updatedPhoneInputPreloaded}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg, phoneCmd));
		}
	});
var $author$project$Pages$StyleGuide$PhoneInput$viewBody = function (_v0) {
	var phoneInput = _v0.bw;
	var phoneInputPreloaded = _v0.nw;
	var phoneInputRequired = _v0.nx;
	var phoneInputOne = _v0.nu;
	var phoneInputOneRequired = _v0.nv;
	return _List_fromArray(
		[
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Phone Input')
				])),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Default')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg,
			$author$project$Components$PhoneInput$view(phoneInput)),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Default + Preloaded')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg,
			$author$project$Components$PhoneInput$view(phoneInputPreloaded)),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('Required')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg,
			$author$project$Components$PhoneInput$view(phoneInputRequired)),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('One')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg,
			$author$project$Components$PhoneInput$view(phoneInputOne)),
			$author$project$Ui$Typography$heading(
			_List_fromArray(
				[
					$elm$html$Html$text('One + Required')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg,
			$author$project$Components$PhoneInput$view(phoneInputOneRequired))
		]);
};
var $author$project$Pages$StyleGuide$PhoneInput$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$PhoneInput$viewBody(model),
		$G: 'Phone Input'
	};
};
var $author$project$Pages$StyleGuide$PhoneInput$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$PhoneInput$init, ahd: $author$project$Pages$StyleGuide$PhoneInput$subscriptions, aaq: $author$project$Pages$StyleGuide$PhoneInput$update, ahP: $author$project$Pages$StyleGuide$PhoneInput$view});
var $author$project$Pages$StyleGuide$Popover$example = A3(
	$author$project$Ui$Popover$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hover over '),
							A2($author$project$Ui$Icon$view, _List_Nil, 5)
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Popover$heading,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Popover Heading')
				])),
			A2(
			$author$project$Ui$Popover$body,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Popover Body')
				])),
			A2(
			$author$project$Ui$Popover$footer,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Popover Footer')
				]))
		]));
var $author$project$Pages$StyleGuide$Popover$exampleDark = A3(
	$author$project$Ui$Popover$view,
	_List_fromArray(
		[$author$project$Ui$Popover$dark]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Hover over '),
							A2($author$project$Ui$Icon$view, _List_Nil, 5)
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Popover$body,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Popover Body')
				]))
		]));
var $author$project$Pages$StyleGuide$Popover$exampleHistory = A3(
	$author$project$Ui$Popover$view,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('See history ')
						]))
				]))
		]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Popover$body,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Last updated by practice user')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text('06/25/2023 at 15:25 by test@test.com')
						])),
					$author$project$Ui$HorizontalRule$view(
					_List_fromArray(
						[$author$project$Ui$HorizontalRule$thin])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Created by practice')
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textMuted]),
					_List_fromArray(
						[
							$elm$html$Html$text('04/13/2023 at 13:16 via online signup https://member.staging.hint.com/signup?practice=test')
						]))
				]))
		]));
var $author$project$Generated$StyleGuide$Examples$popoverExample = '\n    Popover.view []\n        [ div []\n            [ span []\n                [ text "Hover over "\n                , Icon.view [] Icon.Question\n                ]\n            ]\n        ]\n        [ Popover.heading []\n            [ text "Popover Heading"\n            ]\n        , Popover.body []\n            [ text "Popover Body"\n            ]\n        , Popover.footer []\n            [ text "Popover Footer"\n            ]\n        ]    ';
var $author$project$Generated$StyleGuide$Examples$popoverExampleDark = '\n    Popover.view [ Popover.dark ]\n        [ div []\n            [ span []\n                [ text "Hover over "\n                , Icon.view [] Icon.Question\n                ]\n            ]\n        ]\n        [ Popover.body []\n            [ text "Popover Body"\n            ]\n        ]    ';
var $author$project$Generated$StyleGuide$Examples$popoverExampleHistory = '\n    Popover.view []\n        [ div []\n            [ span []\n                [ text "See history "\n                ]\n            ]\n        ]\n        [ Popover.body []\n            [ Element.view [] [ text "Last updated by practice user" ]\n            , Element.view [ Element.textMuted ] [ text "06/25/2023 at 15:25 by test@test.com" ]\n            , Hr.view [ Hr.thin ]\n            , Element.view [] [ text "Created by practice" ]\n            , Element.view [ Element.textMuted ] [ text "04/13/2023 at 13:16 via online signup https://member.staging.hint.com/signup?practice=test" ]\n            ]\n        ]\n    ';
var $author$project$Pages$StyleGuide$Popover$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Popover')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$popoverExample,
									EG: _List_fromArray(
										[$author$project$Pages$StyleGuide$Popover$example])
								}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('History Popover')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$popoverExampleHistory,
									EG: _List_fromArray(
										[$author$project$Pages$StyleGuide$Popover$exampleHistory])
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Dark Popover')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$popoverExampleDark,
									EG: _List_fromArray(
										[$author$project$Pages$StyleGuide$Popover$exampleDark])
								})
							]))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Popover$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Popover$view);
var $author$project$Ui$ProgressBar$Info = {$: 3};
var $author$project$Ui$ProgressBar$info = $author$project$Ui$ProgressBar$Info;
var $author$project$Pages$StyleGuide$ProgressBar$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Striped')
					])),
				$author$project$Ui$ProgressBar$view(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$striped,
						$author$project$Ui$ProgressBar$width(10)
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Animated')
					])),
				$author$project$Ui$ProgressBar$view(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$striped,
						$author$project$Ui$ProgressBar$animated,
						$author$project$Ui$ProgressBar$width(20)
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Success')
					])),
				$author$project$Ui$ProgressBar$view(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$success,
						$author$project$Ui$ProgressBar$width(30)
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Info')
					])),
				$author$project$Ui$ProgressBar$view(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$info,
						$author$project$Ui$ProgressBar$width(40)
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Danger')
					])),
				$author$project$Ui$ProgressBar$view(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$danger,
						$author$project$Ui$ProgressBar$width(50)
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Warning')
					])),
				$author$project$Ui$ProgressBar$view(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$warning,
						$author$project$Ui$ProgressBar$width(60)
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('With Label')
					])),
				$author$project$Ui$ProgressBar$view(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$width(70.512),
						$author$project$Ui$ProgressBar$showProgress
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Stacked')
					])),
				$author$project$Ui$ProgressBar$stacked(
				_List_fromArray(
					[
						$author$project$Ui$ProgressBar$bar(
						_List_fromArray(
							[
								$author$project$Ui$ProgressBar$striped,
								$author$project$Ui$ProgressBar$animated,
								$author$project$Ui$ProgressBar$success,
								$author$project$Ui$ProgressBar$width(10)
							])),
						$author$project$Ui$ProgressBar$bar(
						_List_fromArray(
							[
								$author$project$Ui$ProgressBar$striped,
								$author$project$Ui$ProgressBar$animated,
								$author$project$Ui$ProgressBar$info,
								$author$project$Ui$ProgressBar$width(30)
							])),
						$author$project$Ui$ProgressBar$bar(
						_List_fromArray(
							[
								$author$project$Ui$ProgressBar$striped,
								$author$project$Ui$ProgressBar$animated,
								$author$project$Ui$ProgressBar$danger,
								$author$project$Ui$ProgressBar$width(60)
							]))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$ProgressBar$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ProgressBar$view);
var $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$ResourceFilter$init = F4(
	function (session, _v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var _v3 = A4(
			$author$project$Components$ResourceFilter$Plan$init,
			apiClient,
			session,
			function (d) {
				return _Utils_update(
					d,
					{
						AS: _List_fromArray(
							[0, 1])
					});
			},
			$elm$core$Basics$identity);
		var planResourceFilter = _v3.a;
		var planResourceFilterCmd = _v3.b;
		var _v4 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, $elm$core$Basics$identity);
		var locationResourceFilter = _v4.a;
		var locationResourceFilterCmd = _v4.b;
		return _Utils_Tuple2(
			{D5: apiClient, aet: $author$project$Components$ResourceFilter$None, rl: locationResourceFilter, GH: $author$project$Components$ResourceFilter$None, jw: planResourceFilter},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg, planResourceFilterCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg, locationResourceFilterCmd)
					])));
	});
var $author$project$Pages$StyleGuide$ResourceFilter$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$ResourceFilter$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$ResourceFilter$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$ResourceFilter$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.D5, subMsg, model.jw);
			var modelAfterEvent = function () {
				var _v1 = planResourceResult.ac5;
				if (!_v1.$) {
					if (!_v1.a.$) {
						var selected = _v1.a.a;
						return _Utils_update(
							model,
							{GH: selected});
					} else {
						var _v2 = _v1.a;
						return model;
					}
				} else {
					return model;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					modelAfterEvent,
					{jw: planResourceResult.y8}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg, planResourceResult.EC),
				planResourceResult.as);
		} else {
			var subMsg = msg.a;
			var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, model.D5, subMsg, model.rl);
			var modelAfterEvent = function () {
				var _v3 = locationResourceResult.ac5;
				if (!_v3.$) {
					if (!_v3.a.$) {
						var selected = _v3.a.a;
						return _Utils_update(
							model,
							{aet: selected});
					} else {
						var _v4 = _v3.a;
						return model;
					}
				} else {
					return model;
				}
			}();
			return _Utils_Tuple3(
				_Utils_update(
					modelAfterEvent,
					{rl: locationResourceResult.y8}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg, locationResourceResult.EC),
				locationResourceResult.as);
		}
	});
var $author$project$Pages$StyleGuide$ResourceFilter$planName = function (choice) {
	switch (choice.$) {
		case 2:
			return 'All';
		case 3:
			return 'None';
		case 0:
			var plan = choice.a;
			return $author$project$Api$Plan$name(plan);
		case 1:
			var plans = choice.a;
			return A2(
				$elm$core$String$join,
				', ',
				A2($elm$core$List$map, $author$project$Api$Plan$name, plans));
		case 4:
			var extraItem = choice.a;
			return extraItem.aej;
		default:
			var string = choice.a;
			return 'Custom: ' + string;
	}
};
var $author$project$Pages$StyleGuide$ResourceFilter$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Resource Filter')
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Plan')
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg,
				A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.jw)),
				$elm$html$Html$text(
				'Plan: ' + $author$project$Pages$StyleGuide$ResourceFilter$planName(model.GH)),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Location')
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg,
				A2($author$project$Components$ResourceFilter$Location$view, _List_Nil, model.rl)),
				$elm$html$Html$text(
				'Location: ' + A2(
					$elm$core$Maybe$withDefault,
					'None',
					$author$project$Components$ResourceFilter$Location$value(model.rl))),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Location (disabled)')
					])),
				A2(
				$elm$html$Html$map,
				$author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg,
				A2(
					$author$project$Components$ResourceFilter$Location$view,
					_List_fromArray(
						[
							$author$project$Components$ResourceFilter$disabled(true)
						]),
					model.rl))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$ResourceFilter$page = $author$project$Spa$Page$applicationPractice(
	{ad0: $author$project$Pages$StyleGuide$ResourceFilter$init, aer: $author$project$Pages$StyleGuide$ResourceFilter$load, agD: $author$project$Pages$StyleGuide$ResourceFilter$save, ahd: $author$project$Pages$StyleGuide$ResourceFilter$subscriptions, aaq: $author$project$Pages$StyleGuide$ResourceFilter$update, ahP: $author$project$Pages$StyleGuide$ResourceFilter$view});
var $author$project$Pages$StyleGuide$SearchInput$urlParams = function (model) {
	var queryParams = _List_fromArray(
		[
			A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$pair('q'),
			model.af_)
		]);
	return $elm$core$Dict$fromList(
		A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
};
var $author$project$Pages$StyleGuide$SearchInput$buildUrl = function (model) {
	return A2(
		$elm$url$Url$Builder$relative,
		_List_fromArray(
			[
				$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$StyleGuide__SearchInput)
			]),
		$author$project$Utils$QueryParameter$fromDict(
			$author$project$Pages$StyleGuide$SearchInput$urlParams(model)));
};
var $author$project$Pages$StyleGuide$SearchInput$GotHeroes = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StyleGuide$SearchInput$Hero = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$SearchInput$heroes = _List_fromArray(
	[
		{adR: '1', zh: 'Batman'},
		{adR: 'spidey', zh: 'Spiderman'},
		{adR: 'drstrange', zh: 'Dr Strange'},
		{adR: '2', zh: 'The Flash'},
		{adR: 'ironman', zh: 'Ironman'}
	]);
var $author$project$Pages$StyleGuide$SearchInput$searchHeroes = function (query) {
	return A2(
		$elm$core$List$filter,
		function (choice) {
			var _v0 = _Utils_Tuple2(query, choice);
			if (!_v0.a.$) {
				var query_ = _v0.a.a;
				var hero = _v0.b;
				return A2($elm$core$String$contains, query_, hero.zh);
			} else {
				return true;
			}
		},
		$author$project$Pages$StyleGuide$SearchInput$heroes);
};
var $author$project$Pages$StyleGuide$SearchInput$fetchHeroes = function (model) {
	return A2(
		$elm$core$Task$perform,
		function (_v0) {
			return $author$project$Pages$StyleGuide$SearchInput$GotHeroes(
				$author$project$Pages$StyleGuide$SearchInput$searchHeroes(model.af_));
		},
		$elm$core$Process$sleep(1500));
};
var $author$project$Pages$StyleGuide$SearchInput$init = F2(
	function (_v0, _v1) {
		var query = _v1.Bi;
		var q = A2($elm$core$Dict$get, 'q', query);
		var model = {
			qO: _List_Nil,
			S_: $author$project$Utils$Maybe$toBool(q),
			af_: q,
			sA: $author$project$Ui$SearchInput$init(q)
		};
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$StyleGuide$SearchInput$fetchHeroes(model),
						A2($elm$core$Basics$composeR, $author$project$Pages$StyleGuide$SearchInput$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
					])),
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$SearchInput$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$SearchInput$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$SearchInput$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$SearchInput$SearchInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$SearchInput$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var subMsg = msg.a;
			var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
			var searchInput = _v1.a;
			var searchInputCmd = _v1.b;
			var searchInputEvent = _v1.c;
			var q = function () {
				if (searchInputEvent.$ === 1) {
					var query = searchInputEvent.a;
					return query;
				} else {
					return model.af_;
				}
			}();
			var _v2 = function () {
				if (_Utils_eq(q, model.af_)) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var qModel = _Utils_update(
						model,
						{S_: true, af_: q});
					return _Utils_Tuple2(
						qModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Pages$StyleGuide$SearchInput$fetchHeroes(qModel),
									A2($elm$core$Basics$composeR, $author$project$Pages$StyleGuide$SearchInput$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
								])));
				}
			}();
			var newModel = _v2.a;
			var cmd = _v2.b;
			return _Utils_Tuple3(
				_Utils_update(
					newModel,
					{sA: searchInput}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$SearchInput$SearchInputMsg, searchInputCmd),
							cmd
						])),
				_List_Nil);
		} else {
			var heroes_ = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{qO: heroes_, S_: false}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$SearchInput$heroToLabel = function (_v0) {
	var hero = _v0;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(hero.zh)
			]));
};
var $author$project$Pages$StyleGuide$SearchInput$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Search Input')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$author$project$Pages$StyleGuide$SearchInput$SearchInputMsg,
								A2(
									$author$project$Ui$SearchInput$view,
									_List_fromArray(
										[
											$author$project$Ui$SearchInput$placeholder('Search for heroes'),
											$author$project$Ui$SearchInput$phi(false),
											$author$project$Ui$SearchInput$loading(model.S_)
										]),
									model.sA))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Search results')
									])),
								$elm$core$List$isEmpty(model.qO) ? $elm$html$Html$text('None') : A2(
								$elm$html$Html$div,
								_List_Nil,
								A2($elm$core$List$map, $author$project$Pages$StyleGuide$SearchInput$heroToLabel, model.qO))
							]))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$SearchInput$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$StyleGuide$SearchInput$init, aer: $author$project$Pages$StyleGuide$SearchInput$load, agD: $author$project$Pages$StyleGuide$SearchInput$save, ahd: $author$project$Pages$StyleGuide$SearchInput$subscriptions, aaq: $author$project$Pages$StyleGuide$SearchInput$update, ahP: $author$project$Pages$StyleGuide$SearchInput$view});
var $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToTitle = function (heroChoice) {
	switch (heroChoice.$) {
		case 0:
			var name = heroChoice.a.zh;
			return name;
		case 1:
			return 'All :)';
		default:
			return 'None :(';
	}
};
var $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToLabel = function (heroChoice) {
	return _List_fromArray(
		[
			$elm$html$Html$text(
			$author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToTitle(heroChoice))
		]);
};
var $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToValue = function (heroChoice) {
	switch (heroChoice.$) {
		case 0:
			var id = heroChoice.a.adR;
			return $elm$core$Maybe$Just(id);
		case 1:
			return $elm$core$Maybe$Just('');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Pages$StyleGuide$SearchableSelect$All = {$: 1};
var $author$project$Pages$StyleGuide$SearchableSelect$Hero = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$SearchableSelect$None = {$: 2};
var $author$project$Pages$StyleGuide$SearchableSelect$heroChoices = _List_fromArray(
	[
		$author$project$Pages$StyleGuide$SearchableSelect$All,
		$author$project$Pages$StyleGuide$SearchableSelect$None,
		$author$project$Pages$StyleGuide$SearchableSelect$Hero(
		{adR: '1', zh: 'Batman'}),
		$author$project$Pages$StyleGuide$SearchableSelect$Hero(
		{adR: 'spidey', zh: 'Spiderman'}),
		$author$project$Pages$StyleGuide$SearchableSelect$Hero(
		{adR: 'drstrange', zh: 'Dr Strange'}),
		$author$project$Pages$StyleGuide$SearchableSelect$Hero(
		{adR: '2', zh: 'The Flash'}),
		$author$project$Pages$StyleGuide$SearchableSelect$Hero(
		{adR: 'ironman', zh: 'Ironman'})
	]);
var $author$project$Pages$StyleGuide$SearchableSelect$init = F2(
	function (_v0, _v1) {
		return _Utils_Tuple3(
			{
				mn: $elm$core$Maybe$Nothing,
				iK: $author$project$Ui$Form$SearchableSelect$init(
					{adR: 'heroes', ahw: $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToLabel, ahA: $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToTitle, g0: $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToValue}),
				qO: $author$project$Pages$StyleGuide$SearchableSelect$heroChoices
			},
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$SearchableSelect$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$SearchableSelect$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$SearchableSelect$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$SearchableSelect$SelectMsg = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$SearchableSelect$searchHeroes = function (query) {
	return A2(
		$elm$core$List$filter,
		function (choice) {
			if (!choice.$) {
				var hero = choice.a;
				return A2($elm$core$String$contains, query, hero.zh);
			} else {
				return true;
			}
		},
		$author$project$Pages$StyleGuide$SearchableSelect$heroChoices);
};
var $author$project$Pages$StyleGuide$SearchableSelect$update = F2(
	function (msg, model) {
		var selectMsg = msg;
		var _v1 = A2($author$project$Ui$Form$SearchableSelect$update, selectMsg, model.iK);
		var selectModel = _v1.a;
		var selectCmd = _v1.b;
		var event = _v1.c;
		var modelAfterEvent = function () {
			_v2$2:
			while (true) {
				if (!event.$) {
					switch (event.a.$) {
						case 0:
							var hero = event.a.a;
							return _Utils_update(
								model,
								{mn: hero});
						case 1:
							var string = event.a.a;
							return _Utils_update(
								model,
								{
									qO: $author$project$Pages$StyleGuide$SearchableSelect$searchHeroes(string)
								});
						default:
							break _v2$2;
					}
				} else {
					break _v2$2;
				}
			}
			return model;
		}();
		return _Utils_Tuple3(
			_Utils_update(
				modelAfterEvent,
				{iK: selectModel}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, selectCmd),
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$SearchableSelect$heroInvalid = function (heroChoice) {
	if ((!heroChoice.$) && (!heroChoice.a.$)) {
		var hero = heroChoice.a.a;
		return hero.adR === 'ironman';
	} else {
		return false;
	}
};
var $author$project$Pages$StyleGuide$SearchableSelect$heroErrors = function (heroChoice) {
	return $author$project$Pages$StyleGuide$SearchableSelect$heroInvalid(heroChoice) ? _List_fromArray(
		['Pick a DC hero']) : _List_Nil;
};
var $author$project$Pages$StyleGuide$SearchableSelect$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Form -> Searchable Select')
					])),
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A3(
					$author$project$Ui$Form$SearchableSelect$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$SearchableSelect$value(model.mn),
							$author$project$Ui$Form$SearchableSelect$invalid(
							$author$project$Pages$StyleGuide$SearchableSelect$heroInvalid(model.mn)),
							$author$project$Ui$Form$SearchableSelect$errors(
							$author$project$Pages$StyleGuide$SearchableSelect$heroErrors(model.mn)),
							$author$project$Ui$Form$SearchableSelect$placeholder('Pick your favorite hero')
						]),
					A2(
						$elm$core$List$map,
						function (heroChoice) {
							return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, heroChoice);
						},
						model.qO),
					model.iK)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A3(
					$author$project$Ui$Form$SearchableSelect$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$SearchableSelect$disabled(true),
							$author$project$Ui$Form$SearchableSelect$placeholder('Disabled')
						]),
					A2(
						$elm$core$List$map,
						function (heroChoice) {
							return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, heroChoice);
						},
						model.qO),
					model.iK)),
				A2($elm$html$Html$br, _List_Nil, _List_Nil),
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$identity,
				A3(
					$author$project$Ui$Form$SearchableSelect$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$SearchableSelect$loading(true),
							$author$project$Ui$Form$SearchableSelect$placeholder('Loading')
						]),
					A2(
						$elm$core$List$map,
						function (heroChoice) {
							return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, heroChoice);
						},
						model.qO),
					model.iK))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$SearchableSelect$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$StyleGuide$SearchableSelect$init, aer: $author$project$Pages$StyleGuide$SearchableSelect$load, agD: $author$project$Pages$StyleGuide$SearchableSelect$save, ahd: $author$project$Pages$StyleGuide$SearchableSelect$subscriptions, aaq: $author$project$Pages$StyleGuide$SearchableSelect$update, ahP: $author$project$Pages$StyleGuide$SearchableSelect$view});
var $author$project$Pages$StyleGuide$Select$init = function (_v0) {
	return _Utils_Tuple2(
		{B3: 'spidey'},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Select$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Select$update = F2(
	function (msg, model) {
		var selectedHero = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{B3: selectedHero}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$Select$HeroSelected = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$Select$heroChoices = _List_fromArray(
	[
		{adR: '1', zh: 'Batman', ky: 'DC'},
		{adR: 'spidey', zh: 'Spiderman', ky: 'Marver'},
		{adR: 'drstrange', zh: 'Dr Strange', ky: 'Marver'},
		{adR: '2', zh: 'The Flash', ky: 'DC'}
	]);
var $author$project$Pages$StyleGuide$Select$heroGroupOptions = function (heroes) {
	return A2(
		$elm$core$List$map,
		function (hero) {
			return A3(
				$author$project$Ui$Form$Select$option,
				_List_Nil,
				$elm$core$Maybe$Just(hero.adR),
				hero.zh);
		},
		heroes);
};
var $author$project$Pages$StyleGuide$Select$heroOptions = function (heroes) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var hero = _v0.a;
			var grouped = _v0.b;
			return A2(
				$author$project$Ui$Form$Select$group,
				hero.ky,
				$author$project$Pages$StyleGuide$Select$heroGroupOptions(
					A2($elm$core$List$cons, hero, grouped)));
		},
		A2(
			$elm_community$list_extra$List$Extra$gatherEqualsBy,
			function ($) {
				return $.ky;
			},
			heroes));
};
var $author$project$Pages$StyleGuide$Select$viewBody = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section')
				]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingLg(
					_List_fromArray(
						[
							$elm$html$Html$text('Form > Select')
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$value(
									$elm$core$Maybe$Just(model.B3)),
									$author$project$Ui$Form$Select$onChange($elm$core$Basics$identity)
								]),
							$author$project$Pages$StyleGuide$Select$heroOptions($author$project$Pages$StyleGuide$Select$heroChoices))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$disabled(true)
								]),
							_List_fromArray(
								[
									A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Disabled')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$loading(true)
								]),
							_List_fromArray(
								[
									A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Loading')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Select$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Select$invalid(true),
									$author$project$Ui$Form$Select$errors(
									_List_fromArray(
										['Some error']))
								]),
							_List_fromArray(
								[
									A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Invalid')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$Select$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$Select$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Select$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Select$init, ahd: $author$project$Pages$StyleGuide$Select$subscriptions, aaq: $author$project$Pages$StyleGuide$Select$update, ahP: $author$project$Pages$StyleGuide$Select$view});
var $author$project$Pages$StyleGuide$Skeleton$init = function (_v0) {
	return {};
};
var $author$project$Pages$StyleGuide$Skeleton$update = F2(
	function (_v0, model) {
		return model;
	});
var $author$project$Pages$StyleGuide$Skeleton$exampleFormGroup = _List_fromArray(
	[
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$labelSkeleton('Papyrus')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$labelSkeleton('Sans')
			]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(_List_Nil)
			])),
		A2(
		$author$project$Ui$Form$Group$view,
		_List_fromArray(
			[
				$author$project$Ui$Form$Group$labelSpan(4),
				$author$project$Ui$Form$Group$inputSpan(8),
				$author$project$Ui$Form$Group$label('')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Static$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$text(
						_List_fromArray(
							[
								$author$project$Ui$Skeleton$span(4)
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleInput = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$spaceBetween]),
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$input(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(8)
					])),
				$author$project$Ui$Skeleton$input(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$span(2)
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleSpan = _List_fromArray(
	[
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(2)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(4)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(6)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(8)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$block,
				$author$project$Ui$Skeleton$span(10)
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[$author$project$Ui$Skeleton$block]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleSpanFromText = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('The sight of such a friendly skeleton fills you with determination.')
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$spanFromText('The sight of such a friendly skeleton fills you with determination.')
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('I can cook spaghetti')
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$spanFromText('I can cook spaghetti')
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Its a beautiful day outside')
			])),
		$author$project$Ui$Skeleton$text(
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$spanFromText('Its a beautiful day outside')
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleTableWithPagination = _List_fromArray(
	[
		A4(
		$author$project$Ui$Table$view,
		_List_fromArray(
			[
				$author$project$Ui$Table$loading(true)
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Header 1')
					])),
				A2(
				$author$project$Ui$Table$header,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Header 2')
					]))
			]),
		_List_Nil,
		_List_Nil),
		$author$project$Ui$Pagination$List$view(
		_List_fromArray(
			[
				$author$project$Ui$Pagination$List$loading(true)
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$exampleText = _List_fromArray(
	[
		A2(
		$elm$html$Html$h1,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(_List_Nil)
			])),
		A2(
		$elm$html$Html$h2,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(_List_Nil)
			])),
		A2(
		$elm$html$Html$h3,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(_List_Nil)
			])),
		A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(_List_Nil)
			]))
	]);
var $author$project$Generated$StyleGuide$Examples$skeletonExampleFormGroup = '\n    [ FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.labelSkeleton "Papyrus"\n        ]\n        [ Skeleton.input []\n        ]\n    , FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.labelSkeleton "Sans"\n        ]\n        [ Skeleton.input []\n        ]\n    , FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.label ""\n        ]\n        [ FormStatic.view [] [ Skeleton.text [ Skeleton.span 4 ] ]\n        ]\n    ]\n    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleInput = '\n    [ Element.view [ Element.spaceBetween ]\n        [ Skeleton.input [ Skeleton.span 8 ]\n        , Skeleton.input [ Skeleton.span 2 ]\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleSpan = '\n    [ Skeleton.text [ Skeleton.block, Skeleton.span 2 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 4 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 6 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 8 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 10 ]\n    , Skeleton.text [ Skeleton.block ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleSpanFromText = '\n    [ Html.div [] [ text "The sight of such a friendly skeleton fills you with determination." ]\n    , Skeleton.text [ Skeleton.spanFromText "The sight of such a friendly skeleton fills you with determination." ]\n    , Html.div [] [ text "I can cook spaghetti" ]\n    , Skeleton.text [ Skeleton.spanFromText "I can cook spaghetti" ]\n    , Html.div [] [ text "Its a beautiful day outside" ]\n    , Skeleton.text [ Skeleton.spanFromText "Its a beautiful day outside" ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleTableWithPagination = '\n    [ Table.view [ Table.loading True ]\n        [ Table.header [] [ text "Header 1" ]\n        , Table.header [] [ text "Header 2" ]\n        ]\n        []\n        []\n    , Pagination.view [ Pagination.loading True ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$skeletonExampleText = '\n    [ Html.h1 [] [ Skeleton.text [] ]\n    , Html.h2 [] [ Skeleton.text [] ]\n    , Html.h3 [] [ Skeleton.text [] ]\n    , Html.p [] [ Skeleton.text [] ]\n    ]    ';
var $author$project$Pages$StyleGuide$Skeleton$viewBody = _List_fromArray(
	[
		A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Panel$title(
						_List_fromArray(
							[
								$elm$html$Html$text('Skeletons')
							]))
					])),
				$author$project$Ui$Panel$hr,
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Skeletons are the main activity indicator.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('They can be used alongside progressive loading techniques to enhance the user experience and reduce the perception of waiting time.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Skeletons are the go to component on first loads or when the data shown is stale and new one being loaded (like on tables).')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('They also look pretty good in my (biased) opinion')
							]))
					]))
			])),
		A2(
		$author$project$Ui$FlexGrid$row,
		_List_fromArray(
			[$author$project$Ui$FlexGrid$mt4]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Text Skeleton'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('The height will adjust based on font size, so they can be used inside headings.')
									]))
							]),
						{K3: $author$project$Generated$StyleGuide$Examples$skeletonExampleText, EG: $author$project$Pages$StyleGuide$Skeleton$exampleText})
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Input Skeleton'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('Buttons count as inputs')
									]))
							]),
						{K3: $author$project$Generated$StyleGuide$Examples$skeletonExampleInput, EG: $author$project$Pages$StyleGuide$Skeleton$exampleInput})
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Input Span'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('Same API as grid, they also support responsive spans (spanSm, spanMd, spanLg)')
									]))
							]),
						{K3: $author$project$Generated$StyleGuide$Examples$skeletonExampleSpan, EG: $author$project$Pages$StyleGuide$Skeleton$exampleSpan})
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Span from Text'),
								$author$project$Components$StyleGuide$Example$description(
								_List_fromArray(
									[
										$elm$html$Html$text('If the text is known beforehand it can be used directly to take the same space')
									]))
							]),
						{K3: $author$project$Generated$StyleGuide$Examples$skeletonExampleSpanFromText, EG: $author$project$Pages$StyleGuide$Skeleton$exampleSpanFromText})
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Table with Pagination')
							]),
						{K3: $author$project$Generated$StyleGuide$Examples$skeletonExampleTableWithPagination, EG: $author$project$Pages$StyleGuide$Skeleton$exampleTableWithPagination})
					])),
				A2(
				$author$project$Ui$FlexGrid$column,
				_List_fromArray(
					[
						$author$project$Ui$FlexGrid$spanMd(6)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Components$StyleGuide$Example$view,
						_List_fromArray(
							[
								$author$project$Components$StyleGuide$Example$title('Form Group')
							]),
						{K3: $author$project$Generated$StyleGuide$Examples$skeletonExampleFormGroup, EG: $author$project$Pages$StyleGuide$Skeleton$exampleFormGroup})
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Skeleton$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$Skeleton$viewBody, $G: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$Skeleton$page = $author$project$Spa$Page$sandbox(
	{ad0: $author$project$Pages$StyleGuide$Skeleton$init, aaq: $author$project$Pages$StyleGuide$Skeleton$update, ahP: $author$project$Pages$StyleGuide$Skeleton$view});
var $author$project$Pages$StyleGuide$SvgIcon$init = function (_v0) {
	return _Utils_Tuple2(
		{hM: '#000'},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$SvgIcon$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$SvgIcon$update = F2(
	function (msg, model) {
		var color = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{hM: color}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$SvgIcon$ColorChanged = $elm$core$Basics$identity;
var $author$project$Ui$SvgIcon$ApiKey = 77;
var $author$project$Ui$SvgIcon$App = 81;
var $author$project$Ui$SvgIcon$BusinessCenter = 90;
var $author$project$Ui$SvgIcon$Contact = 72;
var $author$project$Ui$SvgIcon$Dashboard = 70;
var $author$project$Ui$SvgIcon$Demography = 89;
var $author$project$Ui$SvgIcon$Dev = 91;
var $author$project$Ui$SvgIcon$Favicon = 31;
var $author$project$Ui$SvgIcon$File = 74;
var $author$project$Ui$SvgIcon$Filter = 62;
var $author$project$Ui$SvgIcon$Form = 73;
var $author$project$Ui$SvgIcon$HintHeartFlat = 33;
var $author$project$Ui$SvgIcon$Inbox = 71;
var $author$project$Ui$SvgIcon$Inventory = 75;
var $author$project$Ui$SvgIcon$OnlineSignup = 26;
var $author$project$Ui$SvgIcon$Task = 76;
var $author$project$Ui$SvgIcon$Webhook = 78;
var $author$project$Pages$StyleGuide$SvgIcon$allIcons = _List_fromArray(
	[3, 27, 38, 4, 5, 57, 56, 58, 28, 29, 53, 44, 12, 13, 6, 15, 46, 60, 41, 50, 55, 39, 24, 23, 16, 21, 49, 62, 42, 7, 30, 31, 32, 33, 51, 25, 19, 20, 14, 26, 18, 8, 22, 43, 9, 40, 17, 37, 10, 34, 35, 36, 11, 54, 1, 0, 47, 61, 64, 63, 2, 48, 52, 59, 65, 66, 67, 68, 70, 71, 72, 73, 74, 75, 76, 77, 78, 81, 84, 85, 86, 80, 89, 90, 91, 45]);
var $author$project$Ui$SvgIcon$apiKey = $author$project$Ui$SvgIcon$viewIcon(77);
var $author$project$Ui$SvgIcon$app = $author$project$Ui$SvgIcon$viewIcon(81);
var $author$project$Ui$SvgIcon$Book = 88;
var $author$project$Ui$SvgIcon$book = $author$project$Ui$SvgIcon$viewIcon(88);
var $author$project$Ui$SvgIcon$businessCenter = $author$project$Ui$SvgIcon$viewIcon(90);
var $author$project$Ui$SvgIcon$contact = $author$project$Ui$SvgIcon$viewIcon(72);
var $author$project$Ui$SvgIcon$dashboard = $author$project$Ui$SvgIcon$viewIcon(70);
var $author$project$Ui$SvgIcon$demography = $author$project$Ui$SvgIcon$viewIcon(89);
var $author$project$Ui$SvgIcon$dev = $author$project$Ui$SvgIcon$viewIcon(91);
var $author$project$Ui$SvgIcon$favicon = $author$project$Ui$SvgIcon$viewIcon(31);
var $author$project$Ui$SvgIcon$file = $author$project$Ui$SvgIcon$viewIcon(74);
var $author$project$Ui$SvgIcon$filter = $author$project$Ui$SvgIcon$viewIcon(62);
var $author$project$Ui$SvgIcon$form = $author$project$Ui$SvgIcon$viewIcon(73);
var $author$project$Ui$SvgIcon$Groups = 82;
var $author$project$Ui$SvgIcon$groups = $author$project$Ui$SvgIcon$viewIcon(82);
var $author$project$Ui$SvgIcon$hintHeartFlat = $author$project$Ui$SvgIcon$viewIcon(33);
var $author$project$Ui$SvgIcon$inbox = $author$project$Ui$SvgIcon$viewIcon(71);
var $author$project$Ui$SvgIcon$inventory = $author$project$Ui$SvgIcon$viewIcon(75);
var $author$project$Ui$SvgIcon$Marketplace = 87;
var $author$project$Ui$SvgIcon$marketplace = $author$project$Ui$SvgIcon$viewIcon(87);
var $author$project$Ui$SvgIcon$onlineSignup = $author$project$Ui$SvgIcon$viewIcon(26);
var $author$project$Ui$SvgIcon$Practices = 79;
var $author$project$Ui$SvgIcon$practices = $author$project$Ui$SvgIcon$viewIcon(79);
var $author$project$Ui$SvgIcon$quote = $author$project$Ui$SvgIcon$viewIcon(92);
var $author$project$Ui$SvgIcon$Sandbox = 83;
var $author$project$Ui$SvgIcon$sandbox = $author$project$Ui$SvgIcon$viewIcon(83);
var $author$project$Ui$SvgIcon$scissors = $author$project$Ui$SvgIcon$viewIcon(65);
var $author$project$Ui$SvgIcon$star = $author$project$Ui$SvgIcon$viewIcon(66);
var $author$project$Ui$SvgIcon$starNote = $author$project$Ui$SvgIcon$viewIcon(67);
var $author$project$Ui$SvgIcon$task = $author$project$Ui$SvgIcon$viewIcon(76);
var $author$project$Ui$SvgIcon$webhook = $author$project$Ui$SvgIcon$viewIcon(78);
var $author$project$Pages$StyleGuide$SvgIcon$iconNameToFunctionAndName = function (icon) {
	switch (icon) {
		case 0:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$syncedTo, 'syncedTo');
		case 1:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$syncedFrom, 'syncedFrom');
		case 2:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$unpublishedRuleArrow, 'unpublishedRuleArrow');
		case 3:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$account, 'account');
		case 4:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$admin, 'admin');
		case 6:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$commissions, 'commissions');
		case 7:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$help, 'help');
		case 8:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$patients, 'patients');
		case 9:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$report, 'report');
		case 10:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$share, 'share');
		case 11:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$sponsors, 'sponsors');
		case 12:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$chevron, 'chevron');
		case 13:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$chevronDown, 'chevronDown');
		case 14:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$location, 'location');
		case 15:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$copy, 'copy');
		case 16:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$enter, 'enter');
		case 17:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$selectArrows, 'selectArrows');
		case 18:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$open, 'open');
		case 19:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$kebabMenu, 'kebabMenu');
		case 20:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$launch, 'launch');
		case 21:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$exit, 'exit');
		case 22:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$paymentMethods, 'paymentMethods');
		case 23:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$employees, 'employees');
		case 24:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$employeeUploads, 'employeeUploads');
		case 25:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$invoices, 'invoices');
		case 26:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$onlineSignup, 'onlineSignup');
		case 27:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$accountAndPricing, 'accountPricing');
		case 28:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$burgerMenu, 'burgerMenu');
		case 29:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$burgerMenuClose, 'burgerMenuClose');
		case 31:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$favicon, 'favicon');
		case 32:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$hintHeart, 'hintHeart');
		case 33:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$hintHeartFlat, 'hintHeartFlat');
		case 30:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$hint404, 'hint404');
		case 34:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$sort, 'sort');
		case 35:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$sortDown, 'sortDown');
		case 36:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$sortUp, 'sortUp');
		case 37:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$send, 'send');
		case 38:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$add, 'add');
		case 39:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$edit, 'edit');
		case 40:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$search, 'search');
		case 41:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$delete, 'delete');
		case 42:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$flag, 'flag');
		case 43:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$repeat, 'repeat');
		case 44:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$check, 'check');
		case 46:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$cross, 'cross');
		case 47:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$transfer, 'transfer');
		case 51:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$history, 'history');
		case 48:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$upload, 'upload');
		case 49:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$export, 'export');
		case 50:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$dollar, 'dollar');
		case 52:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$void, 'void');
		case 53:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$calendar, 'calendar');
		case 54:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$stop, 'stop');
		case 55:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$dots, 'dots');
		case 56:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$arrowRight, 'arrowRight');
		case 58:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$arrowRightBottom, 'arrowRightBottom');
		case 57:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$arrowLeft, 'arrowLeft');
		case 59:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$warning, 'warning');
		case 5:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$alert, 'alert');
		case 60:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$crossCircle, 'crossCircle');
		case 61:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$translate, 'translate');
		case 62:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$filter, 'filter');
		case 64:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$trendingDown, 'trendingDown');
		case 63:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$trendingUp, 'trendingUp');
		case 65:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$scissors, 'scissors');
		case 66:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$star, 'star');
		case 67:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$starNote, 'starNote');
		case 68:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$minus, 'minus');
		case 69:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$testConnection, 'testConnection');
		case 70:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$dashboard, 'dashboard');
		case 71:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$inbox, 'inbox');
		case 72:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$contact, 'contact');
		case 73:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$form, 'form');
		case 74:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$file, 'file');
		case 75:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$inventory, 'inventory');
		case 76:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$task, 'task');
		case 77:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$apiKey, 'apiKey');
		case 78:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$webhook, 'webhook');
		case 79:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$practices, 'practices');
		case 81:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$app, 'app');
		case 82:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$groups, 'groups');
		case 83:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$sandbox, 'sandbox');
		case 84:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$package, 'package');
		case 85:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$call, 'call');
		case 86:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$mail, 'mail');
		case 80:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$progressActivity, 'progressActivity');
		case 87:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$marketplace, 'marketplace');
		case 88:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$book, 'book');
		case 89:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$demography, 'demography');
		case 90:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$businessCenter, 'businessCenter');
		case 91:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$dev, 'dev');
		case 92:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$quote, 'quote');
		default:
			return _Utils_Tuple2($author$project$Ui$SvgIcon$circle, 'circle');
	}
};
var $author$project$Pages$StyleGuide$SvgIcon$viewIcon = function (name) {
	var _v0 = $author$project$Pages$StyleGuide$SvgIcon$iconNameToFunctionAndName(name);
	var viewIconFn = _v0.a;
	var functionName = _v0.b;
	return A2(
		$author$project$Ui$FlexGrid$column,
		_List_fromArray(
			[
				$author$project$Ui$FlexGrid$span(3),
				$author$project$Ui$FlexGrid$justifyLeft
			]),
		_List_fromArray(
			[
				viewIconFn(_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-base-color mb-8')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('SVG.' + functionName)
					]))
			]));
};
var $author$project$Pages$StyleGuide$SvgIcon$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('SvgIcon')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mb-4')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('(Make sure when selecting a new color the SVG icon changes accordingly)'),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('color'),
								$elm$html$Html$Events$onInput($elm$core$Basics$identity),
								$elm$html$Html$Attributes$value(model.hM)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Sorts and Hint404 are extent from this ckeck.')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'color', model.hM)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						A2($elm$core$List$map, $author$project$Pages$StyleGuide$SvgIcon$viewIcon, $author$project$Pages$StyleGuide$SvgIcon$allIcons))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$SvgIcon$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$SvgIcon$init, ahd: $author$project$Pages$StyleGuide$SvgIcon$subscriptions, aaq: $author$project$Pages$StyleGuide$SvgIcon$update, ahP: $author$project$Pages$StyleGuide$SvgIcon$view});
var $author$project$Pages$StyleGuide$Table$Id = 0;
var $author$project$Pages$StyleGuide$Table$init = function (_v0) {
	return _Utils_Tuple2(
		{kd: 0, ke: 1},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$StyleGuide$Table$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Table$update = F2(
	function (msg, model) {
		var column = msg;
		var newDirection = function () {
			if (_Utils_eq(model.kd, column)) {
				var _v1 = model.ke;
				if (!_v1) {
					return 1;
				} else {
					return 0;
				}
			} else {
				return 0;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{kd: column, ke: newDirection}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$StyleGuide$Table$Name = 1;
var $author$project$Pages$StyleGuide$Table$Datum = F3(
	function (id, name, ring) {
		return {adR: id, zh: name, YN: ring};
	});
var $author$project$Pages$StyleGuide$Table$data = _List_fromArray(
	[
		A3($author$project$Pages$StyleGuide$Table$Datum, 1, 'Mercury', 'Inner'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 2, 'Venus', 'Inner'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 3, 'Earth', 'Inner'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 4, 'Mars', 'Inner'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 5, 'Jupiter', 'Outer'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 6, 'Saturn', 'Outer'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 7, 'Uranus', 'Outer'),
		A3($author$project$Pages$StyleGuide$Table$Datum, 8, 'Neptune', 'Outer')
	]);
var $author$project$Pages$StyleGuide$Table$sort = F3(
	function (column, direction, data_) {
		return function () {
			if (!direction) {
				return $elm$core$List$reverse;
			} else {
				return $elm$core$Basics$identity;
			}
		}()(
			A2(
				$elm$core$List$sortWith,
				F2(
					function (one, other) {
						if (!column) {
							return A2($elm$core$Basics$compare, one.adR, other.adR);
						} else {
							return A2($elm$core$Basics$compare, one.zh, other.zh);
						}
					}),
				data_));
	});
var $author$project$Pages$StyleGuide$Table$SortTable = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$Table$sortableHeaderAttributes = F3(
	function (sortColumn, sortDirection, column) {
		var columnSort = _Utils_eq(column, sortColumn) ? _List_fromArray(
			[
				$author$project$Ui$Table$sortDirection(sortDirection)
			]) : _List_Nil;
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$author$project$Ui$Table$onClick(column),
						$author$project$Ui$Table$sortable(true)
					]),
					columnSort
				]));
	});
var $author$project$Ui$Table$Active = 0;
var $author$project$Pages$StyleGuide$Table$viewTableRow = function (_v0) {
	var id = _v0.adR;
	var name = _v0.zh;
	var ring = _v0.YN;
	var options = function () {
		switch (id) {
			case 1:
				return _List_fromArray(
					[
						$author$project$Ui$Table$styled(1)
					]);
			case 2:
				return _List_fromArray(
					[
						$author$project$Ui$Table$styled(0)
					]);
			case 3:
				return _List_fromArray(
					[
						$author$project$Ui$Table$styled(2)
					]);
			case 4:
				return _List_fromArray(
					[
						$author$project$Ui$Table$styled(3)
					]);
			case 5:
				return _List_fromArray(
					[
						$author$project$Ui$Table$styled(4)
					]);
			default:
				return _List_Nil;
		}
	}();
	return A2(
		$author$project$Ui$Table$row,
		options,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$elm$core$String$fromInt(id))
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				A2(
				$author$project$Ui$Table$cell,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(ring)
					]))
			]));
};
var $author$project$Pages$StyleGuide$Table$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Table')
					])),
				A4(
				$author$project$Ui$Table$view,
				_List_fromArray(
					[$author$project$Ui$Table$striped, $author$project$Ui$Table$bordered]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						A3($author$project$Pages$StyleGuide$Table$sortableHeaderAttributes, model.kd, model.ke, 0),
						_List_fromArray(
							[
								$elm$html$Html$text('Id')
							])),
						A2(
						$author$project$Ui$Table$header,
						A3($author$project$Pages$StyleGuide$Table$sortableHeaderAttributes, model.kd, model.ke, 1),
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							])),
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Ring')
							]))
					]),
				A2(
					$elm$core$List$map,
					$author$project$Pages$StyleGuide$Table$viewTableRow,
					A3($author$project$Pages$StyleGuide$Table$sort, model.kd, model.ke, $author$project$Pages$StyleGuide$Table$data)),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Some')
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Footer')
									]))
							]))
					])),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Zero State')
					])),
				A4(
				$author$project$Ui$Table$view,
				_List_fromArray(
					[
						$author$project$Ui$Table$zeroState(
						_List_fromArray(
							[
								$elm$html$Html$text('You don\'t have any data for the time period and filters selected.')
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							]))
					]),
				_List_Nil,
				_List_Nil),
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$elm$html$Html$text('Loading')
					])),
				A4(
				$author$project$Ui$Table$view,
				_List_fromArray(
					[
						$author$project$Ui$Table$loading(true)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$header,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Name')
							]))
					]),
				_List_Nil,
				_List_Nil)
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Table$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Table$init, ahd: $author$project$Pages$StyleGuide$Table$subscriptions, aaq: $author$project$Pages$StyleGuide$Table$update, ahP: $author$project$Pages$StyleGuide$Table$view});
var $author$project$Pages$StyleGuide$Tabs$TabMsg = $elm$core$Basics$identity;
var $author$project$Ui$Tabs$NavMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Tabs$Tabs = $elm$core$Basics$identity;
var $author$project$Ui$Tabs$init = F2(
	function (id, activeId) {
		var _v0 = A2($author$project$Ui$Nav$init, id + '-nav', $author$project$Ui$Tabs$NavMsg);
		var nav = _v0.a;
		var navCmd = _v0.b;
		return _Utils_Tuple2(
			{pj: activeId, adR: id, m8: nav},
			navCmd);
	});
var $author$project$Pages$StyleGuide$Tabs$init = function (_v0) {
	var _v1 = A2($author$project$Ui$Tabs$init, 'tabs', 'pat-1');
	var tabsModel = _v1.a;
	var tabsCmd = _v1.b;
	return _Utils_Tuple2(
		tabsModel,
		A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, tabsCmd));
};
var $author$project$Pages$StyleGuide$Tabs$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Ui$Tabs$TabSwitched = $elm$core$Basics$identity;
var $author$project$Ui$Tabs$update = F2(
	function (msg, _v0) {
		var model = _v0;
		if (!msg.$) {
			var navMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$fromTuple2,
				$elm$core$Maybe$Nothing,
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Ui$Tabs$NavMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (nav) {
							return _Utils_update(
								model,
								{m8: nav});
						},
						A2($author$project$Ui$Nav$update, navMsg, model.m8))));
		} else {
			var _v2 = msg.a;
			var tabItem = _v2.a;
			var toId = _v2.b.ahv;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						pj: toId(tabItem)
					}),
				$elm$core$Platform$Cmd$none,
				$elm$core$Maybe$Just(tabItem));
		}
	});
var $author$project$Pages$StyleGuide$Tabs$update = F2(
	function (msg, tabs) {
		var tabMsg = msg;
		var _v1 = A2($author$project$Ui$Tabs$update, tabMsg, tabs);
		var tabModel = _v1.a;
		var tabsCmd = _v1.b;
		return _Utils_Tuple2(
			tabModel,
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, tabsCmd));
	});
var $author$project$Ui$Tabs$mapActive = F3(
	function (toPane, _v0, tabItems) {
		var activeId = _v0.pj;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text('Tab NotFound'),
			A2(
				$elm$core$Maybe$map,
				function (_v2) {
					var a = _v2.a;
					return toPane(a);
				},
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var a = _v1.a;
							var toId = _v1.b.ahv;
							return _Utils_eq(
								toId(a),
								activeId);
						},
						tabItems))));
	});
var $author$project$Ui$Tabs$TabItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$Tabs$item = $author$project$Ui$Tabs$TabItem;
var $author$project$Pages$StyleGuide$Tabs$toTab = function (_v0) {
	var name = _v0.zh;
	var age = _v0.IK;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-main')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						' (' + ($elm$core$String$fromInt(age) + ' y/o)'))
					]))
			]));
};
var $author$project$Pages$StyleGuide$Tabs$memberToTabItem = function (member) {
	return A2(
		$author$project$Ui$Tabs$item,
		member,
		{
			d: $elm$core$Maybe$Nothing,
			ahv: function ($) {
				return $.adR;
			},
			ahz: $author$project$Pages$StyleGuide$Tabs$toTab
		});
};
var $author$project$Pages$StyleGuide$Tabs$members = _List_fromArray(
	[
		{IK: 30, adR: 'pat-1', zh: 'Brandon'},
		{IK: 31, adR: 'pat-2', zh: 'Jessy'},
		{IK: 10, adR: 'pat-3', zh: 'Philip'},
		{IK: 7, adR: 'pat-4', zh: 'Sofia'}
	]);
var $author$project$Pages$StyleGuide$Tabs$toPane = function (_v0) {
	var id = _v0.adR;
	var name = _v0.zh;
	var age = _v0.IK;
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('id: ' + id)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('name: ' + name)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'age: ' + $elm$core$String$fromInt(age))
									]))
							]))
					]))
			]));
};
var $author$project$Ui$Tabs$TabClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Nav$Route = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Nav$route = $author$project$Ui$Nav$Route;
var $author$project$Ui$Tabs$viewTab = F2(
	function (activeId, tabItem) {
		var tabItem_ = tabItem.a;
		var toTab = tabItem.b.ahz;
		var toId = tabItem.b.ahv;
		var route = tabItem.b.d;
		var id = toId(tabItem_);
		return A2(
			$author$project$Ui$Nav$item,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Nav$itemId(id),
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Nav$activeItem(
						_Utils_eq(activeId, id)),
					A2(
						$elm$core$List$cons,
						$author$project$Ui$Nav$onItemClick(
							$author$project$Ui$Tabs$TabClicked(tabItem)),
						A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Ui$Nav$route, $elm$core$List$singleton),
								route))))),
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					toTab(tabItem_))));
	});
var $author$project$Ui$Tabs$view = F2(
	function (_v0, tabItems) {
		var activeId = _v0.pj;
		var nav = _v0.m8;
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Ui$Tabs$viewTab(activeId),
				tabItems),
			nav);
	});
var $author$project$Pages$StyleGuide$Tabs$viewBody = function (tabs) {
	var memberTabs = A2($elm$core$List$map, $author$project$Pages$StyleGuide$Tabs$memberToTabItem, $author$project$Pages$StyleGuide$Tabs$members);
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$map,
			$elm$core$Basics$identity,
			A2($author$project$Ui$Tabs$view, tabs, memberTabs)),
			A3($author$project$Ui$Tabs$mapActive, $author$project$Pages$StyleGuide$Tabs$toPane, tabs, memberTabs)
		]);
};
var $author$project$Pages$StyleGuide$Tabs$view = function (model) {
	return {
		e5: $author$project$Pages$StyleGuide$Tabs$viewBody(model),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Tabs$page = $author$project$Spa$Page$element(
	{ad0: $author$project$Pages$StyleGuide$Tabs$init, ahd: $author$project$Pages$StyleGuide$Tabs$subscriptions, aaq: $author$project$Pages$StyleGuide$Tabs$update, ahP: $author$project$Pages$StyleGuide$Tabs$view});
var $author$project$Pages$StyleGuide$Toast$init = F2(
	function (_v0, _v1) {
		return _Utils_Tuple3(
			{},
			$elm$core$Platform$Cmd$none,
			_List_Nil);
	});
var $author$project$Pages$StyleGuide$Toast$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$Toast$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$Toast$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$StyleGuide$Toast$update = F2(
	function (msg, model) {
		var level = msg.a;
		var message = msg.b;
		return _Utils_Tuple3(
			model,
			$elm$core$Platform$Cmd$none,
			_List_fromArray(
				[
					A2($author$project$OutMsg$ShowToast, level, message)
				]));
	});
var $author$project$Pages$StyleGuide$Toast$ShowToast = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$StyleGuide$Toast$viewBody = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Show info toast'},
				_List_fromArray(
					[
						$author$project$Ui$Button$primary,
						$author$project$Ui$Button$onClick(
						A2($author$project$Pages$StyleGuide$Toast$ShowToast, 0, 'Lots of info'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Info')
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Show success toast'},
				_List_fromArray(
					[
						$author$project$Ui$Button$success,
						$author$project$Ui$Button$onClick(
						A2($author$project$Pages$StyleGuide$Toast$ShowToast, 3, 'Wohoo'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Success')
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Show error toast'},
				_List_fromArray(
					[
						$author$project$Ui$Button$danger,
						$author$project$Ui$Button$onClick(
						A2($author$project$Pages$StyleGuide$Toast$ShowToast, 1, 'Oopsie Daisy!'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Error')
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Show warning toast'},
				_List_fromArray(
					[
						$author$project$Ui$Button$styled(4),
						$author$project$Ui$Button$onClick(
						A2($author$project$Pages$StyleGuide$Toast$ShowToast, 2, 'Halt!'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Warning')
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Toast$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$Toast$viewBody, $G: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$Toast$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$StyleGuide$Toast$init, aer: $author$project$Pages$StyleGuide$Toast$load, agD: $author$project$Pages$StyleGuide$Toast$save, ahd: $author$project$Pages$StyleGuide$Toast$subscriptions, aaq: $author$project$Pages$StyleGuide$Toast$update, ahP: $author$project$Pages$StyleGuide$Toast$view});
var $author$project$Pages$StyleGuide$ToggleSwitch$init = function (_v0) {
	return {kw: true};
};
var $author$project$Pages$StyleGuide$ToggleSwitch$update = F2(
	function (msg, model) {
		var bool = msg;
		return _Utils_update(
			model,
			{kw: bool});
	});
var $author$project$Pages$StyleGuide$ToggleSwitch$ToggleSwitchChanged = $elm$core$Basics$identity;
var $author$project$Pages$StyleGuide$ToggleSwitch$example = function (value) {
	return _List_fromArray(
		[
			$author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(value),
					$author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
				]))
		]);
};
var $author$project$Pages$StyleGuide$ToggleSwitch$exampleDisabled = function (value) {
	return _List_fromArray(
		[
			$author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(value),
					$author$project$Ui$ToggleSwitch$disabled(true),
					$author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
				]))
		]);
};
var $author$project$Pages$StyleGuide$ToggleSwitch$exampleSmall = function (value) {
	return _List_fromArray(
		[
			$author$project$Ui$ToggleSwitch$view(
			_List_fromArray(
				[
					$author$project$Ui$ToggleSwitch$on(value),
					$author$project$Ui$ToggleSwitch$sm,
					$author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
				]))
		]);
};
var $author$project$Generated$StyleGuide$Examples$toggleSwitchExample = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleDisabled = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.disabled True\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]    ';
var $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleSmall = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.sm\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]\n    ';
var $author$project$Pages$StyleGuide$ToggleSwitch$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title(
										'Toggle Switch: ' + (model.kw ? 'True' : 'False'))
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$toggleSwitchExample,
									EG: $author$project$Pages$StyleGuide$ToggleSwitch$example(model.kw)
								}),
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Small')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleSmall,
									EG: $author$project$Pages$StyleGuide$ToggleSwitch$exampleSmall(model.kw)
								})
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(6)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Components$StyleGuide$Example$view,
								_List_fromArray(
									[
										$author$project$Components$StyleGuide$Example$title('Disabled')
									]),
								{
									K3: $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleDisabled,
									EG: $author$project$Pages$StyleGuide$ToggleSwitch$exampleDisabled(model.kw)
								})
							]))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$ToggleSwitch$page = $author$project$Spa$Page$sandbox(
	{ad0: $author$project$Pages$StyleGuide$ToggleSwitch$init, aaq: $author$project$Pages$StyleGuide$ToggleSwitch$update, ahP: $author$project$Pages$StyleGuide$ToggleSwitch$view});
var $author$project$Pages$StyleGuide$Tooltip$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Tooltip')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_Nil,
						'Thanks for hovering! I\'m a tooltip',
						_List_fromArray(
							[
								$elm$html$Html$text('TOP: Hover over me!')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(3)
							]),
						'Thanks for hovering! I\'m a tooltip',
						_List_fromArray(
							[
								$elm$html$Html$text('RIGHT: Hover over me!')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(1)
							]),
						'Thanks for hovering! I\'m a tooltip',
						_List_fromArray(
							[
								$elm$html$Html$text('BOTTOM: Hover over me!')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(2)
							]),
						'Thanks for hovering! I\'m a tooltip',
						_List_fromArray(
							[
								$elm$html$Html$text('LEFT: Hover over me!')
							]))
					]))
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Tooltip$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Tooltip$view);
var $author$project$Pages$StyleGuide$Top$view = function (_v0) {
	return {
		e5: _List_fromArray(
			[
				$elm$html$Html$text('StyleGuide')
			]),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$Top$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Top$view);
var $author$project$Ui$OverflowWrap$Anywhere = 2;
var $author$project$Ui$OverflowWrap$anywhere = 2;
var $author$project$Pages$StyleGuide$Typography$loremIpsum = 'Lorem ipsum dolor sit amet, Antidisestablishmentarianism adipiscing elit.';
var $author$project$Ui$OverflowWrap$Normal = 1;
var $author$project$Ui$OverflowWrap$normal = 1;
var $author$project$Pages$StyleGuide$Typography$viewBody = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Headings')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$elm$html$Html$text('Base Title')
							])),
						$author$project$Ui$Typography$headingSm(
						_List_fromArray(
							[
								$elm$html$Html$text('Small Title')
							]))
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Type')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('mt-4')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Normal text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$muted]),
						_List_fromArray(
							[
								$elm$html$Html$text('Muted text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$gray]),
						_List_fromArray(
							[
								$elm$html$Html$text('Gray text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$primary]),
						_List_fromArray(
							[
								$elm$html$Html$text('Primary text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$success]),
						_List_fromArray(
							[
								$elm$html$Html$text('Success text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$info]),
						_List_fromArray(
							[
								$elm$html$Html$text('Info text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$warning]),
						_List_fromArray(
							[
								$elm$html$Html$text('Warning text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$danger]),
						_List_fromArray(
							[
								$elm$html$Html$text('Danger text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$underline]),
						_List_fromArray(
							[
								$elm$html$Html$text('Underline text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[$author$project$Ui$Typography$strike]),
						_List_fromArray(
							[
								$elm$html$Html$text('Strike text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Left text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Center text')
							])),
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Right text')
							]))
					]))
			])),
		A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Typography$headingLg(
				_List_fromArray(
					[
						$elm$html$Html$text('Word wrap')
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(12)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Break Word')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Pages$StyleGuide$Typography$loremIpsum)
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(12)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Anywhere')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$anywhere)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Pages$StyleGuide$Typography$loremIpsum)
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(12)
							]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Normal')
									]))
							])),
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanSm(1)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[
										$author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$normal)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Pages$StyleGuide$Typography$loremIpsum)
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$StyleGuide$Typography$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$Typography$viewBody, $G: 'Typography'};
};
var $author$project$Pages$StyleGuide$Typography$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Typography$view);
var $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$UploadForm$WithSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$UploadForm$WithoutSession = {$: 1};
var $author$project$Ui$DropdownMenu$Model = $elm$core$Basics$identity;
var $author$project$Ui$DropdownMenu$init = function (id) {
	return {adR: id, U9: false};
};
var $author$project$Pages$StyleGuide$UploadForm$init = F2(
	function (shared, _v0) {
		var _v1 = shared.ZD;
		if (_v1.$ === 3) {
			var _v2 = A4($author$project$Components$Upload$Form$init, shared.Hy, shared.D5, 0, $elm$core$Maybe$Nothing);
			var uploadForm = _v2.a;
			var uploadFormCmd = _v2.b;
			return _Utils_Tuple3(
				$author$project$Pages$StyleGuide$UploadForm$WithSession(
					{
						D5: shared.D5,
						ff: '',
						lV: $author$project$Ui$DropdownMenu$init('resource-dropdown-menu'),
						G0: 0,
						Hy: shared.Hy,
						g9: $elm$core$Maybe$Just(uploadForm)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, uploadFormCmd),
				_List_Nil);
		} else {
			return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadForm$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$UploadForm$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$UploadForm$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$UploadForm$DropdownMenuMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$DropdownMenu$Close = {$: 3};
var $author$project$Ui$DropdownMenu$subscriptions = function (_v0) {
	var model = _v0;
	return A2($author$project$Utils$Dom$onOutsideMouseDown, $author$project$Ui$DropdownMenu$Close, model.adR);
};
var $author$project$Pages$StyleGuide$UploadForm$subscriptions = function (model) {
	if (!model.$) {
		var withSessionModel = model.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Pages$StyleGuide$UploadForm$DropdownMenuMsg,
					$author$project$Ui$DropdownMenu$subscriptions(withSessionModel.lV)),
					function () {
					var _v1 = withSessionModel.g9;
					if (!_v1.$) {
						var uploadForm = _v1.a;
						return A2(
							$elm$core$Platform$Sub$map,
							$author$project$Pages$StyleGuide$UploadForm$UploadFormMsg,
							$author$project$Components$Upload$Form$subscriptions(uploadForm));
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}()
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Ui$DropdownMenu$None = {$: 0};
var $author$project$Ui$DropdownMenu$OuterMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$DropdownMenu$outerMsgToEvent = function (maybeOuterMsg) {
	if (!maybeOuterMsg.$) {
		var outerMsg = maybeOuterMsg.a;
		return $author$project$Ui$DropdownMenu$OuterMsg(outerMsg);
	} else {
		return $author$project$Ui$DropdownMenu$None;
	}
};
var $author$project$Ui$DropdownMenu$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: !model.U9}),
					$author$project$Ui$DropdownMenu$None);
			case 1:
				var maybeOuterMsg = msg.a;
				var close = msg.b;
				var event = $author$project$Ui$DropdownMenu$outerMsgToEvent(maybeOuterMsg);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: !close}),
					event);
			case 2:
				var maybeOuterMsg = msg.a;
				var event = $author$project$Ui$DropdownMenu$outerMsgToEvent(maybeOuterMsg);
				return _Utils_Tuple2(model, event);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{U9: false}),
					$author$project$Ui$DropdownMenu$None);
		}
	});
var $author$project$Pages$StyleGuide$UploadForm$update = F2(
	function (msg, model) {
		update:
		while (true) {
			if (model.$ === 1) {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
			} else {
				var modelRecord = model.a;
				switch (msg.$) {
					case 0:
						var subMsg = msg.a;
						var _v2 = modelRecord.g9;
						if (!_v2.$) {
							var uploadForm = _v2.a;
							var _v3 = A3($author$project$Components$Upload$Form$update, modelRecord.D5, subMsg, uploadForm);
							var uploadForm_ = _v3.a;
							var subCmd = _v3.b;
							var subOutMsgs = _v3.c;
							return _Utils_Tuple3(
								$author$project$Pages$StyleGuide$UploadForm$WithSession(
									_Utils_update(
										modelRecord,
										{
											g9: $elm$core$Maybe$Just(uploadForm_)
										})),
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, subCmd),
								subOutMsgs);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
						}
					case 1:
						var subMsg = msg.a;
						var _v4 = A2($author$project$Ui$DropdownMenu$update, subMsg, modelRecord.lV);
						var dropdownMenu = _v4.a;
						var dropdownMenuEvent = _v4.b;
						var modelWithDropdownMenu = $author$project$Pages$StyleGuide$UploadForm$WithSession(
							_Utils_update(
								modelRecord,
								{lV: dropdownMenu}));
						if (dropdownMenuEvent.$ === 1) {
							var newMsg = dropdownMenuEvent.a;
							var $temp$msg = newMsg,
								$temp$model = modelWithDropdownMenu;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							return _Utils_Tuple3(modelWithDropdownMenu, $elm$core$Platform$Cmd$none, _List_Nil);
						}
					default:
						var resource = msg.a;
						var _v6 = A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Pages$StyleGuide$UploadForm$UploadFormMsg),
							A2(
								$elm$core$Tuple$mapFirst,
								$elm$core$Maybe$Just,
								A4($author$project$Components$Upload$Form$init, modelRecord.Hy, modelRecord.D5, resource, $elm$core$Maybe$Nothing)));
						var uploadForm = _v6.a;
						var uploadFormCmd = _v6.b;
						return _Utils_Tuple3(
							$author$project$Pages$StyleGuide$UploadForm$WithSession(
								_Utils_update(
									modelRecord,
									{G0: resource, g9: uploadForm})),
							uploadFormCmd,
							_List_Nil);
				}
			}
		}
	});
var $author$project$Pages$StyleGuide$UploadForm$ResourceSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$DropdownMenu$Item = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$DropdownMenu$item = F2(
	function (options, contents) {
		return A2($author$project$Ui$DropdownMenu$Item, options, contents);
	});
var $author$project$Ui$DropdownMenu$ItemActive = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$DropdownMenu$itemActive = $author$project$Ui$DropdownMenu$ItemActive;
var $author$project$Ui$DropdownMenu$ItemOnClick = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$DropdownMenu$itemOnClick = $author$project$Ui$DropdownMenu$ItemOnClick;
var $author$project$Pages$StyleGuide$UploadForm$dropdownMenuItem = F2(
	function (currentResource, resource) {
		return A2(
			$author$project$Ui$DropdownMenu$item,
			_List_fromArray(
				[
					$author$project$Ui$DropdownMenu$itemActive(
					_Utils_eq(currentResource, resource)),
					$author$project$Ui$DropdownMenu$itemOnClick(
					$author$project$Pages$StyleGuide$UploadForm$ResourceSelected(resource))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Upload$Resource$toString(resource))
				]));
	});
var $author$project$Pages$StyleGuide$UploadForm$dropdownMenuItems = function (resource) {
	return A2(
		$elm$core$List$map,
		$author$project$Pages$StyleGuide$UploadForm$dropdownMenuItem(resource),
		_List_fromArray(
			[0, 1, 2, 3, 5]));
};
var $author$project$Ui$DropdownMenu$Title = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$DropdownMenu$title = $author$project$Ui$DropdownMenu$Title;
var $author$project$Ui$DropdownMenu$InputClicked = {$: 0};
var $author$project$Ui$DropdownMenu$directionClass = function (direction_) {
	if (!direction_) {
		return 'dropup';
	} else {
		return 'dropdown';
	}
};
var $author$project$Ui$Button$DropdownToggle = {$: 15};
var $author$project$Ui$Button$dropdownToggle = $author$project$Ui$Button$DropdownToggle;
var $author$project$Ui$DropdownMenu$intToPx = function (pixels) {
	return $elm$core$String$fromInt(pixels) + 'px';
};
var $author$project$Ui$DropdownMenu$menuOffsetHorzStyle = function (side_) {
	return 'margin-' + function () {
		if (!side_) {
			return 'right';
		} else {
			return 'left';
		}
	}();
};
var $author$project$Ui$DropdownMenu$menuOffsetHorzAttr = function (_v0) {
	var side_ = _v0.a;
	var amount = _v0.b;
	return (!amount) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$style,
			$author$project$Ui$DropdownMenu$menuOffsetHorzStyle(side_),
			$author$project$Ui$DropdownMenu$intToPx(amount))
		]);
};
var $author$project$Ui$DropdownMenu$menuOffsetVertStyle = function (dir_) {
	return 'margin-' + function () {
		if (!dir_) {
			return 'bottom';
		} else {
			return 'top';
		}
	}();
};
var $author$project$Ui$DropdownMenu$menuOffsetVertAttr = function (_v0) {
	var dir_ = _v0.a;
	var amount = _v0.b;
	return (!amount) ? _List_Nil : _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$style,
			$author$project$Ui$DropdownMenu$menuOffsetVertStyle(dir_),
			$author$project$Ui$DropdownMenu$intToPx(amount))
		]);
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$DropdownMenu$Caret = 0;
var $author$project$Ui$DropdownMenu$Down = 1;
var $author$project$Ui$DropdownMenu$Left = 0;
var $author$project$Ui$DropdownMenu$Up = 0;
var $author$project$Ui$DropdownMenu$defaultOptions = {
	vt: 0,
	xb: 1,
	dW: false,
	xH: false,
	Fp: false,
	x7: false,
	S_: false,
	yH: 25,
	yT: _Utils_Tuple2(0, 0),
	yU: _Utils_Tuple2(0, 0),
	yV: '',
	sh: 0,
	Ck: 0,
	ag_: 1,
	s_: 0,
	$G: _List_fromArray(
		[
			$elm$html$Html$text('')
		])
};
var $author$project$Ui$DropdownMenu$optionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 2:
						var string = option.a;
						return _Utils_update(
							record,
							{$G: string});
					case 0:
						var direction_ = option.a;
						return _Utils_update(
							record,
							{xb: direction_});
					case 1:
						var side_ = option.a;
						return _Utils_update(
							record,
							{Ck: side_});
					case 3:
						var style_ = option.a;
						return _Utils_update(
							record,
							{s_: style_});
					case 4:
						var size_ = option.a;
						return _Utils_update(
							record,
							{ag_: size_});
					case 5:
						var bool = option.a;
						return _Utils_update(
							record,
							{dW: bool});
					case 7:
						return _Utils_update(
							record,
							{Fp: true});
					case 6:
						var bool = option.a;
						return _Utils_update(
							record,
							{S_: bool});
					case 8:
						var side_ = option.a;
						return _Utils_update(
							record,
							{sh: side_});
					case 9:
						return _Utils_update(
							record,
							{x7: true});
					case 10:
						var margin_ = option.a;
						return _Utils_update(
							record,
							{yH: margin_});
					case 11:
						var arrow_ = option.a;
						return _Utils_update(
							record,
							{vt: arrow_});
					case 12:
						var side_ = option.a;
						var amount = option.b;
						return _Utils_update(
							record,
							{
								yT: _Utils_Tuple2(side_, amount)
							});
					case 13:
						var dir_ = option.a;
						var amount = option.b;
						return _Utils_update(
							record,
							{
								yU: _Utils_Tuple2(dir_, amount)
							});
					case 14:
						var title_ = option.a;
						return _Utils_update(
							record,
							{yV: title_});
					default:
						return _Utils_update(
							record,
							{xH: true});
				}
			}),
		$author$project$Ui$DropdownMenu$defaultOptions,
		options);
};
var $author$project$Ui$SvgIcon$Rotated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$SvgIcon$rotate = $author$project$Ui$SvgIcon$Rotated;
var $author$project$Ui$DropdownMenu$sideClass = function (side_) {
	if (side_ === 1) {
		return 'dropdown-menu-right';
	} else {
		return 'dropdown-menu-left';
	}
};
var $author$project$Ui$DropdownMenu$ItemChecked = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Ui$DropdownMenu$checkboxAttributes = function (options) {
	return _List_fromArray(
		[
			$elm$html$Html$Events$onCheck(
			$author$project$Ui$DropdownMenu$ItemChecked(options.zH)),
			$elm$html$Html$Attributes$class('clickable')
		]);
};
var $author$project$Ui$DropdownMenu$defaultCheckboxOptions = {zH: $elm$core$Maybe$Nothing};
var $author$project$Ui$DropdownMenu$checkboxOptionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				var msg = option;
				return _Utils_update(
					record,
					{
						zH: $elm$core$Maybe$Just(msg)
					});
			}),
		$author$project$Ui$DropdownMenu$defaultCheckboxOptions,
		options);
};
var $author$project$Ui$DropdownMenu$ItemClicked = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Ui$DropdownMenu$itemAttributes = function (options) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				options.dW ? _List_Nil : _List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$Ui$DropdownMenu$ItemClicked, options.zI, options.vy)),
					$elm$html$Html$Attributes$class('clickable')
				]),
				_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('active', options.Ic),
							_Utils_Tuple2('disabled', options.dW)
						]))
				])
			]));
};
var $author$project$Ui$DropdownMenu$defaultItemOptions = {Ic: false, vy: true, dW: false, zI: $elm$core$Maybe$Nothing};
var $author$project$Ui$DropdownMenu$itemOptionsToRecord = function (options) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (option, record) {
				switch (option.$) {
					case 0:
						var msg = option.a;
						return _Utils_update(
							record,
							{
								zI: $elm$core$Maybe$Just(msg)
							});
					case 1:
						var bool = option.a;
						return _Utils_update(
							record,
							{dW: bool});
					case 2:
						var bool = option.a;
						return _Utils_update(
							record,
							{Ic: bool});
					default:
						var bool = option.a;
						return _Utils_update(
							record,
							{vy: bool});
				}
			}),
		$author$project$Ui$DropdownMenu$defaultItemOptions,
		options);
};
var $author$project$Ui$DropdownMenu$viewItem = function (item_) {
	switch (item_.$) {
		case 0:
			var options = item_.a;
			var contents = item_.b;
			var optionsRecord = $author$project$Ui$DropdownMenu$itemOptionsToRecord(options);
			return A2(
				$elm$html$Html$li,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('dropdown-menu__item'),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
						$author$project$Ui$DropdownMenu$itemAttributes(optionsRecord))),
				_List_fromArray(
					[
						A2($elm$html$Html$span, _List_Nil, contents)
					]));
		case 1:
			var contents = item_.a;
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-header')
					]),
				contents);
		case 2:
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'role', 'separator'),
						$elm$html$Html$Attributes$class('divider')
					]),
				_List_Nil);
		case 3:
			var options = item_.a;
			var contents = item_.b;
			var optionsRecord = $author$project$Ui$DropdownMenu$checkboxOptionsToRecord(options);
			return A2(
				$elm$html$Html$li,
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class('dropdown-menu__item'),
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
						$author$project$Ui$DropdownMenu$checkboxAttributes(optionsRecord))),
				_List_fromArray(
					[
						A2($elm$html$Html$span, _List_Nil, contents)
					]));
		case 4:
			return $author$project$Utils$Html$empty;
		default:
			var externalHref = item_.a;
			var contents = item_.b;
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-menu__item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$href(externalHref)
							]),
						contents)
					]));
	}
};
var $author$project$Ui$DropdownMenu$viewMenuTitle = function (title_) {
	return ($elm$core$String$length(title_) > 0) ? _List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown-title')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(title_)
				]))
		]) : _List_Nil;
};
var $author$project$Ui$DropdownMenu$viewDropdownItems = F2(
	function (title_, items) {
		return _Utils_ap(
			$author$project$Ui$DropdownMenu$viewMenuTitle(title_),
			A2($elm$core$List$map, $author$project$Ui$DropdownMenu$viewItem, items));
	});
var $author$project$Ui$DropdownMenu$view = F3(
	function (options, items, _v0) {
		var model = _v0;
		var optionsRecord = $author$project$Ui$DropdownMenu$optionsToRecord(options);
		var pullClass = function () {
			var _v2 = optionsRecord.sh;
			if (_v2 === 1) {
				return _List_fromArray(
					[
						$author$project$Ui$Pull$toClass(optionsRecord.sh)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var menuOffsetStyleY = $author$project$Ui$DropdownMenu$menuOffsetVertAttr(optionsRecord.yU);
		var menuOffsetStyleX = $author$project$Ui$DropdownMenu$menuOffsetHorzAttr(optionsRecord.yT);
		return A2(
			$elm$html$Html$div,
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							$author$project$Ui$DropdownMenu$directionClass(optionsRecord.xb)),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('open', model.U9),
									_Utils_Tuple2('disabled', optionsRecord.dW),
									_Utils_Tuple2('inline-block', optionsRecord.x7),
									_Utils_Tuple2('form-control-select', optionsRecord.xH)
								])),
							$elm$html$Html$Attributes$disabled(optionsRecord.dW),
							$elm$html$Html$Attributes$id(model.adR)
						]),
						pullClass
					])),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Open dropdown menu'},
					_List_fromArray(
						[
							$author$project$Ui$Button$styled(optionsRecord.s_),
							$author$project$Ui$Button$margin(optionsRecord.yH),
							$author$project$Ui$Button$size(optionsRecord.ag_),
							$author$project$Ui$Button$onClick($author$project$Ui$DropdownMenu$InputClicked),
							$author$project$Ui$Button$dropdownToggle,
							$author$project$Ui$Button$fullWidth(optionsRecord.Fp),
							$author$project$Ui$Button$loading(optionsRecord.S_)
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								A2(
								$elm$core$List$map,
								$elm$html$Html$map($elm$core$Basics$never),
								optionsRecord.$G),
								_List_fromArray(
								[
									function () {
									if (optionsRecord.S_) {
										return $author$project$Utils$Html$empty;
									} else {
										var _v1 = optionsRecord.vt;
										switch (_v1) {
											case 0:
												return A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('form-control-select__caret')
														]),
													$elm$core$List$singleton(
														A2(
															$elm$html$Html$b,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('caret')
																]),
															_List_Nil)));
											case 2:
												return A2(
													$elm$html$Html$span,
													_List_Nil,
													$elm$core$List$singleton(
														A2(
															$elm$html$Html$b,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('caret')
																]),
															_List_Nil)));
											default:
												return A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('form-control-select__caret')
														]),
													$elm$core$List$singleton(
														A2(
															$author$project$Ui$SvgIcon$view,
															_List_fromArray(
																[
																	$author$project$Ui$SvgIcon$color('#005377'),
																	$author$project$Ui$SvgIcon$height('14px'),
																	$author$project$Ui$SvgIcon$rotate(90)
																]),
															12)));
										}
									}
								}()
								])
							]))),
					A2(
					$elm$html$Html$ul,
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-menu'),
									$elm$html$Html$Attributes$class(
									$author$project$Ui$DropdownMenu$sideClass(optionsRecord.Ck)),
									$elm$html$Html$Events$onMouseLeave($author$project$Ui$DropdownMenu$Close)
								]),
								menuOffsetStyleX,
								menuOffsetStyleY
							])),
					A2($author$project$Ui$DropdownMenu$viewDropdownItems, optionsRecord.yV, items))
				]));
	});
var $author$project$Pages$StyleGuide$UploadForm$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.g9;
			if (!_v0.$) {
				var uploadForm = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$StyleGuide$UploadForm$UploadFormMsg,
					A2($author$project$Components$Upload$Form$modal, model.D5, uploadForm));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Upload Form')
				])),
			A2(
			$elm$html$Html$map,
			$author$project$Pages$StyleGuide$UploadForm$DropdownMenuMsg,
			A3(
				$author$project$Ui$DropdownMenu$view,
				_List_fromArray(
					[
						$author$project$Ui$DropdownMenu$title(
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Api$Upload$Resource$toString(model.G0))
							]))
					]),
				$author$project$Pages$StyleGuide$UploadForm$dropdownMenuItems(model.G0),
				model.lV)),
			$author$project$Utils$Html$empty,
			function () {
			var _v1 = model.g9;
			if (!_v1.$) {
				var uploadForm = _v1.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$StyleGuide$UploadForm$UploadFormMsg,
					A2($author$project$Components$Upload$Form$view, model.D5, uploadForm));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}()
		]);
};
var $author$project$Pages$StyleGuide$UploadForm$view = function (model) {
	return {
		e5: function () {
			if (!model.$) {
				var modelRecord = model.a;
				return $author$project$Pages$StyleGuide$UploadForm$viewBody(modelRecord);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You need to be logged in to view this style guide')
							]))
					]);
			}
		}(),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$UploadForm$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$StyleGuide$UploadForm$init, aer: $author$project$Pages$StyleGuide$UploadForm$load, agD: $author$project$Pages$StyleGuide$UploadForm$save, ahd: $author$project$Pages$StyleGuide$UploadForm$subscriptions, aaq: $author$project$Pages$StyleGuide$UploadForm$update, ahP: $author$project$Pages$StyleGuide$UploadForm$view});
var $author$project$Pages$StyleGuide$UploadResult$WithSession = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$UploadResult$WithoutSession = {$: 1};
var $author$project$Pages$StyleGuide$UploadResult$init = F2(
	function (shared, _v0) {
		var _v1 = shared.ZD;
		if (_v1.$ === 3) {
			return _Utils_Tuple3(
				$author$project$Pages$StyleGuide$UploadResult$WithSession(
					{D5: shared.D5, HK: '', ha: $elm$core$Maybe$Nothing}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		} else {
			return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadResult$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$UploadResult$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$StyleGuide$UploadResult$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$StyleGuide$UploadResult$subscriptions = function (model) {
	if (!model.$) {
		var record = model.a;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Pages$StyleGuide$UploadResult$UploadResultMsg,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2($elm$core$Maybe$map, $author$project$Components$Upload$Result$subscriptions, record.ha)));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$StyleGuide$UploadResult$update = F2(
	function (msg, model) {
		if (!model.$) {
			var modelRecord = model.a;
			switch (msg.$) {
				case 0:
					var subMsg = msg.a;
					var _v2 = modelRecord.ha;
					if (!_v2.$) {
						var uploadResult = _v2.a;
						var result = A3($author$project$Components$Upload$Result$update, modelRecord.D5, subMsg, uploadResult);
						var uploadResult_ = function () {
							var _v3 = result.ac5;
							if (!_v3) {
								return $elm$core$Maybe$Just(result.y8);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						return _Utils_Tuple3(
							$author$project$Pages$StyleGuide$UploadResult$WithSession(
								_Utils_update(
									modelRecord,
									{ha: uploadResult_})),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg, result.EC),
							result.as);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 2:
					var uploadId = msg.a;
					return _Utils_Tuple3(
						$author$project$Pages$StyleGuide$UploadResult$WithSession(
							_Utils_update(
								modelRecord,
								{HK: uploadId})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				default:
					var _v4 = A2($author$project$Components$Upload$Result$init, modelRecord.D5, modelRecord.HK);
					var uploadResult = _v4.a;
					var uploadResultCmd = _v4.b;
					return _Utils_Tuple3(
						$author$project$Pages$StyleGuide$UploadResult$WithSession(
							_Utils_update(
								modelRecord,
								{
									ha: $elm$core$Maybe$Just(uploadResult)
								})),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg, uploadResultCmd),
						_List_Nil);
			}
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$StyleGuide$UploadResult$UploadIdChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$StyleGuide$UploadResult$ViewUploadResult = {$: 1};
var $author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid = function (uploadId) {
	return $elm$core$String$isEmpty(uploadId) || (!A2($elm$core$String$startsWith, 'upl-', uploadId));
};
var $author$project$Pages$StyleGuide$UploadResult$uploadIdErrors = function (email) {
	return $author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid(email) ? _List_fromArray(
		['Please enter a valid upload id.']) : _List_Nil;
};
var $author$project$Pages$StyleGuide$UploadResult$viewBody = function (model) {
	return _List_fromArray(
		[
			function () {
			var _v0 = model.ha;
			if (!_v0.$) {
				var uploadResult = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$StyleGuide$UploadResult$UploadResultMsg,
					A2($author$project$Components$Upload$Result$modal, model.D5, uploadResult));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}(),
			$author$project$Ui$Typography$headingLg(
			_List_fromArray(
				[
					$elm$html$Html$text('Upload > Result')
				])),
			A2(
			$author$project$Ui$Form$view,
			_List_fromArray(
				[$author$project$Ui$Form$horizontal]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Upload Id'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpanSm(2),
							$author$project$Ui$Form$Group$inputSpanSm(4)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(model.HK),
									$author$project$Ui$Form$Input$invalid(
									$author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid(model.HK)),
									$author$project$Ui$Form$Input$errors(
									$author$project$Pages$StyleGuide$UploadResult$uploadIdErrors(model.HK)),
									$author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$UploadResult$UploadIdChanged)
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'View result'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$UploadResult$ViewUploadResult)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('View result')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$StyleGuide$UploadResult$view = function (model) {
	return {
		e5: function () {
			if (!model.$) {
				var modelRecord = model.a;
				return $author$project$Pages$StyleGuide$UploadResult$viewBody(modelRecord);
			} else {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You need to be logged in to view this style guide')
							]))
					]);
			}
		}(),
		$G: 'Style Guide'
	};
};
var $author$project$Pages$StyleGuide$UploadResult$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$StyleGuide$UploadResult$init, aer: $author$project$Pages$StyleGuide$UploadResult$load, agD: $author$project$Pages$StyleGuide$UploadResult$save, ahd: $author$project$Pages$StyleGuide$UploadResult$subscriptions, aaq: $author$project$Pages$StyleGuide$UploadResult$update, ahP: $author$project$Pages$StyleGuide$UploadResult$view});
var $author$project$Ui$Well$large = $author$project$Ui$Well$Size(3);
var $author$project$Pages$StyleGuide$Well$viewWell = _List_fromArray(
	[
		$author$project$Ui$Typography$headingLg(
		_List_fromArray(
			[
				$elm$html$Html$text('Well')
			])),
		$author$project$Ui$Typography$heading(
		_List_fromArray(
			[
				$elm$html$Html$text('Styles')
			])),
		A2(
		$author$project$Ui$Well$view,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('default')
			])),
		A2(
		$author$project$Ui$Well$view,
		_List_fromArray(
			[$author$project$Ui$Well$small]),
		_List_fromArray(
			[
				$elm$html$Html$text('small')
			])),
		A2(
		$author$project$Ui$Well$view,
		_List_fromArray(
			[$author$project$Ui$Well$large]),
		_List_fromArray(
			[
				$elm$html$Html$text('large')
			])),
		A2(
		$author$project$Ui$Well$view,
		_List_fromArray(
			[$author$project$Ui$Well$signin]),
		_List_fromArray(
			[
				$elm$html$Html$text('signin')
			]))
	]);
var $author$project$Pages$StyleGuide$Well$view = function (_v0) {
	return {e5: $author$project$Pages$StyleGuide$Well$viewWell, $G: 'Style Guide'};
};
var $author$project$Pages$StyleGuide$Well$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Well$view);
var $author$project$Pages$Support$CannySso$GotCannyJwt = $elm$core$Basics$identity;
var $author$project$Api$Provider$Support$CannySso$CannyJwtResponse = $elm$core$Basics$identity;
var $author$project$Api$Provider$Support$CannySso$Record = function (cannyJwt) {
	return {KG: cannyJwt};
};
var $author$project$Api$Provider$Support$CannySso$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'canny_jwt',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Api$Provider$Support$CannySso$Record)));
var $author$project$Api$Provider$Support$CannySso$createToken = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Provider$Support$CannySso$decoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['user', 'canny_jwt']),
					$author$project$Api$Data$platformPath)));
	});
var $author$project$Pages$Support$CannySso$init = F3(
	function (_v0, _v1, _v2) {
		var apiClient = _v1.D5;
		var flags = _v1.adu;
		return _Utils_Tuple2(
			{D5: apiClient, abP: flags.abP, KG: $author$project$Api$Data$NotAsked},
			A2($author$project$Api$Provider$Support$CannySso$createToken, apiClient, $elm$core$Basics$identity));
	});
var $author$project$Pages$Support$CannySso$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Support$CannySso$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Support$CannySso$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Api$Provider$Support$CannySso$cannyJwt = function (_v0) {
	var record = _v0;
	return record.KG;
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Pages$Support$CannySso$update = F2(
	function (msg, model) {
		var response = msg;
		if (response.$ === 3) {
			var jwt = response.a;
			var urlParam = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (param) {
						return _List_fromArray(
							[param]);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$url$Url$Builder$string('companyID'),
						model.abP)));
			var redirectUrl = 'https://feedback.hint.com/feature-requests';
			var urlWithJwt = A2(
				$elm$core$String$append,
				'https://canny.io',
				A2(
					$elm$url$Url$Builder$absolute,
					_List_fromArray(
						['api', 'redirects', 'sso']),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$url$Url$Builder$string,
							'ssoToken',
							$author$project$Api$Provider$Support$CannySso$cannyJwt(jwt)),
						A2(
							$elm$core$List$cons,
							A2($elm$url$Url$Builder$string, 'redirect', redirectUrl),
							urlParam))));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{KG: response}),
				$elm$browser$Browser$Navigation$load(urlWithJwt),
				_List_Nil);
		} else {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{KG: response}),
				$elm$core$Platform$Cmd$none,
				_List_Nil);
		}
	});
var $author$project$Pages$Support$CannySso$view = function (_v0) {
	return {e5: $author$project$Components$LoadingPage$view, $G: 'Support'};
};
var $author$project$Pages$Support$CannySso$page = $author$project$Spa$Page$applicationPrivate(
	{ad0: $author$project$Pages$Support$CannySso$init, aer: $author$project$Pages$Support$CannySso$load, agD: $author$project$Pages$Support$CannySso$save, ahd: $author$project$Pages$Support$CannySso$subscriptions, aaq: $author$project$Pages$Support$CannySso$update, ahP: $author$project$Pages$Support$CannySso$view});
var $author$project$Pages$Tasks$New$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$New$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$New$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Tasks$New$view = function (_v0) {
	return {e5: _List_Nil, $G: 'New Task'};
};
var $author$project$Pages$Tasks$New$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Tasks$New$init,
		aer: $author$project$Pages$Tasks$New$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Tasks$New$update,
		ahP: $author$project$Pages$Tasks$New$view
	});
var $author$project$Pages$Tasks$TasksId_String$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$TasksId_String$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$TasksId_String$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Tasks$TasksId_String$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Task'};
};
var $author$project$Pages$Tasks$TasksId_String$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Tasks$TasksId_String$Top$init,
		aer: $author$project$Pages$Tasks$TasksId_String$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Tasks$TasksId_String$Top$update,
		ahP: $author$project$Pages$Tasks$TasksId_String$Top$view
	});
var $author$project$Pages$Tasks$Top$init = F4(
	function (_v0, _v1, shared, url) {
		return _Utils_Tuple2(
			{D5: shared.D5, aav: url},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$Tasks$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Tasks$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: 'Tasks'};
};
var $author$project$Pages$Tasks$Top$page = $author$project$Spa$Page$applicationPractice(
	{
		ad0: $author$project$Pages$Tasks$Top$init,
		aer: $author$project$Pages$Tasks$Top$load,
		agD: $elm$core$Basics$always($elm$core$Basics$identity),
		ahd: function (_v0) {
			return $elm$core$Platform$Sub$none;
		},
		aaq: $author$project$Pages$Tasks$Top$update,
		ahP: $author$project$Pages$Tasks$Top$view
	});
var $author$project$Pages$Top$init = F2(
	function (_v0, _v1) {
		return _Utils_Tuple3(
			{},
			A2($author$project$Ports$Navigation$pushRoute, _List_Nil, $author$project$Spa$Generated$Route$Login),
			_List_Nil);
	});
var $author$project$Pages$Top$load = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$Top$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Pages$Top$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Pages$Top$view = function (_v0) {
	return {e5: _List_Nil, $G: ''};
};
var $author$project$Pages$Top$page = $author$project$Spa$Page$application(
	{ad0: $author$project$Pages$Top$init, aer: $author$project$Pages$Top$load, agD: $author$project$Pages$Top$save, ahd: $author$project$Pages$Top$subscriptions, aaq: $author$project$Pages$Top$update, ahP: $author$project$Pages$Top$view});
var $author$project$Spa$Page$applicationUser = function (page) {
	return {
		ad0: F2(
			function (shared, url) {
				var _v0 = _Utils_Tuple2(shared.ZD, shared.aaz);
				_v0$3:
				while (true) {
					_v0$4:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var _v1 = _v0.a;
										var session = _v1.a;
										var _v2 = _v0.b;
										var user = _v2.a;
										return (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) ? _Utils_Tuple3(
											$author$project$Spa$Page$SessionLoading(url),
											A2(
												$author$project$Utils$Route$navigate,
												$elm$core$Dict$empty,
												A2($author$project$Permission$homeStateFor, session, shared.adN)),
											_List_Nil) : A2(
											$author$project$Utils$Tuple3$mapFirst,
											$author$project$Spa$Page$SessionLoaded,
											A2(
												$author$project$Utils$Tuple3$fromTuple2,
												_List_Nil,
												A4(page.ad0, session, user, shared, url)));
									case 2:
										break _v0$3;
									default:
										break _v0$4;
								}
							case 0:
								var _v3 = _v0.a;
								return _Utils_Tuple3(
									$author$project$Spa$Page$SessionLoading(url),
									$author$project$Ports$Session$authorize(
										{af6: true}),
									_List_Nil);
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								if (_v0.b.$ === 2) {
									break _v0$3;
								} else {
									break _v0$4;
								}
						}
					}
					return _Utils_Tuple3(
						$author$project$Spa$Page$SessionLoading(url),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		aer: F2(
			function (shared, model) {
				var _v4 = _Utils_Tuple2(shared.ZD, shared.aaz);
				_v4$2:
				while (true) {
					_v4$3:
					while (true) {
						switch (_v4.a.$) {
							case 3:
								switch (_v4.b.$) {
									case 3:
										var _v5 = _v4.a;
										var session = _v5.a;
										var _v6 = _v4.b;
										var user = _v6.a;
										switch (model.$) {
											case 0:
												var url = model.a;
												if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.adN, shared.aav)) {
													return _Utils_Tuple3(
														$author$project$Spa$Page$SessionLoading(url),
														A2(
															$author$project$Utils$Route$navigate,
															$elm$core$Dict$empty,
															A2($author$project$Permission$homeStateFor, session, shared.adN)),
														_List_Nil);
												} else {
													var _v8 = A4(page.ad0, session, user, shared, url);
													var pageModel = _v8.a;
													var cmd = _v8.b;
													return _Utils_Tuple3(
														$author$project$Spa$Page$SessionLoaded(pageModel),
														cmd,
														_List_Nil);
												}
											case 1:
												var modelWithSession = model.a;
												return A2(
													$author$project$Utils$Tuple3$fromTuple2,
													_List_Nil,
													A2(
														$elm$core$Tuple$mapFirst,
														$author$project$Spa$Page$SessionLoaded,
														A2(
															page.aer,
															shared,
															_Utils_update(
																modelWithSession,
																{D5: shared.D5}))));
											default:
												return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
										}
									case 2:
										break _v4$2;
									default:
										break _v4$3;
								}
							case 2:
								return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
							default:
								if (_v4.b.$ === 2) {
									break _v4$2;
								} else {
									break _v4$3;
								}
						}
					}
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
				return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
			}),
		agD: F2(
			function (model, shared) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(page.agD, modelWithSession, shared);
				} else {
					return shared;
				}
			}),
		ahd: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahd(modelWithSession);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		},
		aaq: F2(
			function (msg, model) {
				if (model.$ === 1) {
					var modelWithSession = model.a;
					return A2(
						$author$project$Utils$Tuple3$mapFirst,
						$author$project$Spa$Page$SessionLoaded,
						A2(page.aaq, msg, modelWithSession));
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			}),
		ahP: function (model) {
			if (model.$ === 1) {
				var modelWithSession = model.a;
				return page.ahP(modelWithSession);
			} else {
				return {e5: $author$project$Components$BlankPage$view, $G: 'Loading...'};
			}
		}
	};
};
var $author$project$Api$Platform$User$Shared$termsAccepted = function (_v0) {
	var record = _v0;
	return record.Hw;
};
var $author$project$Api$Platform$User$One$termsAccepted = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$termsAccepted(shared);
};
var $author$project$Pages$User$AcceptTerms$initFormFields = function (user) {
	return {
		Hw: $author$project$Api$Platform$User$One$termsAccepted(user)
	};
};
var $author$project$Pages$User$AcceptTerms$init = F4(
	function (session, user, shared, _v0) {
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				PB: $author$project$Utils$Form$init(
					$author$project$Pages$User$AcceptTerms$initFormFields(user)),
				jY: $author$project$Api$Data$NotAsked,
				ZD: session,
				aaz: user
			},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$AcceptTerms$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$AcceptTerms$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$User$AcceptTerms$Close = {$: 0};
var $author$project$Pages$User$AcceptTerms$subscriptions = function (_v0) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$User$AcceptTerms$Close);
};
var $author$project$Pages$User$AcceptTerms$formFieldsUpdate = F2(
	function (field, fields) {
		var bool = field;
		return _Utils_update(
			fields,
			{Hw: bool});
	});
var $author$project$Pages$User$AcceptTerms$TermsAcceptedValidation = 0;
var $author$project$Pages$User$AcceptTerms$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function ($) {
				return $.Hw;
			},
			_Utils_Tuple2(0, 'Please accept our terms.'))
		]));
var $author$project$Pages$User$AcceptTerms$UserUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Platform$User$updateTermsAcceptance = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'terms_accepted',
								$elm$json$Json$Encode$bool(fields.Hw))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Platform$User$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
	});
var $author$project$Pages$User$AcceptTerms$updateUser = F2(
	function (apiClient, formFields) {
		return A3(
			$author$project$Api$Platform$User$updateTermsAcceptance,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			$author$project$Pages$User$AcceptTerms$UserUpdated);
	});
var $author$project$Pages$User$AcceptTerms$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$User$AcceptTerms$formFieldsUpdate, field, model.PB);
				var validatedForm = function () {
					var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$AcceptTerms$formFieldsValidator, newForm);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var form = _v2.a;
						return form;
					} else {
						var form = _v1.a;
						return form;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: validatedForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$AcceptTerms$formFieldsValidator, model.PB);
				if (!_v3.$) {
					var _v4 = _v3.a;
					var newForm = _v4.a;
					var validFormFields = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						A2($author$project$Pages$User$AcceptTerms$updateUser, model.D5, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v3.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 3:
				var response = msg.a;
				if (response.$ === 3) {
					var _v6 = function () {
						var _v7 = $author$project$Api$Platform$Session$One$organization(model.ZD);
						if (!_v7.$) {
							var organization = _v7.a;
							return _Utils_Tuple2(
								$elm$core$Platform$Cmd$none,
								_List_fromArray(
									[
										A3(
										$author$project$OutMsg$SwitchToOrganization,
										$author$project$Api$Platform$Organization$Shared$id(organization),
										$elm$core$Maybe$Nothing,
										$author$project$OutMsg$GoToDefaultStateAction)
									]));
						} else {
							return _Utils_Tuple2(
								A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Organizations__Top),
								_List_Nil);
						}
					}();
					var cmd = _v6.a;
					var outMsgs = _v6.b;
					return _Utils_Tuple3(
						model,
						cmd,
						_Utils_ap(
							outMsgs,
							_List_fromArray(
								[
									A2($author$project$OutMsg$ShowToast, 3, 'Your profile has been updated')
								])));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(response));
				}
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$User$AcceptTerms$UpdateUser = {$: 2};
var $author$project$Ui$Modal$Dismissible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Modal$dismissible = $author$project$Ui$Modal$Dismissible;
var $author$project$Pages$User$AcceptTerms$FormFieldUpdated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$AcceptTerms$TermsAccepted = $elm$core$Basics$identity;
var $author$project$Pages$User$AcceptTerms$viewAcceptTerms = F2(
	function (user, form) {
		if ($author$project$Api$Platform$User$One$termsAccepted(user)) {
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 33),
							A2(
							$author$project$Ui$Typography$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(' You agreed to this software platform\'s')
								])),
							A3(
							$author$project$Ui$Link$externalHref,
							$author$project$Utils$HintUrls$termsUrl,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Terms of Service.')
								]))
						]))
				]);
		} else {
			var _v0 = $author$project$Utils$Form$fields(form);
			var termsAccepted = _v0.Hw;
			return _List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Checkbox$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Checkbox$value(termsAccepted),
									$author$project$Ui$Form$Checkbox$required(true),
									$author$project$Ui$Form$Checkbox$onCheck(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$AcceptTerms$FormFieldUpdated, $elm$core$Basics$identity))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('I agree to this software platform\'s'),
											A3(
											$author$project$Ui$Link$externalHref,
											$author$project$Utils$HintUrls$termsUrl,
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Terms of Service.')
												]))
										]))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 0, form))
						]))
				]);
		}
	});
var $author$project$Pages$User$AcceptTerms$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A3(
				$author$project$Ui$Modal$view,
				$author$project$Pages$User$AcceptTerms$Close,
				_List_fromArray(
					[
						$author$project$Ui$Modal$dismissible(false)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Modal$header(
						_List_fromArray(
							[
								$author$project$Ui$Modal$title('Protect Your Patients\' Privacy')
							])),
						$author$project$Ui$Modal$body(
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('This platform has instituted more rigorous safeguards, policies, and procedures in accordance with the HIPAA and HITECH final rule. To help better protect your patients\' privacy, please change your password.')
											]))
									])),
								A2(
								$author$project$Ui$Form$Group$view,
								_List_fromArray(
									[
										$author$project$Ui$Form$Group$label('')
									]),
								A2($author$project$Pages$User$AcceptTerms$viewAcceptTerms, model.aaz, model.PB)),
								$author$project$Ui$Clearfix$view
							])),
						$author$project$Ui$Modal$footer(
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Update terms'},
								_List_fromArray(
									[
										$author$project$Ui$Button$primary,
										$author$project$Ui$Button$submit,
										$author$project$Ui$Button$onClick($author$project$Pages$User$AcceptTerms$UpdateUser),
										$author$project$Ui$Button$loading(
										_Utils_eq(model.jY, $author$project$Api$Data$Loading))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Update')
									]))
							]))
					]))
			]),
		$G: 'Patients'
	};
};
var $author$project$Pages$User$AcceptTerms$page = $author$project$Spa$Page$applicationUser(
	{ad0: $author$project$Pages$User$AcceptTerms$init, aer: $author$project$Pages$User$AcceptTerms$load, agD: $author$project$Pages$User$AcceptTerms$save, ahd: $author$project$Pages$User$AcceptTerms$subscriptions, aaq: $author$project$Pages$User$AcceptTerms$update, ahP: $author$project$Pages$User$AcceptTerms$view});
var $author$project$Pages$User$Mfa$GotMfa = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Mfa$Qr = 0;
var $author$project$Api$Platform$User$One$requiresMfa = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$requiresMfa(shared);
};
var $author$project$Api$Platform$Mfa$One$Mfa = $elm$core$Basics$identity;
var $author$project$Api$Platform$Mfa$One$Record = F5(
	function (accountName, otpSecretKey, qrcodeUrl, qrcode, status) {
		return {H5: accountName, Vk: otpSecretKey, Xs: qrcode, Xt: qrcodeUrl, ag7: status};
	});
var $author$project$Api$Platform$Mfa$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$author$project$Api$Platform$Mfa$Status$decode,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'qrcode',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'qrcode_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'otp_secret_key',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'account_name',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Api$Platform$Mfa$One$Record))))));
var $author$project$Api$Platform$Mfa$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Mfa$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Mfa$mfaPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['mfa']),
	$author$project$Api$Data$platformPath);
var $author$project$Api$Platform$Mfa$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Platform$Mfa$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
	});
var $author$project$Pages$User$Mfa$initFromSessionAndUser = F3(
	function (apiClient, user, requiresMfaPrerequisite) {
		return _Utils_Tuple2(
			{
				kP: $author$project$Api$Data$NotAsked,
				D5: apiClient,
				qe: $elm$core$Maybe$Nothing,
				F6: 0,
				f3: $author$project$Api$Data$Loading,
				rL: '',
				Yn: $author$project$Api$Platform$User$One$requiresMfa(user),
				G_: requiresMfaPrerequisite
			},
			A2($author$project$Api$Platform$Mfa$retrieve, apiClient, $author$project$Pages$User$Mfa$GotMfa));
	});
var $author$project$Pages$User$Mfa$init = F4(
	function (_v0, user, _v1, _v2) {
		var apiClient = _v1.D5;
		var query = _v2.Bi;
		var requiresMfaPrerequisite = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$eq('true'),
				A2($elm$core$Dict$get, 'requiresMfaPrerequisite', query)));
		return A3($author$project$Pages$User$Mfa$initFromSessionAndUser, apiClient, user, requiresMfaPrerequisite);
	});
var $author$project$Pages$User$Mfa$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$Mfa$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$User$Mfa$QRDecoderMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ports$QRDecoder$onDecodePort = _Platform_incomingPort('onDecodePort', $elm$json$Json$Decode$string);
var $author$project$Ports$QRDecoder$onDecode = $author$project$Ports$QRDecoder$onDecodePort;
var $author$project$Pages$User$Mfa$subscriptions = function (_v0) {
	return $author$project$Ports$QRDecoder$onDecode($author$project$Pages$User$Mfa$QRDecoderMsg);
};
var $author$project$Pages$User$Mfa$GotActivatingMfa = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Mfa$Logout = {$: 4};
var $author$project$Pages$User$Mfa$Manual = 1;
var $author$project$Api$Platform$Mfa$activateMfaPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['activate']),
	$author$project$Api$Platform$Mfa$mfaPath);
var $author$project$Api$Platform$Mfa$activate = F4(
	function (apiClient, otpCode, qrCodeUrl, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'otp_code',
					$elm$json$Json$Encode$string(otpCode)),
					_Utils_Tuple2(
					'qrcode_url',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, qrCodeUrl))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Mfa$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$activateMfaPath)));
	});
var $author$project$Api$Platform$Mfa$create = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Mfa$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
	});
var $author$project$Ports$QRDecoder$decodePort = _Platform_outgoingPort('decodePort', $elm$json$Json$Encode$string);
var $author$project$Ports$QRDecoder$decode = function (base64) {
	return $author$project$Ports$QRDecoder$decodePort(base64);
};
var $author$project$Api$Platform$Mfa$One$qrcode = function (_v0) {
	var record = _v0;
	return record.Xs;
};
var $author$project$Api$Platform$Mfa$One$qrcodeUrl = function (_v0) {
	var record = _v0;
	return record.Xt;
};
var $author$project$Api$Platform$Mfa$update = F3(
	function (apiClient, qrCodeUrl, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'qrcode_url',
					$elm$json$Json$Encode$string(qrCodeUrl))
				]));
		return A4(
			$author$project$Api$Data$put,
			apiClient,
			$author$project$Api$Platform$Mfa$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath)));
	});
var $author$project$Pages$User$Mfa$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var dataMfa = msg.a;
				_v1$2:
				while (true) {
					switch (dataMfa.$) {
						case 3:
							var mfa = dataMfa.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										qe: $elm$core$Maybe$Just(
											$author$project$Api$Platform$Mfa$One$qrcodeUrl(mfa)),
										f3: dataMfa
									}),
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										$author$project$Ports$QRDecoder$decode,
										$author$project$Api$Platform$Mfa$One$qrcode(mfa))),
								_List_Nil);
						case 2:
							if (dataMfa.a.$ === 5) {
								var _v2 = dataMfa.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{f3: dataMfa}),
									A2($author$project$Api$Platform$Mfa$create, model.D5, $author$project$Pages$User$Mfa$GotMfa),
									_List_Nil);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{f3: dataMfa}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$reportDecodeError(dataMfa));
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{F6: 1}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var code = msg.a;
				var _v3 = ($elm$core$String$length(code) === 6) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{kP: $author$project$Api$Data$Loading}),
					A4($author$project$Api$Platform$Mfa$activate, model.D5, code, model.qe, $author$project$Pages$User$Mfa$GotActivatingMfa)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				var newModel = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{rL: code}),
					cmd,
					_List_Nil);
			case 3:
				var dataMfa = msg.a;
				switch (dataMfa.$) {
					case 3:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kP: dataMfa, f3: dataMfa}),
							A2(
								$elm$core$Task$perform,
								function (_v5) {
									return $author$project$Pages$User$Mfa$Logout;
								},
								$elm$core$Process$sleep(5000)),
							_List_Nil);
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{kP: dataMfa, rL: ''}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(dataMfa));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 4:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Session$logout(
						{af6: true}),
					_List_Nil);
			default:
				var qrCode = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							qe: $elm$core$Maybe$Just(qrCode)
						}),
					A3($author$project$Api$Platform$Mfa$update, model.D5, qrCode, $author$project$Pages$User$Mfa$GotMfa),
					_List_Nil);
		}
	});
var $author$project$Api$Platform$Mfa$One$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Pages$User$Mfa$OtpCodeChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$Mfa$viewActivate = F2(
	function (otpCode, activatingMfa) {
		var loading = function () {
			if (activatingMfa.$ === 1) {
				return true;
			} else {
				return false;
			}
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Enter the 6 digit code from your phone bellow')
							])),
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$disabled(loading),
												$author$project$Ui$Form$Input$value(otpCode),
												$author$project$Ui$Form$Input$autofocus(true),
												$author$project$Ui$Form$Input$onInput($author$project$Pages$User$Mfa$OtpCodeChanged)
											])),
										loading ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty
									]))
							]))
					]))
			]);
	});
var $author$project$Api$Platform$Mfa$One$accountName = function (_v0) {
	var record = _v0;
	return record.H5;
};
var $author$project$Api$Platform$Mfa$One$otpSecretKey = function (_v0) {
	var record = _v0;
	return record.Vk;
};
var $author$project$Pages$User$Mfa$viewManualSteps = function (mfa) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select the '),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Enter a provided key')
						])),
					$elm$html$Html$text(' option')
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Enter the following information')
						])),
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Account name: '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Platform$Mfa$One$accountName(mfa))
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text('Key: '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Platform$Mfa$One$otpSecretKey(mfa))
								]))
						]))
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Tap '),
							A2(
							$author$project$Ui$Typography$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Add')
								]))
						]))
				]))
		]);
};
var $pablohirafuji$elm_qrcode$QRCode$Quartile = 2;
var $author$project$Pages$User$Mfa$SwitchToManual = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$QRCode = $elm$core$Basics$identity;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3(
	function (size, row, col) {
		return (size * row) + col;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4(
	function (row, col, size, matrix) {
		var _v0 = A2(
			$elm$core$Array$get,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			matrix);
		if ((!_v0.$) && (!_v0.a.$)) {
			return true;
		} else {
			return false;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function (placement) {
	var row = placement.n3;
	var col = placement.K6;
	var isRight = placement.d7;
	var isUp = placement.q8;
	return isRight ? _Utils_update(
		placement,
		{K6: col - 1, d7: false}) : (isUp ? _Utils_update(
		placement,
		{K6: col + 1, d7: true, n3: row - 1}) : _Utils_update(
		placement,
		{K6: col + 1, d7: true, n3: row + 1}));
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2(
	function (_byte, offset) {
		return (1 & (_byte >> (7 - offset))) === 1;
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3(
	function (_v0, _byte, offset) {
		var size = _v0.ag_;
		var row = _v0.n3;
		var col = _v0.K6;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					false,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor, _byte, offset))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4(
	function (placement, bytes, offset, matrix) {
		addDataModule:
		while (true) {
			var size = placement.ag_;
			var row = placement.n3;
			var col = placement.K6;
			if (!bytes.b) {
				return matrix;
			} else {
				var head = bytes.a;
				var tail = bytes.b;
				if (offset >= 8) {
					var $temp$placement = placement,
						$temp$bytes = tail,
						$temp$offset = 0,
						$temp$matrix = matrix;
					placement = $temp$placement;
					bytes = $temp$bytes;
					offset = $temp$offset;
					matrix = $temp$matrix;
					continue addDataModule;
				} else {
					if (col === 6) {
						var $temp$placement = _Utils_update(
							placement,
							{K6: col - 1, d7: true}),
							$temp$bytes = bytes,
							$temp$offset = offset,
							$temp$matrix = matrix;
						placement = $temp$placement;
						bytes = $temp$bytes;
						offset = $temp$offset;
						matrix = $temp$matrix;
						continue addDataModule;
					} else {
						if (row < 0) {
							var $temp$placement = _Utils_update(
								placement,
								{K6: col - 2, d7: true, q8: false, n3: 0}),
								$temp$bytes = bytes,
								$temp$offset = offset,
								$temp$matrix = matrix;
							placement = $temp$placement;
							bytes = $temp$bytes;
							offset = $temp$offset;
							matrix = $temp$matrix;
							continue addDataModule;
						} else {
							if (_Utils_cmp(row, size) > -1) {
								var $temp$placement = _Utils_update(
									placement,
									{K6: col - 2, d7: true, q8: true, n3: size - 1}),
									$temp$bytes = bytes,
									$temp$offset = offset,
									$temp$matrix = matrix;
								placement = $temp$placement;
								bytes = $temp$bytes;
								offset = $temp$offset;
								matrix = $temp$matrix;
								continue addDataModule;
							} else {
								if (A4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy, row, col, size, matrix)) {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset,
										$temp$matrix = matrix;
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								} else {
									var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement),
										$temp$bytes = bytes,
										$temp$offset = offset + 1,
										$temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix);
									placement = $temp$placement;
									bytes = $temp$bytes;
									offset = $temp$offset;
									matrix = $temp$matrix;
									continue addDataModule;
								}
							}
						}
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function (size) {
	return {K6: size + 1, d7: true, q8: true, n3: size + 1, ag_: size};
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3(
	function (size, bytes, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size),
			bytes,
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(
	_List_fromArray(
		[
			_List_Nil,
			_List_fromArray(
			[6, 18]),
			_List_fromArray(
			[6, 22]),
			_List_fromArray(
			[6, 26]),
			_List_fromArray(
			[6, 30]),
			_List_fromArray(
			[6, 34]),
			_List_fromArray(
			[6, 22, 38]),
			_List_fromArray(
			[6, 24, 42]),
			_List_fromArray(
			[6, 26, 46]),
			_List_fromArray(
			[6, 28, 50]),
			_List_fromArray(
			[6, 30, 54]),
			_List_fromArray(
			[6, 32, 58]),
			_List_fromArray(
			[6, 34, 62]),
			_List_fromArray(
			[6, 26, 46, 66]),
			_List_fromArray(
			[6, 26, 48, 70]),
			_List_fromArray(
			[6, 26, 50, 74]),
			_List_fromArray(
			[6, 30, 54, 78]),
			_List_fromArray(
			[6, 30, 56, 82]),
			_List_fromArray(
			[6, 30, 58, 86]),
			_List_fromArray(
			[6, 34, 62, 90]),
			_List_fromArray(
			[6, 28, 50, 72, 94]),
			_List_fromArray(
			[6, 26, 50, 74, 98]),
			_List_fromArray(
			[6, 30, 54, 78, 102]),
			_List_fromArray(
			[6, 28, 54, 80, 106]),
			_List_fromArray(
			[6, 32, 58, 84, 110]),
			_List_fromArray(
			[6, 30, 58, 86, 114]),
			_List_fromArray(
			[6, 34, 62, 90, 118]),
			_List_fromArray(
			[6, 26, 50, 74, 98, 122]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126]),
			_List_fromArray(
			[6, 26, 52, 78, 104, 130]),
			_List_fromArray(
			[6, 30, 56, 82, 108, 134]),
			_List_fromArray(
			[6, 34, 60, 86, 112, 138]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142]),
			_List_fromArray(
			[6, 34, 62, 90, 118, 146]),
			_List_fromArray(
			[6, 30, 54, 78, 102, 126, 150]),
			_List_fromArray(
			[6, 24, 50, 76, 102, 128, 154]),
			_List_fromArray(
			[6, 28, 54, 80, 106, 132, 158]),
			_List_fromArray(
			[6, 32, 58, 84, 110, 136, 162]),
			_List_fromArray(
			[6, 26, 54, 82, 110, 138, 166]),
			_List_fromArray(
			[6, 30, 58, 86, 114, 142, 170])
		]));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2(
	function (rows, cols) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (row, list) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (col, list_) {
								return A2(
									$elm$core$List$cons,
									_Utils_Tuple2(row, col),
									list_);
							}),
						list,
						cols);
				}),
			_List_Nil,
			rows);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2(
	function (size, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return ((row > 10) || ((10 < col) && (_Utils_cmp(col, size - 10) < 0))) && ((_Utils_cmp(row, size - 10) < 0) || (col > 10));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = A2($elm$core$List$range, -2, 2);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2(
	function (row, col) {
		return (_Utils_eq(row, -2) || ((row === 2) || (_Utils_eq(col, -2) || ((col === 2) || ((!row) && (!col)))))) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4(
	function (size, rowPos, colPos, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row + rowPos, col + colPos),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3(
	function (size, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3(
	function (size, locations, matrix) {
		return A3(
			$elm$core$List$foldl,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size),
			matrix,
			A2(
				$elm$core$List$filter,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size),
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, locations, locations)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3(
	function (version, size, matrix) {
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments, size, a, matrix);
			},
			A2(
				$elm$core$Result$fromMaybe,
				$pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound,
				A2($elm$core$Array$get, version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2(
	function (version, size) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, (4 * version) + 9, 8),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, true)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = A2($elm$core$List$range, 0, 8);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2(
	function (row, col) {
		return ((1 <= row) && ((row <= 7) && ((col === 1) || (col === 7)))) || (((1 <= col) && ((col <= 7) && ((row === 1) || (row === 7)))) || ((3 <= row) && ((row <= 5) && ((3 <= col) && (col <= 5)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5(
	function (size, rowOffset, colOffset, _v0, matrix) {
		var row = _v0.a;
		var col = _v0.b;
		var finalRow = row + rowOffset;
		var finalCol = col + colOffset;
		return ((finalRow < 0) || ((finalCol < 0) || ((_Utils_cmp(finalRow, size) > -1) || (_Utils_cmp(finalCol, size) > -1)))) ? matrix : A3(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, finalRow, finalCol),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(
					true,
					A2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor, row, col))),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4(
	function (size, rowOffset, colOffset, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset),
			matrix,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2(
	function (maybeModule, isChange) {
		if (isChange) {
			if ((!maybeModule.$) && (!maybeModule.a.a)) {
				var _v1 = maybeModule.a;
				var isDark = _v1.b;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(false, !isDark));
			} else {
				return maybeModule;
			}
		} else {
			return maybeModule;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2(
	function (size, index) {
		return _Utils_Tuple2(
			(index / size) | 0,
			A2($elm$core$Basics$modBy, size, index));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4(
	function (_function, size, index, maybeModule) {
		return A2(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor,
			maybeModule,
			_function(
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord, size, index)));
	});
var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
var $elm$core$Array$indexedMap = F2(
	function (func, _v0) {
		var len = _v0.a;
		var tree = _v0.c;
		var tail = _v0.d;
		var initialBuilder = {
			R: _List_Nil,
			y: 0,
			J: A3(
				$elm$core$Elm$JsArray$indexedMap,
				func,
				$elm$core$Array$tailIndex(len),
				tail)
		};
		var helper = F2(
			function (node, builder) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
				} else {
					var leaf = node.a;
					var offset = builder.y * $elm$core$Array$branchFactor;
					var mappedLeaf = $elm$core$Array$Leaf(
						A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
					return {
						R: A2($elm$core$List$cons, mappedLeaf, builder.R),
						y: builder.y + 1,
						J: builder.J
					};
				}
			});
		return A2(
			$elm$core$Array$builderToArray,
			true,
			A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function (mask) {
	switch (mask) {
		case 0:
			return function (_v1) {
				var row = _v1.a;
				var col = _v1.b;
				return !A2($elm$core$Basics$modBy, 2, row + col);
			};
		case 1:
			return function (_v2) {
				var row = _v2.a;
				return !A2($elm$core$Basics$modBy, 2, row);
			};
		case 2:
			return function (_v3) {
				var col = _v3.b;
				return !A2($elm$core$Basics$modBy, 3, col);
			};
		case 3:
			return function (_v4) {
				var row = _v4.a;
				var col = _v4.b;
				return !A2($elm$core$Basics$modBy, 3, row + col);
			};
		case 4:
			return function (_v5) {
				var row = _v5.a;
				var col = _v5.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					$elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
			};
		case 5:
			return function (_v6) {
				var row = _v6.a;
				var col = _v6.b;
				return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		case 6:
			return function (_v7) {
				var row = _v7.a;
				var col = _v7.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
			};
		default:
			return function (_v8) {
				var row = _v8.a;
				var col = _v8.b;
				return !A2(
					$elm$core$Basics$modBy,
					2,
					A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
			};
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3(
	function (size, mask, matrix) {
		return A2(
			$elm$core$Array$indexedMap,
			A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction,
				$pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask),
				size),
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3(
	function (width, list, acc) {
		breakList:
		while (true) {
			if (!list.b) {
				return $elm$core$List$reverse(acc);
			} else {
				var $temp$width = width,
					$temp$list = A2($elm$core$List$drop, width, list),
					$temp$acc = A2(
					$elm$core$List$cons,
					A2($elm$core$List$take, width, list),
					acc);
				width = $temp$width;
				list = $temp$list;
				acc = $temp$acc;
				continue breakList;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2(
	$elm$core$Basics$composeR,
	$elm$core$Maybe$map($elm$core$Tuple$second),
	$elm$core$Maybe$withDefault(false));
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2(
	function (simplifiedList, _v0) {
		rule1Score_:
		while (true) {
			var last = _v0.a;
			var partialScore = _v0.b;
			var score = _v0.c;
			if (!simplifiedList.b) {
				return (partialScore >= 5) ? ((score + partialScore) - 2) : score;
			} else {
				var head = simplifiedList.a;
				var tail = simplifiedList.b;
				if (_Utils_eq(last, head)) {
					var $temp$simplifiedList = tail,
						$temp$_v0 = _Utils_Tuple3(last, partialScore + 1, score);
					simplifiedList = $temp$simplifiedList;
					_v0 = $temp$_v0;
					continue rule1Score_;
				} else {
					if (partialScore >= 5) {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, (score + partialScore) - 2);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					} else {
						var $temp$simplifiedList = tail,
							$temp$_v0 = _Utils_Tuple3(head, 0, score);
						simplifiedList = $temp$simplifiedList;
						_v0 = $temp$_v0;
						continue rule1Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2(
	$elm$core$Basics$composeR,
	$elm$core$List$map(
		function (a) {
			return A2(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_,
				a,
				_Utils_Tuple3(false, 0, 0));
		}),
	$elm$core$List$sum);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4(
	function (row1, row2, maybeLast, score) {
		rule2Score_:
		while (true) {
			if (!row1.b) {
				return score;
			} else {
				var head = row1.a;
				var tail = row1.b;
				if (!row2.b) {
					return score;
				} else {
					var head2 = row2.a;
					var tail2 = row2.b;
					if (_Utils_eq(head, head2)) {
						if (_Utils_eq(
							$elm$core$Maybe$Just(head),
							maybeLast)) {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score + 3;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						} else {
							var $temp$row1 = tail,
								$temp$row2 = tail2,
								$temp$maybeLast = $elm$core$Maybe$Just(head),
								$temp$score = score;
							row1 = $temp$row1;
							row2 = $temp$row2;
							maybeLast = $temp$maybeLast;
							score = $temp$score;
							continue rule2Score_;
						}
					} else {
						var $temp$row1 = tail,
							$temp$row2 = tail2,
							$temp$maybeLast = $elm$core$Maybe$Nothing,
							$temp$score = score;
						row1 = $temp$row1;
						row2 = $temp$row2;
						maybeLast = $temp$maybeLast;
						score = $temp$score;
						continue rule2Score_;
					}
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2(
	function (list, score) {
		rule2Score:
		while (true) {
			if (list.b && list.b.b) {
				var head1 = list.a;
				var _v1 = list.b;
				var head2 = _v1.a;
				var tail = _v1.b;
				var $temp$list = tail,
					$temp$score = score + A4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_, head1, head2, $elm$core$Maybe$Nothing, 0);
				list = $temp$list;
				score = $temp$score;
				continue rule2Score;
			} else {
				return score;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2(
	function (simplifiedList, score) {
		rule3Score_:
		while (true) {
			_v0$3:
			while (true) {
				if (!simplifiedList.b) {
					return score;
				} else {
					if (!simplifiedList.a) {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && (!simplifiedList.b.b.a)) && simplifiedList.b.b.b.b) && (!simplifiedList.b.b.b.a)) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
							var _v1 = simplifiedList.b;
							var _v2 = _v1.b;
							var _v3 = _v2.b;
							var _v4 = _v3.b;
							var _v5 = _v4.b;
							var _v6 = _v5.b;
							var _v7 = _v6.b;
							var _v8 = _v7.b;
							var _v9 = _v8.b;
							var _v10 = _v9.b;
							var tail = _v10.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					} else {
						if (((((((((((((((((((simplifiedList.b.b && (!simplifiedList.b.a)) && simplifiedList.b.b.b) && simplifiedList.b.b.a) && simplifiedList.b.b.b.b) && simplifiedList.b.b.b.a) && simplifiedList.b.b.b.b.b) && simplifiedList.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b) && simplifiedList.b.b.b.b.b.b.a) && simplifiedList.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.a)) && simplifiedList.b.b.b.b.b.b.b.b.b.b.b) && (!simplifiedList.b.b.b.b.b.b.b.b.b.b.a)) {
							var _v11 = simplifiedList.b;
							var _v12 = _v11.b;
							var _v13 = _v12.b;
							var _v14 = _v13.b;
							var _v15 = _v14.b;
							var _v16 = _v15.b;
							var _v17 = _v16.b;
							var _v18 = _v17.b;
							var _v19 = _v18.b;
							var _v20 = _v19.b;
							var tail = _v20.b;
							var $temp$simplifiedList = tail,
								$temp$score = score + 40;
							simplifiedList = $temp$simplifiedList;
							score = $temp$score;
							continue rule3Score_;
						} else {
							break _v0$3;
						}
					}
				}
			}
			var head = simplifiedList.a;
			var tail = simplifiedList.b;
			var $temp$simplifiedList = tail,
				$temp$score = score;
			simplifiedList = $temp$simplifiedList;
			score = $temp$score;
			continue rule3Score_;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2(
	function (size, simplifiedList) {
		var moduleCount = size * size;
		var darkCount = $elm$core$List$length(
			A2($elm$core$List$filter, $elm$core$Basics$identity, simplifiedList));
		var darkPerc = $elm$core$Basics$round((100 * darkCount) / moduleCount);
		var remOf5 = darkPerc % 5;
		var nextMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc + (5 - remOf5)) - 50) / 5);
		var prevMult5 = $elm$core$Basics$round(
			$elm$core$Basics$abs((darkPerc - remOf5) - 50) / 5);
		return A2($elm$core$Basics$min, prevMult5, nextMult5) * 10;
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function (ll) {
	transpose:
	while (true) {
		if (!ll.b) {
			return _List_Nil;
		} else {
			if (!ll.a.b) {
				var xss = ll.b;
				var $temp$ll = xss;
				ll = $temp$ll;
				continue transpose;
			} else {
				var _v1 = ll.a;
				var x = _v1.a;
				var xs = _v1.b;
				var xss = ll.b;
				var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
				var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
				return A2(
					$elm$core$List$cons,
					A2($elm$core$List$cons, x, heads),
					$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(
						A2($elm$core$List$cons, xs, tails)));
			}
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2(
	function (size, matrix) {
		var list = A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule,
			$elm$core$Array$toList(matrix));
		var rowList = A3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList, size, list, _List_Nil);
		var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
		return function (b) {
			return _Utils_Tuple2(rowList, b);
		}(
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score, size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + (A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score, rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return 1;
		case 1:
			return 0;
		case 2:
			return 3;
		default:
			return 2;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function (_int) {
	var helper = F2(
		function (digit, int_) {
			helper:
			while (true) {
				if (!(!int_)) {
					var $temp$digit = digit + 1,
						$temp$int_ = int_ >>> 1;
					digit = $temp$digit;
					int_ = $temp$int_;
					continue helper;
				} else {
					return digit;
				}
			}
		});
	return A2(helper, 0, _int);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function (mask) {
	switch (mask) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		default:
			return 7;
	}
};
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2(
	function (ecLevel, mask) {
		var g15Mask = 21522;
		var g15Int = 1335;
		var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
		var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | ($pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3);
		var helper = function (d_) {
			helper:
			while (true) {
				if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit) >= 0) {
					var $temp$d_ = d_ ^ (g15Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit));
					d_ = $temp$d_;
					continue helper;
				} else {
					return g15Mask ^ (d_ | (formatInfoInt << 10));
				}
			}
		};
		var d = formatInfoInt << 10;
		return helper(d);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2(
	function (size, count) {
		return (count < 8) ? _Utils_Tuple2(8, (size - count) - 1) : ((count < 9) ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, (15 - count) - 1));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2(
	function (size, count) {
		return (count < 6) ? _Utils_Tuple2(count, 8) : ((count < 8) ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2((size - 15) + count, 8));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4(
	function (size, isBlack, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setFormatInfo_:
		while (true) {
			if (count < 15) {
				var isBlack = isBlackFn(count);
				var _v0 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical, size, count);
				var x2 = _v0.a;
				var y2 = _v0.b;
				var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal, size, count);
				var x1 = _v1.a;
				var y1 = _v1.b;
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A5(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule,
					size,
					isBlack,
					x2,
					y2,
					A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setFormatInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4(
	function (ecLevel, size, mask, matrix) {
		var isBlack = F2(
			function (bits_, count) {
				return (1 & (bits_ >> count)) === 1;
			});
		var bits = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo, ecLevel, mask);
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			isBlack(bits),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5(
	function (ecLevel, size, matrix, mask, _v0) {
		var minSMatrix = _v0.a;
		var minScore = _v0.b;
		var maskedMatrix = A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo,
			ecLevel,
			size,
			mask,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask, size, mask, matrix));
		var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore, size, maskedMatrix);
		var maskSMatrix = _v1.a;
		var maskScore = _v1.b;
		return ((_Utils_cmp(minScore, maskScore) < 0) && (!_Utils_eq(minScore, -1))) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = 0;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = 1;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = 2;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = 4;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = 5;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = 6;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = 7;
var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7]);
var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3(
	function (ecLevel, size, matrix) {
		return A3(
			$elm$core$List$foldl,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix),
			_Utils_Tuple2(_List_Nil, -1),
			$pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2(
	function (size, matrix) {
		return A4(
			$pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_,
			size,
			$elm$core$Basics$always(true),
			0,
			matrix);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function (version) {
	var g18Int = 7973;
	var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
	var helper = function (d_) {
		helper:
		while (true) {
			if (($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit) >= 0) {
				var $temp$d_ = d_ ^ (g18Int << ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit));
				d_ = $temp$d_;
				continue helper;
			} else {
				return d_ | (version << 12);
			}
		}
	};
	var d = version << 12;
	return helper(d);
};
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3(
	function (size, isBlack, _v0) {
		var row = _v0.a;
		var col = _v0.b;
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			$elm$core$Maybe$Just(
				_Utils_Tuple2(true, isBlack)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4(
	function (size, isBlackFn, count, matrix) {
		setVersionInfo_:
		while (true) {
			if (count < 18) {
				var topRight = _Utils_Tuple2(
					$elm$core$Basics$floor(count / 3),
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3);
				var isBlack = isBlackFn(count);
				var bottomLeft = _Utils_Tuple2(
					((A2($elm$core$Basics$modBy, 3, count) + size) - 8) - 3,
					$elm$core$Basics$floor(count / 3));
				var $temp$size = size,
					$temp$isBlackFn = isBlackFn,
					$temp$count = count + 1,
					$temp$matrix = A4(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule,
					size,
					isBlack,
					bottomLeft,
					A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix));
				size = $temp$size;
				isBlackFn = $temp$isBlackFn;
				count = $temp$count;
				matrix = $temp$matrix;
				continue setVersionInfo_;
			} else {
				return matrix;
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3(
	function (version, size, matrix) {
		if (version >= 7) {
			var isBlack = F2(
				function (bits_, count) {
					return (1 & (bits_ >> count)) === 1;
				});
			var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
			return A4(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_,
				size,
				isBlack(bits),
				0,
				matrix);
		} else {
			return matrix;
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2(
	function (row, col) {
		return (!A2($elm$core$Basics$modBy, 2, row + col)) ? $elm$core$Maybe$Just(
			_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(
			_Utils_Tuple2(true, false));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3(
	function (size, row, col) {
		return A2(
			$elm$core$Array$set,
			A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col),
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor, row, col));
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2(
	function (size, matrix) {
		var range = A2($elm$core$List$range, 8, size - 9);
		return A3(
			$elm$core$List$foldl,
			function (b) {
				return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, b, 6);
			},
			A3(
				$elm$core$List$foldl,
				A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6),
				matrix,
				range),
			range);
	});
var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function (_v0) {
	var ecLevel = _v0.a.N5;
	var groupInfo = _v0.a.adF;
	var bytes = _v0.b;
	var version = groupInfo.HO;
	var size = ((version - 1) * 4) + 21;
	return A2(
		$elm$core$Result$map,
		A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size),
		A2(
			$elm$core$Result$map,
			A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes),
			A3(
				$pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern,
				version,
				size,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern,
					size,
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule,
						version,
						size,
						A3(
							$pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo,
							version,
							size,
							A2(
								$pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo,
								size,
								A4(
									$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
									size,
									-1,
									size - 8,
									A4(
										$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
										size,
										size - 8,
										-1,
										A4(
											$pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern,
											size,
											-1,
											-1,
											A2(
												$elm$core$Array$initialize,
												size * size,
												$elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
};
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = 3;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = 0;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = 1;
var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = 2;
var $pablohirafuji$elm_qrcode$QRCode$convertEC = function (ec) {
	switch (ec) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {$: 0};
var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {$: 1};
var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {$: 3};
var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {$: 6};
var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$convertError = function (e) {
	switch (e.$) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
		case 3:
			return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
		case 4:
			var n = e.a;
			return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
		case 5:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
		case 6:
			return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2(
	function (capacity, bytes) {
		var fillerLength = ((capacity / 8) | 0) - $elm$core$List$length(bytes);
		var ns = $elm$core$List$concat(
			A2(
				$elm$core$List$repeat,
				(fillerLength / 2) | 0,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte, $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte])));
		return (!A2($elm$core$Basics$modBy, 2, fillerLength)) ? _Utils_ap(bytes, ns) : _Utils_ap(
			bytes,
			_Utils_ap(
				ns,
				_List_fromArray(
					[$pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte])));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3(
	function (capacity, bitsCount, bits) {
		return _Utils_ap(
			bits,
			_List_fromArray(
				[
					_Utils_Tuple2(
					0,
					A2($elm$core$Basics$min, 4, capacity - bitsCount))
				]));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function (_v0) {
	bitsToBytes3:
	while (true) {
		var _v1 = _v0.a;
		var bits = _v1.a;
		var length = _v1.b;
		var bytes = _v0.b;
		if (length >= 8) {
			var remLength = length - 8;
			var remBits = bits & ((1 << remLength) - 1);
			var _byte = bits >> remLength;
			var $temp$_v0 = _Utils_Tuple2(
				_Utils_Tuple2(remBits, remLength),
				A2($elm$core$List$cons, _byte, bytes));
			_v0 = $temp$_v0;
			continue bitsToBytes3;
		} else {
			return _Utils_Tuple2(
				_Utils_Tuple2(bits, length),
				bytes);
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2(
	function (_v0, _v1) {
		var curBits = _v0.a;
		var curLength = _v0.b;
		var _v2 = _v1.a;
		var remBits = _v2.a;
		var remLength = _v2.b;
		var bytes = _v1.b;
		var lengthSum = curLength + remLength;
		var bitsSum = curBits | (remBits << curLength);
		return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(
			_Utils_Tuple2(
				_Utils_Tuple2(bitsSum, lengthSum),
				bytes));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2(
	function (bits, _v0) {
		bitsToBytes1:
		while (true) {
			var _v1 = _v0.a;
			var remBits = _v1.a;
			var remLength = _v1.b;
			var bytes = _v0.b;
			if (bits.b) {
				var head = bits.a;
				var tail = bits.b;
				var $temp$bits = tail,
					$temp$_v0 = A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2,
					head,
					_Utils_Tuple2(
						_Utils_Tuple2(remBits, remLength),
						bytes));
				bits = $temp$bits;
				_v0 = $temp$_v0;
				continue bitsToBytes1;
			} else {
				return (!remLength) ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(
					A2($elm$core$List$cons, remBits << (8 - remLength), bytes));
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function (bits) {
	return A2(
		$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1,
		bits,
		_Utils_Tuple2(
			_Utils_Tuple2(0, 0),
			_List_Nil));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = 3;
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2(
	function (mode, version) {
		if (version <= 9) {
			switch (mode) {
				case 0:
					return 10;
				case 1:
					return 9;
				case 2:
					return 8;
				default:
					return 8;
			}
		} else {
			if (version <= 26) {
				switch (mode) {
					case 0:
						return 12;
					case 1:
						return 11;
					case 2:
						return 16;
					default:
						return 16;
				}
			} else {
				switch (mode) {
					case 0:
						return 14;
					case 1:
						return 13;
					case 2:
						return 16;
					default:
						return 16;
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2(
	function (_v0, bits) {
		var groupInfo = _v0.adF;
		var inputStr = _v0.FD;
		var mode = _v0.y7;
		var length = A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.HO);
		var charCount = (mode === 3) ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
		return _Utils_Tuple2(charCount, length);
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function (mode) {
	switch (mode) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 4;
		default:
			return 4;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function (_v0) {
	var bits = _v0.a;
	var model = _v0.b;
	return _Utils_Tuple2(
		model,
		A2(
			$pablohirafuji$elm_qrcode$QRCode$Encode$addFiller,
			model.adF.vV,
			$pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator,
					model.adF.vV,
					model.Eh,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							$pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.y7),
							4),
						A2(
							$elm$core$List$cons,
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator, model, bits),
							bits))))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	var ecBlocks = _v0.c;
	return _Utils_Tuple2(
		model,
		$elm$core$List$concat(
			_Utils_ap(
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks),
				$pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var okayXs = $elm$core$List$length(xs) > 0;
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayXs) ? A2(
			$elm$core$List$cons,
			A2($elm$core$List$take, size, xs),
			A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {$: 2};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('0', 0),
			_Utils_Tuple2('1', 1),
			_Utils_Tuple2('2', 2),
			_Utils_Tuple2('3', 3),
			_Utils_Tuple2('4', 4),
			_Utils_Tuple2('5', 5),
			_Utils_Tuple2('6', 6),
			_Utils_Tuple2('7', 7),
			_Utils_Tuple2('8', 8),
			_Utils_Tuple2('9', 9),
			_Utils_Tuple2('A', 10),
			_Utils_Tuple2('B', 11),
			_Utils_Tuple2('C', 12),
			_Utils_Tuple2('D', 13),
			_Utils_Tuple2('E', 14),
			_Utils_Tuple2('F', 15),
			_Utils_Tuple2('G', 16),
			_Utils_Tuple2('H', 17),
			_Utils_Tuple2('I', 18),
			_Utils_Tuple2('J', 19),
			_Utils_Tuple2('K', 20),
			_Utils_Tuple2('L', 21),
			_Utils_Tuple2('M', 22),
			_Utils_Tuple2('N', 23),
			_Utils_Tuple2('O', 24),
			_Utils_Tuple2('P', 25),
			_Utils_Tuple2('Q', 26),
			_Utils_Tuple2('R', 27),
			_Utils_Tuple2('S', 28),
			_Utils_Tuple2('T', 29),
			_Utils_Tuple2('U', 30),
			_Utils_Tuple2('V', 31),
			_Utils_Tuple2('W', 32),
			_Utils_Tuple2('X', 33),
			_Utils_Tuple2('Y', 34),
			_Utils_Tuple2('Z', 35),
			_Utils_Tuple2(' ', 36),
			_Utils_Tuple2('$', 37),
			_Utils_Tuple2('%', 38),
			_Utils_Tuple2('*', 39),
			_Utils_Tuple2('+', 40),
			_Utils_Tuple2('-', 41),
			_Utils_Tuple2('.', 42),
			_Utils_Tuple2('/', 43),
			_Utils_Tuple2(':', 44)
		]));
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function (_char) {
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar,
		A2($elm$core$Dict$get, _char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function (chars) {
	_v0$2:
	while (true) {
		if (chars.b) {
			if (chars.b.b) {
				if (!chars.b.b.b) {
					var firstChar = chars.a;
					var _v1 = chars.b;
					var secondChar = _v1.a;
					return A3(
						$elm$core$Result$map2,
						F2(
							function (firstCode, secondCode) {
								return _Utils_Tuple2((firstCode * 45) + secondCode, 11);
							}),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar),
						$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
				} else {
					break _v0$2;
				}
			} else {
				var _char = chars.a;
				return A2(
					$elm$core$Result$map,
					function (a) {
						return _Utils_Tuple2(a, 6);
					},
					$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				2,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function (str) {
	return $elm$core$Result$Ok(
		A2(
			$elm$core$List$map,
			function (a) {
				return _Utils_Tuple2(
					$elm$core$Char$toCode(a),
					8);
			},
			$elm$core$String$toList(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {$: 1};
var $elm$core$String$fromList = _String_fromList;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function (str) {
	var _v0 = $elm$core$String$length(str);
	switch (_v0) {
		case 1:
			return 4;
		case 2:
			return 7;
		default:
			return 10;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function (chars) {
	var str = $elm$core$String$fromList(chars);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar,
		A2(
			$elm$core$Maybe$map,
			function (a) {
				return _Utils_Tuple2(
					a,
					$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
			},
			$elm$core$String$toInt(str)));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function (str) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Result$map2($elm$core$List$cons),
		$elm$core$Result$Ok(_List_Nil),
		A2(
			$elm$core$List$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp,
			A2(
				$elm_community$list_extra$List$Extra$greedyGroupsOf,
				3,
				$elm$core$String$toList(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {$: 3};
var $elm$bytes$Bytes$Encode$getStringWidth = _Bytes_getStringWidth;
var $elm$bytes$Bytes$Decode$loopHelp = F4(
	function (state, callback, bites, offset) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var decoder = _v0;
			var _v1 = A2(decoder, bites, offset);
			var newOffset = _v1.a;
			var step = _v1.b;
			if (!step.$) {
				var newState = step.a;
				var $temp$state = newState,
					$temp$callback = callback,
					$temp$bites = bites,
					$temp$offset = newOffset;
				state = $temp$state;
				callback = $temp$callback;
				bites = $temp$bites;
				offset = $temp$offset;
				continue loopHelp;
			} else {
				var result = step.a;
				return _Utils_Tuple2(newOffset, result);
			}
		}
	});
var $elm$bytes$Bytes$Decode$loop = F2(
	function (state, callback) {
		return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
	});
var $elm$bytes$Bytes$Decode$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$bytes$Bytes$Decode$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$bytes$Bytes$Decode$map = F2(
	function (func, _v0) {
		var decodeA = _v0;
		return F2(
			function (bites, offset) {
				var _v1 = A2(decodeA, bites, offset);
				var aOffset = _v1.a;
				var a = _v1.b;
				return _Utils_Tuple2(
					aOffset,
					func(a));
			});
	});
var $elm$bytes$Bytes$Decode$succeed = function (a) {
	return F2(
		function (_v0, offset) {
			return _Utils_Tuple2(offset, a);
		});
};
var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step = function (_v0) {
	var n = _v0.a;
	var xs = _v0.b;
	return (n <= 0) ? $elm$bytes$Bytes$Decode$succeed(
		$elm$bytes$Bytes$Decode$Done(
			$elm$core$List$reverse(xs))) : A2(
		$elm$bytes$Bytes$Decode$map,
		function (x) {
			return $elm$bytes$Bytes$Decode$Loop(
				_Utils_Tuple2(
					n - 1,
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(x, 8),
						xs)));
		},
		$elm$bytes$Bytes$Decode$unsignedInt8);
};
var $elm$bytes$Bytes$Encode$Utf8 = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $elm$bytes$Bytes$Encode$string = function (str) {
	return A2(
		$elm$bytes$Bytes$Encode$Utf8,
		_Bytes_getStringWidth(str),
		str);
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function (str) {
	var utf8BytesWidth = $elm$bytes$Bytes$Encode$getStringWidth(str);
	var decoder = A2(
		$elm$bytes$Bytes$Decode$loop,
		_Utils_Tuple2(utf8BytesWidth, _List_Nil),
		$pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step);
	return A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char,
		A2(
			$elm$bytes$Bytes$Decode$decode,
			decoder,
			$elm$bytes$Bytes$Encode$encode(
				$elm$bytes$Bytes$Encode$string(str))));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function (mode) {
	switch (mode) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(
	_List_fromArray(
		[1, 2, 4, 8, 16, 32, 64, 128, 29, 58, 116, 232, 205, 135, 19, 38, 76, 152, 45, 90, 180, 117, 234, 201, 143, 3, 6, 12, 24, 48, 96, 192, 157, 39, 78, 156, 37, 74, 148, 53, 106, 212, 181, 119, 238, 193, 159, 35, 70, 140, 5, 10, 20, 40, 80, 160, 93, 186, 105, 210, 185, 111, 222, 161, 95, 190, 97, 194, 153, 47, 94, 188, 101, 202, 137, 15, 30, 60, 120, 240, 253, 231, 211, 187, 107, 214, 177, 127, 254, 225, 223, 163, 91, 182, 113, 226, 217, 175, 67, 134, 17, 34, 68, 136, 13, 26, 52, 104, 208, 189, 103, 206, 129, 31, 62, 124, 248, 237, 199, 147, 59, 118, 236, 197, 151, 51, 102, 204, 133, 23, 46, 92, 184, 109, 218, 169, 79, 158, 33, 66, 132, 21, 42, 84, 168, 77, 154, 41, 82, 164, 85, 170, 73, 146, 57, 114, 228, 213, 183, 115, 230, 209, 191, 99, 198, 145, 63, 126, 252, 229, 215, 179, 123, 246, 241, 255, 227, 219, 171, 75, 150, 49, 98, 196, 149, 55, 110, 220, 165, 87, 174, 65, 130, 25, 50, 100, 200, 141, 7, 14, 28, 56, 112, 224, 221, 167, 83, 166, 81, 162, 89, 178, 121, 242, 249, 239, 195, 155, 43, 86, 172, 69, 138, 9, 18, 36, 72, 144, 61, 122, 244, 245, 247, 243, 251, 235, 203, 139, 11, 22, 44, 88, 176, 125, 250, 233, 207, 131, 27, 54, 108, 216, 173, 71, 142, 1]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function (index) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, 255, index),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {$: 5};
var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function (a) {
	return {$: 4, a: a};
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 25, 2, 50, 26, 198, 3, 223, 51, 238, 27, 104, 199, 75, 4, 100, 224, 14, 52, 141, 239, 129, 28, 193, 105, 248, 200, 8, 76, 113, 5, 138, 101, 47, 225, 36, 15, 33, 53, 147, 142, 218, 240, 18, 130, 69, 29, 181, 194, 125, 106, 39, 249, 185, 201, 154, 9, 120, 77, 228, 114, 166, 6, 191, 139, 98, 102, 221, 48, 253, 226, 152, 37, 179, 16, 145, 34, 136, 54, 208, 148, 206, 143, 150, 219, 189, 241, 210, 19, 92, 131, 56, 70, 64, 30, 66, 182, 163, 195, 72, 126, 110, 107, 58, 40, 84, 250, 133, 186, 61, 202, 94, 155, 159, 10, 21, 121, 43, 78, 212, 229, 172, 115, 243, 167, 87, 7, 112, 192, 247, 140, 128, 99, 13, 103, 74, 222, 237, 49, 197, 254, 24, 227, 165, 153, 119, 38, 184, 180, 124, 17, 68, 146, 217, 35, 32, 137, 46, 55, 63, 209, 91, 149, 188, 207, 205, 144, 135, 151, 178, 220, 252, 190, 97, 242, 86, 211, 171, 20, 42, 93, 158, 132, 60, 57, 83, 71, 109, 65, 162, 31, 45, 67, 216, 183, 123, 164, 118, 196, 23, 73, 236, 127, 12, 111, 246, 108, 161, 59, 82, 41, 157, 85, 170, 251, 96, 134, 177, 187, 204, 62, 90, 203, 89, 95, 176, 156, 169, 160, 81, 11, 245, 22, 235, 122, 117, 44, 215, 79, 174, 213, 233, 230, 231, 173, 232, 116, 214, 244, 234, 168, 80, 88, 175]));
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function (index) {
	return (index < 1) ? $elm$core$Result$Err(
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : A2(
		$elm$core$Result$fromMaybe,
		$pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index),
		A2($elm$core$Array$get, index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function (_v0) {
	getOffset:
	while (true) {
		var num = _v0.a;
		var offset = _v0.b;
		if (num.b) {
			var head = num.a;
			var tail = num.b;
			if (!head) {
				var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
				_v0 = $temp$_v0;
				continue getOffset;
			} else {
				return offset;
			}
		} else {
			return offset;
		}
	}
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2(
	function (num, shift) {
		var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(
			_Utils_Tuple2(num, 0));
		var numArray = $elm$core$Array$fromList(num);
		return A2(
			$elm$core$Array$initialize,
			($elm$core$List$length(num) - offset) + shift,
			function (index) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($elm$core$Array$get, index + offset, numArray));
			});
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2(
	function (poly1, poly2) {
		var valuesArray = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index1, value1) {
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (index2, value2) {
								return _Utils_Tuple3(index1 + index2, value1, value2);
							}),
						$elm$core$Array$toList(poly2));
				}),
			$elm$core$Array$toList(poly1));
		var process__ = F3(
			function (indexSum, num_, exp) {
				return A2(
					$elm$core$Result$fromMaybe,
					$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Bitwise$xor(exp),
						A2($elm$core$Array$get, indexSum, num_)));
			});
		var process_ = F2(
			function (_v0, num_) {
				var indexSum = _v0.a;
				var value1 = _v0.b;
				var value2 = _v0.c;
				return A2(
					$elm$core$Result$map,
					function (r) {
						return A3($elm$core$Array$set, indexSum, r, num_);
					},
					A2(
						$elm$core$Result$andThen,
						A2(process__, indexSum, num_),
						A2(
							$elm$core$Result$map,
							$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
							A3(
								$elm$core$Result$map2,
								$elm$core$Basics$add,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1),
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
			});
		var process = F2(
			function (args, numResult) {
				return A2(
					$elm$core$Result$andThen,
					process_(args),
					numResult);
			});
		var num = A2(
			$elm$core$Array$initialize,
			($elm$core$Array$length(poly1) + $elm$core$Array$length(poly2)) - 1,
			$elm$core$Basics$always(0));
		return A2(
			$elm$core$Result$map,
			function (a) {
				return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
			},
			A2(
				$elm$core$Result$map,
				$elm$core$Array$toList,
				A3(
					$elm$core$List$foldl,
					process,
					$elm$core$Result$Ok(num),
					$elm$core$List$concat(valuesArray))));
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function (ecLength) {
	var generate = F2(
		function (count, polyResult) {
			generate:
			while (true) {
				if (_Utils_cmp(count, ecLength) < 0) {
					var $temp$count = count + 1,
						$temp$polyResult = A2(
						$elm$core$Result$andThen,
						function (a) {
							return A2(
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply,
								a,
								A2(
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
									_List_fromArray(
										[
											1,
											$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
										]),
									0));
						},
						polyResult);
					count = $temp$count;
					polyResult = $temp$polyResult;
					continue generate;
				} else {
					return polyResult;
				}
			}
		});
	return A2(
		generate,
		0,
		$elm$core$Result$Ok(
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
				_List_fromArray(
					[1]),
				0)));
};
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2(
	function (ecLength, modPoly) {
		return $elm$core$Array$toList(
			A2(
				$elm$core$Array$initialize,
				ecLength,
				function (index) {
					var modIndex = (index + $elm$core$Array$length(modPoly)) - ecLength;
					return (modIndex >= 0) ? A2(
						$elm$core$Maybe$withDefault,
						0,
						A2($elm$core$Array$get, modIndex, modPoly)) : 0;
				}));
	});
var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {$: 6};
var $elm$core$Array$foldl = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldl,
			func,
			A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree),
			tail);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2(
	function (poly1, poly2) {
		if (($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2)) < 0) {
			return $elm$core$Result$Ok(poly1);
		} else {
			var helper_ = F3(
				function (index2, poly1_, exp) {
					return A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2(
							$elm$core$Maybe$map,
							$elm$core$Bitwise$xor(exp),
							A2($elm$core$Array$get, index2, poly1_)));
				});
			var getHead = function (poly) {
				return A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog,
					A2(
						$elm$core$Result$fromMaybe,
						$pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException,
						A2($elm$core$Array$get, 0, poly)));
			};
			var ratio = A3(
				$elm$core$Result$map2,
				$elm$core$Basics$sub,
				getHead(poly1),
				getHead(poly2));
			var helper = F2(
				function (_v0, poly1_) {
					var index2 = _v0.a;
					var value2 = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (r) {
							return A3($elm$core$Array$set, index2, r, poly1_);
						},
						A2(
							$elm$core$Result$andThen,
							A2(helper_, index2, poly1_),
							A2(
								$elm$core$Result$map,
								$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp,
								A3(
									$elm$core$Result$map2,
									$elm$core$Basics$add,
									ratio,
									$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
				});
			var numFold = F2(
				function (args, poly1Result) {
					return A2(
						$elm$core$Result$andThen,
						helper(args),
						poly1Result);
				});
			var numResult = A3(
				$elm$core$Array$foldl,
				numFold,
				$elm$core$Result$Ok(poly1),
				A2(
					$elm$core$Array$indexedMap,
					F2(
						function (a, b) {
							return _Utils_Tuple2(a, b);
						}),
					poly2));
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, poly2);
				},
				A2(
					$elm$core$Result$map,
					function (a) {
						return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
					},
					A2($elm$core$Result$map, $elm$core$Array$toList, numResult)));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2(
	function (rsPoly, dataCodewords) {
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___(
				$elm$core$Array$length(rsPoly) - 1),
			A2(
				$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod,
				A2(
					$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial,
					dataCodewords,
					$elm$core$Array$length(rsPoly) - 1),
				rsPoly));
	});
var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3(
	function (fun, listb, lista) {
		if (lista.b) {
			var head = lista.a;
			var tail = lista.b;
			return A2(
				$elm$core$Result$andThen,
				function (a) {
					return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, fun, a, tail);
				},
				A2(
					$elm$core$Result$map,
					function (r) {
						return A2($elm$core$List$cons, r, listb);
					},
					fun(head)));
		} else {
			return $elm$core$Result$Ok(
				$elm$core$List$reverse(listb));
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2(
	function (byteBlocks, rsPoly) {
		return A3(
			$pablohirafuji$elm_qrcode$QRCode$Helpers$listResult,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly),
			_List_Nil,
			byteBlocks);
	});
var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2(
	function (ecPerBlock, byteBlocks) {
		return A2(
			$elm$core$Result$andThen,
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks),
			$pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function (_v0) {
	var model = _v0.a;
	var dataBlocks = _v0.b;
	return A2(
		$elm$core$Result$map,
		function (c) {
			return _Utils_Tuple3(model, dataBlocks, c);
		},
		A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get, model.adF.acS, dataBlocks));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = 1;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = 2;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = 0;
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2(
	$elm$regex$Regex$fromStringWith,
	{abS: false, aeK: false},
	'^[0-9A-Z $%*+\\-.\\/:]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2(
	$elm$regex$Regex$fromStringWith,
	{abS: false, aeK: false},
	'^[\\u0000-\\u00ff]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2(
	$elm$regex$Regex$fromStringWith,
	{abS: false, aeK: false},
	'^[0-9]+$');
var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function (input) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (r) {
				return A2($elm$regex$Regex$contains, r, input);
			},
			$pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function (input) {
	return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? 0 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? 1 : ($pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? 2 : 3));
};
var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {$: 7};
var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3(
	function (mode, dataLength, _v0) {
		var version = _v0.HO;
		var capacity = _v0.vV;
		return _Utils_cmp(
			A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, version) + dataLength,
			capacity) < 1;
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function (_v0) {
	var blockCount = _v0.a;
	var bytePerBlock = _v0.b;
	return blockCount * bytePerBlock;
};
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2(
	function (group1, maybeGroup2) {
		if (!maybeGroup2.$) {
			var block2 = maybeGroup2.a;
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
		} else {
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4(
	function (version, ecPerBlock, group1, maybeGroup2) {
		return {
			vV: A2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity, group1, maybeGroup2) * 8,
			acS: ecPerBlock,
			PV: group1,
			aey: maybeGroup2,
			HO: version
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		17,
		_Utils_Tuple2(1, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		28,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		22,
		_Utils_Tuple2(2, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		16,
		_Utils_Tuple2(4, 9),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		22,
		_Utils_Tuple2(2, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		28,
		_Utils_Tuple2(4, 15),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		26,
		_Utils_Tuple2(4, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		26,
		_Utils_Tuple2(4, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		24,
		_Utils_Tuple2(4, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		28,
		_Utils_Tuple2(6, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		24,
		_Utils_Tuple2(3, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(8, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		28,
		_Utils_Tuple2(7, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(12, 11),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 12))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(11, 12),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 13))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		30,
		_Utils_Tuple2(3, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(17, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(9, 13),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 14))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(15, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		30,
		_Utils_Tuple2(19, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		24,
		_Utils_Tuple2(34, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(16, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(30, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		30,
		_Utils_Tuple2(33, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(12, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(23, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(28, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(19, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(11, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(59, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(22, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(41, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(64, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(24, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(46, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(42, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(10, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(67, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(20, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(61, 16)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		7,
		_Utils_Tuple2(1, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		10,
		_Utils_Tuple2(1, 34),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		15,
		_Utils_Tuple2(1, 55),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		20,
		_Utils_Tuple2(1, 80),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		26,
		_Utils_Tuple2(1, 108),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		20,
		_Utils_Tuple2(2, 78),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		24,
		_Utils_Tuple2(2, 97),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		30,
		_Utils_Tuple2(2, 116),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		18,
		_Utils_Tuple2(2, 68),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 69))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		20,
		_Utils_Tuple2(4, 81),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		24,
		_Utils_Tuple2(2, 92),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 93))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		26,
		_Utils_Tuple2(4, 107),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		30,
		_Utils_Tuple2(3, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		22,
		_Utils_Tuple2(5, 87),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 88))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(5, 98),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 99))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		30,
		_Utils_Tuple2(5, 120),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 121))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		28,
		_Utils_Tuple2(3, 113),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 114))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		28,
		_Utils_Tuple2(3, 107),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 108))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(4, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(2, 111),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 112))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(4, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(6, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		26,
		_Utils_Tuple2(8, 106),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 107))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(10, 114),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 115))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(3, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(7, 116),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 117))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(5, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(17, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(13, 115),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 116))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(12, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(6, 121),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 122))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(17, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(4, 122),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(18, 123))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(20, 117),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 118))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(19, 118),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 119)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		10,
		_Utils_Tuple2(1, 16),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		16,
		_Utils_Tuple2(1, 28),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		26,
		_Utils_Tuple2(1, 44),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		18,
		_Utils_Tuple2(2, 32),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		24,
		_Utils_Tuple2(2, 43),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		16,
		_Utils_Tuple2(4, 27),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(4, 31),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(2, 38),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 39))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		22,
		_Utils_Tuple2(3, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		26,
		_Utils_Tuple2(4, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		30,
		_Utils_Tuple2(1, 50),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 51))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		22,
		_Utils_Tuple2(6, 36),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 37))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		22,
		_Utils_Tuple2(8, 37),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 38))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		24,
		_Utils_Tuple2(4, 40),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 41))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		24,
		_Utils_Tuple2(5, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		28,
		_Utils_Tuple2(7, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		26,
		_Utils_Tuple2(9, 43),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 44))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(3, 44),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(11, 45))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		26,
		_Utils_Tuple2(3, 41),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 42))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		26,
		_Utils_Tuple2(17, 42),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		28,
		_Utils_Tuple2(17, 46),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		28,
		_Utils_Tuple2(4, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		28,
		_Utils_Tuple2(6, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		28,
		_Utils_Tuple2(8, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(13, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(19, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		28,
		_Utils_Tuple2(22, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(3, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		28,
		_Utils_Tuple2(3, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		28,
		_Utils_Tuple2(21, 45),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 46))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		28,
		_Utils_Tuple2(19, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		28,
		_Utils_Tuple2(2, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(29, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		28,
		_Utils_Tuple2(10, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(21, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		28,
		_Utils_Tuple2(14, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(23, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		28,
		_Utils_Tuple2(12, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		28,
		_Utils_Tuple2(6, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		28,
		_Utils_Tuple2(29, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		28,
		_Utils_Tuple2(13, 46),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(32, 47))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		28,
		_Utils_Tuple2(40, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 48))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		28,
		_Utils_Tuple2(18, 47),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 48)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray(
	[
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		1,
		13,
		_Utils_Tuple2(1, 13),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		2,
		22,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		3,
		18,
		_Utils_Tuple2(2, 17),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		4,
		26,
		_Utils_Tuple2(2, 24),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		5,
		18,
		_Utils_Tuple2(2, 15),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 16))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		6,
		24,
		_Utils_Tuple2(4, 19),
		$elm$core$Maybe$Nothing),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		7,
		18,
		_Utils_Tuple2(2, 14),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 15))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		8,
		22,
		_Utils_Tuple2(4, 18),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 19))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		9,
		20,
		_Utils_Tuple2(4, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		10,
		24,
		_Utils_Tuple2(6, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		11,
		28,
		_Utils_Tuple2(4, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		12,
		26,
		_Utils_Tuple2(4, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		13,
		24,
		_Utils_Tuple2(8, 20),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 21))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		14,
		20,
		_Utils_Tuple2(11, 16),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 17))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		15,
		30,
		_Utils_Tuple2(5, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		16,
		24,
		_Utils_Tuple2(15, 19),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(2, 20))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		17,
		28,
		_Utils_Tuple2(1, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(15, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		18,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		19,
		26,
		_Utils_Tuple2(17, 21),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(4, 22))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		20,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(5, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		21,
		28,
		_Utils_Tuple2(17, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		22,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		23,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		24,
		30,
		_Utils_Tuple2(11, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(16, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		25,
		30,
		_Utils_Tuple2(7, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		26,
		28,
		_Utils_Tuple2(28, 22),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(6, 23))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		27,
		30,
		_Utils_Tuple2(8, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(26, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		28,
		30,
		_Utils_Tuple2(4, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(31, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		29,
		30,
		_Utils_Tuple2(1, 23),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(37, 24))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		30,
		30,
		_Utils_Tuple2(15, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(25, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		31,
		30,
		_Utils_Tuple2(42, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(1, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		32,
		30,
		_Utils_Tuple2(10, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(35, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		33,
		30,
		_Utils_Tuple2(29, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(19, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		34,
		30,
		_Utils_Tuple2(44, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(7, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		35,
		30,
		_Utils_Tuple2(39, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		36,
		30,
		_Utils_Tuple2(46, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		37,
		30,
		_Utils_Tuple2(49, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(10, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		38,
		30,
		_Utils_Tuple2(48, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(14, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		39,
		30,
		_Utils_Tuple2(43, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(22, 25))),
		A4(
		$pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo,
		40,
		30,
		_Utils_Tuple2(34, 24),
		$elm$core$Maybe$Just(
			_Utils_Tuple2(34, 25)))
	]);
var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function (ecLevel) {
	switch (ecLevel) {
		case 0:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
		case 1:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
		case 2:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
		default:
			return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3(
	function (ecLevel, mode, dataLength) {
		return A2(
			$elm$core$Result$fromMaybe,
			$pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow,
			$elm$core$List$head(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.vV;
					},
					A2(
						$elm$core$List$filter,
						A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength),
						$pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5(
	function (inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
		return {
			Eh: partialBitsCount + A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.HO),
			N5: ecLevel,
			adF: groupInfo,
			FD: inputStr,
			y7: mode
		};
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4(
	function (inputStr, ecLevel, mode, encodedStr) {
		var partialBitsCount = 4 + A3(
			$elm$core$List$foldl,
			F2(
				function (a, b) {
					return a.b + b;
				}),
			0,
			encodedStr);
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(encodedStr, b);
			},
			A2(
				$elm$core$Result$map,
				A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount),
				A3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion, ecLevel, mode, partialBitsCount)));
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3(
	function (checkFinish, _v0, _v1) {
		breakList:
		while (true) {
			var times = _v0.a;
			var itemCount = _v0.b;
			var byteList = _v1.a;
			var progress = _v1.b;
			if (times > 0) {
				var remainList = A2($elm$core$List$drop, itemCount, byteList);
				var block = A2($elm$core$List$take, itemCount, byteList);
				var $temp$checkFinish = checkFinish,
					$temp$_v0 = _Utils_Tuple2(times - 1, itemCount),
					$temp$_v1 = _Utils_Tuple2(
					remainList,
					A2($elm$core$List$cons, block, progress));
				checkFinish = $temp$checkFinish;
				_v0 = $temp$_v0;
				_v1 = $temp$_v1;
				continue breakList;
			} else {
				if (checkFinish && ($elm$core$List$length(byteList) > 0)) {
					return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
				} else {
					return $elm$core$Result$Ok(
						_Utils_Tuple2(byteList, progress));
				}
			}
		}
	});
var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function (_v0) {
	var model = _v0.a;
	var groupInfo = model.adF;
	var byteList = _v0.b;
	var _v1 = groupInfo.aey;
	if (!_v1.$) {
		var group2 = _v1.a;
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A2(
					$elm$core$Result$andThen,
					A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2),
					A3(
						$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
						false,
						groupInfo.PV,
						_Utils_Tuple2(byteList, _List_Nil)))));
	} else {
		return A2(
			$elm$core$Result$map,
			function (b) {
				return _Utils_Tuple2(model, b);
			},
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse),
				A3(
					$pablohirafuji$elm_qrcode$QRCode$Encode$breakList,
					true,
					groupInfo.PV,
					_Utils_Tuple2(byteList, _List_Nil))));
	}
};
var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2(
	function (inputStr, ecLevel) {
		var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
		return A2(
			$elm$core$Result$map,
			$pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose,
			A2(
				$elm$core$Result$andThen,
				$pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection,
				A2(
					$elm$core$Result$andThen,
					$pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks,
					A2(
						$elm$core$Result$map,
						$pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits,
						A2(
							$elm$core$Result$andThen,
							A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode),
							A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$fromStringWith = F2(
	function (ecLevel, input) {
		return A2(
			$elm$core$Result$mapError,
			$pablohirafuji$elm_qrcode$QRCode$convertError,
			A2(
				$elm$core$Result$andThen,
				function (_v0) {
					var encodeModel = _v0.a;
					var encodedData = _v0.b;
					return A2(
						$elm$core$Result$map,
						function (matrix) {
							return {rn: matrix, HO: encodeModel.adF.HO};
						},
						$pablohirafuji$elm_qrcode$QRCode$Matrix$apply(
							_Utils_Tuple2(encodeModel, encodedData)));
				},
				A2(
					$pablohirafuji$elm_qrcode$QRCode$Encode$encode,
					input,
					$pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize = 5;
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect = function (_v0) {
	var lastRect = _v0.a;
	var rowLines = _v0.b;
	return A2(
		$elm$core$List$cons,
		'h' + $elm$core$String$fromInt(lastRect.ahT * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
		rowLines);
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$shapeRendering = _VirtualDom_attribute('shape-rendering');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines = F2(
	function (isDark, _v0) {
		var lastRect = _v0.a;
		var rowLines = _v0.b;
		return isDark ? ((!lastRect.kf) ? _Utils_Tuple2(
			_Utils_update(
				lastRect,
				{ahT: lastRect.ahT + 1}),
			rowLines) : _Utils_Tuple2(
			{kf: 0, ahT: 1},
			A2(
				$elm$core$List$cons,
				$elm$core$String$concat(
					_List_fromArray(
						[
							(lastRect.ahT > 0) ? ('h' + $elm$core$String$fromInt(lastRect.ahT * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize)) : '',
							'm',
							$elm$core$String$fromInt(lastRect.kf * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
							' 0'
						])),
				rowLines))) : _Utils_Tuple2(
			_Utils_update(
				lastRect,
				{kf: lastRect.kf + 1}),
			rowLines);
	});
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow = F3(
	function (quietZoneSize, rowIndex, rowLines) {
		return A2(
			$elm$core$List$cons,
			'M0 ',
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(rowIndex * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
				rowLines));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase = F3(
	function (quietZoneSize, extraAttrs, matrix) {
		var quietZonePx = quietZoneSize * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize;
		var sizePx = $elm$core$String$fromInt(
			($elm$core$List$length(matrix) * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + (2 * quietZonePx));
		return A2(
			$elm$svg$Svg$svg,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$viewBox('0 0 ' + (sizePx + (' ' + sizePx))),
						$elm$svg$Svg$Attributes$shapeRendering('crispEdges'),
						$elm$svg$Svg$Attributes$stroke('#000'),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + 'px')
					]),
				extraAttrs),
			function (d) {
				return _List_fromArray(
					[
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								d,
								$elm$svg$Svg$Attributes$transform(
								'translate(' + ($elm$core$String$fromInt(quietZonePx) + (', ' + ($elm$core$String$fromFloat(quietZonePx + ($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize / 2)) + ')')))),
								$elm$svg$Svg$Attributes$style('stroke-width: 5px')
							]),
						_List_Nil)
					]);
			}(
				$elm$svg$Svg$Attributes$d(
					$elm$core$String$concat(
						$elm$core$List$concat(
							A2(
								$elm$core$List$indexedMap,
								$pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow(quietZoneSize),
								A2(
									$elm$core$List$map,
									A2(
										$elm$core$Basics$composeR,
										A2(
											$elm$core$List$foldl,
											$pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines,
											_Utils_Tuple2(
												{kf: 0, ahT: 0},
												_List_Nil)),
										A2($elm$core$Basics$composeR, $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect, $elm$core$List$reverse)),
									matrix)))))));
	});
var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$view = $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase(4);
var $pablohirafuji$elm_qrcode$QRCode$toSvg = F2(
	function (extraAttrs, _v0) {
		var matrix = _v0.rn;
		return A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$view, extraAttrs, matrix);
	});
var $author$project$Pages$User$Mfa$viewQrSteps = function (mfa) {
	var qrCodeImage = function () {
		var _v0 = $author$project$Api$Platform$Mfa$One$qrcode(mfa);
		if (!_v0.$) {
			var qrcode_ = _v0.a;
			return A3(
				$author$project$Ui$Image$fromSrc,
				{I1: 'QR Code'},
				qrcode_,
				_List_Nil);
		} else {
			return A2(
				$elm$core$Result$withDefault,
				A2(
					$author$project$Ui$Alert$danger,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('There was a problem generating the QR code, please contact us.')
						])),
				A2(
					$elm$core$Result$map,
					$pablohirafuji$elm_qrcode$QRCode$toSvg(
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$width('200px'),
								$elm$svg$Svg$Attributes$height('200px')
							])),
					A2(
						$pablohirafuji$elm_qrcode$QRCode$fromStringWith,
						2,
						$author$project$Api$Platform$Mfa$One$qrcodeUrl(mfa))));
		}
	}();
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select the '),
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Scan Barcode')
						])),
					$elm$html$Html$text(' option'),
					$elm$html$Html$text(' (or '),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Click here'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
							$author$project$Ui$Button$onClick($author$project$Pages$User$Mfa$SwitchToManual)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Click here')
						])),
					$elm$html$Html$text(' if you are having issues scanning the code)')
				])),
			A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Scan the following barcode')
						])),
					qrCodeImage
				]))
		]);
};
var $author$project$Pages$User$Mfa$viewInactiveMfa = F2(
	function (_v0, mfa) {
		var method = _v0.F6;
		var otpCode = _v0.rL;
		var activatingMfa = _v0.kP;
		var requiresMfaPrerequisite = _v0.G_;
		var requiresMfa = _v0.Yn;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						((!requiresMfa) && requiresMfaPrerequisite) ? A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('In order to require multi-factor authentication for all users accessing your account, please complete the setup of multi-factor authentication for your account by following the directions below. ')
							])) : $author$project$Utils$Html$empty,
						requiresMfa ? A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To protect patient information, one of your practices requires that all users enable multi-factor authentication to access their account. ')
							])) : $author$project$Utils$Html$empty,
						A2(
						$author$project$Ui$Typography$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To Enable Multi-factor authentication (MFA), you\'ll need the '),
								A2(
								$author$project$Ui$Typography$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Google Authenticator')
									])),
								$elm$html$Html$text(' app, which you can download from the '),
								A3(
								$author$project$Ui$Link$externalHref,
								'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Google Play Store')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(' or the ')
									])),
								A3(
								$author$project$Ui$Link$externalHref,
								'https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Apple App Store.')
									]))
							]))
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$offset(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								$elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Open Google Authenticator on your phone.')
													])),
												A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Tap the + button in Google Authenticator')
													]))
											]),
											function () {
											if (!method) {
												return $author$project$Pages$User$Mfa$viewQrSteps(mfa);
											} else {
												return $author$project$Pages$User$Mfa$viewManualSteps(mfa);
											}
										}(),
											A2($author$project$Pages$User$Mfa$viewActivate, otpCode, activatingMfa)
										])))
							]))
					]))
			]);
	});
var $author$project$Pages$User$Mfa$viewInactiveMfaSkeleton = _List_fromArray(
	[
		A2(
		$author$project$Ui$Element$view,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Skeleton$text(
				_List_fromArray(
					[
						$author$project$Ui$Skeleton$block,
						$author$project$Ui$Skeleton$span(10)
					])),
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_fromArray(
					[$author$project$Ui$FlexGrid$mt2]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$offset(4)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('list-none')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Open Google Authenticator on your phone.')
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$spanFromText('Tap the + button in Google Authenticator')
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(3)
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$card(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(4)
													]))
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Skeleton$text(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$block,
														$author$project$Ui$Skeleton$span(5)
													])),
												$author$project$Ui$Skeleton$input(
												_List_fromArray(
													[
														$author$project$Ui$Skeleton$span(5)
													]))
											]))
									]))
							]))
					]))
			]))
	]);
var $author$project$Pages$User$Mfa$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Multi-factor authentication (MFA)')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(12)
											]),
										function () {
											var _v0 = model.f3;
											if (_v0.$ === 3) {
												var mfa = _v0.a;
												var _v1 = $author$project$Api$Platform$Mfa$One$status(mfa);
												if (!_v1) {
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('text-center')
																]),
															_List_fromArray(
																[
																	$author$project$Ui$Typography$heading(
																	_List_fromArray(
																		[
																			$elm$html$Html$text('You\'re all set!')
																		])),
																	A2(
																	$author$project$Ui$Alert$info,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text('You will be logged out and will need to login again.')
																		]))
																]))
														]);
												} else {
													return A2($author$project$Pages$User$Mfa$viewInactiveMfa, model, mfa);
												}
											} else {
												return $author$project$Pages$User$Mfa$viewInactiveMfaSkeleton;
											}
										}())
									]))
							])),
						function () {
						var _v2 = model.f3;
						if (_v2.$ === 3) {
							var mfa = _v2.a;
							var _v3 = $author$project$Api$Platform$Mfa$One$status(mfa);
							if (_v3 === 1) {
								return A2(
									$author$project$Ui$Panel$footer,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$User__Security,
											_List_fromArray(
												[$author$project$Ui$Link$buttonDefault]),
											_List_fromArray(
												[
													$elm$html$Html$text('Back')
												]))
										]));
							} else {
								return $author$project$Ui$Panel$none;
							}
						} else {
							return $author$project$Ui$Panel$none;
						}
					}()
					]))
			]),
		$G: 'Login'
	};
};
var $author$project$Pages$User$Mfa$page = $author$project$Spa$Page$applicationUser(
	{ad0: $author$project$Pages$User$Mfa$init, aer: $author$project$Pages$User$Mfa$load, agD: $author$project$Pages$User$Mfa$save, ahd: $author$project$Pages$User$Mfa$subscriptions, aaq: $author$project$Pages$User$Mfa$update, ahP: $author$project$Pages$User$Mfa$view});
var $author$project$Pages$User$Organizations$Top$AdminActionsDropdownMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$User$Organizations$Top$GoAsRoleDropdownMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$User$Organizations$Top$PracticesDropdownMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$User$Organizations$Top$TabMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Platform$User$One$companiesCount = function (_v0) {
	var record = _v0.b;
	return record.Lq;
};
var $author$project$Pages$User$Organizations$Top$GotCompanyRoles = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Employer$Role$rolesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['roles']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Role$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$Role$rolesPath));
	});
var $author$project$Pages$User$Organizations$Top$fetchCompanyRoles = function (apiClient) {
	return A2($author$project$Api$Employer$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotCompanyRoles);
};
var $author$project$Pages$User$Organizations$Top$GotCompanies = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$User$Organizations$Top$GotPartners = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$User$Organizations$Top$GotPractices = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$User$Organizations$Top$filterToValue = function (filter) {
	return 'with_flagged_notes';
};
var $author$project$Api$Platform$User$Company$companiesPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['companies']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$Company$All$Company = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Company$Min$Company = $elm$core$Basics$identity;
var $author$project$Api$Platform$Company$Min$Record = F3(
	function (id, name, requiresMfa) {
		return {adR: id, zh: name, Yn: requiresMfa};
	});
var $author$project$Api$Platform$Company$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'requires_mfa',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$Min$Record))));
var $author$project$Api$Platform$Company$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Company$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Company$All$Record = F2(
	function (practice, organizationId) {
		return {aft: organizationId, WF: practice};
	});
var $author$project$Api$Platform$Company$All$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'practice',
		$author$project$Api$Platform$Practice$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$All$Record)));
var $author$project$Api$Platform$Company$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Company$All$recordDecoder,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Platform$Company$Min$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$All$Company)));
var $author$project$Api$Platform$User$Company$listDefaults = {
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$User$Company$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$Company$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Platform$User$Company$list = F4(
	function (apiClient, optionals, maybeTracker, toMsg) {
		var request = function (req) {
			if (!maybeTracker.$) {
				var tracker = maybeTracker.a;
				return A2($author$project$Api$Data$requestWithTracker, tracker, req);
			} else {
				return req;
			}
		}(
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$Company$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Company$companiesPath)));
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Company$All$decoder),
			toMsg,
			request);
	});
var $author$project$Api$Platform$Partner$All$Partner = $elm$core$Basics$identity;
var $author$project$Api$Platform$Partner$Shared$Partner = $elm$core$Basics$identity;
var $author$project$Api$Platform$Partner$Shared$Record = F6(
	function (id, name, requiresMfa, active, status, organizationId) {
		return {Ic: active, adR: id, zh: name, aft: organizationId, Yn: requiresMfa, ag7: status};
	});
var $author$project$Api$Platform$Partner$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'status',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'active',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'requires_mfa',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Platform$Partner$Shared$Record)))))));
var $author$project$Api$Platform$Partner$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Partner$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$Partner$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$Partner$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$User$Partner$listDefaults = {
	afy: $author$project$Api$Pagination$init,
	af_: $elm$core$Maybe$Nothing,
	ag1: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$User$Partner$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$Partner$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.af_;
				if (!_v0.$) {
					var string = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'q', string)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Platform$User$Partner$partnersPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['partners']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Partner$list = F4(
	function (apiClient, optionals, maybeTracker, toMsg) {
		var request = function (req) {
			if (!maybeTracker.$) {
				var tracker = maybeTracker.a;
				return A2($author$project$Api$Data$requestWithTracker, tracker, req);
			} else {
				return req;
			}
		}(
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$Partner$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Partner$partnersPath)));
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Partner$All$decoder),
			toMsg,
			request);
	});
var $author$project$Pages$User$Organizations$Top$organizationSearchTracker = function (q) {
	return 'organization-search-' + A2($elm$core$Maybe$withDefault, '', q);
};
var $author$project$Pages$User$Organizations$Top$fetchOrganizations = function (model) {
	var tracker = $author$project$Pages$User$Organizations$Top$organizationSearchTracker(model.af_);
	var _v0 = model.fj;
	if (!_v0.$) {
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return A4(
					$author$project$Api$Platform$User$Practice$list,
					model.D5,
					function (d) {
						return _Utils_update(
							d,
							{
								Fi: A2($elm$core$Maybe$map, $author$project$Pages$User$Organizations$Top$filterToValue, model.GP),
								afy: model.afy,
								af_: model.af_
							});
					},
					$elm$core$Maybe$Just(tracker),
					$author$project$Pages$User$Organizations$Top$GotPractices);
			case 1:
				var _v2 = _v0.a;
				return A4(
					$author$project$Api$Platform$User$Company$list,
					model.D5,
					function (d) {
						return _Utils_update(
							d,
							{afy: model.afy, af_: model.af_});
					},
					$elm$core$Maybe$Just(tracker),
					$author$project$Pages$User$Organizations$Top$GotCompanies);
			default:
				var _v3 = _v0.a;
				return A4(
					$author$project$Api$Platform$User$Partner$list,
					model.D5,
					function (d) {
						return _Utils_update(
							d,
							{afy: model.afy, af_: model.af_});
					},
					$elm$core$Maybe$Just(tracker),
					$author$project$Pages$User$Organizations$Top$GotPartners);
		}
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Pages$User$Organizations$Top$GotPartnerRoles = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$User$Organizations$Top$fetchPartnerRoles = function (apiClient) {
	return A2($author$project$Api$Partner$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotPartnerRoles);
};
var $author$project$Pages$User$Organizations$Top$GotPracticeRoles = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$User$Organizations$Top$fetchPracticeRoles = function (apiClient) {
	return A2($author$project$Api$Provider$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotPracticeRoles);
};
var $author$project$Pages$User$Organizations$Top$FocusResult = {$: 19};
var $author$project$Pages$User$Organizations$Top$focusSearchInput = A2(
	$elm$core$Task$attempt,
	function (_v0) {
		return $author$project$Pages$User$Organizations$Top$FocusResult;
	},
	$elm$browser$Browser$Dom$focus('organization-search-input'));
var $author$project$Api$Platform$User$One$partnersCount = function (_v0) {
	var record = _v0.b;
	return record.VH;
};
var $author$project$Api$Platform$User$One$practicesCount = function (_v0) {
	var record = _v0.b;
	return record.WM;
};
var $author$project$Api$OrganizationType$toString = function (organizationType) {
	switch (organizationType) {
		case 0:
			return 'practice';
		case 1:
			return 'company';
		default:
			return 'partner';
	}
};
var $author$project$Pages$User$Organizations$Top$init = F4(
	function (session, user, shared, _v0) {
		var organizationTypes = $elm$core$List$concat(
			_List_fromArray(
				[
					($author$project$Api$Platform$User$One$practicesCount(user) > 0) ? _List_fromArray(
					[0]) : _List_Nil,
					($author$project$Api$Platform$User$One$companiesCount(user) > 0) ? _List_fromArray(
					[1]) : _List_Nil,
					($author$project$Api$Platform$User$One$partnersCount(user) > 0) ? _List_fromArray(
					[2]) : _List_Nil
				]));
		var currentUserIsHintAdmin = $author$project$Api$Platform$User$Shared$isAdmin(
			$author$project$Api$Platform$Session$One$user(session));
		var currentOrganizationType = $elm$core$List$head(organizationTypes);
		var _v1 = A2(
			$author$project$Ui$Tabs$init,
			'organization-types',
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $author$project$Api$OrganizationType$toString, currentOrganizationType)));
		var tabsModel = _v1.a;
		var tabsCmd = _v1.b;
		var model = {
			kV: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$toDownLeft(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'admin-actions-dropdown', ahx: $author$project$Pages$User$Organizations$Top$AdminActionsDropdownMsg}))),
			D5: shared.D5,
			abt: shared.adu.abt,
			wH: _List_Nil,
			lF: $author$project$Api$Platform$Session$One$organization(session),
			fj: currentOrganizationType,
			EQ: user,
			ER: currentUserIsHintAdmin,
			ml: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$toDownLeft(
					$author$project$Ui$NewDropdown$defaultConfig(
						{adR: 'go-as-role-dropdown', ahx: $author$project$Pages$User$Organizations$Top$GoAsRoleDropdownMsg}))),
			mq: shared.mq,
			FR: $author$project$Shared$isHintAdmin(shared),
			S_: true,
			nb: organizationTypes,
			rJ: _List_Nil,
			afy: $author$project$Api$Pagination$init,
			VG: _List_Nil,
			AW: _List_Nil,
			nC: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'practices-dropdown-filter', ahx: $author$project$Pages$User$Organizations$Top$PracticesDropdownMsg})),
			GP: $elm$core$Maybe$Nothing,
			af_: $elm$core$Maybe$Nothing,
			sA: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
			ZD: session,
			gV: tabsModel
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Pages$User$Organizations$Top$fetchOrganizations(model),
						A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Organizations$Top$TabMsg, tabsCmd),
						(currentUserIsHintAdmin && A2($elm$core$List$member, 0, organizationTypes)) ? $author$project$Pages$User$Organizations$Top$fetchPracticeRoles(model.D5) : $elm$core$Platform$Cmd$none,
						(currentUserIsHintAdmin && A2($elm$core$List$member, 1, organizationTypes)) ? $author$project$Pages$User$Organizations$Top$fetchCompanyRoles(model.D5) : $elm$core$Platform$Cmd$none,
						(currentUserIsHintAdmin && A2($elm$core$List$member, 2, organizationTypes)) ? $author$project$Pages$User$Organizations$Top$fetchPartnerRoles(model.D5) : $elm$core$Platform$Cmd$none,
						$author$project$Pages$User$Organizations$Top$focusSearchInput
					])));
	});
var $author$project$Pages$User$Organizations$Top$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					mq: shared.mq,
					FR: $author$project$Shared$isHintAdmin(shared)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$Organizations$Top$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$User$Organizations$Top$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$NewDropdown$subscriptions(model.nC),
				$author$project$Ui$NewDropdown$subscriptions(model.kV),
				$author$project$Ui$NewDropdown$subscriptions(model.ml)
			]));
};
var $author$project$Pages$User$Organizations$Top$SearchInputMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$OutMsg$SwitchRole = function (a) {
	return {$: 17, a: a};
};
var $author$project$OutMsg$SwitchToClinical = function (a) {
	return {$: 16, a: a};
};
var $author$project$OutMsg$ToggleHighlightPhi = {$: 13};
var $author$project$OutMsg$ToggleHinterView = {$: 12};
var $author$project$Api$Platform$Company$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Platform$Company$All$id = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Company$Min$id(min);
};
var $author$project$Api$Platform$Company$Min$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Platform$Company$All$name = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Company$Min$name(min);
};
var $author$project$Api$Platform$Company$All$organizationId = function (_v0) {
	var record = _v0.b;
	return record.aft;
};
var $author$project$Api$Platform$Company$All$practice = function (_v0) {
	var record = _v0.b;
	return record.WF;
};
var $author$project$Api$Platform$Company$Min$requiresMfa = function (_v0) {
	var record = _v0;
	return record.Yn;
};
var $author$project$Api$Platform$Company$All$requiresMfa = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Company$Min$requiresMfa(min);
};
var $author$project$Pages$User$Organizations$Top$companyToOrganization = function (company) {
	return {
		Py: 0,
		adR: $author$project$Api$Platform$Company$All$id(company),
		RH: false,
		aet: $elm$core$Maybe$Nothing,
		zh: $author$project$Api$Platform$Company$All$name(company),
		aft: $author$project$Api$Platform$Company$All$organizationId(company),
		Vp: $elm$core$Maybe$Nothing,
		afQ: $elm$core$Maybe$Just(
			$author$project$Api$Platform$Practice$Min$name(
				$author$project$Api$Platform$Company$All$practice(company))),
		GT: $elm$core$Maybe$Nothing,
		Yn: $author$project$Api$Platform$Company$All$requiresMfa(company),
		ahI: 1
	};
};
var $author$project$Api$Platform$Partner$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Platform$Partner$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$id(shared);
};
var $author$project$Api$Platform$Partner$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Platform$Partner$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$name(shared);
};
var $author$project$Api$Platform$Partner$Shared$organizationId = function (_v0) {
	var record = _v0;
	return record.aft;
};
var $author$project$Api$Platform$Partner$All$organizationId = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$organizationId(shared);
};
var $author$project$Api$Platform$Partner$Shared$requiresMfa = function (_v0) {
	var record = _v0;
	return record.Yn;
};
var $author$project$Api$Platform$Partner$All$requiresMfa = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$requiresMfa(shared);
};
var $author$project$Api$Platform$Partner$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Platform$Partner$All$status = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$Partner$Shared$status(shared);
};
var $author$project$Pages$User$Organizations$Top$partnerToOrganization = function (partner) {
	return {
		Py: 0,
		adR: $author$project$Api$Platform$Partner$All$id(partner),
		RH: false,
		aet: $elm$core$Maybe$Nothing,
		zh: _Utils_ap(
			$author$project$Api$Platform$Partner$All$name(partner),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (status) {
						return ' (' + (status + ')');
					},
					$author$project$Api$Platform$Partner$All$status(partner)))),
		aft: $author$project$Api$Platform$Partner$All$organizationId(partner),
		Vp: $elm$core$Maybe$Nothing,
		afQ: $elm$core$Maybe$Nothing,
		GT: $elm$core$Maybe$Nothing,
		Yn: $author$project$Api$Platform$Partner$All$requiresMfa(partner),
		ahI: 2
	};
};
var $author$project$Api$Platform$Practice$Min$flaggedNotesCount = function (_v0) {
	var record = _v0;
	return record.Py;
};
var $author$project$Api$Platform$Practice$All$flaggedNotesCount = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$flaggedNotesCount(min);
};
var $author$project$Api$Platform$Practice$Min$isDeactivated = function (_v0) {
	var record = _v0;
	return record.RH;
};
var $author$project$Api$Platform$Practice$All$isDeactivated = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$isDeactivated(min);
};
var $author$project$Api$Platform$Practice$All$organizationId = function (_v0) {
	var record = _v0.b;
	return record.aft;
};
var $author$project$Api$Platform$Practice$All$owner = function (_v0) {
	var record = _v0.b;
	return record.Vp;
};
var $author$project$Api$Platform$Practice$All$productType = function (_v0) {
	var record = _v0.b;
	return record.GT;
};
var $author$project$Api$Platform$Practice$Min$requiresMfa = function (_v0) {
	var record = _v0;
	return record.Yn;
};
var $author$project$Api$Platform$Practice$All$requiresMfa = function (_v0) {
	var min = _v0.a;
	return $author$project$Api$Platform$Practice$Min$requiresMfa(min);
};
var $author$project$Components$AddressDisplay$viewCityState = function (address) {
	var state = $author$project$Components$AddressDisplay$formatSegment(
		$author$project$Api$Common$Address$Shared$state(address));
	var city = $author$project$Components$AddressDisplay$formatSegment(
		$author$project$Api$Common$Address$Shared$city(address));
	var _v0 = _Utils_Tuple2(city, state);
	if (_v0.a === '') {
		if (_v0.b === '') {
			return '';
		} else {
			var stateStr = _v0.b;
			return stateStr;
		}
	} else {
		if (_v0.b === '') {
			var cityStr = _v0.a;
			return cityStr;
		} else {
			var cityStr = _v0.a;
			var stateStr = _v0.b;
			return cityStr + (', ' + stateStr);
		}
	}
};
var $author$project$Pages$User$Organizations$Top$practiceToOrganization = function (practice) {
	var location = function () {
		var _v0 = $author$project$Api$Platform$Practice$All$address(practice);
		if (!_v0.$) {
			var address = _v0.a;
			return $elm$core$Maybe$Just(
				$author$project$Components$AddressDisplay$viewCityState(address));
		} else {
			return $elm$core$Maybe$Just('');
		}
	}();
	return {
		Py: $author$project$Api$Platform$Practice$All$flaggedNotesCount(practice),
		adR: $author$project$Api$Platform$Practice$All$id(practice),
		RH: $author$project$Api$Platform$Practice$All$isDeactivated(practice),
		aet: location,
		zh: $author$project$Api$Platform$Practice$All$name(practice),
		aft: $author$project$Api$Platform$Practice$All$organizationId(practice),
		Vp: A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$User$Min$name,
			$author$project$Api$Platform$Practice$All$owner(practice)),
		afQ: $elm$core$Maybe$Just(
			$author$project$Api$Platform$Practice$All$name(practice)),
		GT: $elm$core$Maybe$Just(
			$author$project$Api$Platform$Practice$All$productType(practice)),
		Yn: $author$project$Api$Platform$Practice$All$requiresMfa(practice),
		ahI: 0
	};
};
var $author$project$Pages$User$Organizations$Top$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[$author$project$OutMsg$ToggleHinterView]));
			case 1:
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[$author$project$OutMsg$ToggleHighlightPhi]));
			case 2:
				var tabMsg = msg.a;
				var _v1 = A2($author$project$Ui$Tabs$update, tabMsg, model.gV);
				var tabModel = _v1.a;
				var tabsCmd = _v1.b;
				var tabsEvent = _v1.c;
				var _v2 = function () {
					if (!tabsEvent.$) {
						var organizationType = tabsEvent.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									fj: $elm$core$Maybe$Just(organizationType),
									S_: true,
									rJ: _List_Nil,
									GP: $elm$core$Maybe$Nothing,
									af_: $elm$core$Maybe$Nothing,
									sA: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
									gV: tabModel
								}),
							true);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{gV: tabModel}),
							false);
					}
				}();
				var newModel = _v2.a;
				var refreshOrganizations = _v2.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								refreshOrganizations ? $author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel) : $elm$core$Platform$Cmd$none,
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Organizations$Top$TabMsg, tabsCmd)
							])),
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$SearchInput$update, subMsg, model.sA);
				var searchInput = _v4.a;
				var searchInputCmd = _v4.b;
				var searchInputEvent = _v4.c;
				var q = function () {
					if (searchInputEvent.$ === 1) {
						var query = searchInputEvent.a;
						return query;
					} else {
						return model.af_;
					}
				}();
				var _v5 = function () {
					if (_Utils_eq(q, model.af_)) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var qModel = _Utils_update(
							model,
							{af_: q});
						return _Utils_Tuple2(
							qModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$elm$http$Http$cancel(
										$author$project$Pages$User$Organizations$Top$organizationSearchTracker(model.af_)),
										$author$project$Pages$User$Organizations$Top$fetchOrganizations(qModel)
									])));
					}
				}();
				var newModel = _v5.a;
				var cmd = _v5.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{sA: searchInput}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Organizations$Top$SearchInputMsg, searchInputCmd),
								cmd
							])),
					_List_Nil);
			case 4:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.afy);
				var newModel = _Utils_update(
					model,
					{afy: pagination});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel),
					_List_Nil);
			case 5:
				var response = msg.a;
				if (!_Utils_eq(
					model.fj,
					$elm$core$Maybe$Just(0))) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					if (response.$ === 3) {
						var practices = response.a;
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									S_: false,
									rJ: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$practiceToOrganization, practices),
									afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{S_: false, rJ: _List_Nil}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 6:
				var response = msg.a;
				if (!_Utils_eq(
					model.fj,
					$elm$core$Maybe$Just(1))) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					if (response.$ === 3) {
						var companies = response.a;
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									S_: false,
									rJ: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$companyToOrganization, companies),
									afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{S_: false, rJ: _List_Nil}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 7:
				var response = msg.a;
				if (!_Utils_eq(
					model.fj,
					$elm$core$Maybe$Just(2))) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				} else {
					if (response.$ === 3) {
						var partners = response.a;
						var headers = response.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									S_: false,
									rJ: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$partnerToOrganization, partners),
									afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.afy)
								}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{S_: false, rJ: _List_Nil}),
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				}
			case 8:
				var organization = msg.a;
				var role = msg.b;
				var roleWithPrefix = function () {
					var _v10 = _Utils_Tuple2(model.fj, role);
					if ((!_v10.a.$) && (!_v10.b.$)) {
						switch (_v10.a.a) {
							case 0:
								var _v11 = _v10.a.a;
								var role_ = _v10.b.a;
								return $elm$core$Maybe$Just(
									'practice_' + $author$project$Api$Common$Role$All$name(role_));
							case 1:
								var _v12 = _v10.a.a;
								var role_ = _v10.b.a;
								return $elm$core$Maybe$Just(
									'company_' + $author$project$Api$Common$Role$All$name(role_));
							default:
								var _v13 = _v10.a.a;
								var role_ = _v10.b.a;
								return $elm$core$Maybe$Just(
									'partner_' + $author$project$Api$Common$Role$All$name(role_));
						}
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				var postOrganizationSwitchedAction = $author$project$Api$Platform$Session$One$sandbox(model.ZD) ? $author$project$OutMsg$GoToDefaultStateAndReloadAction : $author$project$OutMsg$GoToDefaultStateAction;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S_: true}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$OutMsg$SwitchToOrganization, organization.aft, roleWithPrefix, postOrganizationSwitchedAction)
						]));
			case 9:
				var organization = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{S_: true}),
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$OutMsg$SwitchToClinical(organization.aft)
						]));
			case 10:
				var subMsg = msg.a;
				var _v14 = A2($author$project$Ui$NewDropdown$update, subMsg, model.ml);
				var dropdown = _v14.a;
				var dropdownCmd = _v14.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ml: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 11:
				var role = msg.a;
				var roleWithPrefix = function () {
					var _v15 = A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, model.lF);
					if (!_v15.$) {
						switch (_v15.a) {
							case 0:
								var _v16 = _v15.a;
								return 'practice_' + $author$project$Api$Common$Role$All$name(role);
							case 1:
								var _v17 = _v15.a;
								return 'company_' + $author$project$Api$Common$Role$All$name(role);
							default:
								var _v18 = _v15.a;
								return 'partner_' + $author$project$Api$Common$Role$All$name(role);
						}
					} else {
						return $author$project$Api$Common$Role$All$name(role);
					}
				}();
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							$author$project$OutMsg$SwitchRole(roleWithPrefix)
						]));
			case 12:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							AW: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(response))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 13:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							wH: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(response))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 14:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							VG: A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$Api$Data$toMaybe(response))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(response));
			case 15:
				var subMsg = msg.a;
				var _v19 = A2($author$project$Ui$NewDropdown$update, subMsg, model.nC);
				var dropdown = _v19.a;
				var dropdownCmd = _v19.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{nC: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 17:
				var subMsg = msg.a;
				var _v20 = A2($author$project$Ui$NewDropdown$update, subMsg, model.kV);
				var dropdown = _v20.a;
				var dropdownCmd = _v20.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{kV: dropdown}),
					dropdownCmd,
					_List_Nil);
			case 16:
				var selected = msg.a;
				var newModel = _Utils_update(
					model,
					{S_: true, rJ: _List_Nil, GP: selected});
				return _Utils_Tuple3(
					newModel,
					$author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel),
					_List_Nil);
			case 18:
				var text = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(text),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						]));
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$User$Organizations$Top$GoAsRole = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$User$Organizations$Top$currentOrgRoles = function (model) {
	var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, model.lF);
	if (!_v0.$) {
		switch (_v0.a) {
			case 0:
				var _v1 = _v0.a;
				return model.AW;
			case 1:
				var _v2 = _v0.a;
				return model.wH;
			default:
				var _v3 = _v0.a;
				return model.VG;
		}
	} else {
		return _List_Nil;
	}
};
var $author$project$Pages$User$Organizations$Top$toTab = function (organizationType) {
	switch (organizationType) {
		case 0:
			return $elm$html$Html$text('Practices');
		case 1:
			return $elm$html$Html$text('Companies');
		default:
			return $elm$html$Html$text('Partners');
	}
};
var $author$project$Pages$User$Organizations$Top$organizationTypeToTabItem = function (organizationType) {
	return A2(
		$author$project$Ui$Tabs$item,
		organizationType,
		{d: $elm$core$Maybe$Nothing, ahv: $author$project$Api$OrganizationType$toString, ahz: $author$project$Pages$User$Organizations$Top$toTab});
};
var $author$project$Pages$User$Organizations$Top$PaginationMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$SearchInput$Autofocus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$SearchInput$autofocus = $author$project$Ui$SearchInput$Autofocus;
var $author$project$Ui$SearchInput$Id = function (a) {
	return {$: 4, a: a};
};
var $author$project$Ui$SearchInput$id = $author$project$Ui$SearchInput$Id;
var $author$project$Pages$User$Organizations$Top$CopyToClipboard = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Platform$User$One$isMfaActive = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$isMfaActive(shared);
};
var $author$project$Pages$User$Organizations$Top$mfaRequiredButDisabled = F2(
	function (currentUser, organization) {
		return organization.Yn && (!$author$project$Api$Platform$User$One$isMfaActive(currentUser));
	});
var $author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage = F2(
	function (currentUser, organization) {
		return A2($author$project$Pages$User$Organizations$Top$mfaRequiredButDisabled, currentUser, organization) ? $elm$core$Maybe$Just(
			A2(
				$author$project$Ui$Typography$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('MFA is required for this practice. Click '),
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Mfa,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('here')
							])),
						$elm$html$Html$text(' to enable it.')
					]))) : $elm$core$Maybe$Nothing;
	});
var $author$project$Pages$User$Organizations$Top$canSwitchOrganization = F2(
	function (currentUser, organization) {
		return _Utils_eq(
			A2($author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage, currentUser, organization),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Pages$User$Organizations$Top$isCurrentOrganization = F2(
	function (currentOrganization, organization) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (currentOrganization_) {
					return _Utils_eq(
						$author$project$Api$Platform$Organization$Shared$type_(currentOrganization_),
						organization.ahI) && _Utils_eq(
						$author$project$Api$Platform$Organization$Shared$id(currentOrganization_),
						organization.adR);
				},
				currentOrganization));
	});
var $author$project$Ui$Element$mr1 = $author$project$Ui$Element$Margin('mr-1');
var $author$project$Pages$User$Organizations$Top$SwitchToOrganization = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Ui$Button$Aligned = function (a) {
	return {$: 13, a: a};
};
var $author$project$Ui$Button$aligned = $author$project$Ui$Button$Aligned;
var $author$project$Pages$User$Organizations$Top$viewOrganizationNameCell = F2(
	function (isLoading, organization) {
		var name = organization.RH ? (organization.zh + ' (deactivated)') : organization.zh;
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Switch to ' + name},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
					$author$project$Ui$Button$onClick(
					A2($author$project$Pages$User$Organizations$Top$SwitchToOrganization, organization, $elm$core$Maybe$Nothing)),
					$author$project$Ui$Button$disabled(isLoading),
					$author$project$Ui$Button$aligned($author$project$Ui$Alignment$textLeft)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
					_List_fromArray(
						[
							$elm$html$Html$text(name),
							(organization.ahI === 1) ? A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$textSm, $author$project$Ui$Element$textSm]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', organization.afQ))
								])) : $author$project$Utils$Html$empty,
							((organization.Py > 0) && (!organization.ahI)) ? $author$project$Ui$SvgIcon$flag(_List_Nil) : $author$project$Utils$Html$empty
						]))
				]));
	});
var $author$project$Pages$User$Organizations$Top$SwitchToClinical = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$User$Organizations$Top$viewProductOptions = function (_v0) {
	var organization = _v0.Vd;
	var isCurrentOrganization_ = _v0.RF;
	var currentUser = _v0.EQ;
	var backupAuthEnabled = _v0.abt;
	var isLoading = _v0.cW;
	var _v1 = _Utils_Tuple2(
		isCurrentOrganization_,
		A2($author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage, currentUser, organization));
	if (_v1.a) {
		return A2(
			$author$project$Ui$Typography$span,
			_List_fromArray(
				[
					$author$project$Ui$Typography$muted,
					$author$project$Ui$Typography$pull(1)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('active')
				]));
	} else {
		if (!_v1.b.$) {
			var message = _v1.b.a;
			return A2(
				$author$project$Ui$Badge$view,
				_List_fromArray(
					[$author$project$Ui$Badge$danger]),
				_List_fromArray(
					[message]));
		} else {
			var _v2 = _v1.b;
			return A2(
				$author$project$Ui$Typography$span,
				_List_fromArray(
					[
						$author$project$Ui$Typography$pull(1)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Button$group(
						_List_fromArray(
							[
								function () {
								var _v3 = organization.GT;
								if ((!_v3.$) && (_v3.a === 'Clinical')) {
									var switchToClinicalButton = A3(
										$author$project$Ui$Button$view,
										{abp: 'Switch to clinical'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$SwitchToClinical(organization)),
												$author$project$Ui$Button$disabled(backupAuthEnabled || isLoading)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Clinical '),
												$author$project$Ui$SvgIcon$arrowRight(
												_List_fromArray(
													[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$info]))
											]));
									return backupAuthEnabled ? A3(
										$author$project$Ui$Popover$view,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Ui$Button$group(
												_List_fromArray(
													[switchToClinicalButton]))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Popover$body,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('The Clinical app is temporarily unavailable due to the sign-in system outage.')
													]))
											])) : switchToClinicalButton;
								} else {
									return $author$project$Utils$Html$empty;
								}
							}(),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Switch to core'},
								_List_fromArray(
									[
										$author$project$Ui$Button$onClick(
										A2($author$project$Pages$User$Organizations$Top$SwitchToOrganization, organization, $elm$core$Maybe$Nothing)),
										$author$project$Ui$Button$disabled(isLoading),
										$author$project$Ui$Button$loading(isLoading)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Core '),
										$author$project$Ui$SvgIcon$arrowRight(
										_List_fromArray(
											[$author$project$Ui$SvgIcon$xs, $author$project$Ui$SvgIcon$info]))
									]))
							]))
					]));
		}
	}
};
var $author$project$Pages$User$Organizations$Top$viewOrganizationRow = F2(
	function (model, organization) {
		var isCurrentOrganization_ = A2($author$project$Pages$User$Organizations$Top$isCurrentOrganization, model.lF, organization);
		var productSwitcherParams = {abt: model.abt, EQ: model.EQ, RF: isCurrentOrganization_, cW: model.S_, Vd: organization};
		var rowOptions = isCurrentOrganization_ ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(1)
			]) : ((!A2($author$project$Pages$User$Organizations$Top$canSwitchOrganization, model.EQ, organization)) ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(4)
			]) : (organization.RH ? _List_fromArray(
			[
				$author$project$Ui$Table$styled(3)
			]) : _List_Nil));
		var _v0 = _Utils_Tuple2(model.FR, organization.ahI);
		if (_v0.a) {
			switch (_v0.b) {
				case 0:
					var _v1 = _v0.b;
					return A2(
						$author$project$Ui$Table$row,
						rowOptions,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.S_, organization)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', organization.Vp))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', organization.aet))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', organization.GT))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.adR)
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Copy organization id'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.adR)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.aft)
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Copy organization identifier'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.aft)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
									]))
							]));
				case 2:
					var _v2 = _v0.b;
					return A2(
						$author$project$Ui$Table$row,
						rowOptions,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.S_, organization)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.adR)
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Copy organization id'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.adR)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.aft)
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Copy organization identifier'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.aft)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
									]))
							]));
				default:
					var _v3 = _v0.b;
					return A2(
						$author$project$Ui$Table$row,
						rowOptions,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.S_, organization)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$inlineBlock, $author$project$Ui$Element$mr1]),
										_List_fromArray(
											[
												$elm$html$Html$text(organization.adR)
											])),
										A3(
										$author$project$Ui$Button$view,
										{abp: 'Copy organization id'},
										_List_fromArray(
											[
												$author$project$Ui$Button$link,
												$author$project$Ui$Button$onClick(
												$author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.adR)),
												$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
											]),
										_List_Nil)
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($elm$core$Maybe$withDefault, '', organization.afQ))
									])),
								A2(
								$author$project$Ui$Table$cell,
								_List_Nil,
								_List_fromArray(
									[
										$author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
									]))
							]));
			}
		} else {
			return A2(
				$author$project$Ui$Table$row,
				rowOptions,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.S_, organization)
							])),
						A2(
						$author$project$Ui$Table$cell,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
							]))
					]));
		}
	});
var $author$project$Pages$User$Organizations$Top$filterToLabel = function (filter) {
	if (filter.$ === 1) {
		return 'All Practices';
	} else {
		var _v1 = filter.a;
		return 'Has Flagged Notes';
	}
};
var $author$project$Pages$User$Organizations$Top$PracticesFilterSelected = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$User$Organizations$Top$WithFlaggedNotes = 0;
var $author$project$Pages$User$Organizations$Top$practicesDropdownOptions = function (currentFilter) {
	var filterToItem = function (filter) {
		return A2(
			$author$project$Ui$NewDropdown$item,
			_List_fromArray(
				[
					$author$project$Ui$NewDropdown$onSelect(
					$author$project$Pages$User$Organizations$Top$PracticesFilterSelected(filter)),
					$author$project$Ui$NewDropdown$selected(
					_Utils_eq(filter, currentFilter))
				]),
			$elm$html$Html$text(
				$author$project$Pages$User$Organizations$Top$filterToLabel(filter)));
	};
	return _List_fromArray(
		[
			filterToItem($elm$core$Maybe$Nothing),
			$author$project$Ui$NewDropdown$separator,
			filterToItem(
			$elm$core$Maybe$Just(0))
		]);
};
var $author$project$Pages$User$Organizations$Top$viewPracticesDropdown = function (model) {
	return A4(
		$author$project$Ui$NewDropdown$viewSelect,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Pages$User$Organizations$Top$filterToLabel(model.GP))
			]),
		$author$project$Pages$User$Organizations$Top$practicesDropdownOptions(model.GP),
		model.nC);
};
var $author$project$Pages$User$Organizations$Top$toPane = F2(
	function (model, organizationType) {
		var showPracticeFilters = (!organizationType) && model.FR;
		return A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(
											showPracticeFilters ? 10 : 12)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											$author$project$Pages$User$Organizations$Top$SearchInputMsg,
											A2(
												$author$project$Ui$SearchInput$view,
												_List_fromArray(
													[
														$author$project$Ui$SearchInput$loading(model.S_),
														$author$project$Ui$SearchInput$autofocus(true),
														$author$project$Ui$SearchInput$id('organization-search-input')
													]),
												model.sA))
										])),
									showPracticeFilters ? A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$spanSm(2)
										]),
									_List_fromArray(
										[
											$author$project$Pages$User$Organizations$Top$viewPracticesDropdown(model)
										])) : $author$project$Ui$FlexGrid$none
								]))
						])),
					A4(
					$author$project$Ui$Panel$table,
					_List_fromArray(
						[
							$author$project$Ui$Table$zeroState(
							_List_fromArray(
								[
									$elm$html$Html$text('No results')
								])),
							$author$project$Ui$Table$loading(model.S_)
						]),
					function () {
						var _v0 = _Utils_Tuple2(model.FR, organizationType);
						if (_v0.a) {
							switch (_v0.b) {
								case 0:
									var _v1 = _v0.b;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Practice Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Owner')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Location')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Product')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Practice ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Org ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('')
												]))
										]);
								case 2:
									var _v2 = _v0.b;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Partner Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Partner ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Org ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('')
												]))
										]);
								default:
									var _v3 = _v0.b;
									return _List_fromArray(
										[
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Company Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Company ID')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Practice Name')
												])),
											A2(
											$author$project$Ui$Table$header,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('')
												]))
										]);
							}
						} else {
							return _List_Nil;
						}
					}(),
					A2(
						$elm$core$List$map,
						$author$project$Pages$User$Organizations$Top$viewOrganizationRow(model),
						model.rJ),
					_List_Nil),
					($elm$core$List$length(model.nb) > 0) ? A2(
					$author$project$Ui$Panel$footer,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$author$project$Pages$User$Organizations$Top$PaginationMsg,
							A2($author$project$Api$Pagination$view, _List_Nil, model.afy))
						])) : $author$project$Ui$Panel$none
				]));
	});
var $author$project$Pages$User$Organizations$Top$ToggleHighlightPhi = {$: 1};
var $author$project$Pages$User$Organizations$Top$viewHighlightPhiToggle = function (highlightPhi) {
	return A2(
		$author$project$Ui$Typography$p,
		_List_Nil,
		_List_fromArray(
			[
				A3(
				$author$project$Ui$Button$view,
				{abp: 'Toggle PHI highlighting'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
						$author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$ToggleHighlightPhi)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('clickable clickable-badge')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Highlight Phi: '),
								highlightPhi ? $elm$html$Html$text('ON') : $elm$html$Html$text('OFF')
							]))
					]))
			]));
};
var $author$project$Pages$User$Organizations$Top$ToggleHinterView = {$: 0};
var $author$project$Pages$User$Organizations$Top$viewHinterViewToggle = function (isHintAdmin) {
	var label = $elm$core$String$concat(
		_List_fromArray(
			[
				'as ',
				isHintAdmin ? '' : 'NON-',
				'hinter'
			]));
	return A3(
		$author$project$Ui$HinterOnly$button,
		{abp: label},
		_List_fromArray(
			[
				$author$project$Ui$Button$link,
				$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
				$author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$ToggleHinterView)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(label)
			]));
};
var $author$project$Pages$User$Organizations$Top$view = function (model) {
	var organizationTypeTabs = A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$organizationTypeToTabItem, model.nb);
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$heading,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$Ui$Panel$title(
								_List_fromArray(
									[
										$elm$html$Html$text('Choose Organization')
									]))
							])),
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$spaceBetween]),
								_List_fromArray(
									[
										function () {
										var _v0 = model.lF;
										if (!_v0.$) {
											var currentOrganization = _v0.a;
											return A2(
												$author$project$Ui$Typography$p,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('You are currently administering '),
														A2(
														$author$project$Ui$Typography$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Api$Platform$Organization$Shared$name(currentOrganization))
															])),
														$author$project$Utils$Html$noBreakSpace,
														model.ER ? $author$project$Pages$User$Organizations$Top$viewHinterViewToggle(model.FR) : $author$project$Utils$Html$empty,
														model.FR ? $author$project$Pages$User$Organizations$Top$viewHighlightPhiToggle(model.mq) : $author$project$Utils$Html$empty
													]));
										} else {
											return $author$project$Utils$Html$empty;
										}
									}(),
										model.FR ? A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter]),
										_List_fromArray(
											[
												(!$elm$core$List$isEmpty(
												$author$project$Pages$User$Organizations$Top$currentOrgRoles(model))) ? A4(
												$author$project$Ui$HinterOnly$dropdown,
												_List_fromArray(
													[$author$project$Ui$NewDropdown$buttonSecondary]),
												_List_fromArray(
													[
														$elm$html$Html$text('Go As Role')
													]),
												A2(
													$elm$core$List$map,
													function (role) {
														return A2(
															$author$project$Ui$NewDropdown$item,
															_List_fromArray(
																[
																	$author$project$Ui$NewDropdown$onSelect(
																	$author$project$Pages$User$Organizations$Top$GoAsRole(role))
																]),
															$elm$html$Html$text(
																'Go as ' + $author$project$Api$Common$Role$All$name(role)));
													},
													$author$project$Pages$User$Organizations$Top$currentOrgRoles(model)),
												model.ml) : $author$project$Utils$Html$empty,
												A4(
												$author$project$Ui$HinterOnly$dropdown,
												_List_fromArray(
													[$author$project$Ui$NewDropdown$buttonSecondary]),
												_List_fromArray(
													[
														$elm$html$Html$text('Hinter Actions')
													]),
												_List_fromArray(
													[
														A3(
														$author$project$Ui$NewDropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__ClonePractice),
														_List_Nil,
														$elm$html$Html$text('Clone practice')),
														A3(
														$author$project$Ui$NewDropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewPractice),
														_List_Nil,
														$elm$html$Html$text('Create new practice')),
														A3(
														$author$project$Ui$NewDropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewPartner),
														_List_Nil,
														$elm$html$Html$text('Create new partner')),
														A3(
														$author$project$Ui$NewDropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewGroup),
														_List_Nil,
														$elm$html$Html$text('Create new group')),
														$author$project$Ui$NewDropdown$separator,
														A3(
														$author$project$Ui$NewDropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__Disputes),
														_List_Nil,
														$elm$html$Html$text('Manage Disputes')),
														A3(
														$author$project$Ui$NewDropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top),
														_List_Nil,
														$elm$html$Html$text('Manage Admin Users Groups')),
														A3(
														$author$project$Ui$NewDropdown$link,
														$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__FeatureFlags),
														_List_Nil,
														$elm$html$Html$text('Manage Feature Flags'))
													]),
												model.kV)
											])) : $author$project$Utils$Html$empty
									])),
								($elm$core$List$length(model.nb) > 1) ? A2(
								$elm$html$Html$map,
								$author$project$Pages$User$Organizations$Top$TabMsg,
								A2($author$project$Ui$Tabs$view, model.gV, organizationTypeTabs)) : $author$project$Utils$Html$empty,
								($elm$core$List$length(model.nb) > 0) ? A3(
								$author$project$Ui$Tabs$mapActive,
								$author$project$Pages$User$Organizations$Top$toPane(model),
								model.gV,
								organizationTypeTabs) : $author$project$Utils$Html$empty
							]))
					]))
			]),
		$G: 'Switch Organization'
	};
};
var $author$project$Pages$User$Organizations$Top$page = $author$project$Spa$Page$applicationUser(
	{ad0: $author$project$Pages$User$Organizations$Top$init, aer: $author$project$Pages$User$Organizations$Top$load, agD: $author$project$Pages$User$Organizations$Top$save, ahd: $author$project$Pages$User$Organizations$Top$subscriptions, aaq: $author$project$Pages$User$Organizations$Top$update, ahP: $author$project$Pages$User$Organizations$Top$view});
var $author$project$Api$Practice$hasClinicalAccount = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice_);
	} else {
		return false;
	}
};
var $author$project$Api$Platform$User$Shared$identityProviderId = function (_v0) {
	var record = _v0;
	return record.QK;
};
var $author$project$Api$Platform$User$One$identityProviderId = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$identityProviderId(shared);
};
var $author$project$Api$Platform$User$One$email = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$email(shared);
};
var $author$project$Api$Platform$User$One$firstName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$firstName(shared);
};
var $author$project$Api$Platform$User$One$lastName = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$lastName(shared);
};
var $author$project$Pages$User$Profile$initFormFields = function (user) {
	return {
		Oo: $author$project$Api$Platform$User$One$email(user),
		Pu: $author$project$Api$Platform$User$One$firstName(user),
		SA: $author$project$Api$Platform$User$One$lastName(user),
		Hw: $author$project$Api$Platform$User$One$termsAccepted(user)
	};
};
var $author$project$Pages$User$Profile$initPhoneInput = function (phones) {
	return A3(
		$author$project$Components$PhoneInput$init,
		'user-phone-input',
		A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones),
		$elm$core$Basics$identity);
};
var $author$project$Api$Platform$User$One$phones = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$phones(shared);
};
var $author$project$Ports$Navigation$navigationPortRequestUrl = _Platform_outgoingPort(
	'navigationPortRequestUrl',
	function ($) {
		var a = $.a;
		var b = $.b;
		var c = $.c;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$bool(b),
					$elm$json$Json$Encode$bool(c)
				]));
	});
var $author$project$Ports$Navigation$requestUrl = F3(
	function (href, isLocal, shouldOpenInNewWindow) {
		return $author$project$Ports$Navigation$navigationPortRequestUrl(
			_Utils_Tuple3(href, isLocal, shouldOpenInNewWindow));
	});
var $author$project$Pages$User$Profile$init = F4(
	function (_v0, user, shared, _v1) {
		var redirectCmd = function () {
			var _v2 = $author$project$Api$Data$toMaybe(shared.WF);
			if (!_v2.$) {
				var practice = _v2.a;
				if ($author$project$Api$Practice$hasClinicalAccount(practice) && A2($author$project$Api$Practice$featureEnabled, 19, practice)) {
					var _v3 = $author$project$Api$Platform$User$One$identityProviderId(user);
					if (!_v3.$) {
						var ipId = _v3.a;
						return A3(
							$author$project$Ports$Navigation$requestUrl,
							$author$project$Spa$Generated$Route$toString(
								$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo(
									{ahk: ipId})),
							true,
							false);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var emailDisabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Practice$hasClinicalAccount,
				$author$project$Api$Data$toMaybe(shared.WF)));
		return _Utils_Tuple2(
			{
				D5: shared.D5,
				E7: emailDisabled,
				PB: $author$project$Utils$Form$init(
					$author$project$Pages$User$Profile$initFormFields(user)),
				bw: $author$project$Pages$User$Profile$initPhoneInput(
					$author$project$Api$Platform$User$One$phones(user)),
				tr: $author$project$Api$Data$NotAsked,
				aaz: user
			},
			redirectCmd);
	});
var $author$project$Pages$User$Profile$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$Profile$save = F2(
	function (model, shared) {
		var _v0 = model.tr;
		if (_v0.$ === 3) {
			return _Utils_update(
				shared,
				{aaz: model.tr});
		} else {
			return shared;
		}
	});
var $author$project$Pages$User$Profile$GotPhoneInputMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Profile$subscriptions = function (model) {
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Pages$User$Profile$GotPhoneInputMsg,
		$author$project$Components$PhoneInput$subscriptions(model.bw));
};
var $author$project$Pages$User$Profile$formFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var firstName = field.a;
				return _Utils_update(
					fields,
					{Pu: firstName});
			case 1:
				var lastName = field.a;
				return _Utils_update(
					fields,
					{SA: lastName});
			case 2:
				var email = field.a;
				return _Utils_update(
					fields,
					{Oo: email});
			default:
				var bool = field.a;
				return _Utils_update(
					fields,
					{Hw: bool});
		}
	});
var $author$project$Pages$User$Profile$EmailValidation = 0;
var $author$project$Pages$User$Profile$TermsAcceptedValidation = 1;
var $author$project$Pages$User$Profile$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A3(
			$author$project$Utils$Validate$ifInvalidEmail,
			{abh: false},
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.Oo;
				},
				$elm$core$Maybe$Just),
			_Utils_Tuple2(0, 'Please enter a valid email.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function ($) {
				return $.Hw;
			},
			_Utils_Tuple2(1, 'Please accept this platform\'s terms.'))
		]));
var $author$project$Pages$User$Profile$GotUpdatedUser = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Platform$User$update = F4(
	function (apiClient, fields, phones_, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'first_name',
								$elm$json$Json$Encode$string(fields.Pu)),
								_Utils_Tuple2(
								'last_name',
								$elm$json$Json$Encode$string(fields.SA)),
								_Utils_Tuple2(
								'email',
								$elm$json$Json$Encode$string(fields.Oo)),
								_Utils_Tuple2(
								'terms_accepted',
								$elm$json$Json$Encode$bool(fields.Hw)),
								_Utils_Tuple2(
								'phones',
								A2($elm$json$Json$Encode$list, $author$project$Api$Common$Phone$Shared$encode, phones_))
							])))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Platform$User$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
	});
var $author$project$Pages$User$Profile$updateUser = F3(
	function (apiClient, formFields, phones) {
		return A4(
			$author$project$Api$Platform$User$update,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(formFields),
			A2($elm$core$List$map, $author$project$Utils$Phone$toRecord, phones),
			$author$project$Pages$User$Profile$GotUpdatedUser);
	});
var $author$project$Pages$User$Profile$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 3:
				var field = msg.a;
				var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$User$Profile$formFieldsUpdate, field, model.PB);
				var validatedForm = function () {
					var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Profile$formFieldsValidator, newForm);
					if (!_v1.$) {
						var _v2 = _v1.a;
						var form = _v2.a;
						return form;
					} else {
						var form = _v1.a;
						return form;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{PB: validatedForm}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 1:
				var _v3 = _Utils_Tuple2(
					A2($author$project$Utils$Form$validate, $author$project$Pages$User$Profile$formFieldsValidator, model.PB),
					$author$project$Components$PhoneInput$getPhones(model.bw));
				if (!_v3.a.$) {
					if (!_v3.b.$) {
						var _v4 = _v3.a.a;
						var newForm = _v4.a;
						var validFormFields = _v4.b;
						var phones = _v3.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{PB: newForm}),
							A3($author$project$Pages$User$Profile$updateUser, model.D5, validFormFields, phones),
							_List_Nil);
					} else {
						var _v5 = _v3.a.a;
						var newForm = _v5.a;
						var _v6 = _v3.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{PB: newForm}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				} else {
					var newForm = _v3.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{PB: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var dataUser = msg.a;
				if (dataUser.$ === 3) {
					var user = dataUser.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								PB: $author$project$Utils$Form$init(
									$author$project$Pages$User$Profile$initFormFields(user)),
								bw: $author$project$Pages$User$Profile$initPhoneInput(
									$author$project$Api$Platform$User$One$phones(user)),
								tr: dataUser,
								aaz: user
							}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your profile has been updated')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataUser));
				}
			default:
				var subMsg = msg.a;
				var _v8 = A2($author$project$Components$PhoneInput$update, subMsg, model.bw);
				var updatedPhoneInput = _v8.a;
				var phoneCmd = _v8.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bw: updatedPhoneInput}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Profile$GotPhoneInputMsg, phoneCmd),
					_List_Nil);
		}
	});
var $author$project$Pages$User$Profile$UpdateUser = {$: 1};
var $author$project$Pages$User$Profile$Email = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$Profile$FirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Profile$FormFieldUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Profile$LastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$Profile$TermsAccepted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Profile$viewAcceptTerms = F2(
	function (user, form) {
		if ($author$project$Api$Platform$User$One$termsAccepted(user)) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Ui$Icon$view, _List_Nil, 33),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Utils$Html$noBreakSpace,
									$elm$html$Html$text(' You agreed to this software platform\'s')
								])),
							A3(
							$author$project$Ui$Link$externalHref,
							$author$project$Utils$HintUrls$termsUrl,
							_List_fromArray(
								[$author$project$Ui$Link$targetBlank]),
							_List_fromArray(
								[
									$elm$html$Html$text(' Terms of Service.')
								]))
						]))
				]);
		} else {
			var _v0 = $author$project$Utils$Form$fields(form);
			var termsAccepted = _v0.Hw;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Form$Checkbox$view,
							_List_fromArray(
								[
									$author$project$Ui$Form$Checkbox$value(termsAccepted),
									$author$project$Ui$Form$Checkbox$required(true),
									$author$project$Ui$Form$Checkbox$onCheck(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$TermsAccepted))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('I agree to this software platform\'s'),
											A3(
											$author$project$Ui$Link$externalHref,
											$author$project$Utils$HintUrls$termsUrl,
											_List_fromArray(
												[$author$project$Ui$Link$targetBlank]),
											_List_fromArray(
												[
													$elm$html$Html$text(' Terms of Service.')
												]))
										]))
								])),
							$author$project$Utils$FormErrors$view(
							A2($author$project$Utils$Form$validationErrors, 1, form))
						]))
				]);
		}
	});
var $author$project$Pages$User$Profile$viewProfileFields = F4(
	function (user, form, phoneInput, emailDisabled) {
		var _v0 = $author$project$Utils$Form$fields(form);
		var firstName = _v0.Pu;
		var lastName = _v0.SA;
		var email = _v0.Oo;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Name'),
						$author$project$Ui$Form$Group$labelSpanSm(4)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(firstName),
												$author$project$Ui$Form$Input$placeholder('First'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$FirstName))
											]))
									])),
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(4)
									]),
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$view(
										_List_fromArray(
											[
												$author$project$Ui$Form$Input$value(lastName),
												$author$project$Ui$Form$Input$placeholder('Last'),
												$author$project$Ui$Form$Input$onInput(
												A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$LastName))
											]))
									]))
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Email'),
						$author$project$Ui$Form$Group$required(true),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$value(email),
								$author$project$Ui$Form$Input$withFeedback(
								$author$project$Utils$Form$validated(form)),
								$author$project$Ui$Form$Input$placeholder('email@example.com'),
								$author$project$Ui$Form$Input$onInput(
								A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$Email)),
								$author$project$Ui$Form$Input$invalid(
								A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
								$author$project$Ui$Form$Input$errors(
								A2($author$project$Utils$Form$validationErrors, 0, form)),
								$author$project$Ui$Form$Input$disabled(emailDisabled)
							]))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Phone'),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$User$Profile$GotPhoneInputMsg,
						$author$project$Components$PhoneInput$view(phoneInput))
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label(''),
						$author$project$Ui$Form$Group$labelSpanSm(4),
						$author$project$Ui$Form$Group$inputSpanSm(8)
					]),
				A2($author$project$Pages$User$Profile$viewAcceptTerms, user, form))
			]);
	});
var $author$project$Pages$User$Profile$toPane = function (model) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('clearfix')
				]),
			_List_Nil),
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Your account')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form-horizontal'),
									$elm$html$Html$Attributes$name('profileForm'),
									$elm$html$Html$Attributes$novalidate(true),
									$elm$html$Html$Attributes$autocomplete(true)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A4($author$project$Pages$User$Profile$viewProfileFields, model.aaz, model.PB, model.bw, model.E7))
								]))
						])),
					A2(
					$author$project$Ui$Panel$footer,
					_List_fromArray(
						[$author$project$Ui$Element$justifyCenter]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Update profile'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$submit,
									$author$project$Ui$Button$onClick($author$project$Pages$User$Profile$UpdateUser)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update')
								]))
						]))
				]))
		]);
};
var $author$project$Pages$User$Profile$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						$author$project$Pages$User$Profile$toPane(model))
					]))
			]),
		$G: 'Profile'
	};
};
var $author$project$Pages$User$Profile$page = $author$project$Spa$Page$applicationUser(
	{ad0: $author$project$Pages$User$Profile$init, aer: $author$project$Pages$User$Profile$load, agD: $author$project$Pages$User$Profile$save, ahd: $author$project$Pages$User$Profile$subscriptions, aaq: $author$project$Pages$User$Profile$update, ahP: $author$project$Pages$User$Profile$view});
var $author$project$Pages$User$Security$GotSessions = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$User$Security$GotTrustedDevices = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Platform$User$Session$listDefaults = {
	Fi: $elm$core$Maybe$Nothing,
	afy: $author$project$Api$Pagination$init,
	ag1: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$User$Session$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$Session$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				function () {
				var _v0 = options.Fi;
				if (!_v0.$) {
					var filter = _v0.a;
					return _List_fromArray(
						[
							A2($author$project$Api$Param$string, 'filter', filter)
						]);
				} else {
					return _List_Nil;
				}
			}(),
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Platform$User$Session$sessionsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['sessions']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Session$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$Session$One$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$Session$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Session$sessionsPath)));
	});
var $author$project$Pages$User$Security$fetchSessions = F2(
	function (model, toMsg) {
		return A3(
			$author$project$Api$Platform$User$Session$list,
			model.D5,
			function (d) {
				return _Utils_update(
					d,
					{afy: model.gH});
			},
			toMsg);
	});
var $author$project$Api$Platform$TrustedDevice$All$TrustedDevice = $elm$core$Basics$identity;
var $author$project$Api$Platform$TrustedDevice$Shared$TrustedDevice = $elm$core$Basics$identity;
var $author$project$Api$Platform$TrustedDevice$Shared$Record = F4(
	function (isExpired, trustedAt, trustedUntil, requestDetail) {
		return {RM: isExpired, Yg: requestDetail, aac: trustedAt, aad: trustedUntil};
	});
var $author$project$Api$Platform$TrustedDevice$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'request_detail',
	$elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'trusted_until',
		$elm_community$json_extra$Json$Decode$Extra$datetime,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'trusted_at',
			$elm_community$json_extra$Json$Decode$Extra$datetime,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_expired',
				$elm$json$Json$Decode$bool,
				$elm$json$Json$Decode$succeed($author$project$Api$Platform$TrustedDevice$Shared$Record)))));
var $author$project$Api$Platform$TrustedDevice$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$TrustedDevice$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$TrustedDevice$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Platform$TrustedDevice$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Platform$User$TrustedDevice$listDefaults = {
	afy: $author$project$Api$Pagination$init,
	ag1: A3($author$project$Api$Sort$withDefault, 'created_at', 0, $author$project$Api$Sort$init)
};
var $author$project$Api$Platform$User$TrustedDevice$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Platform$User$TrustedDevice$listDefaults);
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Sort$toParams(options.ag1),
				$author$project$Api$Pagination$toApiParams(options.afy)
			]));
};
var $author$project$Api$Platform$User$TrustedDevice$listPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['trusted_devices']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$TrustedDevice$list = F3(
	function (apiClient, optionals, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$TrustedDevice$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Platform$User$TrustedDevice$listOptionsToParams(optionals),
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$TrustedDevice$listPath)));
	});
var $author$project$Pages$User$Security$fetchTrustedDevices = F2(
	function (model, toMsg) {
		return A3(
			$author$project$Api$Platform$User$TrustedDevice$list,
			model.D5,
			function (d) {
				return _Utils_update(
					d,
					{afy: model.g4});
			},
			toMsg);
	});
var $author$project$Pages$User$Security$initPasswordFormFields = {aeQ: '', rx: '', afC: '', nh: $elm$core$Maybe$Nothing};
var $author$project$Pages$User$Security$init = F4(
	function (session, user, shared, _v0) {
		var model = {
			D5: shared.D5,
			il: false,
			gf: $author$project$Utils$Form$init($author$project$Pages$User$Security$initPasswordFormFields),
			ni: $author$project$Api$Data$NotAsked,
			ZD: session,
			oc: $author$project$Api$Data$Loading,
			gH: $author$project$Api$Pagination$init,
			Hy: shared.Hy,
			oT: $author$project$Api$Data$Loading,
			g4: $author$project$Api$Pagination$init,
			aaz: user
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Pages$User$Security$fetchSessions, model, $author$project$Pages$User$Security$GotSessions),
						A2($author$project$Pages$User$Security$fetchTrustedDevices, model, $author$project$Pages$User$Security$GotTrustedDevices)
					])));
	});
var $author$project$Pages$User$Security$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$User$Security$save = F2(
	function (_v0, shared) {
		return shared;
	});
var $author$project$Pages$User$Security$DisableMfaHiConfirmClosed = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$User$Security$PasswordFormFieldUpdated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Security$PasswordStrengthCheck = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$User$Security$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$PasswordStrength$checked(
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$PasswordStrengthCheck),
					$elm$core$Maybe$Just)),
				model.il ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$User$Security$DisableMfaHiConfirmClosed) : $elm$core$Platform$Sub$none
			]));
};
var $author$project$Pages$User$Security$GotMfaDestroy = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Platform$Mfa$delete = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$delete,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
	});
var $author$project$Pages$User$Security$passwordFormFieldsUpdate = F2(
	function (field, fields) {
		switch (field.$) {
			case 0:
				var string = field.a;
				return _Utils_update(
					fields,
					{afC: string});
			case 1:
				var string = field.a;
				return _Utils_update(
					fields,
					{aeQ: string, nh: $elm$core$Maybe$Nothing});
			case 2:
				var string = field.a;
				return _Utils_update(
					fields,
					{rx: string});
			default:
				var check = field.a;
				return _Utils_update(
					fields,
					{nh: check});
		}
	});
var $author$project$Pages$User$Security$NewPasswordValidation = 1;
var $author$project$Pages$User$Security$PasswordValidation = 0;
var $author$project$Pages$User$Security$NewPasswordConfirmationValidation = 2;
var $author$project$Pages$User$Security$validateNewPasswordConfirmation = function (form) {
	return $elm$core$String$isEmpty(form.aeQ) ? _List_Nil : (_Utils_eq(form.aeQ, form.rx) ? _List_Nil : _List_fromArray(
		[
			_Utils_Tuple2(2, 'The new password and its confirmation don\'t match')
		]));
};
var $author$project$Pages$User$Security$passwordFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.afC;
			},
			_Utils_Tuple2(0, 'Please enter your current password.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.aeQ;
			},
			_Utils_Tuple2(1, 'Please enter your new password.')),
			$rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$User$Security$validateNewPasswordConfirmation),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.nh));
			},
			_Utils_Tuple2(1, 'Please enter a secure password.'))
		]));
var $author$project$Pages$User$Security$GotPasswordUpdate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Platform$User$Password$passwordPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['password']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Password$update = F3(
	function (apiClient, fields, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'password',
					$elm$json$Json$Encode$string(fields.afC)),
					_Utils_Tuple2(
					'new_password',
					$elm$json$Json$Encode$string(fields.aeQ))
				]));
		return A4(
			$author$project$Api$Data$patch,
			apiClient,
			$author$project$Api$Data$emptyBodyDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Password$passwordPath)));
	});
var $author$project$Pages$User$Security$updatePassword = F2(
	function (apiClient, passwordFormFields) {
		return A3(
			$author$project$Api$Platform$User$Password$update,
			apiClient,
			$rtfeldman$elm_validate$Validate$fromValid(passwordFormFields),
			$author$project$Pages$User$Security$GotPasswordUpdate);
	});
var $author$project$Pages$User$Security$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var field = msg.a;
				var _v1 = _Utils_Tuple2(
					A3($author$project$Utils$Form$update, $author$project$Pages$User$Security$passwordFormFieldsUpdate, field, model.gf),
					function () {
						if (field.$ === 1) {
							var newPassword = field.a;
							return $author$project$Ports$PasswordStrength$check(newPassword);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
				var newForm = _v1.a;
				var cmd = _v1.b;
				var validatedForm = function () {
					var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Security$passwordFormFieldsValidator, newForm);
					if (!_v3.$) {
						var _v4 = _v3.a;
						var form = _v4.a;
						return form;
					} else {
						var form = _v3.a;
						return form;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gf: validatedForm}),
					cmd,
					_List_Nil);
			case 1:
				var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Security$passwordFormFieldsValidator, model.gf);
				if (!_v5.$) {
					var _v6 = _v5.a;
					var newForm = _v6.a;
					var validFormFields = _v6.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gf: newForm, ni: $author$project$Api$Data$Loading}),
						A2($author$project$Pages$User$Security$updatePassword, model.D5, validFormFields),
						_List_Nil);
				} else {
					var newForm = _v5.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gf: newForm}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				}
			case 2:
				var passwordUpdate = msg.a;
				if (passwordUpdate.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ni: passwordUpdate}),
						$elm$core$Platform$Cmd$none,
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Your password has been updated')
							]));
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ni: passwordUpdate}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(passwordUpdate));
				}
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{il: true}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var confirmed = msg.a;
				return confirmed ? _Utils_Tuple3(
					_Utils_update(
						model,
						{il: false}),
					A2($author$project$Api$Platform$Mfa$delete, model.D5, $author$project$Pages$User$Security$GotMfaDestroy),
					_List_Nil) : _Utils_Tuple3(
					_Utils_update(
						model,
						{il: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 5:
				var dataMfa = msg.a;
				if (dataMfa.$ === 3) {
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Session$logout(
							{af6: true}),
						_List_fromArray(
							[
								A2($author$project$OutMsg$ShowToast, 3, 'Multi-factor authentication has been disabled.')
							]));
				} else {
					return _Utils_Tuple3(
						model,
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$handleErrorResponse(dataMfa));
				}
			case 6:
				var dataSessions = msg.a;
				if (dataSessions.$ === 3) {
					var headers = dataSessions.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								oc: dataSessions,
								gH: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.gH)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oc: dataSessions}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(dataSessions));
				}
			case 7:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.gH);
				var newModel = _Utils_update(
					model,
					{gH: pagination});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$User$Security$fetchSessions, newModel, $author$project$Pages$User$Security$GotSessions),
					_List_Nil);
			case 8:
				var dataTrustedDevices = msg.a;
				if (dataTrustedDevices.$ === 3) {
					var headers = dataTrustedDevices.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								oT: dataTrustedDevices,
								g4: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.g4)
							}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{oT: dataTrustedDevices}),
						$elm$core$Platform$Cmd$none,
						$author$project$OutMsg$reportDecodeError(dataTrustedDevices));
				}
			case 9:
				var subMsg = msg.a;
				var pagination = A2($author$project$Api$Pagination$update, subMsg, model.g4);
				var newModel = _Utils_update(
					model,
					{g4: pagination});
				return _Utils_Tuple3(
					newModel,
					A2($author$project$Pages$User$Security$fetchTrustedDevices, newModel, $author$project$Pages$User$Security$GotTrustedDevices),
					_List_Nil);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Pages$User$Security$EnableMfaClicked = {$: 10};
var $author$project$Pages$User$Security$OpenDisableMfaHiConfirm = {$: 3};
var $author$project$Pages$User$Security$TrustedDevicesPaginationMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Platform$User$Shared$mfaStatus = function (_v0) {
	var record = _v0;
	return record.TW;
};
var $author$project$Api$Platform$User$One$mfaStatus = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Platform$User$Shared$mfaStatus(shared);
};
var $author$project$Api$Common$RequestDetail$Shared$clientDescription = function (requestDetail) {
	return A2(
		$elm$core$String$join,
		' on ',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				$author$project$Api$Common$RequestDetail$Shared$clientName(requestDetail)),
				A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				$author$project$Api$Common$RequestDetail$Shared$osName(requestDetail)) + (' ' + A2(
				$elm$core$Maybe$withDefault,
				'N/A',
				$author$project$Api$Common$RequestDetail$Shared$deviceType(requestDetail)))
			]));
};
var $author$project$Api$Platform$TrustedDevice$Shared$isExpired = function (_v0) {
	var record = _v0;
	return record.RM;
};
var $author$project$Api$Platform$TrustedDevice$All$isExpired = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$TrustedDevice$Shared$isExpired(shared);
};
var $author$project$Api$Platform$TrustedDevice$Shared$requestDetail = function (_v0) {
	var record = _v0;
	return record.Yg;
};
var $author$project$Api$Platform$TrustedDevice$All$requestDetail = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$TrustedDevice$Shared$requestDetail(shared);
};
var $author$project$Api$Platform$TrustedDevice$Shared$trustedAt = function (_v0) {
	var record = _v0;
	return record.aac;
};
var $author$project$Api$Platform$TrustedDevice$All$trustedAt = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$TrustedDevice$Shared$trustedAt(shared);
};
var $author$project$Api$Platform$TrustedDevice$Shared$trustedUntil = function (_v0) {
	var record = _v0;
	return record.aad;
};
var $author$project$Api$Platform$TrustedDevice$All$trustedUntil = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Platform$TrustedDevice$Shared$trustedUntil(shared);
};
var $author$project$Pages$User$Security$viewTrustedDevice = F2(
	function (timeFormatter, trustedDevice) {
		var style = $author$project$Api$Platform$TrustedDevice$All$isExpired(trustedDevice) ? 3 : 0;
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[
					$author$project$Ui$ListGroup$style(style)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'N/A',
								A2(
									$elm$core$Maybe$map,
									$author$project$Api$Common$RequestDetail$Shared$clientDescription,
									$author$project$Api$Platform$TrustedDevice$All$requestDetail(trustedDevice)))),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Trusted from ' + (A2(
										timeFormatter,
										0,
										$author$project$Api$Platform$TrustedDevice$All$trustedAt(trustedDevice)) + (' to ' + A2(
										timeFormatter,
										0,
										$author$project$Api$Platform$TrustedDevice$All$trustedUntil(trustedDevice)))))
								]))
						]))
				]));
	});
var $author$project$Pages$User$Security$viewTrustedDeviceSkeleton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween]),
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Chrome on Mac')
						])),
					$author$project$Ui$Skeleton$text(
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$spanFromText('Trusted on mm/dd/YYYY at ll:MM pp')
						]))
				]))
		]));
var $author$project$Pages$User$Security$viewMfaStatus = function (model) {
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-horizontal')
			]),
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Multi-factor authentication (MFA)')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_fromArray(
					[
						$author$project$Ui$Form$Group$label('Status'),
						$author$project$Ui$Form$Group$labelSpan(4),
						$author$project$Ui$Form$Group$inputSpan(8)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = $author$project$Api$Platform$User$One$mfaStatus(model.aaz);
								if (!_v0) {
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 18),
												$author$project$Utils$Html$noBreakSpace,
												$elm$html$Html$text('Enabled '),
												function () {
												var label = $author$project$Api$Platform$User$One$requiresMfa(model.aaz) ? 'Reset MFA device' : 'Disable';
												return A3(
													$author$project$Ui$Button$view,
													{abp: label},
													_List_fromArray(
														[
															$author$project$Ui$Button$link,
															$author$project$Ui$Button$padding($author$project$Ui$Padding$none),
															$author$project$Ui$Button$onClick($author$project$Pages$User$Security$OpenDisableMfaHiConfirm)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(label)
														]));
											}()
											]));
								} else {
									return A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Ui$Icon$view, _List_Nil, 19),
												$author$project$Utils$Html$noBreakSpace,
												$elm$html$Html$text('Disabled'),
												$author$project$Utils$Html$noBreakSpace,
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$User__Mfa,
												_List_fromArray(
													[
														$author$project$Ui$Link$onClick($author$project$Pages$User$Security$EnableMfaClicked)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Enable Now')
													]))
											]));
								}
							}()
							]))
					])),
				function () {
				var _v1 = $author$project$Api$Platform$User$One$mfaStatus(model.aaz);
				if (!_v1) {
					return A2(
						$author$project$Ui$Form$Group$view,
						_List_fromArray(
							[
								$author$project$Ui$Form$Group$label('Trusted devices'),
								$author$project$Ui$Form$Group$labelSpan(4),
								$author$project$Ui$Form$Group$inputSpan(8)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Form$Static$view,
								_List_Nil,
								_List_fromArray(
									[
										function () {
										var _v2 = model.oT;
										if (_v2.$ === 3) {
											var trustedDevices = _v2.a;
											return A2(
												$author$project$Ui$ListGroup$view,
												_List_Nil,
												A2(
													$elm$core$List$map,
													$author$project$Pages$User$Security$viewTrustedDevice(model.Hy),
													trustedDevices));
										} else {
											return A2(
												$author$project$Ui$ListGroup$view,
												_List_Nil,
												A2($elm$core$List$repeat, 10, $author$project$Pages$User$Security$viewTrustedDeviceSkeleton));
										}
									}(),
										A2(
										$elm$html$Html$map,
										$author$project$Pages$User$Security$TrustedDevicesPaginationMsg,
										A2(
											$author$project$Api$Pagination$view,
											_List_fromArray(
												[
													$author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
													$author$project$Ui$Pagination$List$loading(
													!$author$project$Api$Data$isSuccess(model.oT))
												]),
											model.g4))
									]))
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Pages$User$Security$NewPassword = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$User$Security$NewPasswordConfirmation = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$User$Security$Password = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$User$Security$UpdatePassword = {$: 1};
var $author$project$Pages$User$Security$viewPasswordForm = F2(
	function (passwordUpdate, passwordForm) {
		var _v0 = $author$project$Utils$Form$fields(passwordForm);
		var password = _v0.afC;
		var newPassword = _v0.aeQ;
		var newPasswordConfirmation = _v0.rx;
		var passwordStrengthCheck = _v0.nh;
		return A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('form-horizontal'),
					$elm$html$Html$Attributes$novalidate(true),
					$elm$html$Html$Attributes$autocomplete(true)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text('Password')
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('Current Password'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpan(4),
							$author$project$Ui$Form$Group$inputSpan(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(password),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$password,
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$Password)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 0, passwordForm)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 0, passwordForm))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('New Password'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$PasswordInput$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$PasswordInput$value(newPassword),
									$author$project$Ui$Form$PasswordInput$strengthCheck(passwordStrengthCheck),
									$author$project$Ui$Form$PasswordInput$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$NewPassword)),
									$author$project$Ui$Form$PasswordInput$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 1, passwordForm)),
									$author$project$Ui$Form$PasswordInput$errors(
									A2($author$project$Utils$Form$validationErrors, 1, passwordForm))
								]))
						])),
					A2(
					$author$project$Ui$Form$Group$view,
					_List_fromArray(
						[
							$author$project$Ui$Form$Group$label('New Password Confirmation'),
							$author$project$Ui$Form$Group$required(true),
							$author$project$Ui$Form$Group$labelSpanSm(4),
							$author$project$Ui$Form$Group$inputSpanSm(8)
						]),
					_List_fromArray(
						[
							$author$project$Ui$Form$Input$view(
							_List_fromArray(
								[
									$author$project$Ui$Form$Input$value(newPasswordConfirmation),
									$author$project$Ui$Form$Input$phi(true),
									$author$project$Ui$Form$Input$password,
									$author$project$Ui$Form$Input$onInput(
									A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$NewPasswordConfirmation)),
									$author$project$Ui$Form$Input$invalid(
									A2($author$project$Utils$Form$hasValidationErrors, 2, passwordForm)),
									$author$project$Ui$Form$Input$errors(
									A2($author$project$Utils$Form$validationErrors, 2, passwordForm))
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$textCenter, $author$project$Ui$Element$mt4]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Update security settings'},
							_List_fromArray(
								[
									$author$project$Ui$Button$primary,
									$author$project$Ui$Button$onClick($author$project$Pages$User$Security$UpdatePassword),
									$author$project$Ui$Button$loading(
									_Utils_eq(passwordUpdate, $author$project$Api$Data$Loading))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update')
								]))
						]))
				]));
	});
var $author$project$Pages$User$Security$SessionsPaginationMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Common$RequestDetail$Shared$countryCode = function (_v0) {
	var record = _v0;
	return record.LZ;
};
var $author$project$Api$Platform$Session$One$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Platform$Session$One$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Common$RequestDetail$Shared$locationDescription = function (_v0) {
	var record = _v0;
	var _v1 = _Utils_Tuple2(record.sZ, record.pZ);
	if (!_v1.a.$) {
		if (!_v1.b.$) {
			var state_ = _v1.a.a;
			var country_ = _v1.b.a;
			return state_ + (' - ' + country_);
		} else {
			var state_ = _v1.a.a;
			var _v2 = _v1.b;
			return state_;
		}
	} else {
		if (!_v1.b.$) {
			var _v3 = _v1.a;
			var country_ = _v1.b.a;
			return country_;
		} else {
			var _v4 = _v1.a;
			var _v5 = _v1.b;
			return 'N/A';
		}
	}
};
var $author$project$Api$Platform$Session$One$requestDetail = function (_v0) {
	var record = _v0;
	return record.Yg;
};
var $author$project$Ui$CountryFlag$flagClass = function (code) {
	return 'fi-' + $elm$core$String$toLower(code);
};
var $author$project$Ui$CountryFlag$view = F2(
	function (_v0, code) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('fi'),
					$elm$html$Html$Attributes$class(
					$author$project$Ui$CountryFlag$flagClass(code))
				]),
			_List_Nil);
	});
var $author$project$Pages$User$Security$viewSession = F3(
	function (currentSession, timeFormatter, session) {
		var options = _Utils_eq(
			$author$project$Api$Platform$Session$One$id(currentSession),
			$author$project$Api$Platform$Session$One$id(session)) ? _List_fromArray(
			[
				$author$project$Ui$ListGroup$style(1)
			]) : _List_Nil;
		return A2(
			$author$project$Ui$ListGroup$item,
			options,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Started at: ')
												])),
											$elm$html$Html$text(
											A2(
												timeFormatter,
												0,
												$author$project$Api$Platform$Session$One$createdAt(session)))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Location: ')
												])),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Common$RequestDetail$Shared$locationDescription,
													$author$project$Api$Platform$Session$One$requestDetail(session)))),
											$author$project$Utils$Html$noBreakSpace,
											function () {
											var _v0 = A2(
												$elm$core$Maybe$andThen,
												$author$project$Api$Common$RequestDetail$Shared$countryCode,
												$author$project$Api$Platform$Session$One$requestDetail(session));
											if (!_v0.$) {
												var countryCode = _v0.a;
												return A2($author$project$Ui$CountryFlag$view, _List_Nil, countryCode);
											} else {
												return $author$project$Utils$Html$empty;
											}
										}()
										]))
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Device: ')
												])),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$map,
													$author$project$Api$Common$RequestDetail$Shared$clientDescription,
													$author$project$Api$Platform$Session$One$requestDetail(session))))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Role: ')
												])),
											$elm$html$Html$text(
											$author$project$Formatters$String$titleize(
												$author$project$Formatters$String$humanize(
													$author$project$Api$Platform$Session$One$role(session))))
										])),
									A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$strong,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('IP: ')
												])),
											$elm$html$Html$text(
											A2(
												$elm$core$Maybe$withDefault,
												'N/A',
												A2(
													$elm$core$Maybe$andThen,
													$author$project$Api$Common$RequestDetail$Shared$ip,
													$author$project$Api$Platform$Session$One$requestDetail(session))))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$User$Security$viewSessionSkeleton = A2(
	$author$project$Ui$ListGroup$item,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$spaceBetween]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Started at: mm/dd/YYYY at ll:MM pp')
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Location: Montevideo')
								]))
						])),
					A2(
					$author$project$Ui$Element$view,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Authenticated by: SSO')
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Device: Chrome on Mac desktop')
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('Role: Practice Admin')
								])),
							$author$project$Ui$Skeleton$text(
							_List_fromArray(
								[
									$author$project$Ui$Skeleton$block,
									$author$project$Ui$Skeleton$spanFromText('IP: 123.456.78.900')
								]))
						]))
				]))
		]));
var $author$project$Pages$User$Security$viewSessions = function (model) {
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('form-horizontal')
			]),
		_List_fromArray(
			[
				$author$project$Ui$HorizontalRule$view(_List_Nil),
				$author$project$Ui$Typography$headingSm(
				_List_fromArray(
					[
						$elm$html$Html$text('Sessions')
					])),
				A2(
				$author$project$Ui$Form$Group$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								function () {
								var _v0 = model.oc;
								if (_v0.$ === 3) {
									var sessions = _v0.a;
									return A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2(
											$elm$core$List$map,
											A2($author$project$Pages$User$Security$viewSession, model.ZD, model.Hy),
											sessions));
								} else {
									return A2(
										$author$project$Ui$ListGroup$view,
										_List_Nil,
										A2($elm$core$List$repeat, 10, $author$project$Pages$User$Security$viewSessionSkeleton));
								}
							}(),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$User$Security$SessionsPaginationMsg,
								A2(
									$author$project$Api$Pagination$view,
									_List_fromArray(
										[
											$author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
											$author$project$Ui$Pagination$List$loading(
											!$author$project$Api$Data$isSuccess(model.oc))
										]),
									model.gH))
							]))
					]))
			]));
};
var $author$project$Pages$User$Security$toPane = function (model) {
	return _List_fromArray(
		[
			model.il ? A2(
			$author$project$Components$HiConfirm$modal,
			$author$project$Pages$User$Security$DisableMfaHiConfirmClosed,
			_List_fromArray(
				[
					$author$project$Components$HiConfirm$verb('disable'),
					$author$project$Components$HiConfirm$noun('MFA'),
					$author$project$Components$HiConfirm$customMessage(
					_List_fromArray(
						[
							$elm$html$Html$text('Disabling MFA will prevent you from accessing practices that enforce its use. You will be logged out and will have to login again.')
						]))
				])) : $author$project$Utils$Html$empty,
			$author$project$Ui$Clearfix$view,
			A2(
			$author$project$Ui$Panel$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$heading,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Ui$Panel$title(
							_List_fromArray(
								[
									$elm$html$Html$text('Security')
								]))
						])),
					A2(
					$author$project$Ui$Panel$body,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Pages$User$Security$viewPasswordForm, model.ni, model.gf),
							$author$project$Pages$User$Security$viewMfaStatus(model),
							$author$project$Pages$User$Security$viewSessions(model)
						]))
				]))
		]);
};
var $author$project$Pages$User$Security$view = function (model) {
	return {
		e5: _List_fromArray(
			[
				A2(
				$author$project$Ui$FlexGrid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$FlexGrid$column,
						_List_fromArray(
							[
								$author$project$Ui$FlexGrid$spanMd(12)
							]),
						$author$project$Pages$User$Security$toPane(model))
					]))
			]),
		$G: 'Profile | Security'
	};
};
var $author$project$Pages$User$Security$page = $author$project$Spa$Page$applicationUser(
	{ad0: $author$project$Pages$User$Security$init, aer: $author$project$Pages$User$Security$load, agD: $author$project$Pages$User$Security$save, ahd: $author$project$Pages$User$Security$subscriptions, aaq: $author$project$Pages$User$Security$update, ahP: $author$project$Pages$User$Security$view});
var $author$project$Spa$Url$toQueryDict = function (queryString) {
	return $elm$core$Dict$fromList(
		$author$project$Spa$Url$toQuery(queryString));
};
var $author$project$Spa$Url$create = F2(
	function (params, url) {
		return {
			Vx: params,
			Bi: A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Dict$empty,
				A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, url.Bi)),
			af3: url
		};
	});
var $author$project$Spa$Document$map = F2(
	function (fn, doc) {
		return {
			e5: A2(
				$elm$core$List$map,
				$elm$html$Html$map(fn),
				doc.e5),
			$G: doc.$G
		};
	});
var $author$project$Spa$Generated$Pages$mapFirstAndSecond = F3(
	function (mapFirst, mapSecond, _v0) {
		var first = _v0.a;
		var second = _v0.b;
		var third = _v0.c;
		return _Utils_Tuple3(
			mapFirst(first),
			mapSecond(second),
			third);
	});
var $author$project$Spa$Generated$Pages$upgrade = F3(
	function (toModel, toMsg, page) {
		var update_ = F2(
			function (msg, model) {
				return A3(
					$author$project$Spa$Generated$Pages$mapFirstAndSecond,
					toModel,
					$elm$core$Platform$Cmd$map(toMsg),
					A2(page.aaq, msg, model));
			});
		var load_ = F2(
			function (model, shared) {
				return A3(
					$author$project$Spa$Generated$Pages$mapFirstAndSecond,
					toModel,
					$elm$core$Platform$Cmd$map(toMsg),
					A2(page.aer, shared, model));
			});
		var init_ = F2(
			function (params, shared) {
				return A3(
					$author$project$Spa$Generated$Pages$mapFirstAndSecond,
					toModel,
					$elm$core$Platform$Cmd$map(toMsg),
					A2(
						page.ad0,
						shared,
						A2($author$project$Spa$Url$create, params, shared.aav)));
			});
		var bundle_ = function (model) {
			return {
				aer: function (_v0) {
					return load_(model);
				},
				agD: function (_v1) {
					return page.agD(model);
				},
				ahd: function (_v2) {
					return A2(
						$elm$core$Platform$Sub$map,
						toMsg,
						page.ahd(model));
				},
				ahP: function (_v3) {
					return A2(
						$author$project$Spa$Document$map,
						toMsg,
						page.ahP(model));
				}
			};
		};
		return {a: bundle_, ad0: init_, aaq: update_};
	});
var $author$project$Spa$Generated$Pages$pages = {
	tE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Accounting__Model, $author$project$Spa$Generated$Pages$Accounting__Msg, $author$project$Pages$Accounting$page),
	tN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Model, $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Msg, $author$project$Pages$Admin$AdvanceBilling$page),
	tO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Msg, $author$project$Pages$Admin$Athenahealth$Fields$page),
	tP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Msg, $author$project$Pages$Admin$Athenahealth$Link$page),
	tQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Msg, $author$project$Pages$Admin$Athenahealth$Locations$page),
	tR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Msg, $author$project$Pages$Admin$Athenahealth$Overview$page),
	tS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Msg, $author$project$Pages$Admin$Athenahealth$Providers$page),
	tT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Msg, $author$project$Pages$Admin$Athenahealth$Top$page),
	tU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Billing__Model, $author$project$Spa$Generated$Pages$Admin__Billing__Msg, $author$project$Pages$Admin$Billing$page),
	tV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Msg, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$page),
	tW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Model, $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Msg, $author$project$Pages$Admin$CancellationReasons$page),
	tX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CardReaders__Model, $author$project$Spa$Generated$Pages$Admin__CardReaders__Msg, $author$project$Pages$Admin$CardReaders$page),
	tY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Categories__Model, $author$project$Spa$Generated$Pages$Admin__Categories__Msg, $author$project$Pages$Admin$Categories$page),
	tZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Msg, $author$project$Pages$Admin$ChargeItems$Id_String$page),
	t_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Msg, $author$project$Pages$Admin$ChargeItems$New$page),
	t$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Msg, $author$project$Pages$Admin$ChargeItems$Top$page),
	t0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Msg, $author$project$Pages$Admin$ChargeItems$Upload$page),
	t1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Commissions__Model, $author$project$Spa$Generated$Pages$Admin__Commissions__Msg, $author$project$Pages$Admin$Commissions$page),
	t2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Msg, $author$project$Pages$Admin$CompanyPlans$Id_String$page),
	t3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Msg, $author$project$Pages$Admin$CompanyPlans$New$page),
	t4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Msg, $author$project$Pages$Admin$CompanyPlans$Top$page),
	t5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Coupons__Model, $author$project$Spa$Generated$Pages$Admin__Coupons__Msg, $author$project$Pages$Admin$Coupons$page),
	t6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Msg, $author$project$Pages$Admin$CoveragePlans$Id_String$page),
	t7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Msg, $author$project$Pages$Admin$CoveragePlans$New$page),
	t8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Msg, $author$project$Pages$Admin$CoveragePlans$Top$page),
	t9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CreditCategories__Model, $author$project$Spa$Generated$Pages$Admin__CreditCategories__Msg, $author$project$Pages$Admin$CreditCategories$page),
	ua: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Model, $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Msg, $author$project$Pages$Admin$Credits$Upload$page),
	ub: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Msg, $author$project$Pages$Admin$DataExportSettings$Id_String$page),
	uc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Msg, $author$project$Pages$Admin$DataExportSettings$New$page),
	ud: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Msg, $author$project$Pages$Admin$DataExportSettings$Top$page),
	ue: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Msg, $author$project$Pages$Admin$DataExport$Id_String$page),
	uf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Model, $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Msg, $author$project$Pages$Admin$DataExport$Top$page),
	ug: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Model, $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Msg, $author$project$Pages$Admin$Developers$ApiKeys$page),
	uh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Model, $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Msg, $author$project$Pages$Admin$Developers$GetStarted$page),
	ui: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Model, $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Msg, $author$project$Pages$Admin$Developers$Sandboxes$page),
	uj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Model, $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Msg, $author$project$Pages$Admin$Developers$WebhookEndpoints$page),
	uk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Msg, $author$project$Pages$Admin$Documents$Id_String$page),
	ul: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__New__Model, $author$project$Spa$Generated$Pages$Admin__Documents__New__Msg, $author$project$Pages$Admin$Documents$New$page),
	um: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__Top__Model, $author$project$Spa$Generated$Pages$Admin__Documents__Top__Msg, $author$project$Pages$Admin$Documents$Top$page),
	un: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Model, $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Msg, $author$project$Pages$Admin$ElationLegacy$page),
	uo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Link__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Link__Msg, $author$project$Pages$Admin$Elation$Link$page),
	up: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Msg, $author$project$Pages$Admin$Elation$Overview$page),
	uq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Msg, $author$project$Pages$Admin$Elation$Providers$page),
	ur: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Top__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Top__Msg, $author$project$Pages$Admin$Elation$Top$page),
	us: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Features__Model, $author$project$Spa$Generated$Pages$Admin__Features__Msg, $author$project$Pages$Admin$Features$page),
	ut: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Model, $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Msg, $author$project$Pages$Admin$HipaaAuthorizations$page),
	uu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Model, $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Msg, $author$project$Pages$Admin$Integrations$Slug_String$page),
	uv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__InternalSettings__Model, $author$project$Spa$Generated$Pages$Admin__InternalSettings__Msg, $author$project$Pages$Admin$InternalSettings$page),
	uw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Model, $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Msg, $author$project$Pages$Admin$InvoiceSettings$page),
	ux: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__LeadSources__Model, $author$project$Spa$Generated$Pages$Admin__LeadSources__Msg, $author$project$Pages$Admin$LeadSources$page),
	uy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Locations__Model, $author$project$Spa$Generated$Pages$Admin__Locations__Msg, $author$project$Pages$Admin$Locations$page),
	uz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Mailgun__Model, $author$project$Spa$Generated$Pages$Admin__Mailgun__Msg, $author$project$Pages$Admin$Mailgun$page),
	uA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notes__Model, $author$project$Spa$Generated$Pages$Admin__Notes__Msg, $author$project$Pages$Admin$Notes$page),
	uB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Msg, $author$project$Pages$Admin$Notifications$Company$page),
	uC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Msg, $author$project$Pages$Admin$Notifications$Employee$page),
	uD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Msg, $author$project$Pages$Admin$Notifications$Membership$page),
	uE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Msg, $author$project$Pages$Admin$Notifications$Patient$page),
	uF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Msg, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$page),
	uG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Msg, $author$project$Pages$Admin$Notifications$Practice$page),
	uH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Msg, $author$project$Pages$Admin$Notifications$Settings$page),
	uI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Patients__Model, $author$project$Spa$Generated$Pages$Admin__Patients__Msg, $author$project$Pages$Admin$Patients$page),
	uJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Model, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Msg, $author$project$Pages$Admin$PaymentMethodImport$page),
	uK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Model, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Msg, $author$project$Pages$Admin$PaymentMethodImport$Upload$page),
	uL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Model, $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Msg, $author$project$Pages$Admin$PaymentProcessing$page),
	uM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentSources__Model, $author$project$Spa$Generated$Pages$Admin__PaymentSources__Msg, $author$project$Pages$Admin$PaymentSources$page),
	uN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Msg, $author$project$Pages$Admin$Plans$Id_String$page),
	uO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Msg, $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$page),
	uP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Msg, $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$page),
	uQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__New__Model, $author$project$Spa$Generated$Pages$Admin__Plans__New__Msg, $author$project$Pages$Admin$Plans$New$page),
	uR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Top__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Top__Msg, $author$project$Pages$Admin$Plans$Top$page),
	uS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Practice__Model, $author$project$Spa$Generated$Pages$Admin__Practice__Msg, $author$project$Pages$Admin$Practice$page),
	uT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Model, $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Msg, $author$project$Pages$Admin$ProviderGroups$page),
	uU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Providers__Top__Model, $author$project$Spa$Generated$Pages$Admin__Providers__Top__Msg, $author$project$Pages$Admin$Providers$Top$page),
	uV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Model, $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Msg, $author$project$Pages$Admin$Providers$Upload$page),
	uW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Model, $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Msg, $author$project$Pages$Admin$Quickbooks$Top$page),
	uX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Model, $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Msg, $author$project$Pages$Admin$ScheduledJobs$page),
	uY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SelfService__Model, $author$project$Spa$Generated$Pages$Admin__SelfService__Msg, $author$project$Pages$Admin$SelfService$page),
	uZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Signup__Model, $author$project$Spa$Generated$Pages$Admin__Signup__Msg, $author$project$Pages$Admin$Signup$page),
	u_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Msg, $author$project$Pages$Admin$SignupPages$Id_String$page),
	u$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Msg, $author$project$Pages$Admin$SignupPages$New$page),
	u0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Msg, $author$project$Pages$Admin$SignupPages$Top$page),
	u1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Stripe__Model, $author$project$Spa$Generated$Pages$Admin__Stripe__Msg, $author$project$Pages$Admin$Stripe$page),
	u2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Taxes__Model, $author$project$Spa$Generated$Pages$Admin__Taxes__Msg, $author$project$Pages$Admin$Taxes$page),
	u3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Team__Model, $author$project$Spa$Generated$Pages$Admin__Team__Msg, $author$project$Pages$Admin$Team$page),
	u4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Team__New__Model, $author$project$Spa$Generated$Pages$Admin__Team__New__Msg, $author$project$Pages$Admin$Team$New$page),
	u6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$AffiliateBills__Top__Model, $author$project$Spa$Generated$Pages$AffiliateBills__Top__Msg, $author$project$Pages$AffiliateBills$Top$page),
	u8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Msg, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$page),
	u9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$page),
	va: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$page),
	vb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Msg, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$page),
	vc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Msg, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$page),
	vd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Patients$page),
	ve: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Settings$page),
	vf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Users$page),
	vg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__Create__Model, $author$project$Spa$Generated$Pages$Affiliates__Create__Msg, $author$project$Pages$Affiliates$Create$page),
	vh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__New__Model, $author$project$Spa$Generated$Pages$Affiliates__New__Msg, $author$project$Pages$Affiliates$New$page),
	vi: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__Top__Model, $author$project$Spa$Generated$Pages$Affiliates__Top__Msg, $author$project$Pages$Affiliates$Top$page),
	vr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Apps__Slug_String__Model, $author$project$Spa$Generated$Pages$Apps__Slug_String__Msg, $author$project$Pages$Apps$Slug_String$page),
	vH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Blank__Model, $author$project$Spa$Generated$Pages$Blank__Msg, $author$project$Pages$Blank$page),
	vP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Calendar__Model, $author$project$Spa$Generated$Pages$Calendar__Msg, $author$project$Pages$Calendar$page),
	v0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Charges__New__Model, $author$project$Spa$Generated$Pages$Charges__New__Msg, $author$project$Pages$Charges$New$page),
	v8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$page),
	v9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$page),
	wa: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$page),
	wb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$page),
	wc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$page),
	wd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$page),
	we: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$page),
	wf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$page),
	wg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$page),
	wh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Msg, $author$project$Pages$Commissions$BrokerAccounts$New$page),
	wi: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$Top$page),
	wj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Model, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Msg, $author$project$Pages$Commissions$StatementLines$Summary$page),
	wk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Model, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Msg, $author$project$Pages$Commissions$StatementLines$Top$page),
	wl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__Statements__Model, $author$project$Spa$Generated$Pages$Commissions__Statements__Msg, $author$project$Pages$Commissions$Statements$page),
	wm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Msg, $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$page),
	wn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Msg, $author$project$Pages$Companies$CompanyId_String$Eas$page),
	wo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$Create$page),
	wp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$page),
	wq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$Top$page),
	wr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Msg, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$page),
	ws: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Msg, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$page),
	wt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Msg, $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$page),
	wu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$page),
	wv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Msg, $author$project$Pages$Companies$CompanyId_String$Notes$page),
	ww: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Msg, $author$project$Pages$Companies$CompanyId_String$Notifications$page),
	wx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Msg, $author$project$Pages$Companies$CompanyId_String$PaymentSources$page),
	wy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Msg, $author$project$Pages$Companies$CompanyId_String$Signup$page),
	wz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Msg, $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$page),
	wA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Msg, $author$project$Pages$Companies$CompanyId_String$SignupPages$New$page),
	wB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Top$page),
	wC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$page),
	wD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$page),
	wE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$page),
	wF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__New__Model, $author$project$Spa$Generated$Pages$Companies__New__Msg, $author$project$Pages$Companies$New$page),
	wG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__Top__Model, $author$project$Spa$Generated$Pages$Companies__Top__Msg, $author$project$Pages$Companies$Top$page),
	wI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Model, $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Msg, $author$project$Pages$Contacts$ContactId_String$Top$page),
	wJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__List__Model, $author$project$Spa$Generated$Pages$Contacts__List__Msg, $author$project$Pages$Contacts$List$page),
	wK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__New__Model, $author$project$Spa$Generated$Pages$Contacts__New__Msg, $author$project$Pages$Contacts$New$page),
	xt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Error__Status_String__Model, $author$project$Spa$Generated$Pages$Error__Status_String__Msg, $author$project$Pages$Error$Status_String$page),
	xF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Files__Public__Model, $author$project$Spa$Generated$Pages$Files__Public__Msg, $author$project$Pages$Files$Public$page),
	xG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Files__Top__Model, $author$project$Spa$Generated$Pages$Files__Top__Msg, $author$project$Pages$Files$Top$page),
	ao: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Forms__Model, $author$project$Spa$Generated$Pages$Forms__Msg, $author$project$Pages$Forms$page),
	xT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Model, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Msg, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$page),
	xU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Model, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Msg, $author$project$Pages$Hinter$AdminUsersGroups$Top$page),
	xV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Model, $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Msg, $author$project$Pages$Hinter$ClonePractice$page),
	xW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__Disputes__Model, $author$project$Spa$Generated$Pages$Hinter__Disputes__Msg, $author$project$Pages$Hinter$Disputes$page),
	xX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Model, $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Msg, $author$project$Pages$Hinter$FeatureFlags$page),
	xY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewGroup__Model, $author$project$Spa$Generated$Pages$Hinter__NewGroup__Msg, $author$project$Pages$Hinter$NewGroup$page),
	xZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewPartner__Model, $author$project$Spa$Generated$Pages$Hinter__NewPartner__Msg, $author$project$Pages$Hinter$NewPartner$page),
	x_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewPractice__Model, $author$project$Spa$Generated$Pages$Hinter__NewPractice__Msg, $author$project$Pages$Hinter$NewPractice$page),
	x$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Home__Model, $author$project$Spa$Generated$Pages$Home__Msg, $author$project$Pages$Home$page),
	yb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Model, $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Msg, $author$project$Pages$Inventory$InventoryId_String$Top$page),
	yc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__List__Model, $author$project$Spa$Generated$Pages$Inventory__List__Msg, $author$project$Pages$Inventory$List$page),
	yd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__New__Model, $author$project$Spa$Generated$Pages$Inventory__New__Msg, $author$project$Pages$Inventory$New$page),
	ye: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__Settings__Model, $author$project$Spa$Generated$Pages$Inventory__Settings__Msg, $author$project$Pages$Inventory$Settings$page),
	yp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Join__Token_String__Model, $author$project$Spa$Generated$Pages$Join__Token_String__Msg, $author$project$Pages$Join$Token_String$page),
	yD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Login__Model, $author$project$Spa$Generated$Pages$Login__Msg, $author$project$Pages$Login$page),
	yE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Logout__Model, $author$project$Spa$Generated$Pages$Logout__Msg, $author$project$Pages$Logout$page),
	yJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Layer__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Layer__Manage__Settings__Msg, $author$project$Pages$Marketplace$Layer$Manage$Settings$page),
	yK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Manage__Model, $author$project$Spa$Generated$Pages$Marketplace__Manage__Msg, $author$project$Pages$Marketplace$Manage$page),
	yL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Msg, $author$project$Pages$Marketplace$Slug_String$page),
	yM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$page),
	yN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$page),
	yO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Users$page),
	yP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Top__Model, $author$project$Spa$Generated$Pages$Marketplace__Top__Msg, $author$project$Pages$Marketplace$Top$page),
	yX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Calls__Model, $author$project$Spa$Generated$Pages$Messages__Calls__Msg, $author$project$Pages$Messages$Calls$page),
	yY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Drafts__Model, $author$project$Spa$Generated$Pages$Messages__Drafts__Msg, $author$project$Pages$Messages$Drafts$page),
	yZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Faxes__New__Model, $author$project$Spa$Generated$Pages$Messages__Faxes__New__Msg, $author$project$Pages$Messages$Faxes$New$page),
	y_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Model, $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Msg, $author$project$Pages$Messages$Faxes$Top$page),
	y$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Forms__Model, $author$project$Spa$Generated$Pages$Messages__Forms__Msg, $author$project$Pages$Messages$Forms$page),
	y0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Labs__Model, $author$project$Spa$Generated$Pages$Messages__Labs__Msg, $author$project$Pages$Messages$Labs$page),
	y1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Messages__Model, $author$project$Spa$Generated$Pages$Messages__Messages__Msg, $author$project$Pages$Messages$Messages$page),
	y2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Msg, $author$project$Pages$Messages$Scheduled$New$page),
	y3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Msg, $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$page),
	y4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Msg, $author$project$Pages$Messages$Scheduled$Top$page),
	y5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Sms__Model, $author$project$Spa$Generated$Pages$Messages__Sms__Msg, $author$project$Pages$Messages$Sms$page),
	zk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Msg, $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$page),
	zl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Msg, $author$project$Pages$NewSettings$AppointmentTypes$New$page),
	zm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Msg, $author$project$Pages$NewSettings$AppointmentTypes$Top$page),
	zn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Erx__Model, $author$project$Spa$Generated$Pages$NewSettings__Erx__Msg, $author$project$Pages$NewSettings$Erx$page),
	zo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Model, $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Msg, $author$project$Pages$NewSettings$HinterSettings$page),
	zp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Msg, $author$project$Pages$NewSettings$Locations$BookingLocationId_String$page),
	zq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Msg, $author$project$Pages$NewSettings$Locations$Top$page),
	zr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Model, $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Msg, $author$project$Pages$NewSettings$PracticeInfo$page),
	zs: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__Msg, $author$project$Pages$NewSettings$Team$page),
	zt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Msg, $author$project$Pages$NewSettings$Team$TeamId_String$page),
	zu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Msg, $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$page),
	zv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Msg, $author$project$Pages$NewSettings$Templates$New$page),
	zw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Msg, $author$project$Pages$NewSettings$Templates$TemplateId_String$page),
	zx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Msg, $author$project$Pages$NewSettings$Templates$Top$page),
	rA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NotFound__Model, $author$project$Spa$Generated$Pages$NotFound__Msg, $author$project$Pages$NotFound$page),
	zF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Oauth__Callback__Model, $author$project$Spa$Generated$Pages$Oauth__Callback__Msg, $author$project$Pages$Oauth$Callback$page),
	zS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Model, $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Msg, $author$project$Pages$Onboard$DealId_String$Top$page),
	zT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Msg, $author$project$Pages$Onboard$OnboardId_String$Completed$page),
	zU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Msg, $author$project$Pages$Onboard$OnboardId_String$Completing$page),
	zV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Msg, $author$project$Pages$Onboard$OnboardId_String$Payment$page),
	zW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Msg, $author$project$Pages$Onboard$OnboardId_String$User$page),
	zX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboarding__Model, $author$project$Spa$Generated$Pages$Onboarding__Msg, $author$project$Pages$Onboarding$page),
	z6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__ApiKeys__Model, $author$project$Spa$Generated$Pages$Partner__ApiKeys__Msg, $author$project$Pages$Partner$ApiKeys$page),
	z7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Msg, $author$project$Pages$Partner$Billing$page),
	z8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Msg, $author$project$Pages$Partner$Billing$Hinter$page),
	z9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Model, $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Msg, $author$project$Pages$Partner$Dashboard$Top$page),
	Aa: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Engagements__Model, $author$project$Spa$Generated$Pages$Partner__Engagements__Msg, $author$project$Pages$Partner$Engagements$page),
	Ab: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Hinter__Msg, $author$project$Pages$Partner$Hinter$page),
	Ac: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Practices__Top__Model, $author$project$Spa$Generated$Pages$Partner__Practices__Top__Msg, $author$project$Pages$Partner$Practices$Top$page),
	Ad: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__Model, $author$project$Spa$Generated$Pages$Partner__Product__Msg, $author$project$Pages$Partner$Product$page),
	Ae: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__ActivationSettings__Model, $author$project$Spa$Generated$Pages$Partner__Product__ActivationSettings__Msg, $author$project$Pages$Partner$Product$ActivationSettings$page),
	Af: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__AppSettings__Model, $author$project$Spa$Generated$Pages$Partner__Product__AppSettings__Msg, $author$project$Pages$Partner$Product$AppSettings$page),
	Ag: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Product__Hinter__Msg, $author$project$Pages$Partner$Product$Hinter$page),
	Ah: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__New__Model, $author$project$Spa$Generated$Pages$Partner__Product__New__Msg, $author$project$Pages$Partner$Product$New$page),
	Ai: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Model, $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Msg, $author$project$Pages$Partner$Sandboxes$Top$page),
	Aj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Team__Model, $author$project$Spa$Generated$Pages$Partner__Team__Msg, $author$project$Pages$Partner$Team$page),
	Ak: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__WebhookEndpoints__Model, $author$project$Spa$Generated$Pages$Partner__WebhookEndpoints__Msg, $author$project$Pages$Partner$WebhookEndpoints$page),
	Aq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Create__Model, $author$project$Spa$Generated$Pages$Patients__Create__Msg, $author$project$Pages$Patients$Create$page),
	Ar: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Msg, $author$project$Pages$Patients$PatientId_String$Accounts$Top$page),
	As: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Msg, $author$project$Pages$Patients$PatientId_String$Affiliation$Top$page),
	At: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$page),
	Au: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$page),
	Av: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Msg, $author$project$Pages$Patients$PatientId_String$Charges$Top$page),
	Aw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Msg, $author$project$Pages$Patients$PatientId_String$Chart$page),
	Ax: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Msg, $author$project$Pages$Patients$PatientId_String$Edit$page),
	Ay: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Msg, $author$project$Pages$Patients$PatientId_String$ManageCredits$page),
	Az: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$page),
	AA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$New$page),
	AB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$Top$page),
	AC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Msg, $author$project$Pages$Patients$PatientId_String$Merge$page),
	AD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Msg, $author$project$Pages$Patients$PatientId_String$Notes$Top$page),
	AE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Msg, $author$project$Pages$Patients$PatientId_String$Notifications$Top$page),
	AF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Top$page),
	AG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Top__Model, $author$project$Spa$Generated$Pages$Patients__Top__Msg, $author$project$Pages$Patients$Top$page),
	AH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Upload__Model, $author$project$Spa$Generated$Pages$Patients__Upload__Msg, $author$project$Pages$Patients$Upload$page),
	AX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Account__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Account__Msg, $author$project$Pages$PracticeSetup$Account$page),
	AY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Msg, $author$project$Pages$PracticeSetup$Communications$page),
	AZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Msg, $author$project$Pages$PracticeSetup$Complete$page),
	A_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Msg, $author$project$Pages$PracticeSetup$Documents$page),
	A$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Msg, $author$project$Pages$PracticeSetup$Legal$page),
	A0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Model, $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Msg, $author$project$Pages$PracticeSetup$PaymentProcessing$page),
	A1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Msg, $author$project$Pages$PracticeSetup$Plans$page),
	A2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Msg, $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$page),
	A3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Msg, $author$project$Pages$PracticeSetup$Plans$New$page),
	A4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Team__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Team__Msg, $author$project$Pages$PracticeSetup$Team$page),
	A5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Top__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Top__Msg, $author$project$Pages$PracticeSetup$Top$page),
	Bt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Model, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Msg, $author$project$Pages$Reports$AncillaryCharges$Id_String$page),
	Bu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Model, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Msg, $author$project$Pages$Reports$AncillaryCharges$Top$page),
	Bv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Model, $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Msg, $author$project$Pages$Reports$CompanyInvoices$page),
	Bw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Model, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Msg, $author$project$Pages$Reports$CreditOutstanding$page),
	Bx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Model, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Msg, $author$project$Pages$Reports$CreditOutstanding$Summary$page),
	By: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Model, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Msg, $author$project$Pages$Reports$CreditTransactions$page),
	Bz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Model, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Msg, $author$project$Pages$Reports$CreditTransactions$Summary$page),
	BA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Model, $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Msg, $author$project$Pages$Reports$Custom$Id_String$page),
	BB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Custom__New__Model, $author$project$Spa$Generated$Pages$Reports__Custom__New__Msg, $author$project$Pages$Reports$Custom$New$page),
	BC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Dashboard__Model, $author$project$Spa$Generated$Pages$Reports__Dashboard__Msg, $author$project$Pages$Reports$Dashboard$page),
	BD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Model, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Msg, $author$project$Pages$Reports$DeferredRevenue$page),
	BE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Model, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Msg, $author$project$Pages$Reports$DeferredRevenue$Summary$page),
	BF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Deposits__Model, $author$project$Spa$Generated$Pages$Reports__Deposits__Msg, $author$project$Pages$Reports$Deposits$page),
	BG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Disputes__Model, $author$project$Spa$Generated$Pages$Reports__Disputes__Msg, $author$project$Pages$Reports$Disputes$page),
	BH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Invoices__Model, $author$project$Spa$Generated$Pages$Reports__Invoices__Msg, $author$project$Pages$Reports$Invoices$page),
	BI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Memberships__Model, $author$project$Spa$Generated$Pages$Reports__Memberships__Msg, $author$project$Pages$Reports$Memberships$page),
	BJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Months__Model, $author$project$Spa$Generated$Pages$Reports__Months__Msg, $author$project$Pages$Reports$Months$page),
	BK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Model, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Msg, $author$project$Pages$Reports$PaymentApplications$page),
	BL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Model, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Msg, $author$project$Pages$Reports$PaymentApplications$Summary$page),
	BM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Revenue__Model, $author$project$Spa$Generated$Pages$Reports__Revenue__Msg, $author$project$Pages$Reports$Revenue$page),
	BN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Model, $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Msg, $author$project$Pages$Reports$Revenue$Summary$page),
	BO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SalesTax__Model, $author$project$Spa$Generated$Pages$Reports__SalesTax__Msg, $author$project$Pages$Reports$SalesTax$page),
	BP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Model, $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Msg, $author$project$Pages$Reports$SalesTax$Summary$page),
	BQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Model, $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Msg, $author$project$Pages$Reports$SignupAttempts$page),
	Cx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Model, $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Msg, $author$project$Pages$StyleGuide$ActivityIndicators$page),
	Cy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Msg, $author$project$Pages$StyleGuide$AddressInput$page),
	Cz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Alert__Model, $author$project$Spa$Generated$Pages$StyleGuide__Alert__Msg, $author$project$Pages$StyleGuide$Alert$page),
	CA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Badge__Model, $author$project$Spa$Generated$Pages$StyleGuide__Badge__Msg, $author$project$Pages$StyleGuide$Badge$page),
	CB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Button__Model, $author$project$Spa$Generated$Pages$StyleGuide__Button__Msg, $author$project$Pages$StyleGuide$Button$page),
	CC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Model, $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Msg, $author$project$Pages$StyleGuide$Carousel$page),
	CD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Model, $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Msg, $author$project$Pages$StyleGuide$Checkbox$page),
	CE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Msg, $author$project$Pages$StyleGuide$CurrencyInput$page),
	CF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Msg, $author$project$Pages$StyleGuide$DateInput$page),
	CG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Msg, $author$project$Pages$StyleGuide$DateRangeInput$page),
	CH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Model, $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Msg, $author$project$Pages$StyleGuide$Dropdown$page),
	CI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Model, $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Msg, $author$project$Pages$StyleGuide$ExportCsv$page),
	CJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Msg, $author$project$Pages$StyleGuide$FileInput$page),
	CK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FlexGrid__Model, $author$project$Spa$Generated$Pages$StyleGuide__FlexGrid__Msg, $author$project$Pages$StyleGuide$FlexGrid$page),
	CL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Model, $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Msg, $author$project$Pages$StyleGuide$FlyoutMenu$page),
	CM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Msg, $author$project$Pages$StyleGuide$FormExample$page),
	CN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Msg, $author$project$Pages$StyleGuide$FormGroup$page),
	CO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Msg, $author$project$Pages$StyleGuide$FormStatic$page),
	CP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Model, $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Msg, $author$project$Pages$StyleGuide$HiConfirm$page),
	CQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Model, $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Msg, $author$project$Pages$StyleGuide$HorizontalRule$page),
	CR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Icon__Model, $author$project$Spa$Generated$Pages$StyleGuide__Icon__Msg, $author$project$Pages$StyleGuide$Icon$page),
	CS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Input__Model, $author$project$Spa$Generated$Pages$StyleGuide__Input__Msg, $author$project$Pages$StyleGuide$Input$page),
	CT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Link__Model, $author$project$Spa$Generated$Pages$StyleGuide__Link__Msg, $author$project$Pages$StyleGuide$Link$page),
	CU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Model, $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Msg, $author$project$Pages$StyleGuide$ListGroup$page),
	CV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Modal__Model, $author$project$Spa$Generated$Pages$StyleGuide__Modal__Msg, $author$project$Pages$StyleGuide$Modal$page),
	CW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Model, $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Msg, $author$project$Pages$StyleGuide$Pagination$page),
	CX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Panel__Model, $author$project$Spa$Generated$Pages$StyleGuide__Panel__Msg, $author$project$Pages$StyleGuide$Panel$page),
	CY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Msg, $author$project$Pages$StyleGuide$PasswordInput$page),
	CZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Model, $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Msg, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$page),
	C_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Msg, $author$project$Pages$StyleGuide$PhoneInput$page),
	C$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Popover__Model, $author$project$Spa$Generated$Pages$StyleGuide__Popover__Msg, $author$project$Pages$StyleGuide$Popover$page),
	C0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Model, $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Msg, $author$project$Pages$StyleGuide$ProgressBar$page),
	C1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Model, $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Msg, $author$project$Pages$StyleGuide$ResourceFilter$page),
	C2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Msg, $author$project$Pages$StyleGuide$SearchInput$page),
	C3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__SearchableSelect__Model, $author$project$Spa$Generated$Pages$StyleGuide__SearchableSelect__Msg, $author$project$Pages$StyleGuide$SearchableSelect$page),
	C4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Select__Model, $author$project$Spa$Generated$Pages$StyleGuide__Select__Msg, $author$project$Pages$StyleGuide$Select$page),
	C5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Model, $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Msg, $author$project$Pages$StyleGuide$Skeleton$page),
	C6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__SvgIcon__Model, $author$project$Spa$Generated$Pages$StyleGuide__SvgIcon__Msg, $author$project$Pages$StyleGuide$SvgIcon$page),
	C7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Table__Model, $author$project$Spa$Generated$Pages$StyleGuide__Table__Msg, $author$project$Pages$StyleGuide$Table$page),
	C8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Tabs__Model, $author$project$Spa$Generated$Pages$StyleGuide__Tabs__Msg, $author$project$Pages$StyleGuide$Tabs$page),
	C9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Toast__Model, $author$project$Spa$Generated$Pages$StyleGuide__Toast__Msg, $author$project$Pages$StyleGuide$Toast$page),
	Da: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Model, $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Msg, $author$project$Pages$StyleGuide$ToggleSwitch$page),
	Db: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Model, $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Msg, $author$project$Pages$StyleGuide$Tooltip$page),
	Dc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Top__Model, $author$project$Spa$Generated$Pages$StyleGuide__Top__Msg, $author$project$Pages$StyleGuide$Top$page),
	Dd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Typography__Model, $author$project$Spa$Generated$Pages$StyleGuide__Typography__Msg, $author$project$Pages$StyleGuide$Typography$page),
	De: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Model, $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Msg, $author$project$Pages$StyleGuide$UploadForm$page),
	Df: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Model, $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Msg, $author$project$Pages$StyleGuide$UploadResult$page),
	Dg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Well__Model, $author$project$Spa$Generated$Pages$StyleGuide__Well__Msg, $author$project$Pages$StyleGuide$Well$page),
	Di: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Support__CannySso__Model, $author$project$Spa$Generated$Pages$Support__CannySso__Msg, $author$project$Pages$Support$CannySso$page),
	Dn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__New__Model, $author$project$Spa$Generated$Pages$Tasks__New__Msg, $author$project$Pages$Tasks$New$page),
	Do: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Model, $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Msg, $author$project$Pages$Tasks$TasksId_String$Top$page),
	Dp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__Top__Model, $author$project$Spa$Generated$Pages$Tasks__Top__Msg, $author$project$Pages$Tasks$Top$page),
	Dv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Top__Model, $author$project$Spa$Generated$Pages$Top__Msg, $author$project$Pages$Top$page),
	DG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__AcceptTerms__Model, $author$project$Spa$Generated$Pages$User__AcceptTerms__Msg, $author$project$Pages$User$AcceptTerms$page),
	DH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Mfa__Model, $author$project$Spa$Generated$Pages$User__Mfa__Msg, $author$project$Pages$User$Mfa$page),
	DI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Organizations__Top__Model, $author$project$Spa$Generated$Pages$User__Organizations__Top__Msg, $author$project$Pages$User$Organizations$Top$page),
	DJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Profile__Model, $author$project$Spa$Generated$Pages$User__Profile__Msg, $author$project$Pages$User$Profile$page),
	DK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Security__Model, $author$project$Spa$Generated$Pages$User__Security__Msg, $author$project$Pages$User$Security$page)
};
var $author$project$Spa$Generated$Pages$init = function (route) {
	switch (route.$) {
		case 0:
			return $author$project$Spa$Generated$Pages$pages.Dv.ad0(0);
		case 1:
			return $author$project$Spa$Generated$Pages$pages.tE.ad0(0);
		case 2:
			return $author$project$Spa$Generated$Pages$pages.vH.ad0(0);
		case 3:
			return $author$project$Spa$Generated$Pages$pages.vP.ad0(0);
		case 4:
			return $author$project$Spa$Generated$Pages$pages.ao.ad0(0);
		case 5:
			return $author$project$Spa$Generated$Pages$pages.x$.ad0(0);
		case 6:
			return $author$project$Spa$Generated$Pages$pages.yD.ad0(0);
		case 7:
			return $author$project$Spa$Generated$Pages$pages.yE.ad0(0);
		case 8:
			return $author$project$Spa$Generated$Pages$pages.rA.ad0(0);
		case 9:
			return $author$project$Spa$Generated$Pages$pages.zX.ad0(0);
		case 10:
			return $author$project$Spa$Generated$Pages$pages.u6.ad0(0);
		case 11:
			return $author$project$Spa$Generated$Pages$pages.vi.ad0(0);
		case 12:
			return $author$project$Spa$Generated$Pages$pages.wG.ad0(0);
		case 13:
			return $author$project$Spa$Generated$Pages$pages.xG.ad0(0);
		case 14:
			return $author$project$Spa$Generated$Pages$pages.yP.ad0(0);
		case 15:
			return $author$project$Spa$Generated$Pages$pages.AG.ad0(0);
		case 16:
			return $author$project$Spa$Generated$Pages$pages.A5.ad0(0);
		case 17:
			return $author$project$Spa$Generated$Pages$pages.Dc.ad0(0);
		case 18:
			return $author$project$Spa$Generated$Pages$pages.Dp.ad0(0);
		case 19:
			return $author$project$Spa$Generated$Pages$pages.tN.ad0(0);
		case 20:
			return $author$project$Spa$Generated$Pages$pages.tU.ad0(0);
		case 21:
			return $author$project$Spa$Generated$Pages$pages.tW.ad0(0);
		case 22:
			return $author$project$Spa$Generated$Pages$pages.tX.ad0(0);
		case 23:
			return $author$project$Spa$Generated$Pages$pages.tY.ad0(0);
		case 24:
			return $author$project$Spa$Generated$Pages$pages.t1.ad0(0);
		case 25:
			return $author$project$Spa$Generated$Pages$pages.t5.ad0(0);
		case 26:
			return $author$project$Spa$Generated$Pages$pages.t9.ad0(0);
		case 27:
			return $author$project$Spa$Generated$Pages$pages.un.ad0(0);
		case 28:
			return $author$project$Spa$Generated$Pages$pages.us.ad0(0);
		case 29:
			return $author$project$Spa$Generated$Pages$pages.ut.ad0(0);
		case 30:
			return $author$project$Spa$Generated$Pages$pages.uv.ad0(0);
		case 31:
			return $author$project$Spa$Generated$Pages$pages.uw.ad0(0);
		case 32:
			return $author$project$Spa$Generated$Pages$pages.ux.ad0(0);
		case 33:
			return $author$project$Spa$Generated$Pages$pages.uy.ad0(0);
		case 34:
			return $author$project$Spa$Generated$Pages$pages.uz.ad0(0);
		case 35:
			return $author$project$Spa$Generated$Pages$pages.uA.ad0(0);
		case 36:
			return $author$project$Spa$Generated$Pages$pages.uI.ad0(0);
		case 37:
			return $author$project$Spa$Generated$Pages$pages.uJ.ad0(0);
		case 38:
			return $author$project$Spa$Generated$Pages$pages.uL.ad0(0);
		case 39:
			return $author$project$Spa$Generated$Pages$pages.uM.ad0(0);
		case 40:
			return $author$project$Spa$Generated$Pages$pages.uS.ad0(0);
		case 41:
			return $author$project$Spa$Generated$Pages$pages.uT.ad0(0);
		case 42:
			return $author$project$Spa$Generated$Pages$pages.uX.ad0(0);
		case 43:
			return $author$project$Spa$Generated$Pages$pages.uY.ad0(0);
		case 44:
			return $author$project$Spa$Generated$Pages$pages.uZ.ad0(0);
		case 45:
			return $author$project$Spa$Generated$Pages$pages.u1.ad0(0);
		case 46:
			return $author$project$Spa$Generated$Pages$pages.u2.ad0(0);
		case 47:
			return $author$project$Spa$Generated$Pages$pages.u3.ad0(0);
		case 48:
			return $author$project$Spa$Generated$Pages$pages.vg.ad0(0);
		case 49:
			return $author$project$Spa$Generated$Pages$pages.vh.ad0(0);
		case 50:
			return $author$project$Spa$Generated$Pages$pages.v0.ad0(0);
		case 51:
			return $author$project$Spa$Generated$Pages$pages.wl.ad0(0);
		case 52:
			return $author$project$Spa$Generated$Pages$pages.wF.ad0(0);
		case 53:
			return $author$project$Spa$Generated$Pages$pages.wJ.ad0(0);
		case 54:
			return $author$project$Spa$Generated$Pages$pages.wK.ad0(0);
		case 55:
			return $author$project$Spa$Generated$Pages$pages.xF.ad0(0);
		case 56:
			return $author$project$Spa$Generated$Pages$pages.xV.ad0(0);
		case 57:
			return $author$project$Spa$Generated$Pages$pages.xW.ad0(0);
		case 58:
			return $author$project$Spa$Generated$Pages$pages.xX.ad0(0);
		case 59:
			return $author$project$Spa$Generated$Pages$pages.xY.ad0(0);
		case 60:
			return $author$project$Spa$Generated$Pages$pages.xZ.ad0(0);
		case 61:
			return $author$project$Spa$Generated$Pages$pages.x_.ad0(0);
		case 62:
			return $author$project$Spa$Generated$Pages$pages.yc.ad0(0);
		case 63:
			return $author$project$Spa$Generated$Pages$pages.yd.ad0(0);
		case 64:
			return $author$project$Spa$Generated$Pages$pages.ye.ad0(0);
		case 65:
			return $author$project$Spa$Generated$Pages$pages.yK.ad0(0);
		case 66:
			return $author$project$Spa$Generated$Pages$pages.yX.ad0(0);
		case 67:
			return $author$project$Spa$Generated$Pages$pages.yY.ad0(0);
		case 68:
			return $author$project$Spa$Generated$Pages$pages.y$.ad0(0);
		case 69:
			return $author$project$Spa$Generated$Pages$pages.y0.ad0(0);
		case 70:
			return $author$project$Spa$Generated$Pages$pages.y1.ad0(0);
		case 71:
			return $author$project$Spa$Generated$Pages$pages.y5.ad0(0);
		case 72:
			return $author$project$Spa$Generated$Pages$pages.zn.ad0(0);
		case 73:
			return $author$project$Spa$Generated$Pages$pages.zo.ad0(0);
		case 74:
			return $author$project$Spa$Generated$Pages$pages.zr.ad0(0);
		case 75:
			return $author$project$Spa$Generated$Pages$pages.zs.ad0(0);
		case 76:
			return $author$project$Spa$Generated$Pages$pages.zF.ad0(0);
		case 77:
			return $author$project$Spa$Generated$Pages$pages.z6.ad0(0);
		case 78:
			return $author$project$Spa$Generated$Pages$pages.z7.ad0(0);
		case 79:
			return $author$project$Spa$Generated$Pages$pages.Aa.ad0(0);
		case 80:
			return $author$project$Spa$Generated$Pages$pages.Ab.ad0(0);
		case 81:
			return $author$project$Spa$Generated$Pages$pages.Ad.ad0(0);
		case 82:
			return $author$project$Spa$Generated$Pages$pages.Aj.ad0(0);
		case 83:
			return $author$project$Spa$Generated$Pages$pages.Ak.ad0(0);
		case 84:
			return $author$project$Spa$Generated$Pages$pages.Aq.ad0(0);
		case 85:
			return $author$project$Spa$Generated$Pages$pages.AH.ad0(0);
		case 86:
			return $author$project$Spa$Generated$Pages$pages.AX.ad0(0);
		case 87:
			return $author$project$Spa$Generated$Pages$pages.AY.ad0(0);
		case 88:
			return $author$project$Spa$Generated$Pages$pages.AZ.ad0(0);
		case 89:
			return $author$project$Spa$Generated$Pages$pages.A_.ad0(0);
		case 90:
			return $author$project$Spa$Generated$Pages$pages.A$.ad0(0);
		case 91:
			return $author$project$Spa$Generated$Pages$pages.A0.ad0(0);
		case 92:
			return $author$project$Spa$Generated$Pages$pages.A1.ad0(0);
		case 93:
			return $author$project$Spa$Generated$Pages$pages.A4.ad0(0);
		case 94:
			return $author$project$Spa$Generated$Pages$pages.Bv.ad0(0);
		case 95:
			return $author$project$Spa$Generated$Pages$pages.Bw.ad0(0);
		case 96:
			return $author$project$Spa$Generated$Pages$pages.By.ad0(0);
		case 97:
			return $author$project$Spa$Generated$Pages$pages.BC.ad0(0);
		case 98:
			return $author$project$Spa$Generated$Pages$pages.BD.ad0(0);
		case 99:
			return $author$project$Spa$Generated$Pages$pages.BF.ad0(0);
		case 100:
			return $author$project$Spa$Generated$Pages$pages.BG.ad0(0);
		case 101:
			return $author$project$Spa$Generated$Pages$pages.BH.ad0(0);
		case 102:
			return $author$project$Spa$Generated$Pages$pages.BI.ad0(0);
		case 103:
			return $author$project$Spa$Generated$Pages$pages.BJ.ad0(0);
		case 104:
			return $author$project$Spa$Generated$Pages$pages.BK.ad0(0);
		case 105:
			return $author$project$Spa$Generated$Pages$pages.BM.ad0(0);
		case 106:
			return $author$project$Spa$Generated$Pages$pages.BO.ad0(0);
		case 107:
			return $author$project$Spa$Generated$Pages$pages.BQ.ad0(0);
		case 108:
			return $author$project$Spa$Generated$Pages$pages.Cx.ad0(0);
		case 109:
			return $author$project$Spa$Generated$Pages$pages.Cy.ad0(0);
		case 110:
			return $author$project$Spa$Generated$Pages$pages.Cz.ad0(0);
		case 111:
			return $author$project$Spa$Generated$Pages$pages.CA.ad0(0);
		case 112:
			return $author$project$Spa$Generated$Pages$pages.CB.ad0(0);
		case 113:
			return $author$project$Spa$Generated$Pages$pages.CC.ad0(0);
		case 114:
			return $author$project$Spa$Generated$Pages$pages.CD.ad0(0);
		case 115:
			return $author$project$Spa$Generated$Pages$pages.CE.ad0(0);
		case 116:
			return $author$project$Spa$Generated$Pages$pages.CF.ad0(0);
		case 117:
			return $author$project$Spa$Generated$Pages$pages.CG.ad0(0);
		case 118:
			return $author$project$Spa$Generated$Pages$pages.CH.ad0(0);
		case 119:
			return $author$project$Spa$Generated$Pages$pages.CI.ad0(0);
		case 120:
			return $author$project$Spa$Generated$Pages$pages.CJ.ad0(0);
		case 121:
			return $author$project$Spa$Generated$Pages$pages.CK.ad0(0);
		case 122:
			return $author$project$Spa$Generated$Pages$pages.CL.ad0(0);
		case 123:
			return $author$project$Spa$Generated$Pages$pages.CM.ad0(0);
		case 124:
			return $author$project$Spa$Generated$Pages$pages.CN.ad0(0);
		case 125:
			return $author$project$Spa$Generated$Pages$pages.CO.ad0(0);
		case 126:
			return $author$project$Spa$Generated$Pages$pages.CP.ad0(0);
		case 127:
			return $author$project$Spa$Generated$Pages$pages.CQ.ad0(0);
		case 128:
			return $author$project$Spa$Generated$Pages$pages.CR.ad0(0);
		case 129:
			return $author$project$Spa$Generated$Pages$pages.CS.ad0(0);
		case 130:
			return $author$project$Spa$Generated$Pages$pages.CT.ad0(0);
		case 131:
			return $author$project$Spa$Generated$Pages$pages.CU.ad0(0);
		case 132:
			return $author$project$Spa$Generated$Pages$pages.CV.ad0(0);
		case 133:
			return $author$project$Spa$Generated$Pages$pages.CW.ad0(0);
		case 134:
			return $author$project$Spa$Generated$Pages$pages.CX.ad0(0);
		case 135:
			return $author$project$Spa$Generated$Pages$pages.CY.ad0(0);
		case 136:
			return $author$project$Spa$Generated$Pages$pages.CZ.ad0(0);
		case 137:
			return $author$project$Spa$Generated$Pages$pages.C_.ad0(0);
		case 138:
			return $author$project$Spa$Generated$Pages$pages.C$.ad0(0);
		case 139:
			return $author$project$Spa$Generated$Pages$pages.C0.ad0(0);
		case 140:
			return $author$project$Spa$Generated$Pages$pages.C1.ad0(0);
		case 141:
			return $author$project$Spa$Generated$Pages$pages.C2.ad0(0);
		case 142:
			return $author$project$Spa$Generated$Pages$pages.C3.ad0(0);
		case 143:
			return $author$project$Spa$Generated$Pages$pages.C4.ad0(0);
		case 144:
			return $author$project$Spa$Generated$Pages$pages.C5.ad0(0);
		case 145:
			return $author$project$Spa$Generated$Pages$pages.C6.ad0(0);
		case 146:
			return $author$project$Spa$Generated$Pages$pages.C7.ad0(0);
		case 147:
			return $author$project$Spa$Generated$Pages$pages.C8.ad0(0);
		case 148:
			return $author$project$Spa$Generated$Pages$pages.C9.ad0(0);
		case 149:
			return $author$project$Spa$Generated$Pages$pages.Da.ad0(0);
		case 150:
			return $author$project$Spa$Generated$Pages$pages.Db.ad0(0);
		case 151:
			return $author$project$Spa$Generated$Pages$pages.Dd.ad0(0);
		case 152:
			return $author$project$Spa$Generated$Pages$pages.De.ad0(0);
		case 153:
			return $author$project$Spa$Generated$Pages$pages.Df.ad0(0);
		case 154:
			return $author$project$Spa$Generated$Pages$pages.Dg.ad0(0);
		case 155:
			return $author$project$Spa$Generated$Pages$pages.Di.ad0(0);
		case 156:
			return $author$project$Spa$Generated$Pages$pages.Dn.ad0(0);
		case 157:
			return $author$project$Spa$Generated$Pages$pages.DG.ad0(0);
		case 158:
			return $author$project$Spa$Generated$Pages$pages.DH.ad0(0);
		case 159:
			return $author$project$Spa$Generated$Pages$pages.DJ.ad0(0);
		case 160:
			return $author$project$Spa$Generated$Pages$pages.DK.ad0(0);
		case 161:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.vr.ad0(params);
		case 162:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.xt.ad0(params);
		case 163:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yp.ad0(params);
		case 164:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yL.ad0(params);
		case 165:
			return $author$project$Spa$Generated$Pages$pages.tT.ad0(0);
		case 166:
			return $author$project$Spa$Generated$Pages$pages.t$.ad0(0);
		case 167:
			return $author$project$Spa$Generated$Pages$pages.t4.ad0(0);
		case 168:
			return $author$project$Spa$Generated$Pages$pages.t8.ad0(0);
		case 169:
			return $author$project$Spa$Generated$Pages$pages.uf.ad0(0);
		case 170:
			return $author$project$Spa$Generated$Pages$pages.ud.ad0(0);
		case 171:
			return $author$project$Spa$Generated$Pages$pages.um.ad0(0);
		case 172:
			return $author$project$Spa$Generated$Pages$pages.ur.ad0(0);
		case 173:
			return $author$project$Spa$Generated$Pages$pages.uR.ad0(0);
		case 174:
			return $author$project$Spa$Generated$Pages$pages.uU.ad0(0);
		case 175:
			return $author$project$Spa$Generated$Pages$pages.uW.ad0(0);
		case 176:
			return $author$project$Spa$Generated$Pages$pages.u0.ad0(0);
		case 177:
			return $author$project$Spa$Generated$Pages$pages.wi.ad0(0);
		case 178:
			return $author$project$Spa$Generated$Pages$pages.wk.ad0(0);
		case 179:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wB.ad0(params);
		case 180:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wI.ad0(params);
		case 181:
			return $author$project$Spa$Generated$Pages$pages.xU.ad0(0);
		case 182:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yb.ad0(params);
		case 183:
			return $author$project$Spa$Generated$Pages$pages.y_.ad0(0);
		case 184:
			return $author$project$Spa$Generated$Pages$pages.y4.ad0(0);
		case 185:
			return $author$project$Spa$Generated$Pages$pages.zm.ad0(0);
		case 186:
			return $author$project$Spa$Generated$Pages$pages.zq.ad0(0);
		case 187:
			return $author$project$Spa$Generated$Pages$pages.zx.ad0(0);
		case 188:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zS.ad0(params);
		case 189:
			return $author$project$Spa$Generated$Pages$pages.z9.ad0(0);
		case 190:
			return $author$project$Spa$Generated$Pages$pages.Ac.ad0(0);
		case 191:
			return $author$project$Spa$Generated$Pages$pages.Ai.ad0(0);
		case 192:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AF.ad0(params);
		case 193:
			return $author$project$Spa$Generated$Pages$pages.Bu.ad0(0);
		case 194:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Do.ad0(params);
		case 195:
			return $author$project$Spa$Generated$Pages$pages.DI.ad0(0);
		case 196:
			return $author$project$Spa$Generated$Pages$pages.tO.ad0(0);
		case 197:
			return $author$project$Spa$Generated$Pages$pages.tP.ad0(0);
		case 198:
			return $author$project$Spa$Generated$Pages$pages.tQ.ad0(0);
		case 199:
			return $author$project$Spa$Generated$Pages$pages.tR.ad0(0);
		case 200:
			return $author$project$Spa$Generated$Pages$pages.tS.ad0(0);
		case 201:
			return $author$project$Spa$Generated$Pages$pages.t_.ad0(0);
		case 202:
			return $author$project$Spa$Generated$Pages$pages.t0.ad0(0);
		case 203:
			return $author$project$Spa$Generated$Pages$pages.t3.ad0(0);
		case 204:
			return $author$project$Spa$Generated$Pages$pages.t7.ad0(0);
		case 205:
			return $author$project$Spa$Generated$Pages$pages.ua.ad0(0);
		case 206:
			return $author$project$Spa$Generated$Pages$pages.uc.ad0(0);
		case 207:
			return $author$project$Spa$Generated$Pages$pages.ug.ad0(0);
		case 208:
			return $author$project$Spa$Generated$Pages$pages.uh.ad0(0);
		case 209:
			return $author$project$Spa$Generated$Pages$pages.ui.ad0(0);
		case 210:
			return $author$project$Spa$Generated$Pages$pages.uj.ad0(0);
		case 211:
			return $author$project$Spa$Generated$Pages$pages.ul.ad0(0);
		case 212:
			return $author$project$Spa$Generated$Pages$pages.uo.ad0(0);
		case 213:
			return $author$project$Spa$Generated$Pages$pages.up.ad0(0);
		case 214:
			return $author$project$Spa$Generated$Pages$pages.uq.ad0(0);
		case 215:
			return $author$project$Spa$Generated$Pages$pages.uB.ad0(0);
		case 216:
			return $author$project$Spa$Generated$Pages$pages.uC.ad0(0);
		case 217:
			return $author$project$Spa$Generated$Pages$pages.uD.ad0(0);
		case 218:
			return $author$project$Spa$Generated$Pages$pages.uE.ad0(0);
		case 219:
			return $author$project$Spa$Generated$Pages$pages.uG.ad0(0);
		case 220:
			return $author$project$Spa$Generated$Pages$pages.uH.ad0(0);
		case 221:
			return $author$project$Spa$Generated$Pages$pages.uK.ad0(0);
		case 222:
			return $author$project$Spa$Generated$Pages$pages.uQ.ad0(0);
		case 223:
			return $author$project$Spa$Generated$Pages$pages.uV.ad0(0);
		case 224:
			return $author$project$Spa$Generated$Pages$pages.u$.ad0(0);
		case 225:
			return $author$project$Spa$Generated$Pages$pages.u4.ad0(0);
		case 226:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.u8.ad0(params);
		case 227:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.vb.ad0(params);
		case 228:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.vc.ad0(params);
		case 229:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.vd.ad0(params);
		case 230:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.ve.ad0(params);
		case 231:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.vf.ad0(params);
		case 232:
			return $author$project$Spa$Generated$Pages$pages.wh.ad0(0);
		case 233:
			return $author$project$Spa$Generated$Pages$pages.wj.ad0(0);
		case 234:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wm.ad0(params);
		case 235:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wn.ad0(params);
		case 236:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wr.ad0(params);
		case 237:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.ws.ad0(params);
		case 238:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wv.ad0(params);
		case 239:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.ww.ad0(params);
		case 240:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wx.ad0(params);
		case 241:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wy.ad0(params);
		case 242:
			return $author$project$Spa$Generated$Pages$pages.yZ.ad0(0);
		case 243:
			return $author$project$Spa$Generated$Pages$pages.y2.ad0(0);
		case 244:
			return $author$project$Spa$Generated$Pages$pages.zl.ad0(0);
		case 245:
			return $author$project$Spa$Generated$Pages$pages.zv.ad0(0);
		case 246:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zT.ad0(params);
		case 247:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zU.ad0(params);
		case 248:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zV.ad0(params);
		case 249:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zW.ad0(params);
		case 250:
			return $author$project$Spa$Generated$Pages$pages.z8.ad0(0);
		case 251:
			return $author$project$Spa$Generated$Pages$pages.Ae.ad0(0);
		case 252:
			return $author$project$Spa$Generated$Pages$pages.Af.ad0(0);
		case 253:
			return $author$project$Spa$Generated$Pages$pages.Ag.ad0(0);
		case 254:
			return $author$project$Spa$Generated$Pages$pages.Ah.ad0(0);
		case 255:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Aw.ad0(params);
		case 256:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Ax.ad0(params);
		case 257:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Ay.ad0(params);
		case 258:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AC.ad0(params);
		case 259:
			return $author$project$Spa$Generated$Pages$pages.A3.ad0(0);
		case 260:
			return $author$project$Spa$Generated$Pages$pages.Bx.ad0(0);
		case 261:
			return $author$project$Spa$Generated$Pages$pages.Bz.ad0(0);
		case 262:
			return $author$project$Spa$Generated$Pages$pages.BB.ad0(0);
		case 263:
			return $author$project$Spa$Generated$Pages$pages.BE.ad0(0);
		case 264:
			return $author$project$Spa$Generated$Pages$pages.BL.ad0(0);
		case 265:
			return $author$project$Spa$Generated$Pages$pages.BN.ad0(0);
		case 266:
			return $author$project$Spa$Generated$Pages$pages.BP.ad0(0);
		case 267:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.tZ.ad0(params);
		case 268:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.t2.ad0(params);
		case 269:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.t6.ad0(params);
		case 270:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.ue.ad0(params);
		case 271:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.ub.ad0(params);
		case 272:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.uk.ad0(params);
		case 273:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.uu.ad0(params);
		case 274:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.uN.ad0(params);
		case 275:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.u_.ad0(params);
		case 276:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.xT.ad0(params);
		case 277:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zk.ad0(params);
		case 278:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zp.ad0(params);
		case 279:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zt.ad0(params);
		case 280:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zw.ad0(params);
		case 281:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Bt.ad0(params);
		case 282:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.BA.ad0(params);
		case 283:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.va.ad0(params);
		case 284:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wg.ad0(params);
		case 285:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wq.ad0(params);
		case 286:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wu.ad0(params);
		case 287:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wC.ad0(params);
		case 288:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.y3.ad0(params);
		case 289:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Ar.ad0(params);
		case 290:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.As.ad0(params);
		case 291:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Av.ad0(params);
		case 292:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AB.ad0(params);
		case 293:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AD.ad0(params);
		case 294:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AE.ad0(params);
		case 295:
			return $author$project$Spa$Generated$Pages$pages.uF.ad0(0);
		case 296:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wc.ad0(params);
		case 297:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wd.ad0(params);
		case 298:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wo.ad0(params);
		case 299:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wA.ad0(params);
		case 300:
			return $author$project$Spa$Generated$Pages$pages.yJ.ad0(0);
		case 301:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yM.ad0(params);
		case 302:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yN.ad0(params);
		case 303:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.yO.ad0(params);
		case 304:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.zu.ad0(params);
		case 305:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.AA.ad0(params);
		case 306:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.A2.ad0(params);
		case 307:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.tV.ad0(params);
		case 308:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.u9.ad0(params);
		case 309:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wt.ad0(params);
		case 310:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wz.ad0(params);
		case 311:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wb.ad0(params);
		case 312:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wf.ad0(params);
		case 313:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wD.ad0(params);
		case 314:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.At.ad0(params);
		case 315:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Au.ad0(params);
		case 316:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.Az.ad0(params);
		case 317:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.uO.ad0(params);
		case 318:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.v9.ad0(params);
		case 319:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wa.ad0(params);
		case 320:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wE.ad0(params);
		case 321:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.uP.ad0(params);
		case 322:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.we.ad0(params);
		case 323:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.v8.ad0(params);
		default:
			var params = route.a;
			return $author$project$Spa$Generated$Pages$pages.wp.ad0(params);
	}
};
var $author$project$Spa$Layout$AdminModel = function (a) {
	return {$: 13, a: a};
};
var $author$project$Spa$Layout$AdminMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Layout$AffiliatesAffiliateModel = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Spa$Layout$AffiliatesAffiliateMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Spa$Layout$AffiliatesModel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Spa$Layout$AffiliatesMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Layout$ApplicationModel = {$: 1};
var $author$project$Spa$Layout$BlankModel = {$: 14};
var $author$project$Spa$Layout$ClinicalModel = {$: 15};
var $author$project$Spa$Layout$CommissionsBrokerAccountModel = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Spa$Layout$CommissionsBrokerAccountMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Spa$Layout$CommissionsModel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Spa$Layout$CommissionsMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Layout$CompanyModel = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Spa$Layout$CompanyMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Spa$Layout$MarketplaceManageModel = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Spa$Layout$MarketplaceManageMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Spa$Layout$OnboardModel = {$: 17};
var $author$project$Spa$Layout$PartnerBillingModel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Spa$Layout$PartnerBillingMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Spa$Layout$PartnerPracticesModel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Spa$Layout$PartnerPracticesMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Spa$Layout$PartnerProductModel = function (a) {
	return {$: 10, a: a};
};
var $author$project$Spa$Layout$PartnerProductMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Spa$Layout$PatientAndSidebarModel = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Spa$Layout$PatientChartModel = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Spa$Layout$PatientMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Spa$Layout$PatientsSidebarModel = {$: 2};
var $author$project$Spa$Layout$PracticeSetupModel = {$: 19};
var $author$project$Spa$Layout$StyleGuideModel = {$: 0};
var $author$project$Spa$Layout$UserModel = function (a) {
	return {$: 18, a: a};
};
var $author$project$Spa$Layout$UserMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Layouts$Admin$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Admin$init = function (_v0) {
	var _v1 = A2($author$project$Ui$Nav$init, 'admin-nav', $elm$core$Basics$identity);
	var nav = _v1.a;
	var navCmd = _v1.b;
	return _Utils_Tuple2(
		{m8: nav},
		navCmd);
};
var $author$project$Layouts$Affiliates$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Affiliates$init = A2(
	$elm$core$Tuple$mapFirst,
	function (nav) {
		return {m8: nav};
	},
	A2($author$project$Ui$Nav$init, 'affiliates-nav', $elm$core$Basics$identity));
var $author$project$Layouts$Affiliates$Affiliate$GotAffiliate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Affiliates$Affiliate$NavMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Layouts$Affiliates$Affiliate$init = F2(
	function (_v0, affiliateId) {
		var apiClient = _v0.D5;
		var _v1 = A2($author$project$Ui$Nav$init, 'affiliate-nav', $author$project$Layouts$Affiliates$Affiliate$NavMsg);
		var nav = _v1.a;
		var navCmd = _v1.b;
		return _Utils_Tuple2(
			{DZ: $author$project$Api$Data$Loading, pp: affiliateId, m8: nav},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$Affiliate$retrieve, apiClient, affiliateId, $author$project$Layouts$Affiliates$Affiliate$GotAffiliate),
						navCmd
					])));
	});
var $author$project$Layouts$Commissions$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Commissions$init = A2(
	$elm$core$Tuple$mapFirst,
	function (nav) {
		return {m8: nav};
	},
	A2($author$project$Ui$Nav$init, 'commissions-nav', $elm$core$Basics$identity));
var $author$project$Layouts$Commissions$BrokerAccount$GotBrokerAccount = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Commissions$BrokerAccount$NavMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Layouts$Commissions$BrokerAccount$init = F2(
	function (_v0, brokerAccountId) {
		var apiClient = _v0.D5;
		var _v1 = A2($author$project$Ui$Nav$init, 'broker-account-nav', $author$project$Layouts$Commissions$BrokerAccount$NavMsg);
		var nav = _v1.a;
		var navCmd = _v1.b;
		return _Utils_Tuple2(
			{vK: $author$project$Api$Data$Loading, bP: brokerAccountId, m8: nav},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Provider$BrokerAccount$retrieve, apiClient, brokerAccountId, $author$project$Layouts$Commissions$BrokerAccount$GotBrokerAccount),
						navCmd
					])));
	});
var $author$project$Layouts$Company$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Company$init = A2(
	$elm$core$Tuple$mapFirst,
	function (nav) {
		return {m8: nav};
	},
	A2($author$project$Ui$Nav$init, 'company-nav', $elm$core$Basics$identity));
var $author$project$Layouts$Marketplace$Manage$GotIntegration = function (a) {
	return {$: 1, a: a};
};
var $author$project$Layouts$Marketplace$Manage$NavMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Marketplace$Manage$init = F2(
	function (apiClient, slug) {
		var _v0 = A2($author$project$Ui$Nav$init, 'marketplace-manage-nav', $author$project$Layouts$Marketplace$Manage$NavMsg);
		var nav = _v0.a;
		var navCmd = _v0.b;
		return _Utils_Tuple2(
			{Q4: $author$project$Api$Data$Loading, m8: nav, _c: slug},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						navCmd,
						A3($author$project$Api$Provider$Integration$retrieve, apiClient, slug, $author$project$Layouts$Marketplace$Manage$GotIntegration)
					])));
	});
var $author$project$Layouts$Partner$Billing$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Partner$Billing$init = function () {
	var _v0 = A2($author$project$Ui$Nav$init, 'partner-billing-nav', $elm$core$Basics$identity);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		{m8: nav},
		navCmd);
}();
var $author$project$Layouts$Partner$Practices$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Partner$Practices$init = function () {
	var _v0 = A2($author$project$Ui$Nav$init, 'partner-practices-nav', $elm$core$Basics$identity);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		{m8: nav},
		navCmd);
}();
var $author$project$Layouts$Partner$Product$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$Partner$Product$init = function (partner) {
	var _v0 = A2($author$project$Ui$Nav$init, 'partner-product-nav', $elm$core$Basics$identity);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		{m8: nav, Vz: partner},
		navCmd);
};
var $author$project$Layouts$Patient$NavMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Layouts$Patient$init = F2(
	function (_v0, patientId) {
		var session = _v0.ZD;
		var hinterViewOff = _v0.adN;
		var currentPatient = _v0.Mw;
		var _v1 = A2($author$project$Ui$Nav$init, 'patient-nav', $author$project$Layouts$Patient$NavMsg);
		var nav = _v1.a;
		var navCmd = _v1.b;
		return _Utils_Tuple2(
			{ht: $author$project$Api$Data$NotAsked, adN: hinterViewOff, m8: nav, jf: $author$project$Api$Data$NotAsked, VM: currentPatient, VN: patientId, ZD: session},
			navCmd);
	});
var $author$project$Layouts$PatientChart$init = F2(
	function (_v0, patientId) {
		var currentPatient = _v0.Mw;
		return _Utils_Tuple2(
			{VM: currentPatient, VN: patientId},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Layouts$User$NavMsg = $elm$core$Basics$identity;
var $author$project$Layouts$User$init = A2(
	$elm$core$Tuple$mapFirst,
	function (nav) {
		return {m8: nav};
	},
	A2($author$project$Ui$Nav$init, 'user-nav', $elm$core$Basics$identity));
var $author$project$Spa$Layout$Admin = {$: 13};
var $author$project$Spa$Layout$Affiliates = {$: 6};
var $author$project$Spa$Layout$AffiliatesAffiliate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Spa$Layout$Application = {$: 1};
var $author$project$Spa$Layout$Clinical = {$: 17};
var $author$project$Spa$Layout$Commissions = {$: 4};
var $author$project$Spa$Layout$CommissionsBrokerAccount = function (a) {
	return {$: 5, a: a};
};
var $author$project$Spa$Layout$Company = function (a) {
	return {$: 12, a: a};
};
var $author$project$Spa$Layout$MarketplaceManage = function (a) {
	return {$: 11, a: a};
};
var $author$project$Spa$Layout$Onboard = {$: 14};
var $author$project$Spa$Layout$PartnerBilling = {$: 8};
var $author$project$Spa$Layout$PartnerPractices = {$: 9};
var $author$project$Spa$Layout$PartnerProduct = {$: 10};
var $author$project$Spa$Layout$PatientAndSidebar = function (a) {
	return {$: 3, a: a};
};
var $author$project$Spa$Layout$PatientChart = function (a) {
	return {$: 18, a: a};
};
var $author$project$Spa$Layout$PatientsSidebar = {$: 2};
var $author$project$Spa$Layout$PracticeSetup = {$: 15};
var $author$project$Spa$Layout$StyleGuide = {$: 0};
var $author$project$Spa$Layout$User = {$: 16};
var $author$project$Spa$Layout$routeToLayout = function (route) {
	var idRegex = $elm$regex$Regex$fromString('[a-z]+-[a-zA-Z0-9]+');
	var idMatch = function (possibleId) {
		return A2(
			$elm$core$Maybe$andThen,
			function (regex) {
				return A2($elm$regex$Regex$contains, regex, possibleId) ? $elm$core$Maybe$Just(possibleId) : $elm$core$Maybe$Nothing;
			},
			idRegex);
	};
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Spa$Layout$Application,
		function () {
			var _v0 = A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not),
				A2(
					$elm$core$String$split,
					'/',
					$author$project$Spa$Generated$Route$toString(route)));
			_v0$15:
			while (true) {
				_v0$21:
				while (true) {
					_v0$32:
					while (true) {
						if (_v0.b) {
							switch (_v0.a) {
								case 'style_guide':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$StyleGuide);
								case 'onboard':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Onboard);
								case 'practice_setup':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$PracticeSetup);
								case 'calendar':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
									} else {
										break _v0$32;
									}
								case 'home':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
									} else {
										break _v0$32;
									}
								case 'contacts':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
								case 'files':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
								case 'forms':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
								case 'new_settings':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
								case 'inventory':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
								case 'messages':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
								case 'tasks':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
								case 'patients':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Application);
									} else {
										if (!_v0.b.b.b) {
											if (_v0.b.a === 'create') {
												var _v1 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$PatientsSidebar);
											} else {
												break _v0$15;
											}
										} else {
											if ((_v0.b.b.a === 'chart') && (!_v0.b.b.b.b)) {
												var _v2 = _v0.b;
												var patientId = _v2.a;
												var _v3 = _v2.b;
												return A2(
													$elm$core$Maybe$map,
													$author$project$Spa$Layout$PatientChart,
													idMatch(patientId));
											} else {
												break _v0$15;
											}
										}
									}
								case 'companies':
									if (_v0.b.b) {
										var _v5 = _v0.b;
										var companyId = _v5.a;
										return A2(
											$elm$core$Maybe$map,
											$author$project$Spa$Layout$Company,
											idMatch(companyId));
									} else {
										break _v0$32;
									}
								case 'affiliate_bills':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Affiliates);
									} else {
										break _v0$32;
									}
								case 'affiliates':
									if (!_v0.b.b) {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Affiliates);
									} else {
										if (_v0.b.b.b && (!_v0.b.b.b.b)) {
											switch (_v0.b.b.a) {
												case 'link_providers':
													var _v6 = _v0.b;
													var _v7 = _v6.b;
													return $elm$core$Maybe$Nothing;
												case 'activate_new':
													var _v8 = _v0.b;
													var _v9 = _v8.b;
													return $elm$core$Maybe$Nothing;
												default:
													break _v0$21;
											}
										} else {
											break _v0$21;
										}
									}
								case 'partner':
									if (_v0.b.b) {
										switch (_v0.b.a) {
											case 'billing':
												var _v11 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerBilling);
											case 'practices':
												var _v12 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerPractices);
											case 'engagements':
												var _v13 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerPractices);
											case 'product':
												var _v14 = _v0.b;
												return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerProduct);
											default:
												break _v0$32;
										}
									} else {
										break _v0$32;
									}
								case 'marketplace':
									if ((_v0.b.b && _v0.b.b.b) && (_v0.b.b.a === 'manage')) {
										var _v15 = _v0.b;
										var slug = _v15.a;
										var _v16 = _v15.b;
										return $elm$core$Maybe$Just(
											$author$project$Spa$Layout$MarketplaceManage(slug));
									} else {
										break _v0$32;
									}
								case 'commissions':
									if ((_v0.b.b && (_v0.b.a === 'broker_accounts')) && _v0.b.b.b) {
										var _v17 = _v0.b;
										var _v18 = _v17.b;
										var brokerAccountId = _v18.a;
										return A2(
											$elm$core$Maybe$map,
											$author$project$Spa$Layout$CommissionsBrokerAccount,
											idMatch(brokerAccountId));
									} else {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$Commissions);
									}
								case 'admin':
									return $elm$core$Maybe$Just($author$project$Spa$Layout$Admin);
								case 'user':
									if (_v0.b.b && (_v0.b.a === 'organizations')) {
										var _v19 = _v0.b;
										return $elm$core$Maybe$Nothing;
									} else {
										return $elm$core$Maybe$Just($author$project$Spa$Layout$User);
									}
								default:
									break _v0$32;
							}
						} else {
							break _v0$32;
						}
					}
					return $elm$core$Maybe$Nothing;
				}
				var _v10 = _v0.b;
				var affiliateId = _v10.a;
				return A2(
					$elm$core$Maybe$map,
					$author$project$Spa$Layout$AffiliatesAffiliate,
					idMatch(affiliateId));
			}
			var _v4 = _v0.b;
			var patientId = _v4.a;
			return A2(
				$elm$core$Maybe$map,
				$author$project$Spa$Layout$PatientAndSidebar,
				idMatch(patientId));
		}());
};
var $author$project$Spa$Layout$init = function (shared) {
	var route = $author$project$Utils$Route$fromUrl(shared.aav);
	if (_Utils_eq(route, $author$project$Spa$Generated$Route$Blank)) {
		return _Utils_Tuple2($author$project$Spa$Layout$BlankModel, $elm$core$Platform$Cmd$none);
	} else {
		var _v0 = $author$project$Spa$Layout$routeToLayout(route);
		switch (_v0.$) {
			case 12:
				var companyId = _v0.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$CompanyModel(companyId),
						$author$project$Layouts$Company$init));
			case 5:
				var brokerAccountId = _v0.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$CommissionsBrokerAccountModel(brokerAccountId),
						A2($author$project$Layouts$Commissions$BrokerAccount$init, shared, brokerAccountId)));
			case 4:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg),
					A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CommissionsModel, $author$project$Layouts$Commissions$init));
			case 7:
				var affiliateId = _v0.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$AffiliatesAffiliateModel(affiliateId),
						A2($author$project$Layouts$Affiliates$Affiliate$init, shared, affiliateId)));
			case 6:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesMsg),
					A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AffiliatesModel, $author$project$Layouts$Affiliates$init));
			case 8:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg),
					A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerBillingModel, $author$project$Layouts$Partner$Billing$init));
			case 9:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg),
					A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerPracticesModel, $author$project$Layouts$Partner$Practices$init));
			case 10:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PartnerProductModel,
						$author$project$Layouts$Partner$Product$init(shared.Vz)));
			case 11:
				var slug = _v0.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$MarketplaceManageModel(slug),
						A2($author$project$Layouts$Marketplace$Manage$init, shared.D5, slug)));
			case 13:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$AdminModel,
						$author$project$Layouts$Admin$init(shared)));
			case 3:
				var id = _v0.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PatientAndSidebarModel(id),
						A2($author$project$Layouts$Patient$init, shared, id)));
			case 16:
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg),
					A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$UserModel, $author$project$Layouts$User$init));
			case 1:
				return _Utils_Tuple2($author$project$Spa$Layout$ApplicationModel, $elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2($author$project$Spa$Layout$PatientsSidebarModel, $elm$core$Platform$Cmd$none);
			case 14:
				return _Utils_Tuple2($author$project$Spa$Layout$OnboardModel, $elm$core$Platform$Cmd$none);
			case 15:
				return _Utils_Tuple2($author$project$Spa$Layout$PracticeSetupModel, $elm$core$Platform$Cmd$none);
			case 0:
				return _Utils_Tuple2($author$project$Spa$Layout$StyleGuideModel, $elm$core$Platform$Cmd$none);
			case 17:
				return _Utils_Tuple2($author$project$Spa$Layout$ClinicalModel, $elm$core$Platform$Cmd$none);
			default:
				var patientId = _v0.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Spa$Layout$PatientChartModel(patientId),
					A2($author$project$Layouts$PatientChart$init, shared, patientId));
		}
	}
};
var $author$project$Ports$Sentry$captureErrorMessage = _Platform_outgoingPort('captureErrorMessage', $elm$json$Json$Encode$string);
var $author$project$Main$defaultUrl = A6($elm$url$Url$Url, 0, 'localhost', $elm$core$Maybe$Nothing, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
var $author$project$Main$locationHrefToUrl = function (locationHref) {
	var _v0 = $elm$url$Url$fromString(locationHref);
	if (!_v0.$) {
		var url = _v0.a;
		return _Utils_Tuple2(url, $elm$core$Platform$Cmd$none);
	} else {
		return _Utils_Tuple2(
			$author$project$Main$defaultUrl,
			$author$project$Ports$Sentry$captureErrorMessage('Url.fromString Failed: ' + locationHref));
	}
};
var $author$project$Shared$BackupAuthOrganizationSwitched = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$OutMsg$GoToClinicalAction = {$: 5};
var $author$project$Shared$GotCompany = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Shared$GotPatient = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Shared$GotRoleSwitched = function (a) {
	return {$: 30, a: a};
};
var $author$project$Shared$PatientsListMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$PatientsList$RefreshPatients = {$: 14};
var $author$project$Shared$ToastMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Ports$Sentry$captureDebugMessage = _Platform_outgoingPort('captureDebugMessage', $elm$json$Json$Encode$string);
var $author$project$Shared$decodeErrorToMsg = function (error) {
	return $author$project$Ports$Sentry$captureErrorMessage('Decoder Failed: ' + error);
};
var $author$project$Shared$NavbarMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$WhitelabelSetting$empty = {Ek: '', El: true, GB: $elm$core$Maybe$Nothing, GJ: '', GK: '', GL: '', GM: 'App Logo', GN: $elm$core$Maybe$Nothing};
var $author$project$Api$Practice$Employer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbar$CompanyNav = function (a) {
	return {$: 2, a: a};
};
var $author$project$Navbar$CompanyNavbarMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbar$Model = $elm$core$Basics$identity;
var $author$project$Navbar$GotHeaderEndElement = function (a) {
	return {$: 4, a: a};
};
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Navbar$getHeaderEnd = A2(
	$elm$core$Task$attempt,
	$author$project$Navbar$GotHeaderEndElement,
	$elm$browser$Browser$Dom$getElement('topnav-end'));
var $author$project$Navbars$Company$Model = $elm$core$Basics$identity;
var $author$project$Navbars$Company$ProfileMenuMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Platform$User$Shared$canSwitchOrganizations = function (_v0) {
	var record = _v0;
	return record.KE;
};
var $author$project$Navbars$Company$initSessionConfiguration = function (session) {
	var showSideNav_ = function (_v0) {
		return true;
	};
	var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
	return {
		KE: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
		ym: isViewingAsHinter,
		afv: A2(
			$elm$core$Maybe$map,
			function (org) {
				return $author$project$Api$Platform$Organization$Shared$type_(org);
			},
			$author$project$Api$Platform$Session$One$organization(session)),
		Vj: A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Common$RequestDetail$Shared$osName,
			$author$project$Api$Platform$Session$One$requestDetail(session)),
		ZY: showSideNav_,
		ahN: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
	};
};
var $author$project$Navbars$Company$Account = 6;
var $author$project$Navbars$Company$AccountAndPricing = 5;
var $author$project$Navbars$Company$EmployeeUploads = 3;
var $author$project$Navbars$Company$Employees = 0;
var $author$project$Navbars$Company$Invoices = 1;
var $author$project$Navbars$Company$OnlineSignup = 4;
var $author$project$Navbars$Company$PaymentMethods = 2;
var $author$project$Navbars$Company$navItemFromUrl = function (url) {
	var pathList = A2(
		$elm$core$List$drop,
		1,
		A2($elm$core$String$split, '/', url.VL));
	_v0$2:
	while (true) {
		if (pathList.b) {
			switch (pathList.a) {
				case 'companies':
					var tail = pathList.b;
					var companySubpath = A2($elm$core$List$drop, 1, tail);
					if (companySubpath.b) {
						switch (companySubpath.a) {
							case 'employees':
								return 0;
							case 'invoices':
								return 1;
							case 'payment_sources':
								return 2;
							case 'uploads':
								return 3;
							case 'signup':
								return 4;
							default:
								return 0;
						}
					} else {
						return 5;
					}
				case 'user':
					return 6;
				default:
					break _v0$2;
			}
		} else {
			break _v0$2;
		}
	}
	return 0;
};
var $author$project$Navbars$Company$None = 1;
var $author$project$Navbars$Company$ProfileNav = 0;
var $author$project$Navbars$Company$openSubNavFromSelectedNav = function (selectedNav) {
	if (selectedNav === 6) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Navbars$Company$init = function (_v0) {
	var url = _v0.aav;
	var session = _v0.ZD;
	var practice = _v0.WF;
	var company = _v0.ab9;
	var whitelabelSetting = _v0.aa1;
	var selectedNav = $author$project$Navbars$Company$navItemFromUrl(url);
	return _Utils_Tuple2(
		{
			ab9: company,
			c1: $author$project$Navbars$Company$openSubNavFromSelectedNav(selectedNav),
			WF: practice,
			ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg),
			eE: selectedNav,
			ZD: session,
			Cb: $author$project$Navbars$Company$initSessionConfiguration(session),
			ow: false,
			aa1: whitelabelSetting
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Navbar$andInitEmployerNavbar = F4(
	function (practice, whitelabelSetting, company, _v0) {
		var model = _v0;
		return function (_v1) {
			var nav = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ac: nav}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[cmd, $author$project$Navbar$getHeaderEnd])));
		}(
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Navbar$CompanyNavbarMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Navbar$CompanyNav,
					$author$project$Navbars$Company$init(
						{ab9: company, WF: practice, ZD: model.ZD, aav: model.aav, aa1: whitelabelSetting}))));
	});
var $author$project$Navbar$NoNav = {$: 0};
var $author$project$Navbar$init = F3(
	function (session, practice, flags) {
		return {acZ: flags.acZ, adN: flags.adN, qT: flags.qT, ac: $author$project$Navbar$NoNav, afw: flags.afw, WF: practice, ZD: session, ZZ: false, aav: flags.aav};
	});
var $author$project$Navbar$initForEmployer = F5(
	function (session, whitelabelSetting, practice, company, flags) {
		return A4(
			$author$project$Navbar$andInitEmployerNavbar,
			practice,
			whitelabelSetting,
			company,
			A3(
				$author$project$Navbar$init,
				session,
				$elm$core$Maybe$Just(
					$author$project$Api$Practice$Employer(practice)),
				flags));
	});
var $author$project$Navbar$PartnerNav = function (a) {
	return {$: 3, a: a};
};
var $author$project$Navbar$PartnerNavbarMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Navbars$Partner$Model = $elm$core$Basics$identity;
var $author$project$Navbars$Partner$ProfileMenuMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Navbars$Partner$initSessionConfiguration = function (session) {
	var showSideNav_ = function (_v0) {
		return true;
	};
	var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
	return {
		KE: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
		ym: isViewingAsHinter,
		afv: A2(
			$elm$core$Maybe$map,
			function (org) {
				return $author$project$Api$Platform$Organization$Shared$type_(org);
			},
			$author$project$Api$Platform$Session$One$organization(session)),
		Vj: A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Common$RequestDetail$Shared$osName,
			$author$project$Api$Platform$Session$One$requestDetail(session)),
		ZY: showSideNav_,
		ahN: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
	};
};
var $author$project$Navbars$Partner$Account = 8;
var $author$project$Navbars$Partner$Marketplace = 9;
var $author$project$Navbars$Partner$PartnerApiKeys = 3;
var $author$project$Navbars$Partner$PartnerBilling = 2;
var $author$project$Navbars$Partner$PartnerHinter = 1;
var $author$project$Navbars$Partner$PartnerPractices = 5;
var $author$project$Navbars$Partner$PartnerProducts = 7;
var $author$project$Navbars$Partner$PartnerSandboxes = 6;
var $author$project$Navbars$Partner$PartnerTeam = 0;
var $author$project$Navbars$Partner$PartnerWebhookEndpoints = 4;
var $author$project$Navbars$Partner$navItemFromUrl = function (url) {
	var pathList = A2(
		$elm$core$List$drop,
		1,
		A2($elm$core$String$split, '/', url.VL));
	_v0$3:
	while (true) {
		if (pathList.b) {
			switch (pathList.a) {
				case 'partner':
					var partnerSubpath = pathList.b;
					_v1$10:
					while (true) {
						if (partnerSubpath.b) {
							switch (partnerSubpath.a) {
								case 'team':
									return 0;
								case 'api_keys':
									return 3;
								case 'webhook_endpoints':
									return 4;
								case 'practices':
									return 5;
								case 'engagements':
									return 5;
								case 'hinter':
									return 1;
								case 'billing':
									return 2;
								case 'dashboard':
									return 7;
								case 'product':
									return 7;
								case 'sandboxes':
									return 6;
								default:
									break _v1$10;
							}
						} else {
							break _v1$10;
						}
					}
					return 0;
				case 'user':
					return 8;
				case 'marketplace':
					return 9;
				default:
					break _v0$3;
			}
		} else {
			break _v0$3;
		}
	}
	return 0;
};
var $author$project$Navbars$Partner$None = 1;
var $author$project$Navbars$Partner$ProfileNav = 0;
var $author$project$Navbars$Partner$openSubNavFromSelectedNav = function (selectedNav) {
	if (selectedNav === 8) {
		return 0;
	} else {
		return 1;
	}
};
var $author$project$Navbars$Partner$init = function (_v0) {
	var url = _v0.aav;
	var session = _v0.ZD;
	var partner = _v0.Vz;
	var selectedNav = $author$project$Navbars$Partner$navItemFromUrl(url);
	return _Utils_Tuple2(
		{
			c1: $author$project$Navbars$Partner$openSubNavFromSelectedNav(selectedNav),
			Vz: partner,
			ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg),
			eE: selectedNav,
			ZD: session,
			Cb: $author$project$Navbars$Partner$initSessionConfiguration(session),
			ow: false
		},
		$elm$core$Platform$Cmd$none);
};
var $author$project$Navbar$andInitPartnerNavbar = F2(
	function (partner, _v0) {
		var model = _v0;
		return function (_v1) {
			var nav = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ac: nav}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[cmd, $author$project$Navbar$getHeaderEnd])));
		}(
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Navbar$PartnerNavbarMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Navbar$PartnerNav,
					$author$project$Navbars$Partner$init(
						{Vz: partner, ZD: model.ZD, aav: model.aav}))));
	});
var $author$project$Navbar$initForPartner = F3(
	function (session, partner, flags) {
		return A2(
			$author$project$Navbar$andInitPartnerNavbar,
			partner,
			A3($author$project$Navbar$init, session, $elm$core$Maybe$Nothing, flags));
	});
var $author$project$Navbar$PracticeNav = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbar$PracticeNavbarMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$AdminMenuMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Navbars$Practice$GotCurrentDate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$GotEmbeddedReports = function (a) {
	return {$: 1, a: a};
};
var $author$project$Navbars$Practice$GotPartnerApps = function (a) {
	return {$: 18, a: a};
};
var $author$project$Navbars$Practice$GotReports = function (a) {
	return {$: 14, a: a};
};
var $author$project$Navbars$Practice$Model = $elm$core$Basics$identity;
var $author$project$Navbars$Practice$ProfileMenuMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Navbars$Practice$ReportMenuMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Navbars$Practice$SwitchProductDropDownMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Api$Feature$ManageDataExports = 18;
var $author$project$Api$Feature$NavReorganization = 26;
var $author$project$Api$Provider$Practice$One$customLogoUrl = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.MF;
	});
var $author$project$Navbars$Practice$buildPracticeConfig = function (practice) {
	return {
		H8: A2($author$project$Api$Provider$Practice$One$featureEnabled, 15, practice) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 16, practice),
		Ln: $author$project$Api$Provider$Practice$One$commissionsEnabled(practice),
		ME: $author$project$Api$Provider$Practice$One$customLogoUrl(practice),
		ML: A2($author$project$Api$Provider$Practice$One$featureEnabled, 18, practice),
		FJ: A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			2,
			$author$project$Api$Practice$Provider(practice)),
		RV: $author$project$Api$Provider$Practice$One$isNetwork(practice),
		F3: A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			9,
			$author$project$Api$Practice$Provider(practice)),
		Ul: A2($author$project$Api$Provider$Practice$One$featureEnabled, 26, practice),
		Al: A2(
			$author$project$Utils$FeatureGate$gateAvailable,
			4,
			$author$project$Api$Practice$Provider(practice)),
		$e: A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice),
		oV: A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice)
	};
};
var $author$project$Components$HinterPracticeSettingsModal$Closed = {$: 0};
var $author$project$Components$HinterPracticeSettingsModal$init = $author$project$Components$HinterPracticeSettingsModal$Closed;
var $author$project$Api$Platform$Organization$Shared$accountType = function (_v0) {
	var record = _v0.b;
	return record.H7;
};
var $author$project$Api$Platform$Session$One$accountType = function (_v0) {
	var record = _v0;
	return A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$accountType, record.Vd);
};
var $author$project$Navbars$Practice$initSessionConfiguration = function (session) {
	var practiceIsOnboarding = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$Organization$Shared$practiceIsOnboarding,
			$author$project$Api$Platform$Session$One$organization(session)));
	var onboarded = A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$author$project$Api$Platform$Organization$Shared$onboarded,
			$author$project$Api$Platform$Session$One$organization(session)));
	var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
	var showSideNav_ = function (hinterViewOff) {
		return ((practiceIsOnboarding && (!isViewingAsHinter(hinterViewOff))) || ($author$project$Api$Platform$Session$One$role(session) === 'practice_practice_billing_only')) ? false : (isViewingAsHinter(hinterViewOff) ? true : onboarded);
	};
	var canGoToReports = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 45);
	};
	var canGoToPatients = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 44);
	};
	var canSearch = function (hinterViewOff) {
		return canGoToPatients(hinterViewOff) && onboarded;
	};
	var canGoToNetwork = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 50);
	};
	var canGoToCompanies = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 16);
	};
	var canGoToCommissions = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 46);
	};
	var canGoToAdmin = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0);
	};
	var canGoToAccounting = function (hinterViewOff) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 53);
	};
	return {
		H7: $author$project$Api$Platform$Session$One$accountType(session),
		Kt: canGoToAccounting,
		Ep: canGoToAdmin,
		Ku: canGoToCommissions,
		Kv: canGoToCompanies,
		Kw: canGoToNetwork,
		Er: canGoToPatients,
		vS: canGoToReports,
		vT: canSearch,
		WI: practiceIsOnboarding,
		Cd: {
			KE: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
			ym: isViewingAsHinter,
			afv: A2(
				$elm$core$Maybe$map,
				function (org) {
					return $author$project$Api$Platform$Organization$Shared$type_(org);
				},
				$author$project$Api$Platform$Session$One$organization(session)),
			Vj: A2(
				$elm$core$Maybe$andThen,
				$author$project$Api$Common$RequestDetail$Shared$osName,
				$author$project$Api$Platform$Session$One$requestDetail(session)),
			ZY: showSideNav_,
			ahN: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
		}
	};
};
var $author$project$Api$Provider$EmbeddedReport$All$EmbeddedReport = $elm$core$Basics$identity;
var $author$project$Api$Provider$EmbeddedReport$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$EmbeddedReport$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$EmbeddedReport$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$EmbeddedReport$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$EmbeddedReport$embeddedReportsPath));
	});
var $author$project$Api$Common$PartnerApp$All$PartnerApp = $elm$core$Basics$identity;
var $author$project$Api$Common$PartnerApp$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Common$PartnerApp$Shared$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$PartnerApp$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Common$PartnerApp$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$PartnerApp$partnerAppsPath));
	});
var $author$project$Api$Provider$Report$All$Record = function (id) {
	return {adR: id};
};
var $author$project$Api$Provider$Report$All$Report = $elm$core$Basics$identity;
var $author$project$Api$Provider$Report$All$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A2(
		$elm$json$Json$Decode$map,
		$author$project$Api$Provider$Report$All$Record,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['id']),
			$elm$json$Json$Decode$string)));
var $author$project$Api$Provider$Report$reportsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['reports']),
	$author$project$Api$Data$providerPath);
var $author$project$Api$Provider$Report$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Report$All$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Provider$Report$reportsPath));
	});
var $author$project$Navbars$Practice$Navigation$Account = {$: 5};
var $author$project$Navbars$Practice$Navigation$Accounting = {$: 6};
var $author$project$Navbars$Practice$Navigation$Admin = function (a) {
	return {$: 13, a: a};
};
var $author$project$Navbars$Practice$Navigation$AppointmentTypes = 14;
var $author$project$Navbars$Practice$Navigation$Calendar = {$: 1};
var $author$project$Navbars$Practice$Navigation$CalendarLocations = 13;
var $author$project$Navbars$Practice$Navigation$ChargeItems = 5;
var $author$project$Navbars$Practice$Navigation$ClinicalDashboard = {$: 7};
var $author$project$Navbars$Practice$Navigation$Commissions = {$: 4};
var $author$project$Navbars$Practice$Navigation$CommissionsSetup = 6;
var $author$project$Navbars$Practice$Navigation$CompanyInvoices = {$: 5};
var $author$project$Navbars$Practice$Navigation$Contacts = {$: 11};
var $author$project$Navbars$Practice$Navigation$CreditCategories = 4;
var $author$project$Navbars$Practice$Navigation$CreditOutstanding = {$: 6};
var $author$project$Navbars$Practice$Navigation$CreditTransactions = {$: 10};
var $author$project$Navbars$Practice$Navigation$Custom = function (a) {
	return {$: 13, a: a};
};
var $author$project$Navbars$Practice$Navigation$Dashboard = {$: 0};
var $author$project$Navbars$Practice$Navigation$DataExport = 12;
var $author$project$Navbars$Practice$Navigation$DeferredRevenue = {$: 8};
var $author$project$Navbars$Practice$Navigation$Deposits = {$: 11};
var $author$project$Navbars$Practice$Navigation$Developers = 19;
var $author$project$Navbars$Practice$Navigation$Documents = 11;
var $author$project$Navbars$Practice$Navigation$ERx = 15;
var $author$project$Navbars$Practice$Navigation$FileDrive = 17;
var $author$project$Navbars$Practice$Navigation$Forms = {$: 10};
var $author$project$Navbars$Practice$Navigation$Help = function (a) {
	return {$: 14, a: a};
};
var $author$project$Navbars$Practice$Navigation$HipaaAuthorizations = 8;
var $author$project$Navbars$Practice$Navigation$Inbox = {$: 8};
var $author$project$Navbars$Practice$Navigation$Integrations = 9;
var $author$project$Navbars$Practice$Navigation$InvoiceSettings = 10;
var $author$project$Navbars$Practice$Navigation$Invoices = {$: 4};
var $author$project$Navbars$Practice$Navigation$Marketplace = {$: 16};
var $author$project$Navbars$Practice$Navigation$Medications = 16;
var $author$project$Navbars$Practice$Navigation$MembershipOptions = 2;
var $author$project$Navbars$Practice$Navigation$Memberships = {$: 3};
var $author$project$Navbars$Practice$Navigation$Months = {$: 1};
var $author$project$Navbars$Practice$Navigation$Networks = {$: 3};
var $author$project$Navbars$Practice$Navigation$NotificationsPatient = 7;
var $author$project$Navbars$Practice$Navigation$PartnerApp = function (a) {
	return {$: 15, a: a};
};
var $author$project$Navbars$Practice$Navigation$Patients = {$: 0};
var $author$project$Navbars$Practice$Navigation$PaymentApplications = {$: 9};
var $author$project$Navbars$Practice$Navigation$Phones = 20;
var $author$project$Navbars$Practice$Navigation$Practice = 0;
var $author$project$Navbars$Practice$Navigation$Providers = 1;
var $author$project$Navbars$Practice$Navigation$Reports = function (a) {
	return {$: 12, a: a};
};
var $author$project$Navbars$Practice$Navigation$Revenue = {$: 7};
var $author$project$Navbars$Practice$Navigation$SalesTax = {$: 12};
var $author$project$Navbars$Practice$Navigation$Signup = 3;
var $author$project$Navbars$Practice$Navigation$SignupAttempts = {$: 2};
var $author$project$Navbars$Practice$Navigation$Sponsors = {$: 2};
var $author$project$Navbars$Practice$Navigation$Support = 0;
var $author$project$Navbars$Practice$Navigation$Tasks = {$: 9};
var $author$project$Navbars$Practice$Navigation$Team = 21;
var $author$project$Navbars$Practice$Navigation$Templates = 18;
var $author$project$Navbars$Practice$Navigation$navItemFromUrl = function (url) {
	var pathList = A2(
		$elm$core$List$drop,
		1,
		A2($elm$core$String$split, '/', url.VL));
	_v0$22:
	while (true) {
		_v0$25:
		while (true) {
			if (pathList.b) {
				switch (pathList.a) {
					case 'calendar':
						return $author$project$Navbars$Practice$Navigation$Calendar;
					case 'patients':
						return $author$project$Navbars$Practice$Navigation$Patients;
					case 'companies':
						return $author$project$Navbars$Practice$Navigation$Sponsors;
					case 'affiliate_bills':
						return $author$project$Navbars$Practice$Navigation$Networks;
					case 'affiliates':
						return $author$project$Navbars$Practice$Navigation$Networks;
					case 'commissions':
						return $author$project$Navbars$Practice$Navigation$Commissions;
					case 'reports':
						var tail = pathList.b;
						_v1$14:
						while (true) {
							if (tail.b) {
								switch (tail.a) {
									case 'dashboard':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard);
									case 'months':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Months);
									case 'signup_attempts':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SignupAttempts);
									case 'memberships':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Memberships);
									case 'invoices':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Invoices);
									case 'company_invoices':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CompanyInvoices);
									case 'credit_outstanding':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditOutstanding);
									case 'revenue':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Revenue);
									case 'deferred_revenue':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$DeferredRevenue);
									case 'payment_applications':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$PaymentApplications);
									case 'credit_transactions':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditTransactions);
									case 'deposits':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Deposits);
									case 'sales_tax':
										return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SalesTax);
									case 'custom':
										if (tail.b.b) {
											var _v2 = tail.b;
											var id = _v2.a;
											return $author$project$Navbars$Practice$Navigation$Reports(
												$author$project$Navbars$Practice$Navigation$Custom(id));
										} else {
											break _v1$14;
										}
									default:
										break _v1$14;
								}
							} else {
								break _v1$14;
							}
						}
						return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard);
					case 'admin':
						var tail = pathList.b;
						_v3$44:
						while (true) {
							if (tail.b) {
								switch (tail.a) {
									case 'practice':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'team':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'phones':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'billing':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'payment_sources':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'notes':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'features':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'scheduled_jobs':
										return $author$project$Navbars$Practice$Navigation$Admin(0);
									case 'providers':
										return $author$project$Navbars$Practice$Navigation$Admin(1);
									case 'patients':
										return $author$project$Navbars$Practice$Navigation$Admin(1);
									case 'locations':
										return $author$project$Navbars$Practice$Navigation$Admin(1);
									case 'provider_groups':
										return $author$project$Navbars$Practice$Navigation$Admin(1);
									case 'plans':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'coverage_plans':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'coupons':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'cancellation_reasons':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'advance_billing':
										return $author$project$Navbars$Practice$Navigation$Admin(2);
									case 'signup':
										return $author$project$Navbars$Practice$Navigation$Admin(3);
									case 'signup_pages':
										return $author$project$Navbars$Practice$Navigation$Admin(3);
									case 'self_service':
										return $author$project$Navbars$Practice$Navigation$Admin(3);
									case 'lead_sources':
										return $author$project$Navbars$Practice$Navigation$Admin(3);
									case 'credit_categories':
										return $author$project$Navbars$Practice$Navigation$Admin(4);
									case 'credits':
										return $author$project$Navbars$Practice$Navigation$Admin(4);
									case 'charge_items':
										return $author$project$Navbars$Practice$Navigation$Admin(5);
									case 'categories':
										return $author$project$Navbars$Practice$Navigation$Admin(5);
									case 'taxes':
										return $author$project$Navbars$Practice$Navigation$Admin(5);
									case 'commissions':
										return $author$project$Navbars$Practice$Navigation$Admin(6);
									case 'notifications':
										return $author$project$Navbars$Practice$Navigation$Admin(7);
									case 'hipaa_authorizations':
										return $author$project$Navbars$Practice$Navigation$Admin(8);
									case 'stripe':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'card_readers':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'quickbooks':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'elation':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'athenahealth':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'google_analytics':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'integrations':
										return $author$project$Navbars$Practice$Navigation$Admin(9);
									case 'invoice_settings':
										return $author$project$Navbars$Practice$Navigation$Admin(10);
									case 'company_plans':
										return $author$project$Navbars$Practice$Navigation$Admin(10);
									case 'documents':
										return $author$project$Navbars$Practice$Navigation$Admin(11);
									case 'data_export':
										return $author$project$Navbars$Practice$Navigation$Admin(12);
									case 'calendar':
										return $author$project$Navbars$Practice$Navigation$Admin(13);
									case 'appointment_types':
										return $author$project$Navbars$Practice$Navigation$Admin(14);
									case 'erx':
										return $author$project$Navbars$Practice$Navigation$Admin(15);
									case 'developers':
										return $author$project$Navbars$Practice$Navigation$Admin(19);
									default:
										break _v3$44;
								}
							} else {
								break _v3$44;
							}
						}
						return $author$project$Navbars$Practice$Navigation$Admin(0);
					case 'support':
						return $author$project$Navbars$Practice$Navigation$Help(0);
					case 'user':
						return $author$project$Navbars$Practice$Navigation$Account;
					case 'accounting':
						return $author$project$Navbars$Practice$Navigation$Accounting;
					case 'marketplace':
						return $author$project$Navbars$Practice$Navigation$Marketplace;
					case 'apps':
						if (pathList.b.b && (!pathList.b.b.b)) {
							var _v10 = pathList.b;
							var id = _v10.a;
							return $author$project$Navbars$Practice$Navigation$PartnerApp(id);
						} else {
							break _v0$25;
						}
					case 'home':
						return $author$project$Navbars$Practice$Navigation$ClinicalDashboard;
					case 'contacts':
						return $author$project$Navbars$Practice$Navigation$Contacts;
					case 'files':
						return $author$project$Navbars$Practice$Navigation$Admin(17);
					case 'forms':
						return $author$project$Navbars$Practice$Navigation$Forms;
					case 'inventory':
						return $author$project$Navbars$Practice$Navigation$Admin(16);
					case 'new_settings':
						if (pathList.b.b) {
							switch (pathList.b.a) {
								case 'practice_info':
									var _v4 = pathList.b;
									return $author$project$Navbars$Practice$Navigation$Admin(20);
								case 'team':
									if ((pathList.b.b.b && pathList.b.b.b.b) && (pathList.b.b.b.a === 'basic_info')) {
										var _v5 = pathList.b;
										var _v6 = _v5.b;
										var _v7 = _v6.b;
										return $author$project$Navbars$Practice$Navigation$Account;
									} else {
										var _v8 = pathList.b;
										return $author$project$Navbars$Practice$Navigation$Admin(21);
									}
								case 'erx':
									var _v9 = pathList.b;
									return $author$project$Navbars$Practice$Navigation$Admin(15);
								default:
									break _v0$22;
							}
						} else {
							break _v0$22;
						}
					case 'messages':
						if (pathList.b.b && (pathList.b.a === 'sms')) {
							var _v12 = pathList.b;
							return $author$project$Navbars$Practice$Navigation$Inbox;
						} else {
							break _v0$25;
						}
					case 'tasks':
						return $author$project$Navbars$Practice$Navigation$Tasks;
					default:
						break _v0$25;
				}
			} else {
				break _v0$25;
			}
		}
		return $author$project$Navbars$Practice$Navigation$Patients;
	}
	var tail = pathList.b;
	_v11$4:
	while (true) {
		if (tail.b) {
			switch (tail.a) {
				case 'appointment_types':
					return $author$project$Navbars$Practice$Navigation$Admin(14);
				case 'locations':
					return $author$project$Navbars$Practice$Navigation$Admin(13);
				case 'templates':
					return $author$project$Navbars$Practice$Navigation$Admin(18);
				case 'hinter_settings':
					return $author$project$Navbars$Practice$Navigation$Admin(0);
				default:
					break _v11$4;
			}
		} else {
			break _v11$4;
		}
	}
	return $author$project$Navbars$Practice$Navigation$Admin(0);
};
var $author$project$Navbars$Practice$Navigation$AdminNav = 1;
var $author$project$Navbars$Practice$Navigation$HelpNav = 2;
var $author$project$Navbars$Practice$Navigation$None = 4;
var $author$project$Navbars$Practice$Navigation$ProfileNav = 3;
var $author$project$Navbars$Practice$Navigation$ReportNav = 0;
var $author$project$Navbars$Practice$openSubNavFromSelectedNav = function (selectedNav) {
	switch (selectedNav.$) {
		case 13:
			return 1;
		case 14:
			return 2;
		case 12:
			return 0;
		case 5:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Navbars$Practice$init = function (shared) {
	var selectedNav = $author$project$Navbars$Practice$Navigation$navItemFromUrl(shared.aav);
	var practice = shared.WF;
	var apiClient = shared.D5;
	return _Utils_Tuple3(
		{
			hr: A2($author$project$Ui$FlyoutMenu$init, 'admin-menu', $author$project$Navbars$Practice$AdminMenuMsg),
			abt: shared.abt,
			cO: $elm$core$Maybe$Nothing,
			qq: $author$project$Api$Data$Loading,
			acZ: shared.acZ,
			iO: $author$project$Components$HinterPracticeSettingsModal$init,
			qT: shared.qT,
			yj: false,
			c1: $author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav),
			afw: shared.afw,
			rP: $author$project$Api$Data$NotAsked,
			WF: practice,
			nA: $author$project$Navbars$Practice$buildPracticeConfig(practice),
			ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg),
			jP: A2($author$project$Ui$FlyoutMenu$init, 'reporting-menu', $author$project$Navbars$Practice$ReportMenuMsg),
			sn: $author$project$Api$Data$NotAsked,
			eE: selectedNav,
			ZD: shared.ZD,
			Cb: $author$project$Navbars$Practice$initSessionConfiguration(shared.ZD),
			sS: false,
			ow: false,
			oF: $author$project$Ui$NewDropdown$init(
				$author$project$Ui$NewDropdown$defaultConfig(
					{adR: 'switch-product-dropdown', ahx: $author$project$Navbars$Practice$SwitchProductDropDownMsg})),
			aa1: shared.aa1
		},
		$author$project$Api$Data$clientHasAuthToken(apiClient) ? $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Provider$EmbeddedReport$list, apiClient, $author$project$Navbars$Practice$GotEmbeddedReports),
					A2($elm$core$Task$perform, $author$project$Navbars$Practice$GotCurrentDate, $justinmimbs$date$Date$today),
					A2($author$project$Api$Provider$Report$list, apiClient, $author$project$Navbars$Practice$GotReports),
					A2($author$project$Api$Provider$PartnerApp$list, apiClient, $author$project$Navbars$Practice$GotPartnerApps)
				])) : $elm$core$Platform$Cmd$none,
		_List_Nil);
};
var $author$project$Navbar$andInitPracticeNavbar = F5(
	function (apiClient, whitelabelSetting, practice, backupAuthEnabled, _v0) {
		var model = _v0;
		var _v1 = $author$project$Navbars$Practice$init(
			{D5: apiClient, abt: backupAuthEnabled, acZ: model.acZ, adN: model.adN, qT: model.qT, afw: model.afw, WF: practice, ZD: model.ZD, aav: model.aav, aa1: whitelabelSetting});
		var navbarModel = _v1.a;
		var navbarCmd = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					ac: $author$project$Navbar$PracticeNav(navbarModel)
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PracticeNavbarMsg, navbarCmd));
	});
var $author$project$Navbar$initForPractice = F6(
	function (apiClient, session, whitelabelSetting, practice, backupAuthEnabled, flags) {
		return A5(
			$author$project$Navbar$andInitPracticeNavbar,
			apiClient,
			whitelabelSetting,
			practice,
			backupAuthEnabled,
			A3(
				$author$project$Navbar$init,
				session,
				$elm$core$Maybe$Just(
					$author$project$Api$Practice$Provider(practice)),
				flags));
	});
var $author$project$Shared$isPublicRoute = function (route) {
	var _v0 = $author$project$Permission$forRoute(route);
	if (_v0.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Shared$initNavbar = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = _Utils_Tuple2(model.ZD, model.ad);
	if ((_v1.a.$ === 3) && (_v1.b.$ === 1)) {
		var _v2 = _v1.a;
		var session = _v2.a;
		var _v3 = _v1.b;
		var currentRoute = $author$project$Utils$Route$fromUrl(model.aav);
		var isPublic = $author$project$Shared$isPublicRoute(currentRoute);
		if (isPublic) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var whitelabelSetting = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Api$WhitelabelSetting$empty,
				$author$project$Api$Data$toMaybe(model.aa1));
			var organizationType = A2(
				$elm$core$Maybe$map,
				function (org) {
					return $author$project$Api$Platform$Organization$Shared$type_(org);
				},
				$author$project$Api$Platform$Session$One$organization(session));
			var _v4 = _Utils_Tuple2(organizationType, model.WF);
			_v4$3:
			while (true) {
				if (!_v4.a.$) {
					switch (_v4.a.a) {
						case 0:
							if (_v4.b.$ === 3) {
								var _v5 = _v4.a.a;
								var _v6 = _v4.b;
								var practice = _v6.a;
								var _v7 = _Utils_Tuple2(practice, model.ab9);
								if (!_v7.a.$) {
									var practice_ = _v7.a.a;
									return A2(
										$elm$core$Tuple$mapFirst,
										function (navbar) {
											return _Utils_update(
												model,
												{
													ad: $elm$core$Maybe$Just(navbar)
												});
										},
										A2(
											$elm$core$Tuple$mapSecond,
											function (navbarCmd) {
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[cmd, navbarCmd]));
											},
											A2(
												$elm$core$Tuple$mapSecond,
												$elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg),
												A6(
													$author$project$Navbar$initForPractice,
													model.D5,
													session,
													whitelabelSetting,
													practice_,
													model.adu.abt,
													{acZ: model.adu.acZ, adN: model.adN, qT: model.qT, afw: model.adu.afw, aav: model.aav}))));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							} else {
								break _v4$3;
							}
						case 1:
							if (_v4.b.$ === 3) {
								var _v8 = _v4.a.a;
								var _v9 = _v4.b;
								var practice = _v9.a;
								var _v10 = _Utils_Tuple2(practice, model.ab9);
								if (((_v10.a.$ === 1) && (_v10.b.$ === 3)) && (_v10.b.a.$ === 1)) {
									var practice_ = _v10.a.a;
									var _v11 = _v10.b;
									var company = _v11.a.a;
									return A2(
										$elm$core$Tuple$mapFirst,
										function (navbar) {
											return _Utils_update(
												model,
												{
													ad: $elm$core$Maybe$Just(navbar)
												});
										},
										A2(
											$elm$core$Tuple$mapSecond,
											function (navbarCmd) {
												return $elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[cmd, navbarCmd]));
											},
											A2(
												$elm$core$Tuple$mapSecond,
												$elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg),
												A5(
													$author$project$Navbar$initForEmployer,
													session,
													whitelabelSetting,
													practice_,
													company,
													{acZ: model.adu.acZ, adN: model.adN, qT: model.qT, afw: model.adu.afw, aav: model.aav}))));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							} else {
								break _v4$3;
							}
						default:
							var _v12 = _v4.a.a;
							var _v13 = model.Vz;
							if (_v13.$ === 3) {
								var partner = _v13.a;
								return A2(
									$elm$core$Tuple$mapFirst,
									function (navbar) {
										return _Utils_update(
											model,
											{
												ad: $elm$core$Maybe$Just(navbar)
											});
									},
									A2(
										$elm$core$Tuple$mapSecond,
										function (navbarCmd) {
											return $elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[cmd, navbarCmd]));
										},
										A2(
											$elm$core$Tuple$mapSecond,
											$elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg),
											A3(
												$author$project$Navbar$initForPartner,
												session,
												partner,
												{acZ: model.adu.acZ, adN: model.adN, qT: model.qT, afw: model.adu.afw, aav: model.aav}))));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
					}
				} else {
					break _v4$3;
				}
			}
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Api$Practice$provider = function (practice) {
	return A2($author$project$Api$Data$map, $author$project$Api$Practice$Provider, practice);
};
var $author$project$Shared$resetTenancyProperties = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				ab9: $author$project$Api$Data$NotAsked,
				Mw: $author$project$Api$Data$NotAsked,
				lG: $elm$core$Maybe$Nothing,
				qV: $elm$core$Maybe$Just($elm$core$Dict$empty),
				ad: $elm$core$Maybe$Nothing,
				afE: $elm$core$Maybe$Nothing,
				n0: $elm$core$Maybe$Nothing
			}),
		cmd);
};
var $author$project$Shared$GotPartner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Shared$retrievePartner = function (apiClient) {
	return A2($author$project$Api$Partner$Partner$retrieve, apiClient, $author$project$Shared$GotPartner);
};
var $author$project$Shared$GotPractice = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Employer$Practice$One$Practice = $elm$core$Basics$identity;
var $author$project$Api$Employer$Practice$One$Record = function (id) {
	return function (name) {
		return function (hasPaymentProcessorAccount) {
			return function (stripePublishableKey) {
				return function (ssnEnabled) {
					return function (features) {
						return function (trackPatientsByLocation) {
							return function (transInclusivity) {
								return function (address) {
									return function (phones) {
										return function (collectSSNOnSignup) {
											return function (featureGates) {
												return function (requiresPatientMobile) {
													return function (requiresSSN) {
														return function (requiresPatientEmail) {
															return function (requiresPractitioner) {
																return function (requiresLocation) {
																	return function (meta) {
																		return function (email) {
																			return function (network) {
																				return function (paymentProcessor) {
																					return function (hideSponsorInvoices) {
																						return function (organizationId) {
																							return {It: address, Lh: collectSSNOnSignup, Oo: email, Pb: featureGates, Pd: features, Qd: hasPaymentProcessorAccount, Qp: hideSponsorInvoices, adR: id, TU: meta, zh: name, Uo: network, aft: organizationId, V0: paymentProcessor, Wi: phones, Ym: requiresLocation, Yo: requiresPatientEmail, Yp: requiresPatientMobile, Yr: requiresPractitioner, Ys: requiresSSN, _D: ssnEnabled, _Z: stripePublishableKey, $$: trackPatientsByLocation, $1: transInclusivity};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Employer$Network$Shared$Network = $elm$core$Basics$identity;
var $author$project$Api$Employer$Network$Shared$Record = F2(
	function (syncByAffiliation, ratesFromAffiliate) {
		return {XN: ratesFromAffiliate, $f: syncByAffiliation};
	});
var $author$project$Api$Employer$Network$Shared$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rates_from_affiliate',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sync_by_affiliation',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Network$Shared$Record)));
var $author$project$Api$Employer$Network$Shared$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Network$Shared$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Practice$One$OneMeta = F2(
	function (hasPractitioners, hasLocations) {
		return {P8: hasLocations, Qe: hasPractitioners};
	});
var $author$project$Api$Employer$Practice$One$metaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'has_locations',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'has_practitioners',
		$elm$json$Json$Decode$bool,
		$elm$json$Json$Decode$succeed($author$project$Api$Employer$Practice$One$OneMeta)));
var $author$project$Api$Employer$Practice$One$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'organization_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'hide_sponsor_invoices',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'payment_processor',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'network',
				$elm$json$Json$Decode$nullable($author$project$Api$Employer$Network$Shared$decoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'email',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'meta',
						$author$project$Api$Employer$Practice$One$metaDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'requires_location',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'requires_practitioner',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'requires_patient_email',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'requires_ssn',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'requires_patient_mobile',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'feature_gates',
												$elm$json$Json$Decode$list($author$project$Api$Common$FeatureGate$Shared$decoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'collect_ssn_on_signup',
													$author$project$Api$CollectOnSignup$decoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'phones',
														$elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'address',
															$elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder),
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'trans_inclusivity',
																$elm$json$Json$Decode$bool,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'track_patients_by_location',
																	$elm$json$Json$Decode$bool,
																	false,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'features',
																		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'ssn_enabled',
																			$elm$json$Json$Decode$bool,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'stripe_publishable_key',
																				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'has_payment_processor_account',
																					$elm$json$Json$Decode$bool,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'name',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'id',
																							$elm$json$Json$Decode$string,
																							$elm$json$Json$Decode$succeed($author$project$Api$Employer$Practice$One$Record))))))))))))))))))))))));
var $author$project$Api$Employer$Practice$One$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Employer$Practice$One$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Employer$Practice$practicePath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['practice']),
	$author$project$Api$Data$employerPath);
var $author$project$Api$Employer$Practice$retrieve = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Employer$Practice$One$decoder,
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Employer$Practice$practicePath));
	});
var $author$project$Api$Practice$retrieve = F3(
	function (apiClient, session, toMsg) {
		return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2(
			$author$project$Api$Employer$Practice$retrieve,
			apiClient,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Practice$Employer))) : A3(
			$author$project$Api$Provider$Practice$retrieve,
			apiClient,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeL,
				toMsg,
				$author$project$Api$Data$map($author$project$Api$Practice$Provider)));
	});
var $author$project$Shared$retrievePractice = F2(
	function (apiClient, session) {
		return A3($author$project$Api$Practice$retrieve, apiClient, session, $author$project$Shared$GotPractice);
	});
var $author$project$Shared$scheduleOrgSwitchRedirect = F3(
	function (model, postOrganizationSwitchedAction_, cmd) {
		return $author$project$Shared$resetTenancyProperties(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{Vz: $author$project$Api$Data$NotAsked, ej: postOrganizationSwitchedAction_, WF: $author$project$Api$Data$NotAsked, gU: true}),
				cmd));
	});
var $author$project$Ui$Toast$levelToString = function (level) {
	switch (level) {
		case 0:
			return 'info';
		case 1:
			return 'danger';
		case 2:
			return 'warning';
		default:
			return 'success';
	}
};
var $author$project$Ui$Toast$sendToastMessagePort = _Platform_outgoingPort(
	'sendToastMessagePort',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Ui$Toast$sendMessage = F2(
	function (level, message) {
		return $author$project$Ui$Toast$sendToastMessagePort(
			_Utils_Tuple2(
				$author$project$Ui$Toast$levelToString(level),
				message));
	});
var $author$project$Shared$showToast = F3(
	function (embedded, toastLevel, message) {
		return embedded ? A2($author$project$Ui$Toast$sendMessage, toastLevel, message) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Ports$HinterView$hinterViewStorePort = _Platform_outgoingPort('hinterViewStorePort', $elm$json$Json$Encode$bool);
var $author$project$Ports$HinterView$store = $author$project$Ports$HinterView$hinterViewStorePort;
var $author$project$Ports$Session$persistBackupAuthTokenPort = _Platform_outgoingPort('persistBackupAuthTokenPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Session$persistBackupAuthToken = function (token) {
	return $author$project$Ports$Session$persistBackupAuthTokenPort(token);
};
var $author$project$Ports$Session$refreshBackupAuthTokenPort = _Platform_outgoingPort('refreshBackupAuthTokenPort', $elm$json$Json$Encode$string);
var $author$project$Ports$Session$refreshBackupAuthToken = function (token) {
	return $author$project$Ports$Session$refreshBackupAuthTokenPort(token);
};
var $author$project$Shared$storeAuthToken = F2(
	function (authToken, isRefresh) {
		var portCmd = isRefresh ? $author$project$Ports$Session$refreshBackupAuthToken : $author$project$Ports$Session$persistBackupAuthToken;
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				portCmd,
				$author$project$Api$AuthToken$toString(authToken)));
	});
var $author$project$Api$Platform$Session$switchRole = F3(
	function (apiClient, role, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'role',
					$elm$json$Json$Encode$string(role))
				]));
		return A4(
			$author$project$Api$Data$post,
			apiClient,
			$author$project$Api$Platform$Session$One$decoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['switch_role']),
						$author$project$Api$Platform$Session$sessionPath))));
	});
var $author$project$Ports$Session$sessionSwitchTenant = _Platform_outgoingPort('sessionSwitchTenant', $elm$json$Json$Encode$string);
var $author$project$Ports$Session$switchTenant = function (organizationId) {
	return $author$project$Ports$Session$sessionSwitchTenant(organizationId);
};
var $author$project$Api$Auth$switchToOrganization = F4(
	function (client, organizationId, role, toMsg) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'organization',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'id',
								$elm$json$Json$Encode$string(organizationId)),
								_Utils_Tuple2(
								'type',
								$elm$json$Json$Encode$string('organization'))
							]))),
					_Utils_Tuple2(
					'role',
					A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, role))
				]));
		return A4(
			$author$project$Api$Data$post,
			client,
			$author$project$Api$Auth$authTokenDecoder,
			toMsg,
			A2(
				$author$project$Api$Data$requestWithJson,
				body,
				$author$project$Api$Data$requestTo(
					A2(
						$author$project$Api$Data$pathAppend,
						_List_fromArray(
							['switch_organization']),
						$author$project$Api$Auth$authPath))));
	});
var $author$project$Ui$Toast$ToastAutoDismissed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Toast$dismissInSeconds = F2(
	function (seconds, id) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return $author$project$Ui$Toast$ToastAutoDismissed(id);
			},
			$elm$core$Process$sleep(seconds * 1000));
	});
var $author$project$Ui$Toast$Toast = $elm$core$Basics$identity;
var $author$project$Ui$Toast$ToastRecord = F4(
	function (id, level, message, dismissible) {
		return {qj: dismissible, adR: id, SL: level, aeD: message};
	});
var $author$project$Ui$Toast$newToast = F3(
	function (id, level, message) {
		return A4($author$project$Ui$Toast$ToastRecord, id, level, message, true);
	});
var $author$project$Ui$Toast$toast = F3(
	function (level, message, _v0) {
		var count = _v0.a;
		var toasts = _v0.b;
		return _Utils_Tuple2(
			A2(
				$author$project$Ui$Toast$Toastr,
				count + 1,
				_Utils_ap(
					toasts,
					_List_fromArray(
						[
							A3($author$project$Ui$Toast$newToast, count, level, message)
						]))),
			A2($author$project$Ui$Toast$dismissInSeconds, 4, count));
	});
var $author$project$Shared$updateFromOutMsg = F2(
	function (outMsg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		switch (outMsg.$) {
			case 0:
				var error = outMsg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								$author$project$Shared$decodeErrorToMsg(error)
							])));
			case 1:
				var toastLevel = outMsg.a;
				var message = outMsg.b;
				var _v2 = A3($author$project$Ui$Toast$toast, toastLevel, message, model.kv);
				var toastr = _v2.a;
				var toastrCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{kv: toastr}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3($author$project$Shared$showToast, model.adu.acW, toastLevel, message),
								A2($elm$core$Platform$Cmd$map, $author$project$Shared$ToastMsg, toastrCmd)
							])));
			case 5:
				var practice = outMsg.a;
				return $author$project$Shared$initNavbar(
					$author$project$Shared$resetTenancyProperties(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									WF: $author$project$Api$Practice$provider(practice)
								}),
							cmd)));
			case 6:
				var partner = outMsg.a;
				return $author$project$Shared$initNavbar(
					_Utils_Tuple2(
						_Utils_update(
							model,
							{Vz: partner}),
						cmd));
			case 7:
				var dataWhitelabelSetting = outMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aa1: dataWhitelabelSetting}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								function () {
								var _v3 = model.ZD;
								if (_v3.$ === 3) {
									var session = _v3.a;
									return A2($author$project$Shared$retrievePractice, model.D5, session);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}()
							])));
			case 3:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								function () {
								var _v4 = model.ZD;
								if (_v4.$ === 3) {
									return $author$project$Shared$retrievePartner(model.D5);
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							}()
							])));
			case 9:
				var patientId = outMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Mw: $author$project$Api$Data$Loading,
							lG: $elm$core$Maybe$Just(patientId)
						}),
					A3(
						$author$project$Api$Provider$Patient$retrieve,
						model.D5,
						patientId,
						$author$project$Shared$GotPatient(patientId)));
			case 8:
				var companyId = outMsg.a;
				var _v5 = function () {
					var _v6 = model.ZD;
					switch (_v6.$) {
						case 3:
							var session = _v6.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ab9: $author$project$Api$Data$Loading}),
								A4(
									$author$project$Api$Company$retrieve,
									model.D5,
									session,
									companyId,
									$author$project$Shared$GotCompany(companyId)));
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ab9: $author$project$Api$Data$Loading,
										n0: $elm$core$Maybe$Just(companyId)
									}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				}();
				var newModel = _v5.a;
				var retrieveCompanyCmd = _v5.b;
				return _Utils_Tuple2(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[cmd, retrieveCompanyCmd])));
			case 10:
				var query = outMsg.a;
				var _v7 = _Utils_Tuple3(model.ZD, model.WF, model.afE);
				if ((((_v7.a.$ === 3) && (_v7.b.$ === 3)) && (!_v7.b.a.$)) && (_v7.c.$ === 1)) {
					var _v8 = _v7.a;
					var session = _v8.a;
					var _v9 = _v7.b;
					var practice = _v9.a.a;
					var _v10 = _v7.c;
					var _v11 = A4(
						$author$project$Components$PatientsList$init,
						session,
						practice,
						model.lG,
						{D5: model.D5, Bi: query, Hy: model.Hy, Hz: model.Hz, aav: model.aav});
					var newList = _v11.a;
					var listCmd = _v11.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								afE: $elm$core$Maybe$Just(newList)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, listCmd)
								])));
				} else {
					return _Utils_Tuple2(model, cmd);
				}
			case 11:
				var _v12 = model.afE;
				if (!_v12.$) {
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2(
									$elm$core$Task$perform,
									function (_v13) {
										return $author$project$Shared$PatientsListMsg($author$project$Components$PatientsList$RefreshPatients);
									},
									$elm$core$Task$succeed(0))
								])));
				} else {
					return _Utils_Tuple2(model, cmd);
				}
			case 12:
				var hinterViewOff = !model.adN;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{adN: hinterViewOff}),
					$author$project$Ports$HinterView$store(hinterViewOff));
			case 13:
				var highlightPhi = !model.mq;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{mq: highlightPhi}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var error = outMsg.a;
				var serverError = $author$project$Ui$Toast$serverError(error);
				return $author$project$Api$Data$clientHasAuthToken(model.D5) ? _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$Session$logout(
								{af6: true}),
								$author$project$Ports$Sentry$captureDebugMessage('Unauthorized request: ' + serverError)
							]))) : _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3($author$project$Shared$showToast, model.adu.acW, 1, serverError)
							])));
			case 15:
				var organizationId = outMsg.a;
				var roleWithPrefix = outMsg.b;
				var postOrganizationSwitchedAction_ = outMsg.c;
				return model.adu.abt ? _Utils_Tuple2(
					model,
					A4(
						$author$project$Api$Auth$switchToOrganization,
						model.D5,
						organizationId,
						roleWithPrefix,
						$author$project$Shared$BackupAuthOrganizationSwitched(postOrganizationSwitchedAction_))) : A3(
					$author$project$Shared$scheduleOrgSwitchRedirect,
					model,
					postOrganizationSwitchedAction_,
					$author$project$Ports$Session$switchTenant(organizationId));
			case 16:
				var id = outMsg.a;
				return A3(
					$author$project$Shared$scheduleOrgSwitchRedirect,
					model,
					$author$project$OutMsg$GoToClinicalAction,
					$author$project$Ports$Session$switchTenant(id));
			case 17:
				var roleWithPrefix = outMsg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A3($author$project$Api$Platform$Session$switchRole, model.D5, roleWithPrefix, $author$project$Shared$GotRoleSwitched)
							])));
			case 4:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								A2($author$project$Api$Platform$Session$retrieve, model.D5, $author$project$Shared$GotSession)
							])));
			case 18:
				var authToken = outMsg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Shared$storeAuthToken, authToken, false),
								$author$project$Ports$Session$authorize(
								{af6: true})
							])));
			case 19:
				return _Utils_Tuple2(
					model,
					$author$project$Ports$Sentry$captureErrorMessage('Bad Gateway error'));
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Shared$updateFromOutMsgs = F2(
	function (msgs, model) {
		return A3(
			$elm$core$List$foldl,
			$author$project$Shared$updateFromOutMsg,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			msgs);
	});
var $author$project$Main$init = function (flags) {
	var _v0 = $author$project$Main$locationHrefToUrl(flags.S2);
	var url = _v0.a;
	var defaultUrlCmd = _v0.b;
	var _v1 = A2($author$project$Shared$init, flags, url);
	var shared = _v1.a;
	var sharedCmd = _v1.b;
	var _v2 = $author$project$Spa$Layout$init(shared);
	var layout = _v2.a;
	var layoutCmd = _v2.b;
	var route = $author$project$Utils$Route$fromUrl(url);
	var _v3 = A2($author$project$Spa$Generated$Pages$init, route, shared);
	var page = _v3.a;
	var pageCmd = _v3.b;
	var outMsgs = _v3.c;
	var _v4 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, shared);
	var newShared = _v4.a;
	var extraSharedCmd = _v4.b;
	return _Utils_Tuple2(
		A5($author$project$Main$Model, newShared, route, page, layout, $jinjor$elm_debounce$Debounce$init),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, extraSharedCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
					A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
					defaultUrlCmd
				])));
};
var $author$project$Main$UrlChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$UrlRequested = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Ports$Navigation$onUrlChange = _Platform_incomingPort('onUrlChange', $elm$json$Json$Decode$string);
var $author$project$Ports$Navigation$navigationPortOnUrlRequest = _Platform_incomingPort(
	'navigationPortOnUrlRequest',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$bool));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$bool));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Ports$Navigation$onUrlRequest = function (toMsg) {
	return $author$project$Ports$Navigation$navigationPortOnUrlRequest(
		function (_v0) {
			var href = _v0.a;
			var isLocal = _v0.b;
			var shouldOpenInNewWindow = _v0.c;
			return A3(toMsg, href, isLocal, shouldOpenInNewWindow);
		});
};
var $author$project$Shared$AccessTokenCreated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Shared$AccessTokenUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Shared$AccountLockedModalMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Shared$GotCurrentTime = function (a) {
	return {$: 7, a: a};
};
var $author$project$Shared$LoggedOut = {$: 18};
var $author$project$Shared$OrganizationSwitcherMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Shared$PendingChangesKeep = {$: 23};
var $author$project$Shared$ShowLogoutWarning = {$: 9};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {W6: processes, $n: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.W6;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.$n);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Ports$Session$NewSession = F2(
	function (accessToken, redirectToURI) {
		return {pi: accessToken, af7: redirectToURI};
	});
var $author$project$Ports$Session$newSessionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'redirectToURI',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'accessToken',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Ports$Session$NewSession)));
var $author$project$Ports$Session$decodeNewSession = function (json) {
	var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$Session$newSessionDecoder, json);
	if (!_v0.$) {
		var newSession = _v0.a;
		return $elm$core$Result$Ok(newSession);
	} else {
		var error = _v0.a;
		return $elm$core$Result$Err(
			$elm$json$Json$Decode$errorToString(error));
	}
};
var $author$project$Ports$Session$onAccessTokenCreatedPort = _Platform_incomingPort('onAccessTokenCreatedPort', $elm$json$Json$Decode$value);
var $author$project$Ports$Session$onAccessTokenCreated = function (toMsg) {
	return $author$project$Ports$Session$onAccessTokenCreatedPort(
		A2($elm$core$Basics$composeL, toMsg, $author$project$Ports$Session$decodeNewSession));
};
var $author$project$Ports$Session$decodeToken = function (json) {
	var _v0 = A2(
		$elm$json$Json$Decode$decodeValue,
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		json);
	if (!_v0.$) {
		var token = _v0.a;
		return $elm$core$Result$Ok(token);
	} else {
		var error = _v0.a;
		return $elm$core$Result$Err(
			$elm$json$Json$Decode$errorToString(error));
	}
};
var $author$project$Ports$Session$onAccessTokenUpdatedPort = _Platform_incomingPort('onAccessTokenUpdatedPort', $elm$json$Json$Decode$value);
var $author$project$Ports$Session$onAccessTokenUpdated = function (toMsg) {
	return $author$project$Ports$Session$onAccessTokenUpdatedPort(
		A2($elm$core$Basics$composeL, toMsg, $author$project$Ports$Session$decodeToken));
};
var $author$project$Ports$Session$onLogoutWarningPort = _Platform_incomingPort(
	'onLogoutWarningPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Session$onLogoutWarning = function (toMsg) {
	return $author$project$Ports$Session$onLogoutWarningPort(
		$elm$core$Basics$always(toMsg));
};
var $author$project$Shared$seconds = function (_float) {
	return _float * 1000;
};
var $author$project$Ports$Session$onSessionLoggedOutPort = _Platform_incomingPort(
	'onSessionLoggedOutPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Session$sessionLoggedOut = function (toMsg) {
	return $author$project$Ports$Session$onSessionLoggedOutPort(
		$elm$core$Basics$always(toMsg));
};
var $author$project$Components$AccountLockedModal$Close = 0;
var $author$project$Components$AccountLockedModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress(0);
var $author$project$Components$GlobalSearch$GlobalSearchTriggered = {$: 0};
var $author$project$Components$GlobalSearch$LoggedOut = {$: 12};
var $author$project$Components$GlobalSearch$ModalCloseClicked = {$: 1};
var $author$project$Ports$GlobalSearch$globalSearchTriggeredPort = _Platform_incomingPort(
	'globalSearchTriggeredPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$GlobalSearch$globalSearchTriggered = function (toMsg) {
	return $author$project$Ports$GlobalSearch$globalSearchTriggeredPort(
		$elm$core$Basics$always(toMsg));
};
var $author$project$Components$GlobalSearch$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Session$sessionLoggedOut($author$project$Components$GlobalSearch$LoggedOut),
				function () {
				if (!model.$) {
					return $author$project$Ports$GlobalSearch$globalSearchTriggered($author$project$Components$GlobalSearch$GlobalSearchTriggered);
				} else {
					return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$GlobalSearch$ModalCloseClicked);
				}
			}()
			]));
};
var $author$project$Components$OrganizationSwitcher$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ui$FlyoutMenu$subscriptions(model.mj),
				$author$project$Ui$Nav$subscriptions(model.m9)
			]));
};
var $author$project$Components$PendingChangesModal$subscriptions = function (keepChangesMsg) {
	return $author$project$Ui$Modal$subscribeToEscapeKeyPress(keepChangesMsg);
};
var $author$project$Navbar$HinterViewUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Navbar$ScreenResized = {$: 5};
var $elm$browser$Browser$Events$Window = 1;
var $elm$browser$Browser$Events$onResize = function (func) {
	return A3(
		$elm$browser$Browser$Events$on,
		1,
		'resize',
		A2(
			$elm$json$Json$Decode$field,
			'target',
			A3(
				$elm$json$Json$Decode$map2,
				func,
				A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
};
var $author$project$Ports$Navbar$sidenavHinterViewUpdatedPort = _Platform_incomingPort('sidenavHinterViewUpdatedPort', $elm$json$Json$Decode$bool);
var $author$project$Ports$Navbar$sidenavHinterViewUpdated = function (toMsg) {
	return $author$project$Ports$Navbar$sidenavHinterViewUpdatedPort(toMsg);
};
var $author$project$Navbars$Company$SidenavLinkClicked = {$: 3};
var $author$project$Ports$Navbar$onSidenavLinkClickedPort = _Platform_incomingPort(
	'onSidenavLinkClickedPort',
	$elm$json$Json$Decode$null(0));
var $author$project$Ports$Navbar$onSidenavLinkClicked = function (toMsg) {
	return $author$project$Ports$Navbar$onSidenavLinkClickedPort(
		$elm$core$Basics$always(toMsg));
};
var $author$project$Navbars$Company$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Company$SidenavLinkClicked),
				$author$project$Ui$FlyoutMenu$subscriptions(model.ep)
			]));
};
var $author$project$Navbars$Partner$SidenavLinkClicked = {$: 3};
var $author$project$Navbars$Partner$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Partner$SidenavLinkClicked),
				$author$project$Ui$FlyoutMenu$subscriptions(model.ep)
			]));
};
var $author$project$Navbars$Practice$CloseModal = {$: 5};
var $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Navbars$Practice$SidenavLinkClicked = {$: 12};
var $author$project$Components$HinterPracticeSettingsModal$CloseModal = {$: 0};
var $author$project$Components$HinterPracticeSettingsModal$subscriptions = function (model) {
	if (model.$ === 1) {
		return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$HinterPracticeSettingsModal$CloseModal);
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Navbars$Practice$subscriptions = function (_v0) {
	var model = _v0;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				model.yj ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Navbars$Practice$CloseModal) : $elm$core$Platform$Sub$none,
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Navbars$Practice$HinterPracticeSettingsModalMsg,
				$author$project$Components$HinterPracticeSettingsModal$subscriptions(model.iO)),
				$author$project$Ui$FlyoutMenu$subscriptions(model.jP),
				$author$project$Ui$FlyoutMenu$subscriptions(model.hr),
				$author$project$Ui$FlyoutMenu$subscriptions(model.ep),
				$author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Practice$SidenavLinkClicked),
				$author$project$Ui$NewDropdown$subscriptions(model.oF)
			]));
};
var $author$project$Navbar$subscriptions = function (_v0) {
	var model = _v0;
	var subs = function () {
		var _v3 = model.ac;
		switch (_v3.$) {
			case 0:
				return $elm$core$Platform$Sub$none;
			case 1:
				var practiceNavModel = _v3.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Navbar$PracticeNavbarMsg,
					$author$project$Navbars$Practice$subscriptions(practiceNavModel));
			case 2:
				var companyNavModel = _v3.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Navbar$CompanyNavbarMsg,
					$author$project$Navbars$Company$subscriptions(companyNavModel));
			default:
				var partnerNavModel = _v3.a;
				return A2(
					$elm$core$Platform$Sub$map,
					$author$project$Navbar$PartnerNavbarMsg,
					$author$project$Navbars$Partner$subscriptions(partnerNavModel));
		}
	}();
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				subs,
				$author$project$Ports$Navbar$sidenavHinterViewUpdated($author$project$Navbar$HinterViewUpdated),
				$elm$browser$Browser$Events$onResize(
				F2(
					function (_v1, _v2) {
						return $author$project$Navbar$ScreenResized;
					}))
			]));
};
var $author$project$Shared$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Session$onAccessTokenUpdated($author$project$Shared$AccessTokenUpdated),
				$author$project$Ports$Session$onAccessTokenCreated($author$project$Shared$AccessTokenCreated),
				A2(
				$elm$time$Time$every,
				$author$project$Shared$seconds(1),
				$author$project$Shared$GotCurrentTime),
				$author$project$Ports$Session$onLogoutWarning($author$project$Shared$ShowLogoutWarning),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Shared$GlobalSearchMsg,
				$author$project$Components$GlobalSearch$subscriptions(model.fJ)),
				A2($elm$core$Platform$Sub$map, $author$project$Shared$AccountLockedModalMsg, $author$project$Components$AccountLockedModal$subscriptions),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Navbar$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Shared$NavbarMsg)),
					model.ad)),
				$author$project$Ports$Session$sessionLoggedOut($author$project$Shared$LoggedOut),
				$author$project$Components$PendingChangesModal$subscriptions($author$project$Shared$PendingChangesKeep),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$PatientsList$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Shared$PatientsListMsg)),
					model.afE)),
				A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Components$OrganizationSwitcher$subscriptions,
						$elm$core$Platform$Sub$map($author$project$Shared$OrganizationSwitcherMsg)),
					model.ga))
			]));
};
var $author$project$Spa$Generated$Pages$bundle = function (bigModel) {
	switch (bigModel.$) {
		case 0:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dv.a(model);
		case 1:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tE.a(model);
		case 2:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vH.a(model);
		case 3:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vP.a(model);
		case 4:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ao.a(model);
		case 5:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.x$.a(model);
		case 6:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yD.a(model);
		case 7:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yE.a(model);
		case 8:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.rA.a(model);
		case 9:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zX.a(model);
		case 10:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u6.a(model);
		case 11:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vi.a(model);
		case 12:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wG.a(model);
		case 13:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xG.a(model);
		case 14:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yP.a(model);
		case 15:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AG.a(model);
		case 16:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A5.a(model);
		case 17:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dc.a(model);
		case 18:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dp.a(model);
		case 19:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tN.a(model);
		case 20:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tU.a(model);
		case 21:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tW.a(model);
		case 22:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tX.a(model);
		case 23:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tY.a(model);
		case 24:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t1.a(model);
		case 25:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t5.a(model);
		case 26:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t9.a(model);
		case 27:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.un.a(model);
		case 28:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.us.a(model);
		case 29:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ut.a(model);
		case 30:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uv.a(model);
		case 31:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uw.a(model);
		case 32:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ux.a(model);
		case 33:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uy.a(model);
		case 34:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uz.a(model);
		case 35:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uA.a(model);
		case 36:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uI.a(model);
		case 37:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uJ.a(model);
		case 38:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uL.a(model);
		case 39:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uM.a(model);
		case 40:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uS.a(model);
		case 41:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uT.a(model);
		case 42:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uX.a(model);
		case 43:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uY.a(model);
		case 44:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uZ.a(model);
		case 45:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u1.a(model);
		case 46:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u2.a(model);
		case 47:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u3.a(model);
		case 48:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vg.a(model);
		case 49:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vh.a(model);
		case 50:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v0.a(model);
		case 51:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wl.a(model);
		case 52:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wF.a(model);
		case 53:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wJ.a(model);
		case 54:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wK.a(model);
		case 55:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xF.a(model);
		case 56:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xV.a(model);
		case 57:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xW.a(model);
		case 58:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xX.a(model);
		case 59:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xY.a(model);
		case 60:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xZ.a(model);
		case 61:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.x_.a(model);
		case 62:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yc.a(model);
		case 63:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yd.a(model);
		case 64:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ye.a(model);
		case 65:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yK.a(model);
		case 66:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yX.a(model);
		case 67:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yY.a(model);
		case 68:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.y$.a(model);
		case 69:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.y0.a(model);
		case 70:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.y1.a(model);
		case 71:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.y5.a(model);
		case 72:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zn.a(model);
		case 73:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zo.a(model);
		case 74:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zr.a(model);
		case 75:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zs.a(model);
		case 76:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zF.a(model);
		case 77:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z6.a(model);
		case 78:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z7.a(model);
		case 79:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Aa.a(model);
		case 80:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ab.a(model);
		case 81:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ad.a(model);
		case 82:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Aj.a(model);
		case 83:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ak.a(model);
		case 84:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Aq.a(model);
		case 85:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AH.a(model);
		case 86:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AX.a(model);
		case 87:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AY.a(model);
		case 88:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AZ.a(model);
		case 89:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A_.a(model);
		case 90:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A$.a(model);
		case 91:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A0.a(model);
		case 92:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A1.a(model);
		case 93:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A4.a(model);
		case 94:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bv.a(model);
		case 95:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bw.a(model);
		case 96:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.By.a(model);
		case 97:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BC.a(model);
		case 98:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BD.a(model);
		case 99:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BF.a(model);
		case 100:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BG.a(model);
		case 101:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BH.a(model);
		case 102:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BI.a(model);
		case 103:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BJ.a(model);
		case 104:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BK.a(model);
		case 105:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BM.a(model);
		case 106:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BO.a(model);
		case 107:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BQ.a(model);
		case 108:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cx.a(model);
		case 109:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cy.a(model);
		case 110:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Cz.a(model);
		case 111:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CA.a(model);
		case 112:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CB.a(model);
		case 113:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CC.a(model);
		case 114:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CD.a(model);
		case 115:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CE.a(model);
		case 116:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CF.a(model);
		case 117:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CG.a(model);
		case 118:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CH.a(model);
		case 119:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CI.a(model);
		case 120:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CJ.a(model);
		case 121:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CK.a(model);
		case 122:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CL.a(model);
		case 123:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CM.a(model);
		case 124:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CN.a(model);
		case 125:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CO.a(model);
		case 126:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CP.a(model);
		case 127:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CQ.a(model);
		case 128:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CR.a(model);
		case 129:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CS.a(model);
		case 130:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CT.a(model);
		case 131:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CU.a(model);
		case 132:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CV.a(model);
		case 133:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CW.a(model);
		case 134:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CX.a(model);
		case 135:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CY.a(model);
		case 136:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.CZ.a(model);
		case 137:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C_.a(model);
		case 138:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C$.a(model);
		case 139:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C0.a(model);
		case 140:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C1.a(model);
		case 141:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C2.a(model);
		case 142:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C3.a(model);
		case 143:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C4.a(model);
		case 144:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C5.a(model);
		case 145:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C6.a(model);
		case 146:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C7.a(model);
		case 147:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C8.a(model);
		case 148:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.C9.a(model);
		case 149:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Da.a(model);
		case 150:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Db.a(model);
		case 151:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dd.a(model);
		case 152:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.De.a(model);
		case 153:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Df.a(model);
		case 154:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dg.a(model);
		case 155:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Di.a(model);
		case 156:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Dn.a(model);
		case 157:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DG.a(model);
		case 158:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DH.a(model);
		case 159:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DJ.a(model);
		case 160:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DK.a(model);
		case 161:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vr.a(model);
		case 162:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xt.a(model);
		case 163:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yp.a(model);
		case 164:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yL.a(model);
		case 165:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tT.a(model);
		case 166:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t$.a(model);
		case 167:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t4.a(model);
		case 168:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t8.a(model);
		case 169:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uf.a(model);
		case 170:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ud.a(model);
		case 171:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.um.a(model);
		case 172:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ur.a(model);
		case 173:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uR.a(model);
		case 174:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uU.a(model);
		case 175:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uW.a(model);
		case 176:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u0.a(model);
		case 177:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wi.a(model);
		case 178:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wk.a(model);
		case 179:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wB.a(model);
		case 180:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wI.a(model);
		case 181:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xU.a(model);
		case 182:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yb.a(model);
		case 183:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.y_.a(model);
		case 184:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.y4.a(model);
		case 185:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zm.a(model);
		case 186:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zq.a(model);
		case 187:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zx.a(model);
		case 188:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zS.a(model);
		case 189:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z9.a(model);
		case 190:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ac.a(model);
		case 191:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ai.a(model);
		case 192:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AF.a(model);
		case 193:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bu.a(model);
		case 194:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Do.a(model);
		case 195:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.DI.a(model);
		case 196:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tO.a(model);
		case 197:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tP.a(model);
		case 198:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tQ.a(model);
		case 199:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tR.a(model);
		case 200:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tS.a(model);
		case 201:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t_.a(model);
		case 202:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t0.a(model);
		case 203:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t3.a(model);
		case 204:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t7.a(model);
		case 205:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ua.a(model);
		case 206:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uc.a(model);
		case 207:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ug.a(model);
		case 208:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uh.a(model);
		case 209:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ui.a(model);
		case 210:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uj.a(model);
		case 211:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ul.a(model);
		case 212:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uo.a(model);
		case 213:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.up.a(model);
		case 214:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uq.a(model);
		case 215:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uB.a(model);
		case 216:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uC.a(model);
		case 217:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uD.a(model);
		case 218:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uE.a(model);
		case 219:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uG.a(model);
		case 220:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uH.a(model);
		case 221:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uK.a(model);
		case 222:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uQ.a(model);
		case 223:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uV.a(model);
		case 224:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u$.a(model);
		case 225:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u4.a(model);
		case 226:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u8.a(model);
		case 227:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vb.a(model);
		case 228:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vc.a(model);
		case 229:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vd.a(model);
		case 230:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ve.a(model);
		case 231:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.vf.a(model);
		case 232:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wh.a(model);
		case 233:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wj.a(model);
		case 234:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wm.a(model);
		case 235:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wn.a(model);
		case 236:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wr.a(model);
		case 237:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ws.a(model);
		case 238:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wv.a(model);
		case 239:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ww.a(model);
		case 240:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wx.a(model);
		case 241:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wy.a(model);
		case 242:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yZ.a(model);
		case 243:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.y2.a(model);
		case 244:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zl.a(model);
		case 245:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zv.a(model);
		case 246:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zT.a(model);
		case 247:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zU.a(model);
		case 248:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zV.a(model);
		case 249:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zW.a(model);
		case 250:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.z8.a(model);
		case 251:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ae.a(model);
		case 252:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Af.a(model);
		case 253:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ag.a(model);
		case 254:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ah.a(model);
		case 255:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Aw.a(model);
		case 256:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ax.a(model);
		case 257:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ay.a(model);
		case 258:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AC.a(model);
		case 259:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A3.a(model);
		case 260:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bx.a(model);
		case 261:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bz.a(model);
		case 262:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BB.a(model);
		case 263:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BE.a(model);
		case 264:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BL.a(model);
		case 265:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BN.a(model);
		case 266:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BP.a(model);
		case 267:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tZ.a(model);
		case 268:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t2.a(model);
		case 269:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.t6.a(model);
		case 270:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ue.a(model);
		case 271:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.ub.a(model);
		case 272:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uk.a(model);
		case 273:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uu.a(model);
		case 274:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uN.a(model);
		case 275:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u_.a(model);
		case 276:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.xT.a(model);
		case 277:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zk.a(model);
		case 278:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zp.a(model);
		case 279:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zt.a(model);
		case 280:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zw.a(model);
		case 281:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Bt.a(model);
		case 282:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.BA.a(model);
		case 283:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.va.a(model);
		case 284:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wg.a(model);
		case 285:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wq.a(model);
		case 286:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wu.a(model);
		case 287:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wC.a(model);
		case 288:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.y3.a(model);
		case 289:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Ar.a(model);
		case 290:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.As.a(model);
		case 291:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Av.a(model);
		case 292:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AB.a(model);
		case 293:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AD.a(model);
		case 294:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AE.a(model);
		case 295:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uF.a(model);
		case 296:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wc.a(model);
		case 297:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wd.a(model);
		case 298:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wo.a(model);
		case 299:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wA.a(model);
		case 300:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yJ.a(model);
		case 301:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yM.a(model);
		case 302:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yN.a(model);
		case 303:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.yO.a(model);
		case 304:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.zu.a(model);
		case 305:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.AA.a(model);
		case 306:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.A2.a(model);
		case 307:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.tV.a(model);
		case 308:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.u9.a(model);
		case 309:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wt.a(model);
		case 310:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wz.a(model);
		case 311:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wb.a(model);
		case 312:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wf.a(model);
		case 313:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wD.a(model);
		case 314:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.At.a(model);
		case 315:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Au.a(model);
		case 316:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.Az.a(model);
		case 317:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uO.a(model);
		case 318:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v9.a(model);
		case 319:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wa.a(model);
		case 320:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wE.a(model);
		case 321:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.uP.a(model);
		case 322:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.we.a(model);
		case 323:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.v8.a(model);
		default:
			var model = bigModel.a;
			return $author$project$Spa$Generated$Pages$pages.wp.a(model);
	}
};
var $author$project$Spa$Generated$Pages$subscriptions = function (model) {
	return $author$project$Spa$Generated$Pages$bundle(model).ahd(0);
};
var $author$project$Layouts$Admin$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Affiliates$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Affiliates$Affiliate$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Commissions$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Commissions$BrokerAccount$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Company$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Marketplace$Manage$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Partner$Billing$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Partner$Practices$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Partner$Product$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$Patient$subscriptions = function (model) {
	return $author$project$Ui$Nav$subscriptions(model.m8);
};
var $author$project$Layouts$PatientChart$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Layouts$User$subscriptions = function (_v0) {
	var nav = _v0.m8;
	return $author$project$Ui$Nav$subscriptions(nav);
};
var $author$project$Spa$Layout$subscriptions = function (model) {
	switch (model.$) {
		case 0:
			return $elm$core$Platform$Sub$none;
		case 1:
			return $elm$core$Platform$Sub$none;
		case 2:
			return $elm$core$Platform$Sub$none;
		case 3:
			var patientModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PatientMsg,
				$author$project$Layouts$Patient$subscriptions(patientModel));
		case 4:
			var commissionsModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$CommissionsMsg,
				$author$project$Layouts$Commissions$subscriptions(commissionsModel));
		case 5:
			var brokerAccountModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$CommissionsBrokerAccountMsg,
				$author$project$Layouts$Commissions$BrokerAccount$subscriptions(brokerAccountModel));
		case 6:
			var affiliatesModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$AffiliatesMsg,
				$author$project$Layouts$Affiliates$subscriptions(affiliatesModel));
		case 19:
			return $elm$core$Platform$Sub$none;
		case 7:
			var affiliateModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$AffiliatesAffiliateMsg,
				$author$project$Layouts$Affiliates$Affiliate$subscriptions(affiliateModel));
		case 8:
			var billingModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PartnerBillingMsg,
				$author$project$Layouts$Partner$Billing$subscriptions(billingModel));
		case 9:
			var practicesModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PartnerPracticesMsg,
				$author$project$Layouts$Partner$Practices$subscriptions(practicesModel));
		case 10:
			var productModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$PartnerProductMsg,
				$author$project$Layouts$Partner$Product$subscriptions(productModel));
		case 11:
			var manageModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$MarketplaceManageMsg,
				$author$project$Layouts$Marketplace$Manage$subscriptions(manageModel));
		case 12:
			var companyModel = model.b;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$CompanyMsg,
				$author$project$Layouts$Company$subscriptions(companyModel));
		case 13:
			var adminModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$AdminMsg,
				$author$project$Layouts$Admin$subscriptions(adminModel));
		case 14:
			return $elm$core$Platform$Sub$none;
		case 15:
			return $elm$core$Platform$Sub$none;
		case 16:
			var patientChartModel = model.b;
			return $author$project$Layouts$PatientChart$subscriptions(patientChartModel);
		case 17:
			return $elm$core$Platform$Sub$none;
		default:
			var userModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Spa$Layout$UserMsg,
				$author$project$Layouts$User$subscriptions(userModel));
	}
};
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$Navigation$onUrlChange($author$project$Main$UrlChanged),
				$author$project$Ports$Navigation$onUrlRequest($author$project$Main$UrlRequested),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$Shared,
				$author$project$Shared$subscriptions(model.Cd)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$Pages,
				$author$project$Spa$Generated$Pages$subscriptions(model.Gy)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$Layout,
				$author$project$Spa$Layout$subscriptions(model.a6))
			]));
};
var $author$project$Spa$Document$toBrowserElement = function (doc) {
	return A2($elm$html$Html$div, _List_Nil, doc.e5);
};
var $author$project$Main$RequestLoadClinical = {$: 6};
var $author$project$Main$AttemptedScrollingToFragment = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
var $author$project$Utils$Scroll$toElementByIdWithDelay = F3(
	function (delay, elementId, toMsg) {
		return A2(
			$elm$core$Task$attempt,
			toMsg,
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					var element = _v1.acU;
					return A2($elm$browser$Browser$Dom$setViewport, 0, element.aa5);
				},
				A2(
					$elm$core$Task$andThen,
					function (_v0) {
						return $elm$browser$Browser$Dom$getElement(elementId);
					},
					$elm$core$Process$sleep(delay))));
	});
var $author$project$Main$attemptScrollingToFragment = F2(
	function (attempts, fragment) {
		return (attempts > 3) ? $elm$core$Platform$Cmd$none : A3(
			$author$project$Utils$Scroll$toElementByIdWithDelay,
			500,
			fragment,
			A2($author$project$Main$AttemptedScrollingToFragment, attempts + 1, fragment));
	});
var $author$project$Ports$Clinical$dispatchLoadClinicalPort = _Platform_outgoingPort(
	'dispatchLoadClinicalPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Clinical$load = $author$project$Ports$Clinical$dispatchLoadClinicalPort(0);
var $author$project$Spa$Generated$Pages$load = function (model) {
	return $author$project$Spa$Generated$Pages$bundle(model).aer(0);
};
var $author$project$Main$LoadClinicalDebounceMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$loadClinicalDebounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(300),
	ahG: $author$project$Main$LoadClinicalDebounceMsg
};
var $author$project$Spa$Generated$Pages$save = function (model) {
	return $author$project$Spa$Generated$Pages$bundle(model).agD(0);
};
var $author$project$Shared$Company = function (a) {
	return {$: 1, a: a};
};
var $author$project$Shared$GotSessionCreated = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Shared$GotUserPractices = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Shared$Patient = function (a) {
	return {$: 0, a: a};
};
var $author$project$Shared$GotWhitelabelSetting = function (a) {
	return {$: 25, a: a};
};
var $author$project$Shared$retrieveWhitelabelSettings = F2(
	function (apiClient, session) {
		return A3($author$project$Api$WhitelabelSetting$retrieve, apiClient, session, $author$project$Shared$GotWhitelabelSetting);
	});
var $author$project$Shared$transitionToAuthenticatedDefaultState = F3(
	function (session, hinterViewOff, reload) {
		return (reload ? $author$project$Utils$Route$navigateAndReload($elm$core$Dict$empty) : $author$project$Utils$Route$navigate($elm$core$Dict$empty))(
			A2($author$project$Permission$homeStateFor, session, hinterViewOff));
	});
var $author$project$Shared$switchToOrganizationRedirect = F3(
	function (session, hinterViewOff, postOrganizationSwitchedAction_) {
		var _v0 = _Utils_Tuple2(session, postOrganizationSwitchedAction_);
		_v0$5:
		while (true) {
			if (_v0.a.$ === 3) {
				switch (_v0.b.$) {
					case 1:
						var _v1 = _v0.a;
						var session_ = _v1.a;
						var _v2 = _v0.b;
						return A3($author$project$Shared$transitionToAuthenticatedDefaultState, session_, hinterViewOff, false);
					case 4:
						var _v3 = _v0.a;
						var session_ = _v3.a;
						var _v4 = _v0.b;
						return A3($author$project$Shared$transitionToAuthenticatedDefaultState, session_, hinterViewOff, true);
					case 2:
						var _v5 = _v0.a;
						var route = _v0.b.a;
						return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, route);
					case 3:
						var _v6 = _v0.a;
						var route = _v0.b.a;
						return A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, route);
					case 0:
						var _v7 = _v0.a;
						var _v8 = _v0.b;
						return $elm$core$Platform$Cmd$none;
					default:
						break _v0$5;
				}
			} else {
				break _v0$5;
			}
		}
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Shared$applySession = F4(
	function (response, session, model, extraCmd) {
		var retrieveCompanyCmd = function () {
			var _v0 = model.n0;
			if (!_v0.$) {
				var companyId = _v0.a;
				return A4(
					$author$project$Api$Company$retrieve,
					model.D5,
					session,
					companyId,
					$author$project$Shared$GotCompany(companyId));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		var isClinicalSwitch = model.gU && _Utils_eq(model.ej, $author$project$OutMsg$GoToClinicalAction);
		var orgSwitchRedirectCmd = (model.gU && (!isClinicalSwitch)) ? A3($author$project$Shared$switchToOrganizationRedirect, response, model.adN, model.ej) : $elm$core$Platform$Cmd$none;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					afu: $author$project$Api$Platform$Session$One$organizationIsCompany(session),
					ej: isClinicalSwitch ? $author$project$OutMsg$GoToClinicalAction : $author$project$OutMsg$NoAction,
					n0: $elm$core$Maybe$Nothing,
					ZD: response,
					gU: false
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						extraCmd,
						$author$project$Api$Platform$Session$One$organizationIsPartner(session) ? $author$project$Shared$retrievePartner(model.D5) : $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Shared$retrievePractice, model.D5, session),
								A2($author$project$Shared$retrieveWhitelabelSettings, model.D5, session)
							])),
						retrieveCompanyCmd,
						orgSwitchRedirectCmd
					])));
	});
var $author$project$Ports$Intercom$intercomPortShutdown = _Platform_outgoingPort(
	'intercomPortShutdown',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Intercom$shutdown = $author$project$Ports$Intercom$intercomPortShutdown(0);
var $author$project$Shared$deidentifyForIntercom = $author$project$Ports$Intercom$shutdown;
var $author$project$Ports$FullStory$fullStoryPortStopCapturing = _Platform_outgoingPort(
	'fullStoryPortStopCapturing',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$FullStory$shutdown = $author$project$Ports$FullStory$fullStoryPortStopCapturing(0);
var $author$project$Shared$deidentifyForSessionRecording = $author$project$Ports$FullStory$shutdown;
var $author$project$Shared$deidentifyOnExternalServices = $elm$core$Platform$Cmd$batch(
	_List_fromArray(
		[$author$project$Shared$deidentifyForIntercom, $author$project$Shared$deidentifyForSessionRecording]));
var $author$project$Ports$GlobalSearch$enableGlobalSearchShortcutPort = _Platform_outgoingPort(
	'enableGlobalSearchShortcutPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$GlobalSearch$enableCoreGlobalSearchShortcut = $author$project$Ports$GlobalSearch$enableGlobalSearchShortcutPort(0);
var $author$project$Shared$shouldEmbedClinical = function (practice) {
	if (practice.$ === 3) {
		var practice_ = practice.a;
		return $author$project$Api$Practice$hasClinicalAccount(practice_) && A2($author$project$Api$Practice$featureEnabled, 19, practice_);
	} else {
		return false;
	}
};
var $author$project$Shared$enableCoreGlobalSearchShortcutFn = function (_v0) {
	var model = _v0.a;
	var msg = _v0.b;
	return $author$project$Shared$shouldEmbedClinical(model.WF) ? _Utils_Tuple2(model, msg) : _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[msg, $author$project$Ports$GlobalSearch$enableCoreGlobalSearchShortcut])));
};
var $author$project$Navbars$Company$extractOrgSwitcherMsg = function (msg) {
	if (msg.$ === 5) {
		var subMsg = msg.a;
		return $elm$core$Maybe$Just(subMsg);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbars$Partner$extractOrgSwitcherMsg = function (msg) {
	if (msg.$ === 5) {
		var subMsg = msg.a;
		return $elm$core$Maybe$Just(subMsg);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbars$Practice$extractOrgSwitcherMsg = function (msg) {
	if (msg.$ === 19) {
		var subMsg = msg.a;
		return $elm$core$Maybe$Just(subMsg);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Navbar$extractOrgSwitcherMsg = function (msg) {
	switch (msg.$) {
		case 0:
			var subMsg = msg.a;
			return $author$project$Navbars$Practice$extractOrgSwitcherMsg(subMsg);
		case 1:
			var subMsg = msg.a;
			return $author$project$Navbars$Company$extractOrgSwitcherMsg(subMsg);
		case 2:
			var subMsg = msg.a;
			return $author$project$Navbars$Partner$extractOrgSwitcherMsg(subMsg);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$Clinical$getDashboardUrl = F3(
	function (isUnifiedExperience, origin, emrHost) {
		return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + '/home';
	});
var $author$project$Shared$emrDashboardUrl = F3(
	function (practice, origin, emrHost) {
		var isUnifiedExperience = A2($author$project$Api$Practice$featureEnabled, 19, practice);
		return A3($author$project$Utils$Clinical$getDashboardUrl, isUnifiedExperience, origin, emrHost);
	});
var $author$project$Shared$handlePendingClinicalRedirect = F2(
	function (response, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = _Utils_Tuple3(model.ej, model.gU, response);
		if (((_v1.a.$ === 5) && (!_v1.b)) && (_v1.c.$ === 3)) {
			var _v2 = _v1.a;
			var _v3 = _v1.c;
			var practice = _v3.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{ej: $author$project$OutMsg$NoAction}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A3(
							$author$project$Ports$Navigation$requestUrl,
							A3($author$project$Shared$emrDashboardUrl, practice, model.adu.afw, model.adu.acZ),
							false,
							false)
						])));
		} else {
			return _Utils_Tuple2(model, cmd);
		}
	});
var $author$project$Ports$Intercom$intercomPortBoot = _Platform_outgoingPort('intercomPortBoot', $elm$core$Basics$identity);
var $author$project$Api$Platform$User$Shared$intercomUserHash = function (_v0) {
	var record = _v0;
	return record.Re;
};
var $author$project$Utils$User$isHinter = function (user) {
	return $author$project$Api$Platform$User$Shared$isAdmin(user) || A2(
		$author$project$Utils$Regex$matches,
		'@hint\\.com$',
		$author$project$Api$Platform$User$Shared$email(user));
};
var $author$project$Ports$Intercom$boot = F3(
	function (intercomAppId, session, practice) {
		var user = $author$project$Api$Platform$Session$One$user(session);
		var userAttrs = _List_fromArray(
			[
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$string(
					$author$project$Api$Platform$User$Shared$id(user))),
				_Utils_Tuple2(
				'user_hash',
				$elm$json$Json$Encode$string(
					$author$project$Api$Platform$User$Shared$intercomUserHash(user)))
			]);
		var practiceAttrs = $author$project$Utils$User$isHinter(user) ? _List_Nil : _List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Api$Practice$id(practice)))
			]);
		var encoded = $elm$json$Json$Encode$object(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'app_id',
					$elm$json$Json$Encode$string(intercomAppId)),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'company',
						$elm$json$Json$Encode$object(practiceAttrs)),
					userAttrs)));
		return $author$project$Ports$Intercom$intercomPortBoot(encoded);
	});
var $author$project$Shared$identifyForIntercom = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					function () {
					var _v1 = _Utils_Tuple3(model.adu.ad2, model.ZD, model.WF);
					if (((!_v1.a.$) && (_v1.b.$ === 3)) && (_v1.c.$ === 3)) {
						var intercomAppId = _v1.a.a;
						var _v2 = _v1.b;
						var session = _v2.a;
						var _v3 = _v1.c;
						var practice = _v3.a;
						return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Ports$Intercom$shutdown : A3($author$project$Ports$Intercom$boot, intercomAppId, session, practice);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}()
				])));
};
var $author$project$Api$Provider$Practice$Shared$createdAt = function (_v0) {
	var record = _v0;
	return record.Mf;
};
var $author$project$Api$Provider$Practice$One$createdAt = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Practice$Shared$createdAt(shared);
};
var $author$project$Api$Practice$createdAt = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $elm$core$Maybe$Just(
			$author$project$Api$Provider$Practice$One$createdAt(practice_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$Release$currentRelease = function (_v0) {
	var model = _v0;
	var _v1 = model.EO;
	if (_v1 === '') {
		return $elm$core$Maybe$Nothing;
	} else {
		var rest = _v1;
		return $elm$core$Maybe$Just(rest);
	}
};
var $author$project$Api$Employer$Practice$One$email = function (_v0) {
	var record = _v0;
	return record.Oo;
};
var $author$project$Api$Practice$email = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$email(practice_);
	} else {
		var practice_ = practice.a;
		return $author$project$Api$Employer$Practice$One$email(practice_);
	}
};
var $author$project$Ports$FullStory$fullStoryPortBoot = _Platform_outgoingPort(
	'fullStoryPortBoot',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$core$Basics$identity(b)
				]));
	});
var $author$project$Ports$FullStory$boot = F3(
	function (session, practice, release) {
		var user = $author$project$Api$Platform$Session$One$user(session);
		var organizationAttrs = function () {
			var _v0 = $author$project$Api$Platform$Session$One$organization(session);
			if (!_v0.$) {
				var organization = _v0.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'organization_type',
						$elm$json$Json$Encode$string(
							$author$project$Api$OrganizationType$toString(
								$author$project$Api$Platform$Organization$Shared$type_(organization)))),
						_Utils_Tuple2(
						'organization_id',
						$elm$json$Json$Encode$string(
							$author$project$Api$Platform$Organization$Shared$id(organization)))
					]);
			} else {
				return _List_Nil;
			}
		}();
		var defaultAttrs = _List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(
					$author$project$Api$Platform$User$Shared$email(user))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(
					$author$project$Api$Platform$User$Shared$name(user))),
				_Utils_Tuple2(
				'practice_id',
				$elm$json$Json$Encode$string(
					$author$project$Api$Practice$id(practice))),
				_Utils_Tuple2(
				'practice_name',
				$elm$json$Json$Encode$string(
					$author$project$Api$Practice$name(practice))),
				_Utils_Tuple2(
				'practice_created_at',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$int,
					A2(
						$elm$core$Maybe$map,
						$elm$time$Time$posixToMillis,
						$author$project$Api$Practice$createdAt(practice)))),
				_Utils_Tuple2(
				'practice_email',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$string,
					$author$project$Api$Practice$email(practice))),
				_Utils_Tuple2(
				'practice_has_stripe_account',
				$elm$json$Json$Encode$bool(
					($author$project$Api$Practice$paymentProcessor(practice) === 'stripe') && $author$project$Api$Practice$hasPaymentProcessorAccount(practice))),
				_Utils_Tuple2(
				'practice_has_payment_processor_account',
				$elm$json$Json$Encode$bool(
					$author$project$Api$Practice$hasPaymentProcessorAccount(practice))),
				_Utils_Tuple2(
				'payment_processor',
				$elm$json$Json$Encode$string(
					$author$project$Api$Practice$paymentProcessor(practice))),
				_Utils_Tuple2(
				'soft_version',
				A2(
					$author$project$Utils$Encode$nullable,
					$elm$json$Json$Encode$string,
					$author$project$Utils$Release$currentRelease(release)))
			]);
		var userAttrs = $elm$json$Json$Encode$object(
			_Utils_ap(defaultAttrs, organizationAttrs));
		return $author$project$Ports$FullStory$fullStoryPortBoot(
			_Utils_Tuple2(
				$author$project$Api$Platform$User$Shared$id(user),
				userAttrs));
	});
var $author$project$Ports$Sentry$sentrySetContext = _Platform_outgoingPort('sentrySetContext', $elm$core$Basics$identity);
var $author$project$Ports$Sentry$setContext = F2(
	function (user, practice) {
		var contextAttrs = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'user_id',
					$elm$json$Json$Encode$string(
						$author$project$Api$Platform$User$Shared$id(user))),
					_Utils_Tuple2(
					'practice_id',
					$elm$json$Json$Encode$string(
						$author$project$Api$Practice$id(practice)))
				]));
		return $author$project$Ports$Sentry$sentrySetContext(contextAttrs);
	});
var $author$project$Shared$identifyForSessionRecording = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = _Utils_Tuple2(model.ZD, model.WF);
	if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
		var _v2 = _v1.a;
		var session = _v2.a;
		var _v3 = _v1.b;
		var practice = _v3.a;
		var user = $author$project$Api$Platform$Session$One$user(session);
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A3($author$project$Ports$FullStory$boot, session, practice, model.agf),
						A2($author$project$Ports$Sentry$setContext, user, practice)
					])));
	} else {
		return _Utils_Tuple2(model, cmd);
	}
};
var $author$project$Shared$identifyOnExternalServices = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return $author$project$Shared$identifyForSessionRecording(
		$author$project$Shared$identifyForIntercom(
			_Utils_Tuple2(model, cmd)));
};
var $author$project$Components$OrganizationSwitcher$FlyoutMenuMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$OrganizationSwitcher$GotOrganizations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$OrganizationSwitcher$Live = 0;
var $author$project$Components$OrganizationSwitcher$Model = $elm$core$Basics$identity;
var $author$project$Components$OrganizationSwitcher$NavMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$OrganizationSwitcher$Sandbox = 1;
var $author$project$Api$Platform$User$Organization$Organization = $elm$core$Basics$identity;
var $author$project$Api$Platform$User$Organization$Record = F5(
	function (id, name, organizationId, type_, sandbox) {
		return {adR: id, zh: name, aft: organizationId, Y$: sandbox, ahI: type_};
	});
var $author$project$Api$Platform$User$Organization$decoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sandbox',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$author$project$Api$OrganizationType$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'organization_id',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Platform$User$Organization$Record)))))));
var $author$project$Api$Platform$User$Organization$organizationsPath = A2(
	$author$project$Api$Data$pathAppend,
	_List_fromArray(
		['organizations']),
	$author$project$Api$Platform$User$userPath);
var $author$project$Api$Platform$User$Organization$list = F2(
	function (apiClient, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Platform$User$Organization$decoder),
			toMsg,
			$author$project$Api$Data$requestTo($author$project$Api$Platform$User$Organization$organizationsPath));
	});
var $author$project$Components$OrganizationSwitcher$init = F2(
	function (apiClient, options) {
		var _v0 = A2($author$project$Ui$Nav$init, 'org-switcher-nav', $author$project$Components$OrganizationSwitcher$NavMsg);
		var navModel = _v0.a;
		var navCmd = _v0.b;
		return _Utils_Tuple2(
			{
				qz: options.Y$ ? 1 : 0,
				mj: A2($author$project$Ui$FlyoutMenu$init, 'org-switcher', $author$project$Components$OrganizationSwitcher$FlyoutMenuMsg),
				m9: navModel,
				rJ: $author$project$Api$Data$Loading
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Platform$User$Organization$list, apiClient, $author$project$Components$OrganizationSwitcher$GotOrganizations),
						navCmd
					])));
	});
var $author$project$Shared$initializePatientsList = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var _v1 = model.afE;
	if (_v1.$ === 1) {
		var _v2 = _Utils_Tuple3(model.ZD, model.WF, model.qV);
		if ((((_v2.a.$ === 3) && (_v2.b.$ === 3)) && (!_v2.b.a.$)) && (!_v2.c.$)) {
			var _v3 = _v2.a;
			var session = _v3.a;
			var _v4 = _v2.b;
			var practice = _v4.a.a;
			var query = _v2.c.a;
			var _v5 = A4(
				$author$project$Components$PatientsList$init,
				session,
				practice,
				model.lG,
				{D5: model.D5, Bi: query, Hy: model.Hy, Hz: model.Hz, aav: model.aav});
			var patientsListModel = _v5.a;
			var patientsListCmd = _v5.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						qV: $elm$core$Maybe$Nothing,
						afE: $elm$core$Maybe$Just(patientsListModel)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							cmd,
							A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, patientsListCmd)
						])));
		} else {
			return _Utils_Tuple2(model, cmd);
		}
	} else {
		return _Utils_Tuple2(model, cmd);
	}
};
var $author$project$Shared$navigateToErrorPage = function (error) {
	return A2(
		$author$project$Utils$Route$navigate,
		$elm$core$Dict$empty,
		$author$project$Spa$Generated$Route$Error__Status_String(
			{
				ag7: $author$project$Api$Data$errorToStatus(error)
			}));
};
var $author$project$Utils$Route$navigateWithFragment = F3(
	function (params, fragment, route) {
		return $author$project$Ports$Navigation$pushUrl(
			_Utils_ap(
				A2($author$project$Utils$Route$toString, params, route),
				A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function (f) {
							return '#' + f;
						},
						fragment))));
	});
var $author$project$Shared$postOrganizationSwitchedAction = function (switchOrganizationFrom) {
	return $author$project$OutMsg$GoToRouteAndReloadAction(
		function () {
			switch (switchOrganizationFrom.$) {
				case 0:
					var id = switchOrganizationFrom.a;
					return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
						{VN: id});
				case 1:
					var id = switchOrganizationFrom.a;
					return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
						{ff: id});
				case 2:
					var route = switchOrganizationFrom.a;
					return route;
				default:
					var route = switchOrganizationFrom.a;
					return route;
			}
		}());
};
var $author$project$Shared$practiceChanged = F2(
	function (oldPractice, newPractice) {
		var _v0 = _Utils_Tuple2(oldPractice, newPractice);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					return !_Utils_eq(
						$author$project$Api$Practice$id(oldPractice),
						$author$project$Api$Practice$id(newPractice));
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b.$ === 1) {
					return !_Utils_eq(
						$author$project$Api$Practice$id(oldPractice),
						$author$project$Api$Practice$id(newPractice));
				} else {
					break _v0$2;
				}
			}
		}
		return true;
	});
var $author$project$Shared$requestLoadEmbeddedClinical = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	return $author$project$Shared$shouldEmbedClinical(model.WF) ? _Utils_Tuple2(
		_Utils_update(
			model,
			{Wa: true}),
		cmd) : _Utils_Tuple2(model, cmd);
};
var $author$project$Api$WhitelabelSetting$practiceFacingFaviconAppleUrl = function (_v0) {
	var record = _v0;
	return record.GJ;
};
var $author$project$Api$WhitelabelSetting$practiceFacingFaviconIcoUrl = function (_v0) {
	var record = _v0;
	return record.GK;
};
var $author$project$Api$WhitelabelSetting$practiceFacingFaviconPngUrl = function (_v0) {
	var record = _v0;
	return record.GL;
};
var $author$project$Ports$Favicon$setFaviconPort = _Platform_outgoingPort(
	'setFaviconPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'appleUrl',
					$elm$json$Json$Encode$string($.Ji)),
					_Utils_Tuple2(
					'icoUrl',
					$elm$json$Json$Encode$string($.QF)),
					_Utils_Tuple2(
					'pngUrl',
					$elm$json$Json$Encode$string($.Wu))
				]));
	});
var $author$project$Shared$setFaviconUrls = function (whitelabelSetting) {
	var pngUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconPngUrl(whitelabelSetting);
	var icoUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconIcoUrl(whitelabelSetting);
	var appleUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconAppleUrl(whitelabelSetting);
	return $author$project$Ports$Favicon$setFaviconPort(
		{Ji: appleUrl, QF: icoUrl, Wu: pngUrl});
};
var $author$project$Shared$GotUserPartners = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Shared$PartnerQueryParam = function (a) {
	return {$: 3, a: a};
};
var $author$project$Shared$PracticeQueryParam = function (a) {
	return {$: 2, a: a};
};
var $author$project$Shared$switchToPracticeWithQueryParam = F3(
	function (apiClient, backupAuthEnabled, url) {
		var query = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Dict$empty,
			A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, url.Bi));
		var practiceId = A2($elm$core$Dict$get, 'switch-to-practice', query);
		var partnerId = A2($elm$core$Dict$get, 'switch-to-partner', query);
		var _v0 = _Utils_Tuple3(backupAuthEnabled, practiceId, partnerId);
		_v0$4:
		while (true) {
			if (_v0.a) {
				if (!_v0.b.$) {
					var practiceId_ = _v0.b.a;
					return A4(
						$author$project$Api$Auth$switchToOrganization,
						apiClient,
						practiceId_,
						$elm$core$Maybe$Nothing,
						$author$project$Shared$BackupAuthOrganizationSwitched(
							$author$project$OutMsg$GoToRouteAndReloadAction(
								$author$project$Utils$Route$fromUrl(url))));
				} else {
					if (!_v0.c.$) {
						var partnerId_ = _v0.c.a;
						return A4(
							$author$project$Api$Auth$switchToOrganization,
							apiClient,
							partnerId_,
							$elm$core$Maybe$Nothing,
							$author$project$Shared$BackupAuthOrganizationSwitched(
								$author$project$OutMsg$GoToRouteAndReloadAction(
									$author$project$Utils$Route$fromUrl(url))));
					} else {
						break _v0$4;
					}
				}
			} else {
				if (!_v0.b.$) {
					var practiceId_ = _v0.b.a;
					return A4(
						$author$project$Api$Platform$User$Practice$list,
						apiClient,
						function (d) {
							return _Utils_update(
								d,
								{
									af_: $elm$core$Maybe$Just(practiceId_)
								});
						},
						$elm$core$Maybe$Nothing,
						$author$project$Shared$GotUserPractices(
							$author$project$Shared$PracticeQueryParam(
								$author$project$Utils$Route$fromUrl(url))));
				} else {
					if (!_v0.c.$) {
						var partnerId_ = _v0.c.a;
						return A4(
							$author$project$Api$Platform$User$Partner$list,
							apiClient,
							function (d) {
								return _Utils_update(
									d,
									{
										af_: $elm$core$Maybe$Just(partnerId_)
									});
							},
							$elm$core$Maybe$Nothing,
							$author$project$Shared$GotUserPartners(
								$author$project$Shared$PartnerQueryParam(
									$author$project$Utils$Route$fromUrl(url))));
					} else {
						break _v0$4;
					}
				}
			}
		}
		var _v1 = _v0.b;
		var _v2 = _v0.c;
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Components$AccountLockedModal$update = function (msg) {
	return $elm$core$Platform$Cmd$none;
};
var $author$project$Components$GlobalSearch$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$GlobalSearch$SearchInputFocused = {$: 7};
var $author$project$Components$GlobalSearch$TabMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$GlobalSearch$DebounceMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$GlobalSearch$debounceConfig = {
	ag9: $jinjor$elm_debounce$Debounce$later(300),
	ahG: $author$project$Components$GlobalSearch$DebounceMsg
};
var $author$project$Ui$UnderlineTabs$Tabs = $elm$core$Basics$identity;
var $author$project$Ui$UnderlineTabs$Unrestricted = 0;
var $author$project$Ui$UnderlineTabs$FoundActiveTabElement = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$UnderlineTabs$FoundTabsElement = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$UnderlineTabs$FoundTabsViewport = function (a) {
	return {$: 2, a: a};
};
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$Ui$UnderlineTabs$getDomElements = F2(
	function (tabsId, activeTabId) {
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Task$attempt,
					$author$project$Ui$UnderlineTabs$FoundActiveTabElement,
					$elm$browser$Browser$Dom$getElement(activeTabId)),
					A2(
					$elm$core$Task$attempt,
					$author$project$Ui$UnderlineTabs$FoundTabsElement,
					$elm$browser$Browser$Dom$getElement(tabsId)),
					A2(
					$elm$core$Task$attempt,
					$author$project$Ui$UnderlineTabs$FoundTabsViewport,
					$elm$browser$Browser$Dom$getViewportOf(tabsId))
				]));
	});
var $author$project$Ui$UnderlineTabs$init = F2(
	function (id, activeId) {
		return _Utils_Tuple2(
			{pj: activeId, adR: id, zi: 0, Dk: 0, Dl: 0, HE: 0, HF: 0},
			A2($author$project$Ui$UnderlineTabs$getDomElements, id, activeId));
	});
var $author$project$Ports$GlobalSearch$openClinicalSearchPort = _Platform_outgoingPort(
	'openClinicalSearchPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$GlobalSearch$openClinicalSearch = $author$project$Ports$GlobalSearch$openClinicalSearchPort(0);
var $author$project$Api$Provider$Search$Min$path = function (_v0) {
	var record = _v0;
	return record.VL;
};
var $author$project$Api$Provider$Search$All$path = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$path(min);
};
var $author$project$Api$Provider$SearchPermissions$Shared$attributes = function (_v0) {
	var record = _v0;
	return record.vw;
};
var $author$project$Api$Provider$SearchPermissions$All$attributes = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SearchPermissions$Shared$attributes(shared);
};
var $author$project$Api$Provider$SearchPermissions$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$SearchPermissions$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SearchPermissions$Shared$id(shared);
};
var $author$project$Api$Provider$SearchPermissions$Shared$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Provider$SearchPermissions$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SearchPermissions$Shared$name(shared);
};
var $author$project$Api$Provider$SearchPermissions$Shared$searchable = function (_v0) {
	var record = _v0;
	return record.Zc;
};
var $author$project$Api$Provider$SearchPermissions$All$searchable = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$SearchPermissions$Shared$searchable(shared);
};
var $author$project$Components$GlobalSearch$permissionToPermissionType = function (permission) {
	return {
		vw: A2(
			$elm$core$List$map,
			function (attr) {
				return $elm$core$String$toLower(
					$author$project$Formatters$String$humanize(attr));
			},
			$author$project$Api$Provider$SearchPermissions$All$attributes(permission)),
		adR: $author$project$Api$Provider$SearchPermissions$All$id(permission),
		zh: $author$project$Formatters$String$pluralOf(
			$author$project$Api$Provider$SearchPermissions$All$name(permission)),
		Zc: $author$project$Api$Provider$SearchPermissions$All$searchable(permission)
	};
};
var $author$project$Components$GlobalSearch$GotSearchResult = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Provider$Search$All$Search = $elm$core$Basics$identity;
var $author$project$Api$Provider$Search$Min$Search = $elm$core$Basics$identity;
var $author$project$Api$Provider$Search$Min$Record = F6(
	function (id, label, secondaryLabel, type_, path, status) {
		return {adR: id, aej: label, VL: path, Zd: secondaryLabel, ag7: status, ahI: type_};
	});
var $author$project$Api$Provider$Search$Min$recordDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'status',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'path',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'secondary_label',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'label',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Api$Provider$Search$Min$Record)))))));
var $author$project$Api$Provider$Search$Min$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Search$Min$recordDecoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Search$All$decoder = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
	$author$project$Api$Provider$Search$Min$decoder,
	$elm$json$Json$Decode$succeed($elm$core$Basics$identity));
var $author$project$Api$Provider$Search$listDefaults = {
	afy: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
};
var $author$project$Api$Provider$Search$listOptionsToParams = function (optionals) {
	var options = optionals($author$project$Api$Provider$Search$listDefaults);
	var _v0 = options.afy;
	if (!_v0.$) {
		var pagination = _v0.a;
		return $author$project$Api$Pagination$toApiParams(pagination);
	} else {
		return _List_Nil;
	}
};
var $author$project$Api$Provider$Search$search = F5(
	function (apiClient, term, filter, optionals, toMsg) {
		var queryParams = function () {
			if (!filter.$) {
				var string = filter.a;
				return _List_fromArray(
					[
						A2($author$project$Api$Param$string, 'q', term),
						A2($author$project$Api$Param$string, 'type', string)
					]);
			} else {
				return _List_fromArray(
					[
						A2($author$project$Api$Param$string, 'q', term)
					]);
			}
		}();
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$elm$json$Json$Decode$list($author$project$Api$Provider$Search$All$decoder),
			toMsg,
			A2(
				$author$project$Api$Data$requestWithQuery,
				$author$project$Api$Provider$Search$listOptionsToParams(optionals),
				A2(
					$author$project$Api$Data$requestWithQuery,
					queryParams,
					$author$project$Api$Data$requestTo($author$project$Api$Provider$Search$path))));
	});
var $author$project$Components$GlobalSearch$search = F4(
	function (apiClient, model, maybeFilter, term) {
		return A5(
			$author$project$Api$Provider$Search$search,
			apiClient,
			term,
			maybeFilter,
			function (d) {
				return _Utils_update(
					d,
					{
						afy: $elm$core$Maybe$Just(model.afy)
					});
			},
			$author$project$Components$GlobalSearch$GotSearchResult);
	});
var $author$project$Ui$UnderlineTabs$ActiveTabLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$UnderlineTabs$TabSwitched = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$UnderlineTabs$update = F2(
	function (msg, tabs) {
		var model = tabs;
		switch (msg.$) {
			case 2:
				var result = msg.a;
				if (!result.$) {
					var viewport = result.a.ahQ;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Dl: viewport.HS}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(tabs, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 1:
				var result = msg.a;
				if (!result.$) {
					var element = result.a.acU;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{Dk: element.HS}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Nothing);
				} else {
					return _Utils_Tuple3(tabs, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 0:
				var result = msg.a;
				if (!result.$) {
					var element = result.a.acU;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{HE: element.HS, HF: element.ahT}),
						$elm$core$Platform$Cmd$none,
						$elm$core$Maybe$Just(
							$author$project$Ui$UnderlineTabs$ActiveTabLoaded(model.pj)));
				} else {
					return _Utils_Tuple3(tabs, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
				}
			case 3:
				var _v4 = msg.a;
				var tabItem = _v4.a;
				var toId = _v4.b.ahv;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							pj: toId(tabItem)
						}),
					A2(
						$author$project$Ui$UnderlineTabs$getDomElements,
						model.adR,
						toId(tabItem)),
					$elm$core$Maybe$Just(
						$author$project$Ui$UnderlineTabs$TabSwitched(tabItem)));
			default:
				return _Utils_Tuple3(tabs, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Components$GlobalSearch$update = F5(
	function (apiClient, _v0, practice, msg, model) {
		if (model.$ === 1) {
			var openModel = model.a;
			switch (msg.$) {
				case 0:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 1:
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Closed(
							{aav: openModel.aav}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 8:
					var tabMsg = msg.a;
					var _v3 = openModel.gV;
					if (!_v3.$) {
						var tabs = _v3.a;
						var _v4 = A2($author$project$Ui$UnderlineTabs$update, tabMsg, tabs);
						var tabModel = _v4.a;
						var tabsCmd = _v4.b;
						var maybeEvent = _v4.c;
						var _v5 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$GlobalSearch$debounceConfig, openModel.eL, openModel.dE);
						var debouncer = _v5.a;
						var cmd = _v5.b;
						if ((!maybeEvent.$) && (!maybeEvent.a.$)) {
							var tab = maybeEvent.a.a;
							var searchInputFocusedCmd = A2(
								$elm$core$Task$attempt,
								function (_v9) {
									return $author$project$Components$GlobalSearch$SearchInputFocused;
								},
								$elm$browser$Browser$Dom$focus('global-search-input'));
							var filter = function () {
								var _v8 = tab.adR;
								if (_v8 === 'all') {
									return $elm$core$Maybe$Nothing;
								} else {
									return $elm$core$Maybe$Just(tab.adR);
								}
							}();
							var _v7 = openModel.eL;
							if (_v7 === '') {
								return _Utils_Tuple3(
									$author$project$Components$GlobalSearch$Open(
										_Utils_update(
											openModel,
											{
												Fi: filter,
												gV: $elm$core$Maybe$Just(tabModel)
											})),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												searchInputFocusedCmd,
												A2($elm$core$Platform$Cmd$map, $author$project$Components$GlobalSearch$TabMsg, tabsCmd)
											])),
									_List_Nil);
							} else {
								return _Utils_Tuple3(
									$author$project$Components$GlobalSearch$Open(
										_Utils_update(
											openModel,
											{
												dE: debouncer,
												Fi: filter,
												afy: $author$project$Api$Pagination$init,
												gV: $elm$core$Maybe$Just(tabModel)
											})),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												searchInputFocusedCmd,
												A2($elm$core$Platform$Cmd$map, $author$project$Components$GlobalSearch$TabMsg, tabsCmd),
												cmd
											])),
									_List_Nil);
							}
						} else {
							return _Utils_Tuple3(
								$author$project$Components$GlobalSearch$Open(
									_Utils_update(
										openModel,
										{
											gV: $elm$core$Maybe$Just(tabModel)
										})),
								A2($elm$core$Platform$Cmd$map, $author$project$Components$GlobalSearch$TabMsg, tabsCmd),
								_List_Nil);
						}
					} else {
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Open(openModel),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					}
				case 2:
					var term = msg.a;
					var _v10 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$GlobalSearch$debounceConfig, term, openModel.dE);
					var debouncer = _v10.a;
					var cmd = _v10.b;
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(
							_Utils_update(
								openModel,
								{N: -1, dE: debouncer, afy: $author$project$Api$Pagination$init, eL: term})),
						cmd,
						_List_Nil);
				case 3:
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(
							_Utils_update(
								openModel,
								{N: -1, dE: $jinjor$elm_debounce$Debounce$init, afy: $author$project$Api$Pagination$init, YC: $author$project$Api$Data$NotAsked, eL: ''})),
						A2(
							$elm$core$Task$attempt,
							function (_v11) {
								return $author$project$Components$GlobalSearch$SearchInputFocused;
							},
							$elm$browser$Browser$Dom$focus('global-search-input')),
						_List_Nil);
				case 4:
					var debounceMsg = msg.a;
					var _v12 = A4(
						$jinjor$elm_debounce$Debounce$update,
						$author$project$Components$GlobalSearch$debounceConfig,
						$jinjor$elm_debounce$Debounce$takeLast(
							A3($author$project$Components$GlobalSearch$search, apiClient, openModel, openModel.Fi)),
						debounceMsg,
						openModel.dE);
					var debouncer = _v12.a;
					var cmd = _v12.b;
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(
							_Utils_update(
								openModel,
								{dE: debouncer})),
						cmd,
						_List_Nil);
				case 5:
					var response = msg.a;
					if (response.$ === 3) {
						var headers = response.b;
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Open(
								_Utils_update(
									openModel,
									{
										N: 0,
										afy: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, openModel.afy),
										YC: response,
										B1: openModel.B1 + 1
									})),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				case 13:
					var response = msg.a;
					if (response.$ === 3) {
						var permissions = response.a;
						var searchableTypeList = A2(
							$elm$core$List$filter,
							function ($) {
								return $.Zc;
							},
							A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions));
						var _v15 = function () {
							if ($elm$core$List$length(searchableTypeList) > 1) {
								return _Utils_Tuple2($elm$core$Maybe$Nothing, 'all');
							} else {
								var _default = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2(
										$elm$core$Maybe$map,
										function (elem) {
											return elem.adR;
										},
										$elm$core$List$head(searchableTypeList)));
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(_default),
									_default);
							}
						}();
						var filter = _v15.a;
						var defaultPermissionType = _v15.b;
						var _v16 = A2($author$project$Ui$UnderlineTabs$init, 'underline-tabs', defaultPermissionType);
						var tabsModel = _v16.a;
						var tabsCmd = _v16.b;
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Open(
								_Utils_update(
									openModel,
									{
										Fi: filter,
										r1: response,
										gV: $elm$core$Maybe$Just(tabsModel)
									})),
							A2($elm$core$Platform$Cmd$map, $author$project$Components$GlobalSearch$TabMsg, tabsCmd),
							_List_Nil);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$OutMsg$handleErrorResponse(response));
					}
				case 6:
					var subMsg = msg.a;
					var pagination = A2($author$project$Api$Pagination$update, subMsg, openModel.afy);
					var newModel = _Utils_update(
						openModel,
						{afy: pagination});
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(newModel),
						A4($author$project$Components$GlobalSearch$search, apiClient, newModel, newModel.Fi, newModel.eL),
						_List_Nil);
				case 7:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 11:
					var key = msg.a;
					var resultsCount = function () {
						var _v21 = openModel.YC;
						if (_v21.$ === 3) {
							var results = _v21.a;
							return $elm$core$List$length(results);
						} else {
							return 0;
						}
					}();
					switch (key) {
						case 13:
							var _v18 = function () {
								var _v19 = openModel.YC;
								if (_v19.$ === 3) {
									var results = _v19.a;
									return (openModel.N >= 0) ? _Utils_Tuple2(
										A2($elm_community$list_extra$List$Extra$getAt, openModel.N, results),
										openModel.N) : (($elm$core$List$length(results) > 0) ? _Utils_Tuple2(
										A2($elm_community$list_extra$List$Extra$getAt, 0, results),
										0) : _Utils_Tuple2($elm$core$Maybe$Nothing, -1));
								} else {
									return _Utils_Tuple2($elm$core$Maybe$Nothing, -1);
								}
							}();
							var maybeSelectedDoc = _v18.a;
							if (!maybeSelectedDoc.$) {
								var selectedDoc = maybeSelectedDoc.a;
								return (openModel.N >= 0) ? _Utils_Tuple3(
									$author$project$Components$GlobalSearch$Closed(
										{aav: openModel.aav}),
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											$author$project$Utils$Route$navigate($elm$core$Dict$empty),
											A2(
												$elm$core$Maybe$map,
												$author$project$Utils$Route$fromUrl,
												$elm$url$Url$fromString(
													A2(
														$elm$core$String$append,
														'https://app.hint.com',
														$author$project$Api$Provider$Search$All$path(selectedDoc)))))),
									_List_Nil) : _Utils_Tuple3(
									$author$project$Components$GlobalSearch$Open(
										_Utils_update(
											openModel,
											{N: 0})),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							} else {
								return _Utils_Tuple3(
									$author$project$Components$GlobalSearch$Open(openModel),
									$elm$core$Platform$Cmd$none,
									_List_Nil);
							}
						case 38:
							var newIndex = (resultsCount > 0) ? (_Utils_eq(openModel.N, -1) ? (resultsCount - 1) : A2($elm$core$Basics$modBy, resultsCount, openModel.N - 1)) : (-1);
							return _Utils_Tuple3(
								$author$project$Components$GlobalSearch$Open(
									_Utils_update(
										openModel,
										{N: newIndex})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						case 40:
							var newIndex = (resultsCount > 0) ? A2($elm$core$Basics$modBy, resultsCount, openModel.N + 1) : (-1);
							return _Utils_Tuple3(
								$author$project$Components$GlobalSearch$Open(
									_Utils_update(
										openModel,
										{N: newIndex})),
								$elm$core$Platform$Cmd$none,
								_List_Nil);
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 10:
					var index = msg.a;
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Open(
							_Utils_update(
								openModel,
								{N: index})),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				case 9:
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Closed(
							{aav: openModel.aav}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
				default:
					return _Utils_Tuple3(
						$author$project$Components$GlobalSearch$Closed(
							{aav: openModel.aav}),
						$elm$core$Platform$Cmd$none,
						_List_Nil);
			}
		} else {
			var url = model.a.aav;
			var _v22 = _Utils_Tuple2(
				msg,
				$author$project$Api$Data$clientHasAuthToken(apiClient));
			_v22$2:
			while (true) {
				switch (_v22.a.$) {
					case 0:
						if (_v22.b) {
							var _v23 = _v22.a;
							var useClinicalSearch = function () {
								if (practice.$ === 3) {
									var practice_ = practice.a;
									return $author$project$Api$Practice$hasClinicalAccount(practice_) && A2($author$project$Api$Practice$featureEnabled, 19, practice_);
								} else {
									return false;
								}
							}();
							var _v24 = function () {
								if (useClinicalSearch) {
									return _Utils_Tuple2(model, $author$project$Ports$GlobalSearch$openClinicalSearch);
								} else {
									var searchPermissionsCmd = A2($author$project$Api$Provider$Search$permissions, apiClient, $author$project$Components$GlobalSearch$GotSearchPermissions);
									var openModalModel = $author$project$Components$GlobalSearch$Open(
										{N: -1, dE: $jinjor$elm_debounce$Debounce$init, Fi: $elm$core$Maybe$Nothing, afy: $author$project$Api$Pagination$init, r1: $author$project$Api$Data$NotAsked, YC: $author$project$Api$Data$NotAsked, B1: 0, gV: $elm$core$Maybe$Nothing, eL: '', aav: url});
									var openModalCmds = $elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2(
												$elm$core$Task$attempt,
												function (_v25) {
													return $author$project$Components$GlobalSearch$SearchInputFocused;
												},
												$elm$browser$Browser$Dom$focus('global-search-input')),
												searchPermissionsCmd
											]));
									return _Utils_Tuple2(openModalModel, openModalCmds);
								}
							}();
							var newModel = _v24.a;
							var newCmds = _v24.b;
							return _Utils_Tuple3(newModel, newCmds, _List_Nil);
						} else {
							break _v22$2;
						}
					case 12:
						var _v27 = _v22.a;
						return _Utils_Tuple3(
							$author$project$Components$GlobalSearch$Closed(
								{aav: url}),
							$elm$core$Platform$Cmd$none,
							_List_Nil);
					default:
						break _v22$2;
				}
			}
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Components$OrganizationSwitcher$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rJ: response}),
					$elm$core$Platform$Cmd$none,
					function () {
						if (((response.$ === 2) && (response.a.$ === 6)) && (response.a.b === 'Too many organizations')) {
							var _v3 = response.a;
							return _List_Nil;
						} else {
							return $author$project$OutMsg$handleErrorResponse(response);
						}
					}());
			case 1:
				var env = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qz: env}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var subMsg = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							mj: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.mj)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var subMsg = msg.a;
				var _v4 = A2($author$project$Ui$Nav$update, subMsg, model.m9);
				var newNavModel = _v4.a;
				var navCmd = _v4.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{m9: newNavModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Components$OrganizationSwitcher$NavMsg, navCmd),
					_List_Nil);
			default:
				var organizationId = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToDefaultStateAndReloadAction)
						]));
		}
	});
var $author$project$Navbar$SandboxAlertMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Ports$Navbar$topnavHeaderHeightChangedPort = _Platform_outgoingPort('topnavHeaderHeightChangedPort', $elm$json$Json$Encode$float);
var $author$project$Components$SandboxAlert$update = function (msg) {
	var organizationType = msg.a;
	var organizationId = msg.b;
	var postOrganizationSwitchedAction = function () {
		if (organizationType === 2) {
			return $author$project$OutMsg$GoToRouteAndReloadAction($author$project$Spa$Generated$Route$Partner__Sandboxes__Top);
		} else {
			return $author$project$OutMsg$GoToDefaultStateAndReloadAction;
		}
	}();
	return _Utils_Tuple2(
		$elm$core$Platform$Cmd$none,
		_List_fromArray(
			[
				A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, postOrganizationSwitchedAction)
			]));
};
var $author$project$Ports$Navbar$sidenavLinkClickedPort = _Platform_outgoingPort(
	'sidenavLinkClickedPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Navbar$sidenavLinkClicked = $author$project$Ports$Navbar$sidenavLinkClickedPort(0);
var $author$project$Navbars$Company$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c1: 1,
							ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg)
						}),
					$author$project$Ports$Navbar$sidenavLinkClicked);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c1: 1,
							ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg)
						}),
					$author$project$Ports$Session$logout(
						{af6: true}));
			case 2:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c1: checked ? $author$project$Navbars$Company$openSubNavFromSelectedNav(model.eE) : 1,
							ow: checked
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c1: 1, ow: false}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var subnav = msg.a;
				var newOpenSubNav = _Utils_eq(subnav, model.c1) ? 1 : subnav;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c1: newOpenSubNav}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ep: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.ep)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Navbars$Partner$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c1: 1,
							ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg)
						}),
					$author$project$Ports$Navbar$sidenavLinkClicked);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c1: 1,
							ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg)
						}),
					$author$project$Ports$Session$logout(
						{af6: true}));
			case 2:
				var checked = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c1: checked ? $author$project$Navbars$Partner$openSubNavFromSelectedNav(model.eE) : 1,
							ow: checked
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c1: 1, ow: false}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var subnav = msg.a;
				var newOpenSubNav = _Utils_eq(subnav, model.c1) ? 1 : subnav;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c1: newOpenSubNav}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ep: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.ep)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Ports$Navbar$globalSearchButtonClickedPort = _Platform_outgoingPort(
	'globalSearchButtonClickedPort',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Navbar$globalSearchTriggered = $author$project$Ports$Navbar$globalSearchButtonClickedPort(0);
var $author$project$Components$HinterPracticeSettingsModal$GotCurrentManagementGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$GotFeatures = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$GotManagementGroups = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$open = F2(
	function (apiClient, practice) {
		return _Utils_Tuple2(
			$author$project$Components$HinterPracticeSettingsModal$Open(
				{LT: $elm$core$Maybe$Nothing, h2: $elm$core$Maybe$Nothing, Pd: $author$project$Api$Data$Loading, m_: $author$project$Api$Data$Loading, WF: practice, sB: ''}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Api$Provider$ManagementGroup$getCurrent, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotCurrentManagementGroup),
						A2($author$project$Api$Provider$ManagementGroup$list, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotManagementGroups),
						A3($author$project$Api$Common$Feature$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotFeatures)
					])));
	});
var $author$project$Ports$Intercom$intercomPortShow = _Platform_outgoingPort(
	'intercomPortShow',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Intercom$show = function (session) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortShow(0);
};
var $author$project$Components$HinterPracticeSettingsModal$GotFeatureEnableResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupSaved = 2;
var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupUpdated = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$ModalClosed = 1;
var $author$project$Components$HinterPracticeSettingsModal$None = 0;
var $author$project$Components$HinterPracticeSettingsModal$replaceUpdatedFeature = F2(
	function (newFeature, feature) {
		return _Utils_eq(
			$author$project$Api$Common$Feature$Shared$id(feature),
			$author$project$Api$Common$Feature$Shared$id(newFeature)) ? newFeature : feature;
	});
var $author$project$Components$HinterPracticeSettingsModal$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				return {EC: $elm$core$Platform$Cmd$none, ac5: 1, y8: $author$project$Components$HinterPracticeSettingsModal$Closed, as: _List_Nil};
			case 1:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					switch (response.$) {
						case 3:
							var group = response.a;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{
											h2: $elm$core$Maybe$Just(group)
										})),
								as: _List_Nil
							};
						case 2:
							var error = response.a;
							if (error.$ === 5) {
								return {
									EC: $elm$core$Platform$Cmd$none,
									ac5: 0,
									y8: $author$project$Components$HinterPracticeSettingsModal$Open(
										_Utils_update(
											data,
											{h2: $elm$core$Maybe$Nothing})),
									as: _List_Nil
								};
							} else {
								return {
									EC: $elm$core$Platform$Cmd$none,
									ac5: 0,
									y8: model,
									as: $author$project$OutMsg$handleErrorResponse(response)
								};
							}
						default:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: model,
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 2:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					switch (response.$) {
						case 3:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{m_: response})),
								as: _List_Nil
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{m_: response})),
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 1, 'Failed to load management groups')
									])
							};
						default:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: model,
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 3:
				var groupId = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					return {
						EC: A3($author$project$Api$Provider$ManagementGroup$update, apiClient, groupId, $author$project$Components$HinterPracticeSettingsModal$ManagementGroupUpdated),
						ac5: 0,
						y8: $author$project$Components$HinterPracticeSettingsModal$Open(data),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 4:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					if (response.$ === 3) {
						if (!response.a.$) {
							var group = response.a.a;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 2,
								y8: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{
											h2: $elm$core$Maybe$Just(group)
										})),
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Management group updated successfully')
									])
							};
						} else {
							var _v9 = response.a;
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{h2: $elm$core$Maybe$Nothing})),
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 3, 'Management group removed successfully')
									])
							};
						}
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: model,
							as: A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 1, 'Failed to update management group'),
								$author$project$OutMsg$handleErrorResponse(response))
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 5:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					switch (response.$) {
						case 3:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{Pd: response})),
								as: _List_Nil
							};
						case 2:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: $author$project$Components$HinterPracticeSettingsModal$Open(
									_Utils_update(
										data,
										{Pd: response})),
								as: _List_fromArray(
									[
										A2($author$project$OutMsg$ShowToast, 1, 'Failed to load features')
									])
							};
						default:
							return {
								EC: $elm$core$Platform$Cmd$none,
								ac5: 0,
								y8: model,
								as: $author$project$OutMsg$handleErrorResponse(response)
							};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 6:
				var featureId = msg.a;
				var enabled = msg.b;
				if (model.$ === 1) {
					return {
						EC: A5($author$project$Api$Common$Feature$enable, $author$project$Api$Data$providerPath, apiClient, featureId, enabled, $author$project$Components$HinterPracticeSettingsModal$GotFeatureEnableResponse),
						ac5: 0,
						y8: model,
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 7:
				var response = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					if (response.$ === 3) {
						var feature = response.a;
						var toastMessage = $author$project$Api$Common$Feature$Shared$enabled(feature) ? A2(
							$author$project$OutMsg$ShowToast,
							3,
							'Feature \"' + ($author$project$Api$Common$Feature$Shared$name(feature) + '\" turned on')) : A2(
							$author$project$OutMsg$ShowToast,
							3,
							'Feature \"' + ($author$project$Api$Common$Feature$Shared$name(feature) + '\" turned off'));
						var newFeatures = A2(
							$author$project$Api$Data$map,
							$elm$core$List$map(
								$author$project$Components$HinterPracticeSettingsModal$replaceUpdatedFeature(feature)),
							data.Pd);
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: $author$project$Components$HinterPracticeSettingsModal$Open(
								_Utils_update(
									data,
									{Pd: newFeatures})),
							as: _List_fromArray(
								[toastMessage])
						};
					} else {
						return {
							EC: $elm$core$Platform$Cmd$none,
							ac5: 0,
							y8: model,
							as: A2(
								$elm$core$List$cons,
								A2($author$project$OutMsg$ShowToast, 1, 'Failed to update feature'),
								$author$project$OutMsg$handleErrorResponse(response))
						};
					}
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 8:
				var query = msg.a;
				if (model.$ === 1) {
					var data = model.a;
					return {
						EC: $elm$core$Platform$Cmd$none,
						ac5: 0,
						y8: $author$project$Components$HinterPracticeSettingsModal$Open(
							_Utils_update(
								data,
								{sB: query})),
						as: _List_Nil
					};
				} else {
					return {EC: $elm$core$Platform$Cmd$none, ac5: 0, y8: model, as: _List_Nil};
				}
			case 9:
				var text = msg.a;
				return {
					EC: $author$project$Ports$Clipboard$copy(text),
					ac5: 0,
					y8: model,
					as: _List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
						])
				};
			default:
				return {
					EC: $author$project$Ports$Navigation$pushUrl(
						$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$NewSettings__HinterSettings)),
					ac5: 1,
					y8: $author$project$Components$HinterPracticeSettingsModal$Closed,
					as: _List_Nil
				};
		}
	});
var $author$project$Navbars$Practice$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{qq: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 14:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sn: response}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 0:
				var currentDate = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cO: $elm$core$Maybe$Just(currentDate)
						}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 2:
				var subnav = msg.a;
				var newOpenSubNav = _Utils_eq(subnav, model.c1) ? 4 : subnav;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c1: newOpenSubNav}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 3:
				var reportMenu = A2($author$project$Ui$FlyoutMenu$init, 'reporting-menu', $author$project$Navbars$Practice$ReportMenuMsg);
				var profileMenu = A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg);
				var adminMenu = A2($author$project$Ui$FlyoutMenu$init, 'admin-menu', $author$project$Navbars$Practice$AdminMenuMsg);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hr: adminMenu, ep: profileMenu, jP: reportMenu}),
					$author$project$Ports$Navbar$sidenavLinkClicked,
					_List_Nil);
			case 4:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c1: 4, ow: false}),
					$author$project$Ports$Navbar$globalSearchTriggered,
					_List_Nil);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{yj: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg)
						}),
					$author$project$Ports$Session$logout(
						{af6: true}),
					_List_Nil);
			case 7:
				var subMsg = msg.a;
				var _v2 = A2($author$project$Ui$NewDropdown$update, subMsg, model.oF);
				var dropdownMenu = _v2.a;
				var cmd = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{oF: dropdownMenu}),
					cmd,
					_List_Nil);
			case 8:
				var subMsg = msg.a;
				var reportMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.jP);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jP: reportMenu}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 9:
				var subMsg = msg.a;
				var adminMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.hr);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hr: adminMenu}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 10:
				var subMsg = msg.a;
				var profileMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.ep);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ep: profileMenu}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 11:
				var checked = msg.a;
				var newOpenSubNav = checked ? $author$project$Navbars$Practice$openSubNavFromSelectedNav(model.eE) : 4;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c1: newOpenSubNav, ow: checked}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c1: 4, ow: false}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{sS: !model.sS}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 15:
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Intercom$show(model.ZD),
					_List_Nil);
			case 16:
				var _v3 = A2($author$project$Components$HinterPracticeSettingsModal$open, apiClient, model.WF);
				var modalModel = _v3.a;
				var modalCmd = _v3.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iO: modalModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg, modalCmd),
					_List_Nil);
			case 17:
				var modalMsg = msg.a;
				var result = A3($author$project$Components$HinterPracticeSettingsModal$update, apiClient, modalMsg, model.iO);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{iO: result.y8}),
					A2($elm$core$Platform$Cmd$map, $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg, result.EC),
					result.as);
			case 18:
				var partnerApps = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{rP: partnerApps}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(partnerApps));
			case 20:
				var pid = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(pid),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied practice id to clipboard')
						]));
			case 21:
				var oid = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Ports$Clipboard$copy(oid),
					_List_fromArray(
						[
							A2($author$project$OutMsg$ShowToast, 3, 'Copied organization id to clipboard')
						]));
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
		}
	});
var $author$project$Navbar$update = F3(
	function (apiClient, msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				var subMsg = msg.a;
				var _v2 = model.ac;
				if (_v2.$ === 1) {
					var subModel = _v2.a;
					var _v3 = A3($author$project$Navbars$Practice$update, apiClient, subMsg, subModel);
					var subModel_ = _v3.a;
					var subCmd = _v3.b;
					var subOutMsgs = _v3.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ac: $author$project$Navbar$PracticeNav(subModel_)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PracticeNavbarMsg, subCmd),
									$author$project$Navbar$getHeaderEnd
								])),
						subOutMsgs);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 1:
				var subMsg = msg.a;
				var _v4 = model.ac;
				if (_v4.$ === 2) {
					var subModel = _v4.a;
					var _v5 = A2($author$project$Navbars$Company$update, subMsg, subModel);
					var subModel_ = _v5.a;
					var subCmd = _v5.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ac: $author$project$Navbar$CompanyNav(subModel_)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Navbar$CompanyNavbarMsg, subCmd),
									$author$project$Navbar$getHeaderEnd
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var subMsg = msg.a;
				var _v6 = model.ac;
				if (_v6.$ === 3) {
					var subModel = _v6.a;
					var _v7 = A2($author$project$Navbars$Partner$update, subMsg, subModel);
					var subModel_ = _v7.a;
					var subCmd = _v7.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								ac: $author$project$Navbar$PartnerNav(subModel_)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PartnerNavbarMsg, subCmd),
									$author$project$Navbar$getHeaderEnd
								])),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var bool = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{adN: bool}),
					$elm$core$Platform$Cmd$none,
					_List_Nil);
			case 4:
				var result = msg.a;
				if (!result.$) {
					var element = result.a.acU;
					var viewport = result.a.ahQ;
					return _Utils_Tuple3(
						model,
						$author$project$Ports$Navbar$topnavHeaderHeightChangedPort(element.aa5 - viewport.aa5),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 5:
				return _Utils_Tuple3(model, $author$project$Navbar$getHeaderEnd, _List_Nil);
			default:
				var subMsg = msg.a;
				var _v9 = $author$project$Components$SandboxAlert$update(subMsg);
				var sandboxAlertCmd = _v9.a;
				var sandboxAlertOutMsgs = _v9.b;
				return _Utils_Tuple3(
					model,
					A2($elm$core$Platform$Cmd$map, $author$project$Navbar$SandboxAlertMsg, sandboxAlertCmd),
					sandboxAlertOutMsgs);
		}
	});
var $author$project$Ui$Toast$removeToast = F2(
	function (filterFunc, _v0) {
		var count = _v0.a;
		var toasts = _v0.b;
		return A2(
			$author$project$Ui$Toast$Toastr,
			count,
			A2($elm$core$List$filter, filterFunc, toasts));
	});
var $author$project$Ui$Toast$updateToast = F3(
	function (func, id, _v0) {
		var count = _v0.a;
		var toasts = _v0.b;
		return A2(
			$author$project$Ui$Toast$Toastr,
			count,
			A2(
				$elm$core$List$map,
				function (_v1) {
					var toast_ = _v1;
					return _Utils_eq(toast_.adR, id) ? func(toast_) : toast_;
				},
				toasts));
	});
var $author$project$Ui$Toast$update = F2(
	function (msg, toastr) {
		switch (msg.$) {
			case 1:
				var toRemoveId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Ui$Toast$removeToast,
						function (_v1) {
							var id = _v1.adR;
							var dismissible = _v1.qj;
							return !(_Utils_eq(id, toRemoveId) && dismissible);
						},
						toastr),
					$elm$core$Platform$Cmd$none);
			case 0:
				var toRemoveId = msg.a;
				return _Utils_Tuple2(
					A2(
						$author$project$Ui$Toast$removeToast,
						function (_v2) {
							var id = _v2.adR;
							return !_Utils_eq(id, toRemoveId);
						},
						toastr),
					$elm$core$Platform$Cmd$none);
			case 2:
				var id = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Ui$Toast$updateToast,
						function (toast_) {
							return _Utils_update(
								toast_,
								{qj: false});
						},
						id,
						toastr),
					$elm$core$Platform$Cmd$none);
			default:
				var id = msg.a;
				return _Utils_Tuple2(
					A3(
						$author$project$Ui$Toast$updateToast,
						function (toast_) {
							return _Utils_update(
								toast_,
								{qj: true});
						},
						id,
						toastr),
					A2($author$project$Ui$Toast$dismissInSeconds, 2, id));
		}
	});
var $author$project$Utils$Release$GotLiveRelease = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata._L));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{e5: $elm$http$Http$emptyBody, OT: r.OT, iJ: _List_Nil, F6: 'GET', HA: $elm$core$Maybe$Nothing, tn: $elm$core$Maybe$Nothing, aav: r.aav});
};
var $author$project$Utils$Release$fetchLiveRelease = $elm$http$Http$get(
	{
		OT: $elm$http$Http$expectString($author$project$Utils$Release$GotLiveRelease),
		aav: '/RELEASE'
	});
var $author$project$Utils$Release$sha1Regex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[a-f0-9]{40}'));
var $author$project$Utils$Release$update = F2(
	function (msg, _v0) {
		var model = _v0;
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Basics$identity,
			function () {
				if (!msg.$) {
					if (!msg.a.$) {
						var liveRelease = msg.a.a;
						return A2($elm$regex$Regex$contains, $author$project$Utils$Release$sha1Regex, liveRelease) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{
									zj: !_Utils_eq(
										$elm$core$String$trim(liveRelease),
										model.EO)
								}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
							model,
							$author$project$Ports$Sentry$captureErrorMessage('Fetching RELEASE Failed: Not Found'));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Utils$Release$fetchLiveRelease,
									model.zj ? $elm$core$Platform$Cmd$none : $author$project$Utils$Release$scheduleNextReleaseCheck
								])));
				}
			}());
	});
var $author$project$Shared$validateRedirectUrl = F2(
	function (currentPath, redirectToURI) {
		var isErrorPage = function (url) {
			return A2($elm$core$String$contains, '/error/', url);
		};
		var onErrorPage = isErrorPage(currentPath);
		var redirectGoesToErrorPage = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2($elm$core$Maybe$map, isErrorPage, redirectToURI));
		return (onErrorPage || (!redirectGoesToErrorPage)) ? redirectToURI : $elm$core$Maybe$Nothing;
	});
var $author$project$Shared$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					var response = msg.a;
					switch (response.$) {
						case 2:
							var error = response.a;
							if (error.$ === 7) {
								var decodeError = error.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{ZD: response}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												$author$project$Shared$decodeErrorToMsg(decodeError),
												$author$project$Shared$navigateToErrorPage(error)
											])));
							} else {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{ZD: response}),
									$author$project$Shared$navigateToErrorPage(error));
							}
						case 3:
							var session = response.a;
							var rainforestEnv = (_Utils_eq(
								model.adu.adM,
								$elm$core$Maybe$Just('production')) && (!$author$project$Api$Platform$Session$One$sandbox(session))) ? 0 : 1;
							var _v3 = function () {
								var _v4 = model.ga;
								if (_v4.$ === 1) {
									return A2(
										$elm$core$Tuple$mapSecond,
										$elm$core$Platform$Cmd$map($author$project$Shared$OrganizationSwitcherMsg),
										A2(
											$elm$core$Tuple$mapFirst,
											$elm$core$Maybe$Just,
											A2(
												$author$project$Components$OrganizationSwitcher$init,
												model.D5,
												{
													Y$: $author$project$Api$Platform$Session$One$sandbox(session)
												})));
								} else {
									var existing = _v4.a;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(existing),
										$elm$core$Platform$Cmd$none);
								}
							}();
							var orgSwitcher = _v3.a;
							var orgSwitcherCmd = _v3.b;
							return A4(
								$author$project$Shared$applySession,
								response,
								session,
								_Utils_update(
									model,
									{
										ga: orgSwitcher,
										sj: $elm$core$Maybe$Just(rainforestEnv)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Ports$Rainforest$load(rainforestEnv),
											orgSwitcherCmd
										])));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{ZD: response}),
								$elm$core$Platform$Cmd$none);
					}
				case 1:
					var response = msg.a;
					_v5$2:
					while (true) {
						if (response.$ === 2) {
							switch (response.a.$) {
								case 7:
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{WF: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								case 6:
									if ((response.a.a === 428) && (response.a.b === 'This action requires a Practice')) {
										var _v6 = response.a;
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{WF: $author$project$Api$Data$NotAsked}),
											$elm$core$Platform$Cmd$none);
									} else {
										break _v5$2;
									}
								default:
									break _v5$2;
							}
						} else {
							break _v5$2;
						}
					}
					var invokeIfNewPractice = F3(
						function (fn, onFirstLoad, newModelAndCmd) {
							var _v7 = _Utils_Tuple2(model.WF, response);
							if (_v7.b.$ === 3) {
								if (_v7.a.$ === 3) {
									var _v8 = _v7.a;
									var oldPractice = _v8.a;
									var _v9 = _v7.b;
									var newPractice = _v9.a;
									return A2($author$project$Shared$practiceChanged, oldPractice, newPractice) ? fn(newModelAndCmd) : newModelAndCmd;
								} else {
									var _v10 = _v7.b;
									return onFirstLoad ? fn(newModelAndCmd) : newModelAndCmd;
								}
							} else {
								return newModelAndCmd;
							}
						});
					return A2(
						$author$project$Shared$handlePendingClinicalRedirect,
						response,
						$author$project$Shared$initNavbar(
							$author$project$Shared$initializePatientsList(
								$author$project$Shared$enableCoreGlobalSearchShortcutFn(
									$author$project$Shared$requestLoadEmbeddedClinical(
										A3(
											invokeIfNewPractice,
											$author$project$Shared$identifyOnExternalServices,
											true,
											A3(
												invokeIfNewPractice,
												$author$project$Shared$resetTenancyProperties,
												false,
												_Utils_Tuple2(
													_Utils_update(
														model,
														{WF: response}),
													$elm$core$Platform$Cmd$none))))))));
				case 3:
					var companyId = msg.a;
					var response = msg.b;
					_v11$2:
					while (true) {
						if (response.$ === 2) {
							switch (response.a.$) {
								case 5:
									var _v12 = response.a;
									return $author$project$Shared$isHintAdmin(model) ? _Utils_Tuple2(
										_Utils_update(
											model,
											{ab9: response}),
										A4(
											$author$project$Api$Platform$User$Practice$list,
											model.D5,
											function (d) {
												return _Utils_update(
													d,
													{
														af_: $elm$core$Maybe$Just(companyId)
													});
											},
											$elm$core$Maybe$Nothing,
											$author$project$Shared$GotUserPractices(
												$author$project$Shared$Company(companyId)))) : $author$project$Shared$initNavbar(
										_Utils_Tuple2(
											_Utils_update(
												model,
												{ab9: response}),
											$elm$core$Platform$Cmd$none));
								case 7:
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{ab9: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								default:
									break _v11$2;
							}
						} else {
							break _v11$2;
						}
					}
					return $author$project$Shared$initNavbar(
						_Utils_Tuple2(
							_Utils_update(
								model,
								{ab9: response}),
							$elm$core$Platform$Cmd$none));
				case 2:
					var response = msg.a;
					if ((response.$ === 2) && (response.a.$ === 7)) {
						var error = response.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{Vz: response}),
							$author$project$Shared$decodeErrorToMsg(error));
					} else {
						return $author$project$Shared$initNavbar(
							$author$project$Shared$resetTenancyProperties(
								_Utils_Tuple2(
									_Utils_update(
										model,
										{Vz: response}),
									$elm$core$Platform$Cmd$none)));
					}
				case 4:
					var userData = msg.a;
					if ((userData.$ === 2) && (userData.a.$ === 7)) {
						var error = userData.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aaz: userData}),
							$author$project$Shared$decodeErrorToMsg(error));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aaz: userData}),
							$elm$core$Platform$Cmd$none);
					}
				case 5:
					var result = msg.a;
					if (!result.$) {
						var maybeSessionToken = result.a;
						var maybeAuthToken = A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, maybeSessionToken);
						var apiClient = A2($author$project$Api$Data$clientWithAuthToken, maybeAuthToken, model.D5);
						if ($author$project$Api$Data$clientHasAuthToken(apiClient)) {
							var refreshTimeoutCmd = (!A2($author$project$Api$Data$usingDefaultAuth, model.D5, model.adu.abt)) ? $author$project$Shared$backupJwtRefreshTimeout(apiClient) : $elm$core$Platform$Cmd$none;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{pi: maybeAuthToken, D5: apiClient}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Api$Platform$Session$retrieve, apiClient, $author$project$Shared$GotSession),
											A2($author$project$Api$Platform$User$retrieve, apiClient, $author$project$Shared$GotUser),
											refreshTimeoutCmd
										])));
						} else {
							return $author$project$Shared$resetTenancyProperties(
								_Utils_Tuple2(
									_Utils_update(
										model,
										{pi: maybeAuthToken, D5: apiClient, WF: $author$project$Api$Data$NotAsked, ZD: $author$project$Api$Data$NotAsked, aaz: $author$project$Api$Data$NotAsked}),
									$elm$core$Platform$Cmd$none));
						}
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$Ports$Sentry$captureErrorMessage('Session update failed: ' + error));
					}
				case 6:
					var result = msg.a;
					if (!result.$) {
						var _v17 = result.a;
						var zone = _v17.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									Hy: A2($author$project$Formatters$Time$init, zone, model.ack),
									Hz: zone
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 7:
					var currentTime = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cO: A2($justinmimbs$date$Date$fromPosix, model.Hz, currentTime),
								ack: currentTime
							}),
						$elm$core$Platform$Cmd$none);
				case 8:
					var patientsListMsg_ = msg.a;
					var _v18 = model.afE;
					if (!_v18.$) {
						var patientsList = _v18.a;
						var _v19 = A3($author$project$Components$PatientsList$update, model.D5, patientsListMsg_, patientsList);
						var newList = _v19.a;
						var listCmd = _v19.b;
						var outMsgs = _v19.c;
						var _v20 = A2(
							$author$project$Shared$updateFromOutMsgs,
							outMsgs,
							_Utils_update(
								model,
								{
									afE: $elm$core$Maybe$Just(newList)
								}));
						var newModel = _v20.a;
						var outCmd = _v20.b;
						return _Utils_Tuple2(
							newModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, listCmd),
										outCmd
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 9:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{sP: true}),
						$elm$core$Platform$Cmd$none);
				case 10:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{sP: false}),
						$elm$core$Platform$Cmd$none);
				case 11:
					var subMsg = msg.a;
					var _v21 = A5($author$project$Components$GlobalSearch$update, model.D5, model.ZD, model.WF, subMsg, model.fJ);
					var globalSearch = _v21.a;
					var globalSearchCmd = _v21.b;
					var globalSearchOutMsgs = _v21.c;
					var _v22 = A2(
						$author$project$Shared$updateFromOutMsgs,
						globalSearchOutMsgs,
						_Utils_update(
							model,
							{fJ: globalSearch}));
					var newModel = _v22.a;
					var outCmd = _v22.b;
					return _Utils_Tuple2(
						newModel,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Shared$GlobalSearchMsg, globalSearchCmd),
									outCmd
								])));
				case 12:
					var result = msg.a;
					if (!result.$) {
						var result_ = result.a;
						var maybeAuthToken = A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, result_.pi);
						var apiClient = A2($author$project$Api$Data$clientWithAuthToken, maybeAuthToken, model.D5);
						return $author$project$Api$Data$clientHasAuthToken(apiClient) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{pi: maybeAuthToken, D5: apiClient, ZD: $author$project$Api$Data$Loading}),
							A2(
								$author$project$Api$Platform$Session$retrieve,
								apiClient,
								$author$project$Shared$GotSessionCreated(result_.af7))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var error = result.a;
						return _Utils_Tuple2(
							model,
							$author$project$Ports$Sentry$captureErrorMessage('Session create failed: ' + error));
					}
				case 13:
					var redirectToURI = msg.a;
					var response = msg.b;
					_v24$2:
					while (true) {
						switch (response.$) {
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{ZD: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v24$2;
								}
							case 3:
								var session = response.a;
								var validatedRedirectToURI = A2($author$project$Shared$validateRedirectUrl, model.aav.VL, redirectToURI);
								var finalRedirectToURI = function () {
									var _v26 = $author$project$Api$Platform$Session$One$organization(session);
									if (!_v26.$) {
										var session_ = _v26.a;
										return $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding(session_) ? $elm$core$Maybe$Nothing : validatedRedirectToURI;
									} else {
										return validatedRedirectToURI;
									}
								}();
								var navigateTo = A2(
									$elm$core$Maybe$withDefault,
									A2(
										$author$project$Utils$Route$navigate,
										$elm$core$Dict$empty,
										A2($author$project$Permission$homeStateFor, session, model.adN)),
									A2(
										$elm$core$Maybe$map,
										function (uri) {
											var query = A2(
												$elm$core$Maybe$withDefault,
												$elm$core$Dict$empty,
												A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, uri.Bi));
											return A3(
												$author$project$Utils$Route$navigateWithFragment,
												query,
												uri.adz,
												$author$project$Utils$Route$fromUrl(uri));
										},
										A2($elm$core$Maybe$andThen, $elm$url$Url$fromString, finalRedirectToURI)));
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{ZD: response}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A2($author$project$Api$Platform$User$retrieve, model.D5, $author$project$Shared$GotUser),
												navigateTo,
												A2(
												$elm$core$Task$perform,
												function (_v25) {
													return $author$project$Shared$GotSession(response);
												},
												$elm$core$Process$sleep(0)),
												A3($author$project$Shared$switchToPracticeWithQueryParam, model.D5, model.adu.abt, model.aav)
											])));
							default:
								break _v24$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ZD: response}),
						$elm$core$Platform$Cmd$none);
				case 14:
					var releaseMsg = msg.a;
					var _v27 = A2($author$project$Utils$Release$update, releaseMsg, model.agf);
					var release = _v27.a;
					var releaseCmd = _v27.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{agf: release}),
						A2($elm$core$Platform$Cmd$map, $author$project$Shared$ReleaseMsg, releaseCmd));
				case 15:
					var subMsg = msg.a;
					var accountLockedModalCmd = $author$project$Components$AccountLockedModal$update(subMsg);
					return _Utils_Tuple2(
						model,
						A2($elm$core$Platform$Cmd$map, $author$project$Shared$AccountLockedModalMsg, accountLockedModalCmd));
				case 16:
					var toastMsg = msg.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (toastr) {
							return _Utils_update(
								model,
								{kv: toastr});
						},
						A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Shared$ToastMsg),
							A2($author$project$Ui$Toast$update, toastMsg, model.kv)));
				case 17:
					var navbarMsg = msg.a;
					var _v28 = $author$project$Navbar$extractOrgSwitcherMsg(navbarMsg);
					if (!_v28.$) {
						var orgSwitcherMsg = _v28.a;
						var $temp$msg = $author$project$Shared$OrganizationSwitcherMsg(orgSwitcherMsg),
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						var _v29 = model.ad;
						if (!_v29.$) {
							var navbar = _v29.a;
							var _v30 = A3($author$project$Navbar$update, model.D5, navbarMsg, navbar);
							var navbar_ = _v30.a;
							var navbarCmd = _v30.b;
							var navbarOutMsgs = _v30.c;
							var _v31 = A3(
								$elm$core$List$foldl,
								$author$project$Shared$updateFromOutMsg,
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											ad: $elm$core$Maybe$Just(navbar_)
										}),
									$elm$core$Platform$Cmd$none),
								navbarOutMsgs);
							var modelWithOutMsgs = _v31.a;
							var outMsgCmd = _v31.b;
							return _Utils_Tuple2(
								modelWithOutMsgs,
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($elm$core$Platform$Cmd$map, $author$project$Shared$NavbarMsg, navbarCmd),
											outMsgCmd
										])));
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}
				case 18:
					return _Utils_Tuple2(model, $author$project$Shared$deidentifyOnExternalServices);
				case 19:
					var postOrganizationSwitchedAction_ = msg.a;
					var response = msg.b;
					_v32$4:
					while (true) {
						switch (response.$) {
							case 3:
								var authToken = response.a;
								return A3(
									$author$project$Shared$scheduleOrgSwitchRedirect,
									model,
									postOrganizationSwitchedAction_,
									A2($author$project$Shared$storeAuthToken, authToken, true));
							case 2:
								switch (response.a.$) {
									case 9:
										return _Utils_Tuple2(
											model,
											$author$project$Ports$Session$logout(
												{af6: true}));
									case 0:
										return _Utils_Tuple2(
											model,
											$author$project$Ports$Session$logout(
												{af6: true}));
									case 7:
										var error = response.a.a;
										return _Utils_Tuple2(
											model,
											$author$project$Shared$decodeErrorToMsg(error));
									default:
										break _v32$4;
								}
							default:
								break _v32$4;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 20:
					var switchOrganizationFrom = msg.a;
					var response = msg.b;
					_v33$2:
					while (true) {
						switch (response.$) {
							case 3:
								var practices = response.a;
								var _v34 = $elm$core$List$head(practices);
								if (!_v34.$) {
									var practice = _v34.a;
									return model.adu.abt ? _Utils_Tuple2(
										model,
										A4(
											$author$project$Api$Auth$switchToOrganization,
											model.D5,
											$author$project$Api$Platform$Practice$All$organizationId(practice),
											$elm$core$Maybe$Nothing,
											$author$project$Shared$BackupAuthOrganizationSwitched(
												$author$project$Shared$postOrganizationSwitchedAction(switchOrganizationFrom)))) : A3(
										$author$project$Shared$scheduleOrgSwitchRedirect,
										model,
										$author$project$Shared$postOrganizationSwitchedAction(switchOrganizationFrom),
										$author$project$Ports$Session$switchTenant(
											$author$project$Api$Platform$Practice$All$organizationId(practice)));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										model,
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v33$2;
								}
							default:
								break _v33$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 21:
					var switchOrganizationFrom = msg.a;
					var response = msg.b;
					_v35$2:
					while (true) {
						switch (response.$) {
							case 3:
								var partners = response.a;
								var _v36 = $elm$core$List$head(partners);
								if (!_v36.$) {
									var partner = _v36.a;
									return model.adu.abt ? _Utils_Tuple2(
										model,
										A4(
											$author$project$Api$Auth$switchToOrganization,
											model.D5,
											$author$project$Api$Platform$Partner$All$organizationId(partner),
											$elm$core$Maybe$Nothing,
											$author$project$Shared$BackupAuthOrganizationSwitched(
												$author$project$Shared$postOrganizationSwitchedAction(switchOrganizationFrom)))) : A3(
										$author$project$Shared$scheduleOrgSwitchRedirect,
										model,
										$author$project$Shared$postOrganizationSwitchedAction(switchOrganizationFrom),
										$author$project$Ports$Session$switchTenant(
											$author$project$Api$Platform$Partner$All$organizationId(partner)));
								} else {
									return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
								}
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										model,
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v35$2;
								}
							default:
								break _v35$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 22:
					var _v37 = model.V9;
					if (!_v37.$) {
						var _v38 = _v37.a;
						var url = _v38.a;
						var isLocal = _v38.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{afI: $elm$core$Maybe$Nothing}),
							A3($author$project$Ports$Navigation$requestUrl, url, isLocal, false));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 23:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{V9: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 24:
					var patientId = msg.a;
					var response = msg.b;
					_v39$2:
					while (true) {
						if (response.$ === 2) {
							switch (response.a.$) {
								case 5:
									var _v40 = response.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{Mw: response}),
										A4(
											$author$project$Api$Platform$User$Practice$list,
											model.D5,
											function (d) {
												return _Utils_update(
													d,
													{
														af_: $elm$core$Maybe$Just(patientId)
													});
											},
											$elm$core$Maybe$Nothing,
											$author$project$Shared$GotUserPractices(
												$author$project$Shared$Patient(patientId))));
								case 7:
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{Mw: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								default:
									break _v39$2;
							}
						} else {
							break _v39$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{Mw: response}),
						$elm$core$Platform$Cmd$none);
				case 25:
					var response = msg.a;
					_v41$2:
					while (true) {
						switch (response.$) {
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										_Utils_update(
											model,
											{aa1: response}),
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v41$2;
								}
							case 3:
								var whitelabelSetting_ = response.a;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{aa1: response}),
									$author$project$Shared$setFaviconUrls(whitelabelSetting_));
							default:
								break _v41$2;
						}
					}
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aa1: response}),
						$elm$core$Platform$Cmd$none);
				case 26:
					var authTokenData = msg.a;
					_v42$4:
					while (true) {
						switch (authTokenData.$) {
							case 3:
								var authToken = authTokenData.a;
								return _Utils_Tuple2(
									model,
									A2($author$project$Shared$storeAuthToken, authToken, true));
							case 2:
								switch (authTokenData.a.$) {
									case 9:
										return _Utils_Tuple2(
											_Utils_update(
												model,
												{sK: true}),
											$elm$core$Platform$Cmd$none);
									case 0:
										return _Utils_Tuple2(
											model,
											$author$project$Ports$Session$logout(
												{af6: true}));
									case 7:
										var error = authTokenData.a.a;
										return _Utils_Tuple2(
											model,
											$author$project$Shared$decodeErrorToMsg(error));
									default:
										break _v42$4;
								}
							default:
								break _v42$4;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 27:
					return _Utils_Tuple2(
						model,
						$author$project$Shared$refreshToken(model.D5));
				case 28:
					var signOutNow = msg.a;
					var newModel = _Utils_update(
						model,
						{sK: false});
					return signOutNow ? _Utils_Tuple2(
						newModel,
						$author$project$Ports$Session$logout(
							{af6: true})) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
				case 29:
					var subMsg = msg.a;
					var _v43 = model.ga;
					if (!_v43.$) {
						var switcher = _v43.a;
						var _v44 = A2($author$project$Components$OrganizationSwitcher$update, subMsg, switcher);
						var newSwitcher = _v44.a;
						var switcherCmd = _v44.b;
						var outMsgs = _v44.c;
						var _v45 = A2(
							$author$project$Shared$updateFromOutMsgs,
							outMsgs,
							_Utils_update(
								model,
								{
									ga: $elm$core$Maybe$Just(newSwitcher)
								}));
						var updatedModel = _v45.a;
						var outMsgCmd = _v45.b;
						return _Utils_Tuple2(
							updatedModel,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($elm$core$Platform$Cmd$map, $author$project$Shared$OrganizationSwitcherMsg, switcherCmd),
										outMsgCmd
									])));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				default:
					var response = msg.a;
					_v46$2:
					while (true) {
						switch (response.$) {
							case 3:
								var session_ = response.a;
								var scheduledModel = _Utils_update(
									model,
									{ad: $elm$core$Maybe$Nothing, ej: $author$project$OutMsg$GoToDefaultStateAction, WF: $author$project$Api$Data$NotAsked, gU: true});
								return A4($author$project$Shared$applySession, response, session_, scheduledModel, $elm$core$Platform$Cmd$none);
							case 2:
								if (response.a.$ === 7) {
									var error = response.a.a;
									return _Utils_Tuple2(
										model,
										$author$project$Shared$decodeErrorToMsg(error));
								} else {
									break _v46$2;
								}
							default:
								break _v46$2;
						}
					}
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Spa$Generated$Pages$update = F2(
	function (bigMsg, bigModel) {
		var _v0 = _Utils_Tuple2(bigMsg, bigModel);
		_v0$325:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dv.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tE.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vH.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vP.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 4:
					if (_v0.b.$ === 4) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ao.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 5:
					if (_v0.b.$ === 5) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.x$.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 6:
					if (_v0.b.$ === 6) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yD.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 7:
					if (_v0.b.$ === 7) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yE.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 8:
					if (_v0.b.$ === 8) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.rA.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 9:
					if (_v0.b.$ === 9) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zX.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 10:
					if (_v0.b.$ === 10) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u6.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 11:
					if (_v0.b.$ === 11) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vi.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 12:
					if (_v0.b.$ === 12) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wG.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 13:
					if (_v0.b.$ === 13) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xG.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 14:
					if (_v0.b.$ === 14) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yP.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 15:
					if (_v0.b.$ === 15) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AG.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 16:
					if (_v0.b.$ === 16) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A5.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 17:
					if (_v0.b.$ === 17) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dc.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 18:
					if (_v0.b.$ === 18) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dp.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 19:
					if (_v0.b.$ === 19) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tN.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 20:
					if (_v0.b.$ === 20) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tU.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 21:
					if (_v0.b.$ === 21) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tW.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 22:
					if (_v0.b.$ === 22) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tX.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 23:
					if (_v0.b.$ === 23) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tY.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 24:
					if (_v0.b.$ === 24) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t1.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 25:
					if (_v0.b.$ === 25) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t5.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 26:
					if (_v0.b.$ === 26) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t9.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 27:
					if (_v0.b.$ === 27) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.un.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 28:
					if (_v0.b.$ === 28) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.us.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 29:
					if (_v0.b.$ === 29) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ut.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 30:
					if (_v0.b.$ === 30) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uv.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 31:
					if (_v0.b.$ === 31) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uw.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 32:
					if (_v0.b.$ === 32) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ux.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 33:
					if (_v0.b.$ === 33) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uy.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 34:
					if (_v0.b.$ === 34) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uz.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 35:
					if (_v0.b.$ === 35) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uA.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 36:
					if (_v0.b.$ === 36) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uI.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 37:
					if (_v0.b.$ === 37) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uJ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 38:
					if (_v0.b.$ === 38) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uL.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 39:
					if (_v0.b.$ === 39) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uM.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 40:
					if (_v0.b.$ === 40) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uS.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 41:
					if (_v0.b.$ === 41) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uT.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 42:
					if (_v0.b.$ === 42) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uX.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 43:
					if (_v0.b.$ === 43) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uY.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 44:
					if (_v0.b.$ === 44) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uZ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 45:
					if (_v0.b.$ === 45) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u1.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 46:
					if (_v0.b.$ === 46) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u2.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 47:
					if (_v0.b.$ === 47) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u3.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 48:
					if (_v0.b.$ === 48) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vg.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 49:
					if (_v0.b.$ === 49) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vh.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 50:
					if (_v0.b.$ === 50) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v0.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 51:
					if (_v0.b.$ === 51) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wl.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 52:
					if (_v0.b.$ === 52) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wF.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 53:
					if (_v0.b.$ === 53) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wJ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 54:
					if (_v0.b.$ === 54) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wK.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 55:
					if (_v0.b.$ === 55) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xF.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 56:
					if (_v0.b.$ === 56) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xV.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 57:
					if (_v0.b.$ === 57) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xW.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 58:
					if (_v0.b.$ === 58) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xX.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 59:
					if (_v0.b.$ === 59) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xY.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 60:
					if (_v0.b.$ === 60) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xZ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 61:
					if (_v0.b.$ === 61) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.x_.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 62:
					if (_v0.b.$ === 62) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yc.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 63:
					if (_v0.b.$ === 63) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yd.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 64:
					if (_v0.b.$ === 64) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ye.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 65:
					if (_v0.b.$ === 65) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yK.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 66:
					if (_v0.b.$ === 66) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yX.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 67:
					if (_v0.b.$ === 67) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yY.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 68:
					if (_v0.b.$ === 68) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.y$.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 69:
					if (_v0.b.$ === 69) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.y0.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 70:
					if (_v0.b.$ === 70) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.y1.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 71:
					if (_v0.b.$ === 71) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.y5.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 72:
					if (_v0.b.$ === 72) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zn.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 73:
					if (_v0.b.$ === 73) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zo.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 74:
					if (_v0.b.$ === 74) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zr.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 75:
					if (_v0.b.$ === 75) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zs.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 76:
					if (_v0.b.$ === 76) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zF.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 77:
					if (_v0.b.$ === 77) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z6.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 78:
					if (_v0.b.$ === 78) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z7.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 79:
					if (_v0.b.$ === 79) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Aa.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 80:
					if (_v0.b.$ === 80) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ab.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 81:
					if (_v0.b.$ === 81) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ad.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 82:
					if (_v0.b.$ === 82) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Aj.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 83:
					if (_v0.b.$ === 83) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ak.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 84:
					if (_v0.b.$ === 84) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Aq.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 85:
					if (_v0.b.$ === 85) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AH.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 86:
					if (_v0.b.$ === 86) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AX.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 87:
					if (_v0.b.$ === 87) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AY.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 88:
					if (_v0.b.$ === 88) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AZ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 89:
					if (_v0.b.$ === 89) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A_.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 90:
					if (_v0.b.$ === 90) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A$.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 91:
					if (_v0.b.$ === 91) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A0.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 92:
					if (_v0.b.$ === 92) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A1.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 93:
					if (_v0.b.$ === 93) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A4.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 94:
					if (_v0.b.$ === 94) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bv.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 95:
					if (_v0.b.$ === 95) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bw.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 96:
					if (_v0.b.$ === 96) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.By.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 97:
					if (_v0.b.$ === 97) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BC.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 98:
					if (_v0.b.$ === 98) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BD.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 99:
					if (_v0.b.$ === 99) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BF.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 100:
					if (_v0.b.$ === 100) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BG.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 101:
					if (_v0.b.$ === 101) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BH.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 102:
					if (_v0.b.$ === 102) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BI.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 103:
					if (_v0.b.$ === 103) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BJ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 104:
					if (_v0.b.$ === 104) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BK.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 105:
					if (_v0.b.$ === 105) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BM.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 106:
					if (_v0.b.$ === 106) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BO.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 107:
					if (_v0.b.$ === 107) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BQ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 108:
					if (_v0.b.$ === 108) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cx.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 109:
					if (_v0.b.$ === 109) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cy.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 110:
					if (_v0.b.$ === 110) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Cz.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 111:
					if (_v0.b.$ === 111) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CA.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 112:
					if (_v0.b.$ === 112) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CB.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 113:
					if (_v0.b.$ === 113) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CC.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 114:
					if (_v0.b.$ === 114) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CD.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 115:
					if (_v0.b.$ === 115) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CE.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 116:
					if (_v0.b.$ === 116) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CF.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 117:
					if (_v0.b.$ === 117) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CG.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 118:
					if (_v0.b.$ === 118) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CH.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 119:
					if (_v0.b.$ === 119) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CI.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 120:
					if (_v0.b.$ === 120) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CJ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 121:
					if (_v0.b.$ === 121) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CK.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 122:
					if (_v0.b.$ === 122) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CL.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 123:
					if (_v0.b.$ === 123) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CM.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 124:
					if (_v0.b.$ === 124) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CN.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 125:
					if (_v0.b.$ === 125) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CO.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 126:
					if (_v0.b.$ === 126) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CP.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 127:
					if (_v0.b.$ === 127) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CQ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 128:
					if (_v0.b.$ === 128) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CR.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 129:
					if (_v0.b.$ === 129) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CS.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 130:
					if (_v0.b.$ === 130) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CT.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 131:
					if (_v0.b.$ === 131) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CU.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 132:
					if (_v0.b.$ === 132) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CV.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 133:
					if (_v0.b.$ === 133) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CW.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 134:
					if (_v0.b.$ === 134) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CX.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 135:
					if (_v0.b.$ === 135) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CY.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 136:
					if (_v0.b.$ === 136) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.CZ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 137:
					if (_v0.b.$ === 137) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C_.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 138:
					if (_v0.b.$ === 138) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C$.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 139:
					if (_v0.b.$ === 139) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C0.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 140:
					if (_v0.b.$ === 140) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C1.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 141:
					if (_v0.b.$ === 141) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C2.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 142:
					if (_v0.b.$ === 142) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C3.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 143:
					if (_v0.b.$ === 143) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C4.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 144:
					if (_v0.b.$ === 144) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C5.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 145:
					if (_v0.b.$ === 145) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C6.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 146:
					if (_v0.b.$ === 146) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C7.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 147:
					if (_v0.b.$ === 147) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C8.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 148:
					if (_v0.b.$ === 148) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.C9.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 149:
					if (_v0.b.$ === 149) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Da.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 150:
					if (_v0.b.$ === 150) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Db.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 151:
					if (_v0.b.$ === 151) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dd.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 152:
					if (_v0.b.$ === 152) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.De.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 153:
					if (_v0.b.$ === 153) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Df.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 154:
					if (_v0.b.$ === 154) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dg.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 155:
					if (_v0.b.$ === 155) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Di.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 156:
					if (_v0.b.$ === 156) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Dn.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 157:
					if (_v0.b.$ === 157) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DG.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 158:
					if (_v0.b.$ === 158) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DH.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 159:
					if (_v0.b.$ === 159) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DJ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 160:
					if (_v0.b.$ === 160) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DK.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 161:
					if (_v0.b.$ === 161) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vr.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 162:
					if (_v0.b.$ === 162) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xt.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 163:
					if (_v0.b.$ === 163) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yp.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 164:
					if (_v0.b.$ === 164) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yL.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 165:
					if (_v0.b.$ === 165) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tT.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 166:
					if (_v0.b.$ === 166) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t$.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 167:
					if (_v0.b.$ === 167) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t4.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 168:
					if (_v0.b.$ === 168) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t8.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 169:
					if (_v0.b.$ === 169) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uf.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 170:
					if (_v0.b.$ === 170) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ud.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 171:
					if (_v0.b.$ === 171) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.um.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 172:
					if (_v0.b.$ === 172) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ur.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 173:
					if (_v0.b.$ === 173) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uR.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 174:
					if (_v0.b.$ === 174) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uU.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 175:
					if (_v0.b.$ === 175) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uW.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 176:
					if (_v0.b.$ === 176) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u0.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 177:
					if (_v0.b.$ === 177) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wi.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 178:
					if (_v0.b.$ === 178) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wk.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 179:
					if (_v0.b.$ === 179) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wB.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 180:
					if (_v0.b.$ === 180) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wI.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 181:
					if (_v0.b.$ === 181) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xU.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 182:
					if (_v0.b.$ === 182) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yb.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 183:
					if (_v0.b.$ === 183) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.y_.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 184:
					if (_v0.b.$ === 184) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.y4.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 185:
					if (_v0.b.$ === 185) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zm.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 186:
					if (_v0.b.$ === 186) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zq.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 187:
					if (_v0.b.$ === 187) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zx.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 188:
					if (_v0.b.$ === 188) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zS.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 189:
					if (_v0.b.$ === 189) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z9.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 190:
					if (_v0.b.$ === 190) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ac.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 191:
					if (_v0.b.$ === 191) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ai.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 192:
					if (_v0.b.$ === 192) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AF.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 193:
					if (_v0.b.$ === 193) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bu.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 194:
					if (_v0.b.$ === 194) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Do.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 195:
					if (_v0.b.$ === 195) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.DI.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 196:
					if (_v0.b.$ === 196) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tO.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 197:
					if (_v0.b.$ === 197) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tP.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 198:
					if (_v0.b.$ === 198) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tQ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 199:
					if (_v0.b.$ === 199) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tR.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 200:
					if (_v0.b.$ === 200) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tS.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 201:
					if (_v0.b.$ === 201) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t_.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 202:
					if (_v0.b.$ === 202) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t0.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 203:
					if (_v0.b.$ === 203) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t3.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 204:
					if (_v0.b.$ === 204) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t7.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 205:
					if (_v0.b.$ === 205) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ua.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 206:
					if (_v0.b.$ === 206) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uc.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 207:
					if (_v0.b.$ === 207) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ug.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 208:
					if (_v0.b.$ === 208) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uh.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 209:
					if (_v0.b.$ === 209) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ui.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 210:
					if (_v0.b.$ === 210) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uj.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 211:
					if (_v0.b.$ === 211) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ul.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 212:
					if (_v0.b.$ === 212) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uo.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 213:
					if (_v0.b.$ === 213) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.up.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 214:
					if (_v0.b.$ === 214) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uq.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 215:
					if (_v0.b.$ === 215) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uB.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 216:
					if (_v0.b.$ === 216) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uC.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 217:
					if (_v0.b.$ === 217) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uD.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 218:
					if (_v0.b.$ === 218) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uE.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 219:
					if (_v0.b.$ === 219) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uG.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 220:
					if (_v0.b.$ === 220) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uH.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 221:
					if (_v0.b.$ === 221) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uK.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 222:
					if (_v0.b.$ === 222) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uQ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 223:
					if (_v0.b.$ === 223) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uV.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 224:
					if (_v0.b.$ === 224) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u$.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 225:
					if (_v0.b.$ === 225) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u4.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 226:
					if (_v0.b.$ === 226) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u8.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 227:
					if (_v0.b.$ === 227) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vb.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 228:
					if (_v0.b.$ === 228) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vc.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 229:
					if (_v0.b.$ === 229) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vd.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 230:
					if (_v0.b.$ === 230) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ve.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 231:
					if (_v0.b.$ === 231) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.vf.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 232:
					if (_v0.b.$ === 232) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wh.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 233:
					if (_v0.b.$ === 233) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wj.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 234:
					if (_v0.b.$ === 234) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wm.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 235:
					if (_v0.b.$ === 235) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wn.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 236:
					if (_v0.b.$ === 236) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wr.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 237:
					if (_v0.b.$ === 237) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ws.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 238:
					if (_v0.b.$ === 238) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wv.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 239:
					if (_v0.b.$ === 239) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ww.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 240:
					if (_v0.b.$ === 240) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wx.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 241:
					if (_v0.b.$ === 241) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wy.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 242:
					if (_v0.b.$ === 242) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yZ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 243:
					if (_v0.b.$ === 243) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.y2.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 244:
					if (_v0.b.$ === 244) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zl.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 245:
					if (_v0.b.$ === 245) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zv.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 246:
					if (_v0.b.$ === 246) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zT.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 247:
					if (_v0.b.$ === 247) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zU.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 248:
					if (_v0.b.$ === 248) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zV.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 249:
					if (_v0.b.$ === 249) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zW.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 250:
					if (_v0.b.$ === 250) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.z8.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 251:
					if (_v0.b.$ === 251) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ae.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 252:
					if (_v0.b.$ === 252) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Af.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 253:
					if (_v0.b.$ === 253) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ag.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 254:
					if (_v0.b.$ === 254) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ah.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 255:
					if (_v0.b.$ === 255) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Aw.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 256:
					if (_v0.b.$ === 256) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ax.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 257:
					if (_v0.b.$ === 257) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ay.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 258:
					if (_v0.b.$ === 258) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AC.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 259:
					if (_v0.b.$ === 259) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A3.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 260:
					if (_v0.b.$ === 260) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bx.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 261:
					if (_v0.b.$ === 261) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bz.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 262:
					if (_v0.b.$ === 262) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BB.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 263:
					if (_v0.b.$ === 263) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BE.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 264:
					if (_v0.b.$ === 264) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BL.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 265:
					if (_v0.b.$ === 265) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BN.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 266:
					if (_v0.b.$ === 266) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BP.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 267:
					if (_v0.b.$ === 267) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tZ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 268:
					if (_v0.b.$ === 268) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t2.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 269:
					if (_v0.b.$ === 269) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.t6.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 270:
					if (_v0.b.$ === 270) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ue.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 271:
					if (_v0.b.$ === 271) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.ub.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 272:
					if (_v0.b.$ === 272) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uk.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 273:
					if (_v0.b.$ === 273) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uu.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 274:
					if (_v0.b.$ === 274) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uN.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 275:
					if (_v0.b.$ === 275) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u_.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 276:
					if (_v0.b.$ === 276) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.xT.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 277:
					if (_v0.b.$ === 277) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zk.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 278:
					if (_v0.b.$ === 278) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zp.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 279:
					if (_v0.b.$ === 279) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zt.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 280:
					if (_v0.b.$ === 280) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zw.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 281:
					if (_v0.b.$ === 281) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Bt.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 282:
					if (_v0.b.$ === 282) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.BA.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 283:
					if (_v0.b.$ === 283) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.va.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 284:
					if (_v0.b.$ === 284) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wg.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 285:
					if (_v0.b.$ === 285) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wq.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 286:
					if (_v0.b.$ === 286) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wu.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 287:
					if (_v0.b.$ === 287) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wC.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 288:
					if (_v0.b.$ === 288) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.y3.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 289:
					if (_v0.b.$ === 289) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Ar.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 290:
					if (_v0.b.$ === 290) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.As.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 291:
					if (_v0.b.$ === 291) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Av.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 292:
					if (_v0.b.$ === 292) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AB.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 293:
					if (_v0.b.$ === 293) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AD.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 294:
					if (_v0.b.$ === 294) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AE.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 295:
					if (_v0.b.$ === 295) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uF.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 296:
					if (_v0.b.$ === 296) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wc.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 297:
					if (_v0.b.$ === 297) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wd.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 298:
					if (_v0.b.$ === 298) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wo.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 299:
					if (_v0.b.$ === 299) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wA.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 300:
					if (_v0.b.$ === 300) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yJ.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 301:
					if (_v0.b.$ === 301) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yM.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 302:
					if (_v0.b.$ === 302) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yN.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 303:
					if (_v0.b.$ === 303) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.yO.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 304:
					if (_v0.b.$ === 304) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.zu.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 305:
					if (_v0.b.$ === 305) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.AA.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 306:
					if (_v0.b.$ === 306) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.A2.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 307:
					if (_v0.b.$ === 307) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.tV.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 308:
					if (_v0.b.$ === 308) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.u9.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 309:
					if (_v0.b.$ === 309) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wt.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 310:
					if (_v0.b.$ === 310) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wz.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 311:
					if (_v0.b.$ === 311) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wb.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 312:
					if (_v0.b.$ === 312) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wf.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 313:
					if (_v0.b.$ === 313) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wD.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 314:
					if (_v0.b.$ === 314) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.At.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 315:
					if (_v0.b.$ === 315) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Au.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 316:
					if (_v0.b.$ === 316) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.Az.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 317:
					if (_v0.b.$ === 317) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uO.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 318:
					if (_v0.b.$ === 318) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v9.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 319:
					if (_v0.b.$ === 319) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wa.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 320:
					if (_v0.b.$ === 320) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wE.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 321:
					if (_v0.b.$ === 321) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.uP.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 322:
					if (_v0.b.$ === 322) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.we.aaq, msg, model);
					} else {
						break _v0$325;
					}
				case 323:
					if (_v0.b.$ === 323) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.v8.aaq, msg, model);
					} else {
						break _v0$325;
					}
				default:
					if (_v0.b.$ === 324) {
						var msg = _v0.a.a;
						var model = _v0.b.a;
						return A2($author$project$Spa$Generated$Pages$pages.wp.aaq, msg, model);
					} else {
						break _v0$325;
					}
			}
		}
		return _Utils_Tuple3(bigModel, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Layouts$Admin$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
				A2(
					$elm$core$Tuple$mapFirst,
					function (nav) {
						return _Utils_update(
							model,
							{m8: nav});
					},
					A2($author$project$Ui$Nav$update, navMsg, model.m8))));
	});
var $author$project$Layouts$Affiliates$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$elm$core$Tuple$mapFirst,
				function (nav) {
					return _Utils_update(
						model,
						{m8: nav});
				},
				A2($author$project$Ui$Nav$update, navMsg, model.m8)));
	});
var $author$project$Layouts$Affiliates$Affiliate$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{DZ: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		} else {
			var navMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$fromTuple2,
				_List_Nil,
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Layouts$Affiliates$Affiliate$NavMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (nav) {
							return _Utils_update(
								model,
								{m8: nav});
						},
						A2($author$project$Ui$Nav$update, navMsg, model.m8))));
		}
	});
var $author$project$Layouts$Commissions$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$elm$core$Tuple$mapFirst,
				function (nav) {
					return _Utils_update(
						model,
						{m8: nav});
				},
				A2($author$project$Ui$Nav$update, navMsg, model.m8)));
	});
var $author$project$Layouts$Commissions$BrokerAccount$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{vK: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		} else {
			var navMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$fromTuple2,
				_List_Nil,
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Layouts$Commissions$BrokerAccount$NavMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (nav) {
							return _Utils_update(
								model,
								{m8: nav});
						},
						A2($author$project$Ui$Nav$update, navMsg, model.m8))));
		}
	});
var $author$project$Layouts$Company$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$elm$core$Tuple$mapFirst,
				function (nav) {
					return _Utils_update(
						model,
						{m8: nav});
				},
				A2($author$project$Ui$Nav$update, navMsg, model.m8)));
	});
var $author$project$Layouts$Marketplace$Manage$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var navMsg = msg.a;
			return A2(
				$author$project$Utils$Tuple3$fromTuple2,
				_List_Nil,
				A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Layouts$Marketplace$Manage$NavMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						function (nav) {
							return _Utils_update(
								model,
								{m8: nav});
						},
						A2($author$project$Ui$Nav$update, navMsg, model.m8))));
		} else {
			var response = msg.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{Q4: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$OutMsg$handleErrorResponse(response));
		}
	});
var $author$project$Layouts$Partner$Billing$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
				A2(
					$elm$core$Tuple$mapFirst,
					function (nav) {
						return _Utils_update(
							model,
							{m8: nav});
					},
					A2($author$project$Ui$Nav$update, navMsg, model.m8))));
	});
var $author$project$Layouts$Partner$Practices$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
				A2(
					$elm$core$Tuple$mapFirst,
					function (nav) {
						return _Utils_update(
							model,
							{m8: nav});
					},
					A2($author$project$Ui$Nav$update, navMsg, model.m8))));
	});
var $author$project$Layouts$Partner$Product$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$author$project$Utils$Tuple3$fromTuple2,
			_List_Nil,
			A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
				A2(
					$elm$core$Tuple$mapFirst,
					function (nav) {
						return _Utils_update(
							model,
							{m8: nav});
					},
					A2($author$project$Ui$Nav$update, navMsg, model.m8))));
	});
var $author$project$Layouts$Patient$GotAffiliateSyncDetail = function (a) {
	return {$: 4, a: a};
};
var $author$project$Layouts$Patient$GotNetworkSyncDetail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Provider$Organization$Min$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$Organization$Shared$id = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Organization$Min$id(min);
};
var $author$project$Api$Provider$Patient$SyncDetail$Network = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$SyncDetail$networkDecoder = $elm$json$Json$Decode$nullable(
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
		$author$project$Api$Provider$Patient$SyncDetail$recordDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['affiliate', 'name']),
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Network))));
var $author$project$Api$Provider$SyncDetail$retrieveNetwork = F3(
	function (apiClient, patientId, toMsg) {
		return A4(
			$author$project$Api$Data$get,
			apiClient,
			$author$project$Api$Provider$Patient$SyncDetail$networkDecoder,
			toMsg,
			$author$project$Api$Data$requestTo(
				A2(
					$author$project$Api$Data$pathAppend,
					_List_fromArray(
						['sync_details', 'network']),
					$author$project$Api$Provider$Patient$patientPath(patientId))));
	});
var $author$project$Layouts$Patient$update = F3(
	function (apiClient, msg, model) {
		switch (msg.$) {
			case 0:
				var navMsg = msg.a;
				return A2(
					$author$project$Utils$Tuple3$fromTuple2,
					_List_Nil,
					A2(
						$elm$core$Tuple$mapSecond,
						$elm$core$Platform$Cmd$map($author$project$Layouts$Patient$NavMsg),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newNav) {
								return _Utils_update(
									model,
									{m8: newNav});
							},
							A2($author$project$Ui$Nav$update, navMsg, model.m8))));
			case 1:
				var _v1 = model.jf;
				if (!_v1.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{jf: $author$project$Api$Data$Loading}),
						A3($author$project$Api$Provider$SyncDetail$retrieveNetwork, apiClient, model.VN, $author$project$Layouts$Patient$GotNetworkSyncDetail),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 3:
				var _v2 = model.ht;
				if (!_v2.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ht: $author$project$Api$Data$Loading}),
						A4($author$project$Api$Provider$SyncDetail$retrieveAffiliate, apiClient, model.VN, $elm$core$Basics$identity, $author$project$Layouts$Patient$GotAffiliateSyncDetail),
						_List_Nil);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				}
			case 2:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{jf: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			case 4:
				var data = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ht: data}),
					$elm$core$Platform$Cmd$none,
					$author$project$OutMsg$handleErrorResponse(data));
			default:
				var organization = msg.a;
				var patientId = msg.b;
				return _Utils_Tuple3(
					model,
					$elm$core$Platform$Cmd$none,
					_List_fromArray(
						[
							A3(
							$author$project$OutMsg$SwitchToOrganization,
							$author$project$Api$Provider$Organization$Shared$id(organization),
							$elm$core$Maybe$Nothing,
							$author$project$OutMsg$GoToRouteAndReloadAction(
								$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
									{VN: patientId})))
						]));
		}
	});
var $author$project$Layouts$User$update = F2(
	function (msg, model) {
		var navMsg = msg;
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map($elm$core$Basics$identity),
			A2(
				$elm$core$Tuple$mapFirst,
				function (nav) {
					return {m8: nav};
				},
				A2($author$project$Ui$Nav$update, navMsg, model.m8)));
	});
var $author$project$Spa$Layout$update = F3(
	function (apiClient, msg, model) {
		var _v0 = _Utils_Tuple2(model, msg);
		_v0$20:
		while (true) {
			switch (_v0.a.$) {
				case 5:
					if (!_v0.b.$) {
						var _v1 = _v0.a;
						var id = _v1.a;
						var layoutModel = _v1.b;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$CommissionsBrokerAccountModel(id),
								A2($author$project$Layouts$Commissions$BrokerAccount$update, subMsg, layoutModel)));
					} else {
						break _v0$20;
					}
				case 7:
					if (_v0.b.$ === 1) {
						var _v2 = _v0.a;
						var id = _v2.a;
						var layoutModel = _v2.b;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$AffiliatesAffiliateModel(id),
								A2($author$project$Layouts$Affiliates$Affiliate$update, subMsg, layoutModel)));
					} else {
						break _v0$20;
					}
				case 8:
					if (_v0.b.$ === 2) {
						var layoutModel = _v0.a.a;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PartnerBillingModel,
								A2($author$project$Layouts$Partner$Billing$update, subMsg, layoutModel)));
					} else {
						break _v0$20;
					}
				case 9:
					if (_v0.b.$ === 3) {
						var layoutModel = _v0.a.a;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PartnerPracticesModel,
								A2($author$project$Layouts$Partner$Practices$update, subMsg, layoutModel)));
					} else {
						break _v0$20;
					}
				case 10:
					if (_v0.b.$ === 4) {
						var layoutModel = _v0.a.a;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PartnerProductModel,
								A2($author$project$Layouts$Partner$Product$update, subMsg, layoutModel)));
					} else {
						break _v0$20;
					}
				case 11:
					if (_v0.b.$ === 5) {
						var _v3 = _v0.a;
						var slug = _v3.a;
						var layoutModel = _v3.b;
						var subMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$MarketplaceManageModel(slug),
								A2($author$project$Layouts$Marketplace$Manage$update, subMsg, layoutModel)));
					} else {
						break _v0$20;
					}
				case 13:
					if (_v0.b.$ === 10) {
						var layout = _v0.a.a;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$AdminModel,
								A2($author$project$Layouts$Admin$update, layoutMsg, layout)));
					} else {
						break _v0$20;
					}
				case 0:
					var _v4 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 17:
					var _v5 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 1:
					var _v6 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 3:
					if (_v0.b.$ === 6) {
						var _v7 = _v0.a;
						var id = _v7.a;
						var layoutModel = _v7.b;
						var patMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg),
							A2(
								$author$project$Utils$Tuple3$mapFirst,
								$author$project$Spa$Layout$PatientAndSidebarModel(id),
								A3($author$project$Layouts$Patient$update, apiClient, patMsg, layoutModel)));
					} else {
						var _v8 = _v0.a;
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
					}
				case 2:
					var _v9 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 12:
					if (_v0.b.$ === 7) {
						var _v10 = _v0.a;
						var id = _v10.a;
						var layout = _v10.b;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Layout$CompanyModel(id),
									A2($author$project$Layouts$Company$update, layoutMsg, layout))));
					} else {
						break _v0$20;
					}
				case 4:
					if (_v0.b.$ === 8) {
						var layout = _v0.a.a;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Layout$CommissionsModel,
									A2($author$project$Layouts$Commissions$update, layoutMsg, layout))));
					} else {
						break _v0$20;
					}
				case 6:
					if (_v0.b.$ === 9) {
						var layout = _v0.a.a;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Layout$AffiliatesModel,
									A2($author$project$Layouts$Affiliates$update, layoutMsg, layout))));
					} else {
						break _v0$20;
					}
				case 18:
					if (_v0.b.$ === 11) {
						var layout = _v0.a.a;
						var layoutMsg = _v0.b.a;
						return A2(
							$author$project$Utils$Tuple3$fromTuple2,
							_List_Nil,
							A2(
								$elm$core$Tuple$mapSecond,
								$elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg),
								A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Spa$Layout$UserModel,
									A2($author$project$Layouts$User$update, layoutMsg, layout))));
					} else {
						break _v0$20;
					}
				case 14:
					var _v11 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 15:
					var _v12 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				case 16:
					var _v13 = _v0.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
				default:
					break _v0$20;
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
	});
var $author$project$Layouts$Admin$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Layouts$Affiliates$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Affiliates$Affiliate$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Commissions$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Commissions$BrokerAccount$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Company$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Marketplace$Manage$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Layouts$Partner$Billing$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Partner$Practices$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Partner$Product$load = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Layouts$Patient$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{VM: shared.Mw}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Layouts$PatientChart$load = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{VM: shared.Mw}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Layouts$User$load = F2(
	function (_v0, model) {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Spa$Layout$load = F2(
	function (shared, model) {
		switch (model.$) {
			case 5:
				var id = model.a;
				var layoutModel = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$CommissionsBrokerAccountModel(id),
						$author$project$Layouts$Commissions$BrokerAccount$load(layoutModel)));
			case 7:
				var id = model.a;
				var layoutModel = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$AffiliatesAffiliateModel(id),
						$author$project$Layouts$Affiliates$Affiliate$load(layoutModel)));
			case 8:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PartnerBillingModel,
						$author$project$Layouts$Partner$Billing$load(layout)));
			case 9:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PartnerPracticesModel,
						$author$project$Layouts$Partner$Practices$load(layout)));
			case 10:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PartnerProductModel,
						$author$project$Layouts$Partner$Product$load(layout)));
			case 11:
				var slug = model.a;
				var layout = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$MarketplaceManageModel(slug),
						A2($author$project$Layouts$Marketplace$Manage$load, shared, layout)));
			case 13:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$AdminModel,
						A2($author$project$Layouts$Admin$load, shared, layout)));
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 17:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 3:
				var id = model.a;
				var layout = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$PatientAndSidebarModel(id),
						A2($author$project$Layouts$Patient$load, shared, layout)));
			case 2:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 12:
				var id = model.a;
				var layout = model.b;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$CompanyModel(id),
						$author$project$Layouts$Company$load(layout)));
			case 4:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$CommissionsModel,
						$author$project$Layouts$Commissions$load(layout)));
			case 6:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Spa$Layout$AffiliatesModel,
					$author$project$Layouts$Affiliates$load(layout));
			case 19:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 18:
				var layout = model.a;
				return A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg),
					A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Spa$Layout$UserModel,
						A2($author$project$Layouts$User$load, shared, layout)));
			case 14:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 15:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var id = model.a;
				var layout = model.b;
				return A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Spa$Layout$PatientChartModel(id),
					A2($author$project$Layouts$PatientChart$load, shared, layout));
		}
	});
var $author$project$Layouts$Marketplace$Manage$refresh = F2(
	function (shared, model) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{Q4: $author$project$Api$Data$Loading}),
			A3($author$project$Api$Provider$Integration$retrieve, shared.D5, model._c, $author$project$Layouts$Marketplace$Manage$GotIntegration));
	});
var $author$project$Spa$Layout$refresh = F2(
	function (shared, model) {
		if (model.$ === 11) {
			var slug = model.a;
			var layout = model.b;
			return A2(
				$elm$core$Tuple$mapSecond,
				$elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg),
				A2(
					$elm$core$Tuple$mapFirst,
					$author$project$Spa$Layout$MarketplaceManageModel(slug),
					A2($author$project$Layouts$Marketplace$Manage$refresh, shared, layout)));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateLayout = F3(
	function (shared, outMsgs, layout) {
		var refreshLayout = A2($elm$core$List$member, $author$project$OutMsg$RefreshLayout, outMsgs);
		return function (_v0) {
			var loadedLayout = _v0.a;
			var loadedLayoutCmd = _v0.b;
			return refreshLayout ? A2(
				$elm$core$Tuple$mapSecond,
				function (refreshLayoutCmd) {
					return $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[loadedLayoutCmd, refreshLayoutCmd]));
				},
				A2($author$project$Spa$Layout$refresh, shared, loadedLayout)) : _Utils_Tuple2(loadedLayout, loadedLayoutCmd);
		}(
			A2($author$project$Spa$Layout$load, shared, layout));
	});
var $author$project$Ports$PageTitle$updateTabTitle = _Platform_outgoingPort('updateTabTitle', $elm$json$Json$Encode$string);
var $author$project$Utils$Release$newReleaseAvailable = function (_v0) {
	var model = _v0;
	return model.zj;
};
var $author$project$Ports$Intercom$intercomPortUpdate = _Platform_outgoingPort(
	'intercomPortUpdate',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Ports$Intercom$update = function (session) {
	return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortUpdate(0);
};
var $author$project$Shared$updateIntercom = function (session) {
	if (session.$ === 3) {
		var session_ = session.a;
		return $author$project$Ports$Intercom$update(session_);
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Components$GlobalSearch$urlChanged = F2(
	function (url, model) {
		if (!model.$) {
			var closedModel = model.a;
			return $author$project$Components$GlobalSearch$Closed(
				_Utils_update(
					closedModel,
					{aav: url}));
		} else {
			var openModel = model.a;
			return $author$project$Components$GlobalSearch$Open(
				_Utils_update(
					openModel,
					{aav: url}));
		}
	});
var $author$project$Components$PatientsList$urlChanged = F2(
	function (url, model) {
		return _Utils_update(
			model,
			{aav: url});
	});
var $author$project$Navbars$Company$urlChanged = F2(
	function (url, _v0) {
		var model = _v0;
		var newSelectedNav = $author$project$Navbars$Company$navItemFromUrl(url);
		return _Utils_update(
			model,
			{
				c1: $author$project$Navbars$Company$openSubNavFromSelectedNav(newSelectedNav),
				ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg),
				eE: newSelectedNav
			});
	});
var $author$project$Navbars$Partner$urlChanged = F2(
	function (url, _v0) {
		var model = _v0;
		var newSelectedNav = $author$project$Navbars$Partner$navItemFromUrl(url);
		return _Utils_update(
			model,
			{
				c1: $author$project$Navbars$Partner$openSubNavFromSelectedNav(newSelectedNav),
				ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg),
				eE: newSelectedNav
			});
	});
var $author$project$Navbars$Practice$urlChanged = F2(
	function (url, _v0) {
		var model = _v0;
		var newSelectedNav = $author$project$Navbars$Practice$Navigation$navItemFromUrl(url);
		return _Utils_update(
			model,
			{
				c1: $author$project$Navbars$Practice$openSubNavFromSelectedNav(newSelectedNav),
				ep: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg),
				eE: newSelectedNav
			});
	});
var $author$project$Navbar$navbarUrlChanged = F2(
	function (url, navBar) {
		switch (navBar.$) {
			case 0:
				return navBar;
			case 1:
				var model = navBar.a;
				return $author$project$Navbar$PracticeNav(
					A2($author$project$Navbars$Practice$urlChanged, url, model));
			case 2:
				var model = navBar.a;
				return $author$project$Navbar$CompanyNav(
					A2($author$project$Navbars$Company$urlChanged, url, model));
			default:
				var model = navBar.a;
				return $author$project$Navbar$PartnerNav(
					A2($author$project$Navbars$Partner$urlChanged, url, model));
		}
	});
var $author$project$Navbar$urlChanged = F2(
	function (url, _v0) {
		var model = _v0;
		return _Utils_update(
			model,
			{
				ac: A2($author$project$Navbar$navbarUrlChanged, url, model.ac),
				aav: url
			});
	});
var $author$project$Shared$urlChanged = F2(
	function (url, model) {
		var session = $author$project$Api$Data$toMaybe(model.ZD);
		var shouldInitNavbar = (!_Utils_eq(session, $elm$core$Maybe$Nothing)) && _Utils_eq(model.ad, $elm$core$Maybe$Nothing);
		var _v0 = shouldInitNavbar ? $author$project$Shared$initNavbar(
			_Utils_Tuple2(
				_Utils_update(
					model,
					{aav: url}),
				$elm$core$Platform$Cmd$none)) : _Utils_Tuple2(
			_Utils_update(
				model,
				{aav: url}),
			$elm$core$Platform$Cmd$none);
		var modelUpdated = _v0.a;
		var navBarResultCmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				modelUpdated,
				{
					fJ: A2($author$project$Components$GlobalSearch$urlChanged, url, modelUpdated.fJ),
					ad: A2(
						$elm$core$Maybe$map,
						$author$project$Navbar$urlChanged(url),
						modelUpdated.ad),
					afE: A2(
						$elm$core$Maybe$map,
						$author$project$Components$PatientsList$urlChanged(url),
						model.afE),
					afI: $elm$core$Maybe$Nothing,
					V9: $elm$core$Maybe$Nothing
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						((!_Utils_eq(model.aav.VL, url.VL)) && $author$project$Utils$Release$newReleaseAvailable(model.agf)) ? $elm$browser$Browser$Navigation$reload : $elm$core$Platform$Cmd$none,
						navBarResultCmd,
						$author$project$Shared$updateIntercom(modelUpdated.ZD)
					])));
	});
var $author$project$Layouts$Admin$initNav = function (model) {
	var _v0 = A2($author$project$Ui$Nav$init, 'admin-nav', $elm$core$Basics$identity);
	var nav = _v0.a;
	var navCmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{m8: nav}),
		navCmd);
};
var $author$project$Ui$Nav$recalculateActiveTab = function (_v0) {
	var model = _v0;
	return $author$project$Ports$NavTabs$navTabActiveChanged(model.adR);
};
var $author$project$Layouts$Patient$refreshNav = function (model) {
	return $author$project$Ui$Nav$recalculateActiveTab(model.m8);
};
var $author$project$Spa$Layout$urlChanged = F2(
	function (shared, layoutModel) {
		var route = $author$project$Utils$Route$fromUrl(shared.aav);
		var _v0 = _Utils_Tuple2(
			$author$project$Spa$Layout$routeToLayout(route),
			layoutModel);
		_v0$14:
		while (true) {
			switch (_v0.a.$) {
				case 12:
					if (_v0.b.$ === 12) {
						var newId = _v0.a.a;
						var _v1 = _v0.b;
						var currentId = _v1.a;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$14;
					}
				case 7:
					if (_v0.b.$ === 7) {
						var newId = _v0.a.a;
						var _v2 = _v0.b;
						var currentId = _v2.a;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$14;
					}
				case 8:
					if (_v0.b.$ === 8) {
						var _v3 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$14;
					}
				case 9:
					if (_v0.b.$ === 9) {
						var _v4 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$14;
					}
				case 11:
					if (_v0.b.$ === 11) {
						var newSlug = _v0.a.a;
						var _v5 = _v0.b;
						var currentSlug = _v5.a;
						return _Utils_eq(newSlug, currentSlug) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$14;
					}
				case 5:
					if (_v0.b.$ === 5) {
						var newId = _v0.a.a;
						var _v6 = _v0.b;
						var currentId = _v6.a;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$14;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var newId = _v0.a.a;
						var _v7 = _v0.b;
						var currentId = _v7.a;
						var patientLayoutModel = _v7.b;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(
							layoutModel,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$Spa$Layout$PatientMsg,
								$author$project$Layouts$Patient$refreshNav(patientLayoutModel))) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$14;
					}
				case 4:
					if (_v0.b.$ === 4) {
						var _v8 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$14;
					}
				case 6:
					if (_v0.b.$ === 6) {
						var _v9 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$14;
					}
				case 13:
					if (_v0.b.$ === 13) {
						var _v10 = _v0.a;
						var adminModel = _v0.b.a;
						return A2(
							$elm$core$Tuple$mapSecond,
							$elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg),
							A2(
								$elm$core$Tuple$mapFirst,
								$author$project$Spa$Layout$AdminModel,
								$author$project$Layouts$Admin$initNav(adminModel)));
					} else {
						break _v0$14;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var _v11 = _v0.a;
						var _v12 = _v0.b;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$14;
					}
				case 16:
					if (_v0.b.$ === 18) {
						var _v13 = _v0.a;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$14;
					}
				case 17:
					if (_v0.b.$ === 15) {
						var _v14 = _v0.a;
						var _v15 = _v0.b;
						return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$14;
					}
				case 18:
					if (_v0.b.$ === 16) {
						var newId = _v0.a.a;
						var _v16 = _v0.b;
						var currentId = _v16.a;
						return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
					} else {
						break _v0$14;
					}
				default:
					break _v0$14;
			}
		}
		return $author$project$Spa$Layout$init(shared);
	});
var $author$project$Spa$Generated$Pages$view = function (model) {
	return $author$project$Spa$Generated$Pages$bundle(model).ahP(0);
};
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 5:
				var attempts = msg.a;
				var fragment = msg.b;
				var result = msg.c;
				if (result.$ === 1) {
					return _Utils_Tuple2(
						model,
						A2($author$project$Main$attemptScrollingToFragment, attempts + 1, fragment));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				var url = msg.a;
				var isLocal = msg.b;
				var shouldOpenInNewWindow = msg.c;
				var original = model.Cd;
				var hasPendingChanges = !_Utils_eq(original.afI, $elm$core$Maybe$Nothing);
				return _Utils_Tuple2(
					shouldOpenInNewWindow ? model : ((hasPendingChanges && _Utils_eq(original.V9, $elm$core$Maybe$Nothing)) ? _Utils_update(
						model,
						{
							Cd: _Utils_update(
								original,
								{
									V9: $elm$core$Maybe$Just(
										_Utils_Tuple2(url, isLocal))
								})
						}) : model),
					hasPendingChanges ? $elm$core$Platform$Cmd$none : (isLocal ? $author$project$Ports$Navigation$pushUrl(url) : (shouldOpenInNewWindow ? $elm$core$Platform$Cmd$none : $author$project$Ports$Navigation$load(url))));
			case 0:
				var locationHref = msg.a;
				if (model.Cd.adu.acW && (!_Utils_eq(model.d, $author$project$Spa$Generated$Route$Blank))) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var original = model.Cd;
					var _v2 = $author$project$Main$locationHrefToUrl(locationHref);
					var url = _v2.a;
					var defaultUrlCmd = _v2.b;
					var _v3 = A2($author$project$Shared$urlChanged, url, original);
					var shared = _v3.a;
					var urlChangedCmd = _v3.b;
					var _v4 = A2($author$project$Spa$Layout$urlChanged, shared, model.a6);
					var layout = _v4.a;
					var layoutCmd = _v4.b;
					var initPage = (!_Utils_eq(original.aav.VL, shared.aav.VL)) || _Utils_eq(model.d, $author$project$Spa$Generated$Route$Blank);
					var route = $author$project$Utils$Route$fromUrl(url);
					var _v5 = initPage ? A2($author$project$Spa$Generated$Pages$init, route, shared) : _Utils_Tuple3(model.Gy, $elm$core$Platform$Cmd$none, _List_Nil);
					var page = _v5.a;
					var pageCmd = _v5.b;
					var outMsgs = _v5.c;
					var _v6 = A2(
						$author$project$Shared$updateFromOutMsgs,
						outMsgs,
						A2($author$project$Spa$Generated$Pages$save, page, shared));
					var newShared = _v6.a;
					var sharedCmd = _v6.b;
					var _v7 = $author$project$Spa$Generated$Pages$view(page);
					var title = _v7.$G;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a6: layout,
								Gy: page,
								d: route,
								Cd: A2($author$project$Spa$Generated$Pages$save, page, newShared)
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
									defaultUrlCmd,
									A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										$author$project$Main$attemptScrollingToFragment(0),
										url.adz)),
									A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, urlChangedCmd),
									$author$project$Ports$PageTitle$updateTabTitle(title)
								])));
				}
			case 2:
				var sharedMsg = msg.a;
				var _v8 = A2($author$project$Shared$update, sharedMsg, model.Cd);
				var shared = _v8.a;
				var sharedCmd = _v8.b;
				var _v9 = A2($author$project$Spa$Generated$Pages$load, model.Gy, shared);
				var page = _v9.a;
				var pageCmd = _v9.b;
				var outMsgs = _v9.c;
				var _v10 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, shared);
				var newShared = _v10.a;
				var newSharedCmd = _v10.b;
				var _v11 = newShared.Wa ? _Utils_Tuple2(
					_Utils_update(
						newShared,
						{Wa: false}),
					A2(
						$elm$core$Task$perform,
						function (_v12) {
							return $author$project$Main$RequestLoadClinical;
						},
						$elm$core$Task$succeed(0))) : _Utils_Tuple2(newShared, $elm$core$Platform$Cmd$none);
				var sharedWithFlagCleared = _v11.a;
				var requestLoadClinicalCmd = _v11.b;
				var _v13 = A3($author$project$Main$updateLayout, shared, outMsgs, model.a6);
				var layout = _v13.a;
				var layoutCmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a6: layout, Gy: page, Cd: sharedWithFlagCleared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, newSharedCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
								requestLoadClinicalCmd
							])));
			case 3:
				var pageMsg = msg.a;
				var _v14 = A2($author$project$Spa$Generated$Pages$update, pageMsg, model.Gy);
				var page = _v14.a;
				var pageCmd = _v14.b;
				var outMsgs = _v14.c;
				var _v15 = A2(
					$author$project$Shared$updateFromOutMsgs,
					outMsgs,
					A2($author$project$Spa$Generated$Pages$save, page, model.Cd));
				var shared = _v15.a;
				var sharedCmd = _v15.b;
				var _v16 = $author$project$Spa$Generated$Pages$view(page);
				var title = _v16.$G;
				var _v17 = A3($author$project$Main$updateLayout, shared, outMsgs, model.a6);
				var layout = _v17.a;
				var layoutCmd = _v17.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a6: layout, Gy: page, Cd: shared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
								$author$project$Ports$PageTitle$updateTabTitle(title),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd)
							])));
			case 6:
				var _v18 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Main$loadClinicalDebounceConfig, 0, model.ri);
				var debouncer = _v18.a;
				var cmd = _v18.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ri: debouncer}),
					cmd);
			case 7:
				var subMsg = msg.a;
				var _v19 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Main$loadClinicalDebounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast(
						function (_v20) {
							return $author$project$Ports$Clinical$load;
						}),
					subMsg,
					model.ri);
				var debouncer = _v19.a;
				var cmd = _v19.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ri: debouncer}),
					cmd);
			default:
				var layoutMsg = msg.a;
				var _v21 = A3($author$project$Spa$Layout$update, model.Cd.D5, layoutMsg, model.a6);
				var layout = _v21.a;
				var layoutCmd = _v21.b;
				var outMsgs = _v21.c;
				var _v22 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, model.Cd);
				var shared = _v22.a;
				var sharedCmd = _v22.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a6: layout, Cd: shared}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
								A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd)
							])));
		}
	});
var $author$project$Main$isClinicalLayout = function (layout) {
	switch (layout.$) {
		case 15:
			return true;
		case 16:
			return true;
		default:
			return false;
	}
};
var $author$project$Shared$HideAuthRecoveryModal = function (a) {
	return {$: 28, a: a};
};
var $author$project$Shared$HideLogoutWarning = {$: 10};
var $author$project$Shared$PendingChangesDiscard = {$: 22};
var $author$project$Shared$organizationFromSession = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (org) {
			return {
				adR: $author$project$Api$Platform$Organization$Shared$id(org),
				zh: $author$project$Api$Platform$Organization$Shared$name(org),
				aft: $author$project$Api$Platform$Organization$Shared$id(org),
				ahI: $author$project$Api$Platform$Organization$Shared$type_(org)
			};
		},
		A2(
			$elm$core$Maybe$andThen,
			$author$project$Api$Platform$Session$One$organization,
			$author$project$Api$Data$toMaybe(model.ZD)));
};
var $author$project$Components$HiConfirm$ShowCancel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$HiConfirm$showCancel = $author$project$Components$HiConfirm$ShowCancel;
var $author$project$Navbars$Company$showSideNav = F2(
	function (hinterViewOff, _v0) {
		var model = _v0;
		return model.Cb.ZY(hinterViewOff);
	});
var $author$project$Navbars$Partner$showSideNav = F2(
	function (hinterViewOff, _v0) {
		var model = _v0;
		return model.Cb.ZY(hinterViewOff);
	});
var $author$project$Navbars$Practice$showSideNav = F2(
	function (hinterViewOff, _v0) {
		var model = _v0;
		return model.Cb.Cd.ZY(hinterViewOff);
	});
var $author$project$Navbar$showSideNav = F2(
	function (hinterViewOff, _v0) {
		var model = _v0;
		var _v1 = model.ac;
		switch (_v1.$) {
			case 0:
				return false;
			case 1:
				var navBar_ = _v1.a;
				return A2($author$project$Navbars$Practice$showSideNav, hinterViewOff, navBar_);
			case 2:
				var navBar_ = _v1.a;
				return A2($author$project$Navbars$Company$showSideNav, hinterViewOff, navBar_);
			default:
				var navBar_ = _v1.a;
				return A2($author$project$Navbars$Partner$showSideNav, hinterViewOff, navBar_);
		}
	});
var $author$project$Utils$Environment$toString = function (environment) {
	return A2(
		$elm$core$Maybe$map,
		function (env) {
			switch (env) {
				case 0:
					return 'production';
				case 1:
					return 'staging';
				case 2:
					return 'development';
				default:
					return 'feature';
			}
		},
		environment);
};
var $author$project$Api$Provider$Practice$One$accessRestricted = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.H2;
	});
var $author$project$Api$Practice$accessRestricted = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$accessRestricted(practice_);
	} else {
		return false;
	}
};
var $author$project$Api$Provider$Practice$One$daysWithOutstandingBalance = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.MY;
	});
var $author$project$Api$Practice$daysWithOutstandingBalance = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$daysWithOutstandingBalance(practice_);
	} else {
		return 0;
	}
};
var $author$project$Components$AccountLockedModal$viewModal = function (daysWithOutstandingBalance) {
	return A3(
		$author$project$Ui$Modal$view,
		0,
		_List_fromArray(
			[
				$author$project$Ui$Modal$dismissible(false)
			]),
		_List_fromArray(
			[
				$author$project$Ui$Modal$header(
				_List_fromArray(
					[
						$author$project$Ui$Modal$title('Your account is locked')
					])),
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						$elm$html$Html$text('You have outstanding invoices that are '),
						$elm$html$Html$text(
						A2($author$project$Formatters$String$pluralize, 'day', daysWithOutstandingBalance)),
						$elm$html$Html$text(' overdue, so your account has been locked. '),
						A2(
						$author$project$Ui$Typography$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To unlock your account, please '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Admin__Billing,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('click here')
									])),
								$elm$html$Html$text(' to view and pay your invoices.')
							])),
						A2(
						$author$project$Ui$Form$Static$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('If you have questions about your invoices or need to temporarily unlock your account, please contact us. ')
							]))
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$small,
								$author$project$Ui$Typography$muted,
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Note: Although your account is locked, everything is still active and operating as expected. There will be no disruption to your service, including automated billing, notifications, enrollments, or funds disbursement until your account is closed or suspended.')
							]))
					]))
			]));
};
var $author$project$Components$AccountLockedModal$view = F3(
	function (session, practice, route) {
		var userIsAdmin = $author$project$Api$Platform$User$Shared$isAdmin(
			$author$project$Api$Platform$Session$One$user(session));
		var routeString = $author$project$Spa$Generated$Route$toString(route);
		var practiceAccessRestricted = $author$project$Api$Practice$accessRestricted(practice);
		var organizationIsCompany = _Utils_eq(
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Platform$Organization$Shared$type_,
				$author$project$Api$Platform$Session$One$organization(session)),
			$elm$core$Maybe$Just(1));
		var isUserRoute = A2($elm$core$String$startsWith, '/user', routeString);
		var isPaymentSourcesRoute = A2(
			$elm$core$String$startsWith,
			$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__PaymentSources),
			routeString);
		var isBillingRoute = A2(
			$elm$core$String$startsWith,
			$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Billing),
			routeString);
		var routeAllowed = isBillingRoute || (isPaymentSourcesRoute || isUserRoute);
		var showModal = (!organizationIsCompany) && ((!userIsAdmin) && ((!routeAllowed) && practiceAccessRestricted));
		return showModal ? $author$project$Components$AccountLockedModal$viewModal(
			$author$project$Api$Practice$daysWithOutstandingBalance(practice)) : $author$project$Utils$Html$empty;
	});
var $author$project$Components$Auth$SystemRecoveryModal$hiConfirmMessage = function () {
	var infoText = '\n            Our main sign-in system has recovered from the outage. To continue using all features,\n            please sign out of the temporary system and sign back in with the full system.\n            ';
	var alertText = '\n            If you do not sign out and sign back in within the next 2 minutes, this\n            will happen automatically and you may lose unsaved work,  \n            ';
	return A2(
		$author$project$Ui$Typography$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$p,
				_List_fromArray(
					[
						$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(infoText)
					])),
				A2(
				$author$project$Ui$Typography$p,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Alert$warning,
						_List_fromArray(
							[
								$author$project$Ui$Alert$margin(25),
								$author$project$Ui$Alert$icon(59),
								$author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Typography$span,
								_List_fromArray(
									[$author$project$Ui$Typography$bold]),
								_List_fromArray(
									[
										$elm$html$Html$text('Important:')
									])),
								A2(
								$author$project$Ui$Typography$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(alertText)
									]))
							]))
					]))
			]));
}();
var $author$project$Components$Auth$SystemRecoveryModal$hiConfirmOptions = _List_fromArray(
	[
		$author$project$Components$HiConfirm$verb('sign out'),
		$author$project$Components$HiConfirm$noun('now'),
		$author$project$Components$HiConfirm$customMessage(
		_List_fromArray(
			[$author$project$Components$Auth$SystemRecoveryModal$hiConfirmMessage])),
		$author$project$Components$HiConfirm$customTitle('System Recovery Notice'),
		$author$project$Components$HiConfirm$showCancel(true)
	]);
var $author$project$Components$Auth$SystemRecoveryModal$view = function (onClose) {
	return A2($author$project$Components$HiConfirm$modal, onClose, $author$project$Components$Auth$SystemRecoveryModal$hiConfirmOptions);
};
var $author$project$Components$GlobalSearch$ClearTerm = {$: 3};
var $author$project$Components$GlobalSearch$InputKeyDown = function (a) {
	return {$: 11, a: a};
};
var $author$project$Components$GlobalSearch$PaginationMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$GlobalSearch$TermChanged = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$GlobalSearch$attributesToText = function (attributes) {
	var attributesText = A2($elm$core$String$join, ', ', attributes);
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('text-muted')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(attributesText)
			]));
};
var $author$project$Components$GlobalSearch$permissionTypeToAttributesList = function (permissionType) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('mt-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(permissionType.zh + ': ')
					])),
				$author$project$Components$GlobalSearch$attributesToText(permissionType.vw)
			]));
};
var $author$project$Components$GlobalSearch$viewNoResultsFound = F2(
	function (permissionsData, maybeFilter) {
		var searchableInfo = function () {
			if (permissionsData.$ === 3) {
				var permissions = permissionsData.a;
				if (!maybeFilter.$) {
					var filter = maybeFilter.a;
					return A2(
						$elm$core$List$filter,
						function (elem) {
							return _Utils_eq(elem.adR, filter);
						},
						A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions));
				} else {
					return A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions);
				}
			} else {
				return _List_Nil;
			}
		}();
		var noMatchingText = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
								$author$project$Ui$Typography$margin(8)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No matching results found')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$p,
						_List_fromArray(
							[
								$author$project$Ui$Typography$muted,
								$author$project$Ui$Typography$margin(8)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$toUpper('Searchable Information:'))
							]))
					]))
			]);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				noMatchingText,
				A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionTypeToAttributesList, searchableInfo)));
	});
var $author$project$Components$GlobalSearch$DocumentClicked = {$: 9};
var $author$project$Components$GlobalSearch$DocumentHovered = function (a) {
	return {$: 10, a: a};
};
var $author$project$Ui$Margin$Right_0_5 = 14;
var $author$project$Ui$ListGroup$Active = {$: 3};
var $author$project$Ui$ListGroup$active = $author$project$Ui$ListGroup$Active;
var $author$project$Components$GlobalSearch$documentTypeToIcon = function (name) {
	if (name === 'sponsor') {
		return A2(
			$author$project$Ui$SvgIcon$view,
			_List_fromArray(
				[
					$author$project$Ui$SvgIcon$class('global-search__icon')
				]),
			11);
	} else {
		var maybeName = function () {
			switch (name) {
				case 'invoice':
					return $elm$core$Maybe$Just(32);
				case 'customer_invoice':
					return $elm$core$Maybe$Just(32);
				case 'patient':
					return $elm$core$Maybe$Just(0);
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				$author$project$Ui$Icon$view(_List_Nil),
				maybeName));
	}
};
var $author$project$Api$Provider$Search$Min$label = function (_v0) {
	var record = _v0;
	return record.aej;
};
var $author$project$Api$Provider$Search$All$label = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$label(min);
};
var $author$project$Ui$ListGroup$None = {$: 4};
var $author$project$Ui$ListGroup$none = $author$project$Ui$ListGroup$None;
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Api$Provider$Search$Min$secondaryLabel = function (_v0) {
	var record = _v0;
	return record.Zd;
};
var $author$project$Api$Provider$Search$All$secondaryLabel = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$secondaryLabel(min);
};
var $author$project$Api$Provider$Search$Min$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Provider$Search$All$status = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$status(min);
};
var $author$project$Api$Provider$Search$Min$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Api$Provider$Search$All$type_ = function (_v0) {
	var min = _v0;
	return $author$project$Api$Provider$Search$Min$type_(min);
};
var $author$project$Components$GlobalSearch$viewDocument = F3(
	function (activeDocumentIndex, index, document) {
		var activeClass = _Utils_eq(activeDocumentIndex, index) ? $author$project$Ui$ListGroup$active : $author$project$Ui$ListGroup$none;
		return A2(
			$author$project$Ui$ListGroup$item,
			_List_fromArray(
				[activeClass]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							$author$project$Api$Provider$Search$All$path(document)),
							$elm$html$Html$Attributes$class('stretched-link'),
							$elm$html$Html$Events$onClick($author$project$Components$GlobalSearch$DocumentClicked),
							$elm$html$Html$Events$onMouseEnter(
							$author$project$Components$GlobalSearch$DocumentHovered(index))
						]),
					_List_fromArray(
						[
							$author$project$Components$GlobalSearch$documentTypeToIcon(
							$author$project$Api$Provider$Search$All$type_(document)),
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[
									$author$project$Ui$Typography$margin(10),
									$author$project$Ui$Typography$margin(14),
									$author$project$Ui$Typography$phi(true)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Search$All$label(document))
								])),
							function () {
							var _v0 = $author$project$Api$Provider$Search$All$secondaryLabel(document);
							if (!_v0.$) {
								var secondaryLabel_ = _v0.a;
								return A2(
									$author$project$Ui$Typography$span,
									_List_fromArray(
										[
											$author$project$Ui$Typography$muted,
											$author$project$Ui$Typography$small,
											$author$project$Ui$Typography$margin(14),
											$author$project$Ui$Typography$phi(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(secondaryLabel_)
										]));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2(
							$author$project$Ui$Badge$fromString,
							_List_Nil,
							$author$project$Api$Provider$Search$All$status(document)),
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('global-search__action')
								]),
							16)
						]))
				]));
	});
var $author$project$Components$GlobalSearch$viewResults = F2(
	function (documents, activeDocumentIndex) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('global-search__results')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$ListGroup$view,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						$author$project$Components$GlobalSearch$viewDocument(activeDocumentIndex),
						documents))
				]));
	});
var $author$project$Ui$UnderlineTabs$TabItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Ui$UnderlineTabs$item = F2(
	function (thing, _v0) {
		var toId = _v0.ahv;
		var toTab = _v0.ahz;
		return A2(
			$author$project$Ui$UnderlineTabs$TabItem,
			thing,
			{dW: false, ahv: toId, ahz: toTab});
	});
var $author$project$Components$GlobalSearch$viewPermissionTypeTab = function (permissionType) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('text-current')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(permissionType.zh)
					]))
			]));
};
var $author$project$Components$GlobalSearch$permissionToTabItem = function (permission) {
	return A2(
		$author$project$Ui$UnderlineTabs$item,
		permission,
		{
			ahv: function ($) {
				return $.adR;
			},
			ahz: $author$project$Components$GlobalSearch$viewPermissionTypeTab
		});
};
var $author$project$Ui$UnderlineTabs$TabClicked = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$UnderlineTabs$viewTab = F4(
	function (activeIndex, navigation, tabIndex, tabItem) {
		var tabItem_ = tabItem.a;
		var record = tabItem.b;
		var toTab = record.ahz;
		var toId = record.ahv;
		var id = toId(tabItem_);
		return function () {
			if (_Utils_eq(tabIndex, activeIndex)) {
				return $elm$html$Html$button(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(id),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('underline-tabs__item underline-tabs__item--active')
						]));
			} else {
				var canNavigate = function () {
					var _v0 = _Utils_Tuple2(
						navigation,
						_Utils_cmp(tabIndex, activeIndex) < 0);
					if ((_v0.a === 1) && (!_v0.b)) {
						var _v1 = _v0.a;
						return false;
					} else {
						return true;
					}
				}();
				var clickHandler = (canNavigate && (!record.dW)) ? $elm$html$Html$Events$onClick(
					$author$project$Ui$UnderlineTabs$TabClicked(tabItem)) : $elm$html$Html$Attributes$class('');
				return $elm$html$Html$button(
					_List_fromArray(
						[
							clickHandler,
							$elm$html$Html$Attributes$id(id),
							$elm$html$Html$Attributes$type_('button'),
							$elm$html$Html$Attributes$class('underline-tabs__item'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('underline-tabs__item--disabled', (!canNavigate) || record.dW)
								]))
						]));
			}
		}()(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					toTab(tabItem_))
				]));
	});
var $author$project$Ui$UnderlineTabs$view = F2(
	function (_v0, tabItems) {
		var underlineLeft = _v0.HE;
		var tabsLeft = _v0.Dk;
		var tabsOffset = _v0.Dl;
		var underlineWidth = _v0.HF;
		var activeId = _v0.pj;
		var navigation = _v0.zi;
		var id = _v0.adR;
		var transform = 'translateX(' + ($elm$core$String$fromFloat((underlineLeft - tabsLeft) + tabsOffset) + ('px) ' + ('scaleX(' + ($elm$core$String$fromFloat(underlineWidth) + ')'))));
		var activeIndex = A2(
			$elm$core$Maybe$withDefault,
			-1,
			A2(
				$elm_community$list_extra$List$Extra$findIndex,
				function (_v1) {
					var tabItem_ = _v1.a;
					var toId = _v1.b.ahv;
					return _Utils_eq(
						toId(tabItem_),
						activeId);
				},
				tabItems));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$id(id),
					$elm$html$Html$Attributes$class('underline-tabs')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'transform', transform),
							$elm$html$Html$Attributes$class('underline-tabs__current')
						]),
					_List_Nil),
				A2(
					$elm$core$List$indexedMap,
					A2($author$project$Ui$UnderlineTabs$viewTab, activeIndex, navigation),
					tabItems)));
	});
var $author$project$Components$GlobalSearch$viewTabs = function (openModel) {
	var _v0 = openModel.gV;
	if (!_v0.$) {
		var tabs = _v0.a;
		var permissionTypeTabs = function () {
			var _v1 = openModel.r1;
			if (_v1.$ === 3) {
				var permissions = _v1.a;
				var searchableTypeList = A2(
					$elm$core$List$map,
					$author$project$Components$GlobalSearch$permissionToTabItem,
					A2(
						$elm$core$List$filter,
						function (elem) {
							return elem.Zc;
						},
						A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions)));
				if ($elm$core$List$length(searchableTypeList) > 1) {
					var allType = {vw: _List_Nil, adR: 'all', zh: 'All', Zc: true};
					return A2(
						$elm$core$List$cons,
						$author$project$Components$GlobalSearch$permissionToTabItem(allType),
						searchableTypeList);
				} else {
					return searchableTypeList;
				}
			} else {
				return _List_Nil;
			}
		}();
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$author$project$Components$GlobalSearch$TabMsg,
				A2($author$project$Ui$UnderlineTabs$view, tabs, permissionTypeTabs))
			]);
	} else {
		return _List_fromArray(
			[$author$project$Utils$Html$empty]);
	}
};
var $author$project$Components$GlobalSearch$viewOpen = function (model) {
	return A3(
		$author$project$Ui$Modal$view,
		$author$project$Components$GlobalSearch$ModalCloseClicked,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$Modal$body(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							$author$project$Ui$Form$Input$view(
								_List_fromArray(
									[
										$author$project$Ui$Form$Input$id('global-search-input'),
										$author$project$Ui$Form$Input$placeholder('Search...'),
										$author$project$Ui$Form$Input$value(model.eL),
										$author$project$Ui$Form$Input$onInput($author$project$Components$GlobalSearch$TermChanged),
										$author$project$Ui$Form$Input$onKeyDown($author$project$Components$GlobalSearch$InputKeyDown),
										$author$project$Ui$Form$Input$autoComplete(false),
										$author$project$Ui$Form$Input$customAttributes(
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('search-input')
											])),
										$author$project$Ui$Form$Input$wrapped(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('lens-search glyphicon glyphicon-search')
													]),
												_List_Nil),
												(model.eL === '') ? $author$project$Utils$Html$empty : A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('clear-search glyphicon glyphicon-remove-circle'),
														$elm$html$Html$Events$onClick($author$project$Components$GlobalSearch$ClearTerm)
													]),
												_List_Nil)
											])),
										$author$project$Ui$Form$Input$phi(true)
									])),
							$author$project$Components$GlobalSearch$viewTabs(model))),
						function () {
						var _v0 = model.YC;
						switch (_v0.$) {
							case 3:
								var results = _v0.a;
								return $elm$core$List$isEmpty(results) ? A2($author$project$Components$GlobalSearch$viewNoResultsFound, model.r1, model.Fi) : A2($author$project$Components$GlobalSearch$viewResults, results, model.N);
							case 1:
								return $elm$html$Html$text('Loading...');
							default:
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$p,
											_List_fromArray(
												[
													$author$project$Ui$Typography$margin(21),
													$author$project$Ui$Typography$margin(10),
													$author$project$Ui$Typography$gray
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Try searching for id, invoice number, name, email and other information')
												]))
										]));
						}
					}()
					])),
				$author$project$Ui$Modal$footer(
				_List_fromArray(
					[
						function () {
						var _v1 = model.YC;
						if (_v1.$ === 3) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('global-search__footer')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('global-search__pagination')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Components$GlobalSearch$PaginationMsg,
												A2($author$project$Api$Pagination$view, _List_Nil, model.afy))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('global-search__legend')
											]),
										_List_fromArray(
											[
												$author$project$Ui$SvgIcon$selectArrows(_List_Nil),
												$elm$html$Html$text('Select'),
												$author$project$Ui$SvgIcon$open(_List_Nil),
												$elm$html$Html$text('Open')
											]))
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			]));
};
var $author$project$Components$GlobalSearch$view = function (model) {
	if (!model.$) {
		return $elm$html$Html$text('');
	} else {
		var openModel = model.a;
		return $author$project$Components$GlobalSearch$viewOpen(openModel);
	}
};
var $author$project$Components$PendingChangesModal$view = F3(
	function (pendingChangesDetail, discardChangesMsg, keepChangesMsg) {
		return A3(
			$author$project$Ui$Modal$view,
			keepChangesMsg,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('You have pending changes')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							$elm$html$Html$text(pendingChangesDetail)
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Stay on this page'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick(keepChangesMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Stay')
								])),
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Leave and discard pending changes'},
							_List_fromArray(
								[
									$author$project$Ui$Button$danger,
									$author$project$Ui$Button$onClick(discardChangesMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Leave')
								]))
						]))
				]));
	});
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Components$DebugInfo$viewSetting = F2(
	function (label, value) {
		return A2(
			$author$project$Ui$Typography$span,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(label + ': ')
						])),
					$elm$html$Html$text(value)
				]));
	});
var $author$project$Components$DebugInfo$view = function (_v0) {
	var nodeEnv = _v0.aeR;
	var hintEnv = _v0.adM;
	var apiUrl = _v0.abm;
	var debugOrTest = _v0.acv;
	var embedded = _v0.acW;
	var session = _v0.ZD;
	return ((!embedded) && debugOrTest) ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('debug-info')
			]),
		A2(
			$elm$core$List$intersperse,
			$elm$html$Html$text(' - '),
			_List_fromArray(
				[
					A2(
					$author$project$Components$DebugInfo$viewSetting,
					'NODE_ENV',
					A2($elm$core$Maybe$withDefault, 'N/A', nodeEnv)),
					A2(
					$author$project$Components$DebugInfo$viewSetting,
					'HINT_ENV',
					A2($elm$core$Maybe$withDefault, 'N/A', hintEnv)),
					A2($author$project$Components$DebugInfo$viewSetting, 'API_URL', apiUrl),
					A2(
					$author$project$Components$DebugInfo$viewSetting,
					'session.role',
					$author$project$Api$Platform$Session$One$role(session))
				]))) : $author$project$Utils$Html$empty;
};
var $author$project$Components$SandboxAlert$SwitchToOrganization = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Platform$Organization$SandboxOf$organizationId = function (_v0) {
	var orgId = _v0;
	return orgId;
};
var $author$project$Api$Platform$Organization$Shared$sandboxOf = function (_v0) {
	var record = _v0.b;
	return record.Y1;
};
var $author$project$Components$SandboxAlert$view = function (session) {
	return $author$project$Api$Platform$Session$One$sandbox(session) ? A2(
		$author$project$Ui$Alert$warning,
		_List_fromArray(
			[$author$project$Ui$Alert$hardNotification, $author$project$Ui$Alert$m0]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Currently viewing sandbox data.')
							])),
						function () {
						var _v0 = A2(
							$elm$core$Maybe$andThen,
							$author$project$Api$Platform$Organization$Shared$sandboxOf,
							$author$project$Api$Platform$Session$One$organization(session));
						if (!_v0.$) {
							var sandboxOf = _v0.a;
							var _v1 = function () {
								if (!sandboxOf.$) {
									var organization = sandboxOf.a;
									return _Utils_Tuple2(
										0,
										$author$project$Api$Platform$Organization$SandboxOf$organizationId(organization));
								} else {
									var organization = sandboxOf.a;
									return _Utils_Tuple2(
										2,
										$author$project$Api$Platform$Organization$SandboxOf$organizationId(organization));
								}
							}();
							var organizationType = _v1.a;
							var organizationId = _v1.b;
							return A3(
								$author$project$Ui$Button$view,
								{abp: 'Back to Live'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$sm,
										$author$project$Ui$Button$onClick(
										A2($author$project$Components$SandboxAlert$SwitchToOrganization, organizationType, organizationId)),
										$author$project$Ui$Button$secondary
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back to Live')
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]))
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Components$BackupAuthAlert$view = function (backupAuthEnabled) {
	return backupAuthEnabled ? A2(
		$author$project$Ui$Alert$warning,
		_List_fromArray(
			[$author$project$Ui$Alert$m0]),
		$author$project$Components$BackupAuthAlert$viewAlertText) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Practice$deactivated = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$deactivated(practice_);
	} else {
		return false;
	}
};
var $author$project$Components$DeactivatedPracticeAlert$view = function (practice) {
	return $author$project$Api$Practice$deactivated(practice) ? A2(
		$author$project$Ui$Alert$danger,
		_List_fromArray(
			[$author$project$Ui$Alert$hardNotification, $author$project$Ui$Alert$m0]),
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Typography$strong,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Practice Deactivated.')
					])),
				$author$project$Utils$Html$noBreakSpace,
				$elm$html$Html$text('Practice is deactivated and will not process payments, bill memberships or send emails.')
			])) : $author$project$Utils$Html$empty;
};
var $author$project$Api$Provider$Practice$One$collectionWarningStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Lj;
	});
var $author$project$Api$Practice$collectionWarningStatus = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$collectionWarningStatus(practice_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$Practice$One$daysUntilAccessRestricted = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.MX;
	});
var $author$project$Api$Practice$daysUntilAccessRestricted = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$daysUntilAccessRestricted(practice_);
	} else {
		return 0;
	}
};
var $author$project$Api$Platform$Session$One$showCollectionWarning = function (_v0) {
	var record = _v0;
	return record.ZT;
};
var $author$project$Components$MissingSourceAlert$view = F3(
	function (session, practice, hinterViewOff) {
		var _v0 = _Utils_Tuple2(
			A3($author$project$Permission$canGoTo, session, hinterViewOff, 1) && $author$project$Api$Platform$Session$One$showCollectionWarning(session),
			$author$project$Api$Practice$collectionWarningStatus(practice));
		_v0$2:
		while (true) {
			if (_v0.a && (!_v0.b.$)) {
				switch (_v0.b.a) {
					case 'yellow':
						return A2(
							$author$project$Ui$Alert$warning,
							_List_fromArray(
								[$author$project$Ui$Alert$hardNotification, $author$project$Ui$Alert$m0]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have outstanding invoices on your account.')
										])),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Please '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Admin__Billing,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('click here')
												])),
											$elm$html$Html$text(' to view and pay your invoices so that your account doesn\'t become overdue. If you have questions or concerns regarding your invoices, please contact us.')
										]))
								]));
					case 'red':
						var daysWithOutstandingBalance = $author$project$Api$Practice$daysWithOutstandingBalance(practice);
						var daysUntilAccessRestricted = $author$project$Api$Practice$daysUntilAccessRestricted(practice);
						return A2(
							$author$project$Ui$Alert$danger,
							_List_fromArray(
								[$author$project$Ui$Alert$hardNotification, $author$project$Ui$Alert$m0]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Typography$strong,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have outstanding invoices and your account is '),
											$elm$html$Html$text(
											A2($author$project$Formatters$String$pluralize, 'day', daysWithOutstandingBalance)),
											$elm$html$Html$text(' overdue.')
										])),
									$author$project$Utils$Html$noBreakSpace,
									A2(
									$author$project$Ui$Typography$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Please '),
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Admin__Billing,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('click here')
												])),
											$elm$html$Html$text(' to view and pay any overdue invoices to prevent your account from being locked in '),
											$elm$html$Html$text(
											A2($author$project$Formatters$String$pluralize, 'day', daysUntilAccessRestricted)),
											$elm$html$Html$text('. If you have questions or concerns regarding your invoices, please contact us.')
										]))
								]));
					default:
						break _v0$2;
				}
			} else {
				break _v0$2;
			}
		}
		return $author$project$Utils$Html$empty;
	});
var $author$project$Components$OnboardedPracticeAlert$isHintAdmin = F2(
	function (session, hinterViewOff) {
		return A2($author$project$Utils$User$isViewingAsHinter, session, hinterViewOff);
	});
var $author$project$Api$Provider$Practice$One$onboarded = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.U5;
	});
var $author$project$Api$Practice$onboarded = function (practice) {
	if (!practice.$) {
		var practice_ = practice.a;
		return $author$project$Api$Provider$Practice$One$onboarded(practice_);
	} else {
		return true;
	}
};
var $author$project$Components$OnboardedPracticeAlert$view = F3(
	function (session, practice, hinterViewOff) {
		return (A2($author$project$Components$OnboardedPracticeAlert$isHintAdmin, session, hinterViewOff) && (!$author$project$Api$Practice$onboarded(practice))) ? A2(
			$author$project$Ui$Alert$danger,
			_List_fromArray(
				[$author$project$Ui$Alert$hardNotification]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$strong,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('This Practice is required to add payment information.')
						])),
					$author$project$Utils$Html$noBreakSpace,
					A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('All users (other than Hinters) are being redirected to the '),
							A3(
							$author$project$Ui$HinterOnly$linkRoute,
							$author$project$Spa$Generated$Route$Onboarding,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('payment setup')
								])),
							$elm$html$Html$text(' view until a payment method is added.')
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Navbar$viewPracticeAlerts = F3(
	function (session, hinterViewOff, practice) {
		if (!practice.$) {
			var practice_ = practice.a;
			return _List_fromArray(
				[
					A3($author$project$Components$MissingSourceAlert$view, session, practice_, hinterViewOff),
					A3($author$project$Components$OnboardedPracticeAlert$view, session, practice_, hinterViewOff),
					$author$project$Components$DeactivatedPracticeAlert$view(practice_)
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Navbar$viewAlerts = F4(
	function (session, hinterViewOff, practice, backupAuthEnabled) {
		return A2(
			$elm$core$List$cons,
			$author$project$Components$BackupAuthAlert$view(backupAuthEnabled),
			A3($author$project$Navbar$viewPracticeAlerts, session, hinterViewOff, practice));
	});
var $author$project$Navbars$Company$NavClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Navbars$Company$OrgSwitcherMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Navbars$Company$defaultNav = _List_fromArray(
	[
		{yq: 0},
		{yq: 1},
		{yq: 2},
		{yq: 3},
		{yq: 4},
		{yq: 5}
	]);
var $author$project$Components$OrganizationSwitcher$hasInlineOrgs = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			function (orgs) {
				if (!orgs.b) {
					return false;
				} else {
					if (!orgs.b.b) {
						return false;
					} else {
						return true;
					}
				}
			},
			$author$project$Api$Data$toMaybe(model.rJ)));
};
var $author$project$Ui$FlyoutMenu$Direction = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$FlyoutMenu$direction = $author$project$Ui$FlyoutMenu$Direction;
var $author$project$Api$Platform$User$Organization$type_ = function (_v0) {
	var record = _v0;
	return record.ahI;
};
var $author$project$Components$OrganizationSwitcher$groupByType = function (orgs) {
	var practices = A2(
		$elm$core$List$filter,
		function (o) {
			return !$author$project$Api$Platform$User$Organization$type_(o);
		},
		orgs);
	var partners = A2(
		$elm$core$List$filter,
		function (o) {
			return $author$project$Api$Platform$User$Organization$type_(o) === 2;
		},
		orgs);
	var companies = A2(
		$elm$core$List$filter,
		function (o) {
			return $author$project$Api$Platform$User$Organization$type_(o) === 1;
		},
		orgs);
	return A2(
		$elm$core$List$filter,
		function (_v0) {
			var items = _v0.b;
			return !$elm$core$List$isEmpty(items);
		},
		_List_fromArray(
			[
				_Utils_Tuple2(0, practices),
				_Utils_Tuple2(1, companies),
				_Utils_Tuple2(2, partners)
			]));
};
var $author$project$Api$Platform$User$Organization$sandbox = function (_v0) {
	var record = _v0;
	return record.Y$;
};
var $author$project$Components$OrganizationSwitcher$SetEnvironment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$OrganizationSwitcher$viewEnvironmentToggle = F2(
	function (current, navModel) {
		return A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$mb3]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Nav$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$activeItem(!current),
									$author$project$Ui$Nav$onItemClick(
									$author$project$Components$OrganizationSwitcher$SetEnvironment(0))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Live')
								])),
							A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$activeItem(current === 1),
									$author$project$Ui$Nav$onItemClick(
									$author$project$Components$OrganizationSwitcher$SetEnvironment(1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Sandbox')
								]))
						]),
					navModel)
				]));
	});
var $author$project$Components$OrganizationSwitcher$orgTypeLabel = function (orgType) {
	switch (orgType) {
		case 0:
			return 'Practices';
		case 1:
			return 'Companies';
		default:
			return 'Partners';
	}
};
var $author$project$Components$OrganizationSwitcher$SelectOrganization = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Platform$User$Organization$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Platform$User$Organization$name = function (_v0) {
	var record = _v0;
	return record.zh;
};
var $author$project$Api$Platform$User$Organization$organizationId = function (_v0) {
	var record = _v0;
	return record.aft;
};
var $author$project$Components$OrganizationSwitcher$viewOrgItem = F2(
	function (currentOrg, org) {
		var isCurrent = _Utils_eq(
			currentOrg.ahI,
			$author$project$Api$Platform$User$Organization$type_(org)) && _Utils_eq(
			currentOrg.adR,
			$author$project$Api$Platform$User$Organization$id(org));
		return A3(
			$author$project$Ui$Button$view,
			{abp: 'Select org'},
			A2(
				$elm$core$List$cons,
				$author$project$Ui$Button$link,
				A2(
					$elm$core$List$cons,
					$author$project$Ui$Button$onClick(
						$author$project$Components$OrganizationSwitcher$SelectOrganization(
							$author$project$Api$Platform$User$Organization$organizationId(org))),
					isCurrent ? _List_fromArray(
						[
							$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$check)
						]) : _List_Nil)),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Api$Platform$User$Organization$name(org))
				]));
	});
var $author$project$Components$OrganizationSwitcher$viewGroup = F2(
	function (currentOrg, _v0) {
		var orgType = _v0.a;
		var orgs = _v0.b;
		return $elm$core$List$isEmpty(orgs) ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$titleSm,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Components$OrganizationSwitcher$orgTypeLabel(orgType))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$gap2, $author$project$Ui$Element$flexCol, $author$project$Ui$Element$textMuted]),
						A2(
							$elm$core$List$map,
							$author$project$Components$OrganizationSwitcher$viewOrgItem(currentOrg),
							orgs))
					]))
			]);
	});
var $author$project$Components$OrganizationSwitcher$viewGroupedOrgs = F2(
	function (currentOrg, groups) {
		return A2(
			$elm$core$List$concatMap,
			$author$project$Components$OrganizationSwitcher$viewGroup(currentOrg),
			groups);
	});
var $author$project$Components$OrganizationSwitcher$viewTrigger = function (organizationName) {
	return A3(
		$author$project$Ui$Element$custom,
		'topnav__left--content cursor-pointer py-3.5',
		_List_fromArray(
			[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				$author$project$Ui$SvgIcon$location(_List_Nil),
				A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(organizationName)
					])),
				$author$project$Ui$SvgIcon$kebabMenu(_List_Nil)
			]));
};
var $author$project$Components$OrganizationSwitcher$viewDropdown = F3(
	function (currentOrg, model, orgs) {
		var hasSandbox = A2($elm$core$List$any, $author$project$Api$Platform$User$Organization$sandbox, orgs);
		var hasLive = A2(
			$elm$core$List$any,
			function (o) {
				return !$author$project$Api$Platform$User$Organization$sandbox(o);
			},
			orgs);
		var showTabs = hasSandbox && hasLive;
		var filteredOrgs = function () {
			if (showTabs) {
				var _v0 = model.qz;
				if (!_v0) {
					return A2(
						$elm$core$List$filter,
						function (o) {
							return !$author$project$Api$Platform$User$Organization$sandbox(o);
						},
						orgs);
				} else {
					return A2($elm$core$List$filter, $author$project$Api$Platform$User$Organization$sandbox, orgs);
				}
			} else {
				return orgs;
			}
		}();
		var grouped = $author$project$Components$OrganizationSwitcher$groupByType(filteredOrgs);
		return A4(
			$author$project$Ui$FlyoutMenu$view,
			_List_fromArray(
				[
					$author$project$Ui$FlyoutMenu$direction(1)
				]),
			_List_fromArray(
				[
					$author$project$Ui$FlyoutMenu$body(
					$elm$core$List$concat(
						_List_fromArray(
							[
								showTabs ? _List_fromArray(
								[
									A2($author$project$Components$OrganizationSwitcher$viewEnvironmentToggle, model.qz, model.m9)
								]) : _List_Nil,
								_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$gap4, $author$project$Ui$Element$flexCol]),
									A2($author$project$Components$OrganizationSwitcher$viewGroupedOrgs, currentOrg, grouped))
								])
							])))
				]),
			$author$project$Components$OrganizationSwitcher$viewTrigger(currentOrg.zh),
			model.mj);
	});
var $author$project$Components$OrganizationSwitcher$view = F2(
	function (currentOrg, _v0) {
		var model = _v0;
		var _v1 = model.rJ;
		if (_v1.$ === 3) {
			var orgs = _v1.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textSm, $author$project$Ui$Element$itemsCenter]),
				_List_fromArray(
					[
						A3($author$project$Components$OrganizationSwitcher$viewDropdown, currentOrg, model, orgs)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Components$OrganizationSwitcher$viewFor = F3(
	function (toMsg, organization, model) {
		return A2(
			$elm$html$Html$map,
			toMsg,
			A2($author$project$Components$OrganizationSwitcher$view, organization, model));
	});
var $author$project$Components$OrganizationSwitcher$maybeViewFor = F2(
	function (toMsg, maybeConfig) {
		return A2(
			$elm$core$Maybe$andThen,
			function (config) {
				return $author$project$Components$OrganizationSwitcher$hasInlineOrgs(config.y8) ? $elm$core$Maybe$Just(
					A3($author$project$Components$OrganizationSwitcher$viewFor, toMsg, config.Vd, config.y8)) : $elm$core$Maybe$Nothing;
			},
			maybeConfig);
	});
var $author$project$Ui$Tooltip$Stacking = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Tooltip$stackingOrder = $author$project$Ui$Tooltip$Stacking;
var $author$project$Ui$StackingOrder$z1030 = 1030;
var $author$project$Ui$Tooltip$stackingOrder1030 = $author$project$Ui$Tooltip$stackingOrder($author$project$Ui$StackingOrder$z1030);
var $author$project$Navbars$Company$subNavClasses = F2(
	function (subnav, openSubNav) {
		return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
	});
var $author$project$Api$FeatureGate$EmployeeUploads = 8;
var $author$project$Navbars$Company$LinkClicked = {$: 0};
var $author$project$Api$Employer$Company$One$hideSponsorInvoices = function (_v0) {
	var record = _v0.b;
	return record.Qp;
};
var $author$project$Api$Employer$Practice$One$hideSponsorInvoices = function (_v0) {
	var record = _v0;
	return record.Qp;
};
var $author$project$Navbars$Utils$ifConfiguration = F2(
	function (showSetting, body) {
		return showSetting ? body : $author$project$Utils$Html$empty;
	});
var $author$project$Navbars$Utils$selectedNavClass = F3(
	function (modifier, nav, selectedNav) {
		return 'sidenav__item' + (($elm$core$String$isEmpty(modifier) ? '' : (' ' + modifier)) + (_Utils_eq(nav, selectedNav) ? ' sidenav__active' : ''));
	});
var $author$project$Navbars$Company$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('sidenav__item--company');
var $author$project$Navbars$Company$viewDesktopNavElements = F6(
	function (hinterViewOff, _v0, company, practice, sessionConfiguration, navItem) {
		var selectedNav = _v0.eE;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var companyId = $author$project$Api$Employer$Company$One$id(company);
		var _v1 = navItem.yq;
		switch (_v1) {
			case 0:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
					{ff: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 0, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Employees',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
											$author$project$Ui$Link$test('employees')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											23)
										]))
								]))
						]));
			case 1:
				var hideSponsorInvoices = $author$project$Api$Employer$Company$One$hideSponsorInvoices(company) || $author$project$Api$Employer$Practice$One$hideSponsorInvoices(practice);
				if (hideSponsorInvoices) {
					return $author$project$Utils$Html$empty;
				} else {
					var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
						{ff: companyId});
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2($author$project$Navbars$Company$selectedNavClass, 1, selectedNav))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Tooltip$view,
								tooltipOptions,
								'Invoices',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										route,
										_List_fromArray(
											[
												$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
												$author$project$Ui$Link$test('invoices')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$SvgIcon$view,
												_List_fromArray(
													[
														$author$project$Ui$SvgIcon$class('sidenav__icon')
													]),
												25)
											]))
									]))
							]));
				}
			case 2:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
					{ff: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 2, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Payment Methods',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
											$author$project$Ui$Link$test('paymentMethods')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											22)
										]))
								]))
						]));
			case 3:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
					{ff: companyId});
				var canSeeEmployeeUploads = A2(
					$author$project$Utils$FeatureGate$gateAvailable,
					8,
					$author$project$Api$Practice$Employer(practice)) || sessionConfiguration.ym(hinterViewOff);
				return A2(
					$author$project$Navbars$Utils$ifConfiguration,
					canSeeEmployeeUploads,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2($author$project$Navbars$Company$selectedNavClass, 3, selectedNav))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Tooltip$view,
								tooltipOptions,
								'Employee Uploads',
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										route,
										_List_fromArray(
											[
												$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
												$author$project$Ui$Link$test('employee-uploads')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$SvgIcon$view,
												_List_fromArray(
													[
														$author$project$Ui$SvgIcon$class('sidenav__icon')
													]),
												24)
											]))
									]))
							])));
			case 4:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
					{ff: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 4, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Online Signup',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
											$author$project$Ui$Link$test('online-signup')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											26)
										]))
								]))
						]));
			case 5:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
					{ff: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 5, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Account & Pricing',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
											$author$project$Ui$Link$test('account-and-pricing')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											27)
										]))
								]))
						]));
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$Company$viewMobileNavElements = F6(
	function (hinterViewOff, _v0, company, practice, sessionConfiguration, navItem) {
		var selectedNav = _v0.eE;
		var companyId = $author$project$Api$Employer$Company$One$id(company);
		var _v1 = navItem.yq;
		switch (_v1) {
			case 0:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
					{ff: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 0, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
									$author$project$Ui$Link$test('employees')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									23),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Employees')
										]))
								]))
						]));
			case 1:
				var hideSponsorInvoices = $author$project$Api$Employer$Company$One$hideSponsorInvoices(company) || $author$project$Api$Employer$Practice$One$hideSponsorInvoices(practice);
				if (hideSponsorInvoices) {
					return $author$project$Utils$Html$empty;
				} else {
					var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
						{ff: companyId});
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2($author$project$Navbars$Company$selectedNavClass, 1, selectedNav))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								route,
								_List_fromArray(
									[
										$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
										$author$project$Ui$Link$test('invoices')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$SvgIcon$view,
										_List_fromArray(
											[
												$author$project$Ui$SvgIcon$class('sidenav__icon')
											]),
										25),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Invoices')
											]))
									]))
							]));
				}
			case 2:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
					{ff: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 2, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
									$author$project$Ui$Link$test('paymentMethods')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									22),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Payment Methods')
										]))
								]))
						]));
			case 3:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
					{ff: companyId});
				var canSeeEmployeeUploads = A2(
					$author$project$Utils$FeatureGate$gateAvailable,
					8,
					$author$project$Api$Practice$Employer(practice)) || sessionConfiguration.ym(hinterViewOff);
				return A2(
					$author$project$Navbars$Utils$ifConfiguration,
					canSeeEmployeeUploads,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class(
								A2($author$project$Navbars$Company$selectedNavClass, 3, selectedNav))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Link$route,
								route,
								_List_fromArray(
									[
										$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
										$author$project$Ui$Link$test('employee-uploads')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$SvgIcon$view,
										_List_fromArray(
											[
												$author$project$Ui$SvgIcon$class('sidenav__icon')
											]),
										24),
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Employee Uploads')
											]))
									]))
							])));
			case 4:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
					{ff: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 4, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
									$author$project$Ui$Link$test('online-signup')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									26),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Online Signup')
										]))
								]))
						]));
			case 5:
				var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
					{ff: companyId});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Company$selectedNavClass, 5, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
									$author$project$Ui$Link$test('account-and-pricing')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									27),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Account & Pricing')
										]))
								]))
						]));
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$Utils$viewOrganizationHeader = F2(
	function (organizationName, canSwitchOrganizations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav__header--right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$location(_List_Nil),
									$elm$html$Html$text(organizationName)
								])),
							A2(
							$author$project$Navbars$Utils$ifConfiguration,
							canSwitchOrganizations,
							A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$User__Organizations__Top,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Change')
									])))
						]))
				]));
	});
var $author$project$Navbars$Company$LogoutClicked = {$: 1};
var $author$project$Navbars$Company$viewProfileSubNav = function (selectedNav) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__subnav__content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Company$selectedNavClass, 6, selectedNav))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Profile,
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
								$author$project$Ui$Link$test('account-profile')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Logout'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Navbars$Company$LogoutClicked),
								$author$project$Ui$Button$test('account-logout')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Navbars$Utils$viewTopNavEnd = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$id('topnav-end'),
			$elm$html$Html$Attributes$class('topnav__end')
		]),
	_List_Nil);
var $author$project$Navbars$Company$SidenavToggled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$WhitelabelSetting$practiceFacingLogoAltText = function (_v0) {
	var record = _v0;
	return record.GM;
};
var $author$project$Navbars$Company$viewLogo = F3(
	function (whitelabelSetting, practiceName, maybeLinkOptions) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting),
			$author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
		var altText = _v0.a;
		var maybeLogoUrl = _v0.b;
		if (!maybeLogoUrl.$) {
			var logoUrl = maybeLogoUrl.a;
			if (logoUrl === '') {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'display', 'inline')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(practiceName)
						]));
			} else {
				if (!maybeLinkOptions.$) {
					var listOptions = maybeLinkOptions.a;
					return A3(
						$author$project$Ui$Link$externalHref,
						'/',
						listOptions,
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Image$fromSrc,
								{I1: altText},
								logoUrl,
								_List_fromArray(
									[
										$author$project$Ui$Image$height(40)
									]))
							]));
				} else {
					return A3(
						$author$project$Ui$Image$fromSrc,
						{I1: altText},
						logoUrl,
						_List_fromArray(
							[
								$author$project$Ui$Image$height(40)
							]));
				}
			}
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$style, 'display', 'inline')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(practiceName)
					]));
		}
	});
var $author$project$Navbars$Utils$viewSwitchOrganizationLink = F2(
	function (organizationName, canSwitchOrganizations) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('topnav__left--content')
				]),
			canSwitchOrganizations ? _List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$User__Organizations__Top,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('topnav__icon topnav__icon--location')
								]),
							14),
							$elm$html$Html$text(organizationName),
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('topnav__icon topnav__icon--change')
								]),
							19)
						]))
				]) : _List_fromArray(
				[
					A2(
					$author$project$Ui$SvgIcon$view,
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$class('topnav__icon topnav__icon--location')
						]),
					14),
					$elm$html$Html$text(organizationName)
				]));
	});
var $author$project$Navbars$Company$viewTopNavbar = F5(
	function (_v0, whitelabelSetting, companyName, sessionConfig, maybeOrgSwitcher) {
		var slideIn = _v0.ow;
		var practice = _v0.WF;
		var patientFacingLogoSection = A3(
			$author$project$Navbars$Company$viewLogo,
			whitelabelSetting,
			$author$project$Api$Employer$Practice$One$name(practice),
			$elm$core$Maybe$Just(
				_List_fromArray(
					[
						$author$project$Ui$Link$ariaLabel('Home')
					])));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-mobile-nav')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[patientFacingLogoSection]),
								slideIn ? _List_Nil : _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav-open')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Display side navigation menu'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Company$SidenavToggled(true))
												]),
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$burgerMenu(_List_Nil)
												]))
										]))
								])
							]))),
					slideIn ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav-close')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Close side navigation menu'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Navbars$Company$SidenavToggled(false))
								]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$burgerMenuClose(_List_Nil)
								]))
						])) : $author$project$Utils$Html$empty,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('topnav')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__left')
								]),
							_List_fromArray(
								[
									patientFacingLogoSection,
									A2(
									$elm$core$Maybe$withDefault,
									A2($author$project$Navbars$Utils$viewSwitchOrganizationLink, companyName, sessionConfig.KE),
									maybeOrgSwitcher)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__right')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Navbars$Company$view = F3(
	function (hinterViewOff, maybeOrgSwitcherConfig, _v0) {
		var model = _v0;
		var practice = model.WF;
		var whitelabelSetting = model.aa1;
		var company = model.ab9;
		var sessionConfiguration = model.Cb;
		var slideIn = model.ow;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var profileMobileView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Company$subNavClasses, 0, model.c1) + ' sidenav__item--profile-mobile')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Profile'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Navbars$Company$NavClicked(0)),
							$author$project$Ui$Button$test('account-profile-mobile')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('sidenav__icon')
								]),
							3),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__profile-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sessionConfiguration.ahN)
								])),
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('sidenav__icon--show-more ml-2')
								]),
							12)
						])),
					$author$project$Navbars$Company$viewProfileSubNav(model.eE)
				]));
		var profileMenuView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sidenav__active', model.eE === 6)
						]))
				]),
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$position(1)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									$author$project$Navbars$Company$viewProfileSubNav(model.eE)
								]))
						]),
					A3(
						$author$project$Ui$Tooltip$view,
						tooltipOptions,
						'Profile',
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Profile'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$test('account-profile')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$SvgIcon$view,
										_List_fromArray(
											[
												$author$project$Ui$SvgIcon$class('sidenav__icon')
											]),
										3)
									]))
							])),
					model.ep)));
		var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Company$OrgSwitcherMsg, maybeOrgSwitcherConfig);
		var navElementsMobile = A2(
			$elm$core$List$map,
			A5($author$project$Navbars$Company$viewMobileNavElements, hinterViewOff, model, company, practice, sessionConfiguration),
			$author$project$Navbars$Company$defaultNav);
		var navElementsDesktop = A2(
			$elm$core$List$map,
			A5($author$project$Navbars$Company$viewDesktopNavElements, hinterViewOff, model, company, practice, sessionConfiguration),
			$author$project$Navbars$Company$defaultNav);
		return _List_fromArray(
			[
				A5(
				$author$project$Navbars$Company$viewTopNavbar,
				model,
				whitelabelSetting,
				$author$project$Api$Employer$Company$One$name(company),
				sessionConfiguration,
				orgSwitcherHtml),
				$author$project$Navbars$Utils$viewTopNavEnd,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('sidenav'),
						$elm$html$Html$Attributes$class('sidenav'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav--slide-in', slideIn)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Navbars$Utils$viewOrganizationHeader,
						$author$project$Api$Employer$Company$One$name(company),
						sessionConfiguration.KE),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
							]),
						navElementsMobile),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
							]),
						navElementsDesktop),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sidenav__bottom-separator')
									]),
								_List_Nil),
								profileMobileView,
								profileMenuView
							]))
					]))
			]);
	});
var $author$project$Navbars$Partner$NavClicked = function (a) {
	return {$: 4, a: a};
};
var $author$project$Navbars$Partner$OrgSwitcherMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Navbars$Partner$defaultNav = F2(
	function (isHinter, partner) {
		var reducedNav = !$author$project$Api$Partner$Partner$One$active(partner);
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					{yq: 7}),
					$elm$core$Maybe$Just(
					{yq: 0}),
					$elm$core$Maybe$Just(
					{yq: 5}),
					reducedNav ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{yq: 2}),
					reducedNav ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{yq: 3}),
					reducedNav ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					{yq: 4}),
					$author$project$Api$Partner$Partner$One$sandboxEnabled(partner) ? $elm$core$Maybe$Just(
					{yq: 6}) : $elm$core$Maybe$Nothing,
					isHinter ? $elm$core$Maybe$Just(
					{yq: 1}) : $elm$core$Maybe$Nothing
				]));
	});
var $author$project$Navbars$Partner$subNavClasses = F2(
	function (subnav, openSubNav) {
		return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
	});
var $author$project$Navbars$Partner$LinkClicked = {$: 0};
var $author$project$Navbars$Partner$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('sidenav__item--partner');
var $author$project$Navbars$Partner$viewDesktopNavElements = F5(
	function (_v0, _v1, _v2, _v3, navItem) {
		var selectedNav = _v1.eE;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var _v4 = navItem.yq;
		switch (_v4) {
			case 0:
				var route = $author$project$Spa$Generated$Route$Partner__Team;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 0, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Team',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('team')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											82)
										]))
								]))
						]));
			case 7:
				var route = $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 7, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Dashboard',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('products')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											70)
										]))
								]))
						]));
			case 3:
				var route = $author$project$Spa$Generated$Route$Partner__ApiKeys;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 3, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Api Keys',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('partner-api-keys')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											77)
										]))
								]))
						]));
			case 4:
				var route = $author$project$Spa$Generated$Route$Partner__WebhookEndpoints;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 4, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Webhook Endpoints',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('partner-webhook-endpoints')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											78)
										]))
								]))
						]));
			case 5:
				var route = $author$project$Spa$Generated$Route$Partner__Practices__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 5, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Practices',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('practices')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											89)
										]))
								]))
						]));
			case 1:
				var route = $author$project$Spa$Generated$Route$Partner__Hinter;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 1, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Hint',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('hinter')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											33)
										]))
								]))
						]));
			case 2:
				var route = $author$project$Spa$Generated$Route$Partner__Billing;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 2, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Billing',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('billing')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											50)
										]))
								]))
						]));
			case 6:
				var route = $author$project$Spa$Generated$Route$Partner__Sandboxes__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 6, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							'Sandboxes',
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									route,
									_List_fromArray(
										[
											$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
											$author$project$Ui$Link$test('sandboxes')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class('sidenav__icon')
												]),
											91)
										]))
								]))
						]));
			case 8:
				return $author$project$Utils$Html$empty;
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$Partner$viewMobileNavElements = F5(
	function (_v0, _v1, _v2, _v3, navItem) {
		var selectedNav = _v1.eE;
		var _v4 = navItem.yq;
		switch (_v4) {
			case 0:
				var route = $author$project$Spa$Generated$Route$Partner__Team;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 0, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('team')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									82),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Team')
										]))
								]))
						]));
			case 7:
				var route = $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 7, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									70),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Dashboard')
										]))
								]))
						]));
			case 3:
				var route = $author$project$Spa$Generated$Route$Partner__ApiKeys;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 3, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('partner-api-keys')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									77),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Api Keys')
										]))
								]))
						]));
			case 4:
				var route = $author$project$Spa$Generated$Route$Partner__WebhookEndpoints;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 4, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('partner-webhook-endpoints')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									78),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Webhook Endpoints')
										]))
								]))
						]));
			case 5:
				var route = $author$project$Spa$Generated$Route$Partner__Practices__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 5, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('practices')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									79),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Practices')
										]))
								]))
						]));
			case 1:
				var route = $author$project$Spa$Generated$Route$Partner__Hinter;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 1, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('hinter')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									33),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Hint')
										]))
								]))
						]));
			case 6:
				var route = $author$project$Spa$Generated$Route$Partner__Sandboxes__Top;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 6, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('sandboxes')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									83),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Sandboxes')
										]))
								]))
						]));
			case 2:
				var route = $author$project$Spa$Generated$Route$Partner__Billing;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class(
							A2($author$project$Navbars$Partner$selectedNavClass, 2, selectedNav))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							route,
							_List_fromArray(
								[
									$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
									$author$project$Ui$Link$test('billing')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$SvgIcon$view,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$class('sidenav__icon')
										]),
									50),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Billing')
										]))
								]))
						]));
			case 8:
				return $author$project$Utils$Html$empty;
			default:
				return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Navbars$Partner$LogoutClicked = {$: 1};
var $author$project$Navbars$Partner$viewProfileSubNav = function (selectedNav) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__subnav__content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Partner$selectedNavClass, 8, selectedNav))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Profile,
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
								$author$project$Ui$Link$test('account-profile')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Logout'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Navbars$Partner$LogoutClicked),
								$author$project$Ui$Button$test('account-logout')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Navbars$Partner$SidenavToggled = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Image$viewHintLogoImage = function (optionsMinusAlt) {
	return A3(
		$author$project$Ui$Image$viewImg,
		{I1: 'Hint Logo'},
		$author$project$Ui$Image$nameToCdnSrc('full-logo.svg'),
		optionsMinusAlt);
};
var $author$project$Navbars$Partner$viewLogo = $author$project$Ui$Image$viewHintLogoImage(
	_List_fromArray(
		[
			$author$project$Ui$Image$height(40)
		]));
var $author$project$Navbars$Partner$viewTopNavbar = F5(
	function (hinterViewOff, _v0, partnerName, sessionConfig, maybeOrgSwitcher) {
		var selectedNav = _v0.eE;
		var slideIn = _v0.ow;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-mobile-nav')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[$author$project$Navbars$Partner$viewLogo]),
								slideIn ? _List_Nil : _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav-open')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Display side navigation menu'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Partner$SidenavToggled(true))
												]),
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$burgerMenu(_List_Nil)
												]))
										]))
								])
							]))),
					slideIn ? A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav-close')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Close side navigation menu'},
							_List_fromArray(
								[
									$author$project$Ui$Button$link,
									$author$project$Ui$Button$onClick(
									$author$project$Navbars$Partner$SidenavToggled(false))
								]),
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$burgerMenuClose(_List_Nil)
								]))
						])) : $author$project$Utils$Html$empty,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('topnav')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__left')
								]),
							_List_fromArray(
								[
									$author$project$Navbars$Partner$viewLogo,
									A2(
									$elm$core$Maybe$withDefault,
									A2($author$project$Navbars$Utils$viewSwitchOrganizationLink, partnerName, sessionConfig.KE),
									maybeOrgSwitcher)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__right')
								]),
							_List_fromArray(
								[
									sessionConfig.ym(hinterViewOff) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('topnav__item'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('topnav__active', 9 === selectedNav)
												]))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Marketplace__Top,
											_List_fromArray(
												[
													$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$marketplace)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Marketplace')
												]))
										])) : $author$project$Utils$Html$empty
								]))
						]))
				]));
	});
var $author$project$Navbars$Partner$view = F3(
	function (hinterViewOff, maybeOrgSwitcherConfig, _v0) {
		var model = _v0;
		var partner = model.Vz;
		var sessionConfiguration = model.Cb;
		var slideIn = model.ow;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var profileMobileView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Partner$subNavClasses, 0, model.c1) + ' sidenav__item--profile-mobile')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Profile'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Navbars$Partner$NavClicked(0)),
							$author$project$Ui$Button$test('account-profile-mobile')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('sidenav__icon')
								]),
							3),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__profile-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sessionConfiguration.ahN)
								])),
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('sidenav__icon--show-more ml-2')
								]),
							12)
						])),
					$author$project$Navbars$Partner$viewProfileSubNav(model.eE)
				]));
		var profileMenuView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('sidenav__active', model.eE === 8)
						]))
				]),
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$position(1)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									$author$project$Navbars$Partner$viewProfileSubNav(model.eE)
								]))
						]),
					A3(
						$author$project$Ui$Tooltip$view,
						tooltipOptions,
						'Profile',
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Profile'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$test('account-profile')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$SvgIcon$view,
										_List_fromArray(
											[
												$author$project$Ui$SvgIcon$class('sidenav__icon')
											]),
										3)
									]))
							])),
					model.ep)));
		var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Partner$OrgSwitcherMsg, maybeOrgSwitcherConfig);
		var isHinter = sessionConfiguration.ym(hinterViewOff);
		var navElementsDesktop = A2(
			$elm$core$List$map,
			A4($author$project$Navbars$Partner$viewDesktopNavElements, hinterViewOff, model, partner, sessionConfiguration),
			A2($author$project$Navbars$Partner$defaultNav, isHinter, partner));
		var navElementsMobile = A2(
			$elm$core$List$map,
			A4($author$project$Navbars$Partner$viewMobileNavElements, hinterViewOff, model, partner, sessionConfiguration),
			A2($author$project$Navbars$Partner$defaultNav, isHinter, partner));
		return _List_fromArray(
			[
				A5(
				$author$project$Navbars$Partner$viewTopNavbar,
				hinterViewOff,
				model,
				$author$project$Api$Partner$Partner$One$name(partner),
				sessionConfiguration,
				orgSwitcherHtml),
				$author$project$Navbars$Utils$viewTopNavEnd,
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('sidenav'),
						$elm$html$Html$Attributes$class('sidenav'),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav--slide-in', slideIn)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Navbars$Utils$viewOrganizationHeader,
						$author$project$Api$Partner$Partner$One$name(model.Vz),
						sessionConfiguration.KE),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
							]),
						navElementsMobile),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
							]),
						navElementsDesktop),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('sidenav__bottom-separator')
									]),
								_List_Nil),
								profileMobileView,
								profileMenuView
							]))
					]))
			]);
	});
var $author$project$Navbars$Practice$LinkClicked = {$: 3};
var $author$project$Navbars$Practice$NavClicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Navbars$Practice$OrgSwitcherMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Navbars$Practice$SearchClicked = {$: 4};
var $author$project$Navbars$Practice$SidenavExpandToggled = {$: 13};
var $author$project$Navbars$Practice$SidenavToggled = function (a) {
	return {$: 11, a: a};
};
var $author$project$Navbars$Practice$Navigation$InternalRoute = function (a) {
	return {$: 0, a: a};
};
var $author$project$Navbars$Practice$Navigation$InternalRouteWithParams = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Feature$NewMessagingEndpoint = 27;
var $author$project$Navbars$Practice$Navigation$startAndEndDateParams = F2(
	function (startDate, endDate) {
		return _List_fromArray(
			[
				A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('start'),
				$author$project$Utils$Date$toQuery)(startDate),
				A2(
				$elm$core$Basics$composeL,
				$elm$url$Url$Builder$string('end'),
				$author$project$Utils$Date$toQuery)(endDate)
			]);
	});
var $author$project$Navbars$Practice$Navigation$currentMonthParams = function (maybeDate) {
	if (!maybeDate.$) {
		var currentDate_ = maybeDate.a;
		return A2(
			$author$project$Navbars$Practice$Navigation$startAndEndDateParams,
			$author$project$Utils$Date$toBeginningOfMonth(currentDate_),
			$author$project$Utils$Date$toEndOfMonth(currentDate_));
	} else {
		return _List_Nil;
	}
};
var $author$project$Navbars$Practice$Navigation$mainNavItems = F4(
	function (practice, practiceConfiguration, sessionConfiguration, hinterViewOff) {
		var newMessagingEndpointEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 27, practice);
		var inboxRoute = newMessagingEndpointEnabled ? $author$project$Spa$Generated$Route$Messages__Messages : $author$project$Spa$Generated$Route$Messages__Sms;
		var employersText = A2($author$project$Formatters$String$sponsorize, practice, 'Employers');
		return _List_fromArray(
			[
				{
				QG: 70,
				yq: $author$project$Navbars$Practice$Navigation$ClinicalDashboard,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Home),
				th: 'dashboard',
				$A: 'Dashboard',
				hd: practiceConfiguration.oV && practiceConfiguration.$e
			},
				{
				QG: 8,
				yq: $author$project$Navbars$Practice$Navigation$Patients,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Patients__Top),
				th: 'patients',
				$A: 'Patients',
				hd: sessionConfiguration.Er(hinterViewOff)
			},
				{
				QG: 72,
				yq: $author$project$Navbars$Practice$Navigation$Contacts,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Contacts__List),
				th: 'clinical-contacts',
				$A: 'Contacts',
				hd: practiceConfiguration.oV && (practiceConfiguration.$e && practiceConfiguration.Ul)
			},
				{
				QG: 53,
				yq: $author$project$Navbars$Practice$Navigation$Calendar,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Calendar),
				th: 'clinical-calendar',
				$A: 'Calendar',
				hd: practiceConfiguration.oV && practiceConfiguration.$e
			},
				{
				QG: 71,
				yq: $author$project$Navbars$Practice$Navigation$Inbox,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute(inboxRoute),
				th: 'clinical-inbox',
				$A: practiceConfiguration.Ul ? 'Inbox' : 'Communication',
				hd: practiceConfiguration.oV && practiceConfiguration.$e
			},
				{
				QG: 76,
				yq: $author$project$Navbars$Practice$Navigation$Tasks,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Tasks__Top),
				th: 'clinical-tasks',
				$A: 'Tasks',
				hd: practiceConfiguration.oV && practiceConfiguration.$e
			},
				{
				QG: 73,
				yq: $author$project$Navbars$Practice$Navigation$Forms,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Forms),
				th: 'clinical-forms',
				$A: 'Forms',
				hd: practiceConfiguration.oV && practiceConfiguration.$e
			},
				{
				QG: 11,
				yq: $author$project$Navbars$Practice$Navigation$Sponsors,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Companies__Top),
				th: 'sponsors',
				$A: employersText,
				hd: sessionConfiguration.Kv(hinterViewOff)
			},
				{
				QG: 10,
				yq: $author$project$Navbars$Practice$Navigation$Networks,
				SU: A2($author$project$Navbars$Practice$Navigation$InternalRouteWithParams, $author$project$Spa$Generated$Route$AffiliateBills__Top, $author$project$Navbars$Practice$Navigation$currentMonthParams),
				th: 'networks',
				$A: 'Networks',
				hd: practiceConfiguration.RV && sessionConfiguration.Kw(hinterViewOff)
			},
				{
				QG: 6,
				yq: $author$project$Navbars$Practice$Navigation$Commissions,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
				th: 'commissions',
				$A: 'Commissions',
				hd: practiceConfiguration.Ln && sessionConfiguration.Ku(hinterViewOff)
			},
				{
				QG: 63,
				yq: $author$project$Navbars$Practice$Navigation$Accounting,
				SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Accounting),
				th: 'accounting',
				$A: 'Accounting',
				hd: practiceConfiguration.H8 && sessionConfiguration.Kt(hinterViewOff)
			}
			]);
	});
var $author$project$Navbars$Practice$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('');
var $author$project$Navbars$Practice$subNavClasses = F2(
	function (subnav, openSubNav) {
		return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
	});
var $author$project$Components$HinterPracticeSettingsModal$SearchQueryChanged = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$filterFeatures = F2(
	function (query, features) {
		if ($elm$core$String$isEmpty(query)) {
			return features;
		} else {
			var lowercaseQuery = $elm$core$String$toLower(query);
			return A2(
				$elm$core$List$filter,
				function (feature) {
					return A2(
						$elm$core$String$contains,
						lowercaseQuery,
						$elm$core$String$toLower(
							$author$project$Api$Common$Feature$Shared$name(feature)));
				},
				features);
		}
	});
var $author$project$Components$HinterPracticeSettingsModal$sortFeatures = function (features) {
	return A2($elm$core$List$sortBy, $author$project$Api$Common$Feature$Shared$name, features);
};
var $author$project$Components$HinterPracticeSettingsModal$ChangeFeature = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$HinterPracticeSettingsModal$viewFeature = function (feature) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$author$project$Ui$Button$group(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$view(
						_List_fromArray(
							[
								$author$project$Ui$ToggleSwitch$on(
								$author$project$Api$Common$Feature$Shared$enabled(feature)),
								$author$project$Ui$ToggleSwitch$onChange(
								$author$project$Components$HinterPracticeSettingsModal$ChangeFeature(
									$author$project$Api$Common$Feature$Shared$id(feature))),
								$author$project$Ui$ToggleSwitch$sm
							]))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$ml2]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Api$Common$Feature$Shared$name(feature))
					]))
			]));
};
var $author$project$Components$HinterPracticeSettingsModal$viewFeatureFlags = function (data) {
	var _v0 = data.Pd;
	switch (_v0.$) {
		case 1:
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[$author$project$Ui$Spinner$small])),
						$elm$html$Html$text(' Loading features...')
					]));
		case 3:
			var features = _v0.a;
			var filteredFeatures = $author$project$Components$HinterPracticeSettingsModal$sortFeatures(
				A2($author$project$Components$HinterPracticeSettingsModal$filterFeatures, data.sB, features));
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Ui$Form$Input$view(
						_List_fromArray(
							[
								$author$project$Ui$Form$Input$placeholder('Search features...'),
								$author$project$Ui$Form$Input$value(data.sB),
								$author$project$Ui$Form$Input$onInput($author$project$Components$HinterPracticeSettingsModal$SearchQueryChanged)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt4, $author$project$Ui$Element$spaceY2]),
						_List_fromArray(
							[
								$elm$core$List$isEmpty(filteredFeatures) ? A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$textMuted]),
								_List_fromArray(
									[
										$elm$html$Html$text('No features found')
									])) : A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								A2($elm$core$List$map, $author$project$Components$HinterPracticeSettingsModal$viewFeature, filteredFeatures))
							]))
					]));
		case 2:
			return $author$project$Utils$Html$empty;
		default:
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$textMuted]),
				_List_fromArray(
					[
						$author$project$Ui$Spinner$view(
						_List_fromArray(
							[$author$project$Ui$Spinner$small])),
						$elm$html$Html$text(' Loading...')
					]));
	}
};
var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$currentManagementGroupId = function (currentGroup) {
	return A2($elm$core$Maybe$map, $author$project$Api$Provider$ManagementGroup$Shared$id, currentGroup);
};
var $author$project$Components$HinterPracticeSettingsModal$managementGroupOptions = function (data) {
	var _v0 = data.m_;
	if (_v0.$ === 3) {
		var groups = _v0.a;
		return A2(
			$elm$core$List$cons,
			A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'None'),
			A2(
				$elm$core$List$map,
				function (group) {
					return A3(
						$author$project$Ui$Form$Select$option,
						_List_Nil,
						$elm$core$Maybe$Just(
							$author$project$Api$Provider$ManagementGroup$Shared$id(group)),
						$author$project$Api$Provider$ManagementGroup$Shared$name(group));
				},
				groups));
	} else {
		return _List_fromArray(
			[
				A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Loading...')
			]);
	}
};
var $author$project$Components$HinterPracticeSettingsModal$viewManagementGroup = function (data) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Practice Settings')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						function () {
						var _v0 = data.m_;
						switch (_v0.$) {
							case 1:
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Management Group')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small])),
													$elm$html$Html$text(' Loading management groups...')
												]))
										]));
							case 3:
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Management Group')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Form$Select$view,
											_List_fromArray(
												[
													$author$project$Ui$Form$Select$value(
													$author$project$Components$HinterPracticeSettingsModal$currentManagementGroupId(data.h2)),
													$author$project$Ui$Form$Select$onChange($author$project$Components$HinterPracticeSettingsModal$ManagementGroupSelected)
												]),
											$author$project$Components$HinterPracticeSettingsModal$managementGroupOptions(data))
										]));
							case 2:
								return $author$project$Utils$Html$empty;
							default:
								return A2(
									$author$project$Ui$Form$Group$view,
									_List_fromArray(
										[
											$author$project$Ui$Form$Group$label('Management Group')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$textMuted]),
											_List_fromArray(
												[
													$author$project$Ui$Spinner$view(
													_List_fromArray(
														[$author$project$Ui$Spinner$small])),
													$elm$html$Html$text(' Loading...')
												]))
										]));
						}
					}()
					]))
			]));
};
var $author$project$Components$HinterPracticeSettingsModal$CopyToClipboard = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$HinterPracticeSettingsModal$GoToHinterSettings = {$: 10};
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Components$HinterPracticeSettingsModal$formatCreatedDate = function (practice) {
	return A2(
		$author$project$Formatters$Date$toString,
		$author$project$Formatters$Date$Full,
		A2(
			$justinmimbs$date$Date$fromPosix,
			$elm$time$Time$utc,
			$author$project$Api$Provider$Practice$One$createdAt(practice)));
};
var $author$project$Components$HinterPracticeSettingsModal$viewPracticeInfo = function (data) {
	return A2(
		$author$project$Ui$Panel$view,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$heading,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Typography$title,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Practice Info')
							]))
					])),
				A2(
				$author$project$Ui$Panel$body,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Name: ')
											])),
										$elm$html$Html$text(
										$author$project$Api$Provider$Practice$One$name(data.WF))
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Copy practice name'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$HinterPracticeSettingsModal$CopyToClipboard(
											$author$project$Api$Provider$Practice$One$name(data.WF))),
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Practice ID: ')
											])),
										$elm$html$Html$text(
										$author$project$Api$Provider$Practice$One$id(data.WF))
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Copy practice ID'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$HinterPracticeSettingsModal$CopyToClipboard(
											$author$project$Api$Provider$Practice$One$id(data.WF))),
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Organization ID: ')
											])),
										$elm$html$Html$text(
										$author$project$Api$Provider$Practice$One$organizationId(data.WF))
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Copy organization ID'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$HinterPracticeSettingsModal$CopyToClipboard(
											$author$project$Api$Provider$Practice$One$organizationId(data.WF))),
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2, $author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Typography$strong,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Created On: ')
											])),
										$elm$html$Html$text(
										$author$project$Components$HinterPracticeSettingsModal$formatCreatedDate(data.WF))
									])),
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Copy created date'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										$author$project$Components$HinterPracticeSettingsModal$CopyToClipboard(
											$author$project$Components$HinterPracticeSettingsModal$formatCreatedDate(data.WF))),
										$author$project$Ui$Button$size(0),
										$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$copy)
									]),
								_List_Nil)
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mt2]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$Button$view,
								{abp: 'Go to Hinter settings'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$GoToHinterSettings)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Go to Clinical Hinter settings.')
									]))
							]))
					]))
			]));
};
var $author$project$Components$HinterPracticeSettingsModal$view = function (model) {
	if (model.$ === 1) {
		var data = model.a;
		return A3(
			$author$project$Ui$Modal$view,
			$author$project$Components$HinterPracticeSettingsModal$CloseModal,
			_List_fromArray(
				[
					$author$project$Ui$Modal$size(2)
				]),
			_List_fromArray(
				[
					$author$project$Ui$Modal$header(
					_List_fromArray(
						[
							$author$project$Ui$Modal$title('Hinter Practice Settings')
						])),
					$author$project$Ui$Modal$body(
					_List_fromArray(
						[
							A2(
							$author$project$Ui$FlexGrid$row,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(12),
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											$author$project$Components$HinterPracticeSettingsModal$viewPracticeInfo(data),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$mt4]),
											_List_fromArray(
												[
													$author$project$Components$HinterPracticeSettingsModal$viewManagementGroup(data)
												]))
										])),
									A2(
									$author$project$Ui$FlexGrid$column,
									_List_fromArray(
										[
											$author$project$Ui$FlexGrid$span(12),
											$author$project$Ui$FlexGrid$spanMd(6)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Panel$view,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Panel$heading,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Typography$title,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Feature Flags')
																]))
														])),
													A2(
													$author$project$Ui$Panel$body,
													_List_Nil,
													_List_fromArray(
														[
															$author$project$Components$HinterPracticeSettingsModal$viewFeatureFlags(data)
														]))
												]))
										]))
								]))
						])),
					$author$project$Ui$Modal$footer(
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Button$view,
							{abp: 'Close modal'},
							_List_fromArray(
								[
									$author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$CloseModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	} else {
		return $author$project$Utils$Html$empty;
	}
};
var $author$project$Navbars$Practice$DesktopExpandedStyle = {$: 2};
var $author$project$Navbars$Practice$DesktopStyle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Common$PartnerApp$All$shared = function (_v0) {
	var shared_ = _v0;
	return shared_;
};
var $author$project$Api$Common$PartnerApp$All$embedsCorePage = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$embedsCorePage);
var $author$project$Navbars$Practice$Navigation$adminSubnavItems = F3(
	function (practice, practiceConfiguration, isHintAdmin) {
		var providersItem = {
			yq: 1,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Providers__Top),
			th: 'admin-providers',
			$A: 'Providers & Patients',
			hd: true
		};
		var onlineSignupItem = {
			yq: 3,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Signup),
			th: 'admin-signup',
			$A: 'Online Signup',
			hd: true
		};
		var notificationsItem = {
			yq: 7,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Notifications__Patient),
			th: 'admin-notifications-patient',
			$A: 'Notifications',
			hd: true
		};
		var membershipOptionsItem = {
			yq: 2,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Plans__Top),
			th: 'admin-plans',
			$A: 'Membership Options',
			hd: true
		};
		var isClinicalAndCore = practiceConfiguration.oV && practiceConfiguration.$e;
		var integrationsItem = {
			yq: 9,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute(
				$author$project$Utils$Route$integrationsRoute(practice)),
			th: 'admin-stripe',
			$A: 'Integrations',
			hd: true
		};
		var ephiItem = {
			yq: 8,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__HipaaAuthorizations),
			th: 'admin-hipaa-authorizations',
			$A: 'ePHI Communication Waivers',
			hd: true
		};
		var employersText = A2($author$project$Formatters$String$sponsorize, practice, 'Employers');
		var employersItem = {
			yq: 10,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__InvoiceSettings),
			th: 'admin-invoice-settings',
			$A: employersText,
			hd: practiceConfiguration.F3
		};
		var documentsItem = {
			yq: 11,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Documents__Top),
			th: 'admin-documents',
			$A: 'Documents',
			hd: true
		};
		var developersItem = {
			yq: 19,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Developers__ApiKeys),
			th: 'admin-developers',
			$A: 'Developers',
			hd: isHintAdmin && $author$project$Api$Provider$Practice$One$hasManagedPartner(practice)
		};
		var dataExportItem = {
			yq: 12,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__DataExport__Top),
			th: 'admin-data-export',
			$A: 'Data Exporter',
			hd: practiceConfiguration.ML
		};
		var creditsItem = {
			yq: 4,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__CreditCategories),
			th: 'admin-credit-categories',
			$A: 'Credits',
			hd: practiceConfiguration.Al
		};
		var commissionsItem = {
			yq: 6,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Commissions),
			th: 'admin-commissions-setup',
			$A: 'Commissions',
			hd: true
		};
		var chargesText = 'Charges' + (practiceConfiguration.FJ ? ' & Taxes' : '');
		var chargesItem = {
			yq: 5,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__ChargeItems__Top),
			th: 'admin-charge-items',
			$A: chargesText,
			hd: true
		};
		var accountItem = {
			yq: 0,
			SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Practice),
			th: 'admin-practice',
			$A: 'Account',
			hd: true
		};
		if (isClinicalAndCore) {
			var remainingItems = _List_fromArray(
				[
					ephiItem,
					{
					yq: 15,
					SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Erx),
					th: 'clinical-erx',
					$A: 'eRx',
					hd: true
				},
					{
					yq: 17,
					SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Files__Top),
					th: 'clinical-file-drive',
					$A: 'File Drive',
					hd: practiceConfiguration.Ul
				},
					integrationsItem,
					{
					yq: 16,
					SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Inventory__List),
					th: 'clinical-medications',
					$A: 'Medications',
					hd: practiceConfiguration.Ul
				},
					membershipOptionsItem,
					notificationsItem,
					onlineSignupItem,
					{
					yq: 20,
					SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__PracticeInfo),
					th: 'clinical-phones',
					$A: 'Phones',
					hd: true
				},
					providersItem,
					{
					yq: 21,
					SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Team),
					th: 'clinical-team',
					$A: 'Team',
					hd: true
				},
					{
					yq: 18,
					SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Templates__Top),
					th: 'clinical-templates',
					$A: 'Templates',
					hd: true
				}
				]);
			var clinicalCoreItems = _List_fromArray(
				[
					accountItem,
					{
					yq: 14,
					SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top),
					th: 'clinical-appointment-types',
					$A: 'Appointment Types',
					hd: true
				},
					{
					yq: 13,
					SU: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Locations__Top),
					th: 'clinical-calendar-locations',
					$A: 'Calendar',
					hd: true
				},
					chargesItem,
					commissionsItem,
					creditsItem,
					dataExportItem,
					documentsItem
				]);
			return (employersText === 'Employers') ? _Utils_ap(
				clinicalCoreItems,
				_Utils_ap(
					A2($elm$core$List$cons, employersItem, remainingItems),
					_List_fromArray(
						[developersItem]))) : _Utils_ap(
				clinicalCoreItems,
				_Utils_ap(
					remainingItems,
					_List_fromArray(
						[employersItem, developersItem])));
		} else {
			return _List_fromArray(
				[accountItem, providersItem, membershipOptionsItem, onlineSignupItem, creditsItem, chargesItem, commissionsItem, notificationsItem, ephiItem, integrationsItem, employersItem, documentsItem, dataExportItem, developersItem]);
		}
	});
var $author$project$Navbars$Practice$viewAdminSubNav = F4(
	function (selectedNav, practice, practiceConfiguration, isHintAdmin) {
		var viewItem = function (item) {
			return item.hd ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2(
							$author$project$Navbars$Practice$selectedNavClass,
							$author$project$Navbars$Practice$Navigation$Admin(item.yq),
							selectedNav))
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = item.SU;
						if (!_v0.$) {
							var route = _v0.a;
							return A3(
								$author$project$Ui$Link$route,
								route,
								_List_fromArray(
									[
										$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
										$author$project$Ui$Link$test(item.th)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(item.$A)
									]));
						} else {
							var route = _v0.a;
							return A3(
								$author$project$Ui$Link$route,
								route,
								_List_fromArray(
									[
										$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
										$author$project$Ui$Link$test(item.th)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(item.$A)
									]));
						}
					}()
					])) : $author$project$Utils$Html$empty;
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__subnav__content')
				]),
			A2(
				$elm$core$List$map,
				viewItem,
				A3($author$project$Navbars$Practice$Navigation$adminSubnavItems, practice, practiceConfiguration, isHintAdmin)));
	});
var $author$project$Navbars$Practice$viewNavIcon = F2(
	function (style, iconName) {
		var baseClasses = 'sidenav__icon';
		var classes = function () {
			var _v0 = _Utils_Tuple2(style, iconName);
			_v0$2:
			while (true) {
				if (_v0.b === 63) {
					switch (_v0.a.$) {
						case 1:
							var _v1 = _v0.b;
							return baseClasses + ' w-5 h-4.5';
						case 2:
							var _v2 = _v0.a;
							var _v3 = _v0.b;
							return baseClasses;
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			}
			return baseClasses;
		}();
		return A2(
			$author$project$Ui$SvgIcon$view,
			_List_fromArray(
				[
					$author$project$Ui$SvgIcon$class(classes)
				]),
			iconName);
	});
var $author$project$Navbars$Practice$viewMainNavItem = F4(
	function (style, selectedNav, currentDate, item) {
		if (item.hd) {
			var linkOptions = function () {
				switch (style.$) {
					case 0:
						return _List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test(item.th)
							]);
					case 1:
						return _List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test(item.th),
								$author$project$Ui$Link$ariaLabel(item.$A)
							]);
					default:
						return _List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test(item.th)
							]);
				}
			}();
			var linkContent = function () {
				switch (style.$) {
					case 0:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2($author$project$Navbars$Practice$viewNavIcon, style, item.QG)),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(item.$A)
									]))
							]);
					case 1:
						return _List_fromArray(
							[
								A2($author$project$Navbars$Practice$viewNavIcon, style, item.QG)
							]);
					default:
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2($author$project$Navbars$Practice$viewNavIcon, style, item.QG)),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(item.$A)
									]))
							]);
				}
			}();
			var createLink = F2(
				function (route, params) {
					if (!params.$) {
						var paramsFn = params.a;
						return A3(
							$author$project$Ui$Link$route,
							route,
							A2(
								$elm$core$List$cons,
								$author$project$Ui$Link$routeParams(
									paramsFn(currentDate)),
								linkOptions),
							linkContent);
					} else {
						return A3($author$project$Ui$Link$route, route, linkOptions, linkContent);
					}
				});
			var linkElement = function () {
				var _v1 = item.SU;
				if (!_v1.$) {
					var route = _v1.a;
					return A2(createLink, route, $elm$core$Maybe$Nothing);
				} else {
					var route = _v1.a;
					var paramsFn = _v1.b;
					return A2(
						createLink,
						route,
						$elm$core$Maybe$Just(paramsFn));
				}
			}();
			var wrappedLink = function () {
				switch (style.$) {
					case 0:
						return linkElement;
					case 1:
						var tooltipOptions = style.a;
						return A3(
							$author$project$Ui$Tooltip$view,
							tooltipOptions,
							item.$A,
							_List_fromArray(
								[linkElement]));
					default:
						return linkElement;
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Practice$selectedNavClass, item.yq, selectedNav))
					]),
				_List_fromArray(
					[wrappedLink]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Api$Common$PartnerApp$All$corePageAnchor = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$corePageAnchor);
var $author$project$Api$Common$PartnerApp$Anchor$corePageIconLabel = function (_v0) {
	var record = _v0;
	var _v1 = record.ahI;
	switch (_v1) {
		case 0:
			return record.LW;
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$PartnerApp$Anchor$corePageIconUrl = function (_v0) {
	var record = _v0;
	var _v1 = record.ahI;
	switch (_v1) {
		case 0:
			return record.LX;
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Common$PartnerApp$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$name);
var $author$project$Api$Common$PartnerApp$Shared$partner = function (_v0) {
	var record = _v0;
	return record.Vz;
};
var $author$project$Api$Common$Partner$Min$slug = function (_v0) {
	var record = _v0;
	return record._c;
};
var $author$project$Api$Common$PartnerApp$All$partnerSlug = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Common$PartnerApp$All$shared,
	A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$Shared$partner, $author$project$Api$Common$Partner$Min$slug));
var $author$project$WebComponents$SvgIconFromUrl$view = F2(
	function (attributes, url) {
		return A3(
			$elm$html$Html$node,
			'svg-icon-from-url',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'src', url),
				attributes),
			_List_Nil);
	});
var $author$project$Navbars$Practice$viewPartnerNavItem = F3(
	function (style, selectedNav, partnerApp) {
		var partnerIcon = A2(
			$elm$core$Maybe$withDefault,
			A2(
				$author$project$Ui$SvgIcon$view,
				_List_fromArray(
					[
						$author$project$Ui$SvgIcon$class('sidenav__icon')
					]),
				70),
			A2(
				$elm$core$Maybe$map,
				function (url) {
					return A2(
						$author$project$WebComponents$SvgIconFromUrl$view,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('sidenav__icon')
							]),
						url);
				},
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Common$PartnerApp$Anchor$corePageIconUrl,
					$author$project$Api$Common$PartnerApp$All$corePageAnchor(partnerApp))));
		var linkLabel = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Api$Common$PartnerApp$All$name(partnerApp),
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Api$Common$PartnerApp$Anchor$corePageIconLabel,
				$author$project$Api$Common$PartnerApp$All$corePageAnchor(partnerApp)));
		var linkContent = function () {
			switch (style.$) {
				case 0:
					return _List_fromArray(
						[
							A2($elm$html$Html$map, $elm$core$Basics$never, partnerIcon),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(linkLabel)
								]))
						]);
				case 1:
					return _List_fromArray(
						[partnerIcon]);
				default:
					return _List_fromArray(
						[
							A2($elm$html$Html$map, $elm$core$Basics$never, partnerIcon),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(linkLabel)
								]))
						]);
			}
		}();
		var appId = $author$project$Api$Common$PartnerApp$All$partnerSlug(partnerApp);
		var linkOptions = function () {
			switch (style.$) {
				case 0:
					return _List_fromArray(
						[
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test('partner-app-' + appId)
						]);
				case 1:
					return _List_fromArray(
						[
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test('partner-app-' + appId),
							$author$project$Ui$Link$ariaLabel(linkLabel)
						]);
				default:
					return _List_fromArray(
						[
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
							$author$project$Ui$Link$test('partner-app-' + appId)
						]);
			}
		}();
		var linkElement = A3(
			$author$project$Ui$Link$route,
			$author$project$Spa$Generated$Route$Apps__Slug_String(
				{_c: appId}),
			linkOptions,
			linkContent);
		var wrappedLink = function () {
			switch (style.$) {
				case 0:
					return linkElement;
				case 1:
					var tooltipOptions = style.a;
					return A3(
						$author$project$Ui$Tooltip$view,
						tooltipOptions,
						linkLabel,
						_List_fromArray(
							[linkElement]));
				default:
					return linkElement;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2(
						$author$project$Navbars$Practice$selectedNavClass,
						$author$project$Navbars$Practice$Navigation$PartnerApp(appId),
						selectedNav))
				]),
			_List_fromArray(
				[wrappedLink]));
	});
var $author$project$Navbars$Practice$Navigation$AncillaryCharges = {$: 14};
var $author$project$Navbars$Practice$Navigation$Disputes = {$: 15};
var $author$project$Api$Provider$Report$All$record = function (_v0) {
	var record_ = _v0;
	return record_;
};
var $author$project$Api$Provider$Report$All$id = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Report$All$record,
	function ($) {
		return $.adR;
	});
var $author$project$Api$Provider$Report$idToResource = function (id) {
	switch (id) {
		case 'signup_attempts':
			return $elm$core$Maybe$Just(1);
		case 'memberships':
			return $elm$core$Maybe$Just(11);
		case 'customer_invoices':
			return $elm$core$Maybe$Just(12);
		case 'invoices':
			return $elm$core$Maybe$Just(3);
		case 'credits':
			return $elm$core$Maybe$Just(15);
		case 'revenue_lines':
			return $elm$core$Maybe$Just(6);
		case 'deferred_revenue_lines':
			return $elm$core$Maybe$Just(7);
		case 'payment_applications':
			return $elm$core$Maybe$Just(9);
		case 'credit_lines':
			return $elm$core$Maybe$Just(14);
		case 'deposits':
			return $elm$core$Maybe$Just(13);
		case 'tax_lines':
			return $elm$core$Maybe$Just(8);
		case 'disputes':
			return $elm$core$Maybe$Just(21);
		case 'affiliate_ancillary_charges':
			return $elm$core$Maybe$Just(22);
		case 'company_registrations':
			return $elm$core$Maybe$Just(23);
		case 'payment_method_imports':
			return $elm$core$Maybe$Just(24);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Provider$EmbeddedReport$Shared$id = function (_v0) {
	var record = _v0;
	return record.adR;
};
var $author$project$Api$Provider$EmbeddedReport$All$id = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$EmbeddedReport$Shared$id(shared);
};
var $author$project$Api$Provider$EmbeddedReport$All$name = function (_v0) {
	var shared = _v0;
	return $author$project$Api$Provider$EmbeddedReport$Shared$name(shared);
};
var $author$project$Navbars$Practice$viewEmbeddedReport = F2(
	function (selectedNav, report) {
		var reportName = $author$project$Api$Provider$EmbeddedReport$All$name(report);
		var reportId = $author$project$Api$Provider$EmbeddedReport$All$id(report);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2(
						$author$project$Navbars$Practice$selectedNavClass,
						$author$project$Navbars$Practice$Navigation$Reports(
							$author$project$Navbars$Practice$Navigation$Custom(reportId)),
						selectedNav))
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Reports__Custom__Id_String(
						{adR: reportId}),
					_List_fromArray(
						[
							$author$project$Ui$Link$test(
							'reports-custom-' + A3(
								$elm$core$String$replace,
								' ',
								'-',
								$elm$core$String$toLower(reportName))),
							$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(reportName)
						]))
				]));
	});
var $author$project$Navbars$Practice$viewEmbeddedReports = F2(
	function (selectedNav, embeddedReports) {
		if (embeddedReports.$ === 3) {
			var reports = embeddedReports.a;
			return A2(
				$elm$core$List$map,
				$author$project$Navbars$Practice$viewEmbeddedReport(selectedNav),
				reports);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Navbars$Practice$viewReportSubNav = F6(
	function (selectedNav, currentDate, practice, practiceConfiguration, embeddedReports, reports) {
		var viewableReportResources = A2(
			$elm$core$List$filterMap,
			A2($elm$core$Basics$composeR, $author$project$Api$Provider$Report$All$id, $author$project$Api$Provider$Report$idToResource),
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$author$project$Api$Data$toMaybe(reports)));
		var trailing13MonthsParams = function () {
			if (!currentDate.$) {
				var currentDate_ = currentDate.a;
				return function (_v4) {
					var startDate = _v4.a;
					var endDate = _v4.b;
					return A2(
						$author$project$Navbars$Practice$Navigation$startAndEndDateParams,
						$author$project$Utils$Date$toBeginningOfMonth(startDate),
						endDate);
				}(
					A2($author$project$Utils$Date$trailingRange, 13, currentDate_));
			} else {
				return _List_Nil;
			}
		}();
		var trailing12MonthsParams = function () {
			if (!currentDate.$) {
				var currentDate_ = currentDate.a;
				return function (_v2) {
					var startDate = _v2.a;
					var endDate = _v2.b;
					return A2($author$project$Navbars$Practice$Navigation$startAndEndDateParams, startDate, endDate);
				}(
					A2($author$project$Utils$Date$trailingRange, 12, currentDate_));
			} else {
				return _List_Nil;
			}
		}();
		var ifViewable = F2(
			function (reportResource, content) {
				return A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always(content),
						A2(
							$elm_community$list_extra$List$Extra$find,
							$elm$core$Basics$eq(reportResource),
							viewableReportResources)));
			});
		var currentMonthParams = function () {
			if (!currentDate.$) {
				var currentDate_ = currentDate.a;
				return A2(
					$author$project$Navbars$Practice$Navigation$startAndEndDateParams,
					$author$project$Utils$Date$toBeginningOfMonth(currentDate_),
					$author$project$Utils$Date$toEndOfMonth(currentDate_));
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__subnav__content')
				]),
			$elm$core$List$concat(
				_List_fromArray(
					[
						_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class(
									A2(
										$author$project$Navbars$Practice$selectedNavClass,
										$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard),
										selectedNav))
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Reports__Dashboard,
									_List_fromArray(
										[
											$author$project$Ui$Link$routeParams(trailing12MonthsParams),
											$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
											$author$project$Ui$Link$test('reports-dashboard')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Dashboard')
										]))
								])),
							A2(
							ifViewable,
							15,
							A2(
								ifViewable,
								6,
								A2(
									ifViewable,
									9,
									A2(
										ifViewable,
										8,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class(
													A2(
														$author$project$Navbars$Practice$selectedNavClass,
														$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Months),
														selectedNav))
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Reports__Months,
													_List_fromArray(
														[
															$author$project$Ui$Link$routeParams(trailing13MonthsParams),
															$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
															$author$project$Ui$Link$test('reports-months')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Reporting Periods')
														]))
												])))))),
							A2(
							ifViewable,
							1,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										A2(
											$author$project$Navbars$Practice$selectedNavClass,
											$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SignupAttempts),
											selectedNav))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__SignupAttempts,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(currentMonthParams),
												$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
												$author$project$Ui$Link$test('reports-signup-attempts')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Signup Attempts')
											]))
									]))),
							A2(
							ifViewable,
							11,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										A2(
											$author$project$Navbars$Practice$selectedNavClass,
											$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Memberships),
											selectedNav))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__Memberships,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(currentMonthParams),
												$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
												$author$project$Ui$Link$test('reports-memberships')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Memberships')
											]))
									]))),
							A2(
							ifViewable,
							12,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										A2(
											$author$project$Navbars$Practice$selectedNavClass,
											$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Invoices),
											selectedNav))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__Invoices,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(currentMonthParams),
												$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
												$author$project$Ui$Link$test('reports-invoices')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Patient Invoices')
											]))
									]))),
							A2(
							$author$project$Navbars$Utils$ifConfiguration,
							practiceConfiguration.F3,
							A2(
								ifViewable,
								3,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											A2(
												$author$project$Navbars$Practice$selectedNavClass,
												$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CompanyInvoices),
												selectedNav))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__CompanyInvoices,
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(currentMonthParams),
													$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
													$author$project$Ui$Link$test('reports-company-invoices')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													A2($author$project$Formatters$String$sponsorize, practice, 'Employer Invoices'))
												]))
										])))),
							A2(
							ifViewable,
							15,
							A2(
								$author$project$Navbars$Utils$ifConfiguration,
								practiceConfiguration.Al,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											A2(
												$author$project$Navbars$Practice$selectedNavClass,
												$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditOutstanding),
												selectedNav))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(currentMonthParams),
													$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
													$author$project$Ui$Link$test('reports-credit-outstanding')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Credit Outstanding')
												]))
										])))),
							A2(
							ifViewable,
							6,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										A2(
											$author$project$Navbars$Practice$selectedNavClass,
											$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Revenue),
											selectedNav))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__Revenue,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(currentMonthParams),
												$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
												$author$project$Ui$Link$test('reports-revenue')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Billed Revenue')
											]))
									]))),
							A2(
							ifViewable,
							7,
							A2(
								$author$project$Navbars$Utils$ifConfiguration,
								A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice),
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											A2(
												$author$project$Navbars$Practice$selectedNavClass,
												$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$DeferredRevenue),
												selectedNav))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(currentMonthParams),
													$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
													$author$project$Ui$Link$test('reports-deferred-revenue')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Deferred Revenue')
												]))
										])))),
							A2(
							ifViewable,
							9,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										A2(
											$author$project$Navbars$Practice$selectedNavClass,
											$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$PaymentApplications),
											selectedNav))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__PaymentApplications,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(currentMonthParams),
												$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
												$author$project$Ui$Link$test('reports-payment-applications')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Received Payments')
											]))
									]))),
							A2(
							ifViewable,
							14,
							A2(
								$author$project$Navbars$Utils$ifConfiguration,
								practiceConfiguration.Al,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											A2(
												$author$project$Navbars$Practice$selectedNavClass,
												$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditTransactions),
												selectedNav))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__CreditTransactions,
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(currentMonthParams),
													$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
													$author$project$Ui$Link$test('reports-credit-transactions')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Credit Transactions')
												]))
										])))),
							A2(
							ifViewable,
							13,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										A2(
											$author$project$Navbars$Practice$selectedNavClass,
											$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Deposits),
											selectedNav))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__Deposits,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(currentMonthParams),
												$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
												$author$project$Ui$Link$test('reports-deposits')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Deposits')
											]))
									]))),
							A2(
							ifViewable,
							21,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										A2(
											$author$project$Navbars$Practice$selectedNavClass,
											$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Disputes),
											selectedNav))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__Disputes,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(currentMonthParams),
												$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
												$author$project$Ui$Link$test('reports-disputes')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Disputes')
											]))
									]))),
							A2(
							ifViewable,
							8,
							A2(
								$author$project$Navbars$Utils$ifConfiguration,
								practiceConfiguration.FJ,
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											A2(
												$author$project$Navbars$Practice$selectedNavClass,
												$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SalesTax),
												selectedNav))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Reports__SalesTax,
											_List_fromArray(
												[
													$author$project$Ui$Link$routeParams(currentMonthParams),
													$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
													$author$project$Ui$Link$test('reports-sales-tax')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sales Tax')
												]))
										])))),
							A2(
							$author$project$Navbars$Utils$ifConfiguration,
							practiceConfiguration.RV,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class(
										A2(
											$author$project$Navbars$Practice$selectedNavClass,
											$author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$AncillaryCharges),
											selectedNav))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top,
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(currentMonthParams),
												$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
												$author$project$Ui$Link$test('reports-ancillary-charges')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Affiliate Ancillary Charges')
											]))
									])))
						]),
						A2($author$project$Navbars$Practice$viewEmbeddedReports, selectedNav, embeddedReports)
					])));
	});
var $author$project$Navbars$Practice$viewDesktopNavElements = F4(
	function (_v0, hinterViewOff, sidenavExpanded, items) {
		var selectedNav = _v0.eE;
		var currentDate = _v0.cO;
		var embeddedReports = _v0.qq;
		var reports = _v0.sn;
		var reportMenu = _v0.jP;
		var adminMenu = _v0.hr;
		var openSubNav = _v0.c1;
		var practice = _v0.WF;
		var practiceConfiguration = _v0.nA;
		var sessionConfiguration = _v0.Cb;
		var partnerApps = _v0.rP;
		var tooltipOptions = _List_fromArray(
			[
				$author$project$Ui$Tooltip$placement(3),
				$author$project$Ui$Tooltip$stackingOrder1030
			]);
		var reportsTrigger = sidenavExpanded ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Reports'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$test('reports')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$SvgIcon$view,
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$class('sidenav__icon')
						]),
					9),
					$elm$html$Html$text('Reports'),
					A2(
					$author$project$Ui$SvgIcon$view,
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$class('sidenav__expand-chevron ml-auto')
						]),
					12)
				])) : A3(
			$author$project$Ui$Tooltip$view,
			tooltipOptions,
			'Reports',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Reports'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$test('reports')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('sidenav__icon')
								]),
							9)
						]))
				]));
		var reportsItem = A2(
			$author$project$Navbars$Utils$ifConfiguration,
			sessionConfiguration.vS(hinterViewOff),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav__item', true),
								_Utils_Tuple2(
								'sidenav__active',
								(!openSubNav) || (!$author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav)))
							]))
					]),
				$elm$core$List$singleton(
					A4(
						$author$project$Ui$FlyoutMenu$view,
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$position(0)
							]),
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$header(
								_List_fromArray(
									[
										$author$project$Ui$FlyoutMenu$title('Reports')
									])),
								$author$project$Ui$FlyoutMenu$body(
								_List_fromArray(
									[
										A6($author$project$Navbars$Practice$viewReportSubNav, selectedNav, currentDate, practice, practiceConfiguration, embeddedReports, reports)
									]))
							]),
						reportsTrigger,
						reportMenu))));
		var itemStyle = sidenavExpanded ? $author$project$Navbars$Practice$DesktopExpandedStyle : $author$project$Navbars$Practice$DesktopStyle(tooltipOptions);
		var partnerAppItems = A2(
			$elm$core$List$map,
			A2($author$project$Navbars$Practice$viewPartnerNavItem, itemStyle, selectedNav),
			A2(
				$elm$core$List$filter,
				$author$project$Api$Common$PartnerApp$All$embedsCorePage,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(partnerApps))));
		var baseItems = A2(
			$elm$core$List$map,
			A3($author$project$Navbars$Practice$viewMainNavItem, itemStyle, selectedNav, currentDate),
			items);
		var adminTrigger = sidenavExpanded ? A3(
			$author$project$Ui$Button$view,
			{abp: 'Admin'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$test('admin')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$SvgIcon$view,
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$class('sidenav__icon')
						]),
					4),
					$elm$html$Html$text('Admin'),
					A2(
					$author$project$Ui$SvgIcon$view,
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$class('sidenav__expand-chevron ml-auto')
						]),
					12)
				])) : A3(
			$author$project$Ui$Tooltip$view,
			tooltipOptions,
			'Admin',
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Admin'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$test('admin')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('sidenav__icon')
								]),
							4)
						]))
				]));
		var adminItem = A2(
			$author$project$Navbars$Utils$ifConfiguration,
			sessionConfiguration.Ep(hinterViewOff),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('sidenav__item', true),
								_Utils_Tuple2(
								'sidenav__active',
								(openSubNav === 1) || ($author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav) === 1))
							]))
					]),
				$elm$core$List$singleton(
					A4(
						$author$project$Ui$FlyoutMenu$view,
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$position(0)
							]),
						_List_fromArray(
							[
								$author$project$Ui$FlyoutMenu$header(
								_List_fromArray(
									[
										$author$project$Ui$FlyoutMenu$title('Admin')
									])),
								$author$project$Ui$FlyoutMenu$body(
								_List_fromArray(
									[
										A4(
										$author$project$Navbars$Practice$viewAdminSubNav,
										selectedNav,
										practice,
										practiceConfiguration,
										sessionConfiguration.Cd.ym(hinterViewOff))
									]))
							]),
						adminTrigger,
						adminMenu))));
		return _Utils_ap(
			baseItems,
			A2(
				$elm$core$List$cons,
				reportsItem,
				_Utils_ap(
					partnerAppItems,
					_List_fromArray(
						[adminItem]))));
	});
var $author$project$Navbars$Practice$CopyOrganizationId = function (a) {
	return {$: 21, a: a};
};
var $author$project$Navbars$Practice$CopyPracticeId = function (a) {
	return {$: 20, a: a};
};
var $author$project$Navbars$Practice$viewHinterIdButtons = F2(
	function (model, hinterViewOff) {
		return A2($author$project$Utils$User$isViewingAsHinter, model.ZD, hinterViewOff) ? A2(
			$author$project$Ui$Element$view,
			_List_fromArray(
				[$author$project$Ui$Element$flex, $author$project$Ui$Element$justifyCenter, $author$project$Ui$Element$gap]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Copy practice identifier'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Navbars$Practice$CopyPracticeId(
								$author$project$Api$Provider$Practice$One$id(model.WF)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text('PID')
								]))
						])),
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
					_List_fromArray(
						[
							$elm$html$Html$text('|')
						])),
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Copy organization identifier'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Navbars$Practice$CopyOrganizationId(
								$author$project$Api$Provider$Practice$One$organizationId(model.WF)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Typography$span,
							_List_fromArray(
								[$author$project$Ui$Typography$small, $author$project$Ui$Typography$muted]),
							_List_fromArray(
								[
									$elm$html$Html$text('OID')
								]))
						]))
				])) : $author$project$Utils$Html$empty;
	});
var $author$project$Navbars$Practice$MobileStyle = {$: 0};
var $author$project$Navbars$Practice$viewMobileNavElements = F3(
	function (_v0, hinterViewOff, items) {
		var selectedNav = _v0.eE;
		var openSubNav = _v0.c1;
		var currentDate = _v0.cO;
		var embeddedReports = _v0.qq;
		var partnerApps = _v0.rP;
		var practice = _v0.WF;
		var practiceConfiguration = _v0.nA;
		var sessionConfiguration = _v0.Cb;
		var reports = _v0.sn;
		var reportsItem = A2(
			$author$project$Navbars$Utils$ifConfiguration,
			sessionConfiguration.vS(hinterViewOff),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Practice$subNavClasses, 0, openSubNav))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Show reports menu'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Navbars$Practice$NavClicked(0)),
								$author$project$Ui$Button$test('reports')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$SvgIcon$view,
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$class('sidenav__icon')
									]),
								9),
								$elm$html$Html$text('Reports'),
								A2(
								$author$project$Ui$SvgIcon$view,
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$class('sidenav__icon--show-more ml-2')
									]),
								12)
							])),
						A6($author$project$Navbars$Practice$viewReportSubNav, selectedNav, currentDate, practice, practiceConfiguration, embeddedReports, reports)
					])));
		var partnerAppItems = A2(
			$elm$core$List$map,
			A2($author$project$Navbars$Practice$viewPartnerNavItem, $author$project$Navbars$Practice$MobileStyle, selectedNav),
			A2(
				$elm$core$List$filter,
				$author$project$Api$Common$PartnerApp$All$embedsCorePage,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$author$project$Api$Data$toMaybe(partnerApps))));
		var baseItems = A2(
			$elm$core$List$map,
			A3($author$project$Navbars$Practice$viewMainNavItem, $author$project$Navbars$Practice$MobileStyle, selectedNav, currentDate),
			items);
		var adminItem = A2(
			$author$project$Navbars$Utils$ifConfiguration,
			sessionConfiguration.Ep(hinterViewOff),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Practice$subNavClasses, 1, openSubNav))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Show admin menu'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick(
								$author$project$Navbars$Practice$NavClicked(1)),
								$author$project$Ui$Button$test('admin')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$SvgIcon$view,
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$class('sidenav__icon')
									]),
								4),
								$elm$html$Html$text('Admin'),
								A2(
								$author$project$Ui$SvgIcon$view,
								_List_fromArray(
									[
										$author$project$Ui$SvgIcon$class('sidenav__icon--show-more ml-2')
									]),
								12)
							])),
						A4(
						$author$project$Navbars$Practice$viewAdminSubNav,
						selectedNav,
						practice,
						practiceConfiguration,
						sessionConfiguration.Cd.ym(hinterViewOff))
					])));
		return _Utils_ap(
			baseItems,
			A2(
				$elm$core$List$cons,
				reportsItem,
				_Utils_ap(
					partnerAppItems,
					_List_fromArray(
						[adminItem]))));
	});
var $author$project$Navbars$Practice$LogoutClicked = {$: 6};
var $author$project$Navbars$Practice$viewProfileSubNav = function (selectedNav) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__subnav__content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(
						A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Account, selectedNav)),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'bg-primary-100',
								_Utils_eq(selectedNav, $author$project$Navbars$Practice$Navigation$Account))
							]))
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$User__Profile,
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test('account-profile')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Button$view,
						{abp: 'Logout'},
						_List_fromArray(
							[
								$author$project$Ui$Button$link,
								$author$project$Ui$Button$onClick($author$project$Navbars$Practice$LogoutClicked),
								$author$project$Ui$Button$test('account-logout')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Ui$Image$HelpCircle = 13;
var $author$project$Navbars$Practice$ShowSupportChat = {$: 15};
var $author$project$Navbars$Practice$viewResourcesSubNav = function (imageStore) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('sidenav__subnav__content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'#',
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$ShowSupportChat),
								$author$project$Ui$Link$test('help-support-chat')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Help & Support '),
								A4(
								$author$project$Ui$Image$view,
								imageStore,
								{I1: 'Help and support icon'},
								_List_fromArray(
									[
										$author$project$Ui$Image$height(20)
									]),
								13)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://support.hint.com/',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-support-articles')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Support Articles')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://community.hint.com/c/hint-updates/',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-product-updates')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Product Updates')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$route,
						$author$project$Spa$Generated$Route$Support__CannySso,
						_List_fromArray(
							[
								$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
								$author$project$Ui$Link$test('help-feature-requests')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Feature Requests')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://community.hint.com/oauth2/initiate',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-community')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Community')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://www.hint.com/ecosystem',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-partner-ecosystem')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Partner Ecosystem')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('sidenav__item')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Ui$Link$externalHref,
						'https://www.hint.com/blog',
						_List_fromArray(
							[
								$author$project$Ui$Link$targetBlank,
								$author$project$Ui$Link$test('help-blog')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Blog')
							]))
					]))
			]));
};
var $author$project$Navbars$Practice$viewSearchKeyboardShortcut = function (maybeOsName) {
	if (!maybeOsName.$) {
		var osName = maybeOsName.a;
		return ((osName === 'Mac') || ((osName === 'iOS') || (osName === 'iPadOS'))) ? '⌘ K' : 'Ctrl+K';
	} else {
		return '';
	}
};
var $author$project$Ui$SvgIcon$Fill = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$SvgIcon$fill = $author$project$Ui$SvgIcon$Fill;
var $author$project$Ui$Margin$Left_30 = 13;
var $author$project$Navbars$Practice$emrDashboardUrl = F3(
	function (practice, origin, emrHost) {
		var isUnifiedExperience = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice);
		return A3($author$project$Utils$Clinical$getDashboardUrl, isUnifiedExperience, origin, emrHost);
	});
var $author$project$Ui$Popover$Margin = function (a) {
	return {$: 5, a: a};
};
var $author$project$Ui$Popover$margin = $author$project$Ui$Popover$Margin;
var $author$project$Navbars$Practice$LogoClicked = {$: 16};
var $author$project$Navbars$Practice$viewAppLogo = F4(
	function (whitelabelSetting, practiceName, maybeListOptions, isHintAdmin) {
		var createStaticElement = function (content) {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$inlineBlock]),
				_List_fromArray(
					[content]));
		};
		var createHinterButton = function (content) {
			return A3(
				$author$project$Ui$Button$view,
				{abp: 'Show hinter practice settings'},
				_List_fromArray(
					[
						$author$project$Ui$Button$link,
						$author$project$Ui$Button$onClick($author$project$Navbars$Practice$LogoClicked)
					]),
				_List_fromArray(
					[content]));
		};
		var renderContent = F2(
			function (content, hasValidUrl) {
				if (isHintAdmin) {
					return createHinterButton(
						A2($elm$html$Html$map, $elm$core$Basics$never, content));
				} else {
					if (hasValidUrl) {
						if (!maybeListOptions.$) {
							var listOptions = maybeListOptions.a;
							return A3(
								$author$project$Ui$Link$externalHref,
								'/',
								listOptions,
								_List_fromArray(
									[content]));
						} else {
							return A2($elm$html$Html$map, $elm$core$Basics$never, content);
						}
					} else {
						return createStaticElement(
							A2($elm$html$Html$map, $elm$core$Basics$never, content));
					}
				}
			});
		var _v0 = _Utils_Tuple2(
			$author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting),
			$author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
		var altText = _v0.a;
		var maybeLogoUrl = _v0.b;
		var logoElementNever = function (logoUrl) {
			return A2(
				$elm$html$Html$map,
				$elm$core$Basics$never,
				A3(
					$author$project$Ui$Image$fromSrc,
					{I1: altText},
					logoUrl,
					_List_fromArray(
						[
							$author$project$Ui$Image$height(40)
						])));
		};
		if (!maybeLogoUrl.$) {
			var logoUrl = maybeLogoUrl.a;
			return A2(
				renderContent,
				logoElementNever(logoUrl),
				true);
		} else {
			return A2(
				renderContent,
				A2(
					$elm$html$Html$map,
					$elm$core$Basics$never,
					$elm$html$Html$text(practiceName)),
				false);
		}
	});
var $author$project$Navbars$Practice$viewAppLogoForDropdown = F2(
	function (whitelabelSetting, practiceName) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting),
			$author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
		var altText = _v0.a;
		var maybeLogoUrl = _v0.b;
		if (!maybeLogoUrl.$) {
			var logoUrl = maybeLogoUrl.a;
			return A3(
				$author$project$Ui$Image$fromSrc,
				{I1: altText},
				logoUrl,
				_List_fromArray(
					[
						$author$project$Ui$Image$height(40)
					]));
		} else {
			return A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$inlineBlock]),
				_List_fromArray(
					[
						$elm$html$Html$text(practiceName)
					]));
		}
	});
var $author$project$Navbars$Practice$viewLogo = F4(
	function (_v0, dropdownMenu, sessionConfiguration, hinterViewOff) {
		var whitelabelSetting = _v0.aa1;
		var practice = _v0.WF;
		var origin = _v0.afw;
		var emrHost = _v0.acZ;
		var showSwitchProduct = _v0.Hb;
		var unifiedExperienceEnabled = _v0.oV;
		var backupAuthEnabled = _v0.abt;
		var isHintAdmin = _v0.FR;
		if (showSwitchProduct && (!unifiedExperienceEnabled)) {
			var appSwitcher = function (appList) {
				return isHintAdmin ? A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$spaceX2]),
					_List_fromArray(
						[
							A4(
							$author$project$Navbars$Practice$viewAppLogo,
							whitelabelSetting,
							$author$project$Api$Provider$Practice$One$name(practice),
							$elm$core$Maybe$Nothing,
							isHintAdmin),
							A4(
							$author$project$Ui$NewDropdown$view,
							_List_fromArray(
								[
									$author$project$Ui$NewDropdown$disabled(backupAuthEnabled),
									$author$project$Ui$NewDropdown$buttonLink
								]),
							_List_Nil,
							appList,
							dropdownMenu)
						])) : A4(
					$author$project$Ui$NewDropdown$view,
					_List_fromArray(
						[
							$author$project$Ui$NewDropdown$disabled(backupAuthEnabled),
							$author$project$Ui$NewDropdown$buttonLink
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							$elm$core$Basics$never,
							A2(
								$author$project$Navbars$Practice$viewAppLogoForDropdown,
								whitelabelSetting,
								$author$project$Api$Provider$Practice$One$name(practice)))
						]),
					appList,
					dropdownMenu);
			};
			return backupAuthEnabled ? A3(
				$author$project$Ui$Popover$view,
				_List_fromArray(
					[
						$author$project$Ui$Popover$sm,
						$author$project$Ui$Popover$margin(18),
						$author$project$Ui$Popover$margin(13)
					]),
				_List_fromArray(
					[
						appSwitcher(_List_Nil)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Popover$body,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Clinical app is temporarily unavailable due to the sign-in system outage.')
							]))
					])) : appSwitcher(
				_List_fromArray(
					[
						A3(
						$author$project$Ui$NewDropdown$link,
						A3($author$project$Navbars$Practice$emrDashboardUrl, practice, origin, emrHost),
						_List_Nil,
						$elm$html$Html$text('Clinical'))
					]));
		} else {
			var listOptions = _List_fromArray(
				[
					$author$project$Ui$Link$disabled(
					sessionConfiguration.WI && (!sessionConfiguration.Cd.ym(hinterViewOff)))
				]);
			return A4(
				$author$project$Navbars$Practice$viewAppLogo,
				whitelabelSetting,
				$author$project$Api$Provider$Practice$One$name(practice),
				$elm$core$Maybe$Just(listOptions),
				isHintAdmin);
		}
	});
var $author$project$Navbars$Practice$viewTopNavbar = F4(
	function (hinterViewOff, model, jointProductEnabled, maybeOrgSwitcher) {
		var sessionConfiguration = model.Cb;
		var isHintAdmin = A2($author$project$Utils$User$isViewingAsHinter, model.ZD, hinterViewOff);
		var logoConfig = {abt: model.abt, acZ: model.acZ, FR: isHintAdmin, afw: model.afw, WF: model.WF, Hb: jointProductEnabled, oV: model.nA.oV, aa1: model.aa1};
		var logo = A4($author$project$Navbars$Practice$viewLogo, logoConfig, model.oF, sessionConfiguration, hinterViewOff);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('elm-mobile-nav')
						]),
					$elm$core$List$concat(
						_List_fromArray(
							[
								_List_fromArray(
								[logo]),
								model.ow ? _List_Nil : _List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav-open')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Display side navigation menu'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Practice$SidenavToggled(true))
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$SvgIcon$view, _List_Nil, 28)
												]))
										]))
								])
							]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('topnav')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__left')
								]),
							_List_fromArray(
								[
									logo,
									A2(
									$elm$core$Maybe$withDefault,
									A2(
										$author$project$Navbars$Utils$viewSwitchOrganizationLink,
										$author$project$Api$Provider$Practice$One$name(model.WF),
										sessionConfiguration.Cd.KE),
									maybeOrgSwitcher)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('topnav__right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('topnav__search')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Navbars$Utils$ifConfiguration,
											sessionConfiguration.vT(hinterViewOff),
											A3(
												$author$project$Ui$Button$view,
												{abp: 'Search'},
												_List_fromArray(
													[
														$author$project$Ui$Button$onClick($author$project$Navbars$Practice$SearchClicked)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('topnav__search-content')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_Nil,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$SvgIcon$view,
																		_List_fromArray(
																			[
																				$author$project$Ui$SvgIcon$fill('currentColor'),
																				$author$project$Ui$SvgIcon$height('0.9rem')
																			]),
																		40),
																		$author$project$Utils$Html$noBreakSpace,
																		$author$project$Utils$Html$noBreakSpace,
																		$elm$html$Html$text('Search')
																	])),
																A2(
																$elm$html$Html$div,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Navbars$Practice$viewSearchKeyboardShortcut(sessionConfiguration.Cd.Vj))
																	]))
															]))
													])))
										])),
									A2(
									$author$project$Navbars$Utils$ifConfiguration,
									sessionConfiguration.Cd.ym(hinterViewOff) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 25, model.WF),
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('topnav__item')
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Marketplace__Top,
												_List_fromArray(
													[
														$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
														$author$project$Ui$Link$test('marketplace'),
														$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$marketplace)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Marketplace')
													]))
											]))),
									(sessionConfiguration.WI && (!sessionConfiguration.Cd.ym(hinterViewOff))) ? $author$project$Utils$Html$empty : A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('topnav__item topnav__subnav'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('topnav__subnav--open', 2 === model.c1)
												]))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'view help resources'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Practice$NavClicked(2)),
													$author$project$Ui$Button$icon($author$project$Ui$SvgIcon$book),
													$author$project$Ui$Button$test('help')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Resources'),
													A2(
													$author$project$Ui$SvgIcon$view,
													_List_fromArray(
														[
															$author$project$Ui$SvgIcon$class('topnav__icon--show-more')
														]),
													12)
												])),
											$author$project$Navbars$Practice$viewResourcesSubNav(model.qT)
										]))
								]))
						]))
				]));
	});
var $author$project$Navbars$Practice$view = F3(
	function (hinterViewOff, maybeOrgSwitcherConfig, _v0) {
		var model = _v0;
		var sessionConfiguration = model.Cb;
		var slideIn = model.ow;
		var sidenavExpanded = model.sS;
		var profileMobileView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(
					A2($author$project$Navbars$Practice$subNavClasses, 3, model.c1) + ' sidenav__item--profile-mobile')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Button$view,
					{abp: 'Profile'},
					_List_fromArray(
						[
							$author$project$Ui$Button$link,
							$author$project$Ui$Button$onClick(
							$author$project$Navbars$Practice$NavClicked(3)),
							$author$project$Ui$Button$test('account-profile-mobile')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('sidenav__icon')
								]),
							3),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__profile-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sessionConfiguration.Cd.ahN)
								])),
							A2(
							$author$project$Ui$SvgIcon$view,
							_List_fromArray(
								[
									$author$project$Ui$SvgIcon$class('sidenav__icon--show-more ml-2')
								]),
							12)
						])),
					$author$project$Navbars$Practice$viewProfileSubNav(model.eE)
				]));
		var profileButton = A3(
			$author$project$Ui$Button$view,
			{abp: 'Profile'},
			_List_fromArray(
				[
					$author$project$Ui$Button$link,
					$author$project$Ui$Button$test('account-profile')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$SvgIcon$view,
					_List_fromArray(
						[
							$author$project$Ui$SvgIcon$class('sidenav__icon')
						]),
					3),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('sidenav__profile-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Profile')
						]))
				]));
		var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Practice$OrgSwitcherMsg, maybeOrgSwitcherConfig);
		var mainItems = A4($author$project$Navbars$Practice$Navigation$mainNavItems, model.WF, model.nA, model.Cb, hinterViewOff);
		var navElementsMobile = A3($author$project$Navbars$Practice$viewMobileNavElements, model, hinterViewOff, mainItems);
		var jointProduct = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.WF);
		var canExpandNav = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, model.WF);
		var isExpanded = sidenavExpanded && canExpandNav;
		var navElementsDesktop = A4($author$project$Navbars$Practice$viewDesktopNavElements, model, hinterViewOff, isExpanded, mainItems);
		var profileMenuView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'sidenav__active',
							_Utils_eq(model.eE, $author$project$Navbars$Practice$Navigation$Account))
						]))
				]),
			$elm$core$List$singleton(
				A4(
					$author$project$Ui$FlyoutMenu$view,
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$position(1)
						]),
					_List_fromArray(
						[
							$author$project$Ui$FlyoutMenu$body(
							_List_fromArray(
								[
									$author$project$Navbars$Practice$viewProfileSubNav(model.eE)
								]))
						]),
					isExpanded ? profileButton : A3(
						$author$project$Ui$Tooltip$view,
						_List_fromArray(
							[
								$author$project$Ui$Tooltip$placement(3),
								$author$project$Ui$Tooltip$stackingOrder1030
							]),
						'Profile',
						_List_fromArray(
							[profileButton])),
					model.ep)));
		return _List_fromArray(
			[
				A4($author$project$Navbars$Practice$viewTopNavbar, hinterViewOff, model, jointProduct, orgSwitcherHtml),
				$author$project$Navbars$Utils$viewTopNavEnd,
				A2(
				$elm$html$Html$map,
				$author$project$Navbars$Practice$HinterPracticeSettingsModalMsg,
				$author$project$Components$HinterPracticeSettingsModal$view(model.iO)),
				A2(
				$author$project$Navbars$Utils$ifConfiguration,
				sessionConfiguration.Cd.ZY(hinterViewOff),
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('sidenav'),
							$elm$html$Html$Attributes$class('sidenav'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('sidenav--slide-in', slideIn),
									_Utils_Tuple2('sidenav--expanded', isExpanded)
								]))
						]),
					_List_fromArray(
						[
							canExpandNav ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__expand-toggle')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Button$view,
									{
										abp: isExpanded ? 'Collapse navigation' : 'Expand navigation'
									},
									_List_fromArray(
										[
											$author$project$Ui$Button$link,
											$author$project$Ui$Button$onClick($author$project$Navbars$Practice$SidenavExpandToggled),
											$author$project$Ui$Button$test('sidenav-expand-toggle')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$SvgIcon$view,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$class(
													isExpanded ? 'sidenav__toggle-icon sidenav__toggle-icon--expanded' : 'sidenav__toggle-icon')
												]),
											12)
										]))
								])) : $elm$html$Html$text(''),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__header sidenav__header--practice')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav__header--left')
										]),
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$location(_List_Nil),
											$elm$html$Html$text(
											$author$project$Api$Provider$Practice$One$name(model.WF)),
											A2(
											$author$project$Navbars$Utils$ifConfiguration,
											sessionConfiguration.Cd.KE,
											A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$User__Organizations__Top,
												_List_fromArray(
													[
														$author$project$Ui$Link$ariaLabel('Switch organization'),
														$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked)
													]),
												_List_fromArray(
													[
														$author$project$Ui$SvgIcon$kebabMenu(_List_Nil)
													])))
										])),
									slideIn ? A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav-close')
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'Close side navigation menu'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Practice$SidenavToggled(false))
												]),
											_List_fromArray(
												[
													A2($author$project$Ui$SvgIcon$view, _List_Nil, 29)
												]))
										])) : $author$project$Utils$Html$empty
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__search')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Navbars$Utils$ifConfiguration,
									sessionConfiguration.vT(hinterViewOff),
									A3(
										$author$project$Ui$Button$view,
										{abp: 'Search'},
										_List_fromArray(
											[
												$author$project$Ui$Button$onClick($author$project$Navbars$Practice$SearchClicked)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('sidenav__search-content')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$author$project$Ui$SvgIcon$search(_List_Nil),
																$author$project$Utils$Html$noBreakSpace,
																$elm$html$Html$text('Search')
															])),
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																$author$project$Navbars$Practice$viewSearchKeyboardShortcut(sessionConfiguration.Cd.Vj))
															]))
													]))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
								]),
							navElementsMobile),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
								]),
							navElementsDesktop),
							A2($author$project$Navbars$Practice$viewHinterIdButtons, model, hinterViewOff),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sidenav__bottom')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('sidenav__bottom-separator')
										]),
									_List_Nil),
									A2(
									$author$project$Navbars$Utils$ifConfiguration,
									sessionConfiguration.Cd.ym(hinterViewOff) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 25, model.WF),
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class(
												A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Marketplace, model.eE)),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'bg-primary-100',
														_Utils_eq(model.eE, $author$project$Navbars$Practice$Navigation$Marketplace))
													]))
											]),
										_List_fromArray(
											[
												A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Marketplace__Top,
												_List_fromArray(
													[
														$author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
														$author$project$Ui$Link$test('marketplace')
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$SvgIcon$view,
														_List_fromArray(
															[
																$author$project$Ui$SvgIcon$class('sidenav__icon')
															]),
														87),
														$elm$html$Html$text('Marketplace')
													]))
											]))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class(
											A2($author$project$Navbars$Practice$subNavClasses, 2, model.c1))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Button$view,
											{abp: 'View help resources'},
											_List_fromArray(
												[
													$author$project$Ui$Button$link,
													$author$project$Ui$Button$onClick(
													$author$project$Navbars$Practice$NavClicked(2)),
													$author$project$Ui$Button$test('help')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$SvgIcon$view,
													_List_fromArray(
														[
															$author$project$Ui$SvgIcon$class('sidenav__icon sidenav__icon--sm')
														]),
													88),
													$elm$html$Html$text('Resources'),
													A2(
													$author$project$Ui$SvgIcon$view,
													_List_fromArray(
														[
															$author$project$Ui$SvgIcon$class('sidenav__icon--show-more ml-2')
														]),
													12)
												])),
											$author$project$Navbars$Practice$viewResourcesSubNav(model.qT)
										])),
									profileMobileView,
									profileMenuView
								]))
						])))
			]);
	});
var $author$project$Navbar$viewNavbar = F2(
	function (orgSwitcherConfig, _v0) {
		var model = _v0;
		var _v1 = model.ac;
		switch (_v1.$) {
			case 0:
				return _List_Nil;
			case 1:
				var practiceNavModel = _v1.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Navbar$PracticeNavbarMsg),
					A3($author$project$Navbars$Practice$view, model.adN, orgSwitcherConfig, practiceNavModel));
			case 2:
				var companyNavModel = _v1.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Navbar$CompanyNavbarMsg),
					A3($author$project$Navbars$Company$view, model.adN, orgSwitcherConfig, companyNavModel));
			default:
				var partnerNavModel = _v1.a;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$map($author$project$Navbar$PartnerNavbarMsg),
					A3($author$project$Navbars$Partner$view, model.adN, orgSwitcherConfig, partnerNavModel));
		}
	});
var $author$project$Navbar$view = F2(
	function (shared, _v0) {
		var model = _v0;
		var practice = model.WF;
		var session = model.ZD;
		if (shared.acW) {
			return $elm$html$Html$text('');
		} else {
			var orgSwitcherConfig = A3(
				$elm$core$Maybe$map2,
				F2(
					function (switcher, org) {
						return {y8: switcher, Vd: org};
					}),
				shared.afs,
				shared.Vd);
			return A2(
				$elm$html$Html$nav,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('navbar-wrapper'),
						$elm$html$Html$Attributes$class('navbar-wrapper')
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								$author$project$Components$DebugInfo$view(
								{abm: shared.abm, acv: shared.acv, acW: shared.acW, adM: shared.adM, aeR: shared.aeR, ZD: session}),
								A2(
								$elm$html$Html$map,
								$author$project$Navbar$SandboxAlertMsg,
								$author$project$Components$SandboxAlert$view(session))
							]),
							A4($author$project$Navbar$viewAlerts, session, model.adN, practice, shared.abt),
							A2($author$project$Navbar$viewNavbar, orgSwitcherConfig, model)
						])));
		}
	});
var $author$project$Ui$Toast$ToastBlurred = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Toast$ToastClicked = function (a) {
	return {$: 0, a: a};
};
var $author$project$Ui$Toast$ToastHovered = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Toast$levelClass = function (level) {
	switch (level) {
		case 0:
			return $elm$html$Html$Attributes$class('toast--info');
		case 1:
			return $elm$html$Html$Attributes$class('toast--danger');
		case 2:
			return $elm$html$Html$Attributes$class('toast--warning');
		default:
			return $elm$html$Html$Attributes$class('toast--success');
	}
};
var $elm$html$Html$Events$onMouseOut = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseout',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Ui$Toast$viewToast = function (_v0) {
	var id = _v0.adR;
	var level = _v0.SL;
	var message = _v0.aeD;
	return _Utils_Tuple2(
		$elm$core$String$fromInt(id),
		A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Ui$Toast$ToastClicked(id)),
					$elm$html$Html$Events$onMouseEnter(
					$author$project$Ui$Toast$ToastHovered(id)),
					$elm$html$Html$Events$onMouseOut(
					$author$project$Ui$Toast$ToastBlurred(id)),
					$elm$html$Html$Attributes$class('toast'),
					$author$project$Ui$Toast$levelClass(level)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$span,
					_List_fromArray(
						[
							$author$project$Ui$Typography$phi(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				])));
};
var $author$project$Ui$Toast$view = function (_v0) {
	var toasts = _v0.b;
	return $elm$core$List$isEmpty(toasts) ? $elm$html$Html$text('') : A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('toast-container')
			]),
		A2($elm$core$List$map, $author$project$Ui$Toast$viewToast, toasts));
};
var $author$project$Shared$view = F2(
	function (_v0, model) {
		var layout = _v0.a6;
		var page = _v0.Gy;
		var toMsg = _v0.ahx;
		var isClinicalPage = _v0.aec;
		var user = $author$project$Api$Data$toMaybe(model.aaz);
		var showSideNav = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Navbar$showSideNav(model.adN),
				model.ad));
		return {
			e5: _List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					toMsg,
					A2(
						$elm$html$Html$map,
						$author$project$Shared$ToastMsg,
						$author$project$Ui$Toast$view(model.kv))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('ng-app'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('embedded', model.adu.acW)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('horizontal-wrapper'),
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'login',
											_Utils_eq(user, $elm$core$Maybe$Nothing))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('vertical-wrapper'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('with-full-navigation', showSideNav)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$id('spa-document'),
													$elm$html$Html$Attributes$class('flex'),
													$elm$html$Html$Attributes$class('flex-col'),
													$elm$html$Html$Attributes$class('h-full')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('container content'),
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('clinical-page', isClinicalPage)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$core$Maybe$withDefault,
															$author$project$Utils$Html$empty,
															A2(
																$elm$core$Maybe$map,
																A2(
																	$elm$core$Basics$composeR,
																	$author$project$Navbar$view(
																		{
																			abm: model.adu.abm,
																			abt: model.adu.abt,
																			acv: model.adu.acv,
																			acW: model.adu.acW,
																			adM: $author$project$Utils$Environment$toString(model.adM),
																			aeR: $author$project$Utils$Environment$toString(model.aeR),
																			afs: model.ga,
																			Vd: $author$project$Shared$organizationFromSession(model)
																		}),
																	$elm$html$Html$map(
																		A2($elm$core$Basics$composeR, $author$project$Shared$NavbarMsg, toMsg))),
																model.ad)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$id('elm-app'),
																	$elm$html$Html$Attributes$classList(
																	_List_fromArray(
																		[
																			_Utils_Tuple2('highlight-phi', model.mq)
																		]))
																]),
															A2(
																layout,
																A2($elm$core$Basics$composeR, $author$project$Shared$PatientsListMsg, toMsg),
																page.e5)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$id('hint-clinical-root'),
																	$elm$html$Html$Attributes$class('clinical')
																]),
															_List_Nil)
														]))
												]))
										]))
								])),
							function () {
							var _v1 = _Utils_Tuple2(model.ZD, model.WF);
							if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
								var _v2 = _v1.a;
								var session = _v2.a;
								var _v3 = _v1.b;
								var practice = _v3.a;
								var route = $author$project$Utils$Route$fromUrl(model.aav);
								return A2(
									$elm$html$Html$map,
									toMsg,
									A2(
										$elm$html$Html$map,
										$author$project$Shared$AccountLockedModalMsg,
										A3($author$project$Components$AccountLockedModal$view, session, practice, route)));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}(),
							A2(
							$elm$html$Html$map,
							toMsg,
							function () {
								if (model.sP) {
									var customOptions = _List_fromArray(
										[
											$author$project$Components$HiConfirm$verb('resume'),
											$author$project$Components$HiConfirm$noun('session'),
											$author$project$Components$HiConfirm$customMessage(
											_List_fromArray(
												[
													$elm$html$Html$text('Simply click anywhere on the screen to continue.')
												])),
											$author$project$Components$HiConfirm$customTitle('Your Session Is About to Expire'),
											$author$project$Components$HiConfirm$showCancel(false)
										]);
									return A2(
										$author$project$Components$HiConfirm$modal,
										$elm$core$Basics$always($author$project$Shared$HideLogoutWarning),
										customOptions);
								} else {
									return $author$project$Utils$Html$empty;
								}
							}()),
							A2(
							$elm$html$Html$map,
							toMsg,
							model.sK ? $author$project$Components$Auth$SystemRecoveryModal$view($author$project$Shared$HideAuthRecoveryModal) : $author$project$Utils$Html$empty),
							A2(
							$elm$html$Html$map,
							toMsg,
							A2(
								$elm$html$Html$map,
								$author$project$Shared$GlobalSearchMsg,
								$author$project$Components$GlobalSearch$view(model.fJ))),
							function () {
							var _v4 = _Utils_Tuple2(
								model.afI,
								!_Utils_eq(model.V9, $elm$core$Maybe$Nothing));
							if ((!_v4.a.$) && _v4.b) {
								var pendingChangesDetail = _v4.a.a;
								return A2(
									$elm$html$Html$map,
									toMsg,
									A3($author$project$Components$PendingChangesModal$view, pendingChangesDetail, $author$project$Shared$PendingChangesDiscard, $author$project$Shared$PendingChangesKeep));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))
				]),
			$G: page.$G
		};
	});
var $author$project$Layouts$Admin$StructureNode = $elm$core$Basics$identity;
var $author$project$Layouts$Admin$Node = $elm$core$Basics$identity;
var $author$project$Layouts$Admin$structureOrNodeVisible = F2(
	function (practice, featureGated) {
		return A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				function (featureGated_) {
					return A2(
						$author$project$Utils$FeatureGate$gateAvailable,
						featureGated_,
						$author$project$Api$Practice$Provider(practice));
				},
				featureGated));
	});
var $author$project$Layouts$Admin$nodeVisible = F2(
	function (practice, _v0) {
		var node = _v0;
		return A2($author$project$Layouts$Admin$structureOrNodeVisible, practice, node.b);
	});
var $author$project$Layouts$Admin$routeActive = F2(
	function (currentRoute, route) {
		return _Utils_eq(route, currentRoute) || A2(
			$elm$core$String$startsWith,
			$author$project$Spa$Generated$Route$toString(route) + '/',
			$author$project$Spa$Generated$Route$toString(currentRoute));
	});
var $author$project$Layouts$Admin$nodeActive = F3(
	function (currentRoute, practice, _v0) {
		var node = _v0;
		return A2($author$project$Layouts$Admin$nodeVisible, practice, node) && A2($author$project$Layouts$Admin$routeActive, currentRoute, node.d);
	});
var $author$project$Layouts$Admin$structureVisible = F2(
	function (practice, _v0) {
		var node = _v0;
		return A2($author$project$Layouts$Admin$structureOrNodeVisible, practice, node.b);
	});
var $author$project$Layouts$Admin$getActiveStructure = F3(
	function (currentRoute, practice, nodes) {
		return A2(
			$elm_community$list_extra$List$Extra$find,
			function (_v0) {
				var node = _v0;
				var visible = A2($author$project$Layouts$Admin$structureVisible, practice, node);
				return visible && A2(
					$elm$core$List$any,
					A2($author$project$Layouts$Admin$nodeActive, currentRoute, practice),
					node.v);
			},
			nodes);
	});
var $author$project$Layouts$Admin$getAccountLayout = F2(
	function (practice, isHintAdmin) {
		return $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-general', zh: 'General', d: $author$project$Spa$Generated$Route$Admin__Practice}
					]),
					(A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice)) ? _List_Nil : (((!$author$project$Api$Provider$Practice$One$hasClinicalAccount(practice)) || isHintAdmin) ? _List_fromArray(
					[
						{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-users', zh: 'Users', d: $author$project$Spa$Generated$Route$Admin__Team}
					]) : _List_Nil),
					_List_fromArray(
					[
						{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-billing', zh: 'Billing', d: $author$project$Spa$Generated$Route$Admin__Billing},
						{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-sources', zh: 'Payment Sources', d: $author$project$Spa$Generated$Route$Admin__PaymentSources},
						{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-payment-processing', zh: 'Payment Processing', d: $author$project$Spa$Generated$Route$Admin__PaymentProcessing}
					]),
					isHintAdmin ? _List_fromArray(
					[
						{
						b: $elm$core$Maybe$Nothing,
						QG: $elm$core$Maybe$Just(
							$author$project$Ui$SvgIcon$hintHeart(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$spacedRight]))),
						adR: 'nav-item-notes',
						zh: 'Notes',
						d: $author$project$Spa$Generated$Route$Admin__Notes
					},
						{
						b: $elm$core$Maybe$Nothing,
						QG: $elm$core$Maybe$Just(
							$author$project$Ui$SvgIcon$hintHeart(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$spacedRight]))),
						adR: 'nav-item-features',
						zh: 'Beta Features',
						d: $author$project$Spa$Generated$Route$Admin__Features
					},
						{
						b: $elm$core$Maybe$Nothing,
						QG: $elm$core$Maybe$Just(
							$author$project$Ui$SvgIcon$hintHeart(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$spacedRight]))),
						adR: 'nav-item-internal-settings',
						zh: 'Internal Settings',
						d: $author$project$Spa$Generated$Route$Admin__InternalSettings
					},
						{
						b: $elm$core$Maybe$Nothing,
						QG: $elm$core$Maybe$Just(
							$author$project$Ui$SvgIcon$hintHeart(
								_List_fromArray(
									[$author$project$Ui$SvgIcon$spacedRight]))),
						adR: 'nav-item-scheduled-jobs',
						zh: 'Scheduled Jobs',
						d: $author$project$Spa$Generated$Route$Admin__ScheduledJobs
					}
					]) : _List_Nil
				]));
	});
var $author$project$Api$Provider$Practice$One$mailgunStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Practice$One$one,
	function ($) {
		return $.Tc;
	});
var $author$project$Layouts$Admin$getIntegrationsLayout = function (practice) {
	return $elm$core$List$concat(
		_List_fromArray(
			[
				$author$project$Api$Provider$Practice$One$elationEnabled(practice) ? _List_fromArray(
				[
					{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-elation-legacy', zh: 'ElationEMR (Legacy)', d: $author$project$Spa$Generated$Route$Admin__ElationLegacy}
				]) : _List_Nil,
				((($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe') || $author$project$Api$Provider$Practice$One$hasStripeAccount(practice)) && (!A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice))) ? _List_fromArray(
				[
					{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-stripe', zh: 'Stripe', d: $author$project$Spa$Generated$Route$Admin__Stripe}
				]) : _List_Nil,
				_List_fromArray(
				[
					{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-card-readers', zh: 'Card Readers', d: $author$project$Spa$Generated$Route$Admin__CardReaders},
					{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-qbo', zh: 'QuickBooks Online', d: $author$project$Spa$Generated$Route$Admin__Quickbooks__Top},
					{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-elation', zh: 'Elation Health', d: $author$project$Spa$Generated$Route$Admin__Elation__Top},
					{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-athena', zh: 'athenahealth', d: $author$project$Spa$Generated$Route$Admin__Athenahealth__Top}
				]),
				_Utils_eq(
				$author$project$Api$Provider$Practice$One$mailgunStatus(practice),
				$elm$core$Maybe$Just('active')) ? _List_fromArray(
				[
					{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-mailgun', zh: 'Mailgun', d: $author$project$Spa$Generated$Route$Admin__Mailgun}
				]) : _List_Nil,
				_List_fromArray(
				[
					{
					b: $elm$core$Maybe$Nothing,
					QG: $elm$core$Maybe$Nothing,
					adR: 'nav-item-spruce-health',
					zh: 'Spruce',
					d: $author$project$Spa$Generated$Route$Marketplace__Slug_String(
						{_c: 'spruce-health'})
				},
					{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-other-integrations', zh: 'Other Integrations', d: $author$project$Spa$Generated$Route$Marketplace__Manage}
				])
			]));
};
var $author$project$Layouts$Admin$structure = F4(
	function (session, practice, hinterViewOff, isHintAdmin) {
		return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0) ? $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						{
						v: A2($author$project$Layouts$Admin$getAccountLayout, practice, isHintAdmin),
						b: $elm$core$Maybe$Nothing,
						$G: 'Account'
					}
					]),
					(A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice)) ? _List_fromArray(
					[
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-phones', zh: 'Phones', d: $author$project$Spa$Generated$Route$NewSettings__PracticeInfo}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Phones'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-team', zh: 'Team', d: $author$project$Spa$Generated$Route$NewSettings__Team}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Team'
					}
					]) : _List_Nil,
					_List_fromArray(
					[
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-providers', zh: 'Providers', d: $author$project$Spa$Generated$Route$Admin__Providers__Top},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-patients', zh: 'Patients', d: $author$project$Spa$Generated$Route$Admin__Patients},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-locations', zh: 'Locations', d: $author$project$Spa$Generated$Route$Admin__Locations},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-location-groups', zh: 'Location Groups', d: $author$project$Spa$Generated$Route$Admin__ProviderGroups}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Providers & Patients'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-plans', zh: 'Plans', d: $author$project$Spa$Generated$Route$Admin__Plans__Top},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-coverage-plans', zh: 'Coverage Plans', d: $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-coupons', zh: 'Coupons', d: $author$project$Spa$Generated$Route$Admin__Coupons},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-cancellation-reasons', zh: 'Cancellation Reasons', d: $author$project$Spa$Generated$Route$Admin__CancellationReasons},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-invoicing', zh: 'Invoicing Ahead of Time', d: $author$project$Spa$Generated$Route$Admin__AdvanceBilling}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Membership Options'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-global', zh: 'Global Settings', d: $author$project$Spa$Generated$Route$Admin__Signup},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-signup', zh: 'Signup Pages', d: $author$project$Spa$Generated$Route$Admin__SignupPages__Top},
								{
								b: $elm$core$Maybe$Just(5),
								QG: $elm$core$Maybe$Nothing,
								adR: 'nav-item-patient-portal',
								zh: 'Patient Portal',
								d: $author$project$Spa$Generated$Route$Admin__SelfService
							},
								{
								b: $elm$core$Maybe$Just(5),
								QG: $elm$core$Maybe$Nothing,
								adR: 'nav-item-lead-sources',
								zh: 'Lead Sources',
								d: $author$project$Spa$Generated$Route$Admin__LeadSources
							}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Online Signup'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-categories', zh: 'Categories', d: $author$project$Spa$Generated$Route$Admin__CreditCategories},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-upload', zh: 'Upload', d: $author$project$Spa$Generated$Route$Admin__Credits__Upload}
							]),
						b: $elm$core$Maybe$Just(4),
						$G: 'Credits'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-charge-items', zh: 'Charge Items', d: $author$project$Spa$Generated$Route$Admin__ChargeItems__Top},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-charge-categories', zh: 'Charge Categories', d: $author$project$Spa$Generated$Route$Admin__Categories},
								{
								b: $elm$core$Maybe$Just(2),
								QG: $elm$core$Maybe$Nothing,
								adR: 'nav-item-tax',
								zh: 'Sales Tax',
								d: $author$project$Spa$Generated$Route$Admin__Taxes
							}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Charges'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-setup', zh: 'Set-Up', d: $author$project$Spa$Generated$Route$Admin__Commissions}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Commissions'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-patient', zh: 'Patient', d: $author$project$Spa$Generated$Route$Admin__Notifications__Patient},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-membership', zh: 'Membership', d: $author$project$Spa$Generated$Route$Admin__Notifications__Membership},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-practice', zh: 'Practice', d: $author$project$Spa$Generated$Route$Admin__Notifications__Practice},
								{
								b: $elm$core$Maybe$Just(9),
								QG: $elm$core$Maybe$Nothing,
								adR: 'nav-item-employer',
								zh: 'Employer',
								d: $author$project$Spa$Generated$Route$Admin__Notifications__Company
							},
								{
								b: $elm$core$Maybe$Just(9),
								QG: $elm$core$Maybe$Nothing,
								adR: 'nav-item-employee',
								zh: 'Employee',
								d: $author$project$Spa$Generated$Route$Admin__Notifications__Employee
							},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-setting', zh: 'Settings', d: $author$project$Spa$Generated$Route$Admin__Notifications__Settings}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Notifications'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-ephi', zh: 'ePHI Communication Waivers', d: $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'ePHI Communication Waivers'
					},
						{
						v: $author$project$Layouts$Admin$getIntegrationsLayout(practice),
						b: $elm$core$Maybe$Nothing,
						$G: 'Integrations'
					},
						{
						v: _List_fromArray(
							[
								{
								b: $elm$core$Maybe$Nothing,
								QG: $elm$core$Maybe$Nothing,
								adR: 'nav-item-employers-invoice-settings',
								zh: A2($author$project$Formatters$String$sponsorize, practice, 'Employers') + ' Invoice Settings',
								d: $author$project$Spa$Generated$Route$Admin__InvoiceSettings
							},
								{
								b: $elm$core$Maybe$Nothing,
								QG: $elm$core$Maybe$Nothing,
								adR: 'nav-item-empoyers-plans',
								zh: A2($author$project$Formatters$String$sponsorize, practice, 'Employers') + ' Plans',
								d: $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top
							}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: A2($author$project$Formatters$String$sponsorize, practice, 'Employers')
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-documents', zh: 'Documents', d: $author$project$Spa$Generated$Route$Admin__Documents__Top}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Documents'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-developers-api-keys', zh: 'API Keys', d: $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-developers-webhook-endpoints', zh: 'Webhook Endpoints', d: $author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-developers-sandboxes', zh: 'Sandboxes', d: $author$project$Spa$Generated$Route$Admin__Developers__Sandboxes}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Developers'
					},
						{
						v: _List_fromArray(
							[
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-data-export', zh: 'Exports', d: $author$project$Spa$Generated$Route$Admin__DataExport__Top},
								{b: $elm$core$Maybe$Nothing, QG: $elm$core$Maybe$Nothing, adR: 'nav-item-data-export-settings', zh: 'Settings', d: $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: 'Data Exporter'
					}
					]),
					(isHintAdmin && ($author$project$Api$Provider$Practice$One$accountType(practice) === 1)) ? _List_fromArray(
					[
						{
						v: _List_fromArray(
							[
								{
								b: $elm$core$Maybe$Nothing,
								QG: $elm$core$Maybe$Just(
									$author$project$Ui$SvgIcon$hintHeart(
										_List_fromArray(
											[$author$project$Ui$SvgIcon$spacedRight]))),
								adR: 'nav-item-affiliate-plans',
								zh: 'Plans',
								d: $author$project$Spa$Generated$Route$Admin__Plans__Top
							}
							]),
						b: $elm$core$Maybe$Nothing,
						$G: ''
					}
					]) : _List_Nil
				])) : _List_Nil;
	});
var $author$project$Ui$Nav$Empty = {$: 2};
var $author$project$Ui$Nav$emptyItem = $author$project$Ui$Nav$Empty;
var $author$project$Layouts$Admin$viewActiveChildren = F3(
	function (currentRoute, practice, _v0) {
		var node = _v0;
		return A2($author$project$Layouts$Admin$nodeVisible, practice, node) ? A2(
			$author$project$Ui$Nav$item,
			_List_fromArray(
				[
					$author$project$Ui$Nav$route(node.d),
					$author$project$Ui$Nav$activeItem(
					A3($author$project$Layouts$Admin$nodeActive, currentRoute, practice, node))
				]),
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$html$Html$text(''),
					node.QG),
					$elm$html$Html$text(node.zh)
				])) : $author$project$Ui$Nav$emptyItem;
	});
var $author$project$Layouts$Admin$viewNav = F6(
	function (currentRoute, session, practice, hinterViewOff, isHintAdmin, model) {
		var _v0 = A3(
			$author$project$Layouts$Admin$getActiveStructure,
			currentRoute,
			practice,
			A4($author$project$Layouts$Admin$structure, session, practice, hinterViewOff, isHintAdmin));
		if (!_v0.$) {
			var active = _v0.a;
			return A3(
				$author$project$Ui$Nav$view,
				_List_Nil,
				A2(
					$elm$core$List$map,
					A2($author$project$Layouts$Admin$viewActiveChildren, currentRoute, practice),
					active.v),
				model.m8);
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Layouts$Admin$view = F4(
	function (toMsg, shared, model, body) {
		var session = shared.ZD;
		var practice = shared.WF;
		var hinterViewOff = shared.adN;
		var url = shared.aav;
		var _v0 = _Utils_Tuple2(session, practice);
		if (((_v0.a.$ === 3) && (_v0.b.$ === 3)) && (!_v0.b.a.$)) {
			var _v1 = _v0.a;
			var session_ = _v1.a;
			var _v2 = _v0.b;
			var practice_ = _v2.a.a;
			var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
			var currentRoute = $author$project$Utils$Route$fromUrl(url);
			var activeStructure = A3(
				$author$project$Layouts$Admin$getActiveStructure,
				currentRoute,
				practice_,
				A4($author$project$Layouts$Admin$structure, session_, practice_, hinterViewOff, isHintAdmin));
			return _Utils_ap(
				function () {
					if (!activeStructure.$) {
						var node = activeStructure.a;
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('layout-header')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												$author$project$Ui$Typography$heading(
												_List_fromArray(
													[
														$elm$html$Html$text(node.$G)
													]))
											])),
										A2(
										$elm$html$Html$map,
										toMsg,
										A6($author$project$Layouts$Admin$viewNav, currentRoute, session_, practice_, hinterViewOff, isHintAdmin, model))
									]))
							]);
					} else {
						return _List_Nil;
					}
				}(),
				body);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Ui$Nav$LinkOptions = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Nav$linkOptions = $author$project$Ui$Nav$LinkOptions;
var $author$project$Layouts$Affiliates$viewNav = F2(
	function (currentRoute, nav) {
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$AffiliateBills__Top),
							$author$project$Ui$Nav$linkOptions(
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'start', 'default'),
											A2($elm$url$Url$Builder$string, 'end', 'default')
										]))
								])),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$AffiliateBills__Top))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Affiliate Bills')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Affiliates__Top),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Affiliates__Top))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage Affiliates')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Affiliates$view = F4(
	function (toMsg, _v0, _v1, body) {
		var url = _v0.aav;
		var nav = _v1.m8;
		var currentRoute = $author$project$Utils$Route$fromUrl(url);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Networks')
									]))
							])),
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Affiliates$viewNav, currentRoute, nav))
					])),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Api$Provider$Affiliate$One$name = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Provider$Affiliate$Shared$name(shared);
};
var $author$project$Layouts$Affiliates$Affiliate$affiliateName = function (affiliate) {
	if (affiliate.$ === 3) {
		var affiliate_ = affiliate.a;
		return $elm$html$Html$text(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$author$project$Api$Provider$Affiliate$One$name(affiliate_)));
	} else {
		return $author$project$Ui$Spinner$view(
			_List_fromArray(
				[$author$project$Ui$Spinner$extraSmall]));
	}
};
var $author$project$Layouts$Affiliates$Affiliate$viewBreadcrumbs = function (affiliate) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$author$project$Ui$Breadcrumb$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Breadcrumb$item,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Affiliates__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Affiliates')
								]))
						])),
					A2(
					$author$project$Ui$Breadcrumb$item,
					_List_fromArray(
						[
							$author$project$Ui$Breadcrumb$active(true)
						]),
					_List_fromArray(
						[
							$author$project$Layouts$Affiliates$Affiliate$affiliateName(affiliate)
						]))
				])));
};
var $author$project$Layouts$Affiliates$Affiliate$viewHeader = function (affiliate) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
		_List_fromArray(
			[
				$author$project$Ui$Typography$heading(
				_List_fromArray(
					[
						$author$project$Layouts$Affiliates$Affiliate$affiliateName(affiliate)
					])),
				A2(
				$elm$core$Maybe$withDefault,
				$author$project$Utils$Html$empty,
				A2(
					$elm$core$Maybe$map,
					function (status) {
						return A2(
							$author$project$Ui$Badge$fromString,
							_List_fromArray(
								[$author$project$Ui$Badge$inline]),
							status);
					},
					A2(
						$elm$core$Maybe$map,
						$author$project$Api$Provider$Affiliate$One$status,
						$author$project$Api$Data$toMaybe(affiliate))))
			]));
};
var $author$project$Ui$HinterOnly$navItem = F2(
	function (options, content) {
		return A2(
			$author$project$Ui$Nav$item,
			options,
			A2(
				$elm$core$List$cons,
				$author$project$Ui$HinterOnly$icon(
					_List_fromArray(
						[$author$project$Ui$SvgIcon$spacedRight])),
				content));
	});
var $author$project$Layouts$Affiliates$Affiliate$viewNav = F3(
	function (currentRoute, _v0, shared) {
		var affiliateId = _v0.pp;
		var nav = _v0.m8;
		var usersRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users(
			{pp: affiliateId});
		var syncByAffiliation = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Network$Shared$syncByAffiliation,
				A2(
					$elm$core$Maybe$andThen,
					$author$project$Api$Practice$network,
					$author$project$Api$Data$toMaybe(shared.WF))));
		var settingsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings(
			{pp: affiliateId});
		var patientsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients(
			{pp: affiliateId});
		var linkedProvidersRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders(
			{pp: affiliateId});
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var billsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
			{pp: affiliateId});
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(billsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(billsRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Bills')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(patientsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(patientsRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Patients')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(linkedProvidersRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(linkedProvidersRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							syncByAffiliation ? 'Linked Providers & Locations' : 'Linked Providers')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(settingsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(settingsRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Terms & Conditions')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(usersRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(usersRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Users')
						])),
					function () {
					if (isHintAdmin) {
						var affiliateActionsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions(
							{pp: affiliateId});
						return A2(
							$author$project$Ui$HinterOnly$navItem,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(affiliateActionsRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(currentRoute, affiliateActionsRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Affiliate Actions')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}()
				]),
			nav);
	});
var $author$project$Layouts$Affiliates$Affiliate$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.aav);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						$author$project$Layouts$Affiliates$Affiliate$viewBreadcrumbs(model.DZ)),
						$author$project$Layouts$Affiliates$Affiliate$viewHeader(model.DZ),
						A2(
						$elm$html$Html$map,
						toMsg,
						A3($author$project$Layouts$Affiliates$Affiliate$viewNav, currentRoute, model, shared))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Layouts$Application$view = function (body) {
	return body;
};
var $author$project$Layouts$Blank$view = function (body) {
	return body;
};
var $author$project$Layouts$Commissions$viewNav = F2(
	function (currentRoute, nav) {
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top) || _Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Broker Accounts')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__Statements),
							$author$project$Ui$Nav$linkOptions(
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'start', 'default'),
											A2($elm$url$Url$Builder$string, 'end', 'default')
										]))
								])),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__Statements))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Statements')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__StatementLines__Top),
							$author$project$Ui$Nav$linkOptions(
							_List_fromArray(
								[
									$author$project$Ui$Link$routeParams(
									_List_fromArray(
										[
											A2($elm$url$Url$Builder$string, 'start', 'default'),
											A2($elm$url$Url$Builder$string, 'end', 'default')
										]))
								])),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__StatementLines__Top) || _Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__StatementLines__Summary))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Statement Lines')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Commissions$view = F4(
	function (toMsg, _v0, _v1, body) {
		var url = _v0.aav;
		var nav = _v1.m8;
		var currentRoute = $author$project$Utils$Route$fromUrl(url);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$mb2]),
						_List_fromArray(
							[
								$author$project$Ui$Typography$heading(
								_List_fromArray(
									[
										$elm$html$Html$text('Commissions')
									]))
							])),
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Commissions$viewNav, currentRoute, nav))
					])),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Layouts$Commissions$BrokerAccount$brokerAccountName = function (brokerAccount) {
	if (brokerAccount.$ === 3) {
		var brokerAccount_ = brokerAccount.a;
		return $elm$html$Html$text(
			$author$project$Api$Provider$BrokerAccount$One$name(brokerAccount_));
	} else {
		return $author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanFromText('Some Broker')
				]));
	}
};
var $author$project$Layouts$Commissions$BrokerAccount$viewBreadcrumbs = function (brokerAccount) {
	return A2(
		$elm$html$Html$map,
		$elm$core$Basics$never,
		A2(
			$author$project$Ui$Breadcrumb$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Breadcrumb$item,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$Ui$Link$route,
							$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('All Broker Accounts')
								]))
						])),
					A2(
					$author$project$Ui$Breadcrumb$item,
					_List_fromArray(
						[
							$author$project$Ui$Breadcrumb$active(true)
						]),
					_List_fromArray(
						[
							$author$project$Layouts$Commissions$BrokerAccount$brokerAccountName(brokerAccount)
						]))
				])));
};
var $author$project$Layouts$Commissions$BrokerAccount$viewHeader = function (brokerAccount) {
	return $author$project$Ui$Typography$heading(
		_List_fromArray(
			[
				$author$project$Layouts$Commissions$BrokerAccount$brokerAccountName(brokerAccount)
			]));
};
var $author$project$Layouts$Commissions$BrokerAccount$viewNav = F4(
	function (currentRoute, brokerAccountId, brokerAccount, nav) {
		var statementsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top(
			{bP: brokerAccountId});
		var multipleBrokers = A2(
			$elm$core$Maybe$withDefault,
			true,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Provider$BrokerAccount$One$multipleBrokers,
				$author$project$Api$Data$toMaybe(brokerAccount)));
		var endedDealsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals(
			{bP: brokerAccountId});
		var dealsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
			{bP: brokerAccountId});
		var brokerAccountRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top(
			{bP: brokerAccountId});
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(dealsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$List$member,
								currentRoute,
								_List_fromArray(
									[dealsRoute, endedDealsRoute])))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Deals')
						])),
					function () {
					if (multipleBrokers) {
						var brokersRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
							{bP: brokerAccountId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(brokersRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(brokersRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Brokers')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(statementsRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(statementsRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Statements')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(brokerAccountRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, brokerAccountRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Account Setup')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Commissions$BrokerAccount$view = F4(
	function (toMsg, _v0, model, body) {
		var url = _v0.aav;
		var currentRoute = $author$project$Utils$Route$fromUrl(url);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						$author$project$Layouts$Commissions$BrokerAccount$viewBreadcrumbs(model.vK)),
						$author$project$Layouts$Commissions$BrokerAccount$viewHeader(model.vK),
						A2(
						$elm$html$Html$map,
						toMsg,
						A4($author$project$Layouts$Commissions$BrokerAccount$viewNav, currentRoute, model.bP, model.vK, model.m8))
					])),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Layouts$Company$companyName = function (company) {
	if (company.$ === 3) {
		var company_ = company.a;
		return $elm$html$Html$text(
			$author$project$Api$Company$name(company_));
	} else {
		return $author$project$Ui$Skeleton$text(
			_List_fromArray(
				[
					$author$project$Ui$Skeleton$spanFromText('Company Name')
				]));
	}
};
var $author$project$Api$Provider$Company$One$flaggedNotesCount = function (_v0) {
	var record = _v0.b;
	return record.Py;
};
var $author$project$Api$Company$flaggedNotesCount = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$flaggedNotesCount(company_);
	} else {
		return 0;
	}
};
var $author$project$Ui$Badge$SizeMd = {$: 1};
var $author$project$Ui$Badge$md = $author$project$Ui$Badge$SizeMd;
var $author$project$Api$Employer$Company$Shared$status = function (_v0) {
	var record = _v0;
	return record.ag7;
};
var $author$project$Api$Employer$Company$One$status = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Employer$Company$Shared$status(shared);
};
var $author$project$Api$Company$status = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$status(company_);
	} else {
		var company_ = company.a;
		return $author$project$Api$Employer$Company$One$status(company_);
	}
};
var $author$project$Layouts$Company$viewHeader = F3(
	function (organizationIsCompany, practice, company) {
		return organizationIsCompany ? _List_Nil : _List_fromArray(
			[
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Breadcrumb$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Breadcrumb$item,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Companies__Top,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$core$Maybe$withDefault,
													$author$project$Ui$Skeleton$text(
														_List_fromArray(
															[
																$author$project$Ui$Skeleton$spanFromText('Employers')
															])),
													$author$project$Api$Data$toMaybe(
														A2(
															$author$project$Api$Data$map,
															function (pra) {
																return $elm$html$Html$text(
																	A2($author$project$Api$Practice$sponsorize, pra, 'Employers'));
															},
															practice)))
												]))
										])),
									A2(
									$author$project$Ui$Breadcrumb$item,
									_List_fromArray(
										[
											$author$project$Ui$Breadcrumb$active(true)
										]),
									_List_fromArray(
										[
											$author$project$Layouts$Company$companyName(company)
										]))
								]))),
						A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Element$view,
							_List_Nil,
							_List_fromArray(
								[
									A3(
									$author$project$Ui$Link$route,
									$author$project$Spa$Generated$Route$Companies__Top,
									_List_Nil,
									_List_fromArray(
										[
											$author$project$Ui$SvgIcon$cross(
											_List_fromArray(
												[$author$project$Ui$SvgIcon$sm]))
										]))
								])))
					])),
				A2(
				$author$project$Ui$Element$view,
				_List_fromArray(
					[$author$project$Ui$Element$gap2, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2]),
				_List_fromArray(
					[
						$author$project$Ui$Typography$heading(
						_List_fromArray(
							[
								$author$project$Layouts$Company$companyName(company)
							])),
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2(
							$elm$core$Maybe$map,
							function (status) {
								return A2(
									$author$project$Ui$Badge$fromString,
									_List_fromArray(
										[$author$project$Ui$Badge$md, $author$project$Ui$Badge$inline]),
									status);
							},
							A2(
								$elm$core$Maybe$map,
								$author$project$Api$Company$status,
								$author$project$Api$Data$toMaybe(company)))),
						$author$project$Utils$Html$noBreakSpace,
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Utils$Html$empty,
						A2(
							$elm$core$Maybe$andThen,
							function (company_) {
								return ($author$project$Api$Company$flaggedNotesCount(company_) > 0) ? $elm$core$Maybe$Just(
									A3(
										$author$project$Ui$Link$route,
										$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes(
											{
												ff: $author$project$Api$Company$id(company_)
											}),
										_List_fromArray(
											[
												$author$project$Ui$Link$routeParams(
												_List_fromArray(
													[
														A2($elm$url$Url$Builder$string, 'flagged', 'flagged')
													])),
												$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
											]),
										_List_Nil)) : $elm$core$Maybe$Nothing;
							},
							$author$project$Api$Data$toMaybe(company)))
					]))
			]);
	});
var $author$project$Api$Provider$Company$One$invitationPending = function (_v0) {
	var record = _v0.b;
	return record.Rf;
};
var $author$project$Api$Company$invitationPending = function (company) {
	if (!company.$) {
		var company_ = company.a;
		return $author$project$Api$Provider$Company$One$invitationPending(company_);
	} else {
		return false;
	}
};
var $author$project$Layouts$Company$viewInvitationPendingWarning = function (company) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Utils$Html$empty,
		A2(
			$elm$core$Maybe$andThen,
			function (company_) {
				return $author$project$Api$Company$invitationPending(company_) ? $elm$core$Maybe$Just(
					A2(
						$author$project$Ui$Alert$warning,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('No administrators have accepted their invitation. '),
								$elm$html$Html$text('We cannot send any invoices or emails to administrators who have not accepted their invitation. '),
								A3(
								$author$project$Ui$Link$route,
								$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
									{
										ff: $author$project$Api$Company$id(company_)
									}),
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Click here')
									])),
								$elm$html$Html$text(' to review invitations.')
							]))) : $elm$core$Maybe$Nothing;
			},
			$author$project$Api$Data$toMaybe(company)));
};
var $author$project$Api$Feature$CustomizableNotificationsByEmployer = 12;
var $author$project$Layouts$Company$viewNav = F5(
	function (currentRoute, isHintAdmin, practice, company, nav) {
		var gateAvailable = function (code) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (practice_) {
						return A2($author$project$Utils$FeatureGate$gateAvailable, code, practice_);
					},
					$author$project$Api$Data$toMaybe(practice)));
		};
		var customizableNotifificationsByEmployerEnabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				function (practice_) {
					return A2($author$project$Api$Practice$featureEnabled, 12, practice_);
				},
				$author$project$Api$Data$toMaybe(practice)));
		var companyType = $author$project$Api$Company$companyType(company);
		var isChildCompany = companyType === 1;
		var isNetwork = !companyType;
		var companyId = $author$project$Api$Company$id(company);
		var employeesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
			{ff: companyId});
		var invoicesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
			{ff: companyId});
		var notesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes(
			{ff: companyId});
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(employeesRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(employeesRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$author$project$Formatters$String$affiliateMember,
								'Employees',
								$elm$core$Maybe$Just(companyType)))
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(invoicesRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(invoicesRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Invoices')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(notesRoute),
							$author$project$Ui$Nav$activeItem(
							A2(
								$elm$core$String$startsWith,
								$author$project$Spa$Generated$Route$toString(notesRoute),
								$author$project$Spa$Generated$Route$toString(currentRoute)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Notes')
						])),
					function () {
					if (!isNetwork) {
						var endedCommissionsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions(
							{ff: companyId});
						var companyRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
							{ff: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(companyRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$List$member,
										currentRoute,
										_List_fromArray(
											[companyRoute, endedCommissionsRoute])))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Account & Pricing')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (!isNetwork) {
						var signupRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
							{ff: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(signupRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(signupRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Online Signup')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (!isNetwork) {
						var paymentSourcesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
							{ff: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(paymentSourcesRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(paymentSourcesRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Payment Options')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (!isNetwork) {
						var invoiceSettingsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings(
							{ff: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(invoiceSettingsRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(invoiceSettingsRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Invoice Settings')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (customizableNotifificationsByEmployerEnabled) {
						var notificationsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications(
							{ff: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(notificationsRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(notificationsRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Notifications')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if ((!isNetwork) && (gateAvailable(8) || isHintAdmin)) {
						var uploadsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
							{ff: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(uploadsRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(uploadsRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Employee Uploads')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if ((!isNetwork) && (isHintAdmin && (!isChildCompany))) {
						var easRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas(
							{ff: companyId});
						return A2(
							$author$project$Ui$HinterOnly$navItem,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(easRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(easRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Upload Settings')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (isNetwork) {
						var affiliatesPricingRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing(
							{ff: companyId});
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(affiliatesPricingRoute),
									$author$project$Ui$Nav$activeItem(
									A2(
										$elm$core$String$startsWith,
										$author$project$Spa$Generated$Route$toString(affiliatesPricingRoute),
										$author$project$Spa$Generated$Route$toString(currentRoute)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Pricing')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}()
				]),
			nav);
	});
var $author$project$Layouts$Company$view = F4(
	function (toMsg, shared, _v0, body) {
		var url = shared.aav;
		var organizationIsCompany = shared.afu;
		var practice = shared.WF;
		var company = shared.ab9;
		var nav = _v0.m8;
		var headerClass = (!organizationIsCompany) ? 'layout-header' : '';
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class(headerClass)
					]),
				_Utils_ap(
					A3($author$project$Layouts$Company$viewHeader, organizationIsCompany, practice, company),
					_List_fromArray(
						[
							$author$project$Layouts$Company$viewInvitationPendingWarning(company),
							function () {
							var _v1 = _Utils_Tuple2(organizationIsCompany, company);
							if ((!_v1.a) && (_v1.b.$ === 3)) {
								var _v2 = _v1.b;
								var company_ = _v2.a;
								var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
								var currentRoute = $author$project$Utils$Route$fromUrl(url);
								return A2(
									$elm$html$Html$map,
									toMsg,
									A5($author$project$Layouts$Company$viewNav, currentRoute, isHintAdmin, practice, company_, nav));
							} else {
								return $author$project$Utils$Html$empty;
							}
						}()
						]))),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Api$Provider$Integration$One$product = function (_v0) {
	var record = _v0.c;
	return record.W8;
};
var $author$project$Layouts$Marketplace$Manage$appNavItems = F3(
	function (currentRoute, integration, slug) {
		var _v0 = _Utils_Tuple2(
			$author$project$Api$Provider$Integration$One$status(integration),
			$author$project$Api$Common$Marketplace$Product$Shared$type_(
				$author$project$Api$Provider$Integration$One$product(integration)));
		if ((_v0.a === 'active') && (!_v0.b)) {
			var _v1 = _v0.b;
			var usersRoute = $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
				{_c: slug});
			var settingsAnchor = A2(
				$elm$core$Maybe$andThen,
				$author$project$Api$Common$PartnerApp$Shared$settingsAnchor,
				$author$project$Api$Provider$Integration$One$partnerApp(integration));
			var settingsNavItem = function () {
				if (!settingsAnchor.$) {
					var anchor = settingsAnchor.a;
					var settingsRoute = $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings(
						{_c: slug});
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(settingsRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(currentRoute, settingsRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2(
										$elm$core$Maybe$withDefault,
										'Settings',
										$author$project$Api$Common$PartnerApp$Anchor$settingsLabel(anchor)))
								]))
						]);
				} else {
					return _List_Nil;
				}
			}();
			return A2(
				$elm$core$List$cons,
				A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(usersRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, usersRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Manage Users')
						])),
				settingsNavItem);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Layouts$Marketplace$Manage$viewNav = F2(
	function (currentRoute, _v0) {
		var nav = _v0.m8;
		var slug = _v0._c;
		var integration = _v0.Q4;
		var navItems = function () {
			if (slug === 'layer') {
				return _List_fromArray(
					[
						A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Layer__Manage__Settings),
								$author$project$Ui$Nav$activeItem(
								_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Layer__Manage__Settings))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Settings')
							]))
					]);
			} else {
				var _v2 = $author$project$Api$Data$toMaybe(integration);
				if (!_v2.$) {
					var integration_ = _v2.a;
					var onboardingNavItem = A2(
						$elm$core$List$member,
						$author$project$Api$Provider$Integration$One$status(integration_),
						_List_fromArray(
							['pending', 'inactive'])) ? _List_fromArray(
						[
							A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(
									$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
										{_c: slug})),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(
										currentRoute,
										$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
											{_c: slug})))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Onboarding')
								]))
						]) : _List_Nil;
					return $elm$core$List$concat(
						_List_fromArray(
							[
								onboardingNavItem,
								A3($author$project$Layouts$Marketplace$Manage$appNavItems, currentRoute, integration_, slug)
							]));
				} else {
					return _List_Nil;
				}
			}
		}();
		return A3($author$project$Ui$Nav$view, _List_Nil, navItems, nav);
	});
var $author$project$Layouts$Marketplace$Manage$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.aav);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = model.Q4;
						if (_v0.$ === 3) {
							var integration = _v0.a;
							var product = $author$project$Api$Provider$Integration$One$product(integration);
							var productIcon = $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(product);
							var productName = $author$project$Api$Common$Marketplace$Product$Shared$name(product);
							return A2(
								$author$project$Ui$Element$view,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$flex, $author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap4, $author$project$Ui$Element$mb4, $author$project$Ui$Element$mt2]),
										_List_fromArray(
											[
												function () {
												if (!productIcon.$) {
													var iconUrl = productIcon.a;
													return A3(
														$author$project$Ui$Image$fromSrc,
														{I1: productName},
														iconUrl,
														_List_fromArray(
															[
																$author$project$Ui$Image$height(32)
															]));
												} else {
													return $elm$html$Html$text('');
												}
											}(),
												$author$project$Ui$Typography$heading(
												_List_fromArray(
													[
														$elm$html$Html$text(productName + ' Settings')
													]))
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$textMuted, $author$project$Ui$Element$mb2]),
										_List_fromArray(
											[
												function () {
												var _v2 = $author$project$Api$Common$Marketplace$Product$Shared$type_(product);
												switch (_v2) {
													case 0:
														return $elm$html$Html$text('Manage app configuration and user access.');
													case 1:
														return $elm$html$Html$text('Manage integration settings.');
													default:
														return $elm$html$Html$text('');
												}
											}()
											]))
									]));
						} else {
							return $elm$html$Html$text('');
						}
					}(),
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Marketplace$Manage$viewNav, currentRoute, model))
					])),
				A2($elm$html$Html$div, _List_Nil, body)
			]);
	});
var $author$project$Ui$FlexGrid$offsetLg = $author$project$Ui$FlexGrid$Offset(3);
var $author$project$Ui$FlexGrid$offsetXl = $author$project$Ui$FlexGrid$Offset(4);
var $author$project$Layouts$Onboard$viewHeader = A2(
	$author$project$Ui$FlexGrid$row,
	_List_fromArray(
		[$author$project$Ui$FlexGrid$mb4]),
	_List_fromArray(
		[
			A2(
			$author$project$Ui$FlexGrid$column,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Ui$Image$viewHintLogoImage(
					_List_fromArray(
						[
							$author$project$Ui$Image$class('topnav__logo')
						]))
				]))
		]));
var $author$project$Layouts$Onboard$isCurrentRoute = F2(
	function (url, route) {
		return A2(
			$elm$core$String$endsWith,
			$elm$core$String$concat(
				_List_fromArray(
					['/', route])),
			$author$project$Spa$Generated$Route$toString(
				$author$project$Utils$Route$fromUrl(url)));
	});
var $author$project$Components$OnboardingStepper$setCurrentStepFromUrl = function (url) {
	var route = $author$project$Utils$Route$fromUrl(url);
	return A2(
		$elm$core$String$endsWith,
		'/payment',
		$author$project$Spa$Generated$Route$toString(route)) ? 2 : (A2(
		$elm$core$String$endsWith,
		'/user',
		$author$project$Spa$Generated$Route$toString(route)) ? 1 : 0);
};
var $author$project$Ui$Stepper$Step = F5(
	function (label, index, disabled, subtitle, subtitleDescription) {
		return {dW: disabled, x4: index, aej: label, _4: subtitle, _5: subtitleDescription};
	});
var $author$project$Components$OnboardingStepper$convertedSteps = A2(
	$elm$core$List$map,
	function (internalStep) {
		return A5($author$project$Ui$Stepper$Step, internalStep.aej, internalStep.x4, false, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	},
	$author$project$Components$OnboardingStepper$internalSteps);
var $author$project$Ui$Icon$Check = 60;
var $author$project$Ui$Stepper$viewStep = F3(
	function (_v0, attr, step) {
		var currentIndex = _v0.P;
		var numSteps = _v0.T;
		var stepIndexString = $elm$core$String$fromInt(step.x4 + 1);
		var stepOptions = step.dW ? {
			cL: A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stepper__circle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(stepIndexString)
					])),
			dg: 'disabled',
			dh: $elm$html$Html$text(step.aej)
		} : (_Utils_eq(step.x4, currentIndex) ? {
			cL: A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stepper__circle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(stepIndexString)
					])),
			dg: 'current',
			dh: $elm$html$Html$text(step.aej)
		} : ((_Utils_cmp(step.x4, currentIndex) < 0) ? {
			cL: A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stepper__circle'),
						attr
					]),
				_List_fromArray(
					[
						A2($author$project$Ui$Icon$view, _List_Nil, 60)
					])),
			dg: 'previous',
			dh: A2(
				$elm$html$Html$a,
				_List_fromArray(
					[attr]),
				_List_fromArray(
					[
						$elm$html$Html$text(step.aej)
					]))
		} : {
			cL: A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('stepper__circle')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(stepIndexString)
					])),
			dg: 'next',
			dh: $elm$html$Html$text(step.aej)
		}));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stepper__step stepper__step--' + stepOptions.dg)
				]),
			_List_fromArray(
				[
					stepOptions.cL,
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stepper__text')
						]),
					_List_fromArray(
						[stepOptions.dh])),
					A2(
					$author$project$Utils$Html$htmlIf,
					_Utils_cmp(step.x4 + 1, numSteps) < 0,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stepper__line')
							]),
						_List_fromArray(
							[
								$author$project$Ui$HorizontalRule$view(_List_Nil)
							])))
				]));
	});
var $author$project$Ui$Stepper$viewStaticStep = F2(
	function (_v0, step) {
		var currentIndex = _v0.P;
		var numSteps = _v0.T;
		return A3(
			$author$project$Ui$Stepper$viewStep,
			{P: currentIndex, T: numSteps},
			$elm$html$Html$Attributes$class('label'),
			step);
	});
var $author$project$Ui$Stepper$viewStatic = F2(
	function (maybeStepIndex, steps) {
		if ($elm$core$List$isEmpty(steps)) {
			return $author$project$Utils$Html$empty;
		} else {
			if (!maybeStepIndex.$) {
				var stepIndex = maybeStepIndex.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stepper')
						]),
					A2(
						$elm$core$List$map,
						function (step) {
							return A2(
								$author$project$Ui$Stepper$viewStaticStep,
								{
									P: stepIndex,
									T: $elm$core$List$length(steps)
								},
								step);
						},
						steps));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Components$OnboardingStepper$view = function (model) {
	var currentStep = model.EP;
	return A2(
		$author$project$Ui$Stepper$viewStatic,
		$elm$core$Maybe$Just(currentStep.x4),
		$author$project$Components$OnboardingStepper$convertedSteps);
};
var $author$project$Layouts$Onboard$viewStepper = function (url) {
	if (A2($author$project$Layouts$Onboard$isCurrentRoute, url, 'complete') || A2($author$project$Layouts$Onboard$isCurrentRoute, url, 'completing')) {
		return $author$project$Utils$Html$empty;
	} else {
		var stepId = $author$project$Components$OnboardingStepper$setCurrentStepFromUrl(url);
		var stepperModel = $author$project$Components$OnboardingStepper$init(stepId);
		return $author$project$Components$OnboardingStepper$view(stepperModel);
	}
};
var $author$project$Layouts$Onboard$view = F2(
	function (_v0, body) {
		var url = _v0.aav;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Layouts$Onboard$viewHeader,
						$author$project$Layouts$Onboard$viewStepper(url),
						A2(
						$author$project$Ui$FlexGrid$row,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$column,
								_List_fromArray(
									[
										$author$project$Ui$FlexGrid$spanSm(8),
										$author$project$Ui$FlexGrid$offsetSm(2),
										$author$project$Ui$FlexGrid$spanMd(6),
										$author$project$Ui$FlexGrid$offsetMd(3),
										$author$project$Ui$FlexGrid$spanLg(6),
										$author$project$Ui$FlexGrid$offsetLg(3),
										$author$project$Ui$FlexGrid$spanXl(4),
										$author$project$Ui$FlexGrid$offsetXl(4)
									]),
								body)
							]))
					]))
			]);
	});
var $author$project$Layouts$Partner$Billing$viewNav = F3(
	function (shared, currentRoute, _v0) {
		var nav = _v0.m8;
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var billingRoute = $author$project$Spa$Generated$Route$Partner__Billing;
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(billingRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, billingRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Payment Processing')
						])),
					function () {
					if (isHintAdmin) {
						var hinterRoute = $author$project$Spa$Generated$Route$Partner__Billing__Hinter;
						return A2(
							$author$project$Ui$HinterOnly$navItem,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(hinterRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(hinterRoute, currentRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Billing')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}()
				]),
			nav);
	});
var $author$project$Layouts$Partner$Billing$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.aav);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						A3($author$project$Layouts$Partner$Billing$viewNav, shared, currentRoute, model))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Layouts$Partner$Practices$viewNav = F2(
	function (currentRoute, _v0) {
		var nav = _v0.m8;
		var engagementsRoute = $author$project$Spa$Generated$Route$Partner__Engagements;
		var connectionsRoute = $author$project$Spa$Generated$Route$Partner__Practices__Top;
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(connectionsRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, connectionsRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Connections')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(engagementsRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, engagementsRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Engagements')
						]))
				]),
			nav);
	});
var $author$project$Layouts$Partner$Practices$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.aav);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$Partner$Practices$viewNav, currentRoute, model))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Api$Partner$Partner$Shared$appEnabled = function (_v0) {
	var record = _v0;
	return !record.GT;
};
var $author$project$Api$Partner$Partner$One$appEnabled = function (_v0) {
	var shared = _v0.a;
	return $author$project$Api$Partner$Partner$Shared$appEnabled(shared);
};
var $author$project$Layouts$Partner$Product$viewNav = F3(
	function (shared, currentRoute, _v0) {
		var nav = _v0.m8;
		var partner = _v0.Vz;
		var productRoute = $author$project$Spa$Generated$Route$Partner__Product;
		var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
		var appEnabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$Partner$One$appEnabled,
				$author$project$Api$Data$toMaybe(partner)));
		var apiEnabled = A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$author$project$Api$Partner$Partner$One$active,
				$author$project$Api$Data$toMaybe(partner)));
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route(productRoute),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, productRoute))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Product Listing')
						])),
					function () {
					if (apiEnabled) {
						var activationSettingsRoute = $author$project$Spa$Generated$Route$Partner__Product__ActivationSettings;
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(activationSettingsRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(activationSettingsRoute, currentRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Activation Settings')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (apiEnabled && appEnabled) {
						var appSettingsRoute = $author$project$Spa$Generated$Route$Partner__Product__AppSettings;
						return A2(
							$author$project$Ui$Nav$item,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(appSettingsRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(appSettingsRoute, currentRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('App Settings')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}(),
					function () {
					if (isHintAdmin) {
						var hinterRoute = $author$project$Spa$Generated$Route$Partner__Product__Hinter;
						return A2(
							$author$project$Ui$HinterOnly$navItem,
							_List_fromArray(
								[
									$author$project$Ui$Nav$route(hinterRoute),
									$author$project$Ui$Nav$activeItem(
									_Utils_eq(hinterRoute, currentRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Admin Settings')
								]));
					} else {
						return $author$project$Ui$Nav$emptyItem;
					}
				}()
				]),
			nav);
	});
var $author$project$Layouts$Partner$Product$view = F4(
	function (toMsg, shared, model, body) {
		var currentRoute = $author$project$Utils$Route$fromUrl(shared.aav);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('layout-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						A3($author$project$Layouts$Partner$Product$viewNav, shared, currentRoute, model))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
					]),
				body)
			]);
	});
var $author$project$Ui$Pagination$List$HideTotalItems = {$: 3};
var $author$project$Ui$Pagination$List$hideTotalItems = $author$project$Ui$Pagination$List$HideTotalItems;
var $author$project$Ui$Pagination$List$sm = $author$project$Ui$Pagination$List$Size(0);
var $author$project$Components$PatientsList$PhiModeToggled = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$PatientsList$viewPhiToggle = function (phiMode) {
	return A2(
		$author$project$Ui$Element$view,
		_List_fromArray(
			[$author$project$Ui$Element$itemsCenter]),
		_List_fromArray(
			[
				$author$project$Ui$ToggleSwitch$view(
				_List_fromArray(
					[
						$author$project$Ui$ToggleSwitch$sm,
						$author$project$Ui$ToggleSwitch$on(!phiMode),
						$author$project$Ui$ToggleSwitch$onChange(
						A2($elm$core$Basics$composeL, $author$project$Components$PatientsList$PhiModeToggled, $elm$core$Basics$not))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('ml-2')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Display patients list')
					]))
			]));
};
var $author$project$Components$PatientsList$viewMini = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('patients-list patients-list--mini'),
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('patients-list--phi-mode', model.r2)
					]))
			]),
		_Utils_ap(
			A2($author$project$Components$PatientsList$viewSearchAndFilters, true, model),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Panel$view,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Components$PatientsList$viewPhiToggle(model.r2)
								])),
							A2($author$project$Components$PatientsList$viewPatientsTable, true, model),
							A2(
							$author$project$Ui$Panel$body,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Element$view,
									_List_fromArray(
										[$author$project$Ui$Element$mt4]),
									_List_fromArray(
										[
											A2(
											$author$project$Components$PatientsList$viewPagination,
											_List_fromArray(
												[$author$project$Ui$Pagination$List$hideTotalItems, $author$project$Ui$Pagination$List$sm]),
											model)
										]))
								]))
						]))
				])));
};
var $author$project$Layouts$PatientsSidebar$view = F3(
	function (toMsg, patientsListModel, body) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('flex')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						toMsg,
						$author$project$Components$PatientsList$viewMini(patientsListModel)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('md:w-full md:ml-64 w-full')
							]),
						body)
					]))
			]);
	});
var $author$project$Components$PatientViewSwitcher$MembershipsBilling = 1;
var $author$project$Components$PatientViewSwitcher$ClinicalChart = 0;
var $author$project$Components$PatientViewSwitcher$viewToRoute = F2(
	function (activeView, patientId) {
		if (!activeView) {
			return $author$project$Spa$Generated$Route$Patients__PatientId_String__Chart(
				{VN: patientId});
		} else {
			return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
				{VN: patientId});
		}
	});
var $author$project$Components$PatientViewSwitcher$viewItem = F4(
	function (label, itemView, activeView, patientId) {
		return _Utils_eq(itemView, activeView) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('patient-view-switcher__item patient-view-switcher__item--active')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				])) : A3(
			$author$project$Ui$Link$route,
			A2($author$project$Components$PatientViewSwitcher$viewToRoute, itemView, patientId),
			_List_fromArray(
				[$author$project$Ui$Link$currentColor]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('patient-view-switcher__item')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Components$PatientViewSwitcher$view = F2(
	function (patientId, activeView) {
		var barClass = function () {
			if (!activeView) {
				return 'patient-view-switcher-bar patient-view-switcher-bar--clinical';
			} else {
				return 'patient-view-switcher-bar patient-view-switcher-bar--core';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(barClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('patient-view-switcher')
						]),
					_List_fromArray(
						[
							A4($author$project$Components$PatientViewSwitcher$viewItem, 'Clinical Chart', 0, activeView, patientId),
							A4($author$project$Components$PatientViewSwitcher$viewItem, 'Memberships & Billing', 1, activeView, patientId)
						]))
				]));
	});
var $author$project$Layouts$Patient$AffiliateSyncDetailHovered = {$: 3};
var $author$project$Layouts$Patient$NetworkSyncDetailHovered = {$: 1};
var $author$project$Api$Provider$Patient$One$affiliateSyncStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.II;
	});
var $author$project$Api$Provider$Patient$One$hasFlaggedNotes = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.Py;
		},
		function (flaggedNotesCount) {
			return flaggedNotesCount > 0;
		}));
var $author$project$Api$Provider$Patient$One$isAffiliated = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Rw;
	});
var $author$project$Components$SyncedIcon$Md = 0;
var $author$project$Components$SyncedIcon$Size = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$SyncedIcon$md = $author$project$Components$SyncedIcon$Size(0);
var $author$project$Layouts$Patient$membershipStatus = function (patient) {
	return _Utils_ap(
		$author$project$Formatters$String$humanize(
			$author$project$Api$Provider$Patient$One$membershipStatus(patient)),
		function () {
			var _v0 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
			if (!_v0.$) {
				var membershipThrough = _v0.a;
				return ' through ' + $author$project$Api$Provider$Patient$Min$name(membershipThrough);
			} else {
				return '';
			}
		}());
};
var $author$project$Api$Provider$Patient$One$networkSyncStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Ut;
	});
var $author$project$Layouts$Patient$GoToAffiliatedPatient = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Api$Provider$Patient$One$affiliate = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.DZ;
	});
var $author$project$Layouts$Patient$isHintAdmin = F2(
	function (session, hinterViewOff) {
		if (session.$ === 3) {
			var session_ = session.a;
			return A2($author$project$Utils$User$isViewingAsHinter, session_, hinterViewOff);
		} else {
			return false;
		}
	});
var $author$project$Api$Provider$Patient$One$masterRecordId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.To;
	});
var $author$project$Api$Provider$Patient$One$network = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.Uo;
	});
var $author$project$Api$Provider$Patient$One$syncedRecordId = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$One$record_,
	function ($) {
		return $.$m;
	});
var $author$project$Layouts$Patient$viewActions = F2(
	function (_v0, patient) {
		var session = _v0.ZD;
		var hinterViewOff = _v0.adN;
		var isHintAdmin_ = A2($author$project$Layouts$Patient$isHintAdmin, session, hinterViewOff);
		var hintAdminActions = function () {
			if (isHintAdmin_) {
				var syncedRecordId = $author$project$Api$Provider$Patient$One$syncedRecordId(patient);
				var network = $author$project$Api$Provider$Patient$One$network(patient);
				var masterRecordId = $author$project$Api$Provider$Patient$One$masterRecordId(patient);
				var affiliate = $author$project$Api$Provider$Patient$One$affiliate(patient);
				return _List_fromArray(
					[
						function () {
						var _v1 = _Utils_Tuple2(network, masterRecordId);
						if ((!_v1.a.$) && (!_v1.b.$)) {
							var network_ = _v1.a.a;
							var masterId = _v1.b.a;
							return A3(
								$author$project$Ui$HinterOnly$button,
								{abp: 'Go to affiliated patient'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										A2($author$project$Layouts$Patient$GoToAffiliatedPatient, network_, masterId))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Icon$view,
										_List_fromArray(
											[$author$project$Ui$Icon$clickable]),
										13)
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}(),
						function () {
						var _v2 = _Utils_Tuple2(affiliate, syncedRecordId);
						if ((!_v2.a.$) && (!_v2.b.$)) {
							var affiliate_ = _v2.a.a;
							var syncedId = _v2.b.a;
							return A3(
								$author$project$Ui$HinterOnly$button,
								{abp: 'Go to affiliated patient'},
								_List_fromArray(
									[
										$author$project$Ui$Button$link,
										$author$project$Ui$Button$onClick(
										A2($author$project$Layouts$Patient$GoToAffiliatedPatient, affiliate_, syncedId))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$Icon$view,
										_List_fromArray(
											[$author$project$Ui$Icon$clickable]),
										17)
									]));
						} else {
							return $author$project$Utils$Html$empty;
						}
					}()
					]);
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_ap(
			hintAdminActions,
			_List_fromArray(
				[
					A3(
					$author$project$Ui$Link$route,
					$author$project$Spa$Generated$Route$Charges__New,
					_List_fromArray(
						[
							$author$project$Ui$Link$buttonSecondary,
							$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$dollarSign),
							$author$project$Ui$Link$test('add-charge'),
							$author$project$Ui$Link$routeParams(
							_List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'patient',
									$author$project$Api$Provider$Patient$One$id(patient))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Add Charge')
						]))
				]));
	});
var $author$project$Layouts$Patient$viewDemographicsDetails = function (patient) {
	var pronouns = A2(
		$elm$core$Maybe$map,
		function (p) {
			return '(' + ($author$project$Formatters$String$humanize(p) + ')');
		},
		$author$project$Api$Provider$Patient$One$pronoun(patient));
	var mainDetails = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				$author$project$Formatters$String$humanize,
				$author$project$Api$Provider$Patient$One$gender(patient)),
				A2(
				$elm$core$Maybe$map,
				$author$project$Formatters$Date$toString($author$project$Formatters$Date$Full),
				$author$project$Api$Provider$Patient$One$dob(patient))
			]));
	return ($elm$core$List$isEmpty(mainDetails) && _Utils_eq(pronouns, $elm$core$Maybe$Nothing)) ? $author$project$Utils$Html$empty : A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('demographics-bar__details')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($elm$core$String$join, ', ', mainDetails))
					])),
				function () {
				if (!pronouns.$) {
					var p = pronouns.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('demographics-bar__pronouns text-muted')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' ' + p)
							]));
				} else {
					return $author$project$Utils$Html$empty;
				}
			}()
			]));
};
var $author$project$Api$Provider$Patient$SyncDetail$enrollmentStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.OI;
		},
		$elm$core$Maybe$withDefault('')));
var $author$project$Api$Provider$Patient$SyncDetail$errorMessage = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.ON;
	});
var $author$project$Api$Provider$Patient$SyncDetail$startedAt = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $._H;
	});
var $author$project$Api$Provider$Patient$SyncDetail$syncStatus = A2(
	$elm$core$Basics$composeR,
	$author$project$Api$Provider$Patient$SyncDetail$record_,
	function ($) {
		return $.$i;
	});
var $author$project$Api$Provider$Patient$SyncDetail$syncedWith = function (detail) {
	if (!detail.$) {
		var name = detail.a;
		return name;
	} else {
		var name = detail.a;
		return name;
	}
};
var $author$project$Layouts$Patient$viewSyncedIconPopover = F2(
	function (timeFormatter, detailsData) {
		if ((detailsData.$ === 3) && (!detailsData.a.$)) {
			var details = detailsData.a.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								var _v1 = $author$project$Api$Provider$Patient$SyncDetail$syncStatus(details);
								if (_v1 === 'synced') {
									return 'Synced with ';
								} else {
									var status = _v1;
									return 'Sync ' + (status + ' with ');
								}
							}()),
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Api$Provider$Patient$SyncDetail$syncedWith(details))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								$author$project$Api$Provider$Patient$SyncDetail$errorMessage(details)))
						])),
					A2(
					$author$project$Ui$Typography$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2(
									$elm$core$Maybe$map,
									timeFormatter(0),
									A2(
										$author$project$Utils$Maybe$orElse,
										$author$project$Api$Provider$Patient$SyncDetail$startedAt(details),
										$author$project$Api$Provider$Patient$SyncDetail$completedAt(details))))),
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text($author$project$Utils$Html$middleDot),
							$author$project$Utils$Html$noBreakSpace,
							$elm$html$Html$text(
							$author$project$Api$Provider$Patient$SyncDetail$enrollmentStatus(details))
						]))
				]);
		} else {
			return _List_fromArray(
				[
					$elm$html$Html$text('Loading details...'),
					$author$project$Ui$Spinner$view(
					_List_fromArray(
						[$author$project$Ui$Spinner$small]))
				]);
		}
	});
var $author$project$Layouts$Patient$viewDemographicsBar = F4(
	function (shared, patient, model, timeFormatter) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('demographics-bar demographics-bar--unified')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Element$view,
					_List_fromArray(
						[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('demographics-bar__name-row')
										]),
									_List_fromArray(
										[
											$author$project$Ui$Typography$heading(
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Api$Provider$Patient$One$name(patient))
														])),
													function () {
													var ageDisplay = A3(
														$author$project$Formatters$Patient$formatAge,
														shared.cO,
														$author$project$Api$Provider$Patient$One$dob(patient),
														$author$project$Api$Provider$Patient$One$age(patient));
													return $elm$core$String$isEmpty(ageDisplay) ? $elm$html$Html$text('') : $elm$html$Html$text(' (' + (ageDisplay + ')'));
												}()
												])),
											A2(
											$author$project$Ui$Element$view,
											_List_fromArray(
												[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
											_List_fromArray(
												[
													function () {
													var _v0 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
													if (!_v0.$) {
														return A3(
															$author$project$Ui$Tooltip$view,
															_List_fromArray(
																[
																	$author$project$Ui$Tooltip$placement(0)
																]),
															$author$project$Layouts$Patient$membershipStatus(patient),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$Badge$fromStringWithIcon,
																	_List_Nil,
																	$author$project$Api$Provider$Patient$One$membershipStatus(patient),
																	$author$project$Ui$SvgIcon$arrowRightBottom(_List_Nil))
																]));
													} else {
														return A2(
															$author$project$Ui$Badge$fromString,
															_List_Nil,
															$author$project$Api$Provider$Patient$One$membershipStatus(patient));
													}
												}(),
													$author$project$Api$Provider$Patient$One$hasFlaggedNotes(patient) ? A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
														{
															VN: $author$project$Api$Provider$Patient$One$id(patient)
														}),
													_List_fromArray(
														[
															$author$project$Ui$Link$routeParams(
															_List_fromArray(
																[
																	A2($elm$url$Url$Builder$string, 'flagged', '1')
																])),
															$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
														]),
													_List_Nil) : $elm$html$Html$text(''),
													($author$project$Api$Provider$Patient$One$isMaster(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient)) ? A3(
													$author$project$Ui$Popover$view,
													_List_fromArray(
														[
															$author$project$Ui$Popover$dark,
															$author$project$Ui$Popover$onHover($author$project$Layouts$Patient$NetworkSyncDetailHovered)
														]),
													_List_fromArray(
														[
															$author$project$Components$SyncedIcon$view(
															_List_fromArray(
																[
																	$author$project$Components$SyncedIcon$md,
																	$author$project$Components$SyncedIcon$master,
																	$author$project$Components$SyncedIcon$status(
																	$author$project$Api$Provider$Patient$One$networkSyncStatus(patient))
																]))
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Popover$body,
															_List_Nil,
															A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.jf))
														])) : $author$project$Utils$Html$empty,
													($author$project$Api$Provider$Patient$One$isSynced(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient)) ? A3(
													$author$project$Ui$Popover$view,
													_List_fromArray(
														[
															$author$project$Ui$Popover$dark,
															$author$project$Ui$Popover$onHover($author$project$Layouts$Patient$AffiliateSyncDetailHovered)
														]),
													_List_fromArray(
														[
															$author$project$Components$SyncedIcon$view(
															_List_fromArray(
																[
																	$author$project$Components$SyncedIcon$md,
																	$author$project$Components$SyncedIcon$synced,
																	$author$project$Components$SyncedIcon$status(
																	$author$project$Api$Provider$Patient$One$affiliateSyncStatus(patient))
																]))
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Ui$Popover$body,
															_List_Nil,
															A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.ht))
														])) : $author$project$Utils$Html$empty
												]))
										])),
									$author$project$Layouts$Patient$viewDemographicsDetails(patient)
								])),
							A2(
							$author$project$Ui$Element$view,
							_List_fromArray(
								[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
							A2($author$project$Layouts$Patient$viewActions, shared, patient))
						]))
				]));
	});
var $author$project$Layouts$Patient$viewHeader = F3(
	function (shared, patient, model) {
		var practice = shared.WF;
		var timeFormatter = shared.Hy;
		if (practice.$ === 3) {
			var practice_ = practice.a;
			var isJointProduct = A2($author$project$Api$Practice$featureEnabled, 6, practice_);
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						isJointProduct ? A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2($author$project$Components$PatientViewSwitcher$view, model.VN, 1)) : A2(
						$elm$html$Html$map,
						$elm$core$Basics$never,
						A2(
							$author$project$Ui$Breadcrumb$view,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$author$project$Ui$Breadcrumb$item,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__Top,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Patients')
												]))
										])),
									A2(
									$author$project$Ui$Breadcrumb$item,
									_List_fromArray(
										[
											$author$project$Ui$Breadcrumb$active(true)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Typography$span,
											_List_fromArray(
												[
													$author$project$Ui$Typography$phi(true)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Api$Provider$Patient$One$name(patient))
												]))
										]))
								]))),
						A4($author$project$Layouts$Patient$viewDemographicsBar, shared, patient, model, timeFormatter)
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Utils$Clinical$getPatientUrl = F4(
	function (isUnifiedExperience, origin, emrHost, patientId) {
		return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + ('/patients/' + (patientId + '/chart'));
	});
var $author$project$Layouts$Patient$viewHeaderLegacy = F3(
	function (shared, patient, model) {
		var practice = shared.WF;
		var timeFormatter = shared.Hy;
		if (practice.$ === 3) {
			var practice_ = practice.a;
			return A2(
				$author$project$Ui$Element$view,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsStart]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Breadcrumb$view,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_Nil,
											_List_fromArray(
												[
													A3(
													$author$project$Ui$Link$route,
													$author$project$Spa$Generated$Route$Patients__Top,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Patients')
														]))
												])),
											A2(
											$author$project$Ui$Breadcrumb$item,
											_List_fromArray(
												[
													$author$project$Ui$Breadcrumb$active(true)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Typography$span,
													_List_fromArray(
														[
															$author$project$Ui$Typography$phi(true)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Api$Provider$Patient$One$name(patient))
														]))
												]))
										]))),
								A2(
								$elm$html$Html$map,
								$elm$core$Basics$never,
								A2(
									$author$project$Ui$Element$view,
									_List_Nil,
									_List_fromArray(
										[
											A3(
											$author$project$Ui$Link$route,
											$author$project$Spa$Generated$Route$Patients__Top,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Ui$SvgIcon$cross(
													_List_fromArray(
														[$author$project$Ui$SvgIcon$sm]))
												]))
										])))
							])),
						A2(
						$author$project$Ui$Element$view,
						_List_fromArray(
							[$author$project$Ui$Element$spaceBetween, $author$project$Ui$Element$itemsCenter]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2]),
								_List_fromArray(
									[
										$author$project$Ui$Typography$heading(
										_List_fromArray(
											[
												A2(
												$author$project$Ui$Typography$span,
												_List_fromArray(
													[
														$author$project$Ui$Typography$phi(true)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Api$Provider$Patient$One$name(patient))
													])),
												function () {
												var ageDisplay = A3(
													$author$project$Formatters$Patient$formatAge,
													shared.cO,
													$author$project$Api$Provider$Patient$One$dob(patient),
													$author$project$Api$Provider$Patient$One$age(patient));
												return $elm$core$String$isEmpty(ageDisplay) ? $elm$html$Html$text('') : $elm$html$Html$text(', ' + ageDisplay);
											}()
											])),
										A2(
										$author$project$Ui$Element$view,
										_List_fromArray(
											[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$gap2]),
										_List_fromArray(
											[
												function () {
												var _v1 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
												if (!_v1.$) {
													return A3(
														$author$project$Ui$Tooltip$view,
														_List_fromArray(
															[
																$author$project$Ui$Tooltip$placement(0)
															]),
														$author$project$Layouts$Patient$membershipStatus(patient),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$Badge$fromStringWithIcon,
																_List_Nil,
																$author$project$Api$Provider$Patient$One$membershipStatus(patient),
																$author$project$Ui$SvgIcon$arrowRightBottom(_List_Nil))
															]));
												} else {
													return A2(
														$author$project$Ui$Badge$fromString,
														_List_Nil,
														$author$project$Api$Provider$Patient$One$membershipStatus(patient));
												}
											}(),
												function () {
												if (A2($author$project$Api$Practice$featureEnabled, 6, practice_)) {
													var isUnifiedExperience = A2($author$project$Api$Practice$featureEnabled, 19, practice_);
													var emrUrl = A4(
														$author$project$Utils$Clinical$getPatientUrl,
														isUnifiedExperience,
														shared.adu.afw,
														shared.adu.acZ,
														$author$project$Api$Provider$Patient$One$id(patient));
													return A3(
														$author$project$Ui$Link$externalHref,
														emrUrl,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('View Chart in Clinical')
															]));
												} else {
													return $elm$html$Html$text('');
												}
											}(),
												$author$project$Api$Provider$Patient$One$hasFlaggedNotes(patient) ? A3(
												$author$project$Ui$Link$route,
												$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
													{
														VN: $author$project$Api$Provider$Patient$One$id(patient)
													}),
												_List_fromArray(
													[
														$author$project$Ui$Link$routeParams(
														_List_fromArray(
															[
																A2($elm$url$Url$Builder$string, 'flagged', '1')
															])),
														$author$project$Ui$Link$icon($author$project$Ui$SvgIcon$flag)
													]),
												_List_Nil) : $elm$html$Html$text(''),
												($author$project$Api$Provider$Patient$One$isMaster(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient)) ? A3(
												$author$project$Ui$Popover$view,
												_List_fromArray(
													[
														$author$project$Ui$Popover$dark,
														$author$project$Ui$Popover$onHover($author$project$Layouts$Patient$NetworkSyncDetailHovered)
													]),
												_List_fromArray(
													[
														$author$project$Components$SyncedIcon$view(
														_List_fromArray(
															[
																$author$project$Components$SyncedIcon$md,
																$author$project$Components$SyncedIcon$master,
																$author$project$Components$SyncedIcon$status(
																$author$project$Api$Provider$Patient$One$networkSyncStatus(patient))
															]))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Popover$body,
														_List_Nil,
														A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.jf))
													])) : $author$project$Utils$Html$empty,
												($author$project$Api$Provider$Patient$One$isSynced(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient)) ? A3(
												$author$project$Ui$Popover$view,
												_List_fromArray(
													[
														$author$project$Ui$Popover$dark,
														$author$project$Ui$Popover$onHover($author$project$Layouts$Patient$AffiliateSyncDetailHovered)
													]),
												_List_fromArray(
													[
														$author$project$Components$SyncedIcon$view(
														_List_fromArray(
															[
																$author$project$Components$SyncedIcon$md,
																$author$project$Components$SyncedIcon$synced,
																$author$project$Components$SyncedIcon$status(
																$author$project$Api$Provider$Patient$One$affiliateSyncStatus(patient))
															]))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Ui$Popover$body,
														_List_Nil,
														A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.ht))
													])) : $author$project$Utils$Html$empty
											]))
									])),
								A2(
								$author$project$Ui$Element$view,
								_List_fromArray(
									[$author$project$Ui$Element$itemsCenter, $author$project$Ui$Element$mb2, $author$project$Ui$Element$gap2]),
								A2($author$project$Layouts$Patient$viewActions, shared, patient))
							]))
					]));
		} else {
			return $author$project$Utils$Html$empty;
		}
	});
var $author$project$Layouts$Patient$Affiliation = 4;
var $author$project$Layouts$Patient$Invoices = 3;
var $author$project$Layouts$Patient$Memberships = 1;
var $author$project$Layouts$Patient$Notes = 5;
var $author$project$Layouts$Patient$Notifications = 6;
var $author$project$Layouts$Patient$Patient = 0;
var $author$project$Layouts$Patient$PaymentOptions = 2;
var $author$project$Layouts$Patient$isAuthorized = function (session) {
	if (session.$ === 3) {
		var session_ = session.a;
		return !$author$project$Api$Platform$Session$One$practiceReadOnlyRole(session_);
	} else {
		return false;
	}
};
var $author$project$Layouts$Patient$showIfAuthorized = F2(
	function (authorized, item) {
		return authorized ? item : $author$project$Ui$Nav$emptyItem;
	});
var $author$project$Layouts$Patient$tabFromUrl = function (url) {
	var pathWithoutPat = A2(
		$elm$core$List$drop,
		3,
		A2($elm$core$String$split, '/', url.VL));
	_v0$6:
	while (true) {
		if (pathWithoutPat.b) {
			switch (pathWithoutPat.a) {
				case 'memberships':
					return 1;
				case 'accounts':
					return 2;
				case 'charges':
					return 3;
				case 'notes':
					return 5;
				case 'notifications':
					return 6;
				case 'affiliation':
					return 4;
				default:
					break _v0$6;
			}
		} else {
			break _v0$6;
		}
	}
	return 0;
};
var $author$project$Layouts$Patient$tabToRoute = function (tab) {
	return function (id) {
		switch (tab) {
			case 0:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
					{VN: id});
			case 1:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
					{VN: id});
			case 2:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
					{VN: id});
			case 3:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
					{VN: id});
			case 4:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top(
					{VN: id});
			case 5:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
					{VN: id});
			default:
				return $author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top(
					{VN: id});
		}
	};
};
var $author$project$Layouts$Patient$viewNavWith = F4(
	function (linkOptions, _v0, patient, _v1) {
		var url = _v0.aav;
		var session = _v0.ZD;
		var practice = _v0.WF;
		var patientId = _v1.VN;
		var nav = _v1.m8;
		var membershipsTabLabel = function () {
			if (practice.$ === 3) {
				var practice_ = practice.a;
				return A2($author$project$Api$Practice$featureEnabled, 22, practice_) ? 'Memberships & Packages' : 'Memberships';
			} else {
				return 'Memberships';
			}
		}();
		var linkRoute = function (tab) {
			return A2($author$project$Layouts$Patient$tabToRoute, tab, patientId);
		};
		var isSynced = $author$project$Api$Provider$Patient$One$isSynced(patient);
		var isAuthorized_ = $author$project$Layouts$Patient$isAuthorized(session);
		var activeTab = $author$project$Layouts$Patient$tabFromUrl(url);
		var isActive = function (tab) {
			return $author$project$Ui$Nav$activeItem(
				_Utils_eq(activeTab, tab));
		};
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							isActive(0),
							$author$project$Ui$Nav$route(
							linkRoute(0)),
							$author$project$Ui$Nav$linkOptions(linkOptions)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Patient')
						])),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(3),
								$author$project$Ui$Nav$route(
								linkRoute(3)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Invoices'),
										($author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0) ? A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$Utils$Html$noBreakSpace,
												A2($author$project$Ui$Icon$view, _List_Nil, 35)
											])) : $author$project$Utils$Html$empty
									]))
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(1),
								$author$project$Ui$Nav$route(
								linkRoute(1)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(membershipsTabLabel)
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(2),
								$author$project$Ui$Nav$route(
								linkRoute(2)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Payment Options')
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_ && isSynced,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(4),
								$author$project$Ui$Nav$route(
								linkRoute(4)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Affiliation')
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(5),
								$author$project$Ui$Nav$route(
								linkRoute(5)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Notes')
							]))),
					A2(
					$author$project$Layouts$Patient$showIfAuthorized,
					isAuthorized_,
					A2(
						$author$project$Ui$Nav$item,
						_List_fromArray(
							[
								isActive(6),
								$author$project$Ui$Nav$route(
								linkRoute(6)),
								$author$project$Ui$Nav$linkOptions(linkOptions)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Notifications')
							])))
				]),
			nav);
	});
var $author$project$Layouts$Patient$viewNav = F3(
	function (shared, patient, model) {
		return A4($author$project$Layouts$Patient$viewNavWith, _List_Nil, shared, patient, model);
	});
var $author$project$Layouts$Patient$viewNavLegacy = F4(
	function (shared, patient, patientsList, model) {
		return A4(
			$author$project$Layouts$Patient$viewNavWith,
			_List_fromArray(
				[
					$author$project$Ui$Link$routeParams(
					$author$project$Components$PatientsList$urlParams(patientsList))
				]),
			shared,
			patient,
			model);
	});
var $author$project$Layouts$Patient$view = F5(
	function (toMsg, patientListToMsg, shared, model, body) {
		var isUnifiedExperience = function () {
			var _v3 = shared.WF;
			if (_v3.$ === 3) {
				var practice_ = _v3.a;
				return A2($author$project$Api$Practice$featureEnabled, 19, practice_);
			} else {
				return false;
			}
		}();
		if (isUnifiedExperience) {
			var _v0 = model.VM;
			if (_v0.$ === 3) {
				var patient = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('layout-header--patient')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$map,
								toMsg,
								A3($author$project$Layouts$Patient$viewHeader, shared, patient, model))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('patient-content-card')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('patient-nav-bar')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										toMsg,
										A3($author$project$Layouts$Patient$viewNav, shared, patient, model))
									])),
								A2($elm$html$Html$div, _List_Nil, body)
							]))
					]);
			} else {
				return _List_Nil;
			}
		} else {
			var _v1 = shared.afE;
			if (!_v1.$) {
				var patientsList = _v1.a;
				return A3(
					$author$project$Layouts$PatientsSidebar$view,
					patientListToMsg,
					patientsList,
					function () {
						var _v2 = model.VM;
						if (_v2.$ === 3) {
							var patient = _v2.a;
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('layout-header md:ml-0')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											toMsg,
											A3($author$project$Layouts$Patient$viewHeaderLegacy, shared, patient, model)),
											A2(
											$elm$html$Html$map,
											toMsg,
											A4($author$project$Layouts$Patient$viewNavLegacy, shared, patient, patientsList, model))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('md:ml-8')
										]),
									body)
								]);
						} else {
							return _List_Nil;
						}
					}());
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Layouts$PatientChart$view = F2(
	function (_v0, model) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$map,
				$elm$core$Basics$never,
				A2($author$project$Components$PatientViewSwitcher$view, model.VN, 0))
			]);
	});
var $author$project$Ui$Panel$FullHeight = {$: 1};
var $author$project$Ui$Panel$fullHeight = $author$project$Ui$Panel$FullHeight;
var $author$project$Layouts$PracticeSetup$isCurrentRoute = F2(
	function (url, route) {
		return A2(
			$elm$core$String$endsWith,
			$elm$core$String$concat(
				_List_fromArray(
					['/', route])),
			$author$project$Spa$Generated$Route$toString(
				$author$project$Utils$Route$fromUrl(url)));
	});
var $author$project$Components$PracticeSetupStepper$InternalStep = F5(
	function (id, index, label, subtitle, subtitleDescription) {
		return {adR: id, x4: index, aej: label, _4: subtitle, _5: subtitleDescription};
	});
var $author$project$Components$PracticeSetupStepper$stepIndex = F2(
	function (isHintClinical, stepId) {
		if (isHintClinical) {
			if (!stepId.$) {
				switch (stepId.a) {
					case 0:
						var _v1 = stepId.a;
						return 0;
					case 1:
						var _v2 = stepId.a;
						return 1;
					default:
						var _v3 = stepId.a;
						return 2;
				}
			} else {
				switch (stepId.a) {
					case 0:
						var _v4 = stepId.a;
						return 0;
					case 1:
						var _v5 = stepId.a;
						return 1;
					case 2:
						var _v6 = stepId.a;
						return 1;
					case 3:
						var _v7 = stepId.a;
						return 2;
					default:
						var _v8 = stepId.a;
						return 3;
				}
			}
		} else {
			if (!stepId.$) {
				switch (stepId.a) {
					case 0:
						var _v10 = stepId.a;
						return 0;
					case 1:
						var _v11 = stepId.a;
						return 1;
					default:
						var _v12 = stepId.a;
						return 2;
				}
			} else {
				switch (stepId.a) {
					case 0:
						var _v13 = stepId.a;
						return 0;
					case 3:
						var _v14 = stepId.a;
						return 1;
					case 4:
						var _v15 = stepId.a;
						return 2;
					default:
						return -1;
				}
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$stepLabel = F2(
	function (paymentProcessor, stepId) {
		if (!stepId.$) {
			switch (stepId.a) {
				case 0:
					var _v1 = stepId.a;
					return 'General Practice Information';
				case 1:
					var _v2 = stepId.a;
					return 'Membership Pricing Setup';
				default:
					var _v3 = stepId.a;
					return 'Patient Agreements';
			}
		} else {
			switch (stepId.a) {
				case 3:
					var _v4 = stepId.a;
					return (paymentProcessor === 'rainforest') ? 'Payment Processor Setup' : 'Setup Stripe';
				case 0:
					var _v5 = stepId.a;
					return 'Profile Setup';
				case 1:
					var _v6 = stepId.a;
					return 'Communications Setup';
				case 2:
					var _v7 = stepId.a;
					return 'Communications Setup';
				default:
					var _v8 = stepId.a;
					return '';
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$stepSubtitle = F2(
	function (paymentProcessor, stepId) {
		if (!stepId.$) {
			switch (stepId.a) {
				case 0:
					var _v1 = stepId.a;
					return $elm$core$Maybe$Just('3-5 mins');
				case 1:
					var _v2 = stepId.a;
					return $elm$core$Maybe$Just('5-10 mins');
				default:
					var _v3 = stepId.a;
					return $elm$core$Maybe$Just('2 mins');
			}
		} else {
			switch (stepId.a) {
				case 3:
					var _v4 = stepId.a;
					return (paymentProcessor === 'rainforest') ? $elm$core$Maybe$Just('5-10 mins') : $elm$core$Maybe$Just('10 mins');
				case 0:
					var _v5 = stepId.a;
					return $elm$core$Maybe$Just('5-10 mins');
				case 1:
					var _v6 = stepId.a;
					return $elm$core$Maybe$Just('3-5 mins');
				case 2:
					var _v7 = stepId.a;
					return $elm$core$Maybe$Just('3-5 mins');
				default:
					var _v8 = stepId.a;
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$stepSubtitleDescription = F2(
	function (paymentProcessor, stepId) {
		if (!stepId.$) {
			switch (stepId.a) {
				case 0:
					var _v1 = stepId.a;
					return $elm$core$Maybe$Nothing;
				case 1:
					var _v2 = stepId.a;
					return $elm$core$Maybe$Nothing;
				default:
					var _v3 = stepId.a;
					return $elm$core$Maybe$Nothing;
			}
		} else {
			switch (stepId.a) {
				case 3:
					var _v4 = stepId.a;
					return (paymentProcessor === 'rainforest') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('*requires tax ID & practice bank account & routing number');
				case 0:
					var _v5 = stepId.a;
					return $elm$core$Maybe$Nothing;
				case 1:
					var _v6 = stepId.a;
					return $elm$core$Maybe$Nothing;
				case 2:
					var _v7 = stepId.a;
					return $elm$core$Maybe$Nothing;
				default:
					var _v8 = stepId.a;
					return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$buildInternalStep = F3(
	function (isHintClinical, paymentProcessor, stepId) {
		return A5(
			$author$project$Components$PracticeSetupStepper$InternalStep,
			stepId,
			A2($author$project$Components$PracticeSetupStepper$stepIndex, isHintClinical, stepId),
			A2($author$project$Components$PracticeSetupStepper$stepLabel, paymentProcessor, stepId),
			A2($author$project$Components$PracticeSetupStepper$stepSubtitle, paymentProcessor, stepId),
			A2($author$project$Components$PracticeSetupStepper$stepSubtitleDescription, paymentProcessor, stepId));
	});
var $author$project$Components$PracticeSetupStepper$Account = 0;
var $author$project$Components$PracticeSetupStepper$AdminStep = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$PracticeSetupStepper$Communications = 1;
var $author$project$Components$PracticeSetupStepper$Complete = 4;
var $author$project$Components$PracticeSetupStepper$Documents = 2;
var $author$project$Components$PracticeSetupStepper$Legal = 2;
var $author$project$Components$PracticeSetupStepper$PaymentProcessing = 3;
var $author$project$Components$PracticeSetupStepper$Plan = 1;
var $author$project$Components$PracticeSetupStepper$PracticeInfoStep = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$PracticeSetupStepper$Team = 0;
var $author$project$Components$PracticeSetupStepper$stepIds = _List_fromArray(
	[
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(0),
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(1),
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(2),
		$author$project$Components$PracticeSetupStepper$AdminStep(0),
		$author$project$Components$PracticeSetupStepper$AdminStep(1),
		$author$project$Components$PracticeSetupStepper$AdminStep(2),
		$author$project$Components$PracticeSetupStepper$AdminStep(3),
		$author$project$Components$PracticeSetupStepper$AdminStep(4)
	]);
var $author$project$Components$PracticeSetupStepper$internalSteps = F2(
	function (isHintClinical, paymentProcessor) {
		return A2(
			$elm$core$List$map,
			A2($author$project$Components$PracticeSetupStepper$buildInternalStep, isHintClinical, paymentProcessor),
			$author$project$Components$PracticeSetupStepper$stepIds);
	});
var $author$project$Components$PracticeSetupStepper$init = F3(
	function (paymentProcessor, stepId, practice) {
		return {
			EP: A3($author$project$Components$PracticeSetupStepper$buildInternalStep, false, paymentProcessor, stepId),
			V0: paymentProcessor,
			WF: practice,
			_O: A2($author$project$Components$PracticeSetupStepper$internalSteps, false, paymentProcessor)
		};
	});
var $author$project$Components$PracticeSetupStepper$setCurrentStepFromUrl = function (url) {
	var route = $author$project$Utils$Route$fromUrl(url);
	return A2(
		$elm$core$String$endsWith,
		'/account',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(0) : (A2(
		$elm$core$String$endsWith,
		'/new',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(1) : ((A2(
		$elm$core$String$endsWith,
		'/plans',
		$author$project$Spa$Generated$Route$toString(route)) || A2(
		$elm$core$String$contains,
		'/plans',
		$author$project$Spa$Generated$Route$toString(route))) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(1) : (A2(
		$elm$core$String$endsWith,
		'/documents',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(2) : (A2(
		$elm$core$String$endsWith,
		'/team',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(0) : (A2(
		$elm$core$String$endsWith,
		'/communications',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(1) : (A2(
		$elm$core$String$endsWith,
		'/legal',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(2) : (A2(
		$elm$core$String$endsWith,
		'/payment_processing',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(3) : (A2(
		$elm$core$String$endsWith,
		'/complete',
		$author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(4) : $author$project$Components$PracticeSetupStepper$PracticeInfoStep(0)))))))));
};
var $author$project$Components$PracticeSetupStepper$adminStepIds = function (isHintClinical) {
	return isHintClinical ? _List_fromArray(
		[
			$author$project$Components$PracticeSetupStepper$AdminStep(0),
			$author$project$Components$PracticeSetupStepper$AdminStep(1),
			$author$project$Components$PracticeSetupStepper$AdminStep(2),
			$author$project$Components$PracticeSetupStepper$AdminStep(3)
		]) : _List_fromArray(
		[
			$author$project$Components$PracticeSetupStepper$AdminStep(0),
			$author$project$Components$PracticeSetupStepper$AdminStep(3)
		]);
};
var $author$project$Components$PracticeSetupStepper$convertStepsToStep = F3(
	function (isHintClinical, paymentProcessor, stepIds_) {
		return A2(
			$elm$core$List$map,
			function (step) {
				return A5($author$project$Ui$Stepper$Step, step.aej, step.x4, true, step._4, step._5);
			},
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				function (step) {
					return step.x4;
				},
				A2(
					$elm$core$List$map,
					A2($author$project$Components$PracticeSetupStepper$buildInternalStep, isHintClinical, paymentProcessor),
					stepIds_)));
	});
var $author$project$Components$PracticeSetupStepper$convertedAdminSteps = F2(
	function (isHintClinical, paymentProcessor) {
		return A3(
			$author$project$Components$PracticeSetupStepper$convertStepsToStep,
			isHintClinical,
			paymentProcessor,
			$author$project$Components$PracticeSetupStepper$adminStepIds(isHintClinical));
	});
var $author$project$Ui$Stepper$viewVerticalStep = F3(
	function (_v0, attr, step) {
		var currentIndex = _v0.P;
		var lastCompletedIndex = _v0.ra;
		var numSteps = _v0.T;
		var stepIndexString = $elm$core$String$fromInt(step.x4 + 1);
		var stepOptions = function () {
			if (_Utils_eq(step.x4, currentIndex)) {
				return {
					cL: A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('stepper__circle')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(stepIndexString)
							])),
					dg: 'current',
					dh: $elm$html$Html$text(step.aej)
				};
			} else {
				if (step.dW) {
					return {
						cL: A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stepper__circle')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(stepIndexString)
								])),
						dg: 'disabled',
						dh: $elm$html$Html$text(step.aej)
					};
				} else {
					if (_Utils_cmp(step.x4, currentIndex) < 0) {
						return {
							cL: A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stepper__circle'),
										attr
									]),
								_List_fromArray(
									[
										A2($author$project$Ui$Icon$view, _List_Nil, 60)
									])),
							dg: 'previous',
							dh: A2(
								$elm$html$Html$a,
								_List_fromArray(
									[attr]),
								_List_fromArray(
									[
										$elm$html$Html$text(step.aej)
									]))
						};
					} else {
						var circleBodyText = function () {
							if (!lastCompletedIndex.$) {
								var index = lastCompletedIndex.a;
								return (_Utils_cmp(step.x4, index) < 0) ? A2($author$project$Ui$Icon$view, _List_Nil, 60) : $elm$html$Html$text(stepIndexString);
							} else {
								return $elm$html$Html$text(stepIndexString);
							}
						}();
						return {
							cL: A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stepper__circle')
									]),
								_List_fromArray(
									[circleBodyText])),
							dg: 'next',
							dh: $elm$html$Html$text(step.aej)
						};
					}
				}
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('stepper__step stepper__step--' + stepOptions.dg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col justify-center')
						]),
					_List_fromArray(
						[
							stepOptions.cL,
							A2(
							$author$project$Utils$Html$htmlIf,
							_Utils_cmp(step.x4 + 1, numSteps) < 0,
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('stepper__line')
									]),
								_List_fromArray(
									[
										$author$project$Ui$HorizontalRule$view(_List_Nil)
									])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('flex flex-col')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stepper__text')
								]),
							_List_fromArray(
								[stepOptions.dh])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stepper__subtitle')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', step._4))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('stepper__subtitle stepper__description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, '', step._5))
								]))
						]))
				]));
	});
var $author$project$Ui$Stepper$viewStaticVerticalStep = F2(
	function (_v0, step) {
		var currentIndex = _v0.P;
		var numSteps = _v0.T;
		return A3(
			$author$project$Ui$Stepper$viewVerticalStep,
			{P: currentIndex, ra: $elm$core$Maybe$Nothing, T: numSteps},
			$elm$html$Html$Attributes$class('label'),
			step);
	});
var $author$project$Ui$Stepper$viewVertical = F2(
	function (maybeStepIndex, steps) {
		if ($elm$core$List$isEmpty(steps)) {
			return $author$project$Utils$Html$empty;
		} else {
			if (!maybeStepIndex.$) {
				var stepIndex = maybeStepIndex.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('stepper__vertical')
						]),
					A2(
						$elm$core$List$map,
						function (step) {
							return A2(
								$author$project$Ui$Stepper$viewStaticVerticalStep,
								{
									P: stepIndex,
									T: $elm$core$List$length(steps)
								},
								step);
						},
						steps));
			} else {
				return $author$project$Utils$Html$empty;
			}
		}
	});
var $author$project$Components$PracticeSetupStepper$viewExpandedHeader = F4(
	function (partLabel, title, steps, currentStep) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$bold]),
					_List_fromArray(
						[
							$elm$html$Html$text(partLabel)
						])),
					$author$project$Ui$Typography$headingSm(
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$author$project$Ui$Stepper$viewVertical,
					$elm$core$Maybe$Just(currentStep.x4),
					steps)
				]));
	});
var $author$project$Components$PracticeSetupStepper$viewMinimizedHeader = F2(
	function (partLabel, title) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[$author$project$Ui$Typography$muted, $author$project$Ui$Typography$small]),
					_List_fromArray(
						[
							$elm$html$Html$text(partLabel)
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$muted,
							$author$project$Ui$Typography$bold,
							$author$project$Ui$Typography$padding(8)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]))
				]));
	});
var $author$project$Components$PracticeSetupStepper$viewAdminSetup = F3(
	function (isHintClinical, model, currentStep) {
		return (A2(
			$elm$core$List$member,
			currentStep.adR,
			$author$project$Components$PracticeSetupStepper$adminStepIds(isHintClinical)) || _Utils_eq(
			currentStep.adR,
			$author$project$Components$PracticeSetupStepper$AdminStep(2))) ? A4(
			$author$project$Components$PracticeSetupStepper$viewExpandedHeader,
			'Part 2 of 2',
			'Admin Setup',
			A2($author$project$Components$PracticeSetupStepper$convertedAdminSteps, isHintClinical, model.V0),
			_Utils_update(
				currentStep,
				{
					x4: A2($author$project$Components$PracticeSetupStepper$stepIndex, isHintClinical, currentStep.adR)
				})) : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Components$PracticeSetupStepper$viewMinimizedHeader, 'Part 2 of 2', 'Admin Setup'),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$muted,
							$author$project$Ui$Typography$small,
							$author$project$Ui$Typography$padding(8)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Est. 25-30 mins.')
						])),
					A2(
					$author$project$Ui$Typography$div,
					_List_fromArray(
						[
							$author$project$Ui$Typography$muted,
							$author$project$Ui$Typography$small,
							$author$project$Ui$Typography$padding(8)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Requires tax ID & practice bank routing & account numbers.')
						]))
				]));
	});
var $author$project$Components$PracticeSetupStepper$practiceInfoStepIds = _List_fromArray(
	[
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(0),
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(1),
		$author$project$Components$PracticeSetupStepper$PracticeInfoStep(2)
	]);
var $author$project$Components$PracticeSetupStepper$convertedPracticeSteps = F2(
	function (isHintClinical, paymentProcessor) {
		return A3($author$project$Components$PracticeSetupStepper$convertStepsToStep, isHintClinical, paymentProcessor, $author$project$Components$PracticeSetupStepper$practiceInfoStepIds);
	});
var $author$project$Components$PracticeSetupStepper$viewPracticeInfoSetup = F3(
	function (isHintClinical, model, currentStep) {
		return A2($elm$core$List$member, currentStep.adR, $author$project$Components$PracticeSetupStepper$practiceInfoStepIds) ? A4(
			$author$project$Components$PracticeSetupStepper$viewExpandedHeader,
			'Part 1 of 2',
			'Public Practice Information',
			A2($author$project$Components$PracticeSetupStepper$convertedPracticeSteps, isHintClinical, model.V0),
			currentStep) : A2($author$project$Components$PracticeSetupStepper$viewMinimizedHeader, 'Part 1 of 2', 'Public Practice Information');
	});
var $author$project$Components$PracticeSetupStepper$view = F2(
	function (model, _v0) {
		var isHintClinical = function () {
			var _v1 = model.WF;
			if ((_v1.$ === 3) && (!_v1.a.$)) {
				var practice_ = _v1.a.a;
				var _v2 = $author$project$Api$Provider$Practice$One$emr(practice_);
				if (!_v2.$) {
					var emr = _v2.a;
					return !$author$project$Api$Provider$Practice$Emr$toOption(emr);
				} else {
					return false;
				}
			} else {
				return false;
			}
		}();
		var currentStep = model.EP;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Components$PracticeSetupStepper$viewPracticeInfoSetup, isHintClinical, model, currentStep),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					A3($author$project$Components$PracticeSetupStepper$viewAdminSetup, isHintClinical, model, currentStep)
				]));
	});
var $author$project$Layouts$PracticeSetup$viewStepper = F4(
	function (paymentProcessor_, url, accountStep, practice) {
		var stepId = $author$project$Components$PracticeSetupStepper$setCurrentStepFromUrl(url);
		var stepperModel = A3($author$project$Components$PracticeSetupStepper$init, paymentProcessor_, stepId, practice);
		return A2($author$project$Components$PracticeSetupStepper$view, stepperModel, accountStep);
	});
var $author$project$Layouts$PracticeSetup$view = F2(
	function (_v0, body) {
		var practice = _v0.WF;
		var url = _v0.aav;
		var _v1 = function () {
			if ((practice.$ === 3) && (!practice.a.$)) {
				var practice_ = practice.a.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							$author$project$Api$Provider$PracticeOnboarding$Shared$accountStep,
							$author$project$Api$Provider$Practice$One$practiceOnboarding(practice_))),
					$author$project$Api$Provider$Practice$One$paymentProcessor(practice_));
			} else {
				return _Utils_Tuple2(8, 'stripe');
			}
		}();
		var accountStep = _v1.a;
		var paymentProcessor_ = _v1.b;
		return _List_fromArray(
			[
				A2(
				$author$project$Ui$Panel$view,
				_List_fromArray(
					[$author$project$Ui$Panel$extraPadding, $author$project$Ui$Panel$fullHeight]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Panel$body,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								A2($author$project$Layouts$PracticeSetup$isCurrentRoute, url, 'complete') ? _List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'border', '1px solid #ccc'),
												A2($elm$html$Html$Attributes$style, 'padding', '1rem'),
												A2($elm$html$Html$Attributes$style, 'margin', '1rem 0')
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$row,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$author$project$Ui$FlexGrid$column,
														_List_fromArray(
															[
																$author$project$Ui$FlexGrid$spanSm(12),
																$author$project$Ui$FlexGrid$justifyLeft
															]),
														body)
													]))
											]))
									]) : _List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$row,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanSm(3)
													]),
												_List_fromArray(
													[
														A4($author$project$Layouts$PracticeSetup$viewStepper, paymentProcessor_, url, accountStep, practice)
													])),
												A2(
												$author$project$Ui$FlexGrid$column,
												_List_fromArray(
													[
														$author$project$Ui$FlexGrid$spanSm(9),
														$author$project$Ui$FlexGrid$justifyCenter
													]),
												body)
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$Spa$Generated$Route$all = _List_fromArray(
	[
		$author$project$Spa$Generated$Route$Top,
		$author$project$Spa$Generated$Route$Accounting,
		$author$project$Spa$Generated$Route$Blank,
		$author$project$Spa$Generated$Route$Calendar,
		$author$project$Spa$Generated$Route$Forms,
		$author$project$Spa$Generated$Route$Home,
		$author$project$Spa$Generated$Route$Login,
		$author$project$Spa$Generated$Route$Logout,
		$author$project$Spa$Generated$Route$NotFound,
		$author$project$Spa$Generated$Route$Onboarding,
		$author$project$Spa$Generated$Route$AffiliateBills__Top,
		$author$project$Spa$Generated$Route$Affiliates__Top,
		$author$project$Spa$Generated$Route$Companies__Top,
		$author$project$Spa$Generated$Route$Files__Top,
		$author$project$Spa$Generated$Route$Marketplace__Top,
		$author$project$Spa$Generated$Route$Patients__Top,
		$author$project$Spa$Generated$Route$PracticeSetup__Top,
		$author$project$Spa$Generated$Route$StyleGuide__Top,
		$author$project$Spa$Generated$Route$Tasks__Top,
		$author$project$Spa$Generated$Route$Admin__AdvanceBilling,
		$author$project$Spa$Generated$Route$Admin__Billing,
		$author$project$Spa$Generated$Route$Admin__CancellationReasons,
		$author$project$Spa$Generated$Route$Admin__CardReaders,
		$author$project$Spa$Generated$Route$Admin__Categories,
		$author$project$Spa$Generated$Route$Admin__Commissions,
		$author$project$Spa$Generated$Route$Admin__Coupons,
		$author$project$Spa$Generated$Route$Admin__CreditCategories,
		$author$project$Spa$Generated$Route$Admin__ElationLegacy,
		$author$project$Spa$Generated$Route$Admin__Features,
		$author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
		$author$project$Spa$Generated$Route$Admin__InternalSettings,
		$author$project$Spa$Generated$Route$Admin__InvoiceSettings,
		$author$project$Spa$Generated$Route$Admin__LeadSources,
		$author$project$Spa$Generated$Route$Admin__Locations,
		$author$project$Spa$Generated$Route$Admin__Mailgun,
		$author$project$Spa$Generated$Route$Admin__Notes,
		$author$project$Spa$Generated$Route$Admin__Patients,
		$author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
		$author$project$Spa$Generated$Route$Admin__PaymentProcessing,
		$author$project$Spa$Generated$Route$Admin__PaymentSources,
		$author$project$Spa$Generated$Route$Admin__Practice,
		$author$project$Spa$Generated$Route$Admin__ProviderGroups,
		$author$project$Spa$Generated$Route$Admin__ScheduledJobs,
		$author$project$Spa$Generated$Route$Admin__SelfService,
		$author$project$Spa$Generated$Route$Admin__Signup,
		$author$project$Spa$Generated$Route$Admin__Stripe,
		$author$project$Spa$Generated$Route$Admin__Taxes,
		$author$project$Spa$Generated$Route$Admin__Team,
		$author$project$Spa$Generated$Route$Affiliates__Create,
		$author$project$Spa$Generated$Route$Affiliates__New,
		$author$project$Spa$Generated$Route$Charges__New,
		$author$project$Spa$Generated$Route$Commissions__Statements,
		$author$project$Spa$Generated$Route$Companies__New,
		$author$project$Spa$Generated$Route$Contacts__List,
		$author$project$Spa$Generated$Route$Contacts__New,
		$author$project$Spa$Generated$Route$Files__Public,
		$author$project$Spa$Generated$Route$Hinter__ClonePractice,
		$author$project$Spa$Generated$Route$Hinter__Disputes,
		$author$project$Spa$Generated$Route$Hinter__FeatureFlags,
		$author$project$Spa$Generated$Route$Hinter__NewGroup,
		$author$project$Spa$Generated$Route$Hinter__NewPartner,
		$author$project$Spa$Generated$Route$Hinter__NewPractice,
		$author$project$Spa$Generated$Route$Inventory__List,
		$author$project$Spa$Generated$Route$Inventory__New,
		$author$project$Spa$Generated$Route$Inventory__Settings,
		$author$project$Spa$Generated$Route$Marketplace__Manage,
		$author$project$Spa$Generated$Route$Messages__Calls,
		$author$project$Spa$Generated$Route$Messages__Drafts,
		$author$project$Spa$Generated$Route$Messages__Forms,
		$author$project$Spa$Generated$Route$Messages__Labs,
		$author$project$Spa$Generated$Route$Messages__Messages,
		$author$project$Spa$Generated$Route$Messages__Sms,
		$author$project$Spa$Generated$Route$NewSettings__Erx,
		$author$project$Spa$Generated$Route$NewSettings__HinterSettings,
		$author$project$Spa$Generated$Route$NewSettings__PracticeInfo,
		$author$project$Spa$Generated$Route$NewSettings__Team,
		$author$project$Spa$Generated$Route$Oauth__Callback,
		$author$project$Spa$Generated$Route$Partner__ApiKeys,
		$author$project$Spa$Generated$Route$Partner__Billing,
		$author$project$Spa$Generated$Route$Partner__Engagements,
		$author$project$Spa$Generated$Route$Partner__Hinter,
		$author$project$Spa$Generated$Route$Partner__Product,
		$author$project$Spa$Generated$Route$Partner__Team,
		$author$project$Spa$Generated$Route$Partner__WebhookEndpoints,
		$author$project$Spa$Generated$Route$Patients__Create,
		$author$project$Spa$Generated$Route$Patients__Upload,
		$author$project$Spa$Generated$Route$PracticeSetup__Account,
		$author$project$Spa$Generated$Route$PracticeSetup__Communications,
		$author$project$Spa$Generated$Route$PracticeSetup__Complete,
		$author$project$Spa$Generated$Route$PracticeSetup__Documents,
		$author$project$Spa$Generated$Route$PracticeSetup__Legal,
		$author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing,
		$author$project$Spa$Generated$Route$PracticeSetup__Plans,
		$author$project$Spa$Generated$Route$PracticeSetup__Team,
		$author$project$Spa$Generated$Route$Reports__CompanyInvoices,
		$author$project$Spa$Generated$Route$Reports__CreditOutstanding,
		$author$project$Spa$Generated$Route$Reports__CreditTransactions,
		$author$project$Spa$Generated$Route$Reports__Dashboard,
		$author$project$Spa$Generated$Route$Reports__DeferredRevenue,
		$author$project$Spa$Generated$Route$Reports__Deposits,
		$author$project$Spa$Generated$Route$Reports__Disputes,
		$author$project$Spa$Generated$Route$Reports__Invoices,
		$author$project$Spa$Generated$Route$Reports__Memberships,
		$author$project$Spa$Generated$Route$Reports__Months,
		$author$project$Spa$Generated$Route$Reports__PaymentApplications,
		$author$project$Spa$Generated$Route$Reports__Revenue,
		$author$project$Spa$Generated$Route$Reports__SalesTax,
		$author$project$Spa$Generated$Route$Reports__SignupAttempts,
		$author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators,
		$author$project$Spa$Generated$Route$StyleGuide__AddressInput,
		$author$project$Spa$Generated$Route$StyleGuide__Alert,
		$author$project$Spa$Generated$Route$StyleGuide__Badge,
		$author$project$Spa$Generated$Route$StyleGuide__Button,
		$author$project$Spa$Generated$Route$StyleGuide__Carousel,
		$author$project$Spa$Generated$Route$StyleGuide__Checkbox,
		$author$project$Spa$Generated$Route$StyleGuide__CurrencyInput,
		$author$project$Spa$Generated$Route$StyleGuide__DateInput,
		$author$project$Spa$Generated$Route$StyleGuide__DateRangeInput,
		$author$project$Spa$Generated$Route$StyleGuide__Dropdown,
		$author$project$Spa$Generated$Route$StyleGuide__ExportCsv,
		$author$project$Spa$Generated$Route$StyleGuide__FileInput,
		$author$project$Spa$Generated$Route$StyleGuide__FlexGrid,
		$author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu,
		$author$project$Spa$Generated$Route$StyleGuide__FormExample,
		$author$project$Spa$Generated$Route$StyleGuide__FormGroup,
		$author$project$Spa$Generated$Route$StyleGuide__FormStatic,
		$author$project$Spa$Generated$Route$StyleGuide__HiConfirm,
		$author$project$Spa$Generated$Route$StyleGuide__HorizontalRule,
		$author$project$Spa$Generated$Route$StyleGuide__Icon,
		$author$project$Spa$Generated$Route$StyleGuide__Input,
		$author$project$Spa$Generated$Route$StyleGuide__Link,
		$author$project$Spa$Generated$Route$StyleGuide__ListGroup,
		$author$project$Spa$Generated$Route$StyleGuide__Modal,
		$author$project$Spa$Generated$Route$StyleGuide__Pagination,
		$author$project$Spa$Generated$Route$StyleGuide__Panel,
		$author$project$Spa$Generated$Route$StyleGuide__PasswordInput,
		$author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer,
		$author$project$Spa$Generated$Route$StyleGuide__PhoneInput,
		$author$project$Spa$Generated$Route$StyleGuide__Popover,
		$author$project$Spa$Generated$Route$StyleGuide__ProgressBar,
		$author$project$Spa$Generated$Route$StyleGuide__ResourceFilter,
		$author$project$Spa$Generated$Route$StyleGuide__SearchInput,
		$author$project$Spa$Generated$Route$StyleGuide__SearchableSelect,
		$author$project$Spa$Generated$Route$StyleGuide__Select,
		$author$project$Spa$Generated$Route$StyleGuide__Skeleton,
		$author$project$Spa$Generated$Route$StyleGuide__SvgIcon,
		$author$project$Spa$Generated$Route$StyleGuide__Table,
		$author$project$Spa$Generated$Route$StyleGuide__Tabs,
		$author$project$Spa$Generated$Route$StyleGuide__Toast,
		$author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch,
		$author$project$Spa$Generated$Route$StyleGuide__Tooltip,
		$author$project$Spa$Generated$Route$StyleGuide__Typography,
		$author$project$Spa$Generated$Route$StyleGuide__UploadForm,
		$author$project$Spa$Generated$Route$StyleGuide__UploadResult,
		$author$project$Spa$Generated$Route$StyleGuide__Well,
		$author$project$Spa$Generated$Route$Support__CannySso,
		$author$project$Spa$Generated$Route$Tasks__New,
		$author$project$Spa$Generated$Route$User__AcceptTerms,
		$author$project$Spa$Generated$Route$User__Mfa,
		$author$project$Spa$Generated$Route$User__Profile,
		$author$project$Spa$Generated$Route$User__Security,
		$author$project$Spa$Generated$Route$Apps__Slug_String(
		{_c: ''}),
		$author$project$Spa$Generated$Route$Error__Status_String(
		{ag7: ''}),
		$author$project$Spa$Generated$Route$Join__Token_String(
		{$Q: ''}),
		$author$project$Spa$Generated$Route$Marketplace__Slug_String(
		{_c: ''}),
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Top,
		$author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
		$author$project$Spa$Generated$Route$Admin__CompanyPlans__Top,
		$author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
		$author$project$Spa$Generated$Route$Admin__DataExport__Top,
		$author$project$Spa$Generated$Route$Admin__DataExportSettings__Top,
		$author$project$Spa$Generated$Route$Admin__Documents__Top,
		$author$project$Spa$Generated$Route$Admin__Elation__Top,
		$author$project$Spa$Generated$Route$Admin__Plans__Top,
		$author$project$Spa$Generated$Route$Admin__Providers__Top,
		$author$project$Spa$Generated$Route$Admin__Quickbooks__Top,
		$author$project$Spa$Generated$Route$Admin__SignupPages__Top,
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
		$author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Top(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Contacts__ContactId_String__Top(
		{acb: ''}),
		$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top,
		$author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top(
		{ad5: ''}),
		$author$project$Spa$Generated$Route$Messages__Faxes__Top,
		$author$project$Spa$Generated$Route$Messages__Scheduled__Top,
		$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top,
		$author$project$Spa$Generated$Route$NewSettings__Locations__Top,
		$author$project$Spa$Generated$Route$NewSettings__Templates__Top,
		$author$project$Spa$Generated$Route$Onboard__DealId_String__Top(
		{act: ''}),
		$author$project$Spa$Generated$Route$Partner__Dashboard__Top,
		$author$project$Spa$Generated$Route$Partner__Practices__Top,
		$author$project$Spa$Generated$Route$Partner__Sandboxes__Top,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Top(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top,
		$author$project$Spa$Generated$Route$Tasks__TasksId_String__Top(
		{ahi: ''}),
		$author$project$Spa$Generated$Route$User__Organizations__Top,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Fields,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Link,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Locations,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Overview,
		$author$project$Spa$Generated$Route$Admin__Athenahealth__Providers,
		$author$project$Spa$Generated$Route$Admin__ChargeItems__New,
		$author$project$Spa$Generated$Route$Admin__ChargeItems__Upload,
		$author$project$Spa$Generated$Route$Admin__CompanyPlans__New,
		$author$project$Spa$Generated$Route$Admin__CoveragePlans__New,
		$author$project$Spa$Generated$Route$Admin__Credits__Upload,
		$author$project$Spa$Generated$Route$Admin__DataExportSettings__New,
		$author$project$Spa$Generated$Route$Admin__Developers__ApiKeys,
		$author$project$Spa$Generated$Route$Admin__Developers__GetStarted,
		$author$project$Spa$Generated$Route$Admin__Developers__Sandboxes,
		$author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints,
		$author$project$Spa$Generated$Route$Admin__Documents__New,
		$author$project$Spa$Generated$Route$Admin__Elation__Link,
		$author$project$Spa$Generated$Route$Admin__Elation__Overview,
		$author$project$Spa$Generated$Route$Admin__Elation__Providers,
		$author$project$Spa$Generated$Route$Admin__Notifications__Company,
		$author$project$Spa$Generated$Route$Admin__Notifications__Employee,
		$author$project$Spa$Generated$Route$Admin__Notifications__Membership,
		$author$project$Spa$Generated$Route$Admin__Notifications__Patient,
		$author$project$Spa$Generated$Route$Admin__Notifications__Practice,
		$author$project$Spa$Generated$Route$Admin__Notifications__Settings,
		$author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload,
		$author$project$Spa$Generated$Route$Admin__Plans__New,
		$author$project$Spa$Generated$Route$Admin__Providers__Upload,
		$author$project$Spa$Generated$Route$Admin__SignupPages__New,
		$author$project$Spa$Generated$Route$Admin__Team__New,
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions(
		{pp: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders(
		{pp: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders(
		{pp: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients(
		{pp: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings(
		{pp: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users(
		{pp: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
		$author$project$Spa$Generated$Route$Commissions__StatementLines__Summary,
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Messages__Faxes__New,
		$author$project$Spa$Generated$Route$Messages__Scheduled__New,
		$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New,
		$author$project$Spa$Generated$Route$NewSettings__Templates__New,
		$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed(
		{afq: ''}),
		$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing(
		{afq: ''}),
		$author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment(
		{afq: ''}),
		$author$project$Spa$Generated$Route$Onboard__OnboardId_String__User(
		{afq: ''}),
		$author$project$Spa$Generated$Route$Partner__Billing__Hinter,
		$author$project$Spa$Generated$Route$Partner__Product__ActivationSettings,
		$author$project$Spa$Generated$Route$Partner__Product__AppSettings,
		$author$project$Spa$Generated$Route$Partner__Product__Hinter,
		$author$project$Spa$Generated$Route$Partner__Product__New,
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Chart(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Edit(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Merge(
		{VN: ''}),
		$author$project$Spa$Generated$Route$PracticeSetup__Plans__New,
		$author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary,
		$author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary,
		$author$project$Spa$Generated$Route$Reports__Custom__New,
		$author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary,
		$author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary,
		$author$project$Spa$Generated$Route$Reports__Revenue__Summary,
		$author$project$Spa$Generated$Route$Reports__SalesTax__Summary,
		$author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Admin__DataExport__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Admin__Documents__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Admin__Integrations__Slug_String(
		{_c: ''}),
		$author$project$Spa$Generated$Route$Admin__Plans__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Admin__SignupPages__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String(
		{adS: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String(
		{abH: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String(
		{ahk: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String(
		{ahl: ''}),
		$author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Reports__Custom__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top(
		{pp: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top(
		{bP: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top(
		{agG: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top(
		{VN: ''}),
		$author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule,
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals(
		{bP: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals(
		{bP: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New(
		{ff: ''}),
		$author$project$Spa$Generated$Route$Marketplace__Layer__Manage__Settings,
		$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding(
		{_c: ''}),
		$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings(
		{_c: ''}),
		$author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users(
		{_c: ''}),
		$author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo(
		{ahk: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New(
		{VN: ''}),
		$author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String(
		{pp: '', adR: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String(
		{ff: '', adR: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String(
		{ff: '', adR: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top(
		{bP: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top(
		{bP: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top(
		{ff: '', HK: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top(
		{IM: '', VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top(
		{aea: '', VN: ''}),
		$author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top(
		{yS: '', VN: ''}),
		$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New(
		{adR: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended(
		{bP: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New(
		{bP: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults(
		{ff: '', HK: ''}),
		$author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String(
		{adR: '', afY: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String(
		{bP: '', ag6: ''}),
		$author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top(
		{bP: '', Eo: ''}),
		$author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top(
		{ff: '', acF: '', acX: ''})
	]);
var $author$project$Layouts$StyleGuide$routeLabel = function (route) {
	switch (route.$) {
		case 112:
			return $elm$core$Maybe$Just('Button');
		case 121:
			return $elm$core$Maybe$Just('Flex Grid');
		case 154:
			return $elm$core$Maybe$Just('Well');
		case 127:
			return $elm$core$Maybe$Just('Horizontal Rule');
		case 128:
			return $elm$core$Maybe$Just('Icon');
		case 145:
			return $elm$core$Maybe$Just('SvgIcon');
		case 134:
			return $elm$core$Maybe$Just('Panel');
		case 146:
			return $elm$core$Maybe$Just('Table');
		case 149:
			return $elm$core$Maybe$Just('Toggle Switch');
		case 108:
			return $elm$core$Maybe$Just('Activity Indicators');
		case 151:
			return $elm$core$Maybe$Just('Typography');
		case 130:
			return $elm$core$Maybe$Just('Link');
		case 148:
			return $elm$core$Maybe$Just('Toast');
		case 147:
			return $elm$core$Maybe$Just('Tabs');
		case 139:
			return $elm$core$Maybe$Just('Progress Bar');
		case 110:
			return $elm$core$Maybe$Just('Alert');
		case 123:
			return $elm$core$Maybe$Just('Form');
		case 114:
			return $elm$core$Maybe$Just('Form > Checkbox');
		case 129:
			return $elm$core$Maybe$Just('Form > Input');
		case 124:
			return $elm$core$Maybe$Just('Form > Group');
		case 133:
			return $elm$core$Maybe$Just('Pagination');
		case 137:
			return $elm$core$Maybe$Just('Phone Input');
		case 132:
			return $elm$core$Maybe$Just('Modal');
		case 126:
			return $elm$core$Maybe$Just('Hi Confirm');
		case 111:
			return $elm$core$Maybe$Just('Badge');
		case 150:
			return $elm$core$Maybe$Just('Tooltip');
		case 122:
			return $elm$core$Maybe$Just('Flyout Menu');
		case 138:
			return $elm$core$Maybe$Just('Popover');
		case 119:
			return $elm$core$Maybe$Just('Export Csv');
		case 131:
			return $elm$core$Maybe$Just('List Group');
		case 135:
			return $elm$core$Maybe$Just('Form > Password Input');
		case 125:
			return $elm$core$Maybe$Just('Form > Static');
		case 120:
			return $elm$core$Maybe$Just('Form > File Input');
		case 142:
			return $elm$core$Maybe$Just('Form > Searchable Select');
		case 117:
			return $elm$core$Maybe$Just('Date Range Input');
		case 136:
			return $elm$core$Maybe$Just('Payment Source Displayer');
		case 153:
			return $elm$core$Maybe$Just('Upload > Result');
		case 152:
			return $elm$core$Maybe$Just('Upload > Form');
		case 140:
			return $elm$core$Maybe$Just('Resource Filter');
		case 115:
			return $elm$core$Maybe$Just('Form > Currency Input');
		case 143:
			return $elm$core$Maybe$Just('Form > Select');
		case 116:
			return $elm$core$Maybe$Just('Date Input');
		case 141:
			return $elm$core$Maybe$Just('Search Input');
		case 109:
			return $elm$core$Maybe$Just('Address Input');
		case 144:
			return $elm$core$Maybe$Just('Skeleton');
		case 118:
			return $elm$core$Maybe$Just('Dropdown | Select');
		case 113:
			return $elm$core$Maybe$Just('Carousel');
		case 17:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 8:
			return $elm$core$Maybe$Nothing;
		case 159:
			return $elm$core$Maybe$Nothing;
		case 28:
			return $elm$core$Maybe$Nothing;
		case 30:
			return $elm$core$Maybe$Nothing;
		case 41:
			return $elm$core$Maybe$Nothing;
		case 158:
			return $elm$core$Maybe$Nothing;
		case 160:
			return $elm$core$Maybe$Nothing;
		case 42:
			return $elm$core$Maybe$Nothing;
		case 21:
			return $elm$core$Maybe$Nothing;
		case 32:
			return $elm$core$Maybe$Nothing;
		case 107:
			return $elm$core$Maybe$Nothing;
		case 36:
			return $elm$core$Maybe$Nothing;
		case 97:
			return $elm$core$Maybe$Nothing;
		case 103:
			return $elm$core$Maybe$Nothing;
		case 20:
			return $elm$core$Maybe$Nothing;
		case 9:
			return $elm$core$Maybe$Nothing;
		case 205:
			return $elm$core$Maybe$Nothing;
		case 85:
			return $elm$core$Maybe$Nothing;
		case 43:
			return $elm$core$Maybe$Nothing;
		case 106:
			return $elm$core$Maybe$Nothing;
		case 266:
			return $elm$core$Maybe$Nothing;
		case 52:
			return $elm$core$Maybe$Nothing;
		case 193:
			return $elm$core$Maybe$Nothing;
		case 281:
			return $elm$core$Maybe$Nothing;
		case 99:
			return $elm$core$Maybe$Nothing;
		case 94:
			return $elm$core$Maybe$Nothing;
		case 101:
			return $elm$core$Maybe$Nothing;
		case 95:
			return $elm$core$Maybe$Nothing;
		case 260:
			return $elm$core$Maybe$Nothing;
		case 96:
			return $elm$core$Maybe$Nothing;
		case 261:
			return $elm$core$Maybe$Nothing;
		case 104:
			return $elm$core$Maybe$Nothing;
		case 264:
			return $elm$core$Maybe$Nothing;
		case 105:
			return $elm$core$Maybe$Nothing;
		case 265:
			return $elm$core$Maybe$Nothing;
		case 98:
			return $elm$core$Maybe$Nothing;
		case 263:
			return $elm$core$Maybe$Nothing;
		case 262:
			return $elm$core$Maybe$Nothing;
		case 282:
			return $elm$core$Maybe$Nothing;
		case 102:
			return $elm$core$Maybe$Nothing;
		case 100:
			return $elm$core$Maybe$Nothing;
		case 26:
			return $elm$core$Maybe$Nothing;
		case 23:
			return $elm$core$Maybe$Nothing;
		case 29:
			return $elm$core$Maybe$Nothing;
		case 171:
			return $elm$core$Maybe$Nothing;
		case 211:
			return $elm$core$Maybe$Nothing;
		case 272:
			return $elm$core$Maybe$Nothing;
		case 216:
			return $elm$core$Maybe$Nothing;
		case 218:
			return $elm$core$Maybe$Nothing;
		case 215:
			return $elm$core$Maybe$Nothing;
		case 217:
			return $elm$core$Maybe$Nothing;
		case 219:
			return $elm$core$Maybe$Nothing;
		case 220:
			return $elm$core$Maybe$Nothing;
		case 295:
			return $elm$core$Maybe$Nothing;
		case 31:
			return $elm$core$Maybe$Nothing;
		case 35:
			return $elm$core$Maybe$Nothing;
		case 238:
			return $elm$core$Maybe$Nothing;
		case 239:
			return $elm$core$Maybe$Nothing;
		case 237:
			return $elm$core$Maybe$Nothing;
		case 47:
			return $elm$core$Maybe$Nothing;
		case 225:
			return $elm$core$Maybe$Nothing;
		case 74:
			return $elm$core$Maybe$Nothing;
		case 75:
			return $elm$core$Maybe$Nothing;
		case 279:
			return $elm$core$Maybe$Nothing;
		case 304:
			return $elm$core$Maybe$Nothing;
		case 72:
			return $elm$core$Maybe$Nothing;
		case 46:
			return $elm$core$Maybe$Nothing;
		case 33:
			return $elm$core$Maybe$Nothing;
		case 166:
			return $elm$core$Maybe$Nothing;
		case 201:
			return $elm$core$Maybe$Nothing;
		case 267:
			return $elm$core$Maybe$Nothing;
		case 202:
			return $elm$core$Maybe$Nothing;
		case 168:
			return $elm$core$Maybe$Nothing;
		case 204:
			return $elm$core$Maybe$Nothing;
		case 269:
			return $elm$core$Maybe$Nothing;
		case 174:
			return $elm$core$Maybe$Nothing;
		case 223:
			return $elm$core$Maybe$Nothing;
		case 176:
			return $elm$core$Maybe$Nothing;
		case 224:
			return $elm$core$Maybe$Nothing;
		case 275:
			return $elm$core$Maybe$Nothing;
		case 19:
			return $elm$core$Maybe$Nothing;
		case 222:
			return $elm$core$Maybe$Nothing;
		case 173:
			return $elm$core$Maybe$Nothing;
		case 274:
			return $elm$core$Maybe$Nothing;
		case 203:
			return $elm$core$Maybe$Nothing;
		case 167:
			return $elm$core$Maybe$Nothing;
		case 268:
			return $elm$core$Maybe$Nothing;
		case 24:
			return $elm$core$Maybe$Nothing;
		case 27:
			return $elm$core$Maybe$Nothing;
		case 45:
			return $elm$core$Maybe$Nothing;
		case 34:
			return $elm$core$Maybe$Nothing;
		case 25:
			return $elm$core$Maybe$Nothing;
		case 286:
			return $elm$core$Maybe$Nothing;
		case 309:
			return $elm$core$Maybe$Nothing;
		case 40:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 61:
			return $elm$core$Maybe$Nothing;
		case 56:
			return $elm$core$Maybe$Nothing;
		case 60:
			return $elm$core$Maybe$Nothing;
		case 59:
			return $elm$core$Maybe$Nothing;
		case 57:
			return $elm$core$Maybe$Nothing;
		case 181:
			return $elm$core$Maybe$Nothing;
		case 276:
			return $elm$core$Maybe$Nothing;
		case 58:
			return $elm$core$Maybe$Nothing;
		case 15:
			return $elm$core$Maybe$Nothing;
		case 39:
			return $elm$core$Maybe$Nothing;
		case 38:
			return $elm$core$Maybe$Nothing;
		case 37:
			return $elm$core$Maybe$Nothing;
		case 221:
			return $elm$core$Maybe$Nothing;
		case 240:
			return $elm$core$Maybe$Nothing;
		case 307:
			return $elm$core$Maybe$Nothing;
		case 285:
			return $elm$core$Maybe$Nothing;
		case 298:
			return $elm$core$Maybe$Nothing;
		case 324:
			return $elm$core$Maybe$Nothing;
		case 234:
			return $elm$core$Maybe$Nothing;
		case 236:
			return $elm$core$Maybe$Nothing;
		case 179:
			return $elm$core$Maybe$Nothing;
		case 12:
			return $elm$core$Maybe$Nothing;
		case 22:
			return $elm$core$Maybe$Nothing;
		case 177:
			return $elm$core$Maybe$Nothing;
		case 232:
			return $elm$core$Maybe$Nothing;
		case 284:
			return $elm$core$Maybe$Nothing;
		case 296:
			return $elm$core$Maybe$Nothing;
		case 311:
			return $elm$core$Maybe$Nothing;
		case 319:
			return $elm$core$Maybe$Nothing;
		case 323:
			return $elm$core$Maybe$Nothing;
		case 318:
			return $elm$core$Maybe$Nothing;
		case 312:
			return $elm$core$Maybe$Nothing;
		case 51:
			return $elm$core$Maybe$Nothing;
		case 322:
			return $elm$core$Maybe$Nothing;
		case 297:
			return $elm$core$Maybe$Nothing;
		case 178:
			return $elm$core$Maybe$Nothing;
		case 233:
			return $elm$core$Maybe$Nothing;
		case 192:
			return $elm$core$Maybe$Nothing;
		case 256:
			return $elm$core$Maybe$Nothing;
		case 258:
			return $elm$core$Maybe$Nothing;
		case 257:
			return $elm$core$Maybe$Nothing;
		case 314:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 49:
			return $elm$core$Maybe$Nothing;
		case 283:
			return $elm$core$Maybe$Nothing;
		case 227:
			return $elm$core$Maybe$Nothing;
		case 228:
			return $elm$core$Maybe$Nothing;
		case 231:
			return $elm$core$Maybe$Nothing;
		case 10:
			return $elm$core$Maybe$Nothing;
		case 308:
			return $elm$core$Maybe$Nothing;
		case 48:
			return $elm$core$Maybe$Nothing;
		case 226:
			return $elm$core$Maybe$Nothing;
		case 273:
			return $elm$core$Maybe$Nothing;
		case 287:
			return $elm$core$Maybe$Nothing;
		case 313:
			return $elm$core$Maybe$Nothing;
		case 235:
			return $elm$core$Maybe$Nothing;
		case 320:
			return $elm$core$Maybe$Nothing;
		case 163:
			return $elm$core$Maybe$Nothing;
		case 6:
			return $elm$core$Maybe$Nothing;
		case 7:
			return $elm$core$Maybe$Nothing;
		case 76:
			return $elm$core$Maybe$Nothing;
		case 155:
			return $elm$core$Maybe$Nothing;
		case 229:
			return $elm$core$Maybe$Nothing;
		case 84:
			return $elm$core$Maybe$Nothing;
		case 230:
			return $elm$core$Maybe$Nothing;
		case 315:
			return $elm$core$Maybe$Nothing;
		case 44:
			return $elm$core$Maybe$Nothing;
		case 50:
			return $elm$core$Maybe$Nothing;
		case 289:
			return $elm$core$Maybe$Nothing;
		case 291:
			return $elm$core$Maybe$Nothing;
		case 292:
			return $elm$core$Maybe$Nothing;
		case 305:
			return $elm$core$Maybe$Nothing;
		case 316:
			return $elm$core$Maybe$Nothing;
		case 293:
			return $elm$core$Maybe$Nothing;
		case 294:
			return $elm$core$Maybe$Nothing;
		case 241:
			return $elm$core$Maybe$Nothing;
		case 195:
			return $elm$core$Maybe$Nothing;
		case 290:
			return $elm$core$Maybe$Nothing;
		case 299:
			return $elm$core$Maybe$Nothing;
		case 310:
			return $elm$core$Maybe$Nothing;
		case 172:
			return $elm$core$Maybe$Nothing;
		case 212:
			return $elm$core$Maybe$Nothing;
		case 214:
			return $elm$core$Maybe$Nothing;
		case 213:
			return $elm$core$Maybe$Nothing;
		case 175:
			return $elm$core$Maybe$Nothing;
		case 165:
			return $elm$core$Maybe$Nothing;
		case 197:
			return $elm$core$Maybe$Nothing;
		case 198:
			return $elm$core$Maybe$Nothing;
		case 196:
			return $elm$core$Maybe$Nothing;
		case 200:
			return $elm$core$Maybe$Nothing;
		case 199:
			return $elm$core$Maybe$Nothing;
		case 170:
			return $elm$core$Maybe$Nothing;
		case 206:
			return $elm$core$Maybe$Nothing;
		case 271:
			return $elm$core$Maybe$Nothing;
		case 169:
			return $elm$core$Maybe$Nothing;
		case 270:
			return $elm$core$Maybe$Nothing;
		case 207:
			return $elm$core$Maybe$Nothing;
		case 208:
			return $elm$core$Maybe$Nothing;
		case 209:
			return $elm$core$Maybe$Nothing;
		case 210:
			return $elm$core$Maybe$Nothing;
		case 157:
			return $elm$core$Maybe$Nothing;
		case 162:
			return $elm$core$Maybe$Nothing;
		case 0:
			return $elm$core$Maybe$Nothing;
		case 188:
			return $elm$core$Maybe$Nothing;
		case 248:
			return $elm$core$Maybe$Nothing;
		case 249:
			return $elm$core$Maybe$Nothing;
		case 247:
			return $elm$core$Maybe$Nothing;
		case 246:
			return $elm$core$Maybe$Nothing;
		case 16:
			return $elm$core$Maybe$Nothing;
		case 86:
			return $elm$core$Maybe$Nothing;
		case 92:
			return $elm$core$Maybe$Nothing;
		case 259:
			return $elm$core$Maybe$Nothing;
		case 306:
			return $elm$core$Maybe$Nothing;
		case 89:
			return $elm$core$Maybe$Nothing;
		case 91:
			return $elm$core$Maybe$Nothing;
		case 93:
			return $elm$core$Maybe$Nothing;
		case 87:
			return $elm$core$Maybe$Nothing;
		case 90:
			return $elm$core$Maybe$Nothing;
		case 88:
			return $elm$core$Maybe$Nothing;
		case 82:
			return $elm$core$Maybe$Nothing;
		case 81:
			return $elm$core$Maybe$Nothing;
		case 77:
			return $elm$core$Maybe$Nothing;
		case 83:
			return $elm$core$Maybe$Nothing;
		case 190:
			return $elm$core$Maybe$Nothing;
		case 80:
			return $elm$core$Maybe$Nothing;
		case 317:
			return $elm$core$Maybe$Nothing;
		case 321:
			return $elm$core$Maybe$Nothing;
		case 252:
			return $elm$core$Maybe$Nothing;
		case 189:
			return $elm$core$Maybe$Nothing;
		case 254:
			return $elm$core$Maybe$Nothing;
		case 251:
			return $elm$core$Maybe$Nothing;
		case 253:
			return $elm$core$Maybe$Nothing;
		case 191:
			return $elm$core$Maybe$Nothing;
		case 250:
			return $elm$core$Maybe$Nothing;
		case 78:
			return $elm$core$Maybe$Nothing;
		case 79:
			return $elm$core$Maybe$Nothing;
		case 161:
			return $elm$core$Maybe$Nothing;
		case 14:
			return $elm$core$Maybe$Nothing;
		case 164:
			return $elm$core$Maybe$Nothing;
		case 301:
			return $elm$core$Maybe$Nothing;
		case 303:
			return $elm$core$Maybe$Nothing;
		case 302:
			return $elm$core$Maybe$Nothing;
		case 300:
			return $elm$core$Maybe$Nothing;
		case 65:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		case 5:
			return $elm$core$Maybe$Nothing;
		case 255:
			return $elm$core$Maybe$Nothing;
		case 53:
			return $elm$core$Maybe$Nothing;
		case 54:
			return $elm$core$Maybe$Nothing;
		case 180:
			return $elm$core$Maybe$Nothing;
		case 13:
			return $elm$core$Maybe$Nothing;
		case 55:
			return $elm$core$Maybe$Nothing;
		case 4:
			return $elm$core$Maybe$Nothing;
		case 62:
			return $elm$core$Maybe$Nothing;
		case 63:
			return $elm$core$Maybe$Nothing;
		case 182:
			return $elm$core$Maybe$Nothing;
		case 64:
			return $elm$core$Maybe$Nothing;
		case 71:
			return $elm$core$Maybe$Nothing;
		case 70:
			return $elm$core$Maybe$Nothing;
		case 66:
			return $elm$core$Maybe$Nothing;
		case 69:
			return $elm$core$Maybe$Nothing;
		case 183:
			return $elm$core$Maybe$Nothing;
		case 242:
			return $elm$core$Maybe$Nothing;
		case 68:
			return $elm$core$Maybe$Nothing;
		case 67:
			return $elm$core$Maybe$Nothing;
		case 184:
			return $elm$core$Maybe$Nothing;
		case 243:
			return $elm$core$Maybe$Nothing;
		case 288:
			return $elm$core$Maybe$Nothing;
		case 18:
			return $elm$core$Maybe$Nothing;
		case 156:
			return $elm$core$Maybe$Nothing;
		case 194:
			return $elm$core$Maybe$Nothing;
		case 185:
			return $elm$core$Maybe$Nothing;
		case 244:
			return $elm$core$Maybe$Nothing;
		case 277:
			return $elm$core$Maybe$Nothing;
		case 186:
			return $elm$core$Maybe$Nothing;
		case 278:
			return $elm$core$Maybe$Nothing;
		case 187:
			return $elm$core$Maybe$Nothing;
		case 245:
			return $elm$core$Maybe$Nothing;
		case 280:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Layouts$StyleGuide$menuItems = A2(
	$elm$core$List$sortBy,
	$elm$core$Tuple$second,
	A2(
		$elm$core$List$filterMap,
		function (route) {
			return A2(
				$elm$core$Maybe$map,
				function (label) {
					return _Utils_Tuple2(route, label);
				},
				$author$project$Layouts$StyleGuide$routeLabel(route));
		},
		$author$project$Spa$Generated$Route$all));
var $author$project$Layouts$StyleGuide$viewHeader = $author$project$Ui$Typography$heading(
	_List_fromArray(
		[
			A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					$author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$StyleGuide__Typography))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Hint Legos')
				]))
		]));
var $author$project$Layouts$StyleGuide$viewMenuItem = F2(
	function (currentUrl, _v0) {
		var route = _v0.a;
		var linkText = _v0.b;
		var stringRoute = $author$project$Spa$Generated$Route$toString(route);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active',
							A2($elm$core$String$contains, stringRoute, currentUrl))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(stringRoute)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(linkText)
						]))
				]));
	});
var $author$project$Layouts$StyleGuide$view = F2(
	function (_v0, body) {
		var url = _v0.aav;
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$Layouts$StyleGuide$viewHeader,
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Ui$FlexGrid$row,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(4),
												$author$project$Ui$FlexGrid$spanMd(3),
												$author$project$Ui$FlexGrid$spanLg(2)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('')
													]),
												A2(
													$elm$core$List$map,
													$author$project$Layouts$StyleGuide$viewMenuItem(
														$elm$url$Url$toString(url)),
													$author$project$Layouts$StyleGuide$menuItems))
											])),
										A2(
										$author$project$Ui$FlexGrid$column,
										_List_fromArray(
											[
												$author$project$Ui$FlexGrid$spanSm(8),
												$author$project$Ui$FlexGrid$spanMd(9),
												$author$project$Ui$FlexGrid$spanLg(10)
											]),
										body)
									]))
							]))
					]))
			]);
	});
var $author$project$Layouts$User$viewNav = F2(
	function (currentRoute, nav) {
		return A3(
			$author$project$Ui$Nav$view,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$User__Profile),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$User__Profile))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('General')
						])),
					A2(
					$author$project$Ui$Nav$item,
					_List_fromArray(
						[
							$author$project$Ui$Nav$route($author$project$Spa$Generated$Route$User__Security),
							$author$project$Ui$Nav$activeItem(
							_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$User__Security))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Security')
						]))
				]),
			nav);
	});
var $author$project$Layouts$User$view = F4(
	function (toMsg, _v0, _v1, body) {
		var url = _v0.aav;
		var nav = _v1.m8;
		var currentRoute = $author$project$Utils$Route$fromUrl(url);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-panel nav-panel-header')
					]),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$map,
						toMsg,
						A2($author$project$Layouts$User$viewNav, currentRoute, nav)),
					body))
			]);
	});
var $author$project$Spa$Layout$view = F5(
	function (toMainMsg, layout, shared, toSharedMsg, body) {
		if (shared.adu.acW) {
			return $author$project$Layouts$Blank$view(body);
		} else {
			switch (layout.$) {
				case 0:
					return A2($author$project$Layouts$StyleGuide$view, shared, body);
				case 17:
					return A2($author$project$Layouts$Onboard$view, shared, body);
				case 14:
					return $author$project$Layouts$Blank$view(body);
				case 15:
					return _List_Nil;
				case 16:
					var layoutModel = layout.b;
					return A2($author$project$Layouts$PatientChart$view, body, layoutModel);
				case 1:
					return $author$project$Layouts$Application$view(body);
				case 4:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Commissions$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CommissionsMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 5:
					var layoutModel = layout.b;
					return A4(
						$author$project$Layouts$Commissions$BrokerAccount$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CommissionsBrokerAccountMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 6:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Affiliates$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AffiliatesMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 19:
					return A2($author$project$Layouts$PracticeSetup$view, shared, body);
				case 7:
					var layoutModel = layout.b;
					return A4(
						$author$project$Layouts$Affiliates$Affiliate$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AffiliatesAffiliateMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 8:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Partner$Billing$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerBillingMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 9:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Partner$Practices$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerPracticesMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 10:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Partner$Product$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerProductMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 11:
					var layoutModel = layout.b;
					return A4(
						$author$project$Layouts$Marketplace$Manage$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$MarketplaceManageMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 3:
					var layoutModel = layout.b;
					return A5(
						$author$project$Layouts$Patient$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PatientMsg, toMainMsg),
						toSharedMsg,
						shared,
						layoutModel,
						body);
				case 2:
					var _v1 = shared.afE;
					if (!_v1.$) {
						var patientsList = _v1.a;
						return A3($author$project$Layouts$PatientsSidebar$view, toSharedMsg, patientsList, body);
					} else {
						return body;
					}
				case 12:
					var layoutModel = layout.b;
					return A4(
						$author$project$Layouts$Company$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CompanyMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				case 13:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$Admin$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AdminMsg, toMainMsg),
						shared,
						layoutModel,
						body);
				default:
					var layoutModel = layout.a;
					return A4(
						$author$project$Layouts$User$view,
						A2($elm$core$Basics$composeR, $author$project$Spa$Layout$UserMsg, toMainMsg),
						shared,
						layoutModel,
						body);
			}
		}
	});
var $author$project$Main$view = function (model) {
	return A2(
		$author$project$Shared$view,
		{
			aec: $author$project$Main$isClinicalLayout(model.a6),
			a6: A3($author$project$Spa$Layout$view, $author$project$Main$Layout, model.a6, model.Cd),
			Gy: A2(
				$author$project$Spa$Document$map,
				$author$project$Main$Pages,
				$author$project$Spa$Generated$Pages$view(model.Gy)),
			ahx: $author$project$Main$Shared
		},
		model.Cd);
};
var $author$project$Main$main = $elm$browser$Browser$element(
	{
		ad0: $author$project$Main$init,
		ahd: $author$project$Main$subscriptions,
		aaq: $author$project$Main$update,
		ahP: A2($elm$core$Basics$composeR, $author$project$Main$view, $author$project$Spa$Document$toBrowserElement)
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (showRedesignToggle) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (sessionToken) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (release) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (providerAuthUrl) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (origin) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (nodeEnv) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (locationHref) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (intercomAppId) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (images) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (hinterViewOff) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (hintEnv) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (emrHost) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (embedded) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (defaultHubspotDeal) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (debugOrTest) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (currentTime) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (currentRataDieDate) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (cannyAppId) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (backupAuthEnabled) {
																																							return A2(
																																								$elm$json$Json$Decode$andThen,
																																								function (apiVersion) {
																																									return A2(
																																										$elm$json$Json$Decode$andThen,
																																										function (apiUrl) {
																																											return $elm$json$Json$Decode$succeed(
																																												{abm: apiUrl, D6: apiVersion, abt: backupAuthEnabled, abP: cannyAppId, acj: currentRataDieDate, ack: currentTime, acv: debugOrTest, acz: defaultHubspotDeal, acW: embedded, acZ: emrHost, adM: hintEnv, adN: hinterViewOff, QO: images, ad2: intercomAppId, S2: locationHref, aeR: nodeEnv, afw: origin, GU: providerAuthUrl, agf: release, agU: sessionToken, agY: showRedesignToggle});
																																										},
																																										A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string));
																																								},
																																								A2(
																																									$elm$json$Json$Decode$field,
																																									'apiVersion',
																																									$elm$json$Json$Decode$oneOf(
																																										_List_fromArray(
																																											[
																																												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																											]))));
																																						},
																																						A2($elm$json$Json$Decode$field, 'backupAuthEnabled', $elm$json$Json$Decode$bool));
																																				},
																																				A2(
																																					$elm$json$Json$Decode$field,
																																					'cannyAppId',
																																					$elm$json$Json$Decode$oneOf(
																																						_List_fromArray(
																																							[
																																								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																																							]))));
																																		},
																																		A2($elm$json$Json$Decode$field, 'currentRataDieDate', $elm$json$Json$Decode$int));
																																},
																																A2($elm$json$Json$Decode$field, 'currentTime', $elm$json$Json$Decode$int));
																														},
																														A2($elm$json$Json$Decode$field, 'debugOrTest', $elm$json$Json$Decode$bool));
																												},
																												A2(
																													$elm$json$Json$Decode$field,
																													'defaultHubspotDeal',
																													$elm$json$Json$Decode$oneOf(
																														_List_fromArray(
																															[
																																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																															]))));
																										},
																										A2($elm$json$Json$Decode$field, 'embedded', $elm$json$Json$Decode$bool));
																								},
																								A2($elm$json$Json$Decode$field, 'emrHost', $elm$json$Json$Decode$string));
																						},
																						A2(
																							$elm$json$Json$Decode$field,
																							'hintEnv',
																							$elm$json$Json$Decode$oneOf(
																								_List_fromArray(
																									[
																										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																									]))));
																				},
																				A2($elm$json$Json$Decode$field, 'hinterViewOff', $elm$json$Json$Decode$bool));
																		},
																		A2(
																			$elm$json$Json$Decode$field,
																			'images',
																			$elm$json$Json$Decode$list(
																				A2(
																					$elm$json$Json$Decode$andThen,
																					function (_v0) {
																						return A2(
																							$elm$json$Json$Decode$andThen,
																							function (_v1) {
																								return $elm$json$Json$Decode$succeed(
																									_Utils_Tuple2(_v0, _v1));
																							},
																							A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
																					},
																					A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)))));
																},
																A2(
																	$elm$json$Json$Decode$field,
																	'intercomAppId',
																	$elm$json$Json$Decode$oneOf(
																		_List_fromArray(
																			[
																				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
																			]))));
														},
														A2($elm$json$Json$Decode$field, 'locationHref', $elm$json$Json$Decode$string));
												},
												A2(
													$elm$json$Json$Decode$field,
													'nodeEnv',
													$elm$json$Json$Decode$oneOf(
														_List_fromArray(
															[
																$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
																A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
															]))));
										},
										A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'providerAuthUrl', $elm$json$Json$Decode$string));
						},
						A2(
							$elm$json$Json$Decode$field,
							'release',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
										A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
									]))));
				},
				A2(
					$elm$json$Json$Decode$field,
					'sessionToken',
					$elm$json$Json$Decode$oneOf(
						_List_fromArray(
							[
								$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
								A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
							]))));
		},
		A2($elm$json$Json$Decode$field, 'showRedesignToggle', $elm$json$Json$Decode$string)))(0)}});}(_s));export var Elm=_s.Elm;